
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("joOvD", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @authors:
 *   Fabian Vogelsteller <fabian@ethereum.org>
 *   Gav Wood <gav@parity.io>
 *   Jeffrey Wilcke <jeffrey.wilcke@ethereum.org>
 *   Marek Kotewicz <marek@parity.io>
 *   Marian Oancea <marian@ethereum.org>
 * @date 2017
 */ "use strict";

var $jnvYq = parcelRequire("jnvYq");
var $e1f7704fa3690456$require$version = $jnvYq.version;

var $gNDGO = parcelRequire("gNDGO");

var $dZEGL = parcelRequire("dZEGL");

var $jo8Dp = parcelRequire("jo8Dp");

var $7W5Xs = parcelRequire("7W5Xs");

var $l2qhz = parcelRequire("l2qhz");

var $kCpMQ = parcelRequire("kCpMQ");

var $9y1Dl = parcelRequire("9y1Dl");
var $e1f7704fa3690456$var$Web3 = function Web3() {
    var _this = this;
    // sets _requestmanager etc
    $gNDGO.packageInit(this, arguments);
    this.version = $e1f7704fa3690456$require$version;
    this.utils = $9y1Dl;
    this.eth = new $dZEGL(this);
    this.shh = new $l2qhz(this);
    this.bzz = new $kCpMQ(this);
    // overwrite package setProvider
    var setProvider = this.setProvider;
    this.setProvider = function(provider, net) {
        /*jshint unused: false */ setProvider.apply(_this, arguments);
        _this.eth.setRequestManager(_this._requestManager);
        _this.shh.setRequestManager(_this._requestManager);
        _this.bzz.setProvider(provider);
        return true;
    };
};
$e1f7704fa3690456$var$Web3.version = $e1f7704fa3690456$require$version;
$e1f7704fa3690456$var$Web3.utils = $9y1Dl;
$e1f7704fa3690456$var$Web3.modules = {
    Eth: $dZEGL,
    Net: $jo8Dp,
    Personal: $7W5Xs,
    Shh: $l2qhz,
    Bzz: $kCpMQ
};
$gNDGO.addProviders($e1f7704fa3690456$var$Web3);
module.exports = $e1f7704fa3690456$var$Web3;

});
parcelRegister("jnvYq", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"web3\",\"version\":\"1.7.0\",\"description\":\"Ethereum JavaScript API\",\"repository\":\"https://github.com/ethereum/web3.js\",\"license\":\"LGPL-3.0\",\"engines\":{\"node\":\">=8.0.0\"},\"main\":\"lib/index.js\",\"bugs\":{\"url\":\"https://github.com/ethereum/web3.js/issues\"},\"keywords\":[\"Ethereum\",\"JavaScript\",\"API\"],\"author\":\"ethereum.org\",\"types\":\"types/index.d.ts\",\"scripts\":{\"compile\":\"tsc -b tsconfig.json\",\"dtslint\":\"dtslint --localTs ../../node_modules/typescript/lib types\",\"postinstall\":\"echo \\\"WARNING: the web3-shh and web3-bzz api will be deprecated in the next version\\\"\"},\"authors\":[{\"name\":\"Fabian Vogelsteller\",\"email\":\"fabian@ethereum.org\",\"homepage\":\"http://frozeman.de\"},{\"name\":\"Marek Kotewicz\",\"email\":\"marek@parity.io\",\"url\":\"https://github.com/debris\"},{\"name\":\"Marian Oancea\",\"url\":\"https://github.com/cubedro\"},{\"name\":\"Gav Wood\",\"email\":\"g@parity.io\",\"homepage\":\"http://gavwood.com\"},{\"name\":\"Jeffery Wilcke\",\"email\":\"jeffrey.wilcke@ethereum.org\",\"url\":\"https://github.com/obscuren\"}],\"dependencies\":{\"web3-bzz\":\"1.7.0\",\"web3-core\":\"1.7.0\",\"web3-eth\":\"1.7.0\",\"web3-eth-personal\":\"1.7.0\",\"web3-net\":\"1.7.0\",\"web3-shh\":\"1.7.0\",\"web3-utils\":\"1.7.0\"},\"devDependencies\":{\"@types/node\":\"^12.12.6\",\"dtslint\":\"^3.4.1\",\"typescript\":\"^3.9.5\",\"web3-core-helpers\":\"1.7.0\"},\"gitHead\":\"cd4b4d13e7e1d973ceee29c118798d4931860a2b\"}");

});

parcelRegister("gNDGO", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ 
var $1WXQP = parcelRequire("1WXQP");

var $gzatY = parcelRequire("gzatY");
const $c3b0026eaf5011f9$var$packageInit = (pkg, args)=>{
    args = Array.prototype.slice.call(args);
    if (!pkg) throw new Error('You need to instantiate using the "new" keyword.');
    // make property of pkg._provider, which can properly set providers
    Object.defineProperty(pkg, 'currentProvider', {
        get: ()=>{
            return pkg._provider;
        },
        set: (value)=>{
            return pkg.setProvider(value);
        },
        enumerable: true,
        configurable: true
    });
    // inherit from parent package or create a new RequestManager
    if (args[0] && args[0]._requestManager) pkg._requestManager = args[0]._requestManager;
    else pkg._requestManager = new $1WXQP.Manager(args[0], args[1]);
    // add givenProvider
    pkg.givenProvider = $1WXQP.Manager.givenProvider;
    pkg.providers = $1WXQP.Manager.providers;
    pkg._provider = pkg._requestManager.provider;
    // add SETPROVIDER function (don't overwrite if already existing)
    if (!pkg.setProvider) pkg.setProvider = (provider, net)=>{
        pkg._requestManager.setProvider(provider, net);
        pkg._provider = pkg._requestManager.provider;
        return true;
    };
    pkg.setRequestManager = (manager)=>{
        pkg._requestManager = manager;
        pkg._provider = manager.provider;
    };
    // attach batch request creation
    pkg.BatchRequest = $1WXQP.BatchManager.bind(null, pkg._requestManager);
    // attach extend function
    pkg.extend = $gzatY(pkg);
};
const $c3b0026eaf5011f9$var$addProviders = (pkg)=>{
    pkg.givenProvider = $1WXQP.Manager.givenProvider;
    pkg.providers = $1WXQP.Manager.providers;
};
module.exports = {
    packageInit: $c3b0026eaf5011f9$var$packageInit,
    addProviders: $c3b0026eaf5011f9$var$addProviders
};

});
parcelRegister("1WXQP", function(module, exports) {
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $N7Lcz = parcelRequire("N7Lcz");
var $16b9a2608699f0e8$require$callbackify = $N7Lcz.callbackify;

var $hA2kM = parcelRequire("hA2kM");
var $16b9a2608699f0e8$require$errors = $hA2kM.errors;

var $jemaa = parcelRequire("jemaa");

var $9rJ4f = parcelRequire("9rJ4f");

var $fIjTA = parcelRequire("fIjTA");
/**
 * It's responsible for passing messages to providers
 * It's also responsible for polling the ethereum node for incoming messages
 * Default poll timeout is 1 second
 * Singleton
 *
 * @param {string|Object}provider
 * @param {Net.Socket} net
 *
 * @constructor
 */ var $16b9a2608699f0e8$var$RequestManager = function RequestManager(provider, net) {
    this.provider = null;
    this.providers = RequestManager.providers;
    this.setProvider(provider, net);
    this.subscriptions = new Map();
};
$16b9a2608699f0e8$var$RequestManager.givenProvider = $fIjTA;



$16b9a2608699f0e8$var$RequestManager.providers = {
    WebsocketProvider: (parcelRequire("4NExO")),
    HttpProvider: (parcelRequire("ebDIR")),
    IpcProvider: (parcelRequire("1r79I"))
};
/**
 * Should be used to set provider of request manager
 *
 * @method setProvider
 *
 * @param {Object} provider
 * @param {net.Socket} net
 *
 * @returns void
 */ $16b9a2608699f0e8$var$RequestManager.prototype.setProvider = function(provider, net) {
    var _this = this;
    // autodetect provider
    if (provider && typeof provider === 'string' && this.providers) {
        // HTTP
        if (/^http(s)?:\/\//i.test(provider)) provider = new this.providers.HttpProvider(provider);
        else if (/^ws(s)?:\/\//i.test(provider)) provider = new this.providers.WebsocketProvider(provider);
        else if (provider && typeof net === 'object' && typeof net.connect === 'function') provider = new this.providers.IpcProvider(provider, net);
        else if (provider) throw new Error('Can\'t autodetect provider for "' + provider + '"');
    }
    // reset the old one before changing, if still connected
    if (this.provider && this.provider.connected) this.clearSubscriptions();
    this.provider = provider || null;
    // listen to incoming notifications
    if (this.provider && this.provider.on) {
        if (typeof provider.request === 'function') this.provider.on('message', function(payload) {
            if (payload && payload.type === 'eth_subscription' && payload.data) {
                const data = payload.data;
                if (data.subscription && _this.subscriptions.has(data.subscription)) _this.subscriptions.get(data.subscription).callback(null, data.result);
            }
        });
        else this.provider.on('data', function data(result, deprecatedResult) {
            result = result || deprecatedResult; // this is for possible old providers, which may had the error first handler
            // if result is a subscription, call callback for that subscription
            if (result.method && result.params && result.params.subscription && _this.subscriptions.has(result.params.subscription)) _this.subscriptions.get(result.params.subscription).callback(null, result.params.result);
        });
        // resubscribe if the provider has reconnected
        this.provider.on('connect', function connect() {
            _this.subscriptions.forEach(function(subscription) {
                subscription.subscription.resubscribe();
            });
        });
        // notify all subscriptions about the error condition
        this.provider.on('error', function error(error) {
            _this.subscriptions.forEach(function(subscription) {
                subscription.callback(error);
            });
        });
        // notify all subscriptions about bad close conditions
        const disconnect = function disconnect(event) {
            if (!_this._isCleanCloseEvent(event) || _this._isIpcCloseError(event)) {
                _this.subscriptions.forEach(function(subscription) {
                    subscription.callback($16b9a2608699f0e8$require$errors.ConnectionCloseError(event));
                    _this.subscriptions.delete(subscription.subscription.id);
                });
                if (_this.provider && _this.provider.emit) _this.provider.emit('error', $16b9a2608699f0e8$require$errors.ConnectionCloseError(event));
            }
            if (_this.provider && _this.provider.emit) _this.provider.emit('end', event);
        };
        // TODO: Remove close once the standard allows it
        this.provider.on('close', disconnect);
        this.provider.on('disconnect', disconnect);
    // TODO add end, timeout??
    }
};
/**
 * Asynchronously send request to provider.
 * Prefers to use the `request` method available on the provider as specified in [EIP-1193](https://eips.ethereum.org/EIPS/eip-1193).
 * If `request` is not available, falls back to `sendAsync` and `send` respectively.
 * @method send
 * @param {Object} data
 * @param {Function} callback
 */ $16b9a2608699f0e8$var$RequestManager.prototype.send = function(data, callback) {
    callback = callback || function() {};
    if (!this.provider) return callback($16b9a2608699f0e8$require$errors.InvalidProvider());
    const { method: method, params: params } = data;
    const jsonrpcPayload = $jemaa.toPayload(method, params);
    const jsonrpcResultCallback = this._jsonrpcResultCallback(callback, jsonrpcPayload);
    if (this.provider.request) {
        const callbackRequest = $16b9a2608699f0e8$require$callbackify(this.provider.request.bind(this.provider));
        const requestArgs = {
            method: method,
            params: params
        };
        callbackRequest(requestArgs, callback);
    } else if (this.provider.sendAsync) this.provider.sendAsync(jsonrpcPayload, jsonrpcResultCallback);
    else if (this.provider.send) this.provider.send(jsonrpcPayload, jsonrpcResultCallback);
    else throw new Error('Provider does not have a request or send method to use.');
};
/**
 * Asynchronously send batch request.
 * Only works if provider supports batch methods through `sendAsync` or `send`.
 * @method sendBatch
 * @param {Array} data - array of payload objects
 * @param {Function} callback
 */ $16b9a2608699f0e8$var$RequestManager.prototype.sendBatch = function(data, callback) {
    if (!this.provider) return callback($16b9a2608699f0e8$require$errors.InvalidProvider());
    var payload = $jemaa.toBatchPayload(data);
    this.provider[this.provider.sendAsync ? 'sendAsync' : 'send'](payload, function(err, results) {
        if (err) return callback(err);
        if (!Array.isArray(results)) return callback($16b9a2608699f0e8$require$errors.InvalidResponse(results));
        callback(null, results);
    });
};
/**
 * Waits for notifications
 *
 * @method addSubscription
 * @param {Subscription} subscription         the subscription
 * @param {String} type         the subscription namespace (eth, personal, etc)
 * @param {Function} callback   the callback to call for incoming notifications
 */ $16b9a2608699f0e8$var$RequestManager.prototype.addSubscription = function(subscription, callback) {
    if (this.provider.on) this.subscriptions.set(subscription.id, {
        callback: callback,
        subscription: subscription
    });
    else throw new Error('The provider doesn\'t support subscriptions: ' + this.provider.constructor.name);
};
/**
 * Waits for notifications
 *
 * @method removeSubscription
 * @param {String} id           the subscription id
 * @param {Function} callback   fired once the subscription is removed
 */ $16b9a2608699f0e8$var$RequestManager.prototype.removeSubscription = function(id, callback) {
    if (this.subscriptions.has(id)) {
        var type = this.subscriptions.get(id).subscription.options.type;
        // remove subscription first to avoid reentry
        this.subscriptions.delete(id);
        // then, try to actually unsubscribe
        this.send({
            method: type + '_unsubscribe',
            params: [
                id
            ]
        }, callback);
        return;
    }
    if (typeof callback === 'function') // call the callback if the subscription was already removed
    callback(null);
};
/**
 * Should be called to reset the subscriptions
 *
 * @method reset
 *
 * @returns {boolean}
 */ $16b9a2608699f0e8$var$RequestManager.prototype.clearSubscriptions = function(keepIsSyncing) {
    try {
        var _this = this;
        // uninstall all subscriptions
        if (this.subscriptions.size > 0) this.subscriptions.forEach(function(value, id) {
            if (!keepIsSyncing || value.name !== 'syncing') _this.removeSubscription(id);
        });
        //  reset notification callbacks etc.
        if (this.provider.reset) this.provider.reset();
        return true;
    } catch (e) {
        throw new Error(`Error while clearing subscriptions: ${e}`);
    }
};
/**
 * Evaluates WS close event
 *
 * @method _isCleanClose
 *
 * @param {CloseEvent | boolean} event WS close event or exception flag
 *
 * @returns {boolean}
 */ $16b9a2608699f0e8$var$RequestManager.prototype._isCleanCloseEvent = function(event) {
    return typeof event === 'object' && ([
        1000
    ].includes(event.code) || event.wasClean === true);
};
/**
 * Detects Ipc close error. The node.net module emits ('close', isException)
 *
 * @method _isIpcCloseError
 *
 * @param {CloseEvent | boolean} event WS close event or exception flag
 *
 * @returns {boolean}
 */ $16b9a2608699f0e8$var$RequestManager.prototype._isIpcCloseError = function(event) {
    return typeof event === 'boolean' && event;
};
/**
 * The jsonrpc result callback for RequestManager.send
 *
 * @method _jsonrpcResultCallback
 *
 * @param {Function} callback the callback to use
 * @param {Object} payload the jsonrpc payload
 *
 * @returns {Function} return callback of form (err, result)
 *
 */ $16b9a2608699f0e8$var$RequestManager.prototype._jsonrpcResultCallback = function(callback, payload) {
    return function(err, result) {
        if (result && result.id && payload.id !== result.id) return callback(new Error(`Wrong response id ${result.id} (expected: ${payload.id}) in ${JSON.stringify(payload)}`));
        if (err) return callback(err);
        if (result && result.error) return callback($16b9a2608699f0e8$require$errors.ErrorResponse(result));
        if (!$jemaa.isValidResponse(result)) return callback($16b9a2608699f0e8$require$errors.InvalidResponse(result));
        callback(null, result.result);
    };
};
module.exports = {
    Manager: $16b9a2608699f0e8$var$RequestManager,
    BatchManager: $9rJ4f
};

});
parcelRegister("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $hPtJY !== 'undefined' && $hPtJY.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $hPtJY === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = ' ' + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').substr(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== 'undefined';
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== 'undefined';
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === 'Uint8Array';
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === 'Uint16Array';
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === 'Uint32Array';
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === 'Int8Array';
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === 'Int16Array';
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === 'Int32Array';
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === 'Float32Array';
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === 'Float64Array';
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map]';
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== 'undefined' && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set]';
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== 'undefined' && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakMap]';
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakSet]';
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object DataView]';
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === 'undefined') $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("f4HGZ", function(module, exports) {
'use strict';
var $af991f1d6c80f097$var$hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

var $hXu6F = parcelRequire("hXu6F");
var $af991f1d6c80f097$var$$toString = $hXu6F('Object.prototype.toString');
var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === '[object Arguments]';
};
var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== '[object Array]' && $af991f1d6c80f097$var$$toString(value.callee) === '[object Function]';
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRegister("hXu6F", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $d12f4cdcd6b10506$var$$indexOf(name, '.prototype.') > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
'use strict';
var $1258b452ecf218a1$var$undefined1;
var $1258b452ecf218a1$var$$SyntaxError = SyntaxError;
var $1258b452ecf218a1$var$$Function = Function;
var $1258b452ecf218a1$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, '');
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $1258b452ecf218a1$var$$TypeError();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': Error,
    '%eval%': eval,
    '%EvalError%': EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': RangeError,
    '%ReferenceError%': ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $1258b452ecf218a1$var$$SyntaxError,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $1258b452ecf218a1$var$$TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $gvair = parcelRequire("gvair");

var $8aKn2 = parcelRequire("8aKn2");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $1258b452ecf218a1$var$$SyntaxError('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $1258b452ecf218a1$var$$SyntaxError('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($8aKn2($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $1258b452ecf218a1$var$$TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1258b452ecf218a1$var$$SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $1258b452ecf218a1$var$$TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $1258b452ecf218a1$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $1258b452ecf218a1$var$$SyntaxError('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $1258b452ecf218a1$var$$TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $8aKn2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("gvair", function(module, exports) {
'use strict';

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$slice = Array.prototype.slice;
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.call(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push('$' + i);
    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("8aKn2", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");
module.exports = $gvair.call(Function.call, Object.prototype.hasOwnProperty);

});


parcelRegister("cOB0F", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");
var $9546dce5bd4976bd$var$$apply = $1zENl('%Function.prototype.apply%');
var $9546dce5bd4976bd$var$$call = $1zENl('%Function.prototype.call%');
var $9546dce5bd4976bd$var$$reflectApply = $1zENl('%Reflect.apply%', true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);
var $9546dce5bd4976bd$var$$gOPD = $1zENl('%Object.getOwnPropertyDescriptor%', true);
var $9546dce5bd4976bd$var$$defineProperty = $1zENl('%Object.defineProperty%', true);
var $9546dce5bd4976bd$var$$max = $1zENl('%Math.max%');
if ($9546dce5bd4976bd$var$$defineProperty) try {
    $9546dce5bd4976bd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $9546dce5bd4976bd$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    if ($9546dce5bd4976bd$var$$gOPD && $9546dce5bd4976bd$var$$defineProperty) {
        var desc = $9546dce5bd4976bd$var$$gOPD(func, 'length');
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $9546dce5bd4976bd$var$$defineProperty(func, 'length', {
            value: 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($9546dce5bd4976bd$var$$defineProperty) $9546dce5bd4976bd$var$$defineProperty(module.exports, 'apply', {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});



parcelRegister("5WnCa", function(module, exports) {
'use strict';
var $4534afe844d627e4$var$toStr = Object.prototype.toString;
var $4534afe844d627e4$var$fnToStr = Function.prototype.toString;
var $4534afe844d627e4$var$isFnRegex = /^\s*(?:function)?\*/;
var $4534afe844d627e4$var$hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var $4534afe844d627e4$var$getProto = Object.getPrototypeOf;
var $4534afe844d627e4$var$getGeneratorFunc = function() {
    if (!$4534afe844d627e4$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $4534afe844d627e4$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($4534afe844d627e4$var$isFnRegex.test($4534afe844d627e4$var$fnToStr.call(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$4534afe844d627e4$var$getProto) return false;
    if (typeof $4534afe844d627e4$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $4534afe844d627e4$var$getGeneratorFunc();
        $4534afe844d627e4$var$GeneratorFunction = generatorFunc ? $4534afe844d627e4$var$getProto(generatorFunc) : false;
    }
    return $4534afe844d627e4$var$getProto(fn) === $4534afe844d627e4$var$GeneratorFunction;
};

});

parcelRegister("gJrpv", function(module, exports) {
'use strict';

var $1n2vj = parcelRequire("1n2vj");

var $8yXCr = parcelRequire("8yXCr");

var $hXu6F = parcelRequire("hXu6F");
var $c2e61c703a2c9ae0$var$$toString = $hXu6F('Object.prototype.toString');

var $c2e61c703a2c9ae0$var$hasSymbols = (parcelRequire("24qIq"))();
var $c2e61c703a2c9ae0$var$hasToStringTag = $c2e61c703a2c9ae0$var$hasSymbols && typeof Symbol.toStringTag === 'symbol';
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $hXu6F('String.prototype.slice');
var $c2e61c703a2c9ae0$var$toStrTags = {};

var $6SeTG = parcelRequire("6SeTG");
var $c2e61c703a2c9ae0$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($c2e61c703a2c9ae0$var$hasToStringTag && $6SeTG && $c2e61c703a2c9ae0$var$getPrototypeOf) $1n2vj($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    if (typeof $parcel$global[typedArray] === 'function') {
        var arr = new $parcel$global[typedArray]();
        if (!(Symbol.toStringTag in arr)) throw new EvalError('this engine has support for Symbol.toStringTag, but ' + typedArray + ' does not have the property! Please report this.');
        var proto = $c2e61c703a2c9ae0$var$getPrototypeOf(arr);
        var descriptor = $6SeTG(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $c2e61c703a2c9ae0$var$getPrototypeOf(proto);
            descriptor = $6SeTG(superProto, Symbol.toStringTag);
        }
        $c2e61c703a2c9ae0$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $1n2vj($c2e61c703a2c9ae0$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

var $hN833 = parcelRequire("hN833");
module.exports = function whichTypedArray(value) {
    if (!$hN833(value)) return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) return $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("1n2vj", function(module, exports) {
var $0ff9e1aaf16a50e1$var$hasOwn = Object.prototype.hasOwnProperty;
var $0ff9e1aaf16a50e1$var$toString = Object.prototype.toString;
module.exports = function forEach(obj, fn, ctx) {
    if ($0ff9e1aaf16a50e1$var$toString.call(fn) !== '[object Function]') throw new TypeError('iterator must be a function');
    var l = obj.length;
    if (l === +l) for(var i = 0; i < l; i++)fn.call(ctx, obj[i], i, obj);
    else {
        for(var k in obj)if ($0ff9e1aaf16a50e1$var$hasOwn.call(obj, k)) fn.call(ctx, obj[k], k, obj);
    }
};

});

parcelRegister("8yXCr", function(module, exports) {
'use strict';
var $63bfbecf41903c8f$var$possibleNames = [
    'BigInt64Array',
    'BigUint64Array',
    'Float32Array',
    'Float64Array',
    'Int16Array',
    'Int32Array',
    'Int8Array',
    'Uint16Array',
    'Uint32Array',
    'Uint8Array',
    'Uint8ClampedArray'
];
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $63bfbecf41903c8f$var$possibleNames.length; i++)if (typeof $parcel$global[$63bfbecf41903c8f$var$possibleNames[i]] === 'function') out[out.length] = $63bfbecf41903c8f$var$possibleNames[i];
    return out;
};

});

parcelRegister("6SeTG", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");
var $5013578038c7b048$var$$gOPD = $1zENl('%Object.getOwnPropertyDescriptor%', true);
if ($5013578038c7b048$var$$gOPD) try {
    $5013578038c7b048$var$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $5013578038c7b048$var$$gOPD = null;
}
module.exports = $5013578038c7b048$var$$gOPD;

});

parcelRegister("hN833", function(module, exports) {
'use strict';

var $1n2vj = parcelRequire("1n2vj");

var $8yXCr = parcelRequire("8yXCr");

var $hXu6F = parcelRequire("hXu6F");
var $cf3d4182e663752d$var$$toString = $hXu6F('Object.prototype.toString');

var $cf3d4182e663752d$var$hasSymbols = (parcelRequire("24qIq"))();
var $cf3d4182e663752d$var$hasToStringTag = $cf3d4182e663752d$var$hasSymbols && typeof Symbol.toStringTag === 'symbol';
var $cf3d4182e663752d$var$typedArrays = $8yXCr();
var $cf3d4182e663752d$var$$indexOf = $hXu6F('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $cf3d4182e663752d$var$$slice = $hXu6F('String.prototype.slice');
var $cf3d4182e663752d$var$toStrTags = {};

var $6SeTG = parcelRequire("6SeTG");
var $cf3d4182e663752d$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($cf3d4182e663752d$var$hasToStringTag && $6SeTG && $cf3d4182e663752d$var$getPrototypeOf) $1n2vj($cf3d4182e663752d$var$typedArrays, function(typedArray) {
    var arr = new $parcel$global[typedArray]();
    if (!(Symbol.toStringTag in arr)) throw new EvalError('this engine has support for Symbol.toStringTag, but ' + typedArray + ' does not have the property! Please report this.');
    var proto = $cf3d4182e663752d$var$getPrototypeOf(arr);
    var descriptor = $6SeTG(proto, Symbol.toStringTag);
    if (!descriptor) {
        var superProto = $cf3d4182e663752d$var$getPrototypeOf(proto);
        descriptor = $6SeTG(superProto, Symbol.toStringTag);
    }
    $cf3d4182e663752d$var$toStrTags[typedArray] = descriptor.get;
});
var $cf3d4182e663752d$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $1n2vj($cf3d4182e663752d$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$cf3d4182e663752d$var$hasToStringTag) {
        var tag = $cf3d4182e663752d$var$$slice($cf3d4182e663752d$var$$toString(value), 8, -1);
        return $cf3d4182e663752d$var$$indexOf($cf3d4182e663752d$var$typedArrays, tag) > -1;
    }
    if (!$6SeTG) return false;
    return $cf3d4182e663752d$var$tryTypedArrays(value);
};

});



parcelRegister("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("hA2kM", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $jQ34I = parcelRequire("jQ34I");

var $aSWDc = parcelRequire("aSWDc");
module.exports = {
    errors: $jQ34I,
    formatters: $aSWDc
};

});
parcelRegister("jQ34I", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file errors.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2017
 */ "use strict";
module.exports = {
    ErrorResponse: function(result) {
        var message = !!result && !!result.error && !!result.error.message ? result.error.message : JSON.stringify(result);
        var data = !!result.error && !!result.error.data ? result.error.data : null;
        var err = new Error('Returned error: ' + message);
        err.data = data;
        return err;
    },
    InvalidNumberOfParams: function(got, expected, method) {
        return new Error('Invalid number of parameters for "' + method + '". Got ' + got + ' expected ' + expected + '!');
    },
    InvalidConnection: function(host, event) {
        return this.ConnectionError('CONNECTION ERROR: Couldn\'t connect to node ' + host + '.', event);
    },
    InvalidProvider: function() {
        return new Error('Provider not set or invalid');
    },
    InvalidResponse: function(result) {
        var message = !!result && !!result.error && !!result.error.message ? result.error.message : 'Invalid JSON RPC response: ' + JSON.stringify(result);
        return new Error(message);
    },
    ConnectionTimeout: function(ms) {
        return new Error('CONNECTION TIMEOUT: timeout of ' + ms + ' ms achived');
    },
    ConnectionNotOpenError: function(event) {
        return this.ConnectionError('connection not open on send()', event);
    },
    ConnectionCloseError: function(event) {
        if (typeof event === 'object' && event.code && event.reason) return this.ConnectionError("CONNECTION ERROR: The connection got closed with the close code `" + event.code + '` and the following ' + 'reason string `' + event.reason + '`', event);
        return new Error('CONNECTION ERROR: The connection closed unexpectedly');
    },
    MaxAttemptsReachedOnReconnectingError: function() {
        return new Error('Maximum number of reconnect attempts reached!');
    },
    PendingRequestsOnReconnectingError: function() {
        return new Error('CONNECTION ERROR: Provider started to reconnect before the response got received!');
    },
    ConnectionError: function(msg, event) {
        const error = new Error(msg);
        if (event) {
            error.code = event.code;
            error.reason = event.reason;
        }
        return error;
    },
    RevertInstructionError: function(reason, signature) {
        var error = new Error('Your request got reverted with the following reason string: ' + reason);
        error.reason = reason;
        error.signature = signature;
        return error;
    },
    TransactionRevertInstructionError: function(reason, signature, receipt) {
        var error = new Error('Transaction has been reverted by the EVM:\n' + JSON.stringify(receipt, null, 2));
        error.reason = reason;
        error.signature = signature;
        error.receipt = receipt;
        return error;
    },
    TransactionError: function(message, receipt) {
        var error = new Error(message);
        error.receipt = receipt;
        return error;
    },
    NoContractAddressFoundError: function(receipt) {
        return this.TransactionError('The transaction receipt didn\'t contain a contract address.', receipt);
    },
    ContractCodeNotStoredError: function(receipt) {
        return this.TransactionError('The contract code couldn\'t be stored, please check your gas limit.', receipt);
    },
    TransactionRevertedWithoutReasonError: function(receipt) {
        return this.TransactionError('Transaction has been reverted by the EVM:\n' + JSON.stringify(receipt, null, 2), receipt);
    },
    TransactionOutOfGasError: function(receipt) {
        return this.TransactionError('Transaction ran out of gas. Please provide more gas:\n' + JSON.stringify(receipt, null, 2), receipt);
    },
    ResolverMethodMissingError: function(address, name) {
        return new Error('The resolver at ' + address + 'does not implement requested method: "' + name + '".');
    },
    ContractMissingABIError: function() {
        return new Error('You must provide the json interface of the contract when instantiating a contract object.');
    },
    ContractOnceRequiresCallbackError: function() {
        return new Error('Once requires a callback as the second parameter.');
    },
    ContractEventDoesNotExistError: function(eventName) {
        return new Error('Event "' + eventName + '" doesn\'t exist in this contract.');
    },
    ContractReservedEventError: function(type) {
        return new Error('The event "' + type + '" is a reserved event name, you can\'t use it.');
    },
    ContractMissingDeployDataError: function() {
        return new Error('No "data" specified in neither the given options, nor the default options.');
    },
    ContractNoAddressDefinedError: function() {
        return new Error('This contract object doesn\'t have address set yet, please set an address first.');
    },
    ContractNoFromAddressDefinedError: function() {
        return new Error('No "from" address specified in neither the given options, nor the default options.');
    }
};

});

parcelRegister("aSWDc", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file formatters.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2017
 */ "use strict";

var $9y1Dl = parcelRequire("9y1Dl");

var $lyBXN = parcelRequire("lyBXN");
/**
 * Will format the given storage key array values to hex strings.
 *
 * @method inputStorageKeysFormatter
 *
 * @param {Array<Number|String|BN|BigNumber>} keys
 *
 * @returns {Array<String>}
 */ var $7ecc6d7f1a850ec9$var$inputStorageKeysFormatter = function(keys) {
    return keys.map($9y1Dl.numberToHex);
};
/**
 * Will format the given proof response from the node.
 *
 * @method outputProofFormatter
 *
 * @param {object} proof
 *
 * @returns {object}
 */ var $7ecc6d7f1a850ec9$var$outputProofFormatter = function(proof) {
    proof.address = $9y1Dl.toChecksumAddress(proof.address);
    proof.nonce = $9y1Dl.hexToNumberString(proof.nonce);
    proof.balance = $9y1Dl.hexToNumberString(proof.balance);
    return proof;
};
/**
 * Should the format output to a big number
 *
 * @method outputBigNumberFormatter
 *
 * @param {String|Number|BigNumber|BN} number
 *
 * @returns {BN} object
 */ var $7ecc6d7f1a850ec9$var$outputBigNumberFormatter = function(number) {
    return $9y1Dl.toBN(number).toString(10);
};
/**
 * Returns true if the given blockNumber is 'latest', 'pending', or 'earliest.
 *
 * @method isPredefinedBlockNumber
 *
 * @param {String} blockNumber
 *
 * @returns {Boolean}
 */ var $7ecc6d7f1a850ec9$var$isPredefinedBlockNumber = function(blockNumber) {
    return blockNumber === 'latest' || blockNumber === 'pending' || blockNumber === 'earliest';
};
/**
 * Returns the given block number as hex string or does return the defaultBlock property of the current module
 *
 * @method inputDefaultBlockNumberFormatter
 *
 * @param {String|Number|BN|BigNumber} blockNumber
 *
 * @returns {String}
 */ var $7ecc6d7f1a850ec9$var$inputDefaultBlockNumberFormatter = function(blockNumber) {
    if (this && (blockNumber === undefined || blockNumber === null)) return $7ecc6d7f1a850ec9$var$inputBlockNumberFormatter(this.defaultBlock);
    return $7ecc6d7f1a850ec9$var$inputBlockNumberFormatter(blockNumber);
};
/**
 * Returns the given block number as hex string or the predefined block number 'latest', 'pending', 'earliest', 'genesis'
 *
 * @param {String|Number|BN|BigNumber} blockNumber
 *
 * @returns {String}
 */ var $7ecc6d7f1a850ec9$var$inputBlockNumberFormatter = function(blockNumber) {
    if (blockNumber === undefined) return undefined;
    if ($7ecc6d7f1a850ec9$var$isPredefinedBlockNumber(blockNumber)) return blockNumber;
    if (blockNumber === 'genesis') return '0x0';
    return $9y1Dl.isHexStrict(blockNumber) ? typeof blockNumber === 'string' ? blockNumber.toLowerCase() : blockNumber : $9y1Dl.numberToHex(blockNumber);
};
/**
 * Formats the input of a transaction and converts all values to HEX
 *
 * @method _txInputFormatter
 * @param {Object} transaction options
 * @returns object
 */ var $7ecc6d7f1a850ec9$var$_txInputFormatter = function(options) {
    if (options.to) options.to = $7ecc6d7f1a850ec9$var$inputAddressFormatter(options.to);
    if (options.data && options.input) throw new Error('You can\'t have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.');
    if (!options.data && options.input) {
        options.data = options.input;
        delete options.input;
    }
    if (options.data && !options.data.startsWith('0x')) options.data = '0x' + options.data;
    if (options.data && !$9y1Dl.isHex(options.data)) throw new Error('The data field must be HEX encoded data.');
    // allow both
    if (options.gas || options.gasLimit) options.gas = options.gas || options.gasLimit;
    if (options.maxPriorityFeePerGas || options.maxFeePerGas) delete options.gasPrice;
    [
        'gasPrice',
        'gas',
        'value',
        'maxPriorityFeePerGas',
        'maxFeePerGas',
        'nonce'
    ].filter(function(key) {
        return options[key] !== undefined;
    }).forEach(function(key) {
        options[key] = $9y1Dl.numberToHex(options[key]);
    });
    return options;
};
/**
 * Formats the input of a transaction and converts all values to HEX
 *
 * @method inputCallFormatter
 * @param {Object} transaction options
 * @returns object
 */ var $7ecc6d7f1a850ec9$var$inputCallFormatter = function(options) {
    options = $7ecc6d7f1a850ec9$var$_txInputFormatter(options);
    var from = options.from || (this ? this.defaultAccount : null);
    if (from) options.from = $7ecc6d7f1a850ec9$var$inputAddressFormatter(from);
    return options;
};
/**
 * Formats the input of a transaction and converts all values to HEX
 *
 * @method inputTransactionFormatter
 * @param {Object} options
 * @returns object
 */ var $7ecc6d7f1a850ec9$var$inputTransactionFormatter = function(options) {
    options = $7ecc6d7f1a850ec9$var$_txInputFormatter(options);
    // check from, only if not number, or object
    if (!(typeof options.from === 'number') && !(!!options.from && typeof options.from === 'object')) {
        options.from = options.from || (this ? this.defaultAccount : null);
        if (!options.from && !(typeof options.from === 'number')) throw new Error('The send transactions "from" field must be defined!');
        options.from = $7ecc6d7f1a850ec9$var$inputAddressFormatter(options.from);
    }
    return options;
};
/**
 * Hex encodes the data passed to eth_sign and personal_sign
 *
 * @method inputSignFormatter
 * @param {String} data
 * @returns {String}
 */ var $7ecc6d7f1a850ec9$var$inputSignFormatter = function(data) {
    return $9y1Dl.isHexStrict(data) ? data : $9y1Dl.utf8ToHex(data);
};
/**
 * Formats the output of a transaction to its proper values
 *
 * @method outputTransactionFormatter
 * @param {Object} tx
 * @returns {Object}
 */ var $7ecc6d7f1a850ec9$var$outputTransactionFormatter = function(tx) {
    if (tx.blockNumber !== null) tx.blockNumber = $9y1Dl.hexToNumber(tx.blockNumber);
    if (tx.transactionIndex !== null) tx.transactionIndex = $9y1Dl.hexToNumber(tx.transactionIndex);
    tx.nonce = $9y1Dl.hexToNumber(tx.nonce);
    tx.gas = $9y1Dl.hexToNumber(tx.gas);
    if (tx.gasPrice) tx.gasPrice = $7ecc6d7f1a850ec9$var$outputBigNumberFormatter(tx.gasPrice);
    if (tx.maxFeePerGas) tx.maxFeePerGas = $7ecc6d7f1a850ec9$var$outputBigNumberFormatter(tx.maxFeePerGas);
    if (tx.maxPriorityFeePerGas) tx.maxPriorityFeePerGas = $7ecc6d7f1a850ec9$var$outputBigNumberFormatter(tx.maxPriorityFeePerGas);
    if (tx.type) tx.type = $9y1Dl.hexToNumber(tx.type);
    tx.value = $7ecc6d7f1a850ec9$var$outputBigNumberFormatter(tx.value);
    if (tx.to && $9y1Dl.isAddress(tx.to)) tx.to = $9y1Dl.toChecksumAddress(tx.to);
    else tx.to = null; // set to `null` if invalid address
    if (tx.from) tx.from = $9y1Dl.toChecksumAddress(tx.from);
    return tx;
};
/**
 * Formats the output of a transaction receipt to its proper values
 *
 * @method outputTransactionReceiptFormatter
 * @param {Object} receipt
 * @returns {Object}
 */ var $7ecc6d7f1a850ec9$var$outputTransactionReceiptFormatter = function(receipt) {
    if (typeof receipt !== 'object') throw new Error('Received receipt is invalid: ' + receipt);
    if (receipt.blockNumber !== null) receipt.blockNumber = $9y1Dl.hexToNumber(receipt.blockNumber);
    if (receipt.transactionIndex !== null) receipt.transactionIndex = $9y1Dl.hexToNumber(receipt.transactionIndex);
    receipt.cumulativeGasUsed = $9y1Dl.hexToNumber(receipt.cumulativeGasUsed);
    receipt.gasUsed = $9y1Dl.hexToNumber(receipt.gasUsed);
    if (Array.isArray(receipt.logs)) receipt.logs = receipt.logs.map($7ecc6d7f1a850ec9$var$outputLogFormatter);
    if (receipt.effectiveGasPrice) receipt.effectiveGasPrice = $9y1Dl.hexToNumber(receipt.effectiveGasPrice);
    if (receipt.contractAddress) receipt.contractAddress = $9y1Dl.toChecksumAddress(receipt.contractAddress);
    if (typeof receipt.status !== 'undefined' && receipt.status !== null) receipt.status = Boolean(parseInt(receipt.status));
    return receipt;
};
/**
 * Formats the output of a block to its proper values
 *
 * @method outputBlockFormatter
 * @param {Object} block
 * @returns {Object}
 */ var $7ecc6d7f1a850ec9$var$outputBlockFormatter = function(block) {
    // transform to number
    block.gasLimit = $9y1Dl.hexToNumber(block.gasLimit);
    block.gasUsed = $9y1Dl.hexToNumber(block.gasUsed);
    block.size = $9y1Dl.hexToNumber(block.size);
    block.timestamp = $9y1Dl.hexToNumber(block.timestamp);
    if (block.number !== null) block.number = $9y1Dl.hexToNumber(block.number);
    if (block.difficulty) block.difficulty = $7ecc6d7f1a850ec9$var$outputBigNumberFormatter(block.difficulty);
    if (block.totalDifficulty) block.totalDifficulty = $7ecc6d7f1a850ec9$var$outputBigNumberFormatter(block.totalDifficulty);
    if (Array.isArray(block.transactions)) block.transactions.forEach(function(item) {
        if (!(typeof item === 'string')) return $7ecc6d7f1a850ec9$var$outputTransactionFormatter(item);
    });
    if (block.miner) block.miner = $9y1Dl.toChecksumAddress(block.miner);
    if (block.baseFeePerGas) block.baseFeePerGas = $9y1Dl.hexToNumber(block.baseFeePerGas);
    return block;
};
/**
 * Formats the input of a log
 *
 * @method inputLogFormatter
 * @param {Object} log object
 * @returns {Object} log
 */ var $7ecc6d7f1a850ec9$var$inputLogFormatter = function(options) {
    var toTopic = function(value) {
        if (value === null || typeof value === 'undefined') return null;
        value = String(value);
        if (value.indexOf('0x') === 0) return value;
        else return $9y1Dl.fromUtf8(value);
    };
    if (options === undefined) options = {};
    // If options !== undefined, don't blow out existing data
    if (options.fromBlock === undefined) options = {
        ...options,
        fromBlock: 'latest'
    };
    if (options.fromBlock || options.fromBlock === 0) options.fromBlock = $7ecc6d7f1a850ec9$var$inputBlockNumberFormatter(options.fromBlock);
    if (options.toBlock || options.toBlock === 0) options.toBlock = $7ecc6d7f1a850ec9$var$inputBlockNumberFormatter(options.toBlock);
    // make sure topics, get converted to hex
    options.topics = options.topics || [];
    options.topics = options.topics.map(function(topic) {
        return Array.isArray(topic) ? topic.map(toTopic) : toTopic(topic);
    });
    toTopic = null;
    if (options.address) options.address = Array.isArray(options.address) ? options.address.map(function(addr) {
        return $7ecc6d7f1a850ec9$var$inputAddressFormatter(addr);
    }) : $7ecc6d7f1a850ec9$var$inputAddressFormatter(options.address);
    return options;
};
/**
 * Formats the output of a log
 *
 * @method outputLogFormatter
 * @param {Object} log object
 * @returns {Object} log
 */ var $7ecc6d7f1a850ec9$var$outputLogFormatter = function(log) {
    // generate a custom log id
    if (typeof log.blockHash === 'string' && typeof log.transactionHash === 'string' && typeof log.logIndex === 'string') {
        var shaId = $9y1Dl.sha3(log.blockHash.replace('0x', '') + log.transactionHash.replace('0x', '') + log.logIndex.replace('0x', ''));
        log.id = 'log_' + shaId.replace('0x', '').substr(0, 8);
    } else if (!log.id) log.id = null;
    if (log.blockNumber !== null) log.blockNumber = $9y1Dl.hexToNumber(log.blockNumber);
    if (log.transactionIndex !== null) log.transactionIndex = $9y1Dl.hexToNumber(log.transactionIndex);
    if (log.logIndex !== null) log.logIndex = $9y1Dl.hexToNumber(log.logIndex);
    if (log.address) log.address = $9y1Dl.toChecksumAddress(log.address);
    return log;
};
/**
 * Formats the input of a whisper post and converts all values to HEX
 *
 * @method inputPostFormatter
 * @param {Object} transaction object
 * @returns {Object}
 */ var $7ecc6d7f1a850ec9$var$inputPostFormatter = function(post) {
    // post.payload = utils.toHex(post.payload);
    if (post.ttl) post.ttl = $9y1Dl.numberToHex(post.ttl);
    if (post.workToProve) post.workToProve = $9y1Dl.numberToHex(post.workToProve);
    if (post.priority) post.priority = $9y1Dl.numberToHex(post.priority);
    // fallback
    if (!Array.isArray(post.topics)) post.topics = post.topics ? [
        post.topics
    ] : [];
    // format the following options
    post.topics = post.topics.map(function(topic) {
        // convert only if not hex
        return topic.indexOf('0x') === 0 ? topic : $9y1Dl.fromUtf8(topic);
    });
    return post;
};
/**
 * Formats the output of a received post message
 *
 * @method outputPostFormatter
 * @param {Object}
 * @returns {Object}
 */ var $7ecc6d7f1a850ec9$var$outputPostFormatter = function(post) {
    post.expiry = $9y1Dl.hexToNumber(post.expiry);
    post.sent = $9y1Dl.hexToNumber(post.sent);
    post.ttl = $9y1Dl.hexToNumber(post.ttl);
    post.workProved = $9y1Dl.hexToNumber(post.workProved);
    // post.payloadRaw = post.payload;
    // post.payload = utils.hexToAscii(post.payload);
    // if (utils.isJson(post.payload)) {
    //     post.payload = JSON.parse(post.payload);
    // }
    // format the following options
    if (!post.topics) post.topics = [];
    post.topics = post.topics.map(function(topic) {
        return $9y1Dl.toUtf8(topic);
    });
    return post;
};
var $7ecc6d7f1a850ec9$var$inputAddressFormatter = function(address) {
    var iban = new $lyBXN(address);
    if (iban.isValid() && iban.isDirect()) return iban.toAddress().toLowerCase();
    else if ($9y1Dl.isAddress(address)) return '0x' + address.toLowerCase().replace('0x', '');
    throw new Error(`Provided address ${address} is invalid, the capitalization checksum test failed, or it's an indirect IBAN address which can't be converted.`);
};
var $7ecc6d7f1a850ec9$var$outputSyncingFormatter = function(result) {
    result.startingBlock = $9y1Dl.hexToNumber(result.startingBlock);
    result.currentBlock = $9y1Dl.hexToNumber(result.currentBlock);
    result.highestBlock = $9y1Dl.hexToNumber(result.highestBlock);
    if (result.knownStates) {
        result.knownStates = $9y1Dl.hexToNumber(result.knownStates);
        result.pulledStates = $9y1Dl.hexToNumber(result.pulledStates);
    }
    return result;
};
module.exports = {
    inputDefaultBlockNumberFormatter: $7ecc6d7f1a850ec9$var$inputDefaultBlockNumberFormatter,
    inputBlockNumberFormatter: $7ecc6d7f1a850ec9$var$inputBlockNumberFormatter,
    inputCallFormatter: $7ecc6d7f1a850ec9$var$inputCallFormatter,
    inputTransactionFormatter: $7ecc6d7f1a850ec9$var$inputTransactionFormatter,
    inputAddressFormatter: $7ecc6d7f1a850ec9$var$inputAddressFormatter,
    inputPostFormatter: $7ecc6d7f1a850ec9$var$inputPostFormatter,
    inputLogFormatter: $7ecc6d7f1a850ec9$var$inputLogFormatter,
    inputSignFormatter: $7ecc6d7f1a850ec9$var$inputSignFormatter,
    inputStorageKeysFormatter: $7ecc6d7f1a850ec9$var$inputStorageKeysFormatter,
    outputProofFormatter: $7ecc6d7f1a850ec9$var$outputProofFormatter,
    outputBigNumberFormatter: $7ecc6d7f1a850ec9$var$outputBigNumberFormatter,
    outputTransactionFormatter: $7ecc6d7f1a850ec9$var$outputTransactionFormatter,
    outputTransactionReceiptFormatter: $7ecc6d7f1a850ec9$var$outputTransactionReceiptFormatter,
    outputBlockFormatter: $7ecc6d7f1a850ec9$var$outputBlockFormatter,
    outputLogFormatter: $7ecc6d7f1a850ec9$var$outputLogFormatter,
    outputPostFormatter: $7ecc6d7f1a850ec9$var$outputPostFormatter,
    outputSyncingFormatter: $7ecc6d7f1a850ec9$var$outputSyncingFormatter
};

});
parcelRegister("9y1Dl", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file utils.js
 * @author Marek Kotewicz <marek@parity.io>
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ 
var $bijMU = parcelRequire("bijMU");

var $eNPzt = parcelRequire("eNPzt");

var $gQOic = parcelRequire("gQOic");

var $hkN9y = parcelRequire("hkN9y");

var $9WenL = parcelRequire("9WenL");
/**
 * Fires an error in an event emitter and callback and returns the eventemitter
 *
 * @method _fireError
 * @param {Object} error a string, a error, or an object with {message, data}
 * @param {Object} emitter
 * @param {Function} reject
 * @param {Function} callback
 * @param {any} optionalData
 * @return {Object} the emitter
 */ var $6f388e73f687fdcf$var$_fireError = function(error, emitter, reject, callback, optionalData) {
    /*jshint maxcomplexity: 10 */ // add data if given
    if (!!error && typeof error === 'object' && !(error instanceof Error) && error.data) {
        if (!!error.data && typeof error.data === 'object' || Array.isArray(error.data)) error.data = JSON.stringify(error.data, null, 2);
        error = error.message + "\n" + error.data;
    }
    if (typeof error === 'string') error = new Error(error);
    if (typeof callback === 'function') callback(error, optionalData);
    if (typeof reject === 'function') {
        // suppress uncatched error if an error listener is present
        // OR suppress uncatched error if an callback listener is present
        if (emitter && typeof emitter.listeners === 'function' && emitter.listeners('error').length || typeof callback === 'function') emitter.catch(function() {});
        // reject later, to be able to return emitter
        setTimeout(function() {
            reject(error);
        }, 1);
    }
    if (emitter && typeof emitter.emit === 'function') // emit later, to be able to return emitter
    setTimeout(function() {
        emitter.emit('error', error, optionalData);
        emitter.removeAllListeners();
    }, 1);
    return emitter;
};
/**
 * Should be used to create full function/event name from json abi
 *
 * @method _jsonInterfaceMethodToString
 * @param {Object} json
 * @return {String} full function/event name
 */ var $6f388e73f687fdcf$var$_jsonInterfaceMethodToString = function(json) {
    if (!!json && typeof json === 'object' && json.name && json.name.indexOf('(') !== -1) return json.name;
    return json.name + '(' + $6f388e73f687fdcf$var$_flattenTypes(false, json.inputs).join(',') + ')';
};
/**
 * Should be used to flatten json abi inputs/outputs into an array of type-representing-strings
 *
 * @method _flattenTypes
 * @param {bool} includeTuple
 * @param {Object} puts
 * @return {Array} parameters as strings
 */ var $6f388e73f687fdcf$var$_flattenTypes = function(includeTuple, puts) {
    // console.log("entered _flattenTypes. inputs/outputs: " + puts)
    var types = [];
    puts.forEach(function(param) {
        if (typeof param.components === 'object') {
            if (param.type.substring(0, 5) !== 'tuple') throw new Error('components found but type is not tuple; report on GitHub');
            var suffix = '';
            var arrayBracket = param.type.indexOf('[');
            if (arrayBracket >= 0) suffix = param.type.substring(arrayBracket);
            var result = $6f388e73f687fdcf$var$_flattenTypes(includeTuple, param.components);
            // console.log("result should have things: " + result)
            if (Array.isArray(result) && includeTuple) // console.log("include tuple word, and its an array. joining...: " + result.types)
            types.push('tuple(' + result.join(',') + ')' + suffix);
            else if (!includeTuple) // console.log("don't include tuple, but its an array. joining...: " + result)
            types.push('(' + result.join(',') + ')' + suffix);
            else // console.log("its a single type within a tuple: " + result.types)
            types.push('(' + result + ')');
        } else // console.log("its a type and not directly in a tuple: " + param.type)
        types.push(param.type);
    });
    return types;
};
/**
 * Returns a random hex string by the given bytes size
 *
 * @param {Number} size
 * @returns {string}
 */ var $6f388e73f687fdcf$var$randomHex = function(size) {
    return '0x' + $hkN9y(size).toString('hex');
};
/**
 * Should be called to get ascii from it's hex representation
 *
 * @method hexToAscii
 * @param {String} hex
 * @returns {String} ascii string representation of hex value
 */ var $6f388e73f687fdcf$var$hexToAscii = function(hex) {
    if (!$eNPzt.isHexStrict(hex)) throw new Error('The parameter must be a valid HEX string.');
    var str = "";
    var i = 0, l = hex.length;
    if (hex.substring(0, 2) === '0x') i = 2;
    for(; i < l; i += 2){
        var code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
};
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @method asciiToHex
 * @param {String} str
 * @returns {String} hex representation of input string
 */ var $6f388e73f687fdcf$var$asciiToHex = function(str) {
    if (!str) return "0x00";
    var hex = "";
    for(var i = 0; i < str.length; i++){
        var code = str.charCodeAt(i);
        var n = code.toString(16);
        hex += n.length < 2 ? '0' + n : n;
    }
    return "0x" + hex;
};
/**
 * Returns value of unit in Wei
 *
 * @method getUnitValue
 * @param {String} unit the unit to convert to, default ether
 * @returns {BN} value of the unit (in Wei)
 * @throws error if the unit is not correct:w
 */ var $6f388e73f687fdcf$var$getUnitValue = function(unit) {
    unit = unit ? unit.toLowerCase() : 'ether';
    if (!$bijMU.unitMap[unit]) throw new Error('This unit "' + unit + '" doesn\'t exist, please use the one of the following units' + JSON.stringify($bijMU.unitMap, null, 2));
    return unit;
};
/**
 * Takes a number of wei and converts it to any other ether unit.
 *
 * Possible units are:
 *   SI Short   SI Full        Effigy       Other
 * - kwei       femtoether     babbage
 * - mwei       picoether      lovelace
 * - gwei       nanoether      shannon      nano
 * - --         microether     szabo        micro
 * - --         milliether     finney       milli
 * - ether      --             --
 * - kether                    --           grand
 * - mether
 * - gether
 * - tether
 *
 * @method fromWei
 * @param {Number|String} number can be a number, number string or a HEX of a decimal
 * @param {String} unit the unit to convert to, default ether
 * @return {String|Object} When given a BN object it returns one as well, otherwise a number
 */ var $6f388e73f687fdcf$var$fromWei = function(number, unit) {
    unit = $6f388e73f687fdcf$var$getUnitValue(unit);
    if (!$eNPzt.isBN(number) && !(typeof number === 'string')) throw new Error('Please pass numbers as strings or BN objects to avoid precision errors.');
    return $eNPzt.isBN(number) ? $bijMU.fromWei(number, unit) : $bijMU.fromWei(number, unit).toString(10);
};
/**
 * Takes a number of a unit and converts it to wei.
 *
 * Possible units are:
 *   SI Short   SI Full        Effigy       Other
 * - kwei       femtoether     babbage
 * - mwei       picoether      lovelace
 * - gwei       nanoether      shannon      nano
 * - --         microether     szabo        micro
 * - --         microether     szabo        micro
 * - --         milliether     finney       milli
 * - ether      --             --
 * - kether                    --           grand
 * - mether
 * - gether
 * - tether
 *
 * @method toWei
 * @param {Number|String|BN} number can be a number, number string or a HEX of a decimal
 * @param {String} unit the unit to convert from, default ether
 * @return {String|Object} When given a BN object it returns one as well, otherwise a number
 */ var $6f388e73f687fdcf$var$toWei = function(number, unit) {
    unit = $6f388e73f687fdcf$var$getUnitValue(unit);
    if (!$eNPzt.isBN(number) && !(typeof number === 'string')) throw new Error('Please pass numbers as strings or BN objects to avoid precision errors.');
    return $eNPzt.isBN(number) ? $bijMU.toWei(number, unit) : $bijMU.toWei(number, unit).toString(10);
};
/**
 * Converts to a checksum address
 *
 * @method toChecksumAddress
 * @param {String} address the given HEX address
 * @return {String}
 */ var $6f388e73f687fdcf$var$toChecksumAddress = function(address) {
    if (typeof address === 'undefined') return '';
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) throw new Error('Given address "' + address + '" is not a valid Ethereum address.');
    address = address.toLowerCase().replace(/^0x/i, '');
    var addressHash = $eNPzt.sha3(address).replace(/^0x/i, '');
    var checksumAddress = '0x';
    for(var i = 0; i < address.length; i++)// If ith character is 8 to f then make it uppercase
    if (parseInt(addressHash[i], 16) > 7) checksumAddress += address[i].toUpperCase();
    else checksumAddress += address[i];
    return checksumAddress;
};
/**
 * Returns -1 if a<b, 1 if a>b; 0 if a == b.
 * For more details on this type of function, see
 * developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
 *
 * @method compareBlockNumbers
 *
 * @param {String|Number|BN} a
 *
 * @param {String|Number|BN} b
 *
 * @returns {Number} -1, 0, or 1
 */ var $6f388e73f687fdcf$var$compareBlockNumbers = function(a, b) {
    if (a == b) return 0;
    else if (("genesis" == a || "earliest" == a || 0 == a) && ("genesis" == b || "earliest" == b || 0 == b)) return 0;
    else if ("genesis" == a || "earliest" == a) // b !== a, thus a < b
    return -1;
    else if ("genesis" == b || "earliest" == b) // b !== a, thus a > b
    return 1;
    else if (a == "latest") {
        if (b == "pending") return -1;
        else // b !== ("pending" OR "latest"), thus a > b
        return 1;
    } else if (b === "latest") {
        if (a == "pending") return 1;
        else // b !== ("pending" OR "latest"), thus a > b
        return -1;
    } else if (a == "pending") // b (== OR <) "latest", thus a > b
    return 1;
    else if (b == "pending") return -1;
    else {
        let bnA = new $9WenL(a);
        let bnB = new $9WenL(b);
        if (bnA.lt(bnB)) return -1;
        else if (bnA.eq(bnB)) return 0;
        else return 1;
    }
};
module.exports = {
    _fireError: $6f388e73f687fdcf$var$_fireError,
    _jsonInterfaceMethodToString: $6f388e73f687fdcf$var$_jsonInterfaceMethodToString,
    _flattenTypes: $6f388e73f687fdcf$var$_flattenTypes,
    // extractDisplayName: extractDisplayName,
    // extractTypeName: extractTypeName,
    randomHex: $6f388e73f687fdcf$var$randomHex,
    BN: $eNPzt.BN,
    isBN: $eNPzt.isBN,
    isBigNumber: $eNPzt.isBigNumber,
    isHex: $eNPzt.isHex,
    isHexStrict: $eNPzt.isHexStrict,
    sha3: $eNPzt.sha3,
    sha3Raw: $eNPzt.sha3Raw,
    keccak256: $eNPzt.sha3,
    soliditySha3: $gQOic.soliditySha3,
    soliditySha3Raw: $gQOic.soliditySha3Raw,
    encodePacked: $gQOic.encodePacked,
    isAddress: $eNPzt.isAddress,
    checkAddressChecksum: $eNPzt.checkAddressChecksum,
    toChecksumAddress: $6f388e73f687fdcf$var$toChecksumAddress,
    toHex: $eNPzt.toHex,
    toBN: $eNPzt.toBN,
    bytesToHex: $eNPzt.bytesToHex,
    hexToBytes: $eNPzt.hexToBytes,
    hexToNumberString: $eNPzt.hexToNumberString,
    hexToNumber: $eNPzt.hexToNumber,
    toDecimal: $eNPzt.hexToNumber,
    numberToHex: $eNPzt.numberToHex,
    fromDecimal: $eNPzt.numberToHex,
    hexToUtf8: $eNPzt.hexToUtf8,
    hexToString: $eNPzt.hexToUtf8,
    toUtf8: $eNPzt.hexToUtf8,
    stripHexPrefix: $eNPzt.stripHexPrefix,
    utf8ToHex: $eNPzt.utf8ToHex,
    stringToHex: $eNPzt.utf8ToHex,
    fromUtf8: $eNPzt.utf8ToHex,
    hexToAscii: $6f388e73f687fdcf$var$hexToAscii,
    toAscii: $6f388e73f687fdcf$var$hexToAscii,
    asciiToHex: $6f388e73f687fdcf$var$asciiToHex,
    fromAscii: $6f388e73f687fdcf$var$asciiToHex,
    unitMap: $bijMU.unitMap,
    toWei: $6f388e73f687fdcf$var$toWei,
    fromWei: $6f388e73f687fdcf$var$fromWei,
    padLeft: $eNPzt.leftPad,
    leftPad: $eNPzt.leftPad,
    padRight: $eNPzt.rightPad,
    rightPad: $eNPzt.rightPad,
    toTwosComplement: $eNPzt.toTwosComplement,
    isBloom: $eNPzt.isBloom,
    isUserEthereumAddressInBloom: $eNPzt.isUserEthereumAddressInBloom,
    isContractAddressInBloom: $eNPzt.isContractAddressInBloom,
    isTopic: $eNPzt.isTopic,
    isTopicInBloom: $eNPzt.isTopicInBloom,
    isInBloom: $eNPzt.isInBloom,
    compareBlockNumbers: $6f388e73f687fdcf$var$compareBlockNumbers,
    toNumber: $eNPzt.toNumber
};

});
parcelRegister("bijMU", function(module, exports) {
'use strict';

var $37ApY = parcelRequire("37ApY");

var $lrNtv = parcelRequire("lrNtv");
var $8390b99fd7c7bef8$var$zero = new $37ApY(0);
var $8390b99fd7c7bef8$var$negative1 = new $37ApY(-1);
// complete ethereum unit map
var $8390b99fd7c7bef8$var$unitMap = {
    'noether': '0',
    'wei': '1',
    'kwei': '1000',
    'Kwei': '1000',
    'babbage': '1000',
    'femtoether': '1000',
    'mwei': '1000000',
    'Mwei': '1000000',
    'lovelace': '1000000',
    'picoether': '1000000',
    'gwei': '1000000000',
    'Gwei': '1000000000',
    'shannon': '1000000000',
    'nanoether': '1000000000',
    'nano': '1000000000',
    'szabo': '1000000000000',
    'microether': '1000000000000',
    'micro': '1000000000000',
    'finney': '1000000000000000',
    'milliether': '1000000000000000',
    'milli': '1000000000000000',
    'ether': '1000000000000000000',
    'kether': '1000000000000000000000',
    'grand': '1000000000000000000000',
    'mether': '1000000000000000000000000',
    'gether': '1000000000000000000000000000',
    'tether': '1000000000000000000000000000000'
};
/**
 * Returns value of unit in Wei
 *
 * @method getValueOfUnit
 * @param {String} unit the unit to convert to, default ether
 * @returns {BigNumber} value of the unit (in Wei)
 * @throws error if the unit is not correct:w
 */ function $8390b99fd7c7bef8$var$getValueOfUnit(unitInput) {
    var unit = unitInput ? unitInput.toLowerCase() : 'ether';
    var unitValue = $8390b99fd7c7bef8$var$unitMap[unit]; // eslint-disable-line
    if (typeof unitValue !== 'string') throw new Error('[ethjs-unit] the unit provided ' + unitInput + ' doesn\'t exists, please use the one of the following units ' + JSON.stringify($8390b99fd7c7bef8$var$unitMap, null, 2));
    return new $37ApY(unitValue, 10);
}
function $8390b99fd7c7bef8$var$numberToString(arg) {
    if (typeof arg === 'string') {
        if (!arg.match(/^-?[0-9.]+$/)) throw new Error('while converting number to string, invalid number value \'' + arg + '\', should be a number matching (^-?[0-9.]+).');
        return arg;
    } else if (typeof arg === 'number') return String(arg);
    else if (typeof arg === 'object' && arg.toString && (arg.toTwos || arg.dividedToIntegerBy)) {
        if (arg.toPrecision) return String(arg.toPrecision());
        else // eslint-disable-line
        return arg.toString(10);
    }
    throw new Error('while converting number to string, invalid number value \'' + arg + '\' type ' + typeof arg + '.');
}
function $8390b99fd7c7bef8$var$fromWei(weiInput, unit, optionsInput) {
    var wei = $lrNtv(weiInput); // eslint-disable-line
    var negative = wei.lt($8390b99fd7c7bef8$var$zero); // eslint-disable-line
    var base = $8390b99fd7c7bef8$var$getValueOfUnit(unit);
    var baseLength = $8390b99fd7c7bef8$var$unitMap[unit].length - 1 || 1;
    var options = optionsInput || {};
    if (negative) wei = wei.mul($8390b99fd7c7bef8$var$negative1);
    var fraction = wei.mod(base).toString(10); // eslint-disable-line
    while(fraction.length < baseLength)fraction = '0' + fraction;
    if (!options.pad) fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    var whole = wei.div(base).toString(10); // eslint-disable-line
    if (options.commify) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var value = '' + whole + (fraction == '0' ? '' : '.' + fraction); // eslint-disable-line
    if (negative) value = '-' + value;
    return value;
}
function $8390b99fd7c7bef8$var$toWei(etherInput, unit) {
    var ether = $8390b99fd7c7bef8$var$numberToString(etherInput); // eslint-disable-line
    var base = $8390b99fd7c7bef8$var$getValueOfUnit(unit);
    var baseLength = $8390b99fd7c7bef8$var$unitMap[unit].length - 1 || 1;
    // Is it negative?
    var negative = ether.substring(0, 1) === '-'; // eslint-disable-line
    if (negative) ether = ether.substring(1);
    if (ether === '.') throw new Error('[ethjs-unit] while converting number ' + etherInput + ' to wei, invalid value');
    // Split it into a whole and fractional part
    var comps = ether.split('.'); // eslint-disable-line
    if (comps.length > 2) throw new Error('[ethjs-unit] while converting number ' + etherInput + ' to wei,  too many decimal points');
    var whole = comps[0], fraction = comps[1]; // eslint-disable-line
    if (!whole) whole = '0';
    if (!fraction) fraction = '0';
    if (fraction.length > baseLength) throw new Error('[ethjs-unit] while converting number ' + etherInput + ' to wei, too many decimal places');
    while(fraction.length < baseLength)fraction += '0';
    whole = new $37ApY(whole);
    fraction = new $37ApY(fraction);
    var wei = whole.mul(base).add(fraction); // eslint-disable-line
    if (negative) wei = wei.mul($8390b99fd7c7bef8$var$negative1);
    return new $37ApY(wei.toString(10), 10);
}
module.exports = {
    unitMap: $8390b99fd7c7bef8$var$unitMap,
    numberToString: $8390b99fd7c7bef8$var$numberToString,
    getValueOfUnit: $8390b99fd7c7bef8$var$getValueOfUnit,
    fromWei: $8390b99fd7c7bef8$var$fromWei,
    toWei: $8390b99fd7c7bef8$var$toWei
};

});
parcelRegister("37ApY", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = (parcelRequire("6ZWSX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === '-') this.negative = 1;
        this.strip();
        if (endian !== 'le') return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("lrNtv", function(module, exports) {

var $aVYM4 = parcelRequire("aVYM4");

var $edrkG = parcelRequire("edrkG");
/**
 * Returns a BN object, converts a number value to a BN
 * @param {String|Number|Object} `arg` input a string number, hex string number, number, BigNumber or BN object
 * @return {Object} `output` BN object of the number
 * @throws if the argument is not an array, object that isn't a bignumber, not a string number or number
 */ module.exports = function numberToBN(arg) {
    if (typeof arg === 'string' || typeof arg === 'number') {
        var multiplier = new $aVYM4(1); // eslint-disable-line
        var formattedString = String(arg).toLowerCase().trim();
        var isHexPrefixed = formattedString.substr(0, 2) === '0x' || formattedString.substr(0, 3) === '-0x';
        var stringArg = $edrkG(formattedString); // eslint-disable-line
        if (stringArg.substr(0, 1) === '-') {
            stringArg = $edrkG(stringArg.slice(1));
            multiplier = new $aVYM4(-1, 10);
        }
        stringArg = stringArg === '' ? '0' : stringArg;
        if (!stringArg.match(/^-?[0-9]+$/) && stringArg.match(/^[0-9A-Fa-f]+$/) || stringArg.match(/^[a-fA-F]+$/) || isHexPrefixed === true && stringArg.match(/^[0-9A-Fa-f]+$/)) return new $aVYM4(stringArg, 16).mul(multiplier);
        if ((stringArg.match(/^-?[0-9]+$/) || stringArg === '') && isHexPrefixed === false) return new $aVYM4(stringArg, 10).mul(multiplier);
    } else if (typeof arg === 'object' && arg.toString && !arg.pop && !arg.push) {
        if (arg.toString(10).match(/^-?[0-9]+$/) && (arg.mul || arg.dividedToIntegerBy)) return new $aVYM4(arg.toString(10), 10);
    }
    throw new Error('[number-to-bn] while converting number ' + JSON.stringify(arg) + ' to BN.js instance, error: invalid number value. Value must be an integer, hex string, BN or BigNumber instance. Note, decimals are not supported.');
};

});
parcelRegister("aVYM4", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = (parcelRequire("6ZWSX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === '-') this.negative = 1;
        this.strip();
        if (endian !== 'le') return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("edrkG", function(module, exports) {

var $1Gpd4 = parcelRequire("1Gpd4");
/**
 * Removes '0x' from a given `String` is present
 * @param {String} str the string value
 * @return {String|Optional} a string by pass if necessary
 */ module.exports = function stripHexPrefix(str) {
    if (typeof str !== 'string') return str;
    return $1Gpd4(str) ? str.slice(2) : str;
};

});
parcelRegister("1Gpd4", function(module, exports) {
/**
 * Returns a `Boolean` on whether or not the a `String` starts with '0x'
 * @param {String} str the string input value
 * @return {Boolean} a boolean if it is or is not hex prefixed
 * @throws if the str input is not a string
 */ module.exports = function isHexPrefixed(str) {
    if (typeof str !== 'string') throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + typeof str + ", while checking isHexPrefixed.");
    return str.slice(0, 2) === '0x';
};

});




parcelRegister("eNPzt", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file utils.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $ac6da539943f3978$require$Buffer = $6ZWSX.Buffer;

var $9WenL = parcelRequire("9WenL");

var $lrNtv = parcelRequire("lrNtv");

var $7gSD0 = parcelRequire("7gSD0");

var $7Z98w = parcelRequire("7Z98w");

var $36d7k = parcelRequire("36d7k");
/**
 * Returns true if object is BN, otherwise false
 *
 * @method isBN
 * @param {Object} object
 * @return {Boolean}
 */ var $ac6da539943f3978$var$isBN = function(object) {
    return $9WenL.isBN(object);
};
/**
 * Returns true if object is BigNumber, otherwise false
 *
 * @method isBigNumber
 * @param {Object} object
 * @return {Boolean}
 */ var $ac6da539943f3978$var$isBigNumber = function(object) {
    return object && object.constructor && object.constructor.name === 'BigNumber';
};
/**
 * Takes an input and transforms it into an BN
 *
 * @method toBN
 * @param {Number|String|BN} number, string, HEX string or BN
 * @return {BN} BN
 */ var $ac6da539943f3978$var$toBN = function(number) {
    try {
        return $lrNtv.apply(null, arguments);
    } catch (e) {
        throw new Error(e + ' Given value: "' + number + '"');
    }
};
/**
 * Takes and input transforms it into BN and if it is negative value, into two's complement
 *
 * @method toTwosComplement
 * @param {Number|String|BN} number
 * @return {String}
 */ var $ac6da539943f3978$var$toTwosComplement = function(number) {
    return '0x' + $ac6da539943f3978$var$toBN(number).toTwos(256).toString(16, 64);
};
/**
 * Checks if the given string is an address
 *
 * @method isAddress
 * @param {String} address the given HEX address
 * @return {Boolean}
 */ var $ac6da539943f3978$var$isAddress = function(address) {
    // check if it has the basic requirements of an address
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) return false;
    else if (/^(0x|0X)?[0-9a-f]{40}$/.test(address) || /^(0x|0X)?[0-9A-F]{40}$/.test(address)) return true;
    else return $ac6da539943f3978$var$checkAddressChecksum(address);
};
/**
 * Checks if the given string is a checksummed address
 *
 * @method checkAddressChecksum
 * @param {String} address the given HEX address
 * @return {Boolean}
 */ var $ac6da539943f3978$var$checkAddressChecksum = function(address) {
    // Check each case
    address = address.replace(/^0x/i, '');
    var addressHash = $ac6da539943f3978$var$sha3(address.toLowerCase()).replace(/^0x/i, '');
    for(var i = 0; i < 40; i++){
        // the nth letter should be uppercase if the nth digit of casemap is 1
        if (parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i] || parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i]) return false;
    }
    return true;
};
/**
 * Should be called to pad string to expected length
 *
 * @method leftPad
 * @param {String} string to be padded
 * @param {Number} chars that result string should have
 * @param {String} sign, by default 0
 * @returns {String} right aligned string
 */ var $ac6da539943f3978$var$leftPad = function(string, chars, sign) {
    var hasPrefix = /^0x/i.test(string) || typeof string === 'number';
    string = string.toString(16).replace(/^0x/i, '');
    var padding = chars - string.length + 1 >= 0 ? chars - string.length + 1 : 0;
    return (hasPrefix ? '0x' : '') + new Array(padding).join(sign ? sign : "0") + string;
};
/**
 * Should be called to pad string to expected length
 *
 * @method rightPad
 * @param {String} string to be padded
 * @param {Number} chars that result string should have
 * @param {String} sign, by default 0
 * @returns {String} right aligned string
 */ var $ac6da539943f3978$var$rightPad = function(string, chars, sign) {
    var hasPrefix = /^0x/i.test(string) || typeof string === 'number';
    string = string.toString(16).replace(/^0x/i, '');
    var padding = chars - string.length + 1 >= 0 ? chars - string.length + 1 : 0;
    return (hasPrefix ? '0x' : '') + string + new Array(padding).join(sign ? sign : "0");
};
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string
 *
 * @method utf8ToHex
 * @param {String} str
 * @returns {String} hex representation of input string
 */ var $ac6da539943f3978$var$utf8ToHex = function(str) {
    str = $7gSD0.encode(str);
    var hex = "";
    // remove \u0000 padding from either side
    str = str.replace(/^(?:\u0000)*/, '');
    str = str.split("").reverse().join("");
    str = str.replace(/^(?:\u0000)*/, '');
    str = str.split("").reverse().join("");
    for(var i = 0; i < str.length; i++){
        var code = str.charCodeAt(i);
        // if (code !== 0) {
        var n = code.toString(16);
        hex += n.length < 2 ? '0' + n : n;
    // }
    }
    return "0x" + hex;
};
/**
 * Should be called to get utf8 from it's hex representation
 *
 * @method hexToUtf8
 * @param {String} hex
 * @returns {String} ascii string representation of hex value
 */ var $ac6da539943f3978$var$hexToUtf8 = function(hex) {
    if (!$ac6da539943f3978$var$isHexStrict(hex)) throw new Error('The parameter "' + hex + '" must be a valid HEX string.');
    var str = "";
    var code = 0;
    hex = hex.replace(/^0x/i, '');
    // remove 00 padding from either side
    hex = hex.replace(/^(?:00)*/, '');
    hex = hex.split("").reverse().join("");
    hex = hex.replace(/^(?:00)*/, '');
    hex = hex.split("").reverse().join("");
    var l = hex.length;
    for(var i = 0; i < l; i += 2){
        code = parseInt(hex.substr(i, 2), 16);
        // if (code !== 0) {
        str += String.fromCharCode(code);
    // }
    }
    return $7gSD0.decode(str);
};
/**
 * Converts value to it's number representation
 *
 * @method hexToNumber
 * @param {String|Number|BN} value
 * @return {String}
 */ var $ac6da539943f3978$var$hexToNumber = function(value) {
    if (!value) return value;
    if (typeof value === 'string' && !$ac6da539943f3978$var$isHexStrict(value)) throw new Error('Given value "' + value + '" is not a valid hex string.');
    return $ac6da539943f3978$var$toBN(value).toNumber();
};
/**
 * Converts value to it's decimal representation in string
 *
 * @method hexToNumberString
 * @param {String|Number|BN} value
 * @return {String}
 */ var $ac6da539943f3978$var$hexToNumberString = function(value) {
    if (!value) return value;
    if (typeof value === 'string' && !$ac6da539943f3978$var$isHexStrict(value)) throw new Error('Given value "' + value + '" is not a valid hex string.');
    return $ac6da539943f3978$var$toBN(value).toString(10);
};
/**
 * Converts value to it's hex representation
 *
 * @method numberToHex
 * @param {String|Number|BN} value
 * @return {String}
 */ var $ac6da539943f3978$var$numberToHex = function(value) {
    if (value === null || value === undefined) return value;
    if (!isFinite(value) && !$ac6da539943f3978$var$isHexStrict(value)) throw new Error('Given input "' + value + '" is not a number.');
    var number = $ac6da539943f3978$var$toBN(value);
    var result = number.toString(16);
    return number.lt(new $9WenL(0)) ? '-0x' + result.substr(1) : '0x' + result;
};
/**
 * Convert a byte array to a hex string
 *
 * Note: Implementation from crypto-js
 *
 * @method bytesToHex
 * @param {Array} bytes
 * @return {String} the hex string
 */ var $ac6da539943f3978$var$bytesToHex = function(bytes) {
    for(var hex = [], i = 0; i < bytes.length; i++){
        /* jshint ignore:start */ hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
    /* jshint ignore:end */ }
    return '0x' + hex.join("");
};
/**
 * Convert a hex string to a byte array
 *
 * Note: Implementation from crypto-js
 *
 * @method hexToBytes
 * @param {string} hex
 * @return {Array} the byte array
 */ var $ac6da539943f3978$var$hexToBytes = function(hex) {
    hex = hex.toString(16);
    if (!$ac6da539943f3978$var$isHexStrict(hex)) throw new Error('Given value "' + hex + '" is not a valid hex string.');
    hex = hex.replace(/^0x/i, '');
    for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes;
};
/**
 * Auto converts any given value into it's hex representation.
 *
 * And even stringifys objects before.
 *
 * @method toHex
 * @param {String|Number|BN|Object|Buffer} value
 * @param {Boolean} returnType
 * @return {String}
 */ var $ac6da539943f3978$var$toHex = function(value, returnType) {
    /*jshint maxcomplexity: false */ if ($ac6da539943f3978$var$isAddress(value)) return returnType ? 'address' : '0x' + value.toLowerCase().replace(/^0x/i, '');
    if (typeof value === 'boolean') return returnType ? 'bool' : value ? '0x01' : '0x00';
    if ($ac6da539943f3978$require$Buffer.isBuffer(value)) return '0x' + value.toString('hex');
    if (typeof value === 'object' && !!value && !$ac6da539943f3978$var$isBigNumber(value) && !$ac6da539943f3978$var$isBN(value)) return returnType ? 'string' : $ac6da539943f3978$var$utf8ToHex(JSON.stringify(value));
    // if its a negative number, pass it through numberToHex
    if (typeof value === 'string') {
        if (value.indexOf('-0x') === 0 || value.indexOf('-0X') === 0) return returnType ? 'int256' : $ac6da539943f3978$var$numberToHex(value);
        else if (value.indexOf('0x') === 0 || value.indexOf('0X') === 0) return returnType ? 'bytes' : value;
        else if (!isFinite(value)) return returnType ? 'string' : $ac6da539943f3978$var$utf8ToHex(value);
    }
    return returnType ? value < 0 ? 'int256' : 'uint256' : $ac6da539943f3978$var$numberToHex(value);
};
/**
 * Check if string is HEX, requires a 0x in front
 *
 * @method isHexStrict
 * @param {String} hex to be checked
 * @returns {Boolean}
 */ var $ac6da539943f3978$var$isHexStrict = function(hex) {
    return (typeof hex === 'string' || typeof hex === 'number') && /^(-)?0x[0-9a-f]*$/i.test(hex);
};
/**
 * Check if string is HEX
 *
 * @method isHex
 * @param {String} hex to be checked
 * @returns {Boolean}
 */ var $ac6da539943f3978$var$isHex = function(hex) {
    return (typeof hex === 'string' || typeof hex === 'number') && /^(-0x|0x)?[0-9a-f]*$/i.test(hex);
};
/**
 * Remove 0x prefix from string
 *
 * @method stripHexPrefix
 * @param {String} str to be checked
 * @returns {String}
 */ var $ac6da539943f3978$var$stripHexPrefix = function(str) {
    if (str !== 0 && $ac6da539943f3978$var$isHex(str)) return str.replace(/^(-)?0x/i, '$1');
    return str;
};
/**
 * Returns true if given string is a valid Ethereum block header bloom.
 *
 * @method isBloom
 * @param {String} bloom encoded bloom filter
 * @return {Boolean}
 */ var $ac6da539943f3978$var$isBloom = function(bloom) {
    return $36d7k.isBloom(bloom);
};
/**
 * Returns true if the ethereum users address is part of the given bloom
 * note: false positives are possible.
 *
 * @method isUserEthereumAddressInBloom
 * @param {String} ethereumAddress encoded bloom filter
 * @param {String} bloom ethereum addresss
 * @return {Boolean}
 */ var $ac6da539943f3978$var$isUserEthereumAddressInBloom = function(bloom, ethereumAddress) {
    return $36d7k.isUserEthereumAddressInBloom(bloom, ethereumAddress);
};
/**
 * Returns true if the contract address is part of the given bloom
 * note: false positives are possible.
 *
 * @method isUserEthereumAddressInBloom
 * @param {String} bloom encoded bloom filter
 * @param {String} contractAddress contract addresss
 * @return {Boolean}
 */ var $ac6da539943f3978$var$isContractAddressInBloom = function(bloom, contractAddress) {
    return $36d7k.isContractAddressInBloom(bloom, contractAddress);
};
/**
 * Returns true if given string is a valid log topic.
 *
 * @method isTopic
 * @param {String} topic encoded topic
 * @return {Boolean}
 */ var $ac6da539943f3978$var$isTopic = function(topic) {
    return $36d7k.isTopic(topic);
};
/**
 * Returns true if the topic is part of the given bloom
 * note: false positives are possible.
 *
 * @method isTopicInBloom
 * @param {String} bloom encoded bloom filter
 * @param {String} topic encoded topic
 * @return {Boolean}
 */ var $ac6da539943f3978$var$isTopicInBloom = function(bloom, topic) {
    return $36d7k.isTopicInBloom(bloom, topic);
};
/**
 * Returns true if the value is part of the given bloom
 * note: false positives are possible.
 *
 * @method isInBloom
 * @param {String} bloom encoded bloom filter
 * @param {String | Uint8Array} topic encoded value
 * @return {Boolean}
 */ var $ac6da539943f3978$var$isInBloom = function(bloom, topic) {
    return $36d7k.isInBloom(bloom, topic);
};
/**
 * Hashes values to a sha3 hash using keccak 256
 *
 * To hash a HEX string the hex must have 0x in front.
 *
 * @method sha3
 * @return {String} the sha3 string
 */ var $ac6da539943f3978$var$SHA3_NULL_S = '0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470';
var $ac6da539943f3978$var$sha3 = function(value) {
    if ($ac6da539943f3978$var$isBN(value)) value = value.toString();
    if ($ac6da539943f3978$var$isHexStrict(value) && /^0x/i.test(value.toString())) value = $7Z98w.toBuffer(value);
    else if (typeof value === 'string') // Assume value is an arbitrary string
    value = $ac6da539943f3978$require$Buffer.from(value, 'utf-8');
    var returnValue = $7Z98w.bufferToHex($7Z98w.keccak256(value));
    if (returnValue === $ac6da539943f3978$var$SHA3_NULL_S) return null;
    else return returnValue;
};
// expose the under the hood keccak256
$ac6da539943f3978$var$sha3._Hash = $7Z98w.keccak256;
/**
 * @method sha3Raw
 *
 * @param value
 *
 * @returns {string}
 */ var $ac6da539943f3978$var$sha3Raw = function(value) {
    value = $ac6da539943f3978$var$sha3(value);
    if (value === null) return $ac6da539943f3978$var$SHA3_NULL_S;
    return value;
};
/**
 * Auto converts any given value into it's hex representation,
 * then converts hex to number.
 *
 * @method toNumber
 * @param {String|Number|BN} value
 * @return {Number}
 */ var $ac6da539943f3978$var$toNumber = function(value) {
    return typeof value === 'number' ? value : $ac6da539943f3978$var$hexToNumber($ac6da539943f3978$var$toHex(value));
};
module.exports = {
    BN: $9WenL,
    isBN: $ac6da539943f3978$var$isBN,
    isBigNumber: $ac6da539943f3978$var$isBigNumber,
    toBN: $ac6da539943f3978$var$toBN,
    isAddress: $ac6da539943f3978$var$isAddress,
    isBloom: $ac6da539943f3978$var$isBloom,
    isUserEthereumAddressInBloom: $ac6da539943f3978$var$isUserEthereumAddressInBloom,
    isContractAddressInBloom: $ac6da539943f3978$var$isContractAddressInBloom,
    isTopic: $ac6da539943f3978$var$isTopic,
    isTopicInBloom: $ac6da539943f3978$var$isTopicInBloom,
    isInBloom: $ac6da539943f3978$var$isInBloom,
    checkAddressChecksum: $ac6da539943f3978$var$checkAddressChecksum,
    utf8ToHex: $ac6da539943f3978$var$utf8ToHex,
    hexToUtf8: $ac6da539943f3978$var$hexToUtf8,
    hexToNumber: $ac6da539943f3978$var$hexToNumber,
    hexToNumberString: $ac6da539943f3978$var$hexToNumberString,
    numberToHex: $ac6da539943f3978$var$numberToHex,
    toHex: $ac6da539943f3978$var$toHex,
    hexToBytes: $ac6da539943f3978$var$hexToBytes,
    bytesToHex: $ac6da539943f3978$var$bytesToHex,
    isHex: $ac6da539943f3978$var$isHex,
    isHexStrict: $ac6da539943f3978$var$isHexStrict,
    stripHexPrefix: $ac6da539943f3978$var$stripHexPrefix,
    leftPad: $ac6da539943f3978$var$leftPad,
    rightPad: $ac6da539943f3978$var$rightPad,
    toTwosComplement: $ac6da539943f3978$var$toTwosComplement,
    sha3: $ac6da539943f3978$var$sha3,
    sha3Raw: $ac6da539943f3978$var$sha3Raw,
    toNumber: $ac6da539943f3978$var$toNumber
};

});
parcelRegister("9WenL", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("7gSD0", function(module, exports) {
(function(root) {
    var stringFromCharCode = String.fromCharCode;
    // Taken from https://mths.be/punycode
    function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        var value;
        var extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    // Taken from https://mths.be/punycode
    function ucs2encode(array) {
        var length = array.length;
        var index = -1;
        var value;
        var output = '';
        while(++index < length){
            value = array[index];
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
        }
        return output;
    }
    function checkScalarValue(codePoint) {
        if (codePoint >= 0xD800 && codePoint <= 0xDFFF) throw Error('Lone surrogate U+' + codePoint.toString(16).toUpperCase() + ' is not a scalar value');
    }
    /*--------------------------------------------------------------------------*/ function createByte(codePoint, shift) {
        return stringFromCharCode(codePoint >> shift & 0x3F | 0x80);
    }
    function encodeCodePoint(codePoint) {
        if ((codePoint & 0xFFFFFF80) == 0) return stringFromCharCode(codePoint);
        var symbol = '';
        if ((codePoint & 0xFFFFF800) == 0) symbol = stringFromCharCode(codePoint >> 6 & 0x1F | 0xC0);
        else if ((codePoint & 0xFFFF0000) == 0) {
            checkScalarValue(codePoint);
            symbol = stringFromCharCode(codePoint >> 12 & 0x0F | 0xE0);
            symbol += createByte(codePoint, 6);
        } else if ((codePoint & 0xFFE00000) == 0) {
            symbol = stringFromCharCode(codePoint >> 18 & 0x07 | 0xF0);
            symbol += createByte(codePoint, 12);
            symbol += createByte(codePoint, 6);
        }
        symbol += stringFromCharCode(codePoint & 0x3F | 0x80);
        return symbol;
    }
    function utf8encode(string) {
        var codePoints = ucs2decode(string);
        var length = codePoints.length;
        var index = -1;
        var codePoint;
        var byteString = '';
        while(++index < length){
            codePoint = codePoints[index];
            byteString += encodeCodePoint(codePoint);
        }
        return byteString;
    }
    /*--------------------------------------------------------------------------*/ function readContinuationByte() {
        if (byteIndex >= byteCount) throw Error('Invalid byte index');
        var continuationByte = byteArray[byteIndex] & 0xFF;
        byteIndex++;
        if ((continuationByte & 0xC0) == 0x80) return continuationByte & 0x3F;
        // If we end up here, it’s not a continuation byte
        throw Error('Invalid continuation byte');
    }
    function decodeSymbol() {
        var byte1;
        var byte2;
        var byte3;
        var byte4;
        var codePoint;
        if (byteIndex > byteCount) throw Error('Invalid byte index');
        if (byteIndex == byteCount) return false;
        // Read first byte
        byte1 = byteArray[byteIndex] & 0xFF;
        byteIndex++;
        // 1-byte sequence (no continuation bytes)
        if ((byte1 & 0x80) == 0) return byte1;
        // 2-byte sequence
        if ((byte1 & 0xE0) == 0xC0) {
            byte2 = readContinuationByte();
            codePoint = (byte1 & 0x1F) << 6 | byte2;
            if (codePoint >= 0x80) return codePoint;
            else throw Error('Invalid continuation byte');
        }
        // 3-byte sequence (may include unpaired surrogates)
        if ((byte1 & 0xF0) == 0xE0) {
            byte2 = readContinuationByte();
            byte3 = readContinuationByte();
            codePoint = (byte1 & 0x0F) << 12 | byte2 << 6 | byte3;
            if (codePoint >= 0x0800) {
                checkScalarValue(codePoint);
                return codePoint;
            } else throw Error('Invalid continuation byte');
        }
        // 4-byte sequence
        if ((byte1 & 0xF8) == 0xF0) {
            byte2 = readContinuationByte();
            byte3 = readContinuationByte();
            byte4 = readContinuationByte();
            codePoint = (byte1 & 0x07) << 0x12 | byte2 << 0x0C | byte3 << 0x06 | byte4;
            if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) return codePoint;
        }
        throw Error('Invalid UTF-8 detected');
    }
    var byteArray;
    var byteCount;
    var byteIndex;
    function utf8decode(byteString) {
        byteArray = ucs2decode(byteString);
        byteCount = byteArray.length;
        byteIndex = 0;
        var codePoints = [];
        var tmp;
        while((tmp = decodeSymbol()) !== false)codePoints.push(tmp);
        return ucs2encode(codePoints);
    }
    /*--------------------------------------------------------------------------*/ root.version = '3.0.0';
    root.encode = utf8encode;
    root.decode = utf8decode;
})(module.exports);

});

parcelRegister("7Z98w", function(module, exports) {
"use strict";
var $5d0551371c89d07b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5d0551371c89d07b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5d0551371c89d07b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isHexString = module.exports.getKeys = module.exports.fromAscii = module.exports.fromUtf8 = module.exports.toAscii = module.exports.arrayContainsArray = module.exports.getBinarySize = module.exports.padToEven = module.exports.stripHexPrefix = module.exports.isHexPrefixed = void 0;

/**
 * Constants
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("5jI7y")), module.exports);

/**
 * Account class and helper functions
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("idiNS")), module.exports);

/**
 * Address type
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("aSXhg")), module.exports);

/**
 * Hash functions
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("gKSHR")), module.exports);

/**
 * ECDSA signature
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("67JT1")), module.exports);

/**
 * Utilities for manipulating Buffers, byte arrays, etc.
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("b61lJ")), module.exports);

/**
 * Function for definining properties on an object
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("cLPFP")), module.exports);

/**
 * External exports (BN, rlp, secp256k1)
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("4jhio")), module.exports);

/**
 * Helpful TypeScript types
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("eLj8Y")), module.exports);

var $aj8Qm = parcelRequire("aj8Qm");
Object.defineProperty(module.exports, "isHexPrefixed", {
    enumerable: true,
    get: function() {
        return $aj8Qm.isHexPrefixed;
    }
});
Object.defineProperty(module.exports, "stripHexPrefix", {
    enumerable: true,
    get: function() {
        return $aj8Qm.stripHexPrefix;
    }
});
Object.defineProperty(module.exports, "padToEven", {
    enumerable: true,
    get: function() {
        return $aj8Qm.padToEven;
    }
});
Object.defineProperty(module.exports, "getBinarySize", {
    enumerable: true,
    get: function() {
        return $aj8Qm.getBinarySize;
    }
});
Object.defineProperty(module.exports, "arrayContainsArray", {
    enumerable: true,
    get: function() {
        return $aj8Qm.arrayContainsArray;
    }
});
Object.defineProperty(module.exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $aj8Qm.toAscii;
    }
});
Object.defineProperty(module.exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $aj8Qm.fromUtf8;
    }
});
Object.defineProperty(module.exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $aj8Qm.fromAscii;
    }
});
Object.defineProperty(module.exports, "getKeys", {
    enumerable: true,
    get: function() {
        return $aj8Qm.getKeys;
    }
});
Object.defineProperty(module.exports, "isHexString", {
    enumerable: true,
    get: function() {
        return $aj8Qm.isHexString;
    }
});

});
parcelRegister("5jI7y", function(module, exports) {
"use strict";
var $3df0f396ca45489e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KECCAK256_RLP = module.exports.KECCAK256_RLP_S = module.exports.KECCAK256_RLP_ARRAY = module.exports.KECCAK256_RLP_ARRAY_S = module.exports.KECCAK256_NULL = module.exports.KECCAK256_NULL_S = module.exports.TWO_POW256 = module.exports.MAX_INTEGER = void 0;

var $6ZWSX = parcelRequire("6ZWSX");
var $3df0f396ca45489e$require$Buffer = $6ZWSX.Buffer;

var $3df0f396ca45489e$var$bn_js_1 = $3df0f396ca45489e$var$__importDefault((parcelRequire("dEXSZ")));
/**
 * The max integer that this VM can handle
 */ module.exports.MAX_INTEGER = new $3df0f396ca45489e$var$bn_js_1.default('ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff', 16);
/**
 * 2^256
 */ module.exports.TWO_POW256 = new $3df0f396ca45489e$var$bn_js_1.default('10000000000000000000000000000000000000000000000000000000000000000', 16);
/**
 * Keccak-256 hash of null
 */ module.exports.KECCAK256_NULL_S = 'c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470';
/**
 * Keccak-256 hash of null
 */ module.exports.KECCAK256_NULL = $3df0f396ca45489e$require$Buffer.from(module.exports.KECCAK256_NULL_S, 'hex');
/**
 * Keccak-256 of an RLP of an empty array
 */ module.exports.KECCAK256_RLP_ARRAY_S = '1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347';
/**
 * Keccak-256 of an RLP of an empty array
 */ module.exports.KECCAK256_RLP_ARRAY = $3df0f396ca45489e$require$Buffer.from(module.exports.KECCAK256_RLP_ARRAY_S, 'hex');
/**
 * Keccak-256 hash of the RLP of null
 */ module.exports.KECCAK256_RLP_S = '56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421';
/**
 * Keccak-256 hash of the RLP of null
 */ module.exports.KECCAK256_RLP = $3df0f396ca45489e$require$Buffer.from(module.exports.KECCAK256_RLP_S, 'hex');

});
parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("idiNS", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d42806dba2e311ba$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $d42806dba2e311ba$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d42806dba2e311ba$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d42806dba2e311ba$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d42806dba2e311ba$var$__createBinding(result, mod, k);
    }
    $d42806dba2e311ba$var$__setModuleDefault(result, mod);
    return result;
};
var $d42806dba2e311ba$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d42806dba2e311ba$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isZeroAddress = module.exports.zeroAddress = module.exports.importPublic = module.exports.privateToAddress = module.exports.privateToPublic = module.exports.publicToAddress = module.exports.pubToAddress = module.exports.isValidPublic = module.exports.isValidPrivate = module.exports.generateAddress2 = module.exports.generateAddress = module.exports.isValidChecksumAddress = module.exports.toChecksumAddress = module.exports.isValidAddress = module.exports.Account = void 0;

var $d42806dba2e311ba$var$assert_1 = $d42806dba2e311ba$var$__importDefault((parcelRequire("aLUwE")));

var $d42806dba2e311ba$var$bn_js_1 = $d42806dba2e311ba$var$__importDefault((parcelRequire("dEXSZ")));

var $d42806dba2e311ba$var$rlp = $d42806dba2e311ba$var$__importStar((parcelRequire("g16XK")));

var $iET4t = parcelRequire("iET4t");

var $aj8Qm = parcelRequire("aj8Qm");

var $5jI7y = parcelRequire("5jI7y");

var $b61lJ = parcelRequire("b61lJ");

var $gKSHR = parcelRequire("gKSHR");

var $7jIKp = parcelRequire("7jIKp");

var $eLj8Y = parcelRequire("eLj8Y");
var $d42806dba2e311ba$var$Account = /** @class */ function() {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating an Account from varying data types.
     */ function Account(nonce, balance, stateRoot, codeHash) {
        if (nonce === void 0) nonce = new $d42806dba2e311ba$var$bn_js_1.default(0);
        if (balance === void 0) balance = new $d42806dba2e311ba$var$bn_js_1.default(0);
        if (stateRoot === void 0) stateRoot = $5jI7y.KECCAK256_RLP;
        if (codeHash === void 0) codeHash = $5jI7y.KECCAK256_NULL;
        this.nonce = nonce;
        this.balance = balance;
        this.stateRoot = stateRoot;
        this.codeHash = codeHash;
        this._validate();
    }
    Account.fromAccountData = function(accountData) {
        var nonce = accountData.nonce, balance = accountData.balance, stateRoot = accountData.stateRoot, codeHash = accountData.codeHash;
        return new Account(nonce ? new $d42806dba2e311ba$var$bn_js_1.default((0, $b61lJ.toBuffer)(nonce)) : undefined, balance ? new $d42806dba2e311ba$var$bn_js_1.default((0, $b61lJ.toBuffer)(balance)) : undefined, stateRoot ? (0, $b61lJ.toBuffer)(stateRoot) : undefined, codeHash ? (0, $b61lJ.toBuffer)(codeHash) : undefined);
    };
    Account.fromRlpSerializedAccount = function(serialized) {
        var values = $d42806dba2e311ba$var$rlp.decode(serialized);
        if (!Array.isArray(values)) throw new Error('Invalid serialized account input. Must be array');
        return this.fromValuesArray(values);
    };
    Account.fromValuesArray = function(values) {
        var _a = $d42806dba2e311ba$var$__read(values, 4), nonce = _a[0], balance = _a[1], stateRoot = _a[2], codeHash = _a[3];
        return new Account(new $d42806dba2e311ba$var$bn_js_1.default(nonce), new $d42806dba2e311ba$var$bn_js_1.default(balance), stateRoot, codeHash);
    };
    Account.prototype._validate = function() {
        if (this.nonce.lt(new $d42806dba2e311ba$var$bn_js_1.default(0))) throw new Error('nonce must be greater than zero');
        if (this.balance.lt(new $d42806dba2e311ba$var$bn_js_1.default(0))) throw new Error('balance must be greater than zero');
        if (this.stateRoot.length !== 32) throw new Error('stateRoot must have a length of 32');
        if (this.codeHash.length !== 32) throw new Error('codeHash must have a length of 32');
    };
    /**
     * Returns a Buffer Array of the raw Buffers for the account, in order.
     */ Account.prototype.raw = function() {
        return [
            (0, $eLj8Y.bnToUnpaddedBuffer)(this.nonce),
            (0, $eLj8Y.bnToUnpaddedBuffer)(this.balance),
            this.stateRoot,
            this.codeHash
        ];
    };
    /**
     * Returns the RLP serialization of the account as a `Buffer`.
     */ Account.prototype.serialize = function() {
        return $d42806dba2e311ba$var$rlp.encode(this.raw());
    };
    /**
     * Returns a `Boolean` determining if the account is a contract.
     */ Account.prototype.isContract = function() {
        return !this.codeHash.equals($5jI7y.KECCAK256_NULL);
    };
    /**
     * Returns a `Boolean` determining if the account is empty complying to the definition of
     * account emptiness in [EIP-161](https://eips.ethereum.org/EIPS/eip-161):
     * "An account is considered empty when it has no code and zero nonce and zero balance."
     */ Account.prototype.isEmpty = function() {
        return this.balance.isZero() && this.nonce.isZero() && this.codeHash.equals($5jI7y.KECCAK256_NULL);
    };
    return Account;
}();
module.exports.Account = $d42806dba2e311ba$var$Account;
/**
 * Checks if the address is a valid. Accepts checksummed addresses too.
 */ var $d42806dba2e311ba$var$isValidAddress = function(hexAddress) {
    try {
        (0, $7jIKp.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    return /^0x[0-9a-fA-F]{40}$/.test(hexAddress);
};
module.exports.isValidAddress = $d42806dba2e311ba$var$isValidAddress;
/**
 * Returns a checksummed address.
 *
 * If an eip1191ChainId is provided, the chainId will be included in the checksum calculation. This
 * has the effect of checksummed addresses for one chain having invalid checksums for others.
 * For more details see [EIP-1191](https://eips.ethereum.org/EIPS/eip-1191).
 *
 * WARNING: Checksums with and without the chainId will differ and the EIP-1191 checksum is not
 * backwards compatible to the original widely adopted checksum format standard introduced in
 * [EIP-55](https://eips.ethereum.org/EIPS/eip-55), so this will break in existing applications.
 * Usage of this EIP is therefore discouraged unless you have a very targeted use case.
 */ var $d42806dba2e311ba$var$toChecksumAddress = function(hexAddress, eip1191ChainId) {
    (0, $7jIKp.assertIsHexString)(hexAddress);
    var address = (0, $aj8Qm.stripHexPrefix)(hexAddress).toLowerCase();
    var prefix = '';
    if (eip1191ChainId) {
        var chainId = (0, $eLj8Y.toType)(eip1191ChainId, $eLj8Y.TypeOutput.BN);
        prefix = chainId.toString() + '0x';
    }
    var hash = (0, $gKSHR.keccakFromString)(prefix + address).toString('hex');
    var ret = '0x';
    for(var i = 0; i < address.length; i++)if (parseInt(hash[i], 16) >= 8) ret += address[i].toUpperCase();
    else ret += address[i];
    return ret;
};
module.exports.toChecksumAddress = $d42806dba2e311ba$var$toChecksumAddress;
/**
 * Checks if the address is a valid checksummed address.
 *
 * See toChecksumAddress' documentation for details about the eip1191ChainId parameter.
 */ var $d42806dba2e311ba$var$isValidChecksumAddress = function(hexAddress, eip1191ChainId) {
    return (0, module.exports.isValidAddress)(hexAddress) && (0, module.exports.toChecksumAddress)(hexAddress, eip1191ChainId) === hexAddress;
};
module.exports.isValidChecksumAddress = $d42806dba2e311ba$var$isValidChecksumAddress;
/**
 * Generates an address of a newly created contract.
 * @param from The address which is creating this new address
 * @param nonce The nonce of the from account
 */ var $d42806dba2e311ba$var$generateAddress = function(from, nonce) {
    (0, $7jIKp.assertIsBuffer)(from);
    (0, $7jIKp.assertIsBuffer)(nonce);
    var nonceBN = new $d42806dba2e311ba$var$bn_js_1.default(nonce);
    if (nonceBN.isZero()) // in RLP we want to encode null in the case of zero nonce
    // read the RLP documentation for an answer if you dare
    return (0, $gKSHR.rlphash)([
        from,
        null
    ]).slice(-20);
    // Only take the lower 160bits of the hash
    return (0, $gKSHR.rlphash)([
        from,
        $d42806dba2e311ba$require$Buffer.from(nonceBN.toArray())
    ]).slice(-20);
};
module.exports.generateAddress = $d42806dba2e311ba$var$generateAddress;
/**
 * Generates an address for a contract created using CREATE2.
 * @param from The address which is creating this new address
 * @param salt A salt
 * @param initCode The init code of the contract being created
 */ var $d42806dba2e311ba$var$generateAddress2 = function(from, salt, initCode) {
    (0, $7jIKp.assertIsBuffer)(from);
    (0, $7jIKp.assertIsBuffer)(salt);
    (0, $7jIKp.assertIsBuffer)(initCode);
    (0, $d42806dba2e311ba$var$assert_1.default)(from.length === 20);
    (0, $d42806dba2e311ba$var$assert_1.default)(salt.length === 32);
    var address = (0, $gKSHR.keccak256)($d42806dba2e311ba$require$Buffer.concat([
        $d42806dba2e311ba$require$Buffer.from('ff', 'hex'),
        from,
        salt,
        (0, $gKSHR.keccak256)(initCode)
    ]));
    return address.slice(-20);
};
module.exports.generateAddress2 = $d42806dba2e311ba$var$generateAddress2;
/**
 * Checks if the private key satisfies the rules of the curve secp256k1.
 */ var $d42806dba2e311ba$var$isValidPrivate = function(privateKey) {
    return (0, $iET4t.privateKeyVerify)(privateKey);
};
module.exports.isValidPrivate = $d42806dba2e311ba$var$isValidPrivate;
/**
 * Checks if the public key satisfies the rules of the curve secp256k1
 * and the requirements of Ethereum.
 * @param publicKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ var $d42806dba2e311ba$var$isValidPublic = function(publicKey, sanitize) {
    if (sanitize === void 0) sanitize = false;
    (0, $7jIKp.assertIsBuffer)(publicKey);
    if (publicKey.length === 64) // Convert to SEC1 for secp256k1
    return (0, $iET4t.publicKeyVerify)($d42806dba2e311ba$require$Buffer.concat([
        $d42806dba2e311ba$require$Buffer.from([
            4
        ]),
        publicKey
    ]));
    if (!sanitize) return false;
    return (0, $iET4t.publicKeyVerify)(publicKey);
};
module.exports.isValidPublic = $d42806dba2e311ba$var$isValidPublic;
/**
 * Returns the ethereum address of a given public key.
 * Accepts "Ethereum public keys" and SEC1 encoded keys.
 * @param pubKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ var $d42806dba2e311ba$var$pubToAddress = function(pubKey, sanitize) {
    if (sanitize === void 0) sanitize = false;
    (0, $7jIKp.assertIsBuffer)(pubKey);
    if (sanitize && pubKey.length !== 64) pubKey = $d42806dba2e311ba$require$Buffer.from((0, $iET4t.publicKeyConvert)(pubKey, false).slice(1));
    (0, $d42806dba2e311ba$var$assert_1.default)(pubKey.length === 64);
    // Only take the lower 160bits of the hash
    return (0, $gKSHR.keccak)(pubKey).slice(-20);
};
module.exports.pubToAddress = $d42806dba2e311ba$var$pubToAddress;
module.exports.publicToAddress = module.exports.pubToAddress;
/**
 * Returns the ethereum public key of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ var $d42806dba2e311ba$var$privateToPublic = function(privateKey) {
    (0, $7jIKp.assertIsBuffer)(privateKey);
    // skip the type flag and use the X, Y points
    return $d42806dba2e311ba$require$Buffer.from((0, $iET4t.publicKeyCreate)(privateKey, false)).slice(1);
};
module.exports.privateToPublic = $d42806dba2e311ba$var$privateToPublic;
/**
 * Returns the ethereum address of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ var $d42806dba2e311ba$var$privateToAddress = function(privateKey) {
    return (0, module.exports.publicToAddress)((0, module.exports.privateToPublic)(privateKey));
};
module.exports.privateToAddress = $d42806dba2e311ba$var$privateToAddress;
/**
 * Converts a public key to the Ethereum format.
 */ var $d42806dba2e311ba$var$importPublic = function(publicKey) {
    (0, $7jIKp.assertIsBuffer)(publicKey);
    if (publicKey.length !== 64) publicKey = $d42806dba2e311ba$require$Buffer.from((0, $iET4t.publicKeyConvert)(publicKey, false).slice(1));
    return publicKey;
};
module.exports.importPublic = $d42806dba2e311ba$var$importPublic;
/**
 * Returns the zero address.
 */ var $d42806dba2e311ba$var$zeroAddress = function() {
    var addressLength = 20;
    var addr = (0, $b61lJ.zeros)(addressLength);
    return (0, $b61lJ.bufferToHex)(addr);
};
module.exports.zeroAddress = $d42806dba2e311ba$var$zeroAddress;
/**
 * Checks if a given address is the zero address.
 */ var $d42806dba2e311ba$var$isZeroAddress = function(hexAddress) {
    try {
        (0, $7jIKp.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    var zeroAddr = (0, module.exports.zeroAddress)();
    return zeroAddr === hexAddress;
};
module.exports.isZeroAddress = $d42806dba2e311ba$var$isZeroAddress;

});
parcelRegister("aLUwE", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $7d7a23f7babfddb7$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7d7a23f7babfddb7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7d7a23f7babfddb7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7d7a23f7babfddb7$var$_typeof(obj);
}
function $7d7a23f7babfddb7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $cCihK = parcelRequire("cCihK");
var $7d7a23f7babfddb7$var$_require$codes = $cCihK.codes, $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT = $7d7a23f7babfddb7$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_TYPE, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_VALUE, $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_RETURN_VALUE, $7d7a23f7babfddb7$var$ERR_MISSING_ARGS = $7d7a23f7babfddb7$var$_require$codes.ERR_MISSING_ARGS;

var $8pS6q = parcelRequire("8pS6q");

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$var$inspect = $N7Lcz.inspect;

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$require$_require$types = $N7Lcz.types;
var $7d7a23f7babfddb7$var$isPromise = $7d7a23f7babfddb7$require$_require$types.isPromise, $7d7a23f7babfddb7$var$isRegExp = $7d7a23f7babfddb7$require$_require$types.isRegExp;

var $7d7a23f7babfddb7$var$objectAssign = Object.assign ? Object.assign : (parcelRequire("dYBnA")).assign;

var $7d7a23f7babfddb7$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $7d7a23f7babfddb7$var$errorCache = new Map();
var $7d7a23f7babfddb7$var$isDeepEqual;
var $7d7a23f7babfddb7$var$isDeepStrictEqual;
var $7d7a23f7babfddb7$var$parseExpressionAt;
var $7d7a23f7babfddb7$var$findNodeAround;
var $7d7a23f7babfddb7$var$decoder;

function $7d7a23f7babfddb7$var$lazyLoadComparison() {
    var comparison = (parcelRequire("3LKhK"));
    $7d7a23f7babfddb7$var$isDeepEqual = comparison.isDeepEqual;
    $7d7a23f7babfddb7$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $7d7a23f7babfddb7$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $7d7a23f7babfddb7$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $7d7a23f7babfddb7$var$escapeFn = function escapeFn(str) {
    return $7d7a23f7babfddb7$var$meta[str.charCodeAt(0)];
};
var $7d7a23f7babfddb7$var$warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $7d7a23f7babfddb7$var$assert = module.exports = $7d7a23f7babfddb7$var$ok;
var $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $7d7a23f7babfddb7$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $8pS6q(obj);
}
function $7d7a23f7babfddb7$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($7d7a23f7babfddb7$var$warned === false) {
            $7d7a23f7babfddb7$var$warned = true;
            var warn = $hPtJY.emitWarning ? $hPtJY.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $7d7a23f7babfddb7$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $8pS6q(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$7d7a23f7babfddb7$var$assert.fail = $7d7a23f7babfddb7$var$fail; // The AssertionError is defined in internal/error.
$7d7a23f7babfddb7$var$assert.AssertionError = $8pS6q;
function $7d7a23f7babfddb7$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $8pS6q({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $7d7a23f7babfddb7$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$ok,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.ok = $7d7a23f7babfddb7$var$ok; // The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $7d7a23f7babfddb7$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
     // eslint-disable-next-line eqeqeq
    if (actual != expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.
$7d7a23f7babfddb7$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
     // eslint-disable-next-line eqeqeq
    if (actual == expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
}; // The equivalence assertion tests a deep equality relation.
$7d7a23f7babfddb7$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
}; // The non-equivalence assertion tests for any deep inequality.
$7d7a23f7babfddb7$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $7d7a23f7babfddb7$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notDeepStrictEqual = $7d7a23f7babfddb7$var$notDeepStrictEqual;
function $7d7a23f7babfddb7$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $7d7a23f7babfddb7$var$notDeepStrictEqual
    });
}
$7d7a23f7babfddb7$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $7d7a23f7babfddb7$var$Comparison = function Comparison(obj, keys, actual) {
    var _this = this;
    $7d7a23f7babfddb7$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $7d7a23f7babfddb7$var$isRegExp(obj[key]) && obj[key].test(actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
};
function $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$7d7a23f7babfddb7$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $7d7a23f7babfddb7$var$Comparison(actual, keys);
            var b = new $7d7a23f7babfddb7$var$Comparison(expected, keys, actual);
            var err = new $8pS6q({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $7d7a23f7babfddb7$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($7d7a23f7babfddb7$var$isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
         // Handle primitives properly.
        if ($7d7a23f7babfddb7$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $8pS6q({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $7d7a23f7babfddb7$var$isRegExp(expected[key]) && expected[key].test(actual[key])) return;
            $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    } // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $7d7a23f7babfddb7$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
}
function $7d7a23f7babfddb7$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $7d7a23f7babfddb7$var$isPromise(obj) || obj !== null && $7d7a23f7babfddb7$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $7d7a23f7babfddb7$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn(); // Fail in case no promise is returned.
            if (!$7d7a23f7babfddb7$var$checkIsPromise(resultPromise)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($7d7a23f7babfddb7$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $7d7a23f7babfddb7$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($7d7a23f7babfddb7$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $7d7a23f7babfddb7$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $7d7a23f7babfddb7$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$7d7a23f7babfddb7$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $7d7a23f7babfddb7$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $7d7a23f7babfddb7$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$7d7a23f7babfddb7$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
        throws,
        $7d7a23f7babfddb7$var$getActual(promiseFn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $7d7a23f7babfddb7$var$waitForActual(promiseFn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $7d7a23f7babfddb7$var$getActual(fn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $7d7a23f7babfddb7$var$waitForActual(fn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($7d7a23f7babfddb7$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $7d7a23f7babfddb7$var$inspect(err);
        var newErr = new $8pS6q({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        }); // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift(); // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
}; // Expose a strict only variant of assert
function $7d7a23f7babfddb7$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$strict,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.strict = $7d7a23f7babfddb7$var$objectAssign($7d7a23f7babfddb7$var$strict, $7d7a23f7babfddb7$var$assert, {
    equal: $7d7a23f7babfddb7$var$assert.strictEqual,
    deepEqual: $7d7a23f7babfddb7$var$assert.deepStrictEqual,
    notEqual: $7d7a23f7babfddb7$var$assert.notStrictEqual,
    notDeepEqual: $7d7a23f7babfddb7$var$assert.notDeepStrictEqual
});
$7d7a23f7babfddb7$var$assert.strict.strict = $7d7a23f7babfddb7$var$assert.strict;

});
parcelRegister("cCihK", function(module, exports) {

$parcel$export(module.exports, "codes", () => $92f737b1c63f6b54$export$e45cb6485273080e, (v) => $92f737b1c63f6b54$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $92f737b1c63f6b54$export$e45cb6485273080e;
'use strict'; // The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $92f737b1c63f6b54$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $92f737b1c63f6b54$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $92f737b1c63f6b54$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $92f737b1c63f6b54$var$_typeof(obj);
}
function $92f737b1c63f6b54$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $92f737b1c63f6b54$var$_possibleConstructorReturn(self, call) {
    if (call && ($92f737b1c63f6b54$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $92f737b1c63f6b54$var$_assertThisInitialized(self);
}
function $92f737b1c63f6b54$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $92f737b1c63f6b54$var$_getPrototypeOf(o) {
    $92f737b1c63f6b54$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $92f737b1c63f6b54$var$_getPrototypeOf(o);
}
function $92f737b1c63f6b54$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $92f737b1c63f6b54$var$_setPrototypeOf(subClass, superClass);
}
function $92f737b1c63f6b54$var$_setPrototypeOf(o, p) {
    $92f737b1c63f6b54$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $92f737b1c63f6b54$var$_setPrototypeOf(o, p);
}
var $92f737b1c63f6b54$var$codes = {}; // Lazy loaded
var $92f737b1c63f6b54$var$assert;
var $92f737b1c63f6b54$var$util;
function $92f737b1c63f6b54$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $92f737b1c63f6b54$var$_inherits(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $92f737b1c63f6b54$var$_classCallCheck(this, NodeError);
            _this = $92f737b1c63f6b54$var$_possibleConstructorReturn(this, $92f737b1c63f6b54$var$_getPrototypeOf(NodeError).call(this, getMessage(arg1, arg2, arg3)));
            _this.code = code;
            return _this;
        }
        return NodeError;
    }(Base);
    $92f737b1c63f6b54$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $92f737b1c63f6b54$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $92f737b1c63f6b54$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $92f737b1c63f6b54$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $92f737b1c63f6b54$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$92f737b1c63f6b54$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$92f737b1c63f6b54$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(typeof name === 'string', "'name' must be a string"); // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $92f737b1c63f6b54$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($92f737b1c63f6b54$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, 'type'));
    else {
        var type = $92f737b1c63f6b54$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, 'type'));
    } // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($92f737b1c63f6b54$var$_typeof(actual));
    return msg;
}, TypeError);

$92f737b1c63f6b54$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($92f737b1c63f6b54$var$util === undefined) $92f737b1c63f6b54$var$util = (parcelRequire("N7Lcz"));
    var inspected = $92f737b1c63f6b54$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$92f737b1c63f6b54$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($92f737b1c63f6b54$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$92f737b1c63f6b54$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$92f737b1c63f6b54$export$e45cb6485273080e = $92f737b1c63f6b54$var$codes;

});

parcelRegister("8pS6q", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $620aa032cca82da4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $620aa032cca82da4$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $620aa032cca82da4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $620aa032cca82da4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $620aa032cca82da4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $620aa032cca82da4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $620aa032cca82da4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $620aa032cca82da4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $620aa032cca82da4$var$_possibleConstructorReturn(self, call) {
    if (call && ($620aa032cca82da4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $620aa032cca82da4$var$_assertThisInitialized(self);
}
function $620aa032cca82da4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $620aa032cca82da4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $620aa032cca82da4$var$_setPrototypeOf(subClass, superClass);
}
function $620aa032cca82da4$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $620aa032cca82da4$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$620aa032cca82da4$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $620aa032cca82da4$var$_construct(Class, arguments, $620aa032cca82da4$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $620aa032cca82da4$var$_setPrototypeOf(Wrapper, Class);
    };
    return $620aa032cca82da4$var$_wrapNativeSuper(Class);
}
function $620aa032cca82da4$var$isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $620aa032cca82da4$var$_construct(Parent, args, Class) {
    if ($620aa032cca82da4$var$isNativeReflectConstruct()) $620aa032cca82da4$var$_construct = Reflect.construct;
    else $620aa032cca82da4$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $620aa032cca82da4$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $620aa032cca82da4$var$_construct.apply(null, arguments);
}
function $620aa032cca82da4$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $620aa032cca82da4$var$_setPrototypeOf(o, p) {
    $620aa032cca82da4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $620aa032cca82da4$var$_setPrototypeOf(o, p);
}
function $620aa032cca82da4$var$_getPrototypeOf(o) {
    $620aa032cca82da4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $620aa032cca82da4$var$_getPrototypeOf(o);
}
function $620aa032cca82da4$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $620aa032cca82da4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $620aa032cca82da4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $620aa032cca82da4$var$_typeof(obj);
}

var $N7Lcz = parcelRequire("N7Lcz");
var $620aa032cca82da4$var$inspect = $N7Lcz.inspect;

var $cCihK = parcelRequire("cCihK");
var $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE = $cCihK.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $620aa032cca82da4$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $620aa032cca82da4$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $620aa032cca82da4$var$blue = '';
var $620aa032cca82da4$var$green = '';
var $620aa032cca82da4$var$red = '';
var $620aa032cca82da4$var$white = '';
var $620aa032cca82da4$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
}; // Comparing short primitives should just show === / !== instead of using the
// diff.
var $620aa032cca82da4$var$kMaxShortLength = 10;
function $620aa032cca82da4$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $620aa032cca82da4$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $620aa032cca82da4$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $620aa032cca82da4$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $620aa032cca82da4$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $620aa032cca82da4$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = ''; // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $620aa032cca82da4$var$_typeof(actual) === 'object' && $620aa032cca82da4$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
     // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $620aa032cca82da4$var$kMaxShortLength) {
            if (($620aa032cca82da4$var$_typeof(actual) !== 'object' || actual === null) && ($620aa032cca82da4$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $hPtJY.stderr && $hPtJY.stderr.isTTY ? $hPtJY.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                 // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($620aa032cca82da4$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    } // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n'); // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($620aa032cca82da4$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $620aa032cca82da4$var$kReadableOperator[operator] + "\n".concat($620aa032cca82da4$var$green, "+ actual").concat($620aa032cca82da4$var$white, " ").concat($620aa032cca82da4$var$red, "- expected").concat($620aa032cca82da4$var$white);
    var skippedMsg = " ".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the expected line to the cache.
            other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLines[i]);
            printedLines++; // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the actual line to the result.
            res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLines[i]);
            printedLines++; // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$620aa032cca82da4$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $620aa032cca82da4$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                } // Mark the current line as the last diverging one.
                lastPos = i; // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLine);
                other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLine);
                printedLines += 2; // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = ''; // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        } // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(other, "\n") + "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $620aa032cca82da4$var$AssertionError = /*#__PURE__*/ function(_Error) {
    $620aa032cca82da4$var$_inherits(AssertionError, _Error);
    function AssertionError(options) {
        var _this;
        $620aa032cca82da4$var$_classCallCheck(this, AssertionError);
        if ($620aa032cca82da4$var$_typeof(options) !== 'object' || options === null) throw new $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, String(message)));
        else {
            if ($hPtJY.stderr && $hPtJY.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($hPtJY.stderr && $hPtJY.stderr.getColorDepth && $hPtJY.stderr.getColorDepth() !== 1) {
                    $620aa032cca82da4$var$blue = "\x1B[34m";
                    $620aa032cca82da4$var$green = "\x1B[32m";
                    $620aa032cca82da4$var$white = "\x1B[39m";
                    $620aa032cca82da4$var$red = "\x1B[31m";
                } else {
                    $620aa032cca82da4$var$blue = '';
                    $620aa032cca82da4$var$green = '';
                    $620aa032cca82da4$var$white = '';
                    $620aa032cca82da4$var$red = '';
                }
            } // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($620aa032cca82da4$var$_typeof(actual) === 'object' && actual !== null && $620aa032cca82da4$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $620aa032cca82da4$var$copyError(actual);
                expected = $620aa032cca82da4$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, $620aa032cca82da4$var$createErrDiff(actual, expected, operator)));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $620aa032cca82da4$var$kReadableOperator[operator];
                var res = $620aa032cca82da4$var$inspectValue(actual).split('\n'); // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $620aa032cca82da4$var$_typeof(actual) === 'object' && actual !== null) base = $620aa032cca82da4$var$kReadableOperator.notStrictEqualObject;
                 // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    while(res.length > 27)res.pop();
                } // Only print a single input.
                if (res.length === 1) _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, " ").concat(res[0])));
                else _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n")));
            } else {
                var _res = $620aa032cca82da4$var$inspectValue(actual);
                var other = '';
                var knownOperators = $620aa032cca82da4$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($620aa032cca82da4$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(_res).concat(other)));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($620aa032cca82da4$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($620aa032cca82da4$var$_assertThisInitialized(_this), stackStartFn);
         // Create error message including the error code in the name.
        _this.stack; // Reset the name.
        _this.name = 'AssertionError';
        return $620aa032cca82da4$var$_possibleConstructorReturn(_this);
    }
    $620aa032cca82da4$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: $620aa032cca82da4$var$inspect.custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $620aa032cca82da4$var$inspect(this, $620aa032cca82da4$var$_objectSpread({}, ctx, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}($620aa032cca82da4$var$_wrapNativeSuper(Error));
module.exports = $620aa032cca82da4$var$AssertionError;

});

parcelRegister("dYBnA", function(module, exports) {
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ 'use strict';
function $a2cddfb99e0a6135$var$assign(target, firstSource) {
    if (target === undefined || target === null) throw new TypeError('Cannot convert first argument to object');
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}
function $a2cddfb99e0a6135$var$polyfill() {
    if (!Object.assign) Object.defineProperty(Object, 'assign', {
        enumerable: false,
        configurable: true,
        writable: true,
        value: $a2cddfb99e0a6135$var$assign
    });
}
module.exports = {
    assign: $a2cddfb99e0a6135$var$assign,
    polyfill: $a2cddfb99e0a6135$var$polyfill
};

});

parcelRegister("eT9RM", function(module, exports) {
'use strict';

var $1UbTr = parcelRequire("1UbTr");

var $cOB0F = parcelRequire("cOB0F");

var $6wuPW = parcelRequire("6wuPW");

var $5SxoI = parcelRequire("5SxoI");

var $bNbuK = parcelRequire("bNbuK");
var $ad6ddb07ef0cb149$var$polyfill = $cOB0F($5SxoI(), Object);
$1UbTr($ad6ddb07ef0cb149$var$polyfill, {
    getPolyfill: $5SxoI,
    implementation: $6wuPW,
    shim: $bNbuK
});
module.exports = $ad6ddb07ef0cb149$var$polyfill;

});
parcelRegister("1UbTr", function(module, exports) {
'use strict';

var $81enX = parcelRequire("81enX");
var $16343f2546a69e4c$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $16343f2546a69e4c$var$toStr = Object.prototype.toString;
var $16343f2546a69e4c$var$concat = Array.prototype.concat;
var $16343f2546a69e4c$var$origDefineProperty = Object.defineProperty;
var $16343f2546a69e4c$var$isFunction = function(fn) {
    return typeof fn === 'function' && $16343f2546a69e4c$var$toStr.call(fn) === '[object Function]';
};
var $16343f2546a69e4c$var$arePropertyDescriptorsSupported = function() {
    var obj = {};
    try {
        $16343f2546a69e4c$var$origDefineProperty(obj, 'x', {
            enumerable: false,
            value: obj
        });
        // eslint-disable-next-line no-unused-vars, no-restricted-syntax
        for(var _ in obj)return false;
        return obj.x === obj;
    } catch (e) {
        return false;
    }
};
var $16343f2546a69e4c$var$supportsDescriptors = $16343f2546a69e4c$var$origDefineProperty && $16343f2546a69e4c$var$arePropertyDescriptorsSupported();
var $16343f2546a69e4c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object && (!$16343f2546a69e4c$var$isFunction(predicate) || !predicate())) return;
    if ($16343f2546a69e4c$var$supportsDescriptors) $16343f2546a69e4c$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value;
};
var $16343f2546a69e4c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $81enX(map);
    if ($16343f2546a69e4c$var$hasSymbols) props = $16343f2546a69e4c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$16343f2546a69e4c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$16343f2546a69e4c$var$defineProperties.supportsDescriptors = !!$16343f2546a69e4c$var$supportsDescriptors;
module.exports = $16343f2546a69e4c$var$defineProperties;

});
parcelRegister("81enX", function(module, exports) {
'use strict';
var $5d69935f2747da8d$var$slice = Array.prototype.slice;

var $z1gio = parcelRequire("z1gio");
var $5d69935f2747da8d$var$origKeys = Object.keys;

var $5d69935f2747da8d$var$keysShim = $5d69935f2747da8d$var$origKeys ? function keys(o) {
    return $5d69935f2747da8d$var$origKeys(o);
} : (parcelRequire("4nFCC"));
var $5d69935f2747da8d$var$originalKeys = Object.keys;
$5d69935f2747da8d$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($z1gio(object)) return $5d69935f2747da8d$var$originalKeys($5d69935f2747da8d$var$slice.call(object));
            return $5d69935f2747da8d$var$originalKeys(object);
        };
    } else Object.keys = $5d69935f2747da8d$var$keysShim;
    return Object.keys || $5d69935f2747da8d$var$keysShim;
};
module.exports = $5d69935f2747da8d$var$keysShim;

});
parcelRegister("z1gio", function(module, exports) {
'use strict';
var $06943f92b55ad7fa$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $06943f92b55ad7fa$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $06943f92b55ad7fa$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("4nFCC", function(module, exports) {
'use strict';
var $330998a67e44345d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $330998a67e44345d$var$has = Object.prototype.hasOwnProperty;
    var $330998a67e44345d$var$toStr = Object.prototype.toString;
    var $330998a67e44345d$var$isArgs = (parcelRequire("z1gio")); // eslint-disable-line global-require
    var $330998a67e44345d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $330998a67e44345d$var$hasDontEnumBug = !$330998a67e44345d$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $330998a67e44345d$var$hasProtoEnumBug = $330998a67e44345d$var$isEnumerable.call(function() {}, 'prototype');
    var $330998a67e44345d$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $330998a67e44345d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $330998a67e44345d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $330998a67e44345d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$330998a67e44345d$var$excludedKeys['$' + k] && $330998a67e44345d$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $330998a67e44345d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$330998a67e44345d$var$hasAutomationEqualityBug) return $330998a67e44345d$var$equalsConstructorPrototype(o);
        try {
            return $330998a67e44345d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $330998a67e44345d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $330998a67e44345d$var$toStr.call(object) === '[object Function]';
        var isArguments = $330998a67e44345d$var$isArgs(object);
        var isString = isObject && $330998a67e44345d$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $330998a67e44345d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$330998a67e44345d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $330998a67e44345d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($330998a67e44345d$var$hasDontEnumBug) {
            var skipConstructor = $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $330998a67e44345d$var$dontEnums.length; ++k)if (!(skipConstructor && $330998a67e44345d$var$dontEnums[k] === 'constructor') && $330998a67e44345d$var$has.call(object, $330998a67e44345d$var$dontEnums[k])) theKeys.push($330998a67e44345d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $330998a67e44345d$var$keysShim;

});



parcelRegister("6wuPW", function(module, exports) {
'use strict';
var $4bfda6cb765ad269$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4bfda6cb765ad269$var$numberIsNaN(a) && $4bfda6cb765ad269$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("5SxoI", function(module, exports) {
'use strict';

var $6wuPW = parcelRequire("6wuPW");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $6wuPW;
};

});

parcelRegister("bNbuK", function(module, exports) {
'use strict';

var $5SxoI = parcelRequire("5SxoI");

var $1UbTr = parcelRequire("1UbTr");
module.exports = function shimObjectIs() {
    var polyfill = $5SxoI();
    $1UbTr(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("3LKhK", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $2be9aa30bff457b9$var$_slicedToArray(arr, i) {
    return $2be9aa30bff457b9$var$_arrayWithHoles(arr) || $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) || $2be9aa30bff457b9$var$_nonIterableRest();
}
function $2be9aa30bff457b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2be9aa30bff457b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2be9aa30bff457b9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2be9aa30bff457b9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2be9aa30bff457b9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2be9aa30bff457b9$var$_typeof(obj);
}
var $2be9aa30bff457b9$var$regexFlagsSupported = /a/g.flags !== undefined;
var $2be9aa30bff457b9$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $2be9aa30bff457b9$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $2be9aa30bff457b9$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $2be9aa30bff457b9$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $2be9aa30bff457b9$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("c8Cyq"));
function $2be9aa30bff457b9$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $2be9aa30bff457b9$var$hasOwnProperty = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.hasOwnProperty);
var $2be9aa30bff457b9$var$propertyIsEnumerable = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $2be9aa30bff457b9$var$objectToString = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.toString);

var $N7Lcz = parcelRequire("N7Lcz");
var $2be9aa30bff457b9$require$_require$types = $N7Lcz.types;
var $2be9aa30bff457b9$var$isAnyArrayBuffer = $2be9aa30bff457b9$require$_require$types.isAnyArrayBuffer, $2be9aa30bff457b9$var$isArrayBufferView = $2be9aa30bff457b9$require$_require$types.isArrayBufferView, $2be9aa30bff457b9$var$isDate = $2be9aa30bff457b9$require$_require$types.isDate, $2be9aa30bff457b9$var$isMap = $2be9aa30bff457b9$require$_require$types.isMap, $2be9aa30bff457b9$var$isRegExp = $2be9aa30bff457b9$require$_require$types.isRegExp, $2be9aa30bff457b9$var$isSet = $2be9aa30bff457b9$require$_require$types.isSet, $2be9aa30bff457b9$var$isNativeError = $2be9aa30bff457b9$require$_require$types.isNativeError, $2be9aa30bff457b9$var$isBoxedPrimitive = $2be9aa30bff457b9$require$_require$types.isBoxedPrimitive, $2be9aa30bff457b9$var$isNumberObject = $2be9aa30bff457b9$require$_require$types.isNumberObject, $2be9aa30bff457b9$var$isStringObject = $2be9aa30bff457b9$require$_require$types.isStringObject, $2be9aa30bff457b9$var$isBooleanObject = $2be9aa30bff457b9$require$_require$types.isBooleanObject, $2be9aa30bff457b9$var$isBigIntObject = $2be9aa30bff457b9$require$_require$types.isBigIntObject, $2be9aa30bff457b9$var$isSymbolObject = $2be9aa30bff457b9$require$_require$types.isSymbolObject, $2be9aa30bff457b9$var$isFloat32Array = $2be9aa30bff457b9$require$_require$types.isFloat32Array, $2be9aa30bff457b9$var$isFloat64Array = $2be9aa30bff457b9$require$_require$types.isFloat64Array;
function $2be9aa30bff457b9$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    } // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $2be9aa30bff457b9$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($2be9aa30bff457b9$var$isNonIndex).concat($2be9aa30bff457b9$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
} // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $2be9aa30bff457b9$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $2be9aa30bff457b9$var$ONLY_ENUMERABLE = undefined;
var $2be9aa30bff457b9$var$kStrict = true;
var $2be9aa30bff457b9$var$kLoose = false;
var $2be9aa30bff457b9$var$kNoIterator = 0;
var $2be9aa30bff457b9$var$kIsArray = 1;
var $2be9aa30bff457b9$var$kIsSet = 2;
var $2be9aa30bff457b9$var$kIsMap = 3; // Check if they have the same source and flags
function $2be9aa30bff457b9$var$areSimilarRegExps(a, b) {
    return $2be9aa30bff457b9$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $2be9aa30bff457b9$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $2be9aa30bff457b9$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $2be9aa30bff457b9$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $2be9aa30bff457b9$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2) {
    if ($2be9aa30bff457b9$var$isNumberObject(val1)) return $2be9aa30bff457b9$var$isNumberObject(val2) && $2be9aa30bff457b9$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($2be9aa30bff457b9$var$isStringObject(val1)) return $2be9aa30bff457b9$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBooleanObject(val1)) return $2be9aa30bff457b9$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBigIntObject(val1)) return $2be9aa30bff457b9$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $2be9aa30bff457b9$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
} // Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $2be9aa30bff457b9$var$objectIs(val1, val2) : true;
    } // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($2be9aa30bff457b9$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $2be9aa30bff457b9$var$numberIsNaN(val1) && $2be9aa30bff457b9$var$numberIsNaN(val2);
        if ($2be9aa30bff457b9$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $2be9aa30bff457b9$var$_typeof(val1) !== 'object') {
            if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $2be9aa30bff457b9$var$objectToString(val1);
    var val2Tag = $2be9aa30bff457b9$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsArray, keys1);
    } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$2be9aa30bff457b9$var$isMap(val1) && $2be9aa30bff457b9$var$isMap(val2) || !$2be9aa30bff457b9$var$isSet(val1) && $2be9aa30bff457b9$var$isSet(val2)) return false;
    }
    if ($2be9aa30bff457b9$var$isDate(val1)) {
        if (!$2be9aa30bff457b9$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($2be9aa30bff457b9$var$isRegExp(val1)) {
        if (!$2be9aa30bff457b9$var$isRegExp(val2) || !$2be9aa30bff457b9$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($2be9aa30bff457b9$var$isArrayBufferView(val1)) {
        if (!strict && ($2be9aa30bff457b9$var$isFloat32Array(val1) || $2be9aa30bff457b9$var$isFloat64Array(val1))) {
            if (!$2be9aa30bff457b9$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$2be9aa30bff457b9$var$areSimilarTypedArrays(val1, val2)) return false;
         // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var _keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator, _keys);
    } else if ($2be9aa30bff457b9$var$isSet(val1)) {
        if (!$2be9aa30bff457b9$var$isSet(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsSet);
    } else if ($2be9aa30bff457b9$var$isMap(val1)) {
        if (!$2be9aa30bff457b9$var$isMap(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsMap);
    } else if ($2be9aa30bff457b9$var$isAnyArrayBuffer(val1)) {
        if (!$2be9aa30bff457b9$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isBoxedPrimitive(val1) && !$2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator);
}
function $2be9aa30bff457b9$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $2be9aa30bff457b9$var$propertyIsEnumerable(val, k);
    });
}
function $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    } // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$2be9aa30bff457b9$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($2be9aa30bff457b9$var$propertyIsEnumerable(val1, key)) {
                    if (!$2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $2be9aa30bff457b9$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $2be9aa30bff457b9$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $2be9aa30bff457b9$var$kNoIterator || iterationType === $2be9aa30bff457b9$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
     // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $2be9aa30bff457b9$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $2be9aa30bff457b9$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
} // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim) {
    switch($2be9aa30bff457b9$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($2be9aa30bff457b9$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo);
}
function $2be9aa30bff457b9$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $2be9aa30bff457b9$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($2be9aa30bff457b9$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
             // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.
            if (!$2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $2be9aa30bff457b9$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i]; // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($2be9aa30bff457b9$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(key1, key2, strict, memo) && $2be9aa30bff457b9$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $2be9aa30bff457b9$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $2be9aa30bff457b9$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $2be9aa30bff457b9$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($2be9aa30bff457b9$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $2be9aa30bff457b9$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $2be9aa30bff457b9$var$_slicedToArray(bEntries[_i2], 2), key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($2be9aa30bff457b9$var$_typeof(key) === 'object' && key !== null) {
                if (!$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(a.get(key), item, false, memo)) && !$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $2be9aa30bff457b9$var$kIsSet) {
        if (!$2be9aa30bff457b9$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsMap) {
        if (!$2be9aa30bff457b9$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsArray) for(; i < a.length; i++){
        if ($2be9aa30bff457b9$var$hasOwnProperty(a, i)) {
            if (!$2be9aa30bff457b9$var$hasOwnProperty(b, i) || !$2be9aa30bff457b9$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($2be9aa30bff457b9$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$2be9aa30bff457b9$var$hasOwnProperty(b, key) || !$2be9aa30bff457b9$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
     // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key = keys[i];
        if (!$2be9aa30bff457b9$var$innerDeepEqual(a[_key], b[_key], strict, memos)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$isDeepEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kLoose);
}
function $2be9aa30bff457b9$var$isDeepStrictEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kStrict);
}
module.exports = {
    isDeepEqual: $2be9aa30bff457b9$var$isDeepEqual,
    isDeepStrictEqual: $2be9aa30bff457b9$var$isDeepStrictEqual
};

});
parcelRegister("c8Cyq", function(module, exports) {
'use strict';

var $cOB0F = parcelRequire("cOB0F");

var $1UbTr = parcelRequire("1UbTr");

var $8sYH2 = parcelRequire("8sYH2");

var $91M8b = parcelRequire("91M8b");

var $hCf9I = parcelRequire("hCf9I");
var $8d642377f5822430$var$polyfill = $cOB0F($91M8b(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $1UbTr($8d642377f5822430$var$polyfill, {
    getPolyfill: $91M8b,
    implementation: $8sYH2,
    shim: $hCf9I
});
module.exports = $8d642377f5822430$var$polyfill;

});
parcelRegister("8sYH2", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("91M8b", function(module, exports) {
'use strict';

var $8sYH2 = parcelRequire("8sYH2");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $8sYH2;
};

});

parcelRegister("hCf9I", function(module, exports) {
'use strict';

var $1UbTr = parcelRequire("1UbTr");

var $91M8b = parcelRequire("91M8b");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $91M8b();
    $1UbTr(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("g16XK", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $ba9223f47ca24472$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLength = module.exports.decode = module.exports.encode = void 0;

var $3DJLR = parcelRequire("3DJLR");
/**
 * RLP Encoding based on: https://github.com/ethereum/wiki/wiki/%5BEnglish%5D-RLP
 * This function takes in a data, convert it to buffer if not, and a length for recursion
 * @param input - will be converted to buffer
 * @returns returns buffer of encoded data
 **/ function $ba9223f47ca24472$var$encode(input) {
    if (Array.isArray(input)) {
        var output = [];
        for(var i = 0; i < input.length; i++)output.push($ba9223f47ca24472$var$encode(input[i]));
        var buf = $ba9223f47ca24472$require$Buffer.concat(output);
        return $ba9223f47ca24472$require$Buffer.concat([
            $ba9223f47ca24472$var$encodeLength(buf.length, 192),
            buf
        ]);
    } else {
        var inputBuf = $ba9223f47ca24472$var$toBuffer(input);
        return inputBuf.length === 1 && inputBuf[0] < 128 ? inputBuf : $ba9223f47ca24472$require$Buffer.concat([
            $ba9223f47ca24472$var$encodeLength(inputBuf.length, 128),
            inputBuf
        ]);
    }
}
module.exports.encode = $ba9223f47ca24472$var$encode;
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 * @param base The base to parse the integer into
 */ function $ba9223f47ca24472$var$safeParseInt(v, base) {
    if (v.slice(0, 2) === '00') throw new Error('invalid RLP: extra zeros');
    return parseInt(v, base);
}
function $ba9223f47ca24472$var$encodeLength(len, offset) {
    if (len < 56) return $ba9223f47ca24472$require$Buffer.from([
        len + offset
    ]);
    else {
        var hexLength = $ba9223f47ca24472$var$intToHex(len);
        var lLength = hexLength.length / 2;
        var firstByte = $ba9223f47ca24472$var$intToHex(offset + 55 + lLength);
        return $ba9223f47ca24472$require$Buffer.from(firstByte + hexLength, 'hex');
    }
}
function $ba9223f47ca24472$var$decode(input, stream) {
    if (stream === void 0) stream = false;
    if (!input || input.length === 0) return $ba9223f47ca24472$require$Buffer.from([]);
    var inputBuffer = $ba9223f47ca24472$var$toBuffer(input);
    var decoded = $ba9223f47ca24472$var$_decode(inputBuffer);
    if (stream) return decoded;
    if (decoded.remainder.length !== 0) throw new Error('invalid remainder');
    return decoded.data;
}
module.exports.decode = $ba9223f47ca24472$var$decode;
/**
 * Get the length of the RLP input
 * @param input
 * @returns The length of the input or an empty Buffer if no input
 */ function $ba9223f47ca24472$var$getLength(input) {
    if (!input || input.length === 0) return $ba9223f47ca24472$require$Buffer.from([]);
    var inputBuffer = $ba9223f47ca24472$var$toBuffer(input);
    var firstByte = inputBuffer[0];
    if (firstByte <= 0x7f) return inputBuffer.length;
    else if (firstByte <= 0xb7) return firstByte - 0x7f;
    else if (firstByte <= 0xbf) return firstByte - 0xb6;
    else if (firstByte <= 0xf7) // a list between  0-55 bytes long
    return firstByte - 0xbf;
    else {
        // a list  over 55 bytes long
        var llength = firstByte - 0xf6;
        var length = $ba9223f47ca24472$var$safeParseInt(inputBuffer.slice(1, llength).toString('hex'), 16);
        return llength + length;
    }
}
module.exports.getLength = $ba9223f47ca24472$var$getLength;
/** Decode an input with RLP */ function $ba9223f47ca24472$var$_decode(input) {
    var length, llength, data, innerRemainder, d;
    var decoded = [];
    var firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.slice(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = $ba9223f47ca24472$require$Buffer.from([]);
        else data = input.slice(1, length);
        if (length === 2 && data[0] < 0x80) throw new Error('invalid rlp encoding: byte must be less 0x80');
        return {
            data: data,
            remainder: input.slice(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error('invalid RLP: not enough bytes for string length');
        length = $ba9223f47ca24472$var$safeParseInt(input.slice(1, llength).toString('hex'), 16);
        if (length <= 55) throw new Error('invalid RLP: expected string length to be greater than 55');
        data = input.slice(llength, length + llength);
        if (data.length < length) throw new Error('invalid RLP: not enough bytes for string');
        return {
            data: data,
            remainder: input.slice(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between  0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = input.slice(1, length);
        while(innerRemainder.length){
            d = $ba9223f47ca24472$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(length)
        };
    } else {
        // a list  over 55 bytes long
        llength = firstByte - 0xf6;
        length = $ba9223f47ca24472$var$safeParseInt(input.slice(1, llength).toString('hex'), 16);
        var totalLength = llength + length;
        if (totalLength > input.length) throw new Error('invalid rlp: total length is larger than the data');
        innerRemainder = input.slice(llength, totalLength);
        if (innerRemainder.length === 0) throw new Error('invalid rlp, List has a invalid length');
        while(innerRemainder.length){
            d = $ba9223f47ca24472$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(totalLength)
        };
    }
}
/** Check if a string is prefixed by 0x */ function $ba9223f47ca24472$var$isHexPrefixed(str) {
    return str.slice(0, 2) === '0x';
}
/** Removes 0x from a given String */ function $ba9223f47ca24472$var$stripHexPrefix(str) {
    if (typeof str !== 'string') return str;
    return $ba9223f47ca24472$var$isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform an integer into its hexadecimal value */ function $ba9223f47ca24472$var$intToHex(integer) {
    if (integer < 0) throw new Error('Invalid integer as argument, must be unsigned!');
    var hex = integer.toString(16);
    return hex.length % 2 ? "0" + hex : hex;
}
/** Pad a string to be even */ function $ba9223f47ca24472$var$padToEven(a) {
    return a.length % 2 ? "0" + a : a;
}
/** Transform an integer into a Buffer */ function $ba9223f47ca24472$var$intToBuffer(integer) {
    var hex = $ba9223f47ca24472$var$intToHex(integer);
    return $ba9223f47ca24472$require$Buffer.from(hex, 'hex');
}
/** Transform anything into a Buffer */ function $ba9223f47ca24472$var$toBuffer(v) {
    if (!$ba9223f47ca24472$require$Buffer.isBuffer(v)) {
        if (typeof v === 'string') {
            if ($ba9223f47ca24472$var$isHexPrefixed(v)) return $ba9223f47ca24472$require$Buffer.from($ba9223f47ca24472$var$padToEven($ba9223f47ca24472$var$stripHexPrefix(v)), 'hex');
            else return $ba9223f47ca24472$require$Buffer.from(v);
        } else if (typeof v === 'number' || typeof v === 'bigint') {
            if (!v) return $ba9223f47ca24472$require$Buffer.from([]);
            else return $ba9223f47ca24472$var$intToBuffer(v);
        } else if (v === null || v === undefined) return $ba9223f47ca24472$require$Buffer.from([]);
        else if (v instanceof Uint8Array) return $ba9223f47ca24472$require$Buffer.from(v);
        else if ($3DJLR.isBN(v)) // converts a BN to a Buffer
        return $ba9223f47ca24472$require$Buffer.from(v.toArray());
        else throw new Error('invalid type');
    }
    return v;
}

});
parcelRegister("3DJLR", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("iET4t", function(module, exports) {
"use strict";
var $d956ae6943bb41ce$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d956ae6943bb41ce$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $d956ae6943bb41ce$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});


var $1dT7K = parcelRequire("1dT7K");
var $d956ae6943bb41ce$var$SECP256K1_PRIVATE_KEY_SIZE = 32;
function $d956ae6943bb41ce$var$createPrivateKey() {
    return $d956ae6943bb41ce$var$__awaiter(this, void 0, void 0, function() {
        var pk;
        return $d956ae6943bb41ce$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $1dT7K.getRandomBytes($d956ae6943bb41ce$var$SECP256K1_PRIVATE_KEY_SIZE)
                    ];
                case 1:
                    pk = _a.sent();
                    if ((parcelRequire("gcxLH")).privateKeyVerify(pk)) return [
                        2 /*return*/ ,
                        pk
                    ];
                    return [
                        3 /*break*/ ,
                        0
                    ];
                case 2:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.createPrivateKey = $d956ae6943bb41ce$var$createPrivateKey;
function $d956ae6943bb41ce$var$createPrivateKeySync() {
    while(true){
        var pk = $1dT7K.getRandomBytesSync($d956ae6943bb41ce$var$SECP256K1_PRIVATE_KEY_SIZE);
        if ((parcelRequire("gcxLH")).privateKeyVerify(pk)) return pk;
    }
}
module.exports.createPrivateKeySync = $d956ae6943bb41ce$var$createPrivateKeySync;

$d956ae6943bb41ce$var$__export((parcelRequire("gcxLH")));

});
parcelRegister("gcxLH", function(module, exports) {


module.exports = (parcelRequire("fmYyt"))((parcelRequire("c3Vlo")));

});
parcelRegister("fmYyt", function(module, exports) {
const $b307e20ca716a34b$var$errors = {
    IMPOSSIBLE_CASE: 'Impossible case. Please create issue.',
    TWEAK_ADD: 'The tweak was out of range or the resulted private key is invalid',
    TWEAK_MUL: 'The tweak was out of range or equal to zero',
    CONTEXT_RANDOMIZE_UNKNOW: 'Unknow error on context randomization',
    SECKEY_INVALID: 'Private Key is invalid',
    PUBKEY_PARSE: 'Public Key could not be parsed',
    PUBKEY_SERIALIZE: 'Public Key serialization error',
    PUBKEY_COMBINE: 'The sum of the public keys is not valid',
    SIG_PARSE: 'Signature could not be parsed',
    SIGN: 'The nonce generation function failed, or the private key was invalid',
    RECOVER: 'Public key could not be recover',
    ECDH: 'Scalar was invalid (zero or overflow)'
};
function $b307e20ca716a34b$var$assert(cond, msg) {
    if (!cond) throw new Error(msg);
}
function $b307e20ca716a34b$var$isUint8Array(name, value, length) {
    $b307e20ca716a34b$var$assert(value instanceof Uint8Array, `Expected ${name} to be an Uint8Array`);
    if (length !== undefined) {
        if (Array.isArray(length)) {
            const numbers = length.join(', ');
            const msg = `Expected ${name} to be an Uint8Array with length [${numbers}]`;
            $b307e20ca716a34b$var$assert(length.includes(value.length), msg);
        } else {
            const msg = `Expected ${name} to be an Uint8Array with length ${length}`;
            $b307e20ca716a34b$var$assert(value.length === length, msg);
        }
    }
}
function $b307e20ca716a34b$var$isCompressed(value) {
    $b307e20ca716a34b$var$assert($b307e20ca716a34b$var$toTypeString(value) === 'Boolean', 'Expected compressed to be a Boolean');
}
function $b307e20ca716a34b$var$getAssertedOutput(output = (len)=>new Uint8Array(len), length) {
    if (typeof output === 'function') output = output(length);
    $b307e20ca716a34b$var$isUint8Array('output', output, length);
    return output;
}
function $b307e20ca716a34b$var$toTypeString(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
module.exports = (secp256k1)=>{
    return {
        contextRandomize (seed) {
            $b307e20ca716a34b$var$assert(seed === null || seed instanceof Uint8Array, 'Expected seed to be an Uint8Array or null');
            if (seed !== null) $b307e20ca716a34b$var$isUint8Array('seed', seed, 32);
            switch(secp256k1.contextRandomize(seed)){
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.CONTEXT_RANDOMIZE_UNKNOW);
            }
        },
        privateKeyVerify (seckey) {
            $b307e20ca716a34b$var$isUint8Array('private key', seckey, 32);
            return secp256k1.privateKeyVerify(seckey) === 0;
        },
        privateKeyNegate (seckey) {
            $b307e20ca716a34b$var$isUint8Array('private key', seckey, 32);
            switch(secp256k1.privateKeyNegate(seckey)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        privateKeyTweakAdd (seckey, tweak) {
            $b307e20ca716a34b$var$isUint8Array('private key', seckey, 32);
            $b307e20ca716a34b$var$isUint8Array('tweak', tweak, 32);
            switch(secp256k1.privateKeyTweakAdd(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.TWEAK_ADD);
            }
        },
        privateKeyTweakMul (seckey, tweak) {
            $b307e20ca716a34b$var$isUint8Array('private key', seckey, 32);
            $b307e20ca716a34b$var$isUint8Array('tweak', tweak, 32);
            switch(secp256k1.privateKeyTweakMul(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.TWEAK_MUL);
            }
        },
        publicKeyVerify (pubkey) {
            $b307e20ca716a34b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            return secp256k1.publicKeyVerify(pubkey) === 0;
        },
        publicKeyCreate (seckey, compressed = true, output) {
            $b307e20ca716a34b$var$isUint8Array('private key', seckey, 32);
            $b307e20ca716a34b$var$isCompressed(compressed);
            output = $b307e20ca716a34b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCreate(output, seckey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.SECKEY_INVALID);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyConvert (pubkey, compressed = true, output) {
            $b307e20ca716a34b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b307e20ca716a34b$var$isCompressed(compressed);
            output = $b307e20ca716a34b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyConvert(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyNegate (pubkey, compressed = true, output) {
            $b307e20ca716a34b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b307e20ca716a34b$var$isCompressed(compressed);
            output = $b307e20ca716a34b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyNegate(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.IMPOSSIBLE_CASE);
                case 3:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyCombine (pubkeys, compressed = true, output) {
            $b307e20ca716a34b$var$assert(Array.isArray(pubkeys), 'Expected public keys to be an Array');
            $b307e20ca716a34b$var$assert(pubkeys.length > 0, 'Expected public keys array will have more than zero items');
            for (const pubkey of pubkeys)$b307e20ca716a34b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b307e20ca716a34b$var$isCompressed(compressed);
            output = $b307e20ca716a34b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCombine(output, pubkeys)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_COMBINE);
                case 3:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyTweakAdd (pubkey, tweak, compressed = true, output) {
            $b307e20ca716a34b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b307e20ca716a34b$var$isUint8Array('tweak', tweak, 32);
            $b307e20ca716a34b$var$isCompressed(compressed);
            output = $b307e20ca716a34b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakAdd(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.TWEAK_ADD);
            }
        },
        publicKeyTweakMul (pubkey, tweak, compressed = true, output) {
            $b307e20ca716a34b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b307e20ca716a34b$var$isUint8Array('tweak', tweak, 32);
            $b307e20ca716a34b$var$isCompressed(compressed);
            output = $b307e20ca716a34b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakMul(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.TWEAK_MUL);
            }
        },
        signatureNormalize (sig) {
            $b307e20ca716a34b$var$isUint8Array('signature', sig, 64);
            switch(secp256k1.signatureNormalize(sig)){
                case 0:
                    return sig;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.SIG_PARSE);
            }
        },
        signatureExport (sig, output) {
            $b307e20ca716a34b$var$isUint8Array('signature', sig, 64);
            output = $b307e20ca716a34b$var$getAssertedOutput(output, 72);
            const obj = {
                output: output,
                outputlen: 72
            };
            switch(secp256k1.signatureExport(obj, sig)){
                case 0:
                    return output.slice(0, obj.outputlen);
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        signatureImport (sig, output) {
            $b307e20ca716a34b$var$isUint8Array('signature', sig);
            output = $b307e20ca716a34b$var$getAssertedOutput(output, 64);
            switch(secp256k1.signatureImport(output, sig)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaSign (msg32, seckey, options = {}, output) {
            $b307e20ca716a34b$var$isUint8Array('message', msg32, 32);
            $b307e20ca716a34b$var$isUint8Array('private key', seckey, 32);
            $b307e20ca716a34b$var$assert($b307e20ca716a34b$var$toTypeString(options) === 'Object', 'Expected options to be an Object');
            if (options.data !== undefined) $b307e20ca716a34b$var$isUint8Array('options.data', options.data);
            if (options.noncefn !== undefined) $b307e20ca716a34b$var$assert($b307e20ca716a34b$var$toTypeString(options.noncefn) === 'Function', 'Expected options.noncefn to be a Function');
            output = $b307e20ca716a34b$var$getAssertedOutput(output, 64);
            const obj = {
                signature: output,
                recid: null
            };
            switch(secp256k1.ecdsaSign(obj, msg32, seckey, options.data, options.noncefn)){
                case 0:
                    return obj;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.SIGN);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaVerify (sig, msg32, pubkey) {
            $b307e20ca716a34b$var$isUint8Array('signature', sig, 64);
            $b307e20ca716a34b$var$isUint8Array('message', msg32, 32);
            $b307e20ca716a34b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            switch(secp256k1.ecdsaVerify(sig, msg32, pubkey)){
                case 0:
                    return true;
                case 3:
                    return false;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_PARSE);
            }
        },
        ecdsaRecover (sig, recid, msg32, compressed = true, output) {
            $b307e20ca716a34b$var$isUint8Array('signature', sig, 64);
            $b307e20ca716a34b$var$assert($b307e20ca716a34b$var$toTypeString(recid) === 'Number' && recid >= 0 && recid <= 3, 'Expected recovery id to be a Number within interval [0, 3]');
            $b307e20ca716a34b$var$isUint8Array('message', msg32, 32);
            $b307e20ca716a34b$var$isCompressed(compressed);
            output = $b307e20ca716a34b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.ecdsaRecover(output, sig, recid, msg32)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.RECOVER);
                case 3:
                    throw new Error($b307e20ca716a34b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdh (pubkey, seckey, options = {}, output) {
            $b307e20ca716a34b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b307e20ca716a34b$var$isUint8Array('private key', seckey, 32);
            $b307e20ca716a34b$var$assert($b307e20ca716a34b$var$toTypeString(options) === 'Object', 'Expected options to be an Object');
            if (options.data !== undefined) $b307e20ca716a34b$var$isUint8Array('options.data', options.data);
            if (options.hashfn !== undefined) {
                $b307e20ca716a34b$var$assert($b307e20ca716a34b$var$toTypeString(options.hashfn) === 'Function', 'Expected options.hashfn to be a Function');
                if (options.xbuf !== undefined) $b307e20ca716a34b$var$isUint8Array('options.xbuf', options.xbuf, 32);
                if (options.ybuf !== undefined) $b307e20ca716a34b$var$isUint8Array('options.ybuf', options.ybuf, 32);
                $b307e20ca716a34b$var$isUint8Array('output', output);
            } else output = $b307e20ca716a34b$var$getAssertedOutput(output, 32);
            switch(secp256k1.ecdh(output, pubkey, seckey, options.data, options.hashfn, options.xbuf, options.ybuf)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b307e20ca716a34b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b307e20ca716a34b$var$errors.ECDH);
            }
        }
    };
};

});

parcelRegister("c3Vlo", function(module, exports) {

var $1zUcV = parcelRequire("1zUcV");
var $02442a4f43342bcd$require$EC = $1zUcV.ec;
const $02442a4f43342bcd$var$ec = new $02442a4f43342bcd$require$EC('secp256k1');
const $02442a4f43342bcd$var$ecparams = $02442a4f43342bcd$var$ec.curve;
// Hack, we can not use bn.js@5, while elliptic uses bn.js@4
// See https://github.com/indutny/elliptic/issues/191#issuecomment-569888758
const $02442a4f43342bcd$var$BN = $02442a4f43342bcd$var$ecparams.n.constructor;
function $02442a4f43342bcd$var$loadCompressedPublicKey(first, xbuf) {
    let x = new $02442a4f43342bcd$var$BN(xbuf);
    // overflow
    if (x.cmp($02442a4f43342bcd$var$ecparams.p) >= 0) return null;
    x = x.toRed($02442a4f43342bcd$var$ecparams.red);
    // compute corresponding Y
    let y = x.redSqr().redIMul(x).redIAdd($02442a4f43342bcd$var$ecparams.b).redSqrt();
    if (first === 0x03 !== y.isOdd()) y = y.redNeg();
    return $02442a4f43342bcd$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $02442a4f43342bcd$var$loadUncompressedPublicKey(first, xbuf, ybuf) {
    let x = new $02442a4f43342bcd$var$BN(xbuf);
    let y = new $02442a4f43342bcd$var$BN(ybuf);
    // overflow
    if (x.cmp($02442a4f43342bcd$var$ecparams.p) >= 0 || y.cmp($02442a4f43342bcd$var$ecparams.p) >= 0) return null;
    x = x.toRed($02442a4f43342bcd$var$ecparams.red);
    y = y.toRed($02442a4f43342bcd$var$ecparams.red);
    // is odd flag
    if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null;
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($02442a4f43342bcd$var$ecparams.b)).isZero()) return null;
    return $02442a4f43342bcd$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $02442a4f43342bcd$var$loadPublicKey(pubkey) {
    // length should be validated in interface
    const first = pubkey[0];
    switch(first){
        case 0x02:
        case 0x03:
            if (pubkey.length !== 33) return null;
            return $02442a4f43342bcd$var$loadCompressedPublicKey(first, pubkey.subarray(1, 33));
        case 0x04:
        case 0x06:
        case 0x07:
            if (pubkey.length !== 65) return null;
            return $02442a4f43342bcd$var$loadUncompressedPublicKey(first, pubkey.subarray(1, 33), pubkey.subarray(33, 65));
        default:
            return null;
    }
}
function $02442a4f43342bcd$var$savePublicKey(output, point) {
    const pubkey = point.encode(null, output.length === 33);
    // Loop should be faster because we do not need create extra Uint8Array
    // output.set(new Uint8Array(pubkey))
    for(let i = 0; i < output.length; ++i)output[i] = pubkey[i];
}
module.exports = {
    contextRandomize () {
        return 0;
    },
    privateKeyVerify (seckey) {
        const bn = new $02442a4f43342bcd$var$BN(seckey);
        return bn.cmp($02442a4f43342bcd$var$ecparams.n) < 0 && !bn.isZero() ? 0 : 1;
    },
    privateKeyNegate (seckey) {
        const bn = new $02442a4f43342bcd$var$BN(seckey);
        const negate = $02442a4f43342bcd$var$ecparams.n.sub(bn).umod($02442a4f43342bcd$var$ecparams.n).toArrayLike(Uint8Array, 'be', 32);
        seckey.set(negate);
        return 0;
    },
    privateKeyTweakAdd (seckey, tweak) {
        const bn = new $02442a4f43342bcd$var$BN(tweak);
        if (bn.cmp($02442a4f43342bcd$var$ecparams.n) >= 0) return 1;
        bn.iadd(new $02442a4f43342bcd$var$BN(seckey));
        if (bn.cmp($02442a4f43342bcd$var$ecparams.n) >= 0) bn.isub($02442a4f43342bcd$var$ecparams.n);
        if (bn.isZero()) return 1;
        const tweaked = bn.toArrayLike(Uint8Array, 'be', 32);
        seckey.set(tweaked);
        return 0;
    },
    privateKeyTweakMul (seckey, tweak) {
        let bn = new $02442a4f43342bcd$var$BN(tweak);
        if (bn.cmp($02442a4f43342bcd$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        bn.imul(new $02442a4f43342bcd$var$BN(seckey));
        if (bn.cmp($02442a4f43342bcd$var$ecparams.n) >= 0) bn = bn.umod($02442a4f43342bcd$var$ecparams.n);
        const tweaked = bn.toArrayLike(Uint8Array, 'be', 32);
        seckey.set(tweaked);
        return 0;
    },
    publicKeyVerify (pubkey) {
        const pair = $02442a4f43342bcd$var$loadPublicKey(pubkey);
        return pair === null ? 1 : 0;
    },
    publicKeyCreate (output, seckey) {
        const bn = new $02442a4f43342bcd$var$BN(seckey);
        if (bn.cmp($02442a4f43342bcd$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        const point = $02442a4f43342bcd$var$ec.keyFromPrivate(seckey).getPublic();
        $02442a4f43342bcd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyConvert (output, pubkey) {
        const pair = $02442a4f43342bcd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        $02442a4f43342bcd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyNegate (output, pubkey) {
        const pair = $02442a4f43342bcd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        point.y = point.y.redNeg();
        $02442a4f43342bcd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyCombine (output, pubkeys) {
        const pairs = new Array(pubkeys.length);
        for(let i = 0; i < pubkeys.length; ++i){
            pairs[i] = $02442a4f43342bcd$var$loadPublicKey(pubkeys[i]);
            if (pairs[i] === null) return 1;
        }
        let point = pairs[0].getPublic();
        for(let i = 1; i < pairs.length; ++i)point = point.add(pairs[i].pub);
        if (point.isInfinity()) return 2;
        $02442a4f43342bcd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakAdd (output, pubkey, tweak) {
        const pair = $02442a4f43342bcd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $02442a4f43342bcd$var$BN(tweak);
        if (tweak.cmp($02442a4f43342bcd$var$ecparams.n) >= 0) return 2;
        const point = pair.getPublic().add($02442a4f43342bcd$var$ecparams.g.mul(tweak));
        if (point.isInfinity()) return 2;
        $02442a4f43342bcd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakMul (output, pubkey, tweak) {
        const pair = $02442a4f43342bcd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $02442a4f43342bcd$var$BN(tweak);
        if (tweak.cmp($02442a4f43342bcd$var$ecparams.n) >= 0 || tweak.isZero()) return 2;
        const point = pair.getPublic().mul(tweak);
        $02442a4f43342bcd$var$savePublicKey(output, point);
        return 0;
    },
    signatureNormalize (sig) {
        const r = new $02442a4f43342bcd$var$BN(sig.subarray(0, 32));
        const s = new $02442a4f43342bcd$var$BN(sig.subarray(32, 64));
        if (r.cmp($02442a4f43342bcd$var$ecparams.n) >= 0 || s.cmp($02442a4f43342bcd$var$ecparams.n) >= 0) return 1;
        if (s.cmp($02442a4f43342bcd$var$ec.nh) === 1) sig.set($02442a4f43342bcd$var$ecparams.n.sub(s).toArrayLike(Uint8Array, 'be', 32), 32);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport (obj, sig) {
        const sigR = sig.subarray(0, 32);
        const sigS = sig.subarray(32, 64);
        if (new $02442a4f43342bcd$var$BN(sigR).cmp($02442a4f43342bcd$var$ecparams.n) >= 0) return 1;
        if (new $02442a4f43342bcd$var$BN(sigS).cmp($02442a4f43342bcd$var$ecparams.n) >= 0) return 1;
        const { output: output } = obj;
        // Prepare R
        let r = output.subarray(4, 37);
        r[0] = 0x00;
        r.set(sigR, 1);
        let lenR = 33;
        let posR = 0;
        for(; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);
        r = r.subarray(posR);
        if (r[0] & 0x80) return 1;
        if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) return 1;
        // Prepare S
        let s = output.subarray(39, 72);
        s[0] = 0x00;
        s.set(sigS, 1);
        let lenS = 33;
        let posS = 0;
        for(; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);
        s = s.subarray(posS);
        if (s[0] & 0x80) return 1;
        if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) return 1;
        // Set output length for return
        obj.outputlen = 6 + lenR + lenS;
        // Output in specified format
        // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
        output[0] = 0x30;
        output[1] = obj.outputlen - 2;
        output[2] = 0x02;
        output[3] = r.length;
        output.set(r, 4);
        output[4 + lenR] = 0x02;
        output[5 + lenR] = s.length;
        output.set(s, 6 + lenR);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport (output, sig) {
        if (sig.length < 8) return 1;
        if (sig.length > 72) return 1;
        if (sig[0] !== 0x30) return 1;
        if (sig[1] !== sig.length - 2) return 1;
        if (sig[2] !== 0x02) return 1;
        const lenR = sig[3];
        if (lenR === 0) return 1;
        if (5 + lenR >= sig.length) return 1;
        if (sig[4 + lenR] !== 0x02) return 1;
        const lenS = sig[5 + lenR];
        if (lenS === 0) return 1;
        if (6 + lenR + lenS !== sig.length) return 1;
        if (sig[4] & 0x80) return 1;
        if (lenR > 1 && sig[4] === 0x00 && !(sig[5] & 0x80)) return 1;
        if (sig[lenR + 6] & 0x80) return 1;
        if (lenS > 1 && sig[lenR + 6] === 0x00 && !(sig[lenR + 7] & 0x80)) return 1;
        let sigR = sig.subarray(4, 4 + lenR);
        if (sigR.length === 33 && sigR[0] === 0x00) sigR = sigR.subarray(1);
        if (sigR.length > 32) return 1;
        let sigS = sig.subarray(6 + lenR);
        if (sigS.length === 33 && sigS[0] === 0x00) sigS = sigS.slice(1);
        if (sigS.length > 32) throw new Error('S length is too long');
        let r = new $02442a4f43342bcd$var$BN(sigR);
        if (r.cmp($02442a4f43342bcd$var$ecparams.n) >= 0) r = new $02442a4f43342bcd$var$BN(0);
        let s = new $02442a4f43342bcd$var$BN(sig.subarray(6 + lenR));
        if (s.cmp($02442a4f43342bcd$var$ecparams.n) >= 0) s = new $02442a4f43342bcd$var$BN(0);
        output.set(r.toArrayLike(Uint8Array, 'be', 32), 0);
        output.set(s.toArrayLike(Uint8Array, 'be', 32), 32);
        return 0;
    },
    ecdsaSign (obj, message, seckey, data, noncefn) {
        if (noncefn) {
            const _noncefn = noncefn;
            noncefn = (counter)=>{
                const nonce = _noncefn(message, seckey, null, data, counter);
                const isValid = nonce instanceof Uint8Array && nonce.length === 32;
                if (!isValid) throw new Error('This is the way');
                return new $02442a4f43342bcd$var$BN(nonce);
            };
        }
        const d = new $02442a4f43342bcd$var$BN(seckey);
        if (d.cmp($02442a4f43342bcd$var$ecparams.n) >= 0 || d.isZero()) return 1;
        let sig;
        try {
            sig = $02442a4f43342bcd$var$ec.sign(message, seckey, {
                canonical: true,
                k: noncefn,
                pers: data
            });
        } catch (err) {
            return 1;
        }
        obj.signature.set(sig.r.toArrayLike(Uint8Array, 'be', 32), 0);
        obj.signature.set(sig.s.toArrayLike(Uint8Array, 'be', 32), 32);
        obj.recid = sig.recoveryParam;
        return 0;
    },
    ecdsaVerify (sig, msg32, pubkey) {
        const sigObj = {
            r: sig.subarray(0, 32),
            s: sig.subarray(32, 64)
        };
        const sigr = new $02442a4f43342bcd$var$BN(sigObj.r);
        const sigs = new $02442a4f43342bcd$var$BN(sigObj.s);
        if (sigr.cmp($02442a4f43342bcd$var$ecparams.n) >= 0 || sigs.cmp($02442a4f43342bcd$var$ecparams.n) >= 0) return 1;
        if (sigs.cmp($02442a4f43342bcd$var$ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return 3;
        const pair = $02442a4f43342bcd$var$loadPublicKey(pubkey);
        if (pair === null) return 2;
        const point = pair.getPublic();
        const isValid = $02442a4f43342bcd$var$ec.verify(msg32, sigObj, point);
        return isValid ? 0 : 3;
    },
    ecdsaRecover (output, sig, recid, msg32) {
        const sigObj = {
            r: sig.slice(0, 32),
            s: sig.slice(32, 64)
        };
        const sigr = new $02442a4f43342bcd$var$BN(sigObj.r);
        const sigs = new $02442a4f43342bcd$var$BN(sigObj.s);
        if (sigr.cmp($02442a4f43342bcd$var$ecparams.n) >= 0 || sigs.cmp($02442a4f43342bcd$var$ecparams.n) >= 0) return 1;
        if (sigr.isZero() || sigs.isZero()) return 2;
        // Can throw `throw new Error('Unable to find sencond key candinate');`
        let point;
        try {
            point = $02442a4f43342bcd$var$ec.recoverPubKey(msg32, sigObj, recid);
        } catch (err) {
            return 2;
        }
        $02442a4f43342bcd$var$savePublicKey(output, point);
        return 0;
    },
    ecdh (output, pubkey, seckey, data, hashfn, xbuf, ybuf) {
        const pair = $02442a4f43342bcd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const scalar = new $02442a4f43342bcd$var$BN(seckey);
        if (scalar.cmp($02442a4f43342bcd$var$ecparams.n) >= 0 || scalar.isZero()) return 2;
        const point = pair.getPublic().mul(scalar);
        if (hashfn === undefined) {
            const data = point.encode(null, true);
            const sha256 = $02442a4f43342bcd$var$ec.hash().update(data).digest();
            for(let i = 0; i < 32; ++i)output[i] = sha256[i];
        } else {
            if (!xbuf) xbuf = new Uint8Array(32);
            const x = point.getX().toArray('be', 32);
            for(let i = 0; i < 32; ++i)xbuf[i] = x[i];
            if (!ybuf) ybuf = new Uint8Array(32);
            const y = point.getY().toArray('be', 32);
            for(let i = 0; i < 32; ++i)ybuf[i] = y[i];
            const hash = hashfn(xbuf, ybuf, data);
            const isValid = hash instanceof Uint8Array && hash.length === output.length;
            if (!isValid) return 2;
            output.set(hash);
        }
        return 0;
    }
};

});
parcelRegister("1zUcV", function(module, exports) {
'use strict';
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});
parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.5.4\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("gEVtY", function(module, exports) {
'use strict';
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $c20cf89948514165$var$utils.toArray(bytes, 'hex') : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, 'hex', 'le');
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("jX0xT", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});

parcelRegister("lC4vN", function(module, exports) {
'use strict';
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("cP1GP", function(module, exports) {
'use strict';
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, 'short', conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, 'mont', conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, 'edwards', conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
'use strict';
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $cP1GP.short(options);
    else if (options.type === 'edwards') this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), 'Invalid curve');
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$b0f2b206068f1378$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$b0f2b206068f1378$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$b0f2b206068f1378$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$b0f2b206068f1378$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
'use strict';

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
'use strict';

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
'use strict';

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $btcbI.toHex32(this.h.slice(0, 7), 'big');
    else return $btcbI.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("a9EzX", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};

});


parcelRegister("7j4cV", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h.slice(0, 12), 'big');
    else return $btcbI.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("lMBCM", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'little');
    else return $btcbI.split32(this.h, 'little');
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), 'Unknown curve ' + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $jX0xT(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $jX0xT(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("kKonu", function(module, exports) {
'use strict';

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $lC4vN.toArray(options.pers, options.persEnc || 'hex');
    $koC21(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $fe42f8d68750188b$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $fe42f8d68750188b$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("i46nc", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
'use strict';

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, 'KeyPair is public only');
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});





parcelRegister("1dT7K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hkN9y = parcelRequire("hkN9y");
function $0e41c3d3aaec06be$var$getRandomBytes(bytes) {
    return new Promise(function(resolve, reject) {
        $hkN9y(bytes, function(err, resp) {
            if (err) {
                reject(err);
                return;
            }
            resolve(resp);
        });
    });
}
module.exports.getRandomBytes = $0e41c3d3aaec06be$var$getRandomBytes;
function $0e41c3d3aaec06be$var$getRandomBytesSync(bytes) {
    return $hkN9y(bytes);
}
module.exports.getRandomBytesSync = $0e41c3d3aaec06be$var$getRandomBytesSync;

});
parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});




parcelRegister("aj8Qm", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $781289dd73a1c17e$require$Buffer = $6ZWSX.Buffer;
"use strict";
/*
The MIT License

Copyright (c) 2016 Nick Dodson. nickdodson.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isHexString = module.exports.getKeys = module.exports.fromAscii = module.exports.fromUtf8 = module.exports.toAscii = module.exports.arrayContainsArray = module.exports.getBinarySize = module.exports.padToEven = module.exports.stripHexPrefix = module.exports.isHexPrefixed = void 0;
/**
 * Returns a `Boolean` on whether or not the a `String` starts with '0x'
 * @param str the string input value
 * @return a boolean if it is or is not hex prefixed
 * @throws if the str input is not a string
 */ function $781289dd73a1c17e$var$isHexPrefixed(str) {
    if (typeof str !== 'string') throw new Error("[isHexPrefixed] input must be type 'string', received type " + typeof str);
    return str[0] === '0' && str[1] === 'x';
}
module.exports.isHexPrefixed = $781289dd73a1c17e$var$isHexPrefixed;
/**
 * Removes '0x' from a given `String` if present
 * @param str the string value
 * @returns the string without 0x prefix
 */ var $781289dd73a1c17e$var$stripHexPrefix = function(str) {
    if (typeof str !== 'string') throw new Error("[stripHexPrefix] input must be type 'string', received " + typeof str);
    return $781289dd73a1c17e$var$isHexPrefixed(str) ? str.slice(2) : str;
};
module.exports.stripHexPrefix = $781289dd73a1c17e$var$stripHexPrefix;
/**
 * Pads a `String` to have an even length
 * @param value
 * @return output
 */ function $781289dd73a1c17e$var$padToEven(value) {
    var a = value;
    if (typeof a !== 'string') throw new Error("[padToEven] value must be type 'string', received " + typeof a);
    if (a.length % 2) a = "0" + a;
    return a;
}
module.exports.padToEven = $781289dd73a1c17e$var$padToEven;
/**
 * Get the binary size of a string
 * @param str
 * @returns the number of bytes contained within the string
 */ function $781289dd73a1c17e$var$getBinarySize(str) {
    if (typeof str !== 'string') throw new Error("[getBinarySize] method requires input type 'string', recieved " + typeof str);
    return $781289dd73a1c17e$require$Buffer.byteLength(str, 'utf8');
}
module.exports.getBinarySize = $781289dd73a1c17e$var$getBinarySize;
/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param superset
 * @param subset
 *
 */ function $781289dd73a1c17e$var$arrayContainsArray(superset, subset, some) {
    if (Array.isArray(superset) !== true) throw new Error("[arrayContainsArray] method requires input 'superset' to be an array, got type '" + typeof superset + "'");
    if (Array.isArray(subset) !== true) throw new Error("[arrayContainsArray] method requires input 'subset' to be an array, got type '" + typeof subset + "'");
    return subset[some ? 'some' : 'every'](function(value) {
        return superset.indexOf(value) >= 0;
    });
}
module.exports.arrayContainsArray = $781289dd73a1c17e$var$arrayContainsArray;
/**
 * Should be called to get ascii from its hex representation
 *
 * @param string in hex
 * @returns ascii string representation of hex value
 */ function $781289dd73a1c17e$var$toAscii(hex) {
    var str = '';
    var i = 0;
    var l = hex.length;
    if (hex.substring(0, 2) === '0x') i = 2;
    for(; i < l; i += 2){
        var code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
}
module.exports.toAscii = $781289dd73a1c17e$var$toAscii;
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string
 *
 * @param string
 * @param optional padding
 * @returns hex representation of input string
 */ function $781289dd73a1c17e$var$fromUtf8(stringValue) {
    var str = $781289dd73a1c17e$require$Buffer.from(stringValue, 'utf8');
    return "0x" + $781289dd73a1c17e$var$padToEven(str.toString('hex')).replace(/^0+|0+$/g, '');
}
module.exports.fromUtf8 = $781289dd73a1c17e$var$fromUtf8;
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @param  string
 * @param  optional padding
 * @returns  hex representation of input string
 */ function $781289dd73a1c17e$var$fromAscii(stringValue) {
    var hex = '';
    for(var i = 0; i < stringValue.length; i++){
        var code = stringValue.charCodeAt(i);
        var n = code.toString(16);
        hex += n.length < 2 ? "0" + n : n;
    }
    return "0x" + hex;
}
module.exports.fromAscii = $781289dd73a1c17e$var$fromAscii;
/**
 * Returns the keys from an array of objects.
 * @example
 * ```js
 * getKeys([{a: '1', b: '2'}, {a: '3', b: '4'}], 'a') => ['1', '3']
 *````
 * @param  params
 * @param  key
 * @param  allowEmpty
 * @returns output just a simple array of output keys
 */ function $781289dd73a1c17e$var$getKeys(params, key, allowEmpty) {
    if (!Array.isArray(params)) throw new Error("[getKeys] method expects input 'params' to be an array, got " + typeof params);
    if (typeof key !== 'string') throw new Error("[getKeys] method expects input 'key' to be type 'string', got " + typeof params);
    var result = [];
    for(var i = 0; i < params.length; i++){
        var value = params[i][key];
        if (allowEmpty && !value) value = '';
        else if (typeof value !== 'string') throw new Error("invalid abi - expected type 'string', received " + typeof value);
        result.push(value);
    }
    return result;
}
module.exports.getKeys = $781289dd73a1c17e$var$getKeys;
/**
 * Is the string a hex string.
 *
 * @param  value
 * @param  length
 * @returns  output the string is a hex string
 */ function $781289dd73a1c17e$var$isHexString(value, length) {
    if (typeof value !== 'string' || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
module.exports.isHexString = $781289dd73a1c17e$var$isHexString;

});

parcelRegister("b61lJ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $81414d3539e03a13$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $81414d3539e03a13$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.baToJSON = module.exports.toUtf8 = module.exports.addHexPrefix = module.exports.toUnsigned = module.exports.fromSigned = module.exports.bufferToHex = module.exports.bufferToInt = module.exports.toBuffer = module.exports.unpadHexString = module.exports.unpadArray = module.exports.unpadBuffer = module.exports.setLengthRight = module.exports.setLengthLeft = module.exports.zeros = module.exports.intToBuffer = module.exports.intToHex = void 0;

var $81414d3539e03a13$var$bn_js_1 = $81414d3539e03a13$var$__importDefault((parcelRequire("dEXSZ")));

var $aj8Qm = parcelRequire("aj8Qm");

var $7jIKp = parcelRequire("7jIKp");
/**
 * Converts a `Number` into a hex `String`
 * @param {Number} i
 * @return {String}
 */ var $81414d3539e03a13$var$intToHex = function(i) {
    if (!Number.isSafeInteger(i) || i < 0) throw new Error("Received an invalid integer type: " + i);
    return "0x" + i.toString(16);
};
module.exports.intToHex = $81414d3539e03a13$var$intToHex;
/**
 * Converts an `Number` to a `Buffer`
 * @param {Number} i
 * @return {Buffer}
 */ var $81414d3539e03a13$var$intToBuffer = function(i) {
    var hex = (0, module.exports.intToHex)(i);
    return $81414d3539e03a13$require$Buffer.from((0, $aj8Qm.padToEven)(hex.slice(2)), 'hex');
};
module.exports.intToBuffer = $81414d3539e03a13$var$intToBuffer;
/**
 * Returns a buffer filled with 0s.
 * @param bytes the number of bytes the buffer should be
 */ var $81414d3539e03a13$var$zeros = function(bytes) {
    return $81414d3539e03a13$require$Buffer.allocUnsafe(bytes).fill(0);
};
module.exports.zeros = $81414d3539e03a13$var$zeros;
/**
 * Pads a `Buffer` with zeros till it has `length` bytes.
 * Truncates the beginning or end of input if its length exceeds `length`.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @param right whether to start padding form the left or right
 * @return (Buffer)
 */ var $81414d3539e03a13$var$setLength = function(msg, length, right) {
    var buf = (0, module.exports.zeros)(length);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
};
/**
 * Left Pads a `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @return (Buffer)
 */ var $81414d3539e03a13$var$setLengthLeft = function(msg, length) {
    (0, $7jIKp.assertIsBuffer)(msg);
    return $81414d3539e03a13$var$setLength(msg, length, false);
};
module.exports.setLengthLeft = $81414d3539e03a13$var$setLengthLeft;
/**
 * Right Pads a `Buffer` with trailing zeros till it has `length` bytes.
 * it truncates the end if it exceeds.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @return (Buffer)
 */ var $81414d3539e03a13$var$setLengthRight = function(msg, length) {
    (0, $7jIKp.assertIsBuffer)(msg);
    return $81414d3539e03a13$var$setLength(msg, length, true);
};
module.exports.setLengthRight = $81414d3539e03a13$var$setLengthRight;
/**
 * Trims leading zeros from a `Buffer`, `String` or `Number[]`.
 * @param a (Buffer|Array|String)
 * @return (Buffer|Array|String)
 */ var $81414d3539e03a13$var$stripZeros = function(a) {
    var first = a[0];
    while(a.length > 0 && first.toString() === '0'){
        a = a.slice(1);
        first = a[0];
    }
    return a;
};
/**
 * Trims leading zeros from a `Buffer`.
 * @param a (Buffer)
 * @return (Buffer)
 */ var $81414d3539e03a13$var$unpadBuffer = function(a) {
    (0, $7jIKp.assertIsBuffer)(a);
    return $81414d3539e03a13$var$stripZeros(a);
};
module.exports.unpadBuffer = $81414d3539e03a13$var$unpadBuffer;
/**
 * Trims leading zeros from an `Array` (of numbers).
 * @param a (number[])
 * @return (number[])
 */ var $81414d3539e03a13$var$unpadArray = function(a) {
    (0, $7jIKp.assertIsArray)(a);
    return $81414d3539e03a13$var$stripZeros(a);
};
module.exports.unpadArray = $81414d3539e03a13$var$unpadArray;
/**
 * Trims leading zeros from a hex-prefixed `String`.
 * @param a (String)
 * @return (String)
 */ var $81414d3539e03a13$var$unpadHexString = function(a) {
    (0, $7jIKp.assertIsHexString)(a);
    a = (0, $aj8Qm.stripHexPrefix)(a);
    return $81414d3539e03a13$var$stripZeros(a);
};
module.exports.unpadHexString = $81414d3539e03a13$var$unpadHexString;
/**
 * Attempts to turn a value into a `Buffer`.
 * Inputs supported: `Buffer`, `String` (hex-prefixed), `Number`, null/undefined, `BN` and other objects
 * with a `toArray()` or `toBuffer()` method.
 * @param v the value
 */ var $81414d3539e03a13$var$toBuffer = function(v) {
    if (v === null || v === undefined) return $81414d3539e03a13$require$Buffer.allocUnsafe(0);
    if ($81414d3539e03a13$require$Buffer.isBuffer(v)) return $81414d3539e03a13$require$Buffer.from(v);
    if (Array.isArray(v) || v instanceof Uint8Array) return $81414d3539e03a13$require$Buffer.from(v);
    if (typeof v === 'string') {
        if (!(0, $aj8Qm.isHexString)(v)) throw new Error("Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: " + v);
        return $81414d3539e03a13$require$Buffer.from((0, $aj8Qm.padToEven)((0, $aj8Qm.stripHexPrefix)(v)), 'hex');
    }
    if (typeof v === 'number') return (0, module.exports.intToBuffer)(v);
    if ($81414d3539e03a13$var$bn_js_1.default.isBN(v)) return v.toArrayLike($81414d3539e03a13$require$Buffer);
    if (v.toArray) // converts a BN to a Buffer
    return $81414d3539e03a13$require$Buffer.from(v.toArray());
    if (v.toBuffer) return $81414d3539e03a13$require$Buffer.from(v.toBuffer());
    throw new Error('invalid type');
};
module.exports.toBuffer = $81414d3539e03a13$var$toBuffer;
/**
 * Converts a `Buffer` to a `Number`.
 * @param buf `Buffer` object to convert
 * @throws If the input number exceeds 53 bits.
 */ var $81414d3539e03a13$var$bufferToInt = function(buf) {
    return new $81414d3539e03a13$var$bn_js_1.default((0, module.exports.toBuffer)(buf)).toNumber();
};
module.exports.bufferToInt = $81414d3539e03a13$var$bufferToInt;
/**
 * Converts a `Buffer` into a `0x`-prefixed hex `String`.
 * @param buf `Buffer` object to convert
 */ var $81414d3539e03a13$var$bufferToHex = function(buf) {
    buf = (0, module.exports.toBuffer)(buf);
    return '0x' + buf.toString('hex');
};
module.exports.bufferToHex = $81414d3539e03a13$var$bufferToHex;
/**
 * Interprets a `Buffer` as a signed integer and returns a `BN`. Assumes 256-bit numbers.
 * @param num Signed integer value
 */ var $81414d3539e03a13$var$fromSigned = function(num) {
    return new $81414d3539e03a13$var$bn_js_1.default(num).fromTwos(256);
};
module.exports.fromSigned = $81414d3539e03a13$var$fromSigned;
/**
 * Converts a `BN` to an unsigned integer and returns it as a `Buffer`. Assumes 256-bit numbers.
 * @param num
 */ var $81414d3539e03a13$var$toUnsigned = function(num) {
    return $81414d3539e03a13$require$Buffer.from(num.toTwos(256).toArray());
};
module.exports.toUnsigned = $81414d3539e03a13$var$toUnsigned;
/**
 * Adds "0x" to a given `String` if it does not already start with "0x".
 */ var $81414d3539e03a13$var$addHexPrefix = function(str) {
    if (typeof str !== 'string') return str;
    return (0, $aj8Qm.isHexPrefixed)(str) ? str : '0x' + str;
};
module.exports.addHexPrefix = $81414d3539e03a13$var$addHexPrefix;
/**
 * Returns the utf8 string representation from a hex string.
 *
 * Examples:
 *
 * Input 1: '657468657265756d000000000000000000000000000000000000000000000000'
 * Input 2: '657468657265756d'
 * Input 3: '000000000000000000000000000000000000000000000000657468657265756d'
 *
 * Output (all 3 input variants): 'ethereum'
 *
 * Note that this method is not intended to be used with hex strings
 * representing quantities in both big endian or little endian notation.
 *
 * @param string Hex string, should be `0x` prefixed
 * @return Utf8 string
 */ var $81414d3539e03a13$var$toUtf8 = function(hex) {
    var zerosRegexp = /^(00)+|(00)+$/g;
    hex = (0, $aj8Qm.stripHexPrefix)(hex);
    if (hex.length % 2 !== 0) throw new Error('Invalid non-even hex string input for toUtf8() provided');
    var bufferVal = $81414d3539e03a13$require$Buffer.from(hex.replace(zerosRegexp, ''), 'hex');
    return bufferVal.toString('utf8');
};
module.exports.toUtf8 = $81414d3539e03a13$var$toUtf8;
/**
 * Converts a `Buffer` or `Array` to JSON.
 * @param ba (Buffer|Array)
 * @return (Array|String|null)
 */ var $81414d3539e03a13$var$baToJSON = function(ba) {
    if ($81414d3539e03a13$require$Buffer.isBuffer(ba)) return "0x" + ba.toString('hex');
    else if (ba instanceof Array) {
        var array = [];
        for(var i = 0; i < ba.length; i++)array.push((0, module.exports.baToJSON)(ba[i]));
        return array;
    }
};
module.exports.baToJSON = $81414d3539e03a13$var$baToJSON;

});
parcelRegister("7jIKp", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $553d04ab4f0b6098$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertIsString = module.exports.assertIsArray = module.exports.assertIsBuffer = module.exports.assertIsHexString = void 0;

var $aj8Qm = parcelRequire("aj8Qm");
/**
 * Throws if a string is not hex prefixed
 * @param {string} input string to check hex prefix of
 */ var $553d04ab4f0b6098$var$assertIsHexString = function(input) {
    if (!(0, $aj8Qm.isHexString)(input)) {
        var msg = "This method only supports 0x-prefixed hex strings but input was: " + input;
        throw new Error(msg);
    }
};
module.exports.assertIsHexString = $553d04ab4f0b6098$var$assertIsHexString;
/**
 * Throws if input is not a buffer
 * @param {Buffer} input value to check
 */ var $553d04ab4f0b6098$var$assertIsBuffer = function(input) {
    if (!$553d04ab4f0b6098$require$Buffer.isBuffer(input)) {
        var msg = "This method only supports Buffer but input was: " + input;
        throw new Error(msg);
    }
};
module.exports.assertIsBuffer = $553d04ab4f0b6098$var$assertIsBuffer;
/**
 * Throws if input is not an array
 * @param {number[]} input value to check
 */ var $553d04ab4f0b6098$var$assertIsArray = function(input) {
    if (!Array.isArray(input)) {
        var msg = "This method only supports number arrays but input was: " + input;
        throw new Error(msg);
    }
};
module.exports.assertIsArray = $553d04ab4f0b6098$var$assertIsArray;
/**
 * Throws if input is not a string
 * @param {string} input value to check
 */ var $553d04ab4f0b6098$var$assertIsString = function(input) {
    if (typeof input !== 'string') {
        var msg = "This method only supports strings but input was: " + input;
        throw new Error(msg);
    }
};
module.exports.assertIsString = $553d04ab4f0b6098$var$assertIsString;

});


parcelRegister("gKSHR", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c32b60c1ed6688ec$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $c32b60c1ed6688ec$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c32b60c1ed6688ec$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c32b60c1ed6688ec$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c32b60c1ed6688ec$var$__createBinding(result, mod, k);
    }
    $c32b60c1ed6688ec$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rlphash = module.exports.ripemd160FromArray = module.exports.ripemd160FromString = module.exports.ripemd160 = module.exports.sha256FromArray = module.exports.sha256FromString = module.exports.sha256 = module.exports.keccakFromArray = module.exports.keccakFromHexString = module.exports.keccakFromString = module.exports.keccak256 = module.exports.keccak = void 0;

var $bnmFi = parcelRequire("bnmFi");

var $1R2J7 = parcelRequire("1R2J7");

var $c32b60c1ed6688ec$var$rlp = $c32b60c1ed6688ec$var$__importStar((parcelRequire("g16XK")));

var $b61lJ = parcelRequire("b61lJ");

var $7jIKp = parcelRequire("7jIKp");
/**
 * Creates Keccak hash of a Buffer input
 * @param a The input data (Buffer)
 * @param bits (number = 256) The Keccak width
 */ var $c32b60c1ed6688ec$var$keccak = function(a, bits) {
    if (bits === void 0) bits = 256;
    (0, $7jIKp.assertIsBuffer)(a);
    switch(bits){
        case 224:
            return (0, $bnmFi.keccak224)(a);
        case 256:
            return (0, $bnmFi.keccak256)(a);
        case 384:
            return (0, $bnmFi.keccak384)(a);
        case 512:
            return (0, $bnmFi.keccak512)(a);
        default:
            throw new Error("Invald algorithm: keccak" + bits);
    }
};
module.exports.keccak = $c32b60c1ed6688ec$var$keccak;
/**
 * Creates Keccak-256 hash of the input, alias for keccak(a, 256).
 * @param a The input data (Buffer)
 */ var $c32b60c1ed6688ec$var$keccak256 = function(a) {
    return (0, module.exports.keccak)(a);
};
module.exports.keccak256 = $c32b60c1ed6688ec$var$keccak256;
/**
 * Creates Keccak hash of a utf-8 string input
 * @param a The input data (String)
 * @param bits (number = 256) The Keccak width
 */ var $c32b60c1ed6688ec$var$keccakFromString = function(a, bits) {
    if (bits === void 0) bits = 256;
    (0, $7jIKp.assertIsString)(a);
    var buf = $c32b60c1ed6688ec$require$Buffer.from(a, 'utf8');
    return (0, module.exports.keccak)(buf, bits);
};
module.exports.keccakFromString = $c32b60c1ed6688ec$var$keccakFromString;
/**
 * Creates Keccak hash of an 0x-prefixed string input
 * @param a The input data (String)
 * @param bits (number = 256) The Keccak width
 */ var $c32b60c1ed6688ec$var$keccakFromHexString = function(a, bits) {
    if (bits === void 0) bits = 256;
    (0, $7jIKp.assertIsHexString)(a);
    return (0, module.exports.keccak)((0, $b61lJ.toBuffer)(a), bits);
};
module.exports.keccakFromHexString = $c32b60c1ed6688ec$var$keccakFromHexString;
/**
 * Creates Keccak hash of a number array input
 * @param a The input data (number[])
 * @param bits (number = 256) The Keccak width
 */ var $c32b60c1ed6688ec$var$keccakFromArray = function(a, bits) {
    if (bits === void 0) bits = 256;
    (0, $7jIKp.assertIsArray)(a);
    return (0, module.exports.keccak)((0, $b61lJ.toBuffer)(a), bits);
};
module.exports.keccakFromArray = $c32b60c1ed6688ec$var$keccakFromArray;
/**
 * Creates SHA256 hash of an input.
 * @param  a The input data (Buffer|Array|String)
 */ var $c32b60c1ed6688ec$var$_sha256 = function(a) {
    a = (0, $b61lJ.toBuffer)(a);
    return $1R2J7('sha256').update(a).digest();
};
/**
 * Creates SHA256 hash of a Buffer input.
 * @param a The input data (Buffer)
 */ var $c32b60c1ed6688ec$var$sha256 = function(a) {
    (0, $7jIKp.assertIsBuffer)(a);
    return $c32b60c1ed6688ec$var$_sha256(a);
};
module.exports.sha256 = $c32b60c1ed6688ec$var$sha256;
/**
 * Creates SHA256 hash of a string input.
 * @param a The input data (string)
 */ var $c32b60c1ed6688ec$var$sha256FromString = function(a) {
    (0, $7jIKp.assertIsString)(a);
    return $c32b60c1ed6688ec$var$_sha256(a);
};
module.exports.sha256FromString = $c32b60c1ed6688ec$var$sha256FromString;
/**
 * Creates SHA256 hash of a number[] input.
 * @param a The input data (number[])
 */ var $c32b60c1ed6688ec$var$sha256FromArray = function(a) {
    (0, $7jIKp.assertIsArray)(a);
    return $c32b60c1ed6688ec$var$_sha256(a);
};
module.exports.sha256FromArray = $c32b60c1ed6688ec$var$sha256FromArray;
/**
 * Creates RIPEMD160 hash of the input.
 * @param a The input data (Buffer|Array|String|Number)
 * @param padded Whether it should be padded to 256 bits or not
 */ var $c32b60c1ed6688ec$var$_ripemd160 = function(a, padded) {
    a = (0, $b61lJ.toBuffer)(a);
    var hash = $1R2J7('rmd160').update(a).digest();
    if (padded === true) return (0, $b61lJ.setLengthLeft)(hash, 32);
    else return hash;
};
/**
 * Creates RIPEMD160 hash of a Buffer input.
 * @param a The input data (Buffer)
 * @param padded Whether it should be padded to 256 bits or not
 */ var $c32b60c1ed6688ec$var$ripemd160 = function(a, padded) {
    (0, $7jIKp.assertIsBuffer)(a);
    return $c32b60c1ed6688ec$var$_ripemd160(a, padded);
};
module.exports.ripemd160 = $c32b60c1ed6688ec$var$ripemd160;
/**
 * Creates RIPEMD160 hash of a string input.
 * @param a The input data (String)
 * @param padded Whether it should be padded to 256 bits or not
 */ var $c32b60c1ed6688ec$var$ripemd160FromString = function(a, padded) {
    (0, $7jIKp.assertIsString)(a);
    return $c32b60c1ed6688ec$var$_ripemd160(a, padded);
};
module.exports.ripemd160FromString = $c32b60c1ed6688ec$var$ripemd160FromString;
/**
 * Creates RIPEMD160 hash of a number[] input.
 * @param a The input data (number[])
 * @param padded Whether it should be padded to 256 bits or not
 */ var $c32b60c1ed6688ec$var$ripemd160FromArray = function(a, padded) {
    (0, $7jIKp.assertIsArray)(a);
    return $c32b60c1ed6688ec$var$_ripemd160(a, padded);
};
module.exports.ripemd160FromArray = $c32b60c1ed6688ec$var$ripemd160FromArray;
/**
 * Creates SHA-3 hash of the RLP encoded version of the input.
 * @param a The input data
 */ var $c32b60c1ed6688ec$var$rlphash = function(a) {
    return (0, module.exports.keccak)($c32b60c1ed6688ec$var$rlp.encode(a));
};
module.exports.rlphash = $c32b60c1ed6688ec$var$rlphash;

});
parcelRegister("bnmFi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7udHx = parcelRequire("7udHx");

var $6Wbu5 = parcelRequire("6Wbu5");
module.exports.keccak224 = $7udHx.createHashFunction(function() {
    return $6Wbu5("keccak224");
});
module.exports.keccak256 = $7udHx.createHashFunction(function() {
    return $6Wbu5("keccak256");
});
module.exports.keccak384 = $7udHx.createHashFunction(function() {
    return $6Wbu5("keccak384");
});
module.exports.keccak512 = $7udHx.createHashFunction(function() {
    return $6Wbu5("keccak512");
});

});
parcelRegister("7udHx", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $5735f68b0150732d$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $5735f68b0150732d$var$createHashFunction(hashConstructor) {
    return function(msg) {
        var hash = hashConstructor();
        hash.update(msg);
        return $5735f68b0150732d$require$Buffer.from(hash.digest());
    };
}
module.exports.createHashFunction = $5735f68b0150732d$var$createHashFunction;

});

parcelRegister("6Wbu5", function(module, exports) {


module.exports = (parcelRequire("2gIqK"))((parcelRequire("aXZeq")));

});
parcelRegister("2gIqK", function(module, exports) {

var $lNrNT = parcelRequire("lNrNT");

var $dMqOm = parcelRequire("dMqOm");
module.exports = function(KeccakState) {
    const Keccak = $lNrNT(KeccakState);
    const Shake = $dMqOm(KeccakState);
    return function(algorithm, options) {
        const hash = typeof algorithm === 'string' ? algorithm.toLowerCase() : algorithm;
        switch(hash){
            case 'keccak224':
                return new Keccak(1152, 448, null, 224, options);
            case 'keccak256':
                return new Keccak(1088, 512, null, 256, options);
            case 'keccak384':
                return new Keccak(832, 768, null, 384, options);
            case 'keccak512':
                return new Keccak(576, 1024, null, 512, options);
            case 'sha3-224':
                return new Keccak(1152, 448, 0x06, 224, options);
            case 'sha3-256':
                return new Keccak(1088, 512, 0x06, 256, options);
            case 'sha3-384':
                return new Keccak(832, 768, 0x06, 384, options);
            case 'sha3-512':
                return new Keccak(576, 1024, 0x06, 512, options);
            case 'shake128':
                return new Shake(1344, 256, 0x1f, options);
            case 'shake256':
                return new Shake(1088, 512, 0x1f, options);
            default:
                throw new Error('Invald algorithm: ' + algorithm);
        }
    };
};

});
parcelRegister("lNrNT", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $041851836d8c651b$require$Buffer = $6ZWSX.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $041851836d8c651b$require$Transform = $ioRHp.Transform;
module.exports = (KeccakState)=>class Keccak extends $041851836d8c651b$require$Transform {
        constructor(rate, capacity, delimitedSuffix, hashBitLength, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._hashBitLength = hashBitLength;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush(callback) {
            let error = null;
            try {
                this.push(this.digest());
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        update(data, encoding) {
            if (!$041851836d8c651b$require$Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer');
            if (this._finalized) throw new Error('Digest already called');
            if (!$041851836d8c651b$require$Buffer.isBuffer(data)) data = $041851836d8c651b$require$Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        digest(encoding) {
            if (this._finalized) throw new Error('Digest already called');
            this._finalized = true;
            if (this._delimitedSuffix) this._state.absorbLastFewBits(this._delimitedSuffix);
            let digest = this._state.squeeze(this._hashBitLength / 8);
            if (encoding !== undefined) digest = digest.toString(encoding);
            this._resetState();
            return digest;
        }
        // remove result from memory
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        // because sometimes we need hash right now and little later
        _clone() {
            const clone = new Keccak(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("d4xg3"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("3LwY7"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("DwJuQ"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("b7kl8"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("4wWcs"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("fiCvv"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("aGSwO"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog('stream');
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy; // has it been destroyed
    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex); // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
}; // backwards compatibility.

$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
}; // Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug('length less than watermark', doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug('do read');
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug('onend');
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug('cleanup'); // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug('ondata');
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, 'error') === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    } // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug('unpipe');
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit('pipe', src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    } // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug('on readable', state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
    else if (self.listenerCount('data') > 0) self.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self) {
    $9845726cca5dc7eb$var$debug('readable nexttick read 0');
    self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('resume'); // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $9845726cca5dc7eb$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $9845726cca5dc7eb$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
     // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
}); // exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("bF5dL", function(module, exports) {
'use strict';
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $87d792cd1b95f90e$var$ownKeys(Object(source), true).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $87d792cd1b95f90e$var$inspect = $kjyEk.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || 'inspect';
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            } // Consumes a specified amount of bytes or characters from the buffered data.
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            } // Consumes a specified amount of characters from the buffered data.
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Consumes a specified amount of bytes from the buffered data.
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Make sure the linked list only shows the minimal necessary information.
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread({}, options, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict'; // undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
     // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRegister("04a3B", function(module, exports) {
'use strict';

var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = (parcelRequire("6JySE")).codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    } // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRegister("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
'use strict';
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $4e720097bc0bc9d8$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, 'type'));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$4e720097bc0bc9d8$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$4e720097bc0bc9d8$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$4e720097bc0bc9d8$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
}); // the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called
    this.finalCalled = false; // drain event flag.
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // has it been destroyed
    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, 'buffer', {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ")); // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jfAlf.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er); // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
} // if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    } // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config('throwDeprecation')) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol('lastResolve');
var $21db958e3a099d7d$var$kLastReject = Symbol('lastReject');
var $21db958e3a099d7d$var$kError = Symbol('error');
var $21db958e3a099d7d$var$kEnded = Symbol('ended');
var $21db958e3a099d7d$var$kLastPromise = Symbol('lastPromise');
var $21db958e3a099d7d$var$kHandlePromise = Symbol('handlePromise');
var $21db958e3a099d7d$var$kStream = Symbol('stream');
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read(); // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
         // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject]; // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on('readable', $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRegister("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("6JySE")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRegister("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    }; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true; // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});



parcelRegister("dMqOm", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a0848e399cbf0990$require$Buffer = $6ZWSX.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $a0848e399cbf0990$require$Transform = $ioRHp.Transform;
module.exports = (KeccakState)=>class Shake extends $a0848e399cbf0990$require$Transform {
        constructor(rate, capacity, delimitedSuffix, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush() {}
        _read(size) {
            this.push(this.squeeze(size));
        }
        update(data, encoding) {
            if (!$a0848e399cbf0990$require$Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer');
            if (this._finalized) throw new Error('Squeeze already called');
            if (!$a0848e399cbf0990$require$Buffer.isBuffer(data)) data = $a0848e399cbf0990$require$Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        squeeze(dataByteLength, encoding) {
            if (!this._finalized) {
                this._finalized = true;
                this._state.absorbLastFewBits(this._delimitedSuffix);
            }
            let data = this._state.squeeze(dataByteLength);
            if (encoding !== undefined) data = data.toString(encoding);
            return data;
        }
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        _clone() {
            const clone = new Shake(this._rate, this._capacity, this._delimitedSuffix, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

});


parcelRegister("aXZeq", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $7fbee9616d7e34ff$require$Buffer = $6ZWSX.Buffer;

var $2Obs4 = parcelRequire("2Obs4");
function $7fbee9616d7e34ff$var$Keccak() {
    // much faster than `new Array(50)`
    this.state = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    this.blockSize = null;
    this.count = 0;
    this.squeezing = false;
}
$7fbee9616d7e34ff$var$Keccak.prototype.initialize = function(rate, capacity) {
    for(let i = 0; i < 50; ++i)this.state[i] = 0;
    this.blockSize = rate / 8;
    this.count = 0;
    this.squeezing = false;
};
$7fbee9616d7e34ff$var$Keccak.prototype.absorb = function(data) {
    for(let i = 0; i < data.length; ++i){
        this.state[~~(this.count / 4)] ^= data[i] << 8 * (this.count % 4);
        this.count += 1;
        if (this.count === this.blockSize) {
            $2Obs4.p1600(this.state);
            this.count = 0;
        }
    }
};
$7fbee9616d7e34ff$var$Keccak.prototype.absorbLastFewBits = function(bits) {
    this.state[~~(this.count / 4)] ^= bits << 8 * (this.count % 4);
    if ((bits & 0x80) !== 0 && this.count === this.blockSize - 1) $2Obs4.p1600(this.state);
    this.state[~~((this.blockSize - 1) / 4)] ^= 0x80 << 8 * ((this.blockSize - 1) % 4);
    $2Obs4.p1600(this.state);
    this.count = 0;
    this.squeezing = true;
};
$7fbee9616d7e34ff$var$Keccak.prototype.squeeze = function(length) {
    if (!this.squeezing) this.absorbLastFewBits(0x01);
    const output = $7fbee9616d7e34ff$require$Buffer.alloc(length);
    for(let i = 0; i < length; ++i){
        output[i] = this.state[~~(this.count / 4)] >>> 8 * (this.count % 4) & 0xff;
        this.count += 1;
        if (this.count === this.blockSize) {
            $2Obs4.p1600(this.state);
            this.count = 0;
        }
    }
    return output;
};
$7fbee9616d7e34ff$var$Keccak.prototype.copy = function(dest) {
    for(let i = 0; i < 50; ++i)dest.state[i] = this.state[i];
    dest.blockSize = this.blockSize;
    dest.count = this.count;
    dest.squeezing = this.squeezing;
};
module.exports = $7fbee9616d7e34ff$var$Keccak;

});
parcelRegister("2Obs4", function(module, exports) {

$parcel$export(module.exports, "p1600", () => $20b9225e11970988$export$471358fe9e8379c0, (v) => $20b9225e11970988$export$471358fe9e8379c0 = v);
var $20b9225e11970988$export$471358fe9e8379c0;
const $20b9225e11970988$var$P1600_ROUND_CONSTANTS = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
$20b9225e11970988$export$471358fe9e8379c0 = function(s) {
    for(let round = 0; round < 24; ++round){
        // theta
        const lo0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        const hi0 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        const lo1 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        const hi1 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        const lo2 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        const hi2 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        const lo3 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        const hi3 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        const lo4 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        const hi4 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        let lo = lo4 ^ (lo1 << 1 | hi1 >>> 31);
        let hi = hi4 ^ (hi1 << 1 | lo1 >>> 31);
        const t1slo0 = s[0] ^ lo;
        const t1shi0 = s[1] ^ hi;
        const t1slo5 = s[10] ^ lo;
        const t1shi5 = s[11] ^ hi;
        const t1slo10 = s[20] ^ lo;
        const t1shi10 = s[21] ^ hi;
        const t1slo15 = s[30] ^ lo;
        const t1shi15 = s[31] ^ hi;
        const t1slo20 = s[40] ^ lo;
        const t1shi20 = s[41] ^ hi;
        lo = lo0 ^ (lo2 << 1 | hi2 >>> 31);
        hi = hi0 ^ (hi2 << 1 | lo2 >>> 31);
        const t1slo1 = s[2] ^ lo;
        const t1shi1 = s[3] ^ hi;
        const t1slo6 = s[12] ^ lo;
        const t1shi6 = s[13] ^ hi;
        const t1slo11 = s[22] ^ lo;
        const t1shi11 = s[23] ^ hi;
        const t1slo16 = s[32] ^ lo;
        const t1shi16 = s[33] ^ hi;
        const t1slo21 = s[42] ^ lo;
        const t1shi21 = s[43] ^ hi;
        lo = lo1 ^ (lo3 << 1 | hi3 >>> 31);
        hi = hi1 ^ (hi3 << 1 | lo3 >>> 31);
        const t1slo2 = s[4] ^ lo;
        const t1shi2 = s[5] ^ hi;
        const t1slo7 = s[14] ^ lo;
        const t1shi7 = s[15] ^ hi;
        const t1slo12 = s[24] ^ lo;
        const t1shi12 = s[25] ^ hi;
        const t1slo17 = s[34] ^ lo;
        const t1shi17 = s[35] ^ hi;
        const t1slo22 = s[44] ^ lo;
        const t1shi22 = s[45] ^ hi;
        lo = lo2 ^ (lo4 << 1 | hi4 >>> 31);
        hi = hi2 ^ (hi4 << 1 | lo4 >>> 31);
        const t1slo3 = s[6] ^ lo;
        const t1shi3 = s[7] ^ hi;
        const t1slo8 = s[16] ^ lo;
        const t1shi8 = s[17] ^ hi;
        const t1slo13 = s[26] ^ lo;
        const t1shi13 = s[27] ^ hi;
        const t1slo18 = s[36] ^ lo;
        const t1shi18 = s[37] ^ hi;
        const t1slo23 = s[46] ^ lo;
        const t1shi23 = s[47] ^ hi;
        lo = lo3 ^ (lo0 << 1 | hi0 >>> 31);
        hi = hi3 ^ (hi0 << 1 | lo0 >>> 31);
        const t1slo4 = s[8] ^ lo;
        const t1shi4 = s[9] ^ hi;
        const t1slo9 = s[18] ^ lo;
        const t1shi9 = s[19] ^ hi;
        const t1slo14 = s[28] ^ lo;
        const t1shi14 = s[29] ^ hi;
        const t1slo19 = s[38] ^ lo;
        const t1shi19 = s[39] ^ hi;
        const t1slo24 = s[48] ^ lo;
        const t1shi24 = s[49] ^ hi;
        // rho & pi
        const t2slo0 = t1slo0;
        const t2shi0 = t1shi0;
        const t2slo16 = t1shi5 << 4 | t1slo5 >>> 28;
        const t2shi16 = t1slo5 << 4 | t1shi5 >>> 28;
        const t2slo7 = t1slo10 << 3 | t1shi10 >>> 29;
        const t2shi7 = t1shi10 << 3 | t1slo10 >>> 29;
        const t2slo23 = t1shi15 << 9 | t1slo15 >>> 23;
        const t2shi23 = t1slo15 << 9 | t1shi15 >>> 23;
        const t2slo14 = t1slo20 << 18 | t1shi20 >>> 14;
        const t2shi14 = t1shi20 << 18 | t1slo20 >>> 14;
        const t2slo10 = t1slo1 << 1 | t1shi1 >>> 31;
        const t2shi10 = t1shi1 << 1 | t1slo1 >>> 31;
        const t2slo1 = t1shi6 << 12 | t1slo6 >>> 20;
        const t2shi1 = t1slo6 << 12 | t1shi6 >>> 20;
        const t2slo17 = t1slo11 << 10 | t1shi11 >>> 22;
        const t2shi17 = t1shi11 << 10 | t1slo11 >>> 22;
        const t2slo8 = t1shi16 << 13 | t1slo16 >>> 19;
        const t2shi8 = t1slo16 << 13 | t1shi16 >>> 19;
        const t2slo24 = t1slo21 << 2 | t1shi21 >>> 30;
        const t2shi24 = t1shi21 << 2 | t1slo21 >>> 30;
        const t2slo20 = t1shi2 << 30 | t1slo2 >>> 2;
        const t2shi20 = t1slo2 << 30 | t1shi2 >>> 2;
        const t2slo11 = t1slo7 << 6 | t1shi7 >>> 26;
        const t2shi11 = t1shi7 << 6 | t1slo7 >>> 26;
        const t2slo2 = t1shi12 << 11 | t1slo12 >>> 21;
        const t2shi2 = t1slo12 << 11 | t1shi12 >>> 21;
        const t2slo18 = t1slo17 << 15 | t1shi17 >>> 17;
        const t2shi18 = t1shi17 << 15 | t1slo17 >>> 17;
        const t2slo9 = t1shi22 << 29 | t1slo22 >>> 3;
        const t2shi9 = t1slo22 << 29 | t1shi22 >>> 3;
        const t2slo5 = t1slo3 << 28 | t1shi3 >>> 4;
        const t2shi5 = t1shi3 << 28 | t1slo3 >>> 4;
        const t2slo21 = t1shi8 << 23 | t1slo8 >>> 9;
        const t2shi21 = t1slo8 << 23 | t1shi8 >>> 9;
        const t2slo12 = t1slo13 << 25 | t1shi13 >>> 7;
        const t2shi12 = t1shi13 << 25 | t1slo13 >>> 7;
        const t2slo3 = t1slo18 << 21 | t1shi18 >>> 11;
        const t2shi3 = t1shi18 << 21 | t1slo18 >>> 11;
        const t2slo19 = t1shi23 << 24 | t1slo23 >>> 8;
        const t2shi19 = t1slo23 << 24 | t1shi23 >>> 8;
        const t2slo15 = t1slo4 << 27 | t1shi4 >>> 5;
        const t2shi15 = t1shi4 << 27 | t1slo4 >>> 5;
        const t2slo6 = t1slo9 << 20 | t1shi9 >>> 12;
        const t2shi6 = t1shi9 << 20 | t1slo9 >>> 12;
        const t2slo22 = t1shi14 << 7 | t1slo14 >>> 25;
        const t2shi22 = t1slo14 << 7 | t1shi14 >>> 25;
        const t2slo13 = t1slo19 << 8 | t1shi19 >>> 24;
        const t2shi13 = t1shi19 << 8 | t1slo19 >>> 24;
        const t2slo4 = t1slo24 << 14 | t1shi24 >>> 18;
        const t2shi4 = t1shi24 << 14 | t1slo24 >>> 18;
        // chi
        s[0] = t2slo0 ^ ~t2slo1 & t2slo2;
        s[1] = t2shi0 ^ ~t2shi1 & t2shi2;
        s[10] = t2slo5 ^ ~t2slo6 & t2slo7;
        s[11] = t2shi5 ^ ~t2shi6 & t2shi7;
        s[20] = t2slo10 ^ ~t2slo11 & t2slo12;
        s[21] = t2shi10 ^ ~t2shi11 & t2shi12;
        s[30] = t2slo15 ^ ~t2slo16 & t2slo17;
        s[31] = t2shi15 ^ ~t2shi16 & t2shi17;
        s[40] = t2slo20 ^ ~t2slo21 & t2slo22;
        s[41] = t2shi20 ^ ~t2shi21 & t2shi22;
        s[2] = t2slo1 ^ ~t2slo2 & t2slo3;
        s[3] = t2shi1 ^ ~t2shi2 & t2shi3;
        s[12] = t2slo6 ^ ~t2slo7 & t2slo8;
        s[13] = t2shi6 ^ ~t2shi7 & t2shi8;
        s[22] = t2slo11 ^ ~t2slo12 & t2slo13;
        s[23] = t2shi11 ^ ~t2shi12 & t2shi13;
        s[32] = t2slo16 ^ ~t2slo17 & t2slo18;
        s[33] = t2shi16 ^ ~t2shi17 & t2shi18;
        s[42] = t2slo21 ^ ~t2slo22 & t2slo23;
        s[43] = t2shi21 ^ ~t2shi22 & t2shi23;
        s[4] = t2slo2 ^ ~t2slo3 & t2slo4;
        s[5] = t2shi2 ^ ~t2shi3 & t2shi4;
        s[14] = t2slo7 ^ ~t2slo8 & t2slo9;
        s[15] = t2shi7 ^ ~t2shi8 & t2shi9;
        s[24] = t2slo12 ^ ~t2slo13 & t2slo14;
        s[25] = t2shi12 ^ ~t2shi13 & t2shi14;
        s[34] = t2slo17 ^ ~t2slo18 & t2slo19;
        s[35] = t2shi17 ^ ~t2shi18 & t2shi19;
        s[44] = t2slo22 ^ ~t2slo23 & t2slo24;
        s[45] = t2shi22 ^ ~t2shi23 & t2shi24;
        s[6] = t2slo3 ^ ~t2slo4 & t2slo0;
        s[7] = t2shi3 ^ ~t2shi4 & t2shi0;
        s[16] = t2slo8 ^ ~t2slo9 & t2slo5;
        s[17] = t2shi8 ^ ~t2shi9 & t2shi5;
        s[26] = t2slo13 ^ ~t2slo14 & t2slo10;
        s[27] = t2shi13 ^ ~t2shi14 & t2shi10;
        s[36] = t2slo18 ^ ~t2slo19 & t2slo15;
        s[37] = t2shi18 ^ ~t2shi19 & t2shi15;
        s[46] = t2slo23 ^ ~t2slo24 & t2slo20;
        s[47] = t2shi23 ^ ~t2shi24 & t2shi20;
        s[8] = t2slo4 ^ ~t2slo0 & t2slo1;
        s[9] = t2shi4 ^ ~t2shi0 & t2shi1;
        s[18] = t2slo9 ^ ~t2slo5 & t2slo6;
        s[19] = t2shi9 ^ ~t2shi5 & t2shi6;
        s[28] = t2slo14 ^ ~t2slo10 & t2slo11;
        s[29] = t2shi14 ^ ~t2shi10 & t2shi11;
        s[38] = t2slo19 ^ ~t2slo15 & t2slo16;
        s[39] = t2shi19 ^ ~t2shi15 & t2shi16;
        s[48] = t2slo24 ^ ~t2slo20 & t2slo21;
        s[49] = t2shi24 ^ ~t2shi20 & t2shi21;
        // iota
        s[0] ^= $20b9225e11970988$var$P1600_ROUND_CONSTANTS[round * 2];
        s[1] ^= $20b9225e11970988$var$P1600_ROUND_CONSTANTS[round * 2 + 1];
    }
};

});




parcelRegister("1R2J7", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, 'digest');
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $loYLU();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("loYLU", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("eLdEM", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $b6RFW = parcelRequire("b6RFW");
var $abf00c68ae11d39d$require$Transform = $b6RFW.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
}
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(data, 'Data');
    if (this._finalized) throw new Error('Digest already called');
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(data)) data = $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});
parcelRegister("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

exports.finished = (parcelRequire("fiCvv"));

exports.pipeline = (parcelRequire("aGSwO"));

});



parcelRegister("a8qBR", function(module, exports) {
'use strict';

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRegister("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRegister("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === 'string') data = $187e9d8dfda3dbba$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error('can\'t switch encodings');
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});



parcelRegister("eLj8Y", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $abf44dff9428eb2b$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $abf44dff9428eb2b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toType = module.exports.TypeOutput = module.exports.bnToRlp = module.exports.bnToUnpaddedBuffer = module.exports.bnToHex = void 0;

var $abf44dff9428eb2b$var$bn_js_1 = $abf44dff9428eb2b$var$__importDefault((parcelRequire("dEXSZ")));

var $aj8Qm = parcelRequire("aj8Qm");

var $b61lJ = parcelRequire("b61lJ");
/**
 * Convert BN to 0x-prefixed hex string.
 */ function $abf44dff9428eb2b$var$bnToHex(value) {
    return "0x" + value.toString(16);
}
module.exports.bnToHex = $abf44dff9428eb2b$var$bnToHex;
/**
 * Convert value from BN to an unpadded Buffer
 * (useful for RLP transport)
 * @param value value to convert
 */ function $abf44dff9428eb2b$var$bnToUnpaddedBuffer(value) {
    // Using `bn.toArrayLike(Buffer)` instead of `bn.toBuffer()`
    // for compatibility with browserify and similar tools
    return (0, $b61lJ.unpadBuffer)(value.toArrayLike($abf44dff9428eb2b$require$Buffer));
}
module.exports.bnToUnpaddedBuffer = $abf44dff9428eb2b$var$bnToUnpaddedBuffer;
/**
 * Deprecated alias for {@link bnToUnpaddedBuffer}
 * @deprecated
 */ function $abf44dff9428eb2b$var$bnToRlp(value) {
    return $abf44dff9428eb2b$var$bnToUnpaddedBuffer(value);
}
module.exports.bnToRlp = $abf44dff9428eb2b$var$bnToRlp;
/**
 * Type output options
 */ var $abf44dff9428eb2b$var$TypeOutput;
(function(TypeOutput) {
    TypeOutput[TypeOutput["Number"] = 0] = "Number";
    TypeOutput[TypeOutput["BN"] = 1] = "BN";
    TypeOutput[TypeOutput["Buffer"] = 2] = "Buffer";
    TypeOutput[TypeOutput["PrefixedHexString"] = 3] = "PrefixedHexString";
})($abf44dff9428eb2b$var$TypeOutput = module.exports.TypeOutput || (module.exports.TypeOutput = {}));
function $abf44dff9428eb2b$var$toType(input, outputType) {
    if (input === null) return null;
    if (input === undefined) return undefined;
    if (typeof input === 'string' && !(0, $aj8Qm.isHexString)(input)) throw new Error("A string must be provided with a 0x-prefix, given: " + input);
    else if (typeof input === 'number' && !Number.isSafeInteger(input)) throw new Error('The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)');
    var output = (0, $b61lJ.toBuffer)(input);
    if (outputType === $abf44dff9428eb2b$var$TypeOutput.Buffer) return output;
    else if (outputType === $abf44dff9428eb2b$var$TypeOutput.BN) return new $abf44dff9428eb2b$var$bn_js_1.default(output);
    else if (outputType === $abf44dff9428eb2b$var$TypeOutput.Number) {
        var bn = new $abf44dff9428eb2b$var$bn_js_1.default(output);
        var max = new $abf44dff9428eb2b$var$bn_js_1.default(Number.MAX_SAFE_INTEGER.toString());
        if (bn.gt(max)) throw new Error('The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)');
        return bn.toNumber();
    } else // outputType === TypeOutput.PrefixedHexString
    return "0x" + output.toString('hex');
}
module.exports.toType = $abf44dff9428eb2b$var$toType;

});


parcelRegister("aSXhg", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $7eccedcfb056007a$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $7eccedcfb056007a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Address = void 0;

var $7eccedcfb056007a$var$assert_1 = $7eccedcfb056007a$var$__importDefault((parcelRequire("aLUwE")));

var $7eccedcfb056007a$var$bn_js_1 = $7eccedcfb056007a$var$__importDefault((parcelRequire("dEXSZ")));

var $b61lJ = parcelRequire("b61lJ");

var $idiNS = parcelRequire("idiNS");
var $7eccedcfb056007a$var$Address = /** @class */ function() {
    function Address(buf) {
        (0, $7eccedcfb056007a$var$assert_1.default)(buf.length === 20, 'Invalid address length');
        this.buf = buf;
    }
    /**
     * Returns the zero address.
     */ Address.zero = function() {
        return new Address((0, $b61lJ.zeros)(20));
    };
    /**
     * Returns an Address object from a hex-encoded string.
     * @param str - Hex-encoded address
     */ Address.fromString = function(str) {
        (0, $7eccedcfb056007a$var$assert_1.default)((0, $idiNS.isValidAddress)(str), 'Invalid address');
        return new Address((0, $b61lJ.toBuffer)(str));
    };
    /**
     * Returns an address for a given public key.
     * @param pubKey The two points of an uncompressed key
     */ Address.fromPublicKey = function(pubKey) {
        (0, $7eccedcfb056007a$var$assert_1.default)($7eccedcfb056007a$require$Buffer.isBuffer(pubKey), 'Public key should be Buffer');
        var buf = (0, $idiNS.pubToAddress)(pubKey);
        return new Address(buf);
    };
    /**
     * Returns an address for a given private key.
     * @param privateKey A private key must be 256 bits wide
     */ Address.fromPrivateKey = function(privateKey) {
        (0, $7eccedcfb056007a$var$assert_1.default)($7eccedcfb056007a$require$Buffer.isBuffer(privateKey), 'Private key should be Buffer');
        var buf = (0, $idiNS.privateToAddress)(privateKey);
        return new Address(buf);
    };
    /**
     * Generates an address for a newly created contract.
     * @param from The address which is creating this new address
     * @param nonce The nonce of the from account
     */ Address.generate = function(from, nonce) {
        (0, $7eccedcfb056007a$var$assert_1.default)($7eccedcfb056007a$var$bn_js_1.default.isBN(nonce));
        return new Address((0, $idiNS.generateAddress)(from.buf, nonce.toArrayLike($7eccedcfb056007a$require$Buffer)));
    };
    /**
     * Generates an address for a contract created using CREATE2.
     * @param from The address which is creating this new address
     * @param salt A salt
     * @param initCode The init code of the contract being created
     */ Address.generate2 = function(from, salt, initCode) {
        (0, $7eccedcfb056007a$var$assert_1.default)($7eccedcfb056007a$require$Buffer.isBuffer(salt));
        (0, $7eccedcfb056007a$var$assert_1.default)($7eccedcfb056007a$require$Buffer.isBuffer(initCode));
        return new Address((0, $idiNS.generateAddress2)(from.buf, salt, initCode));
    };
    /**
     * Is address equal to another.
     */ Address.prototype.equals = function(address) {
        return this.buf.equals(address.buf);
    };
    /**
     * Is address zero.
     */ Address.prototype.isZero = function() {
        return this.equals(Address.zero());
    };
    /**
     * True if address is in the address range defined
     * by EIP-1352
     */ Address.prototype.isPrecompileOrSystemAddress = function() {
        var addressBN = new $7eccedcfb056007a$var$bn_js_1.default(this.buf);
        var rangeMin = new $7eccedcfb056007a$var$bn_js_1.default(0);
        var rangeMax = new $7eccedcfb056007a$var$bn_js_1.default('ffff', 'hex');
        return addressBN.gte(rangeMin) && addressBN.lte(rangeMax);
    };
    /**
     * Returns hex encoding of address.
     */ Address.prototype.toString = function() {
        return '0x' + this.buf.toString('hex');
    };
    /**
     * Returns Buffer representation of address.
     */ Address.prototype.toBuffer = function() {
        return $7eccedcfb056007a$require$Buffer.from(this.buf);
    };
    return Address;
}();
module.exports.Address = $7eccedcfb056007a$var$Address;

});

parcelRegister("67JT1", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $4756fda0b84972b4$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $4756fda0b84972b4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashPersonalMessage = module.exports.isValidSignature = module.exports.fromRpcSig = module.exports.toCompactSig = module.exports.toRpcSig = module.exports.ecrecover = module.exports.ecsign = void 0;

var $iET4t = parcelRequire("iET4t");

var $4756fda0b84972b4$var$bn_js_1 = $4756fda0b84972b4$var$__importDefault((parcelRequire("dEXSZ")));

var $b61lJ = parcelRequire("b61lJ");

var $gKSHR = parcelRequire("gKSHR");

var $7jIKp = parcelRequire("7jIKp");

var $eLj8Y = parcelRequire("eLj8Y");
function $4756fda0b84972b4$var$ecsign(msgHash, privateKey, chainId) {
    var _a = (0, $iET4t.ecdsaSign)(msgHash, privateKey), signature = _a.signature, recovery = _a.recid;
    var r = $4756fda0b84972b4$require$Buffer.from(signature.slice(0, 32));
    var s = $4756fda0b84972b4$require$Buffer.from(signature.slice(32, 64));
    if (!chainId || typeof chainId === 'number') {
        // return legacy type ECDSASignature (deprecated in favor of ECDSASignatureBuffer to handle large chainIds)
        if (chainId && !Number.isSafeInteger(chainId)) throw new Error('The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)');
        var v_1 = chainId ? recovery + (chainId * 2 + 35) : recovery + 27;
        return {
            r: r,
            s: s,
            v: v_1
        };
    }
    var chainIdBN = (0, $eLj8Y.toType)(chainId, $eLj8Y.TypeOutput.BN);
    var v = chainIdBN.muln(2).addn(35).addn(recovery).toArrayLike($4756fda0b84972b4$require$Buffer);
    return {
        r: r,
        s: s,
        v: v
    };
}
module.exports.ecsign = $4756fda0b84972b4$var$ecsign;
function $4756fda0b84972b4$var$calculateSigRecovery(v, chainId) {
    var vBN = (0, $eLj8Y.toType)(v, $eLj8Y.TypeOutput.BN);
    if (!chainId) return vBN.subn(27);
    var chainIdBN = (0, $eLj8Y.toType)(chainId, $eLj8Y.TypeOutput.BN);
    return vBN.sub(chainIdBN.muln(2).addn(35));
}
function $4756fda0b84972b4$var$isValidSigRecovery(recovery) {
    var rec = new $4756fda0b84972b4$var$bn_js_1.default(recovery);
    return rec.eqn(0) || rec.eqn(1);
}
/**
 * ECDSA public key recovery from signature.
 * @returns Recovered public key
 */ var $4756fda0b84972b4$var$ecrecover = function(msgHash, v, r, s, chainId) {
    var signature = $4756fda0b84972b4$require$Buffer.concat([
        (0, $b61lJ.setLengthLeft)(r, 32),
        (0, $b61lJ.setLengthLeft)(s, 32)
    ], 64);
    var recovery = $4756fda0b84972b4$var$calculateSigRecovery(v, chainId);
    if (!$4756fda0b84972b4$var$isValidSigRecovery(recovery)) throw new Error('Invalid signature v value');
    var senderPubKey = (0, $iET4t.ecdsaRecover)(signature, recovery.toNumber(), msgHash);
    return $4756fda0b84972b4$require$Buffer.from((0, $iET4t.publicKeyConvert)(senderPubKey, false).slice(1));
};
module.exports.ecrecover = $4756fda0b84972b4$var$ecrecover;
/**
 * Convert signature parameters into the format of `eth_sign` RPC method.
 * @returns Signature
 */ var $4756fda0b84972b4$var$toRpcSig = function(v, r, s, chainId) {
    var recovery = $4756fda0b84972b4$var$calculateSigRecovery(v, chainId);
    if (!$4756fda0b84972b4$var$isValidSigRecovery(recovery)) throw new Error('Invalid signature v value');
    // geth (and the RPC eth_sign method) uses the 65 byte format used by Bitcoin
    return (0, $b61lJ.bufferToHex)($4756fda0b84972b4$require$Buffer.concat([
        (0, $b61lJ.setLengthLeft)(r, 32),
        (0, $b61lJ.setLengthLeft)(s, 32),
        (0, $b61lJ.toBuffer)(v)
    ]));
};
module.exports.toRpcSig = $4756fda0b84972b4$var$toRpcSig;
/**
 * Convert signature parameters into the format of Compact Signature Representation (EIP-2098).
 * @returns Signature
 */ var $4756fda0b84972b4$var$toCompactSig = function(v, r, s, chainId) {
    var recovery = $4756fda0b84972b4$var$calculateSigRecovery(v, chainId);
    if (!$4756fda0b84972b4$var$isValidSigRecovery(recovery)) throw new Error('Invalid signature v value');
    var vn = (0, $eLj8Y.toType)(v, $eLj8Y.TypeOutput.Number);
    var ss = s;
    if (vn > 28 && vn % 2 === 1 || vn === 1 || vn === 28) {
        ss = $4756fda0b84972b4$require$Buffer.from(s);
        ss[0] |= 0x80;
    }
    return (0, $b61lJ.bufferToHex)($4756fda0b84972b4$require$Buffer.concat([
        (0, $b61lJ.setLengthLeft)(r, 32),
        (0, $b61lJ.setLengthLeft)(ss, 32)
    ]));
};
module.exports.toCompactSig = $4756fda0b84972b4$var$toCompactSig;
/**
 * Convert signature format of the `eth_sign` RPC method to signature parameters
 * NOTE: all because of a bug in geth: https://github.com/ethereum/go-ethereum/issues/2053
 */ var $4756fda0b84972b4$var$fromRpcSig = function(sig) {
    var buf = (0, $b61lJ.toBuffer)(sig);
    var r;
    var s;
    var v;
    if (buf.length >= 65) {
        r = buf.slice(0, 32);
        s = buf.slice(32, 64);
        v = (0, $b61lJ.bufferToInt)(buf.slice(64));
    } else if (buf.length === 64) {
        // Compact Signature Representation (https://eips.ethereum.org/EIPS/eip-2098)
        r = buf.slice(0, 32);
        s = buf.slice(32, 64);
        v = (0, $b61lJ.bufferToInt)(buf.slice(32, 33)) >> 7;
        s[0] &= 0x7f;
    } else throw new Error('Invalid signature length');
    // support both versions of `eth_sign` responses
    if (v < 27) v += 27;
    return {
        v: v,
        r: r,
        s: s
    };
};
module.exports.fromRpcSig = $4756fda0b84972b4$var$fromRpcSig;
/**
 * Validate a ECDSA signature.
 * @param homesteadOrLater Indicates whether this is being used on either the homestead hardfork or a later one
 */ var $4756fda0b84972b4$var$isValidSignature = function(v, r, s, homesteadOrLater, chainId) {
    if (homesteadOrLater === void 0) homesteadOrLater = true;
    var SECP256K1_N_DIV_2 = new $4756fda0b84972b4$var$bn_js_1.default('7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0', 16);
    var SECP256K1_N = new $4756fda0b84972b4$var$bn_js_1.default('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141', 16);
    if (r.length !== 32 || s.length !== 32) return false;
    if (!$4756fda0b84972b4$var$isValidSigRecovery($4756fda0b84972b4$var$calculateSigRecovery(v, chainId))) return false;
    var rBN = new $4756fda0b84972b4$var$bn_js_1.default(r);
    var sBN = new $4756fda0b84972b4$var$bn_js_1.default(s);
    if (rBN.isZero() || rBN.gt(SECP256K1_N) || sBN.isZero() || sBN.gt(SECP256K1_N)) return false;
    if (homesteadOrLater && sBN.cmp(SECP256K1_N_DIV_2) === 1) return false;
    return true;
};
module.exports.isValidSignature = $4756fda0b84972b4$var$isValidSignature;
/**
 * Returns the keccak-256 hash of `message`, prefixed with the header used by the `eth_sign` RPC call.
 * The output of this function can be fed into `ecsign` to produce the same signature as the `eth_sign`
 * call for a given `message`, or fed to `ecrecover` along with a signature to recover the public key
 * used to produce the signature.
 */ var $4756fda0b84972b4$var$hashPersonalMessage = function(message) {
    (0, $7jIKp.assertIsBuffer)(message);
    var prefix = $4756fda0b84972b4$require$Buffer.from("\u0019Ethereum Signed Message:\n" + message.length, 'utf-8');
    return (0, $gKSHR.keccak)($4756fda0b84972b4$require$Buffer.concat([
        prefix,
        message
    ]));
};
module.exports.hashPersonalMessage = $4756fda0b84972b4$var$hashPersonalMessage;

});

parcelRegister("cLPFP", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $94c1f52609770e02$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $94c1f52609770e02$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $94c1f52609770e02$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $94c1f52609770e02$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $94c1f52609770e02$var$__createBinding(result, mod, k);
    }
    $94c1f52609770e02$var$__setModuleDefault(result, mod);
    return result;
};
var $94c1f52609770e02$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defineProperties = void 0;

var $94c1f52609770e02$var$assert_1 = $94c1f52609770e02$var$__importDefault((parcelRequire("aLUwE")));

var $aj8Qm = parcelRequire("aj8Qm");

var $94c1f52609770e02$var$rlp = $94c1f52609770e02$var$__importStar((parcelRequire("g16XK")));

var $b61lJ = parcelRequire("b61lJ");
/**
 * Defines properties on a `Object`. It make the assumption that underlying data is binary.
 * @param self the `Object` to define properties on
 * @param fields an array fields to define. Fields can contain:
 * * `name` - the name of the properties
 * * `length` - the number of bytes the field can have
 * * `allowLess` - if the field can be less than the length
 * * `allowEmpty`
 * @param data data to be validated against the definitions
 * @deprecated
 */ var $94c1f52609770e02$var$defineProperties = function(self, fields, data) {
    self.raw = [];
    self._fields = [];
    // attach the `toJSON`
    self.toJSON = function(label) {
        if (label === void 0) label = false;
        if (label) {
            var obj_1 = {};
            self._fields.forEach(function(field) {
                obj_1[field] = "0x" + self[field].toString('hex');
            });
            return obj_1;
        }
        return (0, $b61lJ.baToJSON)(self.raw);
    };
    self.serialize = function serialize() {
        return $94c1f52609770e02$var$rlp.encode(self.raw);
    };
    fields.forEach(function(field, i) {
        self._fields.push(field.name);
        function getter() {
            return self.raw[i];
        }
        function setter(v) {
            v = (0, $b61lJ.toBuffer)(v);
            if (v.toString('hex') === '00' && !field.allowZero) v = $94c1f52609770e02$require$Buffer.allocUnsafe(0);
            if (field.allowLess && field.length) {
                v = (0, $b61lJ.unpadBuffer)(v);
                (0, $94c1f52609770e02$var$assert_1.default)(field.length >= v.length, "The field " + field.name + " must not have more " + field.length + " bytes");
            } else if (!(field.allowZero && v.length === 0) && field.length) (0, $94c1f52609770e02$var$assert_1.default)(field.length === v.length, "The field " + field.name + " must have byte length of " + field.length);
            self.raw[i] = v;
        }
        Object.defineProperty(self, field.name, {
            enumerable: true,
            configurable: true,
            get: getter,
            set: setter
        });
        if (field.default) self[field.name] = field.default;
        // attach alias
        if (field.alias) Object.defineProperty(self, field.alias, {
            enumerable: false,
            configurable: true,
            set: setter,
            get: getter
        });
    });
    // if the constuctor is passed data
    if (data) {
        if (typeof data === 'string') data = $94c1f52609770e02$require$Buffer.from((0, $aj8Qm.stripHexPrefix)(data), 'hex');
        if ($94c1f52609770e02$require$Buffer.isBuffer(data)) data = $94c1f52609770e02$var$rlp.decode(data);
        if (Array.isArray(data)) {
            if (data.length > self._fields.length) throw new Error('wrong number of fields in data');
            // make sure all the items are buffers
            data.forEach(function(d, i) {
                self[self._fields[i]] = (0, $b61lJ.toBuffer)(d);
            });
        } else if (typeof data === 'object') {
            var keys_1 = Object.keys(data);
            fields.forEach(function(field) {
                if (keys_1.indexOf(field.name) !== -1) self[field.name] = data[field.name];
                if (keys_1.indexOf(field.alias) !== -1) self[field.alias] = data[field.alias];
            });
        } else throw new Error('invalid data');
    }
};
module.exports.defineProperties = $94c1f52609770e02$var$defineProperties;

});

parcelRegister("4jhio", function(module, exports) {
"use strict";
/**
 * Re-exports commonly used modules:
 * * Exports [`BN`](https://github.com/indutny/bn.js), [`rlp`](https://github.com/ethereumjs/rlp).
 * @packageDocumentation
 */ var $32365a58f62e9fb8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $32365a58f62e9fb8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $32365a58f62e9fb8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $32365a58f62e9fb8$var$__createBinding(result, mod, k);
    }
    $32365a58f62e9fb8$var$__setModuleDefault(result, mod);
    return result;
};
var $32365a58f62e9fb8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rlp = module.exports.BN = void 0;

var $32365a58f62e9fb8$var$bn_js_1 = $32365a58f62e9fb8$var$__importDefault((parcelRequire("dEXSZ")));
module.exports.BN = $32365a58f62e9fb8$var$bn_js_1.default;

var $32365a58f62e9fb8$var$rlp = $32365a58f62e9fb8$var$__importStar((parcelRequire("g16XK")));
module.exports.rlp = $32365a58f62e9fb8$var$rlp;

});


parcelRegister("36d7k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h9flZ = parcelRequire("h9flZ");
/**
 * Returns true if the bloom is a valid bloom
 * @param bloom The bloom
 */ function $241c1b70d6ad639f$var$isBloom(bloom) {
    if (typeof bloom !== 'string') return false;
    if (!/^(0x)?[0-9a-f]{512}$/i.test(bloom)) return false;
    if (/^(0x)?[0-9a-f]{512}$/.test(bloom) || /^(0x)?[0-9A-F]{512}$/.test(bloom)) return true;
    return false;
}
module.exports.isBloom = $241c1b70d6ad639f$var$isBloom;
/**
 * Returns true if the value is part of the given bloom
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param value The value
 */ function $241c1b70d6ad639f$var$isInBloom(bloom, value) {
    if (typeof value === 'object' && value.constructor === Uint8Array) value = $h9flZ.bytesToHex(value);
    const hash = $h9flZ.keccak256(value).replace('0x', '');
    for(let i = 0; i < 12; i += 4){
        // calculate bit position in bloom filter that must be active
        const bitpos = (parseInt(hash.substr(i, 2), 16) << 8) + parseInt(hash.substr(i + 2, 2), 16) & 2047;
        // test if bitpos in bloom is active
        const code = $241c1b70d6ad639f$var$codePointToInt(bloom.charCodeAt(bloom.length - 1 - Math.floor(bitpos / 4)));
        const offset = 1 << bitpos % 4;
        if ((code & offset) !== offset) return false;
    }
    return true;
}
module.exports.isInBloom = $241c1b70d6ad639f$var$isInBloom;
/**
 * Code points to int
 * @param codePoint The code point
 */ function $241c1b70d6ad639f$var$codePointToInt(codePoint) {
    if (codePoint >= 48 && codePoint <= 57) /* ['0'..'9'] -> [0..9] */ return codePoint - 48;
    if (codePoint >= 65 && codePoint <= 70) /* ['A'..'F'] -> [10..15] */ return codePoint - 55;
    if (codePoint >= 97 && codePoint <= 102) /* ['a'..'f'] -> [10..15] */ return codePoint - 87;
    throw new Error('invalid bloom');
}
/**
 * Returns true if the ethereum users address is part of the given bloom.
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param address the address to test
 */ function $241c1b70d6ad639f$var$isUserEthereumAddressInBloom(bloom, ethereumAddress) {
    if (!$241c1b70d6ad639f$var$isBloom(bloom)) throw new Error('Invalid bloom given');
    if (!$241c1b70d6ad639f$var$isAddress(ethereumAddress)) throw new Error(`Invalid ethereum address given: "${ethereumAddress}"`);
    // you have to pad the ethereum address to 32 bytes
    // else the bloom filter does not work
    // this is only if your matching the USERS
    // ethereum address. Contract address do not need this
    // hence why we have 2 methods
    // (0x is not in the 2nd parameter of padleft so 64 chars is fine)
    const address = $h9flZ.padLeft(ethereumAddress, 64);
    return $241c1b70d6ad639f$var$isInBloom(bloom, address);
}
module.exports.isUserEthereumAddressInBloom = $241c1b70d6ad639f$var$isUserEthereumAddressInBloom;
/**
 * Returns true if the contract address is part of the given bloom.
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param contractAddress the contract address to test
 */ function $241c1b70d6ad639f$var$isContractAddressInBloom(bloom, contractAddress) {
    if (!$241c1b70d6ad639f$var$isBloom(bloom)) throw new Error('Invalid bloom given');
    if (!$241c1b70d6ad639f$var$isAddress(contractAddress)) throw new Error(`Invalid contract address given: "${contractAddress}"`);
    return $241c1b70d6ad639f$var$isInBloom(bloom, contractAddress);
}
module.exports.isContractAddressInBloom = $241c1b70d6ad639f$var$isContractAddressInBloom;
/**
 * Returns true if the topic is part of the given bloom.
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param topic the topic encoded hex
 */ function $241c1b70d6ad639f$var$isTopicInBloom(bloom, topic) {
    if (!$241c1b70d6ad639f$var$isBloom(bloom)) throw new Error('Invalid bloom given');
    if (!$241c1b70d6ad639f$var$isTopic(topic)) throw new Error('Invalid topic');
    return $241c1b70d6ad639f$var$isInBloom(bloom, topic);
}
module.exports.isTopicInBloom = $241c1b70d6ad639f$var$isTopicInBloom;
/**
 * Checks if its a valid topic
 * @param topic encoded hex topic
 */ function $241c1b70d6ad639f$var$isTopic(topic) {
    if (typeof topic !== 'string') return false;
    if (!/^(0x)?[0-9a-f]{64}$/i.test(topic)) return false;
    else if (/^(0x)?[0-9a-f]{64}$/.test(topic) || /^(0x)?[0-9A-F]{64}$/.test(topic)) return true;
    return false;
}
module.exports.isTopic = $241c1b70d6ad639f$var$isTopic;
/**
 * Is valid address
 * @param address The address
 */ function $241c1b70d6ad639f$var$isAddress(address) {
    if (typeof address !== 'string') return false;
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) return true;
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) return true;
    return false;
}
module.exports.isAddress = $241c1b70d6ad639f$var$isAddress;

});
parcelRegister("h9flZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1IGmO = parcelRequire("1IGmO");
/**
 * Keccak256 hash
 * @param data The data
 */ function $c7bf2fe088bee087$var$keccak256(data) {
    return '0x' + $1IGmO.keccak_256($c7bf2fe088bee087$var$toByteArray(data));
}
module.exports.keccak256 = $c7bf2fe088bee087$var$keccak256;
/**
 * Adding padding to string on the left
 * @param value The value
 * @param chars The chars
 */ module.exports.padLeft = (value, chars)=>{
    const hasPrefix = /^0x/i.test(value) || typeof value === 'number';
    value = value.toString().replace(/^0x/i, '');
    const padding = chars - value.length + 1 >= 0 ? chars - value.length + 1 : 0;
    return (hasPrefix ? '0x' : '') + new Array(padding).join('0') + value;
};
/**
 * Convert bytes to hex
 * @param bytes The bytes
 */ function $c7bf2fe088bee087$var$bytesToHex(bytes) {
    const hex = [];
    for(let i = 0; i < bytes.length; i++){
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xf).toString(16));
    }
    return `0x${hex.join('').replace(/^0+/, '')}`;
}
module.exports.bytesToHex = $c7bf2fe088bee087$var$bytesToHex;
/**
 * To byte array
 * @param value The value
 */ function $c7bf2fe088bee087$var$toByteArray(value) {
    if (value == null) throw new Error('cannot convert null value to array');
    if (typeof value === 'string') {
        const match = value.match(/^(0x)?[0-9a-fA-F]*$/);
        if (!match) throw new Error('invalid hexidecimal string');
        if (match[1] !== '0x') throw new Error('hex string must have 0x prefix');
        value = value.substring(2);
        if (value.length % 2) value = '0' + value;
        const result = [];
        for(let i = 0; i < value.length; i += 2)result.push(parseInt(value.substr(i, 2), 16));
        return $c7bf2fe088bee087$var$addSlice(new Uint8Array(result));
    }
    if ($c7bf2fe088bee087$var$isByteArray(value)) return $c7bf2fe088bee087$var$addSlice(new Uint8Array(value));
    throw new Error('invalid arrayify value');
}
module.exports.toByteArray = $c7bf2fe088bee087$var$toByteArray;
/**
 * Is byte array
 * @param value The value
 */ function $c7bf2fe088bee087$var$isByteArray(value) {
    if (!value || // tslint:disable-next-line: radix
    parseInt(String(value.length)) != value.length || typeof value === 'string') return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        // tslint:disable-next-line: radix
        if (v < 0 || v >= 256 || parseInt(String(v)) != v) return false;
    }
    return true;
}
/**
 * Add slice to array
 * @param array The array
 */ function $c7bf2fe088bee087$var$addSlice(array) {
    if (array.slice !== undefined) return array;
    array.slice = ()=>{
        const args = Array.prototype.slice.call(arguments);
        return $c7bf2fe088bee087$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}

});
parcelRegister("1IGmO", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var INPUT_ERROR = 'input is invalid type';
    var FINALIZE_ERROR = 'finalize already called';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $hPtJY === 'object' && $hPtJY.versions && $hPtJY.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        'hex',
        'buffer',
        'arrayBuffer',
        'array',
        'digest'
    ];
    var CSHAKE_BYTEPAD = {
        '128': 168,
        '256': 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods['cshake' + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods['kmac' + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, 'hex');
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, 'hex');
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, 'hex');
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods['shake' + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, 'hex');
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                'KMAC',
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: 'keccak',
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: 'sha3',
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: 'shake',
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: 'cshake',
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: 'kmac',
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + '_' + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== 'sha3') {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== 'string') {
            if (type === 'object') {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = '', block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});




parcelRegister("gQOic", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file soliditySha3.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ 
var $9WenL = parcelRequire("9WenL");

var $eNPzt = parcelRequire("eNPzt");
var $c44883bae11db1a7$var$_elementaryName = function(name) {
    /*jshint maxcomplexity:false */ if (name.startsWith('int[')) return 'int256' + name.slice(3);
    else if (name === 'int') return 'int256';
    else if (name.startsWith('uint[')) return 'uint256' + name.slice(4);
    else if (name === 'uint') return 'uint256';
    else if (name.startsWith('fixed[')) return 'fixed128x128' + name.slice(5);
    else if (name === 'fixed') return 'fixed128x128';
    else if (name.startsWith('ufixed[')) return 'ufixed128x128' + name.slice(6);
    else if (name === 'ufixed') return 'ufixed128x128';
    return name;
};
// Parse N from type<N>
var $c44883bae11db1a7$var$_parseTypeN = function(type) {
    var typesize = /^\D+(\d+).*$/.exec(type);
    return typesize ? parseInt(typesize[1], 10) : null;
};
// Parse N from type[<N>]
var $c44883bae11db1a7$var$_parseTypeNArray = function(type) {
    var arraySize = /^\D+\d*\[(\d+)\]$/.exec(type);
    return arraySize ? parseInt(arraySize[1], 10) : null;
};
var $c44883bae11db1a7$var$_parseNumber = function(arg) {
    var type = typeof arg;
    if (type === 'string') {
        if ($eNPzt.isHexStrict(arg)) return new $9WenL(arg.replace(/0x/i, ''), 16);
        else return new $9WenL(arg, 10);
    } else if (type === 'number') return new $9WenL(arg);
    else if ($eNPzt.isBigNumber(arg)) return new $9WenL(arg.toString(10));
    else if ($eNPzt.isBN(arg)) return arg;
    else throw new Error(arg + ' is not a number');
};
var $c44883bae11db1a7$var$_solidityPack = function(type, value, arraySize) {
    /*jshint maxcomplexity:false */ var size, num;
    type = $c44883bae11db1a7$var$_elementaryName(type);
    if (type === 'bytes') {
        if (value.replace(/^0x/i, '').length % 2 !== 0) throw new Error('Invalid bytes characters ' + value.length);
        return value;
    } else if (type === 'string') return $eNPzt.utf8ToHex(value);
    else if (type === 'bool') return value ? '01' : '00';
    else if (type.startsWith('address')) {
        if (arraySize) size = 64;
        else size = 40;
        if (!$eNPzt.isAddress(value)) throw new Error(value + ' is not a valid address, or the checksum is invalid.');
        return $eNPzt.leftPad(value.toLowerCase(), size);
    }
    size = $c44883bae11db1a7$var$_parseTypeN(type);
    if (type.startsWith('bytes')) {
        if (!size) throw new Error('bytes[] not yet supported in solidity');
        // must be 32 byte slices when in an array
        if (arraySize) size = 32;
        if (size < 1 || size > 32 || size < value.replace(/^0x/i, '').length / 2) throw new Error('Invalid bytes' + size + ' for ' + value);
        return $eNPzt.rightPad(value, size * 2);
    } else if (type.startsWith('uint')) {
        if (size % 8 || size < 8 || size > 256) throw new Error('Invalid uint' + size + ' size');
        num = $c44883bae11db1a7$var$_parseNumber(value);
        if (num.bitLength() > size) throw new Error('Supplied uint exceeds width: ' + size + ' vs ' + num.bitLength());
        if (num.lt(new $9WenL(0))) throw new Error('Supplied uint ' + num.toString() + ' is negative');
        return size ? $eNPzt.leftPad(num.toString('hex'), size / 8 * 2) : num;
    } else if (type.startsWith('int')) {
        if (size % 8 || size < 8 || size > 256) throw new Error('Invalid int' + size + ' size');
        num = $c44883bae11db1a7$var$_parseNumber(value);
        if (num.bitLength() > size) throw new Error('Supplied int exceeds width: ' + size + ' vs ' + num.bitLength());
        if (num.lt(new $9WenL(0))) return num.toTwos(size).toString('hex');
        else return size ? $eNPzt.leftPad(num.toString('hex'), size / 8 * 2) : num;
    } else // FIXME: support all other types
    throw new Error('Unsupported or invalid type: ' + type);
};
var $c44883bae11db1a7$var$_processSolidityEncodePackedArgs = function(arg) {
    /*jshint maxcomplexity:false */ if (Array.isArray(arg)) throw new Error('Autodetection of array types is not supported.');
    var type, value = '';
    var hexArg, arraySize;
    // if type is given
    if (!!arg && typeof arg === 'object' && (arg.hasOwnProperty('v') || arg.hasOwnProperty('t') || arg.hasOwnProperty('value') || arg.hasOwnProperty('type'))) {
        type = arg.hasOwnProperty('t') ? arg.t : arg.type;
        value = arg.hasOwnProperty('v') ? arg.v : arg.value;
    // otherwise try to guess the type
    } else {
        type = $eNPzt.toHex(arg, true);
        value = $eNPzt.toHex(arg);
        if (!type.startsWith('int') && !type.startsWith('uint')) type = 'bytes';
    }
    if ((type.startsWith('int') || type.startsWith('uint')) && typeof value === 'string' && !/^(-)?0x/i.test(value)) value = new $9WenL(value);
    // get the array size
    if (Array.isArray(value)) {
        arraySize = $c44883bae11db1a7$var$_parseTypeNArray(type);
        if (arraySize && value.length !== arraySize) throw new Error(type + ' is not matching the given array ' + JSON.stringify(value));
        else arraySize = value.length;
    }
    if (Array.isArray(value)) {
        hexArg = value.map(function(val) {
            return $c44883bae11db1a7$var$_solidityPack(type, val, arraySize).toString('hex').replace('0x', '');
        });
        return hexArg.join('');
    } else {
        hexArg = $c44883bae11db1a7$var$_solidityPack(type, value, arraySize);
        return hexArg.toString('hex').replace('0x', '');
    }
};
/**
 * Hashes solidity values to a sha3 hash using keccak 256
 *
 * @method soliditySha3
 * @return {Object} the sha3
 */ var $c44883bae11db1a7$var$soliditySha3 = function() {
    /*jshint maxcomplexity:false */ var args = Array.prototype.slice.call(arguments);
    var hexArgs = args.map($c44883bae11db1a7$var$_processSolidityEncodePackedArgs);
    // console.log(args, hexArgs);
    // console.log('0x'+ hexArgs.join(''));
    return $eNPzt.sha3('0x' + hexArgs.join(''));
};
/**
 * Hashes solidity values to a sha3 hash using keccak 256 but does return the hash of value `null` instead of `null`
 *
 * @method soliditySha3Raw
 * @return {Object} the sha3
 */ var $c44883bae11db1a7$var$soliditySha3Raw = function() {
    return $eNPzt.sha3Raw('0x' + Array.prototype.slice.call(arguments).map($c44883bae11db1a7$var$_processSolidityEncodePackedArgs).join(''));
};
/**
 * Encode packed args to hex
 *
 * @method encodePacked
 * @return {String} the hex encoded arguments
 */ var $c44883bae11db1a7$var$encodePacked = function() {
    /*jshint maxcomplexity:false */ var args = Array.prototype.slice.call(arguments);
    var hexArgs = args.map($c44883bae11db1a7$var$_processSolidityEncodePackedArgs);
    return '0x' + hexArgs.join('').toLowerCase();
};
module.exports = {
    soliditySha3: $c44883bae11db1a7$var$soliditySha3,
    soliditySha3Raw: $c44883bae11db1a7$var$soliditySha3Raw,
    encodePacked: $c44883bae11db1a7$var$encodePacked
};

});


parcelRegister("lyBXN", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file iban.js
 *
 * Details: https://github.com/ethereum/wiki/wiki/ICAP:-Inter-exchange-Client-Address-Protocol
 *
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2015
 */ "use strict";

var $9y1Dl = parcelRequire("9y1Dl");

var $1G8sK = parcelRequire("1G8sK");
const $fb1a38b1e24c50cb$var$leftPad = function(string, bytes) {
    let result = string;
    while(result.length < bytes * 2)result = '0' + result;
    return result;
};
/**
 * Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
 * numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
 *
 * @method iso13616Prepare
 * @param {String} iban the IBAN
 * @returns {String} the prepared IBAN
 */ const $fb1a38b1e24c50cb$var$iso13616Prepare = function(iban) {
    const A = 'A'.charCodeAt(0);
    const Z = 'Z'.charCodeAt(0);
    iban = iban.toUpperCase();
    iban = iban.substr(4) + iban.substr(0, 4);
    return iban.split('').map(function(n) {
        const code = n.charCodeAt(0);
        if (code >= A && code <= Z) // A = 10, B = 11, ... Z = 35
        return code - A + 10;
        else return n;
    }).join('');
};
/**
 * Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
 *
 * @method mod9710
 * @param {String} iban
 * @returns {Number}
 */ const $fb1a38b1e24c50cb$var$mod9710 = function(iban) {
    let remainder = iban;
    let block;
    while(remainder.length > 2){
        block = remainder.slice(0, 9);
        remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
    }
    return parseInt(remainder, 10) % 97;
};
/**
 * This prototype should be used to create iban object from iban correct string
 *
 * @param {String} iban
 */ class $fb1a38b1e24c50cb$var$Iban {
    constructor(iban){
        this._iban = iban;
    }
    /**
     * This method should be used to create an ethereum address from a direct iban address
     *
     * @method toAddress
     * @param {String} iban address
     * @return {String} the ethereum address
     */ static toAddress(ib) {
        ib = new $fb1a38b1e24c50cb$var$Iban(ib);
        if (!ib.isDirect()) throw new Error('IBAN is indirect and can\'t be converted');
        return ib.toAddress();
    }
    /**
     * This method should be used to create iban address from an ethereum address
     *
     * @method toIban
     * @param {String} address
     * @return {String} the IBAN address
     */ static toIban(address) {
        return $fb1a38b1e24c50cb$var$Iban.fromAddress(address).toString();
    }
    /**
     * This method should be used to create iban object from an ethereum address
     *
     * @method fromAddress
     * @param {String} address
     * @return {Iban} the IBAN object
     */ static fromAddress(address) {
        if (!$9y1Dl.isAddress(address)) throw new Error('Provided address is not a valid address: ' + address);
        address = address.replace('0x', '').replace('0X', '');
        const asBn = new $1G8sK(address, 16);
        const base36 = asBn.toString(36);
        const padded = $fb1a38b1e24c50cb$var$leftPad(base36, 15);
        return $fb1a38b1e24c50cb$var$Iban.fromBban(padded.toUpperCase());
    }
    /**
     * Convert the passed BBAN to an IBAN for this country specification.
     * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
     * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
     *
     * @method fromBban
     * @param {String} bban the BBAN to convert to IBAN
     * @returns {Iban} the IBAN object
     */ static fromBban(bban) {
        const countryCode = 'XE';
        const remainder = $fb1a38b1e24c50cb$var$mod9710($fb1a38b1e24c50cb$var$iso13616Prepare(countryCode + '00' + bban));
        const checkDigit = ('0' + (98 - remainder)).slice(-2);
        return new $fb1a38b1e24c50cb$var$Iban(countryCode + checkDigit + bban);
    }
    /**
     * Should be used to create IBAN object for given institution and identifier
     *
     * @method createIndirect
     * @param {Object} options, required options are "institution" and "identifier"
     * @return {Iban} the IBAN object
     */ static createIndirect(options) {
        return $fb1a38b1e24c50cb$var$Iban.fromBban('ETH' + options.institution + options.identifier);
    }
    /**
     * This method should be used to check if given string is valid iban object
     *
     * @method isValid
     * @param {String} iban string
     * @return {Boolean} true if it is valid IBAN
     */ static isValid(iban) {
        const i = new $fb1a38b1e24c50cb$var$Iban(iban);
        return i.isValid();
    }
    /**
     * Should be called to check if iban is correct
     *
     * @method isValid
     * @returns {Boolean} true if it is, otherwise false
     */ isValid() {
        return /^XE[0-9]{2}(ETH[0-9A-Z]{13}|[0-9A-Z]{30,31})$/.test(this._iban) && $fb1a38b1e24c50cb$var$mod9710($fb1a38b1e24c50cb$var$iso13616Prepare(this._iban)) === 1;
    }
    /**
     * Should be called to check if iban number is direct
     *
     * @method isDirect
     * @returns {Boolean} true if it is, otherwise false
     */ isDirect() {
        return this._iban.length === 34 || this._iban.length === 35;
    }
    /**
     * Should be called to check if iban number if indirect
     *
     * @method isIndirect
     * @returns {Boolean} true if it is, otherwise false
     */ isIndirect() {
        return this._iban.length === 20;
    }
    /**
     * Should be called to get iban checksum
     * Uses the mod-97-10 checksumming protocol (ISO/IEC 7064:2003)
     *
     * @method checksum
     * @returns {String} checksum
     */ checksum() {
        return this._iban.substr(2, 2);
    }
    /**
     * Should be called to get institution identifier
     * eg. XREG
     *
     * @method institution
     * @returns {String} institution identifier
     */ institution() {
        return this.isIndirect() ? this._iban.substr(7, 4) : '';
    }
    /**
     * Should be called to get client identifier within institution
     * eg. GAVOFYORK
     *
     * @method client
     * @returns {String} client identifier
     */ client() {
        return this.isIndirect() ? this._iban.substr(11) : '';
    }
    /**
     * Should be called to get client direct address
     *
     * @method toAddress
     * @returns {String} ethereum address
     */ toAddress() {
        if (this.isDirect()) {
            const base36 = this._iban.substr(4);
            const asBn = new $1G8sK(base36, 36);
            return $9y1Dl.toChecksumAddress(asBn.toString(16, 20));
        }
        return '';
    }
    toString() {
        return this._iban;
    }
}
module.exports = $fb1a38b1e24c50cb$var$Iban;

});
parcelRegister("1G8sK", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});




parcelRegister("jemaa", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /** @file jsonrpc.js
 * @authors:
 *   Fabian Vogelsteller <fabian@ethereum.org>
 *   Marek Kotewicz <marek@ethdev.com>
 *   Aaron Kumavis <aaron@kumavis.me>
 * @date 2015
 */ "use strict";
// Initialize Jsonrpc as a simple object with utility functions.
var $e00084416683a54c$var$Jsonrpc = {
    messageId: 0
};
/**
 * Should be called to valid json create payload object
 *
 * @method toPayload
 * @param {Function} method of jsonrpc call, required
 * @param {Array} params, an array of method params, optional
 * @returns {Object} valid jsonrpc payload object
 */ $e00084416683a54c$var$Jsonrpc.toPayload = function(method, params) {
    if (!method) throw new Error('JSONRPC method should be specified for params: "' + JSON.stringify(params) + '"!');
    // advance message ID
    $e00084416683a54c$var$Jsonrpc.messageId++;
    return {
        jsonrpc: '2.0',
        id: $e00084416683a54c$var$Jsonrpc.messageId,
        method: method,
        params: params || []
    };
};
/**
 * Should be called to check if jsonrpc response is valid
 *
 * @method isValidResponse
 * @param {Object}
 * @returns {Boolean} true if response is valid, otherwise false
 */ $e00084416683a54c$var$Jsonrpc.isValidResponse = function(response) {
    return Array.isArray(response) ? response.every(validateSingleMessage) : validateSingleMessage(response);
    function validateSingleMessage(message) {
        return !!message && !message.error && message.jsonrpc === '2.0' && (typeof message.id === 'number' || typeof message.id === 'string') && message.result !== undefined; // only undefined is not valid json object
    }
};
/**
 * Should be called to create batch payload object
 *
 * @method toBatchPayload
 * @param {Array} messages, an array of objects with method (required) and params (optional) fields
 * @returns {Array} batch payload
 */ $e00084416683a54c$var$Jsonrpc.toBatchPayload = function(messages) {
    return messages.map(function(message) {
        return $e00084416683a54c$var$Jsonrpc.toPayload(message.method, message.params);
    });
};
module.exports = $e00084416683a54c$var$Jsonrpc;

});

parcelRegister("9rJ4f", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file batch.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */ "use strict";

var $jemaa = parcelRequire("jemaa");

var $hA2kM = parcelRequire("hA2kM");
var $6e099820de213161$require$errors = $hA2kM.errors;
var $6e099820de213161$var$Batch = function(requestManager) {
    this.requestManager = requestManager;
    this.requests = [];
};
/**
 * Should be called to add create new request to batch request
 *
 * @method add
 * @param {Object} jsonrpc requet object
 */ $6e099820de213161$var$Batch.prototype.add = function(request) {
    this.requests.push(request);
};
/**
 * Should be called to execute batch request
 *
 * @method execute
 */ $6e099820de213161$var$Batch.prototype.execute = function() {
    var requests = this.requests;
    var sortResponses = this._sortResponses.bind(this);
    this.requestManager.sendBatch(requests, function(err, results) {
        results = sortResponses(results);
        requests.map(function(request, index) {
            return results[index] || {};
        }).forEach(function(result, index) {
            if (requests[index].callback) {
                if (result && result.error) return requests[index].callback($6e099820de213161$require$errors.ErrorResponse(result));
                if (!$jemaa.isValidResponse(result)) return requests[index].callback($6e099820de213161$require$errors.InvalidResponse(result));
                try {
                    requests[index].callback(null, requests[index].format ? requests[index].format(result.result) : result.result);
                } catch (err) {
                    requests[index].callback(err);
                }
            }
        });
    });
};
// Sort responses
$6e099820de213161$var$Batch.prototype._sortResponses = function(responses) {
    return (responses || []).sort((a, b)=>a.id - b.id);
};
module.exports = $6e099820de213161$var$Batch;

});

parcelRegister("fIjTA", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file givenProvider.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";
var $b70a65ed8ab1b021$var$givenProvider = null;
// ADD GIVEN PROVIDER
/* jshint ignore:start */ var $b70a65ed8ab1b021$var$global;
try {
    $b70a65ed8ab1b021$var$global = Function('return this')();
} catch (e) {
    $b70a65ed8ab1b021$var$global = window;
}
// EIP-1193: window.ethereum
if (typeof $b70a65ed8ab1b021$var$global.ethereum !== 'undefined') $b70a65ed8ab1b021$var$givenProvider = $b70a65ed8ab1b021$var$global.ethereum;
else if (typeof $b70a65ed8ab1b021$var$global.web3 !== 'undefined' && $b70a65ed8ab1b021$var$global.web3.currentProvider) {
    if ($b70a65ed8ab1b021$var$global.web3.currentProvider.sendAsync) {
        $b70a65ed8ab1b021$var$global.web3.currentProvider.send = $b70a65ed8ab1b021$var$global.web3.currentProvider.sendAsync;
        delete $b70a65ed8ab1b021$var$global.web3.currentProvider.sendAsync;
    }
    // if connection is 'ipcProviderWrapper', add subscription support
    if (!$b70a65ed8ab1b021$var$global.web3.currentProvider.on && $b70a65ed8ab1b021$var$global.web3.currentProvider.connection && $b70a65ed8ab1b021$var$global.web3.currentProvider.connection.constructor.name === 'ipcProviderWrapper') $b70a65ed8ab1b021$var$global.web3.currentProvider.on = function(type, callback) {
        if (typeof callback !== 'function') throw new Error('The second parameter callback must be a function.');
        switch(type){
            case 'data':
                this.connection.on('data', function(data) {
                    var result = '';
                    data = data.toString();
                    try {
                        result = JSON.parse(data);
                    } catch (e) {
                        return callback(new Error('Couldn\'t parse response data' + data));
                    }
                    // notification
                    if (!result.id && result.method.indexOf('_subscription') !== -1) callback(null, result);
                });
                break;
            default:
                this.connection.on(type, callback);
                break;
        }
    };
    $b70a65ed8ab1b021$var$givenProvider = $b70a65ed8ab1b021$var$global.web3.currentProvider;
}
/* jshint ignore:end */ module.exports = $b70a65ed8ab1b021$var$givenProvider;

});

parcelRegister("4NExO", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file WebsocketProvider.js
 * @authors: Samuel Furter <samuel@ethereum.org>, Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2019
 */ 'use strict';

var $9Sw0q = parcelRequire("9Sw0q");

var $e3OPi = parcelRequire("e3OPi");

var $hA2kM = parcelRequire("hA2kM");
var $37eb3047409b608d$require$errors = $hA2kM.errors;

var $fC2qj = parcelRequire("fC2qj");
var $37eb3047409b608d$require$Ws = $fC2qj.w3cwebsocket;
/**
 * @param {string} url
 * @param {Object} options
 *
 * @constructor
 */ var $37eb3047409b608d$var$WebsocketProvider = function WebsocketProvider(url, options) {
    $9Sw0q.call(this);
    options = options || {};
    this.url = url;
    this._customTimeout = options.timeout || 15000;
    this.headers = options.headers || {};
    this.protocol = options.protocol || undefined;
    this.reconnectOptions = Object.assign({
        auto: false,
        delay: 5000,
        maxAttempts: false,
        onTimeout: false
    }, options.reconnect);
    this.clientConfig = options.clientConfig || undefined; // Allow a custom client configuration
    this.requestOptions = options.requestOptions || undefined; // Allow a custom request options (https://github.com/theturtle32/WebSocket-Node/blob/master/docs/WebSocketClient.md#connectrequesturl-requestedprotocols-origin-headers-requestoptions)
    this.DATA = 'data';
    this.CLOSE = 'close';
    this.ERROR = 'error';
    this.CONNECT = 'connect';
    this.RECONNECT = 'reconnect';
    this.connection = null;
    this.requestQueue = new Map();
    this.responseQueue = new Map();
    this.reconnectAttempts = 0;
    this.reconnecting = false;
    // The w3cwebsocket implementation does not support Basic Auth
    // username/password in the URL. So generate the basic auth header, and
    // pass through with any additional headers supplied in constructor
    var parsedURL = $e3OPi.parseURL(url);
    if (parsedURL.username && parsedURL.password) this.headers.authorization = 'Basic ' + $e3OPi.btoa(parsedURL.username + ':' + parsedURL.password);
    // When all node core implementations that do not have the
    // WHATWG compatible URL parser go out of service this line can be removed.
    if (parsedURL.auth) this.headers.authorization = 'Basic ' + $e3OPi.btoa(parsedURL.auth);
    // make property `connected` which will return the current connection status
    Object.defineProperty(this, 'connected', {
        get: function() {
            return this.connection && this.connection.readyState === this.connection.OPEN;
        },
        enumerable: true
    });
    this.connect();
};
// Inherit from EventEmitter
$37eb3047409b608d$var$WebsocketProvider.prototype = Object.create($9Sw0q.prototype);
$37eb3047409b608d$var$WebsocketProvider.prototype.constructor = $37eb3047409b608d$var$WebsocketProvider;
/**
 * Connects to the configured node
 *
 * @method connect
 *
 * @returns {void}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype.connect = function() {
    this.connection = new $37eb3047409b608d$require$Ws(this.url, this.protocol, undefined, this.headers, this.requestOptions, this.clientConfig);
    this._addSocketListeners();
};
/**
 * Listener for the `data` event of the underlying WebSocket object
 *
 * @method _onMessage
 *
 * @returns {void}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype._onMessage = function(e) {
    var _this = this;
    this._parseResponse(typeof e.data === 'string' ? e.data : '').forEach(function(result) {
        if (result.method && result.method.indexOf('_subscription') !== -1) {
            _this.emit(_this.DATA, result);
            return;
        }
        var id = result.id;
        // get the id which matches the returned id
        if (Array.isArray(result)) id = result[0].id;
        if (_this.responseQueue.has(id)) {
            if (_this.responseQueue.get(id).callback !== undefined) _this.responseQueue.get(id).callback(false, result);
            _this.responseQueue.delete(id);
        }
    });
};
/**
 * Listener for the `open` event of the underlying WebSocket object
 *
 * @method _onConnect
 *
 * @returns {void}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype._onConnect = function() {
    this.emit(this.CONNECT);
    this.reconnectAttempts = 0;
    this.reconnecting = false;
    if (this.requestQueue.size > 0) {
        var _this = this;
        this.requestQueue.forEach(function(request, key) {
            _this.send(request.payload, request.callback);
            _this.requestQueue.delete(key);
        });
    }
};
/**
 * Listener for the `close` event of the underlying WebSocket object
 *
 * @method _onClose
 *
 * @returns {void}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype._onClose = function(event) {
    var _this = this;
    if (this.reconnectOptions.auto && (![
        1000,
        1001
    ].includes(event.code) || event.wasClean === false)) {
        this.reconnect();
        return;
    }
    this.emit(this.CLOSE, event);
    if (this.requestQueue.size > 0) this.requestQueue.forEach(function(request, key) {
        request.callback($37eb3047409b608d$require$errors.ConnectionNotOpenError(event));
        _this.requestQueue.delete(key);
    });
    if (this.responseQueue.size > 0) this.responseQueue.forEach(function(request, key) {
        request.callback($37eb3047409b608d$require$errors.InvalidConnection('on WS', event));
        _this.responseQueue.delete(key);
    });
    this._removeSocketListeners();
    this.removeAllListeners();
};
/**
 * Will add the required socket listeners
 *
 * @method _addSocketListeners
 *
 * @returns {void}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype._addSocketListeners = function() {
    this.connection.addEventListener('message', this._onMessage.bind(this));
    this.connection.addEventListener('open', this._onConnect.bind(this));
    this.connection.addEventListener('close', this._onClose.bind(this));
};
/**
 * Will remove all socket listeners
 *
 * @method _removeSocketListeners
 *
 * @returns {void}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype._removeSocketListeners = function() {
    this.connection.removeEventListener('message', this._onMessage);
    this.connection.removeEventListener('open', this._onConnect);
    this.connection.removeEventListener('close', this._onClose);
};
/**
 * Will parse the response and make an array out of it.
 *
 * @method _parseResponse
 *
 * @param {String} data
 *
 * @returns {Array}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype._parseResponse = function(data) {
    var _this = this, returnValues = [];
    // DE-CHUNKER
    var dechunkedData = data.replace(/\}[\n\r]?\{/g, '}|--|{') // }{
    .replace(/\}\][\n\r]?\[\{/g, '}]|--|[{') // }][{
    .replace(/\}[\n\r]?\[\{/g, '}|--|[{') // }[{
    .replace(/\}\][\n\r]?\{/g, '}]|--|{') // }]{
    .split('|--|');
    dechunkedData.forEach(function(data) {
        // prepend the last chunk
        if (_this.lastChunk) data = _this.lastChunk + data;
        var result = null;
        try {
            result = JSON.parse(data);
        } catch (e) {
            _this.lastChunk = data;
            // start timeout to cancel all requests
            clearTimeout(_this.lastChunkTimeout);
            _this.lastChunkTimeout = setTimeout(function() {
                if (_this.reconnectOptions.auto && _this.reconnectOptions.onTimeout) {
                    _this.reconnect();
                    return;
                }
                _this.emit(_this.ERROR, $37eb3047409b608d$require$errors.ConnectionTimeout(_this._customTimeout));
                if (_this.requestQueue.size > 0) _this.requestQueue.forEach(function(request, key) {
                    request.callback($37eb3047409b608d$require$errors.ConnectionTimeout(_this._customTimeout));
                    _this.requestQueue.delete(key);
                });
            }, _this._customTimeout);
            return;
        }
        // cancel timeout and set chunk to null
        clearTimeout(_this.lastChunkTimeout);
        _this.lastChunk = null;
        if (result) returnValues.push(result);
    });
    return returnValues;
};
/**
 * Does check if the provider is connecting and will add it to the queue or will send it directly
 *
 * @method send
 *
 * @param {Object} payload
 * @param {Function} callback
 *
 * @returns {void}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype.send = function(payload, callback) {
    var _this = this;
    var id = payload.id;
    var request = {
        payload: payload,
        callback: callback
    };
    if (Array.isArray(payload)) id = payload[0].id;
    if (this.connection.readyState === this.connection.CONNECTING || this.reconnecting) {
        this.requestQueue.set(id, request);
        return;
    }
    if (this.connection.readyState !== this.connection.OPEN) {
        this.requestQueue.delete(id);
        this.emit(this.ERROR, $37eb3047409b608d$require$errors.ConnectionNotOpenError());
        request.callback($37eb3047409b608d$require$errors.ConnectionNotOpenError());
        return;
    }
    this.responseQueue.set(id, request);
    this.requestQueue.delete(id);
    try {
        this.connection.send(JSON.stringify(request.payload));
    } catch (error) {
        request.callback(error);
        _this.responseQueue.delete(id);
    }
};
/**
 * Resets the providers, clears all callbacks
 *
 * @method reset
 *
 * @returns {void}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype.reset = function() {
    this.responseQueue.clear();
    this.requestQueue.clear();
    this.removeAllListeners();
    this._removeSocketListeners();
    this._addSocketListeners();
};
/**
 * Closes the current connection with the given code and reason arguments
 *
 * @method disconnect
 *
 * @param {number} code
 * @param {string} reason
 *
 * @returns {void}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype.disconnect = function(code, reason) {
    this._removeSocketListeners();
    this.connection.close(code || 1000, reason);
};
/**
 * Returns the desired boolean.
 *
 * @method supportsSubscriptions
 *
 * @returns {boolean}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype.supportsSubscriptions = function() {
    return true;
};
/**
 * Removes the listeners and reconnects to the socket.
 *
 * @method reconnect
 *
 * @returns {void}
 */ $37eb3047409b608d$var$WebsocketProvider.prototype.reconnect = function() {
    var _this = this;
    this.reconnecting = true;
    if (this.responseQueue.size > 0) this.responseQueue.forEach(function(request, key) {
        request.callback($37eb3047409b608d$require$errors.PendingRequestsOnReconnectingError());
        _this.responseQueue.delete(key);
    });
    if (!this.reconnectOptions.maxAttempts || this.reconnectAttempts < this.reconnectOptions.maxAttempts) {
        setTimeout(function() {
            _this.reconnectAttempts++;
            _this._removeSocketListeners();
            _this.emit(_this.RECONNECT, _this.reconnectAttempts);
            _this.connect();
        }, this.reconnectOptions.delay);
        return;
    }
    this.emit(this.ERROR, $37eb3047409b608d$require$errors.MaxAttemptsReachedOnReconnectingError());
    this.reconnecting = false;
    if (this.requestQueue.size > 0) this.requestQueue.forEach(function(request, key) {
        request.callback($37eb3047409b608d$require$errors.MaxAttemptsReachedOnReconnectingError());
        _this.requestQueue.delete(key);
    });
};
module.exports = $37eb3047409b608d$var$WebsocketProvider;

});
parcelRegister("9Sw0q", function(module, exports) {
'use strict';
var $7311fbe05d913ec3$var$has = Object.prototype.hasOwnProperty, $7311fbe05d913ec3$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $7311fbe05d913ec3$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $7311fbe05d913ec3$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $7311fbe05d913ec3$var$Events().__proto__) $7311fbe05d913ec3$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $7311fbe05d913ec3$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $7311fbe05d913ec3$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $7311fbe05d913ec3$var$EE(fn, context || emitter, once), evt = $7311fbe05d913ec3$var$prefix ? $7311fbe05d913ec3$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $7311fbe05d913ec3$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $7311fbe05d913ec3$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $7311fbe05d913ec3$var$EventEmitter() {
    this._events = new $7311fbe05d913ec3$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $7311fbe05d913ec3$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($7311fbe05d913ec3$var$has.call(events, name)) names.push($7311fbe05d913ec3$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $7311fbe05d913ec3$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $7311fbe05d913ec3$var$prefix ? $7311fbe05d913ec3$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $7311fbe05d913ec3$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $7311fbe05d913ec3$var$prefix ? $7311fbe05d913ec3$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $7311fbe05d913ec3$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $7311fbe05d913ec3$var$prefix ? $7311fbe05d913ec3$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7311fbe05d913ec3$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $7311fbe05d913ec3$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7311fbe05d913ec3$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $7311fbe05d913ec3$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7311fbe05d913ec3$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $7311fbe05d913ec3$var$prefix ? $7311fbe05d913ec3$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $7311fbe05d913ec3$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $7311fbe05d913ec3$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $7311fbe05d913ec3$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7311fbe05d913ec3$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $7311fbe05d913ec3$var$prefix ? $7311fbe05d913ec3$var$prefix + event : event;
        if (this._events[evt]) $7311fbe05d913ec3$var$clearEvent(this, evt);
    } else {
        this._events = new $7311fbe05d913ec3$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$7311fbe05d913ec3$var$EventEmitter.prototype.off = $7311fbe05d913ec3$var$EventEmitter.prototype.removeListener;
$7311fbe05d913ec3$var$EventEmitter.prototype.addListener = $7311fbe05d913ec3$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$7311fbe05d913ec3$var$EventEmitter.prefixed = $7311fbe05d913ec3$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$7311fbe05d913ec3$var$EventEmitter.EventEmitter = $7311fbe05d913ec3$var$EventEmitter;
module.exports = $7311fbe05d913ec3$var$EventEmitter;

});

parcelRegister("e3OPi", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $a3c8c588df78d236$require$Buffer = $6ZWSX.Buffer;
var $a3c8c588df78d236$var$isNode = Object.prototype.toString.call(typeof $hPtJY !== 'undefined' ? $hPtJY : 0) === '[object process]';
var $a3c8c588df78d236$var$isRN = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
var $a3c8c588df78d236$var$_btoa = null;
var $a3c8c588df78d236$var$helpers = null;


if ($a3c8c588df78d236$var$isNode || $a3c8c588df78d236$var$isRN) {
    $a3c8c588df78d236$var$_btoa = function(str) {
        return $a3c8c588df78d236$require$Buffer.from(str).toString('base64');
    };
    var $a3c8c588df78d236$var$url = (parcelRequire("biuEp"));
    if ($a3c8c588df78d236$var$url.URL) {
        // Use the new Node 6+ API for parsing URLs that supports username/password
        var $a3c8c588df78d236$var$newURL = $a3c8c588df78d236$var$url.URL;
        $a3c8c588df78d236$var$helpers = function(url) {
            return new $a3c8c588df78d236$var$newURL(url);
        };
    } else // Web3 supports Node.js 5, so fall back to the legacy URL API if necessary
    $a3c8c588df78d236$var$helpers = (parcelRequire("biuEp")).parse;
} else {
    $a3c8c588df78d236$var$_btoa = btoa.bind(window);
    $a3c8c588df78d236$var$helpers = function(url) {
        return new URL(url);
    };
}
module.exports = {
    parseURL: $a3c8c588df78d236$var$helpers,
    btoa: $a3c8c588df78d236$var$_btoa
};

});
parcelRegister("biuEp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $fFTr1 = parcelRequire("fFTr1");

var $7yJoo = parcelRequire("7yJoo");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $9B6BR = parcelRequire("9B6BR");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $7yJoo.isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$7yJoo.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $9B6BR.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $fFTr1.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $9B6BR.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($7yJoo.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && $7yJoo.isObject(this.query) && Object.keys(this.query).length) query = $9B6BR.stringify(this.query);
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if ($7yJoo.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = '/';
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$7yJoo.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$7yJoo.isNull(result.pathname) || !$7yJoo.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join('/');
    //to support request.http
    if (!$7yJoo.isNull(result.pathname) || !$7yJoo.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

});
parcelRegister("fFTr1", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.3.2',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRegister("7yJoo", function(module, exports) {
'use strict';
module.exports = {
    isString: function(arg) {
        return typeof arg === 'string';
    },
    isObject: function(arg) {
        return typeof arg === 'object' && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};

});

parcelRegister("9B6BR", function(module, exports) {

$parcel$export(module.exports, "parse", () => $6fccb246f9bde9ce$export$98e6a39c04603d36, (v) => $6fccb246f9bde9ce$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $6fccb246f9bde9ce$export$fac44ee5b035f737, (v) => $6fccb246f9bde9ce$export$fac44ee5b035f737 = v);
var $6fccb246f9bde9ce$export$2f872c0f2117be69;
var $6fccb246f9bde9ce$export$98e6a39c04603d36;
var $6fccb246f9bde9ce$export$c564cdbbe6da493;
var $6fccb246f9bde9ce$export$fac44ee5b035f737;
'use strict';

$6fccb246f9bde9ce$export$2f872c0f2117be69 = $6fccb246f9bde9ce$export$98e6a39c04603d36 = (parcelRequire("kzGqM"));

$6fccb246f9bde9ce$export$c564cdbbe6da493 = $6fccb246f9bde9ce$export$fac44ee5b035f737 = (parcelRequire("kWD7b"));

});
parcelRegister("kzGqM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $efa7fd707211b5be$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$efa7fd707211b5be$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($efa7fd707211b5be$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $efa7fd707211b5be$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("kWD7b", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $f3f790d06fe816e6$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $f3f790d06fe816e6$var$map($f3f790d06fe816e6$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(k)) + eq;
        if ($f3f790d06fe816e6$var$isArray(obj[k])) return $f3f790d06fe816e6$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(name)) + eq + encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(obj));
};
var $f3f790d06fe816e6$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $f3f790d06fe816e6$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $f3f790d06fe816e6$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});




parcelRegister("fC2qj", function(module, exports) {
var $b5dc48dc7c306f35$var$_globalThis;

if (typeof globalThis === 'object') $b5dc48dc7c306f35$var$_globalThis = globalThis;
else try {
    $b5dc48dc7c306f35$var$_globalThis = (parcelRequire("1EZeK"));
} catch (error) {} finally{
    if (!$b5dc48dc7c306f35$var$_globalThis && typeof window !== 'undefined') $b5dc48dc7c306f35$var$_globalThis = window;
    if (!$b5dc48dc7c306f35$var$_globalThis) throw new Error('Could not determine global this');
}
var $b5dc48dc7c306f35$var$NativeWebSocket = $b5dc48dc7c306f35$var$_globalThis.WebSocket || $b5dc48dc7c306f35$var$_globalThis.MozWebSocket;

var $7N9e6 = parcelRequire("7N9e6");
/**
 * Expose a W3C WebSocket class with just one or two arguments.
 */ function $b5dc48dc7c306f35$var$W3CWebSocket(uri, protocols) {
    var native_instance;
    if (protocols) native_instance = new $b5dc48dc7c306f35$var$NativeWebSocket(uri, protocols);
    else native_instance = new $b5dc48dc7c306f35$var$NativeWebSocket(uri);
    /**
	 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
	 * class). Since it is an Object it will be returned as it is when creating an
	 * instance of W3CWebSocket via 'new W3CWebSocket()'.
	 *
	 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
	 */ return native_instance;
}
if ($b5dc48dc7c306f35$var$NativeWebSocket) [
    'CONNECTING',
    'OPEN',
    'CLOSING',
    'CLOSED'
].forEach(function(prop) {
    Object.defineProperty($b5dc48dc7c306f35$var$W3CWebSocket, prop, {
        get: function() {
            return $b5dc48dc7c306f35$var$NativeWebSocket[prop];
        }
    });
});
/**
 * Module exports.
 */ module.exports = {
    'w3cwebsocket': $b5dc48dc7c306f35$var$NativeWebSocket ? $b5dc48dc7c306f35$var$W3CWebSocket : null,
    'version': $7N9e6
};

});
parcelRegister("1EZeK", function(module, exports) {
var $13590742ec5ba364$var$naiveFallback = function() {
    if (typeof self === "object" && self) return self;
    if (typeof window === "object" && window) return window;
    throw new Error("Unable to resolve global `this`");
};
module.exports = function() {
    if (this) return this;
    // Unexpected strict mode (may happen if e.g. bundled into ESM module)
    // Fallback to standard globalThis if available
    if (typeof globalThis === "object" && globalThis) return globalThis;
    // Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
    // In all ES5+ engines global object inherits from Object.prototype
    // (if you approached one that doesn't please report)
    try {
        Object.defineProperty(Object.prototype, "__global__", {
            get: function() {
                return this;
            },
            configurable: true
        });
    } catch (error) {
        // Unfortunate case of updates to Object.prototype being restricted
        // via preventExtensions, seal or freeze
        return $13590742ec5ba364$var$naiveFallback();
    }
    try {
        // Safari case (window.__global__ works, but __global__ does not)
        if (!__global__) return $13590742ec5ba364$var$naiveFallback();
        return __global__;
    } finally{
        delete Object.prototype.__global__;
    }
}();

});

parcelRegister("7N9e6", function(module, exports) {

module.exports = (parcelRequire("ln8A6")).version;

});
parcelRegister("ln8A6", function(module, exports) {
module.exports = JSON.parse('{"name":"websocket","description":"Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.","keywords":["websocket","websockets","socket","networking","comet","push","RFC-6455","realtime","server","client"],"author":"Brian McKelvey <theturtle32@gmail.com> (https://github.com/theturtle32)","contributors":["I\xf1aki Baz Castillo <ibc@aliax.net> (http://dev.sipdoc.net)"],"version":"1.0.34","repository":{"type":"git","url":"https://github.com/theturtle32/WebSocket-Node.git"},"homepage":"https://github.com/theturtle32/WebSocket-Node","engines":{"node":">=4.0.0"},"dependencies":{"bufferutil":"^4.0.1","debug":"^2.2.0","es5-ext":"^0.10.50","typedarray-to-buffer":"^3.1.5","utf-8-validate":"^5.0.2","yaeti":"^0.0.6"},"devDependencies":{"buffer-equal":"^1.0.0","gulp":"^4.0.2","gulp-jshint":"^2.0.4","jshint-stylish":"^2.2.1","jshint":"^2.0.0","tape":"^4.9.1"},"config":{"verbose":false},"scripts":{"test":"tape test/unit/*.js","gulp":"gulp"},"main":"index","directories":{"lib":"./lib"},"browser":"lib/browser.js","license":"Apache-2.0"}');

});




parcelRegister("ebDIR", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /** @file httpprovider.js
 * @authors:
 *   Marek Kotewicz <marek@parity.io>
 *   Marian Oancea
 *   Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2015
 */ 
var $hA2kM = parcelRequire("hA2kM");
var $a540e7d29466b1b7$require$errors = $hA2kM.errors;

var $jmpkk = parcelRequire("jmpkk");
var $a540e7d29466b1b7$require$XHR2 = $jmpkk.XMLHttpRequest;

var $k6Qs9 = parcelRequire("k6Qs9");

var $cgLmW = parcelRequire("cgLmW");
/**
 * HttpProvider should be used to send rpc calls over http
 */ var $a540e7d29466b1b7$var$HttpProvider = function HttpProvider(host, options) {
    options = options || {};
    this.withCredentials = options.withCredentials || false;
    this.timeout = options.timeout || 0;
    this.headers = options.headers;
    this.agent = options.agent;
    this.connected = false;
    // keepAlive is true unless explicitly set to false
    const keepAlive = options.keepAlive !== false;
    this.host = host || 'http://localhost:8545';
    if (!this.agent) {
        if (this.host.substring(0, 5) === "https") this.httpsAgent = new $cgLmW.Agent({
            keepAlive: keepAlive
        });
        else this.httpAgent = new $k6Qs9.Agent({
            keepAlive: keepAlive
        });
    }
};
$a540e7d29466b1b7$var$HttpProvider.prototype._prepareRequest = function() {
    var request;
    // the current runtime is a browser
    if (typeof XMLHttpRequest !== 'undefined') request = new XMLHttpRequest();
    else {
        request = new $a540e7d29466b1b7$require$XHR2();
        var agents = {
            httpsAgent: this.httpsAgent,
            httpAgent: this.httpAgent,
            baseUrl: this.baseUrl
        };
        if (this.agent) {
            agents.httpsAgent = this.agent.https;
            agents.httpAgent = this.agent.http;
            agents.baseUrl = this.agent.baseUrl;
        }
        request.nodejsSet(agents);
    }
    request.open('POST', this.host, true);
    request.setRequestHeader('Content-Type', 'application/json');
    request.timeout = this.timeout;
    request.withCredentials = this.withCredentials;
    if (this.headers) this.headers.forEach(function(header) {
        request.setRequestHeader(header.name, header.value);
    });
    return request;
};
/**
 * Should be used to make async request
 *
 * @method send
 * @param {Object} payload
 * @param {Function} callback triggered on end with (err, result)
 */ $a540e7d29466b1b7$var$HttpProvider.prototype.send = function(payload, callback) {
    var _this = this;
    var request = this._prepareRequest();
    request.onreadystatechange = function() {
        if (request.readyState === 4 && request.timeout !== 1) {
            var result = request.responseText;
            var error = null;
            try {
                result = JSON.parse(result);
            } catch (e) {
                error = $a540e7d29466b1b7$require$errors.InvalidResponse(request.responseText);
            }
            _this.connected = true;
            callback(error, result);
        }
    };
    request.ontimeout = function() {
        _this.connected = false;
        callback($a540e7d29466b1b7$require$errors.ConnectionTimeout(this.timeout));
    };
    try {
        request.send(JSON.stringify(payload));
    } catch (error) {
        this.connected = false;
        callback($a540e7d29466b1b7$require$errors.InvalidConnection(this.host));
    }
};
$a540e7d29466b1b7$var$HttpProvider.prototype.disconnect = function() {
//NO OP
};
/**
 * Returns the desired boolean.
 *
 * @method supportsSubscriptions
 * @returns {boolean}
 */ $a540e7d29466b1b7$var$HttpProvider.prototype.supportsSubscriptions = function() {
    return false;
};
module.exports = $a540e7d29466b1b7$var$HttpProvider;

});
parcelRegister("jmpkk", function(module, exports) {
"use strict";
function $e183b7cdb60d6650$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e183b7cdb60d6650$var$__export((parcelRequire("9YeiU")));

var $b4sDP = parcelRequire("b4sDP");
module.exports.XMLHttpRequestEventTarget = $b4sDP.XMLHttpRequestEventTarget;

});
parcelRegister("9YeiU", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $7424d024bdebc1f6$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $7424d024bdebc1f6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7424d024bdebc1f6$var$__assign = module.exports && module.exports.__assign || Object.assign || function(t) {
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k6Qs9 = parcelRequire("k6Qs9");

var $cgLmW = parcelRequire("cgLmW");

var $ccDAZ = parcelRequire("ccDAZ");

var $biuEp = parcelRequire("biuEp");

var $aLPd9 = parcelRequire("aLPd9");

var $2be49 = parcelRequire("2be49");

var $b4sDP = parcelRequire("b4sDP");

var $5Bw1p = parcelRequire("5Bw1p");

var $cwLZu = parcelRequire("cwLZu");
var $7424d024bdebc1f6$var$XMLHttpRequest = /** @class */ function(_super) {
    $7424d024bdebc1f6$var$__extends(XMLHttpRequest, _super);
    function XMLHttpRequest(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        _this.UNSENT = XMLHttpRequest.UNSENT;
        _this.OPENED = XMLHttpRequest.OPENED;
        _this.HEADERS_RECEIVED = XMLHttpRequest.HEADERS_RECEIVED;
        _this.LOADING = XMLHttpRequest.LOADING;
        _this.DONE = XMLHttpRequest.DONE;
        _this.onreadystatechange = null;
        _this.readyState = XMLHttpRequest.UNSENT;
        _this.response = null;
        _this.responseText = '';
        _this.responseType = '';
        _this.status = 0; // TODO: UNSENT?
        _this.statusText = '';
        _this.timeout = 0;
        _this.upload = new $5Bw1p.XMLHttpRequestUpload();
        _this.responseUrl = '';
        _this.withCredentials = false;
        _this._method = null;
        _this._url = null;
        _this._sync = false;
        _this._headers = {};
        _this._loweredHeaders = {};
        _this._mimeOverride = null; // TODO: is type right?
        _this._request = null;
        _this._response = null;
        _this._responseParts = null;
        _this._responseHeaders = null;
        _this._aborting = null; // TODO: type?
        _this._error = null; // TODO: type?
        _this._loadedBytes = 0;
        _this._totalBytes = 0;
        _this._lengthComputable = false;
        _this._restrictedMethods = {
            CONNECT: true,
            TRACE: true,
            TRACK: true
        };
        _this._restrictedHeaders = {
            'accept-charset': true,
            'accept-encoding': true,
            'access-control-request-headers': true,
            'access-control-request-method': true,
            connection: true,
            'content-length': true,
            cookie: true,
            cookie2: true,
            date: true,
            dnt: true,
            expect: true,
            host: true,
            'keep-alive': true,
            origin: true,
            referer: true,
            te: true,
            trailer: true,
            'transfer-encoding': true,
            upgrade: true,
            'user-agent': true,
            via: true
        };
        _this._privateHeaders = {
            'set-cookie': true,
            'set-cookie2': true
        };
        _this._userAgent = "Mozilla/5.0 (" + $ccDAZ.type() + " " + $ccDAZ.arch() + ") node.js/" + $hPtJY.versions.node + " v8/" + $hPtJY.versions.v8;
        _this._anonymous = options.anon || false;
        return _this;
    }
    XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
        if (async === void 0) async = true;
        method = method.toUpperCase();
        if (this._restrictedMethods[method]) throw new XMLHttpRequest.SecurityError("HTTP method " + method + " is not allowed in XHR");
        var xhrUrl = this._parseUrl(url, user, password);
        this.readyState === XMLHttpRequest.HEADERS_RECEIVED || (this.readyState, XMLHttpRequest.LOADING);
        this._method = method;
        this._url = xhrUrl;
        this._sync = !async;
        this._headers = {};
        this._loweredHeaders = {};
        this._mimeOverride = null;
        this._setReadyState(XMLHttpRequest.OPENED);
        this._request = null;
        this._response = null;
        this.status = 0;
        this.statusText = '';
        this._responseParts = [];
        this._responseHeaders = null;
        this._loadedBytes = 0;
        this._totalBytes = 0;
        this._lengthComputable = false;
    };
    XMLHttpRequest.prototype.setRequestHeader = function(name, value) {
        if (this.readyState !== XMLHttpRequest.OPENED) throw new XMLHttpRequest.InvalidStateError('XHR readyState must be OPENED');
        var loweredName = name.toLowerCase();
        if (this._restrictedHeaders[loweredName] || /^sec-/.test(loweredName) || /^proxy-/.test(loweredName)) {
            console.warn("Refused to set unsafe header \"" + name + "\"");
            return;
        }
        value = value.toString();
        if (this._loweredHeaders[loweredName] != null) {
            name = this._loweredHeaders[loweredName];
            this._headers[name] = this._headers[name] + ", " + value;
        } else {
            this._loweredHeaders[loweredName] = name;
            this._headers[name] = value;
        }
    };
    XMLHttpRequest.prototype.send = function(data) {
        if (this.readyState !== XMLHttpRequest.OPENED) throw new XMLHttpRequest.InvalidStateError('XHR readyState must be OPENED');
        if (this._request) throw new XMLHttpRequest.InvalidStateError('send() already called');
        switch(this._url.protocol){
            case 'file:':
                return this._sendFile(data);
            case 'http:':
            case 'https:':
                return this._sendHttp(data);
            default:
                throw new XMLHttpRequest.NetworkError("Unsupported protocol " + this._url.protocol);
        }
    };
    XMLHttpRequest.prototype.abort = function() {
        if (this._request == null) return;
        this._request.abort();
        this._setError();
        this._dispatchProgress('abort');
        this._dispatchProgress('loadend');
    };
    XMLHttpRequest.prototype.getResponseHeader = function(name) {
        if (this._responseHeaders == null || name == null) return null;
        var loweredName = name.toLowerCase();
        return this._responseHeaders.hasOwnProperty(loweredName) ? this._responseHeaders[name.toLowerCase()] : null;
    };
    XMLHttpRequest.prototype.getAllResponseHeaders = function() {
        var _this = this;
        if (this._responseHeaders == null) return '';
        return Object.keys(this._responseHeaders).map(function(key) {
            return key + ": " + _this._responseHeaders[key];
        }).join('\r\n');
    };
    XMLHttpRequest.prototype.overrideMimeType = function(mimeType) {
        if (this.readyState === XMLHttpRequest.LOADING || this.readyState === XMLHttpRequest.DONE) throw new XMLHttpRequest.InvalidStateError('overrideMimeType() not allowed in LOADING or DONE');
        this._mimeOverride = mimeType.toLowerCase();
    };
    XMLHttpRequest.prototype.nodejsSet = function(options) {
        this.nodejsHttpAgent = options.httpAgent || this.nodejsHttpAgent;
        this.nodejsHttpsAgent = options.httpsAgent || this.nodejsHttpsAgent;
        if (options.hasOwnProperty('baseUrl')) {
            if (options.baseUrl != null) {
                var parsedUrl = $biuEp.parse(options.baseUrl, false, true);
                if (!parsedUrl.protocol) throw new XMLHttpRequest.SyntaxError("baseUrl must be an absolute URL");
            }
            this.nodejsBaseUrl = options.baseUrl;
        }
    };
    XMLHttpRequest.nodejsSet = function(options) {
        XMLHttpRequest.prototype.nodejsSet(options);
    };
    XMLHttpRequest.prototype._setReadyState = function(readyState) {
        this.readyState = readyState;
        this.dispatchEvent(new $aLPd9.ProgressEvent('readystatechange'));
    };
    XMLHttpRequest.prototype._sendFile = function(data) {
        // TODO
        throw new Error('Protocol file: not implemented');
    };
    XMLHttpRequest.prototype._sendHttp = function(data) {
        if (this._sync) throw new Error('Synchronous XHR processing not implemented');
        if (data && (this._method === 'GET' || this._method === 'HEAD')) {
            console.warn("Discarding entity body for " + this._method + " requests");
            data = null;
        } else data = data || '';
        this.upload._setData(data);
        this._finalizeHeaders();
        this._sendHxxpRequest();
    };
    XMLHttpRequest.prototype._sendHxxpRequest = function() {
        var _this = this;
        if (this.withCredentials) {
            var cookie = XMLHttpRequest.cookieJar.getCookies($cwLZu.CookieAccessInfo(this._url.hostname, this._url.pathname, this._url.protocol === 'https:')).toValueString();
            this._headers.cookie = this._headers.cookie2 = cookie;
        }
        var _a = this._url.protocol === 'http:' ? [
            $k6Qs9,
            this.nodejsHttpAgent
        ] : [
            $cgLmW,
            this.nodejsHttpsAgent
        ], hxxp = _a[0], agent = _a[1];
        var requestMethod = hxxp.request.bind(hxxp);
        var request = requestMethod({
            hostname: this._url.hostname,
            port: +this._url.port,
            path: this._url.path,
            auth: this._url.auth,
            method: this._method,
            headers: this._headers,
            agent: agent
        });
        this._request = request;
        if (this.timeout) request.setTimeout(this.timeout, function() {
            return _this._onHttpTimeout(request);
        });
        request.on('response', function(response) {
            return _this._onHttpResponse(request, response);
        });
        request.on('error', function(error) {
            return _this._onHttpRequestError(request, error);
        });
        this.upload._startUpload(request);
        if (this._request === request) this._dispatchProgress('loadstart');
    };
    XMLHttpRequest.prototype._finalizeHeaders = function() {
        this._headers = $7424d024bdebc1f6$var$__assign({}, this._headers, {
            Connection: 'keep-alive',
            Host: this._url.host,
            'User-Agent': this._userAgent
        }, this._anonymous ? {
            Referer: 'about:blank'
        } : {});
        this.upload._finalizeHeaders(this._headers, this._loweredHeaders);
    };
    XMLHttpRequest.prototype._onHttpResponse = function(request, response) {
        var _this = this;
        if (this._request !== request) return;
        if (this.withCredentials && (response.headers['set-cookie'] || response.headers['set-cookie2'])) XMLHttpRequest.cookieJar.setCookies(response.headers['set-cookie'] || response.headers['set-cookie2']);
        if ([
            301,
            302,
            303,
            307,
            308
        ].indexOf(response.statusCode) >= 0) {
            this._url = this._parseUrl(response.headers.location);
            this._method = 'GET';
            if (this._loweredHeaders['content-type']) {
                delete this._headers[this._loweredHeaders['content-type']];
                delete this._loweredHeaders['content-type'];
            }
            if (this._headers['Content-Type'] != null) delete this._headers['Content-Type'];
            delete this._headers['Content-Length'];
            this.upload._reset();
            this._finalizeHeaders();
            this._sendHxxpRequest();
            return;
        }
        this._response = response;
        this._response.on('data', function(data) {
            return _this._onHttpResponseData(response, data);
        });
        this._response.on('end', function() {
            return _this._onHttpResponseEnd(response);
        });
        this._response.on('close', function() {
            return _this._onHttpResponseClose(response);
        });
        this.responseUrl = this._url.href.split('#')[0];
        this.status = response.statusCode;
        this.statusText = $k6Qs9.STATUS_CODES[this.status];
        this._parseResponseHeaders(response);
        var lengthString = this._responseHeaders['content-length'] || '';
        this._totalBytes = +lengthString;
        this._lengthComputable = !!lengthString;
        this._setReadyState(XMLHttpRequest.HEADERS_RECEIVED);
    };
    XMLHttpRequest.prototype._onHttpResponseData = function(response, data) {
        if (this._response !== response) return;
        this._responseParts.push(new $7424d024bdebc1f6$require$Buffer(data));
        this._loadedBytes += data.length;
        if (this.readyState !== XMLHttpRequest.LOADING) this._setReadyState(XMLHttpRequest.LOADING);
        this._dispatchProgress('progress');
    };
    XMLHttpRequest.prototype._onHttpResponseEnd = function(response) {
        if (this._response !== response) return;
        this._parseResponse();
        this._request = null;
        this._response = null;
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress('load');
        this._dispatchProgress('loadend');
    };
    XMLHttpRequest.prototype._onHttpResponseClose = function(response) {
        if (this._response !== response) return;
        var request = this._request;
        this._setError();
        request.abort();
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress('error');
        this._dispatchProgress('loadend');
    };
    XMLHttpRequest.prototype._onHttpTimeout = function(request) {
        if (this._request !== request) return;
        this._setError();
        request.abort();
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress('timeout');
        this._dispatchProgress('loadend');
    };
    XMLHttpRequest.prototype._onHttpRequestError = function(request, error) {
        if (this._request !== request) return;
        this._setError();
        request.abort();
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress('error');
        this._dispatchProgress('loadend');
    };
    XMLHttpRequest.prototype._dispatchProgress = function(eventType) {
        var event = new XMLHttpRequest.ProgressEvent(eventType);
        event.lengthComputable = this._lengthComputable;
        event.loaded = this._loadedBytes;
        event.total = this._totalBytes;
        this.dispatchEvent(event);
    };
    XMLHttpRequest.prototype._setError = function() {
        this._request = null;
        this._response = null;
        this._responseHeaders = null;
        this._responseParts = null;
    };
    XMLHttpRequest.prototype._parseUrl = function(urlString, user, password) {
        var absoluteUrl = this.nodejsBaseUrl == null ? urlString : $biuEp.resolve(this.nodejsBaseUrl, urlString);
        var xhrUrl = $biuEp.parse(absoluteUrl, false, true);
        xhrUrl.hash = null;
        var _a = (xhrUrl.auth || '').split(':'), xhrUser = _a[0], xhrPassword = _a[1];
        if (xhrUser || xhrPassword || user || password) xhrUrl.auth = (user || xhrUser || '') + ":" + (password || xhrPassword || '');
        return xhrUrl;
    };
    XMLHttpRequest.prototype._parseResponseHeaders = function(response) {
        this._responseHeaders = {};
        for(var name_1 in response.headers){
            var loweredName = name_1.toLowerCase();
            if (this._privateHeaders[loweredName]) continue;
            this._responseHeaders[loweredName] = response.headers[name_1];
        }
        if (this._mimeOverride != null) this._responseHeaders['content-type'] = this._mimeOverride;
    };
    XMLHttpRequest.prototype._parseResponse = function() {
        var buffer = $7424d024bdebc1f6$require$Buffer.concat(this._responseParts);
        this._responseParts = null;
        switch(this.responseType){
            case 'json':
                this.responseText = null;
                try {
                    this.response = JSON.parse(buffer.toString('utf-8'));
                } catch (_a) {
                    this.response = null;
                }
                return;
            case 'buffer':
                this.responseText = null;
                this.response = buffer;
                return;
            case 'arraybuffer':
                this.responseText = null;
                var arrayBuffer = new ArrayBuffer(buffer.length);
                var view = new Uint8Array(arrayBuffer);
                for(var i = 0; i < buffer.length; i++)view[i] = buffer[i];
                this.response = arrayBuffer;
                return;
            case 'text':
            default:
                try {
                    this.responseText = buffer.toString(this._parseResponseEncoding());
                } catch (_b) {
                    this.responseText = buffer.toString('binary');
                }
                this.response = this.responseText;
        }
    };
    XMLHttpRequest.prototype._parseResponseEncoding = function() {
        return /;\s*charset=(.*)$/.exec(this._responseHeaders['content-type'] || '')[1] || 'utf-8';
    };
    XMLHttpRequest.ProgressEvent = $aLPd9.ProgressEvent;
    XMLHttpRequest.InvalidStateError = $2be49.InvalidStateError;
    XMLHttpRequest.NetworkError = $2be49.NetworkError;
    XMLHttpRequest.SecurityError = $2be49.SecurityError;
    XMLHttpRequest.SyntaxError = $2be49.SyntaxError;
    XMLHttpRequest.XMLHttpRequestUpload = $5Bw1p.XMLHttpRequestUpload;
    XMLHttpRequest.UNSENT = 0;
    XMLHttpRequest.OPENED = 1;
    XMLHttpRequest.HEADERS_RECEIVED = 2;
    XMLHttpRequest.LOADING = 3;
    XMLHttpRequest.DONE = 4;
    XMLHttpRequest.cookieJar = $cwLZu.CookieJar();
    return XMLHttpRequest;
}($b4sDP.XMLHttpRequestEventTarget);
module.exports.XMLHttpRequest = $7424d024bdebc1f6$var$XMLHttpRequest;
$7424d024bdebc1f6$var$XMLHttpRequest.prototype.nodejsHttpAgent = $k6Qs9.globalAgent;
$7424d024bdebc1f6$var$XMLHttpRequest.prototype.nodejsHttpsAgent = $cgLmW.globalAgent;
$7424d024bdebc1f6$var$XMLHttpRequest.prototype.nodejsBaseUrl = null;

});
parcelRegister("k6Qs9", function(module, exports) {

var $1r5QY = parcelRequire("1r5QY");

var $6dXuF = parcelRequire("6dXuF");

var $h0kNM = parcelRequire("h0kNM");

var $4rffA = parcelRequire("4rffA");

var $biuEp = parcelRequire("biuEp");
var $ea3d0e42a2be418c$var$http = module.exports;
$ea3d0e42a2be418c$var$http.request = function(opts, cb) {
    if (typeof opts === 'string') opts = $biuEp.parse(opts);
    else opts = $h0kNM(opts);
    // Normally, the page is loaded from http or https, so not specifying a protocol
    // will result in a (valid) protocol-relative url. However, this won't work if
    // the protocol is something else, like 'file:'
    var defaultProtocol = $parcel$global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : '';
    var protocol = opts.protocol || defaultProtocol;
    var host = opts.hostname || opts.host;
    var port = opts.port;
    var path = opts.path || '/';
    // Necessary for IPv6 addresses
    if (host && host.indexOf(':') !== -1) host = '[' + host + ']';
    // This may be a relative url. The browser should always be able to interpret it correctly.
    opts.url = (host ? protocol + '//' + host : '') + (port ? ':' + port : '') + path;
    opts.method = (opts.method || 'GET').toUpperCase();
    opts.headers = opts.headers || {};
    // Also valid opts.auth, opts.mode
    var req = new $1r5QY(opts);
    if (cb) req.on('response', cb);
    return req;
};
$ea3d0e42a2be418c$var$http.get = function get(opts, cb) {
    var req = $ea3d0e42a2be418c$var$http.request(opts, cb);
    req.end();
    return req;
};
$ea3d0e42a2be418c$var$http.ClientRequest = $1r5QY;
$ea3d0e42a2be418c$var$http.IncomingMessage = $6dXuF.IncomingMessage;
$ea3d0e42a2be418c$var$http.Agent = function() {};
$ea3d0e42a2be418c$var$http.Agent.defaultMaxSockets = 4;
$ea3d0e42a2be418c$var$http.globalAgent = new $ea3d0e42a2be418c$var$http.Agent();
$ea3d0e42a2be418c$var$http.STATUS_CODES = $4rffA;
$ea3d0e42a2be418c$var$http.METHODS = [
    'CHECKOUT',
    'CONNECT',
    'COPY',
    'DELETE',
    'GET',
    'HEAD',
    'LOCK',
    'M-SEARCH',
    'MERGE',
    'MKACTIVITY',
    'MKCOL',
    'MOVE',
    'NOTIFY',
    'OPTIONS',
    'PATCH',
    'POST',
    'PROPFIND',
    'PROPPATCH',
    'PURGE',
    'PUT',
    'REPORT',
    'SEARCH',
    'SUBSCRIBE',
    'TRACE',
    'UNLOCK',
    'UNSUBSCRIBE'
];

});
parcelRegister("1r5QY", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $10bcda68fa6d9d94$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");

var $jjD4m = parcelRequire("jjD4m");

var $dlqwk = parcelRequire("dlqwk");

var $6dXuF = parcelRequire("6dXuF");

var $b6RFW = parcelRequire("b6RFW");
var $10bcda68fa6d9d94$var$IncomingMessage = $6dXuF.IncomingMessage;
var $10bcda68fa6d9d94$var$rStates = $6dXuF.readyStates;
function $10bcda68fa6d9d94$var$decideMode(preferBinary, useFetch) {
    if ($jjD4m.fetch && useFetch) return 'fetch';
    else if ($jjD4m.mozchunkedarraybuffer) return 'moz-chunked-arraybuffer';
    else if ($jjD4m.msstream) return 'ms-stream';
    else if ($jjD4m.arraybuffer && preferBinary) return 'arraybuffer';
    else return 'text';
}
var $10bcda68fa6d9d94$var$ClientRequest = module.exports = function(opts) {
    var self = this;
    $b6RFW.Writable.call(self);
    self._opts = opts;
    self._body = [];
    self._headers = {};
    if (opts.auth) self.setHeader('Authorization', 'Basic ' + $10bcda68fa6d9d94$require$Buffer.from(opts.auth).toString('base64'));
    Object.keys(opts.headers).forEach(function(name) {
        self.setHeader(name, opts.headers[name]);
    });
    var preferBinary;
    var useFetch = true;
    if (opts.mode === 'disable-fetch' || 'requestTimeout' in opts && !$jjD4m.abortController) {
        // If the use of XHR should be preferred. Not typically needed.
        useFetch = false;
        preferBinary = true;
    } else if (opts.mode === 'prefer-streaming') // If streaming is a high priority but binary compatibility and
    // the accuracy of the 'content-type' header aren't
    preferBinary = false;
    else if (opts.mode === 'allow-wrong-content-type') // If streaming is more important than preserving the 'content-type' header
    preferBinary = !$jjD4m.overrideMimeType;
    else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') // Use binary if text streaming may corrupt data or the content-type header, or for speed
    preferBinary = true;
    else throw new Error('Invalid value for opts.mode');
    self._mode = $10bcda68fa6d9d94$var$decideMode(preferBinary, useFetch);
    self._fetchTimer = null;
    self._socketTimeout = null;
    self._socketTimer = null;
    self.on('finish', function() {
        self._onFinish();
    });
};
$dlqwk($10bcda68fa6d9d94$var$ClientRequest, $b6RFW.Writable);
$10bcda68fa6d9d94$var$ClientRequest.prototype.setHeader = function(name, value) {
    var self = this;
    var lowerName = name.toLowerCase();
    // This check is not necessary, but it prevents warnings from browsers about setting unsafe
    // headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
    // http-browserify did it, so I will too.
    if ($10bcda68fa6d9d94$var$unsafeHeaders.indexOf(lowerName) !== -1) return;
    self._headers[lowerName] = {
        name: name,
        value: value
    };
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.getHeader = function(name) {
    var header = this._headers[name.toLowerCase()];
    if (header) return header.value;
    return null;
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.removeHeader = function(name) {
    var self = this;
    delete self._headers[name.toLowerCase()];
};
$10bcda68fa6d9d94$var$ClientRequest.prototype._onFinish = function() {
    var self = this;
    if (self._destroyed) return;
    var opts = self._opts;
    if ('timeout' in opts && opts.timeout !== 0) self.setTimeout(opts.timeout);
    var headersObj = self._headers;
    var body = null;
    if (opts.method !== 'GET' && opts.method !== 'HEAD') body = new Blob(self._body, {
        type: (headersObj['content-type'] || {}).value || ''
    });
    // create flattened list of headers
    var headersList = [];
    Object.keys(headersObj).forEach(function(keyName) {
        var name = headersObj[keyName].name;
        var value = headersObj[keyName].value;
        if (Array.isArray(value)) value.forEach(function(v) {
            headersList.push([
                name,
                v
            ]);
        });
        else headersList.push([
            name,
            value
        ]);
    });
    if (self._mode === 'fetch') {
        var signal = null;
        if ($jjD4m.abortController) {
            var controller = new AbortController();
            signal = controller.signal;
            self._fetchAbortController = controller;
            if ('requestTimeout' in opts && opts.requestTimeout !== 0) self._fetchTimer = $parcel$global.setTimeout(function() {
                self.emit('requestTimeout');
                if (self._fetchAbortController) self._fetchAbortController.abort();
            }, opts.requestTimeout);
        }
        $parcel$global.fetch(self._opts.url, {
            method: self._opts.method,
            headers: headersList,
            body: body || undefined,
            mode: 'cors',
            credentials: opts.withCredentials ? 'include' : 'same-origin',
            signal: signal
        }).then(function(response) {
            self._fetchResponse = response;
            self._resetTimers(false);
            self._connect();
        }, function(reason) {
            self._resetTimers(true);
            if (!self._destroyed) self.emit('error', reason);
        });
    } else {
        var xhr = self._xhr = new $parcel$global.XMLHttpRequest();
        try {
            xhr.open(self._opts.method, self._opts.url, true);
        } catch (err) {
            $hPtJY.nextTick(function() {
                self.emit('error', err);
            });
            return;
        }
        // Can't set responseType on really old browsers
        if ('responseType' in xhr) xhr.responseType = self._mode;
        if ('withCredentials' in xhr) xhr.withCredentials = !!opts.withCredentials;
        if (self._mode === 'text' && 'overrideMimeType' in xhr) xhr.overrideMimeType('text/plain; charset=x-user-defined');
        if ('requestTimeout' in opts) {
            xhr.timeout = opts.requestTimeout;
            xhr.ontimeout = function() {
                self.emit('requestTimeout');
            };
        }
        headersList.forEach(function(header) {
            xhr.setRequestHeader(header[0], header[1]);
        });
        self._response = null;
        xhr.onreadystatechange = function() {
            switch(xhr.readyState){
                case $10bcda68fa6d9d94$var$rStates.LOADING:
                case $10bcda68fa6d9d94$var$rStates.DONE:
                    self._onXHRProgress();
                    break;
            }
        };
        // Necessary for streaming in Firefox, since xhr.response is ONLY defined
        // in onprogress, not in onreadystatechange with xhr.readyState = 3
        if (self._mode === 'moz-chunked-arraybuffer') xhr.onprogress = function() {
            self._onXHRProgress();
        };
        xhr.onerror = function() {
            if (self._destroyed) return;
            self._resetTimers(true);
            self.emit('error', new Error('XHR error'));
        };
        try {
            xhr.send(body);
        } catch (err) {
            $hPtJY.nextTick(function() {
                self.emit('error', err);
            });
            return;
        }
    }
};
/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */ function $10bcda68fa6d9d94$var$statusValid(xhr) {
    try {
        var status = xhr.status;
        return status !== null && status !== 0;
    } catch (e) {
        return false;
    }
}
$10bcda68fa6d9d94$var$ClientRequest.prototype._onXHRProgress = function() {
    var self = this;
    self._resetTimers(false);
    if (!$10bcda68fa6d9d94$var$statusValid(self._xhr) || self._destroyed) return;
    if (!self._response) self._connect();
    self._response._onXHRProgress(self._resetTimers.bind(self));
};
$10bcda68fa6d9d94$var$ClientRequest.prototype._connect = function() {
    var self = this;
    if (self._destroyed) return;
    self._response = new $10bcda68fa6d9d94$var$IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._resetTimers.bind(self));
    self._response.on('error', function(err) {
        self.emit('error', err);
    });
    self.emit('response', self._response);
};
$10bcda68fa6d9d94$var$ClientRequest.prototype._write = function(chunk, encoding, cb) {
    var self = this;
    self._body.push(chunk);
    cb();
};
$10bcda68fa6d9d94$var$ClientRequest.prototype._resetTimers = function(done) {
    var self = this;
    $parcel$global.clearTimeout(self._socketTimer);
    self._socketTimer = null;
    if (done) {
        $parcel$global.clearTimeout(self._fetchTimer);
        self._fetchTimer = null;
    } else if (self._socketTimeout) self._socketTimer = $parcel$global.setTimeout(function() {
        self.emit('timeout');
    }, self._socketTimeout);
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.abort = $10bcda68fa6d9d94$var$ClientRequest.prototype.destroy = function(err) {
    var self = this;
    self._destroyed = true;
    self._resetTimers(true);
    if (self._response) self._response._destroyed = true;
    if (self._xhr) self._xhr.abort();
    else if (self._fetchAbortController) self._fetchAbortController.abort();
    if (err) self.emit('error', err);
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.end = function(data, encoding, cb) {
    var self = this;
    if (typeof data === 'function') {
        cb = data;
        data = undefined;
    }
    $b6RFW.Writable.prototype.end.call(self, data, encoding, cb);
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.setTimeout = function(timeout, cb) {
    var self = this;
    if (cb) self.once('timeout', cb);
    self._socketTimeout = timeout;
    self._resetTimers(false);
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.flushHeaders = function() {};
$10bcda68fa6d9d94$var$ClientRequest.prototype.setNoDelay = function() {};
$10bcda68fa6d9d94$var$ClientRequest.prototype.setSocketKeepAlive = function() {};
// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var $10bcda68fa6d9d94$var$unsafeHeaders = [
    'accept-charset',
    'accept-encoding',
    'access-control-request-headers',
    'access-control-request-method',
    'connection',
    'content-length',
    'cookie',
    'cookie2',
    'date',
    'dnt',
    'expect',
    'host',
    'keep-alive',
    'origin',
    'referer',
    'te',
    'trailer',
    'transfer-encoding',
    'upgrade',
    'via'
];

});
parcelRegister("jjD4m", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $e0fe19014972c28c$export$e7aa7bc5c1b3cfb3, (v) => $e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 = v);
$parcel$export(module.exports, "writableStream", () => $e0fe19014972c28c$export$37489d82087dc5d1, (v) => $e0fe19014972c28c$export$37489d82087dc5d1 = v);
$parcel$export(module.exports, "abortController", () => $e0fe19014972c28c$export$f137bf8a46425a6f, (v) => $e0fe19014972c28c$export$f137bf8a46425a6f = v);
$parcel$export(module.exports, "arraybuffer", () => $e0fe19014972c28c$export$724c4efdc2b90612, (v) => $e0fe19014972c28c$export$724c4efdc2b90612 = v);
$parcel$export(module.exports, "msstream", () => $e0fe19014972c28c$export$a9aa1e45c4448986, (v) => $e0fe19014972c28c$export$a9aa1e45c4448986 = v);
$parcel$export(module.exports, "mozchunkedarraybuffer", () => $e0fe19014972c28c$export$4c3c163e941f6ba3, (v) => $e0fe19014972c28c$export$4c3c163e941f6ba3 = v);
$parcel$export(module.exports, "overrideMimeType", () => $e0fe19014972c28c$export$8f1269d6d73f87ef, (v) => $e0fe19014972c28c$export$8f1269d6d73f87ef = v);
var $e0fe19014972c28c$export$e7aa7bc5c1b3cfb3;
var $e0fe19014972c28c$export$37489d82087dc5d1;
var $e0fe19014972c28c$export$f137bf8a46425a6f;
// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
var $e0fe19014972c28c$export$724c4efdc2b90612;
// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
var $e0fe19014972c28c$export$a9aa1e45c4448986;
var $e0fe19014972c28c$export$4c3c163e941f6ba3;
// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
var $e0fe19014972c28c$export$8f1269d6d73f87ef;
$e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 = $e0fe19014972c28c$var$isFunction($parcel$global.fetch) && $e0fe19014972c28c$var$isFunction($parcel$global.ReadableStream);
$e0fe19014972c28c$export$37489d82087dc5d1 = $e0fe19014972c28c$var$isFunction($parcel$global.WritableStream);
$e0fe19014972c28c$export$f137bf8a46425a6f = $e0fe19014972c28c$var$isFunction($parcel$global.AbortController);
// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var $e0fe19014972c28c$var$xhr;
function $e0fe19014972c28c$var$getXHR() {
    // Cache the xhr value
    if ($e0fe19014972c28c$var$xhr !== undefined) return $e0fe19014972c28c$var$xhr;
    if ($parcel$global.XMLHttpRequest) {
        $e0fe19014972c28c$var$xhr = new $parcel$global.XMLHttpRequest();
        // If XDomainRequest is available (ie only, where xhr might not work
        // cross domain), use the page location. Otherwise use example.com
        // Note: this doesn't actually make an http request.
        try {
            $e0fe19014972c28c$var$xhr.open('GET', $parcel$global.XDomainRequest ? '/' : 'https://example.com');
        } catch (e) {
            $e0fe19014972c28c$var$xhr = null;
        }
    } else // Service workers don't have XHR
    $e0fe19014972c28c$var$xhr = null;
    return $e0fe19014972c28c$var$xhr;
}
function $e0fe19014972c28c$var$checkTypeSupport(type) {
    var xhr = $e0fe19014972c28c$var$getXHR();
    if (!xhr) return false;
    try {
        xhr.responseType = type;
        return xhr.responseType === type;
    } catch (e) {}
    return false;
}
$e0fe19014972c28c$export$724c4efdc2b90612 = $e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 || $e0fe19014972c28c$var$checkTypeSupport('arraybuffer');
$e0fe19014972c28c$export$a9aa1e45c4448986 = !$e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 && $e0fe19014972c28c$var$checkTypeSupport('ms-stream');
$e0fe19014972c28c$export$4c3c163e941f6ba3 = !$e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 && $e0fe19014972c28c$var$checkTypeSupport('moz-chunked-arraybuffer');
$e0fe19014972c28c$export$8f1269d6d73f87ef = $e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 || ($e0fe19014972c28c$var$getXHR() ? $e0fe19014972c28c$var$isFunction($e0fe19014972c28c$var$getXHR().overrideMimeType) : false);
function $e0fe19014972c28c$var$isFunction(value) {
    return typeof value === 'function';
}
$e0fe19014972c28c$var$xhr = null // Help gc
;

});

parcelRegister("6dXuF", function(module, exports) {

$parcel$export(module.exports, "readyStates", () => $48821b31b3e528df$export$8e4da25483e314e6, (v) => $48821b31b3e528df$export$8e4da25483e314e6 = v);
$parcel$export(module.exports, "IncomingMessage", () => $48821b31b3e528df$export$9d4333345ffa4fd6, (v) => $48821b31b3e528df$export$9d4333345ffa4fd6 = v);
var $48821b31b3e528df$export$8e4da25483e314e6;
var $48821b31b3e528df$export$9d4333345ffa4fd6;

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $48821b31b3e528df$require$Buffer = $6ZWSX.Buffer;

var $jjD4m = parcelRequire("jjD4m");

var $dlqwk = parcelRequire("dlqwk");

var $b6RFW = parcelRequire("b6RFW");
var $48821b31b3e528df$var$rStates = $48821b31b3e528df$export$8e4da25483e314e6 = {
    UNSENT: 0,
    OPENED: 1,
    HEADERS_RECEIVED: 2,
    LOADING: 3,
    DONE: 4
};
var $48821b31b3e528df$var$IncomingMessage = $48821b31b3e528df$export$9d4333345ffa4fd6 = function(xhr, response, mode, resetTimers) {
    var self = this;
    $b6RFW.Readable.call(self);
    self._mode = mode;
    self.headers = {};
    self.rawHeaders = [];
    self.trailers = {};
    self.rawTrailers = [];
    // Fake the 'close' event, but only once 'end' fires
    self.on('end', function() {
        // The nextTick is necessary to prevent the 'request' module from causing an infinite loop
        $hPtJY.nextTick(function() {
            self.emit('close');
        });
    });
    if (mode === 'fetch') {
        self._fetchResponse = response;
        self.url = response.url;
        self.statusCode = response.status;
        self.statusMessage = response.statusText;
        response.headers.forEach(function(header, key) {
            self.headers[key.toLowerCase()] = header;
            self.rawHeaders.push(key, header);
        });
        if ($jjD4m.writableStream) {
            var writable = new WritableStream({
                write: function(chunk) {
                    resetTimers(false);
                    return new Promise(function(resolve, reject) {
                        if (self._destroyed) reject();
                        else if (self.push($48821b31b3e528df$require$Buffer.from(chunk))) resolve();
                        else self._resumeFetch = resolve;
                    });
                },
                close: function() {
                    resetTimers(true);
                    if (!self._destroyed) self.push(null);
                },
                abort: function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit('error', err);
                }
            });
            try {
                response.body.pipeTo(writable).catch(function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit('error', err);
                });
                return;
            } catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
        }
        // fallback for when writableStream or pipeTo aren't available
        var reader = response.body.getReader();
        function read() {
            reader.read().then(function(result) {
                if (self._destroyed) return;
                resetTimers(result.done);
                if (result.done) {
                    self.push(null);
                    return;
                }
                self.push($48821b31b3e528df$require$Buffer.from(result.value));
                read();
            }).catch(function(err) {
                resetTimers(true);
                if (!self._destroyed) self.emit('error', err);
            });
        }
        read();
    } else {
        self._xhr = xhr;
        self._pos = 0;
        self.url = xhr.responseURL;
        self.statusCode = xhr.status;
        self.statusMessage = xhr.statusText;
        var headers = xhr.getAllResponseHeaders().split(/\r?\n/);
        headers.forEach(function(header) {
            var matches = header.match(/^([^:]+):\s*(.*)/);
            if (matches) {
                var key = matches[1].toLowerCase();
                if (key === 'set-cookie') {
                    if (self.headers[key] === undefined) self.headers[key] = [];
                    self.headers[key].push(matches[2]);
                } else if (self.headers[key] !== undefined) self.headers[key] += ', ' + matches[2];
                else self.headers[key] = matches[2];
                self.rawHeaders.push(matches[1], matches[2]);
            }
        });
        self._charset = 'x-user-defined';
        if (!$jjD4m.overrideMimeType) {
            var mimeType = self.rawHeaders['mime-type'];
            if (mimeType) {
                var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/);
                if (charsetMatch) self._charset = charsetMatch[1].toLowerCase();
            }
            if (!self._charset) self._charset = 'utf-8' // best guess
            ;
        }
    }
};
$dlqwk($48821b31b3e528df$var$IncomingMessage, $b6RFW.Readable);
$48821b31b3e528df$var$IncomingMessage.prototype._read = function() {
    var self = this;
    var resolve = self._resumeFetch;
    if (resolve) {
        self._resumeFetch = null;
        resolve();
    }
};
$48821b31b3e528df$var$IncomingMessage.prototype._onXHRProgress = function(resetTimers) {
    var self = this;
    var xhr = self._xhr;
    var response = null;
    switch(self._mode){
        case 'text':
            response = xhr.responseText;
            if (response.length > self._pos) {
                var newData = response.substr(self._pos);
                if (self._charset === 'x-user-defined') {
                    var buffer = $48821b31b3e528df$require$Buffer.alloc(newData.length);
                    for(var i = 0; i < newData.length; i++)buffer[i] = newData.charCodeAt(i) & 0xff;
                    self.push(buffer);
                } else self.push(newData, self._charset);
                self._pos = response.length;
            }
            break;
        case 'arraybuffer':
            if (xhr.readyState !== $48821b31b3e528df$var$rStates.DONE || !xhr.response) break;
            response = xhr.response;
            self.push($48821b31b3e528df$require$Buffer.from(new Uint8Array(response)));
            break;
        case 'moz-chunked-arraybuffer':
            response = xhr.response;
            if (xhr.readyState !== $48821b31b3e528df$var$rStates.LOADING || !response) break;
            self.push($48821b31b3e528df$require$Buffer.from(new Uint8Array(response)));
            break;
        case 'ms-stream':
            response = xhr.response;
            if (xhr.readyState !== $48821b31b3e528df$var$rStates.LOADING) break;
            var reader = new $parcel$global.MSStreamReader();
            reader.onprogress = function() {
                if (reader.result.byteLength > self._pos) {
                    self.push($48821b31b3e528df$require$Buffer.from(new Uint8Array(reader.result.slice(self._pos))));
                    self._pos = reader.result.byteLength;
                }
            };
            reader.onload = function() {
                resetTimers(true);
                self.push(null);
            };
            // reader.onerror = ??? // TODO: this
            reader.readAsArrayBuffer(response);
            break;
    }
    // The ms-stream case handles end separately in reader.onload()
    if (self._xhr.readyState === $48821b31b3e528df$var$rStates.DONE && self._mode !== 'ms-stream') {
        resetTimers(true);
        self.push(null);
    }
};

});


parcelRegister("h0kNM", function(module, exports) {
module.exports = $c61292941889f8f2$var$extend;
var $c61292941889f8f2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c61292941889f8f2$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($c61292941889f8f2$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});

parcelRegister("4rffA", function(module, exports) {
module.exports = {
    "100": "Continue",
    "101": "Switching Protocols",
    "102": "Processing",
    "200": "OK",
    "201": "Created",
    "202": "Accepted",
    "203": "Non-Authoritative Information",
    "204": "No Content",
    "205": "Reset Content",
    "206": "Partial Content",
    "207": "Multi-Status",
    "208": "Already Reported",
    "226": "IM Used",
    "300": "Multiple Choices",
    "301": "Moved Permanently",
    "302": "Found",
    "303": "See Other",
    "304": "Not Modified",
    "305": "Use Proxy",
    "307": "Temporary Redirect",
    "308": "Permanent Redirect",
    "400": "Bad Request",
    "401": "Unauthorized",
    "402": "Payment Required",
    "403": "Forbidden",
    "404": "Not Found",
    "405": "Method Not Allowed",
    "406": "Not Acceptable",
    "407": "Proxy Authentication Required",
    "408": "Request Timeout",
    "409": "Conflict",
    "410": "Gone",
    "411": "Length Required",
    "412": "Precondition Failed",
    "413": "Payload Too Large",
    "414": "URI Too Long",
    "415": "Unsupported Media Type",
    "416": "Range Not Satisfiable",
    "417": "Expectation Failed",
    "418": "I'm a teapot",
    "421": "Misdirected Request",
    "422": "Unprocessable Entity",
    "423": "Locked",
    "424": "Failed Dependency",
    "425": "Unordered Collection",
    "426": "Upgrade Required",
    "428": "Precondition Required",
    "429": "Too Many Requests",
    "431": "Request Header Fields Too Large",
    "451": "Unavailable For Legal Reasons",
    "500": "Internal Server Error",
    "501": "Not Implemented",
    "502": "Bad Gateway",
    "503": "Service Unavailable",
    "504": "Gateway Timeout",
    "505": "HTTP Version Not Supported",
    "506": "Variant Also Negotiates",
    "507": "Insufficient Storage",
    "508": "Loop Detected",
    "509": "Bandwidth Limit Exceeded",
    "510": "Not Extended",
    "511": "Network Authentication Required"
};

});


parcelRegister("cgLmW", function(module, exports) {

var $k6Qs9 = parcelRequire("k6Qs9");

var $biuEp = parcelRequire("biuEp");
var $8eebb92ac53798d1$var$https = module.exports;
for(var $8eebb92ac53798d1$var$key in $k6Qs9)if ($k6Qs9.hasOwnProperty($8eebb92ac53798d1$var$key)) $8eebb92ac53798d1$var$https[$8eebb92ac53798d1$var$key] = $k6Qs9[$8eebb92ac53798d1$var$key];
$8eebb92ac53798d1$var$https.request = function(params, cb) {
    params = $8eebb92ac53798d1$var$validateParams(params);
    return $k6Qs9.request.call(this, params, cb);
};
$8eebb92ac53798d1$var$https.get = function(params, cb) {
    params = $8eebb92ac53798d1$var$validateParams(params);
    return $k6Qs9.get.call(this, params, cb);
};
function $8eebb92ac53798d1$var$validateParams(params) {
    if (typeof params === 'string') params = $biuEp.parse(params);
    if (!params.protocol) params.protocol = 'https:';
    if (params.protocol !== 'https:') throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"');
    return params;
}

});

parcelRegister("ccDAZ", function(module, exports) {

$parcel$export(module.exports, "type", () => $8e2551e033e95cb5$export$bf9fb029d174d554, (v) => $8e2551e033e95cb5$export$bf9fb029d174d554 = v);
$parcel$export(module.exports, "arch", () => $8e2551e033e95cb5$export$7925d89f138dad5b, (v) => $8e2551e033e95cb5$export$7925d89f138dad5b = v);
var $8e2551e033e95cb5$export$edf525f30916fbb8;
var $8e2551e033e95cb5$export$640106f6dc7d2706;
var $8e2551e033e95cb5$export$3ea386628068cf62;
var $8e2551e033e95cb5$export$749d472264fad440;
var $8e2551e033e95cb5$export$8b931a48d9488767;
var $8e2551e033e95cb5$export$9123f37609399513;
var $8e2551e033e95cb5$export$9b60beb643db4d69;
var $8e2551e033e95cb5$export$bf9fb029d174d554;
var $8e2551e033e95cb5$export$23d3fad09dc44362;
var $8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5;
var $8e2551e033e95cb5$export$3bf7c33313eba0fe;
var $8e2551e033e95cb5$export$7925d89f138dad5b;
var $8e2551e033e95cb5$export$722a64dea1b767dc;
var $8e2551e033e95cb5$export$9e6c06a7d47f9af7;
var $8e2551e033e95cb5$export$6b76988456c0292f;
var $8e2551e033e95cb5$export$266d3b9babd1fc45;
var $8e2551e033e95cb5$export$c1d46b5ea6262c0b;
$8e2551e033e95cb5$export$edf525f30916fbb8 = function() {
    return 'LE';
};
$8e2551e033e95cb5$export$640106f6dc7d2706 = function() {
    if (typeof location !== 'undefined') return location.hostname;
    else return '';
};
$8e2551e033e95cb5$export$3ea386628068cf62 = function() {
    return [];
};
$8e2551e033e95cb5$export$749d472264fad440 = function() {
    return 0;
};
$8e2551e033e95cb5$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9b60beb643db4d69 = function() {
    return [];
};
$8e2551e033e95cb5$export$bf9fb029d174d554 = function() {
    return 'Browser';
};
$8e2551e033e95cb5$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== 'undefined') return navigator.appVersion;
    return '';
};
$8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5 = $8e2551e033e95cb5$export$3bf7c33313eba0fe = function() {
    return {};
};
$8e2551e033e95cb5$export$7925d89f138dad5b = function() {
    return 'javascript';
};
$8e2551e033e95cb5$export$722a64dea1b767dc = function() {
    return 'browser';
};
$8e2551e033e95cb5$export$9e6c06a7d47f9af7 = $8e2551e033e95cb5$export$6b76988456c0292f = function() {
    return '/tmp';
};
$8e2551e033e95cb5$export$266d3b9babd1fc45 = '\n';
$8e2551e033e95cb5$export$c1d46b5ea6262c0b = function() {
    return '/';
};

});

parcelRegister("aLPd9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7d76049ae6893146$var$ProgressEvent = /** @class */ function() {
    function ProgressEvent(type) {
        this.type = type;
        this.bubbles = false;
        this.cancelable = false;
        this.loaded = 0;
        this.lengthComputable = false;
        this.total = 0;
    }
    return ProgressEvent;
}();
module.exports.ProgressEvent = $7d76049ae6893146$var$ProgressEvent;

});

parcelRegister("2be49", function(module, exports) {
"use strict";
var $1967851345309b7a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1967851345309b7a$var$SecurityError = /** @class */ function(_super) {
    $1967851345309b7a$var$__extends(SecurityError, _super);
    function SecurityError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SecurityError;
}(Error);
module.exports.SecurityError = $1967851345309b7a$var$SecurityError;
var $1967851345309b7a$var$InvalidStateError = /** @class */ function(_super) {
    $1967851345309b7a$var$__extends(InvalidStateError, _super);
    function InvalidStateError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InvalidStateError;
}(Error);
module.exports.InvalidStateError = $1967851345309b7a$var$InvalidStateError;
var $1967851345309b7a$var$NetworkError = /** @class */ function(_super) {
    $1967851345309b7a$var$__extends(NetworkError, _super);
    function NetworkError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NetworkError;
}(Error);
module.exports.NetworkError = $1967851345309b7a$var$NetworkError;
var $1967851345309b7a$var$SyntaxError = /** @class */ function(_super) {
    $1967851345309b7a$var$__extends(SyntaxError, _super);
    function SyntaxError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SyntaxError;
}(Error);
module.exports.SyntaxError = $1967851345309b7a$var$SyntaxError;

});

parcelRegister("b4sDP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80f64902acacab3a$var$XMLHttpRequestEventTarget = /** @class */ function() {
    function XMLHttpRequestEventTarget() {
        this.listeners = {};
    }
    XMLHttpRequestEventTarget.prototype.addEventListener = function(eventType, listener) {
        eventType = eventType.toLowerCase();
        this.listeners[eventType] = this.listeners[eventType] || [];
        this.listeners[eventType].push(listener.handleEvent || listener);
    };
    XMLHttpRequestEventTarget.prototype.removeEventListener = function(eventType, listener) {
        eventType = eventType.toLowerCase();
        if (!this.listeners[eventType]) return;
        var index = this.listeners[eventType].indexOf(listener.handleEvent || listener);
        if (index < 0) return;
        this.listeners[eventType].splice(index, 1);
    };
    XMLHttpRequestEventTarget.prototype.dispatchEvent = function(event) {
        var eventType = event.type.toLowerCase();
        event.target = this; // TODO: set event.currentTarget?
        if (this.listeners[eventType]) for(var _i = 0, _a = this.listeners[eventType]; _i < _a.length; _i++){
            var listener_1 = _a[_i];
            listener_1.call(this, event);
        }
        var listener = this["on" + eventType];
        if (listener) listener.call(this, event);
        return true;
    };
    return XMLHttpRequestEventTarget;
}();
module.exports.XMLHttpRequestEventTarget = $80f64902acacab3a$var$XMLHttpRequestEventTarget;

});

parcelRegister("5Bw1p", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $41493f47c7155fd3$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $41493f47c7155fd3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $b4sDP = parcelRequire("b4sDP");
var $41493f47c7155fd3$var$XMLHttpRequestUpload = /** @class */ function(_super) {
    $41493f47c7155fd3$var$__extends(XMLHttpRequestUpload, _super);
    function XMLHttpRequestUpload() {
        var _this = _super.call(this) || this;
        _this._contentType = null;
        _this._body = null;
        _this._reset();
        return _this;
    }
    XMLHttpRequestUpload.prototype._reset = function() {
        this._contentType = null;
        this._body = null;
    };
    XMLHttpRequestUpload.prototype._setData = function(data) {
        if (data == null) return;
        if (typeof data === 'string') {
            if (data.length !== 0) this._contentType = 'text/plain;charset=UTF-8';
            this._body = new $41493f47c7155fd3$require$Buffer(data, 'utf-8');
        } else if ($41493f47c7155fd3$require$Buffer.isBuffer(data)) this._body = data;
        else if (data instanceof ArrayBuffer) {
            var body = new $41493f47c7155fd3$require$Buffer(data.byteLength);
            var view = new Uint8Array(data);
            for(var i = 0; i < data.byteLength; i++)body[i] = view[i];
            this._body = body;
        } else if (data.buffer && data.buffer instanceof ArrayBuffer) {
            var body = new $41493f47c7155fd3$require$Buffer(data.byteLength);
            var offset = data.byteOffset;
            var view = new Uint8Array(data.buffer);
            for(var i = 0; i < data.byteLength; i++)body[i] = view[i + offset];
            this._body = body;
        } else throw new Error("Unsupported send() data " + data);
    };
    XMLHttpRequestUpload.prototype._finalizeHeaders = function(headers, loweredHeaders) {
        if (this._contentType && !loweredHeaders['content-type']) headers['Content-Type'] = this._contentType;
        if (this._body) headers['Content-Length'] = this._body.length.toString();
    };
    XMLHttpRequestUpload.prototype._startUpload = function(request) {
        if (this._body) request.write(this._body);
        request.end();
    };
    return XMLHttpRequestUpload;
}($b4sDP.XMLHttpRequestEventTarget);
module.exports.XMLHttpRequestUpload = $41493f47c7155fd3$var$XMLHttpRequestUpload;

});

parcelRegister("cwLZu", function(module, exports) {

$parcel$export(module.exports, "CookieAccessInfo", () => $91edb328622de1f2$export$f88fc6dda7ae65f0, (v) => $91edb328622de1f2$export$f88fc6dda7ae65f0 = v);
$parcel$export(module.exports, "CookieJar", () => $91edb328622de1f2$export$991f683f69795c48, (v) => $91edb328622de1f2$export$991f683f69795c48 = v);
var $91edb328622de1f2$export$f88fc6dda7ae65f0;
var $91edb328622de1f2$export$bd0cf18531183c14;
var $91edb328622de1f2$export$991f683f69795c48;
/* jshint node: true */ (function() {
    "use strict";
    function CookieAccessInfo(domain, path, secure, script) {
        if (this instanceof CookieAccessInfo) {
            this.domain = domain || undefined;
            this.path = path || "/";
            this.secure = !!secure;
            this.script = !!script;
            return this;
        }
        return new CookieAccessInfo(domain, path, secure, script);
    }
    CookieAccessInfo.All = Object.freeze(Object.create(null));
    $91edb328622de1f2$export$f88fc6dda7ae65f0 = CookieAccessInfo;
    function Cookie(cookiestr, request_domain, request_path) {
        if (cookiestr instanceof Cookie) return cookiestr;
        if (this instanceof Cookie) {
            this.name = null;
            this.value = null;
            this.expiration_date = Infinity;
            this.path = String(request_path || "/");
            this.explicit_path = false;
            this.domain = request_domain || null;
            this.explicit_domain = false;
            this.secure = false; //how to define default?
            this.noscript = false; //httponly
            if (cookiestr) this.parse(cookiestr, request_domain, request_path);
            return this;
        }
        return new Cookie(cookiestr, request_domain, request_path);
    }
    $91edb328622de1f2$export$bd0cf18531183c14 = Cookie;
    Cookie.prototype.toString = function toString() {
        var str = [
            this.name + "=" + this.value
        ];
        if (this.expiration_date !== Infinity) str.push("expires=" + new Date(this.expiration_date).toGMTString());
        if (this.domain) str.push("domain=" + this.domain);
        if (this.path) str.push("path=" + this.path);
        if (this.secure) str.push("secure");
        if (this.noscript) str.push("httponly");
        return str.join("; ");
    };
    Cookie.prototype.toValueString = function toValueString() {
        return this.name + "=" + this.value;
    };
    var cookie_str_splitter = /[:](?=\s*[a-zA-Z0-9_\-]+\s*[=])/g;
    Cookie.prototype.parse = function parse(str, request_domain, request_path) {
        if (this instanceof Cookie) {
            var parts = str.split(";").filter(function(value) {
                return !!value;
            });
            var i;
            var pair = parts[0].match(/([^=]+)=([\s\S]*)/);
            if (!pair) {
                console.warn("Invalid cookie header encountered. Header: '" + str + "'");
                return;
            }
            var key = pair[1];
            var value = pair[2];
            if (typeof key !== 'string' || key.length === 0 || typeof value !== 'string') {
                console.warn("Unable to extract values from cookie header. Cookie: '" + str + "'");
                return;
            }
            this.name = key;
            this.value = value;
            for(i = 1; i < parts.length; i += 1){
                pair = parts[i].match(/([^=]+)(?:=([\s\S]*))?/);
                key = pair[1].trim().toLowerCase();
                value = pair[2];
                switch(key){
                    case "httponly":
                        this.noscript = true;
                        break;
                    case "expires":
                        this.expiration_date = value ? Number(Date.parse(value)) : Infinity;
                        break;
                    case "path":
                        this.path = value ? value.trim() : "";
                        this.explicit_path = true;
                        break;
                    case "domain":
                        this.domain = value ? value.trim() : "";
                        this.explicit_domain = !!this.domain;
                        break;
                    case "secure":
                        this.secure = true;
                        break;
                }
            }
            if (!this.explicit_path) this.path = request_path || "/";
            if (!this.explicit_domain) this.domain = request_domain;
            return this;
        }
        return new Cookie().parse(str, request_domain, request_path);
    };
    Cookie.prototype.matches = function matches(access_info) {
        if (access_info === CookieAccessInfo.All) return true;
        if (this.noscript && access_info.script || this.secure && !access_info.secure || !this.collidesWith(access_info)) return false;
        return true;
    };
    Cookie.prototype.collidesWith = function collidesWith(access_info) {
        if (this.path && !access_info.path || this.domain && !access_info.domain) return false;
        if (this.path && access_info.path.indexOf(this.path) !== 0) return false;
        if (this.explicit_path && access_info.path.indexOf(this.path) !== 0) return false;
        var access_domain = access_info.domain && access_info.domain.replace(/^[\.]/, '');
        var cookie_domain = this.domain && this.domain.replace(/^[\.]/, '');
        if (cookie_domain === access_domain) return true;
        if (cookie_domain) {
            if (!this.explicit_domain) return false; // we already checked if the domains were exactly the same
            var wildcard = access_domain.indexOf(cookie_domain);
            if (wildcard === -1 || wildcard !== access_domain.length - cookie_domain.length) return false;
            return true;
        }
        return true;
    };
    function CookieJar() {
        var cookies, cookies_list, collidable_cookie;
        if (this instanceof CookieJar) {
            cookies = Object.create(null); //name: [Cookie]
            this.setCookie = function setCookie(cookie, request_domain, request_path) {
                var remove, i;
                cookie = new Cookie(cookie, request_domain, request_path);
                //Delete the cookie if the set is past the current time
                remove = cookie.expiration_date <= Date.now();
                if (cookies[cookie.name] !== undefined) {
                    cookies_list = cookies[cookie.name];
                    for(i = 0; i < cookies_list.length; i += 1){
                        collidable_cookie = cookies_list[i];
                        if (collidable_cookie.collidesWith(cookie)) {
                            if (remove) {
                                cookies_list.splice(i, 1);
                                if (cookies_list.length === 0) delete cookies[cookie.name];
                                return false;
                            }
                            cookies_list[i] = cookie;
                            return cookie;
                        }
                    }
                    if (remove) return false;
                    cookies_list.push(cookie);
                    return cookie;
                }
                if (remove) return false;
                cookies[cookie.name] = [
                    cookie
                ];
                return cookies[cookie.name];
            };
            //returns a cookie
            this.getCookie = function getCookie(cookie_name, access_info) {
                var cookie, i;
                cookies_list = cookies[cookie_name];
                if (!cookies_list) return;
                for(i = 0; i < cookies_list.length; i += 1){
                    cookie = cookies_list[i];
                    if (cookie.expiration_date <= Date.now()) {
                        if (cookies_list.length === 0) delete cookies[cookie.name];
                        continue;
                    }
                    if (cookie.matches(access_info)) return cookie;
                }
            };
            //returns a list of cookies
            this.getCookies = function getCookies(access_info) {
                var matches = [], cookie_name, cookie;
                for(cookie_name in cookies){
                    cookie = this.getCookie(cookie_name, access_info);
                    if (cookie) matches.push(cookie);
                }
                matches.toString = function toString() {
                    return matches.join(":");
                };
                matches.toValueString = function toValueString() {
                    return matches.map(function(c) {
                        return c.toValueString();
                    }).join(';');
                };
                return matches;
            };
            return this;
        }
        return new CookieJar();
    }
    $91edb328622de1f2$export$991f683f69795c48 = CookieJar;
    //returns list of cookies that were set correctly. Cookies that are expired and removed are not returned.
    CookieJar.prototype.setCookies = function setCookies(cookies, request_domain, request_path) {
        cookies = Array.isArray(cookies) ? cookies : cookies.split(cookie_str_splitter);
        var successful = [], i, cookie;
        cookies = cookies.map(function(item) {
            return new Cookie(item, request_domain, request_path);
        });
        for(i = 0; i < cookies.length; i += 1){
            cookie = cookies[i];
            if (this.setCookie(cookie, request_domain, request_path)) successful.push(cookie);
        }
        return successful;
    };
})();

});




parcelRegister("1r79I", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /** @file index.js
 * @authors:
 *   Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $hA2kM = parcelRequire("hA2kM");
var $10bddd0402f46c53$require$errors = $hA2kM.errors;

var $3Rufp = parcelRequire("3Rufp");
var $10bddd0402f46c53$var$IpcProvider = function IpcProvider(path, net) {
    var _this = this;
    this.responseCallbacks = {};
    this.notificationCallbacks = [];
    this.path = path;
    this.connected = false;
    this.connection = net.connect({
        path: this.path
    });
    this.addDefaultEvents();
    // LISTEN FOR CONNECTION RESPONSES
    var callback = function(result) {
        /*jshint maxcomplexity: 6 */ var id = null;
        // get the id which matches the returned id
        if (Array.isArray(result)) result.forEach(function(load) {
            if (_this.responseCallbacks[load.id]) id = load.id;
        });
        else id = result.id;
        // notification
        if (!id && result.method.indexOf('_subscription') !== -1) _this.notificationCallbacks.forEach(function(callback) {
            if (typeof callback === 'function') callback(result);
        });
        else if (_this.responseCallbacks[id]) {
            _this.responseCallbacks[id](null, result);
            delete _this.responseCallbacks[id];
        }
    };
    // use oboe.js for Sockets
    if (net.constructor.name === 'Socket') $3Rufp(this.connection).done(callback);
    else this.connection.on('data', function(data) {
        _this._parseResponse(data.toString()).forEach(callback);
    });
};
/**
Will add the error and end event to timeout existing calls

@method addDefaultEvents
*/ $10bddd0402f46c53$var$IpcProvider.prototype.addDefaultEvents = function() {
    var _this = this;
    this.connection.on('connect', function() {
        _this.connected = true;
    });
    this.connection.on('close', function() {
        _this.connected = false;
    });
    this.connection.on('error', function() {
        _this._timeout();
    });
    this.connection.on('end', function() {
        _this._timeout();
    });
    this.connection.on('timeout', function() {
        _this._timeout();
    });
};
/**
 Will parse the response and make an array out of it.

 NOTE, this exists for backwards compatibility reasons.

 @method _parseResponse
 @param {String} data
 */ $10bddd0402f46c53$var$IpcProvider.prototype._parseResponse = function(data) {
    var _this = this, returnValues = [];
    // DE-CHUNKER
    var dechunkedData = data.replace(/\}[\n\r]?\{/g, '}|--|{') // }{
    .replace(/\}\][\n\r]?\[\{/g, '}]|--|[{') // }][{
    .replace(/\}[\n\r]?\[\{/g, '}|--|[{') // }[{
    .replace(/\}\][\n\r]?\{/g, '}]|--|{') // }]{
    .split('|--|');
    dechunkedData.forEach(function(data) {
        // prepend the last chunk
        if (_this.lastChunk) data = _this.lastChunk + data;
        var result = null;
        try {
            result = JSON.parse(data);
        } catch (e) {
            _this.lastChunk = data;
            // start timeout to cancel all requests
            clearTimeout(_this.lastChunkTimeout);
            _this.lastChunkTimeout = setTimeout(function() {
                _this._timeout();
                throw $10bddd0402f46c53$require$errors.InvalidResponse(data);
            }, 15000);
            return;
        }
        // cancel timeout and set chunk to null
        clearTimeout(_this.lastChunkTimeout);
        _this.lastChunk = null;
        if (result) returnValues.push(result);
    });
    return returnValues;
};
/**
Get the adds a callback to the responseCallbacks object,
which will be called if a response matching the response Id will arrive.

@method _addResponseCallback
*/ $10bddd0402f46c53$var$IpcProvider.prototype._addResponseCallback = function(payload, callback) {
    var id = payload.id || payload[0].id;
    var method = payload.method || payload[0].method;
    this.responseCallbacks[id] = callback;
    this.responseCallbacks[id].method = method;
};
/**
Timeout all requests when the end/error event is fired

@method _timeout
*/ $10bddd0402f46c53$var$IpcProvider.prototype._timeout = function() {
    for(var key in this.responseCallbacks)if (this.responseCallbacks.hasOwnProperty(key)) {
        this.responseCallbacks[key]($10bddd0402f46c53$require$errors.InvalidConnection('on IPC'));
        delete this.responseCallbacks[key];
    }
};
/**
 Try to reconnect

 @method reconnect
 */ $10bddd0402f46c53$var$IpcProvider.prototype.reconnect = function() {
    this.connection.connect({
        path: this.path
    });
};
$10bddd0402f46c53$var$IpcProvider.prototype.send = function(payload, callback) {
    // try reconnect, when connection is gone
    if (!this.connection.writable) this.connection.connect({
        path: this.path
    });
    this.connection.write(JSON.stringify(payload));
    this._addResponseCallback(payload, callback);
};
/**
Subscribes to provider events.provider

@method on
@param {String} type    'notification', 'connect', 'error', 'end' or 'data'
@param {Function} callback   the callback to call
*/ $10bddd0402f46c53$var$IpcProvider.prototype.on = function(type, callback) {
    if (typeof callback !== 'function') throw new Error('The second parameter callback must be a function.');
    switch(type){
        case 'data':
            this.notificationCallbacks.push(callback);
            break;
        // adds error, end, timeout, connect
        default:
            this.connection.on(type, callback);
            break;
    }
};
/**
 Subscribes to provider events.provider

 @method on
 @param {String} type    'connect', 'error', 'end' or 'data'
 @param {Function} callback   the callback to call
 */ $10bddd0402f46c53$var$IpcProvider.prototype.once = function(type, callback) {
    if (typeof callback !== 'function') throw new Error('The second parameter callback must be a function.');
    this.connection.once(type, callback);
};
/**
Removes event listener

@method removeListener
@param {String} type    'data', 'connect', 'error', 'end' or 'data'
@param {Function} callback   the callback to call
*/ $10bddd0402f46c53$var$IpcProvider.prototype.removeListener = function(type, callback) {
    var _this = this;
    switch(type){
        case 'data':
            this.notificationCallbacks.forEach(function(cb, index) {
                if (cb === callback) _this.notificationCallbacks.splice(index, 1);
            });
            break;
        default:
            this.connection.removeListener(type, callback);
            break;
    }
};
/**
Removes all event listeners

@method removeAllListeners
@param {String} type    'data', 'connect', 'error', 'end' or 'data'
*/ $10bddd0402f46c53$var$IpcProvider.prototype.removeAllListeners = function(type) {
    switch(type){
        case 'data':
            this.notificationCallbacks = [];
            break;
        default:
            this.connection.removeAllListeners(type);
            break;
    }
};
/**
Resets the providers, clears all callbacks

@method reset
*/ $10bddd0402f46c53$var$IpcProvider.prototype.reset = function() {
    this._timeout();
    this.notificationCallbacks = [];
    this.connection.removeAllListeners('error');
    this.connection.removeAllListeners('end');
    this.connection.removeAllListeners('timeout');
    this.addDefaultEvents();
};
/**
 * Returns the desired boolean.
 *
 * @method supportsSubscriptions
 * @returns {boolean}
 */ $10bddd0402f46c53$var$IpcProvider.prototype.supportsSubscriptions = function() {
    return true;
};
module.exports = $10bddd0402f46c53$var$IpcProvider;

});
parcelRegister("3Rufp", function(module, exports) {
/*!
 * v2.1.4-104-gc868b3a
 * 
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 7);
    /******/ }([
        /* 0 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() {
                return partialComplete;
            });
            /* unused harmony export compose */ /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() {
                return compose2;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() {
                return attr;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() {
                return lazyUnion;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return apply;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() {
                return varArgs;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() {
                return flip;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() {
                return lazyIntersection;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() {
                return noop;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return always;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() {
                return functor;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lists__ = __webpack_require__(1);
            /**
 * Partially complete a function.
 *
 *  var add3 = partialComplete( function add(a,b){return a+b}, 3 );
 *
 *  add3(4) // gives 7
 *
 *  function wrap(left, right, cen){return left + " " + cen + " " + right;}
 *
 *  var pirateGreeting = partialComplete( wrap , "I'm", ", a mighty pirate!" );
 *
 *  pirateGreeting("Guybrush Threepwood");
 *  // gives "I'm Guybrush Threepwood, a mighty pirate!"
 */ var partialComplete = varArgs(function(fn, args) {
                // this isn't the shortest way to write this but it does
                // avoid creating a new array each time to pass to fn.apply,
                // otherwise could just call boundArgs.concat(callArgs)
                var numBoundArgs = args.length;
                return varArgs(function(callArgs) {
                    for(var i = 0; i < callArgs.length; i++)args[numBoundArgs + i] = callArgs[i];
                    args.length = numBoundArgs + callArgs.length;
                    return fn.apply(this, args);
                });
            });
            /**
* Compose zero or more functions:
*
*    compose(f1, f2, f3)(x) = f1(f2(f3(x))))
*
* The last (inner-most) function may take more than one parameter:
*
*    compose(f1, f2, f3)(x,y) = f1(f2(f3(x,y))))
*/ var compose = varArgs(function(fns) {
                var fnsList = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["c" /* arrayAsList */ ])(fns);
                function next(params, curFn) {
                    return [
                        apply(params, curFn)
                    ];
                }
                return varArgs(function(startParams) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__lists__["f" /* foldR */ ])(next, startParams, fnsList)[0];
                });
            });
            /**
* A more optimised version of compose that takes exactly two functions
* @param f1
* @param f2
*/ function compose2(f1, f2) {
                return function() {
                    return f1.call(this, f2.apply(this, arguments));
                };
            }
            /**
* Generic form for a function to get a property from an object
*
*    var o = {
*       foo:'bar'
*    }
*
*    var getFoo = attr('foo')
*
*    fetFoo(o) // returns 'bar'
*
* @param {String} key the property name
*/ function attr(key) {
                return function(o) {
                    return o[key];
                };
            }
            /**
* Call a list of functions with the same args until one returns a
* truthy result. Similar to the || operator.
*
* So:
*      lazyUnion([f1,f2,f3 ... fn])( p1, p2 ... pn )
*
* Is equivalent to:
*      apply([p1, p2 ... pn], f1) ||
*      apply([p1, p2 ... pn], f2) ||
*      apply([p1, p2 ... pn], f3) ... apply(fn, [p1, p2 ... pn])
*
* @returns the first return value that is given that is truthy.
*/ var lazyUnion = varArgs(function(fns) {
                return varArgs(function(params) {
                    var maybeValue;
                    for(var i = 0; i < attr('length')(fns); i++){
                        maybeValue = apply(params, fns[i]);
                        if (maybeValue) return maybeValue;
                    }
                });
            });
            /**
* This file declares various pieces of functional programming.
*
* This isn't a general purpose functional library, to keep things small it
* has just the parts useful for Oboe.js.
*/ /**
* Call a single function with the given arguments array.
* Basically, a functional-style version of the OO-style Function#apply for
* when we don't care about the context ('this') of the call.
*
* The order of arguments allows partial completion of the arguments array
*/ function apply(args, fn) {
                return fn.apply(undefined, args);
            }
            /**
* Define variable argument functions but cut out all that tedious messing about
* with the arguments object. Delivers the variable-length part of the arguments
* list as an array.
*
* Eg:
*
* var myFunction = varArgs(
*    function( fixedArgument, otherFixedArgument, variableNumberOfArguments ){
*       console.log( variableNumberOfArguments );
*    }
* )
*
* myFunction('a', 'b', 1, 2, 3); // logs [1,2,3]
*
* var myOtherFunction = varArgs(function( variableNumberOfArguments ){
*    console.log( variableNumberOfArguments );
* })
*
* myFunction(1, 2, 3); // logs [1,2,3]
*
*/ function varArgs(fn) {
                var numberOfFixedArguments = fn.length - 1;
                var slice = Array.prototype.slice;
                if (numberOfFixedArguments === 0) // an optimised case for when there are no fixed args:
                return function() {
                    return fn.call(this, slice.call(arguments));
                };
                else if (numberOfFixedArguments === 1) // an optimised case for when there are is one fixed args:
                return function() {
                    return fn.call(this, arguments[0], slice.call(arguments, 1));
                };
                // general case
                // we know how many arguments fn will always take. Create a
                // fixed-size array to hold that many, to be re-used on
                // every call to the returned function
                var argsHolder = Array(fn.length);
                return function() {
                    for(var i = 0; i < numberOfFixedArguments; i++)argsHolder[i] = arguments[i];
                    argsHolder[numberOfFixedArguments] = slice.call(arguments, numberOfFixedArguments);
                    return fn.apply(this, argsHolder);
                };
            }
            /**
* Swap the order of parameters to a binary function
*
* A bit like this flip: http://zvon.org/other/haskell/Outputprelude/flip_f.html
*/ function flip(fn) {
                return function(a, b) {
                    return fn(b, a);
                };
            }
            /**
* Create a function which is the intersection of two other functions.
*
* Like the && operator, if the first is truthy, the second is never called,
* otherwise the return value from the second is returned.
*/ function lazyIntersection(fn1, fn2) {
                return function(param) {
                    return fn1(param) && fn2(param);
                };
            }
            /**
* A function which does nothing
*/ function noop() {}
            /**
* A function which is always happy
*/ function always() {
                return true;
            }
            /**
* Create a function which always returns the same
* value
*
* var return3 = functor(3);
*
* return3() // gives 3
* return3() // still gives 3
* return3() // will always give 3
*/ function functor(val) {
                return function() {
                    return val;
                };
            }
        /***/ },
        /* 1 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() {
                return cons;
            });
            /* unused harmony export emptyList */ /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() {
                return head;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() {
                return tail;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() {
                return arrayAsList;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() {
                return list;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() {
                return listAsArray;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() {
                return map;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() {
                return foldR;
            });
            /* unused harmony export foldR1 */ /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() {
                return without;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return all;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return applyEach;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() {
                return reverseList;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() {
                return first;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functional__ = __webpack_require__(0);
            /**
 * Like cons in Lisp
 */ function cons(x, xs) {
                /* Internally lists are linked 2-element Javascript arrays.

      Ideally the return here would be Object.freeze([x,xs])
      so that bugs related to mutation are found fast.
      However, cons is right on the critical path for
      performance and this slows oboe-mark down by
      ~25%. Under theoretical future JS engines that freeze more
      efficiently (possibly even use immutability to
      run faster) this should be considered for
      restoration.
   */ return [
                    x,
                    xs
                ];
            }
            /**
 * The empty list
 */ var emptyList = null;
            /**
 * Get the head of a list.
 *
 * Ie, head(cons(a,b)) = a
 */ var head = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["c" /* attr */ ])(0);
            /**
 * Get the tail of a list.
 *
 * Ie, tail(cons(a,b)) = b
 */ var tail = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["c" /* attr */ ])(1);
            /**
 * Converts an array to a list
 *
 *    asList([a,b,c])
 *
 * is equivalent to:
 *
 *    cons(a, cons(b, cons(c, emptyList)))
 **/ function arrayAsList(inputArray) {
                return reverseList(inputArray.reduce(Object(__WEBPACK_IMPORTED_MODULE_0__functional__["e" /* flip */ ])(cons), emptyList));
            }
            /**
 * A varargs version of arrayAsList. Works a bit like list
 * in LISP.
 *
 *    list(a,b,c)
 *
 * is equivalent to:
 *
 *    cons(a, cons(b, cons(c, emptyList)))
 */ var list = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["k" /* varArgs */ ])(arrayAsList);
            /**
 * Convert a list back to a js native array
 */ function listAsArray(list) {
                return foldR(function(arraySoFar, listItem) {
                    arraySoFar.unshift(listItem);
                    return arraySoFar;
                }, [], list);
            }
            /**
 * Map a function over a list
 */ function map(fn, list) {
                return list ? cons(fn(head(list)), map(fn, tail(list))) : emptyList;
            }
            /**
 * foldR implementation. Reduce a list down to a single value.
 *
 * @pram {Function} fn     (rightEval, curVal) -> result
 */ function foldR(fn, startValue, list) {
                return list ? fn(foldR(fn, startValue, tail(list)), head(list)) : startValue;
            }
            /**
 * foldR implementation. Reduce a list down to a single value.
 *
 * @pram {Function} fn     (rightEval, curVal) -> result
 */ function foldR1(fn, list) {
                return tail(list) ? fn(foldR1(fn, tail(list)), head(list)) : head(list);
            }
            /**
 * Return a list like the one given but with the first instance equal
 * to item removed
 */ function without(list, test, removedFn) {
                return withoutInner(list, removedFn || __WEBPACK_IMPORTED_MODULE_0__functional__["i" /* noop */ ]);
                function withoutInner(subList, removedFn) {
                    return subList ? test(head(subList)) ? (removedFn(head(subList)), tail(subList)) : cons(head(subList), withoutInner(tail(subList), removedFn)) : emptyList;
                }
            }
            /**
 * Returns true if the given function holds for every item in
 * the list, false otherwise
 */ function all(fn, list) {
                return !list || fn(head(list)) && all(fn, tail(list));
            }
            /**
 * Call every function in a list of functions with the same arguments
 *
 * This doesn't make any sense if we're doing pure functional because
 * it doesn't return anything. Hence, this is only really useful if the
 * functions being called have side-effects.
 */ function applyEach(fnList, args) {
                if (fnList) {
                    head(fnList).apply(null, args);
                    applyEach(tail(fnList), args);
                }
            }
            /**
 * Reverse the order of a list
 */ function reverseList(list) {
                // js re-implementation of 3rd solution from:
                //    http://www.haskell.org/haskellwiki/99_questions/Solutions/5
                function reverseInner(list, reversedAlready) {
                    if (!list) return reversedAlready;
                    return reverseInner(tail(list), cons(head(list), reversedAlready));
                }
                return reverseInner(list, emptyList);
            }
            function first(test, list) {
                return list && (test(head(list)) ? head(list) : first(test, tail(list)));
            }
        /***/ },
        /* 2 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() {
                return isOfType;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() {
                return len;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() {
                return isString;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return defined;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return hasAllProperties;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lists__ = __webpack_require__(1);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functional__ = __webpack_require__(0);
            /**
 * This file defines some loosely associated syntactic sugar for
 * Javascript programming
 */ /**
 * Returns true if the given candidate is of type T
 */ function isOfType(T, maybeSomething) {
                return maybeSomething && maybeSomething.constructor === T;
            }
            var len = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["c" /* attr */ ])('length');
            var isString = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(isOfType, String);
            /**
 * I don't like saying this:
 *
 *    foo !=== undefined
 *
 * because of the double-negative. I find this:
 *
 *    defined(foo)
 *
 * easier to read.
 */ function defined(value) {
                return value !== undefined;
            }
            /**
 * Returns true if object o has a key named like every property in
 * the properties array. Will give false if any are missing, or if o
 * is not an object.
 */ function hasAllProperties(fieldList, o) {
                return o instanceof Object && Object(__WEBPACK_IMPORTED_MODULE_0__lists__["a" /* all */ ])(function(field) {
                    return field in o;
                }, fieldList);
            }
        /***/ },
        /* 3 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() {
                return NODE_OPENED;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() {
                return NODE_CLOSED;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() {
                return NODE_SWAP;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() {
                return NODE_DROP;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return FAIL_EVENT;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() {
                return ROOT_NODE_FOUND;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() {
                return ROOT_PATH_FOUND;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() {
                return HTTP_START;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() {
                return STREAM_DATA;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() {
                return STREAM_END;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return ABORTING;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() {
                return SAX_KEY;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() {
                return SAX_VALUE_OPEN;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() {
                return SAX_VALUE_CLOSE;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() {
                return errorReport;
            });
            /**
 * This file declares some constants to use as names for event types.
 */ // the events which are never exported are kept as
            // the smallest possible representation, in numbers:
            var _S = 1;
            // fired whenever a new node starts in the JSON stream:
            var NODE_OPENED = _S++;
            // fired whenever a node closes in the JSON stream:
            var NODE_CLOSED = _S++;
            // called if a .node callback returns a value -
            var NODE_SWAP = _S++;
            var NODE_DROP = _S++;
            var FAIL_EVENT = 'fail';
            var ROOT_NODE_FOUND = _S++;
            var ROOT_PATH_FOUND = _S++;
            var HTTP_START = 'start';
            var STREAM_DATA = 'data';
            var STREAM_END = 'end';
            var ABORTING = _S++;
            // SAX events butchered from Clarinet
            var SAX_KEY = _S++;
            var SAX_VALUE_OPEN = _S++;
            var SAX_VALUE_CLOSE = _S++;
            function errorReport(statusCode, body, error) {
                try {
                    var jsonBody = JSON.parse(body);
                } catch (e) {}
                return {
                    statusCode: statusCode,
                    body: body,
                    jsonBody: jsonBody,
                    thrown: error
                };
            }
        /***/ },
        /* 4 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return namedNode;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return keyOf;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() {
                return nodeOf;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functional__ = __webpack_require__(0);
            /**
 * Get a new key->node mapping
 *
 * @param {String|Number} key
 * @param {Object|Array|String|Number|null} node a value found in the json
 */ function namedNode(key, node) {
                return {
                    key: key,
                    node: node
                };
            }
            /** get the key of a namedNode */ var keyOf = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["c" /* attr */ ])('key');
            /** get the node from a namedNode */ var nodeOf = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["c" /* attr */ ])('node');
        /***/ },
        /* 5 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return oboe;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lists__ = __webpack_require__(1);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functional__ = __webpack_require__(0);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaults__ = __webpack_require__(8);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wire__ = __webpack_require__(9);
            // export public API
            function oboe(arg1) {
                // We use duck-typing to detect if the parameter given is a stream, with the
                // below list of parameters.
                // Unpipe and unshift would normally be present on a stream but this breaks
                // compatibility with Request streams.
                // See https://github.com/jimhigson/oboe.js/issues/65
                var nodeStreamMethodNames = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["h" /* list */ ])('resume', 'pause', 'pipe');
                var isStream = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* hasAllProperties */ ], nodeStreamMethodNames);
                if (arg1) {
                    if (isStream(arg1) || Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* isString */ ])(arg1)) //  simple version for GETs. Signature is:
                    //    oboe( url )
                    //  or, under node:
                    //    oboe( readableStream )
                    return Object(__WEBPACK_IMPORTED_MODULE_3__defaults__["a" /* applyDefaults */ ])(__WEBPACK_IMPORTED_MODULE_4__wire__["a" /* wire */ ], arg1 // url
                    );
                    else // method signature is:
                    //    oboe({method:m, url:u, body:b, headers:{...}})
                    return Object(__WEBPACK_IMPORTED_MODULE_3__defaults__["a" /* applyDefaults */ ])(__WEBPACK_IMPORTED_MODULE_4__wire__["a" /* wire */ ], arg1.url, arg1.method, arg1.body, arg1.headers, arg1.withCredentials, arg1.cached);
                } else // wire up a no-AJAX, no-stream Oboe. Will have to have content
                // fed in externally and using .emit.
                return Object(__WEBPACK_IMPORTED_MODULE_4__wire__["a" /* wire */ ])();
            }
            /* oboe.drop is a special value. If a node callback returns this value the
   parsed node is deleted from the JSON
 */ oboe.drop = function() {
                return oboe.drop;
            };
        /***/ },
        /* 6 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return incrementalContentBuilder;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return ROOT_PATH;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__(3);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascent__ = __webpack_require__(4);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lists__ = __webpack_require__(1);
            /**
 * This file provides various listeners which can be used to build up
 * a changing ascent based on the callbacks provided by Clarinet. It listens
 * to the low-level events from Clarinet and emits higher-level ones.
 *
 * The building up is stateless so to track a JSON file
 * ascentManager.js is required to store the ascent state
 * between calls.
 */ /**
 * A special value to use in the path list to represent the path 'to' a root
 * object (which doesn't really have any path). This prevents the need for
 * special-casing detection of the root object and allows it to be treated
 * like any other object. We might think of this as being similar to the
 * 'unnamed root' domain ".", eg if I go to
 * http://en.wikipedia.org./wiki/En/Main_page the dot after 'org' deliminates
 * the unnamed root of the DNS.
 *
 * This is kept as an object to take advantage that in Javascript's OO objects
 * are guaranteed to be distinct, therefore no other object can possibly clash
 * with this one. Strings, numbers etc provide no such guarantee.
 **/ var ROOT_PATH = {};
            /**
 * Create a new set of handlers for clarinet's events, bound to the emit
 * function given.
 */ function incrementalContentBuilder(oboeBus) {
                var emitNodeOpened = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["f" /* NODE_OPENED */ ]).emit;
                var emitNodeClosed = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["d" /* NODE_CLOSED */ ]).emit;
                var emitRootOpened = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["i" /* ROOT_PATH_FOUND */ ]).emit;
                var emitRootClosed = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["h" /* ROOT_NODE_FOUND */ ]).emit;
                function arrayIndicesAreKeys(possiblyInconsistentAscent, newDeepestNode) {
                    /* for values in arrays we aren't pre-warned of the coming paths
         (Clarinet gives no call to onkey like it does for values in objects)
         so if we are in an array we need to create this path ourselves. The
         key will be len(parentNode) because array keys are always sequential
         numbers. */ var parentNode = Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["c" /* nodeOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_3__lists__["g" /* head */ ])(possiblyInconsistentAscent));
                    return Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* isOfType */ ])(Array, parentNode) ? keyFound(possiblyInconsistentAscent, Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* len */ ])(parentNode), newDeepestNode) : possiblyInconsistentAscent;
                }
                function nodeOpened(ascent, newDeepestNode) {
                    if (!ascent) {
                        // we discovered the root node,
                        emitRootOpened(newDeepestNode);
                        return keyFound(ascent, ROOT_PATH, newDeepestNode);
                    }
                    // we discovered a non-root node
                    var arrayConsistentAscent = arrayIndicesAreKeys(ascent, newDeepestNode);
                    var ancestorBranches = Object(__WEBPACK_IMPORTED_MODULE_3__lists__["l" /* tail */ ])(arrayConsistentAscent);
                    var previouslyUnmappedName = Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["a" /* keyOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_3__lists__["g" /* head */ ])(arrayConsistentAscent));
                    appendBuiltContent(ancestorBranches, previouslyUnmappedName, newDeepestNode);
                    return Object(__WEBPACK_IMPORTED_MODULE_3__lists__["d" /* cons */ ])(Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["b" /* namedNode */ ])(previouslyUnmappedName, newDeepestNode), ancestorBranches);
                }
                /**
    * Add a new value to the object we are building up to represent the
    * parsed JSON
    */ function appendBuiltContent(ancestorBranches, key, node) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["c" /* nodeOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_3__lists__["g" /* head */ ])(ancestorBranches))[key] = node;
                }
                /**
    * For when we find a new key in the json.
    *
    * @param {String|Number|Object} newDeepestName the key. If we are in an
    *    array will be a number, otherwise a string. May take the special
    *    value ROOT_PATH if the root node has just been found
    *
    * @param {String|Number|Object|Array|Null|undefined} [maybeNewDeepestNode]
    *    usually this won't be known so can be undefined. Can't use null
    *    to represent unknown because null is a valid value in JSON
    **/ function keyFound(ascent, newDeepestName, maybeNewDeepestNode) {
                    if (ascent) // If we have the key but (unless adding to an array) no known value
                    // yet. Put that key in the output but against no defined value:
                    appendBuiltContent(ascent, newDeepestName, maybeNewDeepestNode);
                    var ascentWithNewPath = Object(__WEBPACK_IMPORTED_MODULE_3__lists__["d" /* cons */ ])(Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["b" /* namedNode */ ])(newDeepestName, maybeNewDeepestNode), ascent);
                    emitNodeOpened(ascentWithNewPath);
                    return ascentWithNewPath;
                }
                /**
    * For when the current node ends.
    */ function nodeClosed(ascent) {
                    emitNodeClosed(ascent);
                    return Object(__WEBPACK_IMPORTED_MODULE_3__lists__["l" /* tail */ ])(ascent) || // If there are no nodes left in the ascent the root node
                    // just closed. Emit a special event for this:
                    emitRootClosed(Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["c" /* nodeOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_3__lists__["g" /* head */ ])(ascent)));
                }
                var contentBuilderHandlers = {};
                contentBuilderHandlers[__WEBPACK_IMPORTED_MODULE_0__events__["l" /* SAX_VALUE_OPEN */ ]] = nodeOpened;
                contentBuilderHandlers[__WEBPACK_IMPORTED_MODULE_0__events__["k" /* SAX_VALUE_CLOSE */ ]] = nodeClosed;
                contentBuilderHandlers[__WEBPACK_IMPORTED_MODULE_0__events__["j" /* SAX_KEY */ ]] = keyFound;
                return contentBuilderHandlers;
            }
        /***/ },
        /* 7 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: true
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__publicApi__ = __webpack_require__(5);
            /* harmony default export */ __webpack_exports__["default"] = __WEBPACK_IMPORTED_MODULE_0__publicApi__["a" /* oboe */ ];
        /***/ },
        /* 8 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return applyDefaults;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(2);
            function applyDefaults(passthrough, url, httpMethodName, body, headers, withCredentials, cached) {
                headers = headers ? JSON.parse(JSON.stringify(headers)) : {};
                if (body) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* isString */ ])(body)) {
                        // If the body is not a string, stringify it. This allows objects to
                        // be given which will be sent as JSON.
                        body = JSON.stringify(body);
                        // Default Content-Type to JSON unless given otherwise.
                        headers['Content-Type'] = headers['Content-Type'] || 'application/json';
                    }
                    headers['Content-Length'] = headers['Content-Length'] || body.length;
                } else body = null;
                // support cache busting like jQuery.ajax({cache:false})
                function modifiedUrl(baseUrl, cached) {
                    if (cached === false) {
                        if (baseUrl.indexOf('?') === -1) baseUrl += '?';
                        else baseUrl += '&';
                        baseUrl += '_=' + new Date().getTime();
                    }
                    return baseUrl;
                }
                return passthrough(httpMethodName || 'GET', modifiedUrl(url, cached), body, headers, withCredentials || false);
            }
        /***/ },
        /* 9 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return wire;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pubSub__ = __webpack_require__(10);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascentManager__ = __webpack_require__(12);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__incrementalContentBuilder__ = __webpack_require__(6);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__patternAdapter__ = __webpack_require__(13);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsonPath__ = __webpack_require__(14);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__instanceApi__ = __webpack_require__(16);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_clarinet__ = __webpack_require__(17);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__streamingHttp_node__ = __webpack_require__(18);
            /**
 * This file sits just behind the API which is used to attain a new
 * Oboe instance. It creates the new components that are required
 * and introduces them to each other.
 */ function wire(httpMethodName, contentSource, body, headers, withCredentials) {
                var oboeBus = Object(__WEBPACK_IMPORTED_MODULE_0__pubSub__["a" /* pubSub */ ])();
                // Wire the input stream in if we are given a content source.
                // This will usually be the case. If not, the instance created
                // will have to be passed content from an external source.
                if (contentSource) Object(__WEBPACK_IMPORTED_MODULE_7__streamingHttp_node__["b" /* streamingHttp */ ])(oboeBus, Object(__WEBPACK_IMPORTED_MODULE_7__streamingHttp_node__["a" /* httpTransport */ ])(), httpMethodName, contentSource, body, headers, withCredentials);
                Object(__WEBPACK_IMPORTED_MODULE_6__libs_clarinet__["a" /* clarinet */ ])(oboeBus);
                Object(__WEBPACK_IMPORTED_MODULE_1__ascentManager__["a" /* ascentManager */ ])(oboeBus, Object(__WEBPACK_IMPORTED_MODULE_2__incrementalContentBuilder__["b" /* incrementalContentBuilder */ ])(oboeBus));
                Object(__WEBPACK_IMPORTED_MODULE_3__patternAdapter__["a" /* patternAdapter */ ])(oboeBus, __WEBPACK_IMPORTED_MODULE_4__jsonPath__["a" /* jsonPathCompiler */ ]);
                return Object(__WEBPACK_IMPORTED_MODULE_5__instanceApi__["a" /* instanceApi */ ])(oboeBus, contentSource);
            }
        /***/ },
        /* 10 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return pubSub;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__singleEventPubSub__ = __webpack_require__(11);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functional__ = __webpack_require__(0);
            /**
 * pubSub is a curried interface for listening to and emitting
 * events.
 *
 * If we get a bus:
 *
 *    var bus = pubSub();
 *
 * We can listen to event 'foo' like:
 *
 *    bus('foo').on(myCallback)
 *
 * And emit event foo like:
 *
 *    bus('foo').emit()
 *
 * or, with a parameter:
 *
 *    bus('foo').emit('bar')
 *
 * All functions can be cached and don't need to be
 * bound. Ie:
 *
 *    var fooEmitter = bus('foo').emit
 *    fooEmitter('bar');  // emit an event
 *    fooEmitter('baz');  // emit another
 *
 * There's also an uncurried[1] shortcut for .emit and .on:
 *
 *    bus.on('foo', callback)
 *    bus.emit('foo', 'bar')
 *
 * [1]: http://zvon.org/other/haskell/Outputprelude/uncurry_f.html
 */ function pubSub() {
                var singles = {};
                var newListener = newSingle('newListener');
                var removeListener = newSingle('removeListener');
                function newSingle(eventName) {
                    singles[eventName] = Object(__WEBPACK_IMPORTED_MODULE_0__singleEventPubSub__["a" /* singleEventPubSub */ ])(eventName, newListener, removeListener);
                    return singles[eventName];
                }
                /** pubSub instances are functions */ function pubSubInstance(eventName) {
                    return singles[eventName] || newSingle(eventName);
                }
                // add convenience EventEmitter-style uncurried form of 'emit' and 'on'
                [
                    'emit',
                    'on',
                    'un'
                ].forEach(function(methodName) {
                    pubSubInstance[methodName] = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["k" /* varArgs */ ])(function(eventName, parameters) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__functional__["b" /* apply */ ])(parameters, pubSubInstance(eventName)[methodName]);
                    });
                });
                return pubSubInstance;
            }
        /***/ },
        /* 11 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return singleEventPubSub;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lists__ = __webpack_require__(1);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functional__ = __webpack_require__(0);
            /**
 * A pub/sub which is responsible for a single event type. A
 * multi-event type event bus is created by pubSub by collecting
 * several of these.
 *
 * @param {String} eventType
 *    the name of the events managed by this singleEventPubSub
 * @param {singleEventPubSub} [newListener]
 *    place to notify of new listeners
 * @param {singleEventPubSub} [removeListener]
 *    place to notify of when listeners are removed
 */ function singleEventPubSub(eventType, newListener, removeListener) {
                /** we are optimised for emitting events over firing them.
   *  As well as the tuple list which stores event ids and
   *  listeners there is a list with just the listeners which
   *  can be iterated more quickly when we are emitting
   */ var listenerTupleList, listenerList;
                function hasId(id) {
                    return function(tuple) {
                        return tuple.id === id;
                    };
                }
                return {
                    /**
     * @param {Function} listener
     * @param {*} listenerId
     *    an id that this listener can later by removed by.
     *    Can be of any type, to be compared to other ids using ==
     */ on: function(listener, listenerId) {
                        var tuple = {
                            listener: listener,
                            id: listenerId || listener // when no id is given use the
                        };
                        if (newListener) newListener.emit(eventType, listener, tuple.id);
                        listenerTupleList = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["d" /* cons */ ])(tuple, listenerTupleList);
                        listenerList = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["d" /* cons */ ])(listener, listenerList);
                        return this // chaining
                        ;
                    },
                    emit: function() {
                        Object(__WEBPACK_IMPORTED_MODULE_0__lists__["b" /* applyEach */ ])(listenerList, arguments);
                    },
                    un: function(listenerId) {
                        var removed;
                        listenerTupleList = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["m" /* without */ ])(listenerTupleList, hasId(listenerId), function(tuple) {
                            removed = tuple;
                        });
                        if (removed) {
                            listenerList = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["m" /* without */ ])(listenerList, function(listener) {
                                return listener === removed.listener;
                            });
                            if (removeListener) removeListener.emit(eventType, removed.listener, removed.id);
                        }
                    },
                    listeners: function() {
                        // differs from Node EventEmitter: returns list, not array
                        return listenerList;
                    },
                    hasListener: function(listenerId) {
                        var test = listenerId ? hasId(listenerId) : __WEBPACK_IMPORTED_MODULE_2__functional__["a" /* always */ ];
                        return Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defined */ ])(Object(__WEBPACK_IMPORTED_MODULE_0__lists__["e" /* first */ ])(test, listenerTupleList));
                    }
                };
            }
        /***/ },
        /* 12 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return ascentManager;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascent__ = __webpack_require__(4);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__(3);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lists__ = __webpack_require__(1);
            /**
 * A bridge used to assign stateless functions to listen to clarinet.
 *
 * As well as the parameter from clarinet, each callback will also be passed
 * the result of the last callback.
 *
 * This may also be used to clear all listeners by assigning zero handlers:
 *
 *    ascentManager( clarinet, {} )
 */ function ascentManager(oboeBus, handlers) {
                'use strict';
                var listenerId = {};
                var ascent;
                function stateAfter(handler) {
                    return function(param) {
                        ascent = handler(ascent, param);
                    };
                }
                for(var eventName in handlers)oboeBus(eventName).on(stateAfter(handlers[eventName]), listenerId);
                oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["g" /* NODE_SWAP */ ]).on(function(newNode) {
                    var oldHead = Object(__WEBPACK_IMPORTED_MODULE_2__lists__["g" /* head */ ])(ascent);
                    var key = Object(__WEBPACK_IMPORTED_MODULE_0__ascent__["a" /* keyOf */ ])(oldHead);
                    var ancestors = Object(__WEBPACK_IMPORTED_MODULE_2__lists__["l" /* tail */ ])(ascent);
                    var parentNode;
                    if (ancestors) {
                        parentNode = Object(__WEBPACK_IMPORTED_MODULE_0__ascent__["c" /* nodeOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_2__lists__["g" /* head */ ])(ancestors));
                        parentNode[key] = newNode;
                    }
                });
                oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["e" /* NODE_DROP */ ]).on(function() {
                    var oldHead = Object(__WEBPACK_IMPORTED_MODULE_2__lists__["g" /* head */ ])(ascent);
                    var key = Object(__WEBPACK_IMPORTED_MODULE_0__ascent__["a" /* keyOf */ ])(oldHead);
                    var ancestors = Object(__WEBPACK_IMPORTED_MODULE_2__lists__["l" /* tail */ ])(ascent);
                    var parentNode;
                    if (ancestors) {
                        parentNode = Object(__WEBPACK_IMPORTED_MODULE_0__ascent__["c" /* nodeOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_2__lists__["g" /* head */ ])(ancestors));
                        delete parentNode[key];
                    }
                });
                oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* ABORTING */ ]).on(function() {
                    for(var eventName in handlers)oboeBus(eventName).un(listenerId);
                });
            }
        /***/ },
        /* 13 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return patternAdapter;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__(3);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lists__ = __webpack_require__(1);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ascent__ = __webpack_require__(4);
            /**
 *  The pattern adaptor listens for newListener and removeListener
 *  events. When patterns are added or removed it compiles the JSONPath
 *  and wires them up.
 *
 *  When nodes and paths are found it emits the fully-qualified match
 *  events with parameters ready to ship to the outside world
 */ function patternAdapter(oboeBus, jsonPathCompiler) {
                var predicateEventMap = {
                    node: oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["d" /* NODE_CLOSED */ ]),
                    path: oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["f" /* NODE_OPENED */ ])
                };
                function emitMatchingNode(emitMatch, node, ascent) {
                    /*
         We're now calling to the outside world where Lisp-style
         lists will not be familiar. Convert to standard arrays.

         Also, reverse the order because it is more common to
         list paths "root to leaf" than "leaf to root"  */ var descent = Object(__WEBPACK_IMPORTED_MODULE_1__lists__["k" /* reverseList */ ])(ascent);
                    emitMatch(node, // To make a path, strip off the last item which is the special
                    // ROOT_PATH token for the 'path' to the root node
                    Object(__WEBPACK_IMPORTED_MODULE_1__lists__["i" /* listAsArray */ ])(Object(__WEBPACK_IMPORTED_MODULE_1__lists__["l" /* tail */ ])(Object(__WEBPACK_IMPORTED_MODULE_1__lists__["j" /* map */ ])(__WEBPACK_IMPORTED_MODULE_2__ascent__["a" /* keyOf */ ], descent))), Object(__WEBPACK_IMPORTED_MODULE_1__lists__["i" /* listAsArray */ ])(Object(__WEBPACK_IMPORTED_MODULE_1__lists__["j" /* map */ ])(__WEBPACK_IMPORTED_MODULE_2__ascent__["c" /* nodeOf */ ], descent)) // ancestors
                    );
                }
                /*
    * Set up the catching of events such as NODE_CLOSED and NODE_OPENED and, if
    * matching the specified pattern, propagate to pattern-match events such as
    * oboeBus('node:!')
    *
    *
    *
    * @param {Function} predicateEvent
    *          either oboeBus(NODE_CLOSED) or oboeBus(NODE_OPENED).
    * @param {Function} compiledJsonPath
    */ function addUnderlyingListener(fullEventName, predicateEvent, compiledJsonPath) {
                    var emitMatch = oboeBus(fullEventName).emit;
                    predicateEvent.on(function(ascent) {
                        var maybeMatchingMapping = compiledJsonPath(ascent);
                        /* Possible values for maybeMatchingMapping are now:

          false:
          we did not match

          an object/array/string/number/null:
          we matched and have the node that matched.
          Because nulls are valid json values this can be null.

          undefined:
          we matched but don't have the matching node yet.
          ie, we know there is an upcoming node that matches but we
          can't say anything else about it.
          */ if (maybeMatchingMapping !== false) emitMatchingNode(emitMatch, Object(__WEBPACK_IMPORTED_MODULE_2__ascent__["c" /* nodeOf */ ])(maybeMatchingMapping), ascent);
                    }, fullEventName);
                    oboeBus('removeListener').on(function(removedEventName) {
                        // if the fully qualified match event listener is later removed, clean up
                        // by removing the underlying listener if it was the last using that pattern:
                        if (removedEventName === fullEventName) {
                            if (!oboeBus(removedEventName).listeners()) predicateEvent.un(fullEventName);
                        }
                    });
                }
                oboeBus('newListener').on(function(fullEventName) {
                    var match = /(node|path):(.*)/.exec(fullEventName);
                    if (match) {
                        var predicateEvent = predicateEventMap[match[1]];
                        if (!predicateEvent.hasListener(fullEventName)) addUnderlyingListener(fullEventName, predicateEvent, jsonPathCompiler(match[2]));
                    }
                });
            }
        /***/ },
        /* 14 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return jsonPathCompiler;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functional__ = __webpack_require__(0);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lists__ = __webpack_require__(1);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ascent__ = __webpack_require__(4);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__incrementalContentBuilder__ = __webpack_require__(6);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsonPathSyntax__ = __webpack_require__(15);
            /**
 * The jsonPath evaluator compiler used for Oboe.js.
 *
 * One function is exposed. This function takes a String JSONPath spec and
 * returns a function to test candidate ascents for matches.
 *
 *  String jsonPath -> (List ascent) -> Boolean|Object
 *
 * This file is coded in a pure functional style. That is, no function has
 * side effects, every function evaluates to the same value for the same
 * arguments and no variables are reassigned.
 */ // the call to jsonPathSyntax injects the token syntaxes that are needed
            // inside the compiler
            var jsonPathCompiler = Object(__WEBPACK_IMPORTED_MODULE_5__jsonPathSyntax__["a" /* jsonPathSyntax */ ])(function(pathNodeSyntax, doubleDotSyntax, dotSyntax, bangSyntax, emptySyntax) {
                var CAPTURING_INDEX = 1;
                var NAME_INDEX = 2;
                var FIELD_LIST_INDEX = 3;
                var headKey = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["d" /* compose2 */ ])(__WEBPACK_IMPORTED_MODULE_2__ascent__["a" /* keyOf */ ], __WEBPACK_IMPORTED_MODULE_1__lists__["g" /* head */ ]);
                var headNode = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["d" /* compose2 */ ])(__WEBPACK_IMPORTED_MODULE_2__ascent__["c" /* nodeOf */ ], __WEBPACK_IMPORTED_MODULE_1__lists__["g" /* head */ ]);
                /**
    * Create an evaluator function for a named path node, expressed in the
    * JSONPath like:
    *    foo
    *    ["bar"]
    *    [2]
    */ function nameClause(previousExpr, detection) {
                    var name = detection[NAME_INDEX];
                    var matchesName = !name || name === '*' ? __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ] : function(ascent) {
                        return String(headKey(ascent)) === name;
                    };
                    return Object(__WEBPACK_IMPORTED_MODULE_0__functional__["g" /* lazyIntersection */ ])(matchesName, previousExpr);
                }
                /**
    * Create an evaluator function for a a duck-typed node, expressed like:
    *
    *    {spin, taste, colour}
    *    .particle{spin, taste, colour}
    *    *{spin, taste, colour}
    */ function duckTypeClause(previousExpr, detection) {
                    var fieldListStr = detection[FIELD_LIST_INDEX];
                    if (!fieldListStr) return previousExpr;
                     // don't wrap at all, return given expr as-is
                    var hasAllrequiredFields = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["j" /* partialComplete */ ])(__WEBPACK_IMPORTED_MODULE_3__util__["b" /* hasAllProperties */ ], Object(__WEBPACK_IMPORTED_MODULE_1__lists__["c" /* arrayAsList */ ])(fieldListStr.split(/\W+/)));
                    var isMatch = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["d" /* compose2 */ ])(hasAllrequiredFields, headNode);
                    return Object(__WEBPACK_IMPORTED_MODULE_0__functional__["g" /* lazyIntersection */ ])(isMatch, previousExpr);
                }
                /**
    * Expression for $, returns the evaluator function
    */ function capture(previousExpr, detection) {
                    // extract meaning from the detection
                    var capturing = !!detection[CAPTURING_INDEX];
                    if (!capturing) return previousExpr;
                     // don't wrap at all, return given expr as-is
                    return Object(__WEBPACK_IMPORTED_MODULE_0__functional__["g" /* lazyIntersection */ ])(previousExpr, __WEBPACK_IMPORTED_MODULE_1__lists__["g" /* head */ ]);
                }
                /**
    * Create an evaluator function that moves onto the next item on the
    * lists. This function is the place where the logic to move up a
    * level in the ascent exists.
    *
    * Eg, for JSONPath ".foo" we need skip1(nameClause(always, [,'foo']))
    */ function skip1(previousExpr) {
                    if (previousExpr === __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ]) /* If there is no previous expression this consume command
            is at the start of the jsonPath.
            Since JSONPath specifies what we'd like to find but not
            necessarily everything leading down to it, when running
            out of JSONPath to check against we default to true */ return __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ];
                    /** return true if the ascent we have contains only the JSON root,
       *  false otherwise
       */ function notAtRoot(ascent) {
                        return headKey(ascent) !== __WEBPACK_IMPORTED_MODULE_4__incrementalContentBuilder__["a" /* ROOT_PATH */ ];
                    }
                    return Object(__WEBPACK_IMPORTED_MODULE_0__functional__["g" /* lazyIntersection */ ])(/* If we're already at the root but there are more
                  expressions to satisfy, can't consume any more. No match.

                  This check is why none of the other exprs have to be able
                  to handle empty lists; skip1 is the only evaluator that
                  moves onto the next token and it refuses to do so once it
                  reaches the last item in the list. */ notAtRoot, /* We are not at the root of the ascent yet.
                  Move to the next level of the ascent by handing only
                  the tail to the previous expression */ Object(__WEBPACK_IMPORTED_MODULE_0__functional__["d" /* compose2 */ ])(previousExpr, __WEBPACK_IMPORTED_MODULE_1__lists__["l" /* tail */ ]));
                }
                /**
    * Create an evaluator function for the .. (double dot) token. Consumes
    * zero or more levels of the ascent, the fewest that are required to find
    * a match when given to previousExpr.
    */ function skipMany(previousExpr) {
                    if (previousExpr === __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ]) /* If there is no previous expression this consume command
            is at the start of the jsonPath.
            Since JSONPath specifies what we'd like to find but not
            necessarily everything leading down to it, when running
            out of JSONPath to check against we default to true */ return __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ];
                    // In JSONPath .. is equivalent to !.. so if .. reaches the root
                    // the match has succeeded. Ie, we might write ..foo or !..foo
                    // and both should match identically.
                    var terminalCaseWhenArrivingAtRoot = rootExpr();
                    var terminalCaseWhenPreviousExpressionIsSatisfied = previousExpr;
                    var recursiveCase = skip1(function(ascent) {
                        return cases(ascent);
                    });
                    var cases = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["h" /* lazyUnion */ ])(terminalCaseWhenArrivingAtRoot, terminalCaseWhenPreviousExpressionIsSatisfied, recursiveCase);
                    return cases;
                }
                /**
    * Generate an evaluator for ! - matches only the root element of the json
    * and ignores any previous expressions since nothing may precede !.
    */ function rootExpr() {
                    return function(ascent) {
                        return headKey(ascent) === __WEBPACK_IMPORTED_MODULE_4__incrementalContentBuilder__["a" /* ROOT_PATH */ ];
                    };
                }
                /**
    * Generate a statement wrapper to sit around the outermost
    * clause evaluator.
    *
    * Handles the case where the capturing is implicit because the JSONPath
    * did not contain a '$' by returning the last node.
    */ function statementExpr(lastClause) {
                    return function(ascent) {
                        // kick off the evaluation by passing through to the last clause
                        var exprMatch = lastClause(ascent);
                        return exprMatch === true ? Object(__WEBPACK_IMPORTED_MODULE_1__lists__["g" /* head */ ])(ascent) : exprMatch;
                    };
                }
                /**
    * For when a token has been found in the JSONPath input.
    * Compiles the parser for that token and returns in combination with the
    * parser already generated.
    *
    * @param {Function} exprs  a list of the clause evaluator generators for
    *                          the token that was found
    * @param {Function} parserGeneratedSoFar the parser already found
    * @param {Array} detection the match given by the regex engine when
    *                          the feature was found
    */ function expressionsReader(exprs, parserGeneratedSoFar, detection) {
                    // if exprs is zero-length foldR will pass back the
                    // parserGeneratedSoFar as-is so we don't need to treat
                    // this as a special case
                    return Object(__WEBPACK_IMPORTED_MODULE_1__lists__["f" /* foldR */ ])(function(parserGeneratedSoFar, expr) {
                        return expr(parserGeneratedSoFar, detection);
                    }, parserGeneratedSoFar, exprs);
                }
                /**
    *  If jsonPath matches the given detector function, creates a function which
    *  evaluates against every clause in the clauseEvaluatorGenerators. The
    *  created function is propagated to the onSuccess function, along with
    *  the remaining unparsed JSONPath substring.
    *
    *  The intended use is to create a clauseMatcher by filling in
    *  the first two arguments, thus providing a function that knows
    *  some syntax to match and what kind of generator to create if it
    *  finds it. The parameter list once completed is:
    *
    *    (jsonPath, parserGeneratedSoFar, onSuccess)
    *
    *  onSuccess may be compileJsonPathToFunction, to recursively continue
    *  parsing after finding a match or returnFoundParser to stop here.
    */ function generateClauseReaderIfTokenFound(tokenDetector, clauseEvaluatorGenerators, jsonPath, parserGeneratedSoFar, onSuccess) {
                    var detected = tokenDetector(jsonPath);
                    if (detected) {
                        var compiledParser = expressionsReader(clauseEvaluatorGenerators, parserGeneratedSoFar, detected);
                        var remainingUnparsedJsonPath = jsonPath.substr(Object(__WEBPACK_IMPORTED_MODULE_3__util__["e" /* len */ ])(detected[0]));
                        return onSuccess(remainingUnparsedJsonPath, compiledParser);
                    }
                }
                /**
    * Partially completes generateClauseReaderIfTokenFound above.
    */ function clauseMatcher(tokenDetector, exprs) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__functional__["j" /* partialComplete */ ])(generateClauseReaderIfTokenFound, tokenDetector, exprs);
                }
                /**
    * clauseForJsonPath is a function which attempts to match against
    * several clause matchers in order until one matches. If non match the
    * jsonPath expression is invalid and an error is thrown.
    *
    * The parameter list is the same as a single clauseMatcher:
    *
    *    (jsonPath, parserGeneratedSoFar, onSuccess)
    */ var clauseForJsonPath = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["h" /* lazyUnion */ ])(clauseMatcher(pathNodeSyntax, Object(__WEBPACK_IMPORTED_MODULE_1__lists__["h" /* list */ ])(capture, duckTypeClause, nameClause, skip1)), clauseMatcher(doubleDotSyntax, Object(__WEBPACK_IMPORTED_MODULE_1__lists__["h" /* list */ ])(skipMany)), clauseMatcher(dotSyntax, Object(__WEBPACK_IMPORTED_MODULE_1__lists__["h" /* list */ ])()), clauseMatcher(bangSyntax, Object(__WEBPACK_IMPORTED_MODULE_1__lists__["h" /* list */ ])(capture, rootExpr)), clauseMatcher(emptySyntax, Object(__WEBPACK_IMPORTED_MODULE_1__lists__["h" /* list */ ])(statementExpr)), function(jsonPath) {
                    throw Error('"' + jsonPath + '" could not be tokenised');
                });
                /**
    * One of two possible values for the onSuccess argument of
    * generateClauseReaderIfTokenFound.
    *
    * When this function is used, generateClauseReaderIfTokenFound simply
    * returns the compiledParser that it made, regardless of if there is
    * any remaining jsonPath to be compiled.
    */ function returnFoundParser(_remainingJsonPath, compiledParser) {
                    return compiledParser;
                }
                /**
    * Recursively compile a JSONPath expression.
    *
    * This function serves as one of two possible values for the onSuccess
    * argument of generateClauseReaderIfTokenFound, meaning continue to
    * recursively compile. Otherwise, returnFoundParser is given and
    * compilation terminates.
    */ function compileJsonPathToFunction(uncompiledJsonPath, parserGeneratedSoFar) {
                    /**
       * On finding a match, if there is remaining text to be compiled
       * we want to either continue parsing using a recursive call to
       * compileJsonPathToFunction. Otherwise, we want to stop and return
       * the parser that we have found so far.
       */ var onFind = uncompiledJsonPath ? compileJsonPathToFunction : returnFoundParser;
                    return clauseForJsonPath(uncompiledJsonPath, parserGeneratedSoFar, onFind);
                }
                /**
    * This is the function that we expose to the rest of the library.
    */ return function(jsonPath) {
                    try {
                        // Kick off the recursive parsing of the jsonPath
                        return compileJsonPathToFunction(jsonPath, __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ]);
                    } catch (e) {
                        throw Error('Could not compile "' + jsonPath + '" because ' + e.message);
                    }
                };
            });
        /***/ },
        /* 15 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return jsonPathSyntax;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functional__ = __webpack_require__(0);
            var jsonPathSyntax = function() {
                /**
  * Export a regular expression as a simple function by exposing just
  * the Regex#exec. This allows regex tests to be used under the same
  * interface as differently implemented tests, or for a user of the
  * tests to not concern themselves with their implementation as regular
  * expressions.
  *
  * This could also be expressed point-free as:
  *   Function.prototype.bind.bind(RegExp.prototype.exec),
  *
  * But that's far too confusing! (and not even smaller once minified
  * and gzipped)
  */ var regexDescriptor = function regexDescriptor(regex) {
                    return regex.exec.bind(regex);
                };
                /**
  * Join several regular expressions and express as a function.
  * This allows the token patterns to reuse component regular expressions
  * instead of being expressed in full using huge and confusing regular
  * expressions.
  */ var jsonPathClause = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["k" /* varArgs */ ])(function(componentRegexes) {
                    // The regular expressions all start with ^ because we
                    // only want to find matches at the start of the
                    // JSONPath fragment we are inspecting
                    componentRegexes.unshift(/^/);
                    return regexDescriptor(RegExp(componentRegexes.map(Object(__WEBPACK_IMPORTED_MODULE_0__functional__["c" /* attr */ ])('source')).join('')));
                });
                var possiblyCapturing = /(\$?)/;
                var namedNode = /([\w-_]+|\*)/;
                var namePlaceholder = /()/;
                var nodeInArrayNotation = /\["([^"]+)"\]/;
                var numberedNodeInArrayNotation = /\[(\d+|\*)\]/;
                var fieldList = /{([\w ]*?)}/;
                var optionalFieldList = /(?:{([\w ]*?)})?/;
                //   foo or *
                var jsonPathNamedNodeInObjectNotation = jsonPathClause(possiblyCapturing, namedNode, optionalFieldList);
                //   ["foo"]
                var jsonPathNamedNodeInArrayNotation = jsonPathClause(possiblyCapturing, nodeInArrayNotation, optionalFieldList);
                //   [2] or [*]
                var jsonPathNumberedNodeInArrayNotation = jsonPathClause(possiblyCapturing, numberedNodeInArrayNotation, optionalFieldList);
                //   {a b c}
                var jsonPathPureDuckTyping = jsonPathClause(possiblyCapturing, namePlaceholder, fieldList);
                //   ..
                var jsonPathDoubleDot = jsonPathClause(/\.\./);
                //   .
                var jsonPathDot = jsonPathClause(/\./);
                //   !
                var jsonPathBang = jsonPathClause(possiblyCapturing, /!/);
                //   nada!
                var emptyString = jsonPathClause(/$/);
                /* We export only a single function. When called, this function injects
      into another function the descriptors from above.
    */ return function(fn) {
                    return fn(Object(__WEBPACK_IMPORTED_MODULE_0__functional__["h" /* lazyUnion */ ])(jsonPathNamedNodeInObjectNotation, jsonPathNamedNodeInArrayNotation, jsonPathNumberedNodeInArrayNotation, jsonPathPureDuckTyping), jsonPathDoubleDot, jsonPathDot, jsonPathBang, emptyString);
                };
            }();
        /***/ },
        /* 16 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return instanceApi;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__(3);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functional__ = __webpack_require__(0);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__publicApi__ = __webpack_require__(5);
            /**
 * The instance API is the thing that is returned when oboe() is called.
 * it allows:
 *
 *    - listeners for various events to be added and removed
 *    - the http response header/headers to be read
 */ function instanceApi(oboeBus, contentSource) {
                var oboeApi;
                var fullyQualifiedNamePattern = /^(node|path):./;
                var rootNodeFinishedEvent = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["h" /* ROOT_NODE_FOUND */ ]);
                var emitNodeDrop = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["e" /* NODE_DROP */ ]).emit;
                var emitNodeSwap = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["g" /* NODE_SWAP */ ]).emit;
                /**
       * Add any kind of listener that the instance api exposes
       */ var addListener = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["k" /* varArgs */ ])(function(eventId, parameters) {
                    if (oboeApi[eventId]) // for events added as .on(event, callback), if there is a
                    // .event() equivalent with special behaviour , pass through
                    // to that:
                    Object(__WEBPACK_IMPORTED_MODULE_1__functional__["b" /* apply */ ])(parameters, oboeApi[eventId]);
                    else {
                        // we have a standard Node.js EventEmitter 2-argument call.
                        // The first parameter is the listener.
                        var event = oboeBus(eventId);
                        var listener = parameters[0];
                        if (fullyQualifiedNamePattern.test(eventId)) // allow fully-qualified node/path listeners
                        // to be added
                        addForgettableCallback(event, wrapCallbackToSwapNodeIfSomethingReturned(listener));
                        else // the event has no special handling, pass through
                        // directly onto the event bus:
                        event.on(listener);
                    }
                    return oboeApi // chaining
                    ;
                });
                /**
       * Remove any kind of listener that the instance api exposes
       */ var removeListener = function(eventId, p2, p3) {
                    if (eventId === 'done') rootNodeFinishedEvent.un(p2);
                    else if (eventId === 'node' || eventId === 'path') // allow removal of node and path
                    oboeBus.un(eventId + ':' + p2, p3);
                    else {
                        // we have a standard Node.js EventEmitter 2-argument call.
                        // The second parameter is the listener. This may be a call
                        // to remove a fully-qualified node/path listener but requires
                        // no special handling
                        var listener = p2;
                        oboeBus(eventId).un(listener);
                    }
                    return oboeApi // chaining
                    ;
                };
                /**
   * Add a callback, wrapped in a try/catch so as to not break the
   * execution of Oboe if an exception is thrown (fail events are
   * fired instead)
   *
   * The callback is used as the listener id so that it can later be
   * removed using .un(callback)
   */ function addProtectedCallback(eventName, callback) {
                    oboeBus(eventName).on(protectedCallback(callback), callback);
                    return oboeApi // chaining
                    ;
                }
                /**
   * Add a callback where, if .forget() is called during the callback's
   * execution, the callback will be de-registered
   */ function addForgettableCallback(event, callback, listenerId) {
                    // listenerId is optional and if not given, the original
                    // callback will be used
                    listenerId = listenerId || callback;
                    var safeCallback = protectedCallback(callback);
                    event.on(function() {
                        var discard = false;
                        oboeApi.forget = function() {
                            discard = true;
                        };
                        Object(__WEBPACK_IMPORTED_MODULE_1__functional__["b" /* apply */ ])(arguments, safeCallback);
                        delete oboeApi.forget;
                        if (discard) event.un(listenerId);
                    }, listenerId);
                    return oboeApi // chaining
                    ;
                }
                /**
   *  wrap a callback so that if it throws, Oboe.js doesn't crash but instead
   *  throw the error in another event loop
   */ function protectedCallback(callback) {
                    return function() {
                        try {
                            return callback.apply(oboeApi, arguments);
                        } catch (e) {
                            setTimeout(function() {
                                throw new Error(e.message);
                            });
                        }
                    };
                }
                /**
   * Return the fully qualified event for when a pattern matches
   * either a node or a path
   *
   * @param type {String} either 'node' or 'path'
   */ function fullyQualifiedPatternMatchEvent(type, pattern) {
                    return oboeBus(type + ':' + pattern);
                }
                function wrapCallbackToSwapNodeIfSomethingReturned(callback) {
                    return function() {
                        var returnValueFromCallback = callback.apply(this, arguments);
                        if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* defined */ ])(returnValueFromCallback)) {
                            if (returnValueFromCallback === __WEBPACK_IMPORTED_MODULE_3__publicApi__["a" /* oboe */ ].drop) emitNodeDrop();
                            else emitNodeSwap(returnValueFromCallback);
                        }
                    };
                }
                function addSingleNodeOrPathListener(eventId, pattern, callback) {
                    var effectiveCallback;
                    if (eventId === 'node') effectiveCallback = wrapCallbackToSwapNodeIfSomethingReturned(callback);
                    else effectiveCallback = callback;
                    addForgettableCallback(fullyQualifiedPatternMatchEvent(eventId, pattern), effectiveCallback, callback);
                }
                /**
   * Add several listeners at a time, from a map
   */ function addMultipleNodeOrPathListeners(eventId, listenerMap) {
                    for(var pattern in listenerMap)addSingleNodeOrPathListener(eventId, pattern, listenerMap[pattern]);
                }
                /**
   * implementation behind .onPath() and .onNode()
   */ function addNodeOrPathListenerApi(eventId, jsonPathOrListenerMap, callback) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* isString */ ])(jsonPathOrListenerMap)) addSingleNodeOrPathListener(eventId, jsonPathOrListenerMap, callback);
                    else addMultipleNodeOrPathListeners(eventId, jsonPathOrListenerMap);
                    return oboeApi // chaining
                    ;
                }
                // some interface methods are only filled in after we receive
                // values and are noops before that:
                oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["i" /* ROOT_PATH_FOUND */ ]).on(function(rootNode) {
                    oboeApi.root = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["f" /* functor */ ])(rootNode);
                });
                /**
   * When content starts make the headers readable through the
   * instance API
   */ oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["c" /* HTTP_START */ ]).on(function(_statusCode, headers) {
                    oboeApi.header = function(name) {
                        return name ? headers[name] : headers;
                    };
                });
                /**
   * Construct and return the public API of the Oboe instance to be
   * returned to the calling application
   */ oboeApi = {
                    on: addListener,
                    addListener: addListener,
                    removeListener: removeListener,
                    emit: oboeBus.emit,
                    node: Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(addNodeOrPathListenerApi, 'node'),
                    path: Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(addNodeOrPathListenerApi, 'path'),
                    done: Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(addForgettableCallback, rootNodeFinishedEvent),
                    start: Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(addProtectedCallback, __WEBPACK_IMPORTED_MODULE_0__events__["c" /* HTTP_START */ ]),
                    // fail doesn't use protectedCallback because
                    // could lead to non-terminating loops
                    fail: oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["b" /* FAIL_EVENT */ ]).on,
                    // public api calling abort fires the ABORTING event
                    abort: oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* ABORTING */ ]).emit,
                    // initially return nothing for header and root
                    header: __WEBPACK_IMPORTED_MODULE_1__functional__["i" /* noop */ ],
                    root: __WEBPACK_IMPORTED_MODULE_1__functional__["i" /* noop */ ],
                    source: contentSource
                };
                return oboeApi;
            }
        /***/ },
        /* 17 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return clarinet;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__(3);
            /*
   This is a slightly hacked-up browser only version of clarinet

      *  some features removed to help keep browser Oboe under
         the 5k micro-library limit
      *  plug directly into event bus

   For the original go here:
      https://github.com/dscape/clarinet

   We receive the events:
      STREAM_DATA
      STREAM_END

   We emit the events:
      SAX_KEY
      SAX_VALUE_OPEN
      SAX_VALUE_CLOSE
      FAIL_EVENT
 */ function clarinet(eventBus) {
                'use strict';
                // shortcut some events on the bus
                var emitSaxKey = eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["j" /* SAX_KEY */ ]).emit;
                var emitValueOpen = eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["l" /* SAX_VALUE_OPEN */ ]).emit;
                var emitValueClose = eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["k" /* SAX_VALUE_CLOSE */ ]).emit;
                var emitFail = eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["b" /* FAIL_EVENT */ ]).emit;
                var MAX_BUFFER_LENGTH = 65536;
                var stringTokenPattern = /[\\"\n]/g;
                var _n = 0;
                // states
                var BEGIN = _n++;
                var VALUE = _n++ // general stuff
                ;
                var OPEN_OBJECT = _n++ // {
                ;
                var CLOSE_OBJECT = _n++ // }
                ;
                var OPEN_ARRAY = _n++ // [
                ;
                var CLOSE_ARRAY = _n++ // ]
                ;
                var STRING = _n++ // ""
                ;
                var OPEN_KEY = _n++ // , "a"
                ;
                var CLOSE_KEY = _n++ // :
                ;
                var TRUE = _n++ // r
                ;
                var TRUE2 = _n++ // u
                ;
                var TRUE3 = _n++ // e
                ;
                var FALSE = _n++ // a
                ;
                var FALSE2 = _n++ // l
                ;
                var FALSE3 = _n++ // s
                ;
                var FALSE4 = _n++ // e
                ;
                var NULL = _n++ // u
                ;
                var NULL2 = _n++ // l
                ;
                var NULL3 = _n++ // l
                ;
                var NUMBER_DECIMAL_POINT = _n++ // .
                ;
                var NUMBER_DIGIT = _n // [0-9]
                ;
                // setup initial parser values
                var bufferCheckPosition = MAX_BUFFER_LENGTH;
                var latestError;
                var c;
                var p;
                var textNode;
                var numberNode = '';
                var slashed = false;
                var closed = false;
                var state = BEGIN;
                var stack = [];
                var unicodeS = null;
                var unicodeI = 0;
                var depth = 0;
                var position = 0;
                var column = 0 // mostly for error reporting
                ;
                var line = 1;
                function checkBufferLength() {
                    var maxActual = 0;
                    if (textNode !== undefined && textNode.length > MAX_BUFFER_LENGTH) {
                        emitError('Max buffer length exceeded: textNode');
                        maxActual = Math.max(maxActual, textNode.length);
                    }
                    if (numberNode.length > MAX_BUFFER_LENGTH) {
                        emitError('Max buffer length exceeded: numberNode');
                        maxActual = Math.max(maxActual, numberNode.length);
                    }
                    bufferCheckPosition = MAX_BUFFER_LENGTH - maxActual + position;
                }
                eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["m" /* STREAM_DATA */ ]).on(handleData);
                /* At the end of the http content close the clarinet
    This will provide an error if the total content provided was not
    valid json, ie if not all arrays, objects and Strings closed properly */ eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["n" /* STREAM_END */ ]).on(handleStreamEnd);
                function emitError(errorString) {
                    if (textNode !== undefined) {
                        emitValueOpen(textNode);
                        emitValueClose();
                        textNode = undefined;
                    }
                    latestError = Error(errorString + '\nLn: ' + line + '\nCol: ' + column + '\nChr: ' + c);
                    emitFail(Object(__WEBPACK_IMPORTED_MODULE_0__events__["o" /* errorReport */ ])(undefined, undefined, latestError));
                }
                function handleStreamEnd() {
                    if (state === BEGIN) {
                        // Handle the case where the stream closes without ever receiving
                        // any input. This isn't an error - response bodies can be blank,
                        // particularly for 204 http responses
                        // Because of how Oboe is currently implemented, we parse a
                        // completely empty stream as containing an empty object.
                        // This is because Oboe's done event is only fired when the
                        // root object of the JSON stream closes.
                        // This should be decoupled and attached instead to the input stream
                        // from the http (or whatever) resource ending.
                        // If this decoupling could happen the SAX parser could simply emit
                        // zero events on a completely empty input.
                        emitValueOpen({});
                        emitValueClose();
                        closed = true;
                        return;
                    }
                    if (state !== VALUE || depth !== 0) emitError('Unexpected end');
                    if (textNode !== undefined) {
                        emitValueOpen(textNode);
                        emitValueClose();
                        textNode = undefined;
                    }
                    closed = true;
                }
                function whitespace(c) {
                    return c === '\r' || c === '\n' || c === ' ' || c === '\t';
                }
                function handleData(chunk) {
                    // this used to throw the error but inside Oboe we will have already
                    // gotten the error when it was emitted. The important thing is to
                    // not continue with the parse.
                    if (latestError) return;
                    if (closed) return emitError('Cannot write after close');
                    var i = 0;
                    c = chunk[0];
                    while(c){
                        if (i > 0) p = c;
                        c = chunk[i++];
                        if (!c) break;
                        position++;
                        if (c === '\n') {
                            line++;
                            column = 0;
                        } else column++;
                        switch(state){
                            case BEGIN:
                                if (c === '{') state = OPEN_OBJECT;
                                else if (c === '[') state = OPEN_ARRAY;
                                else if (!whitespace(c)) return emitError('Non-whitespace before {[.');
                                continue;
                            case OPEN_KEY:
                            case OPEN_OBJECT:
                                if (whitespace(c)) continue;
                                if (state === OPEN_KEY) stack.push(CLOSE_KEY);
                                else if (c === '}') {
                                    emitValueOpen({});
                                    emitValueClose();
                                    state = stack.pop() || VALUE;
                                    continue;
                                } else stack.push(CLOSE_OBJECT);
                                if (c === '"') state = STRING;
                                else return emitError('Malformed object key should start with " ');
                                continue;
                            case CLOSE_KEY:
                            case CLOSE_OBJECT:
                                if (whitespace(c)) continue;
                                if (c === ':') {
                                    if (state === CLOSE_OBJECT) {
                                        stack.push(CLOSE_OBJECT);
                                        if (textNode !== undefined) {
                                            // was previously (in upstream Clarinet) one event
                                            //  - object open came with the text of the first
                                            emitValueOpen({});
                                            emitSaxKey(textNode);
                                            textNode = undefined;
                                        }
                                        depth++;
                                    } else if (textNode !== undefined) {
                                        emitSaxKey(textNode);
                                        textNode = undefined;
                                    }
                                    state = VALUE;
                                } else if (c === '}') {
                                    if (textNode !== undefined) {
                                        emitValueOpen(textNode);
                                        emitValueClose();
                                        textNode = undefined;
                                    }
                                    emitValueClose();
                                    depth--;
                                    state = stack.pop() || VALUE;
                                } else if (c === ',') {
                                    if (state === CLOSE_OBJECT) stack.push(CLOSE_OBJECT);
                                    if (textNode !== undefined) {
                                        emitValueOpen(textNode);
                                        emitValueClose();
                                        textNode = undefined;
                                    }
                                    state = OPEN_KEY;
                                } else return emitError('Bad object');
                                continue;
                            case OPEN_ARRAY:
                            case VALUE:
                                if (whitespace(c)) continue;
                                if (state === OPEN_ARRAY) {
                                    emitValueOpen([]);
                                    depth++;
                                    state = VALUE;
                                    if (c === ']') {
                                        emitValueClose();
                                        depth--;
                                        state = stack.pop() || VALUE;
                                        continue;
                                    } else stack.push(CLOSE_ARRAY);
                                }
                                if (c === '"') state = STRING;
                                else if (c === '{') state = OPEN_OBJECT;
                                else if (c === '[') state = OPEN_ARRAY;
                                else if (c === 't') state = TRUE;
                                else if (c === 'f') state = FALSE;
                                else if (c === 'n') state = NULL;
                                else if (c === '-') numberNode += c;
                                else if (c === '0') {
                                    numberNode += c;
                                    state = NUMBER_DIGIT;
                                } else if ('123456789'.indexOf(c) !== -1) {
                                    numberNode += c;
                                    state = NUMBER_DIGIT;
                                } else return emitError('Bad value');
                                continue;
                            case CLOSE_ARRAY:
                                if (c === ',') {
                                    stack.push(CLOSE_ARRAY);
                                    if (textNode !== undefined) {
                                        emitValueOpen(textNode);
                                        emitValueClose();
                                        textNode = undefined;
                                    }
                                    state = VALUE;
                                } else if (c === ']') {
                                    if (textNode !== undefined) {
                                        emitValueOpen(textNode);
                                        emitValueClose();
                                        textNode = undefined;
                                    }
                                    emitValueClose();
                                    depth--;
                                    state = stack.pop() || VALUE;
                                } else if (whitespace(c)) continue;
                                else return emitError('Bad array');
                                continue;
                            case STRING:
                                if (textNode === undefined) textNode = '';
                                // thanks thejh, this is an about 50% performance improvement.
                                var starti = i - 1;
                                // eslint-disable-next-line no-labels
                                STRING_BIGLOOP: while(true){
                                    // zero means "no unicode active". 1-4 mean "parse some more". end after 4.
                                    while(unicodeI > 0){
                                        unicodeS += c;
                                        c = chunk.charAt(i++);
                                        if (unicodeI === 4) {
                                            // TODO this might be slow? well, probably not used too often anyway
                                            textNode += String.fromCharCode(parseInt(unicodeS, 16));
                                            unicodeI = 0;
                                            starti = i - 1;
                                        } else unicodeI++;
                                        // we can just break here: no stuff we skipped that still has to be sliced out or so
                                        // eslint-disable-next-line no-labels
                                        if (!c) break STRING_BIGLOOP;
                                    }
                                    if (c === '"' && !slashed) {
                                        state = stack.pop() || VALUE;
                                        textNode += chunk.substring(starti, i - 1);
                                        break;
                                    }
                                    if (c === '\\' && !slashed) {
                                        slashed = true;
                                        textNode += chunk.substring(starti, i - 1);
                                        c = chunk.charAt(i++);
                                        if (!c) break;
                                    }
                                    if (slashed) {
                                        slashed = false;
                                        if (c === 'n') textNode += '\n';
                                        else if (c === 'r') textNode += '\r';
                                        else if (c === 't') textNode += '\t';
                                        else if (c === 'f') textNode += '\f';
                                        else if (c === 'b') textNode += '\b';
                                        else if (c === 'u') {
                                            // \uxxxx. meh!
                                            unicodeI = 1;
                                            unicodeS = '';
                                        } else textNode += c;
                                        c = chunk.charAt(i++);
                                        starti = i - 1;
                                        if (!c) break;
                                        else continue;
                                    }
                                    stringTokenPattern.lastIndex = i;
                                    var reResult = stringTokenPattern.exec(chunk);
                                    if (!reResult) {
                                        i = chunk.length + 1;
                                        textNode += chunk.substring(starti, i - 1);
                                        break;
                                    }
                                    i = reResult.index + 1;
                                    c = chunk.charAt(reResult.index);
                                    if (!c) {
                                        textNode += chunk.substring(starti, i - 1);
                                        break;
                                    }
                                }
                                continue;
                            case TRUE:
                                if (!c) continue; // strange buffers
                                if (c === 'r') state = TRUE2;
                                else return emitError('Invalid true started with t' + c);
                                continue;
                            case TRUE2:
                                if (!c) continue;
                                if (c === 'u') state = TRUE3;
                                else return emitError('Invalid true started with tr' + c);
                                continue;
                            case TRUE3:
                                if (!c) continue;
                                if (c === 'e') {
                                    emitValueOpen(true);
                                    emitValueClose();
                                    state = stack.pop() || VALUE;
                                } else return emitError('Invalid true started with tru' + c);
                                continue;
                            case FALSE:
                                if (!c) continue;
                                if (c === 'a') state = FALSE2;
                                else return emitError('Invalid false started with f' + c);
                                continue;
                            case FALSE2:
                                if (!c) continue;
                                if (c === 'l') state = FALSE3;
                                else return emitError('Invalid false started with fa' + c);
                                continue;
                            case FALSE3:
                                if (!c) continue;
                                if (c === 's') state = FALSE4;
                                else return emitError('Invalid false started with fal' + c);
                                continue;
                            case FALSE4:
                                if (!c) continue;
                                if (c === 'e') {
                                    emitValueOpen(false);
                                    emitValueClose();
                                    state = stack.pop() || VALUE;
                                } else return emitError('Invalid false started with fals' + c);
                                continue;
                            case NULL:
                                if (!c) continue;
                                if (c === 'u') state = NULL2;
                                else return emitError('Invalid null started with n' + c);
                                continue;
                            case NULL2:
                                if (!c) continue;
                                if (c === 'l') state = NULL3;
                                else return emitError('Invalid null started with nu' + c);
                                continue;
                            case NULL3:
                                if (!c) continue;
                                if (c === 'l') {
                                    emitValueOpen(null);
                                    emitValueClose();
                                    state = stack.pop() || VALUE;
                                } else return emitError('Invalid null started with nul' + c);
                                continue;
                            case NUMBER_DECIMAL_POINT:
                                if (c === '.') {
                                    numberNode += c;
                                    state = NUMBER_DIGIT;
                                } else return emitError('Leading zero not followed by .');
                                continue;
                            case NUMBER_DIGIT:
                                if ('0123456789'.indexOf(c) !== -1) numberNode += c;
                                else if (c === '.') {
                                    if (numberNode.indexOf('.') !== -1) return emitError('Invalid number has two dots');
                                    numberNode += c;
                                } else if (c === 'e' || c === 'E') {
                                    if (numberNode.indexOf('e') !== -1 || numberNode.indexOf('E') !== -1) return emitError('Invalid number has two exponential');
                                    numberNode += c;
                                } else if (c === '+' || c === '-') {
                                    if (!(p === 'e' || p === 'E')) return emitError('Invalid symbol in number');
                                    numberNode += c;
                                } else {
                                    if (numberNode) {
                                        emitValueOpen(parseFloat(numberNode));
                                        emitValueClose();
                                        numberNode = '';
                                    }
                                    i-- // go back one
                                    ;
                                    state = stack.pop() || VALUE;
                                }
                                continue;
                            default:
                                return emitError('Unknown state: ' + state);
                        }
                    }
                    if (position >= bufferCheckPosition) checkBufferLength();
                }
            }
        /***/ },
        /* 18 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return httpTransport;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return streamingHttp;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__detectCrossOrigin_browser__ = __webpack_require__(19);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__(3);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parseResponseHeaders_browser__ = __webpack_require__(20);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functional__ = __webpack_require__(0);
            function httpTransport() {
                return new XMLHttpRequest();
            }
            /**
 * A wrapper around the browser XmlHttpRequest object that raises an
 * event whenever a new part of the response is available.
 *
 * In older browsers progressive reading is impossible so all the
 * content is given in a single call. For newer ones several events
 * should be raised, allowing progressive interpretation of the response.
 *
 * @param {Function} oboeBus an event bus local to this Oboe instance
 * @param {XMLHttpRequest} xhr the xhr to use as the transport. Under normal
 *          operation, will have been created using httpTransport() above
 *          but for tests a stub can be provided instead.
 * @param {String} method one of 'GET' 'POST' 'PUT' 'PATCH' 'DELETE'
 * @param {String} url the url to make a request to
 * @param {String|Null} data some content to be sent with the request.
 *                      Only valid if method is POST or PUT.
 * @param {Object} [headers] the http request headers to send
 * @param {boolean} withCredentials the XHR withCredentials property will be
 *    set to this value
 */ function streamingHttp(oboeBus, xhr, method, url, data, headers, withCredentials) {
                'use strict';
                var emitStreamData = oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["m" /* STREAM_DATA */ ]).emit;
                var emitFail = oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["b" /* FAIL_EVENT */ ]).emit;
                var numberOfCharsAlreadyGivenToCallback = 0;
                var stillToSendStartEvent = true;
                // When an ABORTING message is put on the event bus abort
                // the ajax request
                oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* ABORTING */ ]).on(function() {
                    // if we keep the onreadystatechange while aborting the XHR gives
                    // a callback like a successful call so first remove this listener
                    // by assigning null:
                    xhr.onreadystatechange = null;
                    xhr.abort();
                });
                /**
    * Handle input from the underlying xhr: either a state change,
    * the progress event or the request being complete.
    */ function handleProgress() {
                    if (String(xhr.status)[0] === '2') {
                        var textSoFar = xhr.responseText;
                        var newText = (' ' + textSoFar.substr(numberOfCharsAlreadyGivenToCallback)).substr(1);
                        /* Raise the event for new text.

       On older browsers, the new text is the whole response.
       On newer/better ones, the fragment part that we got since
       last progress. */ if (newText) emitStreamData(newText);
                        numberOfCharsAlreadyGivenToCallback = Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* len */ ])(textSoFar);
                    }
                }
                if ('onprogress' in xhr) xhr.onprogress = handleProgress;
                function sendStartIfNotAlready(xhr) {
                    // Internet Explorer is very unreliable as to when xhr.status etc can
                    // be read so has to be protected with try/catch and tried again on
                    // the next readyState if it fails
                    try {
                        stillToSendStartEvent && oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["c" /* HTTP_START */ ]).emit(xhr.status, Object(__WEBPACK_IMPORTED_MODULE_3__parseResponseHeaders_browser__["a" /* parseResponseHeaders */ ])(xhr.getAllResponseHeaders()));
                        stillToSendStartEvent = false;
                    } catch (e) {}
                }
                xhr.onreadystatechange = function() {
                    switch(xhr.readyState){
                        case 2:
                        case 3:
                            return sendStartIfNotAlready(xhr);
                        case 4:
                            sendStartIfNotAlready(xhr) // if xhr.status hasn't been available yet, it must be NOW, huh IE?
                            ;
                            // is this a 2xx http code?
                            var successful = String(xhr.status)[0] === '2';
                            if (successful) {
                                // In Chrome 29 (not 28) no onprogress is emitted when a response
                                // is complete before the onload. We need to always do handleInput
                                // in case we get the load but have not had a final progress event.
                                // This looks like a bug and may change in future but let's take
                                // the safest approach and assume we might not have received a
                                // progress event for each part of the response
                                handleProgress();
                                oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["n" /* STREAM_END */ ]).emit();
                            } else emitFail(Object(__WEBPACK_IMPORTED_MODULE_1__events__["o" /* errorReport */ ])(xhr.status, xhr.responseText));
                    }
                };
                try {
                    xhr.open(method, url, true);
                    for(var headerName in headers)xhr.setRequestHeader(headerName, headers[headerName]);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__detectCrossOrigin_browser__["a" /* isCrossOrigin */ ])(window.location, Object(__WEBPACK_IMPORTED_MODULE_0__detectCrossOrigin_browser__["b" /* parseUrlOrigin */ ])(url))) xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                    xhr.withCredentials = withCredentials;
                    xhr.send(data);
                } catch (e) {
                    // To keep a consistent interface with Node, we can't emit an event here.
                    // Node's streaming http adaptor receives the error as an asynchronous
                    // event rather than as an exception. If we emitted now, the Oboe user
                    // has had no chance to add a .fail listener so there is no way
                    // the event could be useful. For both these reasons defer the
                    // firing to the next JS frame.
                    window.setTimeout(Object(__WEBPACK_IMPORTED_MODULE_4__functional__["j" /* partialComplete */ ])(emitFail, Object(__WEBPACK_IMPORTED_MODULE_1__events__["o" /* errorReport */ ])(undefined, undefined, e)), 0);
                }
            }
        /***/ },
        /* 19 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return isCrossOrigin;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return parseUrlOrigin;
            });
            /**
 * Detect if a given URL is cross-origin in the scope of the
 * current page.
 *
 * Browser only (since cross-origin has no meaning in Node.js)
 *
 * @param {Object} pageLocation - as in window.location
 * @param {Object} ajaxHost - an object like window.location describing the
 *    origin of the url that we want to ajax in
 */ function isCrossOrigin(pageLocation, ajaxHost) {
                /*
    * NB: defaultPort only knows http and https.
    * Returns undefined otherwise.
    */ function defaultPort(protocol) {
                    return ({
                        'http:': 80,
                        'https:': 443
                    })[protocol];
                }
                function portOf(location) {
                    // pageLocation should always have a protocol. ajaxHost if no port or
                    // protocol is specified, should use the port of the containing page
                    return String(location.port || defaultPort(location.protocol || pageLocation.protocol));
                }
                // if ajaxHost doesn't give a domain, port is the same as pageLocation
                // it can't give a protocol but not a domain
                // it can't give a port but not a domain
                return !!(ajaxHost.protocol && ajaxHost.protocol !== pageLocation.protocol || ajaxHost.host && ajaxHost.host !== pageLocation.host || ajaxHost.host && portOf(ajaxHost) !== portOf(pageLocation));
            }
            /* turn any url into an object like window.location */ function parseUrlOrigin(url) {
                // url could be domain-relative
                // url could give a domain
                // cross origin means:
                //    same domain
                //    same port
                //    some protocol
                // so, same everything up to the first (single) slash
                // if such is given
                //
                // can ignore everything after that
                var URL_HOST_PATTERN = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/;
                // if no match, use an empty array so that
                // subexpressions 1,2,3 are all undefined
                // and will ultimately return all empty
                // strings as the parse result:
                var urlHostMatch = URL_HOST_PATTERN.exec(url) || [];
                return {
                    protocol: urlHostMatch[1] || '',
                    host: urlHostMatch[2] || '',
                    port: urlHostMatch[3] || ''
                };
            }
        /***/ },
        /* 20 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return parseResponseHeaders;
            });
            // based on gist https://gist.github.com/monsur/706839
            /**
 * XmlHttpRequest's getAllResponseHeaders() method returns a string of response
 * headers according to the format described here:
 * http://www.w3.org/TR/XMLHttpRequest/#the-getallresponseheaders-method
 * This method parses that string into a user-friendly key/value pair object.
 */ function parseResponseHeaders(headerStr) {
                var headers = {};
                headerStr && headerStr.split('\u000d\u000a').forEach(function(headerPair) {
                    // Can't use split() here because it does the wrong thing
                    // if the header value has the string ": " in it.
                    var index = headerPair.indexOf('\u003a\u0020');
                    headers[headerPair.substring(0, index)] = headerPair.substring(index + 2);
                });
                return headers;
            }
        /***/ }
    ])["default"];
});

});



parcelRegister("gzatY", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file extend.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $hA2kM = parcelRequire("hA2kM");
var $c0f80bd8bba9059c$require$formatters = $hA2kM.formatters;

var $lIu4V = parcelRequire("lIu4V");

var $9y1Dl = parcelRequire("9y1Dl");
var $c0f80bd8bba9059c$var$extend = function(pckg) {
    /* jshint maxcomplexity:5 */ var ex = function(extension) {
        var extendedObject;
        if (extension.property) {
            if (!pckg[extension.property]) pckg[extension.property] = {};
            extendedObject = pckg[extension.property];
        } else extendedObject = pckg;
        if (extension.methods) extension.methods.forEach(function(method) {
            if (!(method instanceof $lIu4V)) method = new $lIu4V(method);
            method.attachToObject(extendedObject);
            method.setRequestManager(pckg._requestManager);
        });
        return pckg;
    };
    ex.formatters = $c0f80bd8bba9059c$require$formatters;
    ex.utils = $9y1Dl;
    ex.Method = $lIu4V;
    return ex;
};
module.exports = $c0f80bd8bba9059c$var$extend;

});
parcelRegister("lIu4V", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2017
 */ 'use strict';

var $hA2kM = parcelRequire("hA2kM");
var $fcf509f913f9b55f$require$errors = $hA2kM.errors;

var $hA2kM = parcelRequire("hA2kM");
var $fcf509f913f9b55f$require$formatters = $hA2kM.formatters;

var $9y1Dl = parcelRequire("9y1Dl");

var $4wdBS = parcelRequire("4wdBS");

var $hhXfq = parcelRequire("hhXfq");
var $fcf509f913f9b55f$require$Subscriptions = $hhXfq.subscriptions;

var $TyNFl = parcelRequire("TyNFl");
var $fcf509f913f9b55f$var$Method = function Method(options) {
    if (!options.call || !options.name) throw new Error('When creating a method you need to provide at least the "name" and "call" property.');
    this.name = options.name;
    this.call = options.call;
    this.params = options.params || 0;
    this.inputFormatter = options.inputFormatter;
    this.outputFormatter = options.outputFormatter;
    this.transformPayload = options.transformPayload;
    this.extraFormatters = options.extraFormatters;
    this.abiCoder = options.abiCoder; // Will be used to encode the revert reason string
    this.requestManager = options.requestManager;
    // reference to eth.accounts
    this.accounts = options.accounts;
    this.defaultBlock = options.defaultBlock || 'latest';
    this.defaultAccount = options.defaultAccount || null;
    this.transactionBlockTimeout = options.transactionBlockTimeout || 50;
    this.transactionConfirmationBlocks = options.transactionConfirmationBlocks || 24;
    this.transactionPollingTimeout = options.transactionPollingTimeout || 750;
    this.transactionPollingInterval = options.transactionPollingInterval || 1000;
    this.blockHeaderTimeout = options.blockHeaderTimeout || 10; // 10 seconds
    this.defaultCommon = options.defaultCommon;
    this.defaultChain = options.defaultChain;
    this.defaultHardfork = options.defaultHardfork;
    this.handleRevert = options.handleRevert;
};
$fcf509f913f9b55f$var$Method.prototype.setRequestManager = function(requestManager, accounts) {
    this.requestManager = requestManager;
    // reference to eth.accounts
    if (accounts) this.accounts = accounts;
};
$fcf509f913f9b55f$var$Method.prototype.createFunction = function(requestManager, accounts) {
    var func = this.buildCall();
    func.call = this.call;
    this.setRequestManager(requestManager || this.requestManager, accounts || this.accounts);
    return func;
};
$fcf509f913f9b55f$var$Method.prototype.attachToObject = function(obj) {
    var func = this.buildCall();
    func.call = this.call;
    var name = this.name.split('.');
    if (name.length > 1) {
        obj[name[0]] = obj[name[0]] || {};
        obj[name[0]][name[1]] = func;
    } else obj[name[0]] = func;
};
/**
 * Should be used to determine name of the jsonrpc method based on arguments
 *
 * @method getCall
 * @param {Array} arguments
 * @return {String} name of jsonrpc method
 */ $fcf509f913f9b55f$var$Method.prototype.getCall = function(args) {
    return typeof this.call === 'function' ? this.call(args) : this.call;
};
/**
 * Should be used to extract callback from array of arguments. Modifies input param
 *
 * @method extractCallback
 * @param {Array} arguments
 * @return {Function|Null} callback, if exists
 */ $fcf509f913f9b55f$var$Method.prototype.extractCallback = function(args) {
    if (typeof args[args.length - 1] === 'function') return args.pop(); // modify the args array!
};
/**
 * Should be called to check if the number of arguments is correct
 *
 * @method validateArgs
 * @param {Array} arguments
 * @throws {Error} if it is not
 */ $fcf509f913f9b55f$var$Method.prototype.validateArgs = function(args) {
    if (args.length !== this.params) throw $fcf509f913f9b55f$require$errors.InvalidNumberOfParams(args.length, this.params, this.name);
};
/**
 * Should be called to format input args of method
 *
 * @method formatInput
 * @param {Array}
 * @return {Array}
 */ $fcf509f913f9b55f$var$Method.prototype.formatInput = function(args) {
    var _this = this;
    if (!this.inputFormatter) return args;
    return this.inputFormatter.map(function(formatter, index) {
        // bind this for defaultBlock, and defaultAccount
        return formatter ? formatter.call(_this, args[index]) : args[index];
    });
};
/**
 * Should be called to format output(result) of method
 *
 * @method formatOutput
 * @param {Object}
 * @return {Object}
 */ $fcf509f913f9b55f$var$Method.prototype.formatOutput = function(result) {
    var _this = this;
    if (Array.isArray(result)) return result.map(function(res) {
        return _this.outputFormatter && res ? _this.outputFormatter(res) : res;
    });
    else return this.outputFormatter && result ? this.outputFormatter(result) : result;
};
/**
 * Should create payload from given input args
 *
 * @method toPayload
 * @param {Array} args
 * @return {Object}
 */ $fcf509f913f9b55f$var$Method.prototype.toPayload = function(args) {
    var call = this.getCall(args);
    var callback = this.extractCallback(args);
    var params = this.formatInput(args);
    this.validateArgs(params);
    var payload = {
        method: call,
        params: params,
        callback: callback
    };
    if (this.transformPayload) payload = this.transformPayload(payload);
    return payload;
};
$fcf509f913f9b55f$var$Method.prototype._confirmTransaction = function(defer, result, payload) {
    var method = this, promiseResolved = false, canUnsubscribe = true, timeoutCount = 0, confirmationCount = 0, intervalId = null, blockHeaderTimeoutId = null, lastBlock = null, receiptJSON = '', gasProvided = !!payload.params[0] && typeof payload.params[0] === 'object' && payload.params[0].gas ? payload.params[0].gas : null, isContractDeployment = !!payload.params[0] && typeof payload.params[0] === 'object' && payload.params[0].data && payload.params[0].from && !payload.params[0].to, hasBytecode = isContractDeployment && payload.params[0].data.length > 2;
    // add custom send Methods
    var _ethereumCalls = [
        new $fcf509f913f9b55f$var$Method({
            name: 'getBlockByNumber',
            call: 'eth_getBlockByNumber',
            params: 2,
            inputFormatter: [
                $fcf509f913f9b55f$require$formatters.inputBlockNumberFormatter,
                function(val) {
                    return !!val;
                }
            ],
            outputFormatter: $fcf509f913f9b55f$require$formatters.outputBlockFormatter
        }),
        new $fcf509f913f9b55f$var$Method({
            name: 'getTransactionReceipt',
            call: 'eth_getTransactionReceipt',
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: $fcf509f913f9b55f$require$formatters.outputTransactionReceiptFormatter
        }),
        new $fcf509f913f9b55f$var$Method({
            name: 'getCode',
            call: 'eth_getCode',
            params: 2,
            inputFormatter: [
                $fcf509f913f9b55f$require$formatters.inputAddressFormatter,
                $fcf509f913f9b55f$require$formatters.inputDefaultBlockNumberFormatter
            ]
        }),
        new $fcf509f913f9b55f$var$Method({
            name: 'getTransactionByHash',
            call: 'eth_getTransactionByHash',
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: $fcf509f913f9b55f$require$formatters.outputTransactionFormatter
        }),
        new $fcf509f913f9b55f$require$Subscriptions({
            name: 'subscribe',
            type: 'eth',
            subscriptions: {
                'newBlockHeaders': {
                    subscriptionName: 'newHeads',
                    params: 0,
                    outputFormatter: $fcf509f913f9b55f$require$formatters.outputBlockFormatter
                }
            }
        })
    ];
    // attach methods to this._ethereumCall
    var _ethereumCall = {};
    _ethereumCalls.forEach((mthd)=>{
        mthd.attachToObject(_ethereumCall);
        mthd.requestManager = method.requestManager; // assign rather than call setRequestManager()
    });
    // fire "receipt" and confirmation events and resolve after
    var checkConfirmation = function(existingReceipt, isPolling, err, blockHeader, sub) {
        if (!err) {
            // create fake unsubscribe
            if (!sub) sub = {
                unsubscribe: function() {
                    clearInterval(intervalId);
                    clearTimeout(blockHeaderTimeoutId);
                }
            };
            // if we have a valid receipt we don't need to send a request
            return (existingReceipt ? $4wdBS.resolve(existingReceipt) : _ethereumCall.getTransactionReceipt(result))// catch error from requesting receipt
            .catch(function(err) {
                sub.unsubscribe();
                promiseResolved = true;
                $9y1Dl._fireError({
                    message: 'Failed to check for transaction receipt:',
                    data: err
                }, defer.eventEmitter, defer.reject);
            })// if CONFIRMATION listener exists check for confirmations, by setting canUnsubscribe = false
            .then(async function(receipt) {
                if (!receipt || !receipt.blockHash) throw new Error('Receipt missing or blockHash null');
                // apply extra formatters
                if (method.extraFormatters && method.extraFormatters.receiptFormatter) receipt = method.extraFormatters.receiptFormatter(receipt);
                // check if confirmation listener exists
                if (defer.eventEmitter.listeners('confirmation').length > 0) {
                    var block;
                    // If there was an immediately retrieved receipt, it's already
                    // been confirmed by the direct call to checkConfirmation needed
                    // for parity instant-seal
                    if (existingReceipt === undefined || confirmationCount !== 0) {
                        // Get latest block to emit with confirmation
                        var latestBlock = await _ethereumCall.getBlockByNumber('latest');
                        var latestBlockHash = latestBlock ? latestBlock.hash : null;
                        if (isPolling) {
                            if (lastBlock) {
                                block = await _ethereumCall.getBlockByNumber(lastBlock.number + 1);
                                if (block) {
                                    lastBlock = block;
                                    defer.eventEmitter.emit('confirmation', confirmationCount, receipt, latestBlockHash);
                                }
                            } else {
                                block = await _ethereumCall.getBlockByNumber(receipt.blockNumber);
                                lastBlock = block;
                                defer.eventEmitter.emit('confirmation', confirmationCount, receipt, latestBlockHash);
                            }
                        } else defer.eventEmitter.emit('confirmation', confirmationCount, receipt, latestBlockHash);
                    }
                    if (isPolling && block || !isPolling) confirmationCount++;
                    canUnsubscribe = false;
                    if (confirmationCount === method.transactionConfirmationBlocks + 1) {
                        sub.unsubscribe();
                        defer.eventEmitter.removeAllListeners();
                    }
                }
                return receipt;
            })// CHECK for CONTRACT DEPLOYMENT
            .then(async function(receipt) {
                if (isContractDeployment && !promiseResolved) {
                    if (!receipt.contractAddress) {
                        if (canUnsubscribe) {
                            sub.unsubscribe();
                            promiseResolved = true;
                        }
                        $9y1Dl._fireError($fcf509f913f9b55f$require$errors.NoContractAddressFoundError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                        return;
                    }
                    var code;
                    try {
                        code = await _ethereumCall.getCode(receipt.contractAddress);
                    } catch (err) {
                    // ignore;
                    }
                    if (!code) return;
                    // If deployment is status.true and there was a real
                    // bytecode string, assume it was successful.
                    var deploymentSuccess = receipt.status === true && hasBytecode;
                    if (deploymentSuccess || code.length > 2) {
                        defer.eventEmitter.emit('receipt', receipt);
                        // if contract, return instance instead of receipt
                        if (method.extraFormatters && method.extraFormatters.contractDeployFormatter) defer.resolve(method.extraFormatters.contractDeployFormatter(receipt));
                        else defer.resolve(receipt);
                        // need to remove listeners, as they aren't removed automatically when succesfull
                        if (canUnsubscribe) defer.eventEmitter.removeAllListeners();
                    } else $9y1Dl._fireError($fcf509f913f9b55f$require$errors.ContractCodeNotStoredError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                    if (canUnsubscribe) sub.unsubscribe();
                    promiseResolved = true;
                }
                return receipt;
            })// CHECK for normal tx check for receipt only
            .then(async function(receipt) {
                if (!isContractDeployment && !promiseResolved) {
                    if (!receipt.outOfGas && (!gasProvided || gasProvided !== receipt.gasUsed) && (receipt.status === true || receipt.status === '0x1' || typeof receipt.status === 'undefined')) {
                        defer.eventEmitter.emit('receipt', receipt);
                        defer.resolve(receipt);
                        // need to remove listeners, as they aren't removed automatically when succesfull
                        if (canUnsubscribe) defer.eventEmitter.removeAllListeners();
                    } else {
                        receiptJSON = JSON.stringify(receipt, null, 2);
                        if (receipt.status === false || receipt.status === '0x0') try {
                            var revertMessage = null;
                            if (method.handleRevert && (method.call === 'eth_sendTransaction' || method.call === 'eth_sendRawTransaction')) {
                                var txReplayOptions = payload.params[0];
                                // If send was raw, fetch the transaction and reconstitute the
                                // original params so they can be replayed with `eth_call`
                                if (method.call === 'eth_sendRawTransaction') {
                                    var rawTransactionHex = payload.params[0];
                                    var parsedTx = $TyNFl.parse(rawTransactionHex);
                                    txReplayOptions = $fcf509f913f9b55f$require$formatters.inputTransactionFormatter({
                                        data: parsedTx.data,
                                        to: parsedTx.to,
                                        from: parsedTx.from,
                                        gas: parsedTx.gasLimit.toHexString(),
                                        gasPrice: parsedTx.gasPrice.toHexString(),
                                        value: parsedTx.value.toHexString()
                                    });
                                }
                                // Get revert reason string with eth_call
                                revertMessage = await method.getRevertReason(txReplayOptions, receipt.blockNumber);
                                if (revertMessage) $9y1Dl._fireError($fcf509f913f9b55f$require$errors.TransactionRevertInstructionError(revertMessage.reason, revertMessage.signature, receipt), defer.eventEmitter, defer.reject, null, receipt);
                                else throw false; // Throw false and let the try/catch statement handle the error correctly after
                            } else throw false; // Throw false and let the try/catch statement handle the error correctly after
                        } catch (error) {
                            // Throw an normal revert error if no revert reason is given or the detection of it is disabled
                            $9y1Dl._fireError($fcf509f913f9b55f$require$errors.TransactionRevertedWithoutReasonError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                        }
                        else // Throw OOG if status is not existing and provided gas and used gas are equal
                        $9y1Dl._fireError($fcf509f913f9b55f$require$errors.TransactionOutOfGasError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                    }
                    if (canUnsubscribe) sub.unsubscribe();
                    promiseResolved = true;
                }
            })// time out the transaction if not mined after 50 blocks
            .catch(function() {
                timeoutCount++;
                // check to see if we are http polling
                if (!!isPolling) // polling timeout is different than transactionBlockTimeout blocks since we are triggering every second
                {
                    if (timeoutCount - 1 >= method.transactionPollingTimeout) {
                        sub.unsubscribe();
                        promiseResolved = true;
                        $9y1Dl._fireError($fcf509f913f9b55f$require$errors.TransactionError('Transaction was not mined within ' + method.transactionPollingTimeout + ' seconds, please make sure your transaction was properly sent. Be aware that it might still be mined!'), defer.eventEmitter, defer.reject);
                    }
                } else if (timeoutCount - 1 >= method.transactionBlockTimeout) {
                    sub.unsubscribe();
                    promiseResolved = true;
                    $9y1Dl._fireError($fcf509f913f9b55f$require$errors.TransactionError('Transaction was not mined within ' + method.transactionBlockTimeout + ' blocks, please make sure your transaction was properly sent. Be aware that it might still be mined!'), defer.eventEmitter, defer.reject);
                }
            });
        } else {
            sub.unsubscribe();
            promiseResolved = true;
            $9y1Dl._fireError({
                message: 'Failed to subscribe to new newBlockHeaders to confirm the transaction receipts.',
                data: err
            }, defer.eventEmitter, defer.reject);
        }
    };
    // start watching for confirmation depending on the support features of the provider
    var startWatching = (function(existingReceipt) {
        let blockHeaderArrived = false;
        const startInterval = ()=>{
            intervalId = setInterval(checkConfirmation.bind(null, existingReceipt, true), method.transactionPollingInterval);
        };
        // If provider do not support event subscription use polling
        if (!this.requestManager.provider.on) return startInterval();
        // Subscribe to new block headers to look for tx receipt
        _ethereumCall.subscribe('newBlockHeaders', function(err, blockHeader, sub) {
            blockHeaderArrived = true;
            if (err || !blockHeader) // fall back to polling
            return startInterval();
            checkConfirmation(existingReceipt, false, err, blockHeader, sub);
        });
        // Fallback to polling if tx receipt didn't arrived in "blockHeaderTimeout" [10 seconds]
        blockHeaderTimeoutId = setTimeout(()=>{
            if (!blockHeaderArrived) startInterval();
        }, this.blockHeaderTimeout * 1000);
    }).bind(this);
    // first check if we already have a confirmed transaction
    _ethereumCall.getTransactionReceipt(result).then(function(receipt) {
        if (receipt && receipt.blockHash) {
            if (defer.eventEmitter.listeners('confirmation').length > 0) // We must keep on watching for new Blocks, if a confirmation listener is present
            startWatching(receipt);
            checkConfirmation(receipt, false);
        } else if (!promiseResolved) startWatching();
    }).catch(function() {
        if (!promiseResolved) startWatching();
    });
};
var $fcf509f913f9b55f$var$getWallet = function(from, accounts) {
    var wallet = null;
    // is index given
    if (typeof from === 'number') wallet = accounts.wallet[from];
    else if (!!from && typeof from === 'object' && from.address && from.privateKey) wallet = from;
    else wallet = accounts.wallet[from.toLowerCase()];
    return wallet;
};
$fcf509f913f9b55f$var$Method.prototype.buildCall = function() {
    var method = this, isSendTx = method.call === 'eth_sendTransaction' || method.call === 'eth_sendRawTransaction', isCall = method.call === 'eth_call';
    // actual send function
    var send = function() {
        var defer = $4wdBS(!isSendTx), payload = method.toPayload(Array.prototype.slice.call(arguments));
        // CALLBACK function
        var sendTxCallback = function(err, result) {
            if (method.handleRevert && isCall && method.abiCoder) {
                var reasonData;
                // Ganache / Geth <= 1.9.13 return the reason data as a successful eth_call response
                // Geth >= 1.9.15 attaches the reason data to an error object.
                // Geth 1.9.14 is missing revert reason (https://github.com/ethereum/web3.js/issues/3520)
                if (!err && method.isRevertReasonString(result)) reasonData = result.substring(10);
                else if (err && err.data) reasonData = err.data.substring(10);
                if (reasonData) {
                    var reason = method.abiCoder.decodeParameter('string', '0x' + reasonData);
                    var signature = 'Error(String)';
                    $9y1Dl._fireError($fcf509f913f9b55f$require$errors.RevertInstructionError(reason, signature), defer.eventEmitter, defer.reject, payload.callback, {
                        reason: reason,
                        signature: signature
                    });
                    return;
                }
            }
            try {
                result = method.formatOutput(result);
            } catch (e) {
                err = e;
            }
            if (result instanceof Error) err = result;
            if (!err) {
                if (payload.callback) payload.callback(null, result);
            } else {
                if (err.error) err = err.error;
                return $9y1Dl._fireError(err, defer.eventEmitter, defer.reject, payload.callback);
            }
            // return PROMISE
            if (!isSendTx) {
                if (!err) defer.resolve(result);
            } else {
                defer.eventEmitter.emit('transactionHash', result);
                method._confirmTransaction(defer, result, payload);
            }
        };
        // SENDS the SIGNED SIGNATURE
        var sendSignedTx = function(sign) {
            var signedPayload = {
                ...payload,
                method: 'eth_sendRawTransaction',
                params: [
                    sign.rawTransaction
                ]
            };
            method.requestManager.send(signedPayload, sendTxCallback);
        };
        var sendRequest = function(payload, method) {
            if (method && method.accounts && method.accounts.wallet && method.accounts.wallet.length) {
                var wallet;
                // ETH_SENDTRANSACTION
                if (payload.method === 'eth_sendTransaction') {
                    var tx = payload.params[0];
                    wallet = $fcf509f913f9b55f$var$getWallet(!!tx && typeof tx === 'object' ? tx.from : null, method.accounts);
                    // If wallet was found, sign tx, and send using sendRawTransaction
                    if (wallet && wallet.privateKey) {
                        var tx = JSON.parse(JSON.stringify(tx));
                        delete tx.from;
                        if (method.defaultChain && !tx.chain) tx.chain = method.defaultChain;
                        if (method.defaultHardfork && !tx.hardfork) tx.hardfork = method.defaultHardfork;
                        if (method.defaultCommon && !tx.common) tx.common = method.defaultCommon;
                        method.accounts.signTransaction(tx, wallet.privateKey).then(sendSignedTx).catch(function(err) {
                            if (typeof defer.eventEmitter.listeners === 'function' && defer.eventEmitter.listeners('error').length) {
                                try {
                                    defer.eventEmitter.emit('error', err);
                                } catch (err) {
                                // Ignore userland error prevent it to bubble up within web3.
                                }
                                defer.eventEmitter.removeAllListeners();
                                defer.eventEmitter.catch(function() {});
                            }
                            defer.reject(err);
                        });
                        return;
                    }
                // ETH_SIGN
                } else if (payload.method === 'eth_sign') {
                    var data = payload.params[1];
                    wallet = $fcf509f913f9b55f$var$getWallet(payload.params[0], method.accounts);
                    // If wallet was found, sign tx, and send using sendRawTransaction
                    if (wallet && wallet.privateKey) {
                        var sign = method.accounts.sign(data, wallet.privateKey);
                        if (payload.callback) payload.callback(null, sign.signature);
                        defer.resolve(sign.signature);
                        return;
                    }
                }
            }
            return method.requestManager.send(payload, sendTxCallback);
        };
        // Send the actual transaction
        if (isSendTx && !!payload.params[0] && typeof payload.params[0] === 'object' && typeof payload.params[0].gasPrice === 'undefined' && (typeof payload.params[0].maxPriorityFeePerGas === 'undefined' || typeof payload.params[0].maxFeePerGas === 'undefined')) $fcf509f913f9b55f$var$_handleTxPricing(method, payload.params[0]).then((txPricing)=>{
            if (txPricing.gasPrice !== undefined) payload.params[0].gasPrice = txPricing.gasPrice;
            else if (txPricing.maxPriorityFeePerGas !== undefined && txPricing.maxFeePerGas !== undefined) {
                payload.params[0].maxPriorityFeePerGas = txPricing.maxPriorityFeePerGas;
                payload.params[0].maxFeePerGas = txPricing.maxFeePerGas;
            }
            if (isSendTx) setTimeout(()=>{
                defer.eventEmitter.emit('sending', payload);
            }, 0);
            sendRequest(payload, method);
        });
        else {
            if (isSendTx) setTimeout(()=>{
                defer.eventEmitter.emit('sending', payload);
            }, 0);
            sendRequest(payload, method);
        }
        if (isSendTx) setTimeout(()=>{
            defer.eventEmitter.emit('sent', payload);
        }, 0);
        return defer.eventEmitter;
    };
    // necessary to attach things to the method
    send.method = method;
    // necessary for batch requests
    send.request = this.request.bind(this);
    return send;
};
function $fcf509f913f9b55f$var$_handleTxPricing(method, tx) {
    return new Promise((resolve, reject)=>{
        try {
            var getBlockByNumber = new $fcf509f913f9b55f$var$Method({
                name: 'getBlockByNumber',
                call: 'eth_getBlockByNumber',
                params: 2,
                inputFormatter: [
                    function(blockNumber) {
                        return blockNumber ? $9y1Dl.toHex(blockNumber) : 'latest';
                    },
                    function() {
                        return false;
                    }
                ]
            }).createFunction(method.requestManager);
            var getGasPrice = new $fcf509f913f9b55f$var$Method({
                name: 'getGasPrice',
                call: 'eth_gasPrice',
                params: 0
            }).createFunction(method.requestManager);
            Promise.all([
                getBlockByNumber(),
                getGasPrice()
            ]).then((responses)=>{
                const [block, gasPrice] = responses;
                if ((tx.type === '0x2' || tx.type === undefined) && block && block.baseFeePerGas) {
                    // The network supports EIP-1559
                    // Taken from https://github.com/ethers-io/ethers.js/blob/ba6854bdd5a912fe873d5da494cb5c62c190adde/packages/abstract-provider/src.ts/index.ts#L230
                    let maxPriorityFeePerGas, maxFeePerGas;
                    if (tx.gasPrice) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        maxPriorityFeePerGas = tx.gasPrice;
                        maxFeePerGas = tx.gasPrice;
                        delete tx.gasPrice;
                    } else {
                        maxPriorityFeePerGas = tx.maxPriorityFeePerGas || '0x9502F900'; // 2.5 Gwei
                        maxFeePerGas = tx.maxFeePerGas || $9y1Dl.toHex($9y1Dl.toBN(block.baseFeePerGas).mul($9y1Dl.toBN(2)).add($9y1Dl.toBN(maxPriorityFeePerGas)));
                    }
                    resolve({
                        maxFeePerGas: maxFeePerGas,
                        maxPriorityFeePerGas: maxPriorityFeePerGas
                    });
                } else {
                    if (tx.maxPriorityFeePerGas || tx.maxFeePerGas) throw Error("Network doesn't support eip-1559");
                    resolve({
                        gasPrice: gasPrice
                    });
                }
            });
        } catch (error) {
            reject(error);
        }
    });
}
/**
 * Returns the revert reason string if existing or otherwise false.
 *
 * @method getRevertReason
 *
 * @param {Object} txOptions
 * @param {Number} blockNumber
 *
 * @returns {Promise<Boolean|String>}
 */ $fcf509f913f9b55f$var$Method.prototype.getRevertReason = function(txOptions, blockNumber) {
    var self = this;
    return new Promise(function(resolve, reject) {
        new $fcf509f913f9b55f$var$Method({
            name: 'call',
            call: 'eth_call',
            params: 2,
            abiCoder: self.abiCoder,
            handleRevert: true
        }).createFunction(self.requestManager)(txOptions, $9y1Dl.numberToHex(blockNumber)).then(function() {
            resolve(false);
        }).catch(function(error) {
            if (error.reason) resolve({
                reason: error.reason,
                signature: error.signature
            });
            else reject(error);
        });
    });
};
/**
 * Checks if the given hex string is a revert message from the EVM
 *
 * @method isRevertReasonString
 *
 * @param {String} data - Hex string prefixed with 0x
 *
 * @returns {Boolean}
 */ $fcf509f913f9b55f$var$Method.prototype.isRevertReasonString = function(data) {
    return typeof data === 'string' && (data.length - 2) / 2 % 32 === 4 && data.substring(0, 10) === '0x08c379a0';
};
/**
 * Should be called to create the pure JSONRPC request which can be used in a batch request
 *
 * @method request
 * @return {Object} jsonrpc request
 */ $fcf509f913f9b55f$var$Method.prototype.request = function() {
    var payload = this.toPayload(Array.prototype.slice.call(arguments));
    payload.format = this.formatOutput.bind(this);
    return payload;
};
module.exports = $fcf509f913f9b55f$var$Method;

});
parcelRegister("4wdBS", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2016
 */ "use strict";

var $cL0OX = parcelRequire("cL0OX");
/**
 * This function generates a defer promise and adds eventEmitter functionality to it
 *
 * @method eventifiedPromise
 */ var $34a4b5348ffa9247$var$PromiEvent = function PromiEvent(justPromise) {
    var resolve, reject, eventEmitter = new Promise(function() {
        resolve = arguments[0];
        reject = arguments[1];
    });
    if (justPromise) return {
        resolve: resolve,
        reject: reject,
        eventEmitter: eventEmitter
    };
    // get eventEmitter
    var emitter = new $cL0OX();
    // add eventEmitter to the promise
    eventEmitter._events = emitter._events;
    eventEmitter.emit = emitter.emit;
    eventEmitter.on = emitter.on;
    eventEmitter.once = emitter.once;
    eventEmitter.off = emitter.off;
    eventEmitter.listeners = emitter.listeners;
    eventEmitter.addListener = emitter.addListener;
    eventEmitter.removeListener = emitter.removeListener;
    eventEmitter.removeAllListeners = emitter.removeAllListeners;
    return {
        resolve: resolve,
        reject: reject,
        eventEmitter: eventEmitter
    };
};
$34a4b5348ffa9247$var$PromiEvent.resolve = function(value) {
    var promise = $34a4b5348ffa9247$var$PromiEvent(true);
    promise.resolve(value);
    return promise.eventEmitter;
};
module.exports = $34a4b5348ffa9247$var$PromiEvent;

});
parcelRegister("cL0OX", function(module, exports) {
'use strict';
var $949a82dabcff9ff6$var$has = Object.prototype.hasOwnProperty, $949a82dabcff9ff6$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $949a82dabcff9ff6$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $949a82dabcff9ff6$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $949a82dabcff9ff6$var$Events().__proto__) $949a82dabcff9ff6$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $949a82dabcff9ff6$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $949a82dabcff9ff6$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $949a82dabcff9ff6$var$EE(fn, context || emitter, once), evt = $949a82dabcff9ff6$var$prefix ? $949a82dabcff9ff6$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $949a82dabcff9ff6$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $949a82dabcff9ff6$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $949a82dabcff9ff6$var$EventEmitter() {
    this._events = new $949a82dabcff9ff6$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $949a82dabcff9ff6$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($949a82dabcff9ff6$var$has.call(events, name)) names.push($949a82dabcff9ff6$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $949a82dabcff9ff6$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $949a82dabcff9ff6$var$prefix ? $949a82dabcff9ff6$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $949a82dabcff9ff6$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $949a82dabcff9ff6$var$prefix ? $949a82dabcff9ff6$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $949a82dabcff9ff6$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $949a82dabcff9ff6$var$prefix ? $949a82dabcff9ff6$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $949a82dabcff9ff6$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $949a82dabcff9ff6$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $949a82dabcff9ff6$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $949a82dabcff9ff6$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $949a82dabcff9ff6$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $949a82dabcff9ff6$var$prefix ? $949a82dabcff9ff6$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $949a82dabcff9ff6$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $949a82dabcff9ff6$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $949a82dabcff9ff6$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $949a82dabcff9ff6$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $949a82dabcff9ff6$var$prefix ? $949a82dabcff9ff6$var$prefix + event : event;
        if (this._events[evt]) $949a82dabcff9ff6$var$clearEvent(this, evt);
    } else {
        this._events = new $949a82dabcff9ff6$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$949a82dabcff9ff6$var$EventEmitter.prototype.off = $949a82dabcff9ff6$var$EventEmitter.prototype.removeListener;
$949a82dabcff9ff6$var$EventEmitter.prototype.addListener = $949a82dabcff9ff6$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$949a82dabcff9ff6$var$EventEmitter.prefixed = $949a82dabcff9ff6$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$949a82dabcff9ff6$var$EventEmitter.EventEmitter = $949a82dabcff9ff6$var$EventEmitter;
module.exports = $949a82dabcff9ff6$var$EventEmitter;

});


parcelRegister("hhXfq", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $7QdTE = parcelRequire("7QdTE");
var $c961fb8ec4ff98b2$var$Subscriptions = function Subscriptions(options) {
    this.name = options.name;
    this.type = options.type;
    this.subscriptions = options.subscriptions || {};
    this.requestManager = null;
};
$c961fb8ec4ff98b2$var$Subscriptions.prototype.setRequestManager = function(rm) {
    this.requestManager = rm;
};
$c961fb8ec4ff98b2$var$Subscriptions.prototype.attachToObject = function(obj) {
    var func = this.buildCall();
    var name = this.name.split('.');
    if (name.length > 1) {
        obj[name[0]] = obj[name[0]] || {};
        obj[name[0]][name[1]] = func;
    } else obj[name[0]] = func;
};
$c961fb8ec4ff98b2$var$Subscriptions.prototype.buildCall = function() {
    var _this = this;
    return function() {
        if (!_this.subscriptions[arguments[0]]) console.warn('Subscription ' + JSON.stringify(arguments[0]) + ' doesn\'t exist. Subscribing anyway.');
        var subscription = new $7QdTE({
            subscription: _this.subscriptions[arguments[0]] || {},
            requestManager: _this.requestManager,
            type: _this.type
        });
        return subscription.subscribe.apply(subscription, arguments);
    };
};
module.exports = {
    subscriptions: $c961fb8ec4ff98b2$var$Subscriptions,
    subscription: $7QdTE
};

});
parcelRegister("7QdTE", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file subscription.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $hA2kM = parcelRequire("hA2kM");
var $5b582b52dba694ea$require$errors = $hA2kM.errors;

var $gQRcN = parcelRequire("gQRcN");

var $hA2kM = parcelRequire("hA2kM");
var $5b582b52dba694ea$require$formatters = $hA2kM.formatters;
function $5b582b52dba694ea$var$identity(value) {
    return value;
}
function $5b582b52dba694ea$var$Subscription(options) {
    $gQRcN.call(this);
    this.id = null;
    this.callback = $5b582b52dba694ea$var$identity;
    this.arguments = null;
    this.lastBlock = null; // "from" block tracker for backfilling events on reconnection
    this.options = {
        subscription: options.subscription,
        type: options.type,
        requestManager: options.requestManager
    };
}
// INHERIT
$5b582b52dba694ea$var$Subscription.prototype = Object.create($gQRcN.prototype);
$5b582b52dba694ea$var$Subscription.prototype.constructor = $5b582b52dba694ea$var$Subscription;
/**
 * Should be used to extract callback from array of arguments. Modifies input param
 *
 * @method extractCallback
 * @param {Array} arguments
 * @return {Function|Null} callback, if exists
 */ $5b582b52dba694ea$var$Subscription.prototype._extractCallback = function(args) {
    if (typeof args[args.length - 1] === 'function') return args.pop(); // modify the args array!
};
/**
 * Should be called to check if the number of arguments is correct
 *
 * @method validateArgs
 * @param {Array} arguments
 * @throws {Error} if it is not
 */ $5b582b52dba694ea$var$Subscription.prototype._validateArgs = function(args) {
    var subscription = this.options.subscription;
    if (!subscription) subscription = {};
    if (!subscription.params) subscription.params = 0;
    if (args.length !== subscription.params) throw $5b582b52dba694ea$require$errors.InvalidNumberOfParams(args.length, subscription.params, subscription.subscriptionName);
};
/**
 * Should be called to format input args of method
 *
 * @method formatInput
 * @param {Array}
 * @return {Array}
 */ $5b582b52dba694ea$var$Subscription.prototype._formatInput = function(args) {
    var subscription = this.options.subscription;
    if (!subscription) return args;
    if (!subscription.inputFormatter) return args;
    var formattedArgs = subscription.inputFormatter.map(function(formatter, index) {
        return formatter ? formatter(args[index]) : args[index];
    });
    return formattedArgs;
};
/**
 * Should be called to format output(result) of method
 *
 * @method formatOutput
 * @param result {Object}
 * @return {Object}
 */ $5b582b52dba694ea$var$Subscription.prototype._formatOutput = function(result) {
    var subscription = this.options.subscription;
    return subscription && subscription.outputFormatter && result ? subscription.outputFormatter(result) : result;
};
/**
 * Should create payload from given input args
 *
 * @method toPayload
 * @param {Array} args
 * @return {Object}
 */ $5b582b52dba694ea$var$Subscription.prototype._toPayload = function(args) {
    var params = [];
    this.callback = this._extractCallback(args) || $5b582b52dba694ea$var$identity;
    if (!this.subscriptionMethod) {
        this.subscriptionMethod = args.shift();
        // replace subscription with given name
        if (this.options.subscription.subscriptionName) this.subscriptionMethod = this.options.subscription.subscriptionName;
    }
    if (!this.arguments) {
        this.arguments = this._formatInput(args);
        this._validateArgs(this.arguments);
        args = []; // make empty after validation
    }
    // re-add subscriptionName
    params.push(this.subscriptionMethod);
    params = params.concat(this.arguments);
    if (args.length) throw new Error('Only a callback is allowed as parameter on an already instantiated subscription.');
    return {
        method: this.options.type + '_subscribe',
        params: params
    };
};
/**
 * Unsubscribes and clears callbacks
 *
 * @method unsubscribe
 * @return {Object}
 */ $5b582b52dba694ea$var$Subscription.prototype.unsubscribe = function(callback) {
    this.options.requestManager.removeSubscription(this.id, callback);
    this.id = null;
    this.lastBlock = null;
    this.removeAllListeners();
};
/**
 * Subscribes and watches for changes
 *
 * @method subscribe
 * @param {String} subscription the subscription
 * @param {Object} options the options object with address topics and fromBlock
 * @return {Object}
 */ $5b582b52dba694ea$var$Subscription.prototype.subscribe = function() {
    var _this = this;
    var args = Array.prototype.slice.call(arguments);
    var payload = this._toPayload(args);
    if (!payload) return this;
    // throw error, if provider is not set
    if (!this.options.requestManager.provider) {
        setTimeout(function() {
            var err1 = new Error('No provider set.');
            _this.callback(err1, null, _this);
            _this.emit('error', err1);
        }, 0);
        return this;
    }
    // throw error, if provider doesnt support subscriptions
    if (!this.options.requestManager.provider.on) {
        setTimeout(function() {
            var err2 = new Error('The current provider doesn\'t support subscriptions: ' + _this.options.requestManager.provider.constructor.name);
            _this.callback(err2, null, _this);
            _this.emit('error', err2);
        }, 0);
        return this;
    }
    // Re-subscription only: continue fetching from the last block we received.
    // a dropped connection may have resulted in gaps in the logs...
    if (this.lastBlock && !!this.options.params && typeof this.options.params === 'object') {
        payload.params[1] = this.options.params;
        payload.params[1].fromBlock = $5b582b52dba694ea$require$formatters.inputBlockNumberFormatter(this.lastBlock + 1);
    }
    // if id is there unsubscribe first
    if (this.id) this.unsubscribe();
    // store the params in the options object
    this.options.params = payload.params[1];
    // get past logs, if fromBlock is available
    if (payload.params[0] === 'logs' && !!payload.params[1] && typeof payload.params[1] === 'object' && payload.params[1].hasOwnProperty('fromBlock') && isFinite(payload.params[1].fromBlock)) {
        // send the subscription request
        // copy the params to avoid race-condition with deletion below this block
        var blockParams = Object.assign({}, payload.params[1]);
        this.options.requestManager.send({
            method: 'eth_getLogs',
            params: [
                blockParams
            ]
        }, function(err, logs) {
            if (!err) logs.forEach(function(log) {
                var output = _this._formatOutput(log);
                _this.callback(null, output, _this);
                _this.emit('data', output);
            });
            else setTimeout(function() {
                _this.callback(err, null, _this);
                _this.emit('error', err);
            }, 0);
        });
    }
    // create subscription
    // TODO move to separate function? so that past logs can go first?
    if (typeof payload.params[1] === 'object') delete payload.params[1].fromBlock;
    this.options.requestManager.send(payload, function(err, result) {
        if (!err && result) {
            _this.id = result;
            _this.method = payload.params[0];
            // call callback on notifications
            _this.options.requestManager.addSubscription(_this, function(error, result) {
                if (!error) {
                    if (!Array.isArray(result)) result = [
                        result
                    ];
                    result.forEach(function(resultItem) {
                        var output = _this._formatOutput(resultItem);
                        // Track current block (for gaps introduced by dropped connections)
                        _this.lastBlock = !!output && typeof output === 'object' ? output.blockNumber : null;
                        if (typeof _this.options.subscription.subscriptionHandler === 'function') return _this.options.subscription.subscriptionHandler.call(_this, output);
                        else _this.emit('data', output);
                        // call the callback, last so that unsubscribe there won't affect the emit above
                        _this.callback(null, output, _this);
                    });
                } else {
                    _this.callback(error, false, _this);
                    _this.emit('error', error);
                }
            });
            _this.emit('connected', result);
        } else setTimeout(function() {
            _this.callback(err, false, _this);
            _this.emit('error', err);
        }, 0);
    });
    // return an object to cancel the subscription
    return this;
};
/**
 * Resubscribe
 *
 * @method resubscribe
 *
 * @returns {void}
 */ $5b582b52dba694ea$var$Subscription.prototype.resubscribe = function() {
    this.options.requestManager.removeSubscription(this.id); // unsubscribe
    this.id = null;
    this.subscribe(this.callback);
};
module.exports = $5b582b52dba694ea$var$Subscription;

});
parcelRegister("gQRcN", function(module, exports) {
'use strict';
var $c44ac62d93d59fc6$var$has = Object.prototype.hasOwnProperty, $c44ac62d93d59fc6$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $c44ac62d93d59fc6$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $c44ac62d93d59fc6$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $c44ac62d93d59fc6$var$Events().__proto__) $c44ac62d93d59fc6$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $c44ac62d93d59fc6$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $c44ac62d93d59fc6$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $c44ac62d93d59fc6$var$EE(fn, context || emitter, once), evt = $c44ac62d93d59fc6$var$prefix ? $c44ac62d93d59fc6$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $c44ac62d93d59fc6$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $c44ac62d93d59fc6$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $c44ac62d93d59fc6$var$EventEmitter() {
    this._events = new $c44ac62d93d59fc6$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $c44ac62d93d59fc6$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($c44ac62d93d59fc6$var$has.call(events, name)) names.push($c44ac62d93d59fc6$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $c44ac62d93d59fc6$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $c44ac62d93d59fc6$var$prefix ? $c44ac62d93d59fc6$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $c44ac62d93d59fc6$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $c44ac62d93d59fc6$var$prefix ? $c44ac62d93d59fc6$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $c44ac62d93d59fc6$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $c44ac62d93d59fc6$var$prefix ? $c44ac62d93d59fc6$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c44ac62d93d59fc6$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $c44ac62d93d59fc6$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c44ac62d93d59fc6$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $c44ac62d93d59fc6$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c44ac62d93d59fc6$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $c44ac62d93d59fc6$var$prefix ? $c44ac62d93d59fc6$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $c44ac62d93d59fc6$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $c44ac62d93d59fc6$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $c44ac62d93d59fc6$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c44ac62d93d59fc6$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $c44ac62d93d59fc6$var$prefix ? $c44ac62d93d59fc6$var$prefix + event : event;
        if (this._events[evt]) $c44ac62d93d59fc6$var$clearEvent(this, evt);
    } else {
        this._events = new $c44ac62d93d59fc6$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$c44ac62d93d59fc6$var$EventEmitter.prototype.off = $c44ac62d93d59fc6$var$EventEmitter.prototype.removeListener;
$c44ac62d93d59fc6$var$EventEmitter.prototype.addListener = $c44ac62d93d59fc6$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$c44ac62d93d59fc6$var$EventEmitter.prefixed = $c44ac62d93d59fc6$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$c44ac62d93d59fc6$var$EventEmitter.EventEmitter = $c44ac62d93d59fc6$var$EventEmitter;
module.exports = $c44ac62d93d59fc6$var$EventEmitter;

});



parcelRegister("TyNFl", function(module, exports) {

$parcel$export(module.exports, "parse", () => $0a7021bc70fec74d$export$98e6a39c04603d36);

var $bVwUc = parcelRequire("bVwUc");

var $1chjt = parcelRequire("1chjt");

var $aBzgs = parcelRequire("aBzgs");

var $gVGT9 = parcelRequire("gVGT9");

var $2yhyU = parcelRequire("2yhyU");

var $e72ut = parcelRequire("e72ut");

var $9BTKH = parcelRequire("9BTKH");

var $lWFPp = parcelRequire("lWFPp");

var $d1hml = parcelRequire("d1hml");

var $cmrHY = parcelRequire("cmrHY");
"use strict";
const $0a7021bc70fec74d$var$logger = new (0, $d1hml.Logger)((0, $cmrHY.version));
var $0a7021bc70fec74d$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($0a7021bc70fec74d$export$80349e05e0724e11 || ($0a7021bc70fec74d$export$80349e05e0724e11 = {}));
///////////////////////////////
function $0a7021bc70fec74d$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $bVwUc.getAddress)(value);
}
function $0a7021bc70fec74d$var$handleNumber(value) {
    if (value === "0x") return 0, $gVGT9.Zero;
    return (0, $1chjt.BigNumber).from(value);
}
// Legacy Transaction Fields
const $0a7021bc70fec74d$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $0a7021bc70fec74d$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $0a7021bc70fec74d$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $lWFPp.computePublicKey)(key);
    return (0, $bVwUc.getAddress)((0, $aBzgs.hexDataSlice)((0, $2yhyU.keccak256)((0, $aBzgs.hexDataSlice)(publicKey, 1)), 12));
}
function $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, signature) {
    return $0a7021bc70fec74d$export$e67e2732ba9803f9((0, $lWFPp.recoverPublicKey)((0, $aBzgs.arrayify)(digest), signature));
}
function $0a7021bc70fec74d$var$formatNumber(value, name) {
    const result = (0, $aBzgs.stripZeros)((0, $1chjt.BigNumber).from(value).toHexString());
    if (result.length > 32) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $0a7021bc70fec74d$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $bVwUc.getAddress)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $aBzgs.hexDataLength)(storageKey) !== 32) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $0a7021bc70fec74d$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $0a7021bc70fec74d$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $0a7021bc70fec74d$var$accessSetify(set[0], set[1]);
        }
        return $0a7021bc70fec74d$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $0a7021bc70fec74d$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $0a7021bc70fec74d$var$formatAccessList(value) {
    return $0a7021bc70fec74d$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $0a7021bc70fec74d$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $1chjt.BigNumber).from(transaction.gasPrice);
        const maxFeePerGas = (0, $1chjt.BigNumber).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $0a7021bc70fec74d$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $0a7021bc70fec74d$var$formatNumber(transaction.chainId || 0, "chainId"),
        $0a7021bc70fec74d$var$formatNumber(transaction.nonce || 0, "nonce"),
        $0a7021bc70fec74d$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $0a7021bc70fec74d$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $bVwUc.getAddress)(transaction.to) : "0x",
        $0a7021bc70fec74d$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $0a7021bc70fec74d$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $aBzgs.splitSignature)(signature);
        fields.push($0a7021bc70fec74d$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $aBzgs.stripZeros)(sig.r));
        fields.push((0, $aBzgs.stripZeros)(sig.s));
    }
    return (0, $aBzgs.hexConcat)([
        "0x02",
        $9BTKH.encode(fields)
    ]);
}
function $0a7021bc70fec74d$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $0a7021bc70fec74d$var$formatNumber(transaction.chainId || 0, "chainId"),
        $0a7021bc70fec74d$var$formatNumber(transaction.nonce || 0, "nonce"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $bVwUc.getAddress)(transaction.to) : "0x",
        $0a7021bc70fec74d$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $0a7021bc70fec74d$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $aBzgs.splitSignature)(signature);
        fields.push($0a7021bc70fec74d$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $aBzgs.stripZeros)(sig.r));
        fields.push((0, $aBzgs.stripZeros)(sig.s));
    }
    return (0, $aBzgs.hexConcat)([
        "0x01",
        $9BTKH.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $0a7021bc70fec74d$var$_serialize(transaction, signature) {
    (0, $e72ut.checkProperties)(transaction, $0a7021bc70fec74d$var$allowedTransactionKeys);
    const raw = [];
    $0a7021bc70fec74d$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $aBzgs.arrayify)((0, $aBzgs.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $aBzgs.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $aBzgs.hexlify)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $0a7021bc70fec74d$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $aBzgs.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $aBzgs.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $9BTKH.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $aBzgs.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $0a7021bc70fec74d$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $0a7021bc70fec74d$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $aBzgs.hexlify)(v));
    raw.push((0, $aBzgs.stripZeros)((0, $aBzgs.arrayify)(sig.r)));
    raw.push((0, $aBzgs.stripZeros)((0, $aBzgs.arrayify)(sig.s)));
    return $9BTKH.encode(raw);
}
function $0a7021bc70fec74d$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $0a7021bc70fec74d$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $0a7021bc70fec74d$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $0a7021bc70fec74d$var$_serializeEip2930(transaction, signature);
        case 2:
            return $0a7021bc70fec74d$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $0a7021bc70fec74d$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $d1hml.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $0a7021bc70fec74d$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $0a7021bc70fec74d$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $0a7021bc70fec74d$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $aBzgs.hexZeroPad)(fields[1], 32);
    tx.s = (0, $aBzgs.hexZeroPad)(fields[2], 32);
    try {
        const digest = (0, $2yhyU.keccak256)(serialize(tx));
        tx.from = $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {
        console.log(error);
    }
}
function $0a7021bc70fec74d$var$_parseEip1559(payload) {
    const transaction = $9BTKH.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $aBzgs.hexlify)(payload));
    const maxPriorityFeePerGas = $0a7021bc70fec74d$var$handleNumber(transaction[2]);
    const maxFeePerGas = $0a7021bc70fec74d$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[4]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[5]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $0a7021bc70fec74d$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $2yhyU.keccak256)(payload);
    $0a7021bc70fec74d$var$_parseEipSignature(tx, transaction.slice(9), $0a7021bc70fec74d$var$_serializeEip1559);
    return tx;
}
function $0a7021bc70fec74d$var$_parseEip2930(payload) {
    const transaction = $9BTKH.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $aBzgs.hexlify)(payload));
    const tx = {
        type: 1,
        chainId: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $0a7021bc70fec74d$var$handleNumber(transaction[2]),
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[3]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[4]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $0a7021bc70fec74d$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $2yhyU.keccak256)(payload);
    $0a7021bc70fec74d$var$_parseEipSignature(tx, transaction.slice(8), $0a7021bc70fec74d$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $0a7021bc70fec74d$var$_parse(rawTransaction) {
    const transaction = $9BTKH.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $0a7021bc70fec74d$var$handleNumber(transaction[1]),
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[2]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[3]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $1chjt.BigNumber).from(transaction[6]).toNumber();
    } catch (error) {
        console.log(error);
        return tx;
    }
    tx.r = (0, $aBzgs.hexZeroPad)(transaction[7], 32);
    tx.s = (0, $aBzgs.hexZeroPad)(transaction[8], 32);
    if ((0, $1chjt.BigNumber).from(tx.r).isZero() && (0, $1chjt.BigNumber).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $aBzgs.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $2yhyU.keccak256)($9BTKH.encode(raw));
        try {
            tx.from = $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, {
                r: (0, $aBzgs.hexlify)(tx.r),
                s: (0, $aBzgs.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {
            console.log(error);
        }
        tx.hash = (0, $2yhyU.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $0a7021bc70fec74d$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $aBzgs.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $0a7021bc70fec74d$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $0a7021bc70fec74d$var$_parseEip2930(payload);
        case 2:
            return $0a7021bc70fec74d$var$_parseEip1559(payload);
        default:
            break;
    }
    return $0a7021bc70fec74d$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $d1hml.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

});
parcelRegister("bVwUc", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $8aee8aee2d40605d$export$88411125f012957a);

var $aBzgs = parcelRequire("aBzgs");

var $1chjt = parcelRequire("1chjt");

var $2yhyU = parcelRequire("2yhyU");

var $9BTKH = parcelRequire("9BTKH");

var $d1hml = parcelRequire("d1hml");

var $kFJax = parcelRequire("kFJax");
"use strict";
const $8aee8aee2d40605d$var$logger = new (0, $d1hml.Logger)((0, $kFJax.version));
function $8aee8aee2d40605d$var$getChecksumAddress(address) {
    if (!(0, $aBzgs.isHexString)(address, 20)) $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $aBzgs.arrayify)((0, $2yhyU.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $8aee8aee2d40605d$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $8aee8aee2d40605d$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $8aee8aee2d40605d$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$8aee8aee2d40605d$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$8aee8aee2d40605d$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $8aee8aee2d40605d$var$safeDigits = Math.floor($8aee8aee2d40605d$var$log10($8aee8aee2d40605d$var$MAX_SAFE_INTEGER));
function $8aee8aee2d40605d$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $8aee8aee2d40605d$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $8aee8aee2d40605d$var$safeDigits){
        let block = expanded.substring(0, $8aee8aee2d40605d$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $8aee8aee2d40605d$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $8aee8aee2d40605d$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $8aee8aee2d40605d$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $8aee8aee2d40605d$var$ibanChecksum(address)) $8aee8aee2d40605d$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $1chjt._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $8aee8aee2d40605d$var$getChecksumAddress("0x" + result);
    } else $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $8aee8aee2d40605d$export$977e255126d763d6(address) {
    try {
        $8aee8aee2d40605d$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $8aee8aee2d40605d$export$962c4ddada9f668f(address) {
    let base36 = (0, $1chjt._base16To36)($8aee8aee2d40605d$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $8aee8aee2d40605d$var$ibanChecksum("XE00" + base36) + base36;
}
function $8aee8aee2d40605d$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $8aee8aee2d40605d$export$88411125f012957a(transaction.from);
    } catch (error) {
        $8aee8aee2d40605d$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $aBzgs.stripZeros)((0, $aBzgs.arrayify)((0, $1chjt.BigNumber).from(transaction.nonce).toHexString()));
    return $8aee8aee2d40605d$export$88411125f012957a((0, $aBzgs.hexDataSlice)((0, $2yhyU.keccak256)((0, $9BTKH.encode)([
        from,
        nonce
    ])), 12));
}
function $8aee8aee2d40605d$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $aBzgs.hexDataLength)(salt) !== 32) $8aee8aee2d40605d$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $aBzgs.hexDataLength)(initCodeHash) !== 32) $8aee8aee2d40605d$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $8aee8aee2d40605d$export$88411125f012957a((0, $aBzgs.hexDataSlice)((0, $2yhyU.keccak256)((0, $aBzgs.concat)([
        "0xff",
        $8aee8aee2d40605d$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRegister("aBzgs", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", () => $7b88b6e03e4708f2$export$9a14abb1a440cd5e);
$parcel$export(module.exports, "isHexString", () => $7b88b6e03e4708f2$export$b02a40aff8e4ad18);
$parcel$export(module.exports, "isBytes", () => $7b88b6e03e4708f2$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "arrayify", () => $7b88b6e03e4708f2$export$3131421a7d01b4fb);
$parcel$export(module.exports, "concat", () => $7b88b6e03e4708f2$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "stripZeros", () => $7b88b6e03e4708f2$export$a8f4574d0e56446c);
$parcel$export(module.exports, "hexlify", () => $7b88b6e03e4708f2$export$2b0d6b5fbe698c70);
$parcel$export(module.exports, "hexDataLength", () => $7b88b6e03e4708f2$export$13882f896d3c0683);
$parcel$export(module.exports, "hexDataSlice", () => $7b88b6e03e4708f2$export$15da666eba198c18);
$parcel$export(module.exports, "hexConcat", () => $7b88b6e03e4708f2$export$6d4b99629b38754a);
$parcel$export(module.exports, "hexZeroPad", () => $7b88b6e03e4708f2$export$e9c46a54370b47e8);
$parcel$export(module.exports, "splitSignature", () => $7b88b6e03e4708f2$export$7fb170f1e457988f);

var $d1hml = parcelRequire("d1hml");

var $cSpPr = parcelRequire("cSpPr");
"use strict";
const $7b88b6e03e4708f2$var$logger = new (0, $d1hml.Logger)((0, $cSpPr.version));
///////////////////////////////
function $7b88b6e03e4708f2$var$isHexable(value) {
    return !!value.toHexString;
}
function $7b88b6e03e4708f2$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $7b88b6e03e4708f2$export$9a14abb1a440cd5e(value) {
    return $7b88b6e03e4708f2$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $7b88b6e03e4708f2$export$c6fabfbfd097fc30(value);
}
function $7b88b6e03e4708f2$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $7b88b6e03e4708f2$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$7b88b6e03e4708f2$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$7b88b6e03e4708f2$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $7b88b6e03e4708f2$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $7b88b6e03e4708f2$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($7b88b6e03e4708f2$var$isHexable(value)) value = value.toHexString();
    if ($7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0x0" + hex.substring(2);
            else if (options.hexPad === "right") hex += "0";
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(result));
    }
    if ($7b88b6e03e4708f2$export$c6fabfbfd097fc30(value)) return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(value));
    return $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $7b88b6e03e4708f2$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$7b88b6e03e4708f2$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $7b88b6e03e4708f2$var$addSlice(result);
}
function $7b88b6e03e4708f2$export$a8f4574d0e56446c(value) {
    let result = $7b88b6e03e4708f2$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d(value, length) {
    value = $7b88b6e03e4708f2$export$3131421a7d01b4fb(value);
    if (value.length > length) $7b88b6e03e4708f2$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $7b88b6e03e4708f2$var$addSlice(result);
}
function $7b88b6e03e4708f2$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $7b88b6e03e4708f2$var$HexCharacters = "0123456789abcdef";
function $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $7b88b6e03e4708f2$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $7b88b6e03e4708f2$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($7b88b6e03e4708f2$var$isHexable(value)) return value.toHexString();
    if ($7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($7b88b6e03e4708f2$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $7b88b6e03e4708f2$var$HexCharacters[(v & 0xf0) >> 4] + $7b88b6e03e4708f2$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $7b88b6e03e4708f2$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(data);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $7b88b6e03e4708f2$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(data);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(data) || data.length % 2) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $7b88b6e03e4708f2$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $7b88b6e03e4708f2$export$6916af760a341dd3(value) {
    const trimmed = $7b88b6e03e4708f2$export$967bc0082a978949($7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $7b88b6e03e4708f2$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value);
    if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $7b88b6e03e4708f2$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $7b88b6e03e4708f2$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $7b88b6e03e4708f2$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0
    };
    if ($7b88b6e03e4708f2$export$9a14abb1a440cd5e(signature)) {
        const bytes = $7b88b6e03e4708f2$export$3131421a7d01b4fb(signature);
        if (bytes.length !== 65) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid signature string; must be 65 bytes", "signature", signature);
        // Get the r, s and v
        result.r = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
        result.s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        result.v = bytes[64];
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d($7b88b6e03e4708f2$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result.r)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result.s)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result.s, 32);
        const vs = $7b88b6e03e4708f2$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result._vs)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    return result;
}
function $7b88b6e03e4708f2$export$71bb9d78a59bbe25(signature) {
    signature = $7b88b6e03e4708f2$export$7fb170f1e457988f(signature);
    return $7b88b6e03e4708f2$export$2b0d6b5fbe698c70($7b88b6e03e4708f2$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("d1hml", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $97a8d5981d597bb7$export$efa9a398d6368992);

var $6utZY = parcelRequire("6utZY");
"use strict";
let $97a8d5981d597bb7$var$_permanentCensorErrors = false;
let $97a8d5981d597bb7$var$_censorErrors = false;
const $97a8d5981d597bb7$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $97a8d5981d597bb7$var$_logLevel = $97a8d5981d597bb7$var$LogLevels["default"];
let $97a8d5981d597bb7$var$_globalLogger = null;
function $97a8d5981d597bb7$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $97a8d5981d597bb7$var$_normalizeError = $97a8d5981d597bb7$var$_checkNormalize();
var $97a8d5981d597bb7$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($97a8d5981d597bb7$export$243e62d78d3b544d || ($97a8d5981d597bb7$export$243e62d78d3b544d = {}));
var $97a8d5981d597bb7$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($97a8d5981d597bb7$export$d4e71bc0b80dc0fb || ($97a8d5981d597bb7$export$d4e71bc0b80dc0fb = {}));
const $97a8d5981d597bb7$var$HEX = "0123456789abcdef";
class $97a8d5981d597bb7$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($97a8d5981d597bb7$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($97a8d5981d597bb7$var$_logLevel > $97a8d5981d597bb7$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($97a8d5981d597bb7$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $97a8d5981d597bb7$var$HEX[value[i] >> 4];
                        hex += $97a8d5981d597bb7$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($97a8d5981d597bb7$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $97a8d5981d597bb7$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$97a8d5981d597bb7$var$_globalLogger) $97a8d5981d597bb7$var$_globalLogger = new $97a8d5981d597bb7$export$efa9a398d6368992((0, $6utZY.version));
        return $97a8d5981d597bb7$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($97a8d5981d597bb7$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $97a8d5981d597bb7$var$_censorErrors = !!censorship;
        $97a8d5981d597bb7$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $97a8d5981d597bb7$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $97a8d5981d597bb7$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $97a8d5981d597bb7$var$_logLevel = level;
    }
    static from(version) {
        return new $97a8d5981d597bb7$export$efa9a398d6368992(version);
    }
}
$97a8d5981d597bb7$export$efa9a398d6368992.errors = $97a8d5981d597bb7$export$d4e71bc0b80dc0fb;
$97a8d5981d597bb7$export$efa9a398d6368992.levels = $97a8d5981d597bb7$export$243e62d78d3b544d;

});
parcelRegister("6utZY", function(module, exports) {

$parcel$export(module.exports, "version", () => $4b9cd088fca23de9$export$83d89fbfd8236492);
const $4b9cd088fca23de9$export$83d89fbfd8236492 = "logger/5.5.0";

});


parcelRegister("cSpPr", function(module, exports) {

$parcel$export(module.exports, "version", () => $95fe903f324809f2$export$83d89fbfd8236492);
const $95fe903f324809f2$export$83d89fbfd8236492 = "bytes/5.5.0";

});


parcelRegister("1chjt", function(module, exports) {

$parcel$export(module.exports, "BigNumber", () => $0df4577496dcf693$export$d97aa349ed20696);
$parcel$export(module.exports, "_base36To16", () => $0df4577496dcf693$export$51e4a08295f7770f);
$parcel$export(module.exports, "_base16To36", () => $0df4577496dcf693$export$1293db5d29c264ff);

var $5eD7a = parcelRequire("5eD7a");

var $aBzgs = parcelRequire("aBzgs");

var $d1hml = parcelRequire("d1hml");

var $e2x6L = parcelRequire("e2x6L");
"use strict";
var $0df4577496dcf693$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($5eD7a))).BN;
const $0df4577496dcf693$var$logger = new (0, $d1hml.Logger)((0, $e2x6L.version));
const $0df4577496dcf693$var$_constructorGuard = {};
const $0df4577496dcf693$var$MAX_SAFE = 0x1fffffffffffff;
function $0df4577496dcf693$export$a3d0a7fa9b65683b(value) {
    return value != null && ($0df4577496dcf693$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $aBzgs.isHexString)(value) || typeof value === "bigint" || (0, $aBzgs.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $0df4577496dcf693$var$_warnedToStringRadix = false;
class $0df4577496dcf693$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        $0df4577496dcf693$var$logger.checkNew(new.target, $0df4577496dcf693$export$d97aa349ed20696);
        if (constructorGuard !== $0df4577496dcf693$var$_constructorGuard) $0df4577496dcf693$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $d1hml.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $0df4577496dcf693$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).add($0df4577496dcf693$var$toBN(other)));
    }
    sub(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).sub($0df4577496dcf693$var$toBN(other)));
    }
    div(other) {
        const o = $0df4577496dcf693$export$d97aa349ed20696.from(other);
        if (o.isZero()) $0df4577496dcf693$var$throwFault("division by zero", "div");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).div($0df4577496dcf693$var$toBN(other)));
    }
    mul(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).mul($0df4577496dcf693$var$toBN(other)));
    }
    mod(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (value.isNeg()) $0df4577496dcf693$var$throwFault("cannot modulo negative values", "mod");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (value.isNeg()) $0df4577496dcf693$var$throwFault("cannot raise to negative values", "pow");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("cannot 'and' negative values", "and");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).and(value));
    }
    or(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("cannot 'or' negative values", "or");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("cannot 'xor' negative values", "xor");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("cannot mask negative values", "mask");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("cannot shift negative values", "shl");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("cannot shift negative values", "shr");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $0df4577496dcf693$var$toBN(this).eq($0df4577496dcf693$var$toBN(other));
    }
    lt(other) {
        return $0df4577496dcf693$var$toBN(this).lt($0df4577496dcf693$var$toBN(other));
    }
    lte(other) {
        return $0df4577496dcf693$var$toBN(this).lte($0df4577496dcf693$var$toBN(other));
    }
    gt(other) {
        return $0df4577496dcf693$var$toBN(this).gt($0df4577496dcf693$var$toBN(other));
    }
    gte(other) {
        return $0df4577496dcf693$var$toBN(this).gte($0df4577496dcf693$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $0df4577496dcf693$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $0df4577496dcf693$var$toBN(this).toNumber();
        } catch (error) {
            $0df4577496dcf693$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $0df4577496dcf693$var$logger.throwError("this platform does not support BigInt", (0, $d1hml.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$0df4577496dcf693$var$_warnedToStringRadix) {
                    $0df4577496dcf693$var$_warnedToStringRadix = true;
                    $0df4577496dcf693$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $0df4577496dcf693$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $d1hml.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $0df4577496dcf693$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $d1hml.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $0df4577496dcf693$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $0df4577496dcf693$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $0df4577496dcf693$export$d97aa349ed20696($0df4577496dcf693$var$_constructorGuard, $0df4577496dcf693$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $0df4577496dcf693$export$d97aa349ed20696($0df4577496dcf693$var$_constructorGuard, $0df4577496dcf693$var$toHex(new $0df4577496dcf693$var$BN(value)));
            return $0df4577496dcf693$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $0df4577496dcf693$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $0df4577496dcf693$var$MAX_SAFE || value <= -$0df4577496dcf693$var$MAX_SAFE) $0df4577496dcf693$var$throwFault("overflow", "BigNumber.from", value);
            return $0df4577496dcf693$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $0df4577496dcf693$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $aBzgs.isBytes)(anyValue)) return $0df4577496dcf693$export$d97aa349ed20696.from((0, $aBzgs.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $0df4577496dcf693$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $aBzgs.isHexString)(hex) || hex[0] === "-" && (0, $aBzgs.isHexString)(hex.substring(1))) return $0df4577496dcf693$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $0df4577496dcf693$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $0df4577496dcf693$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $0df4577496dcf693$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $0df4577496dcf693$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $0df4577496dcf693$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $0df4577496dcf693$var$toBigNumber(value) {
    return $0df4577496dcf693$export$d97aa349ed20696.from($0df4577496dcf693$var$toHex(value));
}
function $0df4577496dcf693$var$toBN(value) {
    const hex = $0df4577496dcf693$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $0df4577496dcf693$var$BN("-" + hex.substring(3), 16);
    return new $0df4577496dcf693$var$BN(hex.substring(2), 16);
}
function $0df4577496dcf693$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $0df4577496dcf693$var$logger.throwError(fault, (0, $d1hml.Logger).errors.NUMERIC_FAULT, params);
}
function $0df4577496dcf693$export$51e4a08295f7770f(value) {
    return new $0df4577496dcf693$var$BN(value, 36).toString(16);
}
function $0df4577496dcf693$export$1293db5d29c264ff(value) {
    return new $0df4577496dcf693$var$BN(value, 16).toString(36);
}

});
parcelRegister("5eD7a", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("e2x6L", function(module, exports) {

$parcel$export(module.exports, "version", () => $a38aef31efdfa85e$export$83d89fbfd8236492);
const $a38aef31efdfa85e$export$83d89fbfd8236492 = "bignumber/5.5.0";

});


parcelRegister("2yhyU", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $1dbc6131e27af3ca$export$f8151fce47ad1c35);

var $1IGmO = parcelRequire("1IGmO");

var $aBzgs = parcelRequire("aBzgs");
"use strict";
function $1dbc6131e27af3ca$export$f8151fce47ad1c35(data) {
    return '0x' + (0, (/*@__PURE__*/$parcel$interopDefault($1IGmO))).keccak_256((0, $aBzgs.arrayify)(data));
}

});

parcelRegister("9BTKH", function(module, exports) {

$parcel$export(module.exports, "encode", () => $6ff2d0f6bfa15181$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $6ff2d0f6bfa15181$export$2f872c0f2117be69);

var $aBzgs = parcelRequire("aBzgs");

var $d1hml = parcelRequire("d1hml");

var $bcrL7 = parcelRequire("bcrL7");
"use strict";
const $6ff2d0f6bfa15181$var$logger = new (0, $d1hml.Logger)((0, $bcrL7.version));
function $6ff2d0f6bfa15181$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $6ff2d0f6bfa15181$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($6ff2d0f6bfa15181$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $6ff2d0f6bfa15181$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $aBzgs.isBytesLike)(object)) $6ff2d0f6bfa15181$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $aBzgs.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $6ff2d0f6bfa15181$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $6ff2d0f6bfa15181$export$c564cdbbe6da493(object) {
    return (0, $aBzgs.hexlify)($6ff2d0f6bfa15181$var$_encode(object));
}
function $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $6ff2d0f6bfa15181$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $6ff2d0f6bfa15181$var$logger.throwError("child data too short", (0, $d1hml.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $6ff2d0f6bfa15181$var$_decode(data, offset) {
    if (data.length === 0) $6ff2d0f6bfa15181$var$logger.throwError("data too short", (0, $d1hml.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data short segment too short", (0, $d1hml.Logger).errors.BUFFER_OVERRUN, {});
        const length = $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data long segment too short", (0, $d1hml.Logger).errors.BUFFER_OVERRUN, {});
        return $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $d1hml.Logger).errors.BUFFER_OVERRUN, {});
        return $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $d1hml.Logger).errors.BUFFER_OVERRUN, {});
        const length = $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $d1hml.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $aBzgs.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data too short", (0, $d1hml.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $aBzgs.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $aBzgs.hexlify)(data[offset])
    };
}
function $6ff2d0f6bfa15181$export$2f872c0f2117be69(data) {
    const bytes = (0, $aBzgs.arrayify)(data);
    const decoded = $6ff2d0f6bfa15181$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $6ff2d0f6bfa15181$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRegister("bcrL7", function(module, exports) {

$parcel$export(module.exports, "version", () => $82765913239667f9$export$83d89fbfd8236492);
const $82765913239667f9$export$83d89fbfd8236492 = "rlp/5.5.0";

});


parcelRegister("kFJax", function(module, exports) {

$parcel$export(module.exports, "version", () => $f0caac95ce71359f$export$83d89fbfd8236492);
const $f0caac95ce71359f$export$83d89fbfd8236492 = "address/5.5.0";

});


parcelRegister("gVGT9", function(module, exports) {

$parcel$export(module.exports, "NegativeOne", () => $c5333cf79421e056$export$c83ef0909a6ddeec);
$parcel$export(module.exports, "Zero", () => $c5333cf79421e056$export$aaef8a3eae948f03);
$parcel$export(module.exports, "One", () => $c5333cf79421e056$export$9aa05a5866350bcf);
$parcel$export(module.exports, "MaxUint256", () => $c5333cf79421e056$export$1b53890de5aabdd0);

var $1chjt = parcelRequire("1chjt");
const $c5333cf79421e056$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $1chjt.BigNumber).from(-1);
const $c5333cf79421e056$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $1chjt.BigNumber).from(0);
const $c5333cf79421e056$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $1chjt.BigNumber).from(1);
const $c5333cf79421e056$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $1chjt.BigNumber).from(2);
const $c5333cf79421e056$export$c8db55bd7405209e = /*#__PURE__*/ (0, $1chjt.BigNumber).from("1000000000000000000");
const $c5333cf79421e056$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $1chjt.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $c5333cf79421e056$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $1chjt.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $c5333cf79421e056$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $1chjt.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});

parcelRegister("e72ut", function(module, exports) {

$parcel$export(module.exports, "defineReadOnly", () => $a463a6b5f08d6875$export$104236534534f9be);
$parcel$export(module.exports, "getStatic", () => $a463a6b5f08d6875$export$f695fbbf3cdaaf47);
$parcel$export(module.exports, "checkProperties", () => $a463a6b5f08d6875$export$ae5a316ba623b73a);
$parcel$export(module.exports, "Description", () => $a463a6b5f08d6875$export$393edc798c47379d);

var $d1hml = parcelRequire("d1hml");

var $kgXnl = parcelRequire("kgXnl");
"use strict";
var $a463a6b5f08d6875$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $a463a6b5f08d6875$var$logger = new (0, $d1hml.Logger)((0, $kgXnl.version));
function $a463a6b5f08d6875$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $a463a6b5f08d6875$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $a463a6b5f08d6875$export$d503dd157d963b60(object) {
    return $a463a6b5f08d6875$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $a463a6b5f08d6875$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $a463a6b5f08d6875$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $a463a6b5f08d6875$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $a463a6b5f08d6875$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $a463a6b5f08d6875$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$a463a6b5f08d6875$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $a463a6b5f08d6875$var$_deepCopy(object) {
    if ($a463a6b5f08d6875$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$a463a6b5f08d6875$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $a463a6b5f08d6875$export$104236534534f9be(result, key, $a463a6b5f08d6875$export$6c40052bed430212(value));
        }
        return result;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $a463a6b5f08d6875$export$6c40052bed430212(object) {
    return $a463a6b5f08d6875$var$_deepCopy(object);
}
class $a463a6b5f08d6875$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $a463a6b5f08d6875$export$6c40052bed430212(info[key]);
    }
}

});
parcelRegister("kgXnl", function(module, exports) {

$parcel$export(module.exports, "version", () => $ec235c03b0398629$export$83d89fbfd8236492);
const $ec235c03b0398629$export$83d89fbfd8236492 = "properties/5.5.0";

});


parcelRegister("lWFPp", function(module, exports) {

$parcel$export(module.exports, "computePublicKey", () => $ff9f75f56da7c459$export$4a89473d39301224);
$parcel$export(module.exports, "recoverPublicKey", () => $ff9f75f56da7c459$export$952dd09fbe0232b7);

var $8ywx4 = parcelRequire("8ywx4");

var $aBzgs = parcelRequire("aBzgs");

var $e72ut = parcelRequire("e72ut");

var $d1hml = parcelRequire("d1hml");

var $eaG84 = parcelRequire("eaG84");
"use strict";
const $ff9f75f56da7c459$var$logger = new (0, $d1hml.Logger)((0, $eaG84.version));
let $ff9f75f56da7c459$var$_curve = null;
function $ff9f75f56da7c459$var$getCurve() {
    if (!$ff9f75f56da7c459$var$_curve) $ff9f75f56da7c459$var$_curve = new (0, $8ywx4.EC)("secp256k1");
    return $ff9f75f56da7c459$var$_curve;
}
class $ff9f75f56da7c459$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $e72ut.defineReadOnly)(this, "curve", "secp256k1");
        (0, $e72ut.defineReadOnly)(this, "privateKey", (0, $aBzgs.hexlify)(privateKey));
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $aBzgs.arrayify)(this.privateKey));
        (0, $e72ut.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $e72ut.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $e72ut.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $aBzgs.arrayify)(this.publicKey));
        const p1 = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $aBzgs.arrayify)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $aBzgs.arrayify)(this.privateKey));
        const digestBytes = (0, $aBzgs.arrayify)(digest);
        if (digestBytes.length !== 32) $ff9f75f56da7c459$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $aBzgs.splitSignature)({
            recoveryParam: signature.recoveryParam,
            r: (0, $aBzgs.hexZeroPad)("0x" + signature.r.toString(16), 32),
            s: (0, $aBzgs.hexZeroPad)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $aBzgs.arrayify)(this.privateKey));
        const otherKeyPair = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $aBzgs.arrayify)($ff9f75f56da7c459$export$4a89473d39301224(otherKey)));
        return (0, $aBzgs.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $ff9f75f56da7c459$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $aBzgs.splitSignature)(signature);
    const rs = {
        r: (0, $aBzgs.arrayify)(sig.r),
        s: (0, $aBzgs.arrayify)(sig.s)
    };
    return "0x" + $ff9f75f56da7c459$var$getCurve().recoverPubKey((0, $aBzgs.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $ff9f75f56da7c459$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $aBzgs.arrayify)(key);
    if (bytes.length === 32) {
        const signingKey = new $ff9f75f56da7c459$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $aBzgs.hexlify)(bytes);
        return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $aBzgs.hexlify)(bytes);
        return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $ff9f75f56da7c459$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

});
parcelRegister("8ywx4", function(module, exports) {

$parcel$export(module.exports, "EC", () => $63aabbf7dfa8a956$export$129fe12d32abc311);

var $cXTXN = parcelRequire("cXTXN");

var $kiSKt = parcelRequire("kiSKt");
var $63aabbf7dfa8a956$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $63aabbf7dfa8a956$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function $63aabbf7dfa8a956$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $63aabbf7dfa8a956$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $63aabbf7dfa8a956$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, 'default') ? n['default'] : n;
}
function $63aabbf7dfa8a956$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, 'default') && Object.keys(n).length === 1 ? n['default'] : n;
}
function $63aabbf7dfa8a956$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, '__esModule', {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $63aabbf7dfa8a956$var$commonjsRequire() {
    throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}
var $63aabbf7dfa8a956$var$minimalisticAssert = $63aabbf7dfa8a956$var$assert;
function $63aabbf7dfa8a956$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$63aabbf7dfa8a956$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};
var $63aabbf7dfa8a956$var$utils_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    'use strict';
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== 'string') {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return '0' + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = '';
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === 'hex') return toHex(arr);
        else return arr;
    };
});
var $63aabbf7dfa8a956$var$utils_1$1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    'use strict';
    var utils = exports;
    utils.assert = $63aabbf7dfa8a956$var$minimalisticAssert;
    utils.toArray = $63aabbf7dfa8a956$var$utils_1.toArray;
    utils.zero2 = $63aabbf7dfa8a956$var$utils_1.zero2;
    utils.toHex = $63aabbf7dfa8a956$var$utils_1.toHex;
    utils.encode = $63aabbf7dfa8a956$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = '_' + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(bytes, 'hex', 'le');
    }
    utils.intFromLE = intFromLE;
});
'use strict';
var $63aabbf7dfa8a956$var$getNAF = $63aabbf7dfa8a956$var$utils_1$1.getNAF;
var $63aabbf7dfa8a956$var$getJSF = $63aabbf7dfa8a956$var$utils_1$1.getJSF;
var $63aabbf7dfa8a956$var$assert$1 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $63aabbf7dfa8a956$var$base = $63aabbf7dfa8a956$var$BaseCurve;
$63aabbf7dfa8a956$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$63aabbf7dfa8a956$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $63aabbf7dfa8a956$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $63aabbf7dfa8a956$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $63aabbf7dfa8a956$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $63aabbf7dfa8a956$var$assert$1(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $63aabbf7dfa8a956$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $63aabbf7dfa8a956$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $63aabbf7dfa8a956$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $63aabbf7dfa8a956$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$63aabbf7dfa8a956$var$BaseCurve.BasePoint = $63aabbf7dfa8a956$var$BasePoint;
$63aabbf7dfa8a956$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$63aabbf7dfa8a956$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$63aabbf7dfa8a956$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $63aabbf7dfa8a956$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $63aabbf7dfa8a956$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $63aabbf7dfa8a956$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$63aabbf7dfa8a956$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$63aabbf7dfa8a956$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$63aabbf7dfa8a956$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $63aabbf7dfa8a956$var$utils_1$1.encode(this._encode(compact), enc);
};
$63aabbf7dfa8a956$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$63aabbf7dfa8a956$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$63aabbf7dfa8a956$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $63aabbf7dfa8a956$var$inherits_browser = $63aabbf7dfa8a956$var$createCommonjsModule(function(module) {
    if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
'use strict';
var $63aabbf7dfa8a956$var$assert$2 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$ShortCurve(conf) {
    $63aabbf7dfa8a956$var$base.call(this, 'short', conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$ShortCurve, $63aabbf7dfa8a956$var$base);
var $63aabbf7dfa8a956$var$short_1 = $63aabbf7dfa8a956$var$ShortCurve;
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $63aabbf7dfa8a956$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $63aabbf7dfa8a956$var$Point(curve, x, y, isRed) {
    $63aabbf7dfa8a956$var$base.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$Point, $63aabbf7dfa8a956$var$base.BasePoint);
$63aabbf7dfa8a956$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $63aabbf7dfa8a956$var$Point(this, x, y, isRed);
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $63aabbf7dfa8a956$var$Point.fromJSON(this, obj, red);
};
$63aabbf7dfa8a956$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$63aabbf7dfa8a956$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$63aabbf7dfa8a956$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$63aabbf7dfa8a956$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$63aabbf7dfa8a956$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$63aabbf7dfa8a956$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$63aabbf7dfa8a956$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$63aabbf7dfa8a956$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$63aabbf7dfa8a956$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$63aabbf7dfa8a956$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$63aabbf7dfa8a956$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$63aabbf7dfa8a956$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$63aabbf7dfa8a956$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$63aabbf7dfa8a956$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$63aabbf7dfa8a956$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $63aabbf7dfa8a956$var$JPoint(curve, x, y, z) {
    $63aabbf7dfa8a956$var$base.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$JPoint, $63aabbf7dfa8a956$var$base.BasePoint);
$63aabbf7dfa8a956$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $63aabbf7dfa8a956$var$JPoint(this, x, y, z);
};
$63aabbf7dfa8a956$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$63aabbf7dfa8a956$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$63aabbf7dfa8a956$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$63aabbf7dfa8a956$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$63aabbf7dfa8a956$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$63aabbf7dfa8a956$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$63aabbf7dfa8a956$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$63aabbf7dfa8a956$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $63aabbf7dfa8a956$var$curve_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    'use strict';
    var curve = exports;
    curve.base = $63aabbf7dfa8a956$var$base;
    curve.short = $63aabbf7dfa8a956$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $63aabbf7dfa8a956$var$curves_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    'use strict';
    var curves = exports;
    var assert = $63aabbf7dfa8a956$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === 'short') this.curve = new $63aabbf7dfa8a956$var$curve_1.short(options);
        else if (options.type === 'edwards') this.curve = new $63aabbf7dfa8a956$var$curve_1.edwards(options);
        else this.curve = new $63aabbf7dfa8a956$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), 'Invalid curve');
        assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve('p192', {
        type: 'short',
        prime: 'p192',
        p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
        a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
        b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
        n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
            '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
        ]
    });
    defineCurve('p224', {
        type: 'short',
        prime: 'p224',
        p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
        a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
        b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
        n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
            'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
        ]
    });
    defineCurve('p256', {
        type: 'short',
        prime: null,
        p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
        a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
        b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
        n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
            '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
        ]
    });
    defineCurve('p384', {
        type: 'short',
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve('p521', {
        type: 'short',
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve('curve25519', {
        type: 'mont',
        prime: 'p25519',
        p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
        a: '76d06',
        b: '1',
        n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            '9'
        ]
    });
    defineCurve('ed25519', {
        type: 'edwards',
        prime: 'p25519',
        p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
        a: '-1',
        c: '1',
        // -121665 * (121666^(-1)) (mod P)
        d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
        n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
            // 4/5
            '6666666666666666666666666666666666666666666666666666666666666658'
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve('secp256k1', {
        type: 'short',
        prime: 'k256',
        p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
        a: '0',
        b: '7',
        n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
        h: '1',
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        // Precomputed endomorphism
        beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
        lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
        basis: [
            {
                a: '3086d221a7d46bcde86c90e49284eb15',
                b: '-e4437ed6010e88286f547fa90abfe4c3'
            },
            {
                a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
                b: '3086d221a7d46bcde86c90e49284eb15'
            }
        ],
        gRed: false,
        g: [
            '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
            '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
            pre
        ]
    });
});
'use strict';
function $63aabbf7dfa8a956$var$HmacDRBG(options) {
    if (!(this instanceof $63aabbf7dfa8a956$var$HmacDRBG)) return new $63aabbf7dfa8a956$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $63aabbf7dfa8a956$var$utils_1.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $63aabbf7dfa8a956$var$utils_1.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $63aabbf7dfa8a956$var$utils_1.toArray(options.pers, options.persEnc || 'hex');
    $63aabbf7dfa8a956$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
var $63aabbf7dfa8a956$var$hmacDrbg = $63aabbf7dfa8a956$var$HmacDRBG;
$63aabbf7dfa8a956$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac(this.hash, this.K);
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $63aabbf7dfa8a956$var$utils_1.toArray(entropy, entropyEnc);
    add = $63aabbf7dfa8a956$var$utils_1.toArray(add, addEnc);
    $63aabbf7dfa8a956$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $63aabbf7dfa8a956$var$utils_1.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $63aabbf7dfa8a956$var$utils_1.encode(res, enc);
};
'use strict';
var $63aabbf7dfa8a956$var$assert$3 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $63aabbf7dfa8a956$var$key = $63aabbf7dfa8a956$var$KeyPair;
$63aabbf7dfa8a956$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $63aabbf7dfa8a956$var$KeyPair) return pub;
    return new $63aabbf7dfa8a956$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$63aabbf7dfa8a956$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $63aabbf7dfa8a956$var$KeyPair) return priv;
    return new $63aabbf7dfa8a956$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$63aabbf7dfa8a956$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$63aabbf7dfa8a956$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$63aabbf7dfa8a956$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$63aabbf7dfa8a956$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $63aabbf7dfa8a956$var$assert$3(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $63aabbf7dfa8a956$var$assert$3(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$63aabbf7dfa8a956$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $63aabbf7dfa8a956$var$assert$3(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$63aabbf7dfa8a956$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};
'use strict';
var $63aabbf7dfa8a956$var$assert$4 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$Signature(options, enc) {
    if (options instanceof $63aabbf7dfa8a956$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $63aabbf7dfa8a956$var$assert$4(options.r && options.s, 'Signature without r or s');
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $63aabbf7dfa8a956$var$signature = $63aabbf7dfa8a956$var$Signature;
function $63aabbf7dfa8a956$var$Position() {
    this.place = 0;
}
function $63aabbf7dfa8a956$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $63aabbf7dfa8a956$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$63aabbf7dfa8a956$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $63aabbf7dfa8a956$var$utils_1$1.toArray(data, enc);
    var p = new $63aabbf7dfa8a956$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $63aabbf7dfa8a956$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $63aabbf7dfa8a956$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $63aabbf7dfa8a956$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(s);
    this.recoveryParam = null;
    return true;
};
function $63aabbf7dfa8a956$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$63aabbf7dfa8a956$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $63aabbf7dfa8a956$var$rmPadding(r);
    s = $63aabbf7dfa8a956$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $63aabbf7dfa8a956$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $63aabbf7dfa8a956$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $63aabbf7dfa8a956$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $63aabbf7dfa8a956$var$utils_1$1.encode(res, enc);
};
'use strict';
var $63aabbf7dfa8a956$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error('unsupported');
};
var $63aabbf7dfa8a956$var$assert$5 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$EC(options) {
    if (!(this instanceof $63aabbf7dfa8a956$var$EC)) return new $63aabbf7dfa8a956$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $63aabbf7dfa8a956$var$assert$5(Object.prototype.hasOwnProperty.call($63aabbf7dfa8a956$var$curves_1, options), 'Unknown curve ' + options);
        options = $63aabbf7dfa8a956$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $63aabbf7dfa8a956$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $63aabbf7dfa8a956$var$ec = $63aabbf7dfa8a956$var$EC;
$63aabbf7dfa8a956$var$EC.prototype.keyPair = function keyPair(options) {
    return new $63aabbf7dfa8a956$var$key(this, options);
};
$63aabbf7dfa8a956$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $63aabbf7dfa8a956$var$key.fromPrivate(this, priv, enc);
};
$63aabbf7dfa8a956$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $63aabbf7dfa8a956$var$key.fromPublic(this, pub, enc);
};
$63aabbf7dfa8a956$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $63aabbf7dfa8a956$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $63aabbf7dfa8a956$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$63aabbf7dfa8a956$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$63aabbf7dfa8a956$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $63aabbf7dfa8a956$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $63aabbf7dfa8a956$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$63aabbf7dfa8a956$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, 'hex');
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$63aabbf7dfa8a956$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $63aabbf7dfa8a956$var$assert$5((3 & j) === j, 'The recovery param is more than two bits');
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($cXTXN)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$63aabbf7dfa8a956$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};
var $63aabbf7dfa8a956$var$elliptic_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    'use strict';
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $63aabbf7dfa8a956$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error('unsupported');
    };
    elliptic.curve = $63aabbf7dfa8a956$var$curve_1;
    elliptic.curves = $63aabbf7dfa8a956$var$curves_1;
    // Protocols
    elliptic.ec = $63aabbf7dfa8a956$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $63aabbf7dfa8a956$export$129fe12d32abc311 = $63aabbf7dfa8a956$var$elliptic_1.ec;

});
parcelRegister("cXTXN", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("eaG84", function(module, exports) {

$parcel$export(module.exports, "version", () => $a512adda7ad1dfdc$export$83d89fbfd8236492);
const $a512adda7ad1dfdc$export$83d89fbfd8236492 = "signing-key/5.5.0";

});


parcelRegister("cmrHY", function(module, exports) {

$parcel$export(module.exports, "version", () => $8ffd0867b0da9487$export$83d89fbfd8236492);
const $8ffd0867b0da9487$export$83d89fbfd8236492 = "transactions/5.5.0";

});





parcelRegister("dZEGL", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $gNDGO = parcelRequire("gNDGO");

var $hA2kM = parcelRequire("hA2kM");

var $hhXfq = parcelRequire("hhXfq");
var $a30088d3ded573ce$require$Subscriptions = $hhXfq.subscriptions;

var $lIu4V = parcelRequire("lIu4V");

var $9y1Dl = parcelRequire("9y1Dl");

var $jo8Dp = parcelRequire("jo8Dp");

var $hoNux = parcelRequire("hoNux");

var $7W5Xs = parcelRequire("7W5Xs");

var $gHrur = parcelRequire("gHrur");

var $lyBXN = parcelRequire("lyBXN");

var $2UrIJ = parcelRequire("2UrIJ");

var $dIHKd = parcelRequire("dIHKd");

var $9d2Gm = parcelRequire("9d2Gm");
var $a30088d3ded573ce$var$formatter = $hA2kM.formatters;
var $a30088d3ded573ce$var$blockCall = function(args) {
    return typeof args[0] === 'string' && args[0].indexOf('0x') === 0 ? "eth_getBlockByHash" : "eth_getBlockByNumber";
};
var $a30088d3ded573ce$var$transactionFromBlockCall = function(args) {
    return typeof args[0] === 'string' && args[0].indexOf('0x') === 0 ? 'eth_getTransactionByBlockHashAndIndex' : 'eth_getTransactionByBlockNumberAndIndex';
};
var $a30088d3ded573ce$var$uncleCall = function(args) {
    return typeof args[0] === 'string' && args[0].indexOf('0x') === 0 ? 'eth_getUncleByBlockHashAndIndex' : 'eth_getUncleByBlockNumberAndIndex';
};
var $a30088d3ded573ce$var$getBlockTransactionCountCall = function(args) {
    return typeof args[0] === 'string' && args[0].indexOf('0x') === 0 ? 'eth_getBlockTransactionCountByHash' : 'eth_getBlockTransactionCountByNumber';
};
var $a30088d3ded573ce$var$uncleCountCall = function(args) {
    return typeof args[0] === 'string' && args[0].indexOf('0x') === 0 ? 'eth_getUncleCountByBlockHash' : 'eth_getUncleCountByBlockNumber';
};
var $a30088d3ded573ce$var$Eth = function Eth() {
    var _this = this;
    // sets _requestmanager
    $gNDGO.packageInit(this, arguments);
    // overwrite package setRequestManager
    var setRequestManager = this.setRequestManager;
    this.setRequestManager = function(manager) {
        setRequestManager(manager);
        _this.net.setRequestManager(manager);
        _this.personal.setRequestManager(manager);
        _this.accounts.setRequestManager(manager);
        _this.Contract._requestManager = _this._requestManager;
        _this.Contract.currentProvider = _this._provider;
        return true;
    };
    // overwrite setProvider
    var setProvider = this.setProvider;
    this.setProvider = function() {
        setProvider.apply(_this, arguments);
        _this.setRequestManager(_this._requestManager);
        // Set detectedAddress/lastSyncCheck back to null because the provider could be connected to a different chain now
        _this.ens._detectedAddress = null;
        _this.ens._lastSyncCheck = null;
    };
    var handleRevert = false;
    var defaultAccount = null;
    var defaultBlock = 'latest';
    var transactionBlockTimeout = 50;
    var transactionConfirmationBlocks = 24;
    var transactionPollingTimeout = 750;
    var transactionPollingInterval = 1000;
    var blockHeaderTimeout = 10; // 10 seconds
    var maxListenersWarningThreshold = 100;
    var defaultChain, defaultHardfork, defaultCommon;
    Object.defineProperty(this, 'handleRevert', {
        get: function() {
            return handleRevert;
        },
        set: function(val) {
            handleRevert = val;
            // also set on the Contract object
            _this.Contract.handleRevert = handleRevert;
            // update handleRevert
            methods.forEach(function(method) {
                method.handleRevert = handleRevert;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, 'defaultCommon', {
        get: function() {
            return defaultCommon;
        },
        set: function(val) {
            defaultCommon = val;
            // also set on the Contract object
            _this.Contract.defaultCommon = defaultCommon;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultCommon = defaultCommon;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, 'defaultHardfork', {
        get: function() {
            return defaultHardfork;
        },
        set: function(val) {
            defaultHardfork = val;
            // also set on the Contract object
            _this.Contract.defaultHardfork = defaultHardfork;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultHardfork = defaultHardfork;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, 'defaultChain', {
        get: function() {
            return defaultChain;
        },
        set: function(val) {
            defaultChain = val;
            // also set on the Contract object
            _this.Contract.defaultChain = defaultChain;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultChain = defaultChain;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, 'transactionPollingTimeout', {
        get: function() {
            return transactionPollingTimeout;
        },
        set: function(val) {
            transactionPollingTimeout = val;
            // also set on the Contract object
            _this.Contract.transactionPollingTimeout = transactionPollingTimeout;
            // update defaultBlock
            methods.forEach(function(method) {
                method.transactionPollingTimeout = transactionPollingTimeout;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, 'transactionPollingInterval', {
        get: function() {
            return transactionPollingInterval;
        },
        set: function(val) {
            transactionPollingInterval = val;
            // also set on the Contract object
            _this.Contract.transactionPollingInterval = transactionPollingInterval;
            // update defaultBlock
            methods.forEach(function(method) {
                method.transactionPollingInterval = transactionPollingInterval;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, 'transactionConfirmationBlocks', {
        get: function() {
            return transactionConfirmationBlocks;
        },
        set: function(val) {
            transactionConfirmationBlocks = val;
            // also set on the Contract object
            _this.Contract.transactionConfirmationBlocks = transactionConfirmationBlocks;
            // update defaultBlock
            methods.forEach(function(method) {
                method.transactionConfirmationBlocks = transactionConfirmationBlocks;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, 'transactionBlockTimeout', {
        get: function() {
            return transactionBlockTimeout;
        },
        set: function(val) {
            transactionBlockTimeout = val;
            // also set on the Contract object
            _this.Contract.transactionBlockTimeout = transactionBlockTimeout;
            // update defaultBlock
            methods.forEach(function(method) {
                method.transactionBlockTimeout = transactionBlockTimeout;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, 'blockHeaderTimeout', {
        get: function() {
            return blockHeaderTimeout;
        },
        set: function(val) {
            blockHeaderTimeout = val;
            // also set on the Contract object
            _this.Contract.blockHeaderTimeout = blockHeaderTimeout;
            // update defaultBlock
            methods.forEach(function(method) {
                method.blockHeaderTimeout = blockHeaderTimeout;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, 'defaultAccount', {
        get: function() {
            return defaultAccount;
        },
        set: function(val) {
            if (val) defaultAccount = $9y1Dl.toChecksumAddress($a30088d3ded573ce$var$formatter.inputAddressFormatter(val));
            // also set on the Contract object
            _this.Contract.defaultAccount = defaultAccount;
            _this.personal.defaultAccount = defaultAccount;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultAccount = defaultAccount;
            });
            return val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'defaultBlock', {
        get: function() {
            return defaultBlock;
        },
        set: function(val) {
            defaultBlock = val;
            // also set on the Contract object
            _this.Contract.defaultBlock = defaultBlock;
            _this.personal.defaultBlock = defaultBlock;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultBlock = defaultBlock;
            });
            return val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'maxListenersWarningThreshold', {
        get: function() {
            return maxListenersWarningThreshold;
        },
        set: function(val) {
            if (_this.currentProvider && _this.currentProvider.setMaxListeners) {
                maxListenersWarningThreshold = val;
                _this.currentProvider.setMaxListeners(val);
            }
        },
        enumerable: true
    });
    this.clearSubscriptions = _this._requestManager.clearSubscriptions.bind(_this._requestManager);
    this.removeSubscriptionById = _this._requestManager.removeSubscription.bind(_this._requestManager);
    // add net
    this.net = new $jo8Dp(this);
    // add chain detection
    this.net.getNetworkType = $9d2Gm.bind(this);
    // add accounts
    this.accounts = new $2UrIJ(this);
    // add personal
    this.personal = new $7W5Xs(this);
    this.personal.defaultAccount = this.defaultAccount;
    // set warnings threshold
    this.maxListenersWarningThreshold = maxListenersWarningThreshold;
    // create a proxy Contract type for this instance, as a Contract's provider
    // is stored as a class member rather than an instance variable. If we do
    // not create this proxy type, changing the provider in one instance of
    // web3-eth would subsequently change the provider for _all_ contract
    // instances!
    var self = this;
    var Contract = function Contract() {
        $gHrur.apply(this, arguments);
        // when Eth.setProvider is called, call packageInit
        // on all contract instances instantiated via this Eth
        // instances. This will update the currentProvider for
        // the contract instances
        var _this = this;
        var setProvider = self.setProvider;
        self.setProvider = function() {
            setProvider.apply(self, arguments);
            $gNDGO.packageInit(_this, [
                self
            ]);
        };
    };
    Contract.setProvider = function() {
        $gHrur.setProvider.apply(this, arguments);
    };
    // make our proxy Contract inherit from web3-eth-contract so that it has all
    // the right functionality and so that instanceof and friends work properly
    Contract.prototype = Object.create($gHrur.prototype);
    Contract.prototype.constructor = Contract;
    // add contract
    this.Contract = Contract;
    this.Contract.defaultAccount = this.defaultAccount;
    this.Contract.defaultBlock = this.defaultBlock;
    this.Contract.transactionBlockTimeout = this.transactionBlockTimeout;
    this.Contract.transactionConfirmationBlocks = this.transactionConfirmationBlocks;
    this.Contract.transactionPollingTimeout = this.transactionPollingTimeout;
    this.Contract.transactionPollingInterval = this.transactionPollingInterval;
    this.Contract.blockHeaderTimeout = this.blockHeaderTimeout;
    this.Contract.handleRevert = this.handleRevert;
    this.Contract._requestManager = this._requestManager;
    this.Contract._ethAccounts = this.accounts;
    this.Contract.currentProvider = this._requestManager.provider;
    // add IBAN
    this.Iban = $lyBXN;
    // add ABI
    this.abi = $dIHKd;
    // add ENS
    this.ens = new $hoNux(this);
    var methods = [
        new $lIu4V({
            name: 'getNodeInfo',
            call: 'web3_clientVersion'
        }),
        new $lIu4V({
            name: 'getProtocolVersion',
            call: 'eth_protocolVersion',
            params: 0
        }),
        new $lIu4V({
            name: 'getCoinbase',
            call: 'eth_coinbase',
            params: 0
        }),
        new $lIu4V({
            name: 'isMining',
            call: 'eth_mining',
            params: 0
        }),
        new $lIu4V({
            name: 'getHashrate',
            call: 'eth_hashrate',
            params: 0,
            outputFormatter: $9y1Dl.hexToNumber
        }),
        new $lIu4V({
            name: 'isSyncing',
            call: 'eth_syncing',
            params: 0,
            outputFormatter: $a30088d3ded573ce$var$formatter.outputSyncingFormatter
        }),
        new $lIu4V({
            name: 'getGasPrice',
            call: 'eth_gasPrice',
            params: 0,
            outputFormatter: $a30088d3ded573ce$var$formatter.outputBigNumberFormatter
        }),
        new $lIu4V({
            name: 'getFeeHistory',
            call: 'eth_feeHistory',
            params: 3,
            inputFormatter: [
                $9y1Dl.numberToHex,
                $a30088d3ded573ce$var$formatter.inputBlockNumberFormatter,
                null
            ]
        }),
        new $lIu4V({
            name: 'getAccounts',
            call: 'eth_accounts',
            params: 0,
            outputFormatter: $9y1Dl.toChecksumAddress
        }),
        new $lIu4V({
            name: 'getBlockNumber',
            call: 'eth_blockNumber',
            params: 0,
            outputFormatter: $9y1Dl.hexToNumber
        }),
        new $lIu4V({
            name: 'getBalance',
            call: 'eth_getBalance',
            params: 2,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputAddressFormatter,
                $a30088d3ded573ce$var$formatter.inputDefaultBlockNumberFormatter
            ],
            outputFormatter: $a30088d3ded573ce$var$formatter.outputBigNumberFormatter
        }),
        new $lIu4V({
            name: 'getStorageAt',
            call: 'eth_getStorageAt',
            params: 3,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputAddressFormatter,
                $9y1Dl.numberToHex,
                $a30088d3ded573ce$var$formatter.inputDefaultBlockNumberFormatter
            ]
        }),
        new $lIu4V({
            name: 'getCode',
            call: 'eth_getCode',
            params: 2,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputAddressFormatter,
                $a30088d3ded573ce$var$formatter.inputDefaultBlockNumberFormatter
            ]
        }),
        new $lIu4V({
            name: 'getBlock',
            call: $a30088d3ded573ce$var$blockCall,
            params: 2,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputBlockNumberFormatter,
                function(val) {
                    return !!val;
                }
            ],
            outputFormatter: $a30088d3ded573ce$var$formatter.outputBlockFormatter
        }),
        new $lIu4V({
            name: 'getUncle',
            call: $a30088d3ded573ce$var$uncleCall,
            params: 2,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputBlockNumberFormatter,
                $9y1Dl.numberToHex
            ],
            outputFormatter: $a30088d3ded573ce$var$formatter.outputBlockFormatter
        }),
        new $lIu4V({
            name: 'getBlockTransactionCount',
            call: $a30088d3ded573ce$var$getBlockTransactionCountCall,
            params: 1,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputBlockNumberFormatter
            ],
            outputFormatter: $9y1Dl.hexToNumber
        }),
        new $lIu4V({
            name: 'getBlockUncleCount',
            call: $a30088d3ded573ce$var$uncleCountCall,
            params: 1,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputBlockNumberFormatter
            ],
            outputFormatter: $9y1Dl.hexToNumber
        }),
        new $lIu4V({
            name: 'getTransaction',
            call: 'eth_getTransactionByHash',
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: $a30088d3ded573ce$var$formatter.outputTransactionFormatter
        }),
        new $lIu4V({
            name: 'getTransactionFromBlock',
            call: $a30088d3ded573ce$var$transactionFromBlockCall,
            params: 2,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputBlockNumberFormatter,
                $9y1Dl.numberToHex
            ],
            outputFormatter: $a30088d3ded573ce$var$formatter.outputTransactionFormatter
        }),
        new $lIu4V({
            name: 'getTransactionReceipt',
            call: 'eth_getTransactionReceipt',
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: $a30088d3ded573ce$var$formatter.outputTransactionReceiptFormatter
        }),
        new $lIu4V({
            name: 'getTransactionCount',
            call: 'eth_getTransactionCount',
            params: 2,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputAddressFormatter,
                $a30088d3ded573ce$var$formatter.inputDefaultBlockNumberFormatter
            ],
            outputFormatter: $9y1Dl.hexToNumber
        }),
        new $lIu4V({
            name: 'sendSignedTransaction',
            call: 'eth_sendRawTransaction',
            params: 1,
            inputFormatter: [
                null
            ],
            abiCoder: $dIHKd
        }),
        new $lIu4V({
            name: 'signTransaction',
            call: 'eth_signTransaction',
            params: 1,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputTransactionFormatter
            ]
        }),
        new $lIu4V({
            name: 'sendTransaction',
            call: 'eth_sendTransaction',
            params: 1,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputTransactionFormatter
            ],
            abiCoder: $dIHKd
        }),
        new $lIu4V({
            name: 'sign',
            call: 'eth_sign',
            params: 2,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputSignFormatter,
                $a30088d3ded573ce$var$formatter.inputAddressFormatter
            ],
            transformPayload: function(payload) {
                payload.params.reverse();
                return payload;
            }
        }),
        new $lIu4V({
            name: 'call',
            call: 'eth_call',
            params: 2,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputCallFormatter,
                $a30088d3ded573ce$var$formatter.inputDefaultBlockNumberFormatter
            ],
            abiCoder: $dIHKd
        }),
        new $lIu4V({
            name: 'estimateGas',
            call: 'eth_estimateGas',
            params: 1,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputCallFormatter
            ],
            outputFormatter: $9y1Dl.hexToNumber
        }),
        new $lIu4V({
            name: 'submitWork',
            call: 'eth_submitWork',
            params: 3
        }),
        new $lIu4V({
            name: 'getWork',
            call: 'eth_getWork',
            params: 0
        }),
        new $lIu4V({
            name: 'getPastLogs',
            call: 'eth_getLogs',
            params: 1,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputLogFormatter
            ],
            outputFormatter: $a30088d3ded573ce$var$formatter.outputLogFormatter
        }),
        new $lIu4V({
            name: 'getChainId',
            call: 'eth_chainId',
            params: 0,
            outputFormatter: $9y1Dl.hexToNumber
        }),
        new $lIu4V({
            name: 'requestAccounts',
            call: 'eth_requestAccounts',
            params: 0,
            outputFormatter: $9y1Dl.toChecksumAddress
        }),
        new $lIu4V({
            name: 'getProof',
            call: 'eth_getProof',
            params: 3,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputAddressFormatter,
                $a30088d3ded573ce$var$formatter.inputStorageKeysFormatter,
                $a30088d3ded573ce$var$formatter.inputDefaultBlockNumberFormatter
            ],
            outputFormatter: $a30088d3ded573ce$var$formatter.outputProofFormatter
        }),
        new $lIu4V({
            name: 'getPendingTransactions',
            call: 'eth_pendingTransactions',
            params: 0,
            outputFormatter: $a30088d3ded573ce$var$formatter.outputTransactionFormatter
        }),
        new $lIu4V({
            name: 'createAccessList',
            call: 'eth_createAccessList',
            params: 2,
            inputFormatter: [
                $a30088d3ded573ce$var$formatter.inputTransactionFormatter,
                $a30088d3ded573ce$var$formatter.inputDefaultBlockNumberFormatter
            ]
        }),
        // subscriptions
        new $a30088d3ded573ce$require$Subscriptions({
            name: 'subscribe',
            type: 'eth',
            subscriptions: {
                'newBlockHeaders': {
                    // TODO rename on RPC side?
                    subscriptionName: 'newHeads',
                    params: 0,
                    outputFormatter: $a30088d3ded573ce$var$formatter.outputBlockFormatter
                },
                'pendingTransactions': {
                    subscriptionName: 'newPendingTransactions',
                    params: 0
                },
                'logs': {
                    params: 1,
                    inputFormatter: [
                        $a30088d3ded573ce$var$formatter.inputLogFormatter
                    ],
                    outputFormatter: $a30088d3ded573ce$var$formatter.outputLogFormatter,
                    // DUBLICATE, also in web3-eth-contract
                    subscriptionHandler: function(output) {
                        if (output.removed) this.emit('changed', output);
                        else this.emit('data', output);
                        if (typeof this.callback === 'function') this.callback(null, output, this);
                    }
                },
                'syncing': {
                    params: 0,
                    outputFormatter: $a30088d3ded573ce$var$formatter.outputSyncingFormatter,
                    subscriptionHandler: function(output) {
                        var _this = this;
                        // fire TRUE at start
                        if (this._isSyncing !== true) {
                            this._isSyncing = true;
                            this.emit('changed', _this._isSyncing);
                            if (typeof this.callback === 'function') this.callback(null, _this._isSyncing, this);
                            setTimeout(function() {
                                _this.emit('data', output);
                                if (typeof _this.callback === 'function') _this.callback(null, output, _this);
                            }, 0);
                        // fire sync status
                        } else {
                            this.emit('data', output);
                            if (typeof _this.callback === 'function') this.callback(null, output, this);
                            // wait for some time before fireing the FALSE
                            clearTimeout(this._isSyncingTimeout);
                            this._isSyncingTimeout = setTimeout(function() {
                                if (output.currentBlock > output.highestBlock - 200) {
                                    _this._isSyncing = false;
                                    _this.emit('changed', _this._isSyncing);
                                    if (typeof _this.callback === 'function') _this.callback(null, _this._isSyncing, _this);
                                }
                            }, 500);
                        }
                    }
                }
            }
        })
    ];
    methods.forEach(function(method) {
        method.attachToObject(_this);
        method.setRequestManager(_this._requestManager, _this.accounts); // second param is the eth.accounts module (necessary for signing transactions locally)
        method.defaultBlock = _this.defaultBlock;
        method.defaultAccount = _this.defaultAccount;
        method.transactionBlockTimeout = _this.transactionBlockTimeout;
        method.transactionConfirmationBlocks = _this.transactionConfirmationBlocks;
        method.transactionPollingTimeout = _this.transactionPollingTimeout;
        method.transactionPollingInterval = _this.transactionPollingInterval;
        method.handleRevert = _this.handleRevert;
    });
};
// Adds the static givenProvider and providers property to the Eth module
$gNDGO.addProviders($a30088d3ded573ce$var$Eth);
module.exports = $a30088d3ded573ce$var$Eth;

});
parcelRegister("jo8Dp", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $gNDGO = parcelRequire("gNDGO");

var $lIu4V = parcelRequire("lIu4V");

var $9y1Dl = parcelRequire("9y1Dl");
var $e1d6f4e0aa5f19a9$var$Net = function() {
    var _this = this;
    // sets _requestmanager
    $gNDGO.packageInit(this, arguments);
    [
        new $lIu4V({
            name: 'getId',
            call: 'net_version',
            params: 0,
            outputFormatter: parseInt
        }),
        new $lIu4V({
            name: 'isListening',
            call: 'net_listening',
            params: 0
        }),
        new $lIu4V({
            name: 'getPeerCount',
            call: 'net_peerCount',
            params: 0,
            outputFormatter: $9y1Dl.hexToNumber
        })
    ].forEach(function(method) {
        method.attachToObject(_this);
        method.setRequestManager(_this._requestManager);
    });
};
$gNDGO.addProviders($e1d6f4e0aa5f19a9$var$Net);
module.exports = $e1d6f4e0aa5f19a9$var$Net;

});

parcelRegister("hoNux", function(module, exports) {
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 *
 * @author Samuel Furter <samuel@ethereum.org>
 * @date 2018
 */ "use strict";

var $jnrt2 = parcelRequire("jnrt2");
module.exports = $jnrt2;

});
parcelRegister("jnrt2", function(module, exports) {
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file ENS.js
 *
 * @author Samuel Furter <samuel@ethereum.org>
 * @date 2018
 */ "use strict";

var $2pEPc = parcelRequire("2pEPc");

var $hA2kM = parcelRequire("hA2kM");
var $e1b578c191654cf8$require$formatters = $hA2kM.formatters;

var $9y1Dl = parcelRequire("9y1Dl");

var $a7x7L = parcelRequire("a7x7L");

var $iTVdc = parcelRequire("iTVdc");

var $i3yXV = parcelRequire("i3yXV");
/**
 * Constructs a new instance of ENS
 *
 * @param {Eth} eth
 *
 * @constructor
 */ function $e1b578c191654cf8$var$ENS(eth) {
    this.eth = eth;
    var registryAddress = null;
    this._detectedAddress = null;
    this._lastSyncCheck = null;
    Object.defineProperty(this, 'registry', {
        get: function() {
            return new $a7x7L(this);
        },
        enumerable: true
    });
    Object.defineProperty(this, 'resolverMethodHandler', {
        get: function() {
            return new $iTVdc(this.registry);
        },
        enumerable: true
    });
    Object.defineProperty(this, 'registryAddress', {
        get: function() {
            return registryAddress;
        },
        set: function(value) {
            if (value === null) {
                registryAddress = value;
                return;
            }
            registryAddress = $e1b578c191654cf8$require$formatters.inputAddressFormatter(value);
        },
        enumerable: true
    });
}
/**
 * Returns true if the given interfaceId is supported and otherwise false.
 *
 * @method supportsInterface
 *
 * @param {string} name
 * @param {string} interfaceId
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<boolean>}
 */ $e1b578c191654cf8$var$ENS.prototype.supportsInterface = function(name, interfaceId, callback) {
    return this.getResolver(name).then(function(resolver) {
        if (!$9y1Dl.isHexStrict(interfaceId)) interfaceId = $9y1Dl.sha3(interfaceId).slice(0, 10);
        return resolver.methods.supportsInterface(interfaceId).call(callback);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        throw error;
    });
};
/**
 * Returns the Resolver by the given address
 *
 * @deprecated Please use the "getResolver" method instead of "resolver"
 *
 * @method resolver
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<Contract>}
 */ $e1b578c191654cf8$var$ENS.prototype.resolver = function(name, callback) {
    return this.registry.resolver(name, callback);
};
/**
 * Returns the Resolver by the given address
 *
 * @method getResolver
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<Contract>}
 */ $e1b578c191654cf8$var$ENS.prototype.getResolver = function(name, callback) {
    return this.registry.getResolver(name, callback);
};
/**
 * Does set the resolver of the given name
 *
 * @method setResolver
 *
 * @param {string} name
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setResolver = function(name, address, txConfig, callback) {
    return this.registry.setResolver(name, address, txConfig, callback);
};
/**
 * Sets the owner, resolver, and TTL for an ENS record in a single operation.
 *
 * @method setRecord
 *
 * @param {string} name
 * @param {string} owner
 * @param {string} resolver
 * @param {string | number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setRecord = function(name, owner, resolver, ttl, txConfig, callback) {
    return this.registry.setRecord(name, owner, resolver, ttl, txConfig, callback);
};
/**
 * Sets the owner, resolver and TTL for a subdomain, creating it if necessary.
 *
 * @method setSubnodeRecord
 *
 * @param {string} name
 * @param {string} label
 * @param {string} owner
 * @param {string} resolver
 * @param {string | number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setSubnodeRecord = function(name, label, owner, resolver, ttl, txConfig, callback) {
    return this.registry.setSubnodeRecord(name, label, owner, resolver, ttl, txConfig, callback);
};
/**
 * Sets or clears an approval by the given operator.
 *
 * @method setApprovalForAll
 *
 * @param {string} operator
 * @param {boolean} approved
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setApprovalForAll = function(operator, approved, txConfig, callback) {
    return this.registry.setApprovalForAll(operator, approved, txConfig, callback);
};
/**
 * Returns true if the operator is approved
 *
 * @method isApprovedForAll
 *
 * @param {string} owner
 * @param {string} operator
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<boolean>}
 */ $e1b578c191654cf8$var$ENS.prototype.isApprovedForAll = function(owner, operator, callback) {
    return this.registry.isApprovedForAll(owner, operator, callback);
};
/**
 * Returns true if the record exists
 *
 * @method recordExists
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<boolean>}
 */ $e1b578c191654cf8$var$ENS.prototype.recordExists = function(name, callback) {
    return this.registry.recordExists(name, callback);
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setSubnodeOwner
 *
 * @param {string} name
 * @param {string} label
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setSubnodeOwner = function(name, label, address, txConfig, callback) {
    return this.registry.setSubnodeOwner(name, label, address, txConfig, callback);
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method getTTL
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.getTTL = function(name, callback) {
    return this.registry.getTTL(name, callback);
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setTTL
 *
 * @param {string} name
 * @param {number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setTTL = function(name, ttl, txConfig, callback) {
    return this.registry.setTTL(name, ttl, txConfig, callback);
};
/**
 * Returns the owner by the given name and current configured or detected Registry
 *
 * @method getOwner
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.getOwner = function(name, callback) {
    return this.registry.getOwner(name, callback);
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setOwner
 *
 * @param {string} name
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setOwner = function(name, address, txConfig, callback) {
    return this.registry.setOwner(name, address, txConfig, callback);
};
/**
 * Returns the address record associated with a name.
 *
 * @method getAddress
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.getAddress = function(name, callback) {
    return this.resolverMethodHandler.method(name, 'addr', []).call(callback);
};
/**
 * Sets a new address
 *
 * @method setAddress
 *
 * @param {string} name
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setAddress = function(name, address, txConfig, callback) {
    return this.resolverMethodHandler.method(name, 'setAddr', [
        address
    ]).send(txConfig, callback);
};
/**
 * Returns the public key
 *
 * @method getPubkey
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.getPubkey = function(name, callback) {
    return this.resolverMethodHandler.method(name, 'pubkey', [], null, callback).call(callback);
};
/**
 * Set the new public key
 *
 * @method setPubkey
 *
 * @param {string} name
 * @param {string} x
 * @param {string} y
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setPubkey = function(name, x, y, txConfig, callback) {
    return this.resolverMethodHandler.method(name, 'setPubkey', [
        x,
        y
    ]).send(txConfig, callback);
};
/**
 * Returns the content
 *
 * @method getContent
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.getContent = function(name, callback) {
    return this.resolverMethodHandler.method(name, 'content', []).call(callback);
};
/**
 * Set the content
 *
 * @method setContent
 *
 * @param {string} name
 * @param {string} hash
 * @param {function} callback
 * @param {TransactionConfig} txConfig
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setContent = function(name, hash, txConfig, callback) {
    return this.resolverMethodHandler.method(name, 'setContent', [
        hash
    ]).send(txConfig, callback);
};
/**
 * Returns the contenthash
 *
 * @method getContenthash
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<ContentHash>}
 */ $e1b578c191654cf8$var$ENS.prototype.getContenthash = function(name, callback) {
    return this.resolverMethodHandler.method(name, 'contenthash', [], $i3yXV.decode).call(callback);
};
/**
 * Set the contenthash
 *
 * @method setContent
 *
 * @param {string} name
 * @param {string} hash
 * @param {function} callback
 * @param {TransactionConfig} txConfig
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setContenthash = function(name, hash, txConfig, callback) {
    var encoded;
    try {
        encoded = $i3yXV.encode(hash);
    } catch (err) {
        var error = new Error('Could not encode ' + hash + '. See docs for supported hash protocols.');
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        throw error;
    }
    return this.resolverMethodHandler.method(name, 'setContenthash', [
        encoded
    ]).send(txConfig, callback);
};
/**
 * Get the multihash
 *
 * @method getMultihash
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.getMultihash = function(name, callback) {
    return this.resolverMethodHandler.method(name, 'multihash', []).call(callback);
};
/**
 * Set the multihash
 *
 * @method setMultihash
 *
 * @param {string} name
 * @param {string} hash
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $e1b578c191654cf8$var$ENS.prototype.setMultihash = function(name, hash, txConfig, callback) {
    return this.resolverMethodHandler.method(name, 'multihash', [
        hash
    ]).send(txConfig, callback);
};
/**
 * Checks if the current used network is synced and looks for ENS support there.
 * Throws an error if not.
 *
 * @returns {Promise<string>}
 */ $e1b578c191654cf8$var$ENS.prototype.checkNetwork = async function() {
    var now = new Date() / 1000;
    if (!this._lastSyncCheck || now - this._lastSyncCheck > 3600) {
        var block = await this.eth.getBlock('latest');
        var headAge = now - block.timestamp;
        if (headAge > 3600) throw new Error("Network not synced; last block was " + headAge + " seconds ago");
        this._lastSyncCheck = now;
    }
    if (this.registryAddress) return this.registryAddress;
    if (!this._detectedAddress) {
        var networkType = await this.eth.net.getNetworkType();
        var addr = $2pEPc.addresses[networkType];
        if (typeof addr === 'undefined') throw new Error("ENS is not supported on network " + networkType);
        this._detectedAddress = addr;
        return this._detectedAddress;
    }
    return this._detectedAddress;
};
module.exports = $e1b578c191654cf8$var$ENS;

});
parcelRegister("2pEPc", function(module, exports) {
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file config.js
 *
 * @author Samuel Furter <samuel@ethereum.org>
 * @date 2017
 */ "use strict";
/**
 * Source: https://docs.ens.domains/ens-deployments
 *
 * @type {{addresses: {main: string, rinkeby: string, goerli: string, ropsten: string}}}
 */ var $1c1d9582c0031ee7$var$config = {
    addresses: {
        main: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        ropsten: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        rinkeby: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        goerli: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    // These ids obtained at ensdomains docs:
    // https://docs.ens.domains/contract-developer-guide/writing-a-resolver
    interfaceIds: {
        addr: "0x3b3b57de",
        setAddr: "0x3b3b57de",
        pubkey: "0xc8690233",
        setPubkey: "0xc8690233",
        contenthash: "0xbc1c58d1",
        setContenthash: "0xbc1c58d1",
        content: "0xd8389dc5",
        setContent: "0xd8389dc5"
    }
};
module.exports = $1c1d9582c0031ee7$var$config;

});

parcelRegister("a7x7L", function(module, exports) {
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file Registry.js
 *
 * @author Samuel Furter <samuel@ethereum.org>
 * @date 2018
 */ "use strict";

var $gHrur = parcelRequire("gHrur");

var $6Wdcs = parcelRequire("6Wdcs");

var $4wdBS = parcelRequire("4wdBS");

var $hA2kM = parcelRequire("hA2kM");
var $75e44097c3e71b7a$require$formatters = $hA2kM.formatters;

var $9y1Dl = parcelRequire("9y1Dl");

var $5gTLh = parcelRequire("5gTLh");

var $bYaXC = parcelRequire("bYaXC");
/**
 * A wrapper around the ENS registry contract.
 *
 * @method Registry
 * @param {Ens} ens
 * @constructor
 */ function $75e44097c3e71b7a$var$Registry(ens) {
    var self = this;
    this.ens = ens;
    this.contract = ens.checkNetwork().then(function(address) {
        var contract = new $gHrur($5gTLh, address);
        contract.setProvider(self.ens.eth.currentProvider);
        return contract;
    });
}
/**
 * Returns the address of the owner of an ENS name.
 *
 * @deprecated Please use the "getOwner" method instead of "owner"
 *
 * @method owner
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<string>}
 */ $75e44097c3e71b7a$var$Registry.prototype.owner = function(name, callback) {
    console.warn('Deprecated: Please use the "getOwner" method instead of "owner".');
    return this.getOwner(name, callback);
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method getOwner
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<string>}
 */ $75e44097c3e71b7a$var$Registry.prototype.getOwner = function(name, callback) {
    var promiEvent = new $4wdBS(true);
    this.contract.then(function(contract) {
        return contract.methods.owner($6Wdcs.hash(name)).call();
    }).then(function(receipt) {
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setOwner
 *
 * @param {string} name
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $75e44097c3e71b7a$var$Registry.prototype.setOwner = function(name, address, txConfig, callback) {
    var promiEvent = new $4wdBS(true);
    this.contract.then(function(contract) {
        return contract.methods.setOwner($6Wdcs.hash(name), $75e44097c3e71b7a$require$formatters.inputAddressFormatter(address)).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns the TTL of the given node by his name
 *
 * @method getTTL
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returnss {Promise<string>}
 */ $75e44097c3e71b7a$var$Registry.prototype.getTTL = function(name, callback) {
    var promiEvent = new $4wdBS(true);
    this.contract.then(function(contract) {
        return contract.methods.ttl($6Wdcs.hash(name)).call();
    }).then(function(receipt) {
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setTTL
 *
 * @param {string} name
 * @param {number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $75e44097c3e71b7a$var$Registry.prototype.setTTL = function(name, ttl, txConfig, callback) {
    var promiEvent = new $4wdBS(true);
    this.contract.then(function(contract) {
        return contract.methods.setTTL($6Wdcs.hash(name), ttl).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setSubnodeOwner
 *
 * @param {string} name
 * @param {string} label
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $75e44097c3e71b7a$var$Registry.prototype.setSubnodeOwner = function(name, label, address, txConfig, callback) {
    var promiEvent = new $4wdBS(true);
    if (!$9y1Dl.isHexStrict(label)) label = $9y1Dl.sha3(label);
    this.contract.then(function(contract) {
        return contract.methods.setSubnodeOwner($6Wdcs.hash(name), label, $75e44097c3e71b7a$require$formatters.inputAddressFormatter(address)).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Sets the owner, resolver, and TTL for an ENS record in a single operation.
 *
 * @method setRecord
 *
 * @param {string} name
 * @param {string} owner
 * @param {string} resolver
 * @param {string | number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $75e44097c3e71b7a$var$Registry.prototype.setRecord = function(name, owner, resolver, ttl, txConfig, callback) {
    var promiEvent = new $4wdBS(true);
    this.contract.then(function(contract) {
        return contract.methods.setRecord($6Wdcs.hash(name), $75e44097c3e71b7a$require$formatters.inputAddressFormatter(owner), $75e44097c3e71b7a$require$formatters.inputAddressFormatter(resolver), ttl).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Sets the owner, resolver and TTL for a subdomain, creating it if necessary.
 *
 * @method setSubnodeRecord
 *
 * @param {string} name
 * @param {string} label
 * @param {string} owner
 * @param {string} resolver
 * @param {string | number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $75e44097c3e71b7a$var$Registry.prototype.setSubnodeRecord = function(name, label, owner, resolver, ttl, txConfig, callback) {
    var promiEvent = new $4wdBS(true);
    if (!$9y1Dl.isHexStrict(label)) label = $9y1Dl.sha3(label);
    this.contract.then(function(contract) {
        return contract.methods.setSubnodeRecord($6Wdcs.hash(name), label, $75e44097c3e71b7a$require$formatters.inputAddressFormatter(owner), $75e44097c3e71b7a$require$formatters.inputAddressFormatter(resolver), ttl).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Sets or clears an approval by the given operator.
 *
 * @method setApprovalForAll
 *
 * @param {string} operator
 * @param {boolean} approved
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $75e44097c3e71b7a$var$Registry.prototype.setApprovalForAll = function(operator, approved, txConfig, callback) {
    var promiEvent = new $4wdBS(true);
    this.contract.then(function(contract) {
        return contract.methods.setApprovalForAll($75e44097c3e71b7a$require$formatters.inputAddressFormatter(operator), approved).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns true if the operator is approved
 *
 * @method isApprovedForAll
 *
 * @param {string} owner
 * @param {string} operator
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<boolean>}
 */ $75e44097c3e71b7a$var$Registry.prototype.isApprovedForAll = function(owner, operator, callback) {
    var promiEvent = new $4wdBS(true);
    this.contract.then(function(contract) {
        return contract.methods.isApprovedForAll($75e44097c3e71b7a$require$formatters.inputAddressFormatter(owner), $75e44097c3e71b7a$require$formatters.inputAddressFormatter(operator)).call();
    }).then(function(receipt) {
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns true if the record exists
 *
 * @method recordExists
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<boolean>}
 */ $75e44097c3e71b7a$var$Registry.prototype.recordExists = function(name, callback) {
    var promiEvent = new $4wdBS(true);
    this.contract.then(function(contract) {
        return contract.methods.recordExists($6Wdcs.hash(name)).call();
    }).then(function(receipt) {
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns the resolver contract associated with a name.
 *
 * @deprecated Please use the "getResolver" method instead of "resolver"
 *
 * @method resolver
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<Contract>}
 */ $75e44097c3e71b7a$var$Registry.prototype.resolver = function(name, callback) {
    console.warn('Deprecated: Please use the "getResolver" method instead of "resolver".');
    return this.getResolver(name, callback);
};
/**
 * Returns the resolver contract associated with a name.
 *
 * @method getResolver
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<Contract>}
 */ $75e44097c3e71b7a$var$Registry.prototype.getResolver = function(name, callback) {
    var self = this;
    return this.contract.then(function(contract) {
        return contract.methods.resolver($6Wdcs.hash(name)).call();
    }).then(function(address) {
        var contract = new $gHrur($bYaXC, address);
        contract.setProvider(self.ens.eth.currentProvider);
        if (typeof callback === 'function') {
            // It's required to pass the contract to the first argument to be backward compatible and to have the required consistency
            callback(contract, contract);
            return;
        }
        return contract;
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        throw error;
    });
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setResolver
 *
 * @param {string} name
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $75e44097c3e71b7a$var$Registry.prototype.setResolver = function(name, address, txConfig, callback) {
    var promiEvent = new $4wdBS(true);
    this.contract.then(function(contract) {
        return contract.methods.setResolver($6Wdcs.hash(name), $75e44097c3e71b7a$require$formatters.inputAddressFormatter(address)).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
module.exports = $75e44097c3e71b7a$var$Registry;

});
parcelRegister("gHrur", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file contract.js
 *
 * To initialize a contract use:
 *
 *  var Contract = require('web3-eth-contract');
 *  Contract.setProvider('ws://localhost:8546');
 *  var contract = new Contract(abi, address, ...);
 *
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $gNDGO = parcelRequire("gNDGO");

var $lIu4V = parcelRequire("lIu4V");

var $9y1Dl = parcelRequire("9y1Dl");

var $hhXfq = parcelRequire("hhXfq");
var $c285fc7293a63583$require$Subscription = $hhXfq.subscription;

var $hA2kM = parcelRequire("hA2kM");
var $c285fc7293a63583$require$formatters = $hA2kM.formatters;

var $hA2kM = parcelRequire("hA2kM");
var $c285fc7293a63583$require$errors = $hA2kM.errors;

var $4wdBS = parcelRequire("4wdBS");

var $dIHKd = parcelRequire("dIHKd");
/**
 * Should be called to create new contract instance
 *
 * @method Contract
 * @constructor
 * @param {Array} jsonInterface
 * @param {String} address
 * @param {Object} options
 */ var $c285fc7293a63583$var$Contract = function Contract(jsonInterface, address, options) {
    var _this = this, args = Array.prototype.slice.call(arguments);
    if (!(this instanceof Contract)) throw new Error('Please use the "new" keyword to instantiate a web3.eth.Contract() object!');
    this.setProvider = function() {
        $gNDGO.packageInit(_this, arguments);
        _this.clearSubscriptions = _this._requestManager.clearSubscriptions;
    };
    // sets _requestmanager
    $gNDGO.packageInit(this, [
        this.constructor
    ]);
    this.clearSubscriptions = this._requestManager.clearSubscriptions;
    if (!jsonInterface || !Array.isArray(jsonInterface)) throw $c285fc7293a63583$require$errors.ContractMissingABIError();
    // create the options object
    this.options = {};
    var lastArg = args[args.length - 1];
    if (!!lastArg && typeof lastArg === 'object' && !Array.isArray(lastArg)) {
        options = lastArg;
        this.options = {
            ...this.options,
            ...this._getOrSetDefaultOptions(options)
        };
        if (!!address && typeof address === 'object') address = null;
    }
    // set address
    Object.defineProperty(this.options, 'address', {
        set: function(value) {
            if (value) _this._address = $9y1Dl.toChecksumAddress($c285fc7293a63583$require$formatters.inputAddressFormatter(value));
        },
        get: function() {
            return _this._address;
        },
        enumerable: true
    });
    // add method and event signatures, when the jsonInterface gets set
    Object.defineProperty(this.options, 'jsonInterface', {
        set: function(value) {
            _this.methods = {};
            _this.events = {};
            _this._jsonInterface = value.map(function(method) {
                var func, funcName;
                // make constant and payable backwards compatible
                method.constant = method.stateMutability === "view" || method.stateMutability === "pure" || method.constant;
                method.payable = method.stateMutability === "payable" || method.payable;
                if (method.name) funcName = $9y1Dl._jsonInterfaceMethodToString(method);
                // function
                if (method.type === 'function') {
                    method.signature = $dIHKd.encodeFunctionSignature(funcName);
                    func = _this._createTxObject.bind({
                        method: method,
                        parent: _this
                    });
                    // add method only if not one already exists
                    if (!_this.methods[method.name]) _this.methods[method.name] = func;
                    else {
                        var cascadeFunc = _this._createTxObject.bind({
                            method: method,
                            parent: _this,
                            nextMethod: _this.methods[method.name]
                        });
                        _this.methods[method.name] = cascadeFunc;
                    }
                    // definitely add the method based on its signature
                    _this.methods[method.signature] = func;
                    // add method by name
                    _this.methods[funcName] = func;
                // event
                } else if (method.type === 'event') {
                    method.signature = $dIHKd.encodeEventSignature(funcName);
                    var event = _this._on.bind(_this, method.signature);
                    // add method only if not already exists
                    if (!_this.events[method.name] || _this.events[method.name].name === 'bound ') _this.events[method.name] = event;
                    // definitely add the method based on its signature
                    _this.events[method.signature] = event;
                    // add event by name
                    _this.events[funcName] = event;
                }
                return method;
            });
            // add allEvents
            _this.events.allEvents = _this._on.bind(_this, 'allevents');
            return _this._jsonInterface;
        },
        get: function() {
            return _this._jsonInterface;
        },
        enumerable: true
    });
    // get default account from the Class
    var defaultAccount = this.constructor.defaultAccount;
    var defaultBlock = this.constructor.defaultBlock || 'latest';
    Object.defineProperty(this, 'handleRevert', {
        get: function() {
            if (_this.options.handleRevert === false || _this.options.handleRevert === true) return _this.options.handleRevert;
            return this.constructor.handleRevert;
        },
        set: function(val) {
            _this.options.handleRevert = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'defaultCommon', {
        get: function() {
            return _this.options.common || this.constructor.defaultCommon;
        },
        set: function(val) {
            _this.options.common = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'defaultHardfork', {
        get: function() {
            return _this.options.hardfork || this.constructor.defaultHardfork;
        },
        set: function(val) {
            _this.options.hardfork = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'defaultChain', {
        get: function() {
            return _this.options.chain || this.constructor.defaultChain;
        },
        set: function(val) {
            _this.options.chain = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'transactionPollingTimeout', {
        get: function() {
            if (_this.options.transactionPollingTimeout === 0) return _this.options.transactionPollingTimeout;
            return _this.options.transactionPollingTimeout || this.constructor.transactionPollingTimeout;
        },
        set: function(val) {
            _this.options.transactionPollingTimeout = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'transactionPollingInterval', {
        get: function() {
            if (_this.options.transactionPollingInterval === 0) return _this.options.transactionPollingInterval;
            return _this.options.transactionPollingInterval || this.constructor.transactionPollingInterval;
        },
        set: function(val) {
            _this.options.transactionPollingInterval = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'transactionConfirmationBlocks', {
        get: function() {
            if (_this.options.transactionConfirmationBlocks === 0) return _this.options.transactionConfirmationBlocks;
            return _this.options.transactionConfirmationBlocks || this.constructor.transactionConfirmationBlocks;
        },
        set: function(val) {
            _this.options.transactionConfirmationBlocks = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'transactionBlockTimeout', {
        get: function() {
            if (_this.options.transactionBlockTimeout === 0) return _this.options.transactionBlockTimeout;
            return _this.options.transactionBlockTimeout || this.constructor.transactionBlockTimeout;
        },
        set: function(val) {
            _this.options.transactionBlockTimeout = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'blockHeaderTimeout', {
        get: function() {
            if (_this.options.blockHeaderTimeout === 0) return _this.options.blockHeaderTimeout;
            return _this.options.blockHeaderTimeout || this.constructor.blockHeaderTimeout;
        },
        set: function(val) {
            _this.options.blockHeaderTimeout = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'defaultAccount', {
        get: function() {
            return defaultAccount;
        },
        set: function(val) {
            if (val) defaultAccount = $9y1Dl.toChecksumAddress($c285fc7293a63583$require$formatters.inputAddressFormatter(val));
            return val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'defaultBlock', {
        get: function() {
            return defaultBlock;
        },
        set: function(val) {
            defaultBlock = val;
            return val;
        },
        enumerable: true
    });
    // properties
    this.methods = {};
    this.events = {};
    this._address = null;
    this._jsonInterface = [];
    // set getter/setter properties
    this.options.address = address;
    this.options.jsonInterface = jsonInterface;
};
/**
 * Sets the new provider, creates a new requestManager, registers the "data" listener on the provider and sets the
 * accounts module for the Contract class.
 *
 * @method setProvider
 *
 * @param {string|provider} provider
 * @param {Accounts} accounts
 *
 * @returns void
 */ $c285fc7293a63583$var$Contract.setProvider = function(provider, accounts) {
    // Contract.currentProvider = provider;
    $gNDGO.packageInit(this, [
        provider
    ]);
    this._ethAccounts = accounts;
};
/**
 * Get the callback and modify the array if necessary
 *
 * @method _getCallback
 * @param {Array} args
 * @return {Function} the callback
 */ $c285fc7293a63583$var$Contract.prototype._getCallback = function getCallback(args) {
    if (args && !!args[args.length - 1] && typeof args[args.length - 1] === 'function') return args.pop(); // modify the args array!
};
/**
 * Checks that no listener with name "newListener" or "removeListener" is added.
 *
 * @method _checkListener
 * @param {String} type
 * @param {String} event
 * @return {Object} the contract instance
 */ $c285fc7293a63583$var$Contract.prototype._checkListener = function(type, event) {
    if (event === type) throw $c285fc7293a63583$require$errors.ContractReservedEventError(type);
};
/**
 * Use default values, if options are not available
 *
 * @method _getOrSetDefaultOptions
 * @param {Object} options the options gived by the user
 * @return {Object} the options with gaps filled by defaults
 */ $c285fc7293a63583$var$Contract.prototype._getOrSetDefaultOptions = function getOrSetDefaultOptions(options) {
    var gasPrice = options.gasPrice ? String(options.gasPrice) : null;
    var from = options.from ? $9y1Dl.toChecksumAddress($c285fc7293a63583$require$formatters.inputAddressFormatter(options.from)) : null;
    options.data = options.data || this.options.data;
    options.from = from || this.options.from;
    options.gasPrice = gasPrice || this.options.gasPrice;
    options.gas = options.gas || options.gasLimit || this.options.gas;
    // TODO replace with only gasLimit?
    delete options.gasLimit;
    return options;
};
/**
 * Should be used to encode indexed params and options to one final object
 *
 * @method _encodeEventABI
 * @param {Object} event
 * @param {Object} options
 * @return {Object} everything combined together and encoded
 */ $c285fc7293a63583$var$Contract.prototype._encodeEventABI = function(event, options) {
    options = options || {};
    var filter = options.filter || {}, result = {};
    [
        'fromBlock',
        'toBlock'
    ].filter(function(f) {
        return options[f] !== undefined;
    }).forEach(function(f) {
        result[f] = $c285fc7293a63583$require$formatters.inputBlockNumberFormatter(options[f]);
    });
    // use given topics
    if (Array.isArray(options.topics)) result.topics = options.topics;
    else {
        result.topics = [];
        // add event signature
        if (event && !event.anonymous && event.name !== 'ALLEVENTS') result.topics.push(event.signature);
        // add event topics (indexed arguments)
        if (event.name !== 'ALLEVENTS') {
            var indexedTopics = event.inputs.filter(function(i) {
                return i.indexed === true;
            }).map(function(i) {
                var value = filter[i.name];
                if (!value) return null;
                // TODO: https://github.com/ethereum/web3.js/issues/344
                // TODO: deal properly with components
                if (Array.isArray(value)) return value.map(function(v) {
                    return $dIHKd.encodeParameter(i.type, v);
                });
                return $dIHKd.encodeParameter(i.type, value);
            });
            result.topics = result.topics.concat(indexedTopics);
        }
        if (!result.topics.length) delete result.topics;
    }
    if (this.options.address) result.address = this.options.address.toLowerCase();
    return result;
};
/**
 * Should be used to decode indexed params and options
 *
 * @method _decodeEventABI
 * @param {Object} data
 * @return {Object} result object with decoded indexed && not indexed params
 */ $c285fc7293a63583$var$Contract.prototype._decodeEventABI = function(data) {
    var event = this;
    data.data = data.data || '';
    data.topics = data.topics || [];
    var result = $c285fc7293a63583$require$formatters.outputLogFormatter(data);
    // if allEvents get the right event
    if (event.name === 'ALLEVENTS') event = event.jsonInterface.find(function(intf) {
        return intf.signature === data.topics[0];
    }) || {
        anonymous: true
    };
    // create empty inputs if none are present (e.g. anonymous events on allEvents)
    event.inputs = event.inputs || [];
    // Handle case where an event signature shadows the current ABI with non-identical
    // arg indexing. If # of topics doesn't match, event is anon.
    if (!event.anonymous) {
        let indexedInputs = 0;
        event.inputs.forEach((input)=>input.indexed ? indexedInputs++ : null);
        if (indexedInputs > 0 && data.topics.length !== indexedInputs + 1) event = {
            anonymous: true,
            inputs: []
        };
    }
    var argTopics = event.anonymous ? data.topics : data.topics.slice(1);
    result.returnValues = $dIHKd.decodeLog(event.inputs, data.data, argTopics);
    delete result.returnValues.__length__;
    // add name
    result.event = event.name;
    // add signature
    result.signature = event.anonymous || !data.topics[0] ? null : data.topics[0];
    // move the data and topics to "raw"
    result.raw = {
        data: result.data,
        topics: result.topics
    };
    delete result.data;
    delete result.topics;
    return result;
};
/**
 * Encodes an ABI for a method, including signature or the method.
 * Or when constructor encodes only the constructor parameters.
 *
 * @method _encodeMethodABI
 * @param {Mixed} args the arguments to encode
 * @param {String} the encoded ABI
 */ $c285fc7293a63583$var$Contract.prototype._encodeMethodABI = function _encodeMethodABI() {
    var methodSignature = this._method.signature, args = this.arguments || [];
    var signature = false, paramsABI = this._parent.options.jsonInterface.filter(function(json) {
        return methodSignature === 'constructor' && json.type === methodSignature || (json.signature === methodSignature || json.signature === methodSignature.replace('0x', '') || json.name === methodSignature) && json.type === 'function';
    }).map(function(json) {
        var inputLength = Array.isArray(json.inputs) ? json.inputs.length : 0;
        if (inputLength !== args.length) throw new Error('The number of arguments is not matching the methods required number. You need to pass ' + inputLength + ' arguments.');
        if (json.type === 'function') signature = json.signature;
        return Array.isArray(json.inputs) ? json.inputs : [];
    }).map(function(inputs) {
        return $dIHKd.encodeParameters(inputs, args).replace('0x', '');
    })[0] || '';
    // return constructor
    if (methodSignature === 'constructor') {
        if (!this._deployData) throw new Error('The contract has no contract data option set. This is necessary to append the constructor parameters.');
        if (!this._deployData.startsWith('0x')) this._deployData = '0x' + this._deployData;
        return this._deployData + paramsABI;
    }
    // return method
    var returnValue = signature ? signature + paramsABI : paramsABI;
    if (!returnValue) throw new Error('Couldn\'t find a matching contract method named "' + this._method.name + '".');
    return returnValue;
};
/**
 * Decode method return values
 *
 * @method _decodeMethodReturn
 * @param {Array} outputs
 * @param {String} returnValues
 * @return {Object} decoded output return values
 */ $c285fc7293a63583$var$Contract.prototype._decodeMethodReturn = function(outputs, returnValues) {
    if (!returnValues) return null;
    returnValues = returnValues.length >= 2 ? returnValues.slice(2) : returnValues;
    var result = $dIHKd.decodeParameters(outputs, returnValues);
    if (result.__length__ === 1) return result[0];
    delete result.__length__;
    return result;
};
/**
 * Deploys a contract and fire events based on its state: transactionHash, receipt
 *
 * All event listeners will be removed, once the last possible event is fired ("error", or "receipt")
 *
 * @method deploy
 * @param {Object} options
 * @param {Function} callback
 * @return {Object} EventEmitter possible events are "error", "transactionHash" and "receipt"
 */ $c285fc7293a63583$var$Contract.prototype.deploy = function(options, callback) {
    options = options || {};
    options.arguments = options.arguments || [];
    options = this._getOrSetDefaultOptions(options);
    // throw error, if no "data" is specified
    if (!options.data) {
        if (typeof callback === 'function') return callback($c285fc7293a63583$require$errors.ContractMissingDeployDataError());
        throw $c285fc7293a63583$require$errors.ContractMissingDeployDataError();
    }
    var constructor = this.options.jsonInterface.find((method)=>{
        return method.type === 'constructor';
    }) || {};
    constructor.signature = 'constructor';
    return this._createTxObject.apply({
        method: constructor,
        parent: this,
        deployData: options.data,
        _ethAccounts: this.constructor._ethAccounts
    }, options.arguments);
};
/**
 * Gets the event signature and outputFormatters
 *
 * @method _generateEventOptions
 * @param {Object} event
 * @param {Object} options
 * @param {Function} callback
 * @return {Object} the event options object
 */ $c285fc7293a63583$var$Contract.prototype._generateEventOptions = function() {
    var args = Array.prototype.slice.call(arguments);
    // get the callback
    var callback = this._getCallback(args);
    // get the options
    var options = (!!args[args.length - 1] && typeof args[args.length - 1]) === 'object' ? args.pop() : {};
    var eventName = typeof args[0] === 'string' ? args[0] : 'allevents';
    var event = eventName.toLowerCase() === 'allevents' ? {
        name: 'ALLEVENTS',
        jsonInterface: this.options.jsonInterface
    } : this.options.jsonInterface.find(function(json) {
        return json.type === 'event' && (json.name === eventName || json.signature === '0x' + eventName.replace('0x', ''));
    });
    if (!event) throw $c285fc7293a63583$require$errors.ContractEventDoesNotExistError(eventName);
    if (!$9y1Dl.isAddress(this.options.address)) throw $c285fc7293a63583$require$errors.ContractNoAddressDefinedError();
    return {
        params: this._encodeEventABI(event, options),
        event: event,
        callback: callback
    };
};
/**
 * Adds event listeners and creates a subscription, and remove it once its fired.
 *
 * @method clone
 * @return {Object} the event subscription
 */ $c285fc7293a63583$var$Contract.prototype.clone = function() {
    return new this.constructor(this.options.jsonInterface, this.options.address, this.options);
};
/**
 * Adds event listeners and creates a subscription, and remove it once its fired.
 *
 * @method once
 * @param {String} event
 * @param {Object} options
 * @param {Function} callback
 * @return {Object} the event subscription
 */ $c285fc7293a63583$var$Contract.prototype.once = function(event, options, callback) {
    var args = Array.prototype.slice.call(arguments);
    // get the callback
    callback = this._getCallback(args);
    if (!callback) throw $c285fc7293a63583$require$errors.ContractOnceRequiresCallbackError();
    // don't allow fromBlock
    if (options) delete options.fromBlock;
    // don't return as once shouldn't provide "on"
    this._on(event, options, function(err, res, sub) {
        sub.unsubscribe();
        if (typeof callback === 'function') callback(err, res, sub);
    });
    return undefined;
};
/**
 * Adds event listeners and creates a subscription.
 *
 * @method _on
 *
 * @param {String} event
 * @param {Object} options
 * @param {Function} callback
 *
 * @return {Object} the event subscription
 */ $c285fc7293a63583$var$Contract.prototype._on = function() {
    var subOptions = this._generateEventOptions.apply(this, arguments);
    if (subOptions.params && subOptions.params.toBlock) {
        delete subOptions.params.toBlock;
        console.warn('Invalid option: toBlock. Use getPastEvents for specific range.');
    }
    // prevent the event "newListener" and "removeListener" from being overwritten
    this._checkListener('newListener', subOptions.event.name);
    this._checkListener('removeListener', subOptions.event.name);
    // TODO check if listener already exists? and reuse subscription if options are the same.
    // create new subscription
    var subscription = new $c285fc7293a63583$require$Subscription({
        subscription: {
            params: 1,
            inputFormatter: [
                $c285fc7293a63583$require$formatters.inputLogFormatter
            ],
            outputFormatter: this._decodeEventABI.bind(subOptions.event),
            // DUBLICATE, also in web3-eth
            subscriptionHandler: function(output) {
                if (output.removed) this.emit('changed', output);
                else this.emit('data', output);
                if (typeof this.callback === 'function') this.callback(null, output, this);
            }
        },
        type: 'eth',
        requestManager: this._requestManager
    });
    subscription.subscribe('logs', subOptions.params, subOptions.callback || function() {});
    return subscription;
};
/**
 * Get past events from contracts
 *
 * @method getPastEvents
 * @param {String} event
 * @param {Object} options
 * @param {Function} callback
 * @return {Object} the promievent
 */ $c285fc7293a63583$var$Contract.prototype.getPastEvents = function() {
    var subOptions = this._generateEventOptions.apply(this, arguments);
    var getPastLogs = new $lIu4V({
        name: 'getPastLogs',
        call: 'eth_getLogs',
        params: 1,
        inputFormatter: [
            $c285fc7293a63583$require$formatters.inputLogFormatter
        ],
        outputFormatter: this._decodeEventABI.bind(subOptions.event)
    });
    getPastLogs.setRequestManager(this._requestManager);
    var call = getPastLogs.buildCall();
    getPastLogs = null;
    return call(subOptions.params, subOptions.callback);
};
/**
 * returns the an object with call, send, estimate functions
 *
 * @method _createTxObject
 * @returns {Object} an object with functions to call the methods
 */ $c285fc7293a63583$var$Contract.prototype._createTxObject = function _createTxObject() {
    var args = Array.prototype.slice.call(arguments);
    var txObject = {};
    if (this.method.type === 'function') {
        txObject.call = this.parent._executeMethod.bind(txObject, 'call');
        txObject.call.request = this.parent._executeMethod.bind(txObject, 'call', true); // to make batch requests
    }
    txObject.send = this.parent._executeMethod.bind(txObject, 'send');
    txObject.send.request = this.parent._executeMethod.bind(txObject, 'send', true); // to make batch requests
    txObject.encodeABI = this.parent._encodeMethodABI.bind(txObject);
    txObject.estimateGas = this.parent._executeMethod.bind(txObject, 'estimate');
    txObject.createAccessList = this.parent._executeMethod.bind(txObject, 'createAccessList');
    if (args && this.method.inputs && args.length !== this.method.inputs.length) {
        if (this.nextMethod) return this.nextMethod.apply(null, args);
        throw $c285fc7293a63583$require$errors.InvalidNumberOfParams(args.length, this.method.inputs.length, this.method.name);
    }
    txObject.arguments = args || [];
    txObject._method = this.method;
    txObject._parent = this.parent;
    txObject._ethAccounts = this.parent.constructor._ethAccounts || this._ethAccounts;
    if (this.deployData) txObject._deployData = this.deployData;
    return txObject;
};
/**
 * Generates the options for the execute call
 *
 * @method _processExecuteArguments
 * @param {Array} args
 * @param {Promise} defer
 */ $c285fc7293a63583$var$Contract.prototype._processExecuteArguments = function _processExecuteArguments(args, defer) {
    var processedArgs = {};
    processedArgs.type = args.shift();
    // get the callback
    processedArgs.callback = this._parent._getCallback(args);
    // get block number to use for call
    if (processedArgs.type === 'call' && args[args.length - 1] !== true && (typeof args[args.length - 1] === 'string' || isFinite(args[args.length - 1]))) processedArgs.defaultBlock = args.pop();
    // get the options
    processedArgs.options = (!!args[args.length - 1] && typeof args[args.length - 1]) === 'object' ? args.pop() : {};
    // get the generateRequest argument for batch requests
    processedArgs.generateRequest = args[args.length - 1] === true ? args.pop() : false;
    processedArgs.options = this._parent._getOrSetDefaultOptions(processedArgs.options);
    processedArgs.options.data = this.encodeABI();
    // add contract address
    if (!this._deployData && !$9y1Dl.isAddress(this._parent.options.address)) throw $c285fc7293a63583$require$errors.ContractNoAddressDefinedError();
    if (!this._deployData) processedArgs.options.to = this._parent.options.address;
    // return error, if no "data" is specified
    if (!processedArgs.options.data) return $9y1Dl._fireError(new Error('Couldn\'t find a matching contract method, or the number of parameters is wrong.'), defer.eventEmitter, defer.reject, processedArgs.callback);
    return processedArgs;
};
/**
 * Executes a call, transact or estimateGas on a contract function
 *
 * @method _executeMethod
 * @param {String} type the type this execute function should execute
 * @param {Boolean} makeRequest if true, it simply returns the request parameters, rather than executing it
 */ $c285fc7293a63583$var$Contract.prototype._executeMethod = function _executeMethod() {
    var _this = this, args = this._parent._processExecuteArguments.call(this, Array.prototype.slice.call(arguments), defer), defer = $4wdBS(args.type !== 'send'), ethAccounts = _this.constructor._ethAccounts || _this._ethAccounts;
    // simple return request for batch requests
    if (args.generateRequest) {
        var payload = {
            params: [
                $c285fc7293a63583$require$formatters.inputCallFormatter.call(this._parent, args.options)
            ],
            callback: args.callback
        };
        if (args.type === 'call') {
            payload.params.push($c285fc7293a63583$require$formatters.inputDefaultBlockNumberFormatter.call(this._parent, args.defaultBlock));
            payload.method = 'eth_call';
            payload.format = this._parent._decodeMethodReturn.bind(null, this._method.outputs);
        } else payload.method = 'eth_sendTransaction';
        return payload;
    }
    switch(args.type){
        case 'createAccessList':
            // return error, if no "from" is specified
            if (!$9y1Dl.isAddress(args.options.from)) return $9y1Dl._fireError($c285fc7293a63583$require$errors.ContractNoFromAddressDefinedError(), defer.eventEmitter, defer.reject, args.callback);
            var createAccessList = new $lIu4V({
                name: 'createAccessList',
                call: 'eth_createAccessList',
                params: 2,
                inputFormatter: [
                    $c285fc7293a63583$require$formatters.inputTransactionFormatter,
                    $c285fc7293a63583$require$formatters.inputDefaultBlockNumberFormatter
                ],
                requestManager: _this._parent._requestManager,
                accounts: ethAccounts,
                defaultAccount: _this._parent.defaultAccount,
                defaultBlock: _this._parent.defaultBlock
            }).createFunction();
            return createAccessList(args.options, args.callback);
        case 'estimate':
            var estimateGas = new $lIu4V({
                name: 'estimateGas',
                call: 'eth_estimateGas',
                params: 1,
                inputFormatter: [
                    $c285fc7293a63583$require$formatters.inputCallFormatter
                ],
                outputFormatter: $9y1Dl.hexToNumber,
                requestManager: _this._parent._requestManager,
                accounts: ethAccounts,
                defaultAccount: _this._parent.defaultAccount,
                defaultBlock: _this._parent.defaultBlock
            }).createFunction();
            return estimateGas(args.options, args.callback);
        case 'call':
            // TODO check errors: missing "from" should give error on deploy and send, call ?
            var call = new $lIu4V({
                name: 'call',
                call: 'eth_call',
                params: 2,
                inputFormatter: [
                    $c285fc7293a63583$require$formatters.inputCallFormatter,
                    $c285fc7293a63583$require$formatters.inputDefaultBlockNumberFormatter
                ],
                // add output formatter for decoding
                outputFormatter: function(result) {
                    return _this._parent._decodeMethodReturn(_this._method.outputs, result);
                },
                requestManager: _this._parent._requestManager,
                accounts: ethAccounts,
                defaultAccount: _this._parent.defaultAccount,
                defaultBlock: _this._parent.defaultBlock,
                handleRevert: _this._parent.handleRevert,
                abiCoder: $dIHKd
            }).createFunction();
            return call(args.options, args.defaultBlock, args.callback);
        case 'send':
            // return error, if no "from" is specified
            if (!$9y1Dl.isAddress(args.options.from)) return $9y1Dl._fireError($c285fc7293a63583$require$errors.ContractNoFromAddressDefinedError(), defer.eventEmitter, defer.reject, args.callback);
            if (typeof this._method.payable === 'boolean' && !this._method.payable && args.options.value && args.options.value > 0) return $9y1Dl._fireError(new Error('Can not send value to non-payable contract method or constructor'), defer.eventEmitter, defer.reject, args.callback);
            // make sure receipt logs are decoded
            var extraFormatters = {
                receiptFormatter: function(receipt) {
                    if (Array.isArray(receipt.logs)) {
                        // decode logs
                        var events = receipt.logs.map((log)=>{
                            return _this._parent._decodeEventABI.call({
                                name: 'ALLEVENTS',
                                jsonInterface: _this._parent.options.jsonInterface
                            }, log);
                        });
                        // make log names keys
                        receipt.events = {};
                        var count = 0;
                        events.forEach(function(ev) {
                            if (ev.event) {
                                // if > 1 of the same event, don't overwrite any existing events
                                if (receipt.events[ev.event]) {
                                    if (Array.isArray(receipt.events[ev.event])) receipt.events[ev.event].push(ev);
                                    else receipt.events[ev.event] = [
                                        receipt.events[ev.event],
                                        ev
                                    ];
                                } else receipt.events[ev.event] = ev;
                            } else {
                                receipt.events[count] = ev;
                                count++;
                            }
                        });
                        delete receipt.logs;
                    }
                    return receipt;
                },
                contractDeployFormatter: function(receipt) {
                    var newContract = _this._parent.clone();
                    newContract.options.address = receipt.contractAddress;
                    return newContract;
                }
            };
            var sendTransaction = new $lIu4V({
                name: 'sendTransaction',
                call: 'eth_sendTransaction',
                params: 1,
                inputFormatter: [
                    $c285fc7293a63583$require$formatters.inputTransactionFormatter
                ],
                requestManager: _this._parent._requestManager,
                accounts: _this.constructor._ethAccounts || _this._ethAccounts,
                defaultAccount: _this._parent.defaultAccount,
                defaultBlock: _this._parent.defaultBlock,
                transactionBlockTimeout: _this._parent.transactionBlockTimeout,
                transactionConfirmationBlocks: _this._parent.transactionConfirmationBlocks,
                transactionPollingTimeout: _this._parent.transactionPollingTimeout,
                transactionPollingInterval: _this._parent.transactionPollingInterval,
                defaultCommon: _this._parent.defaultCommon,
                defaultChain: _this._parent.defaultChain,
                defaultHardfork: _this._parent.defaultHardfork,
                handleRevert: _this._parent.handleRevert,
                extraFormatters: extraFormatters,
                abiCoder: $dIHKd
            }).createFunction();
            return sendTransaction(args.options, args.callback);
        default:
            throw new Error('Method "' + args.type + '" not implemented.');
    }
};
module.exports = $c285fc7293a63583$var$Contract;

});
parcelRegister("dIHKd", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file index.js
 * @author Marek Kotewicz <marek@parity.io>
 * @author Fabian Vogelsteller <fabian@frozeman.de>
 * @date 2018
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $9fd1512b747f3c2d$require$Buffer = $6ZWSX.Buffer;

var $9y1Dl = parcelRequire("9y1Dl");
parcelRequire("7YNWw");
var $gYiun = parcelRequire("gYiun");
var $8aez5 = parcelRequire("8aez5");
var $9fd1512b747f3c2d$require$EthersAbiCoder = $gYiun.AbiCoder;
parcelRequire("7YNWw");
var $gYiun = parcelRequire("gYiun");
var $8aez5 = parcelRequire("8aez5");
var $9fd1512b747f3c2d$require$ParamType = $8aez5.ParamType;
var $9fd1512b747f3c2d$var$ethersAbiCoder = new $9fd1512b747f3c2d$require$EthersAbiCoder(function(type, value) {
    if (type.match(/^u?int/) && !Array.isArray(value) && (!(!!value && typeof value === 'object') || value.constructor.name !== 'BN')) return value.toString();
    return value;
});
// result method
function $9fd1512b747f3c2d$var$Result() {}
/**
 * ABICoder prototype should be used to encode/decode solidity params of any type
 */ var $9fd1512b747f3c2d$var$ABICoder = function() {};
/**
 * Encodes the function name to its ABI representation, which are the first 4 bytes of the sha3 of the function name including  types.
 *
 * @method encodeFunctionSignature
 * @param {String|Object} functionName
 * @return {String} encoded function name
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.encodeFunctionSignature = function(functionName) {
    if (typeof functionName === 'function' || typeof functionName === 'object' && functionName) functionName = $9y1Dl._jsonInterfaceMethodToString(functionName);
    return $9y1Dl.sha3(functionName).slice(0, 10);
};
/**
 * Encodes the function name to its ABI representation, which are the first 4 bytes of the sha3 of the function name including  types.
 *
 * @method encodeEventSignature
 * @param {String|Object} functionName
 * @return {String} encoded function name
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.encodeEventSignature = function(functionName) {
    if (typeof functionName === 'function' || typeof functionName === 'object' && functionName) functionName = $9y1Dl._jsonInterfaceMethodToString(functionName);
    return $9y1Dl.sha3(functionName);
};
/**
 * Should be used to encode plain param
 *
 * @method encodeParameter
 *
 * @param {String|Object} type
 * @param {any} param
 *
 * @return {String} encoded plain param
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.encodeParameter = function(type, param) {
    return this.encodeParameters([
        type
    ], [
        param
    ]);
};
/**
 * Should be used to encode list of params
 *
 * @method encodeParameters
 *
 * @param {Array<String|Object>} types
 * @param {Array<any>} params
 *
 * @return {String} encoded list of params
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.encodeParameters = function(types, params) {
    var self = this;
    types = self.mapTypes(types);
    params = params.map(function(param, index) {
        let type = types[index];
        if (typeof type === 'object' && type.type) // We may get a named type of shape {name, type}
        type = type.type;
        param = self.formatParam(type, param);
        // Format params for tuples
        if (typeof type === 'string' && type.includes('tuple')) {
            const coder = $9fd1512b747f3c2d$var$ethersAbiCoder._getCoder($9fd1512b747f3c2d$require$ParamType.from(type));
            const modifyParams = (coder, param)=>{
                if (coder.name === 'array') return param.map((p)=>modifyParams($9fd1512b747f3c2d$var$ethersAbiCoder._getCoder($9fd1512b747f3c2d$require$ParamType.from(coder.type.replace('[]', ''))), p));
                coder.coders.forEach((c, i)=>{
                    if (c.name === 'tuple') modifyParams(c, param[i]);
                    else param[i] = self.formatParam(c.name, param[i]);
                });
            };
            modifyParams(coder, param);
        }
        return param;
    });
    return $9fd1512b747f3c2d$var$ethersAbiCoder.encode(types, params);
};
/**
 * Map types if simplified format is used
 *
 * @method mapTypes
 * @param {Array} types
 * @return {Array}
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.mapTypes = function(types) {
    var self = this;
    var mappedTypes = [];
    types.forEach(function(type) {
        // Remap `function` type params to bytes24 since Ethers does not
        // recognize former type. Solidity docs say `Function` is a bytes24
        // encoding the contract address followed by the function selector hash.
        if (typeof type === 'object' && type.type === 'function') type = Object.assign({}, type, {
            type: "bytes24"
        });
        if (self.isSimplifiedStructFormat(type)) {
            var structName = Object.keys(type)[0];
            mappedTypes.push(Object.assign(self.mapStructNameAndType(structName), {
                components: self.mapStructToCoderFormat(type[structName])
            }));
            return;
        }
        mappedTypes.push(type);
    });
    return mappedTypes;
};
/**
 * Check if type is simplified struct format
 *
 * @method isSimplifiedStructFormat
 * @param {string | Object} type
 * @returns {boolean}
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.isSimplifiedStructFormat = function(type) {
    return typeof type === 'object' && typeof type.components === 'undefined' && typeof type.name === 'undefined';
};
/**
 * Maps the correct tuple type and name when the simplified format in encode/decodeParameter is used
 *
 * @method mapStructNameAndType
 * @param {string} structName
 * @return {{type: string, name: *}}
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.mapStructNameAndType = function(structName) {
    var type = 'tuple';
    if (structName.indexOf('[]') > -1) {
        type = 'tuple[]';
        structName = structName.slice(0, -2);
    }
    return {
        type: type,
        name: structName
    };
};
/**
 * Maps the simplified format in to the expected format of the ABICoder
 *
 * @method mapStructToCoderFormat
 * @param {Object} struct
 * @return {Array}
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.mapStructToCoderFormat = function(struct) {
    var self = this;
    var components = [];
    Object.keys(struct).forEach(function(key) {
        if (typeof struct[key] === 'object') {
            components.push(Object.assign(self.mapStructNameAndType(key), {
                components: self.mapStructToCoderFormat(struct[key])
            }));
            return;
        }
        components.push({
            name: key,
            type: struct[key]
        });
    });
    return components;
};
/**
 * Handle some formatting of params for backwards compatability with Ethers V4
 *
 * @method formatParam
 * @param {String} - type
 * @param {any} - param
 * @return {any} - The formatted param
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.formatParam = function(type, param) {
    const paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
    const paramTypeBytesArray = new RegExp(/^bytes([0-9]*)\[\]$/);
    const paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
    const paramTypeNumberArray = new RegExp(/^(u?int)([0-9]*)\[\]$/);
    // Format BN to string
    if ($9y1Dl.isBN(param) || $9y1Dl.isBigNumber(param)) return param.toString(10);
    if (type.match(paramTypeBytesArray) || type.match(paramTypeNumberArray)) return param.map((p)=>this.formatParam(type.replace('[]', ''), p));
    // Format correct width for u?int[0-9]*
    let match = type.match(paramTypeNumber);
    if (match) {
        let size = parseInt(match[2] || "256");
        if (size / 8 < param.length) // pad to correct bit width
        param = $9y1Dl.leftPad(param, size);
    }
    // Format correct length for bytes[0-9]+
    match = type.match(paramTypeBytes);
    if (match) {
        if ($9fd1512b747f3c2d$require$Buffer.isBuffer(param)) param = $9y1Dl.toHex(param);
        // format to correct length
        let size = parseInt(match[1]);
        if (size) {
            let maxSize = size * 2;
            if (param.substring(0, 2) === '0x') maxSize += 2;
            if (param.length < maxSize) // pad to correct length
            param = $9y1Dl.rightPad(param, size * 2);
        }
        // format odd-length bytes to even-length
        if (param.length % 2 === 1) param = '0x0' + param.substring(2);
    }
    return param;
};
/**
 * Encodes a function call from its json interface and parameters.
 *
 * @method encodeFunctionCall
 * @param {Array} jsonInterface
 * @param {Array} params
 * @return {String} The encoded ABI for this function call
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.encodeFunctionCall = function(jsonInterface, params) {
    return this.encodeFunctionSignature(jsonInterface) + this.encodeParameters(jsonInterface.inputs, params).replace('0x', '');
};
/**
 * Should be used to decode bytes to plain param
 *
 * @method decodeParameter
 * @param {String} type
 * @param {String} bytes
 * @return {Object} plain param
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.decodeParameter = function(type, bytes) {
    return this.decodeParameters([
        type
    ], bytes)[0];
};
/**
 * Should be used to decode list of params
 *
 * @method decodeParameter
 * @param {Array} outputs
 * @param {String} bytes
 * @return {Array} array of plain params
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.decodeParameters = function(outputs, bytes) {
    return this.decodeParametersWith(outputs, bytes, false);
};
/**
 * Should be used to decode list of params
 *
 * @method decodeParameter
 * @param {Array} outputs
 * @param {String} bytes
 * @param {Boolean} loose
 * @return {Array} array of plain params
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.decodeParametersWith = function(outputs, bytes, loose) {
    if (outputs.length > 0 && (!bytes || bytes === '0x' || bytes === '0X')) throw new Error("Returned values aren't valid, did it run Out of Gas? You might also see this error if you are not using the correct ABI for the contract you are retrieving data from, requesting data from a block number that does not exist, or querying a node which is not fully synced.");
    var res = $9fd1512b747f3c2d$var$ethersAbiCoder.decode(this.mapTypes(outputs), '0x' + bytes.replace(/0x/i, ''), loose);
    var returnValue = new $9fd1512b747f3c2d$var$Result();
    returnValue.__length__ = 0;
    outputs.forEach(function(output, i) {
        var decodedValue = res[returnValue.__length__];
        decodedValue = decodedValue === '0x' ? null : decodedValue;
        returnValue[i] = decodedValue;
        if ((typeof output === 'function' || !!output && typeof output === 'object') && output.name) returnValue[output.name] = decodedValue;
        returnValue.__length__++;
    });
    return returnValue;
};
/**
 * Decodes events non- and indexed parameters.
 *
 * @method decodeLog
 * @param {Object} inputs
 * @param {String} data
 * @param {Array} topics
 * @return {Array} array of plain params
 */ $9fd1512b747f3c2d$var$ABICoder.prototype.decodeLog = function(inputs, data, topics) {
    var _this = this;
    topics = Array.isArray(topics) ? topics : [
        topics
    ];
    data = data || '';
    var notIndexedInputs = [];
    var indexedParams = [];
    var topicCount = 0;
    // TODO check for anonymous logs?
    inputs.forEach(function(input, i) {
        if (input.indexed) {
            indexedParams[i] = [
                'bool',
                'int',
                'uint',
                'address',
                'fixed',
                'ufixed'
            ].find(function(staticType) {
                return input.type.indexOf(staticType) !== -1;
            }) ? _this.decodeParameter(input.type, topics[topicCount]) : topics[topicCount];
            topicCount++;
        } else notIndexedInputs[i] = input;
    });
    var nonIndexedData = data;
    var notIndexedParams = nonIndexedData ? this.decodeParametersWith(notIndexedInputs, nonIndexedData, true) : [];
    var returnValue = new $9fd1512b747f3c2d$var$Result();
    returnValue.__length__ = 0;
    inputs.forEach(function(res, i) {
        returnValue[i] = res.type === 'string' ? '' : null;
        if (typeof notIndexedParams[i] !== 'undefined') returnValue[i] = notIndexedParams[i];
        if (typeof indexedParams[i] !== 'undefined') returnValue[i] = indexedParams[i];
        if (res.name) returnValue[res.name] = returnValue[i];
        returnValue.__length__++;
    });
    return returnValue;
};
var $9fd1512b747f3c2d$var$coder = new $9fd1512b747f3c2d$var$ABICoder();
module.exports = $9fd1512b747f3c2d$var$coder;

});
parcelRegister("7YNWw", function(module, exports) {

$parcel$export(module.exports, "ParamType", () => (parcelRequire("8aez5")).ParamType);
$parcel$export(module.exports, "AbiCoder", () => (parcelRequire("gYiun")).AbiCoder);

var $8aez5 = parcelRequire("8aez5");

var $gYiun = parcelRequire("gYiun");

var $bKqKs = parcelRequire("bKqKs");
var $d4e6U = parcelRequire("d4e6U");
"use strict";

});
parcelRegister("8aez5", function(module, exports) {

$parcel$export(module.exports, "FormatTypes", () => $5f1a8e36b1548921$export$f010f239efc4d445);
$parcel$export(module.exports, "ParamType", () => $5f1a8e36b1548921$export$426dc07f493a4c47);
$parcel$export(module.exports, "Fragment", () => $5f1a8e36b1548921$export$ffb0004e005737fa);
$parcel$export(module.exports, "FunctionFragment", () => $5f1a8e36b1548921$export$8d576c928b93668f);
$parcel$export(module.exports, "EventFragment", () => $5f1a8e36b1548921$export$958548f08bac2833);
$parcel$export(module.exports, "ConstructorFragment", () => $5f1a8e36b1548921$export$3ac5c9504f801ea4);

var $1chjt = parcelRequire("1chjt");

var $e72ut = parcelRequire("e72ut");

var $d1hml = parcelRequire("d1hml");

var $3bam6 = parcelRequire("3bam6");
"use strict";
const $5f1a8e36b1548921$var$logger = new (0, $d1hml.Logger)((0, $3bam6.version));
const $5f1a8e36b1548921$var$_constructorGuard = {};
let $5f1a8e36b1548921$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $5f1a8e36b1548921$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $5f1a8e36b1548921$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($5f1a8e36b1548921$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($5f1a8e36b1548921$var$ModifiersNest[name]) return true;
    }
    if ($5f1a8e36b1548921$var$ModifiersBytes[name] || name === "payable") $5f1a8e36b1548921$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $5f1a8e36b1548921$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $5f1a8e36b1548921$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $5f1a8e36b1548921$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($5f1a8e36b1548921$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $5f1a8e36b1548921$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($5f1a8e36b1548921$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $5f1a8e36b1548921$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $5f1a8e36b1548921$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($5f1a8e36b1548921$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $5f1a8e36b1548921$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($5f1a8e36b1548921$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $5f1a8e36b1548921$var$verifyType(parent.type);
    return parent;
}
function $5f1a8e36b1548921$var$populate(object, params) {
    for(let key in params)(0, $e72ut.defineReadOnly)(object, key, params[key]);
}
const $5f1a8e36b1548921$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readble with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $5f1a8e36b1548921$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $5f1a8e36b1548921$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $5f1a8e36b1548921$var$_constructorGuard) $5f1a8e36b1548921$var$logger.throwError("use fromString", (0, $d1hml.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $5f1a8e36b1548921$var$populate(this, params);
        let match = this.type.match($5f1a8e36b1548921$var$paramTypeArray);
        if (match) $5f1a8e36b1548921$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $5f1a8e36b1548921$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $5f1a8e36b1548921$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, addres bar) indexed baz"
    format(format) {
        if (!format) format = $5f1a8e36b1548921$export$f010f239efc4d445.sighash;
        if (!$5f1a8e36b1548921$export$f010f239efc4d445[format]) $5f1a8e36b1548921$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $5f1a8e36b1548921$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $5f1a8e36b1548921$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $5f1a8e36b1548921$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $5f1a8e36b1548921$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $5f1a8e36b1548921$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $5f1a8e36b1548921$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $5f1a8e36b1548921$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($5f1a8e36b1548921$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $5f1a8e36b1548921$export$426dc07f493a4c47($5f1a8e36b1548921$var$_constructorGuard, {
            name: value.name || null,
            type: $5f1a8e36b1548921$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($5f1a8e36b1548921$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $5f1a8e36b1548921$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($5f1a8e36b1548921$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $5f1a8e36b1548921$var$parseParams(value, allowIndex) {
    return $5f1a8e36b1548921$var$splitNesting(value).map((param)=>$5f1a8e36b1548921$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $5f1a8e36b1548921$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $5f1a8e36b1548921$var$_constructorGuard) $5f1a8e36b1548921$var$logger.throwError("use a static from method", (0, $d1hml.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $5f1a8e36b1548921$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($5f1a8e36b1548921$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $5f1a8e36b1548921$export$ffb0004e005737fa.fromString(value);
        return $5f1a8e36b1548921$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($5f1a8e36b1548921$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $5f1a8e36b1548921$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $5f1a8e36b1548921$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $5f1a8e36b1548921$export$3ac5c9504f801ea4.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $5f1a8e36b1548921$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $5f1a8e36b1548921$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $5f1a8e36b1548921$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $5f1a8e36b1548921$export$3ac5c9504f801ea4.fromString(value.trim());
        return $5f1a8e36b1548921$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $5f1a8e36b1548921$export$958548f08bac2833 extends $5f1a8e36b1548921$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $5f1a8e36b1548921$export$f010f239efc4d445.sighash;
        if (!$5f1a8e36b1548921$export$f010f239efc4d445[format]) $5f1a8e36b1548921$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $5f1a8e36b1548921$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $5f1a8e36b1548921$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $5f1a8e36b1548921$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $5f1a8e36b1548921$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $5f1a8e36b1548921$export$958548f08bac2833.fromString(value);
        return $5f1a8e36b1548921$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($5f1a8e36b1548921$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $5f1a8e36b1548921$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $5f1a8e36b1548921$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($5f1a8e36b1548921$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $5f1a8e36b1548921$export$958548f08bac2833($5f1a8e36b1548921$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($5f1a8e36b1548921$var$regexParen);
        if (!match) $5f1a8e36b1548921$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $5f1a8e36b1548921$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $5f1a8e36b1548921$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $5f1a8e36b1548921$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $5f1a8e36b1548921$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $5f1a8e36b1548921$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $5f1a8e36b1548921$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $1chjt.BigNumber).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $5f1a8e36b1548921$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $5f1a8e36b1548921$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $5f1a8e36b1548921$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $5f1a8e36b1548921$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $5f1a8e36b1548921$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $5f1a8e36b1548921$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $5f1a8e36b1548921$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $5f1a8e36b1548921$export$3ac5c9504f801ea4 extends $5f1a8e36b1548921$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $5f1a8e36b1548921$export$f010f239efc4d445.sighash;
        if (!$5f1a8e36b1548921$export$f010f239efc4d445[format]) $5f1a8e36b1548921$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $5f1a8e36b1548921$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payble: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $5f1a8e36b1548921$export$f010f239efc4d445.sighash) $5f1a8e36b1548921$var$logger.throwError("cannot format a constructor for sighash", (0, $d1hml.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $5f1a8e36b1548921$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $5f1a8e36b1548921$export$3ac5c9504f801ea4.fromString(value);
        return $5f1a8e36b1548921$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($5f1a8e36b1548921$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $5f1a8e36b1548921$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $5f1a8e36b1548921$var$verifyState(value);
        if (state.constant) $5f1a8e36b1548921$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($5f1a8e36b1548921$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $1chjt.BigNumber).from(value.gas) : null
        };
        return new $5f1a8e36b1548921$export$3ac5c9504f801ea4($5f1a8e36b1548921$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $5f1a8e36b1548921$var$parseGas(value, params);
        let parens = value.match($5f1a8e36b1548921$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $5f1a8e36b1548921$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $5f1a8e36b1548921$var$parseParams(parens[2].trim(), false);
        $5f1a8e36b1548921$var$parseModifiers(parens[3].trim(), params);
        return $5f1a8e36b1548921$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $5f1a8e36b1548921$export$8d576c928b93668f extends $5f1a8e36b1548921$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $5f1a8e36b1548921$export$f010f239efc4d445.sighash;
        if (!$5f1a8e36b1548921$export$f010f239efc4d445[format]) $5f1a8e36b1548921$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $5f1a8e36b1548921$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payble: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            ouputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $5f1a8e36b1548921$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $5f1a8e36b1548921$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $5f1a8e36b1548921$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $5f1a8e36b1548921$export$8d576c928b93668f.fromString(value);
        return $5f1a8e36b1548921$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($5f1a8e36b1548921$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $5f1a8e36b1548921$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $5f1a8e36b1548921$var$verifyState(value);
        const params = {
            type: value.type,
            name: $5f1a8e36b1548921$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($5f1a8e36b1548921$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($5f1a8e36b1548921$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $1chjt.BigNumber).from(value.gas) : null
        };
        return new $5f1a8e36b1548921$export$8d576c928b93668f($5f1a8e36b1548921$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $5f1a8e36b1548921$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $5f1a8e36b1548921$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($5f1a8e36b1548921$var$regexParen);
        if (!parens) $5f1a8e36b1548921$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $5f1a8e36b1548921$var$verifyIdentifier(params.name);
        params.inputs = $5f1a8e36b1548921$var$parseParams(parens[2], false);
        $5f1a8e36b1548921$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($5f1a8e36b1548921$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $5f1a8e36b1548921$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $5f1a8e36b1548921$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $5f1a8e36b1548921$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class ErrorFragment extends Fragment {
//}
//export class StructFragment extends Fragment {
//}
function $5f1a8e36b1548921$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
const $5f1a8e36b1548921$var$regexIdentifier = new RegExp("^[A-Za-z_][A-Za-z0-9_]*$");
function $5f1a8e36b1548921$var$verifyIdentifier(value) {
    if (!value || !value.match($5f1a8e36b1548921$var$regexIdentifier)) $5f1a8e36b1548921$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $5f1a8e36b1548921$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $5f1a8e36b1548921$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $5f1a8e36b1548921$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}

});
parcelRegister("3bam6", function(module, exports) {

$parcel$export(module.exports, "version", () => $250a6e923f43a9af$export$83d89fbfd8236492);
const $250a6e923f43a9af$export$83d89fbfd8236492 = "abi/5.0.7";

});


parcelRegister("gYiun", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", () => $c5b09772c67cc0be$export$fe041e1a83d3efc6);
$parcel$export(module.exports, "defaultAbiCoder", () => $c5b09772c67cc0be$export$51d1cfcdb913adff);

var $aBzgs = parcelRequire("aBzgs");

var $e72ut = parcelRequire("e72ut");

var $d1hml = parcelRequire("d1hml");

var $3bam6 = parcelRequire("3bam6");

var $d4e6U = parcelRequire("d4e6U");

var $jRzOe = parcelRequire("jRzOe");

var $1PseI = parcelRequire("1PseI");

var $jlyBr = parcelRequire("jlyBr");

var $9v5CJ = parcelRequire("9v5CJ");

var $3YxKx = parcelRequire("3YxKx");

var $1CLox = parcelRequire("1CLox");

var $hWOC2 = parcelRequire("hWOC2");

var $l8RZV = parcelRequire("l8RZV");

var $hdhvf = parcelRequire("hdhvf");

var $8aez5 = parcelRequire("8aez5");
"use strict";
const $c5b09772c67cc0be$var$logger = new (0, $d1hml.Logger)((0, $3bam6.version));
const $c5b09772c67cc0be$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $c5b09772c67cc0be$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $c5b09772c67cc0be$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        $c5b09772c67cc0be$var$logger.checkNew(new.target, $c5b09772c67cc0be$export$fe041e1a83d3efc6);
        (0, $e72ut.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $jRzOe.AddressCoder)(param.name);
            case "bool":
                return new (0, $jlyBr.BooleanCoder)(param.name);
            case "string":
                return new (0, $l8RZV.StringCoder)(param.name);
            case "bytes":
                return new (0, $9v5CJ.BytesCoder)(param.name);
            case "array":
                return new (0, $1PseI.ArrayCoder)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $hdhvf.TupleCoder)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $1CLox.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($c5b09772c67cc0be$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $c5b09772c67cc0be$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $hWOC2.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($c5b09772c67cc0be$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $c5b09772c67cc0be$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $3YxKx.FixedBytesCoder)(size, param.name);
        }
        return $c5b09772c67cc0be$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $d4e6U.Reader)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $d4e6U.Writer)(this._getWordSize());
    }
    encode(types, values) {
        if (types.length !== values.length) $c5b09772c67cc0be$var$logger.throwError("types/values length mismatch", (0, $d1hml.Logger).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $8aez5.ParamType).from(type)));
        const coder = new (0, $hdhvf.TupleCoder)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $8aez5.ParamType).from(type)));
        const coder = new (0, $hdhvf.TupleCoder)(coders, "_");
        return coder.decode(this._getReader((0, $aBzgs.arrayify)(data), loose));
    }
}
const $c5b09772c67cc0be$export$51d1cfcdb913adff = new $c5b09772c67cc0be$export$fe041e1a83d3efc6();

});
parcelRegister("d4e6U", function(module, exports) {

$parcel$export(module.exports, "Coder", () => $98369819881a56ac$export$2c0c39526f8bad46);
$parcel$export(module.exports, "Writer", () => $98369819881a56ac$export$d7a960146e1a269e);
$parcel$export(module.exports, "Reader", () => $98369819881a56ac$export$2f7a2f0e90c07dc4);

var $aBzgs = parcelRequire("aBzgs");

var $1chjt = parcelRequire("1chjt");

var $e72ut = parcelRequire("e72ut");

var $d1hml = parcelRequire("d1hml");

var $3bam6 = parcelRequire("3bam6");
"use strict";
const $98369819881a56ac$var$logger = new (0, $d1hml.Logger)((0, $3bam6.version));
function $98369819881a56ac$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $98369819881a56ac$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $98369819881a56ac$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $98369819881a56ac$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $e72ut.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $aBzgs.hexConcat)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $aBzgs.concat)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $aBzgs.arrayify)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $aBzgs.concat)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $aBzgs.arrayify)((0, $1chjt.BigNumber).from(value));
        if (bytes.length > this.wordSize) $98369819881a56ac$var$logger.throwError("value out-of-bounds", (0, $d1hml.Logger).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $aBzgs.concat)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $98369819881a56ac$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $e72ut.defineReadOnly)(this, "_data", (0, $aBzgs.arrayify)(data));
        (0, $e72ut.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $e72ut.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $e72ut.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $aBzgs.hexlify)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $98369819881a56ac$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $98369819881a56ac$var$logger.throwError("data out-of-bounds", (0, $d1hml.Logger).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $98369819881a56ac$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $1chjt.BigNumber).from(this.readBytes(this.wordSize));
    }
}

});

parcelRegister("jRzOe", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", () => $e75ebe80da077533$export$59dbbded7775bfe7);

var $bVwUc = parcelRequire("bVwUc");

var $aBzgs = parcelRequire("aBzgs");

var $d4e6U = parcelRequire("d4e6U");
"use strict";
class $e75ebe80da077533$export$59dbbded7775bfe7 extends (0, $d4e6U.Coder) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    encode(writer, value) {
        try {
            (0, $bVwUc.getAddress)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $bVwUc.getAddress)((0, $aBzgs.hexZeroPad)(reader.readValue().toHexString(), 20));
    }
}

});

parcelRegister("1PseI", function(module, exports) {

$parcel$export(module.exports, "pack", () => $15507500001d5e48$export$2a703dbb0cb35339);
$parcel$export(module.exports, "unpack", () => $15507500001d5e48$export$417857010dc9287f);
$parcel$export(module.exports, "ArrayCoder", () => $15507500001d5e48$export$88bc419d2df11f54);

var $d1hml = parcelRequire("d1hml");

var $3bam6 = parcelRequire("3bam6");

var $d4e6U = parcelRequire("d4e6U");

var $bhUl4 = parcelRequire("bhUl4");
"use strict";
const $15507500001d5e48$var$logger = new (0, $d1hml.Logger)((0, $3bam6.version));
function $15507500001d5e48$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $15507500001d5e48$var$logger.throwError("cannot encode object for signature with missing names", (0, $d1hml.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $15507500001d5e48$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $d1hml.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $15507500001d5e48$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $15507500001d5e48$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $d4e6U.Writer)(writer.wordSize);
    let dynamicWriter = new (0, $d4e6U.Writer)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $15507500001d5e48$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $d1hml.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $d1hml.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $15507500001d5e48$export$88bc419d2df11f54 extends (0, $d4e6U.Coder) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $15507500001d5e48$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $15507500001d5e48$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) count = reader.readValue().toNumber();
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $bhUl4.AnonymousCoder)(this.coder));
        return reader.coerce(this.name, $15507500001d5e48$export$417857010dc9287f(reader, coders));
    }
}

});
parcelRegister("bhUl4", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", () => $837cfbf728b360cb$export$87c41d1139a03fa2);

var $d4e6U = parcelRequire("d4e6U");
"use strict";
class $837cfbf728b360cb$export$87c41d1139a03fa2 extends (0, $d4e6U.Coder) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

});


parcelRegister("jlyBr", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", () => $e15ad1e71a8c434c$export$fe9118d6c093150c);

var $d4e6U = parcelRequire("d4e6U");
"use strict";
class $e15ad1e71a8c434c$export$fe9118d6c093150c extends (0, $d4e6U.Coder) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}

});

parcelRegister("9v5CJ", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", () => $6eab5f09fc44fb88$export$db9eadd8df12ad2e);
$parcel$export(module.exports, "BytesCoder", () => $6eab5f09fc44fb88$export$e5823e9574df18d2);

var $aBzgs = parcelRequire("aBzgs");

var $d4e6U = parcelRequire("d4e6U");
"use strict";
class $6eab5f09fc44fb88$export$db9eadd8df12ad2e extends (0, $d4e6U.Coder) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    encode(writer, value) {
        value = (0, $aBzgs.arrayify)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $6eab5f09fc44fb88$export$e5823e9574df18d2 extends $6eab5f09fc44fb88$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $aBzgs.hexlify)(super.decode(reader)));
    }
}

});

parcelRegister("3YxKx", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", () => $2e5127a8f74f8727$export$7dec9db68e6bcf5a);

var $aBzgs = parcelRequire("aBzgs");

var $d4e6U = parcelRequire("d4e6U");
"use strict";
class $2e5127a8f74f8727$export$7dec9db68e6bcf5a extends (0, $d4e6U.Coder) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    encode(writer, value) {
        let data = (0, $aBzgs.arrayify)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $aBzgs.hexlify)(reader.readBytes(this.size)));
    }
}

});

parcelRegister("1CLox", function(module, exports) {

$parcel$export(module.exports, "NullCoder", () => $12ee1aad3af2da34$export$70982cadf2d6b4ec);

var $d4e6U = parcelRequire("d4e6U");
"use strict";
class $12ee1aad3af2da34$export$70982cadf2d6b4ec extends (0, $d4e6U.Coder) {
    constructor(localName){
        super("null", "", localName, false);
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}

});

parcelRegister("hWOC2", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", () => $d10f1d086136fcd2$export$b934dc8cfe13938c);

var $1chjt = parcelRequire("1chjt");

var $gVGT9 = parcelRequire("gVGT9");

var $d4e6U = parcelRequire("d4e6U");
"use strict";
class $d10f1d086136fcd2$export$b934dc8cfe13938c extends (0, $d4e6U.Coder) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    encode(writer, value) {
        let v = (0, $1chjt.BigNumber).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $gVGT9.MaxUint256).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $gVGT9.One)).mul((0, $gVGT9.NegativeOne)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $gVGT9.Zero)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}

});

parcelRegister("l8RZV", function(module, exports) {

$parcel$export(module.exports, "StringCoder", () => $f6443b2c870e6399$export$2d1b854518731426);

var $fkVsY = parcelRequire("fkVsY");

var $9v5CJ = parcelRequire("9v5CJ");
"use strict";
class $f6443b2c870e6399$export$2d1b854518731426 extends (0, $9v5CJ.DynamicBytesCoder) {
    constructor(localName){
        super("string", localName);
    }
    encode(writer, value) {
        return super.encode(writer, (0, $fkVsY.toUtf8Bytes)(value));
    }
    decode(reader) {
        return (0, $fkVsY.toUtf8String)(super.decode(reader));
    }
}

});
parcelRegister("fkVsY", function(module, exports) {

$parcel$export(module.exports, "toUtf8Bytes", () => $b2a54ce293d87a2e$export$8feeb310b4b4752f);
$parcel$export(module.exports, "toUtf8String", () => $b2a54ce293d87a2e$export$7643a1dc2c38d5eb);

var $aBzgs = parcelRequire("aBzgs");

var $d1hml = parcelRequire("d1hml");

var $lrjmA = parcelRequire("lrjmA");
"use strict";
const $b2a54ce293d87a2e$var$logger = new (0, $d1hml.Logger)((0, $lrjmA.version));
var $b2a54ce293d87a2e$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($b2a54ce293d87a2e$export$c6986442964129f5 || ($b2a54ce293d87a2e$export$c6986442964129f5 = {}));
var $b2a54ce293d87a2e$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($b2a54ce293d87a2e$export$c285fa6ac15ff6a6 || ($b2a54ce293d87a2e$export$c285fa6ac15ff6a6 = {}));
function $b2a54ce293d87a2e$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $b2a54ce293d87a2e$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $b2a54ce293d87a2e$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $b2a54ce293d87a2e$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $b2a54ce293d87a2e$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $b2a54ce293d87a2e$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $b2a54ce293d87a2e$var$errorFunc,
    ignore: $b2a54ce293d87a2e$var$ignoreFunc,
    replace: $b2a54ce293d87a2e$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $b2a54ce293d87a2e$export$c6e2180c5bb5bc05.error;
    bytes = (0, $aBzgs.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $b2a54ce293d87a2e$export$8feeb310b4b4752f(str, form = $b2a54ce293d87a2e$export$c6986442964129f5.current) {
    if (form != $b2a54ce293d87a2e$export$c6986442964129f5.current) {
        $b2a54ce293d87a2e$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $aBzgs.arrayify)(result);
}
function $b2a54ce293d87a2e$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $b2a54ce293d87a2e$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return "\\\"";
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $b2a54ce293d87a2e$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $b2a54ce293d87a2e$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $b2a54ce293d87a2e$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $b2a54ce293d87a2e$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $b2a54ce293d87a2e$export$7643a1dc2c38d5eb(bytes, onError) {
    return $b2a54ce293d87a2e$export$232e1dab03132235($b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError));
}
function $b2a54ce293d87a2e$export$ae470a36a31b28c2(str, form = $b2a54ce293d87a2e$export$c6986442964129f5.current) {
    return $b2a54ce293d87a2e$var$getUtf8CodePoints($b2a54ce293d87a2e$export$8feeb310b4b4752f(str, form));
}

});
parcelRegister("lrjmA", function(module, exports) {

$parcel$export(module.exports, "version", () => $f9bb23bb4b058849$export$83d89fbfd8236492);
const $f9bb23bb4b058849$export$83d89fbfd8236492 = "strings/5.5.0";

});



parcelRegister("hdhvf", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", () => $c8813a479ff8f599$export$e9fceba8f110fea6);

var $d4e6U = parcelRequire("d4e6U");

var $1PseI = parcelRequire("1PseI");
"use strict";
class $c8813a479ff8f599$export$e9fceba8f110fea6 extends (0, $d4e6U.Coder) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    encode(writer, value) {
        return (0, $1PseI.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $1PseI.unpack)(reader, this.coders));
    }
}

});


parcelRegister("bKqKs", function(module, exports) {

var $bVwUc = parcelRequire("bVwUc");

var $1chjt = parcelRequire("1chjt");

var $aBzgs = parcelRequire("aBzgs");

var $aIo2D = parcelRequire("aIo2D");

var $2yhyU = parcelRequire("2yhyU");

var $e72ut = parcelRequire("e72ut");

var $gYiun = parcelRequire("gYiun");

var $d4e6U = parcelRequire("d4e6U");

var $8aez5 = parcelRequire("8aez5");

var $d1hml = parcelRequire("d1hml");

var $3bam6 = parcelRequire("3bam6");
"use strict";
const $88d8bd435357f45e$var$logger = new (0, $d1hml.Logger)((0, $3bam6.version));
class $88d8bd435357f45e$export$c2ab6499be98b3c5 extends (0, $e72ut.Description) {
}
class $88d8bd435357f45e$export$7a3223b0fadb690b extends (0, $e72ut.Description) {
}
class $88d8bd435357f45e$export$8ef99100a3c56f8c extends (0, $e72ut.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
function $88d8bd435357f45e$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $88d8bd435357f45e$export$48cefb51a4e315b2 {
    constructor(fragments){
        $88d8bd435357f45e$var$logger.checkNew(new.target, $88d8bd435357f45e$export$48cefb51a4e315b2);
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $e72ut.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $8aez5.Fragment).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $e72ut.defineReadOnly)(this, "_abiCoder", (0, $e72ut.getStatic)(new.target, "getAbiCoder")());
        (0, $e72ut.defineReadOnly)(this, "functions", {});
        (0, $e72ut.defineReadOnly)(this, "errors", {});
        (0, $e72ut.defineReadOnly)(this, "events", {});
        (0, $e72ut.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $88d8bd435357f45e$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $e72ut.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $88d8bd435357f45e$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $e72ut.defineReadOnly)(this, "deploy", (0, $8aez5.ConstructorFragment).from({
            payable: false,
            type: "constructor"
        }));
        (0, $e72ut.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $8aez5.FormatTypes).full;
        if (format === (0, $8aez5.FormatTypes).sighash) $88d8bd435357f45e$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $8aez5.FormatTypes).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $gYiun.defaultAbiCoder;
    }
    static getAddress(address) {
        return (0, $bVwUc.getAddress)(address);
    }
    static getSighash(functionFragment) {
        return (0, $aBzgs.hexDataSlice)((0, $aIo2D.id)(functionFragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $aIo2D.id)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $aBzgs.isHexString)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $88d8bd435357f45e$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $88d8bd435357f45e$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $88d8bd435357f45e$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normlize the signature and lookup the function
        const result = this.functions[(0, $8aez5.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $88d8bd435357f45e$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $aBzgs.isHexString)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $88d8bd435357f45e$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $88d8bd435357f45e$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $88d8bd435357f45e$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normlize the signature and lookup the function
        const result = this.events[(0, $8aez5.EventFragment).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $88d8bd435357f45e$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(functionFragment) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $e72ut.getStatic)(this.constructor, "getSighash")(functionFragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $e72ut.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $aBzgs.arrayify)(data);
        if ((0, $aBzgs.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $88d8bd435357f45e$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $aBzgs.hexlify)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $aBzgs.hexlify)((0, $aBzgs.concat)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $aBzgs.arrayify)(data);
        let reason = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                if ((0, $aBzgs.hexlify)(bytes.slice(0, 4)) === "0x08c379a0") {
                    errorSignature = "Error(string)";
                    reason = this._abiCoder.decode([
                        "string"
                    ], bytes.slice(4))[0];
                }
                break;
        }
        return $88d8bd435357f45e$var$logger.throwError("call revert exception", (0, $d1hml.Logger).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            errorSignature: errorSignature,
            errorArgs: [
                reason
            ],
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $aBzgs.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $88d8bd435357f45e$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $d1hml.Logger).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $aIo2D.id)(value);
            else if (param.type === "bytes") return (0, $2yhyU.keccak256)((0, $aBzgs.hexlify)(value));
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $aBzgs.hexZeroPad)((0, $aBzgs.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $88d8bd435357f45e$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $88d8bd435357f45e$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $88d8bd435357f45e$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $aIo2D.id)(value));
                else if (param.type === "bytes") topics.push((0, $2yhyU.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TOOD
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $aBzgs.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $88d8bd435357f45e$var$logger.throwError("fragment/topic mismatch", (0, $d1hml.Logger).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $8aez5.ParamType).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $aBzgs.concat)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $88d8bd435357f45e$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $88d8bd435357f45e$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    get: ()=>{
                        throw $88d8bd435357f45e$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                get: ()=>{
                    throw $88d8bd435357f45e$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $88d8bd435357f45e$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $1chjt.BigNumber).from(tx.value || "0")
        });
    }
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe jsut a fragment?
        return new $88d8bd435357f45e$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}

});
parcelRegister("aIo2D", function(module, exports) {

$parcel$export(module.exports, "id", () => $7cd0a9996bd6b341$export$d560c7e4a29451c2);

var $2yhyU = parcelRequire("2yhyU");

var $fkVsY = parcelRequire("fkVsY");
function $7cd0a9996bd6b341$export$d560c7e4a29451c2(text) {
    return (0, $2yhyU.keccak256)((0, $fkVsY.toUtf8Bytes)(text));
}

});





parcelRegister("6Wdcs", function(module, exports) {

$parcel$export(module.exports, "hash", () => $50d2661a165b7438$export$d6af199866bfb566, (v) => $50d2661a165b7438$export$d6af199866bfb566 = v);
var $50d2661a165b7438$export$d6af199866bfb566;
var $50d2661a165b7438$export$a3295358bff77e;

var $6ZWSX = parcelRequire("6ZWSX");
var $50d2661a165b7438$require$Buffer = $6ZWSX.Buffer;

var $e1cGD = parcelRequire("e1cGD");
var $50d2661a165b7438$require$sha3 = $e1cGD.keccak_256;

var $qUvz3 = parcelRequire("qUvz3");
function $50d2661a165b7438$var$namehash(inputName) {
    // Reject empty names:
    var node = '';
    for(var i = 0; i < 32; i++)node += '00';
    name = $50d2661a165b7438$var$normalize(inputName);
    if (name) {
        var labels = name.split('.');
        for(var i = labels.length - 1; i >= 0; i--){
            var labelSha = $50d2661a165b7438$require$sha3(labels[i]);
            node = $50d2661a165b7438$require$sha3(new $50d2661a165b7438$require$Buffer(node + labelSha, 'hex'));
        }
    }
    return '0x' + node;
}
function $50d2661a165b7438$var$normalize(name1) {
    return name1 ? $qUvz3.toUnicode(name1, {
        useStd3ASCII: true,
        transitional: false
    }) : name1;
}
$50d2661a165b7438$export$d6af199866bfb566 = $50d2661a165b7438$var$namehash;
$50d2661a165b7438$export$a3295358bff77e = $50d2661a165b7438$var$normalize;

});
parcelRegister("e1cGD", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.5.7
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2016
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var root = typeof window === 'object' ? window : {};
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $hPtJY === 'object' && $hPtJY.versions && $hPtJY.versions.node;
    if (NODE_JS) root = $parcel$global;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var HEX_CHARS = '0123456789abcdef'.split('');
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        'hex',
        'buffer',
        'arrayBuffer',
        'array'
    ];
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, 'hex');
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(bits, padding, type);
        }
        return method;
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, 'hex');
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createShakeOutputMethod(bits, padding, type);
        }
        return method;
    };
    var algorithms = [
        {
            name: 'keccak',
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: 'sha3',
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: 'shake',
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + '_' + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        var notString = typeof message !== 'string';
        if (notString && message.constructor === ArrayBuffer) message = new Uint8Array(message);
        var length = message.length, blocks = this.blocks, byteCount = this.byteCount, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.finalize = function() {
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = '', block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            if (extraBytes > 0) hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            if (extraBytes > 0) array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else for(var i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
})();

});

parcelRegister("qUvz3", function(module, exports) {


(function(root, factory) {
    /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define([
        'punycode',
        './idna-map'
    ], function(punycode, idna_map) {
        return factory(punycode, idna_map);
    });
    else module.exports = factory((parcelRequire("SWLke")), (parcelRequire("lVmIg")));
})(module.exports, function(punycode, idna_map) {
    function mapLabel(label, useStd3ASCII, transitional) {
        var mapped = [];
        var chars = punycode.ucs2.decode(label);
        for(var i = 0; i < chars.length; i++){
            var cp = chars[i];
            var ch = punycode.ucs2.encode([
                chars[i]
            ]);
            var composite = idna_map.mapChar(cp);
            var flags = composite >> 23;
            var kind = composite >> 21 & 3;
            var index = composite >> 5 & 0xffff;
            var length = composite & 0x1f;
            var value = idna_map.mapStr.substr(index, length);
            if (kind === 0 || useStd3ASCII && flags & 1) throw new Error("Illegal char " + ch);
            else if (kind === 1) mapped.push(value);
            else if (kind === 2) mapped.push(transitional ? value : ch);
            else if (kind === 3) mapped.push(ch);
        }
        var newLabel = mapped.join("").normalize("NFC");
        return newLabel;
    }
    function process(domain, transitional, useStd3ASCII) {
        /* istanbul ignore if */ if (useStd3ASCII === undefined) useStd3ASCII = false;
        var mappedIDNA = mapLabel(domain, useStd3ASCII, transitional);
        // Step 3. Break
        var labels = mappedIDNA.split(".");
        // Step 4. Convert/Validate
        labels = labels.map(function(label) {
            if (label.startsWith("xn--")) {
                label = punycode.decode(label.substring(4));
                validateLabel(label, useStd3ASCII, false);
            } else validateLabel(label, useStd3ASCII, transitional);
            return label;
        });
        return labels.join(".");
    }
    function validateLabel(label, useStd3ASCII, transitional) {
        // 2. The label must not contain a U+002D HYPHEN-MINUS character in both the
        // third position and fourth positions.
        if (label[2] === '-' && label[3] === '-') throw new Error("Failed to validate " + label);
        // 3. The label must neither begin nor end with a U+002D HYPHEN-MINUS
        // character.
        if (label.startsWith('-') || label.endsWith('-')) throw new Error("Failed to validate " + label);
        // 4. The label must not contain a U+002E ( . ) FULL STOP.
        // this should nerver happen as label is chunked internally by this character
        /* istanbul ignore if */ if (label.includes('.')) throw new Error("Failed to validate " + label);
        if (mapLabel(label, useStd3ASCII, transitional) !== label) throw new Error("Failed to validate " + label);
        // 5. The label must not begin with a combining mark, that is:
        // General_Category=Mark.
        var ch = label.codePointAt(0);
        if (idna_map.mapChar(ch) & 16777216) throw new Error("Label contains illegal character: " + ch);
    }
    function toAscii(domain, options) {
        if (options === undefined) options = {};
        var transitional = 'transitional' in options ? options.transitional : true;
        var useStd3ASCII = 'useStd3ASCII' in options ? options.useStd3ASCII : false;
        var verifyDnsLength = 'verifyDnsLength' in options ? options.verifyDnsLength : false;
        var labels = process(domain, transitional, useStd3ASCII).split('.');
        var asciiLabels = labels.map(punycode.toASCII);
        var asciiString = asciiLabels.join('.');
        var i;
        if (verifyDnsLength) {
            if (asciiString.length < 1 || asciiString.length > 253) throw new Error("DNS name has wrong length: " + asciiString);
            for(i = 0; i < asciiLabels.length; i++){
                var label = asciiLabels[i];
                if (label.length < 1 || label.length > 63) throw new Error("DNS label has wrong length: " + label);
            }
        }
        return asciiString;
    }
    function toUnicode(domain, options) {
        if (options === undefined) options = {};
        var useStd3ASCII = 'useStd3ASCII' in options ? options.useStd3ASCII : false;
        return process(domain, false, useStd3ASCII);
    }
    return {
        toUnicode: toUnicode,
        toAscii: toAscii
    };
});

});
parcelRegister("SWLke", function(module, exports) {
'use strict';
/** Highest positive signed 32-bit float value */ const $0a52a03b405ad4e5$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $0a52a03b405ad4e5$var$base = 36;
const $0a52a03b405ad4e5$var$tMin = 1;
const $0a52a03b405ad4e5$var$tMax = 26;
const $0a52a03b405ad4e5$var$skew = 38;
const $0a52a03b405ad4e5$var$damp = 700;
const $0a52a03b405ad4e5$var$initialBias = 72;
const $0a52a03b405ad4e5$var$initialN = 128; // 0x80
const $0a52a03b405ad4e5$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $0a52a03b405ad4e5$var$regexPunycode = /^xn--/;
const $0a52a03b405ad4e5$var$regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
const $0a52a03b405ad4e5$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $0a52a03b405ad4e5$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $0a52a03b405ad4e5$var$baseMinusTMin = $0a52a03b405ad4e5$var$base - $0a52a03b405ad4e5$var$tMin;
const $0a52a03b405ad4e5$var$floor = Math.floor;
const $0a52a03b405ad4e5$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $0a52a03b405ad4e5$var$error(type) {
    throw new RangeError($0a52a03b405ad4e5$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $0a52a03b405ad4e5$var$map(array, fn) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = fn(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function $0a52a03b405ad4e5$var$mapDomain(string, fn) {
    const parts = string.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        string = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    string = string.replace($0a52a03b405ad4e5$var$regexSeparators, '\x2E');
    const labels = string.split('.');
    const encoded = $0a52a03b405ad4e5$var$map(labels, fn).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $0a52a03b405ad4e5$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $0a52a03b405ad4e5$var$ucs2encode = (array)=>String.fromCodePoint(...array);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $0a52a03b405ad4e5$var$basicToDigit = function(codePoint) {
    if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
    if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
    if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
    return $0a52a03b405ad4e5$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $0a52a03b405ad4e5$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $0a52a03b405ad4e5$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $0a52a03b405ad4e5$var$floor(delta / $0a52a03b405ad4e5$var$damp) : delta >> 1;
    delta += $0a52a03b405ad4e5$var$floor(delta / numPoints);
    for(; delta > $0a52a03b405ad4e5$var$baseMinusTMin * $0a52a03b405ad4e5$var$tMax >> 1; k += $0a52a03b405ad4e5$var$base)delta = $0a52a03b405ad4e5$var$floor(delta / $0a52a03b405ad4e5$var$baseMinusTMin);
    return $0a52a03b405ad4e5$var$floor(k + ($0a52a03b405ad4e5$var$baseMinusTMin + 1) * delta / (delta + $0a52a03b405ad4e5$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $0a52a03b405ad4e5$var$decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $0a52a03b405ad4e5$var$initialN;
    let bias = $0a52a03b405ad4e5$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($0a52a03b405ad4e5$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $0a52a03b405ad4e5$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        let oldi = i;
        for(let w = 1, k = $0a52a03b405ad4e5$var$base;; k += $0a52a03b405ad4e5$var$base){
            if (index >= inputLength) $0a52a03b405ad4e5$var$error('invalid-input');
            const digit = $0a52a03b405ad4e5$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $0a52a03b405ad4e5$var$base || digit > $0a52a03b405ad4e5$var$floor(($0a52a03b405ad4e5$var$maxInt - i) / w)) $0a52a03b405ad4e5$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $0a52a03b405ad4e5$var$tMin : k >= bias + $0a52a03b405ad4e5$var$tMax ? $0a52a03b405ad4e5$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $0a52a03b405ad4e5$var$base - t;
            if (w > $0a52a03b405ad4e5$var$floor($0a52a03b405ad4e5$var$maxInt / baseMinusT)) $0a52a03b405ad4e5$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $0a52a03b405ad4e5$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($0a52a03b405ad4e5$var$floor(i / out) > $0a52a03b405ad4e5$var$maxInt - n) $0a52a03b405ad4e5$var$error('overflow');
        n += $0a52a03b405ad4e5$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $0a52a03b405ad4e5$var$encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $0a52a03b405ad4e5$var$ucs2decode(input);
    // Cache the length.
    let inputLength = input.length;
    // Initialize the state.
    let n = $0a52a03b405ad4e5$var$initialN;
    let delta = 0;
    let bias = $0a52a03b405ad4e5$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($0a52a03b405ad4e5$var$stringFromCharCode(currentValue));
    let basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($0a52a03b405ad4e5$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $0a52a03b405ad4e5$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $0a52a03b405ad4e5$var$floor(($0a52a03b405ad4e5$var$maxInt - delta) / handledCPCountPlusOne)) $0a52a03b405ad4e5$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $0a52a03b405ad4e5$var$maxInt) $0a52a03b405ad4e5$var$error('overflow');
            if (currentValue == n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $0a52a03b405ad4e5$var$base;; k += $0a52a03b405ad4e5$var$base){
                    const t = k <= bias ? $0a52a03b405ad4e5$var$tMin : k >= bias + $0a52a03b405ad4e5$var$tMax ? $0a52a03b405ad4e5$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $0a52a03b405ad4e5$var$base - t;
                    output.push($0a52a03b405ad4e5$var$stringFromCharCode($0a52a03b405ad4e5$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $0a52a03b405ad4e5$var$floor(qMinusT / baseMinusT);
                }
                output.push($0a52a03b405ad4e5$var$stringFromCharCode($0a52a03b405ad4e5$var$digitToBasic(q, 0)));
                bias = $0a52a03b405ad4e5$var$adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $0a52a03b405ad4e5$var$toUnicode = function(input) {
    return $0a52a03b405ad4e5$var$mapDomain(input, function(string) {
        return $0a52a03b405ad4e5$var$regexPunycode.test(string) ? $0a52a03b405ad4e5$var$decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $0a52a03b405ad4e5$var$toASCII = function(input) {
    return $0a52a03b405ad4e5$var$mapDomain(input, function(string) {
        return $0a52a03b405ad4e5$var$regexNonASCII.test(string) ? 'xn--' + $0a52a03b405ad4e5$var$encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $0a52a03b405ad4e5$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.1.0',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $0a52a03b405ad4e5$var$ucs2decode,
        'encode': $0a52a03b405ad4e5$var$ucs2encode
    },
    'decode': $0a52a03b405ad4e5$var$decode,
    'encode': $0a52a03b405ad4e5$var$encode,
    'toASCII': $0a52a03b405ad4e5$var$toASCII,
    'toUnicode': $0a52a03b405ad4e5$var$toUnicode
};
module.exports = $0a52a03b405ad4e5$var$punycode;

});

parcelRegister("lVmIg", function(module, exports) {
/* This file is generated from the Unicode IDNA table, using
   the build-unicode-tables.py script. Please edit that
   script instead of this file. */ /* istanbul ignore next */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define([], function() {
        return factory();
    });
    else module.exports = factory();
})(module.exports, function() {
    var blocks = [
        new Uint32Array([
            2157250,
            2157314,
            2157378,
            2157442,
            2157506,
            2157570,
            2157634,
            0,
            2157698,
            2157762,
            2157826,
            2157890,
            2157954,
            0,
            2158018,
            0
        ]),
        new Uint32Array([
            2179041,
            6291456,
            2179073,
            6291456,
            2179105,
            6291456,
            2179137,
            6291456,
            2179169,
            6291456,
            2179201,
            6291456,
            2179233,
            6291456,
            2179265,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064
        ]),
        new Uint32Array([
            0,
            2113729,
            2197345,
            2197377,
            2113825,
            2197409,
            2197441,
            2113921,
            2197473,
            2114017,
            2197505,
            2197537,
            2197569,
            2197601,
            2197633,
            2197665
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            23068672
        ]),
        new Uint32Array([
            14680064,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            14680064,
            14680064
        ]),
        new Uint32Array([
            2196001,
            2196033,
            2196065,
            2196097,
            2196129,
            2196161,
            2196193,
            2196225,
            2196257,
            2196289,
            2196321,
            2196353,
            2196385,
            2196417,
            2196449,
            2196481
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2097281,
            2105921,
            2097729,
            2106081,
            0,
            2097601,
            2162337,
            2106017,
            2133281,
            2097505,
            2105889,
            2097185,
            2097697,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            2177025,
            6291456,
            2177057,
            6291456,
            2177089,
            6291456,
            2177121,
            6291456,
            2177153,
            6291456,
            2177185,
            6291456,
            2177217,
            6291456,
            2177249,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2134435,
            2134531,
            2134627,
            2134723,
            2134723,
            2134819,
            2134819,
            2134915,
            2134915,
            2135011,
            2105987,
            2135107,
            2135203,
            2135299,
            2131587,
            2135395
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            2168673,
            2169249,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2147906,
            2147970,
            2148034,
            2148098,
            2148162,
            2148226,
            2148290,
            2148354,
            2147906,
            2147970,
            2148034,
            2148098,
            2148162,
            2148226,
            2148290,
            2148354
        ]),
        new Uint32Array([
            2125219,
            2125315,
            2152834,
            2152898,
            2125411,
            2152962,
            2153026,
            2125506,
            2125507,
            2125603,
            2153090,
            2153154,
            2153218,
            2153282,
            2153346,
            2105348
        ]),
        new Uint32Array([
            2203393,
            6291456,
            2203425,
            6291456,
            2203457,
            6291456,
            2203489,
            6291456,
            6291456,
            6291456,
            6291456,
            2203521,
            6291456,
            2181281,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            23068672,
            6291456,
            2145538,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2139426,
            2160834,
            2160898,
            2160962,
            2134242,
            2161026,
            2161090,
            2161154,
            2161218,
            2161282,
            2161346,
            2161410,
            2138658,
            2161474,
            2161538,
            2134722
        ]),
        new Uint32Array([
            2119939,
            2124930,
            2125026,
            2106658,
            2125218,
            2128962,
            2129058,
            2129154,
            2129250,
            2129346,
            2129442,
            2108866,
            2108770,
            2150466,
            2150530,
            2150594
        ]),
        new Uint32Array([
            2201601,
            6291456,
            2201633,
            6291456,
            2201665,
            6291456,
            2201697,
            6291456,
            2201729,
            6291456,
            2201761,
            6291456,
            2201793,
            6291456,
            2201825,
            6291456
        ]),
        new Uint32Array([
            2193537,
            2193569,
            2193601,
            2193633,
            2193665,
            2193697,
            2193729,
            2193761,
            2193793,
            2193825,
            2193857,
            2193889,
            2193921,
            2193953,
            2193985,
            2194017
        ]),
        new Uint32Array([
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2190561,
            6291456,
            2190593,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2190625,
            6291456,
            2190657,
            6291456,
            23068672
        ]),
        new Uint32Array([
            2215905,
            2215937,
            2215969,
            2216001,
            2216033,
            2216065,
            2216097,
            2216129,
            2216161,
            2216193,
            2216225,
            2216257,
            2105441,
            2216289,
            2216321,
            2216353
        ]),
        new Uint32Array([
            23068672,
            18884130,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2191233,
            2191265,
            2191297,
            2191329,
            2191361,
            2191393,
            2191425,
            2117377,
            2191457,
            2191489,
            2191521,
            2191553,
            2191585,
            2191617,
            2191649,
            2117953
        ]),
        new Uint32Array([
            2132227,
            2132323,
            2132419,
            2132419,
            2132515,
            2132515,
            2132611,
            2132707,
            2132707,
            2132803,
            2132899,
            2132899,
            2132995,
            2132995,
            2133091,
            2133187
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            10609889,
            10610785,
            10609921,
            10610817,
            2222241
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2219969,
            2157121,
            2157441,
            2157505,
            2157889,
            2157953,
            2220001,
            2158465,
            2158529,
            10575617,
            2156994,
            2157058,
            2129923,
            2130019,
            2157122,
            2157186
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2185249,
            6291456,
            2185281,
            6291456,
            2185313,
            6291456,
            2185345,
            6291456,
            2185377,
            6291456,
            2185409,
            6291456,
            2185441,
            6291456,
            2185473,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            6291456,
            0
        ]),
        new Uint32Array([
            2183361,
            6291456,
            2183393,
            6291456,
            2183425,
            6291456,
            2183457,
            6291456,
            2183489,
            6291456,
            2183521,
            6291456,
            2183553,
            6291456,
            2183585,
            6291456
        ]),
        new Uint32Array([
            2192161,
            2192193,
            2192225,
            2192257,
            2192289,
            2192321,
            2192353,
            2192385,
            2192417,
            2192449,
            2192481,
            2192513,
            2192545,
            2192577,
            2192609,
            2192641
        ]),
        new Uint32Array([
            2212001,
            2212033,
            2212065,
            2212097,
            2212129,
            2212161,
            2212193,
            2212225,
            2212257,
            2212289,
            2212321,
            2212353,
            2212385,
            2212417,
            2212449,
            2207265
        ]),
        new Uint32Array([
            2249825,
            2249857,
            2249889,
            2249921,
            2249954,
            2250018,
            2250082,
            2250145,
            2250177,
            2250209,
            2250241,
            2250274,
            2250337,
            2250370,
            2250433,
            2250465
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2147905,
            2147969,
            2148033,
            2148097,
            2148161,
            2148225,
            2148289,
            2148353
        ]),
        new Uint32Array([
            10485857,
            6291456,
            2197217,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            23068672,
            23068672
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2180353,
            2180385,
            2144033,
            2180417,
            2180449,
            2180481,
            2180513,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            10610209,
            10610465,
            10610241,
            10610753,
            10609857
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2223842,
            2223906,
            2223970,
            2224034,
            2224098,
            2224162,
            2224226,
            2224290,
            2224354,
            2224418,
            2224482,
            2224546,
            2224610,
            2224674,
            2224738,
            2224802
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            18923650,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            18923714,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2126179,
            2125538,
            2126275,
            2126371,
            2126467,
            2125634,
            2126563,
            2105603,
            2105604,
            2125346,
            2126659,
            2126755,
            2126851,
            2098179,
            2098181,
            2098182
        ]),
        new Uint32Array([
            2227426,
            2227490,
            2227554,
            2227618,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2192353,
            2240642,
            2240642,
            2240705,
            2240737,
            2240737,
            2240769,
            2240802,
            2240866,
            2240929,
            2240961,
            2240993,
            2241025,
            2241057,
            2241089,
            2241121
        ]),
        new Uint32Array([
            6291456,
            2170881,
            2170913,
            2170945,
            6291456,
            2170977,
            6291456,
            2171009,
            2171041,
            6291456,
            6291456,
            6291456,
            2171073,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2132226,
            2132514,
            2163586,
            2132610,
            2160386,
            2133090,
            2133186,
            2160450,
            2160514,
            2160578,
            2133570,
            2106178,
            2160642,
            2133858,
            2160706,
            2160770
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            10532162,
            10532226,
            10532290,
            10532354,
            10532418,
            10532482,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672
        ]),
        new Uint32Array([
            2098209,
            2108353,
            2108193,
            2108481,
            2170241,
            2111713,
            2105473,
            2105569,
            2105601,
            2112289,
            2112481,
            2098305,
            2108321,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2209121,
            2209153,
            2209185,
            2209217,
            2209249,
            2209281,
            2209313,
            2209345,
            2209377,
            2209409,
            2209441,
            2209473,
            2207265,
            2209505,
            2209537,
            2209569
        ]),
        new Uint32Array([
            2189025,
            6291456,
            2189057,
            6291456,
            2189089,
            6291456,
            2189121,
            6291456,
            2189153,
            6291456,
            2189185,
            6291456,
            2189217,
            6291456,
            2189249,
            6291456
        ]),
        new Uint32Array([
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2173761,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233057
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2165764,
            2140004
        ]),
        new Uint32Array([
            2215105,
            6291456,
            2215137,
            6291456,
            6291456,
            2215169,
            2215201,
            6291456,
            6291456,
            6291456,
            2215233,
            2215265,
            2215297,
            2215329,
            2215361,
            2215393
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            10505091,
            10505187,
            10505283,
            10505379,
            10505475,
            10505571,
            10505667,
            10505763,
            10505859,
            10505955,
            10506051,
            10506147,
            10506243,
            10506339,
            10506435,
            10506531
        ]),
        new Uint32Array([
            2229730,
            2229794,
            2229858,
            2229922,
            2229986,
            2230050,
            2230114,
            2230178,
            2230242,
            2230306,
            2230370,
            2230434,
            2230498,
            2230562,
            2230626,
            2230690
        ]),
        new Uint32Array([
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            0,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            10502115,
            10502178,
            10502211,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2190305,
            6291456,
            2190337,
            6291456,
            2190369,
            6291456,
            2190401,
            6291456,
            2190433,
            6291456,
            2190465,
            6291456,
            2190497,
            6291456,
            2190529,
            6291456
        ]),
        new Uint32Array([
            2173793,
            2173985,
            2174017,
            6291456,
            2173761,
            2173697,
            6291456,
            2174689,
            6291456,
            2174017,
            2174721,
            6291456,
            6291456,
            2174753,
            2174785,
            2174817
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2099521,
            2099105,
            2120705,
            2098369,
            2120801,
            2103361,
            2097985,
            2098433,
            2121377,
            2121473,
            2099169,
            2099873,
            2098401,
            2099393,
            2152609,
            2100033
        ]),
        new Uint32Array([
            2132898,
            2163842,
            2163906,
            2133282,
            2132034,
            2131938,
            2137410,
            2132802,
            2132706,
            2164866,
            2133282,
            2160578,
            2165186,
            2165186,
            6291456,
            6291456
        ]),
        new Uint32Array([
            10500003,
            10500099,
            10500195,
            10500291,
            10500387,
            10500483,
            10500579,
            10500675,
            10500771,
            10500867,
            10500963,
            10501059,
            10501155,
            10501251,
            10501347,
            10501443
        ]),
        new Uint32Array([
            2163458,
            2130978,
            2131074,
            2131266,
            2131362,
            2163522,
            2160130,
            2132066,
            2131010,
            2131106,
            2106018,
            2131618,
            2131298,
            2132034,
            2131938,
            2137410
        ]),
        new Uint32Array([
            2212961,
            2116993,
            2212993,
            2213025,
            2213057,
            2213089,
            2213121,
            2213153,
            2213185,
            2213217,
            2213249,
            2209633,
            2213281,
            2213313,
            2213345,
            2213377
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2113729,
            2113825,
            2113921,
            2114017,
            2114113,
            2114209,
            2114305,
            2114401,
            2114497,
            2114593,
            2114689,
            2114785,
            2114881,
            2114977,
            2115073,
            2115169
        ]),
        new Uint32Array([
            2238177,
            2238209,
            2238241,
            2238273,
            2238305,
            2238337,
            2238337,
            2217537,
            2238369,
            2238401,
            2238433,
            2238465,
            2215649,
            2238497,
            2238529,
            2238561
        ]),
        new Uint32Array([
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905
        ]),
        new Uint32Array([
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            2145026,
            0,
            6291456,
            2145090,
            0,
            6291456,
            6291456,
            0,
            0,
            23068672,
            0,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2099233,
            2122017,
            2200673,
            2098113,
            2121537,
            2103201,
            2200705,
            2104033,
            2121857,
            2121953,
            2122401,
            2099649,
            2099969,
            2123009,
            2100129,
            2100289
        ]),
        new Uint32Array([
            6291456,
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2187681,
            2187713,
            2187745,
            2187777,
            2187809,
            2187841,
            2187873,
            2187905,
            2187937,
            2187969,
            2188001,
            2188033,
            2188065,
            2188097,
            2188129,
            2188161
        ]),
        new Uint32Array([
            0,
            10554498,
            10554562,
            10554626,
            10554690,
            10554754,
            10554818,
            10554882,
            10554946,
            10555010,
            10555074,
            6291456,
            6291456,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2235170,
            2235234,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2181153,
            6291456,
            2188897,
            6291456,
            6291456,
            2188929,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2111905,
            2100865,
            2188961,
            2188993
        ]),
        new Uint32Array([
            2100833,
            2100897,
            0,
            0,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            10575617,
            2187041,
            10502177,
            10489601,
            10489697,
            2112289
        ]),
        new Uint32Array([
            6291456,
            2172833,
            6291456,
            2172865,
            2172897,
            2172929,
            2172961,
            6291456,
            2172993,
            6291456,
            2173025,
            6291456,
            2173057,
            6291456,
            2173089,
            6291456
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            23068672,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2190721
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2184993,
            6291456,
            2185025,
            6291456,
            2185057,
            6291456,
            2185089,
            6291456,
            2185121,
            6291456,
            2185153,
            6291456,
            2185185,
            6291456,
            2185217,
            6291456
        ]),
        new Uint32Array([
            2115265,
            2115361,
            2115457,
            2115553,
            2115649,
            2115745,
            2115841,
            2115937,
            2116033,
            2116129,
            2116225,
            2116321,
            2150658,
            2150722,
            2200225,
            6291456
        ]),
        new Uint32Array([
            2168321,
            6291456,
            2168353,
            6291456,
            2168385,
            6291456,
            2168417,
            6291456,
            2168449,
            6291456,
            2168481,
            6291456,
            2168513,
            6291456,
            2168545,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            0,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            2186625,
            0,
            0,
            6291456,
            6291456,
            2186657,
            2186689,
            2186721,
            2173505,
            0,
            10496067,
            10496163,
            10496259
        ]),
        new Uint32Array([
            2178785,
            6291456,
            2178817,
            6291456,
            2178849,
            6291456,
            2178881,
            6291456,
            2178913,
            6291456,
            2178945,
            6291456,
            2178977,
            6291456,
            2179009,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2097152,
            0,
            0,
            0,
            2097152,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            2197857,
            2197889,
            2197921,
            2197953,
            2197985,
            2198017,
            0,
            0,
            2198049,
            2198081,
            2198113,
            2198145,
            2198177,
            2198209
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2098209,
            2167297,
            2111137,
            6291456
        ]),
        new Uint32Array([
            2171393,
            6291456,
            2171425,
            6291456,
            2171457,
            6291456,
            2171489,
            6291456,
            2171521,
            6291456,
            2171553,
            6291456,
            2171585,
            6291456,
            2171617,
            6291456
        ]),
        new Uint32Array([
            2206753,
            2206785,
            2195457,
            2206817,
            2206849,
            2206881,
            2206913,
            2197153,
            2197153,
            2206945,
            2117857,
            2206977,
            2207009,
            2207041,
            2207073,
            2207105
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            0,
            0,
            0,
            0,
            2144834,
            2144898,
            0,
            2144962
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            23068672
        ]),
        new Uint32Array([
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            0,
            2105505,
            2098241
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2202049,
            6291456,
            2202081,
            6291456,
            2202113,
            6291456,
            2202145,
            6291456,
            2202177,
            6291456,
            2202209,
            6291456,
            2202241,
            6291456
        ]),
        new Uint32Array([
            10501155,
            10501251,
            10501347,
            10501443,
            10501539,
            10501635,
            10501731,
            10501827,
            10501923,
            10502019,
            2141731,
            2105505,
            2098177,
            2155586,
            2166530,
            0
        ]),
        new Uint32Array([
            2102081,
            2102209,
            2100833,
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            2100833,
            2100737,
            2098337,
            2101441
        ]),
        new Uint32Array([
            2146882,
            2146946,
            2147010,
            2147074,
            2147138,
            2147202,
            2147266,
            2147330,
            2146882,
            2146946,
            2147010,
            2147074,
            2147138,
            2147202,
            2147266,
            2147330
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            10502307,
            10502403,
            10502499,
            10502595,
            10502691,
            10502787,
            10502883,
            10502979,
            10503075,
            10503171,
            10503267,
            10503363,
            10503459,
            10503555,
            10503651,
            10503747
        ]),
        new Uint32Array([
            2179937,
            2179969,
            2180001,
            2180033,
            2156545,
            2180065,
            2156577,
            2180097,
            2180129,
            2180161,
            2180193,
            2180225,
            2180257,
            2180289,
            2156737,
            2180321
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0
        ]),
        new Uint32Array([
            2227682,
            2227746,
            2227810,
            2227874,
            2227938,
            2228002,
            2228066,
            2228130,
            2228194,
            2228258,
            2228322,
            2228386,
            2228450,
            2228514,
            2228578,
            2228642
        ]),
        new Uint32Array([
            2105601,
            2169121,
            2108193,
            2170049,
            2181025,
            2181057,
            2112481,
            2108321,
            2108289,
            2181089,
            2170497,
            2100865,
            2181121,
            2173601,
            2173633,
            2173665
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2180641,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            6291456,
            0,
            0,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2178273,
            6291456,
            2178305,
            6291456,
            2178337,
            6291456,
            2178369,
            6291456,
            2178401,
            6291456,
            2178433,
            6291456,
            2178465,
            6291456,
            2178497,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456
        ]),
        new Uint32Array([
            2237377,
            2237409,
            2236225,
            2237441,
            2237473,
            2217441,
            2215521,
            2215553,
            2217473,
            2237505,
            2237537,
            2209697,
            2237569,
            2215585,
            2237601,
            2237633
        ]),
        new Uint32Array([
            2221985,
            2165601,
            2165601,
            2165665,
            2165665,
            2222017,
            2222017,
            2165729,
            2165729,
            2158913,
            2158913,
            2158913,
            2158913,
            2097281,
            2097281,
            2105921
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2149634,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2176897,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            2176929,
            6291456,
            2176961,
            6291456,
            2176993,
            6291456
        ]),
        new Uint32Array([
            2172641,
            6291456,
            2172673,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2172705,
            2172737,
            6291456,
            2172769,
            2172801,
            6291456
        ]),
        new Uint32Array([
            2099173,
            2104196,
            2121667,
            2099395,
            2121763,
            2152258,
            2152322,
            2098946,
            2152386,
            2121859,
            2121955,
            2099333,
            2122051,
            2104324,
            2099493,
            2122147
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            2145794,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            2145858,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            0,
            0,
            6291456,
            0
        ]),
        new Uint32Array([
            0,
            2105921,
            2097729,
            0,
            2097377,
            0,
            0,
            2106017,
            0,
            2097505,
            2105889,
            2097185,
            2097697,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2239074,
            2239138,
            2239201,
            2239233,
            2239265,
            2239297,
            2239329,
            2239361,
            0,
            2239393,
            2239425,
            2239425,
            2239458,
            2239521,
            2239553,
            2209569
        ]),
        new Uint32Array([
            14680064,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            23068672
        ]),
        new Uint32Array([
            2108321,
            2108289,
            2113153,
            2098209,
            2180897,
            2180929,
            2180961,
            2111137,
            2098241,
            2108353,
            2170241,
            2170273,
            2180993,
            2105825,
            6291456,
            2105473
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2146114,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2105921,
            2105921,
            2105921,
            2222049,
            2222049,
            2130977,
            2130977,
            2130977,
            2130977,
            2160065,
            2160065,
            2160065,
            2160065,
            2097729,
            2097729,
            2097729
        ]),
        new Uint32Array([
            2218145,
            2214785,
            2207937,
            2218177,
            2218209,
            2192993,
            2210113,
            2212769,
            2218241,
            2218273,
            2216129,
            2218305,
            2216161,
            2218337,
            2218369,
            2218401
        ]),
        new Uint32Array([
            0,
            0,
            0,
            2156546,
            2156610,
            2156674,
            2156738,
            2156802,
            0,
            0,
            0,
            0,
            0,
            2156866,
            23068672,
            2156930
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2213409,
            2213441,
            2213473,
            2213505,
            2213537,
            2213569,
            2213601,
            2213633,
            2213665,
            2195681,
            2213697,
            2213729,
            2213761,
            2213793,
            2213825,
            2213857
        ]),
        new Uint32Array([
            2100033,
            2099233,
            2122017,
            2200673,
            2098113,
            2121537,
            2103201,
            2200705,
            2104033,
            2121857,
            2121953,
            2122401,
            2099649,
            2099969,
            2123009,
            2100129
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2201857,
            6291456,
            2201889,
            6291456,
            2201921,
            6291456,
            2201953,
            6291456,
            2201985,
            6291456,
            2202017,
            6291456,
            2176193,
            2176257,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2188193,
            2188225,
            2188257,
            2188289,
            2188321,
            2188353,
            2188385,
            2188417,
            2188449,
            2188481,
            2188513,
            2188545,
            2188577,
            2188609,
            2188641,
            0
        ]),
        new Uint32Array([
            10554529,
            2221089,
            0,
            10502113,
            10562017,
            10537921,
            10538049,
            2221121,
            2221153,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2213889,
            2213921,
            2213953,
            2213985,
            2214017,
            2214049,
            2214081,
            2194177,
            2214113,
            2214145,
            2214177,
            2214209,
            2214241,
            2214273,
            2214305,
            2214337
        ]),
        new Uint32Array([
            2166978,
            2167042,
            2099169,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2180545,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            10518915,
            10519011,
            10519107,
            10519203,
            2162242,
            2162306,
            2159554,
            2162370,
            2159362,
            2159618,
            2105922,
            2162434,
            2159746,
            2162498,
            2159810,
            2159874
        ]),
        new Uint32Array([
            2161730,
            2161794,
            2135586,
            2161858,
            2161922,
            2137186,
            2131810,
            2160290,
            2135170,
            2161986,
            2137954,
            2162050,
            2162114,
            2162178,
            10518723,
            10518819
        ]),
        new Uint32Array([
            10506627,
            10506723,
            10506819,
            10506915,
            10507011,
            10507107,
            10507203,
            10507299,
            10507395,
            10507491,
            10507587,
            10507683,
            10507779,
            10507875,
            10507971,
            10508067
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2175873,
            2175905,
            2175937,
            2175969,
            2176001,
            2176033,
            2176065,
            2176097,
            2176129,
            2176161,
            2176193,
            2176225,
            2176257,
            2176289,
            2176321,
            2176353
        ]),
        new Uint32Array([
            2140006,
            2140198,
            2140390,
            2140582,
            2140774,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241
        ]),
        new Uint32Array([
            0,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2145154,
            2145218,
            2145282,
            6291456,
            0,
            2145346,
            0
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            10531458,
            10495395,
            2148545,
            2143201,
            2173473,
            2148865,
            2173505,
            0,
            2173537,
            0,
            2173569,
            2149121
        ]),
        new Uint32Array([
            10537282,
            10495683,
            2148738,
            2148802,
            2148866,
            0,
            6291456,
            2148930,
            2186593,
            2173473,
            2148737,
            2148865,
            2148802,
            10495779,
            10495875,
            10495971
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2215425,
            2215457,
            2215489,
            2215521,
            2215553,
            2215585,
            2215617,
            2215649,
            2215681,
            2215713,
            2215745,
            2215777,
            2192033,
            2215809,
            2215841,
            2215873
        ]),
        new Uint32Array([
            2242049,
            2242081,
            2242113,
            2242145,
            2242177,
            2242209,
            2242241,
            2242273,
            2215937,
            2242305,
            2242338,
            2242401,
            2242433,
            2242465,
            2242497,
            2216001
        ]),
        new Uint32Array([
            10554529,
            2221089,
            0,
            0,
            10562017,
            10502113,
            10538049,
            10537921,
            2221185,
            10489601,
            10489697,
            10609889,
            10609921,
            2141729,
            2141793,
            10610273
        ]),
        new Uint32Array([
            2141923,
            2142019,
            2142115,
            2142211,
            2142307,
            2142403,
            2142499,
            2142595,
            2142691,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            0,
            2221185,
            2221217,
            10609857,
            10609857,
            10489601,
            10489697,
            10609889,
            10609921,
            2141729,
            2141793,
            2221345,
            2221377,
            2221409,
            2221441,
            2187105
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            18923970,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2183105,
            6291456,
            2183137,
            6291456,
            2183169,
            6291456,
            2183201,
            6291456,
            2183233,
            6291456,
            2183265,
            6291456,
            2183297,
            6291456,
            2183329,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2134434,
            2134818,
            2097666,
            2097186,
            2097474,
            2097698,
            2105986,
            2131586,
            2132450,
            2131874,
            2131778,
            2135970,
            2135778,
            2161602,
            2136162,
            2161666
        ]),
        new Uint32Array([
            2236865,
            2236897,
            2236930,
            2236993,
            2237025,
            2235681,
            2237058,
            2237121,
            2237153,
            2237185,
            2237217,
            2217281,
            2237250,
            2191233,
            2237313,
            2237345
        ]),
        new Uint32Array([
            2190049,
            6291456,
            2190081,
            6291456,
            2190113,
            6291456,
            2190145,
            6291456,
            2190177,
            6291456,
            2190209,
            6291456,
            2190241,
            6291456,
            2190273,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2101922,
            2102050,
            2102178,
            2102306,
            10498755,
            10498851,
            10498947,
            10499043,
            10499139,
            10499235,
            10499331,
            10499427,
            10499523,
            10489604,
            10489732,
            10489860
        ]),
        new Uint32Array([
            2166914,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2181601,
            2170561,
            2181633,
            2181665,
            2170753,
            2181697,
            2172897,
            2170881,
            2181729,
            2170913,
            2172929,
            2113441,
            2181761,
            2181793,
            2171009,
            2173761
        ]),
        new Uint32Array([
            0,
            2105921,
            2097729,
            2106081,
            0,
            2097601,
            2162337,
            2106017,
            2133281,
            2097505,
            0,
            2097185,
            2097697,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2248001,
            2248033,
            2248066,
            2248130,
            2248193,
            2248226,
            2248289,
            2248322,
            2248385,
            2248417,
            2216673,
            2248450,
            2248514,
            2248577,
            2248610,
            2248673
        ]),
        new Uint32Array([
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2169729,
            6291456,
            2169761,
            6291456,
            2169793,
            6291456,
            2169825,
            6291456,
            2169857,
            2169889,
            6291456,
            2169921,
            6291456,
            2143329,
            6291456,
            2098305
        ]),
        new Uint32Array([
            2162178,
            2163202,
            2163266,
            2135170,
            2136226,
            2161986,
            2137954,
            2159426,
            2159490,
            2163330,
            2159554,
            2163394,
            2159682,
            2139522,
            2136450,
            2159746
        ]),
        new Uint32Array([
            2173953,
            2173985,
            0,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2174209,
            2174241,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            4271169,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2174273
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            2190785,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2189793,
            6291456,
            2189825,
            6291456,
            2189857,
            6291456,
            2189889,
            6291456,
            2189921,
            6291456,
            2189953,
            6291456,
            2189985,
            6291456,
            2190017,
            6291456
        ]),
        new Uint32Array([
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            0,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            0,
            2098209,
            2111137
        ]),
        new Uint32Array([
            2172129,
            6291456,
            2172161,
            6291456,
            2172193,
            6291456,
            2172225,
            6291456,
            2172257,
            6291456,
            2172289,
            6291456,
            2172321,
            6291456,
            2172353,
            6291456
        ]),
        new Uint32Array([
            2214753,
            6291456,
            2214785,
            6291456,
            6291456,
            2214817,
            2214849,
            2214881,
            2214913,
            2214945,
            2214977,
            2215009,
            2215041,
            2215073,
            2194401,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            10610305,
            10610337,
            10575617,
            2221761,
            10610401,
            10610433,
            10502177,
            0,
            10610465,
            10610497,
            10610529,
            10610561,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            23068672,
            0,
            0,
            0,
            0,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2187105,
            2187137,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2199393,
            2199425,
            2199457,
            2199489,
            2199521,
            2199553,
            2199585,
            2199617,
            2199649,
            2199681,
            2199713,
            2199745,
            2199777,
            2199809,
            2199841,
            0
        ]),
        new Uint32Array([
            2217249,
            2217281,
            2217313,
            2217345,
            2217377,
            2217409,
            2217441,
            2217473,
            2215617,
            2217505,
            2217537,
            2217569,
            2214753,
            2217601,
            2217633,
            2217665
        ]),
        new Uint32Array([
            2170273,
            2170305,
            6291456,
            2170337,
            2170369,
            6291456,
            2170401,
            2170433,
            2170465,
            6291456,
            6291456,
            6291456,
            2170497,
            2170529,
            6291456,
            2170561
        ]),
        new Uint32Array([
            2188673,
            6291456,
            2188705,
            2188737,
            2188769,
            6291456,
            6291456,
            2188801,
            6291456,
            2188833,
            6291456,
            2188865,
            6291456,
            2180929,
            2181505,
            2180897
        ]),
        new Uint32Array([
            10489988,
            10490116,
            10490244,
            10490372,
            10490500,
            10490628,
            10490756,
            10490884,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2147393,
            2147457,
            2147521,
            2147585,
            2147649,
            2147713,
            2147777,
            2147841
        ]),
        new Uint32Array([
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2241153,
            2241185,
            2241217,
            2215809,
            2241250,
            2241313,
            2241345,
            2241377,
            2217921,
            2241377,
            2241409,
            2215873,
            2241441,
            2241473,
            2241505,
            2241537
        ]),
        new Uint32Array([
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2220417,
            2220417,
            2220449,
            2220449,
            2220481,
            2220481,
            2220513,
            2220513,
            2220545,
            2220545,
            2220577,
            2220577,
            2220609,
            2220609,
            2220641,
            2220641
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2144002,
            0,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2167105,
            2167137,
            2167169,
            2167201,
            2167233,
            2167265,
            2167297,
            2167329,
            2167361,
            2167393,
            2167425,
            2167457,
            2167489,
            2167521,
            2167553,
            2167585
        ]),
        new Uint32Array([
            10575521,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193
        ]),
        new Uint32Array([
            2234146,
            2234210,
            2234274,
            2234338,
            2234402,
            2234466,
            2234530,
            2234594,
            2234658,
            2234722,
            2234786,
            2234850,
            2234914,
            2234978,
            2235042,
            2235106
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2180577,
            0,
            0,
            0,
            0,
            0,
            2180609,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2242529,
            2242561,
            2242593,
            2242625,
            2242657,
            2242689,
            2242721,
            2242753,
            2207937,
            2218177,
            2242785,
            2242817,
            2242849,
            2242882,
            2242945,
            2242977
        ]),
        new Uint32Array([
            2118049,
            2105345,
            2118241,
            2105441,
            2118433,
            2118529,
            2118625,
            2118721,
            2118817,
            2200257,
            2200289,
            2191809,
            2200321,
            2200353,
            2200385,
            2200417
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2185505,
            6291456,
            2185537,
            6291456,
            2185569,
            6291456,
            2185601,
            6291456,
            2185633,
            6291456,
            2185665,
            6291456,
            2185697,
            6291456,
            2185729,
            6291456
        ]),
        new Uint32Array([
            2231970,
            2232034,
            2232098,
            2232162,
            2232226,
            2232290,
            2232354,
            2232418,
            2232482,
            2232546,
            2232610,
            2232674,
            2232738,
            2232802,
            2232866,
            2232930
        ]),
        new Uint32Array([
            2218625,
            2246402,
            2246466,
            2246530,
            2246594,
            2246657,
            2246689,
            2246689,
            2218657,
            2219681,
            2246721,
            2246753,
            2246785,
            2246818,
            2246881,
            2208481
        ]),
        new Uint32Array([
            2197025,
            2197057,
            2197089,
            2197121,
            2197153,
            2197185,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2219137,
            2216961,
            2219169,
            2219201,
            2219233,
            2219265,
            2219297,
            2217025,
            2215041,
            2219329,
            2217057,
            2219361,
            2217089,
            2219393,
            2197153,
            2219426
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713
        ]),
        new Uint32Array([
            2243522,
            2243585,
            2243617,
            2243649,
            2243681,
            2210113,
            2243713,
            2243746,
            2243810,
            2243874,
            2243937,
            2243970,
            2244033,
            2244065,
            2244097,
            2244129
        ]),
        new Uint32Array([
            2178017,
            6291456,
            2178049,
            6291456,
            2178081,
            6291456,
            2178113,
            6291456,
            2178145,
            6291456,
            2178177,
            6291456,
            2178209,
            6291456,
            2178241,
            6291456
        ]),
        new Uint32Array([
            10553858,
            2165314,
            10518722,
            6291456,
            10518818,
            0,
            10518914,
            2130690,
            10519010,
            2130786,
            10519106,
            2130882,
            10519202,
            2165378,
            10554050,
            2165506
        ]),
        new Uint32Array([
            0,
            0,
            2135491,
            2135587,
            2135683,
            2135779,
            2135875,
            2135971,
            2135971,
            2136067,
            2136163,
            2136259,
            2136355,
            2136355,
            2136451,
            2136547
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2220033,
            2220033,
            2220065,
            2220065,
            2220065,
            2220065,
            2220097,
            2220097,
            2220097,
            2220097,
            2220129,
            2220129,
            2220129,
            2220129,
            2220161,
            2220161
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2100897,
            2100898,
            2100899,
            2150018,
            2100865,
            2100866,
            2100867,
            2100868,
            2150082,
            2108481,
            2109858,
            2109859,
            2105569,
            2105505,
            2098241,
            2105601
        ]),
        new Uint32Array([
            2097217,
            2097505,
            2097505,
            2097505,
            2097505,
            2165570,
            2165570,
            2165634,
            2165634,
            2165698,
            2165698,
            2097858,
            2097858,
            0,
            0,
            2097152
        ]),
        new Uint32Array([
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            10503843,
            10503939,
            10504035,
            10504131,
            10504227,
            10504323,
            10504419,
            10504515,
            10504611,
            10504707,
            10504803,
            10504899,
            10504995,
            10491140,
            10491268,
            0
        ]),
        new Uint32Array([
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2173761,
            2174017,
            2174049
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2134145,
            2097153,
            2134241,
            2105953,
            2132705,
            2130977,
            2160065,
            2131297,
            2162049,
            2133089,
            2160577,
            2133857,
            2235297,
            2220769,
            2235329,
            2235361
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2222401,
            2222433,
            2222465,
            10531394,
            2222497,
            2222529,
            2222561,
            0,
            2222593,
            2222625,
            2222657,
            2222689,
            2222721,
            2222753,
            2222785,
            0
        ]),
        new Uint32Array([
            2184481,
            6291456,
            2184513,
            6291456,
            2184545,
            6291456,
            2184577,
            6291456,
            2184609,
            6291456,
            2184641,
            6291456,
            2184673,
            6291456,
            2184705,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2105570,
            2156034,
            2126947,
            2156098,
            2153666,
            2127043,
            2127139,
            2156162,
            0,
            2127235,
            2156226,
            2156290,
            2156354,
            2156418,
            2127331,
            2127427
        ]),
        new Uint32Array([
            2215905,
            2207041,
            2153185,
            2241569,
            2241601,
            2241633,
            2241665,
            2241697,
            2241730,
            2241793,
            2241825,
            2241857,
            2241889,
            2241921,
            2241954,
            2242017
        ]),
        new Uint32Array([
            2203777,
            6291456,
            2203809,
            6291456,
            2203841,
            6291456,
            2203873,
            6291456,
            2203905,
            6291456,
            2173121,
            2180993,
            2181249,
            2203937,
            2181313,
            0
        ]),
        new Uint32Array([
            2168577,
            6291456,
            2168609,
            6291456,
            2168641,
            6291456,
            2168673,
            6291456,
            2168705,
            6291456,
            2168737,
            6291456,
            2168769,
            6291456,
            2168801,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            23068672,
            23068672,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2210113,
            2195521,
            2210145,
            2210177,
            2210209,
            2210241,
            2210273,
            2210305,
            2210337,
            2210369,
            2210401,
            2210433,
            2210465,
            2210497,
            2210529,
            2210561
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0
        ]),
        new Uint32Array([
            2228706,
            2228770,
            2228834,
            2228898,
            2228962,
            2229026,
            2229090,
            2229154,
            2229218,
            2229282,
            2229346,
            2229410,
            2229474,
            2229538,
            2229602,
            2229666
        ]),
        new Uint32Array([
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            18874368,
            18874368,
            18874368,
            0,
            0
        ]),
        new Uint32Array([
            2133089,
            2133281,
            2133281,
            2133281,
            2133281,
            2160577,
            2160577,
            2160577,
            2160577,
            2097441,
            2097441,
            2097441,
            2097441,
            2133857,
            2133857,
            2133857
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2174017,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233089
        ]),
        new Uint32Array([
            2178529,
            6291456,
            2178561,
            6291456,
            2178593,
            6291456,
            2178625,
            6291456,
            2178657,
            6291456,
            2178689,
            6291456,
            2178721,
            6291456,
            2178753,
            6291456
        ]),
        new Uint32Array([
            2221025,
            2221025,
            2221057,
            2221057,
            2159329,
            2159329,
            2159329,
            2159329,
            2097217,
            2097217,
            2158914,
            2158914,
            2158978,
            2158978,
            2159042,
            2159042
        ]),
        new Uint32Array([
            2208161,
            2208193,
            2208225,
            2208257,
            2194433,
            2208289,
            2208321,
            2208353,
            2208385,
            2208417,
            2208449,
            2208481,
            2208513,
            2208545,
            2208577,
            2208609
        ]),
        new Uint32Array([
            2169217,
            6291456,
            2169249,
            6291456,
            2169281,
            6291456,
            2169313,
            6291456,
            2169345,
            6291456,
            2169377,
            6291456,
            2169409,
            6291456,
            2169441,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2133187,
            2133283,
            2133283,
            2133379,
            2133475,
            2133571,
            2133667,
            2133667,
            2133763,
            2133859,
            2133955,
            2134051,
            2134147,
            2134147,
            2134243,
            2134339
        ]),
        new Uint32Array([
            2197697,
            2114113,
            2114209,
            2197729,
            2197761,
            2114305,
            2197793,
            2114401,
            2114497,
            2197825,
            2114593,
            2114689,
            2114785,
            2114881,
            2114977,
            0
        ]),
        new Uint32Array([
            2193089,
            2193121,
            2193153,
            2193185,
            2117665,
            2117569,
            2193217,
            2193249,
            2193281,
            2193313,
            2193345,
            2193377,
            2193409,
            2193441,
            2193473,
            2193505
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2184225,
            6291456,
            2184257,
            6291456,
            2184289,
            6291456,
            2184321,
            6291456,
            2184353,
            6291456,
            2184385,
            6291456,
            2184417,
            6291456,
            2184449,
            6291456
        ]),
        new Uint32Array([
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2100833,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2098657,
            2098049,
            2200737,
            2123489,
            2123681,
            2200769,
            2098625,
            2100321,
            2098145,
            2100449,
            2098017,
            2098753,
            2200801,
            2200833,
            2200865,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            0,
            2098241,
            2108353,
            2108417,
            2105825,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2181153,
            2105505,
            2181185,
            2167617,
            2180993
        ]),
        new Uint32Array([
            2160002,
            2160066,
            2160130,
            2160194,
            2160258,
            2132066,
            2131010,
            2131106,
            2106018,
            2131618,
            2160322,
            2131298,
            2132034,
            2131938,
            2137410,
            2132226
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2183617,
            6291456,
            2183649,
            6291456,
            2183681,
            6291456,
            2183713,
            6291456,
            2183745,
            6291456,
            2183777,
            6291456,
            2183809,
            6291456,
            2183841,
            6291456
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            0,
            6291456,
            0,
            0,
            6291456,
            6291456,
            0,
            6291456,
            0,
            0,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2250977,
            2251009,
            2251041,
            2251073,
            2195009,
            2251106,
            2251169,
            2251201,
            2251233,
            2251265,
            2251297,
            2251330,
            2251394,
            2251457,
            2251489,
            2251521
        ]),
        new Uint32Array([
            2205729,
            2205761,
            2205793,
            2205825,
            2205857,
            2205889,
            2205921,
            2205953,
            2205985,
            2206017,
            2206049,
            2206081,
            2206113,
            2206145,
            2206177,
            2206209
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2143170,
            2168993,
            6291456,
            2169025,
            6291456,
            2169057,
            6291456,
            2169089,
            6291456,
            2143234,
            2169121,
            6291456,
            2169153,
            6291456,
            2169185,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            2190689,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2248706,
            2248769,
            2248801,
            2248833,
            2248865,
            2248897,
            2248929,
            2248962,
            2249026,
            2249090,
            2249154,
            2240705,
            2249217,
            2249249,
            2249281,
            2249313
        ]),
        new Uint32Array([
            10485857,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            10495394,
            6291456,
            2098209,
            6291456,
            6291456,
            2097152,
            6291456,
            10531394
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0
        ]),
        new Uint32Array([
            14680064,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2173985,
            2173953,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889
        ]),
        new Uint32Array([
            6291456,
            2186977,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            10537858,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2209601,
            2209633,
            2209665,
            2209697,
            2209729,
            2209761,
            2209793,
            2209825,
            2209857,
            2209889,
            2209921,
            2209953,
            2209985,
            2210017,
            2210049,
            2210081
        ]),
        new Uint32Array([
            10501539,
            10501635,
            10501731,
            10501827,
            10501923,
            10502019,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905
        ]),
        new Uint32Array([
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2174017,
            2174017,
            2174049
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2194561,
            2194593,
            2194625,
            2119777,
            2119873,
            2194657,
            2194689,
            2194721,
            2194753,
            2194785,
            2194817,
            2194849,
            2194881,
            2194913,
            2194945,
            2194977
        ]),
        new Uint32Array([
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569
        ]),
        new Uint32Array([
            2222818,
            2222882,
            2222946,
            2223010,
            2223074,
            2223138,
            2223202,
            2223266,
            2223330,
            2223394,
            2223458,
            2223522,
            2223586,
            2223650,
            2223714,
            2223778
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672
        ]),
        new Uint32Array([
            0,
            2179553,
            2179585,
            2179617,
            2179649,
            2144001,
            2179681,
            2179713,
            2179745,
            2179777,
            2179809,
            2156705,
            2179841,
            2156833,
            2179873,
            2179905
        ]),
        new Uint32Array([
            6291456,
            23068672,
            6291456,
            2145602,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2196513,
            2196545,
            2196577,
            2196609,
            2196641,
            2196673,
            2196705,
            2196737,
            2196769,
            2196801,
            2196833,
            2196865,
            2196897,
            2196929,
            2196961,
            2196993
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2177281,
            6291456,
            2177313,
            6291456,
            2177345,
            6291456,
            2177377,
            6291456,
            2177409,
            6291456,
            2177441,
            6291456,
            2177473,
            6291456,
            2177505,
            6291456
        ]),
        new Uint32Array([
            2187137,
            2221473,
            2221505,
            2221537,
            2221569,
            6291456,
            6291456,
            10610209,
            10610241,
            10537986,
            10537986,
            10537986,
            10537986,
            10609857,
            10609857,
            10609857
        ]),
        new Uint32Array([
            2243009,
            2243041,
            2216033,
            2243074,
            2243137,
            2243169,
            2243201,
            2219617,
            2243233,
            2243265,
            2243297,
            2243329,
            2243362,
            2243425,
            2243457,
            2243489
        ]),
        new Uint32Array([
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            2097152,
            4194304,
            4194304,
            0,
            0
        ]),
        new Uint32Array([
            2143042,
            6291456,
            2143106,
            2143106,
            2168833,
            6291456,
            2168865,
            6291456,
            6291456,
            2168897,
            6291456,
            2168929,
            6291456,
            2168961,
            6291456,
            2143170
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2204193,
            2204225,
            2204257,
            2204289,
            2204321,
            2204353,
            2204385,
            2204417,
            2204449,
            2204481,
            2204513,
            2204545,
            2204577,
            2204609,
            2204641,
            2204673
        ]),
        new Uint32Array([
            2202753,
            6291456,
            2202785,
            6291456,
            2202817,
            6291456,
            2202849,
            6291456,
            2202881,
            6291456,
            2202913,
            6291456,
            2202945,
            6291456,
            2202977,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321
        ]),
        new Uint32Array([
            2147394,
            2147458,
            2147522,
            2147586,
            2147650,
            2147714,
            2147778,
            2147842,
            2147394,
            2147458,
            2147522,
            2147586,
            2147650,
            2147714,
            2147778,
            2147842
        ]),
        new Uint32Array([
            2253313,
            2253346,
            2253409,
            2253441,
            2253473,
            2253505,
            2253537,
            2253569,
            2253601,
            2253634,
            2219393,
            2253697,
            2253729,
            2253761,
            2253793,
            2253825
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2162562,
            2162626,
            2131362,
            2162690,
            2159938,
            2160002,
            2162754,
            2162818,
            2160130,
            2162882,
            2160194,
            2160258,
            2160834,
            2160898,
            2161026,
            2161090
        ]),
        new Uint32Array([
            2175361,
            2175393,
            2175425,
            2175457,
            2175489,
            2175521,
            2175553,
            2175585,
            2175617,
            2175649,
            2175681,
            2175713,
            2175745,
            2175777,
            2175809,
            2175841
        ]),
        new Uint32Array([
            2253858,
            2253921,
            2253954,
            2254018,
            2254082,
            2196737,
            2254145,
            2196865,
            2254177,
            2254209,
            2254241,
            2254273,
            2197025,
            2254306,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2202113,
            2204129,
            2188705,
            2204161
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2173985,
            2174017,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233089,
            2173697,
            2173761,
            2173793,
            2174113,
            2173985,
            2173953
        ]),
        new Uint32Array([
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            2100833,
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209
        ]),
        new Uint32Array([
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            0,
            2108417,
            0,
            2111713,
            2100897,
            2111905
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2175425,
            2175489,
            2175809,
            2175905,
            2175937,
            2175937,
            2176193,
            2176417,
            2180865,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            2143298,
            2143298,
            2143298,
            2143362,
            2143362,
            2143362,
            2143426,
            2143426,
            2143426,
            2171105,
            6291456,
            2171137
        ]),
        new Uint32Array([
            2120162,
            2120258,
            2151618,
            2151682,
            2151746,
            2151810,
            2151874,
            2151938,
            2152002,
            2120035,
            2120131,
            2120227,
            2152066,
            2120323,
            2152130,
            2120419
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2195361,
            2142433,
            2236065,
            2236097,
            2236129,
            2236161,
            2118241,
            2117473,
            2236193,
            2236225,
            2236257,
            2236289,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2189281,
            6291456,
            2189313,
            6291456,
            2189345,
            6291456,
            2189377,
            6291456,
            2189409,
            6291456,
            2189441,
            6291456,
            2189473,
            6291456,
            2189505,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2145922,
            6291456,
            6291456,
            6291456,
            6291456,
            2145986,
            6291456,
            6291456,
            6291456,
            6291456,
            2146050,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2100833,
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            10502113,
            10562017,
            10610401,
            10502177,
            10610433,
            10538049
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            2186401,
            0,
            2186433,
            0,
            2186465,
            0,
            2186497
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            0,
            0,
            2198241,
            2198273,
            2198305,
            2198337,
            2198369,
            2198401,
            0,
            0,
            2198433,
            2198465,
            2198497,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            23068672,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            0,
            2105921,
            2097729,
            0,
            2097377,
            0,
            0,
            2106017,
            2133281,
            2097505,
            2105889,
            0,
            2097697,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            2197889,
            2197921,
            2197953,
            2197985,
            2198017,
            2198049,
            2198081,
            2198113,
            2198145,
            2198177,
            2198209,
            2198241,
            2198273,
            2198305,
            2198337,
            2198369
        ]),
        new Uint32Array([
            2132514,
            2132610,
            2160386,
            2133090,
            2133186,
            2160450,
            2160514,
            2133282,
            2160578,
            2133570,
            2106178,
            2160642,
            2133858,
            2160706,
            2160770,
            2134146
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            6291456,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2184737,
            6291456,
            2184769,
            6291456,
            2184801,
            6291456,
            2184833,
            6291456,
            2184865,
            6291456,
            2184897,
            6291456,
            2184929,
            6291456,
            2184961,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            2186753,
            6291456,
            6291456,
            6291456,
            6291456,
            2186785,
            2186817,
            2186849,
            2173569,
            2186881,
            10496355,
            10495395,
            10575521
        ]),
        new Uint32Array([
            0,
            0,
            2097729,
            0,
            0,
            0,
            0,
            2106017,
            0,
            2097505,
            0,
            2097185,
            0,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            2189537,
            6291456,
            2189569,
            6291456,
            2189601,
            6291456,
            2189633,
            6291456,
            2189665,
            6291456,
            2189697,
            6291456,
            2189729,
            6291456,
            2189761,
            6291456
        ]),
        new Uint32Array([
            2202497,
            6291456,
            2202529,
            6291456,
            2202561,
            6291456,
            2202593,
            6291456,
            2202625,
            6291456,
            2202657,
            6291456,
            2202689,
            6291456,
            2202721,
            6291456
        ]),
        new Uint32Array([
            2245217,
            2218369,
            2245249,
            2245282,
            2245345,
            2245377,
            2245410,
            2245474,
            2245537,
            2245569,
            2245601,
            2245633,
            2245665,
            2245665,
            2245697,
            2245729
        ]),
        new Uint32Array([
            6291456,
            0,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            23068672,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2097281,
            2105921,
            2097729,
            2106081,
            2097377,
            2097601,
            2162337,
            2106017,
            2133281,
            2097505,
            0,
            2097185,
            2097697,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            2176641,
            6291456,
            2176673,
            6291456,
            2176705,
            6291456,
            2176737,
            6291456,
            2176769,
            6291456,
            2176801,
            6291456,
            2176833,
            6291456,
            2176865,
            6291456
        ]),
        new Uint32Array([
            2174145,
            2174177,
            2149057,
            2233089,
            2173697,
            2173761,
            2173793,
            2174113,
            2173985,
            2173953,
            2174369,
            2174369,
            0,
            0,
            2100833,
            2100737
        ]),
        new Uint32Array([
            2116513,
            2190817,
            2190849,
            2190881,
            2190913,
            2190945,
            2116609,
            2190977,
            2191009,
            2191041,
            2191073,
            2117185,
            2191105,
            2191137,
            2191169,
            2191201
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456
        ]),
        new Uint32Array([
            2167617,
            2167649,
            2167681,
            2167713,
            2167745,
            2167777,
            2167809,
            6291456,
            2167841,
            2167873,
            2167905,
            2167937,
            2167969,
            2168001,
            2168033,
            4240130
        ]),
        new Uint32Array([
            2165122,
            2163970,
            2164034,
            2164098,
            2164162,
            2164226,
            2164290,
            2164354,
            2164418,
            2164482,
            2164546,
            2133122,
            2134562,
            2132162,
            2132834,
            2136866
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            2186209,
            2186241,
            2186273,
            2186305,
            2186337,
            2186369,
            0,
            0
        ]),
        new Uint32Array([
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064
        ]),
        new Uint32Array([
            0,
            0,
            23068672,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            10537921,
            10610689,
            10610273,
            10610497,
            10610529,
            10610305,
            10610721,
            10489601,
            10489697,
            10610337,
            10575617,
            10554529,
            2221761,
            2197217,
            10496577
        ]),
        new Uint32Array([
            2105473,
            2105569,
            2105601,
            2112289,
            0,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441
        ]),
        new Uint32Array([
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481
        ]),
        new Uint32Array([
            2125346,
            2153410,
            2153474,
            2127394,
            2153538,
            2153602,
            2153666,
            2153730,
            2105507,
            2105476,
            2153794,
            2153858,
            2153922,
            2153986,
            2154050,
            2105794
        ]),
        new Uint32Array([
            2200449,
            2119681,
            2200481,
            2153313,
            2199873,
            2199905,
            2199937,
            2200513,
            2200545,
            2200577,
            2200609,
            2119105,
            2119201,
            2119297,
            2119393,
            2119489
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2175777,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2222273,
            2197217,
            2221473,
            2221505,
            2221089,
            2222305,
            2200865,
            2099681,
            2104481,
            2222337,
            2099905,
            2120737,
            2222369,
            2103713,
            2100225,
            2098785
        ]),
        new Uint32Array([
            2201377,
            6291456,
            2201409,
            6291456,
            2201441,
            6291456,
            2201473,
            6291456,
            2201505,
            6291456,
            2201537,
            6291456,
            2201569,
            6291456,
            6291456,
            23068672
        ]),
        new Uint32Array([
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233057,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793
        ]),
        new Uint32Array([
            2200897,
            6291456,
            2200929,
            6291456,
            2200961,
            6291456,
            2200993,
            6291456,
            2201025,
            6291456,
            2180865,
            6291456,
            2201057,
            6291456,
            2201089,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2161154,
            2161410,
            2138658,
            2161474,
            2161538,
            2097666,
            2097186,
            2097474,
            2162946,
            2132450,
            2163010,
            2163074,
            2136162,
            2163138,
            2161666,
            2161730
        ]),
        new Uint32Array([
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            2145410,
            2145474,
            0,
            6291456
        ]),
        new Uint32Array([
            2244161,
            2216065,
            2212769,
            2244193,
            2244225,
            2244257,
            2244290,
            2244353,
            2244385,
            2244417,
            2244449,
            2218273,
            2244481,
            2244514,
            2244577,
            2244609
        ]),
        new Uint32Array([
            2125730,
            2125699,
            2125795,
            2125891,
            2125987,
            2154114,
            2154178,
            2154242,
            2154306,
            2154370,
            2154434,
            2154498,
            2126082,
            2126178,
            2126274,
            2126083
        ]),
        new Uint32Array([
            2237665,
            2237697,
            2237697,
            2237697,
            2237730,
            2237793,
            2237825,
            2237857,
            2237890,
            2237953,
            2237985,
            2238017,
            2238049,
            2238081,
            2238113,
            2238145
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2150146,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2214369,
            2238593,
            2238625,
            2238657,
            2238689,
            2238721,
            2238753,
            2238785,
            2238817,
            2238850,
            2238913,
            2238945,
            2238977,
            2235457,
            2239009,
            2239041
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2252066,
            2252130,
            2252193,
            2252225,
            2252257,
            2252290,
            2252353,
            2252385,
            2252417,
            2252449,
            2252481,
            2252513,
            2252545,
            2252578,
            2252641,
            2252673
        ]),
        new Uint32Array([
            2197697,
            2114113,
            2114209,
            2197729,
            2197761,
            2114305,
            2197793,
            2114401,
            2114497,
            2197825,
            2114593,
            2114689,
            2114785,
            2114881,
            2114977,
            2197857
        ]),
        new Uint32Array([
            2224866,
            2224930,
            2224994,
            2225058,
            2225122,
            2225186,
            2225250,
            2225314,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2219490,
            2219554,
            2219617,
            2219649,
            2219681,
            2219714,
            2219778,
            2219842,
            2219905,
            2219937,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289
        ]),
        new Uint32Array([
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233089,
            2173697,
            2173761,
            2173793,
            2174113,
            2173985,
            2173953,
            2148481,
            2173601,
            2173633,
            2173665
        ]),
        new Uint32Array([
            2220161,
            2220161,
            2220193,
            2220193,
            2220193,
            2220193,
            2220225,
            2220225,
            2220225,
            2220225,
            2220257,
            2220257,
            2220257,
            2220257,
            2220289,
            2220289
        ]),
        new Uint32Array([
            2192673,
            2192705,
            2192737,
            2192769,
            2192801,
            2192833,
            2192865,
            2118049,
            2192897,
            2117473,
            2117761,
            2192929,
            2192961,
            2192993,
            2193025,
            2193057
        ]),
        new Uint32Array([
            2179297,
            6291456,
            2179329,
            6291456,
            2179361,
            6291456,
            2179393,
            6291456,
            2179425,
            6291456,
            2179457,
            6291456,
            2179489,
            6291456,
            2179521,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2235745,
            2235777,
            2193633,
            2235809,
            2235841,
            2235873,
            2235905,
            2235937,
            2235969,
            2116513,
            2116705,
            2236001,
            2200513,
            2199905,
            2200545,
            2236033
        ]),
        new Uint32Array([
            2113153,
            2108481,
            2113345,
            2113441,
            2232993,
            2233025,
            0,
            0,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761
        ]),
        new Uint32Array([
            2170593,
            6291456,
            2170625,
            6291456,
            2170657,
            6291456,
            2170689,
            2170721,
            6291456,
            2170753,
            6291456,
            6291456,
            2170785,
            6291456,
            2170817,
            2170849
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2166786,
            2166850,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2100833,
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            10575617,
            2187041,
            10502177,
            10489601,
            10489697,
            0
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2134562,
            2132162,
            2132834,
            2136866,
            2136482,
            2164610,
            2164674,
            2164738,
            2164802,
            2132802,
            2132706,
            2164866,
            2132898,
            2164930,
            2164994,
            2165058
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2098337,
            2101441,
            10531458,
            2153473,
            6291456,
            6291456,
            10531522,
            2100737,
            2108193,
            6291456,
            2106499,
            2106595,
            2106691,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2233122,
            2233186,
            2233250,
            2233314,
            2233378,
            2233442,
            2233506,
            2233570,
            2233634,
            2233698,
            2233762,
            2233826,
            2233890,
            2233954,
            2234018,
            2234082
        ]),
        new Uint32Array([
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2205217,
            2205249,
            2205281,
            2205313,
            2205345,
            2205377,
            2205409,
            2205441,
            2205473,
            2205505,
            2205537,
            2205569,
            2205601,
            2205633,
            2205665,
            2205697
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            23068672,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2173601,
            2173761,
            2174081,
            2173569,
            2174241,
            2174113,
            2173953,
            6291456,
            2174305,
            6291456,
            2174337,
            6291456,
            2174369,
            6291456,
            2174401,
            6291456
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2152450,
            2152514,
            2099653,
            2104452,
            2099813,
            2122243,
            2099973,
            2152578,
            2122339,
            2122435,
            2122531,
            2122627,
            2122723,
            2104580,
            2122819,
            2152642
        ]),
        new Uint32Array([
            2236385,
            2236417,
            2236449,
            2236482,
            2236545,
            2215425,
            2236577,
            2236609,
            2236641,
            2236673,
            2215457,
            2236705,
            2236737,
            2236770,
            2215489,
            2236833
        ]),
        new Uint32Array([
            2163394,
            2159746,
            2163458,
            2131362,
            2163522,
            2160130,
            2163778,
            2132226,
            2163842,
            2132898,
            2163906,
            2161410,
            2138658,
            2097666,
            2136162,
            2163650
        ]),
        new Uint32Array([
            2218721,
            2246913,
            2246946,
            2216385,
            2247010,
            2247074,
            2215009,
            2247137,
            2247169,
            2216481,
            2247201,
            2247233,
            2247266,
            2247330,
            2247330,
            0
        ]),
        new Uint32Array([
            2129730,
            2129762,
            2129858,
            2129731,
            2129827,
            2156482,
            2156482,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2203969,
            2204001,
            2181377,
            2204033,
            2204065,
            6291456,
            2204097,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2169473,
            6291456,
            2169505,
            6291456,
            2169537,
            6291456,
            2169569,
            6291456,
            2169601,
            6291456,
            2169633,
            6291456,
            2169665,
            6291456,
            2169697,
            6291456
        ]),
        new Uint32Array([
            2141542,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2220801,
            2220801,
            2220801,
            2220801,
            2220833,
            2220833,
            2220865,
            2220865,
            2220865,
            2220865,
            2220897,
            2220897,
            2220897,
            2220897,
            2139873,
            2139873
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            0
        ]),
        new Uint32Array([
            2214849,
            2218433,
            2218465,
            2218497,
            2218529,
            2218561,
            2214881,
            2218593,
            2218625,
            2218657,
            2218689,
            2218721,
            2218753,
            2216545,
            2218785,
            2218817
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2136482,
            2164610,
            2164674,
            2164738,
            2164802,
            2132802,
            2132706,
            2164866,
            2132898,
            2164930,
            2164994,
            2165058,
            2165122,
            2132802,
            2132706,
            2164866
        ]),
        new Uint32Array([
            2207649,
            2207681,
            2207713,
            2207745,
            2207777,
            2207809,
            2207841,
            2207873,
            2207905,
            2207937,
            2207969,
            2208001,
            2208033,
            2208065,
            2208097,
            2208129
        ]),
        new Uint32Array([
            2123683,
            2105092,
            2152706,
            2123779,
            2105220,
            2152770,
            2100453,
            2098755,
            2123906,
            2124002,
            2124098,
            2124194,
            2124290,
            2124386,
            2124482,
            2124578
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10485857
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            10508163,
            10508259,
            10508355,
            10508451,
            2200129,
            2200161,
            2192737,
            2200193,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2203553,
            6291456,
            2203585,
            6291456,
            6291456,
            6291456,
            2203617,
            6291456,
            2203649,
            6291456,
            2203681,
            6291456,
            2203713,
            6291456,
            2203745,
            6291456
        ]),
        new Uint32Array([
            18884449,
            18884065,
            23068672,
            18884417,
            18884034,
            18921185,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            18874368
        ]),
        new Uint32Array([
            2247393,
            2247426,
            2247489,
            2247521,
            2247553,
            2247586,
            2247649,
            2247681,
            2247713,
            2247745,
            2247777,
            2247810,
            2247873,
            2247905,
            2247937,
            2247969
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672
        ]),
        new Uint32Array([
            2134145,
            2097153,
            2134241,
            0,
            2132705,
            2130977,
            2160065,
            2131297,
            0,
            2133089,
            2160577,
            2133857,
            2235297,
            0,
            2235329,
            0
        ]),
        new Uint32Array([
            2182593,
            6291456,
            2182625,
            6291456,
            2182657,
            6291456,
            2182689,
            6291456,
            2182721,
            6291456,
            2182753,
            6291456,
            2182785,
            6291456,
            2182817,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2102402,
            2102403,
            6291456,
            2110050
        ]),
        new Uint32Array([
            2149890,
            2108323,
            2149954,
            6291456,
            2113441,
            6291456,
            2149057,
            6291456,
            2113441,
            6291456,
            2105473,
            2167265,
            2111137,
            2105505,
            6291456,
            2108353
        ]),
        new Uint32Array([
            2219105,
            2219137,
            2195233,
            2251554,
            2251617,
            2251649,
            2251681,
            2251713,
            2251746,
            2251810,
            2251873,
            2251905,
            2251937,
            2251970,
            2252033,
            2219169
        ]),
        new Uint32Array([
            2203009,
            6291456,
            2203041,
            6291456,
            2203073,
            6291456,
            2203105,
            6291456,
            2203137,
            6291456,
            2203169,
            6291456,
            2203201,
            6291456,
            2203233,
            6291456
        ]),
        new Uint32Array([
            2128195,
            2128291,
            2128387,
            2128483,
            2128579,
            2128675,
            2128771,
            2128867,
            2128963,
            2129059,
            2129155,
            2129251,
            2129347,
            2129443,
            2129539,
            2129635
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2140964,
            2141156,
            2140966,
            2141158,
            2141350
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2225378,
            2225442,
            2225506,
            2225570,
            2225634,
            2225698,
            2225762,
            2225826,
            2225890,
            2225954,
            2226018,
            2226082,
            2226146,
            2226210,
            2226274,
            2226338
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417
        ]),
        new Uint32Array([
            2108353,
            2108417,
            0,
            2105601,
            2108193,
            2157121,
            2157313,
            2157377,
            2157441,
            2100897,
            6291456,
            2108419,
            2173953,
            2173633,
            2173633,
            2173953
        ]),
        new Uint32Array([
            2111713,
            2173121,
            2111905,
            2098177,
            2173153,
            2173185,
            2173217,
            2113153,
            2113345,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            2190753
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2197249,
            6291456,
            2117377,
            2197281,
            2197313,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            2100833,
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2173281,
            6291456,
            2173313,
            6291456,
            2173345,
            6291456,
            2173377,
            6291456,
            0,
            0,
            10532546,
            6291456,
            6291456,
            6291456,
            10562017,
            2173441
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2159426,
            2159490,
            2159554,
            2159362,
            2159618,
            2159682,
            2139522,
            2136450,
            2159746,
            2159810,
            2159874,
            2130978,
            2131074,
            2131266,
            2131362,
            2159938
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2203233,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2203265,
            6291456,
            2203297,
            6291456,
            2203329,
            2203361,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2148418,
            2148482,
            2148546,
            0,
            6291456,
            2148610,
            2186529,
            2186561,
            2148417,
            2148545,
            2148482,
            10495778,
            2143969,
            10495778
        ]),
        new Uint32Array([
            2134146,
            2139426,
            2160962,
            2134242,
            2161218,
            2161282,
            2161346,
            2161410,
            2138658,
            2134722,
            2134434,
            2134818,
            2097666,
            2097346,
            2097698,
            2105986
        ]),
        new Uint32Array([
            2198881,
            2198913,
            2198945,
            2198977,
            2199009,
            2199041,
            2199073,
            2199105,
            2199137,
            2199169,
            2199201,
            2199233,
            2199265,
            2199297,
            2199329,
            2199361
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456
        ]),
        new Uint32Array([
            10610561,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193
        ]),
        new Uint32Array([
            2183873,
            6291456,
            2183905,
            6291456,
            2183937,
            6291456,
            2183969,
            6291456,
            2184001,
            6291456,
            2184033,
            6291456,
            2184065,
            6291456,
            2184097,
            6291456
        ]),
        new Uint32Array([
            2244642,
            2244706,
            2244769,
            2244801,
            2218305,
            2244833,
            2244865,
            2244897,
            2244929,
            2244961,
            2244993,
            2245026,
            2245089,
            2245122,
            2245185,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2116513,
            2116609,
            2116705,
            2116801,
            2199873,
            2199905,
            2199937,
            2199969,
            2190913,
            2200001,
            2200033,
            2200065,
            2200097,
            2191009
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            2180673,
            2180705,
            2180737,
            2180769,
            2180801,
            2180833,
            0,
            0
        ]),
        new Uint32Array([
            2098081,
            2099521,
            2099105,
            2120705,
            2098369,
            2120801,
            2103361,
            2097985,
            2098433,
            2121377,
            2121473,
            2099169,
            2099873,
            2098401,
            2099393,
            2152609
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2150402
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            2145666,
            2145730,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2173921,
            2173953,
            2173985,
            2173761,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233057,
            2148481,
            2173601,
            2173633,
            2173665
        ]),
        new Uint32Array([
            2187073,
            6291456,
            6291456,
            6291456,
            6291456,
            2098241,
            2098241,
            2108353,
            2100897,
            2111905,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2102404,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2100612,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            10485857
        ]),
        new Uint32Array([
            2149057,
            2233057,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889
        ]),
        new Uint32Array([
            2217697,
            2217729,
            2217761,
            2217793,
            2217825,
            2217857,
            2217889,
            2217921,
            2217953,
            2215873,
            2217985,
            2215905,
            2218017,
            2218049,
            2218081,
            2218113
        ]),
        new Uint32Array([
            2211233,
            2218849,
            2216673,
            2218881,
            2218913,
            2218945,
            2218977,
            2219009,
            2216833,
            2219041,
            2215137,
            2219073,
            2216865,
            2209505,
            2219105,
            2216897
        ]),
        new Uint32Array([
            2240097,
            2240129,
            2240161,
            2240193,
            2240225,
            2240257,
            2240289,
            2240321,
            2240353,
            2240386,
            2240449,
            2240481,
            2240513,
            2240545,
            2207905,
            2240578
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2202273,
            6291456,
            2202305,
            6291456,
            2202337,
            6291456,
            2202369,
            6291456,
            2202401,
            6291456,
            2202433,
            6291456,
            2202465,
            6291456
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            18923394,
            23068672,
            18923458,
            18923522,
            18884099,
            18923586,
            18884195,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2201121,
            6291456,
            2201153,
            6291456,
            2201185,
            6291456,
            2201217,
            6291456,
            2201249,
            6291456,
            2201281,
            6291456,
            2201313,
            6291456,
            2201345,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2211041,
            2211073,
            2211105,
            2211137,
            2211169,
            2211201,
            2211233,
            2211265,
            2211297,
            2211329,
            2211361,
            2211393,
            2211425,
            2211457,
            2211489,
            2211521
        ]),
        new Uint32Array([
            2181825,
            6291456,
            2181857,
            6291456,
            2181889,
            6291456,
            2181921,
            6291456,
            2181953,
            6291456,
            2181985,
            6291456,
            2182017,
            6291456,
            2182049,
            6291456
        ]),
        new Uint32Array([
            2162337,
            2097633,
            2097633,
            2097633,
            2097633,
            2132705,
            2132705,
            2132705,
            2132705,
            2097153,
            2097153,
            2097153,
            2097153,
            2133089,
            2133089,
            2133089
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            2148545,
            6291456,
            2173473,
            6291456,
            2148865,
            6291456,
            2173505,
            6291456,
            2173537,
            6291456,
            2173569,
            6291456,
            2149121,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2174017,
            2174017,
            2174049,
            2174081,
            2174113
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2207137,
            2207169,
            2207201,
            2207233,
            2207265,
            2207297,
            2207329,
            2207361,
            2207393,
            2207425,
            2207457,
            2207489,
            2207521,
            2207553,
            2207585,
            2207617
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            0,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2198401,
            2198433,
            2198465,
            2198497,
            0,
            2198529,
            2198561,
            2198593,
            2198625,
            2198657,
            2198689,
            2198721,
            2198753,
            2198785,
            2198817,
            2198849
        ]),
        new Uint32Array([
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2216385,
            2118721,
            2216417,
            2216449,
            2216481,
            2216513,
            2216545,
            2211233,
            2216577,
            2216609,
            2216641,
            2216673,
            2216705,
            2216737,
            2216737,
            2216769
        ]),
        new Uint32Array([
            2216801,
            2216833,
            2216865,
            2216897,
            2216929,
            2216961,
            2216993,
            2215169,
            2217025,
            2217057,
            2217089,
            2217121,
            2217154,
            2217217,
            0,
            0
        ]),
        new Uint32Array([
            2210593,
            2191809,
            2210625,
            2210657,
            2210689,
            2210721,
            2210753,
            2210785,
            2210817,
            2210849,
            2191297,
            2210881,
            2210913,
            2210945,
            2210977,
            2211009
        ]),
        new Uint32Array([
            0,
            0,
            2105825,
            0,
            0,
            2111905,
            2105473,
            0,
            0,
            2112289,
            2108193,
            2112481,
            2112577,
            0,
            2098305,
            2108321
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            2097153,
            2134241,
            0,
            2132705,
            0,
            0,
            2131297,
            0,
            2133089,
            0,
            2133857,
            0,
            2220769,
            0,
            2235361
        ]),
        new Uint32Array([
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            6291456,
            6291456,
            14680064
        ]),
        new Uint32Array([
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2171873,
            6291456,
            2171905,
            6291456,
            2171937,
            6291456,
            2171969,
            6291456,
            2172001,
            6291456,
            2172033,
            6291456,
            2172065,
            6291456,
            2172097,
            6291456
        ]),
        new Uint32Array([
            2220929,
            2220929,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2133857,
            2134145,
            2134145,
            2134145,
            2134145,
            2134241,
            2134241,
            2134241,
            2134241,
            2105889,
            2105889,
            2105889,
            2105889,
            2097185,
            2097185,
            2097185
        ]),
        new Uint32Array([
            2173697,
            2173761,
            2173793,
            2174113,
            2173985,
            2173953,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10499619,
            10499715,
            10499811,
            10499907
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            0,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            2144322,
            2144386,
            2144450,
            2144514,
            2144578,
            2144642,
            2144706,
            2144770
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            0,
            2098241,
            2108353,
            2108417,
            2105825,
            0,
            0,
            2111905,
            2105473,
            2105569
        ]),
        new Uint32Array([
            2236321,
            2236353,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2152194,
            2121283,
            2103684,
            2103812,
            2097986,
            2098533,
            2097990,
            2098693,
            2098595,
            2098853,
            2099013,
            2103940,
            2121379,
            2121475,
            2121571,
            2104068
        ]),
        new Uint32Array([
            2206241,
            2206273,
            2206305,
            2206337,
            2206369,
            2206401,
            2206433,
            2206465,
            2206497,
            2206529,
            2206561,
            2206593,
            2206625,
            2206657,
            2206689,
            2206721
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            16777216,
            16777216,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            23068672,
            23068672,
            10538818,
            10538882,
            6291456,
            6291456,
            2150338
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2214369,
            2214401,
            2214433,
            2214465,
            2214497,
            2214529,
            2214561,
            2214593,
            2194977,
            2214625,
            2195073,
            2214657,
            2214689,
            2214721,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2097152,
            2097152,
            2097152,
            2097152,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2182081,
            6291456,
            2182113,
            6291456,
            2182145,
            6291456,
            2182177,
            6291456,
            2182209,
            6291456,
            2182241,
            6291456,
            2182273,
            6291456,
            2182305,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2146881,
            2146945,
            2147009,
            2147073,
            2147137,
            2147201,
            2147265,
            2147329
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2122915,
            2123011,
            2123107,
            2104708,
            2123203,
            2123299,
            2123395,
            2100133,
            2104836,
            2100290,
            2100293,
            2104962,
            2104964,
            2098052,
            2123491,
            2123587
        ]),
        new Uint32Array([
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456
        ]),
        new Uint32Array([
            6291456,
            2171169,
            6291456,
            2171201,
            6291456,
            2171233,
            6291456,
            2171265,
            6291456,
            2171297,
            6291456,
            2171329,
            6291456,
            6291456,
            2171361,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            2148994,
            2149058,
            2149122,
            0,
            6291456,
            2149186,
            2186945,
            2173537,
            2148993,
            2149121,
            2149058,
            10531458,
            10496066,
            0
        ]),
        new Uint32Array([
            2195009,
            2195041,
            2195073,
            2195105,
            2195137,
            2195169,
            2195201,
            2195233,
            2195265,
            2195297,
            2195329,
            2195361,
            2195393,
            2195425,
            2195457,
            2195489
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2182849,
            6291456,
            2182881,
            6291456,
            2182913,
            6291456,
            2182945,
            6291456,
            2182977,
            6291456,
            2183009,
            6291456,
            2183041,
            6291456,
            2183073,
            6291456
        ]),
        new Uint32Array([
            2211553,
            2210081,
            2211585,
            2211617,
            2211649,
            2211681,
            2211713,
            2211745,
            2211777,
            2211809,
            2209569,
            2211841,
            2211873,
            2211905,
            2211937,
            2211969
        ]),
        new Uint32Array([
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2166594,
            2127298,
            2166658,
            2142978,
            2141827,
            2166722
        ]),
        new Uint32Array([
            2173985,
            2173761,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233057,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            2185761,
            2185793,
            2185825,
            2185857,
            2185889,
            2185921,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            2220961,
            2220961,
            2220961,
            2220961,
            2144193,
            2144193,
            2159201,
            2159201,
            2159265,
            2159265,
            2144194,
            2220993,
            2220993
        ]),
        new Uint32Array([
            2192641,
            2235393,
            2235425,
            2152257,
            2116609,
            2235457,
            2235489,
            2200065,
            2235521,
            2235553,
            2235585,
            2212449,
            2235617,
            2235649,
            2235681,
            2235713
        ]),
        new Uint32Array([
            2194049,
            2194081,
            2194113,
            2194145,
            2194177,
            2194209,
            2194241,
            2194273,
            2194305,
            2194337,
            2194369,
            2194401,
            2194433,
            2194465,
            2194497,
            2194529
        ]),
        new Uint32Array([
            2196673,
            2208641,
            2208673,
            2208705,
            2208737,
            2208769,
            2208801,
            2208833,
            2208865,
            2208897,
            2208929,
            2208961,
            2208993,
            2209025,
            2209057,
            2209089
        ]),
        new Uint32Array([
            2191681,
            2191713,
            2191745,
            2191777,
            2153281,
            2191809,
            2191841,
            2191873,
            2191905,
            2191937,
            2191969,
            2192001,
            2192033,
            2192065,
            2192097,
            2192129
        ]),
        new Uint32Array([
            2230946,
            2231010,
            2231074,
            2231138,
            2231202,
            2231266,
            2231330,
            2231394,
            2231458,
            2231522,
            2231586,
            2231650,
            2231714,
            2231778,
            2231842,
            2231906
        ]),
        new Uint32Array([
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2185953,
            2185985,
            2186017,
            2186049,
            2186081,
            2186113,
            2186145,
            2186177
        ]),
        new Uint32Array([
            2139811,
            2139907,
            2097284,
            2105860,
            2105988,
            2106116,
            2106244,
            2097444,
            2097604,
            2097155,
            10485778,
            10486344,
            2106372,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2110051,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2172385,
            6291456,
            2172417,
            6291456,
            2172449,
            6291456,
            2172481,
            6291456,
            2172513,
            6291456,
            2172545,
            6291456,
            2172577,
            6291456,
            2172609,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            23068672,
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2249345,
            2249377,
            2249409,
            2249441,
            2249473,
            2249505,
            2249537,
            2249570,
            2210209,
            2249633,
            2249665,
            2249697,
            2249729,
            2249761,
            2249793,
            2216769
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2187169,
            2187201,
            2187233,
            2187265,
            2187297,
            2187329,
            2187361,
            2187393,
            2187425,
            2187457,
            2187489,
            2187521,
            2187553,
            2187585,
            2187617,
            2187649
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2182337,
            6291456,
            2182369,
            6291456,
            2182401,
            6291456,
            2182433,
            6291456,
            2182465,
            6291456,
            2182497,
            6291456,
            2182529,
            6291456,
            2182561,
            6291456
        ]),
        new Uint32Array([
            2138179,
            2138275,
            2138371,
            2138467,
            2134243,
            2134435,
            2138563,
            2138659,
            2138755,
            2138851,
            2138947,
            2139043,
            2138947,
            2138755,
            2139139,
            2139235
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            0,
            0,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2250498,
            2250562,
            2250625,
            2250657,
            2208321,
            2250689,
            2250721,
            2250753,
            2250785,
            2250817,
            2250849,
            2218945,
            2250881,
            2250913,
            2250945,
            0
        ]),
        new Uint32Array([
            2170369,
            2105569,
            2098305,
            2108481,
            2173249,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            0,
            2108193,
            0,
            0,
            0,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481
        ]),
        new Uint32Array([
            2100897,
            2100897,
            2105569,
            2105569,
            6291456,
            2112289,
            2149826,
            6291456,
            6291456,
            2112481,
            2112577,
            2098177,
            2098177,
            2098177,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            2169953,
            2169985,
            6291456,
            2170017,
            6291456,
            2170049,
            2170081,
            6291456,
            2170113,
            2170145,
            2170177,
            6291456,
            6291456,
            2170209,
            2170241
        ]),
        new Uint32Array([
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2220641,
            2220641,
            2220673,
            2220673,
            2220673,
            2220673,
            2220705,
            2220705,
            2220705,
            2220705,
            2220737,
            2220737,
            2220737,
            2220737,
            2220769,
            2220769
        ]),
        new Uint32Array([
            2127650,
            2127746,
            2127842,
            2127938,
            2128034,
            2128130,
            2128226,
            2128322,
            2128418,
            2127523,
            2127619,
            2127715,
            2127811,
            2127907,
            2128003,
            2128099
        ]),
        new Uint32Array([
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2173761,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177
        ]),
        new Uint32Array([
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2204705,
            2204737,
            2204769,
            2204801,
            2204833,
            2204865,
            2204897,
            2204929,
            2204961,
            2204993,
            2205025,
            2205057,
            2205089,
            2205121,
            2205153,
            2205185
        ]),
        new Uint32Array([
            2176385,
            6291456,
            2176417,
            6291456,
            2176449,
            6291456,
            2176481,
            6291456,
            2176513,
            6291456,
            2176545,
            6291456,
            2176577,
            6291456,
            2176609,
            6291456
        ]),
        new Uint32Array([
            2195521,
            2195553,
            2195585,
            2195617,
            2195649,
            2195681,
            2117857,
            2195713,
            2195745,
            2195777,
            2195809,
            2195841,
            2195873,
            2195905,
            2195937,
            2195969
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2173921,
            2173953,
            2173985,
            2174017,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233089,
            2173697,
            2173761,
            2173793,
            2174113
        ]),
        new Uint32Array([
            2131586,
            2132450,
            2135970,
            2135778,
            2161602,
            2136162,
            2163650,
            2161794,
            2135586,
            2163714,
            2137186,
            2131810,
            2160290,
            2135170,
            2097506,
            2159554
        ]),
        new Uint32Array([
            2134145,
            2097153,
            2134241,
            2105953,
            2132705,
            2130977,
            2160065,
            2131297,
            2162049,
            2133089,
            2160577,
            2133857,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2116513,
            2116609,
            2116705,
            2116801,
            2116897,
            2116993,
            2117089,
            2117185,
            2117281,
            2117377,
            2117473,
            2117569,
            2117665,
            2117761,
            2117857,
            2117953
        ]),
        new Uint32Array([
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            2100802,
            2101154,
            2101282,
            2101410,
            2101538,
            2101666,
            2101794
        ]),
        new Uint32Array([
            2100289,
            2098657,
            2098049,
            2200737,
            2123489,
            2123681,
            2200769,
            2098625,
            2100321,
            2098145,
            2100449,
            2098017,
            2098753,
            2098977,
            2150241,
            2150305
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2109955,
            6291456,
            6291456,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2130979,
            2131075,
            2131075,
            2131171,
            2131267,
            2131363,
            2131459,
            2131555,
            2131651,
            2131651,
            2131747,
            2131843,
            2131939,
            2132035,
            2132131,
            2132227
        ]),
        new Uint32Array([
            0,
            2177793,
            6291456,
            2177825,
            6291456,
            2177857,
            6291456,
            2177889,
            6291456,
            2177921,
            6291456,
            2177953,
            6291456,
            2177985,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2113345,
            0,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289
        ]),
        new Uint32Array([
            2136643,
            2136739,
            2136835,
            2136931,
            2137027,
            2137123,
            2137219,
            2137315,
            2137411,
            2137507,
            2137603,
            2137699,
            2137795,
            2137891,
            2137987,
            2138083
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0
        ]),
        new Uint32Array([
            2174433,
            6291456,
            2174465,
            6291456,
            2174497,
            6291456,
            2174529,
            6291456,
            2174561,
            6291456,
            2174593,
            6291456,
            2174625,
            6291456,
            2174657,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441
        ]),
        new Uint32Array([
            10496547,
            10496643,
            2105505,
            2149698,
            6291456,
            10496739,
            10496835,
            2170273,
            6291456,
            2149762,
            2105825,
            2111713,
            2111713,
            2111713,
            2111713,
            2168673
        ]),
        new Uint32Array([
            6291456,
            2143490,
            2143490,
            2143490,
            2171649,
            6291456,
            2171681,
            2171713,
            2171745,
            6291456,
            2171777,
            6291456,
            2171809,
            6291456,
            2171841,
            6291456
        ]),
        new Uint32Array([
            2159106,
            2159106,
            2159170,
            2159170,
            2159234,
            2159234,
            2159298,
            2159298,
            2159298,
            2159362,
            2159362,
            2159362,
            2106401,
            2106401,
            2106401,
            2106401
        ]),
        new Uint32Array([
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137
        ]),
        new Uint32Array([
            2108417,
            2181217,
            2181249,
            2181281,
            2170433,
            2170401,
            2181313,
            2181345,
            2181377,
            2181409,
            2181441,
            2181473,
            2181505,
            2181537,
            2170529,
            2181569
        ]),
        new Uint32Array([
            2218433,
            2245761,
            2245793,
            2245825,
            2245857,
            2245890,
            2245953,
            2245986,
            2209665,
            2246050,
            2246113,
            2246146,
            2246210,
            2246274,
            2246337,
            2246369
        ]),
        new Uint32Array([
            2230754,
            2230818,
            2230882,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2184129,
            6291456,
            2184161,
            6291456,
            2184193,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2146818,
            2183361,
            6291456,
            6291456,
            2142978,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2135170,
            2097506,
            2130691,
            2130787,
            2130883,
            2163970,
            2164034,
            2164098,
            2164162,
            2164226,
            2164290,
            2164354,
            2164418,
            2164482,
            2164546,
            2133122
        ]),
        new Uint32Array([
            2108515,
            2108611,
            2100740,
            2108707,
            2108803,
            2108899,
            2108995,
            2109091,
            2109187,
            2109283,
            2109379,
            2109475,
            2109571,
            2109667,
            2109763,
            2100738
        ]),
        new Uint32Array([
            2102788,
            2102916,
            2103044,
            2120515,
            2103172,
            2120611,
            2120707,
            2098373,
            2103300,
            2120803,
            2120899,
            2120995,
            2103428,
            2103556,
            2121091,
            2121187
        ]),
        new Uint32Array([
            2158082,
            2158146,
            0,
            2158210,
            2158274,
            0,
            2158338,
            2158402,
            2158466,
            2129922,
            2158530,
            2158594,
            2158658,
            2158722,
            2158786,
            2158850
        ]),
        new Uint32Array([
            10499619,
            10499715,
            10499811,
            10499907,
            10500003,
            10500099,
            10500195,
            10500291,
            10500387,
            10500483,
            10500579,
            10500675,
            10500771,
            10500867,
            10500963,
            10501059
        ]),
        new Uint32Array([
            2239585,
            2239618,
            2239681,
            2239713,
            0,
            2191969,
            2239745,
            2239777,
            2192033,
            2239809,
            2239841,
            2239874,
            2239937,
            2239970,
            2240033,
            2240065
        ]),
        new Uint32Array([
            2252705,
            2252738,
            2252801,
            2252833,
            2252865,
            2252897,
            2252930,
            2252994,
            2253057,
            2253089,
            2253121,
            2253154,
            2253217,
            2253250,
            2219361,
            2219361
        ]),
        new Uint32Array([
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            10538050,
            10538114,
            10538178,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2226402,
            2226466,
            2226530,
            2226594,
            2226658,
            2226722,
            2226786,
            2226850,
            2226914,
            2226978,
            2227042,
            2227106,
            2227170,
            2227234,
            2227298,
            2227362
        ]),
        new Uint32Array([
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            2144066,
            2144130,
            2144194,
            2144258,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2124674,
            2124770,
            2123875,
            2123971,
            2124067,
            2124163,
            2124259,
            2124355,
            2124451,
            2124547,
            2124643,
            2124739,
            2124835,
            2124931,
            2125027,
            2125123
        ]),
        new Uint32Array([
            2168065,
            6291456,
            2168097,
            6291456,
            2168129,
            6291456,
            2168161,
            6291456,
            2168193,
            6291456,
            2168225,
            6291456,
            2168257,
            6291456,
            2168289,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            2100610,
            2100611,
            6291456,
            2107842,
            2107843,
            6291456,
            6291456,
            6291456,
            6291456,
            10537922,
            6291456,
            10537986,
            6291456
        ]),
        new Uint32Array([
            2174849,
            2174881,
            2174913,
            2174945,
            2174977,
            2175009,
            2175041,
            2175073,
            2175105,
            2175137,
            2175169,
            2175201,
            2175233,
            2175265,
            2175297,
            2175329
        ]),
        new Uint32Array([
            2154562,
            2154626,
            2154690,
            2154754,
            2141858,
            2154818,
            2154882,
            2127298,
            2154946,
            2127298,
            2155010,
            2155074,
            2155138,
            2155202,
            2155266,
            2155202
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            0
        ]),
        new Uint32Array([
            2200641,
            2150786,
            2150850,
            2150914,
            2150978,
            2151042,
            2106562,
            2151106,
            2150562,
            2151170,
            2151234,
            2151298,
            2151362,
            2151426,
            2151490,
            2151554
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2220289,
            2220289,
            2220321,
            2220321,
            2220321,
            2220321,
            2220353,
            2220353,
            2220353,
            2220353,
            2220385,
            2220385,
            2220385,
            2220385,
            2220417,
            2220417
        ]),
        new Uint32Array([
            2155330,
            2155394,
            0,
            2155458,
            2155522,
            2155586,
            2105732,
            0,
            2155650,
            2155714,
            2155778,
            2125314,
            2155842,
            2155906,
            2126274,
            2155970
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2097729,
            2106017,
            2106017,
            2106017,
            2106017,
            2131297,
            2131297,
            2131297,
            2131297,
            2106081,
            2106081,
            2162049,
            2162049,
            2105953,
            2105953,
            2162337
        ]),
        new Uint32Array([
            2097185,
            2097697,
            2097697,
            2097697,
            2097697,
            2135777,
            2135777,
            2135777,
            2135777,
            2097377,
            2097377,
            2097377,
            2097377,
            2097601,
            2097601,
            2097217
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672
        ]),
        new Uint32Array([
            2139331,
            2139427,
            2139523,
            2139043,
            2133571,
            2132611,
            2139619,
            2139715,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2174113,
            2174145,
            2100897,
            2098177,
            2108289,
            2100865,
            2173601,
            2173633,
            2173985,
            2174113,
            2174145,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            18923778,
            23068672,
            23068672,
            23068672,
            23068672,
            18923842,
            23068672,
            23068672,
            23068672,
            23068672,
            18923906,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2134145,
            2097153,
            2134241,
            0,
            2132705,
            2130977,
            2160065,
            2131297,
            0,
            2133089,
            0,
            2133857,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2177537,
            6291456,
            2177569,
            6291456,
            2177601,
            6291456,
            2177633,
            6291456,
            2177665,
            6291456,
            2177697,
            6291456,
            2177729,
            6291456,
            2177761,
            6291456
        ]),
        new Uint32Array([
            2212481,
            2212513,
            2212545,
            2212577,
            2197121,
            2212609,
            2212641,
            2212673,
            2212705,
            2212737,
            2212769,
            2212801,
            2212833,
            2212865,
            2212897,
            2212929
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2098241,
            2108353,
            2170209,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            6291456,
            2108193,
            2172417,
            2112481,
            2098177
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ])
    ];
    var blockIdxes = new Uint16Array([
        616,
        616,
        565,
        147,
        161,
        411,
        330,
        2,
        131,
        131,
        328,
        454,
        241,
        408,
        86,
        86,
        696,
        113,
        285,
        350,
        325,
        301,
        473,
        214,
        639,
        232,
        447,
        64,
        369,
        598,
        124,
        672,
        567,
        223,
        621,
        154,
        107,
        86,
        86,
        86,
        86,
        86,
        86,
        505,
        86,
        68,
        634,
        86,
        218,
        218,
        218,
        218,
        486,
        218,
        218,
        513,
        188,
        608,
        216,
        86,
        217,
        463,
        668,
        85,
        700,
        360,
        184,
        86,
        86,
        86,
        647,
        402,
        153,
        10,
        346,
        718,
        662,
        260,
        145,
        298,
        117,
        1,
        443,
        342,
        138,
        54,
        563,
        86,
        240,
        572,
        218,
        70,
        387,
        86,
        118,
        460,
        641,
        602,
        86,
        86,
        306,
        218,
        86,
        692,
        86,
        86,
        86,
        86,
        86,
        162,
        707,
        86,
        458,
        26,
        86,
        218,
        638,
        86,
        86,
        86,
        86,
        86,
        65,
        449,
        86,
        86,
        306,
        183,
        86,
        58,
        391,
        667,
        86,
        157,
        131,
        131,
        131,
        131,
        86,
        433,
        131,
        406,
        31,
        218,
        247,
        86,
        86,
        693,
        218,
        581,
        351,
        86,
        438,
        295,
        69,
        462,
        45,
        126,
        173,
        650,
        14,
        295,
        69,
        97,
        168,
        187,
        641,
        78,
        523,
        390,
        69,
        108,
        287,
        664,
        173,
        219,
        83,
        295,
        69,
        108,
        431,
        426,
        173,
        694,
        412,
        115,
        628,
        52,
        257,
        398,
        641,
        118,
        501,
        121,
        69,
        579,
        151,
        423,
        173,
        620,
        464,
        121,
        69,
        382,
        151,
        476,
        173,
        27,
        53,
        121,
        86,
        594,
        578,
        226,
        173,
        86,
        632,
        130,
        86,
        96,
        228,
        268,
        641,
        622,
        563,
        86,
        86,
        21,
        148,
        650,
        131,
        131,
        321,
        43,
        144,
        343,
        381,
        531,
        131,
        131,
        178,
        20,
        86,
        399,
        156,
        375,
        164,
        541,
        30,
        60,
        715,
        198,
        92,
        118,
        131,
        131,
        86,
        86,
        306,
        407,
        86,
        280,
        457,
        196,
        488,
        358,
        131,
        131,
        244,
        86,
        86,
        143,
        86,
        86,
        86,
        86,
        86,
        667,
        563,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        336,
        363,
        86,
        86,
        336,
        86,
        86,
        380,
        678,
        67,
        86,
        86,
        86,
        678,
        86,
        86,
        86,
        512,
        86,
        307,
        86,
        708,
        86,
        86,
        86,
        86,
        86,
        528,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        563,
        307,
        86,
        86,
        86,
        86,
        86,
        104,
        450,
        337,
        86,
        720,
        86,
        32,
        450,
        397,
        86,
        86,
        86,
        587,
        218,
        558,
        708,
        708,
        293,
        708,
        86,
        86,
        86,
        86,
        86,
        694,
        205,
        86,
        8,
        86,
        86,
        86,
        86,
        549,
        86,
        667,
        697,
        697,
        679,
        86,
        458,
        460,
        86,
        86,
        650,
        86,
        708,
        543,
        86,
        86,
        86,
        245,
        86,
        86,
        86,
        140,
        218,
        127,
        708,
        708,
        458,
        197,
        131,
        131,
        131,
        131,
        500,
        86,
        86,
        483,
        251,
        86,
        306,
        510,
        515,
        86,
        722,
        86,
        86,
        86,
        65,
        201,
        86,
        86,
        483,
        580,
        470,
        86,
        86,
        86,
        368,
        131,
        131,
        131,
        694,
        114,
        110,
        555,
        86,
        86,
        123,
        721,
        163,
        142,
        713,
        418,
        86,
        317,
        675,
        209,
        218,
        218,
        218,
        371,
        545,
        592,
        629,
        490,
        603,
        199,
        46,
        320,
        525,
        680,
        310,
        279,
        388,
        111,
        42,
        252,
        593,
        607,
        235,
        617,
        410,
        377,
        50,
        548,
        135,
        356,
        17,
        520,
        189,
        116,
        392,
        600,
        349,
        332,
        482,
        699,
        690,
        535,
        119,
        106,
        451,
        71,
        152,
        667,
        131,
        218,
        218,
        265,
        671,
        637,
        492,
        504,
        533,
        683,
        269,
        269,
        658,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        491,
        619,
        86,
        86,
        6,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        229,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        667,
        86,
        86,
        171,
        131,
        118,
        131,
        656,
        206,
        234,
        571,
        89,
        334,
        670,
        246,
        311,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        534,
        86,
        86,
        86,
        86,
        86,
        86,
        82,
        86,
        86,
        86,
        86,
        86,
        430,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        599,
        86,
        324,
        86,
        470,
        69,
        640,
        264,
        131,
        626,
        101,
        174,
        86,
        86,
        667,
        233,
        105,
        73,
        374,
        394,
        221,
        204,
        84,
        28,
        326,
        86,
        86,
        471,
        86,
        86,
        86,
        109,
        573,
        86,
        171,
        200,
        200,
        200,
        200,
        218,
        218,
        86,
        86,
        86,
        86,
        460,
        131,
        131,
        131,
        86,
        506,
        86,
        86,
        86,
        86,
        86,
        220,
        404,
        34,
        614,
        47,
        442,
        305,
        25,
        612,
        338,
        601,
        648,
        7,
        344,
        255,
        131,
        131,
        51,
        86,
        312,
        507,
        563,
        86,
        86,
        86,
        86,
        588,
        86,
        86,
        86,
        86,
        86,
        530,
        511,
        86,
        458,
        3,
        435,
        384,
        556,
        522,
        230,
        527,
        86,
        118,
        86,
        86,
        717,
        86,
        137,
        273,
        79,
        181,
        484,
        23,
        93,
        112,
        655,
        249,
        417,
        703,
        370,
        87,
        98,
        313,
        684,
        585,
        155,
        465,
        596,
        481,
        695,
        18,
        416,
        428,
        61,
        701,
        706,
        282,
        643,
        495,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        549,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        549,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        307,
        86,
        86,
        86,
        171,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        650,
        131,
        422,
        542,
        420,
        263,
        24,
        172,
        86,
        86,
        86,
        86,
        86,
        566,
        86,
        86,
        132,
        540,
        395,
        353,
        494,
        519,
        19,
        485,
        284,
        472,
        131,
        131,
        131,
        16,
        714,
        86,
        211,
        708,
        86,
        86,
        86,
        694,
        698,
        86,
        86,
        483,
        704,
        708,
        218,
        272,
        86,
        86,
        120,
        86,
        159,
        478,
        86,
        307,
        247,
        86,
        86,
        663,
        597,
        459,
        627,
        667,
        86,
        86,
        277,
        455,
        39,
        302,
        86,
        250,
        86,
        86,
        86,
        271,
        99,
        452,
        306,
        281,
        329,
        400,
        200,
        86,
        86,
        362,
        549,
        352,
        646,
        461,
        323,
        586,
        86,
        86,
        4,
        708,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        717,
        86,
        518,
        86,
        86,
        650,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        125,
        554,
        480,
        300,
        613,
        72,
        333,
        288,
        561,
        544,
        604,
        48,
        719,
        91,
        169,
        176,
        590,
        224,
        76,
        191,
        29,
        559,
        560,
        231,
        537,
        166,
        477,
        538,
        256,
        437,
        131,
        131,
        469,
        167,
        40,
        0,
        685,
        266,
        441,
        705,
        239,
        642,
        475,
        568,
        640,
        610,
        299,
        673,
        517,
        318,
        385,
        22,
        202,
        180,
        179,
        359,
        424,
        215,
        90,
        66,
        521,
        653,
        467,
        682,
        453,
        409,
        479,
        88,
        131,
        661,
        35,
        303,
        15,
        262,
        666,
        630,
        712,
        131,
        131,
        618,
        659,
        175,
        218,
        195,
        347,
        193,
        227,
        261,
        150,
        165,
        709,
        546,
        294,
        569,
        710,
        270,
        413,
        376,
        524,
        55,
        242,
        38,
        419,
        529,
        170,
        657,
        3,
        304,
        122,
        379,
        278,
        131,
        651,
        86,
        67,
        576,
        458,
        458,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        118,
        309,
        86,
        86,
        547,
        86,
        86,
        86,
        86,
        667,
        650,
        664,
        131,
        131,
        86,
        86,
        56,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        307,
        86,
        86,
        86,
        664,
        238,
        650,
        86,
        86,
        717,
        86,
        118,
        86,
        86,
        315,
        86,
        59,
        86,
        86,
        574,
        549,
        131,
        131,
        340,
        57,
        436,
        86,
        86,
        86,
        86,
        86,
        86,
        458,
        708,
        499,
        691,
        62,
        86,
        650,
        86,
        86,
        694,
        86,
        86,
        86,
        319,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        171,
        86,
        549,
        694,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        77,
        86,
        86,
        139,
        86,
        502,
        86,
        86,
        86,
        667,
        595,
        131,
        131,
        131,
        86,
        12,
        86,
        13,
        86,
        609,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        625,
        86,
        669,
        86,
        86,
        182,
        129,
        86,
        5,
        694,
        104,
        86,
        86,
        86,
        86,
        131,
        131,
        86,
        86,
        386,
        171,
        86,
        86,
        86,
        345,
        86,
        324,
        86,
        589,
        86,
        213,
        36,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        104,
        131,
        131,
        131,
        141,
        290,
        80,
        677,
        86,
        86,
        86,
        267,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        667,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        515,
        86,
        86,
        33,
        136,
        669,
        86,
        711,
        515,
        86,
        86,
        550,
        640,
        86,
        104,
        708,
        515,
        86,
        159,
        372,
        717,
        86,
        86,
        444,
        515,
        86,
        86,
        663,
        37,
        86,
        563,
        460,
        86,
        390,
        624,
        702,
        131,
        131,
        131,
        131,
        389,
        59,
        708,
        86,
        86,
        341,
        208,
        708,
        635,
        295,
        69,
        108,
        431,
        508,
        100,
        190,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        649,
        516,
        660,
        131,
        131,
        86,
        86,
        86,
        218,
        631,
        708,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        341,
        575,
        238,
        514,
        131,
        131,
        86,
        86,
        86,
        218,
        291,
        708,
        307,
        131,
        86,
        86,
        306,
        367,
        708,
        131,
        131,
        131,
        86,
        378,
        697,
        86,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        615,
        253,
        86,
        86,
        86,
        292,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        104,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        69,
        86,
        341,
        553,
        549,
        86,
        307,
        86,
        86,
        645,
        275,
        455,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        708,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        667,
        460,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        717,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        667,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        171,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        104,
        86,
        667,
        459,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        458,
        225,
        86,
        86,
        86,
        516,
        549,
        11,
        390,
        405,
        86,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        460,
        44,
        218,
        197,
        711,
        515,
        131,
        131,
        131,
        131,
        664,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        307,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        308,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        640,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        118,
        307,
        104,
        286,
        591,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        549,
        86,
        86,
        681,
        86,
        86,
        75,
        185,
        314,
        582,
        86,
        358,
        496,
        474,
        86,
        104,
        131,
        86,
        86,
        86,
        86,
        146,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        171,
        86,
        640,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        246,
        503,
        689,
        339,
        674,
        81,
        258,
        415,
        439,
        128,
        562,
        366,
        414,
        246,
        503,
        689,
        583,
        222,
        557,
        316,
        636,
        665,
        186,
        355,
        95,
        670,
        246,
        503,
        689,
        339,
        674,
        557,
        258,
        415,
        439,
        186,
        355,
        95,
        670,
        246,
        503,
        689,
        446,
        644,
        536,
        652,
        331,
        532,
        335,
        440,
        274,
        421,
        297,
        570,
        74,
        425,
        364,
        425,
        606,
        552,
        403,
        509,
        134,
        365,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        218,
        218,
        218,
        498,
        218,
        218,
        577,
        627,
        551,
        497,
        572,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        553,
        354,
        236,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        296,
        455,
        131,
        131,
        456,
        243,
        103,
        86,
        41,
        459,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        9,
        276,
        158,
        716,
        393,
        564,
        383,
        489,
        401,
        654,
        210,
        654,
        131,
        131,
        131,
        640,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        650,
        86,
        86,
        86,
        86,
        86,
        86,
        717,
        667,
        563,
        563,
        563,
        86,
        549,
        102,
        686,
        133,
        246,
        605,
        86,
        448,
        86,
        86,
        207,
        307,
        131,
        131,
        131,
        641,
        86,
        177,
        611,
        445,
        373,
        194,
        584,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        308,
        307,
        171,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        717,
        86,
        86,
        86,
        86,
        86,
        460,
        131,
        131,
        650,
        86,
        86,
        86,
        694,
        708,
        86,
        86,
        694,
        86,
        458,
        131,
        131,
        131,
        131,
        131,
        131,
        667,
        694,
        289,
        650,
        667,
        131,
        131,
        86,
        640,
        131,
        131,
        664,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        171,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        460,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        458,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        640,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        466,
        203,
        149,
        429,
        94,
        432,
        160,
        687,
        539,
        63,
        237,
        283,
        192,
        248,
        348,
        259,
        427,
        526,
        396,
        676,
        254,
        468,
        487,
        212,
        327,
        623,
        49,
        633,
        322,
        493,
        434,
        688,
        357,
        361,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131
    ]);
    var mappingStr = "\u0635\u0644\u0649 \u0627\u0644\u0644\u0647 \u0639\u0644\u064A\u0647 \u0648\u0633\u0644\u0645\u062C\u0644 \u062C\u0644\u0627\u0644\u0647\u30AD\u30ED\u30E1\u30FC\u30C8\u30EBrad\u2215s2\u30A8\u30B9\u30AF\u30FC\u30C9\u30AD\u30ED\u30B0\u30E9\u30E0\u30AD\u30ED\u30EF\u30C3\u30C8\u30B0\u30E9\u30E0\u30C8\u30F3\u30AF\u30EB\u30BC\u30A4\u30ED\u30B5\u30F3\u30C1\u30FC\u30E0\u30D1\u30FC\u30BB\u30F3\u30C8\u30D4\u30A2\u30B9\u30C8\u30EB\u30D5\u30A1\u30E9\u30C3\u30C9\u30D6\u30C3\u30B7\u30A7\u30EB\u30D8\u30AF\u30BF\u30FC\u30EB\u30DE\u30F3\u30B7\u30E7\u30F3\u30DF\u30EA\u30D0\u30FC\u30EB\u30EC\u30F3\u30C8\u30B2\u30F3\u2032\u2032\u2032\u20321\u204410viii(10)(11)(12)(13)(14)(15)(16)(17)(18)(19)(20)\u222B\u222B\u222B\u222B(\uC624\uC804)(\uC624\uD6C4)\u30A2\u30D1\u30FC\u30C8\u30A2\u30EB\u30D5\u30A1\u30A2\u30F3\u30DA\u30A2\u30A4\u30CB\u30F3\u30B0\u30A8\u30FC\u30AB\u30FC\u30AB\u30E9\u30C3\u30C8\u30AB\u30ED\u30EA\u30FC\u30AD\u30E5\u30EA\u30FC\u30AE\u30EB\u30C0\u30FC\u30AF\u30ED\u30FC\u30CD\u30B5\u30A4\u30AF\u30EB\u30B7\u30EA\u30F3\u30B0\u30D0\u30FC\u30EC\u30EB\u30D5\u30A3\u30FC\u30C8\u30DD\u30A4\u30F3\u30C8\u30DE\u30A4\u30AF\u30ED\u30DF\u30AF\u30ED\u30F3\u30E1\u30AC\u30C8\u30F3\u30EA\u30C3\u30C8\u30EB\u30EB\u30FC\u30D6\u30EB\u682A\u5F0F\u4F1A\u793Ekcalm\u2215s2c\u2215kg\u0627\u0643\u0628\u0631\u0645\u062D\u0645\u062F\u0635\u0644\u0639\u0645\u0631\u0633\u0648\u0644\u0631\u06CC\u0627\u06441\u204441\u204423\u20444 \u0308\u0301\u0FB2\u0F71\u0F80\u0FB3\u0F71\u0F80 \u0308\u0342 \u0313\u0300 \u0313\u0301 \u0313\u0342 \u0314\u0300 \u0314\u0301 \u0314\u0342 \u0308\u0300\u2035\u2035\u2035a/ca/sc/oc/utelfax1\u204471\u204491\u204432\u204431\u204452\u204453\u204454\u204451\u204465\u204461\u204483\u204485\u204487\u20448xii0\u20443\u222E\u222E\u222E(1)(2)(3)(4)(5)(6)(7)(8)(9)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)(k)(l)(m)(n)(o)(p)(q)(r)(s)(t)(u)(v)(w)(x)(y)(z)::====(\u1100)(\u1102)(\u1103)(\u1105)(\u1106)(\u1107)(\u1109)(\u110B)(\u110C)(\u110E)(\u110F)(\u1110)(\u1111)(\u1112)(\uAC00)(\uB098)(\uB2E4)(\uB77C)(\uB9C8)(\uBC14)(\uC0AC)(\uC544)(\uC790)(\uCC28)(\uCE74)(\uD0C0)(\uD30C)(\uD558)(\uC8FC)(\u4E00)(\u4E8C)(\u4E09)(\u56DB)(\u4E94)(\u516D)(\u4E03)(\u516B)(\u4E5D)(\u5341)(\u6708)(\u706B)(\u6C34)(\u6728)(\u91D1)(\u571F)(\u65E5)(\u682A)(\u6709)(\u793E)(\u540D)(\u7279)(\u8CA1)(\u795D)(\u52B4)(\u4EE3)(\u547C)(\u5B66)(\u76E3)(\u4F01)(\u8CC7)(\u5354)(\u796D)(\u4F11)(\u81EA)(\u81F3)pte10\u670811\u670812\u6708ergltd\u30A2\u30FC\u30EB\u30A4\u30F3\u30C1\u30A6\u30A9\u30F3\u30AA\u30F3\u30B9\u30AA\u30FC\u30E0\u30AB\u30A4\u30EA\u30AC\u30ED\u30F3\u30AC\u30F3\u30DE\u30AE\u30CB\u30FC\u30B1\u30FC\u30B9\u30B3\u30EB\u30CA\u30B3\u30FC\u30DD\u30BB\u30F3\u30C1\u30C0\u30FC\u30B9\u30CE\u30C3\u30C8\u30CF\u30A4\u30C4\u30D1\u30FC\u30C4\u30D4\u30AF\u30EB\u30D5\u30E9\u30F3\u30DA\u30CB\u30D2\u30D8\u30EB\u30C4\u30DA\u30F3\u30B9\u30DA\u30FC\u30B8\u30D9\u30FC\u30BF\u30DC\u30EB\u30C8\u30DD\u30F3\u30C9\u30DB\u30FC\u30EB\u30DB\u30FC\u30F3\u30DE\u30A4\u30EB\u30DE\u30C3\u30CF\u30DE\u30EB\u30AF\u30E4\u30FC\u30C9\u30E4\u30FC\u30EB\u30E6\u30A2\u30F3\u30EB\u30D4\u30FC10\u70B911\u70B912\u70B913\u70B914\u70B915\u70B916\u70B917\u70B918\u70B919\u70B920\u70B921\u70B922\u70B923\u70B924\u70B9hpabardm2dm3khzmhzghzthzmm2cm2km2mm3cm3km3kpampagpalogmilmolppmv\u2215ma\u2215m10\u65E511\u65E512\u65E513\u65E514\u65E515\u65E516\u65E517\u65E518\u65E519\u65E520\u65E521\u65E522\u65E523\u65E524\u65E525\u65E526\u65E527\u65E528\u65E529\u65E530\u65E531\u65E5galffiffl\u05E9\u05BC\u05C1\u05E9\u05BC\u05C2 \u064C\u0651 \u064D\u0651 \u064E\u0651 \u064F\u0651 \u0650\u0651 \u0651\u0670\u0640\u064E\u0651\u0640\u064F\u0651\u0640\u0650\u0651\u062A\u062C\u0645\u062A\u062D\u062C\u062A\u062D\u0645\u062A\u062E\u0645\u062A\u0645\u062C\u062A\u0645\u062D\u062A\u0645\u062E\u062C\u0645\u062D\u062D\u0645\u064A\u062D\u0645\u0649\u0633\u062D\u062C\u0633\u062C\u062D\u0633\u062C\u0649\u0633\u0645\u062D\u0633\u0645\u062C\u0633\u0645\u0645\u0635\u062D\u062D\u0635\u0645\u0645\u0634\u062D\u0645\u0634\u062C\u064A\u0634\u0645\u062E\u0634\u0645\u0645\u0636\u062D\u0649\u0636\u062E\u0645\u0637\u0645\u062D\u0637\u0645\u0645\u0637\u0645\u064A\u0639\u062C\u0645\u0639\u0645\u0645\u0639\u0645\u0649\u063A\u0645\u0645\u063A\u0645\u064A\u063A\u0645\u0649\u0641\u062E\u0645\u0642\u0645\u062D\u0642\u0645\u0645\u0644\u062D\u0645\u0644\u062D\u064A\u0644\u062D\u0649\u0644\u062C\u062C\u0644\u062E\u0645\u0644\u0645\u062D\u0645\u062D\u062C\u0645\u062D\u064A\u0645\u062C\u062D\u0645\u062C\u0645\u0645\u062E\u0645\u0645\u062C\u062E\u0647\u0645\u062C\u0647\u0645\u0645\u0646\u062D\u0645\u0646\u062D\u0649\u0646\u062C\u0645\u0646\u062C\u0649\u0646\u0645\u064A\u0646\u0645\u0649\u064A\u0645\u0645\u0628\u062E\u064A\u062A\u062C\u064A\u062A\u062C\u0649\u062A\u062E\u064A\u062A\u062E\u0649\u062A\u0645\u064A\u062A\u0645\u0649\u062C\u0645\u064A\u062C\u062D\u0649\u062C\u0645\u0649\u0633\u062E\u0649\u0635\u062D\u064A\u0634\u062D\u064A\u0636\u062D\u064A\u0644\u062C\u064A\u0644\u0645\u064A\u064A\u062D\u064A\u064A\u062C\u064A\u064A\u0645\u064A\u0645\u0645\u064A\u0642\u0645\u064A\u0646\u062D\u064A\u0639\u0645\u064A\u0643\u0645\u064A\u0646\u062C\u062D\u0645\u062E\u064A\u0644\u062C\u0645\u0643\u0645\u0645\u062C\u062D\u064A\u062D\u062C\u064A\u0645\u062C\u064A\u0641\u0645\u064A\u0628\u062D\u064A\u0633\u062E\u064A\u0646\u062C\u064A\u0635\u0644\u06D2\u0642\u0644\u06D2\uD834\uDD58\uD834\uDD65\uD834\uDD6E\uD834\uDD58\uD834\uDD65\uD834\uDD6F\uD834\uDD58\uD834\uDD65\uD834\uDD70\uD834\uDD58\uD834\uDD65\uD834\uDD71\uD834\uDD58\uD834\uDD65\uD834\uDD72\uD834\uDDB9\uD834\uDD65\uD834\uDD6E\uD834\uDDBA\uD834\uDD65\uD834\uDD6E\uD834\uDDB9\uD834\uDD65\uD834\uDD6F\uD834\uDDBA\uD834\uDD65\uD834\uDD6F\u3014s\u3015ppv\u3014\u672C\u3015\u3014\u4E09\u3015\u3014\u4E8C\u3015\u3014\u5B89\u3015\u3014\u70B9\u3015\u3014\u6253\u3015\u3014\u76D7\u3015\u3014\u52DD\u3015\u3014\u6557\u3015 \u0304 \u0301 \u0327ssi\u0307ijl\xb7\u02BCnd\u017Eljnjdz \u0306 \u0307 \u030A \u0328 \u0303 \u030B \u03B9\u0565\u0582\u0627\u0674\u0648\u0674\u06C7\u0674\u064A\u0674\u0915\u093C\u0916\u093C\u0917\u093C\u091C\u093C\u0921\u093C\u0922\u093C\u092B\u093C\u092F\u093C\u09A1\u09BC\u09A2\u09BC\u09AF\u09BC\u0A32\u0A3C\u0A38\u0A3C\u0A16\u0A3C\u0A17\u0A3C\u0A1C\u0A3C\u0A2B\u0A3C\u0B21\u0B3C\u0B22\u0B3C\u0E4D\u0E32\u0ECD\u0EB2\u0EAB\u0E99\u0EAB\u0EA1\u0F42\u0FB7\u0F4C\u0FB7\u0F51\u0FB7\u0F56\u0FB7\u0F5B\u0FB7\u0F40\u0FB5\u0F71\u0F72\u0F71\u0F74\u0FB2\u0F80\u0FB3\u0F80\u0F92\u0FB7\u0F9C\u0FB7\u0FA1\u0FB7\u0FA6\u0FB7\u0FAB\u0FB7\u0F90\u0FB5a\u02BE\u1F00\u03B9\u1F01\u03B9\u1F02\u03B9\u1F03\u03B9\u1F04\u03B9\u1F05\u03B9\u1F06\u03B9\u1F07\u03B9\u1F20\u03B9\u1F21\u03B9\u1F22\u03B9\u1F23\u03B9\u1F24\u03B9\u1F25\u03B9\u1F26\u03B9\u1F27\u03B9\u1F60\u03B9\u1F61\u03B9\u1F62\u03B9\u1F63\u03B9\u1F64\u03B9\u1F65\u03B9\u1F66\u03B9\u1F67\u03B9\u1F70\u03B9\u03B1\u03B9\u03AC\u03B9\u1FB6\u03B9 \u0342\u1F74\u03B9\u03B7\u03B9\u03AE\u03B9\u1FC6\u03B9\u1F7C\u03B9\u03C9\u03B9\u03CE\u03B9\u1FF6\u03B9 \u0333!! \u0305???!!?rs\xb0c\xb0fnosmtmivix\u2ADD\u0338 \u3099 \u309A\u3088\u308A\u30B3\u30C8333435\uCC38\uACE0\uC8FC\uC758363738394042444546474849503\u67084\u67085\u67086\u67087\u67088\u67089\u6708hgev\u30AE\u30AC\u30C7\u30B7\u30C9\u30EB\u30CA\u30CE\u30D4\u30B3\u30D3\u30EB\u30DA\u30BD\u30DB\u30F3\u30EA\u30E9\u30EC\u30E0daauovpciu\u5E73\u6210\u662D\u548C\u5927\u6B63\u660E\u6CBBna\u03BCakakbmbgbpfnf\u03BCf\u03BCgmg\u03BClmldlklfmnm\u03BCmpsns\u03BCsmsnv\u03BCvkvpwnw\u03BCwmwkwk\u03C9m\u03C9bqcccddbgyhainkkktlnlxphprsrsvwbst\u0574\u0576\u0574\u0565\u0574\u056B\u057E\u0576\u0574\u056D\u05D9\u05B4\u05F2\u05B7\u05E9\u05C1\u05E9\u05C2\u05D0\u05B7\u05D0\u05B8\u05D0\u05BC\u05D1\u05BC\u05D2\u05BC\u05D3\u05BC\u05D4\u05BC\u05D5\u05BC\u05D6\u05BC\u05D8\u05BC\u05D9\u05BC\u05DA\u05BC\u05DB\u05BC\u05DC\u05BC\u05DE\u05BC\u05E0\u05BC\u05E1\u05BC\u05E3\u05BC\u05E4\u05BC\u05E6\u05BC\u05E7\u05BC\u05E8\u05BC\u05EA\u05BC\u05D5\u05B9\u05D1\u05BF\u05DB\u05BF\u05E4\u05BF\u05D0\u05DC\u0626\u0627\u0626\u06D5\u0626\u0648\u0626\u06C7\u0626\u06C6\u0626\u06C8\u0626\u06D0\u0626\u0649\u0626\u062C\u0626\u062D\u0626\u0645\u0626\u064A\u0628\u062C\u0628\u0645\u0628\u0649\u0628\u064A\u062A\u0649\u062A\u064A\u062B\u062C\u062B\u0645\u062B\u0649\u062B\u064A\u062E\u062D\u0636\u062C\u0636\u0645\u0637\u062D\u0638\u0645\u063A\u062C\u0641\u062C\u0641\u062D\u0641\u0649\u0641\u064A\u0642\u062D\u0642\u0649\u0642\u064A\u0643\u0627\u0643\u062C\u0643\u062D\u0643\u062E\u0643\u0644\u0643\u0649\u0643\u064A\u0646\u062E\u0646\u0649\u0646\u064A\u0647\u062C\u0647\u0649\u0647\u064A\u064A\u0649\u0630\u0670\u0631\u0670\u0649\u0670\u0626\u0631\u0626\u0632\u0626\u0646\u0628\u0632\u0628\u0646\u062A\u0631\u062A\u0632\u062A\u0646\u062B\u0631\u062B\u0632\u062B\u0646\u0645\u0627\u0646\u0631\u0646\u0632\u0646\u0646\u064A\u0631\u064A\u0632\u0626\u062E\u0626\u0647\u0628\u0647\u062A\u0647\u0635\u062E\u0646\u0647\u0647\u0670\u062B\u0647\u0633\u0647\u0634\u0647\u0637\u0649\u0637\u064A\u0639\u0649\u0639\u064A\u063A\u0649\u063A\u064A\u0633\u0649\u0633\u064A\u0634\u0649\u0634\u064A\u0635\u0649\u0635\u064A\u0636\u0649\u0636\u064A\u0634\u062E\u0634\u0631\u0633\u0631\u0635\u0631\u0636\u0631\u0627\u064B \u064B\u0640\u064B\u0640\u0651 \u0652\u0640\u0652\u0644\u0622\u0644\u0623\u0644\u0625\uD834\uDD57\uD834\uDD650,1,2,3,4,5,6,7,8,9,wzhvsdwcmcmddj\u307B\u304B\u30B3\u30B3\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf8\xf9\xfa\xfb\xfc\xfd\xfe\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0135\u0137\u013A\u013C\u013E\u0142\u0144\u0146\u0148\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\xff\u017A\u017C\u0253\u0183\u0185\u0254\u0188\u0256\u0257\u018C\u01DD\u0259\u025B\u0192\u0260\u0263\u0269\u0268\u0199\u026F\u0272\u0275\u01A1\u01A3\u01A5\u0280\u01A8\u0283\u01AD\u0288\u01B0\u028A\u028B\u01B4\u01B6\u0292\u01B9\u01BD\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F5\u0195\u01BF\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u019E\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233\u2C65\u023C\u019A\u2C66\u0242\u0180\u0289\u028C\u0247\u0249\u024B\u024D\u024F\u0266\u0279\u027B\u0281\u0295\u0371\u0373\u02B9\u0377;\u03F3\u03AD\u03AF\u03CC\u03CD\u03B2\u03B3\u03B4\u03B5\u03B6\u03B8\u03BA\u03BB\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03CA\u03CB\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF\u03F8\u03FB\u037B\u037C\u037D\u0450\u0451\u0452\u0453\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\u045D\u045E\u045F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561\u0562\u0563\u0564\u0566\u0567\u0568\u0569\u056A\u056C\u056E\u056F\u0570\u0571\u0572\u0573\u0575\u0577\u0578\u0579\u057A\u057B\u057C\u057D\u057F\u0580\u0581\u0583\u0584\u0585\u0586\u0F0B\u2D27\u2D2D\u10DC\u13F0\u13F1\u13F2\u13F3\u13F4\u13F5\uA64B\u0250\u0251\u1D02\u025C\u1D16\u1D17\u1D1D\u1D25\u0252\u0255\u025F\u0261\u0265\u026A\u1D7B\u029D\u026D\u1D85\u029F\u0271\u0270\u0273\u0274\u0278\u0282\u01AB\u1D1C\u0290\u0291\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF\u1F10\u1F11\u1F12\u1F13\u1F14\u1F15\u1F30\u1F31\u1F32\u1F33\u1F34\u1F35\u1F36\u1F37\u1F40\u1F41\u1F42\u1F43\u1F44\u1F45\u1F51\u1F53\u1F55\u1F57\u1FB0\u1FB1\u1F72\u0390\u1FD0\u1FD1\u1F76\u03B0\u1FE0\u1FE1\u1F7A\u1FE5`\u1F78\u2010+\u2212\u2211\u3008\u3009\u2C30\u2C31\u2C32\u2C33\u2C34\u2C35\u2C36\u2C37\u2C38\u2C39\u2C3A\u2C3B\u2C3C\u2C3D\u2C3E\u2C3F\u2C40\u2C41\u2C42\u2C43\u2C44\u2C45\u2C46\u2C47\u2C48\u2C49\u2C4A\u2C4B\u2C4C\u2C4D\u2C4E\u2C4F\u2C50\u2C51\u2C52\u2C53\u2C54\u2C55\u2C56\u2C57\u2C58\u2C59\u2C5A\u2C5B\u2C5C\u2C5D\u2C5E\u2C61\u026B\u1D7D\u027D\u2C68\u2C6A\u2C6C\u2C73\u2C76\u023F\u0240\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CEC\u2CEE\u2CF3\u2D61\u6BCD\u9F9F\u4E28\u4E36\u4E3F\u4E59\u4E85\u4EA0\u4EBA\u513F\u5165\u5182\u5196\u51AB\u51E0\u51F5\u5200\u529B\u52F9\u5315\u531A\u5338\u535C\u5369\u5382\u53B6\u53C8\u53E3\u56D7\u58EB\u5902\u590A\u5915\u5973\u5B50\u5B80\u5BF8\u5C0F\u5C22\u5C38\u5C6E\u5C71\u5DDB\u5DE5\u5DF1\u5DFE\u5E72\u5E7A\u5E7F\u5EF4\u5EFE\u5F0B\u5F13\u5F50\u5F61\u5F73\u5FC3\u6208\u6236\u624B\u652F\u6534\u6587\u6597\u65A4\u65B9\u65E0\u66F0\u6B20\u6B62\u6B79\u6BB3\u6BCB\u6BD4\u6BDB\u6C0F\u6C14\u722A\u7236\u723B\u723F\u7247\u7259\u725B\u72AC\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7530\u758B\u7592\u7676\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79B8\u79BE\u7A74\u7ACB\u7AF9\u7C73\u7CF8\u7F36\u7F51\u7F8A\u7FBD\u8001\u800C\u8012\u8033\u807F\u8089\u81E3\u81FC\u820C\u821B\u821F\u826E\u8272\u8278\u864D\u866B\u8840\u884C\u8863\u897E\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C78\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FB5\u9091\u9149\u91C6\u91CC\u9577\u9580\u961C\u96B6\u96B9\u96E8\u9751\u975E\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u99AC\u9AA8\u9AD8\u9ADF\u9B25\u9B2F\u9B32\u9B3C\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u9EC3\u9ECD\u9ED1\u9EF9\u9EFD\u9F0E\u9F13\u9F20\u9F3B\u9F4A\u9F52\u9F8D\u9F9C\u9FA0.\u3012\u5344\u5345\u1101\u11AA\u11AC\u11AD\u1104\u11B0\u11B1\u11B2\u11B3\u11B4\u11B5\u111A\u1108\u1121\u110A\u110D\u1161\u1162\u1163\u1164\u1165\u1166\u1167\u1168\u1169\u116A\u116B\u116C\u116D\u116E\u116F\u1170\u1171\u1172\u1173\u1174\u1175\u1114\u1115\u11C7\u11C8\u11CC\u11CE\u11D3\u11D7\u11D9\u111C\u11DD\u11DF\u111D\u111E\u1120\u1122\u1123\u1127\u1129\u112B\u112C\u112D\u112E\u112F\u1132\u1136\u1140\u1147\u114C\u11F1\u11F2\u1157\u1158\u1159\u1184\u1185\u1188\u1191\u1192\u1194\u119E\u11A1\u4E0A\u4E2D\u4E0B\u7532\u4E19\u4E01\u5929\u5730\u554F\u5E7C\u7B8F\uC6B0\u79D8\u7537\u9069\u512A\u5370\u6CE8\u9805\u5199\u5DE6\u53F3\u533B\u5B97\u591C\u30C6\u30CC\u30E2\u30E8\u30F0\u30F1\u30F2\uA641\uA643\uA645\uA647\uA649\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA77A\uA77C\u1D79\uA77F\uA781\uA783\uA785\uA787\uA78C\uA791\uA793\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\u026C\u029E\u0287\uAB53\uA7B5\uA7B7\uAB37\uAB52\u13A0\u13A1\u13A2\u13A3\u13A4\u13A5\u13A6\u13A7\u13A8\u13A9\u13AA\u13AB\u13AC\u13AD\u13AE\u13AF\u13B0\u13B1\u13B2\u13B3\u13B4\u13B5\u13B6\u13B7\u13B8\u13B9\u13BA\u13BB\u13BC\u13BD\u13BE\u13BF\u13C0\u13C1\u13C2\u13C3\u13C4\u13C5\u13C6\u13C7\u13C8\u13C9\u13CA\u13CB\u13CC\u13CD\u13CE\u13CF\u13D0\u13D1\u13D2\u13D3\u13D4\u13D5\u13D6\u13D7\u13D8\u13D9\u13DA\u13DB\u13DC\u13DD\u13DE\u13DF\u13E0\u13E1\u13E2\u13E3\u13E4\u13E5\u13E6\u13E7\u13E8\u13E9\u13EA\u13EB\u13EC\u13ED\u13EE\u13EF\u8C48\u66F4\u8CC8\u6ED1\u4E32\u53E5\u5951\u5587\u5948\u61F6\u7669\u7F85\u863F\u87BA\u88F8\u908F\u6A02\u6D1B\u70D9\u73DE\u843D\u916A\u99F1\u4E82\u5375\u6B04\u721B\u862D\u9E1E\u5D50\u6FEB\u85CD\u8964\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u90CE\u4F86\u51B7\u52DE\u64C4\u6AD3\u7210\u76E7\u8606\u865C\u8DEF\u9732\u9B6F\u9DFA\u788C\u797F\u7DA0\u83C9\u9304\u8AD6\u58DF\u5F04\u7C60\u807E\u7262\u78CA\u8CC2\u96F7\u58D8\u5C62\u6A13\u6DDA\u6F0F\u7D2F\u7E37\u964B\u52D2\u808B\u51DC\u51CC\u7A1C\u7DBE\u83F1\u9675\u8B80\u62CF\u8AFE\u4E39\u5BE7\u6012\u7387\u7570\u5317\u78FB\u4FBF\u5FA9\u4E0D\u6CCC\u6578\u7D22\u53C3\u585E\u7701\u8449\u8AAA\u6BBA\u6C88\u62FE\u82E5\u63A0\u7565\u4EAE\u5169\u51C9\u6881\u7CE7\u826F\u8AD2\u91CF\u52F5\u5442\u5EEC\u65C5\u6FFE\u792A\u95AD\u9A6A\u9E97\u9ECE\u66C6\u6B77\u8F62\u5E74\u6190\u6200\u649A\u6F23\u7149\u7489\u79CA\u7DF4\u806F\u8F26\u84EE\u9023\u934A\u5217\u52A3\u54BD\u70C8\u88C2\u5EC9\u5FF5\u637B\u6BAE\u7C3E\u7375\u4EE4\u56F9\u5DBA\u601C\u73B2\u7469\u7F9A\u8046\u9234\u96F6\u9748\u9818\u4F8B\u79AE\u91B4\u96B8\u60E1\u4E86\u50DA\u5BEE\u5C3F\u6599\u71CE\u7642\u84FC\u907C\u6688\u962E\u5289\u677B\u67F3\u6D41\u6E9C\u7409\u7559\u786B\u7D10\u985E\u622E\u9678\u502B\u5D19\u6DEA\u8F2A\u5F8B\u6144\u6817\u9686\u5229\u540F\u5C65\u6613\u674E\u68A8\u6CE5\u7406\u75E2\u7F79\u88CF\u88E1\u96E2\u533F\u6EBA\u541D\u71D0\u7498\u85FA\u96A3\u9C57\u9E9F\u6797\u6DCB\u81E8\u7B20\u7C92\u72C0\u7099\u8B58\u4EC0\u8336\u523A\u5207\u5EA6\u62D3\u7CD6\u5B85\u6D1E\u66B4\u8F3B\u964D\u5ED3\u5140\u55C0\u585A\u6674\u51DE\u732A\u76CA\u793C\u795E\u7965\u798F\u9756\u7CBE\u8612\u8AF8\u9038\u90FD\u98EF\u98FC\u9928\u9DB4\u90DE\u96B7\u4FAE\u50E7\u514D\u52C9\u52E4\u5351\u559D\u5606\u5668\u5840\u58A8\u5C64\u6094\u6168\u618E\u61F2\u654F\u65E2\u6691\u6885\u6D77\u6E1A\u6F22\u716E\u722B\u7422\u7891\u7949\u7948\u7950\u7956\u798D\u798E\u7A40\u7A81\u7BC0\u7E09\u7E41\u7F72\u8005\u81ED\u8279\u8457\u8910\u8996\u8B01\u8B39\u8CD3\u8D08\u8FB6\u96E3\u97FF\u983B\u6075\uD850\uDEEE\u8218\u4E26\u51B5\u5168\u4F80\u5145\u5180\u52C7\u52FA\u5555\u5599\u55E2\u58B3\u5944\u5954\u5A62\u5B28\u5ED2\u5ED9\u5F69\u5FAD\u60D8\u614E\u6108\u6160\u6234\u63C4\u641C\u6452\u6556\u671B\u6756\u6EDB\u6ECB\u701E\u77A7\u7235\u72AF\u7471\u7506\u753B\u761D\u761F\u76DB\u76F4\u774A\u7740\u78CC\u7AB1\u7C7B\u7D5B\u7F3E\u8352\u83EF\u8779\u8941\u8986\u8ABF\u8ACB\u8AED\u8B8A\u8F38\u9072\u9199\u9276\u967C\u97DB\u980B\u9B12\uD84A\uDC4A\uD84A\uDC44\uD84C\uDFD5\u3B9D\u4018\u4039\uD854\uDE49\uD857\uDCD0\uD85F\uDED3\u9F43\u9F8E\u05E2\u05DD\u0671\u067B\u067E\u0680\u067A\u067F\u0679\u06A4\u06A6\u0684\u0683\u0686\u0687\u068D\u068C\u068E\u0688\u0698\u0691\u06A9\u06AF\u06B3\u06B1\u06BA\u06BB\u06C0\u06C1\u06BE\u06D3\u06AD\u06CB\u06C5\u06C9\u3001\u3016\u3017\u2014\u2013_{}\u3010\u3011\u300A\u300B\u300C\u300D\u300E\u300F[]#&*-<>\\$%@\u0621\u0624\u0629\"'^|~\u2985\u2986\u30FB\u30A5\u30E3\xa2\xa3\xac\xa6\xa5\u20A9\u2502\u2190\u2191\u2192\u2193\u25A0\u25CB\uD801\uDC28\uD801\uDC29\uD801\uDC2A\uD801\uDC2B\uD801\uDC2C\uD801\uDC2D\uD801\uDC2E\uD801\uDC2F\uD801\uDC30\uD801\uDC31\uD801\uDC32\uD801\uDC33\uD801\uDC34\uD801\uDC35\uD801\uDC36\uD801\uDC37\uD801\uDC38\uD801\uDC39\uD801\uDC3A\uD801\uDC3B\uD801\uDC3C\uD801\uDC3D\uD801\uDC3E\uD801\uDC3F\uD801\uDC40\uD801\uDC41\uD801\uDC42\uD801\uDC43\uD801\uDC44\uD801\uDC45\uD801\uDC46\uD801\uDC47\uD801\uDC48\uD801\uDC49\uD801\uDC4A\uD801\uDC4B\uD801\uDC4C\uD801\uDC4D\uD801\uDC4E\uD801\uDC4F\uD801\uDCD8\uD801\uDCD9\uD801\uDCDA\uD801\uDCDB\uD801\uDCDC\uD801\uDCDD\uD801\uDCDE\uD801\uDCDF\uD801\uDCE0\uD801\uDCE1\uD801\uDCE2\uD801\uDCE3\uD801\uDCE4\uD801\uDCE5\uD801\uDCE6\uD801\uDCE7\uD801\uDCE8\uD801\uDCE9\uD801\uDCEA\uD801\uDCEB\uD801\uDCEC\uD801\uDCED\uD801\uDCEE\uD801\uDCEF\uD801\uDCF0\uD801\uDCF1\uD801\uDCF2\uD801\uDCF3\uD801\uDCF4\uD801\uDCF5\uD801\uDCF6\uD801\uDCF7\uD801\uDCF8\uD801\uDCF9\uD801\uDCFA\uD801\uDCFB\uD803\uDCC0\uD803\uDCC1\uD803\uDCC2\uD803\uDCC3\uD803\uDCC4\uD803\uDCC5\uD803\uDCC6\uD803\uDCC7\uD803\uDCC8\uD803\uDCC9\uD803\uDCCA\uD803\uDCCB\uD803\uDCCC\uD803\uDCCD\uD803\uDCCE\uD803\uDCCF\uD803\uDCD0\uD803\uDCD1\uD803\uDCD2\uD803\uDCD3\uD803\uDCD4\uD803\uDCD5\uD803\uDCD6\uD803\uDCD7\uD803\uDCD8\uD803\uDCD9\uD803\uDCDA\uD803\uDCDB\uD803\uDCDC\uD803\uDCDD\uD803\uDCDE\uD803\uDCDF\uD803\uDCE0\uD803\uDCE1\uD803\uDCE2\uD803\uDCE3\uD803\uDCE4\uD803\uDCE5\uD803\uDCE6\uD803\uDCE7\uD803\uDCE8\uD803\uDCE9\uD803\uDCEA\uD803\uDCEB\uD803\uDCEC\uD803\uDCED\uD803\uDCEE\uD803\uDCEF\uD803\uDCF0\uD803\uDCF1\uD803\uDCF2\uD806\uDCC0\uD806\uDCC1\uD806\uDCC2\uD806\uDCC3\uD806\uDCC4\uD806\uDCC5\uD806\uDCC6\uD806\uDCC7\uD806\uDCC8\uD806\uDCC9\uD806\uDCCA\uD806\uDCCB\uD806\uDCCC\uD806\uDCCD\uD806\uDCCE\uD806\uDCCF\uD806\uDCD0\uD806\uDCD1\uD806\uDCD2\uD806\uDCD3\uD806\uDCD4\uD806\uDCD5\uD806\uDCD6\uD806\uDCD7\uD806\uDCD8\uD806\uDCD9\uD806\uDCDA\uD806\uDCDB\uD806\uDCDC\uD806\uDCDD\uD806\uDCDE\uD806\uDCDF\u0131\u0237\u2207\u2202\uD83A\uDD22\uD83A\uDD23\uD83A\uDD24\uD83A\uDD25\uD83A\uDD26\uD83A\uDD27\uD83A\uDD28\uD83A\uDD29\uD83A\uDD2A\uD83A\uDD2B\uD83A\uDD2C\uD83A\uDD2D\uD83A\uDD2E\uD83A\uDD2F\uD83A\uDD30\uD83A\uDD31\uD83A\uDD32\uD83A\uDD33\uD83A\uDD34\uD83A\uDD35\uD83A\uDD36\uD83A\uDD37\uD83A\uDD38\uD83A\uDD39\uD83A\uDD3A\uD83A\uDD3B\uD83A\uDD3C\uD83A\uDD3D\uD83A\uDD3E\uD83A\uDD3F\uD83A\uDD40\uD83A\uDD41\uD83A\uDD42\uD83A\uDD43\u066E\u06A1\u066F\u5B57\u53CC\u591A\u89E3\u4EA4\u6620\u7121\u524D\u5F8C\u518D\u65B0\u521D\u7D42\u8CA9\u58F0\u5439\u6F14\u6295\u6355\u904A\u6307\u7981\u7A7A\u5408\u6E80\u7533\u5272\u55B6\u914D\u5F97\u53EF\u4E3D\u4E38\u4E41\uD840\uDD22\u4F60\u4FBB\u5002\u507A\u5099\u50CF\u349E\uD841\uDE3A\u5154\u5164\u5177\uD841\uDD1C\u34B9\u5167\uD841\uDD4B\u5197\u51A4\u4ECC\u51AC\uD864\uDDDF\u5203\u34DF\u523B\u5246\u5277\u3515\u5305\u5306\u5349\u535A\u5373\u537D\u537F\uD842\uDE2C\u7070\u53CA\u53DF\uD842\uDF63\u53EB\u53F1\u5406\u549E\u5438\u5448\u5468\u54A2\u54F6\u5510\u5553\u5563\u5584\u55AB\u55B3\u55C2\u5716\u5717\u5651\u5674\u58EE\u57CE\u57F4\u580D\u578B\u5832\u5831\u58AC\uD845\uDCE4\u58F2\u58F7\u5906\u5922\u5962\uD845\uDEA8\uD845\uDEEA\u59EC\u5A1B\u5A27\u59D8\u5A66\u36EE\u5B08\u5B3E\uD846\uDDC8\u5BC3\u5BD8\u5BF3\uD846\uDF18\u5BFF\u5C06\u3781\u5C60\u5CC0\u5C8D\uD847\uDDE4\u5D43\uD847\uDDE6\u5D6E\u5D6B\u5D7C\u5DE1\u5DE2\u382F\u5DFD\u5E28\u5E3D\u5E69\u3862\uD848\uDD83\u387C\u5EB0\u5EB3\u5EB6\uD868\uDF92\uD848\uDF31\u8201\u5F22\u38C7\uD84C\uDEB8\uD858\uDDDA\u5F62\u5F6B\u38E3\u5F9A\u5FCD\u5FD7\u5FF9\u6081\u393A\u391C\uD849\uDED4\u60C7\u6148\u614C\u617A\u61B2\u61A4\u61AF\u61DE\u621B\u625D\u62B1\u62D4\u6350\uD84A\uDF0C\u633D\u62FC\u6368\u6383\u63E4\uD84A\uDFF1\u6422\u63C5\u63A9\u3A2E\u6469\u647E\u649D\u6477\u3A6C\u656C\uD84C\uDC0A\u65E3\u66F8\u6649\u3B19\u3B08\u3AE4\u5192\u5195\u6700\u669C\u80AD\u43D9\u6721\u675E\u6753\uD84C\uDFC3\u3B49\u67FA\u6785\u6852\uD84D\uDC6D\u688E\u681F\u6914\u6942\u69A3\u69EA\u6AA8\uD84D\uDEA3\u6ADB\u3C18\u6B21\uD84E\uDCA7\u6B54\u3C4E\u6B72\u6B9F\u6BBB\uD84E\uDE8D\uD847\uDD0B\uD84E\uDEFA\u6C4E\uD84F\uDCBC\u6CBF\u6CCD\u6C67\u6D16\u6D3E\u6D69\u6D78\u6D85\uD84F\uDD1E\u6D34\u6E2F\u6E6E\u3D33\u6EC7\uD84F\uDED1\u6DF9\u6F6E\uD84F\uDF5E\uD84F\uDF8E\u6FC6\u7039\u701B\u3D96\u704A\u707D\u7077\u70AD\uD841\uDD25\u7145\uD850\uDE63\u719C\u7228\u7250\uD851\uDE08\u7280\u7295\uD851\uDF35\uD852\uDC14\u737A\u738B\u3EAC\u73A5\u3EB8\u7447\u745C\u7485\u74CA\u3F1B\u7524\uD853\uDC36\u753E\uD853\uDC92\uD848\uDD9F\u7610\uD853\uDFA1\uD853\uDFB8\uD854\uDC44\u3FFC\u4008\uD854\uDCF3\uD854\uDCF2\uD854\uDD19\uD854\uDD33\u771E\u771F\u778B\u4046\u4096\uD855\uDC1D\u784E\u40E3\uD855\uDE26\uD855\uDE9A\uD855\uDEC5\u79EB\u412F\u7A4A\u7A4F\uD856\uDD7C\uD856\uDEA7\u4202\uD856\uDFAB\u7BC6\u7BC9\u4227\uD857\uDC80\u7CD2\u42A0\u7CE8\u7CE3\u7D00\uD857\uDF86\u7D63\u4301\u7DC7\u7E02\u7E45\u4334\uD858\uDE28\uD858\uDE47\u4359\uD858\uDED9\u7F7A\uD858\uDF3E\u7F95\u7FFA\uD859\uDCDA\uD859\uDD23\u8060\uD859\uDDA8\u8070\uD84C\uDF5F\u43D5\u80B2\u8103\u440B\u813E\u5AB5\uD859\uDFA7\uD859\uDFB5\uD84C\uDF93\uD84C\uDF9C\u8204\u8F9E\u446B\u8291\u828B\u829D\u52B3\u82B1\u82B3\u82BD\u82E6\uD85A\uDF3C\u831D\u8363\u83AD\u8323\u83BD\u83E7\u8353\u83CA\u83CC\u83DC\uD85B\uDC36\uD85B\uDD6B\uD85B\uDCD5\u452B\u84F1\u84F3\u8516\uD85C\uDFCA\u8564\uD85B\uDF2C\u455D\u4561\uD85B\uDFB1\uD85C\uDCD2\u456B\u8650\u8667\u8669\u86A9\u8688\u870E\u86E2\u8728\u876B\u8786\u87E1\u8801\u45F9\u8860\uD85D\uDE67\u88D7\u88DE\u4635\u88FA\u34BB\uD85E\uDCAE\uD85E\uDD66\u46BE\u46C7\u8AA0\uD85F\uDCA8\u8CAB\u8CC1\u8D1B\u8D77\uD85F\uDF2F\uD842\uDC04\u8DCB\u8DBC\u8DF0\uD842\uDCDE\u8ED4\uD861\uDDD2\uD861\uDDED\u9094\u90F1\u9111\uD861\uDF2E\u911B\u9238\u92D7\u92D8\u927C\u93F9\u9415\uD862\uDFFA\u958B\u4995\u95B7\uD863\uDD77\u49E6\u96C3\u5DB2\u9723\uD864\uDD45\uD864\uDE1A\u4A6E\u4A76\u97E0\uD865\uDC0A\u4AB2\uD865\uDC96\u9829\uD865\uDDB6\u98E2\u4B33\u9929\u99A7\u99C2\u99FE\u4BCE\uD866\uDF30\u9C40\u9CFD\u4CCE\u4CED\u9D67\uD868\uDCCE\u4CF8\uD868\uDD05\uD868\uDE0E\uD868\uDE91\u4D56\u9EFE\u9F05\u9F0F\u9F16\uD869\uDE00";
    function mapChar(codePoint) {
        if (codePoint >= 0x30000) {
            // High planes are special cased.
            if (codePoint >= 0xE0100 && codePoint <= 0xE01EF) return 18874368;
            return 0;
        }
        return blocks[blockIdxes[codePoint >> 4]][codePoint & 15];
    }
    return {
        mapStr: mappingStr,
        mapChar: mapChar
    };
});

});



parcelRegister("5gTLh", function(module, exports) {
"use strict";
var $3d69b3719fe37bf8$var$REGISTRY = [
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "resolver",
        "outputs": [
            {
                "name": "",
                "type": "address"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "owner",
        "outputs": [
            {
                "name": "",
                "type": "address"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "label",
                "type": "bytes32"
            },
            {
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "setSubnodeOwner",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "ttl",
                "type": "uint64"
            }
        ],
        "name": "setTTL",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "ttl",
        "outputs": [
            {
                "name": "",
                "type": "uint64"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "resolver",
                "type": "address"
            }
        ],
        "name": "setResolver",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "setOwner",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "Transfer",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": true,
                "name": "label",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "NewOwner",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "resolver",
                "type": "address"
            }
        ],
        "name": "NewResolver",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "ttl",
                "type": "uint64"
            }
        ],
        "name": "NewTTL",
        "type": "event"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "bytes32",
                "name": "node",
                "type": "bytes32"
            },
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "resolver",
                "type": "address"
            },
            {
                "internalType": "uint64",
                "name": "ttl",
                "type": "uint64"
            }
        ],
        "name": "setRecord",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "setApprovalForAll",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "ApprovalForAll",
        "type": "event"
    },
    {
        "constant": true,
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            }
        ],
        "name": "isApprovedForAll",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "internalType": "bytes32",
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "recordExists",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "bytes32",
                "name": "node",
                "type": "bytes32"
            },
            {
                "internalType": "bytes32",
                "name": "label",
                "type": "bytes32"
            },
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "resolver",
                "type": "address"
            },
            {
                "internalType": "uint64",
                "name": "ttl",
                "type": "uint64"
            }
        ],
        "name": "setSubnodeRecord",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    }
];
module.exports = $3d69b3719fe37bf8$var$REGISTRY;

});

parcelRegister("bYaXC", function(module, exports) {
"use strict";
var $8b6dccd56e3c777d$var$RESOLVER = [
    {
        "constant": true,
        "inputs": [
            {
                "name": "interfaceID",
                "type": "bytes4"
            }
        ],
        "name": "supportsInterface",
        "outputs": [
            {
                "name": "",
                "type": "bool"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "contentTypes",
                "type": "uint256"
            }
        ],
        "name": "ABI",
        "outputs": [
            {
                "name": "contentType",
                "type": "uint256"
            },
            {
                "name": "data",
                "type": "bytes"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "hash",
                "type": "bytes"
            }
        ],
        "name": "setMultihash",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "multihash",
        "outputs": [
            {
                "name": "",
                "type": "bytes"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "x",
                "type": "bytes32"
            },
            {
                "name": "y",
                "type": "bytes32"
            }
        ],
        "name": "setPubkey",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "content",
        "outputs": [
            {
                "name": "ret",
                "type": "bytes32"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "addr",
        "outputs": [
            {
                "name": "ret",
                "type": "address"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "contentType",
                "type": "uint256"
            },
            {
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "setABI",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "name",
        "outputs": [
            {
                "name": "ret",
                "type": "string"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "name",
                "type": "string"
            }
        ],
        "name": "setName",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "hash",
                "type": "bytes32"
            }
        ],
        "name": "setContent",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "pubkey",
        "outputs": [
            {
                "name": "x",
                "type": "bytes32"
            },
            {
                "name": "y",
                "type": "bytes32"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "addr",
                "type": "address"
            }
        ],
        "name": "setAddr",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "inputs": [
            {
                "name": "ensAddr",
                "type": "address"
            }
        ],
        "payable": false,
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "a",
                "type": "address"
            }
        ],
        "name": "AddrChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "hash",
                "type": "bytes32"
            }
        ],
        "name": "ContentChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "name",
                "type": "string"
            }
        ],
        "name": "NameChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": true,
                "name": "contentType",
                "type": "uint256"
            }
        ],
        "name": "ABIChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "x",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "y",
                "type": "bytes32"
            }
        ],
        "name": "PubkeyChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "hash",
                "type": "bytes"
            }
        ],
        "name": "ContenthashChanged",
        "type": "event"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "contenthash",
        "outputs": [
            {
                "name": "",
                "type": "bytes"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "hash",
                "type": "bytes"
            }
        ],
        "name": "setContenthash",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    }
];
module.exports = $8b6dccd56e3c777d$var$RESOLVER;

});


parcelRegister("iTVdc", function(module, exports) {
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file ResolverMethodHandler.js
 *
 * @author Samuel Furter <samuel@ethereum.org>
 * @date 2018
 */ "use strict";

var $4wdBS = parcelRequire("4wdBS");

var $6Wdcs = parcelRequire("6Wdcs");

var $hA2kM = parcelRequire("hA2kM");
var $dc29be1f8e9c1cbf$require$errors = $hA2kM.errors;

var $2pEPc = parcelRequire("2pEPc");
var $dc29be1f8e9c1cbf$require$interfaceIds = $2pEPc.interfaceIds;
/**
 * @param {Registry} registry
 * @constructor
 */ function $dc29be1f8e9c1cbf$var$ResolverMethodHandler(registry) {
    this.registry = registry;
}
/**
 * Executes an resolver method and returns an eventifiedPromise
 *
 * @param {string} ensName
 * @param {string} methodName
 * @param {array} methodArguments
 * @param {function} callback
 * @returns {Object}
 */ $dc29be1f8e9c1cbf$var$ResolverMethodHandler.prototype.method = function(ensName, methodName, methodArguments, outputFormatter, callback) {
    return {
        call: this.call.bind({
            ensName: ensName,
            methodName: methodName,
            methodArguments: methodArguments,
            callback: callback,
            parent: this,
            outputFormatter: outputFormatter
        }),
        send: this.send.bind({
            ensName: ensName,
            methodName: methodName,
            methodArguments: methodArguments,
            callback: callback,
            parent: this
        })
    };
};
/**
 * Executes call
 *
 * @returns {eventifiedPromise}
 */ $dc29be1f8e9c1cbf$var$ResolverMethodHandler.prototype.call = function(callback) {
    var self = this;
    var promiEvent = new $4wdBS();
    var preparedArguments = this.parent.prepareArguments(this.ensName, this.methodArguments);
    var outputFormatter = this.outputFormatter || null;
    this.parent.registry.getResolver(this.ensName).then(async function(resolver) {
        await self.parent.checkInterfaceSupport(resolver, self.methodName);
        self.parent.handleCall(promiEvent, resolver.methods[self.methodName], preparedArguments, outputFormatter, callback);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Executes send
 *
 * @param {Object} sendOptions
 * @param {function} callback
 * @returns {eventifiedPromise}
 */ $dc29be1f8e9c1cbf$var$ResolverMethodHandler.prototype.send = function(sendOptions, callback) {
    var self = this;
    var promiEvent = new $4wdBS();
    var preparedArguments = this.parent.prepareArguments(this.ensName, this.methodArguments);
    this.parent.registry.getResolver(this.ensName).then(async function(resolver) {
        await self.parent.checkInterfaceSupport(resolver, self.methodName);
        self.parent.handleSend(promiEvent, resolver.methods[self.methodName], preparedArguments, sendOptions, callback);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Handles a call method
 *
 * @param {eventifiedPromise} promiEvent
 * @param {function} method
 * @param {array} preparedArguments
 * @param {function} callback
 * @returns {eventifiedPromise}
 */ $dc29be1f8e9c1cbf$var$ResolverMethodHandler.prototype.handleCall = function(promiEvent, method, preparedArguments, outputFormatter, callback) {
    method.apply(this, preparedArguments).call().then(function(result) {
        if (outputFormatter) result = outputFormatter(result);
        if (typeof callback === 'function') {
            // It's required to pass the receipt to the second argument to be backwards compatible and to have the required consistency
            callback(result, result);
            return;
        }
        promiEvent.resolve(result);
    }).catch(function(error) {
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent;
};
/**
 * Handles a send method
 *
 * @param {eventifiedPromise} promiEvent
 * @param {function} method
 * @param {array} preparedArguments
 * @param {Object} sendOptions
 * @param {function} callback
 * @returns {eventifiedPromise}
 */ $dc29be1f8e9c1cbf$var$ResolverMethodHandler.prototype.handleSend = function(promiEvent, method, preparedArguments, sendOptions, callback) {
    method.apply(this, preparedArguments).send(sendOptions).on('sending', function() {
        promiEvent.eventEmitter.emit('sending');
    }).on('sent', function() {
        promiEvent.eventEmitter.emit('sent');
    }).on('transactionHash', function(hash) {
        promiEvent.eventEmitter.emit('transactionHash', hash);
    }).on('confirmation', function(confirmationNumber, receipt) {
        promiEvent.eventEmitter.emit('confirmation', confirmationNumber, receipt);
    }).on('receipt', function(receipt) {
        promiEvent.eventEmitter.emit('receipt', receipt);
        promiEvent.resolve(receipt);
        if (typeof callback === 'function') // It's required to pass the receipt to the second argument to be backwards compatible and to have the required consistency
        callback(receipt, receipt);
    }).on('error', function(error) {
        promiEvent.eventEmitter.emit('error', error);
        if (typeof callback === 'function') {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent;
};
/**
 * Adds the ENS node to the arguments
 *
 * @param {string} name
 * @param {array} methodArguments
 *
 * @returns {array}
 */ $dc29be1f8e9c1cbf$var$ResolverMethodHandler.prototype.prepareArguments = function(name, methodArguments) {
    var node = $6Wdcs.hash(name);
    if (methodArguments.length > 0) {
        methodArguments.unshift(node);
        return methodArguments;
    }
    return [
        node
    ];
};
/**
 *
 *
 * @param {Contract} resolver
 * @param {string} methodName
 *
 * @returns {Promise}
 */ $dc29be1f8e9c1cbf$var$ResolverMethodHandler.prototype.checkInterfaceSupport = async function(resolver, methodName) {
    // Skip validation for undocumented interface ids (ex: multihash)
    if (!$dc29be1f8e9c1cbf$require$interfaceIds[methodName]) return;
    var supported = false;
    try {
        supported = await resolver.methods.supportsInterface($dc29be1f8e9c1cbf$require$interfaceIds[methodName]).call();
    } catch (err) {
        console.warn('Could not verify interface of resolver contract at "' + resolver.options.address + '". ');
    }
    if (!supported) throw $dc29be1f8e9c1cbf$require$errors.ResolverMethodMissingError(resolver.options.address, methodName);
};
module.exports = $dc29be1f8e9c1cbf$var$ResolverMethodHandler;

});

parcelRegister("i3yXV", function(module, exports) {
/*
Adapted from ensdomains/ui
https://github.com/ensdomains/ui/blob/3e62e440b53466eeec9dd1c63d73924eefbd88c1/src/utils/contents.js#L1-L85

BSD 2-Clause License

Copyright (c) 2019, Ethereum Name Service
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ 
var $f9Y1s = parcelRequire("f9Y1s");
function $d253a135e3a6eedd$var$decode(encoded) {
    var decoded = null;
    var protocolType = null;
    var error = null;
    if (encoded && encoded.error) return {
        protocolType: null,
        decoded: encoded.error
    };
    if (encoded) try {
        decoded = $f9Y1s.decode(encoded);
        var codec = $f9Y1s.getCodec(encoded);
        if (codec === 'ipfs-ns') protocolType = 'ipfs';
        else if (codec === 'swarm-ns') protocolType = 'bzz';
        else if (codec === 'onion') protocolType = 'onion';
        else if (codec === 'onion3') protocolType = 'onion3';
        else decoded = encoded;
    } catch (e) {
        error = e.message;
    }
    return {
        protocolType: protocolType,
        decoded: decoded,
        error: error
    };
}
function $d253a135e3a6eedd$var$encode(text) {
    var content, contentType;
    var encoded = false;
    if (!!text) {
        var matched = text.match(/^(ipfs|bzz|onion|onion3):\/\/(.*)/) || text.match(/\/(ipfs)\/(.*)/);
        if (matched) {
            contentType = matched[1];
            content = matched[2];
        }
        try {
            if (contentType === 'ipfs') {
                if (content.length >= 4) encoded = '0x' + $f9Y1s.fromIpfs(content);
            } else if (contentType === 'bzz') {
                if (content.length >= 4) encoded = '0x' + $f9Y1s.fromSwarm(content);
            } else if (contentType === 'onion') {
                if (content.length === 16) encoded = '0x' + $f9Y1s.encode('onion', content);
            } else if (contentType === 'onion3') {
                if (content.length === 56) encoded = '0x' + $f9Y1s.encode('onion3', content);
            } else throw new Error('Could not encode content hash: unsupported content type');
        } catch (err) {
            throw err;
        }
    }
    return encoded;
}
module.exports = {
    decode: $d253a135e3a6eedd$var$decode,
    encode: $d253a135e3a6eedd$var$encode
};

});
parcelRegister("f9Y1s", function(module, exports) {
/*
	ISC License

	Copyright (c) 2019, Pierre-Louis Despaigne

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted, provided that the above
	copyright notice and this permission notice appear in all copies.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
	WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
	MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
	ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
	WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
	ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
	OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/ 
var $e0LjF = parcelRequire("e0LjF");

var $gB0LY = parcelRequire("gB0LY");
var $b096417db9d2746b$require$hexStringToBuffer = $gB0LY.hexStringToBuffer;
var $b096417db9d2746b$require$profiles = $gB0LY.profiles;

var $tp4Kx = parcelRequire("tp4Kx");
var $b096417db9d2746b$require$cidV0ToV1Base32 = $tp4Kx.cidV0ToV1Base32;
module.exports = {
    //export some helpers functions
    helpers: {
        cidV0ToV1Base32: $b096417db9d2746b$require$cidV0ToV1Base32
    },
    /**
	* Decode a Content Hash.
	* @param {string} hash an hex string containing a content hash
	* @return {string} the decoded content
	*/ decode: function(contentHash) {
        const buffer = $b096417db9d2746b$require$hexStringToBuffer(contentHash);
        const codec = $e0LjF.getCodec(buffer);
        const value = $e0LjF.rmPrefix(buffer);
        let profile = $b096417db9d2746b$require$profiles[codec];
        if (!profile) profile = $b096417db9d2746b$require$profiles['default'];
        return profile.decode(value);
    },
    /**
	* Encode an IPFS address into a content hash
	* @param {string} ipfsHash string containing an IPFS address
	* @return {string} the resulting content hash
	*/ fromIpfs: function(ipfsHash) {
        return this.encode('ipfs-ns', ipfsHash);
    },
    /**
	* Encode a Swarm address into a content hash
	* @param {string} swarmHash string containing a Swarm address
	* @return {string} the resulting content hash
	*/ fromSwarm: function(swarmHash) {
        return this.encode('swarm-ns', swarmHash);
    },
    /**
	* General purpose encoding function
  * @param {string} codec 
  * @param {string} value 
  */ encode: function(codec, value) {
        let profile = $b096417db9d2746b$require$profiles[codec];
        if (!profile) profile = $b096417db9d2746b$require$profiles['default'];
        const encodedValue = profile.encode(value);
        return $e0LjF.addPrefix(codec, encodedValue).toString('hex');
    },
    /**
	* Extract the codec of a content hash
	* @param {string} hash hex string containing a content hash
	* @return {string} the extracted codec
	*/ getCodec: function(hash) {
        let buffer = $b096417db9d2746b$require$hexStringToBuffer(hash);
        return $e0LjF.getCodec(buffer);
    }
};

});
parcelRegister("e0LjF", function(module, exports) {
/**
 * Implementation of the multicodec specification.
 *
 * @module multicodec
 * @example
 * const multicodec = require('multicodec')
 *
 * const prefixedProtobuf = multicodec.addPrefix('protobuf', protobufBuffer)
 * // prefixedProtobuf 0x50...
 *
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $a335c4c3ecbad0cd$require$Buffer = $6ZWSX.Buffer;
'use strict';

var $bmskQ = parcelRequire("bmskQ");

var $4X73u = parcelRequire("4X73u");

var $65azp = parcelRequire("65azp");

var $ibqZm = parcelRequire("ibqZm");
exports = module.exports;
/**
 * Prefix a buffer with a multicodec-packed.
 *
 * @param {string|number} multicodecStrOrCode
 * @param {Buffer} data
 * @returns {Buffer}
 */ exports.addPrefix = (multicodecStrOrCode, data)=>{
    let prefix;
    if ($a335c4c3ecbad0cd$require$Buffer.isBuffer(multicodecStrOrCode)) prefix = $ibqZm.varintBufferEncode(multicodecStrOrCode);
    else {
        if ($65azp[multicodecStrOrCode]) prefix = $65azp[multicodecStrOrCode];
        else throw new Error('multicodec not recognized');
    }
    return $a335c4c3ecbad0cd$require$Buffer.concat([
        prefix,
        data
    ]);
};
/**
 * Decapsulate the multicodec-packed prefix from the data.
 *
 * @param {Buffer} data
 * @returns {Buffer}
 */ exports.rmPrefix = (data)=>{
    $bmskQ.decode(data);
    return data.slice($bmskQ.decode.bytes);
};
/**
 * Get the codec of the prefixed data.
 * @param {Buffer} prefixedData
 * @returns {string}
 */ exports.getCodec = (prefixedData)=>{
    const code = $bmskQ.decode(prefixedData);
    const codecName = $4X73u.get(code);
    if (codecName === undefined) throw new Error(`Code ${code} not found`);
    return codecName;
};
/**
 * Get the name of the codec.
 * @param {number} codec
 * @returns {string}
 */ exports.getName = (codec)=>{
    return $4X73u.get(codec);
};
/**
 * Get the code of the codec
 * @param {string} name
 * @returns {number}
 */ exports.getNumber = (name)=>{
    const code = $65azp[name];
    if (code === undefined) throw new Error('Codec `' + name + '` not found');
    return $ibqZm.varintBufferDecode(code)[0];
};
/**
 * Get the code of the prefixed data.
 * @param {Buffer} prefixedData
 * @returns {number}
 */ exports.getCode = (prefixedData)=>{
    return $bmskQ.decode(prefixedData);
};
/**
 * Get the code as varint of a codec name.
 * @param {string} codecName
 * @returns {Buffer}
 */ exports.getCodeVarint = (codecName)=>{
    const code = $65azp[codecName];
    if (code === undefined) throw new Error('Codec `' + codecName + '` not found');
    return code;
};
/**
 * Get the varint of a code.
 * @param {Number} code
 * @returns {Array.<number>}
 */ exports.getVarint = (code)=>{
    return $bmskQ.encode(code);
};

var $bXlaZ = parcelRequire("bXlaZ");
Object.assign(exports, $bXlaZ);

// Human friendly names for printing, e.g. in error messages
exports.print = (parcelRequire("aIFQN"));

});
parcelRegister("bmskQ", function(module, exports) {



module.exports = {
    encode: (parcelRequire("8Ms4A")),
    decode: (parcelRequire("g3nC5")),
    encodingLength: (parcelRequire("l5uGA"))
};

});
parcelRegister("8Ms4A", function(module, exports) {
module.exports = $6648952880436b0d$var$encode;
var $6648952880436b0d$var$MSB = 0x80, $6648952880436b0d$var$REST = 0x7F, $6648952880436b0d$var$MSBALL = ~$6648952880436b0d$var$REST, $6648952880436b0d$var$INT = Math.pow(2, 31);
function $6648952880436b0d$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $6648952880436b0d$var$INT){
        out[offset++] = num & 0xFF | $6648952880436b0d$var$MSB;
        num /= 128;
    }
    while(num & $6648952880436b0d$var$MSBALL){
        out[offset++] = num & 0xFF | $6648952880436b0d$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $6648952880436b0d$var$encode.bytes = offset - oldOffset + 1;
    return out;
}

});

parcelRegister("g3nC5", function(module, exports) {
module.exports = $baff3e42b01b23d4$var$read;
var $baff3e42b01b23d4$var$MSB = 0x80, $baff3e42b01b23d4$var$REST = 0x7F;
function $baff3e42b01b23d4$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $baff3e42b01b23d4$var$read.bytes = 0;
            throw new RangeError('Could not decode varint');
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $baff3e42b01b23d4$var$REST) << shift : (b & $baff3e42b01b23d4$var$REST) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $baff3e42b01b23d4$var$MSB);
    $baff3e42b01b23d4$var$read.bytes = counter - offset;
    return res;
}

});

parcelRegister("l5uGA", function(module, exports) {
var $f5a1de28ecdd9f47$var$N1 = Math.pow(2, 7);
var $f5a1de28ecdd9f47$var$N2 = Math.pow(2, 14);
var $f5a1de28ecdd9f47$var$N3 = Math.pow(2, 21);
var $f5a1de28ecdd9f47$var$N4 = Math.pow(2, 28);
var $f5a1de28ecdd9f47$var$N5 = Math.pow(2, 35);
var $f5a1de28ecdd9f47$var$N6 = Math.pow(2, 42);
var $f5a1de28ecdd9f47$var$N7 = Math.pow(2, 49);
var $f5a1de28ecdd9f47$var$N8 = Math.pow(2, 56);
var $f5a1de28ecdd9f47$var$N9 = Math.pow(2, 63);
module.exports = function(value) {
    return value < $f5a1de28ecdd9f47$var$N1 ? 1 : value < $f5a1de28ecdd9f47$var$N2 ? 2 : value < $f5a1de28ecdd9f47$var$N3 ? 3 : value < $f5a1de28ecdd9f47$var$N4 ? 4 : value < $f5a1de28ecdd9f47$var$N5 ? 5 : value < $f5a1de28ecdd9f47$var$N6 ? 6 : value < $f5a1de28ecdd9f47$var$N7 ? 7 : value < $f5a1de28ecdd9f47$var$N8 ? 8 : value < $f5a1de28ecdd9f47$var$N9 ? 9 : 10;
};

});


parcelRegister("4X73u", function(module, exports) {
'use strict';

var $38KcH = parcelRequire("38KcH");
// map for hexString -> codecName
const $39b2252ad9299d4c$var$nameTable = new Map();
for(const encodingName in $38KcH){
    const code = $38KcH[encodingName];
    $39b2252ad9299d4c$var$nameTable.set(code, encodingName);
}
module.exports = Object.freeze($39b2252ad9299d4c$var$nameTable);

});
parcelRegister("38KcH", function(module, exports) {
module.exports = JSON.parse("{\"identity\":0,\"ip4\":4,\"tcp\":6,\"sha1\":17,\"sha2-256\":18,\"sha2-512\":19,\"sha3-512\":20,\"sha3-384\":21,\"sha3-256\":22,\"sha3-224\":23,\"shake-128\":24,\"shake-256\":25,\"keccak-224\":26,\"keccak-256\":27,\"keccak-384\":28,\"keccak-512\":29,\"dccp\":33,\"murmur3-128\":34,\"murmur3-32\":35,\"ip6\":41,\"ip6zone\":42,\"path\":47,\"multicodec\":48,\"multihash\":49,\"multiaddr\":50,\"multibase\":51,\"dns\":53,\"dns4\":54,\"dns6\":55,\"dnsaddr\":56,\"protobuf\":80,\"cbor\":81,\"raw\":85,\"dbl-sha2-256\":86,\"rlp\":96,\"bencode\":99,\"dag-pb\":112,\"dag-cbor\":113,\"libp2p-key\":114,\"git-raw\":120,\"torrent-info\":123,\"torrent-file\":124,\"leofcoin-block\":129,\"leofcoin-tx\":130,\"leofcoin-pr\":131,\"sctp\":132,\"eth-block\":144,\"eth-block-list\":145,\"eth-tx-trie\":146,\"eth-tx\":147,\"eth-tx-receipt-trie\":148,\"eth-tx-receipt\":149,\"eth-state-trie\":150,\"eth-account-snapshot\":151,\"eth-storage-trie\":152,\"bitcoin-block\":176,\"bitcoin-tx\":177,\"zcash-block\":192,\"zcash-tx\":193,\"stellar-block\":208,\"stellar-tx\":209,\"md4\":212,\"md5\":213,\"bmt\":214,\"decred-block\":224,\"decred-tx\":225,\"ipld-ns\":226,\"ipfs-ns\":227,\"swarm-ns\":228,\"ipns-ns\":229,\"zeronet\":230,\"ed25519-pub\":237,\"dash-block\":240,\"dash-tx\":241,\"swarm-manifest\":250,\"swarm-feed\":251,\"udp\":273,\"p2p-webrtc-star\":275,\"p2p-webrtc-direct\":276,\"p2p-stardust\":277,\"p2p-circuit\":290,\"dag-json\":297,\"udt\":301,\"utp\":302,\"unix\":400,\"p2p\":421,\"ipfs\":421,\"https\":443,\"onion\":444,\"onion3\":445,\"garlic64\":446,\"garlic32\":447,\"tls\":448,\"quic\":460,\"ws\":477,\"wss\":478,\"p2p-websocket-star\":479,\"http\":480,\"json\":512,\"messagepack\":513,\"x11\":4352,\"blake2b-8\":45569,\"blake2b-16\":45570,\"blake2b-24\":45571,\"blake2b-32\":45572,\"blake2b-40\":45573,\"blake2b-48\":45574,\"blake2b-56\":45575,\"blake2b-64\":45576,\"blake2b-72\":45577,\"blake2b-80\":45578,\"blake2b-88\":45579,\"blake2b-96\":45580,\"blake2b-104\":45581,\"blake2b-112\":45582,\"blake2b-120\":45583,\"blake2b-128\":45584,\"blake2b-136\":45585,\"blake2b-144\":45586,\"blake2b-152\":45587,\"blake2b-160\":45588,\"blake2b-168\":45589,\"blake2b-176\":45590,\"blake2b-184\":45591,\"blake2b-192\":45592,\"blake2b-200\":45593,\"blake2b-208\":45594,\"blake2b-216\":45595,\"blake2b-224\":45596,\"blake2b-232\":45597,\"blake2b-240\":45598,\"blake2b-248\":45599,\"blake2b-256\":45600,\"blake2b-264\":45601,\"blake2b-272\":45602,\"blake2b-280\":45603,\"blake2b-288\":45604,\"blake2b-296\":45605,\"blake2b-304\":45606,\"blake2b-312\":45607,\"blake2b-320\":45608,\"blake2b-328\":45609,\"blake2b-336\":45610,\"blake2b-344\":45611,\"blake2b-352\":45612,\"blake2b-360\":45613,\"blake2b-368\":45614,\"blake2b-376\":45615,\"blake2b-384\":45616,\"blake2b-392\":45617,\"blake2b-400\":45618,\"blake2b-408\":45619,\"blake2b-416\":45620,\"blake2b-424\":45621,\"blake2b-432\":45622,\"blake2b-440\":45623,\"blake2b-448\":45624,\"blake2b-456\":45625,\"blake2b-464\":45626,\"blake2b-472\":45627,\"blake2b-480\":45628,\"blake2b-488\":45629,\"blake2b-496\":45630,\"blake2b-504\":45631,\"blake2b-512\":45632,\"blake2s-8\":45633,\"blake2s-16\":45634,\"blake2s-24\":45635,\"blake2s-32\":45636,\"blake2s-40\":45637,\"blake2s-48\":45638,\"blake2s-56\":45639,\"blake2s-64\":45640,\"blake2s-72\":45641,\"blake2s-80\":45642,\"blake2s-88\":45643,\"blake2s-96\":45644,\"blake2s-104\":45645,\"blake2s-112\":45646,\"blake2s-120\":45647,\"blake2s-128\":45648,\"blake2s-136\":45649,\"blake2s-144\":45650,\"blake2s-152\":45651,\"blake2s-160\":45652,\"blake2s-168\":45653,\"blake2s-176\":45654,\"blake2s-184\":45655,\"blake2s-192\":45656,\"blake2s-200\":45657,\"blake2s-208\":45658,\"blake2s-216\":45659,\"blake2s-224\":45660,\"blake2s-232\":45661,\"blake2s-240\":45662,\"blake2s-248\":45663,\"blake2s-256\":45664,\"skein256-8\":45825,\"skein256-16\":45826,\"skein256-24\":45827,\"skein256-32\":45828,\"skein256-40\":45829,\"skein256-48\":45830,\"skein256-56\":45831,\"skein256-64\":45832,\"skein256-72\":45833,\"skein256-80\":45834,\"skein256-88\":45835,\"skein256-96\":45836,\"skein256-104\":45837,\"skein256-112\":45838,\"skein256-120\":45839,\"skein256-128\":45840,\"skein256-136\":45841,\"skein256-144\":45842,\"skein256-152\":45843,\"skein256-160\":45844,\"skein256-168\":45845,\"skein256-176\":45846,\"skein256-184\":45847,\"skein256-192\":45848,\"skein256-200\":45849,\"skein256-208\":45850,\"skein256-216\":45851,\"skein256-224\":45852,\"skein256-232\":45853,\"skein256-240\":45854,\"skein256-248\":45855,\"skein256-256\":45856,\"skein512-8\":45857,\"skein512-16\":45858,\"skein512-24\":45859,\"skein512-32\":45860,\"skein512-40\":45861,\"skein512-48\":45862,\"skein512-56\":45863,\"skein512-64\":45864,\"skein512-72\":45865,\"skein512-80\":45866,\"skein512-88\":45867,\"skein512-96\":45868,\"skein512-104\":45869,\"skein512-112\":45870,\"skein512-120\":45871,\"skein512-128\":45872,\"skein512-136\":45873,\"skein512-144\":45874,\"skein512-152\":45875,\"skein512-160\":45876,\"skein512-168\":45877,\"skein512-176\":45878,\"skein512-184\":45879,\"skein512-192\":45880,\"skein512-200\":45881,\"skein512-208\":45882,\"skein512-216\":45883,\"skein512-224\":45884,\"skein512-232\":45885,\"skein512-240\":45886,\"skein512-248\":45887,\"skein512-256\":45888,\"skein512-264\":45889,\"skein512-272\":45890,\"skein512-280\":45891,\"skein512-288\":45892,\"skein512-296\":45893,\"skein512-304\":45894,\"skein512-312\":45895,\"skein512-320\":45896,\"skein512-328\":45897,\"skein512-336\":45898,\"skein512-344\":45899,\"skein512-352\":45900,\"skein512-360\":45901,\"skein512-368\":45902,\"skein512-376\":45903,\"skein512-384\":45904,\"skein512-392\":45905,\"skein512-400\":45906,\"skein512-408\":45907,\"skein512-416\":45908,\"skein512-424\":45909,\"skein512-432\":45910,\"skein512-440\":45911,\"skein512-448\":45912,\"skein512-456\":45913,\"skein512-464\":45914,\"skein512-472\":45915,\"skein512-480\":45916,\"skein512-488\":45917,\"skein512-496\":45918,\"skein512-504\":45919,\"skein512-512\":45920,\"skein1024-8\":45921,\"skein1024-16\":45922,\"skein1024-24\":45923,\"skein1024-32\":45924,\"skein1024-40\":45925,\"skein1024-48\":45926,\"skein1024-56\":45927,\"skein1024-64\":45928,\"skein1024-72\":45929,\"skein1024-80\":45930,\"skein1024-88\":45931,\"skein1024-96\":45932,\"skein1024-104\":45933,\"skein1024-112\":45934,\"skein1024-120\":45935,\"skein1024-128\":45936,\"skein1024-136\":45937,\"skein1024-144\":45938,\"skein1024-152\":45939,\"skein1024-160\":45940,\"skein1024-168\":45941,\"skein1024-176\":45942,\"skein1024-184\":45943,\"skein1024-192\":45944,\"skein1024-200\":45945,\"skein1024-208\":45946,\"skein1024-216\":45947,\"skein1024-224\":45948,\"skein1024-232\":45949,\"skein1024-240\":45950,\"skein1024-248\":45951,\"skein1024-256\":45952,\"skein1024-264\":45953,\"skein1024-272\":45954,\"skein1024-280\":45955,\"skein1024-288\":45956,\"skein1024-296\":45957,\"skein1024-304\":45958,\"skein1024-312\":45959,\"skein1024-320\":45960,\"skein1024-328\":45961,\"skein1024-336\":45962,\"skein1024-344\":45963,\"skein1024-352\":45964,\"skein1024-360\":45965,\"skein1024-368\":45966,\"skein1024-376\":45967,\"skein1024-384\":45968,\"skein1024-392\":45969,\"skein1024-400\":45970,\"skein1024-408\":45971,\"skein1024-416\":45972,\"skein1024-424\":45973,\"skein1024-432\":45974,\"skein1024-440\":45975,\"skein1024-448\":45976,\"skein1024-456\":45977,\"skein1024-464\":45978,\"skein1024-472\":45979,\"skein1024-480\":45980,\"skein1024-488\":45981,\"skein1024-496\":45982,\"skein1024-504\":45983,\"skein1024-512\":45984,\"skein1024-520\":45985,\"skein1024-528\":45986,\"skein1024-536\":45987,\"skein1024-544\":45988,\"skein1024-552\":45989,\"skein1024-560\":45990,\"skein1024-568\":45991,\"skein1024-576\":45992,\"skein1024-584\":45993,\"skein1024-592\":45994,\"skein1024-600\":45995,\"skein1024-608\":45996,\"skein1024-616\":45997,\"skein1024-624\":45998,\"skein1024-632\":45999,\"skein1024-640\":46000,\"skein1024-648\":46001,\"skein1024-656\":46002,\"skein1024-664\":46003,\"skein1024-672\":46004,\"skein1024-680\":46005,\"skein1024-688\":46006,\"skein1024-696\":46007,\"skein1024-704\":46008,\"skein1024-712\":46009,\"skein1024-720\":46010,\"skein1024-728\":46011,\"skein1024-736\":46012,\"skein1024-744\":46013,\"skein1024-752\":46014,\"skein1024-760\":46015,\"skein1024-768\":46016,\"skein1024-776\":46017,\"skein1024-784\":46018,\"skein1024-792\":46019,\"skein1024-800\":46020,\"skein1024-808\":46021,\"skein1024-816\":46022,\"skein1024-824\":46023,\"skein1024-832\":46024,\"skein1024-840\":46025,\"skein1024-848\":46026,\"skein1024-856\":46027,\"skein1024-864\":46028,\"skein1024-872\":46029,\"skein1024-880\":46030,\"skein1024-888\":46031,\"skein1024-896\":46032,\"skein1024-904\":46033,\"skein1024-912\":46034,\"skein1024-920\":46035,\"skein1024-928\":46036,\"skein1024-936\":46037,\"skein1024-944\":46038,\"skein1024-952\":46039,\"skein1024-960\":46040,\"skein1024-968\":46041,\"skein1024-976\":46042,\"skein1024-984\":46043,\"skein1024-992\":46044,\"skein1024-1000\":46045,\"skein1024-1008\":46046,\"skein1024-1016\":46047,\"skein1024-1024\":46048,\"holochain-adr-v0\":8417572,\"holochain-adr-v1\":8483108,\"holochain-key-v0\":9728292,\"holochain-key-v1\":9793828,\"holochain-sig-v0\":10645796,\"holochain-sig-v1\":10711332}");

});


parcelRegister("65azp", function(module, exports) {
'use strict';

var $38KcH = parcelRequire("38KcH");

var $ibqZm = parcelRequire("ibqZm");
var $46db68b40fe67b19$require$varintEncode = $ibqZm.varintEncode;
// map for codecName -> codeVarintBuffer
const $46db68b40fe67b19$var$varintTable = {};
for(const encodingName in $38KcH){
    const code = $38KcH[encodingName];
    $46db68b40fe67b19$var$varintTable[encodingName] = $46db68b40fe67b19$require$varintEncode(code);
}
module.exports = Object.freeze($46db68b40fe67b19$var$varintTable);

});
parcelRegister("ibqZm", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d3ce30778becb1f7$require$Buffer = $6ZWSX.Buffer;
'use strict';

var $bmskQ = parcelRequire("bmskQ");
module.exports = {
    numberToBuffer: $d3ce30778becb1f7$var$numberToBuffer,
    bufferToNumber: $d3ce30778becb1f7$var$bufferToNumber,
    varintBufferEncode: $d3ce30778becb1f7$var$varintBufferEncode,
    varintBufferDecode: $d3ce30778becb1f7$var$varintBufferDecode,
    varintEncode: $d3ce30778becb1f7$var$varintEncode
};
function $d3ce30778becb1f7$var$bufferToNumber(buf) {
    return parseInt(buf.toString('hex'), 16);
}
function $d3ce30778becb1f7$var$numberToBuffer(num) {
    let hexString = num.toString(16);
    if (hexString.length % 2 === 1) hexString = '0' + hexString;
    return $d3ce30778becb1f7$require$Buffer.from(hexString, 'hex');
}
function $d3ce30778becb1f7$var$varintBufferEncode(input) {
    return $d3ce30778becb1f7$require$Buffer.from($bmskQ.encode($d3ce30778becb1f7$var$bufferToNumber(input)));
}
function $d3ce30778becb1f7$var$varintBufferDecode(input) {
    return $d3ce30778becb1f7$var$numberToBuffer($bmskQ.decode(input));
}
function $d3ce30778becb1f7$var$varintEncode(num) {
    return $d3ce30778becb1f7$require$Buffer.from($bmskQ.encode(num));
}

});


parcelRegister("bXlaZ", function(module, exports) {
'use strict';

var $38KcH = parcelRequire("38KcH");
// map for codecConstant -> code
const $8b45a189f7105ee1$var$constants = {};
for (const [name, code] of Object.entries($38KcH))$8b45a189f7105ee1$var$constants[name.toUpperCase().replace(/-/g, '_')] = code;
module.exports = Object.freeze($8b45a189f7105ee1$var$constants);

});

parcelRegister("aIFQN", function(module, exports) {
'use strict';

var $38KcH = parcelRequire("38KcH");
// map for code -> print friendly name
const $7cde7a1b02a25202$var$tableByCode = {};
for (const [name, code] of Object.entries($38KcH))if ($7cde7a1b02a25202$var$tableByCode[code] === undefined) $7cde7a1b02a25202$var$tableByCode[code] = name;
module.exports = Object.freeze($7cde7a1b02a25202$var$tableByCode);

});


parcelRegister("gB0LY", function(module, exports) {

$parcel$export(module.exports, "hexStringToBuffer", () => $c150b385b14f9f5b$export$83238ff569ad9e94, (v) => $c150b385b14f9f5b$export$83238ff569ad9e94 = v);
$parcel$export(module.exports, "profiles", () => $c150b385b14f9f5b$export$63dc120dff6c5db8, (v) => $c150b385b14f9f5b$export$63dc120dff6c5db8 = v);
/*
	ISC License

	Copyright (c) 2019, Pierre-Louis Despaigne

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted, provided that the above
	copyright notice and this permission notice appear in all copies.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
	WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
	MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
	ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
	WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
	ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
	OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/ var $c150b385b14f9f5b$export$83238ff569ad9e94;
var $c150b385b14f9f5b$export$63dc120dff6c5db8;

var $6ZWSX = parcelRequire("6ZWSX");
var $c150b385b14f9f5b$require$Buffer = $6ZWSX.Buffer;

var $ejBfT = parcelRequire("ejBfT");

var $bjWAl = parcelRequire("bjWAl");
/**
 * Convert an hexadecimal string to a Buffer, the string can start with or without '0x'
 * @param {string} hex an hexadecimal value
 * @return {Buffer} the resulting Buffer
 */ const $c150b385b14f9f5b$var$hexStringToBuffer = (hex)=>{
    let prefix = hex.slice(0, 2);
    let value = hex.slice(2);
    let res = '';
    if (prefix === '0x') res = value;
    else res = hex;
    return $bjWAl.fromHexString(res);
};
/**
* list of known encoding,
* encoding should be a function that takes a `string` input,
* and return a `Buffer` result
*/ const $c150b385b14f9f5b$var$encodes = {
    /**
  * @param {string} value
  * @return {Buffer}
  */ swarm: (value)=>{
        const multihash = $bjWAl.encode($c150b385b14f9f5b$var$hexStringToBuffer(value), 'keccak-256');
        return new $ejBfT(1, 'swarm-manifest', multihash).buffer;
    },
    /**
  * @param {string} value
  * @return {Buffer}
  */ ipfs: (value)=>{
        const multihash = $bjWAl.fromB58String(value);
        return new $ejBfT(1, 'dag-pb', multihash).buffer;
    },
    /**
  * @param {string} value
  * @return {Buffer}
  */ utf8: (value)=>{
        return $c150b385b14f9f5b$require$Buffer.from(value, 'utf8');
    }
};
/** 
* list of known decoding,
* decoding should be a function that takes a `Buffer` input,
* and return a `string` result
*/ const $c150b385b14f9f5b$var$decodes = {
    /**
  * @param {Buffer} value 
  */ hexMultiHash: (value)=>{
        const cid = new $ejBfT(value);
        return $bjWAl.decode(cid.multihash).digest.toString('hex');
    },
    /**
  * @param {Buffer} value 
  */ b58MultiHash: (value)=>{
        const cid = new $ejBfT(value);
        return $bjWAl.toB58String(cid.multihash);
    },
    /**
  * @param {Buffer} value 
  */ utf8: (value)=>{
        return value.toString('utf8');
    }
};
/**
* list of known encoding/decoding for a given codec,
* `encode` should be chosen among the `encodes` functions
* `decode` should be chosen among the `decodes` functions
*/ const $c150b385b14f9f5b$var$profiles = {
    'swarm-ns': {
        encode: $c150b385b14f9f5b$var$encodes.swarm,
        decode: $c150b385b14f9f5b$var$decodes.hexMultiHash
    },
    'ipfs-ns': {
        encode: $c150b385b14f9f5b$var$encodes.ipfs,
        decode: $c150b385b14f9f5b$var$decodes.b58MultiHash
    },
    'ipns-ns': {
        encode: $c150b385b14f9f5b$var$encodes.ipfs,
        decode: $c150b385b14f9f5b$var$decodes.b58MultiHash
    },
    'default': {
        encode: $c150b385b14f9f5b$var$encodes.utf8,
        decode: $c150b385b14f9f5b$var$decodes.utf8
    }
};
$c150b385b14f9f5b$export$83238ff569ad9e94 = $c150b385b14f9f5b$var$hexStringToBuffer;
$c150b385b14f9f5b$export$63dc120dff6c5db8 = $c150b385b14f9f5b$var$profiles;

});
parcelRegister("ejBfT", function(module, exports) {
'use strict';

var $6nsOh = parcelRequire("6nsOh");
var $a6bfbd2922010450$require$Buffer = $6nsOh.Buffer;

var $bjWAl = parcelRequire("bjWAl");

var $ffdMf = parcelRequire("ffdMf");

var $kHKdq = parcelRequire("kHKdq");

var $abqiu = parcelRequire("abqiu");

var $j1ZpV = parcelRequire("j1ZpV");

var $iA5vg = parcelRequire("iA5vg");
/**
 * @typedef {Object} SerializedCID
 * @param {string} codec
 * @param {number} version
 * @param {Buffer} multihash
 */ /**
 * Test if the given input is a CID.
 * @function isCID
 * @memberof CID
 * @static
 * @param {any} other
 * @returns {bool}
 */ /**
 * Class representing a CID `<mbase><version><mcodec><mhash>`
 * , as defined in [ipld/cid](https://github.com/multiformats/cid).
 * @class CID
 */ class $a6bfbd2922010450$var$CID {
    /**
   * Create a new CID.
   *
   * The algorithm for argument input is roughly:
   * ```
   * if (cid)
   *   -> create a copy
   * else if (str)
   *   if (1st char is on multibase table) -> CID String
   *   else -> bs58 encoded multihash
   * else if (Buffer)
   *   if (1st byte is 0 or 1) -> CID
   *   else -> multihash
   * else if (Number)
   *   -> construct CID by parts
   * ```
   *
   * @param {string|Buffer|CID} version
   * @param {string} [codec]
   * @param {Buffer} [multihash]
   * @param {string} [multibaseName]
   *
   * @example
   * new CID(<version>, <codec>, <multihash>, <multibaseName>)
   * new CID(<cidStr>)
   * new CID(<cid.buffer>)
   * new CID(<multihash>)
   * new CID(<bs58 encoded multihash>)
   * new CID(<cid>)
   */ constructor(version, codec, multihash, multibaseName){
        if ($a6bfbd2922010450$var$_CID.isCID(version)) {
            // version is an exising CID instance
            const cid = version;
            this.version = cid.version;
            this.codec = cid.codec;
            this.multihash = $a6bfbd2922010450$require$Buffer.from(cid.multihash);
            // Default guard for when a CID < 0.7 is passed with no multibaseName
            this.multibaseName = cid.multibaseName || (cid.version === 0 ? 'base58btc' : 'base32');
            return;
        }
        if (typeof version === 'string') {
            // e.g. 'base32' or false
            const baseName = $ffdMf.isEncoded(version);
            if (baseName) {
                // version is a CID String encoded with multibase, so v1
                const cid = $ffdMf.decode(version);
                this.version = parseInt(cid.slice(0, 1).toString('hex'), 16);
                this.codec = $kHKdq.getCodec(cid.slice(1));
                this.multihash = $kHKdq.rmPrefix(cid.slice(1));
                this.multibaseName = baseName;
            } else {
                // version is a base58btc string multihash, so v0
                this.version = 0;
                this.codec = 'dag-pb';
                this.multihash = $bjWAl.fromB58String(version);
                this.multibaseName = 'base58btc';
            }
            $a6bfbd2922010450$var$CID.validateCID(this);
            Object.defineProperty(this, 'string', {
                value: version
            });
            return;
        }
        if ($a6bfbd2922010450$require$Buffer.isBuffer(version)) {
            const firstByte = version.slice(0, 1);
            const v = parseInt(firstByte.toString('hex'), 16);
            if (v === 1) {
                // version is a CID buffer
                const cid = version;
                this.version = v;
                this.codec = $kHKdq.getCodec(cid.slice(1));
                this.multihash = $kHKdq.rmPrefix(cid.slice(1));
                this.multibaseName = 'base32';
            } else {
                // version is a raw multihash buffer, so v0
                this.version = 0;
                this.codec = 'dag-pb';
                this.multihash = version;
                this.multibaseName = 'base58btc';
            }
            $a6bfbd2922010450$var$CID.validateCID(this);
            return;
        }
        // otherwise, assemble the CID from the parameters
        /**
     * @type {number}
     */ this.version = version;
        /**
     * @type {string}
     */ this.codec = codec;
        /**
     * @type {Buffer}
     */ this.multihash = multihash;
        /**
     * @type {string}
     */ this.multibaseName = multibaseName || (version === 0 ? 'base58btc' : 'base32');
        $a6bfbd2922010450$var$CID.validateCID(this);
    }
    /**
   * The CID as a `Buffer`
   *
   * @return {Buffer}
   * @readonly
   *
   * @memberOf CID
   */ get buffer() {
        let buffer = this._buffer;
        if (!buffer) {
            if (this.version === 0) buffer = this.multihash;
            else if (this.version === 1) buffer = $a6bfbd2922010450$require$Buffer.concat([
                $a6bfbd2922010450$require$Buffer.from('01', 'hex'),
                $kHKdq.getCodeVarint(this.codec),
                this.multihash
            ]);
            else throw new Error('unsupported version');
            // Cache this buffer so it doesn't have to be recreated
            Object.defineProperty(this, '_buffer', {
                value: buffer
            });
        }
        return buffer;
    }
    /**
   * Get the prefix of the CID.
   *
   * @returns {Buffer}
   * @readonly
   */ get prefix() {
        return $a6bfbd2922010450$require$Buffer.concat([
            $a6bfbd2922010450$require$Buffer.from(`0${this.version}`, 'hex'),
            $kHKdq.getCodeVarint(this.codec),
            $bjWAl.prefix(this.multihash)
        ]);
    }
    /**
   * Convert to a CID of version `0`.
   *
   * @returns {CID}
   */ toV0() {
        if (this.codec !== 'dag-pb') throw new Error('Cannot convert a non dag-pb CID to CIDv0');
        const { name: name, length: length } = $bjWAl.decode(this.multihash);
        if (name !== 'sha2-256') throw new Error('Cannot convert non sha2-256 multihash CID to CIDv0');
        if (length !== 32) throw new Error('Cannot convert non 32 byte multihash CID to CIDv0');
        return new $a6bfbd2922010450$var$_CID(0, this.codec, this.multihash);
    }
    /**
   * Convert to a CID of version `1`.
   *
   * @returns {CID}
   */ toV1() {
        return new $a6bfbd2922010450$var$_CID(1, this.codec, this.multihash);
    }
    /**
   * Encode the CID into a string.
   *
   * @param {string} [base=this.multibaseName] - Base encoding to use.
   * @returns {string}
   */ toBaseEncodedString(base = this.multibaseName) {
        if (this.string && base === this.multibaseName) return this.string;
        let str = null;
        if (this.version === 0) {
            if (base !== 'base58btc') throw new Error('not supported with CIDv0, to support different bases, please migrate the instance do CIDv1, you can do that through cid.toV1()');
            str = $bjWAl.toB58String(this.multihash);
        } else if (this.version === 1) str = $ffdMf.encode(base, this.buffer).toString();
        else throw new Error('unsupported version');
        if (base === this.multibaseName) // cache the string value
        Object.defineProperty(this, 'string', {
            value: str
        });
        return str;
    }
    /**
   * CID(QmdfTbBqBPQ7VNxZEYEj14VmRuZBkqFbiwReogJgS1zR1n)
   *
   * @returns {String}
   */ [Symbol.for('nodejs.util.inspect.custom')]() {
        return 'CID(' + this.toString() + ')';
    }
    toString(base) {
        return this.toBaseEncodedString(base);
    }
    /**
   * Serialize to a plain object.
   *
   * @returns {SerializedCID}
   */ toJSON() {
        return {
            codec: this.codec,
            version: this.version,
            hash: this.multihash
        };
    }
    /**
   * Compare equality with another CID.
   *
   * @param {CID} other
   * @returns {bool}
   */ equals(other) {
        return this.codec === other.codec && this.version === other.version && this.multihash.equals(other.multihash);
    }
    /**
   * Test if the given input is a valid CID object.
   * Throws if it is not.
   *
   * @param {any} other
   * @returns {void}
   */ static validateCID(other) {
        const errorMsg = $j1ZpV.checkCIDComponents(other);
        if (errorMsg) throw new Error(errorMsg);
    }
}
const $a6bfbd2922010450$var$_CID = $iA5vg($a6bfbd2922010450$var$CID, {
    className: 'CID',
    symbolName: '@ipld/js-cid/CID'
});
$a6bfbd2922010450$var$_CID.codecs = $abqiu;
module.exports = $a6bfbd2922010450$var$_CID;

});
parcelRegister("6nsOh", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $4a4b3d1e1482eea6$export$a143d493d941bafc, (v) => $4a4b3d1e1482eea6$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $4a4b3d1e1482eea6$export$f99ded8fe4b79145, (v) => $4a4b3d1e1482eea6$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $4a4b3d1e1482eea6$export$a143d493d941bafc;
var $4a4b3d1e1482eea6$export$e4cf37d7f6fb9e0a;
var $4a4b3d1e1482eea6$export$f99ded8fe4b79145;
var $4a4b3d1e1482eea6$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $4a4b3d1e1482eea6$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$4a4b3d1e1482eea6$export$a143d493d941bafc = $4a4b3d1e1482eea6$var$Buffer;
$4a4b3d1e1482eea6$export$e4cf37d7f6fb9e0a = $4a4b3d1e1482eea6$var$SlowBuffer;
$4a4b3d1e1482eea6$export$f99ded8fe4b79145 = 50;
var $4a4b3d1e1482eea6$var$K_MAX_LENGTH = 0x7fffffff;
$4a4b3d1e1482eea6$export$599f31c3813fae4d = $4a4b3d1e1482eea6$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $4a4b3d1e1482eea6$var$Buffer.TYPED_ARRAY_SUPPORT = $4a4b3d1e1482eea6$var$typedArraySupport();
if (!$4a4b3d1e1482eea6$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $4a4b3d1e1482eea6$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($4a4b3d1e1482eea6$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$4a4b3d1e1482eea6$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($4a4b3d1e1482eea6$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$4a4b3d1e1482eea6$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $4a4b3d1e1482eea6$var$createBuffer(length) {
    if (length > $4a4b3d1e1482eea6$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $4a4b3d1e1482eea6$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $4a4b3d1e1482eea6$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $4a4b3d1e1482eea6$var$allocUnsafe(arg);
    }
    return $4a4b3d1e1482eea6$var$from(arg, encodingOrOffset, length);
}
$4a4b3d1e1482eea6$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $4a4b3d1e1482eea6$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $4a4b3d1e1482eea6$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $4a4b3d1e1482eea6$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($4a4b3d1e1482eea6$var$isInstance(value, ArrayBuffer) || value && $4a4b3d1e1482eea6$var$isInstance(value.buffer, ArrayBuffer)) return $4a4b3d1e1482eea6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($4a4b3d1e1482eea6$var$isInstance(value, SharedArrayBuffer) || value && $4a4b3d1e1482eea6$var$isInstance(value.buffer, SharedArrayBuffer))) return $4a4b3d1e1482eea6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $4a4b3d1e1482eea6$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $4a4b3d1e1482eea6$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $4a4b3d1e1482eea6$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $4a4b3d1e1482eea6$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $4a4b3d1e1482eea6$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($4a4b3d1e1482eea6$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($4a4b3d1e1482eea6$var$Buffer, Uint8Array);
function $4a4b3d1e1482eea6$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $4a4b3d1e1482eea6$var$alloc(size, fill, encoding) {
    $4a4b3d1e1482eea6$var$assertSize(size);
    if (size <= 0) return $4a4b3d1e1482eea6$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $4a4b3d1e1482eea6$var$createBuffer(size).fill(fill, encoding) : $4a4b3d1e1482eea6$var$createBuffer(size).fill(fill);
    return $4a4b3d1e1482eea6$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $4a4b3d1e1482eea6$var$Buffer.alloc = function(size, fill, encoding) {
    return $4a4b3d1e1482eea6$var$alloc(size, fill, encoding);
};
function $4a4b3d1e1482eea6$var$allocUnsafe(size) {
    $4a4b3d1e1482eea6$var$assertSize(size);
    return $4a4b3d1e1482eea6$var$createBuffer(size < 0 ? 0 : $4a4b3d1e1482eea6$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $4a4b3d1e1482eea6$var$Buffer.allocUnsafe = function(size) {
    return $4a4b3d1e1482eea6$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $4a4b3d1e1482eea6$var$Buffer.allocUnsafeSlow = function(size) {
    return $4a4b3d1e1482eea6$var$allocUnsafe(size);
};
function $4a4b3d1e1482eea6$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$4a4b3d1e1482eea6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $4a4b3d1e1482eea6$var$byteLength(string, encoding) | 0;
    var buf = $4a4b3d1e1482eea6$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $4a4b3d1e1482eea6$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $4a4b3d1e1482eea6$var$checked(array.length) | 0;
    var buf = $4a4b3d1e1482eea6$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $4a4b3d1e1482eea6$var$fromArrayView(arrayView) {
    if ($4a4b3d1e1482eea6$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $4a4b3d1e1482eea6$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $4a4b3d1e1482eea6$var$fromArrayLike(arrayView);
}
function $4a4b3d1e1482eea6$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $4a4b3d1e1482eea6$var$Buffer.prototype);
    return buf;
}
function $4a4b3d1e1482eea6$var$fromObject(obj) {
    if ($4a4b3d1e1482eea6$var$Buffer.isBuffer(obj)) {
        var len = $4a4b3d1e1482eea6$var$checked(obj.length) | 0;
        var buf = $4a4b3d1e1482eea6$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $4a4b3d1e1482eea6$var$numberIsNaN(obj.length)) return $4a4b3d1e1482eea6$var$createBuffer(0);
        return $4a4b3d1e1482eea6$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $4a4b3d1e1482eea6$var$fromArrayLike(obj.data);
}
function $4a4b3d1e1482eea6$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $4a4b3d1e1482eea6$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $4a4b3d1e1482eea6$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $4a4b3d1e1482eea6$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $4a4b3d1e1482eea6$var$Buffer.alloc(+length);
}
$4a4b3d1e1482eea6$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $4a4b3d1e1482eea6$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$4a4b3d1e1482eea6$var$Buffer.compare = function compare(a, b) {
    if ($4a4b3d1e1482eea6$var$isInstance(a, Uint8Array)) a = $4a4b3d1e1482eea6$var$Buffer.from(a, a.offset, a.byteLength);
    if ($4a4b3d1e1482eea6$var$isInstance(b, Uint8Array)) b = $4a4b3d1e1482eea6$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$4a4b3d1e1482eea6$var$Buffer.isBuffer(a) || !$4a4b3d1e1482eea6$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$4a4b3d1e1482eea6$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$4a4b3d1e1482eea6$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $4a4b3d1e1482eea6$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $4a4b3d1e1482eea6$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($4a4b3d1e1482eea6$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $4a4b3d1e1482eea6$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$4a4b3d1e1482eea6$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $4a4b3d1e1482eea6$var$byteLength(string, encoding) {
    if ($4a4b3d1e1482eea6$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $4a4b3d1e1482eea6$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $4a4b3d1e1482eea6$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $4a4b3d1e1482eea6$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $4a4b3d1e1482eea6$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$4a4b3d1e1482eea6$var$Buffer.byteLength = $4a4b3d1e1482eea6$var$byteLength;
function $4a4b3d1e1482eea6$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $4a4b3d1e1482eea6$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $4a4b3d1e1482eea6$var$utf8Slice(this, start, end);
        case 'ascii':
            return $4a4b3d1e1482eea6$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $4a4b3d1e1482eea6$var$latin1Slice(this, start, end);
        case 'base64':
            return $4a4b3d1e1482eea6$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4a4b3d1e1482eea6$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$4a4b3d1e1482eea6$var$Buffer.prototype._isBuffer = true;
function $4a4b3d1e1482eea6$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$4a4b3d1e1482eea6$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$4a4b3d1e1482eea6$var$swap(this, i, i + 1);
    return this;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $4a4b3d1e1482eea6$var$swap(this, i, i + 3);
        $4a4b3d1e1482eea6$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $4a4b3d1e1482eea6$var$swap(this, i, i + 7);
        $4a4b3d1e1482eea6$var$swap(this, i + 1, i + 6);
        $4a4b3d1e1482eea6$var$swap(this, i + 2, i + 5);
        $4a4b3d1e1482eea6$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $4a4b3d1e1482eea6$var$utf8Slice(this, 0, length);
    return $4a4b3d1e1482eea6$var$slowToString.apply(this, arguments);
};
$4a4b3d1e1482eea6$var$Buffer.prototype.toLocaleString = $4a4b3d1e1482eea6$var$Buffer.prototype.toString;
$4a4b3d1e1482eea6$var$Buffer.prototype.equals = function equals(b) {
    if (!$4a4b3d1e1482eea6$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $4a4b3d1e1482eea6$var$Buffer.compare(this, b) === 0;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $4a4b3d1e1482eea6$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($4a4b3d1e1482eea6$var$customInspectSymbol) $4a4b3d1e1482eea6$var$Buffer.prototype[$4a4b3d1e1482eea6$var$customInspectSymbol] = $4a4b3d1e1482eea6$var$Buffer.prototype.inspect;
$4a4b3d1e1482eea6$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($4a4b3d1e1482eea6$var$isInstance(target, Uint8Array)) target = $4a4b3d1e1482eea6$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$4a4b3d1e1482eea6$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $4a4b3d1e1482eea6$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($4a4b3d1e1482eea6$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $4a4b3d1e1482eea6$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($4a4b3d1e1482eea6$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $4a4b3d1e1482eea6$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $4a4b3d1e1482eea6$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $4a4b3d1e1482eea6$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$4a4b3d1e1482eea6$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $4a4b3d1e1482eea6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$4a4b3d1e1482eea6$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $4a4b3d1e1482eea6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $4a4b3d1e1482eea6$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($4a4b3d1e1482eea6$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $4a4b3d1e1482eea6$var$utf8Write(buf, string, offset, length) {
    return $4a4b3d1e1482eea6$var$blitBuffer($4a4b3d1e1482eea6$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $4a4b3d1e1482eea6$var$asciiWrite(buf, string, offset, length) {
    return $4a4b3d1e1482eea6$var$blitBuffer($4a4b3d1e1482eea6$var$asciiToBytes(string), buf, offset, length);
}
function $4a4b3d1e1482eea6$var$base64Write(buf, string, offset, length) {
    return $4a4b3d1e1482eea6$var$blitBuffer($4a4b3d1e1482eea6$var$base64ToBytes(string), buf, offset, length);
}
function $4a4b3d1e1482eea6$var$ucs2Write(buf, string, offset, length) {
    return $4a4b3d1e1482eea6$var$blitBuffer($4a4b3d1e1482eea6$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$4a4b3d1e1482eea6$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $4a4b3d1e1482eea6$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $4a4b3d1e1482eea6$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $4a4b3d1e1482eea6$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $4a4b3d1e1482eea6$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4a4b3d1e1482eea6$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$4a4b3d1e1482eea6$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $4a4b3d1e1482eea6$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $4a4b3d1e1482eea6$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $4a4b3d1e1482eea6$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $4a4b3d1e1482eea6$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $4a4b3d1e1482eea6$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $4a4b3d1e1482eea6$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $4a4b3d1e1482eea6$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $4a4b3d1e1482eea6$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $4a4b3d1e1482eea6$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $4a4b3d1e1482eea6$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $4a4b3d1e1482eea6$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $4a4b3d1e1482eea6$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$4a4b3d1e1482eea6$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $4a4b3d1e1482eea6$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $4a4b3d1e1482eea6$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$4a4b3d1e1482eea6$var$Buffer.prototype.readUintLE = $4a4b3d1e1482eea6$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readUintBE = $4a4b3d1e1482eea6$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readUint8 = $4a4b3d1e1482eea6$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readUint16LE = $4a4b3d1e1482eea6$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readUint16BE = $4a4b3d1e1482eea6$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readUint32LE = $4a4b3d1e1482eea6$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readUint32BE = $4a4b3d1e1482eea6$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$4a4b3d1e1482eea6$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $4a4b3d1e1482eea6$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$4a4b3d1e1482eea6$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$4a4b3d1e1482eea6$var$Buffer.prototype.writeUintLE = $4a4b3d1e1482eea6$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4a4b3d1e1482eea6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeUintBE = $4a4b3d1e1482eea6$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4a4b3d1e1482eea6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeUint8 = $4a4b3d1e1482eea6$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeUint16LE = $4a4b3d1e1482eea6$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeUint16BE = $4a4b3d1e1482eea6$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeUint32LE = $4a4b3d1e1482eea6$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeUint32BE = $4a4b3d1e1482eea6$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $4a4b3d1e1482eea6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $4a4b3d1e1482eea6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $4a4b3d1e1482eea6$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $4a4b3d1e1482eea6$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$4a4b3d1e1482eea6$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $4a4b3d1e1482eea6$var$writeFloat(this, value, offset, true, noAssert);
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $4a4b3d1e1482eea6$var$writeFloat(this, value, offset, false, noAssert);
};
function $4a4b3d1e1482eea6$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4a4b3d1e1482eea6$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$4a4b3d1e1482eea6$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $4a4b3d1e1482eea6$var$writeDouble(this, value, offset, true, noAssert);
};
$4a4b3d1e1482eea6$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $4a4b3d1e1482eea6$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$4a4b3d1e1482eea6$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$4a4b3d1e1482eea6$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$4a4b3d1e1482eea6$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$4a4b3d1e1482eea6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $4a4b3d1e1482eea6$var$Buffer.isBuffer(val) ? val : $4a4b3d1e1482eea6$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $4a4b3d1e1482eea6$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $4a4b3d1e1482eea6$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($4a4b3d1e1482eea6$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $4a4b3d1e1482eea6$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $4a4b3d1e1482eea6$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $4a4b3d1e1482eea6$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $4a4b3d1e1482eea6$var$base64ToBytes(str) {
    return $kuxul.toByteArray($4a4b3d1e1482eea6$var$base64clean(str));
}
function $4a4b3d1e1482eea6$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $4a4b3d1e1482eea6$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $4a4b3d1e1482eea6$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $4a4b3d1e1482eea6$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});

parcelRegister("bjWAl", function(module, exports) {

$parcel$export(module.exports, "fromHexString", () => $83dee9db354fbebd$export$99a70112ceb8327b, (v) => $83dee9db354fbebd$export$99a70112ceb8327b = v);
$parcel$export(module.exports, "toB58String", () => $83dee9db354fbebd$export$6f10cd39aba42032, (v) => $83dee9db354fbebd$export$6f10cd39aba42032 = v);
$parcel$export(module.exports, "fromB58String", () => $83dee9db354fbebd$export$94293751533bac2, (v) => $83dee9db354fbebd$export$94293751533bac2 = v);
$parcel$export(module.exports, "decode", () => $83dee9db354fbebd$export$2f872c0f2117be69, (v) => $83dee9db354fbebd$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "isValidCode", () => $83dee9db354fbebd$export$a5c39676d2a86af8, (v) => $83dee9db354fbebd$export$a5c39676d2a86af8 = v);
$parcel$export(module.exports, "encode", () => $83dee9db354fbebd$export$c564cdbbe6da493, (v) => $83dee9db354fbebd$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "coerceCode", () => $83dee9db354fbebd$export$5c4b645cb8721bfa, (v) => $83dee9db354fbebd$export$5c4b645cb8721bfa = v);
$parcel$export(module.exports, "isAppCode", () => $83dee9db354fbebd$export$dd468b29e9e316eb, (v) => $83dee9db354fbebd$export$dd468b29e9e316eb = v);
$parcel$export(module.exports, "validate", () => $83dee9db354fbebd$export$a22775fa5e2eebd9, (v) => $83dee9db354fbebd$export$a22775fa5e2eebd9 = v);
$parcel$export(module.exports, "prefix", () => $83dee9db354fbebd$export$82e9f45cca5ba907, (v) => $83dee9db354fbebd$export$82e9f45cca5ba907 = v);
/**
 * Multihash implementation in JavaScript.
 *
 * @module multihash
 */ var $83dee9db354fbebd$export$e4b2ac9215619f8d;
var $83dee9db354fbebd$export$e45cb6485273080e;
var $83dee9db354fbebd$export$6afcb0067345fd27;
/**
 * Convert the given multihash to a hex encoded string.
 *
 * @param {Buffer} hash
 * @returns {string}
 */ var $83dee9db354fbebd$export$f4915efbb94d4d01;
/**
 * Convert the given hex encoded string to a multihash.
 *
 * @param {string} hash
 * @returns {Buffer}
 */ var $83dee9db354fbebd$export$99a70112ceb8327b;
/**
 * Convert the given multihash to a base58 encoded string.
 *
 * @param {Buffer} hash
 * @returns {string}
 */ var $83dee9db354fbebd$export$6f10cd39aba42032;
/**
 * Convert the given base58 encoded string to a multihash.
 *
 * @param {string|Buffer} hash
 * @returns {Buffer}
 */ var $83dee9db354fbebd$export$94293751533bac2;
/**
 * Decode a hash from the given multihash.
 *
 * @param {Buffer} buf
 * @returns {{code: number, name: string, length: number, digest: Buffer}} result
 */ var $83dee9db354fbebd$export$2f872c0f2117be69;
/**
 *  Encode a hash digest along with the specified function code.
 *
 * > **Note:** the length is derived from the length of the digest itself.
 *
 * @param {Buffer} digest
 * @param {string|number} code
 * @param {number} [length]
 * @returns {Buffer}
 */ var $83dee9db354fbebd$export$c564cdbbe6da493;
/**
 * Converts a hash function name into the matching code.
 * If passed a number it will return the number if it's a valid code.
 * @param {string|number} name
 * @returns {number}
 */ var $83dee9db354fbebd$export$5c4b645cb8721bfa;
/**
 * Checks wether a code is part of the app range
 *
 * @param {number} code
 * @returns {boolean}
 */ var $83dee9db354fbebd$export$dd468b29e9e316eb;
/**
 * Checks whether a multihash code is valid.
 *
 * @param {number} code
 * @returns {boolean}
 */ var $83dee9db354fbebd$export$a5c39676d2a86af8;
var $83dee9db354fbebd$export$a22775fa5e2eebd9;
/**
 * Returns a prefix from a valid multihash. Throws an error if it is not valid.
 *
 * @param {Buffer} multihash
 * @returns {undefined}
 * @throws {Error}
 */ var $83dee9db354fbebd$export$82e9f45cca5ba907;
'use strict';

var $jU1Op = parcelRequire("jU1Op");
var $83dee9db354fbebd$require$Buffer = $jU1Op.Buffer;

var $jOFVn = parcelRequire("jOFVn");

var $bmskQ = parcelRequire("bmskQ");

var $cOgHr = parcelRequire("cOgHr");
$83dee9db354fbebd$export$e4b2ac9215619f8d = $cOgHr.names;
$83dee9db354fbebd$export$e45cb6485273080e = $cOgHr.codes;
$83dee9db354fbebd$export$6afcb0067345fd27 = $cOgHr.defaultLengths;
$83dee9db354fbebd$export$f4915efbb94d4d01 = function toHexString(hash) {
    if (!$83dee9db354fbebd$require$Buffer.isBuffer(hash)) throw new Error('must be passed a buffer');
    return hash.toString('hex');
};
$83dee9db354fbebd$export$99a70112ceb8327b = function fromHexString(hash) {
    return $83dee9db354fbebd$require$Buffer.from(hash, 'hex');
};
$83dee9db354fbebd$export$6f10cd39aba42032 = function toB58String(hash) {
    if (!$83dee9db354fbebd$require$Buffer.isBuffer(hash)) throw new Error('must be passed a buffer');
    return $jOFVn.encode('base58btc', hash).toString().slice(1);
};
$83dee9db354fbebd$export$94293751533bac2 = function fromB58String(hash) {
    let encoded = hash;
    if ($83dee9db354fbebd$require$Buffer.isBuffer(hash)) encoded = hash.toString();
    return $jOFVn.decode('z' + encoded);
};
$83dee9db354fbebd$export$2f872c0f2117be69 = function decode(buf) {
    if (!$83dee9db354fbebd$require$Buffer.isBuffer(buf)) throw new Error('multihash must be a Buffer');
    if (buf.length < 2) throw new Error('multihash too short. must be > 2 bytes.');
    const code = $bmskQ.decode(buf);
    if (!$83dee9db354fbebd$export$a5c39676d2a86af8(code)) throw new Error(`multihash unknown function code: 0x${code.toString(16)}`);
    buf = buf.slice($bmskQ.decode.bytes);
    const len = $bmskQ.decode(buf);
    if (len < 0) throw new Error(`multihash invalid length: ${len}`);
    buf = buf.slice($bmskQ.decode.bytes);
    if (buf.length !== len) throw new Error(`multihash length inconsistent: 0x${buf.toString('hex')}`);
    return {
        code: code,
        name: $cOgHr.codes[code],
        length: len,
        digest: buf
    };
};
$83dee9db354fbebd$export$c564cdbbe6da493 = function encode(digest, code, length) {
    if (!digest || code === undefined) throw new Error('multihash encode requires at least two args: digest, code');
    // ensure it's a hashfunction code.
    const hashfn = $83dee9db354fbebd$export$5c4b645cb8721bfa(code);
    if (!$83dee9db354fbebd$require$Buffer.isBuffer(digest)) throw new Error('digest should be a Buffer');
    if (length == null) length = digest.length;
    if (length && digest.length !== length) throw new Error('digest length should be equal to specified length.');
    return $83dee9db354fbebd$require$Buffer.concat([
        $83dee9db354fbebd$require$Buffer.from($bmskQ.encode(hashfn)),
        $83dee9db354fbebd$require$Buffer.from($bmskQ.encode(length)),
        digest
    ]);
};
$83dee9db354fbebd$export$5c4b645cb8721bfa = function coerceCode(name) {
    let code = name;
    if (typeof name === 'string') {
        if ($cOgHr.names[name] === undefined) throw new Error(`Unrecognized hash function named: ${name}`);
        code = $cOgHr.names[name];
    }
    if (typeof code !== 'number') throw new Error(`Hash function code should be a number. Got: ${code}`);
    if ($cOgHr.codes[code] === undefined && !$83dee9db354fbebd$export$dd468b29e9e316eb(code)) throw new Error(`Unrecognized function code: ${code}`);
    return code;
};
$83dee9db354fbebd$export$dd468b29e9e316eb = function appCode(code) {
    return code > 0 && code < 0x10;
};
$83dee9db354fbebd$export$a5c39676d2a86af8 = function validCode(code) {
    if ($83dee9db354fbebd$export$dd468b29e9e316eb(code)) return true;
    if ($cOgHr.codes[code]) return true;
    return false;
};
/**
 * Check if the given buffer is a valid multihash. Throws an error if it is not valid.
 *
 * @param {Buffer} multihash
 * @returns {undefined}
 * @throws {Error}
 */ function $83dee9db354fbebd$var$validate(multihash) {
    $83dee9db354fbebd$export$2f872c0f2117be69(multihash) // throws if bad.
    ;
}
$83dee9db354fbebd$export$a22775fa5e2eebd9 = $83dee9db354fbebd$var$validate;
$83dee9db354fbebd$export$82e9f45cca5ba907 = function prefix(multihash) {
    $83dee9db354fbebd$var$validate(multihash);
    return multihash.slice(0, 2);
};

});
parcelRegister("jU1Op", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $e7d4a71c7e5705dc$export$a143d493d941bafc, (v) => $e7d4a71c7e5705dc$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $e7d4a71c7e5705dc$export$f99ded8fe4b79145, (v) => $e7d4a71c7e5705dc$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e7d4a71c7e5705dc$export$a143d493d941bafc;
var $e7d4a71c7e5705dc$export$e4cf37d7f6fb9e0a;
var $e7d4a71c7e5705dc$export$f99ded8fe4b79145;
var $e7d4a71c7e5705dc$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $e7d4a71c7e5705dc$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$e7d4a71c7e5705dc$export$a143d493d941bafc = $e7d4a71c7e5705dc$var$Buffer;
$e7d4a71c7e5705dc$export$e4cf37d7f6fb9e0a = $e7d4a71c7e5705dc$var$SlowBuffer;
$e7d4a71c7e5705dc$export$f99ded8fe4b79145 = 50;
var $e7d4a71c7e5705dc$var$K_MAX_LENGTH = 0x7fffffff;
$e7d4a71c7e5705dc$export$599f31c3813fae4d = $e7d4a71c7e5705dc$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e7d4a71c7e5705dc$var$Buffer.TYPED_ARRAY_SUPPORT = $e7d4a71c7e5705dc$var$typedArraySupport();
if (!$e7d4a71c7e5705dc$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e7d4a71c7e5705dc$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e7d4a71c7e5705dc$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$e7d4a71c7e5705dc$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e7d4a71c7e5705dc$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$e7d4a71c7e5705dc$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e7d4a71c7e5705dc$var$createBuffer(length) {
    if (length > $e7d4a71c7e5705dc$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e7d4a71c7e5705dc$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e7d4a71c7e5705dc$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e7d4a71c7e5705dc$var$allocUnsafe(arg);
    }
    return $e7d4a71c7e5705dc$var$from(arg, encodingOrOffset, length);
}
$e7d4a71c7e5705dc$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e7d4a71c7e5705dc$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $e7d4a71c7e5705dc$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e7d4a71c7e5705dc$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($e7d4a71c7e5705dc$var$isInstance(value, ArrayBuffer) || value && $e7d4a71c7e5705dc$var$isInstance(value.buffer, ArrayBuffer)) return $e7d4a71c7e5705dc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($e7d4a71c7e5705dc$var$isInstance(value, SharedArrayBuffer) || value && $e7d4a71c7e5705dc$var$isInstance(value.buffer, SharedArrayBuffer))) return $e7d4a71c7e5705dc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e7d4a71c7e5705dc$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $e7d4a71c7e5705dc$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $e7d4a71c7e5705dc$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e7d4a71c7e5705dc$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e7d4a71c7e5705dc$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e7d4a71c7e5705dc$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e7d4a71c7e5705dc$var$Buffer, Uint8Array);
function $e7d4a71c7e5705dc$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e7d4a71c7e5705dc$var$alloc(size, fill, encoding) {
    $e7d4a71c7e5705dc$var$assertSize(size);
    if (size <= 0) return $e7d4a71c7e5705dc$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $e7d4a71c7e5705dc$var$createBuffer(size).fill(fill, encoding) : $e7d4a71c7e5705dc$var$createBuffer(size).fill(fill);
    return $e7d4a71c7e5705dc$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e7d4a71c7e5705dc$var$Buffer.alloc = function(size, fill, encoding) {
    return $e7d4a71c7e5705dc$var$alloc(size, fill, encoding);
};
function $e7d4a71c7e5705dc$var$allocUnsafe(size) {
    $e7d4a71c7e5705dc$var$assertSize(size);
    return $e7d4a71c7e5705dc$var$createBuffer(size < 0 ? 0 : $e7d4a71c7e5705dc$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e7d4a71c7e5705dc$var$Buffer.allocUnsafe = function(size) {
    return $e7d4a71c7e5705dc$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e7d4a71c7e5705dc$var$Buffer.allocUnsafeSlow = function(size) {
    return $e7d4a71c7e5705dc$var$allocUnsafe(size);
};
function $e7d4a71c7e5705dc$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$e7d4a71c7e5705dc$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $e7d4a71c7e5705dc$var$byteLength(string, encoding) | 0;
    var buf = $e7d4a71c7e5705dc$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e7d4a71c7e5705dc$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $e7d4a71c7e5705dc$var$checked(array.length) | 0;
    var buf = $e7d4a71c7e5705dc$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e7d4a71c7e5705dc$var$fromArrayView(arrayView) {
    if ($e7d4a71c7e5705dc$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $e7d4a71c7e5705dc$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e7d4a71c7e5705dc$var$fromArrayLike(arrayView);
}
function $e7d4a71c7e5705dc$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e7d4a71c7e5705dc$var$Buffer.prototype);
    return buf;
}
function $e7d4a71c7e5705dc$var$fromObject(obj) {
    if ($e7d4a71c7e5705dc$var$Buffer.isBuffer(obj)) {
        var len = $e7d4a71c7e5705dc$var$checked(obj.length) | 0;
        var buf = $e7d4a71c7e5705dc$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $e7d4a71c7e5705dc$var$numberIsNaN(obj.length)) return $e7d4a71c7e5705dc$var$createBuffer(0);
        return $e7d4a71c7e5705dc$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $e7d4a71c7e5705dc$var$fromArrayLike(obj.data);
}
function $e7d4a71c7e5705dc$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e7d4a71c7e5705dc$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e7d4a71c7e5705dc$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $e7d4a71c7e5705dc$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e7d4a71c7e5705dc$var$Buffer.alloc(+length);
}
$e7d4a71c7e5705dc$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e7d4a71c7e5705dc$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e7d4a71c7e5705dc$var$Buffer.compare = function compare(a, b) {
    if ($e7d4a71c7e5705dc$var$isInstance(a, Uint8Array)) a = $e7d4a71c7e5705dc$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e7d4a71c7e5705dc$var$isInstance(b, Uint8Array)) b = $e7d4a71c7e5705dc$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e7d4a71c7e5705dc$var$Buffer.isBuffer(a) || !$e7d4a71c7e5705dc$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e7d4a71c7e5705dc$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$e7d4a71c7e5705dc$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e7d4a71c7e5705dc$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $e7d4a71c7e5705dc$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($e7d4a71c7e5705dc$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $e7d4a71c7e5705dc$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e7d4a71c7e5705dc$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e7d4a71c7e5705dc$var$byteLength(string, encoding) {
    if ($e7d4a71c7e5705dc$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e7d4a71c7e5705dc$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $e7d4a71c7e5705dc$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $e7d4a71c7e5705dc$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e7d4a71c7e5705dc$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e7d4a71c7e5705dc$var$Buffer.byteLength = $e7d4a71c7e5705dc$var$byteLength;
function $e7d4a71c7e5705dc$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $e7d4a71c7e5705dc$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $e7d4a71c7e5705dc$var$utf8Slice(this, start, end);
        case 'ascii':
            return $e7d4a71c7e5705dc$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $e7d4a71c7e5705dc$var$latin1Slice(this, start, end);
        case 'base64':
            return $e7d4a71c7e5705dc$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e7d4a71c7e5705dc$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e7d4a71c7e5705dc$var$Buffer.prototype._isBuffer = true;
function $e7d4a71c7e5705dc$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e7d4a71c7e5705dc$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$e7d4a71c7e5705dc$var$swap(this, i, i + 1);
    return this;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $e7d4a71c7e5705dc$var$swap(this, i, i + 3);
        $e7d4a71c7e5705dc$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $e7d4a71c7e5705dc$var$swap(this, i, i + 7);
        $e7d4a71c7e5705dc$var$swap(this, i + 1, i + 6);
        $e7d4a71c7e5705dc$var$swap(this, i + 2, i + 5);
        $e7d4a71c7e5705dc$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $e7d4a71c7e5705dc$var$utf8Slice(this, 0, length);
    return $e7d4a71c7e5705dc$var$slowToString.apply(this, arguments);
};
$e7d4a71c7e5705dc$var$Buffer.prototype.toLocaleString = $e7d4a71c7e5705dc$var$Buffer.prototype.toString;
$e7d4a71c7e5705dc$var$Buffer.prototype.equals = function equals(b) {
    if (!$e7d4a71c7e5705dc$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $e7d4a71c7e5705dc$var$Buffer.compare(this, b) === 0;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $e7d4a71c7e5705dc$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($e7d4a71c7e5705dc$var$customInspectSymbol) $e7d4a71c7e5705dc$var$Buffer.prototype[$e7d4a71c7e5705dc$var$customInspectSymbol] = $e7d4a71c7e5705dc$var$Buffer.prototype.inspect;
$e7d4a71c7e5705dc$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e7d4a71c7e5705dc$var$isInstance(target, Uint8Array)) target = $e7d4a71c7e5705dc$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e7d4a71c7e5705dc$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e7d4a71c7e5705dc$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e7d4a71c7e5705dc$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $e7d4a71c7e5705dc$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e7d4a71c7e5705dc$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e7d4a71c7e5705dc$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e7d4a71c7e5705dc$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $e7d4a71c7e5705dc$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e7d4a71c7e5705dc$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e7d4a71c7e5705dc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e7d4a71c7e5705dc$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e7d4a71c7e5705dc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e7d4a71c7e5705dc$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e7d4a71c7e5705dc$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e7d4a71c7e5705dc$var$utf8Write(buf, string, offset, length) {
    return $e7d4a71c7e5705dc$var$blitBuffer($e7d4a71c7e5705dc$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e7d4a71c7e5705dc$var$asciiWrite(buf, string, offset, length) {
    return $e7d4a71c7e5705dc$var$blitBuffer($e7d4a71c7e5705dc$var$asciiToBytes(string), buf, offset, length);
}
function $e7d4a71c7e5705dc$var$base64Write(buf, string, offset, length) {
    return $e7d4a71c7e5705dc$var$blitBuffer($e7d4a71c7e5705dc$var$base64ToBytes(string), buf, offset, length);
}
function $e7d4a71c7e5705dc$var$ucs2Write(buf, string, offset, length) {
    return $e7d4a71c7e5705dc$var$blitBuffer($e7d4a71c7e5705dc$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e7d4a71c7e5705dc$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $e7d4a71c7e5705dc$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $e7d4a71c7e5705dc$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $e7d4a71c7e5705dc$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $e7d4a71c7e5705dc$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e7d4a71c7e5705dc$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e7d4a71c7e5705dc$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e7d4a71c7e5705dc$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $e7d4a71c7e5705dc$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e7d4a71c7e5705dc$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $e7d4a71c7e5705dc$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e7d4a71c7e5705dc$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $e7d4a71c7e5705dc$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e7d4a71c7e5705dc$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e7d4a71c7e5705dc$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e7d4a71c7e5705dc$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e7d4a71c7e5705dc$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $e7d4a71c7e5705dc$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e7d4a71c7e5705dc$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e7d4a71c7e5705dc$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e7d4a71c7e5705dc$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e7d4a71c7e5705dc$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$e7d4a71c7e5705dc$var$Buffer.prototype.readUintLE = $e7d4a71c7e5705dc$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readUintBE = $e7d4a71c7e5705dc$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readUint8 = $e7d4a71c7e5705dc$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readUint16LE = $e7d4a71c7e5705dc$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readUint16BE = $e7d4a71c7e5705dc$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readUint32LE = $e7d4a71c7e5705dc$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readUint32BE = $e7d4a71c7e5705dc$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$e7d4a71c7e5705dc$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $e7d4a71c7e5705dc$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e7d4a71c7e5705dc$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$e7d4a71c7e5705dc$var$Buffer.prototype.writeUintLE = $e7d4a71c7e5705dc$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e7d4a71c7e5705dc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeUintBE = $e7d4a71c7e5705dc$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e7d4a71c7e5705dc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeUint8 = $e7d4a71c7e5705dc$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeUint16LE = $e7d4a71c7e5705dc$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeUint16BE = $e7d4a71c7e5705dc$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeUint32LE = $e7d4a71c7e5705dc$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeUint32BE = $e7d4a71c7e5705dc$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e7d4a71c7e5705dc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e7d4a71c7e5705dc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e7d4a71c7e5705dc$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $e7d4a71c7e5705dc$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e7d4a71c7e5705dc$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e7d4a71c7e5705dc$var$writeFloat(this, value, offset, true, noAssert);
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e7d4a71c7e5705dc$var$writeFloat(this, value, offset, false, noAssert);
};
function $e7d4a71c7e5705dc$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e7d4a71c7e5705dc$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e7d4a71c7e5705dc$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e7d4a71c7e5705dc$var$writeDouble(this, value, offset, true, noAssert);
};
$e7d4a71c7e5705dc$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e7d4a71c7e5705dc$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e7d4a71c7e5705dc$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e7d4a71c7e5705dc$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e7d4a71c7e5705dc$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$e7d4a71c7e5705dc$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $e7d4a71c7e5705dc$var$Buffer.isBuffer(val) ? val : $e7d4a71c7e5705dc$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $e7d4a71c7e5705dc$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e7d4a71c7e5705dc$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e7d4a71c7e5705dc$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $e7d4a71c7e5705dc$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $e7d4a71c7e5705dc$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e7d4a71c7e5705dc$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e7d4a71c7e5705dc$var$base64ToBytes(str) {
    return $kuxul.toByteArray($e7d4a71c7e5705dc$var$base64clean(str));
}
function $e7d4a71c7e5705dc$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e7d4a71c7e5705dc$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e7d4a71c7e5705dc$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $e7d4a71c7e5705dc$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});

parcelRegister("jOFVn", function(module, exports) {
/**
 * Implementation of the [multibase](https://github.com/multiformats/multibase) specification.
 * @module Multibase
 */ 'use strict';

var $6hCo0 = parcelRequire("6hCo0");
var $e6d33529318c92ad$require$Buffer = $6hCo0.Buffer;

var $7Du4g = parcelRequire("7Du4g");
exports = module.exports = multibase;
exports.encode = encode;
exports.decode = decode;
exports.isEncoded = isEncoded;
exports.names = Object.freeze(Object.keys($7Du4g.names));
exports.codes = Object.freeze(Object.keys($7Du4g.codes));
/**
 * Create a new buffer with the multibase varint+code.
 *
 * @param {string|number} nameOrCode - The multibase name or code number.
 * @param {Buffer} buf - The data to be prefixed with multibase.
 * @memberof Multibase
 * @returns {Buffer}
 */ function multibase(nameOrCode, buf) {
    if (!buf) throw new Error('requires an encoded buffer');
    const base = getBase(nameOrCode);
    const codeBuf = $e6d33529318c92ad$require$Buffer.from(base.code);
    const name = base.name;
    validEncode(name, buf);
    return $e6d33529318c92ad$require$Buffer.concat([
        codeBuf,
        buf
    ]);
}
/**
 * Encode data with the specified base and add the multibase prefix.
 *
 * @param {string|number} nameOrCode - The multibase name or code number.
 * @param {Buffer} buf - The data to be encoded.
 * @returns {Buffer}
 * @memberof Multibase
 */ function encode(nameOrCode, buf) {
    const base = getBase(nameOrCode);
    const name = base.name;
    return multibase(name, $e6d33529318c92ad$require$Buffer.from(base.encode(buf)));
}
/**
 * Takes a buffer or string encoded with multibase header, decodes it and
 * returns the decoded buffer
 *
 * @param {Buffer|string} bufOrString
 * @returns {Buffer}
 * @memberof Multibase
 *
 */ function decode(bufOrString) {
    if ($e6d33529318c92ad$require$Buffer.isBuffer(bufOrString)) bufOrString = bufOrString.toString();
    const code = bufOrString.substring(0, 1);
    bufOrString = bufOrString.substring(1, bufOrString.length);
    if (typeof bufOrString === 'string') bufOrString = $e6d33529318c92ad$require$Buffer.from(bufOrString);
    const base = getBase(code);
    return $e6d33529318c92ad$require$Buffer.from(base.decode(bufOrString.toString()));
}
/**
 * Is the given data multibase encoded?
 *
 * @param {Buffer|string} bufOrString
 * @returns {boolean}
 * @memberof Multibase
 */ function isEncoded(bufOrString) {
    if ($e6d33529318c92ad$require$Buffer.isBuffer(bufOrString)) bufOrString = bufOrString.toString();
    // Ensure bufOrString is a string
    if (Object.prototype.toString.call(bufOrString) !== '[object String]') return false;
    const code = bufOrString.substring(0, 1);
    try {
        const base = getBase(code);
        return base.name;
    } catch (err) {
        return false;
    }
}
/**
 * @param {string} name
 * @param {Buffer} buf
 * @private
 * @returns {undefined}
 */ function validEncode(name, buf) {
    const base = getBase(name);
    base.decode(buf.toString());
}
function getBase(nameOrCode) {
    let base;
    if ($7Du4g.names[nameOrCode]) base = $7Du4g.names[nameOrCode];
    else if ($7Du4g.codes[nameOrCode]) base = $7Du4g.codes[nameOrCode];
    else throw new Error('Unsupported encoding');
    if (!base.isImplemented()) throw new Error('Base ' + nameOrCode + ' is not implemented yet');
    return base;
}

});
parcelRegister("6hCo0", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $49321b4f09f46371$export$a143d493d941bafc, (v) => $49321b4f09f46371$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $49321b4f09f46371$export$f99ded8fe4b79145, (v) => $49321b4f09f46371$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $49321b4f09f46371$export$a143d493d941bafc;
var $49321b4f09f46371$export$e4cf37d7f6fb9e0a;
var $49321b4f09f46371$export$f99ded8fe4b79145;
var $49321b4f09f46371$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $49321b4f09f46371$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$49321b4f09f46371$export$a143d493d941bafc = $49321b4f09f46371$var$Buffer;
$49321b4f09f46371$export$e4cf37d7f6fb9e0a = $49321b4f09f46371$var$SlowBuffer;
$49321b4f09f46371$export$f99ded8fe4b79145 = 50;
var $49321b4f09f46371$var$K_MAX_LENGTH = 0x7fffffff;
$49321b4f09f46371$export$599f31c3813fae4d = $49321b4f09f46371$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $49321b4f09f46371$var$Buffer.TYPED_ARRAY_SUPPORT = $49321b4f09f46371$var$typedArraySupport();
if (!$49321b4f09f46371$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $49321b4f09f46371$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($49321b4f09f46371$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$49321b4f09f46371$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($49321b4f09f46371$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$49321b4f09f46371$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $49321b4f09f46371$var$createBuffer(length) {
    if (length > $49321b4f09f46371$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $49321b4f09f46371$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $49321b4f09f46371$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $49321b4f09f46371$var$allocUnsafe(arg);
    }
    return $49321b4f09f46371$var$from(arg, encodingOrOffset, length);
}
$49321b4f09f46371$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $49321b4f09f46371$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $49321b4f09f46371$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $49321b4f09f46371$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($49321b4f09f46371$var$isInstance(value, ArrayBuffer) || value && $49321b4f09f46371$var$isInstance(value.buffer, ArrayBuffer)) return $49321b4f09f46371$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($49321b4f09f46371$var$isInstance(value, SharedArrayBuffer) || value && $49321b4f09f46371$var$isInstance(value.buffer, SharedArrayBuffer))) return $49321b4f09f46371$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $49321b4f09f46371$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $49321b4f09f46371$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $49321b4f09f46371$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $49321b4f09f46371$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $49321b4f09f46371$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($49321b4f09f46371$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($49321b4f09f46371$var$Buffer, Uint8Array);
function $49321b4f09f46371$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $49321b4f09f46371$var$alloc(size, fill, encoding) {
    $49321b4f09f46371$var$assertSize(size);
    if (size <= 0) return $49321b4f09f46371$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $49321b4f09f46371$var$createBuffer(size).fill(fill, encoding) : $49321b4f09f46371$var$createBuffer(size).fill(fill);
    return $49321b4f09f46371$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $49321b4f09f46371$var$Buffer.alloc = function(size, fill, encoding) {
    return $49321b4f09f46371$var$alloc(size, fill, encoding);
};
function $49321b4f09f46371$var$allocUnsafe(size) {
    $49321b4f09f46371$var$assertSize(size);
    return $49321b4f09f46371$var$createBuffer(size < 0 ? 0 : $49321b4f09f46371$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $49321b4f09f46371$var$Buffer.allocUnsafe = function(size) {
    return $49321b4f09f46371$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $49321b4f09f46371$var$Buffer.allocUnsafeSlow = function(size) {
    return $49321b4f09f46371$var$allocUnsafe(size);
};
function $49321b4f09f46371$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$49321b4f09f46371$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $49321b4f09f46371$var$byteLength(string, encoding) | 0;
    var buf = $49321b4f09f46371$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $49321b4f09f46371$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $49321b4f09f46371$var$checked(array.length) | 0;
    var buf = $49321b4f09f46371$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $49321b4f09f46371$var$fromArrayView(arrayView) {
    if ($49321b4f09f46371$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $49321b4f09f46371$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $49321b4f09f46371$var$fromArrayLike(arrayView);
}
function $49321b4f09f46371$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $49321b4f09f46371$var$Buffer.prototype);
    return buf;
}
function $49321b4f09f46371$var$fromObject(obj) {
    if ($49321b4f09f46371$var$Buffer.isBuffer(obj)) {
        var len = $49321b4f09f46371$var$checked(obj.length) | 0;
        var buf = $49321b4f09f46371$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $49321b4f09f46371$var$numberIsNaN(obj.length)) return $49321b4f09f46371$var$createBuffer(0);
        return $49321b4f09f46371$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $49321b4f09f46371$var$fromArrayLike(obj.data);
}
function $49321b4f09f46371$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $49321b4f09f46371$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $49321b4f09f46371$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $49321b4f09f46371$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $49321b4f09f46371$var$Buffer.alloc(+length);
}
$49321b4f09f46371$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $49321b4f09f46371$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$49321b4f09f46371$var$Buffer.compare = function compare(a, b) {
    if ($49321b4f09f46371$var$isInstance(a, Uint8Array)) a = $49321b4f09f46371$var$Buffer.from(a, a.offset, a.byteLength);
    if ($49321b4f09f46371$var$isInstance(b, Uint8Array)) b = $49321b4f09f46371$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$49321b4f09f46371$var$Buffer.isBuffer(a) || !$49321b4f09f46371$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$49321b4f09f46371$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$49321b4f09f46371$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $49321b4f09f46371$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $49321b4f09f46371$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($49321b4f09f46371$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $49321b4f09f46371$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$49321b4f09f46371$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $49321b4f09f46371$var$byteLength(string, encoding) {
    if ($49321b4f09f46371$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $49321b4f09f46371$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $49321b4f09f46371$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $49321b4f09f46371$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $49321b4f09f46371$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$49321b4f09f46371$var$Buffer.byteLength = $49321b4f09f46371$var$byteLength;
function $49321b4f09f46371$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $49321b4f09f46371$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $49321b4f09f46371$var$utf8Slice(this, start, end);
        case 'ascii':
            return $49321b4f09f46371$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $49321b4f09f46371$var$latin1Slice(this, start, end);
        case 'base64':
            return $49321b4f09f46371$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $49321b4f09f46371$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$49321b4f09f46371$var$Buffer.prototype._isBuffer = true;
function $49321b4f09f46371$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$49321b4f09f46371$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$49321b4f09f46371$var$swap(this, i, i + 1);
    return this;
};
$49321b4f09f46371$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $49321b4f09f46371$var$swap(this, i, i + 3);
        $49321b4f09f46371$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$49321b4f09f46371$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $49321b4f09f46371$var$swap(this, i, i + 7);
        $49321b4f09f46371$var$swap(this, i + 1, i + 6);
        $49321b4f09f46371$var$swap(this, i + 2, i + 5);
        $49321b4f09f46371$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$49321b4f09f46371$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $49321b4f09f46371$var$utf8Slice(this, 0, length);
    return $49321b4f09f46371$var$slowToString.apply(this, arguments);
};
$49321b4f09f46371$var$Buffer.prototype.toLocaleString = $49321b4f09f46371$var$Buffer.prototype.toString;
$49321b4f09f46371$var$Buffer.prototype.equals = function equals(b) {
    if (!$49321b4f09f46371$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $49321b4f09f46371$var$Buffer.compare(this, b) === 0;
};
$49321b4f09f46371$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $49321b4f09f46371$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($49321b4f09f46371$var$customInspectSymbol) $49321b4f09f46371$var$Buffer.prototype[$49321b4f09f46371$var$customInspectSymbol] = $49321b4f09f46371$var$Buffer.prototype.inspect;
$49321b4f09f46371$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($49321b4f09f46371$var$isInstance(target, Uint8Array)) target = $49321b4f09f46371$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$49321b4f09f46371$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $49321b4f09f46371$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($49321b4f09f46371$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $49321b4f09f46371$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($49321b4f09f46371$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $49321b4f09f46371$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $49321b4f09f46371$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $49321b4f09f46371$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$49321b4f09f46371$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$49321b4f09f46371$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $49321b4f09f46371$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$49321b4f09f46371$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $49321b4f09f46371$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $49321b4f09f46371$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($49321b4f09f46371$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $49321b4f09f46371$var$utf8Write(buf, string, offset, length) {
    return $49321b4f09f46371$var$blitBuffer($49321b4f09f46371$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $49321b4f09f46371$var$asciiWrite(buf, string, offset, length) {
    return $49321b4f09f46371$var$blitBuffer($49321b4f09f46371$var$asciiToBytes(string), buf, offset, length);
}
function $49321b4f09f46371$var$base64Write(buf, string, offset, length) {
    return $49321b4f09f46371$var$blitBuffer($49321b4f09f46371$var$base64ToBytes(string), buf, offset, length);
}
function $49321b4f09f46371$var$ucs2Write(buf, string, offset, length) {
    return $49321b4f09f46371$var$blitBuffer($49321b4f09f46371$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$49321b4f09f46371$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $49321b4f09f46371$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $49321b4f09f46371$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $49321b4f09f46371$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $49321b4f09f46371$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $49321b4f09f46371$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$49321b4f09f46371$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $49321b4f09f46371$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $49321b4f09f46371$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $49321b4f09f46371$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $49321b4f09f46371$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $49321b4f09f46371$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $49321b4f09f46371$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $49321b4f09f46371$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $49321b4f09f46371$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $49321b4f09f46371$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $49321b4f09f46371$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $49321b4f09f46371$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $49321b4f09f46371$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$49321b4f09f46371$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $49321b4f09f46371$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $49321b4f09f46371$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$49321b4f09f46371$var$Buffer.prototype.readUintLE = $49321b4f09f46371$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$49321b4f09f46371$var$Buffer.prototype.readUintBE = $49321b4f09f46371$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$49321b4f09f46371$var$Buffer.prototype.readUint8 = $49321b4f09f46371$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$49321b4f09f46371$var$Buffer.prototype.readUint16LE = $49321b4f09f46371$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$49321b4f09f46371$var$Buffer.prototype.readUint16BE = $49321b4f09f46371$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$49321b4f09f46371$var$Buffer.prototype.readUint32LE = $49321b4f09f46371$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$49321b4f09f46371$var$Buffer.prototype.readUint32BE = $49321b4f09f46371$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$49321b4f09f46371$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$49321b4f09f46371$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$49321b4f09f46371$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$49321b4f09f46371$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$49321b4f09f46371$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$49321b4f09f46371$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$49321b4f09f46371$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$49321b4f09f46371$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$49321b4f09f46371$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$49321b4f09f46371$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$49321b4f09f46371$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $49321b4f09f46371$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$49321b4f09f46371$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$49321b4f09f46371$var$Buffer.prototype.writeUintLE = $49321b4f09f46371$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $49321b4f09f46371$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$49321b4f09f46371$var$Buffer.prototype.writeUintBE = $49321b4f09f46371$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $49321b4f09f46371$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$49321b4f09f46371$var$Buffer.prototype.writeUint8 = $49321b4f09f46371$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$49321b4f09f46371$var$Buffer.prototype.writeUint16LE = $49321b4f09f46371$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$49321b4f09f46371$var$Buffer.prototype.writeUint16BE = $49321b4f09f46371$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$49321b4f09f46371$var$Buffer.prototype.writeUint32LE = $49321b4f09f46371$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$49321b4f09f46371$var$Buffer.prototype.writeUint32BE = $49321b4f09f46371$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$49321b4f09f46371$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $49321b4f09f46371$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$49321b4f09f46371$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $49321b4f09f46371$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$49321b4f09f46371$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$49321b4f09f46371$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$49321b4f09f46371$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$49321b4f09f46371$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$49321b4f09f46371$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $49321b4f09f46371$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $49321b4f09f46371$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$49321b4f09f46371$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $49321b4f09f46371$var$writeFloat(this, value, offset, true, noAssert);
};
$49321b4f09f46371$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $49321b4f09f46371$var$writeFloat(this, value, offset, false, noAssert);
};
function $49321b4f09f46371$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $49321b4f09f46371$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$49321b4f09f46371$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $49321b4f09f46371$var$writeDouble(this, value, offset, true, noAssert);
};
$49321b4f09f46371$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $49321b4f09f46371$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$49321b4f09f46371$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$49321b4f09f46371$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$49321b4f09f46371$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$49321b4f09f46371$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $49321b4f09f46371$var$Buffer.isBuffer(val) ? val : $49321b4f09f46371$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $49321b4f09f46371$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $49321b4f09f46371$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($49321b4f09f46371$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $49321b4f09f46371$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $49321b4f09f46371$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $49321b4f09f46371$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $49321b4f09f46371$var$base64ToBytes(str) {
    return $kuxul.toByteArray($49321b4f09f46371$var$base64clean(str));
}
function $49321b4f09f46371$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $49321b4f09f46371$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $49321b4f09f46371$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $49321b4f09f46371$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});

parcelRegister("7Du4g", function(module, exports) {
'use strict';

var $5JNT0 = parcelRequire("5JNT0");

var $0DhcF = parcelRequire("0DhcF");

var $ZGOmu = parcelRequire("ZGOmu");

var $CsBDD = parcelRequire("CsBDD");

var $80GpZ = parcelRequire("80GpZ");
// name, code, implementation, alphabet
const $58f37fc2edbfc1ac$var$constants = [
    [
        'base1',
        '1',
        '',
        '1'
    ],
    [
        'base2',
        '0',
        $0DhcF,
        '01'
    ],
    [
        'base8',
        '7',
        $0DhcF,
        '01234567'
    ],
    [
        'base10',
        '9',
        $0DhcF,
        '0123456789'
    ],
    [
        'base16',
        'f',
        $ZGOmu,
        '0123456789abcdef'
    ],
    [
        'base32',
        'b',
        $CsBDD,
        'abcdefghijklmnopqrstuvwxyz234567'
    ],
    [
        'base32pad',
        'c',
        $CsBDD,
        'abcdefghijklmnopqrstuvwxyz234567='
    ],
    [
        'base32hex',
        'v',
        $CsBDD,
        '0123456789abcdefghijklmnopqrstuv'
    ],
    [
        'base32hexpad',
        't',
        $CsBDD,
        '0123456789abcdefghijklmnopqrstuv='
    ],
    [
        'base32z',
        'h',
        $CsBDD,
        'ybndrfg8ejkmcpqxot1uwisza345h769'
    ],
    [
        'base58flickr',
        'Z',
        $0DhcF,
        '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'
    ],
    [
        'base58btc',
        'z',
        $0DhcF,
        '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
    ],
    [
        'base64',
        'm',
        $80GpZ,
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    ],
    [
        'base64pad',
        'M',
        $80GpZ,
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    ],
    [
        'base64url',
        'u',
        $80GpZ,
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
    ],
    [
        'base64urlpad',
        'U',
        $80GpZ,
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_='
    ]
];
const $58f37fc2edbfc1ac$var$names = $58f37fc2edbfc1ac$var$constants.reduce((prev, tupple)=>{
    prev[tupple[0]] = new $5JNT0(tupple[0], tupple[1], tupple[2], tupple[3]);
    return prev;
}, {});
const $58f37fc2edbfc1ac$var$codes = $58f37fc2edbfc1ac$var$constants.reduce((prev, tupple)=>{
    prev[tupple[1]] = $58f37fc2edbfc1ac$var$names[tupple[0]];
    return prev;
}, {});
module.exports = {
    names: $58f37fc2edbfc1ac$var$names,
    codes: $58f37fc2edbfc1ac$var$codes
};

});
parcelRegister("5JNT0", function(module, exports) {
'use strict';
class $42d7da15e77f32a9$var$Base {
    constructor(name, code, implementation, alphabet){
        this.name = name;
        this.code = code;
        this.alphabet = alphabet;
        if (implementation && alphabet) this.engine = implementation(alphabet);
    }
    encode(stringOrBuffer) {
        return this.engine.encode(stringOrBuffer);
    }
    decode(stringOrBuffer) {
        return this.engine.decode(stringOrBuffer);
    }
    isImplemented() {
        return this.engine;
    }
}
module.exports = $42d7da15e77f32a9$var$Base;

});

parcelRegister("0DhcF", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $001e77b0dfd1bf3d$require$_Buffer = $1U9GM.Buffer;
function $001e77b0dfd1bf3d$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $001e77b0dfd1bf3d$require$_Buffer.from(source);
        if (!$001e77b0dfd1bf3d$require$_Buffer.isBuffer(source)) throw new TypeError('Expected Buffer');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return $001e77b0dfd1bf3d$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip leading spaces.
        if (source[psz] === ' ') return;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip trailing spaces.
        if (source[psz] === ' ') return;
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $001e77b0dfd1bf3d$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $001e77b0dfd1bf3d$var$base;

});

parcelRegister("ZGOmu", function(module, exports) {
'use strict';

var $6hCo0 = parcelRequire("6hCo0");
var $0b96e80c98df8e6c$require$Buffer = $6hCo0.Buffer;
module.exports = function base16(alphabet) {
    return {
        encode (input) {
            if (typeof input === 'string') return $0b96e80c98df8e6c$require$Buffer.from(input).toString('hex');
            return input.toString('hex');
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error('invalid base16 character');
            }
            return $0b96e80c98df8e6c$require$Buffer.from(input, 'hex');
        }
    };
};

});

parcelRegister("CsBDD", function(module, exports) {
'use strict';
function $0739bd4b276446c7$var$decode(input, alphabet) {
    input = input.replace(new RegExp('=', 'g'), '');
    const length = input.length;
    let bits = 0;
    let value = 0;
    let index = 0;
    const output = new Uint8Array(length * 5 / 8 | 0);
    for(let i = 0; i < length; i++){
        value = value << 5 | alphabet.indexOf(input[i]);
        bits += 5;
        if (bits >= 8) {
            output[index++] = value >>> bits - 8 & 255;
            bits -= 8;
        }
    }
    return output.buffer;
}
function $0739bd4b276446c7$var$encode(buffer, alphabet) {
    const length = buffer.byteLength;
    const view = new Uint8Array(buffer);
    const padding = alphabet.indexOf('=') === alphabet.length - 1;
    if (padding) alphabet = alphabet.substring(0, alphabet.length - 1);
    let bits = 0;
    let value = 0;
    let output = '';
    for(let i = 0; i < length; i++){
        value = value << 8 | view[i];
        bits += 8;
        while(bits >= 5){
            output += alphabet[value >>> bits - 5 & 31];
            bits -= 5;
        }
    }
    if (bits > 0) output += alphabet[value << 5 - bits & 31];
    if (padding) while(output.length % 8 !== 0)output += '=';
    return output;
}
module.exports = function base32(alphabet) {
    return {
        encode (input) {
            if (typeof input === 'string') return $0739bd4b276446c7$var$encode(Uint8Array.from(input), alphabet);
            return $0739bd4b276446c7$var$encode(input, alphabet);
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error('invalid base32 character');
            }
            return $0739bd4b276446c7$var$decode(input, alphabet);
        }
    };
};

});

parcelRegister("80GpZ", function(module, exports) {
'use strict';

var $6hCo0 = parcelRequire("6hCo0");
var $5d4f3a3280f08363$require$Buffer = $6hCo0.Buffer;
module.exports = function base64(alphabet) {
    // The alphabet is only used to know:
    //   1. If padding is enabled (must contain '=')
    //   2. If the output must be url-safe (must contain '-' and '_')
    //   3. If the input of the output function is valid
    // The alphabets from RFC 4648 are always used.
    const padding = alphabet.indexOf('=') > -1;
    const url = alphabet.indexOf('-') > -1 && alphabet.indexOf('_') > -1;
    return {
        encode (input) {
            let output = '';
            if (typeof input === 'string') output = $5d4f3a3280f08363$require$Buffer.from(input).toString('base64');
            else output = input.toString('base64');
            if (url) output = output.replace(/\+/g, '-').replace(/\//g, '_');
            const pad = output.indexOf('=');
            if (pad > 0 && !padding) output = output.substring(0, pad);
            return output;
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error('invalid base64 character');
            }
            return $5d4f3a3280f08363$require$Buffer.from(input, 'base64');
        }
    };
};

});



parcelRegister("cOgHr", function(module, exports) {

$parcel$export(module.exports, "names", () => $95371bbd409b8258$export$e4b2ac9215619f8d, (v) => $95371bbd409b8258$export$e4b2ac9215619f8d = v);
$parcel$export(module.exports, "codes", () => $95371bbd409b8258$export$e45cb6485273080e, (v) => $95371bbd409b8258$export$e45cb6485273080e = v);
$parcel$export(module.exports, "defaultLengths", () => $95371bbd409b8258$export$6afcb0067345fd27, (v) => $95371bbd409b8258$export$6afcb0067345fd27 = v);
/* eslint quote-props: off */ /* eslint key-spacing: off */ var $95371bbd409b8258$export$e4b2ac9215619f8d;
var $95371bbd409b8258$export$e45cb6485273080e;
var $95371bbd409b8258$export$6afcb0067345fd27;
'use strict';
$95371bbd409b8258$export$e4b2ac9215619f8d = Object.freeze({
    'identity': 0x0,
    'sha1': 0x11,
    'sha2-256': 0x12,
    'sha2-512': 0x13,
    'dbl-sha2-256': 0x56,
    'sha3-224': 0x17,
    'sha3-256': 0x16,
    'sha3-384': 0x15,
    'sha3-512': 0x14,
    'shake-128': 0x18,
    'shake-256': 0x19,
    'keccak-224': 0x1A,
    'keccak-256': 0x1B,
    'keccak-384': 0x1C,
    'keccak-512': 0x1D,
    'murmur3-128': 0x22,
    'murmur3-32': 0x23,
    'md4': 0xd4,
    'md5': 0xd5,
    'blake2b-8': 0xb201,
    'blake2b-16': 0xb202,
    'blake2b-24': 0xb203,
    'blake2b-32': 0xb204,
    'blake2b-40': 0xb205,
    'blake2b-48': 0xb206,
    'blake2b-56': 0xb207,
    'blake2b-64': 0xb208,
    'blake2b-72': 0xb209,
    'blake2b-80': 0xb20a,
    'blake2b-88': 0xb20b,
    'blake2b-96': 0xb20c,
    'blake2b-104': 0xb20d,
    'blake2b-112': 0xb20e,
    'blake2b-120': 0xb20f,
    'blake2b-128': 0xb210,
    'blake2b-136': 0xb211,
    'blake2b-144': 0xb212,
    'blake2b-152': 0xb213,
    'blake2b-160': 0xb214,
    'blake2b-168': 0xb215,
    'blake2b-176': 0xb216,
    'blake2b-184': 0xb217,
    'blake2b-192': 0xb218,
    'blake2b-200': 0xb219,
    'blake2b-208': 0xb21a,
    'blake2b-216': 0xb21b,
    'blake2b-224': 0xb21c,
    'blake2b-232': 0xb21d,
    'blake2b-240': 0xb21e,
    'blake2b-248': 0xb21f,
    'blake2b-256': 0xb220,
    'blake2b-264': 0xb221,
    'blake2b-272': 0xb222,
    'blake2b-280': 0xb223,
    'blake2b-288': 0xb224,
    'blake2b-296': 0xb225,
    'blake2b-304': 0xb226,
    'blake2b-312': 0xb227,
    'blake2b-320': 0xb228,
    'blake2b-328': 0xb229,
    'blake2b-336': 0xb22a,
    'blake2b-344': 0xb22b,
    'blake2b-352': 0xb22c,
    'blake2b-360': 0xb22d,
    'blake2b-368': 0xb22e,
    'blake2b-376': 0xb22f,
    'blake2b-384': 0xb230,
    'blake2b-392': 0xb231,
    'blake2b-400': 0xb232,
    'blake2b-408': 0xb233,
    'blake2b-416': 0xb234,
    'blake2b-424': 0xb235,
    'blake2b-432': 0xb236,
    'blake2b-440': 0xb237,
    'blake2b-448': 0xb238,
    'blake2b-456': 0xb239,
    'blake2b-464': 0xb23a,
    'blake2b-472': 0xb23b,
    'blake2b-480': 0xb23c,
    'blake2b-488': 0xb23d,
    'blake2b-496': 0xb23e,
    'blake2b-504': 0xb23f,
    'blake2b-512': 0xb240,
    'blake2s-8': 0xb241,
    'blake2s-16': 0xb242,
    'blake2s-24': 0xb243,
    'blake2s-32': 0xb244,
    'blake2s-40': 0xb245,
    'blake2s-48': 0xb246,
    'blake2s-56': 0xb247,
    'blake2s-64': 0xb248,
    'blake2s-72': 0xb249,
    'blake2s-80': 0xb24a,
    'blake2s-88': 0xb24b,
    'blake2s-96': 0xb24c,
    'blake2s-104': 0xb24d,
    'blake2s-112': 0xb24e,
    'blake2s-120': 0xb24f,
    'blake2s-128': 0xb250,
    'blake2s-136': 0xb251,
    'blake2s-144': 0xb252,
    'blake2s-152': 0xb253,
    'blake2s-160': 0xb254,
    'blake2s-168': 0xb255,
    'blake2s-176': 0xb256,
    'blake2s-184': 0xb257,
    'blake2s-192': 0xb258,
    'blake2s-200': 0xb259,
    'blake2s-208': 0xb25a,
    'blake2s-216': 0xb25b,
    'blake2s-224': 0xb25c,
    'blake2s-232': 0xb25d,
    'blake2s-240': 0xb25e,
    'blake2s-248': 0xb25f,
    'blake2s-256': 0xb260,
    'Skein256-8': 0xb301,
    'Skein256-16': 0xb302,
    'Skein256-24': 0xb303,
    'Skein256-32': 0xb304,
    'Skein256-40': 0xb305,
    'Skein256-48': 0xb306,
    'Skein256-56': 0xb307,
    'Skein256-64': 0xb308,
    'Skein256-72': 0xb309,
    'Skein256-80': 0xb30a,
    'Skein256-88': 0xb30b,
    'Skein256-96': 0xb30c,
    'Skein256-104': 0xb30d,
    'Skein256-112': 0xb30e,
    'Skein256-120': 0xb30f,
    'Skein256-128': 0xb310,
    'Skein256-136': 0xb311,
    'Skein256-144': 0xb312,
    'Skein256-152': 0xb313,
    'Skein256-160': 0xb314,
    'Skein256-168': 0xb315,
    'Skein256-176': 0xb316,
    'Skein256-184': 0xb317,
    'Skein256-192': 0xb318,
    'Skein256-200': 0xb319,
    'Skein256-208': 0xb31a,
    'Skein256-216': 0xb31b,
    'Skein256-224': 0xb31c,
    'Skein256-232': 0xb31d,
    'Skein256-240': 0xb31e,
    'Skein256-248': 0xb31f,
    'Skein256-256': 0xb320,
    'Skein512-8': 0xb321,
    'Skein512-16': 0xb322,
    'Skein512-24': 0xb323,
    'Skein512-32': 0xb324,
    'Skein512-40': 0xb325,
    'Skein512-48': 0xb326,
    'Skein512-56': 0xb327,
    'Skein512-64': 0xb328,
    'Skein512-72': 0xb329,
    'Skein512-80': 0xb32a,
    'Skein512-88': 0xb32b,
    'Skein512-96': 0xb32c,
    'Skein512-104': 0xb32d,
    'Skein512-112': 0xb32e,
    'Skein512-120': 0xb32f,
    'Skein512-128': 0xb330,
    'Skein512-136': 0xb331,
    'Skein512-144': 0xb332,
    'Skein512-152': 0xb333,
    'Skein512-160': 0xb334,
    'Skein512-168': 0xb335,
    'Skein512-176': 0xb336,
    'Skein512-184': 0xb337,
    'Skein512-192': 0xb338,
    'Skein512-200': 0xb339,
    'Skein512-208': 0xb33a,
    'Skein512-216': 0xb33b,
    'Skein512-224': 0xb33c,
    'Skein512-232': 0xb33d,
    'Skein512-240': 0xb33e,
    'Skein512-248': 0xb33f,
    'Skein512-256': 0xb340,
    'Skein512-264': 0xb341,
    'Skein512-272': 0xb342,
    'Skein512-280': 0xb343,
    'Skein512-288': 0xb344,
    'Skein512-296': 0xb345,
    'Skein512-304': 0xb346,
    'Skein512-312': 0xb347,
    'Skein512-320': 0xb348,
    'Skein512-328': 0xb349,
    'Skein512-336': 0xb34a,
    'Skein512-344': 0xb34b,
    'Skein512-352': 0xb34c,
    'Skein512-360': 0xb34d,
    'Skein512-368': 0xb34e,
    'Skein512-376': 0xb34f,
    'Skein512-384': 0xb350,
    'Skein512-392': 0xb351,
    'Skein512-400': 0xb352,
    'Skein512-408': 0xb353,
    'Skein512-416': 0xb354,
    'Skein512-424': 0xb355,
    'Skein512-432': 0xb356,
    'Skein512-440': 0xb357,
    'Skein512-448': 0xb358,
    'Skein512-456': 0xb359,
    'Skein512-464': 0xb35a,
    'Skein512-472': 0xb35b,
    'Skein512-480': 0xb35c,
    'Skein512-488': 0xb35d,
    'Skein512-496': 0xb35e,
    'Skein512-504': 0xb35f,
    'Skein512-512': 0xb360,
    'Skein1024-8': 0xb361,
    'Skein1024-16': 0xb362,
    'Skein1024-24': 0xb363,
    'Skein1024-32': 0xb364,
    'Skein1024-40': 0xb365,
    'Skein1024-48': 0xb366,
    'Skein1024-56': 0xb367,
    'Skein1024-64': 0xb368,
    'Skein1024-72': 0xb369,
    'Skein1024-80': 0xb36a,
    'Skein1024-88': 0xb36b,
    'Skein1024-96': 0xb36c,
    'Skein1024-104': 0xb36d,
    'Skein1024-112': 0xb36e,
    'Skein1024-120': 0xb36f,
    'Skein1024-128': 0xb370,
    'Skein1024-136': 0xb371,
    'Skein1024-144': 0xb372,
    'Skein1024-152': 0xb373,
    'Skein1024-160': 0xb374,
    'Skein1024-168': 0xb375,
    'Skein1024-176': 0xb376,
    'Skein1024-184': 0xb377,
    'Skein1024-192': 0xb378,
    'Skein1024-200': 0xb379,
    'Skein1024-208': 0xb37a,
    'Skein1024-216': 0xb37b,
    'Skein1024-224': 0xb37c,
    'Skein1024-232': 0xb37d,
    'Skein1024-240': 0xb37e,
    'Skein1024-248': 0xb37f,
    'Skein1024-256': 0xb380,
    'Skein1024-264': 0xb381,
    'Skein1024-272': 0xb382,
    'Skein1024-280': 0xb383,
    'Skein1024-288': 0xb384,
    'Skein1024-296': 0xb385,
    'Skein1024-304': 0xb386,
    'Skein1024-312': 0xb387,
    'Skein1024-320': 0xb388,
    'Skein1024-328': 0xb389,
    'Skein1024-336': 0xb38a,
    'Skein1024-344': 0xb38b,
    'Skein1024-352': 0xb38c,
    'Skein1024-360': 0xb38d,
    'Skein1024-368': 0xb38e,
    'Skein1024-376': 0xb38f,
    'Skein1024-384': 0xb390,
    'Skein1024-392': 0xb391,
    'Skein1024-400': 0xb392,
    'Skein1024-408': 0xb393,
    'Skein1024-416': 0xb394,
    'Skein1024-424': 0xb395,
    'Skein1024-432': 0xb396,
    'Skein1024-440': 0xb397,
    'Skein1024-448': 0xb398,
    'Skein1024-456': 0xb399,
    'Skein1024-464': 0xb39a,
    'Skein1024-472': 0xb39b,
    'Skein1024-480': 0xb39c,
    'Skein1024-488': 0xb39d,
    'Skein1024-496': 0xb39e,
    'Skein1024-504': 0xb39f,
    'Skein1024-512': 0xb3a0,
    'Skein1024-520': 0xb3a1,
    'Skein1024-528': 0xb3a2,
    'Skein1024-536': 0xb3a3,
    'Skein1024-544': 0xb3a4,
    'Skein1024-552': 0xb3a5,
    'Skein1024-560': 0xb3a6,
    'Skein1024-568': 0xb3a7,
    'Skein1024-576': 0xb3a8,
    'Skein1024-584': 0xb3a9,
    'Skein1024-592': 0xb3aa,
    'Skein1024-600': 0xb3ab,
    'Skein1024-608': 0xb3ac,
    'Skein1024-616': 0xb3ad,
    'Skein1024-624': 0xb3ae,
    'Skein1024-632': 0xb3af,
    'Skein1024-640': 0xb3b0,
    'Skein1024-648': 0xb3b1,
    'Skein1024-656': 0xb3b2,
    'Skein1024-664': 0xb3b3,
    'Skein1024-672': 0xb3b4,
    'Skein1024-680': 0xb3b5,
    'Skein1024-688': 0xb3b6,
    'Skein1024-696': 0xb3b7,
    'Skein1024-704': 0xb3b8,
    'Skein1024-712': 0xb3b9,
    'Skein1024-720': 0xb3ba,
    'Skein1024-728': 0xb3bb,
    'Skein1024-736': 0xb3bc,
    'Skein1024-744': 0xb3bd,
    'Skein1024-752': 0xb3be,
    'Skein1024-760': 0xb3bf,
    'Skein1024-768': 0xb3c0,
    'Skein1024-776': 0xb3c1,
    'Skein1024-784': 0xb3c2,
    'Skein1024-792': 0xb3c3,
    'Skein1024-800': 0xb3c4,
    'Skein1024-808': 0xb3c5,
    'Skein1024-816': 0xb3c6,
    'Skein1024-824': 0xb3c7,
    'Skein1024-832': 0xb3c8,
    'Skein1024-840': 0xb3c9,
    'Skein1024-848': 0xb3ca,
    'Skein1024-856': 0xb3cb,
    'Skein1024-864': 0xb3cc,
    'Skein1024-872': 0xb3cd,
    'Skein1024-880': 0xb3ce,
    'Skein1024-888': 0xb3cf,
    'Skein1024-896': 0xb3d0,
    'Skein1024-904': 0xb3d1,
    'Skein1024-912': 0xb3d2,
    'Skein1024-920': 0xb3d3,
    'Skein1024-928': 0xb3d4,
    'Skein1024-936': 0xb3d5,
    'Skein1024-944': 0xb3d6,
    'Skein1024-952': 0xb3d7,
    'Skein1024-960': 0xb3d8,
    'Skein1024-968': 0xb3d9,
    'Skein1024-976': 0xb3da,
    'Skein1024-984': 0xb3db,
    'Skein1024-992': 0xb3dc,
    'Skein1024-1000': 0xb3dd,
    'Skein1024-1008': 0xb3de,
    'Skein1024-1016': 0xb3df,
    'Skein1024-1024': 0xb3e0
});
$95371bbd409b8258$export$e45cb6485273080e = Object.freeze({
    0x0: 'identity',
    // sha family
    0x11: 'sha1',
    0x12: 'sha2-256',
    0x13: 'sha2-512',
    0x56: 'dbl-sha2-256',
    0x17: 'sha3-224',
    0x16: 'sha3-256',
    0x15: 'sha3-384',
    0x14: 'sha3-512',
    0x18: 'shake-128',
    0x19: 'shake-256',
    0x1A: 'keccak-224',
    0x1B: 'keccak-256',
    0x1C: 'keccak-384',
    0x1D: 'keccak-512',
    0x22: 'murmur3-128',
    0x23: 'murmur3-32',
    0xd4: 'md4',
    0xd5: 'md5',
    // blake2
    0xb201: 'blake2b-8',
    0xb202: 'blake2b-16',
    0xb203: 'blake2b-24',
    0xb204: 'blake2b-32',
    0xb205: 'blake2b-40',
    0xb206: 'blake2b-48',
    0xb207: 'blake2b-56',
    0xb208: 'blake2b-64',
    0xb209: 'blake2b-72',
    0xb20a: 'blake2b-80',
    0xb20b: 'blake2b-88',
    0xb20c: 'blake2b-96',
    0xb20d: 'blake2b-104',
    0xb20e: 'blake2b-112',
    0xb20f: 'blake2b-120',
    0xb210: 'blake2b-128',
    0xb211: 'blake2b-136',
    0xb212: 'blake2b-144',
    0xb213: 'blake2b-152',
    0xb214: 'blake2b-160',
    0xb215: 'blake2b-168',
    0xb216: 'blake2b-176',
    0xb217: 'blake2b-184',
    0xb218: 'blake2b-192',
    0xb219: 'blake2b-200',
    0xb21a: 'blake2b-208',
    0xb21b: 'blake2b-216',
    0xb21c: 'blake2b-224',
    0xb21d: 'blake2b-232',
    0xb21e: 'blake2b-240',
    0xb21f: 'blake2b-248',
    0xb220: 'blake2b-256',
    0xb221: 'blake2b-264',
    0xb222: 'blake2b-272',
    0xb223: 'blake2b-280',
    0xb224: 'blake2b-288',
    0xb225: 'blake2b-296',
    0xb226: 'blake2b-304',
    0xb227: 'blake2b-312',
    0xb228: 'blake2b-320',
    0xb229: 'blake2b-328',
    0xb22a: 'blake2b-336',
    0xb22b: 'blake2b-344',
    0xb22c: 'blake2b-352',
    0xb22d: 'blake2b-360',
    0xb22e: 'blake2b-368',
    0xb22f: 'blake2b-376',
    0xb230: 'blake2b-384',
    0xb231: 'blake2b-392',
    0xb232: 'blake2b-400',
    0xb233: 'blake2b-408',
    0xb234: 'blake2b-416',
    0xb235: 'blake2b-424',
    0xb236: 'blake2b-432',
    0xb237: 'blake2b-440',
    0xb238: 'blake2b-448',
    0xb239: 'blake2b-456',
    0xb23a: 'blake2b-464',
    0xb23b: 'blake2b-472',
    0xb23c: 'blake2b-480',
    0xb23d: 'blake2b-488',
    0xb23e: 'blake2b-496',
    0xb23f: 'blake2b-504',
    0xb240: 'blake2b-512',
    0xb241: 'blake2s-8',
    0xb242: 'blake2s-16',
    0xb243: 'blake2s-24',
    0xb244: 'blake2s-32',
    0xb245: 'blake2s-40',
    0xb246: 'blake2s-48',
    0xb247: 'blake2s-56',
    0xb248: 'blake2s-64',
    0xb249: 'blake2s-72',
    0xb24a: 'blake2s-80',
    0xb24b: 'blake2s-88',
    0xb24c: 'blake2s-96',
    0xb24d: 'blake2s-104',
    0xb24e: 'blake2s-112',
    0xb24f: 'blake2s-120',
    0xb250: 'blake2s-128',
    0xb251: 'blake2s-136',
    0xb252: 'blake2s-144',
    0xb253: 'blake2s-152',
    0xb254: 'blake2s-160',
    0xb255: 'blake2s-168',
    0xb256: 'blake2s-176',
    0xb257: 'blake2s-184',
    0xb258: 'blake2s-192',
    0xb259: 'blake2s-200',
    0xb25a: 'blake2s-208',
    0xb25b: 'blake2s-216',
    0xb25c: 'blake2s-224',
    0xb25d: 'blake2s-232',
    0xb25e: 'blake2s-240',
    0xb25f: 'blake2s-248',
    0xb260: 'blake2s-256',
    // skein
    0xb301: 'Skein256-8',
    0xb302: 'Skein256-16',
    0xb303: 'Skein256-24',
    0xb304: 'Skein256-32',
    0xb305: 'Skein256-40',
    0xb306: 'Skein256-48',
    0xb307: 'Skein256-56',
    0xb308: 'Skein256-64',
    0xb309: 'Skein256-72',
    0xb30a: 'Skein256-80',
    0xb30b: 'Skein256-88',
    0xb30c: 'Skein256-96',
    0xb30d: 'Skein256-104',
    0xb30e: 'Skein256-112',
    0xb30f: 'Skein256-120',
    0xb310: 'Skein256-128',
    0xb311: 'Skein256-136',
    0xb312: 'Skein256-144',
    0xb313: 'Skein256-152',
    0xb314: 'Skein256-160',
    0xb315: 'Skein256-168',
    0xb316: 'Skein256-176',
    0xb317: 'Skein256-184',
    0xb318: 'Skein256-192',
    0xb319: 'Skein256-200',
    0xb31a: 'Skein256-208',
    0xb31b: 'Skein256-216',
    0xb31c: 'Skein256-224',
    0xb31d: 'Skein256-232',
    0xb31e: 'Skein256-240',
    0xb31f: 'Skein256-248',
    0xb320: 'Skein256-256',
    0xb321: 'Skein512-8',
    0xb322: 'Skein512-16',
    0xb323: 'Skein512-24',
    0xb324: 'Skein512-32',
    0xb325: 'Skein512-40',
    0xb326: 'Skein512-48',
    0xb327: 'Skein512-56',
    0xb328: 'Skein512-64',
    0xb329: 'Skein512-72',
    0xb32a: 'Skein512-80',
    0xb32b: 'Skein512-88',
    0xb32c: 'Skein512-96',
    0xb32d: 'Skein512-104',
    0xb32e: 'Skein512-112',
    0xb32f: 'Skein512-120',
    0xb330: 'Skein512-128',
    0xb331: 'Skein512-136',
    0xb332: 'Skein512-144',
    0xb333: 'Skein512-152',
    0xb334: 'Skein512-160',
    0xb335: 'Skein512-168',
    0xb336: 'Skein512-176',
    0xb337: 'Skein512-184',
    0xb338: 'Skein512-192',
    0xb339: 'Skein512-200',
    0xb33a: 'Skein512-208',
    0xb33b: 'Skein512-216',
    0xb33c: 'Skein512-224',
    0xb33d: 'Skein512-232',
    0xb33e: 'Skein512-240',
    0xb33f: 'Skein512-248',
    0xb340: 'Skein512-256',
    0xb341: 'Skein512-264',
    0xb342: 'Skein512-272',
    0xb343: 'Skein512-280',
    0xb344: 'Skein512-288',
    0xb345: 'Skein512-296',
    0xb346: 'Skein512-304',
    0xb347: 'Skein512-312',
    0xb348: 'Skein512-320',
    0xb349: 'Skein512-328',
    0xb34a: 'Skein512-336',
    0xb34b: 'Skein512-344',
    0xb34c: 'Skein512-352',
    0xb34d: 'Skein512-360',
    0xb34e: 'Skein512-368',
    0xb34f: 'Skein512-376',
    0xb350: 'Skein512-384',
    0xb351: 'Skein512-392',
    0xb352: 'Skein512-400',
    0xb353: 'Skein512-408',
    0xb354: 'Skein512-416',
    0xb355: 'Skein512-424',
    0xb356: 'Skein512-432',
    0xb357: 'Skein512-440',
    0xb358: 'Skein512-448',
    0xb359: 'Skein512-456',
    0xb35a: 'Skein512-464',
    0xb35b: 'Skein512-472',
    0xb35c: 'Skein512-480',
    0xb35d: 'Skein512-488',
    0xb35e: 'Skein512-496',
    0xb35f: 'Skein512-504',
    0xb360: 'Skein512-512',
    0xb361: 'Skein1024-8',
    0xb362: 'Skein1024-16',
    0xb363: 'Skein1024-24',
    0xb364: 'Skein1024-32',
    0xb365: 'Skein1024-40',
    0xb366: 'Skein1024-48',
    0xb367: 'Skein1024-56',
    0xb368: 'Skein1024-64',
    0xb369: 'Skein1024-72',
    0xb36a: 'Skein1024-80',
    0xb36b: 'Skein1024-88',
    0xb36c: 'Skein1024-96',
    0xb36d: 'Skein1024-104',
    0xb36e: 'Skein1024-112',
    0xb36f: 'Skein1024-120',
    0xb370: 'Skein1024-128',
    0xb371: 'Skein1024-136',
    0xb372: 'Skein1024-144',
    0xb373: 'Skein1024-152',
    0xb374: 'Skein1024-160',
    0xb375: 'Skein1024-168',
    0xb376: 'Skein1024-176',
    0xb377: 'Skein1024-184',
    0xb378: 'Skein1024-192',
    0xb379: 'Skein1024-200',
    0xb37a: 'Skein1024-208',
    0xb37b: 'Skein1024-216',
    0xb37c: 'Skein1024-224',
    0xb37d: 'Skein1024-232',
    0xb37e: 'Skein1024-240',
    0xb37f: 'Skein1024-248',
    0xb380: 'Skein1024-256',
    0xb381: 'Skein1024-264',
    0xb382: 'Skein1024-272',
    0xb383: 'Skein1024-280',
    0xb384: 'Skein1024-288',
    0xb385: 'Skein1024-296',
    0xb386: 'Skein1024-304',
    0xb387: 'Skein1024-312',
    0xb388: 'Skein1024-320',
    0xb389: 'Skein1024-328',
    0xb38a: 'Skein1024-336',
    0xb38b: 'Skein1024-344',
    0xb38c: 'Skein1024-352',
    0xb38d: 'Skein1024-360',
    0xb38e: 'Skein1024-368',
    0xb38f: 'Skein1024-376',
    0xb390: 'Skein1024-384',
    0xb391: 'Skein1024-392',
    0xb392: 'Skein1024-400',
    0xb393: 'Skein1024-408',
    0xb394: 'Skein1024-416',
    0xb395: 'Skein1024-424',
    0xb396: 'Skein1024-432',
    0xb397: 'Skein1024-440',
    0xb398: 'Skein1024-448',
    0xb399: 'Skein1024-456',
    0xb39a: 'Skein1024-464',
    0xb39b: 'Skein1024-472',
    0xb39c: 'Skein1024-480',
    0xb39d: 'Skein1024-488',
    0xb39e: 'Skein1024-496',
    0xb39f: 'Skein1024-504',
    0xb3a0: 'Skein1024-512',
    0xb3a1: 'Skein1024-520',
    0xb3a2: 'Skein1024-528',
    0xb3a3: 'Skein1024-536',
    0xb3a4: 'Skein1024-544',
    0xb3a5: 'Skein1024-552',
    0xb3a6: 'Skein1024-560',
    0xb3a7: 'Skein1024-568',
    0xb3a8: 'Skein1024-576',
    0xb3a9: 'Skein1024-584',
    0xb3aa: 'Skein1024-592',
    0xb3ab: 'Skein1024-600',
    0xb3ac: 'Skein1024-608',
    0xb3ad: 'Skein1024-616',
    0xb3ae: 'Skein1024-624',
    0xb3af: 'Skein1024-632',
    0xb3b0: 'Skein1024-640',
    0xb3b1: 'Skein1024-648',
    0xb3b2: 'Skein1024-656',
    0xb3b3: 'Skein1024-664',
    0xb3b4: 'Skein1024-672',
    0xb3b5: 'Skein1024-680',
    0xb3b6: 'Skein1024-688',
    0xb3b7: 'Skein1024-696',
    0xb3b8: 'Skein1024-704',
    0xb3b9: 'Skein1024-712',
    0xb3ba: 'Skein1024-720',
    0xb3bb: 'Skein1024-728',
    0xb3bc: 'Skein1024-736',
    0xb3bd: 'Skein1024-744',
    0xb3be: 'Skein1024-752',
    0xb3bf: 'Skein1024-760',
    0xb3c0: 'Skein1024-768',
    0xb3c1: 'Skein1024-776',
    0xb3c2: 'Skein1024-784',
    0xb3c3: 'Skein1024-792',
    0xb3c4: 'Skein1024-800',
    0xb3c5: 'Skein1024-808',
    0xb3c6: 'Skein1024-816',
    0xb3c7: 'Skein1024-824',
    0xb3c8: 'Skein1024-832',
    0xb3c9: 'Skein1024-840',
    0xb3ca: 'Skein1024-848',
    0xb3cb: 'Skein1024-856',
    0xb3cc: 'Skein1024-864',
    0xb3cd: 'Skein1024-872',
    0xb3ce: 'Skein1024-880',
    0xb3cf: 'Skein1024-888',
    0xb3d0: 'Skein1024-896',
    0xb3d1: 'Skein1024-904',
    0xb3d2: 'Skein1024-912',
    0xb3d3: 'Skein1024-920',
    0xb3d4: 'Skein1024-928',
    0xb3d5: 'Skein1024-936',
    0xb3d6: 'Skein1024-944',
    0xb3d7: 'Skein1024-952',
    0xb3d8: 'Skein1024-960',
    0xb3d9: 'Skein1024-968',
    0xb3da: 'Skein1024-976',
    0xb3db: 'Skein1024-984',
    0xb3dc: 'Skein1024-992',
    0xb3dd: 'Skein1024-1000',
    0xb3de: 'Skein1024-1008',
    0xb3df: 'Skein1024-1016',
    0xb3e0: 'Skein1024-1024'
});
$95371bbd409b8258$export$6afcb0067345fd27 = Object.freeze({
    0x11: 20,
    0x12: 32,
    0x13: 64,
    0x56: 32,
    0x17: 28,
    0x16: 32,
    0x15: 48,
    0x14: 64,
    0x18: 32,
    0x19: 64,
    0x1A: 28,
    0x1B: 32,
    0x1C: 48,
    0x1D: 64,
    0x22: 32,
    0xb201: 0x01,
    0xb202: 0x02,
    0xb203: 0x03,
    0xb204: 0x04,
    0xb205: 0x05,
    0xb206: 0x06,
    0xb207: 0x07,
    0xb208: 0x08,
    0xb209: 0x09,
    0xb20a: 0x0a,
    0xb20b: 0x0b,
    0xb20c: 0x0c,
    0xb20d: 0x0d,
    0xb20e: 0x0e,
    0xb20f: 0x0f,
    0xb210: 0x10,
    0xb211: 0x11,
    0xb212: 0x12,
    0xb213: 0x13,
    0xb214: 0x14,
    0xb215: 0x15,
    0xb216: 0x16,
    0xb217: 0x17,
    0xb218: 0x18,
    0xb219: 0x19,
    0xb21a: 0x1a,
    0xb21b: 0x1b,
    0xb21c: 0x1c,
    0xb21d: 0x1d,
    0xb21e: 0x1e,
    0xb21f: 0x1f,
    0xb220: 0x20,
    0xb221: 0x21,
    0xb222: 0x22,
    0xb223: 0x23,
    0xb224: 0x24,
    0xb225: 0x25,
    0xb226: 0x26,
    0xb227: 0x27,
    0xb228: 0x28,
    0xb229: 0x29,
    0xb22a: 0x2a,
    0xb22b: 0x2b,
    0xb22c: 0x2c,
    0xb22d: 0x2d,
    0xb22e: 0x2e,
    0xb22f: 0x2f,
    0xb230: 0x30,
    0xb231: 0x31,
    0xb232: 0x32,
    0xb233: 0x33,
    0xb234: 0x34,
    0xb235: 0x35,
    0xb236: 0x36,
    0xb237: 0x37,
    0xb238: 0x38,
    0xb239: 0x39,
    0xb23a: 0x3a,
    0xb23b: 0x3b,
    0xb23c: 0x3c,
    0xb23d: 0x3d,
    0xb23e: 0x3e,
    0xb23f: 0x3f,
    0xb240: 0x40,
    0xb241: 0x01,
    0xb242: 0x02,
    0xb243: 0x03,
    0xb244: 0x04,
    0xb245: 0x05,
    0xb246: 0x06,
    0xb247: 0x07,
    0xb248: 0x08,
    0xb249: 0x09,
    0xb24a: 0x0a,
    0xb24b: 0x0b,
    0xb24c: 0x0c,
    0xb24d: 0x0d,
    0xb24e: 0x0e,
    0xb24f: 0x0f,
    0xb250: 0x10,
    0xb251: 0x11,
    0xb252: 0x12,
    0xb253: 0x13,
    0xb254: 0x14,
    0xb255: 0x15,
    0xb256: 0x16,
    0xb257: 0x17,
    0xb258: 0x18,
    0xb259: 0x19,
    0xb25a: 0x1a,
    0xb25b: 0x1b,
    0xb25c: 0x1c,
    0xb25d: 0x1d,
    0xb25e: 0x1e,
    0xb25f: 0x1f,
    0xb260: 0x20,
    0xb301: 0x01,
    0xb302: 0x02,
    0xb303: 0x03,
    0xb304: 0x04,
    0xb305: 0x05,
    0xb306: 0x06,
    0xb307: 0x07,
    0xb308: 0x08,
    0xb309: 0x09,
    0xb30a: 0x0a,
    0xb30b: 0x0b,
    0xb30c: 0x0c,
    0xb30d: 0x0d,
    0xb30e: 0x0e,
    0xb30f: 0x0f,
    0xb310: 0x10,
    0xb311: 0x11,
    0xb312: 0x12,
    0xb313: 0x13,
    0xb314: 0x14,
    0xb315: 0x15,
    0xb316: 0x16,
    0xb317: 0x17,
    0xb318: 0x18,
    0xb319: 0x19,
    0xb31a: 0x1a,
    0xb31b: 0x1b,
    0xb31c: 0x1c,
    0xb31d: 0x1d,
    0xb31e: 0x1e,
    0xb31f: 0x1f,
    0xb320: 0x20,
    0xb321: 0x01,
    0xb322: 0x02,
    0xb323: 0x03,
    0xb324: 0x04,
    0xb325: 0x05,
    0xb326: 0x06,
    0xb327: 0x07,
    0xb328: 0x08,
    0xb329: 0x09,
    0xb32a: 0x0a,
    0xb32b: 0x0b,
    0xb32c: 0x0c,
    0xb32d: 0x0d,
    0xb32e: 0x0e,
    0xb32f: 0x0f,
    0xb330: 0x10,
    0xb331: 0x11,
    0xb332: 0x12,
    0xb333: 0x13,
    0xb334: 0x14,
    0xb335: 0x15,
    0xb336: 0x16,
    0xb337: 0x17,
    0xb338: 0x18,
    0xb339: 0x19,
    0xb33a: 0x1a,
    0xb33b: 0x1b,
    0xb33c: 0x1c,
    0xb33d: 0x1d,
    0xb33e: 0x1e,
    0xb33f: 0x1f,
    0xb340: 0x20,
    0xb341: 0x21,
    0xb342: 0x22,
    0xb343: 0x23,
    0xb344: 0x24,
    0xb345: 0x25,
    0xb346: 0x26,
    0xb347: 0x27,
    0xb348: 0x28,
    0xb349: 0x29,
    0xb34a: 0x2a,
    0xb34b: 0x2b,
    0xb34c: 0x2c,
    0xb34d: 0x2d,
    0xb34e: 0x2e,
    0xb34f: 0x2f,
    0xb350: 0x30,
    0xb351: 0x31,
    0xb352: 0x32,
    0xb353: 0x33,
    0xb354: 0x34,
    0xb355: 0x35,
    0xb356: 0x36,
    0xb357: 0x37,
    0xb358: 0x38,
    0xb359: 0x39,
    0xb35a: 0x3a,
    0xb35b: 0x3b,
    0xb35c: 0x3c,
    0xb35d: 0x3d,
    0xb35e: 0x3e,
    0xb35f: 0x3f,
    0xb360: 0x40,
    0xb361: 0x01,
    0xb362: 0x02,
    0xb363: 0x03,
    0xb364: 0x04,
    0xb365: 0x05,
    0xb366: 0x06,
    0xb367: 0x07,
    0xb368: 0x08,
    0xb369: 0x09,
    0xb36a: 0x0a,
    0xb36b: 0x0b,
    0xb36c: 0x0c,
    0xb36d: 0x0d,
    0xb36e: 0x0e,
    0xb36f: 0x0f,
    0xb370: 0x10,
    0xb371: 0x11,
    0xb372: 0x12,
    0xb373: 0x13,
    0xb374: 0x14,
    0xb375: 0x15,
    0xb376: 0x16,
    0xb377: 0x17,
    0xb378: 0x18,
    0xb379: 0x19,
    0xb37a: 0x1a,
    0xb37b: 0x1b,
    0xb37c: 0x1c,
    0xb37d: 0x1d,
    0xb37e: 0x1e,
    0xb37f: 0x1f,
    0xb380: 0x20,
    0xb381: 0x21,
    0xb382: 0x22,
    0xb383: 0x23,
    0xb384: 0x24,
    0xb385: 0x25,
    0xb386: 0x26,
    0xb387: 0x27,
    0xb388: 0x28,
    0xb389: 0x29,
    0xb38a: 0x2a,
    0xb38b: 0x2b,
    0xb38c: 0x2c,
    0xb38d: 0x2d,
    0xb38e: 0x2e,
    0xb38f: 0x2f,
    0xb390: 0x30,
    0xb391: 0x31,
    0xb392: 0x32,
    0xb393: 0x33,
    0xb394: 0x34,
    0xb395: 0x35,
    0xb396: 0x36,
    0xb397: 0x37,
    0xb398: 0x38,
    0xb399: 0x39,
    0xb39a: 0x3a,
    0xb39b: 0x3b,
    0xb39c: 0x3c,
    0xb39d: 0x3d,
    0xb39e: 0x3e,
    0xb39f: 0x3f,
    0xb3a0: 0x40,
    0xb3a1: 0x41,
    0xb3a2: 0x42,
    0xb3a3: 0x43,
    0xb3a4: 0x44,
    0xb3a5: 0x45,
    0xb3a6: 0x46,
    0xb3a7: 0x47,
    0xb3a8: 0x48,
    0xb3a9: 0x49,
    0xb3aa: 0x4a,
    0xb3ab: 0x4b,
    0xb3ac: 0x4c,
    0xb3ad: 0x4d,
    0xb3ae: 0x4e,
    0xb3af: 0x4f,
    0xb3b0: 0x50,
    0xb3b1: 0x51,
    0xb3b2: 0x52,
    0xb3b3: 0x53,
    0xb3b4: 0x54,
    0xb3b5: 0x55,
    0xb3b6: 0x56,
    0xb3b7: 0x57,
    0xb3b8: 0x58,
    0xb3b9: 0x59,
    0xb3ba: 0x5a,
    0xb3bb: 0x5b,
    0xb3bc: 0x5c,
    0xb3bd: 0x5d,
    0xb3be: 0x5e,
    0xb3bf: 0x5f,
    0xb3c0: 0x60,
    0xb3c1: 0x61,
    0xb3c2: 0x62,
    0xb3c3: 0x63,
    0xb3c4: 0x64,
    0xb3c5: 0x65,
    0xb3c6: 0x66,
    0xb3c7: 0x67,
    0xb3c8: 0x68,
    0xb3c9: 0x69,
    0xb3ca: 0x6a,
    0xb3cb: 0x6b,
    0xb3cc: 0x6c,
    0xb3cd: 0x6d,
    0xb3ce: 0x6e,
    0xb3cf: 0x6f,
    0xb3d0: 0x70,
    0xb3d1: 0x71,
    0xb3d2: 0x72,
    0xb3d3: 0x73,
    0xb3d4: 0x74,
    0xb3d5: 0x75,
    0xb3d6: 0x76,
    0xb3d7: 0x77,
    0xb3d8: 0x78,
    0xb3d9: 0x79,
    0xb3da: 0x7a,
    0xb3db: 0x7b,
    0xb3dc: 0x7c,
    0xb3dd: 0x7d,
    0xb3de: 0x7e,
    0xb3df: 0x7f,
    0xb3e0: 0x80
});

});


parcelRegister("ffdMf", function(module, exports) {
/**
 * Implementation of the [multibase](https://github.com/multiformats/multibase) specification.
 * @module Multibase
 */ 'use strict';

var $6nsOh = parcelRequire("6nsOh");
var $b192f1976e03c1d5$require$Buffer = $6nsOh.Buffer;

var $7A2QM = parcelRequire("7A2QM");
exports = module.exports = multibase;
exports.encode = encode;
exports.decode = decode;
exports.isEncoded = isEncoded;
exports.names = Object.freeze(Object.keys($7A2QM.names));
exports.codes = Object.freeze(Object.keys($7A2QM.codes));
const errNotSupported = new Error('Unsupported encoding');
/**
 * Create a new buffer with the multibase varint+code.
 *
 * @param {string|number} nameOrCode - The multibase name or code number.
 * @param {Buffer} buf - The data to be prefixed with multibase.
 * @memberof Multibase
 * @returns {Buffer}
 */ function multibase(nameOrCode, buf) {
    if (!buf) throw new Error('requires an encoded buffer');
    const base = getBase(nameOrCode);
    const codeBuf = $b192f1976e03c1d5$require$Buffer.from(base.code);
    const name = base.name;
    validEncode(name, buf);
    return $b192f1976e03c1d5$require$Buffer.concat([
        codeBuf,
        buf
    ]);
}
/**
 * Encode data with the specified base and add the multibase prefix.
 *
 * @param {string|number} nameOrCode - The multibase name or code number.
 * @param {Buffer} buf - The data to be encoded.
 * @returns {Buffer}
 * @memberof Multibase
 */ function encode(nameOrCode, buf) {
    const base = getBase(nameOrCode);
    const name = base.name;
    return multibase(name, $b192f1976e03c1d5$require$Buffer.from(base.encode(buf)));
}
/**
 * Takes a buffer or string encoded with multibase header, decodes it and
 * returns the decoded buffer
 *
 * @param {Buffer|string} bufOrString
 * @returns {Buffer}
 * @memberof Multibase
 *
 */ function decode(bufOrString) {
    if ($b192f1976e03c1d5$require$Buffer.isBuffer(bufOrString)) bufOrString = bufOrString.toString();
    const code = bufOrString.substring(0, 1);
    bufOrString = bufOrString.substring(1, bufOrString.length);
    if (typeof bufOrString === 'string') bufOrString = $b192f1976e03c1d5$require$Buffer.from(bufOrString);
    const base = getBase(code);
    return $b192f1976e03c1d5$require$Buffer.from(base.decode(bufOrString.toString()));
}
/**
 * Is the given data multibase encoded?
 *
 * @param {Buffer|string} bufOrString
 * @returns {boolean}
 * @memberof Multibase
 */ function isEncoded(bufOrString) {
    if ($b192f1976e03c1d5$require$Buffer.isBuffer(bufOrString)) bufOrString = bufOrString.toString();
    // Ensure bufOrString is a string
    if (Object.prototype.toString.call(bufOrString) !== '[object String]') return false;
    const code = bufOrString.substring(0, 1);
    try {
        const base = getBase(code);
        return base.name;
    } catch (err) {
        return false;
    }
}
/**
 * @param {string} name
 * @param {Buffer} buf
 * @private
 * @returns {undefined}
 */ function validEncode(name, buf) {
    const base = getBase(name);
    base.decode(buf.toString());
}
function getBase(nameOrCode) {
    let base;
    if ($7A2QM.names[nameOrCode]) base = $7A2QM.names[nameOrCode];
    else if ($7A2QM.codes[nameOrCode]) base = $7A2QM.codes[nameOrCode];
    else throw errNotSupported;
    if (!base.isImplemented()) throw new Error('Base ' + nameOrCode + ' is not implemented yet');
    return base;
}

});
parcelRegister("7A2QM", function(module, exports) {
'use strict';

var $aPLPe = parcelRequire("aPLPe");

var $0DhcF = parcelRequire("0DhcF");

var $g3Ahu = parcelRequire("g3Ahu");

var $dKyv2 = parcelRequire("dKyv2");

var $18eEH = parcelRequire("18eEH");
// name, code, implementation, alphabet
const $584e1b37530e15b5$var$constants = [
    [
        'base1',
        '1',
        '',
        '1'
    ],
    [
        'base2',
        '0',
        $0DhcF,
        '01'
    ],
    [
        'base8',
        '7',
        $0DhcF,
        '01234567'
    ],
    [
        'base10',
        '9',
        $0DhcF,
        '0123456789'
    ],
    [
        'base16',
        'f',
        $g3Ahu,
        '0123456789abcdef'
    ],
    [
        'base32',
        'b',
        $dKyv2,
        'abcdefghijklmnopqrstuvwxyz234567'
    ],
    [
        'base32pad',
        'c',
        $dKyv2,
        'abcdefghijklmnopqrstuvwxyz234567='
    ],
    [
        'base32hex',
        'v',
        $dKyv2,
        '0123456789abcdefghijklmnopqrstuv'
    ],
    [
        'base32hexpad',
        't',
        $dKyv2,
        '0123456789abcdefghijklmnopqrstuv='
    ],
    [
        'base32z',
        'h',
        $dKyv2,
        'ybndrfg8ejkmcpqxot1uwisza345h769'
    ],
    [
        'base58flickr',
        'Z',
        $0DhcF,
        '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'
    ],
    [
        'base58btc',
        'z',
        $0DhcF,
        '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
    ],
    [
        'base64',
        'm',
        $18eEH,
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    ],
    [
        'base64pad',
        'M',
        $18eEH,
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    ],
    [
        'base64url',
        'u',
        $18eEH,
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
    ],
    [
        'base64urlpad',
        'U',
        $18eEH,
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_='
    ]
];
const $584e1b37530e15b5$var$names = $584e1b37530e15b5$var$constants.reduce((prev, tupple)=>{
    prev[tupple[0]] = new $aPLPe(tupple[0], tupple[1], tupple[2], tupple[3]);
    return prev;
}, {});
const $584e1b37530e15b5$var$codes = $584e1b37530e15b5$var$constants.reduce((prev, tupple)=>{
    prev[tupple[1]] = $584e1b37530e15b5$var$names[tupple[0]];
    return prev;
}, {});
module.exports = {
    names: $584e1b37530e15b5$var$names,
    codes: $584e1b37530e15b5$var$codes
};

});
parcelRegister("aPLPe", function(module, exports) {
'use strict';
class $7e33c3e9749c276a$var$Base {
    constructor(name, code, implementation, alphabet){
        this.name = name;
        this.code = code;
        this.alphabet = alphabet;
        if (implementation && alphabet) this.engine = implementation(alphabet);
    }
    encode(stringOrBuffer) {
        return this.engine.encode(stringOrBuffer);
    }
    decode(stringOrBuffer) {
        return this.engine.decode(stringOrBuffer);
    }
    isImplemented() {
        return this.engine;
    }
}
module.exports = $7e33c3e9749c276a$var$Base;

});

parcelRegister("g3Ahu", function(module, exports) {
'use strict';

var $6nsOh = parcelRequire("6nsOh");
var $bb0911d36f594cb7$require$Buffer = $6nsOh.Buffer;
module.exports = function base16(alphabet) {
    return {
        encode (input) {
            if (typeof input === 'string') return $bb0911d36f594cb7$require$Buffer.from(input).toString('hex');
            return input.toString('hex');
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error('invalid base16 character');
            }
            return $bb0911d36f594cb7$require$Buffer.from(input, 'hex');
        }
    };
};

});

parcelRegister("dKyv2", function(module, exports) {
'use strict';
function $a02a551efe0083f2$var$decode(input, alphabet) {
    input = input.replace(new RegExp('=', 'g'), '');
    const length = input.length;
    let bits = 0;
    let value = 0;
    let index = 0;
    const output = new Uint8Array(length * 5 / 8 | 0);
    for(let i = 0; i < length; i++){
        value = value << 5 | alphabet.indexOf(input[i]);
        bits += 5;
        if (bits >= 8) {
            output[index++] = value >>> bits - 8 & 255;
            bits -= 8;
        }
    }
    return output.buffer;
}
function $a02a551efe0083f2$var$encode(buffer, alphabet) {
    const length = buffer.byteLength;
    const view = new Uint8Array(buffer);
    const padding = alphabet.indexOf('=') === alphabet.length - 1;
    if (padding) alphabet = alphabet.substring(0, alphabet.length - 1);
    let bits = 0;
    let value = 0;
    let output = '';
    for(let i = 0; i < length; i++){
        value = value << 8 | view[i];
        bits += 8;
        while(bits >= 5){
            output += alphabet[value >>> bits - 5 & 31];
            bits -= 5;
        }
    }
    if (bits > 0) output += alphabet[value << 5 - bits & 31];
    if (padding) while(output.length % 8 !== 0)output += '=';
    return output;
}
module.exports = function base32(alphabet) {
    return {
        encode (input) {
            if (typeof input === 'string') return $a02a551efe0083f2$var$encode(Uint8Array.from(input), alphabet);
            return $a02a551efe0083f2$var$encode(input, alphabet);
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error('invalid base32 character');
            }
            return $a02a551efe0083f2$var$decode(input, alphabet);
        }
    };
};

});

parcelRegister("18eEH", function(module, exports) {
'use strict';

var $6nsOh = parcelRequire("6nsOh");
var $0d31e80f580e15d4$require$Buffer = $6nsOh.Buffer;
module.exports = function base64(alphabet) {
    // The alphabet is only used to know:
    //   1. If padding is enabled (must contain '=')
    //   2. If the output must be url-safe (must contain '-' and '_')
    //   3. If the input of the output function is valid
    // The alphabets from RFC 4648 are always used.
    const padding = alphabet.indexOf('=') > -1;
    const url = alphabet.indexOf('-') > -1 && alphabet.indexOf('_') > -1;
    return {
        encode (input) {
            let output = '';
            if (typeof input === 'string') output = $0d31e80f580e15d4$require$Buffer.from(input).toString('base64');
            else output = input.toString('base64');
            if (url) output = output.replace(/\+/g, '-').replace(/\//g, '_');
            const pad = output.indexOf('=');
            if (pad > 0 && !padding) output = output.substring(0, pad);
            return output;
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error('invalid base64 character');
            }
            return $0d31e80f580e15d4$require$Buffer.from(input, 'base64');
        }
    };
};

});



parcelRegister("kHKdq", function(module, exports) {
/**
 * Implementation of the multicodec specification.
 *
 * @module multicodec
 * @example
 * const multicodec = require('multicodec')
 *
 * const prefixedProtobuf = multicodec.addPrefix('protobuf', protobufBuffer)
 * // prefixedProtobuf 0x50...
 *
 */ 'use strict';

var $6nsOh = parcelRequire("6nsOh");
var $f12bac43a0af2249$require$Buffer = $6nsOh.Buffer;

var $bmskQ = parcelRequire("bmskQ");

var $bAK9o = parcelRequire("bAK9o");

var $4fkoo = parcelRequire("4fkoo");

var $ctpLB = parcelRequire("ctpLB");
exports = module.exports;
/**
 * Prefix a buffer with a multicodec-packed.
 *
 * @param {string|number} multicodecStrOrCode
 * @param {Buffer} data
 * @returns {Buffer}
 */ exports.addPrefix = (multicodecStrOrCode, data)=>{
    let prefix;
    if ($f12bac43a0af2249$require$Buffer.isBuffer(multicodecStrOrCode)) prefix = $ctpLB.varintBufferEncode(multicodecStrOrCode);
    else {
        if ($4fkoo[multicodecStrOrCode]) prefix = $4fkoo[multicodecStrOrCode];
        else throw new Error('multicodec not recognized');
    }
    return $f12bac43a0af2249$require$Buffer.concat([
        prefix,
        data
    ]);
};
/**
 * Decapsulate the multicodec-packed prefix from the data.
 *
 * @param {Buffer} data
 * @returns {Buffer}
 */ exports.rmPrefix = (data)=>{
    $bmskQ.decode(data);
    return data.slice($bmskQ.decode.bytes);
};
/**
 * Get the codec of the prefixed data.
 * @param {Buffer} prefixedData
 * @returns {string}
 */ exports.getCodec = (prefixedData)=>{
    const code = $bmskQ.decode(prefixedData);
    const codecName = $bAK9o.get(code);
    if (codecName === undefined) throw new Error(`Code ${code} not found`);
    return codecName;
};
/**
 * Get the name of the codec.
 * @param {number} codec
 * @returns {string}
 */ exports.getName = (codec)=>{
    return $bAK9o.get(codec);
};
/**
 * Get the code of the codec
 * @param {string} name
 * @returns {number}
 */ exports.getNumber = (name)=>{
    const code = $4fkoo[name];
    if (code === undefined) throw new Error('Codec `' + name + '` not found');
    return $ctpLB.varintBufferDecode(code)[0];
};
/**
 * Get the code of the prefixed data.
 * @param {Buffer} prefixedData
 * @returns {number}
 */ exports.getCode = (prefixedData)=>{
    return $bmskQ.decode(prefixedData);
};
/**
 * Get the code as varint of a codec name.
 * @param {string} codecName
 * @returns {Buffer}
 */ exports.getCodeVarint = (codecName)=>{
    const code = $4fkoo[codecName];
    if (code === undefined) throw new Error('Codec `' + codecName + '` not found');
    return code;
};
/**
 * Get the varint of a code.
 * @param {Number} code
 * @returns {Array.<number>}
 */ exports.getVarint = (code)=>{
    return $bmskQ.encode(code);
};

var $9diS7 = parcelRequire("9diS7");
Object.assign(exports, $9diS7);

// Human friendly names for printing, e.g. in error messages
exports.print = (parcelRequire("e3h98"));

});
parcelRegister("bAK9o", function(module, exports) {
'use strict';

var $abqiu = parcelRequire("abqiu");
// map for hexString -> codecName
const $8706db05d4749c0b$var$nameTable = new Map();
for(const encodingName in $abqiu){
    const code = $abqiu[encodingName];
    $8706db05d4749c0b$var$nameTable.set(code, encodingName);
}
module.exports = Object.freeze($8706db05d4749c0b$var$nameTable);

});
parcelRegister("abqiu", function(module, exports) {
module.exports = JSON.parse("{\"identity\":0,\"ip4\":4,\"tcp\":6,\"sha1\":17,\"sha2-256\":18,\"sha2-512\":19,\"sha3-512\":20,\"sha3-384\":21,\"sha3-256\":22,\"sha3-224\":23,\"shake-128\":24,\"shake-256\":25,\"keccak-224\":26,\"keccak-256\":27,\"keccak-384\":28,\"keccak-512\":29,\"blake3\":30,\"dccp\":33,\"murmur3-128\":34,\"murmur3-32\":35,\"ip6\":41,\"ip6zone\":42,\"path\":47,\"multicodec\":48,\"multihash\":49,\"multiaddr\":50,\"multibase\":51,\"dns\":53,\"dns4\":54,\"dns6\":55,\"dnsaddr\":56,\"protobuf\":80,\"cbor\":81,\"raw\":85,\"dbl-sha2-256\":86,\"rlp\":96,\"bencode\":99,\"dag-pb\":112,\"dag-cbor\":113,\"libp2p-key\":114,\"git-raw\":120,\"torrent-info\":123,\"torrent-file\":124,\"leofcoin-block\":129,\"leofcoin-tx\":130,\"leofcoin-pr\":131,\"sctp\":132,\"dag-jose\":133,\"dag-cose\":134,\"eth-block\":144,\"eth-block-list\":145,\"eth-tx-trie\":146,\"eth-tx\":147,\"eth-tx-receipt-trie\":148,\"eth-tx-receipt\":149,\"eth-state-trie\":150,\"eth-account-snapshot\":151,\"eth-storage-trie\":152,\"bitcoin-block\":176,\"bitcoin-tx\":177,\"bitcoin-witness-commitment\":178,\"zcash-block\":192,\"zcash-tx\":193,\"stellar-block\":208,\"stellar-tx\":209,\"md4\":212,\"md5\":213,\"bmt\":214,\"decred-block\":224,\"decred-tx\":225,\"ipld-ns\":226,\"ipfs-ns\":227,\"swarm-ns\":228,\"ipns-ns\":229,\"zeronet\":230,\"secp256k1-pub\":231,\"bls12_381-g1-pub\":234,\"bls12_381-g2-pub\":235,\"x25519-pub\":236,\"ed25519-pub\":237,\"dash-block\":240,\"dash-tx\":241,\"swarm-manifest\":250,\"swarm-feed\":251,\"udp\":273,\"p2p-webrtc-star\":275,\"p2p-webrtc-direct\":276,\"p2p-stardust\":277,\"p2p-circuit\":290,\"dag-json\":297,\"udt\":301,\"utp\":302,\"unix\":400,\"p2p\":421,\"ipfs\":421,\"https\":443,\"onion\":444,\"onion3\":445,\"garlic64\":446,\"garlic32\":447,\"tls\":448,\"quic\":460,\"ws\":477,\"wss\":478,\"p2p-websocket-star\":479,\"http\":480,\"json\":512,\"messagepack\":513,\"libp2p-peer-record\":769,\"sha2-256-trunc254-padded\":4114,\"ripemd-128\":4178,\"ripemd-160\":4179,\"ripemd-256\":4180,\"ripemd-320\":4181,\"x11\":4352,\"sm3-256\":21325,\"blake2b-8\":45569,\"blake2b-16\":45570,\"blake2b-24\":45571,\"blake2b-32\":45572,\"blake2b-40\":45573,\"blake2b-48\":45574,\"blake2b-56\":45575,\"blake2b-64\":45576,\"blake2b-72\":45577,\"blake2b-80\":45578,\"blake2b-88\":45579,\"blake2b-96\":45580,\"blake2b-104\":45581,\"blake2b-112\":45582,\"blake2b-120\":45583,\"blake2b-128\":45584,\"blake2b-136\":45585,\"blake2b-144\":45586,\"blake2b-152\":45587,\"blake2b-160\":45588,\"blake2b-168\":45589,\"blake2b-176\":45590,\"blake2b-184\":45591,\"blake2b-192\":45592,\"blake2b-200\":45593,\"blake2b-208\":45594,\"blake2b-216\":45595,\"blake2b-224\":45596,\"blake2b-232\":45597,\"blake2b-240\":45598,\"blake2b-248\":45599,\"blake2b-256\":45600,\"blake2b-264\":45601,\"blake2b-272\":45602,\"blake2b-280\":45603,\"blake2b-288\":45604,\"blake2b-296\":45605,\"blake2b-304\":45606,\"blake2b-312\":45607,\"blake2b-320\":45608,\"blake2b-328\":45609,\"blake2b-336\":45610,\"blake2b-344\":45611,\"blake2b-352\":45612,\"blake2b-360\":45613,\"blake2b-368\":45614,\"blake2b-376\":45615,\"blake2b-384\":45616,\"blake2b-392\":45617,\"blake2b-400\":45618,\"blake2b-408\":45619,\"blake2b-416\":45620,\"blake2b-424\":45621,\"blake2b-432\":45622,\"blake2b-440\":45623,\"blake2b-448\":45624,\"blake2b-456\":45625,\"blake2b-464\":45626,\"blake2b-472\":45627,\"blake2b-480\":45628,\"blake2b-488\":45629,\"blake2b-496\":45630,\"blake2b-504\":45631,\"blake2b-512\":45632,\"blake2s-8\":45633,\"blake2s-16\":45634,\"blake2s-24\":45635,\"blake2s-32\":45636,\"blake2s-40\":45637,\"blake2s-48\":45638,\"blake2s-56\":45639,\"blake2s-64\":45640,\"blake2s-72\":45641,\"blake2s-80\":45642,\"blake2s-88\":45643,\"blake2s-96\":45644,\"blake2s-104\":45645,\"blake2s-112\":45646,\"blake2s-120\":45647,\"blake2s-128\":45648,\"blake2s-136\":45649,\"blake2s-144\":45650,\"blake2s-152\":45651,\"blake2s-160\":45652,\"blake2s-168\":45653,\"blake2s-176\":45654,\"blake2s-184\":45655,\"blake2s-192\":45656,\"blake2s-200\":45657,\"blake2s-208\":45658,\"blake2s-216\":45659,\"blake2s-224\":45660,\"blake2s-232\":45661,\"blake2s-240\":45662,\"blake2s-248\":45663,\"blake2s-256\":45664,\"skein256-8\":45825,\"skein256-16\":45826,\"skein256-24\":45827,\"skein256-32\":45828,\"skein256-40\":45829,\"skein256-48\":45830,\"skein256-56\":45831,\"skein256-64\":45832,\"skein256-72\":45833,\"skein256-80\":45834,\"skein256-88\":45835,\"skein256-96\":45836,\"skein256-104\":45837,\"skein256-112\":45838,\"skein256-120\":45839,\"skein256-128\":45840,\"skein256-136\":45841,\"skein256-144\":45842,\"skein256-152\":45843,\"skein256-160\":45844,\"skein256-168\":45845,\"skein256-176\":45846,\"skein256-184\":45847,\"skein256-192\":45848,\"skein256-200\":45849,\"skein256-208\":45850,\"skein256-216\":45851,\"skein256-224\":45852,\"skein256-232\":45853,\"skein256-240\":45854,\"skein256-248\":45855,\"skein256-256\":45856,\"skein512-8\":45857,\"skein512-16\":45858,\"skein512-24\":45859,\"skein512-32\":45860,\"skein512-40\":45861,\"skein512-48\":45862,\"skein512-56\":45863,\"skein512-64\":45864,\"skein512-72\":45865,\"skein512-80\":45866,\"skein512-88\":45867,\"skein512-96\":45868,\"skein512-104\":45869,\"skein512-112\":45870,\"skein512-120\":45871,\"skein512-128\":45872,\"skein512-136\":45873,\"skein512-144\":45874,\"skein512-152\":45875,\"skein512-160\":45876,\"skein512-168\":45877,\"skein512-176\":45878,\"skein512-184\":45879,\"skein512-192\":45880,\"skein512-200\":45881,\"skein512-208\":45882,\"skein512-216\":45883,\"skein512-224\":45884,\"skein512-232\":45885,\"skein512-240\":45886,\"skein512-248\":45887,\"skein512-256\":45888,\"skein512-264\":45889,\"skein512-272\":45890,\"skein512-280\":45891,\"skein512-288\":45892,\"skein512-296\":45893,\"skein512-304\":45894,\"skein512-312\":45895,\"skein512-320\":45896,\"skein512-328\":45897,\"skein512-336\":45898,\"skein512-344\":45899,\"skein512-352\":45900,\"skein512-360\":45901,\"skein512-368\":45902,\"skein512-376\":45903,\"skein512-384\":45904,\"skein512-392\":45905,\"skein512-400\":45906,\"skein512-408\":45907,\"skein512-416\":45908,\"skein512-424\":45909,\"skein512-432\":45910,\"skein512-440\":45911,\"skein512-448\":45912,\"skein512-456\":45913,\"skein512-464\":45914,\"skein512-472\":45915,\"skein512-480\":45916,\"skein512-488\":45917,\"skein512-496\":45918,\"skein512-504\":45919,\"skein512-512\":45920,\"skein1024-8\":45921,\"skein1024-16\":45922,\"skein1024-24\":45923,\"skein1024-32\":45924,\"skein1024-40\":45925,\"skein1024-48\":45926,\"skein1024-56\":45927,\"skein1024-64\":45928,\"skein1024-72\":45929,\"skein1024-80\":45930,\"skein1024-88\":45931,\"skein1024-96\":45932,\"skein1024-104\":45933,\"skein1024-112\":45934,\"skein1024-120\":45935,\"skein1024-128\":45936,\"skein1024-136\":45937,\"skein1024-144\":45938,\"skein1024-152\":45939,\"skein1024-160\":45940,\"skein1024-168\":45941,\"skein1024-176\":45942,\"skein1024-184\":45943,\"skein1024-192\":45944,\"skein1024-200\":45945,\"skein1024-208\":45946,\"skein1024-216\":45947,\"skein1024-224\":45948,\"skein1024-232\":45949,\"skein1024-240\":45950,\"skein1024-248\":45951,\"skein1024-256\":45952,\"skein1024-264\":45953,\"skein1024-272\":45954,\"skein1024-280\":45955,\"skein1024-288\":45956,\"skein1024-296\":45957,\"skein1024-304\":45958,\"skein1024-312\":45959,\"skein1024-320\":45960,\"skein1024-328\":45961,\"skein1024-336\":45962,\"skein1024-344\":45963,\"skein1024-352\":45964,\"skein1024-360\":45965,\"skein1024-368\":45966,\"skein1024-376\":45967,\"skein1024-384\":45968,\"skein1024-392\":45969,\"skein1024-400\":45970,\"skein1024-408\":45971,\"skein1024-416\":45972,\"skein1024-424\":45973,\"skein1024-432\":45974,\"skein1024-440\":45975,\"skein1024-448\":45976,\"skein1024-456\":45977,\"skein1024-464\":45978,\"skein1024-472\":45979,\"skein1024-480\":45980,\"skein1024-488\":45981,\"skein1024-496\":45982,\"skein1024-504\":45983,\"skein1024-512\":45984,\"skein1024-520\":45985,\"skein1024-528\":45986,\"skein1024-536\":45987,\"skein1024-544\":45988,\"skein1024-552\":45989,\"skein1024-560\":45990,\"skein1024-568\":45991,\"skein1024-576\":45992,\"skein1024-584\":45993,\"skein1024-592\":45994,\"skein1024-600\":45995,\"skein1024-608\":45996,\"skein1024-616\":45997,\"skein1024-624\":45998,\"skein1024-632\":45999,\"skein1024-640\":46000,\"skein1024-648\":46001,\"skein1024-656\":46002,\"skein1024-664\":46003,\"skein1024-672\":46004,\"skein1024-680\":46005,\"skein1024-688\":46006,\"skein1024-696\":46007,\"skein1024-704\":46008,\"skein1024-712\":46009,\"skein1024-720\":46010,\"skein1024-728\":46011,\"skein1024-736\":46012,\"skein1024-744\":46013,\"skein1024-752\":46014,\"skein1024-760\":46015,\"skein1024-768\":46016,\"skein1024-776\":46017,\"skein1024-784\":46018,\"skein1024-792\":46019,\"skein1024-800\":46020,\"skein1024-808\":46021,\"skein1024-816\":46022,\"skein1024-824\":46023,\"skein1024-832\":46024,\"skein1024-840\":46025,\"skein1024-848\":46026,\"skein1024-856\":46027,\"skein1024-864\":46028,\"skein1024-872\":46029,\"skein1024-880\":46030,\"skein1024-888\":46031,\"skein1024-896\":46032,\"skein1024-904\":46033,\"skein1024-912\":46034,\"skein1024-920\":46035,\"skein1024-928\":46036,\"skein1024-936\":46037,\"skein1024-944\":46038,\"skein1024-952\":46039,\"skein1024-960\":46040,\"skein1024-968\":46041,\"skein1024-976\":46042,\"skein1024-984\":46043,\"skein1024-992\":46044,\"skein1024-1000\":46045,\"skein1024-1008\":46046,\"skein1024-1016\":46047,\"skein1024-1024\":46048,\"poseidon-bls12_381-a2-fc1\":46081,\"poseidon-bls12_381-a2-fc1-sc\":46082,\"zeroxcert-imprint-256\":52753,\"fil-commitment-unsealed\":61697,\"fil-commitment-sealed\":61698,\"holochain-adr-v0\":8417572,\"holochain-adr-v1\":8483108,\"holochain-key-v0\":9728292,\"holochain-key-v1\":9793828,\"holochain-sig-v0\":10645796,\"holochain-sig-v1\":10711332}");

});


parcelRegister("4fkoo", function(module, exports) {
'use strict';

var $abqiu = parcelRequire("abqiu");

var $ctpLB = parcelRequire("ctpLB");
var $317861aaa582d392$require$varintEncode = $ctpLB.varintEncode;
// map for codecName -> codeVarintBuffer
const $317861aaa582d392$var$varintTable = {};
for(const encodingName in $abqiu){
    const code = $abqiu[encodingName];
    $317861aaa582d392$var$varintTable[encodingName] = $317861aaa582d392$require$varintEncode(code);
}
module.exports = Object.freeze($317861aaa582d392$var$varintTable);

});
parcelRegister("ctpLB", function(module, exports) {
'use strict';

var $bmskQ = parcelRequire("bmskQ");

var $6nsOh = parcelRequire("6nsOh");
var $914c2e37ccd23bae$require$Buffer = $6nsOh.Buffer;
module.exports = {
    numberToBuffer: $914c2e37ccd23bae$var$numberToBuffer,
    bufferToNumber: $914c2e37ccd23bae$var$bufferToNumber,
    varintBufferEncode: $914c2e37ccd23bae$var$varintBufferEncode,
    varintBufferDecode: $914c2e37ccd23bae$var$varintBufferDecode,
    varintEncode: $914c2e37ccd23bae$var$varintEncode
};
function $914c2e37ccd23bae$var$bufferToNumber(buf) {
    return parseInt(buf.toString('hex'), 16);
}
function $914c2e37ccd23bae$var$numberToBuffer(num) {
    let hexString = num.toString(16);
    if (hexString.length % 2 === 1) hexString = '0' + hexString;
    return $914c2e37ccd23bae$require$Buffer.from(hexString, 'hex');
}
function $914c2e37ccd23bae$var$varintBufferEncode(input) {
    return $914c2e37ccd23bae$require$Buffer.from($bmskQ.encode($914c2e37ccd23bae$var$bufferToNumber(input)));
}
function $914c2e37ccd23bae$var$varintBufferDecode(input) {
    return $914c2e37ccd23bae$var$numberToBuffer($bmskQ.decode(input));
}
function $914c2e37ccd23bae$var$varintEncode(num) {
    return $914c2e37ccd23bae$require$Buffer.from($bmskQ.encode(num));
}

});


parcelRegister("9diS7", function(module, exports) {
'use strict';

var $abqiu = parcelRequire("abqiu");
// map for codecConstant -> code
const $6b53f77fb4f7ad0b$var$constants = {};
for (const [name, code] of Object.entries($abqiu))$6b53f77fb4f7ad0b$var$constants[name.toUpperCase().replace(/-/g, '_')] = code;
module.exports = Object.freeze($6b53f77fb4f7ad0b$var$constants);

});

parcelRegister("e3h98", function(module, exports) {
'use strict';

var $abqiu = parcelRequire("abqiu");
// map for code -> print friendly name
const $a3aea56978a85955$var$tableByCode = {};
for (const [name, code] of Object.entries($abqiu))if ($a3aea56978a85955$var$tableByCode[code] === undefined) $a3aea56978a85955$var$tableByCode[code] = name;
module.exports = Object.freeze($a3aea56978a85955$var$tableByCode);

});


parcelRegister("j1ZpV", function(module, exports) {
'use strict';

var $bjWAl = parcelRequire("bjWAl");

var $6nsOh = parcelRequire("6nsOh");
var $ddadc07bb798efea$require$Buffer = $6nsOh.Buffer;
var $ddadc07bb798efea$var$CIDUtil = {
    /**
   * Test if the given input is a valid CID object.
   * Returns an error message if it is not.
   * Returns undefined if it is a valid CID.
   *
   * @param {any} other
   * @returns {string}
   */ checkCIDComponents: function(other) {
        if (other == null) return 'null values are not valid CIDs';
        if (!(other.version === 0 || other.version === 1)) return 'Invalid version, must be a number equal to 1 or 0';
        if (typeof other.codec !== 'string') return 'codec must be string';
        if (other.version === 0) {
            if (other.codec !== 'dag-pb') return "codec must be 'dag-pb' for CIDv0";
            if (other.multibaseName !== 'base58btc') return "multibaseName must be 'base58btc' for CIDv0";
        }
        if (!$ddadc07bb798efea$require$Buffer.isBuffer(other.multihash)) return 'multihash must be a Buffer';
        try {
            $bjWAl.validate(other.multihash);
        } catch (err) {
            let errorMsg = err.message;
            if (!errorMsg) errorMsg = 'Multihash validation failed';
            return errorMsg;
        }
    }
};
module.exports = $ddadc07bb798efea$var$CIDUtil;

});

parcelRegister("iA5vg", function(module, exports) {
'use strict';
function $d86fdb998654ceca$var$withIs(Class, { className: className, symbolName: symbolName }) {
    const symbol = Symbol.for(symbolName);
    const ClassIsWrapper = {
        // The code below assigns the class wrapper to an object to trick
        // JavaScript engines to show the name of the extended class when
        // logging an instances.
        // We are assigning an anonymous class (class wrapper) to the object
        // with key `className` to keep the correct name.
        // If this is not supported it falls back to logging `ClassIsWrapper`.
        [className]: class extends Class {
            constructor(...args){
                super(...args);
                Object.defineProperty(this, symbol, {
                    value: true
                });
            }
            get [Symbol.toStringTag]() {
                return className;
            }
        }
    }[className];
    ClassIsWrapper[`is${className}`] = (obj)=>!!(obj && obj[symbol]);
    return ClassIsWrapper;
}
function $d86fdb998654ceca$var$withIsProto(Class, { className: className, symbolName: symbolName, withoutNew: withoutNew }) {
    const symbol = Symbol.for(symbolName);
    /* eslint-disable object-shorthand */ const ClassIsWrapper = {
        [className]: function(...args) {
            if (withoutNew && !(this instanceof ClassIsWrapper)) return new ClassIsWrapper(...args);
            const _this = Class.call(this, ...args) || this;
            if (_this && !_this[symbol]) Object.defineProperty(_this, symbol, {
                value: true
            });
            return _this;
        }
    }[className];
    /* eslint-enable object-shorthand */ ClassIsWrapper.prototype = Object.create(Class.prototype);
    ClassIsWrapper.prototype.constructor = ClassIsWrapper;
    Object.defineProperty(ClassIsWrapper.prototype, Symbol.toStringTag, {
        get () {
            return className;
        }
    });
    ClassIsWrapper[`is${className}`] = (obj)=>!!(obj && obj[symbol]);
    return ClassIsWrapper;
}
module.exports = $d86fdb998654ceca$var$withIs;
module.exports.proto = $d86fdb998654ceca$var$withIsProto;

});



parcelRegister("tp4Kx", function(module, exports) {

$parcel$export(module.exports, "cidV0ToV1Base32", () => $0586290a7b746152$export$842ca2baf3158eb4, (v) => $0586290a7b746152$export$842ca2baf3158eb4 = v);
/*
	ISC License

	Copyright (c) 2019, Pierre-Louis Despaigne

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted, provided that the above
	copyright notice and this permission notice appear in all copies.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
	WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
	MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
	ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
	WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
	ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
	OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/ var $0586290a7b746152$export$842ca2baf3158eb4;

var $ejBfT = parcelRequire("ejBfT");
/**
 * Take any ipfsHash and convert it to a CID v1 encoded in base32.
 * @param {string} ipfsHash a regular ipfs hash either a cid v0 or v1 (v1 will remain unchanged)
 * @return {string} the resulting ipfs hash as a cid v1
 */ const $0586290a7b746152$var$cidV0ToV1Base32 = (ipfsHash)=>{
    let cid = new $ejBfT(ipfsHash);
    if (cid.version === 0) cid = cid.toV1();
    return cid.toString('base32');
};
$0586290a7b746152$export$842ca2baf3158eb4 = $0586290a7b746152$var$cidV0ToV1Base32;

});





parcelRegister("7W5Xs", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $gNDGO = parcelRequire("gNDGO");

var $lIu4V = parcelRequire("lIu4V");

var $9y1Dl = parcelRequire("9y1Dl");

var $jo8Dp = parcelRequire("jo8Dp");

var $hA2kM = parcelRequire("hA2kM");
var $5c729255862535e1$require$formatters = $hA2kM.formatters;
var $5c729255862535e1$var$Personal = function Personal() {
    var _this = this;
    // sets _requestmanager
    $gNDGO.packageInit(this, arguments);
    this.net = new $jo8Dp(this);
    var defaultAccount = null;
    var defaultBlock = 'latest';
    Object.defineProperty(this, 'defaultAccount', {
        get: function() {
            return defaultAccount;
        },
        set: function(val) {
            if (val) defaultAccount = $9y1Dl.toChecksumAddress($5c729255862535e1$require$formatters.inputAddressFormatter(val));
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultAccount = defaultAccount;
            });
            return val;
        },
        enumerable: true
    });
    Object.defineProperty(this, 'defaultBlock', {
        get: function() {
            return defaultBlock;
        },
        set: function(val) {
            defaultBlock = val;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultBlock = defaultBlock;
            });
            return val;
        },
        enumerable: true
    });
    var methods = [
        new $lIu4V({
            name: 'getAccounts',
            call: 'personal_listAccounts',
            params: 0,
            outputFormatter: $9y1Dl.toChecksumAddress
        }),
        new $lIu4V({
            name: 'newAccount',
            call: 'personal_newAccount',
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: $9y1Dl.toChecksumAddress
        }),
        new $lIu4V({
            name: 'unlockAccount',
            call: 'personal_unlockAccount',
            params: 3,
            inputFormatter: [
                $5c729255862535e1$require$formatters.inputAddressFormatter,
                null,
                null
            ]
        }),
        new $lIu4V({
            name: 'lockAccount',
            call: 'personal_lockAccount',
            params: 1,
            inputFormatter: [
                $5c729255862535e1$require$formatters.inputAddressFormatter
            ]
        }),
        new $lIu4V({
            name: 'importRawKey',
            call: 'personal_importRawKey',
            params: 2
        }),
        new $lIu4V({
            name: 'sendTransaction',
            call: 'personal_sendTransaction',
            params: 2,
            inputFormatter: [
                $5c729255862535e1$require$formatters.inputTransactionFormatter,
                null
            ]
        }),
        new $lIu4V({
            name: 'signTransaction',
            call: 'personal_signTransaction',
            params: 2,
            inputFormatter: [
                $5c729255862535e1$require$formatters.inputTransactionFormatter,
                null
            ]
        }),
        new $lIu4V({
            name: 'sign',
            call: 'personal_sign',
            params: 3,
            inputFormatter: [
                $5c729255862535e1$require$formatters.inputSignFormatter,
                $5c729255862535e1$require$formatters.inputAddressFormatter,
                null
            ]
        }),
        new $lIu4V({
            name: 'ecRecover',
            call: 'personal_ecRecover',
            params: 2,
            inputFormatter: [
                $5c729255862535e1$require$formatters.inputSignFormatter,
                null
            ]
        })
    ];
    methods.forEach(function(method) {
        method.attachToObject(_this);
        method.setRequestManager(_this._requestManager);
        method.defaultBlock = _this.defaultBlock;
        method.defaultAccount = _this.defaultAccount;
    });
};
$gNDGO.addProviders($5c729255862535e1$var$Personal);
module.exports = $5c729255862535e1$var$Personal;

});

parcelRegister("2UrIJ", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file accounts.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $21e650742ccc87d8$require$Buffer = $6ZWSX.Buffer;
'use strict';

var $gNDGO = parcelRequire("gNDGO");

var $lIu4V = parcelRequire("lIu4V");

var $lqeKj = parcelRequire("lqeKj");


var $21e650742ccc87d8$var$cryp = typeof $parcel$global === 'undefined' ? (parcelRequire("5UUfm")) : (parcelRequire("5UUfm"));

var $innAd = parcelRequire("innAd");

var $8u0so = parcelRequire("8u0so");

var $9y1Dl = parcelRequire("9y1Dl");

var $hA2kM = parcelRequire("hA2kM");

var $1s2di = parcelRequire("1s2di");
var $21e650742ccc87d8$require$TransactionFactory = $1s2di.TransactionFactory;

var $5XUmm = parcelRequire("5XUmm");
var $21e650742ccc87d8$require$Common = $5XUmm.default;

var $5XUmm = parcelRequire("5XUmm");
var $21e650742ccc87d8$require$HardForks = $5XUmm.Hardfork;

var $7Z98w = parcelRequire("7Z98w");
var $21e650742ccc87d8$var$isNot = function(value) {
    return typeof value === 'undefined' || value === null;
};
var $21e650742ccc87d8$var$isExist = function(value) {
    return typeof value !== 'undefined' && value !== null;
};
var $21e650742ccc87d8$var$Accounts = function Accounts() {
    var _this = this;
    // sets _requestmanager
    $gNDGO.packageInit(this, arguments);
    // remove unecessary core functions
    delete this.BatchRequest;
    delete this.extend;
    var _ethereumCall = [
        new $lIu4V({
            name: 'getNetworkId',
            call: 'net_version',
            params: 0,
            outputFormatter: parseInt
        }),
        new $lIu4V({
            name: 'getChainId',
            call: 'eth_chainId',
            params: 0,
            outputFormatter: $9y1Dl.hexToNumber
        }),
        new $lIu4V({
            name: 'getGasPrice',
            call: 'eth_gasPrice',
            params: 0
        }),
        new $lIu4V({
            name: 'getTransactionCount',
            call: 'eth_getTransactionCount',
            params: 2,
            inputFormatter: [
                function(address) {
                    if ($9y1Dl.isAddress(address)) return address;
                    else throw new Error('Address ' + address + ' is not a valid address to get the "transactionCount".');
                },
                function() {
                    return 'latest';
                }
            ]
        }),
        new $lIu4V({
            name: 'getBlockByNumber',
            call: 'eth_getBlockByNumber',
            params: 2,
            inputFormatter: [
                function(blockNumber) {
                    return blockNumber ? $9y1Dl.toHex(blockNumber) : 'latest';
                },
                function() {
                    return false;
                }
            ]
        })
    ];
    // attach methods to this._ethereumCall
    this._ethereumCall = {};
    _ethereumCall.forEach((method)=>{
        method.attachToObject(_this._ethereumCall);
        method.setRequestManager(_this._requestManager);
    });
    this.wallet = new $21e650742ccc87d8$var$Wallet(this);
};
$21e650742ccc87d8$var$Accounts.prototype._addAccountFunctions = function(account) {
    var _this = this;
    // add sign functions
    account.signTransaction = function signTransaction(tx, callback) {
        return _this.signTransaction(tx, account.privateKey, callback);
    };
    account.sign = function sign(data) {
        return _this.sign(data, account.privateKey);
    };
    account.encrypt = function encrypt(password, options) {
        return _this.encrypt(account.privateKey, password, options);
    };
    return account;
};
$21e650742ccc87d8$var$Accounts.prototype.create = function create(entropy) {
    return this._addAccountFunctions($lqeKj.create(entropy || $9y1Dl.randomHex(32)));
};
$21e650742ccc87d8$var$Accounts.prototype.privateKeyToAccount = function privateKeyToAccount(privateKey, ignoreLength) {
    if (!privateKey.startsWith('0x')) privateKey = '0x' + privateKey;
    // 64 hex characters + hex-prefix
    if (!ignoreLength && privateKey.length !== 66) throw new Error("Private key must be 32 bytes long");
    return this._addAccountFunctions($lqeKj.fromPrivate(privateKey));
};
$21e650742ccc87d8$var$Accounts.prototype.signTransaction = function signTransaction(tx, privateKey, callback) {
    var _this = this, error = false, transactionOptions = {}, hasTxSigningOptions = !!(tx && (tx.chain && tx.hardfork || tx.common));
    callback = callback || function() {};
    if (!tx) {
        error = new Error('No transaction object given!');
        callback(error);
        return Promise.reject(error);
    }
    if ($21e650742ccc87d8$var$isExist(tx.common) && $21e650742ccc87d8$var$isNot(tx.common.customChain)) {
        error = new Error('If tx.common is provided it must have tx.common.customChain');
        callback(error);
        return Promise.reject(error);
    }
    if ($21e650742ccc87d8$var$isExist(tx.common) && $21e650742ccc87d8$var$isNot(tx.common.customChain.chainId)) {
        error = new Error('If tx.common is provided it must have tx.common.customChain and tx.common.customChain.chainId');
        callback(error);
        return Promise.reject(error);
    }
    if ($21e650742ccc87d8$var$isExist(tx.common) && $21e650742ccc87d8$var$isExist(tx.common.customChain.chainId) && $21e650742ccc87d8$var$isExist(tx.chainId) && tx.chainId !== tx.common.customChain.chainId) {
        error = new Error('Chain Id doesnt match in tx.chainId tx.common.customChain.chainId');
        callback(error);
        return Promise.reject(error);
    }
    function signed(tx) {
        const error = $21e650742ccc87d8$var$_validateTransactionForSigning(tx);
        if (error) {
            callback(error);
            return Promise.reject(error);
        }
        try {
            var transaction = $hA2kM.formatters.inputCallFormatter(Object.assign({}, tx));
            transaction.data = transaction.data || '0x';
            transaction.value = transaction.value || '0x';
            transaction.gasLimit = transaction.gasLimit || transaction.gas;
            if (transaction.type === '0x1' && transaction.accessList === undefined) transaction.accessList = [];
            // Because tx has no @ethereumjs/tx signing options we use fetched vals.
            if (!hasTxSigningOptions) {
                transactionOptions.common = $21e650742ccc87d8$require$Common.forCustomChain('mainnet', {
                    name: 'custom-network',
                    networkId: transaction.networkId,
                    chainId: transaction.chainId
                }, transaction.hardfork || $21e650742ccc87d8$require$HardForks.London);
                delete transaction.networkId;
            } else {
                if (transaction.common) {
                    transactionOptions.common = $21e650742ccc87d8$require$Common.forCustomChain(transaction.common.baseChain || 'mainnet', {
                        name: transaction.common.customChain.name || 'custom-network',
                        networkId: transaction.common.customChain.networkId,
                        chainId: transaction.common.customChain.chainId
                    }, transaction.common.hardfork || $21e650742ccc87d8$require$HardForks.London);
                    delete transaction.common;
                }
                if (transaction.chain) {
                    transactionOptions.chain = transaction.chain;
                    delete transaction.chain;
                }
                if (transaction.hardfork) {
                    transactionOptions.hardfork = transaction.hardfork;
                    delete transaction.hardfork;
                }
            }
            if (privateKey.startsWith('0x')) privateKey = privateKey.substring(2);
            var ethTx = $21e650742ccc87d8$require$TransactionFactory.fromTxData(transaction, transactionOptions);
            var signedTx = ethTx.sign($21e650742ccc87d8$require$Buffer.from(privateKey, 'hex'));
            var validationErrors = signedTx.validate(true);
            if (validationErrors.length > 0) {
                let errorString = 'Signer Error: ';
                for (const validationError of validationErrors)errorString += `${errorString} ${validationError}.`;
                throw new Error(errorString);
            }
            var rlpEncoded = signedTx.serialize().toString('hex');
            var rawTransaction = '0x' + rlpEncoded;
            var transactionHash = $9y1Dl.keccak256(rawTransaction);
            var result = {
                messageHash: '0x' + $21e650742ccc87d8$require$Buffer.from(signedTx.getMessageToSign(true)).toString('hex'),
                v: '0x' + signedTx.v.toString('hex'),
                r: '0x' + signedTx.r.toString('hex'),
                s: '0x' + signedTx.s.toString('hex'),
                rawTransaction: rawTransaction,
                transactionHash: transactionHash
            };
            callback(null, result);
            return result;
        } catch (e) {
            callback(e);
            return Promise.reject(e);
        }
    }
    tx.type = $21e650742ccc87d8$var$_handleTxType(tx);
    // Resolve immediately if nonce, chainId, price and signing options are provided
    if (tx.nonce !== undefined && tx.chainId !== undefined && (tx.gasPrice !== undefined || tx.maxFeePerGas !== undefined && tx.maxPriorityFeePerGas !== undefined) && hasTxSigningOptions) return Promise.resolve(signed(tx));
    // Otherwise, get the missing info from the Ethereum Node
    return Promise.all([
        $21e650742ccc87d8$var$isNot(tx.common) || $21e650742ccc87d8$var$isNot(tx.common.customChain.chainId) ? $21e650742ccc87d8$var$isNot(tx.chainId) ? _this._ethereumCall.getChainId() : tx.chainId : undefined,
        $21e650742ccc87d8$var$isNot(tx.nonce) ? _this._ethereumCall.getTransactionCount(_this.privateKeyToAccount(privateKey).address) : tx.nonce,
        $21e650742ccc87d8$var$isNot(hasTxSigningOptions) ? _this._ethereumCall.getNetworkId() : 1,
        $21e650742ccc87d8$var$_handleTxPricing(_this, tx)
    ]).then(function(args) {
        const [txchainId, txnonce, txnetworkId, txgasInfo] = args;
        if ($21e650742ccc87d8$var$isNot(txchainId) && $21e650742ccc87d8$var$isNot(tx.common) && $21e650742ccc87d8$var$isNot(tx.common.customChain.chainId) || $21e650742ccc87d8$var$isNot(txnonce) || $21e650742ccc87d8$var$isNot(txnetworkId) || $21e650742ccc87d8$var$isNot(txgasInfo)) throw new Error('One of the values "chainId", "networkId", "gasPrice", or "nonce" couldn\'t be fetched: ' + JSON.stringify(args));
        return signed({
            ...tx,
            ...$21e650742ccc87d8$var$isNot(tx.common) || $21e650742ccc87d8$var$isNot(tx.common.customChain.chainId) ? {
                chainId: txchainId
            } : {},
            nonce: txnonce,
            networkId: txnetworkId,
            ...txgasInfo // Will either be gasPrice or maxFeePerGas and maxPriorityFeePerGas
        });
    });
};
function $21e650742ccc87d8$var$_validateTransactionForSigning(tx) {
    if (tx.common && tx.chain && tx.hardfork) return new Error('Please provide the @ethereumjs/common object or the chain and hardfork property but not all together.');
    if (tx.chain && !tx.hardfork || tx.hardfork && !tx.chain) return new Error('When specifying chain and hardfork, both values must be defined. Received "chain": ' + tx.chain + ', "hardfork": ' + tx.hardfork);
    if (!tx.gas && !tx.gasLimit && !tx.maxPriorityFeePerGas && !tx.maxFeePerGas) return new Error('"gas" is missing');
    if (tx.gas && tx.gasPrice) {
        if (tx.gas < 0 || tx.gasPrice < 0) return new Error('Gas or gasPrice is lower than 0');
    } else {
        if (tx.maxPriorityFeePerGas < 0 || tx.maxFeePerGas < 0) return new Error('maxPriorityFeePerGas or maxFeePerGas is lower than 0');
    }
    if (tx.nonce < 0 || tx.chainId < 0) return new Error('Nonce or chainId is lower than 0');
    return;
}
function $21e650742ccc87d8$var$_handleTxType(tx) {
    // Taken from https://github.com/ethers-io/ethers.js/blob/2a7ce0e72a1e0c9469e10392b0329e75e341cf18/packages/abstract-signer/src.ts/index.ts#L215
    const hasEip1559 = tx.maxFeePerGas !== undefined || tx.maxPriorityFeePerGas !== undefined;
    let txType;
    if (tx.type !== undefined) txType = $9y1Dl.toHex(tx.type);
    else if (tx.type === undefined && hasEip1559) txType = '0x2';
    if (tx.gasPrice !== undefined && (txType === '0x2' || hasEip1559)) throw Error("eip-1559 transactions don't support gasPrice");
    if ((txType === '0x1' || txType === '0x0') && hasEip1559) throw Error("pre-eip-1559 transaction don't support maxFeePerGas/maxPriorityFeePerGas");
    if (hasEip1559 || tx.common && tx.common.hardfork && tx.common.hardfork.toLowerCase() === $21e650742ccc87d8$require$HardForks.London || tx.hardfork && tx.hardfork.toLowerCase() === $21e650742ccc87d8$require$HardForks.London) txType = '0x2';
    else if (tx.accessList || tx.common && tx.common.hardfork && tx.common.hardfork.toLowerCase() === $21e650742ccc87d8$require$HardForks.Berlin || tx.hardfork && tx.hardfork.toLowerCase() === $21e650742ccc87d8$require$HardForks.Berlin) txType = '0x1';
    return txType;
}
function $21e650742ccc87d8$var$_handleTxPricing(_this, tx) {
    return new Promise((resolve, reject)=>{
        try {
            if ((tx.type === undefined || tx.type < '0x2') && tx.gasPrice !== undefined) // Legacy transaction, return provided gasPrice
            resolve({
                gasPrice: tx.gasPrice
            });
            else Promise.all([
                _this._ethereumCall.getBlockByNumber(),
                _this._ethereumCall.getGasPrice()
            ]).then((responses)=>{
                const [block, gasPrice] = responses;
                if (tx.type === '0x2' && block && block.baseFeePerGas) {
                    // The network supports EIP-1559
                    // Taken from https://github.com/ethers-io/ethers.js/blob/ba6854bdd5a912fe873d5da494cb5c62c190adde/packages/abstract-provider/src.ts/index.ts#L230
                    let maxPriorityFeePerGas, maxFeePerGas;
                    if (tx.gasPrice) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        maxPriorityFeePerGas = tx.gasPrice;
                        maxFeePerGas = tx.gasPrice;
                        delete tx.gasPrice;
                    } else {
                        maxPriorityFeePerGas = tx.maxPriorityFeePerGas || '0x9502F900'; // 2.5 Gwei
                        maxFeePerGas = tx.maxFeePerGas || $9y1Dl.toHex($9y1Dl.toBN(block.baseFeePerGas).mul($9y1Dl.toBN(2)).add($9y1Dl.toBN(maxPriorityFeePerGas)));
                    }
                    resolve({
                        maxFeePerGas: maxFeePerGas,
                        maxPriorityFeePerGas: maxPriorityFeePerGas
                    });
                } else {
                    if (tx.maxPriorityFeePerGas || tx.maxFeePerGas) throw Error("Network doesn't support eip-1559");
                    resolve({
                        gasPrice: gasPrice
                    });
                }
            });
        } catch (error) {
            reject(error);
        }
    });
}
/* jshint ignore:start */ $21e650742ccc87d8$var$Accounts.prototype.recoverTransaction = function recoverTransaction(rawTx, txOptions = {}) {
    // Rely on EthereumJs/tx to determine the type of transaction
    const data = $21e650742ccc87d8$require$Buffer.from(rawTx.slice(2), "hex");
    const tx = $21e650742ccc87d8$require$TransactionFactory.fromSerializedData(data);
    //update checksum
    return $9y1Dl.toChecksumAddress(tx.getSenderAddress().toString("hex"));
};
/* jshint ignore:end */ $21e650742ccc87d8$var$Accounts.prototype.hashMessage = function hashMessage(data) {
    var messageHex = $9y1Dl.isHexStrict(data) ? data : $9y1Dl.utf8ToHex(data);
    var messageBytes = $9y1Dl.hexToBytes(messageHex);
    var messageBuffer = $21e650742ccc87d8$require$Buffer.from(messageBytes);
    var preamble = '\x19Ethereum Signed Message:\n' + messageBytes.length;
    var preambleBuffer = $21e650742ccc87d8$require$Buffer.from(preamble);
    var ethMessage = $21e650742ccc87d8$require$Buffer.concat([
        preambleBuffer,
        messageBuffer
    ]);
    return $7Z98w.bufferToHex($7Z98w.keccak256(ethMessage));
};
$21e650742ccc87d8$var$Accounts.prototype.sign = function sign(data, privateKey) {
    if (!privateKey.startsWith('0x')) privateKey = '0x' + privateKey;
    // 64 hex characters + hex-prefix
    if (privateKey.length !== 66) throw new Error("Private key must be 32 bytes long");
    var hash = this.hashMessage(data);
    var signature = $lqeKj.sign(hash, privateKey);
    var vrs = $lqeKj.decodeSignature(signature);
    return {
        message: data,
        messageHash: hash,
        v: vrs[0],
        r: vrs[1],
        s: vrs[2],
        signature: signature
    };
};
$21e650742ccc87d8$var$Accounts.prototype.recover = function recover(message, signature, preFixed) {
    var args = [].slice.apply(arguments);
    if (!!message && typeof message === 'object') return this.recover(message.messageHash, $lqeKj.encodeSignature([
        message.v,
        message.r,
        message.s
    ]), true);
    if (!preFixed) message = this.hashMessage(message);
    if (args.length >= 4) {
        preFixed = args.slice(-1)[0];
        preFixed = typeof preFixed === 'boolean' ? !!preFixed : false;
        return this.recover(message, $lqeKj.encodeSignature(args.slice(1, 4)), preFixed); // v, r, s
    }
    return $lqeKj.recover(message, signature);
};
// Taken from https://github.com/ethereumjs/ethereumjs-wallet
$21e650742ccc87d8$var$Accounts.prototype.decrypt = function(v3Keystore, password, nonStrict) {
    /* jshint maxcomplexity: 10 */ if (!(typeof password === 'string')) throw new Error('No password given.');
    var json = !!v3Keystore && typeof v3Keystore === 'object' ? v3Keystore : JSON.parse(nonStrict ? v3Keystore.toLowerCase() : v3Keystore);
    if (json.version !== 3) throw new Error('Not a valid V3 wallet');
    var derivedKey;
    var kdfparams;
    if (json.crypto.kdf === 'scrypt') {
        kdfparams = json.crypto.kdfparams;
        // FIXME: support progress reporting callback
        derivedKey = $innAd.syncScrypt($21e650742ccc87d8$require$Buffer.from(password), $21e650742ccc87d8$require$Buffer.from(kdfparams.salt, 'hex'), kdfparams.n, kdfparams.r, kdfparams.p, kdfparams.dklen);
    } else if (json.crypto.kdf === 'pbkdf2') {
        kdfparams = json.crypto.kdfparams;
        if (kdfparams.prf !== 'hmac-sha256') throw new Error('Unsupported parameters to PBKDF2');
        derivedKey = $21e650742ccc87d8$var$cryp.pbkdf2Sync($21e650742ccc87d8$require$Buffer.from(password), $21e650742ccc87d8$require$Buffer.from(kdfparams.salt, 'hex'), kdfparams.c, kdfparams.dklen, 'sha256');
    } else throw new Error('Unsupported key derivation scheme');
    var ciphertext = $21e650742ccc87d8$require$Buffer.from(json.crypto.ciphertext, 'hex');
    var mac = $9y1Dl.sha3($21e650742ccc87d8$require$Buffer.from([
        ...derivedKey.slice(16, 32),
        ...ciphertext
    ])).replace('0x', '');
    if (mac !== json.crypto.mac) throw new Error('Key derivation failed - possibly wrong password');
    var decipher = $21e650742ccc87d8$var$cryp.createDecipheriv(json.crypto.cipher, derivedKey.slice(0, 16), $21e650742ccc87d8$require$Buffer.from(json.crypto.cipherparams.iv, 'hex'));
    var seed = '0x' + $21e650742ccc87d8$require$Buffer.from([
        ...decipher.update(ciphertext),
        ...decipher.final()
    ]).toString('hex');
    return this.privateKeyToAccount(seed, true);
};
$21e650742ccc87d8$var$Accounts.prototype.encrypt = function(privateKey, password, options) {
    /* jshint maxcomplexity: 20 */ var account = this.privateKeyToAccount(privateKey, true);
    options = options || {};
    var salt = options.salt || $21e650742ccc87d8$var$cryp.randomBytes(32);
    var iv = options.iv || $21e650742ccc87d8$var$cryp.randomBytes(16);
    var derivedKey;
    var kdf = options.kdf || 'scrypt';
    var kdfparams = {
        dklen: options.dklen || 32,
        salt: salt.toString('hex')
    };
    if (kdf === 'pbkdf2') {
        kdfparams.c = options.c || 262144;
        kdfparams.prf = 'hmac-sha256';
        derivedKey = $21e650742ccc87d8$var$cryp.pbkdf2Sync($21e650742ccc87d8$require$Buffer.from(password), $21e650742ccc87d8$require$Buffer.from(kdfparams.salt, 'hex'), kdfparams.c, kdfparams.dklen, 'sha256');
    } else if (kdf === 'scrypt') {
        // FIXME: support progress reporting callback
        kdfparams.n = options.n || 8192; // 2048 4096 8192 16384
        kdfparams.r = options.r || 8;
        kdfparams.p = options.p || 1;
        derivedKey = $innAd.syncScrypt($21e650742ccc87d8$require$Buffer.from(password), $21e650742ccc87d8$require$Buffer.from(kdfparams.salt, 'hex'), kdfparams.n, kdfparams.r, kdfparams.p, kdfparams.dklen);
    } else throw new Error('Unsupported kdf');
    var cipher = $21e650742ccc87d8$var$cryp.createCipheriv(options.cipher || 'aes-128-ctr', derivedKey.slice(0, 16), iv);
    if (!cipher) throw new Error('Unsupported cipher');
    var ciphertext = $21e650742ccc87d8$require$Buffer.from([
        ...cipher.update($21e650742ccc87d8$require$Buffer.from(account.privateKey.replace('0x', ''), 'hex')),
        ...cipher.final()
    ]);
    var mac = $9y1Dl.sha3($21e650742ccc87d8$require$Buffer.from([
        ...derivedKey.slice(16, 32),
        ...ciphertext
    ])).replace('0x', '');
    return {
        version: 3,
        id: $8u0so.v4({
            random: options.uuid || $21e650742ccc87d8$var$cryp.randomBytes(16)
        }),
        address: account.address.toLowerCase().replace('0x', ''),
        crypto: {
            ciphertext: ciphertext.toString('hex'),
            cipherparams: {
                iv: iv.toString('hex')
            },
            cipher: options.cipher || 'aes-128-ctr',
            kdf: kdf,
            kdfparams: kdfparams,
            mac: mac.toString('hex')
        }
    };
};
// Note: this is trying to follow closely the specs on
// http://web3js.readthedocs.io/en/1.0/web3-eth-accounts.html
function $21e650742ccc87d8$var$Wallet(accounts) {
    this._accounts = accounts;
    this.length = 0;
    this.defaultKeyName = 'web3js_wallet';
}
$21e650742ccc87d8$var$Wallet.prototype._findSafeIndex = function(pointer) {
    pointer = pointer || 0;
    if (this.hasOwnProperty(pointer)) return this._findSafeIndex(pointer + 1);
    else return pointer;
};
$21e650742ccc87d8$var$Wallet.prototype._currentIndexes = function() {
    var keys = Object.keys(this);
    var indexes = keys.map(function(key) {
        return parseInt(key);
    }).filter(function(n) {
        return n < 9e20;
    });
    return indexes;
};
$21e650742ccc87d8$var$Wallet.prototype.create = function(numberOfAccounts, entropy) {
    for(var i = 0; i < numberOfAccounts; ++i)this.add(this._accounts.create(entropy).privateKey);
    return this;
};
$21e650742ccc87d8$var$Wallet.prototype.add = function(account) {
    if (typeof account === 'string') account = this._accounts.privateKeyToAccount(account);
    if (!this[account.address]) {
        account = this._accounts.privateKeyToAccount(account.privateKey);
        account.index = this._findSafeIndex();
        this[account.index] = account;
        this[account.address] = account;
        this[account.address.toLowerCase()] = account;
        this.length++;
        return account;
    } else return this[account.address];
};
$21e650742ccc87d8$var$Wallet.prototype.remove = function(addressOrIndex) {
    var account = this[addressOrIndex];
    if (account && account.address) {
        // address
        this[account.address].privateKey = null;
        delete this[account.address];
        // address lowercase
        this[account.address.toLowerCase()].privateKey = null;
        delete this[account.address.toLowerCase()];
        // index
        this[account.index].privateKey = null;
        delete this[account.index];
        this.length--;
        return true;
    } else return false;
};
$21e650742ccc87d8$var$Wallet.prototype.clear = function() {
    var _this = this;
    var indexes = this._currentIndexes();
    indexes.forEach(function(index) {
        _this.remove(index);
    });
    return this;
};
$21e650742ccc87d8$var$Wallet.prototype.encrypt = function(password, options) {
    var _this = this;
    var indexes = this._currentIndexes();
    var accounts = indexes.map(function(index) {
        return _this[index].encrypt(password, options);
    });
    return accounts;
};
$21e650742ccc87d8$var$Wallet.prototype.decrypt = function(encryptedWallet, password) {
    var _this = this;
    encryptedWallet.forEach(function(keystore) {
        var account = _this._accounts.decrypt(keystore, password);
        if (account) _this.add(account);
        else throw new Error('Couldn\'t decrypt accounts. Password wrong?');
    });
    return this;
};
$21e650742ccc87d8$var$Wallet.prototype.save = function(password, keyName) {
    localStorage.setItem(keyName || this.defaultKeyName, JSON.stringify(this.encrypt(password)));
    return true;
};
$21e650742ccc87d8$var$Wallet.prototype.load = function(password, keyName) {
    var keystore = localStorage.getItem(keyName || this.defaultKeyName);
    if (keystore) try {
        keystore = JSON.parse(keystore);
    } catch (e) {}
    return this.decrypt(keystore || [], password);
};
if (!$21e650742ccc87d8$var$storageAvailable('localStorage')) {
    delete $21e650742ccc87d8$var$Wallet.prototype.save;
    delete $21e650742ccc87d8$var$Wallet.prototype.load;
}
/**
 * Checks whether a storage type is available or not
 * For more info on how this works, please refer to MDN documentation
 * https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
 *
 * @method storageAvailable
 * @param {String} type the type of storage ('localStorage', 'sessionStorage')
 * @returns {Boolean} a boolean indicating whether the specified storage is available or not
 */ function $21e650742ccc87d8$var$storageAvailable(type) {
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}
module.exports = $21e650742ccc87d8$var$Accounts;

});
parcelRegister("lqeKj", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f98776f07a84dd09$require$Buffer = $6ZWSX.Buffer;

var $aQ1ms = parcelRequire("aQ1ms");

var $h57gi = parcelRequire("h57gi");

var $1zUcV = parcelRequire("1zUcV");
parcelRequire("94Wtp");
const $f98776f07a84dd09$var$secp256k1 = new $1zUcV.ec("secp256k1"); // eslint-disable-line

var $cmnt0 = parcelRequire("cmnt0");
var $f98776f07a84dd09$require$keccak256 = $cmnt0.keccak256;
var $f98776f07a84dd09$require$keccak256s = $cmnt0.keccak256s;
const $f98776f07a84dd09$var$create = (entropy)=>{
    const innerHex = $f98776f07a84dd09$require$keccak256($aQ1ms.concat($aQ1ms.random(32), entropy || $aQ1ms.random(32)));
    const middleHex = $aQ1ms.concat($aQ1ms.concat($aQ1ms.random(32), innerHex), $aQ1ms.random(32));
    const outerHex = $f98776f07a84dd09$require$keccak256(middleHex);
    return $f98776f07a84dd09$var$fromPrivate(outerHex);
};
const $f98776f07a84dd09$var$toChecksum = (address)=>{
    const addressHash = $f98776f07a84dd09$require$keccak256s(address.slice(2));
    let checksumAddress = "0x";
    for(let i = 0; i < 40; i++)checksumAddress += parseInt(addressHash[i + 2], 16) > 7 ? address[i + 2].toUpperCase() : address[i + 2];
    return checksumAddress;
};
const $f98776f07a84dd09$var$fromPrivate = (privateKey)=>{
    const buffer = new $f98776f07a84dd09$require$Buffer(privateKey.slice(2), "hex");
    const ecKey = $f98776f07a84dd09$var$secp256k1.keyFromPrivate(buffer);
    const publicKey = "0x" + ecKey.getPublic(false, 'hex').slice(2);
    const publicHash = $f98776f07a84dd09$require$keccak256(publicKey);
    const address = $f98776f07a84dd09$var$toChecksum("0x" + publicHash.slice(-40));
    return {
        address: address,
        privateKey: privateKey
    };
};
const $f98776f07a84dd09$var$encodeSignature = ([v, r, s])=>$aQ1ms.flatten([
        r,
        s,
        v
    ]);
const $f98776f07a84dd09$var$decodeSignature = (hex)=>[
        $aQ1ms.slice(64, $aQ1ms.length(hex), hex),
        $aQ1ms.slice(0, 32, hex),
        $aQ1ms.slice(32, 64, hex)
    ];
const $f98776f07a84dd09$var$makeSigner = (addToV)=>(hash, privateKey)=>{
        const signature = $f98776f07a84dd09$var$secp256k1.keyFromPrivate(new $f98776f07a84dd09$require$Buffer(privateKey.slice(2), "hex")).sign(new $f98776f07a84dd09$require$Buffer(hash.slice(2), "hex"), {
            canonical: true
        });
        return $f98776f07a84dd09$var$encodeSignature([
            $h57gi.fromString($aQ1ms.fromNumber(addToV + signature.recoveryParam)),
            $aQ1ms.pad(32, $aQ1ms.fromNat("0x" + signature.r.toString(16))),
            $aQ1ms.pad(32, $aQ1ms.fromNat("0x" + signature.s.toString(16)))
        ]);
    };
const $f98776f07a84dd09$var$sign = $f98776f07a84dd09$var$makeSigner(27); // v=27|28 instead of 0|1...
const $f98776f07a84dd09$var$recover = (hash, signature)=>{
    const vals = $f98776f07a84dd09$var$decodeSignature(signature);
    const vrs = {
        v: $aQ1ms.toNumber(vals[0]),
        r: vals[1].slice(2),
        s: vals[2].slice(2)
    };
    const ecPublicKey = $f98776f07a84dd09$var$secp256k1.recoverPubKey(new $f98776f07a84dd09$require$Buffer(hash.slice(2), "hex"), vrs, vrs.v < 2 ? vrs.v : 1 - vrs.v % 2); // because odd vals mean v=0... sadly that means v=0 means v=1... I hate that
    const publicKey = "0x" + ecPublicKey.encode("hex", false).slice(2);
    const publicHash = $f98776f07a84dd09$require$keccak256(publicKey);
    const address = $f98776f07a84dd09$var$toChecksum("0x" + publicHash.slice(-40));
    return address;
};
module.exports = {
    create: $f98776f07a84dd09$var$create,
    toChecksum: $f98776f07a84dd09$var$toChecksum,
    fromPrivate: $f98776f07a84dd09$var$fromPrivate,
    sign: $f98776f07a84dd09$var$sign,
    makeSigner: $f98776f07a84dd09$var$makeSigner,
    recover: $f98776f07a84dd09$var$recover,
    encodeSignature: $f98776f07a84dd09$var$encodeSignature,
    decodeSignature: $f98776f07a84dd09$var$decodeSignature
};

});
parcelRegister("aQ1ms", function(module, exports) {
parcelRequire("7WkkH");
const $020949908086531e$var$at = (bytes, index)=>parseInt(bytes.slice(index * 2 + 2, index * 2 + 4), 16);

const $020949908086531e$var$random = (bytes)=>{
    let rnd;
    if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) rnd = window.crypto.getRandomValues(new Uint8Array(bytes));
    else rnd = (parcelRequire("5UUfm")).randomBytes(bytes);
    let hex = "0x";
    for(let i = 0; i < bytes; ++i)hex += ("00" + rnd[i].toString(16)).slice(-2);
    return hex;
};
const $020949908086531e$var$length = (a)=>(a.length - 2) / 2;
const $020949908086531e$var$flatten = (a)=>"0x" + a.reduce((r, s)=>r + s.slice(2), "");
const $020949908086531e$var$slice = (i, j, bs)=>"0x" + bs.slice(i * 2 + 2, j * 2 + 2);
const $020949908086531e$var$reverse = (hex)=>{
    let rev = "0x";
    for(let i = 0, l = $020949908086531e$var$length(hex); i < l; ++i)rev += hex.slice((l - i) * 2, (l - i + 1) * 2);
    return rev;
};
const $020949908086531e$var$pad = (l, hex)=>hex.length === l * 2 + 2 ? hex : $020949908086531e$var$pad(l, "0x0" + hex.slice(2));
const $020949908086531e$var$padRight = (l, hex)=>hex.length === l * 2 + 2 ? hex : $020949908086531e$var$padRight(l, hex + "0");
const $020949908086531e$var$toArray = (hex)=>{
    let arr = [];
    for(let i = 2, l = hex.length; i < l; i += 2)arr.push(parseInt(hex.slice(i, i + 2), 16));
    return arr;
};
const $020949908086531e$var$fromArray = (arr)=>{
    let hex = "0x";
    for(let i = 0, l = arr.length; i < l; ++i){
        let b = arr[i];
        hex += (b < 16 ? "0" : "") + b.toString(16);
    }
    return hex;
};
const $020949908086531e$var$toUint8Array = (hex)=>new Uint8Array($020949908086531e$var$toArray(hex));
const $020949908086531e$var$fromUint8Array = (arr)=>$020949908086531e$var$fromArray([].slice.call(arr, 0));
const $020949908086531e$var$fromNumber = (num)=>{
    let hex = num.toString(16);
    return hex.length % 2 === 0 ? "0x" + hex : "0x0" + hex;
};
const $020949908086531e$var$toNumber = (hex)=>parseInt(hex.slice(2), 16);
const $020949908086531e$var$concat = (a, b)=>a.concat(b.slice(2));
const $020949908086531e$var$fromNat = (bn)=>bn === "0x0" ? "0x" : bn.length % 2 === 0 ? bn : "0x0" + bn.slice(2);
const $020949908086531e$var$toNat = (bn)=>bn[2] === "0" ? "0x" + bn.slice(3) : bn;
const $020949908086531e$var$fromAscii = (ascii)=>{
    let hex = "0x";
    for(let i = 0; i < ascii.length; ++i)hex += ("00" + ascii.charCodeAt(i).toString(16)).slice(-2);
    return hex;
};
const $020949908086531e$var$toAscii = (hex)=>{
    let ascii = "";
    for(let i = 2; i < hex.length; i += 2)ascii += String.fromCharCode(parseInt(hex.slice(i, i + 2), 16));
    return ascii;
};
// From https://gist.github.com/pascaldekloe/62546103a1576803dade9269ccf76330
const $020949908086531e$var$fromString = (s)=>{
    const makeByte = (uint8)=>{
        const b = uint8.toString(16);
        return b.length < 2 ? "0" + b : b;
    };
    let bytes = "0x";
    for(let ci = 0; ci != s.length; ci++){
        let c = s.charCodeAt(ci);
        if (c < 128) {
            bytes += makeByte(c);
            continue;
        }
        if (c < 2048) bytes += makeByte(c >> 6 | 192);
        else {
            if (c > 0xd7ff && c < 0xdc00) {
                if (++ci == s.length) return null;
                let c2 = s.charCodeAt(ci);
                if (c2 < 0xdc00 || c2 > 0xdfff) return null;
                c = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
                bytes += makeByte(c >> 18 | 240);
                bytes += makeByte(c >> 12 & 63 | 128);
            } else // c <= 0xffff
            bytes += makeByte(c >> 12 | 224);
            bytes += makeByte(c >> 6 & 63 | 128);
        }
        bytes += makeByte(c & 63 | 128);
    }
    return bytes;
};
const $020949908086531e$var$toString = (bytes)=>{
    let s = '';
    let i = 0;
    let l = $020949908086531e$var$length(bytes);
    while(i < l){
        let c = $020949908086531e$var$at(bytes, i++);
        if (c > 127) {
            if (c > 191 && c < 224) {
                if (i >= l) return null;
                c = (c & 31) << 6 | $020949908086531e$var$at(bytes, i) & 63;
            } else if (c > 223 && c < 240) {
                if (i + 1 >= l) return null;
                c = (c & 15) << 12 | ($020949908086531e$var$at(bytes, i) & 63) << 6 | $020949908086531e$var$at(bytes, ++i) & 63;
            } else if (c > 239 && c < 248) {
                if (i + 2 >= l) return null;
                c = (c & 7) << 18 | ($020949908086531e$var$at(bytes, i) & 63) << 12 | ($020949908086531e$var$at(bytes, ++i) & 63) << 6 | $020949908086531e$var$at(bytes, ++i) & 63;
            } else return null;
            ++i;
        }
        if (c <= 0xffff) s += String.fromCharCode(c);
        else if (c <= 0x10ffff) {
            c -= 0x10000;
            s += String.fromCharCode(c >> 10 | 0xd800);
            s += String.fromCharCode(c & 0x3FF | 0xdc00);
        } else return null;
    }
    return s;
};
module.exports = {
    random: $020949908086531e$var$random,
    length: $020949908086531e$var$length,
    concat: $020949908086531e$var$concat,
    flatten: $020949908086531e$var$flatten,
    slice: $020949908086531e$var$slice,
    reverse: $020949908086531e$var$reverse,
    pad: $020949908086531e$var$pad,
    padRight: $020949908086531e$var$padRight,
    fromAscii: $020949908086531e$var$fromAscii,
    toAscii: $020949908086531e$var$toAscii,
    fromString: $020949908086531e$var$fromString,
    toString: $020949908086531e$var$toString,
    fromNumber: $020949908086531e$var$fromNumber,
    toNumber: $020949908086531e$var$toNumber,
    fromNat: $020949908086531e$var$fromNat,
    toNat: $020949908086531e$var$toNat,
    fromArray: $020949908086531e$var$fromArray,
    toArray: $020949908086531e$var$toArray,
    fromUint8Array: $020949908086531e$var$fromUint8Array,
    toUint8Array: $020949908086531e$var$toUint8Array
};

});
parcelRegister("7WkkH", function(module, exports) {
const $5c7db8d9c8b011f4$var$generate = (num, fn)=>{
    let a = [];
    for(var i = 0; i < num; ++i)a.push(fn(i));
    return a;
};
const $5c7db8d9c8b011f4$var$replicate = (num, val)=>$5c7db8d9c8b011f4$var$generate(num, ()=>val);
const $5c7db8d9c8b011f4$var$concat = (a, b)=>a.concat(b);
const $5c7db8d9c8b011f4$var$flatten = (a)=>{
    let r = [];
    for(let j = 0, J = a.length; j < J; ++j)for(let i = 0, I = a[j].length; i < I; ++i)r.push(a[j][i]);
    return r;
};
const $5c7db8d9c8b011f4$var$chunksOf = (n, a)=>{
    let b = [];
    for(let i = 0, l = a.length; i < l; i += n)b.push(a.slice(i, i + n));
    return b;
};
module.exports = {
    generate: $5c7db8d9c8b011f4$var$generate,
    replicate: $5c7db8d9c8b011f4$var$replicate,
    concat: $5c7db8d9c8b011f4$var$concat,
    flatten: $5c7db8d9c8b011f4$var$flatten,
    chunksOf: $5c7db8d9c8b011f4$var$chunksOf
};

});

parcelRegister("5UUfm", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $44edd02a6be448cd$export$5f828d93ff035aa8, (v) => $44edd02a6be448cd$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $44edd02a6be448cd$export$cd94982b18c6332c, (v) => $44edd02a6be448cd$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $44edd02a6be448cd$export$1d518568e4f529b0, (v) => $44edd02a6be448cd$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $44edd02a6be448cd$export$5285b6d41c912b41, (v) => $44edd02a6be448cd$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $44edd02a6be448cd$export$2fb37efbf6ae0c0e, (v) => $44edd02a6be448cd$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $44edd02a6be448cd$export$ab85ecd77ce6a5cd, (v) => $44edd02a6be448cd$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $44edd02a6be448cd$export$da39cf97e1eb7c91, (v) => $44edd02a6be448cd$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $44edd02a6be448cd$export$52a9039d7177394f, (v) => $44edd02a6be448cd$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $44edd02a6be448cd$export$f7201db400317331, (v) => $44edd02a6be448cd$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $44edd02a6be448cd$export$448fa22aedc9dbca, (v) => $44edd02a6be448cd$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $44edd02a6be448cd$export$b80c7ba289c8fa56, (v) => $44edd02a6be448cd$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $44edd02a6be448cd$export$26e5786e8ac8e530, (v) => $44edd02a6be448cd$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $44edd02a6be448cd$export$bdd223f16383713e, (v) => $44edd02a6be448cd$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $44edd02a6be448cd$export$20533d26f07f1ee0, (v) => $44edd02a6be448cd$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $44edd02a6be448cd$export$2f64596b8cbf08b4, (v) => $44edd02a6be448cd$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $44edd02a6be448cd$export$2ce6d8d0e8b04e1a, (v) => $44edd02a6be448cd$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $44edd02a6be448cd$export$12ada9414fbc594c, (v) => $44edd02a6be448cd$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $44edd02a6be448cd$export$f5e7e39d57cd9700, (v) => $44edd02a6be448cd$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $44edd02a6be448cd$export$36b6d6ef312eab39, (v) => $44edd02a6be448cd$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $44edd02a6be448cd$export$58a258485f1e49f6, (v) => $44edd02a6be448cd$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $44edd02a6be448cd$export$dedd8dc3dc62b370, (v) => $44edd02a6be448cd$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $44edd02a6be448cd$export$971862a2fcb1bb40, (v) => $44edd02a6be448cd$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $44edd02a6be448cd$export$c6ff6a88acbeaf40, (v) => $44edd02a6be448cd$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $44edd02a6be448cd$export$fdc27893e98845cc, (v) => $44edd02a6be448cd$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $44edd02a6be448cd$export$6671fb9a1323bed, (v) => $44edd02a6be448cd$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $44edd02a6be448cd$export$d74daf141a551db, (v) => $44edd02a6be448cd$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $44edd02a6be448cd$export$45df7cae684751af, (v) => $44edd02a6be448cd$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $44edd02a6be448cd$export$1db683ad541682f6, (v) => $44edd02a6be448cd$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $44edd02a6be448cd$export$6f65485f87568e37, (v) => $44edd02a6be448cd$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $44edd02a6be448cd$export$91a8e56769aeb334, (v) => $44edd02a6be448cd$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $44edd02a6be448cd$export$2d4117e99c2179e4, (v) => $44edd02a6be448cd$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $44edd02a6be448cd$export$512823e338ddb1b7, (v) => $44edd02a6be448cd$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $44edd02a6be448cd$export$9d0e0c0c4a8d30f3, (v) => $44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $44edd02a6be448cd$export$b9d55ff329113abd, (v) => $44edd02a6be448cd$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $44edd02a6be448cd$export$7efb24e2fddf99b9, (v) => $44edd02a6be448cd$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $44edd02a6be448cd$export$bb1abf2ce84fc7e8, (v) => $44edd02a6be448cd$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $44edd02a6be448cd$export$2f7171e78e524d5e, (v) => $44edd02a6be448cd$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $44edd02a6be448cd$export$e1d879b482f37d98, (v) => $44edd02a6be448cd$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $44edd02a6be448cd$export$1a988e7317c65621, (v) => $44edd02a6be448cd$export$1a988e7317c65621 = v);
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
'use strict';

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));

var $eFSIF = parcelRequire("eFSIF");
var $44edd02a6be448cd$var$algoKeys = Object.keys($eFSIF);
var $44edd02a6be448cd$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;

var $eyeBm = parcelRequire("eyeBm");
$44edd02a6be448cd$export$26e5786e8ac8e530 = $eyeBm.Cipher;
$44edd02a6be448cd$export$bdd223f16383713e = $eyeBm.createCipher;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $eyeBm.Cipheriv;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $eyeBm.createCipheriv;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $eyeBm.Decipher;
$44edd02a6be448cd$export$12ada9414fbc594c = $eyeBm.createDecipher;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $eyeBm.Decipheriv;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $eyeBm.createDecipheriv;
$44edd02a6be448cd$export$58a258485f1e49f6 = $eyeBm.getCiphers;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $eyeBm.listCiphers;

var $5NszM = parcelRequire("5NszM");
$44edd02a6be448cd$export$971862a2fcb1bb40 = $5NszM.DiffieHellmanGroup;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $5NszM.createDiffieHellmanGroup;
$44edd02a6be448cd$export$fdc27893e98845cc = $5NszM.getDiffieHellman;
$44edd02a6be448cd$export$6671fb9a1323bed = $5NszM.createDiffieHellman;
$44edd02a6be448cd$export$d74daf141a551db = $5NszM.DiffieHellman;

var $4zMFU = parcelRequire("4zMFU");
$44edd02a6be448cd$export$45df7cae684751af = $4zMFU.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $4zMFU.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $4zMFU.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $4zMFU.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));

var $fMM6j = parcelRequire("fMM6j");
$44edd02a6be448cd$export$512823e338ddb1b7 = $fMM6j.publicEncrypt;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $fMM6j.privateEncrypt;
$44edd02a6be448cd$export$b9d55ff329113abd = $fMM6j.publicDecrypt;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $fMM6j.privateDecrypt;

var $c34vB = parcelRequire("c34vB");
$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $c34vB.randomFill;
$44edd02a6be448cd$export$2f7171e78e524d5e = $c34vB.randomFillSync;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error([
        'sorry, createCredentials is not implemented yet',
        'we accept pull requests',
        'https://github.com/crypto-browserify/crypto-browserify'
    ].join('\n'));
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    'DH_CHECK_P_NOT_SAFE_PRIME': 2,
    'DH_CHECK_P_NOT_PRIME': 1,
    'DH_UNABLE_TO_CHECK_GENERATOR': 4,
    'DH_NOT_SUITABLE_GENERATOR': 8,
    'NPN_ENABLED': 1,
    'ALPN_ENABLED': 1,
    'RSA_PKCS1_PADDING': 1,
    'RSA_SSLV23_PADDING': 2,
    'RSA_NO_PADDING': 3,
    'RSA_PKCS1_OAEP_PADDING': 4,
    'RSA_X931_PADDING': 5,
    'RSA_PKCS1_PSS_PADDING': 6,
    'POINT_CONVERSION_COMPRESSED': 2,
    'POINT_CONVERSION_UNCOMPRESSED': 4,
    'POINT_CONVERSION_HYBRID': 6
};

});
parcelRegister("1iL1D", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, 'digest');
    if (typeof key === 'string') key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $0f2bf322914b61b2$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, 'digest');
    if (typeof key === 'string') key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("eFSIF", function(module, exports) {

module.exports = (parcelRequire("6swAi"));

});
parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});
parcelRegister("5dQ72", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $3cd697166017b735$var$checks = [];
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    digest = digest || 'sha1';
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, 'Password');
    salt = $kiaDM(salt, $6YaY3, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split('.')[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $5130da986dd86f24$var$defaultEncoding = 'utf-8';
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $a8qBR().update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func;
    if (alg === 'md5') return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, 'Password');
    salt = $kiaDM(salt, $6YaY3, 'Salt');
    digest = digest || 'sha1';
    var hmac = new $16722fe28cdbf3c2$var$Hmac(digest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $16722fe28cdbf3c2$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("kiaDM", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;
module.exports = function(thing, encoding, name) {
    if ($ec5dbe1d2de061b3$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === 'string') return $ec5dbe1d2de061b3$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $ec5dbe1d2de061b3$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView');
};

});




parcelRegister("eyeBm", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $a97f913e2ff95e3b$export$bdd223f16383713e, (v) => $a97f913e2ff95e3b$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $a97f913e2ff95e3b$export$26e5786e8ac8e530, (v) => $a97f913e2ff95e3b$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $a97f913e2ff95e3b$export$2f64596b8cbf08b4, (v) => $a97f913e2ff95e3b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $a97f913e2ff95e3b$export$20533d26f07f1ee0, (v) => $a97f913e2ff95e3b$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $a97f913e2ff95e3b$export$12ada9414fbc594c, (v) => $a97f913e2ff95e3b$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a, (v) => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $a97f913e2ff95e3b$export$36b6d6ef312eab39, (v) => $a97f913e2ff95e3b$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $a97f913e2ff95e3b$export$f5e7e39d57cd9700, (v) => $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $a97f913e2ff95e3b$export$dedd8dc3dc62b370, (v) => $a97f913e2ff95e3b$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $a97f913e2ff95e3b$export$58a258485f1e49f6, (v) => $a97f913e2ff95e3b$export$58a258485f1e49f6 = v);
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;

var $ljOtR = parcelRequire("ljOtR");

var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");

var $xsYYh = parcelRequire("xsYYh");

var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($xsYYh).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;

});
parcelRegister("ljOtR", function(module, exports) {

var $26nOC = parcelRequire("26nOC");

var $8SeDJ = parcelRequire("8SeDJ");

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    'des-ede3-cbc': $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    'des-ede3': $8SeDJ.EDE,
    'des-ede-cbc': $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    'des-ede': $8SeDJ.EDE,
    'des-cbc': $8SeDJ.CBC.instantiate($8SeDJ.DES),
    'des-ecb': $8SeDJ.DES
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes['des-cbc'];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes['des-ede3-cbc'];
module.exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};

});
parcelRegister("8SeDJ", function(module, exports) {

$parcel$export(module.exports, "DES", () => $675eb908dbde2e68$export$cc8859615686b300, (v) => $675eb908dbde2e68$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $675eb908dbde2e68$export$8ad3f227af08fcc5, (v) => $675eb908dbde2e68$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $675eb908dbde2e68$export$947646e34766044f, (v) => $675eb908dbde2e68$export$947646e34766044f = v);
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
'use strict';

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));

});
parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
'use strict';
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("enfpo", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});

parcelRegister("dB8Kv", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $dB8Kv.create({
            type: 'encrypt',
            key: k1
        }),
        $dB8Kv.create({
            type: 'decrypt',
            key: k2
        }),
        $dB8Kv.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: 'decrypt',
            key: k3
        }),
        $dB8Kv.create({
            type: 'encrypt',
            key: k2
        }),
        $dB8Kv.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});



parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $hzsAp(config.module, password, iv);
    else if (config.type === 'auth') return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});

parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $hzsAp(config.module, password, iv, true);
    else if (config.type === 'auth') return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});


parcelRegister("xsYYh", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("5NszM", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $4387b1fafb8a1868$export$971862a2fcb1bb40, (v) => $4387b1fafb8a1868$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $4387b1fafb8a1868$export$c6ff6a88acbeaf40, (v) => $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $4387b1fafb8a1868$export$fdc27893e98845cc, (v) => $4387b1fafb8a1868$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $4387b1fafb8a1868$export$6671fb9a1323bed, (v) => $4387b1fafb8a1868$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $4387b1fafb8a1868$export$d74daf141a551db, (v) => $4387b1fafb8a1868$export$d74daf141a551db = v);
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;

var $aV75E = parcelRequire("aV75E");

var $kGErQ = parcelRequire("kGErQ");

var $bLCm8 = parcelRequire("bLCm8");
function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].prime, 'hex');
    var gen = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].gen, 'hex');
    return new $bLCm8(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $bLCm8($aV75E(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $bLCm8(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;

});
parcelRegister("aV75E", function(module, exports) {

var $hkN9y = parcelRequire("hkN9y");
module.exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);

var $g2bJL = parcelRequire("g2bJL");
var $7f34ba2fa9025258$var$millerRabin = new $g2bJL();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("5vmVB", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("g2bJL", function(module, exports) {

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
module.exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("7Zvov", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});



parcelRegister("kGErQ", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("bLCm8", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $g2bJL = parcelRequire("g2bJL");
var $8911d62d5514749e$var$millerRabin = new $g2bJL();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);

var $aV75E = parcelRequire("aV75E");

var $hkN9y = parcelRequire("hkN9y");
module.exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$aV75E.simpleSieve || !$aV75E.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("4zMFU", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $b6RFW = parcelRequire("b6RFW");

var $dlqwk = parcelRequire("dlqwk");

var $6E9kG = parcelRequire("6E9kG");

var $fQdau = parcelRequire("fQdau");

var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, 'hex');
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $b6RFW.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    if (typeof data === 'string') data = $3550302076d9e62e$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $6E9kG(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $b6RFW.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    if (typeof data === 'string') data = $3550302076d9e62e$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    if (typeof sig === 'string') sig = $3550302076d9e62e$require$Buffer.from(sig, enc);
    this.end();
    var hash = this._hash.digest();
    return $fQdau(sig, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
module.exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};

});
parcelRegister("6E9kG", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    } else {
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    }
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $aYksR[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $4d6db7c28d99f640$var$sign;
module.exports.getKey = $4d6db7c28d99f640$var$getKey;
module.exports.makeKey = $4d6db7c28d99f640$var$makeKey;

});
parcelRegister("3Sg1O", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d22d91c93a13ae5$require$Buffer = $6ZWSX.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, 'be', len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});

parcelRegister("aNeDF", function(module, exports) {

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
module.exports = $7db9d5f82e4113aa$var$parseKeys;
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $fC6a8.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $fC6a8.EncryptedPrivateKey.decode(data, 'der');
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $fC6a8.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $fC6a8.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $fC6a8.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $fC6a8.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $fC6a8.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
'use strict';

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('modulus').int(), this.key('publicExponent').int(), this.key('privateExponent').int(), this.key('prime1').int(), this.key('prime2').int(), this.key('exponent1').int(), this.key('exponent2').int(), this.key('coefficient').int());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus').int(), this.key('publicExponent').int());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p').int(), this.key('q').int(), this.key('g').int()).optional());
});
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version').int(), this.key('algorithm').use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters').int())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('p').int(), this.key('q').int(), this.key('g').int(), this.key('pub_key').int(), this.key('priv_key').int());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define('DSAparam', function() {
    this.int();
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define('signature', function() {
    this.seq().obj(this.key('r').int(), this.key('s').int());
});

});
parcelRegister("10gXo", function(module, exports) {
'use strict';
const $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});
parcelRegister("9qVGS", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8fBln", function(module, exports) {
'use strict';

var $ljw8S = parcelRequire("ljw8S");

var $89TTw = parcelRequire("89TTw");

var $dlqwk = parcelRequire("dlqwk");
const $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $dlqwk(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($89TTw[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($ljw8S[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("ljw8S", function(module, exports) {
'use strict';
const $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $1ae2666fc718ae87$require$Buffer = $5ZrzL.Buffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $h4y6g.call(this, 'der', parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $h4y6g);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $1ae2666fc718ae87$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $1ae2666fc718ae87$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        const buf = $1ae2666fc718ae87$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $1ae2666fc718ae87$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === 'gentime') str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $1ae2666fc718ae87$require$Buffer.from(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $1ae2666fc718ae87$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($1ae2666fc718ae87$require$Buffer.from(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state['default'] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($1G1m0.tagByName.hasOwnProperty(tag)) res = $1G1m0.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $1G1m0.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});
parcelRegister("5ZrzL", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $hPtJY = parcelRequire("hPtJY");
'use strict';

var $6ZWSX = parcelRequire("6ZWSX");
var $45c80a3e8b7e5b65$var$Buffer = $6ZWSX.Buffer;
var $45c80a3e8b7e5b65$var$safer = {};
var $45c80a3e8b7e5b65$var$key;
for($45c80a3e8b7e5b65$var$key in $6ZWSX){
    if (!$6ZWSX.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === 'SlowBuffer' || $45c80a3e8b7e5b65$var$key === 'Buffer') continue;
    $45c80a3e8b7e5b65$var$safer[$45c80a3e8b7e5b65$var$key] = $6ZWSX[$45c80a3e8b7e5b65$var$key];
}
var $45c80a3e8b7e5b65$var$Safer = $45c80a3e8b7e5b65$var$safer.Buffer = {};
for($45c80a3e8b7e5b65$var$key in $45c80a3e8b7e5b65$var$Buffer){
    if (!$45c80a3e8b7e5b65$var$Buffer.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === 'allocUnsafe' || $45c80a3e8b7e5b65$var$key === 'allocUnsafeSlow') continue;
    $45c80a3e8b7e5b65$var$Safer[$45c80a3e8b7e5b65$var$key] = $45c80a3e8b7e5b65$var$Buffer[$45c80a3e8b7e5b65$var$key];
}
$45c80a3e8b7e5b65$var$safer.Buffer.prototype = $45c80a3e8b7e5b65$var$Buffer.prototype;
if (!$45c80a3e8b7e5b65$var$Safer.from || $45c80a3e8b7e5b65$var$Safer.from === Uint8Array.from) $45c80a3e8b7e5b65$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === 'undefined') throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value);
    return $45c80a3e8b7e5b65$var$Buffer(value, encodingOrOffset, length);
};
if (!$45c80a3e8b7e5b65$var$Safer.alloc) $45c80a3e8b7e5b65$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $45c80a3e8b7e5b65$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === 'string') buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$45c80a3e8b7e5b65$var$safer.kStringMaxLength) try {
    $45c80a3e8b7e5b65$var$safer.kStringMaxLength = $hPtJY.binding('buffer').kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$45c80a3e8b7e5b65$var$safer.constants) {
    $45c80a3e8b7e5b65$var$safer.constants = {
        MAX_LENGTH: $45c80a3e8b7e5b65$var$safer.kMaxLength
    };
    if ($45c80a3e8b7e5b65$var$safer.kStringMaxLength) $45c80a3e8b7e5b65$var$safer.constants.MAX_STRING_LENGTH = $45c80a3e8b7e5b65$var$safer.kStringMaxLength;
}
module.exports = $45c80a3e8b7e5b65$var$safer;

});

parcelRegister("h4y6g", function(module, exports) {
'use strict';

var $k2jVB = parcelRequire("k2jVB");
var $c6dd42f3395d566f$require$Reporter = $k2jVB.Reporter;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$EncoderBuffer = $33sbF.EncoderBuffer;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
const $c6dd42f3395d566f$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
const $c6dd42f3395d566f$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
const $c6dd42f3395d566f$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $c6dd42f3395d566f$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
const $c6dd42f3395d566f$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, 'Root node can have only one child');
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    const state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $koC21(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state['default'];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            const data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $koC21(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;
'use strict';

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $k2jVB = parcelRequire("k2jVB");
var $2397844df508f52e$require$Reporter = $k2jVB.Reporter;

var $5ZrzL = parcelRequire("5ZrzL");
var $2397844df508f52e$require$Buffer = $5ZrzL.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === 'object' && $2397844df508f52e$require$Buffer.isBuffer(data.base) && data.constructor.name === 'DecoderBuffer' && typeof data.offset === 'number' && typeof data.length === 'number' && typeof data.save === 'function' && typeof data.restore === 'function' && typeof data.isEmpty === 'function' && typeof data.readUInt8 === 'function' && typeof data.skip === 'function' && typeof data.raw === 'function';
    return isCompatible;
};
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer(item)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === 'object' && data.constructor.name === 'EncoderBuffer' && typeof data.length === 'number' && typeof data.join === 'function';
    return isCompatible;
};
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $2397844df508f52e$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;
'use strict';
// Helper
function $138ac3909863432c$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$138ac3909863432c$export$f18596ef8d632e49 = $138ac3909863432c$var$reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$138ac3909863432c$export$f17df38a421ab9e3 = $138ac3909863432c$var$reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("bPffB", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = 'pem';
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $2j6ve.prototype.encode.call(this, data);
    const p = buf.toString('base64');
    const out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});


parcelRegister("89TTw", function(module, exports) {
'use strict';
const $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $9qVGS = parcelRequire("9qVGS");

var $33sbF = parcelRequire("33sbF");
var $b28be291c8d179e1$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$b28be291c8d179e1$require$DecoderBuffer.isDecoderBuffer(data)) data = new $b28be291c8d179e1$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $h4y6g.call(this, 'der', parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $h4y6g);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        let str = '';
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        const numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        const printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === 'gentime') {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $9qVGS(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $1G1m0.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $1G1m0.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $6ef8062b6cdbe0f4$require$Buffer = $5ZrzL.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = 'pem';
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    const base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, '');
    const input = $6ef8062b6cdbe0f4$require$Buffer.from(base64, 'base64');
    return $fkoHA.prototype.decode.call(this, input, options);
};

});



parcelRegister("5JhaY", function(module, exports) {
'use strict';
const $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});

parcelRegister("3TcQc", function(module, exports) {
'use strict';
const $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});


parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define('RelativeDistinguishedName', function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define('RDNSequence', function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define('Name', function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($877bcccea3fc6be5$var$Time), this.key('notAfter').use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0).int().optional(), this.key('serialNumber').int(), this.key('signature').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('issuer').use($877bcccea3fc6be5$var$Name), this.key('validity').use($877bcccea3fc6be5$var$Validity), this.key('subject').use($877bcccea3fc6be5$var$Name), this.key('subjectPublicKeyInfo').use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($877bcccea3fc6be5$var$TBSCertificate), this.key('signatureAlgorithm').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});


parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("3ILSx", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], 'hex');
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("aYksR", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("fQdau", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    } else {
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    }
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum++;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $aYksR[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= q) throw new Error('invalid sig');
}
module.exports = $b885ed4272d45f84$var$verify;

});


parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("jqmf0", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("fMM6j", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $b7e0a6843ffae451$export$512823e338ddb1b7, (v) => $b7e0a6843ffae451$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $b7e0a6843ffae451$export$7efb24e2fddf99b9, (v) => $b7e0a6843ffae451$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3, (v) => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $b7e0a6843ffae451$export$b9d55ff329113abd, (v) => $b7e0a6843ffae451$export$b9d55ff329113abd = v);
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7('sha1').update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6rDPA", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7('sha1').update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("c34vB", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $8c5943302864e9a5$export$bb1abf2ce84fc7e8, (v) => $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $8c5943302864e9a5$export$2f7171e78e524d5e, (v) => $8c5943302864e9a5$export$2f7171e78e524d5e = v);
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}

});



parcelRegister("h57gi", function(module, exports) {

var $j6Niz = parcelRequire("j6Niz");

var $aQ1ms = parcelRequire("aQ1ms");
const $c6f8895d6c39c78c$var$fromBN = (bn)=>"0x" + bn.toString("hex");
const $c6f8895d6c39c78c$var$toBN = (str)=>new $j6Niz(str.slice(2), 16);
const $c6f8895d6c39c78c$var$fromString = (str)=>{
    const bn = "0x" + (str.slice(0, 2) === "0x" ? new $j6Niz(str.slice(2), 16) : new $j6Niz(str, 10)).toString("hex");
    return bn === "0x0" ? "0x" : bn;
};
const $c6f8895d6c39c78c$var$toEther = (wei)=>$c6f8895d6c39c78c$var$toNumber($c6f8895d6c39c78c$var$div(wei, $c6f8895d6c39c78c$var$fromString("10000000000"))) / 100000000;
const $c6f8895d6c39c78c$var$fromEther = (eth)=>$c6f8895d6c39c78c$var$mul($c6f8895d6c39c78c$var$fromNumber(Math.floor(eth * 100000000)), $c6f8895d6c39c78c$var$fromString("10000000000"));
const $c6f8895d6c39c78c$var$toString = (a)=>$c6f8895d6c39c78c$var$toBN(a).toString(10);
const $c6f8895d6c39c78c$var$fromNumber = (a)=>typeof a === "string" ? /^0x/.test(a) ? a : "0x" + a : "0x" + new $j6Niz(a).toString("hex");
const $c6f8895d6c39c78c$var$toNumber = (a)=>$c6f8895d6c39c78c$var$toBN(a).toNumber();
const $c6f8895d6c39c78c$var$toUint256 = (a)=>$aQ1ms.pad(32, a);
const $c6f8895d6c39c78c$var$bin = (method)=>(a, b)=>$c6f8895d6c39c78c$var$fromBN($c6f8895d6c39c78c$var$toBN(a)[method]($c6f8895d6c39c78c$var$toBN(b)));
const $c6f8895d6c39c78c$var$add = $c6f8895d6c39c78c$var$bin("add");
const $c6f8895d6c39c78c$var$mul = $c6f8895d6c39c78c$var$bin("mul");
const $c6f8895d6c39c78c$var$div = $c6f8895d6c39c78c$var$bin("div");
const $c6f8895d6c39c78c$var$sub = $c6f8895d6c39c78c$var$bin("sub");
module.exports = {
    toString: $c6f8895d6c39c78c$var$toString,
    fromString: $c6f8895d6c39c78c$var$fromString,
    toNumber: $c6f8895d6c39c78c$var$toNumber,
    fromNumber: $c6f8895d6c39c78c$var$fromNumber,
    toEther: $c6f8895d6c39c78c$var$toEther,
    fromEther: $c6f8895d6c39c78c$var$fromEther,
    toUint256: $c6f8895d6c39c78c$var$toUint256,
    add: $c6f8895d6c39c78c$var$add,
    mul: $c6f8895d6c39c78c$var$mul,
    div: $c6f8895d6c39c78c$var$div,
    sub: $c6f8895d6c39c78c$var$sub
};

});
parcelRegister("j6Niz", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("94Wtp", function(module, exports) {
// The RLP format
// Serialization and deserialization for the BytesTree type, under the following grammar:
// | First byte | Meaning                                                                    |
// | ---------- | -------------------------------------------------------------------------- |
// | 0   to 127 | HEX(leaf)                                                                  |
// | 128 to 183 | HEX(length_of_leaf + 128) + HEX(leaf)                                      |
// | 184 to 191 | HEX(length_of_length_of_leaf + 128 + 55) + HEX(length_of_leaf) + HEX(leaf) |
// | 192 to 247 | HEX(length_of_node + 192) + HEX(node)                                      |
// | 248 to 255 | HEX(length_of_length_of_node + 128 + 55) + HEX(length_of_node) + HEX(node) |
const $69c1d858812d991e$var$encode = (tree)=>{
    const padEven = (str)=>str.length % 2 === 0 ? str : "0" + str;
    const uint = (num)=>padEven(num.toString(16));
    const length = (len, add)=>len < 56 ? uint(add + len) : uint(add + uint(len).length / 2 + 55) + uint(len);
    const dataTree = (tree)=>{
        if (typeof tree === "string") {
            const hex = tree.slice(2);
            const pre = hex.length != 2 || hex >= "80" ? length(hex.length / 2, 128) : "";
            return pre + hex;
        } else {
            const hex = tree.map(dataTree).join("");
            const pre = length(hex.length / 2, 192);
            return pre + hex;
        }
    };
    return "0x" + dataTree(tree);
};
const $69c1d858812d991e$var$decode = (hex)=>{
    let i = 2;
    const parseTree = ()=>{
        if (i >= hex.length) throw "";
        const head = hex.slice(i, i + 2);
        return head < "80" ? (i += 2, "0x" + head) : head < "c0" ? parseHex() : parseList();
    };
    const parseLength = ()=>{
        const len = parseInt(hex.slice(i, i += 2), 16) % 64;
        return len < 56 ? len : parseInt(hex.slice(i, i += (len - 55) * 2), 16);
    };
    const parseHex = ()=>{
        const len = parseLength();
        return "0x" + hex.slice(i, i += len * 2);
    };
    const parseList = ()=>{
        const lim = parseLength() * 2 + i;
        let list = [];
        while(i < lim)list.push(parseTree());
        return list;
    };
    try {
        return parseTree();
    } catch (e) {
        return [];
    }
};
module.exports = {
    encode: $69c1d858812d991e$var$encode,
    decode: $69c1d858812d991e$var$decode
};

});

parcelRegister("cmnt0", function(module, exports) {
// This was ported from https://github.com/emn178/js-sha3, with some minor
// modifications and pruning. It is licensed under MIT:
//
// Copyright 2015-2016 Chen, Yi-Cyuan
//  
// Permission is hereby granted, free of charge, to any person obtaining
// a copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
// 
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
// 
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
// LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
// OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
const $8ff9be21f81a68a4$var$HEX_CHARS = '0123456789abcdef'.split('');
const $8ff9be21f81a68a4$var$KECCAK_PADDING = [
    1,
    256,
    65536,
    16777216
];
const $8ff9be21f81a68a4$var$SHIFT = [
    0,
    8,
    16,
    24
];
const $8ff9be21f81a68a4$var$RC = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
const $8ff9be21f81a68a4$var$Keccak = (bits)=>({
        blocks: [],
        reset: true,
        block: 0,
        start: 0,
        blockCount: 1600 - (bits << 1) >> 5,
        outputBlocks: bits >> 5,
        s: ((s)=>[].concat(s, s, s, s, s))([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ])
    });
const $8ff9be21f81a68a4$var$update = (state, message)=>{
    var length = message.length, blocks = state.blocks, byteCount = state.blockCount << 2, blockCount = state.blockCount, outputBlocks = state.outputBlocks, s = state.s, index = 0, i, code;
    // update
    while(index < length){
        if (state.reset) {
            state.reset = false;
            blocks[0] = state.block;
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        if (typeof message !== "string") for(i = state.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << $8ff9be21f81a68a4$var$SHIFT[i++ & 3];
        else for(i = state.start; index < length && i < byteCount; ++index){
            code = message.charCodeAt(index);
            if (code < 0x80) blocks[i >> 2] |= code << $8ff9be21f81a68a4$var$SHIFT[i++ & 3];
            else if (code < 0x800) {
                blocks[i >> 2] |= (0xc0 | code >> 6) << $8ff9be21f81a68a4$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $8ff9be21f81a68a4$var$SHIFT[i++ & 3];
            } else if (code < 0xd800 || code >= 0xe000) {
                blocks[i >> 2] |= (0xe0 | code >> 12) << $8ff9be21f81a68a4$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $8ff9be21f81a68a4$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $8ff9be21f81a68a4$var$SHIFT[i++ & 3];
            } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                blocks[i >> 2] |= (0xf0 | code >> 18) << $8ff9be21f81a68a4$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << $8ff9be21f81a68a4$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $8ff9be21f81a68a4$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $8ff9be21f81a68a4$var$SHIFT[i++ & 3];
            }
        }
        state.lastByteIndex = i;
        if (i >= byteCount) {
            state.start = i - byteCount;
            state.block = blocks[blockCount];
            for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
            $8ff9be21f81a68a4$var$f(s);
            state.reset = true;
        } else state.start = i;
    }
    // finalize
    i = state.lastByteIndex;
    blocks[i >> 2] |= $8ff9be21f81a68a4$var$KECCAK_PADDING[i & 3];
    if (state.lastByteIndex === byteCount) {
        blocks[0] = blocks[blockCount];
        for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
    }
    blocks[blockCount - 1] |= 0x80000000;
    for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
    $8ff9be21f81a68a4$var$f(s);
    // toString
    var hex = '', i = 0, j = 0, block;
    while(j < outputBlocks){
        for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
            block = s[i];
            hex += $8ff9be21f81a68a4$var$HEX_CHARS[block >> 4 & 0x0F] + $8ff9be21f81a68a4$var$HEX_CHARS[block & 0x0F] + $8ff9be21f81a68a4$var$HEX_CHARS[block >> 12 & 0x0F] + $8ff9be21f81a68a4$var$HEX_CHARS[block >> 8 & 0x0F] + $8ff9be21f81a68a4$var$HEX_CHARS[block >> 20 & 0x0F] + $8ff9be21f81a68a4$var$HEX_CHARS[block >> 16 & 0x0F] + $8ff9be21f81a68a4$var$HEX_CHARS[block >> 28 & 0x0F] + $8ff9be21f81a68a4$var$HEX_CHARS[block >> 24 & 0x0F];
        }
        if (j % blockCount === 0) {
            $8ff9be21f81a68a4$var$f(s);
            i = 0;
        }
    }
    return "0x" + hex;
};
const $8ff9be21f81a68a4$var$f = (s)=>{
    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
    for(n = 0; n < 48; n += 2){
        c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        h = c8 ^ (c2 << 1 | c3 >>> 31);
        l = c9 ^ (c3 << 1 | c2 >>> 31);
        s[0] ^= h;
        s[1] ^= l;
        s[10] ^= h;
        s[11] ^= l;
        s[20] ^= h;
        s[21] ^= l;
        s[30] ^= h;
        s[31] ^= l;
        s[40] ^= h;
        s[41] ^= l;
        h = c0 ^ (c4 << 1 | c5 >>> 31);
        l = c1 ^ (c5 << 1 | c4 >>> 31);
        s[2] ^= h;
        s[3] ^= l;
        s[12] ^= h;
        s[13] ^= l;
        s[22] ^= h;
        s[23] ^= l;
        s[32] ^= h;
        s[33] ^= l;
        s[42] ^= h;
        s[43] ^= l;
        h = c2 ^ (c6 << 1 | c7 >>> 31);
        l = c3 ^ (c7 << 1 | c6 >>> 31);
        s[4] ^= h;
        s[5] ^= l;
        s[14] ^= h;
        s[15] ^= l;
        s[24] ^= h;
        s[25] ^= l;
        s[34] ^= h;
        s[35] ^= l;
        s[44] ^= h;
        s[45] ^= l;
        h = c4 ^ (c8 << 1 | c9 >>> 31);
        l = c5 ^ (c9 << 1 | c8 >>> 31);
        s[6] ^= h;
        s[7] ^= l;
        s[16] ^= h;
        s[17] ^= l;
        s[26] ^= h;
        s[27] ^= l;
        s[36] ^= h;
        s[37] ^= l;
        s[46] ^= h;
        s[47] ^= l;
        h = c6 ^ (c0 << 1 | c1 >>> 31);
        l = c7 ^ (c1 << 1 | c0 >>> 31);
        s[8] ^= h;
        s[9] ^= l;
        s[18] ^= h;
        s[19] ^= l;
        s[28] ^= h;
        s[29] ^= l;
        s[38] ^= h;
        s[39] ^= l;
        s[48] ^= h;
        s[49] ^= l;
        b0 = s[0];
        b1 = s[1];
        b32 = s[11] << 4 | s[10] >>> 28;
        b33 = s[10] << 4 | s[11] >>> 28;
        b14 = s[20] << 3 | s[21] >>> 29;
        b15 = s[21] << 3 | s[20] >>> 29;
        b46 = s[31] << 9 | s[30] >>> 23;
        b47 = s[30] << 9 | s[31] >>> 23;
        b28 = s[40] << 18 | s[41] >>> 14;
        b29 = s[41] << 18 | s[40] >>> 14;
        b20 = s[2] << 1 | s[3] >>> 31;
        b21 = s[3] << 1 | s[2] >>> 31;
        b2 = s[13] << 12 | s[12] >>> 20;
        b3 = s[12] << 12 | s[13] >>> 20;
        b34 = s[22] << 10 | s[23] >>> 22;
        b35 = s[23] << 10 | s[22] >>> 22;
        b16 = s[33] << 13 | s[32] >>> 19;
        b17 = s[32] << 13 | s[33] >>> 19;
        b48 = s[42] << 2 | s[43] >>> 30;
        b49 = s[43] << 2 | s[42] >>> 30;
        b40 = s[5] << 30 | s[4] >>> 2;
        b41 = s[4] << 30 | s[5] >>> 2;
        b22 = s[14] << 6 | s[15] >>> 26;
        b23 = s[15] << 6 | s[14] >>> 26;
        b4 = s[25] << 11 | s[24] >>> 21;
        b5 = s[24] << 11 | s[25] >>> 21;
        b36 = s[34] << 15 | s[35] >>> 17;
        b37 = s[35] << 15 | s[34] >>> 17;
        b18 = s[45] << 29 | s[44] >>> 3;
        b19 = s[44] << 29 | s[45] >>> 3;
        b10 = s[6] << 28 | s[7] >>> 4;
        b11 = s[7] << 28 | s[6] >>> 4;
        b42 = s[17] << 23 | s[16] >>> 9;
        b43 = s[16] << 23 | s[17] >>> 9;
        b24 = s[26] << 25 | s[27] >>> 7;
        b25 = s[27] << 25 | s[26] >>> 7;
        b6 = s[36] << 21 | s[37] >>> 11;
        b7 = s[37] << 21 | s[36] >>> 11;
        b38 = s[47] << 24 | s[46] >>> 8;
        b39 = s[46] << 24 | s[47] >>> 8;
        b30 = s[8] << 27 | s[9] >>> 5;
        b31 = s[9] << 27 | s[8] >>> 5;
        b12 = s[18] << 20 | s[19] >>> 12;
        b13 = s[19] << 20 | s[18] >>> 12;
        b44 = s[29] << 7 | s[28] >>> 25;
        b45 = s[28] << 7 | s[29] >>> 25;
        b26 = s[38] << 8 | s[39] >>> 24;
        b27 = s[39] << 8 | s[38] >>> 24;
        b8 = s[48] << 14 | s[49] >>> 18;
        b9 = s[49] << 14 | s[48] >>> 18;
        s[0] = b0 ^ ~b2 & b4;
        s[1] = b1 ^ ~b3 & b5;
        s[10] = b10 ^ ~b12 & b14;
        s[11] = b11 ^ ~b13 & b15;
        s[20] = b20 ^ ~b22 & b24;
        s[21] = b21 ^ ~b23 & b25;
        s[30] = b30 ^ ~b32 & b34;
        s[31] = b31 ^ ~b33 & b35;
        s[40] = b40 ^ ~b42 & b44;
        s[41] = b41 ^ ~b43 & b45;
        s[2] = b2 ^ ~b4 & b6;
        s[3] = b3 ^ ~b5 & b7;
        s[12] = b12 ^ ~b14 & b16;
        s[13] = b13 ^ ~b15 & b17;
        s[22] = b22 ^ ~b24 & b26;
        s[23] = b23 ^ ~b25 & b27;
        s[32] = b32 ^ ~b34 & b36;
        s[33] = b33 ^ ~b35 & b37;
        s[42] = b42 ^ ~b44 & b46;
        s[43] = b43 ^ ~b45 & b47;
        s[4] = b4 ^ ~b6 & b8;
        s[5] = b5 ^ ~b7 & b9;
        s[14] = b14 ^ ~b16 & b18;
        s[15] = b15 ^ ~b17 & b19;
        s[24] = b24 ^ ~b26 & b28;
        s[25] = b25 ^ ~b27 & b29;
        s[34] = b34 ^ ~b36 & b38;
        s[35] = b35 ^ ~b37 & b39;
        s[44] = b44 ^ ~b46 & b48;
        s[45] = b45 ^ ~b47 & b49;
        s[6] = b6 ^ ~b8 & b0;
        s[7] = b7 ^ ~b9 & b1;
        s[16] = b16 ^ ~b18 & b10;
        s[17] = b17 ^ ~b19 & b11;
        s[26] = b26 ^ ~b28 & b20;
        s[27] = b27 ^ ~b29 & b21;
        s[36] = b36 ^ ~b38 & b30;
        s[37] = b37 ^ ~b39 & b31;
        s[46] = b46 ^ ~b48 & b40;
        s[47] = b47 ^ ~b49 & b41;
        s[8] = b8 ^ ~b0 & b2;
        s[9] = b9 ^ ~b1 & b3;
        s[18] = b18 ^ ~b10 & b12;
        s[19] = b19 ^ ~b11 & b13;
        s[28] = b28 ^ ~b20 & b22;
        s[29] = b29 ^ ~b21 & b23;
        s[38] = b38 ^ ~b30 & b32;
        s[39] = b39 ^ ~b31 & b33;
        s[48] = b48 ^ ~b40 & b42;
        s[49] = b49 ^ ~b41 & b43;
        s[0] ^= $8ff9be21f81a68a4$var$RC[n];
        s[1] ^= $8ff9be21f81a68a4$var$RC[n + 1];
    }
};
const $8ff9be21f81a68a4$var$keccak = (bits)=>(str)=>{
        var msg;
        if (str.slice(0, 2) === "0x") {
            msg = [];
            for(var i = 2, l = str.length; i < l; i += 2)msg.push(parseInt(str.slice(i, i + 2), 16));
        } else msg = str;
        return $8ff9be21f81a68a4$var$update($8ff9be21f81a68a4$var$Keccak(bits, bits), msg);
    };
module.exports = {
    keccak256: $8ff9be21f81a68a4$var$keccak(256),
    keccak512: $8ff9be21f81a68a4$var$keccak(512),
    keccak256s: $8ff9be21f81a68a4$var$keccak(256),
    keccak512s: $8ff9be21f81a68a4$var$keccak(512)
};

});


parcelRegister("innAd", function(module, exports) {
"use strict";
(function(root) {
    const MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);
        function blocks(p) {
            let off = 0, len = p.length;
            while(len >= 64){
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        let i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);
        let i;
        let dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(let i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(let i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(let i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(let i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== 'number') return false;
        for(let i = 0; i < o.length; i++){
            const v = o[i];
            if (typeof v !== 'number' || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error('invalid ' + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, 'N');
        r = ensureInteger(r, 'r');
        p = ensureInteger(p, 'p');
        dkLen = ensureInteger(dkLen, 'dkLen');
        if (N === 0 || (N & N - 1) !== 0) throw new Error('N must be power of 2');
        if (N > MAX_VALUE / 128 / r) throw new Error('N too large');
        if (r > MAX_VALUE / 128 / p) throw new Error('r too large');
        if (!checkBufferish(password)) throw new Error('password must be an array or buffer');
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error('salt must be an array or buffer');
        salt = Array.prototype.slice.call(salt);
        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r);
        for(let i = 0; i < B.length; i++){
            const j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);
        const Yi = 32 * r;
        // scratch space
        const x = new Uint32Array(16); // salsa20_8
        const _X = new Uint32Array(16); // blockmix_salsa8
        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        let stop = false;
        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;
        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) return callback(new Error('cancelled'), currentOp / totalOps);
            let steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        const offset = (2 * r - 1) * 16; // ROMix - 7
                        const j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(let i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            const derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof module.exports !== 'undefined') module.exports = lib;
    else if (typeof define === 'function' && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})(module.exports);

});

parcelRegister("8u0so", function(module, exports) {

var $3e7nW = parcelRequire("3e7nW");

var $3rVK8 = parcelRequire("3rVK8");
var $62d17ad2cd34250f$var$uuid = $3rVK8;
$62d17ad2cd34250f$var$uuid.v1 = $3e7nW;
$62d17ad2cd34250f$var$uuid.v4 = $3rVK8;
module.exports = $62d17ad2cd34250f$var$uuid;

});
parcelRegister("3e7nW", function(module, exports) {

var $cnGcu = parcelRequire("cnGcu");

var $lkQKO = parcelRequire("lkQKO");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $25986876d2e0df7a$var$_nodeId;
var $25986876d2e0df7a$var$_clockseq;
// Previous uuid creation time
var $25986876d2e0df7a$var$_lastMSecs = 0;
var $25986876d2e0df7a$var$_lastNSecs = 0;
// See https://github.com/broofa/node-uuid for API details
function $25986876d2e0df7a$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $25986876d2e0df7a$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $25986876d2e0df7a$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $cnGcu();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $25986876d2e0df7a$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $25986876d2e0df7a$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $25986876d2e0df7a$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $25986876d2e0df7a$var$_lastMSecs + (nsecs - $25986876d2e0df7a$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $25986876d2e0df7a$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $25986876d2e0df7a$var$_lastMSecs = msecs;
    $25986876d2e0df7a$var$_lastNSecs = nsecs;
    $25986876d2e0df7a$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $lkQKO(b);
}
module.exports = $25986876d2e0df7a$var$v1;

});
parcelRegister("cnGcu", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $02537d63b0cea7b7$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($02537d63b0cea7b7$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $02537d63b0cea7b7$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $02537d63b0cea7b7$var$getRandomValues($02537d63b0cea7b7$var$rnds8);
        return $02537d63b0cea7b7$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $02537d63b0cea7b7$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $02537d63b0cea7b7$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $02537d63b0cea7b7$var$rnds;
    };
}

});

parcelRegister("lkQKO", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $f884631216adbc31$var$byteToHex = [];
for(var $f884631216adbc31$var$i = 0; $f884631216adbc31$var$i < 256; ++$f884631216adbc31$var$i)$f884631216adbc31$var$byteToHex[$f884631216adbc31$var$i] = ($f884631216adbc31$var$i + 0x100).toString(16).substr(1);
function $f884631216adbc31$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $f884631216adbc31$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $f884631216adbc31$var$bytesToUuid;

});


parcelRegister("3rVK8", function(module, exports) {

var $cnGcu = parcelRequire("cnGcu");

var $lkQKO = parcelRequire("lkQKO");
function $2830af4e02d475a5$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $cnGcu)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $lkQKO(rnds);
}
module.exports = $2830af4e02d475a5$var$v4;

});


parcelRegister("1s2di", function(module, exports) {
"use strict";
var $10ea1f86be857130$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $10ea1f86be857130$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $10ea1f86be857130$var$__createBinding(exports1, m, p);
};
var $10ea1f86be857130$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeeMarketEIP1559Transaction = module.exports.TransactionFactory = module.exports.AccessListEIP2930Transaction = module.exports.Transaction = void 0;

var $lgnu8 = parcelRequire("lgnu8");
Object.defineProperty(module.exports, "Transaction", {
    enumerable: true,
    get: function() {
        return $10ea1f86be857130$var$__importDefault($lgnu8).default;
    }
});

var $fwf55 = parcelRequire("fwf55");
Object.defineProperty(module.exports, "AccessListEIP2930Transaction", {
    enumerable: true,
    get: function() {
        return $10ea1f86be857130$var$__importDefault($fwf55).default;
    }
});

var $5sL9U = parcelRequire("5sL9U");
Object.defineProperty(module.exports, "TransactionFactory", {
    enumerable: true,
    get: function() {
        return $10ea1f86be857130$var$__importDefault($5sL9U).default;
    }
});

var $gwlKN = parcelRequire("gwlKN");
Object.defineProperty(module.exports, "FeeMarketEIP1559Transaction", {
    enumerable: true,
    get: function() {
        return $10ea1f86be857130$var$__importDefault($gwlKN).default;
    }
});

$10ea1f86be857130$var$__exportStar((parcelRequire("joOVu")), module.exports);

});
parcelRegister("lgnu8", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f7ad4f3af7041e3f$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $f7ad4f3af7041e3f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f7ad4f3af7041e3f$var$__assign = module.exports && module.exports.__assign || function() {
    $f7ad4f3af7041e3f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f7ad4f3af7041e3f$var$__assign.apply(this, arguments);
};
var $f7ad4f3af7041e3f$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7Z98w = parcelRequire("7Z98w");

var $joOVu = parcelRequire("joOVu");

var $kuLXK = parcelRequire("kuLXK");
var $f7ad4f3af7041e3f$var$TRANSACTION_TYPE = 0;
/**
 * An Ethereum non-typed (legacy) transaction
 */ var $f7ad4f3af7041e3f$var$Transaction = /** @class */ function(_super) {
    $f7ad4f3af7041e3f$var$__extends(Transaction, _super);
    /**
     * This constructor takes the values, validates them, assigns them and freezes the object.
     *
     * It is not recommended to use this constructor directly. Instead use
     * the static factory methods to assist in creating a Transaction object from
     * varying data types.
     */ function Transaction(txData, opts) {
        if (opts === void 0) opts = {};
        var _a;
        var _this = _super.call(this, $f7ad4f3af7041e3f$var$__assign($f7ad4f3af7041e3f$var$__assign({}, txData), {
            type: $f7ad4f3af7041e3f$var$TRANSACTION_TYPE
        })) || this;
        _this.common = _this._validateTxV(_this.v, opts.common);
        _this.gasPrice = new $7Z98w.BN((0, $7Z98w.toBuffer)(txData.gasPrice === '' ? '0x' : txData.gasPrice));
        _this._validateCannotExceedMaxInteger({
            gasPrice: _this.gasPrice
        });
        if (_this.common.gteHardfork('spuriousDragon')) {
            if (!_this.isSigned()) _this.activeCapabilities.push($joOVu.Capability.EIP155ReplayProtection);
            else {
                // EIP155 spec:
                // If block.number >= 2,675,000 and v = CHAIN_ID * 2 + 35 or v = CHAIN_ID * 2 + 36
                // then when computing the hash of a transaction for purposes of signing or recovering
                // instead of hashing only the first six elements (i.e. nonce, gasprice, startgas, to, value, data)
                // hash nine elements, with v replaced by CHAIN_ID, r = 0 and s = 0.
                var v = _this.v;
                var chainIdDoubled = _this.common.chainIdBN().muln(2);
                // v and chain ID meet EIP-155 conditions
                if (v.eq(chainIdDoubled.addn(35)) || v.eq(chainIdDoubled.addn(36))) _this.activeCapabilities.push($joOVu.Capability.EIP155ReplayProtection);
            }
        }
        var freeze = (_a = opts === null || opts === void 0 ? void 0 : opts.freeze) !== null && _a !== void 0 ? _a : true;
        if (freeze) Object.freeze(_this);
        return _this;
    }
    /**
     * Instantiate a transaction from a data dictionary.
     *
     * Format: { nonce, gasPrice, gasLimit, to, value, data, v, r, s }
     *
     * Notes:
     * - All parameters are optional and have some basic default values
     */ Transaction.fromTxData = function(txData, opts) {
        if (opts === void 0) opts = {};
        return new Transaction(txData, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     *
     * Format: `rlp([nonce, gasPrice, gasLimit, to, value, data, v, r, s])`
     */ Transaction.fromSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        var values = $7Z98w.rlp.decode(serialized);
        if (!Array.isArray(values)) throw new Error('Invalid serialized tx input. Must be array');
        return this.fromValuesArray(values, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     * (alias of {@link Transaction.fromSerializedTx})
     *
     * @deprecated this constructor alias is deprecated and will be removed
     * in favor of the {@link Transaction.fromSerializedTx} constructor
     */ Transaction.fromRlpSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        return Transaction.fromSerializedTx(serialized, opts);
    };
    /**
     * Create a transaction from a values array.
     *
     * Format: `[nonce, gasPrice, gasLimit, to, value, data, v, r, s]`
     */ Transaction.fromValuesArray = function(values, opts) {
        if (opts === void 0) opts = {};
        // If length is not 6, it has length 9. If v/r/s are empty Buffers, it is still an unsigned transaction
        // This happens if you get the RLP data from `raw()`
        if (values.length !== 6 && values.length !== 9) throw new Error('Invalid transaction. Only expecting 6 values (for unsigned tx) or 9 values (for signed tx).');
        var _a = $f7ad4f3af7041e3f$var$__read(values, 9), nonce = _a[0], gasPrice = _a[1], gasLimit = _a[2], to = _a[3], value = _a[4], data = _a[5], v = _a[6], r = _a[7], s = _a[8];
        return new Transaction({
            nonce: nonce,
            gasPrice: gasPrice,
            gasLimit: gasLimit,
            to: to,
            value: value,
            data: data,
            v: v,
            r: r,
            s: s
        }, opts);
    };
    /**
     * Returns a Buffer Array of the raw Buffers of the legacy transaction, in order.
     *
     * Format: `[nonce, gasPrice, gasLimit, to, value, data, v, r, s]`
     *
     * For legacy txs this is also the correct format to add transactions
     * to a block with {@link Block.fromValuesArray} (use the `serialize()` method
     * for typed txs).
     *
     * For an unsigned tx this method returns the empty Buffer values
     * for the signature parameters `v`, `r` and `s`. For an EIP-155 compliant
     * representation have a look at {@link Transaction.getMessageToSign}.
     */ Transaction.prototype.raw = function() {
        return [
            (0, $7Z98w.bnToUnpaddedBuffer)(this.nonce),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.gasPrice),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.gasLimit),
            this.to !== undefined ? this.to.buf : $f7ad4f3af7041e3f$require$Buffer.from([]),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.value),
            this.data,
            this.v !== undefined ? (0, $7Z98w.bnToUnpaddedBuffer)(this.v) : $f7ad4f3af7041e3f$require$Buffer.from([]),
            this.r !== undefined ? (0, $7Z98w.bnToUnpaddedBuffer)(this.r) : $f7ad4f3af7041e3f$require$Buffer.from([]),
            this.s !== undefined ? (0, $7Z98w.bnToUnpaddedBuffer)(this.s) : $f7ad4f3af7041e3f$require$Buffer.from([])
        ];
    };
    /**
     * Returns the serialized encoding of the legacy transaction.
     *
     * Format: `rlp([nonce, gasPrice, gasLimit, to, value, data, v, r, s])`
     *
     * For an unsigned tx this method uses the empty Buffer values for the
     * signature parameters `v`, `r` and `s` for encoding. For an EIP-155 compliant
     * representation for external signing use {@link Transaction.getMessageToSign}.
     */ Transaction.prototype.serialize = function() {
        return $7Z98w.rlp.encode(this.raw());
    };
    Transaction.prototype._getMessageToSign = function() {
        var values = [
            (0, $7Z98w.bnToUnpaddedBuffer)(this.nonce),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.gasPrice),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.gasLimit),
            this.to !== undefined ? this.to.buf : $f7ad4f3af7041e3f$require$Buffer.from([]),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.value),
            this.data
        ];
        if (this.supports($joOVu.Capability.EIP155ReplayProtection)) {
            values.push((0, $7Z98w.toBuffer)(this.common.chainIdBN()));
            values.push((0, $7Z98w.unpadBuffer)((0, $7Z98w.toBuffer)(0)));
            values.push((0, $7Z98w.unpadBuffer)((0, $7Z98w.toBuffer)(0)));
        }
        return values;
    };
    Transaction.prototype.getMessageToSign = function(hashMessage) {
        if (hashMessage === void 0) hashMessage = true;
        var message = this._getMessageToSign();
        if (hashMessage) return (0, $7Z98w.rlphash)(message);
        else return message;
    };
    /**
     * The amount of gas paid for the data in this tx
     */ Transaction.prototype.getDataFee = function() {
        if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) return this.cache.dataFee.value;
        if (Object.isFrozen(this)) this.cache.dataFee = {
            value: _super.prototype.getDataFee.call(this),
            hardfork: this.common.hardfork()
        };
        return _super.prototype.getDataFee.call(this);
    };
    /**
     * The up front amount that an account must have for this transaction to be valid
     */ Transaction.prototype.getUpfrontCost = function() {
        return this.gasLimit.mul(this.gasPrice).add(this.value);
    };
    /**
     * Computes a sha3-256 hash of the serialized tx.
     *
     * This method can only be used for signed txs (it throws otherwise).
     * Use {@link Transaction.getMessageToSign} to get a tx hash for the purpose of signing.
     */ Transaction.prototype.hash = function() {
        // In contrast to the tx type transaction implementations the `hash()` function
        // for the legacy tx does not throw if the tx is not signed.
        // This has been considered for inclusion but lead to unexpected backwards
        // compatibility problems (no concrete reference found, needs validation).
        //
        // For context see also https://github.com/ethereumjs/ethereumjs-monorepo/pull/1445,
        // September, 2021 as well as work done before.
        //
        // This should be updated along the next major version release by adding:
        //
        //if (!this.isSigned()) {
        //  const msg = this._errorMsg('Cannot call hash method if transaction is not signed')
        //  throw new Error(msg)
        //}
        if (Object.isFrozen(this)) {
            if (!this.cache.hash) this.cache.hash = (0, $7Z98w.rlphash)(this.raw());
            return this.cache.hash;
        }
        return (0, $7Z98w.rlphash)(this.raw());
    };
    /**
     * Computes a sha3-256 hash which can be used to verify the signature
     */ Transaction.prototype.getMessageToVerifySignature = function() {
        if (!this.isSigned()) {
            var msg = this._errorMsg('This transaction is not signed');
            throw new Error(msg);
        }
        var message = this._getMessageToSign();
        return (0, $7Z98w.rlphash)(message);
    };
    /**
     * Returns the public key of the sender
     */ Transaction.prototype.getSenderPublicKey = function() {
        var _a;
        var msgHash = this.getMessageToVerifySignature();
        // EIP-2: All transaction signatures whose s-value is greater than secp256k1n/2 are considered invalid.
        // Reasoning: https://ethereum.stackexchange.com/a/55728
        if (this.common.gteHardfork('homestead') && ((_a = this.s) === null || _a === void 0 ? void 0 : _a.gt($joOVu.N_DIV_2))) {
            var msg = this._errorMsg('Invalid Signature: s-values greater than secp256k1n/2 are considered invalid');
            throw new Error(msg);
        }
        var _b = this, v = _b.v, r = _b.r, s = _b.s;
        try {
            return (0, $7Z98w.ecrecover)(msgHash, v, (0, $7Z98w.bnToUnpaddedBuffer)(r), (0, $7Z98w.bnToUnpaddedBuffer)(s), this.supports($joOVu.Capability.EIP155ReplayProtection) ? this.common.chainIdBN() : undefined);
        } catch (e) {
            var msg = this._errorMsg('Invalid Signature');
            throw new Error(msg);
        }
    };
    /**
     * Process the v, r, s values from the `sign` method of the base transaction.
     */ Transaction.prototype._processSignature = function(v, r, s) {
        var vBN = new $7Z98w.BN(v);
        if (this.supports($joOVu.Capability.EIP155ReplayProtection)) vBN.iadd(this.common.chainIdBN().muln(2).addn(8));
        var opts = {
            common: this.common
        };
        return Transaction.fromTxData({
            nonce: this.nonce,
            gasPrice: this.gasPrice,
            gasLimit: this.gasLimit,
            to: this.to,
            value: this.value,
            data: this.data,
            v: vBN,
            r: new $7Z98w.BN(r),
            s: new $7Z98w.BN(s)
        }, opts);
    };
    /**
     * Returns an object with the JSON representation of the transaction.
     */ Transaction.prototype.toJSON = function() {
        return {
            nonce: (0, $7Z98w.bnToHex)(this.nonce),
            gasPrice: (0, $7Z98w.bnToHex)(this.gasPrice),
            gasLimit: (0, $7Z98w.bnToHex)(this.gasLimit),
            to: this.to !== undefined ? this.to.toString() : undefined,
            value: (0, $7Z98w.bnToHex)(this.value),
            data: '0x' + this.data.toString('hex'),
            v: this.v !== undefined ? (0, $7Z98w.bnToHex)(this.v) : undefined,
            r: this.r !== undefined ? (0, $7Z98w.bnToHex)(this.r) : undefined,
            s: this.s !== undefined ? (0, $7Z98w.bnToHex)(this.s) : undefined
        };
    };
    /**
     * Validates tx's `v` value
     */ Transaction.prototype._validateTxV = function(v, common) {
        var chainIdBN;
        // No unsigned tx and EIP-155 activated and chain ID included
        if (v !== undefined && !v.eqn(0) && (!common || common.gteHardfork('spuriousDragon')) && !v.eqn(27) && !v.eqn(28)) {
            if (common) {
                var chainIdDoubled = common.chainIdBN().muln(2);
                var isValidEIP155V = v.eq(chainIdDoubled.addn(35)) || v.eq(chainIdDoubled.addn(36));
                if (!isValidEIP155V) throw new Error("Incompatible EIP155-based V " + v + " and chain id " + common.chainIdBN() + ". See the Common parameter of the Transaction constructor to set the chain id.");
            } else {
                // Derive the original chain ID
                var numSub = void 0;
                if (v.subn(35).isEven()) numSub = 35;
                else numSub = 36;
                // Use derived chain ID to create a proper Common
                chainIdBN = v.subn(numSub).divn(2);
            }
        }
        return this._getCommon(common, chainIdBN);
    };
    /**
     * @deprecated if you have called this internal method please use `tx.supports(Capabilities.EIP155ReplayProtection)` instead
     */ Transaction.prototype._unsignedTxImplementsEIP155 = function() {
        return this.common.gteHardfork('spuriousDragon');
    };
    /**
     * @deprecated if you have called this internal method please use `tx.supports(Capabilities.EIP155ReplayProtection)` instead
     */ Transaction.prototype._signedTxImplementsEIP155 = function() {
        if (!this.isSigned()) {
            var msg = this._errorMsg('This transaction is not signed');
            throw new Error(msg);
        }
        var onEIP155BlockOrLater = this.common.gteHardfork('spuriousDragon');
        // EIP155 spec:
        // If block.number >= 2,675,000 and v = CHAIN_ID * 2 + 35 or v = CHAIN_ID * 2 + 36, then when computing the hash of a transaction for purposes of signing or recovering, instead of hashing only the first six elements (i.e. nonce, gasprice, startgas, to, value, data), hash nine elements, with v replaced by CHAIN_ID, r = 0 and s = 0.
        var v = this.v;
        var chainIdDoubled = this.common.chainIdBN().muln(2);
        var vAndChainIdMeetEIP155Conditions = v.eq(chainIdDoubled.addn(35)) || v.eq(chainIdDoubled.addn(36));
        return vAndChainIdMeetEIP155Conditions && onEIP155BlockOrLater;
    };
    /**
     * Return a compact error string representation of the object
     */ Transaction.prototype.errorStr = function() {
        var errorStr = this._getSharedErrorPostfix();
        errorStr += " gasPrice=" + this.gasPrice;
        return errorStr;
    };
    /**
     * Internal helper function to create an annotated error message
     *
     * @param msg Base error message
     * @hidden
     */ Transaction.prototype._errorMsg = function(msg) {
        return msg + " (" + this.errorStr() + ")";
    };
    return Transaction;
}($kuLXK.BaseTransaction);
module.exports.default = $f7ad4f3af7041e3f$var$Transaction;

});
parcelRegister("joOVu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.N_DIV_2 = module.exports.isAccessList = module.exports.isAccessListBuffer = module.exports.Capability = void 0;

var $7Z98w = parcelRequire("7Z98w");
/**
 * Can be used in conjunction with {@link Transaction.supports}
 * to query on tx capabilities
 */ var $e1f7c31612c515b2$var$Capability;
(function(Capability) {
    /**
     * Tx supports EIP-155 replay protection
     * See: [155](https://eips.ethereum.org/EIPS/eip-155) Replay Attack Protection EIP
     */ Capability[Capability["EIP155ReplayProtection"] = 155] = "EIP155ReplayProtection";
    /**
     * Tx supports EIP-1559 gas fee market mechansim
     * See: [1559](https://eips.ethereum.org/EIPS/eip-1559) Fee Market EIP
     */ Capability[Capability["EIP1559FeeMarket"] = 1559] = "EIP1559FeeMarket";
    /**
     * Tx is a typed transaction as defined in EIP-2718
     * See: [2718](https://eips.ethereum.org/EIPS/eip-2718) Transaction Type EIP
     */ Capability[Capability["EIP2718TypedTransaction"] = 2718] = "EIP2718TypedTransaction";
    /**
     * Tx supports access list generation as defined in EIP-2930
     * See: [2930](https://eips.ethereum.org/EIPS/eip-2930) Access Lists EIP
     */ Capability[Capability["EIP2930AccessLists"] = 2930] = "EIP2930AccessLists";
})($e1f7c31612c515b2$var$Capability = module.exports.Capability || (module.exports.Capability = {}));
function $e1f7c31612c515b2$var$isAccessListBuffer(input) {
    if (input.length === 0) return true;
    var firstItem = input[0];
    if (Array.isArray(firstItem)) return true;
    return false;
}
module.exports.isAccessListBuffer = $e1f7c31612c515b2$var$isAccessListBuffer;
function $e1f7c31612c515b2$var$isAccessList(input) {
    return !$e1f7c31612c515b2$var$isAccessListBuffer(input); // This is exactly the same method, except the output is negated.
}
module.exports.isAccessList = $e1f7c31612c515b2$var$isAccessList;
/**
 * A const defining secp256k1n/2
 */ module.exports.N_DIV_2 = new $7Z98w.BN('7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0', 16);

});

parcelRegister("kuLXK", function(module, exports) {
"use strict";
var $eebbd05d128efecd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eebbd05d128efecd$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $eebbd05d128efecd$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $eebbd05d128efecd$var$__createBinding(result, mod, k);
    }
    $eebbd05d128efecd$var$__setModuleDefault(result, mod);
    return result;
};
var $eebbd05d128efecd$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $eebbd05d128efecd$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseTransaction = void 0;

var $eebbd05d128efecd$var$common_1 = $eebbd05d128efecd$var$__importStar((parcelRequire("5XUmm")));

var $7Z98w = parcelRequire("7Z98w");

var $joOVu = parcelRequire("joOVu");
/**
 * This base class will likely be subject to further
 * refactoring along the introduction of additional tx types
 * on the Ethereum network.
 *
 * It is therefore not recommended to use directly.
 */ var $eebbd05d128efecd$var$BaseTransaction = /** @class */ function() {
    function BaseTransaction(txData) {
        this.cache = {
            hash: undefined,
            dataFee: undefined
        };
        /**
         * List of tx type defining EIPs,
         * e.g. 1559 (fee market) and 2930 (access lists)
         * for FeeMarketEIP1559Transaction objects
         */ this.activeCapabilities = [];
        /**
         * The default chain the tx falls back to if no Common
         * is provided and if the chain can't be derived from
         * a passed in chainId (only EIP-2718 typed txs) or
         * EIP-155 signature (legacy txs).
         *
         * @hidden
         */ this.DEFAULT_CHAIN = $eebbd05d128efecd$var$common_1.Chain.Mainnet;
        /**
         * The default HF if the tx type is active on that HF
         * or the first greater HF where the tx is active.
         *
         * @hidden
         */ this.DEFAULT_HARDFORK = $eebbd05d128efecd$var$common_1.Hardfork.Istanbul;
        var nonce = txData.nonce, gasLimit = txData.gasLimit, to = txData.to, value = txData.value, data = txData.data, v = txData.v, r = txData.r, s = txData.s, type = txData.type;
        this._type = new $7Z98w.BN((0, $7Z98w.toBuffer)(type)).toNumber();
        var toB = (0, $7Z98w.toBuffer)(to === '' ? '0x' : to);
        var vB = (0, $7Z98w.toBuffer)(v === '' ? '0x' : v);
        var rB = (0, $7Z98w.toBuffer)(r === '' ? '0x' : r);
        var sB = (0, $7Z98w.toBuffer)(s === '' ? '0x' : s);
        this.nonce = new $7Z98w.BN((0, $7Z98w.toBuffer)(nonce === '' ? '0x' : nonce));
        this.gasLimit = new $7Z98w.BN((0, $7Z98w.toBuffer)(gasLimit === '' ? '0x' : gasLimit));
        this.to = toB.length > 0 ? new $7Z98w.Address(toB) : undefined;
        this.value = new $7Z98w.BN((0, $7Z98w.toBuffer)(value === '' ? '0x' : value));
        this.data = (0, $7Z98w.toBuffer)(data === '' ? '0x' : data);
        this.v = vB.length > 0 ? new $7Z98w.BN(vB) : undefined;
        this.r = rB.length > 0 ? new $7Z98w.BN(rB) : undefined;
        this.s = sB.length > 0 ? new $7Z98w.BN(sB) : undefined;
        this._validateCannotExceedMaxInteger({
            nonce: this.nonce,
            gasLimit: this.gasLimit,
            value: this.value,
            r: this.r,
            s: this.s
        });
    }
    Object.defineProperty(BaseTransaction.prototype, "transactionType", {
        /**
         * Alias for {@link BaseTransaction.type}
         *
         * @deprecated Use `type` instead
         */ get: function() {
            return this.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTransaction.prototype, "type", {
        /**
         * Returns the transaction type.
         *
         * Note: legacy txs will return tx type `0`.
         */ get: function() {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Checks if a tx type defining capability is active
     * on a tx, for example the EIP-1559 fee market mechanism
     * or the EIP-2930 access list feature.
     *
     * Note that this is different from the tx type itself,
     * so EIP-2930 access lists can very well be active
     * on an EIP-1559 tx for example.
     *
     * This method can be useful for feature checks if the
     * tx type is unknown (e.g. when instantiated with
     * the tx factory).
     *
     * See `Capabilites` in the `types` module for a reference
     * on all supported capabilities.
     */ BaseTransaction.prototype.supports = function(capability) {
        return this.activeCapabilities.includes(capability);
    };
    BaseTransaction.prototype.validate = function(stringError) {
        if (stringError === void 0) stringError = false;
        var errors = [];
        if (this.getBaseFee().gt(this.gasLimit)) errors.push("gasLimit is too low. given " + this.gasLimit + ", need at least " + this.getBaseFee());
        if (this.isSigned() && !this.verifySignature()) errors.push('Invalid Signature');
        return stringError ? errors : errors.length === 0;
    };
    /**
     * The minimum amount of gas the tx must have (DataFee + TxFee + Creation Fee)
     */ BaseTransaction.prototype.getBaseFee = function() {
        var fee = this.getDataFee().addn(this.common.param('gasPrices', 'tx'));
        if (this.common.gteHardfork('homestead') && this.toCreationAddress()) fee.iaddn(this.common.param('gasPrices', 'txCreation'));
        return fee;
    };
    /**
     * The amount of gas paid for the data in this tx
     */ BaseTransaction.prototype.getDataFee = function() {
        var txDataZero = this.common.param('gasPrices', 'txDataZero');
        var txDataNonZero = this.common.param('gasPrices', 'txDataNonZero');
        var cost = 0;
        for(var i = 0; i < this.data.length; i++)this.data[i] === 0 ? cost += txDataZero : cost += txDataNonZero;
        return new $7Z98w.BN(cost);
    };
    /**
     * If the tx's `to` is to the creation address
     */ BaseTransaction.prototype.toCreationAddress = function() {
        return this.to === undefined || this.to.buf.length === 0;
    };
    BaseTransaction.prototype.isSigned = function() {
        var _a = this, v = _a.v, r = _a.r, s = _a.s;
        if (this.type === 0) {
            if (!v || !r || !s) return false;
            else return true;
        } else {
            if (v === undefined || !r || !s) return false;
            else return true;
        }
    };
    /**
     * Determines if the signature is valid
     */ BaseTransaction.prototype.verifySignature = function() {
        try {
            // Main signature verification is done in `getSenderPublicKey()`
            var publicKey = this.getSenderPublicKey();
            return (0, $7Z98w.unpadBuffer)(publicKey).length !== 0;
        } catch (e) {
            return false;
        }
    };
    /**
     * Returns the sender's address
     */ BaseTransaction.prototype.getSenderAddress = function() {
        return new $7Z98w.Address((0, $7Z98w.publicToAddress)(this.getSenderPublicKey()));
    };
    /**
     * Signs a transaction.
     *
     * Note that the signed tx is returned as a new object,
     * use as follows:
     * ```javascript
     * const signedTx = tx.sign(privateKey)
     * ```
     */ BaseTransaction.prototype.sign = function(privateKey) {
        if (privateKey.length !== 32) {
            var msg = this._errorMsg('Private key must be 32 bytes in length.');
            throw new Error(msg);
        }
        // Hack for the constellation that we have got a legacy tx after spuriousDragon with a non-EIP155 conforming signature
        // and want to recreate a signature (where EIP155 should be applied)
        // Leaving this hack lets the legacy.spec.ts -> sign(), verifySignature() test fail
        // 2021-06-23
        var hackApplied = false;
        if (this.type === 0 && this.common.gteHardfork('spuriousDragon') && !this.supports($joOVu.Capability.EIP155ReplayProtection)) {
            this.activeCapabilities.push($joOVu.Capability.EIP155ReplayProtection);
            hackApplied = true;
        }
        var msgHash = this.getMessageToSign(true);
        var _a = (0, $7Z98w.ecsign)(msgHash, privateKey), v = _a.v, r = _a.r, s = _a.s;
        var tx = this._processSignature(v, r, s);
        // Hack part 2
        if (hackApplied) {
            var index = this.activeCapabilities.indexOf($joOVu.Capability.EIP155ReplayProtection);
            if (index > -1) this.activeCapabilities.splice(index, 1);
        }
        return tx;
    };
    /**
     * Does chain ID checks on common and returns a common
     * to be used on instantiation
     * @hidden
     *
     * @param common - {@link Common} instance from tx options
     * @param chainId - Chain ID from tx options (typed txs) or signature (legacy tx)
     */ BaseTransaction.prototype._getCommon = function(common, chainId) {
        var _a;
        // Chain ID provided
        if (chainId) {
            var chainIdBN = new $7Z98w.BN((0, $7Z98w.toBuffer)(chainId));
            if (common) {
                if (!common.chainIdBN().eq(chainIdBN)) {
                    var msg = this._errorMsg('The chain ID does not match the chain ID of Common');
                    throw new Error(msg);
                }
                // Common provided, chain ID does match
                // -> Return provided Common
                return common.copy();
            } else {
                if ($eebbd05d128efecd$var$common_1.default.isSupportedChainId(chainIdBN)) // No Common, chain ID supported by Common
                // -> Instantiate Common with chain ID
                return new $eebbd05d128efecd$var$common_1.default({
                    chain: chainIdBN,
                    hardfork: this.DEFAULT_HARDFORK
                });
                else // No Common, chain ID not supported by Common
                // -> Instantiate custom Common derived from DEFAULT_CHAIN
                return $eebbd05d128efecd$var$common_1.default.forCustomChain(this.DEFAULT_CHAIN, {
                    name: 'custom-chain',
                    networkId: chainIdBN,
                    chainId: chainIdBN
                }, this.DEFAULT_HARDFORK);
            }
        } else // No chain ID provided
        // -> return Common provided or create new default Common
        return (_a = common === null || common === void 0 ? void 0 : common.copy()) !== null && _a !== void 0 ? _a : new $eebbd05d128efecd$var$common_1.default({
            chain: this.DEFAULT_CHAIN,
            hardfork: this.DEFAULT_HARDFORK
        });
    };
    BaseTransaction.prototype._validateCannotExceedMaxInteger = function(values, bits) {
        var e_1, _a;
        if (bits === void 0) bits = 53;
        try {
            for(var _b = $eebbd05d128efecd$var$__values(Object.entries(values)), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $eebbd05d128efecd$var$__read(_c.value, 2), key = _d[0], value = _d[1];
                if (bits === 53) {
                    if (value === null || value === void 0 ? void 0 : value.gt($7Z98w.MAX_INTEGER)) {
                        var msg = this._errorMsg(key + " cannot exceed MAX_INTEGER, given " + value);
                        throw new Error(msg);
                    }
                } else if (bits === 256) {
                    if (value === null || value === void 0 ? void 0 : value.gte($7Z98w.TWO_POW256)) {
                        var msg = this._errorMsg(key + " must be less than 2^256, given " + value);
                        throw new Error(msg);
                    }
                } else {
                    var msg = this._errorMsg('unimplemented bits value');
                    throw new Error(msg);
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Returns the shared error postfix part for _error() method
     * tx type implementations.
     */ BaseTransaction.prototype._getSharedErrorPostfix = function() {
        var hash = '';
        try {
            hash = this.isSigned() ? (0, $7Z98w.bufferToHex)(this.hash()) : 'not available (unsigned)';
        } catch (e) {
            hash = 'error';
        }
        var isSigned = '';
        try {
            isSigned = this.isSigned().toString();
        } catch (e) {
            hash = 'error';
        }
        var hf = '';
        try {
            hf = this.common.hardfork();
        } catch (e) {
            hf = 'error';
        }
        var postfix = "tx type=" + this.type + " hash=" + hash + " nonce=" + this.nonce + " value=" + this.value + " ";
        postfix += "signed=" + isSigned + " hf=" + hf;
        return postfix;
    };
    return BaseTransaction;
}();
module.exports.BaseTransaction = $eebbd05d128efecd$var$BaseTransaction;

});
parcelRegister("5XUmm", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $457e2e4aaefd48de$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $457e2e4aaefd48de$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $457e2e4aaefd48de$var$__assign = module.exports && module.exports.__assign || function() {
    $457e2e4aaefd48de$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $457e2e4aaefd48de$var$__assign.apply(this, arguments);
};
var $457e2e4aaefd48de$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsensusAlgorithm = module.exports.ConsensusType = module.exports.Hardfork = module.exports.Chain = module.exports.CustomChain = void 0;

var $7etJZ = parcelRequire("7etJZ");

var $5ylEQ = parcelRequire("5ylEQ");

var $7Z98w = parcelRequire("7Z98w");

var $iFArz = parcelRequire("iFArz");

var $hvgll = parcelRequire("hvgll");

var $jkA0Q = parcelRequire("jkA0Q");
var $457e2e4aaefd48de$var$CustomChain;
(function(CustomChain) {
    /**
     * Polygon (Matic) Mainnet
     *
     * - [Documentation](https://docs.matic.network/docs/develop/network-details/network)
     */ CustomChain["PolygonMainnet"] = "polygon-mainnet";
    /**
     * Polygon (Matic) Mumbai Testnet
     *
     * - [Documentation](https://docs.matic.network/docs/develop/network-details/network)
     */ CustomChain["PolygonMumbai"] = "polygon-mumbai";
    /**
     * Arbitrum Rinkeby Testnet
     *
     * - [Documentation](https://developer.offchainlabs.com/docs/public_testnet)
     */ CustomChain["ArbitrumRinkebyTestnet"] = "arbitrum-rinkeby-testnet";
    /**
     * xDai EVM sidechain with a native stable token
     *
     * - [Documentation](https://www.xdaichain.com/)
     */ CustomChain["xDaiChain"] = "x-dai-chain";
    /**
     * Optimistic Kovan - testnet for Optimism roll-up
     *
     * - [Documentation](https://community.optimism.io/docs/developers/tutorials.html)
     */ CustomChain["OptimisticKovan"] = "optimistic-kovan";
    /**
     * Optimistic Ethereum - mainnet for Optimism roll-up
     *
     * - [Documentation](https://community.optimism.io/docs/developers/tutorials.html)
     */ CustomChain["OptimisticEthereum"] = "optimistic-ethereum";
})($457e2e4aaefd48de$var$CustomChain = module.exports.CustomChain || (module.exports.CustomChain = {}));
var $457e2e4aaefd48de$var$Chain;
(function(Chain) {
    Chain[Chain["Mainnet"] = 1] = "Mainnet";
    Chain[Chain["Ropsten"] = 3] = "Ropsten";
    Chain[Chain["Rinkeby"] = 4] = "Rinkeby";
    Chain[Chain["Kovan"] = 42] = "Kovan";
    Chain[Chain["Goerli"] = 5] = "Goerli";
})($457e2e4aaefd48de$var$Chain = module.exports.Chain || (module.exports.Chain = {}));
var $457e2e4aaefd48de$var$Hardfork;
(function(Hardfork) {
    Hardfork["Chainstart"] = "chainstart";
    Hardfork["Homestead"] = "homestead";
    Hardfork["Dao"] = "dao";
    Hardfork["TangerineWhistle"] = "tangerineWhistle";
    Hardfork["SpuriousDragon"] = "spuriousDragon";
    Hardfork["Byzantium"] = "byzantium";
    Hardfork["Constantinople"] = "constantinople";
    Hardfork["Petersburg"] = "petersburg";
    Hardfork["Istanbul"] = "istanbul";
    Hardfork["MuirGlacier"] = "muirGlacier";
    Hardfork["Berlin"] = "berlin";
    Hardfork["London"] = "london";
    Hardfork["ArrowGlacier"] = "arrowGlacier";
    Hardfork["Shanghai"] = "shanghai";
    Hardfork["Merge"] = "merge";
})($457e2e4aaefd48de$var$Hardfork = module.exports.Hardfork || (module.exports.Hardfork = {}));
var $457e2e4aaefd48de$var$ConsensusType;
(function(ConsensusType) {
    ConsensusType["ProofOfStake"] = "pos";
    ConsensusType["ProofOfWork"] = "pow";
    ConsensusType["ProofOfAuthority"] = "poa";
})($457e2e4aaefd48de$var$ConsensusType = module.exports.ConsensusType || (module.exports.ConsensusType = {}));
var $457e2e4aaefd48de$var$ConsensusAlgorithm;
(function(ConsensusAlgorithm) {
    ConsensusAlgorithm["Ethash"] = "ethash";
    ConsensusAlgorithm["Clique"] = "clique";
    ConsensusAlgorithm["Casper"] = "casper";
})($457e2e4aaefd48de$var$ConsensusAlgorithm = module.exports.ConsensusAlgorithm || (module.exports.ConsensusAlgorithm = {}));





/**
 * Common class to access chain and hardfork parameters and to provide
 * a unified and shared view on the network and hardfork state.
 *
 * Use the {@link Common.custom} static constructor for creating simple
 * custom chain {@link Common} objects (more complete custom chain setups
 * can be created via the main constructor and the {@link CommonOpts.customChains} parameter).
 */ var $457e2e4aaefd48de$var$Common = /** @class */ function(_super) {
    $457e2e4aaefd48de$var$__extends(Common, _super);
    /**
     *
     * @constructor
     */ function Common(opts) {
        var e_1, _a;
        var _b, _c;
        var _this = _super.call(this) || this;
        _this._supportedHardforks = [];
        _this._eips = [];
        _this._customChains = (_b = opts.customChains) !== null && _b !== void 0 ? _b : [];
        _this._chainParams = _this.setChain(opts.chain);
        _this.DEFAULT_HARDFORK = (_c = _this._chainParams.defaultHardfork) !== null && _c !== void 0 ? _c : $457e2e4aaefd48de$var$Hardfork.Istanbul;
        try {
            for(var _d = $457e2e4aaefd48de$var$__values(_this._chainParams.hardforks), _e = _d.next(); !_e.done; _e = _d.next()){
                var hf = _e.value;
                if (!hf.forkHash) hf.forkHash = _this._calcForkHash(hf.name);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        _this._hardfork = _this.DEFAULT_HARDFORK;
        if (opts.supportedHardforks) _this._supportedHardforks = opts.supportedHardforks;
        if (opts.hardfork) _this.setHardfork(opts.hardfork);
        if (opts.eips) _this.setEIPs(opts.eips);
        return _this;
    }
    /**
     * Creates a {@link Common} object for a custom chain, based on a standard one.
     *
     * It uses all the {@link Chain} parameters from the {@link baseChain} option except the ones overridden
     * in a provided {@link chainParamsOrName} dictionary. Some usage example:
     *
     * ```javascript
     * Common.custom({chainId: 123})
     * ```
     *
     * There are also selected supported custom chains which can be initialized by using one of the
     * {@link CustomChains} for {@link chainParamsOrName}, e.g.:
     *
     * ```javascript
     * Common.custom(CustomChains.MaticMumbai)
     * ```
     *
     * Note that these supported custom chains only provide some base parameters (usually the chain and
     * network ID and a name) and can only be used for selected use cases (e.g. sending a tx with
     * the `@ethereumjs/tx` library to a Layer-2 chain).
     *
     * @param chainParamsOrName Custom parameter dict (`name` will default to `custom-chain`) or string with name of a supported custom chain
     * @param opts Custom chain options to set the {@link CustomCommonOpts.baseChain}, selected {@link CustomCommonOpts.hardfork} and others
     */ Common.custom = function(chainParamsOrName, opts) {
        var _a;
        if (opts === void 0) opts = {};
        var baseChain = (_a = opts.baseChain) !== null && _a !== void 0 ? _a : 'mainnet';
        var standardChainParams = $457e2e4aaefd48de$var$__assign({}, Common._getChainParams(baseChain));
        standardChainParams['name'] = 'custom-chain';
        if (typeof chainParamsOrName !== 'string') return new Common($457e2e4aaefd48de$var$__assign({
            chain: $457e2e4aaefd48de$var$__assign($457e2e4aaefd48de$var$__assign({}, standardChainParams), chainParamsOrName)
        }, opts));
        else {
            if (chainParamsOrName === $457e2e4aaefd48de$var$CustomChain.PolygonMainnet) return Common.custom({
                name: $457e2e4aaefd48de$var$CustomChain.PolygonMainnet,
                chainId: 137,
                networkId: 137
            });
            if (chainParamsOrName === $457e2e4aaefd48de$var$CustomChain.PolygonMumbai) return Common.custom({
                name: $457e2e4aaefd48de$var$CustomChain.PolygonMumbai,
                chainId: 80001,
                networkId: 80001
            });
            if (chainParamsOrName === $457e2e4aaefd48de$var$CustomChain.ArbitrumRinkebyTestnet) return Common.custom({
                name: $457e2e4aaefd48de$var$CustomChain.ArbitrumRinkebyTestnet,
                chainId: 421611,
                networkId: 421611
            });
            if (chainParamsOrName === $457e2e4aaefd48de$var$CustomChain.xDaiChain) return Common.custom({
                name: $457e2e4aaefd48de$var$CustomChain.xDaiChain,
                chainId: 100,
                networkId: 100
            });
            if (chainParamsOrName === $457e2e4aaefd48de$var$CustomChain.OptimisticKovan) return Common.custom({
                name: $457e2e4aaefd48de$var$CustomChain.OptimisticKovan,
                chainId: 69,
                networkId: 69
            }, // Optimism has not implemented the London hardfork yet (targeting Q1.22)
            {
                hardfork: $457e2e4aaefd48de$var$Hardfork.Berlin
            });
            if (chainParamsOrName === $457e2e4aaefd48de$var$CustomChain.OptimisticEthereum) return Common.custom({
                name: $457e2e4aaefd48de$var$CustomChain.OptimisticEthereum,
                chainId: 10,
                networkId: 10
            }, // Optimism has not implemented the London hardfork yet (targeting Q1.22)
            {
                hardfork: $457e2e4aaefd48de$var$Hardfork.Berlin
            });
            throw new Error("Custom chain " + chainParamsOrName + " not supported");
        }
    };
    /**
     * Creates a {@link Common} object for a custom chain, based on a standard one. It uses all the `Chain`
     * params from {@link baseChain} except the ones overridden in {@link customChainParams}.
     *
     * @deprecated Use {@link Common.custom} instead
     *
     * @param baseChain The name (`mainnet`) or id (`1`) of a standard chain used to base the custom
     * chain params on.
     * @param customChainParams The custom parameters of the chain.
     * @param hardfork String identifier ('byzantium') for hardfork (optional)
     * @param supportedHardforks Limit parameter returns to the given hardforks (optional)
     */ Common.forCustomChain = function(baseChain, customChainParams, hardfork, supportedHardforks) {
        var standardChainParams = Common._getChainParams(baseChain);
        return new Common({
            chain: $457e2e4aaefd48de$var$__assign($457e2e4aaefd48de$var$__assign({}, standardChainParams), customChainParams),
            hardfork: hardfork,
            supportedHardforks: supportedHardforks
        });
    };
    /**
     * Static method to determine if a {@link chainId} is supported as a standard chain
     * @param chainId BN id (`1`) of a standard chain
     * @returns boolean
     */ Common.isSupportedChainId = function(chainId) {
        var initializedChains = (0, $iFArz._getInitializedChains)();
        return Boolean(initializedChains['names'][chainId.toString()]);
    };
    Common._getChainParams = function(chain, customChains) {
        var initializedChains = (0, $iFArz._getInitializedChains)(customChains);
        if (typeof chain === 'number' || $7Z98w.BN.isBN(chain)) {
            chain = chain.toString();
            if (initializedChains['names'][chain]) {
                var name_1 = initializedChains['names'][chain];
                return initializedChains[name_1];
            }
            throw new Error("Chain with ID " + chain + " not supported");
        }
        if (initializedChains[chain]) return initializedChains[chain];
        throw new Error("Chain with name " + chain + " not supported");
    };
    /**
     * Sets the chain
     * @param chain String ('mainnet') or Number (1) chain
     *     representation. Or, a Dictionary of chain parameters for a private network.
     * @returns The dictionary with parameters set as chain
     */ Common.prototype.setChain = function(chain) {
        var e_2, _a;
        if (typeof chain === 'number' || typeof chain === 'string' || $7Z98w.BN.isBN(chain)) {
            // Filter out genesis states if passed in to customChains
            var plainCustomChains = void 0;
            if (this._customChains && this._customChains.length > 0 && Array.isArray(this._customChains[0])) plainCustomChains = this._customChains.map(function(e) {
                return e[0];
            });
            else plainCustomChains = this._customChains;
            this._chainParams = Common._getChainParams(chain, plainCustomChains);
        } else if (typeof chain === 'object') {
            if (this._customChains.length > 0) throw new Error('Chain must be a string, number, or BN when initialized with customChains passed in');
            var required = [
                'networkId',
                'genesis',
                'hardforks',
                'bootstrapNodes'
            ];
            try {
                for(var required_1 = $457e2e4aaefd48de$var$__values(required), required_1_1 = required_1.next(); !required_1_1.done; required_1_1 = required_1.next()){
                    var param = required_1_1.value;
                    if (chain[param] === undefined) throw new Error("Missing required chain parameter: " + param);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (required_1_1 && !required_1_1.done && (_a = required_1.return)) _a.call(required_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            this._chainParams = chain;
        } else throw new Error('Wrong input format');
        return this._chainParams;
    };
    /**
     * Sets the hardfork to get params for
     * @param hardfork String identifier (e.g. 'byzantium') or {@link Hardfork} enum
     */ Common.prototype.setHardfork = function(hardfork) {
        var e_3, _a;
        if (!this._isSupportedHardfork(hardfork)) throw new Error("Hardfork " + hardfork + " not set as supported in supportedHardforks");
        var existing = false;
        try {
            for(var HARDFORK_CHANGES_1 = $457e2e4aaefd48de$var$__values($hvgll.hardforks), HARDFORK_CHANGES_1_1 = HARDFORK_CHANGES_1.next(); !HARDFORK_CHANGES_1_1.done; HARDFORK_CHANGES_1_1 = HARDFORK_CHANGES_1.next()){
                var hfChanges = HARDFORK_CHANGES_1_1.value;
                if (hfChanges[0] === hardfork) {
                    if (this._hardfork !== hardfork) {
                        this._hardfork = hardfork;
                        this.emit('hardforkChanged', hardfork);
                    }
                    existing = true;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (HARDFORK_CHANGES_1_1 && !HARDFORK_CHANGES_1_1.done && (_a = HARDFORK_CHANGES_1.return)) _a.call(HARDFORK_CHANGES_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!existing) throw new Error("Hardfork with name " + hardfork + " not supported");
    };
    /**
     * Returns the hardfork based on the block number or an optional
     * total difficulty (Merge HF) provided.
     *
     * An optional TD takes precedence in case the corresponding HF block
     * is set to `null` or otherwise needs to match (if not an error
     * will be thrown).
     *
     * @param blockNumber
     * @param td
     * @returns The name of the HF
     */ Common.prototype.getHardforkByBlockNumber = function(blockNumber, td) {
        var e_4, _a;
        blockNumber = (0, $7Z98w.toType)(blockNumber, $7Z98w.TypeOutput.BN);
        td = (0, $7Z98w.toType)(td, $7Z98w.TypeOutput.BN);
        var hardfork = $457e2e4aaefd48de$var$Hardfork.Chainstart;
        var minTdHF;
        var maxTdHF;
        var previousHF;
        try {
            for(var _b = $457e2e4aaefd48de$var$__values(this.hardforks()), _c = _b.next(); !_c.done; _c = _b.next()){
                var hf = _c.value;
                // Skip comparison for not applied HFs
                if (hf.block === null) {
                    if (td !== undefined && td !== null && hf.td !== undefined && hf.td !== null) {
                        if (td.gte(new $7Z98w.BN(hf.td))) return hf.name;
                    }
                    continue;
                }
                if (blockNumber.gte(new $7Z98w.BN(hf.block))) hardfork = hf.name;
                if (td && hf.td) {
                    if (td.gte(new $7Z98w.BN(hf.td))) minTdHF = hf.name;
                    else maxTdHF = previousHF;
                }
                previousHF = hf.name;
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        if (td) {
            var msgAdd = "block number: " + blockNumber + " (-> " + hardfork + "), ";
            if (minTdHF) {
                if (!this.hardforkGteHardfork(hardfork, minTdHF)) {
                    var msg = 'HF determined by block number is lower than the minimum total difficulty HF';
                    msgAdd += "total difficulty: " + td + " (-> " + minTdHF + ")";
                    throw new Error(msg + ": " + msgAdd);
                }
            }
            if (maxTdHF) {
                if (!this.hardforkGteHardfork(maxTdHF, hardfork)) {
                    var msg = 'Maximum HF determined by total difficulty is lower than the block number HF';
                    msgAdd += "total difficulty: " + td + " (-> " + maxTdHF + ")";
                    throw new Error(msg + ": " + msgAdd);
                }
            }
        }
        return hardfork;
    };
    /**
     * Sets a new hardfork based on the block number or an optional
     * total difficulty (Merge HF) provided.
     *
     * An optional TD takes precedence in case the corresponding HF block
     * is set to `null` or otherwise needs to match (if not an error
     * will be thrown).
     *
     * @param blockNumber
     * @param td
     * @returns The name of the HF set
     */ Common.prototype.setHardforkByBlockNumber = function(blockNumber, td) {
        var hardfork = this.getHardforkByBlockNumber(blockNumber, td);
        this.setHardfork(hardfork);
        return hardfork;
    };
    /**
     * Internal helper function to choose between hardfork set and hardfork provided as param
     * @param hardfork Hardfork given to function as a parameter
     * @returns Hardfork chosen to be used
     */ Common.prototype._chooseHardfork = function(hardfork, onlySupported) {
        if (onlySupported === void 0) onlySupported = true;
        if (!hardfork) hardfork = this._hardfork;
        else if (onlySupported && !this._isSupportedHardfork(hardfork)) throw new Error("Hardfork " + hardfork + " not set as supported in supportedHardforks");
        return hardfork;
    };
    /**
     * Internal helper function, returns the params for the given hardfork for the chain set
     * @param hardfork Hardfork name
     * @returns Dictionary with hardfork params
     */ Common.prototype._getHardfork = function(hardfork) {
        var e_5, _a;
        var hfs = this.hardforks();
        try {
            for(var hfs_1 = $457e2e4aaefd48de$var$__values(hfs), hfs_1_1 = hfs_1.next(); !hfs_1_1.done; hfs_1_1 = hfs_1.next()){
                var hf = hfs_1_1.value;
                if (hf['name'] === hardfork) return hf;
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (hfs_1_1 && !hfs_1_1.done && (_a = hfs_1.return)) _a.call(hfs_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        throw new Error("Hardfork " + hardfork + " not defined for chain " + this.chainName());
    };
    /**
     * Internal helper function to check if a hardfork is set to be supported by the library
     * @param hardfork Hardfork name
     * @returns True if hardfork is supported
     */ Common.prototype._isSupportedHardfork = function(hardfork) {
        var e_6, _a;
        if (this._supportedHardforks.length > 0) try {
            for(var _b = $457e2e4aaefd48de$var$__values(this._supportedHardforks), _c = _b.next(); !_c.done; _c = _b.next()){
                var supportedHf = _c.value;
                if (hardfork === supportedHf) return true;
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        else return true;
        return false;
    };
    /**
     * Sets the active EIPs
     * @param eips
     */ Common.prototype.setEIPs = function(eips) {
        var e_7, _a;
        var _this = this;
        if (eips === void 0) eips = [];
        var _loop_1 = function(eip) {
            if (!(eip in $jkA0Q.EIPs)) throw new Error(eip + " not supported");
            var minHF = this_1.gteHardfork($jkA0Q.EIPs[eip]['minimumHardfork']);
            if (!minHF) throw new Error(eip + " cannot be activated on hardfork " + this_1.hardfork() + ", minimumHardfork: " + minHF);
            if ($jkA0Q.EIPs[eip].requiredEIPs) $jkA0Q.EIPs[eip].requiredEIPs.forEach(function(elem) {
                if (!(eips.includes(elem) || _this.isActivatedEIP(elem))) throw new Error(eip + " requires EIP " + elem + ", but is not included in the EIP list");
            });
        };
        var this_1 = this;
        try {
            for(var eips_2 = $457e2e4aaefd48de$var$__values(eips), eips_2_1 = eips_2.next(); !eips_2_1.done; eips_2_1 = eips_2.next()){
                var eip = eips_2_1.value;
                _loop_1(eip);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (eips_2_1 && !eips_2_1.done && (_a = eips_2.return)) _a.call(eips_2);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        this._eips = eips;
    };
    /**
     * Returns a parameter for the current chain setup
     *
     * If the parameter is present in an EIP, the EIP always takes precendence.
     * Otherwise the parameter if taken from the latest applied HF with
     * a change on the respective parameter.
     *
     * @param topic Parameter topic ('gasConfig', 'gasPrices', 'vm', 'pow')
     * @param name Parameter name (e.g. 'minGasLimit' for 'gasConfig' topic)
     * @returns The value requested or `null` if not found
     */ Common.prototype.param = function(topic, name) {
        var e_8, _a;
        // TODO: consider the case that different active EIPs
        // can change the same parameter
        var value = null;
        try {
            for(var _b = $457e2e4aaefd48de$var$__values(this._eips), _c = _b.next(); !_c.done; _c = _b.next()){
                var eip = _c.value;
                value = this.paramByEIP(topic, name, eip);
                if (value !== null) return value;
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        return this.paramByHardfork(topic, name, this._hardfork);
    };
    /**
     * Returns the parameter corresponding to a hardfork
     * @param topic Parameter topic ('gasConfig', 'gasPrices', 'vm', 'pow')
     * @param name Parameter name (e.g. 'minGasLimit' for 'gasConfig' topic)
     * @param hardfork Hardfork name
     * @returns The value requested or `null` if not found
     */ Common.prototype.paramByHardfork = function(topic, name, hardfork) {
        var e_9, _a, e_10, _b;
        hardfork = this._chooseHardfork(hardfork);
        var value = null;
        try {
            for(var HARDFORK_CHANGES_2 = $457e2e4aaefd48de$var$__values($hvgll.hardforks), HARDFORK_CHANGES_2_1 = HARDFORK_CHANGES_2.next(); !HARDFORK_CHANGES_2_1.done; HARDFORK_CHANGES_2_1 = HARDFORK_CHANGES_2.next()){
                var hfChanges = HARDFORK_CHANGES_2_1.value;
                // EIP-referencing HF file (e.g. berlin.json)
                if ('eips' in hfChanges[1]) {
                    var hfEIPs = hfChanges[1]['eips'];
                    try {
                        for(var hfEIPs_1 = (e_10 = void 0, $457e2e4aaefd48de$var$__values(hfEIPs)), hfEIPs_1_1 = hfEIPs_1.next(); !hfEIPs_1_1.done; hfEIPs_1_1 = hfEIPs_1.next()){
                            var eip = hfEIPs_1_1.value;
                            var valueEIP = this.paramByEIP(topic, name, eip);
                            value = valueEIP !== null ? valueEIP : value;
                        }
                    } catch (e_10_1) {
                        e_10 = {
                            error: e_10_1
                        };
                    } finally{
                        try {
                            if (hfEIPs_1_1 && !hfEIPs_1_1.done && (_b = hfEIPs_1.return)) _b.call(hfEIPs_1);
                        } finally{
                            if (e_10) throw e_10.error;
                        }
                    }
                // Paramater-inlining HF file (e.g. istanbul.json)
                } else {
                    if (!hfChanges[1][topic]) throw new Error("Topic " + topic + " not defined");
                    if (hfChanges[1][topic][name] !== undefined) value = hfChanges[1][topic][name].v;
                }
                if (hfChanges[0] === hardfork) break;
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (HARDFORK_CHANGES_2_1 && !HARDFORK_CHANGES_2_1.done && (_a = HARDFORK_CHANGES_2.return)) _a.call(HARDFORK_CHANGES_2);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        return value;
    };
    /**
     * Returns a parameter corresponding to an EIP
     * @param topic Parameter topic ('gasConfig', 'gasPrices', 'vm', 'pow')
     * @param name Parameter name (e.g. 'minGasLimit' for 'gasConfig' topic)
     * @param eip Number of the EIP
     * @returns The value requested or `null` if not found
     */ Common.prototype.paramByEIP = function(topic, name, eip) {
        if (!(eip in $jkA0Q.EIPs)) throw new Error(eip + " not supported");
        var eipParams = $jkA0Q.EIPs[eip];
        if (!(topic in eipParams)) throw new Error("Topic " + topic + " not defined");
        if (eipParams[topic][name] === undefined) return null;
        var value = eipParams[topic][name].v;
        return value;
    };
    /**
     * Returns a parameter for the hardfork active on block number
     * @param topic Parameter topic
     * @param name Parameter name
     * @param blockNumber Block number
     */ Common.prototype.paramByBlock = function(topic, name, blockNumber) {
        var activeHfs = this.activeHardforks(blockNumber);
        var hardfork = activeHfs[activeHfs.length - 1]['name'];
        return this.paramByHardfork(topic, name, hardfork);
    };
    /**
     * Checks if an EIP is activated by either being included in the EIPs
     * manually passed in with the {@link CommonOpts.eips} or in a
     * hardfork currently being active
     *
     * Note: this method only works for EIPs being supported
     * by the {@link CommonOpts.eips} constructor option
     * @param eip
     */ Common.prototype.isActivatedEIP = function(eip) {
        var e_11, _a;
        if (this.eips().includes(eip)) return true;
        try {
            for(var HARDFORK_CHANGES_3 = $457e2e4aaefd48de$var$__values($hvgll.hardforks), HARDFORK_CHANGES_3_1 = HARDFORK_CHANGES_3.next(); !HARDFORK_CHANGES_3_1.done; HARDFORK_CHANGES_3_1 = HARDFORK_CHANGES_3.next()){
                var hfChanges = HARDFORK_CHANGES_3_1.value;
                var hf = hfChanges[1];
                if (this.gteHardfork(hf['name']) && 'eips' in hf) {
                    if (hf['eips'].includes(eip)) return true;
                }
            }
        } catch (e_11_1) {
            e_11 = {
                error: e_11_1
            };
        } finally{
            try {
                if (HARDFORK_CHANGES_3_1 && !HARDFORK_CHANGES_3_1.done && (_a = HARDFORK_CHANGES_3.return)) _a.call(HARDFORK_CHANGES_3);
            } finally{
                if (e_11) throw e_11.error;
            }
        }
        return false;
    };
    /**
     * Checks if set or provided hardfork is active on block number
     * @param hardfork Hardfork name or null (for HF set)
     * @param blockNumber
     * @param opts Hardfork options (onlyActive unused)
     * @returns True if HF is active on block number
     */ Common.prototype.hardforkIsActiveOnBlock = function(hardfork, blockNumber, opts) {
        var _a;
        if (opts === void 0) opts = {};
        blockNumber = (0, $7Z98w.toType)(blockNumber, $7Z98w.TypeOutput.BN);
        var onlySupported = (_a = opts.onlySupported) !== null && _a !== void 0 ? _a : false;
        hardfork = this._chooseHardfork(hardfork, onlySupported);
        var hfBlock = this.hardforkBlockBN(hardfork);
        if (hfBlock && blockNumber.gte(hfBlock)) return true;
        return false;
    };
    /**
     * Alias to hardforkIsActiveOnBlock when hardfork is set
     * @param blockNumber
     * @param opts Hardfork options (onlyActive unused)
     * @returns True if HF is active on block number
     */ Common.prototype.activeOnBlock = function(blockNumber, opts) {
        return this.hardforkIsActiveOnBlock(null, blockNumber, opts);
    };
    /**
     * Sequence based check if given or set HF1 is greater than or equal HF2
     * @param hardfork1 Hardfork name or null (if set)
     * @param hardfork2 Hardfork name
     * @param opts Hardfork options
     * @returns True if HF1 gte HF2
     */ Common.prototype.hardforkGteHardfork = function(hardfork1, hardfork2, opts) {
        var e_12, _a;
        if (opts === void 0) opts = {};
        var onlyActive = opts.onlyActive === undefined ? false : opts.onlyActive;
        hardfork1 = this._chooseHardfork(hardfork1, opts.onlySupported);
        var hardforks;
        if (onlyActive) hardforks = this.activeHardforks(null, opts);
        else hardforks = this.hardforks();
        var posHf1 = -1, posHf2 = -1;
        var index = 0;
        try {
            for(var hardforks_2 = $457e2e4aaefd48de$var$__values(hardforks), hardforks_2_1 = hardforks_2.next(); !hardforks_2_1.done; hardforks_2_1 = hardforks_2.next()){
                var hf = hardforks_2_1.value;
                if (hf['name'] === hardfork1) posHf1 = index;
                if (hf['name'] === hardfork2) posHf2 = index;
                index += 1;
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (hardforks_2_1 && !hardforks_2_1.done && (_a = hardforks_2.return)) _a.call(hardforks_2);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
        return posHf1 >= posHf2 && posHf2 !== -1;
    };
    /**
     * Alias to hardforkGteHardfork when hardfork is set
     * @param hardfork Hardfork name
     * @param opts Hardfork options
     * @returns True if hardfork set is greater than hardfork provided
     */ Common.prototype.gteHardfork = function(hardfork, opts) {
        return this.hardforkGteHardfork(null, hardfork, opts);
    };
    /**
     * Checks if given or set hardfork is active on the chain
     * @param hardfork Hardfork name, optional if HF set
     * @param opts Hardfork options (onlyActive unused)
     * @returns True if hardfork is active on the chain
     */ Common.prototype.hardforkIsActiveOnChain = function(hardfork, opts) {
        var e_13, _a;
        var _b;
        if (opts === void 0) opts = {};
        var onlySupported = (_b = opts.onlySupported) !== null && _b !== void 0 ? _b : false;
        hardfork = this._chooseHardfork(hardfork, onlySupported);
        try {
            for(var _c = $457e2e4aaefd48de$var$__values(this.hardforks()), _d = _c.next(); !_d.done; _d = _c.next()){
                var hf = _d.value;
                if (hf['name'] === hardfork && hf['block'] !== null) return true;
            }
        } catch (e_13_1) {
            e_13 = {
                error: e_13_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_13) throw e_13.error;
            }
        }
        return false;
    };
    /**
     * Returns the active hardfork switches for the current chain
     * @param blockNumber up to block if provided, otherwise for the whole chain
     * @param opts Hardfork options (onlyActive unused)
     * @return Array with hardfork arrays
     */ Common.prototype.activeHardforks = function(blockNumber, opts) {
        var e_14, _a;
        if (opts === void 0) opts = {};
        var activeHardforks = [];
        var hfs = this.hardforks();
        try {
            for(var hfs_2 = $457e2e4aaefd48de$var$__values(hfs), hfs_2_1 = hfs_2.next(); !hfs_2_1.done; hfs_2_1 = hfs_2.next()){
                var hf = hfs_2_1.value;
                if (hf['block'] === null) continue;
                if (blockNumber !== undefined && blockNumber !== null && blockNumber < hf['block']) break;
                if (opts.onlySupported && !this._isSupportedHardfork(hf['name'])) continue;
                activeHardforks.push(hf);
            }
        } catch (e_14_1) {
            e_14 = {
                error: e_14_1
            };
        } finally{
            try {
                if (hfs_2_1 && !hfs_2_1.done && (_a = hfs_2.return)) _a.call(hfs_2);
            } finally{
                if (e_14) throw e_14.error;
            }
        }
        return activeHardforks;
    };
    /**
     * Returns the latest active hardfork name for chain or block or throws if unavailable
     * @param blockNumber up to block if provided, otherwise for the whole chain
     * @param opts Hardfork options (onlyActive unused)
     * @return Hardfork name
     */ Common.prototype.activeHardfork = function(blockNumber, opts) {
        if (opts === void 0) opts = {};
        var activeHardforks = this.activeHardforks(blockNumber, opts);
        if (activeHardforks.length > 0) return activeHardforks[activeHardforks.length - 1]['name'];
        else throw new Error("No (supported) active hardfork found");
    };
    /**
     * Returns the hardfork change block for hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Block number or null if unscheduled
     * @deprecated Please use {@link Common.hardforkBlockBN} for large number support
     */ Common.prototype.hardforkBlock = function(hardfork) {
        var block = this.hardforkBlockBN(hardfork);
        return (0, $7Z98w.toType)(block, $7Z98w.TypeOutput.Number);
    };
    /**
     * Returns the hardfork change block for hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Block number or null if unscheduled
     */ Common.prototype.hardforkBlockBN = function(hardfork) {
        hardfork = this._chooseHardfork(hardfork, false);
        var block = this._getHardfork(hardfork)['block'];
        if (block === undefined || block === null) return null;
        return new $7Z98w.BN(block);
    };
    /**
     * Returns the hardfork change total difficulty (Merge HF) for hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Total difficulty or null if no set
     */ Common.prototype.hardforkTD = function(hardfork) {
        hardfork = this._chooseHardfork(hardfork, false);
        var td = this._getHardfork(hardfork)['td'];
        if (td === undefined || td === null) return null;
        return new $7Z98w.BN(td);
    };
    /**
     * True if block number provided is the hardfork (given or set) change block
     * @param blockNumber Number of the block to check
     * @param hardfork Hardfork name, optional if HF set
     * @returns True if blockNumber is HF block
     */ Common.prototype.isHardforkBlock = function(blockNumber, hardfork) {
        blockNumber = (0, $7Z98w.toType)(blockNumber, $7Z98w.TypeOutput.BN);
        hardfork = this._chooseHardfork(hardfork, false);
        var block = this.hardforkBlockBN(hardfork);
        return block ? block.eq(blockNumber) : false;
    };
    /**
     * Returns the change block for the next hardfork after the hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Block number or null if not available
     * @deprecated Please use {@link Common.nextHardforkBlockBN} for large number support
     */ Common.prototype.nextHardforkBlock = function(hardfork) {
        var block = this.nextHardforkBlockBN(hardfork);
        return (0, $7Z98w.toType)(block, $7Z98w.TypeOutput.Number);
    };
    /**
     * Returns the change block for the next hardfork after the hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Block number or null if not available
     */ Common.prototype.nextHardforkBlockBN = function(hardfork) {
        hardfork = this._chooseHardfork(hardfork, false);
        var hfBlock = this.hardforkBlockBN(hardfork);
        if (hfBlock === null) return null;
        // Next fork block number or null if none available
        // Logic: if accumulator is still null and on the first occurrence of
        // a block greater than the current hfBlock set the accumulator,
        // pass on the accumulator as the final result from this time on
        var nextHfBlock = this.hardforks().reduce(function(acc, hf) {
            var block = new $7Z98w.BN(hf.block);
            return block.gt(hfBlock) && acc === null ? block : acc;
        }, null);
        return nextHfBlock;
    };
    /**
     * True if block number provided is the hardfork change block following the hardfork given or set
     * @param blockNumber Number of the block to check
     * @param hardfork Hardfork name, optional if HF set
     * @returns True if blockNumber is HF block
     */ Common.prototype.isNextHardforkBlock = function(blockNumber, hardfork) {
        blockNumber = (0, $7Z98w.toType)(blockNumber, $7Z98w.TypeOutput.BN);
        hardfork = this._chooseHardfork(hardfork, false);
        var nextHardforkBlock = this.nextHardforkBlockBN(hardfork);
        return nextHardforkBlock === null ? false : nextHardforkBlock.eq(blockNumber);
    };
    /**
     * Internal helper function to calculate a fork hash
     * @param hardfork Hardfork name
     * @returns Fork hash as hex string
     */ Common.prototype._calcForkHash = function(hardfork) {
        var e_15, _a;
        var genesis = $457e2e4aaefd48de$require$Buffer.from(this.genesis().hash.substr(2), 'hex');
        var hfBuffer = $457e2e4aaefd48de$require$Buffer.alloc(0);
        var prevBlock = 0;
        try {
            for(var _b = $457e2e4aaefd48de$var$__values(this.hardforks()), _c = _b.next(); !_c.done; _c = _b.next()){
                var hf = _c.value;
                var block = hf.block;
                // Skip for chainstart (0), not applied HFs (null) and
                // when already applied on same block number HFs
                if (block !== 0 && block !== null && block !== prevBlock) {
                    var hfBlockBuffer = $457e2e4aaefd48de$require$Buffer.from(block.toString(16).padStart(16, '0'), 'hex');
                    hfBuffer = $457e2e4aaefd48de$require$Buffer.concat([
                        hfBuffer,
                        hfBlockBuffer
                    ]);
                }
                if (hf.name === hardfork) break;
                if (block !== null) prevBlock = block;
            }
        } catch (e_15_1) {
            e_15 = {
                error: e_15_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_15) throw e_15.error;
            }
        }
        var inputBuffer = $457e2e4aaefd48de$require$Buffer.concat([
            genesis,
            hfBuffer
        ]);
        // CRC32 delivers result as signed (negative) 32-bit integer,
        // convert to hex string
        var forkhash = (0, $7Z98w.intToBuffer)((0, $5ylEQ.buf)(inputBuffer) >>> 0).toString('hex');
        return "0x" + forkhash;
    };
    /**
     * Returns an eth/64 compliant fork hash (EIP-2124)
     * @param hardfork Hardfork name, optional if HF set
     */ Common.prototype.forkHash = function(hardfork) {
        hardfork = this._chooseHardfork(hardfork, false);
        var data = this._getHardfork(hardfork);
        if (data['block'] === null && data['td'] === undefined) {
            var msg = 'No fork hash calculation possible for future hardfork';
            throw new Error(msg);
        }
        if (data['forkHash'] !== undefined) return data['forkHash'];
        return this._calcForkHash(hardfork);
    };
    /**
     *
     * @param forkHash Fork hash as a hex string
     * @returns Array with hardfork data (name, block, forkHash)
     */ Common.prototype.hardforkForForkHash = function(forkHash) {
        var resArray = this.hardforks().filter(function(hf) {
            return hf.forkHash === forkHash;
        });
        return resArray.length >= 1 ? resArray[resArray.length - 1] : null;
    };
    /**
     * Returns the Genesis parameters of the current chain
     * @returns Genesis dictionary
     */ Common.prototype.genesis = function() {
        return this._chainParams['genesis'];
    };
    /**
     * Returns the Genesis state of the current chain,
     * all values are provided as hex-prefixed strings.
     */ Common.prototype.genesisState = function() {
        var e_16, _a;
        // Use require statements here in favor of import statements
        // to load json files on demand
        // (high memory usage by large mainnet.json genesis state file)
        switch(this.chainName()){
            case 'mainnet':
                return (parcelRequire("h7v9F"));
            case 'ropsten':
                return (parcelRequire("MAawF"));
            case 'rinkeby':
                return (parcelRequire("66KfJ"));
            case 'kovan':
                return (parcelRequire("g4EhK"));
            case 'goerli':
                return (parcelRequire("iINzt"));
        }
        // Custom chains with genesis state provided
        if (this._customChains && this._customChains.length > 0 && Array.isArray(this._customChains[0])) try {
            for(var _b = $457e2e4aaefd48de$var$__values(this._customChains), _c = _b.next(); !_c.done; _c = _b.next()){
                var chainArrayWithGenesis = _c.value;
                if (chainArrayWithGenesis[0].name === this.chainName()) return chainArrayWithGenesis[1];
            }
        } catch (e_16_1) {
            e_16 = {
                error: e_16_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_16) throw e_16.error;
            }
        }
        return {};
    };
    /**
     * Returns the hardforks for current chain
     * @returns {Array} Array with arrays of hardforks
     */ Common.prototype.hardforks = function() {
        return this._chainParams['hardforks'];
    };
    /**
     * Returns bootstrap nodes for the current chain
     * @returns {Dictionary} Dict with bootstrap nodes
     */ Common.prototype.bootstrapNodes = function() {
        return this._chainParams['bootstrapNodes'];
    };
    /**
     * Returns DNS networks for the current chain
     * @returns {String[]} Array of DNS ENR urls
     */ Common.prototype.dnsNetworks = function() {
        return this._chainParams['dnsNetworks'];
    };
    /**
     * Returns the hardfork set
     * @returns Hardfork name
     */ Common.prototype.hardfork = function() {
        return this._hardfork;
    };
    /**
     * Returns the Id of current chain
     * @returns chain Id
     * @deprecated Please use {@link Common.chainIdBN} for large number support
     */ Common.prototype.chainId = function() {
        return (0, $7Z98w.toType)(this.chainIdBN(), $7Z98w.TypeOutput.Number);
    };
    /**
     * Returns the Id of current chain
     * @returns chain Id
     */ Common.prototype.chainIdBN = function() {
        return new $7Z98w.BN(this._chainParams['chainId']);
    };
    /**
     * Returns the name of current chain
     * @returns chain name (lower case)
     */ Common.prototype.chainName = function() {
        return this._chainParams['name'];
    };
    /**
     * Returns the Id of current network
     * @returns network Id
     * @deprecated Please use {@link Common.networkIdBN} for large number support
     */ Common.prototype.networkId = function() {
        return (0, $7Z98w.toType)(this.networkIdBN(), $7Z98w.TypeOutput.Number);
    };
    /**
     * Returns the Id of current network
     * @returns network Id
     */ Common.prototype.networkIdBN = function() {
        return new $7Z98w.BN(this._chainParams['networkId']);
    };
    /**
     * Returns the active EIPs
     * @returns List of EIPs
     */ Common.prototype.eips = function() {
        return this._eips;
    };
    /**
     * Returns the consensus type of the network
     * Possible values: "pow"|"poa"|"pos"
     *
     * Note: This value can update along a hardfork.
     */ Common.prototype.consensusType = function() {
        var e_17, _a;
        var hardfork = this.hardfork();
        var value;
        try {
            for(var HARDFORK_CHANGES_4 = $457e2e4aaefd48de$var$__values($hvgll.hardforks), HARDFORK_CHANGES_4_1 = HARDFORK_CHANGES_4.next(); !HARDFORK_CHANGES_4_1.done; HARDFORK_CHANGES_4_1 = HARDFORK_CHANGES_4.next()){
                var hfChanges = HARDFORK_CHANGES_4_1.value;
                if ('consensus' in hfChanges[1]) value = hfChanges[1]['consensus']['type'];
                if (hfChanges[0] === hardfork) break;
            }
        } catch (e_17_1) {
            e_17 = {
                error: e_17_1
            };
        } finally{
            try {
                if (HARDFORK_CHANGES_4_1 && !HARDFORK_CHANGES_4_1.done && (_a = HARDFORK_CHANGES_4.return)) _a.call(HARDFORK_CHANGES_4);
            } finally{
                if (e_17) throw e_17.error;
            }
        }
        if (value) return value;
        return this._chainParams['consensus']['type'];
    };
    /**
     * Returns the concrete consensus implementation
     * algorithm or protocol for the network
     * e.g. "ethash" for "pow" consensus type,
     * "clique" for "poa" consensus type or
     * "casper" for "pos" consensus type.
     *
     * Note: This value can update along a hardfork.
     */ Common.prototype.consensusAlgorithm = function() {
        var e_18, _a;
        var hardfork = this.hardfork();
        var value;
        try {
            for(var HARDFORK_CHANGES_5 = $457e2e4aaefd48de$var$__values($hvgll.hardforks), HARDFORK_CHANGES_5_1 = HARDFORK_CHANGES_5.next(); !HARDFORK_CHANGES_5_1.done; HARDFORK_CHANGES_5_1 = HARDFORK_CHANGES_5.next()){
                var hfChanges = HARDFORK_CHANGES_5_1.value;
                if ('consensus' in hfChanges[1]) value = hfChanges[1]['consensus']['algorithm'];
                if (hfChanges[0] === hardfork) break;
            }
        } catch (e_18_1) {
            e_18 = {
                error: e_18_1
            };
        } finally{
            try {
                if (HARDFORK_CHANGES_5_1 && !HARDFORK_CHANGES_5_1.done && (_a = HARDFORK_CHANGES_5.return)) _a.call(HARDFORK_CHANGES_5);
            } finally{
                if (e_18) throw e_18.error;
            }
        }
        if (value) return value;
        return this._chainParams['consensus']['algorithm'];
    };
    /**
     * Returns a dictionary with consensus configuration
     * parameters based on the consensus algorithm
     *
     * Expected returns (parameters must be present in
     * the respective chain json files):
     *
     * ethash: -
     * clique: period, epoch
     * aura: -
     * casper: -
     *
     * Note: This value can update along a hardfork.
     */ Common.prototype.consensusConfig = function() {
        var e_19, _a;
        var hardfork = this.hardfork();
        var value;
        try {
            for(var HARDFORK_CHANGES_6 = $457e2e4aaefd48de$var$__values($hvgll.hardforks), HARDFORK_CHANGES_6_1 = HARDFORK_CHANGES_6.next(); !HARDFORK_CHANGES_6_1.done; HARDFORK_CHANGES_6_1 = HARDFORK_CHANGES_6.next()){
                var hfChanges = HARDFORK_CHANGES_6_1.value;
                if ('consensus' in hfChanges[1]) // The config parameter is named after the respective consensus algorithm
                value = hfChanges[1]['consensus'][hfChanges[1]['consensus']['algorithm']];
                if (hfChanges[0] === hardfork) break;
            }
        } catch (e_19_1) {
            e_19 = {
                error: e_19_1
            };
        } finally{
            try {
                if (HARDFORK_CHANGES_6_1 && !HARDFORK_CHANGES_6_1.done && (_a = HARDFORK_CHANGES_6.return)) _a.call(HARDFORK_CHANGES_6);
            } finally{
                if (e_19) throw e_19.error;
            }
        }
        if (value) return value;
        var consensusAlgorithm = this.consensusAlgorithm();
        return this._chainParams['consensus'][consensusAlgorithm];
    };
    /**
     * Returns a deep copy of this {@link Common} instance.
     */ Common.prototype.copy = function() {
        return Object.assign(Object.create(Object.getPrototypeOf(this)), this);
    };
    return Common;
}($7etJZ.EventEmitter);
module.exports.default = $457e2e4aaefd48de$var$Common;

});
parcelRegister("5ylEQ", function(module, exports) {
/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $40b0ed8255973f00$var$CRC32;
(function(factory) {
    /*jshint ignore:start */ /*eslint-disable */ if (typeof DO_NOT_EXPORT_CRC === 'undefined') factory(module.exports);
    else factory($40b0ed8255973f00$var$CRC32 = {});
/*eslint-enable */ /*jshint ignore:end */ })(function(CRC32) {
    CRC32.version = '1.2.0';
    /* see perf/crc32table.js */ /*global Int32Array */ function signed_crc_table() {
        var c = 0, table = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
    }
    var T = signed_crc_table();
    function crc32_bstr(bstr, seed) {
        var C = seed ^ -1, L = bstr.length - 1;
        for(var i = 0; i < L;){
            C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 0xFF];
            C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        }
        if (i === L) C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i)) & 0xFF];
        return C ^ -1;
    }
    function crc32_buf(buf, seed) {
        if (buf.length > 10000) return crc32_buf_8(buf, seed);
        var C = seed ^ -1, L = buf.length - 3;
        for(var i = 0; i < L;){
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
        }
        while(i < L + 3)C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
        return C ^ -1;
    }
    function crc32_buf_8(buf, seed) {
        var C = seed ^ -1, L = buf.length - 7;
        for(var i = 0; i < L;){
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
        }
        while(i < L + 7)C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
        return C ^ -1;
    }
    function crc32_str(str, seed) {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c, d; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return C ^ -1;
    }
    CRC32.table = T;
    // $FlowIgnore
    CRC32.bstr = crc32_bstr;
    // $FlowIgnore
    CRC32.buf = crc32_buf;
    // $FlowIgnore
    CRC32.str = crc32_str;
});

});

parcelRegister("iFArz", function(module, exports) {
"use strict";
var $d978534c09150091$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $d978534c09150091$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chains = module.exports._getInitializedChains = void 0;

var $d978534c09150091$var$mainnet_json_1 = $d978534c09150091$var$__importDefault((parcelRequire("o6MLI")));

var $d978534c09150091$var$ropsten_json_1 = $d978534c09150091$var$__importDefault((parcelRequire("9llx6")));

var $d978534c09150091$var$rinkeby_json_1 = $d978534c09150091$var$__importDefault((parcelRequire("2vVZR")));

var $d978534c09150091$var$kovan_json_1 = $d978534c09150091$var$__importDefault((parcelRequire("3yRux")));

var $d978534c09150091$var$goerli_json_1 = $d978534c09150091$var$__importDefault((parcelRequire("6aXGp")));
/**
 * @hidden
 */ function $d978534c09150091$var$_getInitializedChains(customChains) {
    var e_1, _a;
    var names = {
        '1': 'mainnet',
        '3': 'ropsten',
        '4': 'rinkeby',
        '42': 'kovan',
        '5': 'goerli'
    };
    var chains = {
        mainnet: $d978534c09150091$var$mainnet_json_1.default,
        ropsten: $d978534c09150091$var$ropsten_json_1.default,
        rinkeby: $d978534c09150091$var$rinkeby_json_1.default,
        kovan: $d978534c09150091$var$kovan_json_1.default,
        goerli: $d978534c09150091$var$goerli_json_1.default
    };
    if (customChains) try {
        for(var customChains_1 = $d978534c09150091$var$__values(customChains), customChains_1_1 = customChains_1.next(); !customChains_1_1.done; customChains_1_1 = customChains_1.next()){
            var chain = customChains_1_1.value;
            var name_1 = chain.name;
            names[chain.chainId.toString()] = name_1;
            chains[name_1] = chain;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (customChains_1_1 && !customChains_1_1.done && (_a = customChains_1.return)) _a.call(customChains_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    chains['names'] = names;
    return chains;
}
module.exports._getInitializedChains = $d978534c09150091$var$_getInitializedChains;
/**
 * @deprecated this constant will be internalized (removed)
 * on next major version update
 */ module.exports.chains = $d978534c09150091$var$_getInitializedChains();

});
parcelRegister("o6MLI", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"mainnet\",\"chainId\":1,\"networkId\":1,\"defaultHardfork\":\"istanbul\",\"consensus\":{\"type\":\"pow\",\"algorithm\":\"ethash\",\"ethash\":{}},\"comment\":\"The Ethereum main chain\",\"url\":\"https://ethstats.net/\",\"genesis\":{\"hash\":\"0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3\",\"timestamp\":null,\"gasLimit\":5000,\"difficulty\":17179869184,\"nonce\":\"0x0000000000000042\",\"extraData\":\"0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa\",\"stateRoot\":\"0xd7f8974fb5ac78d9ac099b9ad5018bedc2ce0a72dad1827a1709da30580f0544\"},\"hardforks\":[{\"name\":\"chainstart\",\"block\":0,\"forkHash\":\"0xfc64ec04\"},{\"name\":\"homestead\",\"block\":1150000,\"forkHash\":\"0x97c2c34c\"},{\"name\":\"dao\",\"block\":1920000,\"forkHash\":\"0x91d1f948\"},{\"name\":\"tangerineWhistle\",\"block\":2463000,\"forkHash\":\"0x7a64da13\"},{\"name\":\"spuriousDragon\",\"block\":2675000,\"forkHash\":\"0x3edd5b10\"},{\"name\":\"byzantium\",\"block\":4370000,\"forkHash\":\"0xa00bc324\"},{\"name\":\"constantinople\",\"block\":7280000,\"forkHash\":\"0x668db0af\"},{\"name\":\"petersburg\",\"block\":7280000,\"forkHash\":\"0x668db0af\"},{\"name\":\"istanbul\",\"block\":9069000,\"forkHash\":\"0x879d6e30\"},{\"name\":\"muirGlacier\",\"block\":9200000,\"forkHash\":\"0xe029e991\"},{\"name\":\"berlin\",\"block\":12244000,\"forkHash\":\"0x0eb440f6\"},{\"name\":\"london\",\"block\":12965000,\"forkHash\":\"0xb715077d\"},{\"name\":\"arrowGlacier\",\"block\":13773000,\"forkHash\":\"0x20c327fc\"},{\"name\":\"merge\",\"block\":null,\"forkHash\":null},{\"name\":\"shanghai\",\"block\":null,\"forkHash\":null}],\"bootstrapNodes\":[{\"ip\":\"18.138.108.67\",\"port\":30303,\"id\":\"d860a01f9722d78051619d1e2351aba3f43f943f6f00718d1b9baa4101932a1f5011f16bb2b1bb35db20d6fe28fa0bf09636d26a87d31de9ec6203eeedb1f666\",\"location\":\"ap-southeast-1-001\",\"comment\":\"bootnode-aws-ap-southeast-1-001\"},{\"ip\":\"3.209.45.79\",\"port\":30303,\"id\":\"22a8232c3abc76a16ae9d6c3b164f98775fe226f0917b0ca871128a74a8e9630b458460865bab457221f1d448dd9791d24c4e5d88786180ac185df813a68d4de\",\"location\":\"us-east-1-001\",\"comment\":\"bootnode-aws-us-east-1-001\"},{\"ip\":\"34.255.23.113\",\"port\":30303,\"id\":\"ca6de62fce278f96aea6ec5a2daadb877e51651247cb96ee310a318def462913b653963c155a0ef6c7d50048bba6e6cea881130857413d9f50a621546b590758\",\"location\":\"eu-west-1-001\",\"comment\":\"bootnode-aws-eu-west-1-001\"},{\"ip\":\"35.158.244.151\",\"port\":30303,\"id\":\"279944d8dcd428dffaa7436f25ca0ca43ae19e7bcf94a8fb7d1641651f92d121e972ac2e8f381414b80cc8e5555811c2ec6e1a99bb009b3f53c4c69923e11bd8\",\"location\":\"eu-central-1-001\",\"comment\":\"bootnode-aws-eu-central-1-001\"},{\"ip\":\"52.187.207.27\",\"port\":30303,\"id\":\"8499da03c47d637b20eee24eec3c356c9a2e6148d6fe25ca195c7949ab8ec2c03e3556126b0d7ed644675e78c4318b08691b7b57de10e5f0d40d05b09238fa0a\",\"location\":\"australiaeast-001\",\"comment\":\"bootnode-azure-australiaeast-001\"},{\"ip\":\"191.234.162.198\",\"port\":30303,\"id\":\"103858bdb88756c71f15e9b5e09b56dc1be52f0a5021d46301dbbfb7e130029cc9d0d6f73f693bc29b665770fff7da4d34f3c6379fe12721b5d7a0bcb5ca1fc1\",\"location\":\"brazilsouth-001\",\"comment\":\"bootnode-azure-brazilsouth-001\"},{\"ip\":\"52.231.165.108\",\"port\":30303,\"id\":\"715171f50508aba88aecd1250af392a45a330af91d7b90701c436b618c86aaa1589c9184561907bebbb56439b8f8787bc01f49a7c77276c58c1b09822d75e8e8\",\"location\":\"koreasouth-001\",\"comment\":\"bootnode-azure-koreasouth-001\"},{\"ip\":\"104.42.217.25\",\"port\":30303,\"id\":\"5d6d7cd20d6da4bb83a1d28cadb5d409b64edf314c0335df658c1a54e32c7c4a7ab7823d57c39b6a757556e68ff1df17c748b698544a55cb488b52479a92b60f\",\"location\":\"westus-001\",\"comment\":\"bootnode-azure-westus-001\"}],\"dnsNetworks\":[\"enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.mainnet.ethdisco.net\"]}");

});

parcelRegister("9llx6", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"ropsten\",\"chainId\":3,\"networkId\":3,\"defaultHardfork\":\"istanbul\",\"consensus\":{\"type\":\"pow\",\"algorithm\":\"ethash\",\"ethash\":{}},\"comment\":\"PoW test network\",\"url\":\"https://github.com/ethereum/ropsten\",\"genesis\":{\"hash\":\"0x41941023680923e0fe4d74a34bdac8141f2540e3ae90623718e47d66d1ca4a2d\",\"timestamp\":null,\"gasLimit\":16777216,\"difficulty\":1048576,\"nonce\":\"0x0000000000000042\",\"extraData\":\"0x3535353535353535353535353535353535353535353535353535353535353535\",\"stateRoot\":\"0x217b0bbcfb72e2d57e28f33cb361b9983513177755dc3f33ce3e7022ed62b77b\"},\"hardforks\":[{\"name\":\"chainstart\",\"block\":0,\"forkHash\":\"0x30c7ddbc\"},{\"name\":\"homestead\",\"block\":0,\"forkHash\":\"0x30c7ddbc\"},{\"name\":\"tangerineWhistle\",\"block\":0,\"forkHash\":\"0x30c7ddbc\"},{\"name\":\"spuriousDragon\",\"block\":10,\"forkHash\":\"0x63760190\"},{\"name\":\"byzantium\",\"block\":1700000,\"forkHash\":\"0x3ea159c7\"},{\"name\":\"constantinople\",\"block\":4230000,\"forkHash\":\"0x97b544f3\"},{\"name\":\"petersburg\",\"block\":4939394,\"forkHash\":\"0xd6e2149b\"},{\"name\":\"istanbul\",\"block\":6485846,\"forkHash\":\"0x4bc66396\"},{\"name\":\"muirGlacier\",\"block\":7117117,\"forkHash\":\"0x6727ef90\"},{\"name\":\"berlin\",\"block\":9812189,\"forkHash\":\"0xa157d377\"},{\"name\":\"london\",\"block\":10499401,\"forkHash\":\"0x7119b6b3\"},{\"name\":\"merge\",\"block\":null,\"forkHash\":null},{\"name\":\"shanghai\",\"block\":null,\"forkHash\":null}],\"bootstrapNodes\":[{\"ip\":\"52.176.7.10\",\"port\":30303,\"id\":\"30b7ab30a01c124a6cceca36863ece12c4f5fa68e3ba9b0b51407ccc002eeed3b3102d20a88f1c1d3c3154e2449317b8ef95090e77b312d5cc39354f86d5d606\",\"location\":\"\",\"comment\":\"US-Azure geth\"},{\"ip\":\"52.176.100.77\",\"port\":30303,\"id\":\"865a63255b3bb68023b6bffd5095118fcc13e79dcf014fe4e47e065c350c7cc72af2e53eff895f11ba1bbb6a2b33271c1116ee870f266618eadfc2e78aa7349c\",\"location\":\"\",\"comment\":\"US-Azure parity\"},{\"ip\":\"52.232.243.152\",\"port\":30303,\"id\":\"6332792c4a00e3e4ee0926ed89e0d27ef985424d97b6a45bf0f23e51f0dcb5e66b875777506458aea7af6f9e4ffb69f43f3778ee73c81ed9d34c51c4b16b0b0f\",\"location\":\"\",\"comment\":\"Parity\"},{\"ip\":\"192.81.208.223\",\"port\":30303,\"id\":\"94c15d1b9e2fe7ce56e458b9a3b672ef11894ddedd0c6f247e0f1d3487f52b66208fb4aeb8179fce6e3a749ea93ed147c37976d67af557508d199d9594c35f09\",\"location\":\"\",\"comment\":\"@gpip\"}],\"dnsNetworks\":[\"enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.ropsten.ethdisco.net\"]}");

});

parcelRegister("2vVZR", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"rinkeby\",\"chainId\":4,\"networkId\":4,\"defaultHardfork\":\"istanbul\",\"consensus\":{\"type\":\"poa\",\"algorithm\":\"clique\",\"clique\":{\"period\":15,\"epoch\":30000}},\"comment\":\"PoA test network\",\"url\":\"https://www.rinkeby.io\",\"genesis\":{\"hash\":\"0x6341fd3daf94b748c72ced5a5b26028f2474f5f00d824504e4fa37a75767e177\",\"timestamp\":\"0x58ee40ba\",\"gasLimit\":4700000,\"difficulty\":1,\"nonce\":\"0x0000000000000000\",\"extraData\":\"0x52657370656374206d7920617574686f7269746168207e452e436172746d616e42eb768f2244c8811c63729a21a3569731535f067ffc57839b00206d1ad20c69a1981b489f772031b279182d99e65703f0076e4812653aab85fca0f00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"stateRoot\":\"0x53580584816f617295ea26c0e17641e0120cab2f0a8ffb53a866fd53aa8e8c2d\"},\"hardforks\":[{\"name\":\"chainstart\",\"block\":0,\"forkHash\":\"0x3b8e0691\"},{\"name\":\"homestead\",\"block\":1,\"forkHash\":\"0x60949295\"},{\"name\":\"tangerineWhistle\",\"block\":2,\"forkHash\":\"0x8bde40dd\"},{\"name\":\"spuriousDragon\",\"block\":3,\"forkHash\":\"0xcb3a64bb\"},{\"name\":\"byzantium\",\"block\":1035301,\"forkHash\":\"0x8d748b57\"},{\"name\":\"constantinople\",\"block\":3660663,\"forkHash\":\"0xe49cab14\"},{\"name\":\"petersburg\",\"block\":4321234,\"forkHash\":\"0xafec6b27\"},{\"name\":\"istanbul\",\"block\":5435345,\"forkHash\":\"0xcbdb8838\"},{\"name\":\"berlin\",\"block\":8290928,\"forkHash\":\"0x6910c8bd\"},{\"name\":\"london\",\"block\":8897988,\"forkHash\":\"0x8e29f2f3\"},{\"name\":\"merge\",\"block\":null,\"forkHash\":null},{\"name\":\"shanghai\",\"block\":null,\"forkHash\":null}],\"bootstrapNodes\":[{\"ip\":\"52.169.42.101\",\"port\":30303,\"id\":\"a24ac7c5484ef4ed0c5eb2d36620ba4e4aa13b8c84684e1b4aab0cebea2ae45cb4d375b77eab56516d34bfbd3c1a833fc51296ff084b770b94fb9028c4d25ccf\",\"location\":\"\",\"comment\":\"IE\"},{\"ip\":\"52.3.158.184\",\"port\":30303,\"id\":\"343149e4feefa15d882d9fe4ac7d88f885bd05ebb735e547f12e12080a9fa07c8014ca6fd7f373123488102fe5e34111f8509cf0b7de3f5b44339c9f25e87cb8\",\"location\":\"\",\"comment\":\"INFURA\"},{\"ip\":\"159.89.28.211\",\"port\":30303,\"id\":\"b6b28890b006743680c52e64e0d16db57f28124885595fa03a562be1d2bf0f3a1da297d56b13da25fb992888fd556d4c1a27b1f39d531bde7de1921c90061cc6\",\"location\":\"\",\"comment\":\"AKASHA\"}],\"dnsNetworks\":[\"enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.rinkeby.ethdisco.net\"]}");

});

parcelRegister("3yRux", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"kovan\",\"chainId\":42,\"networkId\":42,\"defaultHardfork\":\"istanbul\",\"consensus\":{\"type\":\"poa\",\"algorithm\":\"aura\",\"aura\":{}},\"comment\":\"Parity PoA test network\",\"url\":\"https://kovan-testnet.github.io/website/\",\"genesis\":{\"hash\":\"0xa3c565fc15c7478862d50ccd6561e3c06b24cc509bf388941c25ea985ce32cb9\",\"timestamp\":null,\"gasLimit\":6000000,\"difficulty\":131072,\"nonce\":\"0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"extraData\":\"0x\",\"stateRoot\":\"0x2480155b48a1cea17d67dbfdfaafe821c1d19cdd478c5358e8ec56dec24502b2\"},\"hardforks\":[{\"name\":\"chainstart\",\"block\":0,\"forkHash\":\"0x010ffe56\"},{\"name\":\"homestead\",\"block\":0,\"forkHash\":\"0x010ffe56\"},{\"name\":\"tangerineWhistle\",\"block\":0,\"forkHash\":\"0x010ffe56\"},{\"name\":\"spuriousDragon\",\"block\":0,\"forkHash\":\"0x010ffe56\"},{\"name\":\"byzantium\",\"block\":5067000,\"forkHash\":\"0x7f83c620\"},{\"name\":\"constantinople\",\"block\":9200000,\"forkHash\":\"0xa94e3dc4\"},{\"name\":\"petersburg\",\"block\":10255201,\"forkHash\":\"0x186874aa\"},{\"name\":\"istanbul\",\"block\":14111141,\"forkHash\":\"0x7f6599a6\"},{\"name\":\"berlin\",\"block\":null,\"forkHash\":null},{\"name\":\"london\",\"block\":null,\"forkHash\":null},{\"name\":\"merge\",\"block\":null,\"forkHash\":null},{\"name\":\"shanghai\",\"block\":null,\"forkHash\":null}],\"bootstrapNodes\":[{\"ip\":\"116.203.116.241\",\"port\":30303,\"id\":\"16898006ba2cd4fa8bf9a3dfe32684c178fa861df144bfc21fe800dc4838a03e342056951fa9fd533dcb0be1219e306106442ff2cf1f7e9f8faa5f2fc1a3aa45\",\"location\":\"\",\"comment\":\"1\"},{\"ip\":\"3.217.96.11\",\"port\":30303,\"id\":\"2909846f78c37510cc0e306f185323b83bb2209e5ff4fdd279d93c60e3f365e3c6e62ad1d2133ff11f9fd6d23ad9c3dad73bb974d53a22f7d1ac5b7dea79d0b0\",\"location\":\"\",\"comment\":\"2\"},{\"ip\":\"108.61.170.124\",\"port\":30303,\"id\":\"740e1c8ea64e71762c71a463a04e2046070a0c9394fcab5891d41301dc473c0cff00ebab5a9bc87fbcb610ab98ac18225ff897bc8b7b38def5975d5ceb0a7d7c\",\"location\":\"\",\"comment\":\"3\"},{\"ip\":\"157.230.31.163\",\"port\":30303,\"id\":\"2909846f78c37510cc0e306f185323b83bb2209e5ff4fdd279d93c60e3f365e3c6e62ad1d2133ff11f9fd6d23ad9c3dad73bb974d53a22f7d1ac5b7dea79d0b0\",\"location\":\"\",\"comment\":\"4\"}]}");

});

parcelRegister("6aXGp", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"goerli\",\"chainId\":5,\"networkId\":5,\"defaultHardfork\":\"istanbul\",\"consensus\":{\"type\":\"poa\",\"algorithm\":\"clique\",\"clique\":{\"period\":15,\"epoch\":30000}},\"comment\":\"Cross-client PoA test network\",\"url\":\"https://github.com/goerli/testnet\",\"genesis\":{\"hash\":\"0xbf7e331f7f7c1dd2e05159666b3bf8bc7a8a3a9eb1d518969eab529dd9b88c1a\",\"timestamp\":\"0x5c51a607\",\"gasLimit\":10485760,\"difficulty\":1,\"nonce\":\"0x0000000000000000\",\"extraData\":\"0x22466c6578692069732061207468696e6722202d204166726900000000000000e0a2bd4258d2768837baa26a28fe71dc079f84c70000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"stateRoot\":\"0x5d6cded585e73c4e322c30c2f782a336316f17dd85a4863b9d838d2d4b8b3008\"},\"hardforks\":[{\"name\":\"chainstart\",\"block\":0,\"forkHash\":\"0xa3f5ab08\"},{\"name\":\"homestead\",\"block\":0,\"forkHash\":\"0xa3f5ab08\"},{\"name\":\"tangerineWhistle\",\"block\":0,\"forkHash\":\"0xa3f5ab08\"},{\"name\":\"spuriousDragon\",\"block\":0,\"forkHash\":\"0xa3f5ab08\"},{\"name\":\"byzantium\",\"block\":0,\"forkHash\":\"0xa3f5ab08\"},{\"name\":\"constantinople\",\"block\":0,\"forkHash\":\"0xa3f5ab08\"},{\"name\":\"petersburg\",\"block\":0,\"forkHash\":\"0xa3f5ab08\"},{\"name\":\"istanbul\",\"block\":1561651,\"forkHash\":\"0xc25efa5c\"},{\"name\":\"berlin\",\"block\":4460644,\"forkHash\":\"0x757a1c47\"},{\"name\":\"london\",\"block\":5062605,\"forkHash\":\"0xb8c6299d\"},{\"name\":\"merge\",\"block\":null,\"forkHash\":null},{\"name\":\"shanghai\",\"block\":null,\"forkHash\":null}],\"bootstrapNodes\":[{\"ip\":\"51.141.78.53\",\"port\":30303,\"id\":\"011f758e6552d105183b1761c5e2dea0111bc20fd5f6422bc7f91e0fabbec9a6595caf6239b37feb773dddd3f87240d99d859431891e4a642cf2a0a9e6cbb98a\",\"location\":\"\",\"comment\":\"Upstream bootnode 1\"},{\"ip\":\"13.93.54.137\",\"port\":30303,\"id\":\"176b9417f511d05b6b2cf3e34b756cf0a7096b3094572a8f6ef4cdcb9d1f9d00683bf0f83347eebdf3b81c3521c2332086d9592802230bf528eaf606a1d9677b\",\"location\":\"\",\"comment\":\"Upstream bootnode 2\"},{\"ip\":\"94.237.54.114\",\"port\":30313,\"id\":\"46add44b9f13965f7b9875ac6b85f016f341012d84f975377573800a863526f4da19ae2c620ec73d11591fa9510e992ecc03ad0751f53cc02f7c7ed6d55c7291\",\"location\":\"\",\"comment\":\"Upstream bootnode 3\"},{\"ip\":\"18.218.250.66\",\"port\":30313,\"id\":\"b5948a2d3e9d486c4d75bf32713221c2bd6cf86463302339299bd227dc2e276cd5a1c7ca4f43a0e9122fe9af884efed563bd2a1fd28661f3b5f5ad7bf1de5949\",\"location\":\"\",\"comment\":\"Upstream bootnode 4\"},{\"ip\":\"3.11.147.67\",\"port\":30303,\"id\":\"a61215641fb8714a373c80edbfa0ea8878243193f57c96eeb44d0bc019ef295abd4e044fd619bfc4c59731a73fb79afe84e9ab6da0c743ceb479cbb6d263fa91\",\"location\":\"\",\"comment\":\"Ethereum Foundation bootnode\"},{\"ip\":\"51.15.116.226\",\"port\":30303,\"id\":\"a869b02cec167211fb4815a82941db2e7ed2936fd90e78619c53eb17753fcf0207463e3419c264e2a1dd8786de0df7e68cf99571ab8aeb7c4e51367ef186b1dd\",\"location\":\"\",\"comment\":\"Goerli Initiative bootnode\"},{\"ip\":\"51.15.119.157\",\"port\":30303,\"id\":\"807b37ee4816ecf407e9112224494b74dd5933625f655962d892f2f0f02d7fbbb3e2a94cf87a96609526f30c998fd71e93e2f53015c558ffc8b03eceaf30ee33\",\"location\":\"\",\"comment\":\"Goerli Initiative bootnode\"},{\"ip\":\"51.15.119.157\",\"port\":40303,\"id\":\"a59e33ccd2b3e52d578f1fbd70c6f9babda2650f0760d6ff3b37742fdcdfdb3defba5d56d315b40c46b70198c7621e63ffa3f987389c7118634b0fefbbdfa7fd\",\"location\":\"\",\"comment\":\"Goerli Initiative bootnode\"}],\"dnsNetworks\":[\"enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.goerli.ethdisco.net\"]}");

});


parcelRegister("hvgll", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hardforks = void 0;















module.exports.hardforks = [
    [
        'chainstart',
        (parcelRequire("bOvCw"))
    ],
    [
        'homestead',
        (parcelRequire("lp6eL"))
    ],
    [
        'dao',
        (parcelRequire("2q0Mo"))
    ],
    [
        'tangerineWhistle',
        (parcelRequire("1RP41"))
    ],
    [
        'spuriousDragon',
        (parcelRequire("74eRB"))
    ],
    [
        'byzantium',
        (parcelRequire("befHk"))
    ],
    [
        'constantinople',
        (parcelRequire("aTJem"))
    ],
    [
        'petersburg',
        (parcelRequire("6Cjzd"))
    ],
    [
        'istanbul',
        (parcelRequire("eqZtt"))
    ],
    [
        'muirGlacier',
        (parcelRequire("9iOv6"))
    ],
    [
        'berlin',
        (parcelRequire("kppXm"))
    ],
    [
        'london',
        (parcelRequire("bfvGx"))
    ],
    [
        'shanghai',
        (parcelRequire("kMsNp"))
    ],
    [
        'arrowGlacier',
        (parcelRequire("7I74T"))
    ],
    [
        'merge',
        (parcelRequire("hHwCw"))
    ]
];

});
parcelRegister("bOvCw", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"chainstart\",\"comment\":\"Start of the Ethereum main chain\",\"url\":\"\",\"status\":\"\",\"gasConfig\":{\"minGasLimit\":{\"v\":5000,\"d\":\"Minimum the gas limit may ever be\"},\"gasLimitBoundDivisor\":{\"v\":1024,\"d\":\"The bound divisor of the gas limit, used in update calculations\"},\"maxRefundQuotient\":{\"v\":2,\"d\":\"Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)\"}},\"gasPrices\":{\"base\":{\"v\":2,\"d\":\"Gas base cost, used e.g. for ChainID opcode (Istanbul)\"},\"tierStep\":{\"v\":[0,2,3,5,8,10,20],\"d\":\"Once per operation, for a selection of them\"},\"exp\":{\"v\":10,\"d\":\"Base fee of the EXP opcode\"},\"expByte\":{\"v\":10,\"d\":\"Times ceil(log256(exponent)) for the EXP instruction\"},\"sha3\":{\"v\":30,\"d\":\"Base fee of the SHA3 opcode\"},\"sha3Word\":{\"v\":6,\"d\":\"Once per word of the SHA3 operation's data\"},\"sload\":{\"v\":50,\"d\":\"Base fee of the SLOAD opcode\"},\"sstoreSet\":{\"v\":20000,\"d\":\"Once per SSTORE operation if the zeroness changes from zero\"},\"sstoreReset\":{\"v\":5000,\"d\":\"Once per SSTORE operation if the zeroness does not change from zero\"},\"sstoreRefund\":{\"v\":15000,\"d\":\"Once per SSTORE operation if the zeroness changes to zero\"},\"jumpdest\":{\"v\":1,\"d\":\"Base fee of the JUMPDEST opcode\"},\"log\":{\"v\":375,\"d\":\"Base fee of the LOG opcode\"},\"logData\":{\"v\":8,\"d\":\"Per byte in a LOG* operation's data\"},\"logTopic\":{\"v\":375,\"d\":\"Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas\"},\"create\":{\"v\":32000,\"d\":\"Base fee of the CREATE opcode\"},\"call\":{\"v\":40,\"d\":\"Base fee of the CALL opcode\"},\"callStipend\":{\"v\":2300,\"d\":\"Free gas given at beginning of call\"},\"callValueTransfer\":{\"v\":9000,\"d\":\"Paid for CALL when the value transfor is non-zero\"},\"callNewAccount\":{\"v\":25000,\"d\":\"Paid for CALL when the destination address didn't exist prior\"},\"selfdestructRefund\":{\"v\":24000,\"d\":\"Refunded following a selfdestruct operation\"},\"memory\":{\"v\":3,\"d\":\"Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL\"},\"quadCoeffDiv\":{\"v\":512,\"d\":\"Divisor for the quadratic particle of the memory cost equation\"},\"createData\":{\"v\":200,\"d\":\"\"},\"tx\":{\"v\":21000,\"d\":\"Per transaction. NOTE: Not payable on data of calls between transactions\"},\"txCreation\":{\"v\":32000,\"d\":\"The cost of creating a contract via tx\"},\"txDataZero\":{\"v\":4,\"d\":\"Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions\"},\"txDataNonZero\":{\"v\":68,\"d\":\"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions\"},\"copy\":{\"v\":3,\"d\":\"Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added\"},\"ecRecover\":{\"v\":3000,\"d\":\"\"},\"sha256\":{\"v\":60,\"d\":\"\"},\"sha256Word\":{\"v\":12,\"d\":\"\"},\"ripemd160\":{\"v\":600,\"d\":\"\"},\"ripemd160Word\":{\"v\":120,\"d\":\"\"},\"identity\":{\"v\":15,\"d\":\"\"},\"identityWord\":{\"v\":3,\"d\":\"\"},\"stop\":{\"v\":0,\"d\":\"Base fee of the STOP opcode\"},\"add\":{\"v\":3,\"d\":\"Base fee of the ADD opcode\"},\"mul\":{\"v\":5,\"d\":\"Base fee of the MUL opcode\"},\"sub\":{\"v\":3,\"d\":\"Base fee of the SUB opcode\"},\"div\":{\"v\":5,\"d\":\"Base fee of the DIV opcode\"},\"sdiv\":{\"v\":5,\"d\":\"Base fee of the SDIV opcode\"},\"mod\":{\"v\":5,\"d\":\"Base fee of the MOD opcode\"},\"smod\":{\"v\":5,\"d\":\"Base fee of the SMOD opcode\"},\"addmod\":{\"v\":8,\"d\":\"Base fee of the ADDMOD opcode\"},\"mulmod\":{\"v\":8,\"d\":\"Base fee of the MULMOD opcode\"},\"signextend\":{\"v\":5,\"d\":\"Base fee of the SIGNEXTEND opcode\"},\"lt\":{\"v\":3,\"d\":\"Base fee of the LT opcode\"},\"gt\":{\"v\":3,\"d\":\"Base fee of the GT opcode\"},\"slt\":{\"v\":3,\"d\":\"Base fee of the SLT opcode\"},\"sgt\":{\"v\":3,\"d\":\"Base fee of the SGT opcode\"},\"eq\":{\"v\":3,\"d\":\"Base fee of the EQ opcode\"},\"iszero\":{\"v\":3,\"d\":\"Base fee of the ISZERO opcode\"},\"and\":{\"v\":3,\"d\":\"Base fee of the AND opcode\"},\"or\":{\"v\":3,\"d\":\"Base fee of the OR opcode\"},\"xor\":{\"v\":3,\"d\":\"Base fee of the XOR opcode\"},\"not\":{\"v\":3,\"d\":\"Base fee of the NOT opcode\"},\"byte\":{\"v\":3,\"d\":\"Base fee of the BYTE opcode\"},\"address\":{\"v\":2,\"d\":\"Base fee of the ADDRESS opcode\"},\"balance\":{\"v\":20,\"d\":\"Base fee of the BALANCE opcode\"},\"origin\":{\"v\":2,\"d\":\"Base fee of the ORIGIN opcode\"},\"caller\":{\"v\":2,\"d\":\"Base fee of the CALLER opcode\"},\"callvalue\":{\"v\":2,\"d\":\"Base fee of the CALLVALUE opcode\"},\"calldataload\":{\"v\":3,\"d\":\"Base fee of the CALLDATALOAD opcode\"},\"calldatasize\":{\"v\":2,\"d\":\"Base fee of the CALLDATASIZE opcode\"},\"calldatacopy\":{\"v\":3,\"d\":\"Base fee of the CALLDATACOPY opcode\"},\"codesize\":{\"v\":2,\"d\":\"Base fee of the CODESIZE opcode\"},\"codecopy\":{\"v\":3,\"d\":\"Base fee of the CODECOPY opcode\"},\"gasprice\":{\"v\":2,\"d\":\"Base fee of the GASPRICE opcode\"},\"extcodesize\":{\"v\":20,\"d\":\"Base fee of the EXTCODESIZE opcode\"},\"extcodecopy\":{\"v\":20,\"d\":\"Base fee of the EXTCODECOPY opcode\"},\"blockhash\":{\"v\":20,\"d\":\"Base fee of the BLOCKHASH opcode\"},\"coinbase\":{\"v\":2,\"d\":\"Base fee of the COINBASE opcode\"},\"timestamp\":{\"v\":2,\"d\":\"Base fee of the TIMESTAMP opcode\"},\"number\":{\"v\":2,\"d\":\"Base fee of the NUMBER opcode\"},\"difficulty\":{\"v\":2,\"d\":\"Base fee of the DIFFICULTY opcode\"},\"gaslimit\":{\"v\":2,\"d\":\"Base fee of the GASLIMIT opcode\"},\"pop\":{\"v\":2,\"d\":\"Base fee of the POP opcode\"},\"mload\":{\"v\":3,\"d\":\"Base fee of the MLOAD opcode\"},\"mstore\":{\"v\":3,\"d\":\"Base fee of the MSTORE opcode\"},\"mstore8\":{\"v\":3,\"d\":\"Base fee of the MSTORE8 opcode\"},\"sstore\":{\"v\":0,\"d\":\"Base fee of the SSTORE opcode\"},\"jump\":{\"v\":8,\"d\":\"Base fee of the JUMP opcode\"},\"jumpi\":{\"v\":10,\"d\":\"Base fee of the JUMPI opcode\"},\"pc\":{\"v\":2,\"d\":\"Base fee of the PC opcode\"},\"msize\":{\"v\":2,\"d\":\"Base fee of the MSIZE opcode\"},\"gas\":{\"v\":2,\"d\":\"Base fee of the GAS opcode\"},\"push\":{\"v\":3,\"d\":\"Base fee of the PUSH opcode\"},\"dup\":{\"v\":3,\"d\":\"Base fee of the DUP opcode\"},\"swap\":{\"v\":3,\"d\":\"Base fee of the SWAP opcode\"},\"callcode\":{\"v\":40,\"d\":\"Base fee of the CALLCODE opcode\"},\"return\":{\"v\":0,\"d\":\"Base fee of the RETURN opcode\"},\"invalid\":{\"v\":0,\"d\":\"Base fee of the INVALID opcode\"},\"selfdestruct\":{\"v\":0,\"d\":\"Base fee of the SELFDESTRUCT opcode\"}},\"vm\":{\"stackLimit\":{\"v\":1024,\"d\":\"Maximum size of VM stack allowed\"},\"callCreateDepth\":{\"v\":1024,\"d\":\"Maximum depth of call/create stack\"},\"maxExtraDataSize\":{\"v\":32,\"d\":\"Maximum size extra data may be after Genesis\"}},\"pow\":{\"minimumDifficulty\":{\"v\":131072,\"d\":\"The minimum that the difficulty may ever be\"},\"difficultyBoundDivisor\":{\"v\":2048,\"d\":\"The bound divisor of the difficulty, used in the update calculations\"},\"durationLimit\":{\"v\":13,\"d\":\"The decision boundary on the blocktime duration used to determine whether difficulty should go up or not\"},\"epochDuration\":{\"v\":30000,\"d\":\"Duration between proof-of-work epochs\"},\"timebombPeriod\":{\"v\":100000,\"d\":\"Exponential difficulty timebomb period\"},\"minerReward\":{\"v\":\"5000000000000000000\",\"d\":\"the amount a miner get rewarded for mining a block\"},\"difficultyBombDelay\":{\"v\":0,\"d\":\"the amount of blocks to delay the difficulty bomb with\"}}}");

});

parcelRegister("lp6eL", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"homestead\",\"comment\":\"Homestead hardfork with protocol and network changes\",\"url\":\"https://eips.ethereum.org/EIPS/eip-606\",\"status\":\"Final\",\"gasConfig\":{},\"gasPrices\":{\"delegatecall\":{\"v\":40,\"d\":\"Base fee of the DELEGATECALL opcode\"}},\"vm\":{},\"pow\":{}}");

});

parcelRegister("2q0Mo", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"dao\",\"comment\":\"DAO rescue hardfork\",\"url\":\"https://eips.ethereum.org/EIPS/eip-779\",\"status\":\"Final\",\"gasConfig\":{},\"gasPrices\":{},\"vm\":{},\"pow\":{}}");

});

parcelRegister("1RP41", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"tangerineWhistle\",\"comment\":\"Hardfork with gas cost changes for IO-heavy operations\",\"url\":\"https://eips.ethereum.org/EIPS/eip-608\",\"status\":\"Final\",\"gasConfig\":{},\"gasPrices\":{\"sload\":{\"v\":200,\"d\":\"Once per SLOAD operation\"},\"call\":{\"v\":700,\"d\":\"Once per CALL operation & message call transaction\"},\"extcodesize\":{\"v\":700,\"d\":\"Base fee of the EXTCODESIZE opcode\"},\"extcodecopy\":{\"v\":700,\"d\":\"Base fee of the EXTCODECOPY opcode\"},\"balance\":{\"v\":400,\"d\":\"Base fee of the BALANCE opcode\"},\"delegatecall\":{\"v\":700,\"d\":\"Base fee of the DELEGATECALL opcode\"},\"callcode\":{\"v\":700,\"d\":\"Base fee of the CALLCODE opcode\"},\"selfdestruct\":{\"v\":5000,\"d\":\"Base fee of the SELFDESTRUCT opcode\"}},\"vm\":{},\"pow\":{}}");

});

parcelRegister("74eRB", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"spuriousDragon\",\"comment\":\"HF with EIPs for simple replay attack protection, EXP cost increase, state trie clearing, contract code size limit\",\"url\":\"https://eips.ethereum.org/EIPS/eip-607\",\"status\":\"Final\",\"gasConfig\":{},\"gasPrices\":{\"expByte\":{\"v\":50,\"d\":\"Times ceil(log256(exponent)) for the EXP instruction\"}},\"vm\":{\"maxCodeSize\":{\"v\":24576,\"d\":\"Maximum length of contract code\"}},\"pow\":{}}");

});

parcelRegister("befHk", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"byzantium\",\"comment\":\"Hardfork with new precompiles, instructions and other protocol changes\",\"url\":\"https://eips.ethereum.org/EIPS/eip-609\",\"status\":\"Final\",\"gasConfig\":{},\"gasPrices\":{\"modexpGquaddivisor\":{\"v\":20,\"d\":\"Gquaddivisor from modexp precompile for gas calculation\"},\"ecAdd\":{\"v\":500,\"d\":\"Gas costs for curve addition precompile\"},\"ecMul\":{\"v\":40000,\"d\":\"Gas costs for curve multiplication precompile\"},\"ecPairing\":{\"v\":100000,\"d\":\"Base gas costs for curve pairing precompile\"},\"ecPairingWord\":{\"v\":80000,\"d\":\"Gas costs regarding curve pairing precompile input length\"},\"revert\":{\"v\":0,\"d\":\"Base fee of the REVERT opcode\"},\"staticcall\":{\"v\":700,\"d\":\"Base fee of the STATICCALL opcode\"},\"returndatasize\":{\"v\":2,\"d\":\"Base fee of the RETURNDATASIZE opcode\"},\"returndatacopy\":{\"v\":3,\"d\":\"Base fee of the RETURNDATACOPY opcode\"}},\"vm\":{},\"pow\":{\"minerReward\":{\"v\":\"3000000000000000000\",\"d\":\"the amount a miner get rewarded for mining a block\"},\"difficultyBombDelay\":{\"v\":3000000,\"d\":\"the amount of blocks to delay the difficulty bomb with\"}}}");

});

parcelRegister("aTJem", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"constantinople\",\"comment\":\"Postponed hardfork including EIP-1283 (SSTORE gas metering changes)\",\"url\":\"https://eips.ethereum.org/EIPS/eip-1013\",\"status\":\"Final\",\"gasConfig\":{},\"gasPrices\":{\"netSstoreNoopGas\":{\"v\":200,\"d\":\"Once per SSTORE operation if the value doesn't change\"},\"netSstoreInitGas\":{\"v\":20000,\"d\":\"Once per SSTORE operation from clean zero\"},\"netSstoreCleanGas\":{\"v\":5000,\"d\":\"Once per SSTORE operation from clean non-zero\"},\"netSstoreDirtyGas\":{\"v\":200,\"d\":\"Once per SSTORE operation from dirty\"},\"netSstoreClearRefund\":{\"v\":15000,\"d\":\"Once per SSTORE operation for clearing an originally existing storage slot\"},\"netSstoreResetRefund\":{\"v\":4800,\"d\":\"Once per SSTORE operation for resetting to the original non-zero value\"},\"netSstoreResetClearRefund\":{\"v\":19800,\"d\":\"Once per SSTORE operation for resetting to the original zero value\"},\"shl\":{\"v\":3,\"d\":\"Base fee of the SHL opcode\"},\"shr\":{\"v\":3,\"d\":\"Base fee of the SHR opcode\"},\"sar\":{\"v\":3,\"d\":\"Base fee of the SAR opcode\"},\"extcodehash\":{\"v\":400,\"d\":\"Base fee of the EXTCODEHASH opcode\"},\"create2\":{\"v\":32000,\"d\":\"Base fee of the CREATE2 opcode\"}},\"vm\":{},\"pow\":{\"minerReward\":{\"v\":\"2000000000000000000\",\"d\":\"The amount a miner gets rewarded for mining a block\"},\"difficultyBombDelay\":{\"v\":5000000,\"d\":\"the amount of blocks to delay the difficulty bomb with\"}}}");

});

parcelRegister("6Cjzd", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"petersburg\",\"comment\":\"Aka constantinopleFix, removes EIP-1283, activate together with or after constantinople\",\"url\":\"https://eips.ethereum.org/EIPS/eip-1716\",\"status\":\"Draft\",\"gasConfig\":{},\"gasPrices\":{\"netSstoreNoopGas\":{\"v\":null,\"d\":\"Removed along EIP-1283\"},\"netSstoreInitGas\":{\"v\":null,\"d\":\"Removed along EIP-1283\"},\"netSstoreCleanGas\":{\"v\":null,\"d\":\"Removed along EIP-1283\"},\"netSstoreDirtyGas\":{\"v\":null,\"d\":\"Removed along EIP-1283\"},\"netSstoreClearRefund\":{\"v\":null,\"d\":\"Removed along EIP-1283\"},\"netSstoreResetRefund\":{\"v\":null,\"d\":\"Removed along EIP-1283\"},\"netSstoreResetClearRefund\":{\"v\":null,\"d\":\"Removed along EIP-1283\"}},\"vm\":{},\"pow\":{}}");

});

parcelRegister("eqZtt", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"istanbul\",\"comment\":\"HF targeted for December 2019 following the Constantinople/Petersburg HF\",\"url\":\"https://eips.ethereum.org/EIPS/eip-1679\",\"status\":\"Draft\",\"gasConfig\":{},\"gasPrices\":{\"blake2Round\":{\"v\":1,\"d\":\"Gas cost per round for the Blake2 F precompile\"},\"ecAdd\":{\"v\":150,\"d\":\"Gas costs for curve addition precompile\"},\"ecMul\":{\"v\":6000,\"d\":\"Gas costs for curve multiplication precompile\"},\"ecPairing\":{\"v\":45000,\"d\":\"Base gas costs for curve pairing precompile\"},\"ecPairingWord\":{\"v\":34000,\"d\":\"Gas costs regarding curve pairing precompile input length\"},\"txDataNonZero\":{\"v\":16,\"d\":\"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions\"},\"sstoreSentryGasEIP2200\":{\"v\":2300,\"d\":\"Minimum gas required to be present for an SSTORE call, not consumed\"},\"sstoreNoopGasEIP2200\":{\"v\":800,\"d\":\"Once per SSTORE operation if the value doesn't change\"},\"sstoreDirtyGasEIP2200\":{\"v\":800,\"d\":\"Once per SSTORE operation if a dirty value is changed\"},\"sstoreInitGasEIP2200\":{\"v\":20000,\"d\":\"Once per SSTORE operation from clean zero to non-zero\"},\"sstoreInitRefundEIP2200\":{\"v\":19200,\"d\":\"Once per SSTORE operation for resetting to the original zero value\"},\"sstoreCleanGasEIP2200\":{\"v\":5000,\"d\":\"Once per SSTORE operation from clean non-zero to something else\"},\"sstoreCleanRefundEIP2200\":{\"v\":4200,\"d\":\"Once per SSTORE operation for resetting to the original non-zero value\"},\"sstoreClearRefundEIP2200\":{\"v\":15000,\"d\":\"Once per SSTORE operation for clearing an originally existing storage slot\"},\"balance\":{\"v\":700,\"d\":\"Base fee of the BALANCE opcode\"},\"extcodehash\":{\"v\":700,\"d\":\"Base fee of the EXTCODEHASH opcode\"},\"chainid\":{\"v\":2,\"d\":\"Base fee of the CHAINID opcode\"},\"selfbalance\":{\"v\":5,\"d\":\"Base fee of the SELFBALANCE opcode\"},\"sload\":{\"v\":800,\"d\":\"Base fee of the SLOAD opcode\"}},\"vm\":{},\"pow\":{}}");

});

parcelRegister("9iOv6", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"muirGlacier\",\"comment\":\"HF to delay the difficulty bomb\",\"url\":\"https://eips.ethereum.org/EIPS/eip-2384\",\"status\":\"Final\",\"gasConfig\":{},\"gasPrices\":{},\"vm\":{},\"pow\":{\"difficultyBombDelay\":{\"v\":9000000,\"d\":\"the amount of blocks to delay the difficulty bomb with\"}}}");

});

parcelRegister("kppXm", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"berlin\",\"comment\":\"HF targeted for July 2020 following the Muir Glacier HF\",\"url\":\"https://eips.ethereum.org/EIPS/eip-2070\",\"status\":\"Draft\",\"eips\":[2565,2929,2718,2930]}");

});

parcelRegister("bfvGx", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"london\",\"comment\":\"HF targeted for July 2021 following the Berlin fork\",\"url\":\"https://github.com/ethereum/eth1.0-specs/blob/master/network-upgrades/mainnet-upgrades/london.md\",\"status\":\"Draft\",\"eips\":[1559,3198,3529,3541]}");

});

parcelRegister("kMsNp", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"shanghai\",\"comment\":\"Next feature hardfork after the London HF\",\"url\":\"https://github.com/ethereum/pm/issues/356\",\"status\":\"Pre-Draft\",\"eips\":[]}");

});

parcelRegister("7I74T", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"arrowGlacier\",\"comment\":\"HF to delay the difficulty bomb\",\"url\":\"https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/arrow-glacier.md\",\"status\":\"Final\",\"eips\":[4345],\"gasConfig\":{},\"gasPrices\":{},\"vm\":{},\"pow\":{}}");

});

parcelRegister("hHwCw", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"merge\",\"comment\":\"Hardfork to upgrade the consensus mechanism to Proof-of-Stake\",\"url\":\"https://github.com/ethereum/pm/issues/361\",\"status\":\"pre-Draft\",\"consensus\":{\"type\":\"pos\",\"algorithm\":\"casper\",\"casper\":{}},\"eips\":[3675]}");

});


parcelRegister("jkA0Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EIPs = void 0;













module.exports.EIPs = {
    1559: (parcelRequire("5lhxG")),
    2315: (parcelRequire("kiVPR")),
    2537: (parcelRequire("5K41p")),
    2565: (parcelRequire("1mJqq")),
    2718: (parcelRequire("jSMcB")),
    2929: (parcelRequire("cQI70")),
    2930: (parcelRequire("dlihC")),
    3198: (parcelRequire("l59N5")),
    3529: (parcelRequire("nKJkA")),
    3541: (parcelRequire("88gkY")),
    3554: (parcelRequire("2SL9D")),
    3675: (parcelRequire("fRnx4")),
    4345: (parcelRequire("7IFPd"))
};

});
parcelRegister("5lhxG", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-1559\",\"number\":1559,\"comment\":\"Fee market change for ETH 1.0 chain\",\"url\":\"https://eips.ethereum.org/EIPS/eip-1559\",\"status\":\"Review\",\"minimumHardfork\":\"berlin\",\"requiredEIPs\":[2930],\"gasConfig\":{\"baseFeeMaxChangeDenominator\":{\"v\":8,\"d\":\"Maximum base fee change denominator\"},\"elasticityMultiplier\":{\"v\":2,\"d\":\"Maximum block gas target elasticity\"},\"initialBaseFee\":{\"v\":1000000000,\"d\":\"Initial base fee on first EIP1559 block\"}},\"gasPrices\":{},\"vm\":{},\"pow\":{}}");

});

parcelRegister("kiVPR", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-2315\",\"number\":2315,\"comment\":\"Simple subroutines for the EVM\",\"url\":\"https://eips.ethereum.org/EIPS/eip-2315\",\"status\":\"Draft\",\"minimumHardfork\":\"istanbul\",\"gasConfig\":{},\"gasPrices\":{\"beginsub\":{\"v\":2,\"d\":\"Base fee of the BEGINSUB opcode\"},\"returnsub\":{\"v\":5,\"d\":\"Base fee of the RETURNSUB opcode\"},\"jumpsub\":{\"v\":10,\"d\":\"Base fee of the JUMPSUB opcode\"}},\"vm\":{},\"pow\":{}}");

});

parcelRegister("5K41p", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-2537\",\"number\":2537,\"comment\":\"BLS12-381 precompiles\",\"url\":\"https://eips.ethereum.org/EIPS/eip-2537\",\"status\":\"Draft\",\"minimumHardfork\":\"chainstart\",\"gasConfig\":{},\"gasPrices\":{\"Bls12381G1AddGas\":{\"v\":600,\"d\":\"Gas cost of a single BLS12-381 G1 addition precompile-call\"},\"Bls12381G1MulGas\":{\"v\":12000,\"d\":\"Gas cost of a single BLS12-381 G1 multiplication precompile-call\"},\"Bls12381G2AddGas\":{\"v\":4500,\"d\":\"Gas cost of a single BLS12-381 G2 addition precompile-call\"},\"Bls12381G2MulGas\":{\"v\":55000,\"d\":\"Gas cost of a single BLS12-381 G2 multiplication precompile-call\"},\"Bls12381PairingBaseGas\":{\"v\":115000,\"d\":\"Base gas cost of BLS12-381 pairing check\"},\"Bls12381PairingPerPairGas\":{\"v\":23000,\"d\":\"Per-pair gas cost of BLS12-381 pairing check\"},\"Bls12381MapG1Gas\":{\"v\":5500,\"d\":\"Gas cost of BLS12-381 map field element to G1\"},\"Bls12381MapG2Gas\":{\"v\":110000,\"d\":\"Gas cost of BLS12-381 map field element to G2\"},\"Bls12381MultiExpGasDiscount\":{\"v\":[[1,1200],[2,888],[3,764],[4,641],[5,594],[6,547],[7,500],[8,453],[9,438],[10,423],[11,408],[12,394],[13,379],[14,364],[15,349],[16,334],[17,330],[18,326],[19,322],[20,318],[21,314],[22,310],[23,306],[24,302],[25,298],[26,294],[27,289],[28,285],[29,281],[30,277],[31,273],[32,269],[33,268],[34,266],[35,265],[36,263],[37,262],[38,260],[39,259],[40,257],[41,256],[42,254],[43,253],[44,251],[45,250],[46,248],[47,247],[48,245],[49,244],[50,242],[51,241],[52,239],[53,238],[54,236],[55,235],[56,233],[57,232],[58,231],[59,229],[60,228],[61,226],[62,225],[63,223],[64,222],[65,221],[66,220],[67,219],[68,219],[69,218],[70,217],[71,216],[72,216],[73,215],[74,214],[75,213],[76,213],[77,212],[78,211],[79,211],[80,210],[81,209],[82,208],[83,208],[84,207],[85,206],[86,205],[87,205],[88,204],[89,203],[90,202],[91,202],[92,201],[93,200],[94,199],[95,199],[96,198],[97,197],[98,196],[99,196],[100,195],[101,194],[102,193],[103,193],[104,192],[105,191],[106,191],[107,190],[108,189],[109,188],[110,188],[111,187],[112,186],[113,185],[114,185],[115,184],[116,183],[117,182],[118,182],[119,181],[120,180],[121,179],[122,179],[123,178],[124,177],[125,176],[126,176],[127,175],[128,174]],\"d\":\"Discount gas costs of calls to the MultiExp precompiles with `k` (point, scalar) pair\"}},\"vm\":{},\"pow\":{}}");

});

parcelRegister("1mJqq", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-2565\",\"number\":2565,\"comment\":\"ModExp gas cost\",\"url\":\"https://eips.ethereum.org/EIPS/eip-2565\",\"status\":\"Last call\",\"minimumHardfork\":\"byzantium\",\"gasConfig\":{},\"gasPrices\":{\"modexpGquaddivisor\":{\"v\":3,\"d\":\"Gquaddivisor from modexp precompile for gas calculation\"}},\"vm\":{},\"pow\":{}}");

});

parcelRegister("jSMcB", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-2718\",\"comment\":\"Typed Transaction Envelope\",\"url\":\"https://eips.ethereum.org/EIPS/eip-2718\",\"status\":\"Draft\",\"minimumHardfork\":\"chainstart\",\"gasConfig\":{},\"gasPrices\":{},\"vm\":{},\"pow\":{}}");

});

parcelRegister("cQI70", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-2929\",\"comment\":\"Gas cost increases for state access opcodes\",\"url\":\"https://eips.ethereum.org/EIPS/eip-2929\",\"status\":\"Draft\",\"minimumHardfork\":\"chainstart\",\"gasConfig\":{},\"gasPrices\":{\"coldsload\":{\"v\":2100,\"d\":\"Gas cost of the first read of storage from a given location (per transaction)\"},\"coldaccountaccess\":{\"v\":2600,\"d\":\"Gas cost of the first read of a given address (per transaction)\"},\"warmstorageread\":{\"v\":100,\"d\":\"Gas cost of reading storage locations which have already loaded 'cold'\"},\"sstoreCleanGasEIP2200\":{\"v\":2900,\"d\":\"Once per SSTORE operation from clean non-zero to something else\"},\"sstoreNoopGasEIP2200\":{\"v\":100,\"d\":\"Once per SSTORE operation if the value doesn't change\"},\"sstoreDirtyGasEIP2200\":{\"v\":100,\"d\":\"Once per SSTORE operation if a dirty value is changed\"},\"sstoreInitRefundEIP2200\":{\"v\":19900,\"d\":\"Once per SSTORE operation for resetting to the original zero value\"},\"sstoreCleanRefundEIP2200\":{\"v\":4900,\"d\":\"Once per SSTORE operation for resetting to the original non-zero value\"},\"call\":{\"v\":0,\"d\":\"Base fee of the CALL opcode\"},\"callcode\":{\"v\":0,\"d\":\"Base fee of the CALLCODE opcode\"},\"delegatecall\":{\"v\":0,\"d\":\"Base fee of the DELEGATECALL opcode\"},\"staticcall\":{\"v\":0,\"d\":\"Base fee of the STATICCALL opcode\"},\"balance\":{\"v\":0,\"d\":\"Base fee of the BALANCE opcode\"},\"extcodesize\":{\"v\":0,\"d\":\"Base fee of the EXTCODESIZE opcode\"},\"extcodecopy\":{\"v\":0,\"d\":\"Base fee of the EXTCODECOPY opcode\"},\"extcodehash\":{\"v\":0,\"d\":\"Base fee of the EXTCODEHASH opcode\"},\"sload\":{\"v\":0,\"d\":\"Base fee of the SLOAD opcode\"},\"sstore\":{\"v\":0,\"d\":\"Base fee of the SSTORE opcode\"}},\"vm\":{},\"pow\":{}}");

});

parcelRegister("dlihC", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-2930\",\"comment\":\"Optional access lists\",\"url\":\"https://eips.ethereum.org/EIPS/eip-2930\",\"status\":\"Draft\",\"minimumHardfork\":\"istanbul\",\"requiredEIPs\":[2718,2929],\"gasConfig\":{},\"gasPrices\":{\"accessListStorageKeyCost\":{\"v\":1900,\"d\":\"Gas cost per storage key in an Access List transaction\"},\"accessListAddressCost\":{\"v\":2400,\"d\":\"Gas cost per storage key in an Access List transaction\"}},\"vm\":{},\"pow\":{}}");

});

parcelRegister("l59N5", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-3198\",\"number\":3198,\"comment\":\"BASEFEE opcode\",\"url\":\"https://eips.ethereum.org/EIPS/eip-3198\",\"status\":\"Review\",\"minimumHardfork\":\"london\",\"gasConfig\":{},\"gasPrices\":{\"basefee\":{\"v\":2,\"d\":\"Gas cost of the BASEFEE opcode\"}},\"vm\":{},\"pow\":{}}");

});

parcelRegister("nKJkA", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-3529\",\"comment\":\"Reduction in refunds\",\"url\":\"https://eips.ethereum.org/EIPS/eip-3529\",\"status\":\"Draft\",\"minimumHardfork\":\"berlin\",\"requiredEIPs\":[2929],\"gasConfig\":{\"maxRefundQuotient\":{\"v\":5,\"d\":\"Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)\"}},\"gasPrices\":{\"selfdestructRefund\":{\"v\":0,\"d\":\"Refunded following a selfdestruct operation\"},\"sstoreClearRefundEIP2200\":{\"v\":4800,\"d\":\"Once per SSTORE operation for clearing an originally existing storage slot\"}},\"vm\":{},\"pow\":{}}");

});

parcelRegister("88gkY", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-3541\",\"comment\":\"Reject new contracts starting with the 0xEF byte\",\"url\":\"https://eips.ethereum.org/EIPS/eip-3541\",\"status\":\"Draft\",\"minimumHardfork\":\"berlin\",\"requiredEIPs\":[],\"gasConfig\":{},\"gasPrices\":{},\"vm\":{},\"pow\":{}}");

});

parcelRegister("2SL9D", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-3554\",\"comment\":\"Reduction in refunds\",\"url\":\"Difficulty Bomb Delay to December 1st 2021\",\"status\":\"Draft\",\"minimumHardfork\":\"muirGlacier\",\"requiredEIPs\":[],\"gasConfig\":{},\"gasPrices\":{},\"vm\":{},\"pow\":{\"difficultyBombDelay\":{\"v\":9500000,\"d\":\"the amount of blocks to delay the difficulty bomb with\"}}}");

});

parcelRegister("fRnx4", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-3675\",\"number\":3675,\"comment\":\"Upgrade consensus to Proof-of-Stake\",\"url\":\"https://eips.ethereum.org/EIPS/eip-3675\",\"status\":\"Draft\",\"minimumHardfork\":\"london\",\"requiredEIPs\":[],\"gasConfig\":{},\"gasPrices\":{},\"vm\":{},\"pow\":{}}");

});

parcelRegister("7IFPd", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"EIP-4345\",\"number\":4345,\"comment\":\"Difficulty Bomb Delay to June 2022\",\"url\":\"https://eips.ethereum.org/EIPS/eip-4345\",\"status\":\"Review\",\"minimumHardfork\":\"london\",\"gasConfig\":{},\"gasPrices\":{},\"vm\":{},\"pow\":{\"difficultyBombDelay\":{\"v\":10700000,\"d\":\"the amount of blocks to delay the difficulty bomb with\"}}}");

});


parcelRegister("h7v9F", function(module, exports) {
module.exports = JSON.parse("{\"0x000d836201318ec6899a67540690382780743280\":\"0xad78ebc5ac6200000\",\"0x001762430ea9c3a26e5749afdb70da5f78ddbb8c\":\"0xad78ebc5ac6200000\",\"0x001d14804b399c6ef80e64576f657660804fec0b\":\"0xe3aeb5737240a00000\",\"0x0032403587947b9f15622a68d104d54d33dbd1cd\":\"0x433874f632cc60000\",\"0x00497e92cdc0e0b963d752b2296acb87da828b24\":\"0xa8f649fe7c6180000\",\"0x004bfbe1546bc6c65b5c7eaa55304b38bbfec6d3\":\"0x6c6b935b8bbd400000\",\"0x005a9c03f69d17d66cbb8ad721008a9ebbb836fb\":\"0x6c6b935b8bbd400000\",\"0x005d0ee8155ec0a6ff6808552ca5f16bb5be323a\":\"0xaadec983fcff40000\",\"0x007622d84a234bb8b078230fcf84b67ae9a8acae\":\"0x25e1cc519952f80000\",\"0x007b9fc31905b4994b04c9e2cfdc5e2770503f42\":\"0x6c5db2a4d815dc0000\",\"0x007f4a23ca00cd043d25c2888c1aa5688f81a344\":\"0x29f0a95bfbf7290000\",\"0x008639dabbe3aeac887b5dc0e43e13bcd287d76c\":\"0x10d0e3c87d6e2c0000\",\"0x0089508679abf8c71bf6781687120e3e6a84584d\":\"0x6194049f30f7200000\",\"0x008fc7cbadffbd0d7fe44f8dfd60a79d721a1c9c\":\"0x3635c9adc5dea00000\",\"0x009560a3de627868f91fa8bfe1c1b7afaf08186b\":\"0x1c67f5f7baa0b00000\",\"0x00969747f7a5b30645fe00e44901435ace24cc37\":\"0x5c283d410394100000\",\"0x009a6d7db326679b77c90391a7476d238f3ba33e\":\"0xada55474b81340000\",\"0x009eef0a0886056e3f69211853b9b7457f3782e4\":\"0xa2a878069b28e00000\",\"0x009fdbf44e1f4a6362b769c39a475f95a96c2bc7\":\"0x1e931283ccc8500000\",\"0x00a5797f52c9d58f189f36b1d45d1bf6041f2f6b\":\"0x127d1b3461acd1a0000\",\"0x00aa5381b2138ebeffc191d5d8c391753b7098d2\":\"0x35abb09ffedeb68000\",\"0x00aada25ea2286709abb422d41923fd380cd04c7\":\"0x233df3299f61720000\",\"0x00acbfb2f25a5485c739ef70a44eeeeb7c65a66f\":\"0x56bc75e2d63100000\",\"0x00acc6f082a442828764d11f58d6894ae408f073\":\"0xcb49b44ba602d800000\",\"0x00b277b099a8e866ca0ec65bcb87284fd142a582\":\"0x6acb3df27e1f880000\",\"0x00bdd4013aa31c04616c2bc9785f2788f915679b\":\"0xb9f65d00f63c0000\",\"0x00c27d63fde24b92ee8a1e7ed5d26d8dc5c83b03\":\"0x6c6b935b8bbd400000\",\"0x00c40fe2095423509b9fd9b754323158af2310f3\":\"0x0\",\"0x00d75ed60c774f8b3a5a5173fb1833ad7105a2d9\":\"0x6cb7e74867d5e60000\",\"0x00d78d89b35f472716eceafebf600527d3a1f969\":\"0x5e0549c9632e1d80000\",\"0x00dae27b350bae20c5652124af5d8b5cba001ec1\":\"0x22b1c8c1227a00000\",\"0x00dc01cbf44978a42e8de8e436edf94205cfb6ec\":\"0x4f0febbcda8cb40000\",\"0x00e681bc2d10db62de85848324492250348e90bf\":\"0x43c33c1937564800000\",\"0x00f463e137dcf625fbf3bca39eca98d2b968cf7f\":\"0x14061b9d77a5e980000\",\"0x010007394b8b7565a1658af88ce463499135d6b7\":\"0x56bc75e2d63100000\",\"0x010df1df4bed23760d2d1c03781586ddf7918e54\":\"0x340aad21b3b700000\",\"0x010f4a98dfa1d9799bf5c796fb550efbe7ecd877\":\"0x1b2f292236292c70000\",\"0x01155057002f6b0d18acb9388d3bc8129f8f7a20\":\"0x48a43c54602f700000\",\"0x01226e0ad8d62277b162621c62c928e96e0b9a8c\":\"0x6c6b935b8bbd400000\",\"0x0126e12ebc17035f35c0e9d11dd148393c405d7a\":\"0x6c660645aa47180000\",\"0x012f396a2b5eb83559bac515e5210df2c8c362ba\":\"0xad78ebc5ac6200000\",\"0x0134ff38155fabae94fd35c4ffe1d79de7ef9c59\":\"0x35659ef93f0fc40000\",\"0x0136a5af6c3299c6b5f005fdaddb148c070b299b\":\"0x11aa9ac15f1280000\",\"0x01488ad3da603c4cdd6cb0b7a1e30d2a30c8fc38\":\"0xad78ebc5ac6200000\",\"0x014974a1f46bf204944a853111e52f1602617def\":\"0x6c6b935b8bbd400000\",\"0x014b7f67b14f5d983d87014f570c8b993b9872b5\":\"0xad78ebc5ac6200000\",\"0x0151fa5d17a2dce2d7f1eb39ef7fe2ad213d5d89\":\"0xd8d726b7177a800000\",\"0x01577afd4e50890247c9b10d44af73229aec884f\":\"0x24dce54d34a1a00000\",\"0x015f097d9acddcddafaf2a107eb93a40fc94b04c\":\"0x43c33c1937564800000\",\"0x0169c1c210eae845e56840412e1f65993ea90fb4\":\"0x6c6b935b8bbd400000\",\"0x016b60bb6d67928c29fd0313c666da8f1698d9c5\":\"0x6c6b935b8bbd400000\",\"0x016c85e1613b900fa357b8283b120e65aefcdd08\":\"0x2b5d9784a97cd50000\",\"0x018492488ba1a292342247b31855a55905fef269\":\"0x796e3ea3f8ab00000\",\"0x018f20a27b27ec441af723fd9099f2cbb79d6263\":\"0x75792a8abdef7c0000\",\"0x0191eb547e7bf6976b9b1b577546761de65622e2\":\"0x6c6b4c4da6ddbe0000\",\"0x019d709579ff4bc09fdcdde431dc1447d2c260bc\":\"0x1158e460913d00000\",\"0x01a25a5f5af0169b30864c3be4d7563ccd44f09e\":\"0x4d853c8f8908980000\",\"0x01a7d9fa7d0eb1185c67e54da83c2e75db69e39f\":\"0x19d4addd0d8bc960000\",\"0x01a818135a414210c37c62b625aca1a54611ac36\":\"0xe18398e7601900000\",\"0x01b1cae91a3b9559afb33cdc6d689442fdbfe037\":\"0xad78ebc5ac6200000\",\"0x01b5b5bc5a117fa08b34ed1db9440608597ac548\":\"0xad78ebc5ac6200000\",\"0x01bbc14f67af0639aab1441e6a08d4ce7162090f\":\"0x46fcf68ff8be060000\",\"0x01d03815c61f416b71a2610a2daba59ff6a6de5b\":\"0x205dfe50b81c82e0000\",\"0x01d599ee0d5f8c38ab2d392e2c65b74c3ce31820\":\"0x1ba5abf9e779380000\",\"0x01e40521122530d9ac91113c06a0190b6d63850b\":\"0x487a9a304539440000\",\"0x01e6415d587b065490f1ed7f21d6e0f386ee6747\":\"0x6c6b935b8bbd400000\",\"0x01e864d354741b423e6f42851724468c74f5aa9c\":\"0x43c33c1937564800000\",\"0x01ed5fba8d2eab673aec042d30e4e8a611d8c55a\":\"0x6c6b935b8bbd400000\",\"0x01fb8ec12425a04f813e46c54c05748ca6b29aa9\":\"0xe15730385467c0000\",\"0x01ff1eb1dead50a7f2f9638fdee6eccf3a7b2ac8\":\"0x2086ac351052600000\",\"0x020362c3ade878ca90d6b2d889a4cc5510eed5f3\":\"0x3888e8b311adb38000\",\"0x0203ae01d4c41cae1865e04b1f5b53cdfaecae31\":\"0x3689cdceb28cd70000\",\"0x02089361a3fe7451fb1f87f01a2d866653dc0b07\":\"0x22ac74832b5040000\",\"0x021f69043de88c4917ca10f1842897eec0589c7c\":\"0x6b44cfb81487f40000\",\"0x02290fb5f9a517f82845acdeca0fc846039be233\":\"0x6c6b935b8bbd400000\",\"0x0239b4f21f8e05cd01512b2be7a0e18a6d974607\":\"0x3635c9adc5dea00000\",\"0x02477212ffdd75e5155651b76506b1646671a1eb\":\"0x5f68e8131ecf800000\",\"0x024a098ae702bef5406c9c22b78bd4eb2cc7a293\":\"0xd8d726b7177a800000\",\"0x024bdd2c7bfd500ee7404f7fb3e9fb31dd20fbd1\":\"0x9c2007651b2500000\",\"0x025367960304beee34591118e9ac2d1358d8021a\":\"0x6c6b935b8bbd400000\",\"0x0256149f5b5063bea14e15661ffb58f9b459a957\":\"0x2629f66e0c53000000\",\"0x02603d7a3bb297c67c877e5d34fbd5b913d4c63a\":\"0x1158e460913d00000\",\"0x0261ad3a172abf1315f0ffec3270986a8409cb25\":\"0xb08213bcf8ffe0000\",\"0x026432af37dc5113f1f46d480a4de0b28052237e\":\"0x1349b786e40bfc0000\",\"0x0266ab1c6b0216230b9395443d5fa75e684568c6\":\"0x3635c9adc5dea00000\",\"0x02751dc68cb5bd737027abf7ddb77390cd77c16b\":\"0x1158e460913d00000\",\"0x02778e390fa17510a3428af2870c4273547d386c\":\"0x36c3c66170c0d720000\",\"0x02ade5db22f8b758ee1443626c64ec2f32aa0a15\":\"0x43c33c1937564800000\",\"0x02af2459a93d0b3f4d062636236cd4b29e3bcecf\":\"0x678a932062e4180000\",\"0x02b1af72339b2a2256389fd64607de24f0de600a\":\"0x6c6b935b8bbd400000\",\"0x02b643d6fabd437a851accbe79abb7fde126dccf\":\"0x18650127cc3dc800000\",\"0x02b6d65cb00b7b36e1fb5ed3632c4cb20a894130\":\"0x43c33c1937564800000\",\"0x02b7b1d6b34ce053a40eb65cd4a4f7dddd0e9f30\":\"0x252248deb6e6940000\",\"0x02c9f7940a7b8b7a410bf83dc9c22333d4275dd3\":\"0x10f0cf064dd59200000\",\"0x02d4a30968a39e2b3498c3a6a4ed45c1c6646822\":\"0x6c6b935b8bbd400000\",\"0x02dfcb17a1b87441036374b762a5d3418b1cb4d4\":\"0x48b02ba9d1ba460000\",\"0x02e4cb22be46258a40e16d4338d802fffd00c151\":\"0x149696eaceba810000\",\"0x02e816afc1b5c0f39852131959d946eb3b07b5ad\":\"0x3635c9adc5dea00000\",\"0x02f7f67209b16a17550c694c72583819c80b54ad\":\"0x5559306a78a700000\",\"0x030973807b2f426914ad00181270acd27b8ff61f\":\"0x121ea68c114e5100000\",\"0x03097923ba155e16d82f3ad3f6b815540884b92c\":\"0x62a992e53a0af00000\",\"0x030fb3401f72bd3418b7d1da75bf8c519dd707dc\":\"0xa2a15d09519be00000\",\"0x031e25db516b0f099faebfd94f890cf96660836b\":\"0x6c6b935b8bbd400000\",\"0x0328510c09dbcd85194a98d67c33ac49f2f94d60\":\"0x2544faa778090e00000\",\"0x0329188f080657ab3a2afa522467178279832085\":\"0xbbf510ddfcb260000\",\"0x03317826d1f70aa4bddfa09be0c4105552d2358b\":\"0x21a754a6dc5280000\",\"0x03337012ae1d7ff3ee7f697c403e7780188bf0ef\":\"0xad78ebc5ac6200000\",\"0x03377c0e556b640103289a6189e1aeae63493467\":\"0x43c33c1937564800000\",\"0x0349634dc2a9e80c3f7721ee2b5046aeaaedfbb5\":\"0xd8d726b7177a800000\",\"0x0355bcacbd21441e95adeedc30c17218c8a408ce\":\"0x15af1d78b58c400000\",\"0x036eeff5ba90a6879a14dff4c5043b18ca0460c9\":\"0x56bc75e2d63100000\",\"0x03714b41d2a6f751008ef8dd4d2b29aecab8f36e\":\"0x14542ba12a337c00000\",\"0x0372e852582e0934344a0fed2178304df25d4628\":\"0x43c33c1937564800000\",\"0x0372ee5508bf8163ed284e5eef94ce4d7367e522\":\"0x56bc75e2d63100000\",\"0x037dd056e7fdbd641db5b6bea2a8780a83fae180\":\"0x796e3ea3f8ab00000\",\"0x038323b184cff7a82ae2e1bda7793fe4319ca0bf\":\"0x43c33c1937564800000\",\"0x038779ca2dbe663e63db3fe75683ea0ec62e2383\":\"0x5a87e7d7f5f6580000\",\"0x038e45eadd3d88b87fe4dab066680522f0dfc8f9\":\"0x21e19e0c9bab2400000\",\"0x0392549a727f81655429cb928b529f25df4d1385\":\"0x16c43a0eea0740000\",\"0x0394b90fadb8604f86f43fc1e35d3124b32a5989\":\"0x296aa140278e700000\",\"0x039e7a4ebc284e2ccd42b1bdd60bd6511c0f7706\":\"0xf015f25736420000\",\"0x039ef1ce52fe7963f166d5a275c4b1069fe3a832\":\"0x15af39e4aab2740000\",\"0x03a26cfc4c18316f70d59e9e1a79ee3e8b962f4c\":\"0x6c6b935b8bbd400000\",\"0x03aa622881236dd0f4940c24c324ff8b7b7e2186\":\"0xad78ebc5ac62000000\",\"0x03af7ad9d5223cf7c8c13f20df67ebe5ffc5bb41\":\"0xad78ebc5ac6200000\",\"0x03b0f17cd4469ddccfb7da697e82a91a5f9e7774\":\"0x1158e460913d00000\",\"0x03b41b51f41df20dd279bae18c12775f77ad771c\":\"0x3635c9adc5dea00000\",\"0x03be5b4629aefbbcab9de26d39576cb7f691d764\":\"0xadf30ba70c8970000\",\"0x03c647a9f929b0781fe9ae01caa3e183e876777e\":\"0x182ab7c20ce5240000\",\"0x03c91d92943603e752203e05340e566013b90045\":\"0x2b7cc2e9c3225c0000\",\"0x03cb4c4f4516c4ff79a1b6244fbf572e1c7fea79\":\"0x9489237adb9a500000\",\"0x03cb98d7acd817de9d886d22fab3f1b57d92a608\":\"0x56bc75e2d631000000\",\"0x03cc9d2d21f86b84ac8ceaf971dba78a90e62570\":\"0x57473d05dabae80000\",\"0x03d1724fd00e54aabcd2de2a91e8462b1049dd3a\":\"0x8f1d5c1cae37400000\",\"0x03dedfcd0b3c2e17c705da248790ef98a6bd5751\":\"0x487a9a304539440000\",\"0x03e8b084537557e709eae2e1e1a5a6bce1ef8314\":\"0x1158e460913d00000\",\"0x03ea6d26d080e57aee3926b18e8ed73a4e5b2826\":\"0xad78ebc5ac6200000\",\"0x03eb3cb860f6028da554d344a2bb5a500ae8b86f\":\"0x6c6b935b8bbd400000\",\"0x03ebc63fda6660a465045e235fbe6e5cf195735f\":\"0x7b06ce87fdd680000\",\"0x03ef6ad20ff7bd4f002bac58d47544cf879ae728\":\"0x175c758d0b96e5c0000\",\"0x03f7b92008813ae0a676eb212814afab35221069\":\"0x6c6b935b8bbd400000\",\"0x041170f581de80e58b2a045c8f7c1493b001b7cb\":\"0x303c74a1a336940000\",\"0x0413d0cf78c001898a378b918cd6e498ea773c4d\":\"0xf2dc7d47f15600000\",\"0x04241b41ecbd0bfdf1295e9d4fa59ea09e6c6186\":\"0x655f769450bc780000\",\"0x043707071e2ae21eed977891dc79cd5d8ee1c2da\":\"0x6c6b935b8bbd400000\",\"0x044e853144e3364495e7a69fa1d46abea3ac0964\":\"0x2ab2254b1dc9a8000\",\"0x0455dcec8a7fc4461bfd7f37456fce3f4c3caac7\":\"0x15af1d78b58c400000\",\"0x045ed7f6d9ee9f252e073268db022c6326adfc5b\":\"0x56bc75e2d63100000\",\"0x046377f864b0143f282174a892a73d3ec8ec6132\":\"0xa5aa85009e39c0000\",\"0x0469e8c440450b0e512626fe817e6754a8152830\":\"0x6c6b935b8bbd400000\",\"0x046d274b1af615fb505a764ad8dda770b1db2f3d\":\"0x6c6b935b8bbd400000\",\"0x047d5a26d7ad8f8e70600f70a398ddaa1c2db26f\":\"0x14542ba12a337c00000\",\"0x047e87c8f7d1fce3b01353a85862a948ac049f3e\":\"0x50c5e761a444080000\",\"0x047f9bf1529daf87d407175e6f171b5e59e9ff3e\":\"0x233c8fe42703e80000\",\"0x04852732b4c652f6c2e58eb36587e60a62da14db\":\"0x43c33c1937564800000\",\"0x048a8970ea4145c64d5517b8de5b46d0595aad06\":\"0x43c33c1937564800000\",\"0x049c5d4bc6f25d4e456c697b52a07811ccd19fb1\":\"0x104400a2470e680000\",\"0x04a1cada1cc751082ff8da928e3cfa000820a9e9\":\"0x22b1c8c1227a00000\",\"0x04a80afad53ef1f84165cfd852b0fdf1b1c24ba8\":\"0x324e964b3eca80000\",\"0x04aafc8ae5ce6f4903c89d7fac9cb19512224777\":\"0x1b1ae4d6e2ef500000\",\"0x04ba4bb87140022c214a6fac42db5a16dd954045\":\"0x3635c9adc5dea00000\",\"0x04ba8a3f03f08b895095994dda619edaacee3e7a\":\"0x6c6b935b8bbd400000\",\"0x04c2c64bb54c3eccd05585e10ec6f99a0cdb01a3\":\"0x56bc75e2d63100000\",\"0x04ce45f600db18a9d0851b29d9393ebdaafe3dc5\":\"0x1158e460913d00000\",\"0x04d6b8d4da867407bb997749debbcdc0b358538a\":\"0x3635c9adc5dea00000\",\"0x04d73896cf6593a691972a13a6e4871ff2c42b13\":\"0x6c6b935b8bbd400000\",\"0x04d82af9e01a936d97f8f85940b970f9d4db9936\":\"0xad78ebc5ac6200000\",\"0x04e5f5bc7c923fd1e31735e72ef968fd67110c6e\":\"0x57551dbc8e624c0000\",\"0x04eca501630abce35218b174956b891ba25efb23\":\"0x36369ed7747d260000\",\"0x0505a08e22a109015a22f685305354662a5531d5\":\"0x8cf23f909c0fa00000\",\"0x0514954c3c2fb657f9a06f510ea22748f027cdd3\":\"0x15af1d78b58c400000\",\"0x051633080d07a557adde319261b074997f14692d\":\"0x13a6b2b564871a00000\",\"0x0517448dada761cc5ba4033ee881c83037036400\":\"0x6c4fd1ee246e780000\",\"0x051d424276b21239665186133d653bb8b1862f89\":\"0x3635c9adc5dea00000\",\"0x0521bc3a9f8711fecb10f50797d71083e341eb9d\":\"0x1158e460913d00000\",\"0x05236d4c90d065f9e3938358aaffd777b86aec49\":\"0x1b1ae4d6e2ef500000\",\"0x052a58e035f1fe9cdd169bcf20970345d12b9c51\":\"0x50c5e761a444080000\",\"0x052eab1f61b6d45517283f41d1441824878749d0\":\"0xd8d726b7177a800000\",\"0x05336e9a722728d963e7a1cf2759fd0274530fca\":\"0x31a2443f888a798000\",\"0x053471cd9a41925b3904a5a8ffca3659e034be23\":\"0xad201a6794ff80000\",\"0x05361d8eb6941d4e90fb7e1418a95a32d5257732\":\"0x1158e460913d00000\",\"0x05423a54c8d0f9707e704173d923b946edc8e700\":\"0x6ea03c2bf8ba58000\",\"0x05440c5b073b529b4829209dff88090e07c4f6f5\":\"0x45d29737e22f200000\",\"0x055ab658c6f0ed4f875ed6742e4bc7292d1abbf0\":\"0x486cb9799191e0000\",\"0x055bd02caf19d6202bbcdc836d187bd1c01cf261\":\"0x56bc75e2d63100000\",\"0x055eac4f1ad3f58f0bd024d68ea60dbe01c6afb3\":\"0x56bc75e2d63100000\",\"0x05665155cc49cbf6aabdd5ae92cbfaad82b8c0c1\":\"0x15af1d78b58c400000\",\"0x056686078fb6bcf9ba0a8a8dc63a906f5feac0ea\":\"0x1b181e4bf2343c0000\",\"0x05696b73916bd3033e05521e3211dfec026e98e4\":\"0x6c6b935b8bbd400000\",\"0x056b1546894f9a85e203fb336db569b16c25e04f\":\"0x92edb09ff08d88000\",\"0x057949e1ca0570469e4ce3c690ae613a6b01c559\":\"0xad78ebc5ac6200000\",\"0x057dd29f2d19aa3da42327ea50bce86ff5c911d9\":\"0xd8d726b7177a800000\",\"0x057f7f81cd7a406fc45994408b5049912c566463\":\"0x5c283d410394100000\",\"0x05915d4e225a668162aee7d6c25fcfc6ed18db03\":\"0x398c37279259e0000\",\"0x0596a27dc3ee115fce2f94b481bc207a9e261525\":\"0x3635c9adc5dea00000\",\"0x05a830724302bc0f6ebdaa1ebeeeb46e6ce00b39\":\"0x556f64c1fe7fa0000\",\"0x05ae7fd4bbcc80ca11a90a1ec7a301f7cccc83db\":\"0x3154c9729d05780000\",\"0x05bb64a916be66f460f5e3b64332110d209e19ae\":\"0xe3aeb5737240a00000\",\"0x05bf4fcfe772e45b826443852e6c351350ce72a2\":\"0x1b1ae4d6e2ef5000000\",\"0x05c64004a9a826e94e5e4ee267fa2a7632dd4e6f\":\"0x36dc42ebff90b7f8000\",\"0x05c736d365aa37b5c0be9c12c8ad5cd903c32cf9\":\"0x1455e7b800a86880000\",\"0x05cb6c3b0072d3116761b532b218443b53e8f6c5\":\"0x1e02c3d7fca9b6280000\",\"0x05d0f4d728ebe82e84bf597515ad41b60bf28b39\":\"0xe3aeb5737240a00000\",\"0x05d68dad61d3bbdfb3f779265c49474aff3fcd30\":\"0x222c55dc1519d8000\",\"0x05e671de55afec964b074de574d5158d5d21b0a3\":\"0xd5967be4fc3f100000\",\"0x05e97b09492cd68f63b12b892ed1d11d152c0eca\":\"0x3708baed3d68900000\",\"0x05f3631f5664bdad5d0132c8388d36d7d8920918\":\"0x1158e460913d00000\",\"0x0609d83a6ce1ffc9b690f3e9a81e983e8bdc4d9d\":\"0xed2b525841adfc00000\",\"0x061ea4877cd08944eb64c2966e9db8dedcfec06b\":\"0x3635c9adc5dea00000\",\"0x0625d06056968b002206ff91980140242bfaa499\":\"0x3635c9adc5dea00000\",\"0x0628bfbe5535782fb588406bc96660a49b011af5\":\"0x52663ccab1e1c00000\",\"0x0631d18bbbbd30d9e1732bf36edae2ce8901ab80\":\"0xa3f98855ec39900000\",\"0x0631dc40d74e5095e3729eddf49544ecd4396f67\":\"0x8ac7230489e800000\",\"0x063759dd1c4e362eb19398951ff9f8fad1d31068\":\"0x21e19e0c9bab2400000\",\"0x065ff575fd9c16d3cb6fd68ffc8f483fc32ec835\":\"0xad78ebc5ac6200000\",\"0x06618e9d5762df62028601a81d4487d6a0ecb80e\":\"0x487a9a304539440000\",\"0x066647cfc85d23d37605573d208ca154b244d76c\":\"0x21e19e0c9bab2400000\",\"0x0678654ac6761db904a2f7e8595ec1eaac734308\":\"0x2f98b29c2818f80000\",\"0x06860a93525955ff624940fadcffb8e149fd599c\":\"0x6c68ccd09b022c0000\",\"0x068ce8bd6e902a45cb83b51541b40f39c4469712\":\"0x11c0f9bad4a46e00000\",\"0x068e29b3f191c812a6393918f71ab933ae6847f2\":\"0x6c6acc67d7b1d40000\",\"0x068e655766b944fb263619658740b850c94afa31\":\"0x1e87f85809dc00000\",\"0x06964e2d17e9189f88a8203936b40ac96e533c06\":\"0xfc936392801c0000\",\"0x06994cd83aa2640a97b2600b41339d1e0d3ede6c\":\"0xd8d726b7177a80000\",\"0x069ed0ab7aa77de571f16106051d92afe195f2d0\":\"0xad78ebc5ac6200000\",\"0x06ac26ad92cb859bd5905ddce4266aa0ec50a9c5\":\"0x2a034919dfbfbc0000\",\"0x06b0c1e37f5a5ec4bbf50840548f9d3ac0288897\":\"0xd8d882e1928e7d0000\",\"0x06b0ff834073cce1cbc9ea557ea87b605963e8b4\":\"0x1043561a8829300000\",\"0x06b106649aa8c421ddcd1b8c32cd0418cf30da1f\":\"0x878678326eac9000000\",\"0x06b5ede6fdf1d6e9a34721379aeaa17c713dd82a\":\"0x6c6b935b8bbd400000\",\"0x06cbfa08cdd4fba737bac407be8224f4eef35828\":\"0x202be5e8382e8b8000\",\"0x06d6cb308481c336a6e1a225a912f6e6355940a1\":\"0x5f68e8131ecf800000\",\"0x06dc7f18cee7edab5b795337b1df6a9e8bd8ae59\":\"0x15af1d78b58c400000\",\"0x06f68de3d739db41121eacf779aada3de8762107\":\"0x18493fba64ef00000\",\"0x06f7dc8d1b9462cef6feb13368a7e3974b097f9f\":\"0x6c6b935b8bbd400000\",\"0x0701f9f147ec486856f5e1b71de9f117e99e2105\":\"0x965da717fd5b80000\",\"0x070d5d364cb7bbf822fc2ca91a35bdd441b215d5\":\"0x6c6b935b8bbd400000\",\"0x071dd90d14d41f4ff7c413c24238d3359cd61a07\":\"0x7b53f79e888dac00000\",\"0x0726c42e00f45404836eb1e280d073e7059687f5\":\"0x58003e3fb947a38000\",\"0x0727be0a2a00212048b5520fbefb953ebc9d54a0\":\"0x21e19e0c9bab2400000\",\"0x0729a8a4a5ba23f579d0025b1ad0f8a0d35cdfd2\":\"0x20dd68aaf3289100000\",\"0x0729b4b47c09eb16158464c8aa7fd9690b438839\":\"0x6c68ccd09b022c0000\",\"0x0734a0a81c9562f4d9e9e10a8503da15db46d76e\":\"0xfc936392801c0000\",\"0x073c67e09b5c713c5221c8a0c7f3f74466c347b0\":\"0x41bad155e6512200000\",\"0x073f1ed1c9c3e9c52a9b0249a5c1caa0571fdf05\":\"0x3d0ff0b013b800000\",\"0x0748713145ef83c3f0ef4d31d823786f7e9cc689\":\"0xf3f20b8dfa69d00000\",\"0x075d15e2d33d8b4fa7dba8b9e607f04a261e340b\":\"0x678a932062e4180000\",\"0x076561a856455d7ef86e63f87c73dbb628a55f45\":\"0x30ca024f987b900000\",\"0x076ee99d3548623a03b5f99859d2d785a1778d48\":\"0xad78ebc5ac6200000\",\"0x0770b43dbae4b1f35a927b4fa8124d3866caf97b\":\"0x37193ea7ef5b470000\",\"0x0770c61be78772230cb5a3bb2429a72614a0b336\":\"0x16ee0a299b713418000\",\"0x07723e3c30e8b731ee456a291ee0e798b0204a77\":\"0x6c6b935b8bbd400000\",\"0x0773eeacc050f74720b4a1bd57895b1cceeb495d\":\"0x21e19e0c9bab2400000\",\"0x07800d2f8068e448c79a4f69b1f15ef682aae5f6\":\"0x41bad155e6512200000\",\"0x07a8dadec142571a7d53a4297051786d072cba55\":\"0x13b6da1139bda8000\",\"0x07af938c1237a27c9030094dcf240750246e3d2c\":\"0x1b1ae4d6e2ef500000\",\"0x07b1a306cb4312df66482c2cae72d1e061400fcd\":\"0x43c33c1937564800000\",\"0x07b7a57033f8f11330e4665e185d234e83ec140b\":\"0xea7ee92a0c9a0b8000\",\"0x07bc2cc8eedc01970700efc9c4fb36735e98cd71\":\"0xd8d726b7177a800000\",\"0x07d41217badca5e0e60327d845a3464f0f27f84a\":\"0xd8d726b7177a800000\",\"0x07d4334ec385e8aa54eedaeadb30022f0cdfa4ab\":\"0x8e91d520f2eb790000\",\"0x07dae622630d1136381933d2ad6b22b839d82102\":\"0xad78ebc5ac6200000\",\"0x07dc2bf83bc6af19a842ffea661af5b41b67fda1\":\"0x5150ae84a8cdf00000\",\"0x07dc8c8b927adbedfa8f5d639b4352351f2f36d2\":\"0x110aed3b5530db0000\",\"0x07ddd0422c86ef65bf0c7fc3452862b1228b08b8\":\"0x6ff5d2aa8f9fcf0000\",\"0x07e1162ceae3cf21a3f62d105990302e307f4e3b\":\"0x52f103edb66ba80000\",\"0x07e2b4cdeed9d087b12e556d9e770c13c099615f\":\"0x243d4d18229ca20000\",\"0x07feef54c136850829badc4b49c3f2a73c89fb9e\":\"0x6685ac1bfe32c0000\",\"0x080546508a3d2682c8b9884f13637b8847b44db3\":\"0x6c6b935b8bbd400000\",\"0x08090876baadfee65c3d363ba55312748cfa873d\":\"0x5c2a99371cffe10000\",\"0x08166f02313feae18bb044e7877c808b55b5bf58\":\"0x6acb3df27e1f880000\",\"0x0829d0f7bb7c446cfbb0deadb2394d9db7249a87\":\"0x22ca3587cf4eb0000\",\"0x08306de51981e7aca1856859b7c778696a6b69f9\":\"0xad78ebc5ac62000000\",\"0x0837539b5f6a522a482cdcd3a9bb7043af39bdd2\":\"0x14542ba12a337c00000\",\"0x0838a7768d9c2aca8ba279adfee4b1f491e326f1\":\"0xad78ebc5ac6200000\",\"0x08411652c871713609af0062a8a1281bf1bbcfd9\":\"0x4be4e7267b6ae00000\",\"0x084d103254759b343cb2b9c2d8ff9e1ac5f14596\":\"0x19bff2ff57968c00000\",\"0x08504f05643fab5919f5eea55925d7a3ed7d807a\":\"0x1158e460913d00000\",\"0x085b4ab75d8362d914435cedee1daa2b1ee1a23b\":\"0xd255d112e103a00000\",\"0x085ba65febe23eefc2c802666ab1262382cfc494\":\"0x15af1d78b58c400000\",\"0x087498c0464668f31150f4d3c4bcdda5221ba102\":\"0x1158e460913d00000\",\"0x0877eeaeab78d5c00e83c32b2d98fa79ad51482f\":\"0x17d22d71da62260000\",\"0x08936a37df85b3a158cafd9de021f58137681347\":\"0xfc936392801c0000\",\"0x08a9a44e1f41de3dbba7a363a3ab412c124cd15e\":\"0xad78ebc5ac6200000\",\"0x08b7bdcf944d5570838be70460243a8694485858\":\"0x6c6b935b8bbd400000\",\"0x08b84536b74c8c01543da88b84d78bb95747d822\":\"0xad78ebc5ac6200000\",\"0x08c2f236ac4adcd3fda9fbc6e4532253f9da3bec\":\"0x1158e460913d00000\",\"0x08c802f87758349fa03e6bc2e2fd0791197eea9a\":\"0x6c6b935b8bbd400000\",\"0x08c9f1bfb689fdf804d769f82123360215aff93b\":\"0x6acb3df27e1f880000\",\"0x08cac8952641d8fc526ec1ab4f2df826a5e7710f\":\"0x1043561a8829300000\",\"0x08ccda50e4b26a0ffc0ef92e9205310706bec2c7\":\"0x149756c3857c6000000\",\"0x08d0864dc32f9acb36bf4ea447e8dd6726906a15\":\"0x6c6e59e67c78540000\",\"0x08d4267feb15da9700f7ccc3c84a8918bf17cfde\":\"0x61093d7c2c6d380000\",\"0x08d4311c9c1bbaf87fabe1a1d01463828d5d98ce\":\"0x130ee8e7179044400000\",\"0x08d54e83ad486a934cfaeae283a33efd227c0e99\":\"0x38530583245edc0000\",\"0x08d97eadfcb7b064e1ccd9c8979fbee5e77a9719\":\"0xe6c5da8d67ac18000\",\"0x08da3a7a0f452161cfbcec311bb68ebfdee17e88\":\"0x6c6b935b8bbd400000\",\"0x08e38ee0ce48c9ca645c1019f73b5355581c56e6\":\"0x56bc75e2d631000000\",\"0x08ef3fa4c43ccdc57b22a4b9b2331a82e53818f2\":\"0xd8d726b7177a800000\",\"0x0909648c18a3ce5bae7a047ec2f868d24cdda81d\":\"0xcf152640c5c8300000\",\"0x090cd67b60e81d54e7b5f6078f3e021ba65b9a1e\":\"0x3635c9adc5dea00000\",\"0x090cebef292c3eb081a05fd8aaf7d39bf07b89d4\":\"0xd8d726b7177a800000\",\"0x090fa9367bda57d0d3253a0a8ff76ce0b8e19a73\":\"0x3635c9adc5dea00000\",\"0x09146ea3885176f07782e1fe30dce3ce24c49e1f\":\"0x1158e460913d00000\",\"0x0921605f99164e3bcc28f31caece78973182561d\":\"0x2b07692a9065a80000\",\"0x09261f9acb451c3788844f0c1451a35bad5098e3\":\"0x1d5ad27502920600000\",\"0x0927220492194b2eda9fc4bbe38f25d681dfd36c\":\"0x14542ba12a337c00000\",\"0x092acb624b08c05510189bbbe21e6524d644ccad\":\"0xfc936392801c0000\",\"0x092e815558402d67f90d6bfe6da0b2fffa91455a\":\"0x340aad21b3b700000\",\"0x095030e4b82692dcf8b8d0912494b9b378ec9328\":\"0x48a43c54602f700000\",\"0x095270cc42141dd998ad2862dbd1fe9b44e7e650\":\"0x410d586a20a4c00000\",\"0x095457f8ef8e2bdc362196b9a9125da09c67e3ab\":\"0xad78ebc5ac6200000\",\"0x0954a8cb5d321fc3351a7523a617d0f58da676a7\":\"0x87d9bc7aa498e80000\",\"0x095b0ea2b218d82e0aea7c2889238a39c9bf9077\":\"0x43c33c1937564800000\",\"0x095b949de3333a377d5019d893754a5e4656ff97\":\"0x126e72a69a50d00000\",\"0x095e0174829f34c3781be1a5e38d1541ea439b7f\":\"0x14542ba12a337c00000\",\"0x095f5a51d06f6340d80b6d29ea2e88118ad730fe\":\"0x6c6e59e67c78540000\",\"0x0968ee5a378f8cadb3bafdbed1d19aaacf936711\":\"0x3635c9adc5dea00000\",\"0x0977bfba038a44fb49b03970d8d8cf2cb61f8b25\":\"0x16c4abbebea0100000\",\"0x097da12cfc1f7c1a2464def08c29bed5e2f851e9\":\"0x1158e460913d00000\",\"0x097ecda22567c2d91cb03f8c5215c22e9dcda949\":\"0x11651ac3e7a758000\",\"0x0989c200440b878991b69d6095dfe69e33a22e70\":\"0x678a932062e4180000\",\"0x0990e81cd785599ea236bd1966cf526302c35b9c\":\"0x3635c9adc5dea00000\",\"0x0998d8273115b56af43c505e087aff0676ed3659\":\"0xd8d6eddf2d2e180000\",\"0x09a025316f967fa8b9a1d60700063f5a68001caa\":\"0x21221a99b93ec0000\",\"0x09a928d528ec1b3e25ffc83e218c1e0afe8928c7\":\"0xfc936392801c0000\",\"0x09ae49e37f121df5dc158cfde806f173a06b0c7f\":\"0xd8309e26aba1d00000\",\"0x09afa73bc047ef46b977fd9763f87286a6be68c6\":\"0x1b2fb5e8f06a660000\",\"0x09b4668696f86a080f8bebb91db8e6f87015915a\":\"0x238ff7b34f60010000\",\"0x09b59b8698a7fbd3d2f8c73a008988de3e406b2b\":\"0x878678326eac9000000\",\"0x09b7a988d13ff89186736f03fdf46175b53d16e0\":\"0x14542ba12a337c00000\",\"0x09c177f1ae442411ddacf187d46db956148360e7\":\"0x1e52e336cde22180000\",\"0x09c88f917e4d6ad473fa12e98ea3c4472a5ed6da\":\"0x21e19e0c9bab2400000\",\"0x09d0b8cd077c69d9f32d9cca43b3c208a21ed48b\":\"0x821d221b5291f8000\",\"0x09d6cefd75b0c4b3f8f1d687a522c96123f1f539\":\"0x14542ba12a337c00000\",\"0x09e437d448861228a232b62ee8d37965a904ed9c\":\"0x498cf401df8842e8000\",\"0x09ee12b1b42b05af9cf207d5fcac255b2ec411f2\":\"0x331cddd47e0fe8000\",\"0x09f3f601f605441140586ce0656fa24aa5b1d9ae\":\"0x5373776fe8c4540000\",\"0x09f9575be57d004793c7a4eb84b71587f97cbb6a\":\"0xad78ebc5ac6200000\",\"0x0a0650861f785ed8e4bf1005c450bbd06eb48fb6\":\"0xa6413b79144e7e0000\",\"0x0a06fad7dcd7a492cbc053eeabde6934b39d8637\":\"0x1158e460913d00000\",\"0x0a077db13ffeb09484c217709d5886b8bf9c5a8b\":\"0xd8d726b7177a800000\",\"0x0a0ecda6636f7716ef1973614687fd89a820a706\":\"0x155bd9307f9fe80000\",\"0x0a29a8a4d5fd950075ffb34d77afeb2d823bd689\":\"0xad78ebc5ac6200000\",\"0x0a2ade95b2e8c66d8ae6f0ba64ca57d783be6d44\":\"0xd8d726b7177a800000\",\"0x0a2b4fc5d81ace67dc4bba03f7b455413d46fe3d\":\"0xaadec983fcff40000\",\"0x0a2dcb7a671701dbb8f495728088265873356c8e\":\"0x83f16ce08a06c0000\",\"0x0a3de155d5ecd8e81c1ff9bbf0378301f8d4c623\":\"0xd8d726b7177a800000\",\"0x0a47ad9059a249fc936b2662353da6905f75c2b9\":\"0x6c6b935b8bbd400000\",\"0x0a48296f7631708c95d2b74975bc4ab88ac1392a\":\"0x10f0cf064dd59200000\",\"0x0a4a011995c681bc999fdd79754e9a324ae3b379\":\"0x8c19ab06eb89af60000\",\"0x0a58fddd71898de773a74fdae45e7bd84ef43646\":\"0x1158e460913d00000\",\"0x0a5b79d8f23b6483dbe2bdaa62b1064cc76366ae\":\"0x6ac882100952c78000\",\"0x0a652e2a8b77bd97a790d0e91361c98890dbb04e\":\"0x3635c9adc5dea00000\",\"0x0a6ebe723b6ed1f9a86a69ddda68dc47465c2b1b\":\"0x403d2db599d5e40000\",\"0x0a77e7f72b437b574f00128b21f2ac265133528c\":\"0x6c6b935b8bbd400000\",\"0x0a917f3b5cb0b883047fd9b6593dbcd557f453b9\":\"0x3635c9adc5dea00000\",\"0x0a931b449ea8f12cdbd5e2c8cc76bad2c27c0639\":\"0x13f9e8c79fe058000\",\"0x0a9804137803ba6868d93a55f9985fcd540451e4\":\"0xb98bc829a6f90000\",\"0x0a9ab2638b1cfd654d25dab018a0aebddf85fd55\":\"0x12e8cb5fe4c4a8000\",\"0x0ab366e6e7d5abbce6b44a438d69a1cabb90d133\":\"0x1158e460913d000000\",\"0x0ab4281ebb318590abb89a81df07fa3af904258a\":\"0x1b1ae4d6e2ef500000\",\"0x0ab59d390702c9c059db148eb4f3fcfa7d04c7e7\":\"0xfc936392801c0000\",\"0x0abfb39b11486d79572866195ba26c630b6784db\":\"0x19ba8737f96928f00000\",\"0x0aca9a5626913b08cfc9a66d40508dce52b60f87\":\"0x678a932062e4180000\",\"0x0ad3e44d3c001fa290b393617030544108ac6eb9\":\"0x6abda0bc30b2df8000\",\"0x0aec2e426ed6cc0cf3c249c1897eac47a7faa9bd\":\"0xad78ebc5ac6200000\",\"0x0af65f14784e55a6f95667fd73252a1c94072d2a\":\"0xa763b8e02d44f8000\",\"0x0af6c8d539c96d50259e1ba6719e9c8060f388c2\":\"0x3635c9adc5dea00000\",\"0x0b06390f2437b20ec4a3d3431b3279c6583e5ed7\":\"0xa844a7424d9c80000\",\"0x0b0b3862112aeec3a03492b1b05f440eca54256e\":\"0xd8d726b7177a800000\",\"0x0b0e055b28cbd03dc5ff44aa64f3dce04f5e63fb\":\"0x6c6b935b8bbd400000\",\"0x0b119df99c6b8de58a1e2c3f297a6744bf552277\":\"0x6c6b935b8bbd400000\",\"0x0b14891999a65c9ef73308efe3100ca1b20e8192\":\"0x2b5e3af16b18800000\",\"0x0b2113504534642a1daf102eee10b9ebde76e261\":\"0x942cdd7c95f2bd8000\",\"0x0b288a5a8b75f3dc4191eb0457e1c83dbd204d25\":\"0x10714e77bb43ab40000\",\"0x0b369e002e1b4c7913fcf00f2d5e19c58165478f\":\"0x37f6516288c340000\",\"0x0b43bd2391025581d8956ce42a072579cbbfcb14\":\"0x104e70464b1580000\",\"0x0b507cf553568daaf65504ae4eaa17a8ea3cdbf5\":\"0x6c6b935b8bbd400000\",\"0x0b5d66b13c87b392e94d91d5f76c0d450a552843\":\"0x6c6b935b8bbd400000\",\"0x0b5e2011ebc25a007f21362960498afb8af280fb\":\"0x6c6b935b8bbd400000\",\"0x0b649da3b96a102cdc6db652a0c07d65b1e443e6\":\"0x6c6b935b8bbd400000\",\"0x0b6920a64b363b8d5d90802494cf564b547c430d\":\"0x410d586a20a4c00000\",\"0x0b701101a4109f9cb360dc57b77442673d5e5983\":\"0x6c6b935b8bbd400000\",\"0x0b71f554122469ef978e2f1fefd7cbb410982772\":\"0xd255d112e103a00000\",\"0x0b7bb342f01bc9888e6a9af4a887cbf4c2dd2caf\":\"0x3635c9adc5dea000000\",\"0x0b7d339371e5be6727e6e331b5821fa24bdb9d5a\":\"0x2e7f81868262010000\",\"0x0b7fc9ddf70576f6330669eaaa71b6a831e99528\":\"0x796e3ea3f8ab00000\",\"0x0b80fc70282cbdd5fde35bf78984db3bdb120188\":\"0x3638021cecdab00000\",\"0x0b924df007e9c0878417cfe63b976ea1a382a897\":\"0x22b1c8c1227a00000\",\"0x0b93fca4a4f09cac20db60e065edcccc11e0a5b6\":\"0xad78ebc5ac6200000\",\"0x0b9df80fbe232009dacf0aa8cac59376e2476203\":\"0x6c6b935b8bbd400000\",\"0x0ba6e46af25a13f57169255a34a4dac7ce12be04\":\"0x1b1ae4d6e2ef500000\",\"0x0ba8705bf55cf219c0956b5e3fc01c4474a6cdc1\":\"0x525e0595d4d6b8000\",\"0x0baf6ecdb91acb3606a8357c0bc4f45cfd2d7e6f\":\"0x3635c9adc5dea00000\",\"0x0bb05f7224bb5804856556c07eeadbed87ba8f7c\":\"0x15be6174e1912e0000\",\"0x0bb0c12682a2f15c9b5741b2385cbe41f034068e\":\"0x5150ae84a8cdf00000\",\"0x0bb25ca7d188e71e4d693d7b170717d6f8f0a70a\":\"0x124302a82fadd70000\",\"0x0bb2650ea01aca755bc0c017b64b1ab5a66d82e3\":\"0x487a9a304539440000\",\"0x0bb54c72fd6610bfa4363397e020384b022b0c49\":\"0x487a9a304539440000\",\"0x0bb7160aba293762f8734f3e0326ffc9a4cac190\":\"0x3635c9adc5dea00000\",\"0x0bc95cb32dbb574c832fa8174a81356d38bc92ac\":\"0x6c6b935b8bbd400000\",\"0x0bd67dbde07a856ebd893b5edc4f3a5be4202616\":\"0x6c6b935b8bbd400000\",\"0x0bdbc54cc8bdbbb402a08911e2232a5460ce866b\":\"0xa2a15d09519be00000\",\"0x0bdd58b96e7c916dd2fb30356f2aebfaaf1d8630\":\"0x6c6b935b8bbd400000\",\"0x0be1bcb90343fae5303173f461bd914a4839056c\":\"0x14542ba12a337c00000\",\"0x0be1fdf626ee6189102d70d13b31012c95cd1cd6\":\"0x6c6b935b8bbd400000\",\"0x0be2b94ad950a2a62640c35bfccd6c67dae450f6\":\"0x692ae8897081d00000\",\"0x0be6a09e4307fe48d412b8d1a1a8284dce486261\":\"0x40fbff85c0138300000\",\"0x0befb54707f61b2c9fb04715ab026e1bb72042bd\":\"0xd8d726b7177a800000\",\"0x0bf064428f83626722a7b5b26a9ab20421a7723e\":\"0x73f75d1a085ba0000\",\"0x0bfbb6925dc75e52cf2684224bbe0550fea685d3\":\"0x6acb3df27e1f880000\",\"0x0c088006c64b30c4ddafbc36cb5f05469eb62834\":\"0x6c6b935b8bbd400000\",\"0x0c2073ba44d3ddbdb639c04e191039a71716237f\":\"0x4d853c8f8908980000\",\"0x0c222c7c41c9b048efcce0a232434362e12d673b\":\"0x21e8359697677380000\",\"0x0c2808b951ed9e872d7b32790fcc5994ae41ffdc\":\"0x15996e5b3cd6b3c00000\",\"0x0c28847e4f09dfce5f9b25af7c4e530f59c880fe\":\"0x3635c9adc5dea00000\",\"0x0c2d5c920538e953caaf24f0737f554cc6927742\":\"0x3635c9adc5dea00000\",\"0x0c30cacc3f72269f8b4f04cf073d2b05a83d9ad1\":\"0x6c7974123f64a40000\",\"0x0c3239e2e841242db989a61518c22247e8c55208\":\"0xe4af6471734640000\",\"0x0c480de9f7461002908b49f60fc61e2b62d3140b\":\"0x21e19e0c9bab2400000\",\"0x0c48ae62d1539788eba013d75ea60b64eeba4e80\":\"0x77fbdc43e030998000\",\"0x0c5589a7a89b9ad15b02751930415948a875fbef\":\"0x6d499ec6c63380000\",\"0x0c67033dd8ee7f0c8ae534d42a51f7d9d4f7978f\":\"0xad78ebc5ac6200000\",\"0x0c6845bf41d5ee273c3ee6b5b0d69f6fd5eabbf7\":\"0xa2a1b9682e58090000\",\"0x0c7f869f8e90d53fdc03e8b2819b016b9d18eb26\":\"0x43c33c1937564800000\",\"0x0c8692eeff2a53d6d1688ed56a9ddbbd68dabba1\":\"0x6c6b935b8bbd400000\",\"0x0c8f66c6017bce5b20347204b602b743bad78d60\":\"0x6c6b935b8bbd400000\",\"0x0c8fd7775e54a6d9c9a3bf890e761f6577693ff0\":\"0x215f835bc769da80000\",\"0x0c925ad5eb352c8ef76d0c222d115b0791b962a1\":\"0xac635d7fa34e300000\",\"0x0c967e3061b87a753e84507eb60986782c8f3013\":\"0x56bc75e2d63100000\",\"0x0ca12ab0b9666cf0cec6671a15292f2653476ab2\":\"0x2c7827c42d22d07c0000\",\"0x0ca670eb2c8b96cba379217f5929c2b892f39ef6\":\"0x6c6b935b8bbd400000\",\"0x0cae108e6db99b9e637876b064c6303eda8a65c8\":\"0xa2a15d09519be00000\",\"0x0cbd921dbe121563b98a6871fecb14f1cc7e88d7\":\"0xad78ebc5ac6200000\",\"0x0cbf8770f0d1082e5c20c5aead34e5fca9ae7ae2\":\"0x3635c9adc5dea00000\",\"0x0cc67f8273e1bae0867fd42e8b8193d72679dbf8\":\"0x1b1ae4d6e2ef500000\",\"0x0cd6a141918d126b106d9f2ebf69e102de4d3277\":\"0x1158e460913d00000\",\"0x0cda12bf72d461bbc479eb92e6491d057e6b5ad1\":\"0x21e19e0c9bab2400000\",\"0x0cdc960b998c141998160dc179b36c15d28470ed\":\"0x1b1b6bd7af64c70000\",\"0x0cfb172335b16c87d519cd1475530d20577f5e0e\":\"0x152d02c7e14af6800000\",\"0x0d1f2a57713ebc6e94de29846e8844d376665763\":\"0x10f0cf064dd59200000\",\"0x0d3265d3e7bdb93d5e8e8b1ca47f210a793ecc8e\":\"0xad78ebc5ac6200000\",\"0x0d35408f226566116fb8acdaa9e2c9d59b76683f\":\"0x32f51edbaaa3300000\",\"0x0d551ec1a2133c981d5fc6a8c8173f9e7c4f47af\":\"0x6c6b935b8bbd400000\",\"0x0d5d98565c647ca5f177a2adb9d3022fac287f21\":\"0xad78ebc5ac6200000\",\"0x0d658014a199061cf6b39433140303c20ffd4e5a\":\"0x1bc85dc2a89bb200000\",\"0x0d678706d037187f3e22e6f69b99a592d11ebc59\":\"0x55a6e79ccd1d300000\",\"0x0d69100c395ce6c5eaadf95d05d872837ededd21\":\"0x15af1d78b58c400000\",\"0x0d747ee5969bf79d57381d6fe3a2406cd0d8ce27\":\"0x152d02c7e14af6800000\",\"0x0d8023929d917234ae40512b1aabb5e8a4512771\":\"0x805e99fdcc5d00000\",\"0x0d8aab8f74ea862cdf766805009d3f3e42d8d00b\":\"0x13b80b99c5185700000\",\"0x0d8c40a79e18994ff99ec251ee10d088c3912e80\":\"0x63664fcd2bbc40000\",\"0x0d8ed7d0d15638330ed7e4eaccab8a458d75737e\":\"0x6c6b935b8bbd400000\",\"0x0d92582fdba05eabc3e51538c56db8813785b328\":\"0xa5aa85009e39c0000\",\"0x0d9443a79468a5bbf7c13c6e225d1de91aee07df\":\"0x3cb71f51fc5580000\",\"0x0d9a825ff2bcd397cbad5b711d9dcc95f1cc112d\":\"0x2b5e3af16b188000000\",\"0x0d9d3f9bc4a4c6efbd59679b69826bc1f63d9916\":\"0x2086ac351052600000\",\"0x0da532c910e3ac0dfb14db61cd739a93353fd05f\":\"0x4878be1ffaf95d0000\",\"0x0da7401262384e2e8b4b26dd154799b55145efa0\":\"0x1043561a8829300000\",\"0x0dae3ee5b915b36487f9161f19846d101433318a\":\"0x678a932062e4180000\",\"0x0dbd417c372b8b0d01bcd944706bd32e60ae28d1\":\"0x126e72a69a50d00000\",\"0x0dc100b107011c7fc0a1339612a16ccec3285208\":\"0x6c6b935b8bbd400000\",\"0x0dcf9d8c9804459f647c14138ed50fad563b4154\":\"0x960db77681e940000\",\"0x0dcfe837ea1cf28c65fccec3bef1f84e59d150c0\":\"0xad78ebc5ac6200000\",\"0x0dd4e674bbadb1b0dc824498713dce3b5156da29\":\"0x93739534d28680000\",\"0x0dfbd4817050d91d9d625c02053cf61a3ee28572\":\"0x126e72a69a50d00000\",\"0x0e024e7f029c6aaf3a8b910f5e080873b85795aa\":\"0x3635c9adc5dea00000\",\"0x0e09646c99af438e99fa274cb2f9c856cb65f736\":\"0x678a932062e4180000\",\"0x0e0c9d005ea016c295cd795cc9213e87febc33eb\":\"0xabbcd4ef377580000\",\"0x0e0d6633db1e0c7f234a6df163a10e0ab39c200f\":\"0xad78ebc5ac6200000\",\"0x0e11d77a8977fac30d268445e531149b31541a24\":\"0x6c6b935b8bbd400000\",\"0x0e123d7da6d1e6fac2dcadd27029240bb39052fe\":\"0x3635c9adc5dea00000\",\"0x0e1801e70b6262861b1134ccbc391f568afc92f7\":\"0xd8d726b7177a800000\",\"0x0e2094ac1654a46ba1c4d3a40bb8c17da7f39688\":\"0x13683f7f3c15d80000\",\"0x0e21af1b8dbf27fcf63f37e047b87a825cbe7c27\":\"0xa2a15d09519be00000\",\"0x0e2e504a2d1122b5a9feee5cb1451bf4c2ace87b\":\"0xd5967be4fc3f100000\",\"0x0e2f8e28a681f77c583bd0ecde16634bdd7e00cd\":\"0x52738f659bca20000\",\"0x0e320219838e859b2f9f18b72e3d4073ca50b37d\":\"0x6c6b935b8bbd400000\",\"0x0e33fcbbc003510be35785b52a9c5d216bc005f4\":\"0x65ea3db75546600000\",\"0x0e3696cf1f4217b163d1bc12a5ea730f1c32a14a\":\"0xd8d726b7177a800000\",\"0x0e390f44053ddfcef0d608b35e4d9c2cbe9871bb\":\"0x6acb3df27e1f880000\",\"0x0e3a28c1dfafb0505bdce19fe025f506a6d01ceb\":\"0x6c6b935b8bbd400000\",\"0x0e3dd7d4e429fe3930a6414035f52bdc599d784d\":\"0x22ca3587cf4eb0000\",\"0x0e4765790352656bc656682c24fc5ef3e76a23c7\":\"0x286d7fc0cb4f50000\",\"0x0e498800447177b8c8afc3fdfa7f69f4051bb629\":\"0x7405b69b8de5610000\",\"0x0e6baaa3deb989f289620076668618e9ac332865\":\"0xad78ebc5ac6200000\",\"0x0e6cd664ad9c1ed64bf98749f40644b626e3792c\":\"0xcb49b44ba602d800000\",\"0x0e6dfd553b2e873d2aec15bd5fbb3f8472d8d394\":\"0x28a857425466f800000\",\"0x0e6ec313376271dff55423ab5422cc3a8b06b22b\":\"0xd8d726b7177a800000\",\"0x0e6ece99111cad1961c748ed3df51edd69d2a3b1\":\"0x152d02c7e14af6800000\",\"0x0e83b850481ab44d49e0a229a2e464902c69539b\":\"0x56bc75e2d63100000\",\"0x0e89eddd3fa0d71d8ab0ff8da5580686e3d4f74f\":\"0x6c6b935b8bbd400000\",\"0x0e9096d343c060db581a120112b278607ec6e52b\":\"0x1158e460913d00000\",\"0x0e9c511864a177f49be78202773f60489fe04e52\":\"0x14542ba12a337c00000\",\"0x0ea2a210312b3e867ee0d1cc682ce1d666f18ed5\":\"0x21e19e0c9bab2400000\",\"0x0eb189ef2c2d5762a963d6b7bdf9698ea8e7b48a\":\"0x487a9a304539440000\",\"0x0eb5b662a1c718608fd52f0c25f9378830178519\":\"0x14a37281a612e740000\",\"0x0ec46696ffac1f58005fa8439824f08eed1df89b\":\"0x21e19e0c9bab2400000\",\"0x0ec50aa823f465b9464b0bc0c4a57724a555f5d6\":\"0xc83d1426ac7b1f00000\",\"0x0ec5308b31282e218fc9e759d4fec5db3708cec4\":\"0x3643aa647986040000\",\"0x0eccf617844fd61fba62cb0e445b7ac68bcc1fbe\":\"0x14fe4fe63565c60000\",\"0x0ed3bb3a4eb554cfca97947d575507cdfd6d21d8\":\"0x1db3205fcc23d58000\",\"0x0ed76c2c3b5d50ff8fb50b3eeacd681590be1c2d\":\"0x56bc75e2d63100000\",\"0x0eda80f4ed074aea697aeddf283b63dbca3dc4da\":\"0x6c6b935b8bbd400000\",\"0x0edd4b580ff10fe06c4a03116239ef96622bae35\":\"0xaadec983fcff40000\",\"0x0ee391f03c765b11d69026fd1ab35395dc3802a0\":\"0xad78ebc5ac6200000\",\"0x0ee414940487fd24e390378285c5d7b9334d8b65\":\"0x914878a8c05ee00000\",\"0x0ef54ac7264d2254abbb5f8b41adde875157db7c\":\"0x22b1c8c1227a00000\",\"0x0ef85b49d08a75198692914eddb4b22cf5fa4450\":\"0x6cae30621d47200000\",\"0x0efd1789eb1244a3dede0f5de582d8963cb1f39f\":\"0x5150ae84a8cdf00000\",\"0x0f042c9c2fb18766f836bb59f735f27dc329fe3c\":\"0x21e19e0c9bab2400000\",\"0x0f049a8bdfd761de8ec02cee2829c4005b23c06b\":\"0xda933d8d8c6700000\",\"0x0f05f120c89e9fbc93d4ab0c5e2b4a0df092b424\":\"0x65a4da25d3016c00000\",\"0x0f127bbf8e311caea2ba502a33feced3f730ba42\":\"0xa31062beeed700000\",\"0x0f1c249cd962b00fd114a9349f6a6cc778d76c4d\":\"0x6c6b935b8bbd400000\",\"0x0f206e1a1da7207ea518b112418baa8b06260328\":\"0x2086ac351052600000\",\"0x0f24105abbdaa03fa6309ef6c188e51f714a6e59\":\"0xad78ebc5ac6200000\",\"0x0f26480a150961b8e30750713a94ee6f2e47fc00\":\"0x3635c9adc5dea00000\",\"0x0f2d8daf04b5414a0261f549ff6477b80f2f1d07\":\"0x2a5a058fc295ed000000\",\"0x0f2fb884c8aaff6f543ac6228bd08e4f60b0a5fd\":\"0xaa7da485136b840000\",\"0x0f32d9cb4d0fdaa0150656bb608dcc43ed7d9301\":\"0x28df8bf440db790000\",\"0x0f3665d48e9f1419cd984fc7fa92788710c8f2e4\":\"0x6c6b935b8bbd400000\",\"0x0f3a1023cac04dbf44f5a5fa6a9cf8508cd4fddf\":\"0x62a992e53a0af00000\",\"0x0f4073c1b99df60a1549d69789c7318d9403a814\":\"0x43c33c1937564800000\",\"0x0f46c81db780c1674ac73d314f06539ee56ebc83\":\"0x215f835bc769da80000\",\"0x0f4f94b9191bb7bb556aaad7c74ddb288417a50b\":\"0x4be4e7267b6ae00000\",\"0x0f6000de1578619320aba5e392706b131fb1de6f\":\"0x1b1ab319f5ec750000\",\"0x0f6e840a3f2a24647d8e43e09d45c7c335df4248\":\"0x878678326eac900000\",\"0x0f7515ff0e808f695e0c20485ff96ed2f7b79310\":\"0x3638221660a5aa8000\",\"0x0f789e30397c53bf256fc364e6ef39f853504114\":\"0xc55325ca7415e00000\",\"0x0f7b61c59b016322e8226cafaee9d9e76d50a1b3\":\"0xd8d726b7177a800000\",\"0x0f7bea4ef3f73ae0233df1e100718cbe29310bb0\":\"0x6c6b935b8bbd400000\",\"0x0f7bf6373f771a4601762c4dae5fbbf4fedd9cc9\":\"0x6c6b935b8bbd400000\",\"0x0f832a93df9d7f74cd0fb8546b7198bf5377d925\":\"0x7c0860e5a80dc0000\",\"0x0f83461ba224bb1e8fdd9dae535172b735acb4e0\":\"0xad78ebc5ac6200000\",\"0x0f85e42b1df321a4b3e835b50c00b06173968436\":\"0x35659ef93f0fc40000\",\"0x0f88aac9346cb0e7347fba70905475ba8b3e5ece\":\"0x21e19e0c9bab2400000\",\"0x0f929cf895db017af79f3ead2216b1bd69c37dc7\":\"0x6c6b935b8bbd400000\",\"0x0fa010ce0c731d3b628e36b91f571300e49dbeab\":\"0x36330322d5238c0000\",\"0x0fa5d8c5b3f294efd495ab69d768f81872508548\":\"0x6c6b935b8bbd400000\",\"0x0fa6c7b0973d0bae2940540e247d3627e37ca347\":\"0x3635c9adc5dea00000\",\"0x0fad05507cdc8f24b2be4cb7fa5d927ddb911b88\":\"0xa2df13f441f0098000\",\"0x0fb5d2c673bfb1ddca141b9894fd6d3f05da6720\":\"0x56bc75e2d63100000\",\"0x0fc9a0e34145fbfdd2c9d2a499b617d7a02969b9\":\"0x9c2007651b2500000\",\"0x0fcfc4065008cfd323305f6286b57a4dd7eee23b\":\"0x43c33c1937564800000\",\"0x0fdd65402395df9bd19fee4507ef5345f745104c\":\"0x10f0cf064dd59200000\",\"0x0fec4ee0d7ca180290b6bd20f9992342f60ff68d\":\"0x12207f0edce9718000\",\"0x0fee81ac331efd8f81161c57382bb4507bb9ebec\":\"0x15af880d8cdb830000\",\"0x0ffea06d7113fb6aec2869f4a9dfb09007facef4\":\"0xc384681b1e1740000\",\"0x10097198b4e7ee91ff82cc2f3bd95fed73c540c0\":\"0x6c6b935b8bbd400000\",\"0x100b4d0977fcbad4debd5e64a0497aeae5168fab\":\"0x110c9073b5245a0000\",\"0x101a0a64f9afcc448a8a130d4dfcbee89537d854\":\"0x337fe5feaf2d1800000\",\"0x102c477d69aadba9a0b0f62b7459e17fbb1c1561\":\"0x6c6b935b8bbd400000\",\"0x1031e0ecb54985ae21af1793950dc811888fde7c\":\"0x1158e460913d00000\",\"0x10346414bec6d3dcc44e50e54d54c2b8c3734e3e\":\"0xd8d726b7177a800000\",\"0x10389858b800e8c0ec32f51ed61a355946cc409b\":\"0xad78ebc5ac6200000\",\"0x1059cbc63e36c43e88f30008aca7ce058eeaa096\":\"0x152d02c7e14af6800000\",\"0x106ed5c719b5261477890425ae7551dc59bd255c\":\"0x2896a58c95be5880000\",\"0x10711c3dda32317885f0a2fd8ae92e82069b0d0b\":\"0xd8d726b7177a800000\",\"0x107379d4c467464f235bc18e55938aad3e688ad7\":\"0x2b5e3af16b1880000\",\"0x1076212d4f758c8ec7121c1c7d74254926459284\":\"0x7695b59b5c17b4c0000\",\"0x1078d7f61b0e56c74ee6635b2e1819ef1e3d8785\":\"0x3635c9adc5dea00000\",\"0x107a03cf0842dbdeb0618fb587ca69189ec92ff5\":\"0x6acb3df27e1f880000\",\"0x1080c1d8358a15bc84dac8253c6883319020df2c\":\"0x90f534608a72880000\",\"0x108a2b7c336f784779d8b54d02a8d31d9a139c0a\":\"0x21e19e0c9bab2400000\",\"0x108ba7c2895c50e072dc6f964932d50c282d3034\":\"0x1b1ae4d6e2ef500000\",\"0x108fe8ee2a13da487b22c6ab6d582ea71064d98c\":\"0x15ac56edc4d12c0000\",\"0x1091176be19b9964a8f72e0ece6bf8e3cfad6e9c\":\"0x21f2f6f0fc3c6100000\",\"0x1098c774c20ca1daac5ddb620365316d353f109c\":\"0x56bc75e2d63100000\",\"0x1098cc20ef84bad5146639c4cd1ca6c3996cb99b\":\"0xfc936392801c0000\",\"0x10a1c42dc1ba746986b985a522a73c93eae64c63\":\"0x3635c9adc5dea00000\",\"0x10a93457496f1108cd98e140a1ecdbae5e6de171\":\"0x15a99062d416180000\",\"0x10b5b34d1248fcf017f8c8ffc408ce899ceef92f\":\"0xe7eeba3410b740000\",\"0x10cf560964ff83c1c9674c783c0f73fcd89943fc\":\"0x878678326eac9000000\",\"0x10d32416722ca4e648630548ead91edd79c06aff\":\"0x56bc75e2d63100000\",\"0x10d945334ecde47beb9ca3816c173dfbbd0b5333\":\"0x4be4e7267b6ae00000\",\"0x10df681506e34930ac7a5c67a54c3e89ce92b981\":\"0x74c1fab8adb4540000\",\"0x10e1e3377885c42d7df218522ee7766887c05e6a\":\"0x1043c43cde1d398000\",\"0x10e390ad2ba33d82b37388d09c4544c6b0225de5\":\"0xad78ebc5ac6200000\",\"0x10f4bff0caa5027c0a6a2dcfc952824de2940909\":\"0x6c6b935b8bbd400000\",\"0x11001b89ed873e3aaec1155634b4681643986323\":\"0x3635c9adc5dea00000\",\"0x110237cf9117e767922fc4a1b78d7964da82df20\":\"0xd5967be4fc3f100000\",\"0x1111e5dbf45e6f906d62866f1708101788ddd571\":\"0x467be6533ec2e40000\",\"0x11172b278ddd44eea2fdf4cb1d16962391c453d9\":\"0xc62f3d9bfd4895f00000\",\"0x112634b4ec30ff786e024159f796a57939ea144e\":\"0x6c6acc67d7b1d40000\",\"0x11306c7d57588637780fc9fde8e98ecb008f0164\":\"0x6c6acc67d7b1d40000\",\"0x113612bc3ba0ee4898b49dd20233905f2f458f62\":\"0x2f6f10780d22cc00000\",\"0x11415fab61e0dfd4b90676141a557a869ba0bde9\":\"0x6f05b59d3b20000000\",\"0x114cbbbf6fb52ac414be7ec61f7bb71495ce1dfa\":\"0xa2a15d09519be00000\",\"0x114cfefe50170dd97ae08f0a44544978c599548d\":\"0x2ec887e7a14a1c0000\",\"0x116108c12084612eeda7a93ddcf8d2602e279e5c\":\"0x6c6b935b8bbd400000\",\"0x1164caaa8cc5977afe1fad8a7d6028ce2d57299b\":\"0x15af1d78b58c400000\",\"0x11675a25554607a3b6c92a9ee8f36f75edd3e336\":\"0x8a9aba557e36c0000\",\"0x116a09df66cb150e97578e297fb06e13040c893c\":\"0x6c6b935b8bbd400000\",\"0x116fef5e601642c918cb89160fc2293ba71da936\":\"0x2b7cc2e9c3225c0000\",\"0x1178501ff94add1c5881fe886136f6dfdbe61a94\":\"0x890b0c2e14fb80000\",\"0x1179c60dbd068b150b074da4be23033b20c68558\":\"0x24dce54d34a1a00000\",\"0x117d9aa3c4d13bee12c7500f09f5dd1c66c46504\":\"0xb2ad30490b2780000\",\"0x117db836377fe15455e02c2ebda40b1ceb551b19\":\"0x14542ba12a337c00000\",\"0x118c18b2dce170e8f445753ba5d7513cb7636d2d\":\"0x1dd0c885f9a0d800000\",\"0x118fbd753b9792395aef7a4d78d263cdcaabd4f7\":\"0x36330322d5238c0000\",\"0x11928378d27d55c520ceedf24ceb1e822d890df0\":\"0x1b1ae4d6e2ef5000000\",\"0x119aa64d5b7d181dae9d3cb449955c89c1f963fa\":\"0x25f273933db5700000\",\"0x11c0358aa6479de21866fe21071924b65e70f8b9\":\"0x7b53f79e888dac00000\",\"0x11d2247a221e70c2d66d17ee138d38c55ffb8640\":\"0x21e19e0c9bab2400000\",\"0x11d7844a471ef89a8d877555583ceebd1439ea26\":\"0x22369e6ba80c6880000\",\"0x11dd6185d9a8d73ddfdaa71e9b7774431c4dfec2\":\"0x3635c9adc5dea00000\",\"0x11e7997edd904503d77da6038ab0a4c834bbd563\":\"0x150894e849b3900000\",\"0x11ec00f849b6319cf51aa8dd8f66b35529c0be77\":\"0x6c6b935b8bbd400000\",\"0x11efb8a20451161b644a8ccebbc1d343a3bbcb52\":\"0xad78ebc5ac62000000\",\"0x11fefb5dc1a4598aa712640c517775dfa1d91f8c\":\"0x21e19e0c9bab2400000\",\"0x120f9de6e0af7ec02a07c609ca8447f157e6344c\":\"0xe7eeba3410b740000\",\"0x1210f80bdb826c175462ab0716e69e46c24ad076\":\"0x56bc75e2d63100000\",\"0x12134e7f6b017bf48e855a399ca58e2e892fa5c8\":\"0x3635c9adc5dea00000\",\"0x12173074980153aeaa4b0dcbc7132eadcec21b64\":\"0xd02ab486cedc00000\",\"0x121f855b70149ac83473b9706fb44d47828b983b\":\"0x4be4e7267b6ae00000\",\"0x1227e10a4dbf9caca31b1780239f557615fc35c1\":\"0xad78ebc5ac6200000\",\"0x122dcfd81addb97d1a0e4925c4b549806e9f3beb\":\"0x522035cc6e01210000\",\"0x122f56122549d168a5c5e267f52662e5c5cce5c8\":\"0xa076407d3f7440000\",\"0x12316fc7f178eac22eb2b25aedeadf3d75d00177\":\"0x43c33be05f6bfb98000\",\"0x123759f333e13e3069e2034b4f05398918119d36\":\"0x43c33c1937564800000\",\"0x125cc5e4d56b2bcc2ee1c709fb9e68fb177440bd\":\"0x6c6b935b8bbd400000\",\"0x12632388b2765ee4452b50161d1fffd91ab81f4a\":\"0x281d901f4fdd100000\",\"0x126897a311a14ad43b78e0920100c4426bfd6bdd\":\"0x34c726893f2d948000\",\"0x126d91f7ad86debb0557c612ca276eb7f96d00a1\":\"0x56bc75e2d63100000\",\"0x127d3fc5003bf63c0d83e93957836515fd279045\":\"0x610c9222e6e750000\",\"0x127db1cadf1b771cbd7475e1b272690f558c8565\":\"0x2f6f10780d22cc00000\",\"0x1284f0cee9d2ff2989b65574d06ffd9ab0f7b805\":\"0x15af1d78b58c400000\",\"0x128b908fe743a434203de294c441c7e20a86ea67\":\"0x26ab14e0c0e13c0000\",\"0x1293c78c7d6a443b9d74b0ba5ee7bb47fd418588\":\"0x16a6502f15a1e540000\",\"0x1296acded1e063af39fe8ba0b4b63df789f70517\":\"0x56bf91b1a65eb0000\",\"0x12aa7d86ddfbad301692feac8a08f841cb215c37\":\"0x76d41c62494840000\",\"0x12afbcba1427a6a39e7ba4849f7ab1c4358ac31b\":\"0x43c33c1937564800000\",\"0x12b5e28945bb2969f9c64c63cc05b6f1f8d6f4d5\":\"0x1a29e86913b74050000\",\"0x12cf8b0e465213211a5b53dfb0dd271a282c12c9\":\"0xd2f13f7789f00000\",\"0x12d20790b7d3dbd88c81a279b812039e8a603bd0\":\"0x56f985d38644b80000\",\"0x12d60d65b7d9fc48840be5f891c745ce76ee501e\":\"0x485e5388d0c76840000\",\"0x12d91a92d74fc861a729646db192a125b79f5374\":\"0xfc936392801c0000\",\"0x12e9a4ad2ad57484dd700565bddb46423bd9bd31\":\"0x43c30fb0884a96c0000\",\"0x12f32c0a1f2daab676fe69abd9e018352d4ccd45\":\"0x2b5e3af16b1880000\",\"0x12f460ae646cd2780fd35c50a6af4b9accfa85c6\":\"0x3635c9adc5dea00000\",\"0x12ffc1128605cb0c13709a7290506f2690977193\":\"0xb50fcfafebecb00000\",\"0x13032446e7d610aa00ec8c56c9b574d36ca1c016\":\"0x6c6b935b8bbd400000\",\"0x131c792c197d18bd045d7024937c1f84b60f4438\":\"0xd8d726b7177a800000\",\"0x131df8d330eb7cc7147d0a55576f05de8d26a8b7\":\"0xa31062beeed700000\",\"0x131faed12561bb7aee04e5185af802b1c3438d9b\":\"0xbdf3c4bb0328c0000\",\"0x1321b605026f4ffb296a3e0edcb390c9c85608b7\":\"0x6c6b935b8bbd400000\",\"0x1321ccf29739b974e5a516f18f3a843671e39642\":\"0xd8d726b7177a800000\",\"0x1327d759d56e0ab87af37ecf63fe01f310be100a\":\"0x23bc3cdb68a1800000\",\"0x1329dd19cd4baa9fc64310efeceab22117251f12\":\"0xad78ebc5ac6200000\",\"0x13371f92a56ea8381e43059a95128bdc4d43c5a6\":\"0x3635c9adc5dea00000\",\"0x133c490fa5bf7f372888e607d958fab7f955bae1\":\"0x55a6e79ccd1d300000\",\"0x133e4f15e1e39c53435930aaedf3e0fe56fde843\":\"0x1158e460913d00000\",\"0x134163be9fbbe1c5696ee255e90b13254395c318\":\"0xad78ebc5ac6200000\",\"0x135cecd955e5798370769230159303d9b1839f66\":\"0x10f0cf064dd59200000\",\"0x135d1719bf03e3f866312479fe338118cd387e70\":\"0x6c6b935b8bbd400000\",\"0x135eb8c0e9e101deedec11f2ecdb66ae1aae8867\":\"0x43c33c1937564800000\",\"0x1360e87df24c69ee6d51c76e73767ffe19a2131c\":\"0x4fcc1a89027f00000\",\"0x136c834bf111326d207395295b2e583ea7f33572\":\"0x56bc75e2d63100000\",\"0x136d4b662bbd1080cfe4445b0fa213864435b7f1\":\"0xd8d726b7177a800000\",\"0x136f4907cab41e27084b9845069ff2fd0c9ade79\":\"0xd8d726b7177a800000\",\"0x1374facd7b3f8d68649d60d4550ee69ff0484133\":\"0xe9ed6e11172da0000\",\"0x137cf341e8516c815814ebcd73e6569af14cf7bc\":\"0x3635c9adc5dea00000\",\"0x13848b46ea75beb7eaa85f59d866d77fd24cf21a\":\"0xa968163f0a57b400000\",\"0x139d3531c9922ad56269f6309aa789fb2485f98c\":\"0xd8d726b7177a800000\",\"0x139e479764b499d666208c4a8a047a97043163dd\":\"0x2077212aff6df00000\",\"0x13a5eecb38305df94971ef2d9e179ae6cebab337\":\"0x11e3ab8395c6e80000\",\"0x13acada8980affc7504921be84eb4944c8fbb2bd\":\"0x56d2aa3a5c09a00000\",\"0x13b9b10715714c09cfd610cf9c9846051cb1d513\":\"0x6acb3df27e1f880000\",\"0x13ce332dff65a6ab933897588aa23e000980fa82\":\"0xe020536f028f00000\",\"0x13d67a7e25f2b12cdb85585009f8acc49b967301\":\"0x6c6acc67d7b1d40000\",\"0x13dee03e3799952d0738843d4be8fc0a803fb20e\":\"0x6c6b935b8bbd400000\",\"0x13e02fb448d6c84ae17db310ad286d056160da95\":\"0x6c6b935b8bbd400000\",\"0x13e321728c9c57628058e93fc866a032dd0bda90\":\"0x26bcca23fe2ea20000\",\"0x13ec812284026e409bc066dfebf9d5a4a2bf801e\":\"0x57473d05dabae80000\",\"0x140129eaa766b5a29f5b3af2574e4409f8f6d3f1\":\"0x15af1d78b58c4000000\",\"0x140518a3194bad1350b8949e650565debe6db315\":\"0x6c6b935b8bbd400000\",\"0x1406854d149e081ac09cb4ca560da463f3123059\":\"0x487a9a304539440000\",\"0x140ca28ff33b9f66d7f1fc0078f8c1eef69a1bc0\":\"0x56bc75e2d631000000\",\"0x140fba58dbc04803d84c2130f01978f9e0c73129\":\"0x15af1d78b58c400000\",\"0x141a5e39ee2f680a600fbf6fa297de90f3225cdd\":\"0x21e19e0c9bab2400000\",\"0x14254ea126b52d0142da0a7e188ce255d8c47178\":\"0x2a034919dfbfbc0000\",\"0x142b87c5043ffb5a91df18c2e109ced6fe4a71db\":\"0xad78ebc5ac6200000\",\"0x143c639752caeecf6a997d39709fc8f19878c7e8\":\"0x6acb3df27e1f880000\",\"0x143d536b8b1cb84f56a39e0bc81fd5442bcacce1\":\"0x56bc75e2d63100000\",\"0x143f5f1658d9e578f4f3d95f80c0b1bd3933cbda\":\"0x50c5e761a444080000\",\"0x14410fb310711be074a80883c635d0ef6afb2539\":\"0x6c6b935b8bbd400000\",\"0x144b19f1f66cbe318347e48d84b14039466c5909\":\"0x6c6b935b8bbd400000\",\"0x145250b06e4fa7cb2749422eb817bdda8b54de5f\":\"0xbdf3c4bb0328c0000\",\"0x145e0600e2a927b2dd8d379356b45a2e7d51d3ae\":\"0x8a02ab400bb2cb8000\",\"0x145e1de0147911ccd880875fbbea61f6a142d11d\":\"0xd8d726b7177a800000\",\"0x1463a873555bc0397e575c2471cf77fa9db146e0\":\"0x21e19e0c9bab2400000\",\"0x1479a9ec7480b74b5db8fc499be352da7f84ee9c\":\"0x3635c9adc5dea00000\",\"0x147af46ae9ccd18bb35ca01b353b51990e49dce1\":\"0xd8d726b7177a800000\",\"0x147f4210ab5804940a0b7db8c14c28396b62a6bf\":\"0x6c6b935b8bbd400000\",\"0x14830704e99aaad5c55e1f502b27b22c12c91933\":\"0x219c3a7b1966300000\",\"0x149b6dbde632c19f5af47cb493114bebd9b03c1f\":\"0x28a857425466f800000\",\"0x149ba10f0da2725dc704733e87f5a524ca88515e\":\"0x1ab2cf7c9f87e200000\",\"0x14a7352066364404db50f0d0d78d754a22198ef4\":\"0x65ea3db75546600000\",\"0x14ab164b3b524c82d6abfbc0de831126ae8d1375\":\"0x6c6b935b8bbd400000\",\"0x14b1603ec62b20022033eec4d6d6655ac24a015a\":\"0x2b5e3af16b1880000\",\"0x14c63ba2dcb1dd4df33ddab11c4f0007fa96a62d\":\"0x34841b6057afab00000\",\"0x14cdddbc8b09e6675a9e9e05091cb92238c39e1e\":\"0x11478b7c30abc300000\",\"0x14d00aad39a0a7d19ca05350f7b03727f08dd82e\":\"0x1b1ae4d6e2ef500000\",\"0x14eec09bf03e352bd6ff1b1e876be664ceffd0cf\":\"0x116dc3a8994b30000\",\"0x14f221159518783bc4a706676fc4f3c5ee405829\":\"0xad78ebc5ac6200000\",\"0x14fcd1391e7d732f41766cdacd84fa1deb9ffdd2\":\"0x6c6b935b8bbd400000\",\"0x150e3dbcbcfc84ccf89b73427763a565c23e60d0\":\"0x22b1c8c1227a00000\",\"0x1518627b88351fede796d3f3083364fbd4887b0c\":\"0x3635c9adc5dea000000\",\"0x15224ad1c0face46f9f556e4774a3025ad06bd52\":\"0xb98bc829a6f90000\",\"0x152f2bd229ddf3cb0fdaf455c183209c0e1e39a2\":\"0x6c6b935b8bbd400000\",\"0x152f4e860ef3ee806a502777a1b8dbc91a907668\":\"0x2086ac351052600000\",\"0x153c08aa8b96a611ef63c0253e2a4334829e579d\":\"0x155bd9307f9fe80000\",\"0x153cf2842cb9de876c276fa64767d1a8ecf573bb\":\"0x6c6b935b8bbd400000\",\"0x153ef58a1e2e7a3eb6b459a80ab2a547c94182a2\":\"0x14542ba12a337c000000\",\"0x154459fa2f21318e3434449789d826cdc1570ce5\":\"0x6c6b935b8bbd400000\",\"0x1547b9bf7ad66274f3413827231ba405ee8c88c1\":\"0x3a9d5baa4abf1d00000\",\"0x1548b770a5118ede87dba2f690337f616de683ab\":\"0x1c995685e0bf870000\",\"0x15528350e0d9670a2ea27f7b4a33b9c0f9621d21\":\"0xd8d8583fa2d52f0000\",\"0x155b3779bb6d56342e2fda817b5b2d81c7f41327\":\"0x2b8aa3a076c9c0000\",\"0x1565af837ef3b0bd4e2b23568d5023cd34b16498\":\"0x1551e9724ac4ba0000\",\"0x15669180dee29598869b08a721c7d24c4c0ee63f\":\"0x3635c9adc5dea00000\",\"0x1572cdfab72a01ce968e78f5b5448da29853fbdd\":\"0x112626c49060fa60000\",\"0x157559adc55764cc6df79323092534e3d6645a66\":\"0x14542ba12a337c00000\",\"0x1578bdbc371b4d243845330556fff2d5ef4dff67\":\"0x56bc75e2d63100000\",\"0x157eb3d3113bd3b597714d3a954edd018982a5cb\":\"0x6c6b935b8bbd400000\",\"0x1584a2c066b7a455dbd6ae2807a7334e83c35fa5\":\"0x70c1cc73b00c80000\",\"0x15874686b6733d10d703c9f9bec6c52eb8628d67\":\"0x6c6b935b8bbd400000\",\"0x158a0d619253bf4432b5cd02c7b862f7c2b75636\":\"0x75bac7c5b12188000\",\"0x1598127982f2f8ad3b6b8fc3cf27bf617801ba2b\":\"0x960db77681e940000\",\"0x159adce27aa10b47236429a34a5ac42cad5b6416\":\"0x6bf90a96edbfa718000\",\"0x15a0aec37ff9ff3d5409f2a4f0c1212aaccb0296\":\"0x3635c9adc5dea00000\",\"0x15aa530dc36958b4edb38eee6dd9e3c77d4c9145\":\"0x6c6b935b8bbd400000\",\"0x15acb61568ec4af7ea2819386181b116a6c5ee70\":\"0x690836c0af5f5600000\",\"0x15b96f30c23b8664e7490651066b00c4391fbf84\":\"0x1642e9df4876290000\",\"0x15c7edb8118ee27b342285eb5926b47a855bc7a5\":\"0x1158e460913d00000\",\"0x15d99468507aa0413fb60dca2adc7f569cb36b54\":\"0x6c6b935b8bbd400000\",\"0x15dbb48c98309764f99ced3692dcca35ee306bac\":\"0x1fc3842bd1f071c00000\",\"0x15dcafcc2bace7b55b54c01a1c514626bf61ebd8\":\"0x1fd933494aa5fe00000\",\"0x15e3b584056b62c973cf5eb096f1733e54c15c91\":\"0x32c75a0223ddf30000\",\"0x15ebd1c7cad2aff19275c657c4d808d010efa0f5\":\"0xadf30ba70c8970000\",\"0x15ee0fc63ebf1b1fc49d7bb38f8863823a2e17d2\":\"0x678a932062e4180000\",\"0x15f1b352110d68901d8f67aac46a6cfafe031477\":\"0xad78ebc5ac6200000\",\"0x15f2b7b16432ee50a5f55b41232f6334ed58bdc0\":\"0x15af1d78b58c400000\",\"0x16019a4dafab43f4d9bf4163fae0847d848afca2\":\"0x15bc70139f74a0000\",\"0x160226efe7b53a8af462d117a0108089bdecc2d1\":\"0xadf30ba70c8970000\",\"0x160ceb6f980e04315f53c4fc988b2bf69e284d7d\":\"0x10910d4cdc9f60000\",\"0x161caf5a972ace8379a6d0a04ae6e163fe21df2b\":\"0x152d02c7e14af6800000\",\"0x161d26ef6759ba5b9f20fdcd66f16132c352415e\":\"0x6c6b935b8bbd400000\",\"0x162110f29eac5f7d02b543d8dcd5bb59a5e33b73\":\"0x6c6b935b8bbd400000\",\"0x162ba503276214b509f97586bd842110d103d517\":\"0x1e7ffd8895c22680000\",\"0x162d76c2e6514a3afb6fe3d3cb93a35c5ae783f1\":\"0x6c6b935b8bbd400000\",\"0x163bad4a122b457d64e8150a413eae4d07023e6b\":\"0x104e70464b1580000\",\"0x163cc8be227646cb09719159f28ed09c5dc0dce0\":\"0x487a9a304539440000\",\"0x163dca73d7d6ea3f3e6062322a8734180c0b78ef\":\"0x9f742003cb7dfc0000\",\"0x164d7aac3eecbaeca1ad5191b753f173fe12ec33\":\"0x285652b8a468690000\",\"0x16526c9edf943efa4f6d0f0bae81e18b31c54079\":\"0x35659ef93f0fc40000\",\"0x165305b787322e25dc6ad0cefe6c6f334678d569\":\"0x6c6b935b8bbd400000\",\"0x1665ab1739d71119ee6132abbd926a279fe67948\":\"0x56bc75e2d63100000\",\"0x166bf6dab22d841b486c38e7ba6ab33a1487ed8c\":\"0x43c33c1937564800000\",\"0x167699f48a78c615512515739958993312574f07\":\"0x21d3bd55e803c0000\",\"0x1678c5f2a522393225196361894f53cc752fe2f3\":\"0x68f365aea1e4400000\",\"0x167ce7de65e84708595a525497a3eb5e5a665073\":\"0x1f314773666fc40000\",\"0x167e3e3ae2003348459392f7dfce44af7c21ad59\":\"0x1b1ae4d6e2ef500000\",\"0x1680cec5021ee93050f8ae127251839e74c1f1fd\":\"0x2c61461e5d743d68000\",\"0x16816aac0ede0d2d3cd442da79e063880f0f1d67\":\"0x6c6b935b8bbd400000\",\"0x168b5019b818691644835fe69bf229e17112d52c\":\"0x5ede20f01a459800000\",\"0x168bdec818eafc6d2992e5ef54aa0e1601e3c561\":\"0x3637507a30abeb0000\",\"0x168d30e53fa681092b52e9bae15a0dcb41a8c9bb\":\"0x56bc75e2d63100000\",\"0x169bbefc41cfd7d7cbb8dfc63020e9fb06d49546\":\"0x6c6b935b8bbd400000\",\"0x16a58e985dccd707a594d193e7cca78b5d027849\":\"0x49b9ca9a6943400000\",\"0x16a9e9b73ae98b864d1728798b8766dbc6ea8d12\":\"0x33e7b44b0db5040000\",\"0x16aa52cb0b554723e7060f21f327b0a68315fea3\":\"0xd8d726b7177a80000\",\"0x16abb8b021a710bdc78ea53494b20614ff4eafe8\":\"0x890b0c2e14fb80000\",\"0x16afa787fc9f94bdff6976b1a42f430a8bf6fb0f\":\"0x6c6b935b8bbd400000\",\"0x16bae5d24eff91778cd98b4d3a1cc3162f44aa77\":\"0x15be6174e1912e0000\",\"0x16bc40215abbd9ae5d280b95b8010b4514ff1292\":\"0xad78ebc5ac6200000\",\"0x16be75e98a995a395222d00bd79ff4b6e638e191\":\"0x79f905c6fd34e800000\",\"0x16c1bf5b7dc9c83c179efacbcf2eb174e3561cb3\":\"0x3635c9adc5dea00000\",\"0x16c7b31e8c376282ac2271728c31c95e35d952c3\":\"0x6c6b935b8bbd400000\",\"0x16f313cf8ad000914a0a176dc6a4342b79ec2538\":\"0x6c6b935b8bbd400000\",\"0x16ffac84032940f0121a09668b858a7e79ffa3bb\":\"0xd24ada6e1087110000\",\"0x1703b4b292b8a9deddede81bb25d89179f6446b6\":\"0x42b65a455e8b1680000\",\"0x17049311101d817efb1d65910f663662a699c98c\":\"0x6c68ccd09b022c0000\",\"0x1704cefcfb1331ec7a78388b29393e85c1af7916\":\"0x15af1d78b58c400000\",\"0x170a88a8997f92d238370f1affdee6347050b013\":\"0xa2ac77351488300000\",\"0x17108dab2c50f99de110e1b3b3b4cd82f5df28e7\":\"0x35203b67bccad00000\",\"0x17125b59ac51cee029e4bd78d7f5947d1ea49bb2\":\"0x4a89f54ef0121c00000\",\"0x171ad9a04bedc8b861e8ed4bddf5717813b1bb48\":\"0x15af1d78b58c400000\",\"0x171ca02a8b6d62bf4ca47e906914079861972cb2\":\"0xad78ebc5ac6200000\",\"0x1722c4cbe70a94b6559d425084caeed4d6e66e21\":\"0xd8d726b7177a800000\",\"0x17580b766f7453525ca4c6a88b01b50570ea088c\":\"0x56bc75e2d63100000\",\"0x17589a6c006a54cad70103123aae0a82135fdeb4\":\"0xd8d726b7177a800000\",\"0x175a183a3a235ffbb03ba835675267229417a091\":\"0x3635c9adc5dea000000\",\"0x175feeea2aa4e0efda12e1588d2f483290ede81a\":\"0xad78ebc5ac6200000\",\"0x1765361c2ec2f83616ce8363aae21025f2566f40\":\"0x10f0cf064dd59200000\",\"0x1767525c5f5a22ed80e9d4d7710f0362d29efa33\":\"0x15af1d78b58c400000\",\"0x17762560e82a93b3f522e0e524adb8612c3a7470\":\"0x3635c9adc5dea00000\",\"0x177dae78bc0113d8d39c4402f2a641ae2a105ab8\":\"0x6292425620b4480000\",\"0x1784948bf99848c89e445638504dd698271b5924\":\"0x1474c410d87baee0000\",\"0x1788da9b57fd05edc4ff99e7fef301519c8a0a1e\":\"0x6c6b935b8bbd400000\",\"0x178eaf6b8554c45dfde16b78ce0c157f2ee31351\":\"0x1158e460913d000000\",\"0x17961d633bcf20a7b029a7d94b7df4da2ec5427f\":\"0xc6ff070f1938b8000\",\"0x1796bcc97b8abc717f4b4a7c6b1036ea2182639f\":\"0x1341f91cd8e3510000\",\"0x17993d312aa1106957868f6a55a5e8f12f77c843\":\"0x1865e814f4142e8000\",\"0x179a825e0f1f6e985309668465cffed436f6aea9\":\"0x1158e460913d00000\",\"0x17b2d6cf65c6f4a347ddc6572655354d8a412b29\":\"0x6c6b935b8bbd400000\",\"0x17b807afa3ddd647e723542e7b52fee39527f306\":\"0x15af40ffa7fc010000\",\"0x17c0478657e1d3d17aaa331dd429cecf91f8ae5d\":\"0x3634fb9f1489a70000\",\"0x17c0fef6986cfb2e4041f9979d9940b69dff3de2\":\"0xd8d726b7177a800000\",\"0x17d4918dfac15d77c47f9ed400a850190d64f151\":\"0x6c6b935b8bbd400000\",\"0x17d521a8d9779023f7164d233c3b6420ffd223ed\":\"0x1158e460913d00000\",\"0x17d931d4c56294dcbe77c8655be4695f006d4a3c\":\"0x6c6b935b8bbd400000\",\"0x17df49518d73b129f0da36b1c9b40cb66420fdc7\":\"0x21e19e0c9bab2400000\",\"0x17e4a0e52bac3ee44efe0954e753d4b85d644e05\":\"0x6c6b935b8bbd400000\",\"0x17e584e810e567702c61d55d434b34cdb5ee30f6\":\"0x10f0cf064dd59200000\",\"0x17e82e7078dc4fd9e879fb8a50667f53a5c54591\":\"0xad78ebc5ac6200000\",\"0x17e86f3b5b30c0ba59f2b2e858425ba89f0a10b0\":\"0x6c6b935b8bbd400000\",\"0x17ee9f54d4ddc84d670eff11e54a659fd72f4455\":\"0x3635c9adc5dea000000\",\"0x17ef4acc1bf147e326749d10e677dcffd76f9e06\":\"0x87751f4e0e1b5300000\",\"0x17f14632a7e2820be6e8f6df823558283dadab2d\":\"0x6c6b935b8bbd400000\",\"0x17f523f117bc9fe978aa481eb4f5561711371bc8\":\"0x6c69f73e29134e0000\",\"0x17fd9b551a98cb61c2e07fbf41d3e8c9a530cba5\":\"0x1768c308193048000\",\"0x180478a655d78d0f3b0c4f202b61485bc4002fd5\":\"0x6c6b935b8bbd400000\",\"0x18136c9df167aa17b6f18e22a702c88f4bc28245\":\"0xd8d726b7177a800000\",\"0x1815279dff9952da3be8f77249dbe22243377be7\":\"0x1017cb76e7b26640000\",\"0x181fbba852a7f50178b1c7f03ed9e58d54162929\":\"0x241a9b4f617a280000\",\"0x1827039f09570294088fddf047165c33e696a492\":\"0x205b4dfa1ee74780000\",\"0x182db85293f606e88988c3704cb3f0c0bbbfca5a\":\"0x73f75d1a085ba0000\",\"0x1848003c25bfd4aa90e7fcb5d7b16bcd0cffc0d8\":\"0x3635c9adc5dea00000\",\"0x184a4f0beb71ffd558a6b6e8f228b78796c4cf3e\":\"0x28a857425466f800000\",\"0x184d86f3466ae6683b19729982e7a7e1a48347b2\":\"0x21e19e0c9bab2400000\",\"0x1851a063ccdb30549077f1d139e72de7971197d5\":\"0x6c6b935b8bbd400000\",\"0x185546e8768d506873818ac9751c1f12116a3bef\":\"0xad78ebc5ac6200000\",\"0x1858cf11aea79f5398ad2bb22267b5a3c952ea74\":\"0x215f835bc769da80000\",\"0x185a7fc4ace368d233e620b2a45935661292bdf2\":\"0x43c33c1937564800000\",\"0x1864a3c7b48155448c54c88c708f166709736d31\":\"0x73f75d1a085ba0000\",\"0x186afdc085f2a3dce4615edffbadf71a11780f50\":\"0xad78ebc5ac6200000\",\"0x186b95f8e5effddcc94f1a315bf0295d3b1ea588\":\"0x6c6acc67d7b1d40000\",\"0x187d9f0c07f8eb74faaad15ebc7b80447417f782\":\"0x1158e460913d00000\",\"0x1895a0eb4a4372722fcbc5afe6936f289c88a419\":\"0x3154c9729d05780000\",\"0x1899f69f653b05a5a6e81f480711d09bbf97588c\":\"0x69fb133df750ac0000\",\"0x18a6d2fc52be73084023c91802f05bc24a4be09f\":\"0x6c6b935b8bbd400000\",\"0x18b0407cdad4ce52600623bd5e1f6a81ab61f026\":\"0x1151ccf0c654c68000\",\"0x18b8bcf98321da61fb4e3eacc1ec5417272dc27e\":\"0x2fb474098f67c00000\",\"0x18c6723a6753299cb914477d04a3bd218df8c775\":\"0x3635c9adc5dea00000\",\"0x18e113d8177c691a61be785852fa5bb47aeebdaf\":\"0x487a9a304539440000\",\"0x18e4ce47483b53040adbab35172c01ef64506e0c\":\"0x1e7e4171bf4d3a00000\",\"0x18e53243981aabc8767da10c73449f1391560eaa\":\"0x14542ba12a337c00000\",\"0x18fa8625c9dc843c78c7ab259ff87c9599e07f10\":\"0x3635c9adc5dea00000\",\"0x18fb09188f27f1038e654031924f628a2106703d\":\"0x6c6b935b8bbd400000\",\"0x18fccf62d2c3395453b7587b9e26f5cff9eb7482\":\"0x3635c9adc5dea00000\",\"0x191313525238a21c767457a91374f02200c55448\":\"0x64f5fdf494f780000\",\"0x1914f1eb95d1277e93b6e61b668b7d77f13a11a1\":\"0x34957444b840e80000\",\"0x1923cfc68b13ea7e2055803645c1e320156bd88d\":\"0x487a9a304539440000\",\"0x19336a236ded755872411f2e0491d83e3e00159e\":\"0x32f51edbaaa3300000\",\"0x1933e334c40f3acbad0c0b851158206924beca3a\":\"0x1995eaf01b896188000\",\"0x1937c5c515057553ccbd46d5866455ce66290284\":\"0xd3c21bcecceda1000000\",\"0x193ac65183651800e23580f8f0ead3bb597eb8a4\":\"0x2b62abcfb910a0000\",\"0x193d37ed347d1c2f4e35350d9a444bc57ca4db43\":\"0x340aad21b3b700000\",\"0x1940dc9364a852165f47414e27f5002445a4f143\":\"0x24c2dff6a3c7c480000\",\"0x1945fe377fe6d4b71e3e791f6f17db243c9b8b0f\":\"0x7679e7beb988360000\",\"0x194a6bb302b8aba7a5b579df93e0df1574967625\":\"0x1b1ae4d6e2ef500000\",\"0x194cebb4929882bf3b4bf9864c2b1b0f62c283f9\":\"0x1ef861531f74aa0000\",\"0x194ff44aefc17bd20efd7a204c47d1620c86db5d\":\"0xa29909687f6aa40000\",\"0x194ffe78bbf5d20dd18a1f01da552e00b7b11db1\":\"0x17b7883c06916600000\",\"0x1953313e2ad746239cb2270f48af34d8bb9c4465\":\"0x6c6b935b8bbd400000\",\"0x19571a2b8f81c6bcf66ab3a10083295617150003\":\"0x1ab2cf7c9f87e20000\",\"0x19687daa39c368139b6e7be60dc1753a9f0cbea3\":\"0x1b1ae4d6e2ef5000000\",\"0x196c02210a450ab0b36370655f717aa87bd1c004\":\"0xe10ace157dbc00000\",\"0x196e85df7e732b4a8f0ed03623f4db9db0b8fa31\":\"0x125b92f5cef248000\",\"0x19732bf973055dbd91a4533adaa2149a91d38380\":\"0x6c6b935b8bbd400000\",\"0x197672fd39d6f246ce66a790d13aa922d70ea109\":\"0x3635c9adc5dea00000\",\"0x19798cbda715ea9a9b9d6aab942c55121e98bf91\":\"0x410d586a20a4c00000\",\"0x198bfcf1b07ae308fa2c02069ac9dafe7135fb47\":\"0x1158e460913d00000\",\"0x198ef1ec325a96cc354c7266a038be8b5c558f67\":\"0x80d1e4373e7f21da0000\",\"0x19918aa09e7d494e98ffa5db50350892f7156ac6\":\"0x21e19e0c9bab2400000\",\"0x19b36b0c87ea664ed80318dc77b688dde87d95a5\":\"0x699f499802303d0000\",\"0x19df9445a81c1b3d804aeaeb6f6e204e4236663f\":\"0x206d94e6a49878000\",\"0x19e5dea3370a2c746aae34a37c531f41da264e83\":\"0xad78ebc5ac6200000\",\"0x19e7f3eb7bf67f3599209ebe08b62ad3327f8cde\":\"0x6c6b935b8bbd400000\",\"0x19e94e620050aad766b9e1bad931238312d4bf49\":\"0x81e32df972abf00000\",\"0x19ecf2abf40c9e857b252fe1dbfd3d4c5d8f816e\":\"0x6c6b935b8bbd400000\",\"0x19f5caf4c40e6908813c0745b0aea9586d9dd931\":\"0x23fed9e1fa2b600000\",\"0x19f643e1a8fa04ae16006028138333a59a96de87\":\"0x1158e460913d00000\",\"0x19f99f2c0b46ce8906875dc9f90ae104dae35594\":\"0xf4575a5d4d162a0000\",\"0x19ff244fcfe3d4fa2f4fd99f87e55bb315b81eb6\":\"0xad78ebc5ac6200000\",\"0x1a04cec420ad432215246d77fe178d339ed0b595\":\"0x11216185c29f700000\",\"0x1a04d5389eb006f9ce880c30d15353f8d11c4b31\":\"0x39d84b2186dc9100000\",\"0x1a0841b92a7f7075569dc4627e6b76cab05ade91\":\"0x52663ccab1e1c00000\",\"0x1a085d43ec92414ea27b914fe767b6d46b1eef44\":\"0x641e8a13563d8f80000\",\"0x1a09fdc2c7a20e23574b97c69e93deba67d37220\":\"0x6c4fd1ee246e780000\",\"0x1a0a1ddfb031e5c8cc1d46cf05842d50fddc7130\":\"0x3635c9adc5dea00000\",\"0x1a1c9a26e0e02418a5cf687da75a275c622c9440\":\"0x10f0cf064dd59200000\",\"0x1a201b4327cea7f399046246a3c87e6e03a3cda8\":\"0x3635c9adc5dea00000\",\"0x1a2434cc774422d48d53d59c5d562cce8407c94b\":\"0x1a055690d9db80000\",\"0x1a25e1c5bc7e5f50ec16f8885f210ea1b938800e\":\"0xd8d726b7177a800000\",\"0x1a2694ec07cf5e4d68ba40f3e7a14c53f3038c6e\":\"0x3636cd06e2db3a8000\",\"0x1a3520453582c718a21c42375bc50773255253e1\":\"0x2ad373ce668e980000\",\"0x1a376e1b2d2f590769bb858d4575320d4e149970\":\"0x106712576391d180000\",\"0x1a3a330e4fcb69dbef5e6901783bf50fd1c15342\":\"0xe3aeb5737240a00000\",\"0x1a4ec6a0ae7f5a9427d23db9724c0d0cffb2ab2f\":\"0x9b41fbf9e0aec0000\",\"0x1a505e62a74e87e577473e4f3afa16bedd3cfa52\":\"0x1b1ae4d6e2ef500000\",\"0x1a5ee533acbfb3a2d76d5b685277b796c56a052b\":\"0x6c6b935b8bbd400000\",\"0x1a644a50cbc2aee823bd2bf243e825be4d47df02\":\"0x56be03ca3e47d8000\",\"0x1a7044e2383f8708305b495bd1176b92e7ef043a\":\"0xad78ebc5ac6200000\",\"0x1a79c7f4039c67a39d7513884cdc0e2c34222490\":\"0x1158e460913d00000\",\"0x1a89899cbebdbb64bb26a195a63c08491fcd9eee\":\"0x6c6b935b8bbd400000\",\"0x1a8a5ce414de9cd172937e37f2d59cff71ce57a0\":\"0x21e19e0c9bab2400000\",\"0x1a95a8a8082e4652e4170df9271cb4bb4305f0b2\":\"0x2b5e3af16b1880000\",\"0x1a95c9b7546b5d1786c3858fb1236446bc0ca4ce\":\"0x6acb3df27e1f880000\",\"0x1a987e3f83de75a42f1bde7c997c19217b4a5f24\":\"0x6c6b935b8bbd400000\",\"0x1a9e702f385dcd105e8b9fa428eea21c57ff528a\":\"0x4be4e7267b6ae00000\",\"0x1aa1021f550af158c747668dd13b463160f95a40\":\"0x4fb0591b9b30380000\",\"0x1aa27699cada8dc3a76f7933aa66c71919040e88\":\"0x15af1d78b58c400000\",\"0x1aa40270d21e5cde86b6316d1ac3c533494b79ed\":\"0x1158e460913d00000\",\"0x1ab53a11bcc63ddfaa40a02b9e186496cdbb8aff\":\"0x6c3f2aac800c000000\",\"0x1abc4e253b080aeb437984ab05bca0979aa43e1c\":\"0x3635c9adc5dea00000\",\"0x1ac089c3bc4d82f06a20051a9d732dc0e734cb61\":\"0x25f69d63a6ce0e0000\",\"0x1ad4563ea5786be1159935abb0f1d5879c3e7372\":\"0x14542ba12a337c00000\",\"0x1ad72d20a76e7fcc6b764058f48d417d496fa6cd\":\"0x6c6b935b8bbd400000\",\"0x1adaf4abfa867db17f99af6abebf707a3cf55df6\":\"0x14542ba12a337c00000\",\"0x1af60343360e0b2d75255210375720df21db5c7d\":\"0x3635c9adc5dea00000\",\"0x1afcc585896cd0ede129ee2de5c19ea811540b64\":\"0xaf2aba0c8e5bef8000\",\"0x1b05ea6a6ac8af7cb6a8b911a8cce8fe1a2acfc8\":\"0x6c6b935b8bbd400000\",\"0x1b0b31afff4b6df3653a94d7c87978ae35f34aae\":\"0x133910453fa9840000\",\"0x1b0d076817e8d68ee2df4e1da1c1142d198c4435\":\"0x54069233bf7f780000\",\"0x1b130d6fa51d5c48ec8d1d52dc8a227be8735c8a\":\"0x6c6b935b8bbd400000\",\"0x1b23cb8663554871fbbe0d9e60397efb6faedc3e\":\"0xad78ebc5ac6200000\",\"0x1b2639588b55c344b023e8de5fd4087b1f040361\":\"0x5150ae84a8cdf00000\",\"0x1b3920d001c43e72b24e7ca46f0fd6e0c20a5ff2\":\"0x6c6b935b8bbd400000\",\"0x1b3cb81e51011b549d78bf720b0d924ac763a7c2\":\"0x7695a92c20d6fe000000\",\"0x1b43232ccd4880d6f46fa751a96cd82473315841\":\"0x4563918244f400000\",\"0x1b4bbcb18165211b265b280716cb3f1f212176e8\":\"0x199ad37d03d0608000\",\"0x1b4d07acd38183a61bb2783d2b7b178dd502ac8d\":\"0xad78ebc5ac6200000\",\"0x1b636b7a496f044d7359596e353a104616436f6b\":\"0x1388ea95c33f1d0000\",\"0x1b6495891240e64e594493c2662171db5e30ce13\":\"0x95887d695ed580000\",\"0x1b6610fb68bad6ed1cfaa0bbe33a24eb2e96fafb\":\"0x83d6c7aab63600000\",\"0x1b799033ef6dc7127822f74542bb22dbfc09a308\":\"0x56bc75e2d63100000\",\"0x1b7ed974b6e234ce81247498429a5bd4a0a2d139\":\"0x6c6b935b8bbd400000\",\"0x1b826fb3c012b0d159e294ba5b8a499ff3c0e03c\":\"0x6c6b935b8bbd400000\",\"0x1b8aa0160cd79f005f88510a714913d70ad3be33\":\"0xaeffb83079ad00000\",\"0x1b8bd6d2eca20185a78e7d98e8e185678dac4830\":\"0x3894f0e6f9b9f700000\",\"0x1b9b2dc2960e4cb9408f7405827c9b59071612fd\":\"0x3635c9adc5dea00000\",\"0x1ba9228d388727f389150ea03b73c82de8eb2e09\":\"0x18974fbe177c9280000\",\"0x1ba9f7997e5387b6b2aa0135ac2452fe36b4c20d\":\"0x2e141ea081ca080000\",\"0x1bba03ff6b4ad5bf18184acb21b188a399e9eb4a\":\"0x61093d7c2c6d380000\",\"0x1bbc199e586790be87afedc849c04726745c5d7b\":\"0xd8d726b7177a800000\",\"0x1bbc60bcc80e5cdc35c5416a1f0a40a83dae867b\":\"0x6c6b935b8bbd400000\",\"0x1bc44c8761231ba1f11f5faa40fa669a013e12ce\":\"0xb0952c45aeaad0000\",\"0x1bcf3441a866bdbe963009ce33c81cbb0261b02c\":\"0x9ddc1e3b901180000\",\"0x1bd28cd5c78aee51357c95c1ef9235e7c18bc854\":\"0x6c6b935b8bbd400000\",\"0x1bd8ebaa7674bb18e19198db244f570313075f43\":\"0x821ab0d4414980000\",\"0x1bd909ac0d4a1102ec98dcf2cca96a0adcd7a951\":\"0x11651ac3e7a758000\",\"0x1be3542c3613687465f15a70aeeb81662b65cca8\":\"0x6c6b935b8bbd400000\",\"0x1bea4df5122fafdeb3607eddda1ea4ffdb9abf2a\":\"0x12c1b6eed03d280000\",\"0x1bec4d02ce85fc48feb62489841d85b170586a9b\":\"0x821ab0d44149800000\",\"0x1bf974d9904f45ce81a845e11ef4cbcf27af719e\":\"0x56bc75e2d63100000\",\"0x1c045649cd53dc23541f8ed4d341812808d5dd9c\":\"0x17b7883c06916600000\",\"0x1c128bd6cda5fca27575e4b43b3253c8c4172afe\":\"0x6c6b935b8bbd400000\",\"0x1c13d38637b9a47ce79d37a86f50fb409c060728\":\"0x487a9a304539440000\",\"0x1c2010bd662df417f2a271879afb13ef4c88a3ae\":\"0xd8d726b7177a800000\",\"0x1c257ad4a55105ea3b58ed374b198da266c85f63\":\"0x21e19e0c9bab2400000\",\"0x1c2e3607e127caca0fbd5c5948adad7dd830b285\":\"0x42bf06b78ed3b500000\",\"0x1c356cfdb95febb714633b28d5c132dd84a9b436\":\"0x15af1d78b58c40000\",\"0x1c35aab688a0cd8ef82e76541ba7ac39527f743b\":\"0x1b1ae4d6e2ef500000\",\"0x1c3ef05dae9dcbd489f3024408669de244c52a02\":\"0x43c33c1937564800000\",\"0x1c4af0e863d2656c8635bc6ffec8dd9928908cb5\":\"0x6c6b935b8bbd400000\",\"0x1c601993789207f965bb865cbb4cd657cce76fc0\":\"0x5541a7037503f0000\",\"0x1c63fa9e2cbbf23c49fcdef1cbabfe6e0d1e14c1\":\"0x3635c9adc5dea00000\",\"0x1c6702b3b05a5114bdbcaeca25531aeeb34835f4\":\"0x58556bead45dcae0000\",\"0x1c68a66138783a63c98cc675a9ec77af4598d35e\":\"0x2b746f48f0f120000\",\"0x1c73d00b6e25d8eb9c1ff4ad827b6b9e9cf6d20c\":\"0xad78ebc5ac6200000\",\"0x1c751e7f24df9d94a637a5dedeffc58277b5db19\":\"0xae8e7a0bb575d00000\",\"0x1c7cb2fe6bf3e09cbcdc187af38fa8f5053a70b6\":\"0x21c84f742d0cead8000\",\"0x1c89060f987c518fa079ec2c0a5ebfa30f5d20f7\":\"0x80bfbefcb5f0bc00000\",\"0x1c94d636e684eb155895ce6db4a2588fba1d001b\":\"0x6c6b935b8bbd400000\",\"0x1c99fe9bb6c6d1066d912099547fd1f4809eacd9\":\"0x6c6b935b8bbd400000\",\"0x1cb450920078aab2317c7db3b38af7dd298b2d41\":\"0x126e72a69a50d00000\",\"0x1cb5f33b4d488936d13e3161da33a1da7df70d1b\":\"0xad78ebc5ac6200000\",\"0x1cb6b2d7cfc559b7f41e6f56ab95c7c958cd0e4c\":\"0x487a9a304539440000\",\"0x1cc1d3c14f0fb8640e36724dc43229d2ea7a1e48\":\"0x5c283d410394100000\",\"0x1cc90876004109cd79a3dea866cb840ac364ba1b\":\"0x6c6b935b8bbd400000\",\"0x1cd1f0a314cbb200de0a0cb1ef97e920709d97c2\":\"0x6c6b935b8bbd400000\",\"0x1cda411bd5163baeca1e558563601ce720e24ee1\":\"0xfc936392801c0000\",\"0x1ce81d31a7923022e125bf48a3e03693b98dc9dd\":\"0x6c6b935b8bbd400000\",\"0x1cebf0985d7f680aaa915c44cc62edb49eab269e\":\"0x3635c9adc5dea00000\",\"0x1ced6715f862b1ff86058201fcce5082b36e62b2\":\"0x16a5e60bee273b10000\",\"0x1cf04cb14380059efd3f238b65d5beb86afa14d8\":\"0x1158e460913d00000\",\"0x1cf105ab23023b554c583e86d7921179ee83169f\":\"0x6acb3df27e1f880000\",\"0x1cf2eb7a8ccac2adeaef0ee87347d535d3b94058\":\"0x6c6b935b8bbd400000\",\"0x1cfcf7517f0c08459720942b647ad192aa9c8828\":\"0x2b5e3af16b18800000\",\"0x1d09ad2412691cc581c1ab36b6f9434cd4f08b54\":\"0x17b7883c06916600000\",\"0x1d157c5876c5cad553c912caf6ce2d5277e05c73\":\"0x6c6b935b8bbd400000\",\"0x1d2615f8b6ca5012b663bdd094b0c5137c778ddf\":\"0x21e19e0c9bab2400000\",\"0x1d29c7aab42b2048d2b25225d498dba67a03fbb2\":\"0xad78ebc5ac6200000\",\"0x1d341fa5a3a1bd051f7db807b6db2fc7ba4f9b45\":\"0xfc936392801c0000\",\"0x1d344e962567cb27e44db9f2fac7b68df1c1e6f7\":\"0x692ae8897081d00000\",\"0x1d36683063b7e9eb99462dabd569bddce71686f2\":\"0x3635c9adc5dea00000\",\"0x1d37616b793f94911838ac8e19ee9449df921ec4\":\"0x5150ae84a8cdf00000\",\"0x1d395b30adda1cf21f091a4f4a7b753371189441\":\"0x152d02c7e14af6800000\",\"0x1d45586eb803ca2190650bf748a2b174312bb507\":\"0x4be4e7267b6ae00000\",\"0x1d572edd2d87ca271a6714c15a3b37761dcca005\":\"0x6ebd52a8ddd390000\",\"0x1d633097a85225a1ff4321b12988fdd55c2b3844\":\"0xd8d726b7177a800000\",\"0x1d69c83d28ff0474ceebeacb3ad227a144ece7a3\":\"0x128cc03920a62d28000\",\"0x1d96bcd58457bbf1d3c2a46ffaf16dbf7d836859\":\"0x9497209d8467e8000\",\"0x1d9e6aaf8019a05f230e5def05af5d889bd4d0f2\":\"0x73f75d1a085ba0000\",\"0x1dab172effa6fbee534c94b17e794edac54f55f8\":\"0x6acb3df27e1f880000\",\"0x1db9ac9a9eaeec0a523757050c71f47278c72d50\":\"0x487a9a304539440000\",\"0x1dbe8e1c2b8a009f85f1ad3ce80d2e05350ee39c\":\"0x7570d6e9ebbe40000\",\"0x1dc7f7dad85df53f1271152403f4e1e4fdb3afa0\":\"0xad78ebc5ac6200000\",\"0x1dcebcb7656df5dcaa3368a055d22f9ed6cdd940\":\"0x1b181e4bf2343c0000\",\"0x1dd77441844afe9cc18f15d8c77bccfb655ee034\":\"0x106eb45579944880000\",\"0x1ddefefd35ab8f658b2471e54790bc17af98dea4\":\"0x3635c9adc5dea00000\",\"0x1deec01abe5c0d952de9106c3dc30639d85005d6\":\"0x6c6b935b8bbd400000\",\"0x1df6911672679bb0ef3509038c0c27e394fdfe30\":\"0x1d460162f516f00000\",\"0x1dfaee077212f1beaf0e6f2f1840537ae154ad86\":\"0x3635c9adc5dea00000\",\"0x1e060dc6c5f1cb8cc7e1452e02ee167508b56542\":\"0x2b14f02c864c77e0000\",\"0x1e13ec51142cebb7a26083412c3ce35144ba56a1\":\"0x10f0cf064dd59200000\",\"0x1e1a4828119be309bd88236e4d482b504dc55711\":\"0xa030dcebbd2f4c0000\",\"0x1e1aed85b86c6562cb8fa1eb6f8f3bc9dcae6e79\":\"0xf4d2dd84259b240000\",\"0x1e1c6351776ac31091397ecf16002d979a1b2d51\":\"0x4be4e7267b6ae00000\",\"0x1e1d7a5f2468b94ea826982dbf2125793c6e4a5a\":\"0x3634f48417401a0000\",\"0x1e210e7047886daa52aaf70f4b991dac68e3025e\":\"0xad78ebc5ac6200000\",\"0x1e2bf4ba8e5ef18d37de6d6ad636c4cae489d0cc\":\"0x6c6b935b8bbd400000\",\"0x1e2fe4e4a77d141ff49a0c7fbc95b0a2b283eeeb\":\"0x6c6b935b8bbd400000\",\"0x1e33d1c2fb5e084f2f1d54bc5267727fec3f985d\":\"0x1b1ae4d6e2ef500000\",\"0x1e381adcf801a3bf9fd7bfac9ccc2b8482ad5e66\":\"0x208972c0010d740000\",\"0x1e3badb1b6e1380e27039c576ae6222e963a5b53\":\"0x43c33c1937564800000\",\"0x1e484d0621f0f5331b35d5408d9aae4eb1acf21e\":\"0x1158e460913d00000\",\"0x1e5800227d4dcf75e30f5595c5bed3f72e341e3b\":\"0xd75dace73417e0000\",\"0x1e596a81b357c6f24970cc313df6dbdaabd0d09e\":\"0x6c6b935b8bbd400000\",\"0x1e6915ebd9a19c81b692ad99b1218a592c1ac7b1\":\"0xd8d726b7177a800000\",\"0x1e6e0153fc161bc05e656bbb144c7187bf4fe84d\":\"0x6c6b935b8bbd400000\",\"0x1e706655e284dcf0bb37fe075d613a18dc12ff4a\":\"0xed43bf1eee82ac0000\",\"0x1e783e522ab7df0acaac9eeed3593039e5ac7579\":\"0x2b1446dd6aefe41c0000\",\"0x1e7b5e4d1f572becf2c00fc90cb4767b4a6e33d4\":\"0x61fc6107593e10000\",\"0x1e8e689b02917cdc29245d0c9c68b094b41a9ed6\":\"0x6c6b935b8bbd400000\",\"0x1ea334b5750807ea74aac5ab8694ec5f28aa77cf\":\"0x1ab2cf7c9f87e20000\",\"0x1ea4715504c6af107b0194f4f7b1cb6fcccd6f4b\":\"0x20043197e0b0270000\",\"0x1ea492bce1ad107e337f4bd4a7ac9a7babcccdab\":\"0x56bc75e2d63100000\",\"0x1ea6bf2f15ae9c1dbc64daa7f8ea4d0d81aad3eb\":\"0xe3aeb5737240a00000\",\"0x1eb4bf73156a82a0a6822080c6edf49c469af8b9\":\"0x678a932062e4180000\",\"0x1ebacb7844fdc322f805904fbf1962802db1537c\":\"0x21e19e0c9bab2400000\",\"0x1ec4ec4b77bf19d091a868e6f49154180541f90e\":\"0x6c6b935b8bbd400000\",\"0x1ed06ee51662a86c634588fb62dc43c8f27e7c17\":\"0xad78ebc5ac6200000\",\"0x1ed8bb3f06778b039e9961d81cb71a73e6787c8e\":\"0x6c6b935b8bbd400000\",\"0x1eda084e796500ba14c5121c0d90846f66e4be62\":\"0x1cfdd7468216e80000\",\"0x1eee6cbee4fe96ad615a9cf5857a647940df8c78\":\"0x10d3aa536e2940000\",\"0x1ef2dcbfe0a500411d956eb8c8939c3d6cfe669d\":\"0x2a1129d09367200000\",\"0x1ef5c9c73650cfbbde5c885531d427c7c3fe5544\":\"0x14542ba12a337c00000\",\"0x1f0412bfedcd964e837d092c71a5fcbaf30126e2\":\"0x1158e460913d00000\",\"0x1f174f40a0447234e66653914d75bc003e5690dc\":\"0x8ac7230489e800000\",\"0x1f2186ded23e0cf9521694e4e164593e690a9685\":\"0x1043561a8829300000\",\"0x1f2afc0aed11bfc71e77a907657b36ea76e3fb99\":\"0xd8d726b7177a800000\",\"0x1f3959fc291110e88232c36b7667fc78a379613f\":\"0xfc936392801c0000\",\"0x1f3da68fe87eaf43a829ab6d7ec5a6e009b204fb\":\"0x1e1601758c2c7e0000\",\"0x1f49b86d0d3945590698a6aaf1673c37755ca80d\":\"0x25f273933db5700000\",\"0x1f5f3b34bd134b2781afe5a0424ac5846cdefd11\":\"0x55de6a779bbac0000\",\"0x1f6f0030349752061c96072bc3d6eb3549208d6b\":\"0x14b8de1eb88db8000\",\"0x1f7d8e86d6eeb02545aad90e91327bd369d7d2f3\":\"0x1158e460913d00000\",\"0x1f8116bd0af5570eaf0c56c49c7ab5e37a580458\":\"0x6c6b935b8bbd400000\",\"0x1f88f8a1338fc7c10976abcd3fb8d38554b5ec9c\":\"0xb9f65d00f63c0000\",\"0x1f9c3268458da301a2be5ab08257f77bb5a98aa4\":\"0xad78ebc5ac6200000\",\"0x1fa2319fed8c2d462adf2e17feec6a6f30516e95\":\"0x6cae30621d4720000\",\"0x1fb463a0389983df7d593f7bdd6d78497fed8879\":\"0x1158e460913d00000\",\"0x1fb7bd310d95f2a6d9baaf8a8a430a9a04453a8b\":\"0xa2a15d09519be00000\",\"0x1fcc7ce6a8485895a3199e16481f72e1f762defe\":\"0x3635c9adc5dea00000\",\"0x1fcfd1d57f872290560cb62d600e1defbefccc1c\":\"0x50c5e761a444080000\",\"0x1fd296be03ad737c92f9c6869e8d80a71c5714aa\":\"0xb98bc829a6f90000\",\"0x1fddd85fc98be9c4045961f40f93805ecc4549e5\":\"0x8e3f50b173c100000\",\"0x2001bef77b66f51e1599b02fb110194a0099b78d\":\"0x6c6b935b8bbd400000\",\"0x200264a09f8c68e3e6629795280f56254f8640d0\":\"0x1158e460913d00000\",\"0x2003717907a72560f4307f1beecc5436f43d21e7\":\"0x1b1ae4d6e2ef500000\",\"0x200dfc0b71e359b2b465440a36a6cdc352773007\":\"0x5150ae84a8cdf00000\",\"0x20134cbff88bfadc466b52eceaa79857891d831e\":\"0x3635c9adc5dea00000\",\"0x2014261f01089f53795630ba9dd24f9a34c2d942\":\"0x487a9a304539440000\",\"0x2016895df32c8ed5478269468423aea7b7fbce50\":\"0x1158e460913d00000\",\"0x20181c4b41f6f972b66958215f19f570c15ddff1\":\"0x56bc75e2d631000000\",\"0x201864a8f784c2277b0b7c9ee734f7b377eab648\":\"0xf2281400d1d5ec0000\",\"0x2020b81ae53926ace9f7d7415a050c031d585f20\":\"0x127f19e83eb3480000\",\"0x203c6283f20df7bc86542fdfb4e763ecdbbbeef5\":\"0x54b40b1f852bda00000\",\"0x204ac98867a7c9c7ed711cb82f28a878caf69b48\":\"0x14542ba12a337c00000\",\"0x205237c4be146fba99478f3a7dad17b09138da95\":\"0x6c6b935b8bbd400000\",\"0x2053ac97548a0c4e8b80bc72590cd6a098fe7516\":\"0xa2325753b460c0000\",\"0x205f5166f12440d85762c967d3ae86184f8f4d98\":\"0x177224aa844c720000\",\"0x205fc843e19a4913d1881eb69b69c0fa3be5c50b\":\"0x20dd68aaf3289100000\",\"0x206482ee6f138a778fe1ad62b180ce856fbb23e6\":\"0x6c6b935b8bbd400000\",\"0x2066774d822793ff25f1760909479cf62491bf88\":\"0xbae3ac685cb72e00000\",\"0x206d55d5792a514ec108e090599f2a065e501185\":\"0xadf30ba70c8970000\",\"0x20707e425d2a11d2c89f391b2b809f556c592421\":\"0x6c6b935b8bbd400000\",\"0x207ef80b5d60b6fbffc51f3a64b8c72036a5abbd\":\"0x16a6502f15a1e540000\",\"0x20824ba1dbebbef9846ef3d0f6c1b017e6912ec4\":\"0x184b26e4daf1d350000\",\"0x2084fce505d97bebf1ad8c5ff6826fc645371fb2\":\"0x1a055690d9db80000\",\"0x208c45732c0a378f17ac8324926d459ba8b658b4\":\"0xa030dcebbd2f4c0000\",\"0x209377b6ad3fe101c9685b3576545c6b1684e73c\":\"0x62a992e53a0af00000\",\"0x209e8e29d33beae8fb6baa783d133e1d9ec1bc0b\":\"0x2d43f3ebfafb2c0000\",\"0x20a15256d50ce058bf0eac43aa533aa16ec9b380\":\"0x1158e460913d00000\",\"0x20a29c5079e26b3f18318bb2e50e8e8b346e5be8\":\"0x1b1ab319f5ec750000\",\"0x20a81680e465f88790f0074f60b4f35f5d1e6aa5\":\"0x456180278f0c778000\",\"0x20b9a9e6bd8880d9994ae00dd0b9282a0beab816\":\"0x1b1ae4d6e2ef500000\",\"0x20c284ba10a20830fc3d699ec97d2dfa27e1b95e\":\"0x6c6b935b8bbd400000\",\"0x20d1417f99c569e3beb095856530fe12d0fceaaa\":\"0x4015f94b1183698000\",\"0x20dd8fcbb46ea46fe381a68b8ca0ea5be21fe9a5\":\"0x6c6b935b8bbd400000\",\"0x20ff3ede8cadb5c37b48cb14580fb65e23090a7b\":\"0x8e4d316827686400000\",\"0x2100381d60a5b54adc09d19683a8f6d5bb4bfbcb\":\"0x21e19e0c9bab2400000\",\"0x2118c116ab0cdf6fd11d54a4309307b477c3fc0f\":\"0x21e19e0c9bab2400000\",\"0x211b29cefc79ae976744fdebcebd3cbb32c51303\":\"0x2f6f10780d22cc00000\",\"0x21206ce22ea480e85940d31314e0d64f4e4d3a04\":\"0x3635c9adc5dea00000\",\"0x2132c0516a2e17174ac547c43b7b0020d1eb4c59\":\"0x35659ef93f0fc40000\",\"0x21408b4d7a2c0e6eca4143f2cacdbbccba121bd8\":\"0x43c33c1937564800000\",\"0x214b743955a512de6e0d886a8cbd0282bee6d2a2\":\"0x6c6b935b8bbd400000\",\"0x214c89c5bd8e7d22bc574bb35e48950211c6f776\":\"0x10654f258fd358000\",\"0x21546914dfd3af2add41b0ff3e83ffda7414e1e0\":\"0x14395e7385a502e0000\",\"0x21582e99e502cbf3d3c23bdffb76e901ac6d56b2\":\"0x56bc75e2d63100000\",\"0x2159240813a73095a7ebf7c3b3743e8028ae5f09\":\"0x6c6b935b8bbd400000\",\"0x2160b4c02cac0a81de9108de434590a8bfe68735\":\"0x6acb3df27e1f880000\",\"0x216e41864ef98f060da08ecae19ad1166a17d036\":\"0x1369fb96128ac480000\",\"0x21846f2fdf5a41ed8df36e5ed8544df75988ece3\":\"0x6c6acc67d7b1d40000\",\"0x21a6db6527467bc6dad54bc16e9fe2953b6794ed\":\"0x2f6f10780d22cc00000\",\"0x21a6feb6ab11c766fdd977f8df4121155f47a1c0\":\"0x319cf38f100580000\",\"0x21b182f2da2b384493cf5f35f83d9d1ee14f2a21\":\"0x6c6b935b8bbd400000\",\"0x21bfe1b45cacde6274fd8608d9a178bf3eeb6edc\":\"0x6cee06ddbe15ec0000\",\"0x21c07380484f6cbc8724ad32bc864c3b5ad500b7\":\"0x3635c9adc5dea00000\",\"0x21c3a8bba267c8cca27b1a9afabad86f607af708\":\"0x1e4a36c49d998300000\",\"0x21ce6d5b9018cec04ad6967944bea39e8030b6b8\":\"0x1158e460913d00000\",\"0x21d02705f3f64905d80ed9147913ea8c7307d695\":\"0x49edb1c09887360000\",\"0x21d13f0c4024e967d9470791b50f22de3afecf1b\":\"0xf15ad35e2e31e50000\",\"0x21dbdb817a0d8404c6bdd61504374e9c43c9210e\":\"0x21e18b9e9ab45e48000\",\"0x21df1ec24b4e4bfe79b0c095cebae198f291fbd1\":\"0x43c33c1937564800000\",\"0x21df2dcdaf74b2bf803404dd4de6a35eabec1bbd\":\"0x177224aa844c7200000\",\"0x21e219c89ca8ac14ae4cba6130eeb77d9e6d3962\":\"0x2acd9faaa038ee0000\",\"0x21e5d2bae995ccfd08a5c16bb524e1f630448f82\":\"0x97c9ce4cf6d5c00000\",\"0x21e5d77320304c201c1e53b261a123d0a1063e81\":\"0x4b6fa9d33dd460000\",\"0x21eae6feffa9fbf4cd874f4739ace530ccbe5937\":\"0x10f0cf064dd59200000\",\"0x21ecb2dfa65779c7592d041cd2105a81f4fd4e46\":\"0x3635c9adc5dea00000\",\"0x21efbca09b3580b98e73f5b2f7f4dc0bf02c529c\":\"0x6c6b935b8bbd400000\",\"0x21fd0bade5f4ef7474d058b7f3d854cb1300524e\":\"0x1158e460913d00000\",\"0x21fd47c5256012198fa5abf131c06d6aa1965f75\":\"0x1ab2cf7c9f87e200000\",\"0x21fd6c5d97f9c600b76821ddd4e776350fce2be0\":\"0x6c6ad382d4fb610000\",\"0x220dc68df019b6b0ccbffb784b5a5ab4b15d4060\":\"0xd5967be4fc3f100000\",\"0x220e2b92c0f6c902b513d9f1e6fab6a8b0def3d7\":\"0x2b5e3af16b18800000\",\"0x22561c5931143536309c17e832587b625c390b9a\":\"0xd8d726b7177a800000\",\"0x2257fca16a6e5c2a647c3c29f36ce229ab93b17e\":\"0xd8d726b7177a800000\",\"0x225d35faedb391c7bc2db7fa9071160405996d00\":\"0x91854fc1862630000\",\"0x225f9eb3fb6ff3e9e3c8447e14a66e8d4f3779f6\":\"0x6c6b935b8bbd400000\",\"0x2272186ef27dcbe2f5fc373050fdae7f2ace2316\":\"0x368c8623a8b4d100000\",\"0x2273bad7bc4e487622d175ef7a66988b6a93c4ee\":\"0x1158e460913d00000\",\"0x2276264bec8526c0c0f270677abaf4f0e441e167\":\"0x3635c9adc5dea00000\",\"0x228242f8336eecd8242e1f000f41937e71dffbbf\":\"0x10f0cf064dd59200000\",\"0x22842ab830da509913f81dd1f04f10af9edd1c55\":\"0x6c6b935b8bbd400000\",\"0x22944fbca9b57963084eb84df7c85fb9bcdfb856\":\"0xfc118fef90ba388000\",\"0x229cc4711b62755ea296445ac3b77fc633821cf2\":\"0x223e8b05219328000\",\"0x229e430de2b74f442651ddcdb70176bc054cad54\":\"0xbbf981bc4aaa8000\",\"0x229f4f1a2a4f540774505b4707a81de44410255b\":\"0x6c6b935b8bbd400000\",\"0x229ff80bf5708009a9f739e0f8b560914016d5a6\":\"0x1211ecb56d13488000\",\"0x22a25812ab56dcc423175ed1d8adacce33cd1810\":\"0x6449e84e47a8a80000\",\"0x22b96ab2cad55db100b53001f9e4db378104c807\":\"0x21e19e0c9bab2400000\",\"0x22bdffc240a88ff7431af3bff50e14da37d5183e\":\"0x3635c9adc5dea00000\",\"0x22ce349159eeb144ef06ff2636588aef79f62832\":\"0xa31062beeed700000\",\"0x22db559f2c3c1475a2e6ffe83a5979599196a7fa\":\"0x3635c9adc5dea00000\",\"0x22e15158b5ee3e86eb0332e3e6a9ac6cd9b55ecd\":\"0x8ac7230489e800000\",\"0x22e2488e2da26a49ae84c01bd54b21f2947891c6\":\"0x5dc892aa1131c80000\",\"0x22e512149a18d369b73c71efa43e86c9edabaf1d\":\"0x4ee02e6714615c0000\",\"0x22eb7db0ba56b0f8b816ccb206e615d929185b0d\":\"0x45d29737e22f20000\",\"0x22eed327f8eb1d1338a3cb7b0f8a4baa5907cd95\":\"0x1455d5f4877088000\",\"0x22f004df8de9e6ebf523ccace457accb26f97281\":\"0x21e19e0c9bab2400000\",\"0x22f2dcff5ad78c3eb6850b5cb951127b659522e6\":\"0xbe202d6a0eda0000\",\"0x22f3c779dd79023ea92a78b65c1a1780f62d5c4a\":\"0x6acb3df27e1f880000\",\"0x22fe884d9037291b4d52e6285ae68dea0be9ffb5\":\"0x6c6b935b8bbd400000\",\"0x2306df931a940d58c01665fa4d0800802c02edfe\":\"0x3635c9adc5dea00000\",\"0x2309d34091445b3232590bd70f4f10025b2c9509\":\"0x21e19e0c9bab2400000\",\"0x23120046f6832102a752a76656691c863e17e59c\":\"0x11e0e4f8a50bd40000\",\"0x231a15acc199c89fa9cb22441cc70330bdcce617\":\"0x1b1ae4d6e2ef500000\",\"0x231d94155dbcfe2a93a319b6171f63b20bd2b6fa\":\"0xcf147bb906e2f80000\",\"0x232832cd5977e00a4c30d0163f2e24f088a6cb09\":\"0xa2a15d09519be00000\",\"0x232c6d03b5b6e6711efff190e49c28eef36c82b0\":\"0x487a9a304539440000\",\"0x232cb1cd49993c144a3f88b3611e233569a86bd6\":\"0x34c606c42d0ac600000\",\"0x232ce782506225fd9860a2edc14a7a3047736da2\":\"0x1158e460913d00000\",\"0x232f525d55859b7d4e608d20487faadb00293135\":\"0xd8d726b7177a800000\",\"0x2334c590c7a48769103045c5b6534c8a3469f44a\":\"0x3b199073df72dc00000\",\"0x23376ecabf746ce53321cf42c86649b92b67b2ff\":\"0x6c6b935b8bbd400000\",\"0x23378f42926d0184b793b0c827a6dd3e3d334fcd\":\"0x30927f74c9de00000\",\"0x233842b1d0692fd11140cf5acda4bf9630bae5f8\":\"0x6c6b935b8bbd400000\",\"0x2339e9492870afea2537f389ac2f838302a33c06\":\"0x6c6b935b8bbd400000\",\"0x233bdddd5da94852f4ade8d212885682d9076bc6\":\"0xd8d726b7177a800000\",\"0x234f46bab73fe45d31bf87f0a1e0466199f2ebac\":\"0x1a4aba225c20740000\",\"0x23551f56975fe92b31fa469c49ea66ee6662f41e\":\"0x678a932062e4180000\",\"0x23569542c97d566018c907acfcf391d14067e87e\":\"0x6c6b935b8bbd400000\",\"0x235fa66c025ef5540070ebcf0d372d8177c467ab\":\"0x7129e1cdf373ee00000\",\"0x2372c4c1c9939f7aaf6cfac04090f00474840a09\":\"0x21e19e0c9bab2400000\",\"0x23730c357a91026e44b1d0e2fc2a51d071d8d77b\":\"0xd8d726b7177a800000\",\"0x2376ada90333b1d181084c97e645e810aa5b76f1\":\"0x28a857425466f80000\",\"0x2378fd4382511e968ed192106737d324f454b535\":\"0x3635c9adc5dea00000\",\"0x2382a9d48ec83ea3652890fd0ee79c907b5b2dc1\":\"0x73f75d1a085ba0000\",\"0x2383c222e67e969190d3219ef14da37850e26c55\":\"0x6c6b935b8bbd400000\",\"0x238a6b7635252f5244486c0af0a73a207385e039\":\"0x4a4491bd6dcd280000\",\"0x239a733e6b855ac592d663156186a8a174d2449e\":\"0x58be3758b241f60000\",\"0x23ab09e73f87aa0f3be0139df0c8eb6be5634f95\":\"0x1b1ae4d6e2ef5000000\",\"0x23abd9e93e7957e5b636be6579051c15e5ce0b0e\":\"0x3a3c8f7cbf42c380000\",\"0x23b1c4917fbd93ee3d48389306957384a5496cbf\":\"0xd8d8583fa2d52f0000\",\"0x23ba3864da583dab56f420873c37679690e02f00\":\"0x21342520d5fec200000\",\"0x23c55aeb5739876f0ac8d7ebea13be729685f000\":\"0x487a9a304539440000\",\"0x23c99ba087448e19c9701df66e0cab52368331fa\":\"0x6c6b935b8bbd400000\",\"0x23ccc3c6acd85c2e460c4ffdd82bc75dc849ea14\":\"0xd8d726b7177a800000\",\"0x23cd2598a20e149ead2ad69379576ecedb60e38e\":\"0x6c6b935b8bbd400000\",\"0x23df8f48ee009256ea797e1fa369beebcf6bc663\":\"0x7cd3fac26d19818000\",\"0x23e2c6a8be8e0acfa5c4df5e36058bb7cbac5a81\":\"0x6c6b935b8bbd400000\",\"0x23ea669e3564819a83b0c26c00a16d9e826f6c46\":\"0x4d8d6ca968ca130000\",\"0x23eb6fd85671a9063ab7678ebe265a20f61a02b3\":\"0x6c6b935b8bbd400000\",\"0x23f9ecf3e5dddca38815d3e59ed34b5b90b4a353\":\"0xb1781a3f0bb200000\",\"0x23fa7eb51a48229598f97e762be0869652dffc66\":\"0x3635c9adc5dea00000\",\"0x240305727313d01e73542c775ff59d11cd35f819\":\"0x141885666807f5c8000\",\"0x24046b91da9b61b629cb8b8ec0c351a07e0703e4\":\"0x6c6b935b8bbd400000\",\"0x240e559e274aaef0c258998c979f671d1173b88b\":\"0xd8d726b7177a800000\",\"0x241361559feef80ef137302153bd9ed2f25db3ef\":\"0x43c33c1937564800000\",\"0x243b3bca6a299359e886ce33a30341fafe4d573d\":\"0x43c33c1937564800000\",\"0x243c84d12420570cc4ef3baba1c959c283249520\":\"0x7f1f6993a853040000\",\"0x24434a3e32e54ecf272fe3470b5f6f512f675520\":\"0x14061b9d77a5e980000\",\"0x2448596f91c09baa30bc96106a2d37b5705e5d28\":\"0x6c6b935b8bbd400000\",\"0x24586ec5451735eeaaeb470dc8736aae752f82e5\":\"0xf43fc2c04ee00000\",\"0x2458d6555ff98a129cce4037953d00206eff4287\":\"0xaadec983fcff40000\",\"0x246291165b59332df5f18ce5c98856fae95897d6\":\"0x5c283d410394100000\",\"0x2467c6a5c696ede9a1e542bf1ad06bcc4b06aca0\":\"0x100bd33fb98ba0000\",\"0x2476b2bb751ce748e1a4c4ff7b230be0c15d2245\":\"0xd8d726b7177a800000\",\"0x247a0a11c57f0383b949de540b66dee68604b0a1\":\"0x39fbae8d042dd00000\",\"0x2487c3c4be86a2723d917c06b458550170c3edba\":\"0x3635c9adc5dea00000\",\"0x2489ac126934d4d6a94df08743da7b7691e9798e\":\"0x3635c9adc5dea00000\",\"0x249db29dbc19d1235da7298a04081c315742e9ac\":\"0x61acff81a78ad40000\",\"0x24a4eb36a7e498c36f99975c1a8d729fd6b305d7\":\"0xdfc78210eb2c80000\",\"0x24a750eae5874711116dd7d47b7186ce990d3103\":\"0xad78ebc5ac6200000\",\"0x24aa1151bb765fa3a89ca50eb6e1b1c706417fd4\":\"0xa80d24677efef00000\",\"0x24aca08d5be85ebb9f3132dfc1b620824edfedf9\":\"0xfc936392801c0000\",\"0x24b2be118b16d8b2174769d17b4cf84f07ca946d\":\"0x6c6b935b8bbd400000\",\"0x24b8b446debd1947955dd084f2c544933346d3ad\":\"0xea696d904039bd8000\",\"0x24b95ebef79500baa0eda72e77f877415df75c33\":\"0x3154c9729d05780000\",\"0x24b9e6644f6ba4cde126270d81f6ab60f286dff4\":\"0x73f75d1a085ba0000\",\"0x24bd5904059091d2f9e12d6a26a010ca22ab14e8\":\"0x65ea3db75546600000\",\"0x24c0c88b54a3544709828ab4ab06840559f6c5e2\":\"0x90f534608a72880000\",\"0x24c117d1d2b3a97ab11a4679c99a774a9eade8d1\":\"0x3635c9adc5dea00000\",\"0x24cff0e9336a9f80f9b1cb968caf6b1d1c4932a4\":\"0xada55474b81340000\",\"0x24daaaddf7b06bbcea9b80590085a88567682b4e\":\"0x114b2015d2bbd00000\",\"0x24dcc24bd9c7210ceacfb30da98ae04a4d7b8ab9\":\"0x3635c9adc5dea00000\",\"0x24f7450ddbf18b020feb1a2032d9d54b633edf37\":\"0x2b5e3af16b1880000\",\"0x24fc73d20793098e09ddab5798506224fa1e1850\":\"0xad78ebc5ac6200000\",\"0x24fd9a6c874c2fab3ff36e9afbf8ce0d32c7de92\":\"0x487a9a304539440000\",\"0x250a40cef3202397f240469548beb5626af4f23c\":\"0x503b203e9fba20000\",\"0x250a69430776f6347703f9529783955a6197b682\":\"0x692ae8897081d00000\",\"0x250eb7c66f869ddf49da85f3393e980c029aa434\":\"0xd8d726b7177a800000\",\"0x25106ab6755df86d6b63a187703b0cfea0e594a0\":\"0x17c405ad41db40000\",\"0x25185f325acf2d64500698f65c769ddf68301602\":\"0x10f0cf064dd59200000\",\"0x251c12722c6879227992a304eb3576cd18434ea5\":\"0x6c6b935b8bbd400000\",\"0x251e6838f7cec5b383c1d90146341274daf8e502\":\"0x7ff1ccb7561df0000\",\"0x25259d975a21d83ae30e33f800f53f37dfa01938\":\"0x1158e460913d00000\",\"0x25287b815f5c82380a73b0b13fbaf982be24c4d3\":\"0x22b1c8c1227a00000\",\"0x252b6555afdc80f2d96d972d17db84ea5ad521ac\":\"0x1ab2cf7c9f87e200000\",\"0x2538532936813c91e653284f017c80c3b8f8a36f\":\"0x6c8754c8f30c080000\",\"0x253e32b74ea4490ab92606fda0aa257bf23dcb8b\":\"0x21e19e0c9bab2400000\",\"0x253f1e742a2cec86b0d7b306e5eacb6ccb2f8554\":\"0x43e5ede1f878c200000\",\"0x2541314a0b408e95a694444977712a50713591ab\":\"0x589e1a5df4d7b50000\",\"0x254c1ecc630c2877de8095f0a8dba1e8bf1f550c\":\"0x5c283d410394100000\",\"0x255abc8d08a096a88f3d6ab55fbc7352bddcb9ce\":\"0x4743682313ede8000\",\"0x255bdd6474cc8262f26a22c38f45940e1ceea69b\":\"0xd8d726b7177a800000\",\"0x2560b09b89a4ae6849ed5a3c9958426631714466\":\"0x5c283d410394100000\",\"0x2561a138dcf83bd813e0e7f108642be3de3d6f05\":\"0x3634f48417401a0000\",\"0x2561ec0f379218fe5ed4e028a3f744aa41754c72\":\"0xb98bc829a6f90000\",\"0x256292a191bdda34c4da6b6bd69147bf75e2a9ab\":\"0xc2ff2e0dfb038000\",\"0x25697ef20cccaa70d32d376f8272d9c1070c3d78\":\"0xad78ebc5ac6200000\",\"0x256fa150cc87b5056a07d004efc84524739e62b5\":\"0xad78ebc5ac6200000\",\"0x25721c87b0dc21377c7200e524b14a22f0af69fb\":\"0xd8d726b7177a800000\",\"0x258939bbf00c9de9af5338f5d714abf6d0c1c671\":\"0x54069233bf7f780000\",\"0x2590126870e0bde8a663ab040a72a5573d8d41c2\":\"0x10f0cf064dd59200000\",\"0x259ec4d265f3ab536b7c70fa97aca142692c13fc\":\"0x11b1b5bea89f80000\",\"0x25a500eeec7a662a841552b5168b707b0de21e9e\":\"0x21f2f6f0fc3c6100000\",\"0x25a5a44d38a2f44c6a9db9cdbc6b1e2e97abb509\":\"0x39992648a23c8a00000\",\"0x25a74c2ac75dc8baa8b31a9c7cb4b7829b2456da\":\"0x6c6b935b8bbd400000\",\"0x25adb8f96f39492c9bb47c5edc88624e46075697\":\"0x5a9940bc56879500000\",\"0x25aee68d09afb71d8817f3f184ec562f7897b734\":\"0x6c6b935b8bbd400000\",\"0x25b0533b81d02a617b9229c7ec5d6f2f672e5b5a\":\"0x3635c9adc5dea00000\",\"0x25b78c9fad85b43343f0bfcd0fac11c9949ca5eb\":\"0x6c6b935b8bbd400000\",\"0x25bc49ef288cd165e525c661a812cf84fbec8f33\":\"0x125921aebda9d00000\",\"0x25bdfa3ee26f3849617b230062588a97e3cae701\":\"0x3635e619bb04d40000\",\"0x25c1a37ee5f08265a1e10d3d90d5472955f97806\":\"0x62a992e53a0af00000\",\"0x25c6e74ff1d928df98137af4df8430df24f07cd7\":\"0x15245655b102580000\",\"0x25cfc4e25c35c13b69f7e77dbfb08baf58756b8d\":\"0x878678326eac9000000\",\"0x25dad495a11a86b9eeece1eeec805e57f157faff\":\"0x3635c9adc5dea000000\",\"0x25e037f00a18270ba5ec3420229ddb0a2ce38fa2\":\"0x21e19e0c9bab2400000\",\"0x25e661c939863acc044e6f17b5698cce379ec3cc\":\"0x4a4491bd6dcd280000\",\"0x26048fe84d9b010a62e731627e49bc2eb73f408f\":\"0xd8d726b7177a800000\",\"0x2606c3b3b4ca1b091498602cb1978bf3b95221c0\":\"0x15af1d78b58c400000\",\"0x260a230e4465077e0b14ee4442a482d5b0c914bf\":\"0x5af606a06b5b118000\",\"0x260df8943a8c9a5dba7945327fd7e0837c11ad07\":\"0xad78ebc5ac6200000\",\"0x2614f42d5da844377578e6b448dc24305bef2b03\":\"0x6c6b935b8bbd400000\",\"0x2615100ea7e25bba9bca746058afbbb4ffbe4244\":\"0x1b1ae4d6e2ef500000\",\"0x261575e9cf59c8226fa7aaf91de86fb70f5ac3ae\":\"0x1043a4436a523f0000\",\"0x261e0fa64c51137465eecf5b90f197f7937fdb05\":\"0x3cfc82e37e9a7400000\",\"0x262a8bfd7d9dc5dd3ad78161b6bb560824373655\":\"0x3f6a8384072b760000\",\"0x262aed4bc0f4a4b2c6fb35793e835a49189cdfec\":\"0x21e19e0c9bab2400000\",\"0x262dc1364ccf6df85c43268ee182554dae692e29\":\"0x10b202fec74ced80000\",\"0x263814309de4e635cf585e0d365477fc40e66cf7\":\"0x7ea28327577080000\",\"0x2639eee9873ceec26fcc9454b548b9e7c54aa65c\":\"0x3635c9adc5dea00000\",\"0x263e57dacbe0149f82fe65a2664898866ff5b463\":\"0x80bfbefcb5f0bc00000\",\"0x26475419c06d5f147aa597248eb46cf7befa64a5\":\"0x58e7926ee858a00000\",\"0x264cc8086a8710f91b21720905912cd7964ae868\":\"0x1731790534df20000\",\"0x265383d68b52d034161bfab01ae1b047942fbc32\":\"0x47271dee20d745c0000\",\"0x2659facb1e83436553b5b42989adb8075f9953ed\":\"0x1976576771a5e0000\",\"0x266f2da7f0085ef3f3fa09baee232b93c744db2e\":\"0xcb49b44ba602d800000\",\"0x267148fd72c54f620a592fb92799319cc4532b5c\":\"0x1639e49bba16280000\",\"0x26784ade91c8a83a8e39658c8d8277413ccc9954\":\"0x14542ba12a337c00000\",\"0x267a7e6e82e1b91d51deddb644f0e96dbb1f7f7e\":\"0x1158e460913d00000\",\"0x2680713d40808e2a50ed013150a2a694b96a7f1d\":\"0x61093d7c2c6d380000\",\"0x2697b339813b0c2d964b2471eb1c606f4ecb9616\":\"0x3e8ef795d890c80000\",\"0x26a68eab905a8b3dce00e317308225dab1b9f6b8\":\"0x6b56051582a9700000\",\"0x26b11d066588ce74a572a85a6328739212aa8b40\":\"0x6c6b935b8bbd400000\",\"0x26babf42b267fdcf3861fdd4236a5e474848b358\":\"0x3635c9adc5dea00000\",\"0x26c0054b700d3a7c2dcbe275689d4f4cad16a335\":\"0x6c6b935b8bbd400000\",\"0x26c2ffc30efdc5273e76183a16c2698d6e531286\":\"0x2a1129d09367200000\",\"0x26c99f8849c9802b83c861217fd07a9e84cdb79d\":\"0x1043561a8829300000\",\"0x26cfffd052152bb3f957b478d5f98b233a7c2b92\":\"0xd8d726b7177a800000\",\"0x26d4a16891f52922789217fcd886f7fce296d400\":\"0x6c6b935b8bbd400000\",\"0x26d4ec17d5ceb2c894bdc59d0a6a695dad2b43cc\":\"0x9f1f78761d341a0000\",\"0x26e801b62c827191dd68d31a011990947fd0ebe0\":\"0x1158e460913d00000\",\"0x26e9e2ad729702626417ef25de0dc800f7a779b3\":\"0x3635c9adc5dea00000\",\"0x26f9f7cefd7e394b9d3924412bf2c2831faf1f85\":\"0xd8d726b7177a800000\",\"0x26fe174cbf526650e0cd009bd6126502ce8e684d\":\"0x277017338a30ae00000\",\"0x26ff0a51e7cece8400276978dbd6236ef162c0e6\":\"0x152e185627540a500000\",\"0x27101a0f56d39a88c5a84f9b324cdde33e5cb68c\":\"0x6c6b935b8bbd400000\",\"0x27144ca9a7771a836ad50f803f64d869b2ae2b20\":\"0xd8d726b7177a800000\",\"0x27146913563aa745e2588430d9348e86ea7c3510\":\"0x15af1d78b58c400000\",\"0x271d3d481cb88e7671ad216949b6365e06303de0\":\"0xd8d726b7177a800000\",\"0x2720f9ca426ef2f2cbd2fecd39920c4f1a89e16d\":\"0x6c6b935b8bbd400000\",\"0x272a131a5a656a7a3aca35c8bd202222a7592258\":\"0x90f534608a72880000\",\"0x2744ff67464121e35afc2922177164fa2fcb0267\":\"0x56bc75e2d63100000\",\"0x274a3d771a3d709796fbc4d5f48fce2fe38c79d6\":\"0x1158e460913d00000\",\"0x274d69170fe7141401882b886ac4618c6ae40edb\":\"0x33c5499031720c0000\",\"0x27521deb3b6ef1416ea4c781a2e5d7b36ee81c61\":\"0x6c6b935b8bbd400000\",\"0x275875ff4fbb0cf3a430213127487f7608d04cba\":\"0x1b1c010e766d580000\",\"0x276a006e3028ecd44cdb62ba0a77ce94ebd9f10f\":\"0x6194049f30f7200000\",\"0x276b0521b0e68b277df0bb32f3fd48326350bfb2\":\"0x2b5e3af16b1880000\",\"0x276fd7d24f8f883f5a7a28295bf17151c7a84b03\":\"0x6c6b935b8bbd400000\",\"0x2770f14efb165ddeba79c10bb0af31c31e59334c\":\"0xa2a15d09519be00000\",\"0x277677aba1e52c3b53bfa2071d4e859a0af7e8e1\":\"0x3635c9adc5dea00000\",\"0x27824666d278d70423f03dfe1dc7a3f02f43e2b5\":\"0x3636c25e66ece70000\",\"0x27830c5f6023afaaf79745676c204a0faccda0ba\":\"0xd02ab486cedc00000\",\"0x2784903f1d7c1b5cd901f8875d14a79b3cbe2a56\":\"0x4bda7e9d74ad5500000\",\"0x278c0bde630ec393b1e7267fc9d7d97019e4145b\":\"0x6c6b935b8bbd400000\",\"0x27987110221a880826adb2e7ab5eca78c6e31aec\":\"0xd8d726b7177a800000\",\"0x27ac073be79ce657a93aa693ee43bf0fa41fef04\":\"0xa968163f0a57b400000\",\"0x27b1694eafa165ebd7cc7bc99e74814a951419dc\":\"0x2b5e3af16b18800000\",\"0x27b62816e1e3b8d19b79d1513d5dfa855b0c3a2a\":\"0x56af5c1fd69508000\",\"0x27bf943c1633fe32f8bcccdb6302b407a5724e44\":\"0x32f84c6df408c08000\",\"0x27bf9f44ba7d05c33540c3a53bb02cbbffe7c3c6\":\"0x6c6b935b8bbd400000\",\"0x27c2d7ca504daa3d9066dc09137dc42f3aaab452\":\"0x2086ac351052600000\",\"0x27d158ac3d3e1109ab6e570e90e85d3892cd7680\":\"0x56bc75e2d63100000\",\"0x27e63989ca1e903bc620cf1b9c3f67b9e2ae6581\":\"0x487a9a304539440000\",\"0x27f03cf1abc5e1b51dbc444b289e542c9ddfb0e6\":\"0x10f0cf064dd59200000\",\"0x27fc85a49cff90dbcfdadc9ddd40d6b9a2210a6c\":\"0x56bc75e2d63100000\",\"0x2805415e1d7fdec6dedfb89e521d10592d743c10\":\"0x56bc75e2d63100000\",\"0x28073efc17d05cab3195c2db332b61984777a612\":\"0x3635c9adc5dea00000\",\"0x281250a29121270a4ee5d78d24feafe82c70ba3a\":\"0x3635c9adc5dea00000\",\"0x2813d263fc5ff2479e970595d6b6b560f8d6d6d1\":\"0x6c6b935b8bbd400000\",\"0x282e80a554875a56799fa0a97f5510e795974c4e\":\"0x3635c9adc5dea00000\",\"0x283396ce3cac398bcbe7227f323e78ff96d08767\":\"0x15af1d78b58c400000\",\"0x28349f7ef974ea55fe36a1583b34cec3c45065f0\":\"0xcb633d49e65590000\",\"0x2836123046b284e5ef102bfd22b1765e508116ad\":\"0x1653fbb5c427e40000\",\"0x283c2314283c92d4b064f0aef9bb5246a7007f39\":\"0xad78ebc5ac6200000\",\"0x283e11203749b1fa4f32febb71e49d135919382a\":\"0x3635c9adc5dea00000\",\"0x283e6252b4efcf4654391acb75f903c59b78c5fb\":\"0x28a857425466f800000\",\"0x28510e6eff1fc829b6576f4328bc3938ec7a6580\":\"0x21e19e0c9bab2400000\",\"0x2858acacaf21ea81cab7598fdbd86b452e9e8e15\":\"0x241a9b4f617a280000\",\"0x285ae51b9500c58d541365d97569f14bb2a3709b\":\"0x6c6b935b8bbd400000\",\"0x2866b81decb02ee70ae250cee5cdc77b59d7b679\":\"0x6c6b935b8bbd400000\",\"0x286906b6bd4972e3c71655e04baf36260c7cb153\":\"0x126e72a69a50d00000\",\"0x286b186d61ea1fd78d9930fe12b06537b05c3d51\":\"0x3635c9adc5dea00000\",\"0x2874f3e2985d5f7b406627e17baa772b01abcc9e\":\"0x146050410765f380000\",\"0x287cf9d0902ef819a7a5f149445bf1775ee8c47c\":\"0x3635c9adc5dea000000\",\"0x28818e18b610001321b31df6fe7d2815cdadc9f5\":\"0x3635c9adc5dea00000\",\"0x28868324337e11ba106cb481da962f3a8453808d\":\"0x6c6b935b8bbd400000\",\"0x28904bb7c4302943b709b14d7970e42b8324e1a1\":\"0x21f97846a072d7e0000\",\"0x2895e80999d406ad592e2b262737d35f7db4b699\":\"0x692ae8897081d00000\",\"0x28967280214e218a120c5dda37041b111ea36d74\":\"0xad78ebc5ac6200000\",\"0x28a3da09a8194819ae199f2e6d9d1304817e28a5\":\"0x6c6b935b8bbd400000\",\"0x28ab165ffb69eda0c549ae38e9826f5f7f92f853\":\"0x464df6d7c844590000\",\"0x28b77585cb3d55a199ab291d3a18c68fe89a848a\":\"0x6a4076cf7995a00000\",\"0x28d4ebf41e3d3c451e943bdd7e1f175fae932a3d\":\"0x14542ba12a337c00000\",\"0x28d7e5866f1d85fd1ceb32bfbe1dfc36db434566\":\"0x1864231c610351c0000\",\"0x28d8c35fb7eea622582135e3ad47a227c9a663bd\":\"0xfc936392801c0000\",\"0x28e4af30cd93f686a122ad7bb19f8a8785eee342\":\"0x71e53b706cc7b40000\",\"0x28eaea78cd4d95faecfb68836eafe83520f3bbb7\":\"0xad78ebc5ac6200000\",\"0x28efae6356509edface89fc61a7fdcdb39eea8e5\":\"0x121ea68c114e5100000\",\"0x28fa2580f9ebe420f3e5eefdd371638e3b7af499\":\"0x14542ba12a337c00000\",\"0x2901f8077f34190bb47a8e227fa29b30ce113b31\":\"0x56bc75e2d63100000\",\"0x2905b192e83ce659aa355b9d0c204e3e95f9bb9a\":\"0x75235c1d00393e8000\",\"0x290a56d41f6e9efbdcea0342e0b7929a8cdfcb05\":\"0x12a5f58168ee600000\",\"0x2915624bcb679137b8dae9ab57d11b4905eaee4b\":\"0x1158e460913d00000\",\"0x291efe0081dce8c14799f7b2a43619c0c3b3fc1f\":\"0x410d586a20a4c00000\",\"0x291f929ca59b54f8443e3d4d75d95dee243cef78\":\"0x1b1a089237073d0000\",\"0x29298ccbdff689f87fe41aa6e98fdfb53deaf37a\":\"0x4315c32d71a9e600000\",\"0x292f228b0a94748c8eec612d246f989363e08f08\":\"0xa076407d3f7440000\",\"0x293384c42b6f8f2905ce52b7205c2274376c612b\":\"0x4be4e7267b6ae00000\",\"0x2934c0df7bbc172b6c186b0b72547ace8bf75454\":\"0x340aad21b3b700000\",\"0x293c2306df3604ae4fda0d207aba736f67de0792\":\"0xad78ebc5ac6200000\",\"0x2949fd1def5c76a286b3872424809a07db3966f3\":\"0x11bd906daa0c9438000\",\"0x294f494b3f2e143c2ffc9738cbfd9501850b874e\":\"0x796e3ea3f8ab000000\",\"0x2955c357fd8f75d5159a3dfa69c5b87a359dea8c\":\"0x6c6b935b8bbd400000\",\"0x2961fb391c61957cb5c9e407dda29338d3b92c80\":\"0x3634fb9f1489a70000\",\"0x29681d9912ddd07eaabb88d05d90f766e862417d\":\"0x3635c9adc5dea00000\",\"0x296b71c0015819c242a7861e6ff7eded8a5f71e3\":\"0x6c68ccd09b022c0000\",\"0x296d66b521571a4e4103a7f562c511e6aa732d81\":\"0x243d4d18229ca20000\",\"0x296f00de1dc3bb01d47a8ccd1e5d1dd9a1eb7791\":\"0x3635c9adc5dea00000\",\"0x297385e88634465685c231a314a0d5dcd146af01\":\"0x54069233bf7f780000\",\"0x29763dd6da9a7c161173888321eba6b63c8fb845\":\"0x11c7ea162e78200000\",\"0x2979741174a8c1ea0b7f9edf658177859417f512\":\"0x1901966c8496838000\",\"0x297a88921b5fca10e5bb9ded60025437ae221694\":\"0xad78ebc5ac6200000\",\"0x297d5dbe222f2fb52531acbd0b013dc446ac7368\":\"0x43c33c1937564800000\",\"0x29824e94cc4348bc963279dcdf47391715324cd3\":\"0x692ae8897081d00000\",\"0x2982d76a15f847dd41f1922af368fe678d0e681e\":\"0x56bc75e2d63100000\",\"0x298887bab57c5ba4f0615229d7525fa113b7ea89\":\"0x22b1c8c1227a00000\",\"0x298ec76b440d8807b3f78b5f90979bee42ed43db\":\"0x65a4da25d3016c00000\",\"0x299368609042a858d1ecdf1fc0ada5eaceca29cf\":\"0x6c6b935b8bbd400000\",\"0x299e0bca55e069de8504e89aca6eca21d38a9a5d\":\"0x302379bf2ca2e0000\",\"0x29ac2b458454a36c7e96c73a8667222a12242c71\":\"0xd8d726b7177a800000\",\"0x29adcf83b6b20ac6a434abb1993cbd05c60ea2e4\":\"0x21e19e0c9bab2400000\",\"0x29aef48de8c9fbad4b9e4ca970797a5533eb722d\":\"0x21e19e0c9bab2400000\",\"0x29b3f561ee7a6e25941e98a5325b78adc79785f3\":\"0x56bc75e2d63100000\",\"0x29bdc4f28de0180f433c2694eb74f5504ce94337\":\"0x6c6b935b8bbd400000\",\"0x29cc804d922be91f5909f348b0aaa5d21b607830\":\"0xd8d726b7177a800000\",\"0x29da3e35b23bb1f72f8e2258cf7f553359d24bac\":\"0x43c33c1937564800000\",\"0x29e67990e1b6d52e1055ffe049c53195a81542cf\":\"0x43c33c1937564800000\",\"0x29eaae82761762f4d2db53a9c68b0f6b0b6d4e66\":\"0x6c6b935b8bbd400000\",\"0x29eb7eefdae9feb449c63ff5f279d67510eb1422\":\"0x10d3aa536e2940000\",\"0x29f0edc60338e7112085a1d114da8c42ce8f55d6\":\"0xa05a7f0fd825780000\",\"0x29f8fba4c30772b057edbbe62ae7420c390572e1\":\"0x3635c9adc5dea00000\",\"0x29f9286c0e738d1721a691c6b95ab3d9a797ede8\":\"0x2a5a058fc295ed000000\",\"0x2a085e25b64862f5e68d768e2b0f7a8529858eee\":\"0x6b883acd5766cd0000\",\"0x2a2ab6b74c7af1d9476bb5bcb4524797bedc3552\":\"0x3635c9adc5dea00000\",\"0x2a39190a4fde83dfb3ddcb4c5fbb83ac6c49755c\":\"0x3635c9adc5dea00000\",\"0x2a400dff8594de7228b4fd15c32322b75bb87da8\":\"0x531a17f607a2d0000\",\"0x2a44a7218fe44d65a1b4b7a7d9b1c2c52c8c3e34\":\"0xd2d06c305a1eb578000\",\"0x2a46d353777176ff8e83ffa8001f4f70f9733aa5\":\"0x5bf0ba6634f680000\",\"0x2a595f16eee4cb0c17d9a2d939b3c10f6c677243\":\"0x3ba1910bf341b00000\",\"0x2a59e47ea5d8f0e7c028a3e8e093a49c1b50b9a3\":\"0x6c6b935b8bbd400000\",\"0x2a5ba9e34cd58da54c9a2712663a3be274c8e47b\":\"0xaadec983fcff40000\",\"0x2a5e3a40d2cd0325766de73a3d671896b362c73b\":\"0x152d02c7e14af6800000\",\"0x2a63590efe9986c3fee09b0a0a338b15bed91f21\":\"0x15e1c4e05ee26d00000\",\"0x2a67660a1368efcd626ef36b2b1b601980941c05\":\"0x73f75d1a085ba0000\",\"0x2a742b8910941e0932830a1d9692cfd28494cf40\":\"0x1b1ab319f5ec750000\",\"0x2a746cd44027af3ebd37c378c85ef7f754ab5f28\":\"0x155bd9307f9fe80000\",\"0x2a81d27cb6d4770ff4f3c4a3ba18e5e57f07517c\":\"0x6c6b935b8bbd400000\",\"0x2a91a9fed41b7d0e5cd2d83158d3e8a41a9a2d71\":\"0x692ae8897081d00000\",\"0x2a9c57fe7b6b138a920d676f3c76b6c2a0eef699\":\"0x1fd933494aa5fe00000\",\"0x2a9c96c19151ffcbe29a4616d0c52b3933b4659f\":\"0x3c1379b8765e18000\",\"0x2aa192777ca5b978b6b2c2ff800ac1860f753f47\":\"0x12290f15180bdc0000\",\"0x2aaa35274d742546670b7426264521032af4f4c3\":\"0x21e19e0c9bab2400000\",\"0x2aaea1f1046f30f109faec1c63ef5c7594eb08da\":\"0xd8d726b7177a800000\",\"0x2ab97e8d59eee648ab6caf8696f89937143864d6\":\"0xcf152640c5c8300000\",\"0x2abce1808940cd4ef5b5e05285f82df7a9ab5e03\":\"0x21342520d5fec200000\",\"0x2abdf1a637ef6c42a7e2fe217773d677e804ebdd\":\"0x10f0cf064dd59200000\",\"0x2ac1f8d7bf721f3cfe74d20fea9b87a28aaa982c\":\"0x8ba52e6fc45e40000\",\"0x2acc9c1a32240b4d5b2f777a2ea052b42fc1271c\":\"0x8d807ee14d836100000\",\"0x2ad6c9d10c261819a1a0ca2c48d8c7b2a71728df\":\"0x3635c9adc5dea00000\",\"0x2ae53866fc2d14d572ab73b4a065a1188267f527\":\"0x1b1ae4d6e2ef5000000\",\"0x2ae73a79aea0278533accf21070922b1613f8f32\":\"0xa7e94bbeae701a8000\",\"0x2ae82dab92a66389eea1abb901d1d57f5a7cca0b\":\"0x6c6b935b8bbd400000\",\"0x2aec809df9325b9f483996e99f7331097f08aa0e\":\"0xd8d726b7177a800000\",\"0x2aed2ce531c056b0097efc3c6de10c4762004ed9\":\"0x2356953ab7ddc380000\",\"0x2afb058c3d31032b353bf24f09ae20d54de57dbe\":\"0x3ba1910bf341b00000\",\"0x2b0362633614bfcb583569438ecc4ea57b1d337e\":\"0x43c33c1937564800000\",\"0x2b101e822cd962962a06800a2c08d3b15d82b735\":\"0x83d6c7aab63600000\",\"0x2b129c26b75dde127f8320bd0f63410c92a9f876\":\"0x77432217e683600000\",\"0x2b241f037337eb4acc61849bd272ac133f7cdf4b\":\"0x500b6bca962ab8400000\",\"0x2b3a68db6b0cae8a7c7a476bdfcfbd6205e10687\":\"0x821ab0d44149800000\",\"0x2b3cf97311ff30f460945a9d8099f4a88e26d456\":\"0x6c6b935b8bbd400000\",\"0x2b49fba29830360fcdb6da23bbfea5c0bbac5281\":\"0x1158e460913d00000\",\"0x2b4f4507bb6b9817942ce433781b708fbcd166fd\":\"0xfc936392801c0000\",\"0x2b5016e2457387956562587115aa8759d8695fdf\":\"0x2a5a058fc295ed000000\",\"0x2b5c60e84535eeb4d580de127a12eb2677ccb392\":\"0x43c33c1937564800000\",\"0x2b5ced9987c0765f900e49cf9da2d9f9c1138855\":\"0x15af1d78b58c400000\",\"0x2b5f4b3f1e11707a227aa5e69fa49dded33fb321\":\"0x14542ba12a337c00000\",\"0x2b68306ba7f8daaf73f4c644ef7d2743c0f26856\":\"0x2ee182ca17ddd00000\",\"0x2b6ed29a95753c3ad948348e3e7b1a251080ffb9\":\"0x34f086f3b33b68400000\",\"0x2b701d16c0d3cc1e4cd85445e6ad02eea4ac012d\":\"0x2086ac351052600000\",\"0x2b717cd432a323a4659039848d3b87de26fc9546\":\"0x69e10de76676d0800000\",\"0x2b74c373d04bfb0fd60a18a01a88fbe84770e58c\":\"0x22b1c8c1227a00000\",\"0x2b77a4d88c0d56a3dbe3bae04a05f4fcd1b757e1\":\"0x1043561a8829300000\",\"0x2b8488bd2d3c197a3d26151815b5a798d27168dc\":\"0x16a1f9f5fd7d9600000\",\"0x2b8a0dee5cb0e1e97e15cfca6e19ad21f995efad\":\"0x1b55438d9a249b0000\",\"0x2b8fe4166e23d11963c0932b8ade8e0145ea0770\":\"0x92896529baddc880000\",\"0x2b99b42e4f42619ee36baa7e4af2d65eacfcba35\":\"0x878678326eac9000000\",\"0x2bab0fbe28d58420b52036770a12f9952aea6911\":\"0xcf152640c5c8300000\",\"0x2bade91d154517620fd4b439ac97157a4102a9f7\":\"0xd8d726b7177a800000\",\"0x2baf8d6e221174124820ee492b9459ec4fadafbb\":\"0x6c6b935b8bbd400000\",\"0x2bafbf9e9ed2c219f7f2791374e7d05cb06777e7\":\"0xbed1d0263d9f00000\",\"0x2bb366b9edcb0da680f0e10b3b6e28748190d6c3\":\"0x13a62d7b57640640000\",\"0x2bb6f578adfbe7b2a116b3554facf9969813c319\":\"0x19127a1391ea2a00000\",\"0x2bbe62eac80ca7f4d6fdee7e7d8e28b63acf770e\":\"0x81e32df972abf00000\",\"0x2bbe672a1857508f630f2a5edb563d9e9de92815\":\"0x6c6b935b8bbd400000\",\"0x2bc429d618a66a4cf82dbb2d824e9356effa126a\":\"0x6c6acc67d7b1d40000\",\"0x2bd252e0d732ff1d7c78f0a02e6cb25423cf1b1a\":\"0x90f534608a72880000\",\"0x2bdd03bebbee273b6ca1059b34999a5bbd61bb79\":\"0x1158e460913d00000\",\"0x2c04115c3e52961b0dc0b0bf31fba4546f5966fd\":\"0xad78ebc5ac6200000\",\"0x2c06dd922b61514aafedd84488c0c28e6dcf0e99\":\"0x152d02c7e14af6800000\",\"0x2c0cc3f951482cc8a2925815684eb9f94e060200\":\"0x14542ba12a337c00000\",\"0x2c0ee134d8b36145b47beee7af8d2738dbda08e8\":\"0xae56f730e6d840000\",\"0x2c0f5b9df43625798e7e03c1a5fd6a6d091af82b\":\"0x1b0fcaab200300000\",\"0x2c128c95d957215101f043dd8fc582456d41016d\":\"0x2d43f3ebfafb2c0000\",\"0x2c1800f35fa02d3eb6ff5b25285f5e4add13b38d\":\"0x3122d3adafde100000\",\"0x2c1c19114e3d6de27851484b8d2715e50f8a1065\":\"0x56bc75e2d63100000\",\"0x2c1cc6e18c152488ba11c2cc1bcefa2df306abd1\":\"0x5a87e7d7f5f6580000\",\"0x2c1df8a76f48f6b54bcf9caf56f0ee1cf57ab33d\":\"0x2247f750089da580000\",\"0x2c2147947ae33fb098b489a5c16bfff9abcd4e2a\":\"0xad78ebc5ac6200000\",\"0x2c234f505ca8dcc77d9b7e01d257c318cc19396d\":\"0x56bc75e2d63100000\",\"0x2c2428e4a66974edc822d5dbfb241b2728075158\":\"0x6c6b935b8bbd400000\",\"0x2c2d15ff39561c1b72eda1cc027ffef23743a144\":\"0xd480ed9ef32b400000\",\"0x2c2db28c3309375eea3c6d72cd6d0eec145afcc0\":\"0x6c6b935b8bbd400000\",\"0x2c424ee47f583cdce07ae318b6fad462381d4d2b\":\"0xd8d726b7177a800000\",\"0x2c4b470307a059854055d91ec3794d80b53d0f4a\":\"0x43c33c1937564800000\",\"0x2c52c984102ee0cd3e31821b84d408930efa1ac7\":\"0x6c6b935b8bbd400000\",\"0x2c5a2d0abda03bbe215781b4ff296c8c61bdbaf6\":\"0x1a8e56f48c0228000\",\"0x2c5b7d7b195a371bf9abddb42fe04f2f1d9a9910\":\"0xad78ebc5ac6200000\",\"0x2c5df866666a194b26cebb407e4a1fd73e208d5e\":\"0x3635c9adc5dea00000\",\"0x2c603ff0fe93616c43573ef279bfea40888d6ae7\":\"0x100f4b6d66757900000\",\"0x2c6846a1aa999a2246a287056000ba4dcba8e63d\":\"0x21f2f6f0fc3c6100000\",\"0x2c6afcd4037c1ed14fa74ff6758e0945a185a8e8\":\"0xf43fc2c04ee00000\",\"0x2c6b699d9ead349f067f45711a074a641db6a897\":\"0x1158e460913d00000\",\"0x2c6f5c124cc789f8bb398e3f889751bc4b602d9e\":\"0x159f20bed00f00000\",\"0x2c83aeb02fcf067d65a47082fd977833ab1cec91\":\"0x8273823258ac00000\",\"0x2c89f5fdca3d155409b638b98a742e55eb4652b7\":\"0x14dbb2195ca228900000\",\"0x2c964849b1f69cc7cea4442538ed87fdf16cfc8f\":\"0x6c6b935b8bbd400000\",\"0x2c9fa72c95f37d08e9a36009e7a4b07f29bad41a\":\"0xdf6eb0b2d3ca0000\",\"0x2caf6bf4ec7d5a19c5e0897a5eeb011dcece4210\":\"0x7934835a031160000\",\"0x2cb4c3c16bb1c55e7c6b7a19b127a1ac9390cc09\":\"0xb82794a9244f0c8000\",\"0x2cb5495a505336c2465410d1cae095b8e1ba5cdd\":\"0x43c33c1937564800000\",\"0x2cb615073a40dcdb99faa848572e987b3b056efb\":\"0x2b58addb89a2580000\",\"0x2cba6d5d0dc204ea8a25ada2e26f5675bd5f2fdc\":\"0x4823ef7ddb9af38000\",\"0x2cbb0c73df91b91740b6693b774a7d05177e8e58\":\"0x6449e84e47a8a80000\",\"0x2ccb66494d0af689abf9483d365d782444e7dead\":\"0x3635c9adc5dea00000\",\"0x2ccc1f1cb5f4a8002e186b20885d9dbc030c0894\":\"0x6c6b935b8bbd400000\",\"0x2ccf80e21898125eb4e807cd82e09b9d28592f6e\":\"0x6c6b935b8bbd400000\",\"0x2cd19694d1926a0fa9189edebafc671cf1b2caa5\":\"0x3635c9adc5dea00000\",\"0x2cd39334ac7eac797257abe3736195f5b4b5ce0f\":\"0x56b47785e37260000\",\"0x2cd79eb52027b12c18828e3eaab2969bfcd287e9\":\"0x1158e460913d00000\",\"0x2cd87866568dd81ad47d9d3ad0846e5a65507373\":\"0x15af1d78b58c400000\",\"0x2cdb3944650616e47cb182e060322fa1487978ce\":\"0x62a992e53a0af00000\",\"0x2ce11a92fad024ff2b3e87e3b542e6c60dcbd996\":\"0xd8d726b7177a800000\",\"0x2d0326b23f0409c0c0e9236863a133075a94ba18\":\"0xb679be75be6ae0000\",\"0x2d0dec51a6e87330a6a8fa2a0f65d88d4abcdf73\":\"0xa076407d3f7440000\",\"0x2d23766b6f6b05737dad80a419c40eda4d77103e\":\"0xcf152640c5c8300000\",\"0x2d2b032359b363964fc11a518263bfd05431e867\":\"0x81c1df7629e700000\",\"0x2d3480bf0865074a72c7759ee5137b4d70c51ce9\":\"0xad78ebc5ac6200000\",\"0x2d35a9df62757f7ffad1049afb06ca4afc464c51\":\"0x1158e460913d00000\",\"0x2d40558b06f90a3923145592123b6774e46e31f4\":\"0x3635c9adc5dea00000\",\"0x2d426912d059fad9740b2e390a2eeac0546ff01b\":\"0x4be4e7267b6ae00000\",\"0x2d532df4c63911d1ce91f6d1fcbff7960f78a885\":\"0x5a85968a5878da8000\",\"0x2d5391e938b34858cf965b840531d5efda410b09\":\"0x4be4e7267b6ae00000\",\"0x2d5b42fc59ebda0dfd66ae914bc28c1b0a6ef83a\":\"0x2bc8b59fdcd836638000\",\"0x2d5d7335acb0362b47dfa3a8a4d3f5949544d380\":\"0xad78ebc5ac6200000\",\"0x2d61bfc56873923c2b00095dc3eaa0f590d8ae0f\":\"0x46566dff8ce55600000\",\"0x2d6511fd7a3800b26854c7ec39c0dcb5f4c4e8e8\":\"0x15adddba2f9e770000\",\"0x2d7d5c40ddafc450b04a74a4dabc2bb5d665002e\":\"0x6c6b935b8bbd400000\",\"0x2d89a8006a4f137a20dc2bec46fe2eb312ea9654\":\"0xad78ebc5ac6200000\",\"0x2d8c52329f38d2a2fa9cbaf5c583daf1490bb11c\":\"0x1158e460913d00000\",\"0x2d8e061892a5dcce21966ae1bb0788fd3e8ba059\":\"0xd8e5ce617f2d50000\",\"0x2d8e5bb8d3521695c77e7c834e0291bfacee7408\":\"0x6acb3df27e1f880000\",\"0x2d90b415a38e2e19cdd02ff3ad81a97af7cbf672\":\"0x5f3c7f64131e40000\",\"0x2d9bad6f1ee02a70f1f13def5cccb27a9a274031\":\"0x61093d7c2c6d380000\",\"0x2d9c5fecd2b44fbb6a1ec732ea059f4f1f9d2b5c\":\"0x36ca32661d1aa70000\",\"0x2da617695009cc57d26ad490b32a5dfbeb934e5e\":\"0x43c33c1937564800000\",\"0x2da76b7c39b420e388ba2c1020b0856b0270648a\":\"0x6c6b935b8bbd400000\",\"0x2dc79d6e7f55bce2e2d0c02ad07ceca8bb529354\":\"0x55a6e79ccd1d300000\",\"0x2dca0e449ab646dbdfd393a96662960bcab5ae1e\":\"0x878678326eac9000000\",\"0x2dd325fdffb97b19995284afa5abdb574a1df16a\":\"0x1b1ae4d6e2ef500000\",\"0x2dd578f7407dfbd548d05e95ccc39c485429626a\":\"0xe3aeb5737240a00000\",\"0x2dd8eeef87194abc2ce7585da1e35b7cea780cb7\":\"0x3635c6204739d98000\",\"0x2ddf40905769bcc426cb2c2938ffe077e1e89d98\":\"0xa2a15d09519be00000\",\"0x2de0964400c282bdd78a919c6bf77c6b5f796179\":\"0xad78ebc5ac6200000\",\"0x2de31afd189a13a76ff6fe73ead9f74bb5c4a629\":\"0x14542ba12a337c00000\",\"0x2dec98329d1f96c3a59caa7981755452d4da49d5\":\"0xad78ebc5ac6200000\",\"0x2dee90a28f192d676a8773232b56f18f239e2fad\":\"0x3efa7e747b6d1ad0000\",\"0x2e0880a34596230720f05ac8f065af8681dcb6c2\":\"0x152d02c7e14af6800000\",\"0x2e0c57b47150f95aa6a7e16ab9b1cbf54328979a\":\"0x56bc75e2d63100000\",\"0x2e10910ba6e0bc17e055556614cb87090f4d7e5b\":\"0xad78ebc5ac6200000\",\"0x2e24b597873bb141bdb237ea8a5ab747799af02d\":\"0x43c33c1937564800000\",\"0x2e2810dee44ae4dff3d86342ab126657d653c336\":\"0xad78ebc5ac6200000\",\"0x2e2cbd7ad82547b4f5ff8b3ab56f942a6445a3b0\":\"0xad78ebc5ac6200000\",\"0x2e2d7ea66b9f47d8cc52c01c52b6e191bc7d4786\":\"0xd8d4602c26bf6c0000\",\"0x2e439348df8a4277b22a768457d1158e97c40904\":\"0x2a1e9ff26fbf410000\",\"0x2e46fcee6a3bb145b594a243a3913fce5dad6fba\":\"0x21e19e0c9bab2400000\",\"0x2e47f287f498233713850d3126823cc67dcee255\":\"0xca9d9ea558b40000\",\"0x2e4ee1ae996aa0a1d92428d06652a6bea6d2d15d\":\"0x6c6b935b8bbd400000\",\"0x2e52912bc10ea39d54e293f7aed6b99a0f4c73be\":\"0x15af1d78b58c400000\",\"0x2e619f57abc1e987aa936ae3a2264962e7eb2d9a\":\"0x28fb9b8a8a53500000\",\"0x2e64a8d71111a22f4c5de1e039b336f68d398a7c\":\"0x6c6b935b8bbd400000\",\"0x2e6933543d4f2cc00b5350bd8068ba9243d6beb0\":\"0x6c6b935b8bbd400000\",\"0x2e7e05e29edda7e4ae25c5173543efd71f6d3d80\":\"0x14542ba12a337c00000\",\"0x2e7f465520ec35cc23d68e75651bb6689544a196\":\"0x38ec5b721a1a268000\",\"0x2e8eb30a716e5fe15c74233e039bfb1106e81d12\":\"0x56bc75e2d63100000\",\"0x2e9824b5c132111bca24ddfba7e575a5cd7296c1\":\"0x3a484516e6d7ffe0000\",\"0x2ea5fee63f337a376e4b918ea82148f94d48a626\":\"0x650f8e0dd293c50000\",\"0x2eaf4e2a46b789ccc288c8d1d9294e3fb0853896\":\"0x6c6b935b8bbd400000\",\"0x2eaff9f8f8113064d3957ac6d6e11eee42c8195d\":\"0x6acb3df27e1f880000\",\"0x2eba0c6ee5a1145c1c573984963a605d880a7a20\":\"0x1b1ae4d6e2ef500000\",\"0x2ec95822eb887bc113b4712a4dfd7f13b097b5e7\":\"0x3635c9adc5dea00000\",\"0x2eca6a3c5d9f449d0956bd43fa7b4d7be8435958\":\"0x6c6bda69709cc20000\",\"0x2ecac504b233866eb5a4a99e7bd2901359e43b3d\":\"0x43c33c1937564800000\",\"0x2eebf59432b52892f9380bd140aa99dcf8ad0c0f\":\"0x83d6c7aab63600000\",\"0x2eeed50471a1a2bf53ee30b1232e6e9d80ef866d\":\"0x1158e460913d00000\",\"0x2eef6b1417d7b10ecfc19b123a8a89e73e526c58\":\"0x2086ac351052600000\",\"0x2ef869f0350b57d53478d701e3fee529bc911c75\":\"0x2b5e3af16b1880000\",\"0x2ef9e465716acacfb8c8252fa8e7bc7969ebf6e4\":\"0x959eb1c0e4ae200000\",\"0x2efc4c647dac6acac35577ad221758fef6616faa\":\"0x1b1ae4d6e2ef5000000\",\"0x2f13657526b177cad547c3908c840eff647b45d9\":\"0x3f76849cf1ee2c8000\",\"0x2f187d5a704d5a338c5b2876a090dce964284e29\":\"0xd8d726b7177a800000\",\"0x2f2523cc834f0086052402626296675186a8e582\":\"0x3635c9adc5dea000000\",\"0x2f282abbb6d4a3c3cd3b5ca812f7643e80305f06\":\"0x6449e84e47a8a80000\",\"0x2f2bba1b1796821a766fce64b84f28ec68f15aea\":\"0x1158e460913d00000\",\"0x2f315d9016e8ee5f536681202f9084b032544d4d\":\"0x383cd12b9e863c0000\",\"0x2f4da753430fc09e73acbccdcde9da647f2b5d37\":\"0xad78ebc5ac6200000\",\"0x2f5080b83f7e2dc0a1dd11b092ad042bff788f4c\":\"0xb4f8fb79231d2b8000\",\"0x2f61efa5819d705f2b1e4ee754aeb8a819506a75\":\"0x4f2591f896a6500000\",\"0x2f66bfbf2262efcc8d2bd0444fc5b0696298ff1e\":\"0x21ad935f79f76d00000\",\"0x2f6dce1330c59ef921602154572d4d4bacbd048a\":\"0x3635c9adc5dea00000\",\"0x2f7d3290851be5c6b4b43f7d4574329f61a792c3\":\"0x56bc75e2d63100000\",\"0x2f853817afd3b8f3b86e9f60ee77b5d97773c0e3\":\"0x4eaeea44e368b90000\",\"0x2fa491fb5920a6574ebd289f39c1b2430d2d9a6a\":\"0x6c6b935b8bbd400000\",\"0x2fb566c94bbba4e3cb67cdda7d5fad7131539102\":\"0x6c6b935b8bbd400000\",\"0x2fbb504a5dc527d3e3eb0085e2fc3c7dd538cb7a\":\"0x43c2b18aec3c0a8000\",\"0x2fbc85798a583598b522166d6e9dda121d627dbc\":\"0xad78ebc5ac6200000\",\"0x2fbcef3384d420e4bf61a0669990bc7054f1a5af\":\"0x6c6b935b8bbd400000\",\"0x2fc82ef076932341264f617a0c80dd571e6ae939\":\"0x18424f5f0b1b4e00000\",\"0x2fdd9b79df8df530ad63c20e62af431ae99216b8\":\"0x1236efcbcbb340000\",\"0x2fe0023f5722650f3a8ac01009125e74e3f82e9b\":\"0xa2a15d09519be00000\",\"0x2fe0cc424b53a31f0916be08ec81c50bf8eab0c1\":\"0x2086ac351052600000\",\"0x2fe13a8d0785de8758a5e41876c36e916cf75074\":\"0xd8d726b7177a800000\",\"0x2fea1b2f834f02fc54333f8a809f0438e5870aa9\":\"0x11854d0f9cee40000\",\"0x2fee36a49ee50ecf716f1047915646779f8ba03f\":\"0x394222c4da86d70000\",\"0x2fef81478a4b2e8098db5ff387ba2153f4e22b79\":\"0x3627e8f712373c0000\",\"0x2ff160c44f72a299b5ec2d71e28ce5446d2fcbaf\":\"0x138400eca364a00000\",\"0x2ff1ca55fd9cec1b1fe9f0a9abb74c513c1e2aaa\":\"0xa2a15d09519be00000\",\"0x2ff5cab12c0d957fd333f382eeb75107a64cb8e8\":\"0x21e19e0c9bab2400000\",\"0x2ff830cf55fb00d5a0e03514fecd44314bd6d9f1\":\"0x21e19e0c9bab2400000\",\"0x2ffe93ec1a5636e9ee34af70dff52682e6ff7079\":\"0x6c6b935b8bbd400000\",\"0x30037988702671acbe892c03fe5788aa98af287a\":\"0x97c9ce4cf6d5c00000\",\"0x30248d58e414b20fed3a6c482b59d9d8f5a4b7e2\":\"0x340aad21b3b700000\",\"0x303139bc596403d5d3931f774c66c4ba467454db\":\"0x5c25e14aea283f0000\",\"0x30380087786965149e81423b15e313ba32c5c783\":\"0xfc936392801c0000\",\"0x303a30ac4286ae17cf483dad7b870c6bd64d7b4a\":\"0x1b1ae4d6e2ef500000\",\"0x303fbaebbe46b35b6e5b74946a5f99bc1585cae7\":\"0x2f9ac0695f5bba0000\",\"0x3041445a33ba158741160d9c344eb88e5c306f94\":\"0x340aad21b3b700000\",\"0x30480164bcd84974ebc0d90c9b9afab626cd1c73\":\"0x2b5e3af16b18800000\",\"0x304ec69a74545721d7316aef4dcfb41ac59ee2f0\":\"0xad78ebc5ac6200000\",\"0x30511832918d8034a7bee72ef2bfee440ecbbcf6\":\"0x368c8623a8b4d100000\",\"0x30513fca9f36fd788cfea7a340e86df98294a244\":\"0x183b5f03b1479c0000\",\"0x3055efd26029e0d11b930df4f53b162c8c3fd2ce\":\"0x1b1a089237073d0000\",\"0x305d26c10bdc103f6b9c21272eb7cb2d9108c47e\":\"0x1b1ae4d6e2ef500000\",\"0x305f78d618b990b4295bac8a2dfa262884f804ea\":\"0xd8d726b7177a800000\",\"0x3064899a963c4779cbf613cd6980846af1e6ec65\":\"0x17b773ce6e5df0a0000\",\"0x30730466b8eb6dc90d5496aa76a3472d7dbe0bbe\":\"0x6c68ccd09b022c0000\",\"0x30742ccdf4abbcd005681f8159345c9e79054b1a\":\"0x243d4d18229ca20000\",\"0x3083ef0ed4c4401196774a95cf4edc83edc1484f\":\"0x23ffb7ed6565d6400000\",\"0x308dd21cebe755126704b48c0f0dc234c60ba9b1\":\"0xad78ebc5ac6200000\",\"0x3090f8130ec44466afadb36ed3c926133963677b\":\"0xd8d726b7177a800000\",\"0x309544b6232c3dd737f945a03193d19b5f3f65b9\":\"0x3af342f67ef6c80000\",\"0x3096dca34108085bcf04ae72b94574a13e1a3e1d\":\"0xad78ebc5ac6200000\",\"0x3098b65db93ecacaf7353c48808390a223d57684\":\"0x186484cf7bb6a48000\",\"0x30a9da72574c51e7ee0904ba1f73a6b7b83b9b9d\":\"0x11854d0f9cee40000\",\"0x30acd858875fa24eef0d572fc7d62aad0ebddc35\":\"0x15af1d78b58c400000\",\"0x30b66150f1a63457023fdd45d0cc6cb54e0c0f06\":\"0x3635c9adc5dea00000\",\"0x30bb4357cd6910c86d2238bf727cbe8156680e62\":\"0x56bf91b1a65eb0000\",\"0x30bf61b2d877fe10635126326fa189e4b0b1c3b0\":\"0x37b48985a5d7e60000\",\"0x30c01142907acb1565f70438b9980ae731818738\":\"0x6c6b935b8bbd400000\",\"0x30c26a8e971baa1855d633ba703f028cc7873140\":\"0x21e19e0c9bab2400000\",\"0x30db6b9b107e62102f434a9dd0960c2021f5ce4c\":\"0x2083179b6e42530000\",\"0x30e33358fc21c85006e40f32357dc8895940aaf0\":\"0x678a932062e4180000\",\"0x30e60900cacc7203f314dc604347255167fc2a0f\":\"0x6c6b935b8bbd400000\",\"0x30e789b3d2465e946e6210fa5b35de4e8c93085f\":\"0x6c6b935b8bbd400000\",\"0x30e9698cf1e08a9d048bd8d8048f28be7ed9409f\":\"0x16a6502f15a1e540000\",\"0x30e9d5a0088f1ddb2fd380e2a049192266c51cbf\":\"0xaacacd9b9e22b0000\",\"0x30eac740e4f02cb56eef0526e5d300322600d03e\":\"0x6acb3df27e1f880000\",\"0x30ec9392244a2108c987bc5cdde0ed9f837a817b\":\"0x549925f6c9c5250000\",\"0x30ed11b77bc17e5e6694c8bc5b6e4798f68d9ca7\":\"0x1e6fb3421fe0299e0000\",\"0x30f7d025d16f7bee105580486f9f561c7bae3fef\":\"0x1b1ae4d6e2ef500000\",\"0x30fbe5885f9fcce9ea5edb82ed4a1196dd259aed\":\"0x119e47f21381f400000\",\"0x31047d703f63b93424fbbd6e2f1f9e74de13e709\":\"0x9a8166f7e6b2a78000\",\"0x31313ffd635bf2f3324841a88c07ed146144ceeb\":\"0x6acb3df27e1f880000\",\"0x3159e90c48a915904adfe292b22fa5fd5e72796b\":\"0x36afe98f2606100000\",\"0x315db7439fa1d5b423afa7dd7198c1cf74c918bc\":\"0x2086ac351052600000\",\"0x315ef2da620fd330d12ee55de5f329a696e0a968\":\"0x821ab0d4414980000\",\"0x316e92a91bbda68b9e2f98b3c048934e3cc0b416\":\"0x6c6b935b8bbd400000\",\"0x316eb4e47df71b42e16d6fe46825b7327baf3124\":\"0xd8d726b7177a800000\",\"0x3171877e9d820cc618fc0919b29efd333fda4934\":\"0x3635c9adc5dea00000\",\"0x317cf4a23cb191cdc56312c29d15e210b3b9b784\":\"0x7ce66c50e28400000\",\"0x318b2ea5f0aaa879c4d5e548ac9d92a0c67487b7\":\"0xad78ebc5ac6200000\",\"0x318c76ecfd8af68d70555352e1f601e35988042d\":\"0x1b31192e68c7f00000\",\"0x318f1f8bd220b0558b95fb33100ffdbb640d7ca6\":\"0xd8d726b7177a800000\",\"0x31aa3b1ebe8c4dbcb6a708b1d74831e60e497660\":\"0x15af1d78b58c400000\",\"0x31ab088966ecc7229258f6098fce68cf39b38485\":\"0x3635c9adc5dea00000\",\"0x31ad4d9946ef09d8e988d946b1227f9141901736\":\"0x4d853c8f89089800000\",\"0x31b43b015d0081643c6cda46a7073a6dfdbca825\":\"0xa97916520cd18e80000\",\"0x31ccc616b3118268e75d9ab8996c8858ebd7f3c3\":\"0x15ae0f771ca1520000\",\"0x31d81d526c195e3f10b5c6db52b5e59afbe0a995\":\"0xe4fbc69449f200000\",\"0x31e9c00f0c206a4e4e7e0522170dc81e88f3eb70\":\"0x918ddc3a42a3d40000\",\"0x31ea12d49a35a740780ddeeaece84c0835b26270\":\"0xad78ebc5ac6200000\",\"0x31ea6eab19d00764e9a95e183f2b1b22fc7dc40f\":\"0x1158e460913d00000\",\"0x31eb123c95c82bf685ace7a75a1881a289efca10\":\"0x31e009607371bd0000\",\"0x31ed858788bda4d5270992221cc04206ec62610d\":\"0x3fc0474948f3600000\",\"0x31f006f3494ed6c16eb92aaf9044fa8abb5fd5a3\":\"0x1b1ae4d6e2ef500000\",\"0x3201259caf734ad7581c561051ba0bca7fd6946b\":\"0x261dd1ce2f2088800000\",\"0x32034e8581d9484e8af42a28df190132ec29c466\":\"0xbb9125542263900000\",\"0x322021022678a0166d204b3aaa7ad4ec4b88b7d0\":\"0x15af1d78b58c400000\",\"0x3225c1ca5f2a9c88156bb7d9cdc44a326653c214\":\"0x15af1d78b58c400000\",\"0x322788b5e29bf4f5f55ae1ddb32085fda91b8ebe\":\"0xad78ebc5ac6200000\",\"0x322d6f9a140d213f4c80cd051afe25c620bf4c7d\":\"0x1158e460913d00000\",\"0x322e5c43b0f524389655a9b3ff24f2d4db3da10f\":\"0xfc13b69b3e7e680000\",\"0x323486ca64b375474fb2b759a9e7a135859bd9f6\":\"0x15af1d78b58c400000\",\"0x323749a3b971959e46c8b4822dcafaf7aaf9bd6e\":\"0x11671a5b245700000\",\"0x323aad41df4b6fc8fece8c93958aa901fa680843\":\"0x34957444b840e80000\",\"0x323b3cfe3ee62bbde2a261e53cb3ecc05810f2c6\":\"0x2eb8eb1a172dcb80000\",\"0x323fca5ed77f699f9d9930f5ceeff8e56f59f03c\":\"0x487a9a304539440000\",\"0x32485c818728c197fea487fbb6e829159eba8370\":\"0x3921b413bc4ec08000\",\"0x3250e3e858c26adeccadf36a5663c22aa84c4170\":\"0x10f0cf064dd59200000\",\"0x3259bd2fddfbbc6fbad3b6e874f0bbc02cda18b5\":\"0x2846056495b0d188000\",\"0x3275496fd4dd8931fd69fb0a0b04c4d1ff879ef5\":\"0x182d7e4cfda0380000\",\"0x327bb49e754f6fb4f733c6e06f3989b4f65d4bee\":\"0x1158e460913d00000\",\"0x3282791d6fd713f1e94f4bfd565eaa78b3a0599d\":\"0x487a9a304539440000\",\"0x3283eb7f9137dd39bed55ffe6b8dc845f3e1a079\":\"0x3970ae92155780000\",\"0x32860997d730b2d83b73241a25d3667d51c908ef\":\"0x1b1a089237073d0000\",\"0x3286d1bc657a312c8847d93cb3cb7950f2b0c6e3\":\"0x43c33c1937564800000\",\"0x32a20d028e2c6218b9d95b445c771524636a22ef\":\"0x202fefbf2d7c2f00000\",\"0x32a70691255c9fc9791a4f75c8b81f388e0a2503\":\"0x35659ef93f0fc40000\",\"0x32b7feebc5c59bf65e861c4c0be42a7611a5541a\":\"0x77e9aaa8525c100000\",\"0x32ba9a7d0423e03a525fe2ebeb661d2085778bd8\":\"0x43c33c1937564800000\",\"0x32bb2e9693e4e085344d2f0dbd46a283e3a087fd\":\"0x15af1d78b58c400000\",\"0x32c2fde2b6aabb80e5aea2b949a217f3cb092283\":\"0x1306160afdf20378000\",\"0x32d950d5e93ea1d5b48db4714f867b0320b31c0f\":\"0x3708baed3d68900000\",\"0x32dbb6716c54e83165829a4abb36757849b6e47d\":\"0x3635c9adc5dea00000\",\"0x32eb64be1b5dede408c6bdefbe6e405c16b7ed02\":\"0x6acb3df27e1f880000\",\"0x32ef5cdc671df5562a901aee5db716b9be76dcf6\":\"0x6c6b935b8bbd400000\",\"0x32f29e8727a74c6b4301e3ffff0687c1b870dae9\":\"0x3635c9adc5dea00000\",\"0x32fa0e86cd087dd68d693190f32d93310909ed53\":\"0xd8d726b7177a800000\",\"0x32fbeed6f626fcdfd51acafb730b9eeff612f564\":\"0x6c6b935b8bbd400000\",\"0x3300fb149aded65bcba6c04e9cd6b7a03b893bb1\":\"0xfc936392801c0000\",\"0x3301d9ca2f3bfe026279cd6819f79a293d98156e\":\"0xa968163f0a57b400000\",\"0x3308b03466c27a17dfe1aafceb81e16d2934566f\":\"0x39992648a23c8a00000\",\"0x331a1c26cc6994cdd3c14bece276ffff4b9df77c\":\"0xfa7aeddf4f068000\",\"0x3326b88de806184454c40b27f309d9dd6dcfb978\":\"0x3ca5c66d9bc44300000\",\"0x3329eb3baf4345d600ced40e6e9975656f113742\":\"0x10f08eda8e555098000\",\"0x33320dd90f2baa110dd334872a998f148426453c\":\"0x36356633ebd8ea0000\",\"0x3336c3ef6e8b50ee90e037b164b7a8ea5faac65d\":\"0xec8a3a71c22540000\",\"0x33380c6fff5acd2651309629db9a71bf3f20c5ba\":\"0x368c8623a8b4d100000\",\"0x333ad1596401e05aea2d36ca47318ef4cd2cb3df\":\"0x9dc05cce28c2b80000\",\"0x334340ee4b9cdc81f850a75116d50ee9b69825bf\":\"0x6c6b935b8bbd400000\",\"0x33481e856ebed48ea708a27426ef28e867f57cd1\":\"0xad78ebc5ac6200000\",\"0x33565ba9da2c03e778ce12294f081dfe81064d24\":\"0x3635c9adc5dea000000\",\"0x33581cee233088c0860d944e0cf1ceabb8261c2e\":\"0xb98bc829a6f90000\",\"0x335858f749f169cabcfe52b796e3c11ec47ea3c2\":\"0xad78ebc5ac6200000\",\"0x335e22025b7a77c3a074c78b8e3dfe071341946e\":\"0x227ca730ab3f6ac0000\",\"0x33629bd52f0e107bc071176c64df108f64777d49\":\"0x1cfdd7468216e8000\",\"0x337b3bdf86d713dbd07b5dbfcc022b7a7b1946ae\":\"0xd7c198710e66b00000\",\"0x337cfe1157a5c6912010dd561533791769c2b6a6\":\"0x3635c9adc5dea00000\",\"0x33b336f5ba5edb7b1ccc7eb1a0d984c1231d0edc\":\"0x6c6b935b8bbd400000\",\"0x33c407133b84b3ca4c3ded1f4658900c38101624\":\"0x97c9ce4cf6d5c00000\",\"0x33d172ab075c51db1cd40a8ca8dbff0d93b843bb\":\"0x136780510d12de38000\",\"0x33e9b71823952e1f66958c278fc28b1196a6c5a4\":\"0x56bc75e2d63100000\",\"0x33ea6b7855e05b07ab80dab1e14de9b649e99b6c\":\"0x1cd6fbad57dbd00000\",\"0x33f15223310d44de8b6636685f3a4c3d9c5655a5\":\"0xd9462c6cb4b5a0000\",\"0x33f4a6471eb1bca6a9f85b3b4872e10755c82be1\":\"0x6c6b935b8bbd400000\",\"0x33fb577a4d214fe010d32cca7c3eeda63f87ceef\":\"0x3635c9adc5dea00000\",\"0x33fd718f0b91b5cec88a5dc15eecf0ecefa4ef3d\":\"0x177224aa844c720000\",\"0x341480cc8cb476f8d01ff30812e7c70e05afaf5d\":\"0x6c6b935b8bbd400000\",\"0x34272d5e7574315dcae9abbd317bac90289d4765\":\"0x62a992e53a0af00000\",\"0x3430a16381f869f6ea5423915855e800883525a9\":\"0x3ca5c66d9bc44300000\",\"0x34318625818ec13f11835ae97353ce377d6f590a\":\"0x52663ccab1e1c00000\",\"0x34393c5d91b9de597203e75bac4309b5fa3d28c3\":\"0xa844a7424d9c80000\",\"0x3439998b247cb4bf8bc80a6d2b3527f1dfe9a6d2\":\"0x796e3ea3f8ab00000\",\"0x34437d1465640b136cb5841c3f934f9ba0b7097d\":\"0x960db77681e940000\",\"0x344a8db086faed4efc37131b3a22b0782dad7095\":\"0x1b1ae4d6e2ef500000\",\"0x34664d220fa7f37958024a3332d684bcc6d4c8bd\":\"0x21e19e0c9bab2400000\",\"0x3466f67e39636c01f43b3a21a0e8529325c08624\":\"0x2db1167650acd80000\",\"0x3485361ee6bf06ef6508ccd23d94641f814d3e2f\":\"0x6c6b935b8bbd400000\",\"0x3485f621256433b98a4200dad857efe55937ec98\":\"0x6c6b935b8bbd400000\",\"0x34958a46d30e30b273ecc6e5d358a212e5307e8c\":\"0x6c6b935b8bbd400000\",\"0x3497dd66fd118071a78c2cb36e40b6651cc82598\":\"0x5f1016b5076d00000\",\"0x349a816b17ab3d27bbc0ae0051f6a070be1ff29d\":\"0x21e19e0c9bab2400000\",\"0x349d2c918fd09e2807318e66ce432909176bd50b\":\"0x3cb71f51fc55800000\",\"0x34a0431fff5ead927f3c69649616dc6e97945f6f\":\"0x15af1d78b58c400000\",\"0x34a85d6d243fb1dfb7d1d2d44f536e947a4cee9e\":\"0x43c33c1937564800000\",\"0x34a901a69f036bcf9f7843c0ba01b426e8c3dc2b\":\"0xd8d726b7177a800000\",\"0x34b454416e9fb4274e6addf853428a0198d62ee1\":\"0x161042779f1ffc0000\",\"0x34c8e5f1330fcb4b14ca75cb2580a4b93d204e36\":\"0x6c6b935b8bbd400000\",\"0x34e2849bea583ab0cc37975190f322b395055582\":\"0x1a5c5e857fdf2b20000\",\"0x34fa7792bad8bbd7ff64056214a33eb6600c1ea8\":\"0x2b5e3af16b1880000\",\"0x34ff26eb60a8d1a95a489fae136ee91d4e58084c\":\"0x2086ac351052600000\",\"0x34ff582952ff24458f7b13d51f0b4f987022c1fe\":\"0x9806de3da6e9780000\",\"0x35106ba94e8563d4b3cb3c5c692c10e604b7ced8\":\"0x6c6b935b8bbd400000\",\"0x35145f620397c69cb8e00962961f0f4886643989\":\"0x14542ba12a337c00000\",\"0x35147430c3106500e79fa2f502462e94703c23b1\":\"0x6c6acc67d7b1d40000\",\"0x351787843505f8e4eff46566cce6a59f4d1c5fe7\":\"0x1f5718987664b480000\",\"0x351f16e5e0735af56751b0e225b2421171394090\":\"0x2d4ca05e2b43ca80000\",\"0x3524a000234ebaaf0789a134a2a417383ce5282a\":\"0x1317955947d8e2c0000\",\"0x3526eece1a6bdc3ee7b400fe935b48463f31bed7\":\"0x477879b6d14300000\",\"0x352a785f4a921632504ce5d015f83c49aa838d6d\":\"0xe9e7e0fb35b7780000\",\"0x352d29a26e8a41818181746467f582e6e84012e0\":\"0x14542ba12a337c00000\",\"0x352e77c861696ef96ad54934f894aa8ea35151dd\":\"0x3635c9adc5dea00000\",\"0x352f25babf4a690673e35195efa8f79d05848aad\":\"0xe253c39be6e7dc00000\",\"0x3536453322c1466cb905af5c335ca8db74bff1e6\":\"0x183b5f03b1479c0000\",\"0x353dbec42f92b50f975129b93c4c997375f09073\":\"0x6c5db2a4d815dc0000\",\"0x3540c7bd7a8442d5bee21a2180a1c4edff1649e0\":\"0x432eac4c6f05b98000\",\"0x3549bd40bbbc2b30095cac8be2c07a0588e0aed6\":\"0x1158e460913d00000\",\"0x3552a496eba67f12be6eedab360cd13661dc7480\":\"0x1043561a8829300000\",\"0x3554947b7b947b0040da52ca180925c6d3b88ffe\":\"0x39fbae8d042dd0000\",\"0x355c0c39f5d5700b41d375b3f17851dcd52401f9\":\"0xd7b3b7ba5abf4c0000\",\"0x355ccfe0e77d557b971be1a558bc02df9eee0594\":\"0x5f5cb1afc865280000\",\"0x3571cf7ad304ecaee595792f4bbfa484418549d6\":\"0x13bcd0d892d9e160000\",\"0x3575c770668a9d179f1ef768c293f80166e2aa3d\":\"0x19b21248a3ef280000\",\"0x357a02c0a9dfe287de447fb67a70ec5b62366647\":\"0x1731790534df20000\",\"0x35855ec641ab9e081ed0c2a6dcd81354d0244a87\":\"0x4127abe993a7aa8000\",\"0x3588895ac9fbafec012092dc05c0c302d90740fa\":\"0xa2a15d09519be00000\",\"0x3599493ce65772cf93e98af1195ec0955dc98002\":\"0x5151590c67b3280000\",\"0x35a08081799173e001cc5bd46a02406dc95d1787\":\"0x21e19e0c9bab2400000\",\"0x35a549e8fd6c368d6dcca6d2e7d18e4db95f5284\":\"0x1b1a089237073d0000\",\"0x35a6885083c899dabbf530ed6c12f4dd3a204cf5\":\"0xad78ebc5ac6200000\",\"0x35aaa0465d1c260c420fa30e2629869fb6559207\":\"0x263781e0e087c80000\",\"0x35ac1d3ed7464fa3db14e7729213ceaa378c095e\":\"0x52663ccab1e1c00000\",\"0x35af040a0cc2337a76af288154c7561e1a233349\":\"0x3635c9adc5dea00000\",\"0x35b03ea4245736f57b85d2eb79628f036ddcd705\":\"0xd8d726b7177a800000\",\"0x35bd246865fab490ac087ac1f1d4f2c10d0cda03\":\"0x15af1d78b58c400000\",\"0x35bf6688522f35467a7f75302314c02ba176800e\":\"0x3af418202d954e00000\",\"0x35c8adc11125432b3b77acd64625fe58ebee9d66\":\"0x6c6b935b8bbd400000\",\"0x35d2970f49dcc81ea9ee707e9c8a0ab2a8bb7463\":\"0x4e1003b28d92800000\",\"0x35e096120deaa5c1ecb1645e2ccb8b4edbd9299a\":\"0x1b1ae4d6e2ef500000\",\"0x35ea2163a38cdf9a123f82a5ec00258dae0bc767\":\"0xd8d726b7177a800000\",\"0x35f1da127b83376f1b88c82a3359f67a5e67dd50\":\"0x678a932062e4180000\",\"0x35f2949cf78bc219bb4f01907cf3b4b3d3865482\":\"0xfb5c86c92e4340000\",\"0x35f5860149e4bbc04b8ac5b272be55ad1aca58e0\":\"0xad78ebc5ac6200000\",\"0x3602458da86f6d6a9d9eb03daf97fe5619d442fa\":\"0x6c6b935b8bbd400000\",\"0x3605372d93a9010988018f9f315d032ed1880fa1\":\"0x1b1bcf51896a7d0000\",\"0x3616d448985f5d32aefa8b93a993e094bd854986\":\"0xb227f63be813c0000\",\"0x3616fb46c81578c9c8eb4d3bf880451a88379d7d\":\"0xad78ebc5ac6200000\",\"0x361c75931696bc3d427d93e76c77fd13b241f6f4\":\"0x1dc5d8fc266dd60000\",\"0x361d9ed80b5bd27cf9f1226f26753258ee5f9b3f\":\"0xbf6914ba7d72c20000\",\"0x361f3ba9ed956b770f257d3672fe1ff9f7b0240c\":\"0x2086ac351052600000\",\"0x36227cdfa0fd3b9d7e6a744685f5be9aa366a7f0\":\"0xac2730ee9c6c18000\",\"0x362fbcb10662370a068fc2652602a2577937cce6\":\"0xad78ebc5ac6200000\",\"0x3630c5e565ceaa8a0f0ffe32875eae2a6ce63c19\":\"0x937722b3774d00000\",\"0x36339f84a5c2b44ce53dfdb6d4f97df78212a7df\":\"0x116f18b81715a00000\",\"0x36343aeca07b6ed58a0e62fa4ecb498a124fc971\":\"0x1043561a8829300000\",\"0x366175403481e0ab15bb514615cbb989ebc68f82\":\"0x6c6b935b8bbd400000\",\"0x36726f3b885a24f92996da81625ec8ad16d8cbe6\":\"0x53af75d18148578000\",\"0x3673954399f6dfbe671818259bb278e2e92ee315\":\"0x2a5a058fc295ed000000\",\"0x36758e049cd98bcea12277a676f9297362890023\":\"0xd8d726b7177a800000\",\"0x367f59cc82795329384e41e1283115e791f26a01\":\"0x6c6b935b8bbd400000\",\"0x36810ff9d213a271eda2b8aa798be654fa4bbe06\":\"0x6c6b935b8bbd400000\",\"0x368c5414b56b8455171fbf076220c1cba4b5ca31\":\"0x1e3ef911e83d720000\",\"0x3690246ba3c80679e22eac4412a1aefce6d7cd82\":\"0x43c33c1937564800000\",\"0x36928b55bc861509d51c8cf1d546bfec6e3e90af\":\"0x6acb3df27e1f880000\",\"0x369822f5578b40dd1f4471706b22cd971352da6b\":\"0x12c1b6eed03d280000\",\"0x369ef761195f3a373e24ece6cd22520fe0b9e86e\":\"0x1cffafc94db2088000\",\"0x36a08fd6fd1ac17ce15ed57eefb12a2be28188bf\":\"0x487a9a304539440000\",\"0x36a0e61e1be47fa87e30d32888ee0330901ca991\":\"0x1158e460913d00000\",\"0x36b2c85e3aeeebb70d63c4a4730ce2e8e88a3624\":\"0x21e19e0c9bab2400000\",\"0x36bf43ff35df90908824336c9b31ce33067e2f50\":\"0x49721510c1c1e9480000\",\"0x36bfe1fa3b7b70c172eb042f6819a8972595413e\":\"0x3635c9adc5dea00000\",\"0x36c510bf8d6e569bf2f37d47265dbcb502ff2bce\":\"0x65a4da25d3016c00000\",\"0x36d85dc3683156e63bf880a9fab7788cf8143a27\":\"0x43c33c1937564800000\",\"0x36df8f883c1273ec8a171f7a33cfd649b1fe6075\":\"0xc52484ac416890000\",\"0x36e156610cd8ff64e780d89d0054385ca76755aa\":\"0x2f6f10780d22cc00000\",\"0x36fec62c2c425e219b18448ad757009d8c54026f\":\"0x15af1d78b58c400000\",\"0x3700e3027424d939dbde5d42fb78f6c4dbec1a8f\":\"0x22b1c8c1227a00000\",\"0x3702e704cc21617439ad4ea27a5714f2fda1e932\":\"0x3635c9adc5dea00000\",\"0x3703350c4d6fe337342cddc65bf1e2386bf3f9b2\":\"0x6d8121a194d1100000\",\"0x3708e59de6b4055088782902e0579c7201a8bf50\":\"0x2a5a058fc295ed000000\",\"0x3712367e5e55a96d5a19168f6eb2bc7e9971f869\":\"0x3635c9adc5dea00000\",\"0x37195a635dcc62f56a718049d47e8f9f96832891\":\"0x6acb3df27e1f880000\",\"0x3727341f26c12001e378405ee38b2d8464ec7140\":\"0x6c6b935b8bbd400000\",\"0x372e453a6b629f27678cc8aeb5e57ce85ec0aef9\":\"0xad78ebc5ac6200000\",\"0x3734cb187491ede713ae5b3b2d12284af46b8101\":\"0xa2a15d09519be00000\",\"0x3737216ee91f177732fb58fa4097267207e2cf55\":\"0x52663ccab1e1c00000\",\"0x373c547e0cb5ce632e1c5ad66155720c01c40995\":\"0xfe54dcdce6c55a0000\",\"0x376cd7577383e902951b60a2017ba7ea29e33576\":\"0x6c6b935b8bbd400000\",\"0x378ea1dc8edc19bae82638029ea8752ce98bcfcd\":\"0x6c6b935b8bbd400000\",\"0x378f37243f3ff0bef5e1dc85eb4308d9340c29f9\":\"0x6c6e59e67c78540000\",\"0x37959c20b7e9931d72f5a8ae869dafddad3b6d5c\":\"0xad78ebc5ac6200000\",\"0x379a7f755a81a17edb7daaa28afc665dfa6be63a\":\"0x15af1d78b58c40000\",\"0x379c7166849bc24a02d6535e2def13daeef8aa8d\":\"0x56bc75e2d63100000\",\"0x37a05aceb9395c8635a39a7c5d266ae610d10bf2\":\"0x65a4da25d3016c00000\",\"0x37a10451f36166cf643dd2de6c1cbba8a011cfa3\":\"0x14998f32ac78700000\",\"0x37a7a6ff4ea3d60ec307ca516a48d3053bb79cbb\":\"0x6c6b935b8bbd400000\",\"0x37ab66083a4fa23848b886f9e66d79cdc150cc70\":\"0x12be22ffb5ec00380000\",\"0x37ac29bda93f497bc4aeaab935452c431510341e\":\"0x35659ef93f0fc40000\",\"0x37b8beac7b1ca38829d61ab552c766f48a10c32f\":\"0x15af1d78b58c400000\",\"0x37bbc47212d82fcb5ee08f5225ecc2041ad2da7d\":\"0xb1cf24ddd0b1400000\",\"0x37cb868d2c3f95b257611eb34a4188d58b749802\":\"0x6c6b935b8bbd400000\",\"0x37d980a12ee3bf23cc5cdb63b4ae45691f74c837\":\"0x6c6b935b8bbd400000\",\"0x37e169a93808d8035698f815c7235613c1e659f2\":\"0x3635c9adc5dea00000\",\"0x37eada93c475ded2f7e15e7787d400470fa52062\":\"0xad78ebc5ac6200000\",\"0x37fac1e6bc122e936dfb84de0c4bef6e0d60c2d7\":\"0x6c6b935b8bbd400000\",\"0x3807eff43aa97c76910a19752dd715ee0182d94e\":\"0xd90156f6fc2fb0000\",\"0x3815b0743f94fc8cc8654fd9d597ed7d8b77c57e\":\"0x2809d429d896750000\",\"0x381db4c8465df446a4ce15bf81d47e2f17c980bf\":\"0x6c6b935b8bbd4000000\",\"0x38202c5cd7078d4f887673ab07109ad8ada89720\":\"0x3635c9adc5dea00000\",\"0x3821862493242c0aeb84b90de05d250c1e50c074\":\"0x11776c58e946dc0000\",\"0x382591e7217b435e8e884cdbf415fe377a6fe29e\":\"0x1b2df9d219f57980000\",\"0x382ba76db41b75606dd48a48f0137e9174e031b6\":\"0x1158e460913d00000\",\"0x3831757eae7557cb8a37a4b10644b63e4d3b3c75\":\"0xad78ebc5ac6200000\",\"0x383304dd7a5720b29c1a10f60342219f48032f80\":\"0x12f939c99edab800000\",\"0x383a7c899ee18bc214969870bc7482f6d8f3570e\":\"0x21e19e0c9bab2400000\",\"0x38430e931d93be01b4c3ef0dc535f1e0a9610063\":\"0x21e19e0c9bab2400000\",\"0x38439aaa24e3636f3a18e020ea1da7e145160d86\":\"0x8cf23f909c0fa00000\",\"0x38458e0685573cb4d28f53098829904570179266\":\"0x22b1c8c1227a00000\",\"0x3847667038f33b01c1cc795d8daf5475eff5a0d4\":\"0x277b9bf4246c410000\",\"0x38643babea6011316cc797d9b093c897a17bdae7\":\"0x1220bb7445daa00000\",\"0x38695fc7e1367ceb163ebb053751f9f68ddb07a0\":\"0x6c6b935b8bbd400000\",\"0x3872f48dc5e3f817bc6b2ad2d030fc5e0471193d\":\"0xd8d726b7177a800000\",\"0x387eeafd6b4009deaf8bd5b85a72983a8dcc3487\":\"0xd8d726b7177a800000\",\"0x3881defae1c07b3ce04c78abe26b0cdc8d73f010\":\"0xad78ebc5ac6200000\",\"0x3883becc08b9be68ad3b0836aac3b620dc0017ef\":\"0x6c6b935b8bbd400000\",\"0x3885fee67107dc3a3c741ee290c98918c9b99397\":\"0x1158e460913d00000\",\"0x3887192c7f705006b630091276b39ac680448d6b\":\"0x340aad21b3b700000\",\"0x38898bbb4553e00bbfd0cf268b2fc464d154add5\":\"0x1158e460913d000000\",\"0x388bdcdae794fc44082e667501344118ea96cd96\":\"0x5a87e7d7f5f6580000\",\"0x388c85a9b9207d8146033fe38143f6d34b595c47\":\"0xad78ebc5ac6200000\",\"0x3896ad743579d38e2302454d1fb6e2ab69e01bfd\":\"0x65ea3db75546600000\",\"0x38a3dccf2fcfe0c91a2624bd0cbf88ee4a076c33\":\"0x6c6b935b8bbd400000\",\"0x38a744efa6d5c2137defef8ef9187b649eee1c78\":\"0xd8d726b7177a800000\",\"0x38ac664ee8e0795e4275cb852bcba6a479ad9c8d\":\"0x1158e460913d00000\",\"0x38b2197106123387a0d4de368431a8bacdda30e2\":\"0x1158e460913d00000\",\"0x38b3965c21fa893931079beacfffaf153678b6eb\":\"0x93c6a0a51e2670000\",\"0x38b403fb1fb7c14559a2d6f6564a5552bca39aff\":\"0x6c6b935b8bbd400000\",\"0x38b50146e71916a5448de12a4d742135dcf39833\":\"0x6d190c475169a200000\",\"0x38bf2a1f7a69de0e2546adb808b36335645da9ff\":\"0x6c700439d9b5600000\",\"0x38c10b90c859cbb7815692f99dae520ab5febf5e\":\"0x2c9e4966fa5cf240000\",\"0x38c7851f5ffd4cee98df30f3b25597af8a6ca263\":\"0x8ead3a2f7d7e180000\",\"0x38d2e9154964b41c8d50a7487d391e7ee2c3d3c2\":\"0xbdbc41e0348b300000\",\"0x38da1ba2de9e2c954b092dd9d81204fd016ba016\":\"0x2268ed01f34b3300000\",\"0x38df0c4abe7ded5fe068eadf154ac691774324a4\":\"0x61093d7c2c6d380000\",\"0x38e2af73393ea98a1d993a74df5cd754b98d529a\":\"0x61093d7c2c6d380000\",\"0x38e46de4453c38e941e7930f43304f94bb7b2be8\":\"0x6cb7e74867d5e60000\",\"0x38e7dba8fd4f1f850dbc2649d8e84f0952e3eb3c\":\"0x2b5e3af16b1880000\",\"0x38e8a31af2d265e31a9fff2d8f46286d1245a467\":\"0x1158e460913d00000\",\"0x38ea6f5b5a7b88417551b4123dc127dfe9342da6\":\"0x15af1d78b58c400000\",\"0x38eec6e217f4d41aa920e424b9525197041cd4c6\":\"0xf00d25eb922e670000\",\"0x38f387e1a4ed4a73106ef2b462e474e2e3143ad0\":\"0x14542ba12a337c00000\",\"0x391161b0e43c302066e8a68d2ce7e199ecdb1d57\":\"0xd8d726b7177a800000\",\"0x3915eab5ab2e5977d075dec47d96b68b4b5cf515\":\"0xd07018185120f400000\",\"0x391a77405c09a72b5e8436237aaaf95d68da1709\":\"0x2a9264af3d1b90000\",\"0x391f20176d12360d724d51470a90703675594a4d\":\"0x56bc75e2d631000000\",\"0x392433d2ce83d3fb4a7602cca3faca4ec140a4b0\":\"0x2c3c465ca58ec0000\",\"0x393f783b5cdb86221bf0294fb714959c7b45899c\":\"0x14061b9d77a5e980000\",\"0x393ff4255e5c658f2e7f10ecbd292572671bc2d2\":\"0x6c6b935b8bbd400000\",\"0x394132600f4155e07f4d45bc3eb8d9fb72dcd784\":\"0x9f6e92edea07d40000\",\"0x3951e48e3c869e6b72a143b6a45068cdb9d466d0\":\"0x1158e460913d00000\",\"0x3954bdfe0bf587c695a305d9244c3d5bdddac9bb\":\"0x410278327f985608000\",\"0x395d6d255520a8db29abc47d83a5db8a1a7df087\":\"0x56bc75e2d63100000\",\"0x39636b25811b176abfcfeeca64bc87452f1fdff4\":\"0x15af1d78b58c400000\",\"0x3969b4f71bb8751ede43c016363a7a614f76118e\":\"0x6c6b935b8bbd400000\",\"0x39782ffe06ac78822a3c3a8afe305e50a56188ce\":\"0x21e19e0c9bab2400000\",\"0x397a6ef8763a18f00fac217e055c0d3094101011\":\"0x6c6b935b8bbd400000\",\"0x397cdb8c80c67950b18d654229610e93bfa6ee1a\":\"0x3f95c8e08215210000\",\"0x39824f8bced176fd3ea22ec6a493d0ccc33fc147\":\"0xd8d726b7177a800000\",\"0x39936c2719450b9420cc2522cf91db01f227c1c1\":\"0x1b1ae4d6e2ef500000\",\"0x3995e096b08a5a726800fcd17d9c64c64e088d2b\":\"0xad78ebc5ac6200000\",\"0x399aa6f5d078cb0970882bc9992006f8fbdf3471\":\"0x3635c9adc5dea00000\",\"0x39aa05e56d7d32385421cf9336e90d3d15a9f859\":\"0x168d28e3f00280000\",\"0x39aaf0854db6eb39bc7b2e43846a76171c0445de\":\"0x6449e84e47a8a80000\",\"0x39b1c471ae94e12164452e811fbbe2b3cd7275ac\":\"0x6c6b935b8bbd400000\",\"0x39b299327490d72f9a9edff11b83afd0e9d3c450\":\"0xad78ebc5ac6200000\",\"0x39bac68d947859f59e9226089c96d62e9fbe3cde\":\"0x22b1c8c1227a00000\",\"0x39bfd978689bec048fc776aa15247f5e1d7c39a2\":\"0x43c33c1937564800000\",\"0x39c773367c8825d3596c686f42bf0d14319e3f84\":\"0x73f75d1a085ba0000\",\"0x39d4a931402c0c79c457186f24df8729cf957031\":\"0xd8d726b7177a800000\",\"0x39d6caca22bccd6a72f87ee7d6b59e0bde21d719\":\"0x6c8754c8f30c080000\",\"0x39e0db4d60568c800b8c5500026c2594f5768960\":\"0x3635c9adc5dea00000\",\"0x39ee4fe00fbced647068d4f57c01cb22a80bccd1\":\"0x14542ba12a337c00000\",\"0x39f198331e4b21c1b760a3155f4ab2fe00a74619\":\"0x6c6b935b8bbd400000\",\"0x39f44663d92561091b82a70dcf593d754005973a\":\"0xad78b2edc21598000\",\"0x3a035594c747476d42d1ee966c36224cdd224993\":\"0x134af74569f9c50000\",\"0x3a04572847d31e81f7765ca5bfc9d557159f3683\":\"0x7362d0dabeafd8000\",\"0x3a06e3bb1edcfd0c44c3074de0bb606b049894a2\":\"0x21e19e0c9bab2400000\",\"0x3a10888b7e149cae272c01302c327d0af01a0b24\":\"0xebec21ee1da40000\",\"0x3a3108c1e680a33b336c21131334409d97e5adec\":\"0x1158e460913d00000\",\"0x3a368efe4ad786e26395ec9fc6ad698cae29fe01\":\"0x2245899675f9f40000\",\"0x3a3dd104cd7eb04f21932fd433ea7affd39369f5\":\"0x13614f23e242260000\",\"0x3a4297da3c555e46c073669d0478fce75f2f790e\":\"0x6ac5c62d9486070000\",\"0x3a476bd2c9e664c63ab266aa4c6e4a4825f516c3\":\"0xad78ebc5ac6200000\",\"0x3a48e0a7098b06a905802b87545731118e89f439\":\"0x6c6b935b8bbd400000\",\"0x3a4da78dce05aeb87de9aead9185726da1926798\":\"0xad78ebc5ac6200000\",\"0x3a59a08246a8206f8d58f70bb1f0d35c5bcc71bd\":\"0xa076407d3f7440000\",\"0x3a72d635aadeee4382349db98a1813a4cfeb3df1\":\"0x2a5a058fc295ed000000\",\"0x3a7db224acae17de7798797d82cdf8253017dfa8\":\"0x10f0cf064dd59200000\",\"0x3a805fa0f7387f73055b7858ca8519edd93d634f\":\"0x6449e84e47a8a80000\",\"0x3a84e950ed410e51b7e8801049ab2634b285fea1\":\"0x3f52fdaa822d2c80000\",\"0x3a86ee94862b743dd34f410969d94e2c5652d4ad\":\"0xaede69ad30e810000\",\"0x3a9132b7093d3ec42e1e4fb8cb31ecdd43ae773c\":\"0x6c6b935b8bbd400000\",\"0x3a9960266df6492063538a99f487c950a3a5ec9e\":\"0x5150ae84a8cdf000000\",\"0x3a9b111029ce1f20c9109c7a74eeeef34f4f2eb2\":\"0xd8d726b7177a800000\",\"0x3a9e5441d44b243be55b75027a1ceb9eacf50df2\":\"0x3635c9adc5dea00000\",\"0x3aa07a34a1afc8967d3d1383b96b62cf96d5fa90\":\"0x43c33c1937564800000\",\"0x3aa42c21b9b31c3e27ccd17e099af679cdf56907\":\"0x1b1ae4d6e2ef5000000\",\"0x3aa948ea02397755effb2f9dc9392df1058f7e33\":\"0x2e141ea081ca080000\",\"0x3aadf98b61e5c896e7d100a3391d3250225d61df\":\"0xcaf67003701680000\",\"0x3aae4872fd9093cbcad1406f1e8078bab50359e2\":\"0x222c8eb3ff6640000\",\"0x3abb8adfc604f48d5984811d7f1d52fef6758270\":\"0xf29719b66f110c0000\",\"0x3ac2f0ff1612e4a1c346d53382abf6d8a25baa53\":\"0x6c6b935b8bbd400000\",\"0x3ac9dc7a436ae98fd01c7a9621aa8e9d0b8b531d\":\"0x61093d7c2c6d380000\",\"0x3ad06149b21c55ff867cc3fb9740d2bcc7101231\":\"0x29b76432b94451200000\",\"0x3ad70243d88bf0400f57c8c1fd57811848af162a\":\"0x2e9ee5c38653f00000\",\"0x3ad915d550b723415620f5a9b5b88a85f382f035\":\"0x3635c9adc5dea00000\",\"0x3ae160e3cd60ae31b9d6742d68e14e76bd96c517\":\"0x1a055690d9db80000\",\"0x3ae62bd271a760637fad79c31c94ff62b4cd12f7\":\"0x6c6b935b8bbd400000\",\"0x3aea4e82d2400248f99871a41ca257060d3a221b\":\"0x3635c9adc5dea00000\",\"0x3af65b3e28895a4a001153391d1e69c31fb9db39\":\"0xd5967be4fc3f100000\",\"0x3b07db5a357f5af2484cbc9d77d73b1fd0519fc7\":\"0x1b1ae4d6e2ef500000\",\"0x3b0accaf4b607cfe61d17334c214b75cdefdbd89\":\"0x6c6b935b8bbd400000\",\"0x3b13631a1b89cb566548899a1d60915cdcc4205b\":\"0x6c6b935b8bbd400000\",\"0x3b159099075207c6807663b1f0f7eda54ac8cce3\":\"0x6ac4e65b69f92d8000\",\"0x3b1937d5e793b89b63fb8eb5f1b1c9ca6ba0fa8e\":\"0x6c6b935b8bbd400000\",\"0x3b22da2a0271c8efe102532773636a69b1c17e09\":\"0x1b36a6444a3e180000\",\"0x3b22dea3c25f1b59c7bd27bb91d3a3eaecef3984\":\"0x56bc75e2d63100000\",\"0x3b2367f8494b5fe18d683c055d89999c9f3d1b34\":\"0x21e19e0c9bab2400000\",\"0x3b2c45990e21474451cf4f59f01955b331c7d7c9\":\"0x6c6b935b8bbd400000\",\"0x3b4100e30a73b0c734b18ffa8426d19b19312f1a\":\"0xbb5d1aa700afd900000\",\"0x3b42a66d979f582834747a8b60428e9b4eeccd23\":\"0x21a1c790fadc580000\",\"0x3b4768fd71e2db2cbe7fa050483c27b4eb931df3\":\"0x6c6b935b8bbd400000\",\"0x3b566a8afad19682dc2ce8679a3ce444a5b0fd4f\":\"0x6c6b935b8bbd400000\",\"0x3b5c251d7fd7893ba209fe541cecd0ce253a990d\":\"0x65a4da25d3016c00000\",\"0x3b5e8b3c77f792decb7a8985df916efb490aac23\":\"0x6c6b935b8bbd400000\",\"0x3b6e814f770748a7c3997806347605480a3fd509\":\"0x6c6b935b8bbd400000\",\"0x3b7b4f53c45655f3dc5f017edc23b16f9bc536fa\":\"0x56bc75e2d63100000\",\"0x3b7b8e27de33d3ce7961b98d19a52fe79f6c25be\":\"0x152d02c7e14af6800000\",\"0x3b7c77dbe95dc2602ce3269a9545d04965fefdbd\":\"0x6c6b935b8bbd400000\",\"0x3b8098533f7d9bdcd307dbb23e1777ca18418936\":\"0x6c6b935b8bbd400000\",\"0x3b93b16136f11eaf10996c95990d3b2739ccea5f\":\"0x21e19e0c9bab2400000\",\"0x3bab4b01a7c84ba13feea9b0bb191b77a3aadca3\":\"0xad78ebc5ac6200000\",\"0x3bb53598cc20e2055dc553b049404ac9b7dd1e83\":\"0x21571df77c00be0000\",\"0x3bbc13d04accc0707aebdcaef087d0b87e0b5ee3\":\"0xbed1d0263d9f000000\",\"0x3bc6e3ee7a56ce8f14a37532590f63716b9966e8\":\"0x6c6b935b8bbd400000\",\"0x3bc85d6c735b9cda4bba5f48b24b13e70630307b\":\"0x6acb3df27e1f880000\",\"0x3bd624b548cb659736907ed8aa3c0c705e24b575\":\"0x6c6b935b8bbd400000\",\"0x3bd9a06d1bd36c4edd27fc0d1f5b088ddae3c72a\":\"0x1b1a7a420ba00d0000\",\"0x3bddbc8134f77d55597fc97c26d26698090604eb\":\"0xbe202d6a0eda0000\",\"0x3bf86ed8a3153ec933786a02ac090301855e576b\":\"0x5f4a8c8375d155400000\",\"0x3bfbd3847c17a61cf3f17b52f8eba1b960b3f39f\":\"0xa2a15d09519be00000\",\"0x3c03bbc023e1e93fa3a3a6e428cf0cd8f95e1ec6\":\"0x52663ccab1e1c00000\",\"0x3c0c3defac9cea7acc319a96c30b8e1fedab4574\":\"0x692ae8897081d00000\",\"0x3c15b3511df6f0342e7348cc89af39a168b7730f\":\"0x3635c9adc5dea00000\",\"0x3c1f91f301f4b565bca24751aa1f761322709ddd\":\"0x61093d7c2c6d380000\",\"0x3c286cfb30146e5fd790c2c8541552578de334d8\":\"0x2291b11aa306e8c0000\",\"0x3c322e611fdb820d47c6f8fc64b6fad74ca95f5e\":\"0xd258ece1b13150000\",\"0x3c5a241459c6abbf630239c98a30d20b8b3ac561\":\"0x88b23acffd9900000\",\"0x3c79c863c3d372b3ff0c6f452734a7f97042d706\":\"0x98a7d9b8314c00000\",\"0x3c83c1701db0388b68210d00f5717cd9bd322c6a\":\"0x65a4da25d3016c00000\",\"0x3c860e2e663f46db53427b29fe3ea5e5bf62bbcc\":\"0x556f64c1fe7fa0000\",\"0x3c869c09696523ced824a070414605bb76231ff2\":\"0x3635c9adc5dea00000\",\"0x3c925619c9b33144463f0537d896358706c520b0\":\"0x6c6b935b8bbd400000\",\"0x3c98594bf68b57351e8814ae9e6dfd2d254aa06f\":\"0x1043561a8829300000\",\"0x3cadeb3d3eed3f62311d52553e70df4afce56f23\":\"0xd8d726b7177a800000\",\"0x3caedb5319fe806543c56e5021d372f71be9062e\":\"0x878678326eac9000000\",\"0x3cafaf5e62505615068af8eb22a13ad8a9e55070\":\"0x6c660645aa47180000\",\"0x3cb179cb4801a99b95c3b0c324a2bdc101a65360\":\"0x168d28e3f00280000\",\"0x3cb561ce86424b359891e364ec925ffeff277df7\":\"0xad78ebc5ac6200000\",\"0x3ccb71aa6880cb0b84012d90e60740ec06acd78f\":\"0x6c6b935b8bbd400000\",\"0x3ccef88679573947e94997798a1e327e08603a65\":\"0x2bc916d69f3b020000\",\"0x3cd1d9731bd548c1dd6fcea61beb75d91754f7d3\":\"0x1161d01b215cae48000\",\"0x3cd3a6e93579c56d494171fc533e7a90e6f59464\":\"0x6c6b935b8bbd400000\",\"0x3cd6b7593cbee77830a8b19d0801958fcd4bc57a\":\"0x1b1ae4d6e2ef500000\",\"0x3cd7f7c7c2353780cde081eeec45822b25f2860c\":\"0xad78ebc5ac6200000\",\"0x3ce1dc97fcd7b7c4d3a18a49d6f2a5c1b1a906d7\":\"0xad78ebc5ac6200000\",\"0x3cea302a472a940379dd398a24eafdbadf88ad79\":\"0xa2a15d09519be00000\",\"0x3ceca96bb1cdc214029cbc5e181d398ab94d3d41\":\"0x10f0cf064dd592000000\",\"0x3cf484524fbdfadae26dc185e32b2b630fd2e726\":\"0x185452cb2a91c30000\",\"0x3cf9a1d465e78b7039e3694478e2627b36fcd141\":\"0x4a60532ad51bf00000\",\"0x3cfbf066565970639e130df2a7d16b0e14d6091c\":\"0x5c283d410394100000\",\"0x3d09688d93ad07f3abe68c722723cd680990435e\":\"0x65a4ce99f769e6e0000\",\"0x3d31587b5fd5869845788725a663290a49d3678c\":\"0x1b1ae4d6e2ef500000\",\"0x3d3fad49c9e5d2759c8e8e5a7a4d60a0dd135692\":\"0x1158e460913d00000\",\"0x3d574fcf00fae1d98cc8bf9ddfa1b3953b9741bc\":\"0x6acb3df27e1f880000\",\"0x3d5a8b2b80be8b35d8ecf789b5ed7a0775c5076c\":\"0x1158e460913d00000\",\"0x3d66cd4bd64d5c8c1b5eea281e106d1c5aad2373\":\"0x69c4f3a8a110a60000\",\"0x3d6ae053fcbc318d6fd0fbc353b8bf542e680d27\":\"0xc673ce3c40160000\",\"0x3d6ff82c9377059fb30d9215723f60c775c891fe\":\"0xd8e5ce617f2d50000\",\"0x3d79a853d71be0621b44e29759656ca075fdf409\":\"0x6c6b935b8bbd400000\",\"0x3d7ea5bf03528100ed8af8aed2653e921b6e6725\":\"0x3635c9adc5dea00000\",\"0x3d813ff2b6ed57b937dabf2b381d148a411fa085\":\"0x56bc75e2d63100000\",\"0x3d881433f04a7d0d27f84944e08a512da3555287\":\"0x410d586a20a4c00000\",\"0x3d89e505cb46e211a53f32f167a877bec87f4b0a\":\"0x15b3557f1937f8000\",\"0x3d8d0723721e73a6c0d860aa0557abd14c1ee362\":\"0x10f0cf064dd59200000\",\"0x3d8f39881b9edfe91227c33fa4cdd91e678544b0\":\"0x4ab07ba43ada98000\",\"0x3d9d6be57ff83e065985664f12564483f2e600b2\":\"0x6eace43f23bd800000\",\"0x3da39ce3ef4a7a3966b32ee7ea4ebc2335a8f11f\":\"0x6c6b935b8bbd400000\",\"0x3daa01ceb70eaf9591fa521ba4a27ea9fb8ede4a\":\"0x5a63d2c9bc76540000\",\"0x3db5fe6a68bd3612ac15a99a61e555928eeceaf3\":\"0x55a6e79ccd1d300000\",\"0x3db9ed7f024c7e26372feacf2b050803445e3810\":\"0x45b148b4996a300000\",\"0x3dbf0dbfd77890800533f09dea8301b9f025d2a6\":\"0x3635c9adc5dea00000\",\"0x3dcef19c868b15d34eda426ec7e04b18b6017002\":\"0x6c68ccd09b022c0000\",\"0x3dd12e556a603736feba4a6fa8bd4ac45d662a04\":\"0x23757b9183e078280000\",\"0x3dde8b15b3ccbaa5780112c3d674f313bba68026\":\"0x601d515a3e4f940000\",\"0x3ddedbe48923fbf9e536bf9ffb0747c9cdd39eef\":\"0x368c8623a8b4d100000\",\"0x3deae43327913f62808faa1b6276a2bd6368ead9\":\"0x6c6b935b8bbd400000\",\"0x3df762049eda8ac6927d904c7af42f94e5519601\":\"0x6c6b935b8bbd400000\",\"0x3e040d40cb80ba0125f3b15fdefcc83f3005da1b\":\"0x384524cc70b7780000\",\"0x3e0b8ed86ed669e12723af7572fbacfe829b1e16\":\"0x514de7f9b812dc0000\",\"0x3e0cbe6a6dcb61f110c45ba2aa361d7fcad3da73\":\"0x1b2df9d219f57980000\",\"0x3e194b4ecef8bb711ea2ff24fec4e87bd032f7d1\":\"0x8b9dc1bc1a036a8000\",\"0x3e1b2230afbbd310b4926a4c776d5ae7819c661d\":\"0x65a4da25d3016c00000\",\"0x3e1c53300e4c168912163c7e99b95da268ad280a\":\"0x3662325cd18fe00000\",\"0x3e1c962063e0d5295941f210dca3ab531eec8809\":\"0xa2a15d09519be00000\",\"0x3e2ca0d234baf607ad466a1b85f4a6488ef00ae7\":\"0x4da21a3483d568000\",\"0x3e2f26235e137a7324e4dc154b5df5af46ea1a49\":\"0x137aad8032db90000\",\"0x3e3161f1ea2fbf126e79da1801da9512b37988c9\":\"0xa6dd90cae5114480000\",\"0x3e36c17253c11cf38974ed0db1b759160da63783\":\"0x17b7883c06916600000\",\"0x3e3cd3bec06591d6346f254b621eb41c89008d31\":\"0x35dfbeda9f37340000\",\"0x3e45bd55db9060eced923bb9cb733cb3573fb531\":\"0x58e7926ee858a00000\",\"0x3e4d13c55a84e46ed7e9cb90fd355e8ad991e38f\":\"0x3635c9adc5dea00000\",\"0x3e4e9265223c9738324cf20bd06006d0073edb8c\":\"0x73f75d1a085ba0000\",\"0x3e4fbd661015f6461ed6735cefef01f31445de3a\":\"0x36e342998b8b0200000\",\"0x3e53ff2107a8debe3328493a92a586a7e1f49758\":\"0x4e69c2a71a405ab0000\",\"0x3e5a39fdda70df1126ab0dc49a7378311a537a1f\":\"0x821ab0d44149800000\",\"0x3e5abd09ce5af7ba8487c359e0f2a93a986b0b18\":\"0x21e19e0c9bab2400000\",\"0x3e5cb8928c417825c03a3bfcc52183e5c91e42d7\":\"0xe731d9c52c962f0000\",\"0x3e5e93fb4c9c9d1246f8f247358e22c3c5d17b6a\":\"0x821ab0d4414980000\",\"0x3e618350fa01657ab0ef3ebac8e37012f8fc2b6f\":\"0x9806de3da6e9780000\",\"0x3e63ce3b24ca2865b4c5a687b7aea3597ef6e548\":\"0x6c6b935b8bbd400000\",\"0x3e66b84769566ab67945d5fa81373556bcc3a1fa\":\"0x83d6c7aab63600000\",\"0x3e76a62db187aa74f63817533b306cead0e8cebe\":\"0x69b5afac750bb800000\",\"0x3e7a966b5dc357ffb07e9fe067c45791fd8e3049\":\"0x3342d60dff1960000\",\"0x3e81772175237eb4cbe0fe2dcafdadffeb6a1999\":\"0x1dd0c885f9a0d800000\",\"0x3e8349b67f5745449f659367d9ad4712db5b895a\":\"0x62a992e53a0af00000\",\"0x3e83544f0082552572c782bee5d218f1ef064a9d\":\"0x56cd55fc64dfe0000\",\"0x3e84b35c5b2265507061d30b6f12da033fe6f8b9\":\"0x61093d7c2c6d380000\",\"0x3e8641d43c42003f0a33c929f711079deb2b9e46\":\"0x1b1ae4d6e2ef500000\",\"0x3e8745ba322f5fd6cb50124ec46688c7a69a7fae\":\"0x10afc1ade3b4ed40000\",\"0x3e914e3018ac00449341c49da71d04dfeeed6221\":\"0xd8d726b7177a800000\",\"0x3e9410d3b9a87ed5e451a6b91bb8923fe90fb2b5\":\"0xad78ebc5ac6200000\",\"0x3e94df5313fa520570ef232bc3311d5f622ff183\":\"0x6c6b935b8bbd400000\",\"0x3e9b34a57f3375ae59c0a75e19c4b641228d9700\":\"0xf8699329677e0000\",\"0x3eada8c92f56067e1bb73ce378da56dc2cdfd365\":\"0x77cde93aeb0d480000\",\"0x3eaf0879b5b6db159b589f84578b6a74f6c10357\":\"0x18938b671fa65a28000\",\"0x3eaf316b87615d88f7adc77c58e712ed4d77966b\":\"0x56dbc4cee24648000\",\"0x3eb8b33b21d23cda86d8288884ab470e164691b5\":\"0x1b1ae4d6e2ef500000\",\"0x3eb9ef06d0c259040319947e8c7a6812aa0253d8\":\"0x90d972f32323c0000\",\"0x3ecc8e1668dde995dc570fe414f44211c534a615\":\"0x6c6b935b8bbd400000\",\"0x3ecdb532e397579662b2a46141e78f8235936a5f\":\"0x39fbae8d042dd0000\",\"0x3eee6f1e96360b7689b3069adaf9af8eb60ce481\":\"0x3635c9adc5dea00000\",\"0x3f08d9ad894f813e8e2148c160d24b353a8e74b0\":\"0xcb49b44ba602d800000\",\"0x3f0c83aac5717962734e5ceaeaecd39b28ad06be\":\"0x6c6b935b8bbd400000\",\"0x3f10800282d1b7ddc78fa92d8230074e1bf6aeae\":\"0x10afc1ade3b4ed40000\",\"0x3f1233714f204de9de4ee96d073b368d8197989f\":\"0x217c41074e6bb0000\",\"0x3f173aa6edf469d185e59bd26ae4236b92b4d8e1\":\"0x1158e460913d000000\",\"0x3f1bc420c53c002c9e90037c44fe6a8ef4ddc962\":\"0x960db77681e940000\",\"0x3f236108eec72289bac3a65cd283f95e041d144c\":\"0x3634bf39ab98788000\",\"0x3f2da093bb16eb064f8bfa9e30b929d15f8e1c4c\":\"0x6c6b935b8bbd400000\",\"0x3f2dd55db7eab0ebee65b33ed8202c1e992e958b\":\"0x2c73c937742c500000\",\"0x3f2f381491797cc5c0d48296c14fd0cd00cdfa2d\":\"0x2b95bdcc39b6100000\",\"0x3f30d3bc9f602232bc724288ca46cd0b0788f715\":\"0xd8d726b7177a800000\",\"0x3f3c8e61e5604cef0605d436dd22accd862217fc\":\"0x487a9a304539440000\",\"0x3f3f46b75cabe37bfacc8760281f4341ca7f463d\":\"0x20ac448235fae88000\",\"0x3f472963197883bbda5a9b7dfcb22db11440ad31\":\"0x1a19643cb1eff08000\",\"0x3f4cd1399f8a34eddb9a17a471fc922b5870aafc\":\"0xad78ebc5ac6200000\",\"0x3f551ba93cd54693c183fb9ad60d65e1609673c9\":\"0x6c6b935b8bbd400000\",\"0x3f627a769e6a950eb87017a7cd9ca20871136831\":\"0x2eb8eb1a172dcb80000\",\"0x3f6dd3650ee428dcb7759553b017a96a94286ac9\":\"0x487a9a304539440000\",\"0x3f747237806fed3f828a6852eb0867f79027af89\":\"0x5150ae84a8cdf00000\",\"0x3f75ae61cc1d8042653b5baec4443e051c5e7abd\":\"0x52d542804f1ce0000\",\"0x3fb7d197b3ba4fe045efc23d50a14585f558d9b2\":\"0x1158e460913d00000\",\"0x3fbc1e4518d73400c6d046359439fb68ea1a49f4\":\"0x3790bb8551376400000\",\"0x3fbed6e7e0ca9c84fbe9ebcf9d4ef9bb49428165\":\"0x6c6b935b8bbd400000\",\"0x3fd0bb47798cf44cdfbe4d333de637df4a00e45c\":\"0x56c5579f722140000\",\"0x3fe40fbd919aad2818df01ee4df46c46842ac539\":\"0x14542ba12a337c00000\",\"0x3fe801e61335c5140dc7eda2ef5204460a501230\":\"0x6c6b935b8bbd400000\",\"0x3ff836b6f57b901b440c30e4dbd065cf37d3d48c\":\"0xad78ebc5ac6200000\",\"0x3ffcb870d4023d255d5167d8a507cefc366b68ba\":\"0x23343c4354d2ac0000\",\"0x401354a297952fa972ad383ca07a0a2811d74a71\":\"0xc249fdd327780000\",\"0x4030a925706b2c101c8c5cb9bd05fbb4f6759b18\":\"0xd8d726b7177a800000\",\"0x403145cb4ae7489fcc90cd985c6dc782b3cc4e44\":\"0x1453ff387b27cac0000\",\"0x403220600a36f73f24e190d1edb2d61be3f41354\":\"0x107ad8f556c6c00000\",\"0x4039bd50a2bde15ffe37191f410390962a2b8886\":\"0xad78ebc5ac6200000\",\"0x403c64896a75cad816a9105e18d8aa5bf80f238e\":\"0x35659ef93f0fc40000\",\"0x403d53cf620f0922b417848dee96c190b5bc8271\":\"0x215f835bc769da80000\",\"0x404100db4c5d0eec557823b58343758bcc2c8083\":\"0x1158e460913d00000\",\"0x4041374b0feef4792e4b33691fb86897a4ff560c\":\"0x13c9647e25a9940000\",\"0x40467d80e74c35407b7db51789234615fea66818\":\"0x150894e849b3900000\",\"0x40585200683a403901372912a89834aadcb55fdb\":\"0x6c6b935b8bbd400000\",\"0x4058808816fdaa3a5fc98ed47cfae6c18315422e\":\"0xad4c8316a0b0c0000\",\"0x405f596b94b947344c033ce2dcbff12e25b79784\":\"0x6c6b935b8bbd400000\",\"0x40630024bd2c58d248edd8465617b2bf1647da0e\":\"0x3635c9adc5dea00000\",\"0x40652360d6716dc55cf9aab21f3482f816cc2cbd\":\"0x21e19e0c9bab2400000\",\"0x407295ebd94b48269c2d569c9b9af9aa05e83e5e\":\"0x21e19e0c9bab2400000\",\"0x4073fa49b87117cb908cf1ab512da754a932d477\":\"0x6acb3df27e1f880000\",\"0x408a69a40715e1b313e1354e600800a1e6dc02a5\":\"0x1e7b891cc92540000\",\"0x409bd75085821c1de70cdc3b11ffc3d923c74010\":\"0xd8d726b7177a800000\",\"0x409d5a962edeeebea178018c0f38b9cdb213f289\":\"0x1158e460913d00000\",\"0x40a331195b977325c2aa28fa2f42cb25ec3c253c\":\"0x6c6b935b8bbd400000\",\"0x40a7f72867a7dc86770b162b7557a434ed50cce9\":\"0x3635c9adc5dea00000\",\"0x40ab0a3e83d0c8ac9366910520eab1772bac3b1a\":\"0x34f10c2dc05e7c0000\",\"0x40ab66fe213ea56c3afb12c75be33f8e32fd085d\":\"0xd8d726b7177a800000\",\"0x40ad74bc0bce2a45e52f36c3debb1b3ada1b7619\":\"0x170162de109c6580000\",\"0x40cf890591eae4a18f812a2954cb295f633327e6\":\"0x29bf736fc591a0000\",\"0x40cf90ef5b768c5da585002ccbe6617650d8e837\":\"0x36330322d5238c0000\",\"0x40d45d9d7625d15156c932b771ca7b0527130958\":\"0x152d02c7e14af6800000\",\"0x40db1ba585ce34531edec5494849391381e6ccd3\":\"0x61093d7c2c6d380000\",\"0x40df495ecf3f8b4cef2a6c189957248fe884bc2b\":\"0x28a857425466f800000\",\"0x40e0dbf3efef9084ea1cd7e503f40b3b4a8443f6\":\"0xd8d726b7177a800000\",\"0x40e2440ae142c880366a12c6d4102f4b8434b62a\":\"0x3635c9adc5dea00000\",\"0x40e3c283f7e24de0410c121bee60a5607f3e29a6\":\"0x3635c9adc5dea00000\",\"0x40ea5044b204b23076b1a5803bf1d30c0f88871a\":\"0x2f6f10780d22cc00000\",\"0x40eddb448d690ed72e05c225d34fc8350fa1e4c5\":\"0x17b7883c06916600000\",\"0x40f4f4c06c732cd35b119b893b127e7d9d0771e4\":\"0x21e19e0c9bab2400000\",\"0x41010fc8baf8437d17a04369809a168a17ca56fb\":\"0x56bc75e2d63100000\",\"0x4103299671d46763978fa4aa19ee34b1fc952784\":\"0xad78ebc5ac6200000\",\"0x41033c1b6d05e1ca89b0948fc64453fbe87ab25e\":\"0x487a9a304539440000\",\"0x41098a81452317c19e3eef0bd123bbe178e9e9ca\":\"0x97c9ce4cf6d5c00000\",\"0x411610b178d5617dfab934d293f512a93e5c10e1\":\"0x93739534d28680000\",\"0x411c831cc6f44f1965ec5757ab4e5b3ca4cffd1f\":\"0x170a0f5040e5040000\",\"0x412a68f6c645559cc977fc4964047a201d1bb0e2\":\"0xa968163f0a57b400000\",\"0x413f4b02669ccff6806bc826fcb7deca3b0ea9bc\":\"0x1158e460913d00000\",\"0x414599092e879ae25372a84d735af5c4e510cd6d\":\"0x15af1d78b58c400000\",\"0x41485612d03446ec4c05e5244e563f1cbae0f197\":\"0x34957444b840e80000\",\"0x415d096ab06293183f3c033d25f6cf7178ac3bc7\":\"0x22b1c8c1227a00000\",\"0x4166fc08ca85f766fde831460e9dc93c0e21aa6c\":\"0x3635c9adc5dea00000\",\"0x416784af609630b070d49a8bcd12235c6428a408\":\"0x43c33c1937564800000\",\"0x4167cd48e733418e8f99ffd134121c4a4ab278c4\":\"0xc55325ca7415e00000\",\"0x416c86b72083d1f8907d84efd2d2d783dffa3efb\":\"0x6c6acc67d7b1d40000\",\"0x4173419d5c9f6329551dc4d3d0ceac1b701b869e\":\"0x4c53ecdc18a600000\",\"0x4174fa1bc12a3b7183cbabb77a0b59557ba5f1db\":\"0x6c6b935b8bbd400000\",\"0x41786a10d447f484d33244ccb7facd8b427b5b8c\":\"0x3635c9adc5dea00000\",\"0x417a3cd19496530a6d4204c3b5a17ce0f207b1a5\":\"0x1b1ae4d6e2ef5000000\",\"0x417e4e2688b1fd66d821529e46ed4f42f8b3db3d\":\"0x6c6b935b8bbd400000\",\"0x419a71a36c11d105e0f2aef5a3e598078e85c80b\":\"0x10f0cf064dd59200000\",\"0x419bde7316cc1ed295c885ace342c79bf7ee33ea\":\"0x14542ba12a337c00000\",\"0x41a2f2e6ecb86394ec0e338c0fc97e9c5583ded2\":\"0x6cee06ddbe15ec0000\",\"0x41a8c2830081b102df6e0131657c07ab635b54ce\":\"0x6c6acc67d7b1d40000\",\"0x41a8e236a30e6d63c1ff644d132aa25c89537e01\":\"0x1158e460913d00000\",\"0x41a9a404fc9f5bfee48ec265b12523338e29a8bf\":\"0x150894e849b3900000\",\"0x41ad369f758fef38a19aa3149379832c818ef2a0\":\"0x36369ed7747d260000\",\"0x41b2d34fde0b1029262b4172c81c1590405b03ae\":\"0x3635c9adc5dea00000\",\"0x41b2dbd79dda9b864f6a7030275419c39d3efd3b\":\"0xad78ebc5ac62000000\",\"0x41c3c2367534d13ba2b33f185cdbe6ac43c2fa31\":\"0xd8d726b7177a800000\",\"0x41cb9896445f70a10a14215296daf614e32cf4d5\":\"0x678a932062e4180000\",\"0x41ce79950935cff55bf78e4ccec2fe631785db95\":\"0x6c6b935b8bbd400000\",\"0x41d3b731a326e76858baa5f4bd89b57b36932343\":\"0x155bd9307f9fe80000\",\"0x41e4a20275e39bdcefeb655c0322744b765140c2\":\"0x21e19e0c9bab2400000\",\"0x41ed2d8e7081482c919fc23d8f0091b3c82c4685\":\"0x463a1e765bd78a0000\",\"0x41f27e744bd29de2b0598f02a0bb9f98e681eaa4\":\"0x1a4aba225c207400000\",\"0x41f489a1ec747bc29c3e5f9d8db97877d4d1b4e9\":\"0x73f75d1a085ba0000\",\"0x420fb86e7d2b51401fc5e8c72015decb4ef8fc2e\":\"0x3635c9adc5dea00000\",\"0x421684baa9c0b4b5f55338e6f6e7c8e146d41cb7\":\"0x5150ae84a8cdf00000\",\"0x42399659aca6a5a863ea2245c933fe9a35b7880e\":\"0x6ece32c26c82700000\",\"0x423bca47abc00c7057e3ad34fca63e375fbd8b4a\":\"0x3cfc82e37e9a7400000\",\"0x423c3107f4bace414e499c64390a51f74615ca5e\":\"0x6c6b935b8bbd400000\",\"0x423cc4594cf4abb6368de59fd2b1230734612143\":\"0x6c6b935b8bbd400000\",\"0x4244f1331158b9ce26bbe0b9236b9203ca351434\":\"0x21e19e0c9bab2400000\",\"0x425177eb74ad0a9d9a5752228147ee6d6356a6e6\":\"0xb98bc829a6f90000\",\"0x425725c0f08f0811f5f006eec91c5c5c126b12ae\":\"0x821ab0d4414980000\",\"0x4258fd662fc4ce3295f0d4ed8f7bb1449600a0a9\":\"0x16c452ed6088ad80000\",\"0x425c1816868f7777cc2ba6c6d28c9e1e796c52b3\":\"0x21e19e0c9bab2400000\",\"0x425c338a1325e3a1578efa299e57d986eb474f81\":\"0x6c6b935b8bbd400000\",\"0x426259b0a756701a8b663528522156c0288f0f24\":\"0x218ae196b8d4f300000\",\"0x426d15f407a01135b13a6b72f8f2520b3531e302\":\"0x1158e460913d00000\",\"0x426f78f70db259ac8534145b2934f4ef1098b5d8\":\"0x138400eca364a00000\",\"0x42732d8ef49ffda04b19780fd3c18469fb374106\":\"0x170b00e5e4a9be0000\",\"0x427417bd16b1b3d22dbb902d8f9657016f24a61c\":\"0x6c6b935b8bbd400000\",\"0x42746aeea14f27beff0c0da64253f1e7971890a0\":\"0x54069233bf7f780000\",\"0x427b462ab84e5091f48a46eb0cdc92ddcb26e078\":\"0x6c6b935b8bbd400000\",\"0x427e4751c3babe78cff8830886febc10f9908d74\":\"0x6acb3df27e1f880000\",\"0x427ec668ac9404e895cc861511d1620a4912be98\":\"0x878678326eac9000000\",\"0x4280a58f8bb10b9440de94f42b4f592120820191\":\"0x6c6b935b8bbd400000\",\"0x428a1ee0ed331d7952ccbe1c7974b2852bd1938a\":\"0x77b74a4e8de5650000\",\"0x429c06b487e8546abdfc958a25a3f0fba53f6f00\":\"0xbb644af542198000\",\"0x42a98bf16027ce589c4ed2c95831e2724205064e\":\"0x21e19e0c9bab2400000\",\"0x42c6edc515d35557808d13cd44dcc4400b2504e4\":\"0xaba14c59ba7320000\",\"0x42cecfd2921079c2d7df3f08b07aa3beee5e219a\":\"0x3635c9adc5dea00000\",\"0x42d1a6399b3016a8597f8b640927b8afbce4b215\":\"0xa18bcec34888100000\",\"0x42d34940edd2e7005d46e2188e4cfece8311d74d\":\"0x890b0c2e14fb80000\",\"0x42d3a5a901f2f6bd9356f112a70180e5a1550b60\":\"0x3224f42723d4540000\",\"0x42d6b263d9e9f4116c411424fc9955783c763030\":\"0x6c6b935b8bbd400000\",\"0x42db0b902559e04087dd5c441bc7611934184b89\":\"0x6d33b17d253a620000\",\"0x42ddd014dc52bfbcc555325a40b516f4866a1dd3\":\"0x6c6b935b8bbd400000\",\"0x4319263f75402c0b5325f263be4a5080651087f0\":\"0x354b0f14631bab0000\",\"0x431f2c19e316b044a4b3e61a0c6ff8c104a1a12f\":\"0x3635c9adc5dea00000\",\"0x43227d65334e691cf231b4a4e1d339b95d598afb\":\"0x21e19e0c9bab2400000\",\"0x432809a2390f07c665921ff37d547d12f1c9966a\":\"0x65a4da25d3016c00000\",\"0x4329fc0931cbeb033880fe4c9398ca45b0e2d11a\":\"0x6c7120716d33680000\",\"0x432d884bd69db1acc0d89c64ade4cb4fc3a88b7a\":\"0x869a8c10808eec0000\",\"0x4331ab3747d35720a9d8ca25165cd285acd4bda8\":\"0x6c6b935b8bbd400000\",\"0x433a3b68e56b0df1862b90586bbd39c840ff1936\":\"0x6c6b935b8bbd400000\",\"0x433e3ba1c51b810fc467d5ba4dea42f7a9885e69\":\"0x878678326eac9000000\",\"0x433eb94a339086ed12d9bde9cd1d458603c97dd6\":\"0x152d02c7e14af6800000\",\"0x4349225a62f70aea480a029915a01e5379e64fa5\":\"0x8cd67e2334c0d80000\",\"0x4354221e62dc09e6406436163a185ef06d114a81\":\"0x6c6b935b8bbd400000\",\"0x435443b81dfdb9bd8c6787bc2518e2d47e57c15f\":\"0x1438d9397881ef20000\",\"0x4361d4846fafb377b6c0ee49a596a78ddf3516a3\":\"0xc2127af858da700000\",\"0x4364309a9fa07095600f79edc65120cdcd23dc64\":\"0x21e19e0c9bab2400000\",\"0x4367ae4b0ce964f4a54afd4b5c368496db169e9a\":\"0x6c6b935b8bbd400000\",\"0x43748928e8c3ec4436a1d092fbe43ac749be1251\":\"0x15af1d78b58c400000\",\"0x43767bf7fd2af95b72e9312da9443cb1688e4343\":\"0x1043561a8829300000\",\"0x437983388ab59a4ffc215f8e8269461029c3f1c1\":\"0x43c33c1937564800000\",\"0x43898c49a34d509bfed4f76041ee91caf3aa6aa5\":\"0x1043561a8829300000\",\"0x438c2f54ff8e629bab36b1442b760b12a88f02ae\":\"0x6c6b935b8bbd400000\",\"0x4398628ea6632d393e929cbd928464c568aa4a0c\":\"0x4be4e7267b6ae00000\",\"0x439d2f2f5110a4d58b1757935015408740fec7f8\":\"0xcfa5c5150f4c888000\",\"0x439dee3f7679ff1030733f9340c096686b49390b\":\"0x6c6b935b8bbd400000\",\"0x43b079baf0727999e66bf743d5bcbf776c3b0922\":\"0x6c6b935b8bbd400000\",\"0x43bc2d4ddcd6583be2c7bc094b28fb72e62ba83b\":\"0x6c6b935b8bbd400000\",\"0x43c7ebc5b3e7af16f47dc5617ab10e0f39b4afbb\":\"0x678a932062e4180000\",\"0x43cb9652818c6f4d6796b0e89409306c79db6349\":\"0x6c6b935b8bbd400000\",\"0x43cc08d0732aa58adef7619bed46558ad7774173\":\"0xf0e7dcb0122a8f0000\",\"0x43d5a71ce8b8f8ae02b2eaf8eaf2ca2840b93fb6\":\"0x14542ba12a337c00000\",\"0x43db7ff95a086d28ebbfb82fb8fb5f230a5ebccd\":\"0xdf6eb0b2d3ca0000\",\"0x43e7ec846358d7d0f937ad1c350ba069d7bf72bf\":\"0x670ae629214680000\",\"0x43f16f1e75c3c06a9478e8c597a40a3cb0bf04cc\":\"0x9df7dfa8f760480000\",\"0x43f470ed659e2991c375957e5ddec5bd1d382231\":\"0x56bc75e2d63100000\",\"0x43f7e86e381ec51ec4906d1476cba97a3db584e4\":\"0x3635c9adc5dea00000\",\"0x43ff38743ed0cd43308c066509cc8e7e72c862aa\":\"0x692ae8897081d00000\",\"0x43ff8853e98ed8406b95000ada848362d6a0392a\":\"0x4ae0b1c4d2e84d00000\",\"0x44098866a69b68c0b6bc168229b9603587058967\":\"0xa31062beeed700000\",\"0x4419ac618d5dea7cdc6077206fb07dbdd71c1702\":\"0xd8d726b7177a800000\",\"0x441a52001661fac718b2d7b351b7c6fb521a7afd\":\"0x15af1d78b58c400000\",\"0x441aca82631324acbfa2468bda325bbd78477bbf\":\"0x14542ba12a337c00000\",\"0x441f37e8a029fd02482f289c49b5d06d00e408a4\":\"0x1211ecb56d13488000\",\"0x4420aa35465be617ad2498f370de0a3cc4d230af\":\"0x6c6b935b8bbd400000\",\"0x44232ff66ddad1fd841266380036afd7cf7d7f42\":\"0xad78ebc5ac6200000\",\"0x44250d476e062484e9080a3967bf3a4a732ad73f\":\"0x1158e460913d00000\",\"0x4429a29fee198450672c0c1d073162250bec6474\":\"0x362aaf8202f2500000\",\"0x44355253b27748e3f34fe9cae1fb718c8f249529\":\"0xad78ebc5ac6200000\",\"0x4438e880cb2766b0c1ceaec9d2418fceb952a044\":\"0x73fa073903f080000\",\"0x444caf79b71338ee9aa7c733b02acaa7dc025948\":\"0x22b1c8c1227a00000\",\"0x445cb8de5e3df520b499efc980f52bff40f55c76\":\"0x6c6b935b8bbd400000\",\"0x446a8039cecf9dce4879cbcaf3493bf545a88610\":\"0x17b7883c06916600000\",\"0x4474299d0ee090dc90789a1486489c3d0d645e6d\":\"0x3635c9adc5dea00000\",\"0x448bf410ad9bbc2fecc4508d87a7fc2e4b8561ad\":\"0xad6eedd17cf3b8000\",\"0x44901e0d0e08ac3d5e95b8ec9d5e0ff5f12e0393\":\"0x16a1f9f5fd7d960000\",\"0x4493123c021ece3b33b1a452c9268de14007f9d3\":\"0x16a6502f15a1e540000\",\"0x449ac4fbe383e36738855e364a57f471b2bfa131\":\"0x29b76432b94451200000\",\"0x44a01fb04ac0db2cce5dbe281e1c46e28b39d878\":\"0x6c6acc67d7b1d40000\",\"0x44a63d18424587b9b307bfc3c364ae10cd04c713\":\"0x1158e460913d00000\",\"0x44a8989e32308121f72466978db395d1f76c3a4b\":\"0x18850299f42b06a0000\",\"0x44c1110b18870ec81178d93d215838c551d48e64\":\"0xad6f98593bd8f0000\",\"0x44c14765127cde11fab46c5d2cf4d4b2890023fd\":\"0x6c6b935b8bbd400000\",\"0x44c54eaa8ac940f9e80f1e74e82fc14f1676856a\":\"0x1ab2cf7c9f87e200000\",\"0x44cd77535a893fa7c4d5eb3a240e79d099a72d2d\":\"0x2c73c937742c500000\",\"0x44dfba50b829becc5f4f14d1b04aab3320a295e5\":\"0x3635c9adc5dea00000\",\"0x44e2fdc679e6bee01e93ef4a3ab1bcce012abc7c\":\"0x163d194900c5458000\",\"0x44f62f2aaabc29ad3a6b04e1ff6f9ce452d1c140\":\"0x39992648a23c8a00000\",\"0x44fff37be01a3888d3b8b8e18880a7ddefeeead3\":\"0xe0c5bfc7dae9a8000\",\"0x4506fe19fa4b006baa3984529d8516db2b2b50ab\":\"0x6c6b935b8bbd400000\",\"0x451b3699475bed5d7905f8905aa3456f1ed788fc\":\"0x8ac7230489e8000000\",\"0x451b7070259bdba27100e36e23428a53dfe304e9\":\"0xb98bc829a6f90000\",\"0x45272b8f62e9f9fa8ce04420e1aea3eba9686eac\":\"0xd8d726b7177a800000\",\"0x452b64db8ef7d6df87c788639c2290be8482d575\":\"0x1b1ae4d6e2ef5000000\",\"0x453e359a3397944c5a275ab1a2f70a5e5a3f6989\":\"0xd02ab486cedc00000\",\"0x4549b15979255f7e65e99b0d5604db98dfcac8bf\":\"0xd8d726b7177a800000\",\"0x454b61b344c0ef965179238155f277c3829d0b38\":\"0x6c6b935b8bbd400000\",\"0x454f0141d721d33cbdc41018bd01119aa4784818\":\"0x14542ba12a337c00000\",\"0x45533390e340fe0de3b3cf5fb9fc8ea552e29e62\":\"0x4f2591f896a6500000\",\"0x455396a4bbd9bae8af9fb7c4d64d471db9c24505\":\"0x8ba52e6fc45e40000\",\"0x455b9296921a74d1fc41617f43b8303e6f3ed76c\":\"0xe3aeb5737240a00000\",\"0x455cb8ee39ffbc752331e5aefc588ef0ee593454\":\"0x3635463a780def8000\",\"0x456ae0aca48ebcfae166060250525f63965e760f\":\"0x1043561a8829300000\",\"0x456f8d746682b224679349064d1b368c7c05b176\":\"0xc893d09c8f51500000\",\"0x457029c469c4548d168cec3e65872e4428d42b67\":\"0x6c6b935b8bbd400000\",\"0x4571de672b9904bad8743692c21c4fdcea4c2e01\":\"0xd8d726b7177a800000\",\"0x45781bbe7714a1c8f73b1c747921df4f84278b70\":\"0x6c6b935b8bbd400000\",\"0x457bcef37dd3d60b2dd019e3fe61d46b3f1e7252\":\"0x1158e460913d00000\",\"0x458e3cc99e947844a18e6a42918fef7e7f5f5eb3\":\"0x7b53f79e888dac00000\",\"0x459393d63a063ef3721e16bd9fde45ee9dbd77fb\":\"0x6abad6a3c153050000\",\"0x45a570dcc2090c86a6b3ea29a60863dde41f13b5\":\"0xc9a95ee2986520000\",\"0x45a820a0672f17dc74a08112bc643fd1167736c3\":\"0xad6c43b2815ed8000\",\"0x45b47105fe42c4712dce6e2a21c05bffd5ea47a9\":\"0x6c6b935b8bbd400000\",\"0x45bb829652d8bfb58b8527f0ecb621c29e212ec3\":\"0x6c6b935b8bbd400000\",\"0x45c0d19f0b8e054f9e893836d5ecae7901af2812\":\"0x10f0cf064dd59200000\",\"0x45c4ecb4ee891ea984a7c5cefd8dfb00310b2850\":\"0x6b56051582a9700000\",\"0x45ca8d956608f9e00a2f9974028640888465668f\":\"0x6c6b935b8bbd400000\",\"0x45ca9862003b4e40a3171fb5cafa9028cac8de19\":\"0x2eb8eb1a172dcb80000\",\"0x45d1c9eedf7cab41a779057b79395f5428d80528\":\"0x6c6b935b8bbd400000\",\"0x45d4b54d37a8cf599821235f062fa9d170ede8a4\":\"0x1190673b5fda900000\",\"0x45db03bccfd6a5f4d0266b82a22a368792c77d83\":\"0x1b1ae4d6e2ef5000000\",\"0x45e3a93e72144ada860cbc56ff85145ada38c6da\":\"0x57473d05dabae80000\",\"0x45e68db8dbbaba5fc2cb337c62bcd0d61b059189\":\"0x6c6b935b8bbd400000\",\"0x45e68db94c7d0ab7ac41857a71d67147870f4e71\":\"0x54b40b1f852bda000000\",\"0x45f4fc60f08eaca10598f0336329801e3c92cb46\":\"0xad78ebc5ac6200000\",\"0x460d5355b2ceeb6e62107d81e51270b26bf45620\":\"0x6cb7e74867d5e60000\",\"0x46224f32f4ece5c8867090d4409d55e50b18432d\":\"0x14542ba12a337c00000\",\"0x4627c606842671abde8295ee5dd94c7f549534f4\":\"0xf895fbd8732f40000\",\"0x462b678b51b584f3ed7ada070b5cd99c0bf7b87f\":\"0x56bc75e2d63100000\",\"0x464d9c89cce484df000277198ed8075fa63572d1\":\"0x1158e460913d00000\",\"0x46504e6a215ac83bccf956befc82ab5a679371c8\":\"0x1c212805c2b4a50000\",\"0x4651dc420e08c3293b27d2497890eb50223ae2f4\":\"0x43c33c1937564800000\",\"0x46531e8b1bde097fdf849d6d119885608a008df7\":\"0xad78ebc5ac6200000\",\"0x466292f0e80d43a78774277590a9eb45961214f4\":\"0x34957444b840e80000\",\"0x4662a1765ee921842ddc88898d1dc8627597bd7e\":\"0x21e19e0c9bab2400000\",\"0x4665e47396c7db97eb2a03d90863d5d4ba319a94\":\"0x2086ac351052600000\",\"0x466fda6b9b58c5532750306a10a2a8c768103b07\":\"0xad6eedd17cf3b8000\",\"0x467124ae7f452f26b3d574f6088894fa5d1cfb3b\":\"0x925e06eec972b00000\",\"0x46722a36a01e841d03f780935e917d85d5a67abd\":\"0xcec76f0e71520000\",\"0x46779a5656ff00d73eac3ad0c38b6c853094fb40\":\"0xc8253c96c6af00000\",\"0x4677b04e0343a32131fd6abb39b1b6156bba3d5b\":\"0xad78ebc5ac6200000\",\"0x467d5988249a68614716659840ed0ae6f6f457bc\":\"0x1501a48cefdfde0000\",\"0x467e0ed54f3b76ae0636176e07420815a021736e\":\"0x6c6b935b8bbd400000\",\"0x467ea10445827ef1e502daf76b928a209e0d4032\":\"0x6c6b935b8bbd400000\",\"0x467fbf41441600757fe15830c8cd5f4ffbbbd560\":\"0x21e19e0c9bab2400000\",\"0x469358709332c82b887e20bcddd0220f8edba7d0\":\"0x3a9d5baa4abf1d00000\",\"0x4697baaf9ccb603fd30430689d435445e9c98bf5\":\"0xad201a6794ff80000\",\"0x46a30b8a808931217445c3f5a93e882c0345b426\":\"0xd8db5ebd7b2638000\",\"0x46a430a2d4a894a0d8aa3feac615361415c3f81f\":\"0x6c6b935b8bbd400000\",\"0x46aa501870677e7f0a504876b4e8801a0ad01c46\":\"0x2b5e3af16b18800000\",\"0x46bfc5b207eb2013e2e60f775fecd71810c5990c\":\"0x54069233bf7f780000\",\"0x46c1aa2244b9c8a957ca8fac431b0595a3b86824\":\"0xd8d726b7177a800000\",\"0x46d80631284203f6288ecd4e5758bb9d41d05dbe\":\"0x6c6b935b8bbd400000\",\"0x470ac5d1f3efe28f3802af925b571e63868b397d\":\"0x6c6b935b8bbd400000\",\"0x471010da492f4018833b088d9872901e06129174\":\"0x1b1ae4d6e2ef500000\",\"0x4712540265cbeec3847022c59f1b318d43400a9e\":\"0xbdbc41e0348b300000\",\"0x4714cfa4f46bd6bd70737d75878197e08f88e631\":\"0x27f3edfb34e6e400000\",\"0x472048cc609aeb242165eaaa8705850cf3125de0\":\"0x3635c9adc5dea00000\",\"0x47219229e8cd56659a65c2a943e2dd9a8f4bfd89\":\"0x52663ccab1e1c00000\",\"0x4737d042dc6ae73ec73ae2517acea2fdd96487c5\":\"0x3635c9adc5dea00000\",\"0x474158a1a9dc693c133f65e47b5c3ae2f773a86f\":\"0xada55474b81340000\",\"0x4745ab181a36aa8cbf2289d0c45165bc7ebe2381\":\"0x222c8eb3ff6640000\",\"0x475066f9ad26655196d5535327bbeb9b7929cb04\":\"0xa4cc799563c3800000\",\"0x4752218e54de423f86c0501933917aea08c8fed5\":\"0x43c33c1937564800000\",\"0x475a6193572d4a4e59d7be09cb960ddd8c530e2f\":\"0x242cf78cdf07ff8000\",\"0x47648bed01f3cd3249084e635d14daa9e7ec3c8a\":\"0xa844a7424d9c80000\",\"0x47688410ff25d654d72eb2bc06e4ad24f833b094\":\"0x8b28d61f3d3ac0000\",\"0x476b5599089a3fb6f29c6c72e49b2e4740ea808d\":\"0x97c9ce4cf6d5c00000\",\"0x47730f5f8ebf89ac72ef80e46c12195038ecdc49\":\"0xab4dcf399a3a600000\",\"0x477b24eee8839e4fd19d1250bd0b6645794a61ca\":\"0x1b1ae4d6e2ef5000000\",\"0x4781a10a4df5eebc82f4cfe107ba1d8a7640bd66\":\"0x61093d7c2c6d380000\",\"0x47885ababedf4d928e1c3c71d7ca40d563ed595f\":\"0x62a992e53a0af00000\",\"0x478dc09a1311377c093f9cc8ae74111f65f82f39\":\"0xd8d726b7177a800000\",\"0x478e524ef2a381d70c82588a93ca7a5fa9d51cbf\":\"0x35fa97226f8899700000\",\"0x479298a9de147e63a1c7d6d2fce089c7e64083bd\":\"0x21e19dd3c3c0d798000\",\"0x479abf2da4d58716fd973a0d13a75f530150260a\":\"0x1158e460913d00000\",\"0x47a281dff64167197855bf6e705eb9f2cef632ea\":\"0x3636c9796436740000\",\"0x47beb20f759100542aa93d41118b3211d664920e\":\"0x6c6b935b8bbd400000\",\"0x47c247f53b9fbeb17bba0703a00c009fdb0f6eae\":\"0x43c33c1937564800000\",\"0x47c7e5efb48b3aed4b7c6e824b435f357df4c723\":\"0xfc936392801c0000\",\"0x47cf9cdaf92fc999cc5efbb7203c61e4f1cdd4c3\":\"0x71f8a93d01e540000\",\"0x47d20e6ae4cad3f829eac07e5ac97b66fdd56cf5\":\"0x3635c9adc5dea00000\",\"0x47d792a756779aedf1343e8883a6619c6c281184\":\"0x6c6b935b8bbd400000\",\"0x47e25df8822538a8596b28c637896b4d143c351d\":\"0x110be9eb24b881500000\",\"0x47f4696bd462b20da09fb83ed2039818d77625b3\":\"0x813ca56906d340000\",\"0x47fef58584465248a0810d60463ee93e5a6ee8d3\":\"0xf58cd3e1269160000\",\"0x47ff6feb43212060bb1503d7a397fc08f4e70352\":\"0x6c6b935b8bbd400000\",\"0x47fff42c678551d141eb75a6ee398117df3e4a8d\":\"0x56beae51fd2d10000\",\"0x48010ef3b8e95e3f308f30a8cb7f4eb4bf60d965\":\"0x6c6b935b8bbd400000\",\"0x480af52076009ca73781b70e43b95916a62203ab\":\"0x321972f4083d878000\",\"0x480f31b989311e4124c6a7465f5a44094d36f9d0\":\"0x3790bb855137640000\",\"0x481115296ab7db52492ff7b647d63329fb5cbc6b\":\"0x368c8623a8b4d100000\",\"0x481e3a91bfdc2f1c8428a0119d03a41601417e1c\":\"0x3635c9adc5dea00000\",\"0x4828e4cbe34e1510afb72c2beeac8a4513eaebd9\":\"0xd5967be4fc3f100000\",\"0x482982ac1f1c6d1721feecd9b9c96cd949805055\":\"0x21e19e0c9bab2400000\",\"0x48302c311ef8e5dc664158dd583c81194d6e0d58\":\"0xb6676ce0bccb5c0000\",\"0x483ba99034e900e3aedf61499d3b2bce39beb7aa\":\"0x35659ef93f0fc40000\",\"0x48548b4ba62bcb2f0d34a88dc69a680e539cf046\":\"0x56cf1cbbb74320000\",\"0x4863849739265a63b0a2bf236a5913e6f959ce15\":\"0x52663ccab1e1c00000\",\"0x48659d8f8c9a2fd44f68daa55d23a608fbe500dc\":\"0x6c6b935b8bbd400000\",\"0x48669eb5a801d8b75fb6aa58c3451b7058c243bf\":\"0x68d42c138dab9f00000\",\"0x486a6c8583a84484e3df43a123837f8c7e2317d0\":\"0x1187c571ab80450000\",\"0x487adf7d70a6740f8d51cbdd68bb3f91c4a5ce68\":\"0x39fbae8d042dd0000\",\"0x487e108502b0b189ef9c8c6da4d0db6261eec6c0\":\"0x678a932062e4180000\",\"0x4888fb25cd50dbb9e048f41ca47d78b78a27c7d9\":\"0x3a9d5baa4abf1d00000\",\"0x489334c2b695c8ee0794bd864217fb9fd8f8b135\":\"0xfc936392801c0000\",\"0x48a30de1c919d3fd3180e97d5f2b2a9dbd964d2d\":\"0x2629f66e0c5300000\",\"0x48bf14d7b1fc84ebf3c96be12f7bce01aa69b03e\":\"0x68155a43676e00000\",\"0x48c2ee91a50756d8ce9abeeb7589d22c6fee5dfb\":\"0xae8e7a0bb575d00000\",\"0x48c5c6970b9161bb1c7b7adfed9cdede8a1ba864\":\"0xd8d726b7177a800000\",\"0x48d2434b7a7dbbff08223b6387b05da2e5093126\":\"0x3cfc82e37e9a7400000\",\"0x48d4f2468f963fd79a006198bb67895d2d5aa4d3\":\"0x4be4e7267b6ae00000\",\"0x48e0cbd67f18acdb7a6291e1254db32e0972737f\":\"0x56be03ca3e47d8000\",\"0x48f60a35484fe7792bcc8a7b6393d0dda1f6b717\":\"0xc328093e61ee400000\",\"0x48f883e567b436a27bb5a3124dbc84dec775a800\":\"0x29d76e869dcd800000\",\"0x490145afa8b54522bb21f352f06da5a788fa8f1d\":\"0x1f46c62901a03fb0000\",\"0x4909b31998ead414b8fb0e846bd5cbde393935be\":\"0xd8d726b7177a800000\",\"0x4912d902931676ff39fc34fe3c3cc8fb2182fa7a\":\"0x1158e460913d00000\",\"0x49136fe6e28b7453fcb16b6bbbe9aaacba8337fd\":\"0x6c6b935b8bbd400000\",\"0x491561db8b6fafb9007e62d050c282e92c4b6bc8\":\"0x65a4da25d3016c00000\",\"0x49185dd7c23632f46c759473ebae966008cd3598\":\"0xdc55fdb17647b0000\",\"0x492cb5f861b187f9df21cd4485bed90b50ffe22d\":\"0x1b19e50b44977c0000\",\"0x492de46aaf8f1d708d59d79af1d03ad2cb60902f\":\"0x6c6b935b8bbd400000\",\"0x492e70f04d18408cb41e25603730506b35a2876b\":\"0x222c8eb3ff6640000\",\"0x493a67fe23decc63b10dda75f3287695a81bd5ab\":\"0x2fb474098f67c00000\",\"0x493d48bda015a9bfcf1603936eab68024ce551e0\":\"0x138a388a43c000000\",\"0x494256e99b0f9cd6e5ebca3899863252900165c8\":\"0x2f6f10780d22cc00000\",\"0x494dec4d5ee88a2771a815f1ee7264942fb58b28\":\"0x6c6b935b8bbd400000\",\"0x495b641b1cdea362c3b4cbbd0f5cc50b1e176b9c\":\"0x3635c9adc5dea00000\",\"0x4968a2cedb457555a139295aea28776e54003c87\":\"0x2231aefc9a6628f0000\",\"0x496d365534530a5fc1577c0a5241cb88c4da7072\":\"0x61093d7c2c6d380000\",\"0x496e319592b341eaccd778dda7c8196d54cac775\":\"0x1f5718987664b480000\",\"0x496f5843f6d24cd98d255e4c23d1e1f023227545\":\"0x5f179fd4a6ee098000\",\"0x4970d3acf72b5b1f32a7003cf102c64ee0547941\":\"0x1da56a4b0835bf800000\",\"0x4977a7939d0939689455ce2639d0ee5a4cd910ed\":\"0x62a992e53a0af00000\",\"0x4979194ec9e97db9bee8343b7c77d9d7f3f1dc9f\":\"0x1158e460913d00000\",\"0x49793463e1681083d6abd6e725d5bba745dccde8\":\"0x1d98e94c4e471f0000\",\"0x4981c5ff66cc4e9680251fc4cd2ff907cb327865\":\"0x28a857425466f80000\",\"0x49897fe932bbb3154c95d3bce6d93b6d732904dd\":\"0xd8d726b7177a800000\",\"0x4989e1ab5e7cd00746b3938ef0f0d064a2025ba5\":\"0x6c6b935b8bbd400000\",\"0x498abdeb14c26b7b7234d70fceaef361a76dff72\":\"0xa2a15d09519be00000\",\"0x49a645e0667dfd7b32d075cc2467dd8c680907c4\":\"0x70601958fcb9c0000\",\"0x49b74e169265f01a89ec4c9072c5a4cd72e4e835\":\"0x368c8623a8b4d100000\",\"0x49bdbc7ba5abebb6389e91a3285220d3451bd253\":\"0x3635c9adc5dea00000\",\"0x49c941e0e5018726b7290fc473b471d41dae80d1\":\"0x1b1ae4d6e2ef500000\",\"0x49c9771fca19d5b9d245c891f8158fe49f47a062\":\"0x21e19e0c9bab2400000\",\"0x49cf1e54be363106b920729d2d0ba46f0867989a\":\"0xe873f44133cb00000\",\"0x49d2c28ee9bc545eaaf7fd14c27c4073b4bb5f1a\":\"0x4fe9b806b40daf0000\",\"0x49ddee902e1d0c99d1b11af3cc8a96f78e4dcf1a\":\"0xacea5e4c18c530000\",\"0x49f028395b5a86c9e07f7778630e4c2e3d373a77\":\"0x6a74a5038db918000\",\"0x4a192035e2619b24b0709d56590e9183ccf2c1d9\":\"0x21e19e0c9bab2400000\",\"0x4a4053b31d0ee5dbafb1d06bd7ac7ff3222c47d6\":\"0x4be4e7267b6ae00000\",\"0x4a430170152de5172633dd8262d107a0afd96a0f\":\"0xab4dcf399a3a600000\",\"0x4a47fc3e177f567a1e3893e000e36bba23520ab8\":\"0x6c6b935b8bbd400000\",\"0x4a52bad20357228faa1e996bed790c93674ba7d0\":\"0x487a9a304539440000\",\"0x4a53dcdb56ce4cdce9f82ec0eb13d67352e7c88b\":\"0xe3aeb5737240a00000\",\"0x4a5fae3b0372c230c125d6d470140337ab915656\":\"0x56bc75e2d631000000\",\"0x4a719061f5285495b37b9d7ef8a51b07d6e6acac\":\"0xad4c8316a0b0c0000\",\"0x4a73389298031b8816cca946421c199e18b343d6\":\"0x223868b879146f0000\",\"0x4a735d224792376d331367c093d31c8794341582\":\"0x66ffcbfd5e5a300000\",\"0x4a7494cce44855cc80582842be958a0d1c0072ee\":\"0x821ab0d44149800000\",\"0x4a75c3d4fa6fccbd5dd5a703c15379a1e783e9b7\":\"0x62a992e53a0af00000\",\"0x4a81abe4984c7c6bef63d69820e55743c61f201c\":\"0x36401004e9aa3470000\",\"0x4a82694fa29d9e213202a1a209285df6e745c209\":\"0xd8d726b7177a800000\",\"0x4a835c25824c47ecbfc79439bf3f5c3481aa75cd\":\"0x4be4e7267b6ae00000\",\"0x4a918032439159bb315b6725b6830dc83697739f\":\"0x12a32ef678334c0000\",\"0x4a97e8fcf4635ea7fc5e96ee51752ec388716b60\":\"0x1d9945ab2b03480000\",\"0x4a9a26fd0a8ba10f977da4f77c31908dab4a8016\":\"0x61093d7c2c6d380000\",\"0x4aa148c2c33401e66a2b586e6577c4b292d3f240\":\"0xbb860b285f7740000\",\"0x4aa693b122f314482a47b11cc77c68a497876162\":\"0x6acb3df27e1f880000\",\"0x4ab2d34f04834fbf7479649cab923d2c4725c553\":\"0xbed1d0263d9f000000\",\"0x4ac07673e42f64c1a25ec2fa2d86e5aa2b34e039\":\"0x6c6b935b8bbd400000\",\"0x4ac5acad000b8877214cb1ae00eac9a37d59a0fd\":\"0xd8d726b7177a800000\",\"0x4ac9905a4cb6ab1cfd62546ee5917300b87c4fde\":\"0x3708baed3d68900000\",\"0x4acfa9d94eda6625c9dfa5f9f4f5d107c4031fdf\":\"0x222c8eb3ff6640000\",\"0x4ad047fae67ef162fe68fedbc27d3b65caf10c36\":\"0x6acb3df27e1f880000\",\"0x4ad95d188d6464709add2555fb4d97fe1ebf311f\":\"0x12c1b6eed03d280000\",\"0x4adbf4aae0e3ef44f7dd4d8985cfaf096ec48e98\":\"0x821ab0d4414980000\",\"0x4ae2a04d3909ef454e544ccfd614bfefa71089ae\":\"0x1801159df1eef80000\",\"0x4ae93082e45187c26160e66792f57fad3551c73a\":\"0x4961520daff82280000\",\"0x4af0db077bb9ba5e443e21e148e59f379105c592\":\"0x2086ac351052600000\",\"0x4b0619d9d8aa313a9531ac7dbe04ca0d6a5ad1b6\":\"0x6c6b935b8bbd400000\",\"0x4b0bd8acfcbc53a6010b40d4d08ddd2d9d69622d\":\"0x243d4d18229ca20000\",\"0x4b19eb0c354bc1393960eb06063b83926f0d67b2\":\"0x19274b259f6540000\",\"0x4b29437c97b4a844be71cca3b648d4ca0fdd9ba4\":\"0x824719834cfac0000\",\"0x4b31bf41abc75c9ae2cd8f7f35163b6e2b745054\":\"0x14b550a013c7380000\",\"0x4b3a7cc3a7d7b00ed5282221a60259f25bf6538a\":\"0x3635c9adc5dea00000\",\"0x4b3aab335ebbfaa870cc4d605e7d2e74c668369f\":\"0xcb49b44ba602d800000\",\"0x4b3c7388cc76da3d62d40067dabccd7ef0433d23\":\"0x56cd55fc64dfe0000\",\"0x4b3dfbdb454be5279a3b8addfd0ed1cd37a9420d\":\"0x6c6b935b8bbd400000\",\"0x4b470f7ba030bc7cfcf338d4bf0432a91e2ea5ff\":\"0x6c6b935b8bbd400000\",\"0x4b53ae59c784b6b5c43616b9a0809558e684e10c\":\"0x410d586a20a4c00000\",\"0x4b58101f44f7e389e12d471d1635b71614fdd605\":\"0x8ac7230489e800000\",\"0x4b5cdb1e428c91dd7cb54a6aed4571da054bfe52\":\"0x4c53ecdc18a600000\",\"0x4b60a3e253bf38c8d5662010bb93a473c965c3e5\":\"0x50c5e761a444080000\",\"0x4b74f5e58e2edf76daf70151964a0b8f1de0663c\":\"0x1190ae4944ba120000\",\"0x4b762166dd1118e84369f804c75f9cd657bf730c\":\"0x1b1ae4d6e2ef500000\",\"0x4b792e29683eb586e394bb33526c6001b397999e\":\"0x2086ac351052600000\",\"0x4b904e934bd0cc8b20705f879e905b93ea0ccc30\":\"0x6c6b935b8bbd400000\",\"0x4b9206ba6b549a1a7f969e1d5dba867539d1fa67\":\"0x1ab2cf7c9f87e200000\",\"0x4b984ef26c576e815a2eaed2f5177f07dbb1c476\":\"0x54915956c409600000\",\"0x4b9e068fc4680976e61504912985fd5ce94bab0d\":\"0x243d4d18229ca20000\",\"0x4ba0d9e89601772b496847a2bb4340186787d265\":\"0x3635c9adc5dea00000\",\"0x4ba53ab549e2016dfa223c9ed5a38fad91288d07\":\"0x4be4e7267b6ae00000\",\"0x4ba8e0117fc0b6a3e56b24a3a58fe6cef442ff98\":\"0x131beb925ffd3200000\",\"0x4bac846af4169f1d95431b341d8800b22180af1a\":\"0x1158e460913d00000\",\"0x4bb6d86b8314c22d8d37ea516d0019f156aae12d\":\"0x3635c9adc5dea00000\",\"0x4bb9655cfb2a36ea7c637a7b859b4a3154e26ebe\":\"0x3635c9adc5dea000000\",\"0x4bbcbf38b3c90163a84b1cd2a93b58b2a3348d87\":\"0x1b1ae4d6e2ef5000000\",\"0x4bd6dd0cff23400e1730ba7b894504577d14e74a\":\"0x2ba0ccddd0df73b00000\",\"0x4be8628a8154874e048d80c142181022b180bcc1\":\"0x340aad21b3b700000\",\"0x4be90d412129d5a4d0424361d6649d4e47a62316\":\"0x3708baed3d68900000\",\"0x4bea288eea42c4955eb9faad2a9faf4783cbddac\":\"0x618be1663c4af490000\",\"0x4bf4479799ef82eea20943374f56a1bf54001e5e\":\"0xd5967be4fc3f100000\",\"0x4bf8bf1d35a231315764fc8001809a949294fc49\":\"0x39fbae8d042dd0000\",\"0x4bf8e26f4c2790da6533a2ac9abac3c69a199433\":\"0xad78ebc5ac6200000\",\"0x4c0aca508b3caf5ee028bc707dd1e800b838f453\":\"0xfc936392801c0000\",\"0x4c0b1515dfced7a13e13ee12c0f523ae504f032b\":\"0xa968163f0a57b400000\",\"0x4c13980c32dcf3920b78a4a7903312907c1b123f\":\"0x3410015faae0c0000\",\"0x4c1579af3312e4f88ae93c68e9449c2e9a68d9c4\":\"0x6c6b935b8bbd400000\",\"0x4c23b370fc992bb67cec06e26715b62f0b3a4ac3\":\"0x21e19e0c9bab2400000\",\"0x4c24b78baf2bafc7fcc69016426be973e20a50b2\":\"0xa2a15d09519be00000\",\"0x4c2f1afef7c5868c44832fc77cb03b55f89e6d6e\":\"0x43c33c1937564800000\",\"0x4c377bb03ab52c4cb79befa1dd114982924c4ae9\":\"0x631603ccd38dd70000\",\"0x4c3e95cc3957d252ce0bf0c87d5b4f2234672e70\":\"0x878678326eac900000\",\"0x4c423c76930d07f93c47a5cc4f615745c45a9d72\":\"0x56bc75e2d63100000\",\"0x4c45d4c9a725d11112bfcbca00bf31186ccaadb7\":\"0x15af1d78b58c400000\",\"0x4c4e6f13fb5e3f70c3760262a03e317982691d10\":\"0x56bc75e2d63100000\",\"0x4c5afe40f18ffc48d3a1aec41fc29de179f4d297\":\"0x6c6b935b8bbd400000\",\"0x4c5b3dc0e2b9360f91289b1fe13ce12c0fbda3e1\":\"0x6c6b935b8bbd400000\",\"0x4c666b86f1c5ee8ca41285f5bde4f79052081406\":\"0x1b1ae4d6e2ef500000\",\"0x4c696be99f3a690440c3436a59a7d7e937d6ba0d\":\"0xbb9125542263900000\",\"0x4c6a248fc97d705def495ca20759169ef0d36471\":\"0x29331e6558f0e00000\",\"0x4c6a9dc2cab10abb2e7c137006f08fecb5b779e1\":\"0x1b0d04202f47ec0000\",\"0x4c6b93a3bec16349540cbfcae96c9621d6645010\":\"0x6c6b935b8bbd400000\",\"0x4c759813ad1386bed27ffae9e4815e3630cca312\":\"0x6c6b935b8bbd400000\",\"0x4c760cd9e195ee4f2d6bce2500ff96da7c43ee91\":\"0xcb49b44ba602d800000\",\"0x4c767b65fd91161f4fbdcc6a69e2f6ad711bb918\":\"0x270801d946c9400000\",\"0x4c7e2e2b77ad0cd6f44acb2861f0fb8b28750ef9\":\"0x1158e460913d00000\",\"0x4c85ed362f24f6b9f04cdfccd022ae535147cbb9\":\"0x5150ae84a8cdf00000\",\"0x4c935bb250778b3c4c7f7e07fc251fa630314aab\":\"0x5150ae84a8cdf00000\",\"0x4c997992036c5b433ac33d25a8ea1dc3d4e4e6d8\":\"0x1953b3d4ab1680000\",\"0x4c99dae96481e807c1f99f8b7fbde29b7547c5bf\":\"0x821ab0d4414980000\",\"0x4c9a862ad115d6c8274ed0b944bdd6a5500510a7\":\"0x56bc75e2d63100000\",\"0x4ca783b556e5bf53aa13c8116613d65782c9b642\":\"0x5561840b4ad83c00000\",\"0x4ca7b717d9bc8793b04e051a8d23e1640f5ba5e3\":\"0x43b514549ecf620000\",\"0x4ca8db4a5efefc80f4cd9bbcccb03265931332b6\":\"0xad78ebc5ac6200000\",\"0x4cac91fb83a147d2f76c3267984b910a79933348\":\"0x75792a8abdef7c0000\",\"0x4cadf573ce4ceec78b8e1b21b0ed78eb113b2c0e\":\"0x6c6b935b8bbd400000\",\"0x4cb5c6cd713ca447b848ae2f56b761ca14d7ad57\":\"0xe7eeba3410b740000\",\"0x4cc22c9bc9ad05d875a397dbe847ed221c920c67\":\"0x6c6b935b8bbd400000\",\"0x4cd0b0a6436362595ceade052ebc9b929fb6c6c0\":\"0x6c6b935b8bbd400000\",\"0x4cda41dd533991290794e22ae324143e309b3d3d\":\"0x821ab0d44149800000\",\"0x4cee901b4ac8b156c5e2f8a6f1bef572a7dceb7e\":\"0x3635c9adc5dea00000\",\"0x4cefbe2398e47d52e78db4334c8b697675f193ae\":\"0xd96fce90cfabcc0000\",\"0x4cf5537b85842f89cfee359eae500fc449d2118f\":\"0x3635c9adc5dea00000\",\"0x4d08471d68007aff2ae279bc5e3fe4156fbbe3de\":\"0x878678326eac9000000\",\"0x4d200110124008d56f76981256420c946a6ff45c\":\"0xad6eedd17cf3b8000\",\"0x4d24b7ac47d2f27de90974ba3de5ead203544bcd\":\"0x56bc75e2d63100000\",\"0x4d29fc523a2c1629532121da9998e9b5ab9d1b45\":\"0xdb44e049bb2c0000\",\"0x4d38d90f83f4515c03cc78326a154d358bd882b7\":\"0xa076407d3f7440000\",\"0x4d4cf5807429615e30cdface1e5aae4dad3055e6\":\"0x2086ac351052600000\",\"0x4d57e716876c0c95ef5eaebd35c8f41b069b6bfe\":\"0x6c6b935b8bbd400000\",\"0x4d67f2ab8599fef5fc413999aa01fd7fce70b43d\":\"0x21e19e0c9bab2400000\",\"0x4d6e8fe109ccd2158e4db114132fe75fecc8be5b\":\"0x15b3557f1937f8000\",\"0x4d71a6eb3d7f327e1834278e280b039eddd31c2f\":\"0x14542ba12a337c00000\",\"0x4d7cfaa84cb33106800a8c802fb8aa463896c599\":\"0x61093d7c2c6d380000\",\"0x4d801093c19ca9b8f342e33cc9c77bbd4c8312cf\":\"0x12b3e7fb95cda48000\",\"0x4d828894752f6f25175daf2177094487954b6f9f\":\"0x4f212bc2c49c838000\",\"0x4d82d7700c123bb919419bbaf046799c6b0e2c66\":\"0x43c33c1937564800000\",\"0x4d836d9d3b0e2cbd4de050596faa490cffb60d5d\":\"0x1043561a8829300000\",\"0x4d8697af0fbf2ca36e8768f4af22133570685a60\":\"0x1158e460913d00000\",\"0x4d9279962029a8bd45639737e98b511eff074c21\":\"0x487a9a304539440000\",\"0x4d93696fa24859f5d2939aebfa54b4b51ae1dccc\":\"0x10910d4cdc9f60000\",\"0x4d9c77d0750c5e6fbc247f2fd79274686cb353d6\":\"0x1158e460913d00000\",\"0x4da5edc688b0cb62e1403d1700d9dcb99ffe3fd3\":\"0x6c6b935b8bbd400000\",\"0x4da8030769844bc34186b85cd4c7348849ff49e9\":\"0x21e19e0c9bab2400000\",\"0x4db1c43a0f834d7d0478b8960767ec1ac44c9aeb\":\"0x2f5181305627370000\",\"0x4db21284bcd4f787a7556500d6d7d8f36623cf35\":\"0x6928374f77a3630000\",\"0x4dc3da13b2b4afd44f5d0d3189f444d4ddf91b1b\":\"0x6c6b935b8bbd400000\",\"0x4dc4bf5e7589c47b28378d7503cf96488061dbbd\":\"0x5f68e8131ecf800000\",\"0x4dc9d5bb4b19cecd94f19ec25d200ea72f25d7ed\":\"0x6c6b935b8bbd400000\",\"0x4dcd11815818ae29b85d01367349a8a7fb12d06b\":\"0x1ac4286100191f00000\",\"0x4dcf62a3de3f061db91498fd61060f1f6398ff73\":\"0x6c6acc67d7b1d40000\",\"0x4dd131c74a068a37c90aded4f309c2409f6478d3\":\"0x15af39e4aab2740000\",\"0x4ddda7586b2237b053a7f3289cf460dc57d37a09\":\"0x21e19e0c9bab2400000\",\"0x4de3fe34a6fbf634c051997f47cc7f48791f5824\":\"0x6c5db2a4d815dc0000\",\"0x4df140ba796585dd5489315bca4bba680adbb818\":\"0x90f534608a72880000\",\"0x4e020779b5ddd3df228a00cb48c2fc979da6ae38\":\"0x6c6b935b8bbd400000\",\"0x4e0bd32473c4c51bf25654def69f797c6b29a232\":\"0x56c95de8e8ca1d0000\",\"0x4e2225a1bb59bc88a2316674d333b9b0afca6655\":\"0x8670e9ec6598c0000\",\"0x4e2310191ead8d3bc6489873a5f0c2ec6b87e1be\":\"0x3635c9adc5dea00000\",\"0x4e232d53b3e6be8f895361d31c34d4762b12c82e\":\"0x5f68e8131ecf800000\",\"0x4e2bfa4a466f82671b800eee426ad00c071ba170\":\"0xd8d726b7177a800000\",\"0x4e3edad4864dab64cae4c5417a76774053dc6432\":\"0x2008fb478cbfa98000\",\"0x4e4318f5e13e824a54edfe30a7ed4f26cd3da504\":\"0x6c6b935b8bbd400000\",\"0x4e5b77f9066159e615933f2dda7477fa4e47d648\":\"0xad78ebc5ac6200000\",\"0x4e6600806289454acda330a2a3556010dfacade6\":\"0x14542ba12a337c00000\",\"0x4e73cf2379f124860f73d6d91bf59acc5cfc845b\":\"0x22ca3587cf4eb0000\",\"0x4e7aa67e12183ef9d7468ea28ad239c2eef71b76\":\"0x10afc1ade3b4ed40000\",\"0x4e7b54474d01fefd388dfcd53b9f662624418a05\":\"0x1b1ae4d6e2ef5000000\",\"0x4e892e8081bf36e488fddb3b2630f3f1e8da30d2\":\"0x28aba30752451fc0000\",\"0x4e8a6d63489ccc10a57f885f96eb04ecbb546024\":\"0x3eae3130ecc96900000\",\"0x4e8e47ae3b1ef50c9d54a38e14208c1abd3603c2\":\"0x7928db1276660c0000\",\"0x4e90ccb13258acaa9f4febc0a34292f95991e230\":\"0xdb44e049bb2c0000\",\"0x4ea56e1112641c038d0565a9c296c463afefc17e\":\"0x9ddc1e3b901180000\",\"0x4ea70f04313fae65c3ff224a055c3d2dab28dddf\":\"0x43c30fb0884a96c0000\",\"0x4eb1454b573805c8aca37edec7149a41f61202f4\":\"0x1043561a8829300000\",\"0x4eb87ba8788eba0df87e5b9bd50a8e45368091c1\":\"0x1158e460913d00000\",\"0x4ebc5629f9a6a66b2cf3363ac4895c0348e8bf87\":\"0x3637096c4bcc690000\",\"0x4ec768295eeabafc42958415e22be216cde77618\":\"0x33b1dbc39c5480000\",\"0x4ecc19948dd9cd87b4c7201ab48e758f28e7cc76\":\"0x1b1dab61d3aa640000\",\"0x4ed14d81b60b23fb25054d8925dfa573dcae6168\":\"0x126e72a69a50d00000\",\"0x4ee13c0d41200b46d19dee5c4bcec71d82bb8e38\":\"0x1abee13ccbeefaf8000\",\"0x4eead40aad8c73ef08fc84bc0a92c9092f6a36bf\":\"0x1731790534df20000\",\"0x4eebe80cb6f3ae5904f6f4b28d907f907189fcab\":\"0x6c6acc67d7b1d40000\",\"0x4eebf1205d0cc20cee6c7f8ff3115f56d48fba26\":\"0x10d3aa536e2940000\",\"0x4ef1c214633ad9c0703b4e2374a2e33e3e429291\":\"0x487a9a304539440000\",\"0x4efcd9c79fb4334ca6247b0a33bd9cc33208e272\":\"0x487a9a304539440000\",\"0x4f06246b8d4bd29661f43e93762201d286935ab1\":\"0x105394ffc4636110000\",\"0x4f152b2fb8659d43776ebb1e81673aa84169be96\":\"0x6c6b935b8bbd400000\",\"0x4f177f9d56953ded71a5611f393322c30279895c\":\"0xd55ef90a2da180000\",\"0x4f1a2da54a4c6da19d142412e56e815741db2325\":\"0x56bc75e2d63100000\",\"0x4f23b6b817ffa5c664acdad79bb7b726d30af0f9\":\"0x5f68e8131ecf800000\",\"0x4f26690c992b7a312ab12e1385d94acd58288e7b\":\"0x2f6f10780d22cc00000\",\"0x4f2b47e2775a1fa7178dad92985a5bbe493ba6d6\":\"0xad78ebc5ac6200000\",\"0x4f3a4854911145ea01c644044bdb2e5a960a982f\":\"0xd8d726b7177a800000\",\"0x4f3f2c673069ac97c2023607152981f5cd6063a0\":\"0x2086ac351052600000\",\"0x4f4a9be10cd5d3fb5de48c17be296f895690645b\":\"0x878678326eac9000000\",\"0x4f52ad6170d25b2a2e850eadbb52413ff2303e7f\":\"0xa4cc799563c3800000\",\"0x4f5801b1eb30b712d8a0575a9a71ff965d4f34eb\":\"0x1043561a8829300000\",\"0x4f5df5b94357de948604c51b7893cddf6076baad\":\"0xcbd47b6eaa8cc00000\",\"0x4f64a85e8e9a40498c0c75fceb0337fb49083e5e\":\"0x3635c9adc5dea00000\",\"0x4f67396d2553f998785f704e07a639197dd1948d\":\"0x104472521ba7380000\",\"0x4f6d4737d7a940382487264886697cf7637f8015\":\"0x5a87e7d7f5f6580000\",\"0x4f7330096f79ed264ee0127f5d30d2f73c52b3d8\":\"0x1b1a7a420ba00d0000\",\"0x4f767bc8794aef9a0a38fea5c81f14694ff21a13\":\"0x1bc433f23f83140000\",\"0x4f85bc1fc5cbc9c001e8f1372e07505370d8c71f\":\"0x32f51edbaaa3300000\",\"0x4f88dfd01091a45a9e2676021e64286cd36b8d34\":\"0x3635c9adc5dea00000\",\"0x4f8972838f70c903c9b6c6c46162e99d6216d451\":\"0xf9e89a0f2c56c80000\",\"0x4f8ae80238e60008557075ab6afe0a7f2e74d729\":\"0x56bc75e2d63100000\",\"0x4f8e8d274fb22a3fd36a47fe72980471544b3434\":\"0xad78ebc5ac6200000\",\"0x4f9ce2af9b8c5e42c6808a3870ec576f313545d1\":\"0x21e19e0c9bab2400000\",\"0x4fa3f32ef4086448b344d5f0a9890d1ce4d617c3\":\"0x5150ae84a8cdf00000\",\"0x4fa554ab955c249217386a4d3263bbf72895434e\":\"0x1154e53217ddb0000\",\"0x4fa983bb5e3073a8edb557effeb4f9fb1d60ef86\":\"0x56b9af57e575ec0000\",\"0x4faf90b76ecfb9631bf9022176032d8b2c207009\":\"0x36363b5d9a77700000\",\"0x4fc46c396e674869ad9481638f0013630c87caac\":\"0x3635c9adc5dea00000\",\"0x4fcc19ea9f4c57dcbce893193cfb166aa914edc5\":\"0x17b8baa7f19546a0000\",\"0x4fce8429ba49caa0369d1e494db57e89eab2ad39\":\"0x2a5a058fc295ed000000\",\"0x4fdac1aa517007e0089430b3316a1badd12c01c7\":\"0x1b1ae4d6e2ef500000\",\"0x4fe56ab3bae1b0a44433458333c4b05a248f8241\":\"0x762d93d1dd6f900000\",\"0x4feb846be43041fd6b34202897943e3f21cb7f04\":\"0x482fe260cbca90000\",\"0x4fee50c5f988206b09a573469fb1d0b42ebb6dce\":\"0x6cee06ddbe15ec0000\",\"0x4ff676e27f681a982d8fd9d20e648b3dce05e945\":\"0x97c9ce4cf6d5c00000\",\"0x4ff67fb87f6efba9279930cfbd1b7a343c79fade\":\"0x15af1d78b58c400000\",\"0x5006fe4c22173980f00c74342b39cd231c653129\":\"0x6c6b935b8bbd400000\",\"0x500c16352e901d48ba8d04e2c767121772790b02\":\"0x1a3a6824973098000\",\"0x500c902958f6421594d1b6ded712490d52ed6c44\":\"0x6acb3df27e1f880000\",\"0x500e34cde5bd9e2b71bb92d7cf55eee188d5fa0c\":\"0x121ea68c114e5100000\",\"0x5032e4bcf7932b49fdba377b6f1499636513cfc3\":\"0x56bc75e2d63100000\",\"0x50378af7ef54043f892ab7ce97d647793511b108\":\"0x11164759ffb320000\",\"0x503bdbd8bc421c32a443032deb2e3e4cd5ba8b4e\":\"0x6c6b935b8bbd400000\",\"0x504666ce8931175e11a5ed11c1dcaa06e57f4e66\":\"0x27f3edfb34e6e400000\",\"0x50584d9206a46ce15c301117ee28f15c30e60e75\":\"0xb9f65d00f63c0000\",\"0x505a33a18634dd4800693c67f48a1d693d4833f8\":\"0x18921b79941dcd00000\",\"0x505e4f7c275588c533a20ebd2ac13b409bbdea3c\":\"0xf43fc2c04ee00000\",\"0x5062e5134c612f12694dbd0e131d4ce197d1b6a4\":\"0x3635c9adc5dea00000\",\"0x506411fd79003480f6f2b6aac26b7ba792f094b2\":\"0x1b1ae4d6e2ef500000\",\"0x5067f4549afbfe884c59cbc12b96934923d45db0\":\"0x3635c9adc5dea00000\",\"0x50763add868fd7361178342fc055eaa2b95f6846\":\"0x39f9046e0898f0000\",\"0x508cf19119db70aa86454253da764a2cb1b2be1a\":\"0x3635c9adc5dea00000\",\"0x509982f56237ee458951047e0a2230f804e2e895\":\"0x3b4ad496106b7f00000\",\"0x509a20bc48e72be1cdaf9569c711e8648d957334\":\"0x6c6b935b8bbd400000\",\"0x509c8668036d143fb8ae70b11995631f3dfcad87\":\"0x3635c9adc5dea00000\",\"0x50ad187ab21167c2b6e78be0153f44504a07945e\":\"0x56cd55fc64dfe0000\",\"0x50b9fef0a1329b02d16506255f5a2db71ec92d1f\":\"0x47da821564085c0000\",\"0x50bb67c8b8d8bd0f63c4760904f2d333f400aace\":\"0x6c6b935b8bbd400000\",\"0x50bef2756248f9a7a380f91b051ba3be28a649ed\":\"0x6c69f73e29134e0000\",\"0x50ca86b5eb1d01874df8e5f34945d49c6c1ab848\":\"0x3635c9adc5dea00000\",\"0x50cd97e9378b5cf18f173963236c9951ef7438a5\":\"0x4be4e7267b6ae00000\",\"0x50dcbc27bcad984093a212a9b4178eabe9017561\":\"0x7e362790b5ca40000\",\"0x50e13023bd9ca96ad4c53fdfd410cb6b1f420bdf\":\"0xad78ebc5ac6200000\",\"0x50e1c8ec98415bef442618708799437b86e6c205\":\"0x14542ba12a337c00000\",\"0x50f8fa4bb9e2677c990a4ee8ce70dd1523251e4f\":\"0x1693d23164f6b0000\",\"0x50fb36c27107ee2ca9a3236e2746cca19ace6b49\":\"0x6c6b935b8bbd400000\",\"0x50fef296955588caae74c62ec32a23a454e09ab8\":\"0x411dffabc507380000\",\"0x5102a4a42077e11c58df4773e3ac944623a66d9f\":\"0x6c7015fd52ed408000\",\"0x51039377eed0c573f986c5e8a95fb99a59e9330f\":\"0x6acb3df27e1f880000\",\"0x5103bc09933e9921fd53dc536f11f05d0d47107d\":\"0xd8d726b7177a800000\",\"0x5104ecc0e330dd1f81b58ac9dbb1a9fbf88a3c85\":\"0x152d02c7e14af6800000\",\"0x510d8159cc945768c7450790ba073ec0d9f89e30\":\"0x8ac7230489e8000000\",\"0x510eda5601499a0d5e1a006bfffd833672f2e267\":\"0x6c6b935b8bbd400000\",\"0x51126446ab3d8032557e8eba65597d75fadc815c\":\"0x1174a5cdf88bc80000\",\"0x5118557d600d05c2fcbf3806ffbd93d02025d730\":\"0x267d3ab6423f5800000\",\"0x511e0efb04ac4e3ff2e6550e498295bfcd56ffd5\":\"0x243d4d18229ca20000\",\"0x512116817ba9aaf843d1507c65a5ea640a7b9eec\":\"0x2b5e3af16b1880000\",\"0x5126460d692c71c9af6f05574d93998368a23799\":\"0x2d1a51c7e00500000\",\"0x51277fe7c81eebd252a03df69a6b9f326e272207\":\"0x3402e79cab44c8000\",\"0x51296f5044270d17707646129c86aad1645eadc1\":\"0x487c72b310d4648000\",\"0x512b91bbfaa9e581ef683fc90d9db22a8f49f48b\":\"0x41a522386d9b95c00000\",\"0x5135fb8757600cf474546252f74dc0746d06262c\":\"0x6c6b935b8bbd400000\",\"0x514632efbd642c04de6ca342315d40dd90a2dba6\":\"0x90f534608a72880000\",\"0x514b7512c9ae5ea63cbf11715b63f21e18d296c1\":\"0x6c6acc67d7b1d40000\",\"0x5153a0c3c8912881bf1c3501bf64b45649e48222\":\"0xd8d726b7177a800000\",\"0x515651d6db4faf9ecd103a921bbbbe6ae970fdd4\":\"0x43c33c1937564800000\",\"0x515f30bc90cdf4577ee47d65d785fbe2e837c6bc\":\"0x2271b5e018ba0580000\",\"0x5160ed612e1b48e73f3fc15bc4321b8f23b8a24b\":\"0x1e826b422865d80000\",\"0x5161fd49e847f67455f1c8bb7abb36e985260d03\":\"0x410d586a20a4c00000\",\"0x516954025fca2608f47da81c215eedfd844a09ff\":\"0x14b550a013c7380000\",\"0x5169c60aee4ceed1849ab36d664cff97061e8ea8\":\"0xa2a15d09519be00000\",\"0x517c75430de401c341032686112790f46d4d369e\":\"0x150894e849b3900000\",\"0x517cd7608e5d0d83a26b717f3603dac2277dc3a4\":\"0x6c6b935b8bbd400000\",\"0x51865db148881951f51251710e82b9be0d7eadb2\":\"0x6c6b935b8bbd400000\",\"0x51891b2ccdd2f5a44b2a8bc49a5d9bca6477251c\":\"0x10ce1d3d8cb3180000\",\"0x518cef27b10582b6d14f69483ddaa0dd3c87bb5c\":\"0x2086ac351052600000\",\"0x51a6d627f66a8923d88d6094c4715380d3057cb6\":\"0x3e73d27a35941e0000\",\"0x51a8c2163602a32ee24cf4aa97fd9ea414516941\":\"0x368f7e6b8672c0000\",\"0x51b4758e9e1450e7af4268c3c7b1e7bd6f5c7550\":\"0x3635c9adc5dea00000\",\"0x51ca8bd4dc644fac47af675563d5804a0da21eeb\":\"0x2ab7b260ff3fd00000\",\"0x51d24bc3736f88dd63b7222026886630b6eb878d\":\"0x6c6b935b8bbd400000\",\"0x51d78b178d707e396e8710965c4f41b1a1d9179d\":\"0x5fee222041e340000\",\"0x51e32f14f4ca5e287cdac057a7795ea9e0439953\":\"0x1b1ae4d6e2ef500000\",\"0x51e43fe0d25c782860af81ea89dd793c13f0cbb1\":\"0x340aad21b3b700000\",\"0x51e7b55c2f9820eed73884361b5066a59b6f45c6\":\"0x6c6b935b8bbd400000\",\"0x51ea1c0934e3d04022ed9c95a087a150ef705e81\":\"0x1547081e7224d200000\",\"0x51ee0cca3bcb10cd3e983722ced8493d926c0866\":\"0x36356633ebd8ea0000\",\"0x51f4663ab44ff79345f427a0f6f8a6c8a53ff234\":\"0x43c33c1937564800000\",\"0x51f55ef47e6456a418ab32b9221ed27dba6608ee\":\"0xe3aeb5737240a00000\",\"0x51f9c432a4e59ac86282d6adab4c2eb8919160eb\":\"0x703b5b89c3a6e7400000\",\"0x520f66a0e2657ff0ac4195f2f064cf2fa4b24250\":\"0x22b1c8c1227a00000\",\"0x52102354a6aca95d8a2e86d5debda6de69346076\":\"0x6c6b935b8bbd400000\",\"0x5213f459e078ad3ab95a0920239fcf1633dc04ca\":\"0x8cf2187c2afb188000\",\"0x5215183b8f80a9bc03d26ce91207832a0d39e620\":\"0x3635c9adc5dea00000\",\"0x52214378b54004056a7cc08c891327798ac6b248\":\"0x337fe5feaf2d1800000\",\"0x522323aad71dbc96d85af90f084b99c3f09decb7\":\"0x14542ba12a337c00000\",\"0x523e140dc811b186dee5d6c88bf68e90b8e096fd\":\"0x6c6b935b8bbd400000\",\"0x523f6d64690fdacd942853591bb0ff20d3656d95\":\"0x62a992e53a0af00000\",\"0x524fb210522c5e23bb67dfbf8c26aa616da49955\":\"0x363562a66d34238000\",\"0x5255dc69155a45b970c604d30047e2f530690e7f\":\"0x1158e460913d00000\",\"0x5260dc51ee07bddaababb9ee744b393c7f4793a6\":\"0x1d8665fa5fa4c0000\",\"0x5267f4d41292f370863c90d793296903843625c7\":\"0x4be4e7267b6ae00000\",\"0x526bb533b76e20c8ee1ebf123f1e9ff4148e40be\":\"0xaadec983fcff40000\",\"0x526cb09ce3ada3672eec1deb46205be89a4b563e\":\"0x85ca615bf9c0100000\",\"0x52738c90d860e04cb12f498d96fdb5bf36fc340e\":\"0x1a055690d9db80000\",\"0x527a8ca1268633a6c939c5de1b929aee92aeac8d\":\"0x30ca024f987b900000\",\"0x528101ce46b720a2214dcdae6618a53177ffa377\":\"0x1b9612b9dc01ae0000\",\"0x5281733473e00d87f11e9955e589b59f4ac28e7a\":\"0x8bd62ff4eec559200000\",\"0x5298ab182a19359ffcecafd7d1b5fa212dede6dd\":\"0x1158e460913d00000\",\"0x529aa002c6962a3a8545027fd8b05f22b5bf9564\":\"0x5a87e7d7f5f6580000\",\"0x529e824fa072582b4032683ac7eecc1c04b4cac1\":\"0x6c6b935b8bbd400000\",\"0x52a5e4de4393eeccf0581ac11b52c683c76ea15d\":\"0x43c30fb0884a96c0000\",\"0x52b4257cf41b6e28878d50d57b99914ffa89873a\":\"0xd50dc9aa2c41770000\",\"0x52b8a9592634f7300b7c5c59a3345b835f01b95c\":\"0x6c6b935b8bbd400000\",\"0x52bdd9af5978850bc24110718b3723759b437e59\":\"0x5dc892aa1131c80000\",\"0x52cd20403ba7eda6bc307a3d63b5911b817c1263\":\"0x1158e460913d00000\",\"0x52d380511df19d5ec2807bbcb676581b67fd37a3\":\"0xb9f65d00f63c0000\",\"0x52e1731350f983cc2c4189842fde0613fad50ce1\":\"0x277017338a30ae00000\",\"0x52e46783329a769301b175009d346768f4c87ee4\":\"0x6c6b935b8bbd400000\",\"0x52f058d46147e9006d29bf2c09304ad1cddd6e15\":\"0x5150ae84a8cdf00000\",\"0x52f15423323c24f19ae2ab673717229d3f747d9b\":\"0x37a034cbe8e3f38000\",\"0x52f8b509fee1a874ab6f9d87367fbeaf15ac137f\":\"0x3635c9adc5dea00000\",\"0x52fb46ac5d00c3518b2c3a1c177d442f8165555f\":\"0x5150ae84a8cdf00000\",\"0x530077c9f7b907ff9cec0c77a41a70e9029add4a\":\"0x6c6b935b8bbd400000\",\"0x530319db0a8f93e5bb7d4dbf4816314fbed8361b\":\"0x6c6b935b8bbd400000\",\"0x53047dc8ac9083d90672e8b3473c100ccd278323\":\"0x22b1c8c1227a00000\",\"0x530b61e42f39426d2408d40852b9e34ab5ebebc5\":\"0xe7eeba3410b740000\",\"0x530ffac3bc3412e2ec0ea47b7981c770f5bb2f35\":\"0x73f75d1a085ba0000\",\"0x5317ecb023052ca7f5652be2fa854cfe4563df4d\":\"0x1b1ab319f5ec750000\",\"0x53194d8afa3e883502767edbc30586af33b114d3\":\"0x6c6b935b8bbd400000\",\"0x532a7da0a5ad7407468d3be8e07e69c7dd64e861\":\"0x1b1ae4d6e2ef500000\",\"0x532d32b00f305bcc24dcef56817d622f34fb2c24\":\"0x6194049f30f7200000\",\"0x533444584082eba654e1ad30e149735c6f7ba922\":\"0x5dc892aa1131c80000\",\"0x5338ef70eac9dd9af5a0503b5efad1039e67e725\":\"0x90f534608a72880000\",\"0x53396f4a26c2b4604496306c5442e7fcba272e36\":\"0x43f2f08d40e5afc0000\",\"0x533a73a4a2228eee05c4ffd718bbf3f9c1b129a7\":\"0x14542ba12a337c00000\",\"0x533c06928f19d0a956cc28866bf6c8d8f4191a94\":\"0xfd8c14338e6300000\",\"0x534065361cb854fac42bfb5c9fcde0604ac919da\":\"0x6c6b935b8bbd400000\",\"0x53437fecf34ab9d435f4deb8ca181519e2592035\":\"0xa31062beeed700000\",\"0x535201a0a1d73422801f55ded4dfaee4fbaa6e3b\":\"0x226211f7915428000\",\"0x53608105ce4b9e11f86bf497ffca3b78967b5f96\":\"0x43c33c1937564800000\",\"0x536e4d8029b73f5579dca33e70b24eba89e11d7e\":\"0x6acb3df27e1f880000\",\"0x53700d53254d430f22781a4a76a463933b5d6b08\":\"0x6acb3df27e1f880000\",\"0x537f9d4d31ef70839d84b0d9cdb72b9afedbdf35\":\"0xed2b525841adfc00000\",\"0x5381448503c0c702542b1de7cc5fb5f6ab1cf6a5\":\"0x1b1ae4d6e2ef5000000\",\"0x53942e7949d6788bb780a7e8a0792781b1614b84\":\"0x35deb46684f10c80000\",\"0x5395a4455d95d178b4532aa4725b193ffe512961\":\"0x3635c9adc5dea00000\",\"0x53989ed330563fd57dfec9bd343c3760b0799390\":\"0x150894e849b39000000\",\"0x53a244672895480f4a2b1cdf7da5e5a242ec4dbc\":\"0x3635c9adc5dea00000\",\"0x53a714f99fa00fef758e23a2e746326dad247ca7\":\"0x50c5e761a444080000\",\"0x53af32c22fef99803f178cf90b802fb571c61cb9\":\"0xd255d112e103a00000\",\"0x53c0bb7fc88ea422d2ef7e540e2d8f28b1bb8183\":\"0x1158e460913d00000\",\"0x53c5fe0119e1e848640cee30adea96940f2a5d8b\":\"0x49ada5fa8c10c880000\",\"0x53c9eca40973f63bb5927be0bc6a8a8be1951f74\":\"0x6c6b935b8bbd400000\",\"0x53ce88e66c5af2f29bbd8f592a56a3d15f206c32\":\"0x7a28c31cc36040000\",\"0x53cec6c88092f756efe56f7db11228a2db45b122\":\"0xd8d726b7177a800000\",\"0x53e35b12231f19c3fd774c88fec8cbeedf1408b2\":\"0x1bc16d674ec8000000\",\"0x53e4d9696dcb3f4d7b3f70dcaa4eecb71782ff5c\":\"0xad78ebc5ac6200000\",\"0x53faf165be031ec18330d9fce5bd1281a1af08db\":\"0x796e3ea3f8ab00000\",\"0x540a1819bd7c35861e791804e5fbb3bc97c9abb1\":\"0x4ed7dac64230200000\",\"0x540c072802014ef0d561345aec481e8e11cb3570\":\"0x1b1ae4d6e2ef5000000\",\"0x540cf23dd95c4d558a279d778d2b3735b3164191\":\"0x21e19e0c9bab2400000\",\"0x541060fc58c750c40512f83369c0a63340c122b6\":\"0x6acb3df27e1f880000\",\"0x5413c97ffa4a6e2a7bba8961dc9fce8530a787d7\":\"0x3635c9adc5dea00000\",\"0x541db20a80cf3b17f1621f1b3ff79b882f50def3\":\"0x3635c9adc5dea00000\",\"0x542e8096bafb88162606002e8c8a3ed19814aeac\":\"0x6c6b935b8bbd400000\",\"0x54310b3aa88703a725dfa57de6e646935164802c\":\"0x678a932062e4180000\",\"0x5431b1d18751b98fc9e2888ac7759f1535a2db47\":\"0x6c6b935b8bbd400000\",\"0x5431ca427e6165a644bae326bd09750a178c650d\":\"0x6c6b935b8bbd400000\",\"0x5435c6c1793317d32ce13bba4c4ffeb973b78adc\":\"0xd8e6b1c1285ef0000\",\"0x543629c95cdef428ad37d453ca9538a9f90900ac\":\"0x92896529baddc880000\",\"0x54391b4d176d476cea164e5fb535c69700cb2535\":\"0x56cd55fc64dfe0000\",\"0x543a8c0efb8bcd15c543e2a6a4f807597631adef\":\"0x13f80e7e14f2d440000\",\"0x543f8c674e2462d8d5daa0e80195a8708e11a29e\":\"0x37758833b3a7a0000\",\"0x544b5b351d1bc82e9297439948cf4861dac9ae11\":\"0x4a89f54ef0121c00000\",\"0x544dda421dc1eb73bb24e3e56a248013b87c0f44\":\"0x6acb3df27e1f880000\",\"0x54575c3114751e3c631971da6a2a02fd3ffbfcc8\":\"0x692ae8897081d00000\",\"0x545bb070e781172eb1608af7fc2895d6cb87197e\":\"0x79a5c17ec748900000\",\"0x5475d7f174bdb1f789017c7c1705989646079d49\":\"0x1fd933494aa5fe00000\",\"0x548558d08cfcb101181dac1eb6094b4e1a896fa6\":\"0x6c6acc67d7b1d40000\",\"0x54939ff08921b467cf2946751d856378296c63ed\":\"0x3635c9adc5dea00000\",\"0x549b47649cfad993e4064d2636a4baa0623305cc\":\"0x209d922f5259c50000\",\"0x549d51af29f724c967f59423b85b2681e7b15136\":\"0xcbd47b6eaa8cc00000\",\"0x54a1370116fe22099e015d07cd2669dd291cc9d1\":\"0x1158e460913d00000\",\"0x54a62bf9233e146ffec3876e45f20ee8414adeba\":\"0x21e19e0c9bab2400000\",\"0x54b4429b182f0377be7e626939c5db6440f75d7a\":\"0x6acb3df27e1f880000\",\"0x54bcb8e7f73cda3d73f4d38b2d0847e600ba0df8\":\"0x3a70415882df180000\",\"0x54c93e03a9b2e8e4c3672835a9ee76f9615bc14e\":\"0x10d3aa536e2940000\",\"0x54ce88275956def5f9458e3b95decacd484021a0\":\"0x6c6b935b8bbd400000\",\"0x54db5e06b4815d31cb56a8719ba33af2d73e7252\":\"0x24521e2a3017b80000\",\"0x54e01283cc8b384538dd646770b357c960d6cacd\":\"0x10f0cf064dd59200000\",\"0x54ec7300b81ac84333ed1b033cd5d7a33972e234\":\"0xad78ebc5ac6200000\",\"0x54febcce20fe7a9098a755bd90988602a48c089e\":\"0x22b1c8c1227a000000\",\"0x550aadae1221b07afea39fba2ed62e05e5b7b5f9\":\"0x1158e460913d00000\",\"0x550c306f81ef5d9580c06cb1ab201b95c748a691\":\"0x2417d4c470bf140000\",\"0x551999ddd205563327b9b530785acff9bc73a4ba\":\"0x14542ba12a337c00000\",\"0x551e7784778ef8e048e495df49f2614f84a4f1dc\":\"0x2086ac351052600000\",\"0x5529830a61c1f13c197e550beddfd6bd195c9d02\":\"0x21e19e0c9bab2400000\",\"0x552987f0651b915b2e1e5328c121960d4bdd6af4\":\"0x61093d7c2c6d380000\",\"0x553b6b1c57050e88cf0c31067b8d4cd1ff80cb09\":\"0x15af1d78b58c400000\",\"0x553f37d92466550e9fd775ae74362df030179132\":\"0x6c6b935b8bbd400000\",\"0x554336ee4ea155f9f24f87bca9ca72e253e12cd2\":\"0x56bc75e2d63100000\",\"0x5543dd6d169eec8a213bbf7a8af9ffd15d4ff759\":\"0xfc936392801c0000\",\"0x5547fdb4ae11953e01292b7807fa9223d0e4606a\":\"0x55d117dcb1d260000\",\"0x5552f4b3ed3e1da79a2f78bb13e8ae5a68a9df3b\":\"0x3635c9adc5dea00000\",\"0x555ca9f05cc134ab54ae9bea1c3ff87aa85198ca\":\"0x56bc75e2d63100000\",\"0x555d8d3ce1798aca902754f164b8be2a02329c6c\":\"0x21e19e0c9bab2400000\",\"0x555df19390c16d01298772bae8bc3a1152199cbd\":\"0xad78ebc5ac6200000\",\"0x555ebe84daa42ba256ea789105cec4b693f12f18\":\"0x56bc75e2d63100000\",\"0x557f5e65e0da33998219ad4e99570545b2a9d511\":\"0x2559cbb985842400000\",\"0x558360206883dd1b6d4a59639e5629d0f0c675d0\":\"0x6c6b935b8bbd400000\",\"0x5584423050e3c2051f0bbd8f44bd6dbc27ecb62c\":\"0xa2a15d09519be00000\",\"0x55852943492970f8d629a15366cdda06a94f4513\":\"0x6c6b935b8bbd400000\",\"0x55866486ec168f79dbe0e1abb18864d98991ae2c\":\"0xdf6eb0b2d3ca0000\",\"0x558c54649a8a6e94722bd6d21d14714f71780534\":\"0x6c6b935b8bbd400000\",\"0x559194304f14b1b93afe444f0624e053c23a0009\":\"0x15af1d78b58c400000\",\"0x5593c9d4b664730fd93ca60151c25c2eaed93c3b\":\"0xad78ebc5ac6200000\",\"0x559706c332d20779c45f8a6d046a699159b74921\":\"0x149b442e85a3cf8000\",\"0x5598b3a79a48f32b1f5fc915b87b645d805d1afe\":\"0x1b1ae4d6e2ef500000\",\"0x55a3df57b7aaec16a162fd5316f35bec082821cf\":\"0x6acb3df27e1f880000\",\"0x55a4cac0cb8b582d9fef38c5c9fff9bd53093d1f\":\"0x6acb3df27e1f880000\",\"0x55a61b109480b5b2c4fcfdef92d90584160c0d35\":\"0x26c564d2b53f60000\",\"0x55aa5d313ebb084da0e7801091e29e92c5dec3aa\":\"0x6c6b935b8bbd400000\",\"0x55ab99b0e0e55d7bb874b7cfe834de631c97ec23\":\"0x37e98ce36899e40000\",\"0x55af092f94ba6a79918b0cf939eab3f01b3f51c7\":\"0x820d5e39576120000\",\"0x55c564664166a1edf3913e0169f1cd451fdb5d0c\":\"0x8217ea49508e6c0000\",\"0x55ca6abe79ea2497f46fdbb830346010fe469cbe\":\"0x1369fb96128ac480000\",\"0x55caff4bba04d220c9a5d2018672ec85e31ef83e\":\"0x6c6b935b8bbd400000\",\"0x55d057bcc04bd0f4af9642513aa5090bb3ff93fe\":\"0x3bfe452c8edd4c0000\",\"0x55d42eb495bf46a634997b5f2ea362814918e2b0\":\"0x5c0d265b5b2a80000\",\"0x55da9dcdca61cbfe1f133c7bcefc867b9c8122f9\":\"0x2fb474098f67c00000\",\"0x55e220876262c218af4f56784798c7e55da09e91\":\"0x73d99c15645d30000\",\"0x55fd08d18064bd202c0ec3d2cce0ce0b9d169c4d\":\"0x6acb3df27e1f880000\",\"0x5600730a55f6b20ebd24811faa3de96d1662abab\":\"0x65ea3db75546600000\",\"0x5603241eb8f08f721e348c9d9ad92f48e390aa24\":\"0xad78ebc5ac6200000\",\"0x560536794a9e2b0049d10233c41adc5f418a264a\":\"0x3635c9adc5dea00000\",\"0x5607590059a9fec1881149a44b36949aef85d560\":\"0x6c6b935b8bbd400000\",\"0x560becdf52b71f3d8827d927610f1a980f33716f\":\"0x17474d705f56d08000\",\"0x560da37e956d862f81a75fd580a7135c1b246352\":\"0x21e19e0c9bab2400000\",\"0x560fc08d079f047ed8d7df75551aa53501f57013\":\"0x19bff2ff57968c00000\",\"0x561be9299b3e6b3e63b79b09169d1a948ae6db01\":\"0x1b1ae4d6e2ef500000\",\"0x562020e3ed792d2f1835fe5f55417d5111460c6a\":\"0x43c33c1937564800000\",\"0x5620f46d1451c2353d6243a5d4b427130be2d407\":\"0x340aad21b3b700000\",\"0x562105e82b099735de49f62692cc87cd38a8edcd\":\"0x14542ba12a337c00000\",\"0x562a8dcbbeeef7b360685d27303bd69e094accf6\":\"0x21e19e0c9bab2400000\",\"0x562bced38ab2ab6c080f3b0541b8456e70824b3f\":\"0x22ca3587cf4eb00000\",\"0x562be95aba17c5371fe2ba828799b1f55d2177d6\":\"0x816d37e87b9d1e00000\",\"0x562f16d79abfcec3943e34b20f05f97bdfcda605\":\"0xd8d726b7177a800000\",\"0x56373daab46316fd7e1576c61e6affcb6559ddd7\":\"0xbac715d146c9e0000\",\"0x56397638bb3cebf1f62062794b5eb942f916171d\":\"0x6c6b935b8bbd400000\",\"0x563a03ab9c56b600f6d25b660c21e16335517a75\":\"0x3635c9adc5dea00000\",\"0x563cb8803c1d32a25b27b64114852bd04d9c20cd\":\"0xb149ead0ad9d80000\",\"0x56586391040c57eec6f5affd8cd4abde10b50acc\":\"0xd8d726b7177a800000\",\"0x566c10d638e8b88b47d6e6a414497afdd00600d4\":\"0x56b394263a40c0000\",\"0x566c28e34c3808d9766fe8421ebf4f2b1c4f7d77\":\"0x6acb3df27e1f880000\",\"0x568df31856699bb5acfc1fe1d680df9960ca4359\":\"0x4acf5552f3b2498000\",\"0x5691dd2f6745f20e22d2e1d1b955aa2903d65656\":\"0x6ac5c62d9486070000\",\"0x56a1d60d40f57f308eebf087dee3b37f1e7c2cba\":\"0x3edcaec82d06f80000\",\"0x56ac20d63bd803595cec036da7ed1dc66e0a9e07\":\"0x3772a53ccdc658000\",\"0x56b6c23dd2ec90b4728f3bb2e764c3c50c85f144\":\"0x3635c9adc5dea00000\",\"0x56df05bad46c3f00ae476ecf017bb8c877383ff1\":\"0xab15daaef70400000\",\"0x56ee197f4bbf9f1b0662e41c2bbd9aa1f799e846\":\"0x3635c9adc5dea00000\",\"0x56f493a3d108aaa2d18d98922f8efe1662cfb73d\":\"0x6d8121a194d1100000\",\"0x56fc1a7bad4047237ce116146296238e078f93ad\":\"0x9a63f08ea63880000\",\"0x56febf9e1003af15b1bd4907ec089a4a1b91d268\":\"0xad78ebc5ac6200000\",\"0x5717cc9301511d4a81b9f583148beed3d3cc8309\":\"0x8cf23f909c0fa00000\",\"0x5717f2d8f18ffcc0e5fe247d3a4219037c3a649c\":\"0xd8bb6549b02bb80000\",\"0x571950ea2c90c1427d939d61b4f2de4cf1cfbfb0\":\"0x1158e460913d00000\",\"0x5719f49b720da68856f4b9e708f25645bdbc4b41\":\"0x22b1c8c1227a000000\",\"0x572ac1aba0de23ae41a7cae1dc0842d8abfc103b\":\"0x678a932062e4180000\",\"0x572dd8cd3fe399d1d0ec281231b7cefc20b9e4bb\":\"0x233c8fe42703e800000\",\"0x574921838cc77d6c98b17d903a3ae0ee0da95bd0\":\"0xb5328178ad0f2a00000\",\"0x574ad9355390e4889ef42acd138b2a27e78c00ae\":\"0x5467b732a913340000\",\"0x574de1b3f38d915846ae3718564a5ada20c2f3ed\":\"0xd8d726b7177a800000\",\"0x575c00c2818210c28555a0ff29010289d3f82309\":\"0x21e19e0c9bab2400000\",\"0x5773b6026721a1dd04b7828cd62b591bfb34534c\":\"0x5b7ac4553de7ae00000\",\"0x5777441c83e03f0be8dd340bde636850847c620b\":\"0x21e19e0c9bab2400000\",\"0x5778ffdc9b94c5a59e224eb965b6de90f222d170\":\"0x122d7ff36603fc0000\",\"0x577aeee8d4bc08fc97ab156ed57fb970925366be\":\"0x120df1147258bf0000\",\"0x577b2d073c590c50306f5b1195a4b2ba9ecda625\":\"0x1440bdd49515f00000\",\"0x577bfe64e3a1e3800e94db1c6c184d8dc8aafc66\":\"0x5134ed17417f280000\",\"0x57825aeb09076caa477887fbc9ae37e8b27cc962\":\"0x56bc75e2d63100000\",\"0x57883010b4ac857fedac03eab2551723a8447ffb\":\"0x3635c9adc5dea00000\",\"0x5789d01db12c816ac268e9af19dc0dd6d99f15df\":\"0xad78ebc5ac6200000\",\"0x5792814f59a33a1843faa01baa089eb02ffb5cf1\":\"0x1b1ab319f5ec750000\",\"0x5793abe6f1533311fd51536891783b3f9625ef1c\":\"0x2cd8a656f23fda0000\",\"0x5797b60fd2894ab3c2f4aede86daf2e788d745ad\":\"0x14542ba12a337c00000\",\"0x57a852fdb9b1405bf53ccf9508f83299d3206c52\":\"0x6c6b935b8bbd400000\",\"0x57b23d6a1adc06c652a779c6a7fb6b95b9fead66\":\"0xad78ebc5ac6200000\",\"0x57bc20e2d62b3d19663cdb4c309d5b4f2fc2db8f\":\"0x56bc75e2d63100000\",\"0x57bddf078834009c89d88e6282759dc45335b470\":\"0x74717cfb6883100000\",\"0x57beea716cbd81700a73d67f9ff039529c2d9025\":\"0xad78ebc5ac6200000\",\"0x57d032a43d164e71aa2ef3ffd8491b0a4ef1ea5b\":\"0x6c6b935b8bbd400000\",\"0x57d3df804f2beee6ef53ab94cb3ee9cf524a18d3\":\"0x1556616b9606670000\",\"0x57d5fd0e3d3049330ffcdcd020456917657ba2da\":\"0x6bf20195f554d40000\",\"0x57dd9471cbfa262709f5f486bcb774c5f527b8f8\":\"0xaadec983fcff40000\",\"0x57df23bebdc65eb75feb9cb2fad1c073692b2baf\":\"0xd8d726b7177a800000\",\"0x5800cd8130839e94495d2d8415a8ea2c90e0c5cb\":\"0xad78ebc5ac6200000\",\"0x5803e68b34da121aef08b602badbafb4d12481ca\":\"0x3cfc82e37e9a7400000\",\"0x5816c2687777b6d7d2a2432d59a41fa059e3a406\":\"0x1c4fe43adb0a5e900000\",\"0x581a3af297efa4436a29af0072929abf9826f58b\":\"0x6c6b935b8bbd400000\",\"0x581b9fd6eae372f3501f42eb9619eec820b78a84\":\"0x42be2c00ca53b8d8000\",\"0x581bdf1bb276dbdd86aedcdb397a01efc0e00c5b\":\"0x3635c9adc5dea00000\",\"0x581f34b523e5b41c09c87c298e299cbc0e29d066\":\"0x3d5833aafd39758000\",\"0x5824a7e22838277134308c5f4b50dab65e43bb31\":\"0x14542ba12a337c00000\",\"0x582b70669c97aab7d68148d8d4e90411e2810d56\":\"0x36356633ebd8ea0000\",\"0x582e7cc46f1d7b4e6e9d95868bfd370573178f4c\":\"0x6c6b935b8bbd400000\",\"0x583e83ba55e67e13e0e76f8392d873cd21fbf798\":\"0x1158e460913d00000\",\"0x5869fb867d71f1387f863b698d09fdfb87c49b5c\":\"0xc6bbf858b316080000\",\"0x587d6849b168f6c3332b7abae7eb6c42c37f48bf\":\"0x2fb474098f67c00000\",\"0x5887dc6a33dfed5ac1edefe35ef91a216231ac96\":\"0xd8d726b7177a80000\",\"0x588ed990a2aff44a94105d58c305257735c868ac\":\"0x368c8623a8b4d100000\",\"0x58ae2ddc5f4c8ada97e06c0086171767c423f5d7\":\"0x57473d05dabae80000\",\"0x58aed6674affd9f64233272a578dd9386b99c263\":\"0xb8507a820728200000\",\"0x58b808a65b51e6338969afb95ec70735e451d526\":\"0x8784bc1b9837a380000\",\"0x58b8ae8f63ef35ed0762f0b6233d4ac14e64b64d\":\"0x6c6b935b8bbd400000\",\"0x58ba1569650e5bbbb21d35d3e175c0d6b0c651a9\":\"0x1b1ae4d6e2ef500000\",\"0x58c555bc293cdb16c6362ed97ae9550b92ea180e\":\"0x1158e460913d00000\",\"0x58c650ced40bb65641b8e8a924a039def46854df\":\"0x100bd33fb98ba0000\",\"0x58c90754d2f20a1cb1dd330625e04b45fa619d5c\":\"0x6c6b935b8bbd400000\",\"0x58e2f11223fc8237f69d99c6289c148c0604f742\":\"0x5150ae84a8cdf000000\",\"0x58e554af3d87629620da61d538c7f5b4b54c4afe\":\"0x46509d694534728000\",\"0x58e5c9e344c806650dacfc904d33edba5107b0de\":\"0x10910d4cdc9f60000\",\"0x58e661d0ba73d6cf24099a5562b808f7b3673b68\":\"0x6c6b935b8bbd400000\",\"0x58f05b262560503ca761c61890a4035f4c737280\":\"0x1b1ae4d6e2ef5000000\",\"0x58fb947364e7695765361ebb1e801ffb8b95e6d0\":\"0xad78ebc5ac6200000\",\"0x590181d445007bd0875aaf061c8d51153900836a\":\"0x6c6b935b8bbd400000\",\"0x5902e44af769a87246a21e079c08bf36b06efeb3\":\"0x3635c9adc5dea00000\",\"0x590acbda37290c0d3ec84fc2000d7697f9a4b15d\":\"0x1b1ae4d6e2ef500000\",\"0x590ccb5911cf78f6f622f535c474375f4a12cfcf\":\"0x43c33c1937564800000\",\"0x5910106debd291a1cd80b0fbbb8d8d9e93a7cc1e\":\"0x6c6b935b8bbd400000\",\"0x59161749fedcf1c721f2202d13ade2abcf460b3d\":\"0x6c6b935b8bbd400000\",\"0x591bef3171d1c5957717a4e98d17eb142c214e56\":\"0x43c33c1937564800000\",\"0x59203cc37599b648312a7cc9e06dacb589a9ae6a\":\"0x80f7971b6400e8000\",\"0x59268171b833e0aa13c54b52ccc0422e4fa03aeb\":\"0xa2a15d09519be00000\",\"0x592777261e3bd852c48eca95b3a44c5b7f2d422c\":\"0x43c33c1937564800000\",\"0x593044670faeff00a55b5ae051eb7be870b11694\":\"0x73f75d1a085ba0000\",\"0x593b45a1864ac5c7e8f0caaeba0d873cd5d113b2\":\"0x14542ba12a337c00000\",\"0x593c48935beaff0fde19b04d309cd530a28e52ce\":\"0xd8d726b7177a800000\",\"0x59473cd300fffae240f5785626c65dfec792b9af\":\"0x1158e460913d00000\",\"0x5948bc3650ed519bf891a572679fd992f8780c57\":\"0xaadec983fcff40000\",\"0x594a76f06935388dde5e234696a0668bc20d2ddc\":\"0x97c9ce4cf6d5c00000\",\"0x59569a21d28fba4bda37753405a081f2063da150\":\"0xd8d726b7177a800000\",\"0x5956b28ec7890b76fc061a1feb52d82ae81fb635\":\"0x6c6b935b8bbd400000\",\"0x595e23d788a2d4bb85a15df7136d264a635511b3\":\"0xd5967be4fc3f100000\",\"0x597038ff91a0900cbbab488af483c790e6ec00a0\":\"0x21e19e0c9bab2400000\",\"0x5970fb1b144dd751e4ce2eca7caa20e363dc4da3\":\"0x21e19e0c9bab2400000\",\"0x5975b9528f23af1f0e2ec08ac8ebaa786a2cb8e0\":\"0x12bf50503ae3038000\",\"0x5975d78d974ee5bb9e4d4ca2ae77c84b9c3b4b82\":\"0x4a4491bd6dcd280000\",\"0x5985c59a449dfc5da787d8244e746c6d70caa55f\":\"0x56bc75e2d63100000\",\"0x598aaabae9ed833d7bc222e91fcaa0647b77580b\":\"0x6194049f30f7200000\",\"0x5992624c54cdec60a5ae938033af8be0c50cbb0a\":\"0xc454e0f8870f2b0000\",\"0x599728a78618d1a17b9e34e0fed8e857d5c40622\":\"0x2f6f10780d22cc00000\",\"0x5997ffefb3c1d9d10f1ae2ac8ac3c8e2d2292783\":\"0x3635c9adc5dea00000\",\"0x59a087b9351ca42f58f36e021927a22988284f38\":\"0x100bd33fb98ba0000\",\"0x59a12df2e3ef857aceff9306b309f6a500f70134\":\"0x3635c9adc5dea00000\",\"0x59b96deb8784885d8d3b4a166143cc435d2555a1\":\"0x487a9a304539440000\",\"0x59b9e733cba4be00429b4bd9dfa64732053a7d55\":\"0x1158e460913d00000\",\"0x59c5d06b170ee4d26eb0a0eb46cb7d90c1c91019\":\"0x21e19e0c9bab2400000\",\"0x59c7f785c93160e5807ed34e5e534bc6188647a7\":\"0x22b1c8c1227a000000\",\"0x59d139e2e40c7b97239d23dfaca33858f602d22b\":\"0x6c6b935b8bbd400000\",\"0x59f6247b0d582aaa25e5114765e4bf3c774f43c2\":\"0x2b5e3af16b1880000\",\"0x59fe00696dbd87b7976b29d1156c8842a2e17914\":\"0x6c6b935b8bbd400000\",\"0x5a0d609aae2332b137ab3b2f26615a808f37e433\":\"0x21e19e0c9bab24000000\",\"0x5a192b964afd80773e5f5eda6a56f14e25e0c6f3\":\"0x1b1ae4d6e2ef500000\",\"0x5a1a336962d6e0c63031cc83c6a5c6a6f4478ecb\":\"0x3635c9adc5dea00000\",\"0x5a1d2d2d1d520304b6208849570437eb3091bb9f\":\"0x6acb3df27e1f880000\",\"0x5a267331facb262daaecd9dd63a9700c5f5259df\":\"0x56bc75e2d63100000\",\"0x5a285755391e914e58025faa48cc685f4fd4f5b8\":\"0x581767ba6189c400000\",\"0x5a2916b8d2e8cc12e207ab464d433e2370d823d9\":\"0x6c6b935b8bbd400000\",\"0x5a2b1c853aeb28c45539af76a00ac2d8a8242896\":\"0x15af1d78b58c40000\",\"0x5a2daab25c31a61a92a4c82c9925a1d2ef58585e\":\"0xc380da9c7950c0000\",\"0x5a30feac37ac9f72d7b4af0f2bc73952c74fd5c3\":\"0x6c6b935b8bbd400000\",\"0x5a5468fa5ca226c7532ecf06e1bc1c45225d7ec9\":\"0x678a932062e4180000\",\"0x5a565285374a49eedd504c957d510874d00455bc\":\"0x56bc75e2d63100000\",\"0x5a5ee8e9bb0e8ab2fecb4b33d29478be50bbd44b\":\"0x2a1129d09367200000\",\"0x5a5f8508da0ebebb90be9033bd4d9e274105ae00\":\"0x16a6502f15a1e540000\",\"0x5a6071bcebfcba4ab57f4db96fc7a68bece2ba5b\":\"0x6c6b935b8bbd400000\",\"0x5a60c924162873fc7ea4da7f972e350167376031\":\"0x487f277a885798000\",\"0x5a6686b0f17e07edfc59b759c77d5bef164d3879\":\"0x50c5e761a444080000\",\"0x5a70106f20d63f875265e48e0d35f00e17d02bc9\":\"0x1158e460913d00000\",\"0x5a74ba62e7c81a3474e27d894fed33dd24ad95fe\":\"0xfc936392801c0000\",\"0x5a7735007d70b06844da9901cdfadb11a2582c2f\":\"0x14542ba12a337c00000\",\"0x5a82f96cd4b7e2d93d10f3185dc8f43d4b75aa69\":\"0x6c633fbab98c040000\",\"0x5a87f034e6f68f4e74ffe60c64819436036cf7d7\":\"0x1158e460913d00000\",\"0x5a891155f50e42074374c739baadf7df2651153a\":\"0x102da6fd0f73a3c0000\",\"0x5a9c8b69fc614d69564999b00dcb42db67f97e90\":\"0xb9e615abad3a778000\",\"0x5aaf1c31254a6e005fba7f5ab0ec79d7fc2b630e\":\"0x14061b9d77a5e980000\",\"0x5ab1a5615348001c7c775dc75748669b8be4de14\":\"0x256a72fb29e69c0000\",\"0x5abfec25f74cd88437631a7731906932776356f9\":\"0x9d83cc0dfa11177ff8000\",\"0x5ac2908b0f398c0df5bac2cb13ca7314fba8fa3d\":\"0xad4c8316a0b0c0000\",\"0x5ac99ad7816ae9020ff8adf79fa9869b7cea6601\":\"0x472698b413b43200000\",\"0x5ad12c5ed4fa827e2150cfa0d68c0aa37b1769b8\":\"0x2b5e3af16b18800000\",\"0x5ad5e420755613886f35aa56ac403eebdfe4b0d0\":\"0x10f0cf064dd592000000\",\"0x5ade77fd81c25c0af713b10702768c1eb2f975e7\":\"0x1158e460913d00000\",\"0x5ae64e853ba0a51282cb8db52e41615e7c9f733f\":\"0x6c6b935b8bbd400000\",\"0x5aed0e6cfe95f9d680c76472a81a2b680a7f93e2\":\"0xaadec983fcff40000\",\"0x5aef16a226dd68071f2483e1da42598319f69b2c\":\"0x6c6b935b8bbd400000\",\"0x5af46a25ac09cb73616b53b14fb42ff0a51cddb2\":\"0xd8d726b7177a800000\",\"0x5af7c072b2c5acd71c76addcce535cf7f8f93585\":\"0x1158e460913d00000\",\"0x5afda9405c8e9736514574da928de67456010918\":\"0x145b8b0239a46920000\",\"0x5b06d1e6930c1054692b79e3dbe6ecce53966420\":\"0xb227f63be813c0000\",\"0x5b25cae86dcafa2a60e7723631fc5fa49c1ad87d\":\"0x870c58510e85200000\",\"0x5b287c7e734299e727626f93fb1187a60d5057fe\":\"0x57cd934a914cb0000\",\"0x5b290c01967c812e4dc4c90b174c1b4015bae71e\":\"0x820eb348d52b90000\",\"0x5b2b64e9c058e382a8b299224eecaa16e09c8d92\":\"0x8ba52e6fc45e40000\",\"0x5b2e2f1618552eab0db98add55637c2951f1fb19\":\"0x28a857425466f800000\",\"0x5b30608c678e1ac464a8994c3b33e5cdf3497112\":\"0x15af1d78b58c400000\",\"0x5b333696e04cca1692e71986579c920d6b2916f9\":\"0x1b1ae4d6e2ef500000\",\"0x5b430d779696a3653fc60e74fbcbacf6b9c2baf1\":\"0x2f6f10780d22cc00000\",\"0x5b437365ae3a9a2ff97c68e6f90a7620188c7d19\":\"0x6c8754c8f30c080000\",\"0x5b49afcd75447838f6e7ceda8d21777d4fc1c3c0\":\"0xd8d726b7177a800000\",\"0x5b4c0c60f10ed2894bdb42d9dd1d210587810a0d\":\"0x1b1ae4d6e2ef500000\",\"0x5b4ea16db6809b0352d4b6e81c3913f76a51bb32\":\"0x15af1d78b58c400000\",\"0x5b5be0d8c67276baabd8edb30d48ea75640b8b29\":\"0x2cb1f55fb7be100000\",\"0x5b5d517029321562111b43086d0b043591109a70\":\"0x8cf23f909c0fa00000\",\"0x5b5d8c8eed6c85ac215661de026676823faa0a0c\":\"0x43c33c1937564800000\",\"0x5b6d55f6712967405c659129f4b1de09acf2cb7b\":\"0xe7eeba3410b740000\",\"0x5b70c49cc98b3df3fbe2b1597f5c1b6347a388b7\":\"0x34957444b840e80000\",\"0x5b736eb18353629bde9676dadd165034ce5ecc68\":\"0x6acb3df27e1f880000\",\"0x5b759fa110a31c88469f54d44ba303d57dd3e10f\":\"0x5b46dd2f0ea3b80000\",\"0x5b7784caea01799ca30227827667ce207c5cbc76\":\"0x6c6b935b8bbd400000\",\"0x5b78eca27fbdea6f26befba8972b295e7814364b\":\"0x6c6b935b8bbd400000\",\"0x5b800bfd1b3ed4a57d875aed26d42f1a7708d72a\":\"0x15a82d1d5bb88e00000\",\"0x5b85e60e2af0544f2f01c64e2032900ebd38a3c7\":\"0x6c6b935b8bbd400000\",\"0x5ba2c6c35dfaec296826591904d544464aeabd5e\":\"0x1158e460913d00000\",\"0x5baf6d749620803e8348af3710e5c4fbf20fc894\":\"0x10f4002615dfe900000\",\"0x5bc1f95507b1018642e45cd9c0e22733b9b1a326\":\"0x56bc75e2d63100000\",\"0x5bd23547477f6d09d7b2a005c5ee650c510c56d7\":\"0x21e19e0c9bab2400000\",\"0x5bd24aac3612b20c609eb46779bf95698407c57c\":\"0x6acb3df27e1f880000\",\"0x5bd6862d517d4de4559d4eec0a06cad05e2f946e\":\"0xad78ebc5ac6200000\",\"0x5be045512a026e3f1cebfd5a7ec0cfc36f2dc16b\":\"0x68155a43676e00000\",\"0x5bf9f2226e5aeacf1d80ae0a59c6e38038bc8db5\":\"0x14542ba12a337c00000\",\"0x5bfafe97b1dd1d712be86d41df79895345875a87\":\"0x1b1ae4d6e2ef500000\",\"0x5c0f2e51378f6b0d7bab617331580b6e39ad3ca5\":\"0x2086ac3510526000000\",\"0x5c29f9e9a523c1f8669448b55c48cbd47c25e610\":\"0x3446a0dad04cb00000\",\"0x5c308bac4857d33baea074f3956d3621d9fa28e1\":\"0x10f08eda8e555098000\",\"0x5c312a56c784b122099b764d059c21ece95e84ca\":\"0x52663ccab1e1c0000\",\"0x5c31996dcac015f9be985b611f468730ef244d90\":\"0xad78ebc5ac6200000\",\"0x5c323457e187761a8276e359b7b7af3f3b6e3df6\":\"0x21e19e0c9bab2400000\",\"0x5c3c1c645b917543113b3e6c1c054da1fe742b9a\":\"0x2b5e3af16b18800000\",\"0x5c3d19441d196cb443662020fcad7fbb79b29e78\":\"0xc673ce3c40160000\",\"0x5c3f567faff7bad1b5120022e8cbcaa82b4917b3\":\"0x6c6b935b8bbd400000\",\"0x5c4368918ace6409c79eca80cdaae4391d2b624e\":\"0xd8d726b7177a800000\",\"0x5c464197791c8a3da3c925436f277ab13bf2faa2\":\"0x1b1ae4d6e2ef5000000\",\"0x5c4881165cb42bb82e97396c8ef44adbf173fb99\":\"0x5fee222041e340000\",\"0x5c4892907a0720df6fd3413e63ff767d6b398023\":\"0x2cb009fd3b5790f8000\",\"0x5c4f24e994ed8f850ea7818f471c8fac3bcf0452\":\"0x5d80688d9e31c00000\",\"0x5c5419565c3aad4e714e0739328e3521c98f05cc\":\"0x1c9f78d2893e400000\",\"0x5c6136e218de0a61a137b2b3962d2a6112b809d7\":\"0xff3dbb65ff4868000\",\"0x5c61ab79b408dd3229f662593705d72f1e147bb8\":\"0x4d0243d3498cd840000\",\"0x5c6d041da7af4487b9dc48e8e1f60766d0a56dbc\":\"0x4f070a003e9c740000\",\"0x5c6f36af90ab1a656c6ec8c7d521512762bba3e1\":\"0x6c68ccd09b022c0000\",\"0x5c7b9ec7a2438d1e3c7698b545b9c3fd77b7cd55\":\"0x3635c9adc5dea00000\",\"0x5c936f3b9d22c403db5e730ff177d74eef42dbbf\":\"0x410d586a20a4c0000\",\"0x5cb731160d2e8965670bde925d9de5510935347d\":\"0x22b1c8c1227a00000\",\"0x5cb953a0e42f5030812226217fffc3ce230457e4\":\"0x56bc75e2d63100000\",\"0x5cbd8daf27ddf704cdd0d909a789ba36ed4f37b2\":\"0xb9f65d00f63c0000\",\"0x5cc4cba621f220637742057f6055b80dffd77e13\":\"0x878477b7d253b660000\",\"0x5cc7d3066d45d27621f78bb4b339473e442a860f\":\"0x21e1899f0377aea0000\",\"0x5cccf1508bfd35c20530aa642500c10dee65eaed\":\"0x2e141ea081ca080000\",\"0x5cce72d068c7c3f55b1d2819545e77317cae8240\":\"0x692ae8897081d00000\",\"0x5cd0e475b54421bdfc0c12ea8e082bd7a5af0a6a\":\"0x332ca1b67940c0000\",\"0x5cd588a14ec648ccf64729f9167aa7bf8be6eb3d\":\"0x3635c9adc5dea00000\",\"0x5cd8af60de65f24dc3ce5730ba92653022dc5963\":\"0x61093d7c2c6d380000\",\"0x5cdc4708f14f40dcc15a795f7dc8cb0b7faa9e6e\":\"0x1d1c5f3eda20c40000\",\"0x5ce0b6862cce9162e87e0849e387cb5df4f9118c\":\"0x5a87e7d7f5f6580000\",\"0x5ce2e7ceaaa18af0f8aafa7fbad74cc89e3cd436\":\"0x43c33c1937564800000\",\"0x5ce44068b8f4a3fe799e6a8311dbfdeda29dee0e\":\"0x6c6b935b8bbd400000\",\"0x5cebe30b2a95f4aefda665651dc0cf7ef5758199\":\"0xfc936392801c0000\",\"0x5cf18fa7c8a7c0a2b3d5efd1990f64ddc569242c\":\"0x3635c9adc5dea00000\",\"0x5cf44e10540d65716423b1bcb542d21ff83a94cd\":\"0x21e19e0c9bab2400000\",\"0x5cf8c03eb3e872e50f7cfd0c2f8d3b3f2cb5183a\":\"0xad78ebc5ac6200000\",\"0x5cfa8d568575658ca4c1a593ac4c5d0e44c60745\":\"0xfc66fae3746ac0000\",\"0x5cfa9877f719c79d9e494a08d1e41cf103fc87c9\":\"0xad78ebc5ac6200000\",\"0x5d1dc3387b47b8451e55106c0cc67d6dc72b7f0b\":\"0x6c6b935b8bbd400000\",\"0x5d231a70c1dfeb360abd97f616e2d10d39f3cab5\":\"0x15af1d78b58c400000\",\"0x5d24bdbc1c47f0eb83d128cae48ac33c4817e91f\":\"0x3635c9adc5dea00000\",\"0x5d2819e8d57821922ee445650ccaec7d40544a8d\":\"0xad78ebc5ac6200000\",\"0x5d2f7f0b04ba4be161e19cb6f112ce7a5e7d7fe4\":\"0x1e87f85809dc00000\",\"0x5d32f6f86e787ff78e63d78b0ef95fe6071852b8\":\"0x15be6174e1912e0000\",\"0x5d39ef9ea6bdfff15d11fe91f561a6f9e31f5da5\":\"0x6c6b935b8bbd400000\",\"0x5d3f3b1f7130b0bb21a0fd32396239179a25657f\":\"0xd3ab8ea5e8fd9e80000\",\"0x5d5751819b4f3d26ed0c1ac571552735271dbefa\":\"0x3635c9adc5dea00000\",\"0x5d5c2c1099bbeefb267e74b58880b444d94449e0\":\"0xdbf0bd181e2e70000\",\"0x5d5cdbe25b2a044b7b9be383bcaa5807b06d3c6b\":\"0x6c6b935b8bbd400000\",\"0x5d5d6e821c6eef96810c83c491468560ef70bfb5\":\"0x6c6b935b8bbd400000\",\"0x5d68324bcb776d3ffd0bf9fea91d9f037fd6ab0f\":\"0x6c6b935b8bbd400000\",\"0x5d6ae8cbd6b3393c22d16254100d0238e808147c\":\"0x2707e56d51a30c0000\",\"0x5d6c5c720d66a6abca8397142e63d26818eaab54\":\"0x22b1c8c1227a00000\",\"0x5d6ccf806738091042ad97a6e095fe8c36aa79c5\":\"0xa31062beeed700000\",\"0x5d71799c8df3bccb7ee446df50b8312bc4eb71c5\":\"0xad78ebc5ac6200000\",\"0x5d822d9b3ef4b502627407da272f67814a6becd4\":\"0x1158e460913d00000\",\"0x5d83b21bd2712360436b67a597ee3378db3e7ae4\":\"0x6c6b935b8bbd400000\",\"0x5d872b122e994ef27c71d7deb457bf65429eca6c\":\"0x1b1aded81d394108000\",\"0x5d8d31faa864e22159cd6f5175ccecc53fa54d72\":\"0x5b696b70dd567100000\",\"0x5d958a9bd189c2985f86c58a8c69a7a78806e8da\":\"0x228f16f861578600000\",\"0x5da2a9a4c2c0a4a924cbe0a53ab9d0c627a1cfa0\":\"0x27bf38c6544df50000\",\"0x5da4ca88935c27f55c311048840e589e04a8a049\":\"0x4563918244f400000\",\"0x5da54785c9bd30575c89deb59d2041d20a39e17b\":\"0x6aa209f0b91d658000\",\"0x5db69fe93e6fb6fbd450966b97238b110ad8279a\":\"0x878678326eac9000000\",\"0x5db7bba1f9573f24115d8c8c62e9ce8895068e9f\":\"0x2b5aad72c65200000\",\"0x5db84400570069a9573cab04b4e6b69535e202b8\":\"0x20dd68aaf3289100000\",\"0x5dc36de5359450a1ec09cb0c44cf2bb42b3ae435\":\"0x3c946d893b33060000\",\"0x5dc6f45fef26b06e3302313f884daf48e2746fb9\":\"0x1b1ae4d6e2ef500000\",\"0x5dcdb6b87a503c6d8a3c65c2cf9a9aa883479a1e\":\"0x1f2bba5d84f99c00000\",\"0x5dd112f368c0e6ceff77a9df02a5481651a02fb7\":\"0x93472c85c6d540000\",\"0x5dd53ae897526b167d39f1744ef7c3da5b37a293\":\"0x1b1ae4d6e2ef5000000\",\"0x5dded049a6e1f329dc4b971e722c9c1f2ade83f0\":\"0x3635c9adc5dea00000\",\"0x5de598aba344378cab4431555b4f79992dc290c6\":\"0x487a9a304539440000\",\"0x5de9e7d5d1b667d095dd34099c85b0421a0bc681\":\"0x1158e460913d00000\",\"0x5df3277ca85936c7a0d2c0795605ad25095e7159\":\"0x6c6b935b8bbd400000\",\"0x5dff811dad819ece3ba602c383fb5dc64c0a3a48\":\"0xa1544be879ea80000\",\"0x5e031b0a724471d476f3bcd2eb078338bf67fbef\":\"0xfc936392801c0000\",\"0x5e0785532c7723e4c0af9357d5274b73bdddddde\":\"0x54b41ea9bdb61dc0000\",\"0x5e11ecf69d551d7f4f84df128046b3a13240a328\":\"0x1158e460913d00000\",\"0x5e1fbd4e58e2312b3c78d7aaaafa10bf9c3189e3\":\"0x878678326eac9000000\",\"0x5e32c72191b8392c55f510d8e3326e3a60501d62\":\"0x9513ea9de0243800000\",\"0x5e51b8a3bb09d303ea7c86051582fd600fb3dc1a\":\"0x1158e460913d00000\",\"0x5e58e255fc19870a04305ff2a04631f2ff294bb1\":\"0xf43fc2c04ee00000\",\"0x5e5a441974a83d74c687ebdc633fb1a49e7b1ad7\":\"0xa2a15d09519be00000\",\"0x5e65458be964ae449f71773704979766f8898761\":\"0x1ca7cc735b6f7c0000\",\"0x5e67df8969101adabd91accd6bb1991274af8df2\":\"0x1b1ae4d6e2ef500000\",\"0x5e6e9747e162f8b45c656e0f6cae7a84bac80e4e\":\"0x6c6b935b8bbd400000\",\"0x5e731b55ced452bb3f3fe871ddc3ed7ee6510a8f\":\"0xa2a15d09519be00000\",\"0x5e74ed80e9655788e1bb269752319667fe754e5a\":\"0x30927f74c9de00000\",\"0x5e772e27f28800c50dda973bb33e10762e6eea20\":\"0x61093d7c2c6d380000\",\"0x5e7b8c54dc57b0402062719dee7ef5e37ea35d62\":\"0x9bf9810fd05c840000\",\"0x5e7f70378775589fc66a81d3f653e954f55560eb\":\"0x83f289181d84c80000\",\"0x5e806e845730f8073e6cc9018ee90f5c05f909a3\":\"0x201e96dacceaf200000\",\"0x5e8e4df18cf0af770978a8df8dac90931510a679\":\"0x6c6b935b8bbd400000\",\"0x5e90c85877198756b0366c0e17b28e52b446505a\":\"0x144a4a18efeb680000\",\"0x5e95fe5ffcf998f9f9ac0e9a81dab83ead77003d\":\"0x1d42c20d32797f0000\",\"0x5ead29037a12896478b1296ab714e9cb95428c81\":\"0x3e043072d406e0000\",\"0x5eb371c407406c427b3b7de271ad3c1e04269579\":\"0xa2a15d09519be00000\",\"0x5ecdbaeab9106ffe5d7b519696609a05baeb85ad\":\"0x1158e460913d00000\",\"0x5ed0d6338559ef44dc7a61edeb893fa5d83fa1b5\":\"0xbed1d0263d9f00000\",\"0x5ed3bbc05240e0d399eb6ddfe60f62de4d9509af\":\"0x2914c02475f9d6d30000\",\"0x5ed3f1ebe2ae6756b5d8dc19cad02c419aa5778b\":\"0x0\",\"0x5ed56115bd6505a88273df5c56839470d24a2db7\":\"0x38e6591ee56668000\",\"0x5ef8c96186b37984cbfe04c598406e3b0ac3171f\":\"0x1fd933494aa5fe00000\",\"0x5efbdfe5389999633c26605a5bfc2c1bb5959393\":\"0x3c057c95cd9080000\",\"0x5f13154631466dcb1353c890932a7c97e0878e90\":\"0x14542ba12a337c00000\",\"0x5f167aa242bc4c189adecb3ac4a7c452cf192fcf\":\"0x6c6b4c4da6ddbe0000\",\"0x5f1c8a04c90d735b8a152909aeae636fb0ce1665\":\"0x17b7827618c5a370000\",\"0x5f23ba1f37a96c45bc490259538a54c28ba3b0d5\":\"0x410d586a20a4c00000\",\"0x5f26cf34599bc36ea67b9e7a9f9b4330c9d542a3\":\"0x3635c9adc5dea00000\",\"0x5f29c9de765dde25852af07d33f2ce468fd20982\":\"0x6c6b935b8bbd400000\",\"0x5f2f07d2d697e8c567fcfdfe020f49f360be2139\":\"0x6c6b935b8bbd400000\",\"0x5f321b3daaa296cadf29439f9dab062a4bffedd6\":\"0x47025903ea7ae0000\",\"0x5f333a3b2310765a0d1832b9be4c0a03704c1c09\":\"0x3635c9adc5dea00000\",\"0x5f344b01c7191a32d0762ac188f0ec2dd460911d\":\"0x3635c9adc5dea00000\",\"0x5f363e0ab747e02d1b3b66abb69ea53c7baf523a\":\"0x277017338a30ae00000\",\"0x5f375b86600c40cca8b2676b7a1a1d1644c5f52c\":\"0x44618d74c623f0000\",\"0x5f3e1e6739b0c62200e00a003691d9efb238d89f\":\"0xa2a15d09519be00000\",\"0x5f483ffb8f680aedf2a38f7833afdcde59b61e4b\":\"0x6c6b935b8bbd400000\",\"0x5f4ace4c1cc13391e01f00b198e1f20b5f91cbf5\":\"0x10f0fa8b9d3811a0000\",\"0x5f521282e9b278dc8c034c72af53ee29e5443d78\":\"0x161732d2f8f3ae00000\",\"0x5f68a24c7eb4117667737b33393fb3c2148a53b6\":\"0x2cede918d453c0000\",\"0x5f708eaf39d823946c51b3a3e9b7b3c003e26341\":\"0x62a992e53a0af00000\",\"0x5f742e487e3ab81af2f94afdbe1b9b8f5ccc81bc\":\"0x75c445d41163e60000\",\"0x5f74ed0e24ff80d9b2c4a44baa9975428cd6b935\":\"0xa18bcec34888100000\",\"0x5f76f0a306269c78306b3d650dc3e9c37084db61\":\"0x821ab0d44149800000\",\"0x5f77a107ab1226b3f95f10ee83aefc6c5dff3edc\":\"0x1b1ae4d6e2ef500000\",\"0x5f7b3bbac16dab831a4a0fc53b0c549dc36c31ca\":\"0x692ae8897081d00000\",\"0x5f93ff832774db5114c55bb4bf44ccf3b58f903f\":\"0x28a9c91a263458290000\",\"0x5f9616c47b4a67f406b95a14fe6fc268396f1721\":\"0xad78ebc5ac6200000\",\"0x5f981039fcf50225e2adf762752112d1cc26b6e3\":\"0x1b1a416a2153a50000\",\"0x5f99dc8e49e61d57daef606acdd91b4d7007326a\":\"0xa2a15d09519be00000\",\"0x5fa61f152de6123516c751242979285f796ac791\":\"0xb0f11972963b00000\",\"0x5fa7bfe043886127d4011d8356a47e947963aca8\":\"0x62a992e53a0af00000\",\"0x5fa8a54e68176c4fe2c01cf671c515bfbdd528a8\":\"0x45e155fa0110fa400000\",\"0x5fad960f6b2c84569c9f4d47bf1985fcb2c65da6\":\"0x36356633ebd8ea0000\",\"0x5fc6c11426b4a1eae7e51dd512ad1090c6f1a85b\":\"0x93fe5c57d710680000\",\"0x5fcd84546896dd081db1a320bd4d8c1dd1528c4c\":\"0x1158e460913d00000\",\"0x5fcda847aaf8d7fa8bca08029ca2849166aa15a3\":\"0x21cab81259a3bf0000\",\"0x5fd1c3e31778276cb42ea740f5eae9c641dbc701\":\"0xa844a7424d9c80000\",\"0x5fd3d6777ec2620ae83a05528ed425072d3ca8fd\":\"0x6c6b935b8bbd400000\",\"0x5fd973af366aa5157c54659bcfb27cbfa5ac15d6\":\"0xd8d726b7177a800000\",\"0x5fe77703808f823e6c399352108bdb2c527cb87c\":\"0x6a4076cf7995a00000\",\"0x5fec49c665e64ee89dd441ee74056e1f01e92870\":\"0x1569b9e733474c00000\",\"0x5ff326cd60fd136b245e29e9087a6ad3a6527f0d\":\"0x65ea3db75546600000\",\"0x5ff93de6ee054cad459b2d5eb0f6870389dfcb74\":\"0xbed1d0263d9f00000\",\"0x6006e36d929bf45d8f16231b126a011ae283d925\":\"0x98a7d9b8314c00000\",\"0x6021e85a8814fce1e82a41abd1d3b2dad2faefe0\":\"0x6c6b935b8bbd400000\",\"0x6038740ae28d66ba93b0be08482b3205a0f7a07b\":\"0x11216185c29f700000\",\"0x603f2fab7afb6e017b94766069a4b43b38964923\":\"0x59d2db2414da990000\",\"0x6042276df2983fe2bc4759dc1943e18fdbc34f77\":\"0x6acb3df27e1f880000\",\"0x6042c644bae2b96f25f94d31f678c90dc96690db\":\"0x6c6b935b8bbd400000\",\"0x604cdf18628dbfa8329194d478dd5201eecc4be7\":\"0x13f306a2409fc0000\",\"0x604e9477ebf4727c745bcabbedcb6ccf29994022\":\"0x36369ed7747d260000\",\"0x60676d1fa21fca052297e24bf96389c5b12a70d7\":\"0xd177c5a7a68d60000\",\"0x60676e92d18b000509c61de540e6c5ddb676d509\":\"0x410d586a20a4c00000\",\"0x606f177121f7855c21a5062330c8762264a97b31\":\"0xd8d726b7177a800000\",\"0x60864236930d04d8402b5dcbeb807f3caf611ea2\":\"0xd8d726b7177a800000\",\"0x60ab71cd26ea6d6e59a7a0f627ee079c885ebbf6\":\"0x1731790534df20000\",\"0x60af0ee118443c9b37d2fead77f5e521debe1573\":\"0x678a932062e4180000\",\"0x60b358cb3dbefa37f47df2d7365840da8e3bc98c\":\"0x1158e460913d00000\",\"0x60b8d6b73b79534fb08bb8cbcefac7f393c57bfe\":\"0x5f68e8131ecf800000\",\"0x60be6f953f2a4d25b6256ffd2423ac1438252e4e\":\"0x821ab0d4414980000\",\"0x60c3714fdddb634659e4a2b1ea42c4728cc7b8ba\":\"0xb98bc829a6f90000\",\"0x60cc3d445ebdf76a7d7ae571c6971dff68cc8585\":\"0x3635c9adc5dea00000\",\"0x60d5667140d12614b21c8e5e8a33082e32dfcf23\":\"0x43c33c1937564800000\",\"0x60de22a1507432a47b01cc68c52a0bf8a2e0d098\":\"0x10910d4cdc9f60000\",\"0x60e0bdd0a259bb9cb09d3f37e5cd8b9daceabf8a\":\"0x4a4491bd6dcd280000\",\"0x60e3cc43bcdb026aad759c7066f555bbf2ac66f5\":\"0x6c6b935b8bbd400000\",\"0x61042b80fd6095d1b87be2f00f109fabafd157a6\":\"0x56bc75e2d63100000\",\"0x6107d71dd6d0eefb11d4c916404cb98c753e117d\":\"0x6c6b935b8bbd400000\",\"0x610fd6ee4eebab10a8c55d0b4bd2e7d6ef817156\":\"0x1159561065d5d0000\",\"0x6114b0eae5576903f80bfb98842d24ed92237f1e\":\"0x56bc75e2d63100000\",\"0x6121af398a5b2da69f65c6381aec88ce9cc6441f\":\"0x22b1c8c1227a000000\",\"0x612667f172135b950b2cd1de10afdece6857b873\":\"0x3635c9adc5dea00000\",\"0x612ced8dc0dc9e899ee46f7962333315f3f55e44\":\"0x125e35f9cd3d9b0000\",\"0x6134d942f037f2cc3d424a230c603d67abd3edf7\":\"0x6c6b935b8bbd400000\",\"0x613ac53be565d46536b820715b9b8d3ae68a4b95\":\"0xcbd47b6eaa8cc00000\",\"0x613fab44b16bbe554d44afd178ab1d02f37aeaa5\":\"0x6c6b935b8bbd400000\",\"0x614e8bef3dd2c59b59a4145674401018351884ea\":\"0x1158e460913d00000\",\"0x61518464fdd8b73c1bb6ac6db600654938dbf17a\":\"0xad78ebc5ac6200000\",\"0x61547d376e5369bcf978fc162c3c56ae453547e8\":\"0xad78ebc5ac6200000\",\"0x6158e107c5eb54cb7604e0cd8dc1e07500d91c3c\":\"0x2b5e3af16b1880000\",\"0x615a6f36777f40d6617eb5819896186983fd3731\":\"0x14061b9d77a5e980000\",\"0x615f82365c5101f071e7d2cb6af14f7aad2c16c6\":\"0x1158e460913d00000\",\"0x6170dd0687bd55ca88b87adef51cfdc55c4dd458\":\"0x6cb32f5c34fe440000\",\"0x61733947fab820dbd351efd67855ea0e881373a0\":\"0x1158e460913d00000\",\"0x6179979907fe7f037e4c38029d60bcbab832b3d6\":\"0x57473d05dabae80000\",\"0x617f20894fa70e94a86a49cd74e03238f64d3cd9\":\"0x10f0dbae61009528000\",\"0x617ff2cc803e31c9082233b825d025be3f7b1056\":\"0x6acb3df27e1f880000\",\"0x6191ddc9b64a8e0890b4323709d7a07c48b92a64\":\"0x2a034919dfbfbc0000\",\"0x6196c3d3c0908d254366b7bca55745222d9d4db1\":\"0xd8d726b7177a800000\",\"0x619f171445d42b02e2e07004ad8afe694fa53d6a\":\"0x1158e460913d00000\",\"0x61adf5929a5e2981684ea243baa01f7d1f5e148a\":\"0x5fabf6c984f230000\",\"0x61b1b8c012cd4c78f698e470f90256e6a30f48dd\":\"0xad78ebc5ac6200000\",\"0x61b3df2e9e9fd968131f1e88f0a0eb5bd765464d\":\"0xd8d726b7177a800000\",\"0x61b902c5a673885826820d1fe14549e4865fbdc2\":\"0x1224efed2ae1918000\",\"0x61b905de663fc17386523b3a28e2f7d037a655cd\":\"0x1b1ae4d6e2ef500000\",\"0x61ba87c77e9b596de7ba0e326fddfeec2163ef66\":\"0xad78ebc5ac6200000\",\"0x61bf84d5ab026f58c873f86ff0dfca82b55733ae\":\"0x6c6b935b8bbd400000\",\"0x61c4ee7c864c4d6b5e37ea1331c203739e826b2f\":\"0x1a1353b382a918000\",\"0x61c830f1654718f075ccaba316faacb85b7d120b\":\"0x15af1d78b58c400000\",\"0x61c8f1fa43bf846999ecf47b2b324dfb6b63fe3a\":\"0x2b5e3af16b18800000\",\"0x61c9dce8b2981cb40e98b0402bc3eb28348f03ac\":\"0xaacacd9b9e22b0000\",\"0x61cea71fa464d62a07063f920b0cc917539733d8\":\"0x5a87e7d7f5f6580000\",\"0x61d101a033ee0e2ebb3100ede766df1ad0244954\":\"0x1b1ae4d6e2ef500000\",\"0x61ed5596c697207f3d55b2a51aa7d50f07fa09e8\":\"0x6c6b935b8bbd400000\",\"0x61ff8e67b34d9ee6f78eb36ffea1b9f7c15787af\":\"0x58e7926ee858a00000\",\"0x6205c2d5647470848a3840f3887e9b015d34755c\":\"0x6194049f30f7200000\",\"0x6228ade95e8bb17d1ae23bfb0518414d497e0eb8\":\"0x15af1d78b58c400000\",\"0x6229dcc203b1edccfdf06e87910c452a1f4d7a72\":\"0x6e1d41a8f9ec3500000\",\"0x622be4b45495fcd93143efc412d699d6cdc23dc5\":\"0xf015f25736420000\",\"0x62331df2a3cbee3520e911dea9f73e905f892505\":\"0x6c6b935b8bbd400000\",\"0x625644c95a873ef8c06cdb9e9f6d8d7680043d62\":\"0x6194049f30f7200000\",\"0x6265b2e7730f36b776b52d0c9d02ada55d8e3cb6\":\"0x3635c9adc5dea00000\",\"0x62680a15f8ccb8bdc02f7360c25ad8cfb57b8ccd\":\"0x3635c9adc5dea00000\",\"0x6294eae6e420a3d5600a39c4141f838ff8e7cc48\":\"0xa030dcebbd2f4c0000\",\"0x62971bf2634cee0be3c9890f51a56099dbb9519b\":\"0x238fd42c5cf0400000\",\"0x629be7ab126a5398edd6da9f18447e78c692a4fd\":\"0x6c6b935b8bbd400000\",\"0x62b4a9226e61683c72c183254690daf511b4117a\":\"0xe18398e7601900000\",\"0x62b9081e7710345e38e02e16449ace1b85bcfc4e\":\"0x3154c9729d05780000\",\"0x62c37c52b97f4b040b1aa391d6dec152893c4707\":\"0x3635c9adc5dea00000\",\"0x62c9b271ffd5b770a5eee4edc9787b5cdc709714\":\"0x6c6b935b8bbd400000\",\"0x62d5cc7117e18500ac2f9e3c26c86b0a94b0de15\":\"0x5b12aefafa8040000\",\"0x62dc72729024375fc37cbb9c7c2393d10233330f\":\"0x6c6b935b8bbd400000\",\"0x62e6b2f5eb94fa7a43831fc87e254a3fe3bf8f89\":\"0xd8d726b7177a80000\",\"0x62f2e5ccecd52cc4b95e0597df27cc079715608c\":\"0x7c0860e5a80dc0000\",\"0x62fb8bd1f0e66b90533e071e6cbe6111fef0bc63\":\"0x3ba1910bf341b000000\",\"0x630a913a9031c9492abd4c41dbb15054cfec4416\":\"0x13458db67af35e00000\",\"0x630c5273126d517ce67101811cab16b8534cf9a8\":\"0x1feccc62573bbd38000\",\"0x631030a5b27b07288a45696f189e1114f12a81c0\":\"0x1b1a7a420ba00d0000\",\"0x6310b020fd98044957995092090f17f04e52cdfd\":\"0x55a6e79ccd1d300000\",\"0x632b9149d70178a7333634275e82d5953f27967b\":\"0x25f273933db5700000\",\"0x632cecb10cfcf38ec986b43b8770adece9200221\":\"0x1158e460913d00000\",\"0x6331028cbb5a21485bc51b565142993bdb2582a9\":\"0x1cfdd7468216e80000\",\"0x63334fcf1745840e4b094a3bb40bb76f9604c04c\":\"0xd7a5d703a717e80000\",\"0x63340a57716bfa63eb6cd133721202575bf796f0\":\"0xb61e0a20c12718000\",\"0x634efc24371107b4cbf03f79a93dfd93e431d5fd\":\"0x423582e08edc5c8000\",\"0x635c00fdf035bca15fa3610df3384e0fb79068b1\":\"0x1e7e4171bf4d3a00000\",\"0x63612e7862c27b587cfb6daf9912cb051f030a9f\":\"0x25b19d4bfe8ed0000\",\"0x63666755bd41b5986997783c13043008242b3cb5\":\"0x1b1ae4d6e2ef500000\",\"0x637be71b3aa815ff453d5642f73074450b64c82a\":\"0x6c6b935b8bbd400000\",\"0x637d67d87f586f0a5a479e20ee13ea310a10b647\":\"0xa3a5926afa1e7300000\",\"0x637f5869d6e4695f0eb9e27311c4878aff333380\":\"0x6ac04e68aaec860000\",\"0x63977cad7d0dcdc52b9ac9f2ffa136e8642882b8\":\"0x410d586a20a4c0000\",\"0x63a61dc30a8e3b30a763c4213c801cbf98738178\":\"0x3635c9adc5dea00000\",\"0x63ac545c991243fa18aec41d4f6f598e555015dc\":\"0x2086ac351052600000\",\"0x63b9754d75d12d384039ec69063c0be210d5e0e3\":\"0x920b860cc8ecfd8000\",\"0x63bb664f9117037628594da7e3c5089fd618b5b5\":\"0x1158e460913d00000\",\"0x63c2a3d235e5eeabd0d4a6afdb89d94627396495\":\"0x434ef05b9d84820000\",\"0x63c8dfde0b8e01dadc2e748c824cc0369df090b3\":\"0xd255d112e103a00000\",\"0x63d55ad99b9137fd1b20cc2b4f03d42cbaddf334\":\"0x15af1d78b58c400000\",\"0x63d80048877596e0c28489e650cd4ac180096a49\":\"0xf2dc7d47f15600000\",\"0x63e414603e80d4e5a0f5c18774204642258208e4\":\"0x10f0cf064dd59200000\",\"0x63e88e2e539ffb450386b4e46789b223f5476c45\":\"0x155170a778e25d00000\",\"0x63ef2fbc3daf5edaf4a295629ccf31bcdf4038e5\":\"0x4f2591f896a6500000\",\"0x63f0e5a752f79f67124eed633ad3fd2705a397d4\":\"0xd5967be4fc3f100000\",\"0x63f5b53d79bf2e411489526530223845fac6f601\":\"0x65a4da25d3016c00000\",\"0x63fc93001305adfbc9b85d29d9291a05f8f1410b\":\"0x3635c9adc5dea00000\",\"0x63fe6bcc4b8a9850abbe75803730c932251f145b\":\"0xfc936392801c0000\",\"0x6403d062549690c8e8b63eae41d6c109476e2588\":\"0x6c6b935b8bbd400000\",\"0x64042ba68b12d4c151651ca2813b7352bd56f08e\":\"0x2086ac351052600000\",\"0x6405dd13e93abcff377e700e3c1a0086eca27d29\":\"0xfc936392801c0000\",\"0x640aba6de984d94517377803705eaea7095f4a11\":\"0x21e19e0c9bab2400000\",\"0x640bf87415e0cf407301e5599a68366da09bbac8\":\"0x1abc9f416098158000\",\"0x6420f8bcc8164a6152a99d6b99693005ccf7e053\":\"0x36356633ebd8ea0000\",\"0x64241a7844290e0ab855f1d4aa75b55345032224\":\"0x56bc75e2d631000000\",\"0x64264aedd52dcae918a012fbcd0c030ee6f71821\":\"0x3635c9adc5dea00000\",\"0x64370e87202645125a35b207af1231fb6072f9a7\":\"0xad78ebc5ac6200000\",\"0x643d9aeed4b180947ed2b9207cce4c3ddc55e1f7\":\"0xad78ebc5ac6200000\",\"0x6443b8ae639de91cf73c5ae763eeeed3ddbb9253\":\"0x6c6b935b8bbd400000\",\"0x64457fa33b0832506c4f7d1180dce48f46f3e0ff\":\"0x6c6b935b8bbd400000\",\"0x64464a6805b462412a901d2db8174b06c22deea6\":\"0x19c846a029c7c80000\",\"0x644ba6c61082e989109f5c11d4b40e991660d403\":\"0xd8d726b7177a800000\",\"0x64628c6fb8ec743adbd87ce5e018d531d9210437\":\"0x1731790534df20000\",\"0x6463f715d594a1a4ace4bb9c3b288a74decf294d\":\"0x6acb3df27e1f880000\",\"0x646628a53c2c4193da88359ce718dadd92b7a48d\":\"0xad8006c2f5ef00000\",\"0x64672da3ab052821a0243d1ce4b6e0a36517b8eb\":\"0xad78ebc5ac6200000\",\"0x646afba71d849e80c0ed59cac519b278e7f7abe4\":\"0x3635c9adc5dea00000\",\"0x646e043d0597a664948fbb0dc15475a3a4f3a6ed\":\"0x1158e460913d00000\",\"0x6470a4f92ec6b0fccd01234fa59023e9ff1f3aac\":\"0xa2a15d09519be00000\",\"0x647b85044df2cf0b4ed4882e88819fe22ae5f793\":\"0x36363b5d9a77700000\",\"0x6485470e61db110aebdbafd536769e3c599cc908\":\"0x2086ac351052600000\",\"0x648f5bd2a2ae8902db37847d1cb0db9390b06248\":\"0x1a535ecf0760a048000\",\"0x649a2b9879cd8fb736e6703b0c7747849796f10f\":\"0x18ee22da01ad34f0000\",\"0x649a85b93653075fa6562c409a565d087ba3e1ba\":\"0x6c6b935b8bbd400000\",\"0x64adcceec53dd9d9dd15c8cc1a9e736de4241d2c\":\"0x30927f74c9de00000\",\"0x64cf0935bf19d2cebbecd8780d27d2e2b2c34166\":\"0x6acb3df27e1f880000\",\"0x64d80c3b8ba68282290b75e65d8978a15a87782c\":\"0x6acb3df27e1f880000\",\"0x64dba2d6615b8bd7571836dc75bc79d314f5ecee\":\"0x21e19e0c9bab2400000\",\"0x64e0217a5b38aa40583625967fa9883690388b6f\":\"0xad78ebc5ac6200000\",\"0x64e02abb016cc23a2934f6bcddb681905021d563\":\"0x3635c9adc5dea00000\",\"0x64e03ef070a54703b7184e48276c5c0077ef4b34\":\"0x1158e460913d000000\",\"0x64e2de21200b1899c3a0c0653b5040136d0dc842\":\"0x43c33c1937564800000\",\"0x64ec8a5b743f3479e707dae9ee20ddaa4f40f1d9\":\"0xad78ebc5ac6200000\",\"0x6503860b191008c15583bfc88158099301762828\":\"0x3635c9adc5dea00000\",\"0x65053191319e067a25e6361d47f37f6318f83419\":\"0x155bd9307f9fe80000\",\"0x65093b239bbfba23c7775ca7da5a8648a9f54cf7\":\"0x15af1d78b58c400000\",\"0x6509eeb1347e842ffb413e37155e2cbc738273fd\":\"0x6c6b935b8bbd400000\",\"0x650b425555e4e4c51718146836a2c1ee77a5b421\":\"0x43c33c1937564800000\",\"0x650cf67db060cce17568d5f2a423687c49647609\":\"0x56bc75e2d63100000\",\"0x6510df42a599bcb0a519cca961b488759a6f6777\":\"0x6c6b935b8bbd400000\",\"0x653675b842d7d8b461f722b4117cb81dac8e639d\":\"0x1ae361fc1451c0000\",\"0x654b7e808799a83d7287c67706f2abf49a496404\":\"0x6acb3df27e1f880000\",\"0x654f524847b3a6acc0d3d5f1f362b603edf65f96\":\"0x1b1ae4d6e2ef5000000\",\"0x655934da8e744eaa3de34dbbc0894c4eda0b61f2\":\"0xad78ebc5ac6200000\",\"0x655d5cd7489629e2413c2105b5a172d933c27af8\":\"0xdb03186cd840a60000\",\"0x656018584130db83ab0591a8128d9381666a8d0e\":\"0x3779f912019fc0000\",\"0x6560941328ff587cbc56c38c78238a7bb5f442f6\":\"0x2861906b59c47a0000\",\"0x656579daedd29370d9b737ee3f5cd9d84bc2b342\":\"0x4d853c8f8908980000\",\"0x657473774f63ac3d6279fd0743d5790c4f161503\":\"0xad78ebc5ac6200000\",\"0x6580b1bc94390f04b397bd73e95d96ef11eaf3a8\":\"0x1158e460913d00000\",\"0x65849be1af20100eb8a3ba5a5be4d3ae8db5a70e\":\"0x15af1d78b58c400000\",\"0x659c0a72c767a3a65ced0e1ca885a4c51fd9b779\":\"0x6c6b935b8bbd400000\",\"0x65a52141f56bef98991724c6e7053381da8b5925\":\"0x3429c335d57fe0000\",\"0x65a9dad42e1632ba3e4e49623fab62a17e4d3611\":\"0x50c4cb2a10c600000\",\"0x65af8d8b5b1d1eedfa77bcbc96c1b133f83306df\":\"0x55005f0c614480000\",\"0x65af9087e05167715497c9a5a749189489004def\":\"0x2d43f3ebfafb2c0000\",\"0x65b42faecc1edfb14283ca979af545f63b30e60c\":\"0xfc936392801c0000\",\"0x65d33eb39cda6453b19e61c1fe4db93170ef9d34\":\"0xb98bc829a6f90000\",\"0x65d8dd4e251cbc021f05b010f2d5dc520c3872e0\":\"0x2d43579a36a90e0000\",\"0x65ea26eabbe2f64ccccfe06829c25d4637520225\":\"0x25f273933db5700000\",\"0x65ea67ad3fb56ad5fb94387dd38eb383001d7c68\":\"0x56bc75e2d63100000\",\"0x65ebaed27edb9dcc1957aee5f452ac2105a65c0e\":\"0x937dfadae25e29b8000\",\"0x65ee20b06d9ad589a7e7ce04b9f5f795f402aece\":\"0x6c6b935b8bbd400000\",\"0x65f534346d2ffb787fa9cf185d745ba42986bd6e\":\"0x1b1ae4d6e2ef500000\",\"0x65f5870f26bce089677dfc23b5001ee492483428\":\"0x112b1f155aa32a30000\",\"0x65fd02d704a12a4dace9471b0645f962a89671c8\":\"0x18d1ce6e427cd8000\",\"0x65ff874fafce4da318d6c93d57e2c38a0d73e820\":\"0x3638021cecdab00000\",\"0x660557bb43f4be3a1b8b85e7df7b3c5bcd548057\":\"0x14542ba12a337c00000\",\"0x66082c75a8de31a53913bbd44de3a0374f7faa41\":\"0x4f2591f896a6500000\",\"0x6611ce59a98b072ae959dc49ad511daaaaa19d6b\":\"0xad78ebc5ac6200000\",\"0x66201bd227ae6dc6bdfed5fbde811fecfe5e9dd9\":\"0x203e9e8492788c0000\",\"0x662334814724935b7931ddca6100e00d467727cd\":\"0x2288269d0783d40000\",\"0x66274fea82cd30b6c29b23350e4f4f3d310a5899\":\"0x70370550ab82980000\",\"0x662cfa038fab37a01745a364e1b98127c503746d\":\"0xd5967be4fc3f100000\",\"0x6635b46f711d2da6f0e16370cd8ee43efb2c2d52\":\"0x6c6b935b8bbd400000\",\"0x663604b0503046e624cd26a8b6fb4742dce02a6f\":\"0x38b9b797ef68c0000\",\"0x6636d7ac637a48f61d38b14cfd4865d36d142805\":\"0x1b1ae4d6e2ef500000\",\"0x6640ccf053555c130ae2b656647ea6e31637b9ab\":\"0x6acb3df27e1f880000\",\"0x66424bd8785b8cb461102a900283c35dfa07ef6a\":\"0x22e2db26666fc8000\",\"0x664cd67dccc9ac8228b45c55db8d76550b659cdc\":\"0x155bd9307f9fe80000\",\"0x664e43119870af107a448db1278b044838ffcdaf\":\"0x15af1d78b58c400000\",\"0x6651736fb59b91fee9c93aa0bd6ea2f7b2506180\":\"0x1b1ae4d6e2ef500000\",\"0x665b000f0b772750cc3c217a5ef429a92bf1ccbb\":\"0xd8d726b7177a800000\",\"0x66662006015c1f8e3ccfcaebc8ee6807ee196303\":\"0x1b1b3a1ac261ec0000\",\"0x666746fb93d1935c5a3c684e725010c4fad0b1d8\":\"0x1158e460913d00000\",\"0x666b4f37d55d63b7d056b615bb74c96b3b01991a\":\"0xd8d726b7177a800000\",\"0x66719c0682b2ac7f9e27abebec7edf8decf0ae0d\":\"0x1158e460913d00000\",\"0x6671b182c9f741a0cd3c356c73c23126d4f9e6f4\":\"0xad78ebc5ac6200000\",\"0x6679aeecd87a57a73f3356811d2cf49d0c4d96dc\":\"0x2086ac351052600000\",\"0x667b61c03bb937a9f5d0fc5a09f1ea3363c77035\":\"0xe664992288f2280000\",\"0x6685fd2e2544702c360b8bb9ee78f130dad16da5\":\"0x6c6b935b8bbd400000\",\"0x668b6ba8ab08eace39c502ef672bd5ccb6a67a20\":\"0x697d95d4201333c0000\",\"0x66925de3e43f4b41bf9dadde27d5488ef569ea0d\":\"0x222c8eb3ff6640000\",\"0x66b0c100c49149935d14c0dc202cce907cea1a3d\":\"0x6acb3df27e1f880000\",\"0x66b1a63da4dcd9f81fe54f5e3fcb4055ef7ec54f\":\"0xaeb272adf9cfa0000\",\"0x66b39837cb3cac8a802afe3f12a258bbca62dacd\":\"0x15af1d78b58c400000\",\"0x66c8331efe7198e98b2d32b938688e3241d0e24f\":\"0x2098051970e39d00000\",\"0x66cc8ab23c00d1b82acd7d73f38c99e0d05a4fa6\":\"0x56bc75e2d63100000\",\"0x66dcc5fb4ee7fee046e141819aa968799d644491\":\"0x487a9a304539440000\",\"0x66e09427c1e63deed7e12b8c55a6a19320ef4b6a\":\"0x93739534d28680000\",\"0x66ec16ee9caab411c55a6629e318de6ee216491d\":\"0x2ee449550898e40000\",\"0x66f50406eb1b11a946cab45927cca37470e5a208\":\"0x6c6b935b8bbd400000\",\"0x66fdc9fee351fa1538eb0d87d819fcf09e7c106a\":\"0x14627b5d93781b20000\",\"0x67048f3a12a4dd1f626c64264cb1d7971de2ca38\":\"0x9c2007651b2500000\",\"0x6704f169e0d0b36b57bbc39f3c45437b5ee3d28d\":\"0x155bd9307f9fe80000\",\"0x671015b97670b10d5e583f3d62a61c1c79c5143f\":\"0x15af1d78b58c400000\",\"0x6710c2c03c65992b2e774be52d3ab4a6ba217ef7\":\"0x274d656ac90e3400000\",\"0x671110d96aaff11523cc546bf9940eedffb2faf7\":\"0xd8d726b7177a800000\",\"0x6715c14035fb57bb3d667f7b707498c41074b855\":\"0x25f273933db5700000\",\"0x671bbca099ff899bab07ea1cf86965c3054c8960\":\"0x2b5e3af16b1880000\",\"0x6727daf5b9d68efcab489fedec96d7f7325dd423\":\"0x6c6b935b8bbd400000\",\"0x672cbca8440a8577097b19aff593a2ad9d28a756\":\"0x4563918244f400000\",\"0x672ec42faa8cd69aaa71b32cc7b404881d52ff91\":\"0x21e19e0c9bab2400000\",\"0x672fa0a019088db3166f6119438d07a99f8ba224\":\"0x2d4ca05e2b43ca80000\",\"0x673144f0ec142e770f4834fee0ee311832f3087b\":\"0x1b1b6bd7af64c70000\",\"0x67350b5331926f5e28f3c1e986f96443809c8b8c\":\"0x1314fb370629800000\",\"0x673706b1b0e4dc7a949a7a796258a5b83bb5aa83\":\"0x368c8623a8b4d100000\",\"0x6742a2cfce8d79a2c4a51b77747498912245cd6a\":\"0xdfd5b80b7e4680000\",\"0x674adb21df4c98c7a347ac4c3c24266757dd7039\":\"0x6c6b935b8bbd400000\",\"0x67518e5d02b205180f0463a32004471f753c523e\":\"0x6b918aac494b168000\",\"0x675d5caa609bf70a18aca580465d8fb7310d1bbb\":\"0x43c33c1937564800000\",\"0x67632046dcb25a54936928a96f423f3320cbed92\":\"0x6c6b935b8bbd400000\",\"0x6765df25280e8e4f38d4b1cf446fc5d7eb659e34\":\"0x56bc75e2d63100000\",\"0x6776e133d9dc354c12a951087b639650f539a433\":\"0x68155a43676e00000\",\"0x6785513cf732e47e87670770b5419be10cd1fc74\":\"0x6c6b935b8bbd400000\",\"0x679437eacf437878dc293d48a39c87b7421a216c\":\"0x37f81821db2680000\",\"0x679b9a109930517e8999099ccf2a914c4c8dd934\":\"0x340aad21b3b700000\",\"0x67a80e0190721f94390d6802729dd12c31a895ad\":\"0x6c6b1375bc91560000\",\"0x67b8a6e90fdf0a1cac441793301e8750a9fa7957\":\"0x30849ebe16369c0000\",\"0x67bc85e87dc34c4e80aafa066ba8d29dbb8e438e\":\"0x15d1cf4176aeba0000\",\"0x67c926093e9b8927933810d98222d62e2b8206bb\":\"0x678a932062e4180000\",\"0x67cfda6e70bf7657d39059b59790e5145afdbe61\":\"0x23050d095866580000\",\"0x67d682a282ef73fb8d6e9071e2614f47ab1d0f5e\":\"0x3635c9adc5dea00000\",\"0x67d6a8aa1bf8d6eaf7384e993dfdf10f0af68a61\":\"0xabcbb5718974b8000\",\"0x67da922effa472a6b124e84ea8f86b24e0f515aa\":\"0x1158e460913d00000\",\"0x67df242d240dd4b8071d72f8fcf35bb3809d71e8\":\"0xd8d726b7177a800000\",\"0x67ee406ea4a7ae6a3a381eb4edd2f09f174b4928\":\"0x3829635f0968b00000\",\"0x67f2bb78b8d3e11f7c458a10b5c8e0a1d374467d\":\"0x61093d7c2c6d380000\",\"0x67fc527dce1785f0fb8bc7e518b1c669f7ecdfb5\":\"0xd02ab486cedc00000\",\"0x68027d19558ed7339a08aee8de3559be063ec2ea\":\"0x6c6b935b8bbd400000\",\"0x680640838bd07a447b168d6d923b90cf6c43cdca\":\"0x5dc892aa1131c80000\",\"0x6807ddc88db489b033e6b2f9a81553571ab3c805\":\"0x19f8e7559924c0000\",\"0x680d5911ed8dd9eec45c060c223f89a7f620bbd5\":\"0x43c33c1937564800000\",\"0x6811b54cd19663b11b94da1de2448285cd9f68d9\":\"0x3ba1910bf341b00000\",\"0x68190ca885da4231874c1cfb42b1580a21737f38\":\"0xcf152640c5c8300000\",\"0x682897bc4f8e89029120fcffb787c01a93e64184\":\"0x21e19e0c9bab2400000\",\"0x68295e8ea5afd9093fc0a465d157922b5d2ae234\":\"0x1154e53217ddb0000\",\"0x682e96276f518d31d7e56e30dfb009c1218201bd\":\"0x1158e460913d00000\",\"0x6835c8e8b74a2ca2ae3f4a8d0f6b954a3e2a8392\":\"0x3429c335d57fe0000\",\"0x683633010a88686bea5a98ea53e87997cbf73e69\":\"0x56b394263a40c0000\",\"0x683dba36f7e94f40ea6aea0d79b8f521de55076e\":\"0x796e3ea3f8ab00000\",\"0x68419c6dd2d3ce6fcbb3c73e2fa079f06051bde6\":\"0x6acb3df27e1f880000\",\"0x68473b7a7d965904bedba556dfbc17136cd5d434\":\"0x56bc75e2d63100000\",\"0x6847825bdee8240e28042c83cad642f286a3bddc\":\"0x5150ae84a8cdf00000\",\"0x684a44c069339d08e19a75668bdba303be855332\":\"0xed2b525841adfc00000\",\"0x68531f4dda808f5320767a03113428ca0ce2f389\":\"0x10d3aa536e2940000\",\"0x687927e3048bb5162ae7c15cf76bd124f9497b9e\":\"0x6c6b935b8bbd400000\",\"0x68809af5d532a11c1a4d6e32aac75c4c52b08ead\":\"0x21e19e0c9bab2400000\",\"0x6886ada7bbb0617bda842191c68c922ea3a8ac82\":\"0x3ee23bde0e7d200000\",\"0x68883e152e5660fee59626e7e3b4f05110e6222f\":\"0xb94633be975a62a0000\",\"0x688a569e965524eb1d0ac3d3733eab909fb3d61e\":\"0x478eae0e571ba00000\",\"0x688eb3853bbcc50ecfee0fa87f0ab693cabdef02\":\"0x6b10a18400647c00000\",\"0x68a7425fe09eb28cf86eb1793e41b211e57bd68d\":\"0x243d4d18229ca20000\",\"0x68a86c402388fddc59028fec7021e98cbf830eac\":\"0x10910d4cdc9f60000\",\"0x68acdaa9fb17d3c309911a77b05f5391fa034ee9\":\"0x1e52e336cde22180000\",\"0x68addf019d6b9cab70acb13f0b3117999f062e12\":\"0x2b51212e6b7c88000\",\"0x68b31836a30a016ada157b638ac15da73f18cfde\":\"0x168d28e3f00280000\",\"0x68b6854788a7c6496cdbf5f84b9ec5ef392b78bb\":\"0x42bf06b78ed3b500000\",\"0x68c08490c89bf0d6b6f320b1aca95c8312c00608\":\"0xd8d726b7177a800000\",\"0x68c7d1711b011a33f16f1f55b5c902cce970bdd7\":\"0x83d6c7aab63600000\",\"0x68c8791dc342c373769ea61fb7b510f251d32088\":\"0x3635c9adc5dea00000\",\"0x68df947c495bebaeb8e889b3f953d533874bf106\":\"0x1d9945ab2b03480000\",\"0x68e8022740f4af29eb48db32bcecddfd148d3de3\":\"0x3635c9adc5dea00000\",\"0x68ec79d5be7155716c40941c79d78d17de9ef803\":\"0x1b233877b5208c0000\",\"0x68eec1e288ac31b6eaba7e1fbd4f04ad579a6b5d\":\"0x6c6b935b8bbd400000\",\"0x68f525921dc11c329b754fbf3e529fc723c834cd\":\"0x57473d05dabae80000\",\"0x68f719ae342bd7fef18a05cbb02f705ad38ed5b2\":\"0x38ebad5cdc90280000\",\"0x68f7573cd457e14c03fea43e302d30347c10705c\":\"0x10f0cf064dd59200000\",\"0x68f8f45155e98c5029a4ebc5b527a92e9fa83120\":\"0xf07b44b40793208000\",\"0x68fe1357218d095849cd579842c4aa02ff888d93\":\"0x6c6b935b8bbd400000\",\"0x690228e4bb12a8d4b5e0a797b0c5cf2a7509131e\":\"0x65ea3db75546600000\",\"0x690594d306613cd3e2fd24bca9994ad98a3d73f8\":\"0x6c6b935b8bbd400000\",\"0x69073269729e6414b26ec8dc0fd935c73b579f1e\":\"0x65a4da25d3016c00000\",\"0x6919dd5e5dfb1afa404703b9faea8cee35d00d70\":\"0x14061b9d77a5e980000\",\"0x693492a5c51396a482881669ccf6d8d779f00951\":\"0x12bf50503ae3038000\",\"0x693d83be09459ef8390b2e30d7f7c28de4b4284e\":\"0x6c6b935b8bbd400000\",\"0x69517083e303d4fbb6c2114514215d69bc46a299\":\"0x56bc75e2d63100000\",\"0x695550656cbf90b75d92ad9122d90d23ca68ca4d\":\"0x3635c9adc5dea00000\",\"0x6958f83bb2fdfb27ce0409cd03f9c5edbf4cbedd\":\"0x43c33c1937564800000\",\"0x695b0f5242753701b264a67071a2dc880836b8db\":\"0xe398811bec680000\",\"0x695b4cce085856d9e1f9ff3e79942023359e5fbc\":\"0x10f0cf064dd59200000\",\"0x6966063aa5de1db5c671f3dd699d5abe213ee902\":\"0x1b1ae4d6e2ef5000000\",\"0x6974c8a414ceaefd3c2e4dfdbef430568d9a960b\":\"0x121ea68c114e510000\",\"0x6978696d5150a9a263513f8f74c696f8b1397cab\":\"0x167f482d3c5b1c00000\",\"0x69797bfb12c9bed682b91fbc593591d5e4023728\":\"0x21e19e0c9bab2400000\",\"0x697f55536bf85ada51841f0287623a9f0ed09a17\":\"0x21e19e0c9bab2400000\",\"0x6982fe8a867e93eb4a0bd051589399f2ec9a5292\":\"0x6c6b935b8bbd400000\",\"0x698a8a6f01f9ab682f637c7969be885f6c5302bf\":\"0x10d3aa536e2940000\",\"0x698ab9a2f33381e07c0c47433d0d21d6f336b127\":\"0x1158e460913d00000\",\"0x6994fb3231d7e41d491a9d68d1fa4cae2cc15960\":\"0xd8d726b7177a800000\",\"0x699c9ee47195511f35f862ca4c22fd35ae8ffbf4\":\"0x4563918244f400000\",\"0x699fc6d68a4775573c1dcdaec830fefd50397c4e\":\"0x340aad21b3b700000\",\"0x69af28b0746cac0da17084b9398c5e36bb3a0df2\":\"0x3677036edf0af60000\",\"0x69b80ed90f84834afa3ff82eb964703b560977d6\":\"0x1731790534df20000\",\"0x69b81d5981141ec7a7141060dfcf8f3599ffc63e\":\"0x10f0cf064dd59200000\",\"0x69bcfc1d43b4ba19de7b274bdffb35139412d3d7\":\"0x35659ef93f0fc40000\",\"0x69bd25ade1a3346c59c4e930db2a9d715ef0a27a\":\"0xd8d726b7177a800000\",\"0x69c08d744754de709ce96e15ae0d1d395b3a2263\":\"0x3635c9adc5dea00000\",\"0x69c2d835f13ee90580408e6a3283c8cca6a434a2\":\"0x238fd42c5cf0400000\",\"0x69c94e07c4a9be3384d95dfa3cb9290051873b7b\":\"0x3cb71f51fc5580000\",\"0x69cb3e2153998d86e5ee20c1fcd1a6baeeb2863f\":\"0xd8d726b7177a800000\",\"0x69d39d510889e552a396135bfcdb06e37e387633\":\"0xd8d726b7177a800000\",\"0x69d98f38a3ba3dbc01fa5c2c1427d862832f2f70\":\"0x152d02c7e14af6800000\",\"0x69e2e2e704307ccc5b5ca3f164fece2ea7b2e512\":\"0x17b7883c06916600000\",\"0x69ff429074cb9b6c63bc914284bce5f0c8fbf7d0\":\"0x1b1ae4d6e2ef500000\",\"0x69ff8901b541763f817c5f2998f02dcfc1df2997\":\"0x22b1c8c1227a00000\",\"0x6a023af57d584d845e698736f130db9db40dfa9a\":\"0x55b201c8900980000\",\"0x6a04f5d53fc0f515be942b8f12a9cb7ab0f39778\":\"0xa9aab3459be1940000\",\"0x6a05b21c4f17f9d73f5fb2b0cb89ff5356a6cc7e\":\"0x5150ae84a8cdf00000\",\"0x6a0f056066c2d56628850273d7ecb7f8e6e9129e\":\"0x10f0d293cc7a5880000\",\"0x6a13d5e32c1fd26d7e91ff6e053160a89b2c8aad\":\"0x2e62f20a69be40000\",\"0x6a2e86469a5bf37cee82e88b4c3863895d28fcaf\":\"0x1c229266385bbc0000\",\"0x6a3694424c7cc6b8bcd9bccaba540cc1f5df18d7\":\"0x6c6b935b8bbd400000\",\"0x6a42ca971c6578d5ade295c3e7f4ad331dd3424e\":\"0x14542ba12a337c00000\",\"0x6a44af96b3f032ae641beb67f4b6c83342d37c5d\":\"0x19274b259f6540000\",\"0x6a4c8907b600248057b1e46354b19bdc859c991a\":\"0x1158e460913d00000\",\"0x6a514e6242f6b68c137e97fea1e78eb555a7e5f7\":\"0x1158e460913d00000\",\"0x6a53d41ae4a752b21abed5374649953a513de5e5\":\"0x6c6b935b8bbd400000\",\"0x6a6159074ab573e0ee581f0f3df2d6a594629b74\":\"0x10ce1d3d8cb3180000\",\"0x6a6337833f8f6a6bf10ca7ec21aa810ed444f4cb\":\"0x37bd24345ce8a40000\",\"0x6a6353b971589f18f2955cba28abe8acce6a5761\":\"0xa2a15d09519be00000\",\"0x6a63fc89abc7f36e282d80787b7b04afd6553e71\":\"0x8ac7230489e800000\",\"0x6a679e378fdce6bfd97fe62f043c6f6405d79e99\":\"0xd8d726b7177a800000\",\"0x6a686bf220b593deb9b7324615fb9144ded3f39d\":\"0x4f2591f896a6500000\",\"0x6a6b18a45a76467e2e5d5a2ef911c3e12929857b\":\"0x115d3a99a9614f400000\",\"0x6a74844d8e9cb5581c45079a2e94462a6cee8821\":\"0x3ab53a552dd4c90000\",\"0x6a7b2e0d88867ff15d207c222bebf94fa6ce8397\":\"0xcb49b44ba602d800000\",\"0x6a7c252042e7468a3ff773d6450bba85efa26391\":\"0x1b1ae4d6e2ef500000\",\"0x6a8a4317c45faa0554ccdb482548183e295a24b9\":\"0x3635c9adc5dea00000\",\"0x6a8cea2de84a8df997fd3f84e3083d93de57cda9\":\"0x56be03ca3e47d8000\",\"0x6a9758743b603eea3aa0524b42889723c4153948\":\"0x22385a827e815500000\",\"0x6aa5732f3b86fb8c81efbe6b5b47b563730b06c8\":\"0x3635c9adc5dea00000\",\"0x6ab323ae5056ed0a453072c5abe2e42fcf5d7139\":\"0x2fb474098f67c00000\",\"0x6ab5b4c41cddb829690c2fda7f20c85e629dd5d5\":\"0x64d4af714c32900000\",\"0x6ac40f532dfee5118117d2ad352da77d4f6da2c8\":\"0x15af1d78b58c400000\",\"0x6ac4d4be2db0d99da3faaaf7525af282051d6a90\":\"0x458ca58a962b28000\",\"0x6acddca3cd2b4990e25cd65c24149d0912099e79\":\"0xa2a1e07c9f6c908000\",\"0x6ad90be252d9cd464d998125fab693060ba8e429\":\"0xd8d726b7177a800000\",\"0x6add932193cd38494aa3f03aeccc4b7ab7fabca2\":\"0x4db73254763000000\",\"0x6ae57f27917c562a132a4d1bf7ec0ac785832926\":\"0x14542ba12a337c00000\",\"0x6aeb9f74742ea491813dbbf0d6fcde1a131d4db3\":\"0x17e554308aa0300000\",\"0x6af235d2bbe050e6291615b71ca5829658810142\":\"0xa2a15d09519be00000\",\"0x6af6c7ee99df271ba15bf384c0b764adcb4da182\":\"0x36356633ebd8ea0000\",\"0x6af8e55969682c715f48ad4fc0fbb67eb59795a3\":\"0x6c6b935b8bbd400000\",\"0x6af940f63ec9b8d876272aca96fef65cdacecdea\":\"0xa2a15d09519be00000\",\"0x6af9f0dfeeaebb5f64bf91ab771669bf05295553\":\"0x15af1d78b58c400000\",\"0x6aff1466c2623675e3cb0e75e423d37a25e442eb\":\"0x5dc892aa1131c80000\",\"0x6b0da25af267d7836c226bcae8d872d2ce52c941\":\"0x14542ba12a337c00000\",\"0x6b10f8f8b3e3b60de90aa12d155f9ff5ffb22c50\":\"0x6c6b935b8bbd400000\",\"0x6b17598a8ef54f797ae515ccb6517d1859bf8011\":\"0x56bc75e2d63100000\",\"0x6b20c080606a79c73bd8e75b11717a4e8db3f1c3\":\"0x103f735803f0140000\",\"0x6b2284440221ce16a8382de5ff0229472269deec\":\"0x3635c9adc5dea00000\",\"0x6b30f1823910b86d3acb5a6afc9defb6f3a30bf8\":\"0xe3aeb5737240a00000\",\"0x6b38de841fad7f53fe02da115bd86aaf662466bd\":\"0x5dc892aa1131c80000\",\"0x6b4b99cb3fa9f7b74ce3a48317b1cd13090a1a7a\":\"0x31b327e695de20000\",\"0x6b5ae7bf78ec75e90cb503c778ccd3b24b4f1aaf\":\"0x2b5e3af16b18800000\",\"0x6b63a2dfb2bcd0caec0022b88be30c1451ea56aa\":\"0x2bdb6bf91f7f4c8000\",\"0x6b6577f3909a4d6de0f411522d4570386400345c\":\"0x65ea3db75546600000\",\"0x6b72a8f061cfe6996ad447d3c72c28c0c08ab3a7\":\"0xe78c6ac79912620000\",\"0x6b760d4877e6a627c1c967bee451a8507ddddbab\":\"0x3154c9729d05780000\",\"0x6b83bae7b565244558555bcf4ba8da2011891c17\":\"0x6c6b935b8bbd400000\",\"0x6b925dd5d8ed6132ab6d0860b82c44e1a51f1fee\":\"0x503b203e9fba200000\",\"0x6b94615db750656ac38c7e1cf29a9d13677f4e15\":\"0x28a857425466f800000\",\"0x6b951a43274eeafc8a0903b0af2ec92bf1efc839\":\"0x56bc75e2d63100000\",\"0x6b992521ec852370848ad697cc2df64e63cc06ff\":\"0x3635c9adc5dea00000\",\"0x6ba8f7e25fc2d871618e24e40184199137f9f6aa\":\"0x15af64869a6bc20000\",\"0x6ba9b21b35106be159d1c1c2657ac56cd29ffd44\":\"0xf2dc7d47f156000000\",\"0x6baf7a2a02ae78801e8904ad7ac05108fc56cff6\":\"0x3635c9adc5dea00000\",\"0x6bb2aca23fa1626d18efd6777fb97db02d8e0ae4\":\"0x878678326eac9000000\",\"0x6bb4a661a33a71d424d49bb5df28622ed4dffcf4\":\"0x222c8eb3ff66400000\",\"0x6bb50813146a9add42ee22038c9f1f7469d47f47\":\"0xada55474b81340000\",\"0x6bbc3f358a668dd1a11f0380f3f73108426abd4a\":\"0xd8d726b7177a800000\",\"0x6bbd1e719390e6b91043f8b6b9df898ea8001b34\":\"0x6c6c4fa6c3da588000\",\"0x6bc85acd5928722ef5095331ee88f484b8cf8357\":\"0x9c2007651b2500000\",\"0x6bd3e59f239fafe4776bb9bddd6bee83ba5d9d9f\":\"0x3635c9adc5dea00000\",\"0x6bd457ade051795df3f2465c3839aed3c5dee978\":\"0x3634bf39ab98788000\",\"0x6be16313643ebc91ff9bb1a2e116b854ea933a45\":\"0x1b1ae4d6e2ef500000\",\"0x6be7595ea0f068489a2701ec4649158ddc43e178\":\"0x6c6b935b8bbd400000\",\"0x6be9030ee6e2fbc491aca3de4022d301772b7b7d\":\"0x1731790534df20000\",\"0x6bec311ad05008b4af353c958c40bd06739a3ff3\":\"0x377f62a0f0a62700000\",\"0x6bf7b3c065f2c1e7c6eb092ba0d15066f393d1b8\":\"0x15af1d78b58c400000\",\"0x6bf86f1e2f2b8032a95c4d7738a109d3d0ed8104\":\"0x62a992e53a0af00000\",\"0x6c05e34e5ef2f42ed09deff1026cd66bcb6960bb\":\"0x6c6b935b8bbd400000\",\"0x6c08a6dc0173c7342955d1d3f2c065d62f83aec7\":\"0x1158e460913d00000\",\"0x6c0ae9f043c834d44271f13406593dfe094f389f\":\"0x52442ae133b62a8000\",\"0x6c0cc917cbee7d7c099763f14e64df7d34e2bf09\":\"0xd8d726b7177a80000\",\"0x6c0e712f405c59725fe829e9774bf4df7f4dd965\":\"0xc2868889ca68a440000\",\"0x6c101205b323d77544d6dc52af37aca3cec6f7f1\":\"0x21e19e0c9bab2400000\",\"0x6c15ec3520bf8ebbc820bd0ff19778375494cf9d\":\"0x6cb7e74867d5e60000\",\"0x6c1ddd33c81966dc8621776071a4129482f2c65f\":\"0x878678326eac9000000\",\"0x6c25327f8dcbb2f45e561e86e35d8850e53ab059\":\"0x3bcdf9bafef2f00000\",\"0x6c2e9be6d4ab450fd12531f33f028c614674f197\":\"0xc2127af858da700000\",\"0x6c359e58a13d4578a9338e335c67e7639f5fb4d7\":\"0xbd15b94fc8b280000\",\"0x6c3d18704126aa99ee3342ce60f5d4c85f1867cd\":\"0x2b5e3af16b1880000\",\"0x6c474bc66a54780066aa4f512eefa773abf919c7\":\"0x5188315f776b80000\",\"0x6c4e426e8dc005dfa3516cb8a680b02eea95ae8e\":\"0x487a9a304539440000\",\"0x6c52cf0895bb35e656161e4dc46ae0e96dd3e62c\":\"0xd8d8583fa2d52f0000\",\"0x6c5422fb4b14e6d98b6091fdec71f1f08640419d\":\"0x15af1d78b58c400000\",\"0x6c5c3a54cda7c2f118edba434ed81e6ebb11dd7a\":\"0xad78ebc5ac6200000\",\"0x6c63f84556d290bfcd99e434ee9997bfd779577a\":\"0x6c6b935b8bbd400000\",\"0x6c63fc85029a2654d79b2bea4de349e4524577c5\":\"0x23c757072b8dd00000\",\"0x6c6564e5c9c24eaaa744c9c7c968c9e2c9f1fbae\":\"0x499b42a21139640000\",\"0x6c67d6db1d03516c128b8ff234bf3d49b26d2941\":\"0x152d02c7e14af6800000\",\"0x6c67e0d7b62e2a08506945a5dfe38263339f1f22\":\"0x6acb3df27e1f880000\",\"0x6c6aa0d30b64721990b9504a863fa0bfb5e57da7\":\"0x925e06eec972b00000\",\"0x6c714a58fff6e97d14b8a5e305eb244065688bbd\":\"0xd8d726b7177a800000\",\"0x6c800d4b49ba07250460f993b8cbe00b266a2553\":\"0x1ab2cf7c9f87e20000\",\"0x6c808cabb8ff5fbb6312d9c8e84af8cf12ef0875\":\"0xd8d8583fa2d52f0000\",\"0x6c822029218ac8e98a260c1e064029348839875b\":\"0x10f97b787e1e3080000\",\"0x6c84cba77c6db4f7f90ef13d5ee21e8cfc7f8314\":\"0x6c6b935b8bbd400000\",\"0x6c8687e3417710bb8a93559021a1469e6a86bc77\":\"0x25b2da278d96b7b8000\",\"0x6c882c27732cef5c7c13a686f0a2ea77555ac289\":\"0x152d02c7e14af6800000\",\"0x6ca5de00817de0cedce5fd000128dede12648b3c\":\"0x1158e460913d00000\",\"0x6ca6a132ce1cd288bee30ec7cfeffb85c1f50a54\":\"0x6c6b935b8bbd400000\",\"0x6cb11ecb32d3ce829601310636f5a10cf7cf9b5f\":\"0x43fe8949c3801f50000\",\"0x6cc1c878fa6cde8a9a0b8311247e741e4642fe6d\":\"0x35659ef93f0fc40000\",\"0x6ccb03acf7f53ce87aadcc21a9932de915f89804\":\"0x1b1ae4d6e2ef5000000\",\"0x6cd212aee04e013f3d2abad2a023606bfb5c6ac7\":\"0x6c6acc67d7b1d40000\",\"0x6cd228dc712169307fe27ceb7477b48cfc8272e5\":\"0x434ea94db8a500000\",\"0x6ce1b0f6adc47051e8ab38b39edb4186b03babcc\":\"0x41799794cd24cc0000\",\"0x6ceae3733d8fa43d6cd80c1a96e8eb93109c83b7\":\"0x102794ad20da680000\",\"0x6d0569e5558fc7df2766f2ba15dc8aeffc5beb75\":\"0xd8e6001e6c302b0000\",\"0x6d120f0caae44fd94bcafe55e2e279ef96ba5c7a\":\"0xd8d726b7177a800000\",\"0x6d1456fff0104ee844a3314737843338d24cd66c\":\"0x7b06ce87fdd680000\",\"0x6d20ef9704670a500bb269b5832e859802049f01\":\"0x70c1cc73b00c80000\",\"0x6d2f976734b9d0070d1883cf7acab8b3e4920fc1\":\"0x21e19e0c9bab2400000\",\"0x6d39a9e98f81f769d73aad2cead276ac1387babe\":\"0x155bd9307f9fe80000\",\"0x6d3b7836a2b9d899721a4d237b522385dce8dfcd\":\"0x3636c25e66ece70000\",\"0x6d3f2ba856ccbb0237fa7661156b14b013f21240\":\"0x3635c9adc5dea00000\",\"0x6d4008b4a888a826f248ee6a0b0dfde9f93210b9\":\"0x127fcb8afae20d00000\",\"0x6d40ca27826d97731b3e86effcd7b92a4161fe89\":\"0x6c6b935b8bbd400000\",\"0x6d44974a31d187eda16ddd47b9c7ec5002d61fbe\":\"0x32f51edbaaa3300000\",\"0x6d4b5c05d06a20957e1748ab6df206f343f92f01\":\"0x21f360699bf825f8000\",\"0x6d4cbf3d8284833ae99344303e08b4d614bfda3b\":\"0x28a857425466f800000\",\"0x6d59b21cd0e2748804d9abe064eac2bef0c95f27\":\"0x6c6b935b8bbd400000\",\"0x6d63d38ee8b90e0e6ed8f192eda051b2d6a58bfd\":\"0x1a055690d9db80000\",\"0x6d6634b5b8a40195d949027af4828802092ceeb6\":\"0xa2a15d09519be00000\",\"0x6d7d1c949511f88303808c60c5ea0640fcc02683\":\"0x21e19e0c9bab2400000\",\"0x6d846dc12657e91af25008519c3e857f51707dd6\":\"0xf8d30bc92342f80000\",\"0x6d9193996b194617211106d1635eb26cc4b66c6c\":\"0x15aa1e7e9dd51c0000\",\"0x6d9997509882027ea947231424bedede2965d0ba\":\"0x6c81c7b31195e00000\",\"0x6da0ed8f1d69339f059f2a0e02471cb44fb8c3bb\":\"0x32bc38bb63a8160000\",\"0x6db72bfd43fef465ca5632b45aab7261404e13bf\":\"0x6c6b935b8bbd400000\",\"0x6dbe8abfa1742806263981371bf3d35590806b6e\":\"0x43c33c1937564800000\",\"0x6dc3f92baa1d21dab7382b893261a0356fa7c187\":\"0x5dc892aa1131c80000\",\"0x6dc7053a718616cfc78bee6382ee51add0c70330\":\"0x6c6b935b8bbd400000\",\"0x6dcc7e64fcafcbc2dc6c0e5e662cb347bffcd702\":\"0x43c33c1937564800000\",\"0x6dda5f788a6c688ddf921fa3852eb6d6c6c62966\":\"0x22b1c8c1227a00000\",\"0x6ddb6092779d5842ead378e21e8120fd4c6bc132\":\"0x6c6b935b8bbd400000\",\"0x6ddfef639155daab0a5cb4953aa8c5afaa880453\":\"0x62a992e53a0af00000\",\"0x6de02f2dd67efdb7393402fa9eaacbcf589d2e56\":\"0x40138b917edfb80000\",\"0x6de4b581385cf7fc9fe8c77d131fe2ee7724c76a\":\"0x7d2997733dcce40000\",\"0x6de4d15219182faf3aa2c5d4d2595ff23091a727\":\"0x55a6e79ccd1d300000\",\"0x6dedf62e743f4d2c2a4b87a787f5424a7aeb393c\":\"0x9c2007651b2500000\",\"0x6df24f6685a62f791ba337bf3ff67e91f3d4bc3a\":\"0x756b49d40a48180000\",\"0x6df5c84f7b909aab3e61fe0ecb1b3bf260222ad2\":\"0xd8d726b7177a800000\",\"0x6dff90e6dc359d2590882b1483edbcf887c0e423\":\"0x3635c9adc5dea00000\",\"0x6e01e4ad569c95d007ada30d5e2db12888492294\":\"0xd8d726b7177a800000\",\"0x6e073b66d1b8c66744d88096a8dd99ec7e0228da\":\"0xd8d726b7177a800000\",\"0x6e0ee70612c976287d499ddfa6c0dcc12c06deea\":\"0x70bd5b95621460000\",\"0x6e12b51e225b4a4372e59ad7a2a1a13ea3d3a137\":\"0x30046c8cc775f040000\",\"0x6e1a046caf5b4a57f4fd4bc173622126b4e2fd86\":\"0x61093d7c2c6d380000\",\"0x6e1ea4b183e252c9bb7767a006d4b43696cb8ae9\":\"0xff3783c85eed08000\",\"0x6e255b700ae7138a4bacf22888a9e2c00a285eec\":\"0xd8d726b7177a800000\",\"0x6e270ad529f1f0b8d9cb6d2427ec1b7e2dc64a74\":\"0xad78ebc5ac6200000\",\"0x6e2eab85dc89fe29dc0aa1853247dab43a523d56\":\"0x4563918244f400000\",\"0x6e3a51db743d334d2fe88224b5fe7c008e80e624\":\"0x5bf0ba6634f680000\",\"0x6e4c2ab7db026939dbd3bc68384af660a61816b2\":\"0x90d972f32323c0000\",\"0x6e4d2e39c8836629e5b487b1918a669aebdd9536\":\"0x3635c9adc5dea00000\",\"0x6e5c2d9b1c546a86eefd5d0a5120c9e4e730190e\":\"0xad201a6794ff80000\",\"0x6e60aee1a78f8eda8b424c73e353354ae67c3042\":\"0xbd35a48d9919e60000\",\"0x6e64e6129f224e378c0e6e736a7e7a06c211e9ec\":\"0x3635c9adc5dea00000\",\"0x6e6d5bbbb9053b89d744a27316c2a7b8c09b547d\":\"0x3152710a023e6d8000\",\"0x6e72b2a1186a8e2916543b1cb36a68870ea5d197\":\"0xa1544be879ea80000\",\"0x6e761eaa0f345f777b5441b73a0fa5b56b85f22d\":\"0x6c6b935b8bbd400000\",\"0x6e79edd4845b076e4cd88d188b6e432dd93f35aa\":\"0x33c5499031720c0000\",\"0x6e8212b722afd408a7a73ed3e2395ee6454a0330\":\"0x89e917994f71c0000\",\"0x6e84876dbb95c40b6656e42ba9aea08a993b54dc\":\"0x3bbc60e3b6cbbe0000\",\"0x6e84c2fd18d8095714a96817189ca21cca62bab1\":\"0x127b6c702621cd8000\",\"0x6e866d032d405abdd65cf651411d803796c22311\":\"0x6c6b935b8bbd400000\",\"0x6e899e59a9b41ab7ea41df7517860f2acb59f4fd\":\"0x43c33c1937564800000\",\"0x6e89c51ea6de13e06cdc748b67c4410fe9bcab03\":\"0xd8d726b7177a800000\",\"0x6e8a26689f7a2fdefd009cbaaa5310253450daba\":\"0x6f213717bad8d30000\",\"0x6e96faeda3054302c45f58f161324c99a3eebb62\":\"0x1158e460913d00000\",\"0x6eb0a5a9ae96d22cf01d8fd6483b9f38f08c2c8b\":\"0xd8d726b7177a800000\",\"0x6eb3819617404058268f0c3cff3596bfe9148c1c\":\"0x5a87e7d7f5f6580000\",\"0x6eb5578a6bb7c32153195b0d8020a6914852c059\":\"0x8bc2abf40221f4800000\",\"0x6ebb5e6957aa821ef659b6018a393a504cae4450\":\"0x6c6b935b8bbd400000\",\"0x6ebcf9957f5fc5e985add475223b04b8c14a7aed\":\"0x5dc892aa1131c80000\",\"0x6ec3659571b11f889dd439bcd4d67510a25be57e\":\"0x6aaf7c8516d0c0000\",\"0x6ec89b39f9f5276a553e8da30e6ec17aa47eefc7\":\"0x18424f5f0b1b4e0000\",\"0x6ec96d13bdb24dc7a557293f029e02dd74b97a55\":\"0xd8d726b7177a800000\",\"0x6ecaefa6fc3ee534626db02c6f85a0c395571e77\":\"0x2086ac351052600000\",\"0x6ed2a12b02f8c688c7b5d3a6ea14d63687dab3b6\":\"0x6c6b935b8bbd400000\",\"0x6ed884459f809dfa1016e770edaf3e9fef46fa30\":\"0xb852d6782093f10000\",\"0x6edf7f5283725c953ee64317f66188af1184b033\":\"0x1b464311d45a6880000\",\"0x6ee8aad7e0a065d8852d7c3b9a6e5fdc4bf50c00\":\"0x1158e460913d00000\",\"0x6eefdc850e87b715c72791773c0316c3559b58a4\":\"0xd8d726b7177a800000\",\"0x6ef9e8c9b6217d56769af97dbb1c8e1b8be799d2\":\"0x9ddc1e3b901180000\",\"0x6efba8fb2ac5b6730729a972ec224426a287c3ad\":\"0xf5985fbcbe1680000\",\"0x6efd90b535e00bbd889fda7e9c3184f879a151db\":\"0x22385a827e815500000\",\"0x6f051666cb4f7bd2b1907221b829b555d7a3db74\":\"0x5f68e8131ecf800000\",\"0x6f0edd23bcd85f6015f9289c28841fe04c83efeb\":\"0x10910d4cdc9f60000\",\"0x6f137a71a6f197df2cbbf010dcbd3c444ef5c925\":\"0x6c6b935b8bbd400000\",\"0x6f176065e88e3c6fe626267d18a088aaa4db80bc\":\"0xbed1d0263d9f000000\",\"0x6f18ec767e320508195f1374500e3f2e125689ff\":\"0x3635c9adc5dea00000\",\"0x6f1f4907b8f61f0c51568d692806b382f50324f5\":\"0x6c6b935b8bbd400000\",\"0x6f24c9af2b763480515d1b0951bb77a540f1e3f9\":\"0x6acb3df27e1f880000\",\"0x6f2576da4de283bbe8e3ee69ddd66e5e711db3f5\":\"0x44591d67fecc800000\",\"0x6f29bb375be5ed34ed999bb830ee2957dde76d16\":\"0x6c6b935b8bbd400000\",\"0x6f2a31900e240395b19f159c1d00dfe4d898ebdf\":\"0x6c660645aa47180000\",\"0x6f2a42e6e033d01061131929f7a6ee1538021e52\":\"0x6c6b935b8bbd400000\",\"0x6f39cc37caaa2ddc9b610f6131e0619fae772a3c\":\"0x1b1ae4d6e2ef500000\",\"0x6f44ca09f0c6a8294cbd519cdc594ad42c67579f\":\"0x2b5e3af16b1880000\",\"0x6f50929777824c291a49c46dc854f379a6bea080\":\"0x138400eca364a00000\",\"0x6f6cf20649a9e973177ac67dbadee4ebe5c7bdda\":\"0x11363297d01a8600000\",\"0x6f791d359bc3536a315d6382b88311af8ed6da47\":\"0x4fcc1a89027f00000\",\"0x6f794dbdf623daa6e0d00774ad6962737c921ea4\":\"0x6c6b935b8bbd400000\",\"0x6f7ac681d45e418fce8b3a1db5bc3be6f06c9849\":\"0x6c6b935b8bbd400000\",\"0x6f81f3abb1f933b1df396b8e9cc723a89b7c9806\":\"0xf2dc7d47f15600000\",\"0x6f8f0d15cc96fb7fe94f1065bc6940f8d12957b2\":\"0x3635c9adc5dea00000\",\"0x6f92d6e4548c78996509ee684b2ee29ba3c532b4\":\"0x3635c9adc5dea00000\",\"0x6fa60df818a5446418b1bbd62826e0b9825e1318\":\"0x2cb92cc8f6714400000\",\"0x6fa6388d402b30afe59934c3b9e13d1186476018\":\"0x24521e2a3017b80000\",\"0x6fa72015fa78696efd9a86174f7f1f21019286b1\":\"0x487a9a304539440000\",\"0x6fc25e7e00ca4f60a9fe6f28d1fde3542e2d1079\":\"0x2aef353bcddd600000\",\"0x6fc53662371dca587b59850de78606e2359df383\":\"0x9c2007651b2500000\",\"0x6fcc2c732bdd934af6ccd16846fb26ef89b2aa9b\":\"0x21e2b1d42261d490000\",\"0x6fd4e0f3f32bee6d3767fdbc9d353a6d3aab7899\":\"0x25b064a875ea940000\",\"0x6fd947d5a73b175008ae6ee8228163da289b167d\":\"0x65a4da25d3016c00000\",\"0x6fd98e563d12ce0fd60f4f1f850ae396a9823c02\":\"0x445be3f2ef87940000\",\"0x6fddbd9bca66e28765c2162c8433548c1052ed11\":\"0x1184429b82a818800000\",\"0x6ff5d361b52ad0b68b1588607ec304ae5665fc98\":\"0x692ae8897081d00000\",\"0x6ff6cc90d649de4e96cffee1077a5b302a848dcb\":\"0x18ce79c78802c0000\",\"0x6ffe5cf82cc9ea5e36cad7c2974ce7249f3749e6\":\"0x692ae8897081d00000\",\"0x7005a772282b1f62afda63f89b5dc6ab64c84cb9\":\"0x3cfc82e37e9a7400000\",\"0x700711e311bb947355f755b579250ca7fd765a3e\":\"0x61093d7c2c6d380000\",\"0x7010be2df57bd0ab9ae8196cd50ab0c521aba9f9\":\"0x6acb3df27e1f880000\",\"0x7023c70956e04a92d70025aad297b539af355869\":\"0x6c6b935b8bbd400000\",\"0x7025965d2b88da197d4459be3dc9386344cc1f31\":\"0x6cb7e74867d5e60000\",\"0x702802f36d00250fab53adbcd696f0176f638a49\":\"0x6c6b935b8bbd400000\",\"0x704819d2e44d6ed1da25bfce84c49fcca25613e5\":\"0x15af1d78b58c400000\",\"0x704a6eb41ba34f13addde7d2db7df04915c7a221\":\"0x62a992e53a0af00000\",\"0x704ab1150d5e10f5e3499508f0bf70650f028d4b\":\"0xd8d726b7177a800000\",\"0x704ae21d762d6e1dde28c235d13104597236db1a\":\"0x6c6b935b8bbd400000\",\"0x704d243c2978e46c2c86adbecd246e3b295ff633\":\"0x6d121bebf795f00000\",\"0x704d5de4846d39b53cd21d1c49f096db5c19ba29\":\"0x83d6c7aab63600000\",\"0x705ddd38355482b8c7d3b515bda1500dd7d7a817\":\"0x15af1d78b58c400000\",\"0x70616e2892fa269705b2046b8fe3e72fa55816d3\":\"0x43c33c1937564800000\",\"0x70670fbb05d33014444b8d1e8e7700258b8caa6d\":\"0x6c6b935b8bbd400000\",\"0x7081fa6baad6cfb7f51b2cca16fb8970991a64ba\":\"0xcaec005f6c0f68000\",\"0x7085ae7e7e4d932197b5c7858c00a3674626b7a5\":\"0x14542ba12a337c00000\",\"0x7086b4bde3e35d4aeb24b825f1a215f99d85f745\":\"0x6c68ccd09b022c0000\",\"0x708a2af425ceb01e87ffc1be54c0f532b20eacd6\":\"0x745d483b1f5a18000\",\"0x708ea707bae4357f1ebea959c3a250acd6aa21b3\":\"0x1b1ae4d6e2ef500000\",\"0x708fa11fe33d85ad1befcbae3818acb71f6a7d7e\":\"0xfc936392801c0000\",\"0x7091303116d5f2389b23238b4d656a8596d984d3\":\"0x3b4e7e80aa58330000\",\"0x7099d12f6ec656899b049a7657065d62996892c8\":\"0x15af1d78b58c400000\",\"0x709fe9d2c1f1ce42207c9585044a60899f35942f\":\"0x6c6b935b8bbd400000\",\"0x70a03549aa6168e97e88a508330a5a0bea74711a\":\"0x487a9a304539440000\",\"0x70a4067d448cc25dc8e70e651cea7cf84e92109e\":\"0x98a7d9b8314c00000\",\"0x70ab34bc17b66f9c3b63f151274f2a727c539263\":\"0x6c6b935b8bbd400000\",\"0x70c213488a020c3cfb39014ef5ba6404724bcaa3\":\"0x692ae8897081d00000\",\"0x70d25ed2c8ada59c088cf70dd22bf2db93acc18a\":\"0x39474545e4adbc0000\",\"0x70e5e9da735ff077249dcb9aaf3db2a48d9498c0\":\"0x3635c9adc5dea00000\",\"0x70fee08b00c6c2c04a3c625c1ff77caf1c32df01\":\"0xad78ebc5ac6200000\",\"0x7101bd799e411cde14bdfac25b067ac890eab8e8\":\"0x4e9b8aae48de470000\",\"0x7109dd011d15f3122d9d3a27588c10d77744508b\":\"0x6c6b935b8bbd400000\",\"0x710b0274d712c77e08a5707d6f3e70c0ce3d92cf\":\"0x15af1d78b58c4000000\",\"0x710be8fd5e2918468be2aabea80d828435d79612\":\"0xf43fc2c04ee00000\",\"0x71135d8f05963c905a4a07922909235a896a52ea\":\"0xa2a15d09519be00000\",\"0x711ecf77d71b3d0ea95ce4758afecdb9c131079d\":\"0x29331e6558f0e00000\",\"0x71213fca313404204ecba87197741aa9dfe96338\":\"0x340aad21b3b700000\",\"0x712b76510214dc620f6c3a1dd29aa22bf6d214fb\":\"0x14542ba12a337c00000\",\"0x712ff7370a13ed360973fedc9ff5d2c93a505e9e\":\"0xd5967be4fc3f100000\",\"0x7133843a78d939c69d4486e10ebc7b602a349ff7\":\"0x11d5cacce21f840000\",\"0x7148aef33261d8031fac3f7182ff35928daf54d9\":\"0xde42ee1544dd900000\",\"0x7163758cbb6c4c525e0414a40a049dcccce919bb\":\"0xad78ebc5ac6200000\",\"0x7168b3bb8c167321d9bdb023a6e9fd11afc9afd9\":\"0x61093d7c2c6d380000\",\"0x7169724ee72271c534cad6420fb04ee644cb86fe\":\"0x163c2b40dba5520000\",\"0x716ad3c33a9b9a0a18967357969b94ee7d2abc10\":\"0x1a2117fe412a480000\",\"0x716ba01ead2a91270635f95f25bfaf2dd610ca23\":\"0x979e7012056aa780000\",\"0x716d50cca01e938500e6421cc070c3507c67d387\":\"0x6c6b935b8bbd400000\",\"0x71762c63678c18d1c6378ce068e666381315147e\":\"0x6c6b935b8bbd400000\",\"0x71784c105117c1f68935797fe159abc74e43d16a\":\"0x6c81c7b31195e00000\",\"0x7179726f5c71ae1b6d16a68428174e6b34b23646\":\"0x18ea250097cbaf60000\",\"0x717cf9beab3638308ded7e195e0c86132d163fed\":\"0x3326ee6f865f4220000\",\"0x7180b83ee5574317f21c8072b191d895d46153c3\":\"0x18efc84ad0c7b00000\",\"0x71946b7117fc915ed107385f42d99ddac63249c2\":\"0x6c6b935b8bbd400000\",\"0x719e891fbcc0a33e19c12dc0f02039ca05b801df\":\"0x14f5538463a1b540000\",\"0x71c7230a1d35bdd6819ed4b9a88e94a0eb0786dd\":\"0xeca08b353d24140000\",\"0x71d2cc6d02578c65f73c575e76ce8fbcfadcf356\":\"0x3ecc078688a480000\",\"0x71d9494e50c5dd59c599dba3810ba1755e6537f0\":\"0xd8d726b7177a800000\",\"0x71e38ff545f30fe14ca863d4f5297fd48c73a5ce\":\"0xc2127af858da700000\",\"0x71ea5b11ad8d29b1a4cb67bf58ca6c9f9c338c16\":\"0x56bc75e2d631000000\",\"0x71ec3aec3f8f9221f9149fede06903a0f9a232f2\":\"0xad78ebc5ac6200000\",\"0x71f2cdd1b046e2da2fbb5a26723422b8325e25a3\":\"0x56b394263a40c0000\",\"0x71fa22cc6d33206b7d701a163a0dab31ae4d31d6\":\"0x57473d05dabae80000\",\"0x7201d1c06920cd397ae8ad869bcda6e47ffb1b5a\":\"0x1158e460913d00000\",\"0x72072a0ef1cff3d567cdd260e708ddc11cbc9a31\":\"0x56bc75e2d63100000\",\"0x72094f3951ffc9771dced23ada080bcaf9c7cca7\":\"0x14542ba12a337c00000\",\"0x720994dbe56a3a95929774e20e1fe525cf3704e4\":\"0x1b1ae4d6e2ef5000000\",\"0x720e6b22bf430966fa32b6acb9a506eebf662c61\":\"0x83d6c7aab63600000\",\"0x721158be5762b119cc9b2035e88ee4ee78f29b82\":\"0x21e19e0c9bab2400000\",\"0x721f9d17e5a0e74205947aeb9bc6a7938961038f\":\"0x2d041d705a2c60000\",\"0x7222fec7711781d26eaa4e8485f7aa3fac442483\":\"0x18b84570022a200000\",\"0x72393d37b451effb9e1ff3b8552712e2a970d8c2\":\"0x35659ef93f0fc40000\",\"0x723d8baa2551d2addc43c21b45e8af4ca2bfb2c2\":\"0x5f68e8131ecf800000\",\"0x72402300e81d146c2e644e2bbda1da163ca3fb56\":\"0x17b7883c06916600000\",\"0x72480bede81ad96423f2228b5c61be44fb523100\":\"0x15af1d78b58c4000000\",\"0x724ce858857ec5481c86bd906e83a04882e5821d\":\"0xa2a15d09519be00000\",\"0x726a14c90e3f84144c765cffacba3e0df11b48be\":\"0x21e19e0c9bab2400000\",\"0x7283cd4675da58c496556151dafd80c7f995d318\":\"0x29331e6558f0e00000\",\"0x7286e89cd9de8f7a8a00c86ffdb53992dd9251d1\":\"0x692ae8897081d00000\",\"0x728f9ab080157db3073156dbca1a169ef3179407\":\"0x1b1ae4d6e2ef500000\",\"0x7294c918b1aefb4d25927ef9d799e71f93a28e85\":\"0xaadec983fcff40000\",\"0x7294ec9da310bc6b4bbdf543b0ef45abfc3e1b4d\":\"0x4a89f54ef0121c00000\",\"0x729aad4627744e53f5d66309aa74448b3acdf46f\":\"0x6c6b935b8bbd400000\",\"0x72a2fc8675feb972fa41b50dffdbbae7fa2adfb7\":\"0x9ab4fc67b528c80000\",\"0x72a8260826294726a75bf39cd9aa9e07a3ea14cd\":\"0x6c6b935b8bbd400000\",\"0x72b05962fb2ad589d65ad16a22559eba1458f387\":\"0x73f75d1a085ba0000\",\"0x72b5633fe477fe542e742facfd690c137854f216\":\"0x5a87e7d7f5f6580000\",\"0x72b7a03dda14ca9c661a1d469fd33736f673c8e8\":\"0x6c6b935b8bbd400000\",\"0x72b904440e90e720d6ac1c2ad79c321dcc1c1a86\":\"0x54069233bf7f780000\",\"0x72b90a4dc097239492c5b9777dcd1e52ba2be2c2\":\"0x14542ba12a337c00000\",\"0x72bb27cb99f3e2c2cf90a98f707d30e4a201a071\":\"0x58e7926ee858a00000\",\"0x72c083beadbdc227c5fb43881597e32e83c26056\":\"0x43c33c1937564800000\",\"0x72cd048a110574482983492dfb1bd27942a696ba\":\"0x6c6b935b8bbd400000\",\"0x72d03d4dfab3500cf89b86866f15d4528e14a195\":\"0xf34b82fd8e91200000\",\"0x72dabb5b6eed9e99be915888f6568056381608f8\":\"0xb4c96c52cb4fe8000\",\"0x72fb49c29d23a18950c4b2dc0ddf410f532d6f53\":\"0x6c6b935b8bbd400000\",\"0x72feaf124579523954645b7fafff0378d1c8242e\":\"0x3635c9adc5dea00000\",\"0x7301dc4cf26d7186f2a11bf8b08bf229463f64a3\":\"0x6c6b935b8bbd400000\",\"0x730447f97ce9b25f22ba1afb36df27f9586beb9b\":\"0x2c73c937742c500000\",\"0x7306de0e288b56cfdf987ef0d3cc29660793f6dd\":\"0x1b8abfb62ec8f60000\",\"0x730d8763c6a4fd824ab8b859161ef7e3a96a1200\":\"0x43c33c1937564800000\",\"0x73128173489528012e76b41a5e28c68ba4e3a9d4\":\"0x3635c9adc5dea00000\",\"0x7313461208455455465445a459b06c3773b0eb30\":\"0x6c6b935b8bbd400000\",\"0x732fead60f7bfdd6a9dec48125e3735db1b6654f\":\"0x1158e460913d00000\",\"0x734223d27ff23e5906caed22595701bb34830ca1\":\"0x6c6b935b8bbd400000\",\"0x73473e72115110d0c3f11708f86e77be2bb0983c\":\"0x1158e460913d00000\",\"0x7352586d021ad0cf77e0e928404a59f374ff4582\":\"0xb8507a820728200000\",\"0x73550beb732ba9ddafda7ae406e18f7feb0f8bb2\":\"0x97c9ce4cf6d5c00000\",\"0x735b97f2fc1bd24b12076efaf3d1288073d20c8c\":\"0x1158e460913d00000\",\"0x735e328666ed5637142b3306b77ccc5460e72c3d\":\"0x6ab8f37879c9910000\",\"0x7363cd90fbab5bb8c49ac20fc62c398fe6fb744c\":\"0x6c6b935b8bbd400000\",\"0x736b44503dd2f6dd5469ff4c5b2db8ea4fec65d0\":\"0x1104ee759f21e30000\",\"0x736bf1402c83800f893e583192582a134eb532e9\":\"0x21e19d293c01f260000\",\"0x738ca94db7ce8be1c3056cd6988eb376359f3353\":\"0x5665b96cf35acf00000\",\"0x73914b22fc2f131584247d82be4fecbf978ad4ba\":\"0x6c6b935b8bbd400000\",\"0x73932709a97f02c98e51b091312865122385ae8e\":\"0x4d853c8f8908980000\",\"0x7393cbe7f9ba2165e5a7553500b6e75da3c33abf\":\"0x56bc75e2d63100000\",\"0x73b4d499de3f38bf35aaf769a6e318bc6d123692\":\"0x6c6b935b8bbd400000\",\"0x73bedd6fda7ba3272185087b6351fc133d484e37\":\"0x11226bf9dce59780000\",\"0x73bfe7710f31cab949b7a2604fbf5239cee79015\":\"0x6c6b935b8bbd400000\",\"0x73cf80ae9688e1580e68e782cd0811f7aa494d2c\":\"0x1a4aba225c207400000\",\"0x73d7269ff06c9ffd33754ce588f74a966abbbbba\":\"0x165c96647b38a200000\",\"0x73d8fee3cb864dce22bb26ca9c2f086d5e95e63b\":\"0x3635c9adc5dea00000\",\"0x73df3c3e7955f4f2d859831be38000b1076b3884\":\"0x6acb3df27e1f880000\",\"0x73e4a2b60cf48e8baf2b777e175a5b1e4d0c2d8f\":\"0x56bc75e2d63100000\",\"0x740af1eefd3365d78ba7b12cb1a673e06a077246\":\"0x42bf06b78ed3b500000\",\"0x740bfd52e01667a3419b029a1b8e45576a86a2db\":\"0x38ebad5cdc902800000\",\"0x740f641614779dcfa88ed1d425d60db42a060ca6\":\"0x3622c6760810570000\",\"0x7412c9bc30b4df439f023100e63924066afd53af\":\"0x1b1ae4d6e2ef500000\",\"0x741693c30376508513082020cc2b63e9fa92131b\":\"0x410d586a20a4c00000\",\"0x7421ce5be381738ddc83f02621974ff0686c79b8\":\"0x58788cb94b1d800000\",\"0x74316adf25378c10f576d5b41a6f47fa98fce33d\":\"0x1238131e5c7ad50000\",\"0x743651b55ef8429df50cf81938c2508de5c8870f\":\"0x6c6b935b8bbd400000\",\"0x743de50026ca67c94df54f066260e1d14acc11ac\":\"0x6c6b935b8bbd400000\",\"0x7445202f0c74297a004eb3726aa6a82dd7c02fa1\":\"0x6c6b935b8bbd400000\",\"0x744b03bba8582ae5498e2dc22d19949467ab53fc\":\"0x1b1ae4d6e2ef500000\",\"0x744c0c77ba7f236920d1e434de5da33e48ebf02c\":\"0x6acb3df27e1f880000\",\"0x7450ff7f99eaa9116275deac68e428df5bbcd8b9\":\"0x6c6b935b8bbd400000\",\"0x7456c5b2c5436e3e571008933f1805ccfe34e9ec\":\"0x3635c9adc5dea00000\",\"0x745ad3abc6eeeb2471689b539e789ce2b8268306\":\"0x3d4194bea011928000\",\"0x745aecbaf9bb39b74a67ea1ce623de368481baa6\":\"0x21e19e0c9bab2400000\",\"0x745ccf2d819edbbddea8117b5c49ed3c2a066e93\":\"0xd8d726b7177a800000\",\"0x7462c89caa9d8d7891b2545def216f7464d5bb21\":\"0x5eaed54a28b310000\",\"0x74648caac748dd135cd91ea14c28e1bd4d7ff6ae\":\"0xa80d24677efef00000\",\"0x7471f72eeb300624eb282eab4d03723c649b1b58\":\"0x1b1ae4d6e2ef5000000\",\"0x747abc9649056d3926044d28c3ad09ed17b67d70\":\"0x10f0dbae61009528000\",\"0x747ff7943b71dc4dcdb1668078f83dd7cc4520c2\":\"0x340aad21b3b700000\",\"0x7480de62254f2ba82b578219c07ba5be430dc3cb\":\"0x17da3a04c7b3e000000\",\"0x7484d26becc1eea8c6315ec3ee0a450117dc86a0\":\"0x28a857425466f800000\",\"0x74863acec75d03d53e860e64002f2c165e538377\":\"0x3635c9adc5dea00000\",\"0x7489cc8abe75cda4ef0d01cef2605e47eda67ab1\":\"0x73f75d1a085ba0000\",\"0x748c285ef1233fe4d31c8fb1378333721c12e27a\":\"0x6c6b935b8bbd400000\",\"0x749087ac0f5a97c6fad021538bf1d6cda18e0daa\":\"0x3635c9adc5dea00000\",\"0x7495ae78c0d90261e2140ef2063104731a60d1ed\":\"0x1db50718925210000\",\"0x749a4a768b5f237248938a12c623847bd4e688dc\":\"0x3e733628714200000\",\"0x749ad6f2b5706bbe2f689a44c4b640b58e96b992\":\"0x56bc75e2d63100000\",\"0x74a17f064b344e84db6365da9591ff1628257643\":\"0x1158e460913d00000\",\"0x74aeec915de01cc69b2cb5a6356feea14658c6c5\":\"0xc9a95ee2986520000\",\"0x74afe54902d615782576f8baac13ac970c050f6e\":\"0x9a1aaa3a9fba70000\",\"0x74b7e0228baed65957aebb4d916d333aae164f0e\":\"0x6c6b935b8bbd400000\",\"0x74bc4a5e2045f4ff8db184cf3a9b0c065ad807d2\":\"0x6c6b935b8bbd400000\",\"0x74bce9ec38362d6c94ccac26d5c0e13a8b3b1d40\":\"0x363526410442f50000\",\"0x74bf7a5ab59293149b5c60cf364263e5ebf1aa0d\":\"0x6470c3e771e3c0000\",\"0x74c73c90528a157336f1e7ea20620ae53fd24728\":\"0x1e63a2e538f16e30000\",\"0x74d1a4d0c7524e018d4e06ed3b648092b5b6af2c\":\"0x2b5e3af16b1880000\",\"0x74d366b07b2f56477d7c7077ac6fe497e0eb6559\":\"0x10f0cf064dd59200000\",\"0x74d37a51747bf8b771bfbf43943933d100d21483\":\"0x3635c9adc5dea00000\",\"0x74d671d99cbea1ab57906375b63ff42b50451d17\":\"0x3635c9adc5dea00000\",\"0x74ebf4425646e6cf81b109ce7bf4a2a63d84815f\":\"0x22b1c8c1227a00000\",\"0x74ed33acf43f35b98c9230b9e6642ecb5330839e\":\"0x24f6dffb498d280000\",\"0x74ef2869cbe608856045d8c2041118579f2236ea\":\"0x33cd64591956e0000\",\"0x74fc5a99c0c5460503a13b0509459da19ce7cd90\":\"0xad78ebc5ac6200000\",\"0x750bbb8c06bbbf240843cc75782ee02f08a97453\":\"0x2d43f3ebfafb2c0000\",\"0x7514adbdc63f483f304d8e94b67ff3309f180b82\":\"0x21c4a06e2d13598000\",\"0x7517f16c28d132bb40e3ba36c6aef131c462da17\":\"0xfc936392801c0000\",\"0x751a2ca34e7187c163d28e3618db28b13c196d26\":\"0x1b1ae4d6e2ef500000\",\"0x751abcb6cc033059911815c96fd191360ab0442d\":\"0x1b1ae4d6e2ef5000000\",\"0x7526e482529f0a14eec98871dddd0e721b0cd9a2\":\"0x1158e460913d00000\",\"0x7529f3797bb6a20f7ea6492419c84c867641d81c\":\"0x6c6b935b8bbd400000\",\"0x752a5ee232612cd3005fb26e5b597de19f776be6\":\"0x127fcb8afae20d00000\",\"0x752c9febf42f66c4787bfa7eb17cf5333bba5070\":\"0x6a99f2b54fdd580000\",\"0x7539333046deb1ef3c4daf50619993f444e1de68\":\"0x40138b917edfb80000\",\"0x7553aa23b68aa5f57e135fe39fdc235eaca8c98c\":\"0x3635c9adc5dea00000\",\"0x755a60bf522fbd8fff9723446b7e343a7068567e\":\"0x43c33c1937564800000\",\"0x755f587e5efff773a220726a13d0f2130d9f896b\":\"0x3635c9adc5dea00000\",\"0x75621865b6591365606ed378308c2d1def4f222c\":\"0xa80d24677efef00000\",\"0x75636cdb109050e43d5d6ec47e359e218e857eca\":\"0x4d8b2276c8962280000\",\"0x7566496162ba584377be040a4f87777a707acaeb\":\"0xd8d726b7177a800000\",\"0x756b84eb85fcc1f4fcdcc2b08db6a86e135fbc25\":\"0xae8e7a0bb575d00000\",\"0x756f45e3fa69347a9a973a725e3c98bc4db0b5a0\":\"0xad78ebc5ac6200000\",\"0x757b65876dbf29bf911d4f0692a2c9beb1139808\":\"0xdf93a59337d6dd8000\",\"0x757fa55446c460968bb74b5ebca96c4ef2c709c5\":\"0x3708baed3d68900000\",\"0x75804aac64b4199083982902994d9c5ed8828f11\":\"0x1e3d07b0a620e40000\",\"0x7592c69d067b51b6cc639d1164d5578c60d2d244\":\"0x1158e460913d00000\",\"0x75abe5270f3a78ce007cf37f8fbc045d489b7bb1\":\"0x6c6acc67d7b1d40000\",\"0x75ac547017134c04ae1e11d60e63ec04d18db4ef\":\"0x14542ba12a337c00000\",\"0x75b0e9c942a4f0f6f86d3f95ff998022fa67963b\":\"0x50c5e761a444080000\",\"0x75b95696e8ec4510d56868a7c1a735c68b244890\":\"0x15af1d78b58c4000000\",\"0x75be8ff65e5788aec6b2a52d5fa7b1e7a03ba675\":\"0x3abcdc5343d740000\",\"0x75c11d024d12ae486c1095b7a7b9c4af3e8edeb9\":\"0x1158e460913d00000\",\"0x75c1ad23d23f24b384d0c3149177e86697610d21\":\"0x15c5bcd6c288bbd0000\",\"0x75c2ffa1bef54919d2097f7a142d2e14f9b04a58\":\"0x90f358504032a10000\",\"0x75d67ce14e8d29e8c2ffe381917b930b1aff1a87\":\"0xa2a15d09519be00000\",\"0x75de7e9352e90b13a59a5878ffecc7831cac4d82\":\"0x9489237adb9a500000\",\"0x75f7539d309e9039989efe2e8b2dbd865a0df088\":\"0x855b5ba65c84f00000\",\"0x7608f437b31f18bc0b64d381ae86fd978ed7b31f\":\"0x2b5e3af16b1880000\",\"0x760ff3354e0fde938d0fb5b82cef5ba15c3d2916\":\"0x21e19e0c9bab2400000\",\"0x761a6e362c97fbbd7c5977acba2da74687365f49\":\"0x9f74ae1f953d00000\",\"0x761e6caec189c230a162ec006530193e67cf9d19\":\"0x6c6b935b8bbd400000\",\"0x761f8a3a2af0a8bdbe1da009321fb29764eb62a1\":\"0x21e19e0c9bab2400000\",\"0x762998e1d75227fced7a70be109a4c0b4ed86414\":\"0x1158e460913d00000\",\"0x762d6f30dab99135e4eca51d5243d6c8621102d5\":\"0xf498941e664280000\",\"0x76331e30796ce664b2700e0d4153700edc869777\":\"0x6c6b935b8bbd400000\",\"0x763886e333c56feff85be3951ab0b889ce262e95\":\"0x6c6b935b8bbd400000\",\"0x763a7cbab70d7a64d0a7e52980f681472593490c\":\"0x2086ac351052600000\",\"0x763eece0b08ac89e32bfa4bece769514d8cb5b85\":\"0xd8d726b7177a800000\",\"0x7640a37f8052981515bce078da93afa4789b5734\":\"0x6c6b935b8bbd400000\",\"0x7641f7d26a86cddb2be13081810e01c9c83c4b20\":\"0xb98bc829a6f90000\",\"0x764692cccb33405dd0ab0c3379b49caf8e6221ba\":\"0x1158e460913d00000\",\"0x764d5212263aff4a2a14f031f04ec749dc883e45\":\"0x6449e84e47a8a80000\",\"0x764fc46d428b6dbc228a0f5f55c9508c772eab9f\":\"0x581767ba6189c400000\",\"0x76506eb4a780c951c74a06b03d3b8362f0999d71\":\"0x1b1ae4d6e2ef500000\",\"0x765be2e12f629e6349b97d21b62a17b7c830edab\":\"0x14542ba12a337c00000\",\"0x76628150e2995b5b279fc83e0dd5f102a671dd1c\":\"0x878678326eac9000000\",\"0x766b3759e8794e926dac473d913a8fb61ad0c2c9\":\"0x4b06dbbb40f4a0000\",\"0x7670b02f2c3cf8fd4f4730f3381a71ea431c33c7\":\"0xe7eeba3410b740000\",\"0x767a03655af360841e810d83f5e61fb40f4cd113\":\"0x35659ef93f0fc40000\",\"0x767ac690791c2e23451089fe6c7083fe55deb62b\":\"0x2c73c937742c500000\",\"0x767fd7797d5169a05f7364321c19843a8c348e1e\":\"0x104e70464b1580000\",\"0x76846f0de03b5a76971ead298cdd08843a4bc6c6\":\"0xd71b0fe0a28e0000\",\"0x768498934e37e905f1d0e77b44b574bcf3ec4ae8\":\"0x43c33c1937564800000\",\"0x768ce0daa029b7ded022e5fc574d11cde3ecb517\":\"0x1174a5cdf88bc80000\",\"0x7693bdeb6fc82b5bca721355223175d47a084b4d\":\"0x4a89f54ef0121c00000\",\"0x76aaf8c1ac012f8752d4c09bb46607b6651d5ca8\":\"0x1158e460913d00000\",\"0x76ab87dd5a05ad839a4e2fc8c85aa6ba05641730\":\"0x6c6b935b8bbd400000\",\"0x76afc225f4fa307de484552bbe1d9d3f15074c4a\":\"0xa290b5c7ad39680000\",\"0x76becae4a31d36f3cb577f2a43594fb1abc1bb96\":\"0x543a9ce0e1332f00000\",\"0x76c27535bcb59ce1fa2d8c919cabeb4a6bba01d1\":\"0x6c6b935b8bbd400000\",\"0x76ca22bcb8799e5327c4aa2a7d0949a1fcce5f29\":\"0x52a03f228c5ae20000\",\"0x76cac488111a4fd595f568ae3a858770fc915d5f\":\"0xad78ebc5ac6200000\",\"0x76cb9c8b69f4387675c48253e234cb7e0d74a426\":\"0x190f4482eb91dae0000\",\"0x76f83ac3da30f7092628c7339f208bfc142cb1ee\":\"0x9a18ffe7427d640000\",\"0x76f9ad3d9bbd04ae055c1477c0c35e7592cb2a20\":\"0x8833f11e3458f200000\",\"0x76ffc157ad6bf8d56d9a1a7fddbc0fea010aabf4\":\"0x3635c9adc5dea00000\",\"0x77028e409cc43a3bd33d21a9fc53ec606e94910e\":\"0xd255d112e103a00000\",\"0x770c2fb2c4a81753ac0182ea460ec09c90a516f8\":\"0x1158e460913d00000\",\"0x770d98d31b4353fceee8560c4ccf803e88c0c4e0\":\"0x2086ac351052600000\",\"0x7713ab8037411c09ba687f6f9364f0d3239fac28\":\"0x21e19e0c9bab2400000\",\"0x771507aeee6a255dc2cd9df55154062d0897b297\":\"0x121ea68c114e510000\",\"0x7719888795ad745924c75760ddb1827dffd8cda8\":\"0x6c6b4c4da6ddbe0000\",\"0x7727af101f0aaba4d23a1cafe17c6eb5dab1c6dc\":\"0x6c6b935b8bbd400000\",\"0x772c297f0ad194482ee8c3f036bdeb01c201d5cc\":\"0xad78ebc5ac6200000\",\"0x77306ffe2e4a8f3ca826c1a249f7212da43aeffd\":\"0x43c33c1937564800000\",\"0x773141127d8cf318aebf88365add3d5527d85b6a\":\"0x3636d7af5ec98e0000\",\"0x7746b6c6699c8f34ca2768a820f1ffa4c207fe05\":\"0xd8d8583fa2d52f0000\",\"0x7751f363a0a7fd0533190809ddaf9340d8d11291\":\"0x1158e460913d00000\",\"0x7757a4b9cc3d0247ccaaeb9909a0e56e1dd6dcc2\":\"0x1158e460913d00000\",\"0x775c10c93e0db7205b2643458233c64fc33fd75b\":\"0x6c6b935b8bbd400000\",\"0x77617ebc4bebc5f5ddeb1b7a70cdeb6ae2ffa024\":\"0x6acb3df27e1f880000\",\"0x776943ffb2ef5cdd35b83c28bc046bd4f4677098\":\"0xa2a15d09519be00000\",\"0x77701e2c493da47c1b58f421b5495dee45bea39b\":\"0x148f649cf6142a58000\",\"0x77798f201257b9c35204957057b54674aefa51df\":\"0x813ca56906d340000\",\"0x778c43d11afe3b586ff374192d96a7f23d2b9b7f\":\"0x8bb4fcfa3b7d6b8000\",\"0x778c79f4de1953ebce98fe8006d53a81fb514012\":\"0x36330322d5238c0000\",\"0x779274bf1803a336e4d3b00ddd93f2d4f5f4a62e\":\"0x3635c9adc5dea00000\",\"0x77a17122fa31b98f1711d32a99f03ec326f33d08\":\"0x5c283d410394100000\",\"0x77a34907f305a54c85db09c363fde3c47e6ae21f\":\"0x35659ef93f0fc40000\",\"0x77a769fafdecf4a638762d5ba3969df63120a41d\":\"0x6c6b935b8bbd400000\",\"0x77be6b64d7c733a436adec5e14bf9ad7402b1b46\":\"0x3635c9adc5dea00000\",\"0x77bfe93ccda750847e41a1affee6b2da96e7214e\":\"0x1043561a8829300000\",\"0x77c4a697e603d42b12056cbba761e7f51d0443f5\":\"0x24dce54d34a1a00000\",\"0x77cc02f623a9cf98530997ea67d95c3b491859ae\":\"0x497303c36ea0c20000\",\"0x77d43fa7b481dbf3db530cfbf5fdced0e6571831\":\"0x6c6b935b8bbd400000\",\"0x77da5e6c72fb36bce1d9798f7bcdf1d18f459c2e\":\"0x13695bb6cf93e0000\",\"0x77f4e3bdf056883cc87280dbe640a18a0d02a207\":\"0xa81993a2bfb5b0000\",\"0x77f609ca8720a023262c55c46f2d26fb3930ac69\":\"0xf015f25736420000\",\"0x77f81b1b26fc84d6de97ef8b9fbd72a33130cc4a\":\"0x3635c9adc5dea00000\",\"0x7819b0458e314e2b53bfe00c38495fd4b9fdf8d6\":\"0x1158e460913d00000\",\"0x781b1501647a2e06c0ed43ff197fccec35e1700b\":\"0xa2a15d09519be00000\",\"0x782f52f0a676c77716d574c81ec4684f9a020a97\":\"0x2e14e206b730ad8000\",\"0x78355df0a230f83d032c703154414de3eedab557\":\"0x6c6b935b8bbd400000\",\"0x7836f7ef6bc7bd0ff3acaf449c84dd6b1e2c939f\":\"0xe08de7a92cd97c0000\",\"0x7837fcb876da00d1eb3b88feb3df3fa4042fac82\":\"0x5f68e8131ecf800000\",\"0x783eec8aa5dac77b2e6623ed5198a431abbaee07\":\"0x17da3a04c7b3e00000\",\"0x785c8ea774d73044a734fa790a1b1e743e77ed7c\":\"0xcf152640c5c830000\",\"0x7860a3de38df382ae4a4dce18c0c07b98bce3dfa\":\"0x3635c9adc5dea00000\",\"0x78634371e17304cbf339b1452a4ce438dc764cce\":\"0x21e19e0c9bab2400000\",\"0x7864dc999fe4f8e003c0f43decc39aae1522dc0f\":\"0x51e102bd8ece00000\",\"0x78746a958dced4c764f876508c414a68342cecb9\":\"0x2be374fe8e2c40000\",\"0x787d313fd36b053eeeaedbce74b9fb0678333289\":\"0x5c058b7842719600000\",\"0x78859c5b548b700d9284cee4b6633c2f52e529c2\":\"0xa030dcebbd2f4c0000\",\"0x788e809741a3b14a22a4b1d937c82cfea489eebe\":\"0x17b7883c06916600000\",\"0x78a1e254409fb1b55a7cb4dd8eba3b30c8bad9ef\":\"0x56bc75e2d63100000\",\"0x78a5e89900bd3f81dd71ba869d25fec65261df15\":\"0xafd812fee03d5700000\",\"0x78b978a9d7e91ee529ea4fc4b76feaf8762f698c\":\"0x6c6b935b8bbd4000000\",\"0x78ce3e3d474a8a047b92c41542242d0a08c70f99\":\"0x21e19e0c9bab2400000\",\"0x78cf8336b328db3d87813a472b9e89b75e0cf3bc\":\"0x3635c9adc5dea00000\",\"0x78d4f8c71c1e68a69a98f52fcb45da8af56ea1a0\":\"0x6c6b935b8bbd400000\",\"0x78df2681d6d602e22142d54116dea15d454957aa\":\"0x102794ad20da680000\",\"0x78e08bc533413c26e291b3143ffa7cc9afb97b78\":\"0xad78ebc5ac6200000\",\"0x78e83f80b3678c7a0a4e3e8c84dccde064426277\":\"0x61093d7c2c6d380000\",\"0x78f5c74785c5668a838072048bf8b453594ddaab\":\"0x15af1d78b58c400000\",\"0x790f91bd5d1c5cc4739ae91300db89e1c1303c93\":\"0x6c6b935b8bbd400000\",\"0x7917e5bd82a9790fd650d043cdd930f7799633db\":\"0xd8d4602c26bf6c0000\",\"0x7919e7627f9b7d54ea3b14bb4dd4649f4f39dee0\":\"0x5a87e7d7f5f6580000\",\"0x791f6040b4e3e50dcf3553f182cd97a90630b75d\":\"0xd8d726b7177a800000\",\"0x7930c2d9cbfa87f510f8f98777ff8a8448ca5629\":\"0xad6eedd17cf3b8000\",\"0x794529d09d017271359730027075b87ad83dae6e\":\"0x10ce1d3d8cb3180000\",\"0x794b51c39e53d9e762b0613b829a44b472f4fff3\":\"0x2435e0647841cc8000\",\"0x79551cede376f747e3716c8d79400d766d2e0195\":\"0x9cb37afa4ff78680000\",\"0x795ebc2626fc39b0c86294e0e837dcf523553090\":\"0x3635c9adc5dea00000\",\"0x796ebbf49b3e36d67694ad79f8ff36767ac6fab0\":\"0x34bc4fdde27c00000\",\"0x796f87ba617a2930b1670be92ed1281fb0b346e1\":\"0x6f5e86fb528280000\",\"0x797427e3dbf0feae7a2506f12df1dc40326e8505\":\"0x3635c9adc5dea00000\",\"0x797510e386f56393ced8f477378a444c484f7dad\":\"0x3635c9adc5dea00000\",\"0x797bb7f157d9feaa17f76da4f704b74dc1038341\":\"0xb50fcfafebecb00000\",\"0x7988901331e387f713faceb9005cb9b65136eb14\":\"0x6acb3df27e1f880000\",\"0x7989d09f3826c3e5af8c752a8115723a84d80970\":\"0x1686f8614cf0ad0000\",\"0x7995bd8ce2e0c67bf1c7a531d477bca1b2b97561\":\"0x14248d617829ece0000\",\"0x79aeb34566b974c35a5881dec020927da7df5d25\":\"0x6c6b935b8bbd400000\",\"0x79b120eb8806732321288f675a27a9225f1cd2eb\":\"0x85a0bf37dec9e40000\",\"0x79b48d2d6137c3854d611c01ea42427a0f597bb7\":\"0xa5aa85009e39c0000\",\"0x79b8aad879dd30567e8778d2d231c8f37ab8734e\":\"0x6c6b935b8bbd400000\",\"0x79bf2f7b6e328aaf26e0bb093fa22da29ef2f471\":\"0x61093d7c2c6d380000\",\"0x79c130c762b8765b19d2abc9a083ab8f3aad7940\":\"0xd5967be4fc3f100000\",\"0x79c1be19711f73bee4e6316ae7549459aacea2e0\":\"0x15af1d78b58c400000\",\"0x79c6002f8452ca157f1317e80a2faf24475559b7\":\"0x1158e460913d00000\",\"0x79cac6494f11ef2798748cb53285bd8e22f97cda\":\"0x6c6b935b8bbd400000\",\"0x79cfa9780ae6d87b2c31883f09276986c89a6735\":\"0x3635c9adc5dea00000\",\"0x79dba256472db4e058f2e4cdc3ea4e8a42773833\":\"0x4f2591f896a6500000\",\"0x79ed10cf1f6db48206b50919b9b697081fbdaaf3\":\"0x6c6b935b8bbd400000\",\"0x79f08e01ce0988e63c7f8f2908fade43c7f9f5c9\":\"0xfc936392801c0000\",\"0x79fd6d48315066c204f9651869c1096c14fc9781\":\"0x6c6b935b8bbd400000\",\"0x79ffb4ac13812a0b78c4a37b8275223e176bfda5\":\"0xf015f25736420000\",\"0x7a0589b143a8e5e107c9ac66a9f9f8597ab3e7ab\":\"0x51e932d76e8f7b0000\",\"0x7a0a78a9cc393f91c3d9e39a6b8c069f075e6bf5\":\"0x487a9a304539440000\",\"0x7a1370a742ec2687e761a19ac5a794329ee67404\":\"0xa2a1326761e2920000\",\"0x7a2dfc770e24368131b7847795f203f3d50d5b56\":\"0x269fec7f0361d200000\",\"0x7a33834e8583733e2d52aead589bd1affb1dd256\":\"0x3635c9adc5dea00000\",\"0x7a36aba5c31ea0ca7e277baa32ec46ce93cf7506\":\"0x43c33c1937564800000\",\"0x7a381122bada791a7ab1f6037dac80432753baad\":\"0x21e19e0c9bab2400000\",\"0x7a48d877b63a8f8f9383e9d01e53e80c528e955f\":\"0x1b1ae4d6e2ef5000000\",\"0x7a4f9b850690c7c94600dbee0ca4b0a411e9c221\":\"0x678a932062e4180000\",\"0x7a63869fc767a4c6b1cd0e0649f3634cb121d24b\":\"0x433874f632cc60000\",\"0x7a67dd043a504fc2f2fc7194e9becf484cecb1fb\":\"0xd8d726b7177a80000\",\"0x7a6b26f438d9a352449155b8876cbd17c9d99b64\":\"0x14542ba12a337c00000\",\"0x7a6d781c77c4ba1fcadf687341c1e31799e93d27\":\"0xeda838c4929080000\",\"0x7a7068e1c3375c0e599db1fbe6b2ea23b8f407d2\":\"0x6c6b935b8bbd400000\",\"0x7a74cee4fa0f6370a7894f116cd00c1147b83e59\":\"0x2b5e3af16b18800000\",\"0x7a79e30ff057f70a3d0191f7f53f761537af7dff\":\"0x15af1d78b58c400000\",\"0x7a7a4f807357a4bbe68e1aa806393210c411ccb3\":\"0x65a4da25d3016c00000\",\"0x7a8563867901206f3f2bf0fa3e1c8109cabccd85\":\"0x76d41c62494840000\",\"0x7a8797690ab77b5470bf7c0c1bba612508e1ac7d\":\"0x1e09296c3378de40000\",\"0x7a8c89c014509d56d7b68130668ff6a3ecec7370\":\"0x1043561a8829300000\",\"0x7a94b19992ceb8ce63bc92ee4b5aded10c4d9725\":\"0x38d1a8064bb64c80000\",\"0x7aa79ac04316cc8d08f20065baa6d4142897d54e\":\"0x4be4e7267b6ae00000\",\"0x7aad4dbcd3acf997df93586956f72b64d8ad94ee\":\"0xd8d726b7177a800000\",\"0x7ab256b204800af20137fabcc916a23258752501\":\"0x43c33c1937564800000\",\"0x7aba56f63a48bc0817d6b97039039a7ad62fae2e\":\"0x2086ac351052600000\",\"0x7abb10f5bd9bc33b8ec1a82d64b55b6b18777541\":\"0x43c33c1937564800000\",\"0x7ac48d40c664cc9a6d89f1c5f5c80a1c70e744e6\":\"0xa31062beeed7000000\",\"0x7ac58f6ffc4f8107ae6e30378e4e9f99c57fbb24\":\"0x22b1c8c1227a00000\",\"0x7ad3f307616f19dcb143e6444dab9c3c33611f52\":\"0x2b5e3af16b1880000\",\"0x7ad82caea1a8b4ed05319b9c9870173c814e06ee\":\"0x2164b7a04ac8a00000\",\"0x7ade5d66b944bb860c0efdc86276d58f4653f711\":\"0x6c6b935b8bbd400000\",\"0x7adfedb06d91f3cc7390450b85550270883c7bb7\":\"0x1178fa40515db40000\",\"0x7ae1c19e53c71cee4c73fae2d7fc73bf9ab5e392\":\"0x3635c9adc5dea00000\",\"0x7ae659eb3bc46852fa86fac4e21c768d50388945\":\"0xf810c1cb501b80000\",\"0x7aea25d42b2612286e99c53697c6bc4100e2dbbf\":\"0x6c6b935b8bbd400000\",\"0x7aef7b551f0b9c46e755c0f38e5b3a73fe1199f5\":\"0x50c5e761a444080000\",\"0x7b0b31ff6e24745ead8ed9bb85fc0bf2fe1d55d4\":\"0x2b5e3af16b18800000\",\"0x7b0fea1176d52159333a143c294943da36bbddb4\":\"0x1fc7da64ea14c100000\",\"0x7b11673cc019626b290cbdce26046f7e6d141e21\":\"0x1b1ae4d6e2ef500000\",\"0x7b122162c913e7146cad0b7ed37affc92a0bf27f\":\"0x51af096b2301d18000\",\"0x7b1bf53a9cbe83a7dea434579fe72aac8d2a0cd0\":\"0xad4c8316a0b0c0000\",\"0x7b1daf14891b8a1e1bd429d8b36b9a4aa1d9afbf\":\"0x1b1ae4d6e2ef500000\",\"0x7b1fe1ab4dfd0088cdd7f60163ef59ec2aee06f5\":\"0x6c6b935b8bbd400000\",\"0x7b25bb9ca8e702217e9333225250e53c36804d48\":\"0x65ea3db75546600000\",\"0x7b27d0d1f3dd3c140294d0488b783ebf4015277d\":\"0x15af1d78b58c400000\",\"0x7b4007c45e5a573fdbb6f8bd746bf94ad04a3c26\":\"0x33821f5135d259a0000\",\"0x7b43c7eea8d62355b0a8a81da081c6446b33e9e0\":\"0xd8d726b7177a800000\",\"0x7b4d2a38269069c18557770d591d24c5121f5e83\":\"0x25f273933db5700000\",\"0x7b6175ec9befc738249535ddde34688cd36edf25\":\"0x21e19e0c9bab2400000\",\"0x7b66126879844dfa34fe65c9f288117fefb449ad\":\"0x14542ba12a337c00000\",\"0x7b6a84718dd86e63338429ac811d7c8a860f21f1\":\"0x61093d7c2c6d380000\",\"0x7b712c7af11676006a66d2fc5c1ab4c479ce6037\":\"0x1b1ae4d6e2ef5000000\",\"0x7b73242d75ca9ad558d650290df17692d54cd8b8\":\"0x6c6e59e67c78540000\",\"0x7b761feb7fcfa7ded1f0eb058f4a600bf3a708cb\":\"0xf95dd2ec27cce00000\",\"0x7b827cae7ff4740918f2e030ab26cb98c4f46cf5\":\"0x194684c0b39de100000\",\"0x7b893286427e72db219a21fc4dcd5fbf59283c31\":\"0x21e19e0c9bab2400000\",\"0x7b9226d46fe751940bc416a798b69ccf0dfab667\":\"0xe3aeb5737240a00000\",\"0x7b98e23cb96beee80a168069ebba8f20edd55ccf\":\"0xba0c91587c14a0000\",\"0x7bb0fdf5a663b5fba28d9c902af0c811e252f298\":\"0xad78ebc5ac6200000\",\"0x7bb9571f394b0b1a8eba5664e9d8b5e840677bea\":\"0x11164759ffb320000\",\"0x7bb984c6dbb9e279966afafda59c01d02627c804\":\"0x1b464311d45a6880000\",\"0x7bbbec5e70bdead8bb32b42805988e9648c0aa97\":\"0x3636d7af5ec98e0000\",\"0x7bca1da6c80a66baa5db5ac98541c4be276b447d\":\"0x24cf049680fa3c0000\",\"0x7bddb2ee98de19ee4c91f661ee8e67a91d054b97\":\"0x3635c9adc5dea00000\",\"0x7be2f7680c802da6154c92c0194ae732517a7169\":\"0xfc936392801c0000\",\"0x7be7f2456971883b9a8dbe4c91dec08ac34e8862\":\"0xa2a15d09519be00000\",\"0x7be8ccb4f11b66ca6e1d57c0b5396221a31ba53a\":\"0x1158e460913d00000\",\"0x7beb81fb2f5e91526b2ac9795e76c69bcff04bc0\":\"0xeb22e794f0a8d600000\",\"0x7c0883054c2d02bc7a852b1f86c42777d0d5c856\":\"0x1b1ae4d6e2ef500000\",\"0x7c0f5e072043c9ee740242197e78cc4b98cdf960\":\"0xad78ebc5ac6200000\",\"0x7c1df24a4f7fb2c7b472e0bb006cb27dcd164156\":\"0x3635c9adc5dea00000\",\"0x7c29d47d57a733f56b9b217063b513dc3b315923\":\"0xd8d726b7177a800000\",\"0x7c2b9603884a4f2e464eceb97d17938d828bc02c\":\"0xa2a15d09519be00000\",\"0x7c382c0296612e4e97e440e02d3871273b55f53b\":\"0xab640391201300000\",\"0x7c3eb713c4c9e0381cd8154c7c9a7db8645cde17\":\"0xad78ebc5ac6200000\",\"0x7c4401ae98f12ef6de39ae24cf9fc51f80eba16b\":\"0xad78ebc5ac6200000\",\"0x7c45f0f8442a56dbd39dbf159995415c52ed479b\":\"0x6c6b935b8bbd400000\",\"0x7c532db9e0c06c26fd40acc56ac55c1ee92d3c3a\":\"0x3f870857a3e0e3800000\",\"0x7c60a05f7a4a5f8cf2784391362e755a8341ef59\":\"0x6694f0182a37ae0000\",\"0x7c60e51f0be228e4d56fdd2992c814da7740c6bc\":\"0xad78ebc5ac6200000\",\"0x7c6924d07c3ef5891966fe0a7856c87bef9d2034\":\"0x6c6b935b8bbd400000\",\"0x7c8bb65a6fbb49bd413396a9d7e31053bbb37aa9\":\"0x14542ba12a337c00000\",\"0x7c9a110cb11f2598b2b20e2ca400325e41e9db33\":\"0x581767ba6189c400000\",\"0x7cbca88fca6a0060b960985c9aa1b02534dc2208\":\"0x19127a1391ea2a0000\",\"0x7cbeb99932e97e6e02058cfc62d0b26bc7cca52b\":\"0x6c6b935b8bbd400000\",\"0x7cc24a6a958c20c7d1249660f7586226950b0d9a\":\"0x6acb3df27e1f880000\",\"0x7cd20eccb518b60cab095b720f571570caaa447e\":\"0x1b1ae4d6e2ef500000\",\"0x7cd5d81eab37e11e6276a3a1091251607e0d7e38\":\"0x3684d5ef981f40000\",\"0x7cdf74213945953db39ad0e8a9781add792e4d1d\":\"0x6c6b935b8bbd400000\",\"0x7ce4686446f1949ebed67215eb0d5a1dd72c11b8\":\"0x7839d321b81ab80000\",\"0x7cef4d43aa417f9ef8b787f8b99d53f1fea1ee88\":\"0x678a932062e4180000\",\"0x7d0350e40b338dda736661872be33f1f9752d755\":\"0x2b4f5a6f191948000\",\"0x7d04d2edc058a1afc761d9c99ae4fc5c85d4c8a6\":\"0x42a9c4675c9467d00000\",\"0x7d0b255efb57e10f7008aa22d40e9752dfcf0378\":\"0x19f8e7559924c0000\",\"0x7d13d6705884ab2157dd8dcc7046caf58ee94be4\":\"0x1d0da07cbb3ee9c00000\",\"0x7d273e637ef1eac481119413b91c989dc5eac122\":\"0x1b1ae4d6e2ef500000\",\"0x7d2a52a7cf0c8436a8e007976b6c26b7229d1e15\":\"0x17bf06b32a241c0000\",\"0x7d34803569e00bd6b59fff081dfa5c0ab4197a62\":\"0x5cd87cb7b9fb860000\",\"0x7d34ff59ae840a7413c6ba4c5bb2ba2c75eab018\":\"0xa2a15d09519be00000\",\"0x7d392852f3abd92ff4bb5bb26cb60874f2be6795\":\"0x3636c25e66ece70000\",\"0x7d445267c59ab8d2a2d9e709990e09682580c49f\":\"0x3635c9adc5dea00000\",\"0x7d551397f79a2988b064afd0efebee802c7721bc\":\"0x857e0d6f1da76a00000\",\"0x7d5aa33fc14b51841a06906edb2bb49c2a117269\":\"0x104400a2470e680000\",\"0x7d5d2f73949dadda0856b206989df0078d51a1e5\":\"0x23c757072b8dd000000\",\"0x7d6e990daa7105de2526339833f77b5c0b85d84f\":\"0x43c33c1937564800000\",\"0x7d73863038ccca22f96affda10496e51e1e6cd48\":\"0x1158e460913d00000\",\"0x7d7dd5ee614dbb6fbfbcd26305247a058c41faa1\":\"0x6c6b935b8bbd400000\",\"0x7d7e7c61779adb7706c94d32409a2bb4e994bf60\":\"0x2ef20d9fc71a140000\",\"0x7d82e523cc2dc591da3954e8b6bb2caf6461e69c\":\"0x7d8dc2efffb1a90000\",\"0x7d858493f07415e0912d05793c972113eae8ae88\":\"0x628dd177d2bc280000\",\"0x7d901b28bf7f88ef73d8f73cca97564913ea8a24\":\"0x33c5499031720c0000\",\"0x7d980f4b566bb045517e4c14c87750de9346744b\":\"0x487a9a304539440000\",\"0x7d9c59631e2ba2e8e82891f3979922aaa3b567a1\":\"0x1b1ae4d6e2ef5000000\",\"0x7d9d221a3df89ddd7b5f61c1468c6787d6b333e6\":\"0x77b227cd83be80000\",\"0x7da7613445a21299aa74f0ad71431ec43fbb1be9\":\"0x3afb087b876900000\",\"0x7db4c7d5b797e9296e6382f203693db409449d62\":\"0x15af1d78b58c400000\",\"0x7db9eacc52e429dc83b461c5f4d86010e5383a28\":\"0x3635c9adc5dea00000\",\"0x7dd46da677e161825e12e80dc446f58276e1127c\":\"0x2c73c937742c500000\",\"0x7dd8d7a1a34fa1f8e73ccb005fc2a03a15b8229c\":\"0xad78ebc5ac6200000\",\"0x7ddd57165c87a2707f025dcfc2508c09834759bc\":\"0x4be4e7267b6ae00000\",\"0x7de442c82386154d2e993cbd1280bb7ca6b12ada\":\"0xd8f2e8247ec9480000\",\"0x7de7fe419cc61f91f408d234cc80d5ca3d054d99\":\"0x1158e460913d00000\",\"0x7dece6998ae1900dd3770cf4b93812bad84f0322\":\"0x56bc75e2d63100000\",\"0x7dfc342dffcf45dfee74f84c0995397bd1a63172\":\"0xd8d726b7177a80000\",\"0x7dfd2962b575bcbeee97f49142d63c30ab009f66\":\"0xd8d726b7177a800000\",\"0x7e1e29721d6cb91057f6c4042d8a0bbc644afe73\":\"0x8a9aba557e36c0000\",\"0x7e236666b2d06e63ea4e2ab84357e2dfc977e50e\":\"0x36356633ebd8ea0000\",\"0x7e24d9e22ce1da3ce19f219ccee523376873f367\":\"0x13fd9079caa60ff0000\",\"0x7e24fbdad290175eb2df6d180a19b9a9f41370be\":\"0x3635c9adc5dea00000\",\"0x7e268f131ddf687cc325c412f78ba961205e9112\":\"0x36364ee7d301b3c0000\",\"0x7e29290038493559194e946d4e460b96fc38a156\":\"0x10c13c527763880000\",\"0x7e2ba86da52e785d8625334f3397ba1c4bf2e8d1\":\"0xaadec983fcff40000\",\"0x7e3f63e13129a221ba1ab06326342cd98b5126ae\":\"0x56a02659a523340000\",\"0x7e47637e97c14622882be057bea229386f4052e5\":\"0x17da3a04c7b3e00000\",\"0x7e4e9409704121d1d77997026ff06ea9b19a8b90\":\"0x8d16549ed58fa40000\",\"0x7e59dc60be8b2fc19abd0a5782c52c28400bce97\":\"0x3635c9adc5dea00000\",\"0x7e5b19ae1be94ff4dee635492a1b012d14db0213\":\"0x56bc75e2d63100000\",\"0x7e5d9993104e4cb545e179a2a3f971f744f98482\":\"0x6c6b935b8bbd400000\",\"0x7e71171f2949fa0c3ac254254b1f0440e5e6a038\":\"0x22b1c8c1227a00000\",\"0x7e7c1e9a61a08a83984835c70ec31d34d3eaa87f\":\"0xa5aa85009e39c0000\",\"0x7e7f18a02eccaa5d61ab8fbf030343c434a25ef7\":\"0x39fbae8d042dd0000\",\"0x7e81f6449a03374191f3b7cb05d938b72e090dff\":\"0x56bc75e2d63100000\",\"0x7e8649e690fc8c1bfda1b5e186581f649b50fe33\":\"0x556f64c1fe7fa0000\",\"0x7e87863ec43a481df04d017762edcb5caa629b5a\":\"0x222c8eb3ff6640000\",\"0x7e8f96cc29f57b0975120cb593b7dd833d606b53\":\"0xaadec983fcff40000\",\"0x7e972a8a7c2a44c93b21436c38d21b9252c345fe\":\"0x61093d7c2c6d380000\",\"0x7e99dfbe989d3ba529d19751b7f4317f8953a3e2\":\"0x15af1d78b58c400000\",\"0x7ea0f96ee0a573a330b56897761f3d4c0130a8e3\":\"0x487a9a304539440000\",\"0x7ea791ebab0445a00efdfc4e4a8e9a7e7565136d\":\"0xfc936392801c0000\",\"0x7eaba035e2af3793fd74674b102540cf190addb9\":\"0x45026c835b60440000\",\"0x7eb4b0185c92b6439a08e7322168cb353c8a774a\":\"0x227196ca04983ca0000\",\"0x7ebd95e9c470f7283583dc6e9d2c4dce0bea8f84\":\"0x2f6f10780d22cc00000\",\"0x7ed0a5a847bef9a9da7cba1d6411f5c316312619\":\"0x228eb37e8751d0000\",\"0x7edafba8984baf631a820b6b92bbc2c53655f6bd\":\"0x6c6b935b8bbd400000\",\"0x7edb02c61a227287611ad950696369cc4e647a68\":\"0xeda838c4929080000\",\"0x7ee5ca805dce23af89c2d444e7e40766c54c7404\":\"0xd0bd412edbd820000\",\"0x7ee604c7a9dc2909ce321de6b9b24f5767577555\":\"0x12bf9c7985cf62d8000\",\"0x7ef16fd8d15b378a0fba306b8d03dd98fc92619f\":\"0x25f273933db5700000\",\"0x7ef98b52bee953bef992f305fda027f8911c5851\":\"0x1be722206996bc8000\",\"0x7efc90766a00bc52372cac97fabd8a3c831f8ecd\":\"0x890b0c2e14fb80000\",\"0x7efec0c6253caf397f71287c1c07f6c9582b5b86\":\"0x1a2cbcb84f30d58000\",\"0x7f01dc7c3747ca608f983dfc8c9b39e755a3b914\":\"0xb386cad5f7a5a0000\",\"0x7f0662b410298c99f311d3a1454a1eedba2fea76\":\"0xad78ebc5ac6200000\",\"0x7f06c89d59807fa60bc60136fcf814cbaf2543bd\":\"0x21e19e0c9bab2400000\",\"0x7f0b90a1fdd48f27b268feb38382e55ddb50ef0f\":\"0x32f51edbaaa3300000\",\"0x7f0ec3db804692d4d1ea3245365aab0590075bc4\":\"0xd8d726b7177a800000\",\"0x7f0f04fcf37a53a4e24ede6e93104e78be1d3c9e\":\"0x6c6b935b8bbd400000\",\"0x7f13d760498d7193ca6859bc95c901386423d76c\":\"0x10f0cf064dd59200000\",\"0x7f150afb1a77c2b45928c268c1e9bdb4641d47d8\":\"0x6c6b935b8bbd400000\",\"0x7f1619988f3715e94ff1d253262dc5581db3de1c\":\"0x30ca024f987b900000\",\"0x7f1c81ee1697fc144b7c0be5493b5615ae7fddca\":\"0x1b1dab61d3aa640000\",\"0x7f2382ffd8f83956467937f9ba72374623f11b38\":\"0x2086ac351052600000\",\"0x7f3709391f3fbeba3592d175c740e87a09541d02\":\"0x1a055690d9db800000\",\"0x7f389c12f3c6164f6446566c77669503c2792527\":\"0x556f64c1fe7fa0000\",\"0x7f3a1e45f67e92c880e573b43379d71ee089db54\":\"0x152d02c7e14af6800000\",\"0x7f3d7203c8a447f7bf36d88ae9b6062a5eee78ae\":\"0x14542ba12a337c00000\",\"0x7f46bb25460dd7dae4211ca7f15ad312fc7dc75c\":\"0x16a6502f15a1e540000\",\"0x7f49e7a4269882bd8722d4a6f566347629624079\":\"0x6c6b935b8bbd400000\",\"0x7f49f20726471ac1c7a83ef106e9775ceb662566\":\"0x14061b9d77a5e980000\",\"0x7f4b5e278578c046cceaf65730a0e068329ed5b6\":\"0x65ea3db75546600000\",\"0x7f4f593b618c330ba2c3d5f41eceeb92e27e426c\":\"0x966edc756b7cfc0000\",\"0x7f541491d2ac00d2612f94aa7f0bcb014651fbd4\":\"0x14620c57dddae00000\",\"0x7f5ae05ae0f8cbe5dfe721f044d7a7bef4c27997\":\"0x340aad21b3b700000\",\"0x7f603aec1759ea5f07c7f8d41a1428fbbaf9e762\":\"0x1158e460913d00000\",\"0x7f616c6f008adfa082f34da7d0650460368075fb\":\"0x3635c9adc5dea00000\",\"0x7f61fa6cf5f898b440dac5abd8600d6d691fdef9\":\"0xf2dc7d47f15600000\",\"0x7f655c6789eddf455cb4b88099720639389eebac\":\"0x14542ba12a337c00000\",\"0x7f6b28c88421e4857e459281d78461692489d3fb\":\"0x6c6b935b8bbd400000\",\"0x7f6efb6f4318876d2ee624e27595f44446f68e93\":\"0x54069233bf7f780000\",\"0x7f7192c0df1c7db6d9ed65d71184d8e4155a17ba\":\"0x453728d33942c0000\",\"0x7f7a3a21b3f5a65d81e0fcb7d52dd00a1aa36dba\":\"0x56bc75e2d63100000\",\"0x7f8dbce180ed9c563635aad2d97b4cbc428906d9\":\"0x90f534608a72880000\",\"0x7f993ddb7e02c282b898f6155f680ef5b9aff907\":\"0x43c33c1937564800000\",\"0x7f9f9b56e4289dfb58e70fd5f12a97b56d35c6a5\":\"0x6acb3df27e1f880000\",\"0x7fa37ed67887751a471f0eb306be44e0dbcd6089\":\"0x3976747fe11a100000\",\"0x7faa30c31519b584e97250ed2a3cf3385ed5fd50\":\"0x6c6b935b8bbd400000\",\"0x7fcf5ba6666f966c5448c17bf1cb0bbcd8019b06\":\"0x56bc3d0aebe498000\",\"0x7fd679e5fb0da2a5d116194dcb508318edc580f3\":\"0x1639e49bba162800000\",\"0x7fdba031c78f9c096d62d05a369eeab0bccc55e5\":\"0x97c9ce4cf6d5c00000\",\"0x7fdbc3a844e40d96b2f3a635322e6065f4ca0e84\":\"0x6c6b935b8bbd400000\",\"0x7fdfc88d78bf1b285ac64f1adb35dc11fcb03951\":\"0x7c06fda02fb0360000\",\"0x7fea1962e35d62059768c749bedd96cab930d378\":\"0x6c6b935b8bbd400000\",\"0x7fef8c38779fb307ec6f044bebe47f3cfae796f1\":\"0x92340f86cf09e8000\",\"0x7ff0c63f70241bece19b737e5341b12b109031d8\":\"0x12c1b6eed03d280000\",\"0x7ffabfbc390cbe43ce89188f0868b27dcb0f0cad\":\"0x1595182224b26480000\",\"0x7ffd02ed370c7060b2ae53c078c8012190dfbb75\":\"0x21e19e0c9bab2400000\",\"0x80022a1207e910911fc92849b069ab0cdad043d3\":\"0xb98bc829a6f90000\",\"0x8009a7cbd192b3aed4adb983d5284552c16c7451\":\"0xd8d726b7177a800000\",\"0x800e7d631c6e573a90332f17f71f5fd19b528cb9\":\"0x83d6c7aab63600000\",\"0x80156d10efa8b230c99410630d37e269d4093cea\":\"0x6c6b935b8bbd400000\",\"0x801732a481c380e57ed62d6c29de998af3fa3b13\":\"0x56bc75e2d63100000\",\"0x801d65c518b11d0e3f4f470221417013c8e53ec5\":\"0xd8d726b7177a800000\",\"0x8026435aac728d497b19b3e7e57c28c563954f2b\":\"0x5dc892aa1131c80000\",\"0x802dc3c4ff2d7d925ee2859f4a06d7ba60f1308c\":\"0x550940c8fd34c0000\",\"0x8030b111c6983f0485ddaca76224c6180634789f\":\"0x4563918244f400000\",\"0x8035bcffaefdeeea35830c497d14289d362023de\":\"0x1043561a8829300000\",\"0x8035fe4e6b6af27ae492a578515e9d39fa6fa65b\":\"0xd8d726b7177a800000\",\"0x8043ed22f997e5a2a4c16e364486ae64975692c4\":\"0x3d4904ffc9112e8000\",\"0x8043fdd0bc4c973d1663d55fc135508ec5d4f4fa\":\"0x1158e460913d00000\",\"0x804ca94972634f633a51f3560b1d06c0b293b3b1\":\"0xad78ebc5ac6200000\",\"0x80522ddf944ec52e27d724ed4c93e1f7be6083d6\":\"0xad78ebc5ac6200000\",\"0x80591a42179f34e64d9df75dcd463b28686f5574\":\"0x43c33c1937564800000\",\"0x805ce51297a0793b812067f017b3e7b2df9bb1f9\":\"0x56bc75e2d63100000\",\"0x805d846fb0bc02a7337226d685be9ee773b9198a\":\"0x43c30fb0884a96c0000\",\"0x8063379a7bf2cb923a84c5093e68dac7f75481c5\":\"0x1176102e6e32df0000\",\"0x806854588ecce541495f81c28a290373df0274b2\":\"0x1f8cdf5c6e8d580000\",\"0x806f44bdeb688037015e84ff218049e382332a33\":\"0x6c5db2a4d815dc0000\",\"0x80744618de396a543197ee4894abd06398dd7c27\":\"0x6c6b935b8bbd400000\",\"0x8077c3e4c445586e094ce102937fa05b737b568c\":\"0x56bc75e2d63100000\",\"0x80907f593148b57c46c177e23d25abc4aae18361\":\"0x56bc75e2d63100000\",\"0x80977316944e5942e79b0e3abad38da746086519\":\"0x21a754a6dc5280000\",\"0x80a0f6cc186cf6201400736e065a391f52a9df4a\":\"0x21e19e0c9bab2400000\",\"0x80abec5aa36e5c9d098f1b942881bd5acac6963d\":\"0x6c6b935b8bbd400000\",\"0x80b23d380b825c46e0393899a85556462da0e18c\":\"0x6c6b935b8bbd400000\",\"0x80b42de170dbd723f454e88f7716452d92985092\":\"0x104623c0762dd10000\",\"0x80b79f338390d1ba1b3737a29a0257e5d91e0731\":\"0x1158e460913d00000\",\"0x80bf995ed8ba92701d10fec49f9e7d014dbee026\":\"0x1f0437ca1a7e128000\",\"0x80c04efd310f440483c73f744b5b9e64599ce3ec\":\"0x410d586a20a4c00000\",\"0x80c3a9f695b16db1597286d1b3a8b7696c39fa27\":\"0x56bc75e2d63100000\",\"0x80c53ee7e3357f94ce0d7868009c208b4a130125\":\"0x6c6b935b8bbd400000\",\"0x80cc21bd99f39005c58fe4a448909220218f66cb\":\"0x3636c9796436740000\",\"0x80d5c40c59c7f54ea3a55fcfd175471ea35099b3\":\"0x3635c9adc5dea00000\",\"0x80da2fdda29a9e27f9e115975e69ae9cfbf3f27e\":\"0xad78ebc5ac6200000\",\"0x80e7b3205230a566a1f061d922819bb4d4d2a0e1\":\"0x2f6f10780d22cc00000\",\"0x80ea1acc136eca4b68c842a95adf6b7fee7eb8a2\":\"0xd8d726b7177a800000\",\"0x80f07ac09e7b2c3c0a3d1e9413a544c73a41becb\":\"0x1158e460913d00000\",\"0x810db25675f45ea4c7f3177f37ce29e22d67999c\":\"0xad78ebc5ac6200000\",\"0x81139bfdcca656c430203f72958c543b6580d40c\":\"0x6c6b935b8bbd400000\",\"0x811461a2b0ca90badac06a9ea16e787b33b196cc\":\"0x8e3f50b173c100000\",\"0x81164deb10814ae08391f32c08667b6248c27d7a\":\"0x155bd9307f9fe80000\",\"0x81186931184137d1192ac88cd3e1e5d0fdb86a74\":\"0x9d3595ab2438d00000\",\"0x812a55c43caedc597218379000ce510d548836fd\":\"0xfc936392801c0000\",\"0x812ea7a3b2c86eed32ff4f2c73514cc63bacfbce\":\"0x3635c9adc5dea00000\",\"0x8134dd1c9df0d6c8a5812426bb55c761ca831f08\":\"0x6a2160bb57ccc0000\",\"0x814135da8f9811075783bf1ab67062af8d3e9f40\":\"0x1158e460913d00000\",\"0x81498ca07b0f2f17e8bbc7e61a7f4ae7be66b78b\":\"0x581fbb5b33bb00000\",\"0x81556db27349ab8b27004944ed50a46e941a0f5f\":\"0xd8bb6549b02bb80000\",\"0x8155fa6c51eb31d808412d748aa086105018122f\":\"0x65ea3db75546600000\",\"0x8156360bbd370961ceca6b6691d75006ad204cf2\":\"0x878678326eac9000000\",\"0x8161d940c3760100b9080529f8a60325030f6edc\":\"0x1043561a8829300000\",\"0x8164e78314ae16b28926cc553d2ccb16f356270d\":\"0x1ca134e95fb32c80000\",\"0x8165cab0eafb5a328fc41ac64dae715b2eef2c65\":\"0x3635c9adc5dea00000\",\"0x8168edce7f2961cf295b9fcd5a45c06cdeda6ef5\":\"0xad78ebc5ac6200000\",\"0x816d9772cf11399116cc1e72c26c6774c9edd739\":\"0xad78ebc5ac6200000\",\"0x8173c835646a672e0152be10ffe84162dd256e4c\":\"0x1aabdf2145b4300000\",\"0x817493cd9bc623702a24a56f9f82e3fd48f3cd31\":\"0x9e4b23f12d4ca00000\",\"0x8179c80970182cc5b7d82a4df06ea94db63a25f3\":\"0x276f259de66bf40000\",\"0x817ac33bd8f847567372951f4a10d7a91ce3f430\":\"0xad7c406c66dc18000\",\"0x818ffe271fc3973565c303f213f6d2da89897ebd\":\"0x136e05342fee1b98000\",\"0x8197948121732e63d9c148194ecad46e30b749c8\":\"0xd8d726b7177a800000\",\"0x819af9a1c27332b1c369bbda1b3de1c6e933d640\":\"0x1109e654b98f7a0000\",\"0x819cdaa5303678ef7cec59d48c82163acc60b952\":\"0x31351545f79816c0000\",\"0x819eb4990b5aba5547093da12b6b3c1093df6d46\":\"0x3635c9adc5dea00000\",\"0x81a88196fac5f23c3e12a69dec4b880eb7d97310\":\"0x6c6b935b8bbd400000\",\"0x81bccbff8f44347eb7fca95b27ce7c952492aaad\":\"0x840c12165dd780000\",\"0x81bd75abd865e0c3f04a0b4fdbcb74d34082fbb7\":\"0xd8d726b7177a800000\",\"0x81c18c2a238ddc4cba230a072dd7dc101e620273\":\"0x487a9a304539440000\",\"0x81c9e1aee2d3365d53bcfdcd96c7c538b0fd7eec\":\"0x62a992e53a0af00000\",\"0x81cfad760913d3c322fcc77b49c2ae3907e74f6e\":\"0xaadec983fcff40000\",\"0x81d619ff5726f2405f12904c72eb1e24a0aaee4f\":\"0x43c33c1937564800000\",\"0x81efe296ae76c860d1c5fbd33d47e8ce9996d157\":\"0x3635c9adc5dea00000\",\"0x81f8de2c283d5fd4afbda85dedf9760eabbbb572\":\"0xa2a15d09519be00000\",\"0x820c19291196505b65059d9914b7090be1db87de\":\"0x796e3ea3f8ab00000\",\"0x821cb5cd05c7ef909fe1be60733d8963d760dc41\":\"0xd8d726b7177a800000\",\"0x821d798af19989c3ae5b84a7a7283cd7fda1fabe\":\"0x43c33c1937564800000\",\"0x821eb90994a2fbf94bdc3233910296f76f9bf6e7\":\"0x21e19e0c9bab2400000\",\"0x82249fe70f61c6b16f19a324840fdc020231bb02\":\"0x20336b08a93635b0000\",\"0x8228ebc087480fd64547ca281f5eace3041453b9\":\"0x6acb3df27e1f880000\",\"0x8229ceb9f0d70839498d44e6abed93c5ca059f5d\":\"0x1a1c1b3c989a20100000\",\"0x822edff636563a6106e52e9a2598f7e6d0ef2782\":\"0x1f4f9693d42d38000\",\"0x823219a25976bb2aa4af8bad41ac3526b493361f\":\"0x6c6b935b8bbd400000\",\"0x8232d1f9742edf8dd927da353b2ae7b4cbce7592\":\"0x243d4d18229ca20000\",\"0x8234f463d18485501f8f85ace4972c9b632dbccc\":\"0x6c6b935b8bbd400000\",\"0x823768746737ce6da312d53e54534e106f967cf3\":\"0x1158e460913d00000\",\"0x823ba7647238d113bce9964a43d0a098118bfe4d\":\"0xad78ebc5ac6200000\",\"0x824074312806da4748434266ee002140e3819ac2\":\"0x51b1d3839261ac0000\",\"0x82438fd2b32a9bdd674b49d8cc5fa2eff9781847\":\"0x1158e460913d00000\",\"0x82485728d0e281563758c75ab27ed9e882a0002d\":\"0x7f808e9291e6c0000\",\"0x824b3c3c443e19295d7ef6faa7f374a4798486a8\":\"0x1158e460913d00000\",\"0x8251358ca4e060ddb559ca58bc0bddbeb4070203\":\"0x6c6b935b8bbd400000\",\"0x825135b1a7fc1605614c8aa4d0ac6dbad08f480e\":\"0x4d853c8f8908980000\",\"0x825309a7d45d1812f51e6e8df5a7b96f6c908887\":\"0x8034f7d9b166d40000\",\"0x825a7f4e10949cb6f8964268f1fa5f57e712b4c4\":\"0x1158e460913d00000\",\"0x8261fa230c901d43ff579f4780d399f31e6076bc\":\"0x6c6b935b8bbd400000\",\"0x8262169b615870134eb4ac6c5f471c6bf2f789fc\":\"0x19127a1391ea2a0000\",\"0x8263ece5d709e0d7ae71cca868ed37cd2fef807b\":\"0x35ab028ac154b80000\",\"0x826ce5790532e0548c6102a30d3eac836bd6388f\":\"0x3cfc82e37e9a7400000\",\"0x826eb7cd7319b82dd07a1f3b409071d96e39677f\":\"0x3635c9adc5dea00000\",\"0x827531a6c5817ae35f82b00b9754fcf74c55e232\":\"0xc328093e61ee400000\",\"0x8275cd684c3679d5887d03664e338345dc3cdde1\":\"0xdb44e049bb2c0000\",\"0x8284923b62e68bbf7c2b9f3414d13ef6c812a904\":\"0xd255d112e103a00000\",\"0x828ba651cb930ed9787156299a3de44cd08b7212\":\"0x487a9a304539440000\",\"0x82a15cef1d6c8260eaf159ea3f0180d8677dce1c\":\"0x6c6b935b8bbd400000\",\"0x82a8b96b6c9e13ebec1e9f18ac02a60ea88a48ff\":\"0x6c6b8c408e73b30000\",\"0x82a8cbbfdff02b2e38ae4bbfca15f1f0e83b1aea\":\"0x49b991c27ef6d8000\",\"0x82e4461eb9d849f0041c1404219e4272c4900ab4\":\"0x6c6b935b8bbd400000\",\"0x82e577b515cb2b0860aafe1ce09a59e09fe7d040\":\"0x2086ac351052600000\",\"0x82ea01e3bf2e83836e71704e22a2719377efd9c3\":\"0xa4cc799563c3800000\",\"0x82f2e991fd324c5f5d17768e9f61335db6319d6c\":\"0x1b1ae4d6e2ef500000\",\"0x82f39b2758ae42277b86d69f75e628d958ebcab0\":\"0x878678326eac9000000\",\"0x82f854c9c2f087dffa985ac8201e626ca5467686\":\"0x152d02c7e14af6800000\",\"0x82ff716fdf033ec7e942c909d9831867b8b6e2ef\":\"0x61093d7c2c6d380000\",\"0x8308ed0af7f8a3c1751fafc877b5a42af7d35882\":\"0x3635c9adc5dea00000\",\"0x831c44b3084047184b2ad218680640903750c45d\":\"0x6acb3df27e1f880000\",\"0x83210583c16a4e1e1dac84ebd37e3d0f7c57eba4\":\"0x6c6b935b8bbd400000\",\"0x832c54176bdf43d2c9bcd7b808b89556b89cbf31\":\"0xad78ebc5ac6200000\",\"0x833316985d47742bfed410604a91953c05fb12b0\":\"0x6c6b935b8bbd400000\",\"0x8334764b7b397a4e578f50364d60ce44899bff94\":\"0x503b203e9fba20000\",\"0x833b6a8ec8da408186ac8a7d2a6dd61523e7ce84\":\"0x3635c9adc5dea000000\",\"0x833d3fae542ad5f8b50ce19bde2bec579180c88c\":\"0x12c1b6eed03d280000\",\"0x833db42c14163c7be4cab86ac593e06266d699d5\":\"0x24e40d2b6943ef900000\",\"0x83563bc364ed81a0c6da3b56ff49bbf267827a9c\":\"0x3ab91d17b20de500000\",\"0x837a645dc95c49549f899c4e8bcf875324b2f57c\":\"0x208c394af1c8880000\",\"0x838bd565f99fde48053f7917fe333cf84ad548ab\":\"0xad78ebc5ac6200000\",\"0x83908aa7478a6d1c9b9b0281148f8f9f242b9fdc\":\"0x6c6b935b8bbd400000\",\"0x8392e53776713578015bff4940cf43849d7dcba1\":\"0x84df0355d56170000\",\"0x8397a1bc47acd647418159b99cea57e1e6532d6e\":\"0x1f10fa827b550b40000\",\"0x8398e07ebcb4f75ff2116de77c1c2a99f303a4cf\":\"0x1b1ae4d6e2ef500000\",\"0x83a3148833d9644984f7c475a7850716efb480ff\":\"0xb8507a820728200000\",\"0x83a402438e0519773d5448326bfb61f8b20cf52d\":\"0x52663ccab1e1c00000\",\"0x83a93b5ba41bf88720e415790cdc0b67b4af34c4\":\"0xad78ebc5ac6200000\",\"0x83c23d8a502124ee150f08d71dc6727410a0f901\":\"0x7331f3bfe661b180000\",\"0x83c897a84b695eebe46679f7da19d776621c2694\":\"0x1b1ae4d6e2ef500000\",\"0x83d532d38d6dee3f60adc68b936133c7a2a1b0dd\":\"0x1b1ae4d6e2ef500000\",\"0x83dbf8a12853b40ac61996f8bf1dc8fdbaddd329\":\"0x34957444b840e80000\",\"0x83dbfd8eda01d0de8e158b16d0935fc2380a5dc7\":\"0x2086ac351052600000\",\"0x83e48055327c28b5936fd9f4447e73bdb2dd3376\":\"0x90f534608a72880000\",\"0x83fe5a1b328bae440711beaf6aad6026eda6d220\":\"0x43c33c1937564800000\",\"0x84008a72f8036f3feba542e35078c057f32a8825\":\"0x56bc75e2d63100000\",\"0x840ec83ea93621f034e7bb3762bb8e29ded4c479\":\"0x878678326eac900000\",\"0x841145b44840c946e21dbc190264b8e0d5029369\":\"0x3f870857a3e0e3800000\",\"0x84232107932b12e03186583525ce023a703ef8d9\":\"0x6c6b935b8bbd400000\",\"0x84244fc95a6957ed7c1504e49f30b8c35eca4b79\":\"0x6c6b935b8bbd400000\",\"0x8431277d7bdd10457dc017408c8dbbbd414a8df3\":\"0x222c8eb3ff6640000\",\"0x84375afbf59b3a1d61a1be32d075e0e15a4fbca5\":\"0xad78ebc5ac6200000\",\"0x843bd3502f45f8bc4da370b323bdac3fcf5f19a6\":\"0x50039d63d11c900000\",\"0x84503334630d77f74147f68b2e086613c8f1ade9\":\"0x56bc75e2d631000000\",\"0x845203750f7148a9aa262921e86d43bf641974fd\":\"0x56bc75e2d63100000\",\"0x8461ecc4a6a45eb1a5b947fb86b88069b91fcd6f\":\"0x6c6b935b8bbd400000\",\"0x84675e9177726d45eaa46b3992a340ba7f710c95\":\"0x3635c9adc5dea00000\",\"0x84686c7bad762c54b667d59f90943cd14d117a26\":\"0x1158e460913d00000\",\"0x8489f6ad1d9a94a297789156899db64154f1dbb5\":\"0x137407c03c8c268000\",\"0x848c994a79003fe7b7c26cc63212e1fc2f9c19eb\":\"0x6c6b935b8bbd400000\",\"0x848fbd29d67cf4a013cb02a4b176ef244e9ee68d\":\"0x1172a636bbdc20000\",\"0x84949dba559a63bfc845ded06e9f2d9b7f11ef24\":\"0x6c6b935b8bbd400000\",\"0x849ab80790b28ff1ffd6ba394efc7463105c36f7\":\"0x1e02be4ae6c840000\",\"0x849b116f596301c5d8bb62e0e97a8248126e39f3\":\"0x1043561a8829300000\",\"0x84a74ceecff65cb93b2f949d773ef1ad7fb4a245\":\"0x50a9b444685c70000\",\"0x84aac7fa197ff85c30e03b7a5382b957f41f3afb\":\"0x88b23acffd9900000\",\"0x84af1b157342d54368260d17876230a534b54b0e\":\"0x35659ef93f0fc40000\",\"0x84b0ee6bb837d3a4c4c5011c3a228c0edab4634a\":\"0x1158e460913d00000\",\"0x84b4b74e6623ba9d1583e0cfbe49643f16384149\":\"0x1158e460913d00000\",\"0x84b6b6adbe2f5b3e2d682c66af1bc4905340c3ed\":\"0x2192f8d22215008000\",\"0x84b91e2e2902d05e2b591b41083bd7beb2d52c74\":\"0x215e5128b4504648000\",\"0x84bcbf22c09607ac84341d2edbc03bfb1739d744\":\"0x1b1ae4d6e2ef500000\",\"0x84bfcef0491a0ae0694b37ceac024584f2aa0467\":\"0x6c6acc67d7b1d40000\",\"0x84cb7da0502df45cf561817bbd2362f451be02da\":\"0x487a9a304539440000\",\"0x84cc7878da605fdb019fab9b4ccfc157709cdda5\":\"0x48798513af04c90000\",\"0x84db1459bb00812ea67ecb3dc189b72187d9c501\":\"0x811b8fbda85ab8000\",\"0x84e9949680bece6841b9a7e5250d08acd87d16cd\":\"0xad78ebc5ac6200000\",\"0x84e9cf8166c36abfa49053b7a1ad4036202681ef\":\"0x6c6b935b8bbd400000\",\"0x84ec06f24700fe42414cb9897c154c88de2f6132\":\"0x487a9a304539440000\",\"0x84f522f0520eba52dd18ad21fa4b829f2b89cb97\":\"0x10c5106d5134f130000\",\"0x850b9db18ff84bf0c7da49ea3781d92090ad7e64\":\"0x8cf23f909c0fa00000\",\"0x8510ee934f0cbc900e1007eb38a21e2a5101b8b2\":\"0x5bf0ba6634f680000\",\"0x8516fcaf77c893970fcd1a958ba9a00e49044019\":\"0xaa3eb1691bce58000\",\"0x851aa91c82f42fad5dd8e8bb5ea69c8f3a5977d1\":\"0x80e561f2578798000\",\"0x851c0d62be4635d4777e8035e37e4ba8517c6132\":\"0x1b1ae4d6e2ef500000\",\"0x851dc38adb4593729a76f33a8616dab6f5f59a77\":\"0x56bc75e2d63100000\",\"0x8532490897bbb4ce8b7f6b837e4cba848fbe9976\":\"0x56bc75e2d63100000\",\"0x853e6abaf44469c72f151d4e223819aced4e3728\":\"0x6c6b935b8bbd400000\",\"0x854691ce714f325ced55ce5928ce9ba12facd1b8\":\"0xed70b5e9c3f2f00000\",\"0x854c0c469c246b83b5d1b3eca443b39af5ee128a\":\"0x56bc75e2d631000000\",\"0x855d9aef2c39c6230d09c99ef6494989abe68785\":\"0x8ba52e6fc45e40000\",\"0x8563c49361b625e768771c96151dbfbd1c906976\":\"0x6c6b935b8bbd400000\",\"0x8566610901aace38b83244f3a9c831306a67b9dc\":\"0xb08213bcf8ffe00000\",\"0x856aa23c82d7215bec8d57f60ad75ef14fa35f44\":\"0x43c33c1937564800000\",\"0x856e5ab3f64c9ab56b009393b01664fc0324050e\":\"0x61093d7c2c6d380000\",\"0x856eb204241a87830fb229031343dc30854f581a\":\"0x3635c9adc5dea00000\",\"0x85732c065cbd64119941aed430ac59670b6c51c4\":\"0x27a57362ab0a0e8000\",\"0x8578e10212ca14ff0732a8241e37467db85632a9\":\"0x14542ba12a337c00000\",\"0x8579dadf1a395a3471e20b6f763d9a0ff19a3f6f\":\"0xd8d726b7177a800000\",\"0x857f100b1a5930225efc7e9020d78327b41c02cb\":\"0x6c6b935b8bbd400000\",\"0x85946d56a4d371a93368539690b60ec825107454\":\"0x5dc892aa1131c80000\",\"0x8599cbd5a6a9dcd4b966be387d69775da5e33c6f\":\"0xc51f1b1d52622900000\",\"0x859c600cf13d1d0273d5d1da3cd789e495899f27\":\"0x90f534608a72880000\",\"0x85a2f6ea94d05e8c1d9ae2f4910338a358e98ded\":\"0x6c6b935b8bbd400000\",\"0x85b16f0b8b34dff3804f69e2168a4f7b24d1042b\":\"0x112f423c7646d40000\",\"0x85b2998d0c73302cb2ba13f489313301e053be15\":\"0x21e19e0c9bab2400000\",\"0x85bb51bc3bfe9a1b2a2f6b1cda95bca8b38c8d5e\":\"0x11712da04ba1ef0000\",\"0x85c8f3cc7a354feac99a5e7bfe7cdfa351cfe355\":\"0x15af1d78b58c400000\",\"0x85ca1e727e9d1a87991cc2c41840ebb9edf21d1b\":\"0xb98bc829a6f90000\",\"0x85ca8bc6da2803d0725f5e1a456c89f9bc774e2f\":\"0x2086ac351052600000\",\"0x85d0d88754ac84b8b21ba93dd2bfec72626faba8\":\"0x3635c9adc5dea00000\",\"0x85eb256b51c819d60ea61a82d12c9358d59c1cae\":\"0x18efc84ad0c7b00000\",\"0x85f0e7c1e3aff805a627a2aaf2cff6b4c0dbe9cb\":\"0x1158e460913d00000\",\"0x86026cad3fe4ea1ce7fca260d3d45eb09ea6a364\":\"0xad78ebc5ac6200000\",\"0x860f5ffc10de767ded807f71e861d647dfd219b1\":\"0x21e19e0c9bab2400000\",\"0x86153063a1ae7f02f1a88136d4d69c7c5e3e4327\":\"0x3635c9adc5dea00000\",\"0x86245f596691093ece3f3d3ca2263eace81941d9\":\"0xa31062beeed700000\",\"0x862569211e8c6327b5415e3a67e5738b15baaf6e\":\"0x796e3ea3f8ab00000\",\"0x86297d730fe0f7a9ee24e08fb1087b31adb306a7\":\"0x6c6b935b8bbd400000\",\"0x8644cc281be332ccced36da483fb2a0746d9ba2e\":\"0x15af1d78b58c400000\",\"0x86499a1228ff2d7ee307759364506f8e8c8307a5\":\"0x6acb3df27e1f880000\",\"0x864bec5069f855a4fd5892a6c4491db07c88ff7c\":\"0x3635c9adc5dea00000\",\"0x86570ab259c9b1c32c9729202f77f590c07dd612\":\"0xad78ebc5ac6200000\",\"0x8663a241a0a89e70e182c845e2105c8ad7264bcf\":\"0x323b13d8398f3238000\",\"0x8667fa1155fed732cfb8dca5a0d765ce0d0705ed\":\"0x46ec965c393b10000\",\"0x8668af868a1e98885f937f2615ded6751804eb2d\":\"0x1158e460913d00000\",\"0x86740a46648e845a5d96461b18091ff57be8a16f\":\"0x14c0973485bf39400000\",\"0x867eba56748a5904350d2ca2a5ce9ca00b670a9b\":\"0x43c33c1937564800000\",\"0x86806474c358047d9406e6a07f40945bc8328e67\":\"0x1752eb0f7013d100000\",\"0x86883d54cd3915e549095530f9ab1805e8c5432d\":\"0xd8d726b7177a800000\",\"0x868c23be873466d4c74c220a19b245d1787e807f\":\"0x4a13bbbd92c88e8000\",\"0x86924fb211aad23cf5ce600e0aae806396444087\":\"0x21e19e0c9bab2400000\",\"0x8693e9b8be94425eef7969bc69f9d42f7cad671e\":\"0x3637096c4bcc690000\",\"0x869f1aa30e4455beb1822091de5cadec79a8f946\":\"0x1b1ae4d6e2ef5000000\",\"0x86a1eadeeb30461345d9ef6bd05216fa247c0d0c\":\"0x6c6b935b8bbd400000\",\"0x86a5f8259ed5b09e188ce346ee92d34aa5dd93fa\":\"0xad78ebc5ac6200000\",\"0x86b7bd563ceab686f96244f9ddc02ad7b0b14bc2\":\"0x21e19e0c9bab2400000\",\"0x86c28b5678af37d727ec05e4447790f15f71f2ea\":\"0xad78ebc5ac6200000\",\"0x86c4ce06d9ac185bb148d96f7b7abe73f441006d\":\"0x21e19e0c9bab2400000\",\"0x86c8d0d982b539f48f9830f9891f9d607a942659\":\"0x2ced37761824fb00000\",\"0x86c934e38e53be3b33f274d0539cfca159a4d0d1\":\"0x34957444b840e80000\",\"0x86ca0145957e6b0dfe36875fbe7a0dec55e17a28\":\"0x21e19e0c9bab2400000\",\"0x86caafacf32aa0317c032ac36babed974791dc03\":\"0x878678326eac9000000\",\"0x86cdb7e51ac44772be3690f61d0e59766e8bfc18\":\"0xd8d726b7177a800000\",\"0x86df73bd377f2c09de63c45d67f283eaefa0f4ab\":\"0x3635c9adc5dea00000\",\"0x86e3fe86e93da486b14266eadf056cbfa4d91443\":\"0x6c6b935b8bbd400000\",\"0x86e8670e27598ea09c3899ab7711d3b9fe901c17\":\"0xad78ebc5ac6200000\",\"0x86ef6426211949cc37f4c75e7850369d0cf5f479\":\"0x2d65f32ea045af60000\",\"0x86f05d19063e9369c6004eb3f123943a7cff4eab\":\"0x6c6acc67d7b1d40000\",\"0x86f23e9c0aafc78b9c404dcd60339a925bffa266\":\"0x15af1d78b58c400000\",\"0x86f4f40ad984fbb80933ae626e0e42f9333fdd41\":\"0x3635c9adc5dea00000\",\"0x86f95c5b11a293940e35c0b898d8b75f08aab06d\":\"0x644e3e875fccf740000\",\"0x86fff220e59305c09f483860d6f94e96fbe32f57\":\"0x2535b6ab4c0420000\",\"0x870796abc0db84af82da52a0ed68734de7e636f5\":\"0x1043561a8829300000\",\"0x870f15e5df8b0eabd02569537a8ef93b56785c42\":\"0x150894e849b3900000\",\"0x87183160d172d2e084d327b86bcb7c1d8e6784ef\":\"0xd8d8583fa2d52f0000\",\"0x871b8a8b51dea1989a5921f13ec1a955a515ad47\":\"0x1b1ae4d6e2ef5000000\",\"0x8725e8c753b3acbfdca55f3c62dfe1a59454968a\":\"0x3637096c4bcc690000\",\"0x8737dae671823a8d5917e0157ace9c43468d946b\":\"0x6c6acc67d7b1d40000\",\"0x873b7f786d3c99ff012c4a7cae2677270240b9c5\":\"0x5dc892aa1131c80000\",\"0x873c6f70efb6b1d0f2bbc57eebcd70617c6ce662\":\"0x36f0d5275d09570000\",\"0x873e49135c3391991060290aa7f6ccb8f85a78db\":\"0x1158e460913d00000\",\"0x875061ee12e820041a01942cb0e65bb427b00060\":\"0x97c9ce4cf6d5c00000\",\"0x87584a3f613bd4fac74c1e780b86d6caeb890cb2\":\"0x5c283d410394100000\",\"0x8764d02722000996ecd475b433298e9f540b05bf\":\"0xad78ebc5ac6200000\",\"0x876c3f218b4776df3ca9dbfb270de152d94ed252\":\"0x56bc75e2d63100000\",\"0x8775a610c502b9f1e6ad4cdadb8ce29bff75f6e4\":\"0x2086ac351052600000\",\"0x87764e3677eef604cbc59aed24abdc566b09fc25\":\"0xa2a15d09519be00000\",\"0x8787d12677a5ec291e57e31ffbfad105c3324b87\":\"0x2a24eb53208f3128000\",\"0x8794bf47d54540ece5c72237a1ffb511ddb74762\":\"0x6c6b935b8bbd400000\",\"0x87a53ea39f59a35bada8352521645594a1a714cb\":\"0x678a932062e4180000\",\"0x87a7c508ef71582dd9a54372f89cb01f252fb180\":\"0xad78ebc5ac6200000\",\"0x87af25d3f6f8eea15313d5fe4557e810c524c083\":\"0x42bf06b78ed3b500000\",\"0x87b10f9c280098179a2b76e9ce90be61fc844d0d\":\"0x487a9a304539440000\",\"0x87bf7cd5d8a929e1c785f9e5449106ac232463c9\":\"0x437b11fcc45640000\",\"0x87c498170934b8233d1ad1e769317d5c475f2f40\":\"0x3708baed3d68900000\",\"0x87cf36ad03c9eae9053abb5242de9117bb0f2a0b\":\"0x1b1ae4d6e2ef500000\",\"0x87d7ac0653ccc67aa9c3469eef4352193f7dbb86\":\"0x2a5a058fc295ed000000\",\"0x87e3062b2321e9dfb0875ce3849c9b2e3522d50a\":\"0x21e19e0c9bab2400000\",\"0x87e6034ecf23f8b5639d5f0ea70a22538a920423\":\"0x11c7ea162e78200000\",\"0x87ef6d8b6a7cbf9b5c8c97f67ee2adc2a73b3f77\":\"0xadd1bd23c3c480000\",\"0x87fb26c31e48644d693134205cae43b21f18614b\":\"0x4a4491bd6dcd280000\",\"0x87fc4635263944ce14a46c75fa4a821f39ce7f72\":\"0x1158e460913d00000\",\"0x87fcbe7c4193ffcb08143779c9bec83fe7fda9fc\":\"0x56f985d38644b8000\",\"0x88015d7203c5e0224aeda286ed12f1a51b789333\":\"0x10f08eda8e555098000\",\"0x88106c27d20b74b4b98ca62b232bd5c97411171f\":\"0xaadec983fcff40000\",\"0x881230047c211d2d5b00d8de4c5139de5e3227c7\":\"0x21e19e0c9bab2400000\",\"0x882aa798bf41df179f85520130f15ccdf59b5e58\":\"0x6c6b935b8bbd400000\",\"0x882bd3a2e9d74110b24961c53777f22f1f46dc5d\":\"0x2d4ca05e2b43ca80000\",\"0x882c8f81872c79fed521cb5f950d8b032322ea69\":\"0x878678326eac9000000\",\"0x882f75708386653c80171d0663bfe30b017ed0ad\":\"0x6c6b935b8bbd400000\",\"0x88344909644c7ad4930fd873ca1c0da2d434c07f\":\"0x727739fcb004d0000\",\"0x8834b2453471f324fb26be5b25166b5b5726025d\":\"0x1f0ff8f01daad40000\",\"0x883a78aeabaa50d8ddd8570bcd34265f14b19363\":\"0xd25522fda379a18000\",\"0x8845e9f90e96336bac3c616be9d88402683e004c\":\"0x6c6b935b8bbd400000\",\"0x8846928d683289a2d11df8db7a9474988ef01348\":\"0x21e19e0c9bab2400000\",\"0x884980eb4565c1048317a8f47fdbb461965be481\":\"0xd8d6119a8146050000\",\"0x884a7a39d0916e05f1c242df55607f37df8c5fda\":\"0x4f4843c157c8ca00000\",\"0x885493bda36a0432976546c1ddce71c3f4570021\":\"0xbbf510ddfcb260000\",\"0x88609e0a465b6e99fce907166d57e9da0814f5c8\":\"0x43c33c1937564800000\",\"0x886d0a9e17c9c095af2ea2358b89ec705212ee94\":\"0x18493fba64ef00000\",\"0x88797e58675ed5cc4c19980783dbd0c956085153\":\"0x6c6b935b8bbd400000\",\"0x887cac41cd706f3345f2d34ac34e01752a6e5909\":\"0x20465cee9da1370000\",\"0x88888a57bd9687cbf950aeeacf9740dcc4d1ef59\":\"0x62a992e53a0af00000\",\"0x8889448316ccf14ed86df8e2f478dc63c4338340\":\"0xd2f13f7789f00000\",\"0x888c16144933197cac26504dd76e06fd6600c789\":\"0x56bc75e2d63100000\",\"0x888e94917083d152202b53163939869d271175b4\":\"0xd8d726b7177a800000\",\"0x889087f66ff284f8b5efbd29493b706733ab1447\":\"0x215f835bc769da80000\",\"0x8895eb726226edc3f78cc6a515077b3296fdb95e\":\"0xd5967be4fc3f100000\",\"0x88975a5f1ef2528c300b83c0c607b8e87dd69315\":\"0x486cb9799191e0000\",\"0x889da40fb1b60f9ea9bd7a453e584cf7b1b4d9f7\":\"0x22b1c8c1227a00000\",\"0x889da662eb4a0a2a069d2bc24b05b4ee2e92c41b\":\"0x5a2c8c5456c9f28000\",\"0x88a122a2382c523931fb51a0ccad3beb5b7259c3\":\"0x6c6b935b8bbd400000\",\"0x88a2154430c0e41147d3c1fee3b3b006f851edbd\":\"0x36356633ebd8ea0000\",\"0x88b217ccb786a254cf4dc57f5d9ac3c455a30483\":\"0x3224f42723d4540000\",\"0x88bc43012edb0ea9f062ac437843250a39b78fbb\":\"0x43c33c1937564800000\",\"0x88c2516a7cdb09a6276d7297d30f5a4db1e84b86\":\"0xd8d726b7177a800000\",\"0x88c361640d6b69373b081ce0c433bd590287d5ec\":\"0xa968163f0a57b400000\",\"0x88d541c840ce43cefbaf6d19af6b9859b573c145\":\"0x93739534d28680000\",\"0x88de13b09931877c910d593165c364c8a1641bd3\":\"0xa2a15d09519be00000\",\"0x88dec5bd3f4eba2d18b8aacefa7b721548c319ba\":\"0x4a4491bd6dcd280000\",\"0x88e6f9b247f988f6c0fc14c56f1de53ec69d43cc\":\"0x56bc75e2d63100000\",\"0x88ee7f0efc8f778c6b687ec32be9e7d6f020b674\":\"0x6c6b935b8bbd400000\",\"0x88f1045f19f2d3191816b1df18bb6e1435ad1b38\":\"0xd02ab486cedc00000\",\"0x89009e3c6488bd5e570d1da34eabe28ed024de1b\":\"0x43c33c1937564800000\",\"0x89054430dcdc28ac15fa635ef87c105e602bf70c\":\"0x5dacd13ca9e300000\",\"0x8908760cd39b9c1e8184e6a752ee888e3f0b7045\":\"0x14542ba12a337c00000\",\"0x890fe11f3c24db8732d6c2e772e2297c7e65f139\":\"0xd5627137da8b5900000\",\"0x8914a680a5aec5226d4baaec2e5552b44dd7c874\":\"0x56cd55fc64dfe0000\",\"0x891cb8238c88e93a1bcf61db49bd82b47a7f4f84\":\"0x914878a8c05ee00000\",\"0x8925da4549e15155e57a628522cea9dddf627d81\":\"0x3636c25e66ece70000\",\"0x893017ff1adad499aa065401b4236ce6e92b625a\":\"0x6c6acc67d7b1d40000\",\"0x8933491760c8f0b4df8caac78ed835caee21046d\":\"0x43c33c1937564800000\",\"0x893608751d68d046e85802926673cdf2f57f7cb8\":\"0x11164759ffb320000\",\"0x8938d1b4daee55a54d738cf17e4477f6794e46f7\":\"0xfc936392801c0000\",\"0x893a6c2eb8b40ab096b4f67e74a897b840746e86\":\"0x5dc892aa1131c80000\",\"0x893cdddf5377f3c751bf2e541120045a47cba101\":\"0x56bc75e2d63100000\",\"0x895613236f3584216ad75c5d3e07e3fa6863a778\":\"0x6c6b935b8bbd400000\",\"0x8957727e72cf629020f4e05edf799aa7458062d0\":\"0x77432217e683600000\",\"0x895d694e880b13ccd0848a86c5ce411f88476bbf\":\"0xad6eedd17cf3b8000\",\"0x895ec5545644e0b78330fffab8ddeac9e833156c\":\"0x2086ac351052600000\",\"0x896009526a2c7b0c09a6f63a80bdf29d9c87de9c\":\"0xbbb86b8223edeb0000\",\"0x8967d7b9bdb7b4aed22e65a15dc803cb7a213f10\":\"0x15af1d78b58c400000\",\"0x896e335ca47af57962fa0f4dbf3e45e688cba584\":\"0x4a2fc0ab6052120000\",\"0x8973aefd5efaee96095d9e288f6a046c97374b43\":\"0x7a4c4a0f332140000\",\"0x898c72dd736558ef9e4be9fdc34fef54d7fc7e08\":\"0x3635c9adc5dea00000\",\"0x899b3c249f0c4b81df75d212004d3d6d952fd223\":\"0x6c6b935b8bbd400000\",\"0x89ab13ee266d779c35e8bb04cd8a90cc2103a95b\":\"0xcb49b44ba602d800000\",\"0x89c433d601fad714da6369308fd26c1dc9942bbf\":\"0x6c6b935b8bbd400000\",\"0x89d75b8e0831e46f80bc174188184e006fde0eae\":\"0x3635c9adc5dea00000\",\"0x89e3b59a15864737d493c1d23cc53dbf8dcb1362\":\"0xd8d726b7177a800000\",\"0x89fc8e4d386b0d0bb4a707edf3bd560df1ad8f4e\":\"0xa030dcebbd2f4c0000\",\"0x89fee30d1728d96cecc1dab3da2e771afbcfaa41\":\"0x6c6acc67d7b1d40000\",\"0x8a1cc5ac111c49bfcfd848f37dd768aa65c88802\":\"0x21e19e0c9bab2400000\",\"0x8a20e5b5cee7cd1f5515bace3bf4f77ffde5cc07\":\"0x4563918244f400000\",\"0x8a217db38bc35f215fd92906be42436fe7e6ed19\":\"0x14542ba12a337c00000\",\"0x8a243a0a9fea49b839547745ff2d11af3f4b0522\":\"0x35659ef93f0fc40000\",\"0x8a247d186510809f71cffc4559471c3910858121\":\"0x61093d7c2c6d380000\",\"0x8a3470282d5e2a2aefd7a75094c822c4f5aeef8a\":\"0xd28bc606478a58000\",\"0x8a36869ad478997cbf6d8924d20a3c8018e9855b\":\"0x1158e460913d00000\",\"0x8a4314fb61cd938fc33e15e816b113f2ac89a7fb\":\"0x17764e7aed65100000\",\"0x8a4f4a7f52a355ba105fca2072d3065fc8f7944b\":\"0x1b1ae4d6e2ef500000\",\"0x8a5831282ce14a657a730dc18826f7f9b99db968\":\"0xeabe8a5b41c1360000\",\"0x8a5fb75793d043f1bcd43885e037bd30a528c927\":\"0x13536e6d2e9ac20000\",\"0x8a66abbc2d30ce21a833b0db8e561d5105e0a72c\":\"0x25f1de5c76acdf0000\",\"0x8a746c5d67064711bfca685b95a4fe291a27028e\":\"0x22b1c8c1227a00000\",\"0x8a780ab87a9145fe10ed60fa476a740af4cab1d2\":\"0x121b2e5e6464780000\",\"0x8a7a06be199a3a58019d846ac9cbd4d95dd757de\":\"0xa2a423944256f40000\",\"0x8a810114b2025db9fbb50099a6e0cb9e2efa6bdc\":\"0x678a932062e4180000\",\"0x8a86e4a51c013b1fb4c76bcf30667c78d52eedef\":\"0x6c6b935b8bbd400000\",\"0x8a9eca9c5aba8e139f8003edf1163afb70aa3aa9\":\"0x23c757072b8dd00000\",\"0x8ab839aeaf2ad37cb78bacbbb633bcc5c099dc46\":\"0x6c6b935b8bbd400000\",\"0x8ac89bd9b8301e6b0677fa25fcf0f58f0cc7b611\":\"0x1158e460913d00000\",\"0x8adc53ef8c18ed3051785d88e996f3e4b20ecd51\":\"0x8e4d316827686400000\",\"0x8ae6f80b70e1f23c91fbd5a966b0e499d95df832\":\"0xaadec983fcff40000\",\"0x8ae9ef8c8a8adfa6ab798ab2cdc405082a1bbb70\":\"0x6c6b935b8bbd400000\",\"0x8af626a5f327d7506589eeb7010ff9c9446020d2\":\"0x4be4e7267b6ae00000\",\"0x8b01da34d470c1d115acf4d8113c4dd8a8c338e4\":\"0x5572dcefab697900000\",\"0x8b07d050754dc9ba230db01c310afdb5395aa1b3\":\"0x666b06e62a6200000\",\"0x8b20ad3b94656dbdc0dd21a393d8a7d9e02138cb\":\"0xa2a15d09519be00000\",\"0x8b27392206b958cd375d7ef8af2cf8ef0598c0bc\":\"0x3635c9adc5dea00000\",\"0x8b30c04098d7a7e6420c357ea7bfa49bac9a8a18\":\"0x1b1b113f91fb0140000\",\"0x8b338411f26ccf37658cc75521d77629099e467d\":\"0x6c6b935b8bbd400000\",\"0x8b36224c7356e751f0c066c35e3b44860364bfc2\":\"0x3627bac7a3d9278000\",\"0x8b3696f3c60de32432a2e4c395ef0303b7e81e75\":\"0x65a4da25d3016c00000\",\"0x8b393fb0813ee101db1e14ecc7d322c72b8c0473\":\"0x18b26a313e8ae90000\",\"0x8b48e19d39dd35b66e6e1bb6b9c657cb2cf59d04\":\"0x3c755ac9c024a018000\",\"0x8b505e2871f7deb7a63895208e8227dcaa1bff05\":\"0xcf68efc308d79bc0000\",\"0x8b57b2bc83cc8d4de331204e893f2f3b1db1079a\":\"0x22b1c8c1227a00000\",\"0x8b5c914b128bf1695c088923fa467e7911f351fa\":\"0x556f64c1fe7fa0000\",\"0x8b5f29cc2faa262cdef30ef554f50eb488146eac\":\"0x13b68705c9720810000\",\"0x8b7056f6abf3b118d026e944d5c073433ca451d7\":\"0x3635c6204739d98000\",\"0x8b714522fa2839620470edcf0c4401b713663df1\":\"0xad78ebc5ac6200000\",\"0x8b74a7cb1bb8c58fce267466a30358adaf527f61\":\"0x2e257784e25b4500000\",\"0x8b7e9f6f05f7e36476a16e3e7100c9031cf404af\":\"0x3635c9adc5dea00000\",\"0x8b81156e698639943c01a75272ad3d35851ab282\":\"0x12b3165f65d3e50000\",\"0x8b9577920053b1a00189304d888010d9ef2cb4bf\":\"0x1b1ae4d6e2ef500000\",\"0x8b9841862e77fbbe919470935583a93cf027e450\":\"0x6c6c5334427f1f0000\",\"0x8b997dbc078ad02961355da0a159f2927ed43d64\":\"0xaadec983fcff40000\",\"0x8b9fda7d981fe9d64287f85c94d83f9074849fcc\":\"0x2f6f10780d22cc00000\",\"0x8bb0212f3295e029cab1d961b04133a1809e7b91\":\"0x6c6b935b8bbd400000\",\"0x8bbeacfc29cfe93402db3c41d99ab759662e73ec\":\"0x6c6b935b8bbd400000\",\"0x8bc1ff8714828bf286ff7e8a7709106548ed1b18\":\"0x21e19e0c9bab2400000\",\"0x8bd0b65a50ef5cef84fec420be7b89ed1470ceb9\":\"0x28a77936e92c81c0000\",\"0x8bd6b1c6d74d010d1008dba6ef835d4430b35c32\":\"0x2b5e3af16b1880000\",\"0x8bd8d4c4e943f6c8073921dc17e3e8d7a0761627\":\"0x9f04219d8d34950000\",\"0x8bdfda6c215720eda2136f91052321af4e936c1f\":\"0x3635e619bb04d40000\",\"0x8bea40379347a5c891d59a6363315640f5a7e07a\":\"0x6c6b76ef96970c0000\",\"0x8bf02bd748690e1fd1c76d270833048b66b25fd3\":\"0x27fade568eba9600000\",\"0x8bf297f8f453523ed66a1acb7676856337b93bf0\":\"0xd8d726b7177a800000\",\"0x8bf373d076814cbc57e1c6d16a82c5be13c73d37\":\"0xad78ebc5ac6200000\",\"0x8c1023fde1574db8bb54f1739670157ca47da652\":\"0x179cf9ac3a1b1770000\",\"0x8c1fbe5f0aea359c5aa1fa08c8895412ca8e05a6\":\"0x3635c9adc5dea00000\",\"0x8c22426055b76f11f0a2de1a7f819a619685fe60\":\"0x6b56051582a9700000\",\"0x8c2b7d8b608d28b77f5caa9cd645242a823e4cd9\":\"0x62a992e53a0af00000\",\"0x8c2fbeee8eacc5c5d77c16abd462ee9c8145f34b\":\"0x692ae8897081d00000\",\"0x8c3a9ee71f729f236cba3867b4d79d8ceee25dbc\":\"0x56bc75e2d63100000\",\"0x8c50aa2a9212bcde56418ae261f0b35e7a9dbb82\":\"0x15af1d78b58c400000\",\"0x8c54c7f8b9896e75d7d5f5c760258699957142ad\":\"0x22b1c8c1227a00000\",\"0x8c5d16ed65e3ed7e8b96ca972bc86173e3500b03\":\"0x6c6b935b8bbd400000\",\"0x8c6aa882ee322ca848578c06cb0fa911d3608305\":\"0x2086ac351052600000\",\"0x8c6ae7a05a1de57582ae2768204276c0ff47ed03\":\"0x2c0bb3dd30c4e2000000\",\"0x8c6f9f4e5b7ae276bf58497bd7bf2a7d25245f64\":\"0x93fe5c57d710680000\",\"0x8c75956e8fed50f5a7dd7cfd27da200f6746aea6\":\"0x3635c9adc5dea00000\",\"0x8c7cb4e48b25031aa1c4f92925d631a8c3edc761\":\"0x3635c9adc5dea00000\",\"0x8c7fa5cae82fedb69ab189d3ff27ae209293fb93\":\"0x15af880d8cdb830000\",\"0x8c81410ea8354cc5c65c41be8bd5de733c0b111d\":\"0x205b4dfa1ee74780000\",\"0x8c83d424a3cf24d51f01923dd54a18d6b6fede7b\":\"0xd8d726b7177a800000\",\"0x8c900a8236b08c2b65405d39d75f20062a7561fd\":\"0x58e7926ee858a00000\",\"0x8c93c3c6db9d37717de165c3a1b4fe51952c08de\":\"0x15af1d78b58c400000\",\"0x8c999591fd72ef7111efca7a9e97a2356b3b000a\":\"0xdd64e2aa0a67500000\",\"0x8ca6989746b06e32e2487461b1ce996a273acfd7\":\"0x1158e460913d00000\",\"0x8cb3aa3fcd212854d7578fcc30fdede6742a312a\":\"0x1043561a8829300000\",\"0x8cc0d7c016fa7aa950114aa1db094882eda274ea\":\"0x8a9aba557e36c0000\",\"0x8cc652dd13e7fe14dabbb36d5d320db9ffee8a54\":\"0x61093d7c2c6d380000\",\"0x8ccabf25077f3aa41545344d53be1b2b9c339000\":\"0x5be866c562c5440000\",\"0x8ccf3aa21ab742576ad8c422f71bb188591dea8a\":\"0x3635c9adc5dea00000\",\"0x8cd0cd22e620eda79c0461e896c93c44837e2968\":\"0x6c6b935b8bbd400000\",\"0x8cde8b732e6023878eb23ed16229124b5f7afbec\":\"0x73f75d1a085ba0000\",\"0x8ce22f9fa372449a420610b47ae0c8d565481232\":\"0x6c6b935b8bbd400000\",\"0x8ce4949d8a16542d423c17984e6739fa72ceb177\":\"0x54b405926f4a63d8000\",\"0x8ce5e3b5f591d5eca38abf228f2e3c35134bdac0\":\"0x7dc35b84897c380000\",\"0x8cee38d6595788a56e3fb94634b3ffe1fbdb26d6\":\"0x43c33c1937564800000\",\"0x8ceea15eec3bdad8023f98ecf25b2b8fef27db29\":\"0x6c6b935b8bbd400000\",\"0x8cf3546fd1cda33d58845fc8fcfecabca7c5642a\":\"0x1f1e39932cb3278000\",\"0x8cf6da0204dbc4860b46ad973fc111008d9e0c46\":\"0xad78ebc5ac6200000\",\"0x8cfedef198db0a9143f09129b3fd64dcbb9b4956\":\"0x6c6b935b8bbd400000\",\"0x8d04a5ebfb5db409db0617c9fa5631c192861f4a\":\"0x34957444b840e80000\",\"0x8d06e464245cad614939e0af0845e6d730e20374\":\"0xadc8a28f3d87d8000\",\"0x8d07d42d831c2d7c838aa1872b3ad5d277176823\":\"0x12ee1f9ddbee680000\",\"0x8d0b9ea53fd263415eac11391f7ce9123c447062\":\"0x6c6b935b8bbd400000\",\"0x8d1794da509cb297053661a14aa892333231e3c1\":\"0xad201a6794ff80000\",\"0x8d1abd897dacd4312e18080c88fb9647eab44052\":\"0xbb59a27953c600000\",\"0x8d2303341e1e1eb5e8189bde03f73a60a2a54861\":\"0x56bc75e2d63100000\",\"0x8d238e036596987643d73173c37b0ad06055b96c\":\"0x7148bf0a2af0660000\",\"0x8d2e31b08803b2c5f13d398ecad88528209f6057\":\"0x21db8bbcad11e840000\",\"0x8d378f0edc0bb0f0686d6a20be6a7692c4fa24b8\":\"0x56bc75e2d63100000\",\"0x8d4b603c5dd4570c34669515fdcc665890840c77\":\"0xfc936392801c0000\",\"0x8d51a4cc62011322c696fd725b9fb8f53feaaa07\":\"0x3635c9adc5dea00000\",\"0x8d544c32c07fd0842c761d53a897d6c950bb7599\":\"0xad78ebc5ac6200000\",\"0x8d5ef172bf77315ea64e85d0061986c794c6f519\":\"0xd5967be4fc3f100000\",\"0x8d616b1eee77eef6f176e0698db3c0c141b2fc8f\":\"0x1b1ae4d6e2ef500000\",\"0x8d6170ff66978e773bb621bf72b1ba7be3a7f87e\":\"0xad78ebc5ac6200000\",\"0x8d620bde17228f6cbba74df6be87264d985cc179\":\"0x56bc75e2d63100000\",\"0x8d629c20608135491b5013f1002586a0383130e5\":\"0x4a4491bd6dcd280000\",\"0x8d6657f59711b1f803c6ebef682f915b62f92dc9\":\"0x6c6b935b8bbd400000\",\"0x8d667637e29eca05b6bfbef1f96d460eefbf9984\":\"0xd8d726b7177a800000\",\"0x8d6df209484d7b94702b03a53e56b9fb0660f6f0\":\"0x6c6b935b8bbd400000\",\"0x8d795c5f4a5689ad62da961671f028065286d554\":\"0x6f05b59d3b20000000\",\"0x8d7f3e61299c2db9b9c0487cf627519ed00a9123\":\"0x5e74a8505e80a00000\",\"0x8d89170b92b2be2c08d57c48a7b190a2f146720f\":\"0x42bf06b78ed3b500000\",\"0x8d93dac785f88f1a84bf927d53652b45a154ccdd\":\"0x890b0c2e14fb80000\",\"0x8d9952d0bb4ebfa0efd01a3aa9e8e87f0525742e\":\"0xbb9125542263900000\",\"0x8d9a0c70d2262042df1017d6c303132024772712\":\"0x6c6b935b8bbd400000\",\"0x8d9ed7f4553058c26f7836a3802d3064eb1b363d\":\"0x4e1003b28d9280000\",\"0x8da1178f55d97772bb1d24111a404a4f8715b95d\":\"0x2f9ac3f6de00808000\",\"0x8da1d359ba6cb4bcc57d7a437720d55db2f01c72\":\"0x4563918244f400000\",\"0x8dab948ae81da301d972e3f617a912e5a753712e\":\"0x15af1d78b58c400000\",\"0x8daddf52efbd74da95b969a5476f4fbbb563bfd2\":\"0x2d43f3ebfafb2c0000\",\"0x8db185fe1b70a94a6a080e7e23a8bedc4acbf34b\":\"0x4be4e7267b6ae00000\",\"0x8db58e406e202df9bc703c480bd8ed248d52a032\":\"0x6c6b935b8bbd400000\",\"0x8dbc3e6cb433e194f40f82b40faadb1f8b856116\":\"0x678a932062e4180000\",\"0x8dc1d5111d09af25fdfcac455c7cec283e6d6775\":\"0x6c6b935b8bbd400000\",\"0x8dd484ff8a307364eb66c525a571aac701c5c318\":\"0xd8d726b7177a800000\",\"0x8dd6a9bae57f518549ada677466fea8ab04fd9b4\":\"0xd8d726b7177a800000\",\"0x8dde3cb8118568ef4503fe998ccdf536bf19a098\":\"0xd8d726b7177a800000\",\"0x8dde60eb08a099d7daa356daaab2470d7b025a6b\":\"0xaadec983fcff40000\",\"0x8df339214b6ad1b24663ce716034749d6ef838d9\":\"0x2544faa778090e00000\",\"0x8df53d96191471e059de51c718b983e4a51d2afd\":\"0x6c6b935b8bbd4000000\",\"0x8dfbafbc0e5b5c86cd1ad697feea04f43188de96\":\"0x15252b7f5fa0de0000\",\"0x8e073bad25e42218615f4a0e6b2ea8f8de2230c0\":\"0x823d629d026bfa0000\",\"0x8e0fee38685a94aabcd7ce857b6b1409824f75b8\":\"0x1b1ae4d6e2ef500000\",\"0x8e23facd12c765c36ab81a6dd34d8aa9e68918ae\":\"0x911e4868dba9b0000\",\"0x8e2f9034c9254719c38e50c9aa64305ed696df1e\":\"0x1004e2e45fb7ee00000\",\"0x8e3240b0810e1cf407a500804740cf8d616432a4\":\"0x22f6655ef0b388000\",\"0x8e486a0442d171c8605be348fee57eb5085eff0d\":\"0xd8d726b7177a800000\",\"0x8e6156336be2cdbe32140df08a2ba55fd0a58463\":\"0x4099e1d6357180000\",\"0x8e670815fb67aeaea57b86534edc00cdf564fee5\":\"0xb2e4b323d9c5100000\",\"0x8e6d7485cbe990acc1ad0ee9e8ccf39c0c93440e\":\"0x33c5499031720c0000\",\"0x8e74e0d1b77ebc823aca03f119854cb12027f6d7\":\"0x16b352da5e0ed3000000\",\"0x8e78f351457d016f4ad2755ec7424e5c21ba6d51\":\"0x7ea28327577080000\",\"0x8e7936d592008fdc7aa04edeeb755ab513dbb89d\":\"0x1158e460913d00000\",\"0x8e7fd23848f4db07906a7d10c04b21803bb08227\":\"0x3635c9adc5dea00000\",\"0x8e92aba38e72a098170b92959246537a2e5556c0\":\"0xe7eeba3410b740000\",\"0x8e98766524b0cf2747c50dd43b9567594d9731de\":\"0x6c44b7c26182280000\",\"0x8e9b35ad4a0a86f758446fffde34269d940ceacd\":\"0xd8d726b7177a800000\",\"0x8e9c08f738661f9676236eff82ba6261dd3f4822\":\"0x56bc75e2d63100000\",\"0x8e9c429266df057efa78dd1d5f77fc40742ad466\":\"0x10442ed1b56c7c8000\",\"0x8ea656e71ec651bfa17c5a5759d86031cc359977\":\"0x56bc75e2d63100000\",\"0x8eae29435598ba8f1c93428cdb3e2b4d31078e00\":\"0x6c6b935b8bbd400000\",\"0x8eb1fbe4e5d3019cd7d30dae9c0d5b4c76fb6331\":\"0x6c6b935b8bbd400000\",\"0x8eb51774af206b966b8909c45aa6722748802c0c\":\"0x1b1ae4d6e2ef500000\",\"0x8eb8c71982a00fb84275293253f8044544b66b49\":\"0x15af1d78b58c400000\",\"0x8ecbcfacbfafe9f00c3922a24e2cf0026756ca20\":\"0x131beb925ffd3200000\",\"0x8eceb2e124536c5b5ffc640ed14ff15ed9a8cb71\":\"0x6c6b935b8bbd400000\",\"0x8ed0af11ff2870da0681004afe18b013f7bd3882\":\"0xd8d726b7177a800000\",\"0x8ed143701f2f72280fd04a7b4164281979ea87c9\":\"0xc249fdd327780000\",\"0x8ed1528b447ed4297902f639c514d0944a88f8c8\":\"0xac6e77ab663a80000\",\"0x8ed4284c0f47449c15b8d9b3245de8beb6ce80bf\":\"0x2b5e3af16b18800000\",\"0x8ede7e3dc50749c6c50e2e28168478c34db81946\":\"0x43c30fb0884a96c0000\",\"0x8ee584337ddbc80f9e3498df55f0a21eacb57fb1\":\"0x1158e460913d00000\",\"0x8eebec1a62c08b05a7d1d59180af9ff0d18e3f36\":\"0x1b1ae4d6e2ef500000\",\"0x8ef4d8a2c23c5279187b64e96f741404085385f3\":\"0x103dc1e9a9697b0000\",\"0x8ef711e43a13918f1303e81d0ea78c9eefd67eb2\":\"0xd8d726b7177a800000\",\"0x8efec058cc546157766a632775404a334aaada87\":\"0x6c5db2a4d815dc0000\",\"0x8f02bda6c36922a6be6a509be51906d393f7b99b\":\"0x37490dc12ebe7f8000\",\"0x8f0538ed71da1155e0f3bde5667ceb84318a1a87\":\"0x692ae8897081d00000\",\"0x8f067c7c1bbd57780b7b9eeb9ec0032f90d0dcf9\":\"0x43c33c1937564800000\",\"0x8f0ab894bd3f4e697dbcfb859d497a9ba195994a\":\"0x85d638b65472aa20000\",\"0x8f0af37566d152802f1ae8f928b25af9b139b448\":\"0xad78ebc5ac6200000\",\"0x8f1952eed1c548d9ee9b97d0169a07933be69f63\":\"0x3635c9adc5dea00000\",\"0x8f1fcc3c51e252b693bc5b0ec3f63529fe69281e\":\"0x14542ba12a337c00000\",\"0x8f226096c184ebb40105e08dac4d22e1c2d54d30\":\"0x109e437bd1618c0000\",\"0x8f29a14a845ad458f2d108b568d813166bcdf477\":\"0x21e19e0c9bab2400000\",\"0x8f31c7005197ec997a87e69bec48649ab94bb2a5\":\"0xd8d726b7177a800000\",\"0x8f41b1fbf54298f5d0bc2d122f4eb95da4e5cd3d\":\"0x1333832f5e335c0000\",\"0x8f47328ee03201c9d35ed2b5412b25decc859362\":\"0x6c6b935b8bbd400000\",\"0x8f473d0ab876ddaa15608621d7013e6ff714b675\":\"0x19801c83b6c7c00000\",\"0x8f4d1d41693e462cf982fd81d0aa701d3a5374c9\":\"0xd8d726b7177a800000\",\"0x8f4d1e7e4561284a34fef9673c0d34e12af4aa03\":\"0x6c6b935b8bbd400000\",\"0x8f4fb1aea7cd0f570ea5e61b40a4f4510b6264e4\":\"0xd8d726b7177a800000\",\"0x8f561b41b209f248c8a99f858788376250609cf3\":\"0x5c283d410394100000\",\"0x8f58d8348fc1dc4e0dd8343b6543c857045ee940\":\"0x2e3038df47303280000\",\"0x8f60895fbebbb5017fcbff3cdda397292bf25ba6\":\"0x174406ff9f6fd28000\",\"0x8f64b9c1246d857831643107d355b5c75fef5d4f\":\"0x6c6acc67d7b1d40000\",\"0x8f660f8b2e4c7cc2b4ac9c47ed28508d5f8f8650\":\"0x43c33c1937564800000\",\"0x8f69eafd0233cadb4059ab779c46edf2a0506e48\":\"0x60f06620a849450000\",\"0x8f717ec1552f4c440084fba1154a81dc003ebdc0\":\"0x21e19e0c9bab2400000\",\"0x8f8acb107607388479f64baaabea8ff007ada97d\":\"0x5c6f3080ad423f40000\",\"0x8f8cd26e82e7c6defd02dfad07979021cbf7150c\":\"0xa2a15d09519be00000\",\"0x8f8f37d0ad8f335d2a7101b41156b688a81a9cbe\":\"0x3cb71f51fc5580000\",\"0x8f92844f282a92999ee5b4a8d773d06b694dbd9f\":\"0x692ae8897081d00000\",\"0x8fac748f784a0fed68dba43319b42a75b4649c6e\":\"0x3154c9729d05780000\",\"0x8fd9a5c33a7d9edce0997bdf77ab306424a11ea9\":\"0x6c6b935b8bbd400000\",\"0x8feffadb387a1547fb284da9b8147f3e7c6dc6da\":\"0x2d627be45305080000\",\"0x8ff46045687723dc33e4d099a06904f1ebb584dc\":\"0x6c6b935b8bbd400000\",\"0x8ffa062122ac307418821adb9311075a3703bfa3\":\"0x3635c9adc5dea00000\",\"0x8ffe322997b8e404422d19c54aadb18f5bc8e9b7\":\"0xd5967be4fc3f100000\",\"0x900194c4b1074305d19de405b0ac78280ecaf967\":\"0x3635c9adc5dea00000\",\"0x9003d270891ba2df643da8341583193545e3e000\":\"0xd8d726b7177a800000\",\"0x90057af9aa66307ec9f033b29724d3b2f41eb6f9\":\"0x19d1d6aadb2c52e80000\",\"0x900f0b8e35b668f81ef252b13855aa5007d012e7\":\"0x170a0f5040e5040000\",\"0x9018cc1f48d2308e252ab6089fb99a7c1d569410\":\"0xad78ebc5ac6200000\",\"0x901d99b699e5c6911519cb2076b4c76330c54d22\":\"0x6c6b935b8bbd400000\",\"0x902d74a157f7d2b9a3378b1f56703730e03a1719\":\"0xd8d726b7177a800000\",\"0x903413878aea3bc1086309a3fe768b65559e8cab\":\"0x1b1ae4d6e2ef5000000\",\"0x904966cc2213b5b8cb5bd6089ef9cddbef7edfcc\":\"0x6c6b935b8bbd400000\",\"0x904caa429c619d940f8e6741826a0db692b19728\":\"0x3635c9adc5dea00000\",\"0x9052f2e4a3e3c12dd1c71bf78a4ec3043dc88b7e\":\"0xe7eeba3410b740000\",\"0x905526568ac123afc0e84aa715124febe83dc87c\":\"0xf8699329677e0000\",\"0x9092918707c621fdbd1d90fb80eb787fd26f7350\":\"0x855b5ba65c84f00000\",\"0x909b5e763a39dcc795223d73a1dbb7d94ca75ac8\":\"0x6c6b935b8bbd400000\",\"0x90acced7e48c08c6b934646dfa0adf29dc94074f\":\"0x30b4b157bbd490000\",\"0x90b1f370f9c1eb0be0fb8e2b8ad96a416371dd8a\":\"0x30ca024f987b900000\",\"0x90b62f131a5f29b45571513ee7a74a8f0b232202\":\"0x890b0c2e14fb80000\",\"0x90bd62a050845261fa4a9f7cf241ea630b05efb8\":\"0x1b1ae4d6e2ef500000\",\"0x90c41eba008e20cbe927f346603fc88698125969\":\"0x246ddf97976680000\",\"0x90d2809ae1d1ffd8f63eda01de49dd552df3d1bc\":\"0xd8bb6549b02bb80000\",\"0x90dc09f717fc2a5b69fd60ba08ebf40bf4e8246c\":\"0xd8d8583fa2d52f0000\",\"0x90e300ac71451e401f887f6e7728851647a80e07\":\"0x15af1d78b58c400000\",\"0x90e35aabb2deef408bb9b5acef714457dfde6272\":\"0x56cd55fc64dfe0000\",\"0x90e7070f4d033fe6910c9efe5a278e1fc6234def\":\"0x571380819b3040000\",\"0x90e93e4dc17121487952333614002be42356498e\":\"0x678a932062e4180000\",\"0x90e9a9a82edaa814c284d232b6e9ba90701d4952\":\"0x56be03ca3e47d8000\",\"0x90f774c9147dde90853ddc43f08f16d455178b8c\":\"0xd8d726b7177a800000\",\"0x90fc537b210658660a83baa9ac4a8402f65746a8\":\"0x65ea3db75546600000\",\"0x91050a5cffadedb4bb6eaafbc9e5013428e96c80\":\"0x5c283d410394100000\",\"0x91051764af6b808e4212c77e30a5572eaa317070\":\"0x3635c9adc5dea00000\",\"0x910b7d577a7e39aa23acf62ad7f1ef342934b968\":\"0x21e19e0c9bab2400000\",\"0x910e996543344c6815fb97cda7af4b8698765a5b\":\"0x59af69829cf640000\",\"0x911feea61fe0ed50c5b9e5a0d66071399d28bdc6\":\"0x340aad21b3b700000\",\"0x911ff233e1a211c0172c92b46cf997030582c83a\":\"0x6acb3df27e1f880000\",\"0x9120e71173e1ba19ba8f9f4fdbdcaa34e1d6bb78\":\"0x6c6b935b8bbd400000\",\"0x91211712719f2b084d3b3875a85069f466363141\":\"0x3635c9adc5dea00000\",\"0x912304118b80473d9e9fe3ee458fbe610ffda2bb\":\"0xad78ebc5ac6200000\",\"0x91546b79ecf69f936b5a561508b0d7e50cc5992f\":\"0xe7eeba3410b740000\",\"0x9156d18029350e470408f15f1aa3be9f040a67c6\":\"0x3635c9adc5dea00000\",\"0x91620f3eb304e813d28b0297556d65dc4e5de5aa\":\"0xcf152640c5c8300000\",\"0x916bf7e3c545921d3206d900c24f14127cbd5e70\":\"0x3d0ddbc7df2bb100000\",\"0x916cf17d71412805f4afc3444a0b8dd1d9339d16\":\"0xc673ce3c40160000\",\"0x917b8f9f3a8d09e9202c52c29e724196b897d35e\":\"0x8ba52e6fc45e40000\",\"0x918967918cd897dd0005e36dc6c883ef438fc8c7\":\"0x796e3ea3f8ab00000\",\"0x91898eab8c05c0222883cd4db23b7795e1a24ad7\":\"0x6c6b935b8bbd400000\",\"0x9191f94698210516cf6321a142070e20597674ed\":\"0xee9d5be6fc110000\",\"0x91a4149a2c7b1b3a67ea28aff34725e0bf8d7524\":\"0x692ae8897081d00000\",\"0x91a787bc5196f34857fe0c372f4df376aaa76613\":\"0x6c6b935b8bbd400000\",\"0x91a8baaed012ea2e63803b593d0d0c2aab4c5b0a\":\"0x5150ae84a8cdf00000\",\"0x91ac5cfe67c54aa7ebfba448666c461a3b1fe2e1\":\"0x15c93492bf9dfc0000\",\"0x91bb3f79022bf3c453f4ff256e269b15cf2c9cbd\":\"0x52585c13fe3a5c0000\",\"0x91c75e3cb4aa89f34619a164e2a47898f5674d9c\":\"0x6c6b935b8bbd400000\",\"0x91c80caa081b38351d2a0e0e00f80a34e56474c1\":\"0x3635c9adc5dea00000\",\"0x91cc46aa379f856a6640dccd5a648a7902f849d9\":\"0xad78ebc5ac6200000\",\"0x91d2a9ee1a6db20f5317cca7fbe2313895db8ef8\":\"0x1ccc3a52f306e280000\",\"0x91d66ea6288faa4b3d606c2aa45c7b6b8a252739\":\"0x6c6b935b8bbd400000\",\"0x91dbb6aaad149585be47375c5d6de5ff09191518\":\"0x43c33c1937564800000\",\"0x91e8810652e8e6161525d63bb7751dc20f676076\":\"0x274d656ac90e340000\",\"0x91f516146cda20281719978060c6be4149067c88\":\"0x6c6b935b8bbd400000\",\"0x91f624b24a1fa5a056fe571229e7379db14b9a1e\":\"0x28a8517c669b3570000\",\"0x91fe8a4c6164df8fa606995d6ba7adcaf1c893ce\":\"0x39992648a23c8a00000\",\"0x921f5261f4f612760706892625c75e7bce96b708\":\"0x6c6b935b8bbd400000\",\"0x9221c9ce01232665741096ac07235903ad1fe2fc\":\"0x6db63335522628000\",\"0x9225983860a1cb4623c72480ac16272b0c95e5f5\":\"0x6c6b935b8bbd400000\",\"0x9225d46a5a80943924a39e5b84b96da0ac450581\":\"0x878678326eac9000000\",\"0x922a20c79a1d3a26dd3829677bf1d45c8f672bb6\":\"0xd8d726b7177a800000\",\"0x92438e5203b6346ff886d7c36288aacccc78ceca\":\"0x3635c9adc5dea00000\",\"0x9243d7762d77287b12638688b9854e88a769b271\":\"0x3635c9adc5dea00000\",\"0x924bce7a853c970bb5ec7bb759baeb9c7410857b\":\"0xbe202d6a0eda0000\",\"0x924efa6db595b79313277e88319625076b580a10\":\"0x6c6b935b8bbd400000\",\"0x92558226b384626cad48e09d966bf1395ee7ea5d\":\"0x121ea68c114e510000\",\"0x926082cb7eed4b1993ad245a477267e1c33cd568\":\"0x144a74badfa4b60000\",\"0x926209b7fda54e8ddb9d9e4d3d19ebdc8e88c29f\":\"0x6c6b935b8bbd400000\",\"0x9268d62646563611dc3b832a30aa2394c64613e3\":\"0x6c6b935b8bbd400000\",\"0x92698e345378c62d8eda184d94366a144b0c105b\":\"0x4be4e7267b6ae00000\",\"0x92793ac5b37268774a7130de2bbd330405661773\":\"0x22ca3587cf4eb0000\",\"0x9279b2228cec8f7b4dda3f320e9a0466c2f585ca\":\"0x10f0cf064dd59200000\",\"0x927cb7dc187036b5427bc7e200c5ec450c1d27d4\":\"0xbb59a27953c600000\",\"0x927cc2bfda0e088d02eff70b38b08aa53cc30941\":\"0x646f60a1f986360000\",\"0x9284f96ddb47b5186ee558aa31324df5361c0f73\":\"0x3635c9adc5dea000000\",\"0x929d368eb46a2d1fbdc8ffa0607ede4ba88f59ad\":\"0x6c6b935b8bbd400000\",\"0x92a7c5a64362e9f842a23deca21035857f889800\":\"0x6c6acc67d7b1d40000\",\"0x92a898d46f19719c38126a8a3c27867ae2cee596\":\"0x6c6b935b8bbd400000\",\"0x92a971a739799f8cb48ea8475d72b2d2474172e6\":\"0xd5967be4fc3f100000\",\"0x92aae59768eddff83cfe60bb512e730a05a161d7\":\"0x5c9778410c76d18000\",\"0x92ad1b3d75fba67d54663da9fc848a8ade10fa67\":\"0x6c6b935b8bbd400000\",\"0x92ae5b7c7eb492ff1ffa16dd42ad9cad40b7f8dc\":\"0x2ee449550898e40000\",\"0x92c0f573eccf62c54810ee6ba8d1f113542b301b\":\"0xb7726f16ccb1e00000\",\"0x92c13fe0d6ce87fd50e03def9fa6400509bd7073\":\"0x22b1c8c1227a00000\",\"0x92c94c2820dfcf7156e6f13088ece7958b3676fd\":\"0x52d542804f1ce0000\",\"0x92cfd60188efdfb2f8c2e7b1698abb9526c1511f\":\"0x6c6b935b8bbd400000\",\"0x92d8ad9a4d61683b80d4a6672e84c20d62421e80\":\"0x1158e460913d00000\",\"0x92dca5e102b3b81b60f1a504634947c374a88ccb\":\"0x6c6b935b8bbd400000\",\"0x92e435340e9d253c00256389f52b067d55974e76\":\"0xe873f44133cb00000\",\"0x92e4392816e5f2ef5fb65837cec2c2325cc64922\":\"0x21e19e0c9bab2400000\",\"0x92e6581e1da1f9b846e09347333dc818e2d2ac66\":\"0xc55325ca7415e00000\",\"0x931df34d1225bcd4224e63680d5c4c09bce735a6\":\"0x3afb087b876900000\",\"0x931fe712f64207a2fd5022728843548bfb8cbb05\":\"0x6c6b935b8bbd400000\",\"0x93235f340d2863e18d2f4c52996516138d220267\":\"0x4002e44fda7d40000\",\"0x93258255b37c7f58f4b10673a932dd3afd90f4f2\":\"0x3635c9adc5dea00000\",\"0x9328d55ccb3fce531f199382339f0e576ee840a3\":\"0xd8d726b7177a800000\",\"0x9329ffdc268babde8874b366406c81445b9b2d35\":\"0x16e62f8c730ca18000\",\"0x932b9c04d40d2ac83083d94298169dae81ab2ed0\":\"0x6c6b935b8bbd400000\",\"0x933436c8472655f64c3afaaf7c4c621c83a62b38\":\"0x3635c9adc5dea00000\",\"0x933bf33f8299702b3a902642c33e0bfaea5c1ca3\":\"0xd2f13f7789f00000\",\"0x9340345ca6a3eabdb77363f2586043f29438ce0b\":\"0x1cc805da0dfff10000\",\"0x9340b5f678e45ee05eb708bb7abb6ec8f08f1b6b\":\"0x14542ba12a337c00000\",\"0x934af21b7ebfa467e2ced65aa34edd3a0ec71332\":\"0x7801f3e80cc0ff00000\",\"0x935069444a6a984de2084e46692ab99f671fc727\":\"0x1e7e4171bf4d3a00000\",\"0x93507e9e8119cbceda8ab087e7ecb071383d6981\":\"0x2f6f10780d22cc00000\",\"0x93678a3c57151aeb68efdc43ef4d36cb59a009f3\":\"0x1a12a92bc3c3e0000\",\"0x936dcf000194e3bff50ac5b4243a3ba014d661d8\":\"0x21e19e0c9bab2400000\",\"0x936f3813f5f6a13b8e4ffec83fe7f826186a71cd\":\"0x1c30731cec03200000\",\"0x9374869d4a9911ee1eaf558bc4c2b63ec63acfdd\":\"0x3635c9adc5dea00000\",\"0x937563d8a80fd5a537b0e66d20a02525d5d88660\":\"0x878678326eac900000\",\"0x9376dce2af2ec8dcda741b7e7345664681d93668\":\"0x3635c9adc5dea00000\",\"0x93868ddb2a794d02ebda2fa4807c76e3609858dc\":\"0x6dee15fc7c24a78000\",\"0x939c4313d2280edf5e071bced846063f0a975d54\":\"0x1969368974c05b000000\",\"0x93a6b3ab423010f981a7489d4aad25e2625c5741\":\"0x44680fe6a1ede4e8000\",\"0x93aa8f92ebfff991fc055e906e651ac768d32bc8\":\"0x32f51edbaaa3300000\",\"0x93b4bf3fdff6de3f4e56ba6d7799dc4b93a6548f\":\"0x10910d4cdc9f60000\",\"0x93bc7d9a4abd44c8bbb8fe8ba804c61ad8d6576c\":\"0xd8d6119a8146050000\",\"0x93c2e64e5de5589ed25006e843196ee9b1cf0b3e\":\"0x5a87e7d7f5f6580000\",\"0x93c88e2d88621e30f58a9586bed4098999eb67dd\":\"0x69b5afac750bb800000\",\"0x93e0f37ecdfb0086e3e862a97034447b1e4dec1a\":\"0x1a055690d9db80000\",\"0x93e303411afaf6c107a44101c9ac5b36e9d6538b\":\"0xdf9ddfecd0365400000\",\"0x93f18cd2526040761488c513174d1e7963768b2c\":\"0x82ffac9ad593720000\",\"0x940f715140509ffabf974546fab39022a41952d2\":\"0x4be4e7267b6ae00000\",\"0x942c6b8c955bc0d88812678a236725b32739d947\":\"0x54069233bf7f780000\",\"0x943d37864a4a537d35c8d99723cd6406ce2562e6\":\"0x6c6b935b8bbd400000\",\"0x94439ca9cc169a79d4a09cae5e67764a6f871a21\":\"0xd02ab486cedc00000\",\"0x94449c01b32a7fa55af8104f42cdd844aa8cbc40\":\"0x38111a1f4f03c100000\",\"0x9445ba5c30e98961b8602461d0385d40fbd80311\":\"0x21e19e0c9bab2400000\",\"0x944f07b96f90c5f0d7c0c580533149f3f585a078\":\"0x402f4cfee62e80000\",\"0x9454b3a8bff9709fd0e190877e6cb6c89974dbd6\":\"0x90f534608a72880000\",\"0x945d96ea573e8df7262bbfa572229b4b16016b0f\":\"0xb589ef914c1420000\",\"0x945e18769d7ee727c7013f92de24d117967ff317\":\"0x6c6b935b8bbd400000\",\"0x94612781033b57b146ee74e753c672017f5385e4\":\"0xc328093e61ee400000\",\"0x94644ad116a41ce2ca7fbec609bdef738a2ac7c7\":\"0x10f0cf064dd59200000\",\"0x9470cc36594586821821c5c996b6edc83b6d5a32\":\"0x14d1120d7b1600000\",\"0x9475c510ec9a26979247744c3d8c3b0e0b5f44d3\":\"0x21e19e0c9bab2400000\",\"0x947e11e5ea290d6fc3b38048979e0cd44ec7c17f\":\"0x6c6b935b8bbd400000\",\"0x9483d98f14a33fdc118d403955c29935edfc5f70\":\"0x18ea3b34ef51880000\",\"0x949131f28943925cfc97d41e0cea0b262973a730\":\"0x97c9ce4cf6d5c00000\",\"0x949f84f0b1d7c4a7cf49ee7f8b2c4a134de32878\":\"0x252248deb6e6940000\",\"0x949f8c107bc7f0aceaa0f17052aadbd2f9732b2e\":\"0x6c6b935b8bbd400000\",\"0x94a7cda8f481f9d89d42c303ae1632b3b709db1d\":\"0x1043561a8829300000\",\"0x94a9a71691317c2064271b51c9353fbded3501a8\":\"0xb50fcfafebecb00000\",\"0x94ad4bad824bd0eb9ea49c58cebcc0ff5e08346b\":\"0x692ae8897081d00000\",\"0x94bbc67d13f89ebca594be94bc5170920c30d9f3\":\"0x458ffa3150a540000\",\"0x94be3ae54f62d663b0d4cc9e1ea8fe9556ea9ebf\":\"0x143132ca843180000\",\"0x94c055e858357aaa30cf2041fa9059ce164a1f91\":\"0x43c25e0dcc1bd1c0000\",\"0x94c742fd7a8b7906b3bfe4f8904fc0be5c768033\":\"0x43c33c1937564800000\",\"0x94ca56de777fd453177f5e0694c478e66aff8a84\":\"0x1b1ae4d6e2ef500000\",\"0x94d81074db5ae197d2bb1373ab80a87d121c4bd3\":\"0x1fd933494aa5fe00000\",\"0x94db807873860aac3d5aea1e885e52bff2869954\":\"0xae8e7a0bb575d00000\",\"0x94e1f5cb9b8abace03a1a6428256553b690c2355\":\"0x1158e460913d00000\",\"0x94ef8be45077c7d4c5652740de946a62624f713f\":\"0x56cf5593a18f88000\",\"0x94f13f9f0836a3ee2437a84922d2984dc0f7d53b\":\"0xa2a0329bc38abe0000\",\"0x94f8f057db7e60e675ad940f155885d1a477348e\":\"0x15be6174e1912e0000\",\"0x94fcceadfe5c109c5eaeaf462d43873142c88e22\":\"0x1043561a88293000000\",\"0x95034e1621865137cd4739b346dc17da3a27c34e\":\"0x55a6e79ccd1d300000\",\"0x950c68a40988154d2393fff8da7ccda99614f72c\":\"0xf94146fd8dcde58000\",\"0x950fe9c6cad50c18f11a9ed9c45740a6180612d0\":\"0x1b1ae4d6e2ef5000000\",\"0x952183cfd38e352e579d36decec5b18450f7fba0\":\"0x6c6b935b8bbd400000\",\"0x95278b08dee7c0f2c8c0f722f9fcbbb9a5241fda\":\"0x829309f64f0db00000\",\"0x952c57d2fb195107d4cd5ca300774119dfad2f78\":\"0x6c6b935b8bbd400000\",\"0x953572f0ea6df9b197cae40e4b8ecc056c4371c5\":\"0x3635c9adc5dea00000\",\"0x953ef652e7b769f53d6e786a58952fa93ee6abe7\":\"0x9b0a791f1211300000\",\"0x95447046313b2f3a5e19b948fd3b8bedc82c717c\":\"0x1b1ae4d6e2ef500000\",\"0x955db3b74360b9a268677e73cea821668af6face\":\"0x65a4da25d3016c00000\",\"0x9560e8ac6718a6a1cdcff189d603c9063e413da6\":\"0xd8d726b7177a800000\",\"0x9567a0de811de6ff095b7ee64e7f1b83c2615b80\":\"0xe7eeba3410b740000\",\"0x95681cdae69b2049ce101e325c759892cac3f811\":\"0x9ae92a9bc94c400000\",\"0x9568b7de755628af359a84543de23504e15e41e6\":\"0x878678326eac9000000\",\"0x9569c63a9284a805626db3a32e9d236393476151\":\"0x6acb3df27e1f880000\",\"0x95809e8da3fbe4b7f281f0b8b1715f420f7d7d63\":\"0x6c6b935b8bbd400000\",\"0x959f57fded6ae37913d900b81e5f48a79322c627\":\"0xddb26104749118000\",\"0x959ff17f1d51b473b44010052755a7fa8c75bd54\":\"0x6acb3df27e1f880000\",\"0x95a577dc2eb3ae6cb9dfc77af697d7efdfe89a01\":\"0x75f610f70ed200000\",\"0x95cb6d8a6379f94aba8b885669562c4d448e56a7\":\"0x6c6b935b8bbd400000\",\"0x95d550427b5a514c751d73a0f6d29fb65d22ed10\":\"0x1043561a8829300000\",\"0x95d98d0c1069908f067a52acac2b8b534da37afd\":\"0x6f59b630a929708000\",\"0x95df4e3445d7662624c48eba74cf9e0a53e9f732\":\"0xbdbc41e0348b3000000\",\"0x95e6a54b2d5f67a24a4875af75107ca7ea9fd2fa\":\"0x487a9a304539440000\",\"0x95e6f93dac228bc7585a25735ac2d076cc3a4017\":\"0x14542ba12a337c00000\",\"0x95e7616424cd0961a71727247437f0069272280e\":\"0x15af1d78b58c400000\",\"0x95e80a82c20cbe3d2060242cb92d735810d034a2\":\"0x1c32e463fd4b98000\",\"0x95f62d0243ede61dad9a3165f53905270d54e242\":\"0x57473d05dabae80000\",\"0x95fb5afb14c1ef9ab7d179c5c300503fd66a5ee2\":\"0x1daf7a02b0dbe8000\",\"0x9610592202c282ab9bd8a884518b3e0bd4758137\":\"0xe873f44133cb00000\",\"0x961c59adc74505d1864d1ecfcb8afa0412593c93\":\"0x878678326eac9000000\",\"0x962c0dec8a3d464bf39b1215eafd26480ae490cd\":\"0x6c82e3eaa513e80000\",\"0x962cd22a8edf1e4f4e55b4b15ddbfb5d9d541971\":\"0x6c6b935b8bbd400000\",\"0x96334bfe04fffa590213eab36514f338b864b736\":\"0x15af1d78b58c400000\",\"0x9637dc12723d9c78588542eab082664f3f038d9d\":\"0x3635c9adc5dea00000\",\"0x964eab4b276b4cd8983e15ca72b106900fe41fce\":\"0x1b1ae4d6e2ef500000\",\"0x9662ee021926682b31c5f200ce457abea76c6ce9\":\"0x24590e8589eb6a0000\",\"0x966c04781cb5e67dde3235d7f8620e1ab663a9a5\":\"0x100d2050da6351600000\",\"0x967076a877b18ec15a415bb116f06ef32645dba3\":\"0x6c6b935b8bbd400000\",\"0x967bfaf76243cdb9403c67d2ceefdee90a3feb73\":\"0x349d87f2a2dc2f0000\",\"0x967d4142af770515dd7062af93498dbfdff29f20\":\"0x11854d0f9cee40000\",\"0x968b14648f018333687cd213fa640aec04ce6323\":\"0x3635c9adc5dea00000\",\"0x968dea60df3e09ae3c8d3505e9c080454be0e819\":\"0x14542ba12a337c00000\",\"0x96924191b7df655b3319dc6d6137f481a73a0ff3\":\"0xd9ecb4fd208e500000\",\"0x9696052138338c722f1140815cf7749d0d3b3a74\":\"0x1b1ae4d6e2ef500000\",\"0x96a55f00dff405dc4de5e58c57f6f6f0cac55d2f\":\"0x6a6616379c87b58000\",\"0x96aa573fed2f233410dbae5180145b23c31a02f0\":\"0x5dc892aa1131c80000\",\"0x96ad579bbfa8db8ebec9d286a72e4661eed8e356\":\"0x3a0ba42bec61830000\",\"0x96b434fe0657e42acc8212b6865139dede15979c\":\"0xd8d726b7177a800000\",\"0x96b906ea729f4655afe3e57d35277c967dfa1577\":\"0x3635c9adc5dea00000\",\"0x96d62dfd46087f62409d93dd606188e70e381257\":\"0x6c6b935b8bbd400000\",\"0x96d9cca8f55eea0040ec6eb348a1774b95d93ef4\":\"0xd8d726b7177a800000\",\"0x96e7c0c9d5bf10821bf140c558a145b7cac21397\":\"0x393ef1a5127c800000\",\"0x96ea6ac89a2bac95347b51dba63d8bd5ebdedce1\":\"0x6c6b935b8bbd400000\",\"0x96eafbf2fb6f4db9a436a74c45b5654452e23819\":\"0x1158e460913d00000\",\"0x96eb523e832f500a017de13ec27f5d366c560eff\":\"0x10acceba43ee280000\",\"0x96f0462ae6f8b96088f7e9c68c74b9d8ad34b347\":\"0x61093d7c2c6d380000\",\"0x96f820500b70f4a3e3239d619cff8f222075b135\":\"0xad78ebc5ac6200000\",\"0x96fe59c3dbb3aa7cc8cb62480c65e56e6204a7e2\":\"0x43c33c1937564800000\",\"0x96ff6f509968f36cb42cba48db32f21f5676abf8\":\"0x6acb3df27e1f880000\",\"0x970938522afb5e8f994873c9fbdc26e3b37e314c\":\"0x3635c9adc5dea00000\",\"0x970abd53a54fca4a6429207c182d4d57bb39d4a0\":\"0x6c6b935b8bbd400000\",\"0x970d8b8a0016d143054f149fb3b8e550dc0797c7\":\"0x3635c9adc5dea00000\",\"0x972c2f96aa00cf8a2f205abcf8937c0c75f5d8d9\":\"0xad78ebc5ac6200000\",\"0x973f4e361fe5decd989d4c8f7d7cc97990385daf\":\"0x150f8543a387420000\",\"0x974d0541ab4a47ec7f75369c0069b64a1b817710\":\"0x15af1d78b58c400000\",\"0x974d2f17895f2902049deaaecf09c3046507402d\":\"0xcc19c29437ab8000\",\"0x9752d14f5e1093f071711c1adbc4e3eb1e5c57f3\":\"0x6c6b935b8bbd400000\",\"0x9756e176c9ef693ee1eec6b9f8b151d313beb099\":\"0x410d586a20a4c00000\",\"0x975f3764e97bbccf767cbd3b795ba86d8ba9840e\":\"0x12c1b6eed03d280000\",\"0x976a18536af41874426308871bcd1512a775c9f8\":\"0x21e19e0c9bab2400000\",\"0x976e3ceaf3f1af51f8c29aff5d7fa21f0386d8ee\":\"0xd02ab486cedc00000\",\"0x9777cc61cf756be3b3c20cd4491c69d275e7a120\":\"0x21e19e0c9bab2400000\",\"0x97810bafc37e84306332aacb35e92ad911d23d24\":\"0x3635c9adc5dea00000\",\"0x978c430ce4359b06bc2cdf5c2985fc950e50d5c8\":\"0x1a055690d9db800000\",\"0x9795f64319fc17dd0f8261f9d206fb66b64cd0c9\":\"0xad78ebc5ac6200000\",\"0x9799ca21dbcf69bfa1b3f72bac51b9e3ca587cf9\":\"0x5c283d410394100000\",\"0x979cbf21dfec8ace3f1c196d82df962534df394f\":\"0x9991d478dd4d160000\",\"0x979d681c617da16f21bcaca101ed16ed015ab696\":\"0x65ea3db75546600000\",\"0x979f30158b574b999aab348107b9eed85b1ff8c1\":\"0x34957444b840e80000\",\"0x97a86f01ce3f7cfd4441330e1c9b19e1b10606ef\":\"0x6c6b935b8bbd400000\",\"0x97b91efe7350c2d57e7e406bab18f3617bcde14a\":\"0x21e1999bbd5d2be0000\",\"0x97d0d9725e3b70e675843173938ed371b62c7fac\":\"0x93739534d28680000\",\"0x97d9e46a7604d7b5a4ea4ee61a42b3d2350fc3ed\":\"0x6c6b935b8bbd400000\",\"0x97dc26ec670a31e0221d2a75bc5dc9f90c1f6fd4\":\"0x2b5e3af16b1880000\",\"0x97de21e421c37fe4b8025f9a51b7b390b5df7804\":\"0x10f0cf064dd592000000\",\"0x97e28973b860c567402800fbb63ce39a048a3d79\":\"0x542253a126ce40000\",\"0x97e5cc6127c4f885be02f44b42d1c8b0ac91e493\":\"0xad78ebc5ac6200000\",\"0x97f1fe4c8083e596212a187728dd5cf80a31bec5\":\"0x1158e460913d00000\",\"0x97f7760657c1e202759086963eb4211c5f8139b9\":\"0xa8a097fcb3d17680000\",\"0x97f99b6ba31346cd98a9fe4c308f87c5a58c5151\":\"0x14542ba12a337c00000\",\"0x980a84b686fc31bdc83c221058546a71b11f838a\":\"0x2a415548af86818000\",\"0x9810e34a94db6ed156d0389a0e2b80f4fd6b0a8a\":\"0x6c6b935b8bbd400000\",\"0x981ddf0404e4d22dda556a0726f00b2d98ab9569\":\"0x36356633ebd8ea0000\",\"0x981f712775c0dad97518ffedcb47b9ad1d6c2762\":\"0x16a6502f15a1e540000\",\"0x9834682180b982d166badb9d9d1d9bbf016d87ee\":\"0x6c6b935b8bbd400000\",\"0x9836b4d30473641ab56aeee19242761d72725178\":\"0x6c6b935b8bbd400000\",\"0x98397342ec5f3d4cb877e54ef5d6f1d366731bd4\":\"0x14061b9d77a5e980000\",\"0x9846648836a307a057184fd51f628a5f8c12427c\":\"0x40b69bf43dce8f00000\",\"0x984a7985e3cc7eb5c93691f6f8cc7b8f245d01b2\":\"0x14542ba12a337c00000\",\"0x985d70d207892bed398590024e2421b1cc119359\":\"0x43c33c1937564800000\",\"0x986df47e76e4d7a789cdee913cc9831650936c9d\":\"0x10f0cf064dd59200000\",\"0x9874803fe1f3a0365e7922b14270eaeb032cc1b5\":\"0x3cf5928824c6c20000\",\"0x9875623495a46cdbf259530ff838a1799ec38991\":\"0x6c6b935b8bbd400000\",\"0x987618c85656207c7bac1507c0ffefa2fb64b092\":\"0x37dfe433189e38000\",\"0x987c9bcd6e3f3990a52be3eda4710c27518f4f72\":\"0x15af1d78b58c400000\",\"0x9882967cee68d2a839fad8ab4a7c3dddf6c0adc8\":\"0x4878be1ffaf95d0000\",\"0x98855c7dfbee335344904a12c40c731795b13a54\":\"0x39fbae8d042dd00000\",\"0x989c0ccff654da03aeb11af701054561d6297e1d\":\"0xd8d726b7177a800000\",\"0x98a0e54c6d9dc8be96276cebf4fec460f6235d85\":\"0x6ac882100952c78000\",\"0x98b769cc305cecfb629a00c907069d7ef9bc3a12\":\"0x168d28e3f00280000\",\"0x98ba4e9ca72fddc20c69b4396f76f8183f7a2a4e\":\"0x2b5e3af16b188000000\",\"0x98be696d51e390ff1c501b8a0f6331b628ddc5ad\":\"0x6c6b935b8bbd400000\",\"0x98bed3a72eccfbafb923489293e429e703c7e25b\":\"0x6c6b935b8bbd400000\",\"0x98bf4af3810b842387db70c14d46099626003d10\":\"0xd8d726b7177a800000\",\"0x98c10ebf2c4f97cba5a1ab3f2aafe1cac423f8cb\":\"0x1043561a8829300000\",\"0x98c19dba810ba611e68f2f83ee16f6e7744f0c1f\":\"0xad78ebc5ac6200000\",\"0x98c5494a03ac91a768dffc0ea1dde0acbf889019\":\"0x2a5a058fc295ed000000\",\"0x98d204f9085f8c8e7de23e589b64c6eff692cc63\":\"0x6c6b935b8bbd400000\",\"0x98d3731992d1d40e1211c7f735f2189afa0702e0\":\"0x1b1ae4d6e2ef5000000\",\"0x98e2b6d606fd2d6991c9d6d4077fdf3fdd4585da\":\"0x30df1a6f8ad6280000\",\"0x98e3e90b28fccaee828779b8d40a5568c4116e21\":\"0x22b1c8c1227a00000\",\"0x98e6f547db88e75f1f9c8ac2c5cf1627ba580b3e\":\"0x3635c9adc5dea00000\",\"0x98f4af3af0aede5fafdc42a081ecc1f89e3ccf20\":\"0x1fd933494aa5fe00000\",\"0x98f6b8e6213dbc9a5581f4cce6655f95252bdb07\":\"0x115872b0bca4300000\",\"0x9909650dd5b1397b8b8b0eb69499b291b0ad1213\":\"0xad78ebc5ac6200000\",\"0x991173601947c2084a62d639527e961512579af9\":\"0x2086ac351052600000\",\"0x99129d5b3c0cde47ea0def4dfc070d1f4a599527\":\"0x6c6b935b8bbd400000\",\"0x9917d68d4af341d651e7f0075c6de6d7144e7409\":\"0x132d4476c08e6f00000\",\"0x991ac7ca7097115f26205eee0ef7d41eb4e311ae\":\"0x1158e460913d00000\",\"0x992365d764c5ce354039ddfc912e023a75b8e168\":\"0xfc936392801c0000\",\"0x992646ac1acaabf5ddaba8f9429aa6a94e7496a7\":\"0x3637507a30abeb0000\",\"0x99268327c373332e06c3f6164287d455b9d5fa4b\":\"0x6c6b935b8bbd400000\",\"0x9928ff715afc3a2b60f8eb4cc4ba4ee8dab6e59d\":\"0x17da3a04c7b3e00000\",\"0x9932ef1c85b75a9b2a80057d508734c51085becc\":\"0x2b83fa5301d590000\",\"0x993f146178605e66d517be782ef0b3c61a4e1925\":\"0x17c1f0535d7a5830000\",\"0x99413704b1a32e70f3bc0d69dd881c38566b54cb\":\"0x5cc6b694631f7120000\",\"0x994152fc95d5c1ca8b88113abbad4d710e40def6\":\"0x1b1ae4d6e2ef500000\",\"0x9944fee9d34a4a880023c78932c00b59d5c82a82\":\"0x28a8a56b3690070000\",\"0x994cc2b5227ec3cf048512467c41b7b7b748909f\":\"0x6c6b935b8bbd400000\",\"0x9971df60f0ae66dce9e8c84e17149f09f9c52f64\":\"0xad78ebc5ac6200000\",\"0x9976947eff5f6ae5da08dd541192f378b428ff94\":\"0x1b1ae4d6e2ef5000000\",\"0x997d6592a31589acc31b9901fbeb3cc3d65b3215\":\"0x6c6b935b8bbd400000\",\"0x9982a5890ffb5406d3aca8d2bfc1dd70aaa80ae0\":\"0x6c6b935b8bbd400000\",\"0x99878f9d6e0a7ed9aec78297b73879a80195afe0\":\"0xd7c198710e66b00000\",\"0x998c1f93bcdb6ff23c10d0dc924728b73be2ff9f\":\"0x365bf3a433eaf30000\",\"0x9991614c5baa47dd6c96874645f97add2c3d8380\":\"0x6acb3df27e1f880000\",\"0x99924a9816bb7ddf3fec1844828e9ad7d06bf4e6\":\"0x5f68e8131ecf800000\",\"0x99997668f7c1a4ff9e31f9977ae3224bcb887a85\":\"0xfc936392801c00000\",\"0x999c49c174ca13bc836c1e0a92bff48b271543ca\":\"0xb1cf24ddd0b1400000\",\"0x99a4de19ded79008cfdcd45d014d2e584b8914a8\":\"0x5150ae84a8cdf00000\",\"0x99a96bf2242ea1b39ece6fcc0d18aed00c0179f3\":\"0x1043561a8829300000\",\"0x99b018932bcad355b6792b255db6702dec8ce5dd\":\"0xd8d8583fa2d52f0000\",\"0x99b743d1d9eff90d9a1934b4db21d519d89b4a38\":\"0x56bc75e2d63100000\",\"0x99b8c824869de9ed24f3bff6854cb6dd45cc3f9f\":\"0x65ea3db75546600000\",\"0x99c0174cf84e0783c220b4eb6ae18fe703854ad3\":\"0x7079a2573d0c780000\",\"0x99c1d9f40c6ab7f8a92fce2fdce47a54a586c53f\":\"0x35659ef93f0fc40000\",\"0x99c236141daec837ece04fdaee1d90cf8bbdc104\":\"0x766516acac0d200000\",\"0x99c31fe748583787cdd3e525b281b218961739e3\":\"0x3708baed3d68900000\",\"0x99c475bf02e8b9214ada5fad02fdfd15ba365c0c\":\"0x2009c5c8bf6fdc0000\",\"0x99c883258546cc7e4e971f522e389918da5ea63a\":\"0xd8d726b7177a800000\",\"0x99c9f93e45fe3c1418c353e4c5ac3894eef8121e\":\"0x585baf145050b0000\",\"0x99d1579cd42682b7644e1d4f7128441eeffe339d\":\"0x43c33c1937564800000\",\"0x99d1b585965f406a42a49a1ca70f769e765a3f98\":\"0x3894f0e6f9b9f700000\",\"0x99dfd0504c06c743e46534fd7b55f1f9c7ec3329\":\"0x6c6b935b8bbd400000\",\"0x99f4147ccc6bcb80cc842e69f6d00e30fa4133d9\":\"0x15af1d78b58c400000\",\"0x99f77f998b20e0bcdcd9fc838641526cf25918ef\":\"0x61093d7c2c6d380000\",\"0x99fad50038d0d9d4c3fbb4bce05606ecadcd5121\":\"0x6c6b935b8bbd400000\",\"0x99fe0d201228a753145655d428eb9fd94985d36d\":\"0x6920bff3515a3a0000\",\"0x9a079c92a629ca15c8cafa2eb28d5bc17af82811\":\"0x1b1ae4d6e2ef500000\",\"0x9a0d3cee3d9892ea3b3700a27ff84140d9025493\":\"0x340aad21b3b700000\",\"0x9a24ce8d485cc4c86e49deb39022f92c7430e67e\":\"0x46791fc84e07d00000\",\"0x9a2ce43b5d89d6936b8e8c354791b8afff962425\":\"0x6c6b935b8bbd400000\",\"0x9a390162535e398877e416787d6239e0754e937c\":\"0x3635c9adc5dea00000\",\"0x9a3da65023a13020d22145cfc18bab10bd19ce4e\":\"0x18bf6ea3464a3a0000\",\"0x9a3e2b1bf346dd070b027357feac44a4b2c97db8\":\"0x21e19e0c9bab2400000\",\"0x9a4ca8b82117894e43db72b9fa78f0b9b93ace09\":\"0x2b5e3af16b1880000\",\"0x9a522e52c195bfb7cf5ffaaedb91a3ba7468161d\":\"0x3635c9adc5dea00000\",\"0x9a5af31c7e06339ac8b4628d7c4db0ce0f45c8a4\":\"0x1b1ae4d6e2ef500000\",\"0x9a633fcd112cceeb765fe0418170732a9705e79c\":\"0xfc936392801c0000\",\"0x9a63d185a79129fdab19b58bb631ea36a420544e\":\"0x246ddf97976680000\",\"0x9a6708ddb8903c289f83fe889c1edcd61f854423\":\"0x3635c9adc5dea00000\",\"0x9a6ff5f6a7af7b7ae0ed9c20ecec5023d281b786\":\"0x8a12b9bd6a67ec0000\",\"0x9a82826d3c29481dcc2bd2950047e8b60486c338\":\"0x43c33c1937564800000\",\"0x9a8eca4189ff4aa8ff7ed4b6b7039f0902219b15\":\"0x1158e460913d00000\",\"0x9a953b5bcc709379fcb559d7b916afdaa50cadcc\":\"0x56bc75e2d63100000\",\"0x9a990b8aeb588d7ee7ec2ed8c2e64f7382a9fee2\":\"0x1d127db69fd8b0000\",\"0x9a9d1dc0baa77d6e20c3d849c78862dd1c054c87\":\"0x2fb474098f67c00000\",\"0x9aa48c66e4fb4ad099934e32022e827427f277ba\":\"0x21e19e0c9bab2400000\",\"0x9aa8308f42910e5ade09c1a5e282d6d91710bdbf\":\"0xad78ebc5ac6200000\",\"0x9aaafa0067647ed999066b7a4ca5b4b3f3feaa6f\":\"0x3635c9adc5dea00000\",\"0x9ab988b505cfee1dbe9cd18e9b5473b9a2d4f536\":\"0x1158e460913d000000\",\"0x9ab98d6dbb1eaae16d45a04568541ad3d8fe06cc\":\"0xec50464fe23f38000\",\"0x9aba2b5e27ff78baaab5cdc988b7be855cebbdce\":\"0x21e0c0013070adc0000\",\"0x9ac4da51d27822d1e208c96ea64a1e5b55299723\":\"0x56c5579f722140000\",\"0x9ac85397792a69d78f286b86432a07aeceb60e64\":\"0xc673ce3c40160000\",\"0x9ac907ee85e6f3e223459992e256a43fa08fa8b2\":\"0x21e19e0c9bab2400000\",\"0x9ad47fdcf9cd942d28effd5b84115b31a658a13e\":\"0xb259ec00d53b280000\",\"0x9adbd3bc7b0afc05d1d2eda49ff863939c48db46\":\"0xad6eedd17cf3b8000\",\"0x9adf458bff3599eee1a26398853c575bc38c6313\":\"0xf2dc7d47f15600000\",\"0x9ae13bd882f2576575921a94974cbea861ba0d35\":\"0xab4dcf399a3a600000\",\"0x9ae9476bfecd3591964dd325cf8c2a24faed82c1\":\"0xd8d726b7177a800000\",\"0x9af100cc3dae83a33402051ce4496b16615483f6\":\"0x6c6b935b8bbd400000\",\"0x9af11399511c213181bfda3a8b264c05fc81b3ce\":\"0x2f6f10780d22cc00000\",\"0x9af5c9894c33e42c2c518e3ac670ea9505d1b53e\":\"0xfc936392801c0000\",\"0x9af9dbe47422d177f945bdead7e6d82930356230\":\"0xd5967be4fc3f100000\",\"0x9afa536b4c66bc38d875c4b30099d9261fdb38eb\":\"0xb2a8f842a77bc8000\",\"0x9b06ad841dffbe4ccf46f1039fc386f3c321446e\":\"0x6c6b935b8bbd400000\",\"0x9b1168de8ab64b47552f3389800a9cc08b4666cf\":\"0x5dc892aa1131c80000\",\"0x9b1811c3051f46e664ae4bc9c824d18592c4574a\":\"0xad6eedd17cf3b8000\",\"0x9b18478655a4851cc906e660feac61f7f4c8bffc\":\"0xe2478d38907d840000\",\"0x9b22a80d5c7b3374a05b446081f97d0a34079e7f\":\"0xa2a15d09519be00000\",\"0x9b2be7f56754f505e3441a10f7f0e20fd3ddf849\":\"0x126e72a69a50d00000\",\"0x9b32cf4f5115f4b34a00a64c617de06387354323\":\"0x5b81ed888207c8000\",\"0x9b43dcb95fde318075a567f1e6b57617055ef9e8\":\"0xd5967be4fc3f100000\",\"0x9b444fd337e5d75293adcfff70e1ea01db023222\":\"0x56bc75e2d63100000\",\"0x9b4824ff9fb2abda554dee4fb8cf549165570631\":\"0x1158e460913d00000\",\"0x9b4c2715780ca4e99e60ebf219f1590c8cad500a\":\"0x56bc75e2d631000000\",\"0x9b59eb213b1e7565e45047e04ea0374f10762d16\":\"0x6c6b935b8bbd400000\",\"0x9b5c39f7e0ac168c8ed0ed340477117d1b682ee9\":\"0x55005f0c614480000\",\"0x9b5ec18e8313887df461d2902e81e67a8f113bb1\":\"0x56bc75e2d63100000\",\"0x9b64d3cd8d2b73f66841b5c46bb695b88a9ab75d\":\"0x1203a4f760c168000\",\"0x9b658fb361e046d4fcaa8aef6d02a99111223625\":\"0x6c6b935b8bbd400000\",\"0x9b6641b13e172fc072ca4b8327a3bc28a15b66a9\":\"0x68155a43676e00000\",\"0x9b68f67416a63bf4451a31164c92f672a68759e9\":\"0xcb49b44ba602d800000\",\"0x9b773669e87d76018c090f8255e54409b9dca8b2\":\"0x1158e460913d00000\",\"0x9b77ebced7e215f0920e8c2b870024f6ecb2ff31\":\"0x3635c9adc5dea00000\",\"0x9b7c8810cc7cc89e804e6d3e38121850472877fe\":\"0x6c6b935b8bbd400000\",\"0x9ba53dc8c95e9a472feba2c4e32c1dc4dd7bab46\":\"0x487a9a304539440000\",\"0x9bacd3d40f3b82ac91a264d9d88d908eac8664b9\":\"0x43c33c1937564800000\",\"0x9bb760d5c289a3e1db18db095345ca413b9a43c2\":\"0xaadec983fcff40000\",\"0x9bb76204186af2f63be79168601687fc9bad661f\":\"0x1043561a8829300000\",\"0x9bb9b02a26bfe1ccc3f0c6219e261c397fc5ca78\":\"0x487a9a304539440000\",\"0x9bc573bcda23b8b26f9073d90c230e8e71e0270b\":\"0x362f75a4305d0c0000\",\"0x9bd7c38a4210304a4d653edeff1b3ce45fce7843\":\"0xf498941e664280000\",\"0x9bd88068e13075f3a8cac464a5f949d6d818c0f6\":\"0x14542ba12a337c00000\",\"0x9bd905f1719fc7acd0159d4dc1f8db2f21472338\":\"0x3635c9adc5dea00000\",\"0x9bdbdc9b973431d13c89a3f9757e9b3b6275bfc7\":\"0x1b1a7dcf8a44d38000\",\"0x9be3c329b62a28b8b0886cbd8b99f8bc930ce3e6\":\"0x409e52b48369a0000\",\"0x9bf58efbea0784eb068adecfa0bb215084c73a35\":\"0x13a6b2b564871a00000\",\"0x9bf672d979b36652fc5282547a6a6bc212ae4368\":\"0x238fd42c5cf0400000\",\"0x9bf703b41c3624e15f4054962390bcba3052f0fd\":\"0x1483e01533c2e3c0000\",\"0x9bf71f7fb537ac54f4e514947fa7ff6728f16d2f\":\"0x1cf84a30a0a0c0000\",\"0x9bf9b3b2f23cf461eb591f28340bc719931c8364\":\"0x3635c9adc5dea00000\",\"0x9bfc659c9c601ea42a6b21b8f17084ec87d70212\":\"0x21e19e0c9bab2400000\",\"0x9bfff50db36a785555f07652a153b0c42b1b8b76\":\"0x6c6b935b8bbd400000\",\"0x9c05e9d0f0758e795303717e31da213ca157e686\":\"0x3635c9adc5dea00000\",\"0x9c1b771f09af882af0643083de2aa79dc097c40e\":\"0x8670e9ec6598c00000\",\"0x9c28a2c4086091cb5da226a657ce3248e8ea7b6f\":\"0xf2dc7d47f15600000\",\"0x9c2fd54089af665df5971d73b804616039647375\":\"0x3635c9adc5dea00000\",\"0x9c344098ba615a398f11d009905b177c44a7b602\":\"0x3635c9adc5dea00000\",\"0x9c3d0692ceeef80aa4965ceed262ffc7f069f2dc\":\"0xad78ebc5ac6200000\",\"0x9c405cf697956138065e11c5f7559e67245bd1a5\":\"0xad78ebc5ac6200000\",\"0x9c45202a25f6ad0011f115a5a72204f2f2198866\":\"0x10fcf3a62b080980000\",\"0x9c49deff47085fc09704caa2dca8c287a9a137da\":\"0x1b1ae4d6e2ef5000000\",\"0x9c4bbcd5f1644a6f075824ddfe85c571d6abf69c\":\"0x6194049f30f7200000\",\"0x9c526a140683edf1431cfaa128a935e2b614d88b\":\"0x6046f37e5945c0000\",\"0x9c54e4ed479a856829c6bb42da9f0b692a75f728\":\"0x197a8f6dd5519800000\",\"0x9c581a60b61028d934167929b22d70b313c34fd0\":\"0xa968163f0a57b400000\",\"0x9c5cc111092c122116f1a85f4ee31408741a7d2f\":\"0x1ab2cf7c9f87e20000\",\"0x9c6bc9a46b03ae5404f043dfcf21883e4110cc33\":\"0xad78ebc5ac6200000\",\"0x9c78963fbc263c09bd72e4f8def74a9475f7055c\":\"0x2eb8eb1a172dcb80000\",\"0x9c78fbb4df769ce2c156920cfedfda033a0e254a\":\"0x6acb3df27e1f880000\",\"0x9c7b6dc5190fe2912963fcd579683ec7395116b0\":\"0x2a1129d09367200000\",\"0x9c80bc18e9f8d4968b185da8c79fa6e11ffc3e23\":\"0xd02ab486cedc00000\",\"0x9c98fdf1fdcd8ba8f4c5b04c3ae8587efdf0f6e6\":\"0x14542ba12a337c00000\",\"0x9c99a1da91d5920bc14e0cb914fdf62b94cb8358\":\"0x43c33c1937564800000\",\"0x9c99b62606281b5cefabf36156c8fe62839ef5f3\":\"0xd8d726b7177a800000\",\"0x9c9a07a8e57c3172a919ef64789474490f0d9f51\":\"0x21e19e0c9bab2400000\",\"0x9c9de44724a4054da0eaa605abcc802668778bea\":\"0xad7d5ca3fa5a20000\",\"0x9c9f3b8a811b21f3ff3fe20fe970051ce66a824f\":\"0x3ec2debc07d4be0000\",\"0x9c9f89a3910f6a2ae8a91047a17ab788bddec170\":\"0x21e19e0c9bab2400000\",\"0x9ca0429f874f8dcee2e9c062a9020a842a587ab9\":\"0x6c6b935b8bbd400000\",\"0x9ca42ee7a0b898f6a5cc60b5a5d7b1bfa3c33231\":\"0x6c6b935b8bbd400000\",\"0x9cb28ac1a20a106f7f373692c5ce4c73f13732a1\":\"0x3635c9adc5dea00000\",\"0x9ccddcb2cfc2b25b08729a0a98d9e6f0202ea2c1\":\"0x56bc75e2d63100000\",\"0x9ce27f245e02d1c312c1d500788c9def7690453b\":\"0xad78ebc5ac6200000\",\"0x9ce5363b13e8238aa4dd15acd0b2e8afe0873247\":\"0xad78ebc5ac6200000\",\"0x9cf2928beef09a40f9bfc953be06a251116182fb\":\"0x14542ba12a337c00000\",\"0x9d069197d1de50045a186f5ec744ac40e8af91c6\":\"0x6c6b935b8bbd400000\",\"0x9d0e7d92fb305853d798263bf15e97c72bf9d7e0\":\"0x3635c9adc5dea00000\",\"0x9d0f347e826b7dceaad279060a35c0061ecf334b\":\"0xd8d726b7177a800000\",\"0x9d207517422cc0d60de7c237097a4d4fce20940c\":\"0x1b1ae4d6e2ef500000\",\"0x9d250ae4f110d71cafc7b0adb52e8d9acb6679b8\":\"0x2156d6e997213c00000\",\"0x9d2bfc36106f038250c01801685785b16c86c60d\":\"0x5077d75df1b675800000\",\"0x9d30cb237bc096f17036fc80dd21ca68992ca2d9\":\"0x66ee7318fdc8f300000\",\"0x9d32962ea99700d93228e9dbdad2cc37bb99f07e\":\"0xb4632bedd4ded40000\",\"0x9d34dac25bd15828faefaaf28f710753b39e89dc\":\"0x3b1c56fed02df00000\",\"0x9d369165fb70b81a3a765f188fd60cbe5e7b0968\":\"0x6c6b935b8bbd400000\",\"0x9d40e012f60425a340d82d03a1c757bfabc706fb\":\"0x9346f3addc88d8000\",\"0x9d4174aa6af28476e229dadb46180808c67505c1\":\"0x421afda42ed6970000\",\"0x9d4213339a01551861764c87a93ce8f85f87959a\":\"0xad78ebc5ac6200000\",\"0x9d460c1b379ddb19a8c85b4c6747050ddf17a875\":\"0xb50fcfafebecb00000\",\"0x9d47ba5b4c8505ad8da42934280b61a0e1e8b971\":\"0x56bc75e2d63100000\",\"0x9d4d321177256ebd9afbda304135d517c3dc5693\":\"0x2164b7a04ac8a00000\",\"0x9d4ff989b7bed9ab109d10c8c7e55f02d76734ad\":\"0x3635c9adc5dea00000\",\"0x9d511543b3d9dc60d47f09d49d01b6c498d82078\":\"0x26197b9516fc3940000\",\"0x9d6ecfa03af2c6e144b7c4692a86951e902e9e1f\":\"0xa2a5aa60ad243f0000\",\"0x9d7655e9f3e5ba5d6e87e412aebe9ee0d49247ee\":\"0x8e09311c1d80fa0000\",\"0x9d7831e834c20b1baa697af1d8e0c621c5afff9a\":\"0x4b06dbbb40f4a0000\",\"0x9d78a975b7db5e4d8e28845cfbe7e31401be0dd9\":\"0x48a43c54602f700000\",\"0x9d799e943e306ba2e5b99c8a6858cbb52c0cf735\":\"0x1043561a8829300000\",\"0x9d7fda7070bf3ee9bbd9a41f55cad4854ae6c22c\":\"0x255cba3c46fcf120000\",\"0x9d81aea69aed6ad07089d61445348c17f34bfc5b\":\"0x1043561a8829300000\",\"0x9d911f3682f32fe0792e9fb6ff3cfc47f589fca5\":\"0xd8d726b7177a800000\",\"0x9d913b5d339c95d87745562563fea98b23c60cc4\":\"0x941302c7f4d230000\",\"0x9d93fab6e22845f8f45a07496f11de71530debc7\":\"0x6c4fd1ee246e780000\",\"0x9d99b189bbd9a48fc2e16e8fcda33bb99a317bbb\":\"0x3d16e10b6d8bb20000\",\"0x9d9c4efe9f433989e23be94049215329fa55b4cb\":\"0xde3b28903c6b58000\",\"0x9d9e57fde30e5068c03e49848edce343b7028358\":\"0x5dc892aa1131c80000\",\"0x9da3302240af0511c6fd1857e6ddb7394f77ab6b\":\"0xa80d24677efef00000\",\"0x9da4ec407077f4b9707b2d9d2ede5ea5282bf1df\":\"0xd8d726b7177a800000\",\"0x9da609fa3a7e6cf2cc0e70cdabe78dc4e382e11e\":\"0x410d586a20a4c00000\",\"0x9da61ccd62bf860656e0325d7157e2f160d93bb5\":\"0x10f0ca956f8799e0000\",\"0x9da6e075989c7419094cc9f6d2e49393bb199688\":\"0x259bb71d5adf3f00000\",\"0x9da8e22ca10e67fea44e525e4751eeac36a31194\":\"0xe18398e7601900000\",\"0x9db2e15ca681f4c66048f6f9b7941ed08b1ff506\":\"0xd8d726b7177a800000\",\"0x9dc10fa38f9fb06810e11f60173ec3d2fd6a751e\":\"0x6acb3df27e1f880000\",\"0x9dd2196624a1ddf14a9d375e5f07152baf22afa2\":\"0x41b05e2463a5438000\",\"0x9dd46b1c6d3f05e29e9c6f037eed9a595af4a9aa\":\"0x1b1ae4d6e2ef500000\",\"0x9ddd355e634ee9927e4b7f6c97e7bf3a2f1e687a\":\"0x2b5e3af16b1880000\",\"0x9de20ae76aa08263b205d5142461961e2408d266\":\"0xda933d8d8c6700000\",\"0x9de20bc37e7f48a80ffd7ad84ffbf1a1abe1738c\":\"0xad78ebc5ac6200000\",\"0x9de7386dde401ce4c67b71b6553f8aa34ea5a17d\":\"0x340aad21b3b700000\",\"0x9deb39027af877992b89f2ec4a1f822ecdf12693\":\"0x6c6b935b8bbd400000\",\"0x9defe56a0ff1a1947dba0923f7dd258d8f12fa45\":\"0x5b12aefafa804000000\",\"0x9df057cd03a4e27e8e032f857985fd7f01adc8d7\":\"0x6c6b935b8bbd400000\",\"0x9df32a501c0b781c0281022f42a1293ffd7b892a\":\"0x1e7e4171bf4d3a00000\",\"0x9e01765aff08bc220550aca5ea2e1ce8e5b09923\":\"0x3635c9adc5dea00000\",\"0x9e20e5fd361eabcf63891f5b87b09268b8eb3793\":\"0x56bc75e2d63100000\",\"0x9e232c08c14dc1a6ed0b8a3b2868977ba5c17d10\":\"0x1158e460913d00000\",\"0x9e23c5e4b782b00a5fadf1aead87dacf5b0367a1\":\"0x1158e460913d00000\",\"0x9e35399071a4a101e9194daa3f09f04a0b5f9870\":\"0xd8d726b7177a800000\",\"0x9e3eb509278fe0dcd8e0bbe78a194e06b6803943\":\"0x32f51edbaaa3300000\",\"0x9e427272516b3e67d4fcbf82f59390d04c8e28e5\":\"0xd8d726b7177a800000\",\"0x9e4cec353ac3e381835e3c0991f8faa5b7d0a8e6\":\"0x21e18b9e9ab45e48000\",\"0x9e5811b40be1e2a1e1d28c3b0774acde0a09603d\":\"0xa2a15d09519be00000\",\"0x9e5a311d9f69898a7c6a9d6360680438e67a7b2f\":\"0x50c5e761a444080000\",\"0x9e7c2050a227bbfd60937e268cea3e68fea8d1fe\":\"0x56bc75e2d63100000\",\"0x9e7f65a90e8508867bccc914256a1ea574cf07e3\":\"0x433874f632cc600000\",\"0x9e8144e08e89647811fe6b72d445d6a5f80ad244\":\"0x21e19e0c9bab2400000\",\"0x9e8f64ddcde9b8b451bafaa235a9bf511a25ac91\":\"0x90f534608a72880000\",\"0x9e951f6dc5e352afb8d04299d2478a451259bf56\":\"0x3e7419881a73a0000\",\"0x9e960dcd03d5ba99cb115d17ff4c09248ad4d0be\":\"0xad78ebc5ac6200000\",\"0x9eaf6a328a4076024efa6b67b48b21eedcc0f0b8\":\"0x890b0c2e14fb80000\",\"0x9eb1ff71798f28d6e989fa1ea0588e27ba86cb7d\":\"0x7a1fe160277000000\",\"0x9eb281c32719c40fdb3e216db0f37fbc73a026b7\":\"0x1158e460913d00000\",\"0x9eb3a7cb5e6726427a3a361cfa8d6164dbd0ba16\":\"0x2b95bdcc39b6100000\",\"0x9eb7834e171d41e069a77947fca87622f0ba4e48\":\"0x56bc75e2d63100000\",\"0x9ec03e02e587b7769def538413e97f7e55be71d8\":\"0x42bf06b78ed3b500000\",\"0x9ecbabb0b22782b3754429e1757aaba04b81189f\":\"0x2ca7bb061f5e998000\",\"0x9ece1400800936c7c6485fcdd3626017d09afbf6\":\"0x10ce1d3d8cb3180000\",\"0x9ed4e63f526542d44fddd34d59cd25388ffd6bda\":\"0xd29b34a46348940000\",\"0x9ed80eda7f55054db9fb5282451688f26bb374c1\":\"0x1043561a8829300000\",\"0x9edc90f4be210865214ab5b35e5a8dd77415279d\":\"0xd8d726b7177a800000\",\"0x9edeac4c026b93054dc5b1d6610c6f3960f2ad73\":\"0x410d586a20a4c00000\",\"0x9ee93f339e6726ec65eea44f8a4bfe10da3d3282\":\"0x6c6b935b8bbd400000\",\"0x9ee9760cc273d4706aa08375c3e46fa230aff3d5\":\"0x1e52e336cde22180000\",\"0x9eeb07bd2b7890195e7d46bdf2071b6617514ddb\":\"0x6c6b935b8bbd400000\",\"0x9eef442d291a447d74c5d253c49ef324eac1d8f0\":\"0xb96608c8103bf00000\",\"0x9ef1896b007c32a15114fb89d73dbd47f9122b69\":\"0xd8d726b7177a800000\",\"0x9f017706b830fb9c30efb0a09f506b9157457534\":\"0x6c6b935b8bbd400000\",\"0x9f10f2a0463b65ae30b070b3df18cf46f51e89bd\":\"0x678a932062e4180000\",\"0x9f19fac8a32437d80ac6837a0bb7841729f4972e\":\"0x233df3299f61720000\",\"0x9f1aa8fcfc89a1a5328cbd6344b71f278a2ca4a0\":\"0x1b1ae4d6e2ef500000\",\"0x9f21302ca5096bea7402b91b0fd506254f999a3d\":\"0x4397451a003dd80000\",\"0x9f271d285500d73846b18f733e25dd8b4f5d4a8b\":\"0x2723c346ae18080000\",\"0x9f3497f5ef5fe63095836c004eb9ce02e9013b4b\":\"0x2256861bf9cf080000\",\"0x9f3a74fd5e7edcc1162993171381cbb632b7cff0\":\"0x21e19e0c9bab2400000\",\"0x9f46e7c1e9078cae86305ac7060b01467d6685ee\":\"0x243d4d18229ca20000\",\"0x9f496cb2069563144d0811677ba0e4713a0a4143\":\"0x3cd2e0bf63a4480000\",\"0x9f4a7195ac7c151ca258cafda0cab083e049c602\":\"0x53538c32185cee0000\",\"0x9f4ac9c9e7e24cb2444a0454fa5b9ad9d92d3853\":\"0x2d43f3ebfafb2c0000\",\"0x9f5f44026b576a4adb41e95961561d41039ca391\":\"0xd8d726b7177a80000\",\"0x9f607b3f12469f446121cebf3475356b71b4328c\":\"0xd8d726b7177a800000\",\"0x9f61beb46f5e853d0a8521c7446e68e34c7d0973\":\"0x1e5b8fa8fe2ac00000\",\"0x9f64a8e8dacf4ade30d10f4d59b0a3d5abfdbf74\":\"0x36369ed7747d260000\",\"0x9f662e95274121f177566e636d23964cf1fd686f\":\"0x6c6b935b8bbd400000\",\"0x9f6a322a6d469981426ae844865d7ee0bb15c7b3\":\"0x2b5ee57929fdb8000\",\"0x9f7986924aeb02687cd64189189fb167ded2dd5c\":\"0x35659ef93f0fc40000\",\"0x9f7a0392f857732e3004a375e6b1068d49d83031\":\"0x6c6b935b8bbd400000\",\"0x9f8245c3ab7d173164861cd3991b94f1ba40a93a\":\"0x9b0a791f1211300000\",\"0x9f83a293c324d4106c18faa8888f64d299054ca0\":\"0xad78ebc5ac6200000\",\"0x9f86a066edb61fcb5856de93b75c8c791864b97b\":\"0x6c6b935b8bbd400000\",\"0x9f98eb34d46979b0a6de8b05aa533a89b825dcf1\":\"0x4b06dbbb40f4a0000\",\"0x9f9fe0c95f10fee87af1af207236c8f3614ef02f\":\"0x14542ba12a337c00000\",\"0x9faea13c733412dc4b490402bfef27a0397a9bc3\":\"0x10ce1d3d8cb3180000\",\"0x9fbe066de57236dc830725d32a02aef9246c6c5e\":\"0x6c6b935b8bbd400000\",\"0x9fd1052a60506bd1a9ef003afd9d033c267d8e99\":\"0x3635c9adc5dea00000\",\"0x9fd64373f2fbcd9c0faca60547cad62e26d9851f\":\"0x3635c9adc5dea00000\",\"0x9fe501aa57ead79278937cd6308c5cfa7a5629fe\":\"0x2b5ee57929fdb8000\",\"0x9ffc5fe06f33f5a480b75aa94eb8556d997a16c0\":\"0x1158e460913d00000\",\"0x9ffcf5ef46d933a519d1d16c6ba3189b27496224\":\"0x3635c9adc5dea00000\",\"0x9ffedcc36b7cc312ad2a9ede431a514fccb49ba3\":\"0x244f579f3f5ca40000\",\"0xa006268446643ec5e81e7acb3f17f1c351ee2ed9\":\"0xd8d726b7177a800000\",\"0xa008019863c1a77c1499eb39bbd7bf2dd7a31cb9\":\"0x76d41c62494840000\",\"0xa009bf076f1ba3fa57d2a7217218bed5565a7a7a\":\"0x3635c9adc5dea00000\",\"0xa01e9476df84431825c836e8803a97e22fa5a0cd\":\"0x14542ba12a337c00000\",\"0xa01f12d70f44aa7b113b285c22dcdb45873454a7\":\"0xfc936392801c0000\",\"0xa01fd1906a908506dedae1e208128872b56ee792\":\"0xa2a15d09519be00000\",\"0xa0228240f99e1de9cb32d82c0f2fa9a3d44b0bf3\":\"0x56bc75e2d631000000\",\"0xa02bde6461686e19ac650c970d0672e76dcb4fc2\":\"0x1e09296c3378de40000\",\"0xa02c1e34064f0475f7fa831ccb25014c3aa31ca2\":\"0x340aad21b3b700000\",\"0xa02dc6aa328b880de99eac546823fccf774047fb\":\"0x6acb3df27e1f880000\",\"0xa02e3f8f5959a7aab7418612129b701ca1b80010\":\"0x1158e460913d00000\",\"0xa0347f0a98776390165c166d32963bf74dcd0a2f\":\"0x3635c9adc5dea00000\",\"0xa035a3652478f82dbd6d115faa8ca946ec9e681d\":\"0x5f4e42dd4afec0000\",\"0xa03a3dc7c533d1744295be955d61af3f52b51af5\":\"0x22b1c8c1227a00000\",\"0xa0459ef3693aacd1647cd5d8929839204cef53be\":\"0x3635c9adc5dea00000\",\"0xa04f2ae02add14c12faf65cb259022d0830a8e26\":\"0x152d02c7e14af6800000\",\"0xa06cd1f396396c0a64464651d7c205efaf387ca3\":\"0x6c6acc67d7b1d40000\",\"0xa072691c8dd7cd4237ff72a75c1a9506d0ce5b9e\":\"0x140ec80fa7ee880000\",\"0xa072cebe62a9e9f61cc3fbf88a9efbfe3e9a8d70\":\"0x15af1d78b58c400000\",\"0xa07682000b1bcf3002f85c80c0fa2949bd1e82fd\":\"0xd8d726b7177a800000\",\"0xa07aa16d74aee8a9a3288d52db1551d593883297\":\"0x2086ac351052600000\",\"0xa08d215b5b6aac4861a281ac7e400b78fef04cbf\":\"0x1158e460913d00000\",\"0xa0951970dfd0832fb83bda12c23545e79041756c\":\"0x2086ac351052600000\",\"0xa09f4d5eaa65a2f4cb750a49923401dae59090af\":\"0x796e3ea3f8ab00000\",\"0xa0a0e65204541fca9b2fb282cd95138fae16f809\":\"0x21e19e0c9bab2400000\",\"0xa0aa5f0201f04d3bbeb898132f7c11679466d901\":\"0x1fbed5215bb4c0000\",\"0xa0aadbd9509722705f6d2358a5c79f37970f00f6\":\"0xad78ebc5ac6200000\",\"0xa0b771951ce1deee363ae2b771b73e07c4b5e800\":\"0x4be4e7267b6ae00000\",\"0xa0de5c601e696635c698b7ae9ca4539fc7b941ec\":\"0x12c3cbd704c9770000\",\"0xa0e8ba661b48154cf843d4c2a5c0f792d528ee29\":\"0x15af1d78b58c400000\",\"0xa0fc7e53c5ebd27a2abdac45261f84ab3b51aefb\":\"0xa313daec9bc0d90000\",\"0xa0ff5b4cf016027e8323497d4428d3e5a83b8795\":\"0x16598d3c83ec0420000\",\"0xa106465bbd19e1b6bce50d1b1157dc59095a3630\":\"0x6c6b935b8bbd400000\",\"0xa106e6923edd53ca8ed650968a9108d6ccfd9670\":\"0x202fe1505afec898000\",\"0xa109e18bb0a39c9ef82fa19597fc5ed8e9eb6d58\":\"0x58e7926ee858a00000\",\"0xa11a03c4bb26d21eff677d5d555c80b25453ee7a\":\"0x3cb2759bc410f8000\",\"0xa11effab6cf0f5972cffe4d56596e98968144a8f\":\"0x5a87e7d7f5f6580000\",\"0xa1204dad5f560728a35c0d8fc79481057bf77386\":\"0x3635c9adc5dea00000\",\"0xa12623e629df93096704b16084be2cd89d562da4\":\"0x1ccc9324511e4500000\",\"0xa12a6c2d985daf0e4f5f207ae851aaf729b332cd\":\"0x152d02c7e14af6800000\",\"0xa1336dfb96b6bcbe4b3edf3205be5723c90fad52\":\"0x10f0cf064dd59200000\",\"0xa13b9d82a99b3c9bba5ae72ef2199edc7d3bb36c\":\"0x6c6acc67d7b1d40000\",\"0xa13cfe826d6d1841dcae443be8c387518136b5e8\":\"0x1da56a4b0835bf800000\",\"0xa1432ed2c6b7777a88e8d46d388e70477f208ca5\":\"0x1b1a7e413a196c50000\",\"0xa144f6b60f72d64a21e330dadb62d8990ade2b09\":\"0x3635c9adc5dea00000\",\"0xa15025f595acdbf3110f77c5bf24477e6548f9e8\":\"0x6c6b935b8bbd400000\",\"0xa158148a2e0f3e92dc2ce38febc20107e3253c96\":\"0x6c6b935b8bbd400000\",\"0xa16160851d2b9c349b92e46f829abfb210943595\":\"0x61093d7c2c6d380000\",\"0xa166f911c644ac3213d29e0e1ae010f794d5ad26\":\"0x6c6b935b8bbd400000\",\"0xa16d9e3d63986159a800b46837f45e8bb980ee0b\":\"0x6e1175da7ad1200000\",\"0xa17070c2e9c5a940a4ec0e4954c4d7d643be8f49\":\"0x6c6b17033b361c8000\",\"0xa17c9e4323069518189d5207a0728dcb92306a3f\":\"0x3635c9adc5dea00000\",\"0xa18360e985f2062e8f8efe02ad2cbc91ad9a5aad\":\"0xa2a15d09519be00000\",\"0xa1911405cf6e999ed011f0ddcd2a4ff7c28f2526\":\"0x22b1c8c1227a00000\",\"0xa192698007cc11aa603d221d5feea076bcf7c30d\":\"0x6c6b935b8bbd400000\",\"0xa192f06ab052d5fd7f94eea8318e827815fe677a\":\"0x71f8a93d01e540000\",\"0xa1998144968a5c70a6415554cefec2824690c4a5\":\"0x1158e460913d00000\",\"0xa1a1f0fa6d20b50a794f02ef52085c9d036aa6ca\":\"0x3635c9adc5dea00000\",\"0xa1ae8d4540d4db6fdde7146f415b431eb55c7983\":\"0xaadec983fcff40000\",\"0xa1b47c4d0ed6018842e6cfc8630ac3a3142e5e6b\":\"0x1158e460913d00000\",\"0xa1c4f45a82e1c478d845082eb18875c4ea6539ab\":\"0x2a5a058fc295ed000000\",\"0xa1dcd0e5b05a977c9623e5ae2f59b9ada2f33e31\":\"0x56bc75e2d63100000\",\"0xa1e4380a3b1f749673e270229993ee55f35663b4\":\"0x6c6b935b8bbd400000\",\"0xa1f193a0592f1feb9fdfc90aa813784eb80471c9\":\"0x4be4e7267b6ae00000\",\"0xa1f2854050f872658ed82e52b0ad7bbc1cb921f6\":\"0x6d0317e2b326f70000\",\"0xa1f5b840140d5a9acef402ac3cc3886a68cad248\":\"0x6c6b935b8bbd400000\",\"0xa1f765c44fe45f790677944844be4f2d42165fbd\":\"0xc7e9cfde768ec70000\",\"0xa1f7dde1d738d8cd679ea1ee965bee224be7d04d\":\"0x3d184450e5e93c0000\",\"0xa1f8d8bcf90e777f19b3a649759ad95027abdfc3\":\"0xad78ebc5ac6200000\",\"0xa202547242806f6e70e74058d6e5292defc8c8d4\":\"0x6c8754c8f30c080000\",\"0xa20d071b1b003063497d7990e1249dabf36c35f7\":\"0x3635c9adc5dea00000\",\"0xa20d8ff60caae31d02e0b665fa435d76f77c9442\":\"0x1a8a909dfcef400000\",\"0xa211da03cc0e31ecce5309998718515528a090df\":\"0xad78ebc5ac6200000\",\"0xa21442ab05340ade68c915f3c3399b9955f3f7eb\":\"0x2a034919dfbfbc0000\",\"0xa2222259dd9c3e3ded127084f808e92a1887302c\":\"0x8c8339dafed480000\",\"0xa22ade0ddb5c6ef8d0cd8de94d82b11082cb2e91\":\"0x374b57f3cef2700000\",\"0xa24c3ab62181e9a15b78c4621e4c7c588127be26\":\"0x8cde43a83d3310000\",\"0xa257ad594bd88328a7d90fc0a907df95eecae316\":\"0x1c3786ff3846930000\",\"0xa25b086437fd2192d0a0f64f6ed044f38ef3da32\":\"0x12290f15180bdc0000\",\"0xa276b058cb98d88beedb67e543506c9a0d9470d8\":\"0x90aafc76e02fbe0000\",\"0xa282e969cac9f7a0e1c0cd90f5d0c438ac570da3\":\"0x2207eb89fc27380000\",\"0xa291e9c7990d552dd1ae16cebc3fca342cbaf1d1\":\"0x43c33c1937564800000\",\"0xa29319e81069e5d60df00f3de5adee3505ecd5fb\":\"0x6c6b935b8bbd400000\",\"0xa2968fc1c64bac0b7ae0d68ba949874d6db253f4\":\"0x43c33c1937564800000\",\"0xa29d5bda74e003474872bd5894b88533ff64c2b5\":\"0x21e19e0c9bab2400000\",\"0xa29d661a6376f66d0b74e2fe9d8f26c0247ec84c\":\"0xdf3304079c13d20000\",\"0xa2a435de44a01bd0ecb29e44e47644e46a0cdffb\":\"0x1b1d445a7affe78000\",\"0xa2ace4c993bb1e5383f8ac74e179066e814f0591\":\"0x56bc75e2d63100000\",\"0xa2b701f9f5cdd09e4ba62baebae3a88257105885\":\"0x3635c9adc5dea00000\",\"0xa2c5854ff1599f98892c5725d262be1da98aadac\":\"0x1109ff333010e78000\",\"0xa2c7eaffdc2c9d937345206c909a52dfb14c478f\":\"0x7c0860e5a80dc0000\",\"0xa2d2aa626b09d6d4e4b13f7ffc5a88bd7ad36742\":\"0xfb8078507553830000\",\"0xa2d38de1c73906f6a7ca6efeb97cf6f69cc421be\":\"0x3635c9adc5dea00000\",\"0xa2dc65ee256b59a5bd7929774f904b358df3ada1\":\"0x483bce28beb09f80000\",\"0xa2e0683a805de6a05edb2ffbb5e96f0570b637c3\":\"0x1158e460913d00000\",\"0xa2e1b8aa900e9c139b3fa122354f6156d92a18b1\":\"0x1b1ae4d6e2ef500000\",\"0xa2e2b5941e0c01944bfe1d5fb4e8a34b922ccfb1\":\"0xad78ebc5ac6200000\",\"0xa2e460a989cb15565f9ecca7d121a18e4eb405b6\":\"0x6c6b935b8bbd400000\",\"0xa2ecce2c49f72a0995a0bda57aacf1e9f001e22a\":\"0xd8d726b7177a800000\",\"0xa2f472fe4f22b77db489219ea4023d11582a9329\":\"0x878678326eac9000000\",\"0xa2f798e077b07d86124e1407df32890dbb4b6379\":\"0xad78ebc5ac6200000\",\"0xa2f86bc061884e9eef05640edd51a2f7c0596c69\":\"0x6c6c44fe47ec050000\",\"0xa2fa17c0fb506ce494008b9557841c3f641b8cae\":\"0x1158e460913d00000\",\"0xa304588f0d850cd8d38f76e9e83c1bf63e333ede\":\"0x2285601216c8c0000\",\"0xa3058c51737a4e96c55f2ef6bd7bb358167ec2a7\":\"0x20db3ae4481ad48000\",\"0xa309df54cabce70c95ec3033149cd6678a6fd4cf\":\"0xc1f12c75101580000\",\"0xa30a45520e5206d9004070e6af3e7bb2e8dd5313\":\"0x15af1d78b58c400000\",\"0xa30e0acb534c9b3084e8501da090b4eb16a2c0cd\":\"0x6c6b935b8bbd400000\",\"0xa3203095edb7028e6871ce0a84f548459f83300a\":\"0xd8d726b7177a800000\",\"0xa321091d3018064279db399d2b2a88a6f440ae24\":\"0xad78ebc5ac62000000\",\"0xa3232d068d50064903c9ebc563b515acc8b7b097\":\"0x6c8754c8f30c080000\",\"0xa3241d890a92baf52908dc4aa049726be426ebd3\":\"0x43c2da661ca2f540000\",\"0xa3294626ec2984c43b43da4d5d8e4669b11d4b59\":\"0x36a4cf636319c00000\",\"0xa32cf7dde20c3dd5679ff5e325845c70c5962662\":\"0x1158e460913d00000\",\"0xa339a3d8ca280e27d2415b26d1fc793228b66043\":\"0x36f28695b78ff00000\",\"0xa33cb450f95bb46e25afb50fe05feee6fb8cc8ea\":\"0x2a1129d09367200000\",\"0xa33f70da7275ef057104dfa7db64f472e9f5d553\":\"0x45946b0f9e9d60000\",\"0xa34076f84bd917f20f8342c98ba79e6fb08ecd31\":\"0xe3aeb5737240a00000\",\"0xa3430e1f647f321ed34739562323c7d623410b56\":\"0x3634fb9f1489a70000\",\"0xa34f9d568bf7afd94c2a5b8a5ff55c66c4087999\":\"0x847d503b220eb00000\",\"0xa35606d51220ee7f2146d411582ee4ee4a45596e\":\"0xd8aabe080bc9400000\",\"0xa356551bb77d4f45a6d7e09f0a089e79cca249cb\":\"0x126e72a69a50d00000\",\"0xa35c19132cac1935576abfed6c0495fb07881ba0\":\"0x6c6b935b8bbd400000\",\"0xa365918bfe3f2627b9f3a86775d8756e0fd8a94b\":\"0x15af1d78b58c400000\",\"0xa36e0d94b95364a82671b608cb2d373245612909\":\"0x821d221b5291f8000\",\"0xa375b4bc24a24e1f797593cc302b2f331063fa5c\":\"0xad78ebc5ac6200000\",\"0xa37622ac9bbdc4d82b75015d745b9f8de65a28ec\":\"0x9dc05cce28c2b80000\",\"0xa379a5070c503d2fac89b8b3afa080fd45ed4bec\":\"0x42bf06b78ed3b500000\",\"0xa3802d8a659e89a2c47e905430b2a827978950a7\":\"0x3635c9adc5dea00000\",\"0xa38306cb70baa8e49186bd68aa70a83d242f2907\":\"0x6c6b935b8bbd400000\",\"0xa38476691d34942eea6b2f76889223047db4617a\":\"0x6c6b935b8bbd400000\",\"0xa387ce4e961a7847f560075c64e1596b5641d21c\":\"0x243d4d18229ca20000\",\"0xa387ecde0ee4c8079499fd8e03473bd88ad7522a\":\"0x6acb3df27e1f880000\",\"0xa3883a24f7f166205f1a6a9949076c26a76e7178\":\"0x62a992e53a0af00000\",\"0xa38b5bd81a9db9d2b21d5ec7c60552cd02ed561b\":\"0x14542ba12a337c00000\",\"0xa390ca122b8501ee3e5e07a8ca4b419f7e4dae15\":\"0x56bc75e2d63100000\",\"0xa3932a31d6ff75fb3b1271ace7caa7d5e1ff1051\":\"0x43c33c1937564800000\",\"0xa394ad4fd9e6530e6f5c53faecbede81cb172da1\":\"0x12f939c99edab800000\",\"0xa3979a92760a135adf69d72f75e167755f1cb8c3\":\"0x56bc75e2d63100000\",\"0xa39bfee4aec9bd75bd22c6b672898ca9a1e95d32\":\"0x21e19e0c9bab2400000\",\"0xa3a262afd2936819230892fde84f2d5a594ab283\":\"0x65ea3db75546600000\",\"0xa3a2e319e7d3a1448b5aa2468953160c2dbcba71\":\"0x6c6b935b8bbd400000\",\"0xa3a57b0716132804d60aac281197ff2b3d237b01\":\"0x4be4e7267b6ae00000\",\"0xa3a93ef9dbea2636263d06d8492f6a41de907c22\":\"0x340aad21b3b700000\",\"0xa3ae1879007d801cb5f352716a4dd8ba2721de3d\":\"0x2a5a058fc295ed000000\",\"0xa3ba0d3a3617b1e31b4e422ce269e873828d5d69\":\"0x2e141ea081ca080000\",\"0xa3bc979b7080092fa1f92f6e0fb347e28d995045\":\"0x97c9ce4cf6d5c00000\",\"0xa3bff1dfa9971668360c0d82828432e27bf54e67\":\"0xad78ebc5ac6200000\",\"0xa3c14ace28b192cbb062145fcbbd5869c67271f6\":\"0x1b1ae4d6e2ef5000000\",\"0xa3c33afc8cb4704e23153de2049d35ae71332472\":\"0x2b58addb89a2580000\",\"0xa3d0b03cffbb269f796ac29d80bfb07dc7c6ad06\":\"0x6c6b935b8bbd400000\",\"0xa3d583a7b65b23f60b7905f3e4aa62aac87f4227\":\"0x38befa126d5a9f8000\",\"0xa3db364a332d884ba93b2617ae4d85a1489bea47\":\"0x5c283d410394100000\",\"0xa3e051fb744aa3410c3b88f899f5d57f168df12d\":\"0xa030dcebbd2f4c0000\",\"0xa3e3a6ea509573e21bd0239ece0523a7b7d89b2f\":\"0x6acb3df27e1f880000\",\"0xa3f4ad14e0bb44e2ce2c14359c75b8e732d37054\":\"0xad78ebc5ac6200000\",\"0xa3facc50195c0b4933c85897fecc5bbd995c34b8\":\"0x1158e460913d00000\",\"0xa4035ab1e5180821f0f380f1131b7387c8d981cd\":\"0x1158e460913d00000\",\"0xa40aa2bbce0c72b4d0dfffcc42715b2b54b01bfa\":\"0x3635c9adc5dea00000\",\"0xa419a984142363267575566089340eea0ea20819\":\"0x6c6acc67d7b1d40000\",\"0xa421dbb89b3a07419084ad10c3c15dfe9b32d0c2\":\"0x43c33c1937564800000\",\"0xa422e4bf0bf74147cc895bed8f16d3cef3426154\":\"0x12ef3f62ee11368000\",\"0xa4259f8345f7e3a8b72b0fec2cf75e321fda4dc2\":\"0x678a932062e4180000\",\"0xa42908e7fe53980a9abf4044e957a54b70e99cbe\":\"0x6c6b935b8bbd400000\",\"0xa429fa88731fdd350e8ecd6ea54296b6484fe695\":\"0x6ac5c62d9486070000\",\"0xa430995ddb185b9865dbe62539ad90d22e4b73c2\":\"0x21e19e0c9bab2400000\",\"0xa436c75453ccca4a1f1b62e5c4a30d86dde4be68\":\"0x6c6b935b8bbd400000\",\"0xa437fe6ec103ca8d158f63b334224eccac5b3ea3\":\"0x1b1ae4d6e2ef5000000\",\"0xa43b6da6cb7aac571dff27f09d39f846f53769b1\":\"0x14998f32ac78700000\",\"0xa43b81f99356c0af141a03010d77bd042c71c1ee\":\"0x6c6b935b8bbd400000\",\"0xa43e1947a9242b355561c30a829dfeeca2815af8\":\"0xd23d99969fd6918000\",\"0xa4489a50ead5d5445a7bee4d2d5536c2a76c41f8\":\"0xad78ebc5ac6200000\",\"0xa44fe800d96fcad73b7170d0f610cb8c0682d6ce\":\"0xd8d726b7177a800000\",\"0xa45432a6f2ac9d56577b938a37fabac8cc7c461c\":\"0x3635c9adc5dea00000\",\"0xa466d770d898d8c9d405e4a0e551efafcde53cf9\":\"0x1ab2cf7c9f87e20000\",\"0xa4670731175893bbcff4fa85ce97d94fc51c4ba8\":\"0x1b1ae4d6e2ef5000000\",\"0xa46b4387fb4dcce011e76e4d73547d4481e09be5\":\"0x487a9a304539440000\",\"0xa46cd237b63eea438c8e3b6585f679e4860832ac\":\"0x3635c9adc5dea00000\",\"0xa47779d8bc1c7bce0f011ccb39ef68b854f8de8f\":\"0x6c6b935b8bbd400000\",\"0xa4826b6c3882fad0ed5c8fbb25cc40cc4f33759f\":\"0x701b43e34433d00000\",\"0xa4875928458ec2005dbb578c5cd33580f0cf1452\":\"0x3635c9adc5dea00000\",\"0xa49f523aa51364cbc7d995163d34eb590ded2f08\":\"0x9027421b2a9fbc0000\",\"0xa4a49f0bc8688cc9e6dc04e1e08d521026e65574\":\"0xad78ebc5ac6200000\",\"0xa4a7d306f510cd58359428c0d2f7c3609d5674d7\":\"0xb58cb61c3ccf340000\",\"0xa4a83a0738799b971bf2de708c2ebf911ca79eb2\":\"0x2086ac351052600000\",\"0xa4b09de6e713dc69546e76ef0acf40b94f0241e6\":\"0x117dc0627ec8700000\",\"0xa4d2b429f1ad5349e31704969edc5f25ee8aca10\":\"0x21e19e0c9bab2400000\",\"0xa4d6c82eddae5947fbe9cdfbd548ae33d91a7191\":\"0x1b1ae4d6e2ef5000000\",\"0xa4da34450d22ec0ffcede0004b02f7872ee0b73a\":\"0x50f616673f0830000\",\"0xa4dd59ab5e517d398e49fa537f899fed4c15e95d\":\"0x43c33c1937564800000\",\"0xa4e623451e7e94e7e89ba5ed95c8a83a62ffc4ea\":\"0x1158e460913d00000\",\"0xa4ed11b072d89fb136759fc69b428c48aa5d4ced\":\"0xe3f1527a03ca80000\",\"0xa4fb14409a67b45688a8593e5cc2cf596ced6f11\":\"0x61093d7c2c6d380000\",\"0xa514d00edd7108a6be839a638db2415418174196\":\"0x65a4da25d3016c00000\",\"0xa522de7eb6ae1250522a513133a93bd42849475c\":\"0x43c33c1937564800000\",\"0xa524a8cccc49518d170a328270a2f88133fbaf5d\":\"0xff7022dac108a0000\",\"0xa539b4a401b584dfe0f344b1b422c65543167e2e\":\"0xad78ebc5ac6200000\",\"0xa53ead54f7850af21438cbe07af686279a315b86\":\"0x21e19e0c9bab2400000\",\"0xa543a066fb32a8668aa0736a0c9cd40d78098727\":\"0x3635c9adc5dea00000\",\"0xa567770b6ae320bdde50f904d663e746a61dace6\":\"0x6c6b935b8bbd400000\",\"0xa568db4d57e4d67462d733c69a9e0fe26e218327\":\"0x3b6bff9266c0ae0000\",\"0xa5698035391e67a49013c0002079593114feb353\":\"0xd02ab486cedc00000\",\"0xa570223ae3caa851418a9843a1ac55db4824f4fd\":\"0xad78ebc5ac6200000\",\"0xa57360f002e0d64d2d74457d8ca4857ee00bcddf\":\"0x1233e232f618aa0000\",\"0xa575f2891dcfcda83c5cf01474af11ee01b72dc2\":\"0x56cd55fc64dfe0000\",\"0xa5783bf33432ff82ac498985d7d460ae67ec3673\":\"0x62a992e53a0af00000\",\"0xa5874d754635a762b381a5c4c792483af8f23d1d\":\"0x2b5e3af16b1880000\",\"0xa5a4227f6cf98825c0d5baff5315752ccc1a1391\":\"0x21e19e0c9bab2400000\",\"0xa5ab4bd3588f46cb272e56e93deed386ba8b753d\":\"0x4842f04105872c8000\",\"0xa5bad86509fbe0e0e3c0e93f6d381f1af6e9d481\":\"0x14542ba12a337c00000\",\"0xa5c336083b04f9471b8c6ed73679b74d66c363ec\":\"0xa3650a4c9d20e20000\",\"0xa5cd123992194b34c4781314303b03c54948f4b9\":\"0x6cfcc3d91da5630000\",\"0xa5d5b8b62d002def92413710d13b6ff8d4fc7dd3\":\"0x15af1d78b58c400000\",\"0xa5d96e697d46358d119af7819dc7087f6ae47fef\":\"0x317bee8af3315a78000\",\"0xa5de5e434fdcdd688f1c31b6fb512cb196724701\":\"0x2b5e3af16b18800000\",\"0xa5e0fc3c3affed3db6710947d1d6fb017f3e276d\":\"0x6c6b935b8bbd400000\",\"0xa5e93b49ea7c509de7c44d6cfeddef5910deaaf2\":\"0x6c6b935b8bbd400000\",\"0xa5e9cd4b74255d22b7d9b27ae8dd43ed6ed0252b\":\"0x298db2f54411d98000\",\"0xa5f0077b351f6c505cd515dfa6d2fa7f5c4cd287\":\"0x878678326eac9000000\",\"0xa5f075fd401335577b6683c281e6d101432dc6e0\":\"0x914878a8c05ee00000\",\"0xa5fe2ce97f0e8c3856be0de5f4dcb2ce5d389a16\":\"0x13db0b8b6863e0000\",\"0xa5ff62222d80c013cec1a0e8850ed4d354dac16d\":\"0xb41075c168b180000\",\"0xa609c26dd350c235e44b2b9c1dddccd0a9d9f837\":\"0x3635c9adc5dea00000\",\"0xa60c1209754f5d87b181da4f0817a81859ef9fd8\":\"0x2b5e3af16b1880000\",\"0xa6101c961e8e1c15798ffcd0e3201d7786ec373a\":\"0x14542ba12a337c00000\",\"0xa613456996408af1c2e93e177788ab55895e2b32\":\"0x15919ff477c88b80000\",\"0xa61887818f914a20e31077290b83715a6b2d6ef9\":\"0x65ea3db75546600000\",\"0xa61a54df784a44d71b771b87317509211381f200\":\"0x3635c9adc5dea00000\",\"0xa61cdbadf04b1e54c883de6005fcdf16beb8eb2f\":\"0x6c6b935b8bbd400000\",\"0xa639acd96b31ba53b0d08763229e1f06fd105e9d\":\"0x1b1ae4d6e2ef5000000\",\"0xa642501004c90ea9c9ed1998ba140a4cd62c6f5f\":\"0xd94fb8b10f8b18000\",\"0xa644ed922cc237a3e5c4979a995477f36e50bc62\":\"0x1fa73d845d7e960000\",\"0xa646a95c6d6f59f104c6541d7760757ab392b08c\":\"0xe3aeb5737240a00000\",\"0xa6484cc684c4c91db53eb68a4da45a6a6bda3067\":\"0x14542ba12a337c00000\",\"0xa64e5ffb704c2c9139d77ef61d8cdfa31d7a88e9\":\"0x7c0860e5a80dc0000\",\"0xa65426cff378ed23253513b19f496de45fa7e18f\":\"0x18650127cc3dc800000\",\"0xa66a4963b27f1ee1932b172be5964e0d3ae54b51\":\"0x960db77681e940000\",\"0xa67f38819565423aa85f3e3ab61bc763cbab89dd\":\"0x7377b022c6be080000\",\"0xa68c313445c22d919ee46cc2d0cdff043a755825\":\"0x41374fd21b0d88000\",\"0xa68e0c30cba3bc5a883e540320f999c7cd558e5c\":\"0x6192333762a58c8000\",\"0xa690f1a4b20ab7ba34628620de9ca040c43c1963\":\"0xd8d726b7177a800000\",\"0xa69d7cd17d4842fe03f62a90b2fbf8f6af7bb380\":\"0x56bc75e2d63100000\",\"0xa6a08252c8595177cc2e60fc27593e2379c81fb1\":\"0x11651ac3e7a758000\",\"0xa6a0de421ae54f6d17281308f5646d2f39f7775d\":\"0x6c6b935b8bbd400000\",\"0xa6b2d573297360102c07a18fc21df2e7499ff4eb\":\"0xd96fce90cfabcc0000\",\"0xa6c910ce4d494a919ccdaaa1fc3b82aa74ba06cf\":\"0x1b1ae4d6e2ef5000000\",\"0xa6e3baa38e104a1e27a4d82869afb1c0ae6eff8d\":\"0x11140eead8b710000\",\"0xa6eebbe464d39187bf80ca9c13d72027ec5ba8be\":\"0xa2a15d09519be00000\",\"0xa6f62b8a3d7f11220701ab9ffffcb327959a2785\":\"0x1b6e291f18dba80000\",\"0xa6f93307f8bce03195fece872043e8a03f7bd11a\":\"0x9c734bad5111580000\",\"0xa701df79f594901afe1444485e6b20c3bda2b9b3\":\"0x3635c9adc5dea00000\",\"0xa7024cfd742c1ec13c01fea18d3042e65f1d5dee\":\"0x263119a28abd0b08000\",\"0xa718aaad59bf395cba2b23e09b02fe0c89816247\":\"0x36303c97e468780000\",\"0xa7247c53d059eb7c9310f628d7fc6c6a0a773f08\":\"0x1b1ae4d6e2ef500000\",\"0xa7253763cf4a75df92ca1e766dc4ee8a2745147b\":\"0x2463770e90a8f500000\",\"0xa72ee666c4b35e82a506808b443cebd5c632c7dd\":\"0x2b5e3af16b18800000\",\"0xa74444f90fbb54e56f3ac9b6cfccaa4819e4614a\":\"0x1158e460913d00000\",\"0xa747439ad0d393b5a03861d77296326de8bb9db9\":\"0x3635c9adc5dea00000\",\"0xa7607b42573bb6f6b4d4f23c7e2a26b3a0f6b6f0\":\"0x57473d05dabae80000\",\"0xa76929890a7b47fb859196016c6fdd8289ceb755\":\"0x10f0cf064dd59200000\",\"0xa76b743f981b693072a131b22ba510965c2fefd7\":\"0xfc936392801c0000\",\"0xa76d3f156251b72c0ccf4b47a3393cbd6f49a9c5\":\"0x487a9a304539440000\",\"0xa77428bcb2a0db76fc8ef1e20e461a0a32c5ac15\":\"0x15be6174e1912e0000\",\"0xa7758cecb60e8f614cce96137ef72b4fbd07774a\":\"0x1b1ae4d6e2ef500000\",\"0xa7775e4af6a23afa201fb78b915e51a515b7a728\":\"0x68155a43676e00000\",\"0xa77f3ee19e9388bbbb2215c62397b96560132360\":\"0xad78ebc5ac6200000\",\"0xa7859fc07f756ea7dcebbccd42f05817582d973f\":\"0x21e19e0c9bab2400000\",\"0xa7966c489f4c748a7ae980aa27a574251767caf9\":\"0xa2a15d09519be00000\",\"0xa7a3bb6139b0ada00c1f7f1f9f56d994ba4d1fa8\":\"0x6c6b935b8bbd400000\",\"0xa7a3f153cdc38821c20c5d8c8241b294a3f82b24\":\"0x1b1ae4d6e2ef500000\",\"0xa7a517d7ad35820b09d497fa7e5540cde9495853\":\"0x6c6b935b8bbd400000\",\"0xa7c9d388ebd873e66b1713448397d0f37f8bd3a8\":\"0x10f0cf064dd59200000\",\"0xa7dcbba9b9bf6762c145416c506a71e3b497209c\":\"0x6c6acc67d7b1d40000\",\"0xa7e74f0bdb278ff0a805a648618ec52b166ff1be\":\"0x56bc75e2d63100000\",\"0xa7e83772bc200f9006aa2a260dbaa8483dc52b30\":\"0xb42d5366637e50000\",\"0xa7ef35ce87eda6c28df248785815053ec97a5045\":\"0x10f0ce949e00f930000\",\"0xa7f9220c8047826bd5d5183f4e676a6d77bfed36\":\"0x85068976be81c0000\",\"0xa807104f2703d679f8deafc442befe849e42950b\":\"0x6c6b935b8bbd400000\",\"0xa80cb1738bac08d4f9c08b4deff515545fa8584f\":\"0x1b1ae4d6e2ef500000\",\"0xa819d2ece122e028c8e8a04a064d02b9029b08b9\":\"0x3635c9adc5dea00000\",\"0xa825fd5abb7926a67cf36ba246a24bd27be6f6ed\":\"0xf43fc2c04ee00000\",\"0xa8285539869d88f8a961533755717d7eb65576ae\":\"0xad78ebc5ac6200000\",\"0xa83382b6e15267974a8550b98f7176c1a353f9be\":\"0xbffdaf2fc1b1a40000\",\"0xa8446c4781a737ac4328b1e15b8a0b3fbb0fd668\":\"0x48794d1f246192a0000\",\"0xa8455b411765d6901e311e726403091e42c56683\":\"0xb73aec3bfe14500000\",\"0xa86613e6c4a4c9c55f5c10bcda32175dcbb4af60\":\"0x243d6c2e36be6ae0000\",\"0xa86db07d9f812f4796622d40e03d135874a88a74\":\"0x1158e460913d00000\",\"0xa87f7abd6fa31194289678efb63cf584ee5e2a61\":\"0xd8d726b7177a800000\",\"0xa880e2a8bf88a1a82648b4013c49c4594c433cc8\":\"0x1004e2e45fb7ee00000\",\"0xa88577a073fbaf33c4cd202e00ea70ef711b4006\":\"0x6c6b935b8bbd400000\",\"0xa8914c95b560ec13f140577338c32bcbb77d3a7a\":\"0x9c2007651b2500000\",\"0xa89ac93b23370472daac337e9afdf642543f3e57\":\"0x21e19e0c9bab2400000\",\"0xa89df34859edd7c820db887740d8ff9e15157c7b\":\"0x6c6b935b8bbd400000\",\"0xa8a43c009100616cb4ae4e033f1fc5d7e0b6f152\":\"0xd588d078b43f4d8000\",\"0xa8a708e84f82db86a35502193b4c6ee9a76ebe8f\":\"0x3708baed3d68900000\",\"0xa8a7b68adab4e3eadff19ffa58e34a3fcec0d96a\":\"0x14542ba12a337c00000\",\"0xa8a8dbdd1a85d1beee2569e91ccc4d09ae7f6ea1\":\"0x13a6b2b564871a00000\",\"0xa8aca748f9d312ec747f8b6578142694c7e9f399\":\"0x6c6b935b8bbd400000\",\"0xa8b65ba3171a3f77a6350b9daf1f8d55b4d201eb\":\"0x2862f3b0d222040000\",\"0xa8beb91c2b99c8964aa95b6b4a184b1269fc3483\":\"0x15af1d78b58c400000\",\"0xa8c0b02faf02cb5519dda884de7bbc8c88a2da81\":\"0xe7c2518505060000\",\"0xa8c1d6aa41fe3d65f67bd01de2a866ed1ed9ae52\":\"0x1a055690d9db80000\",\"0xa8cafac32280d021020bf6f2a9782883d7aabe12\":\"0x56bc75e2d63100000\",\"0xa8db0b9b201453333c757f6ad9bcb555c02da93b\":\"0x7742b7830f341d0000\",\"0xa8e42a4e33d7526cca19d9a36dcd6e8040d0ea73\":\"0x3a8c02c5ea2de00000\",\"0xa8e7201ff619faffc332e6ad37ed41e301bf014a\":\"0x2086ac351052600000\",\"0xa8ee1df5d44b128469e913569ef6ac81eeda4fc8\":\"0x1b1ae4d6e2ef500000\",\"0xa8ef9ad274436042903e413c3b0c62f5f52ed584\":\"0x21e19e0c9bab2400000\",\"0xa8f37f0ab3a1d448a9e3ce40965f97a646083a34\":\"0x11e0e4f8a50bd40000\",\"0xa8f89dd5cc6e64d7b1eeace00702022cd7d2f03d\":\"0x25f273933db5700000\",\"0xa90476e2efdfee4f387b0f32a50678b0efb573b5\":\"0x21e19e0c9bab2400000\",\"0xa9145046fa3628cf5fd4c613927be531e6db1fdd\":\"0x6124fee993bc00000\",\"0xa914cdb571bfd93d64da66a4e108ea134e50d000\":\"0x4d8738994713798000\",\"0xa91a5a7b341f99c535144e20be9c6b3bb4c28e4d\":\"0x126753aa224a70b0000\",\"0xa9252551a624ae513719dabe5207fbefb2fd7749\":\"0x22b1c8c1227a00000\",\"0xa927d48bb6cb814bc609cbcaa9151f5d459a27e1\":\"0xeb935090064180000\",\"0xa929c8bd71db0c308dac06080a1747f21b1465aa\":\"0x1b1ae4d6e2ef500000\",\"0xa94bbb8214cf8da0c2f668a2ac73e86248528d4b\":\"0x340aad21b3b7000000\",\"0xa951b244ff50cfae591d5e1a148df6a938ef2a1a\":\"0x5e001584dfcf580000\",\"0xa960b1cadd3b5c1a8e6cb3abcaf52ee7c3d9fa88\":\"0x528bc3545e52680000\",\"0xa961171f5342b173dd70e7bfe5b5ca238b13bcdd\":\"0xb82794a9244f0c8000\",\"0xa975b077fcb4cc8efcbf838459b6fa243a4159d6\":\"0x22b1c8c1227a00000\",\"0xa97beb3a48c45f1528284cb6a95f7de453358ec6\":\"0x690836c0af5f5600000\",\"0xa97e072144499fe5ebbd354acc7e7efb58985d08\":\"0x90f534608a72880000\",\"0xa986762f7a4f294f2e0b173279ad2c81a2223458\":\"0x1158e460913d00000\",\"0xa98f109835f5eacd0543647c34a6b269e3802fac\":\"0x15af1d78b58c400000\",\"0xa997dfc7986a27050848fa1c64d7a7d6e07acca2\":\"0x7c0860e5a80dc0000\",\"0xa99991cebd98d9c838c25f7a7416d9e244ca250d\":\"0x3635c9adc5dea00000\",\"0xa9a1cdc33bfd376f1c0d76fb6c84b6b4ac274d68\":\"0x10f0cf064dd59200000\",\"0xa9a8eca11a23d64689a2aa3e417dbb3d336bb59a\":\"0xe3453cd3b67ba8000\",\"0xa9acf600081bb55bb6bfbab1815ffc4e17e85a95\":\"0xad78ebc5ac6200000\",\"0xa9ad1926bc66bdb331588ea8193788534d982c98\":\"0x65a4da25d3016c00000\",\"0xa9af21acbe482f8131896a228036ba51b19453c3\":\"0x2b5e021980cc18000\",\"0xa9b2d2e0494eab18e07d37bbb856d80e80f84cd3\":\"0x21e19e0c9bab2400000\",\"0xa9ba6f413b82fcddf3affbbdd09287dcf50415ca\":\"0xd8d726b7177a800000\",\"0xa9be88ad1e518b0bbb024ab1d8f0e73f790e0c76\":\"0x97c9ce4cf6d5c00000\",\"0xa9bfc410dddb20711e45c07387eab30a054e19ac\":\"0x3e99601edf4e530000\",\"0xa9d4a2bcbe5b9e0869d70f0fe2e1d6aacd45edc5\":\"0xac6e77ab663a80000\",\"0xa9d64b4f3bb7850722b58b478ba691375e224e42\":\"0x14542ba12a337c00000\",\"0xa9d6f871ca781a759a20ac3adb972cf12829a208\":\"0x3224f42723d4540000\",\"0xa9dc0424c6969d798358b393b1933a1f51bee00a\":\"0x43c33c1937564800000\",\"0xa9e194661aac704ee9dea043974e9692ded84a5d\":\"0x1a26a51422a0700000\",\"0xa9e28337e6357193d9e2cb236b01be44b81427df\":\"0x77432217e683600000\",\"0xa9e6e25e656b762558619f147a21985b8874edfe\":\"0x6c6b935b8bbd400000\",\"0xa9e9dbce7a2cb03694799897bed7c54d155fdaa8\":\"0xab5ae8fc99d658000\",\"0xa9ed377b7d6ec25971c1a597a3b0f3bead57c98f\":\"0x15af1d78b58c400000\",\"0xaa0200f1d17e9c54da0647bb96395d57a78538d8\":\"0x393ef1a5127c800000\",\"0xaa0ca3737337178a0caac3099c584b056c56301c\":\"0x2fb474098f67c00000\",\"0xaa136b47962bb8b4fb540db4ccf5fdd042ffb8cf\":\"0x1b1b6bd7af64c70000\",\"0xaa14422d6f0ae5a758194ed15780c838d67f1ee1\":\"0x60932056c449de80000\",\"0xaa16269aac9c0d803068d82fc79151dadd334b66\":\"0xd8d726b7177a800000\",\"0xaa167026d39ab7a85635944ed9edb2bfeba11850\":\"0x1c1d5e21b4fcf680000\",\"0xaa1b3768c16d821f580e76c8e4c8e86d7dc78853\":\"0x15af1d78b58c400000\",\"0xaa1df92e51dff70b1973e0e924c66287b494a178\":\"0x1cf84a30a0a0c00000\",\"0xaa2c670096d3f939305325427eb955a8a60db3c5\":\"0x6c95590699232d0000\",\"0xaa3135cb54f102cbefe09e96103a1a796718ff54\":\"0x32222d9c331940000\",\"0xaa321fdbd449180db8ddd34f0fe906ec18ee0914\":\"0x252248deb6e6940000\",\"0xaa3925dc220bb4ae2177b2883078b6dc346ca1b2\":\"0x1b1ae4d6e2ef5000000\",\"0xaa3f29601a1331745e05c42830a15e71938a6237\":\"0x5c283d410394100000\",\"0xaa47a4ffc979363232c99b99fada0f2734b0aeee\":\"0x1b8489df4dbff940000\",\"0xaa493d3f4fb866491cf8f800efb7e2324ed7cfe5\":\"0x5c283d410394100000\",\"0xaa56a65dc4abb72f11bae32b6fbb07444791d5c9\":\"0x2894e975bf496c0000\",\"0xaa5afcfd8309c2df9d15be5e6a504e7d706624c5\":\"0x13cf422e305a1378000\",\"0xaa8eb0823b07b0e6d20aadda0e95cf3835be192e\":\"0x1bc16d674ec800000\",\"0xaa91237e740d25a92f7fa146faa18ce56dc6e1f3\":\"0x3224f42723d4540000\",\"0xaa960e10c52391c54e15387cc67af827b5316dcc\":\"0x6c6b935b8bbd400000\",\"0xaa9bd4589535db27fa2bc903ca17d679dd654806\":\"0x6c6b935b8bbd400000\",\"0xaaa8defe11e3613f11067fb983625a08995a8dfc\":\"0xad78ebc5ac6200000\",\"0xaaaae68b321402c8ebc13468f341c63c0cf03fce\":\"0x52663ccab1e1c00000\",\"0xaaad1baade5af04e2b17439e935987bf8c2bb4b9\":\"0x6c6b935b8bbd400000\",\"0xaab00abf5828d7ebf26b47ceaccdb8ba03325166\":\"0x21e19e0c9bab2400000\",\"0xaabdb35c1514984a039213793f3345a168e81ff1\":\"0x10cac896d239000000\",\"0xaaca60d9d700e78596bbbbb1f1e2f70f4627f9d8\":\"0x3635bb77cb4b860000\",\"0xaaced8a9563b1bc311dbdffc1ae7f57519c4440c\":\"0x6c6b935b8bbd400000\",\"0xaad2b7f8106695078e6c138ec81a7486aaca1eb2\":\"0xad78ebc5ac6200000\",\"0xaae61e43cb0d0c96b30699f77e00d711d0a3979b\":\"0x3635c9adc5dea00000\",\"0xaae732eda65988c3a00c7f472f351c463b1c968e\":\"0x6c6b935b8bbd400000\",\"0xaaf023fef290a49bb78bb7abc95d669c50d528b0\":\"0xad78ebc5ac6200000\",\"0xaaf5b207b88b0de4ac40d747cee06e172df6e745\":\"0x6a7b71d7f51d0900000\",\"0xaaf9ee4b886c6d1e95496fd274235bf4ecfcb07d\":\"0x4be4e7267b6ae00000\",\"0xaafb7b013aa1f8541c7e327bf650adbd194c208f\":\"0x499e092d01f4780000\",\"0xab098633eeee0ccefdf632f9575456f6dd80fc86\":\"0x2a5a058fc295ed000000\",\"0xab0ced762e1661fae1a92afb1408889413794825\":\"0x678a932062e4180000\",\"0xab14d221e33d544629198cd096ed63dfa28d9f47\":\"0x14542ba12a337c00000\",\"0xab209fdca979d0a647010af9a8b52fc7d20d8cd1\":\"0x1eee2532c7c2d040000\",\"0xab27ba78c8e5e3daef31ad05aef0ff0325721e08\":\"0x195ece006e02d00000\",\"0xab2871e507c7be3965498e8fb462025a1a1c4264\":\"0x2a034919dfbfbc0000\",\"0xab3861226ffec1289187fb84a08ec3ed043264e8\":\"0x3635c9adc5dea00000\",\"0xab3d86bc82927e0cd421d146e07f919327cdf6f9\":\"0x678a932062e4180000\",\"0xab3e62e77a8b225e411592b1af300752fe412463\":\"0x215f835bc769da80000\",\"0xab3e78294ba886a0cfd5d3487fb3a3078d338d6e\":\"0x6acb3df27e1f880000\",\"0xab4004c0403f7eabb0ea586f212156c4203d67f1\":\"0x6c6acc67d7b1d40000\",\"0xab416fe30d58afe5d9454c7fce7f830bcc750356\":\"0x6353701c605db8000\",\"0xab4572fbb1d72b575d69ec6ad17333873e8552fc\":\"0x6c6ac54cda68470000\",\"0xab5a79016176320973e8cd38f6375530022531c0\":\"0x3635c9adc5dea00000\",\"0xab5dfc1ea21adc42cf8c3f6e361e243fd0da61e5\":\"0x1043561a8829300000\",\"0xab6b65eab8dfc917ec0251b9db0ecfa0fa032849\":\"0x1b1ae4d6e2ef500000\",\"0xab7091932e4bc39dbb552380ca934fd7166d1e6e\":\"0xb50fcfafebecb00000\",\"0xab7416ff32254951cbbc624ec7fb45fc7ecaa872\":\"0x126e72a69a50d00000\",\"0xab7c42c5e52d641a07ad75099c62928b7f86622f\":\"0x12361aa21d14ba0000\",\"0xab7d54c7c6570efca5b4b8ce70f52a5773e5d53b\":\"0xf283abe9d9f380000\",\"0xab7e0b83ed9a424c6d1e6a6f87a4dbf06409c7d6\":\"0x821ab0d44149800000\",\"0xab84a0f147ad265400002b85029a41fc9ce57f85\":\"0x3635c9adc5dea00000\",\"0xab93b26ece0a0aa21365afed1fa9aea31cd54468\":\"0x572b7b98736c200000\",\"0xab948a4ae3795cbca13126e19253bdc21d3a8514\":\"0xad78ebc5ac6200000\",\"0xab9ad36e5c74ce2e96399f57839431d0e79f96ab\":\"0x8e3f50b173c100000\",\"0xabb2e6a72a40ba6ed908cdbcec3c5612583132fe\":\"0x4f2591f896a6500000\",\"0xabc068b4979b0ea64a62d3b7aa897d73810dc533\":\"0x6acb3df27e1f880000\",\"0xabc45f84db7382dde54c5f7d8938c42f4f3a3bc4\":\"0xad78ebc5ac6200000\",\"0xabc4caeb474d4627cb6eb456ecba0ecd08ed8ae1\":\"0xd5967be4fc3f100000\",\"0xabc74706964960dfe0dca3dca79e9216056f1cf4\":\"0x878678326eac9000000\",\"0xabc9a99e8a2148a55a6d82bd51b98eb5391fdbaf\":\"0x14542ba12a337c00000\",\"0xabcdbc8f1dd13af578d4a4774a62182bedf9f9be\":\"0x1fcc27bc459d20000\",\"0xabd154903513b8da4f019f68284b0656a1d0169b\":\"0x3635c9adc5dea00000\",\"0xabd21eff954fc6a7de26912a7cbb303a6607804e\":\"0x523c9aa696eb940000\",\"0xabd4d6c1666358c0406fdf3af248f78ece830104\":\"0x727de34a24f9000000\",\"0xabd9605b3e91acfd777830d16463478ae0fc7720\":\"0x73f75d1a085ba0000\",\"0xabdc9f1bcf4d19ee96591030e772c334302f7d83\":\"0x87e5e11a81cb5f80000\",\"0xabde147b2af789eaa586547e66c4fa2664d328a4\":\"0xd6b6081f34c128000\",\"0xabe07ced6ac5ddf991eff6c3da226a741bd243fe\":\"0x21e19e0c9bab2400000\",\"0xabf12fa19e82f76c718f01bdca0003674523ef30\":\"0x6c6b935b8bbd400000\",\"0xabf728cf9312f22128024e7046c251f5dc5901ed\":\"0x641e8a13563d8f80000\",\"0xabf8ffe0708a99b528cc1ed4e9ce4b0d0630be8c\":\"0x7ab5c2aeeee6380000\",\"0xabfcf5f25091ce57875fc674dcf104e2a73dd2f2\":\"0x11164759ffb320000\",\"0xabfe936425dcc7b74b955082bbaaf2a11d78bc05\":\"0x4be4e7267b6ae00000\",\"0xac024f594f9558f04943618eb0e6b2ee501dc272\":\"0x6c6b935b8bbd400000\",\"0xac122a03cd058c122e5fe17b872f4877f9df9572\":\"0x6ac5c62d9486070000\",\"0xac142eda1157b9a9a64390df7e6ae694fac98905\":\"0xad78ebc5ac6200000\",\"0xac1dfc984b71a19929a81d81f04a7cbb14073703\":\"0x2086ac351052600000\",\"0xac21c1e5a3d7e0b50681679dd6c792dbca87decb\":\"0x152d02c7e14af6800000\",\"0xac2889b5966f0c7f9edb42895cb69d1c04f923a2\":\"0x10f0cf064dd59200000\",\"0xac28b5edea05b76f8c5f97084541277c96696a4c\":\"0x3635c9adc5dea00000\",\"0xac2c8e09d06493a63858437bd20be01962450365\":\"0x678a932062e4180000\",\"0xac2e766dac3f648f637ac6713fddb068e4a4f04d\":\"0xaadec983fcff40000\",\"0xac3900298dd14d7cc96d4abb428da1bae213ffed\":\"0x53ca12974851c010000\",\"0xac3da526cfce88297302f34c49ca520dc271f9b2\":\"0x2b5e3af16b18800000\",\"0xac4460a76e6db2b9fcd152d9c7718d9ac6ed8c6f\":\"0xad78ebc5ac6200000\",\"0xac4acfc36ed6094a27e118ecc911cd473e8fb91f\":\"0x61913e14403c0c0000\",\"0xac4cc256ae74d624ace80db078b2207f57198f6b\":\"0x6c7974123f64a40000\",\"0xac4ee9d502e7d2d2e99e59d8ca7d5f00c94b4dd6\":\"0x3635c9adc5dea00000\",\"0xac52b77e15664814f39e4f271be641308d91d6cc\":\"0xbed1d0263d9f00000\",\"0xac5999a89d2dd286d5a80c6dee7e86aad40f9e12\":\"0xd255d112e103a00000\",\"0xac5f627231480d0d95302e6d89fc32cb1d4fe7e3\":\"0xad78ebc5ac6200000\",\"0xac608e2bac9dd20728d2947effbbbf900a9ce94b\":\"0x1454b0db37568fc0000\",\"0xac6d02e9a46b379fac4ac9b1d7b5d47bc850ce16\":\"0x5f68e8131ecf800000\",\"0xac6f68e837cf1961cb14ab47446da168a16dde89\":\"0x487a9a304539440000\",\"0xac77bdf00fd5985b5db12bbef800380abc2a0677\":\"0x3635c9adc5dea00000\",\"0xac7e03702723cb16ee27e22dd0b815dc2d5cae9f\":\"0x3635c9adc5dea000000\",\"0xac8b509aefea1dbfaf2bb33500d6570b6fd96d51\":\"0x62a992e53a0af00000\",\"0xac8e87ddda5e78fcbcb9fa7fc3ce038f9f7d2e34\":\"0x6c6b935b8bbd400000\",\"0xac9fff68c61b011efbecf038ed72db97bb9e7281\":\"0x205b4dfa1ee74780000\",\"0xaca1e6bc64cc3180f620e94dc5b1bcfd8158e45d\":\"0x6c6b935b8bbd400000\",\"0xaca2a838330b17302da731d30db48a04f0f207c1\":\"0x487a9a304539440000\",\"0xacaaddcbf286cb0e215dda55598f7ff0f4ada5c6\":\"0x3635c9adc5dea00000\",\"0xacb94338554bc488cc88ae2d9d94080d6bdf8410\":\"0x3635c9adc5dea00000\",\"0xacbc2d19e06c3babbb5b6f052b6bf7fc37e07229\":\"0xad78ebc5ac6200000\",\"0xacbd185589f7a68a67aa4b1bd65077f8c64e4e21\":\"0xad78ebc5ac6200000\",\"0xacc062702c59615d3444ef6214b8862b009a02ed\":\"0x514fcb24ff9c500000\",\"0xacc0909fda2ea6b7b7a88db7a0aac868091ddbf6\":\"0x133765f1e26c78000\",\"0xacc1c78786ab4d2b3b277135b5ba123e0400486b\":\"0x44591d67fecc80000\",\"0xacc46a2a555c74ded4a2bd094e821b97843b40c0\":\"0x692ae8897081d00000\",\"0xacc59f3b30ceffc56461cc5b8df48902240e0e7b\":\"0x6c6b935b8bbd400000\",\"0xacce01e0a70610dc70bb91e9926fa9957f372fba\":\"0x1d1c5f3eda20c40000\",\"0xacd8dd91f714764c45677c63d852e56eb9eece2e\":\"0x6c6b935b8bbd400000\",\"0xace2abb63b0604409fbde3e716d2876d44e8e5dd\":\"0x83d6c7aab63600000\",\"0xacec91ef6941cf630ba9a3e787a012f4a2d91dd4\":\"0x10f0cf064dd592000000\",\"0xad0a4ae478e9636e88c604f242cf5439c6d45639\":\"0xbed1d0263d9f000000\",\"0xad1799aad7602b4540cd832f9db5f11150f1687a\":\"0x6c6b935b8bbd400000\",\"0xad1d68a038fd2586067ef6d135d9628e79c2c924\":\"0xfe09a5279e2abc0000\",\"0xad2a5c00f923aaf21ab9f3fb066efa0a03de2fb2\":\"0x3635bb77cb4b860000\",\"0xad3565d52b688added08168b2d3872d17d0a26ae\":\"0x56bc75e2d63100000\",\"0xad377cd25eb53e83ae091a0a1d2b4516f484afde\":\"0x692ae8897081d00000\",\"0xad414d29cb7ee973fec54e22a388491786cf5402\":\"0x2f6f10780d22cc00000\",\"0xad44357e017e244f476931c7b8189efee80a5d0a\":\"0x1043561a8829300000\",\"0xad57aa9d00d10c439b35efcc0becac2e3955c313\":\"0xad78ebc5ac6200000\",\"0xad59a78eb9a74a7fbdaefafa82eada8475f07f95\":\"0x1b1ae4d6e2ef500000\",\"0xad5a8d3c6478b69f657db3837a2575ef8e1df931\":\"0x20156e104c1b30000\",\"0xad660dec825522a9f62fcec3c5b731980dc286ea\":\"0xa2a15d09519be00000\",\"0xad6628352ed3390bafa86d923e56014cfcb360f4\":\"0x6c6b935b8bbd400000\",\"0xad728121873f0456d0518b80ab6580a203706595\":\"0x1b1ae4d6e2ef500000\",\"0xad732c976593eec4783b4e2ecd793979780bfedb\":\"0x6c6b935b8bbd400000\",\"0xad7dd053859edff1cb6f9d2acbed6dd5e332426f\":\"0x6acb3df27e1f880000\",\"0xad80d865b85c34d2e6494b2e7aefea6b9af184db\":\"0xd8d726b7177a800000\",\"0xad8bfef8c68a4816b3916f35cb7bfcd7d3040976\":\"0x878678326eac9000000\",\"0xad8e48a377695de014363a523a28b1a40c78f208\":\"0x3635c9adc5dea00000\",\"0xad910a23d6850613654af786337ad2a70868ac6d\":\"0x6c68ccd09b022c0000\",\"0xad927e03d1599a78ca2bf0cad2a183dceb71eac0\":\"0x6acb3df27e1f880000\",\"0xad92ca066edb7c711dfc5b166192d1edf8e77185\":\"0x79f905c6fd34e800000\",\"0xad94235fc3b3f47a2413af31e884914908ef0c45\":\"0x1b1b0142d815840000\",\"0xad9e97a0482f353a05c0f792b977b6c7e811fa5f\":\"0xad78ebc5ac6200000\",\"0xad9f4c890a3b511cee51dfe6cfd7f1093b76412c\":\"0x1b767cbfeb0ce40000\",\"0xadaa0e548c035affed64ca678a963fabe9a26bfd\":\"0x3cb71f51fc5580000\",\"0xadb948b1b6fefe207de65e9bbc2de98e605d0b57\":\"0x6c6b935b8bbd400000\",\"0xadc19ec835afe3e58d87dc93a8a9213c90451326\":\"0x6adbe5342282000000\",\"0xadc8228ef928e18b2a807d00fb3c6c79cd1d9e96\":\"0x13c69df334ee80000\",\"0xaddb26317227f45c87a2cb90dc4cfd02fb23caf8\":\"0x3635c9adc5dea00000\",\"0xade6f8163bf7c7bb4abe8e9893bd0cc112fe8872\":\"0x11c25d004d01f80000\",\"0xadeb204aa0c38e179e81a94ed8b3e7d53047c26b\":\"0x20f5b1eaad8d800000\",\"0xadeb52b604e5f77faaac88275b8d6b49e9f9f97f\":\"0x71426b00956ed20000\",\"0xadf1acfe99bc8c14b304c8d905ba27657b8a7bc4\":\"0x43c33c1937564800000\",\"0xadf85203c8376a5fde9815384a350c3879c4cb93\":\"0x3e31fc675815aa0000\",\"0xadff0d1d0b97471e76d789d2e49c8a74f9bd54ff\":\"0x65ea3db75546600000\",\"0xae062c448618643075de7a0030342dced63dbad7\":\"0x2cc6cd8cc282b30000\",\"0xae10e27a014f0d306baf266d4897c89aeee2e974\":\"0x43c33c1937564800000\",\"0xae126b382cf257fad7f0bc7d16297e54cc7267da\":\"0x1043561a8829300000\",\"0xae13a08511110f32e53be4127845c843a1a57c7b\":\"0x1b1ae4d6e2ef500000\",\"0xae179a460db66326743d24e67523a57b246daf7f\":\"0x10007ae7ce5bbe40000\",\"0xae222865799079aaf4f0674a0cdaab02a6d570ff\":\"0x6c6b935b8bbd400000\",\"0xae239acffd4ebe2e1ba5b4170572dc79cc6533ec\":\"0x28a857425466f800000\",\"0xae2f9c19ac76136594432393b0471d08902164d3\":\"0x25df05c6a897e40000\",\"0xae34861d342253194ffc6652dfde51ab44cad3fe\":\"0x194608686316bd8000\",\"0xae36f7452121913e800e0fcd1a65a5471c23846f\":\"0x8e3f50b173c100000\",\"0xae3f98a443efe00f3e711d525d9894dc9a61157b\":\"0x1004e2e45fb7ee0000\",\"0xae47e2609cfafe369d66d415d939de05081a9872\":\"0x5baecf025f9b6500000\",\"0xae4f122e35c0b1d1e4069291457c83c07f965fa3\":\"0x3635c9adc5dea00000\",\"0xae5055814cb8be0c117bb8b1c8d2b63b4698b728\":\"0x1bc932ec573a38000\",\"0xae538c73c5b38d8d584d7ebdadefb15cabe48357\":\"0x3627e8f712373c0000\",\"0xae57cc129a96a89981dac60d2ffb877d5dc5e432\":\"0x3c3a2394b396550000\",\"0xae5aa1e6c2b60f6fd3efe721bb4a719cbe3d6f5d\":\"0x2b24c6b55a5e620000\",\"0xae5c9bdad3c5c8a1220444aea5c229c1839f1d64\":\"0x19e2a4c818b9060000\",\"0xae5ce3355a7ba9b332760c0950c2bc45a85fa9a0\":\"0x15af1d78b58c400000\",\"0xae5d221afcd3d29355f508eadfca408ce33ca903\":\"0x152d02c7e14af6800000\",\"0xae635bf73831119d2d29c0d04ff8f8d8d0a57a46\":\"0x487a9a304539440000\",\"0xae648155a658370f929be384f7e001047e49dd46\":\"0x2df24ae32be20440000\",\"0xae6f0c73fdd77c489727512174d9b50296611c4c\":\"0x14542ba12a337c00000\",\"0xae70e69d2c4a0af818807b1a2705f79fd0b5dbc4\":\"0x35659ef93f0fc40000\",\"0xae7739124ed153052503fc101410d1ffd8cd13b7\":\"0x3634fb9f1489a70000\",\"0xae78bb849139a6ba38ae92a09a69601cc4cb62d1\":\"0x1b1ae4d6e2ef500000\",\"0xae842210f44d14c4a4db91fc9d3b3b50014f7bf7\":\"0xd8d726b7177a800000\",\"0xae842e81858ecfedf6506c686dc204ac15bf8b24\":\"0x22b1c8c1227a00000\",\"0xae8954f8d6166de507cf61297d0fc7ca6b9e7128\":\"0x1043561a8829300000\",\"0xae9ecd6bdd952ef497c0050ae0ab8a82a91898ce\":\"0x1a055690d9db80000\",\"0xae9f5c3fbbe0c9bcbf1af8ff74ea280b3a5d8b08\":\"0x5dc892aa1131c80000\",\"0xaead88d689416b1c91f2364421375b7d3c70fb2e\":\"0x6c6b935b8bbd400000\",\"0xaeadfcd0978edad74a32bd01a0a51d37f246e661\":\"0xe18398e7601900000\",\"0xaeb916ebf49d0f86c13f7331cef19e129937512d\":\"0x2085655b8d1b0a0000\",\"0xaebd4f205de799b64b3564b256d42a711d37ef99\":\"0x3fcf8b4574f84e0000\",\"0xaec27ce2133e82d052520afb5c576d9f7eb93ed2\":\"0xdd04120ba09cfe60000\",\"0xaec27ff5d7f9ddda91183f46f9d52543b6cd2b2f\":\"0x18650127cc3dc80000\",\"0xaee49d68adedb081fd43705a5f78c778fb90de48\":\"0x1158e460913d00000\",\"0xaef5b12258a18dec07d5ec2e316574919d79d6d6\":\"0x6c6b935b8bbd400000\",\"0xaefcfe88c826ccf131d54eb4ea9eb80e61e1ee25\":\"0x126e72a69a50d00000\",\"0xaf06f5fa6d1214ec43967d1bd4dde74ab814a938\":\"0x4c53ecdc18a600000\",\"0xaf1148ef6c8e103d7530efc91679c9ac27000993\":\"0xad78ebc5ac6200000\",\"0xaf203e229d7e6d419df4378ea98715515f631485\":\"0x6acb3df27e1f880000\",\"0xaf2058c7282cf67c8c3cf930133c89617ce75d29\":\"0x177224aa844c7200000\",\"0xaf26f7c6bf453e2078f08953e4b28004a2c1e209\":\"0x56bc75e2d63100000\",\"0xaf3087e62e04bf900d5a54dc3e946274da92423b\":\"0x1158e460913d00000\",\"0xaf3614dcb68a36e45a4e911e62796247222d595b\":\"0x7a81065f1103bc0000\",\"0xaf3615c789d0b1152ad4db25fe5dcf222804cf62\":\"0x3635c9adc5dea00000\",\"0xaf3cb5965933e7dad883693b9c3e15beb68a4873\":\"0x6c6b935b8bbd400000\",\"0xaf4493e8521ca89d95f5267c1ab63f9f45411e1b\":\"0xad78ebc5ac6200000\",\"0xaf4cf41785161f571d0ca69c94f8021f41294eca\":\"0x215f835bc769da80000\",\"0xaf529bdb459cc185bee5a1c58bf7e8cce25c150d\":\"0xaadec983fcff40000\",\"0xaf67fd3e127fd9dc36eb3fcd6a80c7be4f7532b2\":\"0x5a87e7d7f5f6580000\",\"0xaf771039345a343001bc0f8a5923b126b60d509c\":\"0x35659ef93f0fc40000\",\"0xaf7f79cb415a1fb8dbbd094607ee8d41fb7c5a3b\":\"0x21e19e0c9bab2400000\",\"0xaf87d2371ef378957fbd05ba2f1d66931b01e2b8\":\"0x25f273933db5700000\",\"0xaf880fc7567d5595cacce15c3fc14c8742c26c9e\":\"0x73f75d1a085ba0000\",\"0xaf8e1dcb314c950d3687434d309858e1a8739cd4\":\"0xe7eeba3410b740000\",\"0xaf992dd669c0883e5515d3f3112a13f617a4c367\":\"0x6c6b935b8bbd400000\",\"0xafa1d5ad38fed44759c05b8993c1aa0dace19f40\":\"0x4563918244f400000\",\"0xafa539586e4719174a3b46b9b3e663a7d1b5b987\":\"0x10f0cf064dd59200000\",\"0xafa6946effd5ff53154f82010253df47ae280ccc\":\"0x6acb3df27e1f880000\",\"0xafc8ebe8988bd4105acc4c018e546a1e8f9c7888\":\"0x1b1ae4d6e2ef500000\",\"0xafcc7dbb8356d842d43ae7e23c8422b022a30803\":\"0x66ffcbfd5e5a3000000\",\"0xafd019ff36a09155346b69974815a1c912c90aa4\":\"0x6c6b935b8bbd400000\",\"0xafdac5c1cb56e245bf70330066a817eaafac4cd1\":\"0x1158e460913d00000\",\"0xafdd1b786162b8317e20f0e979f4b2ce486d765d\":\"0x1158e460913d00000\",\"0xaff1045adf27a1aa329461b24de1bae9948a698b\":\"0x1cf84a30a0a0c0000\",\"0xaff107960b7ec34ed690b665024d60838c190f70\":\"0x1b1ae4d6e2ef500000\",\"0xaff11ccf699304d5f5862af86083451c26e79ae5\":\"0x6c5db2a4d815dc0000\",\"0xaff161740a6d909fe99c59a9b77945c91cc91448\":\"0x340aad21b3b700000\",\"0xaffc99d5ebb4a84fe7788d97dce274b038240438\":\"0x10f0cf064dd59200000\",\"0xaffea0473722cb7f0e0e86b9e11883bf428d8d54\":\"0x692ae8897081d00000\",\"0xb00996b0566ecb3e7243b8227988dcb352c21899\":\"0x28a857425466f800000\",\"0xb01e389b28a31d8e4995bdd7d7c81beeab1e4119\":\"0x3635c9adc5dea00000\",\"0xb02d062873334545cea29218e4057760590f7423\":\"0xacb6a1c7d93a880000\",\"0xb02fa29387ec12e37f6922ac4ce98c5b09e0b00f\":\"0x6c6b935b8bbd400000\",\"0xb036916bdacf94b69e5a8a65602975eb026104dd\":\"0x1158e460913d00000\",\"0xb041310fe9eed6864cedd4bee58df88eb4ed3cac\":\"0x21e19e0c9bab2400000\",\"0xb055af4cadfcfdb425cf65ba6431078f07ecd5ab\":\"0x56bc75e2d63100000\",\"0xb0571153db1c4ed7acaefe13ecdfdb72e7e4f06a\":\"0x110cff796ac195200000\",\"0xb06eab09a610c6a53d56a946b2c43487ac1d5b2d\":\"0x3635c9adc5dea00000\",\"0xb07249e055044a9155359a402937bbd954fe48b6\":\"0x56bc75e2d63100000\",\"0xb07618328a901307a1b7a0d058fcd5786e9e72fe\":\"0x667495d4a4330ce0000\",\"0xb079bb4d9866143a6da72ae7ac0022062981315c\":\"0x29331e6558f0e00000\",\"0xb07bcc085ab3f729f24400416837b69936ba8873\":\"0x6c6d84bccdd9ce0000\",\"0xb07bcf1cc5d4462e5124c965ecf0d70dc27aca75\":\"0x56bc75e2d631000000\",\"0xb07cb9c12405b711807543c4934465f87f98bd2d\":\"0x6c6b935b8bbd400000\",\"0xb07fdeaff91d4460fe6cd0e8a1b0bd8d22a62e87\":\"0x11d2529f3535ab00000\",\"0xb09fe6d4349b99bc37938054022d54fca366f7af\":\"0x2a5a058fc295ed000000\",\"0xb0aa00950c0e81fa3210173e729aaf163a27cd71\":\"0x878678326eac9000000\",\"0xb0ac4eff6680ee14169cdadbffdb30804f6d25f5\":\"0x6c6b935b8bbd400000\",\"0xb0b36af9aeeedf97b6b02280f114f13984ea3260\":\"0x35659ef93f0fc40000\",\"0xb0b779b94bfa3c2e1f587bcc9c7e21789222378f\":\"0x54069233bf7f780000\",\"0xb0baeb30e313776c4c6d247402ba4167afcda1cc\":\"0x6acb3df27e1f880000\",\"0xb0bb29a861ea1d424d45acd4bfc492fb8ed809b7\":\"0x4563918244f400000\",\"0xb0c1b177a220e41f7c74d07cde8569c21c75c2f9\":\"0x12f939c99edab800000\",\"0xb0c7ce4c0dc3c2bbb99cc1857b8a455f611711ce\":\"0xd8d726b7177a800000\",\"0xb0cef8e8fb8984a6019f01c679f272bbe68f5c77\":\"0x83d6c7aab63600000\",\"0xb0d32bd7e4e695b7b01aa3d0416f80557dba9903\":\"0x3739ff0f6e613300000\",\"0xb0d3c9872b85056ea0c0e6d1ecf7a77e3ce6ab85\":\"0x10f08eda8e555098000\",\"0xb0e469c886593815b3495638595daef0665fae62\":\"0x692ae8897081d00000\",\"0xb0e760bb07c081777345e0578e8bc898226d4e3b\":\"0x6c6b935b8bbd400000\",\"0xb1043004ec1941a8cf4f2b00b15700ddac6ff17e\":\"0x3635c9adc5dea00000\",\"0xb105dd3d987cffd813e9c8500a80a1ad257d56c6\":\"0x6c6acc67d7b1d40000\",\"0xb10fd2a647102f881f74c9fbc37da632949f2375\":\"0x22b1c8c1227a00000\",\"0xb115ee3ab7641e1aa6d000e41bfc1ec7210c2f32\":\"0x2c0bb3dd30c4e200000\",\"0xb1178ad47383c31c8134a1941cbcd474d06244e2\":\"0x3635c9adc5dea00000\",\"0xb1179589e19db9d41557bbec1cb24ccc2dec1c7f\":\"0x152d02c7e14af6800000\",\"0xb119e79aa9b916526581cbf521ef474ae84dcff4\":\"0x4fba1001e5befe0000\",\"0xb11fa7fb270abcdf5a2eab95aa30c4b53636efbf\":\"0x2b5e3af16b18800000\",\"0xb124bcb6ffa430fcae2e86b45f27e3f21e81ee08\":\"0x6c6b935b8bbd400000\",\"0xb129a5cb7105fe810bd895dc7206a991a4545488\":\"0x1a055690d9db80000\",\"0xb12ed07b8a38ad5506363fc07a0b6d799936bdaf\":\"0x21e19e0c9bab2400000\",\"0xb134c004391ab4992878337a51ec242f42285742\":\"0x6c6b935b8bbd400000\",\"0xb13f93af30e8d7667381b2b95bc1a699d5e3e129\":\"0x16c4abbebea0100000\",\"0xb1459285863ea2db3759e546ceb3fb3761f5909c\":\"0x3cd72a894087e08000\",\"0xb146a0b925553cf06fcaf54a1b4dfea621290757\":\"0x6c6e59e67c78540000\",\"0xb14a7aaa8f49f2fb9a8102d6bbe4c48ae7c06fb2\":\"0x1b1ae4d6e2ef5000000\",\"0xb14bbeff70720975dc6191b2a44ff49f2672873c\":\"0x7c0860e5a80dc0000\",\"0xb14cc8de33d6338236539a489020ce4655a32bc6\":\"0x1b1ae4d6e2ef5000000\",\"0xb14ddb0386fb606398b8cc47565afae00ff1d66a\":\"0xa12aff083e66f00000\",\"0xb153f828dd076d4a7c1c2574bb2dee1a44a318a8\":\"0x15af1d78b58c400000\",\"0xb1540e94cff3465cc3d187e7c8e3bdaf984659e2\":\"0xa215e44390e3330000\",\"0xb158db43fa62d30e65f3d09bf781c7b67372ebaa\":\"0x6c5db2a4d815dc0000\",\"0xb161725fdcedd17952d57b23ef285b7e4b1169e8\":\"0x2b6dfed3664958000\",\"0xb16479ba8e7df8f63e1b95d149cd8529d735c2da\":\"0x2de33a6aac32548000\",\"0xb166e37d2e501ae73c84142b5ffb5aa655dd5a99\":\"0x6c5db2a4d815dc0000\",\"0xb183ebee4fcb42c220e47774f59d6c54d5e32ab1\":\"0x56f7a9c33c04d10000\",\"0xb188078444027e386798a8ae68698919d5cc230d\":\"0xe7eeba3410b740000\",\"0xb1896a37e5d8825a2d01765ae5de629977de8352\":\"0xad78ebc5ac6200000\",\"0xb18e67a5050a1dc9fb190919a33da838ef445014\":\"0x1158e460913d00000\",\"0xb1a2b43a7433dd150bb82227ed519cd6b142d382\":\"0x946d620d744b880000\",\"0xb1c0d08b36e184f9952a4037e3e53a667d070a4e\":\"0x3635c9adc5dea00000\",\"0xb1c328fb98f2f19ab6646f0a7c8c566fda5a8540\":\"0x878678326eac900000\",\"0xb1c751786939bba0d671a677a158c6abe7265e46\":\"0x21e19e0c9bab2400000\",\"0xb1cd4bdfd104489a026ec99d597307a04279f173\":\"0x43c33c1937564800000\",\"0xb1cf94f8091505055f010ab4bac696e0ca0f67a1\":\"0x55a6e79ccd1d300000\",\"0xb1d6b01b94d854fe8b374aa65e895cf22aa2560e\":\"0x32f51edbaaa3300000\",\"0xb1dba5250ba9625755246e067967f2ad2f0791de\":\"0x10f0cf064dd592000000\",\"0xb1e2dd95e39ae9775c55aeb13f12c2fa233053ba\":\"0x6c6b935b8bbd400000\",\"0xb1e6e810c24ab0488de9e01e574837829f7c77d0\":\"0x15af1d78b58c400000\",\"0xb1e9c5f1d21e61757a6b2ee75913fc5a1a4101c3\":\"0x6c6b935b8bbd400000\",\"0xb203d29e6c56b92699c4b92d1f6f84648dc4cfbc\":\"0x15af1d78b58c400000\",\"0xb216dc59e27c3d7279f5cd5bb2becfb2606e14d9\":\"0x15af1d78b58c400000\",\"0xb21b7979bf7c5ca01fa82dd640b41c39e6c6bc75\":\"0x6c6acc67d7b1d40000\",\"0xb223bf1fbf80485ca2b5567d98db7bc3534dd669\":\"0xd8d726b7177a800000\",\"0xb22d5055d9623135961e6abd273c90deea16a3e7\":\"0x4be4e7267b6ae00000\",\"0xb22dadd7e1e05232a93237baed98e0df92b1869e\":\"0x6c6b935b8bbd400000\",\"0xb234035f7544463ce1e22bc553064684c513cd51\":\"0xd89fa3dc48dcf0000\",\"0xb247cf9c72ec482af3eaa759658f793d670a570c\":\"0x31708ae00454400000\",\"0xb2676841ee9f2d31c172e82303b0fe9bbf9f1e09\":\"0xad78ebc5ac6200000\",\"0xb279c7d355c2880392aad1aa21ee867c3b3507df\":\"0x445be3f2ef87940000\",\"0xb27c1a24204c1e118d75149dd109311e07c073ab\":\"0xa80d24677efef00000\",\"0xb28181a458a440f1c6bb1de8400281a3148f4c35\":\"0x14620c57dddae00000\",\"0xb28245037cb192f75785cb86cbfe7c930da258b0\":\"0x3635c9adc5dea000000\",\"0xb287f7f8d8c3872c1b586bcd7d0aedbf7e732732\":\"0x1158e460913d00000\",\"0xb28bb39f3466517cd46f979cf59653ee7d8f152e\":\"0x18650127cc3dc80000\",\"0xb28dbfc6499894f73a71faa00abe0f4bc9d19f2a\":\"0x56bc75e2d63100000\",\"0xb2968f7d35f208871631c6687b3f3daeabc6616c\":\"0x875c47f289f760000\",\"0xb29f5b7c1930d9f97a115e067066f0b54db44b3b\":\"0x3635c9adc5dea00000\",\"0xb2a144b1ea67b9510f2267f9da39d3f93de26642\":\"0x6c6b935b8bbd400000\",\"0xb2a2c2111612fb8bbb8e7dd9378d67f1a384f050\":\"0x1158e460913d00000\",\"0xb2a498f03bd7178bd8a789a00f5237af79a3e3f8\":\"0x41bad155e6512200000\",\"0xb2aa2f1f8e93e79713d92cea9ffce9a40af9c82d\":\"0x6c6b935b8bbd400000\",\"0xb2b516fdd19e7f3864b6d2cf1b252a4156f1b03b\":\"0x2e983c76115fc0000\",\"0xb2b7cdb4ff4b61d5b7ce0b2270bbb5269743ec04\":\"0x6c6b935b8bbd400000\",\"0xb2bdbedf95908476d7148a370cc693743628057f\":\"0xd8d726b7177a800000\",\"0xb2bfaa58b5196c5cb7f89de15f479d1838de713d\":\"0x1236efcbcbb340000\",\"0xb2c53efa33fe4a3a1a80205c73ec3b1dbcad0602\":\"0x6801dab35918938000\",\"0xb2d0360515f17daba90fcbac8205d569b915d6ac\":\"0x14542ba12a337c00000\",\"0xb2d1e99af91231858e7065dd1918330dc4c747d5\":\"0x3894f0e6f9b9f700000\",\"0xb2d9ab9664bcf6df203c346fc692fd9cbab9205e\":\"0x17be78976065180000\",\"0xb2ddb786d3794e270187d0451ad6c8b79e0e8745\":\"0x15af1d78b58c400000\",\"0xb2e085fddd1468ba07415b274e734e11237fb2a9\":\"0x56bc75e2d63100000\",\"0xb2e9d76bf50fc36bf7d3944b63e9ca889b699968\":\"0x9032ea62b74b100000\",\"0xb2f9c972c1e9737755b3ff1b3088738396395b26\":\"0x43c33c1937564800000\",\"0xb2fc84a3e50a50af02f94da0383ed59f71ff01d7\":\"0x65a4da25d3016c00000\",\"0xb3050beff9de33c80e1fa15225e28f2c413ae313\":\"0x25f273933db5700000\",\"0xb31196714a48dff726ea9433cd2912f1a414b3b3\":\"0x914878a8c05ee00000\",\"0xb3145b74506d1a8d047cdcdc55392a7b5350799a\":\"0x1b6229741c0d3d5d8000\",\"0xb320834836d1dbfda9e7a3184d1ad1fd4320ccc0\":\"0x3635c9adc5dea00000\",\"0xb323dcbf2eddc5382ee4bbbb201ca3931be8b438\":\"0x6c6b935b8bbd400000\",\"0xb32400fd13c5500917cb037b29fe22e7d5228f2d\":\"0x878678326eac9000000\",\"0xb325674c01e3f7290d5226339fbeac67d221279f\":\"0x97c9ce4cf6d5c00000\",\"0xb32825d5f3db249ef4e85cc4f33153958976e8bc\":\"0x1b2df9d219f5798000\",\"0xb32af3d3e8d075344926546f2e32887bf93b16bd\":\"0xad78ebc5ac6200000\",\"0xb32f1c2689a5ce79f1bc970b31584f1bcf2283e7\":\"0x1158e460913d00000\",\"0xb33c0323fbf9c26c1d8ac44ef74391d0804696da\":\"0x1158e460913d00000\",\"0xb34f04b8db65bba9c26efc4ce6efc50481f3d65d\":\"0x43c33c1937564800000\",\"0xb3557d39b5411b84445f5f54f38f62d2714d0087\":\"0x2086ac351052600000\",\"0xb358e97c70b605b1d7d729dfb640b43c5eafd1e7\":\"0x43c33c1937564800000\",\"0xb35e8a1c0dac7e0e66dbac736a592abd44012561\":\"0xcfce55aa12b30000\",\"0xb3667894b7863c068ad344873fcff4b5671e0689\":\"0x43c33c1937564800000\",\"0xb3717731dad65132da792d876030e46ac227bb8a\":\"0x3635c9adc5dea00000\",\"0xb3731b046c8ac695a127fd79d0a5d5fa6ae6d12e\":\"0x6c4fd1ee246e780000\",\"0xb37c2b9f50637bece0ca959208aefee6463ba720\":\"0x15af1d78b58c400000\",\"0xb388b5dfecd2c5e4b596577c642556dbfe277855\":\"0x1158e460913d00000\",\"0xb38c4e537b5df930d65a74d043831d6b485bbde4\":\"0x15af1d78b58c400000\",\"0xb39139576194a0866195151f33f2140ad1cc86cf\":\"0x152d02c7e14af6800000\",\"0xb39f4c00b2630cab7db7295ef43d47d501e17fd7\":\"0xd8d726b7177a800000\",\"0xb3a64b1176724f5409e1414a3523661baee74b4a\":\"0x16368ff4ff9c10000\",\"0xb3a6bd41f9d9c3201e050b87198fbda399342210\":\"0xc461e1dd1029b58000\",\"0xb3a8c2cb7d358e5739941d945ba9045a023a8bbb\":\"0x3635c9adc5dea00000\",\"0xb3ae54fba09d3ee1d6bdd1e957923919024c35fa\":\"0x38d2cee65b22a8000\",\"0xb3b7f493b44a2c8d80ec78b1cdc75a652b73b06c\":\"0x6c6b935b8bbd400000\",\"0xb3c228731d186d2ded5b5fbe004c666c8e469b86\":\"0x19274b259f6540000\",\"0xb3c260609b9df4095e6c5dff398eeb5e2df49985\":\"0xdc55fdb17647b0000\",\"0xb3c65b845aba6cd816fbaae983e0e46c82aa8622\":\"0x3635c9adc5dea00000\",\"0xb3c94811e7175b148b281c1a845bfc9bb6fbc115\":\"0xad78ebc5ac6200000\",\"0xb3e20eb4de18bd060221689894bee5aeb25351ee\":\"0x3fc80cce516598000\",\"0xb3e3c439069880156600c2892e448d4136c92d9b\":\"0x2e141ea081ca080000\",\"0xb3f82a87e59a39d0d2808f0751eb72c2329cdcc5\":\"0x10f0cf064dd59200000\",\"0xb3fc1d6881abfcb8becc0bb021b8b73b7233dd91\":\"0x2b5e3af16b1880000\",\"0xb40594c4f3664ef849cca6227b8a25aa690925ee\":\"0xd8d726b7177a800000\",\"0xb41eaf5d51a5ba1ba39bb418dbb54fab750efb1f\":\"0x3635c9adc5dea00000\",\"0xb424d68d9d0d00cec1938c854e15ffb880ba0170\":\"0xad78ebc5ac6200000\",\"0xb4256273962bf631d014555cc1da0dcc31616b49\":\"0x6c6b935b8bbd400000\",\"0xb43067fe70d9b55973ba58dc64dd7f311e554259\":\"0xad78ebc5ac6200000\",\"0xb43657a50eecbc3077e005d8f8d94f377876bad4\":\"0x1ec1b3a1ff75a0000\",\"0xb43c27f7a0a122084b98f483922541c8836cee2c\":\"0x26c29e47c4844c0000\",\"0xb4413576869c08f9512ad311fe925988a52d3414\":\"0x21e19e0c9bab2400000\",\"0xb44605552471a6eee4daab71ff3bb41326d473e0\":\"0x2d7e3d51ba53d00000\",\"0xb447571dacbb3ecbb6d1cf0b0c8f3838e52324e2\":\"0x1a318667fb4058000\",\"0xb44783c8e57b480793cbd69a45d90c7b4f0c48ac\":\"0x1158e460913d00000\",\"0xb44815a0f28e569d0e921a4ade8fb2642526497a\":\"0x302379bf2ca2e0000\",\"0xb4496ddb27799a222457d73979116728e8a1845b\":\"0x8d819ea65fa62f8000\",\"0xb4524c95a7860e21840296a616244019421c4aba\":\"0x1b1ae4d6e2ef5000000\",\"0xb45cca0d36826662683cf7d0b2fdac687f02d0c4\":\"0x3635c9adc5dea00000\",\"0xb46440c797a556e04c7d9104660491f96bb076bf\":\"0xcec76f0e71520000\",\"0xb46ace865e2c50ea4698d216ab455dff5a11cd72\":\"0x3635c9adc5dea00000\",\"0xb46d1182e5aacaff0d26b2fcf72f3c9ffbcdd97d\":\"0xaa2a603cdd7f2c0000\",\"0xb48921c9687d5510744584936e8886bdbf2df69b\":\"0x3635c9adc5dea00000\",\"0xb498bb0f520005b6216a4425b75aa9adc52d622b\":\"0xd8d726b7177a800000\",\"0xb4b11d109f608fa8edd3fea9f8c315649aeb3d11\":\"0x10f0cf064dd59200000\",\"0xb4b14bf45455d0ab0803358b7524a72be1a2045b\":\"0x1b1ae4d6e2ef500000\",\"0xb4b185d943ee2b58631e33dff5af6854c17993ac\":\"0x3635c9adc5dea00000\",\"0xb4bf24cb83686bc469869fefb044b909716993e2\":\"0x6c6b935b8bbd400000\",\"0xb4c20040ccd9a1a3283da4d4a2f365820843d7e2\":\"0x3635c9adc5dea00000\",\"0xb4c8170f7b2ab536d1d9a25bdd203ae1288dc3d5\":\"0xad78ebc5ac6200000\",\"0xb4d82f2e69943f7de0f5f7743879406fac2e9cec\":\"0x22b1c8c1227a00000\",\"0xb4dd460cd016725a64b22ea4f8e06e06674e033e\":\"0x1231bb8748547a80000\",\"0xb4dd5499daeb2507fb2de12297731d4c72b16bb0\":\"0x1158e460913d00000\",\"0xb5046cb3dc1dedbd364514a2848e44c1de4ed147\":\"0x37b7d9bb820405e0000\",\"0xb508f987b2de34ae4cf193de85bff61389621f88\":\"0x14542ba12a337c00000\",\"0xb50955aa6e341571986608bdc891c2139f540cdf\":\"0x6acb3df27e1f880000\",\"0xb50c149a1906fad2786ffb135aab501737e9e56f\":\"0x150894e849b3900000\",\"0xb50c9f5789ae44e2dce017c714caf00c830084c2\":\"0x155bd9307f9fe80000\",\"0xb514882c979bb642a80dd38754d5b8c8296d9a07\":\"0x33c5499031720c0000\",\"0xb51ddcb4dd4e8ae6be336dd9654971d9fec86b41\":\"0x16d464f83de2948000\",\"0xb51e558eb5512fbcfa81f8d0bd938c79ebb5242b\":\"0x26c29e47c4844c0000\",\"0xb523fff9749871b35388438837f7e6e0dea9cb6b\":\"0x6c6b935b8bbd400000\",\"0xb52dfb45de5d74e3df208332bc571c809b8dcf32\":\"0x14542ba12a337c00000\",\"0xb535f8db879fc67fec58824a5cbe6e5498aba692\":\"0x678a932062e4180000\",\"0xb537d36a70eeb8d3e5c80de815225c1158cb92c4\":\"0x5150ae84a8cdf00000\",\"0xb53bcb174c2518348b818aece020364596466ba3\":\"0x6c6b935b8bbd400000\",\"0xb5493ef173724445cf345c035d279ba759f28d51\":\"0x1158e460913d00000\",\"0xb553d25d6b5421e81c2ad05e0b8ba751f8f010e3\":\"0x6c6b935b8bbd400000\",\"0xb55474ba58f0f2f40e6cbabed4ea176e011fcad6\":\"0x6acb3df27e1f880000\",\"0xb555d00f9190cc3677aef314acd73fdc39399259\":\"0x6c6b935b8bbd400000\",\"0xb557ab9439ef50d237b553f02508364a466a5c03\":\"0xad78ebc5ac6200000\",\"0xb56a780028039c81caf37b6775c620e786954764\":\"0x6c6b935b8bbd400000\",\"0xb56ad2aec6c8c3f19e1515bbb7dd91285256b639\":\"0x3635c9adc5dea00000\",\"0xb57413060af3f14eb479065f1e9d19b3757ae8cc\":\"0x22b1c8c1227a00000\",\"0xb57549bfbc9bdd18f736b22650e48a73601fa65c\":\"0x182d7e4cfda0380000\",\"0xb577b6befa054e9c040461855094b002d7f57bd7\":\"0x1823f3cf621d23400000\",\"0xb57b04fa23d1203fae061eac4542cb60f3a57637\":\"0xa5aa85009e39c0000\",\"0xb5870ce342d43343333673038b4764a46e925f3e\":\"0x3635c9adc5dea00000\",\"0xb587b44a2ca79e4bc1dd8bfdd43a207150f2e7e0\":\"0x222c8eb3ff66400000\",\"0xb589676d15a04448344230d4ff27c95edf122c49\":\"0x3635c9adc5dea00000\",\"0xb58b52865ea55d8036f2fab26098b352ca837e18\":\"0xfc936392801c0000\",\"0xb5906b0ae9a28158e8ac550e39da086ee3157623\":\"0xad78ebc5ac6200000\",\"0xb5a4679685fa14196c2e9230c8c4e33bffbc10e2\":\"0x4be4e7267b6ae00000\",\"0xb5a589dd9f4071dbb6fba89b3f5d5dae7d96c163\":\"0x6c6b935b8bbd400000\",\"0xb5a606f4ddcbb9471ec67f658caf2b00ee73025e\":\"0xea756ea92afc740000\",\"0xb5ad5157dda921e6bafacd9086ae73ae1f611d3f\":\"0x6c6b935b8bbd400000\",\"0xb5add1e7809f7d03069bfe883b0a932210be8712\":\"0x3635c9adc5dea00000\",\"0xb5ba29917c78a1d9e5c5c713666c1e411d7f693a\":\"0xa80d24677efef00000\",\"0xb5c816a8283ca4df68a1a73d63bd80260488df08\":\"0xad78ebc5ac6200000\",\"0xb5cac5ed03477d390bb267d4ebd46101fbc2c3da\":\"0xaadec983fcff40000\",\"0xb5cdbc4115406f52e5aa85d0fea170d2979cc7ba\":\"0x487a9a304539440000\",\"0xb5d9934d7b292bcf603b2880741eb760288383a0\":\"0xe7c2518505060000\",\"0xb5dd50a15da34968890a53b4f13fe1af081baaaa\":\"0xd8d726b7177a800000\",\"0xb5fa8184e43ed3e0b8ab91216461b3528d84fd09\":\"0x914878a8c05ee00000\",\"0xb5fb7ea2ddc1598b667a9d57dd39e85a38f35d56\":\"0x1b1ae4d6e2ef500000\",\"0xb600429752f399c80d0734744bae0a022eca67c6\":\"0x1158e460913d00000\",\"0xb600feab4aa96c537504d96057223141692c193a\":\"0x15af1d78b58c400000\",\"0xb6047cdf932db3e4045f4976122341537ed5961e\":\"0x1158e460913d00000\",\"0xb615e940143eb57f875893bc98a61b3d618c1e8c\":\"0x1158e460913d00000\",\"0xb61c34fcacda701a5aa8702459deb0e4ae838df8\":\"0x7695a92c20d6fe00000\",\"0xb63064bd3355e6e07e2d377024125a33776c4afa\":\"0x8375a2abcca24400000\",\"0xb635a4bc71fb28fdd5d2c322983a56c284426e69\":\"0x93739534d28680000\",\"0xb646df98b49442746b61525c81a3b04ba3106250\":\"0x6acb3df27e1f880000\",\"0xb65941d44c50d24666670d364766e991c02e11c2\":\"0x2086ac351052600000\",\"0xb65bd780c7434115162027565223f44e5498ff8c\":\"0x43c30fb0884a96c0000\",\"0xb66411e3a02dedb726fa79107dc90bc1cae64d48\":\"0x6c6b935b8bbd400000\",\"0xb66675142e3111a1c2ea1eb2419cfa42aaf7a234\":\"0x3635c9adc5dea00000\",\"0xb66f92124b5e63035859e390628869dbdea9485e\":\"0x215f835bc769da80000\",\"0xb672734afcc224e2e609fc51d4f059732744c948\":\"0x1004e2e45fb7ee0000\",\"0xb6771b0bf3427f9ae7a93e7c2e61ee63941fdb08\":\"0x3fb26692954bfc00000\",\"0xb67a80f170197d96cdcc4ab6cba627b4afa6e12c\":\"0x821ab0d44149800000\",\"0xb68899e7610d4c93a23535bcc448945ba1666f1c\":\"0xad78ebc5ac6200000\",\"0xb6a82933c9eadabd981e5d6d60a6818ff806e36b\":\"0x15af1d78b58c400000\",\"0xb6aacb8cb30bab2ae4a2424626e6e12b02d04605\":\"0x1b1ae4d6e2ef5000000\",\"0xb6b34a263f10c3d2eceb0acc559a7b2ab85ce565\":\"0xd8d726b7177a800000\",\"0xb6bfe1c3ef94e1846fb9e3acfe9b50c3e9069233\":\"0x6c6acc67d7b1d40000\",\"0xb6cd7432d5161be79768ad45de3e447a07982063\":\"0xd8d726b7177a800000\",\"0xb6ce4dc560fc73dc69fb7a62e388db7e72ea764f\":\"0x345df169e9a3580000\",\"0xb6decf82969819ba02de29b9b593f21b64eeda0f\":\"0x281d901f4fdd100000\",\"0xb6e6c3222b6b6f9be2875d2a89f127fb64100fe2\":\"0x1b21d5323cc30200000\",\"0xb6e8afd93dfa9af27f39b4df06076710bee3dfab\":\"0x15af1d78b58c40000\",\"0xb6f78da4f4d041b3bc14bc5ba519a5ba0c32f128\":\"0x247dd32c3fe195048000\",\"0xb6fb39786250081426a342c70d47ee521e5bc563\":\"0x32d26d12e980b600000\",\"0xb70dba9391682b4a364e77fe99256301a6c0bf1f\":\"0xad78ebc5ac6200000\",\"0xb71623f35107cf7431a83fb3d204b29ee0b1a7f4\":\"0x11164759ffb320000\",\"0xb71a13ba8e95167b80331b52d69e37054fe7a826\":\"0xad78ebc5ac6200000\",\"0xb71b62f4b448c02b1201cb5e394ae627b0a560ee\":\"0x1b1ae4d6e2ef500000\",\"0xb72220ade364d0369f2d2da783ca474d7b9b34ce\":\"0x1b1ab319f5ec750000\",\"0xb7230d1d1ff2aca366963914a79df9f7c5ea2c98\":\"0x1b1ae4d6e2ef5000000\",\"0xb7240af2af90b33c08ae9764103e35dce3638428\":\"0x1cadd2fe9686e638000\",\"0xb727a9fc82e1cffc5c175fa1485a9befa2cdbdd1\":\"0x3627e8f712373c0000\",\"0xb72c2a011c0df50fbb6e28b20ae1aad217886790\":\"0xd8d726b7177a800000\",\"0xb7382d37db0398ac72410cf9813de9f8e1ec8dad\":\"0x3636c25e66ece70000\",\"0xb73b4ff99eb88fd89b0b6d57a9bc338e886fa06a\":\"0x1bc16d674ec800000\",\"0xb73d6a77559c86cf6574242903394bacf96e3570\":\"0x4f1a77ccd3ba00000\",\"0xb74372dbfa181dc9242f39bf1d3731dffe2bdacf\":\"0x6c6b935b8bbd400000\",\"0xb7479dab5022c4d5dbaaf8de171b4e951dd1a457\":\"0x4563918244f400000\",\"0xb749b54e04d5b19bdcedfb84da7701ab478c27ae\":\"0x914878a8c05ee00000\",\"0xb74ed2666001c16333cf7af59e4a3d4860363b9c\":\"0xa7ebd5e4363a00000\",\"0xb75149e185f6e3927057739073a1822ae1cf0df2\":\"0xd8d8583fa2d52f0000\",\"0xb753a75f9ed10b21643a0a3dc0517ac96b1a4068\":\"0x15c8185b2c1ff40000\",\"0xb756ad52f3bf74a7d24c67471e0887436936504c\":\"0x43c33c1937564800000\",\"0xb7576e9d314df41ec5506494293afb1bd5d3f65d\":\"0x1158e460913d00000\",\"0xb758896f1baa864f17ebed16d953886fee68aae6\":\"0x3635c9adc5dea00000\",\"0xb768b5234eba3a9968b34d6ddb481c8419b3655d\":\"0xcfce55aa12b30000\",\"0xb782bfd1e2de70f467646f9bc09ea5b1fcf450af\":\"0xe7eeba3410b740000\",\"0xb7a2c103728b7305b5ae6e961c94ee99c9fe8e2b\":\"0xa968163f0a57b400000\",\"0xb7a31a7c38f3db09322eae11d2272141ea229902\":\"0x6c6b935b8bbd400000\",\"0xb7a6791c16eb4e2162f14b6537a02b3d63bfc602\":\"0x2a526391ac93760000\",\"0xb7a7f77c348f92a9f1100c6bd829a8ac6d7fcf91\":\"0x62a992e53a0af00000\",\"0xb7c077946674ba9341fb4c747a5d50f5d2da6415\":\"0x3635c9adc5dea00000\",\"0xb7c0d0cc0b4d342d4062bac624ccc3c70cc6da3f\":\"0xd8d726b7177a800000\",\"0xb7c9f12b038e73436d17e1c12ffe1aeccdb3f58c\":\"0x1d460162f516f00000\",\"0xb7cc6b1acc32d8b295df68ed9d5e60b8f64cb67b\":\"0x1043561a8829300000\",\"0xb7ce684b09abda53389a875369f71958aeac3bdd\":\"0x6c6b935b8bbd400000\",\"0xb7d12e84a2e4c4a6345af1dd1da9f2504a2a996e\":\"0xad78ebc5ac6200000\",\"0xb7d252ee9402b0eef144295f0e69f0db586c0871\":\"0x23c757072b8dd00000\",\"0xb7d581fe0af1ec383f3b3c416783f385146a7612\":\"0x43c33c1937564800000\",\"0xb7f67314cb832e32e63b15a40ce0d7ffbdb26985\":\"0x398279264a818d0000\",\"0xb8040536958d5998ce4bec0cfc9c2204989848e9\":\"0x52ea70d498fd50a0000\",\"0xb8310a16cc6abc465007694b930f978ece1930bd\":\"0x281d901f4fdd100000\",\"0xb834acf3015322c58382eeb2b79638906e88b6de\":\"0x5150ae84a8cdf000000\",\"0xb84b53d0bb125656cddc52eb852ab71d7259f3d5\":\"0x3635c9adc5dea000000\",\"0xb84c8b9fd33ece00af9199f3cf5fe0cce28cd14a\":\"0xcf152640c5c8300000\",\"0xb85218f342f8012eda9f274e63ce2152b2dcfdab\":\"0xa80d24677efef00000\",\"0xb8555010776e3c5cb311a5adeefe9e92bb9a64b9\":\"0xd8d726b7177a800000\",\"0xb85f26dd0e72d9c29ebaf697a8af77472c2b58b5\":\"0x28519acc7190c700000\",\"0xb85ff03e7b5fc422981fae5e9941dacbdaba7584\":\"0x487a9a304539440000\",\"0xb86607021b62d340cf2652f3f95fd2dc67698bdf\":\"0x10f0cf064dd59200000\",\"0xb87de1bcd29269d521b8761cc39cfb4319d2ead5\":\"0x3635c9adc5dea00000\",\"0xb87f5376c2de0b6cc3c179c06087aa473d6b4674\":\"0x487a9a304539440000\",\"0xb884add88d83dc564ab8e0e02cbdb63919aea844\":\"0x6c6b935b8bbd400000\",\"0xb88a37c27f78a617d5c091b7d5b73a3761e65f2a\":\"0x6c6b935b8bbd400000\",\"0xb8947822d5ace7a6ad8326e95496221e0be6b73d\":\"0x1158e460913d00000\",\"0xb89c036ed7c492879921be41e10ca1698198a74c\":\"0x62a992e53a0af00000\",\"0xb89f4632df5909e58b2a9964f74feb9a3b01e0c5\":\"0x48875bcc6e7cbeb8000\",\"0xb8a79c84945e47a9c3438683d6b5842cff7684b1\":\"0x6c6b935b8bbd400000\",\"0xb8a979352759ba09e35aa5935df175bff678a108\":\"0x1158e460913d00000\",\"0xb8ab39805bd821184f6cbd3d2473347b12bf175c\":\"0x6685ac1bfe32c0000\",\"0xb8ac117d9f0dba80901445823c4c9d4fa3fedc6e\":\"0x3564c4427a8fc7d8000\",\"0xb8bc9bca7f71b4ed12e620438d620f53c114342f\":\"0x1b1ae4d6e2ef500000\",\"0xb8bedd576a4b4c2027da735a5bc3f533252a1808\":\"0x6c6b935b8bbd400000\",\"0xb8c2703d8c3f2f44c584bc10e7c0a6b64c1c097e\":\"0x12cddb8ead6f9f80000\",\"0xb8cc0f060aad92d4eb8b36b3b95ce9e90eb383d7\":\"0x1fc3842bd1f071c00000\",\"0xb8d2ddc66f308c0158ae3ccb7b869f7d199d7b32\":\"0x2dcbf4840eca000000\",\"0xb8d389e624a3a7aebce4d3e5dbdf6cdc29932aed\":\"0xad78ebc5ac6200000\",\"0xb8d531a964bcea13829620c0ced72422dadb4cca\":\"0x93715cc5ab8a70000\",\"0xb8d5c324a8209d7c8049d0d4aede02ba80ab578b\":\"0x393928629fff75e8000\",\"0xb8f20005b61352ffa7699a1b52f01f5ab39167f1\":\"0x21e19e0c9bab2400000\",\"0xb8f30758faa808dbc919aa7b425ec922b93b8129\":\"0x3636d7af5ec98e0000\",\"0xb9013c51bd078a098fae05bf2ace0849c6be17a5\":\"0x4563918244f400000\",\"0xb9144b677c2dc614ceefdf50985f1183208ea64c\":\"0x6c6b935b8bbd400000\",\"0xb916b1a01cdc4e56e7657715ea37e2a0f087d106\":\"0x826e3181e027068000\",\"0xb91d9e916cd40d193db60e79202778a0087716fc\":\"0x15f1ba7f4716200000\",\"0xb9231eb26e5f9e4b4d288f03906704fab96c87d6\":\"0x42bf06b78ed3b500000\",\"0xb92427ad7578b4bfe20a9f63a7c5506d5ca12dc8\":\"0x6c6b935b8bbd400000\",\"0xb927abd2d28aaaa24db31778d27419df8e1b04bb\":\"0x17e11c2a26f478000\",\"0xb94d47b3c052a5e50e4261ae06a20f45d8eee297\":\"0x6c6b935b8bbd400000\",\"0xb95396daaa490df2569324fcc6623be052f132ca\":\"0x6c6b935b8bbd400000\",\"0xb959dce02e91d9db02b1bd8b7d17a9c41a97af09\":\"0x1b1ae4d6e2ef5000000\",\"0xb95c9b10aa981cf4a67a71cc52c504dee8cf58bd\":\"0xd8d726b7177a800000\",\"0xb95cfda8465ba9c2661b249fc3ab661bdfa35ff0\":\"0x114a4e79a2c2108000\",\"0xb96841cabbc7dbd69ef0cf8f81dff3c8a5e21570\":\"0x28a857425466f800000\",\"0xb97a6733cd5fe99864b3b33460d1672434d5cafd\":\"0x6c65bbaa46c2cf8000\",\"0xb981ad5e6b7793a23fc6c1e8692eb2965d18d0da\":\"0x21e18d2c821c7520000\",\"0xb98ca31785ef06be49a1e47e864f60d076ca472e\":\"0xd8d726b7177a800000\",\"0xb9920fd0e2c735c256463caa240fb7ac86a93dfa\":\"0x5f68e8131ecf800000\",\"0xb992a967308c02b98af91ee760fd3b6b4824ab0e\":\"0x6c6b935b8bbd400000\",\"0xb9a985501ee950829b17fae1c9cf348c3156542c\":\"0xff17517ca9a620000\",\"0xb9b0a3219a3288d9b35b091b14650b8fe23dce2b\":\"0x2f6f10780d22cc00000\",\"0xb9cf71b226583e3a921103a5316f855a65779d1b\":\"0x5150ae84a8cdf000000\",\"0xb9e90c1192b3d5d3e3ab0700f1bf655f5dd4347a\":\"0x1b19e50b44977c0000\",\"0xb9fd3833e88e7cf1fa9879bdf55af4b99cd5ce3f\":\"0x3635c9adc5dea00000\",\"0xba0249e01d945bef93ee5ec61925e03c5ca509fd\":\"0xd8d726b7177a800000\",\"0xba0f39023bdb29eb1862a9f9059cab5d306e662f\":\"0x6c6b935b8bbd400000\",\"0xba10f2764290f875434372f79dbf713801caac01\":\"0x33c5499031720c0000\",\"0xba1531fb9e791896bcf3a80558a359f6e7c144bd\":\"0xd5967be4fc3f100000\",\"0xba176dbe3249e345cd4fa967c0ed13b24c47e586\":\"0x15aef9f1c31c7f0000\",\"0xba1f0e03cb9aa021f4dcebfa94e5c889c9c7bc9e\":\"0x6d190c475169a200000\",\"0xba1fcaf223937ef89e85675503bdb7ca6a928b78\":\"0x22b1c8c1227a000000\",\"0xba24fc436753a739db2c8d40e6d4d04c528e86fa\":\"0x2c0bb3dd30c4e200000\",\"0xba42f9aace4c184504abf5425762aca26f71fbdc\":\"0x207077dd8a79c0000\",\"0xba469aa5c386b19295d4a1b5473b540353390c85\":\"0x6c6b935b8bbd400000\",\"0xba6440aeb3737b8ef0f1af9b0c15f4c214ffc7cf\":\"0x3635c9adc5dea00000\",\"0xba6d31b9a261d640b5dea51ef2162c3109f1eba8\":\"0x10f0cf064dd59200000\",\"0xba70e8b4759c0c3c82cc00ac4e9a94dd5bafb2b8\":\"0x3043fa33c412d70000\",\"0xba8a63f3f40de4a88388bc50212fea8e064fbb86\":\"0x6c6b935b8bbd400000\",\"0xba8e46d69d2e2343d86c60d82cf42c2041a0c1c2\":\"0x56bc75e2d63100000\",\"0xbaa4b64c2b15b79f5f204246fd70bcbd86e4a92a\":\"0x1b1ae4d6e2ef500000\",\"0xbac8922c4acc7d2cb6fd59a14eb45cf3e702214b\":\"0x2b5e3af16b18800000\",\"0xbad235d5085dc7b068a67c412677b03e1836884c\":\"0x6c6b935b8bbd400000\",\"0xbad4425e171c3e72975eb46ac0a015db315a5d8f\":\"0x6c6b935b8bbd400000\",\"0xbadc2aef9f5951a8d78a6b35c3d0b3a4e6e2e739\":\"0x14542ba12a337c00000\",\"0xbade43599e02f84f4c3014571c976b13a36c65ab\":\"0xd8d726b7177a800000\",\"0xbae9b82f7299631408659dd74e891cb8f3860fe5\":\"0x6acb3df27e1f880000\",\"0xbb0366a7cfbd3445a70db7fe5ae34885754fd468\":\"0x14def2c42ebd6400000\",\"0xbb076aac92208069ea318a31ff8eeb14b7e996e3\":\"0x813ca56906d340000\",\"0xbb0857f1c911b24b86c8a70681473fe6aaa1cce2\":\"0x56bc75e2d63100000\",\"0xbb19bf91cbad74cceb5f811db27e411bc2ea0656\":\"0xf43fc2c04ee00000\",\"0xbb27c6a7f91075475ab229619040f804c8ec7a6a\":\"0x21e19e0c9bab2400000\",\"0xbb371c72c9f0316cea2bd9c6fbb4079e775429ef\":\"0x5f68e8131ecf800000\",\"0xbb3b010b18e6e2be1135871026b7ba15ea0fde24\":\"0x2207c80309b77700000\",\"0xbb3b9005f46fd2ca3b30162599928c77d9f6b601\":\"0x1b1ae7f2b1bf7db0000\",\"0xbb3fc0a29c034d710812dcc775c8cab9d28d6975\":\"0x39d4e844d1cf5f0000\",\"0xbb48eaf516ce2dec3e41feb4c679e4957641164f\":\"0xcf152640c5c8300000\",\"0xbb4b4a4b548070ff41432c9e08a0ca6fa7bc9f76\":\"0x2e141ea081ca080000\",\"0xbb56a404723cff20d0685488b05a02cdc35aacaa\":\"0x1158e460913d00000\",\"0xbb618e25221ad9a740b299ed1406bc3934b0b16d\":\"0x3635c9adc5dea00000\",\"0xbb61a04bffd57c10470d45c39103f64650347616\":\"0x3635c9adc5dea00000\",\"0xbb6823a1bd819f13515538264a2de052b4442208\":\"0x16368ff4ff9c10000\",\"0xbb6c284aac8a69b75cddb00f28e145583b56bece\":\"0x6c6b935b8bbd400000\",\"0xbb75cb5051a0b0944b4673ca752a97037f7c8c15\":\"0xad78ebc5ac6200000\",\"0xbb993b96ee925ada7d99d786573d3f89180ce3aa\":\"0x6c6b935b8bbd400000\",\"0xbba3c68004248e489573abb2743677066b24c8a7\":\"0x6c6b935b8bbd400000\",\"0xbba4fac3c42039d828e742cde0efffe774941b39\":\"0x6c6ad382d4fb610000\",\"0xbba8ab22d2fedbcfc63f684c08afdf1c175090b5\":\"0x55f29f37e4e3b8000\",\"0xbba976f1a1215f7512871892d45f7048acd356c8\":\"0x6c6b935b8bbd400000\",\"0xbbab000b0408ed015a37c04747bc461ab14e151b\":\"0x14542ba12a337c00000\",\"0xbbabf6643beb4bd01c120bd0598a0987d82967d1\":\"0xb5328178ad0f2a0000\",\"0xbbb4ee1d82f2e156442cc93338a2fc286fa28864\":\"0x4a4491bd6dcd280000\",\"0xbbb5a0f4802c8648009e8a6998af352cde87544f\":\"0x52d542804f1ce0000\",\"0xbbb643d2187b364afc10a6fd368d7d55f50d1a3c\":\"0x3635c9adc5dea00000\",\"0xbbb8ffe43f98de8eae184623ae5264e424d0b8d7\":\"0x5d53ffde928080000\",\"0xbbbd6ecbb5752891b4ceb3cce73a8f477059376f\":\"0x1f399b1438a100000\",\"0xbbbf39b1b67995a42241504f9703d2a14a515696\":\"0x55a6e79ccd1d300000\",\"0xbbc8eaff637e94fcc58d913c7770c88f9b479277\":\"0xad78ebc5ac6200000\",\"0xbbc9d8112e5beb02dd29a2257b1fe69b3536a945\":\"0x6c6b935b8bbd400000\",\"0xbbca65b3266ea2fb73a03f921635f912c7bede00\":\"0x6acb3df27e1f880000\",\"0xbbf84292d954acd9e4072fb860b1504106e077ae\":\"0x5150ae84a8cdf00000\",\"0xbbf85aaaa683738f073baef44ac9dc34c4c779ea\":\"0x6c6b935b8bbd400000\",\"0xbbf8616d97724af3def165d0e28cda89b800009a\":\"0x62ef12e2b17618000\",\"0xbbfe0a830cace87b7293993a7e9496ce64f8e394\":\"0x14542ba12a337c00000\",\"0xbc0ca4f217e052753614d6b019948824d0d8688b\":\"0x15af1d78b58c400000\",\"0xbc0e8745c3a549445c2be900f52300804ab56289\":\"0x7029bf5dd4c53b28000\",\"0xbc0f98598f88056a26339620923b8f1eb074a9fd\":\"0xad78ebc5ac6200000\",\"0xbc1609d685b76b48ec909aa099219022f89b2ccd\":\"0x40138b917edfb80000\",\"0xbc171e53d17ac9b61241ae436deec7af452e7496\":\"0x121ea68c114e5100000\",\"0xbc1b021a78fde42d9b5226d6ec26e06aa3670090\":\"0x4563918244f400000\",\"0xbc1e80c181616342ebb3fb3992072f1b28b802c6\":\"0xd8d726b7177a800000\",\"0xbc237148d30c13836ffa2cad520ee4d2e5c4eeff\":\"0x6acb3df27e1f880000\",\"0xbc46d537cf2edd403565bde733b2e34b215001bd\":\"0x43c33c1937564800000\",\"0xbc4e471560c99c8a2a4b1b1ad0c36aa6502b7c4b\":\"0x28a857425466f800000\",\"0xbc62b3096a91e7dc11a1592a293dd2542150d751\":\"0x3635c9adc5dea00000\",\"0xbc69a0d2a31c3dbf7a9122116901b2bdfe9802a0\":\"0xa2a15d09519be00000\",\"0xbc6b58364bf7f1951c309e0cba0595201cd73f9a\":\"0x62401a457e45f80000\",\"0xbc73f7b1ca3b773b34249ada2e2c8a9274cc17c2\":\"0x6c6b935b8bbd400000\",\"0xbc7afc8477412274fc265df13c054473427d43c6\":\"0x70c95920ce3250000\",\"0xbc967fe4418c18b99858966d870678dca2b88879\":\"0x1d9cbdd8d7ed2100000\",\"0xbc999e385c5aebcac8d6f3f0d60d5aa725336d0d\":\"0x6c6b935b8bbd400000\",\"0xbc9c95dfab97a574cea2aa803b5caa197cef0cff\":\"0x16c4abbebea0100000\",\"0xbc9e0ec6788f7df4c7fc210aacd220c27e45c910\":\"0x1b1ae4d6e2ef500000\",\"0xbca3ffd4683fba0ad3bbc90734b611da9cfb457e\":\"0xad78ebc5ac6200000\",\"0xbcaed0acb6a76f113f7c613555a2c3b0f5bf34a5\":\"0xa7ebd5e4363a00000\",\"0xbcaf347918efb2d63dde03e39275bbe97d26df50\":\"0x56bc75e2d63100000\",\"0xbcb422dc4dd2aae94abae95ea45dd1731bb6b0ba\":\"0x18424f5f0b1b4e0000\",\"0xbcbd31252ec288f91e298cd812c92160e738331a\":\"0x6b1bc2cac09a590000\",\"0xbcbf6ba166e2340db052ea23d28029b0de6aa380\":\"0xd255d112e103a00000\",\"0xbcc84597b91e73d5c5b4d69c80ecf146860f779a\":\"0xed70b5e9c3f2f00000\",\"0xbcc9593b2da6df6a34d71b1aa38dacf876f95b88\":\"0x1158e460913d00000\",\"0xbcd95ef962462b6edfa10fda87d72242fe3edb5c\":\"0x121d06e12fff988000\",\"0xbcd99edc2160f210a05e3a1fa0b0434ced00439b\":\"0x6c6b935b8bbd400000\",\"0xbcdfacb9d9023c3417182e9100e8ea1d373393a3\":\"0x3342d60dff1960000\",\"0xbce13e22322acfb355cd21fd0df60cf93add26c6\":\"0xad78ebc5ac6200000\",\"0xbce40475d345b0712dee703d87cd7657fc7f3b62\":\"0x1a420db02bd7d580000\",\"0xbcedc4267ccb89b31bb764d7211171008d94d44d\":\"0xad78ebc5ac6200000\",\"0xbcfc98e5c82b6adb180a3fcb120b9a7690c86a3f\":\"0x6acb3df27e1f880000\",\"0xbd043b67c63e60f841ccca15b129cdfe6590c8e3\":\"0xad78ebc5ac6200000\",\"0xbd047ff1e69cc6b29ad26497a9a6f27a903fc4dd\":\"0x2ee449550898e40000\",\"0xbd08e0cddec097db7901ea819a3d1fd9de8951a2\":\"0x1158e460913d00000\",\"0xbd09126c891c4a83068059fe0e15796c4661a9f4\":\"0x2b5e3af16b18800000\",\"0xbd0c5cd799ebc48642ef97d74e8e429064fee492\":\"0x11ac28a8c729580000\",\"0xbd17eed82b9a2592019a1b1b3c0fbad45c408d22\":\"0xd8d726b7177a80000\",\"0xbd1803370bddb129d239fd16ea8526a6188ae58e\":\"0x1b1ae4d6e2ef500000\",\"0xbd2b70fecc37640f69514fc7f3404946aad86b11\":\"0x410d586a20a4c00000\",\"0xbd3097a79b3c0d2ebff0e6e86ab0edadbed47096\":\"0x5a87e7d7f5f6580000\",\"0xbd325d4029e0d8729f6d399c478224ae9e7ae41e\":\"0xd255d112e103a00000\",\"0xbd432a3916249b4724293af9146e49b8280a7f2a\":\"0xd8d726b7177a800000\",\"0xbd47f5f76e3b930fd9485209efa0d4763da07568\":\"0x3635c9adc5dea00000\",\"0xbd4b60faec740a21e3071391f96aa534f7c1f44e\":\"0x9ddc1e3b901180000\",\"0xbd4bd5b122d8ef7b7c8f0667450320db2116142e\":\"0x2086ac351052600000\",\"0xbd51ee2ea143d7b1d6b77e7e44bdd7da12f485ac\":\"0x477e06ccb2b9280000\",\"0xbd59094e074f8d79142ab1489f148e32151f2089\":\"0x1158e460913d00000\",\"0xbd5a8c94bd8be6470644f70c8f8a33a8a55c6341\":\"0xad78ebc5ac6200000\",\"0xbd5e473abce8f97a6932f77c2facaf9cc0a00514\":\"0x3c9258a106a6b70000\",\"0xbd5f46caab2c3d4b289396bbb07f203c4da82530\":\"0x4563918244f400000\",\"0xbd66ffedb530ea0b2e856dd12ac2296c31fe29e0\":\"0xad78ebc5ac6200000\",\"0xbd67d2e2f82da8861341bc96a2c0791fddf39e40\":\"0xad7c07947c8fb0000\",\"0xbd6a474d66345bcdd707594adb63b30c7822af54\":\"0xd8d726b7177a800000\",\"0xbd723b289a7367b6ece2455ed61edb49670ab9c4\":\"0x10f0cdea164213f8000\",\"0xbd73c3cbc26a175062ea0320dd84b253bce64358\":\"0x155bd9307f9fe80000\",\"0xbd7419dc2a090a46e2873d7de6eaaad59e19c479\":\"0x170bcb671759f080000\",\"0xbd8765f41299c7f479923c4fd18f126d7229047d\":\"0xd8d726b7177a800000\",\"0xbd93e550403e2a06113ed4c3fba1a8913b19407e\":\"0x6c6b935b8bbd400000\",\"0xbd9e56e902f4be1fc8768d8038bac63e2acbbf8e\":\"0x36356633ebd8ea0000\",\"0xbda4be317e7e4bed84c0495eee32d607ec38ca52\":\"0x7d32277978ef4e8000\",\"0xbdb60b823a1173d45a0792245fb496f1fd3301cf\":\"0x6c6b935b8bbd400000\",\"0xbdbaf6434d40d6355b1e80e40cc4ab9c68d96116\":\"0x56bc75e2d63100000\",\"0xbdc02cd4330c93d6fbda4f6db2a85df22f43c233\":\"0x6c6b935b8bbd400000\",\"0xbdc461462b6322b462bdb33f22799e8108e2417d\":\"0x243d4d18229ca20000\",\"0xbdc739a699700b2e8e2c4a4c7b058a0e513ddebe\":\"0x6c6b935b8bbd400000\",\"0xbdc74873af922b9df474853b0fa7ff0bf8c82695\":\"0xd8c9460063d31c0000\",\"0xbdca2a0ff34588af625fa8e28fc3015ab5a3aa00\":\"0x7ed73f773552fc0000\",\"0xbdd3254e1b3a6dc6cc2c697d45711aca21d516b2\":\"0x6c6b935b8bbd400000\",\"0xbddfa34d0ebf1b04af53b99b82494a9e3d8aa100\":\"0x28a857425466f800000\",\"0xbde4c73f969b89e9ceae66a2b51844480e038e9a\":\"0x3635c9adc5dea00000\",\"0xbde9786a84e75b48f18e726dd78d70e4af3ed802\":\"0x1369fb96128ac480000\",\"0xbded11612fb5c6da99d1e30e320bc0995466141e\":\"0x15af1d78b58c400000\",\"0xbded7e07d0711e684de65ac8b2ab57c55c1a8645\":\"0x2009c5c8bf6fdc0000\",\"0xbdf693f833c3fe471753184788eb4bfe4adc3f96\":\"0x6acb3df27e1f880000\",\"0xbdf6e68c0cd7584080e847d72cbb23aad46aeb1d\":\"0x6acb3df27e1f880000\",\"0xbe0a2f385f09dbfce96732e12bb40ac349871ba8\":\"0x574c115e02b8be0000\",\"0xbe0c2a80b9de084b172894a76cf4737a4f529e1a\":\"0x6c6acc67d7b1d40000\",\"0xbe1cd7f4c472070968f3bde268366b21eeea8321\":\"0xe91a7cd19fa3b00000\",\"0xbe2346a27ff9b702044f500deff2e7ffe6824541\":\"0x1158e460913d00000\",\"0xbe2471a67f6047918772d0e36839255ed9d691ae\":\"0xd8d726b7177a800000\",\"0xbe2b2280523768ea8ac35cd9e888d60a719300d4\":\"0x6c6b935b8bbd400000\",\"0xbe2b326e78ed10e550fee8efa8f8070396522f5a\":\"0x857e0d6f1da76a00000\",\"0xbe305a796e33bbf7f9aeae6512959066efda1010\":\"0x24dce54d34a1a000000\",\"0xbe478e8e3dde6bd403bb2d1c657c4310ee192723\":\"0x1ab2cf7c9f87e20000\",\"0xbe4e7d983f2e2a636b1102ec7039efebc842e98d\":\"0x393ef1a5127c80000\",\"0xbe4fd073617022b67f5c13499b827f763639e4e3\":\"0x6c6b935b8bbd400000\",\"0xbe525a33ea916177f17283fca29e8b350b7f530b\":\"0x8f019aaf46e8780000\",\"0xbe53322f43fbb58494d7cce19dda272b2450e827\":\"0xad7ceaf425c150000\",\"0xbe538246dd4e6f0c20bf5ad1373c3b463a131e86\":\"0xad78ebc5ac6200000\",\"0xbe5a60689998639ad75bc105a371743eef0f7940\":\"0x1b327c73e1257a0000\",\"0xbe5cba8d37427986e8ca2600e858bb03c359520f\":\"0xa030dcebbd2f4c0000\",\"0xbe60037e90714a4b917e61f193d834906703b13a\":\"0x5c283d410394100000\",\"0xbe633a3737f68439bac7c90a52142058ee8e8a6f\":\"0x340aad21b3b7000000\",\"0xbe659d85e7c34f8833ea7f488de1fbb5d4149bef\":\"0x1ebd23ad9d5bb720000\",\"0xbe73274d8c5aa44a3cbefc8263c37ba121b20ad3\":\"0x1b1ae4d6e2ef500000\",\"0xbe86d0b0438419ceb1a038319237ba5206d72e46\":\"0x3634fb9f1489a70000\",\"0xbe8d7f18adfe5d6cc775394989e1930c979d007d\":\"0x3635c9adc5dea00000\",\"0xbe9186c34a52514abb9107860f674f97b821bd5b\":\"0x1ba01ee40603100000\",\"0xbe935793f45b70d8045d2654d8dd3ad24b5b6137\":\"0x2fb474098f67c00000\",\"0xbe98a77fd41097b34f59d7589baad021659ff712\":\"0x30ca024f987b900000\",\"0xbe9b8c34b78ee947ff81472eda7af9d204bc8466\":\"0x821ab0d4414980000\",\"0xbea00df17067a43a82bc1daecafb6c14300e89e6\":\"0x62a992e53a0af00000\",\"0xbea0afc93aae2108a3fac059623bf86fa582a75e\":\"0x5c283d410394100000\",\"0xbeb3358c50cf9f75ffc76d443c2c7f55075a0589\":\"0x90f534608a72880000\",\"0xbeb4fd315559436045dcb99d49dcec03f40c42dc\":\"0x6c6b935b8bbd400000\",\"0xbec2e6de39c07c2bae556acfbee2c4728b9982e3\":\"0x1f0ff8f01daad40000\",\"0xbec6640f4909b58cbf1e806342961d607595096c\":\"0x6c6acc67d7b1d40000\",\"0xbec8caf7ee49468fee552eff3ac5234eb9b17d42\":\"0x6c6b935b8bbd400000\",\"0xbecef61c1c442bef7ce04b73adb249a8ba047e00\":\"0x363b56c3a754c80000\",\"0xbed4649df646e2819229032d8868556fe1e053d3\":\"0xfc936392801c0000\",\"0xbed4c8f006a27c1e5f7ce205de75f516bfb9f764\":\"0x3635c9adc5dea000000\",\"0xbee8d0b008421954f92d000d390fb8f8e658eaee\":\"0x3635c9adc5dea00000\",\"0xbeecd6af900c8b064afcc6073f2d85d59af11956\":\"0x6c6b935b8bbd400000\",\"0xbeef94213879e02622142bea61290978939a60d7\":\"0x136857b32ad86048000\",\"0xbef07d97c3481f9d6aee1c98f9d91a180a32442b\":\"0x152d02c7e14af6800000\",\"0xbefb448c0c5f683fb67ee570baf0db5686599751\":\"0x6acb3df27e1f880000\",\"0xbf05070c2c34219311c4548b2614a438810ded6d\":\"0x6c6b935b8bbd400000\",\"0xbf05ff5ecf0df2df887759fb8274d93238ac267d\":\"0x2b5e3af16b18800000\",\"0xbf09d77048e270b662330e9486b38b43cd781495\":\"0x5c539b7bf4ff28800000\",\"0xbf17f397f8f46f1bae45d187148c06eeb959fa4d\":\"0x3649c59624bb300000\",\"0xbf183641edb886ce60b8190261e14f42d93cce01\":\"0x15b3557f1937f8000\",\"0xbf2aea5a1dcf6ed3b5e8323944e983fedfd1acfb\":\"0x55a6e79ccd1d300000\",\"0xbf4096bc547dbfc4e74809a31c039e7b389d5e17\":\"0xd5967be4fc3f100000\",\"0xbf49c14898316567d8b709c2e50594b366c6d38c\":\"0x27bf38c6544df50000\",\"0xbf4c73a7ede7b164fe072114843654e4d8781dde\":\"0x6c6b935b8bbd400000\",\"0xbf50ce2e264b9fe2b06830617aedf502b2351b45\":\"0x3635c9adc5dea00000\",\"0xbf59aee281fa43fe97194351a9857e01a3b897b2\":\"0x2086ac351052600000\",\"0xbf68d28aaf1eeefef646b65e8cc8d190f6c6da9c\":\"0x6c6b935b8bbd400000\",\"0xbf6925c00751008440a6739a02bf2b6cdaab5e3a\":\"0x3635c9adc5dea00000\",\"0xbf7701fc6225d5a17815438a8941d21ebc5d059d\":\"0x65ea3db75546600000\",\"0xbf8b8005d636a49664f74275ef42438acd65ac91\":\"0xad78ebc5ac6200000\",\"0xbf92418a0c6c31244d220260cb3e867dd7b4ef49\":\"0x56900d33ca7fc0000\",\"0xbf9acd4445d9c9554689cabbbab18800ff1741c2\":\"0x3635c9adc5dea00000\",\"0xbf9f271f7a7e12e36dd2fe9facebf385fe6142bd\":\"0x366f84f7bb7840000\",\"0xbfa8c858df102cb12421008b0a31c4c7190ad560\":\"0xad78ebc5ac6200000\",\"0xbfaeb91067617dcf8b44172b02af615674835dba\":\"0x8b59e884813088000\",\"0xbfb0ea02feb61dec9e22a5070959330299c43072\":\"0x43c33c1937564800000\",\"0xbfbca418d3529cb393081062032a6e1183c6b2dc\":\"0x1b1ae4d6e2ef5000000\",\"0xbfbe05e88c9cbbcc0e92a405fac1d85de248ee24\":\"0x56bc75e2d63100000\",\"0xbfbfbcb656c2992be8fcde8219fbc54aadd59f29\":\"0x21e18d2c821c7520000\",\"0xbfc57aa666fae28e9f107a49cb5089a4e22151dd\":\"0x3635c9adc5dea00000\",\"0xbfcb9730246304700da90b4153e71141622e1c41\":\"0x3635c9adc5dea00000\",\"0xbfd93c90c29c07bc5fb5fc49aeea55a40e134f35\":\"0x5ede20f01a459800000\",\"0xbfe3a1fc6e24c8f7b3250560991f93cba2cf8047\":\"0x10f0cf064dd592000000\",\"0xbfe6bcb0f0c07852643324aa5df5fd6225abc3ca\":\"0x409e52b48369a0000\",\"0xbff5df769934b8943ca9137d0efef2fe6ebbb34e\":\"0x56bc75e2d63100000\",\"0xbffb6929241f788693273e7022e60e3eab1fe84f\":\"0x6c6b935b8bbd400000\",\"0xc0064f1d9474ab915d56906c9fb320a2c7098c9b\":\"0x13683f7f3c15d80000\",\"0xc007f0bdb6e7009202b7af3ea90902697c721413\":\"0xa2a0e43e7fb9830000\",\"0xc00ab080b643e1c2bae363e0d195de2efffc1c44\":\"0x1b1ae4d6e2ef500000\",\"0xc02077449a134a7ad1ef7e4d927affeceeadb5ae\":\"0xfc936392801c0000\",\"0xc02471e3fc2ea0532615a7571d493289c13c36ef\":\"0x1158e460913d00000\",\"0xc02d6eadeacf1b78b3ca85035c637bb1ce01f490\":\"0xd8d726b7177a800000\",\"0xc033b1325a0af45472c25527853b1f1c21fa35de\":\"0x6c6b935b8bbd400000\",\"0xc033be10cb48613bd5ebcb33ed4902f38b583003\":\"0xa2a15d09519be00000\",\"0xc0345b33f49ce27fe82cf7c84d141c68f590ce76\":\"0x3635c9adc5dea00000\",\"0xc03de42a109b657a64e92224c08dc1275e80d9b2\":\"0x1158e460913d00000\",\"0xc04069dfb18b096c7867f8bee77a6dc7477ad062\":\"0x90f534608a72880000\",\"0xc0413f5a7c2d9a4b8108289ef6ecd271781524f4\":\"0xa968163f0a57b400000\",\"0xc043f2452dcb9602ef62bd360e033dd23971fe84\":\"0x6c6b935b8bbd400000\",\"0xc04f4bd4049f044685b883b62959ae631d667e35\":\"0x13b80b99c5185700000\",\"0xc056d4bd6bf3cbacac65f8f5a0e3980b852740ae\":\"0x56bc75e2d63100000\",\"0xc05b740620f173f16e52471dc38b9c514a0b1526\":\"0x796e3ea3f8ab00000\",\"0xc069ef0eb34299abd2e32dabc47944b272334824\":\"0x68155a43676e00000\",\"0xc06cebbbf7f5149a66f7eb976b3e47d56516da2f\":\"0x6c6b935b8bbd400000\",\"0xc0725ec2bdc33a1d826071dea29d62d4385a8c25\":\"0x8a08513463aa6100000\",\"0xc07e3867ada096807a051a6c9c34cc3b3f4ad34a\":\"0x60f06620a849450000\",\"0xc0895efd056d9a3a81c3da578ada311bfb9356cf\":\"0xad78ebc5ac6200000\",\"0xc090fe23dcd86b358c32e48d2af91024259f6566\":\"0xad78ebc5ac6200000\",\"0xc09a66172aea370d9a63da04ff71ffbbfcff7f94\":\"0x6c6b935b8bbd400000\",\"0xc09e3cfc19f605ff3ec9c9c70e2540d7ee974366\":\"0x1b1ae4d6e2ef500000\",\"0xc0a02ab94ebe56d045b41b629b98462e3a024a93\":\"0x56bc75e2d63100000\",\"0xc0a39308a80e9e84aaaf16ac01e3b01d74bd6b2d\":\"0x7664ddd4c1c0b8000\",\"0xc0a6cbad77692a3d88d141ef769a99bb9e3c9951\":\"0x56bc75e2d63100000\",\"0xc0a7e8435dff14c25577739db55c24d5bf57a3d9\":\"0xa6dd90cae5114480000\",\"0xc0ae14d724832e2fce2778de7f7b8daf7b12a93e\":\"0x1158e460913d00000\",\"0xc0afb7d8b79370cfd663c68cc6b9702a37cd9eff\":\"0x3635c9adc5dea00000\",\"0xc0b0b7a8a6e1acdd05e47f94c09688aa16c7ad8d\":\"0x37b6d02ac76710000\",\"0xc0b3f244bca7b7de5b48a53edb9cbeab0b6d88c0\":\"0x13b80b99c5185700000\",\"0xc0c04d0106810e3ec0e54a19f2ab8597e69a573d\":\"0x2b5e3af16b1880000\",\"0xc0ca3277942e7445874be31ceb902972714f1823\":\"0xd8d726b7177a80000\",\"0xc0cbad3ccdf654da22cbcf5c786597ca1955c115\":\"0x6c6b935b8bbd400000\",\"0xc0cbf6032fa39e7c46ff778a94f7d445fe22cf30\":\"0x10ce1d3d8cb3180000\",\"0xc0e0b903088e0c63f53dd069575452aff52410c3\":\"0xa2a15d09519be00000\",\"0xc0e457bd56ec36a1246bfa3230fff38e5926ef22\":\"0x692ae8897081d00000\",\"0xc0ed0d4ad10de03435b153a0fc25de3b93f45204\":\"0xab4dcf399a3a600000\",\"0xc0f29ed0076611b5e55e130547e68a48e26df5e4\":\"0xa2a15d09519be00000\",\"0xc1132878235c5ddba5d9f3228b5236e47020dc6f\":\"0x3635c9adc5dea00000\",\"0xc1170dbaadb3dee6198ea544baec93251860fda5\":\"0x410d586a20a4c00000\",\"0xc126573d87b0175a5295f1dd07c575cf8cfa15f2\":\"0x21e19e0c9bab2400000\",\"0xc127aab59065a28644a56ba3f15e2eac13da2995\":\"0x2086ac351052600000\",\"0xc12b7f40df9a2f7bf983661422ab84c9c1f50858\":\"0x1b1ae4d6e2ef5000000\",\"0xc12cfb7b3df70fceca0ede263500e27873f8ed16\":\"0x3635c9adc5dea00000\",\"0xc12f881fa112b8199ecbc73ec4185790e614a20f\":\"0x6c6b935b8bbd400000\",\"0xc1384c6e717ebe4b23014e51f31c9df7e4e25b31\":\"0x1b1ae4d6e2ef500000\",\"0xc1438c99dd51ef1ca8386af0a317e9b041457888\":\"0xc1daf81d8a3ce0000\",\"0xc1631228efbf2a2e3a4092ee8900c639ed34fbc8\":\"0x33c5499031720c0000\",\"0xc175be3194e669422d15fee81eb9f2c56c67d9c9\":\"0xad78ebc5ac6200000\",\"0xc1827686c0169485ec15b3a7c8c01517a2874de1\":\"0x22b1c8c1227a00000\",\"0xc18ab467feb5a0aadfff91230ff056464d78d800\":\"0x6c6b935b8bbd400000\",\"0xc1950543554d8a713003f662bb612c10ad4cdf21\":\"0xfc936392801c0000\",\"0xc1a41a5a27199226e4c7eb198b031b59196f9842\":\"0xa5aa85009e39c0000\",\"0xc1b2a0fb9cad45cd699192cd27540b88d3384279\":\"0x1b1ae4d6e2ef500000\",\"0xc1b2aa8cb2bf62cdc13a47ecc4657facaa995f98\":\"0x363793fa96e6a68000\",\"0xc1b500011cfba95d7cd636e95e6cbf6167464b25\":\"0xad78ebc5ac6200000\",\"0xc1b9a5704d351cfe983f79abeec3dbbbae3bb629\":\"0x1158e460913d00000\",\"0xc1cbd2e2332a524cf219b10d871ccc20af1fb0fa\":\"0x3635c9adc5dea00000\",\"0xc1cdc601f89c0428b31302d187e0dc08ad7d1c57\":\"0x14542ba12a337c00000\",\"0xc1d4af38e9ba799040894849b8a8219375f1ac78\":\"0x43c33c1937564800000\",\"0xc1e1409ca52c25435134d006c2a6a8542dfb7273\":\"0x1dd1e4bd8d1ee0000\",\"0xc1eba5684aa1b24cba63150263b7a9131aeec28d\":\"0x1158e460913d00000\",\"0xc1ec81dd123d4b7c2dd9b4d438a7072c11dc874c\":\"0x6c6b935b8bbd400000\",\"0xc1f39bd35dd9cec337b96f47c677818160df37b7\":\"0x1158e460913d00000\",\"0xc1ffad07db96138c4b2a530ec1c7de29b8a0592c\":\"0xf43fc2c04ee00000\",\"0xc21fa6643a1f14c02996ad7144b75926e87ecb4b\":\"0x43c33c1937564800000\",\"0xc2340a4ca94c9678b7494c3c852528ede5ee529f\":\"0x2a36b05a3fd7c8000\",\"0xc239abdfae3e9af5457f52ed2b91fd0ab4d9c700\":\"0x6c6b935b8bbd400000\",\"0xc23b2f921ce4a37a259ee4ad8b2158d15d664f59\":\"0x1608995e8bd3f8000\",\"0xc24399b4bf86f7338fbf645e3b22b0e0b7973912\":\"0x6c6b935b8bbd400000\",\"0xc24ccebc2344cce56417fb684cf81613f0f4b9bd\":\"0x54069233bf7f780000\",\"0xc25266c7676632f13ef29be455ed948add567792\":\"0x487a9a304539440000\",\"0xc25cf826550c8eaf10af2234fef904ddb95213be\":\"0x3635c9adc5dea00000\",\"0xc2663f8145dbfec6c646fc5c49961345de1c9f11\":\"0x2567ac70392b880000\",\"0xc270456885342b640b4cfc1b520e1a544ee0d571\":\"0x62a992e53a0af00000\",\"0xc27376f45d21e15ede3b26f2655fcee02ccc0f2a\":\"0x1158e460913d00000\",\"0xc2779771f0536d79a8708f6931abc44b3035e999\":\"0x43c4f8300dcb3480000\",\"0xc27f4e08099d8cf39ee11601838ef9fc06d7fc41\":\"0x61093d7c2c6d380000\",\"0xc282e6993fbe7a912ea047153ffd9274270e285b\":\"0x7960b331247638000\",\"0xc2836188d9a29253e0cbda6571b058c289a0bb32\":\"0x6c6b935b8bbd400000\",\"0xc2aa74847e86edfdd3f3db22f8a2152feee5b7f7\":\"0x6f118886b784a20000\",\"0xc2b2cbe65bc6c2ee7a3c75b2e47c189c062e8d8b\":\"0x43c33c1937564800000\",\"0xc2bae4a233c2d85724f0dabebda0249d833e37d3\":\"0x10f0cf064dd59200000\",\"0xc2c13e72d268e7150dc799e7c6cf03c88954ced7\":\"0x25f273933db5700000\",\"0xc2cb1ada5da9a0423873814793f16144ef36b2f3\":\"0x48557e3b7017df0000\",\"0xc2d1778ef6ee5fe488c145f3586b6ebbe3fbb445\":\"0x3e1ff1e03b55a80000\",\"0xc2d9eedbc9019263d9d16cc5ae072d1d3dd9db03\":\"0x43c33c1937564800000\",\"0xc2e0584a71348cc314b73b2029b6230b92dbb116\":\"0x6c6b935b8bbd400000\",\"0xc2e2d498f70dcd0859e50b023a710a6d4b2133bd\":\"0x383911f00cbce10000\",\"0xc2ed5ffdd1add855a2692fe062b5d618742360d4\":\"0x410d586a20a4c00000\",\"0xc2ee91d3ef58c9d1a589844ea1ae3125d6c5ba69\":\"0x34957444b840e80000\",\"0xc2fafdd30acb6d6706e9293cb02641f9edbe07b5\":\"0x5100860b430f480000\",\"0xc2fd0bf7c725ef3e047e5ae1c29fe18f12a7299c\":\"0x487a9a304539440000\",\"0xc2fe7d75731f636dcd09dbda0671393ba0c82a7d\":\"0x77432217e683600000\",\"0xc3107a9af3322d5238df0132419131629539577d\":\"0x1ab4e464d414310000\",\"0xc3110be01dc9734cfc6e1ce07f87d77d1345b7e1\":\"0x10f0ce949e00f930000\",\"0xc32038ca52aee19745be5c31fcdc54148bb2c4d0\":\"0x2b5aad72c65200000\",\"0xc325c352801ba883b3226c5feb0df9eae2d6e653\":\"0xd5967be4fc3f100000\",\"0xc32ec7e42ad16ce3e2555ad4c54306eda0b26758\":\"0x6c6b935b8bbd400000\",\"0xc332df50b13c013490a5d7c75dbfa366da87b6d6\":\"0xd8d726b7177a800000\",\"0xc33acdb3ba1aab27507b86b15d67faf91ecf6293\":\"0x6c6b935b8bbd400000\",\"0xc33ece935a8f4ef938ea7e1bac87cb925d8490ca\":\"0x7038c16781f78480000\",\"0xc340f9b91c26728c31d121d5d6fc3bb56d3d8624\":\"0x6c6b935b8bbd400000\",\"0xc346cb1fbce2ab285d8e5401f42dd7234d37e86d\":\"0x486cb9799191e0000\",\"0xc3483d6e88ac1f4ae73cc4408d6c03abe0e49dca\":\"0x39992648a23c8a00000\",\"0xc348fc5a461323b57be303cb89361b991913df28\":\"0x152d02c7e14af6800000\",\"0xc34e3ba1322ed0571183a24f94204ee49c186641\":\"0x327afefa4a7bc0000\",\"0xc35b95a2a3737cb8f0f596b34524872bd30da234\":\"0x198be85235e2d500000\",\"0xc3631c7698b6c5111989bf452727b3f9395a6dea\":\"0x243275896641dbe0000\",\"0xc36c0b63bfd75c2f8efb060883d868cccd6cbdb4\":\"0xa2a15d09519be00000\",\"0xc3756bcdcc7eec74ed896adfc335275930266e08\":\"0x14542ba12a337c00000\",\"0xc384ac6ee27c39e2f278c220bdfa5baed626d9d3\":\"0x2086ac351052600000\",\"0xc3a046e3d2b2bf681488826e32d9c061518cfe8c\":\"0x8cf23f909c0fa00000\",\"0xc3a9226ae275df2cab312b911040634a9c9c9ef6\":\"0xd8d726b7177a800000\",\"0xc3b928a76fad6578f04f0555e63952cd21d1520a\":\"0x6c6b935b8bbd400000\",\"0xc3c2297329a6fd99117e54fc6af379b4d556547e\":\"0x14542ba12a337c00000\",\"0xc3c3c2510d678020485a63735d1307ec4ca6302b\":\"0x3635c9adc5dea00000\",\"0xc3cb6b36af443f2c6e258b4a39553a818747811f\":\"0x57473d05dabae80000\",\"0xc3db5657bb72f10d58f231fddf11980aff678693\":\"0x14061b9d77a5e980000\",\"0xc3db9fb6f46c480af34465d79753b4e2b74a67ce\":\"0x43c33c1937564800000\",\"0xc3dd58903886303b928625257ae1a013d71ae216\":\"0x6c6b935b8bbd400000\",\"0xc3e0471c64ff35fa5232cc3121d1d38d1a0fb7de\":\"0x6c6b935b8bbd400000\",\"0xc3e20c96df8d4e38f50b265a98a906d61bc51a71\":\"0x6c6b935b8bbd400000\",\"0xc3e387b03ce95ccfd7fa51dd840183bc43532809\":\"0x6c6b935b8bbd400000\",\"0xc3f8f67295a5cd049364d05d23502623a3e52e84\":\"0x14542ba12a337c00000\",\"0xc401c427cccff10decb864202f36f5808322a0a8\":\"0xb47b51a69cd4020000\",\"0xc4088c025f3e85013f5439fb3440a17301e544fe\":\"0x7e09db4d9f3f340000\",\"0xc41461a3cfbd32c9865555a4813137c076312360\":\"0x3635c6204739d98000\",\"0xc420388fbee84ad656dd68cdc1fbaa9392780b34\":\"0xa2dca63aaf4c58000\",\"0xc42250b0fe42e6b7dcd5c890a6f0c88f5f5fb574\":\"0x81ee4825359840000\",\"0xc42d6aeb710e3a50bfb44d6c31092969a11aa7f3\":\"0x82263cafd8cea0000\",\"0xc440c7ca2f964b6972ef664a2261dde892619d9c\":\"0x43c33c1937564800000\",\"0xc44bdec8c36c5c68baa2ddf1d431693229726c43\":\"0x152d02c7e14af6800000\",\"0xc44f4ab5bc60397c737eb0683391b633f83c48fa\":\"0x3635c9adc5dea00000\",\"0xc452e0e4b3d6ae06b836f032ca09db409ddfe0fb\":\"0x2b5e3af16b18800000\",\"0xc45a1ca1036b95004187cdac44a36e33a94ab5c3\":\"0xdd00f720301880000\",\"0xc45d47ab0c9aa98a5bd62d16223ea2471b121ca4\":\"0x202e68f2c2aee40000\",\"0xc4681e73bb0e32f6b726204831ff69baa4877e32\":\"0x62a992e53a0af00000\",\"0xc46bbdef76d4ca60d316c07f5d1a780e3b165f7e\":\"0x6c6b935b8bbd400000\",\"0xc47d610b399250f70ecf1389bab6292c91264f23\":\"0xfa7e7b5df3cd00000\",\"0xc4803bb407c762f90b7596e6fde194931e769590\":\"0xd8d726b7177a800000\",\"0xc48651c1d9c16bff4c9554886c3f3f26431f6f68\":\"0x23ab9599c43f080000\",\"0xc489c83ffbb0252ac0dbe3521217630e0f491f14\":\"0xd8d726b7177a800000\",\"0xc48b693cacefdbd6cb5d7895a42e3196327e261c\":\"0x3635c9adc5dea00000\",\"0xc493489e56c3bdd829007dc2f956412906f76bfa\":\"0x2a791488e71540000\",\"0xc496cbb0459a6a01600fc589a55a32b454217f9d\":\"0xeda838c4929080000\",\"0xc49cfaa967f3afbf55031061fc4cef88f85da584\":\"0x6c6b935b8bbd400000\",\"0xc4b6e5f09cc1b90df07803ce3d4d13766a9c46f4\":\"0x14542ba12a337c00000\",\"0xc4bec96308a20f90cab18399c493fd3d065abf45\":\"0x2f6f10780d22cc00000\",\"0xc4c01afc3e0f045221da1284d7878574442fb9ac\":\"0x1923c688b73ab040000\",\"0xc4c15318d370c73318cc18bdd466dbaa4c6603bf\":\"0x11164759ffb320000\",\"0xc4c6cb723dd7afa7eb535615e53f3cef14f18118\":\"0x6c6b8fce0d18798000\",\"0xc4cc45a2b63c27c0b4429e58cd42da59be739bd6\":\"0x3635c9adc5dea00000\",\"0xc4cf930e5d116ab8d13b9f9a7ec4ab5003a6abde\":\"0x1158e460913d000000\",\"0xc4d916574e68c49f7ef9d3d82d1638b2b7ee0985\":\"0x55a6e79ccd1d300000\",\"0xc4dac5a8a0264fbc1055391c509cc3ee21a6e04c\":\"0x1606b7fa039ce740000\",\"0xc4dd048bfb840e2bc85cb53fcb75abc443c7e90f\":\"0xc971dc07c9c7900000\",\"0xc4f2913b265c430fa1ab8adf26c333fc1d9b66f2\":\"0x1158e460913d00000\",\"0xc4f7b13ac6d4eb4db3d4e6a252af8a07bd5957da\":\"0xad78ebc5ac6200000\",\"0xc4f7d2e2e22084c44f70feaab6c32105f3da376f\":\"0x6acb3df27e1f880000\",\"0xc4ff6fbb1f09bd9e102ba033d636ac1c4c0f5304\":\"0x3635c9adc5dea00000\",\"0xc4ffadaaf2823fbea7bff702021bffc4853eb5c9\":\"0x24a19c1bd6f128000\",\"0xc500b720734ed22938d78c5e48b2ba9367a575ba\":\"0x7129e1cdf373ee00000\",\"0xc50fe415a641b0856c4e75bf960515441afa358d\":\"0x6c6b935b8bbd400000\",\"0xc5134cfbb1df7a20b0ed7057622eeed280947dad\":\"0xcdff97fabcb4600000\",\"0xc517d0315c878813c717e18cafa1eab2654e01da\":\"0x21e19e0c9bab2400000\",\"0xc518799a5925576213e21896e0539abb85b05ae3\":\"0x3635c9adc5dea00000\",\"0xc522e20fbf04ed7f6b05a37b4718d6fce0142e1a\":\"0xd8d726b7177a800000\",\"0xc524086d46c8112b128b2faf6f7c7d8160a8386c\":\"0x15af1d78b58c400000\",\"0xc52d1a0c73c2a1be84915185f8b34faa0adf1de3\":\"0x4be4eab3fa0fa68000\",\"0xc53594c7cfb2a08f284cc9d7a63bbdfc0b319732\":\"0xa6b2328ff3a62c00000\",\"0xc5374928cdf193705443b14cc20da423473cd9cf\":\"0x77d10509bb3af8000\",\"0xc538a0ff282aaa5f4b75cfb62c70037ee67d4fb5\":\"0x6c6b935b8bbd400000\",\"0xc53b50fd3b2b72bc6c430baf194a515585d3986d\":\"0x1158e460913d00000\",\"0xc53d79f7cb9b70952fd30fce58d54b9f0b59f647\":\"0x113e2d6744345f80000\",\"0xc549df83c6f65eec0f1dc9a0934a5c5f3a50fd88\":\"0x9dc05cce28c2b80000\",\"0xc55005a6c37e8ca7e543ce259973a3cace961a4a\":\"0x6c6b935b8bbd400000\",\"0xc555b93156f09101233c6f7cf6eb3c4f196d3346\":\"0xa2a15d09519be00000\",\"0xc55a6b4761fd11e8c85f15174d74767cd8bd9a68\":\"0x73f75d1a085ba0000\",\"0xc56e6b62ba6e40e52aab167d21df025d0055754b\":\"0x6c6b935b8bbd400000\",\"0xc573e841fa08174a208b060ccb7b4c0d7697127f\":\"0x243d4d18229ca20000\",\"0xc57612de91110c482e6f505bcd23f3c5047d1d61\":\"0xc2127af858da700000\",\"0xc5843399d150066bf7979c34ba294620368ad7c0\":\"0xad78ebc5ac6200000\",\"0xc58b9cc61dedbb98c33f224d271f0e228b583433\":\"0xd255d112e103a00000\",\"0xc58f62fee9711e6a05dc0910b618420aa127f288\":\"0xd7c198710e66b00000\",\"0xc593b546b7698710a205ad468b2c13152219a342\":\"0x54069233bf7f780000\",\"0xc593d6e37d14b566643ac4135f243caa0787c182\":\"0x28a857425466f800000\",\"0xc5a3b98e4593fea0b38c4f455a5065f051a2f815\":\"0x44cf468af25bf770000\",\"0xc5a48a8500f9b4e22f0eb16c6f4649687674267d\":\"0x2c0ec50385043e8000\",\"0xc5a629a3962552cb8eded889636aafbd0c18ce65\":\"0x21e19e0c9bab2400000\",\"0xc5ae86b0c6c7e3900f1368105c56537faf8d743e\":\"0xa31062beeed700000\",\"0xc5b009baeaf788a276bd35813ad65b400b849f3b\":\"0x3635c9adc5dea00000\",\"0xc5b56cd234267c28e89c6f6b2266b086a12f970c\":\"0xd8d726b7177a800000\",\"0xc5c6a4998a33feb764437a8be929a73ba34a0764\":\"0xa968163f0a57b400000\",\"0xc5c73d61cce7c8fe4c8fce29f39092cd193e0fff\":\"0x1b1ae4d6e2ef5000000\",\"0xc5c7590b5621ecf8358588de9b6890f2626143f1\":\"0xa2a15d09519be00000\",\"0xc5cdcee0e85d117dabbf536a3f4069bf443f54e7\":\"0x6ac5c62d9486070000\",\"0xc5d48ca2db2f85d8c555cb0e9cfe826936783f9e\":\"0xad78ebc5ac6200000\",\"0xc5de1203d3cc2cea31c82ee2de5916880799eafd\":\"0x10f0cf064dd59200000\",\"0xc5e488cf2b5677933971f64cb8202dd05752a2c0\":\"0x3635c9adc5dea00000\",\"0xc5e812f76f15f2e1f2f9bc4823483c8804636f67\":\"0x3f514193abb840000\",\"0xc5e9939334f1252ed2ba26814487dfd2982b3128\":\"0x3cb71f51fc5580000\",\"0xc5eb42295e9cadeaf2af12dede8a8d53c579c469\":\"0xcf152640c5c8300000\",\"0xc5edbbd2ca0357654ad0ea4793f8c5cecd30e254\":\"0x14542ba12a337c00000\",\"0xc5f64babb7033142f20e46d7aa6201ed86f67103\":\"0x6c6b935b8bbd400000\",\"0xc5f687717246da8a200d20e5e9bcac60b67f3861\":\"0x18d993f34aef10000\",\"0xc6045b3c350b4ce9ca0c6b754fb41a69b97e9900\":\"0x3224f42723d4540000\",\"0xc60b04654e003b4683041f1cbd6bc38fda7cdbd6\":\"0x6c6b935b8bbd400000\",\"0xc61446b754c24e3b1642d9e51765b4d3e46b34b6\":\"0x6c6b935b8bbd400000\",\"0xc618521321abaf5b26513a4a9528086f220adc6f\":\"0x176b344f2a78c0000\",\"0xc6234657a807384126f8968ca1708bb07baa493c\":\"0x1158e460913d00000\",\"0xc625f8c98d27a09a1bcabd5128b1c2a94856af30\":\"0xad78ebc5ac6200000\",\"0xc6355ec4768c70a49af69513cd83a5bca7e3b9cd\":\"0x14542ba12a337c00000\",\"0xc63ac417992e9f9b60386ed953e6d7dff2b090e8\":\"0xd8d8583fa2d52f0000\",\"0xc63cd7882118b8a91e074d4c8f4ba91851303b9a\":\"0xe18398e7601900000\",\"0xc652871d192422c6bc235fa063b44a7e1d43e385\":\"0x8670e9ec6598c0000\",\"0xc667441e7f29799aba616451d53b3f489f9e0f48\":\"0x2f29ace68addd800000\",\"0xc66ae4cee87fb3353219f77f1d6486c580280332\":\"0x19a16b06ff8cb0000\",\"0xc674f28c8afd073f8b799691b2f0584df942e844\":\"0x6c6b935b8bbd400000\",\"0xc697b70477cab42e2b8b266681f4ae7375bb2541\":\"0x12e5732baba5c980000\",\"0xc69b855539ce1b04714728eec25a37f367951de7\":\"0x6c6b935b8bbd400000\",\"0xc69be440134d6280980144a9f64d84748a37f349\":\"0x26c29e47c4844c0000\",\"0xc69d663c8d60908391c8d236191533fdf7775613\":\"0x1a4aba225c20740000\",\"0xc6a286e065c85f3af74812ed8bd3a8ce5d25e21d\":\"0xfc936392801c0000\",\"0xc6a30ef5bb3320f40dc5e981230d52ae3ac19322\":\"0x9ddc1e3b901180000\",\"0xc6ae287ddbe1149ba16ddcca4fe06aa2eaa988a9\":\"0x15af1d78b58c400000\",\"0xc6c7c191379897dd9c9d9a33839c4a5f62c0890d\":\"0xd8d854b22430688000\",\"0xc6cd68ec35362c5ad84c82ad4edc232125912d99\":\"0x5e0549c9632e1d80000\",\"0xc6d8954e8f3fc533d2d230ff025cb4dce14f3426\":\"0x15af1d78b58c400000\",\"0xc6dbdb9efd5ec1b3786e0671eb2279b253f215ed\":\"0x3635c9adc5dea00000\",\"0xc6df2075ebd240d44869c2be6bdf82e63d4ef1f5\":\"0x1158e460913d00000\",\"0xc6e2f5af979a03fd723a1b6efa728318cf9c1800\":\"0x243d4d18229ca20000\",\"0xc6e324beeb5b36765ecd464260f7f26006c5c62e\":\"0x6c6b935b8bbd400000\",\"0xc6e4cc0c7283fc1c85bc4813effaaf72b49823c0\":\"0xf031ec9c87dd30000\",\"0xc6ee35934229693529dc41d9bb71a2496658b88e\":\"0x42bf06b78ed3b500000\",\"0xc6fb1ee37417d080a0d048923bdabab095d077c6\":\"0xad78ebc5ac6200000\",\"0xc70527d444c490e9fc3f5cc44e66eb4f306b380f\":\"0xd8d726b7177a800000\",\"0xc70d856d621ec145303c0a6400cd17bbd6f5eaf7\":\"0x1158e460913d00000\",\"0xc70fa45576bf9c865f983893002c414926f61029\":\"0x15b4aa8e9702680000\",\"0xc71145e529c7a714e67903ee6206e4c3042b6727\":\"0x4d853c8f8908980000\",\"0xc71b2a3d7135d2a85fb5a571dcbe695e13fc43cd\":\"0x3635c9adc5dea00000\",\"0xc71f1d75873f33dcb2dd4b3987a12d0791a5ce27\":\"0x3708baed3d68900000\",\"0xc71f92a3a54a7b8c2f5ea44305fccb84eee23148\":\"0x2b59ca131d2060000\",\"0xc721b2a7aa44c21298e85039d00e2e460e670b9c\":\"0x7a1fe160277000000\",\"0xc72cb301258e91bc08998a805dd192f25c2f9a35\":\"0x2009c5c8bf6fdc0000\",\"0xc7368b9709a5c1b51c0adf187a65df14e12b7dba\":\"0x2026fc77f03e5ae8000\",\"0xc739259e7f85f2659bef5f609ed86b3d596c201e\":\"0xad78ebc5ac6200000\",\"0xc73e2112282215dc0762f32b7e807dcd1a7aae3e\":\"0x1760cbc623bb3500000\",\"0xc749668042e71123a648975e08ed6382f83e05e2\":\"0x2f6f10780d22cc00000\",\"0xc74a3995f807de1db01a2eb9c62e97d0548f696f\":\"0x3635c9adc5dea00000\",\"0xc7506c1019121ff08a2c8c1591a65eb4bdfb4a3f\":\"0x2086ac351052600000\",\"0xc75c37ce2da06bbc40081159c6ba0f976e3993b1\":\"0x3a7923151ecf580000\",\"0xc75d2259306aec7df022768c69899a652185dbc4\":\"0xd8d726b7177a800000\",\"0xc760971bbc181c6a7cf77441f24247d19ce9b4cf\":\"0x6c6b935b8bbd400000\",\"0xc76130c73cb9210238025c9df95d0be54ac67fbe\":\"0x5150ae84a8cdf00000\",\"0xc765e00476810947816af142d46d2ee7bca8cc4f\":\"0x1b1ae4d6e2ef500000\",\"0xc7675e5647b9d8daf4d3dff1e552f6b07154ac38\":\"0x9c2007651b2500000\",\"0xc77b01a6e911fa988d01a3ab33646beef9c138f3\":\"0x271b6fa5dbe6cc0000\",\"0xc7837ad0a0bf14186937ace06c5546a36aa54f46\":\"0xd8d726b7177a800000\",\"0xc79806032bc7d828f19ac6a640c68e3d820fa442\":\"0x1158e460913d00000\",\"0xc799e34e88ff88be7de28e15e4f2a63d0b33c4cb\":\"0xad78ebc5ac6200000\",\"0xc79d5062c796dd7761f1f13e558d73a59f82f38b\":\"0x1b1ae4d6e2ef5000000\",\"0xc7a018f0968a51d1f6603c5c49dc545bcb0ff293\":\"0xd8d726b7177a800000\",\"0xc7aff91929797489555a2ff1d14d5c695a108355\":\"0x3635c9adc5dea00000\",\"0xc7b1c83e63203f9547263ef6282e7da33b6ed659\":\"0xfc936392801c0000\",\"0xc7b39b060451000ca1049ba154bcfa00ff8af262\":\"0x152d02c7e14af6800000\",\"0xc7bf17c4c11f98941f507e77084fffbd2dbd3db5\":\"0x3635c9adc5dea00000\",\"0xc7bf2ed1ed312940ee6aded1516e268e4a604856\":\"0x14542ba12a337c00000\",\"0xc7d44fe32c7f8cd5f1a97427b6cd3afc9e45023e\":\"0x55a6e79ccd1d300000\",\"0xc7d5c7054081e918ec687b5ab36e973d18132935\":\"0x9ddc1e3b901180000\",\"0xc7de5e8eafb5f62b1a0af2195cf793c7894c9268\":\"0x3635c9adc5dea00000\",\"0xc7e330cd0c890ac99fe771fcc7e7b009b7413d8a\":\"0xd8d726b7177a800000\",\"0xc7eac31abce6d5f1dea42202b6a674153db47a29\":\"0x2009c5c8bf6fdc0000\",\"0xc7ec62b804b1f69b1e3070b5d362c62fb309b070\":\"0x2c46bf5416066110000\",\"0xc7f72bb758016b374714d4899bce22b4aec70a31\":\"0x3a26c9478f5e2d0000\",\"0xc80b36d1beafba5fcc644d60ac6e46ed2927e7dc\":\"0xb98bc829a6f90000\",\"0xc811c2e9aa1ac3462eba5e88fcb5120e9f6e2ca2\":\"0x4be6d887bd876e0000\",\"0xc817df1b91faf30fe3251571727c9711b45d8f06\":\"0x6c6acc67d7b1d40000\",\"0xc81fb7d20fd2800192f0aac198d6d6a37d3fcb7d\":\"0xe1149331c2dde0000\",\"0xc820c711f07705273807aaaa6de44d0e4b48be2e\":\"0x8670e9ec6598c0000\",\"0xc8231ba5a411a13e222b29bfc1083f763158f226\":\"0x3637096c4bcc690000\",\"0xc836e24a6fcf29943b3608e662290a215f6529ea\":\"0xfd45064eaee100000\",\"0xc83ba6dd9549be1d3287a5a654d106c34c6b5da2\":\"0x17b7883c06916600000\",\"0xc83e9d6a58253beebeb793e6f28b054a58491b74\":\"0xf46c2b6f5a9140000\",\"0xc841884fa4785fb773b28e9715fae99a5134305d\":\"0x6c6b935b8bbd400000\",\"0xc84d9bea0a7b9f140220fd8b9097cfbfd5edf564\":\"0x6ab9ec291ad7d8000\",\"0xc852428d2b586497acd30c56aa13fb5582f84402\":\"0x3342d60dff19600000\",\"0xc853215b9b9f2d2cd0741e585e987b5fb80c212e\":\"0x54069233bf7f780000\",\"0xc85325eab2a59b3ed863c86a5f2906a04229ffa9\":\"0x193d7f7d253de00000\",\"0xc85ef27d820403805fc9ed259fff64acb8d6346a\":\"0x6c6b935b8bbd400000\",\"0xc8616b4ec09128cdff39d6e4b9ac86eec471d5f2\":\"0x10d3aa536e2940000\",\"0xc86190904b8d079ec010e462cbffc90834ffaa5c\":\"0x22385a827e815500000\",\"0xc8710d7e8b5a3bd69a42fe0fa8b87c357fddcdc8\":\"0xd8d726b7177a800000\",\"0xc87352dba582ee2066b9c002a962e003134f78b1\":\"0x1b1ae4d6e2ef500000\",\"0xc87c77e3c24adecdcd1038a38b56e18dead3b702\":\"0x1dd0c885f9a0d800000\",\"0xc87d3ae3d88704d9ab0009dcc1a0067131f8ba3c\":\"0x6ac5c62d9486070000\",\"0xc8814e34523e38e1f927a7dce8466a447a093603\":\"0x21e19e0c9bab2400000\",\"0xc88255eddcf521c6f81d97f5a42181c9073d4ef1\":\"0xfc39044d00a2a8000\",\"0xc885a18aabf4541b7b7b7ecd30f6fae6869d9569\":\"0x6c6b935b8bbd400000\",\"0xc88ca1e6e5f4d558d13780f488f10d4ad3130d34\":\"0x54069233bf7f780000\",\"0xc88eec54d305c928cc2848c2fee23531acb96d49\":\"0x6c6ad382d4fb610000\",\"0xc89cf504b9f3f835181fd8424f5ccbc8e1bddf7d\":\"0x21e19e0c9bab2400000\",\"0xc8a2c4e59e1c7fc54805580438aed3e44afdf00e\":\"0x2629f66e0c5300000\",\"0xc8aa49e3809f0899f28ab57e6743709d58419033\":\"0x2fb474098f67c00000\",\"0xc8ab1a3cf46cb8b064df2e222d39607394203277\":\"0x6c6b935b8bbd400000\",\"0xc8b1850525d946f2ae84f317b15188c536a5dc86\":\"0x918ddc3a42a3d40000\",\"0xc8d4e1599d03b79809e0130a8dc38408f05e8cd3\":\"0x9fad06241279160000\",\"0xc8dd27f16bf22450f5771b9fe4ed4ffcb30936f4\":\"0xaadec983fcff40000\",\"0xc8de7a564c7f4012a6f6d10fd08f47890fbf07d4\":\"0x1043561a8829300000\",\"0xc8e2adeb545e499d982c0c117363ceb489c5b11f\":\"0x35659ef93f0fc40000\",\"0xc8e558a3c5697e6fb23a2594c880b7a1b68f9860\":\"0x21e19e0c9bab2400000\",\"0xc8f2b320e6dfd70906c597bad2f9501312c78259\":\"0x51934b8b3a57d00000\",\"0xc90300cb1d4077e6a6d7e169a460468cf4a492d7\":\"0x6c6b935b8bbd400000\",\"0xc90c3765156bca8e4897ab802419153cbe5225a9\":\"0xad78ebc5ac6200000\",\"0xc910a970556c9716ea53af66ddef93143124913d\":\"0x55a6e79ccd1d300000\",\"0xc9127b7f6629ee13fc3f60bc2f4467a20745a762\":\"0x37c9aa4e7ce421d8000\",\"0xc91bb562e42bd46130e2d3ae4652b6a4eb86bc0f\":\"0x1d460162f516f00000\",\"0xc9308879056dfe138ef8208f79a915c6bc7e70a8\":\"0x21e19e0c9bab2400000\",\"0xc934becaf71f225f8b4a4bf7b197f4ac9630345c\":\"0x43c33c1937564800000\",\"0xc93fbde8d46d2bcc0fa9b33bd8ba7f8042125565\":\"0x4be4e7267b6ae00000\",\"0xc94089553ae4c22ca09fbc98f57075cf2ec59504\":\"0xd8d726b7177a800000\",\"0xc94110e71afe578aa218e4fc286403b0330ace8d\":\"0x6c6b935b8bbd400000\",\"0xc946d5acc1346eba0a7279a0ac1d465c996d827e\":\"0x3783d545fdf0aa40000\",\"0xc94a28fb3230a9ddfa964e770f2ce3c253a7be4f\":\"0xad78ebc5ac6200000\",\"0xc94a585203da7bbafd93e15884e660d4b1ead854\":\"0x17b7883c06916600000\",\"0xc94f7c35c027d47df8ef4f9df85a9248a17dd23b\":\"0x19f8e7559924c0000\",\"0xc951900c341abbb3bafbf7ee2029377071dbc36a\":\"0x11c25d004d01f80000\",\"0xc953f934c0eb2d0f144bdab00483fd8194865ce7\":\"0x6c6b935b8bbd400000\",\"0xc96626728aaa4c4fb3d31c26df3af310081710d1\":\"0xb50fcfafebecb00000\",\"0xc96751656c0a8ef4357b7344322134b983504aca\":\"0x6c6b935b8bbd400000\",\"0xc98048687f2bfcc9bd90ed18736c57edd352b65d\":\"0x3635c9adc5dea00000\",\"0xc981d312d287d558871edd973abb76b979e5c35e\":\"0x6acb3df27e1f880000\",\"0xc982586d63b0d74c201b1af8418372e30c7616be\":\"0x56bc75e2d63100000\",\"0xc989434f825aaf9c552f685eba7c11db4a5fc73a\":\"0x1b28c58d9696b40000\",\"0xc989eec307e8839b9d7237cfda08822962abe487\":\"0x15af1d78b58c400000\",\"0xc992be59c6721caf4e028f9e8f05c25c55515bd4\":\"0x1158e460913d00000\",\"0xc9957ba94c1b29e5277ec36622704904c63dc023\":\"0x683efc6782642c0000\",\"0xc99a9cd6c9c1be3534eecd92ecc22f5c38e9515b\":\"0x105593b3a169d770000\",\"0xc9ac01c3fb0929033f0ccc7e1acfeaaba7945d47\":\"0x2a36a9e9ca4d2038000\",\"0xc9b698e898d20d4d4f408e4e4d061922aa856307\":\"0x22b1c8c1227a00000\",\"0xc9b6b686111691ee6aa197c7231a88dc60bd295d\":\"0x1b1ae4d6e2ef500000\",\"0xc9c7ac0bdd9342b5ead4360923f68c72a6ba633a\":\"0x1b1ae4d6e2ef500000\",\"0xc9c80dc12e7bab86e949d01e4c3ed35f2b9bba5f\":\"0x6c6b935b8bbd400000\",\"0xc9d76446d5aadff80b68b91b08cd9bc8f5551ac1\":\"0x26b4bd9110dce80000\",\"0xc9dcbb056f4db7d9da39936202c5bd8230b3b477\":\"0x43c33c1937564800000\",\"0xc9e02608066828848aeb28c73672a12925181f4d\":\"0x1b1b6bd7af64c70000\",\"0xca0432cb157b5179f02ebba5c9d1b54fec4d88ca\":\"0x3635c9adc5dea00000\",\"0xca122cf0f2948896b74843f49afed0ba1618eed7\":\"0x1e5b8fa8fe2ac00000\",\"0xca22cda3606da5cad013b8074706d7e9e721a50c\":\"0x17181c6fa3981940000\",\"0xca23f62dff0d6460036c62e840aec5577e0befd2\":\"0x7a1fe160277000000\",\"0xca25ff34934c1942e22a4e7bd56f14021a1af088\":\"0xaadec983fcff40000\",\"0xca373fe3c906b8c6559ee49ccd07f37cd4fb5266\":\"0x61093d7c2c6d380000\",\"0xca41ccac30172052d522cd2f2f957d248153409f\":\"0x6acb3df27e1f880000\",\"0xca4288014eddc5632f5facb5e38517a8f8bc5d98\":\"0x126e72a69a50d00000\",\"0xca428863a5ca30369892d612183ef9fb1a04bcea\":\"0x52663ccab1e1c00000\",\"0xca49a5f58adbefae23ee59eea241cf0482622eaa\":\"0x4d853c8f8908980000\",\"0xca4ca9e4779d530ecbacd47e6a8058cfde65d98f\":\"0x2b5e3af16b18800000\",\"0xca657ec06fe5bc09cf23e52af7f80cc3689e6ede\":\"0x30ca024f987b900000\",\"0xca66b2280fa282c5b67631ce552b62ee55ad8474\":\"0x6ac422f53492880000\",\"0xca6c818befd251361e02744068be99d8aa60b84a\":\"0x14542ba12a337c00000\",\"0xca70f4ddbf069d2143bd6bbc7f696b52789b32e7\":\"0xa2a15d09519be00000\",\"0xca747576446a4c8f30b08340fee198de63ec92cf\":\"0x17c8e1206722a300000\",\"0xca7ba3ff536c7e5f0e153800bd383db8312998e0\":\"0x931ac3d6bb2400000\",\"0xca8276c477b4a07b80107b843594189607b53bec\":\"0x14542ba12a337c00000\",\"0xca8409083e01b397cf12928a05b68455ce6201df\":\"0x56bc75e2d631000000\",\"0xca98c7988efa08e925ef9c9945520326e9f43b99\":\"0xd8d726b7177a800000\",\"0xca9a042a6a806ffc92179500d24429e8ab528117\":\"0x3ba1910bf341b00000\",\"0xca9dec02841adf5cc920576a5187edd2bd434a18\":\"0x1b1ae4d6e2ef500000\",\"0xca9faa17542fafbb388eab21bc4c94e8a7b34788\":\"0x6c6b8fce0d18798000\",\"0xcaaa68ee6cdf0d34454a769b0da148a1faaa1865\":\"0x1872e1de7fe52c00000\",\"0xcaad9dc20d589ce428d8fda3a9d53a607b7988b5\":\"0xd8d726b7177a800000\",\"0xcab0d32cf3767fa6b3537c84328baa9f50458136\":\"0x1e5b8fa8fe2ac000000\",\"0xcab9a301e6bd46e940355028eccd40ce4d5a1ac3\":\"0x15af1d78b58c400000\",\"0xcab9a97ada065c87816e6860a8f1426fe6b3d775\":\"0x3635c9adc5dea00000\",\"0xcabab6274ed15089737e287be878b757934864e2\":\"0x43c33c1937564800000\",\"0xcabdaf354f4720a466a764a528d60e3a482a393c\":\"0x3635c9adc5dea00000\",\"0xcacb675e0996235404efafbb2ecb8152271b55e0\":\"0x25f273933db5700000\",\"0xcad14f9ebba76680eb836b079c7f7baaf481ed6d\":\"0xcef3d7bd7d0340000\",\"0xcae3a253bcb2cf4e13ba80c298ab0402da7c2aa0\":\"0x124bc0ddd92e5600000\",\"0xcaef027b1ab504c73f41f2a10979b474f97e309f\":\"0xad78ebc5ac6200000\",\"0xcaf4481d9db78dc4f25f7b4ac8bd3b1ca0106b31\":\"0x10f0cf064dd59200000\",\"0xcafde855864c2598da3cafc05ad98df2898e8048\":\"0x300a8ed96ff4a940000\",\"0xcb0dd7cf4e5d8661f6028943a4b9b75c914436a7\":\"0x1969368974c05b000000\",\"0xcb1bb6f1da5eb10d4899f7e61d06c1b00fdfb52d\":\"0x384524cc70b7780000\",\"0xcb3d766c983f192bcecac70f4ee03dd9ff714d51\":\"0x56bc75e2d63100000\",\"0xcb42b44eb5fd60b5837e4f9eb47267523d1a229c\":\"0x2ee449550898e40000\",\"0xcb47bd30cfa8ec5468aaa6a94642ced9c819c8d4\":\"0xd8d726b7177a800000\",\"0xcb48fe8265d9af55eb7006bc335645b0a3a183be\":\"0xa2a15d09519be00000\",\"0xcb4a914d2bb029f32e5fef5c234c4fec2d2dd577\":\"0x6194049f30f7200000\",\"0xcb4abfc282aed76e5d57affda542c1f382fcacf4\":\"0x1b90f11c3183faa0000\",\"0xcb4ad0c723da46ab56d526da0c1d25c73daff10a\":\"0x1ba5abf9e779380000\",\"0xcb4bb1c623ba28dc42bdaaa6e74e1d2aa1256c2a\":\"0x6c6acc67d7b1d40000\",\"0xcb50587412822304ebcba07dab3a0f09fffee486\":\"0x4a4491bd6dcd280000\",\"0xcb58990bcd90cfbf6d8f0986f6fa600276b94e2d\":\"0x3634bf39ab98788000\",\"0xcb68ae5abe02dcf8cbc5aa719c25814651af8b85\":\"0x1b1ae4d6e2ef500000\",\"0xcb7479109b43b26657f4465f4d18c6f974be5f42\":\"0x62a992e53a0af00000\",\"0xcb7d2b8089e9312cc9aeaa2773f35308ec6c2a7b\":\"0x21e19e0c9bab2400000\",\"0xcb86edbc8bbb1f9131022be649565ebdb09e32a1\":\"0x6c6b935b8bbd400000\",\"0xcb93199b9c90bc4915bd859e3d42866dc8c18749\":\"0xc90df07def78c0000\",\"0xcb94e76febe208116733e76e805d48d112ec9fca\":\"0x3635c9adc5dea00000\",\"0xcb9b5103e4ce89af4f64916150bff9eecb9faa5c\":\"0x1b1ae4d6e2ef500000\",\"0xcba25c7a503cc8e0d04971ca05c762f9b762b48b\":\"0x1b1ae4d6e2ef500000\",\"0xcba288cd3c1eb4d59ddb06a6421c14c345a47b24\":\"0xd8d726b7177a800000\",\"0xcbb3189e4bd7f45f178b1c30c76e26314d4a4b0a\":\"0xffe0b677c65a98000\",\"0xcbb7be17953f2ccc93e1bc99805bf45511434e4c\":\"0xaae5b9df56d2f200000\",\"0xcbc04b4d8b82caf670996f160c362940d66fcf1a\":\"0x14542ba12a337c00000\",\"0xcbde9734b8e6aa538c291d6d7facedb0f338f857\":\"0x6c6b935b8bbd400000\",\"0xcbe1b948864d8474e765145858fca4550f784b92\":\"0x21e19e0c9bab2400000\",\"0xcbe52fc533d7dd608c92a260b37c3f45deb4eb33\":\"0x3635c9adc5dea00000\",\"0xcbe810fe0fecc964474a1db97728bc87e973fcbd\":\"0x21e19e0c9bab2400000\",\"0xcbf16a0fe2745258cd52db2bf21954c975fc6a15\":\"0x1043561a8829300000\",\"0xcbf37ff854a2f1ce53934494777892d3ec655782\":\"0x21e19e0c9bab2400000\",\"0xcbfa6af6c283b046e2772c6063b0b21553c40106\":\"0x6c6b935b8bbd400000\",\"0xcbfa76db04ce38fb205d37b8d377cf1380da0317\":\"0x4d853c8f8908980000\",\"0xcc034985d3f28c2d39b1a34bced4d3b2b6ca234e\":\"0x9ddc1e3b901180000\",\"0xcc043c4388d345f884c6855e71142a9f41fd6935\":\"0x1158e460913d00000\",\"0xcc1d6ead01aada3e8dc7b95dca25df26eefa639d\":\"0x6c6b935b8bbd400000\",\"0xcc2b5f448f3528d3fe41cc7d1fa9c0dc76f1b776\":\"0x340aad21b3b700000\",\"0xcc2d04f0a4017189b340ca77198641dcf6456b91\":\"0xd5967be4fc3f100000\",\"0xcc419fd9912b85135659e77a93bc3df182d45115\":\"0x21e19e0c9bab2400000\",\"0xcc45fb3a555bad807b388a0357c855205f7c75e8\":\"0x2ee449550898e40000\",\"0xcc48414d2ac4d42a5962f29eee4497092f431352\":\"0x8ba52e6fc45e40000\",\"0xcc4a2f2cf86cf3e43375f360a4734691195f1490\":\"0x4915053bd129098000\",\"0xcc4f0ff2aeb67d54ce3bc8c6510b9ae83e9d328b\":\"0x15af1d78b58c400000\",\"0xcc4faac00be6628f92ef6b8cb1b1e76aac81fa18\":\"0xb22a2eab0f0fd0000\",\"0xcc4feb72df98ff35a138e01761d1203f9b7edf0a\":\"0x17b7883c06916600000\",\"0xcc606f511397a38fc7872bd3b0bd03c71bbd768b\":\"0x3635c9adc5dea00000\",\"0xcc60f836acdef3548a1fefcca13ec6a937db44a0\":\"0x4b06dbbb40f4a0000\",\"0xcc6c03bd603e09de54e9c4d5ac6d41cbce715724\":\"0x556f64c1fe7fa0000\",\"0xcc6c2df00e86eca40f21ffda1a67a1690f477c65\":\"0xab4dcf399a3a600000\",\"0xcc6d7b12061bc96d104d606d65ffa32b0036eb07\":\"0x21e19e0c9bab2400000\",\"0xcc73dd356b4979b579b401d4cc7a31a268ddce5a\":\"0x1b1ae4d6e2ef500000\",\"0xcc758d071d25a6320af68c5dc9c4f6955ba94520\":\"0x14542ba12a337c00000\",\"0xcc7b0481cc32e6faef2386a07022bcb6d2c3b4fc\":\"0xab4dcf399a3a600000\",\"0xcc943be1222cd1400a2399dd1b459445cf6d54a9\":\"0x2a740ae6536fc880000\",\"0xcc9519d1f3985f6b255eaded12d5624a972721e1\":\"0x3635c9adc5dea00000\",\"0xcc9ac715cd6f2610c52b58676456884297018b29\":\"0xb98bc829a6f90000\",\"0xcca07bb794571d4acf041dad87f0d1ef3185b319\":\"0x6c6b935b8bbd400000\",\"0xccabc6048a53464424fcf76eeb9e6e1801fa23d4\":\"0x2ab7b260ff3fd0000\",\"0xccae0d3d852a7da3860f0636154c0a6ca31628d4\":\"0x5c6d12b6bc1a00000\",\"0xccca24d8c56d6e2c07db086ec07e585be267ac8d\":\"0xad78ebc5ac6200000\",\"0xccd521132d986cb96869842622a7dda26c3ed057\":\"0x6c6b935b8bbd400000\",\"0xccf43975b76bfe735fec3cb7d4dd24f805ba0962\":\"0x340aad21b3b700000\",\"0xccf62a663f1353ba2ef8e6521dc1ecb673ec8ef7\":\"0x83d6c7aab63600000\",\"0xccf7110d1bd9a74bfd1d7d7d2d9d55607e7b837d\":\"0x30ca024f987b900000\",\"0xccfd725760a68823ff1e062f4cc97e1360e8d997\":\"0x15ac56edc4d12c0000\",\"0xcd020f8edfcf524798a9b73a640334bbf72f80a5\":\"0x73f75d1a085ba0000\",\"0xcd06f8c1b5cdbd28e2d96b6346c3e85a0483ba24\":\"0x3635c9adc5dea00000\",\"0xcd072e6e1833137995196d7bb1725fef8761f655\":\"0x14542ba12a337c00000\",\"0xcd0a161bc367ae0927a92aac9cf6e5086714efca\":\"0x6c6b935b8bbd400000\",\"0xcd0af3474e22f069ec3407870dd770443d5b12b0\":\"0x8e5eb4ee77b2ef0000\",\"0xcd0b0257e783a3d2c2e3ba9d6e79b75ef98024d4\":\"0x9fad06241279160000\",\"0xcd102cd6db3df14ad6af0f87c72479861bfc3d24\":\"0x6c6b935b8bbd400000\",\"0xcd1e66ed539dd92fc40bbaa1fa16de8c02c14d45\":\"0xc77e4256863d80000\",\"0xcd1ed263fbf6f6f7b48aef8f733d329d4382c7c7\":\"0x100bd33fb98ba0000\",\"0xcd2a36d753e9e0ed012a584d716807587b41d56a\":\"0xe2ba75b0b1f1c0000\",\"0xcd32a4a8a27f1cc63954aa634f7857057334c7a3\":\"0x3ad166576c72d40000\",\"0xcd35ff010ec501a721a1b2f07a9ca5877dfcf95a\":\"0xd96fce90cfabcc0000\",\"0xcd4306d7f6947ac1744d4e13b8ef32cb657e1c00\":\"0x1b1ab319f5ec750000\",\"0xcd43258b7392a930839a51b2ef8ad23412f75a9f\":\"0x6c6b935b8bbd400000\",\"0xcd49bf185e70d04507999f92a4de4455312827d0\":\"0x3635c9adc5dea00000\",\"0xcd5510a242dfb0183de925fba866e312fabc1657\":\"0x821ab0d44149800000\",\"0xcd566ad7b883f01fd3998a9a58a9dee4724ddca5\":\"0x330ae1835be300000\",\"0xcd59f3dde77e09940befb6ee58031965cae7a336\":\"0x21e19e0c9bab2400000\",\"0xcd725d70be97e677e3c8e85c0b26ef31e9955045\":\"0x487a9a304539440000\",\"0xcd7e47909464d871b9a6dc76a8e9195db3485e7a\":\"0x215f835bc769da80000\",\"0xcd7ece086b4b619b3b369352ee38b71ddb06439a\":\"0xad78ebc5ac6200000\",\"0xcd7f09d7ed66d0c38bc5ad4e32b7f2b08dc1b30d\":\"0x3e3bb34da2a4700000\",\"0xcd9529492b5c29e475acb941402b3d3ba50686b0\":\"0x6acb3df27e1f880000\",\"0xcd95fa423d6fc120274aacde19f4eeb766f10420\":\"0xad78ebc5ac6200000\",\"0xcd9b4cef73390c83a8fd71d7b540a7f9cf8b8c92\":\"0x4e1003b28d9280000\",\"0xcda1741109c0265b3fb2bf8d5ec9c2b8a3346b63\":\"0x1158e460913d00000\",\"0xcda1b886e3a795c9ba77914e0a2fe5676f0f5ccf\":\"0x5bf60ea42c2040000\",\"0xcda4530f4b9bc50905b79d17c28fc46f95349bdf\":\"0x3310e04911f1f80000\",\"0xcdab46a5902080646fbf954204204ae88404822b\":\"0x1d8a96e5c606eb0000\",\"0xcdb597299030183f6e2d238533f4642aa58754b6\":\"0x15af1d78b58c400000\",\"0xcdd5d881a7362c9070073bdfbc75e72453ac510e\":\"0x2da518eae48ee80000\",\"0xcdd60d73efaad873c9bbfb178ca1b7105a81a681\":\"0x1bc16d674ec800000\",\"0xcdd9efac4d6d60bd71d95585dce5d59705c13564\":\"0x56bc75e2d63100000\",\"0xcde36d81d128c59da145652193eec2bfd96586ef\":\"0xd8d726b7177a800000\",\"0xcdea386f9d0fd804d02818f237b7d9fa7646d35e\":\"0xa349d36d80ec578000\",\"0xcdecf5675433cdb0c2e55a68db5d8bbe78419dd2\":\"0x1158e460913d00000\",\"0xcdfd8217339725d7ebac11a63655f265eff1cc3d\":\"0x10f0c696410e3a90000\",\"0xce079f51887774d8021cb3b575f58f18e9acf984\":\"0x9c2007651b2500000\",\"0xce1884ddbbb8e10e4dba6e44feeec2a7e5f92f05\":\"0xd8d726b7177a800000\",\"0xce1b0cb46aaecfd79b880cad0f2dda8a8dedd0b1\":\"0x1158e460913d00000\",\"0xce26f9a5305f8381094354dbfc92664e84f902b5\":\"0xc7aaab0591eec0000\",\"0xce2deab51c0a9ae09cd212c4fa4cc52b53cc0dec\":\"0x6c6b935b8bbd400000\",\"0xce2e0da8934699bb1a553e55a0b85c169435bea3\":\"0x10f0c696410e3a90000\",\"0xce3a61f0461b00935e85fa1ead82c45e5a64d488\":\"0x1b1ae4d6e2ef500000\",\"0xce4b065dbcb23047203262fb48c1188364977470\":\"0x1b1ae4d6e2ef500000\",\"0xce53c8cdd74296aca987b2bc19c2b875a48749d0\":\"0xa2a15d09519be00000\",\"0xce5e04f0184369bcfa06aca66ffa91bf59fa0fb9\":\"0x22b1c8c1227a00000\",\"0xce5eb63a7bf4fbc2f6e4baa0c68ab1cb4cf98fb4\":\"0x6c6b935b8bbd400000\",\"0xce62125adec3370ac52110953a4e760be9451e3b\":\"0x83d6c7aab63600000\",\"0xce71086d4c602554b82dcbfce88d20634d53cc4d\":\"0x92896529baddc880000\",\"0xce8a6b6d5033b1498b1ffeb41a41550405fa03a2\":\"0xd8d726b7177a800000\",\"0xce9786d3712fa200e9f68537eeaa1a06a6f45a4b\":\"0x61093d7c2c6d380000\",\"0xce9d21c692cd3c01f2011f505f870036fa8f6cd2\":\"0x15af1d78b58c400000\",\"0xcea2896623f4910287a2bdc5be83aea3f2e6de08\":\"0x1fb5a3751e490dc0000\",\"0xcea34a4dd93dd9aefd399002a97d997a1b4b89cd\":\"0x5150ae84a8cdf00000\",\"0xcea43f7075816b60bbfce68b993af0881270f6c4\":\"0x6c6b935b8bbd400000\",\"0xcea8743341533cb2f0b9c6efb8fda80d77162825\":\"0x56bc75e2d63100000\",\"0xceb089ec8a78337e8ef88de11b49e3dd910f748f\":\"0x3635c9adc5dea00000\",\"0xceb33d78e7547a9da2e87d51aec5f3441c87923a\":\"0x1158e460913d00000\",\"0xceb389381d48a8ae4ffc483ad0bb5e204cfdb1ec\":\"0x2827e6e4dd62ba8000\",\"0xcec6fc65853f9cce5f8e844676362e1579015f02\":\"0x6c6b935b8bbd400000\",\"0xced3c7be8de7585140952aeb501dc1f876ecafb0\":\"0xd8d726b7177a800000\",\"0xced81ec3533ff1bfebf3e3843ee740ad11758d3e\":\"0x6acb3df27e1f880000\",\"0xcedcb3a1d6843fb6bef643617deaf38f8e98dd5f\":\"0x19e2a4c818b9060000\",\"0xcee699c0707a7836252b292f047ce8ad289b2f55\":\"0x119a1e21aa69560000\",\"0xceed47ca5b899fd1623f21e9bd4db65a10e5b09d\":\"0x73877404c1eee0000\",\"0xcef77451dfa2c643e00b156d6c6ff84e2373eb66\":\"0xa31062beeed700000\",\"0xcf1169041c1745e45b172435a2fc99b49ace2b00\":\"0x1bb88baab2d7c0000\",\"0xcf157612764e0fd696c8cb5fba85df4c0ddc3cb0\":\"0x65a4da25d3016c00000\",\"0xcf1bdb799b2ea63ce134668bdc198b54840f180b\":\"0xfc936392801c0000\",\"0xcf2288ef4ebf88e86db13d8a0e0bf52a056582c3\":\"0x89506fbf9740740000\",\"0xcf264e6925130906c4d7c18591aa41b2a67f6f58\":\"0x6c6b935b8bbd400000\",\"0xcf26b47bd034bc508e6c4bcfd6c7d30034925761\":\"0x6194049f30f7200000\",\"0xcf2e2ad635e9861ae95cb9bafcca036b5281f5ce\":\"0x77432217e6836000000\",\"0xcf2e734042a355d05ffb2e3915b16811f45a695e\":\"0x6c6b935b8bbd400000\",\"0xcf348f2fe47b7e413c077a7baf3a75fbf8428692\":\"0x6c6b935b8bbd400000\",\"0xcf3f9128b07203a3e10d7d5755c0c4abc6e2cac2\":\"0x10f0cf064dd59200000\",\"0xcf3fbfa1fd32d7a6e0e6f8ef4eab57be34025c4c\":\"0x39a1c0f7594d480000\",\"0xcf4166746e1d3bc1f8d0714b01f17e8a62df1464\":\"0x3677036edf0af60000\",\"0xcf4f1138f1bd6bf5b6d485cce4c1017fcb85f07d\":\"0x2fd0bc77c32bff0000\",\"0xcf5a6f9df75579c644f794711215b30d77a0ce40\":\"0x6c6b935b8bbd400000\",\"0xcf5e0eacd1b39d0655f2f77535ef6608eb950ba0\":\"0x6c6b935b8bbd400000\",\"0xcf684dfb8304729355b58315e8019b1aa2ad1bac\":\"0x177224aa844c720000\",\"0xcf694081c76d18c64ca71382be5cd63b3cb476f8\":\"0x3635c9adc5dea00000\",\"0xcf6e52e6b77480b1867efec6446d9fc3cc3577e8\":\"0xc0901f6bd98790000\",\"0xcf883a20329667ea226a1e3c765dbb6bab32219f\":\"0xa4be3564d616660000\",\"0xcf8882359c0fb23387f5674074d8b17ade512f98\":\"0x14542ba12a337c00000\",\"0xcf89f7460ba3dfe83c5a1d3a019ee1250f242f0f\":\"0x356813cdcefd028000\",\"0xcf923a5d8fbc3d01aa079d1cfe4b43ce071b1611\":\"0x6c6b935b8bbd400000\",\"0xcf9be9b9ab86c66b59968e67b8d4dcff46b1814a\":\"0x23c757072b8dd00000\",\"0xcfa8b37127149bdbfee25c34d878510951ea10eb\":\"0x6c6b935b8bbd400000\",\"0xcfac2e1bf33205b05533691a02267ee19cd81836\":\"0x3635c9adc5dea00000\",\"0xcfbb32b7d024350e3321fa20c9a914035372ffc6\":\"0x15be6174e1912e0000\",\"0xcfc4e6f7f8b011414bfba42f23adfaa78d4ecc5e\":\"0x6449e84e47a8a80000\",\"0xcfd2728dfb8bdbf3bf73598a6e13eaf43052ea2b\":\"0x93739534d28680000\",\"0xcfd47493c9f89fe680bda5754dd7c9cfe7cb5bbe\":\"0x2f473513448fe0000\",\"0xcfde0fc75d6f16c443c3038217372d99f5d907f7\":\"0x83225e6396b5ec0000\",\"0xcfe2caaf3cec97061d0939748739bffe684ae91f\":\"0x21e19e0c9bab2400000\",\"0xcfeacaaed57285e0ac7268ce6a4e35ecfdb242d7\":\"0x3ae4d4240190600000\",\"0xcfecbea07c27002f65fe534bb8842d0925c78402\":\"0xd8d726b7177a800000\",\"0xcfee05c69d1f29e7714684c88de5a16098e91399\":\"0x6acb3df27e1f880000\",\"0xcff6a6fe3e9a922a12f21faa038156918c4fcb9c\":\"0x44591d67fecc80000\",\"0xcff7f89a4d4219a38295251331568210ffc1c134\":\"0x5f68e8131ecf800000\",\"0xcff8d06b00e3f50c191099ad56ba6ae26571cd88\":\"0x3635c9adc5dea00000\",\"0xcffc49c1787eebb2b56cabe92404b636147d4558\":\"0x133e0308f40a3da8000\",\"0xd008513b27604a89ba1763b6f84ce688b346945b\":\"0x3635c9adc5dea00000\",\"0xd00f067286c0fbd082f9f4a61083ec76deb3cee6\":\"0x3635c9adc5dea00000\",\"0xd015f6fcb84df7bb410e8c8f04894a881dcac237\":\"0x384524cc70b7780000\",\"0xd01af9134faf5257174e8b79186f42ee354e642d\":\"0x3635c9adc5dea00000\",\"0xd02108d2ae3cab10cbcf1657af223e027c8210f6\":\"0x6c6d84bccdd9ce0000\",\"0xd02afecf8e2ec2b62ac8ad204161fd1fae771d0e\":\"0x6c6b935b8bbd400000\",\"0xd0319139fbab2e8e2accc1d924d4b11df6696c5a\":\"0xad78ebc5ac6200000\",\"0xd037d215d11d1df3d54fbd321cd295c5465e273b\":\"0x4be4e7267b6ae00000\",\"0xd03a2da41e868ed3fef5745b96f5eca462ff6fda\":\"0xa2a15d09519be00000\",\"0xd03fc165576aaed525e5502c8e140f8b2e869639\":\"0x17356d8b32501c80000\",\"0xd043a011ec4270ee7ec8b968737515e503f83028\":\"0x1b1ae4d6e2ef500000\",\"0xd04b861b3d9acc563a901689941ab1e1861161a2\":\"0x1158e460913d00000\",\"0xd05a447c911dbb275bfb2e5a37e5a703a56f9997\":\"0xad78ebc5ac6200000\",\"0xd05ffb2b74f867204fe531653b0248e21c13544e\":\"0x3635c9adc5dea00000\",\"0xd062588171cf99bbeb58f126b870f9a3728d61ec\":\"0xf3f20b8dfa69d00000\",\"0xd0638ea57189a6a699024ad78c71d939c1c2ff8c\":\"0x8eae566710fc200000\",\"0xd0648a581b3508e135a2935d12c9657045d871ca\":\"0x1b2df9d219f57980000\",\"0xd071192966eb69c3520fca3aa4dd04297ea04b4e\":\"0x5f68e8131ecf80000\",\"0xd0718520eae0a4d62d70de1be0ca431c5eea2482\":\"0x6c6b935b8bbd400000\",\"0xd0775dba2af4c30a3a78365939cd71c2f9de95d2\":\"0x692ae8897081d00000\",\"0xd07be0f90997caf903c8ac1d53cde904fb190741\":\"0x36389038b699b40000\",\"0xd07e511864b1cf9969e3560602829e32fc4e71f5\":\"0x2b5e3af16b1880000\",\"0xd0809498c548047a1e2a2aa6a29cd61a0ee268bd\":\"0x6c6b935b8bbd400000\",\"0xd082275f745a2cac0276fbdb02d4b2a3ab1711fe\":\"0x1a055690d9db80000\",\"0xd08fc09a0030fd0928cd321198580182a76aae9f\":\"0x3635c9adc5dea00000\",\"0xd093e829819fd2e25b973800bb3d5841dd152d05\":\"0xd8d726b7177a800000\",\"0xd0944aa185a1337061ae20dc9dd96c83b2ba4602\":\"0xad78ebc5ac6200000\",\"0xd096565b7c7407d06536580355fdd6d239144aa1\":\"0xd8d726b7177a80000\",\"0xd09cb2e6082d693a13e8d2f68dd1dd8461f55840\":\"0x3635c9adc5dea00000\",\"0xd0a6c6f9e9c4b383d716b31de78d56414de8fa91\":\"0x1043561a8829300000\",\"0xd0a7209b80cf60db62f57d0a5d7d521a69606655\":\"0x8ac7230489e800000\",\"0xd0a8abd80a199b54b08b65f01d209c27fef0115b\":\"0x161c626dc61a2ef8000\",\"0xd0abcc70c0420e0e172f97d43b87d5e80c336ea9\":\"0x21e19e0c9bab2400000\",\"0xd0ae735d915e946866e1fea77e5ea466b5cadd16\":\"0x6c6b935b8bbd400000\",\"0xd0b11d6f2bce945e0c6a5020c3b52753f803f9d1\":\"0xad78ebc5ac6200000\",\"0xd0c101fd1f01c63f6b1d19bc920d9f932314b136\":\"0x43c33c1937564800000\",\"0xd0c55abf976fdc3db2afe9be99d499484d576c02\":\"0x3635c9adc5dea00000\",\"0xd0d0a2ad45f59a9dccc695d85f25ca46ed31a5a3\":\"0x2d89577d7d40200000\",\"0xd0d62c47ea60fb90a3639209bbfdd4d933991cc6\":\"0xa844a7424d9c80000\",\"0xd0db456178206f5c4430fe005063903c3d7a49a7\":\"0x26491e45a753c08000\",\"0xd0e194f34b1db609288509ccd2e73b6131a2538b\":\"0x36356633ebd8ea0000\",\"0xd0e35e047646e759f4517093d6408642517f084d\":\"0xd58fa46818eccb8000\",\"0xd0ee4d02cf24382c3090d3e99560de3678735cdf\":\"0x821ab0d44149800000\",\"0xd0f04f52109aebec9a7b1e9332761e9fe2b97bb5\":\"0xd8d726b7177a800000\",\"0xd0f9597811b0b992bb7d3757aa25b4c2561d32e2\":\"0x1b1ae4d6e2ef500000\",\"0xd10302faa1929a326904d376bf0b8dc93ad04c4c\":\"0x61093d7c2c6d380000\",\"0xd1100dd00fe2ddf18163ad964d0b69f1f2e9658a\":\"0x143120955b2506b0000\",\"0xd116f3dcd5db744bd008887687aa0ec9fd7292aa\":\"0x3635c9adc5dea00000\",\"0xd119417c46732cf34d1a1afb79c3e7e2cd8eece4\":\"0x6c6b935b8bbd400000\",\"0xd12d77ae01a92d35117bac705aacd982d02e74c1\":\"0x3635c9adc5dea00000\",\"0xd135794b149a18e147d16e621a6931f0a40a969a\":\"0x43c33c1937564800000\",\"0xd1432538e35b7664956ae495a32abdf041a7a21c\":\"0x42bf06b78ed3b500000\",\"0xd1438267231704fc7280d563adf4763844a80722\":\"0xad78ebc5ac6200000\",\"0xd1538e9a87e59ca9ec8e5826a5b793f99f96c4c3\":\"0x3635c9adc5dea00000\",\"0xd1648503b1ccc5b8be03fa1ec4f3ee267e6adf7b\":\"0x13befbf51eec0900000\",\"0xd1682c2159018dc3d07f08240a8c606daf65f8e1\":\"0x2a5a058fc295ed000000\",\"0xd171c3f2258aef35e599c7da1aa07300234da9a6\":\"0x6c6b935b8bbd400000\",\"0xd1778c13fbd968bc083cb7d1024ffe1f49d02caa\":\"0xd9ecb4fd208e500000\",\"0xd17fbe22d90462ed37280670a2ea0b3086a0d6d6\":\"0xad6eedd17cf3b8000\",\"0xd1811c55976980f083901d8a0db269222dfb5cfe\":\"0x54069233bf7f780000\",\"0xd18eb9e1d285dabe93e5d4bae76beefe43b521e8\":\"0x243d4d18229ca20000\",\"0xd193e583d6070563e7b862b9614a47e99489f3e5\":\"0x36356633ebd8ea0000\",\"0xd1978f2e34407fab1dc2183d95cfda6260b35982\":\"0x2ab7b260ff3fd00000\",\"0xd19caf39bb377fdf2cf19bd4fb52591c2631a63c\":\"0x3635c9adc5dea00000\",\"0xd1a396dcdab2c7494130b3fd307820340dfd8c1f\":\"0xf92250e2dfd00000\",\"0xd1a71b2d0858e83270085d95a3b1549650035e23\":\"0x327bb09d06aa8500000\",\"0xd1acb5adc1183973258d6b8524ffa28ffeb23de3\":\"0xd8d726b7177a800000\",\"0xd1b37f03cb107424e9c4dd575ccd4f4cee57e6cd\":\"0x6c6b935b8bbd400000\",\"0xd1b5a454ac3405bb4179208c6c84de006bcb9be9\":\"0x1b1ae4d6e2ef500000\",\"0xd1c45954a62b911ad701ff2e90131e8ceb89c95c\":\"0x4b91a2de457e880000\",\"0xd1c96e70f05ae0e6cd6021b2083750a7717cde56\":\"0x1b1ae4d6e2ef500000\",\"0xd1d5b17ffe2d7bbb79cc7d7930bcb2e518fb1bbf\":\"0xa2a15d09519be00000\",\"0xd1da0c8fb7c210e0f2ec618f85bdae7d3e734b1c\":\"0x6acb3df27e1f880000\",\"0xd1dd79fb158160e5b4e8e23f312e6a907fbc4d4e\":\"0x1b1ae4d6e2ef500000\",\"0xd1de5aad3a5fd803f1b1aeb6103cb8e14fe723b7\":\"0x1158e460913d00000\",\"0xd1e1f2b9c16c309874dee7fac32675aff129c398\":\"0x3f24d8e4a00700000\",\"0xd1e5e234a9f44266a4a6241a84d7a1a55ad5a7fe\":\"0x43c33c1937564800000\",\"0xd1ea4d72a67b5b3e0f315559f52bd0614d713069\":\"0x6c6b935b8bbd400000\",\"0xd1ee905957fe7cc70ec8f2868b43fe47b13febff\":\"0x2629f66e0c5300000\",\"0xd1f1694d22671b5aad6a94995c369fbe6133676f\":\"0x3635c9adc5dea00000\",\"0xd1f4dc1ddb8abb8848a8b14e25f3b55a8591c266\":\"0xd8d726b7177a80000\",\"0xd1fed0aee6f5dfd7e25769254c3cfad15adeccaa\":\"0x2792c8fc4b53280000\",\"0xd2051cb3cb6704f0548cc890ab0a19db3415b42a\":\"0x121b2e5e6464780000\",\"0xd206aaddb336d45e7972e93cb075471d15897b5d\":\"0x2086ac351052600000\",\"0xd209482bb549abc4777bea6d7f650062c9c57a1c\":\"0x11651ac3e7a7580000\",\"0xd20dcb0b78682b94bc3000281448d557a20bfc83\":\"0x30849ebe16369c0000\",\"0xd2107b353726c3a2b46566eaa7d9f80b5d21dbe3\":\"0x1158e460913d00000\",\"0xd211b21f1b12b5096181590de07ef81a89537ead\":\"0x6c6b935b8bbd400000\",\"0xd218efb4db981cdd6a797f4bd48c7c26293ceb40\":\"0xa1466b31c6431c0000\",\"0xd21a7341eb84fd151054e5e387bb25d36e499c09\":\"0x2f6f10780d22cc00000\",\"0xd224f880f9479a89d32f09e52be990b288135cef\":\"0x3a9d5baa4abf1d00000\",\"0xd22f0ca4cd479e661775053bcc49e390f670dd8a\":\"0x3635c9adc5dea00000\",\"0xd231929735132102471ba59007b6644cc0c1de3e\":\"0x3637096c4bcc690000\",\"0xd235d15cb5eceebb61299e0e827fa82748911d89\":\"0xd8d726b7177a800000\",\"0xd23a24d7f9468343c143a41d73b88f7cbe63be5e\":\"0xad78ebc5ac6200000\",\"0xd23d7affacdc3e9f3dae7afcb4006f58f8a44600\":\"0xc328093e61ee400000\",\"0xd243184c801e5d79d2063f3578dbae81e7b3a9cb\":\"0x6bdca2681e1aba0000\",\"0xd24b6644f439c8051dfc64d381b8c86c75c17538\":\"0x6c6b935b8bbd400000\",\"0xd24bf12d2ddf457decb17874efde2052b65cbb49\":\"0x2f6f10780d22cc00000\",\"0xd251f903ae18727259eee841a189a1f569a5fd76\":\"0x21e19e0c9bab2400000\",\"0xd252960b0bf6b2848fdead80136db5f507f8be02\":\"0x6c6b935b8bbd400000\",\"0xd2581a55ce23ab10d8ad8c44378f59079bd6f658\":\"0x1dd0c885f9a0d800000\",\"0xd25aecd7eb8bd6345b063b5dbd271c77d3514494\":\"0x62a992e53a0af00000\",\"0xd27c234ff7accace3d996708f8f9b04970f97d36\":\"0x487a9a304539440000\",\"0xd28298524df5ec4b24b0ffb9df85170a145a9eb5\":\"0xf98a3b9b337e20000\",\"0xd283b8edb10a25528a4404de1c65e7410dbcaa67\":\"0x28a857425466f800000\",\"0xd284a50382f83a616d39b8a9c0f396e0ebbfa95d\":\"0x3636c25e66ece70000\",\"0xd288e7cb7ba9f620ab0f7452e508633d1c5aa276\":\"0xd8d726b7177a800000\",\"0xd29dc08efbb3d72e263f78ab7610d0226de76b00\":\"0x28a857425466f800000\",\"0xd2a030ac8952325f9e1db378a71485a24e1b07b2\":\"0x6c6b935b8bbd400000\",\"0xd2a479404347c5543aab292ae1bb4a6f158357fa\":\"0xd8d726b7177a800000\",\"0xd2a5a024230a57ccc666760b89b0e26cafd189c7\":\"0xa96595a5c6e8a3f8000\",\"0xd2a80327cbe55c4c7bd51ff9dde4ca648f9eb3f8\":\"0x2b5e3af16b1880000\",\"0xd2a84f75675c62d80c88756c428eee2bcb185421\":\"0x410d586a20a4c00000\",\"0xd2abd84a181093e5e229136f42d835e8235de109\":\"0x56be03ca3e47d8000\",\"0xd2ac0d3a58605e1d0f0eb3de25b2cad129ed6058\":\"0xd8d726b7177a800000\",\"0xd2bf67a7f3c6ce56b7be41675dbbadfe7ea93a33\":\"0x15af1d78b58c400000\",\"0xd2dbebe89b0357aea98bbe8e496338debb28e805\":\"0xd8d726b7177a800000\",\"0xd2e21ed56868fab28e0947927adaf29f23ebad6c\":\"0x6c184f1355d0e80000\",\"0xd2e817738abf1fb486583f80c350318bed860c80\":\"0xd02cecf5f5d810000\",\"0xd2edd1ddd6d86dc005baeb541d22b640d5c7cae5\":\"0x1158e460913d00000\",\"0xd2f1998e1cb1580cec4f6c047dcd3dcec54cf73c\":\"0xad78ebc5ac6200000\",\"0xd2f241255dd7c3f73c07043071ec08ddd9c5cde5\":\"0x1b1ae4d6e2ef500000\",\"0xd2ff672016f63b2f85398f4a6fedbb60a50d3cce\":\"0x1291246f5b734a0000\",\"0xd30d4c43adcf55b2cb53d68323264134498d89ce\":\"0x3635c9adc5dea00000\",\"0xd30ee9a12b4d68abace6baca9ad7bf5cd1faf91c\":\"0x514fcb24ff9c500000\",\"0xd3118ea3c83505a9d893bb67e2de142d537a3ee7\":\"0x1158e460913d00000\",\"0xd311bcd7aa4e9b4f383ff3d0d6b6e07e21e3705d\":\"0xad78ebc5ac6200000\",\"0xd315deea1d8c1271f9d1311263ab47c007afb6f5\":\"0x3c81d4e654b400000\",\"0xd32b2c79c36478c5431901f6d700b04dbe9b8810\":\"0x15779a9de6eeb00000\",\"0xd32b45564614516c91b07fa9f72dcf787cce4e1c\":\"0xfc66fae3746ac0000\",\"0xd330728131fe8e3a15487a34573c93457e2afe95\":\"0xd8d726b7177a800000\",\"0xd331c823825a9e5263d052d8915d4dcde07a5c37\":\"0x1e931283ccc8500000\",\"0xd333627445f2d787901ef33bb2a8a3675e27ffec\":\"0x15af1d78b58c400000\",\"0xd33cf82bf14c592640a08608914c237079d5be34\":\"0x6c6b935b8bbd400000\",\"0xd34d708d7398024533a5a2b2309b19d3c55171bb\":\"0x15af1d78b58c400000\",\"0xd34e03d36a2bd4d19a5fa16218d1d61e3ffa0b15\":\"0x1158e460913d000000\",\"0xd35075ca61fe59d123969c36a82d1ab2d918aa38\":\"0x90f534608a72880000\",\"0xd367009ab658263b62c2333a1c9e4140498e1389\":\"0x6c6b935b8bbd400000\",\"0xd3679a47df2d99a49b01c98d1c3e0c987ce1e158\":\"0xf2dc7d47f15600000\",\"0xd38fa2c4cc147ad06ad5a2f75579281f22a7cc1f\":\"0x43c33c1937564800000\",\"0xd39a5da460392b940b3c69bc03757bf3f2e82489\":\"0x17c83a97d6b6ca50000\",\"0xd39b7cbc94003fc948f0cde27b100db8ccd6e063\":\"0x15af1d78b58c400000\",\"0xd3a10ec7a5c9324999dd9e9b6bde7c911e584bda\":\"0x2086ac351052600000\",\"0xd3a941c961e8ca8b1070f23c6d6d0d2a758a4444\":\"0xad78ebc5ac6200000\",\"0xd3bb59fa31258be62f8ed232f1a7d47b4a0b41ee\":\"0x56bc75e2d63100000\",\"0xd3bc730937fa75d8452616ad1ef1fe7fffe0d0e7\":\"0x484e4ded2eae38000\",\"0xd3c24d4b3a5e0ff8a4622d518edd73f16ab28610\":\"0x1158e460913d00000\",\"0xd3c6f1e0f50ec3d2a67e6bcd193ec7ae38f1657f\":\"0x166c5480889db770000\",\"0xd3d6e9fb82542fd29ed9ea3609891e151396b6f7\":\"0xb6f588aa7bcf5c00000\",\"0xd3dad1b6d08d4581ccae65a8732db6ac69f0c69e\":\"0x14542ba12a337c00000\",\"0xd3df3b53cb3b4755de54e180451cc44c9e8ae0aa\":\"0x23c49409b977828000\",\"0xd3f873bd9956135789ab00ebc195b922e94b259d\":\"0x6c6b935b8bbd400000\",\"0xd402b4f6a099ebe716cb14df4f79c0cd01c6071b\":\"0x6c6b935b8bbd400000\",\"0xd40d0055fd9a38488aff923fd03d35ec46d711b3\":\"0x10f08eda8e555098000\",\"0xd40ed66ab3ceff24ca05ecd471efb492c15f5ffa\":\"0x1b1ae4d6e2ef500000\",\"0xd418870bc2e4fa7b8a6121ae0872d55247b62501\":\"0x55a6e79ccd1d300000\",\"0xd41d7fb49fe701baac257170426cc9b38ca3a9b2\":\"0x98a7d9b8314c00000\",\"0xd4205592844055b3c7a1f80cefe3b8eb509bcde7\":\"0x9b3bfd342a9fc8000\",\"0xd42b20bd0311608b66f8a6d15b2a95e6de27c5bf\":\"0x6c6b935b8bbd400000\",\"0xd4344f7d5cad65d17e5c2d0e7323943d6f62fe92\":\"0xe7eeba3410b740000\",\"0xd43ee438d83de9a37562bb4e286cb1bd19f4964d\":\"0x3635c9adc5dea00000\",\"0xd44334b4e23a169a0c16bd21e866bba52d970587\":\"0x8cf23f909c0fa00000\",\"0xd44d81e18f46e2cfb5c1fcf5041bc8569767d100\":\"0x7b442e684f65aa40000\",\"0xd44f4ac5fad76bdc1537a3b3af6472319b410d9d\":\"0x56bc75e2d631000000\",\"0xd44f5edf2bcf2433f211dadd0cc450db1b008e14\":\"0xe7eeba3410b740000\",\"0xd44f6ac3923b5fd731a4c45944ec4f7ec52a6ae4\":\"0x21e19e0c9bab2400000\",\"0xd45b3341e8f15c80329320c3977e3b90e7826a7e\":\"0x1b1ae4d6e2ef500000\",\"0xd45d5daa138dd1d374c71b9019916811f4b20a4e\":\"0x1f399b1438a1000000\",\"0xd460a4b908dd2b056759b488850b66a838fc77a8\":\"0x6acb3df27e1f880000\",\"0xd467cf064c0871989b90d8b2eb14ccc63b360823\":\"0xad78ebc5ac6200000\",\"0xd46bae61b027e5bb422e83a3f9c93f3c8fc77d27\":\"0x6c6b935b8bbd400000\",\"0xd46f8223452982a1eea019a8816efc2d6fc00768\":\"0x76d41c62494840000\",\"0xd475477fa56390d33017518d6711027f05f28dbf\":\"0x6b111333d4fd4c0000\",\"0xd47c242edffea091bc54d57df5d1fdb93101476c\":\"0x9df7dfa8f760480000\",\"0xd47d8685faee147c520fd986709175bf2f886bef\":\"0x6c6b935b8bbd400000\",\"0xd47f50df89a1cff96513bef1b2ae3a2971accf2c\":\"0x2d89577d7d40200000\",\"0xd482e7f68e41f238fe517829de15477fe0f6dd1d\":\"0x1b1ae4d6e2ef500000\",\"0xd4879fd12b1f3a27f7e109761b23ca343c48e3d8\":\"0x241a9b4f617a280000\",\"0xd48e3f9357e303513841b3f84bda83fc89727587\":\"0x3635c9adc5dea00000\",\"0xd49a75bb933fca1fca9aa1303a64b6cb44ea30e1\":\"0x21e19e0c9bab2400000\",\"0xd4b085fb086f3d0d68bf12926b1cc3142cae8770\":\"0xc893d09c8f51500000\",\"0xd4b2ff3bae1993ffea4d3b180231da439f7502a2\":\"0x6c6b935b8bbd400000\",\"0xd4b38a5fdb63e01714e9801db47bc990bd509183\":\"0x14534d95bef905c0000\",\"0xd4b8bdf3df9a51b0b91d16abbea05bb4783c8661\":\"0x3635c9adc5dea00000\",\"0xd4c4d1a7c3c74984f6857b2f5f07e8face68056d\":\"0x6c6b935b8bbd400000\",\"0xd4c6ac742e7c857d4a05a04c33d4d05c1467571d\":\"0xad78ebc5ac6200000\",\"0xd4cb21e590c5a0e06801366aff342c7d7db16424\":\"0x1ac7a08ead02f80000\",\"0xd4d92c62b280e00f626d8657f1b86166cb1f740f\":\"0xad7f23634cbd60000\",\"0xd4ebb1929a23871cf77fe049ab9602be08be0a73\":\"0x678a932062e4180000\",\"0xd4ee4919fb37f2bb970c3fff54aaf1f3dda6c03f\":\"0x878678326eac9000000\",\"0xd4feed99e8917c5c5458635f3603ecb7e817a7d0\":\"0x1043c43cde1d398000\",\"0xd4ff46203efa23064b1caf00516e28704a82a4f8\":\"0x487a9a304539440000\",\"0xd500e4d1c9824ba9f5b635cfa3a8c2c38bbd4ced\":\"0x15af1d78b58c400000\",\"0xd508d39c70916f6abc4cc7f999f011f077105802\":\"0x5724d24afe77f0000\",\"0xd50f7fa03e389876d3908b60a537a6706304fb56\":\"0x56bc75e2d63100000\",\"0xd513a45080ff2febe62cd5854abe29ee4467f996\":\"0x84e13bc4fc5d80000\",\"0xd5276f0cd5ffd5ffb63f98b5703d5594ede0838b\":\"0x15af1d78b58c400000\",\"0xd5294b666242303b6df0b1c88d37429bc8c965aa\":\"0x104d0d00d2b7f60000\",\"0xd52aecc6493938a28ca1c367b701c21598b6a02e\":\"0x3ba1910bf341b00000\",\"0xd53c567f0c3ff2e08b7d59e2b5c73485437fc58d\":\"0x2086ac351052600000\",\"0xd541ac187ad7e090522de6da3213e9a7f4439673\":\"0x6c6b935b8bbd400000\",\"0xd54ba2d85681dc130e5b9b02c4e8c851391fd9b9\":\"0xd5967be4fc3f100000\",\"0xd55508adbbbe9be81b80f97a6ea89add68da674f\":\"0x6c6b935b8bbd400000\",\"0xd5550caaf743b037c56fd2558a1c8ed235130750\":\"0x121e4d49036255b0000\",\"0xd5586da4e59583c8d86cccf71a86197f17996749\":\"0x6c6b935b8bbd400000\",\"0xd55c1c8dfbe1e02cacbca60fdbdd405b09f0b75f\":\"0x6c6b935b8bbd400000\",\"0xd561cbbc05515de73ab8cf9eae1357341e7dfdf4\":\"0x14542ba12a337c00000\",\"0xd56a144d7af0ae8df649abae535a15983aa04d02\":\"0x10f0cf064dd59200000\",\"0xd572309169b1402ec8131a17a6aac3222f89e6eb\":\"0x2ec1978c47766a00000\",\"0xd5787668c2c5175b01a8ee1ac3ecc9c8b2aba95a\":\"0x6c6acc67d7b1d40000\",\"0xd588c3a5df228185d98ee7e60748255cdea68b01\":\"0xd8d726b7177a800000\",\"0xd58a52e078a805596b0d56ea4ae1335af01c66eb\":\"0xe7eeba3410b740000\",\"0xd5903e9978ee20a38c3f498d63d57f31a39f6a06\":\"0x232b36ffc672ab00000\",\"0xd59638d3c5faa7711bf085745f9d5bdc23d498d8\":\"0x6c6b935b8bbd400000\",\"0xd59d92d2c8701980cc073c375d720af064743c0c\":\"0x405fdf7e5af85e00000\",\"0xd5a7bec332adde18b3104b5792546aa59b879b52\":\"0x6c6b935b8bbd400000\",\"0xd5b117ec116eb846418961eb7edb629cd0dd697f\":\"0xa2a15d09519be00000\",\"0xd5b284040130abf7c1d163712371cc7e28ad66da\":\"0x6acb3df27e1f880000\",\"0xd5b9d277d8aad20697a51f76e20978996bffe055\":\"0x7c3fe3c076ab50000\",\"0xd5bd5e8455c130169357c471e3e681b7996a7276\":\"0x2d9e288f8abb360000\",\"0xd5cba5b26bea5d73fabb1abafacdef85def368cc\":\"0xad78ebc5ac6200000\",\"0xd5ce55d1b62f59433c2126bcec09bafc9dfaa514\":\"0xaadec983fcff40000\",\"0xd5e55100fbd1956bbed2ca518d4b1fa376032b0b\":\"0x56bc75e2d63100000\",\"0xd5e5c135d0c4c3303934711993d0d16ff9e7baa0\":\"0x6c6b935b8bbd400000\",\"0xd5e656a1b916f9bf45afb07dd8afaf73b4c56f41\":\"0x542253a126ce40000\",\"0xd5ea472cb9466018110af00c37495b5c2c713112\":\"0x10eee686c854f440000\",\"0xd5f07552b5c693c20067b378b809cee853b8f136\":\"0x1b67c6df88c6fa0000\",\"0xd5f7c41e07729dfa6dfc64c4423160a22c609fd3\":\"0x61093d7c2c6d380000\",\"0xd604abce4330842e3d396ca73ddb5519ed3ec03f\":\"0x8e31fe1689d8a0000\",\"0xd60651e393783423e5cc1bc5f889e44ef7ea243e\":\"0x159e76371129c80000\",\"0xd609bf4f146eea6b0dc8e06ddcf4448a1fccc9fa\":\"0x6c6b935b8bbd400000\",\"0xd609ec0be70d0ad26f6e67c9d4762b52ee51122c\":\"0x3635c9adc5dea00000\",\"0xd60a52580728520df7546bc1e283291788dbae0c\":\"0x363489ef3ff0d70000\",\"0xd60b247321a32a5affb96b1e279927cc584de943\":\"0x7ad020d6ddd7760000\",\"0xd6110276cfe31e42825a577f6b435dbcc10cf764\":\"0x3635c9adc5dea00000\",\"0xd612597bc31743c78633f633f239b1e9426bd925\":\"0x1017f7df96be17800000\",\"0xd6234aaf45c6f22e66a225ffb93add629b4ef80f\":\"0x3635c9adc5dea00000\",\"0xd62edb96fce2969aaf6c545e967cf1c0bc805205\":\"0x4a565536a5ada8000\",\"0xd6300b3215b11de762ecde4b70b7927d01291582\":\"0x6c6b935b8bbd400000\",\"0xd6395db5a4bb66e60f4cfbcdf0057bb4d97862e2\":\"0x3154c9729d05780000\",\"0xd64a2d50f8858537188a24e0f50df1681ab07ed7\":\"0x8375a2abcca24400000\",\"0xd6580ab5ed4c7dfa506fa6fe64ad5ce129707732\":\"0xd8d726b7177a800000\",\"0xd6598b1386e93c5ccb9602ff4bbbecdbd3701dc4\":\"0xc25f4ecb041f00000\",\"0xd6644d40e90bc97fe7dfe7cabd3269fd579ba4b3\":\"0x89e917994f71c0000\",\"0xd6670c036df754be43dadd8f50feea289d061fd6\":\"0x144a2903448cef78000\",\"0xd668523a90f0293d65c538d2dd6c57673710196e\":\"0x2242c30b853ee0000\",\"0xd66ab79294074c8b627d842dab41e17dd70c5de5\":\"0x3635c9adc5dea00000\",\"0xd66acc0d11b689cea6d9ea5ff4014c224a5dc7c4\":\"0xfc936392801c0000\",\"0xd66ddf1159cf22fd8c7a4bc8d5807756d433c43e\":\"0x77432217e683600000\",\"0xd687cec0059087fdc713d4d2d65e77daefedc15f\":\"0x340aad21b3b700000\",\"0xd688e785c98f00f84b3aa1533355c7a258e87948\":\"0x1b1ae4d6e2ef500000\",\"0xd6a22e598dabd38ea6e958bd79d48ddd9604f4df\":\"0x3635c9adc5dea00000\",\"0xd6a7ac4de7b510f0e8de519d973fa4c01ba83400\":\"0x65ea3db75546600000\",\"0xd6acc220ba2e51dfcf21d443361eea765cbd35d8\":\"0x1158e460913d00000\",\"0xd6acffd0bfd99c382e7bd56ff0e6144a9e52b08e\":\"0x8ac7230489e800000\",\"0xd6c0d0bc93a62e257174700e10f024c8b23f1f87\":\"0x6c6b935b8bbd400000\",\"0xd6cf5c1bcf9da662bcea2255905099f9d6e84dcc\":\"0x1c49e420157d9c20000\",\"0xd6d03572a45245dbd4368c4f82c95714bd2167e2\":\"0x3f00c3d66686fc0000\",\"0xd6d6776958ee23143a81adadeb08382009e996c2\":\"0xa2a15d09519be00000\",\"0xd6d9e30f0842012a7176a917d9d2048ca0738759\":\"0xd8d726b7177a800000\",\"0xd6e09e98fe1300332104c1ca34fbfac554364ed9\":\"0x6c6b935b8bbd400000\",\"0xd6e8e97ae9839b9ee507eedb28edfb7477031439\":\"0x6c6b935b8bbd400000\",\"0xd6eea898d4ae2b718027a19ce9a5eb7300abe3ca\":\"0x17d4aceee63db8000\",\"0xd6f1e55b1694089ebcb4fe7d7882aa66c8976176\":\"0x43c23bdbe929db30000\",\"0xd6f4a7d04e8faf20e8c6eb859cf7f78dd23d7a15\":\"0x724ded1c748140000\",\"0xd6fc0446c6a8d40ae3551db7e701d1fa876e4a49\":\"0x6c6b935b8bbd400000\",\"0xd703c6a4f11d60194579d58c2766a7ef16c30a29\":\"0x6c6b935b8bbd400000\",\"0xd7052519756af42590f15391b723a03fa564a951\":\"0xfa3631480d01fd8000\",\"0xd70a612bd6dda9eab0dddcff4aaf4122d38feae4\":\"0x1d460162f516f00000\",\"0xd70ad2c4e9eebfa637ef56bd486ad2a1e5bce093\":\"0xad78ebc5ac6200000\",\"0xd7140c8e5a4307fab0cc27badd9295018bf87970\":\"0x5f1016b5076d00000\",\"0xd7164aa261c09ad9b2b5068d453ed8eb6aa13083\":\"0xa2a15d09519be00000\",\"0xd71e43a45177ad51cbe0f72184a5cb503917285a\":\"0xad78ebc5ac6200000\",\"0xd71fb130f0150c565269e00efb43902b52a455a6\":\"0xad78ebc5ac6200000\",\"0xd7225738dcf3578438f8e7c8b3837e42e04a262f\":\"0x182b8cebbb83aa0000\",\"0xd7274d50804d9c77da93fa480156efe57ba501de\":\"0x692ae8897081d00000\",\"0xd731bb6b5f3c37395e09ceaccd14a918a6060789\":\"0xd5967be4fc3f100000\",\"0xd73ed2d985b5f21b55b274643bc6da031d8edd8d\":\"0xa6dd90cae5114480000\",\"0xd744ac7e5310be696a63b003c40bd039370561c6\":\"0x5a87e7d7f5f6580000\",\"0xd74a6e8d6aab34ce85976814c1327bd6ea0784d2\":\"0x152d02c7e14af6800000\",\"0xd75a502a5b677287470f65c5aa51b87c10150572\":\"0x3130b4646385740000\",\"0xd76dbaebc30d4ef67b03e6e6ecc6d84e004d502d\":\"0x6d76b9188e13850000\",\"0xd771d9e0ca8a08a113775731434eb3270599c40d\":\"0x1158e460913d00000\",\"0xd7788ef28658aa06cc53e1f3f0de58e5c371be78\":\"0x16a6502f15a1e540000\",\"0xd77892e2273b235d7689e430e7aeed9cbce8a1f3\":\"0x6c6b935b8bbd400000\",\"0xd781f7fc09184611568570b4986e2c72872b7ed0\":\"0x1159561065d5d0000\",\"0xd785a8f18c38b9bc4ffb9b8fa8c7727bd642ee1c\":\"0x3635c9adc5dea00000\",\"0xd78ecd25adc86bc2051d96f65364866b42a426b7\":\"0xd23058bf2f26120000\",\"0xd78f84e38944a0e0255faece48ba4950d4bd39d2\":\"0x10f0cf064dd59200000\",\"0xd79483f6a8444f2549d611afe02c432d15e11051\":\"0x1158e460913d00000\",\"0xd79835e404fb86bf845fba090d6ba25e0c8866a6\":\"0x821ab0d44149800000\",\"0xd79aff13ba2da75d46240cac0a2467c656949823\":\"0x5dc892aa1131c80000\",\"0xd79db5ab43621a7a3da795e58929f3dd25af67d9\":\"0x6c6acc67d7b1d40000\",\"0xd7a1431ee453d1e49a0550d1256879b4f5d10201\":\"0x5a87e7d7f5f6580000\",\"0xd7ad09c6d32657685355b5c6ec8e9f57b4ebb982\":\"0x6acb3df27e1f880000\",\"0xd7b740dff8c457668fdf74f6a266bfc1dcb723f9\":\"0x1158e460913d00000\",\"0xd7c2803ed7b0e0837351411a8e6637d168bc5b05\":\"0x641daf5c91bd9358000\",\"0xd7c6265dea11876c903b718e4cd8ab24fe265bde\":\"0x6c6b935b8bbd400000\",\"0xd7ca7fdcfebe4588eff5421d1522b61328df7bf3\":\"0xd8e6001e6c302b0000\",\"0xd7cdbd41fff20df727c70b6255c1ba7606055468\":\"0xad78ebc5ac6200000\",\"0xd7d157e4c0a96437a6d285741dd23ec4361fa36b\":\"0x6c6b935b8bbd400000\",\"0xd7d2c6fca8ad1f75395210b57de5dfd673933909\":\"0x126e72a69a50d00000\",\"0xd7d3c75920590438b82c3e9515be2eb6ed7a8b1a\":\"0xcb49b44ba602d800000\",\"0xd7d7f2caa462a41b3b30a34aeb3ba61010e2626f\":\"0x6c6b935b8bbd400000\",\"0xd7e74afdbad55e96cebc5a374f2c8b768680f2b0\":\"0x55de6a779bbac0000\",\"0xd7eb903162271c1afa35fe69e37322c8a4d29b11\":\"0x21e19e0c9bab2400000\",\"0xd7ebddb9f93987779b680155375438db65afcb6a\":\"0x5741afeff944c0000\",\"0xd7ef340e66b0d7afcce20a19cb7bfc81da33d94e\":\"0xa2a15d09519be00000\",\"0xd7f370d4bed9d57c6f49c999de729ee569d3f4e4\":\"0xad78ebc5ac6200000\",\"0xd7fa5ffb6048f96fb1aba09ef87b1c11dd7005e4\":\"0x3635c9adc5dea00000\",\"0xd8069f84b521493f4715037f3226b25f33b60586\":\"0x678a932062e4180000\",\"0xd815e1d9f4e2b5e57e34826b7cfd8881b8546890\":\"0xf015f25736420000\",\"0xd81bd54ba2c44a6f6beb1561d68b80b5444e6dc6\":\"0x3f170d7ee43c430000\",\"0xd82251456dc1380f8f5692f962828640ab9f2a03\":\"0x1088b53b2c202be0000\",\"0xd82c6fedbdac98af2eed10b00f32b00056ca5a6d\":\"0xad78ebc5ac6200000\",\"0xd82fd9fdf6996bedad2843159c06f37e0924337d\":\"0x5b8ccedc5aa7b00000\",\"0xd83ad260e9a6f432fb6ea28743299b4a09ad658c\":\"0x6c6b935b8bbd400000\",\"0xd843ee0863ce933e22f89c802d31287b9671e81c\":\"0xb98bc829a6f90000\",\"0xd84b922f7841fc5774f00e14604ae0df42c8551e\":\"0xd96fce90cfabcc0000\",\"0xd855b03ccb029a7747b1f07303e0a664793539c8\":\"0x6c6b935b8bbd400000\",\"0xd85fdeaf2a61f95db902f9b5a53c9b8f9266c3ac\":\"0x6cf65a7e9047280000\",\"0xd8715ef9176f850b2e30eb8e382707f777a6fbe9\":\"0x6c6b935b8bbd400000\",\"0xd874b9dfae456a929ba3b1a27e572c9b2cecdfb3\":\"0x93739534d28680000\",\"0xd8930a39c77357c30ad3a060f00b06046331fd62\":\"0x2c73c937742c500000\",\"0xd89bc271b27ba3ab6962c94a559006ae38d5f56a\":\"0x6c6b935b8bbd400000\",\"0xd8b77db9b81bbe90427b62f702b201ffc29ff618\":\"0x326d1e4396d45c0000\",\"0xd8cd64e0284eec53aa4639afc4750810b97fab56\":\"0x1158e460913d00000\",\"0xd8d64384249b776794063b569878d5e3b530a4b2\":\"0x9a043d0b2f9568000\",\"0xd8d65420c18c2327cc5af97425f857e4a9fd51b3\":\"0x5f68e8131ecf800000\",\"0xd8e5c9675ef4deed266b86956fc4590ea7d4a27d\":\"0x3635c9adc5dea00000\",\"0xd8e8474292e7a051604ca164c0707783bb2885e8\":\"0x2d4ca05e2b43ca80000\",\"0xd8eb78503ec31a54a90136781ae109004c743257\":\"0x3635c9adc5dea00000\",\"0xd8eef4cf4beb01ee20d111748b61cb4d3f641a01\":\"0x9489237adb9a500000\",\"0xd8f4bae6f84d910d6d7d5ac914b1e68372f94135\":\"0x56bc75e2d63100000\",\"0xd8f62036f03b7635b858f1103f8a1d9019a892b6\":\"0x2b5e3af16b1880000\",\"0xd8f665fd8cd5c2bcc6ddc0a8ae521e4dc6aa6060\":\"0x5c283d410394100000\",\"0xd8f9240c55cff035523c6d5bd300d370dc8f0c95\":\"0xf732b66015a540000\",\"0xd8f94579496725b5cb53d7985c989749aff849c0\":\"0x39992648a23c8a00000\",\"0xd8fdf546674738c984d8fab857880b3e4280c09e\":\"0x1158e460913d00000\",\"0xd8fe088fffce948f5137ee23b01d959e84ac4223\":\"0xc5b54a94fc0170000\",\"0xd90f3009db437e4e11c780bec8896f738d65ef0d\":\"0xd8d726b7177a800000\",\"0xd9103bb6b67a55a7fece2d1af62d457c2178946d\":\"0x3635c9adc5dea00000\",\"0xd913f0771949753c4726acaa2bd3619c5c20ff77\":\"0xa2a15d09519be00000\",\"0xd91d889164479ce436ece51763e22cda19b22d6b\":\"0xb66d88126800880000\",\"0xd929c65d69d5bbaea59762662ef418bc21ad924a\":\"0x3635c9adc5dea00000\",\"0xd930b27a78876485d0f48b70dd5336549679ca8f\":\"0x22b1c8c1227a00000\",\"0xd931ac2668ba6a84481ab139735aec14b7bfbabf\":\"0x6c6b935b8bbd400000\",\"0xd9383d4b6d17b3f9cd426e10fb944015c0d44bfb\":\"0x2b5e3af16b18800000\",\"0xd942de4784f7a48716c0fd4b9d54a6e54c5f2f3e\":\"0x43c33c1937564800000\",\"0xd944c8a69ff2ca1249690c1229c7192f36251062\":\"0x6acb3df27e1f880000\",\"0xd94a57882a52739bbe2a0647c80c24f58a2b4f1c\":\"0x48b54e2adbe12b0000\",\"0xd95342953c8a21e8b635eefac7819bea30f17047\":\"0x13f06c7ffef05d400000\",\"0xd95c90ffbe5484864780b867494a83c89256d6e4\":\"0x58e7926ee858a00000\",\"0xd96711540e2e998343d4f590b6fc8fac3bb8b31d\":\"0x5f5a4068b71cb00000\",\"0xd96ac2507409c7a383ab2eee1822a5d738b36b56\":\"0xad78ebc5ac6200000\",\"0xd96db33b7b5a950c3efa2dc31b10ba10a532ef87\":\"0x6c6b935b8bbd400000\",\"0xd9775965b716476675a8d513eb14bbf7b07cd14a\":\"0x1132e6d2d23c5e40000\",\"0xd97bc84abd47c05bbf457b2ef659d61ca5e5e48f\":\"0x69d17119dc5a80000\",\"0xd97f4526dea9b163f8e8e33a6bcf92fb907de6ec\":\"0xf654aaf4db2f00000\",\"0xd97fe6f53f2a58f6d76d752adf74a8a2c18e9074\":\"0x10cdf9b69a43570000\",\"0xd99999a2490d9494a530cae4daf38554f4dd633e\":\"0x68155a43676e00000\",\"0xd99df7421b9382e42c89b006c7f087702a0757c0\":\"0x1a055690d9db800000\",\"0xd9b783d31d32adc50fa3eacaa15d92b568eaeb47\":\"0x733af90374c1b280000\",\"0xd9d370fec63576ab15b318bf9e58364dc2a3552a\":\"0x56bc75e2d63100000\",\"0xd9d42fd13ebd4bf69cac5e9c7e82483ab46dd7e9\":\"0x121ea68c114e5100000\",\"0xd9e27eb07dfc71a706060c7f079238ca93e88539\":\"0x3635c9adc5dea00000\",\"0xd9e3857efd1e202a441770a777a49dcc45e2e0d3\":\"0xc1daf81d8a3ce0000\",\"0xd9ec2efe99ff5cf00d03a8317b92a24aef441f7e\":\"0x6c6b935b8bbd400000\",\"0xd9ec8fe69b7716c0865af888a11b2b12f720ed33\":\"0xd8d726b7177a800000\",\"0xd9f1b26408f0ec67ad1d0d6fe22e8515e1740624\":\"0x14d1120d7b1600000\",\"0xd9f547f2c1de0ed98a53d161df57635dd21a00bd\":\"0x556f64c1fe7fa0000\",\"0xd9ff115d01266c9f73b063c1c238ef3565e63b36\":\"0x24dce54d34a1a00000\",\"0xda06044e293c652c467fe74146bf185b21338a1c\":\"0x3635c9adc5dea00000\",\"0xda0b48e489d302b4b7bf204f957c1c9be383b0df\":\"0x6c6b935b8bbd400000\",\"0xda0d4b7ef91fb55ad265f251142067f10376ced6\":\"0x43c33c1937564800000\",\"0xda10978a39a46ff0bb848cf65dd9c77509a6d70e\":\"0x6c6b935b8bbd400000\",\"0xda16dd5c3d1a2714358fe3752cae53dbab2be98c\":\"0x41bad155e6512200000\",\"0xda214c023e2326ff696c00393168ce46ffac39ec\":\"0x3635c9adc5dea00000\",\"0xda2a14f9724015d79014ed8e5909681d596148f1\":\"0x2a10f0f8a91ab8000\",\"0xda2ad58e77deddede2187646c465945a8dc3f641\":\"0x23c757072b8dd00000\",\"0xda3017c150dd0dce7fcf881b0a48d0d1c756c4c7\":\"0x56bf91b1a65eb0000\",\"0xda34b2eae30bafe8daeccde819a794cd89e09549\":\"0x6c6b935b8bbd400000\",\"0xda4a5f557f3bab390a92f49b9b900af30c46ae80\":\"0x21e19e0c9bab2400000\",\"0xda505537537ffb33c415fec64e69bae090c5f60f\":\"0x8ac7230489e800000\",\"0xda698d64c65c7f2b2c7253059cd3d181d899b6b7\":\"0x1004e2e45fb7ee0000\",\"0xda7732f02f2e272eaf28df972ecc0ddeed9cf498\":\"0xb20bfbf6967890000\",\"0xda7ad025ebde25d22243cb830ea1d3f64a566323\":\"0x1b1ae4d6e2ef500000\",\"0xda855d53477f505ec4c8d5e8bb9180d38681119c\":\"0x12f939c99edab800000\",\"0xda875e4e2f3cabe4f37e0eaed7d1f6dcc6ffef43\":\"0x6c6b935b8bbd400000\",\"0xda8bbee182e455d2098acb338a6d45b4b17ed8b6\":\"0x6c6b935b8bbd400000\",\"0xda982e9643ffece723075a40fe776e5ace04b29b\":\"0x8b8b6c9999bf20000\",\"0xda9f55460946d7bfb570ddec757ca5773b58429a\":\"0x1b845d769eb4480000\",\"0xdaa1bd7a9148fb865cd612dd35f162861d0f3bdc\":\"0xa638ab72d92c138000\",\"0xdaa63cbda45dd487a3f1cd4a746a01bb5e060b90\":\"0x10416d9b02a89240000\",\"0xdaa776a6754469d7b9267a89b86725e740da0fa0\":\"0x6acb3df27e1f880000\",\"0xdaac91c1e859d5e57ed3084b50200f9766e2c52b\":\"0x15af1d78b58c400000\",\"0xdaacdaf42226d15cb1cf98fa15048c7f4ceefe69\":\"0x1043561a8829300000\",\"0xdab6bcdb83cf24a0ae1cb21b3b5b83c2f3824927\":\"0xa968163f0a57b400000\",\"0xdabb0889fc042926b05ef57b2520910abc4b4149\":\"0x6c6b935b8bbd400000\",\"0xdabc225042a6592cfa13ebe54efa41040878a5a2\":\"0xe11fad5d85ca30000\",\"0xdac0c177f11c5c3e3e78f2efd663d13221488574\":\"0x3635c9adc5dea00000\",\"0xdad136b88178b4837a6c780feba226b98569a94c\":\"0xad78ebc5ac6200000\",\"0xdadbfafd8b62b92a24efd75256dd83abdbd7bbdb\":\"0x11164759ffb320000\",\"0xdadc00ab7927603c2fcf31cee352f80e6c4d6351\":\"0x6c66e9a55378b80000\",\"0xdae0d33eaa341569fa9ff5982684854a4a328a6e\":\"0x3635c9adc5dea00000\",\"0xdae7201eab8c063302930d693929d07f95e71962\":\"0x91aec028b419810000\",\"0xdaedd4ad107b271e89486cbf80ebd621dd974578\":\"0x6c6b935b8bbd400000\",\"0xdb04fad9c49f9e880beb8fcf1d3a3890e4b3846f\":\"0x435ae6cc0c58e50000\",\"0xdb0cc78f74d9827bdc8a6473276eb84fdc976212\":\"0x6c6b935b8bbd400000\",\"0xdb1293a506e90cad2a59e1b8561f5e66961a6788\":\"0x6c6b935b8bbd400000\",\"0xdb19a3982230368f0177219cb10cb259cdb2257c\":\"0x6c6b935b8bbd400000\",\"0xdb23a6fef1af7b581e772cf91882deb2516fc0a7\":\"0xad78ebc5ac6200000\",\"0xdb244f97d9c44b158a40ed9606d9f7bd38913331\":\"0x58788cb94b1d80000\",\"0xdb288f80ffe232c2ba47cc94c763cf6fc9b82b0d\":\"0x49b9ca9a694340000\",\"0xdb2a0c9ab64df58ddfb1dbacf8ba0d89c85b31b4\":\"0xd8d726b7177a800000\",\"0xdb34745ede8576b499db01beb7c1ecda85cf4abe\":\"0x4563918244f400000\",\"0xdb3f258ab2a3c2cf339c4499f75a4bd1d3472e9e\":\"0x5150ae84a8cdf00000\",\"0xdb4bc83b0e6baadb1156c5cf06e0f721808c52c7\":\"0x2fb474098f67c00000\",\"0xdb63122de7037da4971531fae9af85867886c692\":\"0xf0425b0641f340000\",\"0xdb6c2a73dac7424ab0d031b66761122566c01043\":\"0xa2a15d09519be00000\",\"0xdb6e560c9bc620d4bea3a94d47f7880bf47f2d5f\":\"0x4da0fdfcf05760000\",\"0xdb6ff71b3db0928f839e05a7323bfb57d29c87aa\":\"0x3154c9729d05780000\",\"0xdb73460b59d8e85045d5e752e62559875e42502e\":\"0x36330322d5238c0000\",\"0xdb77b88dcb712fd17ee91a5b94748d720c90a994\":\"0x6c6b935b8bbd400000\",\"0xdb7d4037081f6c65f9476b0687d97f1e044d0a1d\":\"0x23c757072b8dd00000\",\"0xdb882eacedd0eff263511b312adbbc59c6b8b25b\":\"0x1ed4fde7a2236b00000\",\"0xdb9371b30c4c844e59e03e924be606a938d1d310\":\"0x6c6b935b8bbd400000\",\"0xdba4796d0ceb4d3a836b84c96f910afc103f5ba0\":\"0x908f493f737410000\",\"0xdbadc61ed5f0460a7f18e51b2fb2614d9264a0e0\":\"0x22b1c8c1227a00000\",\"0xdbb6ac484027041642bbfd8d80f9d0c1cf33c1eb\":\"0x6c6b935b8bbd400000\",\"0xdbbcbb79bf479a42ad71dbcab77b5adfaa872c58\":\"0x5dc892aa1131c80000\",\"0xdbc1ce0e49b1a705d22e2037aec878ee0d75c703\":\"0xd8d726b7177a80000\",\"0xdbc1d0ee2bab531140de137722cd36bdb4e47194\":\"0xad78ebc5ac6200000\",\"0xdbc59ed88973dead310884223af49763c05030f1\":\"0x1158e460913d00000\",\"0xdbc66965e426ff1ac87ad6eb78c1d95271158f9f\":\"0xfc936392801c0000\",\"0xdbcbcd7a57ea9db2349b878af34b1ad642a7f1d1\":\"0xad78ebc5ac6200000\",\"0xdbd51cdf2c3bfacdff106221de2e19ad6d420414\":\"0x5f68e8131ecf800000\",\"0xdbd71efa4b93c889e76593de609c3b04cbafbe08\":\"0x1158e460913d00000\",\"0xdbf5f061a0f48e5e69618739a77d2ec19768d201\":\"0x83d6c7aab63600000\",\"0xdbf8b13967f55125272de0562536c450ba5655a0\":\"0x6ef578f06e0ccb0000\",\"0xdbfb1bb464b8a58e500d2ed8de972c45f5f1c0fb\":\"0x56bc75e2d631000000\",\"0xdc067ed3e12d711ed475f5156ef7e71a80d934b9\":\"0x205b4dfa1ee74780000\",\"0xdc087f9390fb9e976ac23ab689544a0942ec2021\":\"0x62a992e53a0af00000\",\"0xdc1eb9b6e64351f56424509645f83e79eee76cf4\":\"0xd8d726b7177a800000\",\"0xdc1f1979615f082140b8bb78c67b27a1942713b1\":\"0x340aad21b3b700000\",\"0xdc23b260fcc26e7d10f4bd044af794579460d9da\":\"0x1b1b6bd7af64c70000\",\"0xdc29119745d2337320da51e19100c948d980b915\":\"0x8ac7230489e800000\",\"0xdc2d15a69f6bb33b246aef40450751c2f6756ad2\":\"0x6c341080bd1fb00000\",\"0xdc3dae59ed0fe18b58511e6fe2fb69b219689423\":\"0x56bc75e2d63100000\",\"0xdc3f0e7672f71fe7525ba30b9755183a20b9166a\":\"0x2089cf57b5b3e968000\",\"0xdc4345d6812e870ae90c568c67d2c567cfb4f03c\":\"0x16b352da5e0ed300000\",\"0xdc44275b1715baea1b0345735a29ac42c9f51b4f\":\"0x3f19beb8dd1ab00000\",\"0xdc46c13325cd8edf0230d068896486f007bf4ef1\":\"0x487a9a304539440000\",\"0xdc51b2dc9d247a1d0e5bc36ca3156f7af21ff9f6\":\"0x3635c9adc5dea00000\",\"0xdc5305b4020a06b49d657c7ca34c35c91c5f2c56\":\"0x17df6c10dbeba970000\",\"0xdc57345b38e0f067c9a31d9deac5275a10949321\":\"0xad78ebc5ac6200000\",\"0xdc57477dafa42f705c7fe40eae9c81756e0225f1\":\"0x1b1b8128a7416e0000\",\"0xdc5f5ad663a6f263327d64cac9cb133d2c960597\":\"0x6c6b935b8bbd400000\",\"0xdc703a5f3794c84d6cb3544918cae14a35c3bd4f\":\"0x6449e84e47a8a80000\",\"0xdc738fb217cead2f69594c08170de1af10c419e3\":\"0x152d02c7e14af6800000\",\"0xdc76e85ba50b9b31ec1e2620bce6e7c8058c0eaf\":\"0x1158e460913d00000\",\"0xdc83b6fd0d512131204707eaf72ea0c8c9bef976\":\"0x6c6b935b8bbd400000\",\"0xdc8c2912f084a6d184aa73638513ccbc326e0102\":\"0x4633bc36cbc2dc0000\",\"0xdc911cf7dc5dd0813656670528e9338e67034786\":\"0x6c6b935b8bbd400000\",\"0xdcb03bfa6c1131234e56b7ea7c4f721487546b7a\":\"0x487a9a304539440000\",\"0xdcb64df43758c7cf974fa660484fbb718f8c67c1\":\"0x43c33c1937564800000\",\"0xdcc52d8f8d9fc742a8b82767f0555387c563efff\":\"0x1b1ae4d6e2ef500000\",\"0xdccb370ed68aa922283043ef7cad1b9d403fc34a\":\"0xd8d726b7177a800000\",\"0xdccca42045ec3e16508b603fd936e7fd7de5f36a\":\"0x11164759ffb320000\",\"0xdcd10c55bb854f754434f1219c2c9a98ace79f03\":\"0xd8d8583fa2d52f0000\",\"0xdcd5bca2005395b675fde5035659b26bfefc49ee\":\"0xaadec983fcff40000\",\"0xdcdbbd4e2604e40e1710cc6730289dccfad3892d\":\"0xf95dd2ec27cce00000\",\"0xdce30c31f3ca66721ecb213c809aab561d9b52e4\":\"0x6c6b935b8bbd400000\",\"0xdcf33965531380163168fc11f67e89c6f1bc178a\":\"0x122776853406b08000\",\"0xdcf6b657266e91a4dae6033ddac15332dd8d2b34\":\"0x5f68e8131ecf800000\",\"0xdcf9719be87c6f46756db4891db9b611d2469c50\":\"0x3635c9adc5dea00000\",\"0xdcfff3e8d23c2a34b56bd1b3bd45c79374432239\":\"0x10f0cf064dd59200000\",\"0xdd04eee74e0bf30c3f8d6c2c7f52e0519210df93\":\"0x4563918244f400000\",\"0xdd26b429fd43d84ec179825324bad5bfb916b360\":\"0x116bf95bc8432980000\",\"0xdd2a233adede66fe1126d6c16823b62a021feddb\":\"0x6c6b935b8bbd400000\",\"0xdd2bdfa917c1f310e6fa35aa8af16939c233cd7d\":\"0x15af1d78b58c400000\",\"0xdd35cfdbcb993395537aecc9f59085a8d5ddb6f5\":\"0x3635c9adc5dea00000\",\"0xdd47189a3e64397167f0620e484565b762bfbbf4\":\"0x6449e84e47a8a80000\",\"0xdd4dd6d36033b0636fcc8d0938609f4dd64f4a86\":\"0x340aad21b3b700000\",\"0xdd4f5fa2111db68f6bde3589b63029395b69a92d\":\"0x8963dd8c2c5e00000\",\"0xdd63042f25ed32884ad26e3ad959eb94ea36bf67\":\"0x484d7fde7d593f00000\",\"0xdd65f6e17163b5d203641f51cc7b24b00f02c8fb\":\"0xad78ebc5ac6200000\",\"0xdd6c062193eac23d2fdbf997d5063a346bb3b470\":\"0x1158e460913d00000\",\"0xdd7bcda65924aaa49b80984ae173750258b92847\":\"0x21e19e0c9bab2400000\",\"0xdd7ff441ba6ffe3671f3c0dabbff1823a5043370\":\"0x6c6b935b8bbd400000\",\"0xdd8254121a6e942fc90828f2431f511dad7f32e6\":\"0xa39b29e1f360e80000\",\"0xdd8af9e7765223f4446f44d3d509819a3d3db411\":\"0x21e19e0c9bab2400000\",\"0xdd95dbe30f1f1877c5dd7684aeef302ab6885192\":\"0x1c5d8d6eb3e32500000\",\"0xdd967c4c5f8ae47e266fb416aad1964ee3e7e8c3\":\"0x1a420db02bd7d580000\",\"0xdd9b485a3b1cd33a6a9c62f1e5bee92701856d25\":\"0xc3383ed031b7e8000\",\"0xdda371e600d30688d4710e088e02fdf2b9524d5f\":\"0x177224aa844c7200000\",\"0xdda4ed2a58a8dd20a73275347b580d71b95bf99a\":\"0x15a13cc201e4dc0000\",\"0xdda4ff7de491c687df4574dd1b17ff8f246ba3d1\":\"0x42684a41abfd8400000\",\"0xddab6b51a9030b40fb95cf0b748a059c2417bec7\":\"0x6c6b935b8bbd400000\",\"0xddab75fb2ff9fecb88f89476688e2b00e367ebf9\":\"0x41bad155e6512200000\",\"0xddabf13c3c8ea4e3d73d78ec717afafa430e5479\":\"0x8cf23f909c0fa000000\",\"0xddac312a9655426a9c0c9efa3fd82559ef4505bf\":\"0x15be6174e1912e0000\",\"0xddac6bf4bbdd7d597d9c686d0695593bedccc7fa\":\"0x2ee449550898e40000\",\"0xddbd2b932c763ba5b1b7ae3b362eac3e8d40121a\":\"0x21e19e0c9bab2400000\",\"0xddbddd1bbd38ffade0305d30f02028d92e9f3aa8\":\"0x6c6b935b8bbd400000\",\"0xddbee6f094eae63420b003fb4757142aea6cd0fd\":\"0x6c6b935b8bbd400000\",\"0xddd69c5b9bf5eb5a39cee7c3341a120d973fdb34\":\"0x6bc14b8f8e1b350000\",\"0xdddd7b9e6eab409b92263ac272da801b664f8a57\":\"0x69e10de76676d0800000\",\"0xdde670d01639667576a22dd05d3246d61f06e083\":\"0x1731790534df20000\",\"0xdde77a4740ba08e7f73fbe3a1674912931742eeb\":\"0x434fe4d4382f1d48000\",\"0xdde8f0c31b7415511dced1cd7d46323e4bd12232\":\"0x57473d05dabae80000\",\"0xdde969aef34ea87ac299b7597e292b4a0155cc8a\":\"0x1032f2594a01738000\",\"0xddf0cce1fe996d917635f00712f4052091dff9ea\":\"0x6c6b935b8bbd400000\",\"0xddf3ad76353810be6a89d731b787f6f17188612b\":\"0x43c33c1937564800000\",\"0xddf5810a0eb2fb2e32323bb2c99509ab320f24ac\":\"0x3ca5c66d9bc44300000\",\"0xddf95c1e99ce2f9f5698057c19d5c94027ee4a6e\":\"0x14542ba12a337c00000\",\"0xddfafdbc7c90f1320e54b98f374617fbd01d109f\":\"0xb98bc829a6f90000\",\"0xddfcca13f934f0cfbe231da13039d70475e6a1d0\":\"0x3638221660a5aa8000\",\"0xde027efbb38503226ed871099cb30bdb02af1335\":\"0x3635c9adc5dea00000\",\"0xde06d5ea777a4eb1475e605dbcbf43444e8037ea\":\"0xa968163f0a57b400000\",\"0xde07fb5b7a464e3ba7fbe09e9acb271af5338c58\":\"0x2b5e3af16b1880000\",\"0xde1121829c9a08284087a43fbd2fc1142a3233b4\":\"0x3635c9adc5dea00000\",\"0xde176b5284bcee3a838ba24f67fc7cbf67d78ef6\":\"0x209ce08c962b00000\",\"0xde212293f8f1d231fa10e609470d512cb8ffc512\":\"0x6c6b935b8bbd400000\",\"0xde30e49e5ab313214d2f01dcabce8940b81b1c76\":\"0xaadec983fcff40000\",\"0xde33d708a3b89e909eaf653b30fdc3a5d5ccb4b3\":\"0x99c88229fd4c20000\",\"0xde374299c1d07d79537385190f442ef9ca24061f\":\"0x73f75d1a085ba0000\",\"0xde42fcd24ce4239383304367595f068f0c610740\":\"0x2722a70f1a9a00000\",\"0xde50868eb7e3c71937ec73fa89dd8b9ee10d45aa\":\"0x3635c9adc5dea00000\",\"0xde55de0458f850b37e4d78a641dd2eb2dd8f38ce\":\"0xd8d726b7177a800000\",\"0xde5b005fe8daae8d1f05de3eda042066c6c4691c\":\"0x3ba1910bf341b00000\",\"0xde612d0724e84ea4a7feaa3d2142bd5ee82d3201\":\"0x1158e460913d00000\",\"0xde6d363106cc6238d2f092f0f0372136d1cd50c6\":\"0x121ea68c114e5100000\",\"0xde7dee220f0457a7187d56c1c41f2eb00ac56021\":\"0x2225f39c85052a0000\",\"0xde82cc8d4a1bb1d9434392965b3e80bad3c03d4f\":\"0x50186e75de97a60000\",\"0xde97f4330700b48c496d437c91ca1de9c4b01ba4\":\"0x9dcc0515b56e0c0000\",\"0xde9eff4c798811d968dccb460d9b069cf30278e0\":\"0x15af1d78b58c400000\",\"0xdeb1bc34d86d4a4dde2580d8beaf074eb0e1a244\":\"0x55a6e79ccd1d300000\",\"0xdeb2495d6aca7b2a6a2d138b6e1a42e2dc311fdd\":\"0x6c6b935b8bbd400000\",\"0xdeb97254474c0d2f5a7970dcdb2f52fb1098b896\":\"0x3635c9adc5dea00000\",\"0xdeb9a49a43873020f0759185e20bbb4cf381bb8f\":\"0xb78edb0bf2e5e0000\",\"0xdebbdd831e0f20ae6e378252decdf92f7cf0c658\":\"0x6c6b935b8bbd400000\",\"0xdec3eec2640a752c466e2b7e7ee685afe9ac41f4\":\"0x47c99753596b288000\",\"0xdec82373ade8ebcf2acb6f8bc2414dd7abb70d77\":\"0xad78ebc5ac6200000\",\"0xdec8a1a898f1b895d8301fe64ab3ad5de941f689\":\"0x2ab4f67e8a730f8000\",\"0xdec99e972fca7177508c8e1a47ac22d768acab7c\":\"0x6c6b935b8bbd400000\",\"0xded877378407b94e781c4ef4af7cfc5bc220b516\":\"0x143179d86911020000\",\"0xdee942d5caf5fac11421d86b010b458e5c392990\":\"0xd8d726b7177a800000\",\"0xdeee2689fa9006b59cf285237de53b3a7fd01438\":\"0x186579f29e20250000\",\"0xdefddfd59b8d2c154eecf5c7c167bf0ba2905d3e\":\"0x512cb5e2647420000\",\"0xdefe9141f4704599159d7b223de42bffd80496b3\":\"0x56bc75e2d63100000\",\"0xdf098f5e4e3dffa51af237bda8652c4f73ed9ca6\":\"0x1b36a6444a3e180000\",\"0xdf0d08617bd252a911df8bd41a39b83ddf809673\":\"0x21e19e0c9bab2400000\",\"0xdf0ff1f3d27a8ec9fb8f6b0cb254a63bba8224a5\":\"0xecc5202945d0020000\",\"0xdf1fa2e20e31985ebe2c0f0c93b54c0fb67a264b\":\"0xad78ebc5ac6200000\",\"0xdf211cd21288d6c56fae66c3ff54625dd4b15427\":\"0x8786cd764e1f2c0000\",\"0xdf236bf6abf4f3293795bf0c28718f93e3b1b36b\":\"0x487a9a304539440000\",\"0xdf31025f5649d2c6eea41ed3bdd3471a790f759a\":\"0x1158e460913d00000\",\"0xdf37c22e603aedb60a627253c47d8ba866f6d972\":\"0x5150ae84a8cdf000000\",\"0xdf3b72c5bd71d4814e88a62321a93d4011e3578b\":\"0xd8d726b7177a800000\",\"0xdf3f57b8ee6434d047223def74b20f63f9e4f955\":\"0xd9462c6cb4b5a0000\",\"0xdf44c47fc303ac76e74f97194cca67b5bb3c023f\":\"0x2009c5c8bf6fdc0000\",\"0xdf47a61b72535193c561cccc75c3f3ce0804a20e\":\"0x15935c0b4e3d780000\",\"0xdf47a8ef95f2f49f8e6f58184154145d11f72797\":\"0x678a932062e4180000\",\"0xdf53003346d65c5e7a646bc034f2b7d32fcbe56a\":\"0x6c6b935b8bbd400000\",\"0xdf57353aaff2aadb0a04f9014e8da7884e86589c\":\"0x84886a66e4fb00000\",\"0xdf60f18c812a11ed4e2776e7a80ecf5e5305b3d6\":\"0x30ca024f987b900000\",\"0xdf6485c4297ac152b289b19dde32c77ec417f47d\":\"0x3635c9adc5dea00000\",\"0xdf660a91dab9f730f6190d50c8390561500756ca\":\"0x6c6b935b8bbd400000\",\"0xdf6ed6006a6abe886ed33d95a4de28fc12183927\":\"0x3154c9729d05780000\",\"0xdf8510793eee811c2dab1c93c6f4473f30fbef5b\":\"0x3635c9adc5dea00000\",\"0xdf8d48b1eb07b3c217790e6c2df04dc319e7e848\":\"0x1b1ae4d6e2ef500000\",\"0xdfa6b8b8ad3184e357da282951d79161cfb089bc\":\"0x15af1d78b58c400000\",\"0xdfaf31e622c03d9e18a0ddb8be60fbe3e661be0a\":\"0x21e171a3ec9f72c0000\",\"0xdfb1626ef48a1d7d7552a5e0298f1fc23a3b482d\":\"0x5ce895dd949efa0000\",\"0xdfb4d4ade52fcc818acc7a2c6bb2b00224658f78\":\"0x1a420db02bd7d580000\",\"0xdfbd4232c17c407a980db87ffbcda03630e5c459\":\"0x1dfc7f924923530000\",\"0xdfcbdf09454e1a5e4a40d3eef7c5cf1cd3de9486\":\"0xd8d726b7177a800000\",\"0xdfdbcec1014b96da2158ca513e9c8d3b9af1c3d0\":\"0x6c6b935b8bbd400000\",\"0xdfded2574b27d1613a7d98b715159b0d00baab28\":\"0x43c33c1937564800000\",\"0xdfdf43393c649caebe1bb18059decb39f09fb4e8\":\"0x15af1d78b58c400000\",\"0xdfe3c52a92c30396a4e33a50170dc900fcf8c9cf\":\"0x2b5e3af16b1880000\",\"0xdfe549fe8430e552c6d07cc3b92ccd43b12fb50f\":\"0x48875eaf6562a0000\",\"0xdfe929a61c1b38eddbe82c25c2d6753cb1e12d68\":\"0x15d1cf4176aeba0000\",\"0xdff1b220de3d8e9ca4c1b5be34a799bcded4f61c\":\"0x14e4e353ea39420000\",\"0xdff4007931786593b229efe5959f3a4e219e51af\":\"0x10afc1ade3b4ed40000\",\"0xdffcea5421ec15900c6ecfc777184e140e209e24\":\"0x115473824344e0000\",\"0xe001aba77c02e172086c1950fffbcaa30b83488f\":\"0x6acb3df27e1f880000\",\"0xe00484788db50fc6a48e379d123e508b0f6e5ab1\":\"0x3635c9adc5dea00000\",\"0xe0060462c47ff9679baef07159cae08c29f274a9\":\"0x6c6b935b8bbd400000\",\"0xe00d153b10369143f97f54b8d4ca229eb3e8f324\":\"0x83d6c7aab63600000\",\"0xe012db453827a58e16c1365608d36ed658720507\":\"0x6c6b935b8bbd400000\",\"0xe01547ba42fcafaf93938becf7699f74290af74f\":\"0x6c6b935b8bbd400000\",\"0xe016dc138e25815b90be3fe9eee8ffb2e105624f\":\"0x1b1ae4d6e2ef500000\",\"0xe01859f242f1a0ec602fa8a3b0b57640ec89075e\":\"0x1e162c177be5cc0000\",\"0xe020e86362b487752836a6de0bc02cd8d89a8b6a\":\"0x14542ba12a337c00000\",\"0xe023f09b2887612c7c9cf1988e3a3a602b3394c9\":\"0x6c6b935b8bbd400000\",\"0xe0272213e8d2fd3e96bd6217b24b4ba01b617079\":\"0x1158e460913d00000\",\"0xe02b74a47628be315b1f76b315054ad44ae9716f\":\"0xd8d726b7177a800000\",\"0xe03220c697bcd28f26ef0b74404a8beb06b2ba7b\":\"0x1b1ae4d6e2ef5000000\",\"0xe0352fdf819ba265f14c06a6315c4ac1fe131b2e\":\"0x3635c9adc5dea00000\",\"0xe0388aeddd3fe2ad56f85748e80e710a34b7c92e\":\"0x1b1ae4d6e2ef500000\",\"0xe03c00d00388ecbf4f263d0ac778bb41a57a40d9\":\"0x3636c9796436740000\",\"0xe04920dc6ecc1d6ecc084f88aa0af5db97bf893a\":\"0x9ddc1e3b901180000\",\"0xe04972a83ca4112bc871c72d4ae1616c2f0728db\":\"0xe81c77f29a32f0000\",\"0xe04ff5e5a7e2af995d8857ce0290b53a2b0eda5d\":\"0x3635c9adc5dea00000\",\"0xe05029aceb0778675bef1741ab2cd2931ef7c84b\":\"0x10f0dbae61009528000\",\"0xe056bf3ff41c26256fef51716612b9d39ade999c\":\"0x56be757a12e0a8000\",\"0xe061a4f2fc77b296d19ada238e49a5cb8ecbfa70\":\"0xd8d726b7177a800000\",\"0xe0663e8cd66792a641f56e5003660147880f018e\":\"0x6c6b935b8bbd400000\",\"0xe0668fa82c14d6e8d93a53113ef2862fa81581bc\":\"0x2f2f39fc6c54000000\",\"0xe069c0173352b10bf6834719db5bed01adf97bbc\":\"0x10634f8e5323b0000\",\"0xe06c29a81517e0d487b67fb0b6aabc4f57368388\":\"0x15be6174e1912e0000\",\"0xe06cb6294704eea7437c2fc3d30773b7bf38889a\":\"0x116dc3a8994b30000\",\"0xe07137ae0d116d033533c4eab496f8a9fb09569c\":\"0x4be4e7267b6ae00000\",\"0xe076db30ab486f79194ebbc45d8fab9a9242f654\":\"0x106607e3494baa00000\",\"0xe07ebbc7f4da416e42c8d4f842aba16233c12580\":\"0x6c6b935b8bbd400000\",\"0xe081ca1f4882db6043d5a9190703fde0ab3bf56d\":\"0x15af1d78b58c400000\",\"0xe083d34863e0e17f926b7928edff317e998e9c4b\":\"0x15af1d78b58c400000\",\"0xe08b9aba6bd9d28bc2056779d2fbf0f2855a3d9d\":\"0x6c6b935b8bbd400000\",\"0xe08bc29c2b48b169ff2bdc16714c586e6cb85ccf\":\"0x1158e460913d00000\",\"0xe08c60313106e3f9334fe6f7e7624d211130c077\":\"0x22b1c8c1227a00000\",\"0xe09c68e61998d9c81b14e4ee802ba7adf6d74cdb\":\"0xd8d726b7177a800000\",\"0xe09fea755aee1a44c0a89f03b5deb762ba33006f\":\"0x3ba289bc944ff70000\",\"0xe0a254ac09b9725bebc8e460431dd0732ebcabbf\":\"0x14542ba12a337c00000\",\"0xe0aa69365555b73f282333d1e30c1bbd072854e8\":\"0x17b7883c06916600000\",\"0xe0bad98eee9698dbf6d76085b7923de5754e906d\":\"0x90d972f32323c0000\",\"0xe0c4ab9072b4e6e3654a49f8a8db026a4b3386a9\":\"0x6c6b935b8bbd400000\",\"0xe0ce80a461b648a501fd0b824690c8868b0e4de8\":\"0x1b1ae4d6e2ef500000\",\"0xe0cf698a053327ebd16b7d7700092fe2e8542446\":\"0x52a34cbb61f578000\",\"0xe0d231e144ec9107386c7c9b02f1702ceaa4f700\":\"0x10f0dbae61009528000\",\"0xe0d76b7166b1f3a12b4091ee2b29de8caa7d07db\":\"0x6c6b935b8bbd400000\",\"0xe0e0b2e29dde73af75987ee4446c829a189c95bc\":\"0x813ca56906d340000\",\"0xe0e978753d982f7f9d1d238a18bd4889aefe451b\":\"0x20dd68aaf3289100000\",\"0xe0f372347c96b55f7d4306034beb83266fd90966\":\"0x15af1d78b58c400000\",\"0xe0f903c1e48ac421ab48528f3d4a2648080fe043\":\"0x3708baed3d68900000\",\"0xe0ff0bd9154439c4a5b7233e291d7d868af53f33\":\"0x1579216a51bbfb0000\",\"0xe10ac19c546fc2547c61c139f5d1f45a6666d5b0\":\"0x102da6fd0f73a3c0000\",\"0xe10c540088113fa6ec00b4b2c8824f8796e96ec4\":\"0x320f4509ab1ec7c00000\",\"0xe1173a247d29d8238df0922f4df25a05f2af77c3\":\"0x878c95d560f30478000\",\"0xe1203eb3a723e99c2220117ca6afeb66fa424f61\":\"0x200ef929e3256fe0000\",\"0xe131f87efc5ef07e43f0f2f4a747b551d750d9e6\":\"0x43c25e0dcc1bd1c0000\",\"0xe1334e998379dfe983177062791b90f80ee22d8d\":\"0x1b1ae4d6e2ef500000\",\"0xe13540ecee11b212e8b775dc8e71f374aae9b3f8\":\"0x6c6b935b8bbd400000\",\"0xe13b3d2bbfdcbc8772a23315724c1425167c5688\":\"0x37f379141ed04b8000\",\"0xe1443dbd95cc41237f613a48456988a04f683282\":\"0xd8d8583fa2d52f0000\",\"0xe14617f6022501e97e7b3e2d8836aa61f0ff2dba\":\"0xad78ebc5ac6200000\",\"0xe149b5726caf6d5eb5bf2acc41d4e2dc328de182\":\"0x692ae8897081d00000\",\"0xe154daeadb545838cbc6aa0c55751902f528682a\":\"0x10afc1ade3b4ed40000\",\"0xe16ce35961cd74bd590d04c4ad4a1989e05691c6\":\"0x7ea28327577080000\",\"0xe172dfc8f80cd1f8cd8539dc26082014f5a8e3e8\":\"0xa2a15d09519be00000\",\"0xe177e0c201d335ba3956929c571588b51c5223ae\":\"0x6c6b935b8bbd400000\",\"0xe17812f66c5e65941e186c46922b6e7b2f0eeb46\":\"0x62a992e53a0af00000\",\"0xe180de9e86f57bafacd7904f9826b6b4b26337a3\":\"0x2d041d705a2c600000\",\"0xe192489b85a982c1883246d915b229cb13207f38\":\"0x10f0cf064dd59200000\",\"0xe1953c6e975814c571311c34c0f6a99cdf48ab82\":\"0x2b5e3af16b1880000\",\"0xe1ae029b17e373cde3de5a9152201a14cac4e119\":\"0x56b55ae58ca400000\",\"0xe1b2aca154b8e0766c4eba30bc10c7f35036f368\":\"0x115473824344e0000\",\"0xe1b39b88d9900dbc4a6cdc481e1060080a8aec3c\":\"0x6c6b935b8bbd400000\",\"0xe1b63201fae1f129f95c7a116bd9dde5159c6cda\":\"0x4d60573a2f0c9ef0000\",\"0xe1bfaa5a45c504428923c4a61192a55b1400b45d\":\"0x90f534608a72880000\",\"0xe1c607c0a8a060da8f02a8eb38a013ea8cda5b8c\":\"0x2ba39e82ed5d740000\",\"0xe1cb83ec5eb6f1eeb85e99b2fc63812fde957184\":\"0x43c33c1937564800000\",\"0xe1d91b0954cede221d6f24c7985fc59965fb98b8\":\"0x6c6b935b8bbd400000\",\"0xe1dfb5cc890ee8b2877e885d267c256187d019e6\":\"0x56bc75e2d63100000\",\"0xe1e8c50b80a352b240ce7342bbfdf5690cc8cb14\":\"0x155bd9307f9fe80000\",\"0xe1f63ebbc62c7b7444040eb99623964f7667b376\":\"0x1158e460913d00000\",\"0xe206fb7324e9deb79e19903496d6961b9be56603\":\"0x56bc75e2d63100000\",\"0xe207578e1f4ddb8ff6d5867b39582d71b9812ac5\":\"0xd255d112e103a00000\",\"0xe208812a684098f3da4efe6aba256256adfe3fe6\":\"0x6c6b935b8bbd400000\",\"0xe20954d0f4108c82d4dcb2148d26bbd924f6dd24\":\"0x21e19e0c9bab2400000\",\"0xe20bb9f3966419e14bbbaaaa6789e92496cfa479\":\"0xbbd825030752760000\",\"0xe20d1bcb71286dc7128a9fc7c6ed7f733892eef5\":\"0x3664f8e7c24af40000\",\"0xe2191215983f33fd33e22cd4a2490054da53fddc\":\"0xdb44e049bb2c0000\",\"0xe2198c8ca1b399f7521561fd5384a7132fba486b\":\"0x3708baed3d68900000\",\"0xe21c778ef2a0d7f751ea8c074d1f812243863e4e\":\"0x11fc70e2c8c8ae18000\",\"0xe229e746a83f2ce253b0b03eb1472411b57e5700\":\"0x1369fb96128ac480000\",\"0xe22b20c77894463baf774cc256d5bddbbf7ddd09\":\"0x3635c9adc5dea00000\",\"0xe230fe1bff03186d0219f15d4c481b7d59be286a\":\"0x1fd741e8088970000\",\"0xe237baa4dbc9926e32a3d85d1264402d54db012f\":\"0x6c6b935b8bbd400000\",\"0xe24109be2f513d87498e926a286499754f9ed49e\":\"0x300ea8ad1f27ca0000\",\"0xe246683cc99db7c4a52bcbacaab0b32f6bfc93d7\":\"0x6c6b935b8bbd400000\",\"0xe25a167b031e84616d0f013f31bda95dcc6350b9\":\"0x23c757072b8dd000000\",\"0xe25b9f76b8ad023f057eb11ad94257a0862e4e8c\":\"0x6c6b935b8bbd400000\",\"0xe26657f0ed201ea2392c9222b80a7003608ddf30\":\"0x22b1c8c1227a00000\",\"0xe26bf322774e18288769d67e3107deb7447707b8\":\"0x6c6b935b8bbd400000\",\"0xe2728a3e8c2aaac983d05dc6877374a8f446eee9\":\"0xab640391201300000\",\"0xe28b062259e96eeb3c8d4104943f9eb325893cf5\":\"0x487a9a304539440000\",\"0xe28dbc8efd5e416a762ec0e018864bb9aa83287b\":\"0x531f200ab3e030a8000\",\"0xe2904b1aefa056398b6234cb35811288d736db67\":\"0x22b1c8c1227a00000\",\"0xe29d8ae452dcf3b6ac645e630409385551faae0a\":\"0x45a0da4adf5420000\",\"0xe2bbf84641e3541f6c33e6ed683a635a70bde2ec\":\"0x1b413cfcbf59b78000\",\"0xe2cf360aa2329eb79d2bf7ca04a27a17c532e4d8\":\"0x58788cb94b1d80000\",\"0xe2df23f6ea04becf4ab701748dc0963184555cdb\":\"0x6c6b935b8bbd400000\",\"0xe2e15c60dd381e3a4be25071ab249a4c5c5264da\":\"0x7f6bc49b81b5370000\",\"0xe2e26e4e1dcf30d048cc6ecf9d51ec1205a4e926\":\"0xd8d726b7177a800000\",\"0xe2ee691f237ee6529b6557f2fcdd3dcf0c59ec63\":\"0x127729c14687c200000\",\"0xe2efa5fca79538ce6068bf31d2c516d4d53c08e5\":\"0x71cc408df63400000\",\"0xe2efd0a9bc407ece03d67e8ec8e9d283f48d2a49\":\"0x299b33bf9c584e00000\",\"0xe2f40d358f5e3fe7463ec70480bd2ed398a7063b\":\"0x1158e460913d00000\",\"0xe2f9383d5810ea7b43182b8704b62b27f5925d39\":\"0x15af1d78b58c400000\",\"0xe2ff9ee4b6ecc14141cc74ca52a9e7a2ee14d908\":\"0x4be4e7267b6ae00000\",\"0xe30212b2011bb56bdbf1bc35690f3a4e0fd905ea\":\"0x1b2df9d219f57980000\",\"0xe303167f3d4960fe881b32800a2b4aeff1b088d4\":\"0x6c6b935b8bbd400000\",\"0xe304a32f05a83762744a9542976ff9b723fa31ea\":\"0x5572f240a346200000\",\"0xe308435204793764f5fcbe65eb510f5a744a655a\":\"0xad78ebc5ac6200000\",\"0xe309974ce39d60aadf2e69673251bf0e04760a10\":\"0xdc55fdb17647b0000\",\"0xe31b4eef184c24ab098e36c802714bd4743dd0d4\":\"0xad78ebc5ac6200000\",\"0xe321bb4a946adafdade4571fb15c0043d39ee35f\":\"0x556475382b4c9e0000\",\"0xe3263ce8af6db3e467584502ed7109125eae22a5\":\"0x6c6b935b8bbd400000\",\"0xe32b1c4725a1875449e98f970eb3e54062d15800\":\"0xad78ebc5ac6200000\",\"0xe32f95766d57b5cd4b173289d6876f9e64558194\":\"0x56bc75e2d63100000\",\"0xe33840d8bca7da98a6f3d096d83de78b70b71ef8\":\"0x6c6b935b8bbd400000\",\"0xe338e859fe2e8c15554848b75caecda877a0e832\":\"0x61acff81a78ad40000\",\"0xe33d980220fab259af6a1f4b38cf0ef3c6e2ea1a\":\"0x6c6b935b8bbd400000\",\"0xe33df4ce80ccb62a76b12bcdfcecc46289973aa9\":\"0x14542ba12a337c00000\",\"0xe33ff987541dde5cdee0a8a96dcc3f33c3f24cc2\":\"0x2a5a058fc295ed000000\",\"0xe3410bb7557cf91d79fa69d0dfea0aa075402651\":\"0x6c6b935b8bbd400000\",\"0xe341642d40d2afce2e9107c67079ac7a2660086c\":\"0x15af1d78b58c400000\",\"0xe35453eef2cc3c7a044d0ac134ba615908fa82ee\":\"0x7ff1ccb7561df0000\",\"0xe36a8ea87f1e99e8a2dc1b2608d166667c9dfa01\":\"0x56bc75e2d63100000\",\"0xe3712701619ca7623c55db3a0ad30e867db0168b\":\"0x1158e460913d00000\",\"0xe37f5fdc6ec97d2f866a1cfd0d3a4da4387b22b5\":\"0x21e19e0c9bab2400000\",\"0xe3878f91ca86053fced5444686a330e09cc388fb\":\"0xa844a7424d9c80000\",\"0xe38b91b35190b6d9deed021c30af094b953fdcaa\":\"0x1ceaf795b6b860000\",\"0xe38ef28a5ed984a7db24a1ae782dfb87f397dfc6\":\"0x7c0860e5a80dc0000\",\"0xe3925509c8d0b2a6738c5f6a72f35314491248ce\":\"0x36e9a8669a44768000\",\"0xe3933d61b77dcdc716407f8250bc91e4ffaeb09d\":\"0x1256986c95891c200000\",\"0xe3951de5aefaf0458768d774c254f7157735e505\":\"0x56c95de8e8ca1d0000\",\"0xe399c81a1d701b44f0b66f3399e66b275aaaf8c1\":\"0x3635c9adc5dea00000\",\"0xe39b11a8ab1ff5e22e5ae6517214f73c5b9b55dc\":\"0x6c6b935b8bbd400000\",\"0xe39e46e15d22ce56e0c32f1877b7d1a264cf94f3\":\"0x43c33c1937564800000\",\"0xe3a4621b66004588e31206f718cb00a319889cf0\":\"0x6c6b935b8bbd400000\",\"0xe3a4f83c39f85af9c8b1b312bfe5fc3423afa634\":\"0x18d993f34aef10000\",\"0xe3a89a1927cc4e2d43fbcda1e414d324a7d9e057\":\"0xb23e2a936dec60000\",\"0xe3ab3ca9b870e3f548517306bba4de2591afafc2\":\"0x410e34aecc8cd30000\",\"0xe3b3d2c9bf570be6a2f72adca1862c310936a43c\":\"0x56d2aa3a5c09a0000\",\"0xe3c0c128327a9ad80148139e269773428e638cb0\":\"0x6c6b935b8bbd400000\",\"0xe3c812737ac606baf7522ad817428a36050e7a34\":\"0x692ae8897081d00000\",\"0xe3cffe239c64e7e20388e622117391301b298696\":\"0x1b1ae4d6e2ef500000\",\"0xe3d3eaa299887865569e88be219be507189be1c9\":\"0x18ba6fa92e93160000\",\"0xe3d8bf4efe84b1616d1b89e427ddc6c8830685ae\":\"0x6c6b935b8bbd400000\",\"0xe3d915eda3b825d6ee4af9328d32ac18ada35497\":\"0x1b1ae4d6e2ef500000\",\"0xe3da4f3240844c9b6323b4996921207122454399\":\"0x27190a952df4be58000\",\"0xe3eb2c0a132a524f72ccc0d60fee8b41685d39e2\":\"0x6acb3df27e1f880000\",\"0xe3ec18a74ed43855409a26ade7830de8e42685ef\":\"0x11164759ffb320000\",\"0xe3ece1f632711d13bfffa1f8f6840871ee58fb27\":\"0xd8d726b7177a800000\",\"0xe3f80b40fb83fb97bb0d5230af4f6ed59b1c7cc8\":\"0x487a9a304539440000\",\"0xe3ffb02cb7d9ea5243701689afd5d417d7ed2ece\":\"0x43a77aabd00780000\",\"0xe400d651bb3f2d23d5f849e6f92d9c5795c43a8a\":\"0x90f534608a72880000\",\"0xe406f5dd72cab66d8a6ecbd6bfb494a7b6b09afe\":\"0x56bc75e2d63100000\",\"0xe408aa99835307eea4a6c5eb801fe694117f707d\":\"0x1b1ae4d6e2ef500000\",\"0xe408fceaa1b98f3c640f48fcba39f056066d6308\":\"0x21e19e0c9bab2400000\",\"0xe40a7c82e157540a0b00901dbb86c716e1a062da\":\"0x2b31d2425f6740000\",\"0xe41aea250b877d423a63ba2bce2f3a61c0248d56\":\"0xe18398e7601900000\",\"0xe430c0024fdbf73a82e21fccf8cbd09138421c21\":\"0xd8d726b7177a800000\",\"0xe4324912d64ea3aef76b3c2ff9df82c7e13ae991\":\"0x6c6b935b8bbd400000\",\"0xe4368bc1420b35efda95fafbc73090521916aa34\":\"0xd8d726b7177a800000\",\"0xe437acbe0f6227b0e36f36e4bcf7cf613335fb68\":\"0xad78ebc5ac6200000\",\"0xe44b7264dd836bee8e87970340ed2b9aed8ed0a5\":\"0x138e7faa01a803a0000\",\"0xe44ea51063405154aae736be2bf1ee3b9be639ae\":\"0xd8d726b7177a800000\",\"0xe4625501f52b7af52b19ed612e9d54fdd006b492\":\"0xb5a905a56ddd00000\",\"0xe4715956f52f15306ee9506bf82bccc406b3895e\":\"0xee79d4f48c5000000\",\"0xe47fbaed99fc209962604ebd20e240f74f4591f1\":\"0x6c6b935b8bbd400000\",\"0xe482d255ede56b04c3e8df151f56e9ca62aaa8c2\":\"0x1b1ae4d6e2ef500000\",\"0xe48e65125421880d42bdf1018ab9778d96928f3f\":\"0xe3aeb5737240a00000\",\"0xe492818aa684e5a676561b725d42f3cc56ae5198\":\"0x2b5e3af16b18800000\",\"0xe49936a92a8ccf710eaac342bc454b9b14ebecb1\":\"0x6c6b935b8bbd400000\",\"0xe49af4f34adaa2330b0e49dc74ec18ab2f92f827\":\"0x6c6b935b8bbd400000\",\"0xe49ba0cd96816c4607773cf8a5970bb5bc16a1e6\":\"0x5a87e7d7f5f6580000\",\"0xe4a47e3933246c3fd62979a1ea19ffdf8c72ef37\":\"0x809b383ea7d7e8000\",\"0xe4b6ae22c7735f5b89f34dd77ad0975f0acc9181\":\"0x3635c9adc5dea00000\",\"0xe4ca0a5238564dfc91e8bf22bade2901619a1cd4\":\"0x3635c9adc5dea00000\",\"0xe4cafb727fb5c6b70bb27533b8a9ccc9ef6888e1\":\"0x10497bf4af4caf8000\",\"0xe4dc22ed595bf0a337c01e03cc6be744255fc9e8\":\"0xa5aa85009e39c0000\",\"0xe4fb26d1ca1eecba3d8298d9d148119ac2bbf580\":\"0x15af1d78b58c400000\",\"0xe4fc13cfcbac1b17ce7783acd423a845943f6b3a\":\"0x1158e460913d00000\",\"0xe50b464ac9de35a5618b7cbf254674182b81b97e\":\"0xde42ee1544dd900000\",\"0xe5102c3b711b810344197419b1cd8a7059f13e32\":\"0x1043528d0984698000\",\"0xe510d6797fba3d6693835a844ea2ad540691971b\":\"0x3ae39d47383e8740000\",\"0xe51421f8ee2210c71ed870fe618276c8954afbe9\":\"0x487a9a304539440000\",\"0xe51eb87e7fb7311f5228c479b48ec9878831ac4c\":\"0x6c6b935b8bbd400000\",\"0xe5215631b14248d45a255296bed1fbfa0330ff35\":\"0x4703e6eb5291b80000\",\"0xe528a0e5a267d667e9393a6584e19b34dc9be973\":\"0x12f939c99edab800000\",\"0xe53425d8df1f11c341ff58ae5f1438abf1ca53cf\":\"0x1174a5cdf88bc80000\",\"0xe53c68796212033e4e6f9cff56e19c461eb454f9\":\"0x3635c9adc5dea00000\",\"0xe54102534de8f23effb093b31242ad3b233facfd\":\"0xd8d726b7177a800000\",\"0xe545ee84ea48e564161e9482d59bcf406a602ca2\":\"0x6449e84e47a8a80000\",\"0xe5481a7fed42b901bbed20789bd4ade50d5f83b9\":\"0x6c6b935b8bbd400000\",\"0xe559b5fd337b9c5572a9bf9e0f2521f7d446dbe4\":\"0xad78ebc5ac6200000\",\"0xe55c80520a1b0f755b9a2cd3ce214f7625653e8a\":\"0x6c6b935b8bbd400000\",\"0xe56d431324c92911a1749df292709c14b77a65cd\":\"0x1bc85dc2a89bb200000\",\"0xe57d2995b0ebdf3f3ca6c015eb04260dbb98b7c6\":\"0x6c6b935b8bbd400000\",\"0xe587b16abc8a74081e3613e14342c03375bf0847\":\"0x6c6b935b8bbd400000\",\"0xe589fa76984db5ec4004b46ee8a59492c30744ce\":\"0x97c9ce4cf6d5c00000\",\"0xe58dd23238ee6ea7c2138d385df500c325f376be\":\"0x62a992e53a0af00000\",\"0xe5953fea497104ef9ad2d4e5841c271f073519c2\":\"0x2629f66e0c53000000\",\"0xe5968797468ef767101b761d431fce14abffdbb4\":\"0x1b3d969fa411ca00000\",\"0xe597f083a469c4591c3d2b1d2c772787befe27b2\":\"0xf2dc7d47f15600000\",\"0xe59b3bd300893f97233ef947c46f7217e392f7e9\":\"0x3635c9adc5dea00000\",\"0xe5a365343cc4eb1e770368e1f1144a77b832d7e0\":\"0x1158e460913d00000\",\"0xe5a3d7eb13b15c100177236d1beb30d17ee15420\":\"0x6c6b935b8bbd400000\",\"0xe5aa0b833bb916dc19a8dd683f0ede241d988eba\":\"0xa2a15d09519be00000\",\"0xe5b7af146986c0ff8f85d22e6cc334077d84e824\":\"0x6c6b935b8bbd400000\",\"0xe5b826196c0e1bc1119b021cf6d259a610c99670\":\"0xad78ebc5ac6200000\",\"0xe5b96fc9ac03d448c1613ac91d15978145dbdfd1\":\"0xad78ebc5ac6200000\",\"0xe5b980d28eece2c06fca6c9473068b37d4a6d6e9\":\"0x25afd68cac2b900000\",\"0xe5bab4f0afd8a9d1a381b45761aa18f3d3cce105\":\"0x51bfd7c13878d10000\",\"0xe5bcc88c3b256f6ed5fe550e4a18198b943356ad\":\"0x6c6b935b8bbd400000\",\"0xe5bdf34f4ccc483e4ca530cc7cf2bb18febe92b3\":\"0x6d835a10bbcd20000\",\"0xe5dc9349cb52e161196122cf87a38936e2c57f34\":\"0x6c6b935b8bbd400000\",\"0xe5e33800a1b2e96bde1031630a959aa007f26e51\":\"0x487a9a304539440000\",\"0xe5e37e19408f2cfbec83349dd48153a4a795a08f\":\"0xe3aeb5737240a00000\",\"0xe5edc73e626f5d3441a45539b5f7a398c593edf6\":\"0x2ee449550898e40000\",\"0xe5edf8123f2403ce1a0299becf7aac744d075f23\":\"0xada55474b81340000\",\"0xe5f8ef6d970636b0dcaa4f200ffdc9e75af1741c\":\"0x6c6b935b8bbd400000\",\"0xe5fb31a5caee6a96de393bdbf89fbe65fe125bb3\":\"0x3635c9adc5dea00000\",\"0xe5fbe34984b637196f331c679d0c0c47d83410e1\":\"0x6c6c44fe47ec050000\",\"0xe60955dc0bc156f6c41849f6bd776ba44b0ef0a1\":\"0x10431627a0933b0000\",\"0xe60a55f2df996dc3aedb696c08dde039b2641de8\":\"0x6c6b935b8bbd400000\",\"0xe6115b13f9795f7e956502d5074567dab945ce6b\":\"0x152d02c7e14af6800000\",\"0xe61f280915c774a31d223cf80c069266e5adf19b\":\"0x2fb474098f67c00000\",\"0xe62f98650712eb158753d82972b8e99ca3f61877\":\"0x6c6b935b8bbd400000\",\"0xe62f9d7c64e8e2635aeb883dd73ba684ee7c1079\":\"0x1b1ae4d6e2ef5000000\",\"0xe63e787414b9048478a50733359ecdd7e3647aa6\":\"0x55a6e79ccd1d300000\",\"0xe646665872e40b0d7aa2ff82729caaba5bc3e89e\":\"0x15af1d78b58c400000\",\"0xe64ef012658d54f8e8609c4e9023c09fe865c83b\":\"0x18493fba64ef00000\",\"0xe64f6e1d6401b56c076b64a1b0867d0b2f310d4e\":\"0x2cbad71c53ae50000\",\"0xe667f652f957c28c0e66d0b63417c80c8c9db878\":\"0x209d922f5259c50000\",\"0xe677c31fd9cb720075dca49f1abccd59ec33f734\":\"0x1a6d6beb1d42ee00000\",\"0xe67c2c1665c88338688187629f49e99b60b2d3ba\":\"0xad78ebc5ac6200000\",\"0xe69a6cdb3a8a7db8e1f30c8b84cd73bae02bc0f8\":\"0x394fdc2e452f6718000\",\"0xe69d1c378b771e0feff051db69d966ac6779f4ed\":\"0x1dfa6aaa1497040000\",\"0xe69fcc26ed225f7b2e379834c524d70c1735e5bc\":\"0x6c6b935b8bbd400000\",\"0xe6a3010f0201bc94ff67a2f699dfc206f9e76742\":\"0x2fa7cbf66464980000\",\"0xe6a6f6dd6f70a456f4ec15ef7ad5e5dbb68bd7dc\":\"0xad78ebc5ac6200000\",\"0xe6b20f980ad853ad04cbfc887ce6601c6be0b24c\":\"0xd8d726b7177a800000\",\"0xe6b3ac3f5d4da5a8857d0b3f30fc4b2b692b77d7\":\"0x4f2591f896a6500000\",\"0xe6b9545f7ed086e552924639f9a9edbbd5540b3e\":\"0xcbd47b6eaa8cc00000\",\"0xe6bcd30a8fa138c5d9e5f6c7d2da806992812dcd\":\"0x370ea0d47cf61a800000\",\"0xe6c81ffcecb47ecdc55c0b71e4855f3e5e97fc1e\":\"0x121ea68c114e510000\",\"0xe6cb260b716d4c0ab726eeeb07c8707204e276ae\":\"0x3635c9adc5dea00000\",\"0xe6cb3f3124c9c9cc3834b1274bc3336456a38bac\":\"0x172b1de0a213ff0000\",\"0xe6d22209ffd0b87509ade3a8e2ef429879cb89b5\":\"0x3a7aa9e1899ca300000\",\"0xe6d49f86c228f47367a35e886caacb271e539429\":\"0x165ec09da7a1980000\",\"0xe6e621eaab01f20ef0836b7cad47464cb5fd3c96\":\"0x11219342afa24b0000\",\"0xe6e886317b6a66a5b4f81bf164c538c264351765\":\"0x6c6b935b8bbd400000\",\"0xe6e9a39d750fe994394eb68286e5ea62a6997882\":\"0x2086ac351052600000\",\"0xe6ec5cf0c49b9c317e1e706315ef9eb7c0bf11a7\":\"0x3a469f3467e8ec00000\",\"0xe6f5eb649afb99599c414b27a9c9c855357fa878\":\"0x90f534608a72880000\",\"0xe6fe0afb9dcedd37b2e22c451ba6feab67348033\":\"0x21e19e0c9bab2400000\",\"0xe710dcd09b8101f9437bd97db90a73ef993d0bf4\":\"0x14ee36c05ac2520000\",\"0xe727e67ef911b81f6cf9c73fcbfebc2b02b5bfc6\":\"0x6c6b935b8bbd400000\",\"0xe72e1d335cc29a96b9b1c02f003a16d971e90b9d\":\"0x55a6e79ccd1d300000\",\"0xe7311c9533f0092c7248c9739b5b2c864a34b1ce\":\"0x97f97d6cc26dfe0000\",\"0xe73bfeada6f0fd016fbc843ebcf6e370a65be70c\":\"0x6acb3df27e1f880000\",\"0xe73ccf436725c151e255ccf5210cfce5a43f13e3\":\"0x1154e53217ddb0000\",\"0xe742b1e6069a8ffc3c4767235defb0d49cbed222\":\"0x2b5e3af16b18800000\",\"0xe74608f506866ada6bfbfdf20fea440be76989ef\":\"0x6c6acc67d7b1d40000\",\"0xe7533e270cc61fa164ac1553455c105d04887e14\":\"0x696d8590020bb0000\",\"0xe75c1fb177089f3e58b1067935a6596ef1737fb5\":\"0x56a879fa775470000\",\"0xe75c3b38a58a3f33d55690a5a59766be185e0284\":\"0x1b1ae4d6e2ef500000\",\"0xe761d27fa3502cc76bb1a608740e1403cf9dfc69\":\"0xf2dc7d47f15600000\",\"0xe766f34ff16f3cfcc97321721f43ddf5a38b0cf4\":\"0x54069233bf7f780000\",\"0xe76d945aa89df1e457aa342b31028a5e9130b2ce\":\"0x3708baed3d68900000\",\"0xe7735ec76518fc6aa92da8715a9ee3f625788f13\":\"0x6c4d160bafa1b78000\",\"0xe77a89bd45dc04eeb4e41d7b596b707e6e51e74c\":\"0x28a857425466f800000\",\"0xe77d7deab296c8b4fa07ca3be184163d5a6d606c\":\"0x5043904b671190000\",\"0xe77febabdf080f0f5dca1d3f5766f2a79c0ffa7c\":\"0x4b229d28a843680000\",\"0xe780a56306ba1e6bb331952c22539b858af9f77d\":\"0xa968163f0a57b400000\",\"0xe781ec732d401202bb9bd13860910dd6c29ac0b6\":\"0x433874f632cc600000\",\"0xe784dcc873aa8c1513ec26ff36bc92eac6d4c968\":\"0xad78ebc5ac6200000\",\"0xe7912d4cf4562c573ddc5b71e37310e378ef86c9\":\"0x155bd9307f9fe80000\",\"0xe791d585b89936b25d298f9d35f9f9edc25a2932\":\"0x6c6b935b8bbd400000\",\"0xe792349ce9f6f14f81d0674096befa1f9221cdea\":\"0x5b5d234a0db4388000\",\"0xe796fd4e839b4c95d7510fb7c5c72b83c6c3e3c7\":\"0x1bc433f23f83140000\",\"0xe7a42f59fee074e4fb13ea9e57ecf1cc48282249\":\"0x43c33c1937564800000\",\"0xe7a4560c84b20e0fb54c49670c2903b0a96c42a4\":\"0x206aeac7a903980000\",\"0xe7a8e471eafb798f4554cc6e526730fd56e62c7d\":\"0x3635c9adc5dea00000\",\"0xe7be82c6593c1eeddd2ae0b15001ff201ab57b2f\":\"0x10910d4cdc9f60000\",\"0xe7c6b5fc05fc748e5b4381726449a1c0ad0fb0f1\":\"0x6c6b935b8bbd400000\",\"0xe7d17524d00bad82497c0f27156a647ff51d2792\":\"0x1158e460913d00000\",\"0xe7d213947fcb904ad738480b1eed2f5c329f27e8\":\"0x103c3b1d3e9c30000\",\"0xe7d6240620f42c5edbb2ede6aec43da4ed9b5757\":\"0x3635c9adc5dea00000\",\"0xe7da609d40cde80f00ce5b4ffb6aa9d0b03494fc\":\"0x3635c9adc5dea00000\",\"0xe7f06f699be31c440b43b4db0501ec0e25261644\":\"0x1b1ae4d6e2ef500000\",\"0xe7f4d7fe6f561f7fa1da3005fd365451ad89df89\":\"0xad78ebc5ac6200000\",\"0xe7fd8fd959aed2767ea7fa960ce1db53af802573\":\"0x3635c9adc5dea00000\",\"0xe80e7fef18a5db15b01473f3ad6b78b2a2f8acd9\":\"0x1b1ae4d6e2ef500000\",\"0xe8137fc1b2ec7cc7103af921899b4a39e1d959a1\":\"0x50c5e761a444080000\",\"0xe81c2d346c0adf4cc56708f6394ba6c8c8a64a1e\":\"0x6c6b935b8bbd400000\",\"0xe82c58c579431b673546b53a86459acaf1de9b93\":\"0x3635c9adc5dea00000\",\"0xe834c64318205ca7dd4a21abcb08266cb21ff02c\":\"0x3635c6204739d98000\",\"0xe83604e4ff6be7f96f6018d3ec3072ec525dff6b\":\"0x9ddc1e3b901180000\",\"0xe845e387c4cbdf982280f6aa01c40e4be958ddb2\":\"0x54b40b1f852bda00000\",\"0xe848ca7ebff5c24f9b9c316797a43bf7c356292d\":\"0x62e115c008a880000\",\"0xe84b55b525f1039e744b918cb3332492e45eca7a\":\"0xad78ebc5ac6200000\",\"0xe84f8076a0f2969ecd333eef8de41042986291f2\":\"0x176b344f2a78c00000\",\"0xe864fec07ed1214a65311e11e329de040d04f0fd\":\"0x59ca83f5c404968000\",\"0xe87dbac636a37721df54b08a32ef4959b5e4ff82\":\"0x6c6b935b8bbd400000\",\"0xe87e9bbfbbb71c1a740c74c723426df55d063dd9\":\"0x1b1928c00c7a6380000\",\"0xe87eac6d602b4109c9671bf57b950c2cfdb99d55\":\"0x2b4f21972ecce0000\",\"0xe881bbbe69722d81efecaa48d1952a10a2bfac8f\":\"0x3635c9adc5dea000000\",\"0xe89249738b7eced7cb666a663c49cbf6de8343ea\":\"0x6c6b935b8bbd400000\",\"0xe89c22f1a4e1d4746ecfaa59ed386fee12d51e37\":\"0x26f8e87f0a7da0000\",\"0xe89da96e06beaf6bd880b378f0680c43fd2e9d30\":\"0x209a1a01a56fec0000\",\"0xe8a91da6cf1b9d65c74a02ec1f96eecb6dd241f3\":\"0x692ae8897081d00000\",\"0xe8a9a41740f44f54c3688b53e1ddd42e43c9fe94\":\"0xd8d726b7177a800000\",\"0xe8b28acda971725769db8f563d28666d41ddab6c\":\"0x21e19e0c9bab2400000\",\"0xe8be24f289443ee473bc76822f55098d89b91cc5\":\"0x6c6b935b8bbd400000\",\"0xe8c3d3b0e17f97d1e756e684f94e1470f99c95a1\":\"0x15af1d78b58c400000\",\"0xe8c3f045bb7d38c9d2f395b0ba8492b253230901\":\"0x1e7e4171bf4d3a00000\",\"0xe8cc43bc4f8acf39bff04ebfbf42aac06a328470\":\"0x15af1d78b58c400000\",\"0xe8d942d82f175ecb1c16a405b10143b3f46b963a\":\"0x1ed2e8ff6d971c0000\",\"0xe8ddbed732ebfe754096fde9086b8ea4a4cdc616\":\"0x6c6b935b8bbd400000\",\"0xe8de725eca5def805ff7941d31ac1c2e342dfe95\":\"0x857e0d6f1da76a0000\",\"0xe8e9850586e94f5299ab494bb821a5f40c00bd04\":\"0xcf152640c5c8300000\",\"0xe8ead1bb90ccc3aea2b0dcc5b58056554655d1d5\":\"0x1a4aba225c207400000\",\"0xe8eaf12944092dc3599b3953fa7cb1c9761cc246\":\"0x6194049f30f7200000\",\"0xe8ed51bbb3ace69e06024b33f86844c47348db9e\":\"0x22f9ea89f4a7d6c40000\",\"0xe8ef100d7ce0895832f2678df72d4acf8c28b8e3\":\"0x1b1b6bd7af64c70000\",\"0xe8f29969e75c65e01ce3d86154207d0a9e7c76f2\":\"0xa22fa9a73a27198000\",\"0xe8fc36b0131ec120ac9e85afc10ce70b56d8b6ba\":\"0xad78ebc5ac6200000\",\"0xe90a354cec04d69e5d96ddc0c5138d3d33150aa0\":\"0x1b1a7dcf8a44d38000\",\"0xe9133e7d31845d5f2b66a2618792e869311acf66\":\"0x517c0cbf9a390880000\",\"0xe91dac0195b19e37b59b53f7c017c0b2395ba44c\":\"0x65ea3db75546600000\",\"0xe91fa0badaddb9a97e88d3f4db7c55d6bb7430fe\":\"0x14620c57dddae00000\",\"0xe923c06177b3427ea448c0a6ff019b54cc548d95\":\"0x1f780014667f28000\",\"0xe93d47a8ca885d540c4e526f25d5c6f2c108c4b8\":\"0x17da3a04c7b3e0000000\",\"0xe9458f68bb272cb5673a04f781b403556fd3a387\":\"0x34e8b88cee2d40000\",\"0xe94941b6036019b4016a30c1037d5a6903babaad\":\"0x2a48acab6204b00000\",\"0xe9495ba5842728c0ed97be37d0e422b98d69202c\":\"0x6c6b935b8bbd400000\",\"0xe94ded99dcb572b9bb1dcba32f6dee91e057984e\":\"0x155bd9307f9fe80000\",\"0xe95179527deca5916ca9a38f215c1e9ce737b4c9\":\"0x21e19e0c9bab2400000\",\"0xe9559185f166fc9513cc71116144ce2deb0f1d4b\":\"0x43c33c1937564800000\",\"0xe95e92bbc6de07bf3a660ebf5feb1c8a3527e1c5\":\"0xfc936392801c0000\",\"0xe965daa34039f7f0df62375a37e5ab8a72b301e7\":\"0x103fddecdb3f5700000\",\"0xe969ea1595edc5c4a707cfde380929633251a2b0\":\"0xad78ebc5ac6200000\",\"0xe96b184e1f0f54924ac874f60bbf44707446b72b\":\"0x9dcc0515b56e0c0000\",\"0xe96d7d4cdd15553a4e4d316d6d6480ca3cea1e38\":\"0x2955d02e1a135a00000\",\"0xe96e2d3813efd1165f12f602f97f4a62909d3c66\":\"0x7caee97613e6700000\",\"0xe97fde0b67716325cf0ecce8a191a3761b2c791d\":\"0x3677036edf0af60000\",\"0xe982e6f28c548f5f96f45e63f7ab708724f53fa1\":\"0x157ae829a41f3b0000\",\"0xe9864c1afc8eaad37f3ba56fcb7477cc622009b7\":\"0x448586170a7dc0000\",\"0xe987e6139e6146a717fef96bc24934a5447fe05d\":\"0x6c6b935b8bbd400000\",\"0xe989733ca1d58d9e7b5029ba5d444858bec03172\":\"0x1f87408313df4f8000\",\"0xe98c91cadd924c92579e11b41217b282956cdaa1\":\"0x75c9a8480320c0000\",\"0xe99aece90541cae224b87da673965e0aeb296afd\":\"0x31df9095a18f600000\",\"0xe99de258a4173ce9ac38ede26c0b3bea3c0973d5\":\"0x59d0b805e5bb300000\",\"0xe9a2b4914e8553bf0d7c00ca532369b879f931bf\":\"0x6c6b935b8bbd400000\",\"0xe9a39a8bac0f01c349c64cedb69897f633234ed2\":\"0xd7c198710e66b00000\",\"0xe9a5ae3c9e05977dd1069e9fd9d3aefbae04b8df\":\"0x6acb3df27e1f880000\",\"0xe9ac36376efa06109d40726307dd1a57e213eaa9\":\"0xa844a7424d9c80000\",\"0xe9b1f1fca3fa47269f21b061c353b7f5e96d905a\":\"0x1b1ae4d6e2ef500000\",\"0xe9b36fe9b51412ddca1a521d6e94bc901213dda8\":\"0x21e19e0c9bab2400000\",\"0xe9b4a4853577a9dbcc2e795be0310d1bed28641a\":\"0x3635c9adc5dea00000\",\"0xe9b6a790009bc16642c8d820b7cde0e9fd16d8f5\":\"0xc55325ca7415e00000\",\"0xe9b9a2747510e310241d2ece98f56b3301d757e0\":\"0x6c6b935b8bbd400000\",\"0xe9c35c913ca1fceab461582fe1a5815164b4fd21\":\"0x1b1ae4d6e2ef5000000\",\"0xe9c6dfae97f7099fc5f4e94b784db802923a1419\":\"0x2a53c6d724f100000\",\"0xe9c758f8da41e3346e4350e5ac3976345c6c1082\":\"0x68a0d3092826ad0000\",\"0xe9caf827be9d607915b365c83f0d3b7ea8c79b50\":\"0xa2a15d09519be00000\",\"0xe9cafe41a5e8bbd90ba02d9e06585b4eb546c57f\":\"0x6c6b935b8bbd400000\",\"0xe9d599456b2543e6db80ea9b210e908026e2146e\":\"0xad78ebc5ac6200000\",\"0xe9e1f7cb00a110edd0ebf8b377ef8a7bb856117f\":\"0xad78ebc5ac6200000\",\"0xea14bfda0a6e76668f8788321f07df37824ec5df\":\"0x2a5a058fc295ed000000\",\"0xea1ea0c599afb9cd36caacbbb52b5bbb97597377\":\"0x39fbae8d042dd00000\",\"0xea1efb3ce789bedec3d67c3e1b3bc0e9aa227f90\":\"0x27ca4bd719f0b80000\",\"0xea2c197d26e98b0da83e1b72c787618c979d3db0\":\"0x11164759ffb320000\",\"0xea3779d14a13f6c78566bcde403591413a6239db\":\"0x29b76432b94451200000\",\"0xea4e809e266ae5f13cdbe38f9d0456e6386d1274\":\"0xf3f20b8dfa69d00000\",\"0xea53c954f4ed97fd4810111bdab69ef981ef25b9\":\"0x3a9d5baa4abf1d00000\",\"0xea53d26564859d9e90bb0e53b7abf560e0162c38\":\"0x15af1d78b58c400000\",\"0xea60436912de6bf187d3a472ff8f5333a0f7ed06\":\"0x11164759ffb320000\",\"0xea60549ec7553f511d2149f2d4666cbd9243d93c\":\"0x6c6b935b8bbd400000\",\"0xea66e7b84dcdbf36eea3e75b85382a75f1a15d96\":\"0x5dbc9191266f118000\",\"0xea686c5057093c171c66db99e01b0ececb308683\":\"0x14dda85d2ce1478000\",\"0xea6afe2cc928ac8391eb1e165fc40040e37421e7\":\"0xa27fa063b2e2e68000\",\"0xea79057dabef5e64e7b44f7f18648e7e533718d2\":\"0xad78ebc5ac6200000\",\"0xea7c4d6dc729cd6b157c03ad237ca19a209346c3\":\"0x6c6b935b8bbd400000\",\"0xea8168fbf225e786459ca6bb18d963d26b505309\":\"0x1b1ae4d6e2ef500000\",\"0xea81ca8638540cd9d4d73d060f2cebf2241ffc3e\":\"0x6acb3df27e1f880000\",\"0xea8317197959424041d9d7c67a3ece1dbb78bb55\":\"0x155bd9307f9fe80000\",\"0xea8527febfa1ade29e26419329d393b940bbb7dc\":\"0x6c6acc67d7b1d40000\",\"0xea8f30b6e4c5e65290fb9864259bc5990fa8ee8a\":\"0x1158e460913d00000\",\"0xea94f32808a2ef8a9bf0861d1d2404f7b7be258a\":\"0x1158e460913d00000\",\"0xeaa45cea02d87d2cc8fda9434e2d985bd4031584\":\"0x681fc2cc6e2b8b0000\",\"0xeab0bd148309186cf8cbd13b7232d8095acb833a\":\"0x2439a881c6a717c0000\",\"0xeabb90d37989aab31feae547e0e6f3999ce6a35d\":\"0x6c6b935b8bbd400000\",\"0xeac0827eff0c6e3ff28a7d4a54f65cb7689d7b99\":\"0x9ad9e69f9d47520000\",\"0xeac1482826acb6111e19d340a45fb851576bed60\":\"0x1be8bab04d9be8000\",\"0xeac17b81ed5191fb0802aa54337313834107aaa4\":\"0x1b1ae4d6e2ef5000000\",\"0xeac3af5784927fe9a598fc4eec38b8102f37bc58\":\"0x3635c9adc5dea00000\",\"0xeac6b98842542ea10bb74f26d7c7488f698b6452\":\"0x43c33c1937564800000\",\"0xeac768bf14b8f9432e69eaa82a99fbeb94cd0c9c\":\"0x14dbb2195ca228900000\",\"0xead21c1deccfbf1c5cd96688a2476b69ba07ce4a\":\"0x3f24d8e4a00700000\",\"0xead4d2eefb76abae5533961edd11400406b298fc\":\"0xd255d112e103a00000\",\"0xead65262ed5d122df2b2751410f98c32d1238f51\":\"0x58317ed46b9b80000\",\"0xead75016e3a0815072b6b108bcc1b799acf0383e\":\"0x6c6b935b8bbd400000\",\"0xeaea23aa057200e7c9c15e8ff190d0e66c0c0e83\":\"0x6c6b935b8bbd400000\",\"0xeaed16eaf5daab5bf0295e5e077f59fb8255900b\":\"0xd8d726b7177a800000\",\"0xeaedcc6b8b6962d5d9288c156c579d47c0a9fcff\":\"0x49b9ca9a694340000\",\"0xeaf52388546ec35aca6f6c6393d8d609de3a4bf3\":\"0x1158e460913d00000\",\"0xeb10458daca79e4a6b24b29a8a8ada711b7f2eb6\":\"0xd8bb6549b02bb80000\",\"0xeb1cea7b45d1bd4d0e2a007bd3bfb354759e2c16\":\"0xabbcd4ef377580000\",\"0xeb25481fcd9c221f1ac7e5fd1ecd9307a16215b8\":\"0xaadec983fcff40000\",\"0xeb2ef3d38fe652403cd4c9d85ed7f0682cd7c2de\":\"0x90f534608a728800000\",\"0xeb3bdd59dcdda5a9bb2ac1641fd02180f5f36560\":\"0x165c96647b38a200000\",\"0xeb3ce7fc381c51db7d5fbd692f8f9e058a4c703d\":\"0xad78ebc5ac6200000\",\"0xeb453f5a3adddd8ab56750fadb0fe7f94d9c89e7\":\"0x1158e460913d00000\",\"0xeb4f00e28336ea09942588eeac921811c522143c\":\"0x6c6b935b8bbd400000\",\"0xeb52ab10553492329c1c54833ae610f398a65b9d\":\"0x83d6c7aab63600000\",\"0xeb570dba975227b1c42d6e8dea2c56c9ad960670\":\"0x6c6b935b8bbd400000\",\"0xeb6394a7bfa4d28911d5a5b23e93f35e340c2294\":\"0x43a77aabd00780000\",\"0xeb6810691d1ae0d19e47bd22cebee0b3ba27f88a\":\"0x87856315d878150000\",\"0xeb76424c0fd597d3e341a9642ad1ee118b2b579d\":\"0xd8d726b7177a800000\",\"0xeb7c202b462b7cc5855d7484755f6e26ef43a115\":\"0x6c6b935b8bbd400000\",\"0xeb835c1a911817878a33d167569ea3cdd387f328\":\"0x3635c9adc5dea00000\",\"0xeb89a882670909cf377e9e78286ee97ba78d46c2\":\"0x2b7cc2e9c3225c0000\",\"0xeb90c793b3539761e1c814a29671148692193eb4\":\"0x28a857425466f800000\",\"0xeb9cc9fe0869d2dab52cc7aae8fd57adb35f9feb\":\"0x6a93bb17af81f80000\",\"0xeba388b0da27c87b1cc0eac6c57b2c5a0b459c1a\":\"0x170a0f5040e50400000\",\"0xebaa216de9cc5a43031707d36fe6d5bedc05bdf0\":\"0x6ac5c62d9486070000\",\"0xebac2b4408ef5431a13b8508e86250982114e145\":\"0xd8d726b7177a800000\",\"0xebb62cf8e22c884b1b28c6fa88fbbc17938aa787\":\"0x2b42798403c9b80000\",\"0xebb7d2e11bc6b58f0a8d45c2f6de3010570ac891\":\"0x1731790534df20000\",\"0xebbb4f2c3da8be3eb62d1ffb1f950261cf98ecda\":\"0x6c6b935b8bbd400000\",\"0xebbd4db9019952d68b1b0f6d8cf0683c00387bb5\":\"0x120401563d7d910000\",\"0xebbeeb259184a6e01cccfc2207bbd883785ac90a\":\"0x219bc1b04783d30000\",\"0xebd356156a383123343d48843bffed6103e866b3\":\"0x6acb3df27e1f880000\",\"0xebd37b256563e30c6f9289a8e2702f0852880833\":\"0x6c6acc67d7b1d40000\",\"0xebe46cc3c34c32f5add6c3195bb486c4713eb918\":\"0x3635c9adc5dea00000\",\"0xebff84bbef423071e604c361bba677f5593def4e\":\"0x21e19e0c9bab2400000\",\"0xec0927bac7dc36669c28354ab1be83d7eec30934\":\"0x6c6b935b8bbd400000\",\"0xec0e18a01dc4dc5daae567c3fa4c7f8f9b590205\":\"0x111ffe404a41e60000\",\"0xec11362cec810985d0ebbd7b73451444985b369f\":\"0x65a4e49577057318000\",\"0xec2cb8b9378dff31aec3c22e0e6dadff314ab5dd\":\"0x6c6b935b8bbd400000\",\"0xec30addd895b82ee319e54fb04cb2bb03971f36b\":\"0x6c6b935b8bbd400000\",\"0xec3b8b58a12703e581ce5ffd7e21c57d1e5c663f\":\"0x5c283d410394100000\",\"0xec4867d2175ab5b9469361595546554684cda460\":\"0xa2a15d09519be00000\",\"0xec4d08aa2e47496dca87225de33f2b40a8a5b36f\":\"0x890b0c2e14fb80000\",\"0xec58bc0d0c20d8f49465664153c5c196fe59e6be\":\"0x15af1d78b58c400000\",\"0xec5b198a00cfb55a97b5d53644cffa8a04d2ab45\":\"0x6c6b935b8bbd400000\",\"0xec5df227bfa85d7ad76b426e1cee963bc7f519dd\":\"0x3635c9adc5dea00000\",\"0xec5feafe210c12bfc9a5d05925a123f1e73fbef8\":\"0x608fcf3d88748d000000\",\"0xec6904bae1f69790591709b0609783733f2573e3\":\"0x1b1ae4d6e2ef500000\",\"0xec73114c5e406fdbbe09b4fa621bd70ed54ea1ef\":\"0x53025cd216fce500000\",\"0xec73833de4b810bb027810fc8f69f544e83c12d1\":\"0x3635c9adc5dea00000\",\"0xec75b4a47513120ba5f86039814f1998e3817ac3\":\"0x9b0bce2e8fdba0000\",\"0xec76f12e57a65504033f2c0bce6fc03bd7fa0ac4\":\"0xc2127af858da700000\",\"0xec8014efc7cbe5b0ce50f3562cf4e67f8593cd32\":\"0xf015f25736420000\",\"0xec82f50d06475f684df1b392e00da341aa145444\":\"0x6c6b935b8bbd400000\",\"0xec83e798c396b7a55e2a2224abcd834b27ea459c\":\"0x28a857425466f800000\",\"0xec89f2b678a1a15b9134ec5eb70c6a62071fbaf9\":\"0xad78ebc5ac6200000\",\"0xec8c1d7b6aaccd429db3a91ee4c9eb1ca4f6f73c\":\"0xe664992288f2280000\",\"0xec9851bd917270610267d60518b54d3ca2b35b17\":\"0x878678326eac9000000\",\"0xec99e95dece46ffffb175eb6400fbebb08ee9b95\":\"0x56bc75e2d63100000\",\"0xeca5f58792b8c62d2af556717ee3ee3028be4dce\":\"0x6c6b935b8bbd400000\",\"0xecab5aba5b828de1705381f38bc744b32ba1b437\":\"0x32f51edbaaa3300000\",\"0xecaf3350b7ce144d068b186010852c84dd0ce0f0\":\"0x6c6b935b8bbd400000\",\"0xecb94c568bfe59ade650645f4f26306c736cace4\":\"0xe7eeba3410b740000\",\"0xecbe425e670d39094e20fb5643a9d818eed236de\":\"0x10f0cf064dd59200000\",\"0xecbe5e1c9ad2b1dccf0a305fc9522f4669dd3ae7\":\"0x10f0cf064dd59200000\",\"0xeccf7a0457b566b346ca673a180f444130216ac3\":\"0x56bc75e2d63100000\",\"0xecd1a62802351a41568d23033004acc6c005a5d3\":\"0x2b5e3af16b1880000\",\"0xecd276af64c79d1bd9a92b86b5e88d9a95eb88f8\":\"0x1158e460913d00000\",\"0xecd486fc196791b92cf612d348614f9156488b7e\":\"0x28a857425466f800000\",\"0xecdaf93229b45ee672f65db506fb5eca00f7fce6\":\"0x5701f96dcc40ee8000\",\"0xece111670b563ccdbebca52384290ecd68fe5c92\":\"0x1158e460913d00000\",\"0xece1152682b7598fe2d1e21ec15533885435ac85\":\"0xd8d726b7177a800000\",\"0xece1290877b583e361a2d41b009346e6274e2538\":\"0x1043561a8829300000\",\"0xecf05d07ea026e7ebf4941002335baf2fed0f002\":\"0xad78ebc5ac6200000\",\"0xecf24cdd7c22928c441e694de4aa31b0fab59778\":\"0x2086ac351052600000\",\"0xecfd004d02f36cd4d8b4a8c1a9533b6af85cd716\":\"0x10f41acb4bb3b9c0000\",\"0xed0206cb23315128f8caff26f6a30b985467d022\":\"0x878678326eac9000000\",\"0xed1065dbcf9d73c04ffc7908870d881468c1e132\":\"0x6c6b935b8bbd400000\",\"0xed1276513b6fc68628a74185c2e20cbbca7817bf\":\"0xa5aa85009e39c0000\",\"0xed12a1ba1fb8adfcb20dfa19582e525aa3b74524\":\"0x16a6502f15a1e540000\",\"0xed16ce39feef3bd7f5d162045e0f67c0f00046bb\":\"0x1158e460913d00000\",\"0xed1a5c43c574d4e934299b24f1472cdc9fd6f010\":\"0xad78ebc5ac6200000\",\"0xed1b24b6912d51b334ac0de6e771c7c0454695ea\":\"0x22b1c8c1227a00000\",\"0xed1f1e115a0d60ce02fb25df014d289e3a0cbe7d\":\"0x1b1ae4d6e2ef500000\",\"0xed31305c319f9273d3936d8f5b2f71e9b1b22963\":\"0x56bc75e2d63100000\",\"0xed327a14d5cfadd98103fc0999718d7ed70528ea\":\"0x4e1003b28d92800000\",\"0xed3cbc3782cebd67989b305c4133b2cde32211eb\":\"0x15af1d78b58c400000\",\"0xed4014538cee664a2fbcb6dc669f7ab16d0ba57c\":\"0xad78ebc5ac6200000\",\"0xed41e1a28f5caa843880ef4e8b08bd6c33141edf\":\"0x2ad5ddfa7a8d830000\",\"0xed4be04a052d7accb3dcce90319dba4020ab2c68\":\"0x7f37a70eaf362178000\",\"0xed52a2cc0869dc9e9f842bd0957c47a8e9b0c9ff\":\"0x205b4dfa1ee74780000\",\"0xed5b4c41e762d942404373caf21ed4615d25e6c1\":\"0x6d2d4f3d9525b40000\",\"0xed60c4ab6e540206317e35947a63a9ca6b03e2cb\":\"0x31ad9ad0b467f8000\",\"0xed641e06368fb0efaa1703e01fe48f4a685309eb\":\"0xad78ebc5ac6200000\",\"0xed6643c0e8884b2d3211853785a08bf8f33ed29f\":\"0x487a9a304539440000\",\"0xed70a37cdd1cbda9746d939658ae2a6181288578\":\"0x2086ac3510526000000\",\"0xed7346766e1a676d0d06ec821867a276a083bf31\":\"0xd98a0931cc2d490000\",\"0xed862616fcbfb3becb7406f73c5cbff00c940755\":\"0x5c283d410394100000\",\"0xed9e030ca75cb1d29ea01d0d4cdfdccd3844b6e4\":\"0x1acc116cfafb18000\",\"0xed9ebccba42f9815e78233266dd6e835b6afc31b\":\"0x14542ba12a337c00000\",\"0xed9fb1f5af2fbf7ffc5029cee42b70ff5c275bf5\":\"0xf2dc7d47f15600000\",\"0xeda4b2fa59d684b27a810df8978a73df308a63c2\":\"0xd8d726b7177a800000\",\"0xedb473353979a206879de144c10a3c51d7d7081a\":\"0x14542ba12a337c00000\",\"0xedb71ec41bda7dce86e766e6e8c3e9907723a69b\":\"0x1158e460913d00000\",\"0xedbac9527b54d6df7ae2e000cca3613ba015cae3\":\"0x6acb3df27e1f880000\",\"0xedc22fb92c638e1e21ff5cf039daa6e734dafb29\":\"0x102794ad20da680000\",\"0xeddacd94ec89a2ef968fcf977a08f1fae2757869\":\"0x1b1ae4d6e2ef5000000\",\"0xeddbaafbc21be8f25562f1ed6d05d6afb58f02c2\":\"0x6c6b935b8bbd400000\",\"0xede0147ec032c3618310c1ff25690bf172193dac\":\"0x6c6b935b8bbd400000\",\"0xede5de7c7fb7eee0f36e64530a41440edfbefacf\":\"0x21755ee1ef2b180000\",\"0xede79ae1ff4f1606d59270216fa46ab2ddd4ecaa\":\"0x7ea28327577080000\",\"0xede8c2cb876fbe8a4cca8290361a7ea01a69fdf8\":\"0x1a78c6b44f841838000\",\"0xedeb4894aadd0081bbddd3e8846804b583d19f27\":\"0x6c6b935b8bbd400000\",\"0xedf603890228d7d5de9309942b5cad4219ef9ad7\":\"0x10f0cf064dd59200000\",\"0xedf8a3e1d40f13b79ec8e3e1ecf262fd92116263\":\"0x890b0c2e14fb80000\",\"0xedfda2d5db98f9380714664d54b4ee971a1cae03\":\"0x22bb8ddd679be0000\",\"0xee0007b0960d00908a94432a737557876aac7c31\":\"0x2e0421e69c4cc8000\",\"0xee049af005974dd1c7b3a9ca8d9aa77175ba53aa\":\"0x1211ecb56d13488000\",\"0xee25b9a7032679b113588ed52c137d1a053a1e94\":\"0xad50f3f4eea8e0000\",\"0xee31167f9cc93b3c6465609d79db0cde90e8484c\":\"0x6c6b935b8bbd400000\",\"0xee34c7e7995db9f187cff156918cfb6f13f6e003\":\"0x6a4076cf7995a00000\",\"0xee3564f5f1ba0f94ec7bac164bddbf31c6888b55\":\"0x56bc75e2d63100000\",\"0xee58fb3db29070d0130188ce472be0a172b89055\":\"0x21f42dcdc58e39c0000\",\"0xee655bb4ee0e8d5478526fb9f15e4064e09ff3dd\":\"0xad78ebc5ac6200000\",\"0xee6959de2b67967b71948c891ab00d8c8f38c7dc\":\"0x6685ac1bfe32c0000\",\"0xee6c03429969ca1262cb3f0a4a54afa7d348d7f5\":\"0xde219f91fc18a0000\",\"0xee71793e3acf12a7274f563961f537529d89c7de\":\"0x6c6b935b8bbd400000\",\"0xee7288d91086d9e2eb910014d9ab90a02d78c2a0\":\"0x6c6b935b8bbd400000\",\"0xee7c3ded7c28f459c92fe13b4d95bafbab02367d\":\"0x25f273933db5700000\",\"0xee867d20916bd2e9c9ece08aa04385db667c912e\":\"0xa968163f0a57b400000\",\"0xee899b02cbcb3939cd61de1342d50482abb68532\":\"0x5f68e8131ecf800000\",\"0xee906d7d5f1748258174be4cbc38930302ab7b42\":\"0xad78ebc5ac6200000\",\"0xee97aa8ac69edf7a987d6d70979f8ec1fbca7a94\":\"0x14620c57dddae00000\",\"0xeea1e97988de75d821cd28ad6822b22cce988b31\":\"0x1c30731cec03200000\",\"0xeed28c3f068e094a304b853c950a6809ebcb03e0\":\"0x3a9d5baa4abf1d00000\",\"0xeed384ef2d41d9d203974e57c12328ea760e08ea\":\"0x3635c9adc5dea00000\",\"0xeedf6c4280e6eb05b934ace428e11d4231b5905b\":\"0xad78ebc5ac6200000\",\"0xeee761847e33fd61d99387ee14628694d1bfd525\":\"0x6c6b935b8bbd400000\",\"0xeee9d0526eda01e43116a395322dda8970578f39\":\"0x21e1999bbd5d2be0000\",\"0xeef1bbb1e5a83fde8248f88ee3018afa2d1332eb\":\"0xad78ebc5ac6200000\",\"0xeefba12dfc996742db790464ca7d273be6e81b3e\":\"0x3635c9adc5dea00000\",\"0xeefd05b0e3c417d55b3343060486cdd5e92aa7a6\":\"0x4d853c8f8908980000\",\"0xef0dc7dd7a53d612728bcbd2b27c19dd4d7d666f\":\"0x26411c5b35f05a0000\",\"0xef115252b1b845cd857f002d630f1b6fa37a4e50\":\"0x6acb3df27e1f880000\",\"0xef1c0477f1184d60accab374d374557a0a3e10f3\":\"0x83d6c7aab63600000\",\"0xef2c34bb487d3762c3cca782ccdd7a8fbb0a9931\":\"0x9c2007651b2500000\",\"0xef35f6d4b1075e6aa139151c974b2f4658f70538\":\"0x3c3bc33f94e50d8000\",\"0xef39ca9173df15531d73e6b72a684b51ba0f2bb4\":\"0x56a0b4756ee2380000\",\"0xef463c2679fb279164e20c3d2691358773a0ad95\":\"0x6c6b935b8bbd400000\",\"0xef47cf073e36f271d522d7fa4e7120ad5007a0bc\":\"0x878678326eac900000\",\"0xef61155ba009dcdebef10b28d9da3d1bc6c9ced4\":\"0x3342d60dff1960000\",\"0xef69781f32ffce33346f2c9ae3f08493f3e82f89\":\"0xfc936392801c0000\",\"0xef76a4cd8febcbc9b818f17828f8d93473f3f3cb\":\"0xd8d726b7177a800000\",\"0xef93818f684db0c3675ec81332b3183ecc28a495\":\"0x54069233bf7f780000\",\"0xef9f59aeda418c1494682d941aab4924b5f4929a\":\"0x152d02c7e14af6800000\",\"0xefa6b1f0db603537826891b8b4bc163984bb40cd\":\"0x35659ef93f0fc40000\",\"0xefbd52f97da5fd3a673a46cbf330447b7e8aad5c\":\"0x56c3c9b80a0a68000\",\"0xefc8cf1963c9a95267b228c086239889f4dfd467\":\"0x21e19e0c9bab2400000\",\"0xefcaae9ff64d2cd95b5249dcffe7faa0a0c0e44d\":\"0x15be6174e1912e0000\",\"0xefcce06bd6089d0e458ef561f5a689480afe7000\":\"0x2086ac351052600000\",\"0xefe0675da98a5dda70cd96196b87f4e726b43348\":\"0x3f19beb8dd1ab00000\",\"0xefe8ff87fc260e0767638dd5d02fc4672e0ec06d\":\"0x6c6b935b8bbd400000\",\"0xefeb1997aad277cc33430e6111ed0943594048b8\":\"0x6c6b935b8bbd400000\",\"0xefeea010756f81da4ba25b721787f058170befbd\":\"0x1c29c9cf770ef0000\",\"0xeff51d72adfae143edf3a42b1aec55a2ccdd0b90\":\"0x1043561a8829300000\",\"0xeff86b5123bcdc17ed4ce8e05b7e12e51393a1f7\":\"0x1b1ae4d6e2ef500000\",\"0xeffc15e487b1beda0a8d1325bdb4172240dc540a\":\"0x3853939eee1de0000\",\"0xf01195d657ef3c942e6cb83949e5a20b5cfa8b1e\":\"0x57473d05dabae800000\",\"0xf02796295101674288c1d93467053d042219b794\":\"0x281d901f4fdd100000\",\"0xf039683d7b3d225bc7d8dfadef63163441be41e2\":\"0x1dd1e4bd8d1ee0000\",\"0xf04a6a379708b9428d722aa2b06b77e88935cf89\":\"0x1043561a8829300000\",\"0xf04d2c91efb6e9c45ffbe74b434c8c5f2b028f1f\":\"0x3635c9adc5dea00000\",\"0xf057aa66ca767ede124a1c5b9cc5fc94ef0b0137\":\"0x70a24bcab6f45d0000\",\"0xf05ba8d7b68539d933300bc9289c3d9474d0419e\":\"0x6da27024dd9600000\",\"0xf05ceeab65410564709951773c8445ad9f4ec797\":\"0x10431627a0933b0000\",\"0xf05fcd4c0d73aa167e5553c8c0d6d4f2faa39757\":\"0x2d2d66c3170b2980000\",\"0xf067e1f1d683556a4cc4fd0c0313239f32c4cfd8\":\"0x3635c9adc5dea00000\",\"0xf067fb10dfb293e998abe564c055e3348f9fbf1e\":\"0x6c6b935b8bbd400000\",\"0xf068dfe95d15cd3a7f98ffa688b4346842be2690\":\"0x440ad819e0974c0000\",\"0xf06a854a3c5dc36d1c49f4c87d6db333b57e4add\":\"0x21e19e0c9bab2400000\",\"0xf079e1b1265f50e8c8a98ec0c7815eb3aeac9eb4\":\"0x116dc3a8994b30000\",\"0xf07bd0e5c2ce69c7c4a724bd26bbfa9d2a17ca03\":\"0x14061b9d77a5e980000\",\"0xf0832a6bb25503eeca435be31b0bf905ca1fcf57\":\"0x16a6502f15a1e540000\",\"0xf09b3e87f913ddfd57ae8049c731dba9b636dfc3\":\"0x20f5b1eaad8d800000\",\"0xf0b1340b996f6f0bf0d9561c849caf7f4430befa\":\"0x56bc75e2d63100000\",\"0xf0b1f9e27832c6de6914d70afc238c749995ace4\":\"0x6c6b935b8bbd400000\",\"0xf0b469eae89d400ce7d5d66a9695037036b88903\":\"0x43c33c1937564800000\",\"0xf0b9d683cea12ba600baace219b0b3c97e8c00e4\":\"0x56bc75e2d63100000\",\"0xf0be0faf4d7923fc444622d1980cf2d990aab307\":\"0x6c6b935b8bbd400000\",\"0xf0c081da52a9ae36642adf5e08205f05c54168a6\":\"0x6046f37e5945c0000\",\"0xf0c70d0d6dab7663aa9ed9ceea567ee2c6b02765\":\"0x71438ac5a791a08000\",\"0xf0cbef84e169630098d4e301b20208ef05846ac9\":\"0xe0b8345506b4e0000\",\"0xf0d21663d8b0176e05fde1b90ef31f8530fda95f\":\"0x6c6acc67d7b1d40000\",\"0xf0d5c31ccb6cbe30c7c9ea19f268d159851f8c9c\":\"0x3894f0e6f9b9f700000\",\"0xf0d64cf9df09741133d170485fd24b005011d520\":\"0x1b089341e14fcc0000\",\"0xf0d858105e1b648101ac3f85a0f8222bf4f81d6a\":\"0x2086ac351052600000\",\"0xf0dc43f205619127507b2b1c1cfdf32d28310920\":\"0x105eb79b9417088000\",\"0xf0e1dfa42adeac2f17f6fdf584c94862fd563393\":\"0x1b1ae4d6e2ef500000\",\"0xf0e2649c7e6a3f2c5dfe33bbfbd927ca3c350a58\":\"0x6c6b935b8bbd400000\",\"0xf0e7fb9e420a5340d536f40408344feaefc06aef\":\"0x3635c9adc5dea00000\",\"0xf10462e58fcc07f39584a187639451167e859201\":\"0x934dd5d33bc970000\",\"0xf10661ff94140f203e7a482572437938bec9c3f7\":\"0x43c33c1937564800000\",\"0xf114ff0d0f24eff896edde5471dea484824a99b3\":\"0xbe202d6a0eda0000\",\"0xf116b0b4680f53ab72c968ba802e10aa1be11dc8\":\"0x1158e460913d00000\",\"0xf11cf5d363746fee6864d3ca336dd80679bb87ae\":\"0x878678326eac9000000\",\"0xf11e01c7a9d12499005f4dae7716095a34176277\":\"0x15af1d78b58c400000\",\"0xf13b083093ba564e2dc631568cf7540d9a0ec719\":\"0x6c6acc67d7b1d40000\",\"0xf14f0eb86db0eb68753f16918e5d4b807437bd3e\":\"0xad78ebc5ac6200000\",\"0xf15178ffc43aa8070ece327e930f809ab1a54f9d\":\"0xab640391201300000\",\"0xf156dc0b2a981e5b55d3f2f03b8134e331dbadb7\":\"0x56bc75e2d63100000\",\"0xf15d9d5a21b1929e790371a17f16d95f0c69655c\":\"0x6c6b935b8bbd400000\",\"0xf15e182c4fbbad79bd93342242d4dccf2be58925\":\"0x692ae8897081d00000\",\"0xf1624d980b65336feac5a6d54125005cfcf2aacb\":\"0x6c6b935b8bbd400000\",\"0xf167f5868dcf4233a7830609682caf2df4b1b807\":\"0x81e542e1a7383f0000\",\"0xf16de1891d8196461395f9b136265b3b9546f6ef\":\"0x1b28e1f98bbce8000\",\"0xf17a92e0361dbacecdc5de0d1894955af6a9b606\":\"0x6c6b935b8bbd400000\",\"0xf17adb740f45cbbde3094e7e13716f8103f563bd\":\"0x6c6b935b8bbd400000\",\"0xf18b14cbf6694336d0fe12ac1f25df2da0c05dbb\":\"0xd8d4602c26bf6c0000\",\"0xf19b39389d47b11b8a2c3f1da9124decffbefaf7\":\"0x6c6b935b8bbd400000\",\"0xf19f193508393e4d2a127b20b2031f39c82581c6\":\"0xbdbd7a83bd2f6c0000\",\"0xf1a1f320407964fd3c8f2e2cc8a4580da94f01ea\":\"0x6c6c2177557c440000\",\"0xf1b4ecc63525f7432c3d834ffe2b970fbeb87212\":\"0xa2a24068facd800000\",\"0xf1b58faffa8794f50af8e88309c7a6265455d51a\":\"0x36330322d5238c0000\",\"0xf1c8c4a941b4628c0d6c30fda56452d99c7e1b64\":\"0x4e8cea1ede75040000\",\"0xf1da40736f99d5df3b068a5d745fafc6463fc9b1\":\"0x696ca23058da10000\",\"0xf1dc8ac81042c67a9c3c6792b230c46ac016ca10\":\"0xad78ebc5ac6200000\",\"0xf1df55dcc34a051012b575cb968bc9c458ea09c9\":\"0xd8d726b7177a800000\",\"0xf1e980c559a1a8e5e50a47f8fffdc773b7e06a54\":\"0x65ffbcdea04b7480000\",\"0xf1f391ca92808817b755a8b8f4e2ca08d1fd1108\":\"0x14542ba12a337c00000\",\"0xf1f766b0e46d73fcd4d52e7a72e1b9190cc632b3\":\"0x1b1ae4d6e2ef5000000\",\"0xf2049532fd458a83ca1bff2eebacb6d5ca63f4a4\":\"0xc48c991dc1545c8000\",\"0xf206d328e471d0117b246d2a4619827709e96df3\":\"0xa2af3dc00543440000\",\"0xf20c9a99b74759d782f25c1ceca802a27e0b436c\":\"0x5a87e7d7f5f6580000\",\"0xf2127d54188fedef0f338a5f38c7ff73ad9f6f42\":\"0x43c33c1937564800000\",\"0xf2133431d1d9a37ba2f0762bc40c5acc8aa6978e\":\"0x6c6b935b8bbd400000\",\"0xf21549bdd1487912f900a7523db5f7626121bba3\":\"0x21e19e0c9bab2400000\",\"0xf218bd848ee7f9d38bfdd1c4eb2ed2496ae4305f\":\"0x1b1ae4d6e2ef500000\",\"0xf224eb900b37b4490eee6a0b6420d85c947d8733\":\"0x34957444b840e80000\",\"0xf2294adbb6f0dcc76e632ebef48ab49f124dbba4\":\"0x4e43393600a7b10000\",\"0xf22f4078febbbaa8b0e78e642c8a42f35d433905\":\"0x6c6acc67d7b1d40000\",\"0xf237ef05261c34d79cc22b860de0f17f793c3860\":\"0xad78ebc5ac6200000\",\"0xf23c7b0cb8cd59b82bd890644a57daf40c85e278\":\"0x2b66aafe326ff0000\",\"0xf23d01589eb12d439f7448ff54307529f191858d\":\"0x6c6b935b8bbd400000\",\"0xf23e5c633221a8f7363e65870c9f287424d2a960\":\"0x4acf58e07257100000\",\"0xf242da845d42d4bf779a00f295b40750fe49ea13\":\"0x3635c9adc5dea00000\",\"0xf25259a5c939cd25966c9b6303d3731c53ddbc4c\":\"0xad78ebc5ac6200000\",\"0xf25e4c70bc465632c89e5625a832a7722f6bffab\":\"0xf34b82fd8e91200000\",\"0xf26bcedce3feadcea3bc3e96eb1040dfd8ffe1a0\":\"0x2a034919dfbfbc0000\",\"0xf270792576f05d514493ffd1f5e84bec4b2df810\":\"0x3635c9adc5dea00000\",\"0xf2732cf2c13b8bb8e7492a988f5f89e38273ddc8\":\"0x2086ac351052600000\",\"0xf2742e6859c569d5f2108351e0bf4dca352a48a8\":\"0x21e19e0c9bab2400000\",\"0xf2813a64c5265d020235cb9c319b6c96f906c41e\":\"0x12f939c99edab80000\",\"0xf287ff52f461117adb3e1daa71932d1493c65f2e\":\"0xc55325ca7415e00000\",\"0xf2ab1161750244d0ecd048ee0d3e51abb143a2fd\":\"0x42fe2b907373bc0000\",\"0xf2b4ab2c9427a9015ef6eefff5edb60139b719d1\":\"0x26db992a3b18000000\",\"0xf2c03e2a38998c21648760f1e5ae7ea3077d8522\":\"0x8f3f7193ab079c0000\",\"0xf2c2904e9fa664a11ee25656d8fd2cc0d9a522a0\":\"0xb98bc829a6f90000\",\"0xf2c362b0ef991bc82fb36e66ff75932ae8dd8225\":\"0x402f4cfee62e80000\",\"0xf2d0e986d814ea13c8f466a0538c53dc922651f0\":\"0x4acf58e07257100000\",\"0xf2d1b7357724ec4c03185b879b63f57e26589153\":\"0x14542ba12a337c00000\",\"0xf2d5763ce073127e2cedde6faba786c73ca94141\":\"0x1ac4286100191f00000\",\"0xf2d59c8923759073d6f415aaf8eb065ff2f3b685\":\"0x1ab2cf7c9f87e200000\",\"0xf2e99f5cbb836b7ad36247571a302cbe4b481c69\":\"0x6acb3df27e1f880000\",\"0xf2ed3e77254acb83231dc0860e1a11242ba627db\":\"0x6b56051582a9700000\",\"0xf2edde37f9a8c39ddea24d79f4015757d06bf786\":\"0x152d02c7e14af6800000\",\"0xf2efe96560c9d97b72bd36447843885c1d90c231\":\"0x6c6b935b8bbd400000\",\"0xf2fbb6d887f8b8cc3a869aba847f3d1f643c53d6\":\"0xd8c9460063d31c0000\",\"0xf3034367f87d24d3077fa9a2e38a8b0ccb1104ef\":\"0x3635c9adc5dea00000\",\"0xf303d5a816affd97e83d9e4dac2f79072bb0098f\":\"0x340aad21b3b7000000\",\"0xf3159866c2bc86bba40f9d73bb99f1eee57bb9d7\":\"0x3635c9adc5dea00000\",\"0xf316ef1df2ff4d6c1808dba663ec8093697968e0\":\"0x61464d6cdc80f00000\",\"0xf32d25eb0ea2b8b3028a4c7a155dc1aae865784d\":\"0x13593a9297fdad60000\",\"0xf332c0f3e05a27d9126fd0b641a8c2d4060608fd\":\"0x10f1b62c4d9644e8000\",\"0xf338459f32a159b23db30ac335769ab2351aa63c\":\"0x65a4da25d3016c00000\",\"0xf33efc6397aa65fb53a8f07a0f893aae30e8bcee\":\"0x7cf2381f619f150000\",\"0xf34083ecea385017aa40bdd35ef7effb4ce7762d\":\"0x15af1d78b58c400000\",\"0xf346d7de92741c08fc58a64db55b062dde012d14\":\"0xfff6b1f761e6d0000\",\"0xf355d3ec0cfb907d8dbb1bf3464e458128190bac\":\"0x10b046e7f0d80100000\",\"0xf36df02fbd89607347afce2969b9c4236a58a506\":\"0x6c6b935b8bbd400000\",\"0xf373e9daac0c8675f53b797a160f6fc034ae6b23\":\"0x56bc75e2d63100000\",\"0xf37b426547a1642d8033324814f0ede3114fc212\":\"0x15be6174e1912e0000\",\"0xf37bf78c5875154711cb640d37ea6d28cfcb1259\":\"0xad78ebc5ac6200000\",\"0xf382df583155d8548f3f93440cd5f68cb79d6026\":\"0x38757d027fc1fd5c0000\",\"0xf382e4c20410b951089e19ba96a2fee3d91cce7e\":\"0x111fa56eec2a8380000\",\"0xf38a6ca80168537e974d14e1c3d13990a44c2c1b\":\"0x14542ba12a337c00000\",\"0xf39a9d7aa3581df07ee4279ae6c312ef21033658\":\"0xd8d726b7177a800000\",\"0xf3b668b3f14d920ebc379092db98031b67b219b3\":\"0xad6eedd17cf3b8000\",\"0xf3be99b9103ce7550aa74ff1db18e09dfe32e005\":\"0x6c6b935b8bbd400000\",\"0xf3c1abd29dc57b41dc192d0e384d021df0b4f6d4\":\"0x97ae0cdf8f86f80000\",\"0xf3c4716d1ee5279a86d0163a14618181e16136c7\":\"0x3635c9adc5dea00000\",\"0xf3cc8bcb559465f81bfe583bd7ab0a2306453b9e\":\"0x43c33c1937564800000\",\"0xf3d688f06bbdbf50f9932c4145cbe48ecdf68904\":\"0x1158e460913d00000\",\"0xf3dbcf135acb9dee1a489c593c024f03c2bbaece\":\"0x6c6b935b8bbd400000\",\"0xf3de5f26ef6aded6f06d3b911346ee70401da4a0\":\"0x133ab37d9f9d030000\",\"0xf3df63a97199933330383b3ed7570b96c4812334\":\"0x6c6b935b8bbd400000\",\"0xf3e74f470c7d3a3f0033780f76a89f3ef691e6cb\":\"0xa3cfe631d143640000\",\"0xf3eb1948b951e22df1617829bf3b8d8680ec6b68\":\"0xd8d726b7177a800000\",\"0xf3f1fa3918ca34e2cf7e84670b1f4d8eca160db3\":\"0x24dce54d34a1a00000\",\"0xf3f24fc29e20403fc0e8f5ebbb553426f78270a2\":\"0x56bc75e2d63100000\",\"0xf3fa723552a5d0512e2b62f48dca7b2b8105305b\":\"0x76d41c62494840000\",\"0xf3fe51fde34413c73318b9c85437fe7e820f561a\":\"0x3662325cd18fe00000\",\"0xf400f93d5f5c7e3fc303129ac8fb0c2f786407fa\":\"0x6c6b935b8bbd400000\",\"0xf40b134fea22c6b29c8457f49f000f9cda789adb\":\"0x2086ac351052600000\",\"0xf41557dfdfb1a1bdcefefe2eba1e21fe0a4a9942\":\"0x6acb3df27e1f880000\",\"0xf4177a0d85d48b0e264211ce2aa2efd3f1b47f08\":\"0xc2ccca26b7e80e8000\",\"0xf42f905231c770f0a406f2b768877fb49eee0f21\":\"0xaadec983fcff40000\",\"0xf432b9dbaf11bdbd73b6519fc0a904198771aac6\":\"0x83d6c7aab63600000\",\"0xf43da3a4e3f5fab104ca9bc1a0f7f3bb4a56f351\":\"0x6c6acc67d7b1d40000\",\"0xf447108b98df64b57e871033885c1ad71db1a3f9\":\"0x176f49ead3483508000\",\"0xf44f8551ace933720712c5c491cdb6f2f951736c\":\"0xd8d726b7177a800000\",\"0xf456055a11ab91ff668e2ec922961f2a23e3db25\":\"0xfc936392801c0000\",\"0xf456a75bb99655a7412ce97da081816dfdb2b1f2\":\"0xad78ebc5ac6200000\",\"0xf45b1dcb2e41dc27ffa024daadf619c11175c087\":\"0x11164759ffb320000\",\"0xf463a90cb3f13e1f0643423636beab84c123b06d\":\"0x22b1c8c1227a00000\",\"0xf468906e7edf664ab0d8be3d83eb7ab3f7ffdc78\":\"0x5c283d410394100000\",\"0xf46980e3a4a9d29a6a6e90604537a3114bcb2897\":\"0x1b1ae4d6e2ef500000\",\"0xf46b6b9c7cb552829c1d3dfd8ffb11aabae782f6\":\"0x1236efcbcbb340000\",\"0xf476e1267f86247cc908816f2e7ad5388c952db0\":\"0xd8d726b7177a800000\",\"0xf476f2cb7208a32e051fd94ea8662992638287a2\":\"0x56bc75e2d63100000\",\"0xf47bb134da30a812d003af8dccb888f44bbf5724\":\"0x11959b7fe3395580000\",\"0xf483f607a21fcc28100a018c568ffbe140380410\":\"0x3635c9adc5dea00000\",\"0xf48e1f13f6af4d84b371d7de4b273d03a263278e\":\"0x2086ac351052600000\",\"0xf49c47b3efd86b6e6a5bc9418d1f9fec814b69ef\":\"0x43c33c1937564800000\",\"0xf49f6f9baabc018c8f8e119e0115f491fc92a8a4\":\"0x21e19e0c9bab2400000\",\"0xf4a367b166d2991a2bfda9f56463a09f252c1b1d\":\"0x6acb3df27e1f880000\",\"0xf4a51fce4a1d5b94b0718389ba4e7814139ca738\":\"0x1043561a8829300000\",\"0xf4a9d00cefa97b7a58ef9417fc6267a5069039ee\":\"0x12e89287fa7840000\",\"0xf4aaa3a6163e3706577b49c0767e948a681e16ee\":\"0x6c6b935b8bbd400000\",\"0xf4b1626e24f30bcad9273c527fcc714b5d007b8f\":\"0xad78ebc5ac6200000\",\"0xf4b49100757772f33c177b9a76ba95226c8f3dd8\":\"0x16b352da5e0ed300000\",\"0xf4b6cdcfcb24230b337d770df6034dfbd4e1503f\":\"0x405fdf7e5af85e00000\",\"0xf4b759cc8a1c75f80849ebbcda878dc8f0d66de4\":\"0x15af1d78b58c400000\",\"0xf4ba6a46d55140c439cbcf076cc657136262f4f8\":\"0x6c6b935b8bbd400000\",\"0xf4d67a9044b435b66e8977ff39a28dc4bd53729a\":\"0xad78ebc5ac6200000\",\"0xf4d97664cc4eec9edbe7fa09f4750a663b507d79\":\"0xd8d726b7177a800000\",\"0xf4dc7ba85480bbb3f535c09568aaa3af6f3721c6\":\"0x1871fb6307e35e50000\",\"0xf4ebf50bc7e54f82e9b9bd24baef29438e259ce6\":\"0x21e19e0c9bab2400000\",\"0xf4ec8e97a20aa5f8dd206f55207e06b813df2cc0\":\"0xad78ebc5ac6200000\",\"0xf4ed848ec961739c2c7e352f435ba70a7cd5db38\":\"0x6acb3df27e1f880000\",\"0xf4fc4d39bc0c2c4068a36de50e4ab4d4db7e340a\":\"0x16037df87ef6a0000\",\"0xf504943aaf16796e0b341bbcdf21d11cc586cdd1\":\"0x1e7e4171bf4d3a00000\",\"0xf5061ee2e5ee26b815503677130e1de07a52db07\":\"0x56bc75e2d63100000\",\"0xf509557e90183fbf0f0651a786487bcc428ba175\":\"0xa844a7424d9c80000\",\"0xf50abbd4aa45d3eb88515465a8ba0b310fd9b521\":\"0x16a6502f15a1e540000\",\"0xf50ae7fab4cfb5a646ee04ceadf9bf9dd5a8e540\":\"0xd8d67c2f5895480000\",\"0xf50cbafd397edd556c0678988cb2af5c2617e0a2\":\"0x26d07efe782bb00000\",\"0xf51fded80acb502890e87369741f3722514cefff\":\"0x43c3456ca3c6d110000\",\"0xf52a5882e8927d944b359b26366ba2b9cacfbae8\":\"0x54b41ce2fe63ba80000\",\"0xf52c0a7877345fe0c233bb0f04fd6ab18b6f14ba\":\"0x54cbe55989f38de00000\",\"0xf5437e158090b2a2d68f82b54a5864b95dd6dbea\":\"0xd96c16703b2bfe0000\",\"0xf54c19d9ef3873bfd1f7a622d02d86249a328f06\":\"0x960ae127af32fb28000\",\"0xf5500178cb998f126417831a08c2d7abfff6ab5f\":\"0x46f4f4a5875a9f8000\",\"0xf5534815dc635efa5cc84b2ac734723e21b29372\":\"0x55a6e79ccd1d300000\",\"0xf555a27bb1e2fd4e2cc784caee92939fc06e2fc9\":\"0x6c6b935b8bbd400000\",\"0xf558a2b2dd26dd9593aae04531fd3c3cc3854b67\":\"0xabbcd4ef377580000\",\"0xf56048dd2181d4a36f64fcecc6215481e42abc15\":\"0xad78ebc5ac6200000\",\"0xf56442f60e21691395d0bffaa9194dcaff12e2b7\":\"0xe18398e7601900000\",\"0xf579714a45eb8f52c3d57bbdefd2c15b2e2f11df\":\"0x54915956c409600000\",\"0xf593c65285ee6bbd6637f3be8f89ad40d489f655\":\"0xa2a15d09519be00000\",\"0xf598db2e09a8a5ee7d720d2b5c43bb126d11ecc2\":\"0xad78ebc5ac6200000\",\"0xf59dab1bf8df11327e61f9b7a14b563a96ec3554\":\"0x14542ba12a337c00000\",\"0xf59f9f02bbc98efe097eabb78210979021898bfd\":\"0x21e171a3ec9f72c0000\",\"0xf5a5459fcdd5e5b273830df88eea4cb77ddadfb9\":\"0x409e52b48369a0000\",\"0xf5a7676ad148ae9c1ef8b6f5e5a0c2c473be850b\":\"0xad78ebc5ac6200000\",\"0xf5b068989df29c253577d0405ade6e0e7528f89e\":\"0x57473d05dabae80000\",\"0xf5b6e9061a4eb096160777e26762cf48bdd8b55d\":\"0xdc55fdb17647b0000\",\"0xf5cffbba624e7eb321bc83c60ca68199b4e36671\":\"0x6c6b935b8bbd400000\",\"0xf5d14552b1dce0d6dc1f320da6ffc8a331cd6f0c\":\"0x487a9a304539440000\",\"0xf5d61ac4ca95475e5b7bffd5f2f690b316759615\":\"0x692ae8897081d000000\",\"0xf5d9cf00d658dd45517a48a9d3f5f633541a533d\":\"0x64f5fdf494f780000\",\"0xf5eadcd2d1b8657a121f33c458a8b13e76b65526\":\"0xd8b0f5a5ac24a0000\",\"0xf607c2150d3e1b99f24fa1c7d540add35c4ebe1e\":\"0xa7f1aa07fc8faa0000\",\"0xf60bd735543e6bfd2ea6f11bff627340bc035a23\":\"0x6c6b935b8bbd400000\",\"0xf60c1b45f164b9580e20275a5c39e1d71e35f891\":\"0x6c6b935b8bbd400000\",\"0xf60f62d73937953fef35169e11d872d2ea317eec\":\"0x121ea68c114e5100000\",\"0xf61283b4bd8504058ca360e993999b62cbc8cd67\":\"0xdd2d5fcf3bc9c0000\",\"0xf617b967b9bd485f7695d2ef51fb7792d898f500\":\"0x1b1ae4d6e2ef500000\",\"0xf618d9b104411480a863e623fc55232d1a4f48aa\":\"0xe689e6d44b1668000\",\"0xf622e584a6623eaaf99f2be49e5380c5cbcf5cd8\":\"0xad78ebc5ac6200000\",\"0xf632adff490da4b72d1236d04b510f74d2faa3cd\":\"0x4be4e7267b6ae00000\",\"0xf639ac31da9f67271bd10402b7654e5ce763bd47\":\"0x15af0f42baf9260000\",\"0xf63a579bc3eac2a9490410128dbcebe6d9de8243\":\"0x50c5e761a444080000\",\"0xf645dd7c890093e8e4c8aa92a6bb353522d3dc98\":\"0x7439fa2099e580000\",\"0xf648ea89c27525710172944e79edff847803b775\":\"0x152d02c7e14af6800000\",\"0xf64a4ac8d540a9289c68d960d5fb7cc45a77831c\":\"0x6c6b935b8bbd400000\",\"0xf64ecf2117931c6d535a311e4ffeaef9d49405b8\":\"0x90f534608a72880000\",\"0xf64fe0939a8d1eea2a0ecd9a9730fd7958e33109\":\"0x11de1e6db450c0000\",\"0xf65616be9c8b797e7415227c9138faa0891742d7\":\"0x2ad373ce668e980000\",\"0xf657fcbe682eb4e8db152ecf892456000b513d15\":\"0x692ae8897081d00000\",\"0xf65819ac4cc14c137f05dd7977c7dae08d1a4ab5\":\"0x58788cb94b1d80000\",\"0xf67bb8e2118bbcd59027666eedf6943ec9f880a5\":\"0xd8d726b7177a800000\",\"0xf68464bf64f2411356e4d3250efefe5c50a5f65b\":\"0x1158e460913d00000\",\"0xf686785b89720b61145fea80978d6acc8e0bc196\":\"0xd8d726b7177a800000\",\"0xf68c5e33fa97139df5b2e63886ce34ebf3e4979c\":\"0xb3fa4169e2d8e00000\",\"0xf6a8635757c5e8c134d20d028cf778cf8609e46a\":\"0x4f1d772faec17c0000\",\"0xf6b782f4dcd745a6c0e2e030600e04a24b25e542\":\"0x15af1d78b58c400000\",\"0xf6bc37b1d2a3788d589b6de212dc1713b2f6e78e\":\"0x10f0cf064dd59200000\",\"0xf6c3c48a1ac0a34799f04db86ec7a975fe7768f3\":\"0x6acb3df27e1f880000\",\"0xf6d25d3f3d846d239f525fa8cac97bc43578dbac\":\"0x30927f74c9de000000\",\"0xf6eaac7032d492ef17fd6095afc11d634f56b382\":\"0x1b1b6bd7af64c70000\",\"0xf6ead67dbf5b7eb13358e10f36189d53e643cfcf\":\"0x878678326eac9000000\",\"0xf6f1a44309051c6b25e47dff909b179bb9ab591c\":\"0x692ae8897081d00000\",\"0xf70328ef97625fe745faa49ee0f9d4aa3b0dfb69\":\"0x3635c9adc5dea00000\",\"0xf70a998a717b338d1dd99854409b1a338deea4b0\":\"0x6c6b935b8bbd400000\",\"0xf70d637a845c06db6cdc91e6371ce7c4388a628e\":\"0x1158e460913d00000\",\"0xf7155213449892744bc60f2e04400788bd041fdd\":\"0x39fbae8d042dd0000\",\"0xf71b4534f286e43093b1e15efea749e7597b8b57\":\"0x161c13d3341c87280000\",\"0xf734ec03724ddee5bb5279aa1afcf61b0cb448a1\":\"0xe5bf2cc9b097800000\",\"0xf736dc96760012388fe88b66c06efe57e0d7cf0a\":\"0x71d75ab9b920500000\",\"0xf73ac46c203be1538111b151ec8220c786d84144\":\"0xff7377817b82b8000\",\"0xf73dd9c142b71bce11d06e30e7e7d032f2ec9c9e\":\"0x6acb3df27e1f880000\",\"0xf7418aa0e713d248228776b2e7434222ae75e3a5\":\"0x6c6b935b8bbd400000\",\"0xf74e6e145382b4db821fe0f2d98388f45609c69f\":\"0x56bc75e2d63100000\",\"0xf7500c166f8bea2f82347606e5024be9e4f4ce99\":\"0x1158e460913d00000\",\"0xf757fc8720d3c4fa5277075e60bd5c411aebd977\":\"0x6c6b935b8bbd400000\",\"0xf75bb39c799779ebc04a336d260da63146ed98d0\":\"0x15af1d78b58c40000\",\"0xf768f321fd6433d96b4f354d3cc1652c1732f57f\":\"0x21e19e0c9bab2400000\",\"0xf76f69cee4faa0a63b30ae1e7881f4f715657010\":\"0xad78ebc5ac6200000\",\"0xf777361a3dd8ab62e5f1b9b047568cc0b555704c\":\"0x3635c9adc5dea00000\",\"0xf77c7b845149efba19e261bc7c75157908afa990\":\"0x6c6b935b8bbd400000\",\"0xf77f9587ff7a2d7295f1f571c886bd33926a527c\":\"0x6c68ccd09b022c0000\",\"0xf78258c12481bcdddbb72a8ca0c043097261c6c5\":\"0x1158e460913d00000\",\"0xf798d16da4e460c460cd485fae0fa0599708eb82\":\"0x3635c9adc5dea00000\",\"0xf7a1ade2d0f529123d1055f19b17919f56214e67\":\"0x1b1ae4d6e2ef500000\",\"0xf7acff934b84da0969dc37a8fcf643b7d7fbed41\":\"0x6c6acc67d7b1d40000\",\"0xf7b151cc5e571c17c76539dbe9964cbb6fe5de79\":\"0x74717cfb6883100000\",\"0xf7b29b82195c882dab7897c2ae95e77710f57875\":\"0x7735416132dbfc0000\",\"0xf7bc4c44910d5aedd66ed2355538a6b193c361ec\":\"0x541de2c2d8d620000\",\"0xf7c00cdb1f020310d5acab7b496aaa44b779085e\":\"0x5a87e7d7f5f6580000\",\"0xf7c1b443968b117b5dd9b755572fcd39ca5ec04b\":\"0x18b968c292f1b50000\",\"0xf7c50f922ad16b61c6d1baa045ed816815bac48f\":\"0x2a9396a9784ad7d0000\",\"0xf7c708015071d4fb0a3a2a09a45d156396e3349e\":\"0xa2a15d09519be00000\",\"0xf7cbdba6be6cfe68dbc23c2b0ff530ee05226f84\":\"0x1158e460913d00000\",\"0xf7d0d310acea18406138baaabbfe0571e80de85f\":\"0x487a9a304539440000\",\"0xf7d7af204c56f31fd94398e40df1964bd8bf123c\":\"0x821d221b5291f8000\",\"0xf7dc251196fbcbb77c947d7c1946b0ff65021cea\":\"0x3635c9adc5dea00000\",\"0xf7e45a12aa711c709acefe95f33b78612d2ad22a\":\"0xe0655e2f26bc9180000\",\"0xf7f4898c4c526d955f21f055cb6e47b915e51964\":\"0x7c0860e5a80dc00000\",\"0xf7f91e7acb5b8129a306877ce3168e6f438b66a1\":\"0x98a7d9b8314c00000\",\"0xf7fc45abf76f5088e2e5b5a8d132f28a4d4ec1c0\":\"0x6c6b935b8bbd400000\",\"0xf8063af4cc1dd9619ab5d8bff3fcd1faa8488221\":\"0x6c6b935b8bbd400000\",\"0xf8086e42661ea929d2dda1ab6c748ce3055d111e\":\"0x3635c9adc5dea00000\",\"0xf8087786b42da04ed6d1e0fe26f6c0eefe1e9f5a\":\"0x21e19e0c9bab2400000\",\"0xf80d3619702fa5838c48391859a839fb9ce7160f\":\"0x6c07a7d1b16e700000\",\"0xf814799f6ddf4dcb29c7ee870e75f9cc2d35326d\":\"0x3635c9adc5dea00000\",\"0xf815c10a032d13c34b8976fa6e3bd2c9131a8ba9\":\"0x487a9a304539440000\",\"0xf81622e55757daea6675975dd93538da7d16991e\":\"0x6c6b935b8bbd400000\",\"0xf824ee331e4ac3cc587693395b57ecf625a6c0c2\":\"0x56c95de8e8ca1d0000\",\"0xf827d56ed2d32720d4abf103d6d0ef4d3bcd559b\":\"0x16c80065791a28000\",\"0xf8298591523e50b103f0b701d623cbf0f74556f6\":\"0xad78ebc5ac6200000\",\"0xf848fce9ab611c7d99206e23fac69ad488b94fe1\":\"0x2a1129d0936720000\",\"0xf84f090adf3f8db7e194b350fbb77500699f66fd\":\"0x6acb3df27e1f880000\",\"0xf851b010f633c40af1a8f06a73ebbaab65077ab5\":\"0xee86442fcd06c00000\",\"0xf858171a04d357a13b4941c16e7e55ddd4941329\":\"0x246a5218f2a000000\",\"0xf85bab1cb3710fc05fa19ffac22e67521a0ba21d\":\"0x6c95357fa6b36c0000\",\"0xf86a3ea8071f7095c7db8a05ae507a8929dbb876\":\"0x1236efcbcbb3400000\",\"0xf8704c16d2fd5ba3a2c01d0eb20484e6ecfa3109\":\"0xad78ebc5ac6200000\",\"0xf870995fe1e522321d754337a45c0c9d7b38951c\":\"0x1158e460913d00000\",\"0xf873e57a65c93b6e18cb75f0dc077d5b8933dc5c\":\"0xaadec983fcff40000\",\"0xf875619d8a23e45d8998d184d480c0748970822a\":\"0xd8d726b7177a800000\",\"0xf87bb07b289df7301e54c0efda6a2cf291e89200\":\"0x4be4e7267b6ae00000\",\"0xf88900db737955b1519b1a7d170a18864ce590eb\":\"0xfc936392801c0000\",\"0xf88b58db37420b464c0be88b45ee2b95290f8cfa\":\"0x22b1c8c1227a00000\",\"0xf8962b75db5d24c7e8b7cef1068c3e67cebb30a5\":\"0xf2dc7d47f15600000\",\"0xf8a065f287d91d77cd626af38ffa220d9b552a2b\":\"0x678a932062e4180000\",\"0xf8a49ca2390c1f6d5c0e62513b079571743f7cc6\":\"0xa2a15d09519be00000\",\"0xf8a50cee2e688ceee3aca4d4a29725d4072cc483\":\"0x6c6b935b8bbd400000\",\"0xf8ac4a39b53c11307820973b441365cffe596f66\":\"0x6c6b935b8bbd400000\",\"0xf8ae857b67a4a2893a3fbe7c7a87ff1c01c6a6e7\":\"0xd8d726b7177a800000\",\"0xf8bf9c04874e5a77f38f4c38527e80c676f7b887\":\"0x6c6b935b8bbd400000\",\"0xf8c7f34a38b31801da43063477b12b27d0f203ff\":\"0x1ad2baba6fef480000\",\"0xf8ca336c8e91bd20e314c20b2dd4608b9c8b9459\":\"0x2ddc9bc5b32c780000\",\"0xf8d17424c767bea31205739a2b57a7277214eebe\":\"0x246ddf97976680000\",\"0xf8d52dcc5f96cc28007b3ecbb409f7e22a646caa\":\"0x81690e18128480000\",\"0xf8dce867f0a39c5bef9eeba609229efa02678b6c\":\"0x6c6b935b8bbd400000\",\"0xf8f226142a428434ab17a1864a2597f64aab2f06\":\"0x9598b2fb2e9f28000\",\"0xf8f6645e0dee644b3dad81d571ef9baf840021ad\":\"0x6c6b935b8bbd400000\",\"0xf901c00fc1db88b69c4bc3252b5ca70ea6ee5cf6\":\"0x15af1d78b58c400000\",\"0xf93d5bcb0644b0cce5fcdda343f5168ffab2877d\":\"0xb6207b67d26f90000\",\"0xf9570e924c95debb7061369792cf2efec2a82d5e\":\"0x1158e460913d00000\",\"0xf9642086b1fbae61a6804dbe5fb15ec2d2b537f4\":\"0x6c6b935b8bbd400000\",\"0xf96488698590dc3b2c555642b871348dfa067ad5\":\"0x1b1ae4d6e2ef500000\",\"0xf964d98d281730ba35b2e3a314796e7b42fedf67\":\"0x53b0876098d80c0000\",\"0xf9650d6989f199ab1cc479636ded30f241021f65\":\"0x2e141ea081ca080000\",\"0xf96883582459908c827627e86f28e646f9c7fc7a\":\"0x1c4a78737cdcfb80000\",\"0xf96b4c00766f53736a8574f822e6474c2f21da2d\":\"0x15af1d78b58c400000\",\"0xf9729d48282c9e87166d5eef2d01eda9dbf78821\":\"0x56b83ddc728548000\",\"0xf9767e4ecb4a5980527508d7bec3d45e4c649c13\":\"0x678a932062e4180000\",\"0xf978b025b64233555cc3c19ada7f4199c9348bf7\":\"0x54b40b1f852bda000000\",\"0xf97b56ebd5b77abc9fbacbabd494b9d2c221cd03\":\"0x6acb3df27e1f880000\",\"0xf9811fa19dadbf029f8bfe569adb18228c80481a\":\"0xad78ebc5ac6200000\",\"0xf98250730c4c61c57f129835f2680894794542f3\":\"0xd8d726b7177a800000\",\"0xf989346772995ec1906faffeba2a7fe7de9c6bab\":\"0x16a6502f15a1e540000\",\"0xf998ca3411730a6cd10e7455b0410fb0f6d3ff80\":\"0x6c6b935b8bbd400000\",\"0xf99aee444b5783c093cfffd1c4632cf93c6f050c\":\"0x15af1d78b58c400000\",\"0xf99eeece39fa7ef5076d855061384009792cf2e0\":\"0x1b1ae4d6e2ef500000\",\"0xf9a59c3cc5ffacbcb67be0fc7256f64c9b127cb4\":\"0x6c6b935b8bbd400000\",\"0xf9a94bd56198da245ed01d1e6430b24b2708dcc0\":\"0x28a77afda87ee50000\",\"0xf9b37825f03073d31e249378c30c795c33f83af2\":\"0xad9aabf8c9bfc0000\",\"0xf9b617f752edecae3e909fbb911d2f8192f84209\":\"0x90f534608a72880000\",\"0xf9bfb59d538afc4874d4f5941b08c9730e38e24b\":\"0x22b1c8c1227a00000\",\"0xf9dd239008182fb519fb30eedd2093fed1639be8\":\"0x1b1ae4d6e2ef500000\",\"0xf9debaecb5f339beea4894e5204bfa340d067f25\":\"0x5a42844673b1640000\",\"0xf9e37447406c412197b2e2aebc001d6e30c98c60\":\"0x1c479bb4349c0ee0000\",\"0xf9e7222faaf0f4da40c1c4a40630373a09bed7b6\":\"0x9b4fdcb09456240000\",\"0xf9ece022bccd2c92346911e79dd50303c01e0188\":\"0x3635c9adc5dea00000\",\"0xfa00c376e89c05e887817a9dd0748d96f341aa89\":\"0x104d0d00d2b7f60000\",\"0xfa0c1a988c8a17ad3528eb28b3409daa58225f26\":\"0xad78ebc5ac6200000\",\"0xfa105f1a11b6e4b1f56012a27922e2ac2da4812f\":\"0x205b4dfa1ee74780000\",\"0xfa142fe47eda97e6503b386b18a2bedd73ccb5b1\":\"0x2e153ad81548100000\",\"0xfa14b566234abee73042c31d21717182cba14aa1\":\"0x11c7ea162e78200000\",\"0xfa19d6f7a50f4f079893d167bf14e21d0073d196\":\"0x1cbb3a3ff08d080000\",\"0xfa1f1971a775c3504fef5079f640c2c4bce7ac05\":\"0x6c6b935b8bbd400000\",\"0xfa279bfd8767f956bf7fa0bd5660168da75686bd\":\"0x90f534608a72880000\",\"0xfa27cc49d00b6c987336a875ae39da58fb041b2e\":\"0x21e19e0c9bab2400000\",\"0xfa283299603d8758e8cab082125d2c8f7d445429\":\"0x15bcacb1e0501ae8000\",\"0xfa2bbca15d3fe39f8a328e91f90da14f7ac6253d\":\"0xad78ebc5ac6200000\",\"0xfa2fd29d03fee9a07893df3a269f56b72f2e1e64\":\"0x21e19e0c9bab2400000\",\"0xfa33553285a973719a0d5f956ff861b2d89ed304\":\"0x1158e460913d00000\",\"0xfa3a0c4b903f6ea52ea7ab7b8863b6a616ad6650\":\"0x1158e460913d00000\",\"0xfa3a1aa4488b351aa7560cf5ee630a2fd45c3222\":\"0x2fa47e6aa7340d0000\",\"0xfa410971ad229c3036f41acf852f2ac999281950\":\"0xd8b311a8ddfa7c0000\",\"0xfa44a855e404c86d0ca8ef3324251dfb349c539e\":\"0x542253a126ce400000\",\"0xfa5201fe1342af11307b9142a041243ca92e2f09\":\"0x2038116a3ac043980000\",\"0xfa60868aafd4ff4c5c57914b8ed58b425773dfa9\":\"0x1cfe5c808f39fbc0000\",\"0xfa67b67b4f37a0150915110ede073b05b853bda2\":\"0x2319ba947371ad0000\",\"0xfa68e0cb3edf51f0a6f211c9b2cb5e073c9bffe6\":\"0xfc936392801c00000\",\"0xfa6a37f018e97967937fc5e8617ba1d786dd5f77\":\"0x43c30fb0884a96c0000\",\"0xfa7606435b356cee257bd2fcd3d9eacb3cd1c4e1\":\"0x56bc75e2d63100000\",\"0xfa7adf660b8d99ce15933d7c5f072f3cbeb99d33\":\"0x14061b9d77a5e980000\",\"0xfa86ca27bf2854d98870837fb6f6dfe4bf6453fc\":\"0x11757e8525cf148000\",\"0xfa8cf4e627698c5d5788abb7880417e750231399\":\"0xe61a3696eef6100000\",\"0xfa8e3b1f13433900737daaf1f6299c4887f85b5f\":\"0x26c29e47c4844c0000\",\"0xfa9ec8efe08686fa58c181335872ba698560ecab\":\"0x6c6acc67d7b1d40000\",\"0xfaad905d847c7b23418aeecbe3addb8dd3f8924a\":\"0x6acb3df27e1f880000\",\"0xfaaeba8fc0bbda553ca72e30ef3d732e26e82041\":\"0x488d282aafc9f68000\",\"0xfab487500df20fb83ebed916791d561772adbebf\":\"0x6c6b4c4da6ddbe0000\",\"0xfac5ca94758078fbfccd19db3558da7ee8a0a768\":\"0x3728a62b0dcff60000\",\"0xfad96ab6ac768ad5099452ac4777bd1a47edc48f\":\"0x56bc75e2d63100000\",\"0xfae76719d97eac41870428e940279d97dd57b2f6\":\"0x14dbb2195ca228900000\",\"0xfae881937047895a660cf229760f27e66828d643\":\"0x9ddc1e3b901180000\",\"0xfae92c1370e9e1859a5df83b56d0f586aa3b404c\":\"0x5c5b4f3d843980000\",\"0xfaf5f0b7b6d558f5090d9ea1fb2d42259c586078\":\"0x15affb8420c6b640000\",\"0xfb126f0ec769f49dcefca2f200286451583084b8\":\"0x10fcbc2350396bf0000\",\"0xfb135eb15a8bac72b69915342a60bbc06b7e077c\":\"0x43c33c1937564800000\",\"0xfb223c1e22eac1269b32ee156a5385922ed36fb8\":\"0x6c6b935b8bbd400000\",\"0xfb37cf6b4f81a9e222fba22e9bd24b5098b733cf\":\"0x21a754a6dc5280000\",\"0xfb3860f4121c432ebdc8ec6a0331b1b709792e90\":\"0x208c394af1c8880000\",\"0xfb39189af876e762c71d6c3e741893df226cedd6\":\"0xd8d726b7177a800000\",\"0xfb3a0b0d6b6a718f6fc0292a825dc9247a90a5d0\":\"0xad6dd199e975b0000\",\"0xfb3fa1ac08aba9cc3bf0fe9d483820688f65b410\":\"0x65a4da25d3016c00000\",\"0xfb3fe09bb836861529d7518da27635f538505615\":\"0x4be39216fda0700000\",\"0xfb5125bf0f5eb0b6f020e56bfc2fdf3d402c097e\":\"0x14061b9d77a5e980000\",\"0xfb5518714cefc36d04865de5915ef0ff47dfe743\":\"0x6c6b935b8bbd400000\",\"0xfb5ffaa0f7615726357891475818939d2037cf96\":\"0x1158e460913d00000\",\"0xfb685c15e439965ef626bf0d834cd1a89f2b5695\":\"0xd5967be4fc3f100000\",\"0xfb744b951d094b310262c8f986c860df9ab1de65\":\"0x2d1c515f1cb4a8000\",\"0xfb79abdb925c55b9f98efeef64cfc9eb61f51bb1\":\"0x6140c056fb0ac80000\",\"0xfb8113f94d9173eefd5a3073f516803a10b286ae\":\"0x4563918244f400000\",\"0xfb842ca2c5ef133917a236a0d4ac40690110b038\":\"0x10969a62be15880000\",\"0xfb91fb1a695553f0c68e21276decf0b83909b86d\":\"0x56c003617af780000\",\"0xfb9473cf7712350a1fa0395273fc80560752e4fb\":\"0x6af2198ba85aa0000\",\"0xfb949c647fdcfd2514c7d58e31f28a532d8c5833\":\"0x43c33c1937564800000\",\"0xfba5486d53c6e240494241abf87e43c7600d413a\":\"0x6bbf61494948340000\",\"0xfbb161fe875f09290a4b262bc60110848f0d2226\":\"0x6c6b935b8bbd400000\",\"0xfbbbebcfbe235e57dd2306ad1a9ec581c7f9f48f\":\"0x22b1c8c1227a00000\",\"0xfbc01db54e47cdc3c438694ab717a856c23fe6e9\":\"0x1ca7150ab174f470000\",\"0xfbcfcc4a7b0f26cf26e9f3332132e2fc6a230766\":\"0x1b1ae4d6e2ef5000000\",\"0xfbe71622bcbd31c1a36976e7e5f670c07ffe16de\":\"0x15af1d78b58c400000\",\"0xfbede32c349f3300ef4cd33b4de7dc18e443d326\":\"0xab4dcf399a3a600000\",\"0xfbf204c813f836d83962c7870c7808ca347fd33e\":\"0x1158e460913d00000\",\"0xfbf75933e01b75b154ef0669076be87f62dffae1\":\"0x10846372f249d4c00000\",\"0xfc0096b21e95acb8d619d176a4a1d8d529badbef\":\"0x14d9693bcbec028000\",\"0xfc00a420a36107dfd5f495128a5fe5abb2db0f34\":\"0x143179d869110200000\",\"0xfc018a690ad6746dbe3acf9712ddca52b6250039\":\"0x21e19e0c9bab2400000\",\"0xfc02734033e57f70517e0afc7ee62461f06fad8e\":\"0x155bd9307f9fe80000\",\"0xfc0ee6f7c2b3714ae9916c45566605b656f32441\":\"0x5f68e8131ecf800000\",\"0xfc10b7a67b3268d5331bfb6a14def5ea4a162ca3\":\"0xad78ebc5ac6200000\",\"0xfc15cb99a8d1030b12770add033a79ee0d0c908c\":\"0x12fa00bd52e6240000\",\"0xfc2952b4c49fedd0bc0528a308495e6d6a1c71d6\":\"0x6c6b935b8bbd400000\",\"0xfc2c1f88961d019c3e9ea33009152e0693fbf88a\":\"0x1b1ae4d6e2ef5000000\",\"0xfc361105dd90f9ede566499d69e9130395f12ac8\":\"0x53a4fe2f204e80e00000\",\"0xfc372ff6927cb396d9cf29803500110da632bc52\":\"0x6c6b935b8bbd400000\",\"0xfc39be41094b1997d2169e8264c2c3baa6c99bc4\":\"0x6c6b935b8bbd400000\",\"0xfc3d226bb36a58f526568857b0bb12d109ec9301\":\"0x6c6b935b8bbd400000\",\"0xfc43829ac787ff88aaf183ba352aadbf5a15b193\":\"0xd6ac0a2b0552e00000\",\"0xfc49c1439a41d6b3cf26bb67e0365224e5e38f5f\":\"0x3636d7af5ec98e0000\",\"0xfc5500825105cf712a318a5e9c3bfc69c89d0c12\":\"0xd8d726b7177a800000\",\"0xfc66faba277f4b5de64ad45eb19c31e00ced3ed5\":\"0x131beb925ffd3200000\",\"0xfc7e22a503ec5abe9b08c50bd14999f520fa4884\":\"0x15a477dfbe1ea148000\",\"0xfc8215a0a69913f62a43bf1c8590b9ddcd0d8ddb\":\"0x6c6b935b8bbd400000\",\"0xfc989cb487bf1a7d17e4c1b7c4b7aafdda6b0a8d\":\"0x1158e460913d00000\",\"0xfc9b347464b2f9929d807e039dae48d3d98de379\":\"0x2f6f10780d22cc00000\",\"0xfca43bbc23a0d321ba9e46b929735ce7d8ef0c18\":\"0x1158e460913d00000\",\"0xfca73eff8771c0103ba3cc1a9c259448c72abf0b\":\"0x3635c9adc5dea00000\",\"0xfcada300283f6bcc134a91456760b0d77de410e0\":\"0x6c6b935b8bbd400000\",\"0xfcbc5c71ace79741450b012cf6b8d3f17db68a70\":\"0x205b4dfa1ee74780000\",\"0xfcbd85feea6a754fcf3449449e37ff9784f7773c\":\"0xa74ada69abd7780000\",\"0xfcc9d4a4262e7a027ab7519110d802c495ceea39\":\"0x1595182224b26480000\",\"0xfccd0d1ecee27addea95f6857aeec8c7a04b28ee\":\"0x21e19e0c9bab2400000\",\"0xfcd0b4827cd208ffbf5e759dba8c3cc61d8c2c3c\":\"0x1b1ae4d6e2ef5000000\",\"0xfce089635ce97abac06b44819be5bb0a3e2e0b37\":\"0x503920a7630a78000\",\"0xfcf199f8b854222f182e4e1d099d4e323e2aae01\":\"0x3635c9adc5dea00000\",\"0xfcfc3a5004d678613f0b36a642269a7f371c3f6a\":\"0x3635c9adc5dea00000\",\"0xfd191a35157d781373fb411bf9f25290047c5eef\":\"0x3635c9adc5dea00000\",\"0xfd1faa347b0fcc804c2da86c36d5f1d18b7087bb\":\"0x2d6eb247a96f60000\",\"0xfd1fb5a89a89a721b8797068fbc47f3e9d52e149\":\"0xcd0b5837fc6580000\",\"0xfd204f4f4aba2525ba728afdf78792cbdeb735ae\":\"0x6c6b935b8bbd400000\",\"0xfd2757cc3551a095878d97875615fe0c6a32aa8a\":\"0x206db15299beac0000\",\"0xfd2872d19e57853cfa16effe93d0b1d47b4f93fb\":\"0xd8d726b7177a800000\",\"0xfd2929271e9d2095a264767e7b0df52ea0d1d400\":\"0xa2a1eb251b5ae40000\",\"0xfd377a385272900cb436a3bb7962cdffe93f5dad\":\"0x6c6b935b8bbd400000\",\"0xfd40242bb34a70855ef0fd90f3802dec2136b327\":\"0x68a875073e29240000\",\"0xfd452c3969ece3801c542020f1cdcaa1c71ed23d\":\"0x152d02c7e14af6800000\",\"0xfd4b551f6fdbcda6c511b5bb372250a6b783e534\":\"0x11de1e6db450c0000\",\"0xfd4b989558ae11be0c3b36e2d6f2a54a9343ca2e\":\"0x6c6b935b8bbd400000\",\"0xfd4de8e3748a289cf7d060517d9d38388db01fb8\":\"0xd8d726b7177a80000\",\"0xfd5a63157f914fd398eab19c137dd9550bb7715c\":\"0x56bc75e2d63100000\",\"0xfd60d2b5af3d35f7aaf0c393052e79c4d823d985\":\"0x30eb50d2e14080000\",\"0xfd686de53fa97f99639e2568549720bc588c9efc\":\"0x6ac5c62d9486070000\",\"0xfd7ede8f5240a06541eb699d782c2f9afb2170f6\":\"0x487a9a304539440000\",\"0xfd812bc69fb170ef57e2327e80affd14f8e4b6d2\":\"0x6c6b935b8bbd400000\",\"0xfd88d114220f081cb3d5e15be8152ab07366576a\":\"0x1043561a8829300000\",\"0xfd918536a8efa6f6cefe1fa1153995fef5e33d3b\":\"0x1b1ae4d6e2ef500000\",\"0xfd920f722682afb5af451b0544d4f41b3b9d5742\":\"0x7e52056a123f3c0000\",\"0xfd9579f119bbc819a02b61e38d8803c942f24d32\":\"0x5b97e9081d9400000\",\"0xfda0ce15330707f10bce3201172d2018b9ddea74\":\"0x2d041d705a2c60000\",\"0xfda3042819af3e662900e1b92b4358eda6e92590\":\"0x1907a284d58f63e00000\",\"0xfda6810ea5ac985d6ffbf1c511f1c142edcfddf7\":\"0xd8d726b7177a800000\",\"0xfdb33944f2360615e5be239577c8a19ba52d9887\":\"0x209d922f5259c50000\",\"0xfdba5359f7ec3bc770ac49975d844ec9716256f1\":\"0x3635c9adc5dea00000\",\"0xfdc4d4765a942f5bf96931a9e8cc7ab8b757ff4c\":\"0x126c478a0e3ea8600000\",\"0xfdcd5d80b105897a57abc47865768b2900524295\":\"0x15af1d78b58c4000000\",\"0xfdd1195f797d4f35717d15e6f9810a9a3ff55460\":\"0xfc936392801c0000\",\"0xfdd502a74e813bcfa355ceda3c176f6a6871af7f\":\"0x15af1d78b58c400000\",\"0xfde395bc0b6d5cbb4c1d8fea3e0b4bff635e9db7\":\"0x6c6b935b8bbd400000\",\"0xfdeaac2acf1d138e19f2fc3f9fb74592e3ed818a\":\"0x243d4d18229ca20000\",\"0xfdecc82ddfc56192e26f563c3d68cb544a96bfed\":\"0x17da3a04c7b3e00000\",\"0xfdf42343019b0b0c6bf260b173afab7e45b9d621\":\"0x6c6acc67d7b1d40000\",\"0xfdf449f108c6fb4f5a2b081eed7e45e6919e4d25\":\"0x6c6b935b8bbd400000\",\"0xfdfd6134c04a8ab7eb16f00643f8fed7daaaecb2\":\"0x15af1d78b58c400000\",\"0xfe00bf439911a553982db638039245bcf032dbdc\":\"0x155bd9307f9fe80000\",\"0xfe016ec17ec5f10e3bb98ff4a1eda045157682ab\":\"0x145f5402e7b2e60000\",\"0xfe0e30e214290d743dd30eb082f1f0a5225ade61\":\"0xad78ebc5ac6200000\",\"0xfe210b8f04dc6d4f76216acfcbd59ba83be9b630\":\"0x1158e460913d00000\",\"0xfe22a0b388668d1ae2643e771dacf38a434223cc\":\"0xd8db5ebd7b26380000\",\"0xfe362688845fa244cc807e4b1130eb3741a8051e\":\"0x3635c9adc5dea00000\",\"0xfe3827d57630cf8761d512797b0b858e478bbd12\":\"0x1158e460913d00000\",\"0xfe418b421a9c6d373602790475d2303e11a75930\":\"0x3708baed3d68900000\",\"0xfe4249127950e2f896ec0e7e2e3d055aab10550f\":\"0x243d4d18229ca20000\",\"0xfe4d8403216fd571572bf1bdb01d00578978d688\":\"0x215f835bc769da80000\",\"0xfe53b94989d89964da2061539526bbe979dd2ea9\":\"0x68a875073e29240000\",\"0xfe549bbfe64740189892932538daaf46d2b61d4f\":\"0x22b1c8c1227a00000\",\"0xfe615d975c0887e0c9113ec7298420a793af8b96\":\"0x1b1ae4d6e2ef5000000\",\"0xfe65c4188d7922576909642044fdc52395560165\":\"0xd8d726b7177a800000\",\"0xfe697ff22ca547bfc95e33d960da605c6763f35b\":\"0x47d4119fd960940000\",\"0xfe6a895b795cb4bf85903d3ce09c5aa43953d3bf\":\"0xb8507a820728200000\",\"0xfe6f5f42b6193b1ad16206e4afb5239d4d7db45e\":\"0x5dc892aa1131c80000\",\"0xfe7011b698bf3371132d7445b19eb5b094356aee\":\"0x6c6b935b8bbd400000\",\"0xfe80e9232deaff19baf99869883a4bdf0004e53c\":\"0x2e62f20a69be400000\",\"0xfe8e6e3665570dff7a1bda697aa589c0b4e9024a\":\"0x6c6b935b8bbd400000\",\"0xfe8f1fdcab7fbec9a6a3fcc507619600505c36a3\":\"0x11164759ffb320000\",\"0xfe91eccf2bd566afa11696c5049fa84c69630a52\":\"0x692ae8897081d00000\",\"0xfe96c4cd381562401aa32a86e65b9d52fa8aee27\":\"0x8f1d5c1cae37400000\",\"0xfe98c664c3e447a95e69bd582171b7176ea2a685\":\"0xd8d726b7177a800000\",\"0xfe9ad12ef05d6d90261f96c8340a0381974df477\":\"0x6c6b935b8bbd400000\",\"0xfe9c0fffefb803081256c0cf4d6659e6d33eb4fb\":\"0x52d542804f1ce00000\",\"0xfe9cfc3bb293ddb285e625f3582f74a6b0a5a6cd\":\"0x6acb3df27e1f880000\",\"0xfe9e1197d7974a7648dcc7a03112a88edbc9045d\":\"0x10afc1ade3b4ed40000\",\"0xfeaca2ac74624bf348dac9985143cfd652a4be55\":\"0x5897fcbb02914088000\",\"0xfead1803e5e737a68e18472d9ac715f0994cc2be\":\"0x1b1ae4d6e2ef500000\",\"0xfeb8b8e2af716ae41fc7c04bcf29540156461e6b\":\"0x545174a528a77a0000\",\"0xfeb92d30bf01ff9a1901666c5573532bfa07eeec\":\"0x3635c9adc5dea00000\",\"0xfebc3173bc9072136354002b7b4fb3bfc53f22f1\":\"0x140ec80fa7ee880000\",\"0xfebd48d0ffdbd5656cd5e686363a61145228f279\":\"0x97c9ce4cf6d5c00000\",\"0xfebd9f81cf78bd5fb6c4b9a24bd414bb9bfa4c4e\":\"0x6be10fb8ed6e138000\",\"0xfec06fe27b44c784b2396ec92f7b923ad17e9077\":\"0x6c6b935b8bbd400000\",\"0xfec14e5485de2b3eef5e74c46146db8e454e0335\":\"0x9b41fbf9e0aec0000\",\"0xfed8476d10d584b38bfa6737600ef19d35c41ed8\":\"0x62a992e53a0af00000\",\"0xfeef3b6eabc94affd3310c1c4d0e65375e131119\":\"0x1158e460913d00000\",\"0xfef09d70243f39ed8cd800bf9651479e8f4aca3c\":\"0xad78ebc5ac6200000\",\"0xfef3b3dead1a6926d49aa32b12c22af54d9ff985\":\"0x3635c9adc5dea00000\",\"0xff0b7cb71da9d4c1ea6ecc28ebda504c63f82fd1\":\"0x388a885df2fc6c0000\",\"0xff0c3c7798e8733dd2668152891bab80a8be955c\":\"0x45946b0f9e9d60000\",\"0xff0cb06c42e3d88948e45bd7b0d4e291aefeea51\":\"0x678a932062e4180000\",\"0xff0cc8dac824fa24fc3caa2169e6e057cf638ad6\":\"0xd8d726b7177a800000\",\"0xff0e2fec304207467e1e3307f64cbf30af8fd9cd\":\"0x6c6b935b8bbd400000\",\"0xff128f4b355be1dc4a6f94fa510d7f15d53c2aff\":\"0x93739534d286800000\",\"0xff12e49d8e06aa20f886293c0b98ed7eff788805\":\"0xd8d726b7177a800000\",\"0xff207308ced238a6c01ad0213ca9eb4465d42590\":\"0x6c6acc67d7b1d40000\",\"0xff26138330274df4e0a3081e6df7dd983ec6e78f\":\"0x6c6b935b8bbd400000\",\"0xff2726294148b86c78a9372497e459898ed3fee3\":\"0x6acb3df27e1f880000\",\"0xff3ded7a40d3aff0d7a8c45fa6136aa0433db457\":\"0x6c68ccd09b022c0000\",\"0xff3eee57c34d6dae970d8b311117c53586cd3502\":\"0x5c283d410394100000\",\"0xff3ef6ba151c21b59986ae64f6e8228bc9a2c733\":\"0x6c6b935b8bbd400000\",\"0xff41d9e1b4effe18d8b0d1f63fc4255fb4e06c3d\":\"0x487a9a304539440000\",\"0xff45cb34c928364d9cc9d8bb00373474618f06f3\":\"0x56bc75e2d63100000\",\"0xff49a775814ec00051a795a875de24592ea400d4\":\"0x2a5a058fc295ed000000\",\"0xff4a408f50e9e72146a28ce4fc8d90271f116e84\":\"0x6acb3df27e1f880000\",\"0xff4d9c8484c43c42ff2c5ab759996498d323994d\":\"0xd8d726b7177a800000\",\"0xff4fc66069046c525658c337a917f2d4b832b409\":\"0x6c6b935b8bbd400000\",\"0xff5162f2354dc492c75fd6e3a107268660eecb47\":\"0x5c283d410394100000\",\"0xff545bbb66fbd00eb5e6373ff4e326f5feb5fe12\":\"0x1158e460913d00000\",\"0xff5e7ee7d5114821e159dca5e81f18f1bfffbff9\":\"0x6c6b935b8bbd400000\",\"0xff61c9c1b7a3d8b53bba20b34466544b7b216644\":\"0x6c6b935b8bbd400000\",\"0xff65511cada259260c1ddc41974ecaecd32d6357\":\"0x5f68e8131ecf800000\",\"0xff7843c7010aa7e61519b762dfe49124a76b0e4e\":\"0xc5b17924412b9bb00000\",\"0xff78541756ab2b706e0d70b18adb700fc4f1643d\":\"0x92896529baddc880000\",\"0xff83855051ee8ffb70b4817dba3211ed2355869d\":\"0x15af1d78b58c400000\",\"0xff850e3be1eb6a4d726c08fa73aad358f39706da\":\"0x692ae8897081d00000\",\"0xff86e5e8e15b53909600e41308dab75f0e24e46b\":\"0x30eb50d2e140800000\",\"0xff88ebacc41b3687f39e4b59e159599b80cba33f\":\"0x15af1d78b58c400000\",\"0xff8a2ca5a81333f19998255f203256e1a819c0aa\":\"0xc249fdd3277800000\",\"0xff8eb07de3d49d9d52bbe8e5b26dbe1d160fa834\":\"0xd814dcb94453080000\",\"0xffa4aff1a37f984b0a67272149273ae9bd41e3bc\":\"0x21e19e0c9bab2400000\",\"0xffa696ecbd787e66abae4fe87b635f07ca57d848\":\"0x487a9a304539440000\",\"0xffac3db879a6c7158e8dec603b407463ba0d31cf\":\"0x6acb3df27e1f880000\",\"0xffad3dd74e2c1f796ac640de56dc99b4c792a402\":\"0x10f0cf064dd59200000\",\"0xffb04726dfa41afdc819168418610472970d7bfc\":\"0xd8d726b7177a800000\",\"0xffb3bcc3196a8c3cb834cec94c34fed35b3e1054\":\"0x48a43c54602f700000\",\"0xffb974673367f5c07be5fd270dc4b7138b074d57\":\"0x85ebc8bdb9066d8000\",\"0xffb9c7217e66743031eb377af65c77db7359dcda\":\"0x22b1c8c1227a00000\",\"0xffbc3da0381ec339c1c049eb1ed9ee34fdcea6ca\":\"0xd8d726b7177a800000\",\"0xffc5fc4b7e8a0293ff39a3a0f7d60d2646d37a74\":\"0x6c6b935b8bbd400000\",\"0xffc9cc3094b041ad0e076f968a0de3b167255866\":\"0x1770c1650beee80000\",\"0xffd5170fd1a8118d558e7511e364b24906c4f6b3\":\"0x341d8cd27f1588000\",\"0xffd6da958eecbc016bab91058440d39b41c7be83\":\"0x43c33c1937564800000\",\"0xffe0e997f1977a615f5a315af413fd4869343ba0\":\"0x56cd55fc64dfe0000\",\"0xffe28db53c9044b4ecd4053fd1b4b10d7056c688\":\"0x56bc75e2d63100000\",\"0xffe2e28c3fb74749d7e780dc8a5d422538e6e451\":\"0xdbb81e05bc12d8000\",\"0xffe8cbc1681e5e9db74a0f93f8ed25897519120f\":\"0x51b1d3839261ac0000\",\"0xffeac0305ede3a915295ec8e61c7f881006f4474\":\"0x556f64c1fe7fa0000\",\"0xffec0913c635baca2f5e57a37aa9fb7b6c9b6e26\":\"0x2ba39e82ed5d740000\",\"0xfff33a3bd36abdbd412707b8e310d6011454a7ae\":\"0x1b1ae4d6e2ef5000000\",\"0xfff4bad596633479a2a29f9a8b3f78eefd07e6ee\":\"0x56bc75e2d63100000\",\"0xfff7ac99c8e4feb60c9750054bdc14ce1857f181\":\"0x3635c9adc5dea00000\"}");

});

parcelRegister("MAawF", function(module, exports) {
module.exports = JSON.parse("{\"0x0000000000000000000000000000000000000000\":\"0x1\",\"0x0000000000000000000000000000000000000001\":\"0x1\",\"0x0000000000000000000000000000000000000002\":\"0x1\",\"0x0000000000000000000000000000000000000003\":\"0x1\",\"0x0000000000000000000000000000000000000004\":\"0x1\",\"0x0000000000000000000000000000000000000005\":\"0x1\",\"0x0000000000000000000000000000000000000006\":\"0x1\",\"0x0000000000000000000000000000000000000007\":\"0x1\",\"0x0000000000000000000000000000000000000008\":\"0x1\",\"0x0000000000000000000000000000000000000009\":\"0x1\",\"0x000000000000000000000000000000000000000a\":\"0x0\",\"0x000000000000000000000000000000000000000b\":\"0x0\",\"0x000000000000000000000000000000000000000c\":\"0x0\",\"0x000000000000000000000000000000000000000d\":\"0x0\",\"0x000000000000000000000000000000000000000e\":\"0x0\",\"0x000000000000000000000000000000000000000f\":\"0x0\",\"0x0000000000000000000000000000000000000010\":\"0x0\",\"0x0000000000000000000000000000000000000011\":\"0x0\",\"0x0000000000000000000000000000000000000012\":\"0x0\",\"0x0000000000000000000000000000000000000013\":\"0x0\",\"0x0000000000000000000000000000000000000014\":\"0x0\",\"0x0000000000000000000000000000000000000015\":\"0x0\",\"0x0000000000000000000000000000000000000016\":\"0x0\",\"0x0000000000000000000000000000000000000017\":\"0x0\",\"0x0000000000000000000000000000000000000018\":\"0x0\",\"0x0000000000000000000000000000000000000019\":\"0x0\",\"0x000000000000000000000000000000000000001a\":\"0x0\",\"0x000000000000000000000000000000000000001b\":\"0x0\",\"0x000000000000000000000000000000000000001c\":\"0x0\",\"0x000000000000000000000000000000000000001d\":\"0x0\",\"0x000000000000000000000000000000000000001e\":\"0x0\",\"0x000000000000000000000000000000000000001f\":\"0x0\",\"0x0000000000000000000000000000000000000020\":\"0x0\",\"0x0000000000000000000000000000000000000021\":\"0x0\",\"0x0000000000000000000000000000000000000022\":\"0x0\",\"0x0000000000000000000000000000000000000023\":\"0x0\",\"0x0000000000000000000000000000000000000024\":\"0x0\",\"0x0000000000000000000000000000000000000025\":\"0x0\",\"0x0000000000000000000000000000000000000026\":\"0x0\",\"0x0000000000000000000000000000000000000027\":\"0x0\",\"0x0000000000000000000000000000000000000028\":\"0x0\",\"0x0000000000000000000000000000000000000029\":\"0x0\",\"0x000000000000000000000000000000000000002a\":\"0x0\",\"0x000000000000000000000000000000000000002b\":\"0x0\",\"0x000000000000000000000000000000000000002c\":\"0x0\",\"0x000000000000000000000000000000000000002d\":\"0x0\",\"0x000000000000000000000000000000000000002e\":\"0x0\",\"0x000000000000000000000000000000000000002f\":\"0x0\",\"0x0000000000000000000000000000000000000030\":\"0x0\",\"0x0000000000000000000000000000000000000031\":\"0x0\",\"0x0000000000000000000000000000000000000032\":\"0x0\",\"0x0000000000000000000000000000000000000033\":\"0x0\",\"0x0000000000000000000000000000000000000034\":\"0x0\",\"0x0000000000000000000000000000000000000035\":\"0x0\",\"0x0000000000000000000000000000000000000036\":\"0x0\",\"0x0000000000000000000000000000000000000037\":\"0x0\",\"0x0000000000000000000000000000000000000038\":\"0x0\",\"0x0000000000000000000000000000000000000039\":\"0x0\",\"0x000000000000000000000000000000000000003a\":\"0x0\",\"0x000000000000000000000000000000000000003b\":\"0x0\",\"0x000000000000000000000000000000000000003c\":\"0x0\",\"0x000000000000000000000000000000000000003d\":\"0x0\",\"0x000000000000000000000000000000000000003e\":\"0x0\",\"0x000000000000000000000000000000000000003f\":\"0x0\",\"0x0000000000000000000000000000000000000040\":\"0x0\",\"0x0000000000000000000000000000000000000041\":\"0x0\",\"0x0000000000000000000000000000000000000042\":\"0x0\",\"0x0000000000000000000000000000000000000043\":\"0x0\",\"0x0000000000000000000000000000000000000044\":\"0x0\",\"0x0000000000000000000000000000000000000045\":\"0x0\",\"0x0000000000000000000000000000000000000046\":\"0x0\",\"0x0000000000000000000000000000000000000047\":\"0x0\",\"0x0000000000000000000000000000000000000048\":\"0x0\",\"0x0000000000000000000000000000000000000049\":\"0x0\",\"0x000000000000000000000000000000000000004a\":\"0x0\",\"0x000000000000000000000000000000000000004b\":\"0x0\",\"0x000000000000000000000000000000000000004c\":\"0x0\",\"0x000000000000000000000000000000000000004d\":\"0x0\",\"0x000000000000000000000000000000000000004e\":\"0x0\",\"0x000000000000000000000000000000000000004f\":\"0x0\",\"0x0000000000000000000000000000000000000050\":\"0x0\",\"0x0000000000000000000000000000000000000051\":\"0x0\",\"0x0000000000000000000000000000000000000052\":\"0x0\",\"0x0000000000000000000000000000000000000053\":\"0x0\",\"0x0000000000000000000000000000000000000054\":\"0x0\",\"0x0000000000000000000000000000000000000055\":\"0x0\",\"0x0000000000000000000000000000000000000056\":\"0x0\",\"0x0000000000000000000000000000000000000057\":\"0x0\",\"0x0000000000000000000000000000000000000058\":\"0x0\",\"0x0000000000000000000000000000000000000059\":\"0x0\",\"0x000000000000000000000000000000000000005a\":\"0x0\",\"0x000000000000000000000000000000000000005b\":\"0x0\",\"0x000000000000000000000000000000000000005c\":\"0x0\",\"0x000000000000000000000000000000000000005d\":\"0x0\",\"0x000000000000000000000000000000000000005e\":\"0x0\",\"0x000000000000000000000000000000000000005f\":\"0x0\",\"0x0000000000000000000000000000000000000060\":\"0x0\",\"0x0000000000000000000000000000000000000061\":\"0x0\",\"0x0000000000000000000000000000000000000062\":\"0x0\",\"0x0000000000000000000000000000000000000063\":\"0x0\",\"0x0000000000000000000000000000000000000064\":\"0x0\",\"0x0000000000000000000000000000000000000065\":\"0x0\",\"0x0000000000000000000000000000000000000066\":\"0x0\",\"0x0000000000000000000000000000000000000067\":\"0x0\",\"0x0000000000000000000000000000000000000068\":\"0x0\",\"0x0000000000000000000000000000000000000069\":\"0x0\",\"0x000000000000000000000000000000000000006a\":\"0x0\",\"0x000000000000000000000000000000000000006b\":\"0x0\",\"0x000000000000000000000000000000000000006c\":\"0x0\",\"0x000000000000000000000000000000000000006d\":\"0x0\",\"0x000000000000000000000000000000000000006e\":\"0x0\",\"0x000000000000000000000000000000000000006f\":\"0x0\",\"0x0000000000000000000000000000000000000070\":\"0x0\",\"0x0000000000000000000000000000000000000071\":\"0x0\",\"0x0000000000000000000000000000000000000072\":\"0x0\",\"0x0000000000000000000000000000000000000073\":\"0x0\",\"0x0000000000000000000000000000000000000074\":\"0x0\",\"0x0000000000000000000000000000000000000075\":\"0x0\",\"0x0000000000000000000000000000000000000076\":\"0x0\",\"0x0000000000000000000000000000000000000077\":\"0x0\",\"0x0000000000000000000000000000000000000078\":\"0x0\",\"0x0000000000000000000000000000000000000079\":\"0x0\",\"0x000000000000000000000000000000000000007a\":\"0x0\",\"0x000000000000000000000000000000000000007b\":\"0x0\",\"0x000000000000000000000000000000000000007c\":\"0x0\",\"0x000000000000000000000000000000000000007d\":\"0x0\",\"0x000000000000000000000000000000000000007e\":\"0x0\",\"0x000000000000000000000000000000000000007f\":\"0x0\",\"0x0000000000000000000000000000000000000080\":\"0x0\",\"0x0000000000000000000000000000000000000081\":\"0x0\",\"0x0000000000000000000000000000000000000082\":\"0x0\",\"0x0000000000000000000000000000000000000083\":\"0x0\",\"0x0000000000000000000000000000000000000084\":\"0x0\",\"0x0000000000000000000000000000000000000085\":\"0x0\",\"0x0000000000000000000000000000000000000086\":\"0x0\",\"0x0000000000000000000000000000000000000087\":\"0x0\",\"0x0000000000000000000000000000000000000088\":\"0x0\",\"0x0000000000000000000000000000000000000089\":\"0x0\",\"0x000000000000000000000000000000000000008a\":\"0x0\",\"0x000000000000000000000000000000000000008b\":\"0x0\",\"0x000000000000000000000000000000000000008c\":\"0x0\",\"0x000000000000000000000000000000000000008d\":\"0x0\",\"0x000000000000000000000000000000000000008e\":\"0x0\",\"0x000000000000000000000000000000000000008f\":\"0x0\",\"0x0000000000000000000000000000000000000090\":\"0x0\",\"0x0000000000000000000000000000000000000091\":\"0x0\",\"0x0000000000000000000000000000000000000092\":\"0x0\",\"0x0000000000000000000000000000000000000093\":\"0x0\",\"0x0000000000000000000000000000000000000094\":\"0x0\",\"0x0000000000000000000000000000000000000095\":\"0x0\",\"0x0000000000000000000000000000000000000096\":\"0x0\",\"0x0000000000000000000000000000000000000097\":\"0x0\",\"0x0000000000000000000000000000000000000098\":\"0x0\",\"0x0000000000000000000000000000000000000099\":\"0x0\",\"0x000000000000000000000000000000000000009a\":\"0x0\",\"0x000000000000000000000000000000000000009b\":\"0x0\",\"0x000000000000000000000000000000000000009c\":\"0x0\",\"0x000000000000000000000000000000000000009d\":\"0x0\",\"0x000000000000000000000000000000000000009e\":\"0x0\",\"0x000000000000000000000000000000000000009f\":\"0x0\",\"0x00000000000000000000000000000000000000a0\":\"0x0\",\"0x00000000000000000000000000000000000000a1\":\"0x0\",\"0x00000000000000000000000000000000000000a2\":\"0x0\",\"0x00000000000000000000000000000000000000a3\":\"0x0\",\"0x00000000000000000000000000000000000000a4\":\"0x0\",\"0x00000000000000000000000000000000000000a5\":\"0x0\",\"0x00000000000000000000000000000000000000a6\":\"0x0\",\"0x00000000000000000000000000000000000000a7\":\"0x0\",\"0x00000000000000000000000000000000000000a8\":\"0x0\",\"0x00000000000000000000000000000000000000a9\":\"0x0\",\"0x00000000000000000000000000000000000000aa\":\"0x0\",\"0x00000000000000000000000000000000000000ab\":\"0x0\",\"0x00000000000000000000000000000000000000ac\":\"0x0\",\"0x00000000000000000000000000000000000000ad\":\"0x0\",\"0x00000000000000000000000000000000000000ae\":\"0x0\",\"0x00000000000000000000000000000000000000af\":\"0x0\",\"0x00000000000000000000000000000000000000b0\":\"0x0\",\"0x00000000000000000000000000000000000000b1\":\"0x0\",\"0x00000000000000000000000000000000000000b2\":\"0x0\",\"0x00000000000000000000000000000000000000b3\":\"0x0\",\"0x00000000000000000000000000000000000000b4\":\"0x0\",\"0x00000000000000000000000000000000000000b5\":\"0x0\",\"0x00000000000000000000000000000000000000b6\":\"0x0\",\"0x00000000000000000000000000000000000000b7\":\"0x0\",\"0x00000000000000000000000000000000000000b8\":\"0x0\",\"0x00000000000000000000000000000000000000b9\":\"0x0\",\"0x00000000000000000000000000000000000000ba\":\"0x0\",\"0x00000000000000000000000000000000000000bb\":\"0x0\",\"0x00000000000000000000000000000000000000bc\":\"0x0\",\"0x00000000000000000000000000000000000000bd\":\"0x0\",\"0x00000000000000000000000000000000000000be\":\"0x0\",\"0x00000000000000000000000000000000000000bf\":\"0x0\",\"0x00000000000000000000000000000000000000c0\":\"0x0\",\"0x00000000000000000000000000000000000000c1\":\"0x0\",\"0x00000000000000000000000000000000000000c2\":\"0x0\",\"0x00000000000000000000000000000000000000c3\":\"0x0\",\"0x00000000000000000000000000000000000000c4\":\"0x0\",\"0x00000000000000000000000000000000000000c5\":\"0x0\",\"0x00000000000000000000000000000000000000c6\":\"0x0\",\"0x00000000000000000000000000000000000000c7\":\"0x0\",\"0x00000000000000000000000000000000000000c8\":\"0x0\",\"0x00000000000000000000000000000000000000c9\":\"0x0\",\"0x00000000000000000000000000000000000000ca\":\"0x0\",\"0x00000000000000000000000000000000000000cb\":\"0x0\",\"0x00000000000000000000000000000000000000cc\":\"0x0\",\"0x00000000000000000000000000000000000000cd\":\"0x0\",\"0x00000000000000000000000000000000000000ce\":\"0x0\",\"0x00000000000000000000000000000000000000cf\":\"0x0\",\"0x00000000000000000000000000000000000000d0\":\"0x0\",\"0x00000000000000000000000000000000000000d1\":\"0x0\",\"0x00000000000000000000000000000000000000d2\":\"0x0\",\"0x00000000000000000000000000000000000000d3\":\"0x0\",\"0x00000000000000000000000000000000000000d4\":\"0x0\",\"0x00000000000000000000000000000000000000d5\":\"0x0\",\"0x00000000000000000000000000000000000000d6\":\"0x0\",\"0x00000000000000000000000000000000000000d7\":\"0x0\",\"0x00000000000000000000000000000000000000d8\":\"0x0\",\"0x00000000000000000000000000000000000000d9\":\"0x0\",\"0x00000000000000000000000000000000000000da\":\"0x0\",\"0x00000000000000000000000000000000000000db\":\"0x0\",\"0x00000000000000000000000000000000000000dc\":\"0x0\",\"0x00000000000000000000000000000000000000dd\":\"0x0\",\"0x00000000000000000000000000000000000000de\":\"0x0\",\"0x00000000000000000000000000000000000000df\":\"0x0\",\"0x00000000000000000000000000000000000000e0\":\"0x0\",\"0x00000000000000000000000000000000000000e1\":\"0x0\",\"0x00000000000000000000000000000000000000e2\":\"0x0\",\"0x00000000000000000000000000000000000000e3\":\"0x0\",\"0x00000000000000000000000000000000000000e4\":\"0x0\",\"0x00000000000000000000000000000000000000e5\":\"0x0\",\"0x00000000000000000000000000000000000000e6\":\"0x0\",\"0x00000000000000000000000000000000000000e7\":\"0x0\",\"0x00000000000000000000000000000000000000e8\":\"0x0\",\"0x00000000000000000000000000000000000000e9\":\"0x0\",\"0x00000000000000000000000000000000000000ea\":\"0x0\",\"0x00000000000000000000000000000000000000eb\":\"0x0\",\"0x00000000000000000000000000000000000000ec\":\"0x0\",\"0x00000000000000000000000000000000000000ed\":\"0x0\",\"0x00000000000000000000000000000000000000ee\":\"0x0\",\"0x00000000000000000000000000000000000000ef\":\"0x0\",\"0x00000000000000000000000000000000000000f0\":\"0x0\",\"0x00000000000000000000000000000000000000f1\":\"0x0\",\"0x00000000000000000000000000000000000000f2\":\"0x0\",\"0x00000000000000000000000000000000000000f3\":\"0x0\",\"0x00000000000000000000000000000000000000f4\":\"0x0\",\"0x00000000000000000000000000000000000000f5\":\"0x0\",\"0x00000000000000000000000000000000000000f6\":\"0x0\",\"0x00000000000000000000000000000000000000f7\":\"0x0\",\"0x00000000000000000000000000000000000000f8\":\"0x0\",\"0x00000000000000000000000000000000000000f9\":\"0x0\",\"0x00000000000000000000000000000000000000fa\":\"0x0\",\"0x00000000000000000000000000000000000000fb\":\"0x0\",\"0x00000000000000000000000000000000000000fc\":\"0x0\",\"0x00000000000000000000000000000000000000fd\":\"0x0\",\"0x00000000000000000000000000000000000000fe\":\"0x0\",\"0x00000000000000000000000000000000000000ff\":\"0x0\",\"0x874b54a8bd152966d63f706bae1ffeb0411921e5\":\"0xc9f2c9cd04674edea40000000\"}");

});

parcelRegister("66KfJ", function(module, exports) {
module.exports = JSON.parse("{\"0x0000000000000000000000000000000000000000\":\"0x1\",\"0x0000000000000000000000000000000000000001\":\"0x1\",\"0x0000000000000000000000000000000000000002\":\"0x1\",\"0x0000000000000000000000000000000000000003\":\"0x1\",\"0x0000000000000000000000000000000000000004\":\"0x1\",\"0x0000000000000000000000000000000000000005\":\"0x1\",\"0x0000000000000000000000000000000000000006\":\"0x1\",\"0x0000000000000000000000000000000000000007\":\"0x1\",\"0x0000000000000000000000000000000000000008\":\"0x1\",\"0x0000000000000000000000000000000000000009\":\"0x1\",\"0x000000000000000000000000000000000000000a\":\"0x1\",\"0x000000000000000000000000000000000000000b\":\"0x1\",\"0x000000000000000000000000000000000000000c\":\"0x1\",\"0x000000000000000000000000000000000000000d\":\"0x1\",\"0x000000000000000000000000000000000000000e\":\"0x1\",\"0x000000000000000000000000000000000000000f\":\"0x1\",\"0x0000000000000000000000000000000000000010\":\"0x1\",\"0x0000000000000000000000000000000000000011\":\"0x1\",\"0x0000000000000000000000000000000000000012\":\"0x1\",\"0x0000000000000000000000000000000000000013\":\"0x1\",\"0x0000000000000000000000000000000000000014\":\"0x1\",\"0x0000000000000000000000000000000000000015\":\"0x1\",\"0x0000000000000000000000000000000000000016\":\"0x1\",\"0x0000000000000000000000000000000000000017\":\"0x1\",\"0x0000000000000000000000000000000000000018\":\"0x1\",\"0x0000000000000000000000000000000000000019\":\"0x1\",\"0x000000000000000000000000000000000000001a\":\"0x1\",\"0x000000000000000000000000000000000000001b\":\"0x1\",\"0x000000000000000000000000000000000000001c\":\"0x1\",\"0x000000000000000000000000000000000000001d\":\"0x1\",\"0x000000000000000000000000000000000000001e\":\"0x1\",\"0x000000000000000000000000000000000000001f\":\"0x1\",\"0x0000000000000000000000000000000000000020\":\"0x1\",\"0x0000000000000000000000000000000000000021\":\"0x1\",\"0x0000000000000000000000000000000000000022\":\"0x1\",\"0x0000000000000000000000000000000000000023\":\"0x1\",\"0x0000000000000000000000000000000000000024\":\"0x1\",\"0x0000000000000000000000000000000000000025\":\"0x1\",\"0x0000000000000000000000000000000000000026\":\"0x1\",\"0x0000000000000000000000000000000000000027\":\"0x1\",\"0x0000000000000000000000000000000000000028\":\"0x1\",\"0x0000000000000000000000000000000000000029\":\"0x1\",\"0x000000000000000000000000000000000000002a\":\"0x1\",\"0x000000000000000000000000000000000000002b\":\"0x1\",\"0x000000000000000000000000000000000000002c\":\"0x1\",\"0x000000000000000000000000000000000000002d\":\"0x1\",\"0x000000000000000000000000000000000000002e\":\"0x1\",\"0x000000000000000000000000000000000000002f\":\"0x1\",\"0x0000000000000000000000000000000000000030\":\"0x1\",\"0x0000000000000000000000000000000000000031\":\"0x1\",\"0x0000000000000000000000000000000000000032\":\"0x1\",\"0x0000000000000000000000000000000000000033\":\"0x1\",\"0x0000000000000000000000000000000000000034\":\"0x1\",\"0x0000000000000000000000000000000000000035\":\"0x1\",\"0x0000000000000000000000000000000000000036\":\"0x1\",\"0x0000000000000000000000000000000000000037\":\"0x1\",\"0x0000000000000000000000000000000000000038\":\"0x1\",\"0x0000000000000000000000000000000000000039\":\"0x1\",\"0x000000000000000000000000000000000000003a\":\"0x1\",\"0x000000000000000000000000000000000000003b\":\"0x1\",\"0x000000000000000000000000000000000000003c\":\"0x1\",\"0x000000000000000000000000000000000000003d\":\"0x1\",\"0x000000000000000000000000000000000000003e\":\"0x1\",\"0x000000000000000000000000000000000000003f\":\"0x1\",\"0x0000000000000000000000000000000000000040\":\"0x1\",\"0x0000000000000000000000000000000000000041\":\"0x1\",\"0x0000000000000000000000000000000000000042\":\"0x1\",\"0x0000000000000000000000000000000000000043\":\"0x1\",\"0x0000000000000000000000000000000000000044\":\"0x1\",\"0x0000000000000000000000000000000000000045\":\"0x1\",\"0x0000000000000000000000000000000000000046\":\"0x1\",\"0x0000000000000000000000000000000000000047\":\"0x1\",\"0x0000000000000000000000000000000000000048\":\"0x1\",\"0x0000000000000000000000000000000000000049\":\"0x1\",\"0x000000000000000000000000000000000000004a\":\"0x1\",\"0x000000000000000000000000000000000000004b\":\"0x1\",\"0x000000000000000000000000000000000000004c\":\"0x1\",\"0x000000000000000000000000000000000000004d\":\"0x1\",\"0x000000000000000000000000000000000000004e\":\"0x1\",\"0x000000000000000000000000000000000000004f\":\"0x1\",\"0x0000000000000000000000000000000000000050\":\"0x1\",\"0x0000000000000000000000000000000000000051\":\"0x1\",\"0x0000000000000000000000000000000000000052\":\"0x1\",\"0x0000000000000000000000000000000000000053\":\"0x1\",\"0x0000000000000000000000000000000000000054\":\"0x1\",\"0x0000000000000000000000000000000000000055\":\"0x1\",\"0x0000000000000000000000000000000000000056\":\"0x1\",\"0x0000000000000000000000000000000000000057\":\"0x1\",\"0x0000000000000000000000000000000000000058\":\"0x1\",\"0x0000000000000000000000000000000000000059\":\"0x1\",\"0x000000000000000000000000000000000000005a\":\"0x1\",\"0x000000000000000000000000000000000000005b\":\"0x1\",\"0x000000000000000000000000000000000000005c\":\"0x1\",\"0x000000000000000000000000000000000000005d\":\"0x1\",\"0x000000000000000000000000000000000000005e\":\"0x1\",\"0x000000000000000000000000000000000000005f\":\"0x1\",\"0x0000000000000000000000000000000000000060\":\"0x1\",\"0x0000000000000000000000000000000000000061\":\"0x1\",\"0x0000000000000000000000000000000000000062\":\"0x1\",\"0x0000000000000000000000000000000000000063\":\"0x1\",\"0x0000000000000000000000000000000000000064\":\"0x1\",\"0x0000000000000000000000000000000000000065\":\"0x1\",\"0x0000000000000000000000000000000000000066\":\"0x1\",\"0x0000000000000000000000000000000000000067\":\"0x1\",\"0x0000000000000000000000000000000000000068\":\"0x1\",\"0x0000000000000000000000000000000000000069\":\"0x1\",\"0x000000000000000000000000000000000000006a\":\"0x1\",\"0x000000000000000000000000000000000000006b\":\"0x1\",\"0x000000000000000000000000000000000000006c\":\"0x1\",\"0x000000000000000000000000000000000000006d\":\"0x1\",\"0x000000000000000000000000000000000000006e\":\"0x1\",\"0x000000000000000000000000000000000000006f\":\"0x1\",\"0x0000000000000000000000000000000000000070\":\"0x1\",\"0x0000000000000000000000000000000000000071\":\"0x1\",\"0x0000000000000000000000000000000000000072\":\"0x1\",\"0x0000000000000000000000000000000000000073\":\"0x1\",\"0x0000000000000000000000000000000000000074\":\"0x1\",\"0x0000000000000000000000000000000000000075\":\"0x1\",\"0x0000000000000000000000000000000000000076\":\"0x1\",\"0x0000000000000000000000000000000000000077\":\"0x1\",\"0x0000000000000000000000000000000000000078\":\"0x1\",\"0x0000000000000000000000000000000000000079\":\"0x1\",\"0x000000000000000000000000000000000000007a\":\"0x1\",\"0x000000000000000000000000000000000000007b\":\"0x1\",\"0x000000000000000000000000000000000000007c\":\"0x1\",\"0x000000000000000000000000000000000000007d\":\"0x1\",\"0x000000000000000000000000000000000000007e\":\"0x1\",\"0x000000000000000000000000000000000000007f\":\"0x1\",\"0x0000000000000000000000000000000000000080\":\"0x1\",\"0x0000000000000000000000000000000000000081\":\"0x1\",\"0x0000000000000000000000000000000000000082\":\"0x1\",\"0x0000000000000000000000000000000000000083\":\"0x1\",\"0x0000000000000000000000000000000000000084\":\"0x1\",\"0x0000000000000000000000000000000000000085\":\"0x1\",\"0x0000000000000000000000000000000000000086\":\"0x1\",\"0x0000000000000000000000000000000000000087\":\"0x1\",\"0x0000000000000000000000000000000000000088\":\"0x1\",\"0x0000000000000000000000000000000000000089\":\"0x1\",\"0x000000000000000000000000000000000000008a\":\"0x1\",\"0x000000000000000000000000000000000000008b\":\"0x1\",\"0x000000000000000000000000000000000000008c\":\"0x1\",\"0x000000000000000000000000000000000000008d\":\"0x1\",\"0x000000000000000000000000000000000000008e\":\"0x1\",\"0x000000000000000000000000000000000000008f\":\"0x1\",\"0x0000000000000000000000000000000000000090\":\"0x1\",\"0x0000000000000000000000000000000000000091\":\"0x1\",\"0x0000000000000000000000000000000000000092\":\"0x1\",\"0x0000000000000000000000000000000000000093\":\"0x1\",\"0x0000000000000000000000000000000000000094\":\"0x1\",\"0x0000000000000000000000000000000000000095\":\"0x1\",\"0x0000000000000000000000000000000000000096\":\"0x1\",\"0x0000000000000000000000000000000000000097\":\"0x1\",\"0x0000000000000000000000000000000000000098\":\"0x1\",\"0x0000000000000000000000000000000000000099\":\"0x1\",\"0x000000000000000000000000000000000000009a\":\"0x1\",\"0x000000000000000000000000000000000000009b\":\"0x1\",\"0x000000000000000000000000000000000000009c\":\"0x1\",\"0x000000000000000000000000000000000000009d\":\"0x1\",\"0x000000000000000000000000000000000000009e\":\"0x1\",\"0x000000000000000000000000000000000000009f\":\"0x1\",\"0x00000000000000000000000000000000000000a0\":\"0x1\",\"0x00000000000000000000000000000000000000a1\":\"0x1\",\"0x00000000000000000000000000000000000000a2\":\"0x1\",\"0x00000000000000000000000000000000000000a3\":\"0x1\",\"0x00000000000000000000000000000000000000a4\":\"0x1\",\"0x00000000000000000000000000000000000000a5\":\"0x1\",\"0x00000000000000000000000000000000000000a6\":\"0x1\",\"0x00000000000000000000000000000000000000a7\":\"0x1\",\"0x00000000000000000000000000000000000000a8\":\"0x1\",\"0x00000000000000000000000000000000000000a9\":\"0x1\",\"0x00000000000000000000000000000000000000aa\":\"0x1\",\"0x00000000000000000000000000000000000000ab\":\"0x1\",\"0x00000000000000000000000000000000000000ac\":\"0x1\",\"0x00000000000000000000000000000000000000ad\":\"0x1\",\"0x00000000000000000000000000000000000000ae\":\"0x1\",\"0x00000000000000000000000000000000000000af\":\"0x1\",\"0x00000000000000000000000000000000000000b0\":\"0x1\",\"0x00000000000000000000000000000000000000b1\":\"0x1\",\"0x00000000000000000000000000000000000000b2\":\"0x1\",\"0x00000000000000000000000000000000000000b3\":\"0x1\",\"0x00000000000000000000000000000000000000b4\":\"0x1\",\"0x00000000000000000000000000000000000000b5\":\"0x1\",\"0x00000000000000000000000000000000000000b6\":\"0x1\",\"0x00000000000000000000000000000000000000b7\":\"0x1\",\"0x00000000000000000000000000000000000000b8\":\"0x1\",\"0x00000000000000000000000000000000000000b9\":\"0x1\",\"0x00000000000000000000000000000000000000ba\":\"0x1\",\"0x00000000000000000000000000000000000000bb\":\"0x1\",\"0x00000000000000000000000000000000000000bc\":\"0x1\",\"0x00000000000000000000000000000000000000bd\":\"0x1\",\"0x00000000000000000000000000000000000000be\":\"0x1\",\"0x00000000000000000000000000000000000000bf\":\"0x1\",\"0x00000000000000000000000000000000000000c0\":\"0x1\",\"0x00000000000000000000000000000000000000c1\":\"0x1\",\"0x00000000000000000000000000000000000000c2\":\"0x1\",\"0x00000000000000000000000000000000000000c3\":\"0x1\",\"0x00000000000000000000000000000000000000c4\":\"0x1\",\"0x00000000000000000000000000000000000000c5\":\"0x1\",\"0x00000000000000000000000000000000000000c6\":\"0x1\",\"0x00000000000000000000000000000000000000c7\":\"0x1\",\"0x00000000000000000000000000000000000000c8\":\"0x1\",\"0x00000000000000000000000000000000000000c9\":\"0x1\",\"0x00000000000000000000000000000000000000ca\":\"0x1\",\"0x00000000000000000000000000000000000000cb\":\"0x1\",\"0x00000000000000000000000000000000000000cc\":\"0x1\",\"0x00000000000000000000000000000000000000cd\":\"0x1\",\"0x00000000000000000000000000000000000000ce\":\"0x1\",\"0x00000000000000000000000000000000000000cf\":\"0x1\",\"0x00000000000000000000000000000000000000d0\":\"0x1\",\"0x00000000000000000000000000000000000000d1\":\"0x1\",\"0x00000000000000000000000000000000000000d2\":\"0x1\",\"0x00000000000000000000000000000000000000d3\":\"0x1\",\"0x00000000000000000000000000000000000000d4\":\"0x1\",\"0x00000000000000000000000000000000000000d5\":\"0x1\",\"0x00000000000000000000000000000000000000d6\":\"0x1\",\"0x00000000000000000000000000000000000000d7\":\"0x1\",\"0x00000000000000000000000000000000000000d8\":\"0x1\",\"0x00000000000000000000000000000000000000d9\":\"0x1\",\"0x00000000000000000000000000000000000000da\":\"0x1\",\"0x00000000000000000000000000000000000000db\":\"0x1\",\"0x00000000000000000000000000000000000000dc\":\"0x1\",\"0x00000000000000000000000000000000000000dd\":\"0x1\",\"0x00000000000000000000000000000000000000de\":\"0x1\",\"0x00000000000000000000000000000000000000df\":\"0x1\",\"0x00000000000000000000000000000000000000e0\":\"0x1\",\"0x00000000000000000000000000000000000000e1\":\"0x1\",\"0x00000000000000000000000000000000000000e2\":\"0x1\",\"0x00000000000000000000000000000000000000e3\":\"0x1\",\"0x00000000000000000000000000000000000000e4\":\"0x1\",\"0x00000000000000000000000000000000000000e5\":\"0x1\",\"0x00000000000000000000000000000000000000e6\":\"0x1\",\"0x00000000000000000000000000000000000000e7\":\"0x1\",\"0x00000000000000000000000000000000000000e8\":\"0x1\",\"0x00000000000000000000000000000000000000e9\":\"0x1\",\"0x00000000000000000000000000000000000000ea\":\"0x1\",\"0x00000000000000000000000000000000000000eb\":\"0x1\",\"0x00000000000000000000000000000000000000ec\":\"0x1\",\"0x00000000000000000000000000000000000000ed\":\"0x1\",\"0x00000000000000000000000000000000000000ee\":\"0x1\",\"0x00000000000000000000000000000000000000ef\":\"0x1\",\"0x00000000000000000000000000000000000000f0\":\"0x1\",\"0x00000000000000000000000000000000000000f1\":\"0x1\",\"0x00000000000000000000000000000000000000f2\":\"0x1\",\"0x00000000000000000000000000000000000000f3\":\"0x1\",\"0x00000000000000000000000000000000000000f4\":\"0x1\",\"0x00000000000000000000000000000000000000f5\":\"0x1\",\"0x00000000000000000000000000000000000000f6\":\"0x1\",\"0x00000000000000000000000000000000000000f7\":\"0x1\",\"0x00000000000000000000000000000000000000f8\":\"0x1\",\"0x00000000000000000000000000000000000000f9\":\"0x1\",\"0x00000000000000000000000000000000000000fa\":\"0x1\",\"0x00000000000000000000000000000000000000fb\":\"0x1\",\"0x00000000000000000000000000000000000000fc\":\"0x1\",\"0x00000000000000000000000000000000000000fd\":\"0x1\",\"0x00000000000000000000000000000000000000fe\":\"0x1\",\"0x00000000000000000000000000000000000000ff\":\"0x1\",\"0x31b98d14007bdee637298086988a0bbd31184523\":\"0x200000000000000000000000000000000000000000000000000000000000000\"}");

});

parcelRegister("g4EhK", function(module, exports) {
module.exports = JSON.parse("{\"0x0000000000000000000000000000000000000001\":\"0x1\",\"0x0000000000000000000000000000000000000002\":\"0x1\",\"0x0000000000000000000000000000000000000003\":\"0x1\",\"0x0000000000000000000000000000000000000004\":\"0x1\",\"0x00521965e7bd230323c423d96c657db5b79d099f\":\"0x100000000000000000000000000000000000000000000000000\"}");

});

parcelRegister("iINzt", function(module, exports) {
module.exports = JSON.parse("{\"0x0000000000000000000000000000000000000000\":\"0x1\",\"0x0000000000000000000000000000000000000001\":\"0x1\",\"0x0000000000000000000000000000000000000002\":\"0x1\",\"0x0000000000000000000000000000000000000003\":\"0x1\",\"0x0000000000000000000000000000000000000004\":\"0x1\",\"0x0000000000000000000000000000000000000005\":\"0x1\",\"0x0000000000000000000000000000000000000006\":\"0x1\",\"0x0000000000000000000000000000000000000007\":\"0x1\",\"0x0000000000000000000000000000000000000008\":\"0x1\",\"0x0000000000000000000000000000000000000009\":\"0x1\",\"0x000000000000000000000000000000000000000a\":\"0x1\",\"0x000000000000000000000000000000000000000b\":\"0x1\",\"0x000000000000000000000000000000000000000c\":\"0x1\",\"0x000000000000000000000000000000000000000d\":\"0x1\",\"0x000000000000000000000000000000000000000e\":\"0x1\",\"0x000000000000000000000000000000000000000f\":\"0x1\",\"0x0000000000000000000000000000000000000010\":\"0x1\",\"0x0000000000000000000000000000000000000011\":\"0x1\",\"0x0000000000000000000000000000000000000012\":\"0x1\",\"0x0000000000000000000000000000000000000013\":\"0x1\",\"0x0000000000000000000000000000000000000014\":\"0x1\",\"0x0000000000000000000000000000000000000015\":\"0x1\",\"0x0000000000000000000000000000000000000016\":\"0x1\",\"0x0000000000000000000000000000000000000017\":\"0x1\",\"0x0000000000000000000000000000000000000018\":\"0x1\",\"0x0000000000000000000000000000000000000019\":\"0x1\",\"0x000000000000000000000000000000000000001a\":\"0x1\",\"0x000000000000000000000000000000000000001b\":\"0x1\",\"0x000000000000000000000000000000000000001c\":\"0x1\",\"0x000000000000000000000000000000000000001d\":\"0x1\",\"0x000000000000000000000000000000000000001e\":\"0x1\",\"0x000000000000000000000000000000000000001f\":\"0x1\",\"0x0000000000000000000000000000000000000020\":\"0x1\",\"0x0000000000000000000000000000000000000021\":\"0x1\",\"0x0000000000000000000000000000000000000022\":\"0x1\",\"0x0000000000000000000000000000000000000023\":\"0x1\",\"0x0000000000000000000000000000000000000024\":\"0x1\",\"0x0000000000000000000000000000000000000025\":\"0x1\",\"0x0000000000000000000000000000000000000026\":\"0x1\",\"0x0000000000000000000000000000000000000027\":\"0x1\",\"0x0000000000000000000000000000000000000028\":\"0x1\",\"0x0000000000000000000000000000000000000029\":\"0x1\",\"0x000000000000000000000000000000000000002a\":\"0x1\",\"0x000000000000000000000000000000000000002b\":\"0x1\",\"0x000000000000000000000000000000000000002c\":\"0x1\",\"0x000000000000000000000000000000000000002d\":\"0x1\",\"0x000000000000000000000000000000000000002e\":\"0x1\",\"0x000000000000000000000000000000000000002f\":\"0x1\",\"0x0000000000000000000000000000000000000030\":\"0x1\",\"0x0000000000000000000000000000000000000031\":\"0x1\",\"0x0000000000000000000000000000000000000032\":\"0x1\",\"0x0000000000000000000000000000000000000033\":\"0x1\",\"0x0000000000000000000000000000000000000034\":\"0x1\",\"0x0000000000000000000000000000000000000035\":\"0x1\",\"0x0000000000000000000000000000000000000036\":\"0x1\",\"0x0000000000000000000000000000000000000037\":\"0x1\",\"0x0000000000000000000000000000000000000038\":\"0x1\",\"0x0000000000000000000000000000000000000039\":\"0x1\",\"0x000000000000000000000000000000000000003a\":\"0x1\",\"0x000000000000000000000000000000000000003b\":\"0x1\",\"0x000000000000000000000000000000000000003c\":\"0x1\",\"0x000000000000000000000000000000000000003d\":\"0x1\",\"0x000000000000000000000000000000000000003e\":\"0x1\",\"0x000000000000000000000000000000000000003f\":\"0x1\",\"0x0000000000000000000000000000000000000040\":\"0x1\",\"0x0000000000000000000000000000000000000041\":\"0x1\",\"0x0000000000000000000000000000000000000042\":\"0x1\",\"0x0000000000000000000000000000000000000043\":\"0x1\",\"0x0000000000000000000000000000000000000044\":\"0x1\",\"0x0000000000000000000000000000000000000045\":\"0x1\",\"0x0000000000000000000000000000000000000046\":\"0x1\",\"0x0000000000000000000000000000000000000047\":\"0x1\",\"0x0000000000000000000000000000000000000048\":\"0x1\",\"0x0000000000000000000000000000000000000049\":\"0x1\",\"0x000000000000000000000000000000000000004a\":\"0x1\",\"0x000000000000000000000000000000000000004b\":\"0x1\",\"0x000000000000000000000000000000000000004c\":\"0x1\",\"0x000000000000000000000000000000000000004d\":\"0x1\",\"0x000000000000000000000000000000000000004e\":\"0x1\",\"0x000000000000000000000000000000000000004f\":\"0x1\",\"0x0000000000000000000000000000000000000050\":\"0x1\",\"0x0000000000000000000000000000000000000051\":\"0x1\",\"0x0000000000000000000000000000000000000052\":\"0x1\",\"0x0000000000000000000000000000000000000053\":\"0x1\",\"0x0000000000000000000000000000000000000054\":\"0x1\",\"0x0000000000000000000000000000000000000055\":\"0x1\",\"0x0000000000000000000000000000000000000056\":\"0x1\",\"0x0000000000000000000000000000000000000057\":\"0x1\",\"0x0000000000000000000000000000000000000058\":\"0x1\",\"0x0000000000000000000000000000000000000059\":\"0x1\",\"0x000000000000000000000000000000000000005a\":\"0x1\",\"0x000000000000000000000000000000000000005b\":\"0x1\",\"0x000000000000000000000000000000000000005c\":\"0x1\",\"0x000000000000000000000000000000000000005d\":\"0x1\",\"0x000000000000000000000000000000000000005e\":\"0x1\",\"0x000000000000000000000000000000000000005f\":\"0x1\",\"0x0000000000000000000000000000000000000060\":\"0x1\",\"0x0000000000000000000000000000000000000061\":\"0x1\",\"0x0000000000000000000000000000000000000062\":\"0x1\",\"0x0000000000000000000000000000000000000063\":\"0x1\",\"0x0000000000000000000000000000000000000064\":\"0x1\",\"0x0000000000000000000000000000000000000065\":\"0x1\",\"0x0000000000000000000000000000000000000066\":\"0x1\",\"0x0000000000000000000000000000000000000067\":\"0x1\",\"0x0000000000000000000000000000000000000068\":\"0x1\",\"0x0000000000000000000000000000000000000069\":\"0x1\",\"0x000000000000000000000000000000000000006a\":\"0x1\",\"0x000000000000000000000000000000000000006b\":\"0x1\",\"0x000000000000000000000000000000000000006c\":\"0x1\",\"0x000000000000000000000000000000000000006d\":\"0x1\",\"0x000000000000000000000000000000000000006e\":\"0x1\",\"0x000000000000000000000000000000000000006f\":\"0x1\",\"0x0000000000000000000000000000000000000070\":\"0x1\",\"0x0000000000000000000000000000000000000071\":\"0x1\",\"0x0000000000000000000000000000000000000072\":\"0x1\",\"0x0000000000000000000000000000000000000073\":\"0x1\",\"0x0000000000000000000000000000000000000074\":\"0x1\",\"0x0000000000000000000000000000000000000075\":\"0x1\",\"0x0000000000000000000000000000000000000076\":\"0x1\",\"0x0000000000000000000000000000000000000077\":\"0x1\",\"0x0000000000000000000000000000000000000078\":\"0x1\",\"0x0000000000000000000000000000000000000079\":\"0x1\",\"0x000000000000000000000000000000000000007a\":\"0x1\",\"0x000000000000000000000000000000000000007b\":\"0x1\",\"0x000000000000000000000000000000000000007c\":\"0x1\",\"0x000000000000000000000000000000000000007d\":\"0x1\",\"0x000000000000000000000000000000000000007e\":\"0x1\",\"0x000000000000000000000000000000000000007f\":\"0x1\",\"0x0000000000000000000000000000000000000080\":\"0x1\",\"0x0000000000000000000000000000000000000081\":\"0x1\",\"0x0000000000000000000000000000000000000082\":\"0x1\",\"0x0000000000000000000000000000000000000083\":\"0x1\",\"0x0000000000000000000000000000000000000084\":\"0x1\",\"0x0000000000000000000000000000000000000085\":\"0x1\",\"0x0000000000000000000000000000000000000086\":\"0x1\",\"0x0000000000000000000000000000000000000087\":\"0x1\",\"0x0000000000000000000000000000000000000088\":\"0x1\",\"0x0000000000000000000000000000000000000089\":\"0x1\",\"0x000000000000000000000000000000000000008a\":\"0x1\",\"0x000000000000000000000000000000000000008b\":\"0x1\",\"0x000000000000000000000000000000000000008c\":\"0x1\",\"0x000000000000000000000000000000000000008d\":\"0x1\",\"0x000000000000000000000000000000000000008e\":\"0x1\",\"0x000000000000000000000000000000000000008f\":\"0x1\",\"0x0000000000000000000000000000000000000090\":\"0x1\",\"0x0000000000000000000000000000000000000091\":\"0x1\",\"0x0000000000000000000000000000000000000092\":\"0x1\",\"0x0000000000000000000000000000000000000093\":\"0x1\",\"0x0000000000000000000000000000000000000094\":\"0x1\",\"0x0000000000000000000000000000000000000095\":\"0x1\",\"0x0000000000000000000000000000000000000096\":\"0x1\",\"0x0000000000000000000000000000000000000097\":\"0x1\",\"0x0000000000000000000000000000000000000098\":\"0x1\",\"0x0000000000000000000000000000000000000099\":\"0x1\",\"0x000000000000000000000000000000000000009a\":\"0x1\",\"0x000000000000000000000000000000000000009b\":\"0x1\",\"0x000000000000000000000000000000000000009c\":\"0x1\",\"0x000000000000000000000000000000000000009d\":\"0x1\",\"0x000000000000000000000000000000000000009e\":\"0x1\",\"0x000000000000000000000000000000000000009f\":\"0x1\",\"0x00000000000000000000000000000000000000a0\":\"0x1\",\"0x00000000000000000000000000000000000000a1\":\"0x1\",\"0x00000000000000000000000000000000000000a2\":\"0x1\",\"0x00000000000000000000000000000000000000a3\":\"0x1\",\"0x00000000000000000000000000000000000000a4\":\"0x1\",\"0x00000000000000000000000000000000000000a5\":\"0x1\",\"0x00000000000000000000000000000000000000a6\":\"0x1\",\"0x00000000000000000000000000000000000000a7\":\"0x1\",\"0x00000000000000000000000000000000000000a8\":\"0x1\",\"0x00000000000000000000000000000000000000a9\":\"0x1\",\"0x00000000000000000000000000000000000000aa\":\"0x1\",\"0x00000000000000000000000000000000000000ab\":\"0x1\",\"0x00000000000000000000000000000000000000ac\":\"0x1\",\"0x00000000000000000000000000000000000000ad\":\"0x1\",\"0x00000000000000000000000000000000000000ae\":\"0x1\",\"0x00000000000000000000000000000000000000af\":\"0x1\",\"0x00000000000000000000000000000000000000b0\":\"0x1\",\"0x00000000000000000000000000000000000000b1\":\"0x1\",\"0x00000000000000000000000000000000000000b2\":\"0x1\",\"0x00000000000000000000000000000000000000b3\":\"0x1\",\"0x00000000000000000000000000000000000000b4\":\"0x1\",\"0x00000000000000000000000000000000000000b5\":\"0x1\",\"0x00000000000000000000000000000000000000b6\":\"0x1\",\"0x00000000000000000000000000000000000000b7\":\"0x1\",\"0x00000000000000000000000000000000000000b8\":\"0x1\",\"0x00000000000000000000000000000000000000b9\":\"0x1\",\"0x00000000000000000000000000000000000000ba\":\"0x1\",\"0x00000000000000000000000000000000000000bb\":\"0x1\",\"0x00000000000000000000000000000000000000bc\":\"0x1\",\"0x00000000000000000000000000000000000000bd\":\"0x1\",\"0x00000000000000000000000000000000000000be\":\"0x1\",\"0x00000000000000000000000000000000000000bf\":\"0x1\",\"0x00000000000000000000000000000000000000c0\":\"0x1\",\"0x00000000000000000000000000000000000000c1\":\"0x1\",\"0x00000000000000000000000000000000000000c2\":\"0x1\",\"0x00000000000000000000000000000000000000c3\":\"0x1\",\"0x00000000000000000000000000000000000000c4\":\"0x1\",\"0x00000000000000000000000000000000000000c5\":\"0x1\",\"0x00000000000000000000000000000000000000c6\":\"0x1\",\"0x00000000000000000000000000000000000000c7\":\"0x1\",\"0x00000000000000000000000000000000000000c8\":\"0x1\",\"0x00000000000000000000000000000000000000c9\":\"0x1\",\"0x00000000000000000000000000000000000000ca\":\"0x1\",\"0x00000000000000000000000000000000000000cb\":\"0x1\",\"0x00000000000000000000000000000000000000cc\":\"0x1\",\"0x00000000000000000000000000000000000000cd\":\"0x1\",\"0x00000000000000000000000000000000000000ce\":\"0x1\",\"0x00000000000000000000000000000000000000cf\":\"0x1\",\"0x00000000000000000000000000000000000000d0\":\"0x1\",\"0x00000000000000000000000000000000000000d1\":\"0x1\",\"0x00000000000000000000000000000000000000d2\":\"0x1\",\"0x00000000000000000000000000000000000000d3\":\"0x1\",\"0x00000000000000000000000000000000000000d4\":\"0x1\",\"0x00000000000000000000000000000000000000d5\":\"0x1\",\"0x00000000000000000000000000000000000000d6\":\"0x1\",\"0x00000000000000000000000000000000000000d7\":\"0x1\",\"0x00000000000000000000000000000000000000d8\":\"0x1\",\"0x00000000000000000000000000000000000000d9\":\"0x1\",\"0x00000000000000000000000000000000000000da\":\"0x1\",\"0x00000000000000000000000000000000000000db\":\"0x1\",\"0x00000000000000000000000000000000000000dc\":\"0x1\",\"0x00000000000000000000000000000000000000dd\":\"0x1\",\"0x00000000000000000000000000000000000000de\":\"0x1\",\"0x00000000000000000000000000000000000000df\":\"0x1\",\"0x00000000000000000000000000000000000000e0\":\"0x1\",\"0x00000000000000000000000000000000000000e1\":\"0x1\",\"0x00000000000000000000000000000000000000e2\":\"0x1\",\"0x00000000000000000000000000000000000000e3\":\"0x1\",\"0x00000000000000000000000000000000000000e4\":\"0x1\",\"0x00000000000000000000000000000000000000e5\":\"0x1\",\"0x00000000000000000000000000000000000000e6\":\"0x1\",\"0x00000000000000000000000000000000000000e7\":\"0x1\",\"0x00000000000000000000000000000000000000e8\":\"0x1\",\"0x00000000000000000000000000000000000000e9\":\"0x1\",\"0x00000000000000000000000000000000000000ea\":\"0x1\",\"0x00000000000000000000000000000000000000eb\":\"0x1\",\"0x00000000000000000000000000000000000000ec\":\"0x1\",\"0x00000000000000000000000000000000000000ed\":\"0x1\",\"0x00000000000000000000000000000000000000ee\":\"0x1\",\"0x00000000000000000000000000000000000000ef\":\"0x1\",\"0x00000000000000000000000000000000000000f0\":\"0x1\",\"0x00000000000000000000000000000000000000f1\":\"0x1\",\"0x00000000000000000000000000000000000000f2\":\"0x1\",\"0x00000000000000000000000000000000000000f3\":\"0x1\",\"0x00000000000000000000000000000000000000f4\":\"0x1\",\"0x00000000000000000000000000000000000000f5\":\"0x1\",\"0x00000000000000000000000000000000000000f6\":\"0x1\",\"0x00000000000000000000000000000000000000f7\":\"0x1\",\"0x00000000000000000000000000000000000000f8\":\"0x1\",\"0x00000000000000000000000000000000000000f9\":\"0x1\",\"0x00000000000000000000000000000000000000fa\":\"0x1\",\"0x00000000000000000000000000000000000000fb\":\"0x1\",\"0x00000000000000000000000000000000000000fc\":\"0x1\",\"0x00000000000000000000000000000000000000fd\":\"0x1\",\"0x00000000000000000000000000000000000000fe\":\"0x1\",\"0x00000000000000000000000000000000000000ff\":\"0x1\",\"0x4c2ae482593505f0163cdefc073e81c63cda4107\":\"0x152d02c7e14af6800000\",\"0xa8e8f14732658e4b51e8711931053a8a69baf2b1\":\"0x152d02c7e14af6800000\",\"0xd9a5179f091d85051d3c982785efd1455cec8699\":\"0x84595161401484a000000\",\"0xe0a2bd4258d2768837baa26a28fe71dc079f84c7\":\"0x4a47e3c12448f4ad000000\"}");

});




parcelRegister("fwf55", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b4c58af0f0c49f20$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $b4c58af0f0c49f20$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b4c58af0f0c49f20$var$__assign = module.exports && module.exports.__assign || function() {
    $b4c58af0f0c49f20$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b4c58af0f0c49f20$var$__assign.apply(this, arguments);
};
var $b4c58af0f0c49f20$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7Z98w = parcelRequire("7Z98w");

var $kuLXK = parcelRequire("kuLXK");

var $joOVu = parcelRequire("joOVu");

var $kYdkU = parcelRequire("kYdkU");
var $b4c58af0f0c49f20$var$TRANSACTION_TYPE = 1;
var $b4c58af0f0c49f20$var$TRANSACTION_TYPE_BUFFER = $b4c58af0f0c49f20$require$Buffer.from($b4c58af0f0c49f20$var$TRANSACTION_TYPE.toString(16).padStart(2, '0'), 'hex');
/**
 * Typed transaction with optional access lists
 *
 * - TransactionType: 1
 * - EIP: [EIP-2930](https://eips.ethereum.org/EIPS/eip-2930)
 */ var $b4c58af0f0c49f20$var$AccessListEIP2930Transaction = /** @class */ function(_super) {
    $b4c58af0f0c49f20$var$__extends(AccessListEIP2930Transaction, _super);
    /**
     * This constructor takes the values, validates them, assigns them and freezes the object.
     *
     * It is not recommended to use this constructor directly. Instead use
     * the static factory methods to assist in creating a Transaction object from
     * varying data types.
     */ function AccessListEIP2930Transaction(txData, opts) {
        if (opts === void 0) opts = {};
        var _a, _b;
        var _this = _super.call(this, $b4c58af0f0c49f20$var$__assign($b4c58af0f0c49f20$var$__assign({}, txData), {
            type: $b4c58af0f0c49f20$var$TRANSACTION_TYPE
        })) || this;
        /**
         * The default HF if the tx type is active on that HF
         * or the first greater HF where the tx is active.
         *
         * @hidden
         */ _this.DEFAULT_HARDFORK = 'berlin';
        var chainId = txData.chainId, accessList = txData.accessList, gasPrice = txData.gasPrice;
        _this.common = _this._getCommon(opts.common, chainId);
        _this.chainId = _this.common.chainIdBN();
        // EIP-2718 check is done in Common
        if (!_this.common.isActivatedEIP(2930)) throw new Error('EIP-2930 not enabled on Common');
        _this.activeCapabilities = _this.activeCapabilities.concat([
            2718,
            2930
        ]);
        // Populate the access list fields
        var accessListData = $kYdkU.AccessLists.getAccessListData(accessList !== null && accessList !== void 0 ? accessList : []);
        _this.accessList = accessListData.accessList;
        _this.AccessListJSON = accessListData.AccessListJSON;
        // Verify the access list format.
        $kYdkU.AccessLists.verifyAccessList(_this.accessList);
        _this.gasPrice = new $7Z98w.BN((0, $7Z98w.toBuffer)(gasPrice === '' ? '0x' : gasPrice));
        _this._validateCannotExceedMaxInteger({
            gasPrice: _this.gasPrice
        });
        if (_this.v && !_this.v.eqn(0) && !_this.v.eqn(1)) {
            var msg = _this._errorMsg('The y-parity of the transaction should either be 0 or 1');
            throw new Error(msg);
        }
        if (_this.common.gteHardfork('homestead') && ((_a = _this.s) === null || _a === void 0 ? void 0 : _a.gt($joOVu.N_DIV_2))) {
            var msg = _this._errorMsg('Invalid Signature: s-values greater than secp256k1n/2 are considered invalid');
            throw new Error(msg);
        }
        var freeze = (_b = opts === null || opts === void 0 ? void 0 : opts.freeze) !== null && _b !== void 0 ? _b : true;
        if (freeze) Object.freeze(_this);
        return _this;
    }
    Object.defineProperty(AccessListEIP2930Transaction.prototype, "senderR", {
        /**
         * EIP-2930 alias for `r`
         *
         * @deprecated use `r` instead
         */ get: function() {
            return this.r;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccessListEIP2930Transaction.prototype, "senderS", {
        /**
         * EIP-2930 alias for `s`
         *
         * @deprecated use `s` instead
         */ get: function() {
            return this.s;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccessListEIP2930Transaction.prototype, "yParity", {
        /**
         * EIP-2930 alias for `v`
         *
         * @deprecated use `v` instead
         */ get: function() {
            return this.v;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Instantiate a transaction from a data dictionary.
     *
     * Format: { chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * v, r, s }
     *
     * Notes:
     * - `chainId` will be set automatically if not provided
     * - All parameters are optional and have some basic default values
     */ AccessListEIP2930Transaction.fromTxData = function(txData, opts) {
        if (opts === void 0) opts = {};
        return new AccessListEIP2930Transaction(txData, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     *
     * Format: `0x01 || rlp([chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)])`
     */ AccessListEIP2930Transaction.fromSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        if (!serialized.slice(0, 1).equals($b4c58af0f0c49f20$var$TRANSACTION_TYPE_BUFFER)) throw new Error("Invalid serialized tx input: not an EIP-2930 transaction (wrong tx type, expected: " + $b4c58af0f0c49f20$var$TRANSACTION_TYPE + ", received: " + serialized.slice(0, 1).toString('hex'));
        var values = $7Z98w.rlp.decode(serialized.slice(1));
        if (!Array.isArray(values)) throw new Error('Invalid serialized tx input: must be array');
        return AccessListEIP2930Transaction.fromValuesArray(values, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     * (alias of {@link AccessListEIP2930Transaction.fromSerializedTx})
     *
     * Note: This means that the Buffer should start with 0x01.
     *
     * @deprecated this constructor alias is deprecated and will be removed
     * in favor of the {@link AccessListEIP2930Transaction.fromSerializedTx} constructor
     */ AccessListEIP2930Transaction.fromRlpSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        return AccessListEIP2930Transaction.fromSerializedTx(serialized, opts);
    };
    /**
     * Create a transaction from a values array.
     *
     * Format: `[chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)]`
     */ AccessListEIP2930Transaction.fromValuesArray = function(values, opts) {
        if (opts === void 0) opts = {};
        if (values.length !== 8 && values.length !== 11) throw new Error('Invalid EIP-2930 transaction. Only expecting 8 values (for unsigned tx) or 11 values (for signed tx).');
        var _a = $b4c58af0f0c49f20$var$__read(values, 11), chainId = _a[0], nonce = _a[1], gasPrice = _a[2], gasLimit = _a[3], to = _a[4], value = _a[5], data = _a[6], accessList = _a[7], v = _a[8], r = _a[9], s = _a[10];
        var emptyAccessList = [];
        return new AccessListEIP2930Transaction({
            chainId: new $7Z98w.BN(chainId),
            nonce: nonce,
            gasPrice: gasPrice,
            gasLimit: gasLimit,
            to: to,
            value: value,
            data: data,
            accessList: accessList !== null && accessList !== void 0 ? accessList : emptyAccessList,
            v: v !== undefined ? new $7Z98w.BN(v) : undefined,
            r: r,
            s: s
        }, opts);
    };
    /**
     * The amount of gas paid for the data in this tx
     */ AccessListEIP2930Transaction.prototype.getDataFee = function() {
        if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) return this.cache.dataFee.value;
        var cost = _super.prototype.getDataFee.call(this);
        cost.iaddn($kYdkU.AccessLists.getDataFeeEIP2930(this.accessList, this.common));
        if (Object.isFrozen(this)) this.cache.dataFee = {
            value: cost,
            hardfork: this.common.hardfork()
        };
        return cost;
    };
    /**
     * The up front amount that an account must have for this transaction to be valid
     */ AccessListEIP2930Transaction.prototype.getUpfrontCost = function() {
        return this.gasLimit.mul(this.gasPrice).add(this.value);
    };
    /**
     * Returns a Buffer Array of the raw Buffers of the EIP-2930 transaction, in order.
     *
     * Format: `[chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)]`
     *
     * Use {@link AccessListEIP2930Transaction.serialize} to add a transaction to a block
     * with {@link Block.fromValuesArray}.
     *
     * For an unsigned tx this method uses the empty Buffer values for the
     * signature parameters `v`, `r` and `s` for encoding. For an EIP-155 compliant
     * representation for external signing use {@link AccessListEIP2930Transaction.getMessageToSign}.
     */ AccessListEIP2930Transaction.prototype.raw = function() {
        return [
            (0, $7Z98w.bnToUnpaddedBuffer)(this.chainId),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.nonce),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.gasPrice),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.gasLimit),
            this.to !== undefined ? this.to.buf : $b4c58af0f0c49f20$require$Buffer.from([]),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.value),
            this.data,
            this.accessList,
            this.v !== undefined ? (0, $7Z98w.bnToUnpaddedBuffer)(this.v) : $b4c58af0f0c49f20$require$Buffer.from([]),
            this.r !== undefined ? (0, $7Z98w.bnToUnpaddedBuffer)(this.r) : $b4c58af0f0c49f20$require$Buffer.from([]),
            this.s !== undefined ? (0, $7Z98w.bnToUnpaddedBuffer)(this.s) : $b4c58af0f0c49f20$require$Buffer.from([])
        ];
    };
    /**
     * Returns the serialized encoding of the EIP-2930 transaction.
     *
     * Format: `0x01 || rlp([chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)])`
     *
     * Note that in contrast to the legacy tx serialization format this is not
     * valid RLP any more due to the raw tx type preceding and concatenated to
     * the RLP encoding of the values.
     */ AccessListEIP2930Transaction.prototype.serialize = function() {
        var base = this.raw();
        return $b4c58af0f0c49f20$require$Buffer.concat([
            $b4c58af0f0c49f20$var$TRANSACTION_TYPE_BUFFER,
            $7Z98w.rlp.encode(base)
        ]);
    };
    /**
     * Returns the serialized unsigned tx (hashed or raw), which can be used
     * to sign the transaction (e.g. for sending to a hardware wallet).
     *
     * Note: in contrast to the legacy tx the raw message format is already
     * serialized and doesn't need to be RLP encoded any more.
     *
     * ```javascript
     * const serializedMessage = tx.getMessageToSign(false) // use this for the HW wallet input
     * ```
     *
     * @param hashMessage - Return hashed message if set to true (default: true)
     */ AccessListEIP2930Transaction.prototype.getMessageToSign = function(hashMessage) {
        if (hashMessage === void 0) hashMessage = true;
        var base = this.raw().slice(0, 8);
        var message = $b4c58af0f0c49f20$require$Buffer.concat([
            $b4c58af0f0c49f20$var$TRANSACTION_TYPE_BUFFER,
            $7Z98w.rlp.encode(base)
        ]);
        if (hashMessage) return (0, $7Z98w.keccak256)(message);
        else return message;
    };
    /**
     * Computes a sha3-256 hash of the serialized tx.
     *
     * This method can only be used for signed txs (it throws otherwise).
     * Use {@link AccessListEIP2930Transaction.getMessageToSign} to get a tx hash for the purpose of signing.
     */ AccessListEIP2930Transaction.prototype.hash = function() {
        if (!this.isSigned()) {
            var msg = this._errorMsg('Cannot call hash method if transaction is not signed');
            throw new Error(msg);
        }
        if (Object.isFrozen(this)) {
            if (!this.cache.hash) this.cache.hash = (0, $7Z98w.keccak256)(this.serialize());
            return this.cache.hash;
        }
        return (0, $7Z98w.keccak256)(this.serialize());
    };
    /**
     * Computes a sha3-256 hash which can be used to verify the signature
     */ AccessListEIP2930Transaction.prototype.getMessageToVerifySignature = function() {
        return this.getMessageToSign();
    };
    /**
     * Returns the public key of the sender
     */ AccessListEIP2930Transaction.prototype.getSenderPublicKey = function() {
        var _a;
        if (!this.isSigned()) {
            var msg = this._errorMsg('Cannot call this method if transaction is not signed');
            throw new Error(msg);
        }
        var msgHash = this.getMessageToVerifySignature();
        // EIP-2: All transaction signatures whose s-value is greater than secp256k1n/2 are considered invalid.
        // Reasoning: https://ethereum.stackexchange.com/a/55728
        if (this.common.gteHardfork('homestead') && ((_a = this.s) === null || _a === void 0 ? void 0 : _a.gt($joOVu.N_DIV_2))) {
            var msg = this._errorMsg('Invalid Signature: s-values greater than secp256k1n/2 are considered invalid');
            throw new Error(msg);
        }
        var _b = this, yParity = _b.yParity, r = _b.r, s = _b.s;
        try {
            return (0, $7Z98w.ecrecover)(msgHash, yParity.addn(27), (0, $7Z98w.bnToUnpaddedBuffer)(r), (0, $7Z98w.bnToUnpaddedBuffer)(s));
        } catch (e) {
            var msg = this._errorMsg('Invalid Signature');
            throw new Error(msg);
        }
    };
    AccessListEIP2930Transaction.prototype._processSignature = function(v, r, s) {
        var opts = {
            common: this.common
        };
        return AccessListEIP2930Transaction.fromTxData({
            chainId: this.chainId,
            nonce: this.nonce,
            gasPrice: this.gasPrice,
            gasLimit: this.gasLimit,
            to: this.to,
            value: this.value,
            data: this.data,
            accessList: this.accessList,
            v: new $7Z98w.BN(v - 27),
            r: new $7Z98w.BN(r),
            s: new $7Z98w.BN(s)
        }, opts);
    };
    /**
     * Returns an object with the JSON representation of the transaction
     */ AccessListEIP2930Transaction.prototype.toJSON = function() {
        var accessListJSON = $kYdkU.AccessLists.getAccessListJSON(this.accessList);
        return {
            chainId: (0, $7Z98w.bnToHex)(this.chainId),
            nonce: (0, $7Z98w.bnToHex)(this.nonce),
            gasPrice: (0, $7Z98w.bnToHex)(this.gasPrice),
            gasLimit: (0, $7Z98w.bnToHex)(this.gasLimit),
            to: this.to !== undefined ? this.to.toString() : undefined,
            value: (0, $7Z98w.bnToHex)(this.value),
            data: '0x' + this.data.toString('hex'),
            accessList: accessListJSON,
            v: this.v !== undefined ? (0, $7Z98w.bnToHex)(this.v) : undefined,
            r: this.r !== undefined ? (0, $7Z98w.bnToHex)(this.r) : undefined,
            s: this.s !== undefined ? (0, $7Z98w.bnToHex)(this.s) : undefined
        };
    };
    /**
     * Return a compact error string representation of the object
     */ AccessListEIP2930Transaction.prototype.errorStr = function() {
        var _a, _b;
        var errorStr = this._getSharedErrorPostfix();
        // Keep ? for this.accessList since this otherwise causes Hardhat E2E tests to fail
        errorStr += " gasPrice=" + this.gasPrice + " accessListCount=" + ((_b = (_a = this.accessList) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
        return errorStr;
    };
    /**
     * Internal helper function to create an annotated error message
     *
     * @param msg Base error message
     * @hidden
     */ AccessListEIP2930Transaction.prototype._errorMsg = function(msg) {
        return msg + " (" + this.errorStr() + ")";
    };
    return AccessListEIP2930Transaction;
}($kuLXK.BaseTransaction);
module.exports.default = $b4c58af0f0c49f20$var$AccessListEIP2930Transaction;

});
parcelRegister("kYdkU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccessLists = void 0;

var $7Z98w = parcelRequire("7Z98w");

var $joOVu = parcelRequire("joOVu");
var $f443c188c22c38c9$var$AccessLists = /** @class */ function() {
    function AccessLists() {}
    AccessLists.getAccessListData = function(accessList) {
        var AccessListJSON;
        var bufferAccessList;
        if (accessList && (0, $joOVu.isAccessList)(accessList)) {
            AccessListJSON = accessList;
            var newAccessList = [];
            for(var i = 0; i < accessList.length; i++){
                var item = accessList[i];
                var addressBuffer = (0, $7Z98w.toBuffer)(item.address);
                var storageItems = [];
                for(var index = 0; index < item.storageKeys.length; index++)storageItems.push((0, $7Z98w.toBuffer)(item.storageKeys[index]));
                newAccessList.push([
                    addressBuffer,
                    storageItems
                ]);
            }
            bufferAccessList = newAccessList;
        } else {
            bufferAccessList = accessList !== null && accessList !== void 0 ? accessList : [];
            // build the JSON
            var json = [];
            for(var i = 0; i < bufferAccessList.length; i++){
                var data = bufferAccessList[i];
                var address = (0, $7Z98w.bufferToHex)(data[0]);
                var storageKeys = [];
                for(var item = 0; item < data[1].length; item++)storageKeys.push((0, $7Z98w.bufferToHex)(data[1][item]));
                var jsonItem = {
                    address: address,
                    storageKeys: storageKeys
                };
                json.push(jsonItem);
            }
            AccessListJSON = json;
        }
        return {
            AccessListJSON: AccessListJSON,
            accessList: bufferAccessList
        };
    };
    AccessLists.verifyAccessList = function(accessList) {
        for(var key = 0; key < accessList.length; key++){
            var accessListItem = accessList[key];
            var address = accessListItem[0];
            var storageSlots = accessListItem[1];
            if (accessListItem[2] !== undefined) throw new Error('Access list item cannot have 3 elements. It can only have an address, and an array of storage slots.');
            if (address.length != 20) throw new Error('Invalid EIP-2930 transaction: address length should be 20 bytes');
            for(var storageSlot = 0; storageSlot < storageSlots.length; storageSlot++){
                if (storageSlots[storageSlot].length != 32) throw new Error('Invalid EIP-2930 transaction: storage slot length should be 32 bytes');
            }
        }
    };
    AccessLists.getAccessListJSON = function(accessList) {
        var accessListJSON = [];
        for(var index = 0; index < accessList.length; index++){
            var item = accessList[index];
            var JSONItem = {
                address: '0x' + (0, $7Z98w.setLengthLeft)(item[0], 20).toString('hex'),
                storageKeys: []
            };
            var storageSlots = item[1];
            for(var slot = 0; slot < storageSlots.length; slot++){
                var storageSlot = storageSlots[slot];
                JSONItem.storageKeys.push('0x' + (0, $7Z98w.setLengthLeft)(storageSlot, 32).toString('hex'));
            }
            accessListJSON.push(JSONItem);
        }
        return accessListJSON;
    };
    AccessLists.getDataFeeEIP2930 = function(accessList, common) {
        var accessListStorageKeyCost = common.param('gasPrices', 'accessListStorageKeyCost');
        var accessListAddressCost = common.param('gasPrices', 'accessListAddressCost');
        var slots = 0;
        for(var index = 0; index < accessList.length; index++){
            var item = accessList[index];
            var storageSlots = item[1];
            slots += storageSlots.length;
        }
        var addresses = accessList.length;
        return addresses * accessListAddressCost + slots * accessListStorageKeyCost;
    };
    return AccessLists;
}();
module.exports.AccessLists = $f443c188c22c38c9$var$AccessLists;

});


parcelRegister("5sL9U", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $3fa4260b7c87706e$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7Z98w = parcelRequire("7Z98w");

var $1s2di = parcelRequire("1s2di");
var $3fa4260b7c87706e$var$TransactionFactory = /** @class */ function() {
    // It is not possible to instantiate a TransactionFactory object.
    function TransactionFactory() {}
    /**
     * Create a transaction from a `txData` object
     *
     * @param txData - The transaction data. The `type` field will determine which transaction type is returned (if undefined, creates a legacy transaction)
     * @param txOptions - Options to pass on to the constructor of the transaction
     */ TransactionFactory.fromTxData = function(txData, txOptions) {
        if (txOptions === void 0) txOptions = {};
        if (!('type' in txData) || txData.type === undefined) // Assume legacy transaction
        return $1s2di.Transaction.fromTxData(txData, txOptions);
        else {
            var txType = new $7Z98w.BN((0, $7Z98w.toBuffer)(txData.type)).toNumber();
            if (txType === 0) return $1s2di.Transaction.fromTxData(txData, txOptions);
            else if (txType === 1) return $1s2di.AccessListEIP2930Transaction.fromTxData(txData, txOptions);
            else if (txType === 2) return $1s2di.FeeMarketEIP1559Transaction.fromTxData(txData, txOptions);
            else throw new Error("Tx instantiation with type " + txType + " not supported");
        }
    };
    /**
     * This method tries to decode serialized data.
     *
     * @param data - The data Buffer
     * @param txOptions - The transaction options
     */ TransactionFactory.fromSerializedData = function(data, txOptions) {
        if (txOptions === void 0) txOptions = {};
        if (data[0] <= 0x7f) {
            // Determine the type.
            var EIP = void 0;
            switch(data[0]){
                case 1:
                    EIP = 2930;
                    break;
                case 2:
                    EIP = 1559;
                    break;
                default:
                    throw new Error("TypedTransaction with ID " + data[0] + " unknown");
            }
            if (EIP === 1559) return $1s2di.FeeMarketEIP1559Transaction.fromSerializedTx(data, txOptions);
            else // EIP === 2930
            return $1s2di.AccessListEIP2930Transaction.fromSerializedTx(data, txOptions);
        } else return $1s2di.Transaction.fromSerializedTx(data, txOptions);
    };
    /**
     * When decoding a BlockBody, in the transactions field, a field is either:
     * A Buffer (a TypedTransaction - encoded as TransactionType || rlp(TransactionPayload))
     * A Buffer[] (Legacy Transaction)
     * This method returns the right transaction.
     *
     * @param data - A Buffer or Buffer[]
     * @param txOptions - The transaction options
     */ TransactionFactory.fromBlockBodyData = function(data, txOptions) {
        if (txOptions === void 0) txOptions = {};
        if ($3fa4260b7c87706e$require$Buffer.isBuffer(data)) return this.fromSerializedData(data, txOptions);
        else if (Array.isArray(data)) // It is a legacy transaction
        return $1s2di.Transaction.fromValuesArray(data, txOptions);
        else throw new Error('Cannot decode transaction: unknown type input');
    };
    /**
     * This helper method allows one to retrieve the class which matches the transactionID
     * If transactionID is undefined, returns the legacy transaction class.
     * @deprecated - This method is deprecated and will be removed on the next major release
     * @param transactionID
     * @param _common - This option is not used
     */ TransactionFactory.getTransactionClass = function(transactionID, _common) {
        if (transactionID === void 0) transactionID = 0;
        var legacyTxn = transactionID == 0 || transactionID >= 0x80 && transactionID <= 0xff;
        if (legacyTxn) return $1s2di.Transaction;
        switch(transactionID){
            case 1:
                return $1s2di.AccessListEIP2930Transaction;
            case 2:
                return $1s2di.FeeMarketEIP1559Transaction;
            default:
                throw new Error("TypedTransaction with ID " + transactionID + " unknown");
        }
    };
    return TransactionFactory;
}();
module.exports.default = $3fa4260b7c87706e$var$TransactionFactory;

});

parcelRegister("gwlKN", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c070825c8118fccd$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $c070825c8118fccd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c070825c8118fccd$var$__assign = module.exports && module.exports.__assign || function() {
    $c070825c8118fccd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c070825c8118fccd$var$__assign.apply(this, arguments);
};
var $c070825c8118fccd$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7Z98w = parcelRequire("7Z98w");

var $kuLXK = parcelRequire("kuLXK");

var $joOVu = parcelRequire("joOVu");

var $kYdkU = parcelRequire("kYdkU");
var $c070825c8118fccd$var$TRANSACTION_TYPE = 2;
var $c070825c8118fccd$var$TRANSACTION_TYPE_BUFFER = $c070825c8118fccd$require$Buffer.from($c070825c8118fccd$var$TRANSACTION_TYPE.toString(16).padStart(2, '0'), 'hex');
/**
 * Typed transaction with a new gas fee market mechanism
 *
 * - TransactionType: 2
 * - EIP: [EIP-1559](https://eips.ethereum.org/EIPS/eip-1559)
 */ var $c070825c8118fccd$var$FeeMarketEIP1559Transaction = /** @class */ function(_super) {
    $c070825c8118fccd$var$__extends(FeeMarketEIP1559Transaction, _super);
    /**
     * This constructor takes the values, validates them, assigns them and freezes the object.
     *
     * It is not recommended to use this constructor directly. Instead use
     * the static factory methods to assist in creating a Transaction object from
     * varying data types.
     */ function FeeMarketEIP1559Transaction(txData, opts) {
        if (opts === void 0) opts = {};
        var _a, _b;
        var _this = _super.call(this, $c070825c8118fccd$var$__assign($c070825c8118fccd$var$__assign({}, txData), {
            type: $c070825c8118fccd$var$TRANSACTION_TYPE
        })) || this;
        /**
         * The default HF if the tx type is active on that HF
         * or the first greater HF where the tx is active.
         *
         * @hidden
         */ _this.DEFAULT_HARDFORK = 'london';
        var chainId = txData.chainId, accessList = txData.accessList, maxFeePerGas = txData.maxFeePerGas, maxPriorityFeePerGas = txData.maxPriorityFeePerGas;
        _this.common = _this._getCommon(opts.common, chainId);
        _this.chainId = _this.common.chainIdBN();
        if (!_this.common.isActivatedEIP(1559)) throw new Error('EIP-1559 not enabled on Common');
        _this.activeCapabilities = _this.activeCapabilities.concat([
            1559,
            2718,
            2930
        ]);
        // Populate the access list fields
        var accessListData = $kYdkU.AccessLists.getAccessListData(accessList !== null && accessList !== void 0 ? accessList : []);
        _this.accessList = accessListData.accessList;
        _this.AccessListJSON = accessListData.AccessListJSON;
        // Verify the access list format.
        $kYdkU.AccessLists.verifyAccessList(_this.accessList);
        _this.maxFeePerGas = new $7Z98w.BN((0, $7Z98w.toBuffer)(maxFeePerGas === '' ? '0x' : maxFeePerGas));
        _this.maxPriorityFeePerGas = new $7Z98w.BN((0, $7Z98w.toBuffer)(maxPriorityFeePerGas === '' ? '0x' : maxPriorityFeePerGas));
        _this._validateCannotExceedMaxInteger({
            maxFeePerGas: _this.maxFeePerGas,
            maxPriorityFeePerGas: _this.maxPriorityFeePerGas
        }, 256);
        if (_this.maxFeePerGas.lt(_this.maxPriorityFeePerGas)) {
            var msg = _this._errorMsg('maxFeePerGas cannot be less than maxPriorityFeePerGas (The total must be the larger of the two)');
            throw new Error(msg);
        }
        if (_this.v && !_this.v.eqn(0) && !_this.v.eqn(1)) {
            var msg = _this._errorMsg('The y-parity of the transaction should either be 0 or 1');
            throw new Error(msg);
        }
        if (_this.common.gteHardfork('homestead') && ((_a = _this.s) === null || _a === void 0 ? void 0 : _a.gt($joOVu.N_DIV_2))) {
            var msg = _this._errorMsg('Invalid Signature: s-values greater than secp256k1n/2 are considered invalid');
            throw new Error(msg);
        }
        var freeze = (_b = opts === null || opts === void 0 ? void 0 : opts.freeze) !== null && _b !== void 0 ? _b : true;
        if (freeze) Object.freeze(_this);
        return _this;
    }
    Object.defineProperty(FeeMarketEIP1559Transaction.prototype, "senderR", {
        /**
         * EIP-2930 alias for `r`
         *
         * @deprecated use `r` instead
         */ get: function() {
            return this.r;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeeMarketEIP1559Transaction.prototype, "senderS", {
        /**
         * EIP-2930 alias for `s`
         *
         * @deprecated use `s` instead
         */ get: function() {
            return this.s;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeeMarketEIP1559Transaction.prototype, "yParity", {
        /**
         * EIP-2930 alias for `v`
         *
         * @deprecated use `v` instead
         */ get: function() {
            return this.v;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Instantiate a transaction from a data dictionary.
     *
     * Format: { chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, v, r, s }
     *
     * Notes:
     * - `chainId` will be set automatically if not provided
     * - All parameters are optional and have some basic default values
     */ FeeMarketEIP1559Transaction.fromTxData = function(txData, opts) {
        if (opts === void 0) opts = {};
        return new FeeMarketEIP1559Transaction(txData, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     *
     * Format: `0x02 || rlp([chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS])`
     */ FeeMarketEIP1559Transaction.fromSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        if (!serialized.slice(0, 1).equals($c070825c8118fccd$var$TRANSACTION_TYPE_BUFFER)) throw new Error("Invalid serialized tx input: not an EIP-1559 transaction (wrong tx type, expected: " + $c070825c8118fccd$var$TRANSACTION_TYPE + ", received: " + serialized.slice(0, 1).toString('hex'));
        var values = $7Z98w.rlp.decode(serialized.slice(1));
        if (!Array.isArray(values)) throw new Error('Invalid serialized tx input: must be array');
        return FeeMarketEIP1559Transaction.fromValuesArray(values, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     * (alias of {@link FeeMarketEIP1559Transaction.fromSerializedTx})
     *
     * Note: This means that the Buffer should start with 0x01.
     *
     * @deprecated this constructor alias is deprecated and will be removed
     * in favor of the {@link FeeMarketEIP1559Transaction.fromSerializedTx} constructor
     */ FeeMarketEIP1559Transaction.fromRlpSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        return FeeMarketEIP1559Transaction.fromSerializedTx(serialized, opts);
    };
    /**
     * Create a transaction from a values array.
     *
     * Format: `[chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS]`
     */ FeeMarketEIP1559Transaction.fromValuesArray = function(values, opts) {
        if (opts === void 0) opts = {};
        if (values.length !== 9 && values.length !== 12) throw new Error('Invalid EIP-1559 transaction. Only expecting 9 values (for unsigned tx) or 12 values (for signed tx).');
        var _a = $c070825c8118fccd$var$__read(values, 12), chainId = _a[0], nonce = _a[1], maxPriorityFeePerGas = _a[2], maxFeePerGas = _a[3], gasLimit = _a[4], to = _a[5], value = _a[6], data = _a[7], accessList = _a[8], v = _a[9], r = _a[10], s = _a[11];
        return new FeeMarketEIP1559Transaction({
            chainId: new $7Z98w.BN(chainId),
            nonce: nonce,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            maxFeePerGas: maxFeePerGas,
            gasLimit: gasLimit,
            to: to,
            value: value,
            data: data,
            accessList: accessList !== null && accessList !== void 0 ? accessList : [],
            v: v !== undefined ? new $7Z98w.BN(v) : undefined,
            r: r,
            s: s
        }, opts);
    };
    /**
     * The amount of gas paid for the data in this tx
     */ FeeMarketEIP1559Transaction.prototype.getDataFee = function() {
        if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) return this.cache.dataFee.value;
        var cost = _super.prototype.getDataFee.call(this);
        cost.iaddn($kYdkU.AccessLists.getDataFeeEIP2930(this.accessList, this.common));
        if (Object.isFrozen(this)) this.cache.dataFee = {
            value: cost,
            hardfork: this.common.hardfork()
        };
        return cost;
    };
    /**
     * The up front amount that an account must have for this transaction to be valid
     * @param baseFee The base fee of the block (will be set to 0 if not provided)
     */ FeeMarketEIP1559Transaction.prototype.getUpfrontCost = function(baseFee) {
        if (baseFee === void 0) baseFee = new $7Z98w.BN(0);
        var inclusionFeePerGas = $7Z98w.BN.min(this.maxPriorityFeePerGas, this.maxFeePerGas.sub(baseFee));
        var gasPrice = inclusionFeePerGas.add(baseFee);
        return this.gasLimit.mul(gasPrice).add(this.value);
    };
    /**
     * Returns a Buffer Array of the raw Buffers of the EIP-1559 transaction, in order.
     *
     * Format: `[chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS]`
     *
     * Use {@link FeeMarketEIP1559Transaction.serialize} to add a transaction to a block
     * with {@link Block.fromValuesArray}.
     *
     * For an unsigned tx this method uses the empty Buffer values for the
     * signature parameters `v`, `r` and `s` for encoding. For an EIP-155 compliant
     * representation for external signing use {@link FeeMarketEIP1559Transaction.getMessageToSign}.
     */ FeeMarketEIP1559Transaction.prototype.raw = function() {
        return [
            (0, $7Z98w.bnToUnpaddedBuffer)(this.chainId),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.nonce),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.maxPriorityFeePerGas),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.maxFeePerGas),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.gasLimit),
            this.to !== undefined ? this.to.buf : $c070825c8118fccd$require$Buffer.from([]),
            (0, $7Z98w.bnToUnpaddedBuffer)(this.value),
            this.data,
            this.accessList,
            this.v !== undefined ? (0, $7Z98w.bnToUnpaddedBuffer)(this.v) : $c070825c8118fccd$require$Buffer.from([]),
            this.r !== undefined ? (0, $7Z98w.bnToUnpaddedBuffer)(this.r) : $c070825c8118fccd$require$Buffer.from([]),
            this.s !== undefined ? (0, $7Z98w.bnToUnpaddedBuffer)(this.s) : $c070825c8118fccd$require$Buffer.from([])
        ];
    };
    /**
     * Returns the serialized encoding of the EIP-1559 transaction.
     *
     * Format: `0x02 || rlp([chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS])`
     *
     * Note that in contrast to the legacy tx serialization format this is not
     * valid RLP any more due to the raw tx type preceding and concatenated to
     * the RLP encoding of the values.
     */ FeeMarketEIP1559Transaction.prototype.serialize = function() {
        var base = this.raw();
        return $c070825c8118fccd$require$Buffer.concat([
            $c070825c8118fccd$var$TRANSACTION_TYPE_BUFFER,
            $7Z98w.rlp.encode(base)
        ]);
    };
    /**
     * Returns the serialized unsigned tx (hashed or raw), which can be used
     * to sign the transaction (e.g. for sending to a hardware wallet).
     *
     * Note: in contrast to the legacy tx the raw message format is already
     * serialized and doesn't need to be RLP encoded any more.
     *
     * ```javascript
     * const serializedMessage = tx.getMessageToSign(false) // use this for the HW wallet input
     * ```
     *
     * @param hashMessage - Return hashed message if set to true (default: true)
     */ FeeMarketEIP1559Transaction.prototype.getMessageToSign = function(hashMessage) {
        if (hashMessage === void 0) hashMessage = true;
        var base = this.raw().slice(0, 9);
        var message = $c070825c8118fccd$require$Buffer.concat([
            $c070825c8118fccd$var$TRANSACTION_TYPE_BUFFER,
            $7Z98w.rlp.encode(base)
        ]);
        if (hashMessage) return (0, $7Z98w.keccak256)(message);
        else return message;
    };
    /**
     * Computes a sha3-256 hash of the serialized tx.
     *
     * This method can only be used for signed txs (it throws otherwise).
     * Use {@link FeeMarketEIP1559Transaction.getMessageToSign} to get a tx hash for the purpose of signing.
     */ FeeMarketEIP1559Transaction.prototype.hash = function() {
        if (!this.isSigned()) {
            var msg = this._errorMsg('Cannot call hash method if transaction is not signed');
            throw new Error(msg);
        }
        if (Object.isFrozen(this)) {
            if (!this.cache.hash) this.cache.hash = (0, $7Z98w.keccak256)(this.serialize());
            return this.cache.hash;
        }
        return (0, $7Z98w.keccak256)(this.serialize());
    };
    /**
     * Computes a sha3-256 hash which can be used to verify the signature
     */ FeeMarketEIP1559Transaction.prototype.getMessageToVerifySignature = function() {
        return this.getMessageToSign();
    };
    /**
     * Returns the public key of the sender
     */ FeeMarketEIP1559Transaction.prototype.getSenderPublicKey = function() {
        var _a;
        if (!this.isSigned()) {
            var msg = this._errorMsg('Cannot call this method if transaction is not signed');
            throw new Error(msg);
        }
        var msgHash = this.getMessageToVerifySignature();
        // EIP-2: All transaction signatures whose s-value is greater than secp256k1n/2 are considered invalid.
        // Reasoning: https://ethereum.stackexchange.com/a/55728
        if (this.common.gteHardfork('homestead') && ((_a = this.s) === null || _a === void 0 ? void 0 : _a.gt($joOVu.N_DIV_2))) {
            var msg = this._errorMsg('Invalid Signature: s-values greater than secp256k1n/2 are considered invalid');
            throw new Error(msg);
        }
        var _b = this, v = _b.v, r = _b.r, s = _b.s;
        try {
            return (0, $7Z98w.ecrecover)(msgHash, v.addn(27), (0, $7Z98w.bnToUnpaddedBuffer)(r), (0, $7Z98w.bnToUnpaddedBuffer)(s));
        } catch (e) {
            var msg = this._errorMsg('Invalid Signature');
            throw new Error(msg);
        }
    };
    FeeMarketEIP1559Transaction.prototype._processSignature = function(v, r, s) {
        var opts = {
            common: this.common
        };
        return FeeMarketEIP1559Transaction.fromTxData({
            chainId: this.chainId,
            nonce: this.nonce,
            maxPriorityFeePerGas: this.maxPriorityFeePerGas,
            maxFeePerGas: this.maxFeePerGas,
            gasLimit: this.gasLimit,
            to: this.to,
            value: this.value,
            data: this.data,
            accessList: this.accessList,
            v: new $7Z98w.BN(v - 27),
            r: new $7Z98w.BN(r),
            s: new $7Z98w.BN(s)
        }, opts);
    };
    /**
     * Returns an object with the JSON representation of the transaction
     */ FeeMarketEIP1559Transaction.prototype.toJSON = function() {
        var accessListJSON = $kYdkU.AccessLists.getAccessListJSON(this.accessList);
        return {
            chainId: (0, $7Z98w.bnToHex)(this.chainId),
            nonce: (0, $7Z98w.bnToHex)(this.nonce),
            maxPriorityFeePerGas: (0, $7Z98w.bnToHex)(this.maxPriorityFeePerGas),
            maxFeePerGas: (0, $7Z98w.bnToHex)(this.maxFeePerGas),
            gasLimit: (0, $7Z98w.bnToHex)(this.gasLimit),
            to: this.to !== undefined ? this.to.toString() : undefined,
            value: (0, $7Z98w.bnToHex)(this.value),
            data: '0x' + this.data.toString('hex'),
            accessList: accessListJSON,
            v: this.v !== undefined ? (0, $7Z98w.bnToHex)(this.v) : undefined,
            r: this.r !== undefined ? (0, $7Z98w.bnToHex)(this.r) : undefined,
            s: this.s !== undefined ? (0, $7Z98w.bnToHex)(this.s) : undefined
        };
    };
    /**
     * Return a compact error string representation of the object
     */ FeeMarketEIP1559Transaction.prototype.errorStr = function() {
        var errorStr = this._getSharedErrorPostfix();
        errorStr += " maxFeePerGas=" + this.maxFeePerGas + " maxPriorityFeePerGas=" + this.maxPriorityFeePerGas;
        return errorStr;
    };
    /**
     * Internal helper function to create an annotated error message
     *
     * @param msg Base error message
     * @hidden
     */ FeeMarketEIP1559Transaction.prototype._errorMsg = function(msg) {
        return msg + " (" + this.errorStr() + ")";
    };
    return FeeMarketEIP1559Transaction;
}($kuLXK.BaseTransaction);
module.exports.default = $c070825c8118fccd$var$FeeMarketEIP1559Transaction;

});



parcelRegister("9d2Gm", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file getNetworkType.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";
var $6b47689c375f66a1$var$getNetworkType = function(callback) {
    var _this = this, id;
    return this.net.getId().then(function(givenId) {
        id = givenId;
        return _this.getBlock(0);
    }).then(function(genesis) {
        var returnValue = 'private';
        if (genesis.hash === '0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3' && id === 1) returnValue = 'main';
        if (genesis.hash === '0cd786a2425d16f152c658316c423e6ce1181e15c3295826d7c9904cba9ce303' && id === 2) returnValue = 'morden';
        if (genesis.hash === '0x41941023680923e0fe4d74a34bdac8141f2540e3ae90623718e47d66d1ca4a2d' && id === 3) returnValue = 'ropsten';
        if (genesis.hash === '0x6341fd3daf94b748c72ced5a5b26028f2474f5f00d824504e4fa37a75767e177' && id === 4) returnValue = 'rinkeby';
        if (genesis.hash === '0xbf7e331f7f7c1dd2e05159666b3bf8bc7a8a3a9eb1d518969eab529dd9b88c1a' && id === 5) returnValue = 'goerli';
        if (genesis.hash === '0xa3c565fc15c7478862d50ccd6561e3c06b24cc509bf388941c25ea985ce32cb9' && id === 42) returnValue = 'kovan';
        if (typeof callback === 'function') callback(null, returnValue);
        return returnValue;
    }).catch(function(err) {
        if (typeof callback === 'function') callback(err);
        else throw err;
    });
};
module.exports = $6b47689c375f66a1$var$getNetworkType;

});


parcelRegister("l2qhz", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $gNDGO = parcelRequire("gNDGO");

var $hhXfq = parcelRequire("hhXfq");
var $f50e2c06675b5ea7$require$Subscriptions = $hhXfq.subscriptions;

var $lIu4V = parcelRequire("lIu4V");

var $jo8Dp = parcelRequire("jo8Dp");
var $f50e2c06675b5ea7$var$Shh = function Shh() {
    var _this = this;
    // sets _requestmanager
    $gNDGO.packageInit(this, arguments);
    // overwrite package setRequestManager
    var setRequestManager = this.setRequestManager;
    this.setRequestManager = function(manager) {
        setRequestManager(manager);
        _this.net.setRequestManager(manager);
        return true;
    };
    // overwrite setProvider
    var setProvider = this.setProvider;
    this.setProvider = function() {
        setProvider.apply(_this, arguments);
        _this.setRequestManager(_this._requestManager);
    };
    this.net = new $jo8Dp(this);
    [
        new $f50e2c06675b5ea7$require$Subscriptions({
            name: 'subscribe',
            type: 'shh',
            subscriptions: {
                'messages': {
                    params: 1
                }
            }
        }),
        new $lIu4V({
            name: 'getVersion',
            call: 'shh_version',
            params: 0
        }),
        new $lIu4V({
            name: 'getInfo',
            call: 'shh_info',
            params: 0
        }),
        new $lIu4V({
            name: 'setMaxMessageSize',
            call: 'shh_setMaxMessageSize',
            params: 1
        }),
        new $lIu4V({
            name: 'setMinPoW',
            call: 'shh_setMinPoW',
            params: 1
        }),
        new $lIu4V({
            name: 'markTrustedPeer',
            call: 'shh_markTrustedPeer',
            params: 1
        }),
        new $lIu4V({
            name: 'newKeyPair',
            call: 'shh_newKeyPair',
            params: 0
        }),
        new $lIu4V({
            name: 'addPrivateKey',
            call: 'shh_addPrivateKey',
            params: 1
        }),
        new $lIu4V({
            name: 'deleteKeyPair',
            call: 'shh_deleteKeyPair',
            params: 1
        }),
        new $lIu4V({
            name: 'hasKeyPair',
            call: 'shh_hasKeyPair',
            params: 1
        }),
        new $lIu4V({
            name: 'getPublicKey',
            call: 'shh_getPublicKey',
            params: 1
        }),
        new $lIu4V({
            name: 'getPrivateKey',
            call: 'shh_getPrivateKey',
            params: 1
        }),
        new $lIu4V({
            name: 'newSymKey',
            call: 'shh_newSymKey',
            params: 0
        }),
        new $lIu4V({
            name: 'addSymKey',
            call: 'shh_addSymKey',
            params: 1
        }),
        new $lIu4V({
            name: 'generateSymKeyFromPassword',
            call: 'shh_generateSymKeyFromPassword',
            params: 1
        }),
        new $lIu4V({
            name: 'hasSymKey',
            call: 'shh_hasSymKey',
            params: 1
        }),
        new $lIu4V({
            name: 'getSymKey',
            call: 'shh_getSymKey',
            params: 1
        }),
        new $lIu4V({
            name: 'deleteSymKey',
            call: 'shh_deleteSymKey',
            params: 1
        }),
        new $lIu4V({
            name: 'newMessageFilter',
            call: 'shh_newMessageFilter',
            params: 1
        }),
        new $lIu4V({
            name: 'getFilterMessages',
            call: 'shh_getFilterMessages',
            params: 1
        }),
        new $lIu4V({
            name: 'deleteMessageFilter',
            call: 'shh_deleteMessageFilter',
            params: 1
        }),
        new $lIu4V({
            name: 'post',
            call: 'shh_post',
            params: 1,
            inputFormatter: [
                null
            ]
        }),
        new $lIu4V({
            name: 'unsubscribe',
            call: 'shh_unsubscribe',
            params: 1
        })
    ].forEach(function(method) {
        method.attachToObject(_this);
        method.setRequestManager(_this._requestManager);
    });
};
$f50e2c06675b5ea7$var$Shh.prototype.clearSubscriptions = function() {
    this._requestManager.clearSubscriptions();
};
$gNDGO.addProviders($f50e2c06675b5ea7$var$Shh);
module.exports = $f50e2c06675b5ea7$var$Shh;

});

parcelRegister("kCpMQ", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $2SA1u = parcelRequire("2SA1u");
var $f02b5bff793277d0$var$Bzz = function Bzz(provider) {
    this.givenProvider = Bzz.givenProvider;
    if (provider && provider._requestManager) provider = provider.currentProvider;
    // only allow file picker when in browser
    if (typeof document !== 'undefined') this.pick = $2SA1u.pick;
    this.setProvider(provider);
};
// set default ethereum provider
/* jshint ignore:start */ $f02b5bff793277d0$var$Bzz.givenProvider = null;
if (typeof ethereum !== 'undefined' && ethereum.bzz) $f02b5bff793277d0$var$Bzz.givenProvider = ethereum.bzz;
/* jshint ignore:end */ $f02b5bff793277d0$var$Bzz.prototype.setProvider = function(provider) {
    // is ethereum provider
    if (!!provider && typeof provider === 'object' && typeof provider.bzz === 'string') provider = provider.bzz;
    // else if(!_.isString(provider)) {
    //      provider = 'http://swarm-gateways.net'; // default to gateway
    // }
    if (typeof provider === 'string') this.currentProvider = provider;
    else {
        this.currentProvider = null;
        var noProviderError = new Error('No provider set, please set one using bzz.setProvider().');
        this.download = this.upload = this.isAvailable = function() {
            throw noProviderError;
        };
        return false;
    }
    // add functions
    this.download = $2SA1u.at(provider).download;
    this.upload = $2SA1u.at(provider).upload;
    this.isAvailable = $2SA1u.at(provider).isAvailable;
    return true;
};
module.exports = $f02b5bff793277d0$var$Bzz;

});
parcelRegister("2SA1u", function(module, exports) {
var $218c9156baa1bbed$var$unavailable = function unavailable() {
    throw "This swarm.js function isn't available on the browser.";
};
var $218c9156baa1bbed$var$fs = {
    readFile: $218c9156baa1bbed$var$unavailable
};
var $218c9156baa1bbed$var$files = {
    download: $218c9156baa1bbed$var$unavailable,
    safeDownloadArchived: $218c9156baa1bbed$var$unavailable,
    directoryTree: $218c9156baa1bbed$var$unavailable
};
var $218c9156baa1bbed$var$os = {
    platform: $218c9156baa1bbed$var$unavailable,
    arch: $218c9156baa1bbed$var$unavailable
};
var $218c9156baa1bbed$var$path = {
    join: $218c9156baa1bbed$var$unavailable,
    slice: $218c9156baa1bbed$var$unavailable
};
var $218c9156baa1bbed$var$child_process = {
    spawn: $218c9156baa1bbed$var$unavailable
};
var $218c9156baa1bbed$var$mimetype = {
    lookup: $218c9156baa1bbed$var$unavailable
};
var $218c9156baa1bbed$var$defaultArchives = {};
var $218c9156baa1bbed$var$downloadUrl = null;

var $6ZUgU = parcelRequire("6ZUgU");

var $dAKYh = parcelRequire("dAKYh");

var $aD79B = parcelRequire("aD79B");

var $3WgN1 = parcelRequire("3WgN1");

var $iG7Ro = parcelRequire("iG7Ro");
module.exports = $iG7Ro({
    fs: $218c9156baa1bbed$var$fs,
    files: $218c9156baa1bbed$var$files,
    os: $218c9156baa1bbed$var$os,
    path: $218c9156baa1bbed$var$path,
    child_process: $218c9156baa1bbed$var$child_process,
    defaultArchives: $218c9156baa1bbed$var$defaultArchives,
    mimetype: $218c9156baa1bbed$var$mimetype,
    request: $6ZUgU,
    downloadUrl: $218c9156baa1bbed$var$downloadUrl,
    bytes: $dAKYh,
    hash: $aD79B,
    pick: $3WgN1
});

});
parcelRegister("6ZUgU", function(module, exports) {

var $iRfLm = parcelRequire("iRfLm");

var $fePBl = parcelRequire("fePBl");

var $8coUR = parcelRequire("8coUR");

var $e5iKC = parcelRequire("e5iKC");

var $3louP = parcelRequire("3louP");
var $518416f74d722b37$var$mimeTypeJson = 'application/json';
var $518416f74d722b37$var$noop = function() {};
module.exports = $518416f74d722b37$var$xhrRequest;
function $518416f74d722b37$var$xhrRequest(url, opt, cb) {
    if (!url || typeof url !== 'string') throw new TypeError('must specify a URL');
    if (typeof opt === 'function') {
        cb = opt;
        opt = {};
    }
    if (cb && typeof cb !== 'function') throw new TypeError('expected cb to be undefined or a function');
    cb = cb || $518416f74d722b37$var$noop;
    opt = opt || {};
    var defaultResponse = opt.json ? 'json' : 'text';
    opt = $8coUR({
        responseType: defaultResponse
    }, opt);
    var headers = opt.headers || {};
    var method = (opt.method || 'GET').toUpperCase();
    var query = opt.query;
    if (query) {
        if (typeof query !== 'string') query = $iRfLm.stringify(query);
        url = $fePBl(url, query);
    }
    // allow json response
    if (opt.responseType === 'json') $e5iKC(headers, 'Accept', $518416f74d722b37$var$mimeTypeJson);
    // if body content is json
    if (opt.json && method !== 'GET' && method !== 'HEAD') {
        $e5iKC(headers, 'Content-Type', $518416f74d722b37$var$mimeTypeJson);
        opt.body = JSON.stringify(opt.body);
    }
    opt.method = method;
    opt.url = url;
    opt.headers = headers;
    delete opt.query;
    delete opt.json;
    return $3louP(opt, cb);
}

});
parcelRegister("iRfLm", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $dba967695d032634$export$fac44ee5b035f737, (v) => $dba967695d032634$export$fac44ee5b035f737 = v);
var $dba967695d032634$export$f9380c9a627682d3;
var $dba967695d032634$export$98e6a39c04603d36;
var $dba967695d032634$export$fac44ee5b035f737;
var $dba967695d032634$export$7a5253c0f62e0150;
'use strict';

var $2O8iZ = parcelRequire("2O8iZ");

var $8coUR = parcelRequire("8coUR");

var $5yzCy = parcelRequire("5yzCy");
function $dba967695d032634$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $dba967695d032634$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $dba967695d032634$var$encode(key, opts),
                    '[',
                    $dba967695d032634$var$encode(index, opts),
                    ']=',
                    $dba967695d032634$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $dba967695d032634$var$encode(key, opts) : [
                    $dba967695d032634$var$encode(key, opts),
                    '[]=',
                    $dba967695d032634$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $dba967695d032634$var$encode(key, opts) : [
                    $dba967695d032634$var$encode(key, opts),
                    '=',
                    $dba967695d032634$var$encode(value, opts)
                ].join('');
            };
    }
}
function $dba967695d032634$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $dba967695d032634$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $2O8iZ(value) : encodeURIComponent(value);
    return value;
}
function $dba967695d032634$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $dba967695d032634$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $dba967695d032634$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $dba967695d032634$var$parse(str, opts) {
    opts = $8coUR({
        arrayFormat: 'none'
    }, opts);
    var formatter = $dba967695d032634$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $5yzCy(val);
        formatter($5yzCy(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $dba967695d032634$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$dba967695d032634$export$f9380c9a627682d3 = $dba967695d032634$var$extract;
$dba967695d032634$export$98e6a39c04603d36 = $dba967695d032634$var$parse;
$dba967695d032634$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $8coUR(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $dba967695d032634$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $dba967695d032634$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $dba967695d032634$var$encode(key, opts) + '=' + $dba967695d032634$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$dba967695d032634$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $dba967695d032634$var$parse($dba967695d032634$var$extract(str), opts)
    };
};

});
parcelRegister("2O8iZ", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("5yzCy", function(module, exports) {
'use strict';
var $40bbc24beab9f9b8$var$token = '%[a-f0-9]{2}';
var $40bbc24beab9f9b8$var$singleMatcher = new RegExp($40bbc24beab9f9b8$var$token, 'gi');
var $40bbc24beab9f9b8$var$multiMatcher = new RegExp('(' + $40bbc24beab9f9b8$var$token + ')+', 'gi');
function $40bbc24beab9f9b8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return decodeURIComponent(components.join(''));
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $40bbc24beab9f9b8$var$decodeComponents(left), $40bbc24beab9f9b8$var$decodeComponents(right));
}
function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($40bbc24beab9f9b8$var$singleMatcher);
        for(var i = 1; i < tokens.length; i++){
            input = $40bbc24beab9f9b8$var$decodeComponents(tokens, i).join('');
            tokens = input.match($40bbc24beab9f9b8$var$singleMatcher);
        }
        return input;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
};

});


parcelRegister("fePBl", function(module, exports) {
module.exports = $b18030c409bb601c$var$urlSetQuery;
function $b18030c409bb601c$var$urlSetQuery(url, query) {
    if (query) {
        // remove optional leading symbols
        query = query.trim().replace(/^(\?|#|&)/, '');
        // don't append empty query
        query = query ? '?' + query : query;
        var parts = url.split(/[\?\#]/);
        var start = parts[0];
        if (query && /\:\/\/[^\/]*$/.test(start)) // e.g. http://foo.com -> http://foo.com/
        start = start + '/';
        var match = url.match(/(\#.*)$/);
        url = start + query;
        if (match) url = url + match[0];
    }
    return url;
}

});

parcelRegister("e5iKC", function(module, exports) {
module.exports = $a41013dd76f88e8f$var$ensureHeader;
function $a41013dd76f88e8f$var$ensureHeader(headers, key, value) {
    var lower = key.toLowerCase();
    if (!headers[key] && !headers[lower]) headers[key] = value;
}

});

parcelRegister("3louP", function(module, exports) {

var $bMGeU = parcelRequire("bMGeU");

var $cyL4Z = parcelRequire("cyL4Z");
var $26f655b8f214f087$var$noop = function() {};
module.exports = $26f655b8f214f087$var$xhrRequest;
function $26f655b8f214f087$var$xhrRequest(opt, cb) {
    delete opt.uri;
    // for better JSON.parse error handling than xhr module
    var useJson = false;
    if (opt.responseType === 'json') {
        opt.responseType = 'text';
        useJson = true;
    }
    var req = $bMGeU(opt, function xhrRequestResult(err, resp, body) {
        if (useJson && !err) try {
            var text = resp.rawRequest.responseText;
            body = JSON.parse(text);
        } catch (e) {
            err = e;
        }
        resp = $cyL4Z(opt, resp);
        if (err) cb(err, null, resp);
        else cb(err, body, resp);
        cb = $26f655b8f214f087$var$noop;
    });
    // Patch abort() so that it also calls the callback, but with an error
    var onabort = req.onabort;
    req.onabort = function() {
        var ret = onabort.apply(req, Array.prototype.slice.call(arguments));
        cb(new Error('XHR Aborted'));
        cb = $26f655b8f214f087$var$noop;
        return ret;
    };
    return req;
}

});
parcelRegister("bMGeU", function(module, exports) {
"use strict";

var $eDick = parcelRequire("eDick");

var $3KI1D = parcelRequire("3KI1D");

var $cDhPG = parcelRequire("cDhPG");

var $h0kNM = parcelRequire("h0kNM");
module.exports = $8944f148d4ecec20$var$createXHR;
// Allow use of default import syntax in TypeScript
module.exports.default = $8944f148d4ecec20$var$createXHR;
$8944f148d4ecec20$var$createXHR.XMLHttpRequest = $eDick.XMLHttpRequest || $8944f148d4ecec20$var$noop;
$8944f148d4ecec20$var$createXHR.XDomainRequest = "withCredentials" in new $8944f148d4ecec20$var$createXHR.XMLHttpRequest() ? $8944f148d4ecec20$var$createXHR.XMLHttpRequest : $eDick.XDomainRequest;
$8944f148d4ecec20$var$forEachArray([
    "get",
    "put",
    "post",
    "patch",
    "head",
    "delete"
], function(method) {
    $8944f148d4ecec20$var$createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
        options = $8944f148d4ecec20$var$initParams(uri, options, callback);
        options.method = method.toUpperCase();
        return $8944f148d4ecec20$var$_createXHR(options);
    };
});
function $8944f148d4ecec20$var$forEachArray(array, iterator) {
    for(var i = 0; i < array.length; i++)iterator(array[i]);
}
function $8944f148d4ecec20$var$isEmpty(obj) {
    for(var i in obj){
        if (obj.hasOwnProperty(i)) return false;
    }
    return true;
}
function $8944f148d4ecec20$var$initParams(uri, options, callback) {
    var params = uri;
    if ($3KI1D(options)) {
        callback = options;
        if (typeof uri === "string") params = {
            uri: uri
        };
    } else params = $h0kNM(options, {
        uri: uri
    });
    params.callback = callback;
    return params;
}
function $8944f148d4ecec20$var$createXHR(uri, options, callback) {
    options = $8944f148d4ecec20$var$initParams(uri, options, callback);
    return $8944f148d4ecec20$var$_createXHR(options);
}
function $8944f148d4ecec20$var$_createXHR(options) {
    if (typeof options.callback === "undefined") throw new Error("callback argument missing");
    var called = false;
    var callback = function cbOnce(err, response, body) {
        if (!called) {
            called = true;
            options.callback(err, response, body);
        }
    };
    function readystatechange() {
        if (xhr.readyState === 4) setTimeout(loadFunc, 0);
    }
    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined;
        if (xhr.response) body = xhr.response;
        else body = xhr.responseText || $8944f148d4ecec20$var$getXml(xhr);
        if (isJson) try {
            body = JSON.parse(body);
        } catch (e) {}
        return body;
    }
    function errorFunc(evt) {
        clearTimeout(timeoutTimer);
        if (!(evt instanceof Error)) evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
        evt.statusCode = 0;
        return callback(evt, failureResponse);
    }
    // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return;
        var status;
        clearTimeout(timeoutTimer);
        if (options.useXDR && xhr.status === undefined) //IE8 CORS GET successful response doesn't have a status field, but body is fine
        status = 200;
        else status = xhr.status === 1223 ? 204 : xhr.status;
        var response = failureResponse;
        var err = null;
        if (status !== 0) {
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            };
            if (xhr.getAllResponseHeaders) response.headers = $cDhPG(xhr.getAllResponseHeaders());
        } else err = new Error("Internal XMLHttpRequest Error");
        return callback(err, response, response.body);
    }
    var xhr = options.xhr || null;
    if (!xhr) {
        if (options.cors || options.useXDR) xhr = new $8944f148d4ecec20$var$createXHR.XDomainRequest();
        else xhr = new $8944f148d4ecec20$var$createXHR.XMLHttpRequest();
    }
    var key;
    var aborted;
    var uri = xhr.url = options.uri || options.url;
    var method = xhr.method = options.method || "GET";
    var body = options.body || options.data;
    var headers = xhr.headers = options.headers || {};
    var sync = !!options.sync;
    var isJson = false;
    var timeoutTimer;
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    };
    if ("json" in options && options.json !== false) {
        isJson = true;
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json" //Don't override existing accept header declared by user
        );
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json" //Don't override existing accept header declared by user
            );
            body = JSON.stringify(options.json === true ? body : options.json);
        }
    }
    xhr.onreadystatechange = readystatechange;
    xhr.onload = loadFunc;
    xhr.onerror = errorFunc;
    // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function() {
    // IE must die
    };
    xhr.onabort = function() {
        aborted = true;
    };
    xhr.ontimeout = errorFunc;
    xhr.open(method, uri, !sync, options.username, options.password);
    //has to be after open
    if (!sync) xhr.withCredentials = !!options.withCredentials;
    // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0) timeoutTimer = setTimeout(function() {
        if (aborted) return;
        aborted = true //IE9 may still call readystatechange
        ;
        xhr.abort("timeout");
        var e = new Error("XMLHttpRequest timeout");
        e.code = "ETIMEDOUT";
        errorFunc(e);
    }, options.timeout);
    if (xhr.setRequestHeader) {
        for(key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    } else if (options.headers && !$8944f148d4ecec20$var$isEmpty(options.headers)) throw new Error("Headers cannot be set on an XDomainRequest object");
    if ("responseType" in options) xhr.responseType = options.responseType;
    if ("beforeSend" in options && typeof options.beforeSend === "function") options.beforeSend(xhr);
    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null);
    return xhr;
}
function $8944f148d4ecec20$var$getXml(xhr) {
    // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
    // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
    try {
        if (xhr.responseType === "document") return xhr.responseXML;
        var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
        if (xhr.responseType === "" && !firefoxBugTakenEffect) return xhr.responseXML;
    } catch (e) {}
    return null;
}
function $8944f148d4ecec20$var$noop() {}

});
parcelRegister("eDick", function(module, exports) {
var $aa72d2e69fd2fe14$var$win;
if (typeof window !== "undefined") $aa72d2e69fd2fe14$var$win = window;
else if (typeof $parcel$global !== "undefined") $aa72d2e69fd2fe14$var$win = $parcel$global;
else if (typeof self !== "undefined") $aa72d2e69fd2fe14$var$win = self;
else $aa72d2e69fd2fe14$var$win = {};
module.exports = $aa72d2e69fd2fe14$var$win;

});

parcelRegister("3KI1D", function(module, exports) {
module.exports = $2bb7d1829c4e2ce1$var$isFunction;
var $2bb7d1829c4e2ce1$var$toString = Object.prototype.toString;
function $2bb7d1829c4e2ce1$var$isFunction(fn) {
    if (!fn) return false;
    var string = $2bb7d1829c4e2ce1$var$toString.call(fn);
    return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && // IE8 and below
    (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
}

});

parcelRegister("cDhPG", function(module, exports) {
var $9326f5ba7aa6e939$var$trim = function(string) {
    return string.replace(/^\s+|\s+$/g, '');
}, $9326f5ba7aa6e939$var$isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};
module.exports = function(headers) {
    if (!headers) return {};
    var result = {};
    var headersArr = $9326f5ba7aa6e939$var$trim(headers).split('\n');
    for(var i = 0; i < headersArr.length; i++){
        var row = headersArr[i];
        var index = row.indexOf(':'), key = $9326f5ba7aa6e939$var$trim(row.slice(0, index)).toLowerCase(), value = $9326f5ba7aa6e939$var$trim(row.slice(index + 1));
        if (typeof result[key] === 'undefined') result[key] = value;
        else if ($9326f5ba7aa6e939$var$isArray(result[key])) result[key].push(value);
        else result[key] = [
            result[key],
            value
        ];
    }
    return result;
};

});


parcelRegister("cyL4Z", function(module, exports) {
module.exports = $924d2e024126d379$var$getResponse;
function $924d2e024126d379$var$getResponse(opt, resp) {
    if (!resp) return null;
    return {
        statusCode: resp.statusCode,
        headers: resp.headers,
        method: opt.method,
        url: opt.url,
        // the XHR object in browser, http response in Node
        rawRequest: resp.rawRequest ? resp.rawRequest : resp
    };
}

});



parcelRegister("dAKYh", function(module, exports) {
parcelRequire("5T1Ud");
var $9e5312af42b71ee4$var$at = function at(bytes, index) {
    return parseInt(bytes.slice(index * 2 + 2, index * 2 + 4), 16);
};

var $9e5312af42b71ee4$var$random = function random(bytes) {
    var rnd = void 0;
    if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) rnd = window.crypto.getRandomValues(new Uint8Array(bytes));
    else rnd = (parcelRequire("5UUfm")).randomBytes(bytes);
    var hex = "0x";
    for(var i = 0; i < bytes; ++i)hex += ("00" + rnd[i].toString(16)).slice(-2);
    return hex;
};
var $9e5312af42b71ee4$var$length = function length(a) {
    return (a.length - 2) / 2;
};
var $9e5312af42b71ee4$var$flatten = function flatten(a) {
    return "0x" + a.reduce(function(r, s) {
        return r + s.slice(2);
    }, "");
};
var $9e5312af42b71ee4$var$slice = function slice(i, j, bs) {
    return "0x" + bs.slice(i * 2 + 2, j * 2 + 2);
};
var $9e5312af42b71ee4$var$reverse = function reverse(hex) {
    var rev = "0x";
    for(var i = 0, l = $9e5312af42b71ee4$var$length(hex); i < l; ++i)rev += hex.slice((l - i) * 2, (l - i + 1) * 2);
    return rev;
};
var $9e5312af42b71ee4$var$pad = function pad(l, hex) {
    return hex.length === l * 2 + 2 ? hex : pad(l, "0x0" + hex.slice(2));
};
var $9e5312af42b71ee4$var$padRight = function padRight(l, hex) {
    return hex.length === l * 2 + 2 ? hex : padRight(l, hex + "0");
};
var $9e5312af42b71ee4$var$toArray = function toArray(hex) {
    var arr = [];
    for(var i = 2, l = hex.length; i < l; i += 2)arr.push(parseInt(hex.slice(i, i + 2), 16));
    return arr;
};
var $9e5312af42b71ee4$var$fromArray = function fromArray(arr) {
    var hex = "0x";
    for(var i = 0, l = arr.length; i < l; ++i){
        var b = arr[i];
        hex += (b < 16 ? "0" : "") + b.toString(16);
    }
    return hex;
};
var $9e5312af42b71ee4$var$toUint8Array = function toUint8Array(hex) {
    return new Uint8Array($9e5312af42b71ee4$var$toArray(hex));
};
var $9e5312af42b71ee4$var$fromUint8Array = function fromUint8Array(arr) {
    return $9e5312af42b71ee4$var$fromArray([].slice.call(arr, 0));
};
var $9e5312af42b71ee4$var$fromNumber = function fromNumber(num) {
    var hex = num.toString(16);
    return hex.length % 2 === 0 ? "0x" + hex : "0x0" + hex;
};
var $9e5312af42b71ee4$var$toNumber = function toNumber(hex) {
    return parseInt(hex.slice(2), 16);
};
var $9e5312af42b71ee4$var$concat = function concat(a, b) {
    return a.concat(b.slice(2));
};
var $9e5312af42b71ee4$var$fromNat = function fromNat(bn) {
    return bn === "0x0" ? "0x" : bn.length % 2 === 0 ? bn : "0x0" + bn.slice(2);
};
var $9e5312af42b71ee4$var$toNat = function toNat(bn) {
    return bn[2] === "0" ? "0x" + bn.slice(3) : bn;
};
var $9e5312af42b71ee4$var$fromAscii = function fromAscii(ascii) {
    var hex = "0x";
    for(var i = 0; i < ascii.length; ++i)hex += ("00" + ascii.charCodeAt(i).toString(16)).slice(-2);
    return hex;
};
var $9e5312af42b71ee4$var$toAscii = function toAscii(hex) {
    var ascii = "";
    for(var i = 2; i < hex.length; i += 2)ascii += String.fromCharCode(parseInt(hex.slice(i, i + 2), 16));
    return ascii;
};
// From https://gist.github.com/pascaldekloe/62546103a1576803dade9269ccf76330
var $9e5312af42b71ee4$var$fromString = function fromString(s) {
    var makeByte = function makeByte(uint8) {
        var b = uint8.toString(16);
        return b.length < 2 ? "0" + b : b;
    };
    var bytes = "0x";
    for(var ci = 0; ci != s.length; ci++){
        var c = s.charCodeAt(ci);
        if (c < 128) {
            bytes += makeByte(c);
            continue;
        }
        if (c < 2048) bytes += makeByte(c >> 6 | 192);
        else {
            if (c > 0xd7ff && c < 0xdc00) {
                if (++ci == s.length) return null;
                var c2 = s.charCodeAt(ci);
                if (c2 < 0xdc00 || c2 > 0xdfff) return null;
                c = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
                bytes += makeByte(c >> 18 | 240);
                bytes += makeByte(c >> 12 & 63 | 128);
            } else // c <= 0xffff
            bytes += makeByte(c >> 12 | 224);
            bytes += makeByte(c >> 6 & 63 | 128);
        }
        bytes += makeByte(c & 63 | 128);
    }
    return bytes;
};
var $9e5312af42b71ee4$var$toString = function toString(bytes) {
    var s = '';
    var i = 0;
    var l = $9e5312af42b71ee4$var$length(bytes);
    while(i < l){
        var c = $9e5312af42b71ee4$var$at(bytes, i++);
        if (c > 127) {
            if (c > 191 && c < 224) {
                if (i >= l) return null;
                c = (c & 31) << 6 | $9e5312af42b71ee4$var$at(bytes, i) & 63;
            } else if (c > 223 && c < 240) {
                if (i + 1 >= l) return null;
                c = (c & 15) << 12 | ($9e5312af42b71ee4$var$at(bytes, i) & 63) << 6 | $9e5312af42b71ee4$var$at(bytes, ++i) & 63;
            } else if (c > 239 && c < 248) {
                if (i + 2 >= l) return null;
                c = (c & 7) << 18 | ($9e5312af42b71ee4$var$at(bytes, i) & 63) << 12 | ($9e5312af42b71ee4$var$at(bytes, ++i) & 63) << 6 | $9e5312af42b71ee4$var$at(bytes, ++i) & 63;
            } else return null;
            ++i;
        }
        if (c <= 0xffff) s += String.fromCharCode(c);
        else if (c <= 0x10ffff) {
            c -= 0x10000;
            s += String.fromCharCode(c >> 10 | 0xd800);
            s += String.fromCharCode(c & 0x3FF | 0xdc00);
        } else return null;
    }
    return s;
};
module.exports = {
    random: $9e5312af42b71ee4$var$random,
    length: $9e5312af42b71ee4$var$length,
    concat: $9e5312af42b71ee4$var$concat,
    flatten: $9e5312af42b71ee4$var$flatten,
    slice: $9e5312af42b71ee4$var$slice,
    reverse: $9e5312af42b71ee4$var$reverse,
    pad: $9e5312af42b71ee4$var$pad,
    padRight: $9e5312af42b71ee4$var$padRight,
    fromAscii: $9e5312af42b71ee4$var$fromAscii,
    toAscii: $9e5312af42b71ee4$var$toAscii,
    fromString: $9e5312af42b71ee4$var$fromString,
    toString: $9e5312af42b71ee4$var$toString,
    fromNumber: $9e5312af42b71ee4$var$fromNumber,
    toNumber: $9e5312af42b71ee4$var$toNumber,
    fromNat: $9e5312af42b71ee4$var$fromNat,
    toNat: $9e5312af42b71ee4$var$toNat,
    fromArray: $9e5312af42b71ee4$var$fromArray,
    toArray: $9e5312af42b71ee4$var$toArray,
    fromUint8Array: $9e5312af42b71ee4$var$fromUint8Array,
    toUint8Array: $9e5312af42b71ee4$var$toUint8Array
};

});
parcelRegister("5T1Ud", function(module, exports) {
var $44939141d28d8266$var$generate = function generate(num, fn) {
    var a = [];
    for(var i = 0; i < num; ++i)a.push(fn(i));
    return a;
};
var $44939141d28d8266$var$replicate = function replicate(num, val) {
    return $44939141d28d8266$var$generate(num, function() {
        return val;
    });
};
var $44939141d28d8266$var$concat = function concat(a, b) {
    return a.concat(b);
};
var $44939141d28d8266$var$flatten = function flatten(a) {
    var r = [];
    for(var j = 0, J = a.length; j < J; ++j)for(var i = 0, I = a[j].length; i < I; ++i)r.push(a[j][i]);
    return r;
};
var $44939141d28d8266$var$chunksOf = function chunksOf(n, a) {
    var b = [];
    for(var i = 0, l = a.length; i < l; i += n)b.push(a.slice(i, i + n));
    return b;
};
module.exports = {
    generate: $44939141d28d8266$var$generate,
    replicate: $44939141d28d8266$var$replicate,
    concat: $44939141d28d8266$var$concat,
    flatten: $44939141d28d8266$var$flatten,
    chunksOf: $44939141d28d8266$var$chunksOf
};

});


parcelRegister("aD79B", function(module, exports) {
// Thanks https://github.com/axic/swarmhash

var $5ebJj = parcelRequire("5ebJj");
var $7bd318873cf864bb$require$keccak = $5ebJj.keccak256;

var $dAKYh = parcelRequire("dAKYh");
var $7bd318873cf864bb$var$swarmHashBlock = function swarmHashBlock(length, data) {
    var lengthEncoded = $dAKYh.reverse($dAKYh.pad(6, $dAKYh.fromNumber(length)));
    var bytes = $dAKYh.flatten([
        lengthEncoded,
        "0x0000",
        data
    ]);
    return $7bd318873cf864bb$require$keccak(bytes).slice(2);
}; // (Bytes | Uint8Array | String) -> String
var $7bd318873cf864bb$var$swarmHash = function swarmHash(data) {
    if (typeof data === "string" && data.slice(0, 2) !== "0x") data = $dAKYh.fromString(data);
    else if (typeof data !== "string" && data.length !== undefined) data = $dAKYh.fromUint8Array(data);
    var length = $dAKYh.length(data);
    if (length <= 4096) return $7bd318873cf864bb$var$swarmHashBlock(length, data);
    var maxSize = 4096;
    while(maxSize * 128 < length)maxSize *= 128;
    var innerNodes = [];
    for(var i = 0; i < length; i += maxSize){
        var size = maxSize < length - i ? maxSize : length - i;
        innerNodes.push(swarmHash($dAKYh.slice(data, i, i + size)));
    }
    return $7bd318873cf864bb$var$swarmHashBlock(length, $dAKYh.flatten(innerNodes));
};
module.exports = $7bd318873cf864bb$var$swarmHash;

});
parcelRegister("5ebJj", function(module, exports) {
// This was ported from https://github.com/emn178/js-sha3, with some minor
// modifications and pruning. It is licensed under MIT:
//
// Copyright 2015-2016 Chen, Yi-Cyuan
//  
// Permission is hereby granted, free of charge, to any person obtaining
// a copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
// 
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
// 
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
// LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
// OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
var $3ce75bd9618e99c7$var$HEX_CHARS = '0123456789abcdef'.split('');
var $3ce75bd9618e99c7$var$KECCAK_PADDING = [
    1,
    256,
    65536,
    16777216
];
var $3ce75bd9618e99c7$var$SHIFT = [
    0,
    8,
    16,
    24
];
var $3ce75bd9618e99c7$var$RC = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
var $3ce75bd9618e99c7$var$Keccak = function Keccak(bits) {
    return {
        blocks: [],
        reset: true,
        block: 0,
        start: 0,
        blockCount: 1600 - (bits << 1) >> 5,
        outputBlocks: bits >> 5,
        s: function(s) {
            return [].concat(s, s, s, s, s);
        }([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ])
    };
};
var $3ce75bd9618e99c7$var$update = function update(state, message) {
    var length = message.length, blocks = state.blocks, byteCount = state.blockCount << 2, blockCount = state.blockCount, outputBlocks = state.outputBlocks, s = state.s, index = 0, i, code;
    // update
    while(index < length){
        if (state.reset) {
            state.reset = false;
            blocks[0] = state.block;
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        if (typeof message !== "string") for(i = state.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << $3ce75bd9618e99c7$var$SHIFT[i++ & 3];
        else for(i = state.start; index < length && i < byteCount; ++index){
            code = message.charCodeAt(index);
            if (code < 0x80) blocks[i >> 2] |= code << $3ce75bd9618e99c7$var$SHIFT[i++ & 3];
            else if (code < 0x800) {
                blocks[i >> 2] |= (0xc0 | code >> 6) << $3ce75bd9618e99c7$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $3ce75bd9618e99c7$var$SHIFT[i++ & 3];
            } else if (code < 0xd800 || code >= 0xe000) {
                blocks[i >> 2] |= (0xe0 | code >> 12) << $3ce75bd9618e99c7$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $3ce75bd9618e99c7$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $3ce75bd9618e99c7$var$SHIFT[i++ & 3];
            } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                blocks[i >> 2] |= (0xf0 | code >> 18) << $3ce75bd9618e99c7$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << $3ce75bd9618e99c7$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $3ce75bd9618e99c7$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $3ce75bd9618e99c7$var$SHIFT[i++ & 3];
            }
        }
        state.lastByteIndex = i;
        if (i >= byteCount) {
            state.start = i - byteCount;
            state.block = blocks[blockCount];
            for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
            $3ce75bd9618e99c7$var$f(s);
            state.reset = true;
        } else state.start = i;
    }
    // finalize
    i = state.lastByteIndex;
    blocks[i >> 2] |= $3ce75bd9618e99c7$var$KECCAK_PADDING[i & 3];
    if (state.lastByteIndex === byteCount) {
        blocks[0] = blocks[blockCount];
        for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
    }
    blocks[blockCount - 1] |= 0x80000000;
    for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
    $3ce75bd9618e99c7$var$f(s);
    // toString
    var hex = '', i = 0, j = 0, block;
    while(j < outputBlocks){
        for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
            block = s[i];
            hex += $3ce75bd9618e99c7$var$HEX_CHARS[block >> 4 & 0x0F] + $3ce75bd9618e99c7$var$HEX_CHARS[block & 0x0F] + $3ce75bd9618e99c7$var$HEX_CHARS[block >> 12 & 0x0F] + $3ce75bd9618e99c7$var$HEX_CHARS[block >> 8 & 0x0F] + $3ce75bd9618e99c7$var$HEX_CHARS[block >> 20 & 0x0F] + $3ce75bd9618e99c7$var$HEX_CHARS[block >> 16 & 0x0F] + $3ce75bd9618e99c7$var$HEX_CHARS[block >> 28 & 0x0F] + $3ce75bd9618e99c7$var$HEX_CHARS[block >> 24 & 0x0F];
        }
        if (j % blockCount === 0) {
            $3ce75bd9618e99c7$var$f(s);
            i = 0;
        }
    }
    return "0x" + hex;
};
var $3ce75bd9618e99c7$var$f = function f(s) {
    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
    for(n = 0; n < 48; n += 2){
        c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        h = c8 ^ (c2 << 1 | c3 >>> 31);
        l = c9 ^ (c3 << 1 | c2 >>> 31);
        s[0] ^= h;
        s[1] ^= l;
        s[10] ^= h;
        s[11] ^= l;
        s[20] ^= h;
        s[21] ^= l;
        s[30] ^= h;
        s[31] ^= l;
        s[40] ^= h;
        s[41] ^= l;
        h = c0 ^ (c4 << 1 | c5 >>> 31);
        l = c1 ^ (c5 << 1 | c4 >>> 31);
        s[2] ^= h;
        s[3] ^= l;
        s[12] ^= h;
        s[13] ^= l;
        s[22] ^= h;
        s[23] ^= l;
        s[32] ^= h;
        s[33] ^= l;
        s[42] ^= h;
        s[43] ^= l;
        h = c2 ^ (c6 << 1 | c7 >>> 31);
        l = c3 ^ (c7 << 1 | c6 >>> 31);
        s[4] ^= h;
        s[5] ^= l;
        s[14] ^= h;
        s[15] ^= l;
        s[24] ^= h;
        s[25] ^= l;
        s[34] ^= h;
        s[35] ^= l;
        s[44] ^= h;
        s[45] ^= l;
        h = c4 ^ (c8 << 1 | c9 >>> 31);
        l = c5 ^ (c9 << 1 | c8 >>> 31);
        s[6] ^= h;
        s[7] ^= l;
        s[16] ^= h;
        s[17] ^= l;
        s[26] ^= h;
        s[27] ^= l;
        s[36] ^= h;
        s[37] ^= l;
        s[46] ^= h;
        s[47] ^= l;
        h = c6 ^ (c0 << 1 | c1 >>> 31);
        l = c7 ^ (c1 << 1 | c0 >>> 31);
        s[8] ^= h;
        s[9] ^= l;
        s[18] ^= h;
        s[19] ^= l;
        s[28] ^= h;
        s[29] ^= l;
        s[38] ^= h;
        s[39] ^= l;
        s[48] ^= h;
        s[49] ^= l;
        b0 = s[0];
        b1 = s[1];
        b32 = s[11] << 4 | s[10] >>> 28;
        b33 = s[10] << 4 | s[11] >>> 28;
        b14 = s[20] << 3 | s[21] >>> 29;
        b15 = s[21] << 3 | s[20] >>> 29;
        b46 = s[31] << 9 | s[30] >>> 23;
        b47 = s[30] << 9 | s[31] >>> 23;
        b28 = s[40] << 18 | s[41] >>> 14;
        b29 = s[41] << 18 | s[40] >>> 14;
        b20 = s[2] << 1 | s[3] >>> 31;
        b21 = s[3] << 1 | s[2] >>> 31;
        b2 = s[13] << 12 | s[12] >>> 20;
        b3 = s[12] << 12 | s[13] >>> 20;
        b34 = s[22] << 10 | s[23] >>> 22;
        b35 = s[23] << 10 | s[22] >>> 22;
        b16 = s[33] << 13 | s[32] >>> 19;
        b17 = s[32] << 13 | s[33] >>> 19;
        b48 = s[42] << 2 | s[43] >>> 30;
        b49 = s[43] << 2 | s[42] >>> 30;
        b40 = s[5] << 30 | s[4] >>> 2;
        b41 = s[4] << 30 | s[5] >>> 2;
        b22 = s[14] << 6 | s[15] >>> 26;
        b23 = s[15] << 6 | s[14] >>> 26;
        b4 = s[25] << 11 | s[24] >>> 21;
        b5 = s[24] << 11 | s[25] >>> 21;
        b36 = s[34] << 15 | s[35] >>> 17;
        b37 = s[35] << 15 | s[34] >>> 17;
        b18 = s[45] << 29 | s[44] >>> 3;
        b19 = s[44] << 29 | s[45] >>> 3;
        b10 = s[6] << 28 | s[7] >>> 4;
        b11 = s[7] << 28 | s[6] >>> 4;
        b42 = s[17] << 23 | s[16] >>> 9;
        b43 = s[16] << 23 | s[17] >>> 9;
        b24 = s[26] << 25 | s[27] >>> 7;
        b25 = s[27] << 25 | s[26] >>> 7;
        b6 = s[36] << 21 | s[37] >>> 11;
        b7 = s[37] << 21 | s[36] >>> 11;
        b38 = s[47] << 24 | s[46] >>> 8;
        b39 = s[46] << 24 | s[47] >>> 8;
        b30 = s[8] << 27 | s[9] >>> 5;
        b31 = s[9] << 27 | s[8] >>> 5;
        b12 = s[18] << 20 | s[19] >>> 12;
        b13 = s[19] << 20 | s[18] >>> 12;
        b44 = s[29] << 7 | s[28] >>> 25;
        b45 = s[28] << 7 | s[29] >>> 25;
        b26 = s[38] << 8 | s[39] >>> 24;
        b27 = s[39] << 8 | s[38] >>> 24;
        b8 = s[48] << 14 | s[49] >>> 18;
        b9 = s[49] << 14 | s[48] >>> 18;
        s[0] = b0 ^ ~b2 & b4;
        s[1] = b1 ^ ~b3 & b5;
        s[10] = b10 ^ ~b12 & b14;
        s[11] = b11 ^ ~b13 & b15;
        s[20] = b20 ^ ~b22 & b24;
        s[21] = b21 ^ ~b23 & b25;
        s[30] = b30 ^ ~b32 & b34;
        s[31] = b31 ^ ~b33 & b35;
        s[40] = b40 ^ ~b42 & b44;
        s[41] = b41 ^ ~b43 & b45;
        s[2] = b2 ^ ~b4 & b6;
        s[3] = b3 ^ ~b5 & b7;
        s[12] = b12 ^ ~b14 & b16;
        s[13] = b13 ^ ~b15 & b17;
        s[22] = b22 ^ ~b24 & b26;
        s[23] = b23 ^ ~b25 & b27;
        s[32] = b32 ^ ~b34 & b36;
        s[33] = b33 ^ ~b35 & b37;
        s[42] = b42 ^ ~b44 & b46;
        s[43] = b43 ^ ~b45 & b47;
        s[4] = b4 ^ ~b6 & b8;
        s[5] = b5 ^ ~b7 & b9;
        s[14] = b14 ^ ~b16 & b18;
        s[15] = b15 ^ ~b17 & b19;
        s[24] = b24 ^ ~b26 & b28;
        s[25] = b25 ^ ~b27 & b29;
        s[34] = b34 ^ ~b36 & b38;
        s[35] = b35 ^ ~b37 & b39;
        s[44] = b44 ^ ~b46 & b48;
        s[45] = b45 ^ ~b47 & b49;
        s[6] = b6 ^ ~b8 & b0;
        s[7] = b7 ^ ~b9 & b1;
        s[16] = b16 ^ ~b18 & b10;
        s[17] = b17 ^ ~b19 & b11;
        s[26] = b26 ^ ~b28 & b20;
        s[27] = b27 ^ ~b29 & b21;
        s[36] = b36 ^ ~b38 & b30;
        s[37] = b37 ^ ~b39 & b31;
        s[46] = b46 ^ ~b48 & b40;
        s[47] = b47 ^ ~b49 & b41;
        s[8] = b8 ^ ~b0 & b2;
        s[9] = b9 ^ ~b1 & b3;
        s[18] = b18 ^ ~b10 & b12;
        s[19] = b19 ^ ~b11 & b13;
        s[28] = b28 ^ ~b20 & b22;
        s[29] = b29 ^ ~b21 & b23;
        s[38] = b38 ^ ~b30 & b32;
        s[39] = b39 ^ ~b31 & b33;
        s[48] = b48 ^ ~b40 & b42;
        s[49] = b49 ^ ~b41 & b43;
        s[0] ^= $3ce75bd9618e99c7$var$RC[n];
        s[1] ^= $3ce75bd9618e99c7$var$RC[n + 1];
    }
};
var $3ce75bd9618e99c7$var$keccak = function keccak(bits) {
    return function(str) {
        var msg;
        if (str.slice(0, 2) === "0x") {
            msg = [];
            for(var i = 2, l = str.length; i < l; i += 2)msg.push(parseInt(str.slice(i, i + 2), 16));
        } else msg = str;
        return $3ce75bd9618e99c7$var$update($3ce75bd9618e99c7$var$Keccak(bits, bits), msg);
    };
};
module.exports = {
    keccak256: $3ce75bd9618e99c7$var$keccak(256),
    keccak512: $3ce75bd9618e99c7$var$keccak(512),
    keccak256s: $3ce75bd9618e99c7$var$keccak(256),
    keccak512s: $3ce75bd9618e99c7$var$keccak(512)
};

});


parcelRegister("3WgN1", function(module, exports) {
var $2de3cff58096cf4b$var$picker = function picker(type) {
    return function() {
        return new Promise(function(resolve, reject) {
            var fileLoader = function fileLoader(e) {
                var directory = {};
                var totalFiles = e.target.files.length;
                var loadedFiles = 0;
                [].map.call(e.target.files, function(file) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        var data = new Uint8Array(e.target.result);
                        if (type === "directory") {
                            var path = file.webkitRelativePath;
                            directory[path.slice(path.indexOf("/") + 1)] = {
                                type: "text/plain",
                                data: data
                            };
                            if (++loadedFiles === totalFiles) resolve(directory);
                        } else if (type === "file") {
                            var _path = file.webkitRelativePath;
                            resolve({
                                "type": mimetype.lookup(_path),
                                "data": data
                            });
                        } else resolve(data);
                    };
                    reader.readAsArrayBuffer(file);
                });
            };
            var fileInput;
            if (type === "directory") {
                fileInput = document.createElement("input");
                fileInput.addEventListener("change", fileLoader);
                fileInput.type = "file";
                fileInput.webkitdirectory = true;
                fileInput.mozdirectory = true;
                fileInput.msdirectory = true;
                fileInput.odirectory = true;
                fileInput.directory = true;
            } else {
                fileInput = document.createElement("input");
                fileInput.addEventListener("change", fileLoader);
                fileInput.type = "file";
            }
            var mouseEvent = document.createEvent("MouseEvents");
            mouseEvent.initEvent("click", true, false);
            fileInput.dispatchEvent(mouseEvent);
        });
    };
};
module.exports = {
    data: $2de3cff58096cf4b$var$picker("data"),
    file: $2de3cff58096cf4b$var$picker("file"),
    directory: $2de3cff58096cf4b$var$picker("directory")
};

});

parcelRegister("iG7Ro", function(module, exports) {
// TODO: this is a temporary fix to hide those libraries from the browser. A
// slightly better long-term solution would be to split this file into two,
// separating the functions that are used on Node.js from the functions that
// are used only on the browser.
module.exports = function(_ref) {
    var fs = _ref.fs, files = _ref.files, os = _ref.os, path = _ref.path, child_process = _ref.child_process, mimetype = _ref.mimetype, defaultArchives = _ref.defaultArchives, request = _ref.request, downloadUrl = _ref.downloadUrl, bytes = _ref.bytes, hash = _ref.hash, pick = _ref.pick;
    // ∀ a . String -> JSON -> Map String a -o Map String a
    //   Inserts a key/val pair in an object impurely.
    var impureInsert = function impureInsert(key) {
        return function(val) {
            return function(map) {
                return map[key] = val, map;
            };
        };
    }; // String -> JSON -> Map String JSON
    //   Merges an array of keys and an array of vals into an object.
    var toMap = function toMap(keys) {
        return function(vals) {
            var map = {};
            for(var i = 0, l = keys.length; i < l; ++i)map[keys[i]] = vals[i];
            return map;
        };
    }; // ∀ a . Map String a -> Map String a -> Map String a
    //   Merges two maps into one.
    var merge = function merge(a) {
        return function(b) {
            var map = {};
            for(var key in a)map[key] = a[key];
            for(var _key in b)map[_key] = b[_key];
            return map;
        };
    }; // ∀ a . [a] -> [a] -> Bool
    var equals = function equals(a) {
        return function(b) {
            if (a.length !== b.length) return false;
            else for(var i = 0, l = a.length; i < l; ++i){
                if (a[i] !== b[i]) return false;
            }
            return true;
        };
    }; // String -> String -> String
    var rawUrl = function rawUrl(swarmUrl) {
        return function(hash) {
            return "".concat(swarmUrl, "/bzz-raw:/").concat(hash);
        };
    }; // String -> String -> Promise Uint8Array
    //   Gets the raw contents of a Swarm hash address.
    var downloadData = function downloadData(swarmUrl) {
        return function(hash) {
            return new Promise(function(resolve, reject) {
                request(rawUrl(swarmUrl)(hash), {
                    responseType: "arraybuffer"
                }, function(err, arrayBuffer, response) {
                    if (err) return reject(err);
                    if (response.statusCode >= 400) return reject(new Error("Error ".concat(response.statusCode, ".")));
                    return resolve(new Uint8Array(arrayBuffer));
                });
            });
        };
    }; // type Entry = {"type": String, "hash": String}
    // type File = {"type": String, "data": Uint8Array}
    // String -> String -> Promise (Map String Entry)
    //   Solves the manifest of a Swarm address recursively.
    //   Returns a map from full paths to entries.
    var downloadEntries = function downloadEntries(swarmUrl) {
        return function(hash) {
            var search = function search(hash) {
                return function(path) {
                    return function(routes) {
                        // Formats an entry to the Swarm.js type.
                        var format = function format(entry) {
                            return {
                                type: entry.contentType,
                                hash: entry.hash
                            };
                        }; // To download a single entry:
                        //   if type is bzz-manifest, go deeper
                        //   if not, add it to the routing table
                        var downloadEntry = function downloadEntry(entry) {
                            if (entry.path === undefined) return Promise.resolve();
                            else return entry.contentType === "application/bzz-manifest+json" ? search(entry.hash)(path + entry.path)(routes) : Promise.resolve(impureInsert(path + entry.path)(format(entry))(routes));
                        }; // Downloads the initial manifest and then each entry.
                        return downloadData(swarmUrl)(hash).then(function(text) {
                            return JSON.parse(toString(text)).entries;
                        }).then(function(entries) {
                            return Promise.all(entries.map(downloadEntry));
                        }).then(function() {
                            return routes;
                        });
                    };
                };
            };
            return search(hash)("")({});
        };
    }; // String -> String -> Promise (Map String String)
    //   Same as `downloadEntries`, but returns only hashes (no types).
    var downloadRoutes = function downloadRoutes(swarmUrl) {
        return function(hash) {
            return downloadEntries(swarmUrl)(hash).then(function(entries) {
                return toMap(Object.keys(entries))(Object.keys(entries).map(function(route) {
                    return entries[route].hash;
                }));
            });
        };
    }; // String -> String -> Promise (Map String File)
    //   Gets the entire directory tree in a Swarm address.
    //   Returns a promise mapping paths to file contents.
    var downloadDirectory = function downloadDirectory(swarmUrl) {
        return function(hash) {
            return downloadEntries(swarmUrl)(hash).then(function(entries) {
                var paths = Object.keys(entries);
                var hashs = paths.map(function(path) {
                    return entries[path].hash;
                });
                var types = paths.map(function(path) {
                    return entries[path].type;
                });
                var datas = hashs.map(downloadData(swarmUrl));
                var files = function files(datas) {
                    return datas.map(function(data, i) {
                        return {
                            type: types[i],
                            data: data
                        };
                    });
                };
                return Promise.all(datas).then(function(datas) {
                    return toMap(paths)(files(datas));
                });
            });
        };
    }; // String -> String -> String -> Promise String
    //   Gets the raw contents of a Swarm hash address.
    //   Returns a promise with the downloaded file path.
    var downloadDataToDisk = function downloadDataToDisk(swarmUrl) {
        return function(hash) {
            return function(filePath) {
                return files.download(rawUrl(swarmUrl)(hash))(filePath);
            };
        };
    }; // String -> String -> String -> Promise (Map String String)
    //   Gets the entire directory tree in a Swarm address.
    //   Returns a promise mapping paths to file contents.
    var downloadDirectoryToDisk = function downloadDirectoryToDisk(swarmUrl) {
        return function(hash) {
            return function(dirPath) {
                return downloadRoutes(swarmUrl)(hash).then(function(routingTable) {
                    var downloads = [];
                    for(var route in routingTable)if (route.length > 0) {
                        var filePath = path.join(dirPath, route);
                        downloads.push(downloadDataToDisk(swarmUrl)(routingTable[route])(filePath));
                    }
                    return Promise.all(downloads).then(function() {
                        return dirPath;
                    });
                });
            };
        };
    }; // String -> Uint8Array -> Promise String
    //   Uploads raw data to Swarm.
    //   Returns a promise with the uploaded hash.
    var uploadData = function uploadData(swarmUrl) {
        return function(data) {
            return new Promise(function(resolve, reject) {
                var params = {
                    body: typeof data === "string" ? fromString(data) : data,
                    method: "POST"
                };
                request("".concat(swarmUrl, "/bzz-raw:/"), params, function(err, data) {
                    if (err) return reject(err);
                    return resolve(data);
                });
            });
        };
    }; // String -> String -> String -> File -> Promise String
    //   Uploads a file to the Swarm manifest at a given hash, under a specific
    //   route. Returns a promise containing the uploaded hash.
    //   FIXME: for some reasons Swarm-Gateways is sometimes returning
    //   error 404 (bad request), so we retry up to 3 times. Why?
    var uploadToManifest = function uploadToManifest(swarmUrl) {
        return function(hash) {
            return function(route) {
                return function(file) {
                    var attempt = function attempt(n) {
                        var slashRoute = route[0] === "/" ? route : "/" + route;
                        var url = "".concat(swarmUrl, "/bzz:/").concat(hash).concat(slashRoute);
                        var opt = {
                            method: "PUT",
                            headers: {
                                "Content-Type": file.type
                            },
                            body: file.data
                        };
                        return new Promise(function(resolve, reject) {
                            request(url, opt, function(err, data) {
                                if (err) return reject(err);
                                if (data.indexOf("error") !== -1) return reject(data);
                                return resolve(data);
                            });
                        })["catch"](function(e) {
                            return n > 0 && attempt(n - 1);
                        });
                    };
                    return attempt(3);
                };
            };
        };
    }; // String -> {type: String, data: Uint8Array} -> Promise String
    var uploadFile = function uploadFile(swarmUrl) {
        return function(file) {
            return uploadDirectory(swarmUrl)({
                "": file
            });
        };
    }; // String -> String -> Promise String
    var uploadFileFromDisk = function uploadFileFromDisk(swarmUrl) {
        return function(filePath) {
            return fs.readFile(filePath).then(function(data) {
                return uploadFile(swarmUrl)({
                    type: mimetype.lookup(filePath),
                    data: data
                });
            });
        };
    }; // String -> Map String File -> Promise String
    //   Uploads a directory to Swarm. The directory is
    //   represented as a map of routes and files.
    //   A default path is encoded by having a "" route.
    var uploadDirectory = function uploadDirectory(swarmUrl) {
        return function(directory) {
            return uploadData(swarmUrl)("{}").then(function(hash) {
                var uploadRoute = function uploadRoute(route) {
                    return function(hash) {
                        return uploadToManifest(swarmUrl)(hash)(route)(directory[route]);
                    };
                };
                var uploadToHash = function uploadToHash(hash, route) {
                    return hash.then(uploadRoute(route));
                };
                return Object.keys(directory).reduce(uploadToHash, Promise.resolve(hash));
            });
        };
    }; // String -> Promise String
    var uploadDataFromDisk = function uploadDataFromDisk(swarmUrl) {
        return function(filePath) {
            return fs.readFile(filePath).then(uploadData(swarmUrl));
        };
    }; // String -> Nullable String -> String -> Promise String
    var uploadDirectoryFromDisk = function uploadDirectoryFromDisk(swarmUrl) {
        return function(defaultPath) {
            return function(dirPath) {
                return files.directoryTree(dirPath).then(function(fullPaths) {
                    return Promise.all(fullPaths.map(function(path) {
                        return fs.readFile(path);
                    })).then(function(datas) {
                        var paths = fullPaths.map(function(path) {
                            return path.slice(dirPath.length);
                        });
                        var types = fullPaths.map(function(path) {
                            return mimetype.lookup(path) || "text/plain";
                        });
                        return toMap(paths)(datas.map(function(data, i) {
                            return {
                                type: types[i],
                                data: data
                            };
                        }));
                    });
                }).then(function(directory) {
                    return merge(defaultPath ? {
                        "": directory[defaultPath]
                    } : {})(directory);
                }).then(uploadDirectory(swarmUrl));
            };
        };
    }; // String -> UploadInfo -> Promise String
    //   Simplified multi-type upload which calls the correct
    //   one based on the type of the argument given.
    var _upload = function upload(swarmUrl) {
        return function(arg) {
            // Upload raw data from browser
            if (arg.pick === "data") return pick.data().then(uploadData(swarmUrl)); // Upload a file from browser
            else if (arg.pick === "file") return pick.file().then(uploadFile(swarmUrl)); // Upload a directory from browser
            else if (arg.pick === "directory") return pick.directory().then(uploadDirectory(swarmUrl)); // Upload directory/file from disk
            else if (arg.path) switch(arg.kind){
                case "data":
                    return uploadDataFromDisk(swarmUrl)(arg.path);
                case "file":
                    return uploadFileFromDisk(swarmUrl)(arg.path);
                case "directory":
                    return uploadDirectoryFromDisk(swarmUrl)(arg.defaultFile)(arg.path);
            }
            else if (arg.length || typeof arg === "string") return uploadData(swarmUrl)(arg); // Upload directory with JSON
            else if (arg instanceof Object) return uploadDirectory(swarmUrl)(arg);
            return Promise.reject(new Error("Bad arguments"));
        };
    }; // String -> String -> Nullable String -> Promise (String | Uint8Array | Map String Uint8Array)
    //   Simplified multi-type download which calls the correct function based on
    //   the type of the argument given, and on whether the Swwarm address has a
    //   directory or a file.
    var _download = function download(swarmUrl) {
        return function(hash) {
            return function(path) {
                return isDirectory(swarmUrl)(hash).then(function(isDir) {
                    if (isDir) return path ? downloadDirectoryToDisk(swarmUrl)(hash)(path) : downloadDirectory(swarmUrl)(hash);
                    else return path ? downloadDataToDisk(swarmUrl)(hash)(path) : downloadData(swarmUrl)(hash);
                });
            };
        };
    }; // String -> Promise String
    //   Downloads the Swarm binaries into a path. Returns a promise that only
    //   resolves when the exact Swarm file is there, and verified to be correct.
    //   If it was already there to begin with, skips the download.
    var downloadBinary = function downloadBinary(path, archives) {
        var system = os.platform().replace("win32", "windows") + "-" + (os.arch() === "x64" ? "amd64" : "386");
        var archive = (archives || defaultArchives)[system];
        var archiveUrl = downloadUrl + archive.archive + ".tar.gz";
        var archiveMD5 = archive.archiveMD5;
        var binaryMD5 = archive.binaryMD5;
        return files.safeDownloadArchived(archiveUrl)(archiveMD5)(binaryMD5)(path);
    }; // type SwarmSetup = {
    //   account : String,
    //   password : String,
    //   dataDir : String,
    //   binPath : String,
    //   ensApi : String,
    //   onDownloadProgress : Number ~> (),
    //   archives : [{
    //     archive: String,
    //     binaryMD5: String,
    //     archiveMD5: String
    //   }]
    // }
    // SwarmSetup ~> Promise Process
    //   Starts the Swarm process.
    var startProcess = function startProcess(swarmSetup) {
        return new Promise(function(resolve, reject) {
            var spawn = child_process.spawn;
            var hasString = function hasString(str) {
                return function(buffer) {
                    return ('' + buffer).indexOf(str) !== -1;
                };
            };
            var account = swarmSetup.account, password = swarmSetup.password, dataDir = swarmSetup.dataDir, ensApi = swarmSetup.ensApi, privateKey = swarmSetup.privateKey;
            var STARTUP_TIMEOUT_SECS = 3;
            var WAITING_PASSWORD = 0;
            var STARTING = 1;
            var LISTENING = 2;
            var PASSWORD_PROMPT_HOOK = "Passphrase";
            var LISTENING_HOOK = "Swarm http proxy started";
            var state = WAITING_PASSWORD;
            var swarmProcess = spawn(swarmSetup.binPath, [
                '--bzzaccount',
                account || privateKey,
                '--datadir',
                dataDir,
                '--ens-api',
                ensApi
            ]);
            var handleProcessOutput = function handleProcessOutput(data) {
                if (state === WAITING_PASSWORD && hasString(PASSWORD_PROMPT_HOOK)(data)) setTimeout(function() {
                    state = STARTING;
                    swarmProcess.stdin.write(password + '\n');
                }, 500);
                else if (hasString(LISTENING_HOOK)(data)) {
                    state = LISTENING;
                    clearTimeout(timeout);
                    resolve(swarmProcess);
                }
            };
            swarmProcess.stdout.on('data', handleProcessOutput);
            swarmProcess.stderr.on('data', handleProcessOutput); //swarmProcess.on('close', () => setTimeout(restart, 2000));
            var restart = function restart() {
                return startProcess(swarmSetup).then(resolve)["catch"](reject);
            };
            var error = function error() {
                return reject(new Error("Couldn't start swarm process."));
            };
            var timeout = setTimeout(error, 20000);
        });
    }; // Process ~> Promise ()
    //   Stops the Swarm process.
    var stopProcess = function stopProcess(process) {
        return new Promise(function(resolve, reject) {
            process.stderr.removeAllListeners('data');
            process.stdout.removeAllListeners('data');
            process.stdin.removeAllListeners('error');
            process.removeAllListeners('error');
            process.removeAllListeners('exit');
            process.kill('SIGINT');
            var killTimeout = setTimeout(function() {
                return process.kill('SIGKILL');
            }, 8000);
            process.once('close', function() {
                clearTimeout(killTimeout);
                resolve();
            });
        });
    }; // SwarmSetup -> (SwarmAPI -> Promise ()) -> Promise ()
    //   Receives a Swarm configuration object and a callback function. It then
    //   checks if a local Swarm node is running. If no local Swarm is found, it
    //   downloads the Swarm binaries to the dataDir (if not there), checksums,
    //   starts the Swarm process and calls the callback function with an API
    //   object using the local node. That callback must return a promise which
    //   will resolve when it is done using the API, so that this function can
    //   close the Swarm process properly. Returns a promise that resolves when the
    //   user is done with the API and the Swarm process is closed.
    //   TODO: check if Swarm process is already running (improve `isAvailable`)
    var local = function local(swarmSetup) {
        return function(useAPI) {
            return _isAvailable("http://localhost:8500").then(function(isAvailable) {
                return isAvailable ? useAPI(at("http://localhost:8500")).then(function() {}) : downloadBinary(swarmSetup.binPath, swarmSetup.archives).onData(function(data) {
                    return (swarmSetup.onProgress || function() {})(data.length);
                }).then(function() {
                    return startProcess(swarmSetup);
                }).then(function(process) {
                    return useAPI(at("http://localhost:8500")).then(function() {
                        return process;
                    });
                }).then(stopProcess);
            });
        };
    }; // String ~> Promise Bool
    //   Returns true if Swarm is available on `url`.
    //   Perfoms a test upload to determine that.
    //   TODO: improve this?
    var _isAvailable = function isAvailable(swarmUrl) {
        var testFile = "test";
        var testHash = "c9a99c7d326dcc6316f32fe2625b311f6dc49a175e6877681ded93137d3569e7";
        return uploadData(swarmUrl)(testFile).then(function(hash) {
            return hash === testHash;
        })["catch"](function() {
            return false;
        });
    }; // String -> String ~> Promise Bool
    //   Returns a Promise which is true if that Swarm address is a directory.
    //   Determines that by checking that it (i) is a JSON, (ii) has a .entries.
    //   TODO: improve this?
    var isDirectory = function isDirectory(swarmUrl) {
        return function(hash) {
            return downloadData(swarmUrl)(hash).then(function(data) {
                try {
                    return !!JSON.parse(toString(data)).entries;
                } catch (e) {
                    return false;
                }
            });
        };
    }; // Uncurries a function; used to allow the f(x,y,z) style on exports.
    var uncurry = function uncurry(f) {
        return function(a, b, c, d, e) {
            var p; // Hardcoded because efficiency (`arguments` is very slow).
            if (typeof a !== "undefined") p = f(a);
            if (typeof b !== "undefined") p = f(b);
            if (typeof c !== "undefined") p = f(c);
            if (typeof d !== "undefined") p = f(d);
            if (typeof e !== "undefined") p = f(e);
            return p;
        };
    }; // () -> Promise Bool
    //   Not sure how to mock Swarm to test it properly. Ideas?
    var test = function test() {
        return Promise.resolve(true);
    }; // Uint8Array -> String
    var toString = function toString(uint8Array) {
        return bytes.toString(bytes.fromUint8Array(uint8Array));
    }; // String -> Uint8Array
    var fromString = function fromString(string) {
        return bytes.toUint8Array(bytes.fromString(string));
    }; // String -> SwarmAPI
    //   Fixes the `swarmUrl`, returning an API where you don't have to pass it.
    var at = function at(swarmUrl) {
        return {
            download: function download(hash, path) {
                return _download(swarmUrl)(hash)(path);
            },
            downloadData: uncurry(downloadData(swarmUrl)),
            downloadDataToDisk: uncurry(downloadDataToDisk(swarmUrl)),
            downloadDirectory: uncurry(downloadDirectory(swarmUrl)),
            downloadDirectoryToDisk: uncurry(downloadDirectoryToDisk(swarmUrl)),
            downloadEntries: uncurry(downloadEntries(swarmUrl)),
            downloadRoutes: uncurry(downloadRoutes(swarmUrl)),
            isAvailable: function isAvailable() {
                return _isAvailable(swarmUrl);
            },
            upload: function upload(arg) {
                return _upload(swarmUrl)(arg);
            },
            uploadData: uncurry(uploadData(swarmUrl)),
            uploadFile: uncurry(uploadFile(swarmUrl)),
            uploadFileFromDisk: uncurry(uploadFile(swarmUrl)),
            uploadDataFromDisk: uncurry(uploadDataFromDisk(swarmUrl)),
            uploadDirectory: uncurry(uploadDirectory(swarmUrl)),
            uploadDirectoryFromDisk: uncurry(uploadDirectoryFromDisk(swarmUrl)),
            uploadToManifest: uncurry(uploadToManifest(swarmUrl)),
            pick: pick,
            hash: hash,
            fromString: fromString,
            toString: toString
        };
    };
    return {
        at: at,
        local: local,
        download: _download,
        downloadBinary: downloadBinary,
        downloadData: downloadData,
        downloadDataToDisk: downloadDataToDisk,
        downloadDirectory: downloadDirectory,
        downloadDirectoryToDisk: downloadDirectoryToDisk,
        downloadEntries: downloadEntries,
        downloadRoutes: downloadRoutes,
        isAvailable: _isAvailable,
        startProcess: startProcess,
        stopProcess: stopProcess,
        upload: _upload,
        uploadData: uploadData,
        uploadDataFromDisk: uploadDataFromDisk,
        uploadFile: uploadFile,
        uploadFileFromDisk: uploadFileFromDisk,
        uploadDirectory: uploadDirectory,
        uploadDirectoryFromDisk: uploadDirectoryFromDisk,
        uploadToManifest: uploadToManifest,
        pick: pick,
        hash: hash,
        fromString: fromString,
        toString: toString
    };
};

});




parcelRegister("59kwG", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $hPtJY.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return '';
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
module.exports = $3bfdb7183e8721d6$var$posix;

});

parcelRegister("fzZ9h", function(module, exports) {

$parcel$export(module.exports, "Factory2d", () => Factory2d);
$parcel$export(module.exports, "factory2d", () => factory2d);
// qcom
function Factory2d() {
    var tmp = document.createElement('div');
    document.body.appendChild(tmp);
    tmp.style.display = 'none';
    this.con = tmp.attachShadow({
        mode: 'closed'
    });
    var con = this.con;
    this.cache = {};
    this.vcache = {};
    this.load = function(id_in) {
        let cache = this.cache;
        var url = '/x_modules/apps/' + id_in + '/' + id_in + '.html';
        return new Promise((resolve, reject)=>{
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = (e)=>{
                if (xhr.readyState == 4 && xhr.status == 200) {
                    cache[id_in] = xhr.responseText;
                    resolve(xhr.responseText);
                }
            };
            xhr.open("GET", url, true);
            xhr.setRequestHeader('Content-type', 'text/html');
            xhr.send();
        });
    };
    this.loadAll = function(asset_list) {
        // PREP PARAM 
        asset_list = typeof asset_list == 'string' ? [
            asset_list
        ] : asset_list;
        // here should check if already loaded before adding to cache? // overwrite for now //
        // FILL CACHE: 
        let cache = this.cache;
        return new Promise((resolve, reject)=>{
            var list = [];
            var urls = asset_list;
            var results = [];
            urls.forEach(function(url, i) {
                list.push(fetch(url).then((response)=>{
                    var tx = response.text();
                    //cache[ url ] = tx; // store raw for factory fallback of mangled 
                    return tx;
                }).then((data)=>{
                    // PRE PARSE SEARCH FOR BUNDLED TEMPLATES
                    // STORE IN LOCAL CACHE
                    var parser = new DOMParser();
                    var loaded_dom = parser.parseFromString(data, 'text/html');
                    var loaded_templates = loaded_dom.getElementsByClassName("elx");
                    if (loaded_templates.length > 0) for(var i = 0; i < loaded_templates.length; i++){
                        var tmp = loaded_templates.item(i);
                        cache[tmp.id] = tmp.outerHTML;
                    }
                    else {
                        var cache_key = url.replace(/^.*[\\\/]/, '').split('.').slice(0, -1).join('.');
                        cache[cache_key] = data;
                    }
                    return data;
                }));
            });
            Promise.all(list).then(function(reList) {
                resolve(reList);
            });
        });
    };
    this.storeStaticTemplate = function(domTempIn) {
        var parser = new DOMParser();
        //var loaded_dom = parser.parseFromString( domTempIn , 'text/html');
        var loaded_dom = domTempIn;
        this.cache[loaded_dom.id] = loaded_dom.outerHTML;
    //
    //var loaded_templates = loaded_dom.getElementsByClassName("elx");
    // if( loaded_templates.length > 0 ){
    //     for (var i = 0; i < loaded_templates.length; i++) {
    //         var tmp = loaded_templates.item(i);
    //         cache[ tmp.id ]=tmp.outerHTML;
    //     }             
    };
    this.loadStatic = function(id_in) {};
    this.cloneItemAndInject = function(ref_in, dat_in) {
        console.log('xex');
    };
    this.getTemplate = function(id) {
        let cache = this.cache;
        return new Promise((resolve, reject)=>{
            if (cache[id]) resolve(cache[id]);
            else this.loadTemplate(id).then((template)=>{
                cache[id] = template;
                resolve(template);
            }).fail(reject);
        });
    }, this.render = function(tmp_id, data_in) {
        //var templatestring='`'+this.con.querySelector('#'+tmp_id).innerHTML+'`'
        var templatestring = '`' + this.con.querySelector('#' + tmp_id).outerHTML + '`';
        var wholefunc = '( obj ) =>{ return ' + templatestring + ' }  ';
        var outcome = eval(wholefunc)(data_in);
        return outcome;
    };
    this.renderSync = function(tmp_id, data_in) {
        var templatestring = '`' + this.cache[tmp_id] + '`';
        var wholefunc = '( obj ) =>{ return ' + templatestring + ' }  ';
        var outcome = eval(wholefunc)(data_in);
        return outcome;
    };
    this.renderNode = function(tmp_id, data_in) {};
    this.renderNodeSyncCacheVdom = function(tmp_id, data_in) {
        /// CHECK MEMORY FOOTPRINT OF VDOM CACHE vs. TEXT-STRING CACHE and VDOM EVERYTIME
        if (tmp_id in this.vcache) return this.vcache[tmp_id].cloneNode(true);
        else {
            var rendered_html = this.renderSync(tmp_id, data_in);
            var domfrag = document.createRange().createContextualFragment(rendered_html);
            //var domfrag = document.createContextualFragment( rendered_html );
            this.vcache[tmp_id] = domfrag.firstElementChild; // Cache app UI
            return this.vcache[tmp_id].cloneNode(true);
        }
    };
    this.renderSync = function(tmp_id, data_in) {
        var templatestring = tmp_id in this.cache ? '`' + this.cache[tmp_id] + '`' : '`<div style="color:red;">Template: ' + tmp_id + ' Not Loaded</div>`';
        var f = '( obj ) =>{ return ' + templatestring + ' }  ';
        var outcome = eval(f)(data_in);
        return outcome;
    };
    this.renderNodeSync = function(tmp_id, data_in) {
        var rendered_html = this.renderSync(tmp_id, data_in);
        var domfrag = document.createRange().createContextualFragment(rendered_html);
        this.vcache[tmp_id] = domfrag.firstElementChild; // Cache app UI
        console.log(tmp_id, ': Maybe Not cached-loaded in Factory');
        return this.vcache[tmp_id].cloneNode(true);
    };
    this.renderAsync = function(tmp_id, data_in) {
        return new Promise((resolve, reject)=>{
            if (this.cache[tmp_id]) resolve(this.cache[tmp_id]);
            else this.load2(tmp_id).then((template)=>{
                this.cache[tmp_id] = template;
                //var templatestring='`'+this.con.querySelector('#'+tmp_id).outerHTML+'`'
                var templatestring = '`' + template + '`';
                var wholefunc = '( obj ) =>{ return ' + templatestring + ' }  ';
                var outcome = eval(wholefunc)(data_in);
                resolve(outcome);
            });
        });
    };
    this.asyncRender = function(tmp_url, data_obj) {
    // load template and call promise when done 
    };
    this.renderNodeWithId = function(url, data) {
    //return vnode , id_string 
    };
}
var factory2d = new Factory2d();
 // ALT METHOD 
 //dom_node = new DOMParser().parseFromString( xhr.responseText , "text/xml");
 //this.vcache[ tmp_id ]=new DocumentFragment();
 //this.vcache[ tmp_id ]= document.createDocumentFragment();
 //this.vcache[ tmp_id ].innerHTML = rendered_html;
 /// CHECK MEMORY FOOTPRINT OF VDOM CACHE vs. TEXT-STRING CACHE and VDOM EVERYTIME
 /// RENDER TO CACHE 
 ///if( ! tmp_id in this.vcache ){
 ///    this.vcache[tmp_id]=this.renderSync( tmp_id , data_in ) 
 ///}
 // ACTUALLY HAVE TO CACHE STRING IF WANT TO RENDER ${ obj.x } . yay so no competition        
 /*

    this.load3 = function( id_in ){
        var url = '/x_modules/apps/'+id_in+'/'+id_in+'.html';
        fetch( url )
        .then(response => response.json())
        .then(data => console.log(data));
    }

    this.load4 = function( id_in ){
        fetch('./x_modules/yfer/yfer.html').then(function (response) {
            return response.text(); // The API call was successful!
        }).then(function (html) {
            console.log(html);
            container_in.innerHTML=html;
        }).catch(function (err) {
            console.warn('Something went wrong.', err);
        });
    }

    this.loadPX=function( id_in ) {   
        let cache = this.cache;
        var url = '/x_modules/apps/'+id_in+'/'+id_in+'.html';
        return new Promise( ( resolve, reject ) => {
            
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = (e) => { 
                if (xhr.readyState == 4 && xhr.status == 200) {
                    cache[ id_in ]=xhr.responseText;
                    resolve( xhr.responseText );
                }
            }
            xhr.open("GET", url , true);
            xhr.setRequestHeader('Content-type', 'text/html');
            xhr.send();     

            
        });
    };    

    this.loadTemplate=function(id) {
        return this.load(id)
        //return $.get('/x_modules/apps/' +id+'/'+ id + '.html');
    },



    */ 
});

//import regeneratorRuntime from "./web_modules/regenerator-runtime/runtime.js";
var $5e723104ebc15ec4$export$407448d2b89b1813 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $5e723104ebc15ec4$export$db3b6bfb95261072(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $5e723104ebc15ec4$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $5e723104ebc15ec4$export$39b482c5e57630a8(n) {
    return n && Object.prototype.hasOwnProperty.call(n, 'default') && Object.keys(n).length === 1 ? n['default'] : n;
}
function $5e723104ebc15ec4$var$commonjsRequire() {
    throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}


var $bd2fb69ec5c665ce$var$jquery = (0, $5e723104ebc15ec4$export$db3b6bfb95261072)(function(module) {
    /*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */ (function(global, factory) {
        // For CommonJS and CommonJS-like environments where a proper `window`
        // is present, execute the factory and get jQuery.
        // For environments that do not have a `window` with a `document`
        // (such as Node.js), expose a factory as module.exports.
        // This accentuates the need for the creation of a real `window`.
        // e.g. var jQuery = require("jquery")(window);
        // See ticket #14549 for more info.
        module.exports = global.document ? factory(global, true) : function(w) {
            if (!w.document) throw new Error("jQuery requires a window with a document");
            return factory(w);
        };
    // Pass this if window is not defined yet
    })(typeof window !== "undefined" ? window : (0, $5e723104ebc15ec4$export$407448d2b89b1813), function(window1, noGlobal) {
        var arr = [];
        var getProto = Object.getPrototypeOf;
        var slice = arr.slice;
        var flat = arr.flat ? function(array) {
            return arr.flat.call(array);
        } : function(array) {
            return arr.concat.apply([], array);
        };
        var push = arr.push;
        var indexOf = arr.indexOf;
        var class2type = {};
        var toString = class2type.toString;
        var hasOwn = class2type.hasOwnProperty;
        var fnToString = hasOwn.toString;
        var ObjectFunctionString = fnToString.call(Object);
        var support = {};
        var isFunction = function isFunction(obj) {
            // Support: Chrome <=57, Firefox <=52
            // In some browsers, typeof returns "function" for HTML <object> elements
            // (i.e., `typeof document.createElement( "object" ) === "function"`).
            // We don't want to classify *any* DOM node as a function.
            // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
            // Plus for old WebKit, typeof returns "function" for HTML collections
            // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
            return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
        };
        var isWindow = function isWindow(obj) {
            return obj != null && obj === obj.window;
        };
        var document = window1.document;
        var preservedScriptAttributes = {
            type: true,
            src: true,
            nonce: true,
            noModule: true
        };
        function DOMEval(code, node, doc) {
            doc = doc || document;
            var i, val, script = doc.createElement("script");
            script.text = code;
            if (node) for(i in preservedScriptAttributes){
                // Support: Firefox 64+, Edge 18+
                // Some browsers don't support the "nonce" property on scripts.
                // On the other hand, just using `getAttribute` is not enough as
                // the `nonce` attribute is reset to an empty string whenever it
                // becomes browsing-context connected.
                // See https://github.com/whatwg/html/issues/2369
                // See https://html.spec.whatwg.org/#nonce-attributes
                // The `node.getAttribute` check was added for the sake of
                // `jQuery.globalEval` so that it can fake a nonce-containing node
                // via an object.
                val = node[i] || node.getAttribute && node.getAttribute(i);
                if (val) script.setAttribute(i, val);
            }
            doc.head.appendChild(script).parentNode.removeChild(script);
        }
        function toType(obj) {
            if (obj == null) return obj + "";
            // Support: Android <=2.3 only (functionish RegExp)
            return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
        }
        /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
        // unguarded in another place, it seems safer to define global only for this module
        var version = "3.6.0", // Define a local copy of jQuery
        jQuery = function(selector, context) {
            // The jQuery object is actually just the init constructor 'enhanced'
            // Need init if jQuery is called (just allow error to be thrown if not included)
            return new jQuery.fn.init(selector, context);
        };
        jQuery.fn = jQuery.prototype = {
            // The current version of jQuery being used
            jquery: version,
            constructor: jQuery,
            // The default length of a jQuery object is 0
            length: 0,
            toArray: function() {
                return slice.call(this);
            },
            // Get the Nth element in the matched element set OR
            // Get the whole matched element set as a clean array
            get: function(num) {
                // Return all the elements in a clean array
                if (num == null) return slice.call(this);
                // Return just the one element from the set
                return num < 0 ? this[num + this.length] : this[num];
            },
            // Take an array of elements and push it onto the stack
            // (returning the new matched element set)
            pushStack: function(elems) {
                // Build a new jQuery matched element set
                var ret = jQuery.merge(this.constructor(), elems);
                // Add the old object onto the stack (as a reference)
                ret.prevObject = this;
                // Return the newly-formed element set
                return ret;
            },
            // Execute a callback for every element in the matched set.
            each: function(callback) {
                return jQuery.each(this, callback);
            },
            map: function(callback) {
                return this.pushStack(jQuery.map(this, function(elem, i) {
                    return callback.call(elem, i, elem);
                }));
            },
            slice: function() {
                return this.pushStack(slice.apply(this, arguments));
            },
            first: function() {
                return this.eq(0);
            },
            last: function() {
                return this.eq(-1);
            },
            even: function() {
                return this.pushStack(jQuery.grep(this, function(_elem, i) {
                    return (i + 1) % 2;
                }));
            },
            odd: function() {
                return this.pushStack(jQuery.grep(this, function(_elem, i) {
                    return i % 2;
                }));
            },
            eq: function(i) {
                var len = this.length, j = +i + (i < 0 ? len : 0);
                return this.pushStack(j >= 0 && j < len ? [
                    this[j]
                ] : []);
            },
            end: function() {
                return this.prevObject || this.constructor();
            },
            // For internal use only.
            // Behaves like an Array's method, not like a jQuery method.
            push: push,
            sort: arr.sort,
            splice: arr.splice
        };
        jQuery.extend = jQuery.fn.extend = function() {
            var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
            // Handle a deep copy situation
            if (typeof target === "boolean") {
                deep = target;
                // Skip the boolean and the target
                target = arguments[i] || {};
                i++;
            }
            // Handle case when target is a string or something (possible in deep copy)
            if (typeof target !== "object" && !isFunction(target)) target = {};
            // Extend jQuery itself if only one argument is passed
            if (i === length) {
                target = this;
                i--;
            }
            for(; i < length; i++){
                // Only deal with non-null/undefined values
                if ((options = arguments[i]) != null) // Extend the base object
                for(name in options){
                    copy = options[name];
                    // Prevent Object.prototype pollution
                    // Prevent never-ending loop
                    if (name === "__proto__" || target === copy) continue;
                    // Recurse if we're merging plain objects or arrays
                    if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                        src = target[name];
                        // Ensure proper type for the source value
                        if (copyIsArray && !Array.isArray(src)) clone = [];
                        else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                        else clone = src;
                        copyIsArray = false;
                        // Never move original objects, clone them
                        target[name] = jQuery.extend(deep, clone, copy);
                    // Don't bring in undefined values
                    } else if (copy !== undefined) target[name] = copy;
                }
            }
            // Return the modified object
            return target;
        };
        jQuery.extend({
            // Unique for each copy of jQuery on the page
            expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
            // Assume jQuery is ready without the ready module
            isReady: true,
            error: function(msg) {
                throw new Error(msg);
            },
            noop: function() {},
            isPlainObject: function(obj) {
                var proto, Ctor;
                // Detect obvious negatives
                // Use toString instead of jQuery.type to catch host objects
                if (!obj || toString.call(obj) !== "[object Object]") return false;
                proto = getProto(obj);
                // Objects with no prototype (e.g., `Object.create( null )`) are plain
                if (!proto) return true;
                // Objects with prototype are plain iff they were constructed by a global Object function
                Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
                return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
            },
            isEmptyObject: function(obj) {
                var name;
                for(name in obj)return false;
                return true;
            },
            // Evaluates a script in a provided context; falls back to the global one
            // if not specified.
            globalEval: function(code, options, doc) {
                DOMEval(code, {
                    nonce: options && options.nonce
                }, doc);
            },
            each: function(obj, callback) {
                var length, i = 0;
                if (isArrayLike(obj)) {
                    length = obj.length;
                    for(; i < length; i++){
                        if (callback.call(obj[i], i, obj[i]) === false) break;
                    }
                } else for(i in obj){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
                return obj;
            },
            // results is for internal usage only
            makeArray: function(arr, results) {
                var ret = results || [];
                if (arr != null) {
                    if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                        arr
                    ] : arr);
                    else push.call(ret, arr);
                }
                return ret;
            },
            inArray: function(elem, arr, i) {
                return arr == null ? -1 : indexOf.call(arr, elem, i);
            },
            // Support: Android <=4.0 only, PhantomJS 1 only
            // push.apply(_, arraylike) throws on ancient WebKit
            merge: function(first, second) {
                var len = +second.length, j = 0, i = first.length;
                for(; j < len; j++)first[i++] = second[j];
                first.length = i;
                return first;
            },
            grep: function(elems, callback, invert) {
                var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
                // Go through the array, only saving the items
                // that pass the validator function
                for(; i < length; i++){
                    callbackInverse = !callback(elems[i], i);
                    if (callbackInverse !== callbackExpect) matches.push(elems[i]);
                }
                return matches;
            },
            // arg is for internal usage only
            map: function(elems, callback, arg) {
                var length, value, i = 0, ret = [];
                // Go through the array, translating each of the items to their new values
                if (isArrayLike(elems)) {
                    length = elems.length;
                    for(; i < length; i++){
                        value = callback(elems[i], i, arg);
                        if (value != null) ret.push(value);
                    }
                // Go through every key on the object,
                } else for(i in elems){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
                // Flatten any nested arrays
                return flat(ret);
            },
            // A global GUID counter for objects
            guid: 1,
            // jQuery.support is not used in Core but other projects attach their
            // properties to it so it needs to exist.
            support: support
        });
        if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
        // Populate the class2type map
        jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
            class2type["[object " + name + "]"] = name.toLowerCase();
        });
        function isArrayLike(obj) {
            // Support: real iOS 8.2 only (not reproducible in simulator)
            // `in` check used to prevent JIT error (gh-2145)
            // hasOwn isn't used here due to false negatives
            // regarding Nodelist length in IE
            var length = !!obj && "length" in obj && obj.length, type = toType(obj);
            if (isFunction(obj) || isWindow(obj)) return false;
            return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
        }
        var Sizzle = /*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */ function(window1) {
            var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, // Local document vars
            setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, // Instance-specific data
            expando = "sizzle" + 1 * new Date(), preferredDoc = window1.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
                if (a === b) hasDuplicate = true;
                return 0;
            }, // Instance methods
            hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, pushNative = arr.push, push = arr.push, slice = arr.slice, // Use a stripped-down indexOf as it's faster than native
            // https://jsperf.com/thor-indexof-vs-for/5
            indexOf = function(list, elem) {
                var i = 0, len = list.length;
                for(; i < len; i++){
                    if (list[i] === elem) return i;
                }
                return -1;
            }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
            // http://www.w3.org/TR/css3-selectors/#whitespace
            whitespace = "[\\x20\\t\\r\\n\\f]", // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
            identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
            attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
            "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5]
            // or strings [capture 3 or capture 4]"
            "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
            // 1. quoted (capture 3; capture 4 or capture 5)
            "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
            "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
            ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
            rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
                "ID": new RegExp("^#(" + identifier + ")"),
                "CLASS": new RegExp("^\\.(" + identifier + ")"),
                "TAG": new RegExp("^(" + identifier + "|[*])"),
                "ATTR": new RegExp("^" + attributes),
                "PSEUDO": new RegExp("^" + pseudos),
                "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
                "bool": new RegExp("^(?:" + booleans + ")$", "i"),
                // For use in libraries implementing .is()
                // We use this for POS matching in `select`
                "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
            }, rhtml = /HTML$/i, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, // Easily-parseable/retrievable ID or TAG or CLASS selectors
            rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
            // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
            runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
                var high = "0x" + escape.slice(1) - 0x10000;
                return nonHex ? // Strip the backslash prefix from a non-hex escape sequence
                nonHex : // Replace a hexadecimal escape sequence with the encoded Unicode code point
                // Support: IE <=11+
                // For values outside the Basic Multilingual Plane (BMP), manually construct a
                // surrogate pair
                high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
            }, // CSS string/identifier serialization
            // https://drafts.csswg.org/cssom/#common-serializing-idioms
            rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, fcssescape = function(ch, asCodePoint) {
                if (asCodePoint) {
                    // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                    if (ch === "\0") return "\uFFFD";
                    // Control characters and (dependent upon position) numbers get escaped as code points
                    return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
                }
                // Other potentially-special ASCII characters get backslash-escaped
                return "\\" + ch;
            }, // Used for iframes
            // See setDocument()
            // Removing the function wrapper causes a "Permission Denied"
            // error in IE
            unloadHandler = function() {
                setDocument();
            }, inDisabledFieldset = addCombinator(function(elem) {
                return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
            }, {
                dir: "parentNode",
                next: "legend"
            });
            // Optimize for push.apply( _, NodeList )
            try {
                push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
                // Support: Android<4.0
                // Detect silently failing push.apply
                // eslint-disable-next-line no-unused-expressions
                arr[preferredDoc.childNodes.length].nodeType;
            } catch (e) {
                push = {
                    apply: arr.length ? // Leverage slice if possible
                    function(target, els) {
                        pushNative.apply(target, slice.call(els));
                    } : // Support: IE<9
                    // Otherwise append directly
                    function(target, els) {
                        var j = target.length, i = 0;
                        // Can't trust NodeList.length
                        while(target[j++] = els[i++]);
                        target.length = j - 1;
                    }
                };
            }
            function Sizzle(selector, context, results, seed) {
                var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
                nodeType = context ? context.nodeType : 9;
                results = results || [];
                // Return early from calls with invalid selector or context
                if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
                // Try to shortcut find operations (as opposed to filters) in HTML documents
                if (!seed) {
                    setDocument(context);
                    context = context || document;
                    if (documentIsHTML) {
                        // If the selector is sufficiently simple, try using a "get*By*" DOM method
                        // (excepting DocumentFragment context, where the methods don't exist)
                        if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                            // ID selector
                            if (m = match[1]) {
                                // Document context
                                if (nodeType === 9) {
                                    if (elem = context.getElementById(m)) // Support: IE, Opera, Webkit
                                    // TODO: identify versions
                                    // getElementById can match elements by name instead of ID
                                    {
                                        if (elem.id === m) {
                                            results.push(elem);
                                            return results;
                                        }
                                    } else return results;
                                // Element context
                                } else // Support: IE, Opera, Webkit
                                // TODO: identify versions
                                // getElementById can match elements by name instead of ID
                                if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                    results.push(elem);
                                    return results;
                                }
                            // Type selector
                            } else if (match[2]) {
                                push.apply(results, context.getElementsByTagName(selector));
                                return results;
                            // Class selector
                            } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                                push.apply(results, context.getElementsByClassName(m));
                                return results;
                            }
                        }
                        // Take advantage of querySelectorAll
                        if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && // Support: IE 8 only
                        // Exclude object elements
                        (nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
                            newSelector = selector;
                            newContext = context;
                            // qSA considers elements outside a scoping root when evaluating child or
                            // descendant combinators, which is not what we want.
                            // In such cases, we work around the behavior by prefixing every selector in the
                            // list with an ID selector referencing the scope context.
                            // The technique has to be used as well when a leading combinator is used
                            // as such selectors are not recognized by querySelectorAll.
                            // Thanks to Andrew Dupont for this technique.
                            if (nodeType === 1 && (rdescend.test(selector) || rcombinators.test(selector))) {
                                // Expand context for sibling selectors
                                newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                                // We can use :scope instead of the ID hack if the browser
                                // supports it & if we're not changing the context.
                                if (newContext !== context || !support.scope) {
                                    // Capture the context ID, setting it first if necessary
                                    if (nid = context.getAttribute("id")) nid = nid.replace(rcssescape, fcssescape);
                                    else context.setAttribute("id", nid = expando);
                                }
                                // Prefix every selector in the list
                                groups = tokenize(selector);
                                i = groups.length;
                                while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                                newSelector = groups.join(",");
                            }
                            try {
                                push.apply(results, newContext.querySelectorAll(newSelector));
                                return results;
                            } catch (qsaError) {
                                nonnativeSelectorCache(selector, true);
                            } finally{
                                if (nid === expando) context.removeAttribute("id");
                            }
                        }
                    }
                }
                // All others
                return select(selector.replace(rtrim, "$1"), context, results, seed);
            }
            /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
                var keys = [];
                function cache(key, value) {
                    // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                    if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                    delete cache[keys.shift()];
                    return cache[key + " "] = value;
                }
                return cache;
            }
            /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
                fn[expando] = true;
                return fn;
            }
            /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
                var el = document.createElement("fieldset");
                try {
                    return !!fn(el);
                } catch (e) {
                    return false;
                } finally{
                    // Remove from its parent by default
                    if (el.parentNode) el.parentNode.removeChild(el);
                    // release memory in IE
                    el = null;
                }
            }
            /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */ function addHandle(attrs, handler) {
                var arr = attrs.split("|"), i = arr.length;
                while(i--)Expr.attrHandle[arr[i]] = handler;
            }
            /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */ function siblingCheck(a, b) {
                var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
                // Use IE sourceIndex if available on both nodes
                if (diff) return diff;
                // Check if b follows a
                if (cur) while(cur = cur.nextSibling){
                    if (cur === b) return -1;
                }
                return a ? 1 : -1;
            }
            /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
                return function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === type;
                };
            }
            /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
                return function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return (name === "input" || name === "button") && elem.type === type;
                };
            }
            /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
                // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
                return function(elem) {
                    // Only certain elements can match :enabled or :disabled
                    // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                    // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                    if ("form" in elem) {
                        // Check for inherited disabledness on relevant non-disabled elements:
                        // * listed form-associated elements in a disabled fieldset
                        //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                        //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                        // * option elements in a disabled optgroup
                        //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                        // All such elements have a "form" property.
                        if (elem.parentNode && elem.disabled === false) {
                            // Option elements defer to a parent optgroup if present
                            if ("label" in elem) {
                                if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                                else return elem.disabled === disabled;
                            }
                            // Support: IE 6 - 11
                            // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                            return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                            /* jshint -W018 */ elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                        }
                        return elem.disabled === disabled;
                    // Try to winnow out elements that can't be disabled before trusting the disabled property.
                    // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                    // even exist on them, let alone have a boolean value.
                    } else if ("label" in elem) return elem.disabled === disabled;
                    // Remaining elements are neither :enabled nor :disabled
                    return false;
                };
            }
            /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
                return markFunction(function(argument) {
                    argument = +argument;
                    return markFunction(function(seed, matches) {
                        var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                        // Match elements found at the specified indexes
                        while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                    });
                });
            }
            /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
                return context && typeof context.getElementsByTagName !== "undefined" && context;
            }
            // Expose support vars for convenience
            support = Sizzle.support = {};
            /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */ isXML = Sizzle.isXML = function(elem) {
                var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
                // Support: IE <=8
                // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
                // https://bugs.jquery.com/ticket/4833
                return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
            };
            /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ setDocument = Sizzle.setDocument = function(node) {
                var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
                // Return early if doc is invalid or already selected
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
                // Update global variables
                document = doc;
                docElem = document.documentElement;
                documentIsHTML = !isXML(document);
                // Support: IE 9 - 11+, Edge 12 - 18+
                // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                    // Support: IE 11, Edge
                    if (subWindow.addEventListener) subWindow.addEventListener("unload", unloadHandler, false);
                    else if (subWindow.attachEvent) subWindow.attachEvent("onunload", unloadHandler);
                }
                // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
                // Safari 4 - 5 only, Opera <=11.6 - 12.x only
                // IE/Edge & older browsers don't support the :scope pseudo-class.
                // Support: Safari 6.0 only
                // Safari 6.0 supports :scope but it's an alias of :root there.
                support.scope = assert(function(el) {
                    docElem.appendChild(el).appendChild(document.createElement("div"));
                    return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
                });
                /* Attributes
	---------------------------------------------------------------------- */ // Support: IE<8
                // Verify that getAttribute really returns attributes and not properties
                // (excepting IE8 booleans)
                support.attributes = assert(function(el) {
                    el.className = "i";
                    return !el.getAttribute("className");
                });
                /* getElement(s)By*
	---------------------------------------------------------------------- */ // Check if getElementsByTagName("*") returns only elements
                support.getElementsByTagName = assert(function(el) {
                    el.appendChild(document.createComment(""));
                    return !el.getElementsByTagName("*").length;
                });
                // Support: IE<9
                support.getElementsByClassName = rnative.test(document.getElementsByClassName);
                // Support: IE<10
                // Check if getElementById returns elements by name
                // The broken getElementById methods don't pick up programmatically-set names,
                // so use a roundabout getElementsByName test
                support.getById = assert(function(el) {
                    docElem.appendChild(el).id = expando;
                    return !document.getElementsByName || !document.getElementsByName(expando).length;
                });
                // ID filter and find
                if (support.getById) {
                    Expr.filter["ID"] = function(id) {
                        var attrId = id.replace(runescape, funescape);
                        return function(elem) {
                            return elem.getAttribute("id") === attrId;
                        };
                    };
                    Expr.find["ID"] = function(id, context) {
                        if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                            var elem = context.getElementById(id);
                            return elem ? [
                                elem
                            ] : [];
                        }
                    };
                } else {
                    Expr.filter["ID"] = function(id) {
                        var attrId = id.replace(runescape, funescape);
                        return function(elem) {
                            var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                            return node && node.value === attrId;
                        };
                    };
                    // Support: IE 6 - 7 only
                    // getElementById is not reliable as a find shortcut
                    Expr.find["ID"] = function(id, context) {
                        if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                            var node, i, elems, elem = context.getElementById(id);
                            if (elem) {
                                // Verify the id attribute
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                                // Fall back on getElementsByName
                                elems = context.getElementsByName(id);
                                i = 0;
                                while(elem = elems[i++]){
                                    node = elem.getAttributeNode("id");
                                    if (node && node.value === id) return [
                                        elem
                                    ];
                                }
                            }
                            return [];
                        }
                    };
                }
                // Tag
                Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
                    if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                    else if (support.qsa) return context.querySelectorAll(tag);
                } : function(tag, context) {
                    var elem, tmp = [], i = 0, // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                    results = context.getElementsByTagName(tag);
                    // Filter out possible comments
                    if (tag === "*") {
                        while(elem = results[i++])if (elem.nodeType === 1) tmp.push(elem);
                        return tmp;
                    }
                    return results;
                };
                // Class
                Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
                    if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
                };
                /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
                // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
                rbuggyMatches = [];
                // qSa(:focus) reports false when true (Chrome 21)
                // We allow this because of a bug in IE8/9 that throws an error
                // whenever `document.activeElement` is accessed on an iframe
                // So, we allow :focus to pass through QSA all the time to avoid the IE error
                // See https://bugs.jquery.com/ticket/13378
                rbuggyQSA = [];
                if (support.qsa = rnative.test(document.querySelectorAll)) {
                    // Build QSA regex
                    // Regex strategy adopted from Diego Perini
                    assert(function(el) {
                        var input;
                        // Select is set to empty string on purpose
                        // This is to test IE's treatment of not explicitly
                        // setting a boolean content attribute,
                        // since its presence should be enough
                        // https://bugs.jquery.com/ticket/12359
                        docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                        // Support: IE8, Opera 11-12.16
                        // Nothing should be selected when empty strings follow ^= or $= or *=
                        // The test attribute must be unknown in Opera but "safe" for WinRT
                        // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                        if (el.querySelectorAll("[msallowcapture^='']").length) rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                        // Support: IE8
                        // Boolean attributes and "value" are not treated correctly
                        if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                        // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                        if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                        // Support: IE 11+, Edge 15 - 18+
                        // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                        // Adding a temporary attribute to the document before the selection works
                        // around the issue.
                        // Interestingly, IE 10 & older don't seem to have the issue.
                        input = document.createElement("input");
                        input.setAttribute("name", "");
                        el.appendChild(input);
                        if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
                        // Webkit/Opera - :checked should return selected option elements
                        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                        // IE8 throws error here and will not see later tests
                        if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                        // Support: Safari 8+, iOS 8+
                        // https://bugs.webkit.org/show_bug.cgi?id=136851
                        // In-page `selector#id sibling-combinator selector` fails
                        if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                        // Support: Firefox <=3.6 - 5 only
                        // Old Firefox doesn't throw on a badly-escaped identifier.
                        el.querySelectorAll("\\\f");
                        rbuggyQSA.push("[\\r\\n\\f]");
                    });
                    assert(function(el) {
                        el.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                        // Support: Windows 8 Native Apps
                        // The type and name attributes are restricted during .innerHTML assignment
                        var input = document.createElement("input");
                        input.setAttribute("type", "hidden");
                        el.appendChild(input).setAttribute("name", "D");
                        // Support: IE8
                        // Enforce case-sensitivity of name attribute
                        if (el.querySelectorAll("[name=d]").length) rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                        // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                        // IE8 throws error here and will not see later tests
                        if (el.querySelectorAll(":enabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                        // Support: IE9-11+
                        // IE's :disabled selector does not pick up the children of disabled fieldsets
                        docElem.appendChild(el).disabled = true;
                        if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                        // Support: Opera 10 - 11 only
                        // Opera 10-11 does not throw on post-comma invalid pseudos
                        el.querySelectorAll("*,:x");
                        rbuggyQSA.push(",.*:");
                    });
                }
                if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) assert(function(el) {
                    // Check to see if it's possible to do matchesSelector
                    // on a disconnected node (IE 9)
                    support.disconnectedMatch = matches.call(el, "*");
                    // This should fail with an exception
                    // Gecko does not error, returns false instead
                    matches.call(el, "[s!='']:x");
                    rbuggyMatches.push("!=", pseudos);
                });
                rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
                rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
                /* Contains
	---------------------------------------------------------------------- */ hasCompare = rnative.test(docElem.compareDocumentPosition);
                // Element contains another
                // Purposefully self-exclusive
                // As in, an element does not contain itself
                contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
                    var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
                    return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
                } : function(a, b) {
                    if (b) while(b = b.parentNode){
                        if (b === a) return true;
                    }
                    return false;
                };
                /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
                sortOrder = hasCompare ? function(a, b) {
                    // Flag for duplicate removal
                    if (a === b) {
                        hasDuplicate = true;
                        return 0;
                    }
                    // Sort on method existence if only one input has compareDocumentPosition
                    var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                    if (compare) return compare;
                    // Calculate position if both inputs belong to the same document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                    1;
                    // Disconnected nodes
                    if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                        // Choose the first element that is related to our preferred document
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) return -1;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) return 1;
                        // Maintain original order
                        return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                    }
                    return compare & 4 ? -1 : 1;
                } : function(a, b) {
                    // Exit early if the nodes are identical
                    if (a === b) {
                        hasDuplicate = true;
                        return 0;
                    }
                    var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [
                        a
                    ], bp = [
                        b
                    ];
                    // Parentless nodes are either documents or disconnected
                    if (!aup || !bup) // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    /* eslint-disable eqeqeq */ return a == document ? -1 : b == document ? 1 : /* eslint-enable eqeqeq */ aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                    else if (aup === bup) return siblingCheck(a, b);
                    // Otherwise we need full lists of their ancestors for comparison
                    cur = a;
                    while(cur = cur.parentNode)ap.unshift(cur);
                    cur = b;
                    while(cur = cur.parentNode)bp.unshift(cur);
                    // Walk down the tree looking for a discrepancy
                    while(ap[i] === bp[i])i++;
                    return i ? // Do a sibling check if the nodes have a common ancestor
                    siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    /* eslint-disable eqeqeq */ ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 : /* eslint-enable eqeqeq */ 0;
                };
                return document;
            };
            Sizzle.matches = function(expr, elements) {
                return Sizzle(expr, null, null, elements);
            };
            Sizzle.matchesSelector = function(elem, expr) {
                setDocument(elem);
                if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                    var ret = matches.call(elem, expr);
                    // IE 9's matchesSelector returns false on disconnected nodes
                    if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                    // fragment in IE 9
                    elem.document && elem.document.nodeType !== 11) return ret;
                } catch (e) {
                    nonnativeSelectorCache(expr, true);
                }
                return Sizzle(expr, document, null, [
                    elem
                ]).length > 0;
            };
            Sizzle.contains = function(context, elem) {
                // Set document vars if needed
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if ((context.ownerDocument || context) != document) setDocument(context);
                return contains(context, elem);
            };
            Sizzle.attr = function(elem, name) {
                // Set document vars if needed
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if ((elem.ownerDocument || elem) != document) setDocument(elem);
                var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (jQuery #13807)
                val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
                return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
            };
            Sizzle.escape = function(sel) {
                return (sel + "").replace(rcssescape, fcssescape);
            };
            Sizzle.error = function(msg) {
                throw new Error("Syntax error, unrecognized expression: " + msg);
            };
            /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ Sizzle.uniqueSort = function(results) {
                var elem, duplicates = [], j = 0, i = 0;
                // Unless we *know* we can detect duplicates, assume their presence
                hasDuplicate = !support.detectDuplicates;
                sortInput = !support.sortStable && results.slice(0);
                results.sort(sortOrder);
                if (hasDuplicate) {
                    while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                    while(j--)results.splice(duplicates[j], 1);
                }
                // Clear input after sorting to release objects
                // See https://github.com/jquery/sizzle/pull/225
                sortInput = null;
                return results;
            };
            /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */ getText = Sizzle.getText = function(elem) {
                var node, ret = "", i = 0, nodeType = elem.nodeType;
                if (!nodeType) // If no nodeType, this is expected to be an array
                while(node = elem[i++])// Do not traverse comment nodes
                ret += getText(node);
                else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                    // Use textContent for elements
                    // innerText usage removed for consistency of new lines (jQuery #11153)
                    if (typeof elem.textContent === "string") return elem.textContent;
                    else // Traverse its children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling)ret += getText(elem);
                } else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
                // Do not include comment or processing instruction nodes
                return ret;
            };
            Expr = Sizzle.selectors = {
                // Can be adjusted by the user
                cacheLength: 50,
                createPseudo: markFunction,
                match: matchExpr,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: true
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: true
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    "ATTR": function(match) {
                        match[1] = match[1].replace(runescape, funescape);
                        // Move the given value to match[3] whether quoted or unquoted
                        match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                        if (match[2] === "~=") match[3] = " " + match[3] + " ";
                        return match.slice(0, 4);
                    },
                    "CHILD": function(match) {
                        /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                        if (match[1].slice(0, 3) === "nth") {
                            // nth-* requires argument
                            if (!match[3]) Sizzle.error(match[0]);
                            // numeric x and y parameters for Expr.filter.CHILD
                            // remember that false/true cast respectively to 0/1
                            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                            match[5] = +(match[7] + match[8] || match[3] === "odd");
                        // other types prohibit arguments
                        } else if (match[3]) Sizzle.error(match[0]);
                        return match;
                    },
                    "PSEUDO": function(match) {
                        var excess, unquoted = !match[6] && match[2];
                        if (matchExpr["CHILD"].test(match[0])) return null;
                        // Accept quoted arguments as-is
                        if (match[3]) match[2] = match[4] || match[5] || "";
                        else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                        (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                        (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                            // excess is a negative index
                            match[0] = match[0].slice(0, excess);
                            match[2] = unquoted.slice(0, excess);
                        }
                        // Return only captures needed by the pseudo filter method (type and argument)
                        return match.slice(0, 3);
                    }
                },
                filter: {
                    "TAG": function(nodeNameSelector) {
                        var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                        return nodeNameSelector === "*" ? function() {
                            return true;
                        } : function(elem) {
                            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                        };
                    },
                    "CLASS": function(className) {
                        var pattern = classCache[className + " "];
                        return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                            return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                        }));
                    },
                    "ATTR": function(name, operator, check) {
                        return function(elem) {
                            var result = Sizzle.attr(elem, name);
                            if (result == null) return operator === "!=";
                            if (!operator) return true;
                            result += "";
                            /* eslint-disable max-len */ return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                        /* eslint-enable max-len */ };
                    },
                    "CHILD": function(type, what, _argument, first, last) {
                        var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                        return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                        function(elem) {
                            return !!elem.parentNode;
                        } : function(elem, _context, xml) {
                            var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                            if (parent) {
                                // :(first|last|only)-(child|of-type)
                                if (simple) {
                                    while(dir){
                                        node = elem;
                                        while(node = node[dir]){
                                            if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) return false;
                                        }
                                        // Reverse direction for :only-* (if we haven't yet done so)
                                        start = dir = type === "only" && !start && "nextSibling";
                                    }
                                    return true;
                                }
                                start = [
                                    forward ? parent.firstChild : parent.lastChild
                                ];
                                // non-xml :nth-child(...) stores cache data on `parent`
                                if (forward && useCache) {
                                    // Seek `elem` from a previously-cached index
                                    // ...in a gzip-friendly way
                                    node = parent;
                                    outerCache = node[expando] || (node[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                    cache = uniqueCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex && cache[2];
                                    node = nodeIndex && parent.childNodes[nodeIndex];
                                    while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                    (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                    if (node.nodeType === 1 && ++diff && node === elem) {
                                        uniqueCache[type] = [
                                            dirruns,
                                            nodeIndex,
                                            diff
                                        ];
                                        break;
                                    }
                                } else {
                                    // Use previously-cached element index if available
                                    if (useCache) {
                                        // ...in a gzip-friendly way
                                        node = elem;
                                        outerCache = node[expando] || (node[expando] = {});
                                        // Support: IE <9 only
                                        // Defend against cloned attroperties (jQuery gh-1709)
                                        uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                        cache = uniqueCache[type] || [];
                                        nodeIndex = cache[0] === dirruns && cache[1];
                                        diff = nodeIndex;
                                    }
                                    // xml :nth-child(...)
                                    // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                    if (diff === false) {
                                        // Use the same loop as above to seek `elem` from the start
                                        while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                            // Cache the index of each encountered element
                                            if (useCache) {
                                                outerCache = node[expando] || (node[expando] = {});
                                                // Support: IE <9 only
                                                // Defend against cloned attroperties (jQuery gh-1709)
                                                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                                uniqueCache[type] = [
                                                    dirruns,
                                                    diff
                                                ];
                                            }
                                            if (node === elem) break;
                                        }
                                    }
                                }
                                // Incorporate the offset, then check against cycle size
                                diff -= last;
                                return diff === first || diff % first === 0 && diff / first >= 0;
                            }
                        };
                    },
                    "PSEUDO": function(pseudo, argument) {
                        // pseudo-class names are case-insensitive
                        // http://www.w3.org/TR/selectors/#pseudo-classes
                        // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                        // Remember that setFilters inherits from pseudos
                        var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                        // The user may use createPseudo to indicate that
                        // arguments are needed to create the filter function
                        // just as Sizzle does
                        if (fn[expando]) return fn(argument);
                        // But maintain support for old signatures
                        if (fn.length > 1) {
                            args = [
                                pseudo,
                                pseudo,
                                "",
                                argument
                            ];
                            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                                var idx, matched = fn(seed, argument), i = matched.length;
                                while(i--){
                                    idx = indexOf(seed, matched[i]);
                                    seed[idx] = !(matches[idx] = matched[i]);
                                }
                            }) : function(elem) {
                                return fn(elem, 0, args);
                            };
                        }
                        return fn;
                    }
                },
                pseudos: {
                    // Potentially complex pseudos
                    "not": markFunction(function(selector) {
                        // Trim the selector passed to compile
                        // to avoid treating leading and trailing
                        // spaces as combinators
                        var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                        return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                            var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                            // Match elements unmatched by `matcher`
                            while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                        }) : function(elem, _context, xml) {
                            input[0] = elem;
                            matcher(input, null, xml, results);
                            // Don't keep the element (issue #299)
                            input[0] = null;
                            return !results.pop();
                        };
                    }),
                    "has": markFunction(function(selector) {
                        return function(elem) {
                            return Sizzle(selector, elem).length > 0;
                        };
                    }),
                    "contains": markFunction(function(text) {
                        text = text.replace(runescape, funescape);
                        return function(elem) {
                            return (elem.textContent || getText(elem)).indexOf(text) > -1;
                        };
                    }),
                    // "Whether an element is represented by a :lang() selector
                    // is based solely on the element's language value
                    // being equal to the identifier C,
                    // or beginning with the identifier C immediately followed by "-".
                    // The matching of C against the element's language value is performed case-insensitively.
                    // The identifier C does not have to be a valid language name."
                    // http://www.w3.org/TR/selectors/#lang-pseudo
                    "lang": markFunction(function(lang) {
                        // lang value must be a valid identifier
                        if (!ridentifier.test(lang || "")) Sizzle.error("unsupported lang: " + lang);
                        lang = lang.replace(runescape, funescape).toLowerCase();
                        return function(elem) {
                            var elemLang;
                            do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                                elemLang = elemLang.toLowerCase();
                                return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                            }
                            while ((elem = elem.parentNode) && elem.nodeType === 1);
                            return false;
                        };
                    }),
                    // Miscellaneous
                    "target": function(elem) {
                        var hash = window1.location && window1.location.hash;
                        return hash && hash.slice(1) === elem.id;
                    },
                    "root": function(elem) {
                        return elem === docElem;
                    },
                    "focus": function(elem) {
                        return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                    },
                    // Boolean properties
                    "enabled": createDisabledPseudo(false),
                    "disabled": createDisabledPseudo(true),
                    "checked": function(elem) {
                        // In CSS3, :checked should return both checked and selected elements
                        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                        var nodeName = elem.nodeName.toLowerCase();
                        return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
                    },
                    "selected": function(elem) {
                        // Accessing this property makes selected-by-default
                        // options in Safari work properly
                        if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                        elem.parentNode.selectedIndex;
                        return elem.selected === true;
                    },
                    // Contents
                    "empty": function(elem) {
                        // http://www.w3.org/TR/selectors/#empty-pseudo
                        // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                        //   but not by others (comment: 8; processing instruction: 7; etc.)
                        // nodeType < 6 works because attributes (2) do not appear as children
                        for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                            if (elem.nodeType < 6) return false;
                        }
                        return true;
                    },
                    "parent": function(elem) {
                        return !Expr.pseudos["empty"](elem);
                    },
                    // Element/input types
                    "header": function(elem) {
                        return rheader.test(elem.nodeName);
                    },
                    "input": function(elem) {
                        return rinputs.test(elem.nodeName);
                    },
                    "button": function(elem) {
                        var name = elem.nodeName.toLowerCase();
                        return name === "input" && elem.type === "button" || name === "button";
                    },
                    "text": function(elem) {
                        var attr;
                        return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE<8
                        // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                        ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                    },
                    // Position-in-collection
                    "first": createPositionalPseudo(function() {
                        return [
                            0
                        ];
                    }),
                    "last": createPositionalPseudo(function(_matchIndexes, length) {
                        return [
                            length - 1
                        ];
                    }),
                    "eq": createPositionalPseudo(function(_matchIndexes, length, argument) {
                        return [
                            argument < 0 ? argument + length : argument
                        ];
                    }),
                    "even": createPositionalPseudo(function(matchIndexes, length) {
                        var i = 0;
                        for(; i < length; i += 2)matchIndexes.push(i);
                        return matchIndexes;
                    }),
                    "odd": createPositionalPseudo(function(matchIndexes, length) {
                        var i = 1;
                        for(; i < length; i += 2)matchIndexes.push(i);
                        return matchIndexes;
                    }),
                    "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                        var i = argument < 0 ? argument + length : argument > length ? length : argument;
                        for(; --i >= 0;)matchIndexes.push(i);
                        return matchIndexes;
                    }),
                    "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                        var i = argument < 0 ? argument + length : argument;
                        for(; ++i < length;)matchIndexes.push(i);
                        return matchIndexes;
                    })
                }
            };
            Expr.pseudos["nth"] = Expr.pseudos["eq"];
            // Add button/input type pseudos
            for(i in {
                radio: true,
                checkbox: true,
                file: true,
                password: true,
                image: true
            })Expr.pseudos[i] = createInputPseudo(i);
            for(i in {
                submit: true,
                reset: true
            })Expr.pseudos[i] = createButtonPseudo(i);
            // Easy API for creating new setFilters
            function setFilters() {}
            setFilters.prototype = Expr.filters = Expr.pseudos;
            Expr.setFilters = new setFilters();
            tokenize = Sizzle.tokenize = function(selector, parseOnly) {
                var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
                if (cached) return parseOnly ? 0 : cached.slice(0);
                soFar = selector;
                groups = [];
                preFilters = Expr.preFilter;
                while(soFar){
                    // Comma and first run
                    if (!matched || (match = rcomma.exec(soFar))) {
                        if (match) // Don't consume trailing commas as valid
                        soFar = soFar.slice(match[0].length) || soFar;
                        groups.push(tokens = []);
                    }
                    matched = false;
                    // Combinators
                    if (match = rcombinators.exec(soFar)) {
                        matched = match.shift();
                        tokens.push({
                            value: matched,
                            // Cast descendant combinators to space
                            type: match[0].replace(rtrim, " ")
                        });
                        soFar = soFar.slice(matched.length);
                    }
                    // Filters
                    for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                        matched = match.shift();
                        tokens.push({
                            value: matched,
                            type: type,
                            matches: match
                        });
                        soFar = soFar.slice(matched.length);
                    }
                    if (!matched) break;
                }
                // Return the length of the invalid excess
                // if we're just parsing
                // Otherwise, throw an error or return tokens
                return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
                tokenCache(selector, groups).slice(0);
            };
            function toSelector(tokens) {
                var i = 0, len = tokens.length, selector = "";
                for(; i < len; i++)selector += tokens[i].value;
                return selector;
            }
            function addCombinator(matcher, combinator, base) {
                var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
                return combinator.first ? // Check against closest ancestor/preceding element
                function(elem, context, xml) {
                    while(elem = elem[dir]){
                        if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                    }
                    return false;
                } : // Check against all ancestor/preceding elements
                function(elem, context, xml) {
                    var oldCache, uniqueCache, outerCache, newCache = [
                        dirruns,
                        doneName
                    ];
                    // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                    if (xml) {
                        while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                            if (matcher(elem, context, xml)) return true;
                        }
                    } else {
                        while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                            outerCache = elem[expando] || (elem[expando] = {});
                            // Support: IE <9 only
                            // Defend against cloned attroperties (jQuery gh-1709)
                            uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                            if (skip && skip === elem.nodeName.toLowerCase()) elem = elem[dir] || elem;
                            else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                            return newCache[2] = oldCache[2];
                            else {
                                // Reuse newcache so results back-propagate to previous elements
                                uniqueCache[key] = newCache;
                                // A match means we're done; a fail means we have to keep checking
                                if (newCache[2] = matcher(elem, context, xml)) return true;
                            }
                        }
                    }
                    return false;
                };
            }
            function elementMatcher(matchers) {
                return matchers.length > 1 ? function(elem, context, xml) {
                    var i = matchers.length;
                    while(i--){
                        if (!matchers[i](elem, context, xml)) return false;
                    }
                    return true;
                } : matchers[0];
            }
            function multipleContexts(selector, contexts, results) {
                var i = 0, len = contexts.length;
                for(; i < len; i++)Sizzle(selector, contexts[i], results);
                return results;
            }
            function condense(unmatched, map, filter, context, xml) {
                var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
                for(; i < len; i++){
                    if (elem = unmatched[i]) {
                        if (!filter || filter(elem, context, xml)) {
                            newUnmatched.push(elem);
                            if (mapped) map.push(i);
                        }
                    }
                }
                return newUnmatched;
            }
            function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
                if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
                if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
                return markFunction(function(seed, results, context, xml) {
                    var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                    elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                        context
                    ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                    matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                    postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results : matcherIn;
                    // Find primary matches
                    if (matcher) matcher(matcherIn, matcherOut, context, xml);
                    // Apply postFilter
                    if (postFilter) {
                        temp = condense(matcherOut, postMap);
                        postFilter(temp, [], context, xml);
                        // Un-match failing elements by moving them back to matcherIn
                        i = temp.length;
                        while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                    }
                    if (seed) {
                        if (postFinder || preFilter) {
                            if (postFinder) {
                                // Get the final matcherOut by condensing this intermediate into postFinder contexts
                                temp = [];
                                i = matcherOut.length;
                                while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                                temp.push(matcherIn[i] = elem);
                                postFinder(null, matcherOut = [], temp, xml);
                            }
                            // Move matched elements from seed to results to keep them synchronized
                            i = matcherOut.length;
                            while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                        }
                    } else {
                        matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                        if (postFinder) postFinder(null, results, matcherOut, xml);
                        else push.apply(results, matcherOut);
                    }
                });
            }
            function matcherFromTokens(tokens) {
                var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
                matchContext = addCombinator(function(elem) {
                    return elem === checkContext;
                }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                    return indexOf(checkContext, elem) > -1;
                }, implicitRelative, true), matchers = [
                    function(elem, context, xml) {
                        var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                        // Avoid hanging onto element (issue #299)
                        checkContext = null;
                        return ret;
                    }
                ];
                for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                    addCombinator(elementMatcher(matchers), matcher)
                ];
                else {
                    matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                    // Return special upon seeing a positional matcher
                    if (matcher[expando]) {
                        // Find the next relative operator (if any) for proper handling
                        j = ++i;
                        for(; j < len; j++){
                            if (Expr.relative[tokens[j].type]) break;
                        }
                        return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                        tokens.slice(0, i - 1).concat({
                            value: tokens[i - 2].type === " " ? "*" : ""
                        })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                    }
                    matchers.push(matcher);
                }
                return elementMatcher(matchers);
            }
            function matcherFromGroupMatchers(elementMatchers, setMatchers) {
                var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                    var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                    elems = seed || byElement && Expr.find["TAG"]("*", outermost), // Use integer dirruns iff this is the outermost matcher
                    dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                    if (outermost) // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    outermostContext = context == document || context || outermost;
                    // Add elements passing elementMatchers directly to results
                    // Support: IE<9, Safari
                    // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                    for(; i !== len && (elem = elems[i]) != null; i++){
                        if (byElement && elem) {
                            j = 0;
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                            // two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (!context && elem.ownerDocument != document) {
                                setDocument(elem);
                                xml = !documentIsHTML;
                            }
                            while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                                results.push(elem);
                                break;
                            }
                            if (outermost) dirruns = dirrunsUnique;
                        }
                        // Track unmatched elements for set filters
                        if (bySet) {
                            // They will have gone through all possible matchers
                            if (elem = !matcher && elem) matchedCount--;
                            // Lengthen the array for every element, matched or not
                            if (seed) unmatched.push(elem);
                        }
                    }
                    // `i` is now the count of elements visited above, and adding it to `matchedCount`
                    // makes the latter nonnegative.
                    matchedCount += i;
                    // Apply set filters to unmatched elements
                    // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                    // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                    // no element matchers and no seed.
                    // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                    // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                    // numerically zero.
                    if (bySet && i !== matchedCount) {
                        j = 0;
                        while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                        if (seed) {
                            // Reintegrate element matches to eliminate the need for sorting
                            if (matchedCount > 0) {
                                while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                            }
                            // Discard index placeholder values to get only actual matches
                            setMatched = condense(setMatched);
                        }
                        // Add matches to results
                        push.apply(results, setMatched);
                        // Seedless set matches succeeding multiple successful matchers stipulate sorting
                        if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) Sizzle.uniqueSort(results);
                    }
                    // Override manipulation of globals by nested matchers
                    if (outermost) {
                        dirruns = dirrunsUnique;
                        outermostContext = contextBackup;
                    }
                    return unmatched;
                };
                return bySet ? markFunction(superMatcher) : superMatcher;
            }
            compile = Sizzle.compile = function(selector, match /* Internal Use Only */ ) {
                var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
                if (!cached) {
                    // Generate a function of recursive functions that can be used to check each element
                    if (!match) match = tokenize(selector);
                    i = match.length;
                    while(i--){
                        cached = matcherFromTokens(match[i]);
                        if (cached[expando]) setMatchers.push(cached);
                        else elementMatchers.push(cached);
                    }
                    // Cache the compiled function
                    cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                    // Save selector and tokenization
                    cached.selector = selector;
                }
                return cached;
            };
            /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ select = Sizzle.select = function(selector, context, results, seed) {
                var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
                results = results || [];
                // Try to minimize operations if there is only one selector in the list and no seed
                // (the latter of which guarantees us context)
                if (match.length === 1) {
                    // Reduce context if the leading compound selector is an ID
                    tokens = match[0] = match[0].slice(0);
                    if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                        context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                        if (!context) return results;
                        else if (compiled) context = context.parentNode;
                        selector = selector.slice(tokens.shift().value.length);
                    }
                    // Fetch a seed set for right-to-left matching
                    i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                    while(i--){
                        token = tokens[i];
                        // Abort if we hit a combinator
                        if (Expr.relative[type = token.type]) break;
                        if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                        {
                            if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                                // If seed is empty or no tokens remain, we can return early
                                tokens.splice(i, 1);
                                selector = seed.length && toSelector(tokens);
                                if (!selector) {
                                    push.apply(results, seed);
                                    return results;
                                }
                                break;
                            }
                        }
                    }
                }
                // Compile and execute a filtering function if one is not provided
                // Provide `match` to avoid retokenization if we modified the selector above
                (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
                return results;
            };
            // One-time assignments
            // Sort stability
            support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
            // Support: Chrome 14-35+
            // Always assume duplicates if they aren't passed to the comparison function
            support.detectDuplicates = !!hasDuplicate;
            // Initialize against the default document
            setDocument();
            // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
            // Detached nodes confoundingly follow *each other*
            support.sortDetached = assert(function(el) {
                // Should return 1, but returns 4 (following)
                return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
            });
            // Support: IE<8
            // Prevent attribute/property "interpolation"
            // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
            if (!assert(function(el) {
                el.innerHTML = "<a href='#'></a>";
                return el.firstChild.getAttribute("href") === "#";
            })) addHandle("type|href|height|width", function(elem, name, isXML) {
                if (!isXML) return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
            });
            // Support: IE<9
            // Use defaultValue in place of getAttribute("value")
            if (!support.attributes || !assert(function(el) {
                el.innerHTML = "<input/>";
                el.firstChild.setAttribute("value", "");
                return el.firstChild.getAttribute("value") === "";
            })) addHandle("value", function(elem, _name, isXML) {
                if (!isXML && elem.nodeName.toLowerCase() === "input") return elem.defaultValue;
            });
            // Support: IE<9
            // Use getAttributeNode to fetch booleans when getAttribute lies
            if (!assert(function(el) {
                return el.getAttribute("disabled") == null;
            })) addHandle(booleans, function(elem, name, isXML) {
                var val;
                if (!isXML) return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
            });
            return Sizzle;
        }(window1);
        jQuery.find = Sizzle;
        jQuery.expr = Sizzle.selectors;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
        jQuery.text = Sizzle.getText;
        jQuery.isXMLDoc = Sizzle.isXML;
        jQuery.contains = Sizzle.contains;
        jQuery.escapeSelector = Sizzle.escape;
        var dir = function(elem, dir, until) {
            var matched = [], truncate = until !== undefined;
            while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
                if (truncate && jQuery(elem).is(until)) break;
                matched.push(elem);
            }
            return matched;
        };
        var siblings = function(n, elem) {
            var matched = [];
            for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
            return matched;
        };
        var rneedsContext = jQuery.expr.match.needsContext;
        function nodeName(elem, name) {
            return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
        }
        var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
        // Implement the identical functionality for filter and not
        function winnow(elements, qualifier, not) {
            if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
                return !!qualifier.call(elem, i, elem) !== not;
            });
            // Single element
            if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
                return elem === qualifier !== not;
            });
            // Arraylike of elements (jQuery, arguments, Array)
            if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
                return indexOf.call(qualifier, elem) > -1 !== not;
            });
            // Filtered directly for both simple and complex selectors
            return jQuery.filter(qualifier, elements, not);
        }
        jQuery.filter = function(expr, elems, not) {
            var elem = elems[0];
            if (not) expr = ":not(" + expr + ")";
            if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
                elem
            ] : [];
            return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
                return elem.nodeType === 1;
            }));
        };
        jQuery.fn.extend({
            find: function(selector) {
                var i, ret, len = this.length, self = this;
                if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                    for(i = 0; i < len; i++){
                        if (jQuery.contains(self[i], this)) return true;
                    }
                }));
                ret = this.pushStack([]);
                for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
                return len > 1 ? jQuery.uniqueSort(ret) : ret;
            },
            filter: function(selector) {
                return this.pushStack(winnow(this, selector || [], false));
            },
            not: function(selector) {
                return this.pushStack(winnow(this, selector || [], true));
            },
            is: function(selector) {
                return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
                // so $("p:first").is("p:last") won't return true for a doc with two "p".
                typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
            }
        });
        // Initialize a jQuery object
        // A central reference to the root jQuery(document)
        var rootjQuery, // A simple way to check for HTML strings
        // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
        // Strict HTML recognition (#11290: must start with <)
        // Shortcut simple #id case for speed
        rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
            var match, elem;
            // HANDLE: $(""), $(null), $(undefined), $(false)
            if (!selector) return this;
            // Method init() accepts an alternate rootjQuery
            // so migrate can support jQuery.sub (gh-2101)
            root = root || rootjQuery;
            // Handle HTML strings
            if (typeof selector === "string") {
                if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
                match = [
                    null,
                    selector,
                    null
                ];
                else match = rquickExpr.exec(selector);
                // Match html or make sure no context is specified for #id
                if (match && (match[1] || !context)) {
                    // HANDLE: $(html) -> $(array)
                    if (match[1]) {
                        context = context instanceof jQuery ? context[0] : context;
                        // Option to run scripts is true for back-compat
                        // Intentionally let the error be thrown if parseHTML is not present
                        jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                        // HANDLE: $(html, props)
                        if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                            for(match in context)// Properties of context are called as methods if possible
                            if (isFunction(this[match])) this[match](context[match]);
                            else this.attr(match, context[match]);
                        }
                        return this;
                    // HANDLE: $(#id)
                    } else {
                        elem = document.getElementById(match[2]);
                        if (elem) {
                            // Inject the element directly into the jQuery object
                            this[0] = elem;
                            this.length = 1;
                        }
                        return this;
                    }
                } else if (!context || context.jquery) return (context || root).find(selector);
                else return this.constructor(context).find(selector);
            // HANDLE: $(DOMElement)
            } else if (selector.nodeType) {
                this[0] = selector;
                this.length = 1;
                return this;
            // HANDLE: $(function)
            // Shortcut for document ready
            } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
            selector(jQuery);
            return jQuery.makeArray(selector, this);
        };
        // Give the init function the jQuery prototype for later instantiation
        init.prototype = jQuery.fn;
        // Initialize central reference
        rootjQuery = jQuery(document);
        var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
        guaranteedUnique = {
            children: true,
            contents: true,
            next: true,
            prev: true
        };
        jQuery.fn.extend({
            has: function(target) {
                var targets = jQuery(target, this), l = targets.length;
                return this.filter(function() {
                    var i = 0;
                    for(; i < l; i++){
                        if (jQuery.contains(this, targets[i])) return true;
                    }
                });
            },
            closest: function(selectors, context) {
                var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
                // Positional selectors never match, since there's no _selection_ context
                if (!rneedsContext.test(selectors)) for(; i < l; i++){
                    for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                    if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to Sizzle
                    cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                        matched.push(cur);
                        break;
                    }
                }
                return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
            },
            // Determine the position of an element within the set
            index: function(elem) {
                // No argument, return index in parent
                if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
                // Index in selector
                if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
                // Locate the position of the desired element
                return indexOf.call(this, // If it receives a jQuery object, the first element is used
                elem.jquery ? elem[0] : elem);
            },
            add: function(selector, context) {
                return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
            },
            addBack: function(selector) {
                return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
            }
        });
        function sibling(cur, dir) {
            while((cur = cur[dir]) && cur.nodeType !== 1);
            return cur;
        }
        jQuery.each({
            parent: function(elem) {
                var parent = elem.parentNode;
                return parent && parent.nodeType !== 11 ? parent : null;
            },
            parents: function(elem) {
                return dir(elem, "parentNode");
            },
            parentsUntil: function(elem, _i, until) {
                return dir(elem, "parentNode", until);
            },
            next: function(elem) {
                return sibling(elem, "nextSibling");
            },
            prev: function(elem) {
                return sibling(elem, "previousSibling");
            },
            nextAll: function(elem) {
                return dir(elem, "nextSibling");
            },
            prevAll: function(elem) {
                return dir(elem, "previousSibling");
            },
            nextUntil: function(elem, _i, until) {
                return dir(elem, "nextSibling", until);
            },
            prevUntil: function(elem, _i, until) {
                return dir(elem, "previousSibling", until);
            },
            siblings: function(elem) {
                return siblings((elem.parentNode || {}).firstChild, elem);
            },
            children: function(elem) {
                return siblings(elem.firstChild);
            },
            contents: function(elem) {
                if (elem.contentDocument != null && // Support: IE 11+
                // <object> elements with no `data` attribute has an object
                // `contentDocument` with a `null` prototype.
                getProto(elem.contentDocument)) return elem.contentDocument;
                // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
                // Treat the template element as a regular one in browsers that
                // don't support it.
                if (nodeName(elem, "template")) elem = elem.content || elem;
                return jQuery.merge([], elem.childNodes);
            }
        }, function(name, fn) {
            jQuery.fn[name] = function(until, selector) {
                var matched = jQuery.map(this, fn, until);
                if (name.slice(-5) !== "Until") selector = until;
                if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
                if (this.length > 1) {
                    // Remove duplicates
                    if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                    // Reverse order for parents* and prev-derivatives
                    if (rparentsprev.test(name)) matched.reverse();
                }
                return this.pushStack(matched);
            };
        });
        var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
        // Convert String-formatted options into Object-formatted ones
        function createOptions(options) {
            var object = {};
            jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
                object[flag] = true;
            });
            return object;
        }
        /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
            // Convert options from String-formatted to Object-formatted if needed
            // (we check in cache first)
            options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
            var firing, // Last fire value for non-forgettable lists
            memory, // Flag to know if list was already fired
            fired, // Flag to prevent firing
            locked, // Actual callback list
            list = [], // Queue of execution data for repeatable lists
            queue = [], // Index of currently firing callback (modified by add/remove as needed)
            firingIndex = -1, // Fire callbacks
            fire = function() {
                // Enforce single-firing
                locked = locked || options.once;
                // Execute callbacks for all pending executions,
                // respecting firingIndex overrides and runtime changes
                fired = firing = true;
                for(; queue.length; firingIndex = -1){
                    memory = queue.shift();
                    while(++firingIndex < list.length)// Run callback and check for early termination
                    if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                        // Jump to end and forget the data so .add doesn't re-fire
                        firingIndex = list.length;
                        memory = false;
                    }
                }
                // Forget the data if we're done with it
                if (!options.memory) memory = false;
                firing = false;
                // Clean up if we're done firing for good
                if (locked) {
                    // Keep an empty list if we have data for future add calls
                    if (memory) list = [];
                    else list = "";
                }
            }, // Actual Callbacks object
            self = {
                // Add a callback or a collection of callbacks to the list
                add: function() {
                    if (list) {
                        // If we have memory from a past run, we should fire after adding
                        if (memory && !firing) {
                            firingIndex = list.length - 1;
                            queue.push(memory);
                        }
                        (function add(args) {
                            jQuery.each(args, function(_, arg) {
                                if (isFunction(arg)) {
                                    if (!options.unique || !self.has(arg)) list.push(arg);
                                } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                                add(arg);
                            });
                        })(arguments);
                        if (memory && !firing) fire();
                    }
                    return this;
                },
                // Remove a callback from the list
                remove: function() {
                    jQuery.each(arguments, function(_, arg) {
                        var index;
                        while((index = jQuery.inArray(arg, list, index)) > -1){
                            list.splice(index, 1);
                            // Handle firing indexes
                            if (index <= firingIndex) firingIndex--;
                        }
                    });
                    return this;
                },
                // Check if a given callback is in the list.
                // If no argument is given, return whether or not list has callbacks attached.
                has: function(fn) {
                    return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
                },
                // Remove all callbacks from the list
                empty: function() {
                    if (list) list = [];
                    return this;
                },
                // Disable .fire and .add
                // Abort any current/pending executions
                // Clear all callbacks and values
                disable: function() {
                    locked = queue = [];
                    list = memory = "";
                    return this;
                },
                disabled: function() {
                    return !list;
                },
                // Disable .fire
                // Also disable .add unless we have memory (since it would have no effect)
                // Abort any pending executions
                lock: function() {
                    locked = queue = [];
                    if (!memory && !firing) list = memory = "";
                    return this;
                },
                locked: function() {
                    return !!locked;
                },
                // Call all callbacks with the given context and arguments
                fireWith: function(context, args) {
                    if (!locked) {
                        args = args || [];
                        args = [
                            context,
                            args.slice ? args.slice() : args
                        ];
                        queue.push(args);
                        if (!firing) fire();
                    }
                    return this;
                },
                // Call all the callbacks with the given arguments
                fire: function() {
                    self.fireWith(this, arguments);
                    return this;
                },
                // To know if the callbacks have already been called at least once
                fired: function() {
                    return !!fired;
                }
            };
            return self;
        };
        function Identity(v) {
            return v;
        }
        function Thrower(ex) {
            throw ex;
        }
        function adoptValue(value, resolve, reject, noValue) {
            var method;
            try {
                // Check for promise aspect first to privilege synchronous behavior
                if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
                else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
                else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
                // * false: [ value ].slice( 0 ) => resolve( value )
                // * true: [ value ].slice( 1 ) => resolve()
                resolve.apply(undefined, [
                    value
                ].slice(noValue));
            // For Promises/A+, convert exceptions into rejections
            // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
            // Deferred#then to conditionally suppress rejection.
            } catch (value) {
                // Support: Android 4.0 only
                // Strict mode functions invoked without .call/.apply get global-object context
                reject.apply(undefined, [
                    value
                ]);
            }
        }
        jQuery.extend({
            Deferred: function(func) {
                var tuples = [
                    // action, add listener, callbacks,
                    // ... .then handlers, argument index, [final state]
                    [
                        "notify",
                        "progress",
                        jQuery.Callbacks("memory"),
                        jQuery.Callbacks("memory"),
                        2
                    ],
                    [
                        "resolve",
                        "done",
                        jQuery.Callbacks("once memory"),
                        jQuery.Callbacks("once memory"),
                        0,
                        "resolved"
                    ],
                    [
                        "reject",
                        "fail",
                        jQuery.Callbacks("once memory"),
                        jQuery.Callbacks("once memory"),
                        1,
                        "rejected"
                    ]
                ], state = "pending", promise = {
                    state: function() {
                        return state;
                    },
                    always: function() {
                        deferred.done(arguments).fail(arguments);
                        return this;
                    },
                    "catch": function(fn) {
                        return promise.then(null, fn);
                    },
                    // Keep pipe for back-compat
                    pipe: function() {
                        var fns = arguments;
                        return jQuery.Deferred(function(newDefer) {
                            jQuery.each(tuples, function(_i, tuple) {
                                // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                                var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                                // deferred.progress(function() { bind to newDefer or newDefer.notify })
                                // deferred.done(function() { bind to newDefer or newDefer.resolve })
                                // deferred.fail(function() { bind to newDefer or newDefer.reject })
                                deferred[tuple[1]](function() {
                                    var returned = fn && fn.apply(this, arguments);
                                    if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                    else newDefer[tuple[0] + "With"](this, fn ? [
                                        returned
                                    ] : arguments);
                                });
                            });
                            fns = null;
                        }).promise();
                    },
                    then: function(onFulfilled, onRejected, onProgress) {
                        var maxDepth = 0;
                        function resolve(depth, deferred, handler, special) {
                            return function() {
                                var that = this, args = arguments, mightThrow = function() {
                                    var returned, then;
                                    // Support: Promises/A+ section 2.3.3.3.3
                                    // https://promisesaplus.com/#point-59
                                    // Ignore double-resolution attempts
                                    if (depth < maxDepth) return;
                                    returned = handler.apply(that, args);
                                    // Support: Promises/A+ section 2.3.1
                                    // https://promisesaplus.com/#point-48
                                    if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                    // Support: Promises/A+ sections 2.3.3.1, 3.5
                                    // https://promisesaplus.com/#point-54
                                    // https://promisesaplus.com/#point-75
                                    // Retrieve `then` only once
                                    then = returned && // Support: Promises/A+ section 2.3.4
                                    // https://promisesaplus.com/#point-64
                                    // Only check objects and functions for thenability
                                    (typeof returned === "object" || typeof returned === "function") && returned.then;
                                    // Handle a returned thenable
                                    if (isFunction(then)) {
                                        // Special processors (notify) just wait for resolution
                                        if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                        else {
                                            // ...and disregard older resolution values
                                            maxDepth++;
                                            then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                        }
                                    } else {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Identity) {
                                            that = undefined;
                                            args = [
                                                returned
                                            ];
                                        }
                                        // Process the value(s)
                                        // Default process is resolve
                                        (special || deferred.resolveWith)(that, args);
                                    }
                                }, // Only normal processors (resolve) catch and reject exceptions
                                process = special ? mightThrow : function() {
                                    try {
                                        mightThrow();
                                    } catch (e) {
                                        if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                        // Support: Promises/A+ section 2.3.3.3.4.1
                                        // https://promisesaplus.com/#point-61
                                        // Ignore post-resolution exceptions
                                        if (depth + 1 >= maxDepth) {
                                            // Only substitute handlers pass on context
                                            // and multiple values (non-spec behavior)
                                            if (handler !== Thrower) {
                                                that = undefined;
                                                args = [
                                                    e
                                                ];
                                            }
                                            deferred.rejectWith(that, args);
                                        }
                                    }
                                };
                                // Support: Promises/A+ section 2.3.3.3.1
                                // https://promisesaplus.com/#point-57
                                // Re-resolve promises immediately to dodge false rejection from
                                // subsequent errors
                                if (depth) process();
                                else {
                                    // Call an optional hook to record the stack, in case of exception
                                    // since it's otherwise lost when execution goes async
                                    if (jQuery.Deferred.getStackHook) process.stackTrace = jQuery.Deferred.getStackHook();
                                    window1.setTimeout(process);
                                }
                            };
                        }
                        return jQuery.Deferred(function(newDefer) {
                            // progress_handlers.add( ... )
                            tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                            // fulfilled_handlers.add( ... )
                            tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                            // rejected_handlers.add( ... )
                            tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                        }).promise();
                    },
                    // Get a promise for this deferred
                    // If obj is provided, the promise aspect is added to the object
                    promise: function(obj) {
                        return obj != null ? jQuery.extend(obj, promise) : promise;
                    }
                }, deferred = {};
                // Add list-specific methods
                jQuery.each(tuples, function(i, tuple) {
                    var list = tuple[2], stateString = tuple[5];
                    // promise.progress = list.add
                    // promise.done = list.add
                    // promise.fail = list.add
                    promise[tuple[1]] = list.add;
                    // Handle state
                    if (stateString) list.add(function() {
                        // state = "resolved" (i.e., fulfilled)
                        // state = "rejected"
                        state = stateString;
                    }, // rejected_callbacks.disable
                    // fulfilled_callbacks.disable
                    tuples[3 - i][2].disable, // rejected_handlers.disable
                    // fulfilled_handlers.disable
                    tuples[3 - i][3].disable, // progress_callbacks.lock
                    tuples[0][2].lock, // progress_handlers.lock
                    tuples[0][3].lock);
                    // progress_handlers.fire
                    // fulfilled_handlers.fire
                    // rejected_handlers.fire
                    list.add(tuple[3].fire);
                    // deferred.notify = function() { deferred.notifyWith(...) }
                    // deferred.resolve = function() { deferred.resolveWith(...) }
                    // deferred.reject = function() { deferred.rejectWith(...) }
                    deferred[tuple[0]] = function() {
                        deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                        return this;
                    };
                    // deferred.notifyWith = list.fireWith
                    // deferred.resolveWith = list.fireWith
                    // deferred.rejectWith = list.fireWith
                    deferred[tuple[0] + "With"] = list.fireWith;
                });
                // Make the deferred a promise
                promise.promise(deferred);
                // Call given func if any
                if (func) func.call(deferred, deferred);
                // All done!
                return deferred;
            },
            // Deferred helper
            when: function(singleValue) {
                var // count of uncompleted subordinates
                remaining = arguments.length, // count of unprocessed arguments
                i = remaining, // subordinate fulfillment data
                resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
                primary = jQuery.Deferred(), // subordinate callback factory
                updateFunc = function(i) {
                    return function(value) {
                        resolveContexts[i] = this;
                        resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                        if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                    };
                };
                // Single- and empty arguments are adopted like Promise.resolve
                if (remaining <= 1) {
                    adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                    // Use .then() to unwrap secondary thenables (cf. gh-3000)
                    if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
                }
                // Multiple arguments are aggregated like Promise.all array elements
                while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
                return primary.promise();
            }
        });
        // These usually indicate a programmer mistake during development,
        // warn about them ASAP rather than swallowing them by default.
        var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        jQuery.Deferred.exceptionHook = function(error, stack) {
            // Support: IE 8 - 9 only
            // Console exists when dev tools are open, which can happen at any time
            if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
        };
        jQuery.readyException = function(error) {
            window1.setTimeout(function() {
                throw error;
            });
        };
        // The deferred used on DOM ready
        var readyList = jQuery.Deferred();
        jQuery.fn.ready = function(fn) {
            readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
            // happens at the time of error handling instead of callback
            // registration.
            .catch(function(error) {
                jQuery.readyException(error);
            });
            return this;
        };
        jQuery.extend({
            // Is the DOM ready to be used? Set to true once it occurs.
            isReady: false,
            // A counter to track how many items to wait for before
            // the ready event fires. See #6781
            readyWait: 1,
            // Handle when the DOM is ready
            ready: function(wait) {
                // Abort if there are pending holds or we're already ready
                if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
                // Remember that the DOM is ready
                jQuery.isReady = true;
                // If a normal DOM Ready event fired, decrement, and wait if need be
                if (wait !== true && --jQuery.readyWait > 0) return;
                // If there are functions bound, to execute
                readyList.resolveWith(document, [
                    jQuery
                ]);
            }
        });
        jQuery.ready.then = readyList.then;
        // The ready event handler and self cleanup method
        function completed() {
            document.removeEventListener("DOMContentLoaded", completed);
            window1.removeEventListener("load", completed);
            jQuery.ready();
        }
        // Catch cases where $(document).ready() is called
        // after the browser event has already occurred.
        // Support: IE <=9 - 10 only
        // Older IE sometimes signals "interactive" too soon
        if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
        window1.setTimeout(jQuery.ready);
        else {
            // Use the handy event callback
            document.addEventListener("DOMContentLoaded", completed);
            // A fallback to window.onload, that will always work
            window1.addEventListener("load", completed);
        }
        // Multifunctional method to get and set values of a collection
        // The value/s can optionally be executed if it's a function
        var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
            var i = 0, len = elems.length, bulk = key == null;
            // Sets many values
            if (toType(key) === "object") {
                chainable = true;
                for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
            // Sets one value
            } else if (value !== undefined) {
                chainable = true;
                if (!isFunction(value)) raw = true;
                if (bulk) {
                    // Bulk operations run against the entire set
                    if (raw) {
                        fn.call(elems, value);
                        fn = null;
                    // ...except when executing function values
                    } else {
                        bulk = fn;
                        fn = function(elem, _key, value) {
                            return bulk.call(jQuery(elem), value);
                        };
                    }
                }
                if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
            }
            if (chainable) return elems;
            // Gets
            if (bulk) return fn.call(elems);
            return len ? fn(elems[0], key) : emptyGet;
        };
        // Matches dashed string for camelizing
        var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
        // Used by camelCase as callback to replace()
        function fcamelCase(_all, letter) {
            return letter.toUpperCase();
        }
        // Convert dashed to camelCase; used by the css and data modules
        // Support: IE <=9 - 11, Edge 12 - 15
        // Microsoft forgot to hump their vendor prefix (#9572)
        function camelCase(string) {
            return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
        }
        var acceptData = function(owner) {
            // Accepts only:
            //  - Node
            //    - Node.ELEMENT_NODE
            //    - Node.DOCUMENT_NODE
            //  - Object
            //    - Any
            return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
        };
        function Data() {
            this.expando = jQuery.expando + Data.uid++;
        }
        Data.uid = 1;
        Data.prototype = {
            cache: function(owner) {
                // Check if the owner object already has a cache
                var value = owner[this.expando];
                // If not, create one
                if (!value) {
                    value = {};
                    // We can accept data for non-element nodes in modern browsers,
                    // but we should not, see #8335.
                    // Always return an empty object.
                    if (acceptData(owner)) {
                        // If it is a node unlikely to be stringify-ed or looped over
                        // use plain assignment
                        if (owner.nodeType) owner[this.expando] = value;
                        else Object.defineProperty(owner, this.expando, {
                            value: value,
                            configurable: true
                        });
                    }
                }
                return value;
            },
            set: function(owner, data, value) {
                var prop, cache = this.cache(owner);
                // Handle: [ owner, key, value ] args
                // Always use camelCase key (gh-2257)
                if (typeof data === "string") cache[camelCase(data)] = value;
                else // Copy the properties one-by-one to the cache object
                for(prop in data)cache[camelCase(prop)] = data[prop];
                return cache;
            },
            get: function(owner, key) {
                return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
                owner[this.expando] && owner[this.expando][camelCase(key)];
            },
            access: function(owner, key, value) {
                // In cases where either:
                //
                //   1. No key was specified
                //   2. A string key was specified, but no value provided
                //
                // Take the "read" path and allow the get method to determine
                // which value to return, respectively either:
                //
                //   1. The entire cache object
                //   2. The data stored at the key
                //
                if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
                // When the key is not a string, or both a key and value
                // are specified, set or extend (existing objects) with either:
                //
                //   1. An object of properties
                //   2. A key and value
                //
                this.set(owner, key, value);
                // Since the "set" path can have two possible entry points
                // return the expected data based on which path was taken[*]
                return value !== undefined ? value : key;
            },
            remove: function(owner, key) {
                var i, cache = owner[this.expando];
                if (cache === undefined) return;
                if (key !== undefined) {
                    // Support array or space separated string of keys
                    if (Array.isArray(key)) // If key is an array of keys...
                    // We always set camelCase keys, so remove that.
                    key = key.map(camelCase);
                    else {
                        key = camelCase(key);
                        // If a key with the spaces exists, use it.
                        // Otherwise, create an array by matching non-whitespace
                        key = key in cache ? [
                            key
                        ] : key.match(rnothtmlwhite) || [];
                    }
                    i = key.length;
                    while(i--)delete cache[key[i]];
                }
                // Remove the expando if there's no more data
                if (key === undefined || jQuery.isEmptyObject(cache)) {
                    // Support: Chrome <=35 - 45
                    // Webkit & Blink performance suffers when deleting properties
                    // from DOM nodes, so set to undefined instead
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                    if (owner.nodeType) owner[this.expando] = undefined;
                    else delete owner[this.expando];
                }
            },
            hasData: function(owner) {
                var cache = owner[this.expando];
                return cache !== undefined && !jQuery.isEmptyObject(cache);
            }
        };
        var dataPriv = new Data();
        var dataUser = new Data();
        //	Implementation Summary
        //
        //	1. Enforce API surface and semantic compatibility with 1.9.x branch
        //	2. Improve the module's maintainability by reducing the storage
        //		paths to a single mechanism.
        //	3. Use the same single mechanism to support "private" and "user" data.
        //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
        //	5. Avoid exposing implementation details on user objects (eg. expando properties)
        //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
        var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
        function getData(data) {
            if (data === "true") return true;
            if (data === "false") return false;
            if (data === "null") return null;
            // Only convert to a number if it doesn't change the string
            if (data === +data + "") return +data;
            if (rbrace.test(data)) return JSON.parse(data);
            return data;
        }
        function dataAttr(elem, key, data) {
            var name;
            // If nothing was found internally, try to fetch any
            // data from the HTML5 data-* attribute
            if (data === undefined && elem.nodeType === 1) {
                name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
                data = elem.getAttribute(name);
                if (typeof data === "string") {
                    try {
                        data = getData(data);
                    } catch (e) {}
                    // Make sure we set the data so it isn't changed later
                    dataUser.set(elem, key, data);
                } else data = undefined;
            }
            return data;
        }
        jQuery.extend({
            hasData: function(elem) {
                return dataUser.hasData(elem) || dataPriv.hasData(elem);
            },
            data: function(elem, name, data) {
                return dataUser.access(elem, name, data);
            },
            removeData: function(elem, name) {
                dataUser.remove(elem, name);
            },
            // TODO: Now that all calls to _data and _removeData have been replaced
            // with direct calls to dataPriv methods, these can be deprecated.
            _data: function(elem, name, data) {
                return dataPriv.access(elem, name, data);
            },
            _removeData: function(elem, name) {
                dataPriv.remove(elem, name);
            }
        });
        jQuery.fn.extend({
            data: function(key, value) {
                var i, name, data, elem = this[0], attrs = elem && elem.attributes;
                // Gets all values
                if (key === undefined) {
                    if (this.length) {
                        data = dataUser.get(elem);
                        if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                            i = attrs.length;
                            while(i--)// Support: IE 11 only
                            // The attrs elements can be null (#14894)
                            if (attrs[i]) {
                                name = attrs[i].name;
                                if (name.indexOf("data-") === 0) {
                                    name = camelCase(name.slice(5));
                                    dataAttr(elem, name, data[name]);
                                }
                            }
                            dataPriv.set(elem, "hasDataAttrs", true);
                        }
                    }
                    return data;
                }
                // Sets multiple values
                if (typeof key === "object") return this.each(function() {
                    dataUser.set(this, key);
                });
                return access(this, function(value) {
                    var data;
                    // The calling jQuery object (element matches) is not empty
                    // (and therefore has an element appears at this[ 0 ]) and the
                    // `value` parameter was not undefined. An empty jQuery object
                    // will result in `undefined` for elem = this[ 0 ] which will
                    // throw an exception if an attempt to read a data cache is made.
                    if (elem && value === undefined) {
                        // Attempt to get data from the cache
                        // The key will always be camelCased in Data
                        data = dataUser.get(elem, key);
                        if (data !== undefined) return data;
                        // Attempt to "discover" the data in
                        // HTML5 custom data-* attrs
                        data = dataAttr(elem, key);
                        if (data !== undefined) return data;
                        // We tried really hard, but the data doesn't exist.
                        return;
                    }
                    // Set the data...
                    this.each(function() {
                        // We always store the camelCased key
                        dataUser.set(this, key, value);
                    });
                }, null, value, arguments.length > 1, null, true);
            },
            removeData: function(key) {
                return this.each(function() {
                    dataUser.remove(this, key);
                });
            }
        });
        jQuery.extend({
            queue: function(elem, type, data) {
                var queue;
                if (elem) {
                    type = (type || "fx") + "queue";
                    queue = dataPriv.get(elem, type);
                    // Speed up dequeue by getting out quickly if this is just a lookup
                    if (data) {
                        if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                        else queue.push(data);
                    }
                    return queue || [];
                }
            },
            dequeue: function(elem, type) {
                type = type || "fx";
                var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                    jQuery.dequeue(elem, type);
                };
                // If the fx queue is dequeued, always remove the progress sentinel
                if (fn === "inprogress") {
                    fn = queue.shift();
                    startLength--;
                }
                if (fn) {
                    // Add a progress sentinel to prevent the fx queue from being
                    // automatically dequeued
                    if (type === "fx") queue.unshift("inprogress");
                    // Clear up the last queue stop function
                    delete hooks.stop;
                    fn.call(elem, next, hooks);
                }
                if (!startLength && hooks) hooks.empty.fire();
            },
            // Not public - generate a queueHooks object, or return the current one
            _queueHooks: function(elem, type) {
                var key = type + "queueHooks";
                return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                    empty: jQuery.Callbacks("once memory").add(function() {
                        dataPriv.remove(elem, [
                            type + "queue",
                            key
                        ]);
                    })
                });
            }
        });
        jQuery.fn.extend({
            queue: function(type, data) {
                var setter = 2;
                if (typeof type !== "string") {
                    data = type;
                    type = "fx";
                    setter--;
                }
                if (arguments.length < setter) return jQuery.queue(this[0], type);
                return data === undefined ? this : this.each(function() {
                    var queue = jQuery.queue(this, type, data);
                    // Ensure a hooks for this queue
                    jQuery._queueHooks(this, type);
                    if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
                });
            },
            dequeue: function(type) {
                return this.each(function() {
                    jQuery.dequeue(this, type);
                });
            },
            clearQueue: function(type) {
                return this.queue(type || "fx", []);
            },
            // Get a promise resolved when queues of a certain type
            // are emptied (fx is the type by default)
            promise: function(type, obj) {
                var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                    if (!--count) defer.resolveWith(elements, [
                        elements
                    ]);
                };
                if (typeof type !== "string") {
                    obj = type;
                    type = undefined;
                }
                type = type || "fx";
                while(i--){
                    tmp = dataPriv.get(elements[i], type + "queueHooks");
                    if (tmp && tmp.empty) {
                        count++;
                        tmp.empty.add(resolve);
                    }
                }
                resolve();
                return defer.promise(obj);
            }
        });
        var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
        var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
        var cssExpand = [
            "Top",
            "Right",
            "Bottom",
            "Left"
        ];
        var documentElement = document.documentElement;
        var isAttached = function(elem) {
            return jQuery.contains(elem.ownerDocument, elem);
        }, composed = {
            composed: true
        };
        // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
        // Check attachment across shadow DOM boundaries when possible (gh-3504)
        // Support: iOS 10.0-10.2 only
        // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
        // leading to errors. We need to check for `getRootNode`.
        if (documentElement.getRootNode) isAttached = function(elem) {
            return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
        };
        var isHiddenWithinTree = function(elem, el) {
            // isHiddenWithinTree might be called from jQuery#filter function;
            // in that case, element will be second argument
            elem = el || elem;
            // Inline style trumps all
            return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
            // Support: Firefox <=43 - 45
            // Disconnected elements can have computed display: none, so first confirm that elem is
            // in the document.
            isAttached(elem) && jQuery.css(elem, "display") === "none";
        };
        function adjustCSS(elem, prop, valueParts, tween) {
            var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
                return tween.cur();
            } : function() {
                return jQuery.css(elem, prop, "");
            }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
            initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
            if (initialInUnit && initialInUnit[3] !== unit) {
                // Support: Firefox <=54
                // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
                initial = initial / 2;
                // Trust units reported by jQuery.css
                unit = unit || initialInUnit[3];
                // Iteratively approximate from a nonzero starting point
                initialInUnit = +initial || 1;
                while(maxIterations--){
                    // Evaluate and update our best guess (doubling guesses that zero out).
                    // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                    jQuery.style(elem, prop, initialInUnit + unit);
                    if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                    initialInUnit = initialInUnit / scale;
                }
                initialInUnit = initialInUnit * 2;
                jQuery.style(elem, prop, initialInUnit + unit);
                // Make sure we update the tween properties later on
                valueParts = valueParts || [];
            }
            if (valueParts) {
                initialInUnit = +initialInUnit || +initial || 0;
                // Apply relative offset (+=/-=) if specified
                adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
                if (tween) {
                    tween.unit = unit;
                    tween.start = initialInUnit;
                    tween.end = adjusted;
                }
            }
            return adjusted;
        }
        var defaultDisplayMap = {};
        function getDefaultDisplay(elem) {
            var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
            if (display) return display;
            temp = doc.body.appendChild(doc.createElement(nodeName));
            display = jQuery.css(temp, "display");
            temp.parentNode.removeChild(temp);
            if (display === "none") display = "block";
            defaultDisplayMap[nodeName] = display;
            return display;
        }
        function showHide(elements, show) {
            var display, elem, values = [], index = 0, length = elements.length;
            // Determine new display value for elements that need to change
            for(; index < length; index++){
                elem = elements[index];
                if (!elem.style) continue;
                display = elem.style.display;
                if (show) {
                    // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                    // check is required in this first loop unless we have a nonempty display value (either
                    // inline or about-to-be-restored)
                    if (display === "none") {
                        values[index] = dataPriv.get(elem, "display") || null;
                        if (!values[index]) elem.style.display = "";
                    }
                    if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
                } else if (display !== "none") {
                    values[index] = "none";
                    // Remember what we're overwriting
                    dataPriv.set(elem, "display", display);
                }
            }
            // Set the display of the elements in a second loop to avoid constant reflow
            for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
            return elements;
        }
        jQuery.fn.extend({
            show: function() {
                return showHide(this, true);
            },
            hide: function() {
                return showHide(this);
            },
            toggle: function(state) {
                if (typeof state === "boolean") return state ? this.show() : this.hide();
                return this.each(function() {
                    if (isHiddenWithinTree(this)) jQuery(this).show();
                    else jQuery(this).hide();
                });
            }
        });
        var rcheckableType = /^(?:checkbox|radio)$/i;
        var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
        var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
        (function() {
            var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
            // Support: Android 4.0 - 4.3 only
            // Check state lost if the name is set (#11217)
            // Support: Windows Web Apps (WWA)
            // `name` and `type` must use .setAttribute for WWA (#14901)
            input.setAttribute("type", "radio");
            input.setAttribute("checked", "checked");
            input.setAttribute("name", "t");
            div.appendChild(input);
            // Support: Android <=4.1 only
            // Older WebKit doesn't clone checked state correctly in fragments
            support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
            // Support: IE <=11 only
            // Make sure textarea (and checkbox) defaultValue is properly cloned
            div.innerHTML = "<textarea>x</textarea>";
            support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
            // Support: IE <=9 only
            // IE <=9 replaces <option> tags with their contents when inserted outside of
            // the select element.
            div.innerHTML = "<option></option>";
            support.option = !!div.lastChild;
        })();
        // We have to close these tags to support XHTML (#13200)
        var wrapMap = {
            // XHTML parsers do not magically insert elements in the
            // same way that tag soup parsers do. So we cannot shorten
            // this by omitting <tbody> or other required elements.
            thead: [
                1,
                "<table>",
                "</table>"
            ],
            col: [
                2,
                "<table><colgroup>",
                "</colgroup></table>"
            ],
            tr: [
                2,
                "<table><tbody>",
                "</tbody></table>"
            ],
            td: [
                3,
                "<table><tbody><tr>",
                "</tr></tbody></table>"
            ],
            _default: [
                0,
                "",
                ""
            ]
        };
        wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
        wrapMap.th = wrapMap.td;
        // Support: IE <=9 only
        if (!support.option) wrapMap.optgroup = wrapMap.option = [
            1,
            "<select multiple='multiple'>",
            "</select>"
        ];
        function getAll(context, tag) {
            // Support: IE <=9 - 11 only
            // Use typeof to avoid zero-argument method invocation on host objects (#15151)
            var ret;
            if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
            else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
            else ret = [];
            if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
                context
            ], ret);
            return ret;
        }
        // Mark scripts as having already been evaluated
        function setGlobalEval(elems, refElements) {
            var i = 0, l = elems.length;
            for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
        }
        var rhtml = /<|&#?\w+;/;
        function buildFragment(elems, context, scripts, selection, ignored) {
            var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
            for(; i < l; i++){
                elem = elems[i];
                if (elem || elem === 0) {
                    // Add nodes directly
                    if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, elem.nodeType ? [
                        elem
                    ] : elem);
                    else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                    else {
                        tmp = tmp || fragment.appendChild(context.createElement("div"));
                        // Deserialize a standard representation
                        tag = (rtagName.exec(elem) || [
                            "",
                            ""
                        ])[1].toLowerCase();
                        wrap = wrapMap[tag] || wrapMap._default;
                        tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                        // Descend through wrappers to the right content
                        j = wrap[0];
                        while(j--)tmp = tmp.lastChild;
                        // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(nodes, tmp.childNodes);
                        // Remember the top-level container
                        tmp = fragment.firstChild;
                        // Ensure the created nodes are orphaned (#12392)
                        tmp.textContent = "";
                    }
                }
            }
            // Remove wrapper from fragment
            fragment.textContent = "";
            i = 0;
            while(elem = nodes[i++]){
                // Skip elements already in the context collection (trac-4087)
                if (selection && jQuery.inArray(elem, selection) > -1) {
                    if (ignored) ignored.push(elem);
                    continue;
                }
                attached = isAttached(elem);
                // Append to fragment
                tmp = getAll(fragment.appendChild(elem), "script");
                // Preserve script evaluation history
                if (attached) setGlobalEval(tmp);
                // Capture executables
                if (scripts) {
                    j = 0;
                    while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
                }
            }
            return fragment;
        }
        var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
        function returnTrue() {
            return true;
        }
        function returnFalse() {
            return false;
        }
        // Support: IE <=9 - 11+
        // focus() and blur() are asynchronous, except when they are no-op.
        // So expect focus to be synchronous when the element is already active,
        // and blur to be synchronous when the element is not already active.
        // (focus and blur are always synchronous in other supported browsers,
        // this just defines when we can count on it).
        function expectSync(elem, type) {
            return elem === safeActiveElement() === (type === "focus");
        }
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        function on(elem, types, selector, data, fn, one) {
            var origFn, type;
            // Types can be a map of types/handlers
            if (typeof types === "object") {
                // ( types-Object, selector, data )
                if (typeof selector !== "string") {
                    // ( types-Object, data )
                    data = data || selector;
                    selector = undefined;
                }
                for(type in types)on(elem, type, selector, data, types[type], one);
                return elem;
            }
            if (data == null && fn == null) {
                // ( types, fn )
                fn = selector;
                data = selector = undefined;
            } else if (fn == null) {
                if (typeof selector === "string") {
                    // ( types, selector, fn )
                    fn = data;
                    data = undefined;
                } else {
                    // ( types, data, fn )
                    fn = data;
                    data = selector;
                    selector = undefined;
                }
            }
            if (fn === false) fn = returnFalse;
            else if (!fn) return elem;
            if (one === 1) {
                origFn = fn;
                fn = function(event) {
                    // Can use an empty set, since event contains the info
                    jQuery().off(event);
                    return origFn.apply(this, arguments);
                };
                // Use same guid so caller can remove using origFn
                fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
            }
            return elem.each(function() {
                jQuery.event.add(this, types, fn, data, selector);
            });
        }
        /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
            global: {},
            add: function(elem, types, handler, data, selector) {
                var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
                // Only attach events to objects that accept data
                if (!acceptData(elem)) return;
                // Caller can pass in an object of custom data in lieu of the handler
                if (handler.handler) {
                    handleObjIn = handler;
                    handler = handleObjIn.handler;
                    selector = handleObjIn.selector;
                }
                // Ensure that invalid selectors throw exceptions at attach time
                // Evaluate against documentElement in case elem is a non-element node (e.g., document)
                if (selector) jQuery.find.matchesSelector(documentElement, selector);
                // Make sure that the handler has a unique ID, used to find/remove it later
                if (!handler.guid) handler.guid = jQuery.guid++;
                // Init the element's event structure and main handler, if this is the first
                if (!(events = elemData.events)) events = elemData.events = Object.create(null);
                if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                    // Discard the second event of a jQuery.event.trigger() and
                    // when an event is called after a page has unloaded
                    return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
                };
                // Handle multiple events separated by a space
                types = (types || "").match(rnothtmlwhite) || [
                    ""
                ];
                t = types.length;
                while(t--){
                    tmp = rtypenamespace.exec(types[t]) || [];
                    type = origType = tmp[1];
                    namespaces = (tmp[2] || "").split(".").sort();
                    // There *must* be a type, no attaching namespace-only handlers
                    if (!type) continue;
                    // If event changes its type, use the special event handlers for the changed type
                    special = jQuery.event.special[type] || {};
                    // If selector defined, determine special event api type, otherwise given type
                    type = (selector ? special.delegateType : special.bindType) || type;
                    // Update special based on newly reset type
                    special = jQuery.event.special[type] || {};
                    // handleObj is passed to all event handlers
                    handleObj = jQuery.extend({
                        type: type,
                        origType: origType,
                        data: data,
                        handler: handler,
                        guid: handler.guid,
                        selector: selector,
                        needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                        namespace: namespaces.join(".")
                    }, handleObjIn);
                    // Init the event handler queue if we're the first
                    if (!(handlers = events[type])) {
                        handlers = events[type] = [];
                        handlers.delegateCount = 0;
                        // Only use addEventListener if the special events handler returns false
                        if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                            if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                        }
                    }
                    if (special.add) {
                        special.add.call(elem, handleObj);
                        if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                    }
                    // Add to the element's handler list, delegates in front
                    if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                    else handlers.push(handleObj);
                    // Keep track of which events have ever been used, for event optimization
                    jQuery.event.global[type] = true;
                }
            },
            // Detach an event or set of events from an element
            remove: function(elem, types, handler, selector, mappedTypes) {
                var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
                if (!elemData || !(events = elemData.events)) return;
                // Once for each type.namespace in types; type may be omitted
                types = (types || "").match(rnothtmlwhite) || [
                    ""
                ];
                t = types.length;
                while(t--){
                    tmp = rtypenamespace.exec(types[t]) || [];
                    type = origType = tmp[1];
                    namespaces = (tmp[2] || "").split(".").sort();
                    // Unbind all events (on this namespace, if provided) for the element
                    if (!type) {
                        for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                        continue;
                    }
                    special = jQuery.event.special[type] || {};
                    type = (selector ? special.delegateType : special.bindType) || type;
                    handlers = events[type] || [];
                    tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                    // Remove matching events
                    origCount = j = handlers.length;
                    while(j--){
                        handleObj = handlers[j];
                        if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                            handlers.splice(j, 1);
                            if (handleObj.selector) handlers.delegateCount--;
                            if (special.remove) special.remove.call(elem, handleObj);
                        }
                    }
                    // Remove generic event handler if we removed something and no more handlers exist
                    // (avoids potential for endless recursion during removal of special event handlers)
                    if (origCount && !handlers.length) {
                        if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                        delete events[type];
                    }
                }
                // Remove data and the expando if it's no longer used
                if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
            },
            dispatch: function(nativeEvent) {
                var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
                event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
                // Use the fix-ed jQuery.Event rather than the (read-only) native event
                args[0] = event;
                for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
                event.delegateTarget = this;
                // Call the preDispatch hook for the mapped type, and let it bail if desired
                if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
                // Determine handlers
                handlerQueue = jQuery.event.handlers.call(this, event, handlers);
                // Run delegates first; they may want to stop propagation beneath us
                i = 0;
                while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                    event.currentTarget = matched.elem;
                    j = 0;
                    while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                    // specially universal or its namespaces are a superset of the event's.
                    if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                        event.handleObj = handleObj;
                        event.data = handleObj.data;
                        ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                        if (ret !== undefined) {
                            if ((event.result = ret) === false) {
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        }
                    }
                }
                // Call the postDispatch hook for the mapped type
                if (special.postDispatch) special.postDispatch.call(this, event);
                return event.result;
            },
            handlers: function(event, handlers) {
                var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
                // Find delegate handlers
                if (delegateCount && // Support: IE <=9
                // Black-hole SVG <use> instance trees (trac-13180)
                cur.nodeType && // Support: Firefox <=42
                // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
                // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
                // Support: IE 11 only
                // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
                !(event.type === "click" && event.button >= 1)) {
                    for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (#13208)
                    // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                    if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                        matchedHandlers = [];
                        matchedSelectors = {};
                        for(i = 0; i < delegateCount; i++){
                            handleObj = handlers[i];
                            // Don't conflict with Object.prototype properties (#13203)
                            sel = handleObj.selector + " ";
                            if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                                cur
                            ]).length;
                            if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                        }
                        if (matchedHandlers.length) handlerQueue.push({
                            elem: cur,
                            handlers: matchedHandlers
                        });
                    }
                }
                // Add the remaining (directly-bound) handlers
                cur = this;
                if (delegateCount < handlers.length) handlerQueue.push({
                    elem: cur,
                    handlers: handlers.slice(delegateCount)
                });
                return handlerQueue;
            },
            addProp: function(name, hook) {
                Object.defineProperty(jQuery.Event.prototype, name, {
                    enumerable: true,
                    configurable: true,
                    get: isFunction(hook) ? function() {
                        if (this.originalEvent) return hook(this.originalEvent);
                    } : function() {
                        if (this.originalEvent) return this.originalEvent[name];
                    },
                    set: function(value) {
                        Object.defineProperty(this, name, {
                            enumerable: true,
                            configurable: true,
                            writable: true,
                            value: value
                        });
                    }
                });
            },
            fix: function(originalEvent) {
                return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
            },
            special: {
                load: {
                    // Prevent triggered image.load events from bubbling to window.load
                    noBubble: true
                },
                click: {
                    // Utilize native event to ensure correct state for checkable inputs
                    setup: function(data) {
                        // For mutual compressibility with _default, replace `this` access with a local var.
                        // `|| data` is dead code meant only to preserve the variable through minification.
                        var el = this || data;
                        // Claim the first handler
                        if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                        leverageNative(el, "click", returnTrue);
                        // Return false to allow normal processing in the caller
                        return false;
                    },
                    trigger: function(data) {
                        // For mutual compressibility with _default, replace `this` access with a local var.
                        // `|| data` is dead code meant only to preserve the variable through minification.
                        var el = this || data;
                        // Force setup before triggering a click
                        if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                        // Return non-false to allow normal event-path propagation
                        return true;
                    },
                    // For cross-browser consistency, suppress native .click() on links
                    // Also prevent it if we're currently inside a leveraged native-event stack
                    _default: function(event) {
                        var target = event.target;
                        return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                    }
                },
                beforeunload: {
                    postDispatch: function(event) {
                        // Support: Firefox 20+
                        // Firefox doesn't alert if the returnValue field is not set.
                        if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                    }
                }
            }
        };
        // Ensure the presence of an event listener that handles manually-triggered
        // synthetic events by interrupting progress until reinvoked in response to
        // *native* events that it fires directly, ensuring that state changes have
        // already occurred before other listeners are invoked.
        function leverageNative(el, type, expectSync) {
            // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
            if (!expectSync) {
                if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
                return;
            }
            // Register the controller as a special universal handler for all event namespaces
            dataPriv.set(el, type, false);
            jQuery.event.add(el, type, {
                namespace: false,
                handler: function(event) {
                    var notAsync, result, saved = dataPriv.get(this, type);
                    if (event.isTrigger & 1 && this[type]) {
                        // Interrupt processing of the outer synthetic .trigger()ed event
                        // Saved data should be false in such cases, but might be a leftover capture object
                        // from an async native handler (gh-4350)
                        if (!saved.length) {
                            // Store arguments for use when handling the inner native event
                            // There will always be at least one argument (an event object), so this array
                            // will not be confused with a leftover capture object.
                            saved = slice.call(arguments);
                            dataPriv.set(this, type, saved);
                            // Trigger the native event and capture its result
                            // Support: IE <=9 - 11+
                            // focus() and blur() are asynchronous
                            notAsync = expectSync(this, type);
                            this[type]();
                            result = dataPriv.get(this, type);
                            if (saved !== result || notAsync) dataPriv.set(this, type, false);
                            else result = {};
                            if (saved !== result) {
                                // Cancel the outer synthetic event
                                event.stopImmediatePropagation();
                                event.preventDefault();
                                // Support: Chrome 86+
                                // In Chrome, if an element having a focusout handler is blurred by
                                // clicking outside of it, it invokes the handler synchronously. If
                                // that handler calls `.remove()` on the element, the data is cleared,
                                // leaving `result` undefined. We need to guard against this.
                                return result && result.value;
                            }
                        // If this is an inner synthetic event for an event with a bubbling surrogate
                        // (focus or blur), assume that the surrogate already propagated from triggering the
                        // native event and prevent that from happening again here.
                        // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                        // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                        // less bad than duplication.
                        } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                    // If this is a native event triggered above, everything is now in order
                    // Fire an inner synthetic event with the original arguments
                    } else if (saved.length) {
                        // ...and capture the result
                        dataPriv.set(this, type, {
                            value: jQuery.event.trigger(// Support: IE <=9 - 11+
                            // Extend with the prototype to reset the above stopImmediatePropagation()
                            jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
                        });
                        // Abort handling of the native event
                        event.stopImmediatePropagation();
                    }
                }
            });
        }
        jQuery.removeEvent = function(elem, type, handle) {
            // This "if" is needed for plain objects
            if (elem.removeEventListener) elem.removeEventListener(type, handle);
        };
        jQuery.Event = function(src, props) {
            // Allow instantiation without the 'new' keyword
            if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
            // Event object
            if (src && src.type) {
                this.originalEvent = src;
                this.type = src.type;
                // Events bubbling up the document may have been marked as prevented
                // by a handler lower down the tree; reflect the correct value.
                this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
                src.returnValue === false ? returnTrue : returnFalse;
                // Create target properties
                // Support: Safari <=6 - 7 only
                // Target should not be a text node (#504, #13143)
                this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
                this.currentTarget = src.currentTarget;
                this.relatedTarget = src.relatedTarget;
            // Event type
            } else this.type = src;
            // Put explicitly provided properties onto the event object
            if (props) jQuery.extend(this, props);
            // Create a timestamp if incoming event doesn't have one
            this.timeStamp = src && src.timeStamp || Date.now();
            // Mark it as fixed
            this[jQuery.expando] = true;
        };
        // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
        // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
        jQuery.Event.prototype = {
            constructor: jQuery.Event,
            isDefaultPrevented: returnFalse,
            isPropagationStopped: returnFalse,
            isImmediatePropagationStopped: returnFalse,
            isSimulated: false,
            preventDefault: function() {
                var e = this.originalEvent;
                this.isDefaultPrevented = returnTrue;
                if (e && !this.isSimulated) e.preventDefault();
            },
            stopPropagation: function() {
                var e = this.originalEvent;
                this.isPropagationStopped = returnTrue;
                if (e && !this.isSimulated) e.stopPropagation();
            },
            stopImmediatePropagation: function() {
                var e = this.originalEvent;
                this.isImmediatePropagationStopped = returnTrue;
                if (e && !this.isSimulated) e.stopImmediatePropagation();
                this.stopPropagation();
            }
        };
        // Includes all common event props including KeyEvent and MouseEvent specific props
        jQuery.each({
            altKey: true,
            bubbles: true,
            cancelable: true,
            changedTouches: true,
            ctrlKey: true,
            detail: true,
            eventPhase: true,
            metaKey: true,
            pageX: true,
            pageY: true,
            shiftKey: true,
            view: true,
            "char": true,
            code: true,
            charCode: true,
            key: true,
            keyCode: true,
            button: true,
            buttons: true,
            clientX: true,
            clientY: true,
            offsetX: true,
            offsetY: true,
            pointerId: true,
            pointerType: true,
            screenX: true,
            screenY: true,
            targetTouches: true,
            toElement: true,
            touches: true,
            which: true
        }, jQuery.event.addProp);
        jQuery.each({
            focus: "focusin",
            blur: "focusout"
        }, function(type, delegateType) {
            jQuery.event.special[type] = {
                // Utilize native event if possible so blur/focus sequence is correct
                setup: function() {
                    // Claim the first handler
                    // dataPriv.set( this, "focus", ... )
                    // dataPriv.set( this, "blur", ... )
                    leverageNative(this, type, expectSync);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function() {
                    // Force setup before trigger
                    leverageNative(this, type);
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // Suppress native focus or blur as it's already being fired
                // in leverageNative.
                _default: function() {
                    return true;
                },
                delegateType: delegateType
            };
        });
        // Create mouseenter/leave events using mouseover/out and event-time checks
        // so that event delegation works in jQuery.
        // Do the same for pointerenter/pointerleave and pointerover/pointerout
        //
        // Support: Safari 7 only
        // Safari sends mouseenter too often; see:
        // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
        // for the description of the bug (it existed in older Chrome versions as well).
        jQuery.each({
            mouseenter: "mouseover",
            mouseleave: "mouseout",
            pointerenter: "pointerover",
            pointerleave: "pointerout"
        }, function(orig, fix) {
            jQuery.event.special[orig] = {
                delegateType: fix,
                bindType: fix,
                handle: function(event) {
                    var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                    // For mouseenter/leave call the handler if related is outside the target.
                    // NB: No relatedTarget if the mouse left/entered the browser window
                    if (!related || related !== target && !jQuery.contains(target, related)) {
                        event.type = handleObj.origType;
                        ret = handleObj.handler.apply(this, arguments);
                        event.type = fix;
                    }
                    return ret;
                }
            };
        });
        jQuery.fn.extend({
            on: function(types, selector, data, fn) {
                return on(this, types, selector, data, fn);
            },
            one: function(types, selector, data, fn) {
                return on(this, types, selector, data, fn, 1);
            },
            off: function(types, selector, fn) {
                var handleObj, type;
                if (types && types.preventDefault && types.handleObj) {
                    // ( event )  dispatched jQuery.Event
                    handleObj = types.handleObj;
                    jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                    return this;
                }
                if (typeof types === "object") {
                    // ( types-object [, selector] )
                    for(type in types)this.off(type, selector, types[type]);
                    return this;
                }
                if (selector === false || typeof selector === "function") {
                    // ( types [, fn] )
                    fn = selector;
                    selector = undefined;
                }
                if (fn === false) fn = returnFalse;
                return this.each(function() {
                    jQuery.event.remove(this, types, fn, selector);
                });
            }
        });
        var // Support: IE <=10 - 11, Edge 12 - 13 only
        // In IE/Edge using regex groups here causes severe slowdowns.
        // See https://connect.microsoft.com/IE/feedback/details/1736512/
        rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
        rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
        // Prefer a tbody over its parent table for containing new rows
        function manipulationTarget(elem, content) {
            if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
            return elem;
        }
        // Replace/restore the type attribute of script elements for safe DOM manipulation
        function disableScript(elem) {
            elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
            return elem;
        }
        function restoreScript(elem) {
            if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
            else elem.removeAttribute("type");
            return elem;
        }
        function cloneCopyEvent(src, dest) {
            var i, l, type, pdataOld, udataOld, udataCur, events;
            if (dest.nodeType !== 1) return;
            // 1. Copy private data: events, handlers, etc.
            if (dataPriv.hasData(src)) {
                pdataOld = dataPriv.get(src);
                events = pdataOld.events;
                if (events) {
                    dataPriv.remove(dest, "handle events");
                    for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
                }
            }
            // 2. Copy user data
            if (dataUser.hasData(src)) {
                udataOld = dataUser.access(src);
                udataCur = jQuery.extend({}, udataOld);
                dataUser.set(dest, udataCur);
            }
        }
        // Fix IE bugs, see support tests
        function fixInput(src, dest) {
            var nodeName = dest.nodeName.toLowerCase();
            // Fails to persist the checked state of a cloned checkbox or radio button.
            if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
            else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
        }
        function domManip(collection, args, callback, ignored) {
            // Flatten any nested arrays
            args = flat(args);
            var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
            // We can't cloneNode fragments that contain checked, in WebKit
            if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
                var self = collection.eq(index);
                if (valueIsFunction) args[0] = value.call(this, index, self.html());
                domManip(self, args, callback, ignored);
            });
            if (l) {
                fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
                first = fragment.firstChild;
                if (fragment.childNodes.length === 1) fragment = first;
                // Require either new content or an interest in ignored elements to invoke the callback
                if (first || ignored) {
                    scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                    hasScripts = scripts.length;
                    // Use the original fragment for the last item
                    // instead of the first because it can end up
                    // being emptied incorrectly in certain situations (#8070).
                    for(; i < l; i++){
                        node = fragment;
                        if (i !== iNoClone) {
                            node = jQuery.clone(node, true, true);
                            // Keep references to cloned scripts for later restoration
                            if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                            // push.apply(_, arraylike) throws on ancient WebKit
                            jQuery.merge(scripts, getAll(node, "script"));
                        }
                        callback.call(collection[i], node, i);
                    }
                    if (hasScripts) {
                        doc = scripts[scripts.length - 1].ownerDocument;
                        // Reenable scripts
                        jQuery.map(scripts, restoreScript);
                        // Evaluate executable scripts on first document insertion
                        for(i = 0; i < hasScripts; i++){
                            node = scripts[i];
                            if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                                if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                                {
                                    if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                        nonce: node.nonce || node.getAttribute("nonce")
                                    }, doc);
                                } else DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                            }
                        }
                    }
                }
            }
            return collection;
        }
        function remove(elem, selector, keepData) {
            var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
            for(; (node = nodes[i]) != null; i++){
                if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
                if (node.parentNode) {
                    if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                    node.parentNode.removeChild(node);
                }
            }
            return elem;
        }
        jQuery.extend({
            htmlPrefilter: function(html) {
                return html;
            },
            clone: function(elem, dataAndEvents, deepDataAndEvents) {
                var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
                // Fix IE cloning issues
                if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                    // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                    destElements = getAll(clone);
                    srcElements = getAll(elem);
                    for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
                }
                // Copy the events from the original to the clone
                if (dataAndEvents) {
                    if (deepDataAndEvents) {
                        srcElements = srcElements || getAll(elem);
                        destElements = destElements || getAll(clone);
                        for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                    } else cloneCopyEvent(elem, clone);
                }
                // Preserve script evaluation history
                destElements = getAll(clone, "script");
                if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
                // Return the cloned set
                return clone;
            },
            cleanData: function(elems) {
                var data, elem, type, special = jQuery.event.special, i = 0;
                for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                    if (data = elem[dataPriv.expando]) {
                        if (data.events) {
                            for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                            else jQuery.removeEvent(elem, type, data.handle);
                        }
                        // Support: Chrome <=35 - 45+
                        // Assign undefined instead of using delete, see Data#remove
                        elem[dataPriv.expando] = undefined;
                    }
                    if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataUser.expando] = undefined;
                }
            }
        });
        jQuery.fn.extend({
            detach: function(selector) {
                return remove(this, selector, true);
            },
            remove: function(selector) {
                return remove(this, selector);
            },
            text: function(value) {
                return access(this, function(value) {
                    return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                    });
                }, null, value, arguments.length);
            },
            append: function() {
                return domManip(this, arguments, function(elem) {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                        var target = manipulationTarget(this, elem);
                        target.appendChild(elem);
                    }
                });
            },
            prepend: function() {
                return domManip(this, arguments, function(elem) {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                        var target = manipulationTarget(this, elem);
                        target.insertBefore(elem, target.firstChild);
                    }
                });
            },
            before: function() {
                return domManip(this, arguments, function(elem) {
                    if (this.parentNode) this.parentNode.insertBefore(elem, this);
                });
            },
            after: function() {
                return domManip(this, arguments, function(elem) {
                    if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
                });
            },
            empty: function() {
                var elem, i = 0;
                for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                    // Prevent memory leaks
                    jQuery.cleanData(getAll(elem, false));
                    // Remove any remaining nodes
                    elem.textContent = "";
                }
                return this;
            },
            clone: function(dataAndEvents, deepDataAndEvents) {
                dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
                deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
                return this.map(function() {
                    return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
                });
            },
            html: function(value) {
                return access(this, function(value) {
                    var elem = this[0] || {}, i = 0, l = this.length;
                    if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                    // See if we can take a shortcut and just use innerHTML
                    if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                        "",
                        ""
                    ])[1].toLowerCase()]) {
                        value = jQuery.htmlPrefilter(value);
                        try {
                            for(; i < l; i++){
                                elem = this[i] || {};
                                // Remove element nodes and prevent memory leaks
                                if (elem.nodeType === 1) {
                                    jQuery.cleanData(getAll(elem, false));
                                    elem.innerHTML = value;
                                }
                            }
                            elem = 0;
                        // If using innerHTML throws an exception, use the fallback method
                        } catch (e) {}
                    }
                    if (elem) this.empty().append(value);
                }, null, value, arguments.length);
            },
            replaceWith: function() {
                var ignored = [];
                // Make the changes, replacing each non-ignored context element with the new content
                return domManip(this, arguments, function(elem) {
                    var parent = this.parentNode;
                    if (jQuery.inArray(this, ignored) < 0) {
                        jQuery.cleanData(getAll(this));
                        if (parent) parent.replaceChild(elem, this);
                    }
                // Force callback invocation
                }, ignored);
            }
        });
        jQuery.each({
            appendTo: "append",
            prependTo: "prepend",
            insertBefore: "before",
            insertAfter: "after",
            replaceAll: "replaceWith"
        }, function(name, original) {
            jQuery.fn[name] = function(selector) {
                var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
                for(; i <= last; i++){
                    elems = i === last ? this : this.clone(true);
                    jQuery(insert[i])[original](elems);
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // .get() because push.apply(_, arraylike) throws on ancient WebKit
                    push.apply(ret, elems.get());
                }
                return this.pushStack(ret);
            };
        });
        var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
        var getStyles = function(elem) {
            // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
            // IE throws on elements created in popups
            // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
            var view = elem.ownerDocument.defaultView;
            if (!view || !view.opener) view = window1;
            return view.getComputedStyle(elem);
        };
        var swap = function(elem, options, callback) {
            var ret, name, old = {};
            // Remember the old values, and insert the new ones
            for(name in options){
                old[name] = elem.style[name];
                elem.style[name] = options[name];
            }
            ret = callback.call(elem);
            // Revert the old values
            for(name in options)elem.style[name] = old[name];
            return ret;
        };
        var rboxStyle = new RegExp(cssExpand.join("|"), "i");
        (function() {
            // Executing both pixelPosition & boxSizingReliable tests require only one layout
            // so they're executed at the same time to save the second computation.
            function computeStyleTests() {
                // This is a singleton, we need to execute it only once
                if (!div) return;
                container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
                div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
                documentElement.appendChild(container).appendChild(div);
                var divStyle = window1.getComputedStyle(div);
                pixelPositionVal = divStyle.top !== "1%";
                // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
                reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
                // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
                // Some styles come back with percentage values, even though they shouldn't
                div.style.right = "60%";
                pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
                // Support: IE 9 - 11 only
                // Detect misreporting of content dimensions for box-sizing:border-box elements
                boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
                // Support: IE 9 only
                // Detect overflow:scroll screwiness (gh-3699)
                // Support: Chrome <=64
                // Don't get tricked when zoom affects offsetWidth (gh-4029)
                div.style.position = "absolute";
                scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
                documentElement.removeChild(container);
                // Nullify the div so it wouldn't be stored in the memory and
                // it will also be a sign that checks already performed
                div = null;
            }
            function roundPixelMeasures(measure) {
                return Math.round(parseFloat(measure));
            }
            var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
            // Finish early in limited (non-browser) environments
            if (!div.style) return;
            // Support: IE <=9 - 11 only
            // Style of cloned element affects source element cloned (#8908)
            div.style.backgroundClip = "content-box";
            div.cloneNode(true).style.backgroundClip = "";
            support.clearCloneStyle = div.style.backgroundClip === "content-box";
            jQuery.extend(support, {
                boxSizingReliable: function() {
                    computeStyleTests();
                    return boxSizingReliableVal;
                },
                pixelBoxStyles: function() {
                    computeStyleTests();
                    return pixelBoxStylesVal;
                },
                pixelPosition: function() {
                    computeStyleTests();
                    return pixelPositionVal;
                },
                reliableMarginLeft: function() {
                    computeStyleTests();
                    return reliableMarginLeftVal;
                },
                scrollboxSize: function() {
                    computeStyleTests();
                    return scrollboxSizeVal;
                },
                // Support: IE 9 - 11+, Edge 15 - 18+
                // IE/Edge misreport `getComputedStyle` of table rows with width/height
                // set in CSS while `offset*` properties report correct values.
                // Behavior in IE 9 is more subtle than in newer versions & it passes
                // some versions of this test; make sure not to make it pass there!
                //
                // Support: Firefox 70+
                // Only Firefox includes border widths
                // in computed dimensions. (gh-4529)
                reliableTrDimensions: function() {
                    var table, tr, trChild, trStyle;
                    if (reliableTrDimensionsVal == null) {
                        table = document.createElement("table");
                        tr = document.createElement("tr");
                        trChild = document.createElement("div");
                        table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                        tr.style.cssText = "border:1px solid";
                        // Support: Chrome 86+
                        // Height set through cssText does not get applied.
                        // Computed height then comes back as 0.
                        tr.style.height = "1px";
                        trChild.style.height = "9px";
                        // Support: Android 8 Chrome 86+
                        // In our bodyBackground.html iframe,
                        // display for all div elements is set to "inline",
                        // which causes a problem only in Android 8 Chrome 86.
                        // Ensuring the div is display: block
                        // gets around this issue.
                        trChild.style.display = "block";
                        documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                        trStyle = window1.getComputedStyle(tr);
                        reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                        documentElement.removeChild(table);
                    }
                    return reliableTrDimensionsVal;
                }
            });
        })();
        function curCSS(elem, name, computed) {
            var width, minWidth, maxWidth, ret, // Support: Firefox 51+
            // Retrieving style before computed somehow
            // fixes an issue with getting wrong values
            // on detached elements
            style = elem.style;
            computed = computed || getStyles(elem);
            // getPropertyValue is needed for:
            //   .css('filter') (IE 9 only, #12537)
            //   .css('--customProperty) (#3144)
            if (computed) {
                ret = computed.getPropertyValue(name) || computed[name];
                if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
                // A tribute to the "awesome hack by Dean Edwards"
                // Android Browser returns percentage for some values,
                // but width seems to be reliably pixels.
                // This is against the CSSOM draft spec:
                // https://drafts.csswg.org/cssom/#resolved-values
                if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                    // Remember the original values
                    width = style.width;
                    minWidth = style.minWidth;
                    maxWidth = style.maxWidth;
                    // Put in the new values to get a computed value out
                    style.minWidth = style.maxWidth = style.width = ret;
                    ret = computed.width;
                    // Revert the changed values
                    style.width = width;
                    style.minWidth = minWidth;
                    style.maxWidth = maxWidth;
                }
            }
            return ret !== undefined ? // Support: IE <=9 - 11 only
            // IE returns zIndex value as an integer.
            ret + "" : ret;
        }
        function addGetHookIf(conditionFn, hookFn) {
            // Define the hook, we'll check on the first run if it's really needed.
            return {
                get: function() {
                    if (conditionFn()) {
                        // Hook not needed (or it's not possible to use it due
                        // to missing dependency), remove it.
                        delete this.get;
                        return;
                    }
                    // Hook needed; redefine it so that the support test is not executed again.
                    return (this.get = hookFn).apply(this, arguments);
                }
            };
        }
        var cssPrefixes = [
            "Webkit",
            "Moz",
            "ms"
        ], emptyStyle = document.createElement("div").style, vendorProps = {};
        // Return a vendor-prefixed property or undefined
        function vendorPropName(name) {
            // Check for vendor prefixed names
            var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
            while(i--){
                name = cssPrefixes[i] + capName;
                if (name in emptyStyle) return name;
            }
        }
        // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
        function finalPropName(name) {
            var final = jQuery.cssProps[name] || vendorProps[name];
            if (final) return final;
            if (name in emptyStyle) return name;
            return vendorProps[name] = vendorPropName(name) || name;
        }
        var // Swappable if display is none or starts with table
        // except "table", "table-cell", or "table-caption"
        // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
        rdisplayswap = /^(none|table(?!-c[ea]).+)/, rcustomProp = /^--/, cssShow = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        }, cssNormalTransform = {
            letterSpacing: "0",
            fontWeight: "400"
        };
        function setPositiveNumber(_elem, value, subtract) {
            // Any relative (+/-) values have already been
            // normalized at this point
            var matches = rcssNum.exec(value);
            return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
            Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
        }
        function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
            var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0;
            // Adjustment may not be necessary
            if (box === (isBorderBox ? "border" : "content")) return 0;
            for(; i < 4; i += 2){
                // Both box models exclude margin
                if (box === "margin") delta += jQuery.css(elem, box + cssExpand[i], true, styles);
                // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
                if (!isBorderBox) {
                    // Add padding
                    delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                    // For "border" or "margin", add border
                    if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                    else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                // If we get here with a border-box (content + padding + border), we're seeking "content" or
                // "padding" or "margin"
                } else {
                    // For "content", subtract padding
                    if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                    // For "content" or "padding", subtract border
                    if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                }
            }
            // Account for positive content-box scroll gutter when requested by providing computedVal
            if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
            // Assuming integer scroll gutter, subtract the rest and round down
            delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
            return delta;
        }
        function getWidthOrHeight(elem, dimension, extra) {
            // Start with computed style
            var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
            // Fake content-box until we know it's needed to know the true value.
            boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
            // Support: Firefox <=54
            // Return a confounding non-pixel value or feign ignorance, as appropriate.
            if (rnumnonpx.test(val)) {
                if (!extra) return val;
                val = "auto";
            }
            // Support: IE 9 - 11 only
            // Use offsetWidth/offsetHeight for when box sizing is unreliable.
            // In those cases, the computed value can be trusted to be border-box.
            if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Interestingly, in some cases IE 9 doesn't suffer from this issue.
            !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
            // This happens for inline elements with no explicit setting (gh-3571)
            val === "auto" || // Support: Android <=4.1 - 4.3 only
            // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
            !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
            elem.getClientRects().length) {
                isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
                // Where available, offsetWidth/offsetHeight approximate border box dimensions.
                // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
                // retrieved value as a content box dimension.
                valueIsBorderBox = offsetProp in elem;
                if (valueIsBorderBox) val = elem[offsetProp];
            }
            // Normalize "" and auto
            val = parseFloat(val) || 0;
            // Adjust for the element's box model
            return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
            val) + "px";
        }
        jQuery.extend({
            // Add in style property hooks for overriding the default
            // behavior of getting and setting a style property
            cssHooks: {
                opacity: {
                    get: function(elem, computed) {
                        if (computed) {
                            // We should always get a number back from opacity
                            var ret = curCSS(elem, "opacity");
                            return ret === "" ? "1" : ret;
                        }
                    }
                }
            },
            // Don't automatically add "px" to these possibly-unitless properties
            cssNumber: {
                "animationIterationCount": true,
                "columnCount": true,
                "fillOpacity": true,
                "flexGrow": true,
                "flexShrink": true,
                "fontWeight": true,
                "gridArea": true,
                "gridColumn": true,
                "gridColumnEnd": true,
                "gridColumnStart": true,
                "gridRow": true,
                "gridRowEnd": true,
                "gridRowStart": true,
                "lineHeight": true,
                "opacity": true,
                "order": true,
                "orphans": true,
                "widows": true,
                "zIndex": true,
                "zoom": true
            },
            // Add in properties whose names you wish to fix before
            // setting or getting the value
            cssProps: {},
            // Get and set the style property on a DOM Node
            style: function(elem, name, value, extra) {
                // Don't set styles on text and comment nodes
                if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
                // Make sure that we're working with the right name
                var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
                // Make sure that we're working with the right name. We don't
                // want to query the value if it is a CSS custom property
                // since they are user-defined.
                if (!isCustomProp) name = finalPropName(origName);
                // Gets hook for the prefixed version, then unprefixed version
                hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
                // Check if we're setting a value
                if (value !== undefined) {
                    type = typeof value;
                    // Convert "+=" or "-=" to relative numbers (#7345)
                    if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                        value = adjustCSS(elem, name, ret);
                        // Fixes bug #9237
                        type = "number";
                    }
                    // Make sure that null and NaN values aren't set (#7116)
                    if (value == null || value !== value) return;
                    // If a number was passed in, add the unit (except for certain CSS properties)
                    // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                    // "px" to a few hardcoded values.
                    if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                    // background-* props affect original clone's values
                    if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                    // If a hook was provided, use that value, otherwise just set the specified value
                    if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                        if (isCustomProp) style.setProperty(name, value);
                        else style[name] = value;
                    }
                } else {
                    // If a hook was provided get the non-computed value from there
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                    // Otherwise just get the value from the style object
                    return style[name];
                }
            },
            css: function(elem, name, extra, styles) {
                var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
                // Make sure that we're working with the right name. We don't
                // want to modify the value if it is a CSS custom property
                // since they are user-defined.
                if (!isCustomProp) name = finalPropName(origName);
                // Try prefixed name followed by the unprefixed name
                hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
                // If a hook was provided get the computed value from there
                if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
                // Otherwise, if a way to get the computed value exists, use that
                if (val === undefined) val = curCSS(elem, name, styles);
                // Convert "normal" to computed value
                if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
                // Make numeric if forced or a qualifier was provided and val looks numeric
                if (extra === "" || extra) {
                    num = parseFloat(val);
                    return extra === true || isFinite(num) ? num || 0 : val;
                }
                return val;
            }
        });
        jQuery.each([
            "height",
            "width"
        ], function(_i, dimension) {
            jQuery.cssHooks[dimension] = {
                get: function(elem, computed, extra) {
                    if (computed) // Certain elements can have dimension info if we invisibly show them
                    // but it must have a current display style that would benefit
                    return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                    // Table columns in Safari have non-zero offsetWidth & zero
                    // getBoundingClientRect().width unless display is changed.
                    // Support: IE <=11 only
                    // Running getBoundingClientRect on a disconnected node
                    // in IE throws an error.
                    (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                        return getWidthOrHeight(elem, dimension, extra);
                    }) : getWidthOrHeight(elem, dimension, extra);
                },
                set: function(elem, value, extra) {
                    var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                    // to avoid forcing a reflow.
                    scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                    boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                    // Account for unreliable border-box dimensions by comparing offset* to computed and
                    // faking a content-box to get border and padding (gh-3699)
                    if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                    // Convert to pixels if value adjustment is needed
                    if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                        elem.style[dimension] = value;
                        value = jQuery.css(elem, dimension);
                    }
                    return setPositiveNumber(elem, value, subtract);
                }
            };
        });
        jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
            if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
                marginLeft: 0
            }, function() {
                return elem.getBoundingClientRect().left;
            })) + "px";
        });
        // These hooks are used by animate to expand properties
        jQuery.each({
            margin: "",
            padding: "",
            border: "Width"
        }, function(prefix, suffix) {
            jQuery.cssHooks[prefix + suffix] = {
                expand: function(value) {
                    var i = 0, expanded = {}, // Assumes a single number if not a string
                    parts = typeof value === "string" ? value.split(" ") : [
                        value
                    ];
                    for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                    return expanded;
                }
            };
            if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
        });
        jQuery.fn.extend({
            css: function(name, value) {
                return access(this, function(elem, name, value) {
                    var styles, len, map = {}, i = 0;
                    if (Array.isArray(name)) {
                        styles = getStyles(elem);
                        len = name.length;
                        for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                        return map;
                    }
                    return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
                }, name, value, arguments.length > 1);
            }
        });
        function Tween(elem, options, prop, end, easing) {
            return new Tween.prototype.init(elem, options, prop, end, easing);
        }
        jQuery.Tween = Tween;
        Tween.prototype = {
            constructor: Tween,
            init: function(elem, options, prop, end, easing, unit) {
                this.elem = elem;
                this.prop = prop;
                this.easing = easing || jQuery.easing._default;
                this.options = options;
                this.start = this.now = this.cur();
                this.end = end;
                this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
            },
            cur: function() {
                var hooks = Tween.propHooks[this.prop];
                return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
            },
            run: function(percent) {
                var eased, hooks = Tween.propHooks[this.prop];
                if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
                else this.pos = eased = percent;
                this.now = (this.end - this.start) * eased + this.start;
                if (this.options.step) this.options.step.call(this.elem, this.now, this);
                if (hooks && hooks.set) hooks.set(this);
                else Tween.propHooks._default.set(this);
                return this;
            }
        };
        Tween.prototype.init.prototype = Tween.prototype;
        Tween.propHooks = {
            _default: {
                get: function(tween) {
                    var result;
                    // Use a property on the element directly when it is not a DOM element,
                    // or when there is no matching style property that exists.
                    if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                    // Passing an empty string as a 3rd parameter to .css will automatically
                    // attempt a parseFloat and fallback to a string if the parse fails.
                    // Simple values such as "10px" are parsed to Float;
                    // complex values such as "rotate(1rad)" are returned as-is.
                    result = jQuery.css(tween.elem, tween.prop, "");
                    // Empty strings, null, undefined and "auto" are converted to 0.
                    return !result || result === "auto" ? 0 : result;
                },
                set: function(tween) {
                    // Use step hook for back compat.
                    // Use cssHook if its there.
                    // Use .style if available and use plain properties where available.
                    if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                    else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                    else tween.elem[tween.prop] = tween.now;
                }
            }
        };
        // Support: IE <=9 only
        // Panic based approach to setting things on disconnected nodes
        Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
            set: function(tween) {
                if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
            }
        };
        jQuery.easing = {
            linear: function(p) {
                return p;
            },
            swing: function(p) {
                return 0.5 - Math.cos(p * Math.PI) / 2;
            },
            _default: "swing"
        };
        jQuery.fx = Tween.prototype.init;
        // Back compat <1.8 extension point
        jQuery.fx.step = {};
        var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
        function schedule() {
            if (inProgress) {
                if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
                else window1.setTimeout(schedule, jQuery.fx.interval);
                jQuery.fx.tick();
            }
        }
        // Animations created synchronously will run synchronously
        function createFxNow() {
            window1.setTimeout(function() {
                fxNow = undefined;
            });
            return fxNow = Date.now();
        }
        // Generate parameters to create a standard animation
        function genFx(type, includeWidth) {
            var which, i = 0, attrs = {
                height: type
            };
            // If we include width, step value is 1 to do all cssExpand values,
            // otherwise step value is 2 to skip over Left and Right
            includeWidth = includeWidth ? 1 : 0;
            for(; i < 4; i += 2 - includeWidth){
                which = cssExpand[i];
                attrs["margin" + which] = attrs["padding" + which] = type;
            }
            if (includeWidth) attrs.opacity = attrs.width = type;
            return attrs;
        }
        function createTween(value, prop, animation) {
            var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
            for(; index < length; index++){
                if (tween = collection[index].call(animation, prop, value)) // We're done with this property
                return tween;
            }
        }
        function defaultPrefilter(elem, props, opts) {
            var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
            // Queue-skipping animations hijack the fx hooks
            if (!opts.queue) {
                hooks = jQuery._queueHooks(elem, "fx");
                if (hooks.unqueued == null) {
                    hooks.unqueued = 0;
                    oldfire = hooks.empty.fire;
                    hooks.empty.fire = function() {
                        if (!hooks.unqueued) oldfire();
                    };
                }
                hooks.unqueued++;
                anim.always(function() {
                    // Ensure the complete handler is called before this completes
                    anim.always(function() {
                        hooks.unqueued--;
                        if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                    });
                });
            }
            // Detect show/hide animations
            for(prop in props){
                value = props[prop];
                if (rfxtypes.test(value)) {
                    delete props[prop];
                    toggle = toggle || value === "toggle";
                    if (value === (hidden ? "hide" : "show")) {
                        // Pretend to be hidden if this is a "show" and
                        // there is still data from a stopped show/hide
                        if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                        else continue;
                    }
                    orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
                }
            }
            // Bail out if this is a no-op like .hide().hide()
            propTween = !jQuery.isEmptyObject(props);
            if (!propTween && jQuery.isEmptyObject(orig)) return;
            // Restrict "overflow" and "display" styles during box animations
            if (isBox && elem.nodeType === 1) {
                // Support: IE <=9 - 11, Edge 12 - 15
                // Record all 3 overflow attributes because IE does not infer the shorthand
                // from identically-valued overflowX and overflowY and Edge just mirrors
                // the overflowX value there.
                opts.overflow = [
                    style.overflow,
                    style.overflowX,
                    style.overflowY
                ];
                // Identify a display type, preferring old show/hide data over the CSS cascade
                restoreDisplay = dataShow && dataShow.display;
                if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
                display = jQuery.css(elem, "display");
                if (display === "none") {
                    if (restoreDisplay) display = restoreDisplay;
                    else {
                        // Get nonempty value(s) by temporarily forcing visibility
                        showHide([
                            elem
                        ], true);
                        restoreDisplay = elem.style.display || restoreDisplay;
                        display = jQuery.css(elem, "display");
                        showHide([
                            elem
                        ]);
                    }
                }
                // Animate inline elements as inline-block
                if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                    if (jQuery.css(elem, "float") === "none") {
                        // Restore the original display value at the end of pure show/hide animations
                        if (!propTween) {
                            anim.done(function() {
                                style.display = restoreDisplay;
                            });
                            if (restoreDisplay == null) {
                                display = style.display;
                                restoreDisplay = display === "none" ? "" : display;
                            }
                        }
                        style.display = "inline-block";
                    }
                }
            }
            if (opts.overflow) {
                style.overflow = "hidden";
                anim.always(function() {
                    style.overflow = opts.overflow[0];
                    style.overflowX = opts.overflow[1];
                    style.overflowY = opts.overflow[2];
                });
            }
            // Implement show/hide animations
            propTween = false;
            for(prop in orig){
                // General show/hide setup for this element animation
                if (!propTween) {
                    if (dataShow) {
                        if ("hidden" in dataShow) hidden = dataShow.hidden;
                    } else dataShow = dataPriv.access(elem, "fxshow", {
                        display: restoreDisplay
                    });
                    // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                    if (toggle) dataShow.hidden = !hidden;
                    // Show elements before animating them
                    if (hidden) showHide([
                        elem
                    ], true);
                    /* eslint-disable no-loop-func */ anim.done(function() {
                        /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                        if (!hidden) showHide([
                            elem
                        ]);
                        dataPriv.remove(elem, "fxshow");
                        for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                    });
                }
                // Per-property setup
                propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
                if (!(prop in dataShow)) {
                    dataShow[prop] = propTween.start;
                    if (hidden) {
                        propTween.end = propTween.start;
                        propTween.start = 0;
                    }
                }
            }
        }
        function propFilter(props, specialEasing) {
            var index, name, easing, value, hooks;
            // camelCase, specialEasing and expand cssHook pass
            for(index in props){
                name = camelCase(index);
                easing = specialEasing[name];
                value = props[index];
                if (Array.isArray(value)) {
                    easing = value[1];
                    value = props[index] = value[0];
                }
                if (index !== name) {
                    props[name] = value;
                    delete props[index];
                }
                hooks = jQuery.cssHooks[name];
                if (hooks && "expand" in hooks) {
                    value = hooks.expand(value);
                    delete props[name];
                    // Not quite $.extend, this won't overwrite existing keys.
                    // Reusing 'index' because we have the correct "name"
                    for(index in value)if (!(index in props)) {
                        props[index] = value[index];
                        specialEasing[index] = easing;
                    }
                } else specialEasing[name] = easing;
            }
        }
        function Animation(elem, properties, options) {
            var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
                // Don't match elem in the :animated selector
                delete tick.elem;
            }), tick = function() {
                if (stopped) return false;
                var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
                // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
                temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
                for(; index < length; index++)animation.tweens[index].run(percent);
                deferred.notifyWith(elem, [
                    animation,
                    percent,
                    remaining
                ]);
                // If there's more to do, yield
                if (percent < 1 && length) return remaining;
                // If this was an empty animation, synthesize a final progress notification
                if (!length) deferred.notifyWith(elem, [
                    animation,
                    1,
                    0
                ]);
                // Resolve the animation and report its conclusion
                deferred.resolveWith(elem, [
                    animation
                ]);
                return false;
            }, animation = deferred.promise({
                elem: elem,
                props: jQuery.extend({}, properties),
                opts: jQuery.extend(true, {
                    specialEasing: {},
                    easing: jQuery.easing._default
                }, options),
                originalProperties: properties,
                originalOptions: options,
                startTime: fxNow || createFxNow(),
                duration: options.duration,
                tweens: [],
                createTween: function(prop, end) {
                    var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                    animation.tweens.push(tween);
                    return tween;
                },
                stop: function(gotoEnd) {
                    var index = 0, // If we are going to the end, we want to run all the tweens
                    // otherwise we skip this part
                    length = gotoEnd ? animation.tweens.length : 0;
                    if (stopped) return this;
                    stopped = true;
                    for(; index < length; index++)animation.tweens[index].run(1);
                    // Resolve when we played the last frame; otherwise, reject
                    if (gotoEnd) {
                        deferred.notifyWith(elem, [
                            animation,
                            1,
                            0
                        ]);
                        deferred.resolveWith(elem, [
                            animation,
                            gotoEnd
                        ]);
                    } else deferred.rejectWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                    return this;
                }
            }), props = animation.props;
            propFilter(props, animation.opts.specialEasing);
            for(; index < length; index++){
                result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
                if (result) {
                    if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                    return result;
                }
            }
            jQuery.map(props, createTween, animation);
            if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
            // Attach callbacks from options
            animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
            jQuery.fx.timer(jQuery.extend(tick, {
                elem: elem,
                anim: animation,
                queue: animation.opts.queue
            }));
            return animation;
        }
        jQuery.Animation = jQuery.extend(Animation, {
            tweeners: {
                "*": [
                    function(prop, value) {
                        var tween = this.createTween(prop, value);
                        adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                        return tween;
                    }
                ]
            },
            tweener: function(props, callback) {
                if (isFunction(props)) {
                    callback = props;
                    props = [
                        "*"
                    ];
                } else props = props.match(rnothtmlwhite);
                var prop, index = 0, length = props.length;
                for(; index < length; index++){
                    prop = props[index];
                    Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                    Animation.tweeners[prop].unshift(callback);
                }
            },
            prefilters: [
                defaultPrefilter
            ],
            prefilter: function(callback, prepend) {
                if (prepend) Animation.prefilters.unshift(callback);
                else Animation.prefilters.push(callback);
            }
        });
        jQuery.speed = function(speed, easing, fn) {
            var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
                complete: fn || !fn && easing || isFunction(speed) && speed,
                duration: speed,
                easing: fn && easing || easing && !isFunction(easing) && easing
            };
            // Go to the end state if fx are off
            if (jQuery.fx.off) opt.duration = 0;
            else if (typeof opt.duration !== "number") {
                if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
                else opt.duration = jQuery.fx.speeds._default;
            }
            // Normalize opt.queue - true/undefined/null -> "fx"
            if (opt.queue == null || opt.queue === true) opt.queue = "fx";
            // Queueing
            opt.old = opt.complete;
            opt.complete = function() {
                if (isFunction(opt.old)) opt.old.call(this);
                if (opt.queue) jQuery.dequeue(this, opt.queue);
            };
            return opt;
        };
        jQuery.fn.extend({
            fadeTo: function(speed, to, easing, callback) {
                // Show any hidden elements after setting opacity to 0
                return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
                .end().animate({
                    opacity: to
                }, speed, easing, callback);
            },
            animate: function(prop, speed, easing, callback) {
                var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                    // Operate on a copy of prop so per-property easing won't be lost
                    var anim = Animation(this, jQuery.extend({}, prop), optall);
                    // Empty animations, or finishing resolves immediately
                    if (empty || dataPriv.get(this, "finish")) anim.stop(true);
                };
                doAnimation.finish = doAnimation;
                return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
            },
            stop: function(type, clearQueue, gotoEnd) {
                var stopQueue = function(hooks) {
                    var stop = hooks.stop;
                    delete hooks.stop;
                    stop(gotoEnd);
                };
                if (typeof type !== "string") {
                    gotoEnd = clearQueue;
                    clearQueue = type;
                    type = undefined;
                }
                if (clearQueue) this.queue(type || "fx", []);
                return this.each(function() {
                    var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                    if (index) {
                        if (data[index] && data[index].stop) stopQueue(data[index]);
                    } else {
                        for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                    }
                    for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                        timers[index].anim.stop(gotoEnd);
                        dequeue = false;
                        timers.splice(index, 1);
                    }
                    // Start the next in the queue if the last step wasn't forced.
                    // Timers currently will call their complete callbacks, which
                    // will dequeue but only if they were gotoEnd.
                    if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
                });
            },
            finish: function(type) {
                if (type !== false) type = type || "fx";
                return this.each(function() {
                    var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                    // Enable finishing flag on private data
                    data.finish = true;
                    // Empty the queue first
                    jQuery.queue(this, type, []);
                    if (hooks && hooks.stop) hooks.stop.call(this, true);
                    // Look for any active animations, and finish them
                    for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                        timers[index].anim.stop(true);
                        timers.splice(index, 1);
                    }
                    // Look for any animations in the old queue and finish them
                    for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                    // Turn off finishing flag
                    delete data.finish;
                });
            }
        });
        jQuery.each([
            "toggle",
            "show",
            "hide"
        ], function(_i, name) {
            var cssFn = jQuery.fn[name];
            jQuery.fn[name] = function(speed, easing, callback) {
                return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
            };
        });
        // Generate shortcuts for custom animations
        jQuery.each({
            slideDown: genFx("show"),
            slideUp: genFx("hide"),
            slideToggle: genFx("toggle"),
            fadeIn: {
                opacity: "show"
            },
            fadeOut: {
                opacity: "hide"
            },
            fadeToggle: {
                opacity: "toggle"
            }
        }, function(name, props) {
            jQuery.fn[name] = function(speed, easing, callback) {
                return this.animate(props, speed, easing, callback);
            };
        });
        jQuery.timers = [];
        jQuery.fx.tick = function() {
            var timer, i = 0, timers = jQuery.timers;
            fxNow = Date.now();
            for(; i < timers.length; i++){
                timer = timers[i];
                // Run the timer and safely remove it when done (allowing for external removal)
                if (!timer() && timers[i] === timer) timers.splice(i--, 1);
            }
            if (!timers.length) jQuery.fx.stop();
            fxNow = undefined;
        };
        jQuery.fx.timer = function(timer) {
            jQuery.timers.push(timer);
            jQuery.fx.start();
        };
        jQuery.fx.interval = 13;
        jQuery.fx.start = function() {
            if (inProgress) return;
            inProgress = true;
            schedule();
        };
        jQuery.fx.stop = function() {
            inProgress = null;
        };
        jQuery.fx.speeds = {
            slow: 600,
            fast: 200,
            // Default speed
            _default: 400
        };
        // Based off of the plugin by Clint Helfers, with permission.
        // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
        jQuery.fn.delay = function(time, type) {
            time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
            type = type || "fx";
            return this.queue(type, function(next, hooks) {
                var timeout = window1.setTimeout(next, time);
                hooks.stop = function() {
                    window1.clearTimeout(timeout);
                };
            });
        };
        (function() {
            var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
            input.type = "checkbox";
            // Support: Android <=4.3 only
            // Default value for a checkbox should be "on"
            support.checkOn = input.value !== "";
            // Support: IE <=11 only
            // Must access selectedIndex to make default options select
            support.optSelected = opt.selected;
            // Support: IE <=11 only
            // An input loses its value after becoming a radio
            input = document.createElement("input");
            input.value = "t";
            input.type = "radio";
            support.radioValue = input.value === "t";
        })();
        var boolHook, attrHandle = jQuery.expr.attrHandle;
        jQuery.fn.extend({
            attr: function(name, value) {
                return access(this, jQuery.attr, name, value, arguments.length > 1);
            },
            removeAttr: function(name) {
                return this.each(function() {
                    jQuery.removeAttr(this, name);
                });
            }
        });
        jQuery.extend({
            attr: function(elem, name, value) {
                var ret, hooks, nType = elem.nodeType;
                // Don't get/set attributes on text, comment and attribute nodes
                if (nType === 3 || nType === 8 || nType === 2) return;
                // Fallback to prop when attributes are not supported
                if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
                // Attribute hooks are determined by the lowercase version
                // Grab necessary hook if one is defined
                if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
                if (value !== undefined) {
                    if (value === null) {
                        jQuery.removeAttr(elem, name);
                        return;
                    }
                    if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                    elem.setAttribute(name, value + "");
                    return value;
                }
                if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
                ret = jQuery.find.attr(elem, name);
                // Non-existent attributes return null, we normalize to undefined
                return ret == null ? undefined : ret;
            },
            attrHooks: {
                type: {
                    set: function(elem, value) {
                        if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                            var val = elem.value;
                            elem.setAttribute("type", value);
                            if (val) elem.value = val;
                            return value;
                        }
                    }
                }
            },
            removeAttr: function(elem, value) {
                var name, i = 0, // Attribute names can contain non-HTML whitespace characters
                // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
                attrNames = value && value.match(rnothtmlwhite);
                if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
            }
        });
        // Hooks for boolean attributes
        boolHook = {
            set: function(elem, value, name) {
                if (value === false) // Remove boolean attributes when set to false
                jQuery.removeAttr(elem, name);
                else elem.setAttribute(name, name);
                return name;
            }
        };
        jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
            var getter = attrHandle[name] || jQuery.find.attr;
            attrHandle[name] = function(elem, name, isXML) {
                var ret, handle, lowercaseName = name.toLowerCase();
                if (!isXML) {
                    // Avoid an infinite loop by temporarily removing this function from the getter
                    handle = attrHandle[lowercaseName];
                    attrHandle[lowercaseName] = ret;
                    ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                    attrHandle[lowercaseName] = handle;
                }
                return ret;
            };
        });
        var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
        jQuery.fn.extend({
            prop: function(name, value) {
                return access(this, jQuery.prop, name, value, arguments.length > 1);
            },
            removeProp: function(name) {
                return this.each(function() {
                    delete this[jQuery.propFix[name] || name];
                });
            }
        });
        jQuery.extend({
            prop: function(elem, name, value) {
                var ret, hooks, nType = elem.nodeType;
                // Don't get/set properties on text, comment and attribute nodes
                if (nType === 3 || nType === 8 || nType === 2) return;
                if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                    // Fix name and attach hooks
                    name = jQuery.propFix[name] || name;
                    hooks = jQuery.propHooks[name];
                }
                if (value !== undefined) {
                    if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                    return elem[name] = value;
                }
                if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
                return elem[name];
            },
            propHooks: {
                tabIndex: {
                    get: function(elem) {
                        // Support: IE <=9 - 11 only
                        // elem.tabIndex doesn't always return the
                        // correct value when it hasn't been explicitly set
                        // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                        // Use proper attribute retrieval(#12072)
                        var tabindex = jQuery.find.attr(elem, "tabindex");
                        if (tabindex) return parseInt(tabindex, 10);
                        if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                        return -1;
                    }
                }
            },
            propFix: {
                "for": "htmlFor",
                "class": "className"
            }
        });
        // Support: IE <=11 only
        // Accessing the selectedIndex property
        // forces the browser to respect setting selected
        // on the option
        // The getter ensures a default option is selected
        // when in an optgroup
        // eslint rule "no-unused-expressions" is disabled for this code
        // since it considers such accessions noop
        if (!support.optSelected) jQuery.propHooks.selected = {
            get: function(elem) {
                /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
                if (parent && parent.parentNode) parent.parentNode.selectedIndex;
                return null;
            },
            set: function(elem) {
                /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
                if (parent) {
                    parent.selectedIndex;
                    if (parent.parentNode) parent.parentNode.selectedIndex;
                }
            }
        };
        jQuery.each([
            "tabIndex",
            "readOnly",
            "maxLength",
            "cellSpacing",
            "cellPadding",
            "rowSpan",
            "colSpan",
            "useMap",
            "frameBorder",
            "contentEditable"
        ], function() {
            jQuery.propFix[this.toLowerCase()] = this;
        });
        // Strip and collapse whitespace according to HTML spec
        // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
        function stripAndCollapse(value) {
            var tokens = value.match(rnothtmlwhite) || [];
            return tokens.join(" ");
        }
        function getClass(elem) {
            return elem.getAttribute && elem.getAttribute("class") || "";
        }
        function classesToArray(value) {
            if (Array.isArray(value)) return value;
            if (typeof value === "string") return value.match(rnothtmlwhite) || [];
            return [];
        }
        jQuery.fn.extend({
            addClass: function(value) {
                var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
                if (isFunction(value)) return this.each(function(j) {
                    jQuery(this).addClass(value.call(this, j, getClass(this)));
                });
                classes = classesToArray(value);
                if (classes.length) while(elem = this[i++]){
                    curValue = getClass(elem);
                    cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                    if (cur) {
                        j = 0;
                        while(clazz = classes[j++])if (cur.indexOf(" " + clazz + " ") < 0) cur += clazz + " ";
                        // Only assign if different to avoid unneeded rendering.
                        finalValue = stripAndCollapse(cur);
                        if (curValue !== finalValue) elem.setAttribute("class", finalValue);
                    }
                }
                return this;
            },
            removeClass: function(value) {
                var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
                if (isFunction(value)) return this.each(function(j) {
                    jQuery(this).removeClass(value.call(this, j, getClass(this)));
                });
                if (!arguments.length) return this.attr("class", "");
                classes = classesToArray(value);
                if (classes.length) while(elem = this[i++]){
                    curValue = getClass(elem);
                    // This expression is here for better compressibility (see addClass)
                    cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                    if (cur) {
                        j = 0;
                        while(clazz = classes[j++])// Remove *all* instances
                        while(cur.indexOf(" " + clazz + " ") > -1)cur = cur.replace(" " + clazz + " ", " ");
                        // Only assign if different to avoid unneeded rendering.
                        finalValue = stripAndCollapse(cur);
                        if (curValue !== finalValue) elem.setAttribute("class", finalValue);
                    }
                }
                return this;
            },
            toggleClass: function(value, stateVal) {
                var type = typeof value, isValidValue = type === "string" || Array.isArray(value);
                if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
                if (isFunction(value)) return this.each(function(i) {
                    jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
                });
                return this.each(function() {
                    var className, i, self, classNames;
                    if (isValidValue) {
                        // Toggle individual class names
                        i = 0;
                        self = jQuery(this);
                        classNames = classesToArray(value);
                        while(className = classNames[i++])// Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    // Toggle whole class name
                    } else if (value === undefined || type === "boolean") {
                        className = getClass(this);
                        if (className) // Store className if set
                        dataPriv.set(this, "__className__", className);
                        // If the element has a class name or if we're passed `false`,
                        // then remove the whole classname (if there was one, the above saved it).
                        // Otherwise bring back whatever was previously saved (if anything),
                        // falling back to the empty string if nothing was stored.
                        if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                    }
                });
            },
            hasClass: function(selector) {
                var className, elem, i = 0;
                className = " " + selector + " ";
                while(elem = this[i++]){
                    if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
                }
                return false;
            }
        });
        var rreturn = /\r/g;
        jQuery.fn.extend({
            val: function(value) {
                var hooks, ret, valueIsFunction, elem = this[0];
                if (!arguments.length) {
                    if (elem) {
                        hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                        if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                        ret = elem.value;
                        // Handle most common string cases
                        if (typeof ret === "string") return ret.replace(rreturn, "");
                        // Handle cases where value is null/undef or number
                        return ret == null ? "" : ret;
                    }
                    return;
                }
                valueIsFunction = isFunction(value);
                return this.each(function(i) {
                    var val;
                    if (this.nodeType !== 1) return;
                    if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                    else val = value;
                    // Treat null/undefined as ""; convert numbers to string
                    if (val == null) val = "";
                    else if (typeof val === "number") val += "";
                    else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                        return value == null ? "" : value + "";
                    });
                    hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                    // If set returns undefined, fall back to normal setting
                    if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
                });
            }
        });
        jQuery.extend({
            valHooks: {
                option: {
                    get: function(elem) {
                        var val = jQuery.find.attr(elem, "value");
                        return val != null ? val : // Support: IE <=10 - 11 only
                        // option.text throws exceptions (#14686, #14858)
                        // Strip and collapse whitespace
                        // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                        stripAndCollapse(jQuery.text(elem));
                    }
                },
                select: {
                    get: function(elem) {
                        var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                        if (index < 0) i = max;
                        else i = one ? index : 0;
                        // Loop through all the selected options
                        for(; i < max; i++){
                            option = options[i];
                            // Support: IE <=9 only
                            // IE8-9 doesn't update selected after form reset (#2551)
                            if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                            !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                                // Get the specific value for the option
                                value = jQuery(option).val();
                                // We don't need an array for one selects
                                if (one) return value;
                                // Multi-Selects return an array
                                values.push(value);
                            }
                        }
                        return values;
                    },
                    set: function(elem, value) {
                        var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                        while(i--){
                            option = options[i];
                            /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                        /* eslint-enable no-cond-assign */ }
                        // Force browsers to behave consistently when non-matching value is set
                        if (!optionSet) elem.selectedIndex = -1;
                        return values;
                    }
                }
            }
        });
        // Radios and checkboxes getter/setter
        jQuery.each([
            "radio",
            "checkbox"
        ], function() {
            jQuery.valHooks[this] = {
                set: function(elem, value) {
                    if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
                }
            };
            if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
                return elem.getAttribute("value") === null ? "on" : elem.value;
            };
        });
        // Return jQuery for attributes-only inclusion
        support.focusin = "onfocusin" in window1;
        var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
            e.stopPropagation();
        };
        jQuery.extend(jQuery.event, {
            trigger: function(event, data, elem, onlyHandlers) {
                var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                    elem || document
                ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
                cur = lastElement = tmp = elem = elem || document;
                // Don't do events on text and comment nodes
                if (elem.nodeType === 3 || elem.nodeType === 8) return;
                // focus/blur morphs to focusin/out; ensure we're not firing them right now
                if (rfocusMorph.test(type + jQuery.event.triggered)) return;
                if (type.indexOf(".") > -1) {
                    // Namespaced trigger; create a regexp to match event type in handle()
                    namespaces = type.split(".");
                    type = namespaces.shift();
                    namespaces.sort();
                }
                ontype = type.indexOf(":") < 0 && "on" + type;
                // Caller can pass in a jQuery.Event object, Object, or just an event type string
                event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
                // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
                event.isTrigger = onlyHandlers ? 2 : 3;
                event.namespace = namespaces.join(".");
                event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
                // Clean up the event in case it is being reused
                event.result = undefined;
                if (!event.target) event.target = elem;
                // Clone any incoming data and prepend the event, creating the handler arg list
                data = data == null ? [
                    event
                ] : jQuery.makeArray(data, [
                    event
                ]);
                // Allow special events to draw outside the lines
                special = jQuery.event.special[type] || {};
                if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
                // Determine event propagation path in advance, per W3C events spec (#9951)
                // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
                if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                    bubbleType = special.delegateType || type;
                    if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                    for(; cur; cur = cur.parentNode){
                        eventPath.push(cur);
                        tmp = cur;
                    }
                    // Only add window if we got to document (e.g., not plain obj or detached DOM)
                    if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
                }
                // Fire handlers on the event path
                i = 0;
                while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                    lastElement = cur;
                    event.type = i > 1 ? bubbleType : special.bindType || type;
                    // jQuery handler
                    handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                    if (handle) handle.apply(cur, data);
                    // Native handler
                    handle = ontype && cur[ontype];
                    if (handle && handle.apply && acceptData(cur)) {
                        event.result = handle.apply(cur, data);
                        if (event.result === false) event.preventDefault();
                    }
                }
                event.type = type;
                // If nobody prevented the default action, do it now
                if (!onlyHandlers && !event.isDefaultPrevented()) {
                    if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                    // Don't do default actions on window, that's where global variables be (#6170)
                    {
                        if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                            // Don't re-trigger an onFOO event when we call its FOO() method
                            tmp = elem[ontype];
                            if (tmp) elem[ontype] = null;
                            // Prevent re-triggering of the same event, since we already bubbled it above
                            jQuery.event.triggered = type;
                            if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                            elem[type]();
                            if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                            jQuery.event.triggered = undefined;
                            if (tmp) elem[ontype] = tmp;
                        }
                    }
                }
                return event.result;
            },
            // Piggyback on a donor event to simulate a different one
            // Used only for `focus(in | out)` events
            simulate: function(type, elem, event) {
                var e = jQuery.extend(new jQuery.Event(), event, {
                    type: type,
                    isSimulated: true
                });
                jQuery.event.trigger(e, null, elem);
            }
        });
        jQuery.fn.extend({
            trigger: function(type, data) {
                return this.each(function() {
                    jQuery.event.trigger(type, data, this);
                });
            },
            triggerHandler: function(type, data) {
                var elem = this[0];
                if (elem) return jQuery.event.trigger(type, data, elem, true);
            }
        });
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        if (!support.focusin) jQuery.each({
            focus: "focusin",
            blur: "focusout"
        }, function(orig, fix) {
            // Attach a single capturing handler on the document while someone wants focusin/focusout
            var handler = function(event) {
                jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
            };
            jQuery.event.special[fix] = {
                setup: function() {
                    // Handle: regular nodes (via `this.ownerDocument`), window
                    // (via `this.document`) & document (via `this`).
                    var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix);
                    if (!attaches) doc.addEventListener(orig, handler, true);
                    dataPriv.access(doc, fix, (attaches || 0) + 1);
                },
                teardown: function() {
                    var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix) - 1;
                    if (!attaches) {
                        doc.removeEventListener(orig, handler, true);
                        dataPriv.remove(doc, fix);
                    } else dataPriv.access(doc, fix, attaches);
                }
            };
        });
        var location = window1.location;
        var nonce = {
            guid: Date.now()
        };
        var rquery = /\?/;
        // Cross-browser xml parsing
        jQuery.parseXML = function(data) {
            var xml, parserErrorElem;
            if (!data || typeof data !== "string") return null;
            // Support: IE 9 - 11 only
            // IE throws on parseFromString with invalid input.
            try {
                xml = new window1.DOMParser().parseFromString(data, "text/xml");
            } catch (e) {}
            parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
            if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
                return el.textContent;
            }).join("\n") : data));
            return xml;
        };
        var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
        function buildParams(prefix, obj, traditional, add) {
            var name;
            if (Array.isArray(obj)) // Serialize array item.
            jQuery.each(obj, function(i, v) {
                if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
                add(prefix, v);
                else // Item is non-scalar (array or object), encode its numeric index.
                buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
            });
            else if (!traditional && toType(obj) === "object") // Serialize object item.
            for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
            else // Serialize scalar item.
            add(prefix, obj);
        }
        // Serialize an array of form elements or a set of
        // key/values into a query string
        jQuery.param = function(a, traditional) {
            var prefix, s = [], add = function(key, valueOrFunction) {
                // If value is a function, invoke it and use its return value
                var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
                s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
            };
            if (a == null) return "";
            // If an array was passed in, assume that it is an array of form elements.
            if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
            jQuery.each(a, function() {
                add(this.name, this.value);
            });
            else // If traditional, encode the "old" way (the way 1.3.2 or older
            // did it), otherwise encode params recursively.
            for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
            // Return the resulting serialization
            return s.join("&");
        };
        jQuery.fn.extend({
            serialize: function() {
                return jQuery.param(this.serializeArray());
            },
            serializeArray: function() {
                return this.map(function() {
                    // Can add propHook for "elements" to filter or add form elements
                    var elements = jQuery.prop(this, "elements");
                    return elements ? jQuery.makeArray(elements) : this;
                }).filter(function() {
                    var type = this.type;
                    // Use .is( ":disabled" ) so that fieldset[disabled] works
                    return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
                }).map(function(_i, elem) {
                    var val = jQuery(this).val();
                    if (val == null) return null;
                    if (Array.isArray(val)) return jQuery.map(val, function(val) {
                        return {
                            name: elem.name,
                            value: val.replace(rCRLF, "\r\n")
                        };
                    });
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                }).get();
            }
        });
        var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // #7653, #8125, #8152: local protocol detection
        rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
        allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
        originAnchor = document.createElement("a");
        originAnchor.href = location.href;
        // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
        function addToPrefiltersOrTransports(structure) {
            // dataTypeExpression is optional and defaults to "*"
            return function(dataTypeExpression, func) {
                if (typeof dataTypeExpression !== "string") {
                    func = dataTypeExpression;
                    dataTypeExpression = "*";
                }
                var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
                if (isFunction(func)) {
                    // For each dataType in the dataTypeExpression
                    while(dataType = dataTypes[i++])// Prepend if requested
                    if (dataType[0] === "+") {
                        dataType = dataType.slice(1) || "*";
                        (structure[dataType] = structure[dataType] || []).unshift(func);
                    // Otherwise append
                    } else (structure[dataType] = structure[dataType] || []).push(func);
                }
            };
        }
        // Base inspection function for prefilters and transports
        function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
            var inspected = {}, seekingTransport = structure === transports;
            function inspect(dataType) {
                var selected;
                inspected[dataType] = true;
                jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                    var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                    if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                        options.dataTypes.unshift(dataTypeOrTransport);
                        inspect(dataTypeOrTransport);
                        return false;
                    } else if (seekingTransport) return !(selected = dataTypeOrTransport);
                });
                return selected;
            }
            return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
        }
        // A special extend for ajax options
        // that takes "flat" options (not to be deep extended)
        // Fixes #9887
        function ajaxExtend(target, src) {
            var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
            for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
            if (deep) jQuery.extend(true, target, deep);
            return target;
        }
        /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
            var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
            // Remove auto dataType and get content-type in the process
            while(dataTypes[0] === "*"){
                dataTypes.shift();
                if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
            }
            // Check if we're dealing with a known content-type
            if (ct) {
                for(type in contents)if (contents[type] && contents[type].test(ct)) {
                    dataTypes.unshift(type);
                    break;
                }
            }
            // Check to see if we have a response for the expected dataType
            if (dataTypes[0] in responses) finalDataType = dataTypes[0];
            else {
                // Try convertible dataTypes
                for(type in responses){
                    if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                        finalDataType = type;
                        break;
                    }
                    if (!firstDataType) firstDataType = type;
                }
                // Or just use first one
                finalDataType = finalDataType || firstDataType;
            }
            // If we found a dataType
            // We add the dataType to the list if needed
            // and return the corresponding response
            if (finalDataType) {
                if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
                return responses[finalDataType];
            }
        }
        /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
            var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
            dataTypes = s.dataTypes.slice();
            // Create converters map with lowercased keys
            if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
            current = dataTypes.shift();
            // Convert to each sequential dataType
            while(current){
                if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
                // Apply the dataFilter if provided
                if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
                prev = current;
                current = dataTypes.shift();
                if (current) {
                    // There's only work to do if current dataType is non-auto
                    if (current === "*") current = prev;
                    else if (prev !== "*" && prev !== current) {
                        // Seek a direct converter
                        conv = converters[prev + " " + current] || converters["* " + current];
                        // If none found, seek a pair
                        if (!conv) for(conv2 in converters){
                            // If conv2 outputs current
                            tmp = conv2.split(" ");
                            if (tmp[1] === current) {
                                // If prev can be converted to accepted input
                                conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                                if (conv) {
                                    // Condense equivalence converters
                                    if (conv === true) conv = converters[conv2];
                                    else if (converters[conv2] !== true) {
                                        current = tmp[0];
                                        dataTypes.unshift(tmp[1]);
                                    }
                                    break;
                                }
                            }
                        }
                        // Apply converter (if not an equivalence)
                        if (conv !== true) {
                            // Unless errors are allowed to bubble, catch and return them
                            if (conv && s.throws) response = conv(response);
                            else try {
                                response = conv(response);
                            } catch (e) {
                                return {
                                    state: "parsererror",
                                    error: conv ? e : "No conversion from " + prev + " to " + current
                                };
                            }
                        }
                    }
                }
            }
            return {
                state: "success",
                data: response
            };
        }
        jQuery.extend({
            // Counter for holding the number of active queries
            active: 0,
            // Last-Modified header cache for next request
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: location.href,
                type: "GET",
                isLocal: rlocalProtocol.test(location.protocol),
                global: true,
                processData: true,
                async: true,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                    "*": allTypes,
                    text: "text/plain",
                    html: "text/html",
                    xml: "application/xml, text/xml",
                    json: "application/json, text/javascript"
                },
                contents: {
                    xml: /\bxml\b/,
                    html: /\bhtml/,
                    json: /\bjson\b/
                },
                responseFields: {
                    xml: "responseXML",
                    text: "responseText",
                    json: "responseJSON"
                },
                // Data converters
                // Keys separate source (or catchall "*") and destination types with a single space
                converters: {
                    // Convert anything to text
                    "* text": String,
                    // Text to html (true = no transformation)
                    "text html": true,
                    // Evaluate text as a json expression
                    "text json": JSON.parse,
                    // Parse text as xml
                    "text xml": jQuery.parseXML
                },
                // For options that shouldn't be deep extended:
                // you can add your own custom options here if
                // and when you create one that shouldn't be
                // deep extended (see ajaxExtend)
                flatOptions: {
                    url: true,
                    context: true
                }
            },
            // Creates a full fledged settings object into target
            // with both ajaxSettings and settings fields.
            // If target is omitted, writes into ajaxSettings.
            ajaxSetup: function(target, settings) {
                return settings ? // Building a settings object
                ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
                ajaxExtend(jQuery.ajaxSettings, target);
            },
            ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
            ajaxTransport: addToPrefiltersOrTransports(transports),
            // Main method
            ajax: function(url, options) {
                // If url is an object, simulate pre-1.5 signature
                if (typeof url === "object") {
                    options = url;
                    url = undefined;
                }
                // Force options to be an object
                options = options || {};
                var transport, // URL without anti-cache param
                cacheURL, // Response headers
                responseHeadersString, responseHeaders, // timeout handle
                timeoutTimer, // Url cleanup var
                urlAnchor, // Request state (becomes false upon send and true upon completion)
                completed, // To know if global events are to be dispatched
                fireGlobals, // Loop variable
                i, // uncached part of the url
                uncached, // Create the final options object
                s = jQuery.ajaxSetup({}, options), // Callbacks context
                callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
                globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
                deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
                statusCode = s.statusCode || {}, // Headers (they are sent all at once)
                requestHeaders = {}, requestHeadersNames = {}, // Default abort message
                strAbort = "canceled", // Fake xhr
                jqXHR = {
                    readyState: 0,
                    // Builds headers hashtable if needed
                    getResponseHeader: function(key) {
                        var match;
                        if (completed) {
                            if (!responseHeaders) {
                                responseHeaders = {};
                                while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                            }
                            match = responseHeaders[key.toLowerCase() + " "];
                        }
                        return match == null ? null : match.join(", ");
                    },
                    // Raw string
                    getAllResponseHeaders: function() {
                        return completed ? responseHeadersString : null;
                    },
                    // Caches the header
                    setRequestHeader: function(name, value) {
                        if (completed == null) {
                            name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                            requestHeaders[name] = value;
                        }
                        return this;
                    },
                    // Overrides response content-type header
                    overrideMimeType: function(type) {
                        if (completed == null) s.mimeType = type;
                        return this;
                    },
                    // Status-dependent callbacks
                    statusCode: function(map) {
                        var code;
                        if (map) {
                            if (completed) // Execute the appropriate callbacks
                            jqXHR.always(map[jqXHR.status]);
                            else // Lazy-add the new callbacks in a way that preserves old ones
                            for(code in map)statusCode[code] = [
                                statusCode[code],
                                map[code]
                            ];
                        }
                        return this;
                    },
                    // Cancel the request
                    abort: function(statusText) {
                        var finalText = statusText || strAbort;
                        if (transport) transport.abort(finalText);
                        done(0, finalText);
                        return this;
                    }
                };
                // Attach deferreds
                deferred.promise(jqXHR);
                // Add protocol if not provided (prefilters might expect it)
                // Handle falsy url in the settings object (#10093: consistency with old signature)
                // We also use the url parameter if available
                s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
                // Alias method option to type as per ticket #12004
                s.type = options.method || options.type || s.method || s.type;
                // Extract dataTypes list
                s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                    ""
                ];
                // A cross-domain request is in order when the origin doesn't match the current origin.
                if (s.crossDomain == null) {
                    urlAnchor = document.createElement("a");
                    // Support: IE <=8 - 11, Edge 12 - 15
                    // IE throws exception on accessing the href property if url is malformed,
                    // e.g. http://example.com:80x/
                    try {
                        urlAnchor.href = s.url;
                        // Support: IE <=8 - 11 only
                        // Anchor's host property isn't correctly set when s.url is relative
                        urlAnchor.href = urlAnchor.href;
                        s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                    } catch (e) {
                        // If there is an error parsing the URL, assume it is crossDomain,
                        // it can be rejected by the transport if it is invalid
                        s.crossDomain = true;
                    }
                }
                // Convert data if not already a string
                if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
                // Apply prefilters
                inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
                // If request was aborted inside a prefilter, stop there
                if (completed) return jqXHR;
                // We can fire global events as of now if asked to
                // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
                fireGlobals = jQuery.event && s.global;
                // Watch for a new set of requests
                if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
                // Uppercase the type
                s.type = s.type.toUpperCase();
                // Determine if request has content
                s.hasContent = !rnoContent.test(s.type);
                // Save the URL in case we're toying with the If-Modified-Since
                // and/or If-None-Match header later on
                // Remove hash to simplify url manipulation
                cacheURL = s.url.replace(rhash, "");
                // More options handling for requests with no content
                if (!s.hasContent) {
                    // Remember the hash so we can put it back
                    uncached = s.url.slice(cacheURL.length);
                    // If data is available and should be processed, append data to url
                    if (s.data && (s.processData || typeof s.data === "string")) {
                        cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                        // #9682: remove data so that it's not used in an eventual retry
                        delete s.data;
                    }
                    // Add or update anti-cache param if needed
                    if (s.cache === false) {
                        cacheURL = cacheURL.replace(rantiCache, "$1");
                        uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                    }
                    // Put hash and anti-cache on the URL that will be requested (gh-1732)
                    s.url = cacheURL + uncached;
                // Change '%20' to '+' if this is encoded form body content (gh-2658)
                } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
                // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                if (s.ifModified) {
                    if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                    if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
                }
                // Set the correct header, if data is being sent
                if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
                // Set the Accepts header for the server, depending on the dataType
                jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
                // Check for headers option
                for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
                // Allow custom headers/mimetypes and early abort
                if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
                return jqXHR.abort();
                // Aborting is no longer a cancellation
                strAbort = "abort";
                // Install callbacks on deferreds
                completeDeferred.add(s.complete);
                jqXHR.done(s.success);
                jqXHR.fail(s.error);
                // Get transport
                transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
                // If no transport, we auto-abort
                if (!transport) done(-1, "No Transport");
                else {
                    jqXHR.readyState = 1;
                    // Send global event
                    if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                        jqXHR,
                        s
                    ]);
                    // If request was aborted inside ajaxSend, stop there
                    if (completed) return jqXHR;
                    // Timeout
                    if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                        jqXHR.abort("timeout");
                    }, s.timeout);
                    try {
                        completed = false;
                        transport.send(requestHeaders, done);
                    } catch (e) {
                        // Rethrow post-completion exceptions
                        if (completed) throw e;
                        // Propagate others as results
                        done(-1, e);
                    }
                }
                // Callback for when everything is done
                function done(status, nativeStatusText, responses, headers) {
                    var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                    // Ignore repeat invocations
                    if (completed) return;
                    completed = true;
                    // Clear timeout if it exists
                    if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                    // Dereference transport for early garbage collection
                    // (no matter how long the jqXHR object will be used)
                    transport = undefined;
                    // Cache response headers
                    responseHeadersString = headers || "";
                    // Set readyState
                    jqXHR.readyState = status > 0 ? 4 : 0;
                    // Determine if successful
                    isSuccess = status >= 200 && status < 300 || status === 304;
                    // Get response data
                    if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                    // Use a noop converter for missing script but not if jsonp
                    if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                    // Convert no matter what (that way responseXXX fields are always set)
                    response = ajaxConvert(s, response, jqXHR, isSuccess);
                    // If successful, handle type chaining
                    if (isSuccess) {
                        // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                        if (s.ifModified) {
                            modified = jqXHR.getResponseHeader("Last-Modified");
                            if (modified) jQuery.lastModified[cacheURL] = modified;
                            modified = jqXHR.getResponseHeader("etag");
                            if (modified) jQuery.etag[cacheURL] = modified;
                        }
                        // if no content
                        if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                        else if (status === 304) statusText = "notmodified";
                        else {
                            statusText = response.state;
                            success = response.data;
                            error = response.error;
                            isSuccess = !error;
                        }
                    } else {
                        // Extract error from statusText and normalize for non-aborts
                        error = statusText;
                        if (status || !statusText) {
                            statusText = "error";
                            if (status < 0) status = 0;
                        }
                    }
                    // Set data for the fake xhr object
                    jqXHR.status = status;
                    jqXHR.statusText = (nativeStatusText || statusText) + "";
                    // Success/Error
                    if (isSuccess) deferred.resolveWith(callbackContext, [
                        success,
                        statusText,
                        jqXHR
                    ]);
                    else deferred.rejectWith(callbackContext, [
                        jqXHR,
                        statusText,
                        error
                    ]);
                    // Status-dependent callbacks
                    jqXHR.statusCode(statusCode);
                    statusCode = undefined;
                    if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                        jqXHR,
                        s,
                        isSuccess ? success : error
                    ]);
                    // Complete
                    completeDeferred.fireWith(callbackContext, [
                        jqXHR,
                        statusText
                    ]);
                    if (fireGlobals) {
                        globalEventContext.trigger("ajaxComplete", [
                            jqXHR,
                            s
                        ]);
                        // Handle the global AJAX counter
                        if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                    }
                }
                return jqXHR;
            },
            getJSON: function(url, data, callback) {
                return jQuery.get(url, data, callback, "json");
            },
            getScript: function(url, callback) {
                return jQuery.get(url, undefined, callback, "script");
            }
        });
        jQuery.each([
            "get",
            "post"
        ], function(_i, method) {
            jQuery[method] = function(url, data, callback, type) {
                // Shift arguments if data argument was omitted
                if (isFunction(data)) {
                    type = type || callback;
                    callback = data;
                    data = undefined;
                }
                // The url can be an options object (which then must have .url)
                return jQuery.ajax(jQuery.extend({
                    url: url,
                    type: method,
                    dataType: type,
                    data: data,
                    success: callback
                }, jQuery.isPlainObject(url) && url));
            };
        });
        jQuery.ajaxPrefilter(function(s) {
            var i;
            for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
        });
        jQuery._evalUrl = function(url, options, doc) {
            return jQuery.ajax({
                url: url,
                // Make this explicit, since user can override this through ajaxSetup (#11264)
                type: "GET",
                dataType: "script",
                cache: true,
                async: false,
                global: false,
                // Only evaluate the response if it is successful (gh-4126)
                // dataFilter is not invoked for failure responses, so using it instead
                // of the default converter is kludgy but it works.
                converters: {
                    "text script": function() {}
                },
                dataFilter: function(response) {
                    jQuery.globalEval(response, options, doc);
                }
            });
        };
        jQuery.fn.extend({
            wrapAll: function(html) {
                var wrap;
                if (this[0]) {
                    if (isFunction(html)) html = html.call(this[0]);
                    // The elements to wrap the target around
                    wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                    if (this[0].parentNode) wrap.insertBefore(this[0]);
                    wrap.map(function() {
                        var elem = this;
                        while(elem.firstElementChild)elem = elem.firstElementChild;
                        return elem;
                    }).append(this);
                }
                return this;
            },
            wrapInner: function(html) {
                if (isFunction(html)) return this.each(function(i) {
                    jQuery(this).wrapInner(html.call(this, i));
                });
                return this.each(function() {
                    var self = jQuery(this), contents = self.contents();
                    if (contents.length) contents.wrapAll(html);
                    else self.append(html);
                });
            },
            wrap: function(html) {
                var htmlIsFunction = isFunction(html);
                return this.each(function(i) {
                    jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
                });
            },
            unwrap: function(selector) {
                this.parent(selector).not("body").each(function() {
                    jQuery(this).replaceWith(this.childNodes);
                });
                return this;
            }
        });
        jQuery.expr.pseudos.hidden = function(elem) {
            return !jQuery.expr.pseudos.visible(elem);
        };
        jQuery.expr.pseudos.visible = function(elem) {
            return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
        };
        jQuery.ajaxSettings.xhr = function() {
            try {
                return new window1.XMLHttpRequest();
            } catch (e) {}
        };
        var xhrSuccessStatus = {
            // File protocol always yields status code 0, assume 200
            0: 200,
            // Support: IE <=9 only
            // #1450: sometimes IE returns 1223 when it should be 204
            1223: 204
        }, xhrSupported = jQuery.ajaxSettings.xhr();
        support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
        support.ajax = xhrSupported = !!xhrSupported;
        jQuery.ajaxTransport(function(options) {
            var callback, errorCallback;
            // Cross domain only allowed if supported through XMLHttpRequest
            if (support.cors || xhrSupported && !options.crossDomain) return {
                send: function(headers, complete) {
                    var i, xhr = options.xhr();
                    xhr.open(options.type, options.url, options.async, options.username, options.password);
                    // Apply custom fields if provided
                    if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                    // Override mime type if needed
                    if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                    // X-Requested-With header
                    // For cross-domain requests, seeing as conditions for a preflight are
                    // akin to a jigsaw puzzle, we simply never set it to be sure.
                    // (it can always be set on a per-request basis or even using ajaxSetup)
                    // For same-domain requests, won't change header if already provided.
                    if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                    // Set headers
                    for(i in headers)xhr.setRequestHeader(i, headers[i]);
                    // Callback
                    callback = function(type) {
                        return function() {
                            if (callback) {
                                callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                                if (type === "abort") xhr.abort();
                                else if (type === "error") {
                                    // Support: IE <=9 only
                                    // On a manual native abort, IE9 throws
                                    // errors on any property access that is not readyState
                                    if (typeof xhr.status !== "number") complete(0, "error");
                                    else complete(// File: protocol always yields status 0; see #8605, #14207
                                    xhr.status, xhr.statusText);
                                } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                                // IE9 has no XHR2 but throws on binary (trac-11426)
                                // For XHR2 non-text, let the caller handle it (gh-2498)
                                (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                    binary: xhr.response
                                } : {
                                    text: xhr.responseText
                                }, xhr.getAllResponseHeaders());
                            }
                        };
                    };
                    // Listen to events
                    xhr.onload = callback();
                    errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                    // Support: IE 9 only
                    // Use onreadystatechange to replace onabort
                    // to handle uncaught aborts
                    if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                    else xhr.onreadystatechange = function() {
                        // Check readyState before timeout as it changes
                        if (xhr.readyState === 4) // Allow onerror to be called first,
                        // but that will not handle a native abort
                        // Also, save errorCallback to a variable
                        // as xhr.onerror cannot be accessed
                        window1.setTimeout(function() {
                            if (callback) errorCallback();
                        });
                    };
                    // Create the abort callback
                    callback = callback("abort");
                    try {
                        // Do send the request (this may raise an exception)
                        xhr.send(options.hasContent && options.data || null);
                    } catch (e) {
                        // #14683: Only rethrow if this hasn't been notified as an error yet
                        if (callback) throw e;
                    }
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        });
        // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
        jQuery.ajaxPrefilter(function(s) {
            if (s.crossDomain) s.contents.script = false;
        });
        // Install script dataType
        jQuery.ajaxSetup({
            accepts: {
                script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
            },
            contents: {
                script: /\b(?:java|ecma)script\b/
            },
            converters: {
                "text script": function(text) {
                    jQuery.globalEval(text);
                    return text;
                }
            }
        });
        // Handle cache's special case and crossDomain
        jQuery.ajaxPrefilter("script", function(s) {
            if (s.cache === undefined) s.cache = false;
            if (s.crossDomain) s.type = "GET";
        });
        // Bind script tag hack transport
        jQuery.ajaxTransport("script", function(s) {
            // This transport only deals with cross domain or forced-by-attrs requests
            if (s.crossDomain || s.scriptAttrs) {
                var script, callback;
                return {
                    send: function(_, complete) {
                        script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                            charset: s.scriptCharset,
                            src: s.url
                        }).on("load error", callback = function(evt) {
                            script.remove();
                            callback = null;
                            if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                        });
                        // Use native DOM manipulation to avoid our domManip AJAX trickery
                        document.head.appendChild(script[0]);
                    },
                    abort: function() {
                        if (callback) callback();
                    }
                };
            }
        });
        var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
        // Default jsonp settings
        jQuery.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function() {
                var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
                this[callback] = true;
                return callback;
            }
        });
        // Detect, normalize options and install callbacks for jsonp requests
        jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
            var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
            // Handle iff the expected data type is "jsonp" or we have a parameter to set
            if (jsonProp || s.dataTypes[0] === "jsonp") {
                // Get callback name, remembering preexisting value associated with it
                callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
                // Insert callback into url or form data
                if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
                else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
                // Use data converter to retrieve json after script execution
                s.converters["script json"] = function() {
                    if (!responseContainer) jQuery.error(callbackName + " was not called");
                    return responseContainer[0];
                };
                // Force json dataType
                s.dataTypes[0] = "json";
                // Install callback
                overwritten = window1[callbackName];
                window1[callbackName] = function() {
                    responseContainer = arguments;
                };
                // Clean-up function (fires after converters)
                jqXHR.always(function() {
                    // If previous value didn't exist - remove it
                    if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                    else window1[callbackName] = overwritten;
                    // Save back as free
                    if (s[callbackName]) {
                        // Make sure that re-using the options doesn't screw things around
                        s.jsonpCallback = originalSettings.jsonpCallback;
                        // Save the callback name for future use
                        oldCallbacks.push(callbackName);
                    }
                    // Call if it was a function and we have a response
                    if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                    responseContainer = overwritten = undefined;
                });
                // Delegate to script
                return "script";
            }
        });
        // Support: Safari 8 only
        // In Safari 8 documents created via document.implementation.createHTMLDocument
        // collapse sibling forms: the second one becomes a child of the first one.
        // Because of that, this security measure has to be disabled in Safari 8.
        // https://bugs.webkit.org/show_bug.cgi?id=137337
        support.createHTMLDocument = function() {
            var body = document.implementation.createHTMLDocument("").body;
            body.innerHTML = "<form></form><form></form>";
            return body.childNodes.length === 2;
        }();
        // Argument "data" should be string of html
        // context (optional): If specified, the fragment will be created in this context,
        // defaults to document
        // keepScripts (optional): If true, will include scripts passed in the html string
        jQuery.parseHTML = function(data, context, keepScripts) {
            if (typeof data !== "string") return [];
            if (typeof context === "boolean") {
                keepScripts = context;
                context = false;
            }
            var base, parsed, scripts;
            if (!context) {
                // Stop scripts or inline event handlers from being executed immediately
                // by using document.implementation
                if (support.createHTMLDocument) {
                    context = document.implementation.createHTMLDocument("");
                    // Set the base href for the created document
                    // so any parsed elements with URLs
                    // are based on the document's URL (gh-2965)
                    base = context.createElement("base");
                    base.href = document.location.href;
                    context.head.appendChild(base);
                } else context = document;
            }
            parsed = rsingleTag.exec(data);
            scripts = !keepScripts && [];
            // Single tag
            if (parsed) return [
                context.createElement(parsed[1])
            ];
            parsed = buildFragment([
                data
            ], context, scripts);
            if (scripts && scripts.length) jQuery(scripts).remove();
            return jQuery.merge([], parsed.childNodes);
        };
        /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
            var selector, type, response, self = this, off = url.indexOf(" ");
            if (off > -1) {
                selector = stripAndCollapse(url.slice(off));
                url = url.slice(0, off);
            }
            // If it's a function
            if (isFunction(params)) {
                // We assume that it's the callback
                callback = params;
                params = undefined;
            // Otherwise, build a param string
            } else if (params && typeof params === "object") type = "POST";
            // If we have elements to modify, make the request
            if (self.length > 0) jQuery.ajax({
                url: url,
                // If "type" variable is undefined, then "GET" method will be used.
                // Make value of this field explicit since
                // user can override it through ajaxSetup method
                type: type || "GET",
                dataType: "html",
                data: params
            }).done(function(responseText) {
                // Save response for use in complete callback
                response = arguments;
                self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
                // Exclude scripts to avoid IE 'Permission Denied' errors
                jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
                responseText);
            // If the request succeeds, this function gets "data", "status", "jqXHR"
            // but they are ignored because response was set above.
            // If it fails, this function gets "jqXHR", "status", "error"
            }).always(callback && function(jqXHR, status) {
                self.each(function() {
                    callback.apply(this, response || [
                        jqXHR.responseText,
                        status,
                        jqXHR
                    ]);
                });
            });
            return this;
        };
        jQuery.expr.pseudos.animated = function(elem) {
            return jQuery.grep(jQuery.timers, function(fn) {
                return elem === fn.elem;
            }).length;
        };
        jQuery.offset = {
            setOffset: function(elem, options, i) {
                var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
                // Set position first, in-case top/left are set even on static elem
                if (position === "static") elem.style.position = "relative";
                curOffset = curElem.offset();
                curCSSTop = jQuery.css(elem, "top");
                curCSSLeft = jQuery.css(elem, "left");
                calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
                // Need to be able to calculate position if either
                // top or left is auto and position is either absolute or fixed
                if (calculatePosition) {
                    curPosition = curElem.position();
                    curTop = curPosition.top;
                    curLeft = curPosition.left;
                } else {
                    curTop = parseFloat(curCSSTop) || 0;
                    curLeft = parseFloat(curCSSLeft) || 0;
                }
                if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
                options = options.call(elem, i, jQuery.extend({}, curOffset));
                if (options.top != null) props.top = options.top - curOffset.top + curTop;
                if (options.left != null) props.left = options.left - curOffset.left + curLeft;
                if ("using" in options) options.using.call(elem, props);
                else curElem.css(props);
            }
        };
        jQuery.fn.extend({
            // offset() relates an element's border box to the document origin
            offset: function(options) {
                // Preserve chaining for setter
                if (arguments.length) return options === undefined ? this : this.each(function(i) {
                    jQuery.offset.setOffset(this, options, i);
                });
                var rect, win, elem = this[0];
                if (!elem) return;
                // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
                // Support: IE <=11 only
                // Running getBoundingClientRect on a
                // disconnected node in IE throws an error
                if (!elem.getClientRects().length) return {
                    top: 0,
                    left: 0
                };
                // Get document-relative position by adding viewport scroll to viewport-relative gBCR
                rect = elem.getBoundingClientRect();
                win = elem.ownerDocument.defaultView;
                return {
                    top: rect.top + win.pageYOffset,
                    left: rect.left + win.pageXOffset
                };
            },
            // position() relates an element's margin box to its offset parent's padding box
            // This corresponds to the behavior of CSS absolute positioning
            position: function() {
                if (!this[0]) return;
                var offsetParent, offset, doc, elem = this[0], parentOffset = {
                    top: 0,
                    left: 0
                };
                // position:fixed elements are offset from the viewport, which itself always has zero offset
                if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
                offset = elem.getBoundingClientRect();
                else {
                    offset = this.offset();
                    // Account for the *real* offset parent, which can be the document or its root element
                    // when a statically positioned element is identified
                    doc = elem.ownerDocument;
                    offsetParent = elem.offsetParent || doc.documentElement;
                    while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                    if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                        // Incorporate borders into its offset, since they are outside its content origin
                        parentOffset = jQuery(offsetParent).offset();
                        parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                        parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                    }
                }
                // Subtract parent offsets and element margins
                return {
                    top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                    left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
                };
            },
            // This method will return documentElement in the following cases:
            // 1) For the element inside the iframe without offsetParent, this method will return
            //    documentElement of the parent window
            // 2) For the hidden or detached element
            // 3) For body or html element, i.e. in case of the html node - it will return itself
            //
            // but those exceptions were never presented as a real life use-cases
            // and might be considered as more preferable results.
            //
            // This logic, however, is not guaranteed and can change at any point in the future
            offsetParent: function() {
                return this.map(function() {
                    var offsetParent = this.offsetParent;
                    while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                    return offsetParent || documentElement;
                });
            }
        });
        // Create scrollLeft and scrollTop methods
        jQuery.each({
            scrollLeft: "pageXOffset",
            scrollTop: "pageYOffset"
        }, function(method, prop) {
            var top = "pageYOffset" === prop;
            jQuery.fn[method] = function(val) {
                return access(this, function(elem, method, val) {
                    // Coalesce documents and windows
                    var win;
                    if (isWindow(elem)) win = elem;
                    else if (elem.nodeType === 9) win = elem.defaultView;
                    if (val === undefined) return win ? win[prop] : elem[method];
                    if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                    else elem[method] = val;
                }, method, val, arguments.length);
            };
        });
        // Support: Safari <=7 - 9.1, Chrome <=37 - 49
        // Add the top/left cssHooks using jQuery.fn.position
        // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
        // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
        // getComputedStyle returns percent when specified for top/left/bottom/right;
        // rather than make the css module depend on the offset module, just check for it here
        jQuery.each([
            "top",
            "left"
        ], function(_i, prop) {
            jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
                if (computed) {
                    computed = curCSS(elem, prop);
                    // If curCSS returns percentage, fallback to offset
                    return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
                }
            });
        });
        // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
        jQuery.each({
            Height: "height",
            Width: "width"
        }, function(name, type) {
            jQuery.each({
                padding: "inner" + name,
                content: type,
                "": "outer" + name
            }, function(defaultExtra, funcName) {
                // Margin is only for outerHeight, outerWidth
                jQuery.fn[funcName] = function(margin, value) {
                    var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                    return access(this, function(elem, type, value) {
                        var doc;
                        if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                        return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                        // Get document width or height
                        if (elem.nodeType === 9) {
                            doc = elem.documentElement;
                            // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                            // whichever is greatest
                            return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                        }
                        return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                        jQuery.css(elem, type, extra) : // Set width or height on the element
                        jQuery.style(elem, type, value, extra);
                    }, type, chainable ? margin : undefined, chainable);
                };
            });
        });
        jQuery.each([
            "ajaxStart",
            "ajaxStop",
            "ajaxComplete",
            "ajaxError",
            "ajaxSuccess",
            "ajaxSend"
        ], function(_i, type) {
            jQuery.fn[type] = function(fn) {
                return this.on(type, fn);
            };
        });
        jQuery.fn.extend({
            bind: function(types, data, fn) {
                return this.on(types, null, data, fn);
            },
            unbind: function(types, fn) {
                return this.off(types, null, fn);
            },
            delegate: function(selector, types, data, fn) {
                return this.on(types, selector, data, fn);
            },
            undelegate: function(selector, types, fn) {
                // ( namespace ) or ( selector, types [, fn] )
                return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
            },
            hover: function(fnOver, fnOut) {
                return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
            }
        });
        jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
            // Handle event binding
            jQuery.fn[name] = function(data, fn) {
                return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
            };
        });
        // Support: Android <=4.0 only
        // Make sure we trim BOM and NBSP
        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        // Bind a function to a context, optionally partially applying any
        // arguments.
        // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
        // However, it is not slated for removal any time soon
        jQuery.proxy = function(fn, context) {
            var tmp, args, proxy;
            if (typeof context === "string") {
                tmp = fn[context];
                context = fn;
                fn = tmp;
            }
            // Quick check to determine if target is callable, in the spec
            // this throws a TypeError, but we will just return undefined.
            if (!isFunction(fn)) return undefined;
            // Simulated bind
            args = slice.call(arguments, 2);
            proxy = function() {
                return fn.apply(context || this, args.concat(slice.call(arguments)));
            };
            // Set the guid of unique handler to the same of original handler, so it can be removed
            proxy.guid = fn.guid = fn.guid || jQuery.guid++;
            return proxy;
        };
        jQuery.holdReady = function(hold) {
            if (hold) jQuery.readyWait++;
            else jQuery.ready(true);
        };
        jQuery.isArray = Array.isArray;
        jQuery.parseJSON = JSON.parse;
        jQuery.nodeName = nodeName;
        jQuery.isFunction = isFunction;
        jQuery.isWindow = isWindow;
        jQuery.camelCase = camelCase;
        jQuery.type = toType;
        jQuery.now = Date.now;
        jQuery.isNumeric = function(obj) {
            // As of jQuery 3.0, isNumeric is limited to
            // strings and numbers (primitives or objects)
            // that can be coerced to finite numbers (gh-2662)
            var type = jQuery.type(obj);
            return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
            // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
            // subtraction forces infinities to NaN
            !isNaN(obj - parseFloat(obj));
        };
        jQuery.trim = function(text) {
            return text == null ? "" : (text + "").replace(rtrim, "");
        };
        var // Map over jQuery in case of overwrite
        _jQuery = window1.jQuery, // Map over the $ in case of overwrite
        _$ = window1.$;
        jQuery.noConflict = function(deep) {
            if (window1.$ === jQuery) window1.$ = _$;
            if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
            return jQuery;
        };
        // Expose jQuery and $ identifiers, even in AMD
        // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
        // and CommonJS for browser emulators (#13566)
        if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
        return jQuery;
    });
});
var $bd2fb69ec5c665ce$export$2e2bcd8739ae039 = $bd2fb69ec5c665ce$var$jquery;


function $27f78834e6ba71b5$export$f8f26dd395d7e1bd() {
    function uuidv4a() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }
    this.uuidv4 = function() {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
    };
    this.ping = function() {
        console.log(' ping ');
    };
    this.context = function() {
        var jtkn = 'blank' // JTKN
        ;
        var session_fragment = Math.round(Math.random() * 99999);
        var official_base = window.location.protocol + "//" + window.location.host;
        var session_fragment;
        //var official_base ='https://signalmesh.io'
        return {
            official_base: official_base,
            session_fragment: session_fragment
        };
    };
    // source: http://stackoverflow.com/a/11058858
    this.ab2str = function(buf) {
        return String.fromCharCode.apply(null, new Uint16Array(buf));
    };
    //stringToArrayBuffer.js
    // source: http://stackoverflow.com/a/11058858
    this.str2ab = function(str) {
        var buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
        var bufView = new Uint16Array(buf);
        for(var i = 0, strLen = str.length; i < strLen; i++)bufView[i] = str.charCodeAt(i);
        return buf;
    };
}
function $27f78834e6ba71b5$var$term(min) {
    this.dispatchEvent(new CustomEvent('statusEvent', {
        detail: {
            'message': min
        }
    }));
}
var $27f78834e6ba71b5$var$lightTheme = {
    bg: 0xFFFFFF,
    link: 0xCCCCCC,
    avatarbase: 0xCCCCCC,
    floor_line: 0xffdcc7,
    node_color: 0x82a200,
    dbase: 0xa948ff,
    link_color_transfer: 0xff9a9a,
    link_color_convert: 0xffc368,
    main_avatar_text: 0x222222,
    sub_avatar_text: 0x555555,
    link_colors: [
        0xffbebe,
        0xffcb55,
        0xffc966,
        0xfff040,
        0xd9ff40,
        0xbcff39
    ]
};
var $27f78834e6ba71b5$var$darkTheme = {
    bg: 0x000000,
    link: 0xCCCCCC,
    avatarbase: 0xCCCCCC,
    floor_line: 0x005566,
    node_color: 0x82a200,
    dbase: 0xa948ff,
    link_color_transfer: 0x2e379F,
    link_color_convert: 0x4b7F7C,
    main_avatar_text: 0x222222,
    sub_avatar_text: 0x555555,
    link_colors: [
        0x00FFbe,
        0x33cbFF,
        0x33FF44,
        0xfff040,
        0xd9ff40,
        0xbcff39
    ]
};
var $27f78834e6ba71b5$var$XCOLORS = $27f78834e6ba71b5$var$darkTheme;
// OFFICIAL BASE 
var $27f78834e6ba71b5$export$6d7e0922250f6b7a = 'https://api.apdex.com';
if (window.location.host.includes("localhost") || window.location.host.includes("xcore.love") || window.location.host.includes("0.0.0.0")) $27f78834e6ba71b5$export$6d7e0922250f6b7a = 'http://localhost:8851';
const $27f78834e6ba71b5$var$random_hex_color = ()=>{
    let n = (Math.random() * 1048575000000).toString(16);
    return '#' + n.slice(0, 6);
};
const $27f78834e6ba71b5$var$random_hex_code = ()=>{
    let n = (Math.random() * 1048575000000).toString(16);
    return n.slice(0, 6);
};
var $27f78834e6ba71b5$var$rhc = $27f78834e6ba71b5$var$random_hex_code();
//var session_fragment = Math.round( Math.random()*99999 );
var $27f78834e6ba71b5$export$875773172f320cf8 = $27f78834e6ba71b5$var$random_hex_code();


//import { renderNodeSync } from '/x_modules/flatfactory.js'
class $353707a6de894831$export$e6544c0c2e56b326 {
    constructor(initObj){
        //super();
        var initObj = initObj ? initObj : {};
        if (initObj.target) this.target = initObj.target;
        else {
            var future_id = 'ooo_elx_' + Math.round(Math.random() * 9999) + '_elx';
            this.container2x = document.createRange().createContextualFragment('<div id="' + future_id + '"></div>');
            document.body.appendChild(this.container2x);
            this.target = document.body.querySelector('#' + future_id);
        }
        this.container = this.target;
        this.data = initObj.data ? initObj.data : {}; // DATA IS AVAILABLE TO SUBCLASS
        //insert ui if present 
        if (initObj.url) {
            this.container = factory2d.renderNodeSync(initObj.url, this.data);
            this.ui = this.container; // standardized ui 
            this.container.id = 'ooo2_elx_' + Math.round(Math.random() * 9999) + '_elx';
            this.target.appendChild(this.container);
        // Should Fix ID return like Below?
        }
    }
    // PROXY EVENT HOOKS 
    dispatchEvent(event_in) {
        this.container.dispatchEvent(event_in);
    }
    addEventListener(event_identifier, init_object) {
        this.container.addEventListener(event_identifier, init_object);
    }
    removeEventListener(event_identifier, init_object) {
        this.container.removeEventListener(event_identifier, init_object);
    }
    querySelector(selector) {
        return this.container.querySelector(selector);
    }
    // DISCOVER / CONNECT
    discoverEventDispatchers(broadcaster_in) {
        var subjects = broadcaster_in.subjects();
        this.matchMerge(subjects, this.interests());
    }
    discoverParent() {
        if (this.container.parentElement) console.log(' auto parent: ', this.container.parentElement);
        else console.log(' no parent discovered ');
        this.dispatchEvent(new CustomEvent('discoverParentEvent', {
            'detail': {
                'b': 'a'
            }
        }));
    }
    inject(target, obj) {
        for(var p in obj){
            console.log(p, obj[p]);
            try {
                //this.elem_funcs[ p ]( obj[p] )
                var el = target.querySelector('#' + p + '');
                console.log(el.type);
                if (el.type == 'text') el.value = obj[p];
            } catch (e) {
                console.log(' Injection Error: ', e);
            }
        }
    }
    spanUi(ui_url) {
        console.log(' this should enable spawning internal UI ');
    //this.ui = renderNodeSync( ui_url )
    }
    // SPAWN HOOKS 
    new(entry, obj) {
        function execFunction() {
            console.log('FUNCTION::');
        // attach New class and HTML Element ?
        // .new (  obj )  init aram 
        // return reference to es6 with accessors to underlying DIV / Element 
        }
        function execObject() {
            console.log('OBJECT::');
        }
        function execString() {
            console.log('STRING::');
        }
        var xclass_entries = {
            'function': execFunction,
            'object': execObject,
            'string': execString
        };
        xclass_entries[typeof entry]();
        console.log(' ETNRY: ', entry);
        if (typeof pin == 'function') console.log('FUNCTION YAY');
        if (typeof pin == 'object') console.log('Initilization Object , look for target, container, data , etc.  ');
        if (typeof pin == 'string') console.log('STRING YAY');
    // finds class cache and creates  new Class() 
    // class Finds own UI and
    // Class(  this.container )    is automatically passed its own container 
    // so in instantiated reference its naturally nested.    
    // this.container.appendAdjactendHTML( <el-x id='xixi'></el-x> )
    // var elx_element = this.container.findElement('#xixi')
    // return  ['a1.b1.c6']
    /*
        <obj-x id='a1'>
            <obj-x id='b1'></obj-x>
            <obj-x id='b2'></obj-x>
            <obj-x id='b3'>
                <obj-x id='c6'></obj-x>
                <obj-x id='c5'></obj-x>
                <obj-x id='c4'></obj-x>
            </obj-x>
        </obj-x> */ }
    newClass(container_in, xclass_in, dat, id_in) {
        // Auto cap 
        //var xclass = ( xclass_in.charAt(0).toUpperCase() + xclass_in.slice(1) ) + 'Panel';
        var xclass = xclass_in.charAt(0).toUpperCase() + xclass_in.slice(1);
        var class_ref = this.futureclasses[xclass];
        var p = new class_ref(container_in, dat, id_in);
        return p;
    }
    whoIsMyParent() {
        try {
            throw new Error();
        } catch (e) {
            const allMatches = e.stack.match(/(\w+)@|at (\w+) \(/g); // matches this function, the caller and the parent
            console.log(allMatches, 'xxo');
        //const parentMatches = allMatches[2].match(/(\w+)@|at (\w+) \(/); // match parent function name
        //return parentMatches[1] || parentMatches[2]; // return only name
        }
    }
    child() {
        let caller = whoIsMyParent();
        console.log(caller);
    }
    parent() {
        child();
    }
}


class $ab4527151d7de39d$var$ClearFrame extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    constructor(initObj1){
        super(initObj1);
        this.onNavEvent = this.onNavEvent.bind(this);
        this.onFabricEvent = this.onFabricEvent.bind(this);
        this.onFreshDataEvent = this.onFreshDataEvent.bind(this);
        this.selected_object = {};
        //console.log('booting clear frame : this',this)
        this.leframe = document.querySelector('#afx');
        this.leframe.onload = this.onFrameReset;
    //this.driver = neo4j.driver('bolt://0.0.0.0', neo4j.auth.basic('neo4j', 'loc'))
    }
    onFrameReset(o) {
        // check states and push or load //
        console.log(' - 008 <> VANILLA - ', o);
        console.log('Browser Version:', navigator.userAgent);
    }
    onFabricEvent(e) {
        // this for real-time feed updates like price feeds
        console.log(' Fabric Event should update clear frame: ');
        this.pushMessage(e.detail);
    }
    onFreshDataEvent(e) {
        // this for real-time feed updates like price feeds
        console.log(' Fresh data  Event should update clear frame: ');
        this.pushJSONintoFrame(e.detail);
    //this.pushMessage( e.detail );
    }
    onNavEvent(e) {
        this.model = e.detail.model;
        var obj = e.detail;
        this.selected_object = e.detail;
        var routable_key_fn = 'type' in obj ? obj['type'] : obj['fn'];
        if (routable_key_fn == undefined) routable_key_fn = obj.method;
        switch(routable_key_fn){
            case 'freesearch':
                break;
            case 'map':
                this.fetchFragment(obj['fragment']);
                break;
            case 'query':
                //this.fetchQuery( obj['fragment'] )
                if (obj.payload) this.pushJSONintoFrame(obj.payload);
                break;
            case 'open':
            case 'new':
                this.pushMessage(obj);
                break;
            case 'cred_merge':
                var this_node = this.model.keycache.keySelect('uuid', obj.uuid)[0];
                this.pushJSONintoFrame(this_node.dat);
                break;
            case 'cred_launch':
                var this_node = this.model.keycache.keySelect('uuid', obj.uuid)[0];
                this.loadFreshMap(this_node.dat);
                break;
            case 'create_map':
                this.loadBlankMap();
                break;
            case 'file':
                this.fetchFragment(obj['fragment'], obj['renderer']);
                break;
            default:
                break;
        }
    }
    //=================== internal =====================
    fetchPage(url_in) {
        console.log(' Fetch Page : ', new Date());
        var wn = document.getElementById('afx').contentWindow; // get reference to window inside the iframe
        var leframe = document.getElementById('afx');
        leframe.src = url_in;
    }
    pushJSONintoFrame(initObj1) {
        var wn = document.getElementById('afx').contentWindow; // get reference to window inside the iframe
        var ifr = document.getElementById('afx');
        var iframe = document.getElementById('afx');
        var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        function checkIframeLoaded() {
            console.log(' * * * * * * * * * check check ');
            var a = iframe.contentWindow;
            var b = iframeDoc;
            var xvar = a.xvar;
            if (iframeDoc.readyState == 'complete' && xvar == 9999) {
                wn.postMessage(initObj1); //wn.postMessage(initObj ,"*" );
                // wow so this workss
                // wn.directCallFunction( initObj );
                // is this safer?
                window.clearTimeout(checkIframeLoaded);
            } else window.setTimeout(checkIframeLoaded, 300);
        }
        checkIframeLoaded();
    }
    loadBlankMap() {
        this.leframe.src = "/map.html?embk=" + (0, $27f78834e6ba71b5$export$875773172f320cf8);
        this.pushJSONintoFrame({
            meta: {},
            nodes: {},
            edges: {}
        });
    }
    loadFreshMap(dat) {
        this.leframe.src = "/map.html?embk=" + (0, $27f78834e6ba71b5$export$875773172f320cf8);
        this.pushJSONintoFrame(dat);
    }
    fetchFragment(url_in, renderer = '/map.html') {
        this.leframe.src = renderer + '?embk' + (0, $27f78834e6ba71b5$export$875773172f320cf8);
        var starttime = new Date();
        var cache_buster = Math.round(Math.random() * 9999);
        url_in = url_in.replace(".json", "");
        var url_chunk = url_in.replace(/^[\\/]+|[\\/]+$/g, '');
        var dat_url = '/static/vdisk/' + url_chunk + '.json' + '?cb=' + cache_buster;
        var urla = (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + dat_url;
        urla = '/data/' + url_chunk + '.json' + '?cb=' + cache_buster;
        // UPDATE URL FRAGMENT //
        // THIS SHOULD PUSH FRAGMENT INTO URL 
        /*                
        try{
            window.location.hash = '/'+url_chunk;
        }catch(e){ console.log(' hash fregment set except in search') }  */ var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = (function() {
            if (xhttp.readyState == 4) {
                if (xhttp.status == 200) {
                    var resObj = JSON.parse(xhttp.responseText);
                    var outmessage = resObj.message;
                    var jtkn1 = resObj.tkn;
                    this.pushJSONintoFrame(resObj);
                } else console.log('error in login ');
                 //window.location.replace('/');
            }
        }).bind(this);
        // xhttp.open("POST", official_base+"/jxtavail", true);
        //xhttp.withCredentials = true;
        xhttp.open("GET", urla, true);
        xhttp.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
        xhttp.setRequestHeader('Authorization', jtkn);
        xhttp.send();
    }
    async fetchQuery(url_in) {
        // realistically for new model 
        // try to check if it has complete stuff ? 
        // or append JSON apoc , or insert the json apoc ?
        // froz sd
        var leframe = document.getElementById('afx');
        leframe.src = "/map.html?embkey=" + (0, $27f78834e6ba71b5$export$875773172f320cf8);
        var starttime = new Date();
        //var urla = official_base+"/mapqrx?"+url_in
        var cache_buster = Math.round(Math.random() * 9999);
        // DAT URL will be once user names have own folder
        // for that first need to access user_id in clear-frame-view
        url_in = url_in.replace(".json", "");
        var url_chunk = url_in.replace(/^[\\/]+|[\\/]+$/g, '');
        var dat_url = '/' + url_chunk + '&cb=' + cache_buster; // moved to inside URL for ability to multiple queries 
        //var dat_url = ''+url_chunk+'&cb='+cache_buster;
        var urla = (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + dat_url;
        var er = 0;
        var session = this.driver.session();
        var result = await session.run("MATCH (x)-[r]-(y) WITH collect(x) + collect(y) as nds, collect(r) as rls CALL apoc.export.json.data(nds,rls, null, { stream: true , jsonFormat:'JSON' }) YIELD data RETURN data");
        var resObj = JSON.parse(result.records[0]._fields[0]);
        resObj.links = resObj.rels;
        delete resObj.rels;
        // example loads from Arcade !! Yay . 
        var resm = await fetch('http://localhost:8080');
        var movies = await resm.json();
        this.pushJSONintoFrame(movies);
    // UPDATE URL FRAGMENT //
    // THIS SHOULD PUSH FRAGMENT INTO URL 
    /*                
        try{
            window.location.hash = '/'+url_chunk;
        }catch(e){ console.log(' hash fregment set except in search') }  */ // var xhttp = new XMLHttpRequest();
    // xhttp.onreadystatechange = function() {
    //     if (xhttp.readyState==4 ) {
    //         if( xhttp.status == 200){
    //             var resObj = JSON.parse(xhttp.responseText);
    //             var outmessage =resObj.message;
    //             var jtkn = resObj.tkn
    //             this.pushJSONintoFrame( resObj )
    //         }else{
    //             console.log( 'error in login ')
    //         } //window.location.replace('/');
    //     }
    // }.bind(this);
    // // xhttp.open("POST", official_base+"/jxtavail", true);
    // //xhttp.withCredentials = true;
    // xhttp.open("GET", urla , true);
    // xhttp.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
    // xhttp.setRequestHeader('Authorization', jtkn);
    // xhttp.send();
    }
    fetchQueryThroughP(url_in) {
        var leframe = document.getElementById('afx');
        leframe.src = "/map.html?embkey=" + (0, $27f78834e6ba71b5$export$875773172f320cf8);
        var starttime = new Date();
        //var urla = official_base+"/mapqrx?"+url_in
        var cache_buster = Math.round(Math.random() * 9999);
        // DAT URL will be once user names have own folder
        // for that first need to access user_id in clear-frame-view
        url_in = url_in.replace(".json", "");
        var url_chunk = url_in.replace(/^[\\/]+|[\\/]+$/g, '');
        var dat_url = '/' + url_chunk + '&cb=' + cache_buster; // moved to inside URL for ability to multiple queries 
        //var dat_url = ''+url_chunk+'&cb='+cache_buster;
        var urla = (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + dat_url;
        var er = 0;
        // UPDATE URL FRAGMENT //
        // THIS SHOULD PUSH FRAGMENT INTO URL 
        /*                
        try{
            window.location.hash = '/'+url_chunk;
        }catch(e){ console.log(' hash fregment set except in search') }  */ var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = (function() {
            if (xhttp.readyState == 4) {
                if (xhttp.status == 200) {
                    var resObj = JSON.parse(xhttp.responseText);
                    var outmessage = resObj.message;
                    var jtkn1 = resObj.tkn;
                    this.pushJSONintoFrame(resObj);
                } else console.log('error in login ');
                 //window.location.replace('/');
            }
        }).bind(this);
        // xhttp.open("POST", official_base+"/jxtavail", true);
        //xhttp.withCredentials = true;
        xhttp.open("GET", urla, true);
        xhttp.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
        xhttp.setRequestHeader('Authorization', jtkn);
        xhttp.send();
    }
    pushMessage(obj) {
        var ifr = document.getElementById('afx');
        var wn = document.getElementById('afx').contentWindow; // get reference to window inside the iframe
        //wn.postMessage( JSON.stringify(obj) ,"*" );
        var ob = {};
        const target = ob;
        const source = obj;
        const returnedTarget = Object.assign(target, source);
        delete returnedTarget['element']; // DOM References throw exceptions passed between iframes
        wn.postMessage(returnedTarget, "*");
    }
    pushJSON(json_in) {
        var starttime = new Date();
        var wn = document.getElementById('afx').contentWindow; // get reference to window inside the iframe
        var ifr = (0, $bd2fb69ec5c665ce$export$2e2bcd8739ae039)('#afx');
        this.onIframeReady(ifr, function() {
            var wn = document.getElementById('afx').contentWindow; // get reference to window inside the iframe
            wn.postMessage(initObj, "*"); // postMessage arguments: data to send, target origin
            var completed = new Date() - starttime;
        //printTerm(' Loaded Content in '+completed+' ms' )
        //printTerm(' Happy Trails...' )
        }, function() {
            console.log('errroriframe');
        });
        wn.postMessage(initObj, "*"); // postMessage arguments: data to send, target origin
    }
    async onFrameReady() {
        return new Promise((resolve, err)=>{
            var wn = document.getElementById('afx').contentWindow; // get reference to window inside the iframe
            var ifr = document.getElementById('afx');
            var iframe = document.getElementById('afx');
            var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            function checkIframeLoaded() {
                console.log(' * * * * * * * * * check check ');
                var a = iframe.contentWindow;
                var b = iframeDoc;
                var xvar = a.xvar;
                if (iframeDoc.readyState == 'complete' && xvar == 9999) {
                    wn.postMessage(initObj, "*");
                    window.clearTimeout(checkIframeLoaded);
                } else window.setTimeout(checkIframeLoaded, 300);
            }
            checkIframeLoaded();
        });
    }
    //*  Just listening for the load event will only work if the iframe is not already loaded.
    //* If so, it is necessary to observe the readyState. The issue here is that Chrome will initialize iframes with
    //* "about:blank" and set its readyState to complete. So it is furthermore necessary to check if it's
    //* the readyState of the target document property.
    //* Errors that may occur when trying to access the iframe (Same-Origin-Policy) will be catched and the error
    //* function will be called.
    //* @ param {jquery} $i - The jQuery iframe element
    //* @ param {function} successFn - The callback on success. Will
    //* receive the jQuery contents of the iframe as a parameter
    //* @ param {function} errorFn - The callback on error
    onIframeReady($i, successFn, errorFn) {
        console.log(' trying iframe ready ');
        try {
            const iCon = $i.first()[0].contentWindow, bl = "about:blank", compl = "complete";
            const callCallback = ()=>{
                try {
                    const $con = $i.contents();
                    if ($con.length === 0) throw new Error("iframe inaccessible");
                    successFn($con);
                } catch (e) {
                    console.log(' error 1 ', e);
                    errorFn();
                }
            };
            const observeOnload = ()=>{
                $i.on("load.jqueryMark", ()=>{
                    try {
                        const src = $i.attr("src").trim(), href = iCon.location.href;
                        if (href !== bl || src === bl || src === "") {
                            $i.off("load.jqueryMark");
                            callCallback();
                        }
                    } catch (e) {
                        console.log(' error 2 ', e);
                        errorFn();
                    }
                });
            };
            if (iCon.document.readyState === compl) {
                const src = $i.attr("src").trim(), href = iCon.location.href;
                if (href === bl && src !== bl && src !== "") observeOnload();
                else callCallback();
            } else observeOnload();
        } catch (e) {
            console.log('catching exception ', e);
            errorFn();
        }
    }
}
var $ab4527151d7de39d$export$2e2bcd8739ae039 //render() {
 //this.container.innerHTML= ``;
 //this.leframe = document.getElementById('afx')
 //}
 //get myObj() { return this._myObj; }
 //set myObj(value) { this._myObj = value; this.render(); }
 // onNavEventNOTWorkingTHISisTextField( navObj ){
 //     console.log(' clearFrame hears nav update: ', navObj  )
 //     if( navObj['type']=='map' ){   
 //         this.fetchFragment( navObj['fragment'] )
 //     }else{
 //         this.fetchPage( navObj['fragment'] )
 //     }
 // }
 // onDataUpdate( data_in ){
 //     console.log(' incoming data: ',data_in )
 // }
 // loadResult(e){
 //     spinr.fadeOut();
 //     rez.empty();
 //     e.target.value="";
 //     var leframe = document.getElementById('afx')
 //     leframe.onload = function() {
 //         //this.contentWindow.controller.setMap( {map:9} )
 //     };
 //     var selected_obj = loaded_indexes[ selected_index ]
 //     if( selected_obj['type']=='map' || selected_obj['type']=='python'){
 //         fetchFragment( selected_obj['fragment'] )
 //     }else{
 //         console.log(' no fragment for this entry ')
 //         fetchPage( selected_obj['fragment'] )
 //     }
 // }
 // fetchFragmentJQ( url_in ){
 //     console.log(' REQUEST DATA in Frame: ', new Date())
 //     var leframe = document.getElementById('afx')
 //     leframe.src='map.html'+'?'+session_fragment;
 //     var starttime = new Date()
 //     //var urla = official_base+"/mapqrx?"+url_in
 //     var urla = official_base+url_in
 //    // printTerm('REQUEST: '+urla+' :: '+starttime)
 //     $.ajax({
 //             url: urla,
 //             beforeSend: function(xhr){
 //                 xhr.setRequestHeader('Authorization', jtkn);
 //                 xhr.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
 //             },
 //             dataType: 'json',
 //             error: function( errObj ){
 //                 console.log(' WOW AJAX ERROR LOCAL ',errObj )
 //             },
 //             success:function( initObj ) {
 //                 console.log(' Loaded Results in SearchFrame  ', new Date())
 //                 //controller.processCluster( initObj )
 //                 this.pushJSONintoFrame( initObj )
 //                 // POST FRAME AGAIN REGARDLESS of IFRAME STATE? 
 //                 //wn.postMessage(initObj ,"*" ); // postMessage arguments: data to send, target origin
 //             }.bind(this)
 //     });
 // }  
 // pushURL( url_in ){
 //     console.log(' Fetch Page : ', new Date())
 //     var wn = document.getElementById('afx').contentWindow; // get reference to window inside the iframe
 //     var leframe = document.getElementById('afx')
 //     leframe.src='loginjwt.html';
 // }   
 = $ab4527151d7de39d$var$ClearFrame;




class $079774228d9a400b$var$LogTerm extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    constructor(){
        super();
        this.iter = 0;
        this.onLogEvent = this.onLogEvent.bind(this);
        this.printTerm = this.printTerm.bind(this);
        this.render();
    }
    onSessionEvent(e) {
        if (e.detail.model.session == 1) this.style.display = 'inline';
        else this.style.display = 'none';
    }
    onLogEvent(eventObj) {
        //console.log(' logger term ' , eventObj )
        var mes = '';
        try {
            mes = eventObj.detail.message;
        } catch  {
            mes = 'Blank ';
        }
        this.printTerm(mes);
    }
    updateTossScroll() {
        if (runstate == 'loading') {
            requestAnimationFrame(this.updateTossScroll);
            if (new Date().getMilliseconds() > 500) printTerm(' Load DX: ' + Math.random() * 1000 + new Date());
            else printTerm('::');
        } else {
            printTerm(' LOAD XE: Complete: ' + new Date());
            _time = 0.0;
        }
    }
    printTerm(message_in) {
        var output_message = this.iter + ':' + message_in;
        this.termb.innerHTML += "<div class='loggert'>" + output_message + "</div>";
        this.termb.removeChild(this.termb.firstChild);
        this.iter++;
    }
    render() {
        this.container.innerHTML = `
            <!-- LOGGER TERM 1 -->
            <style>
                .loggert{
                    width:100%; font-size:8px; color:rgb(128, 220, 0);
                }
                b.loggert{ color:green; }
            </style>
            <div id="overflowterm" style="position:absolute; display:none; margin-left:6px; margin-top:49px; width:33%; height:80px; pointer-events:none; ">
                <div id="lineitemtemplate" class='loggert' style=""></div>
                <div id="lineitemtemplate" class='loggert' style="">System Ready...</div>
                <div id="lineitemtemplate" class='loggert' style="">_[]</div>
                <div id="lineitemtemplate" class='loggert' style=""> </div>
                <div id="lineitemtemplate" class='loggert' style=""> </div>
            </div> `;
        // UI ELEMENTS 
        this.term = (0, $bd2fb69ec5c665ce$export$2e2bcd8739ae039)(this.container.querySelector("#overflowterm"));
        this.termb = this.container.querySelector("#overflowterm");
    }
}
var $079774228d9a400b$export$2e2bcd8739ae039 //customElements.define('log-term', LogTerm );
 = $079774228d9a400b$var$LogTerm;




class $7164e009da884f04$var$Connector {
    constructor(nnn){
    //console.log(' running connector constructor ')
    }
    processRequest(path_in) {
        console.log(' process req ');
    }
    async postProc(data = {}) {
        console.log(' POST PROC ');
        var zurl = (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + "/jxt" + data.action;
        // Default options are marked with *
        const response = await fetch(zurl, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            //credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        }).then((zresponse)=>{
            return zresponse.json();
        }).then((zdata)=>{
            return zdata;
        }).catch((error)=>{
            return {
                err: true,
                message: 'Connection Error'
            };
        });
        return response;
    }
    // wow loaded with import but saving ?
    auth(data) {
        var prom = new Promise((resolve, reject)=>{
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var resObj = JSON.parse(xhttp.responseText);
                        var outmessage = resObj.message;
                        var jtkn = resObj.tkn;
                        resolve(resObj);
                    } else resolve({
                        error: true,
                        message: 'Connection Error: T1'
                    });
                     //window.location.replace('/');
                } else console.log(' readyState not 4');
            };
            // xhttp.open("POST", official_base+"/jxtavail", true);
            //xhttp.withCredentials = true;
            xhttp.open("POST", (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + "/jxtlogin", true);
            xhttp.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
            xhttp.send(JSON.stringify(data));
        });
        return prom;
    }
    // wow loaded with import but saving ?
    reg(data) {
        var prom = new Promise((resolve, reject)=>{
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var resObj = JSON.parse(xhttp.responseText);
                        var outmessage = resObj.message;
                        var jtkn = resObj.tkn;
                        resolve(resObj);
                    } else resolve({
                        error: true,
                        message: 'Connection Error: T1'
                    });
                     //window.location.replace('/');
                } else resolve({
                    error: true,
                    message: 'Connection Error: T2'
                });
            };
            // xhttp.open("POST", official_base+"/jxtavail", true);
            //xhttp.withCredentials = true;
            xhttp.open("POST", (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + "/jxtreg", true);
            xhttp.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
            xhttp.send(JSON.stringify(data));
        });
        return prom;
    }
    // wow loaded with import but saving ?
    reset(data) {
        var prom = new Promise((resolve, reject)=>{
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var resObj = JSON.parse(xhttp.responseText);
                        var outmessage = resObj.message;
                        var jtkn = resObj.tkn;
                        resolve(resObj);
                    } else resolve({
                        error: true,
                        message: 'Connection Error: T1'
                    });
                     //window.location.replace('/');
                } else resolve({
                    error: true,
                    message: 'Connection Error: T2'
                });
            };
            // xhttp.open("POST", official_base+"/jxtavail", true);
            //xhttp.withCredentials = true;
            xhttp.open("POST", (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + "/jxtreset", true);
            xhttp.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
            xhttp.send(JSON.stringify(data));
        });
        return prom;
    }
    // wow loaded with import but saving ?
    proc(data) {
        var prom = new Promise((resolve, reject)=>{
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var resObj = JSON.parse(xhttp.responseText);
                        var outmessage = resObj.message;
                        var jtkn = resObj.tkn;
                        resolve(resObj);
                    } else if (xhttp.status == 404) var cei = 0;
                    else resolve({
                        error: true,
                        message: 'Connection Error: T1'
                    });
                     //window.location.replace('/');
                } else resolve({
                    error: true,
                    message: 'Connection Error: T2'
                });
            };
            //xhttp.withCredentials = true;
            xhttp.open("POST", (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + "/jxt" + data.action, true);
            xhttp.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
            xhttp.send(JSON.stringify(data));
        });
        return prom;
    }
    savemap(data) {
        var prom = new Promise((resolve, reject)=>{
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var resObj = JSON.parse(xhttp.responseText);
                        var outmessage = resObj.message;
                        var jtkn = resObj.tkn;
                        resolve(resObj);
                    } else reject('error in login ');
                     //window.location.replace('/');
                }
            };
            // xhttp.open("POST", official_base+"/jxtavail", true);
            //xhttp.withCredentials = true;
            xhttp.open("POST", (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + "/jxtsavemap", true);
            xhttp.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
            xhttp.send(JSON.stringify(data));
        });
        return prom;
    }
    checkstatus() {
        var prom = new Promise((resolve, reject)=>{
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = (function(resx) {
                if (xhttp.readyState == 4 && xhttp.status == 200) {
                    var resObj = JSON.parse(xhttp.responseText);
                    console.log(' status check res ');
                    if (resObj.username == 'UNKNOWN') resolve(resObj);
                    else reject(false);
                }
            }).bind(this);
            xhttp.open("POST", (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + "/jxtstatus", true);
            xhttp.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
            xhttp.send();
        });
        return prom;
    }
    logout() {
        var prom = new Promise((resolve, reject)=>{
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (xhttp.readyState == 4 && xhttp.status == 200) {
                    var response = JSON.parse(xhttp.responseText);
                    console.log(response.message);
                    resolve(response);
                }
                if (xhttp.readyState == 4 && xhttp.status == 403) {
                    console.log(httpx.responseText);
                    resolve(httpx.responseText);
                }
            };
            //xhttp.withCredentials = true;
            xhttp.open("POST", (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + "/jxtlogout", true);
            xhttp.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
            xhttp.send();
        });
        return prom;
    }
    getAbiForAddress(addr_in) {
        var Web3 = (parcelRequire("joOvD"));
        var web3 = new Web3(new Web3.providers.HttpProvider());
        var version = web3.version.api;
        $.getJSON('https://api.etherscan.io/api?module=contract&action=getabi&address=0xfb6916095ca1df60bb79ce92ce3ea74c37c5d359', function(data) {
            var contractABI = "";
            contractABI = JSON.parse(data.result);
            if (contractABI != '') {
                var MyContract = web3.eth.contract(contractABI);
                var myContractInstance = MyContract.at("0xfb6916095ca1df60bb79ce92ce3ea74c37c5d359");
                var result = myContractInstance.memberId("0xfe8ad7dd2f564a877cc23feea6c0a9cc2e783715");
                console.log("result1 : " + result);
                var result = myContractInstance.members(1);
                console.log("result2 : " + result);
            } else console.log("Error");
        });
    }
    pingyo() {
        let promise = new Promise(function(resolve, reject) {
            setTimeout(()=>{
                resolve("done");
            }, 2000);
        });
        return promise;
    }
    updateNodeAsync(data) {
        // WRITE NEO 4J 
        var prom = new Promise((resolve, reject)=>{
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var resObj = JSON.parse(xhttp.responseText);
                        var outmessage = resObj.message;
                        var jtkn = resObj.tkn;
                        resolve(resObj);
                    } else reject('error in login ');
                     //window.location.replace('/');
                }
            };
            // xhttp.open("POST", official_base+"/jxtavail", true);
            //xhttp.withCredentials = true;
            xhttp.open("POST", (0, $27f78834e6ba71b5$export$6d7e0922250f6b7a) + "/jxtsavenode", true);
            xhttp.setRequestHeader("Content-type", 'application/json; charset=UTF-8');
            xhttp.send(JSON.stringify(data));
        });
        return prom;
    }
    getJsonFromUrl(url) {
        if (!url) url = location.href;
        var question = url.indexOf("?");
        var hash = url.indexOf("#");
        if (hash == -1 && question == -1) return {};
        if (hash == -1) hash = url.length;
        var query = question == -1 || hash == question + 1 ? url.substring(hash) : url.substring(question + 1, hash);
        var result = {};
        query.split("&").forEach(function(part) {
            if (!part) return;
            part = part.split("+").join(" "); // replace every + with space, regexp-free version
            var eq = part.indexOf("=");
            var key = eq > -1 ? part.substr(0, eq) : part;
            var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
            var from = key.indexOf("[");
            if (from == -1) result[decodeURIComponent(key)] = val;
            else {
                var to = key.indexOf("]", from);
                var index = decodeURIComponent(key.substring(from + 1, to));
                key = decodeURIComponent(key.substring(0, from));
                if (!result[key]) result[key] = [];
                if (!index) result[key].push(val);
                else result[key][index] = val;
            }
        });
        return result;
    }
}
//window.connector = new Connector(); // haha
var $7164e009da884f04$export$f79a732982c93a3b = new $7164e009da884f04$var$Connector();


function $f7cabcf4b0e0fb2e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f7cabcf4b0e0fb2e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.7.1
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $f7cabcf4b0e0fb2e$var$_config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, $f7cabcf4b0e0fb2e$var$_defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, $f7cabcf4b0e0fb2e$var$_suppressOverwrites, $f7cabcf4b0e0fb2e$var$_bigNum = 1e8, $f7cabcf4b0e0fb2e$var$_tinyNum = 1 / $f7cabcf4b0e0fb2e$var$_bigNum, $f7cabcf4b0e0fb2e$var$_2PI = Math.PI * 2, $f7cabcf4b0e0fb2e$var$_HALF_PI = $f7cabcf4b0e0fb2e$var$_2PI / 4, $f7cabcf4b0e0fb2e$var$_gsID = 0, $f7cabcf4b0e0fb2e$var$_sqrt = Math.sqrt, $f7cabcf4b0e0fb2e$var$_cos = Math.cos, $f7cabcf4b0e0fb2e$var$_sin = Math.sin, $f7cabcf4b0e0fb2e$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $f7cabcf4b0e0fb2e$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $f7cabcf4b0e0fb2e$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $f7cabcf4b0e0fb2e$var$_isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, $f7cabcf4b0e0fb2e$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $f7cabcf4b0e0fb2e$var$_isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, $f7cabcf4b0e0fb2e$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $f7cabcf4b0e0fb2e$var$_isFuncOrString = function _isFuncOrString(value) {
    return $f7cabcf4b0e0fb2e$var$_isFunction(value) || $f7cabcf4b0e0fb2e$var$_isString(value);
}, $f7cabcf4b0e0fb2e$var$_isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
$f7cabcf4b0e0fb2e$var$_isArray = Array.isArray, $f7cabcf4b0e0fb2e$var$_strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
$f7cabcf4b0e0fb2e$var$_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$f7cabcf4b0e0fb2e$var$_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, $f7cabcf4b0e0fb2e$var$_complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
$f7cabcf4b0e0fb2e$var$_relExp = /[+-]=-?[.\d]+/, $f7cabcf4b0e0fb2e$var$_delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
$f7cabcf4b0e0fb2e$var$_unitExp = /[\d.+\-=]+(?:e[-+]\d*)*/i, $f7cabcf4b0e0fb2e$var$_globalTimeline, $f7cabcf4b0e0fb2e$var$_win, $f7cabcf4b0e0fb2e$var$_coreInitted, $f7cabcf4b0e0fb2e$var$_doc, $f7cabcf4b0e0fb2e$var$_globals = {}, $f7cabcf4b0e0fb2e$var$_installScope = {}, $f7cabcf4b0e0fb2e$var$_coreReady, $f7cabcf4b0e0fb2e$var$_install = function _install(scope) {
    return ($f7cabcf4b0e0fb2e$var$_installScope = $f7cabcf4b0e0fb2e$var$_merge(scope, $f7cabcf4b0e0fb2e$var$_globals)) && $f7cabcf4b0e0fb2e$var$gsap;
}, $f7cabcf4b0e0fb2e$var$_missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, $f7cabcf4b0e0fb2e$var$_warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, $f7cabcf4b0e0fb2e$var$_addGlobal = function _addGlobal(name, obj) {
    return name && ($f7cabcf4b0e0fb2e$var$_globals[name] = obj) && $f7cabcf4b0e0fb2e$var$_installScope && ($f7cabcf4b0e0fb2e$var$_installScope[name] = obj) || $f7cabcf4b0e0fb2e$var$_globals;
}, $f7cabcf4b0e0fb2e$var$_emptyFunc = function _emptyFunc() {
    return 0;
}, $f7cabcf4b0e0fb2e$var$_reservedProps = {}, $f7cabcf4b0e0fb2e$var$_lazyTweens = [], $f7cabcf4b0e0fb2e$var$_lazyLookup = {}, $f7cabcf4b0e0fb2e$var$_lastRenderedFrame, $f7cabcf4b0e0fb2e$var$_plugins = {}, $f7cabcf4b0e0fb2e$var$_effects = {}, $f7cabcf4b0e0fb2e$var$_nextGCFrame = 30, $f7cabcf4b0e0fb2e$var$_harnessPlugins = [], $f7cabcf4b0e0fb2e$var$_callbackNames = "", $f7cabcf4b0e0fb2e$var$_harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    $f7cabcf4b0e0fb2e$var$_isObject(target) || $f7cabcf4b0e0fb2e$var$_isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = $f7cabcf4b0e0fb2e$var$_harnessPlugins.length;
        while(i-- && !$f7cabcf4b0e0fb2e$var$_harnessPlugins[i].targetTest(target));
        harnessPlugin = $f7cabcf4b0e0fb2e$var$_harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new $f7cabcf4b0e0fb2e$var$GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, $f7cabcf4b0e0fb2e$var$_getCache = function _getCache(target) {
    return target._gsap || $f7cabcf4b0e0fb2e$var$_harness($f7cabcf4b0e0fb2e$var$toArray(target))[0]._gsap;
}, $f7cabcf4b0e0fb2e$var$_getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && $f7cabcf4b0e0fb2e$var$_isFunction(v) ? target[property]() : $f7cabcf4b0e0fb2e$var$_isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, $f7cabcf4b0e0fb2e$var$_forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
$f7cabcf4b0e0fb2e$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $f7cabcf4b0e0fb2e$var$_arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, $f7cabcf4b0e0fb2e$var$_lazyRender = function _lazyRender() {
    var l = $f7cabcf4b0e0fb2e$var$_lazyTweens.length, a = $f7cabcf4b0e0fb2e$var$_lazyTweens.slice(0), i, tween;
    $f7cabcf4b0e0fb2e$var$_lazyLookup = {};
    $f7cabcf4b0e0fb2e$var$_lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, $f7cabcf4b0e0fb2e$var$_lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    $f7cabcf4b0e0fb2e$var$_lazyTweens.length && $f7cabcf4b0e0fb2e$var$_lazyRender();
    animation.render(time, suppressEvents, force);
    $f7cabcf4b0e0fb2e$var$_lazyTweens.length && $f7cabcf4b0e0fb2e$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, $f7cabcf4b0e0fb2e$var$_numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match($f7cabcf4b0e0fb2e$var$_delimitedValueExp).length < 2 ? n : $f7cabcf4b0e0fb2e$var$_isString(value) ? value.trim() : value;
}, $f7cabcf4b0e0fb2e$var$_passThrough = function _passThrough(p) {
    return p;
}, $f7cabcf4b0e0fb2e$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $f7cabcf4b0e0fb2e$var$_setKeyframeDefaults = function _setKeyframeDefaults(obj, defaults) {
    for(var p in defaults)p in obj || p === "duration" || p === "ease" || (obj[p] = defaults[p]);
}, $f7cabcf4b0e0fb2e$var$_merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, $f7cabcf4b0e0fb2e$var$_mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = $f7cabcf4b0e0fb2e$var$_isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, $f7cabcf4b0e0fb2e$var$_copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, $f7cabcf4b0e0fb2e$var$_inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || $f7cabcf4b0e0fb2e$var$_globalTimeline, func = vars.keyframes ? $f7cabcf4b0e0fb2e$var$_setKeyframeDefaults : $f7cabcf4b0e0fb2e$var$_setDefaults;
    if ($f7cabcf4b0e0fb2e$var$_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, $f7cabcf4b0e0fb2e$var$_arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, $f7cabcf4b0e0fb2e$var$_addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, $f7cabcf4b0e0fb2e$var$_removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, $f7cabcf4b0e0fb2e$var$_removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove(child);
    child._act = 0;
}, $f7cabcf4b0e0fb2e$var$_uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, $f7cabcf4b0e0fb2e$var$_recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, $f7cabcf4b0e0fb2e$var$_hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, $f7cabcf4b0e0fb2e$var$_elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? $f7cabcf4b0e0fb2e$var$_animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
$f7cabcf4b0e0fb2e$var$_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, $f7cabcf4b0e0fb2e$var$_parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, $f7cabcf4b0e0fb2e$var$_setEnd = function _setEnd(animation) {
    return animation._end = $f7cabcf4b0e0fb2e$var$_round(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || $f7cabcf4b0e0fb2e$var$_tinyNum) || 0));
}, $f7cabcf4b0e0fb2e$var$_alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = $f7cabcf4b0e0fb2e$var$_round(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        $f7cabcf4b0e0fb2e$var$_setEnd(animation);
        parent._dirty || $f7cabcf4b0e0fb2e$var$_uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ $f7cabcf4b0e0fb2e$var$_postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || child._initted && !child._dur) {
        //in case, for example, the _start is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
        t = $f7cabcf4b0e0fb2e$var$_parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || $f7cabcf4b0e0fb2e$var$_clamp(0, child.totalDuration(), t) - child._tTime > $f7cabcf4b0e0fb2e$var$_tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if ($f7cabcf4b0e0fb2e$var$_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -$f7cabcf4b0e0fb2e$var$_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, $f7cabcf4b0e0fb2e$var$_addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && $f7cabcf4b0e0fb2e$var$_removeFromParent(child);
    child._start = $f7cabcf4b0e0fb2e$var$_round(($f7cabcf4b0e0fb2e$var$_isNumber(position) ? position : position || timeline !== $f7cabcf4b0e0fb2e$var$_globalTimeline ? $f7cabcf4b0e0fb2e$var$_parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = $f7cabcf4b0e0fb2e$var$_round(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    $f7cabcf4b0e0fb2e$var$_addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    $f7cabcf4b0e0fb2e$var$_isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || $f7cabcf4b0e0fb2e$var$_postAddChecks(timeline, child);
    return timeline;
}, $f7cabcf4b0e0fb2e$var$_scrollTrigger = function _scrollTrigger(animation, trigger) {
    return ($f7cabcf4b0e0fb2e$var$_globals.ScrollTrigger || $f7cabcf4b0e0fb2e$var$_missingPlugin("scrollTrigger", trigger)) && $f7cabcf4b0e0fb2e$var$_globals.ScrollTrigger.create(trigger, animation);
}, $f7cabcf4b0e0fb2e$var$_attemptInitTween = function _attemptInitTween(tween, totalTime, force, suppressEvents) {
    $f7cabcf4b0e0fb2e$var$_initTween(tween, totalTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && $f7cabcf4b0e0fb2e$var$_lastRenderedFrame !== $f7cabcf4b0e0fb2e$var$_ticker.frame) {
        $f7cabcf4b0e0fb2e$var$_lazyTweens.push(tween);
        tween._lazy = [
            totalTime,
            suppressEvents
        ];
        return 1;
    }
}, $f7cabcf4b0e0fb2e$var$_parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
$f7cabcf4b0e0fb2e$var$_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, $f7cabcf4b0e0fb2e$var$_renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && $f7cabcf4b0e0fb2e$var$_parentPlayheadIsBeforeStart(tween) && !(!tween._initted && $f7cabcf4b0e0fb2e$var$_isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !$f7cabcf4b0e0fb2e$var$_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = $f7cabcf4b0e0fb2e$var$_clamp(0, tween._tDur, totalTime);
        iteration = $f7cabcf4b0e0fb2e$var$_animationCycle(tTime, repeatDelay);
        prevIteration = $f7cabcf4b0e0fb2e$var$_animationCycle(tween._tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== prevIteration) {
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || force || tween._zTime === $f7cabcf4b0e0fb2e$var$_tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && $f7cabcf4b0e0fb2e$var$_attemptInitTween(tween, totalTime, force, suppressEvents)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? $f7cabcf4b0e0fb2e$var$_tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        tween._startAt && totalTime < 0 && tween._startAt.render(totalTime, true, true);
        tween._onUpdate && !suppressEvents && $f7cabcf4b0e0fb2e$var$_callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && $f7cabcf4b0e0fb2e$var$_callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && $f7cabcf4b0e0fb2e$var$_removeFromParent(tween, 1);
            if (!suppressEvents) {
                $f7cabcf4b0e0fb2e$var$_callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, $f7cabcf4b0e0fb2e$var$_findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (!child._dur && child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (!child._dur && child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, $f7cabcf4b0e0fb2e$var$_setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = $f7cabcf4b0e0fb2e$var$_round(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : $f7cabcf4b0e0fb2e$var$_round(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress && !leavePlayhead ? $f7cabcf4b0e0fb2e$var$_alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress) : animation.parent && $f7cabcf4b0e0fb2e$var$_setEnd(animation);
    skipUncache || $f7cabcf4b0e0fb2e$var$_uncache(animation.parent, animation);
    return animation;
}, $f7cabcf4b0e0fb2e$var$_onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65 ? $f7cabcf4b0e0fb2e$var$_uncache(animation) : $f7cabcf4b0e0fb2e$var$_setDuration(animation, animation._dur);
}, $f7cabcf4b0e0fb2e$var$_zeroPosition = {
    _start: 0,
    endTime: $f7cabcf4b0e0fb2e$var$_emptyFunc,
    totalDuration: $f7cabcf4b0e0fb2e$var$_emptyFunc
}, $f7cabcf4b0e0fb2e$var$_parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || $f7cabcf4b0e0fb2e$var$_zeroPosition, clippedDuration = animation.duration() >= $f7cabcf4b0e0fb2e$var$_bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if ($f7cabcf4b0e0fb2e$var$_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * ($f7cabcf4b0e0fb2e$var$_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, $f7cabcf4b0e0fb2e$var$_createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = $f7cabcf4b0e0fb2e$var$_isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = $f7cabcf4b0e0fb2e$var$_isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = $f7cabcf4b0e0fb2e$var$_isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new $f7cabcf4b0e0fb2e$export$2a5557542e634d07(params[0], vars, params[varsIndex + 1]);
}, $f7cabcf4b0e0fb2e$var$_conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, $f7cabcf4b0e0fb2e$var$_clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, $f7cabcf4b0e0fb2e$var$getUnit = function getUnit(value) {
    if (typeof value !== "string") return "";
    var v = $f7cabcf4b0e0fb2e$var$_unitExp.exec(value);
    return v ? value.substr(v.index + v[0].length) : "";
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
$f7cabcf4b0e0fb2e$var$clamp = function clamp(min, max, value) {
    return $f7cabcf4b0e0fb2e$var$_conditionalReturn(value, function(v) {
        return $f7cabcf4b0e0fb2e$var$_clamp(min, max, v);
    });
}, $f7cabcf4b0e0fb2e$var$_slice = [].slice, $f7cabcf4b0e0fb2e$var$_isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && $f7cabcf4b0e0fb2e$var$_isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && $f7cabcf4b0e0fb2e$var$_isObject(value[0])) && !value.nodeType && value !== $f7cabcf4b0e0fb2e$var$_win;
}, $f7cabcf4b0e0fb2e$var$_flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return $f7cabcf4b0e0fb2e$var$_isString(value) && !leaveStrings || $f7cabcf4b0e0fb2e$var$_isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, $f7cabcf4b0e0fb2e$var$toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
$f7cabcf4b0e0fb2e$var$toArray = function toArray(value, scope, leaveStrings) {
    return $f7cabcf4b0e0fb2e$var$_isString(value) && !leaveStrings && ($f7cabcf4b0e0fb2e$var$_coreInitted || !$f7cabcf4b0e0fb2e$var$_wake()) ? $f7cabcf4b0e0fb2e$var$_slice.call((scope || $f7cabcf4b0e0fb2e$var$_doc).querySelectorAll(value), 0) : $f7cabcf4b0e0fb2e$var$_isArray(value) ? $f7cabcf4b0e0fb2e$var$_flatten(value, leaveStrings) : $f7cabcf4b0e0fb2e$var$_isArrayLike(value) ? $f7cabcf4b0e0fb2e$var$_slice.call(value, 0) : value ? [
        value
    ] : [];
}, $f7cabcf4b0e0fb2e$var$selector = function selector(value) {
    value = $f7cabcf4b0e0fb2e$var$toArray(value)[0] || $f7cabcf4b0e0fb2e$var$_warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return $f7cabcf4b0e0fb2e$var$toArray(v, el.querySelectorAll ? el : el === value ? $f7cabcf4b0e0fb2e$var$_warn("Invalid scope") || $f7cabcf4b0e0fb2e$var$_doc.createElement("div") : value);
    };
}, $f7cabcf4b0e0fb2e$var$shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
$f7cabcf4b0e0fb2e$var$distribute = function distribute(v) {
    if ($f7cabcf4b0e0fb2e$var$_isFunction(v)) return v;
    var vars = $f7cabcf4b0e0fb2e$var$_isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = $f7cabcf4b0e0fb2e$var$_parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if ($f7cabcf4b0e0fb2e$var$_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                $f7cabcf4b0e0fb2e$var$_bigNum
            ])[1];
            if (!wrapAt) {
                max = -$f7cabcf4b0e0fb2e$var$_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = $f7cabcf4b0e0fb2e$var$_bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? $f7cabcf4b0e0fb2e$var$_sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && $f7cabcf4b0e0fb2e$var$shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = $f7cabcf4b0e0fb2e$var$getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? $f7cabcf4b0e0fb2e$var$_invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return $f7cabcf4b0e0fb2e$var$_round(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, $f7cabcf4b0e0fb2e$var$_roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = v < 1 ? Math.pow(10, (v + "").length - 2) : 1; //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed()
    return function(raw) {
        var n = Math.round(parseFloat(raw) / v) * v * p;
        return (n - n % 1) / p + ($f7cabcf4b0e0fb2e$var$_isNumber(raw) ? 0 : $f7cabcf4b0e0fb2e$var$getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, $f7cabcf4b0e0fb2e$var$snap = function snap(snapTo, value) {
    var isArray = $f7cabcf4b0e0fb2e$var$_isArray(snapTo), radius, is2D;
    if (!isArray && $f7cabcf4b0e0fb2e$var$_isObject(snapTo)) {
        radius = isArray = snapTo.radius || $f7cabcf4b0e0fb2e$var$_bigNum;
        if (snapTo.values) {
            snapTo = $f7cabcf4b0e0fb2e$var$toArray(snapTo.values);
            if (is2D = !$f7cabcf4b0e0fb2e$var$_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = $f7cabcf4b0e0fb2e$var$_roundModifier(snapTo.increment);
    }
    return $f7cabcf4b0e0fb2e$var$_conditionalReturn(value, !isArray ? $f7cabcf4b0e0fb2e$var$_roundModifier(snapTo) : $f7cabcf4b0e0fb2e$var$_isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = $f7cabcf4b0e0fb2e$var$_bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || $f7cabcf4b0e0fb2e$var$_isNumber(raw) ? closest : closest + $f7cabcf4b0e0fb2e$var$getUnit(raw);
    });
}, $f7cabcf4b0e0fb2e$var$random = function random(min, max, roundingIncrement, returnFunction) {
    return $f7cabcf4b0e0fb2e$var$_conditionalReturn($f7cabcf4b0e0fb2e$var$_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return $f7cabcf4b0e0fb2e$var$_isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, $f7cabcf4b0e0fb2e$var$pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, $f7cabcf4b0e0fb2e$var$unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || $f7cabcf4b0e0fb2e$var$getUnit(value));
    };
}, $f7cabcf4b0e0fb2e$var$normalize = function normalize(min, max, value) {
    return $f7cabcf4b0e0fb2e$var$mapRange(min, max, 0, 1, value);
}, $f7cabcf4b0e0fb2e$var$_wrapArray = function _wrapArray(a, wrapper, value) {
    return $f7cabcf4b0e0fb2e$var$_conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, $f7cabcf4b0e0fb2e$var$wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return $f7cabcf4b0e0fb2e$var$_isArray(min) ? $f7cabcf4b0e0fb2e$var$_wrapArray(min, wrap(0, min.length), max) : $f7cabcf4b0e0fb2e$var$_conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, $f7cabcf4b0e0fb2e$var$wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return $f7cabcf4b0e0fb2e$var$_isArray(min) ? $f7cabcf4b0e0fb2e$var$_wrapArray(min, wrapYoyo(0, min.length - 1), max) : $f7cabcf4b0e0fb2e$var$_conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, $f7cabcf4b0e0fb2e$var$_replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? $f7cabcf4b0e0fb2e$var$_delimitedValueExp : $f7cabcf4b0e0fb2e$var$_strictNumExp);
        s += value.substr(prev, i - prev) + $f7cabcf4b0e0fb2e$var$random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, $f7cabcf4b0e0fb2e$var$mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return $f7cabcf4b0e0fb2e$var$_conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, $f7cabcf4b0e0fb2e$var$interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = $f7cabcf4b0e0fb2e$var$_isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if ($f7cabcf4b0e0fb2e$var$_isArray(start) && !$f7cabcf4b0e0fb2e$var$_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = $f7cabcf4b0e0fb2e$var$_merge($f7cabcf4b0e0fb2e$var$_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)$f7cabcf4b0e0fb2e$var$_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return $f7cabcf4b0e0fb2e$var$_renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return $f7cabcf4b0e0fb2e$var$_conditionalReturn(progress, func);
}, $f7cabcf4b0e0fb2e$var$_getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = $f7cabcf4b0e0fb2e$var$_bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, $f7cabcf4b0e0fb2e$var$_callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], params, scope;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && $f7cabcf4b0e0fb2e$var$_lazyTweens.length && $f7cabcf4b0e0fb2e$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    return params ? callback.apply(scope, params) : callback.call(scope);
}, $f7cabcf4b0e0fb2e$var$_interrupt = function _interrupt(animation) {
    $f7cabcf4b0e0fb2e$var$_removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(false);
    animation.progress() < 1 && $f7cabcf4b0e0fb2e$var$_callback(animation, "onInterrupt");
    return animation;
}, $f7cabcf4b0e0fb2e$var$_quickTween, $f7cabcf4b0e0fb2e$var$_createPlugin = function _createPlugin(config) {
    config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    var name = config.name, isFunc = $f7cabcf4b0e0fb2e$var$_isFunction(config), Plugin = name && !isFunc && config.init ? function() {
        this._props = [];
    } : config, //in case someone passes in an object that's not a plugin, like CustomEase
    instanceDefaults = {
        init: $f7cabcf4b0e0fb2e$var$_emptyFunc,
        render: $f7cabcf4b0e0fb2e$var$_renderPropTweens,
        add: $f7cabcf4b0e0fb2e$var$_addPropTween,
        kill: $f7cabcf4b0e0fb2e$var$_killPropTweensOf,
        modifier: $f7cabcf4b0e0fb2e$var$_addPluginModifier,
        rawVars: 0
    }, statics = {
        targetTest: 0,
        get: 0,
        getSetter: $f7cabcf4b0e0fb2e$var$_getSetter,
        aliases: {},
        register: 0
    };
    $f7cabcf4b0e0fb2e$var$_wake();
    if (config !== Plugin) {
        if ($f7cabcf4b0e0fb2e$var$_plugins[name]) return;
        $f7cabcf4b0e0fb2e$var$_setDefaults(Plugin, $f7cabcf4b0e0fb2e$var$_setDefaults($f7cabcf4b0e0fb2e$var$_copyExcluding(config, instanceDefaults), statics)); //static methods
        $f7cabcf4b0e0fb2e$var$_merge(Plugin.prototype, $f7cabcf4b0e0fb2e$var$_merge(instanceDefaults, $f7cabcf4b0e0fb2e$var$_copyExcluding(config, statics))); //instance methods
        $f7cabcf4b0e0fb2e$var$_plugins[Plugin.prop = name] = Plugin;
        if (config.targetTest) {
            $f7cabcf4b0e0fb2e$var$_harnessPlugins.push(Plugin);
            $f7cabcf4b0e0fb2e$var$_reservedProps[name] = 1;
        }
        name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
    }
    $f7cabcf4b0e0fb2e$var$_addGlobal(name, Plugin);
    config.register && config.register($f7cabcf4b0e0fb2e$var$gsap, Plugin, $f7cabcf4b0e0fb2e$var$PropTween);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ $f7cabcf4b0e0fb2e$var$_255 = 255, $f7cabcf4b0e0fb2e$var$_colorLookup = {
    aqua: [
        0,
        $f7cabcf4b0e0fb2e$var$_255,
        $f7cabcf4b0e0fb2e$var$_255
    ],
    lime: [
        0,
        $f7cabcf4b0e0fb2e$var$_255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        $f7cabcf4b0e0fb2e$var$_255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        $f7cabcf4b0e0fb2e$var$_255,
        $f7cabcf4b0e0fb2e$var$_255,
        $f7cabcf4b0e0fb2e$var$_255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        $f7cabcf4b0e0fb2e$var$_255,
        $f7cabcf4b0e0fb2e$var$_255,
        0
    ],
    orange: [
        $f7cabcf4b0e0fb2e$var$_255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        $f7cabcf4b0e0fb2e$var$_255,
        0,
        0
    ],
    pink: [
        $f7cabcf4b0e0fb2e$var$_255,
        192,
        203
    ],
    cyan: [
        0,
        $f7cabcf4b0e0fb2e$var$_255,
        $f7cabcf4b0e0fb2e$var$_255
    ],
    transparent: [
        $f7cabcf4b0e0fb2e$var$_255,
        $f7cabcf4b0e0fb2e$var$_255,
        $f7cabcf4b0e0fb2e$var$_255,
        0
    ]
}, $f7cabcf4b0e0fb2e$var$_hue = function _hue(h, m1, m2) {
    h = h < 0 ? h + 1 : h > 1 ? h - 1 : h;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * $f7cabcf4b0e0fb2e$var$_255 + .5 | 0;
}, $f7cabcf4b0e0fb2e$var$splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? $f7cabcf4b0e0fb2e$var$_colorLookup.black : $f7cabcf4b0e0fb2e$var$_isNumber(v) ? [
        v >> 16,
        v >> 8 & $f7cabcf4b0e0fb2e$var$_255,
        v & $f7cabcf4b0e0fb2e$var$_255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if ($f7cabcf4b0e0fb2e$var$_colorLookup[v]) a = $f7cabcf4b0e0fb2e$var$_colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & $f7cabcf4b0e0fb2e$var$_255,
                    a & $f7cabcf4b0e0fb2e$var$_255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & $f7cabcf4b0e0fb2e$var$_255,
                v & $f7cabcf4b0e0fb2e$var$_255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match($f7cabcf4b0e0fb2e$var$_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = $f7cabcf4b0e0fb2e$var$_hue(h + 1 / 3, r, g);
                a[1] = $f7cabcf4b0e0fb2e$var$_hue(h, r, g);
                a[2] = $f7cabcf4b0e0fb2e$var$_hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match($f7cabcf4b0e0fb2e$var$_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match($f7cabcf4b0e0fb2e$var$_strictNumExp) || $f7cabcf4b0e0fb2e$var$_colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / $f7cabcf4b0e0fb2e$var$_255;
        g = a[1] / $f7cabcf4b0e0fb2e$var$_255;
        b = a[2] / $f7cabcf4b0e0fb2e$var$_255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, $f7cabcf4b0e0fb2e$var$_colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split($f7cabcf4b0e0fb2e$var$_colorExp).forEach(function(v) {
        var a = v.match($f7cabcf4b0e0fb2e$var$_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, $f7cabcf4b0e0fb2e$var$_formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match($f7cabcf4b0e0fb2e$var$_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = $f7cabcf4b0e0fb2e$var$splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = $f7cabcf4b0e0fb2e$var$_colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace($f7cabcf4b0e0fb2e$var$_colorExp, "1").split($f7cabcf4b0e0fb2e$var$_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split($f7cabcf4b0e0fb2e$var$_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, $f7cabcf4b0e0fb2e$var$_colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in $f7cabcf4b0e0fb2e$var$_colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), $f7cabcf4b0e0fb2e$var$_hslExp = /hsl[a]?\(/, $f7cabcf4b0e0fb2e$var$_colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    $f7cabcf4b0e0fb2e$var$_colorExp.lastIndex = 0;
    if ($f7cabcf4b0e0fb2e$var$_colorExp.test(combined)) {
        toHSL = $f7cabcf4b0e0fb2e$var$_hslExp.test(combined);
        a[1] = $f7cabcf4b0e0fb2e$var$_formatColors(a[1], toHSL);
        a[0] = $f7cabcf4b0e0fb2e$var$_formatColors(a[0], toHSL, $f7cabcf4b0e0fb2e$var$_colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ $f7cabcf4b0e0fb2e$var$_tickerActive, $f7cabcf4b0e0fb2e$var$_ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if ($f7cabcf4b0e0fb2e$var$_coreReady) {
                if (!$f7cabcf4b0e0fb2e$var$_coreInitted && $f7cabcf4b0e0fb2e$var$_windowExists()) {
                    $f7cabcf4b0e0fb2e$var$_win = $f7cabcf4b0e0fb2e$var$_coreInitted = window;
                    $f7cabcf4b0e0fb2e$var$_doc = $f7cabcf4b0e0fb2e$var$_win.document || {};
                    $f7cabcf4b0e0fb2e$var$_globals.gsap = $f7cabcf4b0e0fb2e$var$gsap;
                    ($f7cabcf4b0e0fb2e$var$_win.gsapVersions || ($f7cabcf4b0e0fb2e$var$_win.gsapVersions = [])).push($f7cabcf4b0e0fb2e$var$gsap.version);
                    $f7cabcf4b0e0fb2e$var$_install($f7cabcf4b0e0fb2e$var$_installScope || $f7cabcf4b0e0fb2e$var$_win.GreenSockGlobals || !$f7cabcf4b0e0fb2e$var$_win.gsap && $f7cabcf4b0e0fb2e$var$_win || {});
                    _raf = $f7cabcf4b0e0fb2e$var$_win.requestAnimationFrame;
                }
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                $f7cabcf4b0e0fb2e$var$_tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? $f7cabcf4b0e0fb2e$var$_win.cancelAnimationFrame : clearTimeout)(_id);
            $f7cabcf4b0e0fb2e$var$_tickerActive = 0;
            _req = $f7cabcf4b0e0fb2e$var$_emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || 1 / $f7cabcf4b0e0fb2e$var$_tinyNum; //zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback) {
            _listeners.indexOf(callback) < 0 && _listeners.push(callback);
            $f7cabcf4b0e0fb2e$var$_wake();
        },
        remove: function remove(callback) {
            var i;
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), $f7cabcf4b0e0fb2e$var$_wake = function _wake() {
    return !$f7cabcf4b0e0fb2e$var$_tickerActive && $f7cabcf4b0e0fb2e$var$_ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ $f7cabcf4b0e0fb2e$var$_easeMap = {}, $f7cabcf4b0e0fb2e$var$_customEaseExp = /^[\d.\-M][\d.\-,\s]/, $f7cabcf4b0e0fb2e$var$_quotesExp = /["']/g, $f7cabcf4b0e0fb2e$var$_parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace($f7cabcf4b0e0fb2e$var$_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, $f7cabcf4b0e0fb2e$var$_valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, $f7cabcf4b0e0fb2e$var$_configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = $f7cabcf4b0e0fb2e$var$_easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        $f7cabcf4b0e0fb2e$var$_parseObjectInString(split[1])
    ] : $f7cabcf4b0e0fb2e$var$_valueInParentheses(name).split(",").map($f7cabcf4b0e0fb2e$var$_numericIfPossible)) : $f7cabcf4b0e0fb2e$var$_easeMap._CE && $f7cabcf4b0e0fb2e$var$_customEaseExp.test(name) ? $f7cabcf4b0e0fb2e$var$_easeMap._CE("", name) : ease;
}, $f7cabcf4b0e0fb2e$var$_invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
$f7cabcf4b0e0fb2e$var$_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, $f7cabcf4b0e0fb2e$var$_parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : ($f7cabcf4b0e0fb2e$var$_isFunction(ease) ? ease : $f7cabcf4b0e0fb2e$var$_easeMap[ease] || $f7cabcf4b0e0fb2e$var$_configEaseFromString(ease)) || defaultEase;
}, $f7cabcf4b0e0fb2e$var$_insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    $f7cabcf4b0e0fb2e$var$_forEachName(names, function(name) {
        $f7cabcf4b0e0fb2e$var$_easeMap[name] = $f7cabcf4b0e0fb2e$var$_globals[name] = ease;
        $f7cabcf4b0e0fb2e$var$_easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)$f7cabcf4b0e0fb2e$var$_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = $f7cabcf4b0e0fb2e$var$_easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, $f7cabcf4b0e0fb2e$var$_easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, $f7cabcf4b0e0fb2e$var$_configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / $f7cabcf4b0e0fb2e$var$_2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * $f7cabcf4b0e0fb2e$var$_sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $f7cabcf4b0e0fb2e$var$_easeInOutFromOut(easeOut);
    p2 = $f7cabcf4b0e0fb2e$var$_2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, $f7cabcf4b0e0fb2e$var$_configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $f7cabcf4b0e0fb2e$var$_easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
$f7cabcf4b0e0fb2e$var$_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    $f7cabcf4b0e0fb2e$var$_insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
$f7cabcf4b0e0fb2e$var$_easeMap.Linear.easeNone = $f7cabcf4b0e0fb2e$var$_easeMap.none = $f7cabcf4b0e0fb2e$var$_easeMap.Linear.easeIn;
$f7cabcf4b0e0fb2e$var$_insertEase("Elastic", $f7cabcf4b0e0fb2e$var$_configElastic("in"), $f7cabcf4b0e0fb2e$var$_configElastic("out"), $f7cabcf4b0e0fb2e$var$_configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    $f7cabcf4b0e0fb2e$var$_insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
$f7cabcf4b0e0fb2e$var$_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
$f7cabcf4b0e0fb2e$var$_insertEase("Circ", function(p) {
    return -($f7cabcf4b0e0fb2e$var$_sqrt(1 - p * p) - 1);
});
$f7cabcf4b0e0fb2e$var$_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -$f7cabcf4b0e0fb2e$var$_cos(p * $f7cabcf4b0e0fb2e$var$_HALF_PI) + 1;
});
$f7cabcf4b0e0fb2e$var$_insertEase("Back", $f7cabcf4b0e0fb2e$var$_configBack("in"), $f7cabcf4b0e0fb2e$var$_configBack("out"), $f7cabcf4b0e0fb2e$var$_configBack());
$f7cabcf4b0e0fb2e$var$_easeMap.SteppedEase = $f7cabcf4b0e0fb2e$var$_easeMap.steps = $f7cabcf4b0e0fb2e$var$_globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - $f7cabcf4b0e0fb2e$var$_tinyNum;
        return function(p) {
            return ((p2 * $f7cabcf4b0e0fb2e$var$_clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
$f7cabcf4b0e0fb2e$var$_defaults.ease = $f7cabcf4b0e0fb2e$var$_easeMap["quad.out"];
$f7cabcf4b0e0fb2e$var$_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return $f7cabcf4b0e0fb2e$var$_callbackNames += name + "," + name + "Params,";
});
/*
 * --------------------------------------------------------------------------------------
 * CACHE
 * --------------------------------------------------------------------------------------
 */ var $f7cabcf4b0e0fb2e$var$GSCache = function GSCache(target, harness) {
    this.id = $f7cabcf4b0e0fb2e$var$_gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : $f7cabcf4b0e0fb2e$var$_getProperty;
    this.set = harness ? harness.getSetter : $f7cabcf4b0e0fb2e$var$_getSetter;
};
/*
 * --------------------------------------------------------------------------------------
 * ANIMATION
 * --------------------------------------------------------------------------------------
 */ var $f7cabcf4b0e0fb2e$var$Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        $f7cabcf4b0e0fb2e$var$_setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        $f7cabcf4b0e0fb2e$var$_tickerActive || $f7cabcf4b0e0fb2e$var$_ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return $f7cabcf4b0e0fb2e$var$_setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        $f7cabcf4b0e0fb2e$var$_wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            $f7cabcf4b0e0fb2e$var$_alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || $f7cabcf4b0e0fb2e$var$_postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            $f7cabcf4b0e0fb2e$var$_addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === $f7cabcf4b0e0fb2e$var$_tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            $f7cabcf4b0e0fb2e$var$_lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + $f7cabcf4b0e0fb2e$var$_elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + $f7cabcf4b0e0fb2e$var$_elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? $f7cabcf4b0e0fb2e$var$_animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value) {
        if (!arguments.length) return this._rts === -$f7cabcf4b0e0fb2e$var$_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? $f7cabcf4b0e0fb2e$var$_parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -$f7cabcf4b0e0fb2e$var$_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        return $f7cabcf4b0e0fb2e$var$_recacheAncestors(this.totalTime($f7cabcf4b0e0fb2e$var$_clamp(-this._delay, this._tDur, tTime), true));
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                $f7cabcf4b0e0fb2e$var$_wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== $f7cabcf4b0e0fb2e$var$_tinyNum && (this._tTime -= $f7cabcf4b0e0fb2e$var$_tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && $f7cabcf4b0e0fb2e$var$_addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + ($f7cabcf4b0e0fb2e$var$_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : $f7cabcf4b0e0fb2e$var$_parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (animation._ts || 1);
            animation = animation._dp;
        }
        return time;
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return $f7cabcf4b0e0fb2e$var$_onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            $f7cabcf4b0e0fb2e$var$_onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime($f7cabcf4b0e0fb2e$var$_parsePosition(this, position), $f7cabcf4b0e0fb2e$var$_isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, $f7cabcf4b0e0fb2e$var$_isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -$f7cabcf4b0e0fb2e$var$_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -$f7cabcf4b0e0fb2e$var$_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - $f7cabcf4b0e0fb2e$var$_tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = $f7cabcf4b0e0fb2e$var$_isFunction(onFulfilled) ? onFulfilled : $f7cabcf4b0e0fb2e$var$_passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                $f7cabcf4b0e0fb2e$var$_isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        $f7cabcf4b0e0fb2e$var$_interrupt(this);
    };
    return Animation;
}();
$f7cabcf4b0e0fb2e$var$_setDefaults($f7cabcf4b0e0fb2e$var$Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -$f7cabcf4b0e0fb2e$var$_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
/*
 * -------------------------------------------------
 * TIMELINE
 * -------------------------------------------------
 */ var $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65 = /*#__PURE__*/ function(_Animation) {
    $f7cabcf4b0e0fb2e$var$_inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = $f7cabcf4b0e0fb2e$var$_isNotFalse(vars.sortChildren);
        $f7cabcf4b0e0fb2e$var$_globalTimeline && $f7cabcf4b0e0fb2e$var$_addToTimeline(vars.parent || $f7cabcf4b0e0fb2e$var$_globalTimeline, $f7cabcf4b0e0fb2e$var$_assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && $f7cabcf4b0e0fb2e$var$_scrollTrigger($f7cabcf4b0e0fb2e$var$_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        $f7cabcf4b0e0fb2e$var$_createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        $f7cabcf4b0e0fb2e$var$_createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        $f7cabcf4b0e0fb2e$var$_createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        $f7cabcf4b0e0fb2e$var$_inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new $f7cabcf4b0e0fb2e$export$2a5557542e634d07(targets, vars, $f7cabcf4b0e0fb2e$var$_parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return $f7cabcf4b0e0fb2e$var$_addToTimeline(this, $f7cabcf4b0e0fb2e$export$2a5557542e634d07.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new $f7cabcf4b0e0fb2e$export$2a5557542e634d07(targets, vars, $f7cabcf4b0e0fb2e$var$_parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        $f7cabcf4b0e0fb2e$var$_inheritDefaults(vars).immediateRender = $f7cabcf4b0e0fb2e$var$_isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        $f7cabcf4b0e0fb2e$var$_inheritDefaults(toVars).immediateRender = $f7cabcf4b0e0fb2e$var$_isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = this !== $f7cabcf4b0e0fb2e$var$_globalTimeline && totalTime > tDur - $f7cabcf4b0e0fb2e$var$_tinyNum && totalTime >= 0 ? tDur : totalTime < $f7cabcf4b0e0fb2e$var$_tinyNum ? 0 : totalTime, crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $f7cabcf4b0e0fb2e$var$_round(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = $f7cabcf4b0e0fb2e$var$_animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : dur;
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : $f7cabcf4b0e0fb2e$var$_round(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && $f7cabcf4b0e0fb2e$var$_callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    $f7cabcf4b0e0fb2e$var$_propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = $f7cabcf4b0e0fb2e$var$_findNextPauseTween(this, $f7cabcf4b0e0fb2e$var$_round(prevTime), $f7cabcf4b0e0fb2e$var$_round(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents) {
                $f7cabcf4b0e0fb2e$var$_callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -$f7cabcf4b0e0fb2e$var$_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -$f7cabcf4b0e0fb2e$var$_tinyNum : $f7cabcf4b0e0fb2e$var$_tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -$f7cabcf4b0e0fb2e$var$_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    $f7cabcf4b0e0fb2e$var$_setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && $f7cabcf4b0e0fb2e$var$_callback(this, "onUpdate", true);
            if (tTime === tDur && tDur >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && $f7cabcf4b0e0fb2e$var$_removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            $f7cabcf4b0e0fb2e$var$_callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        $f7cabcf4b0e0fb2e$var$_isNumber(position) || (position = $f7cabcf4b0e0fb2e$var$_parsePosition(this, position, child));
        if (!(child instanceof $f7cabcf4b0e0fb2e$var$Animation)) {
            if ($f7cabcf4b0e0fb2e$var$_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if ($f7cabcf4b0e0fb2e$var$_isString(child)) return this.addLabel(child, position);
            if ($f7cabcf4b0e0fb2e$var$_isFunction(child)) child = $f7cabcf4b0e0fb2e$export$2a5557542e634d07.delayedCall(0, child);
            else return this;
        }
        return this !== child ? $f7cabcf4b0e0fb2e$var$_addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -$f7cabcf4b0e0fb2e$var$_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof $f7cabcf4b0e0fb2e$export$2a5557542e634d07) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if ($f7cabcf4b0e0fb2e$var$_isString(child)) return this.removeLabel(child);
        if ($f7cabcf4b0e0fb2e$var$_isFunction(child)) return this.killTweensOf(child);
        $f7cabcf4b0e0fb2e$var$_removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return $f7cabcf4b0e0fb2e$var$_uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = $f7cabcf4b0e0fb2e$var$_round($f7cabcf4b0e0fb2e$var$_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = $f7cabcf4b0e0fb2e$var$_parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = $f7cabcf4b0e0fb2e$export$2a5557542e634d07.delayedCall(0, callback || $f7cabcf4b0e0fb2e$var$_emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return $f7cabcf4b0e0fb2e$var$_addToTimeline(this, t, $f7cabcf4b0e0fb2e$var$_parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = $f7cabcf4b0e0fb2e$var$_parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") $f7cabcf4b0e0fb2e$var$_removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)$f7cabcf4b0e0fb2e$var$_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = $f7cabcf4b0e0fb2e$var$toArray(targets), child = this._first, isGlobalTime = $f7cabcf4b0e0fb2e$var$_isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof $f7cabcf4b0e0fb2e$export$2a5557542e634d07) {
                if ($f7cabcf4b0e0fb2e$var$_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!$f7cabcf4b0e0fb2e$var$_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = $f7cabcf4b0e0fb2e$var$_parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = $f7cabcf4b0e0fb2e$export$2a5557542e634d07.to(tl, $f7cabcf4b0e0fb2e$var$_setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || $f7cabcf4b0e0fb2e$var$_tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && $f7cabcf4b0e0fb2e$var$_setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, $f7cabcf4b0e0fb2e$var$_setDefaults({
            startAt: {
                time: $f7cabcf4b0e0fb2e$var$_parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return $f7cabcf4b0e0fb2e$var$_getLabelInDirection(this, $f7cabcf4b0e0fb2e$var$_parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return $f7cabcf4b0e0fb2e$var$_getLabelInDirection(this, $f7cabcf4b0e0fb2e$var$_parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + $f7cabcf4b0e0fb2e$var$_tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return $f7cabcf4b0e0fb2e$var$_uncache(this);
    };
    _proto2.invalidate = function invalidate() {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate();
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return $f7cabcf4b0e0fb2e$var$_uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = $f7cabcf4b0e0fb2e$var$_bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    $f7cabcf4b0e0fb2e$var$_addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            $f7cabcf4b0e0fb2e$var$_setDuration(self, self === $f7cabcf4b0e0fb2e$var$_globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if ($f7cabcf4b0e0fb2e$var$_globalTimeline._ts) {
            $f7cabcf4b0e0fb2e$var$_lazySafeRender($f7cabcf4b0e0fb2e$var$_globalTimeline, $f7cabcf4b0e0fb2e$var$_parentToChildTotalTime(time, $f7cabcf4b0e0fb2e$var$_globalTimeline));
            $f7cabcf4b0e0fb2e$var$_lastRenderedFrame = $f7cabcf4b0e0fb2e$var$_ticker.frame;
        }
        if ($f7cabcf4b0e0fb2e$var$_ticker.frame >= $f7cabcf4b0e0fb2e$var$_nextGCFrame) {
            $f7cabcf4b0e0fb2e$var$_nextGCFrame += $f7cabcf4b0e0fb2e$var$_config.autoSleep || 120;
            var child = $f7cabcf4b0e0fb2e$var$_globalTimeline._first;
            if (!child || !child._ts) {
                if ($f7cabcf4b0e0fb2e$var$_config.autoSleep && $f7cabcf4b0e0fb2e$var$_ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || $f7cabcf4b0e0fb2e$var$_ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}($f7cabcf4b0e0fb2e$var$Animation);
$f7cabcf4b0e0fb2e$var$_setDefaults($f7cabcf4b0e0fb2e$export$fcaf79afd042bc65.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var $f7cabcf4b0e0fb2e$var$_addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new $f7cabcf4b0e0fb2e$var$PropTween(this._pt, target, prop, 0, 1, $f7cabcf4b0e0fb2e$var$_renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = $f7cabcf4b0e0fb2e$var$_replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match($f7cabcf4b0e0fb2e$var$_complexStringNumExp) || [];
    while(result = $f7cabcf4b0e0fb2e$var$_complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? parseFloat(endNum.substr(2)) * (endNum.charAt(0) === "-" ? -1 : 1) : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = $f7cabcf4b0e0fb2e$var$_complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if ($f7cabcf4b0e0fb2e$var$_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, $f7cabcf4b0e0fb2e$var$_addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam) {
    $f7cabcf4b0e0fb2e$var$_isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !$f7cabcf4b0e0fb2e$var$_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !$f7cabcf4b0e0fb2e$var$_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !$f7cabcf4b0e0fb2e$var$_isFunction(currentValue) ? $f7cabcf4b0e0fb2e$var$_setterPlain : funcParam ? $f7cabcf4b0e0fb2e$var$_setterFuncWithParam : $f7cabcf4b0e0fb2e$var$_setterFunc, pt;
    if ($f7cabcf4b0e0fb2e$var$_isString(end)) {
        if (~end.indexOf("random(")) end = $f7cabcf4b0e0fb2e$var$_replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = parseFloat(parsedStart) + parseFloat(end.substr(2)) * (end.charAt(0) === "-" ? -1 : 1) + ($f7cabcf4b0e0fb2e$var$getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (parsedStart !== end) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new $f7cabcf4b0e0fb2e$var$PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? $f7cabcf4b0e0fb2e$var$_renderBoolean : $f7cabcf4b0e0fb2e$var$_renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && $f7cabcf4b0e0fb2e$var$_missingPlugin(prop, end);
        return $f7cabcf4b0e0fb2e$var$_addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || $f7cabcf4b0e0fb2e$var$_config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
$f7cabcf4b0e0fb2e$var$_processVars = function _processVars(vars, index, target, targets, tween) {
    $f7cabcf4b0e0fb2e$var$_isFunction(vars) && (vars = $f7cabcf4b0e0fb2e$var$_parseFuncOrString(vars, tween, index, target, targets));
    if (!$f7cabcf4b0e0fb2e$var$_isObject(vars) || vars.style && vars.nodeType || $f7cabcf4b0e0fb2e$var$_isArray(vars) || $f7cabcf4b0e0fb2e$var$_isTypedArray(vars)) return $f7cabcf4b0e0fb2e$var$_isString(vars) ? $f7cabcf4b0e0fb2e$var$_parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = $f7cabcf4b0e0fb2e$var$_parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, $f7cabcf4b0e0fb2e$var$_checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if ($f7cabcf4b0e0fb2e$var$_plugins[property] && (plugin = new $f7cabcf4b0e0fb2e$var$_plugins[property]()).init(target, plugin.rawVars ? vars[property] : $f7cabcf4b0e0fb2e$var$_processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new $f7cabcf4b0e0fb2e$var$PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== $f7cabcf4b0e0fb2e$var$_quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, $f7cabcf4b0e0fb2e$var$_overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
$f7cabcf4b0e0fb2e$var$_initTween = function _initTween(tween, time) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, onUpdateParams = vars.onUpdateParams, callbackScope = vars.callbackScope, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.parent._targets : targets, autoOverwrite = tween._overwrite === "auto" && !$f7cabcf4b0e0fb2e$var$_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = $f7cabcf4b0e0fb2e$var$_parseEase(ease, $f7cabcf4b0e0fb2e$var$_defaults.ease);
    tween._yEase = yoyoEase ? $f7cabcf4b0e0fb2e$var$_invertEase($f7cabcf4b0e0fb2e$var$_parseEase(yoyoEase === true ? ease : yoyoEase, $f7cabcf4b0e0fb2e$var$_defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? $f7cabcf4b0e0fb2e$var$_getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = $f7cabcf4b0e0fb2e$var$_copyExcluding(vars, $f7cabcf4b0e0fb2e$var$_reservedProps);
        prevStartAt && prevStartAt.render(-1, true).kill();
        if (startAt) {
            $f7cabcf4b0e0fb2e$var$_removeFromParent(tween._startAt = $f7cabcf4b0e0fb2e$export$2a5557542e634d07.set(targets, $f7cabcf4b0e0fb2e$var$_setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: $f7cabcf4b0e0fb2e$var$_isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate,
                onUpdateParams: onUpdateParams,
                callbackScope: callbackScope,
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            time < 0 && !immediateRender && !autoRevert && tween._startAt.render(-1, true); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                time > 0 && !autoRevert && (tween._startAt = 0); //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in Timeline instances where immediateRender was false or when autoRevert is explicitly set to true.
                if (dur && time <= 0) {
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                } // if (time > 0) {
            // 	autoRevert || (tween._startAt = 0); //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in Timeline instances where immediateRender was false or when autoRevert is explicitly set to true.
            // } else if (dur && !(time < 0 && prevStartAt)) {
            // 	time && (tween._zTime = time);
            // 	return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
            // }
            } else if (autoRevert === false) tween._startAt = 0;
        } else if (runBackwards && dur) {
            //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
            if (prevStartAt) !autoRevert && (tween._startAt = 0);
            else {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = $f7cabcf4b0e0fb2e$var$_setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && $f7cabcf4b0e0fb2e$var$_isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y:gsap.utils.wrap([-100,100])})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                $f7cabcf4b0e0fb2e$var$_removeFromParent(tween._startAt = $f7cabcf4b0e0fb2e$export$2a5557542e634d07.set(targets, p));
                time < 0 && tween._startAt.render(-1, true); // rare edge case, like if a render is forced in the negative direction of a non-initted from() tween.
                if (!immediateRender) _initTween(tween._startAt, $f7cabcf4b0e0fb2e$var$_tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = 0;
        lazy = dur && $f7cabcf4b0e0fb2e$var$_isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || $f7cabcf4b0e0fb2e$var$_harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            $f7cabcf4b0e0fb2e$var$_lazyLookup[gsData.id] && $f7cabcf4b0e0fb2e$var$_lazyTweens.length && $f7cabcf4b0e0fb2e$var$_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new $f7cabcf4b0e0fb2e$var$PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if ($f7cabcf4b0e0fb2e$var$_plugins[p] && (plugin = $f7cabcf4b0e0fb2e$var$_checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = $f7cabcf4b0e0fb2e$var$_addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                $f7cabcf4b0e0fb2e$var$_overwritingTween = tween;
                $f7cabcf4b0e0fb2e$var$_globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(0)); //Also make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                $f7cabcf4b0e0fb2e$var$_overwritingTween = 0;
            }
            tween._pt && lazy && ($f7cabcf4b0e0fb2e$var$_lazyLookup[gsData.id] = 1);
        }
        hasPriority && $f7cabcf4b0e0fb2e$var$_sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
}, $f7cabcf4b0e0fb2e$var$_addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? $f7cabcf4b0e0fb2e$var$_getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = $f7cabcf4b0e0fb2e$var$_merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, $f7cabcf4b0e0fb2e$var$_parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return $f7cabcf4b0e0fb2e$var$_isFunction(value) ? value.call(tween, i, target, targets) : $f7cabcf4b0e0fb2e$var$_isString(value) && ~value.indexOf("random(") ? $f7cabcf4b0e0fb2e$var$_replaceRandom(value) : value;
}, $f7cabcf4b0e0fb2e$var$_staggerTweenProps = $f7cabcf4b0e0fb2e$var$_callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase", $f7cabcf4b0e0fb2e$var$_staggerPropsToSkip = ($f7cabcf4b0e0fb2e$var$_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger").split(",");
/*
 * --------------------------------------------------------------------------------------
 * TWEEN
 * --------------------------------------------------------------------------------------
 */ var $f7cabcf4b0e0fb2e$export$2a5557542e634d07 = /*#__PURE__*/ function(_Animation2) {
    $f7cabcf4b0e0fb2e$var$_inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : $f7cabcf4b0e0fb2e$var$_inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || $f7cabcf4b0e0fb2e$var$_globalTimeline, parsedTargets = ($f7cabcf4b0e0fb2e$var$_isArray(targets) || $f7cabcf4b0e0fb2e$var$_isTypedArray(targets) ? $f7cabcf4b0e0fb2e$var$_isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : $f7cabcf4b0e0fb2e$var$toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? $f7cabcf4b0e0fb2e$var$_harness(parsedTargets) : $f7cabcf4b0e0fb2e$var$_warn("GSAP target " + targets + " not found. https://greensock.com", !$f7cabcf4b0e0fb2e$var$_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || $f7cabcf4b0e0fb2e$var$_isFuncOrString(duration) || $f7cabcf4b0e0fb2e$var$_isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65({
                data: "nested",
                defaults: defaults || {}
            });
            tl.kill();
            tl.parent = tl._dp = $f7cabcf4b0e0fb2e$var$_assertThisInitialized(_this3);
            tl._start = 0;
            if (keyframes) {
                $f7cabcf4b0e0fb2e$var$_setDefaults(tl.vars.defaults, {
                    ease: "none"
                });
                stagger ? parsedTargets.forEach(function(t, i) {
                    return keyframes.forEach(function(frame, j) {
                        return tl.to(t, frame, j ? ">" : i * stagger);
                    });
                }) : keyframes.forEach(function(frame) {
                    return tl.to(parsedTargets, frame, ">");
                });
            } else {
                l = parsedTargets.length;
                staggerFunc = stagger ? $f7cabcf4b0e0fb2e$var$distribute(stagger) : $f7cabcf4b0e0fb2e$var$_emptyFunc;
                if ($f7cabcf4b0e0fb2e$var$_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~$f7cabcf4b0e0fb2e$var$_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = {};
                    for(p in vars)if ($f7cabcf4b0e0fb2e$var$_staggerPropsToSkip.indexOf(p) < 0) copy[p] = vars[p];
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && $f7cabcf4b0e0fb2e$var$_merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +$f7cabcf4b0e0fb2e$var$_parseFuncOrString(duration, $f7cabcf4b0e0fb2e$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+$f7cabcf4b0e0fb2e$var$_parseFuncOrString(delay, $f7cabcf4b0e0fb2e$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc(i, curTarget, parsedTargets));
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !$f7cabcf4b0e0fb2e$var$_suppressOverwrites) {
            $f7cabcf4b0e0fb2e$var$_overwritingTween = $f7cabcf4b0e0fb2e$var$_assertThisInitialized(_this3);
            $f7cabcf4b0e0fb2e$var$_globalTimeline.killTweensOf(parsedTargets);
            $f7cabcf4b0e0fb2e$var$_overwritingTween = 0;
        }
        $f7cabcf4b0e0fb2e$var$_addToTimeline(parent, $f7cabcf4b0e0fb2e$var$_assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === $f7cabcf4b0e0fb2e$var$_round(parent._time) && $f7cabcf4b0e0fb2e$var$_isNotFalse(immediateRender) && $f7cabcf4b0e0fb2e$var$_hasNoPausedAncestors($f7cabcf4b0e0fb2e$var$_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -$f7cabcf4b0e0fb2e$var$_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay)); //in case delay is negative
        }
        scrollTrigger && $f7cabcf4b0e0fb2e$var$_scrollTrigger($f7cabcf4b0e0fb2e$var$_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, tTime = totalTime > tDur - $f7cabcf4b0e0fb2e$var$_tinyNum && totalTime >= 0 ? tDur : totalTime < $f7cabcf4b0e0fb2e$var$_tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) $f7cabcf4b0e0fb2e$var$_renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== totalTime < 0) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $f7cabcf4b0e0fb2e$var$_round(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = $f7cabcf4b0e0fb2e$var$_animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted) //could be during the repeatDelay part. No need to render and fire callbacks.
                return this;
                if (iteration !== prevIteration) {
                    timeline && this._yEase && $f7cabcf4b0e0fb2e$var$_propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render($f7cabcf4b0e0fb2e$var$_round(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if ($f7cabcf4b0e0fb2e$var$_attemptInitTween(this, totalTime < 0 ? totalTime : time, force, suppressEvents)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents) {
                $f7cabcf4b0e0fb2e$var$_callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -$f7cabcf4b0e0fb2e$var$_tinyNum : timeline._dur * ratio, suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                totalTime < 0 && this._startAt && this._startAt.render(totalTime, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                $f7cabcf4b0e0fb2e$var$_callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && $f7cabcf4b0e0fb2e$var$_callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                totalTime < 0 && this._startAt && !this._onUpdate && this._startAt.render(totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && $f7cabcf4b0e0fb2e$var$_removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    $f7cabcf4b0e0fb2e$var$_callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate() {
        this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate();
        return _Animation2.prototype.invalidate.call(this);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? $f7cabcf4b0e0fb2e$var$_interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, $f7cabcf4b0e0fb2e$var$_overwritingTween && $f7cabcf4b0e0fb2e$var$_overwritingTween.vars.overwrite !== true)._first || $f7cabcf4b0e0fb2e$var$_interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && $f7cabcf4b0e0fb2e$var$_setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? $f7cabcf4b0e0fb2e$var$toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && $f7cabcf4b0e0fb2e$var$_arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return $f7cabcf4b0e0fb2e$var$_interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if ($f7cabcf4b0e0fb2e$var$_isString(vars)) {
                p = {};
                $f7cabcf4b0e0fb2e$var$_forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = $f7cabcf4b0e0fb2e$var$_addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) $f7cabcf4b0e0fb2e$var$_removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && $f7cabcf4b0e0fb2e$var$_interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return $f7cabcf4b0e0fb2e$var$_createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        });
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return $f7cabcf4b0e0fb2e$var$_createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return $f7cabcf4b0e0fb2e$var$_globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}($f7cabcf4b0e0fb2e$var$Animation);
$f7cabcf4b0e0fb2e$var$_setDefaults($f7cabcf4b0e0fb2e$export$2a5557542e634d07.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
$f7cabcf4b0e0fb2e$var$_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    $f7cabcf4b0e0fb2e$export$2a5557542e634d07[name] = function() {
        var tl = new $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65(), params = $f7cabcf4b0e0fb2e$var$_slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var $f7cabcf4b0e0fb2e$var$_setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, $f7cabcf4b0e0fb2e$var$_setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, $f7cabcf4b0e0fb2e$var$_setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, $f7cabcf4b0e0fb2e$var$_setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, $f7cabcf4b0e0fb2e$var$_getSetter = function _getSetter(target, property) {
    return $f7cabcf4b0e0fb2e$var$_isFunction(target[property]) ? $f7cabcf4b0e0fb2e$var$_setterFunc : $f7cabcf4b0e0fb2e$var$_isUndefined(target[property]) && target.setAttribute ? $f7cabcf4b0e0fb2e$var$_setterAttribute : $f7cabcf4b0e0fb2e$var$_setterPlain;
}, $f7cabcf4b0e0fb2e$var$_renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, $f7cabcf4b0e0fb2e$var$_renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, $f7cabcf4b0e0fb2e$var$_renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, $f7cabcf4b0e0fb2e$var$_renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, $f7cabcf4b0e0fb2e$var$_addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, $f7cabcf4b0e0fb2e$var$_killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) $f7cabcf4b0e0fb2e$var$_removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, $f7cabcf4b0e0fb2e$var$_setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, $f7cabcf4b0e0fb2e$var$_sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var $f7cabcf4b0e0fb2e$var$PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || $f7cabcf4b0e0fb2e$var$_renderPlain;
        this.d = data || this;
        this.set = setter || $f7cabcf4b0e0fb2e$var$_setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = $f7cabcf4b0e0fb2e$var$_setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
$f7cabcf4b0e0fb2e$var$_forEachName($f7cabcf4b0e0fb2e$var$_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return $f7cabcf4b0e0fb2e$var$_reservedProps[name] = 1;
});
$f7cabcf4b0e0fb2e$var$_globals.TweenMax = $f7cabcf4b0e0fb2e$var$_globals.TweenLite = $f7cabcf4b0e0fb2e$export$2a5557542e634d07;
$f7cabcf4b0e0fb2e$var$_globals.TimelineLite = $f7cabcf4b0e0fb2e$var$_globals.TimelineMax = $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65;
$f7cabcf4b0e0fb2e$var$_globalTimeline = new $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65({
    sortChildren: false,
    defaults: $f7cabcf4b0e0fb2e$var$_defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
$f7cabcf4b0e0fb2e$var$_config.stringFilter = $f7cabcf4b0e0fb2e$var$_colorStringFilter;
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var $f7cabcf4b0e0fb2e$var$_gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return $f7cabcf4b0e0fb2e$var$_createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return $f7cabcf4b0e0fb2e$var$_globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        $f7cabcf4b0e0fb2e$var$_isString(target) && (target = $f7cabcf4b0e0fb2e$var$toArray(target)[0]); //in case selector text or an array is passed in
        var getter = $f7cabcf4b0e0fb2e$var$_getCache(target || {}).get, format = unit ? $f7cabcf4b0e0fb2e$var$_passThrough : $f7cabcf4b0e0fb2e$var$_numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format(($f7cabcf4b0e0fb2e$var$_plugins[property] && $f7cabcf4b0e0fb2e$var$_plugins[property].get || getter)(target, property, unit, uncache));
        } : format(($f7cabcf4b0e0fb2e$var$_plugins[property] && $f7cabcf4b0e0fb2e$var$_plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = $f7cabcf4b0e0fb2e$var$toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return $f7cabcf4b0e0fb2e$var$gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = $f7cabcf4b0e0fb2e$var$_plugins[property], cache = $f7cabcf4b0e0fb2e$var$_getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            $f7cabcf4b0e0fb2e$var$_quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, $f7cabcf4b0e0fb2e$var$_quickTween, 0, [
                target
            ]);
            p.render(1, p);
            $f7cabcf4b0e0fb2e$var$_quickTween._pt && $f7cabcf4b0e0fb2e$var$_renderPropTweens(1, $f7cabcf4b0e0fb2e$var$_quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    isTweening: function isTweening(targets) {
        return $f7cabcf4b0e0fb2e$var$_globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = $f7cabcf4b0e0fb2e$var$_parseEase(value.ease, $f7cabcf4b0e0fb2e$var$_defaults.ease));
        return $f7cabcf4b0e0fb2e$var$_mergeDeep($f7cabcf4b0e0fb2e$var$_defaults, value || {});
    },
    config: function config(value) {
        return $f7cabcf4b0e0fb2e$var$_mergeDeep($f7cabcf4b0e0fb2e$var$_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !$f7cabcf4b0e0fb2e$var$_plugins[pluginName] && !$f7cabcf4b0e0fb2e$var$_globals[pluginName] && $f7cabcf4b0e0fb2e$var$_warn(name + " effect requires " + pluginName + " plugin.");
        });
        $f7cabcf4b0e0fb2e$var$_effects[name] = function(targets, vars, tl) {
            return effect($f7cabcf4b0e0fb2e$var$toArray(targets), $f7cabcf4b0e0fb2e$var$_setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65.prototype[name] = function(targets, vars, position) {
            return this.add($f7cabcf4b0e0fb2e$var$_effects[name](targets, $f7cabcf4b0e0fb2e$var$_isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        $f7cabcf4b0e0fb2e$var$_easeMap[name] = $f7cabcf4b0e0fb2e$var$_parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? $f7cabcf4b0e0fb2e$var$_parseEase(ease, defaultEase) : $f7cabcf4b0e0fb2e$var$_easeMap;
    },
    getById: function getById(id) {
        return $f7cabcf4b0e0fb2e$var$_globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65(vars), child, next;
        tl.smoothChildTiming = $f7cabcf4b0e0fb2e$var$_isNotFalse(vars.smoothChildTiming);
        $f7cabcf4b0e0fb2e$var$_globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = $f7cabcf4b0e0fb2e$var$_globalTimeline._time;
        child = $f7cabcf4b0e0fb2e$var$_globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof $f7cabcf4b0e0fb2e$export$2a5557542e634d07 && child.vars.onComplete === child._targets[0])) $f7cabcf4b0e0fb2e$var$_addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        $f7cabcf4b0e0fb2e$var$_addToTimeline($f7cabcf4b0e0fb2e$var$_globalTimeline, tl, 0);
        return tl;
    },
    utils: {
        wrap: $f7cabcf4b0e0fb2e$var$wrap,
        wrapYoyo: $f7cabcf4b0e0fb2e$var$wrapYoyo,
        distribute: $f7cabcf4b0e0fb2e$var$distribute,
        random: $f7cabcf4b0e0fb2e$var$random,
        snap: $f7cabcf4b0e0fb2e$var$snap,
        normalize: $f7cabcf4b0e0fb2e$var$normalize,
        getUnit: $f7cabcf4b0e0fb2e$var$getUnit,
        clamp: $f7cabcf4b0e0fb2e$var$clamp,
        splitColor: $f7cabcf4b0e0fb2e$var$splitColor,
        toArray: $f7cabcf4b0e0fb2e$var$toArray,
        selector: $f7cabcf4b0e0fb2e$var$selector,
        mapRange: $f7cabcf4b0e0fb2e$var$mapRange,
        pipe: $f7cabcf4b0e0fb2e$var$pipe,
        unitize: $f7cabcf4b0e0fb2e$var$unitize,
        interpolate: $f7cabcf4b0e0fb2e$var$interpolate,
        shuffle: $f7cabcf4b0e0fb2e$var$shuffle
    },
    install: $f7cabcf4b0e0fb2e$var$_install,
    effects: $f7cabcf4b0e0fb2e$var$_effects,
    ticker: $f7cabcf4b0e0fb2e$var$_ticker,
    updateRoot: $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65.updateRoot,
    plugins: $f7cabcf4b0e0fb2e$var$_plugins,
    globalTimeline: $f7cabcf4b0e0fb2e$var$_globalTimeline,
    core: {
        PropTween: $f7cabcf4b0e0fb2e$var$PropTween,
        globals: $f7cabcf4b0e0fb2e$var$_addGlobal,
        Tween: $f7cabcf4b0e0fb2e$export$2a5557542e634d07,
        Timeline: $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65,
        Animation: $f7cabcf4b0e0fb2e$var$Animation,
        getCache: $f7cabcf4b0e0fb2e$var$_getCache,
        _removeLinkedListItem: $f7cabcf4b0e0fb2e$var$_removeLinkedListItem,
        suppressOverwrites: function suppressOverwrites(value) {
            return $f7cabcf4b0e0fb2e$var$_suppressOverwrites = value;
        }
    }
};
$f7cabcf4b0e0fb2e$var$_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return $f7cabcf4b0e0fb2e$var$_gsap[name] = $f7cabcf4b0e0fb2e$export$2a5557542e634d07[name];
});
$f7cabcf4b0e0fb2e$var$_ticker.add($f7cabcf4b0e0fb2e$export$fcaf79afd042bc65.updateRoot);
$f7cabcf4b0e0fb2e$var$_quickTween = $f7cabcf4b0e0fb2e$var$_gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var $f7cabcf4b0e0fb2e$var$_getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, $f7cabcf4b0e0fb2e$var$_addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = $f7cabcf4b0e0fb2e$var$_getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, $f7cabcf4b0e0fb2e$var$_buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if ($f7cabcf4b0e0fb2e$var$_isString(vars)) {
                    temp = {};
                    $f7cabcf4b0e0fb2e$var$_forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                $f7cabcf4b0e0fb2e$var$_addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var $f7cabcf4b0e0fb2e$var$gsap = $f7cabcf4b0e0fb2e$var$_gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt;
        for(p in vars){
            pt = this.add(target, "setAttribute", (target.getAttribute(p) || 0) + "", vars[p], index, targets, 0, 0, p);
            pt && (pt.op = p);
            this._props.push(p);
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i]);
    }
}, $f7cabcf4b0e0fb2e$var$_buildModifierPlugin("roundProps", $f7cabcf4b0e0fb2e$var$_roundModifier), $f7cabcf4b0e0fb2e$var$_buildModifierPlugin("modifiers"), $f7cabcf4b0e0fb2e$var$_buildModifierPlugin("snap", $f7cabcf4b0e0fb2e$var$snap)) || $f7cabcf4b0e0fb2e$var$_gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
$f7cabcf4b0e0fb2e$export$2a5557542e634d07.version = $f7cabcf4b0e0fb2e$export$fcaf79afd042bc65.version = $f7cabcf4b0e0fb2e$var$gsap.version = "3.7.1";
$f7cabcf4b0e0fb2e$var$_coreReady = 1;
$f7cabcf4b0e0fb2e$var$_windowExists() && $f7cabcf4b0e0fb2e$var$_wake();
var $f7cabcf4b0e0fb2e$export$2fae1e8613537d5f = $f7cabcf4b0e0fb2e$var$_easeMap.Power0, $f7cabcf4b0e0fb2e$export$5d84ab4efbecec39 = $f7cabcf4b0e0fb2e$var$_easeMap.Power1, $f7cabcf4b0e0fb2e$export$d8c694b7490ad65d = $f7cabcf4b0e0fb2e$var$_easeMap.Power2, $f7cabcf4b0e0fb2e$export$acebdf2b184a0b6f = $f7cabcf4b0e0fb2e$var$_easeMap.Power3, $f7cabcf4b0e0fb2e$export$42e40a141003d2f0 = $f7cabcf4b0e0fb2e$var$_easeMap.Power4, $f7cabcf4b0e0fb2e$export$cff00ccf6e2392de = $f7cabcf4b0e0fb2e$var$_easeMap.Linear, $f7cabcf4b0e0fb2e$export$7005c9eb6671414d = $f7cabcf4b0e0fb2e$var$_easeMap.Quad, $f7cabcf4b0e0fb2e$export$755261d5a1567778 = $f7cabcf4b0e0fb2e$var$_easeMap.Cubic, $f7cabcf4b0e0fb2e$export$daf531446cad3d2a = $f7cabcf4b0e0fb2e$var$_easeMap.Quart, $f7cabcf4b0e0fb2e$export$4c407d38ce8ad8cc = $f7cabcf4b0e0fb2e$var$_easeMap.Quint, $f7cabcf4b0e0fb2e$export$f301627d437cff88 = $f7cabcf4b0e0fb2e$var$_easeMap.Strong, $f7cabcf4b0e0fb2e$export$56ebabebb04a9ca9 = $f7cabcf4b0e0fb2e$var$_easeMap.Elastic, $f7cabcf4b0e0fb2e$export$25e48ac541203d4a = $f7cabcf4b0e0fb2e$var$_easeMap.Back, $f7cabcf4b0e0fb2e$export$f7a11c7543d81853 = $f7cabcf4b0e0fb2e$var$_easeMap.SteppedEase, $f7cabcf4b0e0fb2e$export$d20e79fdc3899e95 = $f7cabcf4b0e0fb2e$var$_easeMap.Bounce, $f7cabcf4b0e0fb2e$export$bed2d20ad96b784c = $f7cabcf4b0e0fb2e$var$_easeMap.Sine, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a = $f7cabcf4b0e0fb2e$var$_easeMap.Expo, $f7cabcf4b0e0fb2e$export$ce49a57dd865b86c = $f7cabcf4b0e0fb2e$var$_easeMap.Circ;
/*!
 * CSSPlugin 3.7.1
 * https://greensock.com
 *
 * Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ var $f7cabcf4b0e0fb2e$var$_win$1, $f7cabcf4b0e0fb2e$var$_doc$1, $f7cabcf4b0e0fb2e$var$_docElement, $f7cabcf4b0e0fb2e$var$_pluginInitted, $f7cabcf4b0e0fb2e$var$_tempDiv, $f7cabcf4b0e0fb2e$var$_recentSetterPlugin, $f7cabcf4b0e0fb2e$var$_windowExists$1 = function _windowExists() {
    return typeof window !== "undefined";
}, $f7cabcf4b0e0fb2e$var$_transformProps = {}, $f7cabcf4b0e0fb2e$var$_RAD2DEG = 180 / Math.PI, $f7cabcf4b0e0fb2e$var$_DEG2RAD = Math.PI / 180, $f7cabcf4b0e0fb2e$var$_atan2 = Math.atan2, $f7cabcf4b0e0fb2e$var$_bigNum$1 = 1e8, $f7cabcf4b0e0fb2e$var$_capsExp = /([A-Z])/g, $f7cabcf4b0e0fb2e$var$_horizontalExp = /(?:left|right|width|margin|padding|x)/i, $f7cabcf4b0e0fb2e$var$_complexExp = /[\s,\(]\S/, $f7cabcf4b0e0fb2e$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $f7cabcf4b0e0fb2e$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $f7cabcf4b0e0fb2e$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $f7cabcf4b0e0fb2e$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$f7cabcf4b0e0fb2e$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $f7cabcf4b0e0fb2e$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $f7cabcf4b0e0fb2e$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $f7cabcf4b0e0fb2e$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $f7cabcf4b0e0fb2e$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $f7cabcf4b0e0fb2e$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $f7cabcf4b0e0fb2e$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $f7cabcf4b0e0fb2e$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $f7cabcf4b0e0fb2e$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $f7cabcf4b0e0fb2e$var$_transformProp = "transform", $f7cabcf4b0e0fb2e$var$_transformOriginProp = $f7cabcf4b0e0fb2e$var$_transformProp + "Origin", $f7cabcf4b0e0fb2e$var$_supports3D, $f7cabcf4b0e0fb2e$var$_createElement = function _createElement(type, ns) {
    var e = $f7cabcf4b0e0fb2e$var$_doc$1.createElementNS ? $f7cabcf4b0e0fb2e$var$_doc$1.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $f7cabcf4b0e0fb2e$var$_doc$1.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $f7cabcf4b0e0fb2e$var$_doc$1.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $f7cabcf4b0e0fb2e$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($f7cabcf4b0e0fb2e$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $f7cabcf4b0e0fb2e$var$_checkPropPrefix(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $f7cabcf4b0e0fb2e$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $f7cabcf4b0e0fb2e$var$_checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $f7cabcf4b0e0fb2e$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($f7cabcf4b0e0fb2e$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $f7cabcf4b0e0fb2e$var$_prefixes[i] : "") + property;
}, $f7cabcf4b0e0fb2e$var$_initCore = function _initCore() {
    if ($f7cabcf4b0e0fb2e$var$_windowExists$1() && window.document) {
        $f7cabcf4b0e0fb2e$var$_win$1 = window;
        $f7cabcf4b0e0fb2e$var$_doc$1 = $f7cabcf4b0e0fb2e$var$_win$1.document;
        $f7cabcf4b0e0fb2e$var$_docElement = $f7cabcf4b0e0fb2e$var$_doc$1.documentElement;
        $f7cabcf4b0e0fb2e$var$_tempDiv = $f7cabcf4b0e0fb2e$var$_createElement("div") || {
            style: {}
        };
        $f7cabcf4b0e0fb2e$var$_createElement("div");
        $f7cabcf4b0e0fb2e$var$_transformProp = $f7cabcf4b0e0fb2e$var$_checkPropPrefix($f7cabcf4b0e0fb2e$var$_transformProp);
        $f7cabcf4b0e0fb2e$var$_transformOriginProp = $f7cabcf4b0e0fb2e$var$_transformProp + "Origin";
        $f7cabcf4b0e0fb2e$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $f7cabcf4b0e0fb2e$var$_supports3D = !!$f7cabcf4b0e0fb2e$var$_checkPropPrefix("perspective");
        $f7cabcf4b0e0fb2e$var$_pluginInitted = 1;
    }
}, $f7cabcf4b0e0fb2e$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $f7cabcf4b0e0fb2e$var$_createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $f7cabcf4b0e0fb2e$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $f7cabcf4b0e0fb2e$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $f7cabcf4b0e0fb2e$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $f7cabcf4b0e0fb2e$var$_getBBox = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $f7cabcf4b0e0fb2e$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $f7cabcf4b0e0fb2e$var$_getBBoxHack || (bounds = $f7cabcf4b0e0fb2e$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$f7cabcf4b0e0fb2e$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$f7cabcf4b0e0fb2e$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $f7cabcf4b0e0fb2e$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $f7cabcf4b0e0fb2e$var$_getBBox(e));
}, //reports if the element is an SVG on which getBBox() actually works
$f7cabcf4b0e0fb2e$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style;
        if (property in $f7cabcf4b0e0fb2e$var$_transformProps && property !== $f7cabcf4b0e0fb2e$var$_transformOriginProp) property = $f7cabcf4b0e0fb2e$var$_transformProp;
        if (style.removeProperty) {
            if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(property.replace($f7cabcf4b0e0fb2e$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $f7cabcf4b0e0fb2e$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new $f7cabcf4b0e0fb2e$var$PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $f7cabcf4b0e0fb2e$var$_renderNonTweeningValueOnlyAtEnd : $f7cabcf4b0e0fb2e$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $f7cabcf4b0e0fb2e$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$f7cabcf4b0e0fb2e$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $f7cabcf4b0e0fb2e$var$_tempDiv.style, horizontal = $f7cabcf4b0e0fb2e$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $f7cabcf4b0e0fb2e$var$_nonConvertibleUnits[unit] || $f7cabcf4b0e0fb2e$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $f7cabcf4b0e0fb2e$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($f7cabcf4b0e0fb2e$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return $f7cabcf4b0e0fb2e$var$_round(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $f7cabcf4b0e0fb2e$var$_doc$1 || !parent.appendChild) parent = $f7cabcf4b0e0fb2e$var$_doc$1.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === $f7cabcf4b0e0fb2e$var$_ticker.time) return $f7cabcf4b0e0fb2e$var$_round(curValue / cache.width * amount);
    else {
        (toPercent || curUnit === "%") && (style.position = $f7cabcf4b0e0fb2e$var$_getComputedProperty(target, "position"));
        parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
        parent.appendChild($f7cabcf4b0e0fb2e$var$_tempDiv);
        px = $f7cabcf4b0e0fb2e$var$_tempDiv[measureProperty];
        parent.removeChild($f7cabcf4b0e0fb2e$var$_tempDiv);
        style.position = "absolute";
        if (horizontal && toPercent) {
            cache = $f7cabcf4b0e0fb2e$var$_getCache(parent);
            cache.time = $f7cabcf4b0e0fb2e$var$_ticker.time;
            cache.width = parent[measureProperty];
        }
    }
    return $f7cabcf4b0e0fb2e$var$_round(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $f7cabcf4b0e0fb2e$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $f7cabcf4b0e0fb2e$var$_pluginInitted || $f7cabcf4b0e0fb2e$var$_initCore();
    if (property in $f7cabcf4b0e0fb2e$var$_propertyAliases && property !== "transform") {
        property = $f7cabcf4b0e0fb2e$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($f7cabcf4b0e0fb2e$var$_transformProps[property] && property !== "transform") {
        value = $f7cabcf4b0e0fb2e$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $f7cabcf4b0e0fb2e$var$_firstTwoOnly($f7cabcf4b0e0fb2e$var$_getComputedProperty(target, $f7cabcf4b0e0fb2e$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $f7cabcf4b0e0fb2e$var$_specialProps[property] && $f7cabcf4b0e0fb2e$var$_specialProps[property](target, property, unit) || $f7cabcf4b0e0fb2e$var$_getComputedProperty(target, property) || $f7cabcf4b0e0fb2e$var$_getProperty(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $f7cabcf4b0e0fb2e$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $f7cabcf4b0e0fb2e$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    //note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $f7cabcf4b0e0fb2e$var$_checkPropPrefix(prop, target, 1), s = p && $f7cabcf4b0e0fb2e$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $f7cabcf4b0e0fb2e$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new $f7cabcf4b0e0fb2e$var$PropTween(this._pt, target.style, prop, 0, 1, $f7cabcf4b0e0fb2e$var$_renderComplexString), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, relative, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (end === "auto") {
        target.style[prop] = end;
        end = $f7cabcf4b0e0fb2e$var$_getComputedProperty(target, prop) || end;
        target.style[prop] = start;
    }
    a = [
        start,
        end
    ];
    $f7cabcf4b0e0fb2e$var$_colorStringFilter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match($f7cabcf4b0e0fb2e$var$_numWithUnitExp) || [];
    endValues = end.match($f7cabcf4b0e0fb2e$var$_numWithUnitExp) || [];
    if (endValues.length) {
        while(result = $f7cabcf4b0e0fb2e$var$_numWithUnitExp.exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                relative = endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
                if (relative) endValue = endValue.substr(2);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = $f7cabcf4b0e0fb2e$var$_numWithUnitExp.lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || $f7cabcf4b0e0fb2e$var$_config.units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $f7cabcf4b0e0fb2e$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: relative ? relative * endNum : endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $f7cabcf4b0e0fb2e$var$_renderNonTweeningValueOnlyAtEnd : $f7cabcf4b0e0fb2e$var$_renderNonTweeningValue;
    $f7cabcf4b0e0fb2e$var$_relExp.test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $f7cabcf4b0e0fb2e$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $f7cabcf4b0e0fb2e$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $f7cabcf4b0e0fb2e$var$_keywordToPercent[x] || x;
    split[1] = $f7cabcf4b0e0fb2e$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $f7cabcf4b0e0fb2e$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($f7cabcf4b0e0fb2e$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $f7cabcf4b0e0fb2e$var$_transformOriginProp : $f7cabcf4b0e0fb2e$var$_transformProp;
                }
                $f7cabcf4b0e0fb2e$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $f7cabcf4b0e0fb2e$var$_removeProperty(target, $f7cabcf4b0e0fb2e$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $f7cabcf4b0e0fb2e$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$f7cabcf4b0e0fb2e$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new $f7cabcf4b0e0fb2e$var$PropTween(plugin._pt, target, property, 0, 0, $f7cabcf4b0e0fb2e$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $f7cabcf4b0e0fb2e$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $f7cabcf4b0e0fb2e$var$_rotationalProperties = {}, $f7cabcf4b0e0fb2e$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $f7cabcf4b0e0fb2e$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $f7cabcf4b0e0fb2e$var$_getComputedProperty(target, $f7cabcf4b0e0fb2e$var$_transformProp);
    return $f7cabcf4b0e0fb2e$var$_isNullTransform(matrixString) ? $f7cabcf4b0e0fb2e$var$_identity2DMatrix : matrixString.substr(7).match($f7cabcf4b0e0fb2e$var$_numExp).map($f7cabcf4b0e0fb2e$var$_round);
}, $f7cabcf4b0e0fb2e$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || $f7cabcf4b0e0fb2e$var$_getCache(target), style = target.style, matrix = $f7cabcf4b0e0fb2e$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $f7cabcf4b0e0fb2e$var$_identity2DMatrix : matrix;
    } else if (matrix === $f7cabcf4b0e0fb2e$var$_identity2DMatrix && !target.offsetParent && target !== $f7cabcf4b0e0fb2e$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextSibling;
            $f7cabcf4b0e0fb2e$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $f7cabcf4b0e0fb2e$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $f7cabcf4b0e0fb2e$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $f7cabcf4b0e0fb2e$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $f7cabcf4b0e0fb2e$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $f7cabcf4b0e0fb2e$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $f7cabcf4b0e0fb2e$var$_getBBox(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== $f7cabcf4b0e0fb2e$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y;
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$f7cabcf4b0e0fb2e$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $f7cabcf4b0e0fb2e$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $f7cabcf4b0e0fb2e$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $f7cabcf4b0e0fb2e$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $f7cabcf4b0e0fb2e$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $f7cabcf4b0e0fb2e$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new $f7cabcf4b0e0fb2e$var$GSCache(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", origin = $f7cabcf4b0e0fb2e$var$_getComputedProperty(target, $f7cabcf4b0e0fb2e$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $f7cabcf4b0e0fb2e$var$_isSVG(target));
    matrix = $f7cabcf4b0e0fb2e$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        t1 = (!cache.uncache || origin === "0px 0px") && !uncache && target.getAttribute("data-svg-origin"); // if origin is 0,0 and cache.uncache is true, let the recorded data-svg-origin stay. Otherwise, whenever we set cache.uncache to true, we'd need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $f7cabcf4b0e0fb2e$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $f7cabcf4b0e0fb2e$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $f7cabcf4b0e0fb2e$var$_atan2(b, a) * $f7cabcf4b0e0fb2e$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $f7cabcf4b0e0fb2e$var$_atan2(c, d) * $f7cabcf4b0e0fb2e$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $f7cabcf4b0e0fb2e$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $f7cabcf4b0e0fb2e$var$_atan2(a32, a33);
            rotationX = angle * $f7cabcf4b0e0fb2e$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $f7cabcf4b0e0fb2e$var$_atan2(-c, a33);
            rotationY = angle * $f7cabcf4b0e0fb2e$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $f7cabcf4b0e0fb2e$var$_atan2(b, a);
            rotation = angle * $f7cabcf4b0e0fb2e$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = $f7cabcf4b0e0fb2e$var$_round(Math.sqrt(a * a + b * b + c * c));
            scaleY = $f7cabcf4b0e0fb2e$var$_round(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $f7cabcf4b0e0fb2e$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $f7cabcf4b0e0fb2e$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$f7cabcf4b0e0fb2e$var$_isNullTransform($f7cabcf4b0e0fb2e$var$_getComputedProperty(target, $f7cabcf4b0e0fb2e$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    cache.x = x - ((cache.xPercent = x && (cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = $f7cabcf4b0e0fb2e$var$_round(scaleX);
    cache.scaleY = $f7cabcf4b0e0fb2e$var$_round(scaleY);
    cache.rotation = $f7cabcf4b0e0fb2e$var$_round(rotation) + deg;
    cache.rotationX = $f7cabcf4b0e0fb2e$var$_round(rotationX) + deg;
    cache.rotationY = $f7cabcf4b0e0fb2e$var$_round(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) style[$f7cabcf4b0e0fb2e$var$_transformOriginProp] = $f7cabcf4b0e0fb2e$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = $f7cabcf4b0e0fb2e$var$_config.force3D;
    cache.renderTransform = cache.svg ? $f7cabcf4b0e0fb2e$var$_renderSVGTransforms : $f7cabcf4b0e0fb2e$var$_supports3D ? $f7cabcf4b0e0fb2e$var$_renderCSSTransforms : $f7cabcf4b0e0fb2e$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $f7cabcf4b0e0fb2e$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$f7cabcf4b0e0fb2e$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = $f7cabcf4b0e0fb2e$var$getUnit(start);
    return $f7cabcf4b0e0fb2e$var$_round(parseFloat(start) + parseFloat($f7cabcf4b0e0fb2e$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $f7cabcf4b0e0fb2e$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $f7cabcf4b0e0fb2e$var$_renderCSSTransforms(ratio, cache);
}, $f7cabcf4b0e0fb2e$var$_zeroDeg = "0deg", $f7cabcf4b0e0fb2e$var$_zeroPx = "0px", $f7cabcf4b0e0fb2e$var$_endParenthesis = ") ", $f7cabcf4b0e0fb2e$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $f7cabcf4b0e0fb2e$var$_zeroDeg || rotationY !== $f7cabcf4b0e0fb2e$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $f7cabcf4b0e0fb2e$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $f7cabcf4b0e0fb2e$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $f7cabcf4b0e0fb2e$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $f7cabcf4b0e0fb2e$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $f7cabcf4b0e0fb2e$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $f7cabcf4b0e0fb2e$var$_zeroPx) transforms += "perspective(" + transformPerspective + $f7cabcf4b0e0fb2e$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $f7cabcf4b0e0fb2e$var$_zeroPx || y !== $f7cabcf4b0e0fb2e$var$_zeroPx || z !== $f7cabcf4b0e0fb2e$var$_zeroPx) transforms += z !== $f7cabcf4b0e0fb2e$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $f7cabcf4b0e0fb2e$var$_endParenthesis;
    if (rotation !== $f7cabcf4b0e0fb2e$var$_zeroDeg) transforms += "rotate(" + rotation + $f7cabcf4b0e0fb2e$var$_endParenthesis;
    if (rotationY !== $f7cabcf4b0e0fb2e$var$_zeroDeg) transforms += "rotateY(" + rotationY + $f7cabcf4b0e0fb2e$var$_endParenthesis;
    if (rotationX !== $f7cabcf4b0e0fb2e$var$_zeroDeg) transforms += "rotateX(" + rotationX + $f7cabcf4b0e0fb2e$var$_endParenthesis;
    if (skewX !== $f7cabcf4b0e0fb2e$var$_zeroDeg || skewY !== $f7cabcf4b0e0fb2e$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $f7cabcf4b0e0fb2e$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $f7cabcf4b0e0fb2e$var$_endParenthesis;
    target.style[$f7cabcf4b0e0fb2e$var$_transformProp] = transforms || "translate(0, 0)";
}, $f7cabcf4b0e0fb2e$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $f7cabcf4b0e0fb2e$var$_DEG2RAD;
        skewX *= $f7cabcf4b0e0fb2e$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $f7cabcf4b0e0fb2e$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = $f7cabcf4b0e0fb2e$var$_round(a11);
        a21 = $f7cabcf4b0e0fb2e$var$_round(a21);
        a12 = $f7cabcf4b0e0fb2e$var$_round(a12);
        a22 = $f7cabcf4b0e0fb2e$var$_round(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $f7cabcf4b0e0fb2e$var$_convertToUnit(target, "x", x, "px");
        ty = $f7cabcf4b0e0fb2e$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = $f7cabcf4b0e0fb2e$var$_round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = $f7cabcf4b0e0fb2e$var$_round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = $f7cabcf4b0e0fb2e$var$_round(tx + xPercent / 100 * temp.width);
        ty = $f7cabcf4b0e0fb2e$var$_round(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$f7cabcf4b0e0fb2e$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the  transform attribute changes!)
}, $f7cabcf4b0e0fb2e$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue, relative) {
    var cap = 360, isString = $f7cabcf4b0e0fb2e$var$_isString(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $f7cabcf4b0e0fb2e$var$_RAD2DEG : 1), change = relative ? endNum * relative : endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $f7cabcf4b0e0fb2e$var$_bigNum$1) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $f7cabcf4b0e0fb2e$var$_bigNum$1) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new $f7cabcf4b0e0fb2e$var$PropTween(plugin._pt, target, property, startNum, change, $f7cabcf4b0e0fb2e$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $f7cabcf4b0e0fb2e$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $f7cabcf4b0e0fb2e$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $f7cabcf4b0e0fb2e$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$f7cabcf4b0e0fb2e$var$_transformProp] = transforms;
        endCache = $f7cabcf4b0e0fb2e$var$_parseTransform(target, 1);
        $f7cabcf4b0e0fb2e$var$_removeProperty(target, $f7cabcf4b0e0fb2e$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$f7cabcf4b0e0fb2e$var$_transformProp];
        style[$f7cabcf4b0e0fb2e$var$_transformProp] = transforms;
        endCache = $f7cabcf4b0e0fb2e$var$_parseTransform(target, 1);
        style[$f7cabcf4b0e0fb2e$var$_transformProp] = startValue;
    }
    for(p in $f7cabcf4b0e0fb2e$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = $f7cabcf4b0e0fb2e$var$getUnit(startValue);
            endUnit = $f7cabcf4b0e0fb2e$var$getUnit(endValue);
            startNum = startUnit !== endUnit ? $f7cabcf4b0e0fb2e$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new $f7cabcf4b0e0fb2e$var$PropTween(plugin._pt, endCache, p, startNum, endNum - startNum, $f7cabcf4b0e0fb2e$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $f7cabcf4b0e0fb2e$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
$f7cabcf4b0e0fb2e$var$_forEachName("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $f7cabcf4b0e0fb2e$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $f7cabcf4b0e0fb2e$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $f7cabcf4b0e0fb2e$export$855822f522f18eef = {
    name: "css",
    register: $f7cabcf4b0e0fb2e$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority;
        $f7cabcf4b0e0fb2e$var$_pluginInitted || $f7cabcf4b0e0fb2e$var$_initCore();
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ($f7cabcf4b0e0fb2e$var$_plugins[p] && $f7cabcf4b0e0fb2e$var$_checkPlugin(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $f7cabcf4b0e0fb2e$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = $f7cabcf4b0e0fb2e$var$_replaceRandom(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                $f7cabcf4b0e0fb2e$var$_colorExp.lastIndex = 0;
                if (!$f7cabcf4b0e0fb2e$var$_colorExp.test(startValue)) {
                    // colors don't have units
                    startUnit = $f7cabcf4b0e0fb2e$var$getUnit(startValue);
                    endUnit = $f7cabcf4b0e0fb2e$var$getUnit(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $f7cabcf4b0e0fb2e$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    p in $f7cabcf4b0e0fb2e$var$_config.units && !$f7cabcf4b0e0fb2e$var$getUnit(startValue) && (startValue += $f7cabcf4b0e0fb2e$var$_config.units[p]); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $f7cabcf4b0e0fb2e$var$_get(target, p)); // can't work with relative values
                } else startValue = $f7cabcf4b0e0fb2e$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $f7cabcf4b0e0fb2e$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $f7cabcf4b0e0fb2e$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        $f7cabcf4b0e0fb2e$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $f7cabcf4b0e0fb2e$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $f7cabcf4b0e0fb2e$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $f7cabcf4b0e0fb2e$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new $f7cabcf4b0e0fb2e$var$PropTween(this._pt, style, $f7cabcf4b0e0fb2e$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new $f7cabcf4b0e0fb2e$var$PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? relative * endNum : endNum - cache.scaleY) || 0);
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        endValue = $f7cabcf4b0e0fb2e$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $f7cabcf4b0e0fb2e$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $f7cabcf4b0e0fb2e$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $f7cabcf4b0e0fb2e$var$_addNonTweeningPT(this, style, p, $f7cabcf4b0e0fb2e$var$_firstTwoOnly(startValue), $f7cabcf4b0e0fb2e$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $f7cabcf4b0e0fb2e$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $f7cabcf4b0e0fb2e$var$_rotationalProperties) {
                        $f7cabcf4b0e0fb2e$var$_addRotationalPropTween(this, cache, p, startNum, endValue, relative);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $f7cabcf4b0e0fb2e$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $f7cabcf4b0e0fb2e$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $f7cabcf4b0e0fb2e$var$_checkPropPrefix(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$f7cabcf4b0e0fb2e$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = $f7cabcf4b0e0fb2e$var$getUnit(endValue) || (p in $f7cabcf4b0e0fb2e$var$_config.units ? $f7cabcf4b0e0fb2e$var$_config.units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $f7cabcf4b0e0fb2e$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new $f7cabcf4b0e0fb2e$var$PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, relative ? relative * endNum : endNum - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $f7cabcf4b0e0fb2e$var$_renderRoundedCSSProp : $f7cabcf4b0e0fb2e$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit) {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $f7cabcf4b0e0fb2e$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], endValue, index, targets);
                    else {
                        $f7cabcf4b0e0fb2e$var$_missingPlugin(p, endValue);
                        continue;
                    }
                } else $f7cabcf4b0e0fb2e$var$_tweenComplexCSSString.call(this, target, p, startValue, endValue);
                props.push(p);
            }
        }
        hasPriority && $f7cabcf4b0e0fb2e$var$_sortPropTweensByPriority(this);
    },
    get: $f7cabcf4b0e0fb2e$var$_get,
    aliases: $f7cabcf4b0e0fb2e$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $f7cabcf4b0e0fb2e$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $f7cabcf4b0e0fb2e$var$_transformProps && property !== $f7cabcf4b0e0fb2e$var$_transformOriginProp && (target._gsap.x || $f7cabcf4b0e0fb2e$var$_get(target, "x")) ? plugin && $f7cabcf4b0e0fb2e$var$_recentSetterPlugin === plugin ? property === "scale" ? $f7cabcf4b0e0fb2e$var$_setterScale : $f7cabcf4b0e0fb2e$var$_setterTransform : ($f7cabcf4b0e0fb2e$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $f7cabcf4b0e0fb2e$var$_setterScaleWithRender : $f7cabcf4b0e0fb2e$var$_setterTransformWithRender) : target.style && !$f7cabcf4b0e0fb2e$var$_isUndefined(target.style[property]) ? $f7cabcf4b0e0fb2e$var$_setterCSSStyle : ~property.indexOf("-") ? $f7cabcf4b0e0fb2e$var$_setterCSSProp : $f7cabcf4b0e0fb2e$var$_getSetter(target, property);
    },
    core: {
        _removeProperty: $f7cabcf4b0e0fb2e$var$_removeProperty,
        _getMatrix: $f7cabcf4b0e0fb2e$var$_getMatrix
    }
};
$f7cabcf4b0e0fb2e$var$gsap.utils.checkPrefix = $f7cabcf4b0e0fb2e$var$_checkPropPrefix;
(function(positionAndScale, rotation, others, aliases) {
    var all = $f7cabcf4b0e0fb2e$var$_forEachName(positionAndScale + "," + rotation + "," + others, function(name) {
        $f7cabcf4b0e0fb2e$var$_transformProps[name] = 1;
    });
    $f7cabcf4b0e0fb2e$var$_forEachName(rotation, function(name) {
        $f7cabcf4b0e0fb2e$var$_config.units[name] = "deg";
        $f7cabcf4b0e0fb2e$var$_rotationalProperties[name] = 1;
    });
    $f7cabcf4b0e0fb2e$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    $f7cabcf4b0e0fb2e$var$_forEachName(aliases, function(name) {
        var split = name.split(":");
        $f7cabcf4b0e0fb2e$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
$f7cabcf4b0e0fb2e$var$_forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    $f7cabcf4b0e0fb2e$var$_config.units[name] = "px";
});
$f7cabcf4b0e0fb2e$var$gsap.registerPlugin($f7cabcf4b0e0fb2e$export$855822f522f18eef);
var $f7cabcf4b0e0fb2e$export$99ee26438460406a = $f7cabcf4b0e0fb2e$var$gsap.registerPlugin($f7cabcf4b0e0fb2e$export$855822f522f18eef) || $f7cabcf4b0e0fb2e$var$gsap, // to protect from tree shaking
$f7cabcf4b0e0fb2e$export$7b23975ad686bf91 = $f7cabcf4b0e0fb2e$export$99ee26438460406a.core.Tween;
var $f7cabcf4b0e0fb2e$export$2e2bcd8739ae039 = $f7cabcf4b0e0fb2e$export$99ee26438460406a;



var $hPtJY = parcelRequire("hPtJY");
class $b1acb6ed8a11dca2$var$Platform {
    constructor(){
        ////// SESSIONS ////
        window.jtkn = 'blank' // JTKN
        ;
        window.session_fragment = Math.round(Math.random() * 99999);
        window.official_base = window.location.protocol + "//" + window.location.host;
        //var official_base ='https://signalmesh.io'
        window.official_base = 'https://api.signalmesh.io';
        //var official_base = window.location.protocol + "//" + window.location.host;
        if (window.location.host.includes("localhost") || window.location.host.includes("xcore.love") || window.location.host.includes("0.0.0.0")) window.official_base = 'http://localhost:8851';
        window.term = function(min) {
            this.dispatchEvent(new CustomEvent('statusEvent', {
                detail: {
                    'message': min
                }
            }));
        };
    }
    isElectron() {
        // Renderer process
        if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') return true;
        // Main process
        if (typeof $hPtJY !== 'undefined' && typeof $hPtJY.versions === 'object' && !!$hPtJY.versions.electron) return true;
        // Detect the user agent when the `nodeIntegration` option is set to true
        if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) return true;
        return false;
    }
    isElectron() {
        // Renderer process
        if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') return true;
        // Main process
        if (typeof $hPtJY !== 'undefined' && typeof $hPtJY.versions === 'object' && !!$hPtJY.versions.electron) return true;
        // Detect the user agent when the `nodeIntegration` option is set to true
        if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) return true;
        return false;
    }
    inspect() {
        function isElectron() {
            // Renderer process
            if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') return true;
            // Main process
            if (typeof $hPtJY !== 'undefined' && typeof $hPtJY.versions === 'object' && !!$hPtJY.versions.electron) return true;
            // Detect the user agent when the `nodeIntegration` option is set to true
            if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) return true;
            return false;
        }
    }
    domain() {
        var hn = window.location.hostname;
        if (hn == '') hn = 'filehost';
        return hn;
    }
    color() {
        var colors = {
            wo: '#4444FF',
            lo: '#FF00FF',
            sig: '#88ff88'
        };
        var hn = window.location.hostname;
        if (hn.includes('wo')) ;
        else hn.includes('sig');
    }
}
var $b1acb6ed8a11dca2$export$722a64dea1b767dc = new $b1acb6ed8a11dca2$var$Platform();


//https://github.com/chuckfairy/VanillaQR.js
//VanillaQR Function constructor
//pass an object with customizable options
//url, colorLight, colorDark, width, height
function $e1d36db1977d2c76$var$VanillaQR(customize) {
    var scope = this;
    customize = typeof customize === "object" ? customize : {};
    /********************PUBLICS********************/ scope.revision = 3;
    //canvas output types
    scope.imageTypes = {
        "bmp": "image/bmp",
        "gif": "image/gif",
        "jpeg": "image/jpeg",
        "jpg": "image/jpg",
        "png": "image/png",
        "svg+xml": "image/svg+xml",
        "tiff": "image/tiff",
        "webp": "image/webp",
        "x-icon": "image/x-icon"
    };
    //toTable use will default if no canvas support
    scope.toTable = customize.toTable;
    //qr active domElement
    scope.domElement = scope.toTable ? document.createElement("div") : document.createElement("canvas");
    //QR url
    scope.url = customize.url || "";
    //Canvas and qr width and height
    scope.size = customize.size || 280;
    //QR context
    scope.qrc = false;
    //QR colors
    scope.colorLight = customize.colorLight || '#fff';
    scope.colorDark = customize.colorDark || "#000";
    //Correction level
    scope.ecclevel = customize.ecclevel || 1;
    //Border related
    scope.noBorder = customize.noBorder;
    scope.borderSize = customize.borderSize || 4;
    /********************PRIVATES********************/ // Set data values
    // Working buffers:
    var strinbuf = [];
    var eccbuf = [];
    var qrframe = [];
    var framask = [];
    var rlens = [];
    var genpoly = [];
    // Control values - width is based on version, last 4 are from table.
    var ecclevel;
    var version;
    var width;
    var neccblk1;
    var neccblk2;
    var datablkw;
    var eccblkwid;
    /********************QR Creator API********************/ // set bit to indicate cell in qrframe is immutable
    var setmask = function(x, y) {
        var bt;
        if (x > y) {
            bt = x;
            x = y;
            y = bt;
        }
        // y*y = 1+3+5...
        bt = y;
        bt *= y;
        bt += y;
        bt >>= 1;
        bt += x;
        framask[bt] = 1;
    };
    //black to qrframe, white to mask (later black frame merged to mask)
    var putalign = function(x, y) {
        var j;
        qrframe[x + width * y] = 1;
        for(j = -2; j < 2; j++){
            qrframe[x + j + width * (y - 2)] = 1;
            qrframe[x - 2 + width * (y + j + 1)] = 1;
            qrframe[x + 2 + width * (y + j)] = 1;
            qrframe[x + j + 1 + width * (y + 2)] = 1;
        }
        for(j = 0; j < 2; j++){
            setmask(x - 1, y + j);
            setmask(x + 1, y - j);
            setmask(x - j, y - 1);
            setmask(x + j, y + 1);
        }
    };
    //Bit shift modnn
    var modnn = function(x) {
        while(x >= 255){
            x -= 255;
            x = (x >> 8) + (x & 255);
        }
        return x;
    };
    // Calculate and append ECC data to data block.  Block is in strinbuf, indexes to buffers given.
    var appendrs = function(data, dlen, ecbuf, eclen) {
        var i, j, fb;
        var gexp = $e1d36db1977d2c76$var$VanillaQR.gexp;
        var glog = $e1d36db1977d2c76$var$VanillaQR.glog;
        for(i = 0; i < eclen; i++)strinbuf[ecbuf + i] = 0;
        for(i = 0; i < dlen; i++){
            fb = glog[strinbuf[data + i] ^ strinbuf[ecbuf]];
            if (fb != 255) /* fb term is non-zero */ for(j = 1; j < eclen; j++)strinbuf[ecbuf + j - 1] = strinbuf[ecbuf + j] ^ gexp[modnn(fb + genpoly[eclen - j])];
            else for(j = ecbuf; j < ecbuf + eclen; j++)strinbuf[j] = strinbuf[j + 1];
            strinbuf[ecbuf + eclen - 1] = fb == 255 ? 0 : gexp[modnn(fb + genpoly[0])];
        }
    };
    // check mask - since symmetrical use half.
    var ismasked = function(x, y) {
        var bt;
        if (x > y) {
            bt = x;
            x = y;
            y = bt;
        }
        bt = y;
        bt += y * y;
        bt >>= 1;
        bt += x;
        return framask[bt];
    };
    //  Apply the selected mask out of the 8.
    var applymask = function(m) {
        var x, y, r3x, r3y;
        switch(m){
            case 0:
                for(y = 0; y < width; y++)for(x = 0; x < width; x++)if (!(x + y & 1) && !ismasked(x, y)) qrframe[x + y * width] ^= 1;
                break;
            case 1:
                for(y = 0; y < width; y++)for(x = 0; x < width; x++)if (!(y & 1) && !ismasked(x, y)) qrframe[x + y * width] ^= 1;
                break;
            case 2:
                for(y = 0; y < width; y++)for(r3x = 0, x = 0; x < width; x++, r3x++){
                    if (r3x == 3) r3x = 0;
                    if (!r3x && !ismasked(x, y)) qrframe[x + y * width] ^= 1;
                }
                break;
            case 3:
                for(r3y = 0, y = 0; y < width; y++, r3y++){
                    if (r3y == 3) r3y = 0;
                    for(r3x = r3y, x = 0; x < width; x++, r3x++){
                        if (r3x == 3) r3x = 0;
                        if (!r3x && !ismasked(x, y)) qrframe[x + y * width] ^= 1;
                    }
                }
                break;
            case 4:
                for(y = 0; y < width; y++)for(r3x = 0, r3y = y >> 1 & 1, x = 0; x < width; x++, r3x++){
                    if (r3x == 3) {
                        r3x = 0;
                        r3y = !r3y;
                    }
                    if (!r3y && !ismasked(x, y)) qrframe[x + y * width] ^= 1;
                }
                break;
            case 5:
                for(r3y = 0, y = 0; y < width; y++, r3y++){
                    if (r3y == 3) r3y = 0;
                    for(r3x = 0, x = 0; x < width; x++, r3x++){
                        if (r3x == 3) r3x = 0;
                        if (!((x & y & 1) + !(!r3x | !r3y)) && !ismasked(x, y)) qrframe[x + y * width] ^= 1;
                    }
                }
                break;
            case 6:
                for(r3y = 0, y = 0; y < width; y++, r3y++){
                    if (r3y == 3) r3y = 0;
                    for(r3x = 0, x = 0; x < width; x++, r3x++){
                        if (r3x == 3) r3x = 0;
                        if (!((x & y & 1) + (r3x && r3x == r3y) & 1) && !ismasked(x, y)) qrframe[x + y * width] ^= 1;
                    }
                }
                break;
            case 7:
                for(r3y = 0, y = 0; y < width; y++, r3y++){
                    if (r3y == 3) r3y = 0;
                    for(r3x = 0, x = 0; x < width; x++, r3x++){
                        if (r3x == 3) r3x = 0;
                        if (!((r3x && r3x == r3y) + (x + y & 1) & 1) && !ismasked(x, y)) qrframe[x + y * width] ^= 1;
                    }
                }
                break;
        }
    };
    // Using the table of the length of each run, calculate the amount of bad image
    // - long runs or those that look like finders; called twice, once each for X and Y
    var badruns = function(length) {
        var i;
        var runsbad = 0;
        for(i = 0; i <= length; i++)if (rlens[i] >= 5) runsbad += $e1d36db1977d2c76$var$VanillaQR.N1 + rlens[i] - 5;
        // BwBBBwB as in finder
        for(i = 3; i < length - 1; i += 2)if (rlens[i - 2] == rlens[i + 2] && rlens[i + 2] == rlens[i - 1] && rlens[i - 1] == rlens[i + 1] && rlens[i - 1] * 3 == rlens[i] && (rlens[i - 3] == 0 // beginning
         || i + 3 > length // end
         || rlens[i - 3] * 3 >= rlens[i] * 4 || rlens[i + 3] * 3 >= rlens[i] * 4)) runsbad += $e1d36db1977d2c76$var$VanillaQR.N3;
        return runsbad;
    };
    // Calculate how bad the masked image is - blocks, imbalance, runs, or finders.
    var badcheck = function() {
        var x, y, h, b, b1;
        var thisbad = 0;
        var bw = 0;
        // blocks of same color.
        for(y = 0; y < width - 1; y++){
            for(x = 0; x < width - 1; x++)if (qrframe[x + width * y] && qrframe[x + 1 + width * y] && qrframe[x + width * (y + 1)] && qrframe[x + 1 + width * (y + 1)] // all black
             || !(qrframe[x + width * y] || qrframe[x + 1 + width * y] || qrframe[x + width * (y + 1)] || qrframe[x + 1 + width * (y + 1)])) thisbad += $e1d36db1977d2c76$var$VanillaQR.N2;
        }
        // X runs
        for(y = 0; y < width; y++){
            rlens[0] = 0;
            for(h = b = x = 0; x < width; x++){
                if ((b1 = qrframe[x + width * y]) == b) rlens[h]++;
                else rlens[++h] = 1;
                b = b1;
                bw += b ? 1 : -1;
            }
            thisbad += badruns(h);
        }
        // black/white imbalance
        if (bw < 0) bw = -bw;
        var big = bw;
        var count = 0;
        big += big << 2;
        big <<= 1;
        while(big > width * width)big -= width * width, count++;
        thisbad += count * $e1d36db1977d2c76$var$VanillaQR.N4;
        // Y runs
        for(x = 0; x < width; x++){
            rlens[0] = 0;
            for(h = b = y = 0; y < width; y++){
                if ((b1 = qrframe[x + width * y]) == b) rlens[h]++;
                else rlens[++h] = 1;
                b = b1;
            }
            thisbad += badruns(h);
        }
        return thisbad;
    };
    //Generate QR frame array
    scope.genframe = function(instring) {
        var eccblocks = $e1d36db1977d2c76$var$VanillaQR.eccblocks;
        var gexp = $e1d36db1977d2c76$var$VanillaQR.gexp;
        var glog = $e1d36db1977d2c76$var$VanillaQR.glog;
        var x, y, k, t, v, i, j, m;
        // find the smallest version that fits the string
        t = instring.length;
        version = 0;
        do {
            version++;
            k = (ecclevel - 1) * 4 + (version - 1) * 16;
            neccblk1 = eccblocks[k++];
            neccblk2 = eccblocks[k++];
            datablkw = eccblocks[k++];
            eccblkwid = eccblocks[k];
            k = datablkw * (neccblk1 + neccblk2) + neccblk2 - 3 + (version <= 9);
            if (t <= k) break;
        }while (version < 40);
        // FIXME - insure that it fits insted of being truncated
        width = 17 + 4 * version;
        // allocate, clear and setup data structures
        v = datablkw + (datablkw + eccblkwid) * (neccblk1 + neccblk2) + neccblk2;
        for(t = 0; t < v; t++)eccbuf[t] = 0;
        strinbuf = instring.slice(0);
        for(t = 0; t < width * width; t++)qrframe[t] = 0;
        for(t = 0; t < (width * (width + 1) + 1) / 2; t++)framask[t] = 0;
        // insert finders - black to frame, white to mask
        for(t = 0; t < 3; t++){
            k = 0;
            y = 0;
            if (t == 1) k = width - 7;
            if (t == 2) y = width - 7;
            qrframe[y + 3 + width * (k + 3)] = 1;
            for(x = 0; x < 6; x++){
                qrframe[y + x + width * k] = 1;
                qrframe[y + width * (k + x + 1)] = 1;
                qrframe[y + 6 + width * (k + x)] = 1;
                qrframe[y + x + 1 + width * (k + 6)] = 1;
            }
            for(x = 1; x < 5; x++){
                setmask(y + x, k + 1);
                setmask(y + 1, k + x + 1);
                setmask(y + 5, k + x);
                setmask(y + x + 1, k + 5);
            }
            for(x = 2; x < 4; x++){
                qrframe[y + x + width * (k + 2)] = 1;
                qrframe[y + 2 + width * (k + x + 1)] = 1;
                qrframe[y + 4 + width * (k + x)] = 1;
                qrframe[y + x + 1 + width * (k + 4)] = 1;
            }
        }
        // alignment blocks
        if (version > 1) {
            t = $e1d36db1977d2c76$var$VanillaQR.adelta[version];
            y = width - 7;
            for(;;){
                x = width - 7;
                while(x > t - 3){
                    putalign(x, y);
                    if (x < t) break;
                    x -= t;
                }
                if (y <= t + 9) break;
                y -= t;
                putalign(6, y);
                putalign(y, 6);
            }
        }
        // single black
        qrframe[8 + width * (width - 8)] = 1;
        // timing gap - mask only
        for(y = 0; y < 7; y++){
            setmask(7, y);
            setmask(width - 8, y);
            setmask(7, y + width - 7);
        }
        for(x = 0; x < 8; x++){
            setmask(x, 7);
            setmask(x + width - 8, 7);
            setmask(x, width - 8);
        }
        // reserve mask-format area
        for(x = 0; x < 9; x++)setmask(x, 8);
        for(x = 0; x < 8; x++){
            setmask(x + width - 8, 8);
            setmask(8, x);
        }
        for(y = 0; y < 7; y++)setmask(8, y + width - 7);
        // timing row/col
        for(x = 0; x < width - 14; x++)if (x & 1) {
            setmask(8 + x, 6);
            setmask(6, 8 + x);
        } else {
            qrframe[8 + x + width * 6] = 1;
            qrframe[6 + width * (8 + x)] = 1;
        }
        // version block
        if (version > 6) {
            t = $e1d36db1977d2c76$var$VanillaQR.vpat[version - 7];
            k = 17;
            for(x = 0; x < 6; x++)for(y = 0; y < 3; y++, k--)if (1 & (k > 11 ? version >> k - 12 : t >> k)) {
                qrframe[5 - x + width * (2 - y + width - 11)] = 1;
                qrframe[2 - y + width - 11 + width * (5 - x)] = 1;
            } else {
                setmask(5 - x, 2 - y + width - 11);
                setmask(2 - y + width - 11, 5 - x);
            }
        }
        // sync mask bits - only set above for white spaces, so add in black bits
        for(y = 0; y < width; y++)for(x = 0; x <= y; x++)if (qrframe[x + width * y]) setmask(x, y);
        // convert string to bitstream
        // 8 bit data to QR-coded 8 bit data (numeric or alphanum, or kanji not supported)
        v = strinbuf.length;
        // string to array
        for(i = 0; i < v; i++)eccbuf[i] = strinbuf.charCodeAt(i);
        strinbuf = eccbuf.slice(0);
        // calculate max string length
        x = datablkw * (neccblk1 + neccblk2) + neccblk2;
        if (v >= x - 2) {
            v = x - 2;
            if (version > 9) v--;
        }
        // shift and repack to insert length prefix
        i = v;
        if (version > 9) {
            strinbuf[i + 2] = 0;
            strinbuf[i + 3] = 0;
            while(i--){
                t = strinbuf[i];
                strinbuf[i + 3] |= 255 & t << 4;
                strinbuf[i + 2] = t >> 4;
            }
            strinbuf[2] |= 255 & v << 4;
            strinbuf[1] = v >> 4;
            strinbuf[0] = 0x40 | v >> 12;
        } else {
            strinbuf[i + 1] = 0;
            strinbuf[i + 2] = 0;
            while(i--){
                t = strinbuf[i];
                strinbuf[i + 2] |= 255 & t << 4;
                strinbuf[i + 1] = t >> 4;
            }
            strinbuf[1] |= 255 & v << 4;
            strinbuf[0] = 0x40 | v >> 4;
        }
        // fill to end with pad pattern
        i = v + 3 - (version < 10);
        while(i < x){
            strinbuf[i++] = 0xec;
            // buffer has room    if (i == x)      break;
            strinbuf[i++] = 0x11;
        }
        // calculate and append ECC
        // calculate generator polynomial
        genpoly[0] = 1;
        for(i = 0; i < eccblkwid; i++){
            genpoly[i + 1] = 1;
            for(j = i; j > 0; j--)genpoly[j] = genpoly[j] ? genpoly[j - 1] ^ gexp[modnn(glog[genpoly[j]] + i)] : genpoly[j - 1];
            genpoly[0] = gexp[modnn(glog[genpoly[0]] + i)];
        }
        for(i = 0; i <= eccblkwid; i++)genpoly[i] = glog[genpoly[i]]; // use logs for genpoly[] to save calc step
        // append ecc to data buffer
        k = x;
        y = 0;
        for(i = 0; i < neccblk1; i++){
            appendrs(y, datablkw, k, eccblkwid);
            y += datablkw;
            k += eccblkwid;
        }
        for(i = 0; i < neccblk2; i++){
            appendrs(y, datablkw + 1, k, eccblkwid);
            y += datablkw + 1;
            k += eccblkwid;
        }
        // interleave blocks
        y = 0;
        for(i = 0; i < datablkw; i++){
            for(j = 0; j < neccblk1; j++)eccbuf[y++] = strinbuf[i + j * datablkw];
            for(j = 0; j < neccblk2; j++)eccbuf[y++] = strinbuf[neccblk1 * datablkw + i + j * (datablkw + 1)];
        }
        for(j = 0; j < neccblk2; j++)eccbuf[y++] = strinbuf[neccblk1 * datablkw + i + j * (datablkw + 1)];
        for(i = 0; i < eccblkwid; i++)for(j = 0; j < neccblk1 + neccblk2; j++)eccbuf[y++] = strinbuf[x + i + j * eccblkwid];
        strinbuf = eccbuf;
        // pack bits into frame avoiding masked area.
        x = y = width - 1;
        k = v = 1; // up, minus
        /* inteleaved data and ecc codes */ m = (datablkw + eccblkwid) * (neccblk1 + neccblk2) + neccblk2;
        for(i = 0; i < m; i++){
            t = strinbuf[i];
            for(j = 0; j < 8; j++, t <<= 1){
                if (0x80 & t) qrframe[x + width * y] = 1;
                do {
                    if (v) x--;
                    else {
                        x++;
                        if (k) {
                            if (y != 0) y--;
                            else {
                                x -= 2;
                                k = !k;
                                if (x == 6) {
                                    x--;
                                    y = 9;
                                }
                            }
                        } else if (y != width - 1) y++;
                        else {
                            x -= 2;
                            k = !k;
                            if (x == 6) {
                                x--;
                                y -= 8;
                            }
                        }
                    }
                    v = !v;
                }while (ismasked(x, y));
            }
        }
        // save pre-mask copy of frame
        strinbuf = qrframe.slice(0);
        t = 0; // best
        y = 30000; // demerit
        // for instead of while since in original arduino code
        // if an early mask was "good enough" it wouldn't try for a better one
        // since they get more complex and take longer.
        for(k = 0; k < 8; k++){
            // returns black-white imbalance
            applymask(k);
            x = badcheck();
            if (x < y) {
                y = x;
                t = k;
            }
            if (t == 7) break; // don't increment i to a void redoing mask
            qrframe = strinbuf.slice(0); // reset for next pass
        }
        if (t != k) applymask(t);
        // add in final mask/ecclevel bytes
        y = $e1d36db1977d2c76$var$VanillaQR.fmtword[t + (ecclevel - 1 << 3)];
        // low byte
        for(k = 0; k < 8; k++, y >>= 1)if (y & 1) {
            qrframe[width - 1 - k + width * 8] = 1;
            if (k < 6) qrframe[8 + width * k] = 1;
            else qrframe[8 + width * (k + 1)] = 1;
        }
        // high byte
        for(k = 0; k < 7; k++, y >>= 1)if (y & 1) {
            qrframe[8 + width * (width - 7 + k)] = 1;
            if (k) qrframe[6 - k + width * 8] = 1;
            else qrframe[7 + width * 8] = 1;
        }
        // return image
        return qrframe;
    };
    //Initialize QR Code
    scope.init = function() {
        ecclevel = scope.ecclevel;
        var qf = scope.genframe(scope.url);
        if (scope.toTable) scope.tableWrite(qf, width);
        else scope.canvasWrite(qf, width);
    };
    //Auto initialize
    scope.init();
}
//Get canvas 2D Context
$e1d36db1977d2c76$var$VanillaQR.prototype = {
    //Canvas create
    canvasWrite: function(qf, width) {
        var scope = this;
        //Get context and proceed if it is allowed
        if (!scope.qrc) {
            scope.qrc = scope.getContext(scope.domElement);
            //No canvas support default to Table
            if (!scope.qrc) {
                scope.toTable = true;
                scope.domElement = document.createElement("div");
                scope.tableWrite(qf, width);
                return;
            }
        }
        //Setup canvas context
        var size = scope.size;
        var qrc = scope.qrc;
        qrc.lineWidth = 1;
        var px = size;
        px /= width + 10;
        px = Math.round(px - 0.5);
        var offset = 4;
        if (scope.noBorder) {
            qrc.canvas.width = qrc.canvas.height = px * width;
            offset = 0;
        } else qrc.canvas.width = qrc.canvas.height = size;
        //Fill canvas with set colors
        qrc.clearRect(0, 0, size, size);
        qrc.fillStyle = scope.colorLight;
        qrc.fillRect(0, 0, px * (width + 8), px * (width + 8));
        qrc.fillStyle = scope.colorDark;
        //Write boxes per row
        for(var i = 0; i < width; i++){
            for(var j = 0; j < width; j++)if (qf[j * width + i]) qrc.fillRect(px * (offset + i), px * (offset + j), px, px);
        }
    },
    //Table write qr code
    tableWrite: function(qf, width) {
        var scope = this;
        //Table style
        var collapseStyle = "border:0;border-collapse:collapse;";
        var tdWidth = Math.round(this.size / width - 3.5) + "px";
        var borderWidth = width + (scope.noBorder ? 0 : scope.borderSize * 2);
        var sideBorderWidth = scope.borderSize;
        var tdStyle = "width:" + tdWidth + ";height:" + tdWidth + ";";
        var colorLight = scope.colorLight;
        var colorDark = scope.colorDark;
        //Table elements
        var table = document.createElement("table");
        table.style.cssText = collapseStyle;
        var tr = document.createElement("tr");
        var td = document.createElement("td");
        //Cloning and creating table Elements
        var cloneTD = function() {
            return td.cloneNode();
        };
        var createTDDark = function() {
            var elem = cloneTD();
            elem.style.cssText = tdStyle + "background:" + colorDark;
            return elem;
        };
        var createTDLight = function() {
            var elem = cloneTD();
            elem.style.cssText = tdStyle + "background:" + colorLight;
            return elem;
        };
        //Regular borders appending
        var appendBorders = function(table) {
            var insertNode = table.firstChild;
            for(var i = 0; i < scope.borderSize; i++){
                var row = tr.cloneNode();
                for(var t = 0; t < borderWidth; t++){
                    var lightTD = createTDLight();
                    row.appendChild(lightTD);
                }
                table.appendChild(row);
                table.insertBefore(row.cloneNode(true), insertNode);
            }
        };
        //Create side border
        var appendSideBorders = function(row) {
            var insertNode = row.firstChild;
            for(var i = 0; i < sideBorderWidth; i++){
                row.insertBefore(createTDLight(), insertNode);
                row.appendChild(createTDLight());
            }
        };
        //Write boxes per row
        for(var i = 0; i < width; i++){
            var currentRow = tr.cloneNode();
            table.appendChild(currentRow);
            for(var j = 0; j < width; j++)//Is a dark color
            if (qf[i * width + j] === 1) {
                var darkTd = createTDDark();
                currentRow.appendChild(darkTd);
            } else {
                var lightTD = createTDLight();
                currentRow.appendChild(lightTD);
            }
            if (!scope.noBorder) appendSideBorders(currentRow);
        }
        if (!scope.noBorder) appendBorders(table);
        scope.domElement.innerHTML = "";
        scope.domElement.appendChild(table);
    },
    //get domElement 2D  Context
    getContext: function(domElement) {
        //try to get 2d context error
        if (!(domElement.getContext && domElement.getContext('2d'))) {
            console.log("Browser does not have 2d Canvas support");
            return false;
        }
        return domElement.getContext('2d');
    },
    //QR frame to image type
    toImage: function(type) {
        if (!this.qrc) return;
        //Check image output type
        var dataType = this.imageTypes[type];
        if (!dataType) throw new Error(type + " is not a valid image type ");
        //create image with src of QR code
        var image = new Image;
        image.src = this.domElement.toDataURL(dataType);
        return image;
    }
};
// Private variables
// alignment pattern
$e1d36db1977d2c76$var$VanillaQR.adelta = [
    0,
    11,
    15,
    19,
    23,
    27,
    31,
    16,
    18,
    20,
    22,
    24,
    26,
    28,
    20,
    22,
    24,
    24,
    26,
    28,
    28,
    22,
    24,
    24,
    26,
    26,
    28,
    28,
    24,
    24,
    26,
    26,
    26,
    28,
    28,
    24,
    26,
    26,
    26,
    28,
    28
];
// version block
$e1d36db1977d2c76$var$VanillaQR.vpat = [
    0xc94,
    0x5bc,
    0xa99,
    0x4d3,
    0xbf6,
    0x762,
    0x847,
    0x60d,
    0x928,
    0xb78,
    0x45d,
    0xa17,
    0x532,
    0x9a6,
    0x683,
    0x8c9,
    0x7ec,
    0xec4,
    0x1e1,
    0xfab,
    0x08e,
    0xc1a,
    0x33f,
    0xd75,
    0x250,
    0x9d5,
    0x6f0,
    0x8ba,
    0x79f,
    0xb0b,
    0x42e,
    0xa64,
    0x541,
    0xc69
];
// final format bits with mask: level << 3 | mask
$e1d36db1977d2c76$var$VanillaQR.fmtword = [
    0x77c4,
    0x72f3,
    0x7daa,
    0x789d,
    0x662f,
    0x6318,
    0x6c41,
    0x6976,
    0x5412,
    0x5125,
    0x5e7c,
    0x5b4b,
    0x45f9,
    0x40ce,
    0x4f97,
    0x4aa0,
    0x355f,
    0x3068,
    0x3f31,
    0x3a06,
    0x24b4,
    0x2183,
    0x2eda,
    0x2bed,
    0x1689,
    0x13be,
    0x1ce7,
    0x19d0,
    0x0762,
    0x0255,
    0x0d0c,
    0x083b //H
];
// 4 per version: number of blocks 1,2; data width; ecc width
$e1d36db1977d2c76$var$VanillaQR.eccblocks = [
    1,
    0,
    19,
    7,
    1,
    0,
    16,
    10,
    1,
    0,
    13,
    13,
    1,
    0,
    9,
    17,
    1,
    0,
    34,
    10,
    1,
    0,
    28,
    16,
    1,
    0,
    22,
    22,
    1,
    0,
    16,
    28,
    1,
    0,
    55,
    15,
    1,
    0,
    44,
    26,
    2,
    0,
    17,
    18,
    2,
    0,
    13,
    22,
    1,
    0,
    80,
    20,
    2,
    0,
    32,
    18,
    2,
    0,
    24,
    26,
    4,
    0,
    9,
    16,
    1,
    0,
    108,
    26,
    2,
    0,
    43,
    24,
    2,
    2,
    15,
    18,
    2,
    2,
    11,
    22,
    2,
    0,
    68,
    18,
    4,
    0,
    27,
    16,
    4,
    0,
    19,
    24,
    4,
    0,
    15,
    28,
    2,
    0,
    78,
    20,
    4,
    0,
    31,
    18,
    2,
    4,
    14,
    18,
    4,
    1,
    13,
    26,
    2,
    0,
    97,
    24,
    2,
    2,
    38,
    22,
    4,
    2,
    18,
    22,
    4,
    2,
    14,
    26,
    2,
    0,
    116,
    30,
    3,
    2,
    36,
    22,
    4,
    4,
    16,
    20,
    4,
    4,
    12,
    24,
    2,
    2,
    68,
    18,
    4,
    1,
    43,
    26,
    6,
    2,
    19,
    24,
    6,
    2,
    15,
    28,
    4,
    0,
    81,
    20,
    1,
    4,
    50,
    30,
    4,
    4,
    22,
    28,
    3,
    8,
    12,
    24,
    2,
    2,
    92,
    24,
    6,
    2,
    36,
    22,
    4,
    6,
    20,
    26,
    7,
    4,
    14,
    28,
    4,
    0,
    107,
    26,
    8,
    1,
    37,
    22,
    8,
    4,
    20,
    24,
    12,
    4,
    11,
    22,
    3,
    1,
    115,
    30,
    4,
    5,
    40,
    24,
    11,
    5,
    16,
    20,
    11,
    5,
    12,
    24,
    5,
    1,
    87,
    22,
    5,
    5,
    41,
    24,
    5,
    7,
    24,
    30,
    11,
    7,
    12,
    24,
    5,
    1,
    98,
    24,
    7,
    3,
    45,
    28,
    15,
    2,
    19,
    24,
    3,
    13,
    15,
    30,
    1,
    5,
    107,
    28,
    10,
    1,
    46,
    28,
    1,
    15,
    22,
    28,
    2,
    17,
    14,
    28,
    5,
    1,
    120,
    30,
    9,
    4,
    43,
    26,
    17,
    1,
    22,
    28,
    2,
    19,
    14,
    28,
    3,
    4,
    113,
    28,
    3,
    11,
    44,
    26,
    17,
    4,
    21,
    26,
    9,
    16,
    13,
    26,
    3,
    5,
    107,
    28,
    3,
    13,
    41,
    26,
    15,
    5,
    24,
    30,
    15,
    10,
    15,
    28,
    4,
    4,
    116,
    28,
    17,
    0,
    42,
    26,
    17,
    6,
    22,
    28,
    19,
    6,
    16,
    30,
    2,
    7,
    111,
    28,
    17,
    0,
    46,
    28,
    7,
    16,
    24,
    30,
    34,
    0,
    13,
    24,
    4,
    5,
    121,
    30,
    4,
    14,
    47,
    28,
    11,
    14,
    24,
    30,
    16,
    14,
    15,
    30,
    6,
    4,
    117,
    30,
    6,
    14,
    45,
    28,
    11,
    16,
    24,
    30,
    30,
    2,
    16,
    30,
    8,
    4,
    106,
    26,
    8,
    13,
    47,
    28,
    7,
    22,
    24,
    30,
    22,
    13,
    15,
    30,
    10,
    2,
    114,
    28,
    19,
    4,
    46,
    28,
    28,
    6,
    22,
    28,
    33,
    4,
    16,
    30,
    8,
    4,
    122,
    30,
    22,
    3,
    45,
    28,
    8,
    26,
    23,
    30,
    12,
    28,
    15,
    30,
    3,
    10,
    117,
    30,
    3,
    23,
    45,
    28,
    4,
    31,
    24,
    30,
    11,
    31,
    15,
    30,
    7,
    7,
    116,
    30,
    21,
    7,
    45,
    28,
    1,
    37,
    23,
    30,
    19,
    26,
    15,
    30,
    5,
    10,
    115,
    30,
    19,
    10,
    47,
    28,
    15,
    25,
    24,
    30,
    23,
    25,
    15,
    30,
    13,
    3,
    115,
    30,
    2,
    29,
    46,
    28,
    42,
    1,
    24,
    30,
    23,
    28,
    15,
    30,
    17,
    0,
    115,
    30,
    10,
    23,
    46,
    28,
    10,
    35,
    24,
    30,
    19,
    35,
    15,
    30,
    17,
    1,
    115,
    30,
    14,
    21,
    46,
    28,
    29,
    19,
    24,
    30,
    11,
    46,
    15,
    30,
    13,
    6,
    115,
    30,
    14,
    23,
    46,
    28,
    44,
    7,
    24,
    30,
    59,
    1,
    16,
    30,
    12,
    7,
    121,
    30,
    12,
    26,
    47,
    28,
    39,
    14,
    24,
    30,
    22,
    41,
    15,
    30,
    6,
    14,
    121,
    30,
    6,
    34,
    47,
    28,
    46,
    10,
    24,
    30,
    2,
    64,
    15,
    30,
    17,
    4,
    122,
    30,
    29,
    14,
    46,
    28,
    49,
    10,
    24,
    30,
    24,
    46,
    15,
    30,
    4,
    18,
    122,
    30,
    13,
    32,
    46,
    28,
    48,
    14,
    24,
    30,
    42,
    32,
    15,
    30,
    20,
    4,
    117,
    30,
    40,
    7,
    47,
    28,
    43,
    22,
    24,
    30,
    10,
    67,
    15,
    30,
    19,
    6,
    118,
    30,
    18,
    31,
    47,
    28,
    34,
    34,
    24,
    30,
    20,
    61,
    15,
    30
];
// Galois field log table
$e1d36db1977d2c76$var$VanillaQR.glog = [
    0xff,
    0x00,
    0x01,
    0x19,
    0x02,
    0x32,
    0x1a,
    0xc6,
    0x03,
    0xdf,
    0x33,
    0xee,
    0x1b,
    0x68,
    0xc7,
    0x4b,
    0x04,
    0x64,
    0xe0,
    0x0e,
    0x34,
    0x8d,
    0xef,
    0x81,
    0x1c,
    0xc1,
    0x69,
    0xf8,
    0xc8,
    0x08,
    0x4c,
    0x71,
    0x05,
    0x8a,
    0x65,
    0x2f,
    0xe1,
    0x24,
    0x0f,
    0x21,
    0x35,
    0x93,
    0x8e,
    0xda,
    0xf0,
    0x12,
    0x82,
    0x45,
    0x1d,
    0xb5,
    0xc2,
    0x7d,
    0x6a,
    0x27,
    0xf9,
    0xb9,
    0xc9,
    0x9a,
    0x09,
    0x78,
    0x4d,
    0xe4,
    0x72,
    0xa6,
    0x06,
    0xbf,
    0x8b,
    0x62,
    0x66,
    0xdd,
    0x30,
    0xfd,
    0xe2,
    0x98,
    0x25,
    0xb3,
    0x10,
    0x91,
    0x22,
    0x88,
    0x36,
    0xd0,
    0x94,
    0xce,
    0x8f,
    0x96,
    0xdb,
    0xbd,
    0xf1,
    0xd2,
    0x13,
    0x5c,
    0x83,
    0x38,
    0x46,
    0x40,
    0x1e,
    0x42,
    0xb6,
    0xa3,
    0xc3,
    0x48,
    0x7e,
    0x6e,
    0x6b,
    0x3a,
    0x28,
    0x54,
    0xfa,
    0x85,
    0xba,
    0x3d,
    0xca,
    0x5e,
    0x9b,
    0x9f,
    0x0a,
    0x15,
    0x79,
    0x2b,
    0x4e,
    0xd4,
    0xe5,
    0xac,
    0x73,
    0xf3,
    0xa7,
    0x57,
    0x07,
    0x70,
    0xc0,
    0xf7,
    0x8c,
    0x80,
    0x63,
    0x0d,
    0x67,
    0x4a,
    0xde,
    0xed,
    0x31,
    0xc5,
    0xfe,
    0x18,
    0xe3,
    0xa5,
    0x99,
    0x77,
    0x26,
    0xb8,
    0xb4,
    0x7c,
    0x11,
    0x44,
    0x92,
    0xd9,
    0x23,
    0x20,
    0x89,
    0x2e,
    0x37,
    0x3f,
    0xd1,
    0x5b,
    0x95,
    0xbc,
    0xcf,
    0xcd,
    0x90,
    0x87,
    0x97,
    0xb2,
    0xdc,
    0xfc,
    0xbe,
    0x61,
    0xf2,
    0x56,
    0xd3,
    0xab,
    0x14,
    0x2a,
    0x5d,
    0x9e,
    0x84,
    0x3c,
    0x39,
    0x53,
    0x47,
    0x6d,
    0x41,
    0xa2,
    0x1f,
    0x2d,
    0x43,
    0xd8,
    0xb7,
    0x7b,
    0xa4,
    0x76,
    0xc4,
    0x17,
    0x49,
    0xec,
    0x7f,
    0x0c,
    0x6f,
    0xf6,
    0x6c,
    0xa1,
    0x3b,
    0x52,
    0x29,
    0x9d,
    0x55,
    0xaa,
    0xfb,
    0x60,
    0x86,
    0xb1,
    0xbb,
    0xcc,
    0x3e,
    0x5a,
    0xcb,
    0x59,
    0x5f,
    0xb0,
    0x9c,
    0xa9,
    0xa0,
    0x51,
    0x0b,
    0xf5,
    0x16,
    0xeb,
    0x7a,
    0x75,
    0x2c,
    0xd7,
    0x4f,
    0xae,
    0xd5,
    0xe9,
    0xe6,
    0xe7,
    0xad,
    0xe8,
    0x74,
    0xd6,
    0xf4,
    0xea,
    0xa8,
    0x50,
    0x58,
    0xaf
];
// Galios field exponent table
$e1d36db1977d2c76$var$VanillaQR.gexp = [
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1d,
    0x3a,
    0x74,
    0xe8,
    0xcd,
    0x87,
    0x13,
    0x26,
    0x4c,
    0x98,
    0x2d,
    0x5a,
    0xb4,
    0x75,
    0xea,
    0xc9,
    0x8f,
    0x03,
    0x06,
    0x0c,
    0x18,
    0x30,
    0x60,
    0xc0,
    0x9d,
    0x27,
    0x4e,
    0x9c,
    0x25,
    0x4a,
    0x94,
    0x35,
    0x6a,
    0xd4,
    0xb5,
    0x77,
    0xee,
    0xc1,
    0x9f,
    0x23,
    0x46,
    0x8c,
    0x05,
    0x0a,
    0x14,
    0x28,
    0x50,
    0xa0,
    0x5d,
    0xba,
    0x69,
    0xd2,
    0xb9,
    0x6f,
    0xde,
    0xa1,
    0x5f,
    0xbe,
    0x61,
    0xc2,
    0x99,
    0x2f,
    0x5e,
    0xbc,
    0x65,
    0xca,
    0x89,
    0x0f,
    0x1e,
    0x3c,
    0x78,
    0xf0,
    0xfd,
    0xe7,
    0xd3,
    0xbb,
    0x6b,
    0xd6,
    0xb1,
    0x7f,
    0xfe,
    0xe1,
    0xdf,
    0xa3,
    0x5b,
    0xb6,
    0x71,
    0xe2,
    0xd9,
    0xaf,
    0x43,
    0x86,
    0x11,
    0x22,
    0x44,
    0x88,
    0x0d,
    0x1a,
    0x34,
    0x68,
    0xd0,
    0xbd,
    0x67,
    0xce,
    0x81,
    0x1f,
    0x3e,
    0x7c,
    0xf8,
    0xed,
    0xc7,
    0x93,
    0x3b,
    0x76,
    0xec,
    0xc5,
    0x97,
    0x33,
    0x66,
    0xcc,
    0x85,
    0x17,
    0x2e,
    0x5c,
    0xb8,
    0x6d,
    0xda,
    0xa9,
    0x4f,
    0x9e,
    0x21,
    0x42,
    0x84,
    0x15,
    0x2a,
    0x54,
    0xa8,
    0x4d,
    0x9a,
    0x29,
    0x52,
    0xa4,
    0x55,
    0xaa,
    0x49,
    0x92,
    0x39,
    0x72,
    0xe4,
    0xd5,
    0xb7,
    0x73,
    0xe6,
    0xd1,
    0xbf,
    0x63,
    0xc6,
    0x91,
    0x3f,
    0x7e,
    0xfc,
    0xe5,
    0xd7,
    0xb3,
    0x7b,
    0xf6,
    0xf1,
    0xff,
    0xe3,
    0xdb,
    0xab,
    0x4b,
    0x96,
    0x31,
    0x62,
    0xc4,
    0x95,
    0x37,
    0x6e,
    0xdc,
    0xa5,
    0x57,
    0xae,
    0x41,
    0x82,
    0x19,
    0x32,
    0x64,
    0xc8,
    0x8d,
    0x07,
    0x0e,
    0x1c,
    0x38,
    0x70,
    0xe0,
    0xdd,
    0xa7,
    0x53,
    0xa6,
    0x51,
    0xa2,
    0x59,
    0xb2,
    0x79,
    0xf2,
    0xf9,
    0xef,
    0xc3,
    0x9b,
    0x2b,
    0x56,
    0xac,
    0x45,
    0x8a,
    0x09,
    0x12,
    0x24,
    0x48,
    0x90,
    0x3d,
    0x7a,
    0xf4,
    0xf5,
    0xf7,
    0xf3,
    0xfb,
    0xeb,
    0xcb,
    0x8b,
    0x0b,
    0x16,
    0x2c,
    0x58,
    0xb0,
    0x7d,
    0xfa,
    0xe9,
    0xcf,
    0x83,
    0x1b,
    0x36,
    0x6c,
    0xd8,
    0xad,
    0x47,
    0x8e,
    0x00
];
// Badness coefficients.
$e1d36db1977d2c76$var$VanillaQR.N1 = 3;
$e1d36db1977d2c76$var$VanillaQR.N2 = 3;
$e1d36db1977d2c76$var$VanillaQR.N3 = 40;
$e1d36db1977d2c76$var$VanillaQR.N4 = 10;
var $e1d36db1977d2c76$export$2e2bcd8739ae039 = $e1d36db1977d2c76$var$VanillaQR;


/* SNOWPACK PROCESS POLYFILL (based on https://github.com/calvinmetcalf/node-process-es6) */ function $86092612ee5eb68b$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $86092612ee5eb68b$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
var $86092612ee5eb68b$var$cachedSetTimeout = $86092612ee5eb68b$var$defaultSetTimout;
var $86092612ee5eb68b$var$cachedClearTimeout = $86092612ee5eb68b$var$defaultClearTimeout;
var $86092612ee5eb68b$var$globalContext;
if (typeof window !== 'undefined') $86092612ee5eb68b$var$globalContext = window;
else if (typeof self !== 'undefined') $86092612ee5eb68b$var$globalContext = self;
else $86092612ee5eb68b$var$globalContext = {};
if (typeof $86092612ee5eb68b$var$globalContext.setTimeout === 'function') $86092612ee5eb68b$var$cachedSetTimeout = setTimeout;
if (typeof $86092612ee5eb68b$var$globalContext.clearTimeout === 'function') $86092612ee5eb68b$var$cachedClearTimeout = clearTimeout;
function $86092612ee5eb68b$var$runTimeout(fun) {
    if ($86092612ee5eb68b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($86092612ee5eb68b$var$cachedSetTimeout === $86092612ee5eb68b$var$defaultSetTimout || !$86092612ee5eb68b$var$cachedSetTimeout) && setTimeout) {
        $86092612ee5eb68b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $86092612ee5eb68b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $86092612ee5eb68b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $86092612ee5eb68b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $86092612ee5eb68b$var$runClearTimeout(marker) {
    if ($86092612ee5eb68b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($86092612ee5eb68b$var$cachedClearTimeout === $86092612ee5eb68b$var$defaultClearTimeout || !$86092612ee5eb68b$var$cachedClearTimeout) && clearTimeout) {
        $86092612ee5eb68b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $86092612ee5eb68b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $86092612ee5eb68b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $86092612ee5eb68b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $86092612ee5eb68b$var$queue = [];
var $86092612ee5eb68b$var$draining = false;
var $86092612ee5eb68b$var$currentQueue;
var $86092612ee5eb68b$var$queueIndex = -1;
function $86092612ee5eb68b$var$cleanUpNextTick() {
    if (!$86092612ee5eb68b$var$draining || !$86092612ee5eb68b$var$currentQueue) return;
    $86092612ee5eb68b$var$draining = false;
    if ($86092612ee5eb68b$var$currentQueue.length) $86092612ee5eb68b$var$queue = $86092612ee5eb68b$var$currentQueue.concat($86092612ee5eb68b$var$queue);
    else $86092612ee5eb68b$var$queueIndex = -1;
    if ($86092612ee5eb68b$var$queue.length) $86092612ee5eb68b$var$drainQueue();
}
function $86092612ee5eb68b$var$drainQueue() {
    if ($86092612ee5eb68b$var$draining) return;
    var timeout = $86092612ee5eb68b$var$runTimeout($86092612ee5eb68b$var$cleanUpNextTick);
    $86092612ee5eb68b$var$draining = true;
    var len = $86092612ee5eb68b$var$queue.length;
    while(len){
        $86092612ee5eb68b$var$currentQueue = $86092612ee5eb68b$var$queue;
        $86092612ee5eb68b$var$queue = [];
        while(++$86092612ee5eb68b$var$queueIndex < len)if ($86092612ee5eb68b$var$currentQueue) $86092612ee5eb68b$var$currentQueue[$86092612ee5eb68b$var$queueIndex].run();
        $86092612ee5eb68b$var$queueIndex = -1;
        len = $86092612ee5eb68b$var$queue.length;
    }
    $86092612ee5eb68b$var$currentQueue = null;
    $86092612ee5eb68b$var$draining = false;
    $86092612ee5eb68b$var$runClearTimeout(timeout);
}
function $86092612ee5eb68b$export$7ccc53e8f1e7dfc5(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $86092612ee5eb68b$var$queue.push(new $86092612ee5eb68b$var$Item(fun, args));
    if ($86092612ee5eb68b$var$queue.length === 1 && !$86092612ee5eb68b$var$draining) $86092612ee5eb68b$var$runTimeout($86092612ee5eb68b$var$drainQueue);
}
// v8 likes predictible objects
function $86092612ee5eb68b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$86092612ee5eb68b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
var $86092612ee5eb68b$var$title = 'browser';
var $86092612ee5eb68b$var$platform = 'browser';
var $86092612ee5eb68b$var$browser = true;
var $86092612ee5eb68b$var$argv = [];
var $86092612ee5eb68b$var$version = ''; // empty string to avoid regexp issues
var $86092612ee5eb68b$var$versions = {};
var $86092612ee5eb68b$var$release = {};
var $86092612ee5eb68b$var$config = {};
function $86092612ee5eb68b$var$noop() {}
var $86092612ee5eb68b$var$on = $86092612ee5eb68b$var$noop;
var $86092612ee5eb68b$var$addListener = $86092612ee5eb68b$var$noop;
var $86092612ee5eb68b$var$once = $86092612ee5eb68b$var$noop;
var $86092612ee5eb68b$var$off = $86092612ee5eb68b$var$noop;
var $86092612ee5eb68b$var$removeListener = $86092612ee5eb68b$var$noop;
var $86092612ee5eb68b$var$removeAllListeners = $86092612ee5eb68b$var$noop;
var $86092612ee5eb68b$var$emit = $86092612ee5eb68b$var$noop;
function $86092612ee5eb68b$var$binding(name) {
    throw new Error('process.binding is not supported');
}
function $86092612ee5eb68b$var$cwd() {
    return '/';
}
function $86092612ee5eb68b$var$chdir(dir) {
    throw new Error('process.chdir is not supported');
}
function $86092612ee5eb68b$var$umask() {
    return 0;
}
// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var $86092612ee5eb68b$var$performance = $86092612ee5eb68b$var$globalContext.performance || {};
var $86092612ee5eb68b$var$performanceNow = $86092612ee5eb68b$var$performance.now || $86092612ee5eb68b$var$performance.mozNow || $86092612ee5eb68b$var$performance.msNow || $86092612ee5eb68b$var$performance.oNow || $86092612ee5eb68b$var$performance.webkitNow || function() {
    return new Date().getTime();
};
// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function $86092612ee5eb68b$var$hrtime(previousTimestamp) {
    var clocktime = $86092612ee5eb68b$var$performanceNow.call($86092612ee5eb68b$var$performance) * 1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
        seconds = seconds - previousTimestamp[0];
        nanoseconds = nanoseconds - previousTimestamp[1];
        if (nanoseconds < 0) {
            seconds--;
            nanoseconds += 1e9;
        }
    }
    return [
        seconds,
        nanoseconds
    ];
}
var $86092612ee5eb68b$var$startTime = new Date();
function $86092612ee5eb68b$var$uptime() {
    var currentTime = new Date();
    var dif = currentTime - $86092612ee5eb68b$var$startTime;
    return dif / 1000;
}
var $86092612ee5eb68b$export$ffb5f4729a158638 = {
    nextTick: $86092612ee5eb68b$export$7ccc53e8f1e7dfc5,
    title: $86092612ee5eb68b$var$title,
    browser: $86092612ee5eb68b$var$browser,
    env: {
        "NODE_ENV": "production"
    },
    argv: $86092612ee5eb68b$var$argv,
    version: $86092612ee5eb68b$var$version,
    versions: $86092612ee5eb68b$var$versions,
    on: $86092612ee5eb68b$var$on,
    addListener: $86092612ee5eb68b$var$addListener,
    once: $86092612ee5eb68b$var$once,
    off: $86092612ee5eb68b$var$off,
    removeListener: $86092612ee5eb68b$var$removeListener,
    removeAllListeners: $86092612ee5eb68b$var$removeAllListeners,
    emit: $86092612ee5eb68b$var$emit,
    binding: $86092612ee5eb68b$var$binding,
    cwd: $86092612ee5eb68b$var$cwd,
    chdir: $86092612ee5eb68b$var$chdir,
    umask: $86092612ee5eb68b$var$umask,
    hrtime: $86092612ee5eb68b$var$hrtime,
    platform: $86092612ee5eb68b$var$platform,
    release: $86092612ee5eb68b$var$release,
    config: $86092612ee5eb68b$var$config,
    uptime: $86092612ee5eb68b$var$uptime
};



var $6ZWSX = parcelRequire("6ZWSX");
var $59c911fa927d1bcf$require$Buffer = $6ZWSX.Buffer;
const $59c911fa927d1bcf$var$ALIAS = Symbol.for('yaml.alias');
const $59c911fa927d1bcf$var$DOC = Symbol.for('yaml.document');
const $59c911fa927d1bcf$var$MAP = Symbol.for('yaml.map');
const $59c911fa927d1bcf$var$PAIR = Symbol.for('yaml.pair');
const $59c911fa927d1bcf$var$SCALAR = Symbol.for('yaml.scalar');
const $59c911fa927d1bcf$var$SEQ = Symbol.for('yaml.seq');
const $59c911fa927d1bcf$var$NODE_TYPE = Symbol.for('yaml.node.type');
const $59c911fa927d1bcf$export$c6275352883a2b3e = (node)=>!!node && typeof node === 'object' && node[$59c911fa927d1bcf$var$NODE_TYPE] === $59c911fa927d1bcf$var$ALIAS;
const $59c911fa927d1bcf$export$62858bae88b53fd0 = (node)=>!!node && typeof node === 'object' && node[$59c911fa927d1bcf$var$NODE_TYPE] === $59c911fa927d1bcf$var$DOC;
const $59c911fa927d1bcf$export$5c90113a285f2241 = (node)=>!!node && typeof node === 'object' && node[$59c911fa927d1bcf$var$NODE_TYPE] === $59c911fa927d1bcf$var$MAP;
const $59c911fa927d1bcf$export$7c8d445944656308 = (node)=>!!node && typeof node === 'object' && node[$59c911fa927d1bcf$var$NODE_TYPE] === $59c911fa927d1bcf$var$PAIR;
const $59c911fa927d1bcf$export$8f3495e22775e76c = (node)=>!!node && typeof node === 'object' && node[$59c911fa927d1bcf$var$NODE_TYPE] === $59c911fa927d1bcf$var$SCALAR;
const $59c911fa927d1bcf$export$342ac1d101ffe14b = (node)=>!!node && typeof node === 'object' && node[$59c911fa927d1bcf$var$NODE_TYPE] === $59c911fa927d1bcf$var$SEQ;
function $59c911fa927d1bcf$export$cea7aa84e978eba5(node) {
    if (node && typeof node === 'object') switch(node[$59c911fa927d1bcf$var$NODE_TYPE]){
        case $59c911fa927d1bcf$var$MAP:
        case $59c911fa927d1bcf$var$SEQ:
            return true;
    }
    return false;
}
function $59c911fa927d1bcf$export$8ee0fc9ee280b4ee(node) {
    if (node && typeof node === 'object') switch(node[$59c911fa927d1bcf$var$NODE_TYPE]){
        case $59c911fa927d1bcf$var$ALIAS:
        case $59c911fa927d1bcf$var$MAP:
        case $59c911fa927d1bcf$var$SCALAR:
        case $59c911fa927d1bcf$var$SEQ:
            return true;
    }
    return false;
}
const $59c911fa927d1bcf$var$hasAnchor = (node)=>($59c911fa927d1bcf$export$8f3495e22775e76c(node) || $59c911fa927d1bcf$export$cea7aa84e978eba5(node)) && !!node.anchor;
class $59c911fa927d1bcf$var$NodeBase {
    constructor(type){
        Object.defineProperty(this, $59c911fa927d1bcf$var$NODE_TYPE, {
            value: type
        });
    }
    /** Create a copy of this node.  */ clone() {
        const copy = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
        if (this.range) copy.range = this.range.slice();
        return copy;
    }
}
const $59c911fa927d1bcf$var$BREAK = Symbol('break visit');
const $59c911fa927d1bcf$var$SKIP = Symbol('skip children');
const $59c911fa927d1bcf$var$REMOVE = Symbol('remove node');
/**
 * Apply a visitor to an AST node or document.
 *
 * Walks through the tree (depth-first) starting from `node`, calling a
 * `visitor` function with three arguments:
 *   - `key`: For sequence values and map `Pair`, the node's index in the
 *     collection. Within a `Pair`, `'key'` or `'value'`, correspondingly.
 *     `null` for the root node.
 *   - `node`: The current node.
 *   - `path`: The ancestry of the current node.
 *
 * The return value of the visitor may be used to control the traversal:
 *   - `undefined` (default): Do nothing and continue
 *   - `visit.SKIP`: Do not visit the children of this node, continue with next
 *     sibling
 *   - `visit.BREAK`: Terminate traversal completely
 *   - `visit.REMOVE`: Remove the current node, then continue with the next one
 *   - `Node`: Replace the current node, then continue by visiting it
 *   - `number`: While iterating the items of a sequence or map, set the index
 *     of the next step. This is useful especially if the index of the current
 *     node has changed.
 *
 * If `visitor` is a single function, it will be called with all values
 * encountered in the tree, including e.g. `null` values. Alternatively,
 * separate visitor functions may be defined for each `Map`, `Pair`, `Seq`,
 * `Alias` and `Scalar` node. To define the same visitor function for more than
 * one node type, use the `Collection` (map and seq), `Value` (map, seq & scalar)
 * and `Node` (alias, map, seq & scalar) targets. Of all these, only the most
 * specific defined one will be used for each node.
 */ function $59c911fa927d1bcf$export$bf638b60ea8b89b7(node, visitor) {
    if (typeof visitor === 'object' && (visitor.Collection || visitor.Node || visitor.Value)) visitor = Object.assign({
        Alias: visitor.Node,
        Map: visitor.Node,
        Scalar: visitor.Node,
        Seq: visitor.Node
    }, visitor.Value && {
        Map: visitor.Value,
        Scalar: visitor.Value,
        Seq: visitor.Value
    }, visitor.Collection && {
        Map: visitor.Collection,
        Seq: visitor.Collection
    }, visitor);
    if ($59c911fa927d1bcf$export$62858bae88b53fd0(node)) {
        const cd = $59c911fa927d1bcf$var$_visit(null, node.contents, visitor, Object.freeze([
            node
        ]));
        if (cd === $59c911fa927d1bcf$var$REMOVE) node.contents = null;
    } else $59c911fa927d1bcf$var$_visit(null, node, visitor, Object.freeze([]));
}
// Without the `as symbol` casts, TS declares these in the `visit`
// namespace using `var`, but then complains about that because
// `unique symbol` must be `const`.
/** Terminate visit traversal completely */ $59c911fa927d1bcf$export$bf638b60ea8b89b7.BREAK = $59c911fa927d1bcf$var$BREAK;
/** Do not visit the children of the current node */ $59c911fa927d1bcf$export$bf638b60ea8b89b7.SKIP = $59c911fa927d1bcf$var$SKIP;
/** Remove the current node */ $59c911fa927d1bcf$export$bf638b60ea8b89b7.REMOVE = $59c911fa927d1bcf$var$REMOVE;
function $59c911fa927d1bcf$var$_visit(key, node, visitor, path) {
    let ctrl = undefined;
    if (typeof visitor === 'function') ctrl = visitor(key, node, path);
    else if ($59c911fa927d1bcf$export$5c90113a285f2241(node)) {
        if (visitor.Map) ctrl = visitor.Map(key, node, path);
    } else if ($59c911fa927d1bcf$export$342ac1d101ffe14b(node)) {
        if (visitor.Seq) ctrl = visitor.Seq(key, node, path);
    } else if ($59c911fa927d1bcf$export$7c8d445944656308(node)) {
        if (visitor.Pair) ctrl = visitor.Pair(key, node, path);
    } else if ($59c911fa927d1bcf$export$8f3495e22775e76c(node)) {
        if (visitor.Scalar) ctrl = visitor.Scalar(key, node, path);
    } else if ($59c911fa927d1bcf$export$c6275352883a2b3e(node)) {
        if (visitor.Alias) ctrl = visitor.Alias(key, node, path);
    }
    if ($59c911fa927d1bcf$export$8ee0fc9ee280b4ee(ctrl) || $59c911fa927d1bcf$export$7c8d445944656308(ctrl)) {
        const parent = path[path.length - 1];
        if ($59c911fa927d1bcf$export$cea7aa84e978eba5(parent)) parent.items[key] = ctrl;
        else if ($59c911fa927d1bcf$export$7c8d445944656308(parent)) {
            if (key === 'key') parent.key = ctrl;
            else parent.value = ctrl;
        } else if ($59c911fa927d1bcf$export$62858bae88b53fd0(parent)) parent.contents = ctrl;
        else {
            const pt = $59c911fa927d1bcf$export$c6275352883a2b3e(parent) ? 'alias' : 'scalar';
            throw new Error(`Cannot replace node with ${pt} parent`);
        }
        return $59c911fa927d1bcf$var$_visit(key, ctrl, visitor, path);
    }
    if (typeof ctrl !== 'symbol') {
        if ($59c911fa927d1bcf$export$cea7aa84e978eba5(node)) {
            path = Object.freeze(path.concat(node));
            for(let i = 0; i < node.items.length; ++i){
                const ci = $59c911fa927d1bcf$var$_visit(i, node.items[i], visitor, path);
                if (typeof ci === 'number') i = ci - 1;
                else if (ci === $59c911fa927d1bcf$var$BREAK) return $59c911fa927d1bcf$var$BREAK;
                else if (ci === $59c911fa927d1bcf$var$REMOVE) {
                    node.items.splice(i, 1);
                    i -= 1;
                }
            }
        } else if ($59c911fa927d1bcf$export$7c8d445944656308(node)) {
            path = Object.freeze(path.concat(node));
            const ck = $59c911fa927d1bcf$var$_visit('key', node.key, visitor, path);
            if (ck === $59c911fa927d1bcf$var$BREAK) return $59c911fa927d1bcf$var$BREAK;
            else if (ck === $59c911fa927d1bcf$var$REMOVE) node.key = null;
            const cv = $59c911fa927d1bcf$var$_visit('value', node.value, visitor, path);
            if (cv === $59c911fa927d1bcf$var$BREAK) return $59c911fa927d1bcf$var$BREAK;
            else if (cv === $59c911fa927d1bcf$var$REMOVE) node.value = null;
        }
    }
    return ctrl;
}
const $59c911fa927d1bcf$var$escapeChars = {
    '!': '%21',
    ',': '%2C',
    '[': '%5B',
    ']': '%5D',
    '{': '%7B',
    '}': '%7D'
};
const $59c911fa927d1bcf$var$escapeTagName = (tn)=>tn.replace(/[!,[\]{}]/g, (ch)=>$59c911fa927d1bcf$var$escapeChars[ch]);
class $59c911fa927d1bcf$var$Directives {
    constructor(yaml, tags){
        /**
         * The directives-end/doc-start marker `---`. If `null`, a marker may still be
         * included in the document's stringified representation.
         */ this.marker = null;
        this.yaml = Object.assign({}, $59c911fa927d1bcf$var$Directives.defaultYaml, yaml);
        this.tags = Object.assign({}, $59c911fa927d1bcf$var$Directives.defaultTags, tags);
    }
    clone() {
        const copy = new $59c911fa927d1bcf$var$Directives(this.yaml, this.tags);
        copy.marker = this.marker;
        return copy;
    }
    /**
     * During parsing, get a Directives instance for the current document and
     * update the stream state according to the current version's spec.
     */ atDocument() {
        const res = new $59c911fa927d1bcf$var$Directives(this.yaml, this.tags);
        switch(this.yaml.version){
            case '1.1':
                this.atNextDocument = true;
                break;
            case '1.2':
                this.atNextDocument = false;
                this.yaml = {
                    explicit: $59c911fa927d1bcf$var$Directives.defaultYaml.explicit,
                    version: '1.2'
                };
                this.tags = Object.assign({}, $59c911fa927d1bcf$var$Directives.defaultTags);
                break;
        }
        return res;
    }
    /**
     * @param onError - May be called even if the action was successful
     * @returns `true` on success
     */ add(line, onError) {
        if (this.atNextDocument) {
            this.yaml = {
                explicit: $59c911fa927d1bcf$var$Directives.defaultYaml.explicit,
                version: '1.1'
            };
            this.tags = Object.assign({}, $59c911fa927d1bcf$var$Directives.defaultTags);
            this.atNextDocument = false;
        }
        const parts = line.trim().split(/[ \t]+/);
        const name = parts.shift();
        switch(name){
            case '%TAG':
                {
                    if (parts.length !== 2) {
                        onError(0, '%TAG directive should contain exactly two parts');
                        if (parts.length < 2) return false;
                    }
                    const [handle, prefix] = parts;
                    this.tags[handle] = prefix;
                    return true;
                }
            case '%YAML':
                {
                    this.yaml.explicit = true;
                    if (parts.length < 1) {
                        onError(0, '%YAML directive should contain exactly one part');
                        return false;
                    }
                    const [version] = parts;
                    if (version === '1.1' || version === '1.2') {
                        this.yaml.version = version;
                        return true;
                    } else {
                        onError(6, `Unsupported YAML version ${version}`, true);
                        return false;
                    }
                }
            default:
                onError(0, `Unknown directive ${name}`, true);
                return false;
        }
    }
    /**
     * Resolves a tag, matching handles to those defined in %TAG directives.
     *
     * @returns Resolved tag, which may also be the non-specific tag `'!'` or a
     *   `'!local'` tag, or `null` if unresolvable.
     */ tagName(source, onError) {
        if (source === '!') return '!'; // non-specific tag
        if (source[0] !== '!') {
            onError(`Not a valid tag: ${source}`);
            return null;
        }
        if (source[1] === '<') {
            const verbatim = source.slice(2, -1);
            if (verbatim === '!' || verbatim === '!!') {
                onError(`Verbatim tags aren't resolved, so ${source} is invalid.`);
                return null;
            }
            if (source[source.length - 1] !== '>') onError('Verbatim tags must end with a >');
            return verbatim;
        }
        const [, handle, suffix] = source.match(/^(.*!)([^!]*)$/);
        if (!suffix) onError(`The ${source} tag has no suffix`);
        const prefix = this.tags[handle];
        if (prefix) return prefix + decodeURIComponent(suffix);
        if (handle === '!') return source; // local tag
        onError(`Could not resolve tag: ${source}`);
        return null;
    }
    /**
     * Given a fully resolved tag, returns its printable string form,
     * taking into account current tag prefixes and defaults.
     */ tagString(tag) {
        for (const [handle, prefix] of Object.entries(this.tags)){
            if (tag.startsWith(prefix)) return handle + $59c911fa927d1bcf$var$escapeTagName(tag.substring(prefix.length));
        }
        return tag[0] === '!' ? tag : `!<${tag}>`;
    }
    toString(doc) {
        const lines = this.yaml.explicit ? [
            `%YAML ${this.yaml.version || '1.2'}`
        ] : [];
        const tagEntries = Object.entries(this.tags);
        let tagNames;
        if (doc && tagEntries.length > 0 && $59c911fa927d1bcf$export$8ee0fc9ee280b4ee(doc.contents)) {
            const tags = {};
            $59c911fa927d1bcf$export$bf638b60ea8b89b7(doc.contents, (_key, node)=>{
                if ($59c911fa927d1bcf$export$8ee0fc9ee280b4ee(node) && node.tag) tags[node.tag] = true;
            });
            tagNames = Object.keys(tags);
        } else tagNames = [];
        for (const [handle, prefix] of tagEntries){
            if (handle === '!!' && prefix === 'tag:yaml.org,2002:') continue;
            if (!doc || tagNames.some((tn)=>tn.startsWith(prefix))) lines.push(`%TAG ${handle} ${prefix}`);
        }
        return lines.join('\n');
    }
}
$59c911fa927d1bcf$var$Directives.defaultYaml = {
    explicit: false,
    version: '1.2'
};
$59c911fa927d1bcf$var$Directives.defaultTags = {
    '!!': 'tag:yaml.org,2002:'
};
/**
 * Verify that the input string is a valid anchor.
 *
 * Will throw on errors.
 */ function $59c911fa927d1bcf$var$anchorIsValid(anchor) {
    if (/[\x00-\x19\s,[\]{}]/.test(anchor)) {
        const sa = JSON.stringify(anchor);
        const msg = `Anchor must not contain whitespace or control characters: ${sa}`;
        throw new Error(msg);
    }
    return true;
}
function $59c911fa927d1bcf$var$anchorNames(root) {
    const anchors = new Set();
    $59c911fa927d1bcf$export$bf638b60ea8b89b7(root, {
        Value (_key, node) {
            if (node.anchor) anchors.add(node.anchor);
        }
    });
    return anchors;
}
/** Find a new anchor name with the given `prefix` and a one-indexed suffix. */ function $59c911fa927d1bcf$var$findNewAnchor(prefix, exclude) {
    for(let i = 1;; ++i){
        const name = `${prefix}${i}`;
        if (!exclude.has(name)) return name;
    }
}
function $59c911fa927d1bcf$var$createNodeAnchors(doc, prefix) {
    const aliasObjects = [];
    const sourceObjects = new Map();
    let prevAnchors = null;
    return {
        onAnchor (source) {
            aliasObjects.push(source);
            if (!prevAnchors) prevAnchors = $59c911fa927d1bcf$var$anchorNames(doc);
            const anchor = $59c911fa927d1bcf$var$findNewAnchor(prefix, prevAnchors);
            prevAnchors.add(anchor);
            return anchor;
        },
        /**
         * With circular references, the source node is only resolved after all
         * of its child nodes are. This is why anchors are set only after all of
         * the nodes have been created.
         */ setAnchors () {
            for (const source of aliasObjects){
                const ref = sourceObjects.get(source);
                if (typeof ref === 'object' && ref.anchor && ($59c911fa927d1bcf$export$8f3495e22775e76c(ref.node) || $59c911fa927d1bcf$export$cea7aa84e978eba5(ref.node))) ref.node.anchor = ref.anchor;
                else {
                    const error = new Error('Failed to resolve repeated object (this should not happen)');
                    error.source = source;
                    throw error;
                }
            }
        },
        sourceObjects: sourceObjects
    };
}
class $59c911fa927d1bcf$export$17b520249a85fe16 extends $59c911fa927d1bcf$var$NodeBase {
    constructor(source){
        super($59c911fa927d1bcf$var$ALIAS);
        this.source = source;
        Object.defineProperty(this, 'tag', {
            set () {
                throw new Error('Alias nodes cannot have tags');
            }
        });
    }
    /**
     * Resolve the value of this alias within `doc`, finding the last
     * instance of the `source` anchor before this node.
     */ resolve(doc) {
        let found = undefined;
        $59c911fa927d1bcf$export$bf638b60ea8b89b7(doc, {
            Node: (_key, node)=>{
                if (node === this) return $59c911fa927d1bcf$export$bf638b60ea8b89b7.BREAK;
                if (node.anchor === this.source) found = node;
            }
        });
        return found;
    }
    toJSON(_arg, ctx) {
        if (!ctx) return {
            source: this.source
        };
        const { anchors: anchors, doc: doc, maxAliasCount: maxAliasCount } = ctx;
        const source = this.resolve(doc);
        if (!source) {
            const msg = `Unresolved alias (the anchor must be set before the alias): ${this.source}`;
            throw new ReferenceError(msg);
        }
        const data = anchors.get(source);
        /* istanbul ignore if */ if (!data || data.res === undefined) {
            const msg = 'This should not happen: Alias anchor was not resolved?';
            throw new ReferenceError(msg);
        }
        if (maxAliasCount >= 0) {
            data.count += 1;
            if (data.aliasCount === 0) data.aliasCount = $59c911fa927d1bcf$var$getAliasCount(doc, source, anchors);
            if (data.count * data.aliasCount > maxAliasCount) {
                const msg = 'Excessive alias count indicates a resource exhaustion attack';
                throw new ReferenceError(msg);
            }
        }
        return data.res;
    }
    toString(ctx, _onComment, _onChompKeep) {
        const src = `*${this.source}`;
        if (ctx) {
            $59c911fa927d1bcf$var$anchorIsValid(this.source);
            if (ctx.options.verifyAliasOrder && !ctx.anchors.has(this.source)) {
                const msg = `Unresolved alias (the anchor must be set before the alias): ${this.source}`;
                throw new Error(msg);
            }
            if (ctx.implicitKey) return `${src} `;
        }
        return src;
    }
}
function $59c911fa927d1bcf$var$getAliasCount(doc, node, anchors) {
    if ($59c911fa927d1bcf$export$c6275352883a2b3e(node)) {
        const source = node.resolve(doc);
        const anchor = anchors && source && anchors.get(source);
        return anchor ? anchor.count * anchor.aliasCount : 0;
    } else if ($59c911fa927d1bcf$export$cea7aa84e978eba5(node)) {
        let count = 0;
        for (const item of node.items){
            const c = $59c911fa927d1bcf$var$getAliasCount(doc, item, anchors);
            if (c > count) count = c;
        }
        return count;
    } else if ($59c911fa927d1bcf$export$7c8d445944656308(node)) {
        const kc = $59c911fa927d1bcf$var$getAliasCount(doc, node.key, anchors);
        const vc = $59c911fa927d1bcf$var$getAliasCount(doc, node.value, anchors);
        return Math.max(kc, vc);
    }
    return 1;
}
/**
 * Recursively convert any node or its contents to native JavaScript
 *
 * @param value - The input value
 * @param arg - If `value` defines a `toJSON()` method, use this
 *   as its first argument
 * @param ctx - Conversion context, originally set in Document#toJS(). If
 *   `{ keep: true }` is not set, output should be suitable for JSON
 *   stringification.
 */ function $59c911fa927d1bcf$var$toJS(value, arg, ctx) {
    if (Array.isArray(value)) return value.map((v, i)=>$59c911fa927d1bcf$var$toJS(v, String(i), ctx));
    if (value && typeof value.toJSON === 'function') {
        if (!ctx || !$59c911fa927d1bcf$var$hasAnchor(value)) return value.toJSON(arg, ctx);
        const data = {
            aliasCount: 0,
            count: 1,
            res: undefined
        };
        ctx.anchors.set(value, data);
        ctx.onCreate = (res)=>{
            data.res = res;
            delete ctx.onCreate;
        };
        const res = value.toJSON(arg, ctx);
        if (ctx.onCreate) ctx.onCreate(res);
        return res;
    }
    if (typeof value === 'bigint' && !(ctx && ctx.keep)) return Number(value);
    return value;
}
const $59c911fa927d1bcf$var$isScalarValue = (value)=>!value || typeof value !== 'function' && typeof value !== 'object';
class $59c911fa927d1bcf$export$595dbf49c602a1f extends $59c911fa927d1bcf$var$NodeBase {
    constructor(value){
        super($59c911fa927d1bcf$var$SCALAR);
        this.value = value;
    }
    toJSON(arg, ctx) {
        return ctx && ctx.keep ? this.value : $59c911fa927d1bcf$var$toJS(this.value, arg, ctx);
    }
    toString() {
        return String(this.value);
    }
}
$59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_FOLDED = 'BLOCK_FOLDED';
$59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_LITERAL = 'BLOCK_LITERAL';
$59c911fa927d1bcf$export$595dbf49c602a1f.PLAIN = 'PLAIN';
$59c911fa927d1bcf$export$595dbf49c602a1f.QUOTE_DOUBLE = 'QUOTE_DOUBLE';
$59c911fa927d1bcf$export$595dbf49c602a1f.QUOTE_SINGLE = 'QUOTE_SINGLE';
const $59c911fa927d1bcf$var$defaultTagPrefix = 'tag:yaml.org,2002:';
function $59c911fa927d1bcf$var$findTagObject(value, tagName, tags) {
    if (tagName) {
        const match = tags.filter((t)=>t.tag === tagName);
        const tagObj = match.find((t)=>!t.format) || match[0];
        if (!tagObj) throw new Error(`Tag ${tagName} not found`);
        return tagObj;
    }
    return tags.find((t)=>t.identify && t.identify(value) && !t.format);
}
function $59c911fa927d1bcf$var$createNode(value, tagName, ctx) {
    var _a, _b;
    if ($59c911fa927d1bcf$export$62858bae88b53fd0(value)) value = value.contents;
    if ($59c911fa927d1bcf$export$8ee0fc9ee280b4ee(value)) return value;
    if ($59c911fa927d1bcf$export$7c8d445944656308(value)) {
        const map = (_b = (_a = ctx.schema[$59c911fa927d1bcf$var$MAP]).createNode) === null || _b === void 0 ? void 0 : _b.call(_a, ctx.schema, null, ctx);
        map.items.push(value);
        return map;
    }
    if (value instanceof String || value instanceof Number || value instanceof Boolean || typeof BigInt === 'function' && value instanceof BigInt // not supported everywhere
    ) // https://tc39.es/ecma262/#sec-serializejsonproperty
    value = value.valueOf();
    const { aliasDuplicateObjects: aliasDuplicateObjects, onAnchor: onAnchor, onTagObj: onTagObj, schema: schema, sourceObjects: sourceObjects } = ctx;
    // Detect duplicate references to the same object & use Alias nodes for all
    // after first. The `ref` wrapper allows for circular references to resolve.
    let ref = undefined;
    if (aliasDuplicateObjects && value && typeof value === 'object') {
        ref = sourceObjects.get(value);
        if (ref) {
            if (!ref.anchor) ref.anchor = onAnchor(value);
            return new $59c911fa927d1bcf$export$17b520249a85fe16(ref.anchor);
        } else {
            ref = {
                anchor: null,
                node: null
            };
            sourceObjects.set(value, ref);
        }
    }
    if (tagName && tagName.startsWith('!!')) tagName = $59c911fa927d1bcf$var$defaultTagPrefix + tagName.slice(2);
    let tagObj = $59c911fa927d1bcf$var$findTagObject(value, tagName, schema.tags);
    if (!tagObj) {
        if (value && typeof value.toJSON === 'function') value = value.toJSON();
        if (!value || typeof value !== 'object') {
            const node = new $59c911fa927d1bcf$export$595dbf49c602a1f(value);
            if (ref) ref.node = node;
            return node;
        }
        tagObj = value instanceof Map ? schema[$59c911fa927d1bcf$var$MAP] : Symbol.iterator in Object(value) ? schema[$59c911fa927d1bcf$var$SEQ] : schema[$59c911fa927d1bcf$var$MAP];
    }
    if (onTagObj) {
        onTagObj(tagObj);
        delete ctx.onTagObj;
    }
    const node = (tagObj === null || tagObj === void 0 ? void 0 : tagObj.createNode) ? tagObj.createNode(ctx.schema, value, ctx) : new $59c911fa927d1bcf$export$595dbf49c602a1f(value);
    if (tagName) node.tag = tagName;
    if (ref) ref.node = node;
    return node;
}
function $59c911fa927d1bcf$var$collectionFromPath(schema, path, value) {
    let v = value;
    for(let i = path.length - 1; i >= 0; --i){
        const k = path[i];
        if (typeof k === 'number' && Number.isInteger(k) && k >= 0) {
            const a = [];
            a[k] = v;
            v = a;
        } else v = new Map([
            [
                k,
                v
            ]
        ]);
    }
    return $59c911fa927d1bcf$var$createNode(v, undefined, {
        aliasDuplicateObjects: false,
        keepUndefined: false,
        onAnchor: ()=>{
            throw new Error('This should not happen, please report a bug.');
        },
        schema: schema,
        sourceObjects: new Map()
    });
}
// null, undefined, or an empty non-string iterable (e.g. [])
const $59c911fa927d1bcf$var$isEmptyPath = (path)=>path == null || typeof path === 'object' && !!path[Symbol.iterator]().next().done;
class $59c911fa927d1bcf$var$Collection extends $59c911fa927d1bcf$var$NodeBase {
    constructor(type, schema){
        super(type);
        Object.defineProperty(this, 'schema', {
            value: schema,
            configurable: true,
            enumerable: false,
            writable: true
        });
    }
    /**
     * Create a copy of this collection.
     *
     * @param schema - If defined, overwrites the original's schema
     */ clone(schema) {
        const copy = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
        if (schema) copy.schema = schema;
        copy.items = copy.items.map((it)=>$59c911fa927d1bcf$export$8ee0fc9ee280b4ee(it) || $59c911fa927d1bcf$export$7c8d445944656308(it) ? it.clone(schema) : it);
        if (this.range) copy.range = this.range.slice();
        return copy;
    }
    /**
     * Adds a value to the collection. For `!!map` and `!!omap` the value must
     * be a Pair instance or a `{ key, value }` object, which may not have a key
     * that already exists in the map.
     */ addIn(path, value) {
        if ($59c911fa927d1bcf$var$isEmptyPath(path)) this.add(value);
        else {
            const [key, ...rest] = path;
            const node = this.get(key, true);
            if ($59c911fa927d1bcf$export$cea7aa84e978eba5(node)) node.addIn(rest, value);
            else if (node === undefined && this.schema) this.set(key, $59c911fa927d1bcf$var$collectionFromPath(this.schema, rest, value));
            else throw new Error(`Expected YAML collection at ${key}. Remaining path: ${rest}`);
        }
    }
    /**
     * Removes a value from the collection.
     * @returns `true` if the item was found and removed.
     */ deleteIn([key, ...rest]) {
        if (rest.length === 0) return this.delete(key);
        const node = this.get(key, true);
        if ($59c911fa927d1bcf$export$cea7aa84e978eba5(node)) return node.deleteIn(rest);
        else throw new Error(`Expected YAML collection at ${key}. Remaining path: ${rest}`);
    }
    /**
     * Returns item at `key`, or `undefined` if not found. By default unwraps
     * scalar values from their surrounding node; to disable set `keepScalar` to
     * `true` (collections are always returned intact).
     */ getIn([key, ...rest], keepScalar) {
        const node = this.get(key, true);
        if (rest.length === 0) return !keepScalar && $59c911fa927d1bcf$export$8f3495e22775e76c(node) ? node.value : node;
        else return $59c911fa927d1bcf$export$cea7aa84e978eba5(node) ? node.getIn(rest, keepScalar) : undefined;
    }
    hasAllNullValues(allowScalar) {
        return this.items.every((node)=>{
            if (!$59c911fa927d1bcf$export$7c8d445944656308(node)) return false;
            const n = node.value;
            return n == null || allowScalar && $59c911fa927d1bcf$export$8f3495e22775e76c(n) && n.value == null && !n.commentBefore && !n.comment && !n.tag;
        });
    }
    /**
     * Checks if the collection includes a value with the key `key`.
     */ hasIn([key, ...rest]) {
        if (rest.length === 0) return this.has(key);
        const node = this.get(key, true);
        return $59c911fa927d1bcf$export$cea7aa84e978eba5(node) ? node.hasIn(rest) : false;
    }
    /**
     * Sets a value in this collection. For `!!set`, `value` needs to be a
     * boolean to add/remove the item from the set.
     */ setIn([key, ...rest], value) {
        if (rest.length === 0) this.set(key, value);
        else {
            const node = this.get(key, true);
            if ($59c911fa927d1bcf$export$cea7aa84e978eba5(node)) node.setIn(rest, value);
            else if (node === undefined && this.schema) this.set(key, $59c911fa927d1bcf$var$collectionFromPath(this.schema, rest, value));
            else throw new Error(`Expected YAML collection at ${key}. Remaining path: ${rest}`);
        }
    }
}
$59c911fa927d1bcf$var$Collection.maxFlowStringSingleLineLength = 60;
const $59c911fa927d1bcf$var$FOLD_FLOW = 'flow';
const $59c911fa927d1bcf$var$FOLD_BLOCK = 'block';
const $59c911fa927d1bcf$var$FOLD_QUOTED = 'quoted';
/**
 * Tries to keep input at up to `lineWidth` characters, splitting only on spaces
 * not followed by newlines or spaces unless `mode` is `'quoted'`. Lines are
 * terminated with `\n` and started with `indent`.
 */ function $59c911fa927d1bcf$var$foldFlowLines(text, indent, mode = 'flow', { indentAtStart: indentAtStart, lineWidth: lineWidth = 80, minContentWidth: minContentWidth = 20, onFold: onFold, onOverflow: onOverflow } = {}) {
    if (!lineWidth || lineWidth < 0) return text;
    const endStep = Math.max(1 + minContentWidth, 1 + lineWidth - indent.length);
    if (text.length <= endStep) return text;
    const folds = [];
    const escapedFolds = {};
    let end = lineWidth - indent.length;
    if (typeof indentAtStart === 'number') {
        if (indentAtStart > lineWidth - Math.max(2, minContentWidth)) folds.push(0);
        else end = lineWidth - indentAtStart;
    }
    let split = undefined;
    let prev = undefined;
    let overflow = false;
    let i = -1;
    let escStart = -1;
    let escEnd = -1;
    if (mode === $59c911fa927d1bcf$var$FOLD_BLOCK) {
        i = $59c911fa927d1bcf$var$consumeMoreIndentedLines(text, i);
        if (i !== -1) end = i + endStep;
    }
    for(let ch; ch = text[i += 1];){
        if (mode === $59c911fa927d1bcf$var$FOLD_QUOTED && ch === '\\') {
            escStart = i;
            switch(text[i + 1]){
                case 'x':
                    i += 3;
                    break;
                case 'u':
                    i += 5;
                    break;
                case 'U':
                    i += 9;
                    break;
                default:
                    i += 1;
            }
            escEnd = i;
        }
        if (ch === '\n') {
            if (mode === $59c911fa927d1bcf$var$FOLD_BLOCK) i = $59c911fa927d1bcf$var$consumeMoreIndentedLines(text, i);
            end = i + endStep;
            split = undefined;
        } else {
            if (ch === ' ' && prev && prev !== ' ' && prev !== '\n' && prev !== '\t') {
                // space surrounded by non-space can be replaced with newline + indent
                const next = text[i + 1];
                if (next && next !== ' ' && next !== '\n' && next !== '\t') split = i;
            }
            if (i >= end) {
                if (split) {
                    folds.push(split);
                    end = split + endStep;
                    split = undefined;
                } else if (mode === $59c911fa927d1bcf$var$FOLD_QUOTED) {
                    // white-space collected at end may stretch past lineWidth
                    while(prev === ' ' || prev === '\t'){
                        prev = ch;
                        ch = text[i += 1];
                        overflow = true;
                    }
                    // Account for newline escape, but don't break preceding escape
                    const j = i > escEnd + 1 ? i - 2 : escStart - 1;
                    // Bail out if lineWidth & minContentWidth are shorter than an escape string
                    if (escapedFolds[j]) return text;
                    folds.push(j);
                    escapedFolds[j] = true;
                    end = j + endStep;
                    split = undefined;
                } else overflow = true;
            }
        }
        prev = ch;
    }
    if (overflow && onOverflow) onOverflow();
    if (folds.length === 0) return text;
    if (onFold) onFold();
    let res = text.slice(0, folds[0]);
    for(let i = 0; i < folds.length; ++i){
        const fold = folds[i];
        const end = folds[i + 1] || text.length;
        if (fold === 0) res = `\n${indent}${text.slice(0, end)}`;
        else {
            if (mode === $59c911fa927d1bcf$var$FOLD_QUOTED && escapedFolds[fold]) res += `${text[fold]}\\`;
            res += `\n${indent}${text.slice(fold + 1, end)}`;
        }
    }
    return res;
}
/**
 * Presumes `i + 1` is at the start of a line
 * @returns index of last newline in more-indented block
 */ function $59c911fa927d1bcf$var$consumeMoreIndentedLines(text, i) {
    let ch = text[i + 1];
    while(ch === ' ' || ch === '\t'){
        do ch = text[i += 1];
        while (ch && ch !== '\n');
        ch = text[i + 1];
    }
    return i;
}
const $59c911fa927d1bcf$var$getFoldOptions = (ctx)=>({
        indentAtStart: ctx.indentAtStart,
        lineWidth: ctx.options.lineWidth,
        minContentWidth: ctx.options.minContentWidth
    });
// Also checks for lines starting with %, as parsing the output as YAML 1.1 will
// presume that's starting a new document.
const $59c911fa927d1bcf$var$containsDocumentMarker = (str)=>/^(%|---|\.\.\.)/m.test(str);
function $59c911fa927d1bcf$var$lineLengthOverLimit(str, lineWidth, indentLength) {
    if (!lineWidth || lineWidth < 0) return false;
    const limit = lineWidth - indentLength;
    const strLen = str.length;
    if (strLen <= limit) return false;
    for(let i = 0, start = 0; i < strLen; ++i)if (str[i] === '\n') {
        if (i - start > limit) return true;
        start = i + 1;
        if (strLen - start <= limit) return false;
    }
    return true;
}
function $59c911fa927d1bcf$var$doubleQuotedString(value, ctx) {
    const json = JSON.stringify(value);
    if (ctx.options.doubleQuotedAsJSON) return json;
    const { implicitKey: implicitKey } = ctx;
    const minMultiLineLength = ctx.options.doubleQuotedMinMultiLineLength;
    const indent = ctx.indent || ($59c911fa927d1bcf$var$containsDocumentMarker(value) ? '  ' : '');
    let str = '';
    let start = 0;
    for(let i = 0, ch = json[i]; ch; ch = json[++i]){
        if (ch === ' ' && json[i + 1] === '\\' && json[i + 2] === 'n') {
            // space before newline needs to be escaped to not be folded
            str += json.slice(start, i) + '\\ ';
            i += 1;
            start = i;
            ch = '\\';
        }
        if (ch === '\\') switch(json[i + 1]){
            case 'u':
                {
                    str += json.slice(start, i);
                    const code = json.substr(i + 2, 4);
                    switch(code){
                        case '0000':
                            str += '\\0';
                            break;
                        case '0007':
                            str += '\\a';
                            break;
                        case '000b':
                            str += '\\v';
                            break;
                        case '001b':
                            str += '\\e';
                            break;
                        case '0085':
                            str += '\\N';
                            break;
                        case '00a0':
                            str += '\\_';
                            break;
                        case '2028':
                            str += '\\L';
                            break;
                        case '2029':
                            str += '\\P';
                            break;
                        default:
                            if (code.substr(0, 2) === '00') str += '\\x' + code.substr(2);
                            else str += json.substr(i, 6);
                    }
                    i += 5;
                    start = i + 1;
                }
                break;
            case 'n':
                if (implicitKey || json[i + 2] === '"' || json.length < minMultiLineLength) i += 1;
                else {
                    // folding will eat first newline
                    str += json.slice(start, i) + '\n\n';
                    while(json[i + 2] === '\\' && json[i + 3] === 'n' && json[i + 4] !== '"'){
                        str += '\n';
                        i += 2;
                    }
                    str += indent;
                    // space after newline needs to be escaped to not be folded
                    if (json[i + 2] === ' ') str += '\\';
                    i += 1;
                    start = i + 1;
                }
                break;
            default:
                i += 1;
        }
    }
    str = start ? str + json.slice(start) : json;
    return implicitKey ? str : $59c911fa927d1bcf$var$foldFlowLines(str, indent, $59c911fa927d1bcf$var$FOLD_QUOTED, $59c911fa927d1bcf$var$getFoldOptions(ctx));
}
function $59c911fa927d1bcf$var$singleQuotedString(value, ctx) {
    if (ctx.implicitKey) {
        if (/\n/.test(value)) return $59c911fa927d1bcf$var$doubleQuotedString(value, ctx);
    } else {
        // single quoted string can't have leading or trailing whitespace around newline
        if (/[ \t]\n|\n[ \t]/.test(value)) return $59c911fa927d1bcf$var$doubleQuotedString(value, ctx);
    }
    const indent = ctx.indent || ($59c911fa927d1bcf$var$containsDocumentMarker(value) ? '  ' : '');
    const res = "'" + value.replace(/'/g, "''").replace(/\n+/g, `$&\n${indent}`) + "'";
    return ctx.implicitKey ? res : $59c911fa927d1bcf$var$foldFlowLines(res, indent, $59c911fa927d1bcf$var$FOLD_FLOW, $59c911fa927d1bcf$var$getFoldOptions(ctx));
}
function $59c911fa927d1bcf$var$blockString({ comment: comment, type: type, value: value }, ctx, onComment, onChompKeep) {
    // 1. Block can't end in whitespace unless the last line is non-empty.
    // 2. Strings consisting of only whitespace are best rendered explicitly.
    if (/\n[\t ]+$/.test(value) || /^\s*$/.test(value)) return $59c911fa927d1bcf$var$doubleQuotedString(value, ctx);
    const indent = ctx.indent || (ctx.forceBlockIndent || $59c911fa927d1bcf$var$containsDocumentMarker(value) ? '  ' : '');
    const literal = type === $59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_FOLDED ? false : type === $59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_LITERAL ? true : !$59c911fa927d1bcf$var$lineLengthOverLimit(value, ctx.options.lineWidth, indent.length);
    if (!value) return literal ? '|\n' : '>\n';
    // determine chomping from whitespace at value end
    let chomp;
    let endStart;
    for(endStart = value.length; endStart > 0; --endStart){
        const ch = value[endStart - 1];
        if (ch !== '\n' && ch !== '\t' && ch !== ' ') break;
    }
    let end = value.substring(endStart);
    const endNlPos = end.indexOf('\n');
    if (endNlPos === -1) chomp = '-'; // strip
    else if (value === end || endNlPos !== end.length - 1) {
        chomp = '+'; // keep
        if (onChompKeep) onChompKeep();
    } else chomp = ''; // clip
    if (end) {
        value = value.slice(0, -end.length);
        if (end[end.length - 1] === '\n') end = end.slice(0, -1);
        end = end.replace(/\n+(?!\n|$)/g, `$&${indent}`);
    }
    // determine indent indicator from whitespace at value start
    let startWithSpace = false;
    let startEnd;
    let startNlPos = -1;
    for(startEnd = 0; startEnd < value.length; ++startEnd){
        const ch = value[startEnd];
        if (ch === ' ') startWithSpace = true;
        else if (ch === '\n') startNlPos = startEnd;
        else break;
    }
    let start = value.substring(0, startNlPos < startEnd ? startNlPos + 1 : startEnd);
    if (start) {
        value = value.substring(start.length);
        start = start.replace(/\n+/g, `$&${indent}`);
    }
    const indentSize = indent ? '2' : '1'; // root is at -1
    let header = (literal ? '|' : '>') + (startWithSpace ? indentSize : '') + chomp;
    if (comment) {
        header += ' #' + comment.replace(/ ?[\r\n]+/g, ' ');
        if (onComment) onComment();
    }
    if (literal) {
        value = value.replace(/\n+/g, `$&${indent}`);
        return `${header}\n${indent}${start}${value}${end}`;
    }
    value = value.replace(/\n+/g, '\n$&').replace(/(?:^|\n)([\t ].*)(?:([\n\t ]*)\n(?![\n\t ]))?/g, '$1$2') // more-indented lines aren't folded
    //                ^ more-ind. ^ empty     ^ capture next empty lines only at end of indent
    .replace(/\n+/g, `$&${indent}`);
    const body = $59c911fa927d1bcf$var$foldFlowLines(`${start}${value}${end}`, indent, $59c911fa927d1bcf$var$FOLD_BLOCK, $59c911fa927d1bcf$var$getFoldOptions(ctx));
    return `${header}\n${indent}${body}`;
}
function $59c911fa927d1bcf$var$plainString(item, ctx, onComment, onChompKeep) {
    var _a;
    const { type: type, value: value } = item;
    const { actualString: actualString, implicitKey: implicitKey, indent: indent, inFlow: inFlow } = ctx;
    if (implicitKey && /[\n[\]{},]/.test(value) || inFlow && /[[\]{},]/.test(value)) return $59c911fa927d1bcf$var$doubleQuotedString(value, ctx);
    if (!value || /^[\n\t ,[\]{}#&*!|>'"%@`]|^[?-]$|^[?-][ \t]|[\n:][ \t]|[ \t]\n|[\n\t ]#|[\n\t :]$/.test(value)) {
        const hasDouble = value.indexOf('"') !== -1;
        const hasSingle = value.indexOf("'") !== -1;
        let quotedString;
        if (hasDouble && !hasSingle) quotedString = $59c911fa927d1bcf$var$singleQuotedString;
        else if (hasSingle && !hasDouble) quotedString = $59c911fa927d1bcf$var$doubleQuotedString;
        else if (ctx.options.singleQuote) quotedString = $59c911fa927d1bcf$var$singleQuotedString;
        else quotedString = $59c911fa927d1bcf$var$doubleQuotedString;
        // not allowed:
        // - empty string, '-' or '?'
        // - start with an indicator character (except [?:-]) or /[?-] /
        // - '\n ', ': ' or ' \n' anywhere
        // - '#' not preceded by a non-space char
        // - end with ' ' or ':'
        return implicitKey || inFlow || value.indexOf('\n') === -1 ? quotedString(value, ctx) : $59c911fa927d1bcf$var$blockString(item, ctx, onComment, onChompKeep);
    }
    if (!implicitKey && !inFlow && type !== $59c911fa927d1bcf$export$595dbf49c602a1f.PLAIN && value.indexOf('\n') !== -1) // Where allowed & type not set explicitly, prefer block style for multiline strings
    return $59c911fa927d1bcf$var$blockString(item, ctx, onComment, onChompKeep);
    if (indent === '' && $59c911fa927d1bcf$var$containsDocumentMarker(value)) {
        ctx.forceBlockIndent = true;
        return $59c911fa927d1bcf$var$blockString(item, ctx, onComment, onChompKeep);
    }
    const str = value.replace(/\n+/g, `$&\n${indent}`);
    // Verify that output will be parsed as a string, as e.g. plain numbers and
    // booleans get parsed with those types in v1.2 (e.g. '42', 'true' & '0.9e-3'),
    // and others in v1.1.
    if (actualString) for (const tag of ctx.doc.schema.tags){
        if (tag.default && tag.tag !== 'tag:yaml.org,2002:str' && ((_a = tag.test) === null || _a === void 0 ? void 0 : _a.test(str))) return $59c911fa927d1bcf$var$doubleQuotedString(value, ctx);
    }
    return implicitKey ? str : $59c911fa927d1bcf$var$foldFlowLines(str, indent, $59c911fa927d1bcf$var$FOLD_FLOW, $59c911fa927d1bcf$var$getFoldOptions(ctx));
}
function $59c911fa927d1bcf$var$stringifyString(item, ctx, onComment, onChompKeep) {
    const { implicitKey: implicitKey, inFlow: inFlow } = ctx;
    const ss = typeof item.value === 'string' ? item : Object.assign({}, item, {
        value: String(item.value)
    });
    let { type: type } = item;
    if (type !== $59c911fa927d1bcf$export$595dbf49c602a1f.QUOTE_DOUBLE) // force double quotes on control characters & unpaired surrogates
    {
        if (/[\x00-\x08\x0b-\x1f\x7f-\x9f\u{D800}-\u{DFFF}]/u.test(ss.value)) type = $59c911fa927d1bcf$export$595dbf49c602a1f.QUOTE_DOUBLE;
    }
    const _stringify = (_type)=>{
        switch(_type){
            case $59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_FOLDED:
            case $59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_LITERAL:
                return implicitKey || inFlow ? $59c911fa927d1bcf$var$doubleQuotedString(ss.value, ctx) // blocks are not valid inside flow containers
                 : $59c911fa927d1bcf$var$blockString(ss, ctx, onComment, onChompKeep);
            case $59c911fa927d1bcf$export$595dbf49c602a1f.QUOTE_DOUBLE:
                return $59c911fa927d1bcf$var$doubleQuotedString(ss.value, ctx);
            case $59c911fa927d1bcf$export$595dbf49c602a1f.QUOTE_SINGLE:
                return $59c911fa927d1bcf$var$singleQuotedString(ss.value, ctx);
            case $59c911fa927d1bcf$export$595dbf49c602a1f.PLAIN:
                return $59c911fa927d1bcf$var$plainString(ss, ctx, onComment, onChompKeep);
            default:
                return null;
        }
    };
    let res = _stringify(type);
    if (res === null) {
        const { defaultKeyType: defaultKeyType, defaultStringType: defaultStringType } = ctx.options;
        const t = implicitKey && defaultKeyType || defaultStringType;
        res = _stringify(t);
        if (res === null) throw new Error(`Unsupported default string type ${t}`);
    }
    return res;
}
const $59c911fa927d1bcf$var$createStringifyContext = (doc, options)=>({
        anchors: new Set(),
        doc: doc,
        indent: '',
        indentStep: typeof options.indent === 'number' ? ' '.repeat(options.indent) : '  ',
        options: Object.assign({
            defaultKeyType: null,
            defaultStringType: 'PLAIN',
            directives: null,
            doubleQuotedAsJSON: false,
            doubleQuotedMinMultiLineLength: 40,
            falseStr: 'false',
            indentSeq: true,
            lineWidth: 80,
            minContentWidth: 20,
            nullStr: 'null',
            simpleKeys: false,
            singleQuote: false,
            trueStr: 'true',
            verifyAliasOrder: true
        }, options)
    });
function $59c911fa927d1bcf$var$getTagObject(tags, item) {
    if (item.tag) {
        const match = tags.filter((t)=>t.tag === item.tag);
        if (match.length > 0) return match.find((t)=>t.format === item.format) || match[0];
    }
    let tagObj = undefined;
    let obj;
    if ($59c911fa927d1bcf$export$8f3495e22775e76c(item)) {
        obj = item.value;
        const match = tags.filter((t)=>t.identify && t.identify(obj));
        tagObj = match.find((t)=>t.format === item.format) || match.find((t)=>!t.format);
    } else {
        obj = item;
        tagObj = tags.find((t)=>t.nodeClass && obj instanceof t.nodeClass);
    }
    if (!tagObj) {
        // @ts-ignore
        const name = obj && obj.constructor ? obj.constructor.name : typeof obj;
        throw new Error(`Tag not resolved for ${name} value`);
    }
    return tagObj;
}
// needs to be called before value stringifier to allow for circular anchor refs
function $59c911fa927d1bcf$var$stringifyProps(node, tagObj, { anchors: anchors, doc: doc }) {
    const props = [];
    const anchor = ($59c911fa927d1bcf$export$8f3495e22775e76c(node) || $59c911fa927d1bcf$export$cea7aa84e978eba5(node)) && node.anchor;
    if (anchor && $59c911fa927d1bcf$var$anchorIsValid(anchor)) {
        anchors.add(anchor);
        props.push(`&${anchor}`);
    }
    if (node.tag) props.push(doc.directives.tagString(node.tag));
    else if (!tagObj.default) props.push(doc.directives.tagString(tagObj.tag));
    return props.join(' ');
}
function $59c911fa927d1bcf$var$stringify(item, ctx, onComment, onChompKeep) {
    if ($59c911fa927d1bcf$export$7c8d445944656308(item)) return item.toString(ctx, onComment, onChompKeep);
    if ($59c911fa927d1bcf$export$c6275352883a2b3e(item)) return item.toString(ctx);
    let tagObj = undefined;
    const node = $59c911fa927d1bcf$export$8ee0fc9ee280b4ee(item) ? item : ctx.doc.createNode(item, {
        onTagObj: (o)=>tagObj = o
    });
    if (!tagObj) tagObj = $59c911fa927d1bcf$var$getTagObject(ctx.doc.schema.tags, node);
    const props = $59c911fa927d1bcf$var$stringifyProps(node, tagObj, ctx);
    if (props.length > 0) ctx.indentAtStart = (ctx.indentAtStart || 0) + props.length + 1;
    const str = typeof tagObj.stringify === 'function' ? tagObj.stringify(node, ctx, onComment, onChompKeep) : $59c911fa927d1bcf$export$8f3495e22775e76c(node) ? $59c911fa927d1bcf$var$stringifyString(node, ctx, onComment, onChompKeep) : node.toString(ctx, onComment, onChompKeep);
    if (!props) return str;
    return $59c911fa927d1bcf$export$8f3495e22775e76c(node) || str[0] === '{' || str[0] === '[' ? `${props} ${str}` : `${props}\n${ctx.indent}${str}`;
}
const $59c911fa927d1bcf$var$stringifyComment = (comment, indent)=>/^\n+$/.test(comment) ? comment.substring(1) : comment.replace(/^(?!$)(?: $)?/gm, `${indent}#`);
function $59c911fa927d1bcf$var$addComment(str, indent, comment) {
    return !comment ? str : comment.includes('\n') ? `${str}\n` + $59c911fa927d1bcf$var$stringifyComment(comment, indent) : str.endsWith(' ') ? `${str}#${comment}` : `${str} #${comment}`;
}
function $59c911fa927d1bcf$var$stringifyPair({ key: key, value: value }, ctx, onComment, onChompKeep) {
    const { allNullValues: allNullValues, doc: doc, indent: indent, indentStep: indentStep, options: { indentSeq: indentSeq, simpleKeys: simpleKeys } } = ctx;
    let keyComment = $59c911fa927d1bcf$export$8ee0fc9ee280b4ee(key) && key.comment || null;
    if (simpleKeys) {
        if (keyComment) throw new Error('With simple keys, key nodes cannot have comments');
        if ($59c911fa927d1bcf$export$cea7aa84e978eba5(key)) {
            const msg = 'With simple keys, collection cannot be used as a key value';
            throw new Error(msg);
        }
    }
    let explicitKey = !simpleKeys && (!key || keyComment && value == null && !ctx.inFlow || $59c911fa927d1bcf$export$cea7aa84e978eba5(key) || ($59c911fa927d1bcf$export$8f3495e22775e76c(key) ? key.type === $59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_FOLDED || key.type === $59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_LITERAL : typeof key === 'object'));
    ctx = Object.assign({}, ctx, {
        allNullValues: false,
        implicitKey: !explicitKey && (simpleKeys || !allNullValues),
        indent: indent + indentStep
    });
    let keyCommentDone = false;
    let chompKeep = false;
    let str = $59c911fa927d1bcf$var$stringify(key, ctx, ()=>keyCommentDone = true, ()=>chompKeep = true);
    if (!explicitKey && !ctx.inFlow && str.length > 1024) {
        if (simpleKeys) throw new Error('With simple keys, single line scalar must not span more than 1024 characters');
        explicitKey = true;
    }
    if (ctx.inFlow) {
        if (allNullValues || value == null) {
            if (keyCommentDone && onComment) onComment();
            return explicitKey ? `? ${str}` : str;
        }
    } else if (allNullValues && !simpleKeys || value == null && explicitKey) {
        if (keyCommentDone) keyComment = null;
        if (chompKeep && !keyComment && onChompKeep) onChompKeep();
        return $59c911fa927d1bcf$var$addComment(`? ${str}`, ctx.indent, keyComment);
    }
    if (keyCommentDone) keyComment = null;
    str = explicitKey ? `? ${$59c911fa927d1bcf$var$addComment(str, ctx.indent, keyComment)}\n${indent}:` : $59c911fa927d1bcf$var$addComment(`${str}:`, ctx.indent, keyComment);
    let vcb = '';
    let valueComment = null;
    if ($59c911fa927d1bcf$export$8ee0fc9ee280b4ee(value)) {
        if (value.spaceBefore) vcb = '\n';
        if (value.commentBefore) vcb += `\n${$59c911fa927d1bcf$var$stringifyComment(value.commentBefore, ctx.indent)}`;
        valueComment = value.comment;
    } else if (value && typeof value === 'object') value = doc.createNode(value);
    ctx.implicitKey = false;
    if (!explicitKey && !keyComment && $59c911fa927d1bcf$export$8f3495e22775e76c(value)) ctx.indentAtStart = str.length + 1;
    chompKeep = false;
    if (!indentSeq && indentStep.length >= 2 && !ctx.inFlow && !explicitKey && $59c911fa927d1bcf$export$342ac1d101ffe14b(value) && !value.flow && !value.tag && !value.anchor) // If indentSeq === false, consider '- ' as part of indentation where possible
    ctx.indent = ctx.indent.substr(2);
    let valueCommentDone = false;
    const valueStr = $59c911fa927d1bcf$var$stringify(value, ctx, ()=>valueCommentDone = true, ()=>chompKeep = true);
    let ws = ' ';
    if (vcb || keyComment) ws = `${vcb}\n${ctx.indent}`;
    else if (!explicitKey && $59c911fa927d1bcf$export$cea7aa84e978eba5(value)) {
        const flow = valueStr[0] === '[' || valueStr[0] === '{';
        if (!flow || valueStr.includes('\n')) ws = `\n${ctx.indent}`;
    } else if (valueStr[0] === '\n') ws = '';
    if (ctx.inFlow) {
        if (valueCommentDone && onComment) onComment();
        return str + ws + valueStr;
    } else {
        if (valueCommentDone) valueComment = null;
        if (chompKeep && !valueComment && onChompKeep) onChompKeep();
        return $59c911fa927d1bcf$var$addComment(str + ws + valueStr, ctx.indent, valueComment);
    }
}
function $59c911fa927d1bcf$var$warn(logLevel, warning) {
    if (logLevel === 'debug' || logLevel === 'warn') {
        if (typeof (0, $86092612ee5eb68b$export$ffb5f4729a158638) !== 'undefined' && (0, $86092612ee5eb68b$export$ffb5f4729a158638).emitWarning) (0, $86092612ee5eb68b$export$ffb5f4729a158638).emitWarning(warning);
        else console.warn(warning);
    }
}
const $59c911fa927d1bcf$var$MERGE_KEY = '<<';
function $59c911fa927d1bcf$var$addPairToJSMap(ctx, map, { key: key, value: value }) {
    if (ctx && ctx.doc.schema.merge && $59c911fa927d1bcf$var$isMergeKey(key)) {
        if ($59c911fa927d1bcf$export$342ac1d101ffe14b(value)) for (const it of value.items)$59c911fa927d1bcf$var$mergeToJSMap(ctx, map, it);
        else if (Array.isArray(value)) for (const it of value)$59c911fa927d1bcf$var$mergeToJSMap(ctx, map, it);
        else $59c911fa927d1bcf$var$mergeToJSMap(ctx, map, value);
    } else {
        const jsKey = $59c911fa927d1bcf$var$toJS(key, '', ctx);
        if (map instanceof Map) map.set(jsKey, $59c911fa927d1bcf$var$toJS(value, jsKey, ctx));
        else if (map instanceof Set) map.add(jsKey);
        else {
            const stringKey = $59c911fa927d1bcf$var$stringifyKey(key, jsKey, ctx);
            const jsValue = $59c911fa927d1bcf$var$toJS(value, stringKey, ctx);
            if (stringKey in map) Object.defineProperty(map, stringKey, {
                value: jsValue,
                writable: true,
                enumerable: true,
                configurable: true
            });
            else map[stringKey] = jsValue;
        }
    }
    return map;
}
const $59c911fa927d1bcf$var$isMergeKey = (key)=>key === $59c911fa927d1bcf$var$MERGE_KEY || $59c911fa927d1bcf$export$8f3495e22775e76c(key) && key.value === $59c911fa927d1bcf$var$MERGE_KEY && (!key.type || key.type === $59c911fa927d1bcf$export$595dbf49c602a1f.PLAIN);
// If the value associated with a merge key is a single mapping node, each of
// its key/value pairs is inserted into the current mapping, unless the key
// already exists in it. If the value associated with the merge key is a
// sequence, then this sequence is expected to contain mapping nodes and each
// of these nodes is merged in turn according to its order in the sequence.
// Keys in mapping nodes earlier in the sequence override keys specified in
// later mapping nodes. -- http://yaml.org/type/merge.html
function $59c911fa927d1bcf$var$mergeToJSMap(ctx, map, value) {
    const source = ctx && $59c911fa927d1bcf$export$c6275352883a2b3e(value) ? value.resolve(ctx.doc) : value;
    if (!$59c911fa927d1bcf$export$5c90113a285f2241(source)) throw new Error('Merge sources must be maps or map aliases');
    const srcMap = source.toJSON(null, ctx, Map);
    for (const [key, value] of srcMap){
        if (map instanceof Map) {
            if (!map.has(key)) map.set(key, value);
        } else if (map instanceof Set) map.add(key);
        else if (!Object.prototype.hasOwnProperty.call(map, key)) Object.defineProperty(map, key, {
            value: value,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }
    return map;
}
function $59c911fa927d1bcf$var$stringifyKey(key, jsKey, ctx) {
    if (jsKey === null) return '';
    if (typeof jsKey !== 'object') return String(jsKey);
    if ($59c911fa927d1bcf$export$8ee0fc9ee280b4ee(key) && ctx && ctx.doc) {
        const strCtx = $59c911fa927d1bcf$var$createStringifyContext(ctx.doc, {});
        strCtx.anchors = new Set();
        for (const node of ctx.anchors.keys())strCtx.anchors.add(node.anchor);
        strCtx.inFlow = true;
        strCtx.inStringifyKey = true;
        const strKey = key.toString(strCtx);
        if (!ctx.mapKeyWarned) {
            let jsonStr = JSON.stringify(strKey);
            if (jsonStr.length > 40) jsonStr = jsonStr.substring(0, 36) + '..."';
            $59c911fa927d1bcf$var$warn(ctx.doc.options.logLevel, `Keys with collection values will be stringified due to JS Object restrictions: ${jsonStr}. Set mapAsMap: true to use object keys.`);
            ctx.mapKeyWarned = true;
        }
        return strKey;
    }
    return JSON.stringify(jsKey);
}
function $59c911fa927d1bcf$var$createPair(key, value, ctx) {
    const k = $59c911fa927d1bcf$var$createNode(key, undefined, ctx);
    const v = $59c911fa927d1bcf$var$createNode(value, undefined, ctx);
    return new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(k, v);
}
class $59c911fa927d1bcf$export$d63d7cff08fe4dc9 {
    constructor(key, value = null){
        Object.defineProperty(this, $59c911fa927d1bcf$var$NODE_TYPE, {
            value: $59c911fa927d1bcf$var$PAIR
        });
        this.key = key;
        this.value = value;
    }
    clone(schema) {
        let { key: key, value: value } = this;
        if ($59c911fa927d1bcf$export$8ee0fc9ee280b4ee(key)) key = key.clone(schema);
        if ($59c911fa927d1bcf$export$8ee0fc9ee280b4ee(value)) value = value.clone(schema);
        return new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(key, value);
    }
    toJSON(_, ctx) {
        const pair = ctx && ctx.mapAsMap ? new Map() : {};
        return $59c911fa927d1bcf$var$addPairToJSMap(ctx, pair, this);
    }
    toString(ctx, onComment, onChompKeep) {
        return ctx && ctx.doc ? $59c911fa927d1bcf$var$stringifyPair(this, ctx, onComment, onChompKeep) : JSON.stringify(this);
    }
}
/**
 * `yaml` defines document-specific options in three places: as an argument of
 * parse, create and stringify calls, in the values of `YAML.defaultOptions`,
 * and in the version-dependent `YAML.Document.defaults` object. Values set in
 * `YAML.defaultOptions` override version-dependent defaults, and argument
 * options override both.
 */ const $59c911fa927d1bcf$export$ba43bf67f3d48107 = {
    intAsBigInt: false,
    logLevel: 'warn',
    prettyErrors: true,
    strict: true,
    uniqueKeys: true,
    version: '1.2'
};
function $59c911fa927d1bcf$var$stringifyCollection({ comment: comment, flow: flow, items: items }, ctx, { blockItem: blockItem, flowChars: flowChars, itemIndent: itemIndent, onChompKeep: onChompKeep, onComment: onComment }) {
    const { indent: indent, indentStep: indentStep } = ctx;
    const inFlow = flow || ctx.inFlow;
    if (inFlow) itemIndent += indentStep;
    ctx = Object.assign({}, ctx, {
        indent: itemIndent,
        inFlow: inFlow,
        type: null
    });
    let singleLineOutput = true;
    let chompKeep = false; // flag for the preceding node's status
    const nodes = items.reduce((nodes, item, i)=>{
        let comment = null;
        if ($59c911fa927d1bcf$export$8ee0fc9ee280b4ee(item)) {
            if (!chompKeep && item.spaceBefore) nodes.push({
                comment: true,
                str: ''
            });
            let cb = item.commentBefore;
            if (cb && chompKeep) cb = cb.replace(/^\n+/, '');
            if (cb) {
                if (/^\n+$/.test(cb)) cb = cb.substring(1);
                // This match will always succeed on a non-empty string
                for (const line of cb.match(/^.*$/gm)){
                    const str = line === ' ' ? '#' : line ? `#${line}` : '';
                    nodes.push({
                        comment: true,
                        str: str
                    });
                }
            }
            if (item.comment) {
                comment = item.comment;
                singleLineOutput = false;
            }
        } else if ($59c911fa927d1bcf$export$7c8d445944656308(item)) {
            const ik = $59c911fa927d1bcf$export$8ee0fc9ee280b4ee(item.key) ? item.key : null;
            if (ik) {
                if (!chompKeep && ik.spaceBefore) nodes.push({
                    comment: true,
                    str: ''
                });
                let cb = ik.commentBefore;
                if (cb && chompKeep) cb = cb.replace(/^\n+/, '');
                if (cb) {
                    if (/^\n+$/.test(cb)) cb = cb.substring(1);
                    // This match will always succeed on a non-empty string
                    for (const line of cb.match(/^.*$/gm)){
                        const str = line === ' ' ? '#' : line ? `#${line}` : '';
                        nodes.push({
                            comment: true,
                            str: str
                        });
                    }
                }
                if (ik.comment) singleLineOutput = false;
            }
            if (inFlow) {
                const iv = $59c911fa927d1bcf$export$8ee0fc9ee280b4ee(item.value) ? item.value : null;
                if (iv) {
                    if (iv.comment) comment = iv.comment;
                    if (iv.comment || iv.commentBefore) singleLineOutput = false;
                } else if (item.value == null && ik && ik.comment) comment = ik.comment;
            }
        }
        chompKeep = false;
        let str = $59c911fa927d1bcf$var$stringify(item, ctx, ()=>comment = null, ()=>chompKeep = true);
        if (inFlow && i < items.length - 1) str += ',';
        str = $59c911fa927d1bcf$var$addComment(str, itemIndent, comment);
        if (chompKeep && (comment || inFlow)) chompKeep = false;
        nodes.push({
            comment: false,
            str: str
        });
        return nodes;
    }, []);
    let str;
    if (nodes.length === 0) str = flowChars.start + flowChars.end;
    else if (inFlow) {
        const { start: start, end: end } = flowChars;
        const strings = nodes.map((n)=>n.str);
        let singleLineLength = 2;
        for (const node of nodes){
            if (node.comment || node.str.includes('\n')) {
                singleLineOutput = false;
                break;
            }
            singleLineLength += node.str.length + 2;
        }
        if (!singleLineOutput || singleLineLength > $59c911fa927d1bcf$var$Collection.maxFlowStringSingleLineLength) {
            str = start;
            for (const s of strings)str += s ? `\n${indentStep}${indent}${s}` : '\n';
            str += `\n${indent}${end}`;
        } else str = `${start} ${strings.join(' ')} ${end}`;
    } else {
        const strings = nodes.map(blockItem);
        str = strings.shift() || '';
        for (const s of strings)str += s ? `\n${indent}${s}` : '\n';
    }
    if (comment) {
        str += '\n' + $59c911fa927d1bcf$var$stringifyComment(comment, indent);
        if (onComment) onComment();
    } else if (chompKeep && onChompKeep) onChompKeep();
    return str;
}
function $59c911fa927d1bcf$var$findPair(items, key) {
    const k = $59c911fa927d1bcf$export$8f3495e22775e76c(key) ? key.value : key;
    for (const it of items)if ($59c911fa927d1bcf$export$7c8d445944656308(it)) {
        if (it.key === key || it.key === k) return it;
        if ($59c911fa927d1bcf$export$8f3495e22775e76c(it.key) && it.key.value === k) return it;
    }
    return undefined;
}
class $59c911fa927d1bcf$export$eb1691c4b19bb5eb extends $59c911fa927d1bcf$var$Collection {
    constructor(schema){
        super($59c911fa927d1bcf$var$MAP, schema);
        this.items = [];
    }
    static get tagName() {
        return 'tag:yaml.org,2002:map';
    }
    /**
     * Adds a value to the collection.
     *
     * @param overwrite - If not set `true`, using a key that is already in the
     *   collection will throw. Otherwise, overwrites the previous value.
     */ add(pair, overwrite) {
        let _pair;
        if ($59c911fa927d1bcf$export$7c8d445944656308(pair)) _pair = pair;
        else if (!pair || typeof pair !== 'object' || !('key' in pair)) // In TypeScript, this never happens.
        _pair = new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(pair, pair.value);
        else _pair = new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(pair.key, pair.value);
        const prev = $59c911fa927d1bcf$var$findPair(this.items, _pair.key);
        const sortEntries = this.schema && this.schema.sortMapEntries;
        if (prev) {
            if (!overwrite) throw new Error(`Key ${_pair.key} already set`);
            // For scalars, keep the old node & its comments and anchors
            if ($59c911fa927d1bcf$export$8f3495e22775e76c(prev.value) && $59c911fa927d1bcf$var$isScalarValue(_pair.value)) prev.value.value = _pair.value;
            else prev.value = _pair.value;
        } else if (sortEntries) {
            const i = this.items.findIndex((item)=>sortEntries(_pair, item) < 0);
            if (i === -1) this.items.push(_pair);
            else this.items.splice(i, 0, _pair);
        } else this.items.push(_pair);
    }
    delete(key) {
        const it = $59c911fa927d1bcf$var$findPair(this.items, key);
        if (!it) return false;
        const del = this.items.splice(this.items.indexOf(it), 1);
        return del.length > 0;
    }
    get(key, keepScalar) {
        const it = $59c911fa927d1bcf$var$findPair(this.items, key);
        const node = it && it.value;
        return !keepScalar && $59c911fa927d1bcf$export$8f3495e22775e76c(node) ? node.value : node;
    }
    has(key) {
        return !!$59c911fa927d1bcf$var$findPair(this.items, key);
    }
    set(key, value) {
        this.add(new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(key, value), true);
    }
    /**
     * @param ctx - Conversion context, originally set in Document#toJS()
     * @param {Class} Type - If set, forces the returned collection type
     * @returns Instance of Type, Map, or Object
     */ toJSON(_, ctx, Type) {
        const map = Type ? new Type() : ctx && ctx.mapAsMap ? new Map() : {};
        if (ctx && ctx.onCreate) ctx.onCreate(map);
        for (const item of this.items)$59c911fa927d1bcf$var$addPairToJSMap(ctx, map, item);
        return map;
    }
    toString(ctx, onComment, onChompKeep) {
        if (!ctx) return JSON.stringify(this);
        for (const item of this.items){
            if (!$59c911fa927d1bcf$export$7c8d445944656308(item)) throw new Error(`Map items must all be pairs; found ${JSON.stringify(item)} instead`);
        }
        if (!ctx.allNullValues && this.hasAllNullValues(false)) ctx = Object.assign({}, ctx, {
            allNullValues: true
        });
        return $59c911fa927d1bcf$var$stringifyCollection(this, ctx, {
            blockItem: (n)=>n.str,
            flowChars: {
                start: '{',
                end: '}'
            },
            itemIndent: ctx.indent || '',
            onChompKeep: onChompKeep,
            onComment: onComment
        });
    }
}
function $59c911fa927d1bcf$var$createMap(schema, obj, ctx) {
    const { keepUndefined: keepUndefined, replacer: replacer } = ctx;
    const map = new $59c911fa927d1bcf$export$eb1691c4b19bb5eb(schema);
    const add = (key, value)=>{
        if (typeof replacer === 'function') value = replacer.call(obj, key, value);
        else if (Array.isArray(replacer) && !replacer.includes(key)) return;
        if (value !== undefined || keepUndefined) map.items.push($59c911fa927d1bcf$var$createPair(key, value, ctx));
    };
    if (obj instanceof Map) for (const [key, value] of obj)add(key, value);
    else if (obj && typeof obj === 'object') for (const key of Object.keys(obj))add(key, obj[key]);
    if (typeof schema.sortMapEntries === 'function') map.items.sort(schema.sortMapEntries);
    return map;
}
const $59c911fa927d1bcf$var$map = {
    collection: 'map',
    createNode: $59c911fa927d1bcf$var$createMap,
    default: true,
    nodeClass: $59c911fa927d1bcf$export$eb1691c4b19bb5eb,
    tag: 'tag:yaml.org,2002:map',
    resolve (map, onError) {
        if (!$59c911fa927d1bcf$export$5c90113a285f2241(map)) onError('Expected a mapping for this tag');
        return map;
    }
};
class $59c911fa927d1bcf$export$47adc25f769055b2 extends $59c911fa927d1bcf$var$Collection {
    constructor(schema){
        super($59c911fa927d1bcf$var$SEQ, schema);
        this.items = [];
    }
    static get tagName() {
        return 'tag:yaml.org,2002:seq';
    }
    add(value) {
        this.items.push(value);
    }
    /**
     * Removes a value from the collection.
     *
     * `key` must contain a representation of an integer for this to succeed.
     * It may be wrapped in a `Scalar`.
     *
     * @returns `true` if the item was found and removed.
     */ delete(key) {
        const idx = $59c911fa927d1bcf$var$asItemIndex(key);
        if (typeof idx !== 'number') return false;
        const del = this.items.splice(idx, 1);
        return del.length > 0;
    }
    /**
     * Returns item at `key`, or `undefined` if not found. By default unwraps
     * scalar values from their surrounding node; to disable set `keepScalar` to
     * `true` (collections are always returned intact).
     *
     * `key` must contain a representation of an integer for this to succeed.
     * It may be wrapped in a `Scalar`.
     */ get(key, keepScalar) {
        const idx = $59c911fa927d1bcf$var$asItemIndex(key);
        if (typeof idx !== 'number') return undefined;
        const it = this.items[idx];
        return !keepScalar && $59c911fa927d1bcf$export$8f3495e22775e76c(it) ? it.value : it;
    }
    /**
     * Checks if the collection includes a value with the key `key`.
     *
     * `key` must contain a representation of an integer for this to succeed.
     * It may be wrapped in a `Scalar`.
     */ has(key) {
        const idx = $59c911fa927d1bcf$var$asItemIndex(key);
        return typeof idx === 'number' && idx < this.items.length;
    }
    /**
     * Sets a value in this collection. For `!!set`, `value` needs to be a
     * boolean to add/remove the item from the set.
     *
     * If `key` does not contain a representation of an integer, this will throw.
     * It may be wrapped in a `Scalar`.
     */ set(key, value) {
        const idx = $59c911fa927d1bcf$var$asItemIndex(key);
        if (typeof idx !== 'number') throw new Error(`Expected a valid index, not ${key}.`);
        const prev = this.items[idx];
        if ($59c911fa927d1bcf$export$8f3495e22775e76c(prev) && $59c911fa927d1bcf$var$isScalarValue(value)) prev.value = value;
        else this.items[idx] = value;
    }
    toJSON(_, ctx) {
        const seq = [];
        if (ctx && ctx.onCreate) ctx.onCreate(seq);
        let i = 0;
        for (const item of this.items)seq.push($59c911fa927d1bcf$var$toJS(item, String(i++), ctx));
        return seq;
    }
    toString(ctx, onComment, onChompKeep) {
        if (!ctx) return JSON.stringify(this);
        return $59c911fa927d1bcf$var$stringifyCollection(this, ctx, {
            blockItem: (n)=>n.comment ? n.str : `- ${n.str}`,
            flowChars: {
                start: '[',
                end: ']'
            },
            itemIndent: (ctx.indent || '') + '  ',
            onChompKeep: onChompKeep,
            onComment: onComment
        });
    }
}
function $59c911fa927d1bcf$var$asItemIndex(key) {
    let idx = $59c911fa927d1bcf$export$8f3495e22775e76c(key) ? key.value : key;
    if (idx && typeof idx === 'string') idx = Number(idx);
    return typeof idx === 'number' && Number.isInteger(idx) && idx >= 0 ? idx : null;
}
function $59c911fa927d1bcf$var$createSeq(schema, obj, ctx) {
    const { replacer: replacer } = ctx;
    const seq = new $59c911fa927d1bcf$export$47adc25f769055b2(schema);
    if (obj && Symbol.iterator in Object(obj)) {
        let i = 0;
        for (let it of obj){
            if (typeof replacer === 'function') {
                const key = obj instanceof Set ? it : String(i++);
                it = replacer.call(obj, key, it);
            }
            seq.items.push($59c911fa927d1bcf$var$createNode(it, undefined, ctx));
        }
    }
    return seq;
}
const $59c911fa927d1bcf$var$seq = {
    collection: 'seq',
    createNode: $59c911fa927d1bcf$var$createSeq,
    default: true,
    nodeClass: $59c911fa927d1bcf$export$47adc25f769055b2,
    tag: 'tag:yaml.org,2002:seq',
    resolve (seq, onError) {
        if (!$59c911fa927d1bcf$export$342ac1d101ffe14b(seq)) onError('Expected a sequence for this tag');
        return seq;
    }
};
const $59c911fa927d1bcf$var$string = {
    identify: (value)=>typeof value === 'string',
    default: true,
    tag: 'tag:yaml.org,2002:str',
    resolve: (str)=>str,
    stringify (item, ctx, onComment, onChompKeep) {
        ctx = Object.assign({
            actualString: true
        }, ctx);
        return $59c911fa927d1bcf$var$stringifyString(item, ctx, onComment, onChompKeep);
    }
};
const $59c911fa927d1bcf$var$nullTag = {
    identify: (value)=>value == null,
    createNode: ()=>new $59c911fa927d1bcf$export$595dbf49c602a1f(null),
    default: true,
    tag: 'tag:yaml.org,2002:null',
    test: /^(?:~|[Nn]ull|NULL)?$/,
    resolve: ()=>new $59c911fa927d1bcf$export$595dbf49c602a1f(null),
    stringify: ({ source: source }, ctx)=>source && $59c911fa927d1bcf$var$nullTag.test.test(source) ? source : ctx.options.nullStr
};
const $59c911fa927d1bcf$var$boolTag = {
    identify: (value)=>typeof value === 'boolean',
    default: true,
    tag: 'tag:yaml.org,2002:bool',
    test: /^(?:[Tt]rue|TRUE|[Ff]alse|FALSE)$/,
    resolve: (str)=>new $59c911fa927d1bcf$export$595dbf49c602a1f(str[0] === 't' || str[0] === 'T'),
    stringify ({ source: source, value: value }, ctx) {
        if (source && $59c911fa927d1bcf$var$boolTag.test.test(source)) {
            const sv = source[0] === 't' || source[0] === 'T';
            if (value === sv) return source;
        }
        return value ? ctx.options.trueStr : ctx.options.falseStr;
    }
};
function $59c911fa927d1bcf$var$stringifyNumber({ format: format, minFractionDigits: minFractionDigits, tag: tag, value: value }) {
    if (typeof value === 'bigint') return String(value);
    const num = typeof value === 'number' ? value : Number(value);
    if (!isFinite(num)) return isNaN(num) ? '.nan' : num < 0 ? '-.inf' : '.inf';
    let n = JSON.stringify(value);
    if (!format && minFractionDigits && (!tag || tag === 'tag:yaml.org,2002:float') && /^\d/.test(n)) {
        let i = n.indexOf('.');
        if (i < 0) {
            i = n.length;
            n += '.';
        }
        let d = minFractionDigits - (n.length - i - 1);
        while(d-- > 0)n += '0';
    }
    return n;
}
const $59c911fa927d1bcf$var$floatNaN = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:float',
    test: /^(?:[-+]?\.(?:inf|Inf|INF|nan|NaN|NAN))$/,
    resolve: (str)=>str.slice(-3).toLowerCase() === 'nan' ? NaN : str[0] === '-' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY,
    stringify: $59c911fa927d1bcf$var$stringifyNumber
};
const $59c911fa927d1bcf$var$floatExp = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:float',
    format: 'EXP',
    test: /^[-+]?(?:\.[0-9]+|[0-9]+(?:\.[0-9]*)?)[eE][-+]?[0-9]+$/,
    resolve: (str)=>parseFloat(str),
    stringify: ({ value: value })=>Number(value).toExponential()
};
const $59c911fa927d1bcf$var$float = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:float',
    test: /^[-+]?(?:\.[0-9]+|[0-9]+\.[0-9]*)$/,
    resolve (str) {
        const node = new $59c911fa927d1bcf$export$595dbf49c602a1f(parseFloat(str));
        const dot = str.indexOf('.');
        if (dot !== -1 && str[str.length - 1] === '0') node.minFractionDigits = str.length - dot - 1;
        return node;
    },
    stringify: $59c911fa927d1bcf$var$stringifyNumber
};
const $59c911fa927d1bcf$var$intIdentify = (value)=>typeof value === 'bigint' || Number.isInteger(value);
const $59c911fa927d1bcf$var$intResolve = (str, offset, radix, { intAsBigInt: intAsBigInt })=>intAsBigInt ? BigInt(str) : parseInt(str.substring(offset), radix);
function $59c911fa927d1bcf$var$intStringify(node, radix, prefix) {
    const { value: value } = node;
    if ($59c911fa927d1bcf$var$intIdentify(value) && value >= 0) return prefix + value.toString(radix);
    return $59c911fa927d1bcf$var$stringifyNumber(node);
}
const $59c911fa927d1bcf$var$intOct = {
    identify: (value)=>$59c911fa927d1bcf$var$intIdentify(value) && value >= 0,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'OCT',
    test: /^0o[0-7]+$/,
    resolve: (str, _onError, opt)=>$59c911fa927d1bcf$var$intResolve(str, 2, 8, opt),
    stringify: (node)=>$59c911fa927d1bcf$var$intStringify(node, 8, '0o')
};
const $59c911fa927d1bcf$var$int = {
    identify: $59c911fa927d1bcf$var$intIdentify,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    test: /^[-+]?[0-9]+$/,
    resolve: (str, _onError, opt)=>$59c911fa927d1bcf$var$intResolve(str, 0, 10, opt),
    stringify: $59c911fa927d1bcf$var$stringifyNumber
};
const $59c911fa927d1bcf$var$intHex = {
    identify: (value)=>$59c911fa927d1bcf$var$intIdentify(value) && value >= 0,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'HEX',
    test: /^0x[0-9a-fA-F]+$/,
    resolve: (str, _onError, opt)=>$59c911fa927d1bcf$var$intResolve(str, 2, 16, opt),
    stringify: (node)=>$59c911fa927d1bcf$var$intStringify(node, 16, '0x')
};
const $59c911fa927d1bcf$var$schema = [
    $59c911fa927d1bcf$var$map,
    $59c911fa927d1bcf$var$seq,
    $59c911fa927d1bcf$var$string,
    $59c911fa927d1bcf$var$nullTag,
    $59c911fa927d1bcf$var$boolTag,
    $59c911fa927d1bcf$var$intOct,
    $59c911fa927d1bcf$var$int,
    $59c911fa927d1bcf$var$intHex,
    $59c911fa927d1bcf$var$floatNaN,
    $59c911fa927d1bcf$var$floatExp,
    $59c911fa927d1bcf$var$float
];
function $59c911fa927d1bcf$var$intIdentify$1(value) {
    return typeof value === 'bigint' || Number.isInteger(value);
}
const $59c911fa927d1bcf$var$stringifyJSON = ({ value: value })=>JSON.stringify(value);
const $59c911fa927d1bcf$var$jsonScalars = [
    {
        identify: (value)=>typeof value === 'string',
        default: true,
        tag: 'tag:yaml.org,2002:str',
        resolve: (str)=>str,
        stringify: $59c911fa927d1bcf$var$stringifyJSON
    },
    {
        identify: (value)=>value == null,
        createNode: ()=>new $59c911fa927d1bcf$export$595dbf49c602a1f(null),
        default: true,
        tag: 'tag:yaml.org,2002:null',
        test: /^null$/,
        resolve: ()=>null,
        stringify: $59c911fa927d1bcf$var$stringifyJSON
    },
    {
        identify: (value)=>typeof value === 'boolean',
        default: true,
        tag: 'tag:yaml.org,2002:bool',
        test: /^true|false$/,
        resolve: (str)=>str === 'true',
        stringify: $59c911fa927d1bcf$var$stringifyJSON
    },
    {
        identify: $59c911fa927d1bcf$var$intIdentify$1,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        test: /^-?(?:0|[1-9][0-9]*)$/,
        resolve: (str, _onError, { intAsBigInt: intAsBigInt })=>intAsBigInt ? BigInt(str) : parseInt(str, 10),
        stringify: ({ value: value })=>$59c911fa927d1bcf$var$intIdentify$1(value) ? value.toString() : JSON.stringify(value)
    },
    {
        identify: (value)=>typeof value === 'number',
        default: true,
        tag: 'tag:yaml.org,2002:float',
        test: /^-?(?:0|[1-9][0-9]*)(?:\.[0-9]*)?(?:[eE][-+]?[0-9]+)?$/,
        resolve: (str)=>parseFloat(str),
        stringify: $59c911fa927d1bcf$var$stringifyJSON
    }
];
const $59c911fa927d1bcf$var$jsonError = {
    default: true,
    tag: '',
    test: /^/,
    resolve (str, onError) {
        onError(`Unresolved plain scalar ${JSON.stringify(str)}`);
        return str;
    }
};
const $59c911fa927d1bcf$var$schema$1 = [
    $59c911fa927d1bcf$var$map,
    $59c911fa927d1bcf$var$seq
].concat($59c911fa927d1bcf$var$jsonScalars, $59c911fa927d1bcf$var$jsonError);
const $59c911fa927d1bcf$var$binary = {
    identify: (value)=>value instanceof Uint8Array,
    default: false,
    tag: 'tag:yaml.org,2002:binary',
    /**
     * Returns a Buffer in node and an Uint8Array in browsers
     *
     * To use the resulting buffer as an image, you'll want to do something like:
     *
     *   const blob = new Blob([buffer], { type: 'image/jpeg' })
     *   document.querySelector('#photo').src = URL.createObjectURL(blob)
     */ resolve (src, onError) {
        if (typeof $59c911fa927d1bcf$require$Buffer === 'function') return $59c911fa927d1bcf$require$Buffer.from(src, 'base64');
        else if (typeof atob === 'function') {
            // On IE 11, atob() can't handle newlines
            const str = atob(src.replace(/[\n\r]/g, ''));
            const buffer = new Uint8Array(str.length);
            for(let i = 0; i < str.length; ++i)buffer[i] = str.charCodeAt(i);
            return buffer;
        } else {
            onError('This environment does not support reading binary tags; either Buffer or atob is required');
            return src;
        }
    },
    stringify ({ comment: comment, type: type, value: value }, ctx, onComment, onChompKeep) {
        const buf = value; // checked earlier by binary.identify()
        let str;
        if (typeof $59c911fa927d1bcf$require$Buffer === 'function') str = buf instanceof $59c911fa927d1bcf$require$Buffer ? buf.toString('base64') : $59c911fa927d1bcf$require$Buffer.from(buf.buffer).toString('base64');
        else if (typeof btoa === 'function') {
            let s = '';
            for(let i = 0; i < buf.length; ++i)s += String.fromCharCode(buf[i]);
            str = btoa(s);
        } else throw new Error('This environment does not support writing binary tags; either Buffer or btoa is required');
        if (!type) type = $59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_LITERAL;
        if (type !== $59c911fa927d1bcf$export$595dbf49c602a1f.QUOTE_DOUBLE) {
            const lineWidth = Math.max(ctx.options.lineWidth - ctx.indent.length, ctx.options.minContentWidth);
            const n = Math.ceil(str.length / lineWidth);
            const lines = new Array(n);
            for(let i = 0, o = 0; i < n; ++i, o += lineWidth)lines[i] = str.substr(o, lineWidth);
            str = lines.join(type === $59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_LITERAL ? '\n' : ' ');
        }
        return $59c911fa927d1bcf$var$stringifyString({
            comment: comment,
            type: type,
            value: str
        }, ctx, onComment, onChompKeep);
    }
};
function $59c911fa927d1bcf$var$resolvePairs(seq, onError) {
    if ($59c911fa927d1bcf$export$342ac1d101ffe14b(seq)) for(let i = 0; i < seq.items.length; ++i){
        let item = seq.items[i];
        if ($59c911fa927d1bcf$export$7c8d445944656308(item)) continue;
        else if ($59c911fa927d1bcf$export$5c90113a285f2241(item)) {
            if (item.items.length > 1) onError('Each pair must have its own sequence indicator');
            const pair = item.items[0] || new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(new $59c911fa927d1bcf$export$595dbf49c602a1f(null));
            if (item.commentBefore) pair.key.commentBefore = pair.key.commentBefore ? `${item.commentBefore}\n${pair.key.commentBefore}` : item.commentBefore;
            if (item.comment) {
                const cn = pair.value || pair.key;
                cn.comment = cn.comment ? `${item.comment}\n${cn.comment}` : item.comment;
            }
            item = pair;
        }
        seq.items[i] = $59c911fa927d1bcf$export$7c8d445944656308(item) ? item : new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(item);
    }
    else onError('Expected a sequence for this tag');
    return seq;
}
function $59c911fa927d1bcf$var$createPairs(schema, iterable, ctx) {
    const { replacer: replacer } = ctx;
    const pairs = new $59c911fa927d1bcf$export$47adc25f769055b2(schema);
    pairs.tag = 'tag:yaml.org,2002:pairs';
    let i = 0;
    if (iterable && Symbol.iterator in Object(iterable)) for (let it of iterable){
        if (typeof replacer === 'function') it = replacer.call(iterable, String(i++), it);
        let key, value;
        if (Array.isArray(it)) {
            if (it.length === 2) {
                key = it[0];
                value = it[1];
            } else throw new TypeError(`Expected [key, value] tuple: ${it}`);
        } else if (it && it instanceof Object) {
            const keys = Object.keys(it);
            if (keys.length === 1) {
                key = keys[0];
                value = it[key];
            } else throw new TypeError(`Expected { key: value } tuple: ${it}`);
        } else key = it;
        pairs.items.push($59c911fa927d1bcf$var$createPair(key, value, ctx));
    }
    return pairs;
}
const $59c911fa927d1bcf$var$pairs = {
    collection: 'seq',
    default: false,
    tag: 'tag:yaml.org,2002:pairs',
    resolve: $59c911fa927d1bcf$var$resolvePairs,
    createNode: $59c911fa927d1bcf$var$createPairs
};
class $59c911fa927d1bcf$var$YAMLOMap extends $59c911fa927d1bcf$export$47adc25f769055b2 {
    constructor(){
        super();
        this.add = $59c911fa927d1bcf$export$eb1691c4b19bb5eb.prototype.add.bind(this);
        this.delete = $59c911fa927d1bcf$export$eb1691c4b19bb5eb.prototype.delete.bind(this);
        this.get = $59c911fa927d1bcf$export$eb1691c4b19bb5eb.prototype.get.bind(this);
        this.has = $59c911fa927d1bcf$export$eb1691c4b19bb5eb.prototype.has.bind(this);
        this.set = $59c911fa927d1bcf$export$eb1691c4b19bb5eb.prototype.set.bind(this);
        this.tag = $59c911fa927d1bcf$var$YAMLOMap.tag;
    }
    /**
     * If `ctx` is given, the return type is actually `Map<unknown, unknown>`,
     * but TypeScript won't allow widening the signature of a child method.
     */ toJSON(_, ctx) {
        if (!ctx) return super.toJSON(_);
        const map = new Map();
        if (ctx && ctx.onCreate) ctx.onCreate(map);
        for (const pair of this.items){
            let key, value;
            if ($59c911fa927d1bcf$export$7c8d445944656308(pair)) {
                key = $59c911fa927d1bcf$var$toJS(pair.key, '', ctx);
                value = $59c911fa927d1bcf$var$toJS(pair.value, key, ctx);
            } else key = $59c911fa927d1bcf$var$toJS(pair, '', ctx);
            if (map.has(key)) throw new Error('Ordered maps must not include duplicate keys');
            map.set(key, value);
        }
        return map;
    }
}
$59c911fa927d1bcf$var$YAMLOMap.tag = 'tag:yaml.org,2002:omap';
const $59c911fa927d1bcf$var$omap = {
    collection: 'seq',
    identify: (value)=>value instanceof Map,
    nodeClass: $59c911fa927d1bcf$var$YAMLOMap,
    default: false,
    tag: 'tag:yaml.org,2002:omap',
    resolve (seq, onError) {
        const pairs = $59c911fa927d1bcf$var$resolvePairs(seq, onError);
        const seenKeys = [];
        for (const { key: key } of pairs.items)if ($59c911fa927d1bcf$export$8f3495e22775e76c(key)) {
            if (seenKeys.includes(key.value)) onError(`Ordered maps must not include duplicate keys: ${key.value}`);
            else seenKeys.push(key.value);
        }
        return Object.assign(new $59c911fa927d1bcf$var$YAMLOMap(), pairs);
    },
    createNode (schema, iterable, ctx) {
        const pairs = $59c911fa927d1bcf$var$createPairs(schema, iterable, ctx);
        const omap = new $59c911fa927d1bcf$var$YAMLOMap();
        omap.items = pairs.items;
        return omap;
    }
};
function $59c911fa927d1bcf$var$boolStringify({ value: value, source: source }, ctx) {
    const boolObj = value ? $59c911fa927d1bcf$var$trueTag : $59c911fa927d1bcf$var$falseTag;
    if (source && boolObj.test.test(source)) return source;
    return value ? ctx.options.trueStr : ctx.options.falseStr;
}
const $59c911fa927d1bcf$var$trueTag = {
    identify: (value)=>value === true,
    default: true,
    tag: 'tag:yaml.org,2002:bool',
    test: /^(?:Y|y|[Yy]es|YES|[Tt]rue|TRUE|[Oo]n|ON)$/,
    resolve: ()=>new $59c911fa927d1bcf$export$595dbf49c602a1f(true),
    stringify: $59c911fa927d1bcf$var$boolStringify
};
const $59c911fa927d1bcf$var$falseTag = {
    identify: (value)=>value === false,
    default: true,
    tag: 'tag:yaml.org,2002:bool',
    test: /^(?:N|n|[Nn]o|NO|[Ff]alse|FALSE|[Oo]ff|OFF)$/i,
    resolve: ()=>new $59c911fa927d1bcf$export$595dbf49c602a1f(false),
    stringify: $59c911fa927d1bcf$var$boolStringify
};
const $59c911fa927d1bcf$var$floatNaN$1 = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:float',
    test: /^[-+]?\.(?:inf|Inf|INF|nan|NaN|NAN)$/,
    resolve: (str)=>str.slice(-3).toLowerCase() === 'nan' ? NaN : str[0] === '-' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY,
    stringify: $59c911fa927d1bcf$var$stringifyNumber
};
const $59c911fa927d1bcf$var$floatExp$1 = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:float',
    format: 'EXP',
    test: /^[-+]?(?:[0-9][0-9_]*)?(?:\.[0-9_]*)?[eE][-+]?[0-9]+$/,
    resolve: (str)=>parseFloat(str.replace(/_/g, '')),
    stringify: ({ value: value })=>Number(value).toExponential()
};
const $59c911fa927d1bcf$var$float$1 = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:float',
    test: /^[-+]?(?:[0-9][0-9_]*)?\.[0-9_]*$/,
    resolve (str) {
        const node = new $59c911fa927d1bcf$export$595dbf49c602a1f(parseFloat(str.replace(/_/g, '')));
        const dot = str.indexOf('.');
        if (dot !== -1) {
            const f = str.substring(dot + 1).replace(/_/g, '');
            if (f[f.length - 1] === '0') node.minFractionDigits = f.length;
        }
        return node;
    },
    stringify: $59c911fa927d1bcf$var$stringifyNumber
};
const $59c911fa927d1bcf$var$intIdentify$2 = (value)=>typeof value === 'bigint' || Number.isInteger(value);
function $59c911fa927d1bcf$var$intResolve$1(str, offset, radix, { intAsBigInt: intAsBigInt }) {
    const sign = str[0];
    if (sign === '-' || sign === '+') offset += 1;
    str = str.substring(offset).replace(/_/g, '');
    if (intAsBigInt) {
        switch(radix){
            case 2:
                str = `0b${str}`;
                break;
            case 8:
                str = `0o${str}`;
                break;
            case 16:
                str = `0x${str}`;
                break;
        }
        const n = BigInt(str);
        return sign === '-' ? BigInt(-1) * n : n;
    }
    const n = parseInt(str, radix);
    return sign === '-' ? -1 * n : n;
}
function $59c911fa927d1bcf$var$intStringify$1(node, radix, prefix) {
    const { value: value } = node;
    if ($59c911fa927d1bcf$var$intIdentify$2(value)) {
        const str = value.toString(radix);
        return value < 0 ? '-' + prefix + str.substr(1) : prefix + str;
    }
    return $59c911fa927d1bcf$var$stringifyNumber(node);
}
const $59c911fa927d1bcf$var$intBin = {
    identify: $59c911fa927d1bcf$var$intIdentify$2,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'BIN',
    test: /^[-+]?0b[0-1_]+$/,
    resolve: (str, _onError, opt)=>$59c911fa927d1bcf$var$intResolve$1(str, 2, 2, opt),
    stringify: (node)=>$59c911fa927d1bcf$var$intStringify$1(node, 2, '0b')
};
const $59c911fa927d1bcf$var$intOct$1 = {
    identify: $59c911fa927d1bcf$var$intIdentify$2,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'OCT',
    test: /^[-+]?0[0-7_]+$/,
    resolve: (str, _onError, opt)=>$59c911fa927d1bcf$var$intResolve$1(str, 1, 8, opt),
    stringify: (node)=>$59c911fa927d1bcf$var$intStringify$1(node, 8, '0')
};
const $59c911fa927d1bcf$var$int$1 = {
    identify: $59c911fa927d1bcf$var$intIdentify$2,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    test: /^[-+]?[0-9][0-9_]*$/,
    resolve: (str, _onError, opt)=>$59c911fa927d1bcf$var$intResolve$1(str, 0, 10, opt),
    stringify: $59c911fa927d1bcf$var$stringifyNumber
};
const $59c911fa927d1bcf$var$intHex$1 = {
    identify: $59c911fa927d1bcf$var$intIdentify$2,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'HEX',
    test: /^[-+]?0x[0-9a-fA-F_]+$/,
    resolve: (str, _onError, opt)=>$59c911fa927d1bcf$var$intResolve$1(str, 2, 16, opt),
    stringify: (node)=>$59c911fa927d1bcf$var$intStringify$1(node, 16, '0x')
};
class $59c911fa927d1bcf$var$YAMLSet extends $59c911fa927d1bcf$export$eb1691c4b19bb5eb {
    constructor(schema){
        super(schema);
        this.tag = $59c911fa927d1bcf$var$YAMLSet.tag;
    }
    add(key) {
        let pair;
        if ($59c911fa927d1bcf$export$7c8d445944656308(key)) pair = key;
        else if (typeof key === 'object' && 'key' in key && 'value' in key && key.value === null) pair = new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(key.key, null);
        else pair = new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(key, null);
        const prev = $59c911fa927d1bcf$var$findPair(this.items, pair.key);
        if (!prev) this.items.push(pair);
    }
    get(key, keepPair) {
        const pair = $59c911fa927d1bcf$var$findPair(this.items, key);
        return !keepPair && $59c911fa927d1bcf$export$7c8d445944656308(pair) ? $59c911fa927d1bcf$export$8f3495e22775e76c(pair.key) ? pair.key.value : pair.key : pair;
    }
    set(key, value) {
        if (typeof value !== 'boolean') throw new Error(`Expected boolean value for set(key, value) in a YAML set, not ${typeof value}`);
        const prev = $59c911fa927d1bcf$var$findPair(this.items, key);
        if (prev && !value) this.items.splice(this.items.indexOf(prev), 1);
        else if (!prev && value) this.items.push(new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(key));
    }
    toJSON(_, ctx) {
        return super.toJSON(_, ctx, Set);
    }
    toString(ctx, onComment, onChompKeep) {
        if (!ctx) return JSON.stringify(this);
        if (this.hasAllNullValues(true)) return super.toString(Object.assign({}, ctx, {
            allNullValues: true
        }), onComment, onChompKeep);
        else throw new Error('Set items must all have null values');
    }
}
$59c911fa927d1bcf$var$YAMLSet.tag = 'tag:yaml.org,2002:set';
const $59c911fa927d1bcf$var$set = {
    collection: 'map',
    identify: (value)=>value instanceof Set,
    nodeClass: $59c911fa927d1bcf$var$YAMLSet,
    default: false,
    tag: 'tag:yaml.org,2002:set',
    resolve (map, onError) {
        if ($59c911fa927d1bcf$export$5c90113a285f2241(map)) {
            if (map.hasAllNullValues(true)) return Object.assign(new $59c911fa927d1bcf$var$YAMLSet(), map);
            else onError('Set items must all have null values');
        } else onError('Expected a mapping for this tag');
        return map;
    },
    createNode (schema, iterable, ctx) {
        const { replacer: replacer } = ctx;
        const set = new $59c911fa927d1bcf$var$YAMLSet(schema);
        if (iterable && Symbol.iterator in Object(iterable)) for (let value of iterable){
            if (typeof replacer === 'function') value = replacer.call(iterable, value, value);
            set.items.push($59c911fa927d1bcf$var$createPair(value, null, ctx));
        }
        return set;
    }
};
/** Internal types handle bigint as number, because TS can't figure it out. */ function $59c911fa927d1bcf$var$parseSexagesimal(str, asBigInt) {
    const sign = str[0];
    const parts = sign === '-' || sign === '+' ? str.substring(1) : str;
    const num = (n)=>asBigInt ? BigInt(n) : Number(n);
    const res = parts.replace(/_/g, '').split(':').reduce((res, p)=>res * num(60) + num(p), num(0));
    return sign === '-' ? num(-1) * res : res;
}
/**
 * hhhh:mm:ss.sss
 *
 * Internal types handle bigint as number, because TS can't figure it out.
 */ function $59c911fa927d1bcf$var$stringifySexagesimal(node) {
    let { value: value } = node;
    let num = (n)=>n;
    if (typeof value === 'bigint') num = (n)=>BigInt(n);
    else if (isNaN(value) || !isFinite(value)) return $59c911fa927d1bcf$var$stringifyNumber(node);
    let sign = '';
    if (value < 0) {
        sign = '-';
        value *= num(-1);
    }
    const _60 = num(60);
    const parts = [
        value % _60
    ]; // seconds, including ms
    if (value < 60) parts.unshift(0); // at least one : is required
    else {
        value = (value - parts[0]) / _60;
        parts.unshift(value % _60); // minutes
        if (value >= 60) {
            value = (value - parts[0]) / _60;
            parts.unshift(value); // hours
        }
    }
    return sign + parts.map((n)=>n < 10 ? '0' + String(n) : String(n)).join(':').replace(/000000\d*$/, '') // % 60 may introduce error
    ;
}
const $59c911fa927d1bcf$var$intTime = {
    identify: (value)=>typeof value === 'bigint' || Number.isInteger(value),
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'TIME',
    test: /^[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+$/,
    resolve: (str, _onError, { intAsBigInt: intAsBigInt })=>$59c911fa927d1bcf$var$parseSexagesimal(str, intAsBigInt),
    stringify: $59c911fa927d1bcf$var$stringifySexagesimal
};
const $59c911fa927d1bcf$var$floatTime = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:float',
    format: 'TIME',
    test: /^[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\.[0-9_]*$/,
    resolve: (str)=>$59c911fa927d1bcf$var$parseSexagesimal(str, false),
    stringify: $59c911fa927d1bcf$var$stringifySexagesimal
};
const $59c911fa927d1bcf$var$timestamp = {
    identify: (value)=>value instanceof Date,
    default: true,
    tag: 'tag:yaml.org,2002:timestamp',
    // If the time zone is omitted, the timestamp is assumed to be specified in UTC. The time part
    // may be omitted altogether, resulting in a date format. In such a case, the time part is
    // assumed to be 00:00:00Z (start of day, UTC).
    test: RegExp("^([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})(?:(?:t|T|[ \\t]+)([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2}(\\.[0-9]+)?)(?:[ \\t]*(Z|[-+][012]?[0-9](?::[0-9]{2})?))?)?$"),
    resolve (str) {
        const match = str.match($59c911fa927d1bcf$var$timestamp.test);
        if (!match) throw new Error('!!timestamp expects a date, starting with yyyy-mm-dd');
        const [, year, month, day, hour, minute, second] = match.map(Number);
        const millisec = match[7] ? Number((match[7] + '00').substr(1, 3)) : 0;
        let date = Date.UTC(year, month - 1, day, hour || 0, minute || 0, second || 0, millisec);
        const tz = match[8];
        if (tz && tz !== 'Z') {
            let d = $59c911fa927d1bcf$var$parseSexagesimal(tz, false);
            if (Math.abs(d) < 30) d *= 60;
            date -= 60000 * d;
        }
        return new Date(date);
    },
    stringify: ({ value: value })=>value.toISOString().replace(/((T00:00)?:00)?\.000Z$/, '')
};
const $59c911fa927d1bcf$var$schema$2 = [
    $59c911fa927d1bcf$var$map,
    $59c911fa927d1bcf$var$seq,
    $59c911fa927d1bcf$var$string,
    $59c911fa927d1bcf$var$nullTag,
    $59c911fa927d1bcf$var$trueTag,
    $59c911fa927d1bcf$var$falseTag,
    $59c911fa927d1bcf$var$intBin,
    $59c911fa927d1bcf$var$intOct$1,
    $59c911fa927d1bcf$var$int$1,
    $59c911fa927d1bcf$var$intHex$1,
    $59c911fa927d1bcf$var$floatNaN$1,
    $59c911fa927d1bcf$var$floatExp$1,
    $59c911fa927d1bcf$var$float$1,
    $59c911fa927d1bcf$var$binary,
    $59c911fa927d1bcf$var$omap,
    $59c911fa927d1bcf$var$pairs,
    $59c911fa927d1bcf$var$set,
    $59c911fa927d1bcf$var$intTime,
    $59c911fa927d1bcf$var$floatTime,
    $59c911fa927d1bcf$var$timestamp
];
const $59c911fa927d1bcf$var$schemas = {
    core: $59c911fa927d1bcf$var$schema,
    failsafe: [
        $59c911fa927d1bcf$var$map,
        $59c911fa927d1bcf$var$seq,
        $59c911fa927d1bcf$var$string
    ],
    json: $59c911fa927d1bcf$var$schema$1,
    yaml11: $59c911fa927d1bcf$var$schema$2,
    'yaml-1.1': $59c911fa927d1bcf$var$schema$2
};
const $59c911fa927d1bcf$var$tagsByName = {
    binary: $59c911fa927d1bcf$var$binary,
    bool: $59c911fa927d1bcf$var$boolTag,
    float: $59c911fa927d1bcf$var$float,
    floatExp: $59c911fa927d1bcf$var$floatExp,
    floatNaN: $59c911fa927d1bcf$var$floatNaN,
    floatTime: $59c911fa927d1bcf$var$floatTime,
    int: $59c911fa927d1bcf$var$int,
    intHex: $59c911fa927d1bcf$var$intHex,
    intOct: $59c911fa927d1bcf$var$intOct,
    intTime: $59c911fa927d1bcf$var$intTime,
    map: $59c911fa927d1bcf$var$map,
    null: $59c911fa927d1bcf$var$nullTag,
    omap: $59c911fa927d1bcf$var$omap,
    pairs: $59c911fa927d1bcf$var$pairs,
    seq: $59c911fa927d1bcf$var$seq,
    set: $59c911fa927d1bcf$var$set,
    timestamp: $59c911fa927d1bcf$var$timestamp
};
const $59c911fa927d1bcf$var$coreKnownTags = {
    'tag:yaml.org,2002:binary': $59c911fa927d1bcf$var$binary,
    'tag:yaml.org,2002:omap': $59c911fa927d1bcf$var$omap,
    'tag:yaml.org,2002:pairs': $59c911fa927d1bcf$var$pairs,
    'tag:yaml.org,2002:set': $59c911fa927d1bcf$var$set,
    'tag:yaml.org,2002:timestamp': $59c911fa927d1bcf$var$timestamp
};
function $59c911fa927d1bcf$var$getTags(customTags, schemaName) {
    let tags = $59c911fa927d1bcf$var$schemas[schemaName];
    if (!tags) {
        const keys = Object.keys($59c911fa927d1bcf$var$schemas).filter((key)=>key !== 'yaml11').map((key)=>JSON.stringify(key)).join(', ');
        throw new Error(`Unknown schema "${schemaName}"; use one of ${keys}`);
    }
    if (Array.isArray(customTags)) for (const tag of customTags)tags = tags.concat(tag);
    else if (typeof customTags === 'function') tags = customTags(tags.slice());
    return tags.map((tag)=>{
        if (typeof tag !== 'string') return tag;
        const tagObj = $59c911fa927d1bcf$var$tagsByName[tag];
        if (tagObj) return tagObj;
        const keys = Object.keys($59c911fa927d1bcf$var$tagsByName).map((key)=>JSON.stringify(key)).join(', ');
        throw new Error(`Unknown custom tag "${tag}"; use one of ${keys}`);
    });
}
const $59c911fa927d1bcf$var$sortMapEntriesByKey = (a, b)=>a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
class $59c911fa927d1bcf$export$19342e026b58ebb7 {
    constructor({ customTags: customTags, merge: merge, resolveKnownTags: resolveKnownTags, schema: schema, sortMapEntries: sortMapEntries }){
        this.merge = !!merge;
        this.name = schema || 'core';
        this.knownTags = resolveKnownTags ? $59c911fa927d1bcf$var$coreKnownTags : {};
        this.tags = $59c911fa927d1bcf$var$getTags(customTags, this.name);
        Object.defineProperty(this, $59c911fa927d1bcf$var$MAP, {
            value: $59c911fa927d1bcf$var$map
        });
        Object.defineProperty(this, $59c911fa927d1bcf$var$SCALAR, {
            value: $59c911fa927d1bcf$var$string
        });
        Object.defineProperty(this, $59c911fa927d1bcf$var$SEQ, {
            value: $59c911fa927d1bcf$var$seq
        });
        // Used by createMap()
        this.sortMapEntries = sortMapEntries === true ? $59c911fa927d1bcf$var$sortMapEntriesByKey : sortMapEntries || null;
    }
    clone() {
        const copy = Object.create($59c911fa927d1bcf$export$19342e026b58ebb7.prototype, Object.getOwnPropertyDescriptors(this));
        copy.tags = this.tags.slice();
        return copy;
    }
}
function $59c911fa927d1bcf$var$stringifyDocument(doc, options) {
    const lines = [];
    let hasDirectives = options.directives === true;
    if (options.directives !== false) {
        const dir = doc.directives.toString(doc);
        if (dir) {
            lines.push(dir);
            hasDirectives = true;
        } else if (doc.directives.marker) hasDirectives = true;
    }
    if (hasDirectives) lines.push('---');
    if (doc.commentBefore) {
        if (lines.length !== 1) lines.unshift('');
        lines.unshift($59c911fa927d1bcf$var$stringifyComment(doc.commentBefore, ''));
    }
    const ctx = $59c911fa927d1bcf$var$createStringifyContext(doc, options);
    let chompKeep = false;
    let contentComment = null;
    if (doc.contents) {
        if ($59c911fa927d1bcf$export$8ee0fc9ee280b4ee(doc.contents)) {
            if (doc.contents.spaceBefore && hasDirectives) lines.push('');
            if (doc.contents.commentBefore) lines.push($59c911fa927d1bcf$var$stringifyComment(doc.contents.commentBefore, ''));
            // top-level block scalars need to be indented if followed by a comment
            ctx.forceBlockIndent = !!doc.comment;
            contentComment = doc.contents.comment;
        }
        const onChompKeep = contentComment ? undefined : ()=>chompKeep = true;
        let body = $59c911fa927d1bcf$var$stringify(doc.contents, ctx, ()=>contentComment = null, onChompKeep);
        if (contentComment) body = $59c911fa927d1bcf$var$addComment(body, '', contentComment);
        if ((body[0] === '|' || body[0] === '>') && lines[lines.length - 1] === '---') // Top-level block scalars with a preceding doc marker ought to use the
        // same line for their header.
        lines[lines.length - 1] = `--- ${body}`;
        else lines.push(body);
    } else lines.push($59c911fa927d1bcf$var$stringify(doc.contents, ctx));
    let dc = doc.comment;
    if (dc && chompKeep) dc = dc.replace(/^\n+/, '');
    if (dc) {
        if ((!chompKeep || contentComment) && lines[lines.length - 1] !== '') lines.push('');
        lines.push($59c911fa927d1bcf$var$stringifyComment(dc, ''));
    }
    return lines.join('\n') + '\n';
}
/**
 * Applies the JSON.parse reviver algorithm as defined in the ECMA-262 spec,
 * in section 24.5.1.1 "Runtime Semantics: InternalizeJSONProperty" of the
 * 2021 edition: https://tc39.es/ecma262/#sec-json.parse
 *
 * Includes extensions for handling Map and Set objects.
 */ function $59c911fa927d1bcf$var$applyReviver(reviver, obj, key, val) {
    if (val && typeof val === 'object') {
        if (Array.isArray(val)) for(let i = 0, len = val.length; i < len; ++i){
            const v0 = val[i];
            const v1 = $59c911fa927d1bcf$var$applyReviver(reviver, val, String(i), v0);
            if (v1 === undefined) delete val[i];
            else if (v1 !== v0) val[i] = v1;
        }
        else if (val instanceof Map) for (const k of Array.from(val.keys())){
            const v0 = val.get(k);
            const v1 = $59c911fa927d1bcf$var$applyReviver(reviver, val, k, v0);
            if (v1 === undefined) val.delete(k);
            else if (v1 !== v0) val.set(k, v1);
        }
        else if (val instanceof Set) for (const v0 of Array.from(val)){
            const v1 = $59c911fa927d1bcf$var$applyReviver(reviver, val, v0, v0);
            if (v1 === undefined) val.delete(v0);
            else if (v1 !== v0) {
                val.delete(v0);
                val.add(v1);
            }
        }
        else for (const [k, v0] of Object.entries(val)){
            const v1 = $59c911fa927d1bcf$var$applyReviver(reviver, val, k, v0);
            if (v1 === undefined) delete val[k];
            else if (v1 !== v0) val[k] = v1;
        }
    }
    return reviver.call(obj, key, val);
}
class $59c911fa927d1bcf$export$b34a105447964f9f {
    constructor(value, replacer, options){
        /** A comment before this Document */ this.commentBefore = null;
        /** A comment immediately after this Document */ this.comment = null;
        /** Errors encountered during parsing. */ this.errors = [];
        /** Warnings encountered during parsing. */ this.warnings = [];
        Object.defineProperty(this, $59c911fa927d1bcf$var$NODE_TYPE, {
            value: $59c911fa927d1bcf$var$DOC
        });
        let _replacer = null;
        if (typeof replacer === 'function' || Array.isArray(replacer)) _replacer = replacer;
        else if (options === undefined && replacer) {
            options = replacer;
            replacer = undefined;
        }
        const opt = Object.assign({}, $59c911fa927d1bcf$export$ba43bf67f3d48107, options);
        this.options = opt;
        let { version: version } = opt;
        if (options === null || options === void 0 ? void 0 : options.directives) {
            this.directives = options.directives.atDocument();
            if (this.directives.yaml.explicit) version = this.directives.yaml.version;
        } else this.directives = new $59c911fa927d1bcf$var$Directives({
            version: version
        });
        this.setSchema(version, options);
        if (value === undefined) this.contents = null;
        else this.contents = this.createNode(value, _replacer, options);
    }
    /**
     * Create a deep copy of this Document and its contents.
     *
     * Custom Node values that inherit from `Object` still refer to their original instances.
     */ clone() {
        const copy = Object.create($59c911fa927d1bcf$export$b34a105447964f9f.prototype, {
            [$59c911fa927d1bcf$var$NODE_TYPE]: {
                value: $59c911fa927d1bcf$var$DOC
            }
        });
        copy.commentBefore = this.commentBefore;
        copy.comment = this.comment;
        copy.errors = this.errors.slice();
        copy.warnings = this.warnings.slice();
        copy.options = Object.assign({}, this.options);
        copy.directives = this.directives.clone();
        copy.schema = this.schema.clone();
        copy.contents = $59c911fa927d1bcf$export$8ee0fc9ee280b4ee(this.contents) ? this.contents.clone(copy.schema) : this.contents;
        if (this.range) copy.range = this.range.slice();
        return copy;
    }
    /** Adds a value to the document. */ add(value) {
        if ($59c911fa927d1bcf$var$assertCollection(this.contents)) this.contents.add(value);
    }
    /** Adds a value to the document. */ addIn(path, value) {
        if ($59c911fa927d1bcf$var$assertCollection(this.contents)) this.contents.addIn(path, value);
    }
    /**
     * Create a new `Alias` node, ensuring that the target `node` has the required anchor.
     *
     * If `node` already has an anchor, `name` is ignored.
     * Otherwise, the `node.anchor` value will be set to `name`,
     * or if an anchor with that name is already present in the document,
     * `name` will be used as a prefix for a new unique anchor.
     * If `name` is undefined, the generated anchor will use 'a' as a prefix.
     */ createAlias(node, name) {
        if (!node.anchor) {
            const prev = $59c911fa927d1bcf$var$anchorNames(this);
            node.anchor = !name || prev.has(name) ? $59c911fa927d1bcf$var$findNewAnchor(name || 'a', prev) : name;
        }
        return new $59c911fa927d1bcf$export$17b520249a85fe16(node.anchor);
    }
    createNode(value, replacer, options) {
        let _replacer = undefined;
        if (typeof replacer === 'function') {
            value = replacer.call({
                '': value
            }, '', value);
            _replacer = replacer;
        } else if (Array.isArray(replacer)) {
            const keyToStr = (v)=>typeof v === 'number' || v instanceof String || v instanceof Number;
            const asStr = replacer.filter(keyToStr).map(String);
            if (asStr.length > 0) replacer = replacer.concat(asStr);
            _replacer = replacer;
        } else if (options === undefined && replacer) {
            options = replacer;
            replacer = undefined;
        }
        const { aliasDuplicateObjects: aliasDuplicateObjects, anchorPrefix: anchorPrefix, flow: flow, keepUndefined: keepUndefined, onTagObj: onTagObj, tag: tag } = options || {};
        const { onAnchor: onAnchor, setAnchors: setAnchors, sourceObjects: sourceObjects } = $59c911fa927d1bcf$var$createNodeAnchors(this, anchorPrefix || 'a');
        const ctx = {
            aliasDuplicateObjects: aliasDuplicateObjects !== null && aliasDuplicateObjects !== void 0 ? aliasDuplicateObjects : true,
            keepUndefined: keepUndefined !== null && keepUndefined !== void 0 ? keepUndefined : false,
            onAnchor: onAnchor,
            onTagObj: onTagObj,
            replacer: _replacer,
            schema: this.schema,
            sourceObjects: sourceObjects
        };
        const node = $59c911fa927d1bcf$var$createNode(value, tag, ctx);
        if (flow && $59c911fa927d1bcf$export$cea7aa84e978eba5(node)) node.flow = true;
        setAnchors();
        return node;
    }
    /**
     * Convert a key and a value into a `Pair` using the current schema,
     * recursively wrapping all values as `Scalar` or `Collection` nodes.
     */ createPair(key, value, options = {}) {
        const k = this.createNode(key, null, options);
        const v = this.createNode(value, null, options);
        return new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(k, v);
    }
    /**
     * Removes a value from the document.
     * @returns `true` if the item was found and removed.
     */ delete(key) {
        return $59c911fa927d1bcf$var$assertCollection(this.contents) ? this.contents.delete(key) : false;
    }
    /**
     * Removes a value from the document.
     * @returns `true` if the item was found and removed.
     */ deleteIn(path) {
        if ($59c911fa927d1bcf$var$isEmptyPath(path)) {
            if (this.contents == null) return false;
            this.contents = null;
            return true;
        }
        return $59c911fa927d1bcf$var$assertCollection(this.contents) ? this.contents.deleteIn(path) : false;
    }
    /**
     * Returns item at `key`, or `undefined` if not found. By default unwraps
     * scalar values from their surrounding node; to disable set `keepScalar` to
     * `true` (collections are always returned intact).
     */ get(key, keepScalar) {
        return $59c911fa927d1bcf$export$cea7aa84e978eba5(this.contents) ? this.contents.get(key, keepScalar) : undefined;
    }
    /**
     * Returns item at `path`, or `undefined` if not found. By default unwraps
     * scalar values from their surrounding node; to disable set `keepScalar` to
     * `true` (collections are always returned intact).
     */ getIn(path, keepScalar) {
        if ($59c911fa927d1bcf$var$isEmptyPath(path)) return !keepScalar && $59c911fa927d1bcf$export$8f3495e22775e76c(this.contents) ? this.contents.value : this.contents;
        return $59c911fa927d1bcf$export$cea7aa84e978eba5(this.contents) ? this.contents.getIn(path, keepScalar) : undefined;
    }
    /**
     * Checks if the document includes a value with the key `key`.
     */ has(key) {
        return $59c911fa927d1bcf$export$cea7aa84e978eba5(this.contents) ? this.contents.has(key) : false;
    }
    /**
     * Checks if the document includes a value at `path`.
     */ hasIn(path) {
        if ($59c911fa927d1bcf$var$isEmptyPath(path)) return this.contents !== undefined;
        return $59c911fa927d1bcf$export$cea7aa84e978eba5(this.contents) ? this.contents.hasIn(path) : false;
    }
    /**
     * Sets a value in this document. For `!!set`, `value` needs to be a
     * boolean to add/remove the item from the set.
     */ set(key, value) {
        if (this.contents == null) this.contents = $59c911fa927d1bcf$var$collectionFromPath(this.schema, [
            key
        ], value);
        else if ($59c911fa927d1bcf$var$assertCollection(this.contents)) this.contents.set(key, value);
    }
    /**
     * Sets a value in this document. For `!!set`, `value` needs to be a
     * boolean to add/remove the item from the set.
     */ setIn(path, value) {
        if ($59c911fa927d1bcf$var$isEmptyPath(path)) this.contents = value;
        else if (this.contents == null) this.contents = $59c911fa927d1bcf$var$collectionFromPath(this.schema, Array.from(path), value);
        else if ($59c911fa927d1bcf$var$assertCollection(this.contents)) this.contents.setIn(path, value);
    }
    /**
     * Change the YAML version and schema used by the document.
     *
     * Overrides all previously set schema options
     */ setSchema(version, options) {
        let _options;
        switch(String(version)){
            case '1.1':
                this.directives.yaml.version = '1.1';
                _options = Object.assign({
                    merge: true,
                    resolveKnownTags: false,
                    schema: 'yaml-1.1'
                }, options);
                break;
            case '1.2':
                this.directives.yaml.version = '1.2';
                _options = Object.assign({
                    merge: false,
                    resolveKnownTags: true,
                    schema: 'core'
                }, options);
                break;
            default:
                {
                    const sv = JSON.stringify(version);
                    throw new Error(`Expected '1.1' or '1.2' as version, but found: ${sv}`);
                }
        }
        this.schema = new $59c911fa927d1bcf$export$19342e026b58ebb7(_options);
    }
    // json & jsonArg are only used from toJSON()
    toJS({ json: json, jsonArg: jsonArg, mapAsMap: mapAsMap, maxAliasCount: maxAliasCount, onAnchor: onAnchor, reviver: reviver } = {}) {
        const ctx = {
            anchors: new Map(),
            doc: this,
            keep: !json,
            mapAsMap: mapAsMap === true,
            mapKeyWarned: false,
            maxAliasCount: typeof maxAliasCount === 'number' ? maxAliasCount : 100,
            stringify: $59c911fa927d1bcf$var$stringify
        };
        const res = $59c911fa927d1bcf$var$toJS(this.contents, jsonArg || '', ctx);
        if (typeof onAnchor === 'function') for (const { count: count, res: res } of ctx.anchors.values())onAnchor(res, count);
        return typeof reviver === 'function' ? $59c911fa927d1bcf$var$applyReviver(reviver, {
            '': res
        }, '', res) : res;
    }
    /**
     * A JSON representation of the document `contents`.
     *
     * @param jsonArg Used by `JSON.stringify` to indicate the array index or
     *   property name.
     */ toJSON(jsonArg, onAnchor) {
        return this.toJS({
            json: true,
            jsonArg: jsonArg,
            mapAsMap: false,
            onAnchor: onAnchor
        });
    }
    /** A YAML representation of the document. */ toString(options = {}) {
        if (this.errors.length > 0) throw new Error('Document with errors cannot be stringified');
        if ('indent' in options && (!Number.isInteger(options.indent) || Number(options.indent) <= 0)) {
            const s = JSON.stringify(options.indent);
            throw new Error(`"indent" option must be a positive integer, not ${s}`);
        }
        return $59c911fa927d1bcf$var$stringifyDocument(this, options);
    }
}
function $59c911fa927d1bcf$var$assertCollection(contents) {
    if ($59c911fa927d1bcf$export$cea7aa84e978eba5(contents)) return true;
    throw new Error('Expected a YAML collection as document contents');
}
class $59c911fa927d1bcf$export$699cd54d617b337f extends Error {
    constructor(name, pos, code, message){
        super();
        this.name = name;
        this.code = code;
        this.message = message;
        this.pos = pos;
    }
}
class $59c911fa927d1bcf$export$c1188aaa49090a5c extends $59c911fa927d1bcf$export$699cd54d617b337f {
    constructor(pos, code, message){
        super('YAMLParseError', pos, code, message);
    }
}
class $59c911fa927d1bcf$export$856b463bac79f971 extends $59c911fa927d1bcf$export$699cd54d617b337f {
    constructor(pos, code, message){
        super('YAMLWarning', pos, code, message);
    }
}
const $59c911fa927d1bcf$var$prettifyError = (src, lc)=>(error)=>{
        if (error.pos[0] === -1) return;
        error.linePos = error.pos.map((pos)=>lc.linePos(pos));
        const { line: line, col: col } = error.linePos[0];
        error.message += ` at line ${line}, column ${col}`;
        let ci = col - 1;
        let lineStr = src.substring(lc.lineStarts[line - 1], lc.lineStarts[line]).replace(/[\n\r]+$/, '');
        // Trim to max 80 chars, keeping col position near the middle
        if (ci >= 60 && lineStr.length > 80) {
            const trimStart = Math.min(ci - 39, lineStr.length - 79);
            lineStr = "\u2026" + lineStr.substring(trimStart);
            ci -= trimStart - 1;
        }
        if (lineStr.length > 80) lineStr = lineStr.substring(0, 79) + "\u2026";
        // Include previous line in context if pointing at line start
        if (line > 1 && /^ *$/.test(lineStr.substring(0, ci))) {
            // Regexp won't match if start is trimmed
            let prev = src.substring(lc.lineStarts[line - 2], lc.lineStarts[line - 1]);
            if (prev.length > 80) prev = prev.substring(0, 79) + "\u2026\n";
            lineStr = prev + lineStr;
        }
        if (/[^ ]/.test(lineStr)) {
            let count = 1;
            const end = error.linePos[1];
            if (end && end.line === line && end.col > col) count = Math.min(end.col - col, 80 - ci);
            const pointer = ' '.repeat(ci) + '^'.repeat(count);
            error.message += `:\n\n${lineStr}\n${pointer}\n`;
        }
    };
function $59c911fa927d1bcf$var$resolveProps(tokens, { flow: flow, indicator: indicator, next: next, offset: offset, onError: onError, startOnNewline: startOnNewline }) {
    let spaceBefore = false;
    let atNewline = startOnNewline;
    let hasSpace = startOnNewline;
    let comment = '';
    let commentSep = '';
    let hasNewline = false;
    let reqSpace = false;
    let anchor = null;
    let tag = null;
    let comma = null;
    let found = null;
    let start = null;
    for (const token of tokens){
        if (reqSpace) {
            if (token.type !== 'space' && token.type !== 'newline' && token.type !== 'comma') onError(token.offset, 'MISSING_CHAR', 'Tags and anchors must be separated from the next token by white space');
            reqSpace = false;
        }
        switch(token.type){
            case 'space':
                // At the doc level, tabs at line start may be parsed
                // as leading white space rather than indentation.
                // In a flow collection, only the parser handles indent.
                if (!flow && atNewline && indicator !== 'doc-start' && token.source[0] === '\t') onError(token, 'TAB_AS_INDENT', 'Tabs are not allowed as indentation');
                hasSpace = true;
                break;
            case 'comment':
                {
                    if (!hasSpace) onError(token, 'MISSING_CHAR', 'Comments must be separated from other tokens by white space characters');
                    const cb = token.source.substring(1) || ' ';
                    if (!comment) comment = cb;
                    else comment += commentSep + cb;
                    commentSep = '';
                    atNewline = false;
                    break;
                }
            case 'newline':
                if (atNewline) {
                    if (comment) comment += token.source;
                    else spaceBefore = true;
                } else commentSep += token.source;
                atNewline = true;
                hasNewline = true;
                hasSpace = true;
                break;
            case 'anchor':
                if (anchor) onError(token, 'MULTIPLE_ANCHORS', 'A node can have at most one anchor');
                anchor = token;
                if (start === null) start = token.offset;
                atNewline = false;
                hasSpace = false;
                reqSpace = true;
                break;
            case 'tag':
                if (tag) onError(token, 'MULTIPLE_TAGS', 'A node can have at most one tag');
                tag = token;
                if (start === null) start = token.offset;
                atNewline = false;
                hasSpace = false;
                reqSpace = true;
                break;
            case indicator:
                // Could here handle preceding comments differently
                if (anchor || tag) onError(token, 'BAD_PROP_ORDER', `Anchors and tags must be after the ${token.source} indicator`);
                found = token;
                atNewline = false;
                hasSpace = false;
                break;
            case 'comma':
                if (flow) {
                    if (comma) onError(token, 'UNEXPECTED_TOKEN', `Unexpected , in ${flow}`);
                    comma = token;
                    atNewline = false;
                    hasSpace = false;
                    break;
                }
            // else fallthrough
            default:
                onError(token, 'UNEXPECTED_TOKEN', `Unexpected ${token.type} token`);
                atNewline = false;
                hasSpace = false;
        }
    }
    const last = tokens[tokens.length - 1];
    const end = last ? last.offset + last.source.length : offset;
    if (reqSpace && next && next.type !== 'space' && next.type !== 'newline' && next.type !== 'comma' && (next.type !== 'scalar' || next.source !== '')) onError(next.offset, 'MISSING_CHAR', 'Tags and anchors must be separated from the next token by white space');
    return {
        comma: comma,
        found: found,
        spaceBefore: spaceBefore,
        comment: comment,
        hasNewline: hasNewline,
        anchor: anchor,
        tag: tag,
        end: end,
        start: start !== null && start !== void 0 ? start : end
    };
}
function $59c911fa927d1bcf$var$containsNewline(key) {
    if (!key) return null;
    switch(key.type){
        case 'alias':
        case 'scalar':
        case 'double-quoted-scalar':
        case 'single-quoted-scalar':
            if (key.source.includes('\n')) return true;
            if (key.end) {
                for (const st of key.end)if (st.type === 'newline') return true;
            }
            return false;
        case 'flow-collection':
            for (const it of key.items){
                for (const st of it.start)if (st.type === 'newline') return true;
                if (it.sep) {
                    for (const st of it.sep)if (st.type === 'newline') return true;
                }
                if ($59c911fa927d1bcf$var$containsNewline(it.key) || $59c911fa927d1bcf$var$containsNewline(it.value)) return true;
            }
            return false;
        default:
            return true;
    }
}
function $59c911fa927d1bcf$var$mapIncludes(ctx, items, search) {
    const { uniqueKeys: uniqueKeys } = ctx.options;
    if (uniqueKeys === false) return false;
    const isEqual = typeof uniqueKeys === 'function' ? uniqueKeys : (a, b)=>a === b || $59c911fa927d1bcf$export$8f3495e22775e76c(a) && $59c911fa927d1bcf$export$8f3495e22775e76c(b) && a.value === b.value && !(a.value === '<<' && ctx.schema.merge);
    return items.some((pair)=>isEqual(pair.key, search));
}
const $59c911fa927d1bcf$var$startColMsg = 'All mapping items must start at the same column';
function $59c911fa927d1bcf$var$resolveBlockMap({ composeNode: composeNode, composeEmptyNode: composeEmptyNode }, ctx, bm, onError) {
    var _a;
    const map = new $59c911fa927d1bcf$export$eb1691c4b19bb5eb(ctx.schema);
    let offset = bm.offset;
    for (const { start: start, key: key, sep: sep, value: value } of bm.items){
        // key properties
        const keyProps = $59c911fa927d1bcf$var$resolveProps(start, {
            indicator: 'explicit-key-ind',
            next: key || (sep === null || sep === void 0 ? void 0 : sep[0]),
            offset: offset,
            onError: onError,
            startOnNewline: true
        });
        const implicitKey = !keyProps.found;
        if (implicitKey) {
            if (key) {
                if (key.type === 'block-seq') onError(offset, 'BLOCK_AS_IMPLICIT_KEY', 'A block sequence may not be used as an implicit map key');
                else if ('indent' in key && key.indent !== bm.indent) onError(offset, 'BAD_INDENT', $59c911fa927d1bcf$var$startColMsg);
            }
            if (!keyProps.anchor && !keyProps.tag && !sep) {
                // TODO: assert being at last item?
                if (keyProps.comment) {
                    if (map.comment) map.comment += '\n' + keyProps.comment;
                    else map.comment = keyProps.comment;
                }
                continue;
            }
        } else if (((_a = keyProps.found) === null || _a === void 0 ? void 0 : _a.indent) !== bm.indent) onError(offset, 'BAD_INDENT', $59c911fa927d1bcf$var$startColMsg);
        if (implicitKey && $59c911fa927d1bcf$var$containsNewline(key)) onError(key, 'MULTILINE_IMPLICIT_KEY', 'Implicit keys need to be on a single line');
        // key value
        const keyStart = keyProps.end;
        const keyNode = key ? composeNode(ctx, key, keyProps, onError) : composeEmptyNode(ctx, keyStart, start, null, keyProps, onError);
        if ($59c911fa927d1bcf$var$mapIncludes(ctx, map.items, keyNode)) onError(keyStart, 'DUPLICATE_KEY', 'Map keys must be unique');
        // value properties
        const valueProps = $59c911fa927d1bcf$var$resolveProps(sep || [], {
            indicator: 'map-value-ind',
            next: value,
            offset: keyNode.range[2],
            onError: onError,
            startOnNewline: !key || key.type === 'block-scalar'
        });
        offset = valueProps.end;
        if (valueProps.found) {
            if (implicitKey) {
                if ((value === null || value === void 0 ? void 0 : value.type) === 'block-map' && !valueProps.hasNewline) onError(offset, 'BLOCK_AS_IMPLICIT_KEY', 'Nested mappings are not allowed in compact mappings');
                if (ctx.options.strict && keyProps.start < valueProps.found.offset - 1024) onError(keyNode.range, 'KEY_OVER_1024_CHARS', 'The : indicator must be at most 1024 chars after the start of an implicit block mapping key');
            }
            // value value
            const valueNode = value ? composeNode(ctx, value, valueProps, onError) : composeEmptyNode(ctx, offset, sep, null, valueProps, onError);
            offset = valueNode.range[2];
            map.items.push(new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(keyNode, valueNode));
        } else {
            // key with no value
            if (implicitKey) onError(keyNode.range, 'MISSING_CHAR', 'Implicit map keys need to be followed by map values');
            if (valueProps.comment) {
                if (keyNode.comment) keyNode.comment += '\n' + valueProps.comment;
                else keyNode.comment = valueProps.comment;
            }
            map.items.push(new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(keyNode));
        }
    }
    map.range = [
        bm.offset,
        offset,
        offset
    ];
    return map;
}
function $59c911fa927d1bcf$var$resolveBlockSeq({ composeNode: composeNode, composeEmptyNode: composeEmptyNode }, ctx, bs, onError) {
    const seq = new $59c911fa927d1bcf$export$47adc25f769055b2(ctx.schema);
    let offset = bs.offset;
    for (const { start: start, value: value } of bs.items){
        const props = $59c911fa927d1bcf$var$resolveProps(start, {
            indicator: 'seq-item-ind',
            next: value,
            offset: offset,
            onError: onError,
            startOnNewline: true
        });
        offset = props.end;
        if (!props.found) {
            if (props.anchor || props.tag || value) {
                if (value && value.type === 'block-seq') onError(offset, 'BAD_INDENT', 'All sequence items must start at the same column');
                else onError(offset, 'MISSING_CHAR', 'Sequence item without - indicator');
            } else {
                // TODO: assert being at last item?
                if (props.comment) seq.comment = props.comment;
                continue;
            }
        }
        const node = value ? composeNode(ctx, value, props, onError) : composeEmptyNode(ctx, offset, start, null, props, onError);
        offset = node.range[2];
        seq.items.push(node);
    }
    seq.range = [
        bs.offset,
        offset,
        offset
    ];
    return seq;
}
function $59c911fa927d1bcf$var$resolveEnd(end, offset, reqSpace, onError) {
    let comment = '';
    if (end) {
        let hasSpace = false;
        let sep = '';
        for (const token of end){
            const { source: source, type: type } = token;
            switch(type){
                case 'space':
                    hasSpace = true;
                    break;
                case 'comment':
                    {
                        if (reqSpace && !hasSpace) onError(token, 'MISSING_CHAR', 'Comments must be separated from other tokens by white space characters');
                        const cb = source.substring(1) || ' ';
                        if (!comment) comment = cb;
                        else comment += sep + cb;
                        sep = '';
                        break;
                    }
                case 'newline':
                    if (comment) sep += source;
                    hasSpace = true;
                    break;
                default:
                    onError(token, 'UNEXPECTED_TOKEN', `Unexpected ${type} at node end`);
            }
            offset += source.length;
        }
    }
    return {
        comment: comment,
        offset: offset
    };
}
const $59c911fa927d1bcf$var$blockMsg = 'Block collections are not allowed within flow collections';
const $59c911fa927d1bcf$var$isBlock = (token)=>token && (token.type === 'block-map' || token.type === 'block-seq');
function $59c911fa927d1bcf$var$resolveFlowCollection({ composeNode: composeNode, composeEmptyNode: composeEmptyNode }, ctx, fc, onError) {
    const isMap = fc.start.source === '{';
    const fcName = isMap ? 'flow map' : 'flow sequence';
    const coll = isMap ? new $59c911fa927d1bcf$export$eb1691c4b19bb5eb(ctx.schema) : new $59c911fa927d1bcf$export$47adc25f769055b2(ctx.schema);
    coll.flow = true;
    let offset = fc.offset;
    for(let i = 0; i < fc.items.length; ++i){
        const { start: start, key: key, sep: sep, value: value } = fc.items[i];
        const props = $59c911fa927d1bcf$var$resolveProps(start, {
            flow: fcName,
            indicator: 'explicit-key-ind',
            next: key || (sep === null || sep === void 0 ? void 0 : sep[0]),
            offset: offset,
            onError: onError,
            startOnNewline: false
        });
        if (!props.found) {
            if (!props.anchor && !props.tag && !sep && !value) {
                if (i === 0 && props.comma) onError(props.comma, 'UNEXPECTED_TOKEN', `Unexpected , in ${fcName}`);
                else if (i < fc.items.length - 1) onError(props.start, 'UNEXPECTED_TOKEN', `Unexpected empty item in ${fcName}`);
                if (props.comment) {
                    if (coll.comment) coll.comment += '\n' + props.comment;
                    else coll.comment = props.comment;
                }
                continue;
            }
            if (!isMap && ctx.options.strict && $59c911fa927d1bcf$var$containsNewline(key)) onError(key, 'MULTILINE_IMPLICIT_KEY', 'Implicit keys of flow sequence pairs need to be on a single line');
        }
        if (i === 0) {
            if (props.comma) onError(props.comma, 'UNEXPECTED_TOKEN', `Unexpected , in ${fcName}`);
        } else {
            if (!props.comma) onError(props.start, 'MISSING_CHAR', `Missing , between ${fcName} items`);
            if (props.comment) {
                let prevItemComment = '';
                loop: for (const st of start)switch(st.type){
                    case 'comma':
                    case 'space':
                        break;
                    case 'comment':
                        prevItemComment = st.source.substring(1);
                        break loop;
                    default:
                        break loop;
                }
                if (prevItemComment) {
                    let prev = coll.items[coll.items.length - 1];
                    if ($59c911fa927d1bcf$export$7c8d445944656308(prev)) prev = prev.value || prev.key;
                    if (prev.comment) prev.comment += '\n' + prevItemComment;
                    else prev.comment = prevItemComment;
                    props.comment = props.comment.substring(prevItemComment.length + 1);
                }
            }
        }
        if (!isMap && !sep && !props.found) {
            // item is a value in a seq
            // → key & sep are empty, start does not include ? or :
            const valueNode = value ? composeNode(ctx, value, props, onError) : composeEmptyNode(ctx, props.end, sep, null, props, onError);
            coll.items.push(valueNode);
            offset = valueNode.range[2];
            if ($59c911fa927d1bcf$var$isBlock(value)) onError(valueNode.range, 'BLOCK_IN_FLOW', $59c911fa927d1bcf$var$blockMsg);
        } else {
            // item is a key+value pair
            // key value
            const keyStart = props.end;
            const keyNode = key ? composeNode(ctx, key, props, onError) : composeEmptyNode(ctx, keyStart, start, null, props, onError);
            if ($59c911fa927d1bcf$var$isBlock(key)) onError(keyNode.range, 'BLOCK_IN_FLOW', $59c911fa927d1bcf$var$blockMsg);
            // value properties
            const valueProps = $59c911fa927d1bcf$var$resolveProps(sep || [], {
                flow: fcName,
                indicator: 'map-value-ind',
                next: value,
                offset: keyNode.range[2],
                onError: onError,
                startOnNewline: false
            });
            if (valueProps.found) {
                if (!isMap && !props.found && ctx.options.strict) {
                    if (sep) for (const st of sep){
                        if (st === valueProps.found) break;
                        if (st.type === 'newline') {
                            onError(st, 'MULTILINE_IMPLICIT_KEY', 'Implicit keys of flow sequence pairs need to be on a single line');
                            break;
                        }
                    }
                    if (props.start < valueProps.found.offset - 1024) onError(valueProps.found, 'KEY_OVER_1024_CHARS', 'The : indicator must be at most 1024 chars after the start of an implicit flow sequence key');
                }
            } else if (value) {
                if ('source' in value && value.source && value.source[0] === ':') onError(value, 'MISSING_CHAR', `Missing space after : in ${fcName}`);
                else onError(valueProps.start, 'MISSING_CHAR', `Missing , or : between ${fcName} items`);
            }
            // value value
            const valueNode = value ? composeNode(ctx, value, valueProps, onError) : valueProps.found ? composeEmptyNode(ctx, valueProps.end, sep, null, valueProps, onError) : null;
            if (valueNode) {
                if ($59c911fa927d1bcf$var$isBlock(value)) onError(valueNode.range, 'BLOCK_IN_FLOW', $59c911fa927d1bcf$var$blockMsg);
            } else if (valueProps.comment) {
                if (keyNode.comment) keyNode.comment += '\n' + valueProps.comment;
                else keyNode.comment = valueProps.comment;
            }
            const pair = new $59c911fa927d1bcf$export$d63d7cff08fe4dc9(keyNode, valueNode);
            if (isMap) {
                const map = coll;
                if ($59c911fa927d1bcf$var$mapIncludes(ctx, map.items, keyNode)) onError(keyStart, 'DUPLICATE_KEY', 'Map keys must be unique');
                map.items.push(pair);
            } else {
                const map = new $59c911fa927d1bcf$export$eb1691c4b19bb5eb(ctx.schema);
                map.flow = true;
                map.items.push(pair);
                coll.items.push(map);
            }
            offset = valueNode ? valueNode.range[2] : valueProps.end;
        }
    }
    const expectedEnd = isMap ? '}' : ']';
    const [ce, ...ee] = fc.end;
    let cePos = offset;
    if (ce && ce.source === expectedEnd) cePos = ce.offset + ce.source.length;
    else {
        onError(offset + 1, 'MISSING_CHAR', `Expected ${fcName} to end with ${expectedEnd}`);
        if (ce && ce.source.length !== 1) ee.unshift(ce);
    }
    if (ee.length > 0) {
        const end = $59c911fa927d1bcf$var$resolveEnd(ee, cePos, ctx.options.strict, onError);
        if (end.comment) {
            if (coll.comment) coll.comment += '\n' + end.comment;
            else coll.comment = end.comment;
        }
        coll.range = [
            fc.offset,
            cePos,
            end.offset
        ];
    } else coll.range = [
        fc.offset,
        cePos,
        cePos
    ];
    return coll;
}
function $59c911fa927d1bcf$var$composeCollection(CN, ctx, token, tagToken, onError) {
    let coll;
    switch(token.type){
        case 'block-map':
            coll = $59c911fa927d1bcf$var$resolveBlockMap(CN, ctx, token, onError);
            break;
        case 'block-seq':
            coll = $59c911fa927d1bcf$var$resolveBlockSeq(CN, ctx, token, onError);
            break;
        case 'flow-collection':
            coll = $59c911fa927d1bcf$var$resolveFlowCollection(CN, ctx, token, onError);
            break;
    }
    if (!tagToken) return coll;
    const tagName = ctx.directives.tagName(tagToken.source, (msg)=>onError(tagToken, 'TAG_RESOLVE_FAILED', msg));
    if (!tagName) return coll;
    // Cast needed due to: https://github.com/Microsoft/TypeScript/issues/3841
    const Coll = coll.constructor;
    if (tagName === '!' || tagName === Coll.tagName) {
        coll.tag = Coll.tagName;
        return coll;
    }
    const expType = $59c911fa927d1bcf$export$5c90113a285f2241(coll) ? 'map' : 'seq';
    let tag = ctx.schema.tags.find((t)=>t.collection === expType && t.tag === tagName);
    if (!tag) {
        const kt = ctx.schema.knownTags[tagName];
        if (kt && kt.collection === expType) {
            ctx.schema.tags.push(Object.assign({}, kt, {
                default: false
            }));
            tag = kt;
        } else {
            onError(tagToken, 'TAG_RESOLVE_FAILED', `Unresolved tag: ${tagName}`, true);
            coll.tag = tagName;
            return coll;
        }
    }
    const res = tag.resolve(coll, (msg)=>onError(tagToken, 'TAG_RESOLVE_FAILED', msg), ctx.options);
    const node = $59c911fa927d1bcf$export$8ee0fc9ee280b4ee(res) ? res : new $59c911fa927d1bcf$export$595dbf49c602a1f(res);
    node.range = coll.range;
    node.tag = tagName;
    if (tag === null || tag === void 0 ? void 0 : tag.format) node.format = tag.format;
    return node;
}
function $59c911fa927d1bcf$var$resolveBlockScalar(scalar, strict, onError) {
    const start = scalar.offset;
    const header = $59c911fa927d1bcf$var$parseBlockScalarHeader(scalar, strict, onError);
    if (!header) return {
        value: '',
        type: null,
        comment: '',
        range: [
            start,
            start,
            start
        ]
    };
    const type = header.mode === '>' ? $59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_FOLDED : $59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_LITERAL;
    const lines = scalar.source ? $59c911fa927d1bcf$var$splitLines(scalar.source) : [];
    // determine the end of content & start of chomping
    let chompStart = lines.length;
    for(let i = lines.length - 1; i >= 0; --i){
        const content = lines[i][1];
        if (content === '' || content === '\r') chompStart = i;
        else break;
    }
    // shortcut for empty contents
    if (!scalar.source || chompStart === 0) {
        const value = header.chomp === '+' ? lines.map((line)=>line[0]).join('\n') : '';
        let end = start + header.length;
        if (scalar.source) end += scalar.source.length;
        return {
            value: value,
            type: type,
            comment: header.comment,
            range: [
                start,
                end,
                end
            ]
        };
    }
    // find the indentation level to trim from start
    let trimIndent = scalar.indent + header.indent;
    let offset = scalar.offset + header.length;
    let contentStart = 0;
    for(let i = 0; i < chompStart; ++i){
        const [indent, content] = lines[i];
        if (content === '' || content === '\r') {
            if (header.indent === 0 && indent.length > trimIndent) trimIndent = indent.length;
        } else {
            if (indent.length < trimIndent) {
                const message = 'Block scalars with more-indented leading empty lines must use an explicit indentation indicator';
                onError(offset + indent.length, 'MISSING_CHAR', message);
            }
            if (header.indent === 0) trimIndent = indent.length;
            contentStart = i;
            break;
        }
        offset += indent.length + content.length + 1;
    }
    let value = '';
    let sep = '';
    let prevMoreIndented = false;
    // leading whitespace is kept intact
    for(let i = 0; i < contentStart; ++i)value += lines[i][0].slice(trimIndent) + '\n';
    for(let i = contentStart; i < chompStart; ++i){
        let [indent, content] = lines[i];
        offset += indent.length + content.length + 1;
        const crlf = content[content.length - 1] === '\r';
        if (crlf) content = content.slice(0, -1);
        /* istanbul ignore if already caught in lexer */ if (content && indent.length < trimIndent) {
            const src = header.indent ? 'explicit indentation indicator' : 'first line';
            const message = `Block scalar lines must not be less indented than their ${src}`;
            onError(offset - content.length - (crlf ? 2 : 1), 'BAD_INDENT', message);
            indent = '';
        }
        if (type === $59c911fa927d1bcf$export$595dbf49c602a1f.BLOCK_LITERAL) {
            value += sep + indent.slice(trimIndent) + content;
            sep = '\n';
        } else if (indent.length > trimIndent || content[0] === '\t') {
            // more-indented content within a folded block
            if (sep === ' ') sep = '\n';
            else if (!prevMoreIndented && sep === '\n') sep = '\n\n';
            value += sep + indent.slice(trimIndent) + content;
            sep = '\n';
            prevMoreIndented = true;
        } else if (content === '') {
            // empty line
            if (sep === '\n') value += '\n';
            else sep = '\n';
        } else {
            value += sep + content;
            sep = ' ';
            prevMoreIndented = false;
        }
    }
    switch(header.chomp){
        case '-':
            break;
        case '+':
            for(let i = chompStart; i < lines.length; ++i)value += '\n' + lines[i][0].slice(trimIndent);
            if (value[value.length - 1] !== '\n') value += '\n';
            break;
        default:
            value += '\n';
    }
    const end = start + header.length + scalar.source.length;
    return {
        value: value,
        type: type,
        comment: header.comment,
        range: [
            start,
            end,
            end
        ]
    };
}
function $59c911fa927d1bcf$var$parseBlockScalarHeader({ offset: offset, props: props }, strict, onError) {
    /* istanbul ignore if should not happen */ if (props[0].type !== 'block-scalar-header') {
        onError(props[0], 'IMPOSSIBLE', 'Block scalar header not found');
        return null;
    }
    const { source: source } = props[0];
    const mode = source[0];
    let indent = 0;
    let chomp = '';
    let error = -1;
    for(let i = 1; i < source.length; ++i){
        const ch = source[i];
        if (!chomp && (ch === '-' || ch === '+')) chomp = ch;
        else {
            const n = Number(ch);
            if (!indent && n) indent = n;
            else if (error === -1) error = offset + i;
        }
    }
    if (error !== -1) onError(error, 'UNEXPECTED_TOKEN', `Block scalar header includes extra characters: ${source}`);
    let hasSpace = false;
    let comment = '';
    let length = source.length;
    for(let i = 1; i < props.length; ++i){
        const token = props[i];
        switch(token.type){
            case 'space':
                hasSpace = true;
            // fallthrough
            case 'newline':
                length += token.source.length;
                break;
            case 'comment':
                if (strict && !hasSpace) {
                    const message = 'Comments must be separated from other tokens by white space characters';
                    onError(token, 'MISSING_CHAR', message);
                }
                length += token.source.length;
                comment = token.source.substring(1);
                break;
            case 'error':
                onError(token, 'UNEXPECTED_TOKEN', token.message);
                length += token.source.length;
                break;
            /* istanbul ignore next should not happen */ default:
                {
                    const message = `Unexpected token in block scalar header: ${token.type}`;
                    onError(token, 'UNEXPECTED_TOKEN', message);
                    const ts = token.source;
                    if (ts && typeof ts === 'string') length += ts.length;
                }
        }
    }
    return {
        mode: mode,
        indent: indent,
        chomp: chomp,
        comment: comment,
        length: length
    };
}
/** @returns Array of lines split up as `[indent, content]` */ function $59c911fa927d1bcf$var$splitLines(source) {
    const split = source.split(/\n( *)/);
    const first = split[0];
    const m = first.match(/^( *)/);
    const line0 = m && m[1] ? [
        m[1],
        first.slice(m[1].length)
    ] : [
        '',
        first
    ];
    const lines = [
        line0
    ];
    for(let i = 1; i < split.length; i += 2)lines.push([
        split[i],
        split[i + 1]
    ]);
    return lines;
}
function $59c911fa927d1bcf$var$resolveFlowScalar(scalar, strict, onError) {
    const { offset: offset, type: type, source: source, end: end } = scalar;
    let _type;
    let value;
    const _onError = (rel, code, msg)=>onError(offset + rel, code, msg);
    switch(type){
        case 'scalar':
            _type = $59c911fa927d1bcf$export$595dbf49c602a1f.PLAIN;
            value = $59c911fa927d1bcf$var$plainValue(source, _onError);
            break;
        case 'single-quoted-scalar':
            _type = $59c911fa927d1bcf$export$595dbf49c602a1f.QUOTE_SINGLE;
            value = $59c911fa927d1bcf$var$singleQuotedValue(source, _onError);
            break;
        case 'double-quoted-scalar':
            _type = $59c911fa927d1bcf$export$595dbf49c602a1f.QUOTE_DOUBLE;
            value = $59c911fa927d1bcf$var$doubleQuotedValue(source, _onError);
            break;
        /* istanbul ignore next should not happen */ default:
            onError(scalar, 'UNEXPECTED_TOKEN', `Expected a flow scalar value, but found: ${type}`);
            return {
                value: '',
                type: null,
                comment: '',
                range: [
                    offset,
                    offset + source.length,
                    offset + source.length
                ]
            };
    }
    const valueEnd = offset + source.length;
    const re = $59c911fa927d1bcf$var$resolveEnd(end, valueEnd, strict, onError);
    return {
        value: value,
        type: _type,
        comment: re.comment,
        range: [
            offset,
            valueEnd,
            re.offset
        ]
    };
}
function $59c911fa927d1bcf$var$plainValue(source, onError) {
    let badChar = '';
    switch(source[0]){
        /* istanbul ignore next should not happen */ case '\t':
            badChar = 'a tab character';
            break;
        case ',':
            badChar = 'flow indicator character ,';
            break;
        case '%':
            badChar = 'directive indicator character %';
            break;
        case '|':
        case '>':
            badChar = `block scalar indicator ${source[0]}`;
            break;
        case '@':
        case '`':
            badChar = `reserved character ${source[0]}`;
            break;
    }
    if (badChar) onError(0, 'BAD_SCALAR_START', `Plain value cannot start with ${badChar}`);
    return $59c911fa927d1bcf$var$foldLines(source);
}
function $59c911fa927d1bcf$var$singleQuotedValue(source, onError) {
    if (source[source.length - 1] !== "'" || source.length === 1) onError(source.length, 'MISSING_CHAR', "Missing closing 'quote");
    return $59c911fa927d1bcf$var$foldLines(source.slice(1, -1)).replace(/''/g, "'");
}
function $59c911fa927d1bcf$var$foldLines(source) {
    /**
     * The negative lookbehind here and in the `re` RegExp is to
     * prevent causing a polynomial search time in certain cases.
     *
     * The try-catch is for Safari, which doesn't support this yet:
     * https://caniuse.com/js-regexp-lookbehind
     */ let first, line;
    try {
        first = new RegExp('(.*?)(?<![ \t])[ \t]*\r?\n', 'sy');
        line = new RegExp('[ \t]*(.*?)(?:(?<![ \t])[ \t]*)?\r?\n', 'sy');
    } catch (_) {
        first = /(.*?)[ \t]*\r?\n/sy;
        line = /[ \t]*(.*?)[ \t]*\r?\n/sy;
    }
    let match = first.exec(source);
    if (!match) return source;
    let res = match[1];
    let sep = ' ';
    let pos = first.lastIndex;
    line.lastIndex = pos;
    while(match = line.exec(source)){
        if (match[1] === '') {
            if (sep === '\n') res += sep;
            else sep = '\n';
        } else {
            res += sep + match[1];
            sep = ' ';
        }
        pos = line.lastIndex;
    }
    const last = /[ \t]*(.*)/sy;
    last.lastIndex = pos;
    match = last.exec(source);
    return res + sep + (match && match[1] || '');
}
function $59c911fa927d1bcf$var$doubleQuotedValue(source, onError) {
    let res = '';
    for(let i = 1; i < source.length - 1; ++i){
        const ch = source[i];
        if (ch === '\r' && source[i + 1] === '\n') continue;
        if (ch === '\n') {
            const { fold: fold, offset: offset } = $59c911fa927d1bcf$var$foldNewline(source, i);
            res += fold;
            i = offset;
        } else if (ch === '\\') {
            let next = source[++i];
            const cc = $59c911fa927d1bcf$var$escapeCodes[next];
            if (cc) res += cc;
            else if (next === '\n') {
                // skip escaped newlines, but still trim the following line
                next = source[i + 1];
                while(next === ' ' || next === '\t')next = source[++i + 1];
            } else if (next === '\r' && source[i + 1] === '\n') {
                // skip escaped CRLF newlines, but still trim the following line
                next = source[++i + 1];
                while(next === ' ' || next === '\t')next = source[++i + 1];
            } else if (next === 'x' || next === 'u' || next === 'U') {
                const length = {
                    x: 2,
                    u: 4,
                    U: 8
                }[next];
                res += $59c911fa927d1bcf$var$parseCharCode(source, i + 1, length, onError);
                i += length;
            } else {
                const raw = source.substr(i - 1, 2);
                onError(i - 1, 'BAD_DQ_ESCAPE', `Invalid escape sequence ${raw}`);
                res += raw;
            }
        } else if (ch === ' ' || ch === '\t') {
            // trim trailing whitespace
            const wsStart = i;
            let next = source[i + 1];
            while(next === ' ' || next === '\t')next = source[++i + 1];
            if (next !== '\n' && !(next === '\r' && source[i + 2] === '\n')) res += i > wsStart ? source.slice(wsStart, i + 1) : ch;
        } else res += ch;
    }
    if (source[source.length - 1] !== '"' || source.length === 1) onError(source.length, 'MISSING_CHAR', 'Missing closing "quote');
    return res;
}
/**
 * Fold a single newline into a space, multiple newlines to N - 1 newlines.
 * Presumes `source[offset] === '\n'`
 */ function $59c911fa927d1bcf$var$foldNewline(source, offset) {
    let fold = '';
    let ch = source[offset + 1];
    while(ch === ' ' || ch === '\t' || ch === '\n' || ch === '\r'){
        if (ch === '\r' && source[offset + 2] !== '\n') break;
        if (ch === '\n') fold += '\n';
        offset += 1;
        ch = source[offset + 1];
    }
    if (!fold) fold = ' ';
    return {
        fold: fold,
        offset: offset
    };
}
const $59c911fa927d1bcf$var$escapeCodes = {
    '0': '\0',
    a: '\x07',
    b: '\b',
    e: '\x1b',
    f: '\f',
    n: '\n',
    r: '\r',
    t: '\t',
    v: '\v',
    N: '\u0085',
    _: '\u00a0',
    L: '\u2028',
    P: '\u2029',
    ' ': ' ',
    '"': '"',
    '/': '/',
    '\\': '\\',
    '\t': '\t'
};
function $59c911fa927d1bcf$var$parseCharCode(source, offset, length, onError) {
    const cc = source.substr(offset, length);
    const ok = cc.length === length && /^[0-9a-fA-F]+$/.test(cc);
    const code = ok ? parseInt(cc, 16) : NaN;
    if (isNaN(code)) {
        const raw = source.substr(offset - 2, length + 2);
        onError(offset - 2, 'BAD_DQ_ESCAPE', `Invalid escape sequence ${raw}`);
        return raw;
    }
    return String.fromCodePoint(code);
}
function $59c911fa927d1bcf$var$composeScalar(ctx, token, tagToken, onError) {
    const { value: value, type: type, comment: comment, range: range } = token.type === 'block-scalar' ? $59c911fa927d1bcf$var$resolveBlockScalar(token, ctx.options.strict, onError) : $59c911fa927d1bcf$var$resolveFlowScalar(token, ctx.options.strict, onError);
    const tagName = tagToken ? ctx.directives.tagName(tagToken.source, (msg)=>onError(tagToken, 'TAG_RESOLVE_FAILED', msg)) : null;
    const tag = tagToken && tagName ? $59c911fa927d1bcf$var$findScalarTagByName(ctx.schema, value, tagName, tagToken, onError) : $59c911fa927d1bcf$var$findScalarTagByTest(ctx.schema, value, token.type === 'scalar');
    let scalar;
    try {
        const res = tag.resolve(value, (msg)=>onError(tagToken || token, 'TAG_RESOLVE_FAILED', msg), ctx.options);
        scalar = $59c911fa927d1bcf$export$8f3495e22775e76c(res) ? res : new $59c911fa927d1bcf$export$595dbf49c602a1f(res);
    } catch (error) {
        const msg = error instanceof Error ? error.message : String(error);
        onError(tagToken || token, 'TAG_RESOLVE_FAILED', msg);
        scalar = new $59c911fa927d1bcf$export$595dbf49c602a1f(value);
    }
    scalar.range = range;
    scalar.source = value;
    if (type) scalar.type = type;
    if (tagName) scalar.tag = tagName;
    if (tag.format) scalar.format = tag.format;
    if (comment) scalar.comment = comment;
    return scalar;
}
function $59c911fa927d1bcf$var$findScalarTagByName(schema, value, tagName, tagToken, onError) {
    var _a;
    if (tagName === '!') return schema[$59c911fa927d1bcf$var$SCALAR]; // non-specific tag
    const matchWithTest = [];
    for (const tag of schema.tags)if (!tag.collection && tag.tag === tagName) {
        if (tag.default && tag.test) matchWithTest.push(tag);
        else return tag;
    }
    for (const tag of matchWithTest)if ((_a = tag.test) === null || _a === void 0 ? void 0 : _a.test(value)) return tag;
    const kt = schema.knownTags[tagName];
    if (kt && !kt.collection) {
        // Ensure that the known tag is available for stringifying,
        // but does not get used by default.
        schema.tags.push(Object.assign({}, kt, {
            default: false,
            test: undefined
        }));
        return kt;
    }
    onError(tagToken, 'TAG_RESOLVE_FAILED', `Unresolved tag: ${tagName}`, tagName !== 'tag:yaml.org,2002:str');
    return schema[$59c911fa927d1bcf$var$SCALAR];
}
function $59c911fa927d1bcf$var$findScalarTagByTest(schema, value, apply) {
    var _a;
    if (apply) for (const tag of schema.tags){
        if (tag.default && ((_a = tag.test) === null || _a === void 0 ? void 0 : _a.test(value))) return tag;
    }
    return schema[$59c911fa927d1bcf$var$SCALAR];
}
function $59c911fa927d1bcf$var$emptyScalarPosition(offset, before, pos) {
    if (before) {
        if (pos === null) pos = before.length;
        for(let i = pos - 1; i >= 0; --i){
            let st = before[i];
            switch(st.type){
                case 'space':
                case 'comment':
                case 'newline':
                    offset -= st.source.length;
                    continue;
            }
            // Technically, an empty scalar is immediately after the last non-empty
            // node, but it's more useful to place it after any whitespace.
            st = before[++i];
            while((st === null || st === void 0 ? void 0 : st.type) === 'space'){
                offset += st.source.length;
                st = before[++i];
            }
            break;
        }
    }
    return offset;
}
const $59c911fa927d1bcf$var$CN = {
    composeNode: $59c911fa927d1bcf$var$composeNode,
    composeEmptyNode: $59c911fa927d1bcf$var$composeEmptyNode
};
function $59c911fa927d1bcf$var$composeNode(ctx, token, props, onError) {
    const { spaceBefore: spaceBefore, comment: comment, anchor: anchor, tag: tag } = props;
    let node;
    switch(token.type){
        case 'alias':
            node = $59c911fa927d1bcf$var$composeAlias(ctx, token, onError);
            if (anchor || tag) onError(token, 'ALIAS_PROPS', 'An alias node must not specify any properties');
            break;
        case 'scalar':
        case 'single-quoted-scalar':
        case 'double-quoted-scalar':
        case 'block-scalar':
            node = $59c911fa927d1bcf$var$composeScalar(ctx, token, tag, onError);
            if (anchor) node.anchor = anchor.source.substring(1);
            break;
        case 'block-map':
        case 'block-seq':
        case 'flow-collection':
            node = $59c911fa927d1bcf$var$composeCollection($59c911fa927d1bcf$var$CN, ctx, token, tag, onError);
            if (anchor) node.anchor = anchor.source.substring(1);
            break;
        default:
            console.log(token);
            throw new Error(`Unsupporten token type: ${token.type}`);
    }
    if (anchor && node.anchor === '') onError(anchor, 'BAD_ALIAS', 'Anchor cannot be an empty string');
    if (spaceBefore) node.spaceBefore = true;
    if (comment) {
        if (token.type === 'scalar' && token.source === '') node.comment = comment;
        else node.commentBefore = comment;
    }
    return node;
}
function $59c911fa927d1bcf$var$composeEmptyNode(ctx, offset, before, pos, { spaceBefore: spaceBefore, comment: comment, anchor: anchor, tag: tag }, onError) {
    const token = {
        type: 'scalar',
        offset: $59c911fa927d1bcf$var$emptyScalarPosition(offset, before, pos),
        indent: -1,
        source: ''
    };
    const node = $59c911fa927d1bcf$var$composeScalar(ctx, token, tag, onError);
    if (anchor) {
        node.anchor = anchor.source.substring(1);
        if (node.anchor === '') onError(anchor, 'BAD_ALIAS', 'Anchor cannot be an empty string');
    }
    if (spaceBefore) node.spaceBefore = true;
    if (comment) node.comment = comment;
    return node;
}
function $59c911fa927d1bcf$var$composeAlias({ options: options }, { offset: offset, source: source, end: end }, onError) {
    const alias = new $59c911fa927d1bcf$export$17b520249a85fe16(source.substring(1));
    if (alias.source === '') onError(offset, 'BAD_ALIAS', 'Alias cannot be an empty string');
    const valueEnd = offset + source.length;
    const re = $59c911fa927d1bcf$var$resolveEnd(end, valueEnd, options.strict, onError);
    alias.range = [
        offset,
        valueEnd,
        re.offset
    ];
    if (re.comment) alias.comment = re.comment;
    return alias;
}
function $59c911fa927d1bcf$var$composeDoc(options, directives, { offset: offset, start: start, value: value, end: end }, onError) {
    const opts = Object.assign({
        directives: directives
    }, options);
    const doc = new $59c911fa927d1bcf$export$b34a105447964f9f(undefined, opts);
    const ctx = {
        directives: doc.directives,
        options: doc.options,
        schema: doc.schema
    };
    const props = $59c911fa927d1bcf$var$resolveProps(start, {
        indicator: 'doc-start',
        next: value || (end === null || end === void 0 ? void 0 : end[0]),
        offset: offset,
        onError: onError,
        startOnNewline: true
    });
    if (props.found) {
        doc.directives.marker = true;
        if (value && (value.type === 'block-map' || value.type === 'block-seq') && !props.hasNewline) onError(props.end, 'MISSING_CHAR', 'Block collection cannot start on same line with directives-end marker');
    }
    doc.contents = value ? $59c911fa927d1bcf$var$composeNode(ctx, value, props, onError) : $59c911fa927d1bcf$var$composeEmptyNode(ctx, props.end, start, null, props, onError);
    const contentEnd = doc.contents.range[2];
    const re = $59c911fa927d1bcf$var$resolveEnd(end, contentEnd, false, onError);
    if (re.comment) doc.comment = re.comment;
    doc.range = [
        offset,
        contentEnd,
        re.offset
    ];
    return doc;
}
function $59c911fa927d1bcf$var$getErrorPos(src) {
    if (typeof src === 'number') return [
        src,
        src + 1
    ];
    if (Array.isArray(src)) return src.length === 2 ? src : [
        src[0],
        src[1]
    ];
    const { offset: offset, source: source } = src;
    return [
        offset,
        offset + (typeof source === 'string' ? source.length : 1)
    ];
}
function $59c911fa927d1bcf$var$parsePrelude(prelude) {
    var _a;
    let comment = '';
    let atComment = false;
    let afterEmptyLine = false;
    for(let i = 0; i < prelude.length; ++i){
        const source = prelude[i];
        switch(source[0]){
            case '#':
                comment += (comment === '' ? '' : afterEmptyLine ? '\n\n' : '\n') + (source.substring(1) || ' ');
                atComment = true;
                afterEmptyLine = false;
                break;
            case '%':
                if (((_a = prelude[i + 1]) === null || _a === void 0 ? void 0 : _a[0]) !== '#') i += 1;
                atComment = false;
                break;
            default:
                // This may be wrong after doc-end, but in that case it doesn't matter
                if (!atComment) afterEmptyLine = true;
                atComment = false;
        }
    }
    return {
        comment: comment,
        afterEmptyLine: afterEmptyLine
    };
}
/**
 * Compose a stream of CST nodes into a stream of YAML Documents.
 *
 * ```ts
 * import { Composer, Parser } from 'yaml'
 *
 * const src: string = ...
 * const tokens = new Parser().parse(src)
 * const docs = new Composer().compose(tokens)
 * ```
 */ class $59c911fa927d1bcf$export$57ed0bcea28f97a2 {
    constructor(options = {}){
        this.doc = null;
        this.atDirectives = false;
        this.prelude = [];
        this.errors = [];
        this.warnings = [];
        this.onError = (source, code, message, warning)=>{
            const pos = $59c911fa927d1bcf$var$getErrorPos(source);
            if (warning) this.warnings.push(new $59c911fa927d1bcf$export$856b463bac79f971(pos, code, message));
            else this.errors.push(new $59c911fa927d1bcf$export$c1188aaa49090a5c(pos, code, message));
        };
        this.directives = new $59c911fa927d1bcf$var$Directives({
            version: options.version || $59c911fa927d1bcf$export$ba43bf67f3d48107.version
        });
        this.options = options;
    }
    decorate(doc, afterDoc) {
        const { comment: comment, afterEmptyLine: afterEmptyLine } = $59c911fa927d1bcf$var$parsePrelude(this.prelude);
        //console.log({ dc: doc.comment, prelude, comment })
        if (comment) {
            const dc = doc.contents;
            if (afterDoc) doc.comment = doc.comment ? `${doc.comment}\n${comment}` : comment;
            else if (afterEmptyLine || doc.directives.marker || !dc) doc.commentBefore = comment;
            else if ($59c911fa927d1bcf$export$cea7aa84e978eba5(dc) && !dc.flow && dc.items.length > 0) {
                let it = dc.items[0];
                if ($59c911fa927d1bcf$export$7c8d445944656308(it)) it = it.key;
                const cb = it.commentBefore;
                it.commentBefore = cb ? `${comment}\n${cb}` : comment;
            } else {
                const cb = dc.commentBefore;
                dc.commentBefore = cb ? `${comment}\n${cb}` : comment;
            }
        }
        if (afterDoc) {
            Array.prototype.push.apply(doc.errors, this.errors);
            Array.prototype.push.apply(doc.warnings, this.warnings);
        } else {
            doc.errors = this.errors;
            doc.warnings = this.warnings;
        }
        this.prelude = [];
        this.errors = [];
        this.warnings = [];
    }
    /**
     * Current stream status information.
     *
     * Mostly useful at the end of input for an empty stream.
     */ streamInfo() {
        return {
            comment: $59c911fa927d1bcf$var$parsePrelude(this.prelude).comment,
            directives: this.directives,
            errors: this.errors,
            warnings: this.warnings
        };
    }
    /**
     * Compose tokens into documents.
     *
     * @param forceDoc - If the stream contains no document, still emit a final document including any comments and directives that would be applied to a subsequent document.
     * @param endOffset - Should be set if `forceDoc` is also set, to set the document range end and to indicate errors correctly.
     */ *compose(tokens, forceDoc = false, endOffset = -1) {
        for (const token of tokens)yield* this.next(token);
        yield* this.end(forceDoc, endOffset);
    }
    /** Advance the composer by one CST token. */ *next(token) {
        switch(token.type){
            case 'directive':
                this.directives.add(token.source, (offset, message, warning)=>{
                    const pos = $59c911fa927d1bcf$var$getErrorPos(token);
                    pos[0] += offset;
                    this.onError(pos, 'BAD_DIRECTIVE', message, warning);
                });
                this.prelude.push(token.source);
                this.atDirectives = true;
                break;
            case 'document':
                {
                    const doc = $59c911fa927d1bcf$var$composeDoc(this.options, this.directives, token, this.onError);
                    if (this.atDirectives && !doc.directives.marker) this.onError(token, 'MISSING_CHAR', 'Missing directives-end indicator line');
                    this.decorate(doc, false);
                    if (this.doc) yield this.doc;
                    this.doc = doc;
                    this.atDirectives = false;
                    break;
                }
            case 'byte-order-mark':
            case 'space':
                break;
            case 'comment':
            case 'newline':
                this.prelude.push(token.source);
                break;
            case 'error':
                {
                    const msg = token.source ? `${token.message}: ${JSON.stringify(token.source)}` : token.message;
                    const error = new $59c911fa927d1bcf$export$c1188aaa49090a5c($59c911fa927d1bcf$var$getErrorPos(token), 'UNEXPECTED_TOKEN', msg);
                    if (this.atDirectives || !this.doc) this.errors.push(error);
                    else this.doc.errors.push(error);
                    break;
                }
            case 'doc-end':
                {
                    if (!this.doc) {
                        const msg = 'Unexpected doc-end without preceding document';
                        this.errors.push(new $59c911fa927d1bcf$export$c1188aaa49090a5c($59c911fa927d1bcf$var$getErrorPos(token), 'UNEXPECTED_TOKEN', msg));
                        break;
                    }
                    const end = $59c911fa927d1bcf$var$resolveEnd(token.end, token.offset + token.source.length, this.doc.options.strict, this.onError);
                    this.decorate(this.doc, true);
                    if (end.comment) {
                        const dc = this.doc.comment;
                        this.doc.comment = dc ? `${dc}\n${end.comment}` : end.comment;
                    }
                    this.doc.range[2] = end.offset;
                    break;
                }
            default:
                this.errors.push(new $59c911fa927d1bcf$export$c1188aaa49090a5c($59c911fa927d1bcf$var$getErrorPos(token), 'UNEXPECTED_TOKEN', `Unsupported token ${token.type}`));
        }
    }
    /**
     * Call at end of input to yield any remaining document.
     *
     * @param forceDoc - If the stream contains no document, still emit a final document including any comments and directives that would be applied to a subsequent document.
     * @param endOffset - Should be set if `forceDoc` is also set, to set the document range end and to indicate errors correctly.
     */ *end(forceDoc = false, endOffset = -1) {
        if (this.doc) {
            this.decorate(this.doc, true);
            yield this.doc;
            this.doc = null;
        } else if (forceDoc) {
            const opts = Object.assign({
                directives: this.directives
            }, this.options);
            const doc = new $59c911fa927d1bcf$export$b34a105447964f9f(undefined, opts);
            if (this.atDirectives) this.onError(endOffset, 'MISSING_CHAR', 'Missing directives-end indicator line');
            doc.range = [
                0,
                endOffset,
                endOffset
            ];
            this.decorate(doc, false);
            yield doc;
        }
    }
}
/**
 * If `token` is a CST flow or block scalar, determine its string value and a few other attributes.
 * Otherwise, return `null`.
 */ function $59c911fa927d1bcf$var$resolveAsScalar(token, strict = true, onError) {
    if (token) {
        const _onError = (pos, code, message)=>{
            const offset = typeof pos === 'number' ? pos : Array.isArray(pos) ? pos[0] : pos.offset;
            if (onError) onError(offset, code, message);
            else throw new $59c911fa927d1bcf$export$c1188aaa49090a5c([
                offset,
                offset + 1
            ], code, message);
        };
        switch(token.type){
            case 'scalar':
            case 'single-quoted-scalar':
            case 'double-quoted-scalar':
                return $59c911fa927d1bcf$var$resolveFlowScalar(token, strict, _onError);
            case 'block-scalar':
                return $59c911fa927d1bcf$var$resolveBlockScalar(token, strict, _onError);
        }
    }
    return null;
}
/**
 * Create a new scalar token with `value`
 *
 * Values that represent an actual string but may be parsed as a different type should use a `type` other than `'PLAIN'`,
 * as this function does not support any schema operations and won't check for such conflicts.
 *
 * @param value The string representation of the value, which will have its content properly indented.
 * @param context.end Comments and whitespace after the end of the value, or after the block scalar header. If undefined, a newline will be added.
 * @param context.implicitKey Being within an implicit key may affect the resolved type of the token's value.
 * @param context.indent The indent level of the token.
 * @param context.inFlow Is this scalar within a flow collection? This may affect the resolved type of the token's value.
 * @param context.offset The offset position of the token.
 * @param context.type The preferred type of the scalar token. If undefined, the previous type of the `token` will be used, defaulting to `'PLAIN'`.
 */ function $59c911fa927d1bcf$var$createScalarToken(value, context) {
    var _a;
    const { implicitKey: implicitKey = false, indent: indent, inFlow: inFlow = false, offset: offset = -1, type: type = 'PLAIN' } = context;
    const source = $59c911fa927d1bcf$var$stringifyString({
        type: type,
        value: value
    }, {
        implicitKey: implicitKey,
        indent: indent > 0 ? ' '.repeat(indent) : '',
        inFlow: inFlow,
        options: {
            lineWidth: -1
        }
    });
    const end = (_a = context.end) !== null && _a !== void 0 ? _a : [
        {
            type: 'newline',
            offset: -1,
            indent: indent,
            source: '\n'
        }
    ];
    switch(source[0]){
        case '|':
        case '>':
            {
                const he = source.indexOf('\n');
                const head = source.substring(0, he);
                const body = source.substring(he + 1) + '\n';
                const props = [
                    {
                        type: 'block-scalar-header',
                        offset: offset,
                        indent: indent,
                        source: head
                    }
                ];
                if (!$59c911fa927d1bcf$var$addEndtoBlockProps(props, end)) props.push({
                    type: 'newline',
                    offset: -1,
                    indent: indent,
                    source: '\n'
                });
                return {
                    type: 'block-scalar',
                    offset: offset,
                    indent: indent,
                    props: props,
                    source: body
                };
            }
        case '"':
            return {
                type: 'double-quoted-scalar',
                offset: offset,
                indent: indent,
                source: source,
                end: end
            };
        case "'":
            return {
                type: 'single-quoted-scalar',
                offset: offset,
                indent: indent,
                source: source,
                end: end
            };
        default:
            return {
                type: 'scalar',
                offset: offset,
                indent: indent,
                source: source,
                end: end
            };
    }
}
/**
 * Set the value of `token` to the given string `value`, overwriting any previous contents and type that it may have.
 *
 * Best efforts are made to retain any comments previously associated with the `token`,
 * though all contents within a collection's `items` will be overwritten.
 *
 * Values that represent an actual string but may be parsed as a different type should use a `type` other than `'PLAIN'`,
 * as this function does not support any schema operations and won't check for such conflicts.
 *
 * @param token Any token. If it does not include an `indent` value, the value will be stringified as if it were an implicit key.
 * @param value The string representation of the value, which will have its content properly indented.
 * @param context.afterKey In most cases, values after a key should have an additional level of indentation.
 * @param context.implicitKey Being within an implicit key may affect the resolved type of the token's value.
 * @param context.inFlow Being within a flow collection may affect the resolved type of the token's value.
 * @param context.type The preferred type of the scalar token. If undefined, the previous type of the `token` will be used, defaulting to `'PLAIN'`.
 */ function $59c911fa927d1bcf$var$setScalarValue(token, value, context = {}) {
    let { afterKey: afterKey = false, implicitKey: implicitKey = false, inFlow: inFlow = false, type: type } = context;
    let indent = 'indent' in token ? token.indent : null;
    if (afterKey && typeof indent === 'number') indent += 2;
    if (!type) switch(token.type){
        case 'single-quoted-scalar':
            type = 'QUOTE_SINGLE';
            break;
        case 'double-quoted-scalar':
            type = 'QUOTE_DOUBLE';
            break;
        case 'block-scalar':
            {
                const header = token.props[0];
                if (header.type !== 'block-scalar-header') throw new Error('Invalid block scalar header');
                type = header.source[0] === '>' ? 'BLOCK_FOLDED' : 'BLOCK_LITERAL';
                break;
            }
        default:
            type = 'PLAIN';
    }
    const source = $59c911fa927d1bcf$var$stringifyString({
        type: type,
        value: value
    }, {
        implicitKey: implicitKey || indent === null,
        indent: indent !== null && indent > 0 ? ' '.repeat(indent) : '',
        inFlow: inFlow,
        options: {
            lineWidth: -1
        }
    });
    switch(source[0]){
        case '|':
        case '>':
            $59c911fa927d1bcf$var$setBlockScalarValue(token, source);
            break;
        case '"':
            $59c911fa927d1bcf$var$setFlowScalarValue(token, source, 'double-quoted-scalar');
            break;
        case "'":
            $59c911fa927d1bcf$var$setFlowScalarValue(token, source, 'single-quoted-scalar');
            break;
        default:
            $59c911fa927d1bcf$var$setFlowScalarValue(token, source, 'scalar');
    }
}
function $59c911fa927d1bcf$var$setBlockScalarValue(token, source) {
    const he = source.indexOf('\n');
    const head = source.substring(0, he);
    const body = source.substring(he + 1) + '\n';
    if (token.type === 'block-scalar') {
        const header = token.props[0];
        if (header.type !== 'block-scalar-header') throw new Error('Invalid block scalar header');
        header.source = head;
        token.source = body;
    } else {
        const { offset: offset } = token;
        const indent = 'indent' in token ? token.indent : -1;
        const props = [
            {
                type: 'block-scalar-header',
                offset: offset,
                indent: indent,
                source: head
            }
        ];
        if (!$59c911fa927d1bcf$var$addEndtoBlockProps(props, 'end' in token ? token.end : undefined)) props.push({
            type: 'newline',
            offset: -1,
            indent: indent,
            source: '\n'
        });
        for (const key of Object.keys(token))if (key !== 'type' && key !== 'offset') delete token[key];
        Object.assign(token, {
            type: 'block-scalar',
            indent: indent,
            props: props,
            source: body
        });
    }
}
/** @returns `true` if last token is a newline */ function $59c911fa927d1bcf$var$addEndtoBlockProps(props, end) {
    if (end) for (const st of end)switch(st.type){
        case 'space':
        case 'comment':
            props.push(st);
            break;
        case 'newline':
            props.push(st);
            return true;
    }
    return false;
}
function $59c911fa927d1bcf$var$setFlowScalarValue(token, source, type) {
    switch(token.type){
        case 'scalar':
        case 'double-quoted-scalar':
        case 'single-quoted-scalar':
            token.type = type;
            token.source = source;
            break;
        case 'block-scalar':
            {
                const end = token.props.slice(1);
                let oa = source.length;
                if (token.props[0].type === 'block-scalar-header') oa -= token.props[0].source.length;
                for (const tok of end)tok.offset += oa;
                delete token.props;
                Object.assign(token, {
                    type: type,
                    source: source,
                    end: end
                });
                break;
            }
        case 'block-map':
        case 'block-seq':
            {
                const offset = token.offset + source.length;
                const nl = {
                    type: 'newline',
                    offset: offset,
                    indent: token.indent,
                    source: '\n'
                };
                delete token.items;
                Object.assign(token, {
                    type: type,
                    source: source,
                    end: [
                        nl
                    ]
                });
                break;
            }
        default:
            {
                const indent = 'indent' in token ? token.indent : -1;
                const end = 'end' in token && Array.isArray(token.end) ? token.end.filter((st)=>st.type === 'space' || st.type === 'comment' || st.type === 'newline') : [];
                for (const key of Object.keys(token))if (key !== 'type' && key !== 'offset') delete token[key];
                Object.assign(token, {
                    type: type,
                    indent: indent,
                    source: source,
                    end: end
                });
            }
    }
}
/**
 * Stringify a CST document, token, or collection item
 *
 * Fair warning: This applies no validation whatsoever, and
 * simply concatenates the sources in their logical order.
 */ const $59c911fa927d1bcf$var$stringify$1 = (cst)=>'type' in cst ? $59c911fa927d1bcf$var$stringifyToken(cst) : $59c911fa927d1bcf$var$stringifyItem(cst);
function $59c911fa927d1bcf$var$stringifyToken(token) {
    switch(token.type){
        case 'block-scalar':
            {
                let res = '';
                for (const tok of token.props)res += $59c911fa927d1bcf$var$stringifyToken(tok);
                return res + token.source;
            }
        case 'block-map':
        case 'block-seq':
            {
                let res = '';
                for (const item of token.items)res += $59c911fa927d1bcf$var$stringifyItem(item);
                return res;
            }
        case 'flow-collection':
            {
                let res = token.start.source;
                for (const item of token.items)res += $59c911fa927d1bcf$var$stringifyItem(item);
                for (const st of token.end)res += st.source;
                return res;
            }
        case 'document':
            {
                let res = $59c911fa927d1bcf$var$stringifyItem(token);
                if (token.end) for (const st of token.end)res += st.source;
                return res;
            }
        default:
            {
                let res = token.source;
                if ('end' in token && token.end) for (const st of token.end)res += st.source;
                return res;
            }
    }
}
function $59c911fa927d1bcf$var$stringifyItem({ start: start, key: key, sep: sep, value: value }) {
    let res = '';
    for (const st of start)res += st.source;
    if (key) res += $59c911fa927d1bcf$var$stringifyToken(key);
    if (sep) for (const st of sep)res += st.source;
    if (value) res += $59c911fa927d1bcf$var$stringifyToken(value);
    return res;
}
const $59c911fa927d1bcf$var$BREAK$1 = Symbol('break visit');
const $59c911fa927d1bcf$var$SKIP$1 = Symbol('skip children');
const $59c911fa927d1bcf$var$REMOVE$1 = Symbol('remove item');
/**
 * Apply a visitor to a CST document or item.
 *
 * Walks through the tree (depth-first) starting from the root, calling a
 * `visitor` function with two arguments when entering each item:
 *   - `item`: The current item, which included the following members:
 *     - `start: SourceToken[]` – Source tokens before the key or value,
 *       possibly including its anchor or tag.
 *     - `key?: Token | null` – Set for pair values. May then be `null`, if
 *       the key before the `:` separator is empty.
 *     - `sep?: SourceToken[]` – Source tokens between the key and the value,
 *       which should include the `:` map value indicator if `value` is set.
 *     - `value?: Token` – The value of a sequence item, or of a map pair.
 *   - `path`: The steps from the root to the current node, as an array of
 *     `['key' | 'value', number]` tuples.
 *
 * The return value of the visitor may be used to control the traversal:
 *   - `undefined` (default): Do nothing and continue
 *   - `visit.SKIP`: Do not visit the children of this token, continue with
 *      next sibling
 *   - `visit.BREAK`: Terminate traversal completely
 *   - `visit.REMOVE`: Remove the current item, then continue with the next one
 *   - `number`: Set the index of the next step. This is useful especially if
 *     the index of the current token has changed.
 *   - `function`: Define the next visitor for this item. After the original
 *     visitor is called on item entry, next visitors are called after handling
 *     a non-empty `key` and when exiting the item.
 */ function $59c911fa927d1bcf$var$visit$1(cst, visitor) {
    if ('type' in cst && cst.type === 'document') cst = {
        start: cst.start,
        value: cst.value
    };
    $59c911fa927d1bcf$var$_visit$1(Object.freeze([]), cst, visitor);
}
// Without the `as symbol` casts, TS declares these in the `visit`
// namespace using `var`, but then complains about that because
// `unique symbol` must be `const`.
/** Terminate visit traversal completely */ $59c911fa927d1bcf$var$visit$1.BREAK = $59c911fa927d1bcf$var$BREAK$1;
/** Do not visit the children of the current item */ $59c911fa927d1bcf$var$visit$1.SKIP = $59c911fa927d1bcf$var$SKIP$1;
/** Remove the current item */ $59c911fa927d1bcf$var$visit$1.REMOVE = $59c911fa927d1bcf$var$REMOVE$1;
/** Find the item at `path` from `cst` as the root */ $59c911fa927d1bcf$var$visit$1.itemAtPath = (cst, path)=>{
    let item = cst;
    for (const [field, index] of path){
        const tok = item && item[field];
        if (tok && 'items' in tok) item = tok.items[index];
        else return undefined;
    }
    return item;
};
/**
 * Get the immediate parent collection of the item at `path` from `cst` as the root.
 *
 * Throws an error if the collection is not found, which should never happen if the item itself exists.
 */ $59c911fa927d1bcf$var$visit$1.parentCollection = (cst, path)=>{
    const parent = $59c911fa927d1bcf$var$visit$1.itemAtPath(cst, path.slice(0, -1));
    const field = path[path.length - 1][0];
    const coll = parent && parent[field];
    if (coll && 'items' in coll) return coll;
    throw new Error('Parent collection not found');
};
function $59c911fa927d1bcf$var$_visit$1(path, item, visitor) {
    let ctrl = visitor(item, path);
    if (typeof ctrl === 'symbol') return ctrl;
    for (const field of [
        'key',
        'value'
    ]){
        const token = item[field];
        if (token && 'items' in token) {
            for(let i = 0; i < token.items.length; ++i){
                const ci = $59c911fa927d1bcf$var$_visit$1(Object.freeze(path.concat([
                    [
                        field,
                        i
                    ]
                ])), token.items[i], visitor);
                if (typeof ci === 'number') i = ci - 1;
                else if (ci === $59c911fa927d1bcf$var$BREAK$1) return $59c911fa927d1bcf$var$BREAK$1;
                else if (ci === $59c911fa927d1bcf$var$REMOVE$1) {
                    token.items.splice(i, 1);
                    i -= 1;
                }
            }
            if (typeof ctrl === 'function' && field === 'key') ctrl = ctrl(item, path);
        }
    }
    return typeof ctrl === 'function' ? ctrl(item, path) : ctrl;
}
/** The byte order mark */ const $59c911fa927d1bcf$var$BOM = '\u{FEFF}';
/** Start of doc-mode */ const $59c911fa927d1bcf$var$DOCUMENT = '\x02'; // C0: Start of Text
/** Unexpected end of flow-mode */ const $59c911fa927d1bcf$var$FLOW_END = '\x18'; // C0: Cancel
/** Next token is a scalar value */ const $59c911fa927d1bcf$var$SCALAR$1 = '\x1f'; // C0: Unit Separator
/** @returns `true` if `token` is a flow or block collection */ const $59c911fa927d1bcf$var$isCollection$1 = (token)=>!!token && 'items' in token;
/** @returns `true` if `token` is a flow or block scalar; not an alias */ const $59c911fa927d1bcf$var$isScalar$1 = (token)=>!!token && (token.type === 'scalar' || token.type === 'single-quoted-scalar' || token.type === 'double-quoted-scalar' || token.type === 'block-scalar');
/* istanbul ignore next */ /** Get a printable representation of a lexer token */ function $59c911fa927d1bcf$var$prettyToken(token) {
    switch(token){
        case $59c911fa927d1bcf$var$BOM:
            return '<BOM>';
        case $59c911fa927d1bcf$var$DOCUMENT:
            return '<DOC>';
        case $59c911fa927d1bcf$var$FLOW_END:
            return '<FLOW_END>';
        case $59c911fa927d1bcf$var$SCALAR$1:
            return '<SCALAR>';
        default:
            return JSON.stringify(token);
    }
}
/** Identify the type of a lexer token. May return `null` for unknown tokens. */ function $59c911fa927d1bcf$var$tokenType(source) {
    switch(source){
        case $59c911fa927d1bcf$var$BOM:
            return 'byte-order-mark';
        case $59c911fa927d1bcf$var$DOCUMENT:
            return 'doc-mode';
        case $59c911fa927d1bcf$var$FLOW_END:
            return 'flow-error-end';
        case $59c911fa927d1bcf$var$SCALAR$1:
            return 'scalar';
        case '---':
            return 'doc-start';
        case '...':
            return 'doc-end';
        case '':
        case '\n':
        case '\r\n':
            return 'newline';
        case '-':
            return 'seq-item-ind';
        case '?':
            return 'explicit-key-ind';
        case ':':
            return 'map-value-ind';
        case '{':
            return 'flow-map-start';
        case '}':
            return 'flow-map-end';
        case '[':
            return 'flow-seq-start';
        case ']':
            return 'flow-seq-end';
        case ',':
            return 'comma';
    }
    switch(source[0]){
        case ' ':
        case '\t':
            return 'space';
        case '#':
            return 'comment';
        case '%':
            return 'directive-line';
        case '*':
            return 'alias';
        case '&':
            return 'anchor';
        case '!':
            return 'tag';
        case "'":
            return 'single-quoted-scalar';
        case '"':
            return 'double-quoted-scalar';
        case '|':
        case '>':
            return 'block-scalar-header';
    }
    return null;
}
var $59c911fa927d1bcf$export$dd3c50b1c80c78ef = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BOM: $59c911fa927d1bcf$var$BOM,
    DOCUMENT: $59c911fa927d1bcf$var$DOCUMENT,
    FLOW_END: $59c911fa927d1bcf$var$FLOW_END,
    SCALAR: $59c911fa927d1bcf$var$SCALAR$1,
    isCollection: $59c911fa927d1bcf$var$isCollection$1,
    isScalar: $59c911fa927d1bcf$var$isScalar$1,
    prettyToken: $59c911fa927d1bcf$var$prettyToken,
    tokenType: $59c911fa927d1bcf$var$tokenType,
    createScalarToken: $59c911fa927d1bcf$var$createScalarToken,
    resolveAsScalar: $59c911fa927d1bcf$var$resolveAsScalar,
    setScalarValue: $59c911fa927d1bcf$var$setScalarValue,
    stringify: $59c911fa927d1bcf$var$stringify$1,
    visit: $59c911fa927d1bcf$var$visit$1
});
/*
START -> stream

stream
  directive -> line-end -> stream
  indent + line-end -> stream
  [else] -> line-start

line-end
  comment -> line-end
  newline -> .
  input-end -> END

line-start
  doc-start -> doc
  doc-end -> stream
  [else] -> indent -> block-start

block-start
  seq-item-start -> block-start
  explicit-key-start -> block-start
  map-value-start -> block-start
  [else] -> doc

doc
  line-end -> line-start
  spaces -> doc
  anchor -> doc
  tag -> doc
  flow-start -> flow -> doc
  flow-end -> error -> doc
  seq-item-start -> error -> doc
  explicit-key-start -> error -> doc
  map-value-start -> doc
  alias -> doc
  quote-start -> quoted-scalar -> doc
  block-scalar-header -> line-end -> block-scalar(min) -> line-start
  [else] -> plain-scalar(false, min) -> doc

flow
  line-end -> flow
  spaces -> flow
  anchor -> flow
  tag -> flow
  flow-start -> flow -> flow
  flow-end -> .
  seq-item-start -> error -> flow
  explicit-key-start -> flow
  map-value-start -> flow
  alias -> flow
  quote-start -> quoted-scalar -> flow
  comma -> flow
  [else] -> plain-scalar(true, 0) -> flow

quoted-scalar
  quote-end -> .
  [else] -> quoted-scalar

block-scalar(min)
  newline + peek(indent < min) -> .
  [else] -> block-scalar(min)

plain-scalar(is-flow, min)
  scalar-end(is-flow) -> .
  peek(newline + (indent < min)) -> .
  [else] -> plain-scalar(min)
*/ function $59c911fa927d1bcf$var$isEmpty(ch) {
    switch(ch){
        case undefined:
        case ' ':
        case '\n':
        case '\r':
        case '\t':
            return true;
        default:
            return false;
    }
}
const $59c911fa927d1bcf$var$hexDigits = '0123456789ABCDEFabcdef'.split('');
const $59c911fa927d1bcf$var$tagChars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-#;/?:@&=+$_.!~*'()".split('');
const $59c911fa927d1bcf$var$invalidFlowScalarChars = ',[]{}'.split('');
const $59c911fa927d1bcf$var$invalidAnchorChars = ' ,[]{}\n\r\t'.split('');
const $59c911fa927d1bcf$var$isNotAnchorChar = (ch)=>!ch || $59c911fa927d1bcf$var$invalidAnchorChars.includes(ch);
/**
 * Splits an input string into lexical tokens, i.e. smaller strings that are
 * easily identifiable by `tokens.tokenType()`.
 *
 * Lexing starts always in a "stream" context. Incomplete input may be buffered
 * until a complete token can be emitted.
 *
 * In addition to slices of the original input, the following control characters
 * may also be emitted:
 *
 * - `\x02` (Start of Text): A document starts with the next token
 * - `\x18` (Cancel): Unexpected end of flow-mode (indicates an error)
 * - `\x1f` (Unit Separator): Next token is a scalar value
 * - `\u{FEFF}` (Byte order mark): Emitted separately outside documents
 */ class $59c911fa927d1bcf$export$6168dc8908a6c652 {
    constructor(){
        /**
         * Flag indicating whether the end of the current buffer marks the end of
         * all input
         */ this.atEnd = false;
        /**
         * Explicit indent set in block scalar header, as an offset from the current
         * minimum indent, so e.g. set to 1 from a header `|2+`. Set to -1 if not
         * explicitly set.
         */ this.blockScalarIndent = -1;
        /**
         * Block scalars that include a + (keep) chomping indicator in their header
         * include trailing empty lines, which are otherwise excluded from the
         * scalar's contents.
         */ this.blockScalarKeep = false;
        /** Current input */ this.buffer = '';
        /**
         * Flag noting whether the map value indicator : can immediately follow this
         * node within a flow context.
         */ this.flowKey = false;
        /** Count of surrounding flow collection levels. */ this.flowLevel = 0;
        /**
         * Minimum level of indentation required for next lines to be parsed as a
         * part of the current scalar value.
         */ this.indentNext = 0;
        /** Indentation level of the current line. */ this.indentValue = 0;
        /** Position of the next \n character. */ this.lineEndPos = null;
        /** Stores the state of the lexer if reaching the end of incpomplete input */ this.next = null;
        /** A pointer to `buffer`; the current position of the lexer. */ this.pos = 0;
    }
    /**
     * Generate YAML tokens from the `source` string. If `incomplete`,
     * a part of the last line may be left as a buffer for the next call.
     *
     * @returns A generator of lexical tokens
     */ *lex(source, incomplete = false) {
        if (source) {
            this.buffer = this.buffer ? this.buffer + source : source;
            this.lineEndPos = null;
        }
        this.atEnd = !incomplete;
        let next = this.next || 'stream';
        while(next && (incomplete || this.hasChars(1)))next = yield* this.parseNext(next);
    }
    atLineEnd() {
        let i = this.pos;
        let ch = this.buffer[i];
        while(ch === ' ' || ch === '\t')ch = this.buffer[++i];
        if (!ch || ch === '#' || ch === '\n') return true;
        if (ch === '\r') return this.buffer[i + 1] === '\n';
        return false;
    }
    charAt(n) {
        return this.buffer[this.pos + n];
    }
    continueScalar(offset) {
        let ch = this.buffer[offset];
        if (this.indentNext > 0) {
            let indent = 0;
            while(ch === ' ')ch = this.buffer[++indent + offset];
            if (ch === '\r') {
                const next = this.buffer[indent + offset + 1];
                if (next === '\n' || !next && !this.atEnd) return offset + indent + 1;
            }
            return ch === '\n' || indent >= this.indentNext || !ch && !this.atEnd ? offset + indent : -1;
        }
        if (ch === '-' || ch === '.') {
            const dt = this.buffer.substr(offset, 3);
            if ((dt === '---' || dt === '...') && $59c911fa927d1bcf$var$isEmpty(this.buffer[offset + 3])) return -1;
        }
        return offset;
    }
    getLine() {
        let end = this.lineEndPos;
        if (typeof end !== 'number' || end !== -1 && end < this.pos) {
            end = this.buffer.indexOf('\n', this.pos);
            this.lineEndPos = end;
        }
        if (end === -1) return this.atEnd ? this.buffer.substring(this.pos) : null;
        if (this.buffer[end - 1] === '\r') end -= 1;
        return this.buffer.substring(this.pos, end);
    }
    hasChars(n) {
        return this.pos + n <= this.buffer.length;
    }
    setNext(state) {
        this.buffer = this.buffer.substring(this.pos);
        this.pos = 0;
        this.lineEndPos = null;
        this.next = state;
        return null;
    }
    peek(n) {
        return this.buffer.substr(this.pos, n);
    }
    *parseNext(next) {
        switch(next){
            case 'stream':
                return yield* this.parseStream();
            case 'line-start':
                return yield* this.parseLineStart();
            case 'block-start':
                return yield* this.parseBlockStart();
            case 'doc':
                return yield* this.parseDocument();
            case 'flow':
                return yield* this.parseFlowCollection();
            case 'quoted-scalar':
                return yield* this.parseQuotedScalar();
            case 'block-scalar':
                return yield* this.parseBlockScalar();
            case 'plain-scalar':
                return yield* this.parsePlainScalar();
        }
    }
    *parseStream() {
        let line = this.getLine();
        if (line === null) return this.setNext('stream');
        if (line[0] === $59c911fa927d1bcf$var$BOM) {
            yield* this.pushCount(1);
            line = line.substring(1);
        }
        if (line[0] === '%') {
            let dirEnd = line.length;
            const cs = line.indexOf('#');
            if (cs !== -1) {
                const ch = line[cs - 1];
                if (ch === ' ' || ch === '\t') dirEnd = cs - 1;
            }
            while(true){
                const ch = line[dirEnd - 1];
                if (ch === ' ' || ch === '\t') dirEnd -= 1;
                else break;
            }
            const n = (yield* this.pushCount(dirEnd)) + (yield* this.pushSpaces(true));
            yield* this.pushCount(line.length - n); // possible comment
            this.pushNewline();
            return 'stream';
        }
        if (this.atLineEnd()) {
            const sp = yield* this.pushSpaces(true);
            yield* this.pushCount(line.length - sp);
            yield* this.pushNewline();
            return 'stream';
        }
        yield $59c911fa927d1bcf$var$DOCUMENT;
        return yield* this.parseLineStart();
    }
    *parseLineStart() {
        const ch = this.charAt(0);
        if (!ch && !this.atEnd) return this.setNext('line-start');
        if (ch === '-' || ch === '.') {
            if (!this.atEnd && !this.hasChars(4)) return this.setNext('line-start');
            const s = this.peek(3);
            if (s === '---' && $59c911fa927d1bcf$var$isEmpty(this.charAt(3))) {
                yield* this.pushCount(3);
                this.indentValue = 0;
                this.indentNext = 0;
                return 'doc';
            } else if (s === '...' && $59c911fa927d1bcf$var$isEmpty(this.charAt(3))) {
                yield* this.pushCount(3);
                return 'stream';
            }
        }
        this.indentValue = yield* this.pushSpaces(false);
        if (this.indentNext > this.indentValue && !$59c911fa927d1bcf$var$isEmpty(this.charAt(1))) this.indentNext = this.indentValue;
        return yield* this.parseBlockStart();
    }
    *parseBlockStart() {
        const [ch0, ch1] = this.peek(2);
        if (!ch1 && !this.atEnd) return this.setNext('block-start');
        if ((ch0 === '-' || ch0 === '?' || ch0 === ':') && $59c911fa927d1bcf$var$isEmpty(ch1)) {
            const n = (yield* this.pushCount(1)) + (yield* this.pushSpaces(true));
            this.indentNext = this.indentValue + 1;
            this.indentValue += n;
            return yield* this.parseBlockStart();
        }
        return 'doc';
    }
    *parseDocument() {
        yield* this.pushSpaces(true);
        const line = this.getLine();
        if (line === null) return this.setNext('doc');
        let n = yield* this.pushIndicators();
        switch(line[n]){
            case '#':
                yield* this.pushCount(line.length - n);
            // fallthrough
            case undefined:
                yield* this.pushNewline();
                return yield* this.parseLineStart();
            case '{':
            case '[':
                yield* this.pushCount(1);
                this.flowKey = false;
                this.flowLevel = 1;
                return 'flow';
            case '}':
            case ']':
                // this is an error
                yield* this.pushCount(1);
                return 'doc';
            case '*':
                yield* this.pushUntil($59c911fa927d1bcf$var$isNotAnchorChar);
                return 'doc';
            case '"':
            case "'":
                return yield* this.parseQuotedScalar();
            case '|':
            case '>':
                n += yield* this.parseBlockScalarHeader();
                n += yield* this.pushSpaces(true);
                yield* this.pushCount(line.length - n);
                yield* this.pushNewline();
                return yield* this.parseBlockScalar();
            default:
                return yield* this.parsePlainScalar();
        }
    }
    *parseFlowCollection() {
        let nl, sp;
        let indent = -1;
        do {
            nl = yield* this.pushNewline();
            sp = yield* this.pushSpaces(true);
            if (nl > 0) this.indentValue = indent = sp;
        }while (nl + sp > 0);
        const line = this.getLine();
        if (line === null) return this.setNext('flow');
        if (indent !== -1 && indent < this.indentNext || indent === 0 && (line.startsWith('---') || line.startsWith('...')) && $59c911fa927d1bcf$var$isEmpty(line[3])) {
            // Allowing for the terminal ] or } at the same (rather than greater)
            // indent level as the initial [ or { is technically invalid, but
            // failing here would be surprising to users.
            const atFlowEndMarker = indent === this.indentNext - 1 && this.flowLevel === 1 && (line[0] === ']' || line[0] === '}');
            if (!atFlowEndMarker) {
                // this is an error
                this.flowLevel = 0;
                yield $59c911fa927d1bcf$var$FLOW_END;
                return yield* this.parseLineStart();
            }
        }
        let n = 0;
        while(line[n] === ',')n += (yield* this.pushCount(1)) + (yield* this.pushSpaces(true));
        n += yield* this.pushIndicators();
        switch(line[n]){
            case undefined:
                return 'flow';
            case '#':
                yield* this.pushCount(line.length - n);
                return 'flow';
            case '{':
            case '[':
                yield* this.pushCount(1);
                this.flowKey = false;
                this.flowLevel += 1;
                return 'flow';
            case '}':
            case ']':
                yield* this.pushCount(1);
                this.flowKey = true;
                this.flowLevel -= 1;
                return this.flowLevel ? 'flow' : 'doc';
            case '*':
                yield* this.pushUntil($59c911fa927d1bcf$var$isNotAnchorChar);
                return 'flow';
            case '"':
            case "'":
                this.flowKey = true;
                return yield* this.parseQuotedScalar();
            case ':':
                {
                    const next = this.charAt(1);
                    if (this.flowKey || $59c911fa927d1bcf$var$isEmpty(next) || next === ',') {
                        yield* this.pushCount(1);
                        yield* this.pushSpaces(true);
                        return 'flow';
                    }
                }
            // fallthrough
            default:
                this.flowKey = false;
                return yield* this.parsePlainScalar();
        }
    }
    *parseQuotedScalar() {
        const quote = this.charAt(0);
        let end = this.buffer.indexOf(quote, this.pos + 1);
        if (quote === "'") while(end !== -1 && this.buffer[end + 1] === "'")end = this.buffer.indexOf("'", end + 2);
        else // double-quote
        while(end !== -1){
            let n = 0;
            while(this.buffer[end - 1 - n] === '\\')n += 1;
            if (n % 2 === 0) break;
            end = this.buffer.indexOf('"', end + 1);
        }
        // Only looking for newlines within the quotes
        const qb = this.buffer.substring(0, end);
        let nl = qb.indexOf('\n', this.pos);
        if (nl !== -1) {
            while(nl !== -1){
                const cs = this.continueScalar(nl + 1);
                if (cs === -1) break;
                nl = qb.indexOf('\n', cs);
            }
            if (nl !== -1) // this is an error caused by an unexpected unindent
            end = nl - (qb[nl - 1] === '\r' ? 2 : 1);
        }
        if (end === -1) {
            if (!this.atEnd) return this.setNext('quoted-scalar');
            end = this.buffer.length;
        }
        yield* this.pushToIndex(end + 1, false);
        return this.flowLevel ? 'flow' : 'doc';
    }
    *parseBlockScalarHeader() {
        this.blockScalarIndent = -1;
        this.blockScalarKeep = false;
        let i = this.pos;
        while(true){
            const ch = this.buffer[++i];
            if (ch === '+') this.blockScalarKeep = true;
            else if (ch > '0' && ch <= '9') this.blockScalarIndent = Number(ch) - 1;
            else if (ch !== '-') break;
        }
        return yield* this.pushUntil((ch)=>$59c911fa927d1bcf$var$isEmpty(ch) || ch === '#');
    }
    *parseBlockScalar() {
        let nl = this.pos - 1; // may be -1 if this.pos === 0
        let indent = 0;
        let ch;
        loop: for(let i = this.pos; ch = this.buffer[i]; ++i)switch(ch){
            case ' ':
                indent += 1;
                break;
            case '\n':
                nl = i;
                indent = 0;
                break;
            case '\r':
                {
                    const next = this.buffer[i + 1];
                    if (!next && !this.atEnd) return this.setNext('block-scalar');
                    if (next === '\n') break;
                }
            default:
                break loop;
        }
        if (!ch && !this.atEnd) return this.setNext('block-scalar');
        if (indent >= this.indentNext) {
            if (this.blockScalarIndent === -1) this.indentNext = indent;
            else this.indentNext += this.blockScalarIndent;
            do {
                const cs = this.continueScalar(nl + 1);
                if (cs === -1) break;
                nl = this.buffer.indexOf('\n', cs);
            }while (nl !== -1);
            if (nl === -1) {
                if (!this.atEnd) return this.setNext('block-scalar');
                nl = this.buffer.length;
            }
        }
        if (!this.blockScalarKeep) do {
            let i = nl - 1;
            let ch = this.buffer[i];
            if (ch === '\r') ch = this.buffer[--i];
            while(ch === ' ' || ch === '\t')ch = this.buffer[--i];
            if (ch === '\n' && i >= this.pos) nl = i;
            else break;
        }while (true);
        yield $59c911fa927d1bcf$var$SCALAR$1;
        yield* this.pushToIndex(nl + 1, true);
        return yield* this.parseLineStart();
    }
    *parsePlainScalar() {
        const inFlow = this.flowLevel > 0;
        let end = this.pos - 1;
        let i = this.pos - 1;
        let ch;
        while(ch = this.buffer[++i]){
            if (ch === ':') {
                const next = this.buffer[i + 1];
                if ($59c911fa927d1bcf$var$isEmpty(next) || inFlow && next === ',') break;
                end = i;
            } else if ($59c911fa927d1bcf$var$isEmpty(ch)) {
                let next = this.buffer[i + 1];
                if (ch === '\r') {
                    if (next === '\n') {
                        i += 1;
                        ch = '\n';
                        next = this.buffer[i + 1];
                    } else end = i;
                }
                if (next === '#' || inFlow && $59c911fa927d1bcf$var$invalidFlowScalarChars.includes(next)) break;
                if (ch === '\n') {
                    const cs = this.continueScalar(i + 1);
                    if (cs === -1) break;
                    i = Math.max(i, cs - 2); // to advance, but still account for ' #'
                }
            } else {
                if (inFlow && $59c911fa927d1bcf$var$invalidFlowScalarChars.includes(ch)) break;
                end = i;
            }
        }
        if (!ch && !this.atEnd) return this.setNext('plain-scalar');
        yield $59c911fa927d1bcf$var$SCALAR$1;
        yield* this.pushToIndex(end + 1, true);
        return inFlow ? 'flow' : 'doc';
    }
    *pushCount(n) {
        if (n > 0) {
            yield this.buffer.substr(this.pos, n);
            this.pos += n;
            return n;
        }
        return 0;
    }
    *pushToIndex(i, allowEmpty) {
        const s = this.buffer.slice(this.pos, i);
        if (s) {
            yield s;
            this.pos += s.length;
            return s.length;
        } else if (allowEmpty) yield '';
        return 0;
    }
    *pushIndicators() {
        switch(this.charAt(0)){
            case '!':
                return (yield* this.pushTag()) + (yield* this.pushSpaces(true)) + (yield* this.pushIndicators());
            case '&':
                return (yield* this.pushUntil($59c911fa927d1bcf$var$isNotAnchorChar)) + (yield* this.pushSpaces(true)) + (yield* this.pushIndicators());
            case ':':
            case '?':
            case '-':
                if ($59c911fa927d1bcf$var$isEmpty(this.charAt(1))) {
                    if (this.flowLevel === 0) this.indentNext = this.indentValue + 1;
                    return (yield* this.pushCount(1)) + (yield* this.pushSpaces(true)) + (yield* this.pushIndicators());
                }
        }
        return 0;
    }
    *pushTag() {
        if (this.charAt(1) === '<') {
            let i = this.pos + 2;
            let ch = this.buffer[i];
            while(!$59c911fa927d1bcf$var$isEmpty(ch) && ch !== '>')ch = this.buffer[++i];
            return yield* this.pushToIndex(ch === '>' ? i + 1 : i, false);
        } else {
            let i = this.pos + 1;
            let ch = this.buffer[i];
            while(ch){
                if ($59c911fa927d1bcf$var$tagChars.includes(ch)) ch = this.buffer[++i];
                else if (ch === '%' && $59c911fa927d1bcf$var$hexDigits.includes(this.buffer[i + 1]) && $59c911fa927d1bcf$var$hexDigits.includes(this.buffer[i + 2])) ch = this.buffer[i += 3];
                else break;
            }
            return yield* this.pushToIndex(i, false);
        }
    }
    *pushNewline() {
        const ch = this.buffer[this.pos];
        if (ch === '\n') return yield* this.pushCount(1);
        else if (ch === '\r' && this.charAt(1) === '\n') return yield* this.pushCount(2);
        else return 0;
    }
    *pushSpaces(allowTabs) {
        let i = this.pos - 1;
        let ch;
        do ch = this.buffer[++i];
        while (ch === ' ' || allowTabs && ch === '\t');
        const n = i - this.pos;
        if (n > 0) {
            yield this.buffer.substr(this.pos, n);
            this.pos = i;
        }
        return n;
    }
    *pushUntil(test) {
        let i = this.pos;
        let ch = this.buffer[i];
        while(!test(ch))ch = this.buffer[++i];
        return yield* this.pushToIndex(i, false);
    }
}
/**
 * Tracks newlines during parsing in order to provide an efficient API for
 * determining the one-indexed `{ line, col }` position for any offset
 * within the input.
 */ class $59c911fa927d1bcf$export$c8a6f24ae2865e59 {
    constructor(){
        this.lineStarts = [];
        /**
         * Should be called in ascending order. Otherwise, call
         * `lineCounter.lineStarts.sort()` before calling `linePos()`.
         */ this.addNewLine = (offset)=>this.lineStarts.push(offset);
        /**
         * Performs a binary search and returns the 1-indexed { line, col }
         * position of `offset`. If `line === 0`, `addNewLine` has never been
         * called or `offset` is before the first known newline.
         */ this.linePos = (offset)=>{
            let low = 0;
            let high = this.lineStarts.length;
            while(low < high){
                const mid = low + high >> 1; // Math.floor((low + high) / 2)
                if (this.lineStarts[mid] < offset) low = mid + 1;
                else high = mid;
            }
            if (this.lineStarts[low] === offset) return {
                line: low + 1,
                col: 1
            };
            if (low === 0) return {
                line: 0,
                col: offset
            };
            const start = this.lineStarts[low - 1];
            return {
                line: low,
                col: offset - start + 1
            };
        };
    }
}
function $59c911fa927d1bcf$var$includesToken(list, type) {
    for(let i = 0; i < list.length; ++i)if (list[i].type === type) return true;
    return false;
}
function $59c911fa927d1bcf$var$includesNonEmpty(list) {
    for(let i = 0; i < list.length; ++i)switch(list[i].type){
        case 'space':
        case 'comment':
        case 'newline':
            break;
        default:
            return true;
    }
    return false;
}
function $59c911fa927d1bcf$var$isFlowToken(token) {
    switch(token === null || token === void 0 ? void 0 : token.type){
        case 'alias':
        case 'scalar':
        case 'single-quoted-scalar':
        case 'double-quoted-scalar':
        case 'flow-collection':
            return true;
        default:
            return false;
    }
}
function $59c911fa927d1bcf$var$getPrevProps(parent) {
    switch(parent.type){
        case 'document':
            return parent.start;
        case 'block-map':
            {
                const it = parent.items[parent.items.length - 1];
                return it.sep || it.start;
            }
        case 'block-seq':
            return parent.items[parent.items.length - 1].start;
        /* istanbul ignore next should not happen */ default:
            return [];
    }
}
/** Note: May modify input array */ function $59c911fa927d1bcf$var$getFirstKeyStartProps(prev) {
    var _a;
    if (prev.length === 0) return [];
    let i = prev.length;
    loop: while(--i >= 0)switch(prev[i].type){
        case 'doc-start':
        case 'explicit-key-ind':
        case 'map-value-ind':
        case 'seq-item-ind':
        case 'newline':
            break loop;
    }
    while(((_a = prev[++i]) === null || _a === void 0 ? void 0 : _a.type) === 'space');
    return prev.splice(i, prev.length);
}
function $59c911fa927d1bcf$var$fixFlowSeqItems(fc) {
    if (fc.start.type === 'flow-seq-start') {
        for (const it of fc.items)if (it.sep && !it.value && !$59c911fa927d1bcf$var$includesToken(it.start, 'explicit-key-ind') && !$59c911fa927d1bcf$var$includesToken(it.sep, 'map-value-ind')) {
            if (it.key) it.value = it.key;
            delete it.key;
            if ($59c911fa927d1bcf$var$isFlowToken(it.value)) {
                if (it.value.end) Array.prototype.push.apply(it.value.end, it.sep);
                else it.value.end = it.sep;
            } else Array.prototype.push.apply(it.start, it.sep);
            delete it.sep;
        }
    }
}
/**
 * A YAML concrete syntax tree (CST) parser
 *
 * ```ts
 * const src: string = ...
 * for (const token of new Parser().parse(src)) {
 *   // token: Token
 * }
 * ```
 *
 * To use the parser with a user-provided lexer:
 *
 * ```ts
 * function* parse(source: string, lexer: Lexer) {
 *   const parser = new Parser()
 *   for (const lexeme of lexer.lex(source))
 *     yield* parser.next(lexeme)
 *   yield* parser.end()
 * }
 *
 * const src: string = ...
 * const lexer = new Lexer()
 * for (const token of parse(src, lexer)) {
 *   // token: Token
 * }
 * ```
 */ class $59c911fa927d1bcf$export$7acfa6ed01010e37 {
    /**
     * @param onNewLine - If defined, called separately with the start position of
     *   each new line (in `parse()`, including the start of input).
     */ constructor(onNewLine){
        /** If true, space and sequence indicators count as indentation */ this.atNewLine = true;
        /** If true, next token is a scalar value */ this.atScalar = false;
        /** Current indentation level */ this.indent = 0;
        /** Current offset since the start of parsing */ this.offset = 0;
        /** On the same line with a block map key */ this.onKeyLine = false;
        /** Top indicates the node that's currently being built */ this.stack = [];
        /** The source of the current token, set in parse() */ this.source = '';
        /** The type of the current token, set in parse() */ this.type = '';
        // Must be defined after `next()`
        this.lexer = new $59c911fa927d1bcf$export$6168dc8908a6c652();
        this.onNewLine = onNewLine;
    }
    /**
     * Parse `source` as a YAML stream.
     * If `incomplete`, a part of the last line may be left as a buffer for the next call.
     *
     * Errors are not thrown, but yielded as `{ type: 'error', message }` tokens.
     *
     * @returns A generator of tokens representing each directive, document, and other structure.
     */ *parse(source, incomplete = false) {
        if (this.onNewLine && this.offset === 0) this.onNewLine(0);
        for (const lexeme of this.lexer.lex(source, incomplete))yield* this.next(lexeme);
        if (!incomplete) yield* this.end();
    }
    /**
     * Advance the parser by the `source` of one lexical token.
     */ *next(source) {
        this.source = source;
        if (this.atScalar) {
            this.atScalar = false;
            yield* this.step();
            this.offset += source.length;
            return;
        }
        const type = $59c911fa927d1bcf$var$tokenType(source);
        if (!type) {
            const message = `Not a YAML token: ${source}`;
            yield* this.pop({
                type: 'error',
                offset: this.offset,
                message: message,
                source: source
            });
            this.offset += source.length;
        } else if (type === 'scalar') {
            this.atNewLine = false;
            this.atScalar = true;
            this.type = 'scalar';
        } else {
            this.type = type;
            yield* this.step();
            switch(type){
                case 'newline':
                    this.atNewLine = true;
                    this.indent = 0;
                    if (this.onNewLine) this.onNewLine(this.offset + source.length);
                    break;
                case 'space':
                    if (this.atNewLine && source[0] === ' ') this.indent += source.length;
                    break;
                case 'explicit-key-ind':
                case 'map-value-ind':
                case 'seq-item-ind':
                    if (this.atNewLine) this.indent += source.length;
                    break;
                case 'doc-mode':
                    return;
                default:
                    this.atNewLine = false;
            }
            this.offset += source.length;
        }
    }
    /** Call at end of input to push out any remaining constructions */ *end() {
        while(this.stack.length > 0)yield* this.pop();
    }
    get sourceToken() {
        const st = {
            type: this.type,
            offset: this.offset,
            indent: this.indent,
            source: this.source
        };
        return st;
    }
    *step() {
        const top = this.peek(1);
        if (this.type === 'doc-end' && (!top || top.type !== 'doc-end')) {
            while(this.stack.length > 0)yield* this.pop();
            this.stack.push({
                type: 'doc-end',
                offset: this.offset,
                source: this.source
            });
            return;
        }
        if (!top) return yield* this.stream();
        switch(top.type){
            case 'document':
                return yield* this.document(top);
            case 'alias':
            case 'scalar':
            case 'single-quoted-scalar':
            case 'double-quoted-scalar':
                return yield* this.scalar(top);
            case 'block-scalar':
                return yield* this.blockScalar(top);
            case 'block-map':
                return yield* this.blockMap(top);
            case 'block-seq':
                return yield* this.blockSequence(top);
            case 'flow-collection':
                return yield* this.flowCollection(top);
            case 'doc-end':
                return yield* this.documentEnd(top);
        }
        /* istanbul ignore next should not happen */ yield* this.pop();
    }
    peek(n) {
        return this.stack[this.stack.length - n];
    }
    *pop(error) {
        const token = error || this.stack.pop();
        /* istanbul ignore if should not happen */ if (!token) {
            const message = 'Tried to pop an empty stack';
            yield {
                type: 'error',
                offset: this.offset,
                source: '',
                message: message
            };
        } else if (this.stack.length === 0) yield token;
        else {
            const top = this.peek(1);
            // For these, parent indent is needed instead of own
            if (token.type === 'block-scalar' || token.type === 'flow-collection') token.indent = 'indent' in top ? top.indent : -1;
            if (token.type === 'flow-collection') $59c911fa927d1bcf$var$fixFlowSeqItems(token);
            switch(top.type){
                case 'document':
                    top.value = token;
                    break;
                case 'block-scalar':
                    top.props.push(token); // error
                    break;
                case 'block-map':
                    {
                        const it = top.items[top.items.length - 1];
                        if (it.value) {
                            top.items.push({
                                start: [],
                                key: token,
                                sep: []
                            });
                            this.onKeyLine = true;
                            return;
                        } else if (it.sep) it.value = token;
                        else {
                            Object.assign(it, {
                                key: token,
                                sep: []
                            });
                            this.onKeyLine = !$59c911fa927d1bcf$var$includesToken(it.start, 'explicit-key-ind');
                            return;
                        }
                        break;
                    }
                case 'block-seq':
                    {
                        const it = top.items[top.items.length - 1];
                        if (it.value) top.items.push({
                            start: [],
                            value: token
                        });
                        else it.value = token;
                        break;
                    }
                case 'flow-collection':
                    {
                        const it = top.items[top.items.length - 1];
                        if (!it || it.value) top.items.push({
                            start: [],
                            key: token,
                            sep: []
                        });
                        else if (it.sep) it.value = token;
                        else Object.assign(it, {
                            key: token,
                            sep: []
                        });
                        return;
                    }
                /* istanbul ignore next should not happen */ default:
                    yield* this.pop();
                    yield* this.pop(token);
            }
            if ((top.type === 'document' || top.type === 'block-map' || top.type === 'block-seq') && (token.type === 'block-map' || token.type === 'block-seq')) {
                const last = token.items[token.items.length - 1];
                if (last && !last.sep && !last.value && last.start.length > 0 && !$59c911fa927d1bcf$var$includesNonEmpty(last.start) && (token.indent === 0 || last.start.every((st)=>st.type !== 'comment' || st.indent < token.indent))) {
                    if (top.type === 'document') top.end = last.start;
                    else top.items.push({
                        start: last.start
                    });
                    token.items.splice(-1, 1);
                }
            }
        }
    }
    *stream() {
        switch(this.type){
            case 'directive-line':
                yield {
                    type: 'directive',
                    offset: this.offset,
                    source: this.source
                };
                return;
            case 'byte-order-mark':
            case 'space':
            case 'comment':
            case 'newline':
                yield this.sourceToken;
                return;
            case 'doc-mode':
            case 'doc-start':
                {
                    const doc = {
                        type: 'document',
                        offset: this.offset,
                        start: []
                    };
                    if (this.type === 'doc-start') doc.start.push(this.sourceToken);
                    this.stack.push(doc);
                    return;
                }
        }
        yield {
            type: 'error',
            offset: this.offset,
            message: `Unexpected ${this.type} token in YAML stream`,
            source: this.source
        };
    }
    *document(doc) {
        if (doc.value) return yield* this.lineEnd(doc);
        switch(this.type){
            case 'doc-start':
                if ($59c911fa927d1bcf$var$includesNonEmpty(doc.start)) {
                    yield* this.pop();
                    yield* this.step();
                } else doc.start.push(this.sourceToken);
                return;
            case 'anchor':
            case 'tag':
            case 'space':
            case 'comment':
            case 'newline':
                doc.start.push(this.sourceToken);
                return;
        }
        const bv = this.startBlockValue(doc);
        if (bv) this.stack.push(bv);
        else yield {
            type: 'error',
            offset: this.offset,
            message: `Unexpected ${this.type} token in YAML document`,
            source: this.source
        };
    }
    *scalar(scalar) {
        if (this.type === 'map-value-ind') {
            const prev = $59c911fa927d1bcf$var$getPrevProps(this.peek(2));
            const start = $59c911fa927d1bcf$var$getFirstKeyStartProps(prev);
            let sep;
            if (scalar.end) {
                sep = scalar.end;
                sep.push(this.sourceToken);
                delete scalar.end;
            } else sep = [
                this.sourceToken
            ];
            const map = {
                type: 'block-map',
                offset: scalar.offset,
                indent: scalar.indent,
                items: [
                    {
                        start: start,
                        key: scalar,
                        sep: sep
                    }
                ]
            };
            this.onKeyLine = true;
            this.stack[this.stack.length - 1] = map;
        } else yield* this.lineEnd(scalar);
    }
    *blockScalar(scalar) {
        switch(this.type){
            case 'space':
            case 'comment':
            case 'newline':
                scalar.props.push(this.sourceToken);
                return;
            case 'scalar':
                scalar.source = this.source;
                // block-scalar source includes trailing newline
                this.atNewLine = true;
                this.indent = 0;
                if (this.onNewLine) {
                    let nl = this.source.indexOf('\n') + 1;
                    while(nl !== 0){
                        this.onNewLine(this.offset + nl);
                        nl = this.source.indexOf('\n', nl) + 1;
                    }
                }
                yield* this.pop();
                break;
            /* istanbul ignore next should not happen */ default:
                yield* this.pop();
                yield* this.step();
        }
    }
    *blockMap(map) {
        var _a;
        const it = map.items[map.items.length - 1];
        // it.sep is true-ish if pair already has key or : separator
        switch(this.type){
            case 'newline':
                this.onKeyLine = false;
                if (it.value) {
                    const end = 'end' in it.value ? it.value.end : undefined;
                    const last = Array.isArray(end) ? end[end.length - 1] : undefined;
                    if ((last === null || last === void 0 ? void 0 : last.type) === 'comment') end === null || end === void 0 || end.push(this.sourceToken);
                    else map.items.push({
                        start: [
                            this.sourceToken
                        ]
                    });
                } else if (it.sep) it.sep.push(this.sourceToken);
                else it.start.push(this.sourceToken);
                return;
            case 'space':
            case 'comment':
                if (it.value) map.items.push({
                    start: [
                        this.sourceToken
                    ]
                });
                else if (it.sep) it.sep.push(this.sourceToken);
                else {
                    if (this.atIndentedComment(it.start, map.indent)) {
                        const prev = map.items[map.items.length - 2];
                        const end = (_a = prev === null || prev === void 0 ? void 0 : prev.value) === null || _a === void 0 ? void 0 : _a.end;
                        if (Array.isArray(end)) {
                            Array.prototype.push.apply(end, it.start);
                            end.push(this.sourceToken);
                            map.items.pop();
                            return;
                        }
                    }
                    it.start.push(this.sourceToken);
                }
                return;
        }
        if (this.indent >= map.indent) {
            const atNextItem = !this.onKeyLine && this.indent === map.indent && (it.sep || $59c911fa927d1bcf$var$includesNonEmpty(it.start));
            switch(this.type){
                case 'anchor':
                case 'tag':
                    if (atNextItem || it.value) {
                        map.items.push({
                            start: [
                                this.sourceToken
                            ]
                        });
                        this.onKeyLine = true;
                    } else if (it.sep) it.sep.push(this.sourceToken);
                    else it.start.push(this.sourceToken);
                    return;
                case 'explicit-key-ind':
                    if (!it.sep && !$59c911fa927d1bcf$var$includesToken(it.start, 'explicit-key-ind')) it.start.push(this.sourceToken);
                    else if (atNextItem || it.value) map.items.push({
                        start: [
                            this.sourceToken
                        ]
                    });
                    else this.stack.push({
                        type: 'block-map',
                        offset: this.offset,
                        indent: this.indent,
                        items: [
                            {
                                start: [
                                    this.sourceToken
                                ]
                            }
                        ]
                    });
                    this.onKeyLine = true;
                    return;
                case 'map-value-ind':
                    if (!it.sep) Object.assign(it, {
                        key: null,
                        sep: [
                            this.sourceToken
                        ]
                    });
                    else if (it.value || atNextItem && !$59c911fa927d1bcf$var$includesToken(it.start, 'explicit-key-ind')) map.items.push({
                        start: [],
                        key: null,
                        sep: [
                            this.sourceToken
                        ]
                    });
                    else if ($59c911fa927d1bcf$var$includesToken(it.sep, 'map-value-ind')) this.stack.push({
                        type: 'block-map',
                        offset: this.offset,
                        indent: this.indent,
                        items: [
                            {
                                start: [],
                                key: null,
                                sep: [
                                    this.sourceToken
                                ]
                            }
                        ]
                    });
                    else if ($59c911fa927d1bcf$var$includesToken(it.start, 'explicit-key-ind') && $59c911fa927d1bcf$var$isFlowToken(it.key) && !$59c911fa927d1bcf$var$includesToken(it.sep, 'newline')) {
                        const start = $59c911fa927d1bcf$var$getFirstKeyStartProps(it.start);
                        const key = it.key;
                        const sep = it.sep;
                        sep.push(this.sourceToken);
                        // @ts-ignore type guard is wrong here
                        delete it.key, delete it.sep;
                        this.stack.push({
                            type: 'block-map',
                            offset: this.offset,
                            indent: this.indent,
                            items: [
                                {
                                    start: start,
                                    key: key,
                                    sep: sep
                                }
                            ]
                        });
                    } else it.sep.push(this.sourceToken);
                    this.onKeyLine = true;
                    return;
                case 'alias':
                case 'scalar':
                case 'single-quoted-scalar':
                case 'double-quoted-scalar':
                    {
                        const fs = this.flowScalar(this.type);
                        if (atNextItem || it.value) {
                            map.items.push({
                                start: [],
                                key: fs,
                                sep: []
                            });
                            this.onKeyLine = true;
                        } else if (it.sep) this.stack.push(fs);
                        else {
                            Object.assign(it, {
                                key: fs,
                                sep: []
                            });
                            this.onKeyLine = true;
                        }
                        return;
                    }
                default:
                    {
                        const bv = this.startBlockValue(map);
                        if (bv) {
                            if (atNextItem && bv.type !== 'block-seq' && $59c911fa927d1bcf$var$includesToken(it.start, 'explicit-key-ind')) map.items.push({
                                start: []
                            });
                            this.stack.push(bv);
                            return;
                        }
                    }
            }
        }
        yield* this.pop();
        yield* this.step();
    }
    *blockSequence(seq) {
        var _a;
        const it = seq.items[seq.items.length - 1];
        switch(this.type){
            case 'newline':
                if (it.value) {
                    const end = 'end' in it.value ? it.value.end : undefined;
                    const last = Array.isArray(end) ? end[end.length - 1] : undefined;
                    if ((last === null || last === void 0 ? void 0 : last.type) === 'comment') end === null || end === void 0 || end.push(this.sourceToken);
                    else seq.items.push({
                        start: [
                            this.sourceToken
                        ]
                    });
                } else it.start.push(this.sourceToken);
                return;
            case 'space':
            case 'comment':
                if (it.value) seq.items.push({
                    start: [
                        this.sourceToken
                    ]
                });
                else {
                    if (this.atIndentedComment(it.start, seq.indent)) {
                        const prev = seq.items[seq.items.length - 2];
                        const end = (_a = prev === null || prev === void 0 ? void 0 : prev.value) === null || _a === void 0 ? void 0 : _a.end;
                        if (Array.isArray(end)) {
                            Array.prototype.push.apply(end, it.start);
                            end.push(this.sourceToken);
                            seq.items.pop();
                            return;
                        }
                    }
                    it.start.push(this.sourceToken);
                }
                return;
            case 'anchor':
            case 'tag':
                if (it.value || this.indent <= seq.indent) break;
                it.start.push(this.sourceToken);
                return;
            case 'seq-item-ind':
                if (this.indent !== seq.indent) break;
                if (it.value || $59c911fa927d1bcf$var$includesToken(it.start, 'seq-item-ind')) seq.items.push({
                    start: [
                        this.sourceToken
                    ]
                });
                else it.start.push(this.sourceToken);
                return;
        }
        if (this.indent > seq.indent) {
            const bv = this.startBlockValue(seq);
            if (bv) {
                this.stack.push(bv);
                return;
            }
        }
        yield* this.pop();
        yield* this.step();
    }
    *flowCollection(fc) {
        const it = fc.items[fc.items.length - 1];
        if (this.type === 'flow-error-end') {
            let top;
            do {
                yield* this.pop();
                top = this.peek(1);
            }while (top && top.type === 'flow-collection');
        } else if (fc.end.length === 0) {
            switch(this.type){
                case 'comma':
                case 'explicit-key-ind':
                    if (!it || it.sep) fc.items.push({
                        start: [
                            this.sourceToken
                        ]
                    });
                    else it.start.push(this.sourceToken);
                    return;
                case 'map-value-ind':
                    if (!it || it.value) fc.items.push({
                        start: [],
                        key: null,
                        sep: [
                            this.sourceToken
                        ]
                    });
                    else if (it.sep) it.sep.push(this.sourceToken);
                    else Object.assign(it, {
                        key: null,
                        sep: [
                            this.sourceToken
                        ]
                    });
                    return;
                case 'space':
                case 'comment':
                case 'newline':
                case 'anchor':
                case 'tag':
                    if (!it || it.value) fc.items.push({
                        start: [
                            this.sourceToken
                        ]
                    });
                    else if (it.sep) it.sep.push(this.sourceToken);
                    else it.start.push(this.sourceToken);
                    return;
                case 'alias':
                case 'scalar':
                case 'single-quoted-scalar':
                case 'double-quoted-scalar':
                    {
                        const fs = this.flowScalar(this.type);
                        if (!it || it.value) fc.items.push({
                            start: [],
                            key: fs,
                            sep: []
                        });
                        else if (it.sep) this.stack.push(fs);
                        else Object.assign(it, {
                            key: fs,
                            sep: []
                        });
                        return;
                    }
                case 'flow-map-end':
                case 'flow-seq-end':
                    fc.end.push(this.sourceToken);
                    return;
            }
            const bv = this.startBlockValue(fc);
            /* istanbul ignore else should not happen */ if (bv) this.stack.push(bv);
            else {
                yield* this.pop();
                yield* this.step();
            }
        } else {
            const parent = this.peek(2);
            if (parent.type === 'block-map' && (this.type === 'map-value-ind' || this.type === 'newline' && !parent.items[parent.items.length - 1].sep)) {
                yield* this.pop();
                yield* this.step();
            } else if (this.type === 'map-value-ind' && parent.type !== 'flow-collection') {
                const prev = $59c911fa927d1bcf$var$getPrevProps(parent);
                const start = $59c911fa927d1bcf$var$getFirstKeyStartProps(prev);
                $59c911fa927d1bcf$var$fixFlowSeqItems(fc);
                const sep = fc.end.splice(1, fc.end.length);
                sep.push(this.sourceToken);
                const map = {
                    type: 'block-map',
                    offset: fc.offset,
                    indent: fc.indent,
                    items: [
                        {
                            start: start,
                            key: fc,
                            sep: sep
                        }
                    ]
                };
                this.onKeyLine = true;
                this.stack[this.stack.length - 1] = map;
            } else yield* this.lineEnd(fc);
        }
    }
    flowScalar(type) {
        if (this.onNewLine) {
            let nl = this.source.indexOf('\n') + 1;
            while(nl !== 0){
                this.onNewLine(this.offset + nl);
                nl = this.source.indexOf('\n', nl) + 1;
            }
        }
        return {
            type: type,
            offset: this.offset,
            indent: this.indent,
            source: this.source
        };
    }
    startBlockValue(parent) {
        switch(this.type){
            case 'alias':
            case 'scalar':
            case 'single-quoted-scalar':
            case 'double-quoted-scalar':
                return this.flowScalar(this.type);
            case 'block-scalar-header':
                return {
                    type: 'block-scalar',
                    offset: this.offset,
                    indent: this.indent,
                    props: [
                        this.sourceToken
                    ],
                    source: ''
                };
            case 'flow-map-start':
            case 'flow-seq-start':
                return {
                    type: 'flow-collection',
                    offset: this.offset,
                    indent: this.indent,
                    start: this.sourceToken,
                    items: [],
                    end: []
                };
            case 'seq-item-ind':
                return {
                    type: 'block-seq',
                    offset: this.offset,
                    indent: this.indent,
                    items: [
                        {
                            start: [
                                this.sourceToken
                            ]
                        }
                    ]
                };
            case 'explicit-key-ind':
                {
                    this.onKeyLine = true;
                    const prev = $59c911fa927d1bcf$var$getPrevProps(parent);
                    const start = $59c911fa927d1bcf$var$getFirstKeyStartProps(prev);
                    start.push(this.sourceToken);
                    return {
                        type: 'block-map',
                        offset: this.offset,
                        indent: this.indent,
                        items: [
                            {
                                start: start
                            }
                        ]
                    };
                }
            case 'map-value-ind':
                {
                    this.onKeyLine = true;
                    const prev = $59c911fa927d1bcf$var$getPrevProps(parent);
                    const start = $59c911fa927d1bcf$var$getFirstKeyStartProps(prev);
                    return {
                        type: 'block-map',
                        offset: this.offset,
                        indent: this.indent,
                        items: [
                            {
                                start: start,
                                key: null,
                                sep: [
                                    this.sourceToken
                                ]
                            }
                        ]
                    };
                }
        }
        return null;
    }
    atIndentedComment(start, indent) {
        if (this.type !== 'comment') return false;
        if (this.indent <= indent) return false;
        return start.every((st)=>st.type === 'newline' || st.type === 'space');
    }
    *documentEnd(docEnd) {
        if (this.type !== 'doc-mode') {
            if (docEnd.end) docEnd.end.push(this.sourceToken);
            else docEnd.end = [
                this.sourceToken
            ];
            if (this.type === 'newline') yield* this.pop();
        }
    }
    *lineEnd(token) {
        switch(this.type){
            case 'comma':
            case 'doc-start':
            case 'doc-end':
            case 'flow-seq-end':
            case 'flow-map-end':
            case 'map-value-ind':
                yield* this.pop();
                yield* this.step();
                break;
            case 'newline':
                this.onKeyLine = false;
            // fallthrough
            case 'space':
            case 'comment':
            default:
                // all other values are errors
                if (token.end) token.end.push(this.sourceToken);
                else token.end = [
                    this.sourceToken
                ];
                if (this.type === 'newline') yield* this.pop();
        }
    }
}
function $59c911fa927d1bcf$var$parseOptions(options) {
    const prettyErrors = !options || options.prettyErrors !== false;
    const lineCounter = options && options.lineCounter || prettyErrors && new $59c911fa927d1bcf$export$c8a6f24ae2865e59() || null;
    return {
        lineCounter: lineCounter,
        prettyErrors: prettyErrors
    };
}
/**
 * Parse the input as a stream of YAML documents.
 *
 * Documents should be separated from each other by `...` or `---` marker lines.
 *
 * @returns If an empty `docs` array is returned, it will be of type
 *   EmptyStream and contain additional stream information. In
 *   TypeScript, you should use `'empty' in docs` as a type guard for it.
 */ function $59c911fa927d1bcf$export$643da2570c3b3d01(source, options = {}) {
    const { lineCounter: lineCounter, prettyErrors: prettyErrors } = $59c911fa927d1bcf$var$parseOptions(options);
    const parser = new $59c911fa927d1bcf$export$7acfa6ed01010e37(lineCounter === null || lineCounter === void 0 ? void 0 : lineCounter.addNewLine);
    const composer = new $59c911fa927d1bcf$export$57ed0bcea28f97a2(options);
    const docs = Array.from(composer.compose(parser.parse(source)));
    if (prettyErrors && lineCounter) for (const doc of docs){
        doc.errors.forEach($59c911fa927d1bcf$var$prettifyError(source, lineCounter));
        doc.warnings.forEach($59c911fa927d1bcf$var$prettifyError(source, lineCounter));
    }
    if (docs.length > 0) return docs;
    return Object.assign([], {
        empty: true
    }, composer.streamInfo());
}
/** Parse an input string into a single YAML.Document */ function $59c911fa927d1bcf$export$b6a9369736b19f4d(source, options = {}) {
    const { lineCounter: lineCounter, prettyErrors: prettyErrors } = $59c911fa927d1bcf$var$parseOptions(options);
    const parser = new $59c911fa927d1bcf$export$7acfa6ed01010e37(lineCounter === null || lineCounter === void 0 ? void 0 : lineCounter.addNewLine);
    const composer = new $59c911fa927d1bcf$export$57ed0bcea28f97a2(options);
    // `doc` is always set by compose.end(true) at the very latest
    let doc = null;
    for (const _doc of composer.compose(parser.parse(source), true, source.length)){
        if (!doc) doc = _doc;
        else if (doc.options.logLevel !== 'silent') {
            doc.errors.push(new $59c911fa927d1bcf$export$c1188aaa49090a5c(_doc.range.slice(0, 2), 'MULTIPLE_DOCS', 'Source contains multiple documents; please use YAML.parseAllDocuments()'));
            break;
        }
    }
    if (prettyErrors && lineCounter) {
        doc.errors.forEach($59c911fa927d1bcf$var$prettifyError(source, lineCounter));
        doc.warnings.forEach($59c911fa927d1bcf$var$prettifyError(source, lineCounter));
    }
    return doc;
}
function $59c911fa927d1bcf$export$98e6a39c04603d36(src, reviver, options) {
    let _reviver = undefined;
    if (typeof reviver === 'function') _reviver = reviver;
    else if (options === undefined && reviver && typeof reviver === 'object') options = reviver;
    const doc = $59c911fa927d1bcf$export$b6a9369736b19f4d(src, options);
    if (!doc) return null;
    doc.warnings.forEach((warning)=>$59c911fa927d1bcf$var$warn(doc.options.logLevel, warning));
    if (doc.errors.length > 0) {
        if (doc.options.logLevel !== 'silent') throw doc.errors[0];
        else doc.errors = [];
    }
    return doc.toJS(Object.assign({
        reviver: _reviver
    }, options));
}
function $59c911fa927d1bcf$export$fac44ee5b035f737(value, replacer, options) {
    let _replacer = null;
    if (typeof replacer === 'function' || Array.isArray(replacer)) _replacer = replacer;
    else if (options === undefined && replacer) options = replacer;
    if (typeof options === 'string') options = options.length;
    if (typeof options === 'number') {
        const indent = Math.round(options);
        options = indent < 1 ? undefined : indent > 8 ? {
            indent: 8
        } : {
            indent: indent
        };
    }
    if (value === undefined) {
        const { keepUndefined: keepUndefined } = options || replacer || {};
        if (!keepUndefined) return undefined;
    }
    return new $59c911fa927d1bcf$export$b34a105447964f9f(value, _replacer, options).toString(options);
}
var $59c911fa927d1bcf$var$YAML = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CST: $59c911fa927d1bcf$export$dd3c50b1c80c78ef,
    Composer: $59c911fa927d1bcf$export$57ed0bcea28f97a2,
    Document: $59c911fa927d1bcf$export$b34a105447964f9f,
    Schema: $59c911fa927d1bcf$export$19342e026b58ebb7,
    YAMLError: $59c911fa927d1bcf$export$699cd54d617b337f,
    YAMLParseError: $59c911fa927d1bcf$export$c1188aaa49090a5c,
    YAMLWarning: $59c911fa927d1bcf$export$856b463bac79f971,
    Alias: $59c911fa927d1bcf$export$17b520249a85fe16,
    isAlias: $59c911fa927d1bcf$export$c6275352883a2b3e,
    isCollection: $59c911fa927d1bcf$export$cea7aa84e978eba5,
    isDocument: $59c911fa927d1bcf$export$62858bae88b53fd0,
    isMap: $59c911fa927d1bcf$export$5c90113a285f2241,
    isNode: $59c911fa927d1bcf$export$8ee0fc9ee280b4ee,
    isPair: $59c911fa927d1bcf$export$7c8d445944656308,
    isScalar: $59c911fa927d1bcf$export$8f3495e22775e76c,
    isSeq: $59c911fa927d1bcf$export$342ac1d101ffe14b,
    Pair: $59c911fa927d1bcf$export$d63d7cff08fe4dc9,
    Scalar: $59c911fa927d1bcf$export$595dbf49c602a1f,
    YAMLMap: $59c911fa927d1bcf$export$eb1691c4b19bb5eb,
    YAMLSeq: $59c911fa927d1bcf$export$47adc25f769055b2,
    defaultOptions: $59c911fa927d1bcf$export$ba43bf67f3d48107,
    Lexer: $59c911fa927d1bcf$export$6168dc8908a6c652,
    LineCounter: $59c911fa927d1bcf$export$c8a6f24ae2865e59,
    Parser: $59c911fa927d1bcf$export$7acfa6ed01010e37,
    parse: $59c911fa927d1bcf$export$98e6a39c04603d36,
    parseAllDocuments: $59c911fa927d1bcf$export$643da2570c3b3d01,
    parseDocument: $59c911fa927d1bcf$export$b6a9369736b19f4d,
    stringify: $59c911fa927d1bcf$export$fac44ee5b035f737,
    visit: $59c911fa927d1bcf$export$bf638b60ea8b89b7
});
var // `export * as default from ...` fails on Webpack v4
$59c911fa927d1bcf$export$2e2bcd8739ae039 = $59c911fa927d1bcf$var$YAML;


//import { factory2d } from '../../../factory/factory2d.js'
// var factory2d = window.factory2d;
class $3494c43f722f695b$export$1e2124d9bec1f71d {
    constructor(initObj){
        this.container = initObj.container ? initObj.container : window.document.body; // default 
        this.data = initObj.data ? initObj.data : {
            'key1': 'val1'
        };
        this.model = this.data.model;
        var vnode = window.factory2d.renderNodeSync('kvs', {});
        this.holder = vnode.querySelector('#kvs_keyval');
        this.tmplt = vnode.querySelector('.item').cloneNode(true);
        this.holder.innerHTML = '';
        for(var i in this.data){
            let field_pair = this.data[i];
            if (i == 'se' || i == 'pw') this.data[i] = '*****************';
            this.addKvItem(i, this.data[i]);
        }
        vnode.querySelector('#kvs_plus').addEventListener('click', (e)=>{
            console.log(' add keyval ');
            this.addKvItem('', '');
        //model.updateLink( fromId , toId , { tag:e.target.value } )
        });
        if (initObj.color) {
            var colorInput = document.createElement('input');
            colorInput.type = 'color';
            colorInput.id = 'nodecolor';
            vnode.appendChild(colorInput);
            vnode.querySelector('#nodecolor').addEventListener('input', (e)=>{
                console.log('Selected color:', e.target.value);
                var col = parseInt(e.target.value.replace('#', '0x'), 16);
                if ('color' in this.data) this.updateItemValue('color', col);
                else {
                    this.addKvItem('color', col);
                    this.data['color'] = col;
                }
            });
        }
        this.container.appendChild(vnode);
    }
    addEventListener(event_type, event_object) {
        this.container.addEventListener(event_type, event_object);
    }
    onDataUpdate(data_in) {
        var j = 55;
    }
    addKvItem(k, v) {
        var toins = this.tmplt.cloneNode(true);
        toins.querySelector('#xfer_key').value = k;
        // FOR INCOMING UPDATE FINDING  Field ID: 
        toins.setAttribute('fid', k);
        toins.querySelector('#xfer_key').addEventListener('input', (e)=>{
            var ky = e.target.value;
            var vl = e.target.parentElement.querySelector('#xfer_val').value;
        //e.target.setAttribute('fid', e.target.value);
        // DO NOT UPDATE ON KEY CHANGE 
        //var obj = {}
        //obj[ ky ] = vl;
        //this.model.updateObject( this.data.uuid , obj  )
        });
        toins.querySelector('#xfer_val').value = v;
        toins.querySelector('#xfer_val').addEventListener('input', (e)=>{
            var obj = {};
            var ky = e.target.parentElement.querySelector('#xfer_key').value;
            obj[ky] = e.target.value;
            // ADD UUID TO EVENT IF PRESENT
            // BUT PUT THIS ON HOLD SO IT DOES NOT OVERWRITE ITSELF 
            //if( 'uuid' in this.data ){
            //    obj['uuid'] = this.data.uuid; 
            //}
            this.container.dispatchEvent(new CustomEvent('kvInputEvent', {
                detail: obj
            }));
        });
        toins.querySelector('#xfer_removeitem').setAttribute("kvid", k);
        toins.querySelector('#xfer_removeitem').addEventListener('click', (e)=>{
            this.id = k;
            e.target.yoyo = k;
            console.log(' Remove keyval ', k, this.id, e.target.getAttribute("kvid"));
            e.target.parentElement.remove();
        //this.removeItem()
        });
        this.holder.appendChild(toins);
    }
    updateItemValue(k, v) {
        var value = k;
        //var colorInput = this.container.querySelector('input[value="color"]');
        var allInputs = this.container.querySelectorAll('input');
        var results = [];
        for(var x = 0; x < allInputs.length; x++)if (allInputs[x].value == value) {
            results.push(allInputs[x]);
            var ni = allInputs[x + 1];
            break;
        }
        ni.value = v;
    }
    acceptUpdate(k, v) {}
    removeKvItem(k) {}
}
 // How do we determine what is a graph and what is an edge // 
 // Vission ( Visual Mission Control ) https://vission.ai





var $d581773a71ca2ccc$export$2e2bcd8739ae039 = {
    dollar (val_in) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(val_in);
    },
    percent (val_in) {
        return '%' + Number(val_in).toFixed(2);
    },
    units (val_in) {
        return Number(val_in).toLocaleString("en-US");
    },
    pass (val_in) {
        return val_in;
    }
};


var $440781629901dd2f$var$brands_execs = {
    coinbase: 'cex',
    github: 'repo',
    neo: 'repo',
    ethereum: 'dex',
    you: 'tag'
};
var $440781629901dd2f$var$route_map = {
    free: {
        display (o) {
            return {
                0: o[0] || 'FREE DEFAULT no 0',
                1: o[1] || 'FREE DEFAULT     ' + new Date().toLocaleString(),
                2: o[2] || 'FREE DEFAULT no 0'
            };
        },
        brand (o) {
            return o.brand;
        },
        mesh (o) {
            return o.mesh || 'girlbase.glb';
        },
        props (o) {
            return {
                brand: 'coinbase'
            };
        },
        caps (o) {
            return [
                'qr',
                'shim'
            ];
        },
        tokenScan (o) {
        // get init Object and    
        },
        fetchBalance (o) {
            console.log(' cex fetchBalance ');
            try {
                let bstr = '';
                for(var i in o.total)// console.log( f , obj.free[f] )
                if (o.total[i] > 0) bstr += '[' + i + ']:' + o.total[i] + ' ';
                return [
                    false,
                    false,
                    bstr
                ];
            } catch (err) {
                return [
                    false,
                    false,
                    '3000: Update Balance'
                ];
            }
        },
        interests (o) {
            return [
                'pricedBalances'
            ];
        }
    },
    material: {},
    key: {
        launches (o) {
            var label_out;
            if (o.dom && o.dom in $440781629901dd2f$var$brands_execs) label_out = $440781629901dd2f$var$brands_execs[o.dom];
            else label_out = 'tag';
            return label_out;
        }
    },
    ray: {
        display (o) {
            return [
                o.name,
                'LIVE: ' + new Date().toLocaleString(),
                '0.0.0.0'
            ];
        },
        caps (o) {
            return [
                'qr',
                'timeseries'
            ];
        },
        props (o) {
            return {
                brand: 'ray',
                name: 'Ray Cluster'
            };
        },
        mesh (o) {
            return 'simcube.glb';
        },
        brand (o) {
            return o.brand;
        }
    },
    docker: {
        display (o) {
            return [
                o.name,
                'LIVE: ' + new Date().toLocaleString(),
                '0.0.0.0'
            ];
        },
        caps (o) {
            return [
                'qr',
                'timeseries'
            ];
        },
        props (o) {
            return {
                brand: 'docker',
                name: 'Docker Cluster'
            };
        },
        mesh (o) {
            return 'simcube.glb';
        },
        brand (o) {
            return o.brand;
        }
    },
    cex: {
        display (o) {
            return {
                0: o.brand,
                1: 'LIVE: ' + new Date().toLocaleString(),
                2: false
            };
        },
        brand (o) {
            return o.brand;
        },
        mesh (o) {
            return 'simcube.glb';
        },
        props (o) {
            return {
                brand: 'coinbase'
            };
        },
        caps (o) {
            return [
                'qr',
                'shim'
            ];
        },
        tokenScan (o) {
        // get init Object and    
        },
        fetchBalance (o) {
            console.log(' cex fetchBalance ');
            try {
                let bstr = '';
                for(var i in o.total)// console.log( f , obj.free[f] )
                if (o.total[i] > 0) bstr += '[' + i + ']:' + o.total[i] + ' ';
                return [
                    false,
                    false,
                    bstr
                ];
            } catch (err) {
                return [
                    false,
                    false,
                    '3000: Update Balance'
                ];
            }
        },
        interests (o) {
            return [
                'pricedBalances'
            ];
        }
    },
    dex: {
        display (o) {
            return {
                0: o.brand,
                1: 'ETH/AVX/BTC',
                2: false
            };
        },
        brand (o) {
            return o.brand;
        },
        mesh (o) {
            return 'simcube.glb';
        },
        props (o) {
            return {
                brand: 'curve'
            };
        },
        caps (o) {
            return [
                'qr',
                'cex'
            ];
        },
        tokenScan (o) {
        // get init Object and    
        },
        fetchBalance (o) {
            console.log(' cex fetchBalance ');
            try {
                let bstr = '';
                for(var i in o.total)// console.log( f , obj.free[f] )
                if (o.total[i] > 0) bstr += '[' + i + ']:' + o.total[i] + ' ';
                return [
                    false,
                    false,
                    bstr
                ];
            } catch (err) {
                return [
                    false,
                    false,
                    '3000: Update Balance'
                ];
            }
        },
        interests (o) {
            return [
                'fetchBalance'
            ];
        }
    },
    flash: {
        display () {
            return [
                'x',
                'yo',
                'x'
            ];
        }
    },
    admin: {
        display (o) {
            return [
                o.name + ' (' + o.brand + ')',
                o.title
            ];
        },
        mesh (o) {
            return 'pillarcube.glb';
        },
        brand (o) {
            return o.brand;
        },
        menu (o) {
            return [
                'expand',
                'x'
            ];
        },
        caps (o) {
            return [
                'qr',
                'buysell',
                'timeseries'
            ];
        },
        props (o) {
            return {
                brand: 'crown',
                symbol: 'BTC/USD'
            };
        },
        interests (o) {
            return [
                'fetchTicker',
                'timeSeries'
            ];
        }
    },
    automate: {
        display (obj) {
            return [
                obj.name,
                obj.brand
            ];
        },
        mesh (o) {
            return 'simbot.glb';
        },
        brand (o) {
            return o.brand;
        },
        menu (o) {
            return [
                'expand',
                'x'
            ];
        },
        caps (o) {
            return [
                'qr',
                'buysell',
                'timeseries'
            ];
        },
        props (o) {
            return {
                brand: 'plungebot',
                name: 'automate'
            };
        }
    },
    flatworld: {
        props: {
            type: 'meta',
            name: 'flatworld'
        }
    },
    globe: {
        props: {
            type: 'meta',
            name: 'globe'
        }
    },
    ctoken: {
        display (o) {
            var amt = (Math.random() * 1).toFixed(4);
            if (o.amount) amt = o.amount;
            return {
                0: '' + amt + ' ' + o.symbol + ' (' + o.brand + ')',
                1: 'LIVE: ' + new Date().toLocaleString(),
                2: false
            };
        },
        fetchTicker (obj) {
            return [
                "$" + obj.close,
                false,
                '' + new Date().toLocaleTimeString()
            ];
        },
        brand (o) {
            let sub;
            if ('symbol' in o) {
                let symb = o.symbol;
                sub = symb.split("/")[0];
                sub = sub.toLowerCase();
            } else if ('code' in o) sub = o.code.toLowerCase();
            else sub = 'undefined';
            return sub;
        },
        menu (o) {
            return [
                'expand',
                'x'
            ];
        },
        mesh (o) {
            return 'simtoken.glb';
        },
        caps (o) {
            return [
                'qr',
                'buysell',
                'timeseries'
            ];
        },
        props (o) {
            return {
                brand: 'exor',
                symbol: 'BTC/USD'
            };
        },
        interests (o) {
            return [
                'fetchTicker',
                'timeSeries'
            ];
        }
    },
    dtoken: {
        display (obj) {
            return [
                '...',
                obj.symbol + ' (' + obj.brand + ')',
                'LOADING'
            ];
        },
        fetchTicker (obj) {
            return [
                "$" + obj.close,
                false,
                '' + new Date().toLocaleTimeString()
            ];
        },
        pricedBalance (obj) {
            return [
                "$" + obj.close,
                false,
                '' + new Date().toLocaleTimeString()
            ];
        },
        brand (o) {
            let sub;
            if ('symbol' in o) {
                let symb = o.symbol;
                sub = symb.split("/")[0];
                sub = sub.toLowerCase();
            } else if ('code' in o) sub = o.code.toLowerCase();
            else sub = 'undefined';
            return sub;
        },
        menu (o) {
            return [
                'expand',
                'x'
            ];
        },
        mesh (o) {
            return 'simtoken.glb';
        },
        caps (o) {
            return [
                'qr',
                'timeseries'
            ];
        },
        props (o) {
            return {
                brand: 'exor',
                symbol: 'BTC/USD'
            };
        },
        interests (o) {
            return [
                'pricedBalance'
            ];
        },
        balance (o) {
            return [
                '$' + o.payload.avax.current_price,
                false,
                '' + o.payload.avax.balance
            ];
        }
    },
    token: {
        display (obj) {
            return [
                '...',
                obj.symbol + ' (' + obj.brand + ')',
                'LOADING'
            ];
        },
        fetchTicker (obj) {
            return [
                "$" + obj.close,
                false,
                '' + new Date().toLocaleTimeString()
            ];
        },
        brand (o) {
            let sub;
            if ('symbol' in o) {
                let symb = o.symbol;
                sub = symb.split("/")[0];
                sub = sub.toLowerCase();
            } else if ('code' in o) sub = o.code.toLowerCase();
            else sub = 'undefined';
            return sub;
        },
        menu (o) {
            return [
                'expand',
                'x'
            ];
        },
        mesh (o) {
            return 'simtoken.glb';
        },
        caps (o) {
            return [
                'qr',
                'qr',
                'qr'
            ];
        },
        props (o) {
            return {
                brand: 'exor',
                symbol: 'BTC/USD'
            };
        }
    },
    module: {
        init (obj) {
            return [
                obj.name,
                '' + new Date()
            ];
        },
        display (obj) {
            var outlist = [];
            if (obj.properties) outlist = [
                obj.properties.name,
                obj.properties.brand
            ];
            else outlist = [
                'UNLISTED MOD',
                'UNLISTED BRAND'
            ];
            return outlist;
        },
        fetchTicker (obj) {
            return [
                "$ " + obj.close,
                obj.vol
            ];
        },
        fetchBalance (obj) {
            return [
                obj.close,
                obj.vol
            ];
        },
        zeroMeth (obj) {
            return [
                false,
                obj.time
            ];
        },
        caps (o) {
            return [
                'qr',
                'qr',
                'qr'
            ];
        }
    },
    alias: {
        display (obj) {
            return [
                obj.name,
                'Generated Alias'
            ];
        },
        mesh (obj) {
            return 'simsuit.glb';
        },
        fetchTicker: (obj)=>{
            return [
                "ALIAS T: " + obj.close,
                "Alias sub: " + obj.vol
            ];
        },
        default: (o)=>{
            console.log('wow: ', o);
            return [
                false,
                false
            ];
        }
    },
    exchange: {
        display (o) {
            return {
                0: o.brand,
                1: 'LIVE: ' + new Date().toLocaleString(),
                2: false
            };
        },
        tokenScan (o) {
        // get init Object and    
        }
    },
    org: {
        display: (o)=>{
            return {
                '0': 'ORG COMING SOON',
                1: o.name,
                '2': 'X-FiLTR 0.5 Z-FILTR 1.432',
                brand: o.name,
                mesh: o.label.toLowerCase(),
                baseplane: false,
                detail: [
                    'qr',
                    'functions'
                ]
            };
        }
    },
    tower: {
        display (o) {
            return [
                o.brand,
                o.domain,
                'UPDT'
            ];
        }
    },
    unknown: {
        display (o) {
            return [
                'UNKNOWN 1',
                'UNKNOWN 2',
                'DISPLAY: ' + new Date().toLocaleString()
            ];
        }
    },
    repo: {
        display (o) {
            return [
                o.name,
                o.label,
                'UPDATED: ' + new Date().toLocaleString()
            ];
        },
        gitStatus (o) {
            console.log(' status running on git driver ');
        },
        caps (o) {
            return [
                'qr',
                'terminal'
            ];
        }
    },
    finorg: {
        display: (o)=>{
            return [
                'Financial Organization',
                '3,500,000'
            ];
        },
        brand (o) {
            return 'brand' in o ? o.brand : 'undefined';
        }
    },
    tag: {
        display: (o)=>{
            var newVar = o.uuid.substring(0, 5);
            return [
                o.name,
                newVar
            ];
        },
        caps (o) {
            return [
                'qr',
                'detail'
            ];
        }
    },
    coord: {
        display: (o)=>{
            return [
                o.name,
                '[x,y,z]'
            ];
        },
        caps (o) {
            return [
                'qr',
                'detail'
            ];
        }
    },
    address: (obj)=>{
        return {
            line1: obj.balance,
            line2: obj.balance
        };
    },
    simbot: {
        name: function(obj) {
            return 'Min Eff: ' + obj.name;
        },
        brand (o) {
            return o.brand;
        }
    },
    locale: {
        caps (o) {
            return [
                'list',
                'list',
                'list'
            ];
        }
    },
    simserver: [
        'name',
        'subname'
    ],
    parimutuel: [
        'name',
        'subname'
    ],
    stock: {
        display (o) {
            return {
                0: o.brand.toUpperCase(),
                1: 'LIVE: ' + new Date().toLocaleString(),
                2: false
            };
        },
        props: (o)=>{
            return {
                brand: 'stock',
                name: 'Corpname'
            };
        },
        domain: function(obj) {
            return obj.domain.toUpperCase();
        },
        mesh: function(o) {
            return 'simstock.glb';
        },
        label: 'label',
        brand: function(o) {
            return o.brand;
        }
    },
    fiat: {
        display (o) {
            var amt = (Math.random() * 1120).toFixed(2);
            if (o.amount) amt = o.amount;
            return {
                0: '$ ' + amt + ' ' + o.brand.toUpperCase(),
                1: 'LIVE: ' + new Date().toLocaleString(),
                2: false
            };
        },
        props: (o)=>{
            return {
                brand: 'usd',
                symbol: 'UKNX/USD'
            };
        },
        domain: function(obj) {
            return obj.domain.toUpperCase();
        },
        mesh: function(o) {
            return 'simfiat.glb';
        },
        label: 'label',
        brand: function(o) {
            return o.brand;
        }
    },
    study: {
        display (o) {
            var amt = (Math.random() * 1120).toFixed(2);
            if (o.amount) amt = o.amount;
            return {
                0: '$ ' + amt + ' ' + o.brand.toUpperCase(),
                1: 'LIVE: ' + new Date().toLocaleString(),
                2: false
            };
        },
        props: (o)=>{
            return {
                brand: 'usd',
                symbol: 'UKNX/USD'
            };
        },
        domain: function(obj) {
            return obj.domain.toUpperCase();
        },
        mesh: function(o) {
            return 'simstock.glb';
        },
        label: 'label',
        brand: function(o) {
            return o.brand;
        }
    },
    xclass: [
        'name',
        'price'
    ],
    service: [
        'name',
        'subname'
    ],
    project: [
        'name',
        'label'
    ],
    flatsquare: {
        display (o) {
            var d = new Date();
            return [
                o.name.toUpperCase(),
                'LIVE: ' + d.toLocaleTimeString(),
                '0018.07.00'
            ];
        },
        brand (o) {
            return o.brand;
        }
    },
    simcube: {
        display (o) {
            var d = new Date();
            return [
                o.brand.charAt(0).toUpperCase() + o.brand.slice(1),
                'LIVE: ' + d.toLocaleTimeString()
            ];
        },
        brand (o) {
            return o.brand;
        }
    },
    wrapped_sphere: {},
    asset: [
        'name',
        function(obj) {
            return '' + Math.round(Math.random() * 3.23) + '.00 - M';
        }
    ],
    connects: {
        caps (o) {
            return [
                'qr',
                'xfer',
                'qr'
            ];
        },
        display (o) {
            return [
                ' ' + Math.round(Math.random() * 3.23) + '.00 - M',
                'iii',
                'iii'
            ];
        }
    },
    owns: [],
    movie: {
        display (o) {
            var short = o.properties.title.substring(0, 3);
            return [
                short,
                'none',
                'none'
            ];
        }
    },
    default: {
        caps (o) {
            return [
                'qr',
                'xfer',
                'qr'
            ];
        },
        display (o) {
            var d = new Date();
            return [
                'DEFTI',
                'LIVE: '
            ];
        },
        brand (o) {
            return 'DEFBR';
        }
    }
};
var // convenience wraapper with exception fall backs for missing methods 
// how will this now gappen with llms 
$440781629901dd2f$export$2e2bcd8739ae039 // var field_map = {
 //     simbot:['name', function( obj ){ return 'Min Eff: '+obj.name } ],
 //     simserver:['name','subname'],
 //     parimutuel:['name','subname'],
 //     simfiat:[
 //         function(obj){ return obj.domain.toUpperCase()  },
 //         'label'],
 //     xclass:['name','price'],
 //     repo:['name','label'],
 //     service:['name','subname'],
 //     token:[
 //         function(obj){ return obj.domain.toUpperCase()  } , 
 //         function(obj){ 
 //             return ''+(Math.random()*0.23).toFixed(4)+'  M'
 //         }.bind(this)],
 //     project:['name','label'],
 //     simcube:[
 //         function(obj){ return obj.domain.charAt(0).toUpperCase() + obj.domain.slice(1)  },
 //         function(obj){ 
 //             var d = new Date()
 //             return 'LIVE: '+d.toLocaleTimeString();
 //         }],
 //     mod:['name','label'],
 //     tag:['name','label'],
 //     alias:['name','subname'],
 //     asset:['name',function(obj){ return ''+Math.round( Math.random()*3.23)+'.00 - M'} ],
 //     connects:[
 //         'wow',
 //         function(obj){ return ''+Math.round( Math.random()*3.23)+'.00 - M'} ],
 //     owns:[],
 //     default:['name','label'],
 // }
 // var xclass_brand_map = {
 //     token:(o)=>{ 
 //         let sub ;
 //         if( 'symbol' in o){
 //             let symb = o.symbol; 
 //             sub = symb.split("/")[0];                    
 //         }else{
 //             sub = 'USX/XYZ'
 //         }
 //         return {
 //             brand:sub
 //         }
 //     },
 //     simcube(o){ 
 //         return {
 //             brand:o.brand
 //         }
 //     }            
 // }  
 // HERE CAN DO DEFAULT ROUTE NOW OR REPLACE MISSING 
 // OR we can switch routes based on same route accross multiple sub domains 
 // FOR NOW RETURN FALSE ON BOTH FIELDS IF NO FUNCTION ?? 
 // var cap_map = {
 //     'repo':['qr','hexframe'],
 //     'tower':['qr','terminal'],
 //     'project':['qr','terminal'],            
 //     'alias':['qr','timeseries'],
 //     'module':['qr','qr','funbay'], 
 //     'token':['qr','qr','qr'], 
 //     'service':['qr','terminal'],
 //     'exchange':['qr','funbay'],
 //     'exchange1':['stored_key','time_series'],
 //     'wordpress1':['auth','anglezone','greenlogo'],
 //     'app1':['tags','app_domain','auth'],
 //     'connects':['qr','xfer','qr'],
 //     'owns':['qr','xfer','qr'],
 //     'transfers':['qr','xfer','qr'],
 //     'link':['qr','xfer','qr'],
 //     'list':['list','list','list']
 // }
 // yo 
 = {
    fieldListFromData (obj) {
        // LABEL ( XCLASS )
        var label;
        //var obj =  this.node.payload;
        if ('labels' in obj) label = obj.labels[0].toLowerCase();
        else label = (obj.label || 'nolower_case').toLowerCase();
        // FIELD LIST 
        var landing_fields = this.xclass_method_object(label, 'display', obj);
        landing_fields[0] = obj.field1 ? obj[obj.field1] : landing_fields[0];
        landing_fields[1] = obj.field2 ? obj[obj.field2] : landing_fields[1];
        landing_fields[2] = obj.field3 ? obj[obj.field3] : landing_fields[2];
        return landing_fields;
    },
    // RELATED SITE
    xclass_rel (xclass, obj) {
        // try xclass & rel , if not return default page  ( prices  )
        var res1 = {};
        try {
            res1 = $440781629901dd2f$var$route_map[xclass].rel(obj);
        } catch (err) {
            console.log(err);
            res1 = 'default.html';
        }
        return res1;
    },
    // INTERESTS 
    xclass_interests (xclass) {
        var interests;
        try {
            interests = $440781629901dd2f$var$route_map[xclass];
            if ($440781629901dd2f$var$route_map[xclass].interests) interests = $440781629901dd2f$var$route_map[xclass].interests({});
            else interests = [] //  Object.keys( interests );  // too many 
            ;
        } catch (err) {
            //console.log( err );
            interests = [];
        }
        return interests;
    },
    // MAP INPUTS 
    xclass_method_object (xclass, method, obj) {
        var insertion_list;
        try {
            if (xclass in $440781629901dd2f$var$route_map && method in $440781629901dd2f$var$route_map[xclass]) insertion_list = $440781629901dd2f$var$route_map[xclass][method](obj);
            else insertion_list = [
                false,
                false
            ];
        } catch (err) {
            console.log(err);
            insertion_list = [
                false,
                false
            ];
        }
        return insertion_list;
    },
    // BRAND WRAP 
    xclass_brand (xclass, method = 'brand', obj) {
        var fullpath;
        // route_map.contains_xclass( xclass )
        if (xclass in $440781629901dd2f$var$route_map && 'brand' in $440781629901dd2f$var$route_map[xclass]) {
            let shortbrand = $440781629901dd2f$var$route_map[xclass]['brand'](obj);
            fullpath = 'media/domain/' + shortbrand + '.png';
        } else fullpath = false;
        return fullpath;
    },
    // BRAND WRAP 
    xclass_caps (xclass, method = 'caps', obj) {
        // get xclass label from route_map 
        var caplist;
        try {
            caplist = $440781629901dd2f$var$route_map[xclass]['caps'](obj);
        } catch (e) {
            console.log(e);
            caplist = [
                'qr',
                'timeseries'
            ];
        }
        caplist = obj && 'fromId' in obj ? [
            'qr',
            'xfer',
            'qr'
        ] : caplist;
        return caplist;
    },
    // GET CUSTOM PROPS RETURN UNKOWN 
    xclass_props (xclass, method = 'props', obj = {}) {
        var proplist;
        try {
            proplist = $440781629901dd2f$var$route_map[xclass.toLowerCase()]['props'](obj);
        } catch (e) {
            proplist = {
                brand: 'unknown',
                name: 'unknown'
            };
        }
        return proplist;
    },
    // MESH WRAP ( MOVING TO route map )
    xclass_mesh (xclass, method, obj) {
        var meshmap_prev_ref_only = {
            'xindex': 'bluecube.glb',
            'domain': 'bluecube.glb',
            'project': 'bluecube.glb',
            'app': 'greencube.glb',
            'world': 'globe.glb',
            'credential': 'key.glb',
            'barrel': 'atm.glb',
            'atm': 'atm.glb',
            'token': 'simtoken.glb',
            'simfiat': 'simfiat.glb',
            'service': 'simcube.glb',
            'actor': 'subuser.gltf',
            'user': 'subuser.gltf',
            'alias': 'simsuit.glb',
            'zerox': 'simsuit.gltf'
        };
        var icon_url;
        try {
            icon_url = $440781629901dd2f$var$route_map[xclass.toLowerCase()]['mesh'](obj);
        } catch (err) {
            icon_url = xclass + '.glb';
        }
        //let icon_url = ( xclass in meshmap ) ? meshmap[ xclass ] : xclass+'.glb';
        let fullpath = 'models3d/' + icon_url; // temp remove seed: +'?'+Math.round( Math.random()*9999 )    
        return fullpath;
    },
    // USED TO POPULATE OBJECT FOR LOADS AND MERGES INTO MAP 
    xclass_launches (xclass, method = 'launches', obj) {
        try {
            res = $440781629901dd2f$var$route_map[xclass][method](obj);
        } catch (err) {
            res = 'unknown';
        }
        return res;
    },
    // USED FOR TITLE OF LISTS IN GLOBAL OBJECT STORE 
    xclass_list_display (xclass, method, obj) {},
    // CAN THIS BE USED TO STRUCTURE DIFFERNT MAP SAVES 
    format_map: {
        current_price: (0, $d581773a71ca2ccc$export$2e2bcd8739ae039).dollar,
        name: (0, $d581773a71ca2ccc$export$2e2bcd8739ae039).pass,
        drd: (0, $d581773a71ca2ccc$export$2e2bcd8739ae039).percent,
        total_supply: (0, $d581773a71ca2ccc$export$2e2bcd8739ae039).units,
        price_change_percentage_24h: (0, $d581773a71ca2ccc$export$2e2bcd8739ae039).percent
    },
    // this method 
    // HERE IN THE FIELD MAP You can just embed a function for specific fields
    // if  domain in need_capitalization='alias','repo'
    // this should use map as route map of which data to put where 
    pull (obj, label, fieldnum) {
        var out_val;
        var field_obj;
        if (label in this.field_map) field_obj = this.field_map[label][fieldnum];
        else //out_val = 'LABEL NOT MAPPED'
        field_obj = this.field_map['default'][fieldnum];
        try {
            out_val = field_obj(obj);
        } catch (err) {
            try {
                out_val = field_obj in obj ? obj[field_obj] : field_obj;
                var l = 3;
            } catch (err) {
                out_val = field_obj;
            }
        }
        return out_val;
    // remembering that this: eval( 'a+"/"+b') // also works
    },
    push (obj_in, target_node) {
        const keys = Object.keys(obj_in);
        // LATER SPEED THIS UP BY ONLY QUERYING THE EXISTING KEYS 
        keys.forEach((key, index)=>{
            console.log(`${key}: ${obj_in[key]}`);
            var fields = target_node.querySelectorAll('#' + key);
            if (fields.length > 0) for(var i = 0; i < fields.length; ++i){
                var field = fields[i]; // .style.color = "green";
                if (field.nodeName.toLowerCase() === 'img') field.src = "/media/domain/" + obj_in[key] + ".png";
                else if (this.format_map.hasOwnProperty(key)) field.innerHTML = this.format_map[key](obj_in[key]);
                else field.innerHTML = obj_in[key];
            }
        });
    },
    pushx (obj_in, target_node) {
        const keys = Object.keys(obj_in);
        // LATER SPEED THIS UP BY ONLY QUERYING THE EXISTING KEYS 
        keys.forEach((key, index)=>{
            console.log(`${key}: ${obj_in[key]}`);
            var fields = target_node.querySelectorAll('#' + key);
            if (fields.length > 0) for(var i = 0; i < fields.length; ++i){
                var field = fields[i]; // .style.color = "green";
                var nodeName = field.nodeName.toLowerCase();
                if (nodeName === 'img') //field.src="/media/domain/"+obj_in[key]+".png";
                field.src = obj_in[key];
                if (nodeName === 'a') //field.src="/media/domain/"+obj_in[key]+".png";
                field.href = obj_in[key];
                else if (this.format_map.hasOwnProperty(key)) field.innerHTML = this.format_map[key](obj_in[key]);
                else field.innerHTML = obj_in[key];
            // if(  typeof(obj_in[key])=='object' ){ // if data is a [] list 
            //     // iterate
            //     var dd=0
            //     // fancy attach 
            // }
            }
        });
    },
    ingest_type_map: function(map_in) {
        // THIS will Adapt the Glue Mapper using Functions Mappings in the data itself 
        // HERE how do we add a different ROUTE For Detail Panel and Avatar X ?? 
        console.log(' Future Route add functions from data ');
    },
    yo () {
        console.log('yo ');
    }
};


//import { factory2d } from '../../../factory/factory2d.js'
// ELX is Viewable Object , 
// can nest children , 
// can emit events , 
// has own level discovery ,
// MovieClip 
class $b462c281b41aa01f$export$fb8073518f34e6ec extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    constructor(initObj = {
        stack: 'vert',
        elem: 'wer',
        items: []
    }){
        // RECEIVE INIT OBJECT has ITEMS and Various instructions 
        // attach the items to container 
        // and register event listeners for clicks  , 
        // render and display the items 
        super(initObj);
        this.initObj = initObj;
        var tile = 'tile' in initObj ? initObj.tile : 'appItemTile';
        var functionality_map_of_fields = {
            'xclass': {
                'display1': 'name',
                'display2': 'price'
            },
            'alias': {
                'display1': 'name',
                'display2': 'price'
            },
            'repo': {
                'display1': 'name',
                'display2': 'label'
            }
        };
        var vnode = factory2d.renderNodeSync(tile, {});
        for(var i = 0; i < this.initObj.items.length; i++){
            var obj = this.initObj.items[i];
            var clonedNode = vnode.cloneNode(true);
            this.container.appendChild(clonedNode);
            (0, $440781629901dd2f$export$2e2bcd8739ae039).pushx(obj, clonedNode);
            // IMAGE 
            // ONLY 
            let imageUrl;
            if ('img' in obj) imageUrl = `url('../media/domain/${obj.img}.png')`;
            else if ('name' in obj) imageUrl = `url('../media/domain/${obj.name}.png')`;
            else imageUrl = 'url(\'../media/domain/undefined.png\')';
            try {
                var img = clonedNode.querySelector("#image");
                img.style.backgroundImage = imageUrl;
            } catch (e) {}
            try {
                clonedNode.setAttribute('fn', obj.fn);
            } catch (e) {}
        // also works; 
        // var resNode = factory2d.renderNodeSync('appItemTile' , obj ); 
        //this.container.appendChild(resNode);
        }
    }
    itemTemplate2(obj_in) {
        let template_item = `
            <div class="griditem">
                <div class="griditemcolumn">
                    ${obj_in.symbol}
                </div>
                <div  class="griditemcolumn">
                    (${obj_in.price})
                </div>
                <div  class="griditemcolumn">
                    [${obj_in.price}]
                </div>                    
                
                <div  class="griditemcolumn">
                    <img src="img/icons/angle-down-solid.svg" class="redarrow" style=" vertical-align:middle;"/>
                    ${obj_in.price}
                </div>
            </div>`;
        return template_item;
    }
    onDataUpdate(data_in) {}
}
 // initObj.elem.appendChild( vnode )
 // incoming looks like // 
 /*

        {
            "meta":{  "type" :"vert"  },

            OR 

            [ { "type":"map" } , {} ]  // bit multiple types cn be both row and grid   |   icon or line 
              // hmm it HAS to be native original type and xclass ,
              // display and view configurtion is separate 
        
        }
        */  // better to have initObj ? 
 // if 'container' in initObj else 'body'
 // if 'data' in initObj else {}
 // if 'id' in initObj else 'qr'
 //this.model = obj.data.model;
 //var xclass = obj.data.label.toLowerCase();
 /*
        container_in.insertAdjacentHTML( 'beforeend' , factory2d.renderSync( 'qr', obj.data ) );
        var qr_panels = container_in.querySelectorAll('#qr')
        var panel = qr_panels[ qr_panels.length-1 ] 
        panel.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
        panel.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="1" modulesize="2"></qr-code>' );
        panel.querySelector('#supereditabletitle').addEventListener('input', function(e){
            //console.log('what input',e.target.value,data_in.uuid, this.model )
            this.model.updateObject( obj.data.uuid , { name:e.target.value } )
        }.bind(this)) */  //this.inject( vnode , obj.data )
 // TEMP SUSPEND GLYPH INJECT UNTIL PERFORMANCE FIX FOR ICONS: 
 //vnode.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
 //vnode.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="0" modulesize="2"></qr-code>' );
 /*
        // ITEM QR 
        var qr = new VanillaQR({
            //url: "https://github.com/chuckfairy/VanillQR.js",
            url: 'http://vi55ti'+obj.data.uuid,
            size: 80,
            colorLight: "#00000000",
            colorDark: "#00FFFF",
            toTable: false,//output to table or canvas
            ecclevel: 1,//Ecc correction level 1-4
            noBorder:true,//Use a border or not
            borderSize: 4//Border size to output at
        });
        vnode.querySelector('#qrbox').appendChild(qr.domElement);

        // ITEM LOGO
        if( 'domain' in obj.data ){
            var domain_elem = document.createElement("img");
            domain_elem.src = 'media/domain/'+obj.data.domain+'.png';
            domain_elem.style.display='block';
            domain_elem.style.marginLeft = "4px";
            domain_elem.style.width=vnode.querySelector('#qrbox').children[0].width+'px';
            vnode.querySelector('#domainbox').appendChild(domain_elem);
        }

        //var gl = new gluemapper( { fieldname: })

        var DISP1 = gluemapper.pull( obj.data , label , 0 )
        var DISP2 = gluemapper.pull( obj.data , label , 1 )

        vnode.querySelector('#display1').value= DISP1
        vnode.querySelector('#display2').value= DISP2
        vnode.querySelector('#display1').addEventListener('input', function(e){
            // console.log('what input',e.target.value,data_in.uuid, this.model )
            // var updateObj = {} // updateObj[ field_aliases[ data.label ][ 'display1'] ] = e.target.value;
            // would resolve to: field_aliases[ 'repo' ]['display1'] => 'name'; 
            // => updateObject=> { 'name':e.target.value }
            this.model.updateObject( obj.data.uuid , { name:e.target.value } )
        }.bind(this))        
        
        */  // FLIP TOP ICONS
 //if( 'ndx' in initObj && initObj.ndx >1 ){
 //    vnode.querySelector('.iditemholder').style.flexDirection='row-reverse';    
 //}
 //var sym = '3f';
 //var vll = 'X'
 // let dv2 = document.createElement('div');
 // dv2.innerHTML = this.itemTemplate2( { symbol:sym, price:vll } );
 // vnode.insertAdjacentHTML( 'beforeend', dv2.innerHTML );
 /*
        var vnode = factory2d.renderNodeSync( 'appItemTile', {} )
        obj.data.price = Math.random();
        var objlist = obj.model.focusIndex;
        var subnode; 

        for( var o in objlist ){

                var nod = objlist[o];
                subnode = factory2d.renderNodeSync( 'listitem', nod.data );
                vnode.appendChild( subnode );    
                
        }*/  // subnode = factory2d.renderNodeSync( 'listitem', {name:'Hong Kong', price:'$32,000 / CM' } );
 // vnode.appendChild( subnode );
 // obj.data.price = Math.random();
 // subnode = factory2d.renderNodeSync( 'listitem', {name:'Argentina', price:'$36,000 / Cap M' } );
 // vnode.appendChild( subnode );        
 // obj.data.price = Math.random();
 // subnode = factory2d.renderNodeSync( 'listitem', {name:'United States', price:'$11,000 / cap' } );
 // vnode.appendChild( subnode );      
 // obj.data.price = Math.random();
 // subnode = factory2d.renderNodeSync( 'listitem', {name:'China', price:'$12/cap' } );
 // vnode.appendChild( subnode );        
 // obj.data.price = Math.random();
 // subnode = factory2d.renderNodeSync( 'listitem', {name:'South Korea', price:'$11/cap' } );
 // vnode.appendChild( subnode );     
 // obj.data.price = Math.random();
 // subnode = factory2d.renderNodeSync( 'listitem', {name:'Tritun', price:'$30,000/gram' } );
 // vnode.appendChild( subnode );       
 // obj.data.price = Math.random();
 // subnode = factory2d.renderNodeSync( 'listitem', {name:'GOLD', price:'$1,400/gram' } );
 // vnode.appendChild( subnode );    
 // obj.data.price = Math.random();
 // subnode = factory2d.renderNodeSync( 'listitem', {name:'Water Liter', price:'$10/liter' } );
 // vnode.appendChild( subnode );       
 // obj.data.price = Math.random();
 // subnode = factory2d.renderNodeSync( 'listitem', {name:'Silver AG', price:'$1,400/gram' } );
 // vnode.appendChild( subnode );                             
 // obj.data.price = Math.random();
 // subnode = factory2d.renderNodeSync( 'listitem', {name:'StarLINK', price:'$532/share' } );
 // vnode.appendChild( subnode );       
 // obj.data.price = Math.random();
 // subnode = factory2d.renderNodeSync( 'listitem', {name:'AIR METER', price:'$1,400/m3' } );
 // vnode.appendChild( subnode );                             
 //initObj.target.appendChild( vnode )
 // PASS THE NODE MODIFIABLE DATA ONLY 
 /*
        const { body, links,plane,sprite,tele, ...allExceptThe } = obj.data;
        this.kvs = new Kvs( { container: vnode.querySelector('#qr_keyval') , data:allExceptThe  }  )

        this.kvs.addEventListener( 'kvInputEvent' , function(e){
            console.log(' QR hears kvInputEvent ')
            this.model.updateObject( this.uuid , e.detail  )
        }.bind(this));
        */  //var shadow = this.attachShadow({mode: 'open'});
 //shadow.innerHTML = `<p>Hello, ${ wot }</p>`;
 // attach custom listeners 
 //con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
 // fil in the image from obj
 // con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';


class $09c90862b9048f4b$var$QNav {
    constructor(){
        this.con = {};
        this.drawer_open = 0;
        this.drawer = 0;
        const title = this.title;
        this.onSessionEvent = this.onSessionEvent.bind(this);
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.onNavEvent = this.onNavEvent.bind(this);
        this.onAnyClickEvent = this.onAnyClickEvent.bind(this);
        this.render();
    }
    render() {
        this.con = document.createElement('div');
        this.con.setAttribute("id", "qnav_con");
        // Make the menu container fixed to the upper right corner
        this.con.style.position = "fixed";
        this.con.style.top = "0";
        this.con.style.right = "0";
        this.con.style.zIndex = "9999";
        this.con.style.width = "100%";
        document.body.appendChild(this.con);
        this.con.innerHTML = `
            <script src='js/TweenMax.min.js'></script>
            <base href="/uix/">
            <style>
                .xnavicon {
                    font-size:30px;
                    position: absolute;
                    font-family: 'Roboto Condensed', sans-serif;
                    cursor: pointer;
                    top:0;
                    right:0;
                    padding:15px;
                    margin-top:-3px;
                    margin-right:9px;
                    -webkit-user-select: none; /* Safari */        
                    -moz-user-select: none; /* Firefox */
                    -ms-user-select: none; /* IE10+/Edge */
                    user-select: none; /* Standard */
                    color:rgb(255, 248, 248);
                    /* Add black outline for visibility on white backgrounds */
                    text-shadow:
                        -1px -1px 0 #000,  
                         1px -1px 0 #000,
                        -1px  1px 0 #000,
                         1px  1px 0 #000;
                }
                .xnavcart {
                    font-size:30px;
                    position: absolute;
                    font-family: 'Roboto Condensed', sans-serif;
                    cursor: pointer;
                    top:0;
                    right:50px;
                    padding:15px;
                    margin-top:11px;
                    margin-right:9px;
                    -webkit-user-select: none; /* Safari */        
                    -moz-user-select: none; /* Firefox */
                    -ms-user-select: none; /* IE10+/Edge */
                    user-select: none; /* Standard */
                    color:rgb(255, 248, 248);
                    /* Add black outline for visibility on white backgrounds */
                    text-shadow:
                        -1px -1px 0 #000,  
                         1px -1px 0 #000,
                        -1px  1px 0 #000,
                         1px  1px 0 #000;
                }
                .xnava {
                    font-size:30px;
                    position: absolute;
                    font-family: 'Roboto Condensed', sans-serif;
                    cursor: pointer;
                    top:0;
                    left:0;
                    padding:15px;
                    margin-top:1px;
                    margin-left:9px;
                    -webkit-user-select: none; /* Safari */        
                    -moz-user-select: none; /* Firefox */
                    -ms-user-select: none; /* IE10+/Edge */
                    user-select: none; /* Standard */
                    color:rgb(255, 248, 248);
                    /* Add black outline for visibility on white backgrounds */
                    text-shadow:
                        -1px -1px 0 #000,  
                         1px -1px 0 #000,
                        -1px  1px 0 #000,
                         1px  1px 0 #000;
                }                                            
                .xnavitem{
                    margin:10px;
                    color:white;
                    font-weight:bold;
                    font-family: 'Roboto Condensed', sans-serif;
                    cursor:pointer;
                }   
                .frmlabel{
                    color:#FFFFFF;
                    font-size:11px;
                } 
                .logerout{
                    
                    text-align:center; 
                    margin-bottom:5px;
                    font-size:11px;
                }
                #slide_drawer2{
                    position:absolute; 
                    top:0px; width:300px; right:-400px; 
                    pointer-events: auto;
                }
                .slide_container{
                    /*
                    width:300px; 
                    height:400px; 
                    position:fixed; */
                    top:0px; 
                    right:0px; 
                }

            </style>

            <div class="xnava" fn="aClick">&#9651;</div>    
            <div id="slide_container" class="slide_container" style="">

                <div id="slide_drawer2" style="margin-top:80px;">
                    
                    <div id="columnHolder" style="display:flex;">
                        <div id="stagePanelsHolder" style=" width:100%;" > 
                            <div id='displaystage0' style="pointer-events:auto; margin:10px; "></div>
                            <div id='displaystage1' style="pointer-events:auto; margin:10px; "></div>
                            <div id='displaystage2' style="pointer-events:auto; margin:10px; "></div>                   
                        </div>
                        <div id="vertNavHolder" style=" " > </div>
                    </div>
                    

                </div>
                
                <div class="xnavicon" fn="burgerClick">&#9776;</div>    
                
 

            </div>
            
            <input type="file" id="fileInputZ" style="display:none;">`;
        this.con.addEventListener('click', this.onAnyClickEvent.bind(this));
        // DO WE NEED THIS EXTRA EVENT , MAYBE JUST LUMP THIS IN CLICK 
        // DETECT .xnavicon and route with switch : 
        // this.con.querySelector(".xnavicon").onclick = function(event) {
        //     this.toggleDrawer()
        //     var eventObj = { 'action':'burgerClick' }
        //     window.dispatchEvent( new CustomEvent('uiEvent', { detail:eventObj }) );
        // }.bind(this)
        // CHANGE LOGO 
        var dom = (0, $b1acb6ed8a11dca2$export$722a64dea1b767dc).domain();
        if (dom == '127.0.0.1') dom = 'localhost';
        //this.con.querySelector("#qnavlogo").src="img/"+dom+".png"
        factory2d.loadAll([
            './../x_modules/apps/qr/qr.html',
            './../uix/qpanels.html'
        ]).then((libx)=>{
        //var displayStage0 = this.container.querySelector('#displaystage0');
        //var displayStage1 = this.container.querySelector('#displaystage1');
        //var displayStage2 = this.container.querySelector('#displaystage2');
        //this.resetMainPanel();
        //var searchmod = new SearchMod( { target:displayStage1   } );
        //var d=3;
        });
    }
    onFileSelected(event) {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e)=>{
                try {
                    const json = JSON.parse(e.target.result);
                    console.log(json);
                } catch (error) {
                    console.error("Error parsing JSON:", error);
                }
            };
            reader.readAsText(file);
        }
    }
    resetMainPanel() {
        var displayStage0 = this.con.querySelector("#vertNavHolder");
        displayStage0.innerHTML = '';
        // //displayStage0.style.display = 'flex';
        // //displayStage0.style.flexDirection = 'column';
        displayStage0.style.width = '50px';
        // // Adjust displayStage0 to hug the right side and squeeze the rest of the content in the parent
        // //displayStage0.style.position = 'absolute';
        // displayStage0.style.top = '0';
        // displayStage0.style.right = '0';
        // //displayStage0.style.height = '100%';
        // //displayStage0.style.display = 'flex';
        // displayStage0.style.flexDirection = 'column';
        // displayStage0.style.alignItems = 'flex-end';
        // displayStage0.style.justifyContent = 'flex-start';
        //displayStage0.style.zIndex = '1000';
        // Optionally, ensure the parent is positioned relative so absolute works as expected
        displayStage0.parentElement;
        //displayStage0.style.gap = '10px';
        var cll = new (0, $b462c281b41aa01f$export$fb8073518f34e6ec)({
            target: displayStage0,
            tile: "settingsTile",
            items: [
                {
                    name: 'cart',
                    fn: 'installTile'
                },
                {
                    name: 'search',
                    fn: 'check_status'
                },
                {
                    name: 'list2',
                    fn: 'showcol_object'
                },
                {
                    name: 'settingsl',
                    fn: 'show_settings'
                },
                {
                    name: 'closex',
                    fn: 'exit'
                }
            ]
        });
        var displayStage1 = this.con.querySelector('#displaystage1');
        displayStage1.innerHTML = '';
        var displayStage2 = this.con.querySelector('#displaystage2');
        displayStage2.innerHTML = '';
    }
    // CLICKS 
    onAnyClickEvent(e) {
        var fn = 'false/false';
        var nd = this.con.querySelector("#displaystage2");
        // EXTRACT FN CRAWL
        let target = e.target;
        while(target && target !== this.con){
            if ('fn' in target.attributes) {
                var fn = target.getAttribute('fn');
                break;
            }
            target = target.parentElement;
        }
        var tokens = fn.split('/');
        var fun_token = tokens[0] || tokens[0];
        fn = fun_token;
        var authEventObj = {};
        var eventObj = {
            fn: fn,
            action: fn
        };
        switch(fn){
            case 'aClick':
                this.toggleDrawer();
                break;
            case 'burgerClick':
                this.toggleDrawer();
                break;
            case "home":
                // JUST RESTORE LANDING PAGE: 
                // THIS NEEDS MODDL SO IT HAS TO TRIGGER STATE CHANGE 
                // SO broadcast event upstream : 
                var eventObj = {
                    fn: "home"
                };
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: eventObj
                }));
                break;
            case 'create':
                //console.log(' click create object '+tokens[2] )
                eventObj['fn'] = 'createObject';
                eventObj['type'] = tokens[2];
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: eventObj
                }));
                break;
            case 'show_unlock':
                eventObj['domain'] = e.target.querySelector("#domain").innerHTML;
                eventObj['stamp'] = e.target.querySelector("#stamp").innerHTML;
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: eventObj
                }));
                break;
            case 'show_file_unlock':
                //eventObj['domain'] = e.target.querySelector("#domain").innerHTML;
                //eventObj['stamp'] = e.target.querySelector("#stamp").innerHTML;
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: eventObj
                }));
                break;
            case 'show_download_map':
                this.clearContent();
                this.updatePanel('downloadMapPanel', {});
                break;
            case 'show_import_map':
                this.clearContent();
                this.updatePanel('importMapPanel', {});
                break;
            case 'show_create':
                this.clearContent();
                this.updatePanel('createPanel', {});
                break;
            case 'cred_launch':
            case 'cred_del':
            case 'cred_merge':
                var dom = e.target.closest('#credItem').getAttribute('dom');
                var uuid = e.target.closest('#credItem').getAttribute('uuid');
                eventObj['domain'] = dom;
                eventObj['uuid'] = uuid;
                eventObj['action'] = fn;
                eventObj['fn'] = fn;
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: eventObj
                }));
                break;
            case "show_cred":
                var holder = e.target.parentNode.querySelector("#holder");
                if (holder.children.length > 0) holder.innerHTML = '';
                else {
                    var dom = e.target.parentNode.querySelector("#f1").textContent;
                    //eventObj['domain']=dom;
                    eventObj['uuid'] = e.target.closest("#credItem").getAttribute("uuid");
                    window.dispatchEvent(new CustomEvent('uiEvent', {
                        detail: eventObj
                    }));
                /*
                    var kobj= { title:"wut" , meta:"zao" , nice:3 };
                    var dom = e.target.parentNode.querySelector("#f1").textContent;
                    var holder = e.target.parentNode.querySelector("#holder");
                    holder.innerHTML="";//empty holder 
                    this.kvs = new Kvs( { container:holder , data:kobj  }  )
                    this.kvs.addEventListener( 'kvInputEvent' , function(e){
                        console.log(' QR hears kvInputEvent ')
                        this.model.updateObject( this.uuid , e.detail  )
                    }.bind(this));
                    */ }
                break;
            case 'create_vault':
                console.log(' logout in QNav ');
                var eventObj = {};
                eventObj['action'] = fn;
                eventObj['code'] = this.con.querySelector("#code").value + '_';
                eventObj['domain'] = this.con.querySelector("#domain").value;
                eventObj['passphrase1'] = this.con.querySelector("#passphrase1").value;
                eventObj['passphrase2'] = this.con.querySelector("#passphrase2").value;
                const encoder = new TextEncoder();
                const data = encoder.encode(eventObj['code']);
                crypto.subtle.digest('SHA-256', data).then((hashBuffer)=>{
                    const hashArray = Array.from(new Uint8Array(hashBuffer));
                    const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
                    if (hashHex == '533e44064100075049b1cdd161580937ac38f52948531eb47d930c61c53ebaef') window.dispatchEvent(new CustomEvent('uiEvent', {
                        detail: eventObj
                    }));
                    else {
                        const logErrOut = this.con.querySelector("#logerrcodeout");
                        if (logErrOut) {
                            logErrOut.style.color = "#FF0000"; // Set text color to red
                            logErrOut.textContent = "ENTER CODE"; // Update text content
                        }
                    }
                }).catch((err)=>{
                    console.error('Hashing failed:', err);
                });
                break;
            case 'create_vaultOG':
                console.log(' logout in QNav ');
                var eventObj = {};
                eventObj['action'] = fn;
                eventObj['domain'] = this.con.querySelector("#domain").value;
                eventObj['passphrase1'] = this.con.querySelector("#passphrase1").value;
                eventObj['passphrase2'] = this.con.querySelector("#passphrase2").value;
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: eventObj
                }));
                break;
            case 'register':
                authEventObj['un'] = this.con.querySelector("#un").value;
                authEventObj['ac'] = this.con.querySelector("#ac").value;
                authEventObj['pw'] = this.con.querySelector("#pw1").value;
                authEventObj['pw2'] = this.con.querySelector("#pw1").value;
                authEventObj['fn'] = e.target.attributes['fn'].textContent;
                authEventObj['action'] = fn;
                authEventObj['module'] = 'generic';
                authEventObj['method'] = fn;
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: authEventObj
                }));
                break;
            case 'reset':
                authEventObj['un'] = this.con.querySelector("#username").value;
                authEventObj['fn'] = e.target.attributes['fn'].textContent;
                authEventObj['action'] = fn;
                authEventObj['method'] = fn;
                authEventObj['module'] = 'generic';
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: authEventObj
                }));
                break;
            case 'logout':
                console.log(' logout in QNav ');
                authEventObj['action'] = fn;
                authEventObj['module'] = 'generic';
                authEventObj['method'] = 'generic';
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: authEventObj
                }));
                break;
            case 'login':
                authEventObj['un'] = this.con.querySelector("#username").value;
                authEventObj['pw'] = this.con.querySelector("#password").value;
                authEventObj['fn'] = e.target.attributes['fn'].textContent;
                authEventObj['action'] = fn;
                authEventObj['method'] = fn;
                authEventObj['module'] = 'generic';
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: authEventObj
                }));
                break;
            case 'login_vault':
                authEventObj['domain'] = this.con.querySelector("#domain").innerHTML;
                authEventObj['pw'] = this.con.querySelector("#password").value;
                authEventObj['fn'] = e.target.attributes['fn'].textContent;
                authEventObj['action'] = fn;
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: authEventObj
                }));
                break;
            case 'unlockimport_vault':
                //authEventObj['domain'] = this.con.querySelector("#domain").innerHTML;
                authEventObj['pw'] = this.con.querySelector("#password").value;
                //authEventObj['fn'] = e.target.attributes['fn'].textContent
                authEventObj['action'] = fn;
                authEventObj['raw'] = this.raw_import;
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: authEventObj
                }));
                break;
            case 'appendObject':
                authEventObj['dom'] = this.con.querySelector("#dom").value;
                authEventObj['ke'] = this.con.querySelector("#ke").value;
                authEventObj['se'] = this.con.querySelector("#se").value;
                authEventObj['fn'] = e.target.attributes['fn'].textContent;
                authEventObj['action'] = fn;
                if (this.con.querySelector("#url").value) authEventObj['url'] = this.con.querySelector("#url").value;
                authEventObj['ty'] = this.con.querySelector("#ty").value;
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: authEventObj
                }));
                break;
            case 'show_settings':
                this.updatePanel('settingsPanel', {});
                break;
            case 'show_reg':
                this.updatePanel('registerPanel', {});
                break;
            case 'show_elements':
                this.updatePanel('elementsPanel', {});
                break;
            case 'show_login':
                this.updatePanel('loginPanel', {});
                break;
            case 'show_reset':
                this.updatePanel('resetPanel', {});
                break;
            case 'show_add':
                this.updatePanel('addPanel', {});
                break;
            case 'show_import':
                this.updatePanel('importPanel', {});
                break;
            case 'help':
                this.updatePanel('helpPanel', {});
                break;
            case 'show_local':
                this.updatePanel('localPanel', {});
                break;
            case 'exit_vault':
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: eventObj
                }));
                break;
            case 'exit':
                //window.dispatchEvent( new CustomEvent('uiEvent', { detail:eventObj }) )   
                this.toggleDrawer();
                break;
            case 'check_status':
            case 'show_collections':
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: eventObj
                }));
                break;
            case 'installTile':
                this.updatePanel('installTilePanel', {});
                break;
            default:
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: eventObj
                }));
                break;
        }
    }
    // MODEL EVENTS
    onNavEvent(e) {
        console.log(e);
        var model = e.detail.model;
        var nd = this.con; //.querySelector("#displaystage2")
        //if( model.session.state_change == 'check_status'){
        //this.drawer_open=0;
        //gsap.to( this.drawer , { duration:1, right:-350 , ease:Expo.easeOut , delay:1} );        
        //}
        switch(model.session.state_change){
            case "start":
                //COMMENT OUT FOR LANDING ON LOGIN 
                this.updatePanel('landingPanel', model);
                this.toggleDrawer();
                break;
            case "home":
                //COMMENT OUT FOR LANDING ON LOGIN 
                this.updatePanel('landingPanel', model);
                break;
            case "check_status":
                //var n = 'newcode'
                if (model.session.state == 1) {
                    this.resetMainPanel();
                    this.updatePanel('statusPanel', model);
                } else if (model.session.state == 2) this.updatePanel('loginPanel', model);
                else // RUNNING LOCAL?
                if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') this.updatePanel('landingPanel', model);
                else this.updatePanel('landingPanel', model);
                break;
            case "show_status":
                //var n = 'newcode'
                //if( model.state )
                this.updatePanel('statusPanel', model.session);
                break;
            case "show_procs":
                //var n = 'newcode'
                this.clearContent();
                var ftyp = model.session.state_change.split("_").pop();
                //var vnode = factory2d.renderNodeSync( 'collectionsPanel', { label:'TEST'} )
                //var avail = model.keycache.itemsByScope( 'ty', ftyp );
                var avail = model.getProcs();
                for(var i in avail){
                    var cred_item = factory2d.renderNodeSync('credItem', {
                        vaultname: 'Vault1'
                    });
                    var obj = avail[i];
                    var ty = 'ty' in obj ? obj['ty'] : 'unknown';
                    //var dom = ( obj.uuid && obj.dom != '') ? obj.dom : crypto.randomUUID();
                    cred_item.querySelector("#ftyp").src = '/img/' + ty + '.png';
                    cred_item.querySelector("#f1").innerHTML = '' + i.slice(0, 12) // obj.domain;
                    ;
                    cred_item.querySelector("#f3").innerHTML = 'PROC';
                    nd.appendChild(cred_item);
                }
                break;
            case "show_collections":
            case "showcol_object":
            case "showcol_map":
            case "showcol_maps":
            case "showcol_key":
            case "showcol_vault":
            case "showcol_device":
                //this.clearContent();
                var ftyp = model.session.state_change.split("_").pop();
                var vnode = factory2d.renderNodeSync('collectionsPanel', {
                    label: 'TEST'
                });
                var avail = model.keycache.itemsByScope('ty', ftyp);
                for(var i in avail){
                    var cred_item = factory2d.renderNodeSync('credItem', {
                        vaultname: 'Vault1'
                    });
                    var obj = avail[i];
                    var ty = 'ty' in obj ? obj['ty'] : 'unknown';
                    //var dom = ( obj.uuid && obj.dom != '') ? obj.dom : crypto.randomUUID();
                    cred_item.querySelector("#ftyp").src = '/img/' + ty + '.png';
                    cred_item.querySelector("#f1").innerHTML = obj.dom;
                    cred_item.setAttribute('dom', obj.uuid);
                    cred_item.setAttribute('uuid', obj.uuid);
                    cred_item.setAttribute('fn', 'nav_' + ty);
                    // { type: 'map', title: 'miccco/Vission', fragment: 'miccco/vission', searchable: 'map miccco/vission', color: '#341661', …}
                    cred_item.querySelector("#f3").innerHTML = ty;
                    cred_item.querySelector("#f1").innerHTML = 'dom' in obj ? obj['dom'] : 'domain' in obj ? obj['domain'] : 'UNKN';
                    //cred_item.querySelector("#f2").innerHTML= ( 'ke' in obj ) ? obj['ke'] : '# # # #' ;                    
                    //vault_item.querySelector("#domain").innerHTML=item.dom;
                    //vault_item.querySelector("#stamp").innerHTML=item.update_date.toISOString();
                    //vault_item.setAttribute("domain", item.dom );
                    vnode.querySelector("#app_tray").appendChild(cred_item);
                }
                //var dv = this.con.querySelector('displaystage1');
                var displayStage1 = this.con.querySelector('#displaystage1');
                displayStage1.innerHTML = '';
                displayStage1.appendChild(vnode);
                break;
            case "show_cred":
                var obja = model.session.selected_object;
                var sel_dom = model.session.selected_object.uuid;
                var sel_uid = model.session.selected_object.uuid;
                // how to get right item by domain ? 
                var holder = nd.querySelector('[uuid="' + sel_dom + '"]').querySelector('#holder');
                //var kobj = model.keycache.items[ sel_dom ];
                var kobj = model.keycache.keySelect('uuid', sel_dom)[0];
                this.kvs = new (0, $3494c43f722f695b$export$1e2124d9bec1f71d)({
                    container: holder,
                    data: kobj
                });
                // COOL TEMP WAY DEFAULT FUNC INIT TO WRITE UPDATE
                // LATER CHANGE TO BUBBLE EVENT 
                this.kvs.addEventListener('kvInputEvent', (function(e, uid = sel_uid, dat = model.keycache) {
                    console.log(' QR hears kvInputEvent ');
                    dat.keyUpdate('uuid', uid, e.detail);
                // this.model.updateObject( this.uuid , e.detail ) //
                }).bind(this));
                var cred_options = factory2d.renderNodeSync('credOptions', {
                    vaultname: 'Vault1'
                });
                holder.appendChild(cred_options);
                break;
            case "show_unlock":
                this.clearContent();
                var vnode = factory2d.renderNodeSync('unlockPanel', {
                    label: 'TEST'
                });
                var inode = factory2d.renderNodeSync('vaultItem', {
                    label: 'TEST'
                });
                //inode.querySelector('#domain')( 'domain', model.selected_object.domain)
                inode.querySelector("#domain").innerHTML = model.session.selected_object.domain;
                inode.querySelector("#stamp").innerHTML = model.session.selected_object.stamp;
                vnode.querySelector('#app_tray').appendChild(inode);
                var stage = nd.querySelector("#displaystage2");
                stage.appendChild(vnode);
                break;
            case "keyImport":
            case "downloadBlob":
                this.clearContent();
                var vnode = factory2d.renderNodeSync('unlockPanel', {
                    label: 'TEST'
                });
                var inode = factory2d.renderNodeSync('vaultItem', {
                    label: 'TEST'
                });
                //inode.querySelector('#domain')( 'domain', model.selected_object.domain)
                inode.querySelector("#domain").innerHTML = model.session.file.dom; //"IMPORTED FILE";//model.session.selected_object.domain;
                inode.querySelector("#stamp").innerHTML = model.session.file.update_date;
                vnode.querySelector('#app_tray').appendChild(inode);
                var stage = nd.querySelector("#displaystage2");
                stage.appendChild(vnode);
                break;
            case "cred_del":
                var seluuid = model.session.selected_object.uuid;
                var holder = nd.querySelector('[uuid="' + seluuid + '"]');
                holder.parentNode.removeChild(holder);
                var k = 4;
                break;
            default:
                console.log(' default click in Qnav ');
                break;
        }
        var a = 0;
        var b = 2;
    }
    onSessionEvent(obj) {
        var model = obj.detail.model;
        switch(obj.detail.module){
            case 'generic':
                console.log('def ');
                break;
            default:
                if (model.session.state == 0) // HERE IT SHOULD SELECT APPROPRIATE 
                // PANEL FOR CLIENT APP
                // NOT LOGIN PANEL 
                this.updatePanel('loginPanel', model.session);
                else if (model.session.state == 1) this.resetMainPanel();
                else if (model.session.state == 2) this.updatePanel('landingPanel', model);
                else {
                    if (obj.detail.message) this.con.querySelector('#sessionfeedback').innerHTML = obj.detail.message;
                    else if ((0, $b1acb6ed8a11dca2$export$722a64dea1b767dc).isElectron()) this.updatePanel('landingPanel', model);
                    else this.updatePanel('registerPanel', model.session);
                }
                break;
        }
    }
    onAuthEvent(obj) {
    //this.updatePanel('loginPanel')
    }
    // PANEL UPDATES
    clearContent() {
        var nd = this.con.querySelector("#displaystage1");
        while(nd.firstChild)nd.removeChild(nd.lastChild);
        var nd = this.con.querySelector("#displaystage2");
        while(nd.firstChild)nd.removeChild(nd.lastChild);
    }
    async updatePanel(panel_in, model) {
        // update panel display 
        var nd = this.con.querySelector("#displaystage1");
        var obj = model.session;
        this.clearContent();
        // ATTACH PANEL
        var vnode = factory2d.renderNodeSync(panel_in, {
            label: 'TEST'
        });
        nd.appendChild(vnode);
        if (panel_in == 'unlockPanel') {
            var vault_item = factory2d.renderNodeSync('vaultItem2', {
                vaultname: 'Vault1'
            });
            vault_item.querySelector("#vaultname").innerHTML = "DAO Local";
            nd.querySelector("#app_tray").appendChild(vault_item);
        }
        if (panel_in == 'landingPanel') {
            // IMPORT ENCRYPTED
            var displayStage1 = this.con.querySelector("#displaystage1");
            var newDiv = document.createElement('div');
            //newDiv.style.display = 'flex';
            newDiv.style.flexWrap = 'wrap';
            newDiv.style.gap = '10px';
            newDiv.style.height = '800px;';
            newDiv.style.backgroundColor = '#222831'; // grayish dark
            newDiv.id = 'zlla';
            displayStage1.innerHTML = '';
            displayStage1.appendChild(newDiv);
            var displayStageNested = displayStage1.querySelector("#zlla");
            var import_item = factory2d.renderNodeSync('vaultItemImport', {
                vaultname: 'Vault1'
            });
            displayStageNested.appendChild(import_item);
            // CREATE NEW VAULT 
            var vault_item = factory2d.renderNodeSync('vaultItemNew', {
                vaultname: 'Vault1'
            });
            displayStageNested.appendChild(vault_item);
            // SHOW EXISTING VAULTS 
            var avail = await model.keycache.discoverVaults();
            avail.forEach(function(item) {
                var vault_item = factory2d.renderNodeSync('vaultItem', {
                    vaultname: 'Vault1'
                });
                vault_item.querySelector("#domain").innerHTML = item.dom;
                const updateDate = new Date(item.update_date);
                const formattedDate = `${updateDate.getMonth() + 1}.${updateDate.getDate()}.${updateDate.getFullYear()}`;
                vault_item.querySelector("#stamp").innerHTML = formattedDate;
                vault_item.setAttribute("domain", item.dom);
                displayStageNested.appendChild(vault_item);
            });
        } //////////////////////////////////////////////////////////
        // CUSTOM LOGIC PANELS 
        if (panel_in == 'importPanel') {
            function onReaderLoad(event) {
                // var obj = JSON.parse(event.target.result);
                // ( if yaml else json ) //
                // should try to parse as text OR yaml 
                // bubble event with blob to session model  ?
                // 
                // should move to process
                this.raw_import = event.target.result;
                var conf_obj = (0, $59c911fa927d1bcf$export$2e2bcd8739ae039).parse(this.raw_import);
                conf_obj['action'] = 'keyImport';
                conf_obj['fn'] = 'keyImport';
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: conf_obj
                }));
                var x = 0;
            }
            function onChange(event) {
                var reader = new FileReader();
                reader.onload = onReaderLoad.bind(this);
                reader.readAsText(event.target.files[0]);
            }
            nd.querySelector('#xfile').addEventListener('change', onChange.bind(this));
        }
        // CUSTOM LOGIC PANELS 
        if (panel_in == 'importMapPanel') {
            // nd.querySelector('#lastlogin').innerHTML=obj['lastlogin']
            // nd.querySelector('#ip').innerHTML=obj['un']+' @ '+obj['ip']
            var l = 3;
            function onReaderLoad1(event) {
                // var obj = JSON.parse(event.target.result);
                // ( if yaml else json ) //
                // should try to parse as text OR yaml 
                // bubble event with blob to session model  ?
                // 
                // should move to process
                this.raw_import = event.target.result;
                var conf_obj = (0, $59c911fa927d1bcf$export$2e2bcd8739ae039).parse(this.raw_import);
                conf_obj['action'] = 'importComplete';
                conf_obj['fn'] = 'importComplete';
                window.dispatchEvent(new CustomEvent('uiEvent', {
                    detail: conf_obj
                }));
                var x = 0;
            }
            function onChange1(event) {
                var reader = new FileReader();
                reader.onload = onReaderLoad1.bind(this);
                reader.readAsText(event.target.files[0]);
                var t = 0;
            }
            nd.querySelector('#mfile').addEventListener('change', onChange1.bind(this));
        }
        // CUSTOM LOGIC PANELS 
        if (panel_in == 'settingsPanel') {
            //nd.querySelector('#lastlogin').innerHTML=obj['lastlogin']
            //nd.querySelector('#ip').innerHTML=obj['un']+' @ '+obj['ip']
            var qr = new (0, $e1d36db1977d2c76$export$2e2bcd8739ae039)({
                url: "https://apdex.com/connect",
                size: 80,
                colorLight: "#00000000",
                colorDark: "#EEEEFF",
                toTable: false,
                ecclevel: 1,
                noBorder: true,
                borderSize: 0 // Border size to output at
            });
            nd.querySelector('#qr').appendChild(qr.domElement); //Canvas or table is stored in domElement property
            function onChange2(event) {
                var reader = new FileReader();
                reader.onload = onReaderLoad2;
                reader.readAsText(event.target.files[0]);
            }
            function onReaderLoad2(event) {
                // var obj = JSON.parse(event.target.result);
                // ( if yaml else json ) //
                var conf_obj = (0, $59c911fa927d1bcf$export$2e2bcd8739ae039).parse(event.target.result);
                window.dispatchEvent(new CustomEvent('keyImportEvent', {
                    detail: conf_obj
                }));
                var x = 0;
            }
        //nd.querySelector('#xfile').addEventListener('change', onChange);
        }
        if (panel_in === 'installTilePanel') {
            const installTile = factory2d.renderNodeSync('installTile', {
                label: 'Install Tile'
            });
            nd.appendChild(installTile);
        }
    }
    toggleDrawer() {
        if (this.drawer_open) this.closePanel();
        else this.openPanel();
    }
    openPanel() {
        this.drawer_open = 1;
        this.drawer = this.con.querySelector('#slide_drawer2');
        (0, $f7cabcf4b0e0fb2e$export$99ee26438460406a).to(this.drawer, {
            duration: 1,
            right: 0,
            ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
        });
    }
    closePanel() {
        this.drawer_open = 0;
        this.drawer = this.con.querySelector('#slide_drawer2');
        (0, $f7cabcf4b0e0fb2e$export$99ee26438460406a).to(this.drawer, {
            duration: 1,
            right: -350,
            ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
        });
    }
}
var $09c90862b9048f4b$export$2e2bcd8739ae039 = $09c90862b9048f4b$var$QNav;


//import ObjectSystem from './objectsystem.js';
//import { openDB, deleteDB, wrap, unwrap } from './../../web_modules/idb.js';
//import { set,get , update,del, clear,keys,values,entries ,createStore } from './../../web_modules/idb-keyval.js';
/**
 * Work around Safari 14 IndexedDB open bug.
 *
 * Safari has a horrible bug where IDB requests can hang while the browser is starting up. https://bugs.webkit.org/show_bug.cgi?id=226547
 * The only solution is to keep nudging it until it's awake.
 */ function $dbce632c199fae44$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    // No point putting other browsers or older versions of Safari through this mess.
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
function $dbce632c199fae44$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $dbce632c199fae44$export$f51a9068ac82ea43(dbName, storeName) {
    const dbp = $dbce632c199fae44$var$idbReady().then(()=>{
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        return $dbce632c199fae44$export$b327150396135fe7(request);
    });
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $dbce632c199fae44$var$defaultGetStoreFunc;
function $dbce632c199fae44$var$defaultGetStore() {
    if (!$dbce632c199fae44$var$defaultGetStoreFunc) $dbce632c199fae44$var$defaultGetStoreFunc = $dbce632c199fae44$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $dbce632c199fae44$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dbce632c199fae44$export$3988ae62b71be9a3(key, customStore = $dbce632c199fae44$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$dbce632c199fae44$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dbce632c199fae44$export$adaa4cf7ef1b65be(key, value, customStore = $dbce632c199fae44$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $dbce632c199fae44$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dbce632c199fae44$export$daa0a5170277c7a8(entries, customStore = $dbce632c199fae44$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $dbce632c199fae44$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dbce632c199fae44$export$5df405cccea42673(keys, customStore = $dbce632c199fae44$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$dbce632c199fae44$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dbce632c199fae44$export$722fbec263ad908a(key, updater, customStore = $dbce632c199fae44$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($dbce632c199fae44$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dbce632c199fae44$export$1d2f21e549771e67(key, customStore = $dbce632c199fae44$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $dbce632c199fae44$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dbce632c199fae44$export$c8aa84257229cac8(keys, customStore = $dbce632c199fae44$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $dbce632c199fae44$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dbce632c199fae44$export$42ffd38884aecdac(customStore = $dbce632c199fae44$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $dbce632c199fae44$export$b327150396135fe7(store.transaction);
    });
}
function $dbce632c199fae44$var$eachCursor(customStore, callback) {
    return customStore('readonly', (store)=>{
        // This would be store.getAllKeys(), but it isn't supported by Edge or Safari.
        // And openKeyCursor isn't supported by Safari.
        store.openCursor().onsuccess = function() {
            if (!this.result) return;
            callback(this.result);
            this.result.continue();
        };
        return $dbce632c199fae44$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dbce632c199fae44$export$ed97f33186d4b816(customStore = $dbce632c199fae44$var$defaultGetStore()) {
    const items = [];
    return $dbce632c199fae44$var$eachCursor(customStore, (cursor)=>items.push(cursor.key)).then(()=>items);
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dbce632c199fae44$export$68c286be0e7e55b7(customStore = $dbce632c199fae44$var$defaultGetStore()) {
    const items = [];
    return $dbce632c199fae44$var$eachCursor(customStore, (cursor)=>items.push(cursor.value)).then(()=>items);
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dbce632c199fae44$export$3e9f948b41964866(customStore = $dbce632c199fae44$var$defaultGetStore()) {
    const items = [];
    return $dbce632c199fae44$var$eachCursor(customStore, (cursor)=>items.push([
            cursor.key,
            cursor.value
        ])).then(()=>items);
}


function $f88ac7a2e1f41a9d$export$abe4376e1bf796d6() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}
async function $f88ac7a2e1f41a9d$export$9169be2e06c9c165(str) {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashedString = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    return hashedString;
}


function $dad38998d2bf836c$export$8d76bc887c5255cb(buf) {
    return String.fromCharCode.apply(null, new Uint8Array(buf));
}
function $dad38998d2bf836c$export$d6ba8d66061675f7(str) {
    var buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
    var bufView = new Uint8Array(buf);
    for(var i = 0, strLen = str.length; i < strLen; i++)bufView[i] = str.charCodeAt(i);
    return buf;
}
function $dad38998d2bf836c$export$667db85d785f1afc(str) {
    var arr = [];
    for(var i = 0; i < str.length; i++)arr[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4);
    return "\\u" + arr.join("\\u");
}
function $dad38998d2bf836c$var$stringToHsl(stringInput) {
    let stringUniqueHash = [
        ...stringInput
    ].reduce((acc, char)=>{
        return char.charCodeAt(0) + ((acc << 5) - acc);
    }, 0);
    return `hsl(${stringUniqueHash % 360}, 95%, 35%)`;
}
/**
 * 
 * @param {String} - stringInput - 'xyz'
 * @returns {String} - color in hex color code - '#ae6204'
 */ function $dad38998d2bf836c$var$stringToHexColor(stringInput) {
    const h = [
        ...stringInput
    ].reduce((acc, char)=>{
        return char.charCodeAt(0) + ((acc << 5) - acc);
    }, 0);
    const s = 95, l = 0.35;
    const a = s * Math.min(l, 1 - l) / 100;
    const f = (n)=>{
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color).toString(16).padStart(2, '0'); // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
}
function $dad38998d2bf836c$export$70c4ae293293ca1e(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for(var i = 0; i < len; i++)binary += String.fromCharCode(bytes[i]);
    return window.btoa(binary);
}
function $dad38998d2bf836c$export$a7a17e76664e3e44(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for(var i = 0; i < len; i++)bytes[i] = binary_string.charCodeAt(i);
    return bytes.buffer;
}


class $ed871e0b99fd3eca$var$KeyCache {
    constructor(initObj = {}){
        this.store = $dbce632c199fae44$export$f51a9068ac82ea43('kcdbnm', 'kcdbst');
        this.items = []; //{} was 
        this.intermediateKey;
        this.imk;
        this.publicKey;
        this.privateKey;
        this.wrappedKey;
        this.dom;
        this.domhash;
        this.iv;
        this.ek;
        // if anchor it would persist between ressions via 
        // encrypted wasm nugget for seed 
        this.anchor = 'anchor' in initObj ? initObj.anchor : false;
    }
    async deleteBlob() {
        $dbce632c199fae44$export$1d2f21e549771e67(this.dom, this.store); //console.log(' current blob', this.dom );
    }
    async discoverVaults() {
        var availvaults = [];
        var lst = await $dbce632c199fae44$export$68c286be0e7e55b7(this.store);
        return lst;
    }
    exit() {
        this.im_key = false;
        this.items = [];
    }
    async encryptItems() {
        var itemsarr = [];
        for(var i in this.items)itemsarr.push(this.items[i]);
        let s = JSON.stringify(itemsarr);
        let bDat = new TextEncoder().encode(s);
        var cBlob = await window.crypto.subtle.encrypt({
            name: "AES-GCM",
            // Don't re-use initialization vectors!
            // Always generate a new iv every time your encrypt!
            // Recommended to use 12 bytes length
            iv: this.initilizationVector,
            // Additional authentication data (optional)
            // additionalData: ArrayBuffer,
            // Tag length (optional)
            tagLength: 128 //can be 32, 64, 96, 104, 112, 120 or 128 (default)
        }, this.im_key, bDat //ArrayBuffer of data to encrypt
        );
        var unen = await this.decryptItems(cBlob);
        // conert arrau to string bavk to arrau and dectrypt 
        // how to turn thid cBlob back to text 
        // TEST DECRYPT FROM STRING 
        // var blob = new Blob([cBlob], {type: 'text/plain; charset=utf-8'});    
        // var textst = await blob.text()   //.then(text => console.log(text));   
        // var v3 = convert.arrayBufferToBase64( cBlob );
        // var v5 = convert.base64ToArrayBuffer( v3 );
        // // arrayBufferToBase64( buffer ) {
        // // base64ToArrayBuffer(base64) {
        // // convert text to blob
        // var myblob = new Blob([textst], {type: 'text/plain;  charset=utf-8'});
        // var see= await myblob.arrayBuffer();
        // // the text sh0uld convert to arraybuffer 23728
        // var arbufdat = convert.str2ab( textst );
        // var ffff =  new TextEncoder().encode( textst );
        // var dxtxt = new TextDecoder("utf-8").decode( ffff );        
        // var ff = await this.decryptItems( ffff );
        // var eo =0;
        // var dds =9;
        return cBlob;
    }
    async decryptItems(cBlob) {
        var decryptedData = await window.crypto.subtle.decrypt({
            name: "AES-GCM",
            iv: this.initilizationVector,
            //additionalData: ArrayBuffer, //The addtionalData you used to encrypt (if any)
            tagLength: 128
        }, this.im_key, cBlob //ArrayBuffer of the data
        );
        var yofinalObj = decryptedData;
        var enc2 = new TextDecoder("utf-8");
        var finObj = enc2.decode(yofinalObj);
        var fimfim = JSON.parse(finObj);
        return fimfim;
    }
    async save() {
        var cBlob = await this.encryptItems();
        var res = await $dbce632c199fae44$export$adaa4cf7ef1b65be(this.dom, {
            dom: this.dom,
            update_date: new Date(),
            dat: cBlob
        }, this.store);
        var l = 1;
    }
    // EXPORT FILE
    async exportFile() {
        var cBlob = await this.encryptItems();
        const a = document.createElement("a");
        // TEXTST STRING from AB // 
        //const blob = new Blob([cBlob], {type: 'text/plain; charset=utf-8'});    
        //var textst = await blob.text()//.then(text => console.log(text));        
        var textst = $dad38998d2bf836c$export$70c4ae293293ca1e(cBlob);
        var jsonData = {
            dom: this.dom,
            update_date: new Date(),
            dat: textst
        };
        a.href = URL.createObjectURL(new Blob([
            JSON.stringify(jsonData, null, 2)
        ], {
            type: "application/json",
            type_og: "text/plain"
        }));
        a.setAttribute("download", "data.json");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    // OK WARNING THIS IS 
    async exportClear() {
        //var cBlob = await this.encryptItems()
        const a = document.createElement("a");
        // TEXTST STRING from AB // 
        //const blob = new Blob([cBlob], {type: 'text/plain; charset=utf-8'});    
        //var textst = await blob.text()//.then(text => console.log(text));        
        var jsonData = {
            dom: this.dom,
            update_date: new Date(),
            dat: this.items
        };
        a.href = URL.createObjectURL(new Blob([
            JSON.stringify(jsonData, null, 2)
        ], {
            type: "application/json",
            type_og: "text/plain"
        }));
        a.setAttribute("download", "data.json");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    async available(dom1) {
        var existObj = await $dbce632c199fae44$export$3988ae62b71be9a3(dom1, this.store);
        return existObj == undefined;
    }
    ensure_uuids(obj_in) {
        for(const i in obj_in){
            var obj = obj_in[i];
            if (!obj.uuid || obj.uuid == '') obj['uuid'] = $f88ac7a2e1f41a9d$export$abe4376e1bf796d6();
        }
        return obj_in;
    }
    // IMPORT FILE 
    async importFileAndLogin(file, pw) {
        // RECEIVE object , and PW? 
        // GRAB DAT , and Decompress 
        await this.set_imkey(dom, pw);
        console.log(' for importing saved files ');
    }
    async loginAndLoad(dom1, pw, blob = false) {
        await this.set_imkey(dom1, pw);
        var blobdata = {};
        if (blob) blobdata = {
            dat: blob
        };
        else blobdata = await $dbce632c199fae44$export$3988ae62b71be9a3(dom1, this.store);
        // HERE BLOBDATA from BOTH SHOULD BE GOOD
        if (blobdata) try {
            var tempitems = await this.decryptItems(blobdata.dat);
            if (typeof tempitems == 'Object') {
                var l = 3;
                console.log(' previous enc sch detect ');
            }
            this.items = await this.decryptItems(blobdata.dat);
            this.ensure_uuids(this.items);
            var wut = 9;
            //this.items['x']={ty: 'map', title: 'miccco/Vission', fragment: 'miccco/vission', searchable: 'map miccco/vission', color: '#341661'}
            //this.items['y']={ty: 'map', title: 'miccco/Vission', fragment: 'miccco/vission', searchable: 'map miccco/vission', color: '#341661'}
            var x = 0;
            return true;
        } catch (err) {
            return false;
        }
        else return false;
    }
    async set_imkey(dom1, pw) {
        // DERIVE INITILIZATION VECTORS 
        const encoder = new TextEncoder();
        let dat1 = encoder.encode(dom1);
        let dat2 = encoder.encode('0x' + dom1); // if send hex address 
        let dat3 = encoder.encode(pw);
        let hashBuf1 = await window.crypto.subtle.digest('SHA-256', dat1);
        let hashBuf2 = await window.crypto.subtle.digest('SHA-256', dat2);
        this.salt = new Uint8Array(hashBuf1.slice(0, 16));
        this.initilizationVector = new Uint8Array(hashBuf2.slice(0, 12));
        // GENERATE KEY MATERIAL FROM INCOMINGPW
        var keyMaterial = await window.crypto.subtle.importKey("raw", encoder.encode(pw), "PBKDF2", false, [
            "deriveBits",
            "deriveKey"
        ]);
        let im_key = await window.crypto.subtle.deriveKey({
            name: "PBKDF2",
            salt: this.salt,
            iterations: 100000,
            hash: "SHA-256"
        }, keyMaterial, {
            name: "AES-GCM",
            length: 256
        }, true, [
            "encrypt",
            "decrypt"
        ]);
        // RANDOMIZED ONE TIME 
        // this.salt_og = window.crypto.getRandomValues(new Uint8Array(16));
        // this.initilizationVector_og = window.crypto.getRandomValues(new Uint8Array(12));
        // SAVE INTERMEDIATE
        this.imk = im_key;
        this.im_key = im_key;
        this.domhash = dat1;
        this.dom = dom1;
    }
    // ADD REMOVE
    appendCollection(obj_in) {
        for(var i in obj_in)this.items[obj_in[i]['domain']] = obj_in[i];
        var xy = this.items;
    }
    keySelect(k, v) {
        var outarray = [];
        for(var xk in this.items){
            var item = this.items[xk];
            if (item.hasOwnProperty(k)) {
                if (item[k] === v) outarray.push(item);
            }
        }
        if (v == 'object') return this.items;
        else return outarray;
    }
    // UPDATE ITEM BY KEY 
    keyUpdate(k, v, obj) {
        var outarray = [];
        for(var xk in this.items){
            var item = this.items[xk];
            if (item.hasOwnProperty(k) && item[k] == v) {
                //item[ k ] = v;
                for(var i in obj)// TODO: exception for overwriting ***  from views 
                if (i == 'se' && obj[i].includes('***')) // skip display layer obfuscated update 
                var e = 3;
                else item[i] = obj[i];
            }
        }
    }
    // DELETE ITEM BY KEY 
    keyDelete(k, v) {
        var bb = 9;
        var outarray = [];
        for(var xk in this.items){
            var item = this.items[xk];
            if (item.hasOwnProperty(k)) {
                if (item[k] === v) delete this.items[xk];
            }
        }
        var reindexed = [];
        for(var s in this.items)reindexed.push(this.items[s]);
        this.items = reindexed;
    }
    itemsByScope(k, v) {
        var bb = 9;
        var outarray = [];
        for(var xk in this.items){
            var item = this.items[xk];
            if (item.hasOwnProperty(k)) {
                if (item[k] === v) outarray.push(item);
            }
        }
        if (v == 'object') return this.items;
        else return outarray;
    }
    // UPDATE ITEM BY KEY 
    // should hash remain vs. array because of single value requirement?
    // util of array was non sync of hash addrs and domain attr on object 
    keyMerge(k, v, obj) {
        var outarray = [];
        for(var xk in this.items){
            var item = this.items[xk];
            if (item.hasOwnProperty(k) && item[k] == v) {
                //item[ k ] = v;
                // propagate uuid 
                if (!obj['uuid']) obj.uuid = item.uuid;
                this.items[xk] = obj;
                // here it needs to ensure uuid
                //this.items[xk]['dat']=obj.dat;                        
                return;
            }
        }
        //new
        this.addItem(obj);
    }
    replaceItem(obj) {
    //  overwrite uuid ? 
    // 
    }
    addItem(obj = {}) {
        // ABORT IF ALREADY EXISTS OVERRIDDEN , maybe rename to previous version
        // if( ob.dom in this.items ){
        //     return false;
        // }else{  }
        // CURRENT SETUP WILL OVERWRITE
        // ADD UUID IF NONE INCOMING ( )
        if (!('uuid' in obj)) // HERE WE CAN SETUP FUTURE UUIDV4 to take hint_object = ob
        obj['uuid'] = $f88ac7a2e1f41a9d$export$abe4376e1bf796d6();
        // NESTED DATA 
        obj['dat'] = obj.payload ? obj.payload : obj.dat;
        delete obj.payload;
        //this.items[ obj.dom ] = obj; 
        this.items.push(obj);
        // this.items[ ob.dom ]={dom:ob.dom , 
        //                        ke:ob.ke , 
        //                        se:ob.se , ty:ob.ty , dat:ob , 
        //                        uuid:cur_uuid };
        //}
        //var existingItem = (domain_in in this.items) ? this.items[ domain_in ] : {};        
        //this.items[domain_in] = { ...existingItem , ...obj_in }           
        return true;
    }
    deleteItem(domain_in) {
        delete this.items[domain_in];
    }
    count() {
        return Object.keys(this.items).length;
    }
    // MERGE CREDENTIALS 
    mergeArtifacts(obj_in) {
        var inVal = obj_in.brand ? obj_in.brand : obj_in.module;
        return {
            ...obj_in,
            ...this.keySelect('dom', inVal)[0]
        };
    }
    get(key_in) {
        return this.keySelect('dom', key_in)[0];
    }
    // function ab2str(buf) {
    //     return String.fromCharCode.apply(null, new Uint16Array(buf));
    // }
    // function str2ab(str) {
    //     var buf = new ArrayBuffer(str.length*2); // 2 bytes for each char
    //     var bufView = new Uint16Array(buf);
    //     for (var i=0, strLen=str.length; i < strLen; i++) {
    //     bufView[i] = str.charCodeAt(i);
    //     }
    //     return buf;
    // }    
    async digestMessage(message) {
        var msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
        var hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8); // hash the message
        var hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
        var hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
        return hashHex;
    }
}
var $ed871e0b99fd3eca$export$2e2bcd8739ae039 // addXXXXOverwrites( obj_in ){
 //     this.items[ obj_in['domain'] ] = obj_in;
 // }   
 // RETURN ALL ITEMS MATCHING KEY VAL 
 //this.addItem( 'coinbs' , { ke:'ke' , se:'wew' , dom:'coinbs' } )
 //this.addItem( 'krainbs2' , { ke:'kf3f3f3e' , se:'wa2a2aew' , dom:'coinbs' } )
 //this.addItem( 'coinbs' , { ke:'ke' , se:'wew' , dom:'coinbs' } )
 //this.deleteItem( 'krainbs2' )
 //this.addItem( 'vog' , { ke:'kf3f3f3e' , se:'wa2a2aew' , dom:'coinbs' } )
 //this.runtest();
 //this.osz= new ObjectSystem({});
 // this.rundb()    
 //   async rundb(){
 //        var lst = await idbkv.values();
 //var qw = await get('ewe').catch((err) => console.log('It failed!', err));      
 //var qrr= await get('qwe').catch((err) => console.log('It failed!', err));
 // logs: "worcld"
 //         clear()
 //         get('qwre')
 //         .then((val) => console.log( 'gotn',val))
 //         .catch( (err)=> console.log('llll',err));        
 //         set('xalpha.local', { dom:'xalpha.local', update_date:new Date() , items:88088 } )
 //           .then(() => console.log('It worked!'))
 //           .catch((err) => console.log('It failed!', err));
 //         set('DAO.demo.local', { dom:'DAO.demo.local', update_date:new Date() , items:88088 } )
 //           .then(() => console.log('It worked!'))
 //           .catch((err) => console.log('It failed!', err));
 //  }
 // //////////////// FROM MNEMONIC 
 // var mnemonic = "monkey wild winning team fluff whatnot";
 // var wallet = Wallet.fromMnemonic(mnemonic);
 // console.log("Address: " + wallet.address);
 // //////////////// Brain Wallet
 // var un = "village@monkeys.io";
 // var pw = "somesuperpass";
 // Wallet.fromBrainWallet( un, pw).then(function(wallet) {
 //         console.log("Address: " + wallet.address);
 // });
 // loc store 
 //         var availvaults=[];
 //         Object.keys(localStorage).forEach(function(key){
 //             availvaults.push( { dom:key , val:localStorage.getItem(key) }  )
 //         });
 //         return availvaults;
 // function LocalStore(){
 //     this.push=function( obj ){
 //         console.log(' push localstore')
 //     }
 // }
 //         if( dom in localStorage ){
 //             var wObj =  localStorage.getItem( dom );
 //             let enc = new TextEncoder();
 //             var cBlob = enc.encode( wObj );
 //             try {
 //                 //await thisThrows();
 //                 var decryptedData = await window.crypto.subtle.decrypt(
 //                     {
 //                         name: "AES-GCM",
 //                         iv:this.initilizationVector,
 //                         //additionalData: ArrayBuffer, //The addtionalData you used to encrypt (if any)
 //                         tagLength: 128, //The tagLength you used to encrypt (if any)
 //                     },
 //                     this.im_key, //from generateKey or importKey above
 //                     cBlob//ArrayBuffer of the data
 //                 )
 //                 var yofinalObj = decryptedData;
 //                 console.log(new Uint8Array(yofinalObj));
 //                 var enc2 = new TextDecoder("utf-8");
 //                 var finObj = enc2.decode( yofinalObj );
 //             } catch (e) {
 //                 console.log(e);
 //             } finally {
 //                 console.log('We do cleanup here');
 //             }    
 //     async runtest(){
 //         this.hashed_domain = 
 //         this.salt = window.crypto.getRandomValues(new Uint8Array(16));
 //         this.initilizationVector = window.crypto.getRandomValues(new Uint8Array(12));
 //         let pw = "wowsers"; // window.prompt("Enter your password");
 //         let enc = new TextEncoder();
 //         var keyMaterial = await window.crypto.subtle.importKey(
 //             "raw",   
 //             enc.encode(pw),
 //             "PBKDF2",
 //             false,
 //             ["deriveBits", "deriveKey"]
 //         );
 //         let im_key = await window.crypto.subtle.deriveKey(
 //             {
 //                 name:      "PBKDF2",
 //                 salt:       this.salt,
 //                 iterations: 100000,
 //                 hash:      "SHA-256"
 //             },
 //             keyMaterial,
 //             { 
 //                 name: "AES-GCM", 
 //                 length: 256 
 //             },
 //             true,
 //             ["encrypt", "decrypt"]
 //         );
 //         const obj = {name: "xjsx", axis: 230, city: "New York"};
 //         const objString = JSON.stringify(obj);
 //         //var enc = new TextEncoder(); // always utf-8
 //         var data = enc.encode( objString );
 //         var gen_key = await window.crypto.subtle.generateKey(
 //             {
 //                 name: "AES-GCM",   // Galois/Counter Mode
 //                 length: 256,       // Key Length can be  128, 192, 256
 //             },
 //             false,                 // key is extractable (i.e. can be used in exportKey)
 //             ["encrypt", "decrypt"] // can be "encrypt", "decrypt", "wrapKey", or "unwrapKey"
 //         )
 //         var eblob = await window.crypto.subtle.encrypt(
 //             {
 //                 name: "AES-GCM",
 //                 //Don't re-use initialization vectors!
 //                 //Always generate a new iv every time your encrypt!
 //                 //Recommended to use 12 bytes length
 //                 iv: this.initilizationVector,
 //                 //Additional authentication data (optional)
 //                 //additionalData: ArrayBuffer,
 //                 //Tag length (optional)
 //                 tagLength: 128 //can be 32, 64, 96, 104, 112, 120 or 128 (default)
 //             },
 //             im_key,  //from generateKey or importKey above
 //             data   //ArrayBuffer of data to encrypt
 //         )        
 //         var decryptedData = await window.crypto.subtle.decrypt(
 //             {
 //                 name: "AES-GCM",
 //                 iv:this.initilizationVector,
 //                 //additionalData: ArrayBuffer, //The addtionalData you used to encrypt (if any)
 //                 tagLength: 128, //The tagLength you used to encrypt (if any)
 //             },
 //             im_key, //from generateKey or importKey above
 //             eblob //ArrayBuffer of the data
 //         )
 //         var yofinalObj = decryptedData;
 //         console.log(new Uint8Array(yofinalObj));
 //         var enc2 = new TextDecoder("utf-8");
 //         var finObj = enc2.decode( yofinalObj );
 //         localStorage.setItem( 'enc_test' , enc2.decode( eblob) );
 //         console.log( finObj );
 //         console.log( JSON.parse( finObj) );
 //     }
 //     async readBlob( name_in ){
 //         // item xds
 //         var item =  localStorage.getItem( name_in );
 //         if( item ){
 //             var obj= JSON.parse( item )
 //             return obj;
 //         }else{
 //             return {};
 //         }
 //     }
 //     async writeBlob( name_in ){
 //         // get memory resident and convert to byteArray 
 //         var obj = this.items;
 //         //var item = this.getLocal()
 //         var blob = this.readBlob();
 //         var newlocal = { ...item , ...obj }   
 //         localStorage.setItem( name_in  , JSON.stringify(obj) );
 //         return newlocal;
 //     }
 // YOU ARE HERE :  DOES ALIAS WRAP CYTHON ? 
 // this.alias.authenticate() 
 // Alias checks current auth and loads inventory blob ? 
 // 
 // ALIAS_PROXY   , ALIAS_WRAPPER()
 // a = AliasProxy()
 // a.authenticate( obj ) 
 // now token is in Cython  AliasProxy falls back on localstore
 // 
 // a.search( string )
 // v = a.vehicle( 'domain' ,'symbol')
 // map_object.vehicles = v ;
 // map talks to vehicle / object inside the map through alias. 
 // YOU ARE HERE :  DOES ALIAS WRAP CYTHON ? 
 // this.alias.authenticate() 
 // Alias checks current auth and loads inventory blob ? 
 // ALIAS_PROXY   , ALIAS_WRAPPER()
 // a = AliasProxy()
 // a.authenticate( obj )  
 // now token is in Cython  AliasProxy falls back on localstore
 // a.search( string )
 // v = a.vehicle( 'domain' ,'symbol')
 // map_object.vehicles = v ;
 // map talks to vehicle / object inside the map through alias. 
 //var crypto = crypto.subtle;
 //var ephem_im_key = hash( initObj.key );
 // var item =  localStorage.getItem(  hash( userPub ) + key_domain);
 //         this.encProm = crypto.subtle.encrypt( 'wow' ).then(function( out ){
 //returns a keypair object
 //            / console.log( ' total out ' );
 //             console.log( out );
 //         });
 //this.solve();
 //         window.crypto.subtle.generateKey(
 //             {
 //                 name: "RSA-OAEP",
 //                 modulusLength: 4096,
 //                 publicExponent: new Uint8Array([1, 0, 1]),
 //                 hash: "SHA-256",//can be "SHA-1", "SHA-256", "SHA-384", or "SHA-512"
 //             },
 //             true, //whether the key is extractable (i.e. can be used in exportKey)
 //             ["sign", "verify"] //can be any combination of "sign" and "verify"
 //         )
 //         .then( async function(key){
 //             //returns a keypair object
 //             console.log('key Cache Key ');
 //             console.log(key);
 //             console.log(key.publicKey);
 //             console.log(key.privateKey);
 //             const result = await window.crypto.subtle.encrypt( 
 //                 {name: "RSA-OAEP"},  
 //                 key.publicKey, 
 //                 new TextEncoder().encode('mystring')
 //             );
 //             console.log(' result ', result)
 //         })
 //         .catch(function(err){
 //             console.error(err);
 //         });
 // PEM encoded X.509 key
 // const publicKey = 
 // `-----BEGIN PUBLIC KEY-----
 // MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAunF5aDa6HCfLMMI/MZLT
 // OhZu+0Bo1LXloCTe+vmIQ2YCX7EatUOuyQMt2Vwx4uV+d/A3DP6PtMGBKpF8St4i
 // GwIDAQAB
 // -----END PUBLIC KEY-----`;
 // importPublicKeyAndEncrypt();
 //     async function importPublicKeyAndEncrypt() {
 //         const plaintext = 'This text will be encoded UTF8 and may contain special characters like § and €.';
 //         try {
 //             const pub = await importPublicKey(publicKey);
 //             const encrypted = await encryptRSA(pub, new TextEncoder().encode(plaintext));
 //             const encryptedBase64 = window.btoa(ab2str(encrypted));
 //             console.log(encryptedBase64.replace(/(.{64})/g, "$1\n")); 
 //         } catch(error) {
 //             console.log(error);
 //         }
 //     }
 //     async function importPublicKey(spkiPem) {       
 //         return await window.crypto.subtle.importKey(
 //             "spki",
 //             getSpkiDer(spkiPem),
 //             {
 //                 name: "RSA-OAEP",
 //                 hash: "SHA-256",
 //             },
 //             true,
 //             ["encrypt"]
 //         );
 //     }
 //     async function encryptRSA(key, plaintext) {
 //         let encrypted = await window.crypto.subtle.encrypt(
 //             {
 //                 name: "RSA-OAEP"
 //             },
 //             key,
 //             plaintext
 //         );
 //         return encrypted;
 //     }
 //     function getSpkiDer(spkiPem){
 //         const pemHeader = "-----BEGIN PUBLIC KEY-----";
 //         const pemFooter = "-----END PUBLIC KEY-----";
 //         var pemContents = spkiPem.substring(pemHeader.length, spkiPem.length - pemFooter.length);
 //         var binaryDerString = window.atob(pemContents);
 //         return str2ab(binaryDerString); 
 //     }
 // //
 // // Helper
 // //
 //     // https://stackoverflow.com/a/11058858
 //     function str2ab(str) {
 //         const buf = new ArrayBuffer(str.length);
 //         const bufView = new Uint8Array(buf);
 //         for (let i = 0, strLen = str.length; i < strLen; i++) {
 //             bufView[i] = str.charCodeAt(i);
 //         }
 //         return buf;
 //     }
 //     function ab2str(buf) {
 //         return String.fromCharCode.apply(null, new Uint8Array(buf));
 //     }
 //         // window.crypto.subtle.encProm( )
 //     }
 //     resetAll( obj ){
 //         localStorage.clear();
 //         this.connector.logout().then( function( authObj ){
 //             this.setSession( {} )
 //         }.bind(this))
 //     }    
 //     async  rsaKeyPair() {
 //       let keyPair = await crypto.subtle.generateKey({
 //           name: "RSA-OAEP",
 //           modulusLength: 4096,
 //           publicExponent: new Uint8Array([1, 0, 1]),
 //           hash: "SHA-256",
 //         },
 //         true, ["wrapKey", "unwrapKey"]
 //       );
 //       this.publicKey = keyPair.publicKey;
 //       this.privateKey = keyPair.privateKey;
 //     }
 //     async encrypt(secret) {
 //       // generating random intermediate key to encrypt and decrypt the secret
 //       this.intermediateKey = await crypto.subtle.generateKey({
 //           name: "AES-GCM",
 //           length: 256
 //         },
 //         true, ["encrypt", "decrypt"]
 //       );
 //       var s=33;
 //       // encrypt secret
 //       // ...
 //       // wrap intermediate key (export + encrypt) intermediateKey using publicKey.
 //       this.iv = crypto.getRandomValues(new Uint8Array(12));
 //       this.wrappedKey = await crypto.subtle.wrapKey(
 //         "jwk",
 //         this.intermediateKey,
 //         this.publicKey, {
 //           name: "AES-GCM",
 //           iv: this.iv
 //         }
 //       );
 //       var s=23;
 //     }
 //     async decrypt(cipher) {
 //       // unwrap (decrypt + import) aes key using private key.
 //       this.intermediateKey = await crypto.subtle.unwrapKey(
 //         "jwk",
 //         this.wrappedKey,
 //         this.privateKey, {
 //           name: "AES-GCM",
 //           iv: iv
 //         }, {
 //           name: "AES-GCM"
 //         },
 //         false, ["encrypt", "decrypt"]
 //       );
 //       // decrypt the cipher
 //       // ...
 //     }
 //     async  solve() {
 //       // generate rsa-keypairs
 //       await this.rsaKeyPair();
 //       // encrypt secret
 //       const cipher = await this.encrypt("secret");
 //       // decrypt cipher
 //       await this.decrypt(cipher);
 //     }
 //     //// LOCAL STORAGE 
 //     getLocal(){
 //         var item =  localStorage.getItem('sm');
 //         if( item ){
 //             var obj= JSON.parse( item )
 //             return obj;
 //         }else{
 //             return {};
 //         }
 //     }
 //     pushLocal( obj ){
 //         var item = this.getLocal()
 //         var newlocal = { ...item , ...obj }   
 //         localStorage.setItem('sm', JSON.stringify(obj) );
 //         return newlocal;
 //     }
 //     onLogEvent(){
 //         console.log(' state model hears log event ',this)
 //     }
 = $ed871e0b99fd3eca$var$KeyCache;



var $f555e5b4f123ed0e$var$run_counter = 1;
var $f555e5b4f123ed0e$var$counter = 0;
function $f555e5b4f123ed0e$var$inspect(obj) {
    $f555e5b4f123ed0e$var$run_counter++;
    var out = {
        message: 'ob',
        error: 0
    };
    // MISMATCH 
    if (obj.passphrase1 != obj.passphrase2) {
        out.message = 'Mismatched PassPhrase';
        out.error = 1;
    }
    // PAS MISH 
    if ('passphrase1' in obj && obj.passphrase1.length < 1) {
        out.message = 'PassPhrase Too Short';
        out.error = 1;
    }
    // DOM SHORT  
    if (obj.domain == '') {
        console.log('fd');
        out.message = 'Domain Missing';
        out.error = 1;
    }
    return out;
}
function $f555e5b4f123ed0e$var$increment() {
    $f555e5b4f123ed0e$var$counter++;
}
function $f555e5b4f123ed0e$var$decrement() {
    $f555e5b4f123ed0e$var$counter--;
}
var $f555e5b4f123ed0e$export$2e2bcd8739ae039 = {
    counter: $f555e5b4f123ed0e$var$counter,
    inspect: $f555e5b4f123ed0e$var$inspect,
    increment: $f555e5b4f123ed0e$var$increment,
    decrement: $f555e5b4f123ed0e$var$decrement
};




var $692e115c8623e54c$var$start_time = new Date();
var $692e115c8623e54c$var$singleton = ' UniqID_' + Math.round(Math.random() * 99);
function $692e115c8623e54c$export$e04aa69d28450d55() {
    let timepassed = (new Date() - $692e115c8623e54c$var$start_time) / 1000;
    console.log($692e115c8623e54c$var$singleton, timepassed);
    return timepassed;
}
async function $692e115c8623e54c$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
function $692e115c8623e54c$var$delay(milisec) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve('');
        }, milisec);
    });
}
function $692e115c8623e54c$export$abe4376e1bf796d6() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}


(function e(t, n, r) {
    function s(o, u) {
        if (!n[o]) {
            if (!t[o]) {
                var a = undefined;
                if (!u && a) return a(o, !0);
                if (i) return i(o, !0);
                var f = new Error("Cannot find module '" + o + "'");
                throw f.code = "MODULE_NOT_FOUND", f;
            }
            var l = n[o] = {
                exports: {}
            };
            t[o][0].call(l.exports, function(e) {
                var n = t[o][1][e];
                return s(n ? n : e);
            }, l, l.exports, e, t, n, r);
        }
        return n[o].exports;
    }
    var i = undefined;
    for(var o = 0; o < r.length; o++)s(r[o]);
    return s;
})({
    1: [
        function(require1, module, exports) {
            /*  A entry point for the browser bundle version. This gets compiled by:

        browserify --debug ./ccxt.browser.js > ./dist/ccxt.browser.js
 */ // self works in webworkers too
            self.ccxt = require1('./ccxt');
        },
        {
            "./ccxt": 2
        }
    ],
    2: [
        function(require1, module, exports) {
            "use strict";
            /*

MIT License

Copyright (c) 2017 Igor Kroitor

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/ //-----------------------------------------------------------------------------
            const Exchange = require1('./js/base/Exchange'), Precise = require1('./js/base/Precise'), functions = require1('./js/base/functions'), errors = require1('./js/base/errors');
            //-----------------------------------------------------------------------------
            // this is updated by vss.js when building
            const version = '1.82.16';
            Exchange.ccxtVersion = version;
            //-----------------------------------------------------------------------------
            const exchanges = {
                'aax': require1('./js/aax.js'),
                'ascendex': require1('./js/ascendex.js'),
                'bequant': require1('./js/bequant.js'),
                'bibox': require1('./js/bibox.js'),
                'bigone': require1('./js/bigone.js'),
                'binance': require1('./js/binance.js'),
                'binancecoinm': require1('./js/binancecoinm.js'),
                'binanceus': require1('./js/binanceus.js'),
                'binanceusdm': require1('./js/binanceusdm.js'),
                'bit2c': require1('./js/bit2c.js'),
                'bitbank': require1('./js/bitbank.js'),
                'bitbay': require1('./js/bitbay.js'),
                'bitbns': require1('./js/bitbns.js'),
                'bitcoincom': require1('./js/bitcoincom.js'),
                'bitfinex': require1('./js/bitfinex.js'),
                'bitfinex2': require1('./js/bitfinex2.js'),
                'bitflyer': require1('./js/bitflyer.js'),
                'bitforex': require1('./js/bitforex.js'),
                'bitget': require1('./js/bitget.js'),
                'bithumb': require1('./js/bithumb.js'),
                'bitmart': require1('./js/bitmart.js'),
                'bitmex': require1('./js/bitmex.js'),
                'bitopro': require1('./js/bitopro.js'),
                'bitpanda': require1('./js/bitpanda.js'),
                'bitrue': require1('./js/bitrue.js'),
                'bitso': require1('./js/bitso.js'),
                'bitstamp': require1('./js/bitstamp.js'),
                'bitstamp1': require1('./js/bitstamp1.js'),
                'bittrex': require1('./js/bittrex.js'),
                'bitvavo': require1('./js/bitvavo.js'),
                'bkex': require1('./js/bkex.js'),
                'bl3p': require1('./js/bl3p.js'),
                'blockchaincom': require1('./js/blockchaincom.js'),
                'btcalpha': require1('./js/btcalpha.js'),
                'btcbox': require1('./js/btcbox.js'),
                'btcmarkets': require1('./js/btcmarkets.js'),
                'btctradeua': require1('./js/btctradeua.js'),
                'btcturk': require1('./js/btcturk.js'),
                'buda': require1('./js/buda.js'),
                'bw': require1('./js/bw.js'),
                'bybit': require1('./js/bybit.js'),
                'bytetrade': require1('./js/bytetrade.js'),
                'cdax': require1('./js/cdax.js'),
                'cex': require1('./js/cex.js'),
                'coinbase': require1('./js/coinbase.js'),
                'coinbaseprime': require1('./js/coinbaseprime.js'),
                'coinbasepro': require1('./js/coinbasepro.js'),
                'coincheck': require1('./js/coincheck.js'),
                'coinex': require1('./js/coinex.js'),
                'coinfalcon': require1('./js/coinfalcon.js'),
                'coinmate': require1('./js/coinmate.js'),
                'coinone': require1('./js/coinone.js'),
                'coinspot': require1('./js/coinspot.js'),
                'crex24': require1('./js/crex24.js'),
                'cryptocom': require1('./js/cryptocom.js'),
                'currencycom': require1('./js/currencycom.js'),
                'delta': require1('./js/delta.js'),
                'deribit': require1('./js/deribit.js'),
                'digifinex': require1('./js/digifinex.js'),
                'eqonex': require1('./js/eqonex.js'),
                'exmo': require1('./js/exmo.js'),
                'flowbtc': require1('./js/flowbtc.js'),
                'fmfwio': require1('./js/fmfwio.js'),
                'ftx': require1('./js/ftx.js'),
                'ftxus': require1('./js/ftxus.js'),
                'gateio': require1('./js/gateio.js'),
                'gemini': require1('./js/gemini.js'),
                'hitbtc': require1('./js/hitbtc.js'),
                'hitbtc3': require1('./js/hitbtc3.js'),
                'hollaex': require1('./js/hollaex.js'),
                'huobi': require1('./js/huobi.js'),
                'huobijp': require1('./js/huobijp.js'),
                'huobipro': require1('./js/huobipro.js'),
                'idex': require1('./js/idex.js'),
                'independentreserve': require1('./js/independentreserve.js'),
                'indodax': require1('./js/indodax.js'),
                'itbit': require1('./js/itbit.js'),
                'kraken': require1('./js/kraken.js'),
                'kucoin': require1('./js/kucoin.js'),
                'kucoinfutures': require1('./js/kucoinfutures.js'),
                'kuna': require1('./js/kuna.js'),
                'latoken': require1('./js/latoken.js'),
                'lbank': require1('./js/lbank.js'),
                'lbank2': require1('./js/lbank2.js'),
                'liquid': require1('./js/liquid.js'),
                'luno': require1('./js/luno.js'),
                'lykke': require1('./js/lykke.js'),
                'mercado': require1('./js/mercado.js'),
                'mexc': require1('./js/mexc.js'),
                'ndax': require1('./js/ndax.js'),
                'novadax': require1('./js/novadax.js'),
                'oceanex': require1('./js/oceanex.js'),
                'okcoin': require1('./js/okcoin.js'),
                'okex': require1('./js/okex.js'),
                'okex5': require1('./js/okex5.js'),
                'okx': require1('./js/okx.js'),
                'paymium': require1('./js/paymium.js'),
                'phemex': require1('./js/phemex.js'),
                'poloniex': require1('./js/poloniex.js'),
                'probit': require1('./js/probit.js'),
                'qtrade': require1('./js/qtrade.js'),
                'ripio': require1('./js/ripio.js'),
                'stex': require1('./js/stex.js'),
                'therock': require1('./js/therock.js'),
                'tidebit': require1('./js/tidebit.js'),
                'tidex': require1('./js/tidex.js'),
                'timex': require1('./js/timex.js'),
                'upbit': require1('./js/upbit.js'),
                'vcc': require1('./js/vcc.js'),
                'wavesexchange': require1('./js/wavesexchange.js'),
                'wazirx': require1('./js/wazirx.js'),
                'whitebit': require1('./js/whitebit.js'),
                'woo': require1('./js/woo.js'),
                'xena': require1('./js/xena.js'),
                'yobit': require1('./js/yobit.js'),
                'zaif': require1('./js/zaif.js'),
                'zb': require1('./js/zb.js'),
                'zipmex': require1('./js/zipmex.js'),
                'zonda': require1('./js/zonda.js')
            };
            //-----------------------------------------------------------------------------
            module.exports = Object.assign({
                version: version,
                Exchange: Exchange,
                Precise: Precise,
                'exchanges': Object.keys(exchanges)
            }, exchanges, functions, errors);
        //-----------------------------------------------------------------------------
        },
        {
            "./js/aax.js": 3,
            "./js/ascendex.js": 4,
            "./js/base/Exchange": 5,
            "./js/base/Precise": 6,
            "./js/base/errors": 8,
            "./js/base/functions": 9,
            "./js/bequant.js": 20,
            "./js/bibox.js": 21,
            "./js/bigone.js": 22,
            "./js/binance.js": 23,
            "./js/binancecoinm.js": 24,
            "./js/binanceus.js": 25,
            "./js/binanceusdm.js": 26,
            "./js/bit2c.js": 27,
            "./js/bitbank.js": 28,
            "./js/bitbay.js": 29,
            "./js/bitbns.js": 30,
            "./js/bitcoincom.js": 31,
            "./js/bitfinex.js": 32,
            "./js/bitfinex2.js": 33,
            "./js/bitflyer.js": 34,
            "./js/bitforex.js": 35,
            "./js/bitget.js": 36,
            "./js/bithumb.js": 37,
            "./js/bitmart.js": 38,
            "./js/bitmex.js": 39,
            "./js/bitopro.js": 40,
            "./js/bitpanda.js": 41,
            "./js/bitrue.js": 42,
            "./js/bitso.js": 43,
            "./js/bitstamp.js": 44,
            "./js/bitstamp1.js": 45,
            "./js/bittrex.js": 46,
            "./js/bitvavo.js": 47,
            "./js/bkex.js": 48,
            "./js/bl3p.js": 49,
            "./js/blockchaincom.js": 50,
            "./js/btcalpha.js": 51,
            "./js/btcbox.js": 52,
            "./js/btcmarkets.js": 53,
            "./js/btctradeua.js": 54,
            "./js/btcturk.js": 55,
            "./js/buda.js": 56,
            "./js/bw.js": 57,
            "./js/bybit.js": 58,
            "./js/bytetrade.js": 59,
            "./js/cdax.js": 60,
            "./js/cex.js": 61,
            "./js/coinbase.js": 62,
            "./js/coinbaseprime.js": 63,
            "./js/coinbasepro.js": 64,
            "./js/coincheck.js": 65,
            "./js/coinex.js": 66,
            "./js/coinfalcon.js": 67,
            "./js/coinmate.js": 68,
            "./js/coinone.js": 69,
            "./js/coinspot.js": 70,
            "./js/crex24.js": 71,
            "./js/cryptocom.js": 72,
            "./js/currencycom.js": 73,
            "./js/delta.js": 74,
            "./js/deribit.js": 75,
            "./js/digifinex.js": 76,
            "./js/eqonex.js": 77,
            "./js/exmo.js": 78,
            "./js/flowbtc.js": 79,
            "./js/fmfwio.js": 80,
            "./js/ftx.js": 81,
            "./js/ftxus.js": 82,
            "./js/gateio.js": 83,
            "./js/gemini.js": 84,
            "./js/hitbtc.js": 85,
            "./js/hitbtc3.js": 86,
            "./js/hollaex.js": 87,
            "./js/huobi.js": 88,
            "./js/huobijp.js": 89,
            "./js/huobipro.js": 90,
            "./js/idex.js": 91,
            "./js/independentreserve.js": 92,
            "./js/indodax.js": 93,
            "./js/itbit.js": 94,
            "./js/kraken.js": 95,
            "./js/kucoin.js": 96,
            "./js/kucoinfutures.js": 97,
            "./js/kuna.js": 98,
            "./js/latoken.js": 99,
            "./js/lbank.js": 100,
            "./js/lbank2.js": 101,
            "./js/liquid.js": 102,
            "./js/luno.js": 103,
            "./js/lykke.js": 104,
            "./js/mercado.js": 105,
            "./js/mexc.js": 106,
            "./js/ndax.js": 107,
            "./js/novadax.js": 108,
            "./js/oceanex.js": 109,
            "./js/okcoin.js": 110,
            "./js/okex.js": 111,
            "./js/okex5.js": 112,
            "./js/okx.js": 113,
            "./js/paymium.js": 114,
            "./js/phemex.js": 115,
            "./js/poloniex.js": 116,
            "./js/probit.js": 117,
            "./js/qtrade.js": 118,
            "./js/ripio.js": 119,
            "./js/stex.js": 160,
            "./js/therock.js": 161,
            "./js/tidebit.js": 162,
            "./js/tidex.js": 163,
            "./js/timex.js": 164,
            "./js/upbit.js": 165,
            "./js/vcc.js": 166,
            "./js/wavesexchange.js": 167,
            "./js/wazirx.js": 168,
            "./js/whitebit.js": 169,
            "./js/woo.js": 170,
            "./js/xena.js": 171,
            "./js/yobit.js": 172,
            "./js/zaif.js": 173,
            "./js/zb.js": 174,
            "./js/zipmex.js": 175,
            "./js/zonda.js": 176
        }
    ],
    3: [
        function(require1, module, exports) {
            'use strict';
            // ----------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, CancelPending: CancelPending, RateLimitExceeded: RateLimitExceeded, InsufficientFunds: InsufficientFunds, BadRequest: BadRequest, BadSymbol: BadSymbol, PermissionDenied: PermissionDenied } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            // ----------------------------------------------------------------------------
            module.exports = class aax extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'aax',
                        'name': 'AAX',
                        'countries': [
                            'MT'
                        ],
                        // 6000 /  hour => 100 per minute => 1.66 requests per second => rateLimit = 600
                        // market endpoints ratelimits arent mentioned in docs so they are also set to "all other authenticated endpoints"
                        // 5000 / hour => weight = 1.2 ("all other authenticated endpoints")
                        // 600 / hour => weight = 10
                        // 200 / hour => weight = 30
                        'rateLimit': 600,
                        'version': 'v2',
                        'hostname': 'aaxpro.com',
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': true,
                            'future': false,
                            'option': false,
                            'addMargin': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'cancelOrders': undefined,
                            'createDepositAddress': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': true,
                            'fetchAccounts': undefined,
                            'fetchBalance': true,
                            'fetchBidsAsks': undefined,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchCanceledOrders': true,
                            'fetchClosedOrder': undefined,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDeposit': undefined,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': undefined,
                            'fetchDepositAddressesByNetwork': undefined,
                            'fetchDeposits': true,
                            'fetchFundingFee': undefined,
                            'fetchFundingFees': undefined,
                            'fetchFundingHistory': true,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': true,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchL3OrderBook': undefined,
                            'fetchLedger': undefined,
                            'fetchLedgerEntry': undefined,
                            'fetchLeverage': undefined,
                            'fetchLeverageTiers': false,
                            'fetchMarketLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyBuys': undefined,
                            'fetchMySells': undefined,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': undefined,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': undefined,
                            'fetchOrders': true,
                            'fetchOrderTrades': undefined,
                            'fetchPosition': true,
                            'fetchPositions': true,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchStatus': true,
                            'fetchTicker': 'emulated',
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTradingLimits': undefined,
                            'fetchTransactions': undefined,
                            'fetchTransfer': false,
                            'fetchTransfers': true,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': true,
                            'fetchWithdrawalWhitelist': undefined,
                            'reduceMargin': undefined,
                            'setLeverage': true,
                            'setMarginMode': false,
                            'setPositionMode': undefined,
                            'signIn': undefined,
                            'transfer': true,
                            'withdraw': false
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '2h': '2h',
                            '4h': '4h',
                            '12h': '12h',
                            '1d': '1d',
                            '3d': '3d',
                            '1w': '1w'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/104140087-a27f2580-53c0-11eb-87c1-5d9e81208fe9.jpg',
                            'test': {
                                'v1': 'https://api.testnet.{hostname}/marketdata/v1',
                                'public': 'https://api.testnet.{hostname}',
                                'private': 'https://api.testnet.{hostname}'
                            },
                            'api': {
                                'v1': 'https://api.{hostname}/marketdata/v1',
                                'public': 'https://api.{hostname}',
                                'private': 'https://api.{hostname}'
                            },
                            'www': 'https://www.aaxpro.com',
                            'doc': 'https://www.aaxpro.com/apidoc/index.html',
                            'fees': 'https://www.aaxpro.com/en-US/fees/',
                            'referral': 'https://www.aaxpro.com/invite/sign-up?inviteCode=JXGm5Fy7R2MB'
                        },
                        'api': {
                            'v1': {
                                'get': [
                                    'getHistMarketData'
                                ]
                            },
                            'public': {
                                // these endpoints are not documented
                                // 'get': [
                                //     'order_book', // Get the order book of specified market
                                //     'order_book/{market}',
                                //     'trades', // Get recent trades on market, each trade is included only once Trades are sorted in reverse creation order.
                                //     'trades/{market}',
                                //     'tickers', // Get ticker of all markets
                                //     'tickers/{market}', // Get ticker of specific market
                                // ],
                                'get': {
                                    'currencies': 1.2,
                                    'announcement/maintenance': 1.2,
                                    'time': 1.2,
                                    'instruments': 1.2,
                                    'market/orderbook': 1.2,
                                    'futures/position/openInterest': 1.2,
                                    'market/tickers': 1.2,
                                    'market/candles': 1.2,
                                    'market/history/candles': 1.2,
                                    'market/trades': 1.2,
                                    'market/markPrice': 1.2,
                                    'futures/funding/predictedFunding/{symbol}': 1.2,
                                    'futures/funding/prevFundingRate/{symbol}': 1.2,
                                    'futures/funding/fundingRate': 1.2,
                                    'market/candles/index': 1.2,
                                    'market/index/candles': 1.2
                                }
                            },
                            'private': {
                                'get': {
                                    'user/info': 1.2,
                                    'account/balances': 1.2,
                                    'account/deposit/address': 1.2,
                                    'account/deposits': 1.2,
                                    'account/transfer': 1.2,
                                    'account/withdraws': 1.2,
                                    'spot/trades': 1.2,
                                    'spot/openOrders': 1.2,
                                    'spot/orders': 1.2,
                                    'futures/position': 1.2,
                                    'futures/position/closed': 1.2,
                                    'futures/trades': 1.2,
                                    'futures/openOrders': 1.2,
                                    'futures/orders': 1.2,
                                    'futures/funding/fundingFee': 1.2,
                                    'futures/funding/predictedFundingFee/{symbol}': 1.2
                                },
                                'post': {
                                    'account/transfer': 1.2,
                                    'spot/orders': 1.2,
                                    'spot/orders/cancelAllOnTimeout': 10,
                                    'futures/orders': 1.2,
                                    'futures/orders/cancelAllOnTimeout': 10,
                                    'futures/position/sltp': 1.2,
                                    'futures/position/close': 1.2,
                                    'futures/position/leverage': 30,
                                    'futures/position/margin': 1.2
                                },
                                'put': {
                                    'spot/orders': 1.2,
                                    'futures/orders': 1.2
                                },
                                'delete': {
                                    'spot/orders/cancel/{orderID}': 1,
                                    'spot/orders/cancel/all': 10,
                                    'futures/orders/cancel/{orderID}': 1,
                                    'futures/orders/cancel/all': 10
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.0006'),
                                'taker': this.parseNumber('0.001')
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': true,
                                'withdraw': {}
                            }
                        },
                        'commonCurrencies': {
                            'XBT': 'XBT'
                        },
                        'exceptions': {
                            'exact': {
                                '2002': InsufficientFunds,
                                '2003': OrderNotFound,
                                '10003': BadRequest,
                                '10006': AuthenticationError,
                                '10007': AuthenticationError,
                                '11007': AuthenticationError,
                                '20001': InsufficientFunds,
                                '20009': InvalidOrder,
                                '30000': OrderNotFound,
                                '30001': InvalidOrder,
                                '30004': InvalidOrder,
                                '30005': InvalidOrder,
                                '30006': InvalidOrder,
                                '30007': InvalidOrder,
                                '30008': InvalidOrder,
                                '30009': InvalidOrder,
                                '30010': InvalidOrder,
                                '30011': CancelPending,
                                '30012': BadRequest,
                                '30013': BadSymbol,
                                '30014': OrderNotFound,
                                '30015': InvalidOrder,
                                '30016': ExchangeError1,
                                '30017': InvalidOrder,
                                '30018': InvalidOrder,
                                '30019': InvalidOrder,
                                '30020': InvalidOrder,
                                '30021': InvalidOrder,
                                '30022': InvalidOrder,
                                '30023': InvalidOrder,
                                '30024': InvalidOrder,
                                '30025': InvalidOrder,
                                '30026': InvalidOrder,
                                '30027': InvalidOrder,
                                '30028': BadSymbol,
                                '30029': InvalidOrder,
                                '30030': InvalidOrder,
                                '30031': InvalidOrder,
                                '30032': InvalidOrder,
                                '30033': InvalidOrder,
                                '30034': RateLimitExceeded,
                                '30035': RateLimitExceeded,
                                '30036': ExchangeNotAvailable,
                                '30037': InvalidOrder,
                                '30038': ExchangeError1,
                                '30039': InsufficientFunds,
                                '30040': InvalidOrder,
                                '30041': InvalidOrder,
                                '30042': InvalidOrder,
                                '30043': InvalidOrder,
                                '30044': BadRequest,
                                '30045': InvalidOrder,
                                '30046': InvalidOrder,
                                '30047': InvalidOrder,
                                '30048': InvalidOrder,
                                '30049': InvalidOrder,
                                '30050': InvalidOrder,
                                '40004': BadRequest,
                                '40009': RateLimitExceeded,
                                '40102': AuthenticationError,
                                '40103': AuthenticationError,
                                '40303': PermissionDenied,
                                '41001': BadRequest,
                                '41002': BadRequest,
                                '42001': ExchangeNotAvailable,
                                '50001': ExchangeError1,
                                '50002': ExchangeError1
                            },
                            'broad': {}
                        },
                        'precisionMode': TICK_SIZE,
                        'options': {
                            'defaultType': 'spot',
                            'accountsByType': {
                                'spot': 'SPTP',
                                'future': 'FUTP',
                                'otc': 'F2CP',
                                'saving': 'VLTP'
                            },
                            'networks': {
                                'ETH': 'ERC20',
                                'TRX': 'TRC20',
                                'SOL': 'SPL'
                            },
                            'transfer': {
                                'fillResponseFromRequest': true
                            }
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTime(params);
                    //
                    //    {
                    //        "code": 1,
                    //        "data": 1573542445411,  // unit: millisecond
                    //        "message": "success",
                    //        "ts": 1573542445411
                    //    }
                    //
                    return this.safeInteger(response, 'data');
                }
                async fetchStatus(params = {}) {
                    const response = await this.publicGetAnnouncementMaintenance(params);
                    //
                    // note, when there is no maintenance, then data is `null`
                    //
                    //     {
                    //         "code": 1,
                    //         "data": {
                    //             "startTime":"2020-06-25T02:15:00.000Z",
                    //             "endTime":"2020-06-25T02:45:00.000Z"，
                    //             "description":"Spot Trading :UTC Jun 25, 2020 02:15 to 02:45 (HKT Jun 25 10:15 to 10:45),Futures Trading: UTC Jun 25, 2020 02:15 to 02:45 (HKT Jun 25 10:15 to 10:45).We apologize for any inconvenience caused. Thank you for your patience and understanding.Should you have any enquiries, please do not hesitate our live chat support or via email at cs@aax.com.",
                    //             "haltReason":1,
                    //             "systemStatus":{
                    //                 "spotTrading":"readOnly",
                    //                 "futuresTreading":"closeOnly",
                    //                 "walletOperating":"enable",
                    //                 "otcTrading":"disable"
                    //             },
                    //         },
                    //         "message":"success",
                    //         "ts":1593043237000
                    //     }
                    //
                    const timestamp = this.milliseconds();
                    const updated = this.safeInteger(response, 'ts', timestamp);
                    const data = this.safeValue(response, 'data', {});
                    let status = undefined;
                    let eta = undefined;
                    if (data) {
                        const startTime = this.parse8601(this.safeString(data, 'startTime'));
                        const endTime = this.parse8601(this.safeString(data, 'endTime'));
                        if (endTime !== undefined) {
                            const startTimeIsOk = startTime === undefined ? true : updated < startTime;
                            const isOk = updated > endTime || startTimeIsOk;
                            eta = endTime;
                            status = isOk ? 'ok' : 'maintenance';
                        } else status = data;
                    } else {
                        eta = undefined;
                        status = 'ok';
                    }
                    return {
                        'status': status,
                        'updated': updated,
                        'eta': eta,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetInstruments(params);
                    //
                    //     {
                    //         "code":1,
                    //         "message":"success",
                    //         "ts":1610159448962,
                    //         "data":[
                    //             {
                    //                 "tickSize":"0.01",
                    //                 "lotSize":"1",
                    //                 "base":"BTC",
                    //                 "quote":"USDT",
                    //                 "minQuantity":"1.0000000000",
                    //                 "maxQuantity":"30000",
                    //                 "minPrice":"0.0100000000",
                    //                 "maxPrice":"999999.0000000000",
                    //                 "status":"readOnly",
                    //                 "symbol":"BTCUSDTFP",
                    //                 "code":"FP",
                    //                 "takerFee":"0.00040",
                    //                 "makerFee":"0.00020",
                    //                 "multiplier":"0.001000000000",
                    //                 "mmRate":"0.00500",
                    //                 "imRate":"0.01000",
                    //                 "type":"futures",
                    //                 "settleType":"Vanilla",
                    //                 "settleCurrency":"USDT"
                    //             },
                    //             {
                    //                 "tickSize":"0.5",
                    //                 "lotSize":"10",
                    //                 "base":"BTC",
                    //                 "quote":"USD",
                    //                 "minQuantity":"10.0000000000",
                    //                 "maxQuantity":"300000",
                    //                 "minPrice":"0.5000000000",
                    //                 "maxPrice":"999999.0000000000",
                    //                 "status":"readOnly",
                    //                 "symbol":"BTCUSDFP",
                    //                 "code":"FP",
                    //                 "takerFee":"0.00040",
                    //                 "makerFee":"0.00020",
                    //                 "multiplier":"1.000000000000",
                    //                 "mmRate":"0.00500",
                    //                 "imRate":"0.01000",
                    //                 "type":"futures",
                    //                 "settleType":"Inverse",
                    //                 "settleCurrency":"BTC"
                    //             },
                    //             {
                    //                 "tickSize":"0.0001",
                    //                 "lotSize":"0.01",
                    //                 "base":"AAB",
                    //                 "quote":"USDT",
                    //                 "minQuantity":"5.0000000000",
                    //                 "maxQuantity":"50000.0000000000",
                    //                 "minPrice":"0.0001000000",
                    //                 "maxPrice":"999999.0000000000",
                    //                 "status":"readOnly",
                    //                 "symbol":"AABUSDT",
                    //                 "code":null,
                    //                 "takerFee":"0.00100",
                    //                 "makerFee":"0.00100",
                    //                 "multiplier":"1.000000000000",
                    //                 "mmRate":"0.02500",
                    //                 "imRate":"0.05000",
                    //                 "type":"spot",
                    //                 "settleType":null,
                    //                 "settleCurrency":null
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const id = this.safeString(market, 'symbol');
                        const baseId = this.safeString(market, 'base');
                        const quoteId = this.safeString(market, 'quote');
                        const settleId = this.safeString(market, 'settleCurrency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const settle = this.safeCurrencyCode(settleId);
                        const status = this.safeString(market, 'status');
                        const marketType = this.safeString(market, 'type');
                        let inverse = undefined;
                        let linear = undefined;
                        let quanto = undefined;
                        const spot = marketType === 'spot';
                        const swap = marketType === 'futures';
                        const settleType = this.safeStringLower(market, 'settleType');
                        if (settleType !== undefined) {
                            inverse = settleType === 'inverse';
                            linear = settleType === 'vanilla';
                            quanto = settleType === 'quanto';
                        }
                        let symbol = base + '/' + quote;
                        let type = 'spot';
                        let contractSize = undefined;
                        if (swap) {
                            symbol = symbol + ':' + settle;
                            type = 'swap';
                            contractSize = this.safeNumber(market, 'multiplier');
                        }
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': type,
                            'spot': spot,
                            'margin': false,
                            'swap': swap,
                            'future': false,
                            'option': false,
                            'active': status === 'enable',
                            'contract': swap,
                            'linear': linear,
                            'inverse': inverse,
                            'taker': this.safeNumber(market, 'takerFee'),
                            'maker': this.safeNumber(market, 'makerFee'),
                            'contractSize': contractSize,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'quanto': quanto,
                            'precision': {
                                'amount': this.safeNumber(market, 'lotSize'),
                                'price': this.safeNumber(market, 'tickSize')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeString(market, 'minQuantity'),
                                    'max': this.safeString(market, 'maxQuantity')
                                },
                                'price': {
                                    'min': this.safeString(market, 'minPrice'),
                                    'max': this.safeString(market, 'maxPrice')
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     {
                    //         "code":1,
                    //         "data":[
                    //             {
                    //                 "chain":"BTC",
                    //                 "displayName":"Bitcoin",
                    //                 "withdrawFee":"0.0004",
                    //                 "withdrawMin":"0.001",
                    //                 "otcFee":"0",
                    //                 "enableOTC":true,
                    //                 "visible":true,
                    //                 "enableTransfer":true,
                    //                 "transferMin":"0.00001",
                    //                 "depositMin":"0.0005",
                    //                 "enableWithdraw":true,
                    //                 "enableDeposit":true,
                    //                 "addrWithMemo":false,
                    //                 "withdrawPrecision":"0.00000001",
                    //                 "currency":"BTC",
                    //                 "network":"BTC", // ETH, ERC20, TRX, TRC20, OMNI, LTC, XRP, XLM, ...
                    //                 "minConfirm":"2"
                    //             },
                    //         ],
                    //         "message":"success",
                    //         "ts":1624330530697
                    //     }
                    //
                    const result = {};
                    const data = this.safeValue(response, 'data', []);
                    for(let i = 0; i < data.length; i++){
                        const currency = data[i];
                        const id = this.safeString(currency, 'chain');
                        const name = this.safeString(currency, 'displayName');
                        const code = this.safeCurrencyCode(id);
                        const precision = this.safeNumber(currency, 'withdrawPrecision');
                        const enableWithdraw = this.safeValue(currency, 'enableWithdraw');
                        const enableDeposit = this.safeValue(currency, 'enableDeposit');
                        const fee = this.safeNumber(currency, 'withdrawFee');
                        const visible = this.safeValue(currency, 'visible');
                        const active = enableWithdraw && enableDeposit && visible;
                        const deposit = enableDeposit && visible;
                        const withdraw = enableWithdraw && visible;
                        const network = this.safeString(currency, 'network');
                        result[code] = {
                            'id': id,
                            'name': name,
                            'code': code,
                            'precision': precision,
                            'info': currency,
                            'active': active,
                            'deposit': deposit,
                            'withdraw': withdraw,
                            'fee': fee,
                            'network': network,
                            'limits': {
                                'deposit': {
                                    'min': this.safeNumber(currency, 'depositMin'),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'withdrawMin'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "t":1610162685342, // timestamp
                    //         "a":"0.00000000", // trading volume in USD in the last 24 hours, futures only
                    //         "c":"435.20000000", // close
                    //         "d":"4.22953489", // change
                    //         "h":"455.04000000", // high
                    //         "l":"412.78000000", // low
                    //         "o":"417.54000000", // open
                    //         "s":"BCHUSDTFP", // market id
                    //         "v":"2031068.00000000", // trading volume in quote currency of last 24 hours
                    //     }
                    //
                    const timestamp = this.safeInteger(ticker, 't');
                    const marketId = this.safeString(ticker, 's');
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeString(ticker, 'c');
                    const open = this.safeString(ticker, 'o');
                    const quoteVolume = this.safeString(ticker, 'v');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': undefined,
                        'high': this.safeString(ticker, 'h'),
                        'low': this.safeString(ticker, 'l'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': undefined,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetMarketTickers(params);
                    //
                    //     {
                    //         "e":"tickers",
                    //         "t":1610162685342,
                    //         "tickers":[
                    //             {
                    //                 "a":"0.00000000",
                    //                 "c":"435.20000000",
                    //                 "d":"4.22953489",
                    //                 "h":"455.04000000",
                    //                 "l":"412.78000000",
                    //                 "o":"417.54000000",
                    //                 "s":"BCHUSDTFP",
                    //                 "v":"2031068.00000000",
                    //             },
                    //         ],
                    //     }
                    //
                    const tickers = this.safeValue(response, 'tickers', []);
                    const result = [];
                    const timestamp = this.safeInteger(response, 't');
                    for(let i = 0; i < tickers.length; i++){
                        const ticker = this.parseTicker(this.extend(tickers[i], {
                            't': timestamp
                        }));
                        result.push(ticker);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (limit === undefined) limit = 20;
                    else {
                        if (limit !== 20 && limit !== 50) throw new BadRequest(this.id + ' fetchOrderBook() limit argument must be undefined, 20 or 50');
                    }
                    const request = {
                        'symbol': market['id'],
                        'level': limit
                    };
                    //
                    const response = await this.publicGetMarketOrderbook(this.extend(request, params));
                    //
                    //     {
                    //         "asks":[
                    //             ["10823.00000000","0.004000"],
                    //             ["10823.10000000","0.100000"],
                    //             ["10823.20000000","0.010000"]
                    //         ],
                    //         "bids":[
                    //             ["10821.20000000","0.002000"],
                    //             ["10821.10000000","0.005000"],
                    //             ["10820.40000000","0.013000"]
                    //         ],
                    //         "e":"BTCUSDT@book_50",
                    //         "t":1561543614756
                    //     }
                    //
                    const timestamp = this.safeInteger(response, 't'); // need unix type
                    return this.parseOrderBook(response, symbol, timestamp);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     {
                    //         "i":"T1qzQeZG9g",
                    //         "p":"-61348.81000000",
                    //         "q":"0.045400",
                    //         "s":"sell",
                    //         "t":1635731102731
                    //     }
                    //
                    // private fetchMyTrades
                    //
                    //     {
                    //         "avgPrice":"1199.8",
                    //         "base":"ETH",
                    //         "clOrdID":null,
                    //         "commission":"0.00002",
                    //         "createTime":"2021-01-11T02:47:51.512Z",
                    //         "cumQty":"0.02",
                    //         "filledOrderID":"1eUD4F5rwK",
                    //         "filledPrice":"1199.8",
                    //         "filledQty":"0.02",
                    //         "leavesQty":"0",
                    //         "oCreateTime":"2021-01-11T02:47:51.377Z",
                    //         "orderID":"1eUD4EHfdU",
                    //         "orderQty":"0.02",
                    //         "orderStatus":3,
                    //         "orderType":1,
                    //         "price":"1198.25",
                    //         "quote":"USDT",
                    //         "rejectCode":null,
                    //         "rejectReason":null,
                    //         "side":1,
                    //         "stopPrice":"0",
                    //         "symbol":"ETHUSDT",
                    //         "taker":true,
                    //         "tradeID":"E04WTIgfmULU",
                    //         "transactTime":"2021-01-11T02:47:51.389Z",
                    //         "updateTime":null,
                    //         "userID":"1362494"
                    //     }
                    //
                    let timestamp = this.safeInteger(trade, 't');
                    if (timestamp === undefined) timestamp = this.parse8601(this.safeString(trade, 'createTime'));
                    let id = this.safeString2(trade, 'tid', 'tradeID');
                    id = this.safeString(trade, 'i', id);
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market);
                    let priceString = this.safeString2(trade, 'p', 'filledPrice');
                    const amountString = this.safeString2(trade, 'q', 'filledQty');
                    const orderId = this.safeString(trade, 'orderID');
                    const isTaker = this.safeValue(trade, 'taker');
                    let takerOrMaker = undefined;
                    if (isTaker !== undefined) takerOrMaker = isTaker ? 'taker' : 'maker';
                    let side = this.safeString(trade, 'side');
                    if (side === '1') side = 'buy';
                    else if (side === '2') side = 'sell';
                    if (side === undefined) side = priceString[0] === '-' ? 'sell' : 'buy';
                    priceString = Precise.stringAbs(priceString);
                    const orderType = this.parseOrderType(this.safeString(trade, 'orderType'));
                    let fee = undefined;
                    const feeCost = this.safeString(trade, 'commission');
                    if (feeCost !== undefined) {
                        let feeCurrency = undefined;
                        if (side === 'buy') feeCurrency = market['base'];
                        else if (side === 'sell') feeCurrency = market['quote'];
                        fee = {
                            'currency': feeCurrency,
                            'cost': feeCost
                        };
                    }
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': orderType,
                        'side': side,
                        'order': orderId,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTransfers(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) request['startTime'] = since;
                    const response = await this.privateGetAccountTransfer(this.extend(request, params));
                    //
                    //      {
                    //          code: '1',
                    //          data: [{
                    //                  quantity: '0.000010000000',
                    //                  transferID: '480975741034369024',
                    //                  transferTime: '2022-03-24T13:53:07.042Z',
                    //                  fromPurse: 'VLTP',
                    //                  toPurse: 'SPTP',
                    //                  currency: 'ETH'
                    //              },
                    //          ],
                    //          message: 'success',
                    //          ts: '1648338516932'
                    //      }
                    //
                    const transfers = this.safeValue(response, 'data', []);
                    return this.parseTransfers(transfers, currency, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    limit = limit === undefined ? 2000 : limit;
                    limit = Math.min(limit, 2000);
                    const request = {
                        'symbol': market['id'],
                        'limit': limit
                    };
                    const response = await this.publicGetMarketTrades(request);
                    //
                    //     {
                    //         "e":"BTCUSDT@trades",
                    //         "trades":[
                    //             {"i":"T1qzQeZG9g","p":"-61348.81000000","q":"0.045400","s":"sell","t":1635731102731},
                    //             {"i":"T1qzQeU6UK","p":"61343.10000000","q":"0.179300","s":"buy","t":1635731102133},
                    //             {"i":"T1qzQe5BQm","p":"-61346.02000000","q":"0.021100","s":"sell","t":1635731099231},
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         0.042398, // 0 open
                    //         0.042684, // 1 high
                    //         0.042366, // 2 low
                    //         0.042386, // 3 close
                    //         0.93734243, // 4 volume
                    //         1611514800, // 5 timestamp
                    //     ]
                    //
                    return [
                        this.safeTimestamp(ohlcv, 5),
                        this.safeNumber(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        // 'limit': limit, // if set counts from now into the past
                        'symbol': market['id'],
                        'timeFrame': this.timeframes[timeframe]
                    };
                    limit = limit === undefined ? 500 : limit;
                    const duration = this.parseTimeframe(timeframe);
                    if (since === undefined) {
                        const end = this.seconds();
                        request['start'] = end - duration * limit;
                        request['end'] = end;
                    } else {
                        const start = parseInt(since / 1000);
                        request['start'] = start;
                        request['end'] = this.sum(start, duration * limit);
                    }
                    const response = await this.publicGetMarketHistoryCandles(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             [0.042398,0.042684,0.042366,0.042386,0.93734243,1611514800],
                    //             [0.042386,0.042602,0.042234,0.042373,1.01925239,1611518400],
                    //             [0.042373,0.042558,0.042362,0.042389,0.93801705,1611522000],
                    //         ],
                    //         "success":true,
                    //         "t":1611875157
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const defaultType = this.safeString2(this.options, 'fetchBalance', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    const types = this.safeValue(this.options, 'accountsByType', {});
                    const purseType = this.safeString(types, type, type);
                    const request = {
                        'purseType': purseType
                    };
                    params = this.omit(params, 'type');
                    const response = await this.privateGetAccountBalances(this.extend(request, params));
                    //
                    //     {
                    //         "code":1,
                    //         "data":[
                    //             {
                    //                 "purseType":"FUTP",
                    //                 "currency":"BTC",
                    //                 "available":"0.41000000",
                    //                 "unavailable":"0.00000000"
                    //             },
                    //             {
                    //                 "purseType":"FUTP",
                    //                 "currency":"USDT",
                    //                 "available":"0.21000000",
                    //                 "unvaliable":"0.00000000"
                    //             }
                    //         ]
                    //         "message":"success",
                    //         "ts":1573530401020
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const timestamp = this.safeInteger(response, 'ts');
                    const result = {
                        'info': response,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    };
                    for(let i = 0; i < data.length; i++){
                        const balance = data[i];
                        const balanceType = this.safeString(balance, 'purseType');
                        if (balanceType === purseType) {
                            const currencyId = this.safeString(balance, 'currency');
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            account['free'] = this.safeString(balance, 'available');
                            account['used'] = this.safeString(balance, 'unavailable');
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    let orderType = type.toUpperCase();
                    const orderSide = side.toUpperCase();
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        // 'orderType': orderType, // MARKET, LIMIT, STOP, STOP-LIMIT
                        'symbol': market['id'],
                        'orderQty': this.amountToPrecision(symbol, amount),
                        'side': orderSide
                    };
                    const clientOrderId = this.safeString2(params, 'clOrdID', 'clientOrderId');
                    if (clientOrderId !== undefined) request['clOrdID'] = clientOrderId;
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    if (postOnly !== undefined) request['execInst'] = 'Post-Only';
                    params = this.omit(params, [
                        'clOrdID',
                        'clientOrderId',
                        'postOnly'
                    ]);
                    const stopPrice = this.safeNumber(params, 'stopPrice');
                    if (stopPrice === undefined) {
                        if (orderType === 'STOP-LIMIT' || orderType === 'STOP') throw new ArgumentsRequired1(this.id + ' createOrder() requires a stopPrice parameter for ' + orderType + ' orders');
                    } else {
                        if (orderType === 'LIMIT') orderType = 'STOP-LIMIT';
                        else if (orderType === 'MARKET') orderType = 'STOP';
                        request['stopPrice'] = this.priceToPrecision(symbol, stopPrice);
                        params = this.omit(params, 'stopPrice');
                    }
                    if (orderType === 'LIMIT' || orderType === 'STOP-LIMIT') request['price'] = this.priceToPrecision(symbol, price);
                    request['orderType'] = orderType;
                    let method = undefined;
                    if (market['spot']) method = 'privatePostSpotOrders';
                    else if (market['contract']) method = 'privatePostFuturesOrders';
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "symbol":"ETHUSDT",
                    //             "orderType":2,
                    //             "avgPrice":"0",
                    //             "execInst":null,
                    //             "orderStatus":0,
                    //             "userID":"1362494",
                    //             "quote":"USDT",
                    //             "rejectReason":null,
                    //             "rejectCode":null,
                    //             "price":"1500",
                    //             "orderQty":"1",
                    //             "commission":"0",
                    //             "id":"268323430253735936",
                    //             "timeInForce":1,
                    //             "isTriggered":false,
                    //             "side":2,
                    //             "orderID":"1eO51MDSpQ",
                    //             "leavesQty":"0",
                    //             "cumQty":"0",
                    //             "updateTime":null,
                    //             "lastQty":"0",
                    //             "clOrdID":null,
                    //             "stopPrice":null,
                    //             "createTime":null,
                    //             "transactTime":null,
                    //             "base":"ETH",
                    //             "lastPrice":"0"
                    //         },
                    //         "message":"success",
                    //         "ts":1610245290980
                    //     }
                    //
                    // futures
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "liqType":0,
                    //             "symbol":"ETHUSDTFP",
                    //             "orderType":2,
                    //             "leverage":"1",
                    //             "marketPrice":"1318.3150000000",
                    //             "code":"FP",
                    //             "avgPrice":"0",
                    //             "execInst":null,
                    //             "orderStatus":0,
                    //             "userID":"1362494",
                    //             "quote":"USDT",
                    //             "rejectReason":null,
                    //             "rejectCode":null,
                    //             "price":"500",
                    //             "orderQty":"1",
                    //             "commission":"0",
                    //             "id":"268346885133053953",
                    //             "timeInForce":1,
                    //             "isTriggered":false,
                    //             "side":1,
                    //             "orderID":"1eOuPUAAkq",
                    //             "leavesQty":"1",
                    //             "cumQty":"0",
                    //             "updateTime":null,
                    //             "lastQty":null,
                    //             "clOrdID":null,
                    //             "stopPrice":null,
                    //             "createTime":null,
                    //             "transactTime":null,
                    //             "settleType":"VANILLA",
                    //             "base":"ETH",
                    //             "lastPrice":"0"
                    //         },
                    //         "message":"success",
                    //         "ts":1610250883059
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'orderID': id
                    };
                    const stopPrice = this.safeNumber(params, 'stopPrice');
                    if (stopPrice !== undefined) {
                        request['stopPrice'] = this.priceToPrecision(symbol, stopPrice);
                        params = this.omit(params, 'stopPrice');
                    }
                    if (price !== undefined) request['price'] = this.priceToPrecision(symbol, price);
                    if (amount !== undefined) request['orderQty'] = this.amountToPrecision(symbol, amount);
                    let method = undefined;
                    if (market['spot']) method = 'privatePutSpotOrders';
                    else if (market['contract']) method = 'privatePutFuturesOrders';
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "symbol":"ETHUSDT",
                    //             "orderType":2,
                    //             "avgPrice":"0",
                    //             "execInst":null,
                    //             "orderStatus":0,
                    //             "userID":"1362494",
                    //             "quote":"USDT",
                    //             "rejectReason":null,
                    //             "rejectCode":null,
                    //             "price":"1500",
                    //             "orderQty":"1",
                    //             "commission":"0",
                    //             "id":"268323430253735936",
                    //             "timeInForce":1,
                    //             "isTriggered":false,
                    //             "side":2,
                    //             "orderID":"1eO51MDSpQ",
                    //             "leavesQty":"0",
                    //             "cumQty":"0",
                    //             "updateTime":null,
                    //             "lastQty":"0",
                    //             "clOrdID":null,
                    //             "stopPrice":null,
                    //             "createTime":null,
                    //             "transactTime":null,
                    //             "base":"ETH",
                    //             "lastPrice":"0"
                    //         },
                    //         "message":"success",
                    //         "ts":1610245290980
                    //     }
                    //
                    // futures
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "liqType":0,
                    //             "symbol":"ETHUSDTFP",
                    //             "orderType":2,
                    //             "leverage":"1",
                    //             "marketPrice":"1318.3150000000",
                    //             "code":"FP",
                    //             "avgPrice":"0",
                    //             "execInst":null,
                    //             "orderStatus":0,
                    //             "userID":"1362494",
                    //             "quote":"USDT",
                    //             "rejectReason":null,
                    //             "rejectCode":null,
                    //             "price":"500",
                    //             "orderQty":"1",
                    //             "commission":"0",
                    //             "id":"268346885133053953",
                    //             "timeInForce":1,
                    //             "isTriggered":false,
                    //             "side":1,
                    //             "orderID":"1eOuPUAAkq",
                    //             "leavesQty":"1",
                    //             "cumQty":"0",
                    //             "updateTime":null,
                    //             "lastQty":null,
                    //             "clOrdID":null,
                    //             "stopPrice":null,
                    //             "createTime":null,
                    //             "transactTime":null,
                    //             "settleType":"VANILLA",
                    //             "base":"ETH",
                    //             "lastPrice":"0"
                    //         },
                    //         "message":"success",
                    //         "ts":1610250883059
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderID': id
                    };
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('cancelOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateDeleteSpotOrdersCancelOrderID',
                        'swap': 'privateDeleteFuturesOrdersCancelOrderID',
                        'future': 'privateDeleteFuturesOrdersCancelOrderID'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    // spot
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "avgPrice":"0",
                    //             "base":"BTC",
                    //             "clOrdID":"aax",
                    //             "commission":"0",
                    //             "createTime":"2019-11-12T03:46:41Z",
                    //             "cumQty":"0",
                    //             "id":"114330021504606208",
                    //             "isTriggered":false,
                    //             "lastPrice":"0",
                    //             "lastQty":"0",
                    //             "leavesQty":"0",
                    //             "orderID":"wJ4L366KB",
                    //             "orderQty":"0.05",
                    //             "orderStatus":1,
                    //             "orderType":2,
                    //             "price":"8000",
                    //             "quote":"USDT",
                    //             "rejectCode":0,
                    //             "rejectReason":null,
                    //             "side":1,
                    //             "stopPrice":"0",
                    //             "symbol":"BTCUSDT",
                    //             "transactTime":null,
                    //             "updateTime":"2019-11-12T03:46:41Z",
                    //             "timeInForce":1,
                    //             "userID":"216214"
                    //         },
                    //         "message":"success",
                    //         "ts":1573530402029
                    //     }
                    //
                    // futures
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "avgPrice":"0",
                    //             "base":"BTC",
                    //             "clOrdID":"aax_futures",
                    //             "code":"FP",
                    //             "commission":"0",
                    //             "createTime":"2019-11-12T06:48:58Z",
                    //             "cumQty":"0",
                    //             "id":"114375893764395008",
                    //             "isTriggered":false,
                    //             "lastPrice":"0",
                    //             "lastQty":null,
                    //             "leavesQty":"300",
                    //             "leverage":"1",
                    //             "liqType":0,
                    //             "marketPrice":"8760.75",
                    //             "orderID":"wJTewQc81",
                    //             "orderQty":"300",
                    //             "orderStatus":1,
                    //             "orderType":2,
                    //             "price":"8000",
                    //             "quote":"USD",
                    //             "rejectCode":0,
                    //             "rejectReason":null,
                    //             "settleType":"INVERSE",
                    //             "side":1,
                    //             "stopPrice":"0",
                    //             "symbol":"BTCUSDFP",
                    //             "transactTime":"2019-11-12T06:48:58Z",
                    //             "updateTime":"2019-11-12T06:48:58Z",
                    //             "timeInForce":1,
                    //             "execInst": "",
                    //             "userID":"216214"
                    //         },
                    //         "message":"success",
                    //         "ts":1573541642970
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelAllOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    let method = undefined;
                    if (market['spot']) method = 'privateDeleteSpotOrdersCancelAll';
                    else if (market['contract']) method = 'privateDeleteFuturesOrdersCancelAll';
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "code":1,
                    //         "data":[
                    //             "vBC9rXsEE",
                    //             "vBCc46OI0"
                    //             ],
                    //         "message":"success",
                    //         "ts":1572597435470
                    //     }
                    //
                    return response;
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const defaultType = this.safeString2(this.options, 'fetchOrder', 'defaultType', 'spot');
                    params['type'] = this.safeString(params, 'type', defaultType);
                    const request = {};
                    const clientOrderId = this.safeString2(params, 'clOrdID', 'clientOrderId');
                    if (clientOrderId === undefined) request['orderID'] = id;
                    else {
                        request['clOrdID'] = clientOrderId;
                        params = this.omit(params, [
                            'clOrdID',
                            'clientOrderId'
                        ]);
                    }
                    const orders = await this.fetchOrders(symbol, undefined, undefined, this.extend(request, params));
                    const order = this.safeValue(orders, 0);
                    if (order === undefined) {
                        if (clientOrderId === undefined) throw new OrderNotFound(this.id + ' fetchOrder() could not find order id ' + id);
                        else throw new OrderNotFound(this.id + ' fetchOrder() could not find order clientOrderID ' + clientOrderId);
                    }
                    return order;
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOpenOrders', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateGetSpotOpenOrders',
                        'swap': 'privateGetFuturesOpenOrders',
                        'future': 'privateGetFuturesOpenOrders'
                    });
                    const clientOrderId = this.safeString2(params, 'clOrdID', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['clOrdID'] = clientOrderId;
                        params = this.omit(params, [
                            'clOrdID',
                            'clientOrderId'
                        ]);
                    }
                    if (limit !== undefined) request['pageSize'] = limit; // default 10
                    const response = await this[method](this.extend(request, query));
                    //
                    // spot
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "total":19,
                    //             "pageSize":10,
                    //             "list":[
                    //                 {
                    //                     "orderType":2,
                    //                     "symbol":"BTCUSDT",
                    //                     "avgPrice":"0",
                    //                     "orderStatus":0,
                    //                     "userID":"7225",
                    //                     "quote":"USDT",
                    //                     "rejectReason":null,
                    //                     "rejectCode":null,
                    //                     "price":"0",
                    //                     "orderQty":"0.002",
                    //                     "commission":"0",
                    //                     "id":"110419975166304256",
                    //                     "isTriggered":null,
                    //                     "side":1,
                    //                     "orderID":"vBGlDcLwk",
                    //                     "cumQty":"0",
                    //                     "leavesQty":"0",
                    //                     "updateTime":null,
                    //                     "clOrdID":"0001",
                    //                     "lastQty":"0",
                    //                     "stopPrice":"0",
                    //                     "createTime":"2019-11-01T08:49:33Z",
                    //                     "transactTime":null,
                    //                     "timeInForce":1,
                    //                     "base":"BTC",
                    //                     "lastPrice":"0"
                    //                 }
                    //             ],
                    //             "pageNum":1
                    //         },
                    //         "message":"success",
                    //         "ts":1572598173682
                    //     }
                    //
                    // futures
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "list":[
                    //                 {
                    //                     "avgPrice":"8768.99999999484997",
                    //                     "base":"BTC",
                    //                     "clOrdID":null,
                    //                     "code":"FP",
                    //                     "commission":"0.00000913",
                    //                     "createTime":"2019-11-12T07:05:52.000Z,
                    //                     "cumQty":"100",
                    //                     "id":"114380149603028993",
                    //                     "isTriggered":false,
                    //                     "lastPrice":"8769",
                    //                     "lastQty":"100",
                    //                     "leavesQty":"0",
                    //                     "leverage":"1",
                    //                     "liqType":1,
                    //                     "marketPrice":"8769.75",
                    //                     "orderID":"wJXURIFBT",
                    //                     "orderQty":"100",
                    //                     "orderStatus":3,
                    //                     "orderType":1,
                    //                     "price":"8769.75",
                    //                     "quote":"USD",
                    //                     "rejectCode":0,
                    //                     "rejectReason":null,
                    //                     "settleType":"INVERSE",
                    //                     "side":2,
                    //                     "stopPrice":"0",
                    //                     "symbol":"BTCUSDFP",
                    //                     "transactTime":"2019-11-12T07:05:52.000Z,
                    //                     "updateTime":"2019-11-12T07:05:52.000Z,
                    //                     "timeInForce":1,
                    //                     "execInst": "",
                    //                     "userID":"216214"
                    //                 },
                    //             ],
                    //             "pageNum":1,
                    //             "pageSize":10,
                    //             "total":21
                    //         },
                    //         "message":"success",
                    //         "ts":1573546960172
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const orders = this.safeValue(data, 'list', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'orderStatus': '2'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchCanceledOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'orderStatus': '3'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrders', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateGetSpotOrders',
                        'swap': 'privateGetFuturesOrders',
                        'future': 'privateGetFuturesOrders'
                    });
                    const clientOrderId = this.safeString2(params, 'clOrdID', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['clOrdID'] = clientOrderId;
                        params = this.omit(params, [
                            'clOrdID',
                            'clientOrderId'
                        ]);
                    }
                    if (limit !== undefined) request['pageSize'] = limit; // default 10
                    if (since !== undefined) request['startDate'] = this.yyyymmdd(since);
                    const response = await this[method](this.extend(request, query));
                    //
                    // spot
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "total":19,
                    //             "pageSize":10,
                    //             "list":[
                    //                 {
                    //                     "orderType":2,
                    //                     "symbol":"BTCUSDT",
                    //                     "avgPrice":"0",
                    //                     "orderStatus":0,
                    //                     "userID":"7225",
                    //                     "quote":"USDT",
                    //                     "rejectReason":null,
                    //                     "rejectCode":null,
                    //                     "price":"0",
                    //                     "orderQty":"0.002",
                    //                     "commission":"0",
                    //                     "id":"110419975166304256",
                    //                     "isTriggered":null,
                    //                     "side":1,
                    //                     "orderID":"vBGlDcLwk",
                    //                     "cumQty":"0",
                    //                     "leavesQty":"0",
                    //                     "updateTime":null,
                    //                     "clOrdID":"0001",
                    //                     "lastQty":"0",
                    //                     "stopPrice":"0",
                    //                     "createTime":"2019-11-01T08:49:33Z",
                    //                     "transactTime":null,
                    //                     "timeInForce":1,
                    //                     "base":"BTC",
                    //                     "lastPrice":"0"
                    //                 }
                    //             ],
                    //             "pageNum":1
                    //         },
                    //         "message":"success",
                    //         "ts":1572598173682
                    //     }
                    //
                    // futures
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "list":[
                    //                 {
                    //                     "avgPrice":"8768.99999999484997",
                    //                     "base":"BTC",
                    //                     "clOrdID":null,
                    //                     "code":"FP",
                    //                     "commission":"0.00000913",
                    //                     "createTime":"2019-11-12T07:05:52.000Z,
                    //                     "cumQty":"100",
                    //                     "id":"114380149603028993",
                    //                     "isTriggered":false,
                    //                     "lastPrice":"8769",
                    //                     "lastQty":"100",
                    //                     "leavesQty":"0",
                    //                     "leverage":"1",
                    //                     "liqType":1,
                    //                     "marketPrice":"8769.75",
                    //                     "orderID":"wJXURIFBT",
                    //                     "orderQty":"100",
                    //                     "orderStatus":3,
                    //                     "orderType":1,
                    //                     "price":"8769.75",
                    //                     "quote":"USD",
                    //                     "rejectCode":0,
                    //                     "rejectReason":null,
                    //                     "settleType":"INVERSE",
                    //                     "side":2,
                    //                     "stopPrice":"0",
                    //                     "symbol":"BTCUSDFP",
                    //                     "transactTime":"2019-11-12T07:05:52.000Z,
                    //                     "updateTime":"2019-11-12T07:05:52.000Z,
                    //                     "timeInForce":1,
                    //                     "execInst": "",
                    //                     "userID":"216214"
                    //                 },
                    //             ],
                    //             "pageNum":1,
                    //             "pageSize":10,
                    //             "total":21
                    //         },
                    //         "message":"success",
                    //         "ts":1573546960172
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const orders = this.safeValue(data, 'list', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '0': 'open',
                        '1': 'open',
                        '2': 'open',
                        '3': 'closed',
                        '4': 'canceled',
                        '5': 'canceled',
                        '6': 'rejected',
                        '10': 'expired',
                        '11': 'rejected'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrderType(status) {
                    const statuses = {
                        '1': 'market',
                        '2': 'limit',
                        '3': 'stop',
                        '4': 'stop-limit',
                        '7': 'stop-loss',
                        '8': 'take-profit'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTimeInForce(timeInForce) {
                    const timeInForces = {
                        '1': 'GTC',
                        '3': 'IOC',
                        '4': 'FOK'
                    };
                    return this.safeString(timeInForces, timeInForce, timeInForce);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "avgPrice":"8768.99999999484997",
                    //         "base":"BTC",
                    //         "clOrdID":null,
                    //         "code":"FP", // futures only
                    //         "commission":"0.00000913",
                    //         "createTime":"2019-11-12T07:05:52.000Z,
                    //         "cumQty":"100",
                    //         "id":"114380149603028993", // futures only
                    //         "isTriggered":false,
                    //         "lastPrice":"8769",
                    //         "lastQty":"100",
                    //         "leavesQty":"0",
                    //         "leverage":"1", // futures only
                    //         "liqType":1, // futures only
                    //         "marketPrice":"8769.75", // futures only
                    //         "orderID":"wJXURIFBT",
                    //         "orderQty":"100",
                    //         "orderStatus":3,
                    //         "orderType":1,
                    //         "price":"8769.75",
                    //         "quote":"USD",
                    //         "rejectCode":0,
                    //         "rejectReason":null,
                    //         "settleType":"INVERSE", // futures only
                    //         "side":2,
                    //         "stopPrice":"0",
                    //         "symbol":"BTCUSDFP",
                    //         "transactTime":"2019-11-12T07:05:52.000Z,
                    //         "updateTime":"2019-11-12T07:05:52.000Z,
                    //         "timeInForce":1,
                    //         "execInst": "",
                    //         "userID":"216214"
                    //     }
                    //
                    // sometimes the timestamp is returned in milliseconds
                    let timestamp = this.safeValue(order, 'createTime');
                    if (typeof timestamp === 'string') timestamp = this.parse8601(timestamp);
                    const status = this.parseOrderStatus(this.safeString(order, 'orderStatus'));
                    const type = this.parseOrderType(this.safeString(order, 'orderType'));
                    let side = this.safeString(order, 'side');
                    if (side === '1') side = 'buy';
                    else if (side === '2') side = 'sell';
                    const id = this.safeString(order, 'orderID');
                    const clientOrderId = this.safeString(order, 'clOrdID');
                    const marketId = this.safeString(order, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const price = this.safeString(order, 'price');
                    const stopPrice = this.safeNumber(order, 'stopPrice');
                    const timeInForce = this.parseTimeInForce(this.safeString(order, 'timeInForce'));
                    const execInst = this.safeString(order, 'execInst');
                    const postOnly = execInst === 'Post-Only';
                    const average = this.safeString(order, 'avgPrice');
                    const amount = this.safeString(order, 'orderQty');
                    const filled = this.safeString(order, 'cumQty');
                    let remaining = this.safeString(order, 'leavesQty');
                    if (Precise.stringEquals(filled, '0') && Precise.stringEquals(remaining, '0')) remaining = undefined;
                    let lastTradeTimestamp = this.safeValue(order, 'transactTime');
                    if (typeof lastTradeTimestamp === 'string') lastTradeTimestamp = this.parse8601(lastTradeTimestamp);
                    let fee = undefined;
                    const feeCost = this.safeNumber(order, 'commission');
                    if (feeCost !== undefined) {
                        let feeCurrency = undefined;
                        if (side === 'buy') feeCurrency = market['base'];
                        else if (side === 'sell') feeCurrency = market['quote'];
                        fee = {
                            'currency': feeCurrency,
                            'cost': feeCost
                        };
                    }
                    return this.safeOrder({
                        'id': id,
                        'info': order,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'status': status,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'average': average,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'cost': undefined,
                        'trades': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchMyTrades', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateGetSpotTrades',
                        'swap': 'privateGetFuturesTrades',
                        'future': 'privateGetFuturesTrades'
                    });
                    if (limit !== undefined) request['pageSize'] = limit; // default 10
                    if (since !== undefined) request['startDate'] = this.yyyymmdd(since);
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "list":[
                    //                 {
                    //                     "avgPrice":"1199.8",
                    //                     "base":"ETH",
                    //                     "clOrdID":null,
                    //                     "commission":"0.00002",
                    //                     "createTime":"2021-01-11T02:47:51.512Z",
                    //                     "cumQty":"0.02",
                    //                     "filledOrderID":"1eUD4F5rwK",
                    //                     "filledPrice":"1199.8",
                    //                     "filledQty":"0.02",
                    //                     "leavesQty":"0",
                    //                     "oCreateTime":"2021-01-11T02:47:51.377Z",
                    //                     "orderID":"1eUD4EHfdU",
                    //                     "orderQty":"0.02",
                    //                     "orderStatus":3,
                    //                     "orderType":1,
                    //                     "price":"1198.25",
                    //                     "quote":"USDT",
                    //                     "rejectCode":null,
                    //                     "rejectReason":null,
                    //                     "side":1,
                    //                     "stopPrice":"0",
                    //                     "symbol":"ETHUSDT",
                    //                     "taker":true,
                    //                     "tradeID":"E04WTIgfmULU",
                    //                     "transactTime":"2021-01-11T02:47:51.389Z",
                    //                     "updateTime":null,
                    //                     "userID":"1362494"
                    //                 }
                    //             ],
                    //             "pageNum":1,
                    //             "pageSize":10,
                    //             "total":1
                    //         },
                    //         "message":"success",
                    //         "ts":1610333278042
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const trades = this.safeValue(data, 'list', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    if ('network' in params) {
                        const networks = this.safeValue(this.options, 'networks', {});
                        const network = this.safeStringUpper(params, 'network');
                        params = this.omit(params, 'network');
                        request['network'] = this.safeStringUpper(networks, network, network);
                    }
                    const response = await this.privateGetAccountDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         "code":1,
                    //         "data":{
                    //             "address":"0x080c5c667381404cca9be0be9a04b2e47691ff86",
                    //             "tag":null,
                    //             "currency":"USDT",
                    //             "network":"ERC20"
                    //         },
                    //         "message":"success",
                    //         "ts":1610270465132
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseDepositAddress(data, currency);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) {
                        const startTime = parseInt(since / 1000);
                        request['startTime'] = startTime;
                        request['endTime'] = this.sum(startTime, 7776000); // Only allows a 90 day window between start and end
                    }
                    const response = await this.privateGetAccountDeposits(this.extend(request, params));
                    // {    "code": 1,
                    //     "data": [{
                    //         "currency": "USDT",
                    //         "network": "USDT",
                    //         "quantity": "19.000000000000",
                    //         "txHash": "75eb2e5f037b025c535664c49a0f7cc8f601dae218a5f4fe82290ff652c43f3d",
                    //         "address": "1GkB7Taf7uttcguKEb2DmmyRTnihskJ9Le",
                    //         "status": "2",
                    //         "createdTime": "2021-01-08T19:45:01.354Z",
                    //         "updatedTime": "2021-01-08T20:03:05.000Z",
                    //     }]
                    //     "message": "success",
                    //     "ts": 1573561743499
                    // }
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, code, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) {
                        const startTime = parseInt(since / 1000);
                        request['startTime'] = startTime;
                        request['endTime'] = this.sum(startTime, 7776000); // Only allows a 90 day window between start and end
                    }
                    const response = await this.privateGetAccountWithdraws(this.extend(request, params));
                    // {
                    //     "code":1,
                    //     "data": [
                    //       {
                    //            "currency":"USDT",
                    //            "network":"USDT",
                    //            "quantity":"19.000000000000",
                    //            "fee":"0.10000"
                    //            "txHash":"75eb2e5f037b025c535664c49a0f7cc8f601dae218a5f4fe82290ff652c43f3d",
                    //            "address":"1GkB7Taf7uttcguKEb2DmmyRTnihskJ9Le",
                    //            "addressTag": "",
                    //            "status":"2",
                    //            "createdTime":"2021-01-08T19:45:01.354Z",
                    //            "updatedTime":"2021-01-08T20:03:05.000Z",
                    //       }
                    //  ]
                    //     "message":"success",
                    //     "ts":1573561743499
                    //  }
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, code, since, limit);
                }
                parseTransactionStatusByType(status, type) {
                    const statuses = {
                        'deposit': {
                            '1': 'pending',
                            '2': 'ok',
                            '3': 'failed'
                        },
                        'withdrawal': {
                            '0': 'pending',
                            '1': 'pending',
                            '2': 'pending',
                            '3': 'failed',
                            '4': 'pending',
                            '5': 'ok',
                            '6': 'failed'
                        }
                    };
                    return this.safeString(this.safeValue(statuses, type, {}), status, status);
                }
                parseAddressByType(address, tag, type) {
                    let addressFrom = undefined;
                    let addressTo = undefined;
                    let tagFrom = undefined;
                    let tagTo = undefined;
                    if (type === 'deposit') {
                        addressFrom = address;
                        tagFrom = tag;
                    } else if (type === 'withdrawal') {
                        addressTo = address;
                        tagTo = tag;
                    }
                    return [
                        addressFrom,
                        tagFrom,
                        addressTo,
                        tagTo
                    ];
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //    {
                    //         "currency": "USDT",
                    //         "network": "USDT",
                    //         "quantity": "19.000000000000",
                    //         "txHash": "75eb2e5f037b025c535664c49a0f7cc8f601dae218a5f4fe82290ff652c43f3d",
                    //         "address": "1GkB7Taf7uttcguKEb2DmmyRTnihskJ9Le",
                    //         "status": "2",
                    //         "createdTime": "2021-01-08T19:45:01.354Z",
                    //         "updatedTime": "2021-01-08T20:03:05.000Z",
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "currency":"USDT",
                    //         "network":"USDT",
                    //         "quantity":"19.000000000000",
                    //         "fee":"0.10000"
                    //         "txHash":"75eb2e5f037b025c535664c49a0f7cc8f601dae218a5f4fe82290ff652c43f3d",
                    //         "address":"1GkB7Taf7uttcguKEb2DmmyRTnihskJ9Le",
                    //         "addressTag": "",
                    //         "status":"2",
                    //         "createdTime":"2021-01-08T19:45:01.354Z",
                    //         "updatedTime":"2021-01-08T20:03:05.000Z",
                    //      }
                    //
                    const fee = this.safeString(transaction, 'fee');
                    let type = 'withdrawal';
                    if (fee === undefined) type = 'deposit';
                    const code = this.safeCurrencyCode(this.safeString(transaction, 'currency'));
                    const txid = this.safeString(transaction, 'txHash');
                    const address = this.safeString(transaction, 'address');
                    const tag = this.safeString(transaction, 'addressTag'); // withdrawals only
                    const [addressFrom, tagFrom, addressTo, tagTo] = this.parseAddressByType(address, tag, type);
                    const amountString = this.safeString(transaction, 'quantity');
                    const timestamp = this.parse8601(this.safeString(transaction, 'createdTime'));
                    const updated = this.parse8601(this.safeString(transaction, 'updatedTime'));
                    const status = this.parseTransactionStatusByType(this.safeString(transaction, 'status'), type);
                    const network = this.safeString(transaction, 'network');
                    return {
                        'id': undefined,
                        'info': transaction,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'addressFrom': addressFrom,
                        'address': address,
                        'addressTo': addressTo,
                        'amount': this.parseNumber(amountString),
                        'type': type,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'tagFrom': tagFrom,
                        'tag': tag,
                        'tagTo': tagTo,
                        'comment': undefined,
                        'fee': fee
                    };
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (!market['swap']) throw new BadRequest('Funding rates only exist for swap contracts');
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetFuturesFundingPrevFundingRateSymbol(this.extend(request, params));
                    //
                    //    {
                    //        "code": 1,
                    //        "data": {
                    //           "symbol": "BTCUSDFP",
                    //           "markPrice": "11192.5",
                    //           "fundingRate": "0.001",
                    //           "fundingTime": "2020-08-12T08:00:00Z",
                    //           "nextFundingTime": "2020-08-12T16:00:00Z"
                    //        },
                    //        "message": "success",
                    //        "ts": 1573542445411
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseFundingRate(data);
                }
                parseFundingRate(contract, market) {
                    //
                    //    {
                    //        "symbol": "BTCUSDFP",
                    //        "markPrice": "11192.5",
                    //        "fundingRate": "0.001",
                    //        "fundingTime": "2020-08-12T08:00:00Z",
                    //        "nextFundingTime": "2020-08-12T16:00:00Z"
                    //    }
                    //
                    const marketId = this.safeString(contract, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const markPrice = this.safeNumber(contract, 'markPrice');
                    const fundingRate = this.safeNumber(contract, 'fundingRate');
                    const fundingDatetime = this.safeString(contract, 'fundingTime');
                    const nextFundingDatetime = this.safeString(contract, 'nextFundingTime');
                    return {
                        'info': contract,
                        'symbol': symbol,
                        'markPrice': markPrice,
                        'indexPrice': undefined,
                        'interestRate': undefined,
                        'estimatedSettlePrice': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'fundingRate': fundingRate,
                        'fundingTimestamp': this.parse8601(fundingDatetime),
                        'fundingDatetime': fundingDatetime,
                        'nextFundingRate': undefined,
                        'nextFundingTimestamp': this.parse8601(nextFundingDatetime),
                        'nextFundingDatetime': nextFundingDatetime,
                        'previousFundingRate': undefined,
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         "address":"0x080c5c667381404cca9be0be9a04b2e47691ff86",
                    //         "tag":null,
                    //         "currency":"USDT",
                    //         "network":"ERC20"
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'address');
                    const tag = this.safeString(depositAddress, 'tag');
                    let currencyId = this.safeString(depositAddress, 'currency');
                    const network = this.safeString(depositAddress, 'network');
                    if (network !== undefined) currencyId = currencyId.replace(network, '');
                    const code = this.safeCurrencyCode(currencyId);
                    return {
                        'info': depositAddress,
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': network
                    };
                }
                async fetchFundingRateHistory(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchFundingRateHistory() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['startTime'] = parseInt(since / 1000);
                    const till = this.safeInteger(params, 'till'); // unified in milliseconds
                    const endTime = this.safeString(params, 'endTime'); // exchange-specific in seconds
                    params = this.omit(params, [
                        'endTime',
                        'till'
                    ]);
                    if (till !== undefined) request['endTime'] = parseInt(till / 1000);
                    else if (endTime !== undefined) request['endTime'] = endTime;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetFuturesFundingFundingRate(this.extend(request, params));
                    //
                    //    {
                    //        "code": 1,
                    //        "data": [
                    //            {
                    //                "fundingRate": "0.00033992",
                    //                "fundingTime": "2021-12-31T00:00:00.000Z",
                    //                "symbol": "ETHUSDTFP"
                    //            },
                    //        ]
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    const rates = [];
                    for(let i = 0; i < data.length; i++){
                        const entry = data[i];
                        const marketId = this.safeString(entry, 'symbol');
                        const symbol = this.safeSymbol(marketId);
                        const datetime = this.safeString(entry, 'fundingTime');
                        rates.push({
                            'info': entry,
                            'symbol': symbol,
                            'fundingRate': this.safeNumber(entry, 'fundingRate'),
                            'timestamp': this.parse8601(datetime),
                            'datetime': datetime
                        });
                    }
                    const sorted = this.sortBy(rates, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, market['symbol'], since, limit);
                }
                async fetchFundingHistory(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchFundingHistory() requires a symbol argument');
                    if (limit === undefined) limit = 100; // Default
                    else if (limit > 1000) throw new BadRequest(this.id + ' fetchFundingHistory() limit argument cannot exceed 1000');
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'limit': limit
                    };
                    if (since !== undefined) request['startTime'] = since;
                    const response = await this.privateGetFuturesFundingFundingFee(this.extend(request, params));
                    //
                    //    {
                    //        "code": 1,
                    //        "data": [
                    //            {
                    //                "symbol": "BTCUSDTFP",
                    //                "fundingRate":"0.001",
                    //                "fundingFee":"100",
                    //                "currency":"USDT",
                    //                "fundingTime": "2020-08-12T08:00:00Z",
                    //                "markPrice": "11192.5",
                    //            }
                    //        ],
                    //        "message": "success",
                    //        "ts": 1573542445411
                    //    }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const entry = data[i];
                        const datetime = this.safeString(entry, 'fundingTime');
                        result.push({
                            'info': entry,
                            'symbol': symbol,
                            'code': this.safeCurrencyCode(this.safeString(entry, 'currency')),
                            'timestamp': this.parse8601(datetime),
                            'datetime': datetime,
                            'id': undefined,
                            'amount': this.safeNumber(entry, 'fundingFee')
                        });
                    }
                    return result;
                }
                async setLeverage(leverage, symbol, params = {}) {
                    await this.loadMarkets();
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    if (leverage < 1 || leverage > 100) throw new BadRequest(this.id + ' leverage should be between 1 and 100');
                    const market = this.market(symbol);
                    if (market['type'] !== 'swap') throw new BadSymbol(this.id + ' setLeverage() supports swap contracts only');
                    const request = {
                        'symbol': market['id'],
                        'leverage': leverage
                    };
                    return await this.privatePostFuturesPositionLeverage(this.extend(request, params));
                }
                parseTransfer(transfer, currency) {
                    //     {
                    //          quantity: '0.000010000000',
                    //          transferID: '480975741034369024',
                    //          transferTime: '2022-03-24T13:53:07.042Z',
                    //          fromPurse: 'VLTP',
                    //          toPurse: 'SPTP',
                    //          currency: 'ETH'
                    //     },
                    const id = this.safeString(transfer, 'transferID');
                    const amount = this.safeNumber(transfer, 'quantity');
                    const timestamp = this.parse8601(this.safeString(transfer, 'transferTime'));
                    const accounts = this.safeValue(this.options, 'accounts', {});
                    const fromId = this.safeString(transfer, 'fromPurse');
                    const toId = this.safeString(transfer, 'toPurse');
                    const fromAccount = this.safeString(accounts, fromId);
                    const toAccount = this.safeString(accounts, toId);
                    const currencyId = this.safeString(transfer, 'currency');
                    const currencyCode = this.safeCurrencyCode(currencyId, currency);
                    return {
                        'info': transfer,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': currencyCode,
                        'amount': amount,
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'status': undefined
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        '1': 'ok'
                    };
                    return this.safeString(statuses, status, 'canceled');
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const accountTypes = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountTypes, fromAccount, fromAccount);
                    const toId = this.safeString(accountTypes, toAccount, toAccount);
                    const request = {
                        'currency': currency['id'],
                        'fromPurse': fromId,
                        'toPurse': toId,
                        'quantity': amount
                    };
                    const response = await this.privatePostAccountTransfer(this.extend(request, params));
                    //
                    //     {
                    //         "code": 1,
                    //         "data": {
                    //             "transferID": 888561,
                    //             "transferTime": "2022-03-22T15:29:05.197Z"
                    //         },
                    //         "message": "success",
                    //         "ts": 1647962945151
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const transfer = this.parseTransfer(data, currency);
                    const transferOptions = this.safeValue(this.options, 'transfer', {});
                    const fillResponseFromRequest = this.safeValue(transferOptions, 'fillResponseFromRequest', true);
                    if (fillResponseFromRequest) {
                        if (transfer['fromAccount'] === undefined) transfer['fromAccount'] = fromAccount;
                        if (transfer['toAccount'] === undefined) transfer['toAccount'] = toAccount;
                        if (transfer['amount'] === undefined) transfer['amount'] = amount;
                    }
                    transfer['status'] = this.parseTransferStatus(this.safeString(response, 'code'));
                    return transfer;
                }
                parsePosition(position, market) {
                    //
                    //    {
                    //        "autoMarginCall": false,
                    //        "avgEntryPrice": "3706.03",
                    //        "bankruptPrice": "2963.3415880000",
                    //        "base": "ETH",
                    //        "code": "FP",
                    //        "commission": "0.02964824",
                    //        "currentQty": "2",
                    //        "funding": "-0.04827355",
                    //        "fundingStatus": null,
                    //        "id": "385839395735639395",
                    //        "leverage": "5",
                    //        "liquidationPrice": "2983.07",
                    //        "marketPrice": "3731.84",
                    //        "openTime": "2021-12-31T18:57:25.930Z",
                    //        "posLeverage": "5.00",
                    //        "posMargin": "14.85376824",
                    //        "quote": "USDT",
                    //        "realisedPnl": "-0.07792179",
                    //        "riskLimit": "10000000",
                    //        "riskyPrice": "3272.25",
                    //        "settleType": "VANILLA",
                    //        "stopLossPrice": "0",
                    //        "stopLossSource": 1,
                    //        "symbol": "ETHUSDTFP",
                    //        "takeProfitPrice": "0",
                    //        "takeProfitSource": 1,
                    //        "unrealisedPnl": "0.51620000",
                    //        "userID": "3829384",
                    //        "ts": 1641027194500
                    //    }
                    //
                    const contract = this.safeString(position, 'symbol');
                    market = this.safeMarket(contract, market);
                    const size = this.safeString(position, 'currentQty');
                    let side = undefined;
                    if (Precise.stringGt(size, '0')) side = 'long';
                    else if (Precise.stringLt(size, '0')) side = 'short';
                    const leverage = this.safeString(position, 'leverage');
                    const unrealisedPnl = this.safeString(position, 'unrealisedPnl');
                    const currentQty = this.safeString(position, 'currentQty');
                    const contractSize = this.safeString(market, 'contractSize');
                    const initialQuote = Precise.stringMul(currentQty, contractSize);
                    const marketPrice = this.safeString(position, 'marketPrice');
                    const notional = Precise.stringMul(initialQuote, marketPrice);
                    const timestamp = this.safeInteger(position, 'ts');
                    const liquidationPrice = this.safeString(position, 'liquidationPrice');
                    const marginMode = this.safeString(position, 'settleType');
                    return {
                        'info': position,
                        'symbol': this.safeString(market, 'symbol'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'initialMargin': undefined,
                        'initialMarginPercentage': undefined,
                        'maintenanceMargin': undefined,
                        'maintenanceMarginPercentage': undefined,
                        'entryPrice': this.safeNumber(position, 'avgEntryPrice'),
                        'notional': this.parseNumber(notional),
                        'leverage': this.parseNumber(leverage),
                        'unrealizedPnl': this.parseNumber(unrealisedPnl),
                        'contracts': this.parseNumber(size),
                        'contractSize': this.parseNumber(contractSize),
                        'marginRatio': undefined,
                        'liquidationPrice': liquidationPrice,
                        'markPrice': this.safeNumber(position, 'marketPrice'),
                        'collateral': this.safeNumber(position, 'posMargin'),
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'side': side,
                        'percentage': undefined
                    };
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.privateGetFuturesPosition(this.extend(request, params));
                    //
                    //    {
                    //        "code": 1,
                    //        "data": [
                    //            {
                    //                "autoMarginCall": false,
                    //                "avgEntryPrice": "3706.03",
                    //                "bankruptPrice": "2963.3415880000",
                    //                "base": "ETH",
                    //                "code": "FP",
                    //                "commission": "0.02964824",
                    //                "currentQty": "2",
                    //                "funding": "-0.04827355",
                    //                "fundingStatus": null,
                    //                "id": "385839395735639395",
                    //                "leverage": "5",
                    //                "liquidationPrice": "2983.07",
                    //                "marketPrice": "3731.84",
                    //                "openTime": "2021-12-31T18:57:25.930Z",
                    //                "posLeverage": "5.00",
                    //                "posMargin": "14.85376824",
                    //                "quote": "USDT",
                    //                "realisedPnl": "-0.07792179",
                    //                "riskLimit": "10000000",
                    //                "riskyPrice": "3272.25",
                    //                "settleType": "VANILLA",
                    //                "stopLossPrice": "0",
                    //                "stopLossSource": 1,
                    //                "symbol": "ETHUSDTFP",
                    //                "takeProfitPrice": "0",
                    //                "takeProfitSource": 1,
                    //                "unrealisedPnl": "0.51620000",
                    //                "userID": "3829384"
                    //            }
                    //            ...
                    //        ],
                    //        "message": "success",
                    //        "ts": 1641026778068
                    //    }
                    //
                    const positions = this.safeValue(response, 'data', []);
                    const timestamp = this.safeInteger(response, 'ts');
                    const first = this.safeValue(positions, 0);
                    const position = this.parsePosition(first);
                    return this.extend(position, {
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    });
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbols !== undefined) {
                        let symbol = undefined;
                        if (Array.isArray(symbols)) {
                            const symbolsLength = symbols.length;
                            if (symbolsLength > 1) throw new BadRequest(this.id + ' fetchPositions() symbols argument cannot contain more than 1 symbol');
                            symbol = symbols[0];
                        } else symbol = symbols;
                        const market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const response = await this.privateGetFuturesPosition(this.extend(request, params));
                    //
                    //    {
                    //        "code": 1,
                    //        "data": [
                    //            {
                    //                "autoMarginCall": false,
                    //                "avgEntryPrice": "3706.03",
                    //                "bankruptPrice": "2963.3415880000",
                    //                "base": "ETH",
                    //                "code": "FP",
                    //                "commission": "0.02964824",
                    //                "currentQty": "2",
                    //                "funding": "-0.04827355",
                    //                "fundingStatus": null,
                    //                "id": "385839395735639395",
                    //                "leverage": "5",
                    //                "liquidationPrice": "2983.07",
                    //                "marketPrice": "3731.84",
                    //                "openTime": "2021-12-31T18:57:25.930Z",
                    //                "posLeverage": "5.00",
                    //                "posMargin": "14.85376824",
                    //                "quote": "USDT",
                    //                "realisedPnl": "-0.07792179",
                    //                "riskLimit": "10000000",
                    //                "riskyPrice": "3272.25",
                    //                "settleType": "VANILLA",
                    //                "stopLossPrice": "0",
                    //                "stopLossSource": 1,
                    //                "symbol": "ETHUSDTFP",
                    //                "takeProfitPrice": "0",
                    //                "takeProfitSource": 1,
                    //                "unrealisedPnl": "0.51620000",
                    //                "userID": "3829384"
                    //            }
                    //            ...
                    //        ],
                    //        "message": "success",
                    //        "ts": 1641026778068
                    //    }
                    //
                    const result = [];
                    const positions = this.safeValue(response, 'data', []);
                    const timestamp = this.safeInteger(response, 'ts');
                    for(let i = 0; i < positions.length; i++){
                        const position = this.parsePosition(positions[i]);
                        result.push(this.extend(position, {
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp)
                        }));
                    }
                    return this.filterByArray(result, 'symbol', symbols, false);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'v1') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        url = '/' + this.version + url;
                        if (api === 'public') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else if (api === 'private') {
                            this.checkRequiredCredentials();
                            const nonce = this.nonce().toString();
                            headers = {
                                'X-ACCESS-KEY': this.apiKey,
                                'X-ACCESS-NONCE': nonce
                            };
                            let auth = nonce + ':' + method;
                            if (method === 'GET') {
                                if (Object.keys(query).length) url += '?' + this.urlencode(query);
                                auth += url;
                            } else {
                                headers['Content-Type'] = 'application/json';
                                body = this.json(query);
                                auth += url + body;
                            }
                            const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                            headers['X-ACCESS-SIGN'] = signature;
                        }
                    }
                    url = this.implodeHostname(this.urls['api'][api]) + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //     {"code":40102,"message":"Unauthorized(invalid key)"}
                    //
                    const errorCode = this.safeString(response, 'code');
                    if (errorCode !== undefined && errorCode !== '1') {
                        const feedback = this.id + ' ' + this.json(response);
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    4: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, BadSymbol: BadSymbol, PermissionDenied: PermissionDenied, BadRequest: BadRequest } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class ascendex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'ascendex',
                        'name': 'AscendEX',
                        'countries': [
                            'SG'
                        ],
                        // 8 requests per minute = 0.13333 per second => rateLimit = 750
                        // testing 400 works
                        'rateLimit': 400,
                        'certified': true,
                        'pro': true,
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': true,
                            'swap': true,
                            'future': true,
                            'option': false,
                            'addMargin': true,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': false,
                            'fetchDepositAddressesByNetwork': false,
                            'fetchDeposits': true,
                            'fetchFundingFee': false,
                            'fetchFundingFees': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': true,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': true,
                            'fetchMarketLeverageTiers': 'emulated',
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': false,
                            'fetchPosition': false,
                            'fetchPositions': true,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': true,
                            'reduceMargin': true,
                            'setLeverage': true,
                            'setMarginMode': true,
                            'setPositionMode': false,
                            'transfer': true
                        },
                        'timeframes': {
                            '1m': '1',
                            '5m': '5',
                            '15m': '15',
                            '30m': '30',
                            '1h': '60',
                            '2h': '120',
                            '4h': '240',
                            '6h': '360',
                            '12h': '720',
                            '1d': '1d',
                            '1w': '1w',
                            '1M': '1m'
                        },
                        'version': 'v2',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/112027508-47984600-8b48-11eb-9e17-d26459cc36c6.jpg',
                            'api': {
                                'rest': 'https://ascendex.com'
                            },
                            'test': {
                                'rest': 'https://api-test.ascendex-sandbox.com'
                            },
                            'www': 'https://ascendex.com',
                            'doc': [
                                'https://ascendex.github.io/ascendex-pro-api/#ascendex-pro-api-documentation'
                            ],
                            'fees': 'https://ascendex.com/en/feerate/transactionfee-traderate',
                            'referral': {
                                'url': 'https://ascendex.com/en-us/register?inviteCode=EL6BXBQM',
                                'discount': 0.25
                            }
                        },
                        'api': {
                            'v1': {
                                'public': {
                                    'get': {
                                        'assets': 1,
                                        'products': 1,
                                        'ticker': 1,
                                        'barhist/info': 1,
                                        'barhist': 1,
                                        'depth': 1,
                                        'trades': 1,
                                        'cash/assets': 1,
                                        'cash/products': 1,
                                        'margin/assets': 1,
                                        'margin/products': 1,
                                        'futures/collateral': 1,
                                        'futures/contracts': 1,
                                        'futures/ref-px': 1,
                                        'futures/market-data': 1,
                                        'futures/funding-rates': 1,
                                        'risk-limit-info': 1
                                    }
                                },
                                'private': {
                                    'get': {
                                        'info': 1,
                                        'wallet/transactions': 1,
                                        'wallet/deposit/address': 1,
                                        'data/balance/snapshot': 1,
                                        'data/balance/history': 1
                                    },
                                    'accountCategory': {
                                        'get': {
                                            'balance': 1,
                                            'order/open': 1,
                                            'order/status': 1,
                                            'order/hist/current': 1,
                                            'risk': 1
                                        },
                                        'post': {
                                            'order': 1,
                                            'order/batch': 1
                                        },
                                        'delete': {
                                            'order': 1,
                                            'order/all': 1,
                                            'order/batch': 1
                                        }
                                    },
                                    'accountGroup': {
                                        'get': {
                                            'cash/balance': 1,
                                            'margin/balance': 1,
                                            'margin/risk': 1,
                                            'futures/collateral-balance': 1,
                                            'futures/position': 1,
                                            'futures/risk': 1,
                                            'futures/funding-payments': 1,
                                            'order/hist': 1,
                                            'spot/fee': 1
                                        },
                                        'post': {
                                            'transfer': 1,
                                            'futures/transfer/deposit': 1,
                                            'futures/transfer/withdraw': 1
                                        }
                                    }
                                }
                            },
                            'v2': {
                                'public': {
                                    'get': {
                                        'assets': 1,
                                        'futures/contract': 1,
                                        'futures/collateral': 1,
                                        'futures/pricing-data': 1
                                    }
                                },
                                'private': {
                                    'get': {
                                        'account/info': 1
                                    },
                                    'accountGroup': {
                                        'get': {
                                            'order/hist': 1,
                                            'futures/position': 1,
                                            'futures/free-margin': 1,
                                            'futures/order/hist/current': 1,
                                            'futures/order/open': 1,
                                            'futures/order/status': 1
                                        },
                                        'post': {
                                            'futures/isolated-position-margin': 1,
                                            'futures/margin-type': 1,
                                            'futures/leverage': 1,
                                            'futures/transfer/deposit': 1,
                                            'futures/transfer/withdraw': 1,
                                            'futures/order': 1,
                                            'futures/order/batch': 1,
                                            'futures/order/open': 1,
                                            'subuser/subuser-transfer': 1,
                                            'subuser/subuser-transfer-hist': 1
                                        },
                                        'delete': {
                                            'futures/order': 1,
                                            'futures/order/batch': 1,
                                            'futures/order/all': 1
                                        }
                                    }
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.002'),
                                'maker': this.parseNumber('0.002')
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'options': {
                            'account-category': 'cash',
                            'account-group': undefined,
                            'fetchClosedOrders': {
                                'method': 'v1PrivateAccountGroupGetOrderHist'
                            },
                            'defaultType': 'spot',
                            'accountsByType': {
                                'spot': 'cash',
                                'future': 'futures',
                                'margin': 'margin'
                            },
                            'transfer': {
                                'fillResponseFromRequest': true
                            }
                        },
                        'exceptions': {
                            'exact': {
                                // not documented
                                '1900': BadRequest,
                                '2100': AuthenticationError,
                                '5002': BadSymbol,
                                '6001': BadSymbol,
                                '6010': InsufficientFunds,
                                '60060': InvalidOrder,
                                '600503': InvalidOrder,
                                // documented
                                '100001': BadRequest,
                                '100002': BadRequest,
                                '100003': BadRequest,
                                '100004': BadRequest,
                                '100005': BadRequest,
                                '100006': BadRequest,
                                '100007': BadRequest,
                                '100008': BadSymbol,
                                '100009': AuthenticationError,
                                '100010': BadRequest,
                                '100011': BadRequest,
                                '100012': BadRequest,
                                '100013': BadRequest,
                                '100101': ExchangeError1,
                                '150001': BadRequest,
                                '200001': AuthenticationError,
                                '200002': ExchangeError1,
                                '200003': ExchangeError1,
                                '200004': ExchangeError1,
                                '200005': ExchangeError1,
                                '200006': ExchangeError1,
                                '200007': ExchangeError1,
                                '200008': ExchangeError1,
                                '200009': ExchangeError1,
                                '200010': AuthenticationError,
                                '200011': ExchangeError1,
                                '200012': ExchangeError1,
                                '200013': ExchangeError1,
                                '200014': PermissionDenied,
                                '200015': PermissionDenied,
                                '300001': InvalidOrder,
                                '300002': InvalidOrder,
                                '300003': InvalidOrder,
                                '300004': InvalidOrder,
                                '300005': InvalidOrder,
                                '300006': InvalidOrder,
                                '300007': InvalidOrder,
                                '300008': InvalidOrder,
                                '300009': InvalidOrder,
                                '300011': InsufficientFunds,
                                '300012': BadSymbol,
                                '300013': InvalidOrder,
                                '300014': InvalidOrder,
                                '300020': InvalidOrder,
                                '300021': InvalidOrder,
                                '300031': InvalidOrder,
                                '310001': InsufficientFunds,
                                '310002': InvalidOrder,
                                '310003': InvalidOrder,
                                '310004': BadSymbol,
                                '310005': InvalidOrder,
                                '510001': ExchangeError1,
                                '900001': ExchangeError1
                            },
                            'broad': {}
                        },
                        'commonCurrencies': {
                            'BOND': 'BONDED',
                            'BTCBEAR': 'BEAR',
                            'BTCBULL': 'BULL',
                            'BYN': 'BeyondFi',
                            'PLN': 'Pollen'
                        }
                    });
                }
                getAccount(params = {}) {
                    // get current or provided bitmax sub-account
                    const account = this.safeValue(params, 'account', this.options['account']);
                    return account.toLowerCase().capitalize();
                }
                async fetchCurrencies(params = {}) {
                    const assets = await this.v1PublicGetAssets(params);
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "assetCode" : "LTCBULL",
                    //                 "assetName" : "3X Long LTC Token",
                    //                 "precisionScale" : 9,
                    //                 "nativeScale" : 4,
                    //                 "withdrawalFee" : "0.2",
                    //                 "minWithdrawalAmt" : "1.0",
                    //                 "status" : "Normal"
                    //             },
                    //         ]
                    //     }
                    //
                    const margin = await this.v1PublicGetMarginAssets(params);
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "assetCode":"BTT",
                    //                 "borrowAssetCode":"BTT-B",
                    //                 "interestAssetCode":"BTT-I",
                    //                 "nativeScale":0,
                    //                 "numConfirmations":1,
                    //                 "withdrawFee":"100.0",
                    //                 "minWithdrawalAmt":"1000.0",
                    //                 "statusCode":"Normal",
                    //                 "statusMessage":"",
                    //                 "interestRate":"0.001"
                    //             }
                    //         ]
                    //     }
                    //
                    const cash = await this.v1PublicGetCashAssets(params);
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "assetCode":"LTCBULL",
                    //                 "nativeScale":4,
                    //                 "numConfirmations":20,
                    //                 "withdrawFee":"0.2",
                    //                 "minWithdrawalAmt":"1.0",
                    //                 "statusCode":"Normal",
                    //                 "statusMessage":""
                    //             }
                    //         ]
                    //     }
                    //
                    const assetsData = this.safeValue(assets, 'data', []);
                    const marginData = this.safeValue(margin, 'data', []);
                    const cashData = this.safeValue(cash, 'data', []);
                    const assetsById = this.indexBy(assetsData, 'assetCode');
                    const marginById = this.indexBy(marginData, 'assetCode');
                    const cashById = this.indexBy(cashData, 'assetCode');
                    const dataById = this.deepExtend(assetsById, marginById, cashById);
                    const ids = Object.keys(dataById);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const currency = dataById[id];
                        const code = this.safeCurrencyCode(id);
                        const scale = this.safeString2(currency, 'precisionScale', 'nativeScale');
                        const precision = this.parseNumber(this.parsePrecision(scale));
                        // why would the exchange API have different names for the same field
                        const fee = this.safeNumber2(currency, 'withdrawFee', 'withdrawalFee');
                        const status = this.safeString2(currency, 'status', 'statusCode');
                        const active = status === 'Normal';
                        const margin = 'borrowAssetCode' in currency;
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'type': undefined,
                            'margin': margin,
                            'name': this.safeString(currency, 'assetName'),
                            'active': active,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': fee,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': precision,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'minWithdrawalAmt'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const products = await this.v1PublicGetProducts(params);
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "symbol":"LBA/BTC",
                    //                 "baseAsset":"LBA",
                    //                 "quoteAsset":"BTC",
                    //                 "status":"Normal",
                    //                 "minNotional":"0.000625",
                    //                 "maxNotional":"6.25",
                    //                 "marginTradable":false,
                    //                 "commissionType":"Quote",
                    //                 "commissionReserveRate":"0.001",
                    //                 "tickSize":"0.000000001",
                    //                 "lotSize":"1"
                    //             },
                    //         ]
                    //     }
                    //
                    const cash = await this.v1PublicGetCashProducts(params);
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "symbol":"QTUM/BTC",
                    //                 "domain":"BTC",
                    //                 "tradingStartTime":1569506400000,
                    //                 "collapseDecimals":"0.0001,0.000001,0.00000001",
                    //                 "minQty":"0.000000001",
                    //                 "maxQty":"1000000000",
                    //                 "minNotional":"0.000625",
                    //                 "maxNotional":"12.5",
                    //                 "statusCode":"Normal",
                    //                 "statusMessage":"",
                    //                 "tickSize":"0.00000001",
                    //                 "useTick":false,
                    //                 "lotSize":"0.1",
                    //                 "useLot":false,
                    //                 "commissionType":"Quote",
                    //                 "commissionReserveRate":"0.001",
                    //                 "qtyScale":1,
                    //                 "priceScale":8,
                    //                 "notionalScale":4
                    //             }
                    //         ]
                    //     }
                    //
                    const perpetuals = await this.v2PublicGetFuturesContract(params);
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "symbol":"BTC-PERP",
                    //                 "status":"Normal",
                    //                 "displayName":"BTCUSDT",
                    //                 "settlementAsset":"USDT",
                    //                 "underlying":"BTC/USDT",
                    //                 "tradingStartTime":1579701600000,
                    //                 "priceFilter":{"minPrice":"1","maxPrice":"1000000","tickSize":"1"},
                    //                 "lotSizeFilter":{"minQty":"0.0001","maxQty":"1000000000","lotSize":"0.0001"},
                    //                 "commissionType":"Quote",
                    //                 "commissionReserveRate":"0.001",
                    //                 "marketOrderPriceMarkup":"0.03",
                    //                 "marginRequirements":[
                    //                     {"positionNotionalLowerBound":"0","positionNotionalUpperBound":"50000","initialMarginRate":"0.01","maintenanceMarginRate":"0.006"},
                    //                     {"positionNotionalLowerBound":"50000","positionNotionalUpperBound":"200000","initialMarginRate":"0.02","maintenanceMarginRate":"0.012"},
                    //                     {"positionNotionalLowerBound":"200000","positionNotionalUpperBound":"2000000","initialMarginRate":"0.04","maintenanceMarginRate":"0.024"},
                    //                     {"positionNotionalLowerBound":"2000000","positionNotionalUpperBound":"20000000","initialMarginRate":"0.1","maintenanceMarginRate":"0.06"},
                    //                     {"positionNotionalLowerBound":"20000000","positionNotionalUpperBound":"40000000","initialMarginRate":"0.2","maintenanceMarginRate":"0.12"},
                    //                     {"positionNotionalLowerBound":"40000000","positionNotionalUpperBound":"1000000000","initialMarginRate":"0.333333","maintenanceMarginRate":"0.2"}
                    //                 ]
                    //             }
                    //         ]
                    //     }
                    //
                    const productsData = this.safeValue(products, 'data', []);
                    const productsById = this.indexBy(productsData, 'symbol');
                    const cashData = this.safeValue(cash, 'data', []);
                    const perpetualsData = this.safeValue(perpetuals, 'data', []);
                    const cashAndPerpetualsData = this.arrayConcat(cashData, perpetualsData);
                    const cashAndPerpetualsById = this.indexBy(cashAndPerpetualsData, 'symbol');
                    const dataById = this.deepExtend(productsById, cashAndPerpetualsById);
                    const ids = Object.keys(dataById);
                    const result = [];
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const market = dataById[id];
                        let baseId = this.safeString(market, 'baseAsset');
                        let quoteId = this.safeString(market, 'quoteAsset');
                        const settleId = this.safeValue(market, 'settlementAsset');
                        let base = this.safeCurrencyCode(baseId);
                        let quote = this.safeCurrencyCode(quoteId);
                        const settle = this.safeCurrencyCode(settleId);
                        const status = this.safeString(market, 'status');
                        const spot = settle === undefined;
                        const swap = !spot;
                        const linear = swap ? true : undefined;
                        let minQty = this.safeNumber(market, 'minQty');
                        let maxQty = this.safeNumber(market, 'maxQty');
                        let minPrice = this.safeNumber(market, 'tickSize');
                        let maxPrice = undefined;
                        let symbol = base + '/' + quote;
                        if (swap) {
                            const lotSizeFilter = this.safeValue(market, 'lotSizeFilter');
                            minQty = this.safeNumber(lotSizeFilter, 'minQty');
                            maxQty = this.safeNumber(lotSizeFilter, 'maxQty');
                            const priceFilter = this.safeValue(market, 'priceFilter');
                            minPrice = this.safeNumber(priceFilter, 'minPrice');
                            maxPrice = this.safeNumber(priceFilter, 'maxPrice');
                            const underlying = this.safeString(market, 'underlying');
                            const parts = underlying.split('/');
                            baseId = this.safeString(parts, 0);
                            quoteId = this.safeString(parts, 1);
                            base = this.safeCurrencyCode(baseId);
                            quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote + ':' + settle;
                        }
                        const fee = this.safeNumber(market, 'commissionReserveRate');
                        const marginTradable = this.safeValue(market, 'marginTradable', false);
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': swap ? 'swap' : 'spot',
                            'spot': spot,
                            'margin': spot ? marginTradable : undefined,
                            'swap': swap,
                            'future': false,
                            'option': false,
                            'active': status === 'Normal',
                            'contract': swap,
                            'linear': linear,
                            'inverse': swap ? !linear : undefined,
                            'taker': fee,
                            'maker': fee,
                            'contractSize': swap ? this.parseNumber('1') : undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(market, 'lotSize'),
                                'price': this.safeNumber(market, 'tickSize')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': minQty,
                                    'max': maxQty
                                },
                                'price': {
                                    'min': minPrice,
                                    'max': maxPrice
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minNotional'),
                                    'max': this.safeNumber(market, 'maxNotional')
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchAccounts(params = {}) {
                    let accountGroup = this.safeString(this.options, 'account-group');
                    let response = undefined;
                    if (accountGroup === undefined) {
                        response = await this.v1PrivateGetInfo(params);
                        //
                        //     {
                        //         "code":0,
                        //         "data":{
                        //             "email":"igor.kroitor@gmail.com",
                        //             "accountGroup":8,
                        //             "viewPermission":true,
                        //             "tradePermission":true,
                        //             "transferPermission":true,
                        //             "cashAccount":["cshrHKLZCjlZ2ejqkmvIHHtPmLYqdnda"],
                        //             "marginAccount":["martXoh1v1N3EMQC5FDtSj5VHso8aI2Z"],
                        //             "futuresAccount":["futc9r7UmFJAyBY2rE3beA2JFxav2XFF"],
                        //             "userUID":"U6491137460"
                        //         }
                        //     }
                        //
                        const data = this.safeValue(response, 'data', {});
                        accountGroup = this.safeString(data, 'accountGroup');
                        this.options['account-group'] = accountGroup;
                    }
                    return [
                        {
                            'id': accountGroup,
                            'type': undefined,
                            'currency': undefined,
                            'info': response
                        }
                    ];
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const balances = this.safeValue(response, 'data', []);
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const code = this.safeCurrencyCode(this.safeString(balance, 'asset'));
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'availableBalance');
                        account['total'] = this.safeString(balance, 'totalBalance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                parseSwapBalance(response) {
                    const timestamp = this.milliseconds();
                    const result = {
                        'info': response,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    };
                    const data = this.safeValue(response, 'data', {});
                    const collaterals = this.safeValue(data, 'collaterals', []);
                    for(let i = 0; i < collaterals.length; i++){
                        const balance = collaterals[i];
                        const code = this.safeCurrencyCode(this.safeString(balance, 'asset'));
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchBalance', undefined, params);
                    const options = this.safeValue(this.options, 'fetchBalance', {});
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const accountCategory = this.safeString(accountsByType, marketType, 'cash');
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeString(account, 'id');
                    const request = {
                        'account-group': accountGroup
                    };
                    const defaultMethod = this.safeString(options, 'method', 'v1PrivateAccountCategoryGetBalance');
                    const method = this.getSupportedMapping(marketType, {
                        'spot': defaultMethod,
                        'margin': defaultMethod,
                        'swap': 'v2PrivateAccountGroupGetFuturesPosition'
                    });
                    if (accountCategory === 'cash') request['account-category'] = accountCategory;
                    const response = await this[method](this.extend(request, query));
                    //
                    // cash
                    //
                    //     {
                    //         'code': 0,
                    //         'data': [
                    //             {
                    //                 'asset': 'BCHSV',
                    //                 'totalBalance': '64.298000048',
                    //                 'availableBalance': '64.298000048',
                    //             },
                    //         ]
                    //     }
                    //
                    // margin
                    //
                    //     {
                    //         'code': 0,
                    //         'data': [
                    //             {
                    //                 'asset': 'BCHSV',
                    //                 'totalBalance': '64.298000048',
                    //                 'availableBalance': '64.298000048',
                    //                 'borrowed': '0',
                    //                 'interest': '0',
                    //             },
                    //         ]
                    //     }
                    //
                    // swap
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "accountId": "fut2ODPhGiY71Pl4vtXnOZ00ssgD7QGn",
                    //             "ac": "FUTURES",
                    //             "collaterals": [
                    //                 {"asset":"ADA","balance":"0.355803","referencePrice":"1.05095","discountFactor":"0.9"},
                    //                 {"asset":"USDT","balance":"0.000014519","referencePrice":"1","discountFactor":"1"}
                    //             ],
                    //         }j
                    //     }
                    //
                    if (marketType === 'swap') return this.parseSwapBalance(response);
                    else return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.v1PublicGetDepth(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "data":{
                    //             "m":"depth-snapshot",
                    //             "symbol":"BTC-PERP",
                    //             "data":{
                    //                 "ts":1590223998202,
                    //                 "seqnum":115444921,
                    //                 "asks":[
                    //                     ["9207.5","18.2383"],
                    //                     ["9207.75","18.8235"],
                    //                     ["9208","10.7873"],
                    //                 ],
                    //                 "bids":[
                    //                     ["9207.25","0.4009"],
                    //                     ["9207","0.003"],
                    //                     ["9206.5","0.003"],
                    //                 ]
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const orderbook = this.safeValue(data, 'data', {});
                    const timestamp = this.safeInteger(orderbook, 'ts');
                    const result = this.parseOrderBook(orderbook, symbol, timestamp);
                    result['nonce'] = this.safeInteger(orderbook, 'seqnum');
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "symbol":"QTUM/BTC",
                    //         "open":"0.00016537",
                    //         "close":"0.00019077",
                    //         "high":"0.000192",
                    //         "low":"0.00016537",
                    //         "volume":"846.6",
                    //         "ask":["0.00018698","26.2"],
                    //         "bid":["0.00018408","503.7"],
                    //         "type":"spot"
                    //     }
                    //
                    const timestamp = undefined;
                    const marketId = this.safeString(ticker, 'symbol');
                    const type = this.safeString(ticker, 'type');
                    const delimiter = type === 'spot' ? '/' : undefined;
                    const symbol = this.safeSymbol(marketId, market, delimiter);
                    const close = this.safeString(ticker, 'close');
                    const bid = this.safeValue(ticker, 'bid', []);
                    const ask = this.safeValue(ticker, 'ask', []);
                    const open = this.safeString(ticker, 'open');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': undefined,
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(bid, 0),
                        'bidVolume': this.safeString(bid, 1),
                        'ask': this.safeString(ask, 0),
                        'askVolume': this.safeString(ask, 1),
                        'vwap': undefined,
                        'open': open,
                        'close': close,
                        'last': close,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.v1PublicGetTicker(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "data":{
                    //             "symbol":"BTC-PERP", // or "BTC/USDT"
                    //             "open":"9073",
                    //             "close":"9185.75",
                    //             "high":"9185.75",
                    //             "low":"9185.75",
                    //             "volume":"576.8334",
                    //             "ask":["9185.75","15.5863"],
                    //             "bid":["9185.5","0.003"],
                    //             "type":"derivatives", // or "spot"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTicker(data, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbols !== undefined) {
                        const marketIds = this.marketIds(symbols);
                        request['symbol'] = marketIds.join(',');
                    }
                    const response = await this.v1PublicGetTicker(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "symbol":"QTUM/BTC",
                    //                 "open":"0.00016537",
                    //                 "close":"0.00019077",
                    //                 "high":"0.000192",
                    //                 "low":"0.00016537",
                    //                 "volume":"846.6",
                    //                 "ask":["0.00018698","26.2"],
                    //                 "bid":["0.00018408","503.7"],
                    //                 "type":"spot"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTickers(data, symbols);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "m":"bar",
                    //         "s":"BTC/USDT",
                    //         "data":{
                    //             "i":"1",
                    //             "ts":1590228000000,
                    //             "o":"9139.59",
                    //             "c":"9131.94",
                    //             "h":"9139.99",
                    //             "l":"9121.71",
                    //             "v":"25.20648"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(ohlcv, 'data', {});
                    return [
                        this.safeInteger(data, 'ts'),
                        this.safeNumber(data, 'o'),
                        this.safeNumber(data, 'h'),
                        this.safeNumber(data, 'l'),
                        this.safeNumber(data, 'c'),
                        this.safeNumber(data, 'v')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'interval': this.timeframes[timeframe]
                    };
                    // if since and limit are not specified
                    // the exchange will return just 1 last candle by default
                    const duration = this.parseTimeframe(timeframe);
                    const options = this.safeValue(this.options, 'fetchOHLCV', {});
                    const defaultLimit = this.safeInteger(options, 'limit', 500);
                    if (since !== undefined) {
                        request['from'] = since;
                        if (limit === undefined) limit = defaultLimit;
                        else limit = Math.min(limit, defaultLimit);
                        request['to'] = this.sum(since, limit * duration * 1000, 1);
                    } else if (limit !== undefined) request['n'] = limit; // max 500
                    const response = await this.v1PublicGetBarhist(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "m":"bar",
                    //                 "s":"BTC/USDT",
                    //                 "data":{
                    //                     "i":"1",
                    //                     "ts":1590228000000,
                    //                     "o":"9139.59",
                    //                     "c":"9131.94",
                    //                     "h":"9139.99",
                    //                     "l":"9121.71",
                    //                     "v":"25.20648"
                    //                 }
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     {
                    //         "p":"9128.5", // price
                    //         "q":"0.0030", // quantity
                    //         "ts":1590229002385, // timestamp
                    //         "bm":false, // if true, the buyer is the market maker, we only use this field to "define the side" of a public trade
                    //         "seqnum":180143985289898554
                    //     }
                    //
                    const timestamp = this.safeInteger(trade, 'ts');
                    const priceString = this.safeString2(trade, 'price', 'p');
                    const amountString = this.safeString(trade, 'q');
                    const buyerIsMaker = this.safeValue(trade, 'bm', false);
                    const makerOrTaker = buyerIsMaker ? 'maker' : 'taker';
                    const side = buyerIsMaker ? 'buy' : 'sell';
                    market = this.safeMarket(undefined, market);
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'id': undefined,
                        'order': undefined,
                        'type': undefined,
                        'takerOrMaker': makerOrTaker,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['n'] = limit; // max 100
                    const response = await this.v1PublicGetTrades(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "data":{
                    //             "m":"trades",
                    //             "symbol":"BTC-PERP",
                    //             "data":[
                    //                 {"p":"9128.5","q":"0.0030","ts":1590229002385,"bm":false,"seqnum":180143985289898554},
                    //                 {"p":"9129","q":"0.0030","ts":1590229002642,"bm":false,"seqnum":180143985289898587},
                    //                 {"p":"9129.5","q":"0.0030","ts":1590229021306,"bm":false,"seqnum":180143985289899043}
                    //             ]
                    //         }
                    //     }
                    //
                    const records = this.safeValue(response, 'data', []);
                    const trades = this.safeValue(records, 'data', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'PendingNew': 'open',
                        'New': 'open',
                        'PartiallyFilled': 'open',
                        'Filled': 'closed',
                        'Canceled': 'canceled',
                        'Rejected': 'rejected'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "id": "16e607e2b83a8bXHbAwwoqDo55c166fa",
                    //         "orderId": "16e85b4d9b9a8bXHbAwwoqDoc3d66830",
                    //         "orderType": "Market",
                    //         "symbol": "BTC/USDT",
                    //         "timestamp": 1573576916201
                    //     }
                    //
                    //     {
                    //         "ac": "FUTURES",
                    //         "accountId": "fut2ODPhGiY71Pl4vtXnOZ00ssgD7QGn",
                    //         "time": 1640819389454,
                    //         "orderId": "a17e0874ecbdU0711043490bbtcpDU5X",
                    //         "seqNum": -1,
                    //         "orderType": "Limit",
                    //         "execInst": "NULL_VAL",
                    //         "side": "Buy",
                    //         "symbol": "BTC-PERP",
                    //         "price": "30000",
                    //         "orderQty": "0.002",
                    //         "stopPrice": "0",
                    //         "stopBy": "ref-px",
                    //         "status": "Ack",
                    //         "lastExecTime": 1640819389454,
                    //         "lastQty": "0",
                    //         "lastPx": "0",
                    //         "avgFilledPx": "0",
                    //         "cumFilledQty": "0",
                    //         "fee": "0",
                    //         "cumFee": "0",
                    //         "feeAsset": "",
                    //         "errorCode": "",
                    //         "posStopLossPrice": "0",
                    //         "posStopLossTrigger": "market",
                    //         "posTakeProfitPrice": "0",
                    //         "posTakeProfitTrigger": "market",
                    //         "liquidityInd": "n"
                    //      }
                    //
                    // fetchOrder, fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "symbol":       "BTC/USDT",
                    //         "price":        "8131.22",
                    //         "orderQty":     "0.00082",
                    //         "orderType":    "Market",
                    //         "avgPx":        "7392.02",
                    //         "cumFee":       "0.005152238",
                    //         "cumFilledQty": "0.00082",
                    //         "errorCode":    "",
                    //         "feeAsset":     "USDT",
                    //         "lastExecTime": 1575953151764,
                    //         "orderId":      "a16eee20b6750866943712zWEDdAjt3",
                    //         "seqNum":       2623469,
                    //         "side":         "Buy",
                    //         "status":       "Filled",
                    //         "stopPrice":    "",
                    //         "execInst":     "NULL_VAL"
                    //     }
                    //
                    //     {
                    //         "ac": "FUTURES",
                    //         "accountId": "testabcdefg",
                    //         "avgPx": "0",
                    //         "cumFee": "0",
                    //         "cumQty": "0",
                    //         "errorCode": "NULL_VAL",
                    //         "execInst": "NULL_VAL",
                    //         "feeAsset": "USDT",
                    //         "lastExecTime": 1584072844085,
                    //         "orderId": "r170d21956dd5450276356bbtcpKa74",
                    //         "orderQty": "1.1499",
                    //         "orderType": "Limit",
                    //         "price": "4000",
                    //         "sendingTime": 1584072841033,
                    //         "seqNum": 24105338,
                    //         "side": "Buy",
                    //         "status": "Canceled",
                    //         "stopPrice": "",
                    //         "symbol": "BTC-PERP"
                    //     },
                    //
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '/');
                    const timestamp = this.safeInteger2(order, 'timestamp', 'sendingTime');
                    const lastTradeTimestamp = this.safeInteger(order, 'lastExecTime');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'orderQty');
                    const average = this.safeString(order, 'avgPx');
                    const filled = this.safeString2(order, 'cumFilledQty', 'cumQty');
                    const id = this.safeString(order, 'orderId');
                    let clientOrderId = this.safeString(order, 'id');
                    if (clientOrderId !== undefined) {
                        if (clientOrderId.length < 1) clientOrderId = undefined;
                    }
                    const type = this.safeStringLower(order, 'orderType');
                    const side = this.safeStringLower(order, 'side');
                    const feeCost = this.safeNumber(order, 'cumFee');
                    let fee = undefined;
                    if (feeCost !== undefined) {
                        const feeCurrencyId = this.safeString(order, 'feeAsset');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrencyCode
                        };
                    }
                    const stopPrice = this.safeNumber(order, 'stopPrice');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': undefined,
                        'average': average,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeString(account, 'id');
                    const request = {
                        'account-group': accountGroup
                    };
                    const response = await this.v1PrivateAccountGroupGetSpotFee(this.extend(request, params));
                    //
                    //      {
                    //         code: '0',
                    //         data: {
                    //           domain: 'spot',
                    //           userUID: 'U1479576458',
                    //           vipLevel: '0',
                    //           fees: [
                    //             { symbol: 'HT/USDT', fee: { taker: '0.001', maker: '0.001' } },
                    //             { symbol: 'LAMB/BTC', fee: { taker: '0.002', maker: '0.002' } },
                    //             { symbol: 'STOS/USDT', fee: { taker: '0.002', maker: '0.002' } },
                    //             ...
                    //           ]
                    //         }
                    //      }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const fees = this.safeValue(data, 'fees', []);
                    const result = {};
                    for(let i = 0; i < fees.length; i++){
                        const fee = fees[i];
                        const marketId = this.safeString(fee, 'symbol');
                        const symbol = this.safeSymbol(marketId, undefined, '/');
                        const takerMaker = this.safeValue(fee, 'fee', {});
                        result[symbol] = {
                            'info': fee,
                            'symbol': symbol,
                            'maker': this.safeNumber(takerMaker, 'maker'),
                            'taker': this.safeNumber(takerMaker, 'taker')
                        };
                    }
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const market = this.market(symbol);
                    let marketType = undefined;
                    [marketType, params] = this.handleMarketTypeAndParams('createOrder', market, params);
                    const options = this.safeValue(this.options, 'createOrder', {});
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const accountCategory = this.safeString(accountsByType, marketType, 'cash');
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeValue(account, 'id');
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'id');
                    const reduceOnly = this.safeValue(params, 'execInst');
                    if (reduceOnly !== undefined) {
                        if (marketType !== 'swap') throw new InvalidOrder(this.id + ' createOrder() does not support reduceOnly for ' + marketType + ' orders, reduceOnly orders are supported for perpetuals only');
                    }
                    const request = {
                        'account-group': accountGroup,
                        'account-category': accountCategory,
                        'symbol': market['id'],
                        'time': this.milliseconds(),
                        'orderQty': this.amountToPrecision(symbol, amount),
                        'orderType': type,
                        'side': side
                    };
                    if (clientOrderId !== undefined) {
                        request['id'] = clientOrderId;
                        params = this.omit(params, [
                            'clientOrderId',
                            'id'
                        ]);
                    }
                    if (type === 'limit' || type === 'stop_limit') request['orderPrice'] = this.priceToPrecision(symbol, price);
                    if (type === 'stop_limit' || type === 'stop_market') {
                        const stopPrice = this.safeNumber(params, 'stopPrice');
                        if (stopPrice === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a stopPrice parameter for ' + type + ' orders');
                        else {
                            request['stopPrice'] = this.priceToPrecision(symbol, stopPrice);
                            params = this.omit(params, 'stopPrice');
                        }
                    }
                    const timeInForce = this.safeString(params, 'timeInForce');
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    if (timeInForce === 'PO' || postOnly) {
                        request['postOnly'] = true;
                        params = this.omit(params, [
                            'postOnly',
                            'timeInForce'
                        ]);
                    }
                    const defaultMethod = this.safeString(options, 'method', 'v1PrivateAccountCategoryPostOrder');
                    const method = this.getSupportedMapping(marketType, {
                        'spot': defaultMethod,
                        'margin': defaultMethod,
                        'swap': 'v2PrivateAccountGroupPostFuturesOrder'
                    });
                    if (method === 'v1PrivateAccountCategoryPostOrder') {
                        if (accountCategory !== undefined) request['category'] = accountCategory;
                    } else request['account-category'] = accountCategory;
                    const response = await this[method](this.extend(request, params));
                    //
                    // AccountCategoryPostOrder
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "ac": "MARGIN",
                    //             "accountId": "cshQtyfq8XLAA9kcf19h8bXHbAwwoqDo",
                    //             "action": "place-order",
                    //             "info": {
                    //                 "id": "16e607e2b83a8bXHbAwwoqDo55c166fa",
                    //                 "orderId": "16e85b4d9b9a8bXHbAwwoqDoc3d66830",
                    //                 "orderType": "Market",
                    //                 "symbol": "BTC/USDT",
                    //                 "timestamp": 1573576916201
                    //             },
                    //             "status": "Ack"
                    //         }
                    //     }
                    //
                    // AccountGroupPostFuturesOrder
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "meta": {
                    //                 "id": "",
                    //                 "action": "place-order",
                    //                 "respInst": "ACK"
                    //             },
                    //             "order": {
                    //                 "ac": "FUTURES",
                    //                 "accountId": "fut2ODPhGiY71Pl4vtXnOZ00ssgD7QGn",
                    //                 "time": 1640819389454,
                    //                 "orderId": "a17e0874ecbdU0711043490bbtcpDU5X",
                    //                 "seqNum": -1,
                    //                 "orderType": "Limit",
                    //                 "execInst": "NULL_VAL",
                    //                 "side": "Buy",
                    //                 "symbol": "BTC-PERP",
                    //                 "price": "30000",
                    //                 "orderQty": "0.002",
                    //                 "stopPrice": "0",
                    //                 "stopBy": "ref-px",
                    //                 "status": "Ack",
                    //                 "lastExecTime": 1640819389454,
                    //                 "lastQty": "0",
                    //                 "lastPx": "0",
                    //                 "avgFilledPx": "0",
                    //                 "cumFilledQty": "0",
                    //                 "fee": "0",
                    //                 "cumFee": "0",
                    //                 "feeAsset": "",
                    //                 "errorCode": "",
                    //                 "posStopLossPrice": "0",
                    //                 "posStopLossTrigger": "market",
                    //                 "posTakeProfitPrice": "0",
                    //                 "posTakeProfitTrigger": "market",
                    //                 "liquidityInd": "n"
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const order = this.safeValue2(data, 'order', 'info', {});
                    return this.parseOrder(order, market);
                }
                async createReduceOnlyOrder(symbol, type, side, amount, price, params = {}) {
                    const request = {
                        'execInst': 'reduceOnly'
                    };
                    return await this.createOrder(symbol, type, side, amount, price, this.extend(request, params));
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const [type, query] = this.handleMarketTypeAndParams('fetchOrder', market, params);
                    const options = this.safeValue(this.options, 'fetchOrder', {});
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const accountCategory = this.safeString(accountsByType, type, 'cash');
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeValue(account, 'id');
                    const request = {
                        'account-group': accountGroup,
                        'account-category': accountCategory,
                        'orderId': id
                    };
                    const defaultMethod = this.safeString(options, 'method', 'v1PrivateAccountCategoryGetOrderStatus');
                    const method = this.getSupportedMapping(type, {
                        'spot': defaultMethod,
                        'margin': defaultMethod,
                        'swap': 'v2PrivateAccountGroupGetFuturesOrderStatus'
                    });
                    if (method === 'v1PrivateAccountCategoryGetOrderStatus') {
                        if (accountCategory !== undefined) request['category'] = accountCategory;
                    } else request['account-category'] = accountCategory;
                    const response = await this[method](this.extend(request, query));
                    //
                    // AccountCategoryGetOrderStatus
                    //
                    //     {
                    //         "code": 0,
                    //         "accountCategory": "CASH",
                    //         "accountId": "cshQtyfq8XLAA9kcf19h8bXHbAwwoqDo",
                    //         "data": [
                    //             {
                    //                 "symbol":       "BTC/USDT",
                    //                 "price":        "8131.22",
                    //                 "orderQty":     "0.00082",
                    //                 "orderType":    "Market",
                    //                 "avgPx":        "7392.02",
                    //                 "cumFee":       "0.005152238",
                    //                 "cumFilledQty": "0.00082",
                    //                 "errorCode":    "",
                    //                 "feeAsset":     "USDT",
                    //                 "lastExecTime": 1575953151764,
                    //                 "orderId":      "a16eee20b6750866943712zWEDdAjt3",
                    //                 "seqNum":       2623469,
                    //                 "side":         "Buy",
                    //                 "status":       "Filled",
                    //                 "stopPrice":    "",
                    //                 "execInst":     "NULL_VAL"
                    //             }
                    //         ]
                    //     }
                    //
                    // AccountGroupGetFuturesOrderStatus
                    //
                    //     {
                    //         "code": 0,
                    //         "accountId": "fut2ODPhGiY71Pl4vtXnOZ00ssgD7QGn",
                    //         "ac": "FUTURES",
                    //         "data": {
                    //             "ac": "FUTURES",
                    //             "accountId": "fut2ODPhGiY71Pl4vtXnOZ00ssgD7QGn",
                    //             "time": 1640247020217,
                    //             "orderId": "r17de65747aeU0711043490bbtcp0cmt",
                    //             "seqNum": 28796162908,
                    //             "orderType": "Limit",
                    //             "execInst": "NULL_VAL",
                    //             "side": "Buy",
                    //             "symbol": "BTC-PERP",
                    //             "price": "30000",
                    //             "orderQty": "0.0021",
                    //             "stopPrice": "0",
                    //             "stopBy": "market",
                    //             "status": "New",
                    //             "lastExecTime": 1640247020232,
                    //             "lastQty": "0",
                    //             "lastPx": "0",
                    //             "avgFilledPx": "0",
                    //             "cumFilledQty": "0",
                    //             "fee": "0",
                    //             "cumFee": "0",
                    //             "feeAsset": "USDT",
                    //             "errorCode": "",
                    //             "posStopLossPrice": "0",
                    //             "posStopLossTrigger": "market",
                    //             "posTakeProfitPrice": "0",
                    //             "posTakeProfitTrigger": "market",
                    //             "liquidityInd": "n"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        symbol = market['symbol'];
                    }
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeValue(account, 'id');
                    const [type, query] = this.handleMarketTypeAndParams('fetchOpenOrders', market, params);
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const accountCategory = this.safeString(accountsByType, type, 'cash');
                    const request = {
                        'account-group': accountGroup,
                        'account-category': accountCategory
                    };
                    const options = this.safeValue(this.options, 'fetchOpenOrders', {});
                    const defaultMethod = this.safeString(options, 'method', 'v1PrivateAccountCategoryGetOrderOpen');
                    const method = this.getSupportedMapping(type, {
                        'spot': defaultMethod,
                        'margin': defaultMethod,
                        'swap': 'v2PrivateAccountGroupGetFuturesOrderOpen'
                    });
                    if (method === 'v1PrivateAccountCategoryGetOrderOpen') {
                        if (accountCategory !== undefined) request['category'] = accountCategory;
                    } else request['account-category'] = accountCategory;
                    const response = await this[method](this.extend(request, query));
                    //
                    // AccountCategoryGetOrderOpen
                    //
                    //     {
                    //         "ac": "CASH",
                    //         "accountId": "cshQtyfq8XLAA9kcf19h8bXHbAwwoqDo",
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "avgPx": "0",         // Average filled price of the order
                    //                 "cumFee": "0",       // cumulative fee paid for this order
                    //                 "cumFilledQty": "0", // cumulative filled quantity
                    //                 "errorCode": "",     // error code; could be empty
                    //                 "feeAsset": "USDT",  // fee asset
                    //                 "lastExecTime": 1576019723550, //  The last execution time of the order
                    //                 "orderId": "s16ef21882ea0866943712034f36d83", // server provided orderId
                    //                 "orderQty": "0.0083",  // order quantity
                    //                 "orderType": "Limit",  // order type
                    //                 "price": "7105",       // order price
                    //                 "seqNum": 8193258,     // sequence number
                    //                 "side": "Buy",         // order side
                    //                 "status": "New",       // order status on matching engine
                    //                 "stopPrice": "",       // only available for stop market and stop limit orders; otherwise empty
                    //                 "symbol": "BTC/USDT",
                    //                 "execInst": "NULL_VAL" // execution instruction
                    //             },
                    //         ]
                    //     }
                    //
                    // AccountGroupGetFuturesOrderOpen
                    //
                    // {
                    //     "code": 0,
                    //     "data": [
                    //         {
                    //             "ac": "FUTURES",
                    //             "accountId": "fut2ODPhGiY71Pl4vtXnOZ00ssgD7QGn",
                    //             "time": 1640247020217,
                    //             "orderId": "r17de65747aeU0711043490bbtcp0cmt",
                    //             "seqNum": 28796162908,
                    //             "orderType": "Limit",
                    //             "execInst": "NULL_VAL",
                    //             "side": "Buy",
                    //             "symbol": "BTC-PERP",
                    //             "price": "30000",
                    //             "orderQty": "0.0021",
                    //             "stopPrice": "0",
                    //             "stopBy": "market",
                    //             "status": "New",
                    //             "lastExecTime": 1640247020232,
                    //             "lastQty": "0",
                    //             "lastPx": "0",
                    //             "avgFilledPx": "0",
                    //             "cumFilledQty": "0",
                    //             "fee": "0",
                    //             "cumFee": "0",
                    //             "feeAsset": "USDT",
                    //             "errorCode": "",
                    //             "posStopLossPrice": "0",
                    //             "posStopLossTrigger": "market",
                    //             "posTakeProfitPrice": "0",
                    //             "posTakeProfitTrigger": "market",
                    //             "liquidityInd": "n"
                    //         }
                    //     ]
                    // }
                    //
                    const data = this.safeValue(response, 'data', []);
                    if (accountCategory === 'futures') return this.parseOrders(data, market, since, limit);
                    // a workaround for https://github.com/ccxt/ccxt/issues/7187
                    const orders = [];
                    for(let i = 0; i < data.length; i++){
                        const order = this.parseOrder(data[i], market);
                        orders.push(order);
                    }
                    return this.filterBySymbolSinceLimit(orders, symbol, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeValue(account, 'id');
                    const request = {
                        'account-group': accountGroup
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const [type, query] = this.handleMarketTypeAndParams('fetchCLosedOrders', market, params);
                    const options = this.safeValue(this.options, 'fetchClosedOrders', {});
                    const defaultMethod = this.safeString(options, 'method', 'v1PrivateAccountGroupGetOrderHist');
                    const method = this.getSupportedMapping(type, {
                        'spot': defaultMethod,
                        'margin': defaultMethod,
                        'swap': 'v2PrivateAccountGroupGetFuturesOrderHistCurrent'
                    });
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const accountCategory = this.safeString(accountsByType, type, 'cash');
                    if (method === 'v1PrivateAccountGroupGetOrderHist') {
                        if (accountCategory !== undefined) request['category'] = accountCategory;
                    } else request['account-category'] = accountCategory;
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['pageSize'] = limit;
                    const response = await this[method](this.extend(request, query));
                    //
                    // accountCategoryGetOrderHistCurrent
                    //
                    //     {
                    //         "code":0,
                    //         "accountId":"cshrHKLZCjlZ2ejqkmvIHHtPmLYqdnda",
                    //         "ac":"CASH",
                    //         "data":[
                    //             {
                    //                 "seqNum":15561826728,
                    //                 "orderId":"a17294d305c0U6491137460bethu7kw9",
                    //                 "symbol":"ETH/USDT",
                    //                 "orderType":"Limit",
                    //                 "lastExecTime":1591635618200,
                    //                 "price":"200",
                    //                 "orderQty":"0.1",
                    //                 "side":"Buy",
                    //                 "status":"Canceled",
                    //                 "avgPx":"0",
                    //                 "cumFilledQty":"0",
                    //                 "stopPrice":"",
                    //                 "errorCode":"",
                    //                 "cumFee":"0",
                    //                 "feeAsset":"USDT",
                    //                 "execInst":"NULL_VAL"
                    //             }
                    //         ]
                    //     }
                    //
                    // accountGroupGetOrderHist
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "data": [
                    //                 {
                    //                     "ac": "FUTURES",
                    //                     "accountId": "testabcdefg",
                    //                     "avgPx": "0",
                    //                     "cumFee": "0",
                    //                     "cumQty": "0",
                    //                     "errorCode": "NULL_VAL",
                    //                     "execInst": "NULL_VAL",
                    //                     "feeAsset": "USDT",
                    //                     "lastExecTime": 1584072844085,
                    //                     "orderId": "r170d21956dd5450276356bbtcpKa74",
                    //                     "orderQty": "1.1499",
                    //                     "orderType": "Limit",
                    //                     "price": "4000",
                    //                     "sendingTime": 1584072841033,
                    //                     "seqNum": 24105338,
                    //                     "side": "Buy",
                    //                     "status": "Canceled",
                    //                     "stopPrice": "",
                    //                     "symbol": "BTC-PERP"
                    //                 },
                    //             ],
                    //             "hasNext": False,
                    //             "limit": 500,
                    //             "page": 1,
                    //             "pageSize": 20
                    //         }
                    //     }
                    //
                    // accountGroupGetFuturesOrderHistCurrent
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "ac": "FUTURES",
                    //                 "accountId": "fut2ODPhGiY71Pl4vtXnOZ00ssgD7QGn",
                    //                 "time": 1640245777002,
                    //                 "orderId": "r17de6444fa6U0711043490bbtcpJ2lI",
                    //                 "seqNum": 28796124902,
                    //                 "orderType": "Limit",
                    //                 "execInst": "NULL_VAL",
                    //                 "side": "Buy",
                    //                 "symbol": "BTC-PERP",
                    //                 "price": "30000",
                    //                 "orderQty": "0.0021",
                    //                 "stopPrice": "0",
                    //                 "stopBy": "market",
                    //                 "status": "Canceled",
                    //                 "lastExecTime": 1640246574886,
                    //                 "lastQty": "0",
                    //                 "lastPx": "0",
                    //                 "avgFilledPx": "0",
                    //                 "cumFilledQty": "0",
                    //                 "fee": "0",
                    //                 "cumFee": "0",
                    //                 "feeAsset": "USDT",
                    //                 "errorCode": "",
                    //                 "posStopLossPrice": "0",
                    //                 "posStopLossTrigger": "market",
                    //                 "posTakeProfitPrice": "0",
                    //                 "posTakeProfitTrigger": "market",
                    //                 "liquidityInd": "n"
                    //             }
                    //         ]
                    //     }
                    //
                    let data = this.safeValue(response, 'data');
                    const isArray = Array.isArray(data);
                    if (!isArray) data = this.safeValue(data, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const market = this.market(symbol);
                    const [type, query] = this.handleMarketTypeAndParams('cancelOrder', market, params);
                    const options = this.safeValue(this.options, 'cancelOrder', {});
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const accountCategory = this.safeString(accountsByType, type, 'cash');
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeValue(account, 'id');
                    const request = {
                        'account-group': accountGroup,
                        'account-category': accountCategory,
                        'symbol': market['id'],
                        'time': this.milliseconds(),
                        'id': 'foobar'
                    };
                    const defaultMethod = this.safeString(options, 'method', 'v1PrivateAccountCategoryDeleteOrder');
                    const method = this.getSupportedMapping(type, {
                        'spot': defaultMethod,
                        'margin': defaultMethod,
                        'swap': 'v2PrivateAccountGroupDeleteFuturesOrder'
                    });
                    if (method === 'v1PrivateAccountCategoryDeleteOrder') {
                        if (accountCategory !== undefined) request['category'] = accountCategory;
                    } else request['account-category'] = accountCategory;
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'id');
                    if (clientOrderId === undefined) request['orderId'] = id;
                    else {
                        request['id'] = clientOrderId;
                        params = this.omit(params, [
                            'clientOrderId',
                            'id'
                        ]);
                    }
                    const response = await this[method](this.extend(request, query));
                    //
                    // AccountCategoryDeleteOrder
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "accountId": "cshQtyfq8XLAA9kcf19h8bXHbAwwoqDo",
                    //             "ac": "CASH",
                    //             "action": "cancel-order",
                    //             "status": "Ack",
                    //             "info": {
                    //                 "id":        "wv8QGquoeamhssvQBeHOHGQCGlcBjj23",
                    //                 "orderId":   "16e6198afb4s8bXHbAwwoqDo2ebc19dc",
                    //                 "orderType": "", // could be empty
                    //                 "symbol":    "ETH/USDT",
                    //                 "timestamp":  1573594877822
                    //             }
                    //         }
                    //     }
                    //
                    // AccountGroupDeleteFuturesOrder
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "meta": {
                    //                 "id": "foobar",
                    //                 "action": "cancel-order",
                    //                 "respInst": "ACK"
                    //             },
                    //             "order": {
                    //                 "ac": "FUTURES",
                    //                 "accountId": "fut2ODPhGiY71Pl4vtXnOZ00ssgD7QGn",
                    //                 "time": 1640244480476,
                    //                 "orderId": "r17de63086f4U0711043490bbtcpPUF4",
                    //                 "seqNum": 28795959269,
                    //                 "orderType": "Limit",
                    //                 "execInst": "NULL_VAL",
                    //                 "side": "Buy",
                    //                 "symbol": "BTC-PERP",
                    //                 "price": "30000",
                    //                 "orderQty": "0.0021",
                    //                 "stopPrice": "0",
                    //                 "stopBy": "market",
                    //                 "status": "New",
                    //                 "lastExecTime": 1640244480491,
                    //                 "lastQty": "0",
                    //                 "lastPx": "0",
                    //                 "avgFilledPx": "0",
                    //                 "cumFilledQty": "0",
                    //                 "fee": "0",
                    //                 "cumFee": "0",
                    //                 "feeAsset": "BTCPC",
                    //                 "errorCode": "",
                    //                 "posStopLossPrice": "0",
                    //                 "posStopLossTrigger": "market",
                    //                 "posTakeProfitPrice": "0",
                    //                 "posTakeProfitTrigger": "market",
                    //                 "liquidityInd": "n"
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const order = this.safeValue2(data, 'order', 'info', {});
                    return this.parseOrder(order, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const [type, query] = this.handleMarketTypeAndParams('cancelAllOrders', market, params);
                    const options = this.safeValue(this.options, 'cancelAllOrders', {});
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const accountCategory = this.safeString(accountsByType, type, 'cash');
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeValue(account, 'id');
                    const request = {
                        'account-group': accountGroup,
                        'account-category': accountCategory,
                        'time': this.milliseconds()
                    };
                    if (symbol !== undefined) request['symbol'] = market['id'];
                    const defaultMethod = this.safeString(options, 'method', 'v1PrivateAccountCategoryDeleteOrderAll');
                    const method = this.getSupportedMapping(type, {
                        'spot': defaultMethod,
                        'margin': defaultMethod,
                        'swap': 'v2PrivateAccountGroupDeleteFuturesOrderAll'
                    });
                    if (method === 'v1PrivateAccountCategoryDeleteOrderAll') {
                        if (accountCategory !== undefined) request['category'] = accountCategory;
                    } else request['account-category'] = accountCategory;
                    const response = await this[method](this.extend(request, query));
                    //
                    // AccountCategoryDeleteOrderAll
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "ac": "CASH",
                    //             "accountId": "cshQtyfq8XLAA9kcf19h8bXHbAwwoqDo",
                    //             "action": "cancel-all",
                    //             "info": {
                    //                 "id":  "2bmYvi7lyTrneMzpcJcf2D7Pe9V1P9wy",
                    //                 "orderId": "",
                    //                 "orderType": "NULL_VAL",
                    //                 "symbol": "",
                    //                 "timestamp": 1574118495462
                    //             },
                    //             "status": "Ack"
                    //         }
                    //     }
                    //
                    // AccountGroupDeleteFuturesOrderAll
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "ac": "FUTURES",
                    //             "accountId": "fut2ODPhGiY71Pl4vtXnOZ00ssgD7QGn",
                    //             "action": "cancel-all",
                    //             "info": {
                    //                 "symbol":"BTC-PERP"
                    //             }
                    //         }
                    //     }
                    //
                    return response;
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         address: "0xe7c70b4e73b6b450ee46c3b5c0f5fb127ca55722",
                    //         destTag: "",
                    //         tagType: "",
                    //         tagId: "",
                    //         chainName: "ERC20",
                    //         numConfirmations: 20,
                    //         withdrawalFee: 1,
                    //         nativeScale: 4,
                    //         tips: []
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'address');
                    const tagId = this.safeString(depositAddress, 'tagId');
                    const tag = this.safeString(depositAddress, tagId);
                    this.checkAddress(address);
                    const code = currency === undefined ? undefined : currency['code'];
                    const chainName = this.safeString(depositAddress, 'chainName');
                    const network = this.safeNetwork(chainName);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': network,
                        'info': depositAddress
                    };
                }
                safeNetwork(networkId) {
                    const networksById = {
                        'TRC20': 'TRC20',
                        'ERC20': 'ERC20',
                        'GO20': 'GO20',
                        'BEP2': 'BEP2',
                        'BEP20 (BSC)': 'BEP20',
                        'Bitcoin': 'BTC',
                        'Bitcoin ABC': 'BCH',
                        'Litecoin': 'LTC',
                        'Matic Network': 'MATIC',
                        'Solana': 'SOL',
                        'xDai': 'STAKE',
                        'Akash': 'AKT'
                    };
                    return this.safeString(networksById, networkId, networkId);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const chainName = this.safeString(params, 'chainName');
                    params = this.omit(params, 'chainName');
                    const request = {
                        'asset': currency['id']
                    };
                    const response = await this.v1PrivateGetWalletDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "data":{
                    //             "asset":"USDT",
                    //             "assetName":"Tether",
                    //             "address":[
                    //                 {
                    //                     "address":"1N22odLHXnLPCjC8kwBJPTayarr9RtPod6",
                    //                     "destTag":"",
                    //                     "tagType":"",
                    //                     "tagId":"",
                    //                     "chainName":"Omni",
                    //                     "numConfirmations":3,
                    //                     "withdrawalFee":4.7,
                    //                     "nativeScale":4,
                    //                     "tips":[]
                    //                 },
                    //                 {
                    //                     "address":"0xe7c70b4e73b6b450ee46c3b5c0f5fb127ca55722",
                    //                     "destTag":"",
                    //                     "tagType":"",
                    //                     "tagId":"",
                    //                     "chainName":"ERC20",
                    //                     "numConfirmations":20,
                    //                     "withdrawalFee":1.0,
                    //                     "nativeScale":4,
                    //                     "tips":[]
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const addresses = this.safeValue(data, 'address', []);
                    const numAddresses = addresses.length;
                    let address = undefined;
                    if (numAddresses > 1) {
                        const addressesByChainName = this.indexBy(addresses, 'chainName');
                        if (chainName === undefined) {
                            const chainNames = Object.keys(addressesByChainName);
                            const chains = chainNames.join(', ');
                            throw new ArgumentsRequired1(this.id + ' fetchDepositAddress() returned more than one address, a chainName parameter is required, one of ' + chains);
                        }
                        address = this.safeValue(addressesByChainName, chainName, {});
                    } else // first address
                    address = this.safeValue(addresses, 0, {});
                    const result = this.parseDepositAddress(address, currency);
                    return this.extend(result, {
                        'info': response
                    });
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    const request = {
                        'txType': 'deposit'
                    };
                    return await this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    const request = {
                        'txType': 'withdrawal'
                    };
                    return await this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['asset'] = currency['id'];
                    }
                    if (since !== undefined) request['startTs'] = since;
                    if (limit !== undefined) request['pageSize'] = limit;
                    const response = await this.v1PrivateGetWalletTransactions(this.extend(request, params));
                    //
                    //     {
                    //         code: 0,
                    //         data: {
                    //             data: [
                    //                 {
                    //                     requestId: "wuzd1Ojsqtz4bCA3UXwtUnnJDmU8PiyB",
                    //                     time: 1591606166000,
                    //                     asset: "USDT",
                    //                     transactionType: "deposit",
                    //                     amount: "25",
                    //                     commission: "0",
                    //                     networkTransactionId: "0xbc4eabdce92f14dbcc01d799a5f8ca1f02f4a3a804b6350ea202be4d3c738fce",
                    //                     status: "pending",
                    //                     numConfirmed: 8,
                    //                     numConfirmations: 20,
                    //                     destAddress: { address: "0xe7c70b4e73b6b450ee46c3b5c0f5fb127ca55722" }
                    //                 }
                    //             ],
                    //             page: 1,
                    //             pageSize: 20,
                    //             hasNext: false
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const transactions = this.safeValue(data, 'data', []);
                    return this.parseTransactions(transactions, currency, since, limit);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'reviewing': 'pending',
                        'pending': 'pending',
                        'confirmed': 'ok',
                        'rejected': 'rejected'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    //     {
                    //         requestId: "wuzd1Ojsqtz4bCA3UXwtUnnJDmU8PiyB",
                    //         time: 1591606166000,
                    //         asset: "USDT",
                    //         transactionType: "deposit",
                    //         amount: "25",
                    //         commission: "0",
                    //         networkTransactionId: "0xbc4eabdce92f14dbcc01d799a5f8ca1f02f4a3a804b6350ea202be4d3c738fce",
                    //         status: "pending",
                    //         numConfirmed: 8,
                    //         numConfirmations: 20,
                    //         destAddress: {
                    //             address: "0xe7c70b4e73b6b450ee46c3b5c0f5fb127ca55722",
                    //             destTag: "..." // for currencies that have it
                    //         }
                    //     }
                    //
                    const id = this.safeString(transaction, 'requestId');
                    const amount = this.safeNumber(transaction, 'amount');
                    const destAddress = this.safeValue(transaction, 'destAddress', {});
                    const address = this.safeString(destAddress, 'address');
                    const tag = this.safeString(destAddress, 'destTag');
                    const txid = this.safeString(transaction, 'networkTransactionId');
                    const type = this.safeString(transaction, 'transactionType');
                    const timestamp = this.safeInteger(transaction, 'time');
                    const currencyId = this.safeString(transaction, 'asset');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const feeCost = this.safeNumber(transaction, 'commission');
                    return {
                        'info': transaction,
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': undefined,
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'tagFrom': undefined,
                        'status': status,
                        'type': type,
                        'updated': undefined,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': {
                            'currency': code,
                            'cost': feeCost
                        }
                    };
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeString(account, 'id');
                    const request = {
                        'account-group': accountGroup
                    };
                    const response = await this.v2PrivateAccountGroupGetFuturesPosition(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "accountId": "fut2ODPhGiY71Pl4vtXnOZ00ssgD7QGn",
                    //             "ac": "FUTURES",
                    //             "collaterals": [
                    //                 {
                    //                     "asset": "USDT",
                    //                     "balance": "44.570287262",
                    //                     "referencePrice": "1",
                    //                     "discountFactor": "1"
                    //                 }
                    //             ],
                    //             "contracts": [
                    //                 {
                    //                     "symbol": "BTC-PERP",
                    //                     "side": "LONG",
                    //                     "position": "0.0001",
                    //                     "referenceCost": "-3.12277254",
                    //                     "unrealizedPnl": "-0.001700233",
                    //                     "realizedPnl": "0",
                    //                     "avgOpenPrice": "31209",
                    //                     "marginType": "isolated",
                    //                     "isolatedMargin": "1.654972977",
                    //                     "leverage": "2",
                    //                     "takeProfitPrice": "0",
                    //                     "takeProfitTrigger": "market",
                    //                     "stopLossPrice": "0",
                    //                     "stopLossTrigger": "market",
                    //                     "buyOpenOrderNotional": "0",
                    //                     "sellOpenOrderNotional": "0",
                    //                     "markPrice": "31210.723063672",
                    //                     "indexPrice": "31223.148857925"
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const position = this.safeValue(data, 'contracts', []);
                    const result = [];
                    for(let i = 0; i < position.length; i++)result.push(this.parsePosition(position[i]));
                    return this.filterByArray(result, 'symbol', symbols, false);
                }
                parsePosition(position, market) {
                    //
                    //     {
                    //         "symbol": "BTC-PERP",
                    //         "side": "LONG",
                    //         "position": "0.0001",
                    //         "referenceCost": "-3.12277254",
                    //         "unrealizedPnl": "-0.001700233",
                    //         "realizedPnl": "0",
                    //         "avgOpenPrice": "31209",
                    //         "marginType": "isolated",
                    //         "isolatedMargin": "1.654972977",
                    //         "leverage": "2",
                    //         "takeProfitPrice": "0",
                    //         "takeProfitTrigger": "market",
                    //         "stopLossPrice": "0",
                    //         "stopLossTrigger": "market",
                    //         "buyOpenOrderNotional": "0",
                    //         "sellOpenOrderNotional": "0",
                    //         "markPrice": "31210.723063672",
                    //         "indexPrice": "31223.148857925"
                    //     },
                    //
                    const marketId = this.safeString(position, 'symbol');
                    market = this.safeMarket(marketId, market);
                    let notional = this.safeNumber(position, 'buyOpenOrderNotional');
                    if (notional === 0) notional = this.safeNumber(position, 'sellOpenOrderNotional');
                    const marginMode = this.safeString(position, 'marginType');
                    let collateral = undefined;
                    if (marginMode === 'isolated') collateral = this.safeNumber(position, 'isolatedMargin');
                    return {
                        'info': position,
                        'id': undefined,
                        'symbol': market['symbol'],
                        'notional': notional,
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'liquidationPrice': undefined,
                        'entryPrice': this.safeNumber(position, 'avgOpenPrice'),
                        'unrealizedPnl': this.safeNumber(position, 'unrealizedPnl'),
                        'percentage': undefined,
                        'contracts': undefined,
                        'contractSize': this.safeNumber(position, 'position'),
                        'markPrice': this.safeNumber(position, 'markPrice'),
                        'side': this.safeStringLower(position, 'side'),
                        'hedged': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'maintenanceMargin': undefined,
                        'maintenanceMarginPercentage': undefined,
                        'collateral': collateral,
                        'initialMargin': undefined,
                        'initialMarginPercentage': undefined,
                        'leverage': this.safeInteger(position, 'leverage'),
                        'marginRatio': undefined
                    };
                }
                parseFundingRate(fundingRate, market) {
                    //
                    //      {
                    //          "time": 1640061364830,
                    //          "symbol": "EOS-PERP",
                    //          "markPrice": "3.353854865",
                    //          "indexPrice": "3.3542",
                    //          "openInterest": "14242",
                    //          "fundingRate": "-0.000073026",
                    //          "nextFundingTime": 1640073600000
                    //      }
                    //
                    const marketId = this.safeString(fundingRate, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const currentTime = this.safeInteger(fundingRate, 'time');
                    const nextFundingRate = this.safeNumber(fundingRate, 'fundingRate');
                    const nextFundingRateTimestamp = this.safeInteger(fundingRate, 'nextFundingTime');
                    const previousFundingTimestamp = undefined;
                    return {
                        'info': fundingRate,
                        'symbol': symbol,
                        'markPrice': this.safeNumber(fundingRate, 'markPrice'),
                        'indexPrice': this.safeNumber(fundingRate, 'indexPrice'),
                        'interestRate': this.parseNumber('0'),
                        'estimatedSettlePrice': undefined,
                        'timestamp': currentTime,
                        'datetime': this.iso8601(currentTime),
                        'previousFundingRate': undefined,
                        'nextFundingRate': nextFundingRate,
                        'previousFundingTimestamp': previousFundingTimestamp,
                        'nextFundingTimestamp': nextFundingRateTimestamp,
                        'previousFundingDatetime': this.iso8601(previousFundingTimestamp),
                        'nextFundingDatetime': this.iso8601(nextFundingRateTimestamp)
                    };
                }
                async fetchFundingRates(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.v2PublicGetFuturesPricingData(params);
                    //
                    //     {
                    //          "code": 0,
                    //          "data": {
                    //              "contracts": [
                    //                  {
                    //                      "time": 1640061364830,
                    //                      "symbol": "EOS-PERP",
                    //                      "markPrice": "3.353854865",
                    //                      "indexPrice": "3.3542",
                    //                      "openInterest": "14242",
                    //                      "fundingRate": "-0.000073026",
                    //                      "nextFundingTime": 1640073600000
                    //                  },
                    //              ],
                    //              "collaterals": [
                    //                  {
                    //                      "asset": "USDTR",
                    //                      "referencePrice": "1"
                    //                  },
                    //              ]
                    //          }
                    //      }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const contracts = this.safeValue(data, 'contracts', []);
                    const result = this.parseFundingRates(contracts);
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async modifyMarginHelper(symbol, amount, type, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const market = this.market(symbol);
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeString(account, 'id');
                    amount = this.amountToPrecision(symbol, amount);
                    const request = {
                        'account-group': accountGroup,
                        'symbol': market['id'],
                        'amount': amount
                    };
                    const response = await this.v2PrivateAccountGroupPostFuturesIsolatedPositionMargin(this.extend(request, params));
                    //
                    // Can only change margin for perpetual futures isolated margin positions
                    //
                    //     {
                    //          "code": 0
                    //     }
                    //
                    if (type === 'reduce') amount = Precise.stringAbs(amount);
                    return this.extend(this.parseModifyMargin(response, market), {
                        'amount': this.parseNumber(amount),
                        'type': type
                    });
                }
                parseModifyMargin(data, market) {
                    const errorCode = this.safeString(data, 'code');
                    const status = errorCode === '0' ? 'ok' : 'failed';
                    return {
                        'info': data,
                        'type': undefined,
                        'amount': undefined,
                        'code': market['quote'],
                        'symbol': market['symbol'],
                        'status': status
                    };
                }
                async reduceMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 'reduce', params);
                }
                async addMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 'add', params);
                }
                async setLeverage(leverage, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    if (leverage < 1 || leverage > 100) throw new BadRequest(this.id + ' leverage should be between 1 and 100');
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const market = this.market(symbol);
                    if (market['type'] !== 'future') throw new BadSymbol(this.id + ' setLeverage() supports futures contracts only');
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeString(account, 'id');
                    const request = {
                        'account-group': accountGroup,
                        'symbol': market['id'],
                        'leverage': leverage
                    };
                    return await this.v2PrivateAccountGroupPostFuturesLeverage(this.extend(request, params));
                }
                async setMarginMode(marginMode, symbol, params = {}) {
                    marginMode = marginMode.toLowerCase();
                    if (marginMode === 'cross') marginMode = 'crossed';
                    if (marginMode !== 'isolated' && marginMode !== 'crossed') throw new BadRequest(this.id + ' setMarginMode() marginMode argument should be isolated or cross');
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const market = this.market(symbol);
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeString(account, 'id');
                    const request = {
                        'account-group': accountGroup,
                        'symbol': market['id'],
                        'marginMode': marginMode
                    };
                    if (market['type'] !== 'future') throw new BadSymbol(this.id + ' setMarginMode() supports futures contracts only');
                    return await this.v2PrivateAccountGroupPostFuturesMarginType(this.extend(request, params));
                }
                async fetchLeverageTiers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.v2PublicGetFuturesContract(params);
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "symbol":"BTC-PERP",
                    //                 "status":"Normal",
                    //                 "displayName":"BTCUSDT",
                    //                 "settlementAsset":"USDT",
                    //                 "underlying":"BTC/USDT",
                    //                 "tradingStartTime":1579701600000,
                    //                 "priceFilter":{"minPrice":"1","maxPrice":"1000000","tickSize":"1"},
                    //                 "lotSizeFilter":{"minQty":"0.0001","maxQty":"1000000000","lotSize":"0.0001"},
                    //                 "commissionType":"Quote",
                    //                 "commissionReserveRate":"0.001",
                    //                 "marketOrderPriceMarkup":"0.03",
                    //                 "marginRequirements":[
                    //                     {"positionNotionalLowerBound":"0","positionNotionalUpperBound":"50000","initialMarginRate":"0.01","maintenanceMarginRate":"0.006"},
                    //                     {"positionNotionalLowerBound":"50000","positionNotionalUpperBound":"200000","initialMarginRate":"0.02","maintenanceMarginRate":"0.012"},
                    //                     {"positionNotionalLowerBound":"200000","positionNotionalUpperBound":"2000000","initialMarginRate":"0.04","maintenanceMarginRate":"0.024"},
                    //                     {"positionNotionalLowerBound":"2000000","positionNotionalUpperBound":"20000000","initialMarginRate":"0.1","maintenanceMarginRate":"0.06"},
                    //                     {"positionNotionalLowerBound":"20000000","positionNotionalUpperBound":"40000000","initialMarginRate":"0.2","maintenanceMarginRate":"0.12"},
                    //                     {"positionNotionalLowerBound":"40000000","positionNotionalUpperBound":"1000000000","initialMarginRate":"0.333333","maintenanceMarginRate":"0.2"}
                    //                 ]
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseLeverageTiers(data, symbols, 'symbol');
                }
                parseMarketLeverageTiers(info, market) {
                    /**
         * @param {dict} info Exchange market response for 1 market
         * @param {dict} market CCXT market
         */ //
                    //    {
                    //        "symbol":"BTC-PERP",
                    //        "status":"Normal",
                    //        "displayName":"BTCUSDT",
                    //        "settlementAsset":"USDT",
                    //        "underlying":"BTC/USDT",
                    //        "tradingStartTime":1579701600000,
                    //        "priceFilter":{"minPrice":"1","maxPrice":"1000000","tickSize":"1"},
                    //        "lotSizeFilter":{"minQty":"0.0001","maxQty":"1000000000","lotSize":"0.0001"},
                    //        "commissionType":"Quote",
                    //        "commissionReserveRate":"0.001",
                    //        "marketOrderPriceMarkup":"0.03",
                    //        "marginRequirements":[
                    //            {"positionNotionalLowerBound":"0","positionNotionalUpperBound":"50000","initialMarginRate":"0.01","maintenanceMarginRate":"0.006"},
                    //            {"positionNotionalLowerBound":"50000","positionNotionalUpperBound":"200000","initialMarginRate":"0.02","maintenanceMarginRate":"0.012"},
                    //            {"positionNotionalLowerBound":"200000","positionNotionalUpperBound":"2000000","initialMarginRate":"0.04","maintenanceMarginRate":"0.024"},
                    //            {"positionNotionalLowerBound":"2000000","positionNotionalUpperBound":"20000000","initialMarginRate":"0.1","maintenanceMarginRate":"0.06"},
                    //            {"positionNotionalLowerBound":"20000000","positionNotionalUpperBound":"40000000","initialMarginRate":"0.2","maintenanceMarginRate":"0.12"},
                    //            {"positionNotionalLowerBound":"40000000","positionNotionalUpperBound":"1000000000","initialMarginRate":"0.333333","maintenanceMarginRate":"0.2"}
                    //        ]
                    //    }
                    //
                    const marginRequirements = this.safeValue(info, 'marginRequirements');
                    const id = this.safeString(info, 'symbol');
                    market = this.safeMarket(id, market);
                    const tiers = [];
                    for(let i = 0; i < marginRequirements.length; i++){
                        const tier = marginRequirements[i];
                        const initialMarginRate = this.safeString(tier, 'initialMarginRate');
                        tiers.push({
                            'tier': this.sum(i, 1),
                            'currency': market['quote'],
                            'minNotional': this.safeNumber(tier, 'positionNotionalLowerBound'),
                            'maxNotional': this.safeNumber(tier, 'positionNotionalUpperBound'),
                            'maintenanceMarginRate': this.safeNumber(tier, 'maintenanceMarginRate'),
                            'maxLeverage': this.parseNumber(Precise.stringDiv('1', initialMarginRate)),
                            'info': tier
                        });
                    }
                    return tiers;
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const account = this.safeValue(this.accounts, 0, {});
                    const accountGroup = this.safeString(account, 'id');
                    const currency = this.currency(code);
                    amount = this.currencyToPrecision(code, amount);
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                    const toId = this.safeString(accountsByType, toAccount, toAccount);
                    if (fromId !== 'cash' && toId !== 'cash') throw new ExchangeError1(this.id + ' transfer() only supports direct balance transfer between spot and future, spot and margin');
                    const request = {
                        'account-group': accountGroup,
                        'amount': amount,
                        'asset': currency['id'],
                        'fromAccount': fromId,
                        'toAccount': toId
                    };
                    const response = await this.v1PrivateAccountGroupPostTransfer(this.extend(request, params));
                    //
                    //    { code: '0' }
                    //
                    const transferOptions = this.safeValue(this.options, 'transfer', {});
                    const fillResponseFromRequest = this.safeValue(transferOptions, 'fillResponseFromRequest', true);
                    const transfer = this.parseTransfer(response, currency);
                    if (fillResponseFromRequest) {
                        transfer['fromAccount'] = fromAccount;
                        transfer['toAccount'] = toAccount;
                        transfer['amount'] = amount;
                        transfer['currency'] = code;
                    }
                    return transfer;
                }
                parseTransfer(transfer, currency) {
                    //
                    //    { code: '0' }
                    //
                    const status = this.safeInteger(transfer, 'code');
                    const currencyCode = this.safeCurrencyCode(undefined, currency);
                    const timestamp = this.milliseconds();
                    return {
                        'info': transfer,
                        'id': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': currencyCode,
                        'amount': undefined,
                        'fromAccount': undefined,
                        'toAccount': undefined,
                        'status': this.parseTransferStatus(status)
                    };
                }
                parseTransferStatus(status) {
                    if (status === 0) return 'ok';
                    return 'failed';
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const version = api[0];
                    const access = api[1];
                    const type = this.safeString(api, 2);
                    let url = '';
                    const accountCategory = type === 'accountCategory';
                    if (accountCategory || type === 'accountGroup') {
                        url += this.implodeParams('/{account-group}', params);
                        params = this.omit(params, 'account-group');
                    }
                    let request = this.implodeParams(path, params);
                    url += '/api/pro/';
                    if (version === 'v2') request = version + '/' + request;
                    else url += version + '/';
                    if (accountCategory) url += this.implodeParams('{account-category}/', params);
                    params = this.omit(params, 'account-category');
                    url += request;
                    if (version === 'v1' && request === 'cash/balance' || request === 'margin/balance') request = 'balance';
                    if (version === 'v1' && request === 'spot/fee') request = 'fee';
                    if (request.indexOf('subuser') >= 0) {
                        const parts = request.split('/');
                        request = parts[2];
                    }
                    params = this.omit(params, this.extractParams(path));
                    if (access === 'public') {
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    } else {
                        this.checkRequiredCredentials();
                        const timestamp = this.milliseconds().toString();
                        const payload = timestamp + '+' + request;
                        const hmac = this.hmac(this.encode(payload), this.encode(this.secret), 'sha256', 'base64');
                        headers = {
                            'x-auth-key': this.apiKey,
                            'x-auth-timestamp': timestamp,
                            'x-auth-signature': hmac
                        };
                        if (method === 'GET') {
                            if (Object.keys(params).length) url += '?' + this.urlencode(params);
                        } else {
                            headers['Content-Type'] = 'application/json';
                            body = this.json(params);
                        }
                    }
                    url = this.urls['api']['rest'] + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //     {'code': 6010, 'message': 'Not enough balance.'}
                    //     {'code': 60060, 'message': 'The order is already filled or canceled.'}
                    //     {"code":2100,"message":"ApiKeyFailure"}
                    //     {"code":300001,"message":"Price is too low from market price.","reason":"INVALID_PRICE","accountId":"cshrHKLZCjlZ2ejqkmvIHHtPmLYqdnda","ac":"CASH","action":"place-order","status":"Err","info":{"symbol":"BTC/USDT"}}
                    //
                    const code = this.safeString(response, 'code');
                    const message = this.safeString(response, 'message');
                    const error = code !== undefined && code !== '0';
                    if (error || message !== undefined) {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    5: [
        function(require1, module, exports) {
            "use strict";
            // ----------------------------------------------------------------------------
            const functions = require1('./functions');
            const { isNode: isNode, keys: keys, values: values, deepExtend: deepExtend, extend: extend, clone: clone, flatten: flatten, unique: unique, indexBy: indexBy, sortBy: sortBy, sortBy2: sortBy2, groupBy: groupBy, aggregate: aggregate, uuid: uuid, unCamelCase: unCamelCase, precisionFromString: precisionFromString, throttle: throttle, capitalize: capitalize, now: now, timeout: timeout, TimedOut: TimedOut, buildOHLCVC: buildOHLCVC, decimalToPrecision: decimalToPrecision, defaultFetch: defaultFetch } = functions;
            const { ExchangeError: ExchangeError1, BadSymbol: BadSymbol, InvalidAddress: InvalidAddress, InvalidOrder: InvalidOrder, NotSupported: NotSupported, AuthenticationError: AuthenticationError, DDoSProtection: DDoSProtection, RequestTimeout: RequestTimeout, ExchangeNotAvailable: ExchangeNotAvailable, RateLimitExceeded: RateLimitExceeded } = require1('./errors');
            const { TRUNCATE: TRUNCATE, ROUND: ROUND, DECIMAL_PLACES: DECIMAL_PLACES, NO_PADDING: NO_PADDING } = functions.precisionConstants;
            const BN = require1('../static_dependencies/BN/bn');
            const Precise = require1('./Precise');
            // ----------------------------------------------------------------------------
            module.exports = class Exchange {
                describe() {
                    return {
                        'id': undefined,
                        'name': undefined,
                        'countries': undefined,
                        'enableRateLimit': true,
                        'rateLimit': 2000,
                        'certified': false,
                        'pro': false,
                        'alias': false,
                        'has': {
                            'publicAPI': true,
                            'privateAPI': true,
                            'CORS': undefined,
                            'spot': undefined,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'addMargin': undefined,
                            'cancelAllOrders': undefined,
                            'cancelOrder': true,
                            'cancelOrders': undefined,
                            'createDepositAddress': undefined,
                            'createLimitOrder': true,
                            'createMarketOrder': true,
                            'createOrder': true,
                            'createPostOnlyOrder': undefined,
                            'createStopOrder': undefined,
                            'createStopLimitOrder': undefined,
                            'createStopMarketOrder': undefined,
                            'editOrder': 'emulated',
                            'fetchAccounts': undefined,
                            'fetchBalance': true,
                            'fetchBidsAsks': undefined,
                            'fetchBorrowInterest': undefined,
                            'fetchBorrowRate': undefined,
                            'fetchBorrowRateHistory': undefined,
                            'fetchBorrowRatesPerSymbol': undefined,
                            'fetchBorrowRates': undefined,
                            'fetchCanceledOrders': undefined,
                            'fetchClosedOrder': undefined,
                            'fetchClosedOrders': undefined,
                            'fetchCurrencies': 'emulated',
                            'fetchDeposit': undefined,
                            'fetchDepositAddress': undefined,
                            'fetchDepositAddresses': undefined,
                            'fetchDepositAddressesByNetwork': undefined,
                            'fetchDeposits': undefined,
                            'fetchFundingFee': undefined,
                            'fetchFundingFees': undefined,
                            'fetchFundingHistory': undefined,
                            'fetchFundingRate': undefined,
                            'fetchFundingRateHistory': undefined,
                            'fetchFundingRates': undefined,
                            'fetchIndexOHLCV': undefined,
                            'fetchL2OrderBook': true,
                            'fetchLedger': undefined,
                            'fetchLedgerEntry': undefined,
                            'fetchLeverageTiers': undefined,
                            'fetchMarketLeverageTiers': undefined,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': undefined,
                            'fetchMyTrades': undefined,
                            'fetchOHLCV': 'emulated',
                            'fetchOpenOrder': undefined,
                            'fetchOpenOrders': undefined,
                            'fetchOrder': undefined,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': undefined,
                            'fetchOrders': undefined,
                            'fetchOrderTrades': undefined,
                            'fetchPermissions': undefined,
                            'fetchPosition': undefined,
                            'fetchPositions': undefined,
                            'fetchPositionsRisk': undefined,
                            'fetchPremiumIndexOHLCV': undefined,
                            'fetchStatus': 'emulated',
                            'fetchTicker': true,
                            'fetchTickers': undefined,
                            'fetchTime': undefined,
                            'fetchTrades': true,
                            'fetchTradingFee': undefined,
                            'fetchTradingFees': undefined,
                            'fetchTradingLimits': undefined,
                            'fetchTransactions': undefined,
                            'fetchTransfers': undefined,
                            'fetchWithdrawal': undefined,
                            'fetchWithdrawals': undefined,
                            'loadMarkets': true,
                            'reduceMargin': undefined,
                            'setLeverage': undefined,
                            'setMarginMode': undefined,
                            'setPositionMode': undefined,
                            'signIn': undefined,
                            'transfer': undefined,
                            'withdraw': undefined
                        },
                        'urls': {
                            'logo': undefined,
                            'api': undefined,
                            'www': undefined,
                            'doc': undefined,
                            'fees': undefined
                        },
                        'api': undefined,
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'uid': false,
                            'login': false,
                            'password': false,
                            'twofa': false,
                            'privateKey': false,
                            'walletAddress': false,
                            'token': false
                        },
                        'markets': undefined,
                        'currencies': {},
                        'timeframes': undefined,
                        'fees': {
                            'trading': {
                                'tierBased': undefined,
                                'percentage': undefined,
                                'taker': undefined,
                                'maker': undefined
                            },
                            'funding': {
                                'tierBased': undefined,
                                'percentage': undefined,
                                'withdraw': {},
                                'deposit': {}
                            }
                        },
                        'status': {
                            'status': 'ok',
                            'updated': undefined,
                            'eta': undefined,
                            'url': undefined
                        },
                        'exceptions': undefined,
                        'httpExceptions': {
                            '422': ExchangeError1,
                            '418': DDoSProtection,
                            '429': RateLimitExceeded,
                            '404': ExchangeNotAvailable,
                            '409': ExchangeNotAvailable,
                            '410': ExchangeNotAvailable,
                            '500': ExchangeNotAvailable,
                            '501': ExchangeNotAvailable,
                            '502': ExchangeNotAvailable,
                            '520': ExchangeNotAvailable,
                            '521': ExchangeNotAvailable,
                            '522': ExchangeNotAvailable,
                            '525': ExchangeNotAvailable,
                            '526': ExchangeNotAvailable,
                            '400': ExchangeNotAvailable,
                            '403': ExchangeNotAvailable,
                            '405': ExchangeNotAvailable,
                            '503': ExchangeNotAvailable,
                            '530': ExchangeNotAvailable,
                            '408': RequestTimeout,
                            '504': RequestTimeout,
                            '401': AuthenticationError,
                            '511': AuthenticationError
                        },
                        'commonCurrencies': {
                            'XBT': 'BTC',
                            'BCC': 'BCH',
                            'BCHABC': 'BCH',
                            'BCHSV': 'BSV'
                        },
                        'precisionMode': DECIMAL_PLACES,
                        'paddingMode': NO_PADDING,
                        'limits': {
                            'leverage': {
                                'min': undefined,
                                'max': undefined
                            },
                            'amount': {
                                'min': undefined,
                                'max': undefined
                            },
                            'price': {
                                'min': undefined,
                                'max': undefined
                            },
                            'cost': {
                                'min': undefined,
                                'max': undefined
                            }
                        }
                    } // return
                    ;
                }
                constructor(userConfig = {}){
                    Object.assign(this, functions);
                    // if (isNode) {
                    //     this.nodeVersion = process.version.match (/\d+\.\d+\.\d+/)[0]
                    //     this.userAgent = {
                    //         'User-Agent': 'ccxt/' + Exchange.ccxtVersion +
                    //             ' (+https://github.com/ccxt/ccxt)' +
                    //             ' Node.js/' + this.nodeVersion + ' (JavaScript)'
                    //     }
                    // }
                    this.options = {} // exchange-specific options, if any
                    ;
                    // fetch implementation options (JS only)
                    this.fetchOptions = {
                    };
                    this.userAgents = {
                        'chrome': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/62.0.3202.94 Safari/537.36',
                        'chrome39': 'Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36',
                        'chrome100': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.75 Safari/537.36'
                    };
                    this.headers = {};
                    // prepended to URL, like https://proxy.com/https://exchange.com/api...
                    this.proxy = '';
                    this.origin = '*' // CORS origin
                    ;
                    this.minFundingAddressLength = 1 // used in checkAddress
                    ;
                    this.substituteCommonCurrencyCodes = true // reserved
                    ;
                    this.quoteJsonNumbers = true // treat numbers in json as quoted precise strings
                    ;
                    this.number = Number // or String (a pointer to a function)
                    ;
                    this.handleContentTypeApplicationZip = false;
                    // whether fees should be summed by currency code
                    this.reduceFees = true;
                    // do not delete this line, it is needed for users to be able to define their own fetchImplementation
                    this.fetchImplementation = defaultFetch;
                    this.validateServerSsl = true;
                    this.validateClientSsl = false;
                    this.timeout = 10000 // milliseconds
                    ;
                    this.verbose = false;
                    this.debug = false;
                    this.userAgent = undefined;
                    this.twofa = undefined // two-factor authentication (2FA)
                    ;
                    this.apiKey = undefined;
                    this.secret = undefined;
                    this.uid = undefined;
                    this.login = undefined;
                    this.password = undefined;
                    this.privateKey = undefined // a "0x"-prefixed hexstring private key for a wallet
                    ;
                    this.walletAddress = undefined // a wallet address "0x"-prefixed hexstring
                    ;
                    this.token = undefined // reserved for HTTP auth in some cases
                    ;
                    this.balance = {};
                    this.orderbooks = {};
                    this.tickers = {};
                    this.orders = undefined;
                    this.trades = {};
                    this.transactions = {};
                    this.ohlcvs = {};
                    this.myTrades = undefined;
                    this.positions = {};
                    this.requiresWeb3 = false;
                    this.requiresEddsa = false;
                    this.precision = {};
                    this.enableLastJsonResponse = true;
                    this.enableLastHttpResponse = true;
                    this.enableLastResponseHeaders = true;
                    this.last_http_response = undefined;
                    this.last_json_response = undefined;
                    this.last_response_headers = undefined;
                    const unCamelCaseProperties = (obj = this)=>{
                        if (obj !== null) {
                            const ownPropertyNames = Object.getOwnPropertyNames(obj);
                            for(let i = 0; i < ownPropertyNames.length; i++){
                                const k = ownPropertyNames[i];
                                this[unCamelCase(k)] = this[k];
                            }
                            unCamelCaseProperties(Object.getPrototypeOf(obj));
                        }
                    };
                    unCamelCaseProperties();
                    // merge to this
                    const configEntries = Object.entries(this.describe()).concat(Object.entries(userConfig));
                    for(let i = 0; i < configEntries.length; i++){
                        const [property, value] = configEntries[i];
                        if (value && Object.getPrototypeOf(value) === Object.prototype) this[property] = deepExtend(this[property], value);
                        else this[property] = value;
                    }
                    const agentOptions = {
                        'keepAlive': true
                    };
                    if (!this.validateServerSsl) agentOptions['rejectUnauthorized'] = false;
                    if (!this.httpAgent && defaultFetch.http && isNode) this.httpAgent = new defaultFetch.http.Agent(agentOptions);
                    if (!this.httpsAgent && defaultFetch.https && isNode) this.httpsAgent = new defaultFetch.https.Agent(agentOptions);
                    // generate old metainfo interface
                    const hasKeys = Object.keys(this.has);
                    for(let i = 0; i < hasKeys.length; i++){
                        const k = hasKeys[i];
                        this['has' + capitalize(k)] = !!this.has[k] // converts 'emulated' to true
                        ;
                    }
                    if (this.api) this.defineRestApi(this.api, 'request');
                    this.initRestRateLimiter();
                    if (this.markets) this.setMarkets(this.markets);
                }
                defaults() {
                    return {};
                }
                nonce() {
                    return this.seconds();
                }
                encodeURIComponent(...args) {
                    return encodeURIComponent(...args);
                }
                checkRequiredVersion(requiredVersion, error = true) {
                    let result = true;
                    const [major1, minor1, patch1] = requiredVersion.split('.'), [major2, minor2, patch2] = Exchange.ccxtVersion.split('.'), intMajor1 = parseInt(major1), intMinor1 = parseInt(minor1), intPatch1 = parseInt(patch1), intMajor2 = parseInt(major2), intMinor2 = parseInt(minor2), intPatch2 = parseInt(patch2);
                    if (intMajor1 > intMajor2) result = false;
                    if (intMajor1 === intMajor2) {
                        if (intMinor1 > intMinor2) result = false;
                        else if (intMinor1 === intMinor2 && intPatch1 > intPatch2) result = false;
                    }
                    if (!result) {
                        if (error) throw new NotSupported('Your current version of CCXT is ' + Exchange.ccxtVersion + ', a newer version ' + requiredVersion + ' is required, please, upgrade your version of CCXT');
                        else return error;
                    }
                    return result;
                }
                checkRequiredCredentials(error = true) {
                    const keys = Object.keys(this.requiredCredentials);
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        if (this.requiredCredentials[key] && !this[key]) {
                            if (error) throw new AuthenticationError(this.id + ' requires `' + key + '` credential');
                            else return error;
                        }
                    }
                    return true;
                }
                checkAddress(address) {
                    if (address === undefined) throw new InvalidAddress(this.id + ' address is undefined');
                    // check the address is not the same letter like 'aaaaa' nor too short nor has a space
                    if (unique(address).length === 1 || address.length < this.minFundingAddressLength || address.includes(' ')) throw new InvalidAddress(this.id + ' address is invalid or has less than ' + this.minFundingAddressLength.toString() + ' characters: "' + this.json(address) + '"');
                    return address;
                }
                initRestRateLimiter() {
                    if (this.rateLimit === undefined) throw new Error(this.id + '.rateLimit property is not configured');
                    this.tokenBucket = this.extend({
                        delay: 0.001,
                        capacity: 1,
                        cost: 1,
                        maxCapacity: 1000,
                        refillRate: this.rateLimit > 0 ? 1 / this.rateLimit : Number.MAX_VALUE
                    }, this.tokenBucket);
                    this.throttle = throttle(this.tokenBucket);
                    this.executeRestRequest = (url, method = 'GET', headers, body)=>{
                        // fetchImplementation cannot be called on this. in browsers:
                        // TypeError Failed to execute 'fetch' on 'Window': Illegal invocation
                        const fetchImplementation = this.fetchImplementation;
                        const params = {
                            method: method,
                            headers: headers,
                            body: body,
                            timeout: this.timeout
                        };
                        if (this.agent) params['agent'] = this.agent;
                        else if (this.httpAgent && url.indexOf('http://') === 0) params['agent'] = this.httpAgent;
                        else if (this.httpsAgent && url.indexOf('https://') === 0) params['agent'] = this.httpsAgent;
                        const promise = fetchImplementation(url, this.extend(params, this.fetchOptions)).catch((e)=>{
                            if (isNode) throw new ExchangeNotAvailable([
                                this.id,
                                method,
                                url,
                                e.type,
                                e.message
                            ].join(' '));
                            throw e // rethrow all unknown errors
                            ;
                        }).then((response)=>this.handleRestResponse(response, url, method, headers, body));
                        return timeout(this.timeout, promise).catch((e)=>{
                            if (e instanceof TimedOut) throw new RequestTimeout(this.id + ' ' + method + ' ' + url + ' request timed out (' + this.timeout + ' ms)');
                            throw e;
                        });
                    };
                }
                setSandboxMode(enabled) {
                    if (!!enabled) {
                        if ('test' in this.urls) {
                            if (typeof this.urls['api'] === 'string') {
                                this.urls['apiBackup'] = this.urls['api'];
                                this.urls['api'] = this.urls['test'];
                            } else {
                                this.urls['apiBackup'] = clone(this.urls['api']);
                                this.urls['api'] = clone(this.urls['test']);
                            }
                        } else throw new NotSupported(this.id + ' does not have a sandbox URL');
                    } else if ('apiBackup' in this.urls) {
                        if (typeof this.urls['api'] === 'string') this.urls['api'] = this.urls['apiBackup'];
                        else this.urls['api'] = clone(this.urls['apiBackup']);
                    }
                }
                defineRestApiEndpoint(methodName, uppercaseMethod, lowercaseMethod, camelcaseMethod, path, paths, config = {}) {
                    const splitPath = path.split(/[^a-zA-Z0-9]/);
                    const camelcaseSuffix = splitPath.map(this.capitalize).join('');
                    const underscoreSuffix = splitPath.map((x)=>x.trim().toLowerCase()).filter((x)=>x.length > 0).join('_');
                    const camelcasePrefix = [
                        paths[0]
                    ].concat(paths.slice(1).map(this.capitalize)).join('');
                    const underscorePrefix = [
                        paths[0]
                    ].concat(paths.slice(1).map((x)=>x.trim()).filter((x)=>x.length > 0)).join('_');
                    const camelcase = camelcasePrefix + camelcaseMethod + this.capitalize(camelcaseSuffix);
                    const underscore = underscorePrefix + '_' + lowercaseMethod + '_' + underscoreSuffix;
                    const typeArgument = paths.length > 1 ? paths : paths[0];
                    // handle call costs here
                    const partial = async (params = {}, context = {})=>this[methodName](path, typeArgument, uppercaseMethod, params, undefined, undefined, config, context);
                    // const partial = async (params) => this[methodName] (path, typeArgument, uppercaseMethod, params || {})
                    this[camelcase] = partial;
                    this[underscore] = partial;
                }
                defineRestApi(api, methodName, paths = []) {
                    const keys = Object.keys(api);
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        const value = api[key];
                        const uppercaseMethod = key.toUpperCase();
                        const lowercaseMethod = key.toLowerCase();
                        const camelcaseMethod = this.capitalize(lowercaseMethod);
                        if (Array.isArray(value)) for(let k = 0; k < value.length; k++){
                            const path = value[k].trim();
                            this.defineRestApiEndpoint(methodName, uppercaseMethod, lowercaseMethod, camelcaseMethod, path, paths);
                        }
                        else if (key.match(/^(?:get|post|put|delete|head|patch)$/i)) {
                            const endpoints = Object.keys(value);
                            for(let j = 0; j < endpoints.length; j++){
                                const endpoint = endpoints[j];
                                const path = endpoint.trim();
                                const config = value[endpoint];
                                if (typeof config === 'object') this.defineRestApiEndpoint(methodName, uppercaseMethod, lowercaseMethod, camelcaseMethod, path, paths, config);
                                else if (typeof config === 'number') this.defineRestApiEndpoint(methodName, uppercaseMethod, lowercaseMethod, camelcaseMethod, path, paths, {
                                    cost: config
                                });
                                else throw new NotSupported(this.id + ' defineRestApi() API format not supported, API leafs must strings, objects or numbers');
                            }
                        } else this.defineRestApi(value, methodName, paths.concat([
                            key
                        ]));
                    }
                }
                log(...args) {
                    console.log(...args);
                }
                setHeaders(headers) {
                    return headers;
                }
                fetch(url, method = 'GET', headers, body) {
                    if (isNode && this.userAgent) {
                        if (typeof this.userAgent === 'string') headers = extend({
                            'User-Agent': this.userAgent
                        }, headers);
                        else if (typeof this.userAgent === 'object' && 'User-Agent' in this.userAgent) headers = extend(this.userAgent, headers);
                    }
                    if (typeof this.proxy === 'function') {
                        url = this.proxy(url);
                        if (isNode) headers = extend({
                            'Origin': this.origin
                        }, headers);
                    } else if (typeof this.proxy === 'string') {
                        if (this.proxy.length && isNode) headers = extend({
                            'Origin': this.origin
                        }, headers);
                        url = this.proxy + url;
                    }
                    headers = extend(this.headers, headers);
                    headers = this.setHeaders(headers);
                    if (this.verbose) this.log("fetch Request:\n", this.id, method, url, "\nRequestHeaders:\n", headers, "\nRequestBody:\n", body, "\n");
                    return this.executeRestRequest(url, method, headers, body);
                }
                // eslint-disable-next-line no-unused-vars
                calculateRateLimiterCost(api, method, path, params, config = {}, context = {}) {
                    return this.safeValue(config, 'cost', 1);
                }
                async fetch2(path, type = 'public', method = 'GET', params = {}, headers, body, config = {}, context = {}) {
                    if (this.enableRateLimit) {
                        const cost = this.calculateRateLimiterCost(type, method, path, params, config, context);
                        await this.throttle(cost);
                    }
                    const request = this.sign(path, type, method, params, headers, body);
                    return this.fetch(request.url, request.method, request.headers, request.body);
                }
                request(path, type = 'public', method = 'GET', params = {}, headers, body, config = {}, context = {}) {
                    return this.fetch2(path, type, method, params, headers, body, config, context);
                }
                parseJson(jsonString) {
                    try {
                        if (this.isJsonEncodedObject(jsonString)) return JSON.parse(this.onJsonResponse(jsonString));
                    } catch (e) {
                        // SyntaxError
                        return undefined;
                    }
                }
                throwExactlyMatchedException(exact, string, message) {
                    if (string in exact) throw new exact[string](message);
                }
                throwBroadlyMatchedException(broad, string, message) {
                    const broadKey = this.findBroadlyMatchedKey(broad, string);
                    if (broadKey !== undefined) throw new broad[broadKey](message);
                }
                // a helper for matching error strings exactly vs broadly
                findBroadlyMatchedKey(broad, string) {
                    const keys = Object.keys(broad);
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        if (string.indexOf(key) >= 0) return key;
                    }
                    return undefined;
                }
                handleErrors(statusCode, statusText, url, method, responseHeaders, responseBody, response, requestHeaders, requestBody) {
                // override me
                }
                handleHttpStatusCode(code, reason, url, method, body) {
                    const codeAsString = code.toString();
                    if (codeAsString in this.httpExceptions) {
                        const ErrorClass = this.httpExceptions[codeAsString];
                        throw new ErrorClass([
                            this.id,
                            method,
                            url,
                            code,
                            reason,
                            body
                        ].join(' '));
                    }
                }
                getResponseHeaders(response) {
                    const result = {};
                    response.headers.forEach((value, key)=>{
                        key = key.split('-').map((word)=>capitalize(word)).join('-');
                        result[key] = value;
                    });
                    return result;
                }
                handleRestResponse(response, url, method = 'GET', requestHeaders, requestBody) {
                    const responseHeaders = this.getResponseHeaders(response);
                    if (this.handleContentTypeApplicationZip && responseHeaders['Content-Type'] === 'application/zip') {
                        const responseBuffer = response.buffer();
                        if (this.enableLastResponseHeaders) this.last_response_headers = responseHeaders;
                        if (this.enableLastHttpResponse) this.last_http_response = responseBuffer;
                        if (this.verbose) this.log("handleRestResponse:\n", this.id, method, url, response.status, response.statusText, "\nResponseHeaders:\n", responseHeaders, "ZIP redacted", "\n");
                        // no error handler needed, because it would not be a zip response in case of an error
                        return responseBuffer;
                    }
                    return response.text().then((responseBody)=>{
                        const bodyText = this.onRestResponse(response.status, response.statusText, url, method, responseHeaders, responseBody, requestHeaders, requestBody);
                        const json = this.parseJson(bodyText);
                        if (this.enableLastResponseHeaders) this.last_response_headers = responseHeaders;
                        if (this.enableLastHttpResponse) this.last_http_response = responseBody;
                        if (this.enableLastJsonResponse) this.last_json_response = json;
                        if (this.verbose) this.log("handleRestResponse:\n", this.id, method, url, response.status, response.statusText, "\nResponseHeaders:\n", responseHeaders, "\nResponseBody:\n", responseBody, "\n");
                        const skipFurtherErrorHandling = this.handleErrors(response.status, response.statusText, url, method, responseHeaders, responseBody, json, requestHeaders, requestBody);
                        if (!skipFurtherErrorHandling) this.handleHttpStatusCode(response.status, response.statusText, url, method, responseBody);
                        return json || responseBody;
                    });
                }
                onRestResponse(statusCode, statusText, url, method, responseHeaders, responseBody, requestHeaders, requestBody) {
                    return responseBody.trim();
                }
                onJsonResponse(responseBody) {
                    return this.quoteJsonNumbers ? responseBody.replace(/":([+.0-9eE-]+)([,}])/g, '":"$1"$2') : responseBody;
                }
                setMarkets(markets, currencies) {
                    const values = Object.values(markets).map((market)=>deepExtend({
                            'id': undefined,
                            'symbol': undefined,
                            'base': undefined,
                            'quote': undefined,
                            'baseId': undefined,
                            'quoteId': undefined,
                            'active': undefined,
                            'type': undefined,
                            'linear': undefined,
                            'inverse': undefined,
                            'spot': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'margin': false,
                            'contract': false,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'optionType': undefined,
                            'strike': undefined,
                            'settle': undefined,
                            'settleId': undefined,
                            'precision': this.precision,
                            'limits': this.limits,
                            'info': undefined
                        }, this.fees['trading'], market));
                    this.markets = indexBy(values, 'symbol');
                    this.markets_by_id = indexBy(markets, 'id');
                    this.symbols = Object.keys(this.markets).sort();
                    this.ids = Object.keys(this.markets_by_id).sort();
                    if (currencies) this.currencies = deepExtend(this.currencies, currencies);
                    else {
                        let baseCurrencies = values.filter((market)=>'base' in market).map((market)=>({
                                id: market.baseId || market.base,
                                numericId: market.baseNumericId !== undefined ? market.baseNumericId : undefined,
                                code: market.base,
                                precision: market.precision ? market.precision.base || market.precision.amount : 8
                            }));
                        let quoteCurrencies = values.filter((market)=>'quote' in market).map((market)=>({
                                id: market.quoteId || market.quote,
                                numericId: market.quoteNumericId !== undefined ? market.quoteNumericId : undefined,
                                code: market.quote,
                                precision: market.precision ? market.precision.quote || market.precision.price : 8
                            }));
                        baseCurrencies = sortBy(baseCurrencies, 'code');
                        quoteCurrencies = sortBy(quoteCurrencies, 'code');
                        this.baseCurrencies = indexBy(baseCurrencies, 'code');
                        this.quoteCurrencies = indexBy(quoteCurrencies, 'code');
                        const allCurrencies = baseCurrencies.concat(quoteCurrencies);
                        const groupedCurrencies = groupBy(allCurrencies, 'code');
                        const currencies = Object.keys(groupedCurrencies).map((code)=>groupedCurrencies[code].reduce((previous, current)=>previous.precision > current.precision ? previous : current, groupedCurrencies[code][0])) // eslint-disable-line implicit-arrow-linebreak
                        ;
                        const sortedCurrencies = sortBy(flatten(currencies), 'code');
                        this.currencies = deepExtend(this.currencies, indexBy(sortedCurrencies, 'code'));
                    }
                    this.currencies_by_id = indexBy(this.currencies, 'id');
                    this.codes = Object.keys(this.currencies).sort();
                    return this.markets;
                }
                async loadMarketsHelper(reload = false, params = {}) {
                    if (!reload && this.markets) {
                        if (!this.markets_by_id) return this.setMarkets(this.markets);
                        return this.markets;
                    }
                    let currencies = undefined;
                    // only call if exchange API provides endpoint (true), thus avoid emulated versions ('emulated')
                    if (this.has.fetchCurrencies === true) currencies = await this.fetchCurrencies();
                    const markets = await this.fetchMarkets(params);
                    return this.setMarkets(markets, currencies);
                }
                async fetchPermissions(params = {}) {
                    throw new NotSupported(this.id + ' fetchPermissions() is not supported yet');
                }
                // is async (returns a promise)
                loadMarkets(reload = false, params = {}) {
                    if (reload && !this.reloadingMarkets || !this.marketsLoading) {
                        this.reloadingMarkets = true;
                        this.marketsLoading = this.loadMarketsHelper(reload, params).then((resolved)=>{
                            this.reloadingMarkets = false;
                            return resolved;
                        }, (error)=>{
                            this.reloadingMarkets = false;
                            throw error;
                        });
                    }
                    return this.marketsLoading;
                }
                async loadAccounts(reload = false, params = {}) {
                    if (reload) this.accounts = await this.fetchAccounts(params);
                    else {
                        if (this.accounts) return this.accounts;
                        else this.accounts = await this.fetchAccounts(params);
                    }
                    this.accountsById = this.indexBy(this.accounts, 'id');
                    return this.accounts;
                }
                fetchBidsAsks(symbols, params = {}) {
                    throw new NotSupported(this.id + ' fetchBidsAsks() is not supported yet');
                }
                async fetchOHLCVC(symbol, timeframe = '1m', since, limit, params = {}) {
                    if (!this.has['fetchTrades']) throw new NotSupported(this.id + ' fetchOHLCV() is not supported yet');
                    await this.loadMarkets();
                    const trades = await this.fetchTrades(symbol, since, limit, params);
                    const ohlcvc = buildOHLCVC(trades, timeframe, since, limit);
                    return ohlcvc;
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    if (!this.has['fetchTrades']) throw new NotSupported(this.id + ' fetchOHLCV() is not supported yet');
                    await this.loadMarkets();
                    const trades = await this.fetchTrades(symbol, since, limit, params);
                    const ohlcvc = buildOHLCVC(trades, timeframe, since, limit);
                    return ohlcvc.map((c)=>c.slice(0, -1));
                }
                parseTradingViewOHLCV(ohlcvs, market, timeframe = '1m', since, limit) {
                    const result = this.convertTradingViewToOHLCV(ohlcvs);
                    return this.parseOHLCVs(result, market, timeframe, since, limit);
                }
                convertTradingViewToOHLCV(ohlcvs, t = 't', o = 'o', h = 'h', l = 'l', c = 'c', v = 'v', ms = false) {
                    const result = [];
                    for(let i = 0; i < ohlcvs[t].length; i++)result.push([
                        ms ? ohlcvs[t][i] : ohlcvs[t][i] * 1000,
                        ohlcvs[o][i],
                        ohlcvs[h][i],
                        ohlcvs[l][i],
                        ohlcvs[c][i],
                        ohlcvs[v][i]
                    ]);
                    return result;
                }
                convertOHLCVToTradingView(ohlcvs, t = 't', o = 'o', h = 'h', l = 'l', c = 'c', v = 'v', ms = false) {
                    const result = {};
                    result[t] = [];
                    result[o] = [];
                    result[h] = [];
                    result[l] = [];
                    result[c] = [];
                    result[v] = [];
                    for(let i = 0; i < ohlcvs.length; i++){
                        result[t].push(ms ? ohlcvs[i][0] : parseInt(ohlcvs[i][0] / 1000));
                        result[o].push(ohlcvs[i][1]);
                        result[h].push(ohlcvs[i][2]);
                        result[l].push(ohlcvs[i][3]);
                        result[c].push(ohlcvs[i][4]);
                        result[v].push(ohlcvs[i][5]);
                    }
                    return result;
                }
                async fetchTicker(symbol, params = {}) {
                    if (this.has['fetchTickers']) {
                        const tickers = await this.fetchTickers([
                            symbol
                        ], params);
                        const ticker = this.safeValue(tickers, symbol);
                        if (ticker === undefined) throw new InvalidAddress(this.id + ' fetchTickers() could not find a ticker for ' + symbol);
                        else return ticker;
                    } else throw new NotSupported(this.id + ' fetchTicker() is not supported yet');
                }
                fetchTickers(symbols, params = {}) {
                    throw new NotSupported(this.id + ' fetchTickers() is not supported yet');
                }
                fetchOrder(id, symbol, params = {}) {
                    throw new NotSupported(this.id + ' fetchOrder() is not supported yet');
                }
                fetchUnifiedOrder(order, params = {}) {
                    return this.fetchOrder(this.safeValue(order, 'id'), this.safeValue(order, 'symbol'), params);
                }
                createOrder(symbol, type, side, amount, price, params = {}) {
                    throw new NotSupported(this.id + ' createOrder() is not supported yet');
                }
                cancelOrder(id, symbol, params = {}) {
                    throw new NotSupported(this.id + ' cancelOrder() is not supported yet');
                }
                cancelUnifiedOrder(order, params = {}) {
                    return this.cancelOrder(this.safeValue(order, 'id'), this.safeValue(order, 'symbol'), params);
                }
                fetchOrders(symbol, since, limit, params = {}) {
                    throw new NotSupported(this.id + ' fetchOrders() is not supported yet');
                }
                fetchOpenOrders(symbol, since, limit, params = {}) {
                    throw new NotSupported(this.id + ' fetchOpenOrders() is not supported yet');
                }
                fetchClosedOrders(symbol, since, limit, params = {}) {
                    throw new NotSupported(this.id + ' fetchClosedOrders() is not supported yet');
                }
                fetchMyTrades(symbol, since, limit, params = {}) {
                    throw new NotSupported(this.id + ' fetchMyTrades() is not supported yet');
                }
                fetchTransactions(symbol, since, limit, params = {}) {
                    throw new NotSupported(this.id + ' fetchTransactions() is not supported yet');
                }
                fetchDeposits(symbol, since, limit, params = {}) {
                    throw new NotSupported(this.id + ' fetchDeposits() is not supported yet');
                }
                fetchWithdrawals(symbol, since, limit, params = {}) {
                    throw new NotSupported(this.id + ' fetchWithdrawals() is not supported yet');
                }
                async fetchDepositAddress(code, params = {}) {
                    if (this.has['fetchDepositAddresses']) {
                        const depositAddresses = await this.fetchDepositAddresses([
                            code
                        ], params);
                        const depositAddress = this.safeValue(depositAddresses, code);
                        if (depositAddress === undefined) throw new InvalidAddress(this.id + ' fetchDepositAddress() could not find a deposit address for ' + code + ', make sure you have created a corresponding deposit address in your wallet on the exchange website');
                        else return depositAddress;
                    } else throw new NotSupported(this.id + ' fetchDepositAddress() not supported yet');
                }
                fetchCurrencies(params = {}) {
                    // markets are returned as a list
                    // currencies are returned as a dict
                    // this is for historical reasons
                    // and may be changed for consistency later
                    return new Promise((resolve, reject)=>resolve(this.currencies));
                }
                fetchMarkets(params = {}) {
                    // markets are returned as a list
                    // currencies are returned as a dict
                    // this is for historical reasons
                    // and may be changed for consistency later
                    return new Promise((resolve, reject)=>resolve(Object.values(this.markets)));
                }
                async fetchOrderStatus(id, symbol, params = {}) {
                    const order = await this.fetchOrder(id, symbol, params);
                    return order['status'];
                }
                account() {
                    return {
                        'free': undefined,
                        'used': undefined,
                        'total': undefined
                    };
                }
                commonCurrencyCode(currency) {
                    if (!this.substituteCommonCurrencyCodes) return currency;
                    return this.safeString(this.commonCurrencies, currency, currency);
                }
                currency(code) {
                    if (this.currencies === undefined) throw new ExchangeError1(this.id + ' currencies not loaded');
                    if (typeof code === 'string') {
                        if (code in this.currencies) return this.currencies[code];
                        else if (code in this.currencies_by_id) return this.currencies_by_id[code];
                    }
                    throw new ExchangeError1(this.id + ' does not have currency code ' + code);
                }
                market(symbol) {
                    if (this.markets === undefined) throw new ExchangeError1(this.id + ' markets not loaded');
                    if (this.markets_by_id === undefined) throw new ExchangeError1(this.id + ' markets not loaded');
                    if (typeof symbol === 'string') {
                        if (symbol in this.markets) return this.markets[symbol];
                        else if (symbol in this.markets_by_id) return this.markets_by_id[symbol];
                    }
                    throw new BadSymbol(this.id + ' does not have market symbol ' + symbol);
                }
                marketId(symbol) {
                    const market = this.market(symbol);
                    return market !== undefined ? market['id'] : symbol;
                }
                marketIds(symbols) {
                    return symbols.map((symbol)=>this.marketId(symbol));
                }
                symbol(symbol) {
                    return this.market(symbol).symbol || symbol;
                }
                implodeHostname(url) {
                    return this.implodeParams(url, {
                        'hostname': this.hostname
                    });
                }
                resolvePath(path, params) {
                    return [
                        this.implodeParams(path, params),
                        this.omit(params, this.extractParams(path))
                    ];
                }
                parseBidAsk(bidask, priceKey = 0, amountKey = 1) {
                    const price = this.safeNumber(bidask, priceKey);
                    const amount = this.safeNumber(bidask, amountKey);
                    return [
                        price,
                        amount
                    ];
                }
                parseBidsAsks(bidasks, priceKey = 0, amountKey = 1) {
                    return Object.values(bidasks || []).map((bidask)=>this.parseBidAsk(bidask, priceKey, amountKey));
                }
                async fetchL2OrderBook(symbol, limit, params = {}) {
                    const orderbook = await this.fetchOrderBook(symbol, limit, params);
                    return extend(orderbook, {
                        'bids': sortBy(aggregate(orderbook.bids), 0, true),
                        'asks': sortBy(aggregate(orderbook.asks), 0)
                    });
                }
                parseOrderBook(orderbook, symbol, timestamp, bidsKey = 'bids', asksKey = 'asks', priceKey = 0, amountKey = 1) {
                    return {
                        'symbol': symbol,
                        'bids': sortBy(bidsKey in orderbook ? this.parseBidsAsks(orderbook[bidsKey], priceKey, amountKey) : [], 0, true),
                        'asks': sortBy(asksKey in orderbook ? this.parseBidsAsks(orderbook[asksKey], priceKey, amountKey) : [], 0),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'nonce': undefined
                    };
                }
                safeBalance(balance) {
                    const codes = Object.keys(this.omit(balance, [
                        'info',
                        'timestamp',
                        'datetime',
                        'free',
                        'used',
                        'total'
                    ]));
                    balance['free'] = {};
                    balance['used'] = {};
                    balance['total'] = {};
                    for(let i = 0; i < codes.length; i++){
                        const code = codes[i];
                        if (balance[code].total === undefined) {
                            if (balance[code].free !== undefined && balance[code].used !== undefined) balance[code].total = Precise.stringAdd(balance[code].free, balance[code].used);
                        }
                        if (balance[code].free === undefined) {
                            if (balance[code].total !== undefined && balance[code].used !== undefined) balance[code].free = Precise.stringSub(balance[code].total, balance[code].used);
                        }
                        if (balance[code].used === undefined) {
                            if (balance[code].total !== undefined && balance[code].free !== undefined) balance[code].used = Precise.stringSub(balance[code].total, balance[code].free);
                        }
                        balance[code].free = this.parseNumber(balance[code].free);
                        balance[code].used = this.parseNumber(balance[code].used);
                        balance[code].total = this.parseNumber(balance[code].total);
                        balance.free[code] = balance[code].free;
                        balance.used[code] = balance[code].used;
                        balance.total[code] = balance[code].total;
                    }
                    return balance;
                }
                async fetchBalance(params = {}) {
                    throw new NotSupported(this.id + ' fetchBalance() not supported yet');
                }
                async fetchPartialBalance(part, params = {}) {
                    const balance = await this.fetchBalance(params);
                    return balance[part];
                }
                fetchFreeBalance(params = {}) {
                    return this.fetchPartialBalance('free', params);
                }
                fetchUsedBalance(params = {}) {
                    return this.fetchPartialBalance('used', params);
                }
                fetchTotalBalance(params = {}) {
                    return this.fetchPartialBalance('total', params);
                }
                async fetchStatus(params = {}) {
                    if (this.has['fetchTime']) {
                        const time = await this.fetchTime(params);
                        this.status = this.extend(this.status, {
                            'updated': time
                        });
                    }
                    return this.status;
                }
                async fetchTradingFees(params = {}) {
                    throw new NotSupported(this.id + ' fetchTradingFees() not supported yet');
                }
                async fetchTradingFee(symbol, params = {}) {
                    if (!this.has['fetchTradingFees']) throw new NotSupported(this.id + ' fetchTradingFee() not supported yet');
                    return await this.fetchTradingFees(params);
                }
                async loadTradingLimits(symbols, reload = false, params = {}) {
                    if (this.has['fetchTradingLimits']) {
                        if (reload || !('limitsLoaded' in this.options)) {
                            const response = await this.fetchTradingLimits(symbols);
                            for(let i = 0; i < symbols.length; i++){
                                const symbol = symbols[i];
                                this.markets[symbol] = this.deepExtend(this.markets[symbol], response[symbol]);
                            }
                            this.options['limitsLoaded'] = this.milliseconds();
                        }
                    }
                    return this.markets;
                }
                filterBySinceLimit(array, since, limit, key = 'timestamp', tail = false) {
                    const sinceIsDefined = since !== undefined && since !== null;
                    if (sinceIsDefined) array = array.filter((entry)=>entry[key] >= since);
                    if (limit !== undefined && limit !== null) array = tail ? array.slice(-limit) : array.slice(0, limit);
                    return array;
                }
                filterByValueSinceLimit(array, field, value, since, limit, key = 'timestamp', tail = false) {
                    const valueIsDefined = value !== undefined && value !== null;
                    const sinceIsDefined = since !== undefined && since !== null;
                    // single-pass filter for both symbol and since
                    if (valueIsDefined || sinceIsDefined) array = array.filter((entry)=>(valueIsDefined ? entry[field] === value : true) && (sinceIsDefined ? entry[key] >= since : true));
                    if (limit !== undefined && limit !== null) array = tail ? array.slice(-limit) : array.slice(0, limit);
                    return array;
                }
                filterBySymbolSinceLimit(array, symbol, since, limit, tail = false) {
                    return this.filterByValueSinceLimit(array, 'symbol', symbol, since, limit, 'timestamp', tail);
                }
                filterByCurrencySinceLimit(array, code, since, limit, tail = false) {
                    return this.filterByValueSinceLimit(array, 'currency', code, since, limit, 'timestamp', tail);
                }
                filterByArray(objects, key, values, indexed = true) {
                    objects = Object.values(objects);
                    // return all of them if no values were passed
                    if (values === undefined || values === null) return indexed ? indexBy(objects, key) : objects;
                    const result = [];
                    for(let i = 0; i < objects.length; i++)if (values.includes(objects[i][key])) result.push(objects[i]);
                    return indexed ? indexBy(result, key) : result;
                }
                safeTicker(ticker, market, legacy = true) {
                    if (legacy) {
                        let symbol = this.safeValue(ticker, 'symbol');
                        if (symbol === undefined) symbol = this.safeSymbol(undefined, market);
                        const timestamp = this.safeInteger(ticker, 'timestamp');
                        let baseVolume = this.safeValue(ticker, 'baseVolume');
                        let quoteVolume = this.safeValue(ticker, 'quoteVolume');
                        let vwap = this.safeValue(ticker, 'vwap');
                        if (vwap === undefined) vwap = this.vwap(baseVolume, quoteVolume);
                        let open = this.safeValue(ticker, 'open');
                        let close = this.safeValue(ticker, 'close');
                        let last = this.safeValue(ticker, 'last');
                        let change = this.safeValue(ticker, 'change');
                        let percentage = this.safeValue(ticker, 'percentage');
                        let average = this.safeValue(ticker, 'average');
                        if (last !== undefined && close === undefined) close = last;
                        else if (last === undefined && close !== undefined) last = close;
                        if (last !== undefined && open !== undefined) {
                            if (change === undefined) change = last - open;
                            if (average === undefined) average = this.sum(last, open) / 2;
                        }
                        if (percentage === undefined && change !== undefined && open !== undefined && open > 0) percentage = change / open * 100;
                        if (change === undefined && percentage !== undefined && last !== undefined) change = percentage / 100 * last;
                        if (open === undefined && last !== undefined && change !== undefined) open = last - change;
                        if (vwap !== undefined && baseVolume !== undefined && quoteVolume === undefined) quoteVolume = vwap / baseVolume;
                        if (vwap !== undefined && quoteVolume !== undefined && baseVolume === undefined) baseVolume = quoteVolume / vwap;
                        ticker['symbol'] = symbol;
                        ticker['timestamp'] = timestamp;
                        ticker['datetime'] = this.iso8601(timestamp);
                        ticker['open'] = open;
                        ticker['close'] = close;
                        ticker['last'] = last;
                        ticker['vwap'] = vwap;
                        ticker['change'] = change;
                        ticker['percentage'] = percentage;
                        ticker['average'] = average;
                        return ticker;
                    } else {
                        let open = this.safeValue(ticker, 'open');
                        let close = this.safeValue(ticker, 'close');
                        let last = this.safeValue(ticker, 'last');
                        let change = this.safeValue(ticker, 'change');
                        let percentage = this.safeValue(ticker, 'percentage');
                        let average = this.safeValue(ticker, 'average');
                        let vwap = this.safeValue(ticker, 'vwap');
                        const baseVolume = this.safeValue(ticker, 'baseVolume');
                        const quoteVolume = this.safeValue(ticker, 'quoteVolume');
                        if (vwap === undefined) vwap = Precise.stringDiv(quoteVolume, baseVolume);
                        if (last !== undefined && close === undefined) close = last;
                        else if (last === undefined && close !== undefined) last = close;
                        if (last !== undefined && open !== undefined) {
                            if (change === undefined) change = Precise.stringSub(last, open);
                            if (average === undefined) average = Precise.stringDiv(Precise.stringAdd(last, open), '2');
                        }
                        if (percentage === undefined && change !== undefined && open !== undefined && Precise.stringGt(open, '0')) percentage = Precise.stringMul(Precise.stringDiv(change, open), '100');
                        if (change === undefined && percentage !== undefined && last !== undefined) change = Precise.stringDiv(Precise.stringMul(percentage, last), '100');
                        if (open === undefined && last !== undefined && change !== undefined) open = Precise.stringSub(last, change);
                        // timestamp and symbol operations don't belong in safeTicker
                        // they should be done in the derived classes
                        return this.extend(ticker, {
                            'bid': this.safeNumber(ticker, 'bid'),
                            'bidVolume': this.safeNumber(ticker, 'bidVolume'),
                            'ask': this.safeNumber(ticker, 'ask'),
                            'askVolume': this.safeNumber(ticker, 'askVolume'),
                            'high': this.safeNumber(ticker, 'high'),
                            'low': this.safeNumber(ticker, 'low'),
                            'open': this.parseNumber(open),
                            'close': this.parseNumber(close),
                            'last': this.parseNumber(last),
                            'change': this.parseNumber(change),
                            'percentage': this.parseNumber(percentage),
                            'average': this.parseNumber(average),
                            'vwap': this.parseNumber(vwap),
                            'baseVolume': this.parseNumber(baseVolume),
                            'quoteVolume': this.parseNumber(quoteVolume)
                        });
                    }
                }
                parseTickers(tickers, symbols, params = {}) {
                    const result = [];
                    const values = Object.values(tickers || []);
                    for(let i = 0; i < values.length; i++)result.push(this.extend(this.parseTicker(values[i]), params));
                    return this.filterByArray(result, 'symbol', symbols);
                }
                parseDepositAddresses(addresses, codes, indexed = true, params = {}) {
                    let result = [];
                    for(let i = 0; i < addresses.length; i++){
                        const address = this.extend(this.parseDepositAddress(addresses[i]), params);
                        result.push(address);
                    }
                    if (codes) result = this.filterByArray(result, 'currency', codes, false);
                    return indexed ? this.indexBy(result, 'currency') : result;
                }
                parseTrades(trades, market, since, limit, params = {}) {
                    let result = Object.values(trades || []).map((trade)=>this.merge(this.parseTrade(trade, market), params));
                    result = sortBy2(result, 'timestamp', 'id');
                    const symbol = market !== undefined ? market['symbol'] : undefined;
                    const tail = since === undefined;
                    return this.filterBySymbolSinceLimit(result, symbol, since, limit, tail);
                }
                parseTransactions(transactions, currency, since, limit, params = {}) {
                    let result = Object.values(transactions || []).map((transaction)=>this.extend(this.parseTransaction(transaction, currency), params));
                    result = this.sortBy(result, 'timestamp');
                    const code = currency !== undefined ? currency['code'] : undefined;
                    const tail = since === undefined;
                    return this.filterByCurrencySinceLimit(result, code, since, limit, tail);
                }
                parseTransfers(transfers, currency, since, limit, params = {}) {
                    let result = Object.values(transfers || []).map((transfer)=>this.extend(this.parseTransfer(transfer, currency), params));
                    result = this.sortBy(result, 'timestamp');
                    const code = currency !== undefined ? currency['code'] : undefined;
                    const tail = since === undefined;
                    return this.filterByCurrencySinceLimit(result, code, since, limit, tail);
                }
                parseLedger(data, currency, since, limit, params = {}) {
                    let result = [];
                    const array = Object.values(data || []);
                    for(let i = 0; i < array.length; i++){
                        const itemOrItems = this.parseLedgerEntry(array[i], currency);
                        if (Array.isArray(itemOrItems)) for(let j = 0; j < itemOrItems.length; j++)result.push(this.extend(itemOrItems[j], params));
                        else result.push(this.extend(itemOrItems, params));
                    }
                    result = this.sortBy(result, 'timestamp');
                    const code = currency !== undefined ? currency['code'] : undefined;
                    const tail = since === undefined;
                    return this.filterByCurrencySinceLimit(result, code, since, limit, tail);
                }
                safeLedgerEntry(entry, currency) {
                    currency = this.safeCurrency(undefined, currency);
                    let direction = this.safeString(entry, 'direction');
                    let before = this.safeString(entry, 'before');
                    let after = this.safeString(entry, 'after');
                    let amount = this.safeString(entry, 'amount');
                    let fee = this.safeString(entry, 'fee');
                    if (amount !== undefined && fee !== undefined) {
                        if (before === undefined && after !== undefined) {
                            const amountAndFee = Precise.stringAdd(amount, fee);
                            before = Precise.stringSub(after, amountAndFee);
                        } else if (before !== undefined && after === undefined) {
                            const amountAndFee = Precise.stringAdd(amount, fee);
                            after = Precise.stringAdd(before, amountAndFee);
                        }
                    }
                    if (before !== undefined && after !== undefined) {
                        if (direction === undefined) {
                            if (Precise.stringGt(before, after)) direction = 'out';
                            if (Precise.stringGt(after, before)) direction = 'in';
                        }
                        if (amount === undefined && fee !== undefined) {
                            const betweenAfterBefore = Precise.stringSub(after, before);
                            amount = Precise.stringSub(betweenAfterBefore, fee);
                        }
                        if (amount !== undefined && fee === undefined) {
                            const betweenAfterBefore = Precise.stringSub(after, before);
                            fee = Precise.stringSub(betweenAfterBefore, amount);
                        }
                    }
                    return this.extend({
                        'id': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'direction': undefined,
                        'account': undefined,
                        'referenceId': undefined,
                        'referenceAccount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'amount': amount,
                        'before': before,
                        'after': after,
                        'status': undefined,
                        'fee': fee,
                        'info': undefined
                    }, entry);
                }
                parseOrders(orders, market, since, limit, params = {}) {
                    //
                    // the value of orders is either a dict or a list
                    //
                    // dict
                    //
                    //     {
                    //         'id1': { ... },
                    //         'id2': { ... },
                    //         'id3': { ... },
                    //         ...
                    //     }
                    //
                    // list
                    //
                    //     [
                    //         { 'id': 'id1', ... },
                    //         { 'id': 'id2', ... },
                    //         { 'id': 'id3', ... },
                    //         ...
                    //     ]
                    //
                    let result = Array.isArray(orders) ? Object.values(orders).map((order)=>this.extend(this.parseOrder(order, market), params)) : Object.entries(orders).map(([id, order])=>this.extend(this.parseOrder(this.extend({
                            'id': id
                        }, order), market), params));
                    result = sortBy(result, 'timestamp');
                    const symbol = market !== undefined ? market['symbol'] : undefined;
                    const tail = since === undefined;
                    return this.filterBySymbolSinceLimit(result, symbol, since, limit, tail);
                }
                safeCurrency(currencyId, currency) {
                    if (currencyId === undefined && currency !== undefined) return currency;
                    if (this.currencies_by_id !== undefined && currencyId in this.currencies_by_id) return this.currencies_by_id[currencyId];
                    return {
                        'id': currencyId,
                        'code': currencyId === undefined ? currencyId : this.commonCurrencyCode(currencyId.toUpperCase())
                    };
                }
                safeCurrencyCode(currencyId, currency) {
                    currency = this.safeCurrency(currencyId, currency);
                    return currency['code'];
                }
                safeMarket(marketId, market, delimiter) {
                    if (marketId !== undefined) {
                        if (this.markets_by_id !== undefined && marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                        else if (delimiter !== undefined) {
                            const parts = marketId.split(delimiter);
                            if (parts.length === 2) {
                                const baseId = this.safeString(parts, 0);
                                const quoteId = this.safeString(parts, 1);
                                const base = this.safeCurrencyCode(baseId);
                                const quote = this.safeCurrencyCode(quoteId);
                                const symbol = base + '/' + quote;
                                return {
                                    'id': marketId,
                                    'symbol': symbol,
                                    'base': base,
                                    'quote': quote,
                                    'baseId': baseId,
                                    'quoteId': quoteId
                                };
                            } else return {
                                'id': marketId,
                                'symbol': marketId,
                                'base': undefined,
                                'quote': undefined,
                                'baseId': undefined,
                                'quoteId': undefined
                            };
                        }
                    }
                    if (market !== undefined) return market;
                    return {
                        'id': marketId,
                        'symbol': marketId,
                        'base': undefined,
                        'quote': undefined,
                        'baseId': undefined,
                        'quoteId': undefined
                    };
                }
                safeSymbol(marketId, market, delimiter) {
                    market = this.safeMarket(marketId, market, delimiter);
                    return market['symbol'];
                }
                filterBySymbol(array, symbol) {
                    return symbol !== undefined ? array.filter((entry)=>entry.symbol === symbol) : array;
                }
                parseFundingRate(contract, market) {
                    throw new NotSupported(this.id + ' parseFundingRate() not supported yet');
                }
                parseFundingRates(response, market) {
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const parsed = this.parseFundingRate(response[i], market);
                        result[parsed['symbol']] = parsed;
                    }
                    return result;
                }
                parseOHLCV(ohlcv, market) {
                    return Array.isArray(ohlcv) ? ohlcv.slice(0, 6) : ohlcv;
                }
                parseOHLCVs(ohlcvs, market, timeframe = '1m', since, limit) {
                    // this code is commented out temporarily to catch for exchange-specific errors
                    // if (!this.isArray (ohlcvs)) {
                    //     throw new ExchangeError (this.id + ' parseOHLCVs() expected an array in the ohlcvs argument, but got ' + typeof ohlcvs);
                    // }
                    const parsed = ohlcvs.map((ohlcv)=>this.parseOHLCV(ohlcv, market));
                    const sorted = this.sortBy(parsed, 0);
                    const tail = since === undefined;
                    return this.filterBySinceLimit(sorted, since, limit, 0, tail);
                }
                editLimitBuyOrder(id, symbol, ...args) {
                    return this.editLimitOrder(id, symbol, 'buy', ...args);
                }
                editLimitSellOrder(id, symbol, ...args) {
                    return this.editLimitOrder(id, symbol, 'sell', ...args);
                }
                editLimitOrder(id, symbol, ...args) {
                    return this.editOrder(id, symbol, 'limit', ...args);
                }
                async editOrder(id, symbol, ...args) {
                    if (!this.enableRateLimit) throw new ExchangeError1(this.id + ' editOrder() requires enableRateLimit = true');
                    await this.cancelOrder(id, symbol);
                    return this.createOrder(symbol, ...args);
                }
                createLimitOrder(symbol, side, amount, price, params = {}) {
                    return this.createOrder(symbol, 'limit', side, amount, price, params);
                }
                createMarketOrder(symbol, side, amount, price, params = {}) {
                    return this.createOrder(symbol, 'market', side, amount, price, params);
                }
                createLimitBuyOrder(symbol, amount, price, params = {}) {
                    return this.createOrder(symbol, 'limit', 'buy', amount, price, params);
                }
                createLimitSellOrder(symbol, amount, price, params = {}) {
                    return this.createOrder(symbol, 'limit', 'sell', amount, price, params);
                }
                createMarketBuyOrder(symbol, amount, params = {}) {
                    return this.createOrder(symbol, 'market', 'buy', amount, undefined, params);
                }
                createMarketSellOrder(symbol, amount, params = {}) {
                    return this.createOrder(symbol, 'market', 'sell', amount, undefined, params);
                }
                costToPrecision(symbol, cost) {
                    const market = this.market(symbol);
                    return decimalToPrecision(cost, TRUNCATE, market.precision.price, this.precisionMode, this.paddingMode);
                }
                priceToPrecision(symbol, price) {
                    const market = this.market(symbol);
                    return decimalToPrecision(price, ROUND, market.precision.price, this.precisionMode, this.paddingMode);
                }
                amountToPrecision(symbol, amount) {
                    const market = this.market(symbol);
                    return decimalToPrecision(amount, TRUNCATE, market.precision.amount, this.precisionMode, this.paddingMode);
                }
                feeToPrecision(symbol, fee) {
                    const market = this.market(symbol);
                    return decimalToPrecision(fee, ROUND, market.precision.price, this.precisionMode, this.paddingMode);
                }
                currencyToPrecision(code, fee) {
                    return decimalToPrecision(fee, ROUND, this.currencies[code]['precision'], this.precisionMode, this.paddingMode);
                }
                calculateFee(symbol, type, side, amount, price, takerOrMaker = 'taker', params = {}) {
                    const market = this.markets[symbol];
                    const feeSide = this.safeString(market, 'feeSide', 'quote');
                    let key = 'quote';
                    let cost = undefined;
                    if (feeSide === 'quote') // the fee is always in quote currency
                    cost = amount * price;
                    else if (feeSide === 'base') // the fee is always in base currency
                    cost = amount;
                    else if (feeSide === 'get') {
                        // the fee is always in the currency you get
                        cost = amount;
                        if (side === 'sell') cost *= price;
                        else key = 'base';
                    } else if (feeSide === 'give') {
                        // the fee is always in the currency you give
                        cost = amount;
                        if (side === 'buy') cost *= price;
                        else key = 'base';
                    }
                    const rate = market[takerOrMaker];
                    if (cost !== undefined) cost *= rate;
                    return {
                        'type': takerOrMaker,
                        'currency': market[key],
                        'rate': rate,
                        'cost': cost
                    };
                }
                checkRequiredDependencies() {
                    return;
                }
                remove0xPrefix(hexData) {
                    if (hexData.slice(0, 2) === '0x') return hexData.slice(2);
                    else return hexData;
                }
                hashMessage(message) {
                    // takes a hex encoded message
                    const binaryMessage = this.base16ToBinary(this.remove0xPrefix(message));
                    const prefix = this.stringToBinary('\x19Ethereum Signed Message:\n' + binaryMessage.sigBytes);
                    return '0x' + this.hash(this.binaryConcat(prefix, binaryMessage), 'keccak', 'hex');
                }
                signHash(hash, privateKey) {
                    const signature = this.ecdsa(hash.slice(-64), privateKey.slice(-64), 'secp256k1', undefined);
                    return {
                        'r': '0x' + signature['r'],
                        's': '0x' + signature['s'],
                        'v': 27 + signature['v']
                    };
                }
                signMessage(message, privateKey) {
                    return this.signHash(this.hashMessage(message), privateKey.slice(-64));
                }
                signMessageString(message, privateKey) {
                    // still takes the input as a hex string
                    // same as above but returns a string instead of an object
                    const signature = this.signMessage(message, privateKey);
                    return signature['r'] + this.remove0xPrefix(signature['s']) + this.binaryToBase16(this.numberToBE(signature['v']));
                }
                oath() {
                    if (typeof this.twofa !== 'undefined') return this.totp(this.twofa);
                    else throw new ExchangeError1(this.id + ' this.twofa has not been set');
                }
                getNetwork(network, code) {
                    network = network.toUpperCase();
                    const aliases = {
                        'ETHEREUM': 'ETH',
                        'ETHER': 'ETH',
                        'ERC20': 'ETH',
                        'ETH': 'ETH',
                        'TRC20': 'TRX',
                        'TRON': 'TRX',
                        'TRX': 'TRX',
                        'BEP20': 'BSC',
                        'BSC': 'BSC',
                        'HRC20': 'HT',
                        'HECO': 'HT',
                        'SPL': 'SOL',
                        'SOL': 'SOL',
                        'TERRA': 'LUNA',
                        'LUNA': 'LUNA',
                        'POLYGON': 'MATIC',
                        'MATIC': 'MATIC',
                        'EOS': 'EOS',
                        'WAVES': 'WAVES',
                        'AVALANCHE': 'AVAX',
                        'AVAX': 'AVAX',
                        'QTUM': 'QTUM',
                        'CHZ': 'CHZ',
                        'NEO': 'NEO',
                        'ONT': 'ONT',
                        'RON': 'RON'
                    };
                    if (network === code) return network;
                    else if (network in aliases) return aliases[network];
                    else throw new NotSupported(this.id + ' network ' + network + ' is not yet supported');
                }
                reduceFeesByCurrency(fees, string = false) {
                    //
                    // this function takes a list of fee structures having the following format
                    //
                    //     string = true
                    //
                    //     [
                    //         { 'currency': 'BTC', 'cost': '0.1' },
                    //         { 'currency': 'BTC', 'cost': '0.2'  },
                    //         { 'currency': 'BTC', 'cost': '0.2', 'rate': '0.00123' },
                    //         { 'currency': 'BTC', 'cost': '0.4', 'rate': '0.00123' },
                    //         { 'currency': 'BTC', 'cost': '0.5', 'rate': '0.00456' },
                    //         { 'currency': 'USDT', 'cost': '12.3456' },
                    //     ]
                    //
                    //     string = false
                    //
                    //     [
                    //         { 'currency': 'BTC', 'cost': 0.1 },
                    //         { 'currency': 'BTC', 'cost': 0.2 },
                    //         { 'currency': 'BTC', 'cost': 0.2, 'rate': 0.00123 },
                    //         { 'currency': 'BTC', 'cost': 0.4, 'rate': 0.00123 },
                    //         { 'currency': 'BTC', 'cost': 0.5, 'rate': 0.00456 },
                    //         { 'currency': 'USDT', 'cost': 12.3456 },
                    //     ]
                    //
                    // and returns a reduced fee list, where fees are summed per currency and rate (if any)
                    //
                    //     string = true
                    //
                    //     [
                    //         { 'currency': 'BTC', 'cost': '0.3'  },
                    //         { 'currency': 'BTC', 'cost': '0.6', 'rate': '0.00123' },
                    //         { 'currency': 'BTC', 'cost': '0.5', 'rate': '0.00456' },
                    //         { 'currency': 'USDT', 'cost': '12.3456' },
                    //     ]
                    //
                    //     string  = false
                    //
                    //     [
                    //         { 'currency': 'BTC', 'cost': 0.3  },
                    //         { 'currency': 'BTC', 'cost': 0.6, 'rate': 0.00123 },
                    //         { 'currency': 'BTC', 'cost': 0.5, 'rate': 0.00456 },
                    //         { 'currency': 'USDT', 'cost': 12.3456 },
                    //     ]
                    //
                    const reduced = {};
                    for(let i = 0; i < fees.length; i++){
                        const fee = fees[i];
                        const feeCurrencyCode = this.safeString(fee, 'currency');
                        if (feeCurrencyCode !== undefined) {
                            const rate = this.safeString(fee, 'rate');
                            const cost = this.safeValue(fee, 'cost');
                            if (!(feeCurrencyCode in reduced)) reduced[feeCurrencyCode] = {};
                            const rateKey = rate === undefined ? '' : rate;
                            if (rateKey in reduced[feeCurrencyCode]) {
                                if (string) reduced[feeCurrencyCode][rateKey]['cost'] = Precise.stringAdd(reduced[feeCurrencyCode][rateKey]['cost'], cost);
                                else reduced[feeCurrencyCode][rateKey]['cost'] = this.sum(reduced[feeCurrencyCode][rateKey]['cost'], cost);
                            } else {
                                reduced[feeCurrencyCode][rateKey] = {
                                    'currency': feeCurrencyCode,
                                    'cost': string ? cost : this.parseNumber(cost)
                                };
                                if (rate !== undefined) reduced[feeCurrencyCode][rateKey]['rate'] = string ? rate : this.parseNumber(rate);
                            }
                        }
                    }
                    let result = [];
                    const feeValues = Object.values(reduced);
                    for(let i = 0; i < feeValues.length; i++){
                        const reducedFeeValues = Object.values(feeValues[i]);
                        result = this.arrayConcat(result, reducedFeeValues);
                    }
                    return result;
                }
                safeTrade(trade, market) {
                    const amount = this.safeString(trade, 'amount');
                    const price = this.safeString(trade, 'price');
                    let cost = this.safeString(trade, 'cost');
                    if (cost === undefined) {
                        // contract trading
                        const contractSize = this.safeString(market, 'contractSize');
                        let multiplyPrice = price;
                        if (contractSize !== undefined) {
                            const inverse = this.safeValue(market, 'inverse', false);
                            if (inverse) multiplyPrice = Precise.stringDiv('1', price);
                            multiplyPrice = Precise.stringMul(multiplyPrice, contractSize);
                        }
                        cost = Precise.stringMul(multiplyPrice, amount);
                    }
                    const parseFee = this.safeValue(trade, 'fee') === undefined;
                    const parseFees = this.safeValue(trade, 'fees') === undefined;
                    const shouldParseFees = parseFee || parseFees;
                    const fees = this.safeValue(trade, 'fees', []);
                    if (shouldParseFees) {
                        const tradeFees = this.safeValue(trade, 'fees');
                        if (tradeFees !== undefined) for(let j = 0; j < tradeFees.length; j++){
                            const tradeFee = tradeFees[j];
                            fees.push(this.extend({}, tradeFee));
                        }
                        else {
                            const tradeFee = this.safeValue(trade, 'fee');
                            if (tradeFee !== undefined) fees.push(this.extend({}, tradeFee));
                        }
                    }
                    const fee = this.safeValue(trade, 'fee');
                    if (shouldParseFees) {
                        const reducedFees = this.reduceFees ? this.reduceFeesByCurrency(fees, true) : fees;
                        const reducedLength = reducedFees.length;
                        for(let i = 0; i < reducedLength; i++){
                            reducedFees[i]['cost'] = this.safeNumber(reducedFees[i], 'cost');
                            if ('rate' in reducedFees[i]) reducedFees[i]['rate'] = this.safeNumber(reducedFees[i], 'rate');
                        }
                        if (!parseFee && reducedLength === 0) {
                            fee['cost'] = this.safeNumber(fee, 'cost');
                            if ('rate' in fee) fee['rate'] = this.safeNumber(fee, 'rate');
                            reducedFees.push(fee);
                        }
                        if (parseFees) trade['fees'] = reducedFees;
                        if (parseFee && reducedLength === 1) trade['fee'] = reducedFees[0];
                        const tradeFee = this.safeValue(trade, 'fee');
                        if (tradeFee !== undefined) {
                            tradeFee['cost'] = this.safeNumber(tradeFee, 'cost');
                            if ('rate' in tradeFee) tradeFee['rate'] = this.safeNumber(tradeFee, 'rate');
                            trade['fee'] = tradeFee;
                        }
                    }
                    trade['amount'] = this.parseNumber(amount);
                    trade['price'] = this.parseNumber(price);
                    trade['cost'] = this.parseNumber(cost);
                    return trade;
                }
                safeOrder(order, market) {
                    // parses numbers as strings
                    // it is important pass the trades as unparsed rawTrades
                    let amount = this.omitZero(this.safeString(order, 'amount'));
                    let remaining = this.safeString(order, 'remaining');
                    let filled = this.safeString(order, 'filled');
                    let cost = this.safeString(order, 'cost');
                    let average = this.omitZero(this.safeString(order, 'average'));
                    let price = this.omitZero(this.safeString(order, 'price'));
                    let lastTradeTimeTimestamp = this.safeInteger(order, 'lastTradeTimestamp');
                    const parseFilled = filled === undefined;
                    const parseCost = cost === undefined;
                    const parseLastTradeTimeTimestamp = lastTradeTimeTimestamp === undefined;
                    const fee = this.safeValue(order, 'fee');
                    const parseFee = fee === undefined;
                    const parseFees = this.safeValue(order, 'fees') === undefined;
                    const shouldParseFees = parseFee || parseFees;
                    const fees = this.safeValue(order, 'fees', []);
                    let trades = [];
                    if (parseFilled || parseCost || shouldParseFees) {
                        const rawTrades = this.safeValue(order, 'trades', trades);
                        const oldNumber = this.number;
                        // we parse trades as strings here!
                        this.number = String;
                        trades = this.parseTrades(rawTrades, market, undefined, undefined, {
                            'symbol': order['symbol'],
                            'side': order['side'],
                            'type': order['type'],
                            'order': order['id']
                        });
                        this.number = oldNumber;
                        if (Array.isArray(trades) && trades.length) {
                            // move properties that are defined in trades up into the order
                            if (order['symbol'] === undefined) order['symbol'] = trades[0]['symbol'];
                            if (order['side'] === undefined) order['side'] = trades[0]['side'];
                            if (order['type'] === undefined) order['type'] = trades[0]['type'];
                            if (order['id'] === undefined) order['id'] = trades[0]['order'];
                            if (parseFilled) filled = '0';
                            if (parseCost) cost = '0';
                            for(let i = 0; i < trades.length; i++){
                                const trade = trades[i];
                                const tradeAmount = this.safeString(trade, 'amount');
                                if (parseFilled && tradeAmount !== undefined) filled = Precise.stringAdd(filled, tradeAmount);
                                const tradeCost = this.safeString(trade, 'cost');
                                if (parseCost && tradeCost !== undefined) cost = Precise.stringAdd(cost, tradeCost);
                                const tradeTimestamp = this.safeValue(trade, 'timestamp');
                                if (parseLastTradeTimeTimestamp && tradeTimestamp !== undefined) {
                                    if (lastTradeTimeTimestamp === undefined) lastTradeTimeTimestamp = tradeTimestamp;
                                    else lastTradeTimeTimestamp = Math.max(lastTradeTimeTimestamp, tradeTimestamp);
                                }
                                if (shouldParseFees) {
                                    const tradeFees = this.safeValue(trade, 'fees');
                                    if (tradeFees !== undefined) for(let j = 0; j < tradeFees.length; j++){
                                        const tradeFee = tradeFees[j];
                                        fees.push(this.extend({}, tradeFee));
                                    }
                                    else {
                                        const tradeFee = this.safeValue(trade, 'fee');
                                        if (tradeFee !== undefined) fees.push(this.extend({}, tradeFee));
                                    }
                                }
                            }
                        }
                    }
                    if (shouldParseFees) {
                        const reducedFees = this.reduceFees ? this.reduceFeesByCurrency(fees, true) : fees;
                        const reducedLength = reducedFees.length;
                        for(let i = 0; i < reducedLength; i++){
                            reducedFees[i]['cost'] = this.parseNumber(reducedFees[i]['cost']);
                            if ('rate' in reducedFees[i]) reducedFees[i]['rate'] = this.parseNumber(reducedFees['i']['rate']);
                        }
                        if (!parseFee && reducedLength === 0) {
                            fee['cost'] = this.safeNumber(fee, 'cost');
                            if ('rate' in fee) fee['rate'] = this.parseNumber(fee['rate']);
                            reducedFees.push(fee);
                        }
                        if (parseFees) order['fees'] = reducedFees;
                        if (parseFee && reducedLength === 1) order['fee'] = reducedFees[0];
                    }
                    if (amount === undefined) {
                        // ensure amount = filled + remaining
                        if (filled !== undefined && remaining !== undefined) amount = Precise.stringAdd(filled, remaining);
                        else if (this.safeString(order, 'status') === 'closed') amount = filled;
                    }
                    if (filled === undefined) {
                        if (amount !== undefined && remaining !== undefined) filled = Precise.stringSub(amount, remaining);
                    }
                    if (remaining === undefined) {
                        if (amount !== undefined && filled !== undefined) remaining = Precise.stringSub(amount, filled);
                    }
                    // ensure that the average field is calculated correctly
                    if (average === undefined) {
                        if (filled !== undefined && cost !== undefined && Precise.stringGt(filled, '0')) average = Precise.stringDiv(cost, filled);
                    }
                    // also ensure the cost field is calculated correctly
                    const costPriceExists = average !== undefined || price !== undefined;
                    if (parseCost && filled !== undefined && costPriceExists) {
                        let multiplyPrice = undefined;
                        if (average === undefined) multiplyPrice = price;
                        else multiplyPrice = average;
                        // contract trading
                        const contractSize = this.safeString(market, 'contractSize');
                        if (contractSize !== undefined) {
                            const inverse = this.safeValue(market, 'inverse', false);
                            if (inverse) multiplyPrice = Precise.stringDiv('1', multiplyPrice);
                            multiplyPrice = Precise.stringMul(multiplyPrice, contractSize);
                        }
                        cost = Precise.stringMul(multiplyPrice, filled);
                    }
                    // support for market orders
                    const orderType = this.safeValue(order, 'type');
                    const emptyPrice = price === "market_price" || price === undefined || Precise.stringEquals(price, '0');
                    if (emptyPrice && orderType === 'market') price = average;
                    // we have trades with string values at this point so we will mutate them
                    for(let i = 0; i < trades.length; i++){
                        const entry = trades[i];
                        entry['amount'] = this.safeNumber(entry, 'amount');
                        entry['price'] = this.safeNumber(entry, 'price');
                        entry['cost'] = this.safeNumber(entry, 'cost');
                        const fee = this.safeValue(entry, 'fee', {});
                        fee['cost'] = this.safeNumber(fee, 'cost');
                        if ('rate' in fee) fee['rate'] = this.safeNumber(fee, 'rate');
                        entry['fee'] = fee;
                    }
                    // timeInForceHandling
                    let timeInForce = this.safeString(order, 'timeInForce');
                    if (this.safeValue(order, 'postOnly', false)) timeInForce = 'PO';
                    else if (this.safeString(order, 'type') === 'market') timeInForce = 'IOC';
                    return this.extend(order, {
                        'lastTradeTimestamp': lastTradeTimeTimestamp,
                        'price': this.parseNumber(price),
                        'amount': this.parseNumber(amount),
                        'cost': this.parseNumber(cost),
                        'average': this.parseNumber(average),
                        'filled': this.parseNumber(filled),
                        'remaining': this.parseNumber(remaining),
                        'timeInForce': timeInForce,
                        'trades': trades
                    });
                }
                parseNumber(value, d) {
                    if (value === undefined) return d;
                    else try {
                        return this.number(value);
                    } catch (e) {
                        return d;
                    }
                }
                safeNumber(object, key, d) {
                    const value = this.safeString(object, key);
                    return this.parseNumber(value, d);
                }
                safeNumber2(object, key1, key2, d) {
                    const value = this.safeString2(object, key1, key2);
                    return this.parseNumber(value, d);
                }
                parsePrecision(precision) {
                    if (precision === undefined) return undefined;
                    return '1e' + Precise.stringNeg(precision);
                }
                handleWithdrawTagAndParams(tag, params) {
                    if (typeof tag === 'object') {
                        params = this.extend(tag, params);
                        tag = undefined;
                    }
                    if (tag === undefined) {
                        tag = this.safeString(params, 'tag');
                        if (tag !== undefined) params = this.omit(params, 'tag');
                    }
                    return [
                        tag,
                        params
                    ];
                }
                getSupportedMapping(key, mapping = {}) {
                    // Takes a key and a dictionary, and returns the dictionary's value for that key
                    // :throws:
                    //      NotSupported if the dictionary does not contain the key
                    if (key in mapping) return mapping[key];
                    else throw new NotSupported(this.id + ' ' + key + ' does not have a value in mapping');
                }
                async fetchBorrowRate(code, params = {}) {
                    await this.loadMarkets();
                    if (!this.has['fetchBorrowRates']) throw new NotSupported(this.id + ' fetchBorrowRate() is not supported yet');
                    const borrowRates = await this.fetchBorrowRates(params);
                    const rate = this.safeValue(borrowRates, code);
                    if (rate === undefined) throw new ExchangeError1(this.id + ' fetchBorrowRate() could not find the borrow rate for currency code ' + code);
                    return rate;
                }
                handleMarketTypeAndParams(methodName, market, params = {}) {
                    const defaultType = this.safeString2(this.options, 'defaultType', 'type', 'spot');
                    const methodOptions = this.safeValue(this.options, methodName);
                    let methodType = defaultType;
                    if (methodOptions !== undefined) {
                        if (typeof methodOptions === 'string') methodType = methodOptions;
                        else methodType = this.safeString2(methodOptions, 'defaultType', 'type', methodType);
                    }
                    const marketType = market === undefined ? methodType : market['type'];
                    const type = this.safeString2(params, 'defaultType', 'type', marketType);
                    params = this.omit(params, [
                        'defaultType',
                        'type'
                    ]);
                    return [
                        type,
                        params
                    ];
                }
                async loadTimeDifference(params = {}) {
                    const serverTime = await this.fetchTime(params);
                    const after = this.milliseconds();
                    this.options['timeDifference'] = after - serverTime;
                    return this.options['timeDifference'];
                }
                parseLeverageTiers(response, symbols, marketIdKey) {
                    const tiers = {};
                    for(let i = 0; i < response.length; i++){
                        const item = response[i];
                        const id = this.safeString(item, marketIdKey);
                        const market = this.safeMarket(id);
                        const symbol = market['symbol'];
                        let symbolsLength = 0;
                        if (symbols !== undefined) symbolsLength = symbols.length;
                        const contract = this.safeValue(market, 'contract', false);
                        if (contract && (symbolsLength === 0 || symbols.includes(symbol))) tiers[symbol] = this.parseMarketLeverageTiers(item, market);
                    }
                    return tiers;
                }
                async fetchMarketLeverageTiers(symbol, params = {}) {
                    if (this.has['fetchLeverageTiers']) {
                        const market = await this.market(symbol);
                        if (!market['contract']) throw new BadSymbol(this.id + ' fetchLeverageTiers() supports contract markets only');
                        const tiers = await this.fetchLeverageTiers([
                            symbol
                        ]);
                        return this.safeValue(tiers, symbol);
                    } else throw new NotSupported(this.id + ' fetchMarketLeverageTiers() is not supported yet');
                }
                isPostOnly(type, timeInForce, exchangeSpecificOption, params = {}) {
                    /**
         * @param {string} type: Order type
         * @param {string} timeInForce
         * @param {boolean} exchangeSpecificOption: True if the exchange specific post only setting is set
         * @param {dict} params: Exchange specific params
         * @returns {boolean}: true if a post only order, false otherwise
         */ let postOnly = this.safeValue2(params, 'postOnly', 'post_only', false);
                    params = this.omit(params, [
                        'post_only',
                        'postOnly'
                    ]);
                    const timeInForceUpper = timeInForce.toUpperCase();
                    const typeLower = type.toLowerCase();
                    const ioc = timeInForceUpper === 'IOC';
                    const fok = timeInForceUpper === 'FOK';
                    const timeInForcePostOnly = timeInForceUpper === 'PO';
                    const isMarket = typeLower === 'market';
                    postOnly = postOnly || typeLower === 'postonly' || timeInForcePostOnly || exchangeSpecificOption;
                    if (postOnly) {
                        if (ioc || fok) throw new InvalidOrder(this.id + ' postOnly orders cannot have timeInForce equal to ' + timeInForce);
                        else if (isMarket) throw new InvalidOrder(this.id + ' postOnly orders cannot have type ' + type);
                        else {
                            timeInForce = timeInForcePostOnly ? undefined : timeInForce;
                            return [
                                'limit',
                                true,
                                timeInForce,
                                params
                            ];
                        }
                    } else return [
                        type,
                        false,
                        timeInForce,
                        params
                    ];
                }
                async createPostOnlyOrder(symbol, type, side, amount, price, params = {}) {
                    if (!this.has['createPostOnlyOrder']) throw new NotSupported(this.id + 'createPostOnlyOrder() is not supported yet');
                    const query = this.extend(params, {
                        'postOnly': true
                    });
                    return await this.createOrder(symbol, type, side, amount, price, query);
                }
                async createStopOrder(symbol, type, side, amount, price, stopPrice, params = {}) {
                    if (!this.has['createStopOrder']) throw new NotSupported(this.id + ' createStopOrder() is not supported yet');
                    if (stopPrice === undefined) throw new ArgumentsRequired(this.id + ' create_stop_order() requires a stopPrice argument');
                    const query = this.extend(params, {
                        'stopPrice': stopPrice
                    });
                    return await this.createOrder(symbol, type, side, amount, price, query);
                }
                async createStopLimitOrder(symbol, side, amount, price, stopPrice, params = {}) {
                    if (!this.has['createStopLimitOrder']) throw new NotSupported(this.id + ' createStopLimitOrder() is not supported yet');
                    const query = this.extend(params, {
                        'stopPrice': stopPrice
                    });
                    return this.createOrder(symbol, 'limit', side, amount, price, query);
                }
                async createStopMarketOrder(symbol, side, amount, stopPrice, params = {}) {
                    if (!this.has['createStopMarketOrder']) throw new NotSupported(this.id + ' createStopMarketOrder() is not supported yet');
                    const query = this.extend(params, {
                        'stopPrice': stopPrice
                    });
                    return this.createOrder(symbol, 'market', side, amount, undefined, query);
                }
                parseBorrowInterests(response, market) {
                    const interest = [];
                    for(let i = 0; i < response.length; i++){
                        const row = response[i];
                        interest.push(this.parseBorrowInterest(row, market));
                    }
                    return interest;
                }
            };
        },
        {
            "../static_dependencies/BN/bn": 120,
            "./Precise": 6,
            "./errors": 8,
            "./functions": 9
        }
    ],
    6: [
        function(require1, module, exports) {
            'use strict';
            const zero = BigInt(0);
            const minusOne = BigInt(-1);
            const base = BigInt(10);
            class Precise {
                constructor(number, decimals){
                    if (decimals === undefined) {
                        let modifier = 0;
                        number = number.toLowerCase();
                        if (number.indexOf('e') > -1) {
                            [number, modifier] = number.split('e');
                            modifier = parseInt(modifier);
                        }
                        const decimalIndex = number.indexOf('.');
                        this.decimals = decimalIndex > -1 ? number.length - decimalIndex - 1 : 0;
                        const integerString = number.replace('.', '');
                        this.integer = BigInt(integerString);
                        this.decimals = this.decimals - modifier;
                    } else {
                        this.integer = number;
                        this.decimals = decimals;
                    }
                }
                mul(other) {
                    // other must be another instance of Precise
                    const integerResult = this.integer * other.integer;
                    return new Precise(integerResult, this.decimals + other.decimals);
                }
                div(other, precision = 18) {
                    const distance = precision - this.decimals + other.decimals;
                    let numerator;
                    if (distance === 0) numerator = this.integer;
                    else if (distance < 0) {
                        const exponent = base ** BigInt(-distance);
                        numerator = this.integer / exponent;
                    } else {
                        const exponent = base ** BigInt(distance);
                        numerator = this.integer * exponent;
                    }
                    const result = numerator / other.integer;
                    return new Precise(result, precision);
                }
                add(other) {
                    if (this.decimals === other.decimals) {
                        const integerResult = this.integer + other.integer;
                        return new Precise(integerResult, this.decimals);
                    } else {
                        const [smaller, bigger] = this.decimals > other.decimals ? [
                            other,
                            this
                        ] : [
                            this,
                            other
                        ];
                        const exponent = bigger.decimals - smaller.decimals;
                        const normalised = smaller.integer * base ** BigInt(exponent);
                        const result = normalised + bigger.integer;
                        return new Precise(result, bigger.decimals);
                    }
                }
                mod(other) {
                    const rationizerNumerator = Math.max(-this.decimals + other.decimals, 0);
                    const numerator = this.integer * base ** BigInt(rationizerNumerator);
                    const rationizerDenominator = Math.max(-other.decimals + this.decimals, 0);
                    const denominator = other.integer * base ** BigInt(rationizerDenominator);
                    const result = numerator % denominator;
                    return new Precise(result, rationizerDenominator + other.decimals);
                }
                sub(other) {
                    const negative = new Precise(-other.integer, other.decimals);
                    return this.add(negative);
                }
                abs() {
                    return new Precise(this.integer < 0 ? this.integer * minusOne : this.integer, this.decimals);
                }
                neg() {
                    return new Precise(-this.integer, this.decimals);
                }
                min(other) {
                    return this.lt(other) ? this : other;
                }
                max(other) {
                    return this.gt(other) ? this : other;
                }
                gt(other) {
                    const sum = this.sub(other);
                    return sum.integer > 0;
                }
                ge(other) {
                    const sum = this.sub(other);
                    return sum.integer >= 0;
                }
                lt(other) {
                    return other.gt(this);
                }
                le(other) {
                    return other.ge(this);
                }
                reduce() {
                    const string = this.integer.toString();
                    const start = string.length - 1;
                    if (start === 0) {
                        if (string === '0') this.decimals = 0;
                        return this;
                    }
                    let i;
                    for(i = start; i >= 0; i--){
                        if (string.charAt(i) !== '0') break;
                    }
                    const difference = start - i;
                    if (difference === 0) return this;
                    this.decimals -= difference;
                    this.integer = BigInt(string.slice(0, i + 1));
                }
                equals(other) {
                    this.reduce();
                    other.reduce();
                    return this.decimals === other.decimals && this.integer === other.integer;
                }
                toString() {
                    this.reduce();
                    let sign;
                    let abs;
                    if (this.integer < 0) {
                        sign = '-';
                        abs = -this.integer;
                    } else {
                        sign = '';
                        abs = this.integer;
                    }
                    const integerArray = Array.from(abs.toString(this.base).padStart(this.decimals, '0'));
                    const index = integerArray.length - this.decimals;
                    let item;
                    if (index === 0) // if we are adding to the front
                    item = '0.';
                    else if (this.decimals < 0) item = '0'.repeat(-this.decimals);
                    else if (this.decimals === 0) item = '';
                    else item = '.';
                    integerArray.splice(index, 0, item);
                    return sign + integerArray.join('');
                }
                static stringMul(string1, string2) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    return new Precise(string1).mul(new Precise(string2)).toString();
                }
                static stringDiv(string1, string2, precision = 18) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    const string2Precise = new Precise(string2);
                    if (string2Precise.integer === zero) return undefined;
                    return new Precise(string1).div(string2Precise, precision).toString();
                }
                static stringAdd(string1, string2) {
                    if (string1 === undefined && string2 === undefined) return undefined;
                    if (string1 === undefined) return string2;
                    else if (string2 === undefined) return string1;
                    return new Precise(string1).add(new Precise(string2)).toString();
                }
                static stringSub(string1, string2) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    return new Precise(string1).sub(new Precise(string2)).toString();
                }
                static stringAbs(string) {
                    if (string === undefined) return undefined;
                    return new Precise(string).abs().toString();
                }
                static stringNeg(string) {
                    if (string === undefined) return undefined;
                    return new Precise(string).neg().toString();
                }
                static stringMod(string1, string2) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    return new Precise(string1).mod(new Precise(string2)).toString();
                }
                static stringEquals(string1, string2) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    return new Precise(string1).equals(new Precise(string2));
                }
                static stringEq(string1, string2) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    return new Precise(string1).equals(new Precise(string2));
                }
                static stringMin(string1, string2) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    return new Precise(string1).min(new Precise(string2)).toString();
                }
                static stringMax(string1, string2) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    return new Precise(string1).max(new Precise(string2)).toString();
                }
                static stringGt(string1, string2) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    return new Precise(string1).gt(new Precise(string2));
                }
                static stringGe(string1, string2) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    return new Precise(string1).ge(new Precise(string2));
                }
                static stringLt(string1, string2) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    return new Precise(string1).lt(new Precise(string2));
                }
                static stringLe(string1, string2) {
                    if (string1 === undefined || string2 === undefined) return undefined;
                    return new Precise(string1).le(new Precise(string2));
                }
            }
            module.exports = Precise;
        },
        {}
    ],
    7: [
        function(require1, module, exports) {
            'use strict';
            const errorHierarchy = {
                'BaseError': {
                    'ExchangeError': {
                        'AuthenticationError': {
                            'PermissionDenied': {
                                'AccountNotEnabled': {}
                            },
                            'AccountSuspended': {}
                        },
                        'ArgumentsRequired': {},
                        'BadRequest': {
                            'BadSymbol': {},
                            'MarginModeAlreadySet': {}
                        },
                        'BadResponse': {
                            'NullResponse': {}
                        },
                        'InsufficientFunds': {},
                        'InvalidAddress': {
                            'AddressPending': {}
                        },
                        'InvalidOrder': {
                            'OrderNotFound': {},
                            'OrderNotCached': {},
                            'CancelPending': {},
                            'OrderImmediatelyFillable': {},
                            'OrderNotFillable': {},
                            'DuplicateOrderId': {}
                        },
                        'NotSupported': {}
                    },
                    'NetworkError': {
                        'DDoSProtection': {
                            'RateLimitExceeded': {}
                        },
                        'ExchangeNotAvailable': {
                            'OnMaintenance': {}
                        },
                        'InvalidNonce': {},
                        'RequestTimeout': {}
                    }
                }
            };
            module.exports = errorHierarchy;
        },
        {}
    ],
    8: [
        function(require1, module, exports) {
            'use strict';
            const errorHierarchy = require1('./errorHierarchy.js');
            /*  ------------------------------------------------------------------------ */ function subclass(BaseClass, classes, namespace = {}) {
                for (const [className, subclasses] of Object.entries(classes)){
                    const Class = Object.assign(namespace, {
                        /*  By creating a named property, we trick compiler to assign our class constructor function a name.
            Otherwise, all our error constructors would be shown as [Function: Error] in the debugger! And
            the super-useful `e.constructor.name` magic wouldn't work — we then would have no chance to
            obtain a error type string from an error instance programmatically!                               */ [className]: class extends BaseClass {
                            constructor(message){
                                super(message);
                                /*  A workaround to make `instanceof` work on custom Error classes in transpiled ES5.
                    See my blog post for the explanation of this hack:

                    https://medium.com/@xpl/javascript-deriving-from-error-properly-8d2f8f315801        */ this.constructor = Class;
                                this.__proto__ = Class.prototype;
                                this.name = className;
                                this.message = message;
                                // https://github.com/Microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
                                Object.setPrototypeOf(this, Class.prototype);
                            }
                        }
                    })[className];
                    subclass(Class, subclasses, namespace);
                }
                return namespace;
            }
            /*  ------------------------------------------------------------------------ */ module.exports = subclass(// Root class
            Error, // Derived class hierarchy
            errorHierarchy);
        },
        {
            "./errorHierarchy.js": 7
        }
    ],
    9: [
        function(require1, module, exports) {
            'use strict';
            /*  ------------------------------------------------------------------------ */ const { unCamelCase: unCamelCase } = require1('./functions/string');
            const unCamelCasePropertyNames = (x)=>{
                for(const k in x)x[unCamelCase(k)] = x[k] // camel_case_method = camelCaseMethod
                ;
                return x;
            };
            /*  ------------------------------------------------------------------------ */ module.exports = unCamelCasePropertyNames(Object.assign({}, require1('./functions/platform'), require1('./functions/generic'), require1('./functions/string'), require1('./functions/type'), require1('./functions/number'), require1('./functions/encode'), require1('./functions/crypto'), require1('./functions/time'), require1('./functions/throttle'), require1('./functions/misc')));
        /*  ------------------------------------------------------------------------ */ },
        {
            "./functions/crypto": 10,
            "./functions/encode": 11,
            "./functions/generic": 12,
            "./functions/misc": 13,
            "./functions/number": 14,
            "./functions/platform": 15,
            "./functions/string": 16,
            "./functions/throttle": 17,
            "./functions/time": 18,
            "./functions/type": 19
        }
    ],
    10: [
        function(require1, module, exports) {
            'use strict';
            /*  ------------------------------------------------------------------------ */ const CryptoJS = require1('../../static_dependencies/crypto-js/crypto-js');
            const { capitalize: capitalize } = require1('./string');
            const { stringToBase64: stringToBase64, urlencodeBase64: urlencodeBase64 } = require1('./encode');
            const NodeRSA = require1('./../../static_dependencies/node-rsa/NodeRSA');
            const { binaryToBase58: binaryToBase58, byteArrayToWordArray: byteArrayToWordArray } = require1('./encode');
            const elliptic = require1('./../../static_dependencies/elliptic/lib/elliptic');
            const EC = elliptic.ec;
            const EDDSA = elliptic.eddsa;
            const { ArgumentsRequired: ArgumentsRequired1 } = require1('./../errors');
            const BN = require1('../../static_dependencies/BN/bn.js');
            /*  ------------------------------------------------------------------------ */ const hash = (request, hash = 'md5', digest = 'hex')=>{
                const options = {};
                if (hash === 'keccak') {
                    hash = 'SHA3';
                    options['outputLength'] = 256;
                }
                const result = CryptoJS[hash.toUpperCase()](request, options);
                return digest === 'binary' ? result : result.toString(CryptoJS.enc[capitalize(digest)]);
            };
            /*  .............................................   */ const hmac = (request, secret, hash = 'sha256', digest = 'hex')=>{
                const result = CryptoJS['Hmac' + hash.toUpperCase()](request, secret);
                if (digest) {
                    const encoding = digest === 'binary' ? 'Latin1' : capitalize(digest);
                    return result.toString(CryptoJS.enc[capitalize(encoding)]);
                }
                return result;
            };
            /*  .............................................   */ function rsa(request, secret, alg = 'RS256') {
                const algos = {
                    'RS256': 'pkcs1-sha256',
                    'RS512': 'pkcs1-sha512'
                };
                if (!(alg in algos)) throw new ExchangeError(alg + ' is not a supported rsa signing algorithm.');
                const algorithm = algos[alg];
                let key = new NodeRSA(secret, {
                    'environment': 'browser',
                    'signingScheme': algorithm
                });
                return key.sign(request, 'base64', 'binary');
            }
            /**
 * @return {string}
 */ function jwt(request, secret, alg = 'HS256') {
                const algos = {
                    'HS256': 'sha256',
                    'HS384': 'sha384',
                    'HS512': 'sha512'
                };
                const encodedHeader = urlencodeBase64(stringToBase64(JSON.stringify({
                    'alg': alg,
                    'typ': 'JWT'
                })));
                const encodedData = urlencodeBase64(stringToBase64(JSON.stringify(request)));
                const token = [
                    encodedHeader,
                    encodedData
                ].join('.');
                const algoType = alg.slice(0, 2);
                const algorithm = algos[alg];
                let signature = undefined;
                if (algoType === 'HS') signature = urlencodeBase64(hmac(token, secret, algorithm, 'base64'));
                else if (algoType === 'RS') signature = urlencodeBase64(rsa(token, secret, alg));
                return [
                    token,
                    signature
                ].join('.');
            }
            function ecdsa(request, secret, algorithm = 'p256', hashFunction, fixedLength = false) {
                let digest = request;
                if (hashFunction !== undefined) digest = hash(request, hashFunction, 'hex');
                const curve = new EC(algorithm);
                let signature = curve.sign(digest, secret, 'hex', {
                    'canonical': true
                });
                let counter = new BN('0');
                const minimum_size = new BN('1').shln(248).sub(new BN('1'));
                while(fixedLength && (signature.r.gt(curve.nh) || signature.r.lte(minimum_size) || signature.s.lte(minimum_size))){
                    signature = curve.sign(digest, secret, 'hex', {
                        'canonical': true,
                        'extraEntropy': counter.toArray('le', 32)
                    });
                    counter = counter.add(new BN('1'));
                }
                return {
                    'r': signature.r.toString(16).padStart(64, '0'),
                    's': signature.s.toString(16).padStart(64, '0'),
                    'v': signature.recoveryParam
                };
            }
            function eddsa(request, secret, algorithm = 'ed25519') {
                // used for waves.exchange (that's why the output is base58)
                const curve = new EDDSA(algorithm);
                const signature = curve.signModified(request, secret);
                return binaryToBase58(byteArrayToWordArray(signature.toBytes()));
            }
            /*  ------------------------------------------------------------------------ */ const totp = (secret)=>{
                const dec2hex = (s)=>(s < 15.5 ? '0' : '') + Math.round(s).toString(16), hex2dec = (s)=>parseInt(s, 16), leftpad = (s, p)=>(p + s).slice(-p.length) // both s and p are short strings
                ;
                const base32tohex = (base32)=>{
                    let base32chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
                    let bits = '';
                    let hex = '';
                    for(let i = 0; i < base32.length; i++){
                        let val = base32chars.indexOf(base32.charAt(i).toUpperCase());
                        bits += leftpad(val.toString(2), '00000');
                    }
                    for(let i = 0; i + 4 <= bits.length; i += 4){
                        let chunk = bits.substr(i, 4);
                        hex = hex + parseInt(chunk, 2).toString(16);
                    }
                    return hex;
                };
                const getOTP = (secret)=>{
                    secret = secret.replace(' ', '') // support 2fa-secrets with spaces like "4TDV WOGO" → "4TDVWOGO"
                    ;
                    let epoch = Math.round(new Date().getTime() / 1000.0);
                    let time = leftpad(dec2hex(Math.floor(epoch / 30)), '0000000000000000');
                    let hmacRes = hmac(CryptoJS.enc.Hex.parse(time), CryptoJS.enc.Hex.parse(base32tohex(secret)), 'sha1', 'hex');
                    let offset = hex2dec(hmacRes.substring(hmacRes.length - 1));
                    let otp = (hex2dec(hmacRes.substr(offset * 2, 8)) & hex2dec('7fffffff')) + '';
                    otp = otp.substr(otp.length - 6, 6);
                    return otp;
                };
                return getOTP(secret);
            };
            /*  ------------------------------------------------------------------------ */ module.exports = {
                hash: hash,
                hmac: hmac,
                jwt: jwt,
                totp: totp,
                rsa: rsa,
                ecdsa: ecdsa,
                eddsa: eddsa
            };
        /*  ------------------------------------------------------------------------ */ },
        {
            "../../static_dependencies/BN/bn.js": 120,
            "../../static_dependencies/crypto-js/crypto-js": 121,
            "./../../static_dependencies/elliptic/lib/elliptic": 122,
            "./../../static_dependencies/node-rsa/NodeRSA": 140,
            "./../errors": 8,
            "./encode": 11,
            "./string": 16
        }
    ],
    11: [
        function(require1, module, exports) {
            "use strict";
            /*  ------------------------------------------------------------------------ */ const CryptoJS = require1('../../static_dependencies/crypto-js/crypto-js');
            const qs = require1('../../static_dependencies/qs/index');
            const BN = require1('../../static_dependencies/BN/bn');
            /*  ------------------------------------------------------------------------ */ // global vars for base58 encoding
            const base58Alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
            let base58Decoder = null;
            let base58Encoder = null;
            /*  ------------------------------------------------------------------------ */ module.exports = {
                json: (data, params)=>JSON.stringify(data),
                isJsonEncodedObject: (object)=>typeof object === 'string' && object.length >= 2 && (object[0] === '{' || object[0] === '['),
                stringToBinary: (string)=>CryptoJS.enc.Latin1.parse(string),
                stringToBase64: (string)=>CryptoJS.enc.Latin1.parse(string).toString(CryptoJS.enc.Base64),
                base64ToBinary: (string)=>CryptoJS.enc.Base64.parse(string),
                base64ToString: (string)=>CryptoJS.enc.Base64.parse(string).toString(CryptoJS.enc.Utf8),
                binaryToBase64: (binary)=>binary.toString(CryptoJS.enc.Base64),
                base16ToBinary: (string)=>CryptoJS.enc.Hex.parse(string),
                binaryToBase16: (binary)=>binary.toString(CryptoJS.enc.Hex),
                binaryConcat: (...args)=>args.reduce((a, b)=>a.concat(b)),
                binaryConcatArray: (arr)=>arr.reduce((a, b)=>a.concat(b)),
                urlencode: (object)=>qs.stringify(object),
                urlencodeNested: (object)=>qs.stringify(object) // implemented only in python
                ,
                urlencodeWithArrayRepeat: (object)=>qs.stringify(object, {
                        arrayFormat: 'repeat'
                    }),
                rawencode: (object)=>qs.stringify(object, {
                        encode: false
                    }),
                encode: (x)=>x,
                decode: (x)=>x,
                urlencodeBase64: (base64string)=>base64string.replace(/[=]+$/, '').replace(/\+/g, '-').replace(/\//g, '_'),
                numberToLE: (n, padding)=>{
                    const hexArray = new BN(n).toArray('le', padding);
                    return byteArrayToWordArray(hexArray);
                },
                numberToBE: (n, padding)=>{
                    const hexArray = new BN(n).toArray('be', padding);
                    return byteArrayToWordArray(hexArray);
                },
                base58ToBinary: (string)=>{
                    if (!base58Decoder) {
                        base58Decoder = {};
                        base58Encoder = {};
                        for(let i = 0; i < 58; i++){
                            const c = base58Alphabet[i];
                            const bigNum = new BN(i);
                            base58Decoder[c] = bigNum;
                            base58Encoder[bigNum] = c;
                        }
                    }
                    let result = new BN(0);
                    const base = new BN(58);
                    for(let i = 0; i < string.length; i++){
                        const character = string[i];
                        result.imul(base);
                        result.iadd(base58Decoder[character]);
                    }
                    return byteArrayToWordArray(result.toArray('be'));
                },
                binaryToBase58: (wordArray)=>{
                    if (!base58Encoder) {
                        base58Decoder = {};
                        base58Encoder = {};
                        for(let i = 0; i < 58; i++){
                            const c = base58Alphabet[i];
                            const bigNum = new BN(i);
                            base58Decoder[c] = bigNum;
                            base58Encoder[bigNum] = c;
                        }
                    }
                    const base = new BN(58);
                    // hex is only compatible encoding between cryptojs and BN
                    const hexString = wordArray.toString(CryptoJS.enc.Hex);
                    let result = new BN(hexString, 16);
                    let string = [];
                    while(!result.isZero()){
                        const { div: div, mod: mod } = result.divmod(base);
                        result = div;
                        string.push(base58Encoder[mod]);
                    }
                    return string.reverse().join('');
                }
            };
            function byteArrayToWordArray(ba) {
                const wa = [];
                for(let i = 0; i < ba.length; i++)wa[i / 4 | 0] |= ba[i] << 24 - 8 * i;
                return CryptoJS.lib.WordArray.create(wa, ba.length);
            }
            module.exports['byteArrayToWordArray'] = byteArrayToWordArray;
        /*  ------------------------------------------------------------------------ */ },
        {
            "../../static_dependencies/BN/bn": 120,
            "../../static_dependencies/crypto-js/crypto-js": 121,
            "../../static_dependencies/qs/index": 156
        }
    ],
    12: [
        function(require1, module, exports) {
            "use strict";
            // ----------------------------------------------------------------------------
            const { isObject: isObject, isNumber: isNumber, isDictionary: isDictionary, isArray: isArray } = require1('./type');
            // ----------------------------------------------------------------------------
            const keys = Object.keys, values = (x)=>!isArray(x) ? Object.values(x) : x // don't copy arrays if they're already arrays
            , index = (x)=>new Set(values(x)), extend = (...args)=>Object.assign({}, ...args) // NB: side-effect free
            , clone = (x)=>isArray(x) ? Array.from(x) : extend(x) // clone arrays or objects
            ;
            // ----------------------------------------------------------------------------
            module.exports = {
                keys: keys,
                values: values,
                extend: extend,
                clone: clone,
                index: index,
                ordered: (x)=>x // a stub to keep assoc keys in order (in JS it does nothing, it's mostly for Python)
                ,
                unique: (x)=>Array.from(index(x)),
                arrayConcat: (a, b)=>a.concat(b),
                inArray (needle, haystack) {
                    return haystack.includes(needle);
                },
                toArray (object) {
                    return Object.values(object);
                },
                isEmpty (object) {
                    if (!object) return true;
                    return (Array.isArray(object) ? object : Object.keys(object)).length < 1;
                },
                keysort (x, out = {}) {
                    for (const k of keys(x).sort())out[k] = x[k];
                    return out;
                },
                indexBy (x, k, out = {}) {
                    for (const v of values(x))if (k in v) out[v[k]] = v;
                    return out;
                },
                groupBy (x, k, out = {}) {
                    for (const v of values(x))if (k in v) {
                        const p = v[k];
                        out[p] = out[p] || [];
                        out[p].push(v);
                    }
                    return out;
                },
                filterBy (x, k, value, out = []) {
                    for (const v of values(x))if (v[k] === value) out.push(v);
                    return out;
                },
                sortBy: (array, key, descending = false, direction = descending ? -1 : 1)=>array.sort((a, b)=>{
                        if (a[key] < b[key]) return -direction;
                        else if (a[key] > b[key]) return direction;
                        else return 0;
                    }),
                sortBy2: (array, key1, key2, descending = false, direction = descending ? -1 : 1)=>array.sort((a, b)=>{
                        if (a[key1] < b[key1]) return -direction;
                        else if (a[key1] > b[key1]) return direction;
                        else {
                            if (a[key2] < b[key2]) return -direction;
                            else if (a[key2] > b[key2]) return direction;
                            else return 0;
                        }
                    }),
                flatten: function flatten(x, out = []) {
                    for (const v of x)if (isArray(v)) flatten(v, out);
                    else out.push(v);
                    return out;
                },
                pluck: (x, k)=>values(x).filter((v)=>k in v).map((v)=>v[k]),
                omit (x, ...args) {
                    if (!Array.isArray(x)) {
                        const out = clone(x);
                        for (const k of args){
                            if (isArray(k)) for (const kk of k)delete out[kk];
                            else delete out[k] // omit (x, 'a', 'b')
                            ;
                        }
                        return out;
                    }
                    return x;
                },
                sum (...xs) {
                    const ns = xs.filter(isNumber) // leave only numbers
                    ;
                    return ns.length > 0 ? ns.reduce((a, b)=>a + b, 0) : undefined;
                },
                deepExtend: function deepExtend(...xs) {
                    let out = undefined;
                    for (const x of xs)if (isDictionary(x)) {
                        if (!isDictionary(out)) out = {};
                        for(const k in x)out[k] = deepExtend(out[k], x[k]);
                    } else out = x;
                    return out;
                },
                merge (target, ...args) {
                    // doesn't overwrite defined keys with undefined
                    const overwrite = {};
                    const merged = Object.assign({}, ...args);
                    const keys = Object.keys(merged);
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        if (target[key] === undefined) overwrite[key] = merged[key];
                    }
                    // eslint-disable-next-line
                    return Object.assign({}, target, overwrite);
                }
            };
        },
        {
            "./type": 19
        }
    ],
    13: [
        function(require1, module, exports) {
            'use strict';
            const { ROUND_UP: ROUND_UP, ROUND_DOWN: ROUND_DOWN } = require1('./number');
            const { NotSupported: NotSupported } = require1('../errors');
            //-------------------------------------------------------------------------
            // converts timeframe to seconds
            const parseTimeframe = (timeframe)=>{
                const amount = timeframe.slice(0, -1);
                const unit = timeframe.slice(-1);
                let scale = undefined;
                if (unit === 'y') scale = 31536000;
                else if (unit === 'M') scale = 2592000;
                else if (unit === 'w') scale = 604800;
                else if (unit === 'd') scale = 86400;
                else if (unit === 'h') scale = 3600;
                else if (unit === 'm') scale = 60;
                else if (unit === 's') scale = 1;
                else throw new NotSupported('timeframe unit ' + unit + ' is not supported');
                return amount * scale;
            };
            const roundTimeframe = (timeframe, timestamp, direction = ROUND_DOWN)=>{
                const ms = parseTimeframe(timeframe) * 1000;
                // Get offset based on timeframe in milliseconds
                const offset = timestamp % ms;
                return timestamp - offset + (direction === ROUND_UP ? ms : 0);
            };
            // given a sorted arrays of trades (recent last) and a timeframe builds an array of OHLCV candles
            const buildOHLCVC = (trades, timeframe = '1m', since = -Infinity, limit = Infinity)=>{
                const ms = parseTimeframe(timeframe) * 1000;
                const ohlcvs = [];
                const [timestamp, , high, low, close, volume, count] = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ];
                const oldest = Math.min(trades.length - 1, limit);
                for(let i = 0; i <= oldest; i++){
                    const trade = trades[i];
                    if (trade.timestamp < since) continue;
                    const openingTime = Math.floor(trade.timestamp / ms) * ms; // shift to the edge of m/h/d (but not M)
                    const candle = ohlcvs.length - 1;
                    if (candle === -1 || openingTime >= ohlcvs[candle][timestamp] + ms) // moved to a new timeframe -> create a new candle from opening trade
                    ohlcvs.push([
                        openingTime,
                        trade.price,
                        trade.price,
                        trade.price,
                        trade.price,
                        trade.amount,
                        1
                    ]);
                    else {
                        // still processing the same timeframe -> update opening trade
                        ohlcvs[candle][high] = Math.max(ohlcvs[candle][high], trade.price);
                        ohlcvs[candle][low] = Math.min(ohlcvs[candle][low], trade.price);
                        ohlcvs[candle][close] = trade.price;
                        ohlcvs[candle][volume] += trade.amount;
                        ohlcvs[candle][count]++;
                    } // if
                } // for
                return ohlcvs;
            };
            const extractParams = (string)=>{
                const re = /{([\w-]+)}/g;
                const matches = [];
                let match = re.exec(string);
                while(match){
                    matches.push(match[1]);
                    match = re.exec(string);
                }
                return matches;
            };
            const implodeParams = (string, params)=>{
                if (!Array.isArray(params)) {
                    const keys = Object.keys(params);
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        if (!Array.isArray(params[key])) string = string.replace('{' + key + '}', params[key]);
                    }
                }
                return string;
            };
            function vwap(baseVolume, quoteVolume) {
                return baseVolume !== undefined && quoteVolume !== undefined && baseVolume > 0 ? quoteVolume / baseVolume : undefined;
            }
            /*  ------------------------------------------------------------------------ */ module.exports = {
                aggregate (bidasks) {
                    const result = {};
                    for(let i = 0; i < bidasks.length; i++){
                        const [price, volume] = bidasks[i];
                        if (volume > 0) result[price] = (result[price] || 0) + volume;
                    }
                    return Object.keys(result).map((price)=>[
                            parseFloat(price),
                            parseFloat(result[price])
                        ]);
                },
                parseTimeframe: parseTimeframe,
                roundTimeframe: roundTimeframe,
                buildOHLCVC: buildOHLCVC,
                ROUND_UP: ROUND_UP,
                ROUND_DOWN: ROUND_DOWN,
                implodeParams: implodeParams,
                extractParams: extractParams,
                vwap: vwap
            };
        /*  ------------------------------------------------------------------------ */ },
        {
            "../errors": 8,
            "./number": 14
        }
    ],
    14: [
        function(require1, module, exports) {
            'use strict';
            /*  ------------------------------------------------------------------------

    NB: initially, I used objects for options passing:

            decimalToPrecision ('123.456', { digits: 2, round: true, afterPoint: true })

    ...but it turns out it's hard to port that across different languages and it is also
       probably has a performance penalty -- while it's a performance critical code! So
       I switched to using named constants instead, as it is actually more readable and
       succinct, and surely doesn't come with any inherent performance downside:

            decimalToPrecision ('123.456', ROUND, 2, DECIMAL_PLACES)                     */ const ROUND = 0 // rounding mode
            , TRUNCATE = 1, ROUND_UP = 2, ROUND_DOWN = 3;
            const DECIMAL_PLACES = 0 // digits counting mode
            , SIGNIFICANT_DIGITS = 1, TICK_SIZE = 2;
            const NO_PADDING = 0 // zero-padding mode
            , PAD_WITH_ZERO = 1;
            const precisionConstants = {
                ROUND: ROUND,
                TRUNCATE: TRUNCATE,
                ROUND_UP: ROUND_UP,
                ROUND_DOWN: ROUND_DOWN,
                DECIMAL_PLACES: DECIMAL_PLACES,
                SIGNIFICANT_DIGITS: SIGNIFICANT_DIGITS,
                TICK_SIZE: TICK_SIZE,
                NO_PADDING: NO_PADDING,
                PAD_WITH_ZERO: PAD_WITH_ZERO
            };
            /*  ------------------------------------------------------------------------ */ // See https://stackoverflow.com/questions/1685680/how-to-avoid-scientific-notation-for-large-numbers-in-javascript for discussion
            function numberToString(x) {
                if (x === undefined) return undefined;
                if (typeof x !== 'number') return x.toString();
                const s = x.toString();
                if (Math.abs(x) < 1.0) {
                    const n_e = s.split('e-');
                    const n = n_e[0].replace('.', '');
                    const e = parseInt(n_e[1]);
                    const neg = s[0] === '-';
                    if (e) {
                        x = (neg ? '-' : '') + '0.' + new Array(e).join('0') + n.substring(neg);
                        return x;
                    }
                } else {
                    const parts = s.split('e');
                    if (parts[1]) {
                        let e = parseInt(parts[1]);
                        const m = parts[0].split('.');
                        let part = '';
                        if (m[1]) {
                            e -= m[1].length;
                            part = m[1];
                        }
                        return m[0] + part + new Array(e + 1).join('0');
                    }
                }
                return s;
            }
            //-----------------------------------------------------------------------------
            // expects non-scientific notation
            const truncate_regExpCache = [], truncate_to_string = (num, precision = 0)=>{
                num = numberToString(num);
                if (precision > 0) {
                    const re = truncate_regExpCache[precision] || (truncate_regExpCache[precision] = new RegExp("([-]*\\d+\\.\\d{" + precision + "})(\\d)"));
                    const [, result] = num.toString().match(re) || [
                        null,
                        num
                    ];
                    return result.toString();
                }
                return parseInt(num).toString();
            }, truncate = (num, precision = 0)=>parseFloat(truncate_to_string(num, precision));
            function precisionFromString(string) {
                const split = string.replace(/0+$/g, '').split('.');
                return split.length > 1 ? split[1].length : 0;
            }
            /*  ------------------------------------------------------------------------ */ const decimalToPrecision = (x, roundingMode, numPrecisionDigits, countingMode = DECIMAL_PLACES, paddingMode = NO_PADDING)=>{
                if (countingMode === TICK_SIZE) {
                    if (numPrecisionDigits <= 0) throw new Error('TICK_SIZE cant be used with negative or zero numPrecisionDigits');
                }
                if (numPrecisionDigits < 0) {
                    const toNearest = Math.pow(10, -numPrecisionDigits);
                    if (roundingMode === ROUND) return (toNearest * decimalToPrecision(x / toNearest, roundingMode, 0, countingMode, paddingMode)).toString();
                    if (roundingMode === TRUNCATE) return (x - x % toNearest).toString();
                }
                /*  handle tick size */ if (countingMode === TICK_SIZE) {
                    const precisionDigitsString = decimalToPrecision(numPrecisionDigits, ROUND, 22, DECIMAL_PLACES, NO_PADDING);
                    const newNumPrecisionDigits = precisionFromString(precisionDigitsString);
                    let missing = x % numPrecisionDigits;
                    // See: https://github.com/ccxt/ccxt/pull/6486
                    missing = Number(decimalToPrecision(missing, ROUND, 8, DECIMAL_PLACES, NO_PADDING));
                    const fpError = decimalToPrecision(missing / numPrecisionDigits, ROUND, Math.max(newNumPrecisionDigits, 8), DECIMAL_PLACES, NO_PADDING);
                    if (precisionFromString(fpError) !== 0) {
                        if (roundingMode === ROUND) {
                            if (x > 0) {
                                if (missing >= numPrecisionDigits / 2) x = x - missing + numPrecisionDigits;
                                else x = x - missing;
                            } else if (missing >= numPrecisionDigits / 2) x = Number(x) - missing;
                            else x = Number(x) - missing - numPrecisionDigits;
                        } else if (roundingMode === TRUNCATE) x = x - missing;
                    }
                    return decimalToPrecision(x, ROUND, newNumPrecisionDigits, DECIMAL_PLACES, paddingMode);
                }
                /*  Convert to a string (if needed), skip leading minus sign (if any)   */ const str = numberToString(x), isNegative = str[0] === '-', strStart = isNegative ? 1 : 0, strEnd = str.length;
                /*  Find the dot position in the source buffer   */ for(var strDot = 0; strDot < strEnd; strDot++)if (str[strDot] === '.') break;
                const hasDot = strDot < str.length;
                /*  Char code constants         */ const MINUS = 45, DOT = 46, ZERO = 48, ONE = ZERO + 1, FIVE = ZERO + 5, NINE = ZERO + 9;
                /*  For -123.4567 the `chars` array will hold 01234567 (leading zero is reserved for rounding cases when 099 → 100)    */ const chars = new Uint8Array(strEnd - strStart + (hasDot ? 0 : 1));
                chars[0] = ZERO;
                /*  Validate & copy digits, determine certain locations in the resulting buffer  */ let afterDot = chars.length, digitsStart = -1 // significant digits
                , digitsEnd = -1;
                for(var i = 1, j = strStart; j < strEnd; j++, i++){
                    const c = str.charCodeAt(j);
                    if (c === DOT) afterDot = i--;
                    else if (c < ZERO || c > NINE) throw new Error(`${str}: invalid number (contains an illegal character '${str[i - 1]}')`);
                    else {
                        chars[i] = c;
                        if (c !== ZERO && digitsStart < 0) digitsStart = i;
                    }
                }
                if (digitsStart < 0) digitsStart = 1;
                /*  Determine the range to cut  */ let precisionStart = countingMode === DECIMAL_PLACES ? afterDot // 0.(0)001234567
                 : digitsStart // 0.00(1)234567
                , precisionEnd = precisionStart + numPrecisionDigits;
                /*  Reset the last significant digit index, as it will change during the rounding/truncation.   */ digitsEnd = -1;
                /*  Perform rounding/truncation per digit, from digitsEnd to digitsStart, by using the following
    algorithm (rounding 999 → 1000, as an example):

        step  =          i=3      i=2      i=1      i=0

        chars =         0999     0999     0900     1000
        memo  =         ---0     --1-     -1--     0---                     */ let allZeros = true;
                let signNeeded = isNegative;
                for(let i = chars.length - 1, memo = 0; i >= 0; i--){
                    let c = chars[i];
                    if (i !== 0) {
                        c += memo;
                        if (i >= precisionStart + numPrecisionDigits) {
                            const ceil = roundingMode === ROUND && c >= FIVE && !(c === FIVE && memo // prevents rounding of 1.45 to 2
                            );
                            c = ceil ? NINE + 1 : ZERO;
                        }
                        if (c > NINE) {
                            c = ZERO;
                            memo = 1;
                        } else memo = 0;
                    } else if (memo) c = ONE // leading extra digit (0900 → 1000)
                    ;
                    chars[i] = c;
                    if (c !== ZERO) {
                        allZeros = false;
                        digitsStart = i;
                        digitsEnd = digitsEnd < 0 ? i + 1 : digitsEnd;
                    }
                }
                /*  Update the precision range, as `digitsStart` may have changed... & the need for a negative sign if it is only 0    */ if (countingMode === SIGNIFICANT_DIGITS) {
                    precisionStart = digitsStart;
                    precisionEnd = precisionStart + numPrecisionDigits;
                }
                if (allZeros) signNeeded = false;
                /*  Determine the input character range     */ const readStart = digitsStart >= afterDot || allZeros ? afterDot - 1 : digitsStart // 0.000(1)234  ----> (0).0001234
                , readEnd = digitsEnd < afterDot ? afterDot : digitsEnd // 12(3)000     ----> 123000( )
                ;
                /*  Compute various sub-ranges       */ const nSign = signNeeded ? 1 : 0 // (-)123.456
                , nBeforeDot = nSign + (afterDot - readStart) // (-123).456
                , nAfterDot = Math.max(readEnd - afterDot, 0) // -123.(456)
                , actualLength = readEnd - readStart // -(123.456)
                , desiredLength = paddingMode === NO_PADDING ? actualLength // -(123.456)
                 : precisionEnd - readStart // -(123.456    )
                , pad = Math.max(desiredLength - actualLength, 0) //  -123.456(    )
                , padStart = nBeforeDot + 1 + nAfterDot //  -123.456( )
                , padEnd = padStart + pad //  -123.456     ( )
                , isInteger = nAfterDot + pad === 0 //  -123
                ;
                /*  Fill the output buffer with characters    */ const out = new Uint8Array(nBeforeDot + (isInteger ? 0 : 1) + nAfterDot + pad);
                // ------------------------------------------------------------------------------------------ // ---------------------
                if (signNeeded) out[0] = MINUS // -     minus sign
                ;
                for(i = nSign, j = readStart; i < nBeforeDot; i++, j++)out[i] = chars[j] // 123   before dot
                ;
                if (!isInteger) out[nBeforeDot] = DOT // .     dot
                ;
                for(i = nBeforeDot + 1, j = afterDot; i < padStart; i++, j++)out[i] = chars[j] // 456   after dot
                ;
                for(i = padStart; i < padEnd; i++)out[i] = ZERO // 000   padding
                ;
                /*  Build a string from the output buffer     */ return String.fromCharCode(...out);
            };
            function omitZero(stringNumber) {
                if (stringNumber === undefined || stringNumber === '') return undefined;
                if (parseFloat(stringNumber) === 0) return undefined;
                return stringNumber;
            }
            /*  ------------------------------------------------------------------------ */ module.exports = {
                numberToString: numberToString,
                precisionFromString: precisionFromString,
                decimalToPrecision: decimalToPrecision,
                truncate_to_string: truncate_to_string,
                truncate: truncate,
                omitZero: omitZero,
                precisionConstants: precisionConstants,
                ROUND: ROUND,
                TRUNCATE: TRUNCATE,
                ROUND_UP: ROUND_UP,
                ROUND_DOWN: ROUND_DOWN,
                DECIMAL_PLACES: DECIMAL_PLACES,
                SIGNIFICANT_DIGITS: SIGNIFICANT_DIGITS,
                TICK_SIZE: TICK_SIZE,
                NO_PADDING: NO_PADDING,
                PAD_WITH_ZERO: PAD_WITH_ZERO
            };
        /*  ------------------------------------------------------------------------ */ },
        {}
    ],
    15: [
        function(require1, module, exports) {
            (function(process) {
                "use strict";
                // ----------------------------------------------------------------------------
                // There's been a lot of messing with this code...
                // The problem is to satisfy the following requirements:
                // - properly detect isNode == true on server side and isNode == false in the browser (on client side)
                // - make sure create-react-app, react-starter-kit and other react frameworks work
                // - make sure it does not break the browserified version (when linked into a html from a cdn)
                // - make sure it does not break the webpacking and babel-transpiled scripts
                // - make sure it works in Electron
                // - make sure it works with Angular.js
                // - make sure it does not break other possible usage scenarios
                const isBrowser = typeof window !== 'undefined';
                const isElectron = typeof process !== 'undefined' && typeof process.versions !== 'undefined' && typeof process.versions.electron !== 'undefined';
                const isWebWorker = typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
                const isWindows = typeof process !== 'undefined' && process.platform === "win32";
                const isNode = !(isBrowser || isWebWorker);
                const defaultFetch = typeof fetch === "undefined" ? require1('../../static_dependencies/fetch-ponyfill/fetch-node')().fetch : fetch;
                // ----------------------------------------------------------------------------
                module.exports = {
                    isBrowser: isBrowser,
                    isElectron: isElectron,
                    isWebWorker: isWebWorker,
                    isNode: isNode,
                    isWindows: isWindows,
                    defaultFetch: defaultFetch
                };
            }).call(this, require1('_process'));
        },
        {
            "../../static_dependencies/fetch-ponyfill/fetch-node": 138,
            "_process": 204
        }
    ],
    16: [
        function(require1, module, exports) {
            "use strict";
            // ----------------------------------------------------------------------------
            const uuid = (a)=>a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, uuid);
            const uuid16 = (a)=>a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : "1000001004008000".replace(/[018]/g, uuid16);
            const uuid22 = (a)=>a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : "1000000010004000800000".replace(/[018]/g, uuid22);
            // ----------------------------------------------------------------------------
            module.exports = {
                uuid: uuid,
                uuid16: uuid16,
                uuid22: uuid22,
                unCamelCase: (s)=>s.match(/^[A-Z0-9_]+$/) ? s : s.replace(/[a-z0-9][A-Z]/g, (x)=>x[0] + '_' + x[1]).replace(/[A-Z0-9][A-Z0-9][a-z]/g, (x)=>x[0] + '_' + x[1] + x[2]).toLowerCase(),
                capitalize: (s)=>s.length ? s.charAt(0).toUpperCase() + s.slice(1) : s,
                strip: (s)=>s.replace(/^\s+|\s+$/g, '')
            };
        },
        {}
    ],
    17: [
        function(require1, module, exports) {
            "use strict";
            /*  ------------------------------------------------------------------------ */ const { now: now, sleep: sleep } = require1('./time');
            /*  ------------------------------------------------------------------------ */ class Throttle {
                constructor(config){
                    this.config = {
                        refillRate: 1.0,
                        delay: 0.001,
                        capacity: 1.0,
                        maxCapacity: 2000,
                        tokens: 0,
                        cost: 1.0
                    };
                    Object.assign(this.config, config);
                    this.queue = [];
                    this.running = false;
                }
                async loop() {
                    let lastTimestamp = now();
                    while(this.running){
                        const { resolver: resolver, cost: cost } = this.queue[0];
                        if (this.config['tokens'] >= 0) {
                            this.config['tokens'] -= cost;
                            resolver();
                            this.queue.shift();
                            // contextswitch
                            await Promise.resolve();
                            if (this.queue.length === 0) this.running = false;
                        } else {
                            await sleep(this.config['delay'] * 1000);
                            const current = now();
                            const elapsed = current - lastTimestamp;
                            lastTimestamp = current;
                            this.config['tokens'] = Math.min(this.config['tokens'] + this.config['refillRate'] * elapsed, this.config['capacity']);
                        }
                    }
                }
            }
            function throttle(config) {
                function inner(cost) {
                    let resolver;
                    const promise = new Promise((resolve, reject)=>{
                        resolver = resolve;
                    });
                    if (this.queue.length > this.config['maxCapacity']) throw new Error('throttle queue is over maxCapacity');
                    cost = cost === undefined ? this.config['cost'] : cost;
                    this.queue.push({
                        resolver: resolver,
                        cost: cost
                    });
                    if (!this.running) {
                        this.running = true;
                        this.loop();
                    }
                    return promise;
                }
                const instance = new Throttle(config);
                const bound = inner.bind(instance);
                // useful for inspecting the tokenBucket
                bound.config = instance.config;
                return bound;
            }
            module.exports = {
                throttle: throttle
            };
        // ----------------------------------------
        },
        {
            "./time": 18
        }
    ],
    18: [
        function(require1, module, exports) {
            'use strict';
            /*  ------------------------------------------------------------------------ */ const now = Date.now // TODO: figure out how to utilize performance.now () properly – it's not as easy as it does not return a unix timestamp...
            ;
            const microseconds = ()=>now() * 1000 // TODO: utilize performance.now for that purpose
            ;
            const milliseconds = now;
            const seconds = ()=>Math.floor(now() / 1000);
            const uuidv1 = ()=>{
                const biasSeconds = 12219292800 // seconds from 15th Oct 1572 to Jan 1st 1970
                ;
                const bias = biasSeconds * 10000000 // in hundreds of nanoseconds
                ;
                const time = microseconds() * 10 + bias;
                const timeHex = time.toString(16);
                const arranged = timeHex.slice(7, 15) + timeHex.slice(3, 7) + '1' + timeHex.slice(0, 3);
                // these should be random, but we're not making more than 10 requests per microsecond so who cares
                const clockId = '9696' // a 14 bit number
                ;
                const macAddress = 'ff'.repeat(6);
                return arranged + clockId + macAddress;
            };
            /*  ------------------------------------------------------------------------ */ const setTimeout_original = setTimeout;
            const setTimeout_safe = (done, ms, setTimeout1 = setTimeout_original /* overrideable for mocking purposes */ , targetTime = now() + ms)=>{
                // avoid MAX_INT issue https://stackoverflow.com/questions/60474110
                if (ms >= 2147483647) throw new Exception('setTimeout() function was called with unrealistic value of ' + ms.toString());
                // The built-in setTimeout function can fire its callback earlier than specified, so we
                // need to ensure that it does not happen: sleep recursively until `targetTime` is reached...
                let clearInnerTimeout = ()=>{};
                let active = true;
                const id = setTimeout1(()=>{
                    active = true;
                    const rest = targetTime - now();
                    if (rest > 0) clearInnerTimeout = setTimeout_safe(done, rest, setTimeout1, targetTime) // try sleep more
                    ;
                    else done();
                }, ms);
                return function clear() {
                    if (active) {
                        active = false // dunno if IDs are unique on various platforms, so it's better to rely on this flag to exclude the possible cancellation of the wrong timer (if called after completion)
                        ;
                        clearTimeout(id);
                    }
                    clearInnerTimeout();
                };
            };
            /*  ------------------------------------------------------------------------ */ class TimedOut extends Error {
                constructor(){
                    const message = 'timed out';
                    super(message);
                    this.constructor = TimedOut;
                    this.__proto__ = TimedOut.prototype;
                    this.message = message;
                }
            }
            /*  ------------------------------------------------------------------------ */ const iso8601 = (timestamp)=>{
                let _timestampNumber = undefined;
                if (typeof timestamp === 'number') _timestampNumber = Math.floor(timestamp);
                else _timestampNumber = parseInt(timestamp, 10);
                // undefined, null and lots of nasty non-numeric values yield NaN
                if (Number.isNaN(_timestampNumber) || _timestampNumber < 0) return undefined;
                // last line of defence
                try {
                    return new Date(_timestampNumber).toISOString();
                } catch (e) {
                    return undefined;
                }
            };
            const parse8601 = (x)=>{
                if (typeof x !== 'string' || !x) return undefined;
                if (x.match(/^[0-9]+$/)) // a valid number in a string, not a date.
                return undefined;
                if (x.indexOf('-') < 0 || x.indexOf(':') < 0) return undefined;
                // last line of defence
                try {
                    const candidate = Date.parse(x.indexOf('+') >= 0 || x.slice(-1) === 'Z' ? x : (x + 'Z').replace(/\s(\d\d):/, 'T$1:'));
                    if (Number.isNaN(candidate)) return undefined;
                    return candidate;
                } catch (e) {
                    return undefined;
                }
            };
            const parseDate = (x)=>{
                if (typeof x !== 'string' || !x) return undefined;
                if (x.indexOf('GMT') >= 0) try {
                    return Date.parse(x);
                } catch (e) {
                    return undefined;
                }
                return parse8601(x);
            };
            const rfc2616 = (timestamp)=>new Date(timestamp).toUTCString();
            const mdy = (timestamp, infix = '-')=>{
                infix = infix || '';
                const date = new Date(timestamp);
                const Y = date.getUTCFullYear().toString();
                let m = date.getUTCMonth() + 1;
                let d = date.getUTCDate();
                m = m < 10 ? '0' + m : m.toString();
                d = d < 10 ? '0' + d : d.toString();
                return m + infix + d + infix + Y;
            };
            const ymd = (timestamp, infix, fullYear = true)=>{
                infix = infix || '';
                const date = new Date(timestamp);
                const intYear = date.getUTCFullYear();
                const year = fullYear ? intYear : intYear - 2000;
                const Y = year.toString();
                let m = date.getUTCMonth() + 1;
                let d = date.getUTCDate();
                m = m < 10 ? '0' + m : m.toString();
                d = d < 10 ? '0' + d : d.toString();
                return Y + infix + m + infix + d;
            };
            const yymmdd = (timestamp, infix = '')=>ymd(timestamp, infix, false);
            const yyyymmdd = (timestamp, infix = '-')=>ymd(timestamp, infix, true);
            const ymdhms = (timestamp, infix = ' ')=>{
                const date = new Date(timestamp);
                const Y = date.getUTCFullYear();
                let m = date.getUTCMonth() + 1;
                let d = date.getUTCDate();
                let H = date.getUTCHours();
                let M = date.getUTCMinutes();
                let S = date.getUTCSeconds();
                m = m < 10 ? '0' + m : m;
                d = d < 10 ? '0' + d : d;
                H = H < 10 ? '0' + H : H;
                M = M < 10 ? '0' + M : M;
                S = S < 10 ? '0' + S : S;
                return Y + '-' + m + '-' + d + infix + H + ':' + M + ':' + S;
            };
            module.exports = {
                now: now,
                microseconds: microseconds,
                milliseconds: milliseconds,
                seconds: seconds,
                iso8601: iso8601,
                parse8601: parse8601,
                rfc2616: rfc2616,
                uuidv1: uuidv1,
                parseDate: parseDate,
                mdy: mdy,
                ymd: ymd,
                yymmdd: yymmdd,
                yyyymmdd: yyyymmdd,
                ymdhms: ymdhms,
                setTimeout_safe: setTimeout_safe,
                sleep: (ms)=>new Promise((resolve)=>setTimeout_safe(resolve, ms)),
                TimedOut: TimedOut,
                timeout: async (ms, promise)=>{
                    let clear = ()=>{};
                    const expires = new Promise((resolve)=>clear = setTimeout_safe(resolve, ms));
                    try {
                        return await Promise.race([
                            promise,
                            expires.then(()=>{
                                throw new TimedOut();
                            })
                        ]);
                    } finally{
                        clear() // fixes https://github.com/ccxt/ccxt/issues/749
                        ;
                    }
                }
            };
        /*  ------------------------------------------------------------------------ */ },
        {}
    ],
    19: [
        function(require1, module, exports) {
            "use strict";
            /*  ------------------------------------------------------------------------ */ const isNumber = Number.isFinite, isInteger = Number.isInteger, isArray = Array.isArray, hasProps = (o)=>o !== undefined && o !== null, isString = (s)=>typeof s === 'string', isObject = (o)=>o !== null && typeof o === 'object', isRegExp = (o)=>o instanceof RegExp, isDictionary = (o)=>isObject(o) && Object.getPrototypeOf(o) === Object.prototype && !isArray(o) && !isRegExp(o), isStringCoercible = (x)=>hasProps(x) && x.toString || isNumber(x);
            /*  .............................................   */ const prop = (o, k)=>isObject(o) ? o[k] : undefined, prop2 = (o, k1, k2)=>!isObject(o) ? undefined : k1 in o && o[k1] !== null ? o[k1] : o[k2];
            /*  .............................................   */ const asFloat = (x)=>isNumber(x) || isString(x) && x.length !== 0 ? parseFloat(x) : NaN, asInteger = (x)=>isNumber(x) || isString(x) && x.length !== 0 ? Math.trunc(Number(x)) : NaN;
            /*  .............................................   */ module.exports = {
                isNumber: isNumber,
                isInteger: isInteger,
                isArray: isArray,
                isObject: isObject,
                isString: isString,
                isStringCoercible: isStringCoercible,
                isDictionary: isDictionary,
                hasProps: hasProps,
                prop: prop,
                asFloat: asFloat,
                asInteger: asInteger,
                safeFloat: (o, k, $default, n = asFloat(prop(o, k)))=>isNumber(n) ? n : $default,
                safeInteger: (o, k, $default, n = asInteger(prop(o, k)))=>isNumber(n) ? n : $default,
                safeIntegerProduct: (o, k, $factor, $default, n = asInteger(prop(o, k)))=>isNumber(n) ? parseInt(n * $factor) : $default,
                safeTimestamp: (o, k, $default, n = asFloat(prop(o, k)))=>isNumber(n) ? parseInt(n * 1000) : $default,
                safeValue: (o, k, $default, x = prop(o, k))=>hasProps(x) ? x : $default,
                safeString: (o, k, $default, x = prop(o, k))=>isStringCoercible(x) ? String(x) : $default,
                safeStringLower: (o, k, $default, x = prop(o, k))=>isStringCoercible(x) ? String(x).toLowerCase() : $default,
                safeStringUpper: (o, k, $default, x = prop(o, k))=>isStringCoercible(x) ? String(x).toUpperCase() : $default,
                safeFloat2: (o, k1, k2, $default, n = asFloat(prop2(o, k1, k2)))=>isNumber(n) ? n : $default,
                safeInteger2: (o, k1, k2, $default, n = asInteger(prop2(o, k1, k2)))=>isNumber(n) ? n : $default,
                safeIntegerProduct2: (o, k1, k2, $factor, $default, n = asInteger(prop2(o, k1, k2)))=>isNumber(n) ? parseInt(n * $factor) : $default,
                safeTimestamp2: (o, k1, k2, $default, n = asFloat(prop2(o, k1, k2)))=>isNumber(n) ? parseInt(n * 1000) : $default,
                safeValue2: (o, k1, k2, $default, x = prop2(o, k1, k2))=>hasProps(x) ? x : $default,
                safeString2: (o, k1, k2, $default, x = prop2(o, k1, k2))=>isStringCoercible(x) ? String(x) : $default,
                safeStringLower2: (o, k1, k2, $default, x = prop2(o, k1, k2))=>isStringCoercible(x) ? String(x).toLowerCase() : $default,
                safeStringUpper2: (o, k1, k2, $default, x = prop2(o, k1, k2))=>isStringCoercible(x) ? String(x).toUpperCase() : $default
            };
        /*  ------------------------------------------------------------------------ */ },
        {}
    ],
    20: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const hitbtc = require1('./hitbtc');
            // ---------------------------------------------------------------------------
            module.exports = class bequant extends hitbtc {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bequant',
                        'name': 'Bequant',
                        'countries': [
                            'MT'
                        ],
                        'pro': true,
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/55248342-a75dfe00-525a-11e9-8aa2-05e9dca943c6.jpg',
                            'api': {
                                'public': 'https://api.bequant.io',
                                'private': 'https://api.bequant.io'
                            },
                            'www': 'https://bequant.io',
                            'doc': [
                                'https://api.bequant.io/'
                            ],
                            'fees': [
                                'https://bequant.io/fees-and-limits'
                            ],
                            'referral': 'https://bequant.io'
                        }
                    });
                }
            };
        },
        {
            "./hitbtc": 85
        }
    ],
    21: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, AccountSuspended: AccountSuspended, ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, DDoSProtection: DDoSProtection, ExchangeNotAvailable: ExchangeNotAvailable, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, PermissionDenied: PermissionDenied, InsufficientFunds: InsufficientFunds, BadSymbol: BadSymbol, RateLimitExceeded: RateLimitExceeded, BadRequest: BadRequest } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bibox extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bibox',
                        'name': 'Bibox',
                        'countries': [
                            'CN',
                            'US',
                            'KR'
                        ],
                        'version': 'v1',
                        'hostname': 'bibox.com',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelOrder': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRates': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingFees': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchWithdrawals': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1min',
                            '5m': '5min',
                            '15m': '15min',
                            '30m': '30min',
                            '1h': '1hour',
                            '2h': '2hour',
                            '4h': '4hour',
                            '6h': '6hour',
                            '12h': '12hour',
                            '1d': 'day',
                            '1w': 'week'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/77257418-3262b000-6c85-11ea-8fb8-20bdf20b3592.jpg',
                            'api': 'https://api.{hostname}',
                            'www': 'https://www.bibox365.com',
                            'doc': [
                                'https://biboxcom.github.io/en/'
                            ],
                            'fees': 'https://bibox.zendesk.com/hc/en-us/articles/360002336133',
                            'referral': 'https://w2.bibox365.com/login/register?invite_code=05Kj3I'
                        },
                        'api': {
                            'public': {
                                'post': [
                                    // TODO: rework for full endpoint/cmd paths here
                                    'mdata'
                                ],
                                'get': [
                                    'cquery',
                                    'mdata',
                                    'cdata',
                                    'orderpending'
                                ]
                            },
                            'private': {
                                'post': [
                                    'cquery',
                                    'ctrade',
                                    'user',
                                    'orderpending',
                                    'transfer'
                                ]
                            },
                            'v2private': {
                                'post': [
                                    'assets/transfer/spot'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'taker': this.parseNumber('0.002'),
                                'maker': this.parseNumber('0.001')
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false,
                                'withdraw': {},
                                'deposit': {}
                            }
                        },
                        'exceptions': {
                            '2011': AccountSuspended,
                            '2015': AuthenticationError,
                            '2021': InsufficientFunds,
                            '2027': InsufficientFunds,
                            '2033': OrderNotFound,
                            '2065': InvalidOrder,
                            '2066': InvalidOrder,
                            '2067': InvalidOrder,
                            '2068': InvalidOrder,
                            '2078': InvalidOrder,
                            '2085': InvalidOrder,
                            '2091': RateLimitExceeded,
                            '2092': InvalidOrder,
                            '2131': InvalidOrder,
                            '3000': BadRequest,
                            '3002': BadRequest,
                            '3012': AuthenticationError,
                            '3016': BadSymbol,
                            '3024': PermissionDenied,
                            '3025': AuthenticationError,
                            '4000': ExchangeNotAvailable,
                            '4003': DDoSProtection
                        },
                        'commonCurrencies': {
                            'APENFT(NFT)': 'NFT',
                            'BOX': 'DefiBox',
                            'BPT': 'BlockPool Token',
                            'GMT': 'GMT Token',
                            'KEY': 'Bihu',
                            'MTC': 'MTC Mesh Network',
                            'NFT': 'NFT Protocol',
                            'PAI': 'PCHAIN',
                            'REVO': 'Revo Network',
                            'STAR': 'Starbase',
                            'TERN': 'Ternio-ERC20'
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const request = {
                        'cmd': 'pairList'
                    };
                    const response = await this.publicGetMdata(this.extend(request, params));
                    //
                    //     {
                    //         "result": [
                    //             {
                    //                 "id":1,
                    //                 "pair":"BIX_BTC",
                    //                 "pair_type":0,
                    //                 "area_id":7,
                    //                 "is_hide":0,
                    //                 "decimal":8,
                    //                 "amount_scale":4
                    //             }
                    //         ],
                    //         "cmd":"pairList",
                    //         "ver":"1.1"
                    //     }
                    //
                    const markets = this.safeValue(response, 'result');
                    const request2 = {
                        'cmd': 'tradeLimit'
                    };
                    const response2 = await this.publicGetOrderpending(this.extend(request2, params));
                    //
                    //    {
                    //         result: {
                    //             min_trade_price: { default: '0.00000001', USDT: '0.0001', DAI: '0.0001' },
                    //             min_trade_amount: { default: '0.0001' },
                    //             min_trade_money: {
                    //                 USDT: '1',
                    //                 USDC: '1',
                    //                 DAI: '1',
                    //                 GUSD: '1',
                    //                 BIX: '3',
                    //                 BTC: '0.0002',
                    //                 ETH: '0.005'
                    //             }
                    //         },
                    //         cmd: 'tradeLimit'
                    //     }
                    //
                    const result2 = this.safeValue(response2, 'result', {});
                    const minCosts = this.safeValue(result2, 'min_trade_money', {});
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const numericId = this.safeInteger(market, 'id');
                        const id = this.safeString(market, 'pair');
                        let baseId = undefined;
                        let quoteId = undefined;
                        if (id !== undefined) {
                            const parts = id.split('_');
                            baseId = this.safeString(parts, 0);
                            quoteId = this.safeString(parts, 1);
                        }
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const symbol = base + '/' + quote;
                        const type = 'spot';
                        const spot = true;
                        const areaId = this.safeInteger(market, 'area_id');
                        if (areaId === 16) continue;
                        result.push({
                            'id': id,
                            'numericId': numericId,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': type,
                            'spot': spot,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'amount_scale'),
                                'price': this.safeInteger(market, 'decimal')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(minCosts, quoteId),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    // we don't set values that are not defined by the exchange
                    const timestamp = this.safeInteger(ticker, 'timestamp');
                    let marketId = undefined;
                    const baseId = this.safeString(ticker, 'coin_symbol');
                    const quoteId = this.safeString(ticker, 'currency_symbol');
                    if (baseId !== undefined && quoteId !== undefined) marketId = baseId + '_' + quoteId;
                    market = this.safeMarket(marketId, market);
                    const last = this.safeString(ticker, 'last');
                    const change = this.safeString(ticker, 'change');
                    const baseVolume = this.safeString2(ticker, 'vol', 'vol24H');
                    let percentage = this.safeString(ticker, 'percent');
                    if (percentage !== undefined) percentage = percentage.replace('%', '');
                    return this.safeTicker({
                        'symbol': market['symbol'],
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': this.safeString(ticker, 'buy_amount'),
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': this.safeString(ticker, 'sell_amount'),
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': change,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': this.safeString(ticker, 'amount'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'cmd': 'ticker',
                        'pair': market['id']
                    };
                    const response = await this.publicGetMdata(this.extend(request, params));
                    return this.parseTicker(response['result'], market);
                }
                async fetchTickers(symbols, params = {}) {
                    const request = {
                        'cmd': 'marketAll'
                    };
                    const response = await this.publicGetMdata(this.extend(request, params));
                    const tickers = this.parseTickers(response['result'], symbols);
                    const result = this.indexBy(tickers, 'symbol');
                    return this.filterByArray(result, 'symbol', symbols);
                }
                parseTrade(trade, market) {
                    const timestamp = this.safeInteger2(trade, 'time', 'createdAt');
                    let side = this.safeInteger2(trade, 'side', 'order_side');
                    side = side === 1 ? 'buy' : 'sell';
                    let marketId = this.safeString(trade, 'pair');
                    if (marketId === undefined) {
                        const baseId = this.safeString(trade, 'coin_symbol');
                        const quoteId = this.safeString(trade, 'currency_symbol');
                        if (baseId !== undefined && quoteId !== undefined) marketId = baseId + '_' + quoteId;
                    }
                    market = this.safeMarket(marketId, market);
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'fee_symbol');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': Precise.stringNeg(feeCostString),
                            'currency': feeCurrencyCode
                        };
                    }
                    const id = this.safeString(trade, 'id');
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': 'limit',
                        'takerOrMaker': undefined,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'cmd': 'deals',
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['size'] = limit; // default = 200
                    const response = await this.publicGetMdata(this.extend(request, params));
                    return this.parseTrades(response['result'], market, since, limit);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'cmd': 'depth',
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['size'] = limit; // default = 200
                    const response = await this.publicGetMdata(this.extend(request, params));
                    return this.parseOrderBook(response['result'], symbol, this.safeNumber(response['result'], 'update_time'), 'bids', 'asks', 'price', 'volume');
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "time":1591448220000,
                    //         "open":"0.02507029",
                    //         "high":"0.02507029",
                    //         "low":"0.02506349",
                    //         "close":"0.02506349",
                    //         "vol":"5.92000000"
                    //     }
                    //
                    return [
                        this.safeInteger(ohlcv, 'time'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'vol')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit = 1000, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'cmd': 'kline',
                        'pair': market['id'],
                        'period': this.timeframes[timeframe],
                        'size': limit
                    };
                    const response = await this.publicGetMdata(this.extend(request, params));
                    //
                    //     {
                    //         "result":[
                    //             {"time":1591448220000,"open":"0.02507029","high":"0.02507029","low":"0.02506349","close":"0.02506349","vol":"5.92000000"},
                    //             {"time":1591448280000,"open":"0.02506449","high":"0.02506975","low":"0.02506108","close":"0.02506843","vol":"5.72000000"},
                    //             {"time":1591448340000,"open":"0.02506698","high":"0.02506698","low":"0.02506452","close":"0.02506519","vol":"4.86000000"},
                    //         ],
                    //         "cmd":"kline",
                    //         "ver":"1.1"
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseOHLCVs(result, market, timeframe, since, limit);
                }
                async fetchCurrencies(params = {}) {
                    if (this.checkRequiredCredentials(false)) return await this.fetchCurrenciesPrivate(params);
                    else return await this.fetchCurrenciesPublic(params);
                }
                async fetchCurrenciesPublic(params = {}) {
                    const request = {
                        'cmd': 'currencies'
                    };
                    const response = await this.publicGetCdata(this.extend(request, params));
                    //
                    // publicGetCdata
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "symbol":"BTC",
                    //                 "name":"BTC",
                    //                 "valid_decimals":8,
                    //                 "original_decimals":8,
                    //                 "is_erc20":0,
                    //                 "enable_withdraw":1,
                    //                 "enable_deposit":1,
                    //                 "withdraw_min":0.005,
                    //                 "describe_summary":"[{\"lang\":\"zh-cn\",\"text\":\"Bitcoin 比特币的概念最初由中本聪在2009年提出，是点对点的基于 SHA-256 算法的一种P2P形式的数字货币，点对点的传输意味着一个去中心化的支付系统。\"},{\"lang\":\"en-ww\",\"text\":\"Bitcoin is a digital asset and a payment system invented by Satoshi Nakamoto who published a related paper in 2008 and released it as open-source software in 2009. The system featured as peer-to-peer; users can transact directly without an intermediary.\"}]"
                    //             }
                    //         ],
                    //         "cmd":"currencies"
                    //     }
                    //
                    const currencies = this.safeValue(response, 'result');
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'symbol');
                        const name = this.safeString(currency, 'name'); // contains hieroglyphs causing python ASCII bug
                        const code = this.safeCurrencyCode(id);
                        const precision = this.safeInteger(currency, 'valid_decimals');
                        const deposit = this.safeValue(currency, 'enable_deposit');
                        const withdraw = this.safeValue(currency, 'enable_withdraw');
                        const active = deposit && withdraw;
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'name': name,
                            'active': active,
                            'deposit': deposit,
                            'withdraw': withdraw,
                            'fee': undefined,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': Math.pow(10, -precision),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'withdraw_min'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchCurrenciesPrivate(params = {}) {
                    if (!this.checkRequiredCredentials(false)) throw new AuthenticationError(this.id + " fetchCurrencies is an authenticated endpoint, therefore it requires 'apiKey' and 'secret' credentials. If you don't need currency details, set exchange.has['fetchCurrencies'] = false before calling its methods.");
                    const request = {
                        'cmd': 'transfer/coinList',
                        'body': {}
                    };
                    const response = await this.privatePostTransfer(this.extend(request, params));
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result":[
                    //                     {
                    //                         "totalBalance":"14.60987476",
                    //                         "balance":"14.60987476",
                    //                         "freeze":"0.00000000",
                    //                         "id":60,
                    //                         "symbol":"USDT",
                    //                         "icon_url":"/appimg/USDT_icon.png",
                    //                         "describe_url":"[{\"lang\":\"zh-cn\",\"link\":\"https://bibox.zendesk.com/hc/zh-cn/articles/115004798234\"},{\"lang\":\"en-ww\",\"link\":\"https://bibox.zendesk.com/hc/en-us/articles/115004798234\"}]",
                    //                         "name":"USDT",
                    //                         "enable_withdraw":1,
                    //                         "enable_deposit":1,
                    //                         "enable_transfer":1,
                    //                         "confirm_count":2,
                    //                         "is_erc20":1,
                    //                         "forbid_info":null,
                    //                         "describe_summary":"[{\"lang\":\"zh-cn\",\"text\":\"USDT 是 Tether 公司推出的基于稳定价值货币美元（USD）的代币 Tether USD（简称USDT），1USDT=1美元，用户可以随时使用 USDT 与 USD 进行1:1的兑换。\"},{\"lang\":\"en-ww\",\"text\":\"USDT is a cryptocurrency asset issued on the Bitcoin blockchain via the Omni Layer Protocol. Each USDT unit is backed by a U.S Dollar held in the reserves of the Tether Limited and can be redeemed through the Tether Platform.\"}]",
                    //                         "total_amount":4776930644,
                    //                         "supply_amount":4642367414,
                    //                         "price":"--",
                    //                         "contract_father":"OMNI",
                    //                         "supply_time":"--",
                    //                         "comment":null,
                    //                         "chain_type":"OMNI",
                    //                         "general_name":"USDT",
                    //                         "contract":"31",
                    //                         "original_decimals":8,
                    //                         "deposit_type":0,
                    //                         "hasCobo":0,
                    //                         "BTCValue":"0.00027116",
                    //                         "CNYValue":"90.36087919",
                    //                         "USDValue":"14.61090236",
                    //                         "children":[
                    //                             {"type":"ERC20","symbol":"eUSDT","enable_deposit":1,"enable_withdraw":1,"confirm_count":13},
                    //                             {"type":"TRC20","symbol":"tUSDT","enable_deposit":1,"enable_withdraw":1,"confirm_count":20},
                    //                             {"type":"OMNI","symbol":"USDT","enable_deposit":1,"enable_withdraw":1,"confirm_count":2},
                    //                             {"type":"HECO","symbol":"hUSDT","enable_deposit":1,"enable_withdraw":1,"confirm_count":12},
                    //                             {"type":"BSC(BEP20)","symbol":"bUSDT","enable_deposit":1,"enable_withdraw":1,"confirm_count":5},
                    //                             {"type":"HPB","symbol":"pUSDT","enable_deposit":1,"enable_withdraw":1,"confirm_count":20}
                    //                         ]
                    //                     }
                    //                 ],
                    //                 "cmd":"transfer/coinList"
                    //             }
                    //         ]
                    //     }
                    //
                    const outerResults = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResults, 0, {});
                    const currencies = this.safeValue(firstResult, 'result');
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'symbol');
                        const name = currency['name']; // contains hieroglyphs causing python ASCII bug
                        const code = this.safeCurrencyCode(id);
                        const precision = 8;
                        const deposit = this.safeValue(currency, 'enable_deposit');
                        const withdraw = this.safeValue(currency, 'enable_withdraw');
                        const active = deposit && withdraw;
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'name': name,
                            'active': active,
                            'fee': undefined,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': Math.pow(10, -precision),
                                    'max': Math.pow(10, precision)
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': Math.pow(10, precision)
                                }
                            }
                        };
                    }
                    return result;
                }
                parseBalance(response) {
                    const outerResult = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResult, 0, {});
                    const innerResult = this.safeValue(firstResult, 'result');
                    const result = {
                        'info': response
                    };
                    const assetsList = this.safeValue(innerResult, 'assets_list', []);
                    for(let i = 0; i < assetsList.length; i++){
                        const balance = assetsList[i];
                        const currencyId = this.safeString(balance, 'coin_symbol');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'balance');
                        account['used'] = this.safeString(balance, 'freeze');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const type = this.safeString(params, 'type', 'assets');
                    params = this.omit(params, 'type');
                    const request = {
                        'cmd': 'transfer/' + type,
                        'body': this.extend({
                            'select': 1
                        }, params)
                    };
                    const response = await this.privatePostTransfer(request);
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result":{
                    //                     "total_btc":"0.00000298",
                    //                     "total_cny":"0.99",
                    //                     "total_usd":"0.16",
                    //                     "assets_list":[
                    //                         {"coin_symbol":"BTC","BTCValue":"0.00000252","CNYValue":"0.84","USDValue":"0.14","balance":"0.00000252","freeze":"0.00000000"},
                    //                         {"coin_symbol":"LTC","BTCValue":"0.00000023","CNYValue":"0.07","USDValue":"0.01","balance":"0.00006765","freeze":"0.00000000"},
                    //                         {"coin_symbol":"USDT","BTCValue":"0.00000023","CNYValue":"0.08","USDValue":"0.01","balance":"0.01252100","freeze":"0.00000000"}
                    //                     ]
                    //                 },
                    //                 "cmd":"transfer/assets"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (limit === undefined) limit = 100;
                    const request = {
                        'page': 1,
                        'size': limit
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['symbol'] = currency['id'];
                    }
                    const response = await this.privatePostTransfer({
                        'cmd': 'transfer/transferInList',
                        'body': this.extend(request, params)
                    });
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result":{
                    //                     "count":2,
                    //                     "page":1,
                    //                     "items":[
                    //                         {
                    //                             "coin_symbol":"ETH",                        // token
                    //                             "to_address":"xxxxxxxxxxxxxxxxxxxxxxxxxx",  // address
                    //                             "amount":"1.00000000",                      // amount
                    //                             "confirmCount":"15",                        // the acknowledgment number
                    //                             "createdAt":1540641511000,
                    //                             "status":2                                 // status,  1-deposit is in process，2-deposit finished，3-deposit failed
                    //                         },
                    //                         {
                    //                             "coin_symbol":"BIX",
                    //                             "to_address":"xxxxxxxxxxxxxxxxxxxxxxxxxx",
                    //                             "amount":"1.00000000",
                    //                             "confirmCount":"15",
                    //                             "createdAt":1540622460000,
                    //                             "status":2
                    //                         }
                    //                     ]
                    //                 },
                    //                 "cmd":"transfer/transferInList"
                    //             }
                    //         ]
                    //     }
                    //
                    const outerResults = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResults, 0, {});
                    const innerResult = this.safeValue(firstResult, 'result', {});
                    const deposits = this.safeValue(innerResult, 'items', []);
                    for(let i = 0; i < deposits.length; i++)deposits[i]['type'] = 'deposit';
                    return this.parseTransactions(deposits, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (limit === undefined) limit = 100;
                    const request = {
                        'page': 1,
                        'size': limit
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['symbol'] = currency['id'];
                    }
                    const response = await this.privatePostTransfer({
                        'cmd': 'transfer/transferOutList',
                        'body': this.extend(request, params)
                    });
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result":{
                    //                     "count":1,
                    //                     "page":1,
                    //                     "items":[
                    //                         {
                    //                             "id":612867,
                    //                             "coin_symbol":"ETH",
                    //                             "chain_type":"ETH",
                    //                             "to_address":"0xd41de7a88ab5fc59edc6669f54873576be95bff1",
                    //                             "tx_id":"0xc60950596227af3f27c3a1b5911ea1c79bae53bdce67274e48a0ce87a5ef2df8",
                    //                             "addr_remark":"binance",
                    //                             "amount":"2.34550946",
                    //                             "fee":"0.00600000",
                    //                             "createdAt":1561339330000,
                    //                             "memo":"",
                    //                             "status":3
                    //                         }
                    //                     ]
                    //                 },
                    //                 "cmd":"transfer/transferOutList"
                    //             }
                    //         ]
                    //     }
                    //
                    const outerResults = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResults, 0, {});
                    const innerResult = this.safeValue(firstResult, 'result', {});
                    const withdrawals = this.safeValue(innerResult, 'items', []);
                    for(let i = 0; i < withdrawals.length; i++)withdrawals[i]['type'] = 'withdrawal';
                    return this.parseTransactions(withdrawals, currency, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         'id': 1023291,
                    //         'coin_symbol': 'ETH',
                    //         'to_address': '0x7263....',
                    //         'amount': '0.49170000',
                    //         'confirmCount': '16',
                    //         'createdAt': 1553123867000,
                    //         'status': 2
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         'id': 521844,
                    //         'coin_symbol': 'ETH',
                    //         'to_address': '0xfd4e....',
                    //         'addr_remark': '',
                    //         'amount': '0.39452750',
                    //         'fee': '0.00600000',
                    //         'createdAt': 1553226906000,
                    //         'memo': '',
                    //         'status': 3
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "result": 228, // withdrawal id
                    //         "cmd":"transfer/transferOut"
                    //     }
                    //
                    const id = this.safeString2(transaction, 'id', 'result');
                    const address = this.safeString(transaction, 'to_address');
                    const currencyId = this.safeString(transaction, 'coin_symbol');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const timestamp = this.safeString(transaction, 'createdAt');
                    let tag = this.safeString(transaction, 'addr_remark');
                    const type = this.safeString(transaction, 'type');
                    const status = this.parseTransactionStatusByType(this.safeString(transaction, 'status'), type);
                    const amount = this.safeNumber(transaction, 'amount');
                    let feeCost = this.safeNumber(transaction, 'fee');
                    if (type === 'deposit') {
                        feeCost = 0;
                        tag = undefined;
                    }
                    const fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'fee': fee
                    };
                }
                parseTransactionStatusByType(status, type) {
                    const statuses = {
                        'deposit': {
                            '1': 'pending',
                            '2': 'ok'
                        },
                        'withdrawal': {
                            '0': 'pending',
                            '3': 'ok'
                        }
                    };
                    return this.safeString(this.safeValue(statuses, type, {}), status, status);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const orderType = type === 'limit' ? 2 : 1;
                    const orderSide = side === 'buy' ? 1 : 2;
                    const request = {
                        'cmd': 'orderpending/trade',
                        'body': this.extend({
                            'pair': market['id'],
                            'account_type': 0,
                            'order_type': orderType,
                            'order_side': orderSide,
                            'pay_bix': 0,
                            'amount': amount,
                            'price': price
                        }, params)
                    };
                    const response = await this.privatePostOrderpending(request);
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result": "100055558128036", // order id
                    //                 "index": 12345, // random index, specific one in a batch
                    //                 "cmd":"orderpending/trade"
                    //             }
                    //         ]
                    //     }
                    //
                    const outerResults = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResults, 0, {});
                    const id = this.safeValue(firstResult, 'result');
                    return {
                        'info': response,
                        'id': id
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'cmd': 'orderpending/cancelTrade',
                        'body': this.extend({
                            'orders_id': id
                        }, params)
                    };
                    const response = await this.privatePostOrderpending(request);
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result":"OK", // only indicates if the server received the cancelling request, and the cancelling result can be obtained from the order record
                    //                 "index": 12345, // random index, specific one in a batch
                    //                 "cmd":"orderpending/cancelTrade"
                    //             }
                    //         ]
                    //     }
                    //
                    const outerResults = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResults, 0, {});
                    return firstResult;
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'cmd': 'orderpending/order',
                        'body': this.extend({
                            'id': id.toString(),
                            'account_type': 0
                        }, params)
                    };
                    const response = await this.privatePostOrderpending(request);
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result":{
                    //                     "id":"100055558128036",
                    //                     "createdAt": 1512756997000,
                    //                     "account_type":0,
                    //                     "coin_symbol":"LTC",        // Trading Token
                    //                     "currency_symbol":"BTC",    // Pricing Token
                    //                     "order_side":2,             // Trading side 1-Buy, 2-Sell
                    //                     "order_type":2,             // 2-limit order
                    //                     "price":"0.00900000",       // order price
                    //                     "amount":"1.00000000",      // order amount
                    //                     "money":"0.00900000",       // currency amount (price * amount)
                    //                     "deal_amount":"0.00000000", // deal amount
                    //                     "deal_percent":"0.00%",     // deal percentage
                    //                     "unexecuted":"0.00000000",  // unexecuted amount
                    //                     "status":3                  // Status, -1-fail, 0,1-to be dealt, 2-dealt partly, 3-dealt totally, 4- cancelled partly, 5-cancelled totally, 6-to be cancelled
                    //                 },
                    //                 "cmd":"orderpending/order"
                    //             }
                    //         ]
                    //     }
                    //
                    const outerResults = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResults, 0, {});
                    const order = this.safeValue(firstResult, 'result');
                    if (this.isEmpty(order)) throw new OrderNotFound(this.id + ' order ' + id + ' not found');
                    return this.parseOrder(order);
                }
                parseOrder(order, market) {
                    let marketId = undefined;
                    const baseId = this.safeString(order, 'coin_symbol');
                    const quoteId = this.safeString(order, 'currency_symbol');
                    if (baseId !== undefined && quoteId !== undefined) marketId = baseId + '_' + quoteId;
                    market = this.safeMarket(marketId, market);
                    const rawType = this.safeString(order, 'order_type');
                    const type = rawType === '1' ? 'market' : 'limit';
                    const timestamp = this.safeInteger(order, 'createdAt');
                    const price = this.safeString(order, 'price');
                    const average = this.safeString(order, 'deal_price');
                    const filled = this.safeString(order, 'deal_amount');
                    const amount = this.safeString(order, 'amount');
                    const cost = this.safeString2(order, 'deal_money', 'money');
                    const rawSide = this.safeString(order, 'order_side');
                    const side = rawSide === '1' ? 'buy' : 'sell';
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const id = this.safeString(order, 'id');
                    const feeCost = this.safeString(order, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': undefined
                    };
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': cost,
                        'average': average,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        // original comments from bibox:
                        '1': 'open',
                        '2': 'open',
                        '3': 'closed',
                        '4': 'canceled',
                        '5': 'canceled',
                        '6': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    let pair = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        pair = market['id'];
                    }
                    const size = limit ? limit : 200;
                    const request = {
                        'cmd': 'orderpending/orderPendingList',
                        'body': this.extend({
                            'pair': pair,
                            'account_type': 0,
                            'page': 1,
                            'size': size
                        }, params)
                    };
                    const response = await this.privatePostOrderpending(request);
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result":{
                    //                     "count":1,
                    //                     "page":1,
                    //                     "items":[
                    //                         {
                    //                             "id":"100055558128036",
                    //                             "createdAt": 1512756997000,
                    //                             "account_type":0,
                    //                             "coin_symbol":"LTC",        // Trading Token
                    //                             "currency_symbol":"BTC",    // Pricing Token
                    //                             "order_side":2,             // Trading side 1-Buy, 2-Sell
                    //                             "order_type":2,             // 2-limit order
                    //                             "price":"0.00900000",       // order price
                    //                             "amount":"1.00000000",      // order amount
                    //                             "money":"0.00900000",       // currency amount (price * amount)
                    //                             "deal_amount":"0.00000000", // deal amount
                    //                             "deal_percent":"0.00%",     // deal percentage
                    //                             "unexecuted":"0.00000000",  // unexecuted amount
                    //                             "status":1                  // Status,-1-fail, 0,1-to be dealt, 2-dealt partly, 3-dealt totally, 4- cancelled partly, 5-cancelled totally, 6-to be cancelled
                    //                         }
                    //                     ]
                    //                 },
                    //                 "cmd":"orderpending/orderPendingList"
                    //             }
                    //         ]
                    //     }
                    //
                    const outerResults = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResults, 0, {});
                    const innerResult = this.safeValue(firstResult, 'result', {});
                    const orders = this.safeValue(innerResult, 'items', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit = 200, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchClosedOrders() requires a `symbol` argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'cmd': 'orderpending/pendingHistoryList',
                        'body': this.extend({
                            'pair': market['id'],
                            'account_type': 0,
                            'page': 1,
                            'size': limit
                        }, params)
                    };
                    const response = await this.privatePostOrderpending(request);
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result":{
                    //                     "count":1,
                    //                     "page":1,
                    //                     "items":[
                    //                         {
                    //                             "id":"100055558128036",
                    //                             "createdAt": 1512756997000,
                    //                             "account_type":0,
                    //                             "coin_symbol":"LTC",        // Trading Token
                    //                             "currency_symbol":"BTC",    // Pricing Token
                    //                             "order_side":2,             // Trading side 1-Buy, 2-Sell
                    //                             "order_type":2,             // 2-limit order
                    //                             "price":"0.00900000",       // order price
                    //                             "amount":"1.00000000",      // order amount
                    //                             "money":"0.00900000",       // currency amount (price * amount)
                    //                             "deal_amount":"0.00000000", // deal amount
                    //                             "deal_percent":"0.00%",     // deal percentage
                    //                             "unexecuted":"0.00000000",  // unexecuted amount
                    //                             "status":3                  // Status,-1-fail, 0,1-to be dealt, 2-dealt partly, 3-dealt totally, 4- cancelled partly, 5-cancelled totally, 6-to be cancelled
                    //                         }
                    //                     ]
                    //                 },
                    //                 "cmd":"orderpending/pendingHistoryList"
                    //             }
                    //         ]
                    //     }
                    //
                    const outerResults = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResults, 0, {});
                    const innerResult = this.safeValue(firstResult, 'result', {});
                    const orders = this.safeValue(innerResult, 'items', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a `symbol` argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const size = limit ? limit : 200;
                    const request = {
                        'cmd': 'orderpending/orderHistoryList',
                        'body': this.extend({
                            'pair': market['id'],
                            'account_type': 0,
                            'page': 1,
                            'size': size,
                            'coin_symbol': market['baseId'],
                            'currency_symbol': market['quoteId']
                        }, params)
                    };
                    const response = await this.privatePostOrderpending(request);
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result":{
                    //                     "count":1,
                    //                     "page":1,
                    //                     "items":[
                    //                         {
                    //                             "id":"100055558128033",
                    //                             "createdAt": 1512756997000,
                    //                             "account_type":0,
                    //                             "coin_symbol":"LTC",
                    //                             "currency_symbol":"BTC",
                    //                             "order_side":2,
                    //                             "order_type":2,
                    //                             "price":"0.00886500",
                    //                             "amount":"1.00000000",
                    //                             "money":"0.00886500",
                    //                             "fee":0
                    //                         }
                    //                     ]
                    //                 },
                    //                 "cmd":"orderpending/orderHistoryList"
                    //             }
                    //         ]
                    //     }
                    //
                    const outerResults = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResults, 0, {});
                    const innerResult = this.safeValue(firstResult, 'result', {});
                    const trades = this.safeValue(innerResult, 'items', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'cmd': 'transfer/transferIn',
                        'body': this.extend({
                            'coin_symbol': currency['id']
                        }, params)
                    };
                    const response = await this.privatePostTransfer(request);
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result":"3Jx6RZ9TNMsAoy9NUzBwZf68QBppDruSKW",
                    //                 "cmd":"transfer/transferIn"
                    //             }
                    //         ]
                    //     }
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result":"{\"account\":\"PERSONALLY OMITTED\",\"memo\":\"PERSONALLY OMITTED\"}",
                    //                 "cmd":"transfer/transferIn"
                    //             }
                    //         ]
                    //     }
                    //
                    const outerResults = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResults, 0, {});
                    const innerResult = this.safeValue(firstResult, 'result');
                    let address = innerResult;
                    let tag = undefined;
                    if (this.isJsonEncodedObject(innerResult)) {
                        const parsed = JSON.parse(innerResult);
                        address = this.safeString(parsed, 'account');
                        tag = this.safeString(parsed, 'memo');
                    }
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (this.password === undefined) {
                        if (!('trade_pwd' in params)) throw new ExchangeError1(this.id + ' withdraw() requires this.password set on the exchange instance or a trade_pwd parameter');
                    }
                    if (!('totp_code' in params)) throw new ExchangeError1(this.id + ' withdraw() requires a totp_code parameter for 2FA authentication');
                    const request = {
                        'trade_pwd': this.password,
                        'coin_symbol': currency['id'],
                        'amount': amount,
                        'addr': address
                    };
                    if (tag !== undefined) request['address_remark'] = tag;
                    const response = await this.privatePostTransfer({
                        'cmd': 'transfer/transferOut',
                        'body': this.extend(request, params)
                    });
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "result": 228, // withdrawal id
                    //                 "cmd":"transfer/transferOut"
                    //             }
                    //         ]
                    //     }
                    //
                    const outerResults = this.safeValue(response, 'result');
                    const firstResult = this.safeValue(outerResults, 0, {});
                    return this.parseTransaction(firstResult, currency);
                }
                async fetchFundingFees(codes, params = {}) {
                    // by default it will try load withdrawal fees of all currencies (with separate requests)
                    // however if you define codes = [ 'ETH', 'BTC' ] in args it will only load those
                    await this.loadMarkets();
                    const withdrawFees = {};
                    const info = {};
                    if (codes === undefined) codes = Object.keys(this.currencies);
                    for(let i = 0; i < codes.length; i++){
                        const code = codes[i];
                        const currency = this.currency(code);
                        const request = {
                            'cmd': 'transfer/coinConfig',
                            'body': this.extend({
                                'coin_symbol': currency['id']
                            }, params)
                        };
                        const response = await this.privatePostTransfer(request);
                        //     {
                        //         "result":[
                        //             {
                        //                 "result":[
                        //                     {
                        //                         "coin_symbol":"ETH",
                        //                         "is_active":1,
                        //                         "original_decimals":18,
                        //                         "enable_deposit":1,
                        //                         "enable_withdraw":1,
                        //                         "withdraw_fee":0.008,
                        //                         "withdraw_min":0.05,
                        //                         "deposit_avg_spent":173700,
                        //                         "withdraw_avg_spent":322600
                        //                     }
                        //                 ],
                        //                 "cmd":"transfer/coinConfig"
                        //             }
                        //         ]
                        //     }
                        //
                        const outerResults = this.safeValue(response, 'result', []);
                        const firstOuterResult = this.safeValue(outerResults, 0, {});
                        const innerResults = this.safeValue(firstOuterResult, 'result', []);
                        const firstInnerResult = this.safeValue(innerResults, 0, {});
                        info[code] = firstInnerResult;
                        withdrawFees[code] = this.safeNumber(firstInnerResult, 'withdraw_fee');
                    }
                    return {
                        'info': info,
                        'withdraw': withdrawFees,
                        'deposit': {}
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.implodeHostname(this.urls['api']) + '/' + this.version + '/' + path;
                    const cmds = this.json([
                        params
                    ]);
                    if (api === 'public') {
                        if (method !== 'GET') body = {
                            'cmds': cmds
                        };
                        else if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    } else if (api === 'v2private') {
                        this.checkRequiredCredentials();
                        url = this.implodeHostname(this.urls['api']) + '/v2/' + path;
                        const json_params = this.json(params);
                        body = {
                            'body': json_params,
                            'apikey': this.apiKey,
                            'sign': this.hmac(this.encode(json_params), this.encode(this.secret), 'md5')
                        };
                    } else {
                        this.checkRequiredCredentials();
                        body = {
                            'cmds': cmds,
                            'apikey': this.apiKey,
                            'sign': this.hmac(this.encode(cmds), this.encode(this.secret), 'md5')
                        };
                    }
                    if (body !== undefined) body = this.json(body, {
                        'convertArraysToObjects': true
                    });
                    headers = {
                        'Content-Type': 'application/json'
                    };
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    if ('error' in response) {
                        if ('code' in response['error']) {
                            const code = this.safeString(response['error'], 'code');
                            const feedback = this.id + ' ' + body;
                            this.throwExactlyMatchedException(this.exceptions, code, feedback);
                            throw new ExchangeError1(feedback);
                        }
                        throw new ExchangeError1(this.id + ' ' + body);
                    }
                    if (!('result' in response)) throw new ExchangeError1(this.id + ' ' + body);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    22: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, InsufficientFunds: InsufficientFunds, PermissionDenied: PermissionDenied, BadRequest: BadRequest, BadSymbol: BadSymbol, RateLimitExceeded: RateLimitExceeded, InvalidOrder: InvalidOrder } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class bigone extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bigone',
                        'name': 'BigONE',
                        'countries': [
                            'CN'
                        ],
                        'version': 'v3',
                        'rateLimit': 1200,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchWithdrawals': true,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': 'min1',
                            '5m': 'min5',
                            '15m': 'min15',
                            '30m': 'min30',
                            '1h': 'hour1',
                            '3h': 'hour3',
                            '4h': 'hour4',
                            '6h': 'hour6',
                            '12h': 'hour12',
                            '1d': 'day1',
                            '1w': 'week1',
                            '1M': 'month1'
                        },
                        'hostname': 'big.one',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/69354403-1d532180-0c91-11ea-88ed-44c06cefdf87.jpg',
                            'api': {
                                'public': 'https://{hostname}/api/v3',
                                'private': 'https://{hostname}/api/v3/viewer'
                            },
                            'www': 'https://big.one',
                            'doc': 'https://open.big.one/docs/api.html',
                            'fees': 'https://bigone.zendesk.com/hc/en-us/articles/115001933374-BigONE-Fee-Policy',
                            'referral': 'https://b1.run/users/new?code=D3LLBVFT'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'ping',
                                    'asset_pairs',
                                    'asset_pairs/{asset_pair_name}/depth',
                                    'asset_pairs/{asset_pair_name}/trades',
                                    'asset_pairs/{asset_pair_name}/ticker',
                                    'asset_pairs/{asset_pair_name}/candles',
                                    'asset_pairs/tickers'
                                ]
                            },
                            'private': {
                                'get': [
                                    'accounts',
                                    'fund/accounts',
                                    'assets/{asset_symbol}/address',
                                    'orders',
                                    'orders/{id}',
                                    'orders/multi',
                                    'trades',
                                    'withdrawals',
                                    'deposits'
                                ],
                                'post': [
                                    'orders',
                                    'orders/{id}/cancel',
                                    'orders/cancel',
                                    'withdrawals',
                                    'transfer'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.001'),
                                'taker': this.parseNumber('0.001')
                            },
                            'funding': {
                                'withdraw': {}
                            }
                        },
                        'options': {
                            'accountsByType': {
                                'spot': 'SPOT',
                                'funding': 'FUND',
                                'future': 'CONTRACT',
                                'swap': 'CONTRACT'
                            },
                            'transfer': {
                                'fillResponseFromRequest': true
                            }
                        },
                        'exceptions': {
                            'exact': {
                                '10001': BadRequest,
                                '10005': ExchangeError1,
                                "Amount's scale must greater than AssetPair's base scale": InvalidOrder,
                                "Price mulit with amount should larger than AssetPair's min_quote_value": InvalidOrder,
                                '10007': BadRequest,
                                '10011': ExchangeError1,
                                '10013': BadSymbol,
                                '10014': InsufficientFunds,
                                '10403': PermissionDenied,
                                '10429': RateLimitExceeded,
                                '40004': AuthenticationError,
                                '40103': AuthenticationError,
                                '40104': AuthenticationError,
                                '40301': PermissionDenied,
                                '40302': ExchangeError1,
                                '40601': ExchangeError1,
                                '40602': ExchangeError1,
                                '40603': InsufficientFunds,
                                '40605': InvalidOrder,
                                '40120': InvalidOrder,
                                '40121': InvalidOrder,
                                '60100': BadSymbol
                            },
                            'broad': {}
                        },
                        'commonCurrencies': {
                            'CRE': 'Cybereits',
                            'FXT': 'FXTTOKEN',
                            'FREE': 'FreeRossDAO',
                            'MBN': 'Mobilian Coin',
                            'ONE': 'BigONE Token'
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetAssetPairs(params);
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "id":"01e48809-b42f-4a38-96b1-c4c547365db1",
                    //                 "name":"PCX-BTC",
                    //                 "quote_scale":7,
                    //                 "quote_asset":{
                    //                     "id":"0df9c3c3-255a-46d7-ab82-dedae169fba9",
                    //                     "symbol":"BTC",
                    //                     "name":"Bitcoin",
                    //                 },
                    //                 "base_asset":{
                    //                     "id":"405484f7-4b03-4378-a9c1-2bd718ecab51",
                    //                     "symbol":"PCX",
                    //                     "name":"ChainX",
                    //                 },
                    //                 "base_scale":3,
                    //                 "min_quote_value":"0.0001",
                    //                 "max_quote_value":"35"
                    //             },
                    //         ]
                    //     }
                    //
                    const markets = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'name');
                        const uuid = this.safeString(market, 'id');
                        const baseAsset = this.safeValue(market, 'base_asset', {});
                        const quoteAsset = this.safeValue(market, 'quote_asset', {});
                        const baseId = this.safeString(baseAsset, 'symbol');
                        const quoteId = this.safeString(quoteAsset, 'symbol');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const entry = {
                            'id': id,
                            'uuid': uuid,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'base_scale'),
                                'price': this.safeInteger(market, 'quote_scale')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_quote_value'),
                                    'max': this.safeNumber(market, 'max_quote_value')
                                }
                            },
                            'info': market
                        };
                        result.push(entry);
                    }
                    return result;
                }
                async loadMarkets(reload = false, params = {}) {
                    const markets = await super.loadMarkets(reload, params);
                    let marketsByUuid = this.safeValue(this.options, 'marketsByUuid');
                    if (marketsByUuid === undefined || reload) {
                        marketsByUuid = {};
                        for(let i = 0; i < this.symbols.length; i++){
                            const symbol = this.symbols[i];
                            const market = this.markets[symbol];
                            const uuid = this.safeString(market, 'uuid');
                            marketsByUuid[uuid] = market;
                        }
                        this.options['marketsByUuid'] = marketsByUuid;
                    }
                    return markets;
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "asset_pair_name":"ETH-BTC",
                    //         "bid":{"price":"0.021593","order_count":1,"quantity":"0.20936"},
                    //         "ask":{"price":"0.021613","order_count":1,"quantity":"2.87064"},
                    //         "open":"0.021795",
                    //         "high":"0.021795",
                    //         "low":"0.021471",
                    //         "close":"0.021613",
                    //         "volume":"117078.90431",
                    //         "daily_change":"-0.000182"
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'asset_pair_name');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const timestamp = undefined;
                    const close = this.safeString(ticker, 'close');
                    const bid = this.safeValue(ticker, 'bid', {});
                    const ask = this.safeValue(ticker, 'ask', {});
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(bid, 'price'),
                        'bidVolume': this.safeString(bid, 'quantity'),
                        'ask': this.safeString(ask, 'price'),
                        'askVolume': this.safeString(ask, 'quantity'),
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open'),
                        'close': close,
                        'last': close,
                        'previousClose': undefined,
                        'change': this.safeString(ticker, 'daily_change'),
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'asset_pair_name': market['id']
                    };
                    const response = await this.publicGetAssetPairsAssetPairNameTicker(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "data":{
                    //             "asset_pair_name":"ETH-BTC",
                    //             "bid":{"price":"0.021593","order_count":1,"quantity":"0.20936"},
                    //             "ask":{"price":"0.021613","order_count":1,"quantity":"2.87064"},
                    //             "open":"0.021795",
                    //             "high":"0.021795",
                    //             "low":"0.021471",
                    //             "close":"0.021613",
                    //             "volume":"117078.90431",
                    //             "daily_change":"-0.000182"
                    //         }
                    //     }
                    //
                    const ticker = this.safeValue(response, 'data', {});
                    return this.parseTicker(ticker, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbols !== undefined) {
                        const ids = this.marketIds(symbols);
                        request['pair_names'] = ids.join(',');
                    }
                    const response = await this.publicGetAssetPairsTickers(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "asset_pair_name":"PCX-BTC",
                    //                 "bid":{"price":"0.000234","order_count":1,"quantity":"0.518"},
                    //                 "ask":{"price":"0.0002348","order_count":1,"quantity":"2.348"},
                    //                 "open":"0.0002343",
                    //                 "high":"0.0002348",
                    //                 "low":"0.0002162",
                    //                 "close":"0.0002348",
                    //                 "volume":"12887.016",
                    //                 "daily_change":"0.0000005"
                    //             },
                    //             {
                    //                 "asset_pair_name":"GXC-USDT",
                    //                 "bid":{"price":"0.5054","order_count":1,"quantity":"40.53"},
                    //                 "ask":{"price":"0.5055","order_count":1,"quantity":"38.53"},
                    //                 "open":"0.5262",
                    //                 "high":"0.5323",
                    //                 "low":"0.5055",
                    //                 "close":"0.5055",
                    //                 "volume":"603963.05",
                    //                 "daily_change":"-0.0207"
                    //             }
                    //         ]
                    //     }
                    //
                    const tickers = this.safeValue(response, 'data', []);
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const ticker = this.parseTicker(tickers[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetPing(params);
                    //
                    //     {
                    //         "data": {
                    //             "timestamp": 1527665262168391000
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const timestamp = this.safeInteger(data, 'timestamp');
                    return parseInt(timestamp / 1000000);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'asset_pair_name': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 50, max 200
                    const response = await this.publicGetAssetPairsAssetPairNameDepth(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "data": {
                    //             "asset_pair_name": "EOS-BTC",
                    //             "bids": [
                    //                 { "price": "42", "order_count": 4, "quantity": "23.33363711" }
                    //             ],
                    //             "asks": [
                    //                 { "price": "45", "order_count": 2, "quantity": "4193.3283464" }
                    //             ]
                    //         }
                    //     }
                    //
                    const orderbook = this.safeValue(response, 'data', {});
                    return this.parseOrderBook(orderbook, symbol, undefined, 'bids', 'asks', 'price', 'quantity');
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "id": 38199941,
                    //         "price": "3378.67",
                    //         "amount": "0.019812",
                    //         "taker_side": "ASK",
                    //         "created_at": "2019-01-29T06:05:56Z"
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "id": 10854280,
                    //         "asset_pair_name": "XIN-USDT",
                    //         "price": "70",
                    //         "amount": "1",
                    //         "taker_side": "ASK",
                    //         "maker_order_id": 58284908,
                    //         "taker_order_id": 58284909,
                    //         "maker_fee": "0.0008",
                    //         "taker_fee": "0.07",
                    //         "side": "SELF_TRADING",
                    //         "inserted_at": "2019-04-16T12:00:01Z"
                    //     },
                    //
                    //     {
                    //         "id": 10854263,
                    //         "asset_pair_name": "XIN-USDT",
                    //         "price": "75.7",
                    //         "amount": "12.743149",
                    //         "taker_side": "BID",
                    //         "maker_order_id": null,
                    //         "taker_order_id": 58284888,
                    //         "maker_fee": null,
                    //         "taker_fee": "0.0025486298",
                    //         "side": "BID",
                    //         "inserted_at": "2019-04-15T06:20:57Z"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString2(trade, 'created_at', 'inserted_at'));
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const marketId = this.safeString(trade, 'asset_pair_name');
                    market = this.safeMarket(marketId, market, '-');
                    let side = this.safeString(trade, 'side');
                    const takerSide = this.safeString(trade, 'taker_side');
                    let takerOrMaker = undefined;
                    if (takerSide !== undefined && side !== undefined && side !== 'SELF_TRADING') takerOrMaker = takerSide === side ? 'taker' : 'maker';
                    if (side === undefined) // taker side is not related to buy/sell side
                    // the following code is probably a mistake
                    side = takerSide === 'ASK' ? 'sell' : 'buy';
                    else {
                        if (side === 'BID') side = 'buy';
                        else if (side === 'ASK') side = 'sell';
                    }
                    const makerOrderId = this.safeString(trade, 'maker_order_id');
                    const takerOrderId = this.safeString(trade, 'taker_order_id');
                    let orderId = undefined;
                    if (makerOrderId !== undefined) {
                        if (takerOrderId !== undefined) orderId = [
                            makerOrderId,
                            takerOrderId
                        ];
                        else orderId = makerOrderId;
                    } else if (takerOrderId !== undefined) orderId = takerOrderId;
                    const id = this.safeString(trade, 'id');
                    const result = {
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': orderId,
                        'type': 'limit',
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'info': trade
                    };
                    let makerCurrencyCode = undefined;
                    let takerCurrencyCode = undefined;
                    if (takerOrMaker !== undefined) {
                        if (side === 'buy') {
                            if (takerOrMaker === 'maker') {
                                makerCurrencyCode = market['base'];
                                takerCurrencyCode = market['quote'];
                            } else {
                                makerCurrencyCode = market['quote'];
                                takerCurrencyCode = market['base'];
                            }
                        } else if (takerOrMaker === 'maker') {
                            makerCurrencyCode = market['quote'];
                            takerCurrencyCode = market['base'];
                        } else {
                            makerCurrencyCode = market['base'];
                            takerCurrencyCode = market['quote'];
                        }
                    } else if (side === 'SELF_TRADING') {
                        if (takerSide === 'BID') {
                            makerCurrencyCode = market['quote'];
                            takerCurrencyCode = market['base'];
                        } else if (takerSide === 'ASK') {
                            makerCurrencyCode = market['base'];
                            takerCurrencyCode = market['quote'];
                        }
                    }
                    const makerFeeCost = this.safeString(trade, 'maker_fee');
                    const takerFeeCost = this.safeString(trade, 'taker_fee');
                    if (makerFeeCost !== undefined) {
                        if (takerFeeCost !== undefined) result['fees'] = [
                            {
                                'cost': makerFeeCost,
                                'currency': makerCurrencyCode
                            },
                            {
                                'cost': takerFeeCost,
                                'currency': takerCurrencyCode
                            }
                        ];
                        else result['fee'] = {
                            'cost': makerFeeCost,
                            'currency': makerCurrencyCode
                        };
                    } else if (takerFeeCost !== undefined) result['fee'] = {
                        'cost': takerFeeCost,
                        'currency': takerCurrencyCode
                    };
                    else result['fee'] = undefined;
                    return this.safeTrade(result, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'asset_pair_name': market['id']
                    };
                    const response = await this.publicGetAssetPairsAssetPairNameTrades(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "id": 38199941,
                    //                 "price": "3378.67",
                    //                 "amount": "0.019812",
                    //                 "taker_side": "ASK",
                    //                 "created_at": "2019-01-29T06:05:56Z"
                    //             },
                    //             {
                    //                 "id": 38199934,
                    //                 "price": "3376.14",
                    //                 "amount": "0.019384",
                    //                 "taker_side": "ASK",
                    //                 "created_at": "2019-01-29T06:05:40Z"
                    //             }
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, 'data', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         close: '0.021562',
                    //         high: '0.021563',
                    //         low: '0.02156',
                    //         open: '0.021563',
                    //         time: '2019-11-21T07:54:00Z',
                    //         volume: '59.84376'
                    //     }
                    //
                    return [
                        this.parse8601(this.safeString(ohlcv, 'time')),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (limit === undefined) limit = 100; // default 100, max 500
                    const request = {
                        'asset_pair_name': market['id'],
                        'period': this.timeframes[timeframe],
                        'limit': limit
                    };
                    if (since !== undefined) {
                        // const start = parseInt (since / 1000);
                        const duration = this.parseTimeframe(timeframe);
                        const end = this.sum(since, limit * duration * 1000);
                        request['time'] = this.iso8601(end);
                    }
                    const response = await this.publicGetAssetPairsAssetPairNameCandles(this.extend(request, params));
                    //
                    //     {
                    //         code: 0,
                    //         data: [
                    //             {
                    //                 close: '0.021656',
                    //                 high: '0.021658',
                    //                 low: '0.021652',
                    //                 open: '0.021652',
                    //                 time: '2019-11-21T09:30:00Z',
                    //                 volume: '53.08664'
                    //             },
                    //             {
                    //                 close: '0.021652',
                    //                 high: '0.021656',
                    //                 low: '0.021652',
                    //                 open: '0.021656',
                    //                 time: '2019-11-21T09:29:00Z',
                    //                 volume: '88.39861'
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const balances = this.safeValue(response, 'data', []);
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const symbol = this.safeString(balance, 'asset_symbol');
                        const code = this.safeCurrencyCode(symbol);
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'balance');
                        account['used'] = this.safeString(balance, 'locked_balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const type = this.safeString(params, 'type', '');
                    params = this.omit(params, 'type');
                    const method = 'privateGet' + this.capitalize(type) + 'Accounts';
                    const response = await this[method](params);
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             {"asset_symbol":"NKC","balance":"0","locked_balance":"0"},
                    //             {"asset_symbol":"UBTC","balance":"0","locked_balance":"0"},
                    //             {"asset_symbol":"READ","balance":"0","locked_balance":"0"},
                    //         ],
                    //     }
                    //
                    return this.parseBalance(response);
                }
                parseOrder(order, market) {
                    //
                    //    {
                    //        "id": 10,
                    //        "asset_pair_name": "EOS-BTC",
                    //        "price": "10.00",
                    //        "amount": "10.00",
                    //        "filled_amount": "9.0",
                    //        "avg_deal_price": "12.0",
                    //        "side": "ASK",
                    //        "state": "FILLED",
                    //        "created_at":"2019-01-29T06:05:56Z",
                    //        "updated_at":"2019-01-29T06:05:56Z",
                    //    }
                    //
                    const id = this.safeString(order, 'id');
                    const marketId = this.safeString(order, 'asset_pair_name');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'amount');
                    const average = this.safeString(order, 'avg_deal_price');
                    const filled = this.safeString(order, 'filled_amount');
                    const status = this.parseOrderStatus(this.safeString(order, 'state'));
                    let side = this.safeString(order, 'side');
                    if (side === 'BID') side = 'buy';
                    else side = 'sell';
                    const lastTradeTimestamp = this.parse8601(this.safeString(order, 'updated_at'));
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': undefined,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'average': average,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    side = side === 'buy' ? 'BID' : 'ASK';
                    const uppercaseType = type.toUpperCase();
                    const request = {
                        'asset_pair_name': market['id'],
                        'side': side,
                        'amount': this.amountToPrecision(symbol, amount),
                        // 'price': this.priceToPrecision (symbol, price), // order price, string, required
                        'type': uppercaseType
                    };
                    if (uppercaseType === 'LIMIT') request['price'] = this.priceToPrecision(symbol, price);
                    else {
                        const isStopLimit = uppercaseType === 'STOP_LIMIT';
                        const isStopMarket = uppercaseType === 'STOP_MARKET';
                        if (isStopLimit || isStopMarket) {
                            const stopPrice = this.safeNumber2(params, 'stop_price', 'stopPrice');
                            if (stopPrice === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a stop_price parameter');
                            request['stop_price'] = this.priceToPrecision(symbol, stopPrice);
                            params = this.omit(params, [
                                'stop_price',
                                'stopPrice'
                            ]);
                        }
                        if (isStopLimit) request['price'] = this.priceToPrecision(symbol, price);
                    }
                    const response = await this.privatePostOrders(this.extend(request, params));
                    //
                    //    {
                    //        "id": 10,
                    //        "asset_pair_name": "EOS-BTC",
                    //        "price": "10.00",
                    //        "amount": "10.00",
                    //        "filled_amount": "9.0",
                    //        "avg_deal_price": "12.0",
                    //        "side": "ASK",
                    //        "state": "FILLED",
                    //        "created_at":"2019-01-29T06:05:56Z",
                    //        "updated_at":"2019-01-29T06:05:56Z"
                    //    }
                    //
                    const order = this.safeValue(response, 'data');
                    return this.parseOrder(order, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privatePostOrdersIdCancel(this.extend(request, params));
                    //    {
                    //        "id": 10,
                    //        "asset_pair_name": "EOS-BTC",
                    //        "price": "10.00",
                    //        "amount": "10.00",
                    //        "filled_amount": "9.0",
                    //        "avg_deal_price": "12.0",
                    //        "side": "ASK",
                    //        "state": "CANCELLED",
                    //        "created_at":"2019-01-29T06:05:56Z",
                    //        "updated_at":"2019-01-29T06:05:56Z"
                    //    }
                    const order = this.safeValue(response, 'data');
                    return this.parseOrder(order);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'asset_pair_name': market['id']
                    };
                    const response = await this.privatePostOrdersCancel(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "data": {
                    //             "cancelled":[
                    //                 58272370,
                    //                 58272377
                    //             ],
                    //             "failed": []
                    //         }
                    //     }
                    //
                    return response;
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetOrdersId(this.extend(request, params));
                    const order = this.safeValue(response, 'data', {});
                    return this.parseOrder(order);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'asset_pair_name': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 20, max 200
                    const response = await this.privateGetOrders(this.extend(request, params));
                    //
                    //    {
                    //        "code":0,
                    //        "data": [
                    //             {
                    //                 "id": 10,
                    //                 "asset_pair_name": "ETH-BTC",
                    //                 "price": "10.00",
                    //                 "amount": "10.00",
                    //                 "filled_amount": "9.0",
                    //                 "avg_deal_price": "12.0",
                    //                 "side": "ASK",
                    //                 "state": "FILLED",
                    //                 "created_at":"2019-01-29T06:05:56Z",
                    //                 "updated_at":"2019-01-29T06:05:56Z",
                    //             },
                    //         ],
                    //        "page_token":"dxzef",
                    //    }
                    //
                    const orders = this.safeValue(response, 'data', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    const market = this.market(symbol);
                    const request = {
                        'asset_pair_name': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 20, max 200
                    const response = await this.privateGetTrades(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "id": 10854280,
                    //                 "asset_pair_name": "XIN-USDT",
                    //                 "price": "70",
                    //                 "amount": "1",
                    //                 "taker_side": "ASK",
                    //                 "maker_order_id": 58284908,
                    //                 "taker_order_id": 58284909,
                    //                 "maker_fee": "0.0008",
                    //                 "taker_fee": "0.07",
                    //                 "side": "SELF_TRADING",
                    //                 "inserted_at": "2019-04-16T12:00:01Z"
                    //             },
                    //             {
                    //                 "id": 10854263,
                    //                 "asset_pair_name": "XIN-USDT",
                    //                 "price": "75.7",
                    //                 "amount": "12.743149",
                    //                 "taker_side": "BID",
                    //                 "maker_order_id": null,
                    //                 "taker_order_id": 58284888,
                    //                 "maker_fee": null,
                    //                 "taker_fee": "0.0025486298",
                    //                 "side": "BID",
                    //                 "inserted_at": "2019-04-15T06:20:57Z"
                    //             }
                    //         ],
                    //         "page_token":"dxfv"
                    //     }
                    //
                    const trades = this.safeValue(response, 'data', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'PENDING': 'open',
                        'FILLED': 'closed',
                        'CANCELLED': 'canceled'
                    };
                    return this.safeString(statuses, status);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'state': 'PENDING'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'state': 'FILLED'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                nonce() {
                    return this.microseconds() * 1000;
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const query = this.omit(params, this.extractParams(path));
                    const baseUrl = this.implodeHostname(this.urls['api'][api]);
                    let url = baseUrl + '/' + this.implodeParams(path, params);
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const request = {
                            'type': 'OpenAPIV2',
                            'sub': this.apiKey,
                            'nonce': nonce
                        };
                        const jwt = this.jwt(request, this.encode(this.secret));
                        headers = {
                            'Authorization': 'Bearer ' + jwt
                        };
                        if (method === 'GET') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else if (method === 'POST') {
                            headers['Content-Type'] = 'application/json';
                            body = this.json(query);
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'asset_symbol': currency['id']
                    };
                    const response = await this.privateGetAssetsAssetSymbolAddress(this.extend(request, params));
                    //
                    // the actual response format is not the same as the documented one
                    // the data key contains an array in the actual response
                    //
                    //     {
                    //         "code":0,
                    //         "message":"",
                    //         "data":[
                    //             {
                    //                 "id":5521878,
                    //                 "chain":"Bitcoin",
                    //                 "value":"1GbmyKoikhpiQVZ1C9sbF17mTyvBjeobVe",
                    //                 "memo":""
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const dataLength = data.length;
                    if (dataLength < 1) throw new ExchangeError1(this.id + ' fetchDepositAddress() returned empty address response');
                    const firstElement = data[0];
                    const address = this.safeString(firstElement, 'value');
                    const tag = this.safeString(firstElement, 'memo');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        // what are other statuses here?
                        'WITHHOLD': 'ok',
                        'UNCONFIRMED': 'pending',
                        'CONFIRMED': 'ok',
                        'COMPLETED': 'ok',
                        'PENDING': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "amount": "25.0",
                    //         "asset_symbol": "BTS"
                    //         "confirms": 100,
                    //         "id": 5,
                    //         "inserted_at": "2018-02-16T11:39:58.000Z",
                    //         "is_internal": false,
                    //         "kind": "default",
                    //         "memo": "",
                    //         "state": "WITHHOLD",
                    //         "txid": "72e03037d144dae3d32b68b5045462b1049a0755",
                    //         "updated_at": "2018-11-09T10:20:09.000Z",
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "amount": "5",
                    //         "asset_symbol": "ETH",
                    //         "completed_at": "2018-03-15T16:13:45.610463Z",
                    //         "customer_id": "10",
                    //         "id": 10,
                    //         "inserted_at": "2018-03-15T16:13:45.610463Z",
                    //         "is_internal": true,
                    //         "note": "2018-03-15T16:13:45.610463Z",
                    //         "state": "CONFIRMED",
                    //         "target_address": "0x4643bb6b393ac20a6175c713175734a72517c63d6f7"
                    //         "txid": "0x4643bb6b393ac20a6175c713175734a72517c63d6f73a3ca90a15356f2e967da0",
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "id":1077391,
                    //         "customer_id":1082679,
                    //         "amount":"21.9000000000000000",
                    //         "txid":"",
                    //         "is_internal":false,
                    //         "kind":"on_chain",
                    //         "state":"PENDING",
                    //         "inserted_at":"2020-06-03T00:50:57+00:00",
                    //         "updated_at":"2020-06-03T00:50:57+00:00",
                    //         "memo":"",
                    //         "target_address":"rDYtYT3dBeuw376rvHqoZBKW3UmvguoBAf",
                    //         "fee":"0.1000000000000000",
                    //         "asset_symbol":"XRP"
                    //     }
                    //
                    const currencyId = this.safeString(transaction, 'asset_symbol');
                    const code = this.safeCurrencyCode(currencyId);
                    const id = this.safeInteger(transaction, 'id');
                    const amount = this.safeNumber(transaction, 'amount');
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    const timestamp = this.parse8601(this.safeString(transaction, 'inserted_at'));
                    const updated = this.parse8601(this.safeString2(transaction, 'updated_at', 'completed_at'));
                    const txid = this.safeString(transaction, 'txid');
                    const address = this.safeString(transaction, 'target_address');
                    const tag = this.safeString(transaction, 'memo');
                    const type = 'customer_id' in transaction ? 'deposit' : 'withdrawal';
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': address,
                        'tagFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': undefined
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['asset_symbol'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 50
                    const response = await this.privateGetDeposits(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "page_token": "NQ==",
                    //         "data": [
                    //             {
                    //                 "id": 5,
                    //                 "amount": "25.0",
                    //                 "confirms": 100,
                    //                 "txid": "72e03037d144dae3d32b68b5045462b1049a0755",
                    //                 "is_internal": false,
                    //                 "inserted_at": "2018-02-16T11:39:58.000Z",
                    //                 "updated_at": "2018-11-09T10:20:09.000Z",
                    //                 "kind": "default",
                    //                 "memo": "",
                    //                 "state": "WITHHOLD",
                    //                 "asset_symbol": "BTS"
                    //             }
                    //         ]
                    //     }
                    //
                    const deposits = this.safeValue(response, 'data', []);
                    return this.parseTransactions(deposits, code, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['asset_symbol'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 50
                    const response = await this.privateGetWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "id": 10,
                    //                 "customer_id": "10",
                    //                 "asset_symbol": "ETH",
                    //                 "amount": "5",
                    //                 "state": "CONFIRMED",
                    //                 "note": "2018-03-15T16:13:45.610463Z",
                    //                 "txid": "0x4643bb6b393ac20a6175c713175734a72517c63d6f73a3ca90a15356f2e967da0",
                    //                 "completed_at": "2018-03-15T16:13:45.610463Z",
                    //                 "inserted_at": "2018-03-15T16:13:45.610463Z",
                    //                 "is_internal": true,
                    //                 "target_address": "0x4643bb6b393ac20a6175c713175734a72517c63d6f7"
                    //             }
                    //         ],
                    //         "page_token":"dxvf"
                    //     }
                    //
                    const withdrawals = this.safeValue(response, 'data', []);
                    return this.parseTransactions(withdrawals, code, since, limit);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                    const toId = this.safeString(accountsByType, toAccount, toAccount);
                    const guid = this.safeString(params, 'guid', this.uuid());
                    const request = {
                        'symbol': currency['id'],
                        'amount': this.currencyToPrecision(code, amount),
                        'from': fromId,
                        'to': toId,
                        'guid': guid
                    };
                    const response = await this.privatePostTransfer(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": null
                    //     }
                    //
                    const transfer = this.parseTransfer(response, currency);
                    const transferOptions = this.safeValue(this.options, 'transfer', {});
                    const fillResponseFromRequest = this.safeValue(transferOptions, 'fillResponseFromRequest', true);
                    if (fillResponseFromRequest) {
                        transfer['fromAccount'] = fromAccount;
                        transfer['toAccount'] = toAccount;
                        transfer['amount'] = amount;
                        transfer['id'] = guid;
                    }
                    return transfer;
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //         "code": 0,
                    //         "data": null
                    //     }
                    //
                    const code = this.safeNumber(transfer, 'code');
                    return {
                        'info': transfer,
                        'id': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'currency': code,
                        'amount': undefined,
                        'fromAccount': undefined,
                        'toAccount': undefined,
                        'status': this.parseTransferStatus(code)
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        '0': 'ok'
                    };
                    return this.safeString(statuses, status, 'failed');
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'symbol': currency['id'],
                        'target_address': address,
                        'amount': this.currencyToPrecision(code, amount)
                    };
                    if (tag !== undefined) request['memo'] = tag;
                    // requires write permission on the wallet
                    const response = await this.privatePostWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "message":"",
                    //         "data":{
                    //             "id":1077391,
                    //             "customer_id":1082679,
                    //             "amount":"21.9000000000000000",
                    //             "txid":"",
                    //             "is_internal":false,
                    //             "kind":"on_chain",
                    //             "state":"PENDING",
                    //             "inserted_at":"2020-06-03T00:50:57+00:00",
                    //             "updated_at":"2020-06-03T00:50:57+00:00",
                    //             "memo":"",
                    //             "target_address":"rDYtYT3dBeuw376rvHqoZBKW3UmvguoBAf",
                    //             "fee":"0.1000000000000000",
                    //             "asset_symbol":"XRP"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTransaction(data, currency);
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //      {"code":10013,"message":"Resource not found"}
                    //      {"code":40004,"message":"invalid jwt"}
                    //
                    const code = this.safeString(response, 'code');
                    const message = this.safeString(response, 'message');
                    if (code !== '0') {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    23: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, ExchangeNotAvailable: ExchangeNotAvailable, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, DDoSProtection: DDoSProtection, InvalidNonce: InvalidNonce, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded, PermissionDenied: PermissionDenied, NotSupported: NotSupported, BadRequest: BadRequest, BadSymbol: BadSymbol, AccountSuspended: AccountSuspended, OrderImmediatelyFillable: OrderImmediatelyFillable, OnMaintenance: OnMaintenance, BadResponse: BadResponse, RequestTimeout: RequestTimeout, OrderNotFillable: OrderNotFillable, MarginModeAlreadySet: MarginModeAlreadySet } = require1('./base/errors');
            const { TRUNCATE: TRUNCATE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class binance extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'binance',
                        'name': 'Binance',
                        'countries': [
                            'JP',
                            'MT'
                        ],
                        'rateLimit': 50,
                        'certified': true,
                        'pro': true,
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': true,
                            'swap': true,
                            'future': true,
                            'option': undefined,
                            'addMargin': true,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'cancelOrders': undefined,
                            'createDepositAddress': false,
                            'createOrder': true,
                            'createReduceOnlyOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': false,
                            'createStopOrder': true,
                            'fetchAccounts': undefined,
                            'fetchBalance': true,
                            'fetchBidsAsks': true,
                            'fetchBorrowInterest': true,
                            'fetchBorrowRate': true,
                            'fetchBorrowRateHistories': undefined,
                            'fetchBorrowRateHistory': true,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchCanceledOrders': false,
                            'fetchClosedOrder': undefined,
                            'fetchClosedOrders': 'emulated',
                            'fetchCurrencies': true,
                            'fetchDeposit': false,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': false,
                            'fetchDepositAddressesByNetwork': false,
                            'fetchDeposits': true,
                            'fetchFundingFee': undefined,
                            'fetchFundingFees': true,
                            'fetchFundingHistory': true,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': true,
                            'fetchFundingRates': true,
                            'fetchIndexOHLCV': true,
                            'fetchL3OrderBook': undefined,
                            'fetchLedger': undefined,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': true,
                            'fetchMarketLeverageTiers': 'emulated',
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': true,
                            'fetchMyBuys': undefined,
                            'fetchMySells': undefined,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': false,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': false,
                            'fetchOrders': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': undefined,
                            'fetchPositions': true,
                            'fetchPositionsRisk': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': true,
                            'fetchTradingLimits': undefined,
                            'fetchTransactions': false,
                            'fetchTransfers': true,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': true,
                            'fetchWithdrawalWhitelist': false,
                            'reduceMargin': true,
                            'setLeverage': true,
                            'setMarginMode': true,
                            'setPositionMode': true,
                            'signIn': false,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '3m': '3m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '2h': '2h',
                            '4h': '4h',
                            '6h': '6h',
                            '8h': '8h',
                            '12h': '12h',
                            '1d': '1d',
                            '3d': '3d',
                            '1w': '1w',
                            '1M': '1M'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/29604020-d5483cdc-87ee-11e7-94c7-d1a8d9169293.jpg',
                            'test': {
                                'dapiPublic': 'https://testnet.binancefuture.com/dapi/v1',
                                'dapiPrivate': 'https://testnet.binancefuture.com/dapi/v1',
                                'vapiPublic': 'https://testnet.binanceops.com/vapi/v1',
                                'vapiPrivate': 'https://testnet.binanceops.com/vapi/v1',
                                'fapiPublic': 'https://testnet.binancefuture.com/fapi/v1',
                                'fapiPrivate': 'https://testnet.binancefuture.com/fapi/v1',
                                'fapiPrivateV2': 'https://testnet.binancefuture.com/fapi/v2',
                                'public': 'https://testnet.binance.vision/api/v3',
                                'private': 'https://testnet.binance.vision/api/v3',
                                'v1': 'https://testnet.binance.vision/api/v1'
                            },
                            'api': {
                                'wapi': 'https://api.binance.com/wapi/v3',
                                'sapi': 'https://api.binance.com/sapi/v1',
                                'sapiV3': 'https://api.binance.com/sapi/v3',
                                'dapiPublic': 'https://dapi.binance.com/dapi/v1',
                                'dapiPrivate': 'https://dapi.binance.com/dapi/v1',
                                'vapiPublic': 'https://vapi.binance.com/vapi/v1',
                                'vapiPrivate': 'https://vapi.binance.com/vapi/v1',
                                'dapiPrivateV2': 'https://dapi.binance.com/dapi/v2',
                                'dapiData': 'https://dapi.binance.com/futures/data',
                                'fapiPublic': 'https://fapi.binance.com/fapi/v1',
                                'fapiPrivate': 'https://fapi.binance.com/fapi/v1',
                                'fapiData': 'https://fapi.binance.com/futures/data',
                                'fapiPrivateV2': 'https://fapi.binance.com/fapi/v2',
                                'public': 'https://api.binance.com/api/v3',
                                'private': 'https://api.binance.com/api/v3',
                                'v1': 'https://api.binance.com/api/v1'
                            },
                            'www': 'https://www.binance.com',
                            'referral': {
                                'url': 'https://www.binance.com/en/register?ref=D7YA7CLY',
                                'discount': 0.1
                            },
                            'doc': [
                                'https://binance-docs.github.io/apidocs/spot/en'
                            ],
                            'api_management': 'https://www.binance.com/en/usercenter/settings/api-management',
                            'fees': 'https://www.binance.com/en/fee/schedule'
                        },
                        'depth': 1,
                        'api': {
                            // the API structure below will need 3-layer apidefs
                            'sapi': {
                                // IP (api) = 1200 per minute => (rateLimit = 50)
                                // IP (sapi) request rate limit of 12 000 per minute
                                // 1 IP (sapi) => cost = 0.1
                                // 10 IP (sapi) => cost = 1
                                // UID (sapi) request rate limit of 180 000 per minute
                                // 1 UID (sapi) => cost = 1200 / 180 000 = 0.006667
                                'get': {
                                    'system/status': 0.1,
                                    // these endpoints require this.apiKey
                                    'accountSnapshot': 240,
                                    'margin/asset': 1,
                                    'margin/pair': 1,
                                    'margin/allAssets': 0.1,
                                    'margin/allPairs': 0.1,
                                    'margin/priceIndex': 1,
                                    // these endpoints require this.apiKey + this.secret
                                    'asset/assetDividend': 1,
                                    'asset/dribblet': 0.1,
                                    'asset/transfer': 0.1,
                                    'asset/assetDetail': 0.1,
                                    'asset/tradeFee': 0.1,
                                    'margin/loan': 1,
                                    'margin/repay': 1,
                                    'margin/account': 1,
                                    'margin/transfer': 0.1,
                                    'margin/interestHistory': 0.1,
                                    'margin/forceLiquidationRec': 0.1,
                                    'margin/order': 1,
                                    'margin/openOrders': 1,
                                    'margin/allOrders': 20,
                                    'margin/myTrades': 1,
                                    'margin/maxBorrowable': 5,
                                    'margin/maxTransferable': 5,
                                    'margin/isolated/transfer': 0.1,
                                    'margin/isolated/account': 1,
                                    'margin/isolated/pair': 1,
                                    'margin/isolated/allPairs': 1,
                                    'margin/isolated/accountLimit': 0.1,
                                    'margin/interestRateHistory': 0.1,
                                    'margin/orderList': 1,
                                    'margin/allOrderList': 20,
                                    'margin/openOrderList': 1,
                                    'margin/crossMarginData': {
                                        'cost': 0.1,
                                        'noCoin': 0.5
                                    },
                                    'margin/isolatedMarginData': {
                                        'cost': 0.1,
                                        'noCoin': 1
                                    },
                                    'margin/isolatedMarginTier': 0.1,
                                    'margin/rateLimit/order': 2,
                                    'loan/income': 40,
                                    'fiat/orders': 0.1,
                                    'fiat/payments': 0.1,
                                    'futures/transfer': 1,
                                    'futures/loan/borrow/history': 1,
                                    'futures/loan/repay/history': 1,
                                    'futures/loan/wallet': 1,
                                    'futures/loan/configs': 1,
                                    'futures/loan/calcAdjustLevel': 5,
                                    'futures/loan/calcMaxAdjustAmount': 5,
                                    'futures/loan/adjustCollateral/history': 1,
                                    'futures/loan/liquidationHistory': 1,
                                    'rebate/taxQuery': 20.001,
                                    // https://binance-docs.github.io/apidocs/spot/en/#withdraw-sapi
                                    'capital/config/getall': 1,
                                    'capital/deposit/address': 1,
                                    'capital/deposit/hisrec': 0.1,
                                    'capital/deposit/subAddress': 0.1,
                                    'capital/deposit/subHisrec': 0.1,
                                    'capital/withdraw/history': 0.1,
                                    'convert/tradeFlow': 20.001,
                                    'account/status': 0.1,
                                    'account/apiTradingStatus': 0.1,
                                    'account/apiRestrictions/ipRestriction': 0.1,
                                    'bnbBurn': 0.1,
                                    // 'sub-account/assets': 1, (v3 endpoint)
                                    'sub-account/futures/account': 1,
                                    'sub-account/futures/accountSummary': 0.1,
                                    'sub-account/futures/positionRisk': 1,
                                    'sub-account/futures/internalTransfer': 0.1,
                                    'sub-account/list': 0.1,
                                    'sub-account/margin/account': 1,
                                    'sub-account/margin/accountSummary': 1,
                                    'sub-account/spotSummary': 0.1,
                                    'sub-account/status': 1,
                                    'sub-account/sub/transfer/history': 0.1,
                                    'sub-account/transfer/subUserHistory': 0.1,
                                    'sub-account/universalTransfer': 0.1,
                                    'managed-subaccount/asset': 0.1,
                                    'managed-subaccount/accountSnapshot': 240,
                                    // lending endpoints
                                    'lending/daily/product/list': 0.1,
                                    'lending/daily/userLeftQuota': 0.1,
                                    'lending/daily/userRedemptionQuota': 0.1,
                                    'lending/daily/token/position': 0.1,
                                    'lending/union/account': 0.1,
                                    'lending/union/purchaseRecord': 0.1,
                                    'lending/union/redemptionRecord': 0.1,
                                    'lending/union/interestHistory': 0.1,
                                    'lending/project/list': 0.1,
                                    'lending/project/position/list': 0.1,
                                    // mining endpoints
                                    'mining/pub/algoList': 0.1,
                                    'mining/pub/coinList': 0.1,
                                    'mining/worker/detail': 0.5,
                                    'mining/worker/list': 0.5,
                                    'mining/payment/list': 0.5,
                                    'mining/statistics/user/status': 0.5,
                                    'mining/statistics/user/list': 0.5,
                                    'mining/payment/uid': 0.5,
                                    // liquid swap endpoints
                                    'bswap/pools': 0.1,
                                    'bswap/liquidity': {
                                        'cost': 0.1,
                                        'noPoolId': 1
                                    },
                                    'bswap/liquidityOps': 20.001,
                                    'bswap/quote': 1.00005,
                                    'bswap/swap': 20.001,
                                    'bswap/poolConfigure': 1.00005,
                                    'bswap/addLiquidityPreview': 1.00005,
                                    'bswap/removeLiquidityPreview': 1.00005,
                                    'bswap/unclaimedRewards': 6.667,
                                    'bswap/claimedHistory': 6.667,
                                    // leveraged token endpoints
                                    'blvt/tokenInfo': 0.1,
                                    'blvt/subscribe/record': 0.1,
                                    'blvt/redeem/record': 0.1,
                                    'blvt/userLimit': 0.1,
                                    // broker api TODO (NOT IN DOCS)
                                    'apiReferral/ifNewUser': 1,
                                    'apiReferral/customization': 1,
                                    'apiReferral/userCustomization': 1,
                                    'apiReferral/rebate/recentRecord': 1,
                                    'apiReferral/rebate/historicalRecord': 1,
                                    'apiReferral/kickback/recentRecord': 1,
                                    'apiReferral/kickback/historicalRecord': 1,
                                    // brokerage API TODO https://binance-docs.github.io/Brokerage-API/General/ does not state ratelimits
                                    'broker/subAccountApi': 1,
                                    'broker/subAccount': 1,
                                    'broker/subAccountApi/commission/futures': 1,
                                    'broker/subAccountApi/commission/coinFutures': 1,
                                    'broker/info': 1,
                                    'broker/transfer': 1,
                                    'broker/transfer/futures': 1,
                                    'broker/rebate/recentRecord': 1,
                                    'broker/rebate/historicalRecord': 1,
                                    'broker/subAccount/bnbBurn/status': 1,
                                    'broker/subAccount/depositHist': 1,
                                    'broker/subAccount/spotSummary': 1,
                                    'broker/subAccount/marginSummary': 1,
                                    'broker/subAccount/futuresSummary': 1,
                                    'broker/rebate/futures/recentRecord': 1,
                                    'broker/subAccountApi/ipRestriction': 1,
                                    'broker/universalTransfer': 1,
                                    // v2 not supported yet
                                    // GET /sapi/v2/broker/subAccount/futuresSummary
                                    'account/apiRestrictions': 0.1,
                                    // c2c / p2p
                                    'c2c/orderMatch/listUserOrderHistory': 0.1,
                                    // nft endpoints
                                    'nft/history/transactions': 20.001,
                                    'nft/history/deposit': 20.001,
                                    'nft/history/withdraw': 20.001,
                                    'nft/user/getAsset': 20.001,
                                    'pay/transactions': 20.001,
                                    'giftcard/verify': 0.1,
                                    'algo/futures/openOrders': 0.1,
                                    'algo/futures/historicalOrders': 0.1,
                                    'algo/futures/subOrders': 0.1,
                                    'portfolio/account': 0.1,
                                    // staking
                                    'staking/productList': 0.1,
                                    'staking/position': 0.1,
                                    'staking/stakingRecord': 0.1,
                                    'staking/personalLeftQuota': 0.1
                                },
                                'post': {
                                    'asset/dust': 1,
                                    'asset/dust-btc': 0.1,
                                    'asset/transfer': 0.1,
                                    'asset/get-funding-asset': 0.1,
                                    'account/disableFastWithdrawSwitch': 0.1,
                                    'account/enableFastWithdrawSwitch': 0.1,
                                    // 'account/apiRestrictions/ipRestriction': 1, discontinued
                                    // 'account/apiRestrictions/ipRestriction/ipList': 1, discontinued
                                    'capital/withdraw/apply': 0.1,
                                    'margin/transfer': 1,
                                    'margin/loan': 20.001,
                                    'margin/repay': 20.001,
                                    'margin/order': 0.040002,
                                    'margin/order/oco': 0.040002,
                                    // 'margin/isolated/create': 1, discontinued
                                    'margin/isolated/transfer': 4.0002,
                                    'margin/isolated/account': 2.0001,
                                    'bnbBurn': 0.1,
                                    'sub-account/margin/transfer': 4.0002,
                                    'sub-account/margin/enable': 0.1,
                                    'sub-account/futures/enable': 0.1,
                                    'sub-account/futures/transfer': 0.1,
                                    'sub-account/futures/internalTransfer': 0.1,
                                    'sub-account/transfer/subToSub': 0.1,
                                    'sub-account/transfer/subToMaster': 0.1,
                                    'sub-account/universalTransfer': 0.1,
                                    'managed-subaccount/deposit': 0.1,
                                    'managed-subaccount/withdraw': 0.1,
                                    'userDataStream': 0.1,
                                    'userDataStream/isolated': 0.1,
                                    'futures/transfer': 0.1,
                                    'futures/loan/borrow': 20.001,
                                    'futures/loan/repay': 20.001,
                                    'futures/loan/adjustCollateral': 20.001,
                                    // lending
                                    'lending/customizedFixed/purchase': 0.1,
                                    'lending/daily/purchase': 0.1,
                                    'lending/daily/redeem': 0.1,
                                    // liquid swap endpoints
                                    'bswap/liquidityAdd': 60,
                                    'bswap/liquidityRemove': 60,
                                    'bswap/swap': 60,
                                    'bswap/claimRewards': 6.667,
                                    // leveraged token endpoints
                                    'blvt/subscribe': 0.1,
                                    'blvt/redeem': 0.1,
                                    // brokerage API TODO: NO MENTION OF RATELIMITS IN BROKERAGE DOCS
                                    'apiReferral/customization': 1,
                                    'apiReferral/userCustomization': 1,
                                    'apiReferral/rebate/historicalRecord': 1,
                                    'apiReferral/kickback/historicalRecord': 1,
                                    'broker/subAccount': 1,
                                    'broker/subAccount/margin': 1,
                                    'broker/subAccount/futures': 1,
                                    'broker/subAccountApi': 1,
                                    'broker/subAccountApi/permission': 1,
                                    'broker/subAccountApi/commission': 1,
                                    'broker/subAccountApi/commission/futures': 1,
                                    'broker/subAccountApi/commission/coinFutures': 1,
                                    'broker/transfer': 1,
                                    'broker/transfer/futures': 1,
                                    'broker/rebate/historicalRecord': 1,
                                    'broker/subAccount/bnbBurn/spot': 1,
                                    'broker/subAccount/bnbBurn/marginInterest': 1,
                                    'broker/subAccount/blvt': 1,
                                    'broker/subAccountApi/ipRestriction': 1,
                                    'broker/subAccountApi/ipRestriction/ipList': 1,
                                    'broker/universalTransfer': 1,
                                    'broker/subAccountApi/permission/universalTransfer': 1,
                                    'broker/subAccountApi/permission/vanillaOptions': 1,
                                    //
                                    'giftcard/createCode': 0.1,
                                    'giftcard/redeemCode': 0.1,
                                    'algo/futures/newOrderVp': 20.001,
                                    'algo/futures/newOrderTwap': 20.001,
                                    // staking
                                    'staking/purchase': 0.1,
                                    'staking/redeem': 0.1,
                                    'staking/setAutoStaking': 0.1
                                },
                                'put': {
                                    'userDataStream': 0.1,
                                    'userDataStream/isolated': 0.1
                                },
                                'delete': {
                                    // 'account/apiRestrictions/ipRestriction/ipList': 1, discontinued
                                    'margin/openOrders': 0.1,
                                    'margin/order': 0.0066667,
                                    'margin/orderList': 0.0066667,
                                    'margin/isolated/account': 2.0001,
                                    'userDataStream': 0.1,
                                    'userDataStream/isolated': 0.1,
                                    // brokerage API TODO NO MENTION OF RATELIMIT IN BROKERAGE DOCS
                                    'broker/subAccountApi': 1,
                                    'broker/subAccountApi/ipRestriction/ipList': 1,
                                    'algo/futures/order': 0.1
                                }
                            },
                            'sapiV3': {
                                'get': {
                                    'sub-account/assets': 1
                                }
                            },
                            // deprecated
                            'wapi': {
                                'post': {
                                    'withdraw': 1,
                                    'sub-account/transfer': 1
                                },
                                'get': {
                                    'depositHistory': 1,
                                    'withdrawHistory': 1,
                                    'depositAddress': 1,
                                    'accountStatus': 1,
                                    'systemStatus': 1,
                                    'apiTradingStatus': 1,
                                    'userAssetDribbletLog': 1,
                                    'tradeFee': 1,
                                    'assetDetail': 1,
                                    'sub-account/list': 1,
                                    'sub-account/transfer/history': 1,
                                    'sub-account/assets': 1
                                }
                            },
                            'dapiPublic': {
                                'get': {
                                    'ping': 1,
                                    'time': 1,
                                    'exchangeInfo': 1,
                                    'depth': {
                                        'cost': 2,
                                        'byLimit': [
                                            [
                                                50,
                                                2
                                            ],
                                            [
                                                100,
                                                5
                                            ],
                                            [
                                                500,
                                                10
                                            ],
                                            [
                                                1000,
                                                20
                                            ]
                                        ]
                                    },
                                    'trades': 1,
                                    'historicalTrades': 20,
                                    'aggTrades': 20,
                                    'premiumIndex': 10,
                                    'fundingRate': 1,
                                    'klines': {
                                        'cost': 1,
                                        'byLimit': [
                                            [
                                                99,
                                                1
                                            ],
                                            [
                                                499,
                                                2
                                            ],
                                            [
                                                1000,
                                                5
                                            ],
                                            [
                                                10000,
                                                10
                                            ]
                                        ]
                                    },
                                    'continuousKlines': {
                                        'cost': 1,
                                        'byLimit': [
                                            [
                                                99,
                                                1
                                            ],
                                            [
                                                499,
                                                2
                                            ],
                                            [
                                                1000,
                                                5
                                            ],
                                            [
                                                10000,
                                                10
                                            ]
                                        ]
                                    },
                                    'indexPriceKlines': {
                                        'cost': 1,
                                        'byLimit': [
                                            [
                                                99,
                                                1
                                            ],
                                            [
                                                499,
                                                2
                                            ],
                                            [
                                                1000,
                                                5
                                            ],
                                            [
                                                10000,
                                                10
                                            ]
                                        ]
                                    },
                                    'markPriceKlines': {
                                        'cost': 1,
                                        'byLimit': [
                                            [
                                                99,
                                                1
                                            ],
                                            [
                                                499,
                                                2
                                            ],
                                            [
                                                1000,
                                                5
                                            ],
                                            [
                                                10000,
                                                10
                                            ]
                                        ]
                                    },
                                    'ticker/24hr': {
                                        'cost': 1,
                                        'noSymbol': 40
                                    },
                                    'ticker/price': {
                                        'cost': 1,
                                        'noSymbol': 2
                                    },
                                    'ticker/bookTicker': {
                                        'cost': 1,
                                        'noSymbol': 2
                                    },
                                    'openInterest': 1
                                }
                            },
                            'dapiData': {
                                'get': {
                                    'openInterestHist': 1,
                                    'topLongShortAccountRatio': 1,
                                    'topLongShortPositionRatio': 1,
                                    'globalLongShortAccountRatio': 1,
                                    'takerBuySellVol': 1,
                                    'basis': 1
                                }
                            },
                            'dapiPrivate': {
                                'get': {
                                    'positionSide/dual': 30,
                                    'order': 1,
                                    'openOrder': 1,
                                    'openOrders': {
                                        'cost': 1,
                                        'noSymbol': 5
                                    },
                                    'allOrders': {
                                        'cost': 20,
                                        'noSymbol': 40
                                    },
                                    'balance': 1,
                                    'account': 5,
                                    'positionMargin/history': 1,
                                    'positionRisk': 1,
                                    'userTrades': {
                                        'cost': 20,
                                        'noSymbol': 40
                                    },
                                    'income': 20,
                                    'leverageBracket': 1,
                                    'forceOrders': {
                                        'cost': 20,
                                        'noSymbol': 50
                                    },
                                    'adlQuantile': 5
                                },
                                'post': {
                                    'positionSide/dual': 1,
                                    'order': 4,
                                    'batchOrders': 5,
                                    'countdownCancelAll': 10,
                                    'leverage': 1,
                                    'marginType': 1,
                                    'positionMargin': 1,
                                    'listenKey': 1
                                },
                                'put': {
                                    'listenKey': 1
                                },
                                'delete': {
                                    'order': 1,
                                    'allOpenOrders': 1,
                                    'batchOrders': 5,
                                    'listenKey': 1
                                }
                            },
                            'dapiPrivateV2': {
                                'get': {
                                    'leverageBracket': 1
                                }
                            },
                            'fapiPublic': {
                                'get': {
                                    'ping': 1,
                                    'time': 1,
                                    'exchangeInfo': 1,
                                    'depth': {
                                        'cost': 2,
                                        'byLimit': [
                                            [
                                                50,
                                                2
                                            ],
                                            [
                                                100,
                                                5
                                            ],
                                            [
                                                500,
                                                10
                                            ],
                                            [
                                                1000,
                                                20
                                            ]
                                        ]
                                    },
                                    'trades': 1,
                                    'historicalTrades': 20,
                                    'aggTrades': 20,
                                    'klines': {
                                        'cost': 1,
                                        'byLimit': [
                                            [
                                                99,
                                                1
                                            ],
                                            [
                                                499,
                                                2
                                            ],
                                            [
                                                1000,
                                                5
                                            ],
                                            [
                                                10000,
                                                10
                                            ]
                                        ]
                                    },
                                    'continuousKlines': {
                                        'cost': 1,
                                        'byLimit': [
                                            [
                                                99,
                                                1
                                            ],
                                            [
                                                499,
                                                2
                                            ],
                                            [
                                                1000,
                                                5
                                            ],
                                            [
                                                10000,
                                                10
                                            ]
                                        ]
                                    },
                                    'markPriceKlines': {
                                        'cost': 1,
                                        'byLimit': [
                                            [
                                                99,
                                                1
                                            ],
                                            [
                                                499,
                                                2
                                            ],
                                            [
                                                1000,
                                                5
                                            ],
                                            [
                                                10000,
                                                10
                                            ]
                                        ]
                                    },
                                    'indexPriceKlines': {
                                        'cost': 1,
                                        'byLimit': [
                                            [
                                                99,
                                                1
                                            ],
                                            [
                                                499,
                                                2
                                            ],
                                            [
                                                1000,
                                                5
                                            ],
                                            [
                                                10000,
                                                10
                                            ]
                                        ]
                                    },
                                    'fundingRate': 1,
                                    'premiumIndex': 1,
                                    'ticker/24hr': {
                                        'cost': 1,
                                        'noSymbol': 40
                                    },
                                    'ticker/price': {
                                        'cost': 1,
                                        'noSymbol': 2
                                    },
                                    'ticker/bookTicker': {
                                        'cost': 1,
                                        'noSymbol': 2
                                    },
                                    'openInterest': 1,
                                    'indexInfo': 1,
                                    'apiTradingStatus': {
                                        'cost': 1,
                                        'noSymbol': 10
                                    },
                                    'lvtKlines': 1
                                }
                            },
                            'fapiData': {
                                'get': {
                                    'openInterestHist': 1,
                                    'topLongShortAccountRatio': 1,
                                    'topLongShortPositionRatio': 1,
                                    'globalLongShortAccountRatio': 1,
                                    'takerlongshortRatio': 1
                                }
                            },
                            'fapiPrivate': {
                                'get': {
                                    'forceOrders': {
                                        'cost': 20,
                                        'noSymbol': 50
                                    },
                                    'allOrders': 5,
                                    'openOrder': 1,
                                    'openOrders': 1,
                                    'order': 1,
                                    'account': 5,
                                    'balance': 5,
                                    'leverageBracket': 1,
                                    'positionMargin/history': 1,
                                    'positionRisk': 5,
                                    'positionSide/dual': 30,
                                    'userTrades': 5,
                                    'income': 30,
                                    'commissionRate': 20,
                                    'apiTradingStatus': 1,
                                    'multiAssetsMargin': 30,
                                    // broker endpoints
                                    'apiReferral/ifNewUser': 1,
                                    'apiReferral/customization': 1,
                                    'apiReferral/userCustomization': 1,
                                    'apiReferral/traderNum': 1,
                                    'apiReferral/overview': 1,
                                    'apiReferral/tradeVol': 1,
                                    'apiReferral/rebateVol': 1,
                                    'apiReferral/traderSummary': 1,
                                    'adlQuantile': 5
                                },
                                'post': {
                                    'batchOrders': 5,
                                    'positionSide/dual': 1,
                                    'positionMargin': 1,
                                    'marginType': 1,
                                    'order': 4,
                                    'leverage': 1,
                                    'listenKey': 1,
                                    'countdownCancelAll': 10,
                                    'multiAssetsMargin': 1,
                                    // broker endpoints
                                    'apiReferral/customization': 1,
                                    'apiReferral/userCustomization': 1
                                },
                                'put': {
                                    'listenKey': 1
                                },
                                'delete': {
                                    'batchOrders': 1,
                                    'order': 1,
                                    'allOpenOrders': 1,
                                    'listenKey': 1
                                }
                            },
                            'fapiPrivateV2': {
                                'get': {
                                    'account': 1,
                                    'balance': 1,
                                    'positionRisk': 1
                                }
                            },
                            'vapiPublic': {
                                'get': [
                                    'ping',
                                    'time',
                                    'optionInfo',
                                    'exchangeInfo',
                                    'index',
                                    'ticker',
                                    'mark',
                                    'depth',
                                    'klines',
                                    'trades',
                                    'historicalTrades'
                                ]
                            },
                            'vapiPrivate': {
                                'get': [
                                    'account',
                                    'position',
                                    'order',
                                    'openOrders',
                                    'historyOrders',
                                    'userTrades'
                                ],
                                'post': [
                                    'transfer',
                                    'bill',
                                    'order',
                                    'batchOrders',
                                    'userDataStream',
                                    'openAccount'
                                ],
                                'put': [
                                    'userDataStream'
                                ],
                                'delete': [
                                    'order',
                                    'batchOrders',
                                    'allOpenOrders',
                                    'userDataStream'
                                ]
                            },
                            'public': {
                                'get': {
                                    'ping': 1,
                                    'time': 1,
                                    'depth': {
                                        'cost': 1,
                                        'byLimit': [
                                            [
                                                100,
                                                1
                                            ],
                                            [
                                                500,
                                                5
                                            ],
                                            [
                                                1000,
                                                10
                                            ],
                                            [
                                                5000,
                                                50
                                            ]
                                        ]
                                    },
                                    'trades': 1,
                                    'aggTrades': 1,
                                    'historicalTrades': 5,
                                    'klines': 1,
                                    'ticker/24hr': {
                                        'cost': 1,
                                        'noSymbol': 40
                                    },
                                    'ticker/price': {
                                        'cost': 1,
                                        'noSymbol': 2
                                    },
                                    'ticker/bookTicker': {
                                        'cost': 1,
                                        'noSymbol': 2
                                    },
                                    'exchangeInfo': 10
                                },
                                'put': {
                                    'userDataStream': 1
                                },
                                'post': {
                                    'userDataStream': 1
                                },
                                'delete': {
                                    'userDataStream': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'allOrderList': 10,
                                    'openOrderList': 3,
                                    'orderList': 2,
                                    'order': 2,
                                    'openOrders': {
                                        'cost': 3,
                                        'noSymbol': 40
                                    },
                                    'allOrders': 10,
                                    'account': 10,
                                    'myTrades': 10,
                                    'rateLimit/order': 20
                                },
                                'post': {
                                    'order/oco': 1,
                                    'order': 1,
                                    'order/test': 1
                                },
                                'delete': {
                                    'openOrders': 1,
                                    'orderList': 1,
                                    'order': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': false,
                                'percentage': true,
                                'taker': this.parseNumber('0.001'),
                                'maker': this.parseNumber('0.001')
                            },
                            'future': {
                                'trading': {
                                    'feeSide': 'quote',
                                    'tierBased': true,
                                    'percentage': true,
                                    'taker': this.parseNumber('0.000400'),
                                    'maker': this.parseNumber('0.000200'),
                                    'tiers': {
                                        'taker': [
                                            [
                                                this.parseNumber('0'),
                                                this.parseNumber('0.000400')
                                            ],
                                            [
                                                this.parseNumber('250'),
                                                this.parseNumber('0.000400')
                                            ],
                                            [
                                                this.parseNumber('2500'),
                                                this.parseNumber('0.000350')
                                            ],
                                            [
                                                this.parseNumber('7500'),
                                                this.parseNumber('0.000320')
                                            ],
                                            [
                                                this.parseNumber('22500'),
                                                this.parseNumber('0.000300')
                                            ],
                                            [
                                                this.parseNumber('50000'),
                                                this.parseNumber('0.000270')
                                            ],
                                            [
                                                this.parseNumber('100000'),
                                                this.parseNumber('0.000250')
                                            ],
                                            [
                                                this.parseNumber('200000'),
                                                this.parseNumber('0.000220')
                                            ],
                                            [
                                                this.parseNumber('400000'),
                                                this.parseNumber('0.000200')
                                            ],
                                            [
                                                this.parseNumber('750000'),
                                                this.parseNumber('0.000170')
                                            ]
                                        ],
                                        'maker': [
                                            [
                                                this.parseNumber('0'),
                                                this.parseNumber('0.000200')
                                            ],
                                            [
                                                this.parseNumber('250'),
                                                this.parseNumber('0.000160')
                                            ],
                                            [
                                                this.parseNumber('2500'),
                                                this.parseNumber('0.000140')
                                            ],
                                            [
                                                this.parseNumber('7500'),
                                                this.parseNumber('0.000120')
                                            ],
                                            [
                                                this.parseNumber('22500'),
                                                this.parseNumber('0.000100')
                                            ],
                                            [
                                                this.parseNumber('50000'),
                                                this.parseNumber('0.000080')
                                            ],
                                            [
                                                this.parseNumber('100000'),
                                                this.parseNumber('0.000060')
                                            ],
                                            [
                                                this.parseNumber('200000'),
                                                this.parseNumber('0.000040')
                                            ],
                                            [
                                                this.parseNumber('400000'),
                                                this.parseNumber('0.000020')
                                            ],
                                            [
                                                this.parseNumber('750000'),
                                                this.parseNumber('0')
                                            ]
                                        ]
                                    }
                                }
                            },
                            'delivery': {
                                'trading': {
                                    'feeSide': 'base',
                                    'tierBased': true,
                                    'percentage': true,
                                    'taker': this.parseNumber('0.000500'),
                                    'maker': this.parseNumber('0.000100'),
                                    'tiers': {
                                        'taker': [
                                            [
                                                this.parseNumber('0'),
                                                this.parseNumber('0.000500')
                                            ],
                                            [
                                                this.parseNumber('250'),
                                                this.parseNumber('0.000450')
                                            ],
                                            [
                                                this.parseNumber('2500'),
                                                this.parseNumber('0.000400')
                                            ],
                                            [
                                                this.parseNumber('7500'),
                                                this.parseNumber('0.000300')
                                            ],
                                            [
                                                this.parseNumber('22500'),
                                                this.parseNumber('0.000250')
                                            ],
                                            [
                                                this.parseNumber('50000'),
                                                this.parseNumber('0.000240')
                                            ],
                                            [
                                                this.parseNumber('100000'),
                                                this.parseNumber('0.000240')
                                            ],
                                            [
                                                this.parseNumber('200000'),
                                                this.parseNumber('0.000240')
                                            ],
                                            [
                                                this.parseNumber('400000'),
                                                this.parseNumber('0.000240')
                                            ],
                                            [
                                                this.parseNumber('750000'),
                                                this.parseNumber('0.000240')
                                            ]
                                        ],
                                        'maker': [
                                            [
                                                this.parseNumber('0'),
                                                this.parseNumber('0.000100')
                                            ],
                                            [
                                                this.parseNumber('250'),
                                                this.parseNumber('0.000080')
                                            ],
                                            [
                                                this.parseNumber('2500'),
                                                this.parseNumber('0.000050')
                                            ],
                                            [
                                                this.parseNumber('7500'),
                                                this.parseNumber('0.0000030')
                                            ],
                                            [
                                                this.parseNumber('22500'),
                                                this.parseNumber('0')
                                            ],
                                            [
                                                this.parseNumber('50000'),
                                                this.parseNumber('-0.000050')
                                            ],
                                            [
                                                this.parseNumber('100000'),
                                                this.parseNumber('-0.000060')
                                            ],
                                            [
                                                this.parseNumber('200000'),
                                                this.parseNumber('-0.000070')
                                            ],
                                            [
                                                this.parseNumber('400000'),
                                                this.parseNumber('-0.000080')
                                            ],
                                            [
                                                this.parseNumber('750000'),
                                                this.parseNumber('-0.000090')
                                            ]
                                        ]
                                    }
                                }
                            },
                            'option': {}
                        },
                        'commonCurrencies': {
                            'BCC': 'BCC',
                            'YOYO': 'YOYOW'
                        },
                        // exchange-specific options
                        'options': {
                            'fetchCurrencies': true,
                            // 'fetchTradesMethod': 'publicGetAggTrades', // publicGetTrades, publicGetHistoricalTrades
                            'defaultTimeInForce': 'GTC',
                            'defaultType': 'spot',
                            'hasAlreadyAuthenticatedSuccessfully': false,
                            'warnOnFetchOpenOrdersWithoutSymbol': true,
                            // not an error
                            // https://github.com/ccxt/ccxt/issues/11268
                            // https://github.com/ccxt/ccxt/pull/11624
                            // POST https://fapi.binance.com/fapi/v1/marginType 400 Bad Request
                            // binanceusdm
                            'throwMarginModeAlreadySet': false,
                            'fetchPositions': 'positionRisk',
                            'recvWindow': 5000,
                            'timeDifference': 0,
                            'adjustForTimeDifference': false,
                            'newOrderRespType': {
                                'market': 'FULL',
                                'limit': 'FULL'
                            },
                            'quoteOrderQty': true,
                            'broker': {
                                'spot': 'x-R4BD3S82',
                                'margin': 'x-R4BD3S82',
                                'future': 'x-xcKtGhcu',
                                'delivery': 'x-xcKtGhcu'
                            },
                            'accountsByType': {
                                'main': 'MAIN',
                                'spot': 'MAIN',
                                'funding': 'FUNDING',
                                'margin': 'MARGIN',
                                'future': 'UMFUTURE',
                                'delivery': 'CMFUTURE',
                                'mining': 'MINING'
                            },
                            'accountsById': {
                                'MAIN': 'spot',
                                'FUNDING': 'funding',
                                'MARGIN': 'margin',
                                'UMFUTURE': 'future',
                                'CMFUTURE': 'delivery',
                                'MINING': 'mining'
                            },
                            'networks': {
                                'ERC20': 'ETH',
                                'TRC20': 'TRX',
                                'BEP2': 'BNB',
                                'BEP20': 'BSC',
                                'OMNI': 'OMNI',
                                'EOS': 'EOS',
                                'SPL': 'SOL'
                            },
                            'reverseNetworks': {
                                'tronscan.org': 'TRC20',
                                'etherscan.io': 'ERC20',
                                'bscscan.com': 'BSC',
                                'explorer.binance.org': 'BEP2',
                                'bithomp.com': 'XRP',
                                'bloks.io': 'EOS',
                                'stellar.expert': 'XLM',
                                'blockchair.com/bitcoin': 'BTC',
                                'blockchair.com/bitcoin-cash': 'BCH',
                                'blockchair.com/ecash': 'XEC',
                                'explorer.litecoin.net': 'LTC',
                                'explorer.avax.network': 'AVAX',
                                'solscan.io': 'SOL',
                                'polkadot.subscan.io': 'DOT',
                                'dashboard.internetcomputer.org': 'ICP',
                                'explorer.chiliz.com': 'CHZ',
                                'cardanoscan.io': 'ADA',
                                'mainnet.theoan.com': 'AION',
                                'algoexplorer.io': 'ALGO',
                                'explorer.ambrosus.com': 'AMB',
                                'viewblock.io/zilliqa': 'ZIL',
                                'viewblock.io/arweave': 'AR',
                                'explorer.ark.io': 'ARK',
                                'atomscan.com': 'ATOM',
                                'www.mintscan.io': 'CTK',
                                'explorer.bitcoindiamond.org': 'BCD',
                                'btgexplorer.com': 'BTG',
                                'bts.ai': 'BTS',
                                'explorer.celo.org': 'CELO',
                                'explorer.nervos.org': 'CKB',
                                'cerebro.cortexlabs.ai': 'CTXC',
                                'chainz.cryptoid.info': 'VIA',
                                'explorer.dcrdata.org': 'DCR',
                                'digiexplorer.info': 'DGB',
                                'dock.subscan.io': 'DOCK',
                                'dogechain.info': 'DOGE',
                                'explorer.elrond.com': 'EGLD',
                                'blockscout.com': 'ETC',
                                'explore-fetchhub.fetch.ai': 'FET',
                                'filfox.info': 'FIL',
                                'fio.bloks.io': 'FIO',
                                'explorer.firo.org': 'FIRO',
                                'neoscan.io': 'NEO',
                                'ftmscan.com': 'FTM',
                                'explorer.gochain.io': 'GO',
                                'block.gxb.io': 'GXS',
                                'hash-hash.info': 'HBAR',
                                'www.hiveblockexplorer.com': 'HIVE',
                                'explorer.helium.com': 'HNT',
                                'tracker.icon.foundation': 'ICX',
                                'www.iostabc.com': 'IOST',
                                'explorer.iota.org': 'IOTA',
                                'iotexscan.io': 'IOTX',
                                'irishub.iobscan.io': 'IRIS',
                                'kava.mintscan.io': 'KAVA',
                                'scope.klaytn.com': 'KLAY',
                                'kmdexplorer.io': 'KMD',
                                'kusama.subscan.io': 'KSM',
                                'explorer.lto.network': 'LTO',
                                'polygonscan.com': 'POLYGON',
                                'explorer.ont.io': 'ONT',
                                'minaexplorer.com': 'MINA',
                                'nanolooker.com': 'NANO',
                                'explorer.nebulas.io': 'NAS',
                                'explorer.nbs.plus': 'NBS',
                                'explorer.nebl.io': 'NEBL',
                                'nulscan.io': 'NULS',
                                'nxscan.com': 'NXS',
                                'explorer.harmony.one': 'ONE',
                                'explorer.poa.network': 'POA',
                                'qtum.info': 'QTUM',
                                'explorer.rsk.co': 'RSK',
                                'www.oasisscan.com': 'ROSE',
                                'ravencoin.network': 'RVN',
                                'sc.tokenview.com': 'SC',
                                'secretnodes.com': 'SCRT',
                                'explorer.skycoin.com': 'SKY',
                                'steemscan.com': 'STEEM',
                                'explorer.stacks.co': 'STX',
                                'www.thetascan.io': 'THETA',
                                'scan.tomochain.com': 'TOMO',
                                'explore.vechain.org': 'VET',
                                'explorer.vite.net': 'VITE',
                                'www.wanscan.org': 'WAN',
                                'wavesexplorer.com': 'WAVES',
                                'wax.eosx.io': 'WAXP',
                                'waltonchain.pro': 'WTC',
                                'chain.nem.ninja': 'XEM',
                                'verge-blockchain.info': 'XVG',
                                'explorer.yoyow.org': 'YOYOW',
                                'explorer.zcha.in': 'ZEC',
                                'explorer.zensystem.io': 'ZEN'
                            },
                            'impliedNetworks': {
                                'ETH': {
                                    'ERC20': 'ETH'
                                },
                                'TRX': {
                                    'TRC20': 'TRX'
                                }
                            },
                            'legalMoney': {
                                'MXN': true,
                                'UGX': true,
                                'SEK': true,
                                'CHF': true,
                                'VND': true,
                                'AED': true,
                                'DKK': true,
                                'KZT': true,
                                'HUF': true,
                                'PEN': true,
                                'PHP': true,
                                'USD': true,
                                'TRY': true,
                                'EUR': true,
                                'NGN': true,
                                'PLN': true,
                                'BRL': true,
                                'ZAR': true,
                                'KES': true,
                                'ARS': true,
                                'RUB': true,
                                'AUD': true,
                                'NOK': true,
                                'CZK': true,
                                'GBP': true,
                                'UAH': true,
                                'GHS': true,
                                'HKD': true,
                                'CAD': true,
                                'INR': true,
                                'JPY': true,
                                'NZD': true
                            }
                        },
                        // https://binance-docs.github.io/apidocs/spot/en/#error-codes-2
                        'exceptions': {
                            'exact': {
                                'System is under maintenance.': OnMaintenance,
                                'System abnormality': ExchangeError1,
                                'You are not authorized to execute this request.': PermissionDenied,
                                'API key does not exist': AuthenticationError,
                                'Order would trigger immediately.': OrderImmediatelyFillable,
                                'Stop price would trigger immediately.': OrderImmediatelyFillable,
                                'Order would immediately match and take.': OrderImmediatelyFillable,
                                'Account has insufficient balance for requested action.': InsufficientFunds,
                                'Rest API trading is not enabled.': ExchangeNotAvailable,
                                "You don't have permission.": PermissionDenied,
                                'Market is closed.': ExchangeNotAvailable,
                                'Too many requests. Please try again later.': DDoSProtection,
                                'This action disabled is on this account.': AccountSuspended,
                                '-1000': ExchangeNotAvailable,
                                '-1001': ExchangeNotAvailable,
                                '-1002': AuthenticationError,
                                '-1003': RateLimitExceeded,
                                '-1004': DDoSProtection,
                                '-1005': PermissionDenied,
                                '-1006': BadResponse,
                                '-1007': RequestTimeout,
                                '-1010': BadResponse,
                                '-1011': PermissionDenied,
                                '-1013': InvalidOrder,
                                '-1014': InvalidOrder,
                                '-1015': RateLimitExceeded,
                                '-1016': ExchangeNotAvailable,
                                '-1020': BadRequest,
                                '-1021': InvalidNonce,
                                '-1022': AuthenticationError,
                                '-1023': BadRequest,
                                '-1099': AuthenticationError,
                                '-1100': BadRequest,
                                '-1101': BadRequest,
                                '-1102': BadRequest,
                                '-1103': BadRequest,
                                '-1104': BadRequest,
                                '-1105': BadRequest,
                                '-1106': BadRequest,
                                '-1108': BadRequest,
                                '-1109': AuthenticationError,
                                '-1110': BadRequest,
                                '-1111': BadRequest,
                                '-1112': InvalidOrder,
                                '-1113': BadRequest,
                                '-1114': BadRequest,
                                '-1115': BadRequest,
                                '-1116': BadRequest,
                                '-1117': BadRequest,
                                '-1118': BadRequest,
                                '-1119': BadRequest,
                                '-1120': BadRequest,
                                '-1121': BadSymbol,
                                '-1125': AuthenticationError,
                                '-1127': BadRequest,
                                '-1128': BadRequest,
                                '-1130': BadRequest,
                                '-1131': BadRequest,
                                '-1136': BadRequest,
                                '-2008': AuthenticationError,
                                '-2010': ExchangeError1,
                                '-2011': OrderNotFound,
                                '-2013': OrderNotFound,
                                '-2014': AuthenticationError,
                                '-2015': AuthenticationError,
                                '-2016': BadRequest,
                                '-2018': InsufficientFunds,
                                '-2019': InsufficientFunds,
                                '-2020': OrderNotFillable,
                                '-2021': OrderImmediatelyFillable,
                                '-2022': InvalidOrder,
                                '-2023': InsufficientFunds,
                                '-2024': InsufficientFunds,
                                '-2025': InvalidOrder,
                                '-2026': InvalidOrder,
                                '-2027': InvalidOrder,
                                '-2028': InsufficientFunds,
                                '-3000': ExchangeError1,
                                '-3001': AuthenticationError,
                                '-3002': BadSymbol,
                                '-3003': BadRequest,
                                '-3004': ExchangeError1,
                                '-3005': InsufficientFunds,
                                '-3006': InsufficientFunds,
                                '-3007': ExchangeError1,
                                '-3008': InsufficientFunds,
                                '-3009': BadRequest,
                                '-3010': ExchangeError1,
                                '-3011': BadRequest,
                                '-3012': ExchangeError1,
                                '-3013': BadRequest,
                                '-3014': AccountSuspended,
                                '-3015': ExchangeError1,
                                '-3016': BadRequest,
                                '-3017': ExchangeError1,
                                '-3018': AccountSuspended,
                                '-3019': AccountSuspended,
                                '-3020': InsufficientFunds,
                                '-3021': BadRequest,
                                '-3022': AccountSuspended,
                                '-3023': BadRequest,
                                '-3024': ExchangeError1,
                                '-3025': BadRequest,
                                '-3026': BadRequest,
                                '-3027': BadSymbol,
                                '-3028': BadSymbol,
                                '-3029': ExchangeError1,
                                '-3036': AccountSuspended,
                                '-3037': ExchangeError1,
                                '-3038': BadRequest,
                                '-3041': InsufficientFunds,
                                '-3042': BadRequest,
                                '-3043': BadRequest,
                                '-3044': DDoSProtection,
                                '-3045': ExchangeError1,
                                '-3999': ExchangeError1,
                                '-4001': BadRequest,
                                '-4002': BadRequest,
                                '-4003': BadRequest,
                                '-4004': AuthenticationError,
                                '-4005': RateLimitExceeded,
                                '-4006': BadRequest,
                                '-4007': BadRequest,
                                '-4008': BadRequest,
                                '-4010': BadRequest,
                                '-4011': BadRequest,
                                '-4012': BadRequest,
                                '-4013': AuthenticationError,
                                '-4014': PermissionDenied,
                                '-4015': ExchangeError1,
                                '-4016': PermissionDenied,
                                '-4017': PermissionDenied,
                                '-4018': BadSymbol,
                                '-4019': BadSymbol,
                                '-4021': BadRequest,
                                '-4022': BadRequest,
                                '-4023': ExchangeError1,
                                '-4024': InsufficientFunds,
                                '-4025': InsufficientFunds,
                                '-4026': InsufficientFunds,
                                '-4027': ExchangeError1,
                                '-4028': BadRequest,
                                '-4029': BadRequest,
                                '-4030': ExchangeError1,
                                '-4031': ExchangeError1,
                                '-4032': ExchangeError1,
                                '-4033': BadRequest,
                                '-4034': ExchangeError1,
                                '-4035': PermissionDenied,
                                '-4036': BadRequest,
                                '-4037': ExchangeError1,
                                '-4038': ExchangeError1,
                                '-4039': BadRequest,
                                '-4040': BadRequest,
                                '-4041': ExchangeError1,
                                '-4042': ExchangeError1,
                                '-4043': BadRequest,
                                '-4044': BadRequest,
                                '-4045': ExchangeError1,
                                '-4046': AuthenticationError,
                                '-4047': BadRequest,
                                '-5001': BadRequest,
                                '-5002': InsufficientFunds,
                                '-5003': InsufficientFunds,
                                '-5004': BadRequest,
                                '-5005': InsufficientFunds,
                                '-5006': BadRequest,
                                '-5007': BadRequest,
                                '-5008': InsufficientFunds,
                                '-5009': BadRequest,
                                '-5010': ExchangeError1,
                                '-5011': BadRequest,
                                '-5012': ExchangeError1,
                                '-5013': InsufficientFunds,
                                '-5021': BadRequest,
                                '-6001': BadRequest,
                                '-6003': BadRequest,
                                '-6004': ExchangeError1,
                                '-6005': InvalidOrder,
                                '-6006': BadRequest,
                                '-6007': BadRequest,
                                '-6008': BadRequest,
                                '-6009': RateLimitExceeded,
                                '-6011': BadRequest,
                                '-6012': InsufficientFunds,
                                '-6013': ExchangeError1,
                                '-6014': BadRequest,
                                '-6015': BadRequest,
                                '-6016': BadRequest,
                                '-6017': BadRequest,
                                '-6018': BadRequest,
                                '-6019': AuthenticationError,
                                '-6020': BadRequest,
                                '-7001': BadRequest,
                                '-7002': BadRequest,
                                '-9000': InsufficientFunds,
                                '-10017': BadRequest,
                                '-11008': InsufficientFunds,
                                '-12014': RateLimitExceeded,
                                '-13000': BadRequest,
                                '-13001': BadRequest,
                                '-13002': BadRequest,
                                '-13003': BadRequest,
                                '-13004': BadRequest,
                                '-13005': BadRequest,
                                '-13006': InvalidOrder,
                                '-13007': AuthenticationError,
                                '100001003': BadRequest
                            },
                            'broad': {
                                'has no operation privilege': PermissionDenied,
                                'MAX_POSITION': InvalidOrder
                            }
                        }
                    });
                }
                costToPrecision(symbol, cost) {
                    return this.decimalToPrecision(cost, TRUNCATE, this.markets[symbol]['precision']['quote'], this.precisionMode, this.paddingMode);
                }
                currencyToPrecision(code, fee) {
                    // info is available in currencies only if the user has configured his api keys
                    if (this.safeValue(this.currencies[code], 'precision') !== undefined) return this.decimalToPrecision(fee, TRUNCATE, this.currencies[code]['precision'], this.precisionMode, this.paddingMode);
                    else return this.numberToString(fee);
                }
                nonce() {
                    return this.milliseconds() - this.options['timeDifference'];
                }
                async fetchTime(params = {}) {
                    const defaultType = this.safeString2(this.options, 'fetchTime', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    let method = 'publicGetTime';
                    if (type === 'future') method = 'fapiPublicGetTime';
                    else if (type === 'delivery') method = 'dapiPublicGetTime';
                    const response = await this[method](query);
                    return this.safeInteger(response, 'serverTime');
                }
                async fetchCurrencies(params = {}) {
                    const fetchCurrenciesEnabled = this.safeValue(this.options, 'fetchCurrencies');
                    if (!fetchCurrenciesEnabled) return undefined;
                    // this endpoint requires authentication
                    // while fetchCurrencies is a public API method by design
                    // therefore we check the keys here
                    // and fallback to generating the currencies from the markets
                    if (!this.checkRequiredCredentials(false)) return undefined;
                    // sandbox/testnet does not support sapi endpoints
                    const apiBackup = this.safeString(this.urls, 'apiBackup');
                    if (apiBackup !== undefined) return undefined;
                    const response = await this.sapiGetCapitalConfigGetall(params);
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        //
                        //     {
                        //         coin: 'LINK',
                        //         depositAllEnable: true,
                        //         withdrawAllEnable: true,
                        //         name: 'ChainLink',
                        //         free: '0.06168',
                        //         locked: '0',
                        //         freeze: '0',
                        //         withdrawing: '0',
                        //         ipoing: '0',
                        //         ipoable: '0',
                        //         storage: '0',
                        //         isLegalMoney: false,
                        //         trading: true,
                        //         networkList: [
                        //             {
                        //                 network: 'BNB',
                        //                 coin: 'LINK',
                        //                 withdrawIntegerMultiple: '0',
                        //                 isDefault: false,
                        //                 depositEnable: true,
                        //                 withdrawEnable: true,
                        //                 depositDesc: '',
                        //                 withdrawDesc: '',
                        //                 specialTips: 'Both a MEMO and an Address are required to successfully deposit your LINK BEP2 tokens to Binance.',
                        //                 name: 'BEP2',
                        //                 resetAddressStatus: false,
                        //                 addressRegex: '^(bnb1)[0-9a-z]{38}$',
                        //                 memoRegex: '^[0-9A-Za-z\\-_]{1,120}$',
                        //                 withdrawFee: '0.002',
                        //                 withdrawMin: '0.01',
                        //                 withdrawMax: '9999999',
                        //                 minConfirm: 1,
                        //                 unLockConfirm: 0
                        //             },
                        //             {
                        //                 network: 'BSC',
                        //                 coin: 'LINK',
                        //                 withdrawIntegerMultiple: '0.00000001',
                        //                 isDefault: false,
                        //                 depositEnable: true,
                        //                 withdrawEnable: true,
                        //                 depositDesc: '',
                        //                 withdrawDesc: '',
                        //                 specialTips: '',
                        //                 name: 'BEP20 (BSC)',
                        //                 resetAddressStatus: false,
                        //                 addressRegex: '^(0x)[0-9A-Fa-f]{40}$',
                        //                 memoRegex: '',
                        //                 withdrawFee: '0.005',
                        //                 withdrawMin: '0.01',
                        //                 withdrawMax: '9999999',
                        //                 minConfirm: 15,
                        //                 unLockConfirm: 0
                        //             },
                        //             {
                        //                 network: 'ETH',
                        //                 coin: 'LINK',
                        //                 withdrawIntegerMultiple: '0.00000001',
                        //                 isDefault: true,
                        //                 depositEnable: true,
                        //                 withdrawEnable: true,
                        //                 depositDesc: '',
                        //                 withdrawDesc: '',
                        //                 name: 'ERC20',
                        //                 resetAddressStatus: false,
                        //                 addressRegex: '^(0x)[0-9A-Fa-f]{40}$',
                        //                 memoRegex: '',
                        //                 withdrawFee: '0.34',
                        //                 withdrawMin: '0.68',
                        //                 withdrawMax: '0',
                        //                 minConfirm: 12,
                        //                 unLockConfirm: 0
                        //             }
                        //         ]
                        //     }
                        //
                        const entry = response[i];
                        const id = this.safeString(entry, 'coin');
                        const name = this.safeString(entry, 'name');
                        const code = this.safeCurrencyCode(id);
                        const precision = undefined;
                        let isWithdrawEnabled = true;
                        let isDepositEnabled = true;
                        const networkList = this.safeValue(entry, 'networkList', []);
                        const fees = {};
                        let fee = undefined;
                        for(let j = 0; j < networkList.length; j++){
                            const networkItem = networkList[j];
                            const network = this.safeString(networkItem, 'network');
                            // const name = this.safeString (networkItem, 'name');
                            const withdrawFee = this.safeNumber(networkItem, 'withdrawFee');
                            const depositEnable = this.safeValue(networkItem, 'depositEnable');
                            const withdrawEnable = this.safeValue(networkItem, 'withdrawEnable');
                            isDepositEnabled = isDepositEnabled || depositEnable;
                            isWithdrawEnabled = isWithdrawEnabled || withdrawEnable;
                            fees[network] = withdrawFee;
                            const isDefault = this.safeValue(networkItem, 'isDefault');
                            if (isDefault || fee === undefined) fee = withdrawFee;
                        }
                        const trading = this.safeValue(entry, 'trading');
                        const active = isWithdrawEnabled && isDepositEnabled && trading;
                        result[code] = {
                            'id': id,
                            'name': name,
                            'code': code,
                            'precision': precision,
                            'info': entry,
                            'active': active,
                            'deposit': isDepositEnabled,
                            'withdraw': isWithdrawEnabled,
                            'networks': networkList,
                            'fee': fee,
                            'fees': fees,
                            'limits': this.limits
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const defaultType = this.safeString2(this.options, 'fetchMarkets', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    if (type !== 'spot' && type !== 'future' && type !== 'margin' && type !== 'delivery') throw new ExchangeError1(this.id + " does not support '" + type + "' type, set exchange.options['defaultType'] to 'spot', 'margin', 'delivery' or 'future'"); // eslint-disable-line quotes
                    let method = 'publicGetExchangeInfo';
                    if (type === 'future') method = 'fapiPublicGetExchangeInfo';
                    else if (type === 'delivery') method = 'dapiPublicGetExchangeInfo';
                    const response = await this[method](query);
                    //
                    // spot / margin
                    //
                    //     {
                    //         "timezone":"UTC",
                    //         "serverTime":1575416692969,
                    //         "rateLimits":[
                    //             {"rateLimitType":"REQUEST_WEIGHT","interval":"MINUTE","intervalNum":1,"limit":1200},
                    //             {"rateLimitType":"ORDERS","interval":"SECOND","intervalNum":10,"limit":100},
                    //             {"rateLimitType":"ORDERS","interval":"DAY","intervalNum":1,"limit":200000}
                    //         ],
                    //         "exchangeFilters":[],
                    //         "symbols":[
                    //             {
                    //                 "symbol":"ETHBTC",
                    //                 "status":"TRADING",
                    //                 "baseAsset":"ETH",
                    //                 "baseAssetPrecision":8,
                    //                 "quoteAsset":"BTC",
                    //                 "quotePrecision":8,
                    //                 "baseCommissionPrecision":8,
                    //                 "quoteCommissionPrecision":8,
                    //                 "orderTypes":["LIMIT","LIMIT_MAKER","MARKET","STOP_LOSS_LIMIT","TAKE_PROFIT_LIMIT"],
                    //                 "icebergAllowed":true,
                    //                 "ocoAllowed":true,
                    //                 "quoteOrderQtyMarketAllowed":true,
                    //                 "allowTrailingStop":false,
                    //                 "isSpotTradingAllowed":true,
                    //                 "isMarginTradingAllowed":true,
                    //                 "filters":[
                    //                     {"filterType":"PRICE_FILTER","minPrice":"0.00000100","maxPrice":"100000.00000000","tickSize":"0.00000100"},
                    //                     {"filterType":"PERCENT_PRICE","multiplierUp":"5","multiplierDown":"0.2","avgPriceMins":5},
                    //                     {"filterType":"LOT_SIZE","minQty":"0.00100000","maxQty":"100000.00000000","stepSize":"0.00100000"},
                    //                     {"filterType":"MIN_NOTIONAL","minNotional":"0.00010000","applyToMarket":true,"avgPriceMins":5},
                    //                     {"filterType":"ICEBERG_PARTS","limit":10},
                    //                     {"filterType":"MARKET_LOT_SIZE","minQty":"0.00000000","maxQty":"63100.00000000","stepSize":"0.00000000"},
                    //                     {"filterType":"MAX_NUM_ORDERS","maxNumOrders":200},
                    //                     {"filterType":"MAX_NUM_ALGO_ORDERS","maxNumAlgoOrders":5}
                    //                 ],
                    //                 "permissions":["SPOT","MARGIN"]}
                    //             },
                    //         ],
                    //     }
                    //
                    // futures/usdt-margined (fapi)
                    //
                    //     {
                    //         "timezone":"UTC",
                    //         "serverTime":1575417244353,
                    //         "rateLimits":[
                    //             {"rateLimitType":"REQUEST_WEIGHT","interval":"MINUTE","intervalNum":1,"limit":1200},
                    //             {"rateLimitType":"ORDERS","interval":"MINUTE","intervalNum":1,"limit":1200}
                    //         ],
                    //         "exchangeFilters":[],
                    //         "symbols":[
                    //             {
                    //                 "symbol":"BTCUSDT",
                    //                 "status":"TRADING",
                    //                 "maintMarginPercent":"2.5000",
                    //                 "requiredMarginPercent":"5.0000",
                    //                 "baseAsset":"BTC",
                    //                 "quoteAsset":"USDT",
                    //                 "pricePrecision":2,
                    //                 "quantityPrecision":3,
                    //                 "baseAssetPrecision":8,
                    //                 "quotePrecision":8,
                    //                 "filters":[
                    //                     {"minPrice":"0.01","maxPrice":"100000","filterType":"PRICE_FILTER","tickSize":"0.01"},
                    //                     {"stepSize":"0.001","filterType":"LOT_SIZE","maxQty":"1000","minQty":"0.001"},
                    //                     {"stepSize":"0.001","filterType":"MARKET_LOT_SIZE","maxQty":"1000","minQty":"0.001"},
                    //                     {"limit":200,"filterType":"MAX_NUM_ORDERS"},
                    //                     {"multiplierDown":"0.8500","multiplierUp":"1.1500","multiplierDecimal":"4","filterType":"PERCENT_PRICE"}
                    //                 ],
                    //                 "orderTypes":["LIMIT","MARKET","STOP"],
                    //                 "timeInForce":["GTC","IOC","FOK","GTX"]
                    //             }
                    //         ]
                    //     }
                    //
                    // delivery/coin-margined (dapi)
                    //
                    //     {
                    //         "timezone": "UTC",
                    //         "serverTime": 1597667052958,
                    //         "rateLimits": [
                    //             {"rateLimitType":"REQUEST_WEIGHT","interval":"MINUTE","intervalNum":1,"limit":6000},
                    //             {"rateLimitType":"ORDERS","interval":"MINUTE","intervalNum":1,"limit":6000}
                    //         ],
                    //         "exchangeFilters": [],
                    //         "symbols": [
                    //             {
                    //                 "symbol": "BTCUSD_200925",
                    //                 "pair": "BTCUSD",
                    //                 "contractType": "CURRENT_QUARTER",
                    //                 "deliveryDate": 1601020800000,
                    //                 "onboardDate": 1590739200000,
                    //                 "contractStatus": "TRADING",
                    //                 "contractSize": 100,
                    //                 "marginAsset": "BTC",
                    //                 "maintMarginPercent": "2.5000",
                    //                 "requiredMarginPercent": "5.0000",
                    //                 "baseAsset": "BTC",
                    //                 "quoteAsset": "USD",
                    //                 "pricePrecision": 1,
                    //                 "quantityPrecision": 0,
                    //                 "baseAssetPrecision": 8,
                    //                 "quotePrecision": 8,
                    //                 "equalQtyPrecision": 4,
                    //                 "filters": [
                    //                     {"minPrice":"0.1","maxPrice":"100000","filterType":"PRICE_FILTER","tickSize":"0.1"},
                    //                     {"stepSize":"1","filterType":"LOT_SIZE","maxQty":"100000","minQty":"1"},
                    //                     {"stepSize":"0","filterType":"MARKET_LOT_SIZE","maxQty":"100000","minQty":"1"},
                    //                     {"limit":200,"filterType":"MAX_NUM_ORDERS"},
                    //                     {"multiplierDown":"0.9500","multiplierUp":"1.0500","multiplierDecimal":"4","filterType":"PERCENT_PRICE"}
                    //                 ],
                    //                 "orderTypes": ["LIMIT","MARKET","STOP","STOP_MARKET","TAKE_PROFIT","TAKE_PROFIT_MARKET","TRAILING_STOP_MARKET"],
                    //                 "timeInForce": ["GTC","IOC","FOK","GTX"]
                    //             },
                    //             {
                    //                 "symbol": "BTCUSD_PERP",
                    //                 "pair": "BTCUSD",
                    //                 "contractType": "PERPETUAL",
                    //                 "deliveryDate": 4133404800000,
                    //                 "onboardDate": 1596006000000,
                    //                 "contractStatus": "TRADING",
                    //                 "contractSize": 100,
                    //                 "marginAsset": "BTC",
                    //                 "maintMarginPercent": "2.5000",
                    //                 "requiredMarginPercent": "5.0000",
                    //                 "baseAsset": "BTC",
                    //                 "quoteAsset": "USD",
                    //                 "pricePrecision": 1,
                    //                 "quantityPrecision": 0,
                    //                 "baseAssetPrecision": 8,
                    //                 "quotePrecision": 8,
                    //                 "equalQtyPrecision": 4,
                    //                 "filters": [
                    //                     {"minPrice":"0.1","maxPrice":"100000","filterType":"PRICE_FILTER","tickSize":"0.1"},
                    //                     {"stepSize":"1","filterType":"LOT_SIZE","maxQty":"100000","minQty":"1"},
                    //                     {"stepSize":"1","filterType":"MARKET_LOT_SIZE","maxQty":"100000","minQty":"1"},
                    //                     {"limit":200,"filterType":"MAX_NUM_ORDERS"},
                    //                     {"multiplierDown":"0.8500","multiplierUp":"1.1500","multiplierDecimal":"4","filterType":"PERCENT_PRICE"}
                    //                 ],
                    //                 "orderTypes": ["LIMIT","MARKET","STOP","STOP_MARKET","TAKE_PROFIT","TAKE_PROFIT_MARKET","TRAILING_STOP_MARKET"],
                    //                 "timeInForce": ["GTC","IOC","FOK","GTX"]
                    //             }
                    //         ]
                    //     }
                    //
                    if (this.options['adjustForTimeDifference']) await this.loadTimeDifference();
                    const markets = this.safeValue(response, 'symbols', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const spot = type === 'spot';
                        const future = type === 'future';
                        const delivery = type === 'delivery';
                        const id = this.safeString(market, 'symbol');
                        const lowercaseId = this.safeStringLower(market, 'symbol');
                        const baseId = this.safeString(market, 'baseAsset');
                        const quoteId = this.safeString(market, 'quoteAsset');
                        const settleId = this.safeString(market, 'marginAsset');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const settle = this.safeCurrencyCode(settleId);
                        const contract = future || delivery;
                        const contractType = this.safeString(market, 'contractType');
                        const idSymbol = contract && contractType !== 'PERPETUAL';
                        let symbol = undefined;
                        let expiry = undefined;
                        if (idSymbol) {
                            symbol = id;
                            expiry = this.safeInteger(market, 'deliveryDate');
                        } else symbol = base + '/' + quote;
                        const filters = this.safeValue(market, 'filters', []);
                        const filtersByType = this.indexBy(filters, 'filterType');
                        const status = this.safeString2(market, 'status', 'contractStatus');
                        let contractSize = undefined;
                        let fees = this.fees;
                        if (contract) {
                            contractSize = this.safeNumber(market, 'contractSize', this.parseNumber('1'));
                            fees = this.fees[type];
                        }
                        let active = status === 'TRADING';
                        if (spot) {
                            const permissions = this.safeValue(market, 'permissions', []);
                            for(let j = 0; j < permissions.length; j++)if (permissions[j] === 'TRD_GRP_003') {
                                active = false;
                                break;
                            }
                        }
                        const isMarginTradingAllowed = this.safeValue(market, 'isMarginTradingAllowed', false);
                        const entry = {
                            'id': id,
                            'lowercaseId': lowercaseId,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': type,
                            'spot': spot,
                            'margin': spot && isMarginTradingAllowed,
                            'swap': future,
                            'future': future,
                            'delivery': delivery,
                            'option': false,
                            'active': active,
                            'contract': contract,
                            'linear': contract ? future : undefined,
                            'inverse': contract ? delivery : undefined,
                            'taker': fees['trading']['taker'],
                            'maker': fees['trading']['maker'],
                            'contractSize': contractSize,
                            'expiry': expiry,
                            'expiryDatetime': this.iso8601(expiry),
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'quantityPrecision'),
                                'price': this.safeInteger(market, 'pricePrecision'),
                                'base': this.safeInteger(market, 'baseAssetPrecision'),
                                'quote': this.safeInteger(market, 'quotePrecision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        };
                        if ('PRICE_FILTER' in filtersByType) {
                            const filter = this.safeValue(filtersByType, 'PRICE_FILTER', {});
                            const tickSize = this.safeString(filter, 'tickSize');
                            entry['precision']['price'] = this.precisionFromString(tickSize);
                            // PRICE_FILTER reports zero values for maxPrice
                            // since they updated filter types in November 2018
                            // https://github.com/ccxt/ccxt/issues/4286
                            // therefore limits['price']['max'] doesn't have any meaningful value except undefined
                            entry['limits']['price'] = {
                                'min': this.safeNumber(filter, 'minPrice'),
                                'max': this.safeNumber(filter, 'maxPrice')
                            };
                            entry['precision']['price'] = this.precisionFromString(filter['tickSize']);
                        }
                        if ('LOT_SIZE' in filtersByType) {
                            const filter = this.safeValue(filtersByType, 'LOT_SIZE', {});
                            const stepSize = this.safeString(filter, 'stepSize');
                            entry['precision']['amount'] = this.precisionFromString(stepSize);
                            entry['limits']['amount'] = {
                                'min': this.safeNumber(filter, 'minQty'),
                                'max': this.safeNumber(filter, 'maxQty')
                            };
                        }
                        if ('MARKET_LOT_SIZE' in filtersByType) {
                            const filter = this.safeValue(filtersByType, 'MARKET_LOT_SIZE', {});
                            entry['limits']['market'] = {
                                'min': this.safeNumber(filter, 'minQty'),
                                'max': this.safeNumber(filter, 'maxQty')
                            };
                        }
                        if ('MIN_NOTIONAL' in filtersByType) {
                            const filter = this.safeValue(filtersByType, 'MIN_NOTIONAL', {});
                            entry['limits']['cost']['min'] = this.safeNumber2(filter, 'minNotional', 'notional');
                        }
                        result.push(entry);
                    }
                    return result;
                }
                parseBalance(response, type) {
                    const result = {
                        'info': response
                    };
                    let timestamp = undefined;
                    if (type === 'spot' || type === 'margin') {
                        timestamp = this.safeInteger(response, 'updateTime');
                        const balances = this.safeValue2(response, 'balances', 'userAssets', []);
                        for(let i = 0; i < balances.length; i++){
                            const balance = balances[i];
                            const currencyId = this.safeString(balance, 'asset');
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            account['free'] = this.safeString(balance, 'free');
                            account['used'] = this.safeString(balance, 'locked');
                            result[code] = account;
                        }
                    } else if (type === 'savings') {
                        const positionAmountVos = this.safeValue(response, 'positionAmountVos');
                        for(let i = 0; i < positionAmountVos.length; i++){
                            const entry = positionAmountVos[i];
                            const currencyId = this.safeString(entry, 'asset');
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            const usedAndTotal = this.safeString(entry, 'amount');
                            account['total'] = usedAndTotal;
                            account['used'] = usedAndTotal;
                            result[code] = account;
                        }
                    } else if (type === 'funding') for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const account = this.account();
                        const currencyId = this.safeString(entry, 'asset');
                        const code = this.safeCurrencyCode(currencyId);
                        account['free'] = this.safeString(entry, 'free');
                        const frozen = this.safeString(entry, 'freeze');
                        const withdrawing = this.safeString(entry, 'withdrawing');
                        const locked = this.safeString(entry, 'locked');
                        account['used'] = Precise.stringAdd(frozen, Precise.stringAdd(locked, withdrawing));
                        result[code] = account;
                    }
                    else {
                        let balances = response;
                        if (!Array.isArray(response)) balances = this.safeValue(response, 'assets', []);
                        for(let i = 0; i < balances.length; i++){
                            const balance = balances[i];
                            const currencyId = this.safeString(balance, 'asset');
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            account['free'] = this.safeString(balance, 'availableBalance');
                            account['used'] = this.safeString(balance, 'initialMargin');
                            account['total'] = this.safeString2(balance, 'marginBalance', 'balance');
                            result[code] = account;
                        }
                    }
                    result['timestamp'] = timestamp;
                    result['datetime'] = this.iso8601(timestamp);
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const defaultType = this.safeString2(this.options, 'fetchBalance', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    let method = 'privateGetAccount';
                    if (type === 'future') {
                        const options = this.safeValue(this.options, type, {});
                        const fetchBalanceOptions = this.safeValue(options, 'fetchBalance', {});
                        method = this.safeString(fetchBalanceOptions, 'method', 'fapiPrivateV2GetAccount');
                    } else if (type === 'delivery') {
                        const options = this.safeValue(this.options, type, {});
                        const fetchBalanceOptions = this.safeValue(options, 'fetchBalance', {});
                        method = this.safeString(fetchBalanceOptions, 'method', 'dapiPrivateGetAccount');
                    } else if (type === 'margin') method = 'sapiGetMarginAccount';
                    else if (type === 'savings') method = 'sapiGetLendingUnionAccount';
                    else if (type === 'funding') method = 'sapiPostAssetGetFundingAsset';
                    const query = this.omit(params, 'type');
                    const response = await this[method](query);
                    //
                    // spot
                    //
                    //     {
                    //         makerCommission: 10,
                    //         takerCommission: 10,
                    //         buyerCommission: 0,
                    //         sellerCommission: 0,
                    //         canTrade: true,
                    //         canWithdraw: true,
                    //         canDeposit: true,
                    //         updateTime: 1575357359602,
                    //         accountType: "MARGIN",
                    //         balances: [
                    //             { asset: "BTC", free: "0.00219821", locked: "0.00000000"  },
                    //         ]
                    //     }
                    //
                    // margin
                    //
                    //     {
                    //         "borrowEnabled":true,
                    //         "marginLevel":"999.00000000",
                    //         "totalAssetOfBtc":"0.00000000",
                    //         "totalLiabilityOfBtc":"0.00000000",
                    //         "totalNetAssetOfBtc":"0.00000000",
                    //         "tradeEnabled":true,
                    //         "transferEnabled":true,
                    //         "userAssets":[
                    //             {"asset":"MATIC","borrowed":"0.00000000","free":"0.00000000","interest":"0.00000000","locked":"0.00000000","netAsset":"0.00000000"},
                    //             {"asset":"VET","borrowed":"0.00000000","free":"0.00000000","interest":"0.00000000","locked":"0.00000000","netAsset":"0.00000000"},
                    //             {"asset":"USDT","borrowed":"0.00000000","free":"0.00000000","interest":"0.00000000","locked":"0.00000000","netAsset":"0.00000000"}
                    //         ],
                    //     }
                    //
                    // futures (fapi)
                    //
                    //     fapiPrivateGetAccount
                    //
                    //     {
                    //         "feeTier":0,
                    //         "canTrade":true,
                    //         "canDeposit":true,
                    //         "canWithdraw":true,
                    //         "updateTime":0,
                    //         "totalInitialMargin":"0.00000000",
                    //         "totalMaintMargin":"0.00000000",
                    //         "totalWalletBalance":"4.54000000",
                    //         "totalUnrealizedProfit":"0.00000000",
                    //         "totalMarginBalance":"4.54000000",
                    //         "totalPositionInitialMargin":"0.00000000",
                    //         "totalOpenOrderInitialMargin":"0.00000000",
                    //         "maxWithdrawAmount":"4.54000000",
                    //         "assets":[
                    //             {
                    //                 "asset":"USDT",
                    //                 "walletBalance":"4.54000000",
                    //                 "unrealizedProfit":"0.00000000",
                    //                 "marginBalance":"4.54000000",
                    //                 "maintMargin":"0.00000000",
                    //                 "initialMargin":"0.00000000",
                    //                 "positionInitialMargin":"0.00000000",
                    //                 "openOrderInitialMargin":"0.00000000",
                    //                 "maxWithdrawAmount":"4.54000000"
                    //             }
                    //         ],
                    //         "positions":[
                    //             {
                    //                 "symbol":"BTCUSDT",
                    //                 "initialMargin":"0.00000",
                    //                 "maintMargin":"0.00000",
                    //                 "unrealizedProfit":"0.00000000",
                    //                 "positionInitialMargin":"0.00000",
                    //                 "openOrderInitialMargin":"0.00000"
                    //             }
                    //         ]
                    //     }
                    //
                    //     fapiPrivateV2GetAccount
                    //
                    //     {
                    //         "feeTier":0,
                    //         "canTrade":true,
                    //         "canDeposit":true,
                    //         "canWithdraw":true,
                    //         "updateTime":0,
                    //         "totalInitialMargin":"0.00000000",
                    //         "totalMaintMargin":"0.00000000",
                    //         "totalWalletBalance":"0.00000000",
                    //         "totalUnrealizedProfit":"0.00000000",
                    //         "totalMarginBalance":"0.00000000",
                    //         "totalPositionInitialMargin":"0.00000000",
                    //         "totalOpenOrderInitialMargin":"0.00000000",
                    //         "totalCrossWalletBalance":"0.00000000",
                    //         "totalCrossUnPnl":"0.00000000",
                    //         "availableBalance":"0.00000000",
                    //         "maxWithdrawAmount":"0.00000000",
                    //         "assets":[
                    //             {
                    //                 "asset":"BNB",
                    //                 "walletBalance":"0.01000000",
                    //                 "unrealizedProfit":"0.00000000",
                    //                 "marginBalance":"0.01000000",
                    //                 "maintMargin":"0.00000000",
                    //                 "initialMargin":"0.00000000",
                    //                 "positionInitialMargin":"0.00000000",
                    //                 "openOrderInitialMargin":"0.00000000",
                    //                 "maxWithdrawAmount":"0.01000000",
                    //                 "crossWalletBalance":"0.01000000",
                    //                 "crossUnPnl":"0.00000000",
                    //                 "availableBalance":"0.01000000"
                    //             }
                    //         ],
                    //         "positions":[
                    //             {
                    //                 "symbol":"BTCUSDT",
                    //                 "initialMargin":"0",
                    //                 "maintMargin":"0",
                    //                 "unrealizedProfit":"0.00000000",
                    //                 "positionInitialMargin":"0",
                    //                 "openOrderInitialMargin":"0",
                    //                 "leverage":"20",
                    //                 "isolated":false,
                    //                 "entryPrice":"0.00000",
                    //                 "maxNotional":"5000000",
                    //                 "positionSide":"BOTH"
                    //             },
                    //         ]
                    //     }
                    //
                    //     fapiPrivateV2GetBalance
                    //
                    //     [
                    //         {
                    //             "accountAlias":"FzFzXquXXqoC",
                    //             "asset":"BNB",
                    //             "balance":"0.01000000",
                    //             "crossWalletBalance":"0.01000000",
                    //             "crossUnPnl":"0.00000000",
                    //             "availableBalance":"0.01000000",
                    //             "maxWithdrawAmount":"0.01000000"
                    //         }
                    //     ]
                    //
                    // savings
                    //
                    //     {
                    //       "totalAmountInBTC": "0.3172",
                    //       "totalAmountInUSDT": "10000",
                    //       "totalFixedAmountInBTC": "0.3172",
                    //       "totalFixedAmountInUSDT": "10000",
                    //       "totalFlexibleInBTC": "0",
                    //       "totalFlexibleInUSDT": "0",
                    //       "positionAmountVos": [
                    //         {
                    //           "asset": "USDT",
                    //           "amount": "10000",
                    //           "amountInBTC": "0.3172",
                    //           "amountInUSDT": "10000"
                    //         },
                    //         {
                    //           "asset": "BUSD",
                    //           "amount": "0",
                    //           "amountInBTC": "0",
                    //           "amountInUSDT": "0"
                    //         }
                    //       ]
                    //     }
                    //
                    // binance pay
                    //
                    //     [
                    //       {
                    //         "asset": "BUSD",
                    //         "free": "1129.83",
                    //         "locked": "0",
                    //         "freeze": "0",
                    //         "withdrawing": "0"
                    //       }
                    //     ]
                    //
                    return this.parseBalance(response, type);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 5000, see https://github.com/binance/binance-spot-api-docs/blob/master/rest-api.md#order-book
                    let method = 'publicGetDepth';
                    if (market['linear']) method = 'fapiPublicGetDepth';
                    else if (market['inverse']) method = 'dapiPublicGetDepth';
                    const response = await this[method](this.extend(request, params));
                    //
                    // future
                    //
                    //     {
                    //         "lastUpdateId":333598053905,
                    //         "E":1618631511986,
                    //         "T":1618631511964,
                    //         "bids":[
                    //             ["2493.56","20.189"],
                    //             ["2493.54","1.000"],
                    //             ["2493.51","0.005"]
                    //         ],
                    //         "asks":[
                    //             ["2493.57","0.877"],
                    //             ["2493.62","0.063"],
                    //             ["2493.71","12.054"],
                    //         ]
                    //     }
                    const timestamp = this.safeInteger(response, 'T');
                    const orderbook = this.parseOrderBook(response, symbol, timestamp);
                    orderbook['nonce'] = this.safeInteger(response, 'lastUpdateId');
                    return orderbook;
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         symbol: 'ETHBTC',
                    //         priceChange: '0.00068700',
                    //         priceChangePercent: '2.075',
                    //         weightedAvgPrice: '0.03342681',
                    //         prevClosePrice: '0.03310300',
                    //         lastPrice: '0.03378900',
                    //         lastQty: '0.07700000',
                    //         bidPrice: '0.03378900',
                    //         bidQty: '7.16800000',
                    //         askPrice: '0.03379000',
                    //         askQty: '24.00000000',
                    //         openPrice: '0.03310200',
                    //         highPrice: '0.03388900',
                    //         lowPrice: '0.03306900',
                    //         volume: '205478.41000000',
                    //         quoteVolume: '6868.48826294',
                    //         openTime: 1601469986932,
                    //         closeTime: 1601556386932,
                    //         firstId: 196098772,
                    //         lastId: 196186315,
                    //         count: 87544
                    //     }
                    //
                    // coinm
                    //     {
                    //         baseVolume: '214549.95171161',
                    //         closeTime: '1621965286847',
                    //         count: '1283779',
                    //         firstId: '152560106',
                    //         highPrice: '39938.3',
                    //         lastId: '153843955',
                    //         lastPrice: '37993.4',
                    //         lastQty: '1',
                    //         lowPrice: '36457.2',
                    //         openPrice: '37783.4',
                    //         openTime: '1621878840000',
                    //         pair: 'BTCUSD',
                    //         priceChange: '210.0',
                    //         priceChangePercent: '0.556',
                    //         symbol: 'BTCUSD_PERP',
                    //         volume: '81990451',
                    //         weightedAvgPrice: '38215.08713747'
                    //     }
                    //
                    const timestamp = this.safeInteger(ticker, 'closeTime');
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeString(ticker, 'lastPrice');
                    const isCoinm = 'baseVolume' in ticker;
                    let baseVolume = undefined;
                    let quoteVolume = undefined;
                    if (isCoinm) {
                        baseVolume = this.safeString(ticker, 'baseVolume');
                        quoteVolume = this.safeString(ticker, 'volume');
                    } else {
                        baseVolume = this.safeString(ticker, 'volume');
                        quoteVolume = this.safeString(ticker, 'quoteVolume');
                    }
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'highPrice'),
                        'low': this.safeString(ticker, 'lowPrice'),
                        'bid': this.safeString(ticker, 'bidPrice'),
                        'bidVolume': this.safeString(ticker, 'bidQty'),
                        'ask': this.safeString(ticker, 'askPrice'),
                        'askVolume': this.safeString(ticker, 'askQty'),
                        'vwap': this.safeString(ticker, 'weightedAvgPrice'),
                        'open': this.safeString(ticker, 'openPrice'),
                        'close': last,
                        'last': last,
                        'previousClose': this.safeString(ticker, 'prevClosePrice'),
                        'change': this.safeString(ticker, 'priceChange'),
                        'percentage': this.safeString(ticker, 'priceChangePercent'),
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchStatus(params = {}) {
                    const response = await this.sapiGetSystemStatus(params);
                    //
                    //     {
                    //         "status": 0,              // 0: normal，1：system maintenance
                    //         "msg": "normal"           // "normal", "system_maintenance"
                    //     }
                    //
                    const statusRaw = this.safeString(response, 'status');
                    return {
                        'status': this.safeString({
                            '0': 'ok',
                            '1': 'maintenance'
                        }, statusRaw, statusRaw),
                        'updated': this.milliseconds(),
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    let method = 'publicGetTicker24hr';
                    if (market['linear']) method = 'fapiPublicGetTicker24hr';
                    else if (market['inverse']) method = 'dapiPublicGetTicker24hr';
                    const response = await this[method](this.extend(request, params));
                    if (Array.isArray(response)) {
                        const firstTicker = this.safeValue(response, 0, {});
                        return this.parseTicker(firstTicker, market);
                    }
                    return this.parseTicker(response, market);
                }
                async fetchBidsAsks(symbols, params = {}) {
                    await this.loadMarkets();
                    const defaultType = this.safeString2(this.options, 'fetchBidsAsks', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    let method = undefined;
                    if (type === 'future') method = 'fapiPublicGetTickerBookTicker';
                    else if (type === 'delivery') method = 'dapiPublicGetTickerBookTicker';
                    else method = 'publicGetTickerBookTicker';
                    const response = await this[method](query);
                    return this.parseTickers(response, symbols);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const defaultType = this.safeString2(this.options, 'fetchTickers', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    let defaultMethod = undefined;
                    if (type === 'future') defaultMethod = 'fapiPublicGetTicker24hr';
                    else if (type === 'delivery') defaultMethod = 'dapiPublicGetTicker24hr';
                    else defaultMethod = 'publicGetTicker24hr';
                    const method = this.safeString(this.options, 'fetchTickersMethod', defaultMethod);
                    const response = await this[method](query);
                    return this.parseTickers(response, symbols);
                }
                parseOHLCV(ohlcv, market) {
                    // when api method = publicGetKlines || fapiPublicGetKlines || dapiPublicGetKlines
                    //     [
                    //         1591478520000, // open time
                    //         "0.02501300",  // open
                    //         "0.02501800",  // high
                    //         "0.02500000",  // low
                    //         "0.02500000",  // close
                    //         "22.19000000", // volume
                    //         1591478579999, // close time
                    //         "0.55490906",  // quote asset volume
                    //         40,            // number of trades
                    //         "10.92900000", // taker buy base asset volume
                    //         "0.27336462",  // taker buy quote asset volume
                    //         "0"            // ignore
                    //     ]
                    //
                    //  when api method = fapiPublicGetMarkPriceKlines || fapiPublicGetIndexPriceKlines
                    //     [
                    //         [
                    //         1591256460000,          // Open time
                    //         "9653.29201333",        // Open
                    //         "9654.56401333",        // High
                    //         "9653.07367333",        // Low
                    //         "9653.07367333",        // Close (or latest price)
                    //         "0",                    // Ignore
                    //         1591256519999,          // Close time
                    //         "0",                    // Ignore
                    //         60,                     // Number of bisic data
                    //         "0",                    // Ignore
                    //         "0",                    // Ignore
                    //         "0"                     // Ignore
                    //         ]
                    //     ]
                    //
                    return [
                        this.safeInteger(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    // binance docs say that the default limit 500, max 1500 for futures, max 1000 for spot markets
                    // the reality is that the time range wider than 500 candles won't work right
                    const defaultLimit = 500;
                    const maxLimit = 1500;
                    const price = this.safeString(params, 'price');
                    params = this.omit(params, 'price');
                    limit = limit === undefined ? defaultLimit : Math.min(limit, maxLimit);
                    const request = {
                        'interval': this.timeframes[timeframe],
                        'limit': limit
                    };
                    if (price === 'index') request['pair'] = market['id']; // Index price takes this argument instead of symbol
                    else request['symbol'] = market['id'];
                    // const duration = this.parseTimeframe (timeframe);
                    if (since !== undefined) {
                        request['startTime'] = since;
                        //
                        // It didn't work before without the endTime
                        // https://github.com/ccxt/ccxt/issues/8454
                        //
                        if (market['inverse']) {
                            if (since > 0) {
                                const duration = this.parseTimeframe(timeframe);
                                const endTime = this.sum(since, limit * duration * 1000 - 1);
                                const now = this.milliseconds();
                                request['endTime'] = Math.min(now, endTime);
                            }
                        }
                    }
                    let method = 'publicGetKlines';
                    if (price === 'mark') {
                        if (market['inverse']) method = 'dapiPublicGetMarkPriceKlines';
                        else method = 'fapiPublicGetMarkPriceKlines';
                    } else if (price === 'index') {
                        if (market['inverse']) method = 'dapiPublicGetIndexPriceKlines';
                        else method = 'fapiPublicGetIndexPriceKlines';
                    } else if (market['linear']) method = 'fapiPublicGetKlines';
                    else if (market['inverse']) method = 'dapiPublicGetKlines';
                    const response = await this[method](this.extend(request, params));
                    //
                    //     [
                    //         [1591478520000,"0.02501300","0.02501800","0.02500000","0.02500000","22.19000000",1591478579999,"0.55490906",40,"10.92900000","0.27336462","0"],
                    //         [1591478580000,"0.02499600","0.02500900","0.02499400","0.02500300","21.34700000",1591478639999,"0.53370468",24,"7.53800000","0.18850725","0"],
                    //         [1591478640000,"0.02500800","0.02501100","0.02500300","0.02500800","154.14200000",1591478699999,"3.85405839",97,"5.32300000","0.13312641","0"],
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                async fetchMarkOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'mark'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'index'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                parseTrade(trade, market) {
                    if ('isDustTrade' in trade) return this.parseDustTrade(trade, market);
                    //
                    // aggregate trades
                    // https://github.com/binance-exchange/binance-official-api-docs/blob/master/rest-api.md#compressedaggregate-trades-list
                    //
                    //     {
                    //         "a": 26129,         // Aggregate tradeId
                    //         "p": "0.01633102",  // Price
                    //         "q": "4.70443515",  // Quantity
                    //         "f": 27781,         // First tradeId
                    //         "l": 27781,         // Last tradeId
                    //         "T": 1498793709153, // Timestamp
                    //         "m": true,          // Was the buyer the maker?
                    //         "M": true           // Was the trade the best price match?
                    //     }
                    //
                    // recent public trades and old public trades
                    // https://github.com/binance-exchange/binance-official-api-docs/blob/master/rest-api.md#recent-trades-list
                    // https://github.com/binance-exchange/binance-official-api-docs/blob/master/rest-api.md#old-trade-lookup-market_data
                    //
                    //     {
                    //         "id": 28457,
                    //         "price": "4.00000100",
                    //         "qty": "12.00000000",
                    //         "time": 1499865549590,
                    //         "isBuyerMaker": true,
                    //         "isBestMatch": true
                    //     }
                    //
                    // private trades
                    // https://github.com/binance-exchange/binance-official-api-docs/blob/master/rest-api.md#account-trade-list-user_data
                    //
                    //     {
                    //         "symbol": "BNBBTC",
                    //         "id": 28457,
                    //         "orderId": 100234,
                    //         "price": "4.00000100",
                    //         "qty": "12.00000000",
                    //         "commission": "10.10000000",
                    //         "commissionAsset": "BNB",
                    //         "time": 1499865549590,
                    //         "isBuyer": true,
                    //         "isMaker": false,
                    //         "isBestMatch": true
                    //     }
                    //
                    // futures trades
                    // https://binance-docs.github.io/apidocs/futures/en/#account-trade-list-user_data
                    //
                    //     {
                    //       "accountId": 20,
                    //       "buyer": False,
                    //       "commission": "-0.07819010",
                    //       "commissionAsset": "USDT",
                    //       "counterPartyId": 653,
                    //       "id": 698759,
                    //       "maker": False,
                    //       "orderId": 25851813,
                    //       "price": "7819.01",
                    //       "qty": "0.002",
                    //       "quoteQty": "0.01563",
                    //       "realizedPnl": "-0.91539999",
                    //       "side": "SELL",
                    //       "symbol": "BTCUSDT",
                    //       "time": 1569514978020
                    //     }
                    //     {
                    //       "symbol": "BTCUSDT",
                    //       "id": 477128891,
                    //       "orderId": 13809777875,
                    //       "side": "SELL",
                    //       "price": "38479.55",
                    //       "qty": "0.001",
                    //       "realizedPnl": "-0.00009534",
                    //       "marginAsset": "USDT",
                    //       "quoteQty": "38.47955",
                    //       "commission": "-0.00076959",
                    //       "commissionAsset": "USDT",
                    //       "time": 1612733566708,
                    //       "positionSide": "BOTH",
                    //       "maker": true,
                    //       "buyer": false
                    //     }
                    //
                    // { respType: FULL }
                    //
                    //     {
                    //       "price": "4000.00000000",
                    //       "qty": "1.00000000",
                    //       "commission": "4.00000000",
                    //       "commissionAsset": "USDT",
                    //       "tradeId": "1234",
                    //     }
                    //
                    const timestamp = this.safeInteger2(trade, 'T', 'time');
                    const price = this.safeString2(trade, 'p', 'price');
                    const amount = this.safeString2(trade, 'q', 'qty');
                    const cost = this.safeString2(trade, 'quoteQty', 'baseQty'); // inverse futures
                    const marketId = this.safeString(trade, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    let id = this.safeString2(trade, 't', 'a');
                    id = this.safeString2(trade, 'id', 'tradeId', id);
                    let side = undefined;
                    const orderId = this.safeString(trade, 'orderId');
                    const buyerMaker = this.safeValue2(trade, 'm', 'isBuyerMaker');
                    let takerOrMaker = undefined;
                    if (buyerMaker !== undefined) {
                        side = buyerMaker ? 'sell' : 'buy'; // this is reversed intentionally
                        takerOrMaker = 'taker';
                    } else if ('side' in trade) side = this.safeStringLower(trade, 'side');
                    else if ('isBuyer' in trade) side = trade['isBuyer'] ? 'buy' : 'sell'; // this is a true side
                    let fee = undefined;
                    if ('commission' in trade) fee = {
                        'cost': this.safeString(trade, 'commission'),
                        'currency': this.safeCurrencyCode(this.safeString(trade, 'commissionAsset'))
                    };
                    if ('isMaker' in trade) takerOrMaker = trade['isMaker'] ? 'maker' : 'taker';
                    if ('maker' in trade) takerOrMaker = trade['maker'] ? 'maker' : 'taker';
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const defaultType = this.safeString2(this.options, 'fetchTrades', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    let defaultMethod = undefined;
                    if (type === 'future') defaultMethod = 'fapiPublicGetAggTrades';
                    else if (type === 'delivery') defaultMethod = 'dapiPublicGetAggTrades';
                    else defaultMethod = 'publicGetAggTrades';
                    let method = this.safeString(this.options, 'fetchTradesMethod', defaultMethod);
                    if (method === 'publicGetAggTrades') {
                        if (type === 'future') method = 'fapiPublicGetAggTrades';
                        else if (type === 'delivery') method = 'dapiPublicGetAggTrades';
                    } else if (method === 'publicGetHistoricalTrades') {
                        if (type === 'future') method = 'fapiPublicGetHistoricalTrades';
                        else if (type === 'delivery') method = 'dapiPublicGetHistoricalTrades';
                    }
                    if (since !== undefined) {
                        request['startTime'] = since;
                        // https://github.com/ccxt/ccxt/issues/6400
                        // https://github.com/binance-exchange/binance-official-api-docs/blob/master/rest-api.md#compressedaggregate-trades-list
                        request['endTime'] = this.sum(since, 3600000);
                    }
                    if (limit !== undefined) request['limit'] = limit; // default = 500, maximum = 1000
                    //
                    // Caveats:
                    // - default limit (500) applies only if no other parameters set, trades up
                    //   to the maximum limit may be returned to satisfy other parameters
                    // - if both limit and time window is set and time window contains more
                    //   trades than the limit then the last trades from the window are returned
                    // - 'tradeId' accepted and returned by this method is "aggregate" trade id
                    //   which is different from actual trade id
                    // - setting both fromId and time window results in error
                    const response = await this[method](this.extend(request, query));
                    //
                    // aggregate trades
                    //
                    //     [
                    //         {
                    //             "a": 26129,         // Aggregate tradeId
                    //             "p": "0.01633102",  // Price
                    //             "q": "4.70443515",  // Quantity
                    //             "f": 27781,         // First tradeId
                    //             "l": 27781,         // Last tradeId
                    //             "T": 1498793709153, // Timestamp
                    //             "m": true,          // Was the buyer the maker?
                    //             "M": true           // Was the trade the best price match?
                    //         }
                    //     ]
                    //
                    // recent public trades and historical public trades
                    //
                    //     [
                    //         {
                    //             "id": 28457,
                    //             "price": "4.00000100",
                    //             "qty": "12.00000000",
                    //             "time": 1499865549590,
                    //             "isBuyerMaker": true,
                    //             "isBestMatch": true
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'NEW': 'open',
                        'PARTIALLY_FILLED': 'open',
                        'FILLED': 'closed',
                        'CANCELED': 'canceled',
                        'PENDING_CANCEL': 'canceling',
                        'REJECTED': 'rejected',
                        'EXPIRED': 'expired'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // spot
                    //
                    //     {
                    //         "symbol": "LTCBTC",
                    //         "orderId": 1,
                    //         "clientOrderId": "myOrder1",
                    //         "price": "0.1",
                    //         "origQty": "1.0",
                    //         "executedQty": "0.0",
                    //         "cummulativeQuoteQty": "0.0",
                    //         "status": "NEW",
                    //         "timeInForce": "GTC",
                    //         "type": "LIMIT",
                    //         "side": "BUY",
                    //         "stopPrice": "0.0",
                    //         "icebergQty": "0.0",
                    //         "time": 1499827319559,
                    //         "updateTime": 1499827319559,
                    //         "isWorking": true
                    //     }
                    //
                    // futures
                    //
                    //     {
                    //         "symbol": "BTCUSDT",
                    //         "orderId": 1,
                    //         "clientOrderId": "myOrder1",
                    //         "price": "0.1",
                    //         "origQty": "1.0",
                    //         "executedQty": "1.0",
                    //         "cumQuote": "10.0",
                    //         "status": "NEW",
                    //         "timeInForce": "GTC",
                    //         "type": "LIMIT",
                    //         "side": "BUY",
                    //         "stopPrice": "0.0",
                    //         "updateTime": 1499827319559
                    //     }
                    //
                    // createOrder with { "newOrderRespType": "FULL" }
                    //
                    //     {
                    //       "symbol": "BTCUSDT",
                    //       "orderId": 5403233939,
                    //       "orderListId": -1,
                    //       "clientOrderId": "x-R4BD3S825e669e75b6c14f69a2c43e",
                    //       "transactTime": 1617151923742,
                    //       "price": "0.00000000",
                    //       "origQty": "0.00050000",
                    //       "executedQty": "0.00050000",
                    //       "cummulativeQuoteQty": "29.47081500",
                    //       "status": "FILLED",
                    //       "timeInForce": "GTC",
                    //       "type": "MARKET",
                    //       "side": "BUY",
                    //       "fills": [
                    //         {
                    //           "price": "58941.63000000",
                    //           "qty": "0.00050000",
                    //           "commission": "0.00007050",
                    //           "commissionAsset": "BNB",
                    //           "tradeId": 737466631
                    //         }
                    //       ]
                    //     }
                    //
                    // delivery
                    //
                    //     {
                    //       "orderId": "18742727411",
                    //       "symbol": "ETHUSD_PERP",
                    //       "pair": "ETHUSD",
                    //       "status": "FILLED",
                    //       "clientOrderId": "x-xcKtGhcu3e2d1503fdd543b3b02419",
                    //       "price": "0",
                    //       "avgPrice": "4522.14",
                    //       "origQty": "1",
                    //       "executedQty": "1",
                    //       "cumBase": "0.00221134",
                    //       "timeInForce": "GTC",
                    //       "type": "MARKET",
                    //       "reduceOnly": false,
                    //       "closePosition": false,
                    //       "side": "SELL",
                    //       "positionSide": "BOTH",
                    //       "stopPrice": "0",
                    //       "workingType": "CONTRACT_PRICE",
                    //       "priceProtect": false,
                    //       "origType": "MARKET",
                    //       "time": "1636061952660",
                    //       "updateTime": "1636061952660"
                    //     }
                    //
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const filled = this.safeString(order, 'executedQty', '0');
                    let timestamp = undefined;
                    let lastTradeTimestamp = undefined;
                    if ('time' in order) timestamp = this.safeInteger(order, 'time');
                    else if ('transactTime' in order) timestamp = this.safeInteger(order, 'transactTime');
                    else if ('updateTime' in order) {
                        if (status === 'open') {
                            if (Precise.stringGt(filled, '0')) lastTradeTimestamp = this.safeInteger(order, 'updateTime');
                            else timestamp = this.safeInteger(order, 'updateTime');
                        }
                    }
                    const average = this.safeString(order, 'avgPrice');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'origQty');
                    // - Spot/Margin market: cummulativeQuoteQty
                    // - Futures market: cumQuote.
                    //   Note this is not the actual cost, since Binance futures uses leverage to calculate margins.
                    let cost = this.safeString2(order, 'cummulativeQuoteQty', 'cumQuote');
                    cost = this.safeString(order, 'cumBase', cost);
                    const id = this.safeString(order, 'orderId');
                    let type = this.safeStringLower(order, 'type');
                    const side = this.safeStringLower(order, 'side');
                    const fills = this.safeValue(order, 'fills', []);
                    const clientOrderId = this.safeString(order, 'clientOrderId');
                    let timeInForce = this.safeString(order, 'timeInForce');
                    if (timeInForce === 'GTX') // GTX means "Good Till Crossing" and is an equivalent way of saying Post Only
                    timeInForce = 'PO';
                    const postOnly = type === 'limit_maker' || timeInForce === 'PO';
                    if (type === 'limit_maker') type = 'limit';
                    const stopPriceString = this.safeString(order, 'stopPrice');
                    const stopPrice = this.parseNumber(this.omitZero(stopPriceString));
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': cost,
                        'average': average,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': undefined,
                        'trades': fills
                    }, market);
                }
                async createReduceOnlyOrder(symbol, type, side, amount, price, params = {}) {
                    const request = {
                        'reduceOnly': true
                    };
                    return await this.createOrder(symbol, type, side, amount, price, this.extend(request, params));
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const defaultType = this.safeString2(this.options, 'createOrder', 'defaultType', 'spot');
                    const marketType = this.safeString(params, 'type', defaultType);
                    const clientOrderId = this.safeString2(params, 'newClientOrderId', 'clientOrderId');
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    params = this.omit(params, [
                        'type',
                        'newClientOrderId',
                        'clientOrderId',
                        'postOnly'
                    ]);
                    const reduceOnly = this.safeValue(params, 'reduceOnly');
                    if (reduceOnly !== undefined) {
                        if (marketType !== 'future' && marketType !== 'delivery') throw new InvalidOrder(this.id + ' createOrder() does not support reduceOnly for ' + marketType + ' orders, reduceOnly orders are supported for future and delivery markets only');
                    }
                    let method = 'privatePostOrder';
                    if (marketType === 'future') method = 'fapiPrivatePostOrder';
                    else if (marketType === 'delivery') method = 'dapiPrivatePostOrder';
                    else if (marketType === 'margin') method = 'sapiPostMarginOrder';
                    // the next 5 lines are added to support for testing orders
                    if (market['spot']) {
                        const test = this.safeValue(params, 'test', false);
                        if (test) method += 'Test';
                        params = this.omit(params, 'test');
                        // only supported for spot/margin api (all margin markets are spot markets)
                        if (postOnly) type = 'LIMIT_MAKER';
                    }
                    const initialUppercaseType = type.toUpperCase();
                    let uppercaseType = initialUppercaseType;
                    const stopPrice = this.safeNumber(params, 'stopPrice');
                    if (stopPrice !== undefined) {
                        params = this.omit(params, 'stopPrice');
                        if (uppercaseType === 'MARKET') uppercaseType = market['contract'] ? 'STOP_MARKET' : 'STOP_LOSS';
                        else if (uppercaseType === 'LIMIT') uppercaseType = market['contract'] ? 'STOP' : 'STOP_LOSS_LIMIT';
                    }
                    const validOrderTypes = this.safeValue(market['info'], 'orderTypes');
                    if (!this.inArray(uppercaseType, validOrderTypes)) {
                        if (initialUppercaseType !== uppercaseType) throw new InvalidOrder(this.id + ' stopPrice parameter is not allowed for ' + symbol + ' ' + type + ' orders');
                        else throw new InvalidOrder(this.id + ' ' + type + ' is not a valid order type for the ' + symbol + ' market');
                    }
                    const request = {
                        'symbol': market['id'],
                        'type': uppercaseType,
                        'side': side.toUpperCase()
                    };
                    if (clientOrderId === undefined) {
                        const broker = this.safeValue(this.options, 'broker');
                        if (broker !== undefined) {
                            const brokerId = this.safeString(broker, marketType);
                            if (brokerId !== undefined) request['newClientOrderId'] = brokerId + this.uuid22();
                        }
                    } else request['newClientOrderId'] = clientOrderId;
                    if (marketType === 'spot' || marketType === 'margin') request['newOrderRespType'] = this.safeValue(this.options['newOrderRespType'], type, 'RESULT'); // 'ACK' for order id, 'RESULT' for full order or 'FULL' for order with fills
                    else // delivery and future
                    request['newOrderRespType'] = 'RESULT'; // "ACK", "RESULT", default "ACK"
                    // additional required fields depending on the order type
                    let timeInForceIsRequired = false;
                    let priceIsRequired = false;
                    let stopPriceIsRequired = false;
                    let quantityIsRequired = false;
                    //
                    // spot/margin
                    //
                    //     LIMIT                timeInForce, quantity, price
                    //     MARKET               quantity or quoteOrderQty
                    //     STOP_LOSS            quantity, stopPrice
                    //     STOP_LOSS_LIMIT      timeInForce, quantity, price, stopPrice
                    //     TAKE_PROFIT          quantity, stopPrice
                    //     TAKE_PROFIT_LIMIT    timeInForce, quantity, price, stopPrice
                    //     LIMIT_MAKER          quantity, price
                    //
                    // futures
                    //
                    //     LIMIT                timeInForce, quantity, price
                    //     MARKET               quantity
                    //     STOP/TAKE_PROFIT     quantity, price, stopPrice
                    //     STOP_MARKET          stopPrice
                    //     TAKE_PROFIT_MARKET   stopPrice
                    //     TRAILING_STOP_MARKET callbackRate
                    //
                    if (uppercaseType === 'MARKET') {
                        if (market['spot']) {
                            const quoteOrderQty = this.safeValue(this.options, 'quoteOrderQty', false);
                            if (quoteOrderQty) {
                                const quoteOrderQty = this.safeNumber(params, 'quoteOrderQty');
                                const precision = market['precision']['price'];
                                if (quoteOrderQty !== undefined) {
                                    request['quoteOrderQty'] = this.decimalToPrecision(quoteOrderQty, TRUNCATE, precision, this.precisionMode);
                                    params = this.omit(params, 'quoteOrderQty');
                                } else if (price !== undefined) request['quoteOrderQty'] = this.decimalToPrecision(amount * price, TRUNCATE, precision, this.precisionMode);
                                else quantityIsRequired = true;
                            } else quantityIsRequired = true;
                        } else quantityIsRequired = true;
                    } else if (uppercaseType === 'LIMIT') {
                        priceIsRequired = true;
                        timeInForceIsRequired = true;
                        quantityIsRequired = true;
                    } else if (uppercaseType === 'STOP_LOSS' || uppercaseType === 'TAKE_PROFIT') {
                        stopPriceIsRequired = true;
                        quantityIsRequired = true;
                        if (market['linear'] || market['inverse']) priceIsRequired = true;
                    } else if (uppercaseType === 'STOP_LOSS_LIMIT' || uppercaseType === 'TAKE_PROFIT_LIMIT') {
                        quantityIsRequired = true;
                        stopPriceIsRequired = true;
                        priceIsRequired = true;
                        timeInForceIsRequired = true;
                    } else if (uppercaseType === 'LIMIT_MAKER') {
                        priceIsRequired = true;
                        quantityIsRequired = true;
                    } else if (uppercaseType === 'STOP') {
                        quantityIsRequired = true;
                        stopPriceIsRequired = true;
                        priceIsRequired = true;
                    } else if (uppercaseType === 'STOP_MARKET' || uppercaseType === 'TAKE_PROFIT_MARKET') {
                        const closePosition = this.safeValue(params, 'closePosition');
                        if (closePosition === undefined) quantityIsRequired = true;
                        stopPriceIsRequired = true;
                    } else if (uppercaseType === 'TRAILING_STOP_MARKET') {
                        quantityIsRequired = true;
                        const callbackRate = this.safeNumber(params, 'callbackRate');
                        if (callbackRate === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a callbackRate extra param for a ' + type + ' order');
                    }
                    if (quantityIsRequired) request['quantity'] = this.amountToPrecision(symbol, amount);
                    if (priceIsRequired) {
                        if (price === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a price argument for a ' + type + ' order');
                        request['price'] = this.priceToPrecision(symbol, price);
                    }
                    if (timeInForceIsRequired) request['timeInForce'] = this.options['defaultTimeInForce']; // 'GTC' = Good To Cancel (default), 'IOC' = Immediate Or Cancel
                    if (stopPriceIsRequired) {
                        if (stopPrice === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a stopPrice extra param for a ' + type + ' order');
                        else request['stopPrice'] = this.priceToPrecision(symbol, stopPrice);
                    }
                    const response = await this[method](this.extend(request, params));
                    return this.parseOrder(response, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const defaultType = this.safeString2(this.options, 'fetchOrder', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    let method = 'privateGetOrder';
                    if (type === 'future') method = 'fapiPrivateGetOrder';
                    else if (type === 'delivery') method = 'dapiPrivateGetOrder';
                    else if (type === 'margin') method = 'sapiGetMarginOrder';
                    const request = {
                        'symbol': market['id']
                    };
                    const clientOrderId = this.safeValue2(params, 'origClientOrderId', 'clientOrderId');
                    if (clientOrderId !== undefined) request['origClientOrderId'] = clientOrderId;
                    else request['orderId'] = id;
                    const query = this.omit(params, [
                        'type',
                        'clientOrderId',
                        'origClientOrderId'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    return this.parseOrder(response, market);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const defaultType = this.safeString2(this.options, 'fetchOrders', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    let method = 'privateGetAllOrders';
                    if (type === 'future') method = 'fapiPrivateGetAllOrders';
                    else if (type === 'delivery') method = 'dapiPrivateGetAllOrders';
                    else if (type === 'margin') method = 'sapiGetMarginAllOrders';
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const query = this.omit(params, 'type');
                    const response = await this[method](this.extend(request, query));
                    //
                    //  spot
                    //
                    //     [
                    //         {
                    //             "symbol": "LTCBTC",
                    //             "orderId": 1,
                    //             "clientOrderId": "myOrder1",
                    //             "price": "0.1",
                    //             "origQty": "1.0",
                    //             "executedQty": "0.0",
                    //             "cummulativeQuoteQty": "0.0",
                    //             "status": "NEW",
                    //             "timeInForce": "GTC",
                    //             "type": "LIMIT",
                    //             "side": "BUY",
                    //             "stopPrice": "0.0",
                    //             "icebergQty": "0.0",
                    //             "time": 1499827319559,
                    //             "updateTime": 1499827319559,
                    //             "isWorking": true
                    //         }
                    //     ]
                    //
                    //  futures
                    //
                    //     [
                    //         {
                    //             "symbol": "BTCUSDT",
                    //             "orderId": 1,
                    //             "clientOrderId": "myOrder1",
                    //             "price": "0.1",
                    //             "origQty": "1.0",
                    //             "executedQty": "1.0",
                    //             "cumQuote": "10.0",
                    //             "status": "NEW",
                    //             "timeInForce": "GTC",
                    //             "type": "LIMIT",
                    //             "side": "BUY",
                    //             "stopPrice": "0.0",
                    //             "updateTime": 1499827319559
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    let query = undefined;
                    let type = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                        const defaultType = this.safeString2(this.options, 'fetchOpenOrders', 'defaultType', 'spot');
                        const marketType = 'type' in market ? market['type'] : defaultType;
                        type = this.safeString(params, 'type', marketType);
                        query = this.omit(params, 'type');
                    } else if (this.options['warnOnFetchOpenOrdersWithoutSymbol']) {
                        const symbols = this.symbols;
                        const numSymbols = symbols.length;
                        const fetchOpenOrdersRateLimit = parseInt(numSymbols / 2);
                        throw new ExchangeError1(this.id + ' fetchOpenOrders() WARNING: fetching open orders without specifying a symbol is rate-limited to one call per ' + fetchOpenOrdersRateLimit.toString() + ' seconds. Do not call this method frequently to avoid ban. Set ' + this.id + '.options["warnOnFetchOpenOrdersWithoutSymbol"] = false to suppress this warning message.');
                    } else {
                        const defaultType = this.safeString2(this.options, 'fetchOpenOrders', 'defaultType', 'spot');
                        type = this.safeString(params, 'type', defaultType);
                        query = this.omit(params, 'type');
                    }
                    let method = 'privateGetOpenOrders';
                    if (type === 'future') method = 'fapiPrivateGetOpenOrders';
                    else if (type === 'delivery') method = 'dapiPrivateGetOpenOrders';
                    else if (type === 'margin') method = 'sapiGetMarginOpenOrders';
                    const response = await this[method](this.extend(request, query));
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const orders = await this.fetchOrders(symbol, since, limit, params);
                    return this.filterBy(orders, 'status', 'closed');
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const defaultType = this.safeString2(this.options, 'fetchOpenOrders', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    // https://github.com/ccxt/ccxt/issues/6507
                    const origClientOrderId = this.safeValue2(params, 'origClientOrderId', 'clientOrderId');
                    const request = {
                        'symbol': market['id']
                    };
                    if (origClientOrderId === undefined) request['orderId'] = id;
                    else request['origClientOrderId'] = origClientOrderId;
                    let method = 'privateDeleteOrder';
                    if (type === 'future') method = 'fapiPrivateDeleteOrder';
                    else if (type === 'delivery') method = 'dapiPrivateDeleteOrder';
                    else if (type === 'margin') method = 'sapiDeleteMarginOrder';
                    const query = this.omit(params, [
                        'type',
                        'origClientOrderId',
                        'clientOrderId'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    return this.parseOrder(response, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelAllOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const defaultType = this.safeString2(this.options, 'cancelAllOrders', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    let method = 'privateDeleteOpenOrders';
                    if (type === 'margin') method = 'sapiDeleteMarginOpenOrders';
                    else if (type === 'future') method = 'fapiPrivateDeleteAllOpenOrders';
                    else if (type === 'delivery') method = 'dapiPrivateDeleteAllOpenOrders';
                    const response = await this[method](this.extend(request, query));
                    if (Array.isArray(response)) return this.parseOrders(response, market);
                    else return response;
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrderTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const type = this.safeString(params, 'type', market['type']);
                    params = this.omit(params, 'type');
                    if (type !== 'spot') throw new NotSupported(this.id + ' fetchOrderTrades() supports spot markets only');
                    const request = {
                        'orderId': id
                    };
                    return await this.fetchMyTrades(symbol, since, limit, this.extend(request, params));
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const type = this.safeString(params, 'type', market['type']);
                    params = this.omit(params, 'type');
                    let method = undefined;
                    if (type === 'spot') method = 'privateGetMyTrades';
                    else if (type === 'margin') method = 'sapiGetMarginMyTrades';
                    else if (type === 'future') method = 'fapiPrivateGetUserTrades';
                    else if (type === 'delivery') method = 'dapiPrivateGetUserTrades';
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot trade
                    //
                    //     [
                    //         {
                    //             "symbol": "BNBBTC",
                    //             "id": 28457,
                    //             "orderId": 100234,
                    //             "price": "4.00000100",
                    //             "qty": "12.00000000",
                    //             "commission": "10.10000000",
                    //             "commissionAsset": "BNB",
                    //             "time": 1499865549590,
                    //             "isBuyer": true,
                    //             "isMaker": false,
                    //             "isBestMatch": true,
                    //         }
                    //     ]
                    //
                    // futures trade
                    //
                    //     [
                    //         {
                    //             "accountId": 20,
                    //             "buyer": False,
                    //             "commission": "-0.07819010",
                    //             "commissionAsset": "USDT",
                    //             "counterPartyId": 653,
                    //             "id": 698759,
                    //             "maker": False,
                    //             "orderId": 25851813,
                    //             "price": "7819.01",
                    //             "qty": "0.002",
                    //             "quoteQty": "0.01563",
                    //             "realizedPnl": "-0.91539999",
                    //             "side": "SELL",
                    //             "symbol": "BTCUSDT",
                    //             "time": 1569514978020
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchMyDustTrades(symbol, since, limit, params = {}) {
                    //
                    // Binance provides an opportunity to trade insignificant (i.e. non-tradable and non-withdrawable)
                    // token leftovers (of any asset) into `BNB` coin which in turn can be used to pay trading fees with it.
                    // The corresponding trades history is called the `Dust Log` and can be requested via the following end-point:
                    // https://github.com/binance-exchange/binance-official-api-docs/blob/master/wapi-api.md#dustlog-user_data
                    //
                    await this.loadMarkets();
                    const request = {};
                    if (since !== undefined) {
                        request['startTime'] = since;
                        request['endTime'] = this.sum(since, 7776000000);
                    }
                    const response = await this.sapiGetAssetDribblet(this.extend(request, params));
                    //     {
                    //       "total": "4",
                    //       "userAssetDribblets": [
                    //         {
                    //           "operateTime": "1627575731000",
                    //           "totalServiceChargeAmount": "0.00001453",
                    //           "totalTransferedAmount": "0.00072693",
                    //           "transId": "70899815863",
                    //           "userAssetDribbletDetails": [
                    //             {
                    //               "fromAsset": "LTC",
                    //               "amount": "0.000006",
                    //               "transferedAmount": "0.00000267",
                    //               "serviceChargeAmount": "0.00000005",
                    //               "operateTime": "1627575731000",
                    //               "transId": "70899815863"
                    //             },
                    //             {
                    //               "fromAsset": "GBP",
                    //               "amount": "0.15949157",
                    //               "transferedAmount": "0.00072426",
                    //               "serviceChargeAmount": "0.00001448",
                    //               "operateTime": "1627575731000",
                    //               "transId": "70899815863"
                    //             }
                    //           ]
                    //         },
                    //       ]
                    //     }
                    const results = this.safeValue(response, 'userAssetDribblets', []);
                    const rows = this.safeInteger(response, 'total', 0);
                    const data = [];
                    for(let i = 0; i < rows; i++){
                        const logs = this.safeValue(results[i], 'userAssetDribbletDetails', []);
                        for(let j = 0; j < logs.length; j++){
                            logs[j]['isDustTrade'] = true;
                            data.push(logs[j]);
                        }
                    }
                    const trades = this.parseTrades(data, undefined, since, limit);
                    return this.filterBySinceLimit(trades, since, limit);
                }
                parseDustTrade(trade, market) {
                    //
                    //     {
                    //       "fromAsset": "USDT",
                    //       "amount": "0.009669",
                    //       "transferedAmount": "0.00002992",
                    //       "serviceChargeAmount": "0.00000059",
                    //       "operateTime": "1628076010000",
                    //       "transId": "71416578712",
                    //       "isDustTrade": true
                    //     }
                    //
                    const orderId = this.safeString(trade, 'transId');
                    const timestamp = this.safeInteger(trade, 'operateTime');
                    const currencyId = this.safeString(trade, 'fromAsset');
                    const tradedCurrency = this.safeCurrencyCode(currencyId);
                    const bnb = this.currency('BNB');
                    const earnedCurrency = bnb['code'];
                    const applicantSymbol = earnedCurrency + '/' + tradedCurrency;
                    let tradedCurrencyIsQuote = false;
                    if (applicantSymbol in this.markets) tradedCurrencyIsQuote = true;
                    const feeCostString = this.safeString(trade, 'serviceChargeAmount');
                    const fee = {
                        'currency': earnedCurrency,
                        'cost': this.parseNumber(feeCostString)
                    };
                    let symbol = undefined;
                    let amountString = undefined;
                    let costString = undefined;
                    let side = undefined;
                    if (tradedCurrencyIsQuote) {
                        symbol = applicantSymbol;
                        amountString = this.safeString(trade, 'transferedAmount');
                        costString = this.safeString(trade, 'amount');
                        side = 'buy';
                    } else {
                        symbol = tradedCurrency + '/' + earnedCurrency;
                        amountString = this.safeString(trade, 'amount');
                        costString = this.safeString(trade, 'transferedAmount');
                        side = 'sell';
                    }
                    let priceString = undefined;
                    if (costString !== undefined) {
                        if (amountString) priceString = Precise.stringDiv(costString, amountString);
                    }
                    const id = undefined;
                    const amount = this.parseNumber(amountString);
                    const price = this.parseNumber(priceString);
                    const cost = this.parseNumber(costString);
                    const type = undefined;
                    const takerOrMaker = undefined;
                    return {
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': orderId,
                        'type': type,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'amount': amount,
                        'price': price,
                        'cost': cost,
                        'fee': fee,
                        'info': trade
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    let response = undefined;
                    const request = {};
                    const legalMoney = this.safeValue(this.options, 'legalMoney', {});
                    if (code in legalMoney) {
                        if (code !== undefined) currency = this.currency(code);
                        request['transactionType'] = 0;
                        if (since !== undefined) request['beginTime'] = since;
                        const raw = await this.sapiGetFiatOrders(this.extend(request, params));
                        response = this.safeValue(raw, 'data');
                    //     {
                    //       "code": "000000",
                    //       "message": "success",
                    //       "data": [
                    //         {
                    //           "orderNo": "25ced37075c1470ba8939d0df2316e23",
                    //           "fiatCurrency": "EUR",
                    //           "indicatedAmount": "15.00",
                    //           "amount": "15.00",
                    //           "totalFee": "0.00",
                    //           "method": "card",
                    //           "status": "Failed",
                    //           "createTime": 1627501026000,
                    //           "updateTime": 1627501027000
                    //         }
                    //       ],
                    //       "total": 1,
                    //       "success": true
                    //     }
                    } else {
                        if (code !== undefined) {
                            currency = this.currency(code);
                            request['coin'] = currency['id'];
                        }
                        if (since !== undefined) {
                            request['startTime'] = since;
                            // max 3 months range https://github.com/ccxt/ccxt/issues/6495
                            request['endTime'] = this.sum(since, 7776000000);
                        }
                        if (limit !== undefined) request['limit'] = limit;
                        response = await this.sapiGetCapitalDepositHisrec(this.extend(request, params));
                    //     [
                    //       {
                    //         "amount": "0.01844487",
                    //         "coin": "BCH",
                    //         "network": "BCH",
                    //         "status": 1,
                    //         "address": "1NYxAJhW2281HK1KtJeaENBqHeygA88FzR",
                    //         "addressTag": "",
                    //         "txId": "bafc5902504d6504a00b7d0306a41154cbf1d1b767ab70f3bc226327362588af",
                    //         "insertTime": 1610784980000,
                    //         "transferType": 0,
                    //         "confirmTimes": "2/2"
                    //       },
                    //       {
                    //         "amount": "4500",
                    //         "coin": "USDT",
                    //         "network": "BSC",
                    //         "status": 1,
                    //         "address": "0xc9c923c87347ca0f3451d6d308ce84f691b9f501",
                    //         "addressTag": "",
                    //         "txId": "Internal transfer 51376627901",
                    //         "insertTime": 1618394381000,
                    //         "transferType": 1,
                    //         "confirmTimes": "1/15"
                    //     }
                    //   ]
                    }
                    return this.parseTransactions(response, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const legalMoney = this.safeValue(this.options, 'legalMoney', {});
                    const request = {};
                    let response = undefined;
                    let currency = undefined;
                    if (code in legalMoney) {
                        if (code !== undefined) currency = this.currency(code);
                        request['transactionType'] = 1;
                        if (since !== undefined) request['beginTime'] = since;
                        const raw = await this.sapiGetFiatOrders(this.extend(request, params));
                        response = this.safeValue(raw, 'data');
                    //     {
                    //       "code": "000000",
                    //       "message": "success",
                    //       "data": [
                    //         {
                    //           "orderNo": "CJW706452266115170304",
                    //           "fiatCurrency": "GBP",
                    //           "indicatedAmount": "10001.50",
                    //           "amount": "100.00",
                    //           "totalFee": "1.50",
                    //           "method": "bank transfer",
                    //           "status": "Successful",
                    //           "createTime": 1620037745000,
                    //           "updateTime": 1620038480000
                    //         },
                    //         {
                    //           "orderNo": "CJW706287492781891584",
                    //           "fiatCurrency": "GBP",
                    //           "indicatedAmount": "10001.50",
                    //           "amount": "100.00",
                    //           "totalFee": "1.50",
                    //           "method": "bank transfer",
                    //           "status": "Successful",
                    //           "createTime": 1619998460000,
                    //           "updateTime": 1619998823000
                    //         }
                    //       ],
                    //       "total": 39,
                    //       "success": true
                    //     }
                    } else {
                        if (code !== undefined) {
                            currency = this.currency(code);
                            request['coin'] = currency['id'];
                        }
                        if (since !== undefined) {
                            request['startTime'] = since;
                            // max 3 months range https://github.com/ccxt/ccxt/issues/6495
                            request['endTime'] = this.sum(since, 7776000000);
                        }
                        if (limit !== undefined) request['limit'] = limit;
                        response = await this.sapiGetCapitalWithdrawHistory(this.extend(request, params));
                    //     [
                    //       {
                    //         "id": "69e53ad305124b96b43668ceab158a18",
                    //         "amount": "28.75",
                    //         "transactionFee": "0.25",
                    //         "coin": "XRP",
                    //         "status": 6,
                    //         "address": "r3T75fuLjX51mmfb5Sk1kMNuhBgBPJsjza",
                    //         "addressTag": "101286922",
                    //         "txId": "19A5B24ED0B697E4F0E9CD09FCB007170A605BC93C9280B9E6379C5E6EF0F65A",
                    //         "applyTime": "2021-04-15 12:09:16",
                    //         "network": "XRP",
                    //         "transferType": 0
                    //       },
                    //       {
                    //         "id": "9a67628b16ba4988ae20d329333f16bc",
                    //         "amount": "20",
                    //         "transactionFee": "20",
                    //         "coin": "USDT",
                    //         "status": 6,
                    //         "address": "0x0AB991497116f7F5532a4c2f4f7B1784488628e1",
                    //         "txId": "0x77fbf2cf2c85b552f0fd31fd2e56dc95c08adae031d96f3717d8b17e1aea3e46",
                    //         "applyTime": "2021-04-15 12:06:53",
                    //         "network": "ETH",
                    //         "transferType": 0
                    //       },
                    //       {
                    //         "id": "a7cdc0afbfa44a48bd225c9ece958fe2",
                    //         "amount": "51",
                    //         "transactionFee": "1",
                    //         "coin": "USDT",
                    //         "status": 6,
                    //         "address": "TYDmtuWL8bsyjvcauUTerpfYyVhFtBjqyo",
                    //         "txId": "168a75112bce6ceb4823c66726ad47620ad332e69fe92d9cb8ceb76023f9a028",
                    //         "applyTime": "2021-04-13 12:46:59",
                    //         "network": "TRX",
                    //         "transferType": 0
                    //       }
                    //     ]
                    }
                    return this.parseTransactions(response, currency, since, limit);
                }
                parseTransactionStatusByType(status, type) {
                    const statusesByType = {
                        'deposit': {
                            '0': 'pending',
                            '1': 'ok',
                            // Fiat
                            // Processing, Failed, Successful, Finished, Refunding, Refunded, Refund Failed, Order Partial credit Stopped
                            'Processing': 'pending',
                            'Failed': 'failed',
                            'Successful': 'ok',
                            'Refunding': 'canceled',
                            'Refunded': 'canceled',
                            'Refund Failed': 'failed'
                        },
                        'withdrawal': {
                            '0': 'pending',
                            '1': 'canceled',
                            '2': 'pending',
                            '3': 'failed',
                            '4': 'pending',
                            '5': 'failed',
                            '6': 'ok',
                            // Fiat
                            // Processing, Failed, Successful, Finished, Refunding, Refunded, Refund Failed, Order Partial credit Stopped
                            'Processing': 'pending',
                            'Failed': 'failed',
                            'Successful': 'ok',
                            'Refunding': 'canceled',
                            'Refunded': 'canceled',
                            'Refund Failed': 'failed'
                        }
                    };
                    const statuses = this.safeValue(statusesByType, type, {});
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //       "amount": "4500",
                    //       "coin": "USDT",
                    //       "network": "BSC",
                    //       "status": 1,
                    //       "address": "0xc9c923c87347ca0f3451d6d308ce84f691b9f501",
                    //       "addressTag": "",
                    //       "txId": "Internal transfer 51376627901",
                    //       "insertTime": 1618394381000,
                    //       "transferType": 1,
                    //       "confirmTimes": "1/15"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //       "id": "69e53ad305124b96b43668ceab158a18",
                    //       "amount": "28.75",
                    //       "transactionFee": "0.25",
                    //       "coin": "XRP",
                    //       "status": 6,
                    //       "address": "r3T75fuLjX51mmfb5Sk1kMNuhBgBPJsjza",
                    //       "addressTag": "101286922",
                    //       "txId": "19A5B24ED0B697E4F0E9CD09FCB007170A605BC93C9280B9E6379C5E6EF0F65A",
                    //       "applyTime": "2021-04-15 12:09:16",
                    //       "network": "XRP",
                    //       "transferType": 0
                    //     }
                    //
                    // fiat transaction
                    // withdraw
                    //     {
                    //       "orderNo": "CJW684897551397171200",
                    //       "fiatCurrency": "GBP",
                    //       "indicatedAmount": "29.99",
                    //       "amount": "28.49",
                    //       "totalFee": "1.50",
                    //       "method": "bank transfer",
                    //       "status": "Successful",
                    //       "createTime": 1614898701000,
                    //       "updateTime": 1614898820000
                    //     }
                    //
                    // deposit
                    //     {
                    //       "orderNo": "25ced37075c1470ba8939d0df2316e23",
                    //       "fiatCurrency": "EUR",
                    //       "indicatedAmount": "15.00",
                    //       "amount": "15.00",
                    //       "totalFee": "0.00",
                    //       "method": "card",
                    //       "status": "Failed",
                    //       "createTime": "1627501026000",
                    //       "updateTime": "1627501027000"
                    //     }
                    //
                    // withdraw
                    //
                    //    { id: '9a67628b16ba4988ae20d329333f16bc' }
                    //
                    const id = this.safeString2(transaction, 'id', 'orderNo');
                    const address = this.safeString(transaction, 'address');
                    let tag = this.safeString(transaction, 'addressTag'); // set but unused
                    if (tag !== undefined) {
                        if (tag.length < 1) tag = undefined;
                    }
                    let txid = this.safeString(transaction, 'txId');
                    if (txid !== undefined && txid.indexOf('Internal transfer ') >= 0) txid = txid.slice(18);
                    const currencyId = this.safeString2(transaction, 'coin', 'fiatCurrency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    let timestamp = undefined;
                    const insertTime = this.safeInteger2(transaction, 'insertTime', 'createTime');
                    const applyTime = this.parse8601(this.safeString(transaction, 'applyTime'));
                    let type = this.safeString(transaction, 'type');
                    if (type === undefined) {
                        if (insertTime !== undefined && applyTime === undefined) {
                            type = 'deposit';
                            timestamp = insertTime;
                        } else if (insertTime === undefined && applyTime !== undefined) {
                            type = 'withdrawal';
                            timestamp = applyTime;
                        }
                    }
                    const status = this.parseTransactionStatusByType(this.safeString(transaction, 'status'), type);
                    const amount = this.safeNumber(transaction, 'amount');
                    const feeCost = this.safeNumber2(transaction, 'transactionFee', 'totalFee');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'currency': code,
                        'cost': feeCost
                    };
                    const updated = this.safeInteger2(transaction, 'successTime', 'updateTime');
                    let internal = this.safeInteger(transaction, 'transferType');
                    if (internal !== undefined) internal = internal ? true : false;
                    const network = this.safeString(transaction, 'network');
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'internal': internal,
                        'fee': fee
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'CONFIRMED': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransfer(transfer, currency) {
                    //
                    // transfer
                    //
                    //     {
                    //         "tranId":13526853623
                    //     }
                    //
                    // fetchTransfers
                    //
                    //     {
                    //         timestamp: 1614640878000,
                    //         asset: 'USDT',
                    //         amount: '25',
                    //         type: 'MAIN_UMFUTURE',
                    //         status: 'CONFIRMED',
                    //         tranId: 43000126248
                    //     }
                    //
                    const id = this.safeString(transfer, 'tranId');
                    const currencyId = this.safeString(transfer, 'asset');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const amount = this.safeNumber(transfer, 'amount');
                    const type = this.safeString(transfer, 'type');
                    let fromAccount = undefined;
                    let toAccount = undefined;
                    const accountsById = this.safeValue(this.options, 'accountsById', {});
                    if (type !== undefined) {
                        const parts = type.split('_');
                        fromAccount = this.safeValue(parts, 0);
                        toAccount = this.safeValue(parts, 1);
                        fromAccount = this.safeString(accountsById, fromAccount, fromAccount);
                        toAccount = this.safeString(accountsById, toAccount, toAccount);
                    }
                    const timestamp = this.safeInteger(transfer, 'timestamp');
                    const status = this.parseTransferStatus(this.safeString(transfer, 'status'));
                    return {
                        'info': transfer,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': code,
                        'amount': amount,
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'status': status
                    };
                }
                parseIncome(income, market) {
                    //
                    //     {
                    //       "symbol": "ETHUSDT",
                    //       "incomeType": "FUNDING_FEE",
                    //       "income": "0.00134317",
                    //       "asset": "USDT",
                    //       "time": "1621584000000",
                    //       "info": "FUNDING_FEE",
                    //       "tranId": "4480321991774044580",
                    //       "tradeId": ""
                    //     }
                    //
                    const marketId = this.safeString(income, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const amount = this.safeNumber(income, 'income');
                    const currencyId = this.safeString(income, 'asset');
                    const code = this.safeCurrencyCode(currencyId);
                    const id = this.safeString(income, 'tranId');
                    const timestamp = this.safeInteger(income, 'time');
                    return {
                        'info': income,
                        'symbol': symbol,
                        'code': code,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'id': id,
                        'amount': amount
                    };
                }
                parseIncomes(incomes, market, since, limit) {
                    const result = [];
                    for(let i = 0; i < incomes.length; i++){
                        const entry = incomes[i];
                        const parsed = this.parseIncome(entry, market);
                        result.push(parsed);
                    }
                    const sorted = this.sortBy(result, 'timestamp');
                    return this.filterBySinceLimit(sorted, since, limit);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    let type = this.safeString(params, 'type');
                    if (type === undefined) {
                        const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                        const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                        const toId = this.safeString(accountsByType, toAccount, toAccount);
                        type = fromId + '_' + toId;
                    }
                    const request = {
                        'asset': currency['id'],
                        'amount': this.currencyToPrecision(code, amount),
                        'type': type
                    };
                    const response = await this.sapiPostAssetTransfer(this.extend(request, params));
                    //
                    //     {
                    //         "tranId":13526853623
                    //     }
                    //
                    const transfer = this.parseTransfer(response, currency);
                    return this.extend(transfer, {
                        'amount': amount,
                        'currency': code,
                        'fromAccount': fromAccount,
                        'toAccount': toAccount
                    });
                }
                async fetchTransfers(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const defaultType = this.safeString2(this.options, 'fetchTransfers', 'defaultType', 'spot');
                    const fromAccount = this.safeString(params, 'fromAccount', defaultType);
                    const defaultTo = fromAccount === 'future' ? 'spot' : 'future';
                    const toAccount = this.safeString(params, 'toAccount', defaultTo);
                    let type = this.safeString(params, 'type');
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsByType, fromAccount);
                    const toId = this.safeString(accountsByType, toAccount);
                    if (type === undefined) {
                        if (fromId === undefined) {
                            const keys = Object.keys(accountsByType);
                            throw new ExchangeError1(this.id + ' fromAccount parameter must be one of ' + keys.join(', '));
                        }
                        if (toId === undefined) {
                            const keys = Object.keys(accountsByType);
                            throw new ExchangeError1(this.id + ' toAccount parameter must be one of ' + keys.join(', '));
                        }
                        type = fromId + '_' + toId;
                    }
                    const request = {
                        'type': type
                    };
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this.sapiGetAssetTransfer(this.extend(request, params));
                    //
                    //     {
                    //         total: 3,
                    //         rows: [
                    //             {
                    //                 timestamp: 1614640878000,
                    //                 asset: 'USDT',
                    //                 amount: '25',
                    //                 type: 'MAIN_UMFUTURE',
                    //                 status: 'CONFIRMED',
                    //                 tranId: 43000126248
                    //             },
                    //         ]
                    //     }
                    //
                    const rows = this.safeValue(response, 'rows', []);
                    return this.parseTransfers(rows, currency, since, limit);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin': currency['id']
                    };
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeString(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['network'] = network;
                        params = this.omit(params, 'network');
                    }
                    // has support for the 'network' parameter
                    // https://binance-docs.github.io/apidocs/spot/en/#deposit-address-supporting-network-user_data
                    const response = await this.sapiGetCapitalDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         currency: 'XRP',
                    //         address: 'rEb8TK3gBgk5auZkwc6sHnwrGVJH8DuaLh',
                    //         tag: '108618262',
                    //         info: {
                    //             coin: 'XRP',
                    //             address: 'rEb8TK3gBgk5auZkwc6sHnwrGVJH8DuaLh',
                    //             tag: '108618262',
                    //             url: 'https://bithomp.com/explorer/rEb8TK3gBgk5auZkwc6sHnwrGVJH8DuaLh'
                    //         }
                    //     }
                    //
                    const address = this.safeString(response, 'address');
                    const url = this.safeString(response, 'url');
                    let impliedNetwork = undefined;
                    if (url !== undefined) {
                        const reverseNetworks = this.safeValue(this.options, 'reverseNetworks', {});
                        const parts = url.split('/');
                        let topLevel = this.safeString(parts, 2);
                        if (topLevel === 'blockchair.com' || topLevel === 'viewblock.io') {
                            const subLevel = this.safeString(parts, 3);
                            if (subLevel !== undefined) topLevel = topLevel + '/' + subLevel;
                        }
                        impliedNetwork = this.safeString(reverseNetworks, topLevel);
                        const impliedNetworks = this.safeValue(this.options, 'impliedNetworks', {
                            'ETH': {
                                'ERC20': 'ETH'
                            },
                            'TRX': {
                                'TRC20': 'TRX'
                            }
                        });
                        if (code in impliedNetworks) {
                            const conversion = this.safeValue(impliedNetworks, code, {});
                            impliedNetwork = this.safeString(conversion, impliedNetwork, impliedNetwork);
                        }
                    }
                    let tag = this.safeString(response, 'tag', '');
                    if (tag.length === 0) tag = undefined;
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': impliedNetwork,
                        'info': response
                    };
                }
                async fetchFundingFees(codes, params = {}) {
                    await this.loadMarkets();
                    const response = await this.sapiGetCapitalConfigGetall(params);
                    //
                    //  [
                    //     {
                    //       coin: 'BAT',
                    //       depositAllEnable: true,
                    //       withdrawAllEnable: true,
                    //       name: 'Basic Attention Token',
                    //       free: '0',
                    //       locked: '0',
                    //       freeze: '0',
                    //       withdrawing: '0',
                    //       ipoing: '0',
                    //       ipoable: '0',
                    //       storage: '0',
                    //       isLegalMoney: false,
                    //       trading: true,
                    //       networkList: [
                    //         {
                    //           network: 'BNB',
                    //           coin: 'BAT',
                    //           withdrawIntegerMultiple: '0.00000001',
                    //           isDefault: false,
                    //           depositEnable: true,
                    //           withdrawEnable: true,
                    //           depositDesc: '',
                    //           withdrawDesc: '',
                    //           specialTips: 'The name of this asset is Basic Attention Token (BAT). Both a MEMO and an Address are required to successfully deposit your BEP2 tokens to Binance.',
                    //           name: 'BEP2',
                    //           resetAddressStatus: false,
                    //           addressRegex: '^(bnb1)[0-9a-z]{38}$',
                    //           memoRegex: '^[0-9A-Za-z\\-_]{1,120}$',
                    //           withdrawFee: '0.27',
                    //           withdrawMin: '0.54',
                    //           withdrawMax: '10000000000',
                    //           minConfirm: '1',
                    //           unLockConfirm: '0'
                    //         },
                    //         {
                    //           network: 'BSC',
                    //           coin: 'BAT',
                    //           withdrawIntegerMultiple: '0.00000001',
                    //           isDefault: false,
                    //           depositEnable: true,
                    //           withdrawEnable: true,
                    //           depositDesc: '',
                    //           withdrawDesc: '',
                    //           specialTips: 'The name of this asset is Basic Attention Token. Please ensure you are depositing Basic Attention Token (BAT) tokens under the contract address ending in 9766e.',
                    //           name: 'BEP20 (BSC)',
                    //           resetAddressStatus: false,
                    //           addressRegex: '^(0x)[0-9A-Fa-f]{40}$',
                    //           memoRegex: '',
                    //           withdrawFee: '0.27',
                    //           withdrawMin: '0.54',
                    //           withdrawMax: '10000000000',
                    //           minConfirm: '15',
                    //           unLockConfirm: '0'
                    //         },
                    //         {
                    //           network: 'ETH',
                    //           coin: 'BAT',
                    //           withdrawIntegerMultiple: '0.00000001',
                    //           isDefault: true,
                    //           depositEnable: true,
                    //           withdrawEnable: true,
                    //           depositDesc: '',
                    //           withdrawDesc: '',
                    //           specialTips: 'The name of this asset is Basic Attention Token. Please ensure you are depositing Basic Attention Token (BAT) tokens under the contract address ending in 887ef.',
                    //           name: 'ERC20',
                    //           resetAddressStatus: false,
                    //           addressRegex: '^(0x)[0-9A-Fa-f]{40}$',
                    //           memoRegex: '',
                    //           withdrawFee: '27',
                    //           withdrawMin: '54',
                    //           withdrawMax: '10000000000',
                    //           minConfirm: '12',
                    //           unLockConfirm: '0'
                    //         }
                    //       ]
                    //     }
                    //  ]
                    //
                    const withdrawFees = {};
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const currencyId = this.safeString(entry, 'coin');
                        const code = this.safeCurrencyCode(currencyId);
                        const networkList = this.safeValue(entry, 'networkList');
                        withdrawFees[code] = {};
                        for(let j = 0; j < networkList.length; j++){
                            const networkEntry = networkList[j];
                            const networkId = this.safeString(networkEntry, 'network');
                            const networkCode = this.safeCurrencyCode(networkId);
                            const fee = this.safeNumber(networkEntry, 'withdrawFee');
                            withdrawFees[code][networkCode] = fee;
                        }
                    }
                    return {
                        'withdraw': withdrawFees,
                        'deposit': {},
                        'info': response
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin': currency['id'],
                        'address': address,
                        'amount': amount
                    };
                    if (tag !== undefined) request['addressTag'] = tag;
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeString(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['network'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.sapiPostCapitalWithdrawApply(this.extend(request, params));
                    //     { id: '9a67628b16ba4988ae20d329333f16bc' }
                    return this.parseTransaction(response, currency);
                }
                parseTradingFee(fee, market) {
                    //
                    //     {
                    //         "symbol": "ADABNB",
                    //         "makerCommission": 0.001,
                    //         "takerCommission": 0.001
                    //     }
                    //
                    const marketId = this.safeString(fee, 'symbol');
                    const symbol = this.safeSymbol(marketId);
                    return {
                        'info': fee,
                        'symbol': symbol,
                        'maker': this.safeNumber(fee, 'makerCommission'),
                        'taker': this.safeNumber(fee, 'takerCommission')
                    };
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.sapiGetAssetTradeFee(this.extend(request, params));
                    //
                    //     [
                    //       {
                    //         "symbol": "BTCUSDT",
                    //         "makerCommission": "0.001",
                    //         "takerCommission": "0.001"
                    //       }
                    //     ]
                    //
                    const first = this.safeValue(response, 0, {});
                    return this.parseTradingFee(first);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    let method = undefined;
                    const defaultType = this.safeString2(this.options, 'fetchFundingRates', 'defaultType', 'future');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    if (type === 'spot' || type === 'margin') method = 'sapiGetAssetTradeFee';
                    else if (type === 'future') method = 'fapiPrivateGetAccount';
                    else if (type === 'delivery') method = 'dapiPrivateGetAccount';
                    const response = await this[method](query);
                    //
                    // sapi / spot
                    //
                    //    [
                    //       {
                    //         "symbol": "ZRXBNB",
                    //         "makerCommission": "0.001",
                    //         "takerCommission": "0.001"
                    //       },
                    //       {
                    //         "symbol": "ZRXBTC",
                    //         "makerCommission": "0.001",
                    //         "takerCommission": "0.001"
                    //       },
                    //    ]
                    //
                    // fapi / future / linear
                    //
                    //     {
                    //         "feeTier": 0,       // account commisssion tier
                    //         "canTrade": true,   // if can trade
                    //         "canDeposit": true,     // if can transfer in asset
                    //         "canWithdraw": true,    // if can transfer out asset
                    //         "updateTime": 0,
                    //         "totalInitialMargin": "0.00000000",    // total initial margin required with current mark price (useless with isolated positions), only for USDT asset
                    //         "totalMaintMargin": "0.00000000",     // total maintenance margin required, only for USDT asset
                    //         "totalWalletBalance": "23.72469206",     // total wallet balance, only for USDT asset
                    //         "totalUnrealizedProfit": "0.00000000",   // total unrealized profit, only for USDT asset
                    //         "totalMarginBalance": "23.72469206",     // total margin balance, only for USDT asset
                    //         "totalPositionInitialMargin": "0.00000000",    // initial margin required for positions with current mark price, only for USDT asset
                    //         "totalOpenOrderInitialMargin": "0.00000000",   // initial margin required for open orders with current mark price, only for USDT asset
                    //         "totalCrossWalletBalance": "23.72469206",      // crossed wallet balance, only for USDT asset
                    //         "totalCrossUnPnl": "0.00000000",      // unrealized profit of crossed positions, only for USDT asset
                    //         "availableBalance": "23.72469206",       // available balance, only for USDT asset
                    //         "maxWithdrawAmount": "23.72469206"     // maximum amount for transfer out, only for USDT asset
                    //         ...
                    //     }
                    //
                    // dapi / delivery / inverse
                    //
                    //     {
                    //         "canDeposit": true,
                    //         "canTrade": true,
                    //         "canWithdraw": true,
                    //         "feeTier": 2,
                    //         "updateTime": 0
                    //     }
                    //
                    if (type === 'spot' || type === 'margin') {
                        //
                        //    [
                        //       {
                        //         "symbol": "ZRXBNB",
                        //         "makerCommission": "0.001",
                        //         "takerCommission": "0.001"
                        //       },
                        //       {
                        //         "symbol": "ZRXBTC",
                        //         "makerCommission": "0.001",
                        //         "takerCommission": "0.001"
                        //       },
                        //    ]
                        //
                        const result = {};
                        for(let i = 0; i < response.length; i++){
                            const fee = this.parseTradingFee(response[i]);
                            const symbol = fee['symbol'];
                            result[symbol] = fee;
                        }
                        return result;
                    } else if (type === 'future') {
                        //
                        //     {
                        //         "feeTier": 0,       // account commisssion tier
                        //         "canTrade": true,   // if can trade
                        //         "canDeposit": true,     // if can transfer in asset
                        //         "canWithdraw": true,    // if can transfer out asset
                        //         "updateTime": 0,
                        //         "totalInitialMargin": "0.00000000",    // total initial margin required with current mark price (useless with isolated positions), only for USDT asset
                        //         "totalMaintMargin": "0.00000000",     // total maintenance margin required, only for USDT asset
                        //         "totalWalletBalance": "23.72469206",     // total wallet balance, only for USDT asset
                        //         "totalUnrealizedProfit": "0.00000000",   // total unrealized profit, only for USDT asset
                        //         "totalMarginBalance": "23.72469206",     // total margin balance, only for USDT asset
                        //         "totalPositionInitialMargin": "0.00000000",    // initial margin required for positions with current mark price, only for USDT asset
                        //         "totalOpenOrderInitialMargin": "0.00000000",   // initial margin required for open orders with current mark price, only for USDT asset
                        //         "totalCrossWalletBalance": "23.72469206",      // crossed wallet balance, only for USDT asset
                        //         "totalCrossUnPnl": "0.00000000",      // unrealized profit of crossed positions, only for USDT asset
                        //         "availableBalance": "23.72469206",       // available balance, only for USDT asset
                        //         "maxWithdrawAmount": "23.72469206"     // maximum amount for transfer out, only for USDT asset
                        //         ...
                        //     }
                        //
                        const symbols = Object.keys(this.markets);
                        const result = {};
                        const feeTier = this.safeInteger(response, 'feeTier');
                        const feeTiers = this.fees[type]['trading']['tiers'];
                        const maker = feeTiers['maker'][feeTier][1];
                        const taker = feeTiers['taker'][feeTier][1];
                        for(let i = 0; i < symbols.length; i++){
                            const symbol = symbols[i];
                            result[symbol] = {
                                'info': {
                                    'feeTier': feeTier
                                },
                                'symbol': symbol,
                                'maker': maker,
                                'taker': taker
                            };
                        }
                        return result;
                    } else if (type === 'delivery') {
                        //
                        //     {
                        //         "canDeposit": true,
                        //         "canTrade": true,
                        //         "canWithdraw": true,
                        //         "feeTier": 2,
                        //         "updateTime": 0
                        //     }
                        //
                        const symbols = Object.keys(this.markets);
                        const result = {};
                        const feeTier = this.safeInteger(response, 'feeTier');
                        const feeTiers = this.fees[type]['trading']['tiers'];
                        const maker = feeTiers['maker'][feeTier][1];
                        const taker = feeTiers['taker'][feeTier][1];
                        for(let i = 0; i < symbols.length; i++){
                            const symbol = symbols[i];
                            result[symbol] = {
                                'info': {
                                    'feeTier': feeTier
                                },
                                'symbol': symbol,
                                'maker': maker,
                                'taker': taker
                            };
                        }
                        return result;
                    }
                }
                async futuresTransfer(code, amount, type, params = {}) {
                    if (type < 1 || type > 4) throw new ArgumentsRequired1(this.id + ' type must be between 1 and 4');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'asset': currency['id'],
                        'amount': amount,
                        'type': type
                    };
                    const response = await this.sapiPostFuturesTransfer(this.extend(request, params));
                    //
                    //   {
                    //       "tranId": 100000001
                    //   }
                    //
                    return this.parseTransfer(response, currency);
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    let method = undefined;
                    if (market['linear']) method = 'fapiPublicGetPremiumIndex';
                    else if (market['inverse']) method = 'dapiPublicGetPremiumIndex';
                    else throw new NotSupported(this.id + ' fetchFundingRate() supports linear and inverse contracts only');
                    let response = await this[method](this.extend(request, params));
                    if (market['inverse']) response = response[0];
                    //
                    //     {
                    //         "symbol": "BTCUSDT",
                    //         "markPrice": "45802.81129892",
                    //         "indexPrice": "45745.47701915",
                    //         "estimatedSettlePrice": "45133.91753671",
                    //         "lastFundingRate": "0.00063521",
                    //         "interestRate": "0.00010000",
                    //         "nextFundingTime": "1621267200000",
                    //         "time": "1621252344001"
                    //     }
                    //
                    return this.parseFundingRate(response, market);
                }
                async fetchFundingRateHistory(symbol, since, limit, params = {}) {
                    //
                    // Gets a history of funding rates with their timestamps
                    //  (param) symbol: Future currency pair (e.g. "BTC/USDT")
                    //  (param) limit: maximum number of data points returned
                    //  (param) since: Unix timestamp in miliseconds for the time of the earliest requested funding rate
                    //  (param) params: Object containing more params for the request
                    //          - until: Unix timestamp in miliseconds for the time of the earliest requested funding rate
                    //  return: [{symbol, fundingRate, timestamp}]
                    //
                    await this.loadMarkets();
                    const request = {};
                    let method = undefined;
                    const defaultType = this.safeString2(this.options, 'fetchFundingRateHistory', 'defaultType', 'future');
                    const type = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    if (type === 'future') method = 'fapiPublicGetFundingRate';
                    else if (type === 'delivery') method = 'dapiPublicGetFundingRate';
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        symbol = market['symbol'];
                        request['symbol'] = market['id'];
                        if (market['linear']) method = 'fapiPublicGetFundingRate';
                        else if (market['inverse']) method = 'dapiPublicGetFundingRate';
                    }
                    if (method === undefined) throw new NotSupported(this.id + ' fetchFundingRateHistory() not supported for ' + type + ' markets');
                    if (since !== undefined) request['startTime'] = since;
                    const till = this.safeInteger(params, 'till'); // unified in milliseconds
                    const endTime = this.safeString(params, 'endTime', till); // exchange-specific in milliseconds
                    params = this.omit(params, [
                        'endTime',
                        'till'
                    ]);
                    if (endTime !== undefined) request['endTime'] = endTime;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "symbol": "BTCUSDT",
                    //         "fundingRate": "0.00063521",
                    //         "fundingTime": "1621267200000",
                    //     }
                    //
                    const rates = [];
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const timestamp = this.safeInteger(entry, 'fundingTime');
                        rates.push({
                            'info': entry,
                            'symbol': this.safeSymbol(this.safeString(entry, 'symbol')),
                            'fundingRate': this.safeNumber(entry, 'fundingRate'),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp)
                        });
                    }
                    const sorted = this.sortBy(rates, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, symbol, since, limit);
                }
                async fetchFundingRates(symbols, params = {}) {
                    await this.loadMarkets();
                    let method = undefined;
                    const defaultType = this.safeString2(this.options, 'fetchFundingRates', 'defaultType', 'future');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    if (type === 'future') method = 'fapiPublicGetPremiumIndex';
                    else if (type === 'delivery') method = 'dapiPublicGetPremiumIndex';
                    else throw new NotSupported(this.id + ' fetchFundingRates() supports linear and inverse contracts only');
                    const response = await this[method](query);
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const parsed = this.parseFundingRate(entry);
                        result.push(parsed);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                parseFundingRate(premiumIndex, market) {
                    // ensure it matches with https://www.binance.com/en/futures/funding-history/0
                    //
                    //   {
                    //     "symbol": "BTCUSDT",
                    //     "markPrice": "45802.81129892",
                    //     "indexPrice": "45745.47701915",
                    //     "estimatedSettlePrice": "45133.91753671",
                    //     "lastFundingRate": "0.00063521",
                    //     "interestRate": "0.00010000",
                    //     "nextFundingTime": "1621267200000",
                    //     "time": "1621252344001"
                    //  }
                    //
                    const timestamp = this.safeInteger(premiumIndex, 'time');
                    const marketId = this.safeString(premiumIndex, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const markPrice = this.safeNumber(premiumIndex, 'markPrice');
                    const indexPrice = this.safeNumber(premiumIndex, 'indexPrice');
                    const interestRate = this.safeNumber(premiumIndex, 'interestRate');
                    const estimatedSettlePrice = this.safeNumber(premiumIndex, 'estimatedSettlePrice');
                    const fundingRate = this.safeNumber(premiumIndex, 'lastFundingRate');
                    const fundingTime = this.safeInteger(premiumIndex, 'nextFundingTime');
                    return {
                        'info': premiumIndex,
                        'symbol': symbol,
                        'markPrice': markPrice,
                        'indexPrice': indexPrice,
                        'interestRate': interestRate,
                        'estimatedSettlePrice': estimatedSettlePrice,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fundingRate': fundingRate,
                        'fundingTimestamp': fundingTime,
                        'fundingDatetime': this.iso8601(fundingTime),
                        'nextFundingRate': undefined,
                        'nextFundingTimestamp': undefined,
                        'nextFundingDatetime': undefined,
                        'previousFundingRate': undefined,
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                parseAccountPositions(account) {
                    const positions = this.safeValue(account, 'positions');
                    const assets = this.safeValue(account, 'assets');
                    const balances = {};
                    for(let i = 0; i < assets.length; i++){
                        const entry = assets[i];
                        const currencyId = this.safeString(entry, 'asset');
                        const code = this.safeCurrencyCode(currencyId);
                        const crossWalletBalance = this.safeString(entry, 'crossWalletBalance');
                        const crossUnPnl = this.safeString(entry, 'crossUnPnl');
                        balances[code] = {
                            'crossMargin': Precise.stringAdd(crossWalletBalance, crossUnPnl),
                            'crossWalletBalance': crossWalletBalance
                        };
                    }
                    const result = [];
                    for(let i = 0; i < positions.length; i++){
                        const position = positions[i];
                        const marketId = this.safeString(position, 'symbol');
                        const market = this.safeMarket(marketId);
                        const code = this.options['defaultType'] === 'future' ? market['quote'] : market['base'];
                        // sometimes not all the codes are correctly returned...
                        if (code in balances) {
                            const parsed = this.parseAccountPosition(this.extend(position, {
                                'crossMargin': balances[code]['crossMargin'],
                                'crossWalletBalance': balances[code]['crossWalletBalance']
                            }), market);
                            result.push(parsed);
                        }
                    }
                    return result;
                }
                parseAccountPosition(position, market) {
                    //
                    // usdm
                    //    {
                    //       "symbol": "BTCBUSD",
                    //       "initialMargin": "0",
                    //       "maintMargin": "0",
                    //       "unrealizedProfit": "0.00000000",
                    //       "positionInitialMargin": "0",
                    //       "openOrderInitialMargin": "0",
                    //       "leverage": "20",
                    //       "isolated": false,
                    //       "entryPrice": "0.0000",
                    //       "maxNotional": "100000",
                    //       "positionSide": "BOTH",
                    //       "positionAmt": "0.000",
                    //       "notional": "0",
                    //       "isolatedWallet": "0",
                    //       "updateTime": "0",
                    //       "crossMargin": "100.93634809",
                    //     }
                    //
                    // coinm
                    //     {
                    //       "symbol": "BTCUSD_210625",
                    //       "initialMargin": "0.00024393",
                    //       "maintMargin": "0.00002439",
                    //       "unrealizedProfit": "-0.00000163",
                    //       "positionInitialMargin": "0.00024393",
                    //       "openOrderInitialMargin": "0",
                    //       "leverage": "10",
                    //       "isolated": false,
                    //       "positionSide": "BOTH",
                    //       "entryPrice": "41021.20000069",
                    //       "maxQty": "100",
                    //       "notionalValue": "0.00243939",
                    //       "isolatedWallet": "0",
                    //       "crossMargin": "0.314"
                    //       "crossWalletBalance": "34",
                    //     }
                    //
                    const marketId = this.safeString(position, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = this.safeString(market, 'symbol');
                    const leverageString = this.safeString(position, 'leverage');
                    const leverage = parseInt(leverageString);
                    const initialMarginString = this.safeString(position, 'initialMargin');
                    const initialMargin = this.parseNumber(initialMarginString);
                    let initialMarginPercentageString = Precise.stringDiv('1', leverageString, 8);
                    const rational = 1000 % leverage === 0;
                    if (!rational) initialMarginPercentageString = Precise.stringDiv(Precise.stringAdd(initialMarginPercentageString, '1e-8'), '1', 8);
                    // as oppose to notionalValue
                    const usdm = 'notional' in position;
                    const maintenanceMarginString = this.safeString(position, 'maintMargin');
                    const maintenanceMargin = this.parseNumber(maintenanceMarginString);
                    const entryPriceString = this.safeString(position, 'entryPrice');
                    let entryPrice = this.parseNumber(entryPriceString);
                    const notionalString = this.safeString2(position, 'notional', 'notionalValue');
                    const notionalStringAbs = Precise.stringAbs(notionalString);
                    const notional = this.parseNumber(notionalStringAbs);
                    let contractsString = this.safeString(position, 'positionAmt');
                    let contractsStringAbs = Precise.stringAbs(contractsString);
                    if (contractsString === undefined) {
                        const entryNotional = Precise.stringMul(Precise.stringMul(leverageString, initialMarginString), entryPriceString);
                        const contractSize = this.safeString(market, 'contractSize');
                        contractsString = Precise.stringDiv(entryNotional, contractSize);
                        contractsStringAbs = Precise.stringDiv(Precise.stringAdd(contractsString, '0.5'), '1', 0);
                    }
                    const contracts = this.parseNumber(contractsStringAbs);
                    const leverageBrackets = this.safeValue(this.options, 'leverageBrackets', {});
                    const leverageBracket = this.safeValue(leverageBrackets, symbol, []);
                    let maintenanceMarginPercentageString = undefined;
                    for(let i = 0; i < leverageBracket.length; i++){
                        const bracket = leverageBracket[i];
                        if (Precise.stringLt(notionalStringAbs, bracket[0])) break;
                        maintenanceMarginPercentageString = bracket[1];
                    }
                    const maintenanceMarginPercentage = this.parseNumber(maintenanceMarginPercentageString);
                    const unrealizedPnlString = this.safeString(position, 'unrealizedProfit');
                    const unrealizedPnl = this.parseNumber(unrealizedPnlString);
                    let timestamp = this.safeInteger(position, 'updateTime');
                    if (timestamp === 0) timestamp = undefined;
                    const isolated = this.safeValue(position, 'isolated');
                    let marginMode = undefined;
                    let collateralString = undefined;
                    let walletBalance = undefined;
                    if (isolated) {
                        marginMode = 'isolated';
                        walletBalance = this.safeString(position, 'isolatedWallet');
                        collateralString = Precise.stringAdd(walletBalance, unrealizedPnlString);
                    } else {
                        marginMode = 'cross';
                        walletBalance = this.safeString(position, 'crossWalletBalance');
                        collateralString = this.safeString(position, 'crossMargin');
                    }
                    const collateral = this.parseNumber(collateralString);
                    let marginRatio = undefined;
                    let side = undefined;
                    let percentage = undefined;
                    let liquidationPriceStringRaw = undefined;
                    let liquidationPrice = undefined;
                    const contractSize = this.safeValue(market, 'contractSize');
                    const contractSizeString = this.numberToString(contractSize);
                    if (Precise.stringEquals(notionalString, '0')) entryPrice = undefined;
                    else {
                        side = Precise.stringLt(notionalString, '0') ? 'short' : 'long';
                        marginRatio = this.parseNumber(Precise.stringDiv(Precise.stringAdd(Precise.stringDiv(maintenanceMarginString, collateralString), '5e-5'), '1', 4));
                        percentage = this.parseNumber(Precise.stringMul(Precise.stringDiv(unrealizedPnlString, initialMarginString, 4), '100'));
                        if (usdm) {
                            // calculate liquidation price
                            //
                            // liquidationPrice = (walletBalance / (contracts * (±1 + mmp))) + (±entryPrice / (±1 + mmp))
                            //
                            // mmp = maintenanceMarginPercentage
                            // where ± is negative for long and positive for short
                            // TODO: calculate liquidation price for coinm contracts
                            let onePlusMaintenanceMarginPercentageString = undefined;
                            let entryPriceSignString = entryPriceString;
                            if (side === 'short') onePlusMaintenanceMarginPercentageString = Precise.stringAdd('1', maintenanceMarginPercentageString);
                            else {
                                onePlusMaintenanceMarginPercentageString = Precise.stringAdd('-1', maintenanceMarginPercentageString);
                                entryPriceSignString = Precise.stringMul('-1', entryPriceSignString);
                            }
                            const leftSide = Precise.stringDiv(walletBalance, Precise.stringMul(contractsStringAbs, onePlusMaintenanceMarginPercentageString));
                            const rightSide = Precise.stringDiv(entryPriceSignString, onePlusMaintenanceMarginPercentageString);
                            liquidationPriceStringRaw = Precise.stringAdd(leftSide, rightSide);
                        } else {
                            // calculate liquidation price
                            //
                            // liquidationPrice = (contracts * contractSize(±1 - mmp)) / (±1/entryPrice * contracts * contractSize - walletBalance)
                            //
                            let onePlusMaintenanceMarginPercentageString = undefined;
                            let entryPriceSignString = entryPriceString;
                            if (side === 'short') onePlusMaintenanceMarginPercentageString = Precise.stringSub('1', maintenanceMarginPercentageString);
                            else {
                                onePlusMaintenanceMarginPercentageString = Precise.stringSub('-1', maintenanceMarginPercentageString);
                                entryPriceSignString = Precise.stringMul('-1', entryPriceSignString);
                            }
                            const size = Precise.stringMul(contractsStringAbs, contractSizeString);
                            const leftSide = Precise.stringMul(size, onePlusMaintenanceMarginPercentageString);
                            const rightSide = Precise.stringSub(Precise.stringMul(Precise.stringDiv('1', entryPriceSignString), size), walletBalance);
                            liquidationPriceStringRaw = Precise.stringDiv(leftSide, rightSide);
                        }
                        const pricePrecision = market['precision']['price'];
                        const pricePrecisionPlusOne = pricePrecision + 1;
                        const pricePrecisionPlusOneString = pricePrecisionPlusOne.toString();
                        // round half up
                        const rounder = new Precise('5e-' + pricePrecisionPlusOneString);
                        const rounderString = rounder.toString();
                        const liquidationPriceRoundedString = Precise.stringAdd(rounderString, liquidationPriceStringRaw);
                        let truncatedLiquidationPrice = Precise.stringDiv(liquidationPriceRoundedString, '1', pricePrecision);
                        if (truncatedLiquidationPrice[0] === '-') // user cannot be liquidated
                        // since he has more collateral than the size of the position
                        truncatedLiquidationPrice = undefined;
                        liquidationPrice = this.parseNumber(truncatedLiquidationPrice);
                    }
                    const positionSide = this.safeString(position, 'positionSide');
                    const hedged = positionSide !== 'BOTH';
                    return {
                        'info': position,
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'initialMargin': initialMargin,
                        'initialMarginPercentage': this.parseNumber(initialMarginPercentageString),
                        'maintenanceMargin': maintenanceMargin,
                        'maintenanceMarginPercentage': maintenanceMarginPercentage,
                        'entryPrice': entryPrice,
                        'notional': notional,
                        'leverage': this.parseNumber(leverageString),
                        'unrealizedPnl': unrealizedPnl,
                        'contracts': contracts,
                        'contractSize': contractSize,
                        'marginRatio': marginRatio,
                        'liquidationPrice': liquidationPrice,
                        'markPrice': undefined,
                        'collateral': collateral,
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'side': side,
                        'hedged': hedged,
                        'percentage': percentage
                    };
                }
                parsePositionRisk(position, market) {
                    //
                    // usdm
                    //     {
                    //       "symbol": "BTCUSDT",
                    //       "positionAmt": "0.001",
                    //       "entryPrice": "43578.07000",
                    //       "markPrice": "43532.30000000",
                    //       "unRealizedProfit": "-0.04577000",
                    //       "liquidationPrice": "21841.24993976",
                    //       "leverage": "2",
                    //       "maxNotionalValue": "300000000",
                    //       "marginType": "isolated",
                    //       "isolatedMargin": "21.77841506",
                    //       "isAutoAddMargin": "false",
                    //       "positionSide": "BOTH",
                    //       "notional": "43.53230000",
                    //       "isolatedWallet": "21.82418506",
                    //       "updateTime": "1621358023886"
                    //     }
                    //
                    // coinm
                    //     {
                    //       "symbol": "BTCUSD_PERP",
                    //       "positionAmt": "2",
                    //       "entryPrice": "37643.10000021",
                    //       "markPrice": "38103.05510455",
                    //       "unRealizedProfit": "0.00006413",
                    //       "liquidationPrice": "25119.97445760",
                    //       "leverage": "2",
                    //       "maxQty": "1500",
                    //       "marginType": "isolated",
                    //       "isolatedMargin": "0.00274471",
                    //       "isAutoAddMargin": "false",
                    //       "positionSide": "BOTH",
                    //       "notionalValue": "0.00524892",
                    //       "isolatedWallet": "0.00268058"
                    //     }
                    //
                    const marketId = this.safeString(position, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = this.safeString(market, 'symbol');
                    const leverageBrackets = this.safeValue(this.options, 'leverageBrackets', {});
                    const leverageBracket = this.safeValue(leverageBrackets, symbol, []);
                    const notionalString = this.safeString2(position, 'notional', 'notionalValue');
                    const notionalStringAbs = Precise.stringAbs(notionalString);
                    let maintenanceMarginPercentageString = undefined;
                    for(let i = 0; i < leverageBracket.length; i++){
                        const bracket = leverageBracket[i];
                        if (Precise.stringLt(notionalStringAbs, bracket[0])) break;
                        maintenanceMarginPercentageString = bracket[1];
                    }
                    const notional = this.parseNumber(notionalStringAbs);
                    const contractsAbs = Precise.stringAbs(this.safeString(position, 'positionAmt'));
                    const contracts = this.parseNumber(contractsAbs);
                    const unrealizedPnlString = this.safeString(position, 'unRealizedProfit');
                    const unrealizedPnl = this.parseNumber(unrealizedPnlString);
                    const leverageString = this.safeString(position, 'leverage');
                    const leverage = parseInt(leverageString);
                    const liquidationPriceString = this.omitZero(this.safeString(position, 'liquidationPrice'));
                    const liquidationPrice = this.parseNumber(liquidationPriceString);
                    let collateralString = undefined;
                    const marginMode = this.safeString(position, 'marginType');
                    let side = undefined;
                    if (Precise.stringGt(notionalString, '0')) side = 'long';
                    else if (Precise.stringLt(notionalString, '0')) side = 'short';
                    const entryPriceString = this.safeString(position, 'entryPrice');
                    const entryPrice = this.parseNumber(entryPriceString);
                    const contractSize = this.safeValue(market, 'contractSize');
                    const contractSizeString = this.numberToString(contractSize);
                    // as oppose to notionalValue
                    const linear = 'notional' in position;
                    if (marginMode === 'cross') {
                        // calculate collateral
                        const precision = this.safeValue(market, 'precision', {});
                        if (linear) {
                            // walletBalance = (liquidationPrice * (±1 + mmp) ± entryPrice) * contracts
                            let onePlusMaintenanceMarginPercentageString = undefined;
                            let entryPriceSignString = entryPriceString;
                            if (side === 'short') {
                                onePlusMaintenanceMarginPercentageString = Precise.stringAdd('1', maintenanceMarginPercentageString);
                                entryPriceSignString = Precise.stringMul('-1', entryPriceSignString);
                            } else onePlusMaintenanceMarginPercentageString = Precise.stringAdd('-1', maintenanceMarginPercentageString);
                            const inner = Precise.stringMul(liquidationPriceString, onePlusMaintenanceMarginPercentageString);
                            const leftSide = Precise.stringAdd(inner, entryPriceSignString);
                            const pricePrecision = this.safeInteger(precision, 'price');
                            const quotePrecision = this.safeInteger(precision, 'quote', pricePrecision);
                            if (quotePrecision !== undefined) collateralString = Precise.stringDiv(Precise.stringMul(leftSide, contractsAbs), '1', quotePrecision);
                        } else {
                            // walletBalance = (contracts * contractSize) * (±1/entryPrice - (±1 - mmp) / liquidationPrice)
                            let onePlusMaintenanceMarginPercentageString = undefined;
                            let entryPriceSignString = entryPriceString;
                            if (side === 'short') onePlusMaintenanceMarginPercentageString = Precise.stringSub('1', maintenanceMarginPercentageString);
                            else {
                                onePlusMaintenanceMarginPercentageString = Precise.stringSub('-1', maintenanceMarginPercentageString);
                                entryPriceSignString = Precise.stringMul('-1', entryPriceSignString);
                            }
                            const leftSide = Precise.stringMul(contractsAbs, contractSizeString);
                            const rightSide = Precise.stringSub(Precise.stringDiv('1', entryPriceSignString), Precise.stringDiv(onePlusMaintenanceMarginPercentageString, liquidationPriceString));
                            const basePrecision = this.safeInteger(precision, 'base');
                            if (basePrecision !== undefined) collateralString = Precise.stringDiv(Precise.stringMul(leftSide, rightSide), '1', basePrecision);
                        }
                    } else collateralString = this.safeString(position, 'isolatedMargin');
                    collateralString = collateralString === undefined ? '0' : collateralString;
                    const collateral = this.parseNumber(collateralString);
                    const markPrice = this.parseNumber(this.omitZero(this.safeString(position, 'markPrice')));
                    let timestamp = this.safeInteger(position, 'updateTime');
                    if (timestamp === 0) timestamp = undefined;
                    const maintenanceMarginPercentage = this.parseNumber(maintenanceMarginPercentageString);
                    const maintenanceMarginString = Precise.stringMul(maintenanceMarginPercentageString, notionalStringAbs);
                    const maintenanceMargin = this.parseNumber(maintenanceMarginString);
                    let initialMarginPercentageString = Precise.stringDiv('1', leverageString, 8);
                    const rational = 1000 % leverage === 0;
                    if (!rational) initialMarginPercentageString = Precise.stringAdd(initialMarginPercentageString, '1e-8');
                    const initialMarginString = Precise.stringDiv(Precise.stringMul(notionalStringAbs, initialMarginPercentageString), '1', 8);
                    const initialMargin = this.parseNumber(initialMarginString);
                    let marginRatio = undefined;
                    let percentage = undefined;
                    if (!Precise.stringEquals(collateralString, '0')) {
                        marginRatio = this.parseNumber(Precise.stringDiv(Precise.stringAdd(Precise.stringDiv(maintenanceMarginString, collateralString), '5e-5'), '1', 4));
                        percentage = this.parseNumber(Precise.stringMul(Precise.stringDiv(unrealizedPnlString, initialMarginString, 4), '100'));
                    }
                    const positionSide = this.safeString(position, 'positionSide');
                    const hedged = positionSide !== 'BOTH';
                    return {
                        'info': position,
                        'symbol': symbol,
                        'contracts': contracts,
                        'contractSize': contractSize,
                        'unrealizedPnl': unrealizedPnl,
                        'leverage': this.parseNumber(leverageString),
                        'liquidationPrice': liquidationPrice,
                        'collateral': collateral,
                        'notional': notional,
                        'markPrice': markPrice,
                        'entryPrice': entryPrice,
                        'timestamp': timestamp,
                        'initialMargin': initialMargin,
                        'initialMarginPercentage': this.parseNumber(initialMarginPercentageString),
                        'maintenanceMargin': maintenanceMargin,
                        'maintenanceMarginPercentage': maintenanceMarginPercentage,
                        'marginRatio': marginRatio,
                        'datetime': this.iso8601(timestamp),
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'side': side,
                        'hedged': hedged,
                        'percentage': percentage
                    };
                }
                async loadLeverageBrackets(reload = false, params = {}) {
                    await this.loadMarkets();
                    // by default cache the leverage bracket
                    // it contains useful stuff like the maintenance margin and initial margin for positions
                    const leverageBrackets = this.safeValue(this.options, 'leverageBrackets');
                    if (leverageBrackets === undefined || reload) {
                        let method = undefined;
                        const defaultType = this.safeString(this.options, 'defaultType', 'future');
                        const type = this.safeString(params, 'type', defaultType);
                        const query = this.omit(params, 'type');
                        if (type === 'future') method = 'fapiPrivateGetLeverageBracket';
                        else if (type === 'delivery') method = 'dapiPrivateV2GetLeverageBracket';
                        else throw new NotSupported(this.id + ' loadLeverageBrackets() supports linear and inverse contracts only');
                        const response = await this[method](query);
                        this.options['leverageBrackets'] = {};
                        for(let i = 0; i < response.length; i++){
                            const entry = response[i];
                            const marketId = this.safeString(entry, 'symbol');
                            const symbol = this.safeSymbol(marketId);
                            const brackets = this.safeValue(entry, 'brackets');
                            const result = [];
                            for(let j = 0; j < brackets.length; j++){
                                const bracket = brackets[j];
                                const floorValue = this.safeString2(bracket, 'notionalFloor', 'qtyFloor');
                                const maintenanceMarginPercentage = this.safeString(bracket, 'maintMarginRatio');
                                result.push([
                                    floorValue,
                                    maintenanceMarginPercentage
                                ]);
                            }
                            this.options['leverageBrackets'][symbol] = result;
                        }
                    }
                    return this.options['leverageBrackets'];
                }
                async fetchLeverageTiers(symbols, params = {}) {
                    await this.loadMarkets();
                    const [type, query] = this.handleMarketTypeAndParams('fetchLeverageTiers', undefined, params);
                    let method = undefined;
                    if (type === 'future') method = 'fapiPrivateGetLeverageBracket';
                    else if (type === 'delivery') method = 'dapiPrivateV2GetLeverageBracket';
                    else throw new NotSupported(this.id + ' fetchLeverageTiers() supports linear and inverse contracts only');
                    const response = await this[method](query);
                    //
                    // usdm
                    //
                    //    [
                    //        {
                    //            "symbol": "SUSHIUSDT",
                    //            "brackets": [
                    //                {
                    //                    "bracket": 1,
                    //                    "initialLeverage": 50,
                    //                    "notionalCap": 50000,
                    //                    "notionalFloor": 0,
                    //                    "maintMarginRatio": 0.01,
                    //                    "cum": 0.0
                    //                },
                    //                ...
                    //            ]
                    //        }
                    //    ]
                    //
                    // coinm
                    //
                    //     [
                    //         {
                    //             "symbol":"XRPUSD_210326",
                    //             "brackets":[
                    //                 {
                    //                     "bracket":1,
                    //                     "initialLeverage":20,
                    //                     "qtyCap":500000,
                    //                     "qtyFloor":0,
                    //                     "maintMarginRatio":0.0185,
                    //                     "cum":0.0
                    //                 }
                    //             ]
                    //         }
                    //     ]
                    //
                    return this.parseLeverageTiers(response, symbols, 'symbol');
                }
                parseMarketLeverageTiers(info, market) {
                    /**
         * @ignore
         * @method
         * @param {dict} info Exchange response for 1 market
         * @param {dict} market CCXT market
         */ //
                    //    {
                    //        "symbol": "SUSHIUSDT",
                    //        "brackets": [
                    //            {
                    //                "bracket": 1,
                    //                "initialLeverage": 50,
                    //                "notionalCap": 50000,
                    //                "notionalFloor": 0,
                    //                "maintMarginRatio": 0.01,
                    //                "cum": 0.0
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    const marketId = this.safeString(info, 'symbol');
                    const safeSymbol = this.safeSymbol(marketId);
                    market = this.safeMarket(safeSymbol, market);
                    const brackets = this.safeValue(info, 'brackets');
                    const tiers = [];
                    for(let j = 0; j < brackets.length; j++){
                        const bracket = brackets[j];
                        tiers.push({
                            'tier': this.safeNumber(bracket, 'bracket'),
                            'currency': market['quote'],
                            'minNotional': this.safeNumber2(bracket, 'notionalFloor', 'qtyFloor'),
                            'maxNotional': this.safeNumber(bracket, 'notionalCap', 'qtyCap'),
                            'maintenanceMarginRate': this.safeNumber(bracket, 'maintMarginRatio'),
                            'maxLeverage': this.safeNumber(bracket, 'initialLeverage'),
                            'info': bracket
                        });
                    }
                    return tiers;
                }
                async fetchPositions(symbols, params = {}) {
                    const defaultMethod = this.safeString(this.options, 'fetchPositions', 'positionRisk');
                    if (defaultMethod === 'positionRisk') return await this.fetchPositionsRisk(symbols, params);
                    else if (defaultMethod === 'account') return await this.fetchAccountPositions(symbols, params);
                    else throw new NotSupported(this.id + '.options["fetchPositions"] = "' + defaultMethod + '" is invalid, please choose between "account" and "positionRisk"');
                }
                async fetchAccountPositions(symbols, params = {}) {
                    if (symbols !== undefined) {
                        if (!Array.isArray(symbols)) throw new ArgumentsRequired1(this.id + ' fetchPositions() requires an array argument for symbols');
                    }
                    await this.loadMarkets();
                    await this.loadLeverageBrackets();
                    let method = undefined;
                    const defaultType = this.safeString(this.options, 'defaultType', 'future');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    if (type === 'future') method = 'fapiPrivateGetAccount';
                    else if (type === 'delivery') method = 'dapiPrivateGetAccount';
                    else throw new NotSupported(this.id + ' fetchPositions() supports linear and inverse contracts only');
                    const account = await this[method](query);
                    const result = this.parseAccountPositions(account);
                    return this.filterByArray(result, 'symbol', symbols, false);
                }
                async fetchPositionsRisk(symbols, params = {}) {
                    if (symbols !== undefined) {
                        if (!Array.isArray(symbols)) throw new ArgumentsRequired1(this.id + ' fetchPositionsRisk() requires an array argument for symbols');
                    }
                    await this.loadMarkets();
                    await this.loadLeverageBrackets();
                    const request = {};
                    let method = undefined;
                    let defaultType = 'future';
                    defaultType = this.safeString(this.options, 'defaultType', defaultType);
                    const type = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    if (type === 'future' || type === 'linear') method = 'fapiPrivateGetPositionRisk';
                    else if (type === 'delivery' || type === 'inverse') method = 'dapiPrivateGetPositionRisk';
                    else throw NotSupported(this.id + ' fetchPositionsRisk() supports linear and inverse contracts only');
                    const response = await this[method](this.extend(request, params));
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const parsed = this.parsePositionRisk(response[i]);
                        result.push(parsed);
                    }
                    return this.filterByArray(result, 'symbol', symbols, false);
                }
                async fetchFundingHistory(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    let method = undefined;
                    let defaultType = 'future';
                    const request = {
                        'incomeType': 'FUNDING_FEE'
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                        if (market['linear']) defaultType = 'future';
                        else if (market['inverse']) defaultType = 'delivery';
                        else throw NotSupported(this.id + ' fetchFundingHistory() supports linear and inverse contracts only');
                    }
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    defaultType = this.safeString2(this.options, 'fetchFundingHistory', 'defaultType', defaultType);
                    const type = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    if (type === 'future' || type === 'linear') method = 'fapiPrivateGetIncome';
                    else if (type === 'delivery' || type === 'inverse') method = 'dapiPrivateGetIncome';
                    else throw NotSupported(this.id + ' fetchFundingHistory() supports linear and inverse contracts only');
                    const response = await this[method](this.extend(request, params));
                    return this.parseIncomes(response, market, since, limit);
                }
                async setLeverage(leverage, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    // WARNING: THIS WILL INCREASE LIQUIDATION PRICE FOR OPEN ISOLATED LONG POSITIONS
                    // AND DECREASE LIQUIDATION PRICE FOR OPEN ISOLATED SHORT POSITIONS
                    if (leverage < 1 || leverage > 125) throw new BadRequest(this.id + ' leverage should be between 1 and 125');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let method = undefined;
                    if (market['linear']) method = 'fapiPrivatePostLeverage';
                    else if (market['inverse']) method = 'dapiPrivatePostLeverage';
                    else throw new NotSupported(this.id + ' setLeverage() supports linear and inverse contracts only');
                    const request = {
                        'symbol': market['id'],
                        'leverage': leverage
                    };
                    return await this[method](this.extend(request, params));
                }
                async setMarginMode(marginMode, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setMarginMode() requires a symbol argument');
                    //
                    // { "code": -4048 , "msg": "Margin type cannot be changed if there exists position." }
                    //
                    // or
                    //
                    // { "code": 200, "msg": "success" }
                    //
                    marginMode = marginMode.toUpperCase();
                    if (marginMode === 'CROSS') marginMode = 'CROSSED';
                    if (marginMode !== 'ISOLATED' && marginMode !== 'CROSSED') throw new BadRequest(this.id + ' marginMode must be either isolated or cross');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let method = undefined;
                    if (market['linear']) method = 'fapiPrivatePostMarginType';
                    else if (market['inverse']) method = 'dapiPrivatePostMarginType';
                    else throw new NotSupported(this.id + ' setMarginMode() supports linear and inverse contracts only');
                    const request = {
                        'symbol': market['id'],
                        'marginType': marginMode
                    };
                    let response = undefined;
                    try {
                        response = await this[method](this.extend(request, params));
                    } catch (e) {
                        // not an error
                        // https://github.com/ccxt/ccxt/issues/11268
                        // https://github.com/ccxt/ccxt/pull/11624
                        // POST https://fapi.binance.com/fapi/v1/marginType 400 Bad Request
                        // binanceusdm
                        if (e instanceof MarginModeAlreadySet) {
                            const throwMarginModeAlreadySet = this.safeValue(this.options, 'throwMarginModeAlreadySet', false);
                            if (throwMarginModeAlreadySet) throw e;
                            else response = {
                                'code': -4046,
                                'msg': 'No need to change margin type.'
                            };
                        }
                    }
                    return response;
                }
                async setPositionMode(hedged, symbol, params = {}) {
                    const defaultType = this.safeString(this.options, 'defaultType', 'future');
                    const type = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, [
                        'type'
                    ]);
                    let dualSidePosition = undefined;
                    if (hedged) dualSidePosition = 'true';
                    else dualSidePosition = 'false';
                    const request = {
                        'dualSidePosition': dualSidePosition
                    };
                    let method = undefined;
                    if (type === 'delivery') method = 'dapiPrivatePostPositionSideDual';
                    else // default to future
                    method = 'fapiPrivatePostPositionSideDual';
                    //
                    //     {
                    //       "code": 200,
                    //       "msg": "success"
                    //     }
                    //
                    return await this[method](this.extend(request, params));
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    if (!(api in this.urls['api'])) throw new NotSupported(this.id + ' does not have a testnet/sandbox URL for ' + api + ' endpoints');
                    let url = this.urls['api'][api];
                    url += '/' + path;
                    if (api === 'wapi') url += '.html';
                    if (path === 'historicalTrades') {
                        if (this.apiKey) headers = {
                            'X-MBX-APIKEY': this.apiKey
                        };
                        else throw new AuthenticationError(this.id + ' historicalTrades endpoint requires `apiKey` credential');
                    }
                    const userDataStream = path === 'userDataStream' || path === 'listenKey';
                    if (userDataStream) {
                        if (this.apiKey) {
                            // v1 special case for userDataStream
                            headers = {
                                'X-MBX-APIKEY': this.apiKey,
                                'Content-Type': 'application/x-www-form-urlencoded'
                            };
                            if (method !== 'GET') body = this.urlencode(params);
                        } else throw new AuthenticationError(this.id + ' userDataStream endpoint requires `apiKey` credential');
                    } else if (api === 'private' || api === 'sapi' && path !== 'system/status' || api === 'sapiV3' || api === 'wapi' && path !== 'systemStatus' || api === 'dapiPrivate' || api === 'dapiPrivateV2' || api === 'fapiPrivate' || api === 'fapiPrivateV2') {
                        this.checkRequiredCredentials();
                        let query = undefined;
                        const defaultRecvWindow = this.safeInteger(this.options, 'recvWindow');
                        const extendedParams = this.extend({
                            'timestamp': this.nonce()
                        }, params);
                        if (defaultRecvWindow !== undefined) extendedParams['recvWindow'] = defaultRecvWindow;
                        const recvWindow = this.safeInteger(params, 'recvWindow');
                        if (recvWindow !== undefined) extendedParams['recvWindow'] = recvWindow;
                        if (api === 'sapi' && path === 'asset/dust') query = this.urlencodeWithArrayRepeat(extendedParams);
                        else if (path === 'batchOrders' || path.indexOf('sub-account') >= 0 || path === 'capital/withdraw/apply') query = this.rawencode(extendedParams);
                        else query = this.urlencode(extendedParams);
                        const signature = this.hmac(this.encode(query), this.encode(this.secret));
                        query += "&signature=" + signature;
                        headers = {
                            'X-MBX-APIKEY': this.apiKey
                        };
                        if (method === 'GET' || method === 'DELETE' || api === 'wapi') url += '?' + query;
                        else {
                            body = query;
                            headers['Content-Type'] = 'application/x-www-form-urlencoded';
                        }
                    } else if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (code === 418 || code === 429) throw new DDoSProtection(this.id + ' ' + code.toString() + ' ' + reason + ' ' + body);
                    // error response in a form: { "code": -1013, "msg": "Invalid quantity." }
                    // following block cointains legacy checks against message patterns in "msg" property
                    // will switch "code" checks eventually, when we know all of them
                    if (code >= 400) {
                        if (body.indexOf('Price * QTY is zero or less') >= 0) throw new InvalidOrder(this.id + ' order cost = amount * price is zero or less ' + body);
                        if (body.indexOf('LOT_SIZE') >= 0) throw new InvalidOrder(this.id + ' order amount should be evenly divisible by lot size ' + body);
                        if (body.indexOf('PRICE_FILTER') >= 0) throw new InvalidOrder(this.id + ' order price is invalid, i.e. exceeds allowed price precision, exceeds min price or max price limits or is invalid value in general, use this.priceToPrecision (symbol, amount) ' + body);
                    }
                    if (response === undefined) return; // fallback to default error handler
                    // check success value for wapi endpoints
                    // response in format {'msg': 'The coin does not exist.', 'success': true/false}
                    const success = this.safeValue(response, 'success', true);
                    if (!success) {
                        const message = this.safeString(response, 'msg');
                        let parsedMessage = undefined;
                        if (message !== undefined) {
                            try {
                                parsedMessage = JSON.parse(message);
                            } catch (e) {
                                // do nothing
                                parsedMessage = undefined;
                            }
                            if (parsedMessage !== undefined) response = parsedMessage;
                        }
                    }
                    const message = this.safeString(response, 'msg');
                    if (message !== undefined) {
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, this.id + ' ' + message);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, this.id + ' ' + message);
                    }
                    // checks against error codes
                    const error = this.safeString(response, 'code');
                    if (error !== undefined) {
                        // https://github.com/ccxt/ccxt/issues/6501
                        // https://github.com/ccxt/ccxt/issues/7742
                        if (error === '200' || Precise.stringEquals(error, '0')) return undefined;
                        // a workaround for {"code":-2015,"msg":"Invalid API-key, IP, or permissions for action."}
                        // despite that their message is very confusing, it is raised by Binance
                        // on a temporary ban, the API key is valid, but disabled for a while
                        if (error === '-2015' && this.options['hasAlreadyAuthenticatedSuccessfully']) throw new DDoSProtection(this.id + ' temporary banned: ' + body);
                        const feedback = this.id + ' ' + body;
                        if (message === 'No need to change margin type.') // not an error
                        // https://github.com/ccxt/ccxt/issues/11268
                        // https://github.com/ccxt/ccxt/pull/11624
                        // POST https://fapi.binance.com/fapi/v1/marginType 400 Bad Request
                        // binanceusdm {"code":-4046,"msg":"No need to change margin type."}
                        throw new MarginModeAlreadySet(feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], error, feedback);
                        throw new ExchangeError1(feedback);
                    }
                    if (!success) throw new ExchangeError1(this.id + ' ' + body);
                }
                calculateRateLimiterCost(api, method, path, params, config = {}, context = {}) {
                    if ('noCoin' in config && !('coin' in params)) return config['noCoin'];
                    else if ('noSymbol' in config && !('symbol' in params)) return config['noSymbol'];
                    else if ('noPoolId' in config && !('poolId' in params)) return config['noPoolId'];
                    else if ('byLimit' in config && 'limit' in params) {
                        const limit = params['limit'];
                        const byLimit = config['byLimit'];
                        for(let i = 0; i < byLimit.length; i++){
                            const entry = byLimit[i];
                            if (limit <= entry[0]) return entry[1];
                        }
                    }
                    return this.safeInteger(config, 'cost', 1);
                }
                async request(path, api = 'public', method = 'GET', params = {}, headers, body, config = {}, context = {}) {
                    const response = await this.fetch2(path, api, method, params, headers, body, config, context);
                    // a workaround for {"code":-2015,"msg":"Invalid API-key, IP, or permissions for action."}
                    if (api === 'private' || api === 'wapi') this.options['hasAlreadyAuthenticatedSuccessfully'] = true;
                    return response;
                }
                async modifyMarginHelper(symbol, amount, addOrReduce, params = {}) {
                    // used to modify isolated positions
                    let defaultType = this.safeString(this.options, 'defaultType', 'future');
                    if (defaultType === 'spot') defaultType = 'future';
                    const type = this.safeString(params, 'type', defaultType);
                    if (type === 'margin' || type === 'spot') throw new NotSupported(this.id + ' add / reduce margin only supported with type future or delivery');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    amount = this.amountToPrecision(symbol, amount);
                    const request = {
                        'type': addOrReduce,
                        'symbol': market['id'],
                        'amount': amount
                    };
                    let method = undefined;
                    let code = undefined;
                    if (type === 'future') {
                        method = 'fapiPrivatePostPositionMargin';
                        code = market['quote'];
                    } else {
                        method = 'dapiPrivatePostPositionMargin';
                        code = market['base'];
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "code": 200,
                    //         "msg": "Successfully modify position margin.",
                    //         "amount": 0.001,
                    //         "type": 1
                    //     }
                    //
                    return this.extend(this.parseModifyMargin(response, market), {
                        'code': code
                    });
                }
                parseModifyMargin(data, market) {
                    const rawType = this.safeInteger(data, 'type');
                    const resultType = rawType === 1 ? 'add' : 'reduce';
                    const resultAmount = this.safeNumber(data, 'amount');
                    const errorCode = this.safeString(data, 'code');
                    const status = errorCode === '200' ? 'ok' : 'failed';
                    return {
                        'info': data,
                        'type': resultType,
                        'amount': resultAmount,
                        'code': undefined,
                        'symbol': market['symbol'],
                        'status': status
                    };
                }
                async reduceMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 2, params);
                }
                async addMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 1, params);
                }
                async fetchBorrowRate(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'asset': currency['id']
                    };
                    const response = await this.sapiGetMarginInterestRateHistory(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "asset": "USDT",
                    //             "timestamp": 1638230400000,
                    //             "dailyInterestRate": "0.0006",
                    //             "vipLevel": 0
                    //         },
                    //     ]
                    //
                    const rate = this.safeValue(response, 0);
                    return this.parseBorrowRate(rate);
                }
                async fetchBorrowRateHistory(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (limit === undefined) limit = 93;
                    else if (limit > 93) // Binance API says the limit is 100, but "Illegal characters found in a parameter." is returned when limit is > 93
                    throw new BadRequest(this.id + ' fetchBorrowRateHistory() limit parameter cannot exceed 92');
                    const currency = this.currency(code);
                    const request = {
                        'asset': currency['id'],
                        'limit': limit
                    };
                    if (since !== undefined) {
                        request['startTime'] = since;
                        const endTime = this.sum(since, limit * 86400000) - 1; // required when startTime is further than 93 days in the past
                        const now = this.milliseconds();
                        request['endTime'] = Math.min(endTime, now); // cannot have an endTime later than current time
                    }
                    const response = await this.sapiGetMarginInterestRateHistory(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "asset": "USDT",
                    //             "timestamp": 1638230400000,
                    //             "dailyInterestRate": "0.0006",
                    //             "vipLevel": 0
                    //         },
                    //     ]
                    //
                    return this.parseBorrowRateHistory(response);
                }
                parseBorrowRateHistory(response, code, since, limit) {
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const item = response[i];
                        const borrowRate = this.parseBorrowRate(item);
                        result.push(borrowRate);
                    }
                    const sorted = this.sortBy(result, 'timestamp');
                    return this.filterByCurrencySinceLimit(sorted, code, since, limit);
                }
                parseBorrowRate(info, currency) {
                    //
                    //    {
                    //        "asset": "USDT",
                    //        "timestamp": 1638230400000,
                    //        "dailyInterestRate": "0.0006",
                    //        "vipLevel": 0
                    //    }
                    //
                    const timestamp = this.safeNumber(info, 'timestamp');
                    currency = this.safeString(info, 'asset');
                    return {
                        'currency': this.safeCurrencyCode(currency),
                        'rate': this.safeNumber(info, 'dailyInterestRate'),
                        'period': 86400000,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'info': info
                    };
                }
                async createGiftCode(code, amount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    // ensure you have enough token in your funding account before calling this code
                    const request = {
                        'token': currency['id'],
                        'amount': amount
                    };
                    const response = await this.sapiPostGiftcardCreateCode(this.extend(request, params));
                    //
                    //     {
                    //         code: '000000',
                    //         message: 'success',
                    //         data: { referenceNo: '0033002404219823', code: 'AP6EXTLKNHM6CEX7' },
                    //         success: true
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const giftcardCode = this.safeString(data, 'code');
                    const id = this.safeString(data, 'referenceNo');
                    return {
                        'info': response,
                        'id': id,
                        'code': giftcardCode,
                        'currency': code,
                        'amount': amount
                    };
                }
                async redeemGiftCode(giftcardCode, params = {}) {
                    const request = {
                        'code': giftcardCode
                    };
                    const response = await this.sapiPostGiftcardRedeemCode(this.extend(request, params));
                    //
                    //     {
                    //         code: '000000',
                    //         message: 'success',
                    //         data: {
                    //             referenceNo: '0033002404219823',
                    //             identityNo: '10316431732801474560'
                    //         },
                    //         success: true
                    //     }
                    //
                    return response;
                }
                async verifyGiftCode(id, params = {}) {
                    const request = {
                        'referenceNo': id
                    };
                    const response = await this.sapiGetGiftcardVerify(this.extend(request, params));
                    //
                    //     {
                    //         code: '000000',
                    //         message: 'success',
                    //         data: { valid: true },
                    //         success: true
                    //     }
                    //
                    return response;
                }
                async fetchBorrowInterest(code, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (code !== undefined) {
                        const currency = this.currency(code);
                        request['asset'] = currency['id'];
                    }
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['size'] = limit;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['isolatedSymbol'] = market['id'];
                    }
                    const response = await this.sapiGetMarginInterestHistory(this.extend(request, params));
                    //
                    //     {
                    //         "rows":[
                    //             {
                    //                 "isolatedSymbol": "BNBUSDT", // isolated symbol, will not be returned for crossed margin
                    //                 "asset": "BNB",
                    //                 "interest": "0.02414667",
                    //                 "interestAccuredTime": 1566813600000,
                    //                 "interestRate": "0.01600000",
                    //                 "principal": "36.22000000",
                    //                 "type": "ON_BORROW"
                    //             }
                    //         ],
                    //         "total": 1
                    //     }
                    //
                    const rows = this.safeValue(response, 'rows');
                    const interest = this.parseBorrowInterests(rows, market);
                    return this.filterByCurrencySinceLimit(interest, code, since, limit);
                }
                parseBorrowInterest(info, market) {
                    const symbol = this.safeString(info, 'isolatedSymbol');
                    const timestamp = this.safeNumber(info, 'interestAccuredTime');
                    const marginMode = symbol === undefined ? 'cross' : 'isolated';
                    return {
                        'account': symbol === undefined ? 'cross' : symbol,
                        'symbol': symbol,
                        'marginType': marginMode,
                        'marginMode': marginMode,
                        'currency': this.safeCurrencyCode(this.safeString(info, 'asset')),
                        'interest': this.safeNumber(info, 'interest'),
                        'interestRate': this.safeNumber(info, 'interestRate'),
                        'amountBorrowed': this.safeNumber(info, 'principal'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'info': info
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    24: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const binance = require1('./binance.js');
            //  ---------------------------------------------------------------------------
            module.exports = class binancecoinm extends binance {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'binancecoinm',
                        'name': 'Binance COIN-M',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/117738721-668c8d80-b205-11eb-8c49-3fad84c4a07f.jpg',
                            'doc': [
                                'https://binance-docs.github.io/apidocs/delivery/en/',
                                'https://binance-docs.github.io/apidocs/spot/en'
                            ]
                        },
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'createStopMarketOrder': true
                        },
                        'options': {
                            'defaultType': 'delivery',
                            'leverageBrackets': undefined
                        }
                    });
                }
                async transferIn(code, amount, params = {}) {
                    // transfer from spot wallet to coinm futures wallet
                    return await this.futuresTransfer(code, amount, 3, params);
                }
                async transferOut(code, amount, params = {}) {
                    // transfer from coinm futures wallet to spot wallet
                    return await this.futuresTransfer(code, amount, 4, params);
                }
            };
        },
        {
            "./binance.js": 23
        }
    ],
    25: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const binance = require1('./binance.js');
            //  ---------------------------------------------------------------------------
            module.exports = class binanceus extends binance {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'binanceus',
                        'name': 'Binance US',
                        'countries': [
                            'US'
                        ],
                        'certified': false,
                        'pro': true,
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/65177307-217b7c80-da5f-11e9-876e-0b748ba0a358.jpg',
                            'api': {
                                'web': 'https://www.binance.us',
                                'sapi': 'https://api.binance.us/sapi/v1',
                                'wapi': 'https://api.binance.us/wapi/v3',
                                'public': 'https://api.binance.us/api/v3',
                                'private': 'https://api.binance.us/api/v3'
                            },
                            'www': 'https://www.binance.us',
                            'referral': 'https://www.binance.us/?ref=35005074',
                            'doc': 'https://github.com/binance-us/binance-official-api-docs',
                            'fees': 'https://www.binance.us/en/fee/schedule'
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.001'),
                                'maker': this.parseNumber('0.001')
                            }
                        },
                        'options': {
                            'fetchCurrencies': false,
                            'quoteOrderQty': false
                        }
                    });
                }
            };
        },
        {
            "./binance.js": 23
        }
    ],
    26: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const binance = require1('./binance.js');
            //  ---------------------------------------------------------------------------
            module.exports = class binanceusdm extends binance {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'binanceusdm',
                        'name': "Binance USD\u24C8-M",
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/117738721-668c8d80-b205-11eb-8c49-3fad84c4a07f.jpg',
                            'doc': [
                                'https://binance-docs.github.io/apidocs/futures/en/',
                                'https://binance-docs.github.io/apidocs/spot/en'
                            ]
                        },
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'createStopMarketOrder': true
                        },
                        'options': {
                            'defaultType': 'future',
                            // https://www.binance.com/en/support/faq/360033162192
                            // tier amount, maintenance margin, initial margin
                            'leverageBrackets': undefined,
                            'marginTypes': {},
                            'marginModes': {}
                        }
                    });
                }
                async transferIn(code, amount, params = {}) {
                    // transfer from spot wallet to usdm futures wallet
                    return await this.futuresTransfer(code, amount, 1, params);
                }
                async transferOut(code, amount, params = {}) {
                    // transfer from usdm futures wallet to spot wallet
                    return await this.futuresTransfer(code, amount, 2, params);
                }
            };
        },
        {
            "./binance.js": 23
        }
    ],
    27: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ArgumentsRequired: ArgumentsRequired1, ExchangeError: ExchangeError1, InvalidNonce: InvalidNonce, AuthenticationError: AuthenticationError, PermissionDenied: PermissionDenied } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bit2c extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bit2c',
                        'name': 'Bit2C',
                        'countries': [
                            'IL'
                        ],
                        'rateLimit': 3000,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766119-3593220e-5ece-11e7-8b3a-5a041f6bcc3f.jpg',
                            'api': 'https://bit2c.co.il',
                            'www': 'https://www.bit2c.co.il',
                            'referral': 'https://bit2c.co.il/Aff/63bfed10-e359-420c-ab5a-ad368dab0baf',
                            'doc': [
                                'https://www.bit2c.co.il/home/api',
                                'https://github.com/OferE/bit2c'
                            ]
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'Exchanges/{pair}/Ticker',
                                    'Exchanges/{pair}/orderbook',
                                    'Exchanges/{pair}/trades',
                                    'Exchanges/{pair}/lasttrades'
                                ]
                            },
                            'private': {
                                'post': [
                                    'Merchant/CreateCheckout',
                                    'Order/AddCoinFundsRequest',
                                    'Order/AddFund',
                                    'Order/AddOrder',
                                    'Order/AddOrderMarketPriceBuy',
                                    'Order/AddOrderMarketPriceSell',
                                    'Order/CancelOrder',
                                    'Order/AddCoinFundsRequest',
                                    'Order/AddStopOrder',
                                    'Payment/GetMyId',
                                    'Payment/Send',
                                    'Payment/Pay'
                                ],
                                'get': [
                                    'Account/Balance',
                                    'Account/Balance/v2',
                                    'Order/MyOrders',
                                    'Order/GetById',
                                    'Order/AccountHistory',
                                    'Order/OrderHistory'
                                ]
                            }
                        },
                        'markets': {
                            'BTC/NIS': {
                                'id': 'BtcNis',
                                'symbol': 'BTC/NIS',
                                'base': 'BTC',
                                'quote': 'NIS',
                                'baseId': 'Btc',
                                'quoteId': 'Nis',
                                'type': 'spot',
                                'spot': true
                            },
                            'ETH/NIS': {
                                'id': 'EthNis',
                                'symbol': 'ETH/NIS',
                                'base': 'ETH',
                                'quote': 'NIS',
                                'baseId': 'Eth',
                                'quoteId': 'Nis',
                                'type': 'spot',
                                'spot': true
                            },
                            'BCH/NIS': {
                                'id': 'BchabcNis',
                                'symbol': 'BCH/NIS',
                                'base': 'BCH',
                                'quote': 'NIS',
                                'baseId': 'Bchabc',
                                'quoteId': 'Nis',
                                'type': 'spot',
                                'spot': true
                            },
                            'LTC/NIS': {
                                'id': 'LtcNis',
                                'symbol': 'LTC/NIS',
                                'base': 'LTC',
                                'quote': 'NIS',
                                'baseId': 'Ltc',
                                'quoteId': 'Nis',
                                'type': 'spot',
                                'spot': true
                            },
                            'ETC/NIS': {
                                'id': 'EtcNis',
                                'symbol': 'ETC/NIS',
                                'base': 'ETC',
                                'quote': 'NIS',
                                'baseId': 'Etc',
                                'quoteId': 'Nis',
                                'type': 'spot',
                                'spot': true
                            },
                            'BTG/NIS': {
                                'id': 'BtgNis',
                                'symbol': 'BTG/NIS',
                                'base': 'BTG',
                                'quote': 'NIS',
                                'baseId': 'Btg',
                                'quoteId': 'Nis',
                                'type': 'spot',
                                'spot': true
                            },
                            'BSV/NIS': {
                                'id': 'BchsvNis',
                                'symbol': 'BSV/NIS',
                                'base': 'BSV',
                                'quote': 'NIS',
                                'baseId': 'Bchsv',
                                'quoteId': 'Nis',
                                'type': 'spot',
                                'spot': true
                            },
                            'GRIN/NIS': {
                                'id': 'GrinNis',
                                'symbol': 'GRIN/NIS',
                                'base': 'GRIN',
                                'quote': 'NIS',
                                'baseId': 'Grin',
                                'quoteId': 'Nis',
                                'type': 'spot',
                                'spot': true
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.005'),
                                'taker': this.parseNumber('0.005')
                            }
                        },
                        'options': {
                            'fetchTradesMethod': 'public_get_exchanges_pair_trades'
                        },
                        'exceptions': {
                            'exact': {
                                'Please provide valid APIkey': AuthenticationError
                            },
                            'broad': {
                                // { "error": "Please provide valid nonce in Request Nonce (1598218490) is not bigger than last nonce (1598218490)."}
                                // { "error": "Please provide valid nonce in Request UInt64.TryParse failed for nonce :" }
                                'Please provide valid nonce': InvalidNonce,
                                'please approve new terms of use on site': PermissionDenied
                            }
                        }
                    });
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const codes = Object.keys(this.currencies);
                    for(let i = 0; i < codes.length; i++){
                        const code = codes[i];
                        const account = this.account();
                        const currency = this.currency(code);
                        const uppercase = currency['id'].toUpperCase();
                        if (uppercase in response) {
                            account['free'] = this.safeString(response, 'AVAILABLE_' + uppercase);
                            account['total'] = this.safeString(response, uppercase);
                        }
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountBalanceV2(params);
                    //
                    //     {
                    //         "AVAILABLE_NIS": 0.0,
                    //         "NIS": 0.0,
                    //         "LOCKED_NIS": 0.0,
                    //         "AVAILABLE_BTC": 0.0,
                    //         "BTC": 0.0,
                    //         "LOCKED_BTC": 0.0,
                    //         "AVAILABLE_ETH": 0.0,
                    //         "ETH": 0.0,
                    //         "LOCKED_ETH": 0.0,
                    //         "AVAILABLE_BCHSV": 0.0,
                    //         "BCHSV": 0.0,
                    //         "LOCKED_BCHSV": 0.0,
                    //         "AVAILABLE_BCHABC": 0.0,
                    //         "BCHABC": 0.0,
                    //         "LOCKED_BCHABC": 0.0,
                    //         "AVAILABLE_LTC": 0.0,
                    //         "LTC": 0.0,
                    //         "LOCKED_LTC": 0.0,
                    //         "AVAILABLE_ETC": 0.0,
                    //         "ETC": 0.0,
                    //         "LOCKED_ETC": 0.0,
                    //         "AVAILABLE_BTG": 0.0,
                    //         "BTG": 0.0,
                    //         "LOCKED_BTG": 0.0,
                    //         "AVAILABLE_GRIN": 0.0,
                    //         "GRIN": 0.0,
                    //         "LOCKED_GRIN": 0.0,
                    //         "Fees": {
                    //             "BtcNis": { "FeeMaker": 1.0, "FeeTaker": 1.0 },
                    //             "EthNis": { "FeeMaker": 1.0, "FeeTaker": 1.0 },
                    //             "BchabcNis": { "FeeMaker": 1.0, "FeeTaker": 1.0 },
                    //             "LtcNis": { "FeeMaker": 1.0, "FeeTaker": 1.0 },
                    //             "EtcNis": { "FeeMaker": 1.0, "FeeTaker": 1.0 },
                    //             "BtgNis": { "FeeMaker": 1.0, "FeeTaker": 1.0 },
                    //             "LtcBtc": { "FeeMaker": 1.0, "FeeTaker": 1.0 },
                    //             "BchsvNis": { "FeeMaker": 1.0, "FeeTaker": 1.0 },
                    //             "GrinNis": { "FeeMaker": 1.0, "FeeTaker": 1.0 }
                    //         }
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'pair': this.marketId(symbol)
                    };
                    const orderbook = await this.publicGetExchangesPairOrderbook(this.extend(request, params));
                    return this.parseOrderBook(orderbook, symbol);
                }
                parseTicker(ticker, market) {
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.milliseconds();
                    const averagePrice = this.safeString(ticker, 'av');
                    const baseVolume = this.safeString(ticker, 'a');
                    const last = this.safeString(ticker, 'll');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': undefined,
                        'low': undefined,
                        'bid': this.safeString(ticker, 'h'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'l'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': averagePrice,
                        'baseVolume': baseVolume,
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetExchangesPairTicker(this.extend(request, params));
                    return this.parseTicker(response, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const method = this.options['fetchTradesMethod']; // public_get_exchanges_pair_trades or public_get_exchanges_pair_lasttrades
                    const request = {
                        'pair': market['id']
                    };
                    if (since !== undefined) request['date'] = parseInt(since);
                    if (limit !== undefined) request['limit'] = limit; // max 100000
                    const response = await this[method](this.extend(request, params));
                    //
                    //     [
                    //         {"date":1651785980,"price":127975.68,"amount":0.3750321,"isBid":true,"tid":1261018},
                    //         {"date":1651785980,"price":127987.70,"amount":0.0389527820303982335802581029,"isBid":true,"tid":1261020},
                    //         {"date":1651786701,"price":128084.03,"amount":0.0015614749161156156626239821,"isBid":true,"tid":1261022},
                    //     ]
                    //
                    if (typeof response === 'string') throw new ExchangeError1(response);
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountBalance(params);
                    //
                    //     {
                    //         "AVAILABLE_NIS": 0.0,
                    //         "NIS": 0.0,
                    //         "LOCKED_NIS": 0.0,
                    //         "AVAILABLE_BTC": 0.0,
                    //         "BTC": 0.0,
                    //         "LOCKED_BTC": 0.0,
                    //         ...
                    //         "Fees": {
                    //             "BtcNis": { "FeeMaker": 1.0, "FeeTaker": 1.0 },
                    //             "EthNis": { "FeeMaker": 1.0, "FeeTaker": 1.0 },
                    //             ...
                    //         }
                    //     }
                    //
                    const fees = this.safeValue(response, 'Fees', {});
                    const keys = Object.keys(fees);
                    const result = {};
                    for(let i = 0; i < keys.length; i++){
                        const marketId = keys[i];
                        const symbol = this.safeSymbol(marketId);
                        const fee = this.safeValue(fees, marketId);
                        const makerString = this.safeString(fee, 'FeeMaker');
                        const takerString = this.safeString(fee, 'FeeTaker');
                        const maker = this.parseNumber(Precise.stringDiv(makerString, '100'));
                        const taker = this.parseNumber(Precise.stringDiv(takerString, '100'));
                        result[symbol] = {
                            'info': fee,
                            'symbol': symbol,
                            'taker': taker,
                            'maker': maker,
                            'percentage': true,
                            'tierBased': false
                        };
                    }
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    let method = 'privatePostOrderAddOrder';
                    const request = {
                        'Amount': amount,
                        'Pair': this.marketId(symbol)
                    };
                    if (type === 'market') method += 'MarketPrice' + this.capitalize(side);
                    else {
                        request['Price'] = price;
                        request['Total'] = amount * price;
                        request['IsBid'] = side === 'buy';
                    }
                    const response = await this[method](this.extend(request, params));
                    return {
                        'info': response,
                        'id': response['NewOrder']['id']
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'id': id
                    };
                    return await this.privatePostOrderCancelOrder(this.extend(request, params));
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.privateGetOrderMyOrders(this.extend(request, params));
                    const orders = this.safeValue(response, market['id'], {});
                    const asks = this.safeValue(orders, 'ask', []);
                    const bids = this.safeValue(orders, 'bid', []);
                    return this.parseOrders(this.arrayConcat(asks, bids), market, since, limit);
                }
                parseOrder(order, market) {
                    const timestamp = this.safeInteger(order, 'created');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'amount');
                    market = this.safeMarket(undefined, market);
                    let side = this.safeValue(order, 'type');
                    if (side === 0) side = 'buy';
                    else if (side === 1) side = 'sell';
                    const id = this.safeString(order, 'id');
                    const status = this.safeString(order, 'status');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': market['symbol'],
                        'type': undefined,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'filled': undefined,
                        'remaining': undefined,
                        'cost': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'info': order,
                        'average': undefined
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (limit !== undefined) request['take'] = limit;
                    request['take'] = limit;
                    if (since !== undefined) {
                        request['toTime'] = this.yyyymmdd(this.milliseconds(), '.');
                        request['fromTime'] = this.yyyymmdd(since, '.');
                    }
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['pair'] = market['id'];
                    }
                    const response = await this.privateGetOrderOrderHistory(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "ticks":1574767951,
                    //             "created":"26/11/19 13:32",
                    //             "action":1,
                    //             "price":"1000",
                    //             "pair":"EthNis",
                    //             "reference":"EthNis|10867390|10867377",
                    //             "fee":"0.5",
                    //             "feeAmount":"0.08",
                    //             "feeCoin":"₪",
                    //             "firstAmount":"-0.015",
                    //             "firstAmountBalance":"9",
                    //             "secondAmount":"14.93",
                    //             "secondAmountBalance":"130,233.28",
                    //             "firstCoin":"ETH",
                    //             "secondCoin":"₪"
                    //         },
                    //         {
                    //             "ticks":1574767951,
                    //             "created":"26/11/19 13:32",
                    //             "action":0,
                    //             "price":"1000",
                    //             "pair":"EthNis",
                    //             "reference":"EthNis|10867390|10867377",
                    //             "fee":"0.5",
                    //             "feeAmount":"0.08",
                    //             "feeCoin":"₪",
                    //             "firstAmount":"0.015",
                    //             "firstAmountBalance":"9.015",
                    //             "secondAmount":"-15.08",
                    //             "secondAmountBalance":"130,218.35",
                    //             "firstCoin":"ETH",
                    //             "secondCoin":"₪"
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     {
                    //         "date":1651785980,
                    //         "price":127975.68,
                    //         "amount":0.3750321,
                    //         "isBid":true,
                    //         "tid":1261018
                    //     }
                    //
                    // private fetchMyTrades
                    //
                    //     {
                    //         "ticks":1574767951,
                    //         "created":"26/11/19 13:32",
                    //         "action":1,
                    //         "price":"1000",
                    //         "pair":"EthNis",
                    //         "reference":"EthNis|10867390|10867377",
                    //         "fee":"0.5",
                    //         "feeAmount":"0.08",
                    //         "feeCoin":"₪",
                    //         "firstAmount":"-0.015",
                    //         "firstAmountBalance":"9",
                    //         "secondAmount":"14.93",
                    //         "secondAmountBalance":"130,233.28",
                    //         "firstCoin":"ETH",
                    //         "secondCoin":"₪"
                    //     }
                    //
                    let timestamp = undefined;
                    let id = undefined;
                    let price = undefined;
                    let amount = undefined;
                    let orderId = undefined;
                    let fee = undefined;
                    let side = undefined;
                    const reference = this.safeString(trade, 'reference');
                    if (reference !== undefined) {
                        timestamp = this.safeTimestamp(trade, 'ticks');
                        price = this.safeString(trade, 'price');
                        amount = this.safeString(trade, 'firstAmount');
                        const reference_parts = reference.split('|'); // reference contains 'pair|orderId|tradeId'
                        const marketId = this.safeString(trade, 'pair');
                        market = this.safeMarket(marketId, market);
                        market = this.safeMarket(reference_parts[0], market);
                        orderId = reference_parts[1];
                        id = reference_parts[2];
                        side = this.safeInteger(trade, 'action');
                        if (side === 0) side = 'buy';
                        else if (side === 1) side = 'sell';
                        const feeCost = this.safeString(trade, 'feeAmount');
                        if (feeCost !== undefined) fee = {
                            'cost': feeCost,
                            'currency': 'NIS'
                        };
                    } else {
                        timestamp = this.safeTimestamp(trade, 'date');
                        id = this.safeString(trade, 'tid');
                        price = this.safeString(trade, 'price');
                        amount = this.safeString(trade, 'amount');
                        side = this.safeValue(trade, 'isBid');
                        if (side !== undefined) {
                            if (side) side = 'buy';
                            else side = 'sell';
                        }
                    }
                    market = this.safeMarket(undefined, market);
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + this.implodeParams(path, params);
                    if (api === 'public') url += '.json';
                    else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce();
                        const query = this.extend({
                            'nonce': nonce
                        }, params);
                        const auth = this.urlencode(query);
                        if (method === 'GET') {
                            if (Object.keys(query).length) url += '?' + auth;
                        } else body = auth;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha512', 'base64');
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'key': this.apiKey,
                            'sign': signature
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //     { "error" : "please approve new terms of use on site." }
                    //     { "error": "Please provide valid nonce in Request Nonce (1598218490) is not bigger than last nonce (1598218490)."}
                    //
                    const error = this.safeString(response, 'error');
                    if (error !== undefined) {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], error, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], error, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    28: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, AuthenticationError: AuthenticationError, InvalidNonce: InvalidNonce, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, PermissionDenied: PermissionDenied, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class bitbank extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitbank',
                        'name': 'bitbank',
                        'countries': [
                            'JP'
                        ],
                        'version': 'v1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchDepositAddress': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1min',
                            '5m': '5min',
                            '15m': '15min',
                            '30m': '30min',
                            '1h': '1hour',
                            '4h': '4hour',
                            '8h': '8hour',
                            '12h': '12hour',
                            '1d': '1day',
                            '1w': '1week'
                        },
                        'hostname': 'bitbank.cc',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/37808081-b87f2d9c-2e59-11e8-894d-c1900b7584fe.jpg',
                            'api': {
                                'public': 'https://public.{hostname}',
                                'private': 'https://api.{hostname}',
                                'markets': 'https://api.{hostname}'
                            },
                            'www': 'https://bitbank.cc/',
                            'doc': 'https://docs.bitbank.cc/',
                            'fees': 'https://bitbank.cc/docs/fees/'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    '{pair}/ticker',
                                    '{pair}/depth',
                                    '{pair}/transactions',
                                    '{pair}/transactions/{yyyymmdd}',
                                    '{pair}/candlestick/{candletype}/{yyyymmdd}'
                                ]
                            },
                            'private': {
                                'get': [
                                    'user/assets',
                                    'user/spot/order',
                                    'user/spot/active_orders',
                                    'user/spot/trade_history',
                                    'user/withdrawal_account'
                                ],
                                'post': [
                                    'user/spot/order',
                                    'user/spot/cancel_order',
                                    'user/spot/cancel_orders',
                                    'user/spot/orders_info',
                                    'user/request_withdrawal'
                                ]
                            },
                            'markets': {
                                'get': [
                                    'spot/pairs'
                                ]
                            }
                        },
                        'exceptions': {
                            '20001': AuthenticationError,
                            '20002': AuthenticationError,
                            '20003': AuthenticationError,
                            '20005': AuthenticationError,
                            '20004': InvalidNonce,
                            '40020': InvalidOrder,
                            '40021': InvalidOrder,
                            '40025': ExchangeError1,
                            '40013': OrderNotFound,
                            '40014': OrderNotFound,
                            '50008': PermissionDenied,
                            '50009': OrderNotFound,
                            '50010': OrderNotFound,
                            '60001': InsufficientFunds,
                            '60005': InvalidOrder
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.marketsGetSpotPairs(params);
                    //
                    //     {
                    //       "success": 1,
                    //       "data": {
                    //         "pairs": [
                    //           {
                    //             "name": "btc_jpy",
                    //             "base_asset": "btc",
                    //             "quote_asset": "jpy",
                    //             "maker_fee_rate_base": "0",
                    //             "taker_fee_rate_base": "0",
                    //             "maker_fee_rate_quote": "-0.0002",
                    //             "taker_fee_rate_quote": "0.0012",
                    //             "unit_amount": "0.0001",
                    //             "limit_max_amount": "1000",
                    //             "market_max_amount": "10",
                    //             "market_allowance_rate": "0.2",
                    //             "price_digits": 0,
                    //             "amount_digits": 4,
                    //             "is_enabled": true,
                    //             "stop_order": false,
                    //             "stop_order_and_cancel": false
                    //           }
                    //         ]
                    //       }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const pairs = this.safeValue(data, 'pairs', []);
                    const result = [];
                    for(let i = 0; i < pairs.length; i++){
                        const entry = pairs[i];
                        const id = this.safeString(entry, 'name');
                        const baseId = this.safeString(entry, 'base_asset');
                        const quoteId = this.safeString(entry, 'quote_asset');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': this.safeValue(entry, 'is_enabled'),
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.safeNumber(entry, 'taker_fee_rate_quote'),
                            'maker': this.safeNumber(entry, 'maker_fee_rate_quote'),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(entry, 'amount_digits'),
                                'price': this.safeInteger(entry, 'price_digits')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(entry, 'unit_amount'),
                                    'max': this.safeNumber(entry, 'limit_max_amount')
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': entry
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.safeInteger(ticker, 'timestamp');
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'vol'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetPairTicker(this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTicker(data, market);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'pair': this.marketId(symbol)
                    };
                    const response = await this.publicGetPairDepth(this.extend(request, params));
                    const orderbook = this.safeValue(response, 'data', {});
                    const timestamp = this.safeInteger(orderbook, 'timestamp');
                    return this.parseOrderBook(orderbook, symbol, timestamp);
                }
                parseTrade(trade, market) {
                    const timestamp = this.safeInteger(trade, 'executed_at');
                    market = this.safeMarket(undefined, market);
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const id = this.safeString2(trade, 'transaction_id', 'trade_id');
                    const takerOrMaker = this.safeString(trade, 'maker_taker');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee_amount_quote');
                    if (feeCostString !== undefined) fee = {
                        'currency': market['quote'],
                        'cost': feeCostString
                    };
                    const orderId = this.safeString(trade, 'order_id');
                    const type = this.safeString(trade, 'type');
                    const side = this.safeString(trade, 'side');
                    return this.safeTrade({
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'id': id,
                        'order': orderId,
                        'type': type,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetPairTransactions(this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    const trades = this.safeValue(data, 'transactions', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.marketsGetSpotPairs(params);
                    //
                    //     {
                    //         success: '1',
                    //         data: {
                    //           pairs: [
                    //             {
                    //               name: 'btc_jpy',
                    //               base_asset: 'btc',
                    //               quote_asset: 'jpy',
                    //               maker_fee_rate_base: '0',
                    //               taker_fee_rate_base: '0',
                    //               maker_fee_rate_quote: '-0.0002',
                    //               taker_fee_rate_quote: '0.0012',
                    //               unit_amount: '0.0001',
                    //               limit_max_amount: '1000',
                    //               market_max_amount: '10',
                    //               market_allowance_rate: '0.2',
                    //               price_digits: '0',
                    //               amount_digits: '4',
                    //               is_enabled: true,
                    //               stop_order: false,
                    //               stop_order_and_cancel: false
                    //             },
                    //             ...
                    //           ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const pairs = this.safeValue(data, 'pairs', []);
                    const result = {};
                    for(let i = 0; i < pairs.length; i++){
                        const pair = pairs[i];
                        const marketId = this.safeString(pair, 'name');
                        const market = this.safeMarket(marketId);
                        const symbol = market['symbol'];
                        result[symbol] = {
                            'info': pair,
                            'symbol': symbol,
                            'maker': this.safeNumber(pair, 'maker_fee_rate_quote'),
                            'taker': this.safeNumber(pair, 'taker_fee_rate_quote'),
                            'percentage': true,
                            'tierBased': false
                        };
                    }
                    return result;
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         "0.02501786",
                    //         "0.02501786",
                    //         "0.02501786",
                    //         "0.02501786",
                    //         "0.0000",
                    //         1591488000000
                    //     ]
                    //
                    return [
                        this.safeInteger(ohlcv, 5),
                        this.safeNumber(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '5m', since, limit, params = {}) {
                    if (since === undefined) throw new ArgumentsRequired1(this.id + ' fetchOHLCV() requires a since argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'candletype': this.timeframes[timeframe],
                        'yyyymmdd': this.yyyymmdd(since, '')
                    };
                    const response = await this.publicGetPairCandlestickCandletypeYyyymmdd(this.extend(request, params));
                    //
                    //     {
                    //         "success":1,
                    //         "data":{
                    //             "candlestick":[
                    //                 {
                    //                     "type":"5min",
                    //                     "ohlcv":[
                    //                         ["0.02501786","0.02501786","0.02501786","0.02501786","0.0000",1591488000000],
                    //                         ["0.02501747","0.02501953","0.02501747","0.02501953","0.3017",1591488300000],
                    //                         ["0.02501762","0.02501762","0.02500392","0.02500392","0.1500",1591488600000],
                    //                     ]
                    //                 }
                    //             ],
                    //             "timestamp":1591508668190
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const candlestick = this.safeValue(data, 'candlestick', []);
                    const first = this.safeValue(candlestick, 0, {});
                    const ohlcv = this.safeValue(first, 'ohlcv', []);
                    return this.parseOHLCVs(ohlcv, market, timeframe, since, limit);
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const data = this.safeValue(response, 'data', {});
                    const assets = this.safeValue(data, 'assets', []);
                    for(let i = 0; i < assets.length; i++){
                        const balance = assets[i];
                        const currencyId = this.safeString(balance, 'asset');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'free_amount');
                        account['used'] = this.safeString(balance, 'locked_amount');
                        account['total'] = this.safeString(balance, 'onhand_amount');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetUserAssets(params);
                    //
                    //     {
                    //       "success": "1",
                    //       "data": {
                    //         "assets": [
                    //           {
                    //             "asset": "jpy",
                    //             "amount_precision": "4",
                    //             "onhand_amount": "0.0000",
                    //             "locked_amount": "0.0000",
                    //             "free_amount": "0.0000",
                    //             "stop_deposit": false,
                    //             "stop_withdrawal": false,
                    //             "withdrawal_fee": {
                    //               "threshold": "30000.0000",
                    //               "under": "550.0000",
                    //               "over": "770.0000"
                    //             }
                    //           },
                    //           {
                    //             "asset": "btc",
                    //             "amount_precision": "8",
                    //             "onhand_amount": "0.00000000",
                    //             "locked_amount": "0.00000000",
                    //             "free_amount": "0.00000000",
                    //             "stop_deposit": false,
                    //             "stop_withdrawal": false,
                    //             "withdrawal_fee": "0.00060000"
                    //           },
                    //         ]
                    //       }
                    //     }
                    //
                    return this.parseBalance(response);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'UNFILLED': 'open',
                        'PARTIALLY_FILLED': 'open',
                        'FULLY_FILLED': 'closed',
                        'CANCELED_UNFILLED': 'canceled',
                        'CANCELED_PARTIALLY_FILLED': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    const id = this.safeString(order, 'order_id');
                    const marketId = this.safeString(order, 'pair');
                    market = this.safeMarket(marketId, market);
                    const timestamp = this.safeInteger(order, 'ordered_at');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'start_amount');
                    const filled = this.safeString(order, 'executed_amount');
                    const remaining = this.safeString(order, 'remaining_amount');
                    const average = this.safeString(order, 'average_price');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const type = this.safeStringLower(order, 'type');
                    const side = this.safeStringLower(order, 'side');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'average': average,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'trades': undefined,
                        'fee': undefined,
                        'info': order
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'amount': this.amountToPrecision(symbol, amount),
                        'side': side,
                        'type': type
                    };
                    if (type === 'limit') request['price'] = this.priceToPrecision(symbol, price);
                    const response = await this.privatePostUserSpotOrder(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'order_id': id,
                        'pair': market['id']
                    };
                    const response = await this.privatePostUserSpotCancelOrder(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    return data;
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'order_id': id,
                        'pair': market['id']
                    };
                    const response = await this.privateGetUserSpotOrder(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['count'] = limit;
                    if (since !== undefined) request['since'] = parseInt(since / 1000);
                    const response = await this.privateGetUserSpotActiveOrders(this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    const orders = this.safeValue(data, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        request['pair'] = market['id'];
                        market = this.market(symbol);
                    }
                    if (limit !== undefined) request['count'] = limit;
                    if (since !== undefined) request['since'] = parseInt(since / 1000);
                    const response = await this.privateGetUserSpotTradeHistory(this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    const trades = this.safeValue(data, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'asset': currency['id']
                    };
                    const response = await this.privateGetUserWithdrawalAccount(this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    // Not sure about this if there could be more than one account...
                    const accounts = this.safeValue(data, 'accounts', []);
                    const firstAccount = this.safeValue(accounts, 0, {});
                    const address = this.safeString(firstAccount, 'address');
                    return {
                        'currency': currency,
                        'address': address,
                        'tag': undefined,
                        'network': undefined,
                        'info': response
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    if (!('uuid' in params)) throw new ExchangeError1(this.id + ' uuid is required for withdrawal');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'asset': currency['id'],
                        'amount': amount
                    };
                    const response = await this.privatePostUserRequestWithdrawal(this.extend(request, params));
                    //
                    //     {
                    //         "success": 1,
                    //         "data": {
                    //             "uuid": "string",
                    //             "asset": "btc",
                    //             "amount": 0,
                    //             "account_uuid": "string",
                    //             "fee": 0,
                    //             "status": "DONE",
                    //             "label": "string",
                    //             "txid": "string",
                    //             "address": "string",
                    //             "requested_at": 0
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTransaction(data, currency);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "uuid": "string",
                    //         "asset": "btc",
                    //         "amount": 0,
                    //         "account_uuid": "string",
                    //         "fee": 0,
                    //         "status": "DONE",
                    //         "label": "string",
                    //         "txid": "string",
                    //         "address": "string",
                    //         "requested_at": 0
                    //     }
                    //
                    const txid = this.safeString(transaction, 'txid');
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'id': txid,
                        'txid': txid,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': undefined,
                        'info': transaction
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let query = this.omit(params, this.extractParams(path));
                    let url = this.implodeHostname(this.urls['api'][api]) + '/';
                    if (api === 'public' || api === 'markets') {
                        url += this.implodeParams(path, params);
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        let auth = nonce;
                        url += this.version + '/' + this.implodeParams(path, params);
                        if (method === 'POST') {
                            body = this.json(query);
                            auth += body;
                        } else {
                            auth += '/' + this.version + '/' + path;
                            if (Object.keys(query).length) {
                                query = this.urlencode(query);
                                url += '?' + query;
                                auth += '?' + query;
                            }
                        }
                        headers = {
                            'Content-Type': 'application/json',
                            'ACCESS-KEY': this.apiKey,
                            'ACCESS-NONCE': nonce,
                            'ACCESS-SIGNATURE': this.hmac(this.encode(auth), this.encode(this.secret))
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    const success = this.safeInteger(response, 'success');
                    const data = this.safeValue(response, 'data');
                    if (!success || !data) {
                        const errorMessages = {
                            '10000': 'URL does not exist',
                            '10001': 'A system error occurred. Please contact support',
                            '10002': 'Invalid JSON format. Please check the contents of transmission',
                            '10003': 'A system error occurred. Please contact support',
                            '10005': 'A timeout error occurred. Please wait for a while and try again',
                            '20001': 'API authentication failed',
                            '20002': 'Illegal API key',
                            '20003': 'API key does not exist',
                            '20004': 'API Nonce does not exist',
                            '20005': 'API signature does not exist',
                            '20011': 'Two-step verification failed',
                            '20014': 'SMS authentication failed',
                            '30001': 'Please specify the order quantity',
                            '30006': 'Please specify the order ID',
                            '30007': 'Please specify the order ID array',
                            '30009': 'Please specify the stock',
                            '30012': 'Please specify the order price',
                            '30013': 'Trade Please specify either',
                            '30015': 'Please specify the order type',
                            '30016': 'Please specify asset name',
                            '30019': 'Please specify uuid',
                            '30039': 'Please specify the amount to be withdrawn',
                            '40001': 'The order quantity is invalid',
                            '40006': 'Count value is invalid',
                            '40007': 'End time is invalid',
                            '40008': 'end_id Value is invalid',
                            '40009': 'The from_id value is invalid',
                            '40013': 'The order ID is invalid',
                            '40014': 'The order ID array is invalid',
                            '40015': 'Too many specified orders',
                            '40017': 'Incorrect issue name',
                            '40020': 'The order price is invalid',
                            '40021': 'The trading classification is invalid',
                            '40022': 'Start date is invalid',
                            '40024': 'The order type is invalid',
                            '40025': 'Incorrect asset name',
                            '40028': 'uuid is invalid',
                            '40048': 'The amount of withdrawal is illegal',
                            '50003': 'Currently, this account is in a state where you can not perform the operation you specified. Please contact support',
                            '50004': 'Currently, this account is temporarily registered. Please try again after registering your account',
                            '50005': 'Currently, this account is locked. Please contact support',
                            '50006': 'Currently, this account is locked. Please contact support',
                            '50008': 'User identification has not been completed',
                            '50009': 'Your order does not exist',
                            '50010': 'Can not cancel specified order',
                            '50011': 'API not found',
                            '60001': 'The number of possessions is insufficient',
                            '60002': 'It exceeds the quantity upper limit of the tender buying order',
                            '60003': 'The specified quantity exceeds the limit',
                            '60004': 'The specified quantity is below the threshold',
                            '60005': 'The specified price is above the limit',
                            '60006': 'The specified price is below the lower limit',
                            '70001': 'A system error occurred. Please contact support',
                            '70002': 'A system error occurred. Please contact support',
                            '70003': 'A system error occurred. Please contact support',
                            '70004': 'We are unable to accept orders as the transaction is currently suspended',
                            '70005': 'Order can not be accepted because purchase order is currently suspended',
                            '70006': 'We can not accept orders because we are currently unsubscribed ',
                            '70009': 'We are currently temporarily restricting orders to be carried out. Please use the limit order.',
                            '70010': 'We are temporarily raising the minimum order quantity as the system load is now rising.'
                        };
                        const errorClasses = this.exceptions;
                        const code = this.safeString(data, 'code');
                        const message = this.safeString(errorMessages, code, 'Error');
                        const ErrorClass = this.safeValue(errorClasses, code);
                        if (ErrorClass !== undefined) throw new ErrorClass(message);
                        else throw new ExchangeError1(this.id + ' ' + this.json(response));
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    29: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const zonda = require1('./zonda.js');
            // ---------------------------------------------------------------------------
            module.exports = class bitbay extends zonda {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitbay',
                        'alias': true
                    });
                }
            };
        },
        {
            "./zonda.js": 176
        }
    ],
    30: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, BadRequest: BadRequest, BadSymbol: BadSymbol } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bitbns extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitbns',
                        'name': 'Bitbns',
                        'countries': [
                            'IN'
                        ],
                        'rateLimit': 1000,
                        'certified': false,
                        'pro': false,
                        'version': 'v2',
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': undefined,
                            'cancelOrder': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': undefined,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchStatus': true,
                            'fetchTicker': 'emulated',
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': true,
                            'transfer': false,
                            'withdraw': false
                        },
                        'timeframes': {},
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/117201933-e7a6e780-adf5-11eb-9d80-98fc2a21c3d6.jpg',
                            'api': {
                                'www': 'https://bitbns.com',
                                'v1': 'https://api.bitbns.com/api/trade/v1',
                                'v2': 'https://api.bitbns.com/api/trade/v2'
                            },
                            'www': 'https://bitbns.com',
                            'referral': 'https://ref.bitbns.com/1090961',
                            'doc': [
                                'https://bitbns.com/trade/#/api-trading/'
                            ],
                            'fees': 'https://bitbns.com/fees'
                        },
                        'api': {
                            'www': {
                                'get': [
                                    'order/fetchMarkets',
                                    'order/fetchTickers',
                                    'order/fetchOrderbook',
                                    'order/getTickerWithVolume',
                                    'exchangeData/ohlc',
                                    'exchangeData/orderBook',
                                    'exchangeData/tradedetails'
                                ]
                            },
                            'v1': {
                                'get': [
                                    'platform/status',
                                    'tickers',
                                    'orderbook/sell/{symbol}',
                                    'orderbook/buy/{symbol}'
                                ],
                                'post': [
                                    'currentCoinBalance/EVERYTHING',
                                    'getApiUsageStatus/USAGE',
                                    'getOrderSocketToken/USAGE',
                                    'currentCoinBalance/{symbol}',
                                    'orderStatus/{symbol}',
                                    'depositHistory/{symbol}',
                                    'withdrawHistory/{symbol}',
                                    'withdrawHistoryAll/{symbol}',
                                    'depositHistoryAll/{symbol}',
                                    'listOpenOrders/{symbol}',
                                    'listOpenStopOrders/{symbol}',
                                    'getCoinAddress/{symbol}',
                                    'placeSellOrder/{symbol}',
                                    'placeBuyOrder/{symbol}',
                                    'buyStopLoss/{symbol}',
                                    'sellStopLoss/{symbol}',
                                    'placeSellOrder/{symbol}',
                                    'cancelOrder/{symbol}',
                                    'cancelStopLossOrder/{symbol}',
                                    'listExecutedOrders/{symbol}',
                                    'placeMarketOrder/{symbol}',
                                    'placeMarketOrderQnty/{symbol}'
                                ]
                            },
                            'v2': {
                                'post': [
                                    'orders',
                                    'cancel',
                                    'getordersnew',
                                    'marginOrders'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'quote',
                                'tierBased': false,
                                'percentage': true,
                                'taker': this.parseNumber('0.0025'),
                                'maker': this.parseNumber('0.0025')
                            }
                        },
                        'exceptions': {
                            'exact': {
                                '400': BadRequest,
                                '409': BadSymbol,
                                '416': InsufficientFunds,
                                '417': OrderNotFound
                            },
                            'broad': {}
                        }
                    });
                }
                async fetchStatus(params = {}) {
                    const response = await this.v1GetPlatformStatus(params);
                    //
                    //     {
                    //         "data":{
                    //             "BTC":{"status":1},
                    //             "ETH":{"status":1},
                    //             "XRP":{"status":1},
                    //         },
                    //         "status":1,
                    //         "error":null,
                    //         "code":200
                    //     }
                    //
                    const statusRaw = this.safeString(response, 'status');
                    return {
                        'status': this.safeString({
                            '1': 'ok'
                        }, statusRaw, statusRaw),
                        'updated': this.milliseconds(),
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchMarkets(params = {}) {
                    const response = await this.wwwGetOrderFetchMarkets(params);
                    //
                    //     [
                    //         {
                    //             "id":"BTC",
                    //             "symbol":"BTC/INR",
                    //             "base":"BTC",
                    //             "quote":"INR",
                    //             "baseId":"BTC",
                    //             "quoteId":"",
                    //             "active":true,
                    //             "limits":{
                    //                 "amount":{"min":"0.00017376","max":20},
                    //                 "price":{"min":2762353.2359999996,"max":6445490.883999999},
                    //                 "cost":{"min":800,"max":128909817.67999998}
                    //             },
                    //             "precision":{
                    //                 "amount":8,
                    //                 "price":2
                    //             },
                    //             "info":{}
                    //         },
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'id');
                        const baseId = this.safeString(market, 'base');
                        const quoteId = this.safeString(market, 'quote');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const marketPrecision = this.safeValue(market, 'precision', {});
                        const marketLimits = this.safeValue(market, 'limits', {});
                        const amountLimits = this.safeValue(marketLimits, 'amount', {});
                        const priceLimits = this.safeValue(marketLimits, 'price', {});
                        const costLimits = this.safeValue(marketLimits, 'cost', {});
                        const usdt = quoteId === 'USDT';
                        // INR markets don't need a _INR prefix
                        const uppercaseId = usdt ? baseId + '_' + quoteId : baseId;
                        result.push({
                            'id': id,
                            'uppercaseId': uppercaseId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(marketPrecision, 'amount'),
                                'price': this.safeInteger(marketPrecision, 'price')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(amountLimits, 'min'),
                                    'max': this.safeNumber(amountLimits, 'max')
                                },
                                'price': {
                                    'min': this.safeNumber(priceLimits, 'min'),
                                    'max': this.safeNumber(priceLimits, 'max')
                                },
                                'cost': {
                                    'min': this.safeNumber(costLimits, 'min'),
                                    'max': this.safeNumber(costLimits, 'max')
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 5000, see https://github.com/binance-exchange/binance-official-api-docs/blob/master/rest-api.md#order-book
                    const response = await this.wwwGetOrderFetchOrderbook(this.extend(request, params));
                    //
                    //     {
                    //         "bids":[
                    //             [49352.04,0.843948],
                    //             [49352.03,0.742048],
                    //             [49349.78,0.686239],
                    //         ],
                    //         "asks":[
                    //             [49443.59,0.065137],
                    //             [49444.63,0.098211],
                    //             [49449.01,0.066309],
                    //         ],
                    //         "timestamp":1619172786577,
                    //         "datetime":"2021-04-23T10:13:06.577Z",
                    //         "nonce":""
                    //     }
                    //
                    const timestamp = this.safeInteger(response, 'timestamp');
                    return this.parseOrderBook(response, symbol, timestamp);
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "symbol":"BTC/INR",
                    //         "info":{
                    //             "highest_buy_bid":4368494.31,
                    //             "lowest_sell_bid":4374835.09,
                    //             "last_traded_price":4374835.09,
                    //             "yes_price":4531016.27,
                    //             "volume":{"max":"4569119.23","min":"4254552.13","volume":62.17722344}
                    //         },
                    //         "timestamp":1619100020845,
                    //         "datetime":1619100020845,
                    //         "high":"4569119.23",
                    //         "low":"4254552.13",
                    //         "bid":4368494.31,
                    //         "bidVolume":"",
                    //         "ask":4374835.09,
                    //         "askVolume":"",
                    //         "vwap":"",
                    //         "open":4531016.27,
                    //         "close":4374835.09,
                    //         "last":4374835.09,
                    //         "baseVolume":62.17722344,
                    //         "quoteVolume":"",
                    //         "previousClose":"",
                    //         "change":-156181.1799999997,
                    //         "percentage":-3.446934874943623,
                    //         "average":4452925.68
                    //     }
                    //
                    const timestamp = this.safeInteger(ticker, 'timestamp');
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': this.safeString(ticker, 'bidVolume'),
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': this.safeString(ticker, 'askVolume'),
                        'vwap': this.safeString(ticker, 'vwap'),
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': this.safeString(ticker, 'previousClose'),
                        'change': this.safeString(ticker, 'change'),
                        'percentage': this.safeString(ticker, 'percentage'),
                        'average': this.safeString(ticker, 'average'),
                        'baseVolume': this.safeString(ticker, 'baseVolume'),
                        'quoteVolume': this.safeString(ticker, 'quoteVolume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.wwwGetOrderFetchTickers(params);
                    //
                    //     {
                    //         "BTC/INR":{
                    //             "symbol":"BTC/INR",
                    //             "info":{
                    //                 "highest_buy_bid":4368494.31,
                    //                 "lowest_sell_bid":4374835.09,
                    //                 "last_traded_price":4374835.09,
                    //                 "yes_price":4531016.27,
                    //                 "volume":{"max":"4569119.23","min":"4254552.13","volume":62.17722344}
                    //             },
                    //             "timestamp":1619100020845,
                    //             "datetime":1619100020845,
                    //             "high":"4569119.23",
                    //             "low":"4254552.13",
                    //             "bid":4368494.31,
                    //             "bidVolume":"",
                    //             "ask":4374835.09,
                    //             "askVolume":"",
                    //             "vwap":"",
                    //             "open":4531016.27,
                    //             "close":4374835.09,
                    //             "last":4374835.09,
                    //             "baseVolume":62.17722344,
                    //             "quoteVolume":"",
                    //             "previousClose":"",
                    //             "change":-156181.1799999997,
                    //             "percentage":-3.446934874943623,
                    //             "average":4452925.68
                    //         }
                    //     }
                    //
                    return this.parseTickers(response, symbols);
                }
                parseBalance(response) {
                    const timestamp = undefined;
                    const result = {
                        'info': response,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    };
                    const data = this.safeValue(response, 'data', {});
                    const keys = Object.keys(data);
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        const parts = key.split('availableorder');
                        const numParts = parts.length;
                        if (numParts > 1) {
                            const currencyId = this.safeString(parts, 1);
                            if (currencyId !== 'Money') {
                                const code = this.safeCurrencyCode(currencyId);
                                const account = this.account();
                                account['free'] = this.safeString(data, key);
                                account['used'] = this.safeString(data, 'inorder' + currencyId);
                                result[code] = account;
                            }
                        }
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.v1PostCurrentCoinBalanceEVERYTHING(params);
                    //
                    //     {
                    //         "data":{
                    //             "availableorderMoney":0,
                    //             "availableorderBTC":0,
                    //             "availableorderXRP":0,
                    //             "inorderMoney":0,
                    //             "inorderBTC":0,
                    //             "inorderXRP":0,
                    //             "inorderNEO":0,
                    //         },
                    //         "status":1,
                    //         "error":null,
                    //         "code":200
                    //     }
                    //
                    return this.parseBalance(response);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '0': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "data":"Successfully placed bid to purchase currency",
                    //         "status":1,
                    //         "error":null,
                    //         "id":5424475,
                    //         "code":200
                    //     }
                    //
                    // fetchOrder
                    //
                    //     {
                    //         "entry_id":5424475,
                    //         "btc":0.01,
                    //         "rate":2000,
                    //         "time":"2021-04-25T17:05:42.000Z",
                    //         "type":0,
                    //         "status":0,
                    //         "total":0.01,
                    //         "avg_cost":null,
                    //         "side":"BUY",
                    //         "amount":0.01,
                    //         "remaining":0.01,
                    //         "filled":0,
                    //         "cost":null,
                    //         "fee":0.05
                    //     }
                    //
                    // fetchOpenOrders
                    //
                    //     {
                    //         "entry_id":5424475,
                    //         "btc":0.01,
                    //         "rate":2000,
                    //         "time":"2021-04-25T17:05:42.000Z",
                    //         "type":0,
                    //         "status":0
                    //     }
                    //
                    const id = this.safeString2(order, 'id', 'entry_id');
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.parse8601(this.safeString(order, 'time'));
                    const price = this.safeString(order, 'rate');
                    const amount = this.safeString2(order, 'amount', 'btc');
                    const filled = this.safeString(order, 'filled');
                    const remaining = this.safeString(order, 'remaining');
                    const average = this.safeString(order, 'avg_cost');
                    const cost = this.safeString(order, 'cost');
                    let type = this.safeStringLower(order, 'type');
                    if (type === '0') type = 'limit';
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const side = this.safeStringLower(order, 'side');
                    const feeCost = this.safeNumber(order, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined) {
                        const feeCurrencyCode = undefined;
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': cost,
                        'average': average,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (type !== 'limit' && type !== 'market') throw new ExchangeError1(this.id + ' allows limit and market orders only');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'side': side.toUpperCase(),
                        'symbol': market['uppercaseId'],
                        'quantity': this.amountToPrecision(symbol, amount)
                    };
                    let method = 'v2PostOrders';
                    if (type === 'limit') request['rate'] = this.priceToPrecision(symbol, price);
                    else if (type === 'market') {
                        method = 'v1PostPlaceMarketOrderQntySymbol';
                        request['market'] = market['quoteId'];
                    } else throw new ExchangeError1(this.id + ' allows limit and market orders only');
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "data":"Successfully placed bid to purchase currency",
                    //         "status":1,
                    //         "error":null,
                    //         "id":5424475,
                    //         "code":200
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const quoteSide = market['quoteId'] === 'USDT' ? 'usdtcancelOrder' : 'cancelOrder';
                    const request = {
                        'entry_id': id,
                        'symbol': market['uppercaseId'],
                        'side': quoteSide
                    };
                    const response = await this.v2PostCancel(this.extend(request, params));
                    return this.parseOrder(response, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'entry_id': id
                    };
                    const response = await this.v1PostOrderStatusSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "entry_id":5424475,
                    //                 "btc":0.01,
                    //                 "rate":2000,
                    //                 "time":"2021-04-25T17:05:42.000Z",
                    //                 "type":0,
                    //                 "status":0,
                    //                 "total":0.01,
                    //                 "avg_cost":null,
                    //                 "side":"BUY",
                    //                 "amount":0.01,
                    //                 "remaining":0.01,
                    //                 "filled":0,
                    //                 "cost":null,
                    //                 "fee":0.05
                    //             }
                    //         ],
                    //         "status":1,
                    //         "error":null,
                    //         "code":200
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const first = this.safeValue(data, 0);
                    return this.parseOrder(first, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const quoteSide = market['quoteId'] === 'USDT' ? 'usdtListOpenOrders' : 'listOpenOrders';
                    const request = {
                        'symbol': market['uppercaseId'],
                        'side': quoteSide,
                        'page': 0
                    };
                    const response = await this.v2PostGetordersnew(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "entry_id":5424475,
                    //                 "btc":0.01,
                    //                 "rate":2000,
                    //                 "time":"2021-04-25T17:05:42.000Z",
                    //                 "type":0,
                    //                 "status":0
                    //             }
                    //         ],
                    //         "status":1,
                    //         "error":null,
                    //         "code":200
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchMyTrades
                    //
                    //     {
                    //         "type": "BTC Sell order executed",
                    //         "typeI": 6,
                    //         "crypto": 5000,
                    //         "amount": 35.4,
                    //         "rate": 709800,
                    //         "date": "2020-05-22T15:05:34.000Z",
                    //         "unit": "INR",
                    //         "factor": 100000000,
                    //         "fee": 0.09,
                    //         "delh_btc": -5000,
                    //         "delh_inr": 0,
                    //         "del_btc": 0,
                    //         "del_inr": 35.4,
                    //         "id": "2938823"
                    //     }
                    //
                    // fetchTrades
                    //
                    //     {
                    //         "tradeId":"1909151",
                    //         "price":"61904.6300",
                    //         "quote_volume":1618.05,
                    //         "base_volume":0.02607254,
                    //         "timestamp":1634548602000,
                    //         "type":"buy"
                    //     }
                    //
                    market = this.safeMarket(undefined, market);
                    const orderId = this.safeString2(trade, 'id', 'tradeId');
                    let timestamp = this.parse8601(this.safeString(trade, 'date'));
                    timestamp = this.safeInteger(trade, 'timestamp', timestamp);
                    const priceString = this.safeString2(trade, 'rate', 'price');
                    let amountString = this.safeString(trade, 'amount');
                    let side = this.safeStringLower(trade, 'type');
                    if (side !== undefined) {
                        if (side.indexOf('buy') >= 0) side = 'buy';
                        else if (side.indexOf('sell') >= 0) side = 'sell';
                    }
                    const factor = this.safeString(trade, 'factor');
                    let costString = undefined;
                    if (factor !== undefined) amountString = Precise.stringDiv(amountString, factor);
                    else {
                        amountString = this.safeString(trade, 'base_volume');
                        costString = this.safeString(trade, 'quote_volume');
                    }
                    const symbol = market['symbol'];
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) {
                        const feeCurrencyCode = market['quote'];
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': orderId,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'page': 0
                    };
                    if (since !== undefined) request['since'] = this.iso8601(since);
                    const response = await this.v1PostListExecutedOrdersSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "data": [
                    //             {
                    //                 "type": "BTC Sell order executed",
                    //                 "typeI": 6,
                    //                 "crypto": 5000,
                    //                 "amount": 35.4,
                    //                 "rate": 709800,
                    //                 "date": "2020-05-22T15:05:34.000Z",
                    //                 "unit": "INR",
                    //                 "factor": 100000000,
                    //                 "fee": 0.09,
                    //                 "delh_btc": -5000,
                    //                 "delh_inr": 0,
                    //                 "del_btc": 0,
                    //                 "del_inr": 35.4,
                    //                 "id": "2938823"
                    //             },
                    //             {
                    //                 "type": "BTC Sell order executed",
                    //                 "typeI": 6,
                    //                 "crypto": 195000,
                    //                 "amount": 1380.58,
                    //                 "rate": 709765.5,
                    //                 "date": "2020-05-22T15:05:34.000Z",
                    //                 "unit": "INR",
                    //                 "factor": 100000000,
                    //                 "fee": 3.47,
                    //                 "delh_btc": -195000,
                    //                 "delh_inr": 0,
                    //                 "del_btc": 0,
                    //                 "del_inr": 1380.58,
                    //                 "id": "2938823"
                    //             }
                    //         ],
                    //         "status": 1,
                    //         "error": null,
                    //         "code": 200
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'coin': market['baseId'],
                        'market': market['quoteId']
                    };
                    const response = await this.wwwGetExchangeDataTradedetails(this.extend(request, params));
                    //
                    //     [
                    //         {"tradeId":"1909151","price":"61904.6300","quote_volume":1618.05,"base_volume":0.02607254,"timestamp":1634548602000,"type":"buy"},
                    //         {"tradeId":"1909153","price":"61893.9000","quote_volume":16384.42,"base_volume":0.26405767,"timestamp":1634548999000,"type":"sell"},
                    //         {"tradeId":"1909155","price":"61853.1100","quote_volume":2304.37,"base_volume":0.03716263,"timestamp":1634549670000,"type":"sell"}
                    //     }
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires a currency code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'symbol': currency['id'],
                        'page': 0
                    };
                    const response = await this.v1PostDepositHistorySymbol(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "type":"USDT deposited",
                    //                 "typeI":1,
                    //                 "amount":100,
                    //                 "date":"2021-04-24T14:56:04.000Z",
                    //                 "unit":"USDT",
                    //                 "factor":100,
                    //                 "fee":0,
                    //                 "delh_btc":0,
                    //                 "delh_inr":0,
                    //                 "rate":0,
                    //                 "del_btc":10000,
                    //                 "del_inr":0
                    //             }
                    //         ],
                    //         "status":1,
                    //         "error":null,
                    //         "code":200
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchWithdrawals() requires a currency code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'symbol': currency['id'],
                        'page': 0
                    };
                    const response = await this.v1PostWithdrawHistorySymbol(this.extend(request, params));
                    //
                    //     ...
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, currency, since, limit);
                }
                parseTransactionStatusByType(status, type) {
                    const statusesByType = {
                        'deposit': {
                            '0': 'pending',
                            '1': 'ok'
                        },
                        'withdrawal': {
                            '0': 'pending',
                            '1': 'canceled',
                            '2': 'pending',
                            '3': 'failed',
                            '4': 'pending',
                            '5': 'failed',
                            '6': 'ok'
                        }
                    };
                    const statuses = this.safeValue(statusesByType, type, {});
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "type":"USDT deposited",
                    //         "typeI":1,
                    //         "amount":100,
                    //         "date":"2021-04-24T14:56:04.000Z",
                    //         "unit":"USDT",
                    //         "factor":100,
                    //         "fee":0,
                    //         "delh_btc":0,
                    //         "delh_inr":0,
                    //         "rate":0,
                    //         "del_btc":10000,
                    //         "del_inr":0
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     ...
                    //
                    const currencyId = this.safeString(transaction, 'unit');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const timestamp = this.parse8601(this.safeString(transaction, 'date'));
                    let type = this.safeString(transaction, 'type');
                    let status = undefined;
                    if (type !== undefined) {
                        if (type.indexOf('deposit') >= 0) {
                            type = 'deposit';
                            status = 'ok';
                        } else if (type.indexOf('withdraw') >= 0) type = 'withdrawal';
                    }
                    // const status = this.parseTransactionStatusByType (this.safeString (transaction, 'status'), type);
                    const amount = this.safeNumber(transaction, 'amount');
                    const feeCost = this.safeNumber(transaction, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'currency': code,
                        'cost': feeCost
                    };
                    return {
                        'info': transaction,
                        'id': undefined,
                        'txid': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'internal': undefined,
                        'fee': fee
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'symbol': currency['id']
                    };
                    const response = await this.v1PostGetCoinAddressSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "token":"0x680dee9edfff0c397736e10b017cf6a0aee4ba31",
                    //             "expiry":"2022-04-24 22:30:11"
                    //         },
                    //         "status":1,
                    //         "error":null
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const address = this.safeString(data, 'token');
                    const tag = this.safeString(data, 'tag');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'www', method = 'GET', params = {}, headers, body) {
                    if (!(api in this.urls['api'])) throw new ExchangeError1(this.id + ' does not have a testnet/sandbox URL for ' + api + ' endpoints');
                    if (api !== 'www') {
                        this.checkRequiredCredentials();
                        headers = {
                            'X-BITBNS-APIKEY': this.apiKey
                        };
                    }
                    const baseUrl = this.implodeHostname(this.urls['api'][api]);
                    let url = baseUrl + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    const nonce = this.nonce().toString();
                    if (method === 'GET') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (method === 'POST') {
                        if (Object.keys(query).length) body = this.json(query);
                        else body = '{}';
                        const auth = {
                            'timeStamp_nonce': nonce,
                            'body': body
                        };
                        const payload = this.stringToBase64(this.json(auth));
                        const signature = this.hmac(payload, this.encode(this.secret), 'sha512');
                        headers['X-BITBNS-PAYLOAD'] = this.decode(payload);
                        headers['X-BITBNS-SIGNATURE'] = signature;
                        headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //     {"msg":"Invalid Request","status":-1,"code":400}
                    //     {"data":[],"status":0,"error":"Nothing to show","code":417}
                    //
                    const code = this.safeString(response, 'code');
                    const message = this.safeString(response, 'msg');
                    const error = code !== undefined && code !== '200';
                    if (error || message !== undefined) {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    31: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const fmfwio = require1('./fmfwio.js');
            //  ---------------------------------------------------------------------------
            module.exports = class bitcoincom extends fmfwio {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitcoincom'
                    });
                }
            };
        },
        {
            "./fmfwio.js": 80
        }
    ],
    32: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { NotSupported: NotSupported, RateLimitExceeded: RateLimitExceeded, AuthenticationError: AuthenticationError, PermissionDenied: PermissionDenied, ArgumentsRequired: ArgumentsRequired1, ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, InvalidNonce: InvalidNonce, BadSymbol: BadSymbol } = require1('./base/errors');
            const { SIGNIFICANT_DIGITS: SIGNIFICANT_DIGITS, DECIMAL_PLACES: DECIMAL_PLACES, TRUNCATE: TRUNCATE, ROUND: ROUND } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bitfinex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitfinex',
                        'name': 'Bitfinex',
                        'countries': [
                            'VG'
                        ],
                        'version': 'v1',
                        // cheapest is 90 requests a minute = 1.5 requests per second on average => ( 1000ms / 1.5) = 666.666 ms between requests on average
                        'rateLimit': 666.666,
                        'pro': true,
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': undefined,
                            'fetchFundingFees': true,
                            'fetchIndexOHLCV': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPositions': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': false,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': true,
                            'fetchWithdrawals': undefined,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '3h': '3h',
                            '4h': '4h',
                            '6h': '6h',
                            '12h': '12h',
                            '1d': '1D',
                            '1w': '7D',
                            '2w': '14D',
                            '1M': '1M'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766244-e328a50c-5ed2-11e7-947b-041416579bb3.jpg',
                            'api': {
                                'v2': 'https://api-pub.bitfinex.com',
                                'public': 'https://api.bitfinex.com',
                                'private': 'https://api.bitfinex.com'
                            },
                            'www': 'https://www.bitfinex.com',
                            'referral': 'https://www.bitfinex.com/?refcode=P61eYxFL',
                            'doc': [
                                'https://docs.bitfinex.com/v1/docs',
                                'https://github.com/bitfinexcom/bitfinex-api-node'
                            ]
                        },
                        'api': {
                            // v2 symbol ids require a 't' prefix
                            // just the public part of it (use bitfinex2 for everything else)
                            'v2': {
                                'get': {
                                    'platform/status': 3,
                                    'tickers': 1,
                                    'ticker/{symbol}': 1,
                                    'tickers/hist': 1,
                                    'trades/{symbol}/hist': 1,
                                    'book/{symbol}/{precision}': 0.375,
                                    'book/{symbol}/P0': 0.375,
                                    'book/{symbol}/P1': 0.375,
                                    'book/{symbol}/P2': 0.375,
                                    'book/{symbol}/P3': 0.375,
                                    'book/{symbol}/R0': 0.375,
                                    'stats1/{key}:{size}:{symbol}:{side}/{section}': 1,
                                    'stats1/{key}:{size}:{symbol}/{section}': 1,
                                    'stats1/{key}:{size}:{symbol}:long/last': 1,
                                    'stats1/{key}:{size}:{symbol}:long/hist': 1,
                                    'stats1/{key}:{size}:{symbol}:short/last': 1,
                                    'stats1/{key}:{size}:{symbol}:short/hist': 1,
                                    'candles/trade:{timeframe}:{symbol}/{section}': 1,
                                    'candles/trade:{timeframe}:{symbol}/last': 1,
                                    'candles/trade:{timeframe}:{symbol}/hist': 1
                                }
                            },
                            'public': {
                                'get': {
                                    'book/{symbol}': 1,
                                    // 'candles/{symbol}':0,
                                    'lendbook/{currency}': 6,
                                    'lends/{currency}': 3,
                                    'pubticker/{symbol}': 3,
                                    'stats/{symbol}': 6,
                                    'symbols': 18,
                                    'symbols_details': 18,
                                    'tickers': 1,
                                    'trades/{symbol}': 3
                                }
                            },
                            'private': {
                                'post': {
                                    'account_fees': 18,
                                    'account_infos': 6,
                                    'balances': 9.036,
                                    'basket_manage': 6,
                                    'credits': 6,
                                    'deposit/new': 18,
                                    'funding/close': 6,
                                    'history': 6,
                                    'history/movements': 6,
                                    'key_info': 6,
                                    'margin_infos': 3,
                                    'mytrades': 3,
                                    'mytrades_funding': 6,
                                    'offer/cancel': 6,
                                    'offer/new': 6,
                                    'offer/status': 6,
                                    'offers': 6,
                                    'offers/hist': 90.03,
                                    'order/cancel': 0.2,
                                    'order/cancel/all': 0.2,
                                    'order/cancel/multi': 0.2,
                                    'order/cancel/replace': 0.2,
                                    'order/new': 0.2,
                                    'order/new/multi': 0.2,
                                    'order/status': 0.2,
                                    'orders': 0.2,
                                    'orders/hist': 90.03,
                                    'position/claim': 18,
                                    'position/close': 18,
                                    'positions': 18,
                                    'summary': 18,
                                    'taken_funds': 6,
                                    'total_taken_funds': 6,
                                    'transfer': 18,
                                    'unused_taken_funds': 6,
                                    'withdraw': 18
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': true,
                                'percentage': true,
                                'maker': this.parseNumber('0.001'),
                                'taker': this.parseNumber('0.002'),
                                'tiers': {
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('500000'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('2500000'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('7500000'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('10000000'),
                                            this.parseNumber('0.0018')
                                        ],
                                        [
                                            this.parseNumber('15000000'),
                                            this.parseNumber('0.0016')
                                        ],
                                        [
                                            this.parseNumber('20000000'),
                                            this.parseNumber('0.0014')
                                        ],
                                        [
                                            this.parseNumber('25000000'),
                                            this.parseNumber('0.0012')
                                        ],
                                        [
                                            this.parseNumber('30000000'),
                                            this.parseNumber('0.001')
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.001')
                                        ],
                                        [
                                            this.parseNumber('500000'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('2500000'),
                                            this.parseNumber('0.0004')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.0002')
                                        ],
                                        [
                                            this.parseNumber('7500000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('10000000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('15000000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('20000000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('25000000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('30000000'),
                                            this.parseNumber('0')
                                        ]
                                    ]
                                }
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false,
                                // Actually deposit fees are free for larger deposits (> $1000 USD equivalent)
                                // these values below are deprecated, we should not hardcode fees and limits anymore
                                // to be reimplemented with bitfinex funding fees from their API or web endpoints
                                'deposit': {},
                                'withdraw': {}
                            }
                        },
                        // todo rewrite for https://api-pub.bitfinex.com//v2/conf/pub:map:tx:method
                        'commonCurrencies': {
                            'ALG': 'ALGO',
                            'AMP': 'AMPL',
                            'ATO': 'ATOM',
                            'BCHABC': 'XEC',
                            'BCHN': 'BCH',
                            'DAT': 'DATA',
                            'DOG': 'MDOGE',
                            'DSH': 'DASH',
                            // https://github.com/ccxt/ccxt/issues/7399
                            // https://coinmarketcap.com/currencies/pnetwork/
                            // https://en.cryptonomist.ch/blog/eidoo/the-edo-to-pnt-upgrade-what-you-need-to-know-updated/
                            'EDO': 'PNT',
                            'EUS': 'EURS',
                            'EUT': 'EURT',
                            'IDX': 'ID',
                            'IOT': 'IOTA',
                            'IQX': 'IQ',
                            'MNA': 'MANA',
                            'ORS': 'ORS Group',
                            'PAS': 'PASS',
                            'QSH': 'QASH',
                            'QTM': 'QTUM',
                            'RBT': 'RBTC',
                            'SNG': 'SNGLS',
                            'STJ': 'STORJ',
                            'TERRAUST': 'UST',
                            'TSD': 'TUSD',
                            'YGG': 'YEED',
                            'YYW': 'YOYOW',
                            'UDC': 'USDC',
                            'UST': 'USDT',
                            'VSY': 'VSYS',
                            'WAX': 'WAXP',
                            'XCH': 'XCHF',
                            'ZBT': 'ZB'
                        },
                        'exceptions': {
                            'exact': {
                                'temporarily_unavailable': ExchangeNotAvailable,
                                'Order could not be cancelled.': OrderNotFound,
                                'No such order found.': OrderNotFound,
                                'Order price must be positive.': InvalidOrder,
                                'Could not find a key matching the given X-BFX-APIKEY.': AuthenticationError,
                                'Key price should be a decimal number, e.g. "123.456"': InvalidOrder,
                                'Key amount should be a decimal number, e.g. "123.456"': InvalidOrder,
                                'ERR_RATE_LIMIT': RateLimitExceeded,
                                'Ratelimit': RateLimitExceeded,
                                'Nonce is too small.': InvalidNonce,
                                'No summary found.': ExchangeError1,
                                'Cannot evaluate your available balance, please try again': ExchangeNotAvailable,
                                'Unknown symbol': BadSymbol,
                                'Cannot complete transfer. Exchange balance insufficient.': InsufficientFunds,
                                'Momentary balance check. Please wait few seconds and try the transfer again.': ExchangeError1
                            },
                            'broad': {
                                'Invalid X-BFX-SIGNATURE': AuthenticationError,
                                'This API key does not have permission': PermissionDenied,
                                'not enough exchange balance for ': InsufficientFunds,
                                'minimum size for ': InvalidOrder,
                                'Invalid order': InvalidOrder,
                                'The available balance is only': InsufficientFunds
                            }
                        },
                        'precisionMode': SIGNIFICANT_DIGITS,
                        'options': {
                            'currencyNames': {
                                'AGI': 'agi',
                                'AID': 'aid',
                                'AIO': 'aio',
                                'ANT': 'ant',
                                'AVT': 'aventus',
                                'BAT': 'bat',
                                // https://github.com/ccxt/ccxt/issues/5833
                                'BCH': 'bab',
                                // 'BCH': 'bcash', // undocumented
                                'BCI': 'bci',
                                'BFT': 'bft',
                                'BSV': 'bsv',
                                'BTC': 'bitcoin',
                                'BTG': 'bgold',
                                'CFI': 'cfi',
                                'COMP': 'comp',
                                'DAI': 'dai',
                                'DADI': 'dad',
                                'DASH': 'dash',
                                'DATA': 'datacoin',
                                'DTH': 'dth',
                                'EDO': 'eidoo',
                                'ELF': 'elf',
                                'EOS': 'eos',
                                'ETC': 'ethereumc',
                                'ETH': 'ethereum',
                                'ETP': 'metaverse',
                                'FUN': 'fun',
                                'GNT': 'golem',
                                'IOST': 'ios',
                                'IOTA': 'iota',
                                // https://github.com/ccxt/ccxt/issues/5833
                                'LEO': 'let',
                                // 'LEO': 'les', // EOS chain
                                'LINK': 'link',
                                'LRC': 'lrc',
                                'LTC': 'litecoin',
                                'LYM': 'lym',
                                'MANA': 'mna',
                                'MIT': 'mit',
                                'MKR': 'mkr',
                                'MTN': 'mtn',
                                'NEO': 'neo',
                                'ODE': 'ode',
                                'OMG': 'omisego',
                                'OMNI': 'mastercoin',
                                'QASH': 'qash',
                                'QTUM': 'qtum',
                                'RCN': 'rcn',
                                'RDN': 'rdn',
                                'REP': 'rep',
                                'REQ': 'req',
                                'RLC': 'rlc',
                                'SAN': 'santiment',
                                'SNGLS': 'sng',
                                'SNT': 'status',
                                'SPANK': 'spk',
                                'STORJ': 'stj',
                                'TNB': 'tnb',
                                'TRX': 'trx',
                                'TUSD': 'tsd',
                                'USD': 'wire',
                                'USDC': 'udc',
                                'UTK': 'utk',
                                'USDT': 'tetheruso',
                                // 'USDT': 'tetheruse', // Tether on ERC20
                                // 'USDT': 'tetherusl', // Tether on Liquid
                                // 'USDT': 'tetherusx', // Tether on Tron
                                // 'USDT': 'tetheruss', // Tether on EOS
                                'VEE': 'vee',
                                'WAX': 'wax',
                                'XLM': 'xlm',
                                'XMR': 'monero',
                                'XRP': 'ripple',
                                'XVG': 'xvg',
                                'YOYOW': 'yoyow',
                                'ZEC': 'zcash',
                                'ZRX': 'zrx',
                                'XTZ': 'xtz'
                            },
                            'orderTypes': {
                                'limit': 'exchange limit',
                                'market': 'exchange market'
                            },
                            'fiat': {
                                'USD': 'USD',
                                'EUR': 'EUR',
                                'JPY': 'JPY',
                                'GBP': 'GBP',
                                'CNH': 'CNH'
                            },
                            'accountsByType': {
                                'spot': 'exchange',
                                'margin': 'trading',
                                'funding': 'deposit',
                                'swap': 'trading'
                            }
                        }
                    });
                }
                async fetchFundingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostAccountFees(params);
                    const fees = response['withdraw'];
                    const withdraw = {};
                    const ids = Object.keys(fees);
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const code = this.safeCurrencyCode(id);
                        withdraw[code] = this.safeNumber(fees, id);
                    }
                    return {
                        'info': response,
                        'withdraw': withdraw,
                        'deposit': withdraw
                    };
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostSummary(params);
                    //
                    //     {
                    //          time: '2022-02-23T16:05:47.659000Z',
                    //          status: { resid_hint: null, login_last: '2022-02-23T16:05:48Z' },
                    //          is_locked: false,
                    //          leo_lev: '0',
                    //          leo_amount_avg: '0.0',
                    //          trade_vol_30d: [
                    //          {
                    //              curr: 'Total (USD)',
                    //              vol: '0.0',
                    //              vol_safe: '0.0',
                    //              vol_maker: '0.0',
                    //              vol_BFX: '0.0',
                    //              vol_BFX_safe: '0.0',
                    //              vol_BFX_maker: '0.0'
                    //          }
                    //          ],
                    //          fees_funding_30d: {},
                    //          fees_funding_total_30d: '0',
                    //          fees_trading_30d: {},
                    //          fees_trading_total_30d: '0',
                    //          rebates_trading_30d: {},
                    //          rebates_trading_total_30d: '0',
                    //          maker_fee: '0.001',
                    //          taker_fee: '0.002',
                    //          maker_fee_2crypto: '0.001',
                    //          maker_fee_2stablecoin: '0.001',
                    //          maker_fee_2fiat: '0.001',
                    //          maker_fee_2deriv: '0.0002',
                    //          taker_fee_2crypto: '0.002',
                    //          taker_fee_2stablecoin: '0.002',
                    //          taker_fee_2fiat: '0.002',
                    //          taker_fee_2deriv: '0.00065',
                    //          deriv_maker_rebate: '0.0002',
                    //          deriv_taker_fee: '0.00065',
                    //          trade_last: null
                    //     }
                    //
                    const result = {};
                    const fiat = this.safeValue(this.options, 'fiat', {});
                    const makerFee = this.safeNumber(response, 'maker_fee');
                    const takerFee = this.safeNumber(response, 'taker_fee');
                    const makerFee2Fiat = this.safeNumber(response, 'maker_fee_2fiat');
                    const takerFee2Fiat = this.safeNumber(response, 'taker_fee_2fiat');
                    const makerFee2Deriv = this.safeNumber(response, 'maker_fee_2deriv');
                    const takerFee2Deriv = this.safeNumber(response, 'taker_fee_2deriv');
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        const fee = {
                            'info': response,
                            'symbol': symbol,
                            'percentage': true,
                            'tierBased': true
                        };
                        if (market['quote'] in fiat) {
                            fee['maker'] = makerFee2Fiat;
                            fee['taker'] = takerFee2Fiat;
                        } else if (market['contract']) {
                            fee['maker'] = makerFee2Deriv;
                            fee['taker'] = takerFee2Deriv;
                        } else {
                            fee['maker'] = makerFee;
                            fee['taker'] = takerFee;
                        }
                        result[symbol] = fee;
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const ids = await this.publicGetSymbols();
                    //
                    //     [ "btcusd", "ltcusd", "ltcbtc" ]
                    //
                    const details = await this.publicGetSymbolsDetails();
                    //
                    //     [
                    //         {
                    //             "pair":"btcusd",
                    //             "price_precision":5,
                    //             "initial_margin":"10.0",
                    //             "minimum_margin":"5.0",
                    //             "maximum_order_size":"2000.0",
                    //             "minimum_order_size":"0.0002",
                    //             "expiration":"NA",
                    //             "margin":true
                    //         },
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < details.length; i++){
                        const market = details[i];
                        let id = this.safeString(market, 'pair');
                        if (!this.inArray(id, ids)) continue;
                        id = id.toUpperCase();
                        let baseId = undefined;
                        let quoteId = undefined;
                        if (id.indexOf(':') >= 0) {
                            const parts = id.split(':');
                            baseId = parts[0];
                            quoteId = parts[1];
                        } else {
                            baseId = id.slice(0, 3);
                            quoteId = id.slice(3, 6);
                        }
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': this.safeValue(market, 'margin'),
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                // https://docs.bitfinex.com/docs/introduction#amount-precision
                                // The amount field allows up to 8 decimals.
                                // Anything exceeding this will be rounded to the 8th decimal.
                                'amount': parseInt('8'),
                                'price': this.safeInteger(market, 'price_precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minimum_order_size'),
                                    'max': this.safeNumber(market, 'maximum_order_size')
                                },
                                'price': {
                                    'min': this.parseNumber('1e-8'),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                amountToPrecision(symbol, amount) {
                    // https://docs.bitfinex.com/docs/introduction#amount-precision
                    // The amount field allows up to 8 decimals.
                    // Anything exceeding this will be rounded to the 8th decimal.
                    return this.decimalToPrecision(amount, TRUNCATE, this.markets[symbol]['precision']['amount'], DECIMAL_PLACES);
                }
                priceToPrecision(symbol, price) {
                    price = this.decimalToPrecision(price, ROUND, this.markets[symbol]['precision']['price'], this.precisionMode);
                    // https://docs.bitfinex.com/docs/introduction#price-precision
                    // The precision level of all trading prices is based on significant figures.
                    // All pairs on Bitfinex use up to 5 significant digits and up to 8 decimals (e.g. 1.2345, 123.45, 1234.5, 0.00012345).
                    // Prices submit with a precision larger than 5 will be cut by the API.
                    return this.decimalToPrecision(price, TRUNCATE, 8, DECIMAL_PLACES);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const requestedType = this.safeString(params, 'type', 'exchange');
                    const accountType = this.safeString(accountsByType, requestedType, requestedType);
                    if (accountType === undefined) {
                        const keys = Object.keys(accountsByType);
                        throw new ExchangeError1(this.id + ' fetchBalance() type parameter must be one of ' + keys.join(', '));
                    }
                    const query = this.omit(params, 'type');
                    const response = await this.privatePostBalances(query);
                    //    [ { type: 'deposit',
                    //        currency: 'btc',
                    //        amount: '0.00116721',
                    //        available: '0.00116721' },
                    //      { type: 'exchange',
                    //        currency: 'ust',
                    //        amount: '0.0000002',
                    //        available: '0.0000002' },
                    //      { type: 'trading',
                    //        currency: 'btc',
                    //        amount: '0.0005',
                    //        available: '0.0005' } ],
                    const result = {
                        'info': response
                    };
                    const isDerivative = requestedType === 'derivatives';
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const type = this.safeString(balance, 'type');
                        const currencyId = this.safeStringLower(balance, 'currency', '');
                        const start = currencyId.length - 2;
                        const isDerivativeCode = currencyId.slice(start) === 'f0';
                        // this will only filter the derivative codes if the requestedType is 'derivatives'
                        const derivativeCondition = !isDerivative || isDerivativeCode;
                        if (accountType === type && derivativeCondition) {
                            const code = this.safeCurrencyCode(currencyId);
                            // bitfinex had BCH previously, now it's BAB, but the old
                            // BCH symbol is kept for backward-compatibility
                            // we need a workaround here so that the old BCH balance
                            // would not override the new BAB balance (BAB is unified to BCH)
                            // https://github.com/ccxt/ccxt/issues/4989
                            if (!(code in result)) {
                                const account = this.account();
                                account['free'] = this.safeString(balance, 'available');
                                account['total'] = this.safeString(balance, 'amount');
                                result[code] = account;
                            }
                        }
                    }
                    return this.safeBalance(result);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    // transferring between derivatives wallet and regular wallet is not documented in their API
                    // however we support it in CCXT (from just looking at web inspector)
                    await this.loadMarkets();
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                    const toId = this.safeString(accountsByType, toAccount, toAccount);
                    const currency = this.currency(code);
                    const fromCurrencyId = this.convertDerivativesId(currency['id'], fromAccount);
                    const toCurrencyId = this.convertDerivativesId(currency['id'], toAccount);
                    const requestedAmount = this.currencyToPrecision(code, amount);
                    const request = {
                        'amount': requestedAmount,
                        'currency': fromCurrencyId,
                        'currency_to': toCurrencyId,
                        'walletfrom': fromId,
                        'walletto': toId
                    };
                    const response = await this.privatePostTransfer(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             status: 'success',
                    //             message: '0.0001 Bitcoin transfered from Margin to Exchange'
                    //         }
                    //     ]
                    //
                    const result = this.safeValue(response, 0);
                    const message = this.safeString(result, 'message');
                    if (message === undefined) throw new ExchangeError1(this.id + ' transfer failed');
                    return this.extend(this.parseTransfer(result, currency), {
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'amount': this.parseNumber(requestedAmount)
                    });
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //         status: 'success',
                    //         message: '0.0001 Bitcoin transfered from Margin to Exchange'
                    //     }
                    //
                    const timestamp = this.milliseconds();
                    return {
                        'info': transfer,
                        'id': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': this.safeCurrencyCode(undefined, currency),
                        'amount': undefined,
                        'fromAccount': undefined,
                        'toAccount': undefined,
                        'status': this.parseTransferStatus(this.safeString(transfer, 'status'))
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'SUCCESS': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                convertDerivativesId(currencyId, type) {
                    const start = currencyId.length - 2;
                    const isDerivativeCode = currencyId.slice(start) === 'F0';
                    if (type !== 'derivatives' && type !== 'trading' && type !== 'margin' && isDerivativeCode) currencyId = currencyId.slice(0, start);
                    else if (type === 'derivatives' && !isDerivativeCode) currencyId = currencyId + 'F0';
                    return currencyId;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    if (limit !== undefined) {
                        request['limit_bids'] = limit;
                        request['limit_asks'] = limit;
                    }
                    const response = await this.publicGetBookSymbol(this.extend(request, params));
                    return this.parseOrderBook(response, symbol, undefined, 'bids', 'asks', 'price', 'amount');
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTickers(params);
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const ticker = this.parseTicker(response[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const ticker = await this.publicGetPubtickerSymbol(this.extend(request, params));
                    return this.parseTicker(ticker, market);
                }
                parseTicker(ticker, market) {
                    const timestamp = this.safeTimestamp(ticker, 'timestamp');
                    let symbol = undefined;
                    if (market !== undefined) symbol = market['symbol'];
                    else if ('pair' in ticker) {
                        const marketId = this.safeString(ticker, 'pair');
                        if (marketId !== undefined) {
                            if (marketId in this.markets_by_id) {
                                market = this.markets_by_id[marketId];
                                symbol = market['symbol'];
                            } else {
                                const baseId = marketId.slice(0, 3);
                                const quoteId = marketId.slice(3, 6);
                                const base = this.safeCurrencyCode(baseId);
                                const quote = this.safeCurrencyCode(quoteId);
                                symbol = base + '/' + quote;
                            }
                        }
                    }
                    const last = this.safeString(ticker, 'last_price');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': this.safeString(ticker, 'mid'),
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public) v1
                    //
                    //     {
                    //          "timestamp":1637258380,
                    //          "tid":894452833,
                    //          "price":"0.99941",
                    //          "amount":"261.38",
                    //          "exchange":"bitfinex",
                    //          "type":"sell"
                    //     }
                    //
                    //     {    "timestamp":1637258238,
                    //          "tid":894452800,
                    //          "price":"0.99958",
                    //          "amount":"261.90514",
                    //          "exchange":"bitfinex",
                    //          "type":"buy"
                    //     }
                    //
                    // fetchMyTrades (private) v1
                    //
                    //     {
                    //          "price":"0.99941",
                    //          "amount":"261.38",
                    //          "timestamp":"1637258380.0",
                    //          "type":"Sell",
                    //          "fee_currency":"UST",
                    //          "fee_amount":"-0.52245157",
                    //          "tid":894452833,
                    //          "order_id":78819731373
                    //     }
                    //
                    //     {
                    //         "price":"0.99958",
                    //         "amount":"261.90514",
                    //         "timestamp":"1637258238.0",
                    //         "type":"Buy",
                    //         "fee_currency":"UDC",
                    //         "fee_amount":"-0.52381028",
                    //         "tid":894452800,
                    //         "order_id":78819504838
                    //     }
                    //
                    const id = this.safeString(trade, 'tid');
                    const timestamp = this.safeTimestamp(trade, 'timestamp');
                    const type = undefined;
                    const side = this.safeStringLower(trade, 'type');
                    const orderId = this.safeString(trade, 'order_id');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    let fee = undefined;
                    if ('fee_amount' in trade) {
                        const feeCostString = Precise.stringNeg(this.safeString(trade, 'fee_amount'));
                        const feeCurrencyId = this.safeString(trade, 'fee_currency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': type,
                        'order': orderId,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit = 50, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'limit_trades': limit
                    };
                    if (since !== undefined) request['timestamp'] = parseInt(since / 1000);
                    const response = await this.publicGetTradesSymbol(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a `symbol` argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit_trades'] = limit;
                    if (since !== undefined) request['timestamp'] = parseInt(since / 1000);
                    const response = await this.privatePostMytrades(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    params = this.omit(params, [
                        'postOnly'
                    ]);
                    const request = {
                        'symbol': this.marketId(symbol),
                        'side': side,
                        'amount': this.amountToPrecision(symbol, amount),
                        'type': this.safeString(this.options['orderTypes'], type, type),
                        'ocoorder': false,
                        'buy_price_oco': 0,
                        'sell_price_oco': 0
                    };
                    if (type === 'market') request['price'] = this.nonce().toString();
                    else request['price'] = this.priceToPrecision(symbol, price);
                    if (postOnly) request['is_postonly'] = true;
                    const response = await this.privatePostOrderNew(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const order = {
                        'order_id': parseInt(id)
                    };
                    if (price !== undefined) order['price'] = this.priceToPrecision(symbol, price);
                    if (amount !== undefined) order['amount'] = this.numberToString(amount);
                    if (symbol !== undefined) order['symbol'] = this.marketId(symbol);
                    if (side !== undefined) order['side'] = side;
                    if (type !== undefined) order['type'] = this.safeString(this.options['orderTypes'], type, type);
                    const response = await this.privatePostOrderCancelReplace(this.extend(order, params));
                    return this.parseOrder(response);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': parseInt(id)
                    };
                    return await this.privatePostOrderCancel(this.extend(request, params));
                }
                async cancelAllOrders(symbol, params = {}) {
                    return await this.privatePostOrderCancelAll(params);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //           id: 57334010955,
                    //           cid: 1611584840966,
                    //           cid_date: null,
                    //           gid: null,
                    //           symbol: 'ltcbtc',
                    //           exchange: null,
                    //           price: '0.0042125',
                    //           avg_execution_price: '0.0042097',
                    //           side: 'sell',
                    //           type: 'exchange market',
                    //           timestamp: '1611584841.0',
                    //           is_live: false,
                    //           is_cancelled: false,
                    //           is_hidden: 0,
                    //           oco_order: 0,
                    //           was_forced: false,
                    //           original_amount: '0.205176',
                    //           remaining_amount: '0.0',
                    //           executed_amount: '0.205176',
                    //           src: 'web'
                    //     }
                    //
                    const side = this.safeString(order, 'side');
                    const open = this.safeValue(order, 'is_live');
                    const canceled = this.safeValue(order, 'is_cancelled');
                    let status = undefined;
                    if (open) status = 'open';
                    else if (canceled) status = 'canceled';
                    else status = 'closed';
                    const marketId = this.safeStringUpper(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    let orderType = this.safeString(order, 'type', '');
                    const exchange = orderType.indexOf('exchange ') >= 0;
                    if (exchange) {
                        const parts = order['type'].split(' ');
                        orderType = parts[1];
                    }
                    const timestamp = this.safeTimestamp(order, 'timestamp');
                    const id = this.safeString(order, 'id');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': orderType,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': this.safeString(order, 'price'),
                        'stopPrice': undefined,
                        'average': this.safeString(order, 'avg_execution_price'),
                        'amount': this.safeString(order, 'original_amount'),
                        'remaining': this.safeString(order, 'remaining_amount'),
                        'filled': this.safeString(order, 'executed_amount'),
                        'status': status,
                        'fee': undefined,
                        'cost': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (symbol !== undefined) {
                        if (!(symbol in this.markets)) throw new ExchangeError1(this.id + ' has no symbol ' + symbol);
                    }
                    const response = await this.privatePostOrders(params);
                    let orders = this.parseOrders(response, undefined, since, limit);
                    if (symbol !== undefined) orders = this.filterBy(orders, 'symbol', symbol);
                    return orders;
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privatePostOrdersHist(this.extend(request, params));
                    let orders = this.parseOrders(response, undefined, since, limit);
                    if (symbol !== undefined) orders = this.filterBy(orders, 'symbol', symbol);
                    orders = this.filterByArray(orders, 'status', [
                        'closed',
                        'canceled'
                    ], false);
                    return orders;
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': parseInt(id)
                    };
                    const response = await this.privatePostOrderStatus(this.extend(request, params));
                    return this.parseOrder(response);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1457539800000,
                    //         0.02594,
                    //         0.02594,
                    //         0.02594,
                    //         0.02594,
                    //         0.1
                    //     ]
                    //
                    return [
                        this.safeInteger(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    if (limit === undefined) limit = 100;
                    const market = this.market(symbol);
                    const v2id = 't' + market['id'];
                    const request = {
                        'symbol': v2id,
                        'timeframe': this.timeframes[timeframe],
                        'sort': 1,
                        'limit': limit
                    };
                    if (since !== undefined) request['start'] = since;
                    const response = await this.v2GetCandlesTradeTimeframeSymbolHist(this.extend(request, params));
                    //
                    //     [
                    //         [1457539800000,0.02594,0.02594,0.02594,0.02594,0.1],
                    //         [1457547300000,0.02577,0.02577,0.02577,0.02577,0.01],
                    //         [1457550240000,0.0255,0.0253,0.0255,0.0252,3.2640000000000002],
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                getCurrencyName(code) {
                    // todo rewrite for https://api-pub.bitfinex.com//v2/conf/pub:map:tx:method
                    if (code in this.options['currencyNames']) return this.options['currencyNames'][code];
                    throw new NotSupported(this.id + ' ' + code + ' not supported for withdrawal');
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'renew': 1
                    };
                    const response = await this.fetchDepositAddress(code, this.extend(request, params));
                    return response;
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    // todo rewrite for https://api-pub.bitfinex.com//v2/conf/pub:map:tx:method
                    const name = this.getCurrencyName(code);
                    const request = {
                        'method': name,
                        'wallet_name': 'exchange',
                        'renew': 0
                    };
                    const response = await this.privatePostDepositNew(this.extend(request, params));
                    let address = this.safeValue(response, 'address');
                    let tag = undefined;
                    if ('address_pool' in response) {
                        tag = address;
                        address = response['address_pool'];
                    }
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currencyId = this.safeString(params, 'currency');
                    const query = this.omit(params, 'currency');
                    let currency = undefined;
                    if (currencyId === undefined) {
                        if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchTransactions() requires a currency `code` argument or a `currency` parameter');
                        else {
                            currency = this.currency(code);
                            currencyId = currency['id'];
                        }
                    }
                    query['currency'] = currencyId;
                    if (since !== undefined) query['since'] = parseInt(since / 1000);
                    const response = await this.privatePostHistoryMovements(this.extend(query, params));
                    //
                    //     [
                    //         {
                    //             "id":581183,
                    //             "txid": 123456,
                    //             "currency":"BTC",
                    //             "method":"BITCOIN",
                    //             "type":"WITHDRAWAL",
                    //             "amount":".01",
                    //             "description":"3QXYWgRGX2BPYBpUDBssGbeWEa5zq6snBZ, offchain transfer ",
                    //             "address":"3QXYWgRGX2BPYBpUDBssGbeWEa5zq6snBZ",
                    //             "status":"COMPLETED",
                    //             "timestamp":"1443833327.0",
                    //             "timestamp_created": "1443833327.1",
                    //             "fee": 0.1,
                    //         }
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // crypto
                    //
                    //     {
                    //         "id": 12042490,
                    //         "fee": "-0.02",
                    //         "txid": "EA5B5A66000B66855865EFF2494D7C8D1921FCBE996482157EBD749F2C85E13D",
                    //         "type": "DEPOSIT",
                    //         "amount": "2099.849999",
                    //         "method": "RIPPLE",
                    //         "status": "COMPLETED",
                    //         "address": "2505189261",
                    //         "currency": "XRP",
                    //         "timestamp": "1551730524.0",
                    //         "description": "EA5B5A66000B66855865EFF2494D7C8D1921FCBE996482157EBD749F2C85E13D",
                    //         "timestamp_created": "1551730523.0"
                    //     }
                    //
                    // fiat
                    //
                    //     {
                    //         "id": 12725095,
                    //         "fee": "-60.0",
                    //         "txid": null,
                    //         "type": "WITHDRAWAL",
                    //         "amount": "9943.0",
                    //         "method": "WIRE",
                    //         "status": "SENDING",
                    //         "address": null,
                    //         "currency": "EUR",
                    //         "timestamp": "1561802484.0",
                    //         "description": "Name: bob, AccountAddress: some address, Account: someaccountno, Bank: bank address, SWIFT: foo, Country: UK, Details of Payment: withdrawal name, Intermediary Bank Name: , Intermediary Bank Address: , Intermediary Bank City: , Intermediary Bank Country: , Intermediary Bank Account: , Intermediary Bank SWIFT: , Fee: -60.0",
                    //         "timestamp_created": "1561716066.0"
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "status":"success",
                    //         "message":"Your withdrawal request has been successfully submitted.",
                    //         "withdrawal_id":586829
                    //     }
                    //
                    const timestamp = this.safeTimestamp(transaction, 'timestamp_created');
                    const updated = this.safeTimestamp(transaction, 'timestamp');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const type = this.safeStringLower(transaction, 'type'); // DEPOSIT or WITHDRAWAL
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    let feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost !== undefined) feeCost = Math.abs(feeCost);
                    const tag = this.safeString(transaction, 'description');
                    return {
                        'info': transaction,
                        'id': this.safeString2(transaction, 'id', 'withdrawal_id'),
                        'txid': this.safeString(transaction, 'txid'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': this.safeString(transaction, 'address'),
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': this.safeNumber(transaction, 'amount'),
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': {
                            'currency': code,
                            'cost': feeCost,
                            'rate': undefined
                        }
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'SENDING': 'pending',
                        'CANCELED': 'canceled',
                        'ZEROCONFIRMED': 'failed',
                        'COMPLETED': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    // todo rewrite for https://api-pub.bitfinex.com//v2/conf/pub:map:tx:method
                    const name = this.getCurrencyName(code);
                    const currency = this.currency(code);
                    const request = {
                        'withdraw_type': name,
                        'walletselected': 'exchange',
                        'amount': this.numberToString(amount),
                        'address': address
                    };
                    if (tag !== undefined) request['payment_id'] = tag;
                    const responses = await this.privatePostWithdraw(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "status":"success",
                    //             "message":"Your withdrawal request has been successfully submitted.",
                    //             "withdrawal_id":586829
                    //         }
                    //     ]
                    //
                    const response = this.safeValue(responses, 0, {});
                    const id = this.safeString(response, 'withdrawal_id');
                    const message = this.safeString(response, 'message');
                    const errorMessage = this.findBroadlyMatchedKey(this.exceptions['broad'], message);
                    if (id === 0) {
                        if (errorMessage !== undefined) {
                            const ExceptionClass = this.exceptions['broad'][errorMessage];
                            throw new ExceptionClass(this.id + ' ' + message);
                        }
                        throw new ExchangeError1(this.id + ' withdraw returned an id of zero: ' + this.json(response));
                    }
                    return this.parseTransaction(response, currency);
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostPositions(params);
                    //
                    //     [
                    //         {
                    //             "id":943715,
                    //             "symbol":"btcusd",
                    //             "status":"ACTIVE",
                    //             "base":"246.94",
                    //             "amount":"1.0",
                    //             "timestamp":"1444141857.0",
                    //             "swap":"0.0",
                    //             "pl":"-2.22042"
                    //         }
                    //     ]
                    //
                    // todo unify parsePosition/parsePositions
                    return response;
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let request = '/' + this.implodeParams(path, params);
                    if (api === 'v2') request = '/' + api + request;
                    else request = '/' + this.version + request;
                    let query = this.omit(params, this.extractParams(path));
                    let url = this.urls['api'][api] + request;
                    if (api === 'public' || path.indexOf('/hist') >= 0) {
                        if (Object.keys(query).length) {
                            const suffix = '?' + this.urlencode(query);
                            url += suffix;
                            request += suffix;
                        }
                    }
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce();
                        query = this.extend({
                            'nonce': nonce.toString(),
                            'request': request
                        }, query);
                        body = this.json(query);
                        const payload = this.stringToBase64(body);
                        const secret = this.encode(this.secret);
                        const signature = this.hmac(payload, secret, 'sha384');
                        headers = {
                            'X-BFX-APIKEY': this.apiKey,
                            'X-BFX-PAYLOAD': this.decode(payload),
                            'X-BFX-SIGNATURE': signature,
                            'Content-Type': 'application/json'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    let throwError = false;
                    if (code >= 400) {
                        const firstChar = this.safeString(body, 0);
                        if (firstChar === '{') throwError = true;
                    } else {
                        // json response with error, i.e:
                        // [{"status":"error","message":"Momentary balance check. Please wait few seconds and try the transfer again."}]
                        const responseObject = this.safeValue(response, 0, {});
                        const status = this.safeString(responseObject, 'status', '');
                        if (status === 'error') throwError = true;
                    }
                    if (throwError) {
                        const feedback = this.id + ' ' + body;
                        const message = this.safeString2(response, 'message', 'error');
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    33: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const bitfinex = require1('./bitfinex.js');
            const { ExchangeError: ExchangeError1, InvalidAddress: InvalidAddress, ArgumentsRequired: ArgumentsRequired1, InsufficientFunds: InsufficientFunds, AuthenticationError: AuthenticationError, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, BadRequest: BadRequest, InvalidNonce: InvalidNonce, BadSymbol: BadSymbol, OnMaintenance: OnMaintenance, NotSupported: NotSupported, PermissionDenied: PermissionDenied, ExchangeNotAvailable: ExchangeNotAvailable } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            // ---------------------------------------------------------------------------
            module.exports = class bitfinex2 extends bitfinex {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitfinex2',
                        'name': 'Bitfinex',
                        'countries': [
                            'VG'
                        ],
                        'version': 'v2',
                        'certified': false,
                        'pro': false,
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createLimitOrder': true,
                            'createMarketOrder': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': undefined,
                            'fetchBalance': true,
                            'fetchClosedOrder': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchFundingFees': undefined,
                            'fetchIndexOHLCV': false,
                            'fetchLedger': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderTrades': true,
                            'fetchStatus': true,
                            'fetchTickers': true,
                            'fetchTime': false,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '3h': '3h',
                            '4h': '4h',
                            '6h': '6h',
                            '12h': '12h',
                            '1d': '1D',
                            '1w': '7D',
                            '2w': '14D',
                            '1M': '1M'
                        },
                        // cheapest endpoint is 240 requests per minute => ~ 4 requests per second => ( 1000ms / 4 ) = 250ms between requests on average
                        'rateLimit': 250,
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766244-e328a50c-5ed2-11e7-947b-041416579bb3.jpg',
                            'api': {
                                'v1': 'https://api.bitfinex.com',
                                'public': 'https://api-pub.bitfinex.com',
                                'private': 'https://api.bitfinex.com'
                            },
                            'www': 'https://www.bitfinex.com',
                            'doc': [
                                'https://docs.bitfinex.com/v2/docs/',
                                'https://github.com/bitfinexcom/bitfinex-api-node'
                            ],
                            'fees': 'https://www.bitfinex.com/fees'
                        },
                        'api': {
                            'v1': {
                                'get': [
                                    'symbols',
                                    'symbols_details'
                                ]
                            },
                            'public': {
                                'get': {
                                    'conf/{config}': 2.66,
                                    'conf/pub:{action}:{object}': 2.66,
                                    'conf/pub:{action}:{object}:{detail}': 2.66,
                                    'conf/pub:map:{object}': 2.66,
                                    'conf/pub:map:{object}:{detail}': 2.66,
                                    'conf/pub:map:currency:{detail}': 2.66,
                                    'conf/pub:map:currency:sym': 2.66,
                                    'conf/pub:map:currency:label': 2.66,
                                    'conf/pub:map:currency:unit': 2.66,
                                    'conf/pub:map:currency:undl': 2.66,
                                    'conf/pub:map:currency:pool': 2.66,
                                    'conf/pub:map:currency:explorer': 2.66,
                                    'conf/pub:map:currency:tx:fee': 2.66,
                                    'conf/pub:map:tx:method': 2.66,
                                    'conf/pub:list:{object}': 2.66,
                                    'conf/pub:list:{object}:{detail}': 2.66,
                                    'conf/pub:list:currency': 2.66,
                                    'conf/pub:list:pair:exchange': 2.66,
                                    'conf/pub:list:pair:margin': 2.66,
                                    'conf/pub:list:pair:futures': 2.66,
                                    'conf/pub:list:competitions': 2.66,
                                    'conf/pub:info:{object}': 2.66,
                                    'conf/pub:info:{object}:{detail}': 2.66,
                                    'conf/pub:info:pair': 2.66,
                                    'conf/pub:info:tx:status': 2.66,
                                    'conf/pub:fees': 2.66,
                                    'platform/status': 8,
                                    'tickers': 2.66,
                                    'ticker/{symbol}': 2.66,
                                    'tickers/hist': 2.66,
                                    'trades/{symbol}/hist': 2.66,
                                    'book/{symbol}/{precision}': 1,
                                    'book/{symbol}/P0': 1,
                                    'book/{symbol}/P1': 1,
                                    'book/{symbol}/P2': 1,
                                    'book/{symbol}/P3': 1,
                                    'book/{symbol}/R0': 1,
                                    'stats1/{key}:{size}:{symbol}:{side}/{section}': 2.66,
                                    'stats1/{key}:{size}:{symbol}:{side}/last': 2.66,
                                    'stats1/{key}:{size}:{symbol}:{side}/hist': 2.66,
                                    'stats1/{key}:{size}:{symbol}/{section}': 2.66,
                                    'stats1/{key}:{size}:{symbol}/last': 2.66,
                                    'stats1/{key}:{size}:{symbol}/hist': 2.66,
                                    'stats1/{key}:{size}:{symbol}:long/last': 2.66,
                                    'stats1/{key}:{size}:{symbol}:long/hist': 2.66,
                                    'stats1/{key}:{size}:{symbol}:short/last': 2.66,
                                    'stats1/{key}:{size}:{symbol}:short/hist': 2.66,
                                    'candles/trade:{timeframe}:{symbol}:{period}/{section}': 2.66,
                                    'candles/trade:{timeframe}:{symbol}/{section}': 2.66,
                                    'candles/trade:{timeframe}:{symbol}/last': 2.66,
                                    'candles/trade:{timeframe}:{symbol}/hist': 2.66,
                                    'status/{type}': 2.66,
                                    'status/deriv': 2.66,
                                    'liquidations/hist': 80,
                                    'rankings/{key}:{timeframe}:{symbol}/{section}': 2.66,
                                    'rankings/{key}:{timeframe}:{symbol}/hist': 2.66,
                                    'pulse/hist': 2.66,
                                    'pulse/profile/{nickname}': 2.66,
                                    'funding/stats/{symbol}/hist': 10
                                },
                                'post': {
                                    'calc/trade/avg': 2.66,
                                    'calc/fx': 2.66
                                }
                            },
                            'private': {
                                'post': {
                                    // 'auth/r/orders/{symbol}/new', // outdated
                                    // 'auth/r/stats/perf:{timeframe}/hist', // outdated
                                    'auth/r/wallets': 2.66,
                                    'auth/r/wallets/hist': 2.66,
                                    'auth/r/orders': 2.66,
                                    'auth/r/orders/{symbol}': 2.66,
                                    'auth/w/order/submit': 2.66,
                                    'auth/w/order/update': 2.66,
                                    'auth/w/order/cancel': 2.66,
                                    'auth/w/order/multi': 2.66,
                                    'auth/w/order/cancel/multi': 2.66,
                                    'auth/r/orders/{symbol}/hist': 2.66,
                                    'auth/r/orders/hist': 2.66,
                                    'auth/r/order/{symbol}:{id}/trades': 2.66,
                                    'auth/r/trades/{symbol}/hist': 2.66,
                                    'auth/r/trades/hist': 2.66,
                                    'auth/r/ledgers/{currency}/hist': 2.66,
                                    'auth/r/ledgers/hist': 2.66,
                                    'auth/r/info/margin/{key}': 2.66,
                                    'auth/r/info/margin/base': 2.66,
                                    'auth/r/info/margin/sym_all': 2.66,
                                    'auth/r/positions': 2.66,
                                    'auth/w/position/claim': 2.66,
                                    'auth/w/position/increase:': 2.66,
                                    'auth/r/position/increase/info': 2.66,
                                    'auth/r/positions/hist': 2.66,
                                    'auth/r/positions/audit': 2.66,
                                    'auth/r/positions/snap': 2.66,
                                    'auth/w/deriv/collateral/set': 2.66,
                                    'auth/w/deriv/collateral/limits': 2.66,
                                    'auth/r/funding/offers': 2.66,
                                    'auth/r/funding/offers/{symbol}': 2.66,
                                    'auth/w/funding/offer/submit': 2.66,
                                    'auth/w/funding/offer/cancel': 2.66,
                                    'auth/w/funding/offer/cancel/all': 2.66,
                                    'auth/w/funding/close': 2.66,
                                    'auth/w/funding/auto': 2.66,
                                    'auth/w/funding/keep': 2.66,
                                    'auth/r/funding/offers/{symbol}/hist': 2.66,
                                    'auth/r/funding/offers/hist': 2.66,
                                    'auth/r/funding/loans': 2.66,
                                    'auth/r/funding/loans/hist': 2.66,
                                    'auth/r/funding/loans/{symbol}': 2.66,
                                    'auth/r/funding/loans/{symbol}/hist': 2.66,
                                    'auth/r/funding/credits': 2.66,
                                    'auth/r/funding/credits/hist': 2.66,
                                    'auth/r/funding/credits/{symbol}': 2.66,
                                    'auth/r/funding/credits/{symbol}/hist': 2.66,
                                    'auth/r/funding/trades/{symbol}/hist': 2.66,
                                    'auth/r/funding/trades/hist': 2.66,
                                    'auth/r/info/funding/{key}': 2.66,
                                    'auth/r/info/user': 2.66,
                                    'auth/r/summary': 2.66,
                                    'auth/r/logins/hist': 2.66,
                                    'auth/r/permissions': 2.66,
                                    'auth/w/token': 2.66,
                                    'auth/r/audit/hist': 2.66,
                                    'auth/w/transfer': 2.66,
                                    'auth/w/deposit/address': 24,
                                    'auth/w/deposit/invoice': 24,
                                    'auth/w/withdraw': 24,
                                    'auth/r/movements/{currency}/hist': 2.66,
                                    'auth/r/movements/hist': 2.66,
                                    'auth/r/alerts': 5.33,
                                    'auth/w/alert/set': 2.66,
                                    'auth/w/alert/price:{symbol}:{price}/del': 2.66,
                                    'auth/w/alert/{type}:{symbol}:{price}/del': 2.66,
                                    'auth/calc/order/avail': 2.66,
                                    'auth/w/settings/set': 2.66,
                                    'auth/r/settings': 2.66,
                                    'auth/w/settings/del': 2.66,
                                    'auth/r/pulse/hist': 2.66,
                                    'auth/w/pulse/add': 16,
                                    'auth/w/pulse/del': 2.66
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'percentage': true,
                                'tierBased': true,
                                'maker': this.parseNumber('0.001'),
                                'taker': this.parseNumber('0.002'),
                                'tiers': {
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('500000'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('2500000'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('7500000'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('10000000'),
                                            this.parseNumber('0.0018')
                                        ],
                                        [
                                            this.parseNumber('15000000'),
                                            this.parseNumber('0.0016')
                                        ],
                                        [
                                            this.parseNumber('20000000'),
                                            this.parseNumber('0.0014')
                                        ],
                                        [
                                            this.parseNumber('25000000'),
                                            this.parseNumber('0.0012')
                                        ],
                                        [
                                            this.parseNumber('30000000'),
                                            this.parseNumber('0.001')
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.001')
                                        ],
                                        [
                                            this.parseNumber('500000'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('2500000'),
                                            this.parseNumber('0.0004')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.0002')
                                        ],
                                        [
                                            this.parseNumber('7500000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('10000000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('15000000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('20000000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('25000000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('30000000'),
                                            this.parseNumber('0')
                                        ]
                                    ]
                                }
                            },
                            'funding': {
                                'withdraw': {}
                            }
                        },
                        'options': {
                            'precision': 'R0',
                            // convert 'EXCHANGE MARKET' to lowercase 'market'
                            // convert 'EXCHANGE LIMIT' to lowercase 'limit'
                            // everything else remains uppercase
                            'exchangeTypes': {
                                // 'MARKET': undefined,
                                'EXCHANGE MARKET': 'market',
                                // 'LIMIT': undefined,
                                'EXCHANGE LIMIT': 'limit'
                            },
                            // convert 'market' to 'EXCHANGE MARKET'
                            // convert 'limit' 'EXCHANGE LIMIT'
                            // everything else remains as is
                            'orderTypes': {
                                'market': 'EXCHANGE MARKET',
                                'limit': 'EXCHANGE LIMIT'
                            },
                            'fiat': {
                                'USD': 'USD',
                                'EUR': 'EUR',
                                'JPY': 'JPY',
                                'GBP': 'GBP',
                                'CHN': 'CHN'
                            },
                            // actually the correct names unlike the v1
                            // we don't want to extend this with accountsByType in v1
                            'v2AccountsByType': {
                                'spot': 'exchange',
                                'exchange': 'exchange',
                                'funding': 'funding',
                                'margin': 'margin',
                                'derivatives': 'margin',
                                'future': 'margin'
                            },
                            'swap': {
                                'fetchMarkets': {
                                    'settlementCurrencies': [
                                        'BTC',
                                        'USDT',
                                        'EURT'
                                    ]
                                }
                            }
                        },
                        'exceptions': {
                            'exact': {
                                '10001': PermissionDenied,
                                '10020': BadRequest,
                                '10100': AuthenticationError,
                                '10114': InvalidNonce,
                                '20060': OnMaintenance,
                                // {"code":503,"error":"temporarily_unavailable","error_description":"Sorry, the service is temporarily unavailable. See https://www.bitfinex.com/ for more info."}
                                'temporarily_unavailable': ExchangeNotAvailable
                            },
                            'broad': {
                                'address': InvalidAddress,
                                'available balance is only': InsufficientFunds,
                                'not enough exchange balance': InsufficientFunds,
                                'Order not found': OrderNotFound,
                                'symbol: invalid': BadSymbol,
                                'Invalid order': InvalidOrder
                            }
                        },
                        'commonCurrencies': {
                            'EUTFO': 'EURT',
                            'USTF0': 'USDT'
                        }
                    });
                }
                isFiat(code) {
                    return code in this.options['fiat'];
                }
                getCurrencyId(code) {
                    return 'f' + code;
                }
                getCurrencyName(code) {
                    // temporary fix for transpiler recognition, even though this is in parent class
                    if (code in this.options['currencyNames']) return this.options['currencyNames'][code];
                    throw new NotSupported(this.id + ' ' + code + ' not supported for withdrawal');
                }
                async fetchStatus(params = {}) {
                    //
                    //    [1] // operative
                    //    [0] // maintenance
                    //
                    const response = await this.publicGetPlatformStatus(params);
                    const statusRaw = this.safeString(response, 0);
                    return {
                        'status': this.safeString({
                            '0': 'maintenance',
                            '1': 'ok'
                        }, statusRaw, statusRaw),
                        'updated': this.milliseconds(),
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchMarkets(params = {}) {
                    // todo drop v1 in favor of v2 configs  ( temp-reference for v2update: https://pastebin.com/raw/S8CmqSHQ )
                    // pub:list:pair:exchange,pub:list:pair:margin,pub:list:pair:futures,pub:info:pair
                    const v2response = await this.publicGetConfPubListPairFutures(params);
                    const v1response = await this.v1GetSymbolsDetails(params);
                    const swapMarketIds = this.safeValue(v2response, 0, []);
                    const result = [];
                    for(let i = 0; i < v1response.length; i++){
                        const market = v1response[i];
                        const id = this.safeStringUpper(market, 'pair');
                        let spot = true;
                        if (this.inArray(id, swapMarketIds)) spot = false;
                        const swap = !spot;
                        let baseId = undefined;
                        let quoteId = undefined;
                        if (id.indexOf(':') >= 0) {
                            const parts = id.split(':');
                            baseId = parts[0];
                            quoteId = parts[1];
                        } else {
                            baseId = id.slice(0, 3);
                            quoteId = id.slice(3, 6);
                        }
                        let base = this.safeCurrencyCode(baseId);
                        let quote = this.safeCurrencyCode(quoteId);
                        const splitBase = base.split('F0');
                        const splitQuote = quote.split('F0');
                        base = this.safeString(splitBase, 0);
                        quote = this.safeString(splitQuote, 0);
                        let symbol = base + '/' + quote;
                        baseId = this.getCurrencyId(baseId);
                        quoteId = this.getCurrencyId(quoteId);
                        let settleId = undefined;
                        let settle = undefined;
                        if (swap) {
                            settleId = quoteId;
                            settle = this.safeCurrencyCode(settleId);
                            symbol = symbol + ':' + settle;
                        }
                        const minOrderSizeString = this.safeString(market, 'minimum_order_size');
                        const maxOrderSizeString = this.safeString(market, 'maximum_order_size');
                        result.push({
                            'id': 't' + id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': spot ? 'spot' : 'swap',
                            'spot': spot,
                            'margin': this.safeValue(market, 'margin', false),
                            'swap': swap,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': swap,
                            'linear': swap ? true : undefined,
                            'inverse': swap ? false : undefined,
                            'contractSize': swap ? this.parseNumber('1') : undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': parseInt('8'),
                                'price': this.safeInteger(market, 'price_precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.parseNumber(minOrderSizeString),
                                    'max': this.parseNumber(maxOrderSizeString)
                                },
                                'price': {
                                    'min': this.parseNumber('1e-8'),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const labels = [
                        'pub:list:currency',
                        'pub:map:currency:sym',
                        'pub:map:currency:label',
                        'pub:map:currency:unit',
                        'pub:map:currency:undl',
                        'pub:map:currency:pool',
                        'pub:map:currency:explorer',
                        'pub:map:currency:tx:fee'
                    ];
                    const config = labels.join(',');
                    const request = {
                        'config': config
                    };
                    const response = await this.publicGetConfConfig(this.extend(request, params));
                    //
                    //     [
                    //
                    //         a list of symbols
                    //         ["AAA","ABS","ADA"],
                    //
                    //         // sym
                    //         // maps symbols to their API symbols, BAB > BCH
                    //         [
                    //             [ 'BAB', 'BCH' ],
                    //             [ 'CNHT', 'CNHt' ],
                    //             [ 'DSH', 'DASH' ],
                    //             [ 'IOT', 'IOTA' ],
                    //             [ 'LES', 'LEO-EOS' ],
                    //             [ 'LET', 'LEO-ERC20' ],
                    //             [ 'STJ', 'STORJ' ],
                    //             [ 'TSD', 'TUSD' ],
                    //             [ 'UDC', 'USDC' ],
                    //             [ 'USK', 'USDK' ],
                    //             [ 'UST', 'USDt' ],
                    //             [ 'USTF0', 'USDt0' ],
                    //             [ 'XCH', 'XCHF' ],
                    //             [ 'YYW', 'YOYOW' ],
                    //             // ...
                    //         ],
                    //         // label
                    //         // verbose friendly names, BNT > Bancor
                    //         [
                    //             [ 'BAB', 'Bitcoin Cash' ],
                    //             [ 'BCH', 'Bitcoin Cash' ],
                    //             [ 'LEO', 'Unus Sed LEO' ],
                    //             [ 'LES', 'Unus Sed LEO (EOS)' ],
                    //             [ 'LET', 'Unus Sed LEO (ERC20)' ],
                    //             // ...
                    //         ],
                    //         // unit
                    //         // maps symbols to unit of measure where applicable
                    //         [
                    //             [ 'IOT', 'Mi|MegaIOTA' ],
                    //         ],
                    //         // undl
                    //         // maps derivatives symbols to their underlying currency
                    //         [
                    //             [ 'USTF0', 'UST' ],
                    //             [ 'BTCF0', 'BTC' ],
                    //             [ 'ETHF0', 'ETH' ],
                    //         ],
                    //         // pool
                    //         // maps symbols to underlying network/protocol they operate on
                    //         [
                    //             [ 'SAN', 'ETH' ], [ 'OMG', 'ETH' ], [ 'AVT', 'ETH' ], [ 'EDO', 'ETH' ],
                    //             [ 'ESS', 'ETH' ], [ 'ATD', 'EOS' ], [ 'ADD', 'EOS' ], [ 'MTO', 'EOS' ],
                    //             [ 'PNK', 'ETH' ], [ 'BAB', 'BCH' ], [ 'WLO', 'XLM' ], [ 'VLD', 'ETH' ],
                    //             [ 'BTT', 'TRX' ], [ 'IMP', 'ETH' ], [ 'SCR', 'ETH' ], [ 'GNO', 'ETH' ],
                    //             // ...
                    //         ],
                    //         // explorer
                    //         // maps symbols to their recognised block explorer URLs
                    //         [
                    //             [
                    //                 'AIO',
                    //                 [
                    //                     "https://mainnet.aion.network",
                    //                     "https://mainnet.aion.network/#/account/VAL",
                    //                     "https://mainnet.aion.network/#/transaction/VAL"
                    //                 ]
                    //             ],
                    //             // ...
                    //         ],
                    //         // fee
                    //         // maps currencies to their withdrawal fees
                    //         [
                    //             ["AAA",[0,0]],
                    //             ["ABS",[0,131.3]],
                    //             ["ADA",[0,0.3]],
                    //         ],
                    //     ]
                    //
                    const indexed = {
                        'sym': this.indexBy(this.safeValue(response, 1, []), 0),
                        'label': this.indexBy(this.safeValue(response, 2, []), 0),
                        'unit': this.indexBy(this.safeValue(response, 3, []), 0),
                        'undl': this.indexBy(this.safeValue(response, 4, []), 0),
                        'pool': this.indexBy(this.safeValue(response, 5, []), 0),
                        'explorer': this.indexBy(this.safeValue(response, 6, []), 0),
                        'fees': this.indexBy(this.safeValue(response, 7, []), 0)
                    };
                    const ids = this.safeValue(response, 0, []);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const code = this.safeCurrencyCode(id);
                        const label = this.safeValue(indexed['label'], id, []);
                        const name = this.safeString(label, 1);
                        const pool = this.safeValue(indexed['pool'], id, []);
                        const type = this.safeString(pool, 1);
                        const feeValues = this.safeValue(indexed['fees'], id, []);
                        const fees = this.safeValue(feeValues, 1, []);
                        const fee = this.safeNumber(fees, 1);
                        const undl = this.safeValue(indexed['undl'], id, []);
                        const precision = 8; // default precision, todo: fix "magic constants"
                        const fid = 'f' + id;
                        result[code] = {
                            'id': fid,
                            'uppercaseId': id,
                            'code': code,
                            'info': [
                                id,
                                label,
                                pool,
                                feeValues,
                                undl
                            ],
                            'type': type,
                            'name': name,
                            'active': true,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': fee,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': 1 / Math.pow(10, precision),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': fee,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchBalance(params = {}) {
                    // this api call does not return the 'used' amount - use the v1 version instead (which also returns zero balances)
                    // there is a difference between this and the v1 api, namely trading wallet is called margin in v2
                    await this.loadMarkets();
                    const accountsByType = this.safeValue(this.options, 'v2AccountsByType', {});
                    const requestedType = this.safeString(params, 'type', 'exchange');
                    const accountType = this.safeString(accountsByType, requestedType, requestedType);
                    if (accountType === undefined) {
                        const keys = Object.keys(accountsByType);
                        throw new ExchangeError1(this.id + ' fetchBalance() type parameter must be one of ' + keys.join(', '));
                    }
                    const isDerivative = requestedType === 'derivatives';
                    const query = this.omit(params, 'type');
                    const response = await this.privatePostAuthRWallets(query);
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const type = this.safeString(balance, 0);
                        const currencyId = this.safeStringLower(balance, 1, '');
                        const start = currencyId.length - 2;
                        const isDerivativeCode = currencyId.slice(start) === 'f0';
                        // this will only filter the derivative codes if the requestedType is 'derivatives'
                        const derivativeCondition = !isDerivative || isDerivativeCode;
                        if (accountType === type && derivativeCondition) {
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            account['total'] = this.safeString(balance, 2);
                            account['free'] = this.safeString(balance, 4);
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    // transferring between derivatives wallet and regular wallet is not documented in their API
                    // however we support it in CCXT (from just looking at web inspector)
                    await this.loadMarkets();
                    const accountsByType = this.safeValue(this.options, 'v2AccountsByType', {});
                    const fromId = this.safeString(accountsByType, fromAccount);
                    if (fromId === undefined) {
                        const keys = Object.keys(accountsByType);
                        throw new ArgumentsRequired1(this.id + ' transfer() fromAccount must be one of ' + keys.join(', '));
                    }
                    const toId = this.safeString(accountsByType, toAccount);
                    if (toId === undefined) {
                        const keys = Object.keys(accountsByType);
                        throw new ArgumentsRequired1(this.id + ' transfer() toAccount must be one of ' + keys.join(', '));
                    }
                    const currency = this.currency(code);
                    const fromCurrencyId = this.convertDerivativesId(currency, fromAccount);
                    const toCurrencyId = this.convertDerivativesId(currency, toAccount);
                    const requestedAmount = this.currencyToPrecision(code, amount);
                    // this request is slightly different from v1 fromAccount -> from
                    const request = {
                        'amount': requestedAmount,
                        'currency': fromCurrencyId,
                        'currency_to': toCurrencyId,
                        'from': fromId,
                        'to': toId
                    };
                    const response = await this.privatePostAuthWTransfer(this.extend(request, params));
                    //  [1616451183763,"acc_tf",null,null,[1616451183763,"exchange","margin",null,"UST","UST",null,1],null,"SUCCESS","1.0 Tether USDt transfered from Exchange to Margin"]
                    const timestamp = this.safeInteger(response, 0);
                    //  ["error",10001,"Momentary balance check. Please wait few seconds and try the transfer again."]
                    const error = this.safeString(response, 0);
                    if (error === 'error') {
                        const message = this.safeString(response, 2, '');
                        // same message as in v1
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, this.id + ' ' + message);
                        throw new ExchangeError1(this.id + ' ' + message);
                    }
                    const info = this.safeValue(response, 4);
                    const fromResponse = this.safeString(info, 1);
                    const toResponse = this.safeString(info, 2);
                    const toCode = this.safeCurrencyCode(this.safeString(info, 5));
                    const success = this.safeString(response, 6);
                    const status = success === 'SUCCESS' ? 'ok' : undefined;
                    return {
                        'info': response,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'status': status,
                        'amount': requestedAmount,
                        'code': toCode,
                        'fromAccount': fromResponse,
                        'toAccount': toResponse
                    };
                }
                convertDerivativesId(currency, type) {
                    // there is a difference between this and the v1 api, namely trading wallet is called margin in v2
                    // {
                    //   id: 'fUSTF0',
                    //   code: 'USTF0',
                    //   info: [ 'USTF0', [], [], [], [ 'USTF0', 'UST' ] ],
                    const info = this.safeValue(currency, 'info');
                    const transferId = this.safeString(info, 0);
                    const underlying = this.safeValue(info, 4, []);
                    let currencyId = undefined;
                    if (type === 'derivatives') {
                        currencyId = this.safeString(underlying, 0, transferId);
                        const start = currencyId.length - 2;
                        const isDerivativeCode = currencyId.slice(start) === 'F0';
                        if (!isDerivativeCode) currencyId = currencyId + 'F0';
                    } else if (type !== 'margin') currencyId = this.safeString(underlying, 1, transferId);
                    else currencyId = transferId;
                    return currencyId;
                }
                async fetchOrder(id, symbol, params = {}) {
                    throw new NotSupported(this.id + ' fetchOrder() is not supported yet');
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const precision = this.safeValue(this.options, 'precision', 'R0');
                    const request = {
                        'symbol': this.marketId(symbol),
                        'precision': precision
                    };
                    if (limit !== undefined) request['len'] = limit; // 25 or 100
                    const fullRequest = this.extend(request, params);
                    const orderbook = await this.publicGetBookSymbolPrecision(fullRequest);
                    const timestamp = this.milliseconds();
                    const result = {
                        'symbol': symbol,
                        'bids': [],
                        'asks': [],
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'nonce': undefined
                    };
                    const priceIndex = fullRequest['precision'] === 'R0' ? 1 : 0;
                    for(let i = 0; i < orderbook.length; i++){
                        const order = orderbook[i];
                        const price = this.safeNumber(order, priceIndex);
                        const signedAmount = this.safeNumber(order, 2);
                        const amount = Math.abs(signedAmount);
                        const side = signedAmount > 0 ? 'bids' : 'asks';
                        result[side].push([
                            price,
                            amount
                        ]);
                    }
                    result['bids'] = this.sortBy(result['bids'], 0, true);
                    result['asks'] = this.sortBy(result['asks'], 0);
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    // on trading pairs (ex. tBTCUSD)
                    //
                    //     [
                    //         SYMBOL,
                    //         BID,
                    //         BID_SIZE,
                    //         ASK,
                    //         ASK_SIZE,
                    //         DAILY_CHANGE,
                    //         DAILY_CHANGE_RELATIVE,
                    //         LAST_PRICE,
                    //         VOLUME,
                    //         HIGH,
                    //         LOW
                    //     ]
                    //
                    // on funding currencies (ex. fUSD)
                    //
                    //     [
                    //         SYMBOL,
                    //         FRR,
                    //         BID,
                    //         BID_PERIOD,
                    //         BID_SIZE,
                    //         ASK,
                    //         ASK_PERIOD,
                    //         ASK_SIZE,
                    //         DAILY_CHANGE,
                    //         DAILY_CHANGE_RELATIVE,
                    //         LAST_PRICE,
                    //         VOLUME,
                    //         HIGH,
                    //         LOW,
                    //         _PLACEHOLDER,
                    //         _PLACEHOLDER,
                    //         FRR_AMOUNT_AVAILABLE
                    //     ]
                    //
                    const timestamp = this.milliseconds();
                    const symbol = this.safeSymbol(undefined, market);
                    const length = ticker.length;
                    const last = this.safeString(ticker, length - 4);
                    const percentage = this.safeString(ticker, length - 5);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, length - 2),
                        'low': this.safeString(ticker, length - 1),
                        'bid': this.safeString(ticker, length - 10),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, length - 8),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': this.safeString(ticker, length - 6),
                        'percentage': Precise.stringMul(percentage, '100'),
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, length - 3),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbols !== undefined) {
                        const ids = this.marketIds(symbols);
                        request['symbols'] = ids.join(',');
                    } else request['symbols'] = 'ALL';
                    const tickers = await this.publicGetTickers(this.extend(request, params));
                    //
                    //     [
                    //         // on trading pairs (ex. tBTCUSD)
                    //         [
                    //             SYMBOL,
                    //             BID,
                    //             BID_SIZE,
                    //             ASK,
                    //             ASK_SIZE,
                    //             DAILY_CHANGE,
                    //             DAILY_CHANGE_RELATIVE,
                    //             LAST_PRICE,
                    //             VOLUME,
                    //             HIGH,
                    //             LOW
                    //         ],
                    //         // on funding currencies (ex. fUSD)
                    //         [
                    //             SYMBOL,
                    //             FRR,
                    //             BID,
                    //             BID_PERIOD,
                    //             BID_SIZE,
                    //             ASK,
                    //             ASK_PERIOD,
                    //             ASK_SIZE,
                    //             DAILY_CHANGE,
                    //             DAILY_CHANGE_RELATIVE,
                    //             LAST_PRICE,
                    //             VOLUME,
                    //             HIGH,
                    //             LOW,
                    //             _PLACEHOLDER,
                    //             _PLACEHOLDER,
                    //             FRR_AMOUNT_AVAILABLE
                    //         ],
                    //         ...
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const ticker = tickers[i];
                        const id = ticker[0];
                        if (id in this.markets_by_id) {
                            const market = this.markets_by_id[id];
                            const symbol = market['symbol'];
                            result[symbol] = this.parseTicker(ticker, market);
                        }
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const ticker = await this.publicGetTickerSymbol(this.extend(request, params));
                    return this.parseTicker(ticker, market);
                }
                parseSymbol(marketId) {
                    if (marketId === undefined) return marketId;
                    marketId = marketId.replace('t', '');
                    let baseId = undefined;
                    let quoteId = undefined;
                    if (marketId.indexOf(':') >= 0) {
                        const parts = marketId.split(':');
                        baseId = parts[0];
                        quoteId = parts[1];
                    } else {
                        baseId = marketId.slice(0, 3);
                        quoteId = marketId.slice(3, 6);
                    }
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    return base + '/' + quote;
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     [
                    //         ID,
                    //         MTS, // timestamp
                    //         AMOUNT,
                    //         PRICE
                    //     ]
                    //
                    // fetchMyTrades (private)
                    //
                    //     [
                    //         ID,
                    //         PAIR,
                    //         MTS_CREATE,
                    //         ORDER_ID,
                    //         EXEC_AMOUNT,
                    //         EXEC_PRICE,
                    //         ORDER_TYPE,
                    //         ORDER_PRICE,
                    //         MAKER,
                    //         FEE,
                    //         FEE_CURRENCY,
                    //         ...
                    //     ]
                    //
                    const tradeLength = trade.length;
                    const isPrivate = tradeLength > 5;
                    const id = this.safeString(trade, 0);
                    const amountIndex = isPrivate ? 4 : 2;
                    let side = undefined;
                    let amountString = this.safeString(trade, amountIndex);
                    const priceIndex = isPrivate ? 5 : 3;
                    const priceString = this.safeString(trade, priceIndex);
                    if (amountString[0] === '-') {
                        side = 'sell';
                        amountString = Precise.stringAbs(amountString);
                    } else side = 'buy';
                    let orderId = undefined;
                    let takerOrMaker = undefined;
                    let type = undefined;
                    let fee = undefined;
                    let symbol = undefined;
                    const timestampIndex = isPrivate ? 2 : 1;
                    const timestamp = this.safeInteger(trade, timestampIndex);
                    if (isPrivate) {
                        const marketId = trade[1];
                        if (marketId in this.markets_by_id) {
                            market = this.markets_by_id[marketId];
                            symbol = market['symbol'];
                        } else symbol = this.parseSymbol(marketId);
                        orderId = this.safeString(trade, 3);
                        const maker = this.safeInteger(trade, 8);
                        takerOrMaker = maker === 1 ? 'maker' : 'taker';
                        let feeCostString = this.safeString(trade, 9);
                        feeCostString = Precise.stringNeg(feeCostString);
                        const feeCurrencyId = this.safeString(trade, 10);
                        const feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrency
                        };
                        const orderType = trade[6];
                        type = this.safeString(this.options['exchangeTypes'], orderType);
                    }
                    if (symbol === undefined) {
                        if (market !== undefined) symbol = market['symbol'];
                    }
                    return this.safeTrade({
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': orderId,
                        'side': side,
                        'type': type,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let sort = '-1';
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) {
                        request['start'] = since;
                        sort = '1';
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 120, max 5000
                    request['sort'] = sort;
                    const response = await this.publicGetTradesSymbolHist(this.extend(request, params));
                    //
                    //     [
                    //         [
                    //             ID,
                    //             MTS, // timestamp
                    //             AMOUNT,
                    //             PRICE
                    //         ]
                    //     ]
                    //
                    const trades = this.sortBy(response, 1);
                    return this.parseTrades(trades, market, undefined, limit);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit = 100, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (limit === undefined) limit = 100; // default 100, max 5000
                    if (since === undefined) {
                        const duration = this.parseTimeframe(timeframe);
                        since = this.milliseconds() - duration * limit * 1000;
                    }
                    const request = {
                        'symbol': market['id'],
                        'timeframe': this.timeframes[timeframe],
                        'sort': 1,
                        'start': since,
                        'limit': limit
                    };
                    const response = await this.publicGetCandlesTradeTimeframeSymbolHist(this.extend(request, params));
                    //
                    //     [
                    //         [1591503840000,0.025069,0.025068,0.025069,0.025068,1.97828998],
                    //         [1591504500000,0.025065,0.025065,0.025065,0.025065,1.0164],
                    //         [1591504620000,0.025062,0.025062,0.025062,0.025062,0.5],
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseOrderStatus(status) {
                    if (status === undefined) return status;
                    const parts = status.split(' ');
                    const state = this.safeString(parts, 0);
                    const statuses = {
                        'ACTIVE': 'open',
                        'PARTIALLY': 'open',
                        'EXECUTED': 'closed',
                        'CANCELED': 'canceled',
                        'INSUFFICIENT': 'canceled',
                        'POSTONLY': 'canceled',
                        'RSN_DUST': 'rejected',
                        'RSN_PAUSE': 'rejected'
                    };
                    return this.safeString(statuses, state, status);
                }
                parseOrder(order, market) {
                    const id = this.safeString(order, 0);
                    let symbol = undefined;
                    const marketId = this.safeString(order, 3);
                    if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                    else symbol = this.parseSymbol(marketId);
                    if (symbol === undefined && market !== undefined) symbol = market['symbol'];
                    // https://github.com/ccxt/ccxt/issues/6686
                    // const timestamp = this.safeTimestamp (order, 5);
                    const timestamp = this.safeInteger(order, 5);
                    const remaining = Precise.stringAbs(this.safeString(order, 6));
                    const signedAmount = this.safeString(order, 7);
                    const amount = Precise.stringAbs(signedAmount);
                    const side = Precise.stringLt(signedAmount, '0') ? 'sell' : 'buy';
                    const orderType = this.safeString(order, 8);
                    const type = this.safeString(this.safeValue(this.options, 'exchangeTypes'), orderType);
                    let status = undefined;
                    const statusString = this.safeString(order, 13);
                    if (statusString !== undefined) {
                        const parts = statusString.split(' @ ');
                        status = this.parseOrderStatus(this.safeString(parts, 0));
                    }
                    const price = this.safeString(order, 16);
                    const average = this.safeString(order, 17);
                    const clientOrderId = this.safeString(order, 2);
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'average': average,
                        'filled': undefined,
                        'remaining': remaining,
                        'status': status,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const orderTypes = this.safeValue(this.options, 'orderTypes', {});
                    const orderType = this.safeStringUpper(orderTypes, type, type);
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    params = this.omit(params, [
                        'postOnly'
                    ]);
                    amount = side === 'sell' ? -amount : amount;
                    const request = {
                        // 'gid': 0123456789, // int32,  optional group id for the order
                        // 'cid': 0123456789, // int32 client order id
                        'type': orderType,
                        'symbol': market['id'],
                        // 'price': this.numberToString (price),
                        'amount': this.numberToString(amount)
                    };
                    if (postOnly) request['flags'] = 4096;
                    if (orderType === 'LIMIT' || orderType === 'EXCHANGE LIMIT') request['price'] = this.numberToString(price);
                    else if (orderType === 'STOP' || orderType === 'EXCHANGE STOP') {
                        const stopPrice = this.safeNumber(params, 'stopPrice', price);
                        request['price'] = this.numberToString(stopPrice);
                    } else if (orderType === 'STOP LIMIT' || orderType === 'EXCHANGE STOP LIMIT') {
                        const priceAuxLimit = this.safeNumber(params, 'price_aux_limit');
                        let stopPrice = this.safeNumber(params, 'stopPrice');
                        if (priceAuxLimit === undefined) {
                            if (stopPrice === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a stopPrice parameter or a price_aux_limit parameter for a ' + orderType + ' order');
                            else request['price_aux_limit'] = this.numberToString(price);
                        } else {
                            request['price_aux_limit'] = this.numberToString(priceAuxLimit);
                            if (stopPrice === undefined) stopPrice = price;
                        }
                        request['price'] = this.numberToString(stopPrice);
                    } else if (orderType === 'TRAILING STOP' || orderType === 'EXCHANGE TRAILING STOP') {
                        const priceTrailing = this.safeNumber(params, 'price_trailing');
                        request['price_trailing'] = this.numberToString(priceTrailing);
                        const stopPrice = this.safeNumber(params, 'stopPrice', price);
                        request['price'] = this.numberToString(stopPrice);
                    } else if (orderType === 'FOK' || orderType === 'EXCHANGE FOK' || orderType === 'IOC' || orderType === 'EXCHANGE IOC') request['price'] = this.numberToString(price);
                    params = this.omit(params, [
                        'stopPrice',
                        'price_aux_limit',
                        'price_trailing'
                    ]);
                    const clientOrderId = this.safeValue2(params, 'cid', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['cid'] = clientOrderId;
                        params = this.omit(params, [
                            'cid',
                            'clientOrderId'
                        ]);
                    }
                    const response = await this.privatePostAuthWOrderSubmit(this.extend(request, params));
                    //
                    //     [
                    //         1578784364.748,    // Millisecond Time Stamp of the update
                    //         "on-req",          // Purpose of notification ('on-req', 'oc-req', 'uca', 'fon-req', 'foc-req')
                    //         null,              // Unique ID of the message
                    //         null,              // Ignore
                    //         [
                    //             [
                    //                 37271830598,           // Order ID
                    //                 null,                  // Group ID
                    //                 1578784364748,         // Client Order ID
                    //                 "tBTCUST",             // Pair
                    //                 1578784364748,         // Millisecond timestamp of creation
                    //                 1578784364748,         // Millisecond timestamp of update
                    //                 -0.005,                // Positive means buy, negative means sell
                    //                 -0.005,                // Original amount
                    //                 "EXCHANGE LIMIT",      // Order type (LIMIT, MARKET, STOP, TRAILING STOP, EXCHANGE MARKET, EXCHANGE LIMIT, EXCHANGE STOP, EXCHANGE TRAILING STOP, FOK, EXCHANGE FOK, IOC, EXCHANGE IOC)
                    //                 null,                  // Previous order type
                    //                 null,                  // Millisecond timestamp of Time-In-Force: automatic order cancellation
                    //                 null,                  // Ignore
                    //                 0,                     // Flags (see https://docs.bitfinex.com/docs/flag-values)
                    //                 "ACTIVE",              // Order Status
                    //                 null,                  // Ignore
                    //                 null,                  // Ignore
                    //                 20000,                 // Price
                    //                 0,                     // Average price
                    //                 0,                     // The trailing price
                    //                 0,                     // Auxiliary Limit price (for STOP LIMIT)
                    //                 null,                  // Ignore
                    //                 null,                  // Ignore
                    //                 null,                  // Ignore
                    //                 0,                     // 1 - hidden order
                    //                 null,                  // If another order caused this order to be placed (OCO) this will be that other order's ID
                    //                 null,                  // Ignore
                    //                 null,                  // Ignore
                    //                 null,                  // Ignore
                    //                 "API>BFX",             // Origin of action: BFX, ETHFX, API>BFX, API>ETHFX
                    //                 null,                  // Ignore
                    //                 null,                  // Ignore
                    //                 null                   // Meta
                    //             ]
                    //         ],
                    //         null,                  // Error code
                    //         "SUCCESS",             // Status (SUCCESS, ERROR, FAILURE, ...)
                    //         "Submitting 1 orders." // Text of the notification
                    //     ]
                    //
                    const status = this.safeString(response, 6);
                    if (status !== 'SUCCESS') {
                        const errorCode = response[5];
                        const errorText = response[7];
                        throw new ExchangeError1(this.id + ' ' + response[6] + ': ' + errorText + ' (#' + errorCode + ')');
                    }
                    const orders = this.safeValue(response, 4, []);
                    const order = this.safeValue(orders, 0);
                    return this.parseOrder(order, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    const request = {
                        'all': 1
                    };
                    const response = await this.privatePostAuthWOrderCancelMulti(this.extend(request, params));
                    const orders = this.safeValue(response, 4, []);
                    return this.parseOrders(orders);
                }
                async cancelOrder(id, symbol, params = {}) {
                    const cid = this.safeValue2(params, 'cid', 'clientOrderId'); // client order id
                    let request = undefined;
                    if (cid !== undefined) {
                        const cidDate = this.safeValue(params, 'cidDate'); // client order id date
                        if (cidDate === undefined) throw new InvalidOrder(this.id + " canceling an order by clientOrderId ('cid') requires both 'cid' and 'cid_date' ('YYYY-MM-DD')");
                        request = {
                            'cid': cid,
                            'cid_date': cidDate
                        };
                        params = this.omit(params, [
                            'cid',
                            'clientOrderId'
                        ]);
                    } else request = {
                        'id': parseInt(id)
                    };
                    const response = await this.privatePostAuthWOrderCancel(this.extend(request, params));
                    const order = this.safeValue(response, 4);
                    return this.parseOrder(order);
                }
                async fetchOpenOrder(id, symbol, params = {}) {
                    const request = {
                        'id': [
                            parseInt(id)
                        ]
                    };
                    const orders = await this.fetchOpenOrders(symbol, undefined, undefined, this.extend(request, params));
                    const order = this.safeValue(orders, 0);
                    if (order === undefined) throw new OrderNotFound(this.id + ' order ' + id + ' not found');
                    return order;
                }
                async fetchClosedOrder(id, symbol, params = {}) {
                    const request = {
                        'id': [
                            parseInt(id)
                        ]
                    };
                    const orders = await this.fetchClosedOrders(symbol, undefined, undefined, this.extend(request, params));
                    const order = this.safeValue(orders, 0);
                    if (order === undefined) throw new OrderNotFound(this.id + ' order ' + id + ' not found');
                    return order;
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    let response = undefined;
                    if (symbol === undefined) response = await this.privatePostAuthROrders(this.extend(request, params));
                    else {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                        response = await this.privatePostAuthROrdersSymbol(this.extend(request, params));
                    }
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    // returns the most recent closed or canceled orders up to circa two weeks ago
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    let response = undefined;
                    if (symbol === undefined) response = await this.privatePostAuthROrdersHist(this.extend(request, params));
                    else {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                        response = await this.privatePostAuthROrdersSymbolHist(this.extend(request, params));
                    }
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit; // default 25, max 2500
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrderTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const orderId = parseInt(id);
                    const request = {
                        'id': orderId,
                        'symbol': market['id']
                    };
                    // valid for trades upto 10 days old
                    const response = await this.privatePostAuthROrderSymbolIdTrades(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        'end': this.milliseconds()
                    };
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit; // default 25, max 1000
                    let method = 'privatePostAuthRTradesHist';
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                        method = 'privatePostAuthRTradesSymbolHist';
                    }
                    const response = await this[method](this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'op_renew': 1
                    };
                    const response = await this.fetchDepositAddress(code, this.extend(request, params));
                    return response;
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    // todo rewrite for https://api-pub.bitfinex.com//v2/conf/pub:map:tx:method
                    const name = this.getCurrencyName(code);
                    const request = {
                        'method': name,
                        'wallet': 'exchange',
                        'op_renew': 0
                    };
                    const response = await this.privatePostAuthWDepositAddress(this.extend(request, params));
                    //
                    //     [
                    //         1582269616687, // MTS Millisecond Time Stamp of the update
                    //         'acc_dep', // TYPE Purpose of notification 'acc_dep' for account deposit
                    //         null, // MESSAGE_ID unique ID of the message
                    //         null, // not documented
                    //         [
                    //             null, // PLACEHOLDER
                    //             'BITCOIN', // METHOD Method of deposit
                    //             'BTC', // CURRENCY_CODE Currency code of new address
                    //             null, // PLACEHOLDER
                    //             '1BC9PZqpUmjyEB54uggn8TFKj49zSDYzqG', // ADDRESS
                    //             null, // POOL_ADDRESS
                    //         ],
                    //         null, // CODE null or integer work in progress
                    //         'SUCCESS', // STATUS Status of the notification, SUCCESS, ERROR, FAILURE
                    //         'success', // TEXT Text of the notification
                    //     ]
                    //
                    const result = this.safeValue(response, 4, []);
                    const poolAddress = this.safeString(result, 5);
                    const address = poolAddress === undefined ? this.safeString(result, 4) : poolAddress;
                    const tag = poolAddress === undefined ? undefined : this.safeString(result, 4);
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'SUCCESS': 'ok',
                        'ERROR': 'failed',
                        'FAILURE': 'failed',
                        'CANCELED': 'canceled',
                        'COMPLETED': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     [
                    //         1582271520931, // MTS Millisecond Time Stamp of the update
                    //         "acc_wd-req", // TYPE Purpose of notification 'acc_wd-req' account withdrawal request
                    //         null, // MESSAGE_ID unique ID of the message
                    //         null, // not documented
                    //         [
                    //             0, // WITHDRAWAL_ID Unique Withdrawal ID
                    //             null, // PLACEHOLDER
                    //             "bitcoin", // METHOD Method of withdrawal
                    //             null, // PAYMENT_ID Payment ID if relevant
                    //             "exchange", // WALLET Sending wallet
                    //             1, // AMOUNT Amount of Withdrawal less fee
                    //             null, // PLACEHOLDER
                    //             null, // PLACEHOLDER
                    //             0.0004, // WITHDRAWAL_FEE Fee on withdrawal
                    //         ],
                    //         null, // CODE null or integer Work in progress
                    //         "SUCCESS", // STATUS Status of the notification, it may vary over time SUCCESS, ERROR, FAILURE
                    //         "Invalid bitcoin address (abcdef)", // TEXT Text of the notification
                    //     ]
                    //
                    // fetchTransactions
                    //
                    //     [
                    //         13293039, // ID
                    //         'ETH', // CURRENCY
                    //         'ETHEREUM', // CURRENCY_NAME
                    //         null,
                    //         null,
                    //         1574175052000, // MTS_STARTED
                    //         1574181326000, // MTS_UPDATED
                    //         null,
                    //         null,
                    //         'CANCELED', // STATUS
                    //         null,
                    //         null,
                    //         -0.24, // AMOUNT, negative for withdrawals
                    //         -0.00135, // FEES
                    //         null,
                    //         null,
                    //         '0x38110e0Fc932CB2BE...........', // DESTINATION_ADDRESS
                    //         null,
                    //         null,
                    //         null,
                    //         '0x523ec8945500.....................................', // TRANSACTION_ID
                    //         "Purchase of 100 pizzas", // WITHDRAW_TRANSACTION_NOTE, might also be: null
                    //     ]
                    //
                    const transactionLength = transaction.length;
                    let timestamp = undefined;
                    let updated = undefined;
                    let code = undefined;
                    let amount = undefined;
                    let id = undefined;
                    let status = undefined;
                    let tag = undefined;
                    let type = undefined;
                    let feeCost = undefined;
                    let txid = undefined;
                    let addressTo = undefined;
                    if (transactionLength === 8) {
                        const data = this.safeValue(transaction, 4, []);
                        timestamp = this.safeInteger(transaction, 0);
                        if (currency !== undefined) code = currency['code'];
                        feeCost = this.safeNumber(data, 8);
                        if (feeCost !== undefined) feeCost = -feeCost;
                        amount = this.safeNumber(data, 5);
                        id = this.safeValue(data, 0);
                        status = 'ok';
                        if (id === 0) {
                            id = undefined;
                            status = 'failed';
                        }
                        tag = this.safeString(data, 3);
                        type = 'withdrawal';
                    } else if (transactionLength === 22) {
                        id = this.safeString(transaction, 0);
                        const currencyId = this.safeString(transaction, 1);
                        code = this.safeCurrencyCode(currencyId, currency);
                        timestamp = this.safeInteger(transaction, 5);
                        updated = this.safeInteger(transaction, 6);
                        status = this.parseTransactionStatus(this.safeString(transaction, 9));
                        amount = this.safeNumber(transaction, 12);
                        if (amount !== undefined) {
                            if (amount < 0) type = 'withdrawal';
                            else type = 'deposit';
                        }
                        feeCost = this.safeNumber(transaction, 13);
                        if (feeCost !== undefined) feeCost = -feeCost;
                        addressTo = this.safeString(transaction, 16);
                        txid = this.safeString(transaction, 20);
                    }
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': addressTo,
                        'addressTo': addressTo,
                        'tagFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': {
                            'currency': code,
                            'cost': feeCost,
                            'rate': undefined
                        }
                    };
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostAuthRSummary(params);
                    //
                    //      Response Spec:
                    //      [
                    //         PLACEHOLDER,
                    //         PLACEHOLDER,
                    //         PLACEHOLDER,
                    //         PLACEHOLDER,
                    //         [
                    //            [
                    //             MAKER_FEE,
                    //             MAKER_FEE,
                    //             MAKER_FEE,
                    //             PLACEHOLDER,
                    //             PLACEHOLDER,
                    //             DERIV_REBATE
                    //            ],
                    //            [
                    //             TAKER_FEE_TO_CRYPTO,
                    //             TAKER_FEE_TO_STABLE,
                    //             TAKER_FEE_TO_FIAT,
                    //             PLACEHOLDER,
                    //             PLACEHOLDER,
                    //             DERIV_TAKER_FEE
                    //            ]
                    //         ],
                    //         PLACEHOLDER,
                    //         PLACEHOLDER,
                    //         PLACEHOLDER,
                    //         PLACEHOLDER,
                    //         {
                    //             LEO_LEV,
                    //             LEO_AMOUNT_AVG
                    //         }
                    //     ]
                    //
                    //      Example response:
                    //
                    //     [
                    //         null,
                    //         null,
                    //         null,
                    //         null,
                    //         [
                    //          [ 0.001, 0.001, 0.001, null, null, 0.0002 ],
                    //          [ 0.002, 0.002, 0.002, null, null, 0.00065 ]
                    //         ],
                    //         [
                    //          [
                    //              {
                    //              curr: 'Total (USD)',
                    //              vol: '0',
                    //              vol_safe: '0',
                    //              vol_maker: '0',
                    //              vol_BFX: '0',
                    //              vol_BFX_safe: '0',
                    //              vol_BFX_maker: '0'
                    //              }
                    //          ],
                    //          {},
                    //          0
                    //         ],
                    //         [ null, {}, 0 ],
                    //         null,
                    //         null,
                    //         { leo_lev: '0', leo_amount_avg: '0' }
                    //     ]
                    //
                    const result = {};
                    const fiat = this.safeValue(this.options, 'fiat', {});
                    const feeData = this.safeValue(response, 4, []);
                    const makerData = this.safeValue(feeData, 0, []);
                    const takerData = this.safeValue(feeData, 1, []);
                    const makerFee = this.safeNumber(makerData, 0);
                    const makerFeeFiat = this.safeNumber(makerData, 2);
                    const makerFeeDeriv = this.safeNumber(makerData, 5);
                    const takerFee = this.safeNumber(takerData, 0);
                    const takerFeeFiat = this.safeNumber(takerData, 2);
                    const takerFeeDeriv = this.safeNumber(takerData, 5);
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        const fee = {
                            'info': response,
                            'symbol': symbol,
                            'percentage': true,
                            'tierBased': true
                        };
                        if (market['quote'] in fiat) {
                            fee['maker'] = makerFeeFiat;
                            fee['taker'] = takerFeeFiat;
                        } else if (market['contract']) {
                            fee['maker'] = makerFeeDeriv;
                            fee['taker'] = takerFeeDeriv;
                        } else {
                            fee['maker'] = makerFee;
                            fee['taker'] = takerFee;
                        }
                        result[symbol] = fee;
                    }
                    return result;
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    let method = 'privatePostAuthRMovementsHist';
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['uppercaseId'];
                        method = 'privatePostAuthRMovementsCurrencyHist';
                    }
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit; // max 1000
                    const response = await this[method](this.extend(request, params));
                    //
                    //     [
                    //         [
                    //             13293039, // ID
                    //             'ETH', // CURRENCY
                    //             'ETHEREUM', // CURRENCY_NAME
                    //             null,
                    //             null,
                    //             1574175052000, // MTS_STARTED
                    //             1574181326000, // MTS_UPDATED
                    //             null,
                    //             null,
                    //             'CANCELED', // STATUS
                    //             null,
                    //             null,
                    //             -0.24, // AMOUNT, negative for withdrawals
                    //             -0.00135, // FEES
                    //             null,
                    //             null,
                    //             '0x38110e0Fc932CB2BE...........', // DESTINATION_ADDRESS
                    //             null,
                    //             null,
                    //             null,
                    //             '0x523ec8945500.....................................', // TRANSACTION_ID
                    //             "Purchase of 100 pizzas", // WITHDRAW_TRANSACTION_NOTE, might also be: null
                    //         ]
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    // todo rewrite for https://api-pub.bitfinex.com//v2/conf/pub:map:tx:method
                    const name = this.getCurrencyName(code);
                    const request = {
                        'method': name,
                        'wallet': 'exchange',
                        'amount': this.numberToString(amount),
                        'address': address
                    };
                    if (tag !== undefined) request['payment_id'] = tag;
                    const response = await this.privatePostAuthWWithdraw(this.extend(request, params));
                    //
                    //     [
                    //         1582271520931, // MTS Millisecond Time Stamp of the update
                    //         "acc_wd-req", // TYPE Purpose of notification 'acc_wd-req' account withdrawal request
                    //         null, // MESSAGE_ID unique ID of the message
                    //         null, // not documented
                    //         [
                    //             0, // WITHDRAWAL_ID Unique Withdrawal ID
                    //             null, // PLACEHOLDER
                    //             "bitcoin", // METHOD Method of withdrawal
                    //             null, // PAYMENT_ID Payment ID if relevant
                    //             "exchange", // WALLET Sending wallet
                    //             1, // AMOUNT Amount of Withdrawal less fee
                    //             null, // PLACEHOLDER
                    //             null, // PLACEHOLDER
                    //             0.0004, // WITHDRAWAL_FEE Fee on withdrawal
                    //         ],
                    //         null, // CODE null or integer Work in progress
                    //         "SUCCESS", // STATUS Status of the notification, it may vary over time SUCCESS, ERROR, FAILURE
                    //         "Invalid bitcoin address (abcdef)", // TEXT Text of the notification
                    //     ]
                    //
                    const text = this.safeString(response, 7);
                    if (text !== 'success') this.throwBroadlyMatchedException(this.exceptions['broad'], text, text);
                    const transaction = this.parseTransaction(response, currency);
                    return this.extend(transaction, {
                        'address': address
                    });
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostAuthRPositions(params);
                    //
                    //     [
                    //         [
                    //             "tBTCUSD", // SYMBOL
                    //             "ACTIVE", // STATUS
                    //             0.0195, // AMOUNT
                    //             8565.0267019, // BASE_PRICE
                    //             0, // MARGIN_FUNDING
                    //             0, // MARGIN_FUNDING_TYPE
                    //             -0.33455568705000516, // PL
                    //             -0.0003117550117425625, // PL_PERC
                    //             7045.876419249083, // PRICE_LIQ
                    //             3.0673001895895604, // LEVERAGE
                    //             null, // _PLACEHOLDER
                    //             142355652, // POSITION_ID
                    //             1574002216000, // MTS_CREATE
                    //             1574002216000, // MTS_UPDATE
                    //             null, // _PLACEHOLDER
                    //             0, // TYPE
                    //             null, // _PLACEHOLDER
                    //             0, // COLLATERAL
                    //             0, // COLLATERAL_MIN
                    //             // META
                    //             {
                    //                 "reason":"TRADE",
                    //                 "order_id":34271018124,
                    //                 "liq_stage":null,
                    //                 "trade_price":"8565.0267019",
                    //                 "trade_amount":"0.0195",
                    //                 "order_id_oppo":34277498022
                    //             }
                    //         ]
                    //     ]
                    //
                    // todo unify parsePosition/parsePositions
                    return response;
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let request = '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'v1') request = api + request;
                    else request = this.version + request;
                    let url = this.urls['api'][api] + '/' + request;
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    }
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        body = this.json(query);
                        const auth = '/api/' + request + nonce + body;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha384');
                        headers = {
                            'bfx-nonce': nonce,
                            'bfx-apikey': this.apiKey,
                            'bfx-signature': signature,
                            'Content-Type': 'application/json'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(statusCode, statusText, url, method, responseHeaders, responseBody, response, requestHeaders, requestBody) {
                    if (response !== undefined) {
                        if (!Array.isArray(response)) {
                            const message = this.safeString2(response, 'message', 'error');
                            const feedback = this.id + ' ' + responseBody;
                            this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                            throw new ExchangeError1(this.id + ' ' + responseBody);
                        }
                    } else if (response === '') throw new ExchangeError1(this.id + ' returned empty response');
                    if (statusCode === 500) {
                        // See https://docs.bitfinex.com/docs/abbreviations-glossary#section-errorinfo-codes
                        const errorCode = this.numberToString(response[1]);
                        const errorText = response[2];
                        const feedback = this.id + ' ' + errorText;
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorText, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], errorText, feedback);
                        throw new ExchangeError1(this.id + ' ' + errorText + ' (#' + errorCode + ')');
                    }
                    return response;
                }
                parseLedgerEntryType(type) {
                    if (type === undefined) return undefined;
                    else if (type.indexOf('fee') >= 0 || type.indexOf('charged') >= 0) return 'fee';
                    else if (type.indexOf('exchange') >= 0 || type.indexOf('position') >= 0) return 'trade';
                    else if (type.indexOf('rebate') >= 0) return 'rebate';
                    else if (type.indexOf('deposit') >= 0 || type.indexOf('withdrawal') >= 0) return 'transaction';
                    else if (type.indexOf('transfer') >= 0) return 'transfer';
                    else if (type.indexOf('payment') >= 0) return 'payout';
                    else return type;
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     [
                    //         [
                    //             2531822314, // ID: Ledger identifier
                    //             "USD", // CURRENCY: The symbol of the currency (ex. "BTC")
                    //             null, // PLACEHOLDER
                    //             1573521810000, // MTS: Timestamp in milliseconds
                    //             null, // PLACEHOLDER
                    //             0.01644445, // AMOUNT: Amount of funds moved
                    //             0, // BALANCE: New balance
                    //             null, // PLACEHOLDER
                    //             "Settlement @ 185.79 on wallet margin" // DESCRIPTION: Description of ledger transaction
                    //         ]
                    //     ]
                    //
                    let type = undefined;
                    const id = this.safeString(item, 0);
                    const currencyId = this.safeString(item, 1);
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const timestamp = this.safeInteger(item, 3);
                    const amount = this.safeNumber(item, 5);
                    const after = this.safeNumber(item, 6);
                    const description = this.safeString(item, 8);
                    if (description !== undefined) {
                        const parts = description.split(' @ ');
                        const first = this.safeStringLower(parts, 0);
                        type = this.parseLedgerEntryType(first);
                    }
                    return {
                        'id': id,
                        'direction': undefined,
                        'account': undefined,
                        'referenceId': id,
                        'referenceAccount': undefined,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'before': undefined,
                        'after': after,
                        'status': undefined,
                        'fee': undefined,
                        'info': item
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    let method = 'privatePostAuthRLedgersHist';
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['uppercaseId'];
                        method = 'privatePostAuthRLedgersCurrencyHist';
                    }
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit; // max 2500
                    const response = await this[method](this.extend(request, params));
                    //
                    //     [
                    //         [
                    //             2531822314, // ID: Ledger identifier
                    //             "USD", // CURRENCY: The symbol of the currency (ex. "BTC")
                    //             null, // PLACEHOLDER
                    //             1573521810000, // MTS: Timestamp in milliseconds
                    //             null, // PLACEHOLDER
                    //             0.01644445, // AMOUNT: Amount of funds moved
                    //             0, // BALANCE: New balance
                    //             null, // PLACEHOLDER
                    //             "Settlement @ 185.79 on wallet margin" // DESCRIPTION: Description of ledger transaction
                    //         ]
                    //     ]
                    //
                    return this.parseLedger(response, currency, since, limit);
                }
            };
        },
        {
            "./base/Precise": 6,
            "./base/errors": 8,
            "./bitfinex.js": 32
        }
    ],
    34: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, OrderNotFound: OrderNotFound } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class bitflyer extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitflyer',
                        'name': 'bitFlyer',
                        'countries': [
                            'JP'
                        ],
                        'version': 'v1',
                        'rateLimit': 1000,
                        'hostname': 'bitflyer.com',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': undefined,
                            'future': undefined,
                            'option': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': 'emulated',
                            'fetchDeposits': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': 'emulated',
                            'fetchOrder': 'emulated',
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPositions': true,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': false,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawals': true,
                            'transfer': false,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/28051642-56154182-660e-11e7-9b0d-6042d1e6edd8.jpg',
                            'api': 'https://api.{hostname}',
                            'www': 'https://bitflyer.com',
                            'doc': 'https://lightning.bitflyer.com/docs?lang=en'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'getmarkets/usa',
                                    'getmarkets/eu',
                                    'getmarkets',
                                    'getboard',
                                    'getticker',
                                    'getexecutions',
                                    'gethealth',
                                    'getboardstate',
                                    'getchats'
                                ]
                            },
                            'private': {
                                'get': [
                                    'getpermissions',
                                    'getbalance',
                                    'getbalancehistory',
                                    'getcollateral',
                                    'getcollateralhistory',
                                    'getcollateralaccounts',
                                    'getaddresses',
                                    'getcoinins',
                                    'getcoinouts',
                                    'getbankaccounts',
                                    'getdeposits',
                                    'getwithdrawals',
                                    'getchildorders',
                                    'getparentorders',
                                    'getparentorder',
                                    'getexecutions',
                                    'getpositions',
                                    'gettradingcommission'
                                ],
                                'post': [
                                    'sendcoin',
                                    'withdraw',
                                    'sendchildorder',
                                    'cancelchildorder',
                                    'sendparentorder',
                                    'cancelparentorder',
                                    'cancelallchildorders'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.002'),
                                'taker': this.parseNumber('0.002')
                            }
                        }
                    });
                }
                parseExpiryDate(expiry) {
                    const day = expiry.slice(0, 2);
                    const monthName = expiry.slice(2, 5);
                    const year = expiry.slice(5, 9);
                    const months = {
                        'JAN': '01',
                        'FEB': '02',
                        'MAR': '03',
                        'APR': '04',
                        'MAY': '05',
                        'JUN': '06',
                        'JUL': '07',
                        'AUG': '08',
                        'SEP': '09',
                        'OCT': '10',
                        'NOV': '11',
                        'DEC': '12'
                    };
                    const month = this.safeString(months, monthName);
                    return this.parse8601(year + '-' + month + '-' + day + 'T00:00:00Z');
                }
                async fetchMarkets(params = {}) {
                    const jp_markets = await this.publicGetGetmarkets(params);
                    //
                    //     [
                    //         // spot
                    //         { "product_code": "BTC_JPY", "market_type": "Spot" },
                    //         { "product_code": "BCH_BTC", "market_type": "Spot" },
                    //         // forex swap
                    //         { "product_code": "FX_BTC_JPY", "market_type": "FX" },
                    //         // future
                    //         {
                    //             "product_code": "BTCJPY11FEB2022",
                    //             "alias": "BTCJPY_MAT1WK",
                    //             "market_type": "Futures",
                    //         },
                    //     ];
                    //
                    const us_markets = await this.publicGetGetmarketsUsa(params);
                    //
                    //     [
                    //         { "product_code": "BTC_USD", "market_type": "Spot" },
                    //         { "product_code": "BTC_JPY", "market_type": "Spot" },
                    //     ];
                    //
                    const eu_markets = await this.publicGetGetmarketsEu(params);
                    //
                    //     [
                    //         { "product_code": "BTC_EUR", "market_type": "Spot" },
                    //         { "product_code": "BTC_JPY", "market_type": "Spot" },
                    //     ];
                    //
                    let markets = this.arrayConcat(jp_markets, us_markets);
                    markets = this.arrayConcat(markets, eu_markets);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'product_code');
                        const currencies = id.split('_');
                        const marketType = this.safeString(market, 'market_type');
                        const swap = marketType === 'FX';
                        const future = marketType === 'Futures';
                        const spot = !swap && !future;
                        let type = 'spot';
                        let settle = undefined;
                        let baseId = undefined;
                        let quoteId = undefined;
                        let expiry = undefined;
                        if (spot) {
                            baseId = this.safeString(currencies, 0);
                            quoteId = this.safeString(currencies, 1);
                        } else if (swap) {
                            type = 'swap';
                            baseId = this.safeString(currencies, 1);
                            quoteId = this.safeString(currencies, 2);
                        } else if (future) {
                            const alias = this.safeString(market, 'alias');
                            if (alias === undefined) {
                                // no alias:
                                // { product_code: 'BTCJPY11MAR2022', market_type: 'Futures' }
                                // TODO this will break if there are products with 4 chars
                                baseId = id.slice(0, 3);
                                quoteId = id.slice(3, 6);
                                // last 9 chars are expiry date
                                const expiryDate = id.slice(-9);
                                expiry = this.parseExpiryDate(expiryDate);
                            } else {
                                const splitAlias = alias.split('_');
                                const currencyIds = this.safeString(splitAlias, 0);
                                baseId = currencyIds.slice(0, -3);
                                quoteId = currencyIds.slice(-3);
                                const splitId = id.split(currencyIds);
                                const expiryDate = this.safeString(splitId, 1);
                                expiry = this.parseExpiryDate(expiryDate);
                            }
                            type = 'future';
                        }
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        let symbol = base + '/' + quote;
                        let taker = this.fees['trading']['taker'];
                        let maker = this.fees['trading']['maker'];
                        const contract = swap || future;
                        if (contract) {
                            maker = 0.0;
                            taker = 0.0;
                            settle = 'JPY';
                            symbol = symbol + ':' + settle;
                            if (future) symbol = symbol + '-' + this.yymmdd(expiry);
                        }
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': type,
                            'spot': spot,
                            'margin': false,
                            'swap': swap,
                            'future': future,
                            'option': false,
                            'active': true,
                            'contract': contract,
                            'linear': spot ? undefined : true,
                            'inverse': spot ? undefined : false,
                            'taker': taker,
                            'maker': maker,
                            'contractSize': undefined,
                            'expiry': expiry,
                            'expiryDatetime': this.iso8601(expiry),
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': undefined,
                                'price': undefined
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'currency_code');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'amount');
                        account['free'] = this.safeString(balance, 'available');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetGetbalance(params);
                    //
                    //     [
                    //         {
                    //             "currency_code": "JPY",
                    //             "amount": 1024078,
                    //             "available": 508000
                    //         },
                    //         {
                    //             "currency_code": "BTC",
                    //             "amount": 10.24,
                    //             "available": 4.12
                    //         },
                    //         {
                    //             "currency_code": "ETH",
                    //             "amount": 20.48,
                    //             "available": 16.38
                    //         }
                    //     ]
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'product_code': this.marketId(symbol)
                    };
                    const orderbook = await this.publicGetGetboard(this.extend(request, params));
                    return this.parseOrderBook(orderbook, symbol, undefined, 'bids', 'asks', 'price', 'size');
                }
                parseTicker(ticker, market) {
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.parse8601(this.safeString(ticker, 'timestamp'));
                    const last = this.safeString(ticker, 'ltp');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': undefined,
                        'low': undefined,
                        'bid': this.safeString(ticker, 'best_bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'best_ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume_by_product'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'product_code': market['id']
                    };
                    const response = await this.publicGetGetticker(this.extend(request, params));
                    return this.parseTicker(response, market);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public) v1
                    //
                    //     {
                    //          "id":2278466664,
                    //          "side":"SELL",
                    //          "price":56810.7,
                    //          "size":0.08798,
                    //          "exec_date":"2021-11-19T11:46:39.323",
                    //          "buy_child_order_acceptance_id":"JRF20211119-114209-236525",
                    //          "sell_child_order_acceptance_id":"JRF20211119-114639-236919"
                    //      }
                    //
                    //      {
                    //          "id":2278463423,
                    //          "side":"BUY",
                    //          "price":56757.83,
                    //          "size":0.6003,"exec_date":"2021-11-19T11:28:00.523",
                    //          "buy_child_order_acceptance_id":"JRF20211119-112800-236526",
                    //          "sell_child_order_acceptance_id":"JRF20211119-112734-062017"
                    //      }
                    //
                    //
                    //
                    let side = this.safeStringLower(trade, 'side');
                    if (side !== undefined) {
                        if (side.length < 1) side = undefined;
                    }
                    let order = undefined;
                    if (side !== undefined) {
                        const id = side + '_child_order_acceptance_id';
                        if (id in trade) order = trade[id];
                    }
                    if (order === undefined) order = this.safeString(trade, 'child_order_acceptance_id');
                    const timestamp = this.parse8601(this.safeString(trade, 'exec_date'));
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'size');
                    const id = this.safeString(trade, 'id');
                    market = this.safeMarket(undefined, market);
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': order,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'product_code': market['id']
                    };
                    const response = await this.publicGetGetexecutions(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'product_code': market['id']
                    };
                    const response = await this.privateGetGettradingcommission(this.extend(request, params));
                    //
                    //   {
                    //       commission_rate: '0.0020'
                    //   }
                    //
                    const fee = this.safeNumber(response, 'commission_rate');
                    return {
                        'info': response,
                        'symbol': symbol,
                        'maker': fee,
                        'taker': fee
                    };
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'product_code': this.marketId(symbol),
                        'child_order_type': type.toUpperCase(),
                        'side': side.toUpperCase(),
                        'price': price,
                        'size': amount
                    };
                    const result = await this.privatePostSendchildorder(this.extend(request, params));
                    // { "status": - 200, "error_message": "Insufficient funds", "data": null }
                    const id = this.safeString(result, 'child_order_acceptance_id');
                    return {
                        'info': result,
                        'id': id
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a `symbol` argument');
                    await this.loadMarkets();
                    const request = {
                        'product_code': this.marketId(symbol),
                        'child_order_acceptance_id': id
                    };
                    return await this.privatePostCancelchildorder(this.extend(request, params));
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'ACTIVE': 'open',
                        'COMPLETED': 'closed',
                        'CANCELED': 'canceled',
                        'EXPIRED': 'canceled',
                        'REJECTED': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    const timestamp = this.parse8601(this.safeString(order, 'child_order_date'));
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'size');
                    const filled = this.safeString(order, 'executed_size');
                    const remaining = this.safeString(order, 'outstanding_size');
                    const status = this.parseOrderStatus(this.safeString(order, 'child_order_state'));
                    const type = this.safeStringLower(order, 'child_order_type');
                    const side = this.safeStringLower(order, 'side');
                    const marketId = this.safeString(order, 'product_code');
                    const symbol = this.safeSymbol(marketId, market);
                    let fee = undefined;
                    const feeCost = this.safeNumber(order, 'total_commission');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': undefined,
                        'rate': undefined
                    };
                    const id = this.safeString(order, 'child_order_acceptance_id');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'fee': fee,
                        'average': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchOrders(symbol, since, limit = 100, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a `symbol` argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'product_code': market['id'],
                        'count': limit
                    };
                    const response = await this.privateGetGetchildorders(this.extend(request, params));
                    let orders = this.parseOrders(response, market, since, limit);
                    if (symbol !== undefined) orders = this.filterBy(orders, 'symbol', symbol);
                    return orders;
                }
                async fetchOpenOrders(symbol, since, limit = 100, params = {}) {
                    const request = {
                        'child_order_state': 'ACTIVE'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit = 100, params = {}) {
                    const request = {
                        'child_order_state': 'COMPLETED'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a `symbol` argument');
                    const orders = await this.fetchOrders(symbol);
                    const ordersById = this.indexBy(orders, 'id');
                    if (id in ordersById) return ordersById[id];
                    throw new OrderNotFound(this.id + ' No order found with id ' + id);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a `symbol` argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'product_code': market['id']
                    };
                    if (limit !== undefined) request['count'] = limit;
                    const response = await this.privateGetGetexecutions(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchPositions(symbols, params = {}) {
                    if (symbols === undefined) throw new ArgumentsRequired1(this.id + ' fetchPositions() requires a `symbols` argument, exactly one symbol in an array');
                    await this.loadMarkets();
                    const request = {
                        'product_code': this.marketIds(symbols)
                    };
                    const response = await this.privateGetpositions(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "product_code": "FX_BTC_JPY",
                    //             "side": "BUY",
                    //             "price": 36000,
                    //             "size": 10,
                    //             "commission": 0,
                    //             "swap_point_accumulate": -35,
                    //             "require_collateral": 120000,
                    //             "open_date": "2015-11-03T10:04:45.011",
                    //             "leverage": 3,
                    //             "pnl": 965,
                    //             "sfd": -0.5
                    //         }
                    //     ]
                    //
                    // todo unify parsePosition/parsePositions
                    return response;
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    this.checkAddress(address);
                    await this.loadMarkets();
                    if (code !== 'JPY' && code !== 'USD' && code !== 'EUR') throw new ExchangeError1(this.id + ' allows withdrawing JPY, USD, EUR only, ' + code + ' is not supported');
                    const currency = this.currency(code);
                    const request = {
                        'currency_code': currency['id'],
                        'amount': amount
                    };
                    const response = await this.privatePostWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "message_id": "69476620-5056-4003-bcbe-42658a2b041b"
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) currency = this.currency(code);
                    if (limit !== undefined) request['count'] = limit; // default 100
                    const response = await this.privateGetGetcoinins(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id": 100,
                    //             "order_id": "CDP20151227-024141-055555",
                    //             "currency_code": "BTC",
                    //             "amount": 0.00002,
                    //             "address": "1WriteySQufKZ2pVuM1oMhPrTtTVFq35j",
                    //             "tx_hash": "9f92ee65a176bb9545f7becb8706c50d07d4cee5ffca34d8be3ef11d411405ae",
                    //             "status": "COMPLETED",
                    //             "event_date": "2015-11-27T08:59:20.301"
                    //         }
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) currency = this.currency(code);
                    if (limit !== undefined) request['count'] = limit; // default 100
                    const response = await this.privateGetGetcoinouts(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id": 500,
                    //             "order_id": "CWD20151224-014040-077777",
                    //             "currency_code": "BTC",
                    //             "amount": 0.1234,
                    //             "address": "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa",
                    //             "tx_hash": "724c07dfd4044abcb390b0412c3e707dd5c4f373f0a52b3bd295ce32b478c60a",
                    //             "fee": 0.0005,
                    //             "additional_fee": 0.0001,
                    //             "status": "COMPLETED",
                    //             "event_date": "2015-12-24T01:40:40.397"
                    //         }
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit);
                }
                parseDepositStatus(status) {
                    const statuses = {
                        'PENDING': 'pending',
                        'COMPLETED': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseWithdrawalStatus(status) {
                    const statuses = {
                        'PENDING': 'pending',
                        'COMPLETED': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "id": 100,
                    //         "order_id": "CDP20151227-024141-055555",
                    //         "currency_code": "BTC",
                    //         "amount": 0.00002,
                    //         "address": "1WriteySQufKZ2pVuM1oMhPrTtTVFq35j",
                    //         "tx_hash": "9f92ee65a176bb9545f7becb8706c50d07d4cee5ffca34d8be3ef11d411405ae",
                    //         "status": "COMPLETED",
                    //         "event_date": "2015-11-27T08:59:20.301"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "id": 500,
                    //         "order_id": "CWD20151224-014040-077777",
                    //         "currency_code": "BTC",
                    //         "amount": 0.1234,
                    //         "address": "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa",
                    //         "tx_hash": "724c07dfd4044abcb390b0412c3e707dd5c4f373f0a52b3bd295ce32b478c60a",
                    //         "fee": 0.0005,
                    //         "additional_fee": 0.0001,
                    //         "status": "COMPLETED",
                    //         "event_date": "2015-12-24T01:40:40.397"
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "message_id": "69476620-5056-4003-bcbe-42658a2b041b"
                    //     }
                    //
                    const id = this.safeString2(transaction, 'id', 'message_id');
                    const address = this.safeString(transaction, 'address');
                    const currencyId = this.safeString(transaction, 'currency_code');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const timestamp = this.parse8601(this.safeString(transaction, 'event_date'));
                    const amount = this.safeNumber(transaction, 'amount');
                    const txId = this.safeString(transaction, 'tx_hash');
                    const rawStatus = this.safeString(transaction, 'status');
                    let type = undefined;
                    let status = undefined;
                    let fee = undefined;
                    if ('fee' in transaction) {
                        type = 'withdrawal';
                        status = this.parseWithdrawalStatus(rawStatus);
                        const feeCost = this.safeNumber(transaction, 'fee');
                        const additionalFee = this.safeNumber(transaction, 'additional_fee');
                        fee = {
                            'currency': code,
                            'cost': feeCost + additionalFee
                        };
                    } else {
                        type = 'deposit';
                        status = this.parseDepositStatus(rawStatus);
                    }
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'internal': undefined,
                        'fee': fee
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let request = '/' + this.version + '/';
                    if (api === 'private') request += 'me/';
                    request += path;
                    if (method === 'GET') {
                        if (Object.keys(params).length) request += '?' + this.urlencode(params);
                    }
                    const baseUrl = this.implodeHostname(this.urls['api']);
                    const url = baseUrl + request;
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        let auth = [
                            nonce,
                            method,
                            request
                        ].join('');
                        if (Object.keys(params).length) {
                            if (method !== 'GET') {
                                body = this.json(params);
                                auth += body;
                            }
                        }
                        headers = {
                            'ACCESS-KEY': this.apiKey,
                            'ACCESS-TIMESTAMP': nonce,
                            'ACCESS-SIGN': this.hmac(this.encode(auth), this.encode(this.secret)),
                            'Content-Type': 'application/json'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    35: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, AuthenticationError: AuthenticationError, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, DDoSProtection: DDoSProtection, PermissionDenied: PermissionDenied, BadSymbol: BadSymbol, InvalidOrder: InvalidOrder } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class bitforex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitforex',
                        'name': 'Bitforex',
                        'countries': [
                            'CN'
                        ],
                        'rateLimit': 500,
                        'version': 'v1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': undefined,
                            'future': false,
                            'option': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': undefined,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': undefined,
                            'fetchTicker': true,
                            'fetchTickers': undefined,
                            'fetchTrades': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': false,
                            'transfer': false,
                            'withdraw': false
                        },
                        'timeframes': {
                            '1m': '1min',
                            '5m': '5min',
                            '15m': '15min',
                            '30m': '30min',
                            '1h': '1hour',
                            '2h': '2hour',
                            '4h': '4hour',
                            '12h': '12hour',
                            '1d': '1day',
                            '1w': '1week',
                            '1M': '1month'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87295553-1160ec00-c50e-11ea-8ea0-df79276a9646.jpg',
                            'api': 'https://api.bitforex.com',
                            'www': 'https://www.bitforex.com',
                            'doc': 'https://github.com/githubdev2020/API_Doc_en/wiki',
                            'fees': 'https://help.bitforex.com/en_us/?cat=13',
                            'referral': 'https://www.bitforex.com/en/invitationRegister?inviterId=1867438'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'api/v1/market/symbols': 20,
                                    'api/v1/market/ticker': 4,
                                    'api/v1/market/depth': 4,
                                    'api/v1/market/trades': 20,
                                    'api/v1/market/kline': 20
                                }
                            },
                            'private': {
                                'post': {
                                    'api/v1/fund/mainAccount': 1,
                                    'api/v1/fund/allAccount': 30,
                                    'api/v1/trade/placeOrder': 1,
                                    'api/v1/trade/placeMultiOrder': 10,
                                    'api/v1/trade/cancelOrder': 1,
                                    'api/v1/trade/cancelMultiOrder': 20,
                                    'api/v1/trade/cancelAllOrder': 20,
                                    'api/v1/trade/orderInfo': 1,
                                    'api/v1/trade/multiOrderInfo': 10,
                                    'api/v1/trade/orderInfos': 20
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.001'),
                                'taker': this.parseNumber('0.001')
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': true,
                                'deposit': {},
                                'withdraw': {}
                            }
                        },
                        'commonCurrencies': {
                            'BKC': 'Bank Coin',
                            'CAPP': 'Crypto Application Token',
                            'CREDIT': 'TerraCredit',
                            'CTC': 'Culture Ticket Chain',
                            'EWT': 'EcoWatt Token',
                            'IQ': 'IQ.Cash',
                            'MIR': 'MIR COIN',
                            'NOIA': 'METANOIA',
                            'TON': 'To The Moon'
                        },
                        'exceptions': {
                            '1000': OrderNotFound,
                            '1003': BadSymbol,
                            '1013': AuthenticationError,
                            '1016': AuthenticationError,
                            '1017': PermissionDenied,
                            '1019': BadSymbol,
                            '3002': InsufficientFunds,
                            '4002': InvalidOrder,
                            '4003': InvalidOrder,
                            '4004': OrderNotFound,
                            '10204': DDoSProtection
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetApiV1MarketSymbols(params);
                    //
                    //    {
                    //        "data": [
                    //            {
                    //                "amountPrecision":4,
                    //                "minOrderAmount":3.0E-4,
                    //                "pricePrecision":2,
                    //                "symbol":"coin-usdt-btc"
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    const data = response['data'];
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const id = this.safeString(market, 'symbol');
                        const symbolParts = id.split('-');
                        const baseId = symbolParts[2];
                        const quoteId = symbolParts[1];
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDateTime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'amountPrecision'),
                                'price': this.safeInteger(market, 'pricePrecision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minOrderAmount'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public) v1
                    //
                    //      {
                    //          "price":57594.53,
                    //          "amount":0.3172,
                    //          "time":1637329685322,
                    //          "direction":1,
                    //          "tid":"1131019666"
                    //      }
                    //
                    //      {
                    //          "price":57591.33,
                    //          "amount":0.002,
                    //          "time":1637329685322,
                    //          "direction":1,
                    //          "tid":"1131019639"
                    //      }
                    //
                    market = this.safeMarket(undefined, market);
                    const timestamp = this.safeInteger(trade, 'time');
                    const id = this.safeString(trade, 'tid');
                    const orderId = undefined;
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const sideId = this.safeInteger(trade, 'direction');
                    const side = this.parseSide(sideId);
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': undefined,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'order': orderId,
                        'fee': undefined,
                        'takerOrMaker': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['size'] = limit;
                    const market = this.market(symbol);
                    const response = await this.publicGetApiV1MarketTrades(this.extend(request, params));
                    //
                    // {
                    //  "data":
                    //      [
                    //          {
                    //              "price":57594.53,
                    //              "amount":0.3172,
                    //              "time":1637329685322,
                    //              "direction":1,
                    //              "tid":"1131019666"
                    //          }
                    //      ],
                    //  "success": true,
                    //  "time": 1637329688475
                    // }
                    //
                    return this.parseTrades(response['data'], market, since, limit);
                }
                parseBalance(response) {
                    const data = response['data'];
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < data.length; i++){
                        const balance = data[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['used'] = this.safeString(balance, 'frozen');
                        account['free'] = this.safeString(balance, 'active');
                        account['total'] = this.safeString(balance, 'fix');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostApiV1FundAllAccount(params);
                    return this.parseBalance(response);
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "buy":7.04E-7,
                    //         "date":1643371198598,
                    //         "high":7.48E-7,
                    //         "last":7.28E-7,
                    //         "low":7.10E-7,
                    //         "sell":7.54E-7,
                    //         "vol":9877287.2874
                    //     }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.safeInteger(ticker, 'date');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': this.safeString(ticker, 'last'),
                        'last': this.safeString(ticker, 'last'),
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'vol'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.markets[symbol];
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetApiV1MarketTicker(this.extend(request, params));
                    const ticker = this.safeValue(response, 'data');
                    //
                    //     {
                    //         "data":{
                    //             "buy":37082.83,
                    //             "date":1643388686660,
                    //             "high":37487.83,
                    //             "last":37086.79,
                    //             "low":35544.44,
                    //             "sell":37090.52,
                    //             "vol":690.9776
                    //         },
                    //         "success":true,
                    //         "time":1643388686660
                    //     }
                    //
                    return this.parseTicker(ticker, market);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "close":0.02505143,
                    //         "currencyVol":0,
                    //         "high":0.02506422,
                    //         "low":0.02505143,
                    //         "open":0.02506095,
                    //         "time":1591508940000,
                    //         "vol":51.1869
                    //     }
                    //
                    return [
                        this.safeInteger(ohlcv, 'time'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'vol')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'ktype': this.timeframes[timeframe]
                    };
                    if (limit !== undefined) request['size'] = limit; // default 1, max 600
                    const response = await this.publicGetApiV1MarketKline(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             {"close":0.02505143,"currencyVol":0,"high":0.02506422,"low":0.02505143,"open":0.02506095,"time":1591508940000,"vol":51.1869},
                    //             {"close":0.02503914,"currencyVol":0,"high":0.02506687,"low":0.02503914,"open":0.02505358,"time":1591509000000,"vol":9.1082},
                    //             {"close":0.02505172,"currencyVol":0,"high":0.02507466,"low":0.02503895,"open":0.02506371,"time":1591509060000,"vol":63.7431},
                    //         ],
                    //         "success":true,
                    //         "time":1591509427131
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const marketId = this.marketId(symbol);
                    const request = {
                        'symbol': marketId
                    };
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this.publicGetApiV1MarketDepth(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    const timestamp = this.safeInteger(response, 'time');
                    return this.parseOrderBook(data, symbol, timestamp, 'bids', 'asks', 'price', 'amount');
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '0': 'open',
                        '1': 'open',
                        '2': 'closed',
                        '3': 'canceled',
                        '4': 'canceled'
                    };
                    return status in statuses ? statuses[status] : status;
                }
                parseSide(sideId) {
                    if (sideId === 1) return 'buy';
                    else if (sideId === 2) return 'sell';
                    else return undefined;
                }
                parseOrder(order, market) {
                    const id = this.safeString(order, 'orderId');
                    const timestamp = this.safeNumber(order, 'createTime');
                    const lastTradeTimestamp = this.safeNumber(order, 'lastTime');
                    const symbol = market['symbol'];
                    const sideId = this.safeInteger(order, 'tradeType');
                    const side = this.parseSide(sideId);
                    const type = undefined;
                    const price = this.safeString(order, 'orderPrice');
                    const average = this.safeString(order, 'avgPrice');
                    const amount = this.safeString(order, 'orderAmount');
                    const filled = this.safeString(order, 'dealAmount');
                    const status = this.parseOrderStatus(this.safeString(order, 'orderState'));
                    const feeSide = side === 'buy' ? 'base' : 'quote';
                    const feeCurrency = market[feeSide];
                    const fee = {
                        'cost': this.safeNumber(order, 'tradeFee'),
                        'currency': feeCurrency
                    };
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'average': average,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': this.marketId(symbol),
                        'orderId': id
                    };
                    const response = await this.privatePostApiV1TradeOrderInfo(this.extend(request, params));
                    const order = this.parseOrder(response['data'], market);
                    return order;
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': this.marketId(symbol),
                        'state': 0
                    };
                    const response = await this.privatePostApiV1TradeOrderInfos(this.extend(request, params));
                    return this.parseOrders(response['data'], market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': this.marketId(symbol),
                        'state': 1
                    };
                    const response = await this.privatePostApiV1TradeOrderInfos(this.extend(request, params));
                    return this.parseOrders(response['data'], market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    let sideId = undefined;
                    if (side === 'buy') sideId = 1;
                    else if (side === 'sell') sideId = 2;
                    const request = {
                        'symbol': this.marketId(symbol),
                        'price': price,
                        'amount': amount,
                        'tradeType': sideId
                    };
                    const response = await this.privatePostApiV1TradePlaceOrder(this.extend(request, params));
                    const data = response['data'];
                    return {
                        'info': response,
                        'id': this.safeString(data, 'orderId')
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderId': id
                    };
                    if (symbol !== undefined) request['symbol'] = this.marketId(symbol);
                    const results = await this.privatePostApiV1TradeCancelOrder(this.extend(request, params));
                    const success = results['success'];
                    const returnVal = {
                        'info': results,
                        'success': success
                    };
                    return returnVal;
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        let payload = this.urlencode({
                            'accessKey': this.apiKey
                        });
                        query['nonce'] = this.milliseconds();
                        if (Object.keys(query).length) payload += '&' + this.urlencode(this.keysort(query));
                        // let message = '/' + 'api/' + this.version + '/' + path + '?' + payload;
                        const message = '/' + path + '?' + payload;
                        const signature = this.hmac(this.encode(message), this.encode(this.secret));
                        body = payload + '&signData=' + signature;
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (typeof body !== 'string') return; // fallback to default error handler
                    if (body[0] === '{' || body[0] === '[') {
                        const feedback = this.id + ' ' + body;
                        const success = this.safeValue(response, 'success');
                        if (success !== undefined) {
                            if (!success) {
                                const code = this.safeString(response, 'code');
                                this.throwExactlyMatchedException(this.exceptions, code, feedback);
                                throw new ExchangeError1(feedback);
                            }
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    36: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, OnMaintenance: OnMaintenance, ArgumentsRequired: ArgumentsRequired1, BadRequest: BadRequest, AccountSuspended: AccountSuspended, InvalidAddress: InvalidAddress, PermissionDenied: PermissionDenied, DDoSProtection: DDoSProtection, InsufficientFunds: InsufficientFunds, InvalidNonce: InvalidNonce, CancelPending: CancelPending, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, AuthenticationError: AuthenticationError, RequestTimeout: RequestTimeout, BadSymbol: BadSymbol, RateLimitExceeded: RateLimitExceeded } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bitget extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitget',
                        'name': 'Bitget',
                        'countries': [
                            'SG'
                        ],
                        'version': 'v1',
                        'rateLimit': 50,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': undefined,
                            'future': undefined,
                            'option': false,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createOrder': true,
                            'fetchAccounts': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDeposits': false,
                            'fetchLedger': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': true,
                            'fetchPositions': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': true,
                            'fetchTransfer': false,
                            'fetchTransfers': undefined,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': false,
                            'setLeverage': true,
                            'setMarginMode': true,
                            'transfer': false,
                            'withdraw': false
                        },
                        'timeframes': {
                            'spot': {
                                '1m': '1min',
                                '5m': '5min',
                                '15m': '15min',
                                '30m': '30min',
                                '1h': '1h',
                                '4h': '4h',
                                '12h': '12h',
                                '1d': '1day',
                                '1w': '7day'
                            },
                            'swap': {
                                '1m': '60',
                                '5m': '300',
                                '15m': '900',
                                '30m': '1800',
                                '1h': '3600',
                                '4h': '14400',
                                '12h': '43200',
                                '1d': '86400',
                                '1w': '604800'
                            }
                        },
                        'hostname': 'bitget.com',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/88317935-a8a21c80-cd22-11ea-8e2b-4b9fac5975eb.jpg',
                            'api': {
                                'spot': 'https://api.{hostname}',
                                'mix': 'https://api.{hostname}'
                            },
                            'www': 'https://www.bitget.com',
                            'doc': [
                                'https://bitgetlimited.github.io/apidoc/en/swap',
                                'https://bitgetlimited.github.io/apidoc/en/spot'
                            ],
                            'fees': 'https://www.bitget.cc/zh-CN/rate?tab=1',
                            'test': {
                                'rest': 'https://testnet.bitget.com'
                            },
                            'referral': 'https://www.bitget.com/expressly?languageType=0&channelCode=ccxt&vipCode=tg9j'
                        },
                        'api': {
                            'public': {
                                'spot': {
                                    'get': {
                                        'public/time': 1,
                                        'public/currencies': 1,
                                        'public/products': 1,
                                        'public/product': 1,
                                        'market/ticker': 1,
                                        'market/tickers': 1,
                                        'market/fills': 1,
                                        'market/candles': 1,
                                        'market/depth': 1
                                    }
                                },
                                'mix': {
                                    'get': {
                                        'market/contracts': 1,
                                        'market/depth': 1,
                                        'market/ticker': 1,
                                        'market/tickers': 1,
                                        'market/fills': 1,
                                        'market/candles': 1,
                                        'market/index': 1,
                                        'market/funding-time': 1,
                                        'market/history-fundRate': 1,
                                        'market/current-fundRate': 1,
                                        'market/open-interest': 1,
                                        'market/mark-price': 1,
                                        'market/symbol-leverage': 1
                                    }
                                }
                            },
                            'private': {
                                'spot': {
                                    'get': {
                                        'account/assets': 2,
                                        'account/transferRecords': 1
                                    },
                                    'post': {
                                        'account/bills': 2,
                                        'trade/orders': 2,
                                        'trade/batch-orders': 4,
                                        'trade/cancel-order': 2,
                                        'trade/cancel-batch-orders': 4,
                                        'trade/orderInfo': 1,
                                        'trade/open-orders': 1,
                                        'trade/history': 1,
                                        'trade/fills': 1
                                    }
                                },
                                'mix': {
                                    'get': {
                                        'account/account': 2,
                                        'account/accounts': 2,
                                        'account/open-count': 1,
                                        'order/current': 2,
                                        'order/history': 2,
                                        'order/detail': 2,
                                        'order/fills': 2,
                                        'position/singlePosition': 2,
                                        'position/allPosition': 2,
                                        'trace/currentTrack': 2,
                                        'trace/followerOrder': 2,
                                        'trace/historyTrack': 2,
                                        'trace/summary': 2,
                                        'trace/profitSettleTokenIdGroup': 2,
                                        'trace/profitDateGroupList': 2,
                                        'trade/profitDateList': 2,
                                        'trace/waitProfitDateList': 2,
                                        'trace/traderSymbols': 2
                                    },
                                    'post': {
                                        'account/setLeverage': 8,
                                        'account/setMargin': 8,
                                        'account/setMarginMode': 8,
                                        'order/placeOrder': 2,
                                        'order/batch-orders': 2,
                                        'order/cancel-order': 2,
                                        'order/cancel-batch-orders': 2,
                                        'plan/placePlan': 2,
                                        'plan/modifyPlan': 2,
                                        'plan/modifyPlanPreset': 2,
                                        'plan/placeTPSL': 2,
                                        'plan/modifyTPSLPlan': 2,
                                        'plan/cancelPlan': 2,
                                        'plan/currentPlan': 2,
                                        'plan/historyPlan': 2,
                                        'trace/closeTrackOrder': 2,
                                        'trace/setUpCopySymbols': 2
                                    }
                                }
                            }
                        },
                        'fees': {
                            'spot': {
                                'taker': this.parseNumber('0.002'),
                                'maker': this.parseNumber('0.002')
                            },
                            'swap': {
                                'taker': this.parseNumber('0.0006'),
                                'maker': this.parseNumber('0.0004')
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'password': true
                        },
                        'exceptions': {
                            // http error codes
                            // 400 Bad Request — Invalid request format
                            // 401 Unauthorized — Invalid API Key
                            // 403 Forbidden — You do not have access to the requested resource
                            // 404 Not Found
                            // 500 Internal Server Error — We had a problem with our server
                            'exact': {
                                '1': ExchangeError1,
                                // undocumented
                                'failure to get a peer from the ring-balancer': ExchangeNotAvailable,
                                '4010': PermissionDenied,
                                // common
                                // '0': ExchangeError, // 200 successful,when the order placement / cancellation / operation is successful
                                '4001': ExchangeError1,
                                '4002': ExchangeError1,
                                // --------------------------------------------------------
                                '30001': AuthenticationError,
                                '30002': AuthenticationError,
                                '30003': AuthenticationError,
                                '30004': AuthenticationError,
                                '30005': InvalidNonce,
                                '30006': AuthenticationError,
                                '30007': BadRequest,
                                '30008': RequestTimeout,
                                '30009': ExchangeError1,
                                '30010': AuthenticationError,
                                '30011': PermissionDenied,
                                '30012': AuthenticationError,
                                '30013': AuthenticationError,
                                '30014': DDoSProtection,
                                '30015': AuthenticationError,
                                '30016': ExchangeError1,
                                '30017': ExchangeError1,
                                '30018': ExchangeError1,
                                '30019': ExchangeNotAvailable,
                                '30020': BadRequest,
                                '30021': BadRequest,
                                '30022': PermissionDenied,
                                '30023': BadRequest,
                                '30024': BadSymbol,
                                '30025': BadRequest,
                                '30026': DDoSProtection,
                                '30027': AuthenticationError,
                                '30028': PermissionDenied,
                                '30029': AccountSuspended,
                                '30030': ExchangeError1,
                                '30031': BadRequest,
                                '30032': BadSymbol,
                                '30033': BadRequest,
                                '30034': ExchangeError1,
                                '30035': ExchangeError1,
                                '30036': ExchangeError1,
                                '30037': ExchangeNotAvailable,
                                // '30038': AuthenticationError, // { "code": 30038, "message": "user does not exist" }
                                '30038': OnMaintenance,
                                // futures
                                '32001': AccountSuspended,
                                '32002': PermissionDenied,
                                '32003': CancelPending,
                                '32004': ExchangeError1,
                                '32005': InvalidOrder,
                                '32006': InvalidOrder,
                                '32007': InvalidOrder,
                                '32008': InvalidOrder,
                                '32009': InvalidOrder,
                                '32010': ExchangeError1,
                                '32011': ExchangeError1,
                                '32012': ExchangeError1,
                                '32013': ExchangeError1,
                                '32014': ExchangeError1,
                                '32015': ExchangeError1,
                                '32016': ExchangeError1,
                                '32017': ExchangeError1,
                                '32018': ExchangeError1,
                                '32019': ExchangeError1,
                                '32020': ExchangeError1,
                                '32021': ExchangeError1,
                                '32022': ExchangeError1,
                                '32023': ExchangeError1,
                                '32024': ExchangeError1,
                                '32025': ExchangeError1,
                                '32026': ExchangeError1,
                                '32027': ExchangeError1,
                                '32028': AccountSuspended,
                                '32029': ExchangeError1,
                                '32030': InvalidOrder,
                                '32031': ArgumentsRequired1,
                                '32038': AuthenticationError,
                                '32040': ExchangeError1,
                                '32044': ExchangeError1,
                                '32045': ExchangeError1,
                                '32046': ExchangeError1,
                                '32047': ExchangeError1,
                                '32048': InvalidOrder,
                                '32049': ExchangeError1,
                                '32050': InvalidOrder,
                                '32051': InvalidOrder,
                                '32052': ExchangeError1,
                                '32053': ExchangeError1,
                                '32057': ExchangeError1,
                                '32054': ExchangeError1,
                                '32055': InvalidOrder,
                                '32056': ExchangeError1,
                                '32058': ExchangeError1,
                                '32059': InvalidOrder,
                                '32060': InvalidOrder,
                                '32061': InvalidOrder,
                                '32062': InvalidOrder,
                                '32063': InvalidOrder,
                                '32064': ExchangeError1,
                                '32065': ExchangeError1,
                                '32066': ExchangeError1,
                                '32067': ExchangeError1,
                                '32068': ExchangeError1,
                                '32069': ExchangeError1,
                                '32070': ExchangeError1,
                                '32071': ExchangeError1,
                                '32072': ExchangeError1,
                                '32073': ExchangeError1,
                                '32074': ExchangeError1,
                                '32075': ExchangeError1,
                                '32076': ExchangeError1,
                                '32077': ExchangeError1,
                                '32078': ExchangeError1,
                                '32079': ExchangeError1,
                                '32080': ExchangeError1,
                                '32083': ExchangeError1,
                                // token and margin trading
                                '33001': PermissionDenied,
                                '33002': AccountSuspended,
                                '33003': InsufficientFunds,
                                '33004': ExchangeError1,
                                '33005': ExchangeError1,
                                '33006': ExchangeError1,
                                '33007': ExchangeError1,
                                '33008': InsufficientFunds,
                                '33009': ExchangeError1,
                                '33010': ExchangeError1,
                                '33011': ExchangeError1,
                                '33012': ExchangeError1,
                                '33013': InvalidOrder,
                                '33014': OrderNotFound,
                                '33015': InvalidOrder,
                                '33016': ExchangeError1,
                                '33017': InsufficientFunds,
                                '33018': ExchangeError1,
                                '33020': ExchangeError1,
                                '33021': BadRequest,
                                '33022': InvalidOrder,
                                '33023': ExchangeError1,
                                '33024': InvalidOrder,
                                '33025': InvalidOrder,
                                '33026': ExchangeError1,
                                '33027': InvalidOrder,
                                '33028': InvalidOrder,
                                '33029': InvalidOrder,
                                '33034': ExchangeError1,
                                '33035': ExchangeError1,
                                '33036': ExchangeError1,
                                '33037': ExchangeError1,
                                '33038': ExchangeError1,
                                '33039': ExchangeError1,
                                '33040': ExchangeError1,
                                '33041': ExchangeError1,
                                '33042': ExchangeError1,
                                '33043': ExchangeError1,
                                '33044': ExchangeError1,
                                '33045': ExchangeError1,
                                '33046': ExchangeError1,
                                '33047': ExchangeError1,
                                '33048': ExchangeError1,
                                '33049': ExchangeError1,
                                '33050': ExchangeError1,
                                '33051': ExchangeError1,
                                '33059': BadRequest,
                                '33060': BadRequest,
                                '33061': ExchangeError1,
                                '33062': ExchangeError1,
                                '33063': ExchangeError1,
                                '33064': ExchangeError1,
                                '33065': ExchangeError1,
                                // account
                                '21009': ExchangeError1,
                                '34001': PermissionDenied,
                                '34002': InvalidAddress,
                                '34003': ExchangeError1,
                                '34004': ExchangeError1,
                                '34005': ExchangeError1,
                                '34006': ExchangeError1,
                                '34007': ExchangeError1,
                                '34008': InsufficientFunds,
                                '34009': ExchangeError1,
                                '34010': ExchangeError1,
                                '34011': ExchangeError1,
                                '34012': ExchangeError1,
                                '34013': ExchangeError1,
                                '34014': ExchangeError1,
                                '34015': ExchangeError1,
                                '34016': PermissionDenied,
                                '34017': AccountSuspended,
                                '34018': AuthenticationError,
                                '34019': PermissionDenied,
                                '34020': PermissionDenied,
                                '34021': InvalidAddress,
                                '34022': ExchangeError1,
                                '34023': PermissionDenied,
                                '34026': ExchangeError1,
                                '34036': ExchangeError1,
                                '34037': ExchangeError1,
                                '34038': ExchangeError1,
                                '34039': ExchangeError1,
                                // swap
                                '35001': ExchangeError1,
                                '35002': ExchangeError1,
                                '35003': ExchangeError1,
                                '35004': ExchangeError1,
                                '35005': AuthenticationError,
                                '35008': InvalidOrder,
                                '35010': InvalidOrder,
                                '35012': InvalidOrder,
                                '35014': InvalidOrder,
                                '35015': InvalidOrder,
                                '35017': ExchangeError1,
                                '35019': InvalidOrder,
                                '35020': InvalidOrder,
                                '35021': InvalidOrder,
                                '35022': ExchangeError1,
                                '35024': ExchangeError1,
                                '35025': InsufficientFunds,
                                '35026': ExchangeError1,
                                '35029': OrderNotFound,
                                '35030': InvalidOrder,
                                '35031': InvalidOrder,
                                '35032': ExchangeError1,
                                '35037': ExchangeError1,
                                '35039': ExchangeError1,
                                '35040': InvalidOrder,
                                '35044': ExchangeError1,
                                '35046': InsufficientFunds,
                                '35047': InsufficientFunds,
                                '35048': ExchangeError1,
                                '35049': InvalidOrder,
                                '35050': InvalidOrder,
                                '35052': InsufficientFunds,
                                '35053': ExchangeError1,
                                '35055': InsufficientFunds,
                                '35057': ExchangeError1,
                                '35058': ExchangeError1,
                                '35059': BadRequest,
                                '35060': BadRequest,
                                '35061': BadRequest,
                                '35062': InvalidOrder,
                                '35063': InvalidOrder,
                                '35064': InvalidOrder,
                                '35066': InvalidOrder,
                                '35067': InvalidOrder,
                                '35068': InvalidOrder,
                                '35069': InvalidOrder,
                                '35070': InvalidOrder,
                                '35071': InvalidOrder,
                                '35072': InvalidOrder,
                                '35073': InvalidOrder,
                                '35074': InvalidOrder,
                                '35075': InvalidOrder,
                                '35076': InvalidOrder,
                                '35077': InvalidOrder,
                                '35078': InvalidOrder,
                                '35079': InvalidOrder,
                                '35080': InvalidOrder,
                                '35081': InvalidOrder,
                                '35082': InvalidOrder,
                                '35083': InvalidOrder,
                                '35084': InvalidOrder,
                                '35085': InvalidOrder,
                                '35086': InvalidOrder,
                                '35087': InvalidOrder,
                                '35088': InvalidOrder,
                                '35089': InvalidOrder,
                                '35090': ExchangeError1,
                                '35091': ExchangeError1,
                                '35092': ExchangeError1,
                                '35093': ExchangeError1,
                                '35094': ExchangeError1,
                                '35095': BadRequest,
                                '35096': ExchangeError1,
                                '35097': ExchangeError1,
                                '35098': ExchangeError1,
                                '35099': ExchangeError1,
                                // option
                                '36001': BadRequest,
                                '36002': BadRequest,
                                '36005': ExchangeError1,
                                '36101': AuthenticationError,
                                '36102': PermissionDenied,
                                '36103': AccountSuspended,
                                '36104': PermissionDenied,
                                '36105': PermissionDenied,
                                '36106': AccountSuspended,
                                '36107': PermissionDenied,
                                '36108': InsufficientFunds,
                                '36109': PermissionDenied,
                                '36201': PermissionDenied,
                                '36202': PermissionDenied,
                                '36203': InvalidOrder,
                                '36204': ExchangeError1,
                                '36205': BadRequest,
                                '36206': BadRequest,
                                '36207': InvalidOrder,
                                '36208': InvalidOrder,
                                '36209': InvalidOrder,
                                '36210': InvalidOrder,
                                '36211': InvalidOrder,
                                '36212': InvalidOrder,
                                '36213': InvalidOrder,
                                '36214': ExchangeError1,
                                '36216': OrderNotFound,
                                '36217': InvalidOrder,
                                '36218': InvalidOrder,
                                '36219': InvalidOrder,
                                '36220': InvalidOrder,
                                '36221': InvalidOrder,
                                '36222': InvalidOrder,
                                '36223': InvalidOrder,
                                '36224': InvalidOrder,
                                '36225': InvalidOrder,
                                '36226': InvalidOrder,
                                '36227': InvalidOrder,
                                '36228': InvalidOrder,
                                '36229': InvalidOrder,
                                '36230': InvalidOrder,
                                // --------------------------------------------------------
                                // swap
                                '400': BadRequest,
                                '401': AuthenticationError,
                                '403': PermissionDenied,
                                '404': BadRequest,
                                '405': BadRequest,
                                '415': BadRequest,
                                '429': DDoSProtection,
                                '500': ExchangeNotAvailable,
                                '1001': RateLimitExceeded,
                                '1002': ExchangeError1,
                                '1003': ExchangeError1,
                                // '00000': ExchangeError, // success
                                '40001': AuthenticationError,
                                '40002': AuthenticationError,
                                '40003': AuthenticationError,
                                '40004': InvalidNonce,
                                '40005': InvalidNonce,
                                '40006': AuthenticationError,
                                '40007': BadRequest,
                                '40008': InvalidNonce,
                                '40009': AuthenticationError,
                                '40010': AuthenticationError,
                                '40011': AuthenticationError,
                                '40012': AuthenticationError,
                                '40013': ExchangeError1,
                                '40014': PermissionDenied,
                                '40015': ExchangeError1,
                                '40016': PermissionDenied,
                                '40017': ExchangeError1,
                                '40018': PermissionDenied,
                                '40102': BadRequest,
                                '40103': BadRequest,
                                '40104': ExchangeError1,
                                '40105': ExchangeError1,
                                '40106': ExchangeError1,
                                '40107': ExchangeError1,
                                '40108': InvalidOrder,
                                '40109': OrderNotFound,
                                '40200': OnMaintenance,
                                '40201': InvalidOrder,
                                '40202': ExchangeError1,
                                '40203': BadRequest,
                                '40204': BadRequest,
                                '40205': BadRequest,
                                '40206': BadRequest,
                                '40207': BadRequest,
                                '40208': BadRequest,
                                '40209': BadRequest,
                                '40300': ExchangeError1,
                                '40301': PermissionDenied,
                                '40302': BadRequest,
                                '40303': BadRequest,
                                '40304': BadRequest,
                                '40305': BadRequest,
                                '40306': ExchangeError1,
                                '40308': OnMaintenance,
                                '40309': BadSymbol,
                                '40400': ExchangeError1,
                                '40401': ExchangeError1,
                                '40402': BadRequest,
                                '40403': BadRequest,
                                '40404': BadRequest,
                                '40405': BadRequest,
                                '40406': BadRequest,
                                '40407': ExchangeError1,
                                '40408': ExchangeError1,
                                '40409': ExchangeError1,
                                '40500': InvalidOrder,
                                '40501': ExchangeError1,
                                '40502': ExchangeError1,
                                '40503': ExchangeError1,
                                '40504': ExchangeError1,
                                '40505': ExchangeError1,
                                '40506': AuthenticationError,
                                '40507': AuthenticationError,
                                '40508': ExchangeError1,
                                '40509': ExchangeError1,
                                '40600': ExchangeError1,
                                '40601': ExchangeError1,
                                '40602': ExchangeError1,
                                '40603': ExchangeError1,
                                '40604': ExchangeNotAvailable,
                                '40605': ExchangeError1,
                                '40606': ExchangeError1,
                                '40607': ExchangeError1,
                                '40608': ExchangeError1,
                                '40609': ExchangeError1,
                                '40700': BadRequest,
                                '40701': ExchangeError1,
                                '40702': ExchangeError1,
                                '40703': ExchangeError1,
                                '40704': ExchangeError1,
                                '40705': BadRequest,
                                '40706': InvalidOrder,
                                '40707': BadRequest,
                                '40708': BadRequest,
                                '40709': ExchangeError1,
                                '40710': ExchangeError1,
                                '40711': InsufficientFunds,
                                '40712': InsufficientFunds,
                                '40713': ExchangeError1,
                                '40714': ExchangeError1,
                                // spot
                                'invalid sign': AuthenticationError,
                                'invalid currency': BadSymbol,
                                'invalid symbol': BadSymbol,
                                'invalid period': BadRequest,
                                'invalid user': ExchangeError1,
                                'invalid amount': InvalidOrder,
                                'invalid type': InvalidOrder,
                                'invalid orderId': InvalidOrder,
                                'invalid record': ExchangeError1,
                                'invalid accountId': BadRequest,
                                'invalid address': BadRequest,
                                'accesskey not null': AuthenticationError,
                                'illegal accesskey': AuthenticationError,
                                'sign not null': AuthenticationError,
                                'req_time is too much difference from server time': InvalidNonce,
                                'permissions not right': PermissionDenied,
                                'illegal sign invalid': AuthenticationError,
                                'user locked': AccountSuspended,
                                'Request Frequency Is Too High': RateLimitExceeded,
                                'more than a daily rate of cash': BadRequest,
                                'more than the maximum daily withdrawal amount': BadRequest,
                                'need to bind email or mobile': ExchangeError1,
                                'user forbid': PermissionDenied,
                                'User Prohibited Cash Withdrawal': PermissionDenied,
                                'Cash Withdrawal Is Less Than The Minimum Value': BadRequest,
                                'Cash Withdrawal Is More Than The Maximum Value': BadRequest,
                                'the account with in 24 hours ban coin': PermissionDenied,
                                'order cancel fail': BadRequest,
                                'base symbol error': BadSymbol,
                                'base date error': ExchangeError1,
                                'api signature not valid': AuthenticationError,
                                'gateway internal error': ExchangeError1,
                                'audit failed': ExchangeError1,
                                'order queryorder invalid': BadRequest,
                                'market no need price': InvalidOrder,
                                'limit need price': InvalidOrder,
                                'userid not equal to account_id': ExchangeError1,
                                'your balance is low': InsufficientFunds,
                                'address invalid cointype': ExchangeError1,
                                'system exception': ExchangeError1,
                                '50003': ExchangeError1,
                                '50004': BadSymbol,
                                '50006': PermissionDenied,
                                '50007': PermissionDenied,
                                '50008': RequestTimeout,
                                '50009': RateLimitExceeded,
                                '50010': ExchangeError1,
                                '50014': InvalidOrder,
                                '50015': InvalidOrder,
                                '50016': InvalidOrder,
                                '50017': InvalidOrder,
                                '50018': InvalidOrder,
                                '50019': InvalidOrder,
                                '50020': InsufficientFunds,
                                '50021': InvalidOrder,
                                '50026': InvalidOrder,
                                'invalid order query time': ExchangeError1,
                                'invalid start time': BadRequest,
                                'invalid end time': BadRequest,
                                '20003': ExchangeError1,
                                '01001': ExchangeError1
                            },
                            'broad': {
                                'invalid size, valid range': ExchangeError1
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'commonCurrencies': {
                            'JADE': 'Jade Protocol'
                        },
                        'options': {
                            'fetchMarkets': [
                                'spot',
                                'swap'
                            ],
                            'defaultType': 'spot',
                            'defaultSubType': 'linear',
                            'broker': {
                                'spot': 'iauIBf#',
                                'swap': 'iauIBf#'
                            }
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicSpotGetPublicTime(params);
                    //
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645837773501,
                    //       data: '1645837773501'
                    //     }
                    //
                    return this.safeInteger(response, 'data');
                }
                async fetchMarkets(params = {}) {
                    const types = this.safeValue(this.options, 'fetchMarkets', [
                        'spot',
                        'swap'
                    ]);
                    let result = [];
                    for(let i = 0; i < types.length; i++){
                        const type = types[i];
                        if (type === 'swap') {
                            const subTypes = [
                                'umcbl',
                                'dmcbl'
                            ];
                            for(let j = 0; j < subTypes.length; j++){
                                const markets = await this.fetchMarketsByType(type, this.extend(params, {
                                    'productType': subTypes[j]
                                }));
                                result = this.arrayConcat(result, markets);
                            }
                        } else {
                            const markets = await this.fetchMarketsByType(types[i], params);
                            result = this.arrayConcat(result, markets);
                        }
                    }
                    return result;
                }
                parseMarkets(markets) {
                    const result = [];
                    for(let i = 0; i < markets.length; i++)result.push(this.parseMarket(markets[i]));
                    return result;
                }
                parseMarket(market) {
                    //
                    // spot
                    //
                    //     {
                    //       symbol: 'ALPHAUSDT_SPBL',
                    //       symbolName: 'ALPHAUSDT',
                    //       baseCoin: 'ALPHA',
                    //       quoteCoin: 'USDT',
                    //       minTradeAmount: '2',
                    //       maxTradeAmount: '0',
                    //       takerFeeRate: '0.001',
                    //       makerFeeRate: '0.001',
                    //       priceScale: '4',
                    //       quantityScale: '4',
                    //       status: 'online'
                    //     }
                    //
                    // swap
                    //
                    //     {
                    //       symbol: 'BTCUSDT_UMCBL',
                    //       makerFeeRate: '0.0002',
                    //       takerFeeRate: '0.0006',
                    //       feeRateUpRatio: '0.005',
                    //       openCostUpRatio: '0.01',
                    //       quoteCoin: 'USDT',
                    //       baseCoin: 'BTC',
                    //       buyLimitPriceRatio: '0.01',
                    //       sellLimitPriceRatio: '0.01',
                    //       supportMarginCoins: [ 'USDT' ],
                    //       minTradeNum: '0.001',
                    //       priceEndStep: '5',
                    //       volumePlace: '3',
                    //       pricePlace: '1'
                    //     }
                    //
                    //
                    const marketId = this.safeString(market, 'symbol');
                    const quoteId = this.safeString(market, 'quoteCoin');
                    const baseId = this.safeString(market, 'baseCoin');
                    const quote = this.safeCurrencyCode(quoteId);
                    const base = this.safeCurrencyCode(baseId);
                    const supportMarginCoins = this.safeValue(market, 'supportMarginCoins', []);
                    const settleId = this.safeString(supportMarginCoins, 0);
                    const settle = this.safeCurrencyCode(settleId);
                    let symbol = base + '/' + quote;
                    const parts = marketId.split('_');
                    const typeId = this.safeString(parts, 1);
                    let type = undefined;
                    let linear = undefined;
                    let inverse = undefined;
                    let swap = false;
                    let spot = false;
                    let contract = false;
                    let pricePrecision = undefined;
                    let amountPrecision = undefined;
                    if (typeId === 'SPBL') {
                        type = 'spot';
                        spot = true;
                        const priceScale = this.safeString(market, 'priceScale');
                        const amountScale = this.safeString(market, 'quantityScale');
                        pricePrecision = this.parseNumber(this.parsePrecision(priceScale));
                        amountPrecision = this.parseNumber(this.parsePrecision(amountScale));
                    } else {
                        type = 'swap';
                        swap = true;
                        contract = true;
                        symbol = symbol + ':' + settle;
                        if (typeId === 'UMCBL') {
                            linear = true;
                            inverse = false;
                        } else if (typeId === 'DMCBL') {
                            inverse = true;
                            linear = false;
                        }
                        const priceDecimals = this.safeInteger(market, 'pricePlace');
                        const amountDecimals = this.safeInteger(market, 'volumePlace');
                        const priceStep = this.safeString(market, 'priceEndStep');
                        const amountStep = this.safeString(market, 'minTradeNum');
                        const precisePrice = new Precise(priceStep);
                        precisePrice.decimals = this.sum(precisePrice.decimals, priceDecimals);
                        precisePrice.reduce();
                        const priceString = precisePrice.toString();
                        pricePrecision = this.parseNumber(priceString);
                        const preciseAmount = new Precise(amountStep);
                        preciseAmount.decimals = this.sum(preciseAmount.decimals, amountDecimals);
                        preciseAmount.reduce();
                        const amountString = preciseAmount.toString();
                        amountPrecision = this.parseNumber(amountString);
                    }
                    const status = this.safeString(market, 'status');
                    let active = undefined;
                    if (status !== undefined) active = status === 'online';
                    const maker = this.safeNumber(market, 'makerFeeRate');
                    const taker = this.safeNumber(market, 'takerFeeRate');
                    const precision = {
                        'price': pricePrecision,
                        'amount': amountPrecision
                    };
                    const limits = {
                        'amount': {
                            'min': this.safeNumber(market, 'minTradeAmount'),
                            'max': undefined
                        },
                        'price': {
                            'min': undefined,
                            'max': undefined
                        },
                        'cost': {
                            'min': undefined,
                            'max': undefined
                        }
                    };
                    return {
                        'info': market,
                        'id': marketId,
                        'symbol': symbol,
                        'quoteId': quoteId,
                        'baseId': baseId,
                        'quote': quote,
                        'base': base,
                        'type': type,
                        'spot': spot,
                        'swap': swap,
                        'future': false,
                        'option': false,
                        'margin': false,
                        'contract': contract,
                        'contractSize': undefined,
                        'linear': linear,
                        'inverse': inverse,
                        'settleId': settleId,
                        'settle': settle,
                        'expiry': undefined,
                        'expiryDatetime': undefined,
                        'optionType': undefined,
                        'strike': undefined,
                        'active': active,
                        'maker': maker,
                        'taker': taker,
                        'precision': precision,
                        'limits': limits
                    };
                }
                async fetchMarketsByType(type, params = {}) {
                    const method = this.getSupportedMapping(type, {
                        'spot': 'publicSpotGetPublicProducts',
                        'swap': 'publicMixGetMarketContracts'
                    });
                    const response = await this[method](params);
                    //
                    // spot
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645840064031,
                    //       data: [
                    //         {
                    //           symbol: 'ALPHAUSDT_SPBL',
                    //           symbolName: 'ALPHAUSDT',
                    //           baseCoin: 'ALPHA',
                    //           quoteCoin: 'USDT',
                    //           minTradeAmount: '2',
                    //           maxTradeAmount: '0',
                    //           takerFeeRate: '0.001',
                    //           makerFeeRate: '0.001',
                    //           priceScale: '4',
                    //           quantityScale: '4',
                    //           status: 'online'
                    //         }
                    //       ]
                    //     }
                    //
                    // swap
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645840821493,
                    //       data: [
                    //         {
                    //           symbol: 'BTCUSDT_UMCBL',
                    //           makerFeeRate: '0.0002',
                    //           takerFeeRate: '0.0006',
                    //           feeRateUpRatio: '0.005',
                    //           openCostUpRatio: '0.01',
                    //           quoteCoin: 'USDT',
                    //           baseCoin: 'BTC',
                    //           buyLimitPriceRatio: '0.01',
                    //           sellLimitPriceRatio: '0.01',
                    //           supportMarginCoins: [Array],
                    //           minTradeNum: '0.001',
                    //           priceEndStep: '5',
                    //           volumePlace: '3',
                    //           pricePlace: '1'
                    //         }
                    //       ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseMarkets(data);
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicSpotGetPublicCurrencies(params);
                    //
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645935668288,
                    //       data: [
                    //         {
                    //           coinId: '230',
                    //           coinName: 'KIN',
                    //           transfer: 'false',
                    //           chains: [
                    //             {
                    //               chain: 'SOL',
                    //               needTag: 'false',
                    //               withdrawable: 'true',
                    //               rechargeable: 'true',
                    //               withdrawFee: '187500',
                    //               depositConfirm: '100',
                    //               withdrawConfirm: '100',
                    //               minDepositAmount: '12500',
                    //               minWithdrawAmount: '250000',
                    //               browserUrl: 'https://explorer.solana.com/tx/'
                    //             }
                    //           ]
                    //         }
                    //       ]
                    //     }
                    //
                    const result = {};
                    const data = this.safeValue(response, 'data', []);
                    for(let i = 0; i < data.length; i++){
                        const entry = data[i];
                        const id = this.safeString(entry, 'coinId');
                        const code = this.safeCurrencyCode(this.safeString(entry, 'coinName'));
                        const chains = this.safeValue(entry, 'chains', []);
                        const networks = {};
                        for(let j = 0; j < chains.length; j++){
                            const chain = chains[j];
                            const networkId = this.safeString(chain, 'chain');
                            const network = this.safeCurrencyCode(networkId);
                            const withdrawEnabled = this.safeString(chain, 'withdrawable');
                            const depositEnabled = this.safeString(chain, 'rechargeable');
                            networks[network] = {
                                'info': chain,
                                'id': networkId,
                                'network': network,
                                'limits': {
                                    'withdraw': {
                                        'min': this.safeNumber(chain, 'minWithdrawAmount'),
                                        'max': undefined
                                    },
                                    'deposit': {
                                        'min': this.safeNumber(chain, 'minDepositAmount'),
                                        'max': undefined
                                    }
                                },
                                'active': undefined,
                                'withdraw': withdrawEnabled === 'true',
                                'deposit': depositEnabled === 'true',
                                'fee': this.safeNumber(chain, 'withdrawFee')
                            };
                        }
                        result[code] = {
                            'info': entry,
                            'id': id,
                            'code': code,
                            'networks': networks,
                            'type': undefined,
                            'name': undefined,
                            'active': undefined,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': undefined,
                            'precision': undefined,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrderBook', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'publicSpotGetMarketDepth',
                        'swap': 'publicMixGetMarketDepth'
                    });
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645854610294,
                    //       data: {
                    //         asks: [ [ '39102', '11.026' ] ],
                    //         bids: [ [ '39100.5', '1.773' ] ],
                    //         timestamp: '1645854610294'
                    //       }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const timestamp = this.safeInteger(data, 'timestamp');
                    return this.parseOrderBook(data, symbol, timestamp);
                }
                parseTicker(ticker, market) {
                    //
                    // spot
                    //     {
                    //       symbol: 'BTCUSDT',
                    //       high24h: '40252.43',
                    //       low24h: '38548.54',
                    //       close: '39102.16',
                    //       quoteVol: '67295596.1458',
                    //       baseVol: '1723.4152',
                    //       usdtVol: '67295596.14578',
                    //       ts: '1645856170030',
                    //       buyOne: '39096.16',
                    //       sellOne: '39103.99'
                    //     }
                    //
                    // swap
                    //     {
                    //       symbol: 'BTCUSDT_UMCBL',
                    //       last: '39086',
                    //       bestAsk: '39087',
                    //       bestBid: '39086',
                    //       high24h: '40312',
                    //       low24h: '38524.5',
                    //       timestamp: '1645856591864',
                    //       priceChangePercent: '-0.00861',
                    //       baseVolume: '142251.757',
                    //       quoteVolume: '5552388715.9215',
                    //       usdtVolume: '5552388715.9215'
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const high = this.safeString(ticker, 'high24h');
                    const low = this.safeString(ticker, 'low24h');
                    const close = this.safeString2(ticker, 'close', 'last');
                    const quoteVolume = this.safeString2(ticker, 'quoteVol', 'quoteVolume');
                    const baseVolume = this.safeString2(ticker, 'baseVol', 'baseVolume');
                    const timestamp = this.safeInteger2(ticker, 'ts', 'timestamp');
                    const datetime = this.iso8601(timestamp);
                    const bid = this.safeString2(ticker, 'buyOne', 'bestBid');
                    const ask = this.safeString2(ticker, 'sellOne', 'bestAsk');
                    const percentage = Precise.stringMul(this.safeString(ticker, 'priceChangePercent'), '100');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'high': high,
                        'low': low,
                        'bid': bid,
                        'bidVolume': undefined,
                        'ask': ask,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': close,
                        'last': undefined,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTicker', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'publicSpotGetMarketTicker',
                        'swap': 'publicMixGetMarketTicker'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: '1645856138576',
                    //       data: {
                    //         symbol: 'BTCUSDT',
                    //         high24h: '40252.43',
                    //         low24h: '38548.54',
                    //         close: '39104.65',
                    //         quoteVol: '67221762.2184',
                    //         baseVol: '1721.527',
                    //         usdtVol: '67221762.218361',
                    //         ts: '1645856138031',
                    //         buyOne: '39102.55',
                    //         sellOne: '39110.56'
                    //       }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseTicker(data, market);
                }
                async fetchTickers(symbols, params = {}) {
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTickers', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'publicSpotGetMarketTickers',
                        'swap': 'publicMixGetMarketTickers'
                    });
                    const request = {};
                    if (method === 'publicMixGetMarketTickers') {
                        const defaultSubType = this.safeString(this.options, 'defaultSubType');
                        request['productType'] = defaultSubType === 'linear' ? 'UMCBL' : 'DMCBL';
                    }
                    const response = await this[method](this.extend(request, query));
                    const data = this.safeValue(response, 'data');
                    return this.parseTickers(data, symbols);
                }
                parseTrade(trade, market) {
                    //
                    // spot
                    //     {
                    //       symbol: 'BTCUSDT_SPBL',
                    //       tradeId: '881371996363608065',
                    //       side: 'sell',
                    //       fillPrice: '39123.05',
                    //       fillQuantity: '0.0363',
                    //       fillTime: '1645861379709'
                    //     }
                    //
                    // swap
                    //     {
                    //       tradeId: '881373204067311617',
                    //       price: '39119.0',
                    //       size: '0.001',
                    //       side: 'buy',
                    //       timestamp: '1645861667648',
                    //       symbol: 'BTCUSDT_UMCBL'
                    //     }
                    //
                    // private
                    //     {
                    //       accountId: '6394957606',
                    //       symbol: 'LTCUSDT_SPBL',
                    //       orderId: '864752115272552448',
                    //       fillId: '864752115685969921',
                    //       orderType: 'limit',
                    //       side: 'buy',
                    //       fillPrice: '127.92000000',
                    //       fillQuantity: '0.10000000',
                    //       fillTotalAmount: '12.79200000',
                    //       feeCcy: 'LTC',
                    //       fees: '0.00000000',
                    //       cTime: '1641898891373'
                    //     }
                    //
                    //     {
                    //       tradeId: '881640729552281602',
                    //       symbol: 'BTCUSDT_UMCBL',
                    //       orderId: '881640729145409536',
                    //       price: '38429.50',
                    //       sizeQty: '0.001',
                    //       fee: '0',
                    //       side: 'open_long',
                    //       fillAmount: '38.4295',
                    //       profit: '0',
                    //       cTime: '1645925450694'
                    //     }
                    //
                    const marketId = this.safeString(trade, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const id = this.safeString2(trade, 'tradeId', 'fillId');
                    const order = this.safeString(trade, 'orderId');
                    const side = this.safeString(trade, 'side');
                    const price = this.safeString2(trade, 'fillPrice', 'price');
                    let amount = this.safeString2(trade, 'fillQuantity', 'size');
                    amount = this.safeString(trade, 'sizeQty', amount);
                    let timestamp = this.safeInteger2(trade, 'fillTime', 'timestamp');
                    timestamp = this.safeInteger(trade, 'cTime', timestamp);
                    let fee = undefined;
                    const feeAmount = this.safeString(trade, 'fees');
                    const type = this.safeString(trade, 'orderType');
                    if (feeAmount !== undefined) fee = {
                        'code': this.safeCurrencyCode(this.safeString(trade, 'feeCcy')),
                        'cost': feeAmount
                    };
                    const datetime = this.iso8601(timestamp);
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': order,
                        'symbol': symbol,
                        'side': side,
                        'type': type,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': fee,
                        'timestamp': timestamp,
                        'datetime': datetime
                    }, market);
                }
                async fetchTrades(symbol, limit, since, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTrades', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'publicSpotGetMarketFills',
                        'swap': 'publicMixGetMarketFills'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: '1645861382032',
                    //       data: [
                    //         {
                    //           symbol: 'BTCUSDT_SPBL',
                    //           tradeId: '881371996363608065',
                    //           side: 'sell',
                    //           fillPrice: '39123.05',
                    //           fillQuantity: '0.0363',
                    //           fillTime: '1645861379709'
                    //         }
                    //       ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicSpotGetPublicProduct(this.extend(request, params));
                    //
                    //     {
                    //         code: '00000',
                    //         msg: 'success',
                    //         requestTime: '1646255374000',
                    //         data: {
                    //           symbol: 'ethusdt_SPBL',
                    //           symbolName: null,
                    //           baseCoin: 'ETH',
                    //           quoteCoin: 'USDT',
                    //           minTradeAmount: '0',
                    //           maxTradeAmount: '0',
                    //           takerFeeRate: '0.002',
                    //           makerFeeRate: '0.002',
                    //           priceScale: '2',
                    //           quantityScale: '4',
                    //           status: 'online'
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTradingFee(data, market);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicSpotGetPublicProducts(params);
                    //
                    //     {
                    //         code: '00000',
                    //         msg: 'success',
                    //         requestTime: '1646255662391',
                    //         data: [
                    //           {
                    //             symbol: 'ALPHAUSDT_SPBL',
                    //             symbolName: 'ALPHAUSDT',
                    //             baseCoin: 'ALPHA',
                    //             quoteCoin: 'USDT',
                    //             minTradeAmount: '2',
                    //             maxTradeAmount: '0',
                    //             takerFeeRate: '0.001',
                    //             makerFeeRate: '0.001',
                    //             priceScale: '4',
                    //             quantityScale: '4',
                    //             status: 'online'
                    //           },
                    //           ...
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = {};
                    for(let i = 0; i < data.length; i++){
                        const feeInfo = data[i];
                        const fee = this.parseTradingFee(feeInfo);
                        const symbol = fee['symbol'];
                        result[symbol] = fee;
                    }
                    return result;
                }
                parseTradingFee(data, market) {
                    const marketId = this.safeString(data, 'symbol');
                    return {
                        'info': data,
                        'symbol': this.safeSymbol(marketId, market),
                        'maker': this.safeNumber(data, 'makerFeeRate'),
                        'taker': this.safeNumber(data, 'takerFeeRate')
                    };
                }
                parseOHLCV(ohlcv, market, timeframe = '1m') {
                    //
                    // spot
                    //
                    //     {
                    //         open: '57882.31',
                    //         high: '58967.24',
                    //         low: '57509.56',
                    //         close: '57598.96',
                    //         quoteVol: '439160536.605821',
                    //         baseVol: '7531.2927',
                    //         usdtVol: '439160536.605821',
                    //         ts: '1637337600000'
                    //     }
                    //
                    // swap
                    //
                    //     [
                    //         "1645911960000",
                    //         "39406",
                    //         "39407",
                    //         "39374.5",
                    //         "39379",
                    //         "35.526",
                    //         "1399132.341"
                    //     ]
                    //
                    return [
                        this.safeInteger2(ohlcv, 0, 'ts'),
                        this.safeNumber2(ohlcv, 1, 'open'),
                        this.safeNumber2(ohlcv, 2, 'high'),
                        this.safeNumber2(ohlcv, 3, 'low'),
                        this.safeNumber2(ohlcv, 4, 'close'),
                        this.safeNumber2(ohlcv, 5, 'baseVol')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOHLCV', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'publicSpotGetMarketCandles',
                        'swap': 'publicMixGetMarketCandles'
                    });
                    if (market['type'] === 'spot') {
                        request['period'] = this.timeframes['spot'][timeframe];
                        if (limit !== undefined) request['limit'] = limit;
                        if (since !== undefined) request['after'] = since;
                    } else if (market['type'] === 'swap') {
                        request['granularity'] = this.timeframes['swap'][timeframe];
                        const duration = this.parseTimeframe(timeframe);
                        const now = this.milliseconds();
                        if (limit === undefined) limit = 100;
                        if (since === undefined) {
                            request['startTime'] = now - (limit - 1) * (duration * 1000);
                            request['endTime'] = now;
                        } else {
                            request['startTime'] = this.sum(since, duration * 1000);
                            request['endTime'] = this.sum(since, limit * duration * 1000);
                        }
                    }
                    const response = await this[method](this.extend(request, query));
                    //  [ ["1645911960000","39406","39407","39374.5","39379","35.526","1399132.341"] ]
                    const data = this.safeValue(response, 'data', response);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchBalance', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateSpotGetAccountAssets',
                        'swap': 'privateMixGetAccountAccounts'
                    });
                    const request = {};
                    if (marketType === 'swap') {
                        const defaultSubType = this.safeString(this.options, 'defaultSubType');
                        request['productType'] = defaultSubType === 'linear' ? 'UMCBL' : 'DMCBL';
                    }
                    const response = await this[method](this.extend(request, query));
                    // spot
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645928868827,
                    //       data: [
                    //         {
                    //           coinId: 1,
                    //           coinName: 'BTC',
                    //           available: '0.00070000',
                    //           frozen: '0.00000000',
                    //           lock: '0.00000000',
                    //           uTime: '1645921706000'
                    //         }
                    //       ]
                    //     }
                    //
                    // swap
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645928929251,
                    //       data: [
                    //         {
                    //           marginCoin: 'USDT',
                    //           locked: '0',
                    //           available: '8.078525',
                    //           crossMaxAvailable: '8.078525',
                    //           fixedMaxAvailable: '8.078525',
                    //           maxTransferOut: '8.078525',
                    //           equity: '10.02508',
                    //           usdtEquity: '10.02508',
                    //           btcEquity: '0.00026057027'
                    //         }
                    //       ]
                    //     }
                    const data = this.safeValue(response, 'data');
                    return this.parseBalance(data);
                }
                parseBalance(balance) {
                    const result = {
                        'info': balance
                    };
                    for(let i = 0; i < balance.length; i++){
                        const entry = balance[i];
                        const currencyId = this.safeString2(entry, 'coinId', 'marginCoin');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['used'] = this.safeString2(entry, 'lock', 'locked');
                        account['free'] = this.safeString(entry, 'available');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'new': 'open',
                        'full_fill': 'closed',
                        'filled': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // spot
                    //     {
                    //       accountId: '6394957606',
                    //       symbol: 'BTCUSDT_SPBL',
                    //       orderId: '881623995442958336',
                    //       clientOrderId: '135335e9-b054-4e43-b00a-499f11d3a5cc',
                    //       price: '39000.000000000000',
                    //       quantity: '0.000700000000',
                    //       orderType: 'limit',
                    //       side: 'buy',
                    //       status: 'new',
                    //       fillPrice: '0.000000000000',
                    //       fillQuantity: '0.000000000000',
                    //       fillTotalAmount: '0.000000000000',
                    //       cTime: '1645921460972'
                    //     }
                    //
                    // swap
                    //     {
                    //       symbol: 'BTCUSDT_UMCBL',
                    //       size: 0.001,
                    //       orderId: '881640729145409536',
                    //       clientOid: '881640729204129792',
                    //       filledQty: 0.001,
                    //       fee: 0,
                    //       price: null,
                    //       priceAvg: 38429.5,
                    //       state: 'filled',
                    //       side: 'open_long',
                    //       timeInForce: 'normal',
                    //       totalProfits: 0,
                    //       posSide: 'long',
                    //       marginCoin: 'USDT',
                    //       filledAmount: 38.4295,
                    //       orderType: 'market',
                    //       cTime: '1645925450611',
                    //       uTime: '1645925450746'
                    //     }
                    //
                    const marketId = this.safeString(order, 'symbol');
                    market = this.safeMarket(marketId);
                    const symbol = market['symbol'];
                    const id = this.safeString(order, 'orderId');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString2(order, 'quantity', 'size');
                    const filled = this.safeString2(order, 'fillQuantity', 'filledQty');
                    const cost = this.safeString2(order, 'fillTotalAmount', 'filledAmount');
                    const average = this.safeString(order, 'fillPrice');
                    const type = this.safeString(order, 'orderType');
                    const timestamp = this.safeInteger(order, 'cTime');
                    let side = this.safeString2(order, 'side', 'posSide');
                    if (side === 'open_long' || side === 'close_short') side = 'buy';
                    else side = 'sell';
                    const clientOrderId = this.safeString2(order, 'clientOrderId', 'clientOid');
                    const fee = undefined;
                    const rawStatus = this.safeString2(order, 'status', 'state');
                    const status = this.parseOrderStatus(rawStatus);
                    const lastTradeTimestamp = this.safeInteger(order, 'uTime');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'average': average,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('createOrder', market, params);
                    const request = {
                        'symbol': market['id'],
                        'orderType': type
                    };
                    if (type === 'limit') request['price'] = price;
                    let clientOrderId = this.safeString2(params, 'client_oid', 'clientOrderId');
                    if (clientOrderId === undefined) {
                        const broker = this.safeValue(this.options, 'broker');
                        if (broker !== undefined) {
                            const brokerId = this.safeString(broker, market['type']);
                            if (brokerId !== undefined) clientOrderId = brokerId + this.uuid22();
                        }
                    }
                    if (marketType === 'spot') {
                        request['clientOrderId'] = clientOrderId;
                        request['quantity'] = this.amountToPrecision(symbol, amount);
                        request['side'] = side;
                        request['force'] = 'gtc';
                    } else {
                        request['clientOid'] = clientOrderId;
                        request['size'] = this.amountToPrecision(symbol, amount);
                        const reduceOnly = this.safeValue(params, 'reduceOnly', false);
                        if (reduceOnly) request['side'] = side === 'buy' ? 'close_short' : 'close_long';
                        else request['side'] = side === 'buy' ? 'open_long' : 'open_short';
                        request['marginCoin'] = market['settleId'];
                    }
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateSpotPostTradeOrders',
                        'swap': 'privateMixPostOrderPlaceOrder'
                    });
                    const response = await this[method](this.extend(request, query));
                    // spot
                    // {"code":"00000","msg":"success","requestTime":1645932209602,"data":{"orderId":"881669078313766912","clientOrderId":"iauIBf#a45b595f96474d888d0ada"}}
                    // swap
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument for spot orders');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('cancelOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateSpotPostTradeCancelOrder',
                        'swap': 'privateMixPostOrderCancelOrder'
                    });
                    const request = {
                        'symbol': market['id'],
                        'orderId': id
                    };
                    if (marketType === 'swap') request['marginCoin'] = market['settleId'];
                    const response = await this[method](this.extend(request, query));
                    return this.parseOrder(response, market);
                }
                async cancelOrders(ids, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const type = this.safeString(params, 'type', market['type']);
                    if (type === undefined) throw new ArgumentsRequired1(this.id + " cancelOrders() requires a type parameter (one of 'spot', 'swap').");
                    params = this.omit(params, 'type');
                    const request = {};
                    let method = undefined;
                    if (type === 'spot') {
                        method = 'apiPostOrderOrdersBatchcancel';
                        request['method'] = 'batchcancel';
                        const jsonIds = this.json(ids);
                        const parts = jsonIds.split('"');
                        request['order_ids'] = parts.join('');
                    } else if (type === 'swap') {
                        method = 'swapPostOrderCancelBatchOrders';
                        request['symbol'] = market['id'];
                        request['ids'] = ids;
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     spot
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": {
                    //             "success": [
                    //                 "673451224205135872",
                    //             ],
                    //             "failed": [
                    //                 {
                    //                 "err-msg": "invalid record",
                    //                 "order-id": "673451224205135873",
                    //                 "err-code": "base record invalid"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    //     swap
                    //
                    //     {
                    //         "result":true,
                    //         "symbol":"cmt_btcusdt",
                    //         "order_ids":[
                    //             "258414711",
                    //             "478585558"
                    //         ],
                    //         "fail_infos":[
                    //             {
                    //                 "order_id":"258414711",
                    //                 "err_code":"401",
                    //                 "err_msg":""
                    //             }
                    //         ]
                    //     }
                    //
                    return response;
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateSpotPostTradeOrderInfo',
                        'swap': 'privateMixGetOrderDetail'
                    });
                    const request = {
                        'symbol': market['id'],
                        'orderId': id
                    };
                    const response = await this[method](this.extend(request, query));
                    // spot
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: '1645926849436',
                    //       data: [
                    //         {
                    //           accountId: '6394957606',
                    //           symbol: 'BTCUSDT_SPBL',
                    //           orderId: '881626139738935296',
                    //           clientOrderId: '525890c8-767e-4cd6-8585-38160ed7bb5e',
                    //           price: '38000.000000000000',
                    //           quantity: '0.000700000000',
                    //           orderType: 'limit',
                    //           side: 'buy',
                    //           status: 'new',
                    //           fillPrice: '0.000000000000',
                    //           fillQuantity: '0.000000000000',
                    //           fillTotalAmount: '0.000000000000',
                    //           cTime: '1645921972212'
                    //         }
                    //       ]
                    //     }
                    //
                    // swap
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: '1645926587877',
                    //       data: {
                    //         symbol: 'BTCUSDT_UMCBL',
                    //         size: '0.001',
                    //         orderId: '881640729145409536',
                    //         clientOid: '881640729204129792',
                    //         filledQty: '0.001',
                    //         fee: '0E-8',
                    //         price: null,
                    //         priceAvg: '38429.50',
                    //         state: 'filled',
                    //         side: 'open_long',
                    //         timeInForce: 'normal',
                    //         totalProfits: '0E-8',
                    //         posSide: 'long',
                    //         marginCoin: 'USDT',
                    //         filledAmount: '38.4295',
                    //         orderType: 'market',
                    //         cTime: '1645925450611',
                    //         uTime: '1645925450746'
                    //       }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const first = this.safeValue(data, 0, data);
                    return this.parseOrder(first, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOpenOrders', market, params);
                    const request = {
                        'symbol': market['id']
                    };
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateSpotPostTradeOpenOrders',
                        'swap': 'privateMixGetOrderCurrent'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    //  spot
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645921640193,
                    //       data: [
                    //         {
                    //           accountId: '6394957606',
                    //           symbol: 'BTCUSDT_SPBL',
                    //           orderId: '881623995442958336',
                    //           clientOrderId: '135335e9-b054-4e43-b00a-499f11d3a5cc',
                    //           price: '39000.000000000000',
                    //           quantity: '0.000700000000',
                    //           orderType: 'limit',
                    //           side: 'buy',
                    //           status: 'new',
                    //           fillPrice: '0.000000000000',
                    //           fillQuantity: '0.000000000000',
                    //           fillTotalAmount: '0.000000000000',
                    //           cTime: '1645921460972'
                    //         }
                    //       ]
                    //     }
                    //
                    // swap
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645922324630,
                    //       data: [
                    //         {
                    //           symbol: 'BTCUSDT_UMCBL',
                    //           size: 0.001,
                    //           orderId: '881627074081226752',
                    //           clientOid: '881627074160918528',
                    //           filledQty: 0,
                    //           fee: 0,
                    //           price: 38000,
                    //           state: 'new',
                    //           side: 'open_long',
                    //           timeInForce: 'normal',
                    //           totalProfits: 0,
                    //           posSide: 'long',
                    //           marginCoin: 'USDT',
                    //           filledAmount: 0,
                    //           orderType: 'limit',
                    //           cTime: '1645922194995',
                    //           uTime: '1645922194995'
                    //         }
                    //       ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchClosedOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchClosedOrders', market, params);
                    const request = {
                        'symbol': market['id']
                    };
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateSpotPostTradeHistory',
                        'swap': 'privateMixGetOrderHistory'
                    });
                    if (marketType === 'swap') {
                        if (limit === undefined) limit = 100;
                        request['pageSize'] = limit;
                        if (since === undefined) since = 0;
                        request['startTime'] = since;
                        request['endTime'] = this.milliseconds();
                    }
                    const response = await this[method](this.extend(request, query));
                    //
                    //  spot
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645925335553,
                    //       data: [
                    //         {
                    //           accountId: '6394957606',
                    //           symbol: 'BTCUSDT_SPBL',
                    //           orderId: '881623995442958336',
                    //           clientOrderId: '135335e9-b054-4e43-b00a-499f11d3a5cc',
                    //           price: '39000.000000000000',
                    //           quantity: '0.000700000000',
                    //           orderType: 'limit',
                    //           side: 'buy',
                    //           status: 'full_fill',
                    //           fillPrice: '39000.000000000000',
                    //           fillQuantity: '0.000700000000',
                    //           fillTotalAmount: '27.300000000000',
                    //           cTime: '1645921460972'
                    //         }
                    //       ]
                    //     }
                    //
                    // swap
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645925688701,
                    //       data: {
                    //         nextFlag: false,
                    //         endId: '881640729145409536',
                    //         orderList: [
                    //           {
                    //             symbol: 'BTCUSDT_UMCBL',
                    //             size: 0.001,
                    //             orderId: '881640729145409536',
                    //             clientOid: '881640729204129792',
                    //             filledQty: 0.001,
                    //             fee: 0,
                    //             price: null,
                    //             priceAvg: 38429.5,
                    //             state: 'filled',
                    //             side: 'open_long',
                    //             timeInForce: 'normal',
                    //             totalProfits: 0,
                    //             posSide: 'long',
                    //             marginCoin: 'USDT',
                    //             filledAmount: 38.4295,
                    //             orderType: 'market',
                    //             cTime: '1645925450611',
                    //             uTime: '1645925450746'
                    //           }
                    //         ]
                    //       }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const orderList = this.safeValue(data, 'orderList', data);
                    return this.parseOrders(orderList, market, since, limit);
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['coinId'] = currency['id'];
                    }
                    const response = await this.privateSpotPostAccountBills(this.extend(request, params));
                    //
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: '1645929886887',
                    //       data: [
                    //         {
                    //           billId: '881626974170554368',
                    //           coinId: '2',
                    //           coinName: 'USDT',
                    //           groupType: 'transfer',
                    //           bizType: 'transfer-out',
                    //           quantity: '-10.00000000',
                    //           balance: '73.36005300',
                    //           fees: '0.00000000',
                    //           cTime: '1645922171146'
                    //         }
                    //       ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseLedger(data, currency, since, limit);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     {
                    //       billId: '881626974170554368',
                    //       coinId: '2',
                    //       coinName: 'USDT',
                    //       groupType: 'transfer',
                    //       bizType: 'transfer-out',
                    //       quantity: '-10.00000000',
                    //       balance: '73.36005300',
                    //       fees: '0.00000000',
                    //       cTime: '1645922171146'
                    //     }
                    //
                    const id = this.safeString(item, 'billId');
                    const currencyId = this.safeString(item, 'coinId');
                    const code = this.safeCurrencyCode(currencyId);
                    const amount = this.parseNumber(Precise.stringAbs(this.safeString(item, 'quantity')));
                    const timestamp = this.safeInteger(item, 'cTime');
                    const bizType = this.safeString(item, 'bizType');
                    let direction = undefined;
                    if (bizType !== undefined) {
                        const parts = bizType.split('-');
                        direction = parts[1];
                    }
                    const type = this.safeString(item, 'groupType');
                    const fee = this.safeNumber(item, 'fees');
                    const after = this.safeNumber(item, 'balance');
                    return {
                        'info': item,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'direction': direction,
                        'account': undefined,
                        'referenceId': undefined,
                        'referenceAccount': undefined,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'before': undefined,
                        'after': after,
                        'status': undefined,
                        'fee': fee
                    };
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (market['swap']) throw new BadSymbol(this.id + ' fetchMyTrades() only supports spot markets');
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateSpotPostTradeFills(this.extend(request, params));
                    //
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: '1645918954082',
                    //       data: [
                    //         {
                    //           accountId: '6394957606',
                    //           symbol: 'LTCUSDT_SPBL',
                    //           orderId: '864752115272552448',
                    //           fillId: '864752115685969921',
                    //           orderType: 'limit',
                    //           side: 'buy',
                    //           fillPrice: '127.92000000',
                    //           fillQuantity: '0.10000000',
                    //           fillTotalAmount: '12.79200000',
                    //           feeCcy: 'LTC',
                    //           fees: '0.00000000',
                    //           cTime: '1641898891373'
                    //         }
                    //       ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrderTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrderTrades', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateSpotPostTradeFills',
                        'swap': 'privateMixGetOrderFills'
                    });
                    const request = {
                        'symbol': market['id'],
                        'orderId': id
                    };
                    const response = await this[method](this.extend(request, query));
                    // spot
                    //
                    // swap
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: 1645927862710,
                    //       data: [
                    //         {
                    //           tradeId: '881640729552281602',
                    //           symbol: 'BTCUSDT_UMCBL',
                    //           orderId: '881640729145409536',
                    //           price: '38429.50',
                    //           sizeQty: '0.001',
                    //           fee: '0',
                    //           side: 'open_long',
                    //           fillAmount: '38.4295',
                    //           profit: '0',
                    //           cTime: '1645925450694'
                    //         }
                    //       ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return await this.parseTrades(data, market, since, limit);
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'marginCoin': market['settleId']
                    };
                    const response = await this.privateMixGetPositionSinglePosition(this.extend(request, params));
                    //
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: '1645933957584',
                    //       data: [
                    //         {
                    //           marginCoin: 'USDT',
                    //           symbol: 'BTCUSDT_UMCBL',
                    //           holdSide: 'long',
                    //           openDelegateCount: '0',
                    //           margin: '1.921475',
                    //           available: '0.001',
                    //           locked: '0',
                    //           total: '0.001',
                    //           leverage: '20',
                    //           achievedProfits: '0',
                    //           averageOpenPrice: '38429.5',
                    //           marginMode: 'fixed',
                    //           holdMode: 'double_hold',
                    //           unrealizedPL: '0.1634',
                    //           liquidationPrice: '0',
                    //           keepMarginRate: '0.004',
                    //           cTime: '1645922194988'
                    //         }
                    //       ]
                    //     }
                    //
                    return response;
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const defaultSubType = this.safeString(this.options, 'defaultSubType');
                    const request = {
                        'productType': defaultSubType === 'linear' ? 'UMCBL' : 'DMCBL'
                    };
                    const response = await this.privateMixGetPositionAllPosition(this.extend(request, params));
                    //
                    //     {
                    //       code: '00000',
                    //       msg: 'success',
                    //       requestTime: '1645933905060',
                    //       data: [
                    //         {
                    //           marginCoin: 'USDT',
                    //           symbol: 'BTCUSDT_UMCBL',
                    //           holdSide: 'long',
                    //           openDelegateCount: '0',
                    //           margin: '1.921475',
                    //           available: '0.001',
                    //           locked: '0',
                    //           total: '0.001',
                    //           leverage: '20',
                    //           achievedProfits: '0',
                    //           averageOpenPrice: '38429.5',
                    //           marginMode: 'fixed',
                    //           holdMode: 'double_hold',
                    //           unrealizedPL: '0.14869',
                    //           liquidationPrice: '0',
                    //           keepMarginRate: '0.004',
                    //           cTime: '1645922194988'
                    //         }
                    //       ]
                    //     }
                    return response;
                }
                sign(path, api = [], method = 'GET', params = {}, headers, body) {
                    const signed = api[0] === 'private';
                    const endpoint = api[1];
                    const pathPart = endpoint === 'spot' ? '/api/spot/v1' : '/api/mix/v1';
                    const request = '/' + this.implodeParams(path, params);
                    const payload = pathPart + request;
                    let url = this.implodeHostname(this.urls['api'][endpoint]) + payload;
                    const query = this.omit(params, this.extractParams(path));
                    if (!signed && method === 'GET') {
                        const keys = Object.keys(query);
                        if (keys.length) url = url + '?' + this.urlencode(query);
                    }
                    if (signed) {
                        this.checkRequiredCredentials();
                        const timestamp = this.milliseconds().toString();
                        let auth = timestamp + method + payload;
                        if (method === 'POST') {
                            body = this.json(params);
                            auth += body;
                        } else if (Object.keys(params).length) {
                            const query = '?' + this.urlencode(this.keysort(params));
                            url += query;
                            auth += query;
                        }
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha256', 'base64');
                        headers = {
                            'ACCESS-KEY': this.apiKey,
                            'ACCESS-SIGN': signature,
                            'ACCESS-TIMESTAMP': timestamp,
                            'ACCESS-PASSPHRASE': this.password
                        };
                        if (method === 'POST') headers['Content-Type'] = 'application/json';
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                async setLeverage(leverage, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    const holdSide = this.safeString(params, 'holdSide');
                    if (holdSide === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a holdSide param');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'marginCoin': market['settleId'],
                        'leverage': leverage,
                        'holdSide': holdSide
                    };
                    return await this.privateMixPostAccountSetLeverage(this.extend(request, params));
                }
                async setMarginMode(marginMode, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setMarginMode() requires a symbol argument');
                    marginMode = marginMode.toLowerCase();
                    if (marginMode !== 'fixed' && marginMode !== 'crossed') throw new ArgumentsRequired1(this.id + ' setMarginMode() marginMode must be "fixed" or "crossed"');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'marginCoin': market['settleId'],
                        'marginMode': marginMode
                    };
                    return await this.privateMixPostAccountSetMarginMode(this.extend(request, params));
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (!response) return; // fallback to default error handler
                    //
                    // spot
                    //
                    //     {"status":"fail","err_code":"01001","err_msg":"系统异常，请稍后重试"}
                    //     {"status":"error","ts":1595594160149,"err_code":"invalid-parameter","err_msg":"invalid size, valid range: [1,2000]"}
                    //     {"status":"error","ts":1595684716042,"err_code":"invalid-parameter","err_msg":"illegal sign invalid"}
                    //     {"status":"error","ts":1595700216275,"err_code":"bad-request","err_msg":"your balance is low!"}
                    //     {"status":"error","ts":1595700344504,"err_code":"invalid-parameter","err_msg":"invalid type"}
                    //     {"status":"error","ts":1595703343035,"err_code":"bad-request","err_msg":"order cancel fail"}
                    //     {"status":"error","ts":1595704360508,"err_code":"invalid-parameter","err_msg":"accesskey not null"}
                    //     {"status":"error","ts":1595704490084,"err_code":"invalid-parameter","err_msg":"permissions not right"}
                    //     {"status":"error","ts":1595711862763,"err_code":"system exception","err_msg":"system exception"}
                    //     {"status":"error","ts":1595730308979,"err_code":"bad-request","err_msg":"20003"}
                    //
                    // swap
                    //
                    //     {"code":"40015","msg":"","requestTime":1595698564931,"data":null}
                    //     {"code":"40017","msg":"Order id must not be blank","requestTime":1595702477835,"data":null}
                    //     {"code":"40017","msg":"Order Type must not be blank","requestTime":1595698516162,"data":null}
                    //     {"code":"40301","msg":"","requestTime":1595667662503,"data":null}
                    //     {"code":"40017","msg":"Contract code must not be blank","requestTime":1595703151651,"data":null}
                    //     {"code":"40108","msg":"","requestTime":1595885064600,"data":null}
                    //     {"order_id":"513468410013679613","client_oid":null,"symbol":"ethusd","result":false,"err_code":"order_no_exist_error","err_msg":"订单不存在！"}
                    //
                    const message = this.safeString(response, 'err_msg');
                    const errorCode = this.safeString2(response, 'code', 'err_code');
                    const feedback = this.id + ' ' + body;
                    const nonEmptyMessage = message !== undefined && message !== '';
                    if (nonEmptyMessage) {
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                    }
                    const nonZeroErrorCode = errorCode !== undefined && errorCode !== '00000';
                    if (nonZeroErrorCode) this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                    if (nonZeroErrorCode || nonEmptyMessage) throw new ExchangeError1(feedback); // unknown message
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    37: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, AuthenticationError: AuthenticationError, BadRequest: BadRequest, PermissionDenied: PermissionDenied, InvalidAddress: InvalidAddress, ArgumentsRequired: ArgumentsRequired1, InvalidOrder: InvalidOrder } = require1('./base/errors');
            const { DECIMAL_PLACES: DECIMAL_PLACES, SIGNIFICANT_DIGITS: SIGNIFICANT_DIGITS, TRUNCATE: TRUNCATE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bithumb extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bithumb',
                        'name': 'Bithumb',
                        'countries': [
                            'KR'
                        ],
                        'rateLimit': 500,
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createMarketOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'hostname': 'bithumb.com',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/30597177-ea800172-9d5e-11e7-804c-b9d4fa9b56b0.jpg',
                            'api': {
                                'public': 'https://api.{hostname}/public',
                                'private': 'https://api.{hostname}'
                            },
                            'www': 'https://www.bithumb.com',
                            'doc': 'https://apidocs.bithumb.com',
                            'fees': 'https://en.bithumb.com/customer_support/info_fee'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'ticker/{currency}',
                                    'ticker/all',
                                    'ticker/ALL_BTC',
                                    'ticker/ALL_KRW',
                                    'orderbook/{currency}',
                                    'orderbook/all',
                                    'transaction_history/{currency}',
                                    'transaction_history/all',
                                    'candlestick/{currency}/{interval}'
                                ]
                            },
                            'private': {
                                'post': [
                                    'info/account',
                                    'info/balance',
                                    'info/wallet_address',
                                    'info/ticker',
                                    'info/orders',
                                    'info/user_transactions',
                                    'info/order_detail',
                                    'trade/place',
                                    'trade/cancel',
                                    'trade/btc_withdrawal',
                                    'trade/krw_deposit',
                                    'trade/krw_withdrawal',
                                    'trade/market_buy',
                                    'trade/market_sell'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.0025'),
                                'taker': this.parseNumber('0.0025')
                            }
                        },
                        'precisionMode': SIGNIFICANT_DIGITS,
                        'exceptions': {
                            'Bad Request(SSL)': BadRequest,
                            'Bad Request(Bad Method)': BadRequest,
                            'Bad Request.(Auth Data)': AuthenticationError,
                            'Not Member': AuthenticationError,
                            'Invalid Apikey': AuthenticationError,
                            'Method Not Allowed.(Access IP)': PermissionDenied,
                            'Method Not Allowed.(BTC Adress)': InvalidAddress,
                            'Method Not Allowed.(Access)': PermissionDenied,
                            'Database Fail': ExchangeNotAvailable,
                            'Invalid Parameter': BadRequest,
                            '5600': ExchangeError1,
                            'Unknown Error': ExchangeError1,
                            'After May 23th, recent_transactions is no longer, hence users will not be able to connect to recent_transactions': ExchangeError1
                        },
                        'timeframes': {
                            '1m': '1m',
                            '3m': '3m',
                            '5m': '5m',
                            '10m': '10m',
                            '30m': '30m',
                            '1h': '1h',
                            '6h': '6h',
                            '12h': '12h',
                            '1d': '24h'
                        },
                        'options': {
                            'quoteCurrencies': {
                                'BTC': {
                                    'limits': {
                                        'cost': {
                                            'min': 0.0002,
                                            'max': 100
                                        }
                                    }
                                },
                                'KRW': {
                                    'limits': {
                                        'cost': {
                                            'min': 500,
                                            'max': 5000000000
                                        }
                                    }
                                }
                            }
                        },
                        'commonCurrencies': {
                            'FTC': 'FTC2',
                            'MIR': 'MIR COIN',
                            'SOC': 'Soda Coin'
                        }
                    });
                }
                amountToPrecision(symbol, amount) {
                    return this.decimalToPrecision(amount, TRUNCATE, this.markets[symbol]['precision']['amount'], DECIMAL_PLACES);
                }
                async fetchMarkets(params = {}) {
                    const result = [];
                    const quoteCurrencies = this.safeValue(this.options, 'quoteCurrencies', {});
                    const quotes = Object.keys(quoteCurrencies);
                    for(let i = 0; i < quotes.length; i++){
                        const quote = quotes[i];
                        const quoteId = quote;
                        const extension = this.safeValue(quoteCurrencies, quote, {});
                        const method = 'publicGetTickerALL' + quote;
                        const response = await this[method](params);
                        const data = this.safeValue(response, 'data');
                        const currencyIds = Object.keys(data);
                        for(let j = 0; j < currencyIds.length; j++){
                            const currencyId = currencyIds[j];
                            if (currencyId === 'date') continue;
                            const market = data[currencyId];
                            const base = this.safeCurrencyCode(currencyId);
                            let active = true;
                            if (Array.isArray(market)) {
                                const numElements = market.length;
                                if (numElements === 0) active = false;
                            }
                            const entry = this.deepExtend({
                                'id': currencyId,
                                'symbol': base + '/' + quote,
                                'base': base,
                                'quote': quote,
                                'settle': undefined,
                                'baseId': currencyId,
                                'quoteId': quoteId,
                                'settleId': undefined,
                                'type': 'spot',
                                'spot': true,
                                'margin': false,
                                'swap': false,
                                'future': false,
                                'option': false,
                                'active': active,
                                'contract': false,
                                'linear': undefined,
                                'inverse': undefined,
                                'contractSize': undefined,
                                'expiry': undefined,
                                'expiryDateTime': undefined,
                                'strike': undefined,
                                'optionType': undefined,
                                'precision': {
                                    'amount': parseInt('4'),
                                    'price': parseInt('4')
                                },
                                'limits': {
                                    'leverage': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'amount': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'price': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'cost': {}
                                },
                                'info': market
                            }, extension);
                            result.push(entry);
                        }
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const balances = this.safeValue(response, 'data');
                    const codes = Object.keys(this.currencies);
                    for(let i = 0; i < codes.length; i++){
                        const code = codes[i];
                        const account = this.account();
                        const currency = this.currency(code);
                        const lowerCurrencyId = this.safeStringLower(currency, 'id');
                        account['total'] = this.safeString(balances, 'total_' + lowerCurrencyId);
                        account['used'] = this.safeString(balances, 'in_use_' + lowerCurrencyId);
                        account['free'] = this.safeString(balances, 'available_' + lowerCurrencyId);
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'currency': 'ALL'
                    };
                    const response = await this.privatePostInfoBalance(this.extend(request, params));
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['base'] + '_' + market['quote']
                    };
                    if (limit !== undefined) request['count'] = limit; // default 30, max 30
                    const response = await this.publicGetOrderbookCurrency(this.extend(request, params));
                    //
                    //     {
                    //         "status":"0000",
                    //         "data":{
                    //             "timestamp":"1587621553942",
                    //             "payment_currency":"KRW",
                    //             "order_currency":"BTC",
                    //             "bids":[
                    //                 {"price":"8652000","quantity":"0.0043"},
                    //                 {"price":"8651000","quantity":"0.0049"},
                    //                 {"price":"8650000","quantity":"8.4791"},
                    //             ],
                    //             "asks":[
                    //                 {"price":"8654000","quantity":"0.119"},
                    //                 {"price":"8655000","quantity":"0.254"},
                    //                 {"price":"8658000","quantity":"0.119"},
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const timestamp = this.safeInteger(data, 'timestamp');
                    return this.parseOrderBook(data, symbol, timestamp, 'bids', 'asks', 'price', 'quantity');
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker, fetchTickers
                    //
                    //     {
                    //         "opening_price":"227100",
                    //         "closing_price":"228400",
                    //         "min_price":"222300",
                    //         "max_price":"230000",
                    //         "units_traded":"82618.56075337",
                    //         "acc_trade_value":"18767376138.6031",
                    //         "prev_closing_price":"227100",
                    //         "units_traded_24H":"151871.13484676",
                    //         "acc_trade_value_24H":"34247610416.8974",
                    //         "fluctate_24H":"8700",
                    //         "fluctate_rate_24H":"3.96",
                    //         "date":"1587710327264", // fetchTickers inject this
                    //     }
                    //
                    const timestamp = this.safeInteger(ticker, 'date');
                    const symbol = this.safeSymbol(undefined, market);
                    const open = this.safeString(ticker, 'opening_price');
                    const close = this.safeString(ticker, 'closing_price');
                    const baseVolume = this.safeString(ticker, 'units_traded_24H');
                    const quoteVolume = this.safeString(ticker, 'acc_trade_value_24H');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'max_price'),
                        'low': this.safeString(ticker, 'min_price'),
                        'bid': this.safeString(ticker, 'buy_price'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell_price'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': close,
                        'last': close,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTickerAll(params);
                    //
                    //     {
                    //         "status":"0000",
                    //         "data":{
                    //             "BTC":{
                    //                 "opening_price":"9045000",
                    //                 "closing_price":"9132000",
                    //                 "min_price":"8938000",
                    //                 "max_price":"9168000",
                    //                 "units_traded":"4619.79967497",
                    //                 "acc_trade_value":"42021363832.5187",
                    //                 "prev_closing_price":"9041000",
                    //                 "units_traded_24H":"8793.5045804",
                    //                 "acc_trade_value_24H":"78933458515.4962",
                    //                 "fluctate_24H":"530000",
                    //                 "fluctate_rate_24H":"6.16"
                    //             },
                    //             "date":"1587710878669"
                    //         }
                    //     }
                    //
                    const result = {};
                    const data = this.safeValue(response, 'data', {});
                    const timestamp = this.safeInteger(data, 'date');
                    const tickers = this.omit(data, 'date');
                    const ids = Object.keys(tickers);
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        let symbol = id;
                        let market = undefined;
                        if (id in this.markets_by_id) {
                            market = this.markets_by_id[id];
                            symbol = market['symbol'];
                        }
                        const ticker = tickers[id];
                        const isArray = Array.isArray(ticker);
                        if (!isArray) {
                            ticker['date'] = timestamp;
                            result[symbol] = this.parseTicker(ticker, market);
                        }
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['base']
                    };
                    const response = await this.publicGetTickerCurrency(this.extend(request, params));
                    //
                    //     {
                    //         "status":"0000",
                    //         "data":{
                    //             "opening_price":"227100",
                    //             "closing_price":"228400",
                    //             "min_price":"222300",
                    //             "max_price":"230000",
                    //             "units_traded":"82618.56075337",
                    //             "acc_trade_value":"18767376138.6031",
                    //             "prev_closing_price":"227100",
                    //             "units_traded_24H":"151871.13484676",
                    //             "acc_trade_value_24H":"34247610416.8974",
                    //             "fluctate_24H":"8700",
                    //             "fluctate_rate_24H":"3.96",
                    //             "date":"1587710327264"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTicker(data, market);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1576823400000, // 기준 시간
                    //         '8284000', // 시가
                    //         '8286000', // 종가
                    //         '8289000', // 고가
                    //         '8276000', // 저가
                    //         '15.41503692' // 거래량
                    //     ]
                    //
                    return [
                        this.safeInteger(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['base'],
                        'interval': this.timeframes[timeframe]
                    };
                    const response = await this.publicGetCandlestickCurrencyInterval(this.extend(request, params));
                    //
                    //     {
                    //         'status': '0000',
                    //         'data': {
                    //             [
                    //                 1576823400000, // 기준 시간
                    //                 '8284000', // 시가
                    //                 '8286000', // 종가
                    //                 '8289000', // 고가
                    //                 '8276000', // 저가
                    //                 '15.41503692' // 거래량
                    //             ],
                    //             [
                    //                 1576824000000, // 기준 시간
                    //                 '8284000', // 시가
                    //                 '8281000', // 종가
                    //                 '8289000', // 고가
                    //                 '8275000', // 저가
                    //                 '6.19584467' // 거래량
                    //             ],
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "transaction_date":"2020-04-23 22:21:46",
                    //         "type":"ask",
                    //         "units_traded":"0.0125",
                    //         "price":"8667000",
                    //         "total":"108337"
                    //     }
                    //
                    // fetchOrder (private)
                    //
                    //     {
                    //         "transaction_date": "1572497603902030",
                    //         "price": "8601000",
                    //         "units": "0.005",
                    //         "fee_currency": "KRW",
                    //         "fee": "107.51",
                    //         "total": "43005"
                    //     }
                    //
                    // a workaround for their bug in date format, hours are not 0-padded
                    let timestamp = undefined;
                    const transactionDatetime = this.safeString(trade, 'transaction_date');
                    if (transactionDatetime !== undefined) {
                        const parts = transactionDatetime.split(' ');
                        const numParts = parts.length;
                        if (numParts > 1) {
                            const transactionDate = parts[0];
                            let transactionTime = parts[1];
                            if (transactionTime.length < 8) transactionTime = '0' + transactionTime;
                            timestamp = this.parse8601(transactionDate + ' ' + transactionTime);
                        } else timestamp = this.safeIntegerProduct(trade, 'transaction_date', 0.001);
                    }
                    if (timestamp !== undefined) timestamp -= 32400000; // they report UTC + 9 hours, server in Korean timezone
                    const type = undefined;
                    let side = this.safeString(trade, 'type');
                    side = side === 'ask' ? 'sell' : 'buy';
                    const id = this.safeString(trade, 'cont_no');
                    market = this.safeMarket(undefined, market);
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString2(trade, 'units_traded', 'units');
                    const costString = this.safeString(trade, 'total');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'fee_currency');
                        const feeCurrencyCode = this.commonCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': undefined,
                        'type': type,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['base']
                    };
                    if (limit === undefined) request['count'] = limit; // default 20, max 100
                    const response = await this.publicGetTransactionHistoryCurrency(this.extend(request, params));
                    //
                    //     {
                    //         "status":"0000",
                    //         "data":[
                    //             {
                    //                 "transaction_date":"2020-04-23 22:21:46",
                    //                 "type":"ask",
                    //                 "units_traded":"0.0125",
                    //                 "price":"8667000",
                    //                 "total":"108337"
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'order_currency': market['id'],
                        'payment_currency': market['quote'],
                        'units': amount
                    };
                    let method = 'privatePostTradePlace';
                    if (type === 'limit') {
                        request['price'] = price;
                        request['type'] = side === 'buy' ? 'bid' : 'ask';
                    } else method = 'privatePostTradeMarket' + this.capitalize(side);
                    const response = await this[method](this.extend(request, params));
                    const id = this.safeString(response, 'order_id');
                    if (id === undefined) throw new InvalidOrder(this.id + ' createOrder() did not return an order id');
                    return {
                        'info': response,
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'id': id
                    };
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'order_id': id,
                        'count': 1,
                        'order_currency': market['base'],
                        'payment_currency': market['quote']
                    };
                    const response = await this.privatePostInfoOrderDetail(this.extend(request, params));
                    //
                    //     {
                    //         "status": "0000",
                    //         "data": {
                    //             order_date: '1603161798539254',
                    //             type: 'ask',
                    //             order_status: 'Cancel',
                    //             order_currency: 'BTC',
                    //             payment_currency: 'KRW',
                    //             watch_price: '0',
                    //             order_price: '13344000',
                    //             order_qty: '0.0125',
                    //             cancel_date: '1603161803809993',
                    //             cancel_type: '사용자취소',
                    //             contract: [
                    //                 {
                    //                     transaction_date: '1603161799976383',
                    //                     price: '13344000',
                    //                     units: '0.0015',
                    //                     fee_currency: 'KRW',
                    //                     fee: '0',
                    //                     total: '20016'
                    //                 }
                    //             ],
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(this.extend(data, {
                        'order_id': id
                    }), market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'Pending': 'open',
                        'Completed': 'closed',
                        'Cancel': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //
                    // fetchOrder
                    //
                    //     {
                    //         "transaction_date": "1572497603668315",
                    //         "type": "bid",
                    //         "order_status": "Completed",
                    //         "order_currency": "BTC",
                    //         "payment_currency": "KRW",
                    //         "order_price": "8601000",
                    //         "order_qty": "0.007",
                    //         "cancel_date": "",
                    //         "cancel_type": "",
                    //         "contract": [
                    //             {
                    //                 "transaction_date": "1572497603902030",
                    //                 "price": "8601000",
                    //                 "units": "0.005",
                    //                 "fee_currency": "KRW",
                    //                 "fee": "107.51",
                    //                 "total": "43005"
                    //             },
                    //         ]
                    //     }
                    //
                    //     {
                    //         order_date: '1603161798539254',
                    //         type: 'ask',
                    //         order_status: 'Cancel',
                    //         order_currency: 'BTC',
                    //         payment_currency: 'KRW',
                    //         watch_price: '0',
                    //         order_price: '13344000',
                    //         order_qty: '0.0125',
                    //         cancel_date: '1603161803809993',
                    //         cancel_type: '사용자취소',
                    //         contract: [
                    //             {
                    //                 transaction_date: '1603161799976383',
                    //                 price: '13344000',
                    //                 units: '0.0015',
                    //                 fee_currency: 'KRW',
                    //                 fee: '0',
                    //                 total: '20016'
                    //             }
                    //         ],
                    //     }
                    //
                    // fetchOpenOrders
                    //
                    //     {
                    //         "order_currency": "BTC",
                    //         "payment_currency": "KRW",
                    //         "order_id": "C0101000007408440032",
                    //         "order_date": "1571728739360570",
                    //         "type": "bid",
                    //         "units": "5.0",
                    //         "units_remaining": "5.0",
                    //         "price": "501000",
                    //     }
                    //
                    const timestamp = this.safeIntegerProduct(order, 'order_date', 0.001);
                    const sideProperty = this.safeValue2(order, 'type', 'side');
                    const side = sideProperty === 'bid' ? 'buy' : 'sell';
                    const status = this.parseOrderStatus(this.safeString(order, 'order_status'));
                    const price = this.safeString2(order, 'order_price', 'price');
                    let type = 'limit';
                    if (Precise.stringEquals(price, '0')) type = 'market';
                    const amount = this.safeString2(order, 'order_qty', 'units');
                    let remaining = this.safeString(order, 'units_remaining');
                    if (remaining === undefined) {
                        if (status === 'closed') remaining = '0';
                        else if (status !== 'canceled') remaining = amount;
                    }
                    let symbol = undefined;
                    const baseId = this.safeString(order, 'order_currency');
                    const quoteId = this.safeString(order, 'payment_currency');
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    if (base !== undefined && quote !== undefined) symbol = base + '/' + quote;
                    if (symbol === undefined) {
                        market = this.safeMarket(undefined, market);
                        symbol = market['symbol'];
                    }
                    const id = this.safeString(order, 'order_id');
                    const rawTrades = this.safeValue(order, 'contract', []);
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'average': undefined,
                        'filled': undefined,
                        'remaining': remaining,
                        'status': status,
                        'fee': undefined,
                        'trades': rawTrades
                    }, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (limit === undefined) limit = 100;
                    const request = {
                        'count': limit,
                        'order_currency': market['base'],
                        'payment_currency': market['quote']
                    };
                    if (since !== undefined) request['after'] = since;
                    const response = await this.privatePostInfoOrders(this.extend(request, params));
                    //
                    //     {
                    //         "status": "0000",
                    //         "data": [
                    //             {
                    //                 "order_currency": "BTC",
                    //                 "payment_currency": "KRW",
                    //                 "order_id": "C0101000007408440032",
                    //                 "order_date": "1571728739360570",
                    //                 "type": "bid",
                    //                 "units": "5.0",
                    //                 "units_remaining": "5.0",
                    //                 "price": "501000",
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async cancelOrder(id, symbol, params = {}) {
                    const side_in_params = 'side' in params;
                    if (!side_in_params) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a `side` parameter (sell or buy)');
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a `symbol` argument');
                    const market = this.market(symbol);
                    const side = params['side'] === 'buy' ? 'bid' : 'ask';
                    params = this.omit(params, [
                        'side',
                        'currency'
                    ]);
                    // https://github.com/ccxt/ccxt/issues/6771
                    const request = {
                        'order_id': id,
                        'type': side,
                        'order_currency': market['base'],
                        'payment_currency': market['quote']
                    };
                    return await this.privatePostTradeCancel(this.extend(request, params));
                }
                cancelUnifiedOrder(order, params = {}) {
                    const request = {
                        'side': order['side']
                    };
                    return this.cancelOrder(order['id'], order['symbol'], this.extend(request, params));
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'units': amount,
                        'address': address,
                        'currency': currency['id']
                    };
                    if (currency === 'XRP' || currency === 'XMR' || currency === 'EOS' || currency === 'STEEM') {
                        const destination = this.safeString(params, 'destination');
                        if (tag === undefined && destination === undefined) throw new ArgumentsRequired1(this.id + ' ' + code + ' withdraw() requires a tag argument or an extra destination param');
                        else if (tag !== undefined) request['destination'] = tag;
                    }
                    const response = await this.privatePostTradeBtcWithdrawal(this.extend(request, params));
                    //
                    // { "status" : "0000"}
                    //
                    return this.parseTransaction(response, currency);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     { "status" : "0000"}
                    //
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'id': undefined,
                        'txid': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': undefined,
                        'info': transaction
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const endpoint = '/' + this.implodeParams(path, params);
                    let url = this.implodeHostname(this.urls['api'][api]) + endpoint;
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        body = this.urlencode(this.extend({
                            'endpoint': endpoint
                        }, query));
                        const nonce = this.nonce().toString();
                        const auth = endpoint + "\0" + body + "\0" + nonce; // eslint-disable-line quotes
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha512');
                        const signature64 = this.decode(this.stringToBase64(signature));
                        headers = {
                            'Accept': 'application/json',
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Api-Key': this.apiKey,
                            'Api-Sign': signature64,
                            'Api-Nonce': nonce
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if ('status' in response) {
                        //
                        //     {"status":"5100","message":"After May 23th, recent_transactions is no longer, hence users will not be able to connect to recent_transactions"}
                        //
                        const status = this.safeString(response, 'status');
                        const message = this.safeString(response, 'message');
                        if (status !== undefined) {
                            if (status === '0000') return; // no error
                            else if (message === "\uAC70\uB798 \uC9C4\uD589\uC911\uC778 \uB0B4\uC5ED\uC774 \uC874\uC7AC\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4") // https://github.com/ccxt/ccxt/issues/9017
                            return; // no error
                            const feedback = this.id + ' ' + body;
                            this.throwExactlyMatchedException(this.exceptions, status, feedback);
                            this.throwExactlyMatchedException(this.exceptions, message, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    38: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AuthenticationError: AuthenticationError, ExchangeNotAvailable: ExchangeNotAvailable, AccountSuspended: AccountSuspended, PermissionDenied: PermissionDenied, RateLimitExceeded: RateLimitExceeded, InvalidNonce: InvalidNonce, InvalidAddress: InvalidAddress, ArgumentsRequired: ArgumentsRequired1, ExchangeError: ExchangeError1, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, BadRequest: BadRequest, OrderNotFound: OrderNotFound, BadSymbol: BadSymbol, NotSupported: NotSupported } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE, TRUNCATE: TRUNCATE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bitmart extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitmart',
                        'name': 'BitMart',
                        'countries': [
                            'US',
                            'CN',
                            'HK',
                            'KR'
                        ],
                        'rateLimit': 250,
                        'version': 'v1',
                        'certified': true,
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'cancelOrders': false,
                            'createOrder': true,
                            'createStopLimitOrder': false,
                            'createStopMarketOrder': false,
                            'createStopOrder': false,
                            'fetchBalance': true,
                            'fetchCanceledOrders': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDeposit': true,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': false,
                            'fetchDepositAddressesByNetwork': false,
                            'fetchDeposits': true,
                            'fetchFundingFee': true,
                            'fetchFundingFees': false,
                            'fetchFundingHistory': undefined,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': false,
                            'fetchOrderTrades': true,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawAddressesByNetwork': false,
                            'fetchWithdrawal': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'hostname': 'bitmart.com',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/129991357-8f47464b-d0f4-41d6-8a82-34122f0d1398.jpg',
                            'api': {
                                'rest': 'https://api-cloud.{hostname}'
                            },
                            'www': 'https://www.bitmart.com/',
                            'doc': 'https://developer-pro.bitmart.com/',
                            'referral': {
                                'url': 'http://www.bitmart.com/?r=rQCFLh',
                                'discount': 0.3
                            },
                            'fees': 'https://www.bitmart.com/fee/en'
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'uid': true
                        },
                        'api': {
                            'public': {
                                'system': {
                                    'get': {
                                        'time': 5,
                                        'service': 5
                                    }
                                },
                                'account': {
                                    'get': {
                                        'currencies': 10
                                    }
                                },
                                'spot': {
                                    'get': {
                                        'currencies': 1,
                                        'symbols': 1,
                                        'symbols/details': 1,
                                        'ticker': 1,
                                        'steps': 1,
                                        'symbols/kline': 1,
                                        'symbols/book': 1,
                                        'symbols/trades': 1
                                    }
                                },
                                'contract': {
                                    'get': {
                                        'tickers': 0.5
                                    }
                                }
                            },
                            'private': {
                                'account': {
                                    'get': {
                                        'wallet': 0.5,
                                        'deposit/address': 1,
                                        'withdraw/charge': 1,
                                        'deposit-withdraw/history': 1,
                                        'deposit-withdraw/detail': 1
                                    },
                                    'post': {
                                        'withdraw/apply': 1
                                    }
                                },
                                'spot': {
                                    'get': {
                                        'wallet': 0.5,
                                        'order_detail': 0.1,
                                        'orders': 0.5,
                                        'trades': 0.5
                                    },
                                    'post': {
                                        'submit_order': 0.1,
                                        'cancel_order': 0.1,
                                        'cancel_orders': 0.1
                                    }
                                }
                            }
                        },
                        'timeframes': {
                            '1m': 1,
                            '3m': 3,
                            '5m': 5,
                            '15m': 15,
                            '30m': 30,
                            '45m': 45,
                            '1h': 60,
                            '2h': 120,
                            '3h': 180,
                            '4h': 240,
                            '1d': 1440,
                            '1w': 10080,
                            '1M': 43200
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.0025'),
                                'maker': this.parseNumber('0.0025'),
                                'tiers': {
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.0020')
                                        ],
                                        [
                                            this.parseNumber('10'),
                                            this.parseNumber('0.18')
                                        ],
                                        [
                                            this.parseNumber('50'),
                                            this.parseNumber('0.0016')
                                        ],
                                        [
                                            this.parseNumber('250'),
                                            this.parseNumber('0.0014')
                                        ],
                                        [
                                            this.parseNumber('1000'),
                                            this.parseNumber('0.0012')
                                        ],
                                        [
                                            this.parseNumber('5000'),
                                            this.parseNumber('0.0010')
                                        ],
                                        [
                                            this.parseNumber('25000'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('50000'),
                                            this.parseNumber('0.0006')
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.001')
                                        ],
                                        [
                                            this.parseNumber('10'),
                                            this.parseNumber('0.0009')
                                        ],
                                        [
                                            this.parseNumber('50'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('250'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('1000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('5000'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('25000'),
                                            this.parseNumber('0.0004')
                                        ],
                                        [
                                            this.parseNumber('50000'),
                                            this.parseNumber('0.0003')
                                        ]
                                    ]
                                }
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'exceptions': {
                            'exact': {
                                // general errors
                                '30000': ExchangeError1,
                                '30001': AuthenticationError,
                                '30002': AuthenticationError,
                                '30003': AccountSuspended,
                                '30004': AuthenticationError,
                                '30005': AuthenticationError,
                                '30006': AuthenticationError,
                                '30007': AuthenticationError,
                                '30008': AuthenticationError,
                                '30010': PermissionDenied,
                                '30011': AuthenticationError,
                                '30012': AuthenticationError,
                                '30013': RateLimitExceeded,
                                '30014': ExchangeNotAvailable,
                                // funding account errors
                                '60000': BadRequest,
                                '60001': BadRequest,
                                '60002': BadRequest,
                                '60003': ExchangeError1,
                                '60004': ExchangeError1,
                                '60005': ExchangeError1,
                                '60006': ExchangeError1,
                                '60007': InvalidAddress,
                                '60008': InsufficientFunds,
                                '60009': ExchangeError1,
                                '60010': ExchangeError1,
                                '60011': InvalidAddress,
                                '60012': ExchangeError1,
                                '60020': PermissionDenied,
                                '60021': PermissionDenied,
                                '60022': PermissionDenied,
                                '60030': BadRequest,
                                '60031': BadRequest,
                                '60050': ExchangeError1,
                                '60051': ExchangeError1,
                                // spot errors
                                '50000': BadRequest,
                                '50001': BadSymbol,
                                '50002': BadRequest,
                                '50003': BadRequest,
                                '50004': BadRequest,
                                '50005': OrderNotFound,
                                '50006': InvalidOrder,
                                '50007': InvalidOrder,
                                '50008': InvalidOrder,
                                '50009': InvalidOrder,
                                '50010': InvalidOrder,
                                '50011': InvalidOrder,
                                '50012': InvalidOrder,
                                '50013': InvalidOrder,
                                '50014': BadRequest,
                                '50015': BadRequest,
                                '50016': BadRequest,
                                '50017': BadRequest,
                                '50018': BadRequest,
                                '50019': BadRequest,
                                // '50019': ExchangeError, // 400, Invalid status. validate status is [1=Failed, 2=Success, 3=Frozen Failed, 4=Frozen Success, 5=Partially Filled, 6=Fully Fulled, 7=Canceling, 8=Canceled
                                '50020': InsufficientFunds,
                                '50021': BadRequest,
                                '50022': ExchangeNotAvailable,
                                '50023': BadSymbol,
                                '50029': InvalidOrder,
                                '50030': InvalidOrder,
                                // below Error codes used interchangeably for both failed postOnly and IOC orders depending on market price and order side
                                '50035': InvalidOrder,
                                '50034': InvalidOrder,
                                '53000': AccountSuspended,
                                '53001': AccountSuspended,
                                '57001': BadRequest,
                                '58001': BadRequest,
                                '59001': ExchangeError1,
                                '59002': ExchangeError1,
                                // contract errors
                                '40001': ExchangeError1,
                                '40002': ExchangeError1,
                                '40003': ExchangeError1,
                                '40004': ExchangeError1,
                                '40005': ExchangeError1,
                                '40006': PermissionDenied,
                                '40007': BadRequest,
                                '40008': InvalidNonce,
                                '40009': BadRequest,
                                '40010': BadRequest,
                                '40011': BadRequest,
                                '40012': ExchangeError1,
                                '40013': ExchangeError1,
                                '40014': BadSymbol,
                                '40015': BadSymbol,
                                '40016': InvalidOrder,
                                '40017': InvalidOrder,
                                '40018': InvalidOrder,
                                '40019': ExchangeError1,
                                '40020': InvalidOrder,
                                '40021': ExchangeError1,
                                '40022': ExchangeError1,
                                '40023': ExchangeError1,
                                '40024': ExchangeError1,
                                '40025': ExchangeError1,
                                '40026': ExchangeError1,
                                '40027': InsufficientFunds,
                                '40028': PermissionDenied,
                                '40029': InvalidOrder,
                                '40030': InvalidOrder,
                                '40031': InvalidOrder,
                                '40032': InvalidOrder,
                                '40033': InvalidOrder,
                                '40034': BadSymbol,
                                '53002': PermissionDenied
                            },
                            'broad': {}
                        },
                        'commonCurrencies': {
                            '$GM': 'GOLDMINER',
                            '$HERO': 'Step Hero',
                            '$PAC': 'PAC',
                            'AUR': 'Aurum',
                            'BP': 'BEYOND',
                            'COT': 'Community Coin',
                            'CPC': 'CPCoin',
                            'DMS': 'DimSum',
                            'FOX': 'Fox Finance',
                            'GDT': 'Gorilla Diamond',
                            'GLD': 'Goldario',
                            'MIM': 'MIM Swarm',
                            'MVP': 'MVP Coin',
                            'ONE': 'Menlo One',
                            'PLA': 'Plair',
                            'TCT': 'TacoCat Token',
                            'TRU': 'Truebit',
                            'ULT': 'Ultiledger'
                        },
                        'options': {
                            'networks': {
                                'TRX': 'TRC20',
                                'ETH': 'ERC20'
                            },
                            'defaultNetworks': {
                                'USDT': 'ERC20'
                            },
                            'defaultType': 'spot',
                            'fetchBalance': {
                                'type': 'spot'
                            },
                            'createMarketBuyOrderRequiresPrice': true
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicSystemGetTime(params);
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"c4e5e5b7-fe9f-4191-89f7-53f6c5bf9030",
                    //         "data":{
                    //             "server_time":1599843709578
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.safeInteger(data, 'server_time');
                }
                async fetchStatus(params = {}) {
                    const options = this.safeValue(this.options, 'fetchBalance', {});
                    const defaultType = this.safeString(this.options, 'defaultType');
                    let type = this.safeString(options, 'type', defaultType);
                    type = this.safeString(params, 'type', type);
                    params = this.omit(params, 'type');
                    const response = await this.publicSystemGetService(params);
                    //
                    //     {
                    //         "message": "OK",
                    //         "code": 1000,
                    //         "trace": "1d3f28b0-763e-4f78-90c4-5e3ad19dc595",
                    //         "data": {
                    //           "service": [
                    //             {
                    //               "title": "Spot API Stop",
                    //               "service_type": "spot",
                    //               "status": 2,
                    //               "start_time": 1648639069125,
                    //               "end_time": 1648639069125
                    //             },
                    //             {
                    //               "title": "Contract API Stop",
                    //               "service_type": "contract",
                    //               "status": 2,
                    //               "start_time": 1648639069125,
                    //               "end_time": 1648639069125
                    //             }
                    //           ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const services = this.safeValue(data, 'service', []);
                    const servicesByType = this.indexBy(services, 'service_type');
                    if (type === 'swap' || type === 'future') type = 'contract';
                    const service = this.safeValue(servicesByType, type);
                    let status = undefined;
                    let eta = undefined;
                    if (service !== undefined) {
                        const statusCode = this.safeInteger(service, 'status');
                        if (statusCode === 2) status = 'ok';
                        else {
                            status = 'maintenance';
                            eta = this.safeInteger(service, 'end_time');
                        }
                    }
                    return {
                        'status': status,
                        'updated': this.milliseconds(),
                        'eta': eta,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchSpotMarkets(params = {}) {
                    const response = await this.publicSpotGetSymbolsDetails(params);
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"a67c9146-086d-4d3f-9897-5636a9bb26e1",
                    //         "data":{
                    //             "symbols":[
                    //                 {
                    //                     "symbol":"PRQ_BTC",
                    //                     "symbol_id":1232,
                    //                     "base_currency":"PRQ",
                    //                     "quote_currency":"BTC",
                    //                     "quote_increment":"1.0000000000",
                    //                     "base_min_size":"1.0000000000",
                    //                     "base_max_size":"10000000.0000000000",
                    //                     "price_min_precision":8,
                    //                     "price_max_precision":10,
                    //                     "expiration":"NA",
                    //                     "min_buy_amount":"0.0001000000",
                    //                     "min_sell_amount":"0.0001000000"
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const symbols = this.safeValue(data, 'symbols', []);
                    const result = [];
                    for(let i = 0; i < symbols.length; i++){
                        const market = symbols[i];
                        const id = this.safeString(market, 'symbol');
                        const numericId = this.safeInteger(market, 'symbol_id');
                        const baseId = this.safeString(market, 'base_currency');
                        const quoteId = this.safeString(market, 'quote_currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const symbol = base + '/' + quote;
                        //
                        // https://github.com/bitmartexchange/bitmart-official-api-docs/blob/master/rest/public/symbols_details.md#response-details
                        // from the above API doc:
                        // quote_increment Minimum order price as well as the price increment
                        // price_min_precision Minimum price precision (digit) used to query price and kline
                        // price_max_precision Maximum price precision (digit) used to query price and kline
                        //
                        // the docs are wrong: https://github.com/ccxt/ccxt/issues/5612
                        //
                        const minBuyCost = this.safeString(market, 'min_buy_amount');
                        const minSellCost = this.safeString(market, 'min_sell_amount');
                        const minCost = Precise.stringMax(minBuyCost, minSellCost);
                        const pricePrecision = this.parsePrecision(this.safeString(market, 'price_max_precision'));
                        result.push({
                            'id': id,
                            'numericId': numericId,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(market, 'base_min_size'),
                                'price': this.parseNumber(pricePrecision)
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'base_min_size'),
                                    'max': this.safeNumber(market, 'base_max_size')
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.parseNumber(minCost),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchContractMarkets(params = {}) {
                    const response = await this.publicContractGetTickers(params);
                    //
                    //    {
                    //        "message": "OK",
                    //        "code": 1000,
                    //        "trace": "045d13a8-4bc7-4974-9748-97d0ea183ef0",
                    //        "data": {
                    //            "tickers": [
                    //                {
                    //                    "contract_symbol": "RAYUSDT",
                    //                    "last_price": "3.893",
                    //                    "index_price": "3.90248043",
                    //                    "last_funding_rate": "-0.00054285",
                    //                    "price_change_percent_24h": "-6.955",
                    //                    "volume_24h": "10450969.34602996",
                    //                    "url": "https://futures.bitmart.com/en?symbol=RAYUSDT",
                    //                    "high_price": "4.299",
                    //                    "low_price": "3.887",
                    //                    "legal_coin_price": "3.893056"
                    //                },
                    //                ...
                    //            ]
                    //        }
                    //    }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const tickers = this.safeValue(data, 'tickers', []);
                    const result = [];
                    for(let i = 0; i < tickers.length; i++){
                        const market = tickers[i];
                        const id = this.safeString(market, 'contract_symbol');
                        const baseId = id.slice(0, -4);
                        const quoteId = id.slice(-4);
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const splitId = id.split('_');
                        const splitIdEnding = this.safeString(splitId, 1);
                        let settle = 'USDT';
                        let symbol = base + '/' + quote + ':' + settle;
                        let type = 'swap';
                        let swap = true;
                        let future = false;
                        let expiry = undefined;
                        if (splitIdEnding !== undefined) {
                            settle = 'BTC';
                            symbol = base + '/' + quote + ':' + settle;
                            if (splitIdEnding !== 'PERP') {
                                const date = this.iso8601(this.milliseconds());
                                const splitDate = date.split('-');
                                const year = splitDate[0];
                                const shortYear = year.slice(0, 2);
                                const expiryMonth = splitIdEnding.slice(0, 2);
                                const expiryDay = splitIdEnding.slice(2, 4);
                                expiry = this.parse8601(year + '-' + expiryMonth + '-' + expiryDay + 'T00:00:00Z');
                                symbol = symbol + '-' + shortYear + splitIdEnding;
                                type = 'future';
                                swap = false;
                                future = true;
                            }
                        }
                        result.push({
                            'id': id,
                            'numericId': undefined,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': type,
                            'spot': false,
                            'margin': false,
                            'swap': swap,
                            'future': future,
                            'option': false,
                            'active': true,
                            'contract': true,
                            'linear': true,
                            'inverse': false,
                            'contractSize': undefined,
                            'expiry': expiry,
                            'expiryDatetime': this.iso8601(expiry),
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': undefined,
                                'price': undefined
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const spot = await this.fetchSpotMarkets(params);
                    const contract = await this.fetchContractMarkets(params);
                    return this.arrayConcat(spot, contract);
                }
                async fetchFundingFee(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateAccountGetWithdrawCharge(this.extend(request, params));
                    //
                    //     {
                    //         message: 'OK',
                    //         code: '1000',
                    //         trace: '3ecc0adf-91bd-4de7-aca1-886c1122f54f',
                    //         data: {
                    //             today_available_withdraw_BTC: '100.0000',
                    //             min_withdraw: '0.005',
                    //             withdraw_precision: '8',
                    //             withdraw_fee: '0.000500000000000000000000000000'
                    //         }
                    //     }
                    //
                    const data = response['data'];
                    const withdrawFees = {};
                    withdrawFees[code] = this.safeNumber(data, 'withdraw_fee');
                    return {
                        'info': response,
                        'withdraw': withdrawFees,
                        'deposit': {}
                    };
                }
                parseTicker(ticker, market) {
                    //
                    // spot
                    //
                    //      {
                    //          "symbol":"DOGE_USDT",
                    //          "last_price":"0.128300",
                    //          "quote_volume_24h":"2296619.060420",
                    //          "base_volume_24h":"17508866.000000000000000000000000000000",
                    //          "high_24h":"0.133900",
                    //          "low_24h":"0.127799",
                    //          "open_24h":"0.133100",
                    //          "close_24h":"0.128300",
                    //          "best_ask":"0.128530",
                    //          "best_ask_size":"15170",
                    //          "best_bid":"0.128200",
                    //          "best_bid_size":"21232",
                    //          "fluctuation":"-0.0361",
                    //          "s_t": 1610936002, // ws only
                    //          "url":"https://www.bitmart.com/trade?symbol=DOGE_USDT"
                    //      }
                    //
                    // contract
                    //
                    //      {
                    //          "contract_symbol":"DOGEUSDT",
                    //          "last_price":"0.130340",
                    //          "index_price":"0.13048245",
                    //          "last_funding_rate":"0.00002287",
                    //          "price_change_percent_24h":"-2.074",
                    //          "volume_24h":"113705028.59482228",
                    //          "url":"https://futures.bitmart.com/en?symbol=DOGEUSDT",
                    //          "high_price":"0.134520",
                    //          "low_price":"0.128570",
                    //          "legal_coin_price":"0.1302699"
                    //      }
                    //
                    const timestamp = this.safeTimestamp2(ticker, 'timestamp', 's_t', this.milliseconds());
                    const marketId = this.safeString2(ticker, 'symbol', 'contract_symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const last = this.safeString2(ticker, 'close_24h', 'last_price');
                    let percentage = this.safeString(ticker, 'price_change_percent_24h');
                    if (percentage === undefined) {
                        const percentageRaw = this.safeString(ticker, 'fluctuation');
                        if (percentageRaw !== undefined && percentageRaw !== '0') {
                            const direction = percentageRaw[0];
                            percentage = direction + Precise.stringMul(percentageRaw.replace(direction, ''), '100');
                        } else if (percentageRaw === '0') percentage = '0';
                    }
                    const baseVolume = this.safeString(ticker, 'base_volume_24h');
                    let quoteVolume = this.safeString(ticker, 'quote_volume_24h');
                    quoteVolume = this.safeString(ticker, 'volume_24h', quoteVolume);
                    const average = this.safeString2(ticker, 'avg_price', 'index_price');
                    const price = this.safeString(ticker, 'depth_price', ticker);
                    const high = this.safeString2(ticker, 'high_24h', 'high_price');
                    const low = this.safeString2(ticker, 'low_24h', 'low_price');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': high,
                        'low': low,
                        'bid': this.safeString(price, 'best_bid'),
                        'bidVolume': this.safeString(ticker, 'best_bid_size'),
                        'ask': this.safeString(price, 'best_ask'),
                        'askVolume': this.safeString(ticker, 'best_ask_size'),
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open_24h'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': percentage,
                        'average': average,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {};
                    let method = undefined;
                    if (market['swap'] || market['future']) {
                        method = 'publicContractGetTickers';
                        request['contract_symbol'] = market['id'];
                    } else if (market['spot']) {
                        method = 'publicSpotGetTicker';
                        request['symbol'] = market['id'];
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"6aa5b923-2f57-46e3-876d-feca190e0b82",
                    //         "data":{
                    //             "tickers":[
                    //                 {
                    //                     "symbol":"ETH_BTC",
                    //                     "last_price":"0.036037",
                    //                     "quote_volume_24h":"4380.6660000000",
                    //                     "base_volume_24h":"159.3582006712",
                    //                     "high_24h":"0.036972",
                    //                     "low_24h":"0.035524",
                    //                     "open_24h":"0.036561",
                    //                     "close_24h":"0.036037",
                    //                     "best_ask":"0.036077",
                    //                     "best_ask_size":"9.9500",
                    //                     "best_bid":"0.035983",
                    //                     "best_bid_size":"4.2792",
                    //                     "fluctuation":"-0.0143",
                    //                     "url":"https://www.bitmart.com/trade?symbol=ETH_BTC"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    // contract
                    //
                    //      {
                    //          "message":"OK",
                    //          "code":1000,
                    //          "trace":"4a0ebceb-d3f7-45a3-8feb-f61e230e24cd",
                    //          "data":{
                    //              "tickers":[
                    //                  {
                    //                      "contract_symbol":"DOGEUSDT",
                    //                      "last_price":"0.130180",
                    //                      "index_price":"0.13028635",
                    //                      "last_funding_rate":"0.00002025",
                    //                      "price_change_percent_24h":"-2.326",
                    //                      "volume_24h":"116789313.01797258",
                    //                      "url":"https://futures.bitmart.com/en?symbol=DOGEUSDT",
                    //                      "high_price":"0.134520",
                    //                      "low_price":"0.128570",
                    //                      "legal_coin_price":"0.13017401"
                    //                  }
                    //              ]
                    //          }
                    //      }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const tickers = this.safeValue(data, 'tickers', []);
                    // fails in naming for contract tickers 'contract_symbol'
                    let tickersById = undefined;
                    if (market['spot']) tickersById = this.indexBy(tickers, 'symbol');
                    else if (market['swap'] || market['future']) tickersById = this.indexBy(tickers, 'contract_symbol');
                    const ticker = this.safeValue(tickersById, market['id']);
                    return this.parseTicker(ticker, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTickers', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'publicSpotGetTicker',
                        'swap': 'publicContractGetTickers',
                        'future': 'publicContractGetTickers'
                    });
                    const response = await this[method](query);
                    const data = this.safeValue(response, 'data', {});
                    const tickers = this.safeValue(data, 'tickers', []);
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const ticker = this.parseTicker(tickers[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicAccountGetCurrencies(params);
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"8c768b3c-025f-413f-bec5-6d6411d46883",
                    //         "data":{
                    //             "currencies":[
                    //                 {"currency":"MATIC","name":"Matic Network","withdraw_enabled":true,"deposit_enabled":true},
                    //                 {"currency":"KTN","name":"Kasoutuuka News","withdraw_enabled":true,"deposit_enabled":false},
                    //                 {"currency":"BRT","name":"Berith","withdraw_enabled":true,"deposit_enabled":true},
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const currencies = this.safeValue(data, 'currencies', []);
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'currency');
                        const code = this.safeCurrencyCode(id);
                        const name = this.safeString(currency, 'name');
                        const withdrawEnabled = this.safeValue(currency, 'withdraw_enabled');
                        const depositEnabled = this.safeValue(currency, 'deposit_enabled');
                        const active = withdrawEnabled && depositEnabled;
                        result[code] = {
                            'id': id,
                            'code': code,
                            'name': name,
                            'info': currency,
                            'active': active,
                            'deposit': depositEnabled,
                            'withdraw': withdrawEnabled,
                            'fee': undefined,
                            'precision': undefined,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {};
                    if (market['spot']) {
                        request['symbol'] = market['id'];
                        if (limit !== undefined) request['size'] = limit; // default 50, max 200
                    // request['precision'] = 4; // optional price precision / depth level whose range is defined in symbol details
                    } else if (market['swap'] || market['future']) throw new NotSupported(this.id + ' fetchOrderBook () does not accept swap or future markets, only spot markets are allowed');
                    const response = await this.publicSpotGetSymbolsBook(this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"8254f8fc-431d-404f-ad9a-e716339f66c7",
                    //         "data":{
                    //             "buys":[
                    //                 {"amount":"4.7091","total":"4.71","price":"0.034047","count":"1"},
                    //                 {"amount":"5.7439","total":"10.45","price":"0.034039","count":"1"},
                    //                 {"amount":"2.5249","total":"12.98","price":"0.032937","count":"1"},
                    //             ],
                    //             "sells":[
                    //                 {"amount":"41.4365","total":"41.44","price":"0.034174","count":"1"},
                    //                 {"amount":"4.2317","total":"45.67","price":"0.034183","count":"1"},
                    //                 {"amount":"0.3000","total":"45.97","price":"0.034240","count":"1"},
                    //             ]
                    //         }
                    //     }
                    //
                    // contract
                    //
                    //     {
                    //         "errno":"OK",
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"c330dfca-ca5b-4f15-b350-9fef3f049b4f",
                    //         "data":{
                    //             "sells":[
                    //                 {"price":"347.6","vol":"6678"},
                    //                 {"price":"347.7","vol":"3452"},
                    //                 {"price":"347.8","vol":"6331"},
                    //             ],
                    //             "buys":[
                    //                 {"price":"347.5","vol":"6222"},
                    //                 {"price":"347.4","vol":"20979"},
                    //                 {"price":"347.3","vol":"15179"},
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrderBook(data, symbol, undefined, 'buys', 'sells', 'price', 'amount');
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades spot ( amount = count * price )
                    //
                    //     {
                    //          "amount": "818.94",
                    //          "order_time": "1637601839035",    // ETH/USDT
                    //          "price": "4221.99",
                    //          "count": "0.19397",
                    //          "type": "buy"
                    //      }
                    //
                    // public fetchTrades contract, private fetchMyTrades contract
                    //
                    //     {
                    //         "order_id":109159616160,
                    //         "trade_id":109159616197,
                    //         "contract_id":2,
                    //         "deal_price":"347.6",
                    //         "deal_vol":"5623",
                    //         "make_fee":"-5.8636644",
                    //         "take_fee":"9.772774",
                    //         "created_at":"2020-09-09T11:49:50.749170536Z",
                    //         "way":1,
                    //         "fluctuation":"0"
                    //     }
                    //
                    // private fetchMyTrades spot
                    //
                    //     {
                    //         "detail_id":256348632,
                    //         "order_id":2147484350,
                    //         "symbol":"BTC_USDT",
                    //         "create_time":1590462303000,
                    //         "side":"buy",
                    //         "fees":"0.00001350",
                    //         "fee_coin_name":"BTC",
                    //         "notional":"88.00000000",
                    //         "price_avg":"8800.00",
                    //         "size":"0.01000",
                    //         "exec_type":"M"
                    //     }
                    //
                    const id = this.safeString2(trade, 'trade_id', 'detail_id');
                    let timestamp = this.safeInteger2(trade, 'order_time', 'create_time');
                    if (timestamp === undefined) timestamp = this.safeTimestamp(trade, 's_t');
                    if (timestamp === undefined) timestamp = this.parse8601(this.safeString(trade, 'created_at'));
                    const type = undefined;
                    const way = this.safeInteger(trade, 'way');
                    let side = this.safeStringLower2(trade, 'type', 'side');
                    if (side === undefined && way !== undefined) {
                        if (way < 5) side = 'buy';
                        else side = 'sell';
                    }
                    let takerOrMaker = undefined;
                    const execType = this.safeString(trade, 'exec_type');
                    if (execType !== undefined) takerOrMaker = execType === 'M' ? 'maker' : 'taker';
                    let priceString = this.safeString2(trade, 'price', 'deal_price');
                    priceString = this.safeString(trade, 'price_avg', priceString);
                    let amountString = this.safeString2(trade, 'count', 'deal_vol');
                    amountString = this.safeString(trade, 'size', amountString);
                    const costString = this.safeString2(trade, 'amount', 'notional');
                    const orderId = this.safeInteger(trade, 'order_id');
                    const marketId = this.safeString2(trade, 'contract_id', 'symbol');
                    market = this.safeMarket(marketId, market, '_');
                    const feeCostString = this.safeString(trade, 'fees');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'fee_coin_name');
                        let feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        if (feeCurrencyCode === undefined) feeCurrencyCode = side === 'buy' ? market['base'] : market['quote'];
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': type,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'takerOrMaker': takerOrMaker,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (market['spot']) request['symbol'] = market['id'];
                    else if (market['swap'] || market['future']) throw new NotSupported(this.id + ' fetchTrades () does not accept swap or future markets, only spot markets are allowed');
                    const response = await this.publicSpotGetSymbolsTrades(this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"222d74c0-8f6d-49d9-8e1b-98118c50eeba",
                    //         "data":{
                    //             "trades":[
                    //                 {
                    //                     "amount":"0.005703",
                    //                     "order_time":1599652045394,
                    //                     "price":"0.034029",
                    //                     "count":"0.1676",
                    //                     "type":"sell"
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    // contract
                    //
                    //     {
                    //         "errno":"OK",
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"782bc746-b86e-43bf-8d1a-c68b479c9bdd",
                    //         "data":{
                    //             "trades":[
                    //                 {
                    //                     "order_id":109159616160,
                    //                     "trade_id":109159616197,
                    //                     "contract_id":2,
                    //                     "deal_price":"347.6",
                    //                     "deal_vol":"5623",
                    //                     "make_fee":"-5.8636644",
                    //                     "take_fee":"9.772774",
                    //                     "created_at":"2020-09-09T11:49:50.749170536Z",
                    //                     "way":1,
                    //                     "fluctuation":"0"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const trades = this.safeValue(data, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    // spot
                    //
                    //     {
                    //         "last_price":"0.034987",
                    //         "timestamp":1598787420,
                    //         "volume":"1.0198",
                    //         "open":"0.035007",
                    //         "close":"0.034987",
                    //         "high":"0.035007",
                    //         "low":"0.034986"
                    //     }
                    //
                    // contract
                    //
                    //     {
                    //         "low":"404.4",
                    //         "high":"404.4",
                    //         "open":"404.4",
                    //         "close":"404.4",
                    //         "last_price":"404.4",
                    //         "avg_price":"404.4",
                    //         "volume":"7670",
                    //         "timestamp":1598758441,
                    //         "rise_fall_rate":"0",
                    //         "rise_fall_value":"0",
                    //         "base_coin_volume":"76.7",
                    //         "quote_coin_volume":"31017.48"
                    //     }
                    //
                    // ws
                    //
                    //     [
                    //         1631056350, // timestamp
                    //         '46532.83', // oopen
                    //         '46555.71', // high
                    //         '46511.41', // low
                    //         '46555.71', // close
                    //         '0.25', // volume
                    //     ]
                    //
                    if (Array.isArray(ohlcv)) return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                    else return [
                        this.safeTimestamp(ohlcv, 'timestamp'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const type = market['type'];
                    const request = {};
                    const duration = this.parseTimeframe(timeframe);
                    if (type === 'spot') {
                        request['symbol'] = market['id'];
                        request['step'] = this.timeframes[timeframe];
                        // the exchange will return an empty array if more than 500 candles is requested
                        const maxLimit = 500;
                        if (limit === undefined) limit = maxLimit;
                        limit = Math.min(maxLimit, limit);
                        if (since === undefined) {
                            const end = parseInt(this.milliseconds() / 1000);
                            const start = end - limit * duration;
                            request['from'] = start;
                            request['to'] = end;
                        } else {
                            const start = parseInt(since / 1000) - 1;
                            const end = this.sum(start, limit * duration);
                            request['from'] = start;
                            request['to'] = end;
                        }
                    } else if (type === 'swap' || type === 'future') throw new NotSupported(this.id + ' fetchOHLCV () does not accept swap or future markets, only spot markets are allowed');
                    const response = await this.publicSpotGetSymbolsKline(this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"80d86378-ab4e-4c70-819e-b42146cf87ad",
                    //         "data":{
                    //             "klines":[
                    //                 {"last_price":"0.034987","timestamp":1598787420,"volume":"1.0198","open":"0.035007","close":"0.034987","high":"0.035007","low":"0.034986"},
                    //                 {"last_price":"0.034986","timestamp":1598787480,"volume":"0.3959","open":"0.034982","close":"0.034986","high":"0.034986","low":"0.034980"},
                    //                 {"last_price":"0.034978","timestamp":1598787540,"volume":"0.3259","open":"0.034987","close":"0.034978","high":"0.034987","low":"0.034977"},
                    //             ]
                    //         }
                    //     }
                    //
                    // swap
                    //
                    //     {
                    //         "errno":"OK",
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"32965074-5804-4655-b693-e953e36026a0",
                    //         "data":[
                    //             {"low":"404.4","high":"404.4","open":"404.4","close":"404.4","last_price":"404.4","avg_price":"404.4","volume":"7670","timestamp":1598758441,"rise_fall_rate":"0","rise_fall_value":"0","base_coin_volume":"76.7","quote_coin_volume":"31017.48"},
                    //             {"low":"404.1","high":"404.4","open":"404.4","close":"404.1","last_price":"404.1","avg_price":"404.15881086","volume":"12076","timestamp":1598758501,"rise_fall_rate":"-0.000741839762611276","rise_fall_value":"-0.3","base_coin_volume":"120.76","quote_coin_volume":"48806.2179994536"},
                    //             {"low":"404","high":"404.3","open":"404.1","close":"404","last_price":"404","avg_price":"404.08918918","volume":"740","timestamp":1598758561,"rise_fall_rate":"-0.000247463499133878","rise_fall_value":"-0.1","base_coin_volume":"7.4","quote_coin_volume":"2990.259999932"},
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const klines = this.safeValue(data, 'klines', []);
                    return this.parseOHLCVs(klines, market, timeframe, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades () requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchMyTrades', market, params);
                    if (marketType === 'swap' || marketType === 'future') throw new NotSupported(this.id + ' fetchMyTrades () does not accept swap or future markets, only spot markets are allowed');
                    const request = {};
                    if (market['spot']) {
                        request['symbol'] = market['id'];
                        request['offset'] = 1; // max offset * limit < 500
                        if (limit === undefined) limit = 100; // max 100
                        request['limit'] = limit;
                    } else if (market['swap'] || market['future']) throw new NotSupported(this.id + ' fetchMyTrades () does not accept swap or future markets, only spot markets are allowed');
                    const response = await this.privateSpotGetTrades(this.extend(request, query));
                    //
                    // spot
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"a06a5c53-8e6f-42d6-8082-2ff4718d221c",
                    //         "data":{
                    //             "current_page":1,
                    //             "trades":[
                    //                 {
                    //                     "detail_id":256348632,
                    //                     "order_id":2147484350,
                    //                     "symbol":"BTC_USDT",
                    //                     "create_time":1590462303000,
                    //                     "side":"buy",
                    //                     "fees":"0.00001350",
                    //                     "fee_coin_name":"BTC",
                    //                     "notional":"88.00000000",
                    //                     "price_avg":"8800.00",
                    //                     "size":"0.01000",
                    //                     "exec_type":"M"
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    // contract
                    //
                    //     {
                    //         "code": 1000,
                    //         "trace":"886fb6ae-456b-4654-b4e0-d681ac05cea1",
                    //         "message": "OK",
                    //         "data": {
                    //             "trades": [
                    //                 {
                    //                     "order_id": 10116361,
                    //                     "trade_id": 10116363,
                    //                     "contract_id": 1,
                    //                     "deal_price": "16",
                    //                     "deal_vol": "10",
                    //                     "make_fee": "0.04",
                    //                     "take_fee": "0.12",
                    //                     "created_at": null,
                    //                     "way": 5,
                    //                     "fluctuation": "0"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const trades = this.safeValue(data, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrderTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrderTrades', market, params);
                    if (marketType === 'swap' || marketType === 'future') throw new NotSupported(this.id + ' fetchOrderTrades () does not accept swap or future orders, only spot orders are allowed');
                    const request = {};
                    if (market['spot']) {
                        request['symbol'] = market['id'];
                        request['order_id'] = id;
                    } else if (market['swap'] || market['future']) throw new NotSupported(this.id + ' fetchOrderTrades () does not accept swap or future orders, only spot orders are allowed');
                    const response = await this.privateSpotGetTrades(this.extend(request, query));
                    //
                    // spot
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"a06a5c53-8e6f-42d6-8082-2ff4718d221c",
                    //         "data":{
                    //             "current_page":1,
                    //             "trades":[
                    //                 {
                    //                     "detail_id":256348632,
                    //                     "order_id":2147484350,
                    //                     "symbol":"BTC_USDT",
                    //                     "create_time":1590462303000,
                    //                     "side":"buy",
                    //                     "fees":"0.00001350",
                    //                     "fee_coin_name":"BTC",
                    //                     "notional":"88.00000000",
                    //                     "price_avg":"8800.00",
                    //                     "size":"0.01000",
                    //                     "exec_type":"M"
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    // contract
                    //
                    //     {
                    //         "code": 1000,
                    //         "trace":"886fb6ae-456b-4654-b4e0-d681ac05cea1",
                    //         "message": "OK",
                    //         "data": {
                    //             "trades": [
                    //                 {
                    //                     "order_id": 10116361,
                    //                     "trade_id": 10116363,
                    //                     "contract_id": 1,
                    //                     "deal_price": "16",
                    //                     "deal_vol": "10",
                    //                     "make_fee": "0.04",
                    //                     "take_fee": "0.12",
                    //                     "created_at": null,
                    //                     "way": 5,
                    //                     "fluctuation": "0"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const trades = this.safeValue(data, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseBalance(response) {
                    const data = this.safeValue(response, 'data', {});
                    const wallet = this.safeValue2(data, 'wallet', 'accounts', []);
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < wallet.length; i++){
                        const balance = wallet[i];
                        let currencyId = this.safeString2(balance, 'id', 'currency');
                        currencyId = this.safeString(balance, 'coin_code', currencyId);
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString2(balance, 'available', 'available_vol');
                        account['used'] = this.safeString2(balance, 'frozen', 'freeze_vol');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchBalance', undefined, params);
                    if (marketType === 'swap' || marketType === 'future') throw new NotSupported(this.id + ' fetchBalance () does not accept swap or future balances, only spot and account balances are allowed');
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateSpotGetWallet',
                        'account': 'privateAccountGetWallet'
                    });
                    const response = await this[method](query);
                    //
                    // spot
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"39069916-72f9-44c7-acde-2ad5afd21cad",
                    //         "data":{
                    //             "wallet":[
                    //                 {"id":"BTC","name":"Bitcoin","available":"0.00000062","frozen":"0.00000000"},
                    //                 {"id":"ETH","name":"Ethereum","available":"0.00002277","frozen":"0.00000000"},
                    //                 {"id":"BMX","name":"BitMart Token","available":"0.00000000","frozen":"0.00000000"}
                    //             ]
                    //         }
                    //     }
                    //
                    // account
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"5c3b7fc7-93b2-49ef-bb59-7fdc56915b59",
                    //         "data":{
                    //             "wallet":[
                    //                 {"currency":"BTC","name":"Bitcoin","available":"0.00000062","frozen":"0.00000000"},
                    //                 {"currency":"ETH","name":"Ethereum","available":"0.00002277","frozen":"0.00000000"}
                    //             ]
                    //         }
                    //     }
                    //
                    // contract
                    //
                    //     {
                    //         "code": 1000,
                    //         "trace":"886fb6ae-456b-4654-b4e0-d681ac05cea1",
                    //         "message": "OK",
                    //         "data": {
                    //             "accounts": [
                    //                 {
                    //                     "account_id": 10,
                    //                     "coin_code": "USDT",
                    //                     "freeze_vol": "1201.8",
                    //                     "available_vol": "8397.65",
                    //                     "cash_vol": "0",
                    //                     "realised_vol": "-0.5",
                    //                     "unrealised_vol": "-0.5",
                    //                     "earnings_vol": "-0.5",
                    //                     "created_at": "2018-07-13T16:48:49+08:00",
                    //                     "updated_at": "2018-07-13T18:34:45.900387+08:00"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    return this.parseBalance(response);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "order_id": 2707217580
                    //     }
                    //
                    // cancelOrder
                    //
                    //     '2707217580' // order id
                    //
                    // spot fetchOrder, fetchOrdersByStatus, fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "order_id":1736871726781,
                    //         "symbol":"BTC_USDT",
                    //         "create_time":1591096004000,
                    //         "side":"sell",
                    //         "type":"market",
                    //         "price":"0.00",
                    //         "price_avg":"0.00",
                    //         "size":"0.02000",
                    //         "notional":"0.00000000",
                    //         "filled_notional":"0.00000000",
                    //         "filled_size":"0.00000",
                    //         "status":"8"
                    //     }
                    //
                    // contract fetchOrder, fetchOrdersByStatus, fetchOpenOrders, fetchClosedOrders, fetchOrders
                    //
                    //     {
                    //         "order_id": 10539098,
                    //         "contract_id": 1,
                    //         "position_id": 10539088,
                    //         "account_id": 10,
                    //         "price": "16",
                    //         "vol": "1",
                    //         "done_avg_price": "16",
                    //         "done_vol": "1",
                    //         "way": 3,
                    //         "category": 1,
                    //         "open_type": 2,
                    //         "make_fee": "0.00025",
                    //         "take_fee": "0.012",
                    //         "origin": "",
                    //         "created_at": "2018-07-23T11:55:56.715305Z",
                    //         "finished_at": "2018-07-23T11:55:56.763941Z",
                    //         "status": 4,
                    //         "errno": 0
                    //     }
                    //
                    let id = undefined;
                    if (typeof order === 'string') {
                        id = order;
                        order = {};
                    }
                    id = this.safeString(order, 'order_id', id);
                    let timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    timestamp = this.safeInteger(order, 'create_time', timestamp);
                    const marketId = this.safeString2(order, 'symbol', 'contract_id');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    let status = undefined;
                    if (market !== undefined) status = this.parseOrderStatusByType(market['type'], this.safeString(order, 'status'));
                    const amount = this.safeString2(order, 'size', 'vol');
                    const filled = this.safeString2(order, 'filled_size', 'done_vol');
                    const average = this.safeString2(order, 'price_avg', 'done_avg_price');
                    const price = this.safeString(order, 'price');
                    const side = this.safeString2(order, 'way', 'side');
                    // 1 = Open long
                    // 2 = Close short
                    // 3 = Close long
                    // 4 = Open short
                    const category = this.safeInteger(order, 'category');
                    let type = this.safeString(order, 'type');
                    if (category === 1) type = 'limit';
                    else if (category === 2) type = 'market';
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'average': average,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                parseOrderStatusByType(type, status) {
                    const statusesByType = {
                        'spot': {
                            '1': 'failed',
                            '2': 'open',
                            '3': 'failed',
                            '4': 'open',
                            '5': 'open',
                            '6': 'closed',
                            '7': 'canceling',
                            '8': 'canceled'
                        },
                        'swap': {
                            '1': 'open',
                            '2': 'open',
                            '4': 'closed'
                        }
                    };
                    const statuses = this.safeValue(statusesByType, type, {});
                    return this.safeString(statuses, status, status);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {};
                    let method = undefined;
                    if (market['spot']) {
                        request['symbol'] = market['id'];
                        request['side'] = side;
                        request['type'] = type;
                        method = 'privateSpotPostSubmitOrder';
                        if (type === 'limit') {
                            request['size'] = this.amountToPrecision(symbol, amount);
                            request['price'] = this.priceToPrecision(symbol, price);
                        } else if (type === 'market') {
                            // for market buy it requires the amount of quote currency to spend
                            if (side === 'buy') {
                                let notional = this.safeNumber(params, 'notional');
                                const createMarketBuyOrderRequiresPrice = this.safeValue(this.options, 'createMarketBuyOrderRequiresPrice', true);
                                if (createMarketBuyOrderRequiresPrice) {
                                    if (price !== undefined) {
                                        if (notional === undefined) notional = amount * price;
                                    } else if (notional === undefined) throw new InvalidOrder(this.id + " createOrder () requires the price argument with market buy orders to calculate total order cost (amount to spend), where cost = amount * price. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount, or, alternatively, add .options['createMarketBuyOrderRequiresPrice'] = false and supply the total cost value in the 'amount' argument or in the 'notional' extra parameter (the exchange-specific behaviour)");
                                } else notional = notional === undefined ? amount : notional;
                                const precision = market['precision']['price'];
                                request['notional'] = this.decimalToPrecision(notional, TRUNCATE, precision, this.precisionMode);
                            } else if (side === 'sell') request['size'] = this.amountToPrecision(symbol, amount);
                        }
                    } else if (market['swap'] || market['future']) throw new NotSupported(this.id + ' createOrder () does not accept swap or future orders, only spot orders are allowed');
                    const timeInForce = this.safeString(params, 'timeInForce');
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    if (timeInForce !== undefined || postOnly || type === 'limit_maker' || type === 'ioc') {
                        if (timeInForce === 'FOK') throw new InvalidOrder(this.id + ' createOrder () only accepts timeInForce parameter values of IOC or PO');
                        const maker = timeInForce === 'PO' || postOnly || type === 'limit_maker';
                        const ioc = timeInForce === 'IOC' || type === 'ioc';
                        if (maker && ioc) throw new InvalidOrder(this.id + ' createOrder () does not accept IOC postOnly orders, the order cannot be both postOnly and IOC');
                        if (type === 'market') throw new InvalidOrder(this.id + ' createOrder () does not accept market postOnly orders or market IOC orders, only limit postOnly order or limit IOC orders are allowed');
                        if (maker) request['type'] = 'limit_maker';
                        else if (ioc) request['type'] = 'ioc';
                        params = this.omit(params, [
                            'timeInForce',
                            'postOnly'
                        ]);
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot and contract
                    //
                    //     {
                    //         "code": 1000,
                    //         "trace":"886fb6ae-456b-4654-b4e0-d681ac05cea1",
                    //         "message": "OK",
                    //         "data": {
                    //             "order_id": 2707217580
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder () requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {};
                    if (market['spot']) {
                        request['order_id'] = parseInt(id);
                        request['symbol'] = market['id'];
                    } else if (market['swap'] || market['future']) throw new NotSupported(this.id + ' cancelOrder () does not accept swap or future orders, only spot orders are allowed');
                    const response = await this.privateSpotPostCancelOrder(this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "code": 1000,
                    //         "trace":"886fb6ae-456b-4654-b4e0-d681ac05cea1",
                    //         "message": "OK",
                    //         "data": {
                    //             "result": true
                    //         }
                    //     }
                    //
                    // spot alternative
                    //
                    //     {
                    //         "code": 1000,
                    //         "trace":"886fb6ae-456b-4654-b4e0-d681ac05cea1",
                    //         "message": "OK",
                    //         "data": true
                    //     }
                    //
                    // contract
                    //
                    //     {
                    //         "code": 1000,
                    //         "trace":"886fb6ae-456b-4654-b4e0-d681ac05cea1",
                    //         "message": "OK",
                    //         "data": {
                    //             "succeed": [
                    //                 2707219612
                    //             ],
                    //             "failed": []
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    if (data === true) return this.parseOrder(id, market);
                    const succeeded = this.safeValue(data, 'succeed');
                    if (succeeded !== undefined) {
                        id = this.safeString(succeeded, 0);
                        if (id === undefined) throw new InvalidOrder(this.id + ' cancelOrder() failed to cancel ' + symbol + ' order id ' + id);
                    } else {
                        const result = this.safeValue(data, 'result');
                        if (!result) throw new InvalidOrder(this.id + ' cancelOrder() ' + symbol + ' order id ' + id + ' is filled or canceled');
                    }
                    const order = this.parseOrder(id, market);
                    return this.extend(order, {
                        'id': id
                    });
                }
                async cancelAllOrders(symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelAllOrders() requires a symbol argument');
                    const side = this.safeString(params, 'side');
                    if (side === undefined) throw new ArgumentsRequired1(this.id + " cancelAllOrders() requires a `side` parameter ('buy' or 'sell')");
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (!market['spot']) throw new NotSupported(this.id + ' cancelAllOrders() does not support ' + market['type'] + ' orders, only spot orders are accepted');
                    const request = {
                        'symbol': market['id'],
                        'side': side
                    };
                    const response = await this.privateSpotPostCancelOrders(this.extend(request, params));
                    //
                    //     {
                    //         "code": 1000,
                    //         "trace":"886fb6ae-456b-4654-b4e0-d681ac05cea1",
                    //         "message": "OK",
                    //         "data": {}
                    //     }
                    //
                    return response;
                }
                async fetchOrdersByStatus(status, symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrdersByStatus() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrdersByStatus', market, params);
                    if (marketType === 'swap' || marketType === 'future') throw new NotSupported(this.id + ' fetchOrdersByStatus () does not support swap or futures orders, only spot orders are allowed');
                    const request = {};
                    if (market['spot']) {
                        request['symbol'] = market['id'];
                        request['offset'] = 1; // max offset * limit < 500
                        request['limit'] = 100; // max limit is 100
                        //  1 = Order failure
                        //  2 = Placing order
                        //  3 = Order failure, Freeze failure
                        //  4 = Order success, Pending for fulfilment
                        //  5 = Partially filled
                        //  6 = Fully filled
                        //  7 = Canceling
                        //  8 = Canceled
                        //  9 = Outstanding (4 and 5)
                        // 10 = 6 and 8
                        if (status === 'open') request['status'] = 9;
                        else if (status === 'closed') request['status'] = 6;
                        else if (status === 'canceled') request['status'] = 8;
                        else request['status'] = status;
                    } else if (market['swap'] || market['future']) throw new NotSupported(this.id + ' fetchOrdersByStatus () does not support swap or futures orders, only spot orders are allowed');
                    const response = await this.privateSpotGetOrders(this.extend(request, query));
                    //
                    // spot
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"70e7d427-7436-4fb8-8cdd-97e1f5eadbe9",
                    //         "data":{
                    //             "current_page":1,
                    //             "orders":[
                    //                 {
                    //                     "order_id":2147601241,
                    //                     "symbol":"BTC_USDT",
                    //                     "create_time":1591099963000,
                    //                     "side":"sell",
                    //                     "type":"limit",
                    //                     "price":"9000.00",
                    //                     "price_avg":"0.00",
                    //                     "size":"1.00000",
                    //                     "notional":"9000.00000000",
                    //                     "filled_notional":"0.00000000",
                    //                     "filled_size":"0.00000",
                    //                     "status":"4"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    // contract
                    //
                    //     {
                    //         "code": 1000,
                    //         "trace":"886fb6ae-456b-4654-b4e0-d681ac05cea1",
                    //         "message": "OK",
                    //         "data": {
                    //             "orders": [
                    //                 {
                    //                     "order_id": 10284160,
                    //                     "contract_id": 1,
                    //                     "price": "8",
                    //                     "vol": "4",
                    //                     "done_avg_price": "0",
                    //                     "done_vol": "0",
                    //                     "way": 1,
                    //                     "category": 1,
                    //                     "open_type": 2,
                    //                     "make_fee": "0",
                    //                     "take_fee": "0",
                    //                     "origin": "",
                    //                     "created_at": "2018-07-17T07:24:13.410507Z",
                    //                     "finished_at": null,
                    //                     "status": 2,
                    //                     "errno": 0
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const orders = this.safeValue(data, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByStatus('open', symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByStatus('closed', symbol, since, limit, params);
                }
                async fetchCanceledOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByStatus('canceled', symbol, since, limit, params);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const request = {};
                    const market = this.market(symbol);
                    if (typeof id !== 'string') id = id.toString();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrder', market, params);
                    if (marketType === 'swap' || marketType === 'future') throw new NotSupported(this.id + ' fetchOrder () does not support swap or futures orders, only spot orders are allowed');
                    if (market['spot']) {
                        request['symbol'] = market['id'];
                        request['order_id'] = id;
                    } else if (market['swap'] || market['future']) throw new NotSupported(this.id + ' fetchOrder () does not support swap or futures orders, only spot orders are allowed');
                    const response = await this.privateSpotGetOrderDetail(this.extend(request, query));
                    //
                    // spot
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"a27c2cb5-ead4-471d-8455-1cfeda054ea6",
                    //         "data": {
                    //             "order_id":1736871726781,
                    //             "symbol":"BTC_USDT",
                    //             "create_time":1591096004000,
                    //             "side":"sell",
                    //             "type":"market",
                    //             "price":"0.00",
                    //             "price_avg":"0.00",
                    //             "size":"0.02000",
                    //             "notional":"0.00000000",
                    //             "filled_notional":"0.00000000",
                    //             "filled_size":"0.00000",
                    //             "status":"8"
                    //         }
                    //     }
                    //
                    // contract
                    //
                    //     {
                    //         "code": 1000,
                    //         "trace":"886fb6ae-456b-4654-b4e0-d681ac05cea1",
                    //         "message": "OK",
                    //         "data": {
                    //             "orders": [
                    //                 {
                    //                     "order_id": 10539098,
                    //                     "contract_id": 1,
                    //                     "position_id": 10539088,
                    //                     "account_id": 10,
                    //                     "price": "16",
                    //                     "vol": "1",
                    //                     "done_avg_price": "16",
                    //                     "done_vol": "1",
                    //                     "way": 3,
                    //                     "category": 1,
                    //                     "make_fee": "0.00025",
                    //                     "take_fee": "0.012",
                    //                     "origin": "",
                    //                     "created_at": "2018-07-23T11:55:56.715305Z",
                    //                     "finished_at": "2018-07-23T11:55:56.763941Z",
                    //                     "status": 4,
                    //                     "errno": 0
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    if ('orders' in data) {
                        const orders = this.safeValue(data, 'orders', []);
                        const firstOrder = this.safeValue(orders, 0);
                        if (firstOrder === undefined) throw new OrderNotFound(this.id + ' fetchOrder() could not find ' + symbol + ' order id ' + id);
                        return this.parseOrder(firstOrder, market);
                    } else return this.parseOrder(data, market);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    if (code === 'USDT') {
                        const defaultNetworks = this.safeValue(this.options, 'defaultNetworks');
                        const defaultNetwork = this.safeStringUpper(defaultNetworks, code);
                        const networks = this.safeValue(this.options, 'networks', {});
                        let network = this.safeStringUpper(params, 'network', defaultNetwork); // this line allows the user to specify either ERC20 or ETH
                        network = this.safeString(networks, network, network); // handle ERC20>ETH alias
                        if (network !== undefined) {
                            request['currency'] += '-' + network; // when network the currency need to be changed to currency + '-' + network https://developer-pro.bitmart.com/en/account/withdraw_apply.html on the end of page
                            params = this.omit(params, 'network');
                        }
                    }
                    const response = await this.privateAccountGetDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"0e6edd79-f77f-4251-abe5-83ba75d06c1a",
                    //         "data":{
                    //             "currency":"USDT-TRC20",
                    //             "chain":"USDT-TRC20",
                    //             "address":"TGR3ghy2b5VLbyAYrmiE15jasR6aPHTvC5",
                    //             "address_memo":""
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const address = this.safeString(data, 'address');
                    const tag = this.safeString(data, 'address_memo');
                    const chain = this.safeString(data, 'chain');
                    let network = undefined;
                    if (chain !== undefined) {
                        const parts = chain.split('-');
                        const networkId = this.safeString(parts, 1);
                        network = this.safeNetwork(networkId);
                    }
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': network,
                        'info': response
                    };
                }
                safeNetwork(networkId) {
                    // TODO: parse
                    return networkId;
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'amount': amount,
                        'destination': 'To Digital Address',
                        'address': address
                    };
                    if (tag !== undefined) request['address_memo'] = tag;
                    if (code === 'USDT') {
                        const defaultNetworks = this.safeValue(this.options, 'defaultNetworks');
                        const defaultNetwork = this.safeStringUpper(defaultNetworks, code);
                        const networks = this.safeValue(this.options, 'networks', {});
                        let network = this.safeStringUpper(params, 'network', defaultNetwork); // this line allows the user to specify either ERC20 or ETH
                        network = this.safeString(networks, network, network); // handle ERC20>ETH alias
                        if (network !== undefined) {
                            request['currency'] += '-' + network; // when network the currency need to be changed to currency + '-' + network https://developer-pro.bitmart.com/en/account/withdraw_apply.html on the end of page
                            params = this.omit(params, 'network');
                        }
                    }
                    const response = await this.privateAccountPostWithdrawApply(this.extend(request, params));
                    //
                    //     {
                    //         "code": 1000,
                    //         "trace":"886fb6ae-456b-4654-b4e0-d681ac05cea1",
                    //         "message": "OK",
                    //         "data": {
                    //             "withdraw_id": "121212"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const transaction = this.parseTransaction(data, currency);
                    return this.extend(transaction, {
                        'code': code,
                        'address': address,
                        'tag': tag
                    });
                }
                async fetchTransactionsByType(type, code, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (limit === undefined) limit = 50; // max 50
                    const request = {
                        'operation_type': type,
                        'offset': 1,
                        'limit': limit
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    const response = await this.privateAccountGetDepositWithdrawHistory(this.extend(request, params));
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"142bf92a-fc50-4689-92b6-590886f90b97",
                    //         "data":{
                    //             "records":[
                    //                 {
                    //                     "withdraw_id":"1679952",
                    //                     "deposit_id":"",
                    //                     "operation_type":"withdraw",
                    //                     "currency":"BMX",
                    //                     "apply_time":1588867374000,
                    //                     "arrival_amount":"59.000000000000",
                    //                     "fee":"1.000000000000",
                    //                     "status":0,
                    //                     "address":"0xe57b69a8776b37860407965B73cdFFBDFe668Bb5",
                    //                     "address_memo":"",
                    //                     "tx_id":""
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const records = this.safeValue(data, 'records', []);
                    return this.parseTransactions(records, currency, since, limit);
                }
                async fetchDeposit(id, code, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateAccountGetDepositWithdrawDetail(this.extend(request, params));
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"f7f74924-14da-42a6-b7f2-d3799dd9a612",
                    //         "data":{
                    //             "record":{
                    //                 "withdraw_id":"",
                    //                 "deposit_id":"1679952",
                    //                 "operation_type":"deposit",
                    //                 "currency":"BMX",
                    //                 "apply_time":1588867374000,
                    //                 "arrival_amount":"59.000000000000",
                    //                 "fee":"1.000000000000",
                    //                 "status":0,
                    //                 "address":"0xe57b69a8776b37860407965B73cdFFBDFe668Bb5",
                    //                 "address_memo":"",
                    //                 "tx_id":""
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const record = this.safeValue(data, 'record', {});
                    return this.parseTransaction(record);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    return await this.fetchTransactionsByType('deposit', code, since, limit, params);
                }
                async fetchWithdrawal(id, code, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateAccountGetDepositWithdrawDetail(this.extend(request, params));
                    //
                    //     {
                    //         "message":"OK",
                    //         "code":1000,
                    //         "trace":"f7f74924-14da-42a6-b7f2-d3799dd9a612",
                    //         "data":{
                    //             "record":{
                    //                 "withdraw_id":"1679952",
                    //                 "deposit_id":"",
                    //                 "operation_type":"withdraw",
                    //                 "currency":"BMX",
                    //                 "apply_time":1588867374000,
                    //                 "arrival_amount":"59.000000000000",
                    //                 "fee":"1.000000000000",
                    //                 "status":0,
                    //                 "address":"0xe57b69a8776b37860407965B73cdFFBDFe668Bb5",
                    //                 "address_memo":"",
                    //                 "tx_id":""
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const record = this.safeValue(data, 'record', {});
                    return this.parseTransaction(record);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    return await this.fetchTransactionsByType('withdraw', code, since, limit, params);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        '0': 'pending',
                        '1': 'pending',
                        '2': 'pending',
                        '3': 'ok',
                        '4': 'canceled',
                        '5': 'failed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "withdraw_id": "121212"
                    //     }
                    //
                    // fetchDeposits, fetchWithdrawals, fetchWithdrawal
                    //
                    //     {
                    //         "withdraw_id":"1679952",
                    //         "deposit_id":"",
                    //         "operation_type":"withdraw",
                    //         "currency":"BMX",
                    //         "apply_time":1588867374000,
                    //         "arrival_amount":"59.000000000000",
                    //         "fee":"1.000000000000",
                    //         "status":0,
                    //         "address":"0xe57b69a8776b37860407965B73cdFFBDFe668Bb5",
                    //         "address_memo":"",
                    //         "tx_id":""
                    //     }
                    //
                    let id = undefined;
                    const withdrawId = this.safeString(transaction, 'withdraw_id');
                    const depositId = this.safeString(transaction, 'deposit_id');
                    let type = undefined;
                    if (withdrawId !== undefined && withdrawId !== '') {
                        type = 'withdraw';
                        id = withdrawId;
                    } else if (depositId !== undefined && depositId !== '') {
                        type = 'deposit';
                        id = depositId;
                    }
                    const amount = this.safeNumber(transaction, 'arrival_amount');
                    const timestamp = this.safeInteger(transaction, 'apply_time');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const feeCost = this.safeNumber(transaction, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    let txid = this.safeString(transaction, 'tx_id');
                    if (txid === '') txid = undefined;
                    const address = this.safeString(transaction, 'address');
                    const tag = this.safeString(transaction, 'address_memo');
                    return {
                        'info': transaction,
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': undefined,
                        'address': address,
                        'addressFrom': undefined,
                        'addressTo': undefined,
                        'tag': tag,
                        'tagFrom': undefined,
                        'tagTo': undefined,
                        'status': status,
                        'type': type,
                        'updated': undefined,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': fee
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const access = this.safeString(api, 0);
                    const type = this.safeString(api, 1);
                    const baseUrl = this.implodeHostname(this.urls['api']['rest']);
                    let url = baseUrl + '/' + type;
                    if (type !== 'system') url += '/' + this.version;
                    url += '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    let queryString = '';
                    const getOrDelete = method === 'GET' || method === 'DELETE';
                    if (getOrDelete) {
                        if (Object.keys(query).length) {
                            queryString = this.urlencode(query);
                            url += '?' + queryString;
                        }
                    }
                    if (access === 'private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.milliseconds().toString();
                        headers = {
                            'X-BM-KEY': this.apiKey,
                            'X-BM-TIMESTAMP': timestamp,
                            'Content-Type': 'application/json'
                        };
                        if (!getOrDelete) {
                            body = this.json(query);
                            queryString = body;
                        }
                        const auth = timestamp + '#' + this.uid + '#' + queryString;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                        headers['X-BM-SIGN'] = signature;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    // spot
                    //
                    //     {"message":"Bad Request [to is empty]","code":50000,"trace":"f9d46e1b-4edb-4d07-a06e-4895fb2fc8fc","data":{}}
                    //     {"message":"Bad Request [from is empty]","code":50000,"trace":"579986f7-c93a-4559-926b-06ba9fa79d76","data":{}}
                    //     {"message":"Kline size over 500","code":50004,"trace":"d625caa8-e8ca-4bd2-b77c-958776965819","data":{}}
                    //     {"message":"Balance not enough","code":50020,"trace":"7c709d6a-3292-462c-98c5-32362540aeef","data":{}}
                    //
                    // contract
                    //
                    //     {"errno":"OK","message":"INVALID_PARAMETER","code":49998,"trace":"eb5ebb54-23cd-4de2-9064-e090b6c3b2e3","data":null}
                    //
                    const message = this.safeString(response, 'message');
                    const errorCode = this.safeString(response, 'code');
                    if (errorCode !== undefined && errorCode !== '1000' || message !== undefined && message !== 'OK') {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], errorCode, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    39: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const { AuthenticationError: AuthenticationError, BadRequest: BadRequest, DDoSProtection: DDoSProtection, ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, PermissionDenied: PermissionDenied, ArgumentsRequired: ArgumentsRequired1, BadSymbol: BadSymbol } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bitmex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitmex',
                        'name': 'BitMEX',
                        'countries': [
                            'SC'
                        ],
                        'version': 'v1',
                        'userAgent': undefined,
                        'rateLimit': 2000,
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': false,
                            'margin': false,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchIndexOHLCV': false,
                            'fetchLedger': true,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPositions': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTransactions': 'emulated',
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '1h': '1h',
                            '1d': '1d'
                        },
                        'urls': {
                            'test': {
                                'public': 'https://testnet.bitmex.com',
                                'private': 'https://testnet.bitmex.com'
                            },
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766319-f653c6e6-5ed4-11e7-933d-f0bc3699ae8f.jpg',
                            'api': {
                                'public': 'https://www.bitmex.com',
                                'private': 'https://www.bitmex.com'
                            },
                            'www': 'https://www.bitmex.com',
                            'doc': [
                                'https://www.bitmex.com/app/apiOverview',
                                'https://github.com/BitMEX/api-connectors/tree/master/official-http'
                            ],
                            'fees': 'https://www.bitmex.com/app/fees',
                            'referral': 'https://www.bitmex.com/register/upZpOX'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'announcement',
                                    'announcement/urgent',
                                    'funding',
                                    'instrument',
                                    'instrument/active',
                                    'instrument/activeAndIndices',
                                    'instrument/activeIntervals',
                                    'instrument/compositeIndex',
                                    'instrument/indices',
                                    'insurance',
                                    'leaderboard',
                                    'liquidation',
                                    'orderBook',
                                    'orderBook/L2',
                                    'quote',
                                    'quote/bucketed',
                                    'schema',
                                    'schema/websocketHelp',
                                    'settlement',
                                    'stats',
                                    'stats/history',
                                    'trade',
                                    'trade/bucketed'
                                ]
                            },
                            'private': {
                                'get': [
                                    'apiKey',
                                    'chat',
                                    'chat/channels',
                                    'chat/connected',
                                    'execution',
                                    'execution/tradeHistory',
                                    'notification',
                                    'order',
                                    'position',
                                    'user',
                                    'user/affiliateStatus',
                                    'user/checkReferralCode',
                                    'user/commission',
                                    'user/depositAddress',
                                    'user/executionHistory',
                                    'user/margin',
                                    'user/minWithdrawalFee',
                                    'user/wallet',
                                    'user/walletHistory',
                                    'user/walletSummary'
                                ],
                                'post': [
                                    'apiKey',
                                    'apiKey/disable',
                                    'apiKey/enable',
                                    'chat',
                                    'order',
                                    'order/bulk',
                                    'order/cancelAllAfter',
                                    'order/closePosition',
                                    'position/isolate',
                                    'position/leverage',
                                    'position/riskLimit',
                                    'position/transferMargin',
                                    'user/cancelWithdrawal',
                                    'user/confirmEmail',
                                    'user/confirmEnableTFA',
                                    'user/confirmWithdrawal',
                                    'user/disableTFA',
                                    'user/logout',
                                    'user/logoutAll',
                                    'user/preferences',
                                    'user/requestEnableTFA',
                                    'user/requestWithdrawal'
                                ],
                                'put': [
                                    'order',
                                    'order/bulk',
                                    'user'
                                ],
                                'delete': [
                                    'apiKey',
                                    'order',
                                    'order/all'
                                ]
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'Invalid API Key.': AuthenticationError,
                                'This key is disabled.': PermissionDenied,
                                'Access Denied': PermissionDenied,
                                'Duplicate clOrdID': InvalidOrder,
                                'orderQty is invalid': InvalidOrder,
                                'Invalid price': InvalidOrder,
                                'Invalid stopPx for ordType': InvalidOrder
                            },
                            'broad': {
                                'Signature not valid': AuthenticationError,
                                'overloaded': ExchangeNotAvailable,
                                'Account has insufficient Available Balance': InsufficientFunds,
                                'Service unavailable': ExchangeNotAvailable,
                                'Server Error': ExchangeError1,
                                'Unable to cancel order due to existing state': InvalidOrder
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'options': {
                            // https://blog.bitmex.com/api_announcement/deprecation-of-api-nonce-header/
                            // https://github.com/ccxt/ccxt/issues/4789
                            'api-expires': 5,
                            'fetchOHLCVOpenTimestamp': true
                        },
                        'commonCurrencies': {
                            'USDt': 'USDT',
                            'XBt': 'BTC',
                            'XBT': 'BTC'
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetInstrumentActiveAndIndices(params);
                    //
                    //    {
                    //        "symbol": "LTCUSDT",
                    //        "rootSymbol": "LTC",
                    //        "state": "Open",
                    //        "typ": "FFWCSX",
                    //        "listing": "2021-11-10T04:00:00.000Z",
                    //        "front": "2021-11-10T04:00:00.000Z",
                    //        "expiry": null,
                    //        "settle": null,
                    //        "listedSettle": null,
                    //        "relistInterval": null,
                    //        "inverseLeg": "",
                    //        "sellLeg": "",
                    //        "buyLeg": "",
                    //        "optionStrikePcnt": null,
                    //        "optionStrikeRound": null,
                    //        "optionStrikePrice": null,
                    //        "optionMultiplier": null,
                    //        "positionCurrency": "LTC",
                    //        "underlying": "LTC",
                    //        "quoteCurrency": "USDT",
                    //        "underlyingSymbol": "LTCT=",
                    //        "reference": "BMEX",
                    //        "referenceSymbol": ".BLTCT",
                    //        "calcInterval": null,
                    //        "publishInterval": null,
                    //        "publishTime": null,
                    //        "maxOrderQty": 1000000000,
                    //        "maxPrice": 1000000,
                    //        "lotSize": 1000,
                    //        "tickSize": 0.01,
                    //        "multiplier": 100,
                    //        "settlCurrency": "USDt",
                    //        "underlyingToPositionMultiplier": 10000,
                    //        "underlyingToSettleMultiplier": null,
                    //        "quoteToSettleMultiplier": 1000000,
                    //        "isQuanto": false,
                    //        "isInverse": false,
                    //        "initMargin": 0.03,
                    //        "maintMargin": 0.015,
                    //        "riskLimit": 1000000000000,
                    //        "riskStep": 1000000000000,
                    //        "limit": null,
                    //        "capped": false,
                    //        "taxed": true,
                    //        "deleverage": true,
                    //        "makerFee": -0.0001,
                    //        "takerFee": 0.0005,
                    //        "settlementFee": 0,
                    //        "insuranceFee": 0,
                    //        "fundingBaseSymbol": ".LTCBON8H",
                    //        "fundingQuoteSymbol": ".USDTBON8H",
                    //        "fundingPremiumSymbol": ".LTCUSDTPI8H",
                    //        "fundingTimestamp": "2022-01-14T20:00:00.000Z",
                    //        "fundingInterval": "2000-01-01T08:00:00.000Z",
                    //        "fundingRate": 0.0001,
                    //        "indicativeFundingRate": 0.0001,
                    //        "rebalanceTimestamp": null,
                    //        "rebalanceInterval": null,
                    //        "openingTimestamp": "2022-01-14T17:00:00.000Z",
                    //        "closingTimestamp": "2022-01-14T18:00:00.000Z",
                    //        "sessionInterval": "2000-01-01T01:00:00.000Z",
                    //        "prevClosePrice": 138.511,
                    //        "limitDownPrice": null,
                    //        "limitUpPrice": null,
                    //        "bankruptLimitDownPrice": null,
                    //        "bankruptLimitUpPrice": null,
                    //        "prevTotalVolume": 12699024000,
                    //        "totalVolume": 12702160000,
                    //        "volume": 3136000,
                    //        "volume24h": 114251000,
                    //        "prevTotalTurnover": 232418052349000,
                    //        "totalTurnover": 232463353260000,
                    //        "turnover": 45300911000,
                    //        "turnover24h": 1604331340000,
                    //        "homeNotional24h": 11425.1,
                    //        "foreignNotional24h": 1604331.3400000003,
                    //        "prevPrice24h": 135.48,
                    //        "vwap": 140.42165,
                    //        "highPrice": 146.42,
                    //        "lowPrice": 135.08,
                    //        "lastPrice": 144.36,
                    //        "lastPriceProtected": 144.36,
                    //        "lastTickDirection": "MinusTick",
                    //        "lastChangePcnt": 0.0655,
                    //        "bidPrice": 143.75,
                    //        "midPrice": 143.855,
                    //        "askPrice": 143.96,
                    //        "impactBidPrice": 143.75,
                    //        "impactMidPrice": 143.855,
                    //        "impactAskPrice": 143.96,
                    //        "hasLiquidity": true,
                    //        "openInterest": 38103000,
                    //        "openValue": 547963053300,
                    //        "fairMethod": "FundingRate",
                    //        "fairBasisRate": 0.1095,
                    //        "fairBasis": 0.004,
                    //        "fairPrice": 143.811,
                    //        "markMethod": "FairPrice",
                    //        "markPrice": 143.811,
                    //        "indicativeTaxRate": null,
                    //        "indicativeSettlePrice": 143.807,
                    //        "optionUnderlyingPrice": null,
                    //        "settledPriceAdjustmentRate": null,
                    //        "settledPrice": null,
                    //        "timestamp": "2022-01-14T17:49:55.000Z"
                    //    }
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'symbol');
                        const baseId = this.safeString(market, 'underlying');
                        const quoteId = this.safeString(market, 'quoteCurrency');
                        const settleId = this.safeString(market, 'settlCurrency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const settle = this.safeCurrencyCode(settleId);
                        const basequote = baseId + quoteId;
                        const swap = id === basequote;
                        // 'positionCurrency' may be empty ("", as Bitmex currently returns for ETHUSD)
                        // so let's take the quote currency first and then adjust if needed
                        let type = undefined;
                        let future = false;
                        let prediction = false;
                        let index = false;
                        let symbol = base + '/' + quote + ':' + settle;
                        const expiryDatetime = this.safeString(market, 'expiry');
                        const expiry = this.parse8601(expiryDatetime);
                        const inverse = this.safeValue(market, 'isInverse');
                        const status = this.safeString(market, 'state');
                        let active = status !== 'Unlisted';
                        if (swap) type = 'swap';
                        else if (id.indexOf('B_') >= 0) {
                            prediction = true;
                            type = 'prediction';
                            symbol = id;
                        } else if (expiry !== undefined) {
                            future = true;
                            type = 'future';
                            symbol = symbol + '-' + this.yymmdd(expiry);
                        } else {
                            index = true;
                            type = 'index';
                            symbol = id;
                            active = false;
                        }
                        const positionId = this.safeString2(market, 'positionCurrency', 'quoteCurrency');
                        const position = this.safeCurrencyCode(positionId);
                        const positionIsQuote = position === quote;
                        const maxOrderQty = this.safeNumber(market, 'maxOrderQty');
                        const contract = !index;
                        const initMargin = this.safeString(market, 'initMargin', '1');
                        const maxLeverage = this.parseNumber(Precise.stringDiv('1', initMargin));
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': type,
                            'spot': false,
                            'margin': false,
                            'swap': swap,
                            'future': future,
                            'option': false,
                            'prediction': prediction,
                            'index': index,
                            'active': active,
                            'contract': contract,
                            'linear': contract ? !inverse : undefined,
                            'inverse': contract ? inverse : undefined,
                            'taker': this.safeNumber(market, 'takerFee'),
                            'maker': this.safeNumber(market, 'makerFee'),
                            'contractSize': this.safeNumber(market, 'multiplier'),
                            'expiry': expiry,
                            'expiryDatetime': expiryDatetime,
                            'strike': this.safeNumber(market, 'optionStrikePrice'),
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(market, 'lotSize'),
                                'price': this.safeNumber(market, 'tickSize')
                            },
                            'limits': {
                                'leverage': {
                                    'min': contract ? this.parseNumber('1') : undefined,
                                    'max': contract ? maxLeverage : undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': positionIsQuote ? undefined : maxOrderQty
                                },
                                'price': {
                                    'min': undefined,
                                    'max': this.safeNumber(market, 'maxPrice')
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': positionIsQuote ? maxOrderQty : undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    //
                    //     [
                    //         {
                    //             "account":1455728,
                    //             "currency":"XBt",
                    //             "riskLimit":1000000000000,
                    //             "prevState":"",
                    //             "state":"",
                    //             "action":"",
                    //             "amount":263542,
                    //             "pendingCredit":0,
                    //             "pendingDebit":0,
                    //             "confirmedDebit":0,
                    //             "prevRealisedPnl":0,
                    //             "prevUnrealisedPnl":0,
                    //             "grossComm":0,
                    //             "grossOpenCost":0,
                    //             "grossOpenPremium":0,
                    //             "grossExecCost":0,
                    //             "grossMarkValue":0,
                    //             "riskValue":0,
                    //             "taxableMargin":0,
                    //             "initMargin":0,
                    //             "maintMargin":0,
                    //             "sessionMargin":0,
                    //             "targetExcessMargin":0,
                    //             "varMargin":0,
                    //             "realisedPnl":0,
                    //             "unrealisedPnl":0,
                    //             "indicativeTax":0,
                    //             "unrealisedProfit":0,
                    //             "syntheticMargin":null,
                    //             "walletBalance":263542,
                    //             "marginBalance":263542,
                    //             "marginBalancePcnt":1,
                    //             "marginLeverage":0,
                    //             "marginUsedPcnt":0,
                    //             "excessMargin":263542,
                    //             "excessMarginPcnt":1,
                    //             "availableMargin":263542,
                    //             "withdrawableMargin":263542,
                    //             "timestamp":"2020-08-03T12:01:01.246Z",
                    //             "grossLastValue":0,
                    //             "commission":null
                    //         }
                    //     ]
                    //
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        let free = this.safeString(balance, 'availableMargin');
                        let total = this.safeString(balance, 'marginBalance');
                        if (code === 'BTC') {
                            free = Precise.stringDiv(free, '1e8');
                            total = Precise.stringDiv(total, '1e8');
                        }
                        account['free'] = free;
                        account['total'] = total;
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'currency': 'all'
                    };
                    const response = await this.privateGetUserMargin(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "account":1455728,
                    //             "currency":"XBt",
                    //             "riskLimit":1000000000000,
                    //             "prevState":"",
                    //             "state":"",
                    //             "action":"",
                    //             "amount":263542,
                    //             "pendingCredit":0,
                    //             "pendingDebit":0,
                    //             "confirmedDebit":0,
                    //             "prevRealisedPnl":0,
                    //             "prevUnrealisedPnl":0,
                    //             "grossComm":0,
                    //             "grossOpenCost":0,
                    //             "grossOpenPremium":0,
                    //             "grossExecCost":0,
                    //             "grossMarkValue":0,
                    //             "riskValue":0,
                    //             "taxableMargin":0,
                    //             "initMargin":0,
                    //             "maintMargin":0,
                    //             "sessionMargin":0,
                    //             "targetExcessMargin":0,
                    //             "varMargin":0,
                    //             "realisedPnl":0,
                    //             "unrealisedPnl":0,
                    //             "indicativeTax":0,
                    //             "unrealisedProfit":0,
                    //             "syntheticMargin":null,
                    //             "walletBalance":263542,
                    //             "marginBalance":263542,
                    //             "marginBalancePcnt":1,
                    //             "marginLeverage":0,
                    //             "marginUsedPcnt":0,
                    //             "excessMargin":263542,
                    //             "excessMarginPcnt":1,
                    //             "availableMargin":263542,
                    //             "withdrawableMargin":263542,
                    //             "timestamp":"2020-08-03T12:01:01.246Z",
                    //             "grossLastValue":0,
                    //             "commission":null
                    //         }
                    //     ]
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['depth'] = limit;
                    const response = await this.publicGetOrderBookL2(this.extend(request, params));
                    const result = {
                        'symbol': symbol,
                        'bids': [],
                        'asks': [],
                        'timestamp': undefined,
                        'datetime': undefined,
                        'nonce': undefined
                    };
                    for(let i = 0; i < response.length; i++){
                        const order = response[i];
                        const side = order['side'] === 'Sell' ? 'asks' : 'bids';
                        const amount = this.safeNumber(order, 'size');
                        const price = this.safeNumber(order, 'price');
                        // https://github.com/ccxt/ccxt/issues/4926
                        // https://github.com/ccxt/ccxt/issues/4927
                        // the exchange sometimes returns null price in the orderbook
                        if (price !== undefined) result[side].push([
                            price,
                            amount
                        ]);
                    }
                    result['bids'] = this.sortBy(result['bids'], 0, true);
                    result['asks'] = this.sortBy(result['asks'], 0);
                    return result;
                }
                async fetchOrder(id, symbol, params = {}) {
                    const filter = {
                        'filter': {
                            'orderID': id
                        }
                    };
                    const response = await this.fetchOrders(symbol, undefined, undefined, this.deepExtend(filter, params));
                    const numResults = response.length;
                    if (numResults === 1) return response[0];
                    throw new OrderNotFound(this.id + ': The order ' + id + ' not found.');
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    let request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['startTime'] = this.iso8601(since);
                    if (limit !== undefined) request['count'] = limit;
                    request = this.deepExtend(request, params);
                    // why the hassle? urlencode in python is kinda broken for nested dicts.
                    // E.g. self.urlencode({"filter": {"open": True}}) will return "filter={'open':+True}"
                    // Bitmex doesn't like that. Hence resorting to this hack.
                    if ('filter' in request) request['filter'] = this.json(request['filter']);
                    const response = await this.privateGetOrder(request);
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'filter': {
                            'open': true
                        }
                    };
                    return await this.fetchOrders(symbol, since, limit, this.deepExtend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    // Bitmex barfs if you set 'open': false in the filter...
                    const orders = await this.fetchOrders(symbol, since, limit, params);
                    return this.filterBy(orders, 'status', 'closed');
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    let request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['startTime'] = this.iso8601(since);
                    if (limit !== undefined) request['count'] = limit;
                    request = this.deepExtend(request, params);
                    // why the hassle? urlencode in python is kinda broken for nested dicts.
                    // E.g. self.urlencode({"filter": {"open": True}}) will return "filter={'open':+True}"
                    // Bitmex doesn't like that. Hence resorting to this hack.
                    if ('filter' in request) request['filter'] = this.json(request['filter']);
                    const response = await this.privateGetExecutionTradeHistory(request);
                    //
                    //     [
                    //         {
                    //             "execID": "string",
                    //             "orderID": "string",
                    //             "clOrdID": "string",
                    //             "clOrdLinkID": "string",
                    //             "account": 0,
                    //             "symbol": "string",
                    //             "side": "string",
                    //             "lastQty": 0,
                    //             "lastPx": 0,
                    //             "underlyingLastPx": 0,
                    //             "lastMkt": "string",
                    //             "lastLiquidityInd": "string",
                    //             "simpleOrderQty": 0,
                    //             "orderQty": 0,
                    //             "price": 0,
                    //             "displayQty": 0,
                    //             "stopPx": 0,
                    //             "pegOffsetValue": 0,
                    //             "pegPriceType": "string",
                    //             "currency": "string",
                    //             "settlCurrency": "string",
                    //             "execType": "string",
                    //             "ordType": "string",
                    //             "timeInForce": "string",
                    //             "execInst": "string",
                    //             "contingencyType": "string",
                    //             "exDestination": "string",
                    //             "ordStatus": "string",
                    //             "triggered": "string",
                    //             "workingIndicator": true,
                    //             "ordRejReason": "string",
                    //             "simpleLeavesQty": 0,
                    //             "leavesQty": 0,
                    //             "simpleCumQty": 0,
                    //             "cumQty": 0,
                    //             "avgPx": 0,
                    //             "commission": 0,
                    //             "tradePublishIndicator": "string",
                    //             "multiLegReportingType": "string",
                    //             "text": "string",
                    //             "trdMatchID": "string",
                    //             "execCost": 0,
                    //             "execComm": 0,
                    //             "homeNotional": 0,
                    //             "foreignNotional": 0,
                    //             "transactTime": "2019-03-05T12:47:02.762Z",
                    //             "timestamp": "2019-03-05T12:47:02.762Z"
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'Withdrawal': 'transaction',
                        'RealisedPNL': 'margin',
                        'UnrealisedPNL': 'margin',
                        'Deposit': 'transaction',
                        'Transfer': 'transfer',
                        'AffiliatePayout': 'referral'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     {
                    //         transactID: "69573da3-7744-5467-3207-89fd6efe7a47",
                    //         account:  24321,
                    //         currency: "XBt",
                    //         transactType: "Withdrawal", // "AffiliatePayout", "Transfer", "Deposit", "RealisedPNL", ...
                    //         amount:  -1000000,
                    //         fee:  300000,
                    //         transactStatus: "Completed", // "Canceled", ...
                    //         address: "1Ex4fkF4NhQaQdRWNoYpqiPbDBbq18Kdd9",
                    //         tx: "3BMEX91ZhhKoWtsH9QRb5dNXnmnGpiEetA",
                    //         text: "",
                    //         transactTime: "2017-03-21T20:05:14.388Z",
                    //         walletBalance:  0, // balance after
                    //         marginBalance:  null,
                    //         timestamp: "2017-03-22T13:09:23.514Z"
                    //     }
                    //
                    // ButMEX returns the unrealized pnl from the wallet history endpoint.
                    // The unrealized pnl transaction has an empty timestamp.
                    // It is not related to historical pnl it has status set to "Pending".
                    // Therefore it's not a part of the history at all.
                    // https://github.com/ccxt/ccxt/issues/6047
                    //
                    //     {
                    //         "transactID":"00000000-0000-0000-0000-000000000000",
                    //         "account":121210,
                    //         "currency":"XBt",
                    //         "transactType":"UnrealisedPNL",
                    //         "amount":-5508,
                    //         "fee":0,
                    //         "transactStatus":"Pending",
                    //         "address":"XBTUSD",
                    //         "tx":"",
                    //         "text":"",
                    //         "transactTime":null,  # ←---------------------------- null
                    //         "walletBalance":139198767,
                    //         "marginBalance":139193259,
                    //         "timestamp":null  # ←---------------------------- null
                    //     }
                    //
                    const id = this.safeString(item, 'transactID');
                    const account = this.safeString(item, 'account');
                    const referenceId = this.safeString(item, 'tx');
                    const referenceAccount = undefined;
                    const type = this.parseLedgerEntryType(this.safeString(item, 'transactType'));
                    const currencyId = this.safeString(item, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    let amount = this.safeNumber(item, 'amount');
                    if (amount !== undefined) amount = amount / 100000000;
                    let timestamp = this.parse8601(this.safeString(item, 'transactTime'));
                    if (timestamp === undefined) // https://github.com/ccxt/ccxt/issues/6047
                    // set the timestamp to zero, 1970 Jan 1 00:00:00
                    // for unrealized pnl and other transactions without a timestamp
                    timestamp = 0; // see comments above
                    let feeCost = this.safeNumber(item, 'fee', 0);
                    if (feeCost !== undefined) feeCost = feeCost / 100000000;
                    const fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    let after = this.safeNumber(item, 'walletBalance');
                    if (after !== undefined) after = after / 100000000;
                    const before = this.sum(after, -amount);
                    let direction = undefined;
                    if (amount < 0) {
                        direction = 'out';
                        amount = Math.abs(amount);
                    } else direction = 'in';
                    const status = this.parseTransactionStatus(this.safeString(item, 'transactStatus'));
                    return {
                        'id': id,
                        'info': item,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'direction': direction,
                        'account': account,
                        'referenceId': referenceId,
                        'referenceAccount': referenceAccount,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'before': before,
                        'after': after,
                        'status': status,
                        'fee': fee
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const request = {
                    };
                    //
                    //     if (since !== undefined) {
                    //         // date-based pagination not supported
                    //     }
                    //
                    if (limit !== undefined) request['count'] = limit;
                    const response = await this.privateGetUserWalletHistory(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             transactID: "69573da3-7744-5467-3207-89fd6efe7a47",
                    //             account:  24321,
                    //             currency: "XBt",
                    //             transactType: "Withdrawal", // "AffiliatePayout", "Transfer", "Deposit", "RealisedPNL", ...
                    //             amount:  -1000000,
                    //             fee:  300000,
                    //             transactStatus: "Completed", // "Canceled", ...
                    //             address: "1Ex4fkF4NhQaQdRWNoYpqiPbDBbq18Kdd9",
                    //             tx: "3BMEX91ZhhKoWtsH9QRb5dNXnmnGpiEetA",
                    //             text: "",
                    //             transactTime: "2017-03-21T20:05:14.388Z",
                    //             walletBalance:  0, // balance after
                    //             marginBalance:  null,
                    //             timestamp: "2017-03-22T13:09:23.514Z"
                    //         }
                    //     ]
                    //
                    return this.parseLedger(response, currency, since, limit);
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    //
                    //     if (since !== undefined) {
                    //         // date-based pagination not supported
                    //     }
                    //
                    if (limit !== undefined) request['count'] = limit;
                    const response = await this.privateGetUserWalletHistory(this.extend(request, params));
                    const transactions = this.filterByArray(response, 'transactType', [
                        'Withdrawal',
                        'Deposit'
                    ], false);
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    return this.parseTransactions(transactions, currency, since, limit);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'Canceled': 'canceled',
                        'Completed': 'ok',
                        'Pending': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    //   {
                    //      'transactID': 'ffe699c2-95ee-4c13-91f9-0faf41daec25',
                    //      'account': 123456,
                    //      'currency': 'XBt',
                    //      'transactType': 'Withdrawal',
                    //      'amount': -100100000,
                    //      'fee': 100000,
                    //      'transactStatus': 'Completed',
                    //      'address': '385cR5DM96n1HvBDMzLHPYcw89fZAXULJP',
                    //      'tx': '3BMEXabcdefghijklmnopqrstuvwxyz123',
                    //      'text': '',
                    //      'transactTime': '2019-01-02T01:00:00.000Z',
                    //      'walletBalance': 99900000,
                    //      'marginBalance': None,
                    //      'timestamp': '2019-01-02T13:00:00.000Z'
                    //   }
                    //
                    const id = this.safeString(transaction, 'transactID');
                    // For deposits, transactTime == timestamp
                    // For withdrawals, transactTime is submission, timestamp is processed
                    const transactTime = this.parse8601(this.safeString(transaction, 'transactTime'));
                    const timestamp = this.parse8601(this.safeString(transaction, 'timestamp'));
                    const type = this.safeStringLower(transaction, 'transactType');
                    // Deposits have no from address or to address, withdrawals have both
                    let address = undefined;
                    let addressFrom = undefined;
                    let addressTo = undefined;
                    if (type === 'withdrawal') {
                        address = this.safeString(transaction, 'address');
                        addressFrom = this.safeString(transaction, 'tx');
                        addressTo = address;
                    }
                    let amountString = this.safeString(transaction, 'amount');
                    amountString = Precise.stringDiv(Precise.stringAbs(amountString), '1e8');
                    let feeCostString = this.safeString(transaction, 'fee');
                    feeCostString = Precise.stringDiv(feeCostString, '1e8');
                    const fee = {
                        'cost': this.parseNumber(feeCostString),
                        'currency': 'BTC'
                    };
                    let status = this.safeString(transaction, 'transactStatus');
                    if (status !== undefined) status = this.parseTransactionStatus(status);
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': undefined,
                        'timestamp': transactTime,
                        'datetime': this.iso8601(transactTime),
                        'network': undefined,
                        'addressFrom': addressFrom,
                        'address': address,
                        'addressTo': addressTo,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'type': type,
                        'amount': this.parseNumber(amountString),
                        // BTC is the only currency on Bitmex
                        'currency': 'BTC',
                        'status': status,
                        'updated': timestamp,
                        'comment': undefined,
                        'fee': fee
                    };
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const tickers = await this.fetchTickers([
                        market['symbol']
                    ], params);
                    const ticker = this.safeValue(tickers, market['symbol']);
                    if (ticker === undefined) throw new BadSymbol(this.id + ' fetchTicker() symbol ' + symbol + ' not found');
                    return ticker;
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetInstrumentActiveAndIndices(params);
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const ticker = this.parseTicker(response[i]);
                        const symbol = this.safeString(ticker, 'symbol');
                        if (symbol !== undefined) result[symbol] = ticker;
                    }
                    const uniformSymbols = [];
                    if (symbols !== undefined) for(let i = 0; i < symbols.length; i++){
                        const symbol = symbols[i];
                        const market = this.market(symbol);
                        uniformSymbols.push(market['symbol']);
                    }
                    return this.filterByArray(result, 'symbol', uniformSymbols);
                }
                parseTicker(ticker, market) {
                    //
                    //     {                         symbol: "ETHH19",
                    //                           rootSymbol: "ETH",
                    //                                state: "Open",
                    //                                  typ: "FFCCSX",
                    //                              listing: "2018-12-17T04:00:00.000Z",
                    //                                front: "2019-02-22T12:00:00.000Z",
                    //                               expiry: "2019-03-29T12:00:00.000Z",
                    //                               settle: "2019-03-29T12:00:00.000Z",
                    //                       relistInterval:  null,
                    //                           inverseLeg: "",
                    //                              sellLeg: "",
                    //                               buyLeg: "",
                    //                     optionStrikePcnt:  null,
                    //                    optionStrikeRound:  null,
                    //                    optionStrikePrice:  null,
                    //                     optionMultiplier:  null,
                    //                     positionCurrency: "ETH",
                    //                           underlying: "ETH",
                    //                        quoteCurrency: "XBT",
                    //                     underlyingSymbol: "ETHXBT=",
                    //                            reference: "BMEX",
                    //                      referenceSymbol: ".BETHXBT30M",
                    //                         calcInterval:  null,
                    //                      publishInterval:  null,
                    //                          publishTime:  null,
                    //                          maxOrderQty:  100000000,
                    //                             maxPrice:  10,
                    //                              lotSize:  1,
                    //                             tickSize:  0.00001,
                    //                           multiplier:  100000000,
                    //                        settlCurrency: "XBt",
                    //       underlyingToPositionMultiplier:  1,
                    //         underlyingToSettleMultiplier:  null,
                    //              quoteToSettleMultiplier:  100000000,
                    //                             isQuanto:  false,
                    //                            isInverse:  false,
                    //                           initMargin:  0.02,
                    //                          maintMargin:  0.01,
                    //                            riskLimit:  5000000000,
                    //                             riskStep:  5000000000,
                    //                                limit:  null,
                    //                               capped:  false,
                    //                                taxed:  true,
                    //                           deleverage:  true,
                    //                             makerFee:  -0.0005,
                    //                             takerFee:  0.0025,
                    //                        settlementFee:  0,
                    //                         insuranceFee:  0,
                    //                    fundingBaseSymbol: "",
                    //                   fundingQuoteSymbol: "",
                    //                 fundingPremiumSymbol: "",
                    //                     fundingTimestamp:  null,
                    //                      fundingInterval:  null,
                    //                          fundingRate:  null,
                    //                indicativeFundingRate:  null,
                    //                   rebalanceTimestamp:  null,
                    //                    rebalanceInterval:  null,
                    //                     openingTimestamp: "2019-02-13T08:00:00.000Z",
                    //                     closingTimestamp: "2019-02-13T09:00:00.000Z",
                    //                      sessionInterval: "2000-01-01T01:00:00.000Z",
                    //                       prevClosePrice:  0.03347,
                    //                       limitDownPrice:  null,
                    //                         limitUpPrice:  null,
                    //               bankruptLimitDownPrice:  null,
                    //                 bankruptLimitUpPrice:  null,
                    //                      prevTotalVolume:  1386531,
                    //                          totalVolume:  1387062,
                    //                               volume:  531,
                    //                            volume24h:  17118,
                    //                    prevTotalTurnover:  4741294246000,
                    //                        totalTurnover:  4743103466000,
                    //                             turnover:  1809220000,
                    //                          turnover24h:  57919845000,
                    //                      homeNotional24h:  17118,
                    //                   foreignNotional24h:  579.19845,
                    //                         prevPrice24h:  0.03349,
                    //                                 vwap:  0.03383564,
                    //                            highPrice:  0.03458,
                    //                             lowPrice:  0.03329,
                    //                            lastPrice:  0.03406,
                    //                   lastPriceProtected:  0.03406,
                    //                    lastTickDirection: "ZeroMinusTick",
                    //                       lastChangePcnt:  0.017,
                    //                             bidPrice:  0.03406,
                    //                             midPrice:  0.034065,
                    //                             askPrice:  0.03407,
                    //                       impactBidPrice:  0.03406,
                    //                       impactMidPrice:  0.034065,
                    //                       impactAskPrice:  0.03407,
                    //                         hasLiquidity:  true,
                    //                         openInterest:  83679,
                    //                            openValue:  285010674000,
                    //                           fairMethod: "ImpactMidPrice",
                    //                        fairBasisRate:  0,
                    //                            fairBasis:  0,
                    //                            fairPrice:  0.03406,
                    //                           markMethod: "FairPrice",
                    //                            markPrice:  0.03406,
                    //                    indicativeTaxRate:  0,
                    //                indicativeSettlePrice:  0.03406,
                    //                optionUnderlyingPrice:  null,
                    //                         settledPrice:  null,
                    //                            timestamp: "2019-02-13T08:40:30.000Z",
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.parse8601(this.safeString(ticker, 'timestamp'));
                    const open = this.safeString(ticker, 'prevPrice24h');
                    const last = this.safeString(ticker, 'lastPrice');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'highPrice'),
                        'low': this.safeString(ticker, 'lowPrice'),
                        'bid': this.safeString(ticker, 'bidPrice'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'askPrice'),
                        'askVolume': undefined,
                        'vwap': this.safeString(ticker, 'vwap'),
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'homeNotional24h'),
                        'quoteVolume': this.safeString(ticker, 'foreignNotional24h'),
                        'info': ticker
                    }, market, false);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "timestamp":"2015-09-25T13:38:00.000Z",
                    //         "symbol":"XBTUSD",
                    //         "open":237.45,
                    //         "high":237.45,
                    //         "low":237.45,
                    //         "close":237.45,
                    //         "trades":0,
                    //         "volume":0,
                    //         "vwap":null,
                    //         "lastSize":null,
                    //         "turnover":0,
                    //         "homeNotional":0,
                    //         "foreignNotional":0
                    //     }
                    //
                    return [
                        this.parse8601(this.safeString(ohlcv, 'timestamp')),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    // send JSON key/value pairs, such as {"key": "value"}
                    // filter by individual fields and do advanced queries on timestamps
                    // let filter = { 'key': 'value' };
                    // send a bare series (e.g. XBU) to nearest expiring contract in that series
                    // you can also send a timeframe, e.g. XBU:monthly
                    // timeframes: daily, weekly, monthly, quarterly, and biquarterly
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'binSize': this.timeframes[timeframe],
                        'partial': true
                    };
                    if (limit !== undefined) request['count'] = limit; // default 100, max 500
                    const duration = this.parseTimeframe(timeframe) * 1000;
                    const fetchOHLCVOpenTimestamp = this.safeValue(this.options, 'fetchOHLCVOpenTimestamp', true);
                    // if since is not set, they will return candles starting from 2017-01-01
                    if (since !== undefined) {
                        let timestamp = since;
                        if (fetchOHLCVOpenTimestamp) timestamp = this.sum(timestamp, duration);
                        const ymdhms = this.ymdhms(timestamp);
                        request['startTime'] = ymdhms; // starting date filter for results
                    } else request['reverse'] = true;
                    const response = await this.publicGetTradeBucketed(this.extend(request, params));
                    //
                    //     [
                    //         {"timestamp":"2015-09-25T13:38:00.000Z","symbol":"XBTUSD","open":237.45,"high":237.45,"low":237.45,"close":237.45,"trades":0,"volume":0,"vwap":null,"lastSize":null,"turnover":0,"homeNotional":0,"foreignNotional":0},
                    //         {"timestamp":"2015-09-25T13:39:00.000Z","symbol":"XBTUSD","open":237.45,"high":237.45,"low":237.45,"close":237.45,"trades":0,"volume":0,"vwap":null,"lastSize":null,"turnover":0,"homeNotional":0,"foreignNotional":0},
                    //         {"timestamp":"2015-09-25T13:40:00.000Z","symbol":"XBTUSD","open":237.45,"high":237.45,"low":237.45,"close":237.45,"trades":0,"volume":0,"vwap":null,"lastSize":null,"turnover":0,"homeNotional":0,"foreignNotional":0}
                    //     ]
                    //
                    const result = this.parseOHLCVs(response, market, timeframe, since, limit);
                    if (fetchOHLCVOpenTimestamp) // bitmex returns the candle's close timestamp - https://github.com/ccxt/ccxt/issues/4446
                    // we can emulate the open timestamp by shifting all the timestamps one place
                    // so the previous close becomes the current open, and we drop the first candle
                    for(let i = 0; i < result.length; i++)result[i][0] = result[i][0] - duration;
                    return result;
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         timestamp: '2018-08-28T00:00:02.735Z',
                    //         symbol: 'XBTUSD',
                    //         side: 'Buy',
                    //         size: 2000,
                    //         price: 6906.5,
                    //         tickDirection: 'PlusTick',
                    //         trdMatchID: 'b9a42432-0a46-6a2f-5ecc-c32e9ca4baf8',
                    //         grossValue: 28958000,
                    //         homeNotional: 0.28958,
                    //         foreignNotional: 2000
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "execID": "string",
                    //         "orderID": "string",
                    //         "clOrdID": "string",
                    //         "clOrdLinkID": "string",
                    //         "account": 0,
                    //         "symbol": "string",
                    //         "side": "string",
                    //         "lastQty": 0,
                    //         "lastPx": 0,
                    //         "underlyingLastPx": 0,
                    //         "lastMkt": "string",
                    //         "lastLiquidityInd": "string",
                    //         "simpleOrderQty": 0,
                    //         "orderQty": 0,
                    //         "price": 0,
                    //         "displayQty": 0,
                    //         "stopPx": 0,
                    //         "pegOffsetValue": 0,
                    //         "pegPriceType": "string",
                    //         "currency": "string",
                    //         "settlCurrency": "string",
                    //         "execType": "string",
                    //         "ordType": "string",
                    //         "timeInForce": "string",
                    //         "execInst": "string",
                    //         "contingencyType": "string",
                    //         "exDestination": "string",
                    //         "ordStatus": "string",
                    //         "triggered": "string",
                    //         "workingIndicator": true,
                    //         "ordRejReason": "string",
                    //         "simpleLeavesQty": 0,
                    //         "leavesQty": 0,
                    //         "simpleCumQty": 0,
                    //         "cumQty": 0,
                    //         "avgPx": 0,
                    //         "commission": 0,
                    //         "tradePublishIndicator": "string",
                    //         "multiLegReportingType": "string",
                    //         "text": "string",
                    //         "trdMatchID": "string",
                    //         "execCost": 0,
                    //         "execComm": 0,
                    //         "homeNotional": 0,
                    //         "foreignNotional": 0,
                    //         "transactTime": "2019-03-05T12:47:02.762Z",
                    //         "timestamp": "2019-03-05T12:47:02.762Z"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(trade, 'timestamp'));
                    const priceString = this.safeString2(trade, 'avgPx', 'price');
                    const amountString = this.safeString2(trade, 'size', 'lastQty');
                    const execCost = this.safeString(trade, 'execCost');
                    const costString = Precise.stringDiv(Precise.stringAbs(execCost), '1e8');
                    const id = this.safeString(trade, 'trdMatchID');
                    const order = this.safeString(trade, 'orderID');
                    const side = this.safeStringLower(trade, 'side');
                    // price * amount doesn't work for all symbols (e.g. XBT, ETH)
                    let fee = undefined;
                    const feeCostString = Precise.stringDiv(this.safeString(trade, 'execComm'), '1e8');
                    if (feeCostString !== undefined) {
                        const currencyId = this.safeString(trade, 'settlCurrency');
                        const feeCurrencyCode = this.safeCurrencyCode(currencyId);
                        const feeRateString = this.safeString(trade, 'commission');
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode,
                            'rate': feeRateString
                        };
                    }
                    // Trade or Funding
                    const execType = this.safeString(trade, 'execType');
                    let takerOrMaker = undefined;
                    if (feeCostString !== undefined && execType === 'Trade') takerOrMaker = Precise.stringLt(feeCostString, '0') ? 'maker' : 'taker';
                    const marketId = this.safeString(trade, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const type = this.safeStringLower(trade, 'ordType');
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': order,
                        'type': type,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': priceString,
                        'cost': costString,
                        'amount': amountString,
                        'fee': fee
                    }, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'New': 'open',
                        'PartiallyFilled': 'open',
                        'Filled': 'closed',
                        'DoneForDay': 'open',
                        'Canceled': 'canceled',
                        'PendingCancel': 'open',
                        'PendingNew': 'open',
                        'Rejected': 'rejected',
                        'Expired': 'expired',
                        'Stopped': 'open',
                        'Untriggered': 'open',
                        'Triggered': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTimeInForce(timeInForce) {
                    const timeInForces = {
                        'Day': 'Day',
                        'GoodTillCancel': 'GTC',
                        'ImmediateOrCancel': 'IOC',
                        'FillOrKill': 'FOK'
                    };
                    return this.safeString(timeInForces, timeInForce, timeInForce);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "orderID":"56222c7a-9956-413a-82cf-99f4812c214b",
                    //         "clOrdID":"",
                    //         "clOrdLinkID":"",
                    //         "account":1455728,
                    //         "symbol":"XBTUSD",
                    //         "side":"Sell",
                    //         "simpleOrderQty":null,
                    //         "orderQty":1,
                    //         "price":40000,
                    //         "displayQty":null,
                    //         "stopPx":null,
                    //         "pegOffsetValue":null,
                    //         "pegPriceType":"",
                    //         "currency":"USD",
                    //         "settlCurrency":"XBt",
                    //         "ordType":"Limit",
                    //         "timeInForce":"GoodTillCancel",
                    //         "execInst":"",
                    //         "contingencyType":"",
                    //         "exDestination":"XBME",
                    //         "ordStatus":"New",
                    //         "triggered":"",
                    //         "workingIndicator":true,
                    //         "ordRejReason":"",
                    //         "simpleLeavesQty":null,
                    //         "leavesQty":1,
                    //         "simpleCumQty":null,
                    //         "cumQty":0,
                    //         "avgPx":null,
                    //         "multiLegReportingType":"SingleSecurity",
                    //         "text":"Submitted via API.",
                    //         "transactTime":"2021-01-02T21:38:49.246Z",
                    //         "timestamp":"2021-01-02T21:38:49.246Z"
                    //     }
                    //
                    const status = this.parseOrderStatus(this.safeString(order, 'ordStatus'));
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.parse8601(this.safeString(order, 'timestamp'));
                    const lastTradeTimestamp = this.parse8601(this.safeString(order, 'transactTime'));
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'orderQty');
                    const filled = this.safeString(order, 'cumQty', 0.0);
                    const average = this.safeString(order, 'avgPx');
                    const id = this.safeString(order, 'orderID');
                    const type = this.safeStringLower(order, 'ordType');
                    const side = this.safeStringLower(order, 'side');
                    const clientOrderId = this.safeString(order, 'clOrdID');
                    const timeInForce = this.parseTimeInForce(this.safeString(order, 'timeInForce'));
                    const stopPrice = this.safeNumber(order, 'stopPx');
                    const execInst = this.safeString(order, 'execInst');
                    const postOnly = execInst === 'ParticipateDoNotInitiate';
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': undefined,
                        'average': average,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['startTime'] = this.iso8601(since);
                    else // by default reverse=false, i.e. trades are fetched since the time of market inception (year 2015 for XBTUSD)
                    request['reverse'] = true;
                    if (limit !== undefined) request['count'] = limit;
                    const response = await this.publicGetTrade(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             timestamp: '2018-08-28T00:00:02.735Z',
                    //             symbol: 'XBTUSD',
                    //             side: 'Buy',
                    //             size: 2000,
                    //             price: 6906.5,
                    //             tickDirection: 'PlusTick',
                    //             trdMatchID: 'b9a42432-0a46-6a2f-5ecc-c32e9ca4baf8',
                    //             grossValue: 28958000,
                    //             homeNotional: 0.28958,
                    //             foreignNotional: 2000
                    //         },
                    //         {
                    //             timestamp: '2018-08-28T00:00:03.778Z',
                    //             symbol: 'XBTUSD',
                    //             side: 'Sell',
                    //             size: 1000,
                    //             price: 6906,
                    //             tickDirection: 'MinusTick',
                    //             trdMatchID: '0d4f1682-5270-a800-569b-4a0eb92db97c',
                    //             grossValue: 14480000,
                    //             homeNotional: 0.1448,
                    //             foreignNotional: 1000
                    //         },
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const orderType = this.capitalize(type);
                    const request = {
                        'symbol': market['id'],
                        'side': this.capitalize(side),
                        'orderQty': parseFloat(this.amountToPrecision(symbol, amount)),
                        'ordType': orderType
                    };
                    if (orderType === 'Stop' || orderType === 'StopLimit' || orderType === 'MarketIfTouched' || orderType === 'LimitIfTouched') {
                        const stopPrice = this.safeNumber2(params, 'stopPx', 'stopPrice');
                        if (stopPrice === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a stopPx or stopPrice parameter for the ' + orderType + ' order type');
                        else {
                            request['stopPx'] = parseFloat(this.priceToPrecision(symbol, stopPrice));
                            params = this.omit(params, [
                                'stopPx',
                                'stopPrice'
                            ]);
                        }
                    }
                    if (orderType === 'Limit' || orderType === 'StopLimit' || orderType === 'LimitIfTouched') request['price'] = parseFloat(this.priceToPrecision(symbol, price));
                    const clientOrderId = this.safeString2(params, 'clOrdID', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['clOrdID'] = clientOrderId;
                        params = this.omit(params, [
                            'clOrdID',
                            'clientOrderId'
                        ]);
                    }
                    const response = await this.privatePostOrder(this.extend(request, params));
                    return this.parseOrder(response, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    const origClOrdID = this.safeString2(params, 'origClOrdID', 'clientOrderId');
                    if (origClOrdID !== undefined) {
                        request['origClOrdID'] = origClOrdID;
                        const clientOrderId = this.safeString(params, 'clOrdID', 'clientOrderId');
                        if (clientOrderId !== undefined) request['clOrdID'] = clientOrderId;
                        params = this.omit(params, [
                            'origClOrdID',
                            'clOrdID',
                            'clientOrderId'
                        ]);
                    } else request['orderID'] = id;
                    if (amount !== undefined) request['orderQty'] = amount;
                    if (price !== undefined) request['price'] = price;
                    const response = await this.privatePutOrder(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    // https://github.com/ccxt/ccxt/issues/6507
                    const clientOrderId = this.safeValue2(params, 'clOrdID', 'clientOrderId');
                    const request = {};
                    if (clientOrderId === undefined) request['orderID'] = id;
                    else {
                        request['clOrdID'] = clientOrderId;
                        params = this.omit(params, [
                            'clOrdID',
                            'clientOrderId'
                        ]);
                    }
                    const response = await this.privateDeleteOrder(this.extend(request, params));
                    const order = this.safeValue(response, 0, {});
                    const error = this.safeString(order, 'error');
                    if (error !== undefined) {
                        if (error.indexOf('Unable to cancel order due to existing state') >= 0) throw new OrderNotFound(this.id + ' cancelOrder() failed: ' + error);
                    }
                    return this.parseOrder(order);
                }
                async cancelOrders(ids, symbol, params = {}) {
                    return await this.cancelOrder(ids, symbol, params);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const response = await this.privateDeleteOrderAll(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "orderID": "string",
                    //             "clOrdID": "string",
                    //             "clOrdLinkID": "string",
                    //             "account": 0,
                    //             "symbol": "string",
                    //             "side": "string",
                    //             "simpleOrderQty": 0,
                    //             "orderQty": 0,
                    //             "price": 0,
                    //             "displayQty": 0,
                    //             "stopPx": 0,
                    //             "pegOffsetValue": 0,
                    //             "pegPriceType": "string",
                    //             "currency": "string",
                    //             "settlCurrency": "string",
                    //             "ordType": "string",
                    //             "timeInForce": "string",
                    //             "execInst": "string",
                    //             "contingencyType": "string",
                    //             "exDestination": "string",
                    //             "ordStatus": "string",
                    //             "triggered": "string",
                    //             "workingIndicator": true,
                    //             "ordRejReason": "string",
                    //             "simpleLeavesQty": 0,
                    //             "leavesQty": 0,
                    //             "simpleCumQty": 0,
                    //             "cumQty": 0,
                    //             "avgPx": 0,
                    //             "multiLegReportingType": "string",
                    //             "text": "string",
                    //             "transactTime": "2020-06-01T09:36:35.290Z",
                    //             "timestamp": "2020-06-01T09:36:35.290Z"
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market);
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetPosition(params);
                    //     [
                    //         {
                    //             "account": 0,
                    //             "symbol": "string",
                    //             "currency": "string",
                    //             "underlying": "string",
                    //             "quoteCurrency": "string",
                    //             "commission": 0,
                    //             "initMarginReq": 0,
                    //             "maintMarginReq": 0,
                    //             "riskLimit": 0,
                    //             "leverage": 0,
                    //             "crossMargin": true,
                    //             "deleveragePercentile": 0,
                    //             "rebalancedPnl": 0,
                    //             "prevRealisedPnl": 0,
                    //             "prevUnrealisedPnl": 0,
                    //             "prevClosePrice": 0,
                    //             "openingTimestamp": "2020-11-09T06:53:59.892Z",
                    //             "openingQty": 0,
                    //             "openingCost": 0,
                    //             "openingComm": 0,
                    //             "openOrderBuyQty": 0,
                    //             "openOrderBuyCost": 0,
                    //             "openOrderBuyPremium": 0,
                    //             "openOrderSellQty": 0,
                    //             "openOrderSellCost": 0,
                    //             "openOrderSellPremium": 0,
                    //             "execBuyQty": 0,
                    //             "execBuyCost": 0,
                    //             "execSellQty": 0,
                    //             "execSellCost": 0,
                    //             "execQty": 0,
                    //             "execCost": 0,
                    //             "execComm": 0,
                    //             "currentTimestamp": "2020-11-09T06:53:59.893Z",
                    //             "currentQty": 0,
                    //             "currentCost": 0,
                    //             "currentComm": 0,
                    //             "realisedCost": 0,
                    //             "unrealisedCost": 0,
                    //             "grossOpenCost": 0,
                    //             "grossOpenPremium": 0,
                    //             "grossExecCost": 0,
                    //             "isOpen": true,
                    //             "markPrice": 0,
                    //             "markValue": 0,
                    //             "riskValue": 0,
                    //             "homeNotional": 0,
                    //             "foreignNotional": 0,
                    //             "posState": "string",
                    //             "posCost": 0,
                    //             "posCost2": 0,
                    //             "posCross": 0,
                    //             "posInit": 0,
                    //             "posComm": 0,
                    //             "posLoss": 0,
                    //             "posMargin": 0,
                    //             "posMaint": 0,
                    //             "posAllowance": 0,
                    //             "taxableMargin": 0,
                    //             "initMargin": 0,
                    //             "maintMargin": 0,
                    //             "sessionMargin": 0,
                    //             "targetExcessMargin": 0,
                    //             "varMargin": 0,
                    //             "realisedGrossPnl": 0,
                    //             "realisedTax": 0,
                    //             "realisedPnl": 0,
                    //             "unrealisedGrossPnl": 0,
                    //             "longBankrupt": 0,
                    //             "shortBankrupt": 0,
                    //             "taxBase": 0,
                    //             "indicativeTaxRate": 0,
                    //             "indicativeTax": 0,
                    //             "unrealisedTax": 0,
                    //             "unrealisedPnl": 0,
                    //             "unrealisedPnlPcnt": 0,
                    //             "unrealisedRoePcnt": 0,
                    //             "simpleQty": 0,
                    //             "simpleCost": 0,
                    //             "simpleValue": 0,
                    //             "simplePnl": 0,
                    //             "simplePnlPcnt": 0,
                    //             "avgCostPrice": 0,
                    //             "avgEntryPrice": 0,
                    //             "breakEvenPrice": 0,
                    //             "marginCallPrice": 0,
                    //             "liquidationPrice": 0,
                    //             "bankruptPrice": 0,
                    //             "timestamp": "2020-11-09T06:53:59.894Z",
                    //             "lastPrice": 0,
                    //             "lastValue": 0
                    //         }
                    //     ]
                    //
                    // todo unify parsePosition/parsePositions
                    return response;
                }
                isFiat(currency) {
                    if (currency === 'EUR') return true;
                    if (currency === 'PLN') return true;
                    return false;
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    // let currency = this.currency (code);
                    if (code !== 'BTC') throw new ExchangeError1(this.id + ' supoprts BTC withdrawals only, other currencies coming soon...');
                    const currency = this.currency(code);
                    const request = {
                        'currency': 'XBt',
                        'amount': amount,
                        'address': address
                    };
                    const response = await this.privatePostUserRequestWithdrawal(this.extend(request, params));
                    return this.parseTransaction(response, currency);
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    if (code === 429) throw new DDoSProtection(this.id + ' ' + body);
                    if (code >= 400) {
                        const error = this.safeValue(response, 'error', {});
                        const message = this.safeString(error, 'message');
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        if (code === 400) throw new BadRequest(feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let query = '/api/' + this.version + '/' + path;
                    if (method === 'GET') {
                        if (Object.keys(params).length) query += '?' + this.urlencode(params);
                    } else {
                        const format = this.safeString(params, '_format');
                        if (format !== undefined) {
                            query += '?' + this.urlencode({
                                '_format': format
                            });
                            params = this.omit(params, '_format');
                        }
                    }
                    const url = this.urls['api'][api] + query;
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        let auth = method + query;
                        let expires = this.safeInteger(this.options, 'api-expires');
                        headers = {
                            'Content-Type': 'application/json',
                            'api-key': this.apiKey
                        };
                        expires = this.sum(this.seconds(), expires);
                        expires = expires.toString();
                        auth += expires;
                        headers['api-expires'] = expires;
                        if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
                            if (Object.keys(params).length) {
                                body = this.json(params);
                                auth += body;
                            }
                        }
                        headers['api-signature'] = this.hmac(this.encode(auth), this.encode(this.secret));
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    40: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, BadRequest: BadRequest } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bitopro extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitopro',
                        'name': 'BitoPro',
                        'countries': [
                            'TW'
                        ],
                        'version': 'v3',
                        'rateLimit': 100,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createOrder': true,
                            'editOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': false,
                            'fetchDeposits': true,
                            'fetchFundingFees': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': false,
                            'fetchOrderTrades': false,
                            'fetchPositions': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': false,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': false,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': true,
                            'fetchWithdrawals': true,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '3h': '3h',
                            '6h': '6h',
                            '12h': '12h',
                            '1d': '1d',
                            '1w': '1w',
                            '1M': '1M'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/158227251-3a92a220-9222-453c-9277-977c6677fe71.jpg',
                            'api': 'https://api.bitopro.com/v3',
                            'www': 'https://www.bitopro.com',
                            'doc': [
                                'https://github.com/bitoex/bitopro-offical-api-docs/blob/master/v3-1/rest-1/rest.md'
                            ],
                            'fees': 'https://www.bitopro.com/fees'
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'order-book/{pair}',
                                    'tickers',
                                    'tickers/{pair}',
                                    'trades/{pair}',
                                    'provisioning/currencies',
                                    'provisioning/trading-pairs',
                                    'provisioning/limitations-and-fees',
                                    'trading-history/{pair}'
                                ]
                            },
                            'private': {
                                'get': [
                                    'accounts/balance',
                                    'orders/history',
                                    'orders/all/{pair}',
                                    'orders/trades/{pair}',
                                    'orders/{pair}/{orderId}',
                                    'wallet/withdraw/{currency}/{serial}',
                                    'wallet/withdraw/{currency}/id/{id}',
                                    'wallet/depositHistory/{currency}',
                                    'wallet/withdrawHistory/{currency}'
                                ],
                                'post': [
                                    'orders/{pair}',
                                    'orders/batch',
                                    'wallet/withdraw/{currency}'
                                ],
                                'put': [
                                    'orders'
                                ],
                                'delete': [
                                    'orders/{pair}/{id}',
                                    'orders/all',
                                    'orders/{pair}'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'maker': this.parseNumber('0.001'),
                                'taker': this.parseNumber('0.002'),
                                'tiers': {
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('3000000'),
                                            this.parseNumber('0.00194')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.0015')
                                        ],
                                        [
                                            this.parseNumber('30000000'),
                                            this.parseNumber('0.0014')
                                        ],
                                        [
                                            this.parseNumber('300000000'),
                                            this.parseNumber('0.0013')
                                        ],
                                        [
                                            this.parseNumber('550000000'),
                                            this.parseNumber('0.0012')
                                        ],
                                        [
                                            this.parseNumber('1300000000'),
                                            this.parseNumber('0.0011')
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.001')
                                        ],
                                        [
                                            this.parseNumber('3000000'),
                                            this.parseNumber('0.00097')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('30000000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('300000000'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('550000000'),
                                            this.parseNumber('0.0004')
                                        ],
                                        [
                                            this.parseNumber('1300000000'),
                                            this.parseNumber('0.0003')
                                        ]
                                    ]
                                }
                            }
                        },
                        'options': {
                            'networks': {
                                'ERC20': 'ERC20',
                                'ETH': 'ERC20',
                                'TRX': 'TRX',
                                'TRC20': 'TRX'
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'Unsupported currency.': BadRequest,
                                'Unsupported order type': BadRequest,
                                'Invalid body': BadRequest,
                                'Invalid Signature': AuthenticationError,
                                'Address not in whitelist.': BadRequest
                            },
                            'broad': {
                                'Invalid amount': InvalidOrder,
                                'Balance for ': InsufficientFunds,
                                'Invalid ': BadRequest,
                                'Wrong parameter': BadRequest
                            }
                        },
                        'commonCurrencies': {}
                    });
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetProvisioningCurrencies(params);
                    const currencies = this.safeValue(response, 'data', []);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "currency":"eth",
                    //                 "withdrawFee":"0.007",
                    //                 "minWithdraw":"0.001",
                    //                 "maxWithdraw":"1000",
                    //                 "maxDailyWithdraw":"2000",
                    //                 "withdraw":true,
                    //                 "deposit":true,
                    //                 "depositConfirmation":"12"
                    //             }
                    //         ]
                    //     }
                    //
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const currencyId = this.safeString(currency, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const deposit = this.safeValue(currency, 'deposit');
                        const withdraw = this.safeValue(currency, 'withdraw');
                        const fee = this.safeNumber(currency, 'withdrawFee');
                        const withdrawMin = this.safeNumber(currency, 'minWithdraw');
                        const withdrawMax = this.safeNumber(currency, 'maxWithdraw');
                        const limits = {
                            'withdraw': {
                                'min': withdrawMin,
                                'max': withdrawMax
                            },
                            'amount': {
                                'min': undefined,
                                'max': undefined
                            }
                        };
                        result[code] = {
                            'id': currencyId,
                            'code': code,
                            'info': currency,
                            'type': undefined,
                            'name': undefined,
                            'active': deposit && withdraw,
                            'deposit': deposit,
                            'withdraw': withdraw,
                            'fee': fee,
                            'precision': undefined,
                            'limits': limits
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetProvisioningTradingPairs();
                    const markets = this.safeValue(response, 'data', []);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "pair":"shib_twd",
                    //                 "base":"shib",
                    //                 "quote":"twd",
                    //                 "basePrecision":"8",
                    //                 "quotePrecision":"6",
                    //                 "minLimitBaseAmount":"100000",
                    //                 "maxLimitBaseAmount":"5500000000",
                    //                 "minMarketBuyQuoteAmount":"1000",
                    //                 "orderOpenLimit":"200",
                    //                 "maintain":false,
                    //                 "orderBookQuotePrecision":"6",
                    //                 "orderBookQuoteScaleLevel":"5"
                    //             }
                    //         ]
                    //     }
                    //
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const active = !this.safeValue(market, 'maintain');
                        const id = this.safeString(market, 'pair');
                        const uppercaseId = id.toUpperCase();
                        const baseId = this.safeString(market, 'base');
                        const quoteId = this.safeString(market, 'quote');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const symbol = base + '/' + quote;
                        const precision = {
                            'price': this.safeInteger(market, 'quotePrecision'),
                            'amount': this.safeInteger(market, 'basePrecision')
                        };
                        const limits = {
                            'amount': {
                                'min': this.safeNumber(market, 'minLimitBaseAmount'),
                                'max': this.safeNumber(market, 'maxLimitBaseAmount')
                            },
                            'price': {
                                'min': undefined,
                                'max': undefined
                            },
                            'cost': {
                                'min': undefined,
                                'max': undefined
                            },
                            'leverage': {
                                'min': undefined,
                                'max': undefined
                            }
                        };
                        result.push({
                            'id': id,
                            'uppercaseId': uppercaseId,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'baseId': base,
                            'quoteId': quote,
                            'settle': undefined,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'derivative': false,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'limits': limits,
                            'precision': precision,
                            'active': active,
                            'info': market
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "pair":"btc_twd",
                    //         "lastPrice":"1182449.00000000",
                    //         "isBuyer":false,
                    //         "priceChange24hr":"-1.99",
                    //         "volume24hr":"9.13089740",
                    //         "high24hr":"1226097.00000000",
                    //         "low24hr":"1181000.00000000"
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'pair');
                    market = this.safeMarket(marketId, market);
                    const symbol = this.safeString(market, 'symbol');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'high': this.safeString(ticker, 'high24hr'),
                        'low': this.safeString(ticker, 'low24hr'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': this.safeString(ticker, 'lastPrice'),
                        'last': this.safeString(ticker, 'lastPrice'),
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': this.safeString(ticker, 'priceChange24hr'),
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume24hr'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetTickersPair(this.extend(request, params));
                    const ticker = this.safeValue(response, 'data', {});
                    //
                    //     {
                    //         "data":{
                    //             "pair":"btc_twd",
                    //             "lastPrice":"1182449.00000000",
                    //             "isBuyer":false,
                    //             "priceChange24hr":"-1.99",
                    //             "volume24hr":"9.13089740",
                    //             "high24hr":"1226097.00000000",
                    //             "low24hr":"1181000.00000000"
                    //         }
                    //     }
                    //
                    return this.parseTicker(ticker, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTickers();
                    const tickers = this.safeValue(response, 'data', []);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "pair":"xrp_twd",
                    //                 "lastPrice":"21.26110000",
                    //                 "isBuyer":false,
                    //                 "priceChange24hr":"-6.53",
                    //                 "volume24hr":"102846.47084802",
                    //                 "high24hr":"23.24460000",
                    //                 "low24hr":"21.13730000"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseTickers(tickers, symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'pair': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetOrderBookPair(this.extend(request, params));
                    //
                    //     {
                    //         "bids":[
                    //             {
                    //                 "price":"1175271",
                    //                 "amount":"0.00022804",
                    //                 "count":1,
                    //                 "total":"0.00022804"
                    //             }
                    //         ],
                    //         "asks":[
                    //             {
                    //                 "price":"1176906",
                    //                 "amount":"0.0496",
                    //                 "count":1,
                    //                 "total":"0.0496"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseOrderBook(response, symbol, undefined, 'bids', 'asks', 'price', 'amount');
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades
                    //         {
                    //                 "timestamp":1644651458,
                    //                 "price":"1180785.00000000",
                    //                 "amount":"0.00020000",
                    //                 "isBuyer":false
                    //         }
                    //
                    // fetchMyTrades
                    //         {
                    //                 "tradeId":"5685030251",
                    //                 "orderId":"9669168142",
                    //                 "price":"11821.8",
                    //                 "action":"SELL",
                    //                 "baseAmount":"0.01",
                    //                 "quoteAmount":"118.218",
                    //                 "fee":"0.236436",
                    //                 "feeSymbol":"BNB",
                    //                 "isTaker":true,
                    //                 "timestamp":1644905714862,
                    //                 "createdTimestamp":1644905714862
                    //         }
                    //
                    const id = this.safeString(trade, 'tradeId');
                    const orderId = this.safeString(trade, 'orderId');
                    let timestamp = undefined;
                    if (id === undefined) timestamp = this.safeTimestamp(trade, 'timestamp');
                    else timestamp = this.safeInteger(trade, 'timestamp');
                    const marketId = this.safeString(trade, 'pair');
                    market = this.safeMarket(marketId, market);
                    const symbol = this.safeString(market, 'symbol');
                    const price = this.safeString(trade, 'price');
                    const type = this.safeStringLower(trade, 'type');
                    let side = this.safeStringLower(trade, 'action');
                    if (side === undefined) {
                        const isBuyer = this.safeValue(trade, 'isBuyer');
                        if (isBuyer) side = 'buy';
                        else side = 'sell';
                    }
                    let amount = this.safeString(trade, 'amount');
                    if (amount === undefined) amount = this.safeString(trade, 'baseAmount');
                    let fee = undefined;
                    const feeAmount = this.safeString(trade, 'fee');
                    const feeSymbol = this.safeCurrencyCode(this.safeString(trade, 'feeSymbol'));
                    if (feeAmount !== undefined) fee = {
                        'cost': feeAmount,
                        'currency': feeSymbol,
                        'rate': undefined
                    };
                    const isTaker = this.safeValue(trade, 'isTaker');
                    let takerOrMaker = undefined;
                    if (isTaker !== undefined) {
                        if (isTaker) takerOrMaker = 'taker';
                        else takerOrMaker = 'maker';
                    }
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'takerOrMaker': takerOrMaker,
                        'type': type,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetTradesPair(this.extend(request, params));
                    const trades = this.safeValue(response, 'data', []);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "timestamp":1644651458,
                    //                 "price":"1180785.00000000",
                    //                 "amount":"0.00020000",
                    //                 "isBuyer":false
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetProvisioningLimitationsAndFees(params);
                    const tradingFeeRate = this.safeValue(response, 'tradingFeeRate', {});
                    const first = this.safeValue(tradingFeeRate, 0);
                    //
                    //     {
                    //         "tradingFeeRate":[
                    //             {
                    //                 "rank":0,
                    //                 "twdVolumeSymbol":"\u003c",
                    //                 "twdVolume":"3000000",
                    //                 "bitoAmountSymbol":"\u003c",
                    //                 "bitoAmount":"7500",
                    //                 "makerFee":"0.001",
                    //                 "takerFee":"0.002",
                    //                 "makerBitoFee":"0.0008",
                    //                 "takerBitoFee":"0.0016"
                    //             }
                    //         ],
                    //         "orderFeesAndLimitations":[
                    //             {
                    //                 "pair":"BTC/TWD",
                    //                 "minimumOrderAmount":"0.0001",
                    //                 "minimumOrderAmountBase":"BTC",
                    //                 "minimumOrderNumberOfDigits":"0"
                    //             }
                    //         ],
                    //         "restrictionsOfWithdrawalFees":[
                    //             {
                    //                 "currency":"TWD",
                    //                 "fee":"15",
                    //                 "minimumTradingAmount":"100",
                    //                 "maximumTradingAmount":"1000000",
                    //                 "dailyCumulativeMaximumAmount":"2000000",
                    //                 "remarks":"",
                    //                 "protocol":""
                    //             }
                    //         ],
                    //         "cryptocurrencyDepositFeeAndConfirmation":[
                    //             {
                    //                 "currency":"TWD",
                    //                 "generalDepositFees":"0",
                    //                 "blockchainConfirmationRequired":""
                    //             }
                    //         ],
                    //         "ttCheckFeesAndLimitationsLevel1":[
                    //             {
                    //                 "currency":"TWD",
                    //                 "redeemDailyCumulativeMaximumAmount":"",
                    //                 "generateMinimumTradingAmount":"",
                    //                 "generateMaximumTradingAmount":"",
                    //                 "generateDailyCumulativeMaximumAmount":""
                    //             }
                    //         ],
                    //         "ttCheckFeesAndLimitationsLevel2":[
                    //             {
                    //                 "currency":"TWD",
                    //                 "redeemDailyCumulativeMaximumAmount":"20000000",
                    //                 "generateMinimumTradingAmount":"30",
                    //                 "generateMaximumTradingAmount":"10000000",
                    //                 "generateDailyCumulativeMaximumAmount":"10000000"
                    //             }
                    //         ]
                    //     }
                    //
                    const result = {};
                    const maker = this.safeNumber(first, 'makerFee');
                    const taker = this.safeNumber(first, 'takerFee');
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': first,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                parseOHLCV(ohlcv, market, timeframe = '1m', since, limit) {
                    return [
                        this.safeInteger(ohlcv, 'timestamp'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '5m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const resolution = this.timeframes[timeframe];
                    const request = {
                        'pair': market['id'],
                        'resolution': resolution
                    };
                    // we need to have a limit argument because "to" and "from" are required
                    if (limit === undefined) limit = 500;
                    const timeframeInSeconds = this.parseTimeframe(timeframe);
                    let alignedSince = undefined;
                    if (since === undefined) {
                        request['to'] = this.seconds();
                        request['from'] = request['to'] - limit * timeframeInSeconds;
                    } else {
                        const timeframeInMilliseconds = timeframeInSeconds * 1000;
                        alignedSince = Math.floor(since / timeframeInMilliseconds) * timeframeInMilliseconds;
                        request['from'] = Math.floor(since / 1000);
                        request['to'] = this.sum(request['from'], limit * timeframeInSeconds);
                    }
                    const response = await this.publicGetTradingHistoryPair(this.extend(request, params));
                    const data = this.safeValue(response, 'data', []);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "timestamp":1644581100000,
                    //                 "open":"1214737",
                    //                 "high":"1215110",
                    //                 "low":"1214737",
                    //                 "close":"1215110",
                    //                 "volume":"0.08423959"
                    //             }
                    //         ]
                    //     }
                    //
                    const sparse = this.parseOHLCVs(data, market, timeframe, since, limit);
                    return this.insertMissingCandles(sparse, timeframeInSeconds, alignedSince, limit);
                }
                insertMissingCandles(candles, distance, since, limit) {
                    // the exchange doesn't send zero volume candles so we emulate them instead
                    // otherwise sending a limit arg leads to unexpected results
                    const length = candles.length;
                    if (length === 0) return candles;
                    const result = [];
                    let copyFrom = candles[0];
                    let timestamp = undefined;
                    if (since === undefined) timestamp = copyFrom[0];
                    else timestamp = since;
                    let i = 0;
                    const candleLength = candles.length;
                    let resultLength = 0;
                    while(resultLength < limit && i < candleLength){
                        const candle = candles[i];
                        if (candle[0] === timestamp) {
                            result.push(candle);
                            i = this.sum(i, 1);
                        } else {
                            const copy = this.arrayConcat([], copyFrom);
                            copy[0] = timestamp;
                            // set open, high, low to close
                            copy[1] = copy[4];
                            copy[2] = copy[4];
                            copy[3] = copy[4];
                            copy[5] = this.parseNumber('0');
                            result.push(copy);
                        }
                        timestamp = this.sum(timestamp, distance * 1000);
                        resultLength = result.length;
                        copyFrom = result[resultLength - 1];
                    }
                    return result;
                }
                parseBalance(response) {
                    //
                    //     [{
                    //         "currency":"twd",
                    //         "amount":"0",
                    //         "available":"0",
                    //         "stake":"0",
                    //         "tradable":true
                    //     }]
                    //
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const amount = this.safeString(balance, 'amount');
                        const available = this.safeString(balance, 'available');
                        const account = {
                            'free': available,
                            'total': amount
                        };
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountsBalance(params);
                    const balances = this.safeValue(response, 'data', []);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "currency":"twd",
                    //                 "amount":"0",
                    //                 "available":"0",
                    //                 "stake":"0",
                    //                 "tradable":true
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseBalance(balances);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '-1': 'open',
                        '0': 'open',
                        '1': 'open',
                        '2': 'closed',
                        '3': 'closed',
                        '4': 'canceled'
                    };
                    return this.safeString(statuses, status, undefined);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //         {
                    //             orderId: '2220595581',
                    //             timestamp: '1644896744886',
                    //             action: 'SELL',
                    //             amount: '0.01',
                    //             price: '15000',
                    //             timeInForce: 'GTC'
                    //         }
                    //
                    // fetchOrder
                    //         {
                    //             "id":"8777138788",
                    //             "pair":"bnb_twd",
                    //             "price":"16000",
                    //             "avgExecutionPrice":"0",
                    //             "action":"SELL",
                    //             "type":"LIMIT",
                    //             "timestamp":1644899002598,
                    //             "status":4,
                    //             "originalAmount":"0.01",
                    //             "remainingAmount":"0.01",
                    //             "executedAmount":"0",
                    //             "fee":"0",
                    //             "feeSymbol":"twd",
                    //             "bitoFee":"0",
                    //             "total":"0",
                    //             "seq":"BNBTWD548774666",
                    //             "timeInForce":"GTC",
                    //             "createdTimestamp":1644898944074,
                    //             "updatedTimestamp":1644899002598
                    //         }
                    //
                    const id = this.safeString2(order, 'id', 'orderId');
                    const timestamp = this.safeInteger2(order, 'timestamp', 'createdTimestamp');
                    let side = this.safeString(order, 'action');
                    side = side.toLowerCase();
                    const amount = this.safeString2(order, 'amount', 'originalAmount');
                    const price = this.safeString(order, 'price');
                    const marketId = this.safeString(order, 'pair');
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = this.safeString(market, 'symbol');
                    const orderStatus = this.safeString(order, 'status');
                    const status = this.parseOrderStatus(orderStatus);
                    const type = this.safeStringLower(order, 'type');
                    const average = this.safeString(order, 'avgExecutionPrice');
                    const filled = this.safeString(order, 'executedAmount');
                    const remaining = this.safeString(order, 'remainingAmount');
                    const timeInForce = this.safeString(order, 'timeInForce');
                    let fee = undefined;
                    const feeAmount = this.safeString(order, 'fee');
                    const feeSymbol = this.safeCurrencyCode(this.safeString(order, 'feeSymbol'));
                    if (Precise.stringGt(feeAmount, '0')) fee = {
                        'currency': feeSymbol,
                        'cost': feeAmount
                    };
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': this.safeInteger(order, 'updatedTimestamp'),
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'average': average,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': fee,
                        'trades': undefined,
                        'info': order
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'type': type,
                        'pair': market['id'],
                        'action': side,
                        'amount': this.amountToPrecision(symbol, amount),
                        'timestamp': this.milliseconds()
                    };
                    const orderType = type.toUpperCase();
                    if (orderType === 'LIMIT' || orderType === 'STOP_LIMIT') request['price'] = this.priceToPrecision(symbol, price);
                    if (orderType === 'STOP_LIMIT') {
                        const stopPrice = this.safeNumber(params, 'stopPrice');
                        if (stopPrice === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a stopPrice parameter for ' + orderType + ' orders');
                        else request['stopPrice'] = this.priceToPrecision(symbol, stopPrice);
                        const condition = this.safeString(params, 'condition');
                        if (condition === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a condition parameter for ' + orderType + ' orders');
                        else request['condition'] = condition;
                    }
                    const response = await this.privatePostOrdersPair(this.extend(request, params), params);
                    //
                    //     {
                    //         orderId: '2220595581',
                    //         timestamp: '1644896744886',
                    //         action: 'SELL',
                    //         amount: '0.01',
                    //         price: '15000',
                    //         timeInForce: 'GTC'
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires the symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': id,
                        'pair': market['id']
                    };
                    const response = await this.privateDeleteOrdersPairId(this.extend(request, params));
                    //
                    //     {
                    //         "orderId":"8777138788",
                    //         "action":"SELL",
                    //         "timestamp":1644899002465,
                    //         "price":"16000",
                    //         "amount":"0.01"
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrders(ids, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const id = market['uppercaseId'];
                    const request = {};
                    request[id] = ids;
                    const response = await this.privatePutOrders(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "BNB_TWD":[
                    //                 "5236347105",
                    //                 "359488711"
                    //             ]
                    //         }
                    //     }
                    //
                    return response;
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    // privateDeleteOrdersAll or privateDeleteOrdersPair
                    let method = this.safeString(this.options, 'privateDeleteOrdersPair', 'privateDeleteOrdersAll');
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        request['pair'] = market['id'];
                        method = 'privateDeleteOrdersPair';
                    }
                    const response = await this[method](this.extend(request, params));
                    const result = this.safeValue(response, 'data', {});
                    //
                    //     {
                    //         "data":{
                    //             "BNB_TWD":[
                    //                 "9515988421",
                    //                 "4639130027"
                    //             ]
                    //         }
                    //     }
                    //
                    return result;
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires the symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'orderId': id,
                        'pair': market['id']
                    };
                    const response = await this.privateGetOrdersPairOrderId(this.extend(request, params));
                    //
                    //     {
                    //         "id":"8777138788",
                    //         "pair":"bnb_twd",
                    //         "price":"16000",
                    //         "avgExecutionPrice":"0",
                    //         "action":"SELL",
                    //         "type":"LIMIT",
                    //         "timestamp":1644899002598,
                    //         "status":4,
                    //         "originalAmount":"0.01",
                    //         "remainingAmount":"0.01",
                    //         "executedAmount":"0",
                    //         "fee":"0",
                    //         "feeSymbol":"twd",
                    //         "bitoFee":"0",
                    //         "total":"0",
                    //         "seq":"BNBTWD548774666",
                    //         "timeInForce":"GTC",
                    //         "createdTimestamp":1644898944074,
                    //         "updatedTimestamp":1644899002598
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires the symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (since !== undefined) request['startTimestamp'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetOrdersAllPair(this.extend(request, params), params);
                    let orders = this.safeValue(response, 'data');
                    if (orders === undefined) orders = [];
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "id":"2220595581",
                    //                 "pair":"bnb_twd",
                    //                 "price":"15000",
                    //                 "avgExecutionPrice":"0",
                    //                 "action":"SELL",
                    //                 "type":"LIMIT",
                    //                 "createdTimestamp":1644896744886,
                    //                 "updatedTimestamp":1644898706236,
                    //                 "status":4,
                    //                 "originalAmount":"0.01",
                    //                 "remainingAmount":"0.01",
                    //                 "executedAmount":"0",
                    //                 "fee":"0",
                    //                 "feeSymbol":"twd",
                    //                 "bitoFee":"0",
                    //                 "total":"0",
                    //                 "seq":"BNBTWD8540871774",
                    //                 "timeInForce":"GTC"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseOrders(orders, market, since, limit);
                }
                fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'statusKind': 'OPEN'
                    };
                    return this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'statusKind': 'DONE'
                    };
                    return this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires the symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.privateGetOrdersTradesPair(this.extend(request, params));
                    const trades = this.safeValue(response, 'data', []);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "tradeId":"5685030251",
                    //                 "orderId":"9669168142",
                    //                 "price":"11821.8",
                    //                 "action":"SELL",
                    //                 "baseAmount":"0.01",
                    //                 "quoteAmount":"118.218",
                    //                 "fee":"0.236436",
                    //                 "feeSymbol":"BNB",
                    //                 "isTaker":true,
                    //                 "timestamp":1644905714862,
                    //                 "createdTimestamp":1644905714862
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseTrades(trades, market, since, limit);
                }
                parseTransactionStatus(status) {
                    const states = {
                        'COMPLETE': 'ok',
                        'INVALID': 'failed',
                        'PROCESSING': 'pending',
                        'WAIT_PROCESS': 'pending',
                        'FAILED': 'failed',
                        'EXPIRED': 'failed',
                        'CANCELLED': 'failed',
                        'EMAIL_VERIFICATION': 'pending',
                        'WAIT_CONFIRMATION': 'pending'
                    };
                    return this.safeString(states, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //             {
                    //                 "serial":"20220214X766799",
                    //                 "timestamp":"1644833015053",
                    //                 "address":"bnb1xml62k5a9dcewgc542fha75fyxdcp0zv8eqfsh",
                    //                 "amount":"0.20000000",
                    //                 "fee":"0.00000000",
                    //                 "total":"0.20000000",
                    //                 "status":"COMPLETE",
                    //                 "txid":"A3CC4F6828CC752B9F3737F48B5826B9EC2857040CB5141D0CC955F7E53DB6D9",
                    //                 "message":"778553959",
                    //                 "protocol":"MAIN",
                    //                 "id":"2905906537"
                    //             }
                    //
                    // fetchWithdrawals || fetchWithdraw
                    //             {
                    //                 "serial":"20220215BW14069838",
                    //                 "timestamp":"1644907716044",
                    //                 "address":"TKrwMaZaGiAvtXCFT41xHuusNcs4LPWS7w",
                    //                 "amount":"8.00000000",
                    //                 "fee":"2.00000000",
                    //                 "total":"10.00000000",
                    //                 "status":"COMPLETE",
                    //                 "txid":"50bf250c71a582f40cf699fb58bab978437ea9bdf7259ff8072e669aab30c32b",
                    //                 "protocol":"TRX",
                    //                 "id":"9925310345"
                    //             }
                    //
                    // withdraw
                    //             {
                    //                 "serial":"20220215BW14069838",
                    //                 "currency":"USDT",
                    //                 "protocol":"TRX",
                    //                 "address":"TKrwMaZaGiAvtXCFT41xHuusNcs4LPWS7w",
                    //                 "amount":"8",
                    //                 "fee":"2",
                    //                 "total":"10"
                    //             }
                    //
                    const currencyId = this.safeString(transaction, 'coin');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const id = this.safeString(transaction, 'serial');
                    const txId = this.safeString(transaction, 'txid');
                    const timestamp = this.safeInteger(transaction, 'timestamp');
                    const amount = this.safeNumber(transaction, 'total');
                    const address = this.safeString(transaction, 'address');
                    const tag = this.safeString(transaction, 'message');
                    const status = this.safeString(transaction, 'status');
                    const fee = this.safeNumber(transaction, 'fee');
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': address,
                        'addressTo': address,
                        'tagFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'type': undefined,
                        'amount': amount,
                        'currency': code,
                        'status': this.parseTransactionStatus(status),
                        'updated': undefined,
                        'fee': {
                            'currency': code,
                            'cost': fee,
                            'rate': undefined
                        }
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires the code argument');
                    await this.loadMarkets();
                    const currency = this.safeCurrency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    if (since !== undefined) request['startTimestamp'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetWalletDepositHistoryCurrency(this.extend(request, params));
                    const result = this.safeValue(response, 'data', []);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "serial":"20220214X766799",
                    //                 "timestamp":"1644833015053",
                    //                 "address":"bnb1xml62k5a9dcewgc542fha75fyxdcp0zv8eqfsh",
                    //                 "amount":"0.20000000",
                    //                 "fee":"0.00000000",
                    //                 "total":"0.20000000",
                    //                 "status":"COMPLETE",
                    //                 "txid":"A3CC4F6828CC752B9F3737F48B5826B9EC2857040CB5141D0CC955F7E53DB6D9",
                    //                 "message":"778553959",
                    //                 "protocol":"MAIN",
                    //                 "id":"2905906537"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseTransactions(result, currency, since, limit, {
                        'type': 'deposit'
                    });
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchWithdrawals() requires the code argument');
                    await this.loadMarkets();
                    const currency = this.safeCurrency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    if (since !== undefined) request['startTimestamp'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetWalletWithdrawHistoryCurrency(this.extend(request, params));
                    const result = this.safeValue(response, 'data', []);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "serial":"20220215BW14069838",
                    //                 "timestamp":"1644907716044",
                    //                 "address":"TKrwMaZaGiAvtXCFT41xHuusNcs4LPWS7w",
                    //                 "amount":"8.00000000",
                    //                 "fee":"2.00000000",
                    //                 "total":"10.00000000",
                    //                 "status":"COMPLETE",
                    //                 "txid":"50bf250c71a582f40cf699fb58bab978437ea9bdf7259ff8072e669aab30c32b",
                    //                 "protocol":"TRX",
                    //                 "id":"9925310345"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseTransactions(result, currency, since, limit, {
                        'type': 'withdrawal'
                    });
                }
                async fetchWithdrawal(id, code, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchWithdrawal() requires the code argument');
                    await this.loadMarkets();
                    const currency = this.safeCurrency(code);
                    const request = {
                        'serial': id,
                        'currency': currency['id']
                    };
                    const response = await this.privateGetWalletWithdrawCurrencySerial(this.extend(request, params));
                    const result = this.safeValue(response, 'data', {});
                    //
                    //     {
                    //         "data":{
                    //             "serial":"20220215BW14069838",
                    //             "address":"TKrwMaZaGiAvtXCFT41xHuusNcs4LPWS7w",
                    //             "amount":"8.00000000",
                    //             "fee":"2.00000000",
                    //             "total":"10.00000000",
                    //             "status":"COMPLETE",
                    //             "txid":"50bf250c71a582f40cf699fb58bab978437ea9bdf7259ff8072e669aab30c32b",
                    //             "protocol":"TRX",
                    //             "id":"9925310345",
                    //             "timestamp":"1644907716044"
                    //         }
                    //     }
                    //
                    return this.parseTransaction(result, currency);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    this.checkAddress(address);
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'amount': this.numberToString(amount),
                        'address': address
                    };
                    if ('network' in params) {
                        const networks = this.safeValue(this.options, 'networks', {});
                        const requestedNetwork = this.safeStringUpper(params, 'network');
                        params = this.omit(params, [
                            'network'
                        ]);
                        const networkId = this.safeString(networks, requestedNetwork);
                        if (networkId === undefined) throw new ExchangeError1(this.id + ' invalid network ' + requestedNetwork);
                        request['protocol'] = networkId;
                    }
                    if (tag !== undefined) request['message'] = tag;
                    const response = await this.privatePostWalletWithdrawCurrency(this.extend(request, params));
                    const result = this.safeValue(response, 'data', {});
                    //
                    //     {
                    //         "data":{
                    //             "serial":"20220215BW14069838",
                    //             "currency":"USDT",
                    //             "protocol":"TRX",
                    //             "address":"TKrwMaZaGiAvtXCFT41xHuusNcs4LPWS7w",
                    //             "amount":"8",
                    //             "fee":"2",
                    //             "total":"10"
                    //         }
                    //     }
                    //
                    return this.parseTransaction(result, currency);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (headers === undefined) headers = {};
                    headers['X-BITOPRO-API'] = 'ccxt';
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        if (method === 'POST' || method === 'PUT') {
                            body = this.json(params);
                            const payload = this.stringToBase64(body);
                            const signature = this.hmac(payload, this.encode(this.secret), 'sha384');
                            headers['X-BITOPRO-APIKEY'] = this.apiKey;
                            headers['X-BITOPRO-PAYLOAD'] = payload;
                            headers['X-BITOPRO-SIGNATURE'] = signature;
                        } else if (method === 'GET' || method === 'DELETE') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                            const nonce = this.milliseconds();
                            let rawData = {
                                'nonce': nonce
                            };
                            rawData = this.json(rawData);
                            const payload = this.stringToBase64(rawData);
                            const signature = this.hmac(payload, this.encode(this.secret), 'sha384');
                            headers['X-BITOPRO-APIKEY'] = this.apiKey;
                            headers['X-BITOPRO-PAYLOAD'] = payload;
                            headers['X-BITOPRO-SIGNATURE'] = signature;
                        }
                    } else if (api === 'public' && method === 'GET') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    }
                    url = this.urls['api'] + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to the default error handler
                    if (code >= 200 && code < 300) return;
                    const feedback = this.id + ' ' + body;
                    const error = this.safeString(response, 'error');
                    this.throwExactlyMatchedException(this.exceptions['exact'], error, feedback);
                    this.throwBroadlyMatchedException(this.exceptions['broad'], error, feedback);
                    throw new ExchangeError1(feedback); // unknown message
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    41: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, PermissionDenied: PermissionDenied, BadRequest: BadRequest, ArgumentsRequired: ArgumentsRequired1, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, ExchangeNotAvailable: ExchangeNotAvailable, DDoSProtection: DDoSProtection, InvalidAddress: InvalidAddress, InvalidOrder: InvalidOrder } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bitpanda extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitpanda',
                        'name': 'Bitpanda Pro',
                        'countries': [
                            'AT'
                        ],
                        'rateLimit': 300,
                        'version': 'v1',
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawals': true,
                            'privateAPI': true,
                            'publicAPI': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1/MINUTES',
                            '5m': '5/MINUTES',
                            '15m': '15/MINUTES',
                            '30m': '30/MINUTES',
                            '1h': '1/HOURS',
                            '4h': '4/HOURS',
                            '1d': '1/DAYS',
                            '1w': '1/WEEKS',
                            '1M': '1/MONTHS'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87591171-9a377d80-c6f0-11ea-94ac-97a126eac3bc.jpg',
                            'api': {
                                'public': 'https://api.exchange.bitpanda.com/public',
                                'private': 'https://api.exchange.bitpanda.com/public'
                            },
                            'www': 'https://www.bitpanda.com/en/pro',
                            'doc': [
                                'https://developers.bitpanda.com/exchange/'
                            ],
                            'fees': 'https://www.bitpanda.com/en/pro/fees'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'currencies',
                                    'candlesticks/{instrument_code}',
                                    'fees',
                                    'instruments',
                                    'order-book/{instrument_code}',
                                    'market-ticker',
                                    'market-ticker/{instrument_code}',
                                    'price-ticks/{instrument_code}',
                                    'time'
                                ]
                            },
                            'private': {
                                'get': [
                                    'account/balances',
                                    'account/deposit/crypto/{currency_code}',
                                    'account/deposit/fiat/EUR',
                                    'account/deposits',
                                    'account/deposits/bitpanda',
                                    'account/withdrawals',
                                    'account/withdrawals/bitpanda',
                                    'account/fees',
                                    'account/orders',
                                    'account/orders/{order_id}',
                                    'account/orders/{order_id}/trades',
                                    'account/trades',
                                    'account/trades/{trade_id}',
                                    'account/trading-volume'
                                ],
                                'post': [
                                    'account/deposit/crypto',
                                    'account/withdraw/crypto',
                                    'account/withdraw/fiat',
                                    'account/fees',
                                    'account/orders'
                                ],
                                'delete': [
                                    'account/orders',
                                    'account/orders/{order_id}',
                                    'account/orders/client/{client_id}'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.0015'),
                                'maker': this.parseNumber('0.001'),
                                'tiers': [
                                    // volume in BTC
                                    {
                                        'taker': [
                                            [
                                                this.parseNumber('0'),
                                                this.parseNumber('0.0015')
                                            ],
                                            [
                                                this.parseNumber('100'),
                                                this.parseNumber('0.0013')
                                            ],
                                            [
                                                this.parseNumber('250'),
                                                this.parseNumber('0.0013')
                                            ],
                                            [
                                                this.parseNumber('1000'),
                                                this.parseNumber('0.001')
                                            ],
                                            [
                                                this.parseNumber('5000'),
                                                this.parseNumber('0.0009')
                                            ],
                                            [
                                                this.parseNumber('10000'),
                                                this.parseNumber('0.00075')
                                            ],
                                            [
                                                this.parseNumber('20000'),
                                                this.parseNumber('0.00065')
                                            ]
                                        ],
                                        'maker': [
                                            [
                                                this.parseNumber('0'),
                                                this.parseNumber('0.001')
                                            ],
                                            [
                                                this.parseNumber('100'),
                                                this.parseNumber('0.001')
                                            ],
                                            [
                                                this.parseNumber('250'),
                                                this.parseNumber('0.0009')
                                            ],
                                            [
                                                this.parseNumber('1000'),
                                                this.parseNumber('0.00075')
                                            ],
                                            [
                                                this.parseNumber('5000'),
                                                this.parseNumber('0.0006')
                                            ],
                                            [
                                                this.parseNumber('10000'),
                                                this.parseNumber('0.0005')
                                            ],
                                            [
                                                this.parseNumber('20000'),
                                                this.parseNumber('0.0005')
                                            ]
                                        ]
                                    }
                                ]
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': false
                        },
                        'exceptions': {
                            'exact': {
                                'INVALID_CLIENT_UUID': InvalidOrder,
                                'ORDER_NOT_FOUND': OrderNotFound,
                                'ONLY_ONE_ERC20_ADDRESS_ALLOWED': InvalidAddress,
                                'DEPOSIT_ADDRESS_NOT_USED': InvalidAddress,
                                'INVALID_CREDENTIALS': AuthenticationError,
                                'MISSING_CREDENTIALS': AuthenticationError,
                                'INVALID_APIKEY': AuthenticationError,
                                'INVALID_SCOPES': AuthenticationError,
                                'INVALID_SUBJECT': AuthenticationError,
                                'INVALID_ISSUER': AuthenticationError,
                                'INVALID_AUDIENCE': AuthenticationError,
                                'INVALID_DEVICE_ID': AuthenticationError,
                                'INVALID_IP_RESTRICTION': AuthenticationError,
                                'APIKEY_REVOKED': AuthenticationError,
                                'APIKEY_EXPIRED': AuthenticationError,
                                'SYNCHRONIZER_TOKEN_MISMATCH': AuthenticationError,
                                'SESSION_EXPIRED': AuthenticationError,
                                'INTERNAL_ERROR': AuthenticationError,
                                'CLIENT_IP_BLOCKED': PermissionDenied,
                                'MISSING_PERMISSION': PermissionDenied,
                                'ILLEGAL_CHARS': BadRequest,
                                'UNSUPPORTED_MEDIA_TYPE': BadRequest,
                                'ACCOUNT_HISTORY_TIME_RANGE_TOO_BIG': BadRequest,
                                'CANDLESTICKS_TIME_RANGE_TOO_BIG': BadRequest,
                                'INVALID_INSTRUMENT_CODE': BadRequest,
                                'INVALID_ORDER_TYPE': BadRequest,
                                'INVALID_UNIT': BadRequest,
                                'INVALID_PERIOD': BadRequest,
                                'INVALID_TIME': BadRequest,
                                'INVALID_DATE': BadRequest,
                                'INVALID_CURRENCY': BadRequest,
                                'INVALID_AMOUNT': BadRequest,
                                'INVALID_PRICE': BadRequest,
                                'INVALID_LIMIT': BadRequest,
                                'INVALID_QUERY': BadRequest,
                                'INVALID_CURSOR': BadRequest,
                                'INVALID_ACCOUNT_ID': BadRequest,
                                'INVALID_SIDE': InvalidOrder,
                                'INVALID_ACCOUNT_HISTORY_FROM_TIME': BadRequest,
                                'INVALID_ACCOUNT_HISTORY_MAX_PAGE_SIZE': BadRequest,
                                'INVALID_ACCOUNT_HISTORY_TIME_PERIOD': BadRequest,
                                'INVALID_ACCOUNT_HISTORY_TO_TIME': BadRequest,
                                'INVALID_CANDLESTICKS_GRANULARITY': BadRequest,
                                'INVALID_CANDLESTICKS_UNIT': BadRequest,
                                'INVALID_ORDER_BOOK_DEPTH': BadRequest,
                                'INVALID_ORDER_BOOK_LEVEL': BadRequest,
                                'INVALID_PAGE_CURSOR': BadRequest,
                                'INVALID_TIME_RANGE': BadRequest,
                                'INVALID_TRADE_ID': BadRequest,
                                'INVALID_UI_ACCOUNT_SETTINGS': BadRequest,
                                'NEGATIVE_AMOUNT': InvalidOrder,
                                'NEGATIVE_PRICE': InvalidOrder,
                                'MIN_SIZE_NOT_SATISFIED': InvalidOrder,
                                'BAD_AMOUNT_PRECISION': InvalidOrder,
                                'BAD_PRICE_PRECISION': InvalidOrder,
                                'BAD_TRIGGER_PRICE_PRECISION': InvalidOrder,
                                'MAX_OPEN_ORDERS_EXCEEDED': BadRequest,
                                'MISSING_PRICE': InvalidOrder,
                                'MISSING_ORDER_TYPE': InvalidOrder,
                                'MISSING_SIDE': InvalidOrder,
                                'MISSING_CANDLESTICKS_PERIOD_PARAM': ArgumentsRequired1,
                                'MISSING_CANDLESTICKS_UNIT_PARAM': ArgumentsRequired1,
                                'MISSING_FROM_PARAM': ArgumentsRequired1,
                                'MISSING_INSTRUMENT_CODE': ArgumentsRequired1,
                                'MISSING_ORDER_ID': InvalidOrder,
                                'MISSING_TO_PARAM': ArgumentsRequired1,
                                'MISSING_TRADE_ID': ArgumentsRequired1,
                                'INVALID_ORDER_ID': OrderNotFound,
                                'NOT_FOUND': OrderNotFound,
                                'INSUFFICIENT_LIQUIDITY': InsufficientFunds,
                                'INSUFFICIENT_FUNDS': InsufficientFunds,
                                'NO_TRADING': ExchangeNotAvailable,
                                'SERVICE_UNAVAILABLE': ExchangeNotAvailable,
                                'GATEWAY_TIMEOUT': ExchangeNotAvailable,
                                'RATELIMIT': DDoSProtection,
                                'CF_RATELIMIT': DDoSProtection,
                                'INTERNAL_SERVER_ERROR': ExchangeError1
                            },
                            'broad': {}
                        },
                        'commonCurrencies': {
                            'MIOTA': 'IOTA'
                        },
                        // exchange-specific options
                        'options': {
                            'fetchTradingFees': {
                                'method': 'fetchPrivateTradingFees'
                            },
                            'fiat': [
                                'EUR',
                                'CHF'
                            ]
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTime(params);
                    //
                    //     {
                    //         iso: '2020-07-10T05:17:26.716Z',
                    //         epoch_millis: 1594358246716,
                    //     }
                    //
                    return this.safeInteger(response, 'epoch_millis');
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     [
                    //         {
                    //             "code":"BEST",
                    //             "precision":8
                    //         }
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        const id = this.safeString(currency, 'code');
                        const code = this.safeCurrencyCode(id);
                        result[code] = {
                            'id': id,
                            'code': code,
                            'name': undefined,
                            'info': currency,
                            'active': undefined,
                            'fee': undefined,
                            'precision': this.safeInteger(currency, 'precision'),
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetInstruments(params);
                    //
                    //     [
                    //         {
                    //             state: 'ACTIVE',
                    //             base: { code: 'ETH', precision: 8 },
                    //             quote: { code: 'CHF', precision: 2 },
                    //             amount_precision: 4,
                    //             market_precision: 2,
                    //             min_size: '10.0'
                    //         }
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const baseAsset = this.safeValue(market, 'base', {});
                        const quoteAsset = this.safeValue(market, 'quote', {});
                        const baseId = this.safeString(baseAsset, 'code');
                        const quoteId = this.safeString(quoteAsset, 'code');
                        const id = baseId + '_' + quoteId;
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const state = this.safeString(market, 'state');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': state === 'ACTIVE',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'amount_precision'),
                                'price': this.safeInteger(market, 'market_precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_size'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchTradingFees(params = {}) {
                    let method = this.safeString(params, 'method');
                    params = this.omit(params, 'method');
                    if (method === undefined) {
                        const options = this.safeValue(this.options, 'fetchTradingFees', {});
                        method = this.safeString(options, 'method', 'fetchPrivateTradingFees');
                    }
                    return await this[method](params);
                }
                async fetchPublicTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetFees(params);
                    //
                    //     [
                    //         {
                    //             "fee_group_id":"default",
                    //             "display_text":"The standard fee plan.",
                    //             "fee_tiers":[
                    //                 {"volume":"0.0","fee_group_id":"default","maker_fee":"0.1","taker_fee":"0.15"},
                    //                 {"volume":"100.0","fee_group_id":"default","maker_fee":"0.1","taker_fee":"0.13"},
                    //                 {"volume":"250.0","fee_group_id":"default","maker_fee":"0.09","taker_fee":"0.13"},
                    //                 {"volume":"1000.0","fee_group_id":"default","maker_fee":"0.075","taker_fee":"0.1"},
                    //                 {"volume":"5000.0","fee_group_id":"default","maker_fee":"0.06","taker_fee":"0.09"},
                    //                 {"volume":"10000.0","fee_group_id":"default","maker_fee":"0.05","taker_fee":"0.075"},
                    //                 {"volume":"20000.0","fee_group_id":"default","maker_fee":"0.05","taker_fee":"0.065"}
                    //             ],
                    //             "fee_discount_rate":"25.0",
                    //             "minimum_price_value":"0.12"
                    //         }
                    //     ]
                    //
                    const first = this.safeValue(response, 0, {});
                    const feeTiers = this.safeValue(first, 'fee_tiers');
                    const tiers = this.parseFeeTiers(feeTiers);
                    const firstTier = this.safeValue(feeTiers, 0, {});
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': first,
                            'symbol': symbol,
                            'maker': this.safeNumber(firstTier, 'maker_fee'),
                            'taker': this.safeNumber(firstTier, 'taker_fee'),
                            'percentage': true,
                            'tierBased': true,
                            'tiers': tiers
                        };
                    }
                    return result;
                }
                async fetchPrivateTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountFees(params);
                    //
                    //     {
                    //         "account_id": "ed524d00-820a-11e9-8f1e-69602df16d85",
                    //         "running_trading_volume": "0.0",
                    //         "fee_group_id": "default",
                    //         "collect_fees_in_best": false,
                    //         "fee_discount_rate": "25.0",
                    //         "minimum_price_value": "0.12",
                    //         "fee_tiers": [
                    //             { "volume": "0.0", "fee_group_id": "default", "maker_fee": "0.1", "taker_fee": "0.1" },
                    //             { "volume": "100.0", "fee_group_id": "default", "maker_fee": "0.09", "taker_fee": "0.1" },
                    //             { "volume": "250.0", "fee_group_id": "default", "maker_fee": "0.08", "taker_fee": "0.1" },
                    //             { "volume": "1000.0", "fee_group_id": "default", "maker_fee": "0.07", "taker_fee": "0.09" },
                    //             { "volume": "5000.0", "fee_group_id": "default", "maker_fee": "0.06", "taker_fee": "0.08" },
                    //             { "volume": "10000.0", "fee_group_id": "default", "maker_fee": "0.05", "taker_fee": "0.07" },
                    //             { "volume": "20000.0", "fee_group_id": "default", "maker_fee": "0.05", "taker_fee": "0.06" },
                    //             { "volume": "50000.0", "fee_group_id": "default", "maker_fee": "0.05", "taker_fee": "0.05" }
                    //         ],
                    //         "active_fee_tier": { "volume": "0.0", "fee_group_id": "default", "maker_fee": "0.1", "taker_fee": "0.1" }
                    //     }
                    //
                    const activeFeeTier = this.safeValue(response, 'active_fee_tier', {});
                    let makerFee = this.safeString(activeFeeTier, 'maker_fee');
                    let takerFee = this.safeString(activeFeeTier, 'taker_fee');
                    makerFee = Precise.stringDiv(makerFee, '100');
                    takerFee = Precise.stringDiv(takerFee, '100');
                    const feeTiers = this.safeValue(response, 'fee_tiers');
                    const result = {};
                    const tiers = this.parseFeeTiers(feeTiers);
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': this.parseNumber(makerFee),
                            'taker': this.parseNumber(takerFee),
                            'percentage': true,
                            'tierBased': true,
                            'tiers': tiers
                        };
                    }
                    return result;
                }
                parseFeeTiers(feeTiers, market) {
                    const takerFees = [];
                    const makerFees = [];
                    for(let i = 0; i < feeTiers.length; i++){
                        const tier = feeTiers[i];
                        const volume = this.safeNumber(tier, 'volume');
                        let taker = this.safeString(tier, 'taker_fee');
                        let maker = this.safeString(tier, 'maker_fee');
                        maker = Precise.stringDiv(maker, '100');
                        taker = Precise.stringDiv(taker, '100');
                        makerFees.push([
                            volume,
                            this.parseNumber(maker)
                        ]);
                        takerFees.push([
                            volume,
                            this.parseNumber(taker)
                        ]);
                    }
                    return {
                        'maker': makerFees,
                        'taker': takerFees
                    };
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker, fetchTickers
                    //
                    //     {
                    //         "instrument_code":"BTC_EUR",
                    //         "sequence":602562,
                    //         "time":"2020-07-10T06:27:34.951Z",
                    //         "state":"ACTIVE",
                    //         "is_frozen":0,
                    //         "quote_volume":"1695555.1783768",
                    //         "base_volume":"205.67436",
                    //         "last_price":"8143.91",
                    //         "best_bid":"8143.71",
                    //         "best_ask":"8156.9",
                    //         "price_change":"-147.47",
                    //         "price_change_percentage":"-1.78",
                    //         "high":"8337.45",
                    //         "low":"8110.0"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(ticker, 'time'));
                    const marketId = this.safeString(ticker, 'instrument_code');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const last = this.safeString(ticker, 'last_price');
                    const percentage = this.safeString(ticker, 'price_change_percentage');
                    const change = this.safeString(ticker, 'price_change');
                    const baseVolume = this.safeString(ticker, 'base_volume');
                    const quoteVolume = this.safeString(ticker, 'quote_volume');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'best_bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'best_ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': change,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_code': market['id']
                    };
                    const response = await this.publicGetMarketTickerInstrumentCode(this.extend(request, params));
                    //
                    //     {
                    //         "instrument_code":"BTC_EUR",
                    //         "sequence":602562,
                    //         "time":"2020-07-10T06:27:34.951Z",
                    //         "state":"ACTIVE",
                    //         "is_frozen":0,
                    //         "quote_volume":"1695555.1783768",
                    //         "base_volume":"205.67436",
                    //         "last_price":"8143.91",
                    //         "best_bid":"8143.71",
                    //         "best_ask":"8156.9",
                    //         "price_change":"-147.47",
                    //         "price_change_percentage":"-1.78",
                    //         "high":"8337.45",
                    //         "low":"8110.0"
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetMarketTicker(params);
                    //
                    //     [
                    //         {
                    //             "instrument_code":"BTC_EUR",
                    //             "sequence":602562,
                    //             "time":"2020-07-10T06:27:34.951Z",
                    //             "state":"ACTIVE",
                    //             "is_frozen":0,
                    //             "quote_volume":"1695555.1783768",
                    //             "base_volume":"205.67436",
                    //             "last_price":"8143.91",
                    //             "best_bid":"8143.71",
                    //             "best_ask":"8156.9",
                    //             "price_change":"-147.47",
                    //             "price_change_percentage":"-1.78",
                    //             "high":"8337.45",
                    //             "low":"8110.0"
                    //         }
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const ticker = this.parseTicker(response[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'instrument_code': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['depth'] = limit;
                    const response = await this.publicGetOrderBookInstrumentCode(this.extend(request, params));
                    //
                    // level 1
                    //
                    //     {
                    //         "instrument_code":"BTC_EUR",
                    //         "time":"2020-07-10T07:39:06.343Z",
                    //         "asks":{
                    //             "value":{
                    //                 "price":"8145.29",
                    //                 "amount":"0.96538",
                    //                 "number_of_orders":1
                    //             }
                    //         },
                    //         "bids":{
                    //             "value":{
                    //                 "price":"8134.0",
                    //                 "amount":"1.5978",
                    //                 "number_of_orders":5
                    //             }
                    //         }
                    //     }
                    //
                    // level 2
                    //
                    //     {
                    //         "instrument_code":"BTC_EUR","time":"2020-07-10T07:36:43.538Z",
                    //         "asks":[
                    //             {"price":"8146.59","amount":"0.89691","number_of_orders":1},
                    //             {"price":"8146.89","amount":"1.92062","number_of_orders":1},
                    //             {"price":"8169.5","amount":"0.0663","number_of_orders":1},
                    //         ],
                    //         "bids":[
                    //             {"price":"8143.49","amount":"0.01329","number_of_orders":1},
                    //             {"price":"8137.01","amount":"5.34748","number_of_orders":1},
                    //             {"price":"8137.0","amount":"2.0","number_of_orders":1},
                    //         ]
                    //     }
                    //
                    // level 3
                    //
                    //     {
                    //         "instrument_code":"BTC_EUR",
                    //         "time":"2020-07-10T07:32:31.525Z",
                    //         "bids":[
                    //             {"price":"8146.79","amount":"0.01537","order_id":"5d717da1-a8f4-422d-afcc-03cb6ab66825"},
                    //             {"price":"8139.32","amount":"3.66009","order_id":"d0715c68-f28d-4cf1-a450-d56cf650e11c"},
                    //             {"price":"8137.51","amount":"2.61049","order_id":"085fd6f4-e835-4ca5-9449-a8f165772e60"},
                    //         ],
                    //         "asks":[
                    //             {"price":"8153.49","amount":"0.93384","order_id":"755d3aa3-42b5-46fa-903d-98f42e9ae6c4"},
                    //             {"price":"8153.79","amount":"1.80456","order_id":"62034cf3-b70d-45ff-b285-ba6307941e7c"},
                    //             {"price":"8167.9","amount":"0.0018","order_id":"036354e0-71cd-492f-94f2-01f7d4b66422"},
                    //         ]
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(response, 'time'));
                    return this.parseOrderBook(response, symbol, timestamp, 'bids', 'asks', 'price', 'amount');
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "instrument_code":"BTC_EUR",
                    //         "granularity":{"unit":"HOURS","period":1},
                    //         "high":"9252.65",
                    //         "low":"9115.27",
                    //         "open":"9250.0",
                    //         "close":"9132.35",
                    //         "total_amount":"33.85924",
                    //         "volume":"311958.9635744",
                    //         "time":"2020-05-08T22:59:59.999Z",
                    //         "last_sequence":461123
                    //     }
                    //
                    const granularity = this.safeValue(ohlcv, 'granularity');
                    const unit = this.safeString(granularity, 'unit');
                    const period = this.safeString(granularity, 'period');
                    const units = {
                        'MINUTES': 'm',
                        'HOURS': 'h',
                        'DAYS': 'd',
                        'WEEKS': 'w',
                        'MONTHS': 'M'
                    };
                    const lowercaseUnit = this.safeString(units, unit);
                    const timeframe = period + lowercaseUnit;
                    const durationInSeconds = this.parseTimeframe(timeframe);
                    const duration = durationInSeconds * 1000;
                    const timestamp = this.parse8601(this.safeString(ohlcv, 'time'));
                    const alignedTimestamp = duration * parseInt(timestamp / duration);
                    const options = this.safeValue(this.options, 'fetchOHLCV', {});
                    const volumeField = this.safeString(options, 'volume', 'total_amount');
                    return [
                        alignedTimestamp,
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, volumeField)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const periodUnit = this.safeString(this.timeframes, timeframe);
                    const [period, unit] = periodUnit.split('/');
                    const durationInSeconds = this.parseTimeframe(timeframe);
                    const duration = durationInSeconds * 1000;
                    if (limit === undefined) limit = 1500;
                    const request = {
                        'instrument_code': market['id'],
                        // 'from': this.iso8601 (since),
                        // 'to': this.iso8601 (this.milliseconds ()),
                        'period': period,
                        'unit': unit
                    };
                    if (since === undefined) {
                        const now = this.milliseconds();
                        request['to'] = this.iso8601(now);
                        request['from'] = this.iso8601(now - limit * duration);
                    } else {
                        request['from'] = this.iso8601(since);
                        request['to'] = this.iso8601(this.sum(since, limit * duration));
                    }
                    const response = await this.publicGetCandlesticksInstrumentCode(this.extend(request, params));
                    //
                    //     [
                    //         {"instrument_code":"BTC_EUR","granularity":{"unit":"HOURS","period":1},"high":"9252.65","low":"9115.27","open":"9250.0","close":"9132.35","total_amount":"33.85924","volume":"311958.9635744","time":"2020-05-08T22:59:59.999Z","last_sequence":461123},
                    //         {"instrument_code":"BTC_EUR","granularity":{"unit":"HOURS","period":1},"high":"9162.49","low":"9040.0","open":"9132.53","close":"9083.69","total_amount":"26.19685","volume":"238553.7812365","time":"2020-05-08T23:59:59.999Z","last_sequence":461376},
                    //         {"instrument_code":"BTC_EUR","granularity":{"unit":"HOURS","period":1},"high":"9135.7","low":"9002.59","open":"9055.45","close":"9133.98","total_amount":"26.21919","volume":"238278.8724959","time":"2020-05-09T00:59:59.999Z","last_sequence":461521},
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "instrument_code":"BTC_EUR",
                    //         "price":"8137.28",
                    //         "amount":"0.22269",
                    //         "taker_side":"BUY",
                    //         "volume":"1812.0908832",
                    //         "time":"2020-07-10T14:44:32.299Z",
                    //         "trade_timestamp":1594392272299,
                    //         "sequence":603047
                    //     }
                    //
                    // fetchMyTrades, fetchOrder, fetchOpenOrders, fetchClosedOrders trades (private)
                    //
                    //     {
                    //         "fee": {
                    //             "fee_amount": "0.0014",
                    //             "fee_currency": "BTC",
                    //             "fee_percentage": "0.1",
                    //             "fee_group_id": "default",
                    //             "fee_type": "TAKER",
                    //             "running_trading_volume": "0.0"
                    //         },
                    //         "trade": {
                    //             "trade_id": "fdff2bcc-37d6-4a2d-92a5-46e09c868664",
                    //             "order_id": "36bb2437-7402-4794-bf26-4bdf03526439",
                    //             "account_id": "a4c699f6-338d-4a26-941f-8f9853bfc4b9",
                    //             "amount": "1.4",
                    //             "side": "BUY",
                    //             "instrument_code": "BTC_EUR",
                    //             "price": "7341.4",
                    //             "time": "2019-09-27T15:05:32.564Z",
                    //             "sequence": 48670
                    //         }
                    //     }
                    //
                    const feeInfo = this.safeValue(trade, 'fee', {});
                    trade = this.safeValue(trade, 'trade', trade);
                    let timestamp = this.safeInteger(trade, 'trade_timestamp');
                    if (timestamp === undefined) timestamp = this.parse8601(this.safeString(trade, 'time'));
                    const side = this.safeStringLower2(trade, 'side', 'taker_side');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const costString = this.safeString(trade, 'volume');
                    const marketId = this.safeString(trade, 'instrument_code');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const feeCostString = this.safeString(feeInfo, 'fee_amount');
                    let takerOrMaker = undefined;
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(feeInfo, 'fee_currency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        const feeRateString = this.safeString(feeInfo, 'fee_percentage');
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode,
                            'rate': feeRateString
                        };
                        takerOrMaker = this.safeStringLower(feeInfo, 'fee_type');
                    }
                    return this.safeTrade({
                        'id': this.safeString2(trade, 'trade_id', 'sequence'),
                        'order': this.safeString(trade, 'order_id'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'takerOrMaker': takerOrMaker,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_code': market['id']
                    };
                    if (since !== undefined) {
                        // returns price ticks for a specific market with an interval of maximum of 4 hours
                        // sorted by latest first
                        request['from'] = this.iso8601(since);
                        request['to'] = this.iso8601(this.sum(since, 14400000));
                    }
                    const response = await this.publicGetPriceTicksInstrumentCode(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "instrument_code":"BTC_EUR",
                    //             "price":"8137.28",
                    //             "amount":"0.22269",
                    //             "taker_side":"BUY",
                    //             "volume":"1812.0908832",
                    //             "time":"2020-07-10T14:44:32.299Z",
                    //             "trade_timestamp":1594392272299,
                    //             "sequence":603047
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'balances', []);
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency_code');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'locked');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountBalances(params);
                    //
                    //     {
                    //         "account_id":"4b95934f-55f1-460c-a525-bd5afc0cf071",
                    //         "balances":[
                    //             {
                    //                 "account_id":"4b95934f-55f1-460c-a525-bd5afc0cf071",
                    //                 "currency_code":"BTC",
                    //                 "change":"10.0",
                    //                 "available":"10.0",
                    //                 "locked":"0.0",
                    //                 "sequence":142135994,
                    //                 "time":"2020-07-01T10:57:32.959Z"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseBalance(response);
                }
                parseDepositAddress(depositAddress, currency) {
                    let code = undefined;
                    if (currency !== undefined) code = currency['code'];
                    const address = this.safeString(depositAddress, 'address');
                    const tag = this.safeString(depositAddress, 'destination_tag');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': depositAddress
                    };
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privatePostAccountDepositCrypto(this.extend(request, params));
                    //
                    //     {
                    //         "address":"rBnNhk95FrdNisZtXcStzriFS8vEzz53DM",
                    //         "destination_tag":"865690307",
                    //         "enabled":true,
                    //         "is_smart_contract":false
                    //     }
                    //
                    return this.parseDepositAddress(response, currency);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency_code': currency['id']
                    };
                    const response = await this.privateGetAccountDepositCryptoCurrencyCode(this.extend(request, params));
                    //
                    //     {
                    //         "address":"rBnNhk95FrdNisZtXcStzriFS8vEzz53DM",
                    //         "destination_tag":"865690307",
                    //         "enabled":true,
                    //         "is_smart_contract":false,
                    //         "can_create_more":false
                    //     }
                    //
                    return this.parseDepositAddress(response, currency);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency_code'] = currency['id'];
                    }
                    if (limit !== undefined) request['max_page_size'] = limit;
                    if (since !== undefined) {
                        const to = this.safeString(params, 'to');
                        if (to === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires a "to" iso8601 string param with the since argument is specified');
                        request['from'] = this.iso8601(since);
                    }
                    const response = await this.privateGetAccountDeposits(this.extend(request, params));
                    //
                    //     {
                    //         "deposit_history": [
                    //             {
                    //                 "transaction_id": "e5342efcd-d5b7-4a56-8e12-b69ffd68c5ef",
                    //                 "account_id": "c2d0076a-c20d-41f8-9e9a-1a1d028b2b58",
                    //                 "amount": "100",
                    //                 "type": "CRYPTO",
                    //                 "funds_source": "INTERNAL",
                    //                 "time": "2020-04-22T09:57:47Z",
                    //                 "currency": "BTC",
                    //                 "fee_amount": "0.0",
                    //                 "fee_currency": "BTC"
                    //             },
                    //             {
                    //                 "transaction_id": "79793d00-2899-4a4d-95b7-73ae6b31384f",
                    //                 "account_id": "c2d0076a-c20d-41f8-9e9a-1a1d028b2b58",
                    //                 "time": "2020-05-05T11:22:07.925Z",
                    //                 "currency": "EUR",
                    //                 "funds_source": "EXTERNAL",
                    //                 "type": "FIAT",
                    //                 "amount": "50.0",
                    //                 "fee_amount": "0.01",
                    //                 "fee_currency": "EUR"
                    //             }
                    //         ],
                    //         "max_page_size": 2,
                    //         "cursor": "eyJhY2NvdW50X2lkIjp7InMiOiJlMzY5YWM4MC00NTc3LTExZTktYWUwOC05YmVkYzQ3OTBiODQiLCJzcyI6W10sIm5zIjpbXSwiYnMiOltdLCJtIjp7fSwibCI6W119LCJpdGVtX2tleSI6eyJzIjoiV0lUSERSQVdBTDo6MmFlMjYwY2ItOTk3MC00YmNiLTgxNmEtZGY4MDVmY2VhZTY1Iiwic3MiOltdLCJucyI6W10sImJzIjpbXSwibSI6e30sImwiOltdfSwiZ2xvYmFsX3dpdGhkcmF3YWxfaW5kZXhfaGFzaF9rZXkiOnsicyI6ImUzNjlhYzgwLTQ1NzctMTFlOS1hZTA4LTliZWRjNDc5MGI4NCIsInNzIjpbXSwibnMiOltdLCJicyI6W10sIm0iOnt9LCJsIjpbXX0sInRpbWVzdGFtcCI6eyJuIjoiMTU4ODA1ODc2Nzk0OCIsInNzIjpbXSwibnMiOltdLCJicyI6W10sIm0iOnt9LCJsIjpbXX19"
                    //     }
                    //
                    const depositHistory = this.safeValue(response, 'deposit_history', []);
                    return this.parseTransactions(depositHistory, currency, since, limit, {
                        'type': 'deposit'
                    });
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency_code'] = currency['id'];
                    }
                    if (limit !== undefined) request['max_page_size'] = limit;
                    if (since !== undefined) {
                        const to = this.safeString(params, 'to');
                        if (to === undefined) throw new ArgumentsRequired1(this.id + ' fetchWithdrawals() requires a "to" iso8601 string param with the since argument is specified');
                        request['from'] = this.iso8601(since);
                    }
                    const response = await this.privateGetAccountWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         "withdrawal_history": [
                    //             {
                    //                 "account_id": "e369ac80-4577-11e9-ae08-9bedc4790b84",
                    //                 "amount": "0.1",
                    //                 "currency": "BTC",
                    //                 "fee_amount": "0.00002",
                    //                 "fee_currency": "BTC",
                    //                 "funds_source": "EXTERNAL",
                    //                 "related_transaction_id": "e298341a-3855-405e-bce3-92db368a3157",
                    //                 "time": "2020-05-05T11:11:32.110Z",
                    //                 "transaction_id": "6693ff40-bb10-4dcf-ada7-3b287727c882",
                    //                 "type": "CRYPTO"
                    //             },
                    //             {
                    //                 "account_id": "e369ac80-4577-11e9-ae08-9bedc4790b84",
                    //                 "amount": "0.1",
                    //                 "currency": "BTC",
                    //                 "fee_amount": "0.0",
                    //                 "fee_currency": "BTC",
                    //                 "funds_source": "INTERNAL",
                    //                 "time": "2020-05-05T10:29:53.464Z",
                    //                 "transaction_id": "ec9703b1-954b-4f76-adea-faac66eabc0b",
                    //                 "type": "CRYPTO"
                    //             }
                    //         ],
                    //         "cursor": "eyJhY2NvdW50X2lkIjp7InMiOiJlMzY5YWM4MC00NTc3LTExZTktYWUwOC05YmVkYzQ3OTBiODQiLCJzcyI6W10sIm5zIjpbXSwiYnMiOltdLCJtIjp7fSwibCI6W119LCJpdGVtX2tleSI6eyJzIjoiV0lUSERSQVdBTDo6ZWM5NzAzYjEtOTU0Yi00Zjc2LWFkZWEtZmFhYzY2ZWFiYzBiIiwic3MiOltdLCJucyI6W10sImJzIjpbXSwibSI6e30sImwiOltdfSwiZ2xvYmFsX3dpdGhkcmF3YWxfaW5kZXhfaGFzaF9rZXkiOnsicyI6ImUzNjlhYzgwLTQ1NzctMTFlOS1hZTA4LTliZWRjNDc5MGI4NCIsInNzIjpbXSwibnMiOltdLCJicyI6W10sIm0iOnt9LCJsIjpbXX0sInRpbWVzdGFtcCI6eyJuIjoiMTU4ODY3NDU5MzQ2NCIsInNzIjpbXSwibnMiOltdLCJicyI6W10sIm0iOnt9LCJsIjpbXX19",
                    //         "max_page_size": 2
                    //     }
                    //
                    const withdrawalHistory = this.safeValue(response, 'withdrawal_history', []);
                    return this.parseTransactions(withdrawalHistory, currency, since, limit, {
                        'type': 'withdrawal'
                    });
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': code,
                        'amount': this.currencyToPrecision(code, amount)
                    };
                    const options = this.safeValue(this.options, 'fiat', []);
                    const isFiat = this.inArray(code, options);
                    const method = isFiat ? 'privatePostAccountWithdrawFiat' : 'privatePostAccountWithdrawCrypto';
                    if (isFiat) {
                        const payoutAccountId = this.safeString(params, 'payout_account_id');
                        if (payoutAccountId === undefined) throw ArgumentsRequired1(this.id + ' withdraw() requires a payout_account_id param for fiat ' + code + ' withdrawals');
                    } else {
                        const recipient = {
                            'address': address
                        };
                        if (tag !== undefined) recipient['destination_tag'] = tag;
                        request['recipient'] = recipient;
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // crypto
                    //
                    //     {
                    //         "amount": "1234.5678",
                    //         "fee": "1234.5678",
                    //         "recipient": "3NacQ7rzZdhfyAtfJ5a11k8jFPdcMP2Bq7",
                    //         "destination_tag": "",
                    //         "transaction_id": "d0f8529f-f832-4e6a-9dc5-b8d5797badb2"
                    //     }
                    //
                    // fiat
                    //
                    //     {
                    //         "transaction_id": "54236cd0-4413-11e9-93fb-5fea7e5b5df6"
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits, fetchWithdrawals
                    //
                    //     {
                    //         "transaction_id": "C2b42efcd-d5b7-4a56-8e12-b69ffd68c5ef",
                    //         "type": "FIAT",
                    //         "account_id": "c2d0076a-c20d-41f8-9e9a-1a1d028b2b58",
                    //         "amount": "1234.5678",
                    //         "time": "2019-08-24T14:15:22Z",
                    //         "funds_source": "INTERNAL",
                    //         "currency": "BTC",
                    //         "fee_amount": "1234.5678",
                    //         "fee_currency": "BTC",
                    //         "blockchain_transaction_id": "f4184fc596403b9d638783cf57adfe4c75c605f6356fbc91338530e9831e9e16",
                    //         "related_transaction_id": "e298341a-3855-405e-bce3-92db368a3157"
                    //     }
                    //
                    // withdraw
                    //
                    //
                    //     crypto
                    //
                    //     {
                    //         "amount": "1234.5678",
                    //         "fee": "1234.5678",
                    //         "recipient": "3NacQ7rzZdhfyAtfJ5a11k8jFPdcMP2Bq7",
                    //         "destination_tag": "",
                    //         "transaction_id": "d0f8529f-f832-4e6a-9dc5-b8d5797badb2"
                    //     }
                    //
                    //     fiat
                    //
                    //     {
                    //         "transaction_id": "54236cd0-4413-11e9-93fb-5fea7e5b5df6"
                    //     }
                    //
                    const id = this.safeString(transaction, 'transaction_id');
                    const amount = this.safeNumber(transaction, 'amount');
                    const timestamp = this.parse8601(this.safeString(transaction, 'time'));
                    const currencyId = this.safeString(transaction, 'currency');
                    currency = this.safeCurrency(currencyId, currency);
                    const status = 'ok'; // the exchange returns cleared transactions only
                    const feeCost = this.safeNumber2(transaction, 'fee_amount', 'fee');
                    let fee = undefined;
                    const addressTo = this.safeString(transaction, 'recipient');
                    const tagTo = this.safeString(transaction, 'destination_tag');
                    if (feeCost !== undefined) {
                        const feeCurrencyId = this.safeString(transaction, 'fee_currency', currencyId);
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrencyCode
                        };
                    }
                    return {
                        'info': transaction,
                        'id': id,
                        'currency': currency['code'],
                        'amount': amount,
                        'network': undefined,
                        'address': addressTo,
                        'addressFrom': undefined,
                        'addressTo': addressTo,
                        'tag': tagTo,
                        'tagFrom': undefined,
                        'tagTo': tagTo,
                        'status': status,
                        'type': undefined,
                        'updated': undefined,
                        'txid': this.safeString(transaction, 'blockchain_transaction_id'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': fee
                    };
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'FILLED': 'open',
                        'FILLED_FULLY': 'closed',
                        'FILLED_CLOSED': 'canceled',
                        'FILLED_REJECTED': 'rejected',
                        'OPEN': 'open',
                        'REJECTED': 'rejected',
                        'CLOSED': 'canceled',
                        'FAILED': 'failed',
                        'STOP_TRIGGERED': 'triggered'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "order_id": "d5492c24-2995-4c18-993a-5b8bf8fffc0d",
                    //         "client_id": "d75fb03b-b599-49e9-b926-3f0b6d103206",
                    //         "account_id": "a4c699f6-338d-4a26-941f-8f9853bfc4b9",
                    //         "instrument_code": "BTC_EUR",
                    //         "time": "2019-08-01T08:00:44.026Z",
                    //         "side": "BUY",
                    //         "price": "5000",
                    //         "amount": "1",
                    //         "filled_amount": "0.5",
                    //         "type": "LIMIT",
                    //         "time_in_force": "GOOD_TILL_CANCELLED"
                    //     }
                    //
                    // fetchOrder, fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "order": {
                    //             "order_id": "66756a10-3e86-48f4-9678-b634c4b135b2",
                    //             "account_id": "1eb2ad5d-55f1-40b5-bc92-7dc05869e905",
                    //             "instrument_code": "BTC_EUR",
                    //             "amount": "1234.5678",
                    //             "filled_amount": "1234.5678",
                    //             "side": "BUY",
                    //             "type": "LIMIT",
                    //             "status": "OPEN",
                    //             "sequence": 123456789,
                    //             "price": "1234.5678",
                    //             "average_price": "1234.5678",
                    //             "reason": "INSUFFICIENT_FUNDS",
                    //             "time": "2019-08-24T14:15:22Z",
                    //             "time_in_force": "GOOD_TILL_CANCELLED",
                    //             "time_last_updated": "2019-08-24T14:15:22Z",
                    //             "expire_after": "2019-08-24T14:15:22Z",
                    //             "is_post_only": false,
                    //             "time_triggered": "2019-08-24T14:15:22Z",
                    //             "trigger_price": "1234.5678"
                    //         },
                    //         "trades": [
                    //             {
                    //                 "fee": {
                    //                     "fee_amount": "0.0014",
                    //                     "fee_currency": "BTC",
                    //                     "fee_percentage": "0.1",
                    //                     "fee_group_id": "default",
                    //                     "fee_type": "TAKER",
                    //                     "running_trading_volume": "0.0"
                    //                 },
                    //                 "trade": {
                    //                     "trade_id": "fdff2bcc-37d6-4a2d-92a5-46e09c868664",
                    //                     "order_id": "36bb2437-7402-4794-bf26-4bdf03526439",
                    //                     "account_id": "a4c699f6-338d-4a26-941f-8f9853bfc4b9",
                    //                     "amount": "1.4",
                    //                     "side": "BUY",
                    //                     "instrument_code": "BTC_EUR",
                    //                     "price": "7341.4",
                    //                     "time": "2019-09-27T15:05:32.564Z",
                    //                     "sequence": 48670
                    //                 }
                    //             }
                    //         ]
                    //     }
                    //
                    const rawOrder = this.safeValue(order, 'order', order);
                    const id = this.safeString(rawOrder, 'order_id');
                    const clientOrderId = this.safeString(rawOrder, 'client_id');
                    const timestamp = this.parse8601(this.safeString(rawOrder, 'time'));
                    const rawStatus = this.parseOrderStatus(this.safeString(rawOrder, 'status'));
                    const status = this.parseOrderStatus(rawStatus);
                    const marketId = this.safeString(rawOrder, 'instrument_code');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const price = this.safeString(rawOrder, 'price');
                    const amount = this.safeString(rawOrder, 'amount');
                    const filled = this.safeString(rawOrder, 'filled_amount');
                    const side = this.safeStringLower(rawOrder, 'side');
                    const type = this.safeStringLower(rawOrder, 'type');
                    const timeInForce = this.parseTimeInForce(this.safeString(rawOrder, 'time_in_force'));
                    const stopPrice = this.safeNumber(rawOrder, 'trigger_price');
                    const postOnly = this.safeValue(rawOrder, 'is_post_only');
                    const rawTrades = this.safeValue(order, 'trades', []);
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': undefined,
                        'average': undefined,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        // 'fee': undefined,
                        'trades': rawTrades
                    }, market);
                }
                parseTimeInForce(timeInForce) {
                    const timeInForces = {
                        'GOOD_TILL_CANCELLED': 'GTC',
                        'GOOD_TILL_TIME': 'GTT',
                        'IMMEDIATE_OR_CANCELLED': 'IOC',
                        'FILL_OR_KILL': 'FOK'
                    };
                    return this.safeString(timeInForces, timeInForce, timeInForce);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const uppercaseType = type.toUpperCase();
                    const request = {
                        'instrument_code': market['id'],
                        'type': uppercaseType,
                        'side': side.toUpperCase(),
                        'amount': this.amountToPrecision(symbol, amount)
                    };
                    let priceIsRequired = false;
                    if (uppercaseType === 'LIMIT' || uppercaseType === 'STOP') priceIsRequired = true;
                    if (uppercaseType === 'STOP') {
                        const triggerPrice = this.safeNumber(params, 'trigger_price');
                        if (triggerPrice === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a trigger_price param for ' + type + ' orders');
                        request['trigger_price'] = this.priceToPrecision(symbol, triggerPrice);
                        params = this.omit(params, 'trigger_price');
                    }
                    if (priceIsRequired) request['price'] = this.priceToPrecision(symbol, price);
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client_id');
                    if (clientOrderId !== undefined) {
                        request['client_id'] = clientOrderId;
                        params = this.omit(params, [
                            'clientOrderId',
                            'client_id'
                        ]);
                    }
                    const response = await this.privatePostAccountOrders(this.extend(request, params));
                    //
                    //     {
                    //         "order_id": "d5492c24-2995-4c18-993a-5b8bf8fffc0d",
                    //         "client_id": "d75fb03b-b599-49e9-b926-3f0b6d103206",
                    //         "account_id": "a4c699f6-338d-4a26-941f-8f9853bfc4b9",
                    //         "instrument_code": "BTC_EUR",
                    //         "time": "2019-08-01T08:00:44.026Z",
                    //         "side": "BUY",
                    //         "price": "5000",
                    //         "amount": "1",
                    //         "filled_amount": "0.5",
                    //         "type": "LIMIT",
                    //         "time_in_force": "GOOD_TILL_CANCELLED"
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client_id');
                    params = this.omit(params, [
                        'clientOrderId',
                        'client_id'
                    ]);
                    let method = 'privateDeleteAccountOrdersOrderId';
                    const request = {};
                    if (clientOrderId !== undefined) {
                        method = 'privateDeleteAccountOrdersClientClientId';
                        request['client_id'] = clientOrderId;
                    } else request['order_id'] = id;
                    const response = await this[method](this.extend(request, params));
                    //
                    // responds with an empty body
                    //
                    return response;
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        request['instrument_code'] = market['id'];
                    }
                    const response = await this.privateDeleteAccountOrders(this.extend(request, params));
                    //
                    //     [
                    //         "a10e9bd1-8f72-4cfe-9f1b-7f1c8a9bd8ee"
                    //     ]
                    //
                    return response;
                }
                async cancelOrders(ids, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'ids': ids.join(',')
                    };
                    const response = await this.privateDeleteAccountOrders(this.extend(request, params));
                    //
                    //     [
                    //         "a10e9bd1-8f72-4cfe-9f1b-7f1c8a9bd8ee"
                    //     ]
                    //
                    return response;
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privateGetAccountOrdersOrderId(this.extend(request, params));
                    //
                    //     {
                    //         "order": {
                    //             "order_id": "36bb2437-7402-4794-bf26-4bdf03526439",
                    //             "account_id": "a4c699f6-338d-4a26-941f-8f9853bfc4b9",
                    //             "time_last_updated": "2019-09-27T15:05:35.096Z",
                    //             "sequence": 48782,
                    //             "price": "7349.2",
                    //             "filled_amount": "100.0",
                    //             "status": "FILLED_FULLY",
                    //             "amount": "100.0",
                    //             "instrument_code": "BTC_EUR",
                    //             "side": "BUY",
                    //             "time": "2019-09-27T15:05:32.063Z",
                    //             "type": "MARKET"
                    //         },
                    //         "trades": [
                    //             {
                    //                 "fee": {
                    //                     "fee_amount": "0.0014",
                    //                     "fee_currency": "BTC",
                    //                     "fee_percentage": "0.1",
                    //                     "fee_group_id": "default",
                    //                     "fee_type": "TAKER",
                    //                     "running_trading_volume": "0.0"
                    //                 },
                    //                 "trade": {
                    //                     "trade_id": "fdff2bcc-37d6-4a2d-92a5-46e09c868664",
                    //                     "order_id": "36bb2437-7402-4794-bf26-4bdf03526439",
                    //                     "account_id": "a4c699f6-338d-4a26-941f-8f9853bfc4b9",
                    //                     "amount": "1.4",
                    //                     "side": "BUY",
                    //                     "instrument_code": "BTC_EUR",
                    //                     "price": "7341.4",
                    //                     "time": "2019-09-27T15:05:32.564Z",
                    //                     "sequence": 48670
                    //                 }
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instrument_code'] = market['id'];
                    }
                    if (since !== undefined) {
                        const to = this.safeString(params, 'to');
                        if (to === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a "to" iso8601 string param with the since argument is specified, max range is 100 days');
                        request['from'] = this.iso8601(since);
                    }
                    if (limit !== undefined) request['max_page_size'] = limit;
                    const response = await this.privateGetAccountOrders(this.extend(request, params));
                    //
                    //     {
                    //         "order_history": [
                    //             {
                    //                 "order": {
                    //                     "trigger_price": "12089.88",
                    //                     "order_id": "d453ca12-c650-46dd-9dee-66910d96bfc0",
                    //                     "account_id": "ef3a5f4c-cfcd-415e-ba89-5a9abf47b28a",
                    //                     "instrument_code": "BTC_USDT",
                    //                     "time": "2019-08-23T10:02:31.663Z",
                    //                     "side": "SELL",
                    //                     "price": "10159.76",
                    //                     "average_price": "10159.76",
                    //                     "amount": "0.2",
                    //                     "filled_amount": "0.2",
                    //                     "type": "STOP",
                    //                     "sequence": 8,
                    //                     "status": "FILLED_FULLY"
                    //                 },
                    //                 "trades": [
                    //                     {
                    //                         "fee": {
                    //                             "fee_amount": "0.4188869",
                    //                             "fee_currency": "USDT",
                    //                             "fee_percentage": "0.1",
                    //                             "fee_group_id": "default",
                    //                             "fee_type": "TAKER",
                    //                             "running_trading_volume": "0.0"
                    //                         },
                    //                         "trade": {
                    //                             "trade_id": "ec82896f-fd1b-4cbb-89df-a9da85ccbb4b",
                    //                             "order_id": "d453ca12-c650-46dd-9dee-66910d96bfc0",
                    //                             "account_id": "ef3a5f4c-cfcd-415e-ba89-5a9abf47b28a",
                    //                             "amount": "0.2",
                    //                             "side": "SELL",
                    //                             "instrument_code": "BTC_USDT",
                    //                             "price": "10159.76",
                    //                             "time": "2019-08-23T10:02:32.663Z",
                    //                             "sequence": 9
                    //                         }
                    //                     }
                    //                 ]
                    //             },
                    //             {
                    //                 "order": {
                    //                     "order_id": "5151a99e-f414-418f-8cf1-2568d0a63ea5",
                    //                     "account_id": "ef3a5f4c-cfcd-415e-ba89-5a9abf47b28a",
                    //                     "instrument_code": "BTC_USDT",
                    //                     "time": "2019-08-23T10:01:36.773Z",
                    //                     "side": "SELL",
                    //                     "price": "12289.88",
                    //                     "amount": "0.5",
                    //                     "filled_amount": "0.0",
                    //                     "type": "LIMIT",
                    //                     "sequence": 7,
                    //                     "status": "OPEN"
                    //                 },
                    //                 "trades": []
                    //             },
                    //             {
                    //                 "order": {
                    //                     "order_id": "ac80d857-75e1-4733-9070-fd4288395fdc",
                    //                     "account_id": "ef3a5f4c-cfcd-415e-ba89-5a9abf47b28a",
                    //                     "instrument_code": "BTC_USDT",
                    //                     "time": "2019-08-23T10:01:25.031Z",
                    //                     "side": "SELL",
                    //                     "price": "11089.88",
                    //                     "amount": "0.1",
                    //                     "filled_amount": "0.0",
                    //                     "type": "LIMIT",
                    //                     "sequence": 6,
                    //                     "status": "OPEN"
                    //                 },
                    //                 "trades": []
                    //             }
                    //         ],
                    //         "max_page_size": 100
                    //     }
                    //
                    const orderHistory = this.safeValue(response, 'order_history', []);
                    return this.parseOrders(orderHistory, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'with_cancelled_and_rejected': true
                    };
                    return await this.fetchOpenOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    if (limit !== undefined) request['max_page_size'] = limit;
                    const response = await this.privateGetAccountOrdersOrderIdTrades(this.extend(request, params));
                    //
                    //     {
                    //         "trade_history": [
                    //             {
                    //                 "trade": {
                    //                     "trade_id": "2b42efcd-d5b7-4a56-8e12-b69ffd68c5ef",
                    //                     "order_id": "66756a10-3e86-48f4-9678-b634c4b135b2",
                    //                     "account_id": "c2d0076a-c20d-41f8-9e9a-1a1d028b2b58",
                    //                     "amount": "1234.5678",
                    //                     "side": "BUY",
                    //                     "instrument_code": "BTC_EUR",
                    //                     "price": "1234.5678",
                    //                     "time": "2019-08-24T14:15:22Z",
                    //                     "price_tick_sequence": 0,
                    //                     "sequence": 123456789
                    //                 },
                    //                 "fee": {
                    //                     "fee_amount": "1234.5678",
                    //                     "fee_percentage": "1234.5678",
                    //                     "fee_group_id": "default",
                    //                     "running_trading_volume": "1234.5678",
                    //                     "fee_currency": "BTC",
                    //                     "fee_type": "TAKER"
                    //                 }
                    //             }
                    //         ],
                    //         "max_page_size": 0,
                    //         "cursor": "string"
                    //     }
                    //
                    const tradeHistory = this.safeValue(response, 'trade_history', []);
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    return this.parseTrades(tradeHistory, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instrument_code'] = market['id'];
                    }
                    if (since !== undefined) {
                        const to = this.safeString(params, 'to');
                        if (to === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a "to" iso8601 string param with the since argument is specified, max range is 100 days');
                        request['from'] = this.iso8601(since);
                    }
                    if (limit !== undefined) request['max_page_size'] = limit;
                    const response = await this.privateGetAccountTrades(this.extend(request, params));
                    //
                    //     {
                    //         "trade_history": [
                    //             {
                    //                 "trade": {
                    //                     "trade_id": "2b42efcd-d5b7-4a56-8e12-b69ffd68c5ef",
                    //                     "order_id": "66756a10-3e86-48f4-9678-b634c4b135b2",
                    //                     "account_id": "c2d0076a-c20d-41f8-9e9a-1a1d028b2b58",
                    //                     "amount": "1234.5678",
                    //                     "side": "BUY",
                    //                     "instrument_code": "BTC_EUR",
                    //                     "price": "1234.5678",
                    //                     "time": "2019-08-24T14:15:22Z",
                    //                     "price_tick_sequence": 0,
                    //                     "sequence": 123456789
                    //                 },
                    //                 "fee": {
                    //                     "fee_amount": "1234.5678",
                    //                     "fee_percentage": "1234.5678",
                    //                     "fee_group_id": "default",
                    //                     "running_trading_volume": "1234.5678",
                    //                     "fee_currency": "BTC",
                    //                     "fee_type": "TAKER"
                    //                 }
                    //             }
                    //         ],
                    //         "max_page_size": 0,
                    //         "cursor": "string"
                    //     }
                    //
                    const tradeHistory = this.safeValue(response, 'trade_history', []);
                    return this.parseTrades(tradeHistory, market, since, limit);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'private') {
                        this.checkRequiredCredentials();
                        headers = {
                            'Accept': 'application/json',
                            'Authorization': 'Bearer ' + this.apiKey
                        };
                        if (method === 'POST') {
                            body = this.json(query);
                            headers['Content-Type'] = 'application/json';
                        } else if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    //     {"error":"MISSING_FROM_PARAM"}
                    //     {"error":"MISSING_TO_PARAM"}
                    //     {"error":"CANDLESTICKS_TIME_RANGE_TOO_BIG"}
                    //
                    const message = this.safeString(response, 'error');
                    if (message !== undefined) {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    42: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, ExchangeNotAvailable: ExchangeNotAvailable, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, DDoSProtection: DDoSProtection, InvalidNonce: InvalidNonce, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded, PermissionDenied: PermissionDenied, BadRequest: BadRequest, BadSymbol: BadSymbol, AccountSuspended: AccountSuspended, OrderImmediatelyFillable: OrderImmediatelyFillable, OnMaintenance: OnMaintenance } = require1('./base/errors');
            const { TRUNCATE: TRUNCATE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bitrue extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitrue',
                        'name': 'Bitrue',
                        'countries': [
                            'SG'
                        ],
                        'rateLimit': 1000,
                        'certified': false,
                        'version': 'v1',
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': undefined,
                            'future': undefined,
                            'option': false,
                            'cancelAllOrders': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchBidsAsks': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': false,
                            'fetchDeposits': true,
                            'fetchFundingFees': false,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': 'emulated',
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': false,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransactions': false,
                            'fetchTransfers': false,
                            'fetchWithdrawals': true,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '1d': '1d',
                            '1w': '1w',
                            '1M': '1M'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/139516488-243a830d-05dd-446b-91c6-c1f18fe30c63.jpg',
                            'api': {
                                'v1': 'https://www.bitrue.com/api/v1',
                                'v2': 'https://www.bitrue.com/api/v2',
                                'kline': 'https://www.bitrue.com/kline-api'
                            },
                            'www': 'https://www.bitrue.com',
                            'referral': 'https://www.bitrue.com/activity/task/task-landing?inviteCode=EZWETQE&cn=900000',
                            'doc': [
                                'https://github.com/Bitrue-exchange/bitrue-official-api-docs'
                            ],
                            'fees': 'https://bitrue.zendesk.com/hc/en-001/articles/4405479952537'
                        },
                        'api': {
                            'kline': {
                                'public': {
                                    'get': {
                                        'public.json': 1,
                                        'public{currency}.json': 1
                                    }
                                }
                            },
                            'v1': {
                                'public': {
                                    'get': {
                                        'ping': 1,
                                        'time': 1,
                                        'exchangeInfo': 1,
                                        'depth': {
                                            'cost': 1,
                                            'byLimit': [
                                                [
                                                    100,
                                                    1
                                                ],
                                                [
                                                    500,
                                                    5
                                                ],
                                                [
                                                    1000,
                                                    10
                                                ]
                                            ]
                                        },
                                        'trades': 1,
                                        'historicalTrades': 5,
                                        'aggTrades': 1,
                                        'ticker/24hr': {
                                            'cost': 1,
                                            'noSymbol': 40
                                        },
                                        'ticker/price': {
                                            'cost': 1,
                                            'noSymbol': 2
                                        },
                                        'ticker/bookTicker': {
                                            'cost': 1,
                                            'noSymbol': 2
                                        }
                                    }
                                },
                                'private': {
                                    'get': {
                                        'order': 1,
                                        'openOrders': 1,
                                        'allOrders': 5,
                                        'account': 5,
                                        'myTrades': {
                                            'cost': 5,
                                            'noSymbol': 40
                                        },
                                        'etf/net-value/{symbol}': 1,
                                        'withdraw/history': 1,
                                        'deposit/history': 1
                                    },
                                    'post': {
                                        'order': 4,
                                        'withdraw/commit': 1
                                    },
                                    'delete': {
                                        'order': 1
                                    }
                                }
                            },
                            'v2': {
                                'private': {
                                    'get': {
                                        'myTrades': 5
                                    }
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': false,
                                'percentage': true,
                                'taker': this.parseNumber('0.00098'),
                                'maker': this.parseNumber('0.00098')
                            },
                            'future': {
                                'trading': {
                                    'feeSide': 'quote',
                                    'tierBased': true,
                                    'percentage': true,
                                    'taker': this.parseNumber('0.000400'),
                                    'maker': this.parseNumber('0.000200'),
                                    'tiers': {
                                        'taker': [
                                            [
                                                this.parseNumber('0'),
                                                this.parseNumber('0.000400')
                                            ],
                                            [
                                                this.parseNumber('250'),
                                                this.parseNumber('0.000400')
                                            ],
                                            [
                                                this.parseNumber('2500'),
                                                this.parseNumber('0.000350')
                                            ],
                                            [
                                                this.parseNumber('7500'),
                                                this.parseNumber('0.000320')
                                            ],
                                            [
                                                this.parseNumber('22500'),
                                                this.parseNumber('0.000300')
                                            ],
                                            [
                                                this.parseNumber('50000'),
                                                this.parseNumber('0.000270')
                                            ],
                                            [
                                                this.parseNumber('100000'),
                                                this.parseNumber('0.000250')
                                            ],
                                            [
                                                this.parseNumber('200000'),
                                                this.parseNumber('0.000220')
                                            ],
                                            [
                                                this.parseNumber('400000'),
                                                this.parseNumber('0.000200')
                                            ],
                                            [
                                                this.parseNumber('750000'),
                                                this.parseNumber('0.000170')
                                            ]
                                        ],
                                        'maker': [
                                            [
                                                this.parseNumber('0'),
                                                this.parseNumber('0.000200')
                                            ],
                                            [
                                                this.parseNumber('250'),
                                                this.parseNumber('0.000160')
                                            ],
                                            [
                                                this.parseNumber('2500'),
                                                this.parseNumber('0.000140')
                                            ],
                                            [
                                                this.parseNumber('7500'),
                                                this.parseNumber('0.000120')
                                            ],
                                            [
                                                this.parseNumber('22500'),
                                                this.parseNumber('0.000100')
                                            ],
                                            [
                                                this.parseNumber('50000'),
                                                this.parseNumber('0.000080')
                                            ],
                                            [
                                                this.parseNumber('100000'),
                                                this.parseNumber('0.000060')
                                            ],
                                            [
                                                this.parseNumber('200000'),
                                                this.parseNumber('0.000040')
                                            ],
                                            [
                                                this.parseNumber('400000'),
                                                this.parseNumber('0.000020')
                                            ],
                                            [
                                                this.parseNumber('750000'),
                                                this.parseNumber('0')
                                            ]
                                        ]
                                    }
                                }
                            },
                            'delivery': {
                                'trading': {
                                    'feeSide': 'base',
                                    'tierBased': true,
                                    'percentage': true,
                                    'taker': this.parseNumber('0.000500'),
                                    'maker': this.parseNumber('0.000100'),
                                    'tiers': {
                                        'taker': [
                                            [
                                                this.parseNumber('0'),
                                                this.parseNumber('0.000500')
                                            ],
                                            [
                                                this.parseNumber('250'),
                                                this.parseNumber('0.000450')
                                            ],
                                            [
                                                this.parseNumber('2500'),
                                                this.parseNumber('0.000400')
                                            ],
                                            [
                                                this.parseNumber('7500'),
                                                this.parseNumber('0.000300')
                                            ],
                                            [
                                                this.parseNumber('22500'),
                                                this.parseNumber('0.000250')
                                            ],
                                            [
                                                this.parseNumber('50000'),
                                                this.parseNumber('0.000240')
                                            ],
                                            [
                                                this.parseNumber('100000'),
                                                this.parseNumber('0.000240')
                                            ],
                                            [
                                                this.parseNumber('200000'),
                                                this.parseNumber('0.000240')
                                            ],
                                            [
                                                this.parseNumber('400000'),
                                                this.parseNumber('0.000240')
                                            ],
                                            [
                                                this.parseNumber('750000'),
                                                this.parseNumber('0.000240')
                                            ]
                                        ],
                                        'maker': [
                                            [
                                                this.parseNumber('0'),
                                                this.parseNumber('0.000100')
                                            ],
                                            [
                                                this.parseNumber('250'),
                                                this.parseNumber('0.000080')
                                            ],
                                            [
                                                this.parseNumber('2500'),
                                                this.parseNumber('0.000050')
                                            ],
                                            [
                                                this.parseNumber('7500'),
                                                this.parseNumber('0.0000030')
                                            ],
                                            [
                                                this.parseNumber('22500'),
                                                this.parseNumber('0')
                                            ],
                                            [
                                                this.parseNumber('50000'),
                                                this.parseNumber('-0.000050')
                                            ],
                                            [
                                                this.parseNumber('100000'),
                                                this.parseNumber('-0.000060')
                                            ],
                                            [
                                                this.parseNumber('200000'),
                                                this.parseNumber('-0.000070')
                                            ],
                                            [
                                                this.parseNumber('400000'),
                                                this.parseNumber('-0.000080')
                                            ],
                                            [
                                                this.parseNumber('750000'),
                                                this.parseNumber('-0.000090')
                                            ]
                                        ]
                                    }
                                }
                            }
                        },
                        // exchange-specific options
                        'options': {
                            // 'fetchTradesMethod': 'publicGetAggTrades', // publicGetTrades, publicGetHistoricalTrades
                            'fetchMyTradesMethod': 'v2PrivateGetMyTrades',
                            'hasAlreadyAuthenticatedSuccessfully': false,
                            'recvWindow': 5000,
                            'timeDifference': 0,
                            'adjustForTimeDifference': false,
                            'parseOrderToPrecision': false,
                            'newOrderRespType': {
                                'market': 'FULL',
                                'limit': 'FULL'
                            },
                            'networks': {
                                'SPL': 'SOLANA',
                                'SOL': 'SOLANA',
                                'DOGE': 'dogecoin',
                                'ADA': 'Cardano'
                            }
                        },
                        'commonCurrencies': {
                            'MIM': 'MIM Swarm'
                        },
                        // https://binance-docs.github.io/apidocs/spot/en/#error-codes-2
                        'exceptions': {
                            'exact': {
                                'System is under maintenance.': OnMaintenance,
                                'System abnormality': ExchangeError1,
                                'You are not authorized to execute this request.': PermissionDenied,
                                'API key does not exist': AuthenticationError,
                                'Order would trigger immediately.': OrderImmediatelyFillable,
                                'Stop price would trigger immediately.': OrderImmediatelyFillable,
                                'Order would immediately match and take.': OrderImmediatelyFillable,
                                'Account has insufficient balance for requested action.': InsufficientFunds,
                                'Rest API trading is not enabled.': ExchangeNotAvailable,
                                "You don't have permission.": PermissionDenied,
                                'Market is closed.': ExchangeNotAvailable,
                                'Too many requests. Please try again later.': DDoSProtection,
                                '-1000': ExchangeNotAvailable,
                                '-1001': ExchangeNotAvailable,
                                '-1002': AuthenticationError,
                                '-1003': RateLimitExceeded,
                                '-1013': InvalidOrder,
                                '-1015': RateLimitExceeded,
                                '-1016': ExchangeNotAvailable,
                                '-1020': BadRequest,
                                '-1021': InvalidNonce,
                                '-1022': AuthenticationError,
                                '-1100': BadRequest,
                                '-1101': BadRequest,
                                '-1102': BadRequest,
                                '-1103': BadRequest,
                                '-1104': BadRequest,
                                '-1105': BadRequest,
                                '-1106': BadRequest,
                                '-1111': BadRequest,
                                '-1112': InvalidOrder,
                                '-1114': BadRequest,
                                '-1115': BadRequest,
                                '-1116': BadRequest,
                                '-1117': BadRequest,
                                '-1118': BadRequest,
                                '-1119': BadRequest,
                                '-1120': BadRequest,
                                '-1121': BadSymbol,
                                '-1125': AuthenticationError,
                                '-1127': BadRequest,
                                '-1128': BadRequest,
                                '-1130': BadRequest,
                                '-1131': BadRequest,
                                '-2008': AuthenticationError,
                                '-2010': ExchangeError1,
                                '-2011': OrderNotFound,
                                '-2013': OrderNotFound,
                                '-2014': AuthenticationError,
                                '-2015': AuthenticationError,
                                '-2019': InsufficientFunds,
                                '-3005': InsufficientFunds,
                                '-3006': InsufficientFunds,
                                '-3008': InsufficientFunds,
                                '-3010': ExchangeError1,
                                '-3015': ExchangeError1,
                                '-3022': AccountSuspended,
                                '-4028': BadRequest,
                                '-3020': InsufficientFunds,
                                '-3041': InsufficientFunds,
                                '-5013': InsufficientFunds,
                                '-11008': InsufficientFunds,
                                '-4051': InsufficientFunds
                            },
                            'broad': {
                                'has no operation privilege': PermissionDenied,
                                'MAX_POSITION': InvalidOrder
                            }
                        }
                    });
                }
                costToPrecision(symbol, cost) {
                    return this.decimalToPrecision(cost, TRUNCATE, this.markets[symbol]['precision']['quote'], this.precisionMode, this.paddingMode);
                }
                currencyToPrecision(code, fee) {
                    // info is available in currencies only if the user has configured his api keys
                    if (this.safeValue(this.currencies[code], 'precision') !== undefined) return this.decimalToPrecision(fee, TRUNCATE, this.currencies[code]['precision'], this.precisionMode, this.paddingMode);
                    else return this.numberToString(fee);
                }
                nonce() {
                    return this.milliseconds() - this.options['timeDifference'];
                }
                async fetchStatus(params = {}) {
                    const response = await this.v1PublicGetPing(params);
                    //
                    // empty means working status.
                    //
                    //     {}
                    //
                    const keys = Object.keys(response);
                    const keysLength = keys.length;
                    const formattedStatus = keysLength ? 'maintenance' : 'ok';
                    return {
                        'status': formattedStatus,
                        'updated': this.milliseconds(),
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchTime(params = {}) {
                    const response = await this.v1PublicGetTime(params);
                    //
                    //     {
                    //         "serverTime":1635467280514
                    //     }
                    //
                    return this.safeInteger(response, 'serverTime');
                }
                safeNetwork(networkId) {
                    const uppercaseNetworkId = networkId.toUpperCase();
                    const networksById = {
                        'Aeternity': 'Aeternity',
                        'AION': 'AION',
                        'Algorand': 'Algorand',
                        'ASK': 'ASK',
                        'ATOM': 'ATOM',
                        'AVAX C-Chain': 'AVAX C-Chain',
                        'bch': 'bch',
                        'BCH': 'BCH',
                        'BEP2': 'BEP2',
                        'BEP20': 'BEP20',
                        'Bitcoin': 'Bitcoin',
                        'BRP20': 'BRP20',
                        'Cardano': 'ADA',
                        'CasinoCoin': 'CasinoCoin',
                        'CasinoCoin XRPL': 'CasinoCoin XRPL',
                        'Contentos': 'Contentos',
                        'Dash': 'Dash',
                        'Decoin': 'Decoin',
                        'DeFiChain': 'DeFiChain',
                        'DGB': 'DGB',
                        'Divi': 'Divi',
                        'dogecoin': 'DOGE',
                        'EOS': 'EOS',
                        'ERC20': 'ERC20',
                        'ETC': 'ETC',
                        'Filecoin': 'Filecoin',
                        'FREETON': 'FREETON',
                        'HBAR': 'HBAR',
                        'Hedera Hashgraph': 'Hedera Hashgraph',
                        'HRC20': 'HRC20',
                        'ICON': 'ICON',
                        'ICP': 'ICP',
                        'Ignis': 'Ignis',
                        'Internet Computer': 'Internet Computer',
                        'IOTA': 'IOTA',
                        'KAVA': 'KAVA',
                        'KSM': 'KSM',
                        'LiteCoin': 'LiteCoin',
                        'Luna': 'Luna',
                        'MATIC': 'MATIC',
                        'Mobile Coin': 'Mobile Coin',
                        'MonaCoin': 'MonaCoin',
                        'Monero': 'Monero',
                        'NEM': 'NEM',
                        'NEP5': 'NEP5',
                        'OMNI': 'OMNI',
                        'PAC': 'PAC',
                        'Polkadot': 'Polkadot',
                        'Ravencoin': 'Ravencoin',
                        'Safex': 'Safex',
                        'SOLANA': 'SOL',
                        'Songbird': 'Songbird',
                        'Stellar Lumens': 'Stellar Lumens',
                        'Symbol': 'Symbol',
                        'Tezos': 'XTZ',
                        'theta': 'theta',
                        'THETA': 'THETA',
                        'TRC20': 'TRC20',
                        'VeChain': 'VeChain',
                        'VECHAIN': 'VECHAIN',
                        'Wanchain': 'Wanchain',
                        'XinFin Network': 'XinFin Network',
                        'XRP': 'XRP',
                        'XRPL': 'XRPL',
                        'ZIL': 'ZIL'
                    };
                    return this.safeString2(networksById, networkId, uppercaseNetworkId, networkId);
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.v1PublicGetExchangeInfo(params);
                    //
                    //     {
                    //         "timezone":"CTT",
                    //         "serverTime":1635464889117,
                    //         "rateLimits":[
                    //             {"rateLimitType":"REQUESTS_WEIGHT","interval":"MINUTES","limit":6000},
                    //             {"rateLimitType":"ORDERS","interval":"SECONDS","limit":150},
                    //             {"rateLimitType":"ORDERS","interval":"DAYS","limit":288000},
                    //         ],
                    //         "exchangeFilters":[],
                    //         "symbols":[
                    //             {
                    //                 "symbol":"SHABTC",
                    //                 "status":"TRADING",
                    //                 "baseAsset":"sha",
                    //                 "baseAssetPrecision":0,
                    //                 "quoteAsset":"btc",
                    //                 "quotePrecision":10,
                    //                 "orderTypes":["MARKET","LIMIT"],
                    //                 "icebergAllowed":false,
                    //                 "filters":[
                    //                     {"filterType":"PRICE_FILTER","minPrice":"0.00000001349","maxPrice":"0.00000017537","priceScale":10},
                    //                     {"filterType":"LOT_SIZE","minQty":"1.0","minVal":"0.00020","maxQty":"1000000000","volumeScale":0},
                    //                 ],
                    //                 "defaultPrice":"0.0000006100",
                    //             },
                    //         ],
                    //         "coins":[
                    //             {
                    //                 "coin":"sbr",
                    //                 "coinFulName":"Saber",
                    //                 "enableWithdraw":true,
                    //                 "enableDeposit":true,
                    //                 "chains":["SOLANA"],
                    //                 "withdrawFee":"2.0",
                    //                 "minWithdraw":"5.0",
                    //                 "maxWithdraw":"1000000000000000",
                    //             },
                    //         ],
                    //     }
                    //
                    const result = {};
                    const coins = this.safeValue(response, 'coins', []);
                    for(let i = 0; i < coins.length; i++){
                        const currency = coins[i];
                        const id = this.safeString(currency, 'coin');
                        const name = this.safeString(currency, 'coinFulName');
                        const code = this.safeCurrencyCode(id);
                        const enableDeposit = this.safeValue(currency, 'enableDeposit');
                        const enableWithdraw = this.safeValue(currency, 'enableWithdraw');
                        const precision = undefined;
                        const networkIds = this.safeValue(currency, 'chains', []);
                        const networks = {};
                        for(let j = 0; j < networkIds.length; j++){
                            const networkId = networkIds[j];
                            const network = this.safeNetwork(networkId);
                            networks[network] = {
                                'info': networkId,
                                'id': networkId,
                                'network': network,
                                'active': undefined,
                                'fee': undefined,
                                'precision': undefined,
                                'limits': {
                                    'withdraw': {
                                        'min': undefined,
                                        'max': undefined
                                    }
                                }
                            };
                        }
                        const active = enableWithdraw && enableDeposit;
                        result[code] = {
                            'id': id,
                            'name': name,
                            'code': code,
                            'precision': precision,
                            'info': currency,
                            'active': active,
                            'deposit': enableDeposit,
                            'withdraw': enableWithdraw,
                            'networks': networks,
                            'fee': this.safeNumber(currency, 'withdrawFee'),
                            // 'fees': fees,
                            'limits': {
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'minWithdraw'),
                                    'max': this.safeNumber(currency, 'maxWithdraw')
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const response = await this.v1PublicGetExchangeInfo(params);
                    //
                    //     {
                    //         "timezone":"CTT",
                    //         "serverTime":1635464889117,
                    //         "rateLimits":[
                    //             {"rateLimitType":"REQUESTS_WEIGHT","interval":"MINUTES","limit":6000},
                    //             {"rateLimitType":"ORDERS","interval":"SECONDS","limit":150},
                    //             {"rateLimitType":"ORDERS","interval":"DAYS","limit":288000},
                    //         ],
                    //         "exchangeFilters":[],
                    //         "symbols":[
                    //             {
                    //                 "symbol":"SHABTC",
                    //                 "status":"TRADING",
                    //                 "baseAsset":"sha",
                    //                 "baseAssetPrecision":0,
                    //                 "quoteAsset":"btc",
                    //                 "quotePrecision":10,
                    //                 "orderTypes":["MARKET","LIMIT"],
                    //                 "icebergAllowed":false,
                    //                 "filters":[
                    //                     {"filterType":"PRICE_FILTER","minPrice":"0.00000001349","maxPrice":"0.00000017537","priceScale":10},
                    //                     {"filterType":"LOT_SIZE","minQty":"1.0","minVal":"0.00020","maxQty":"1000000000","volumeScale":0},
                    //                 ],
                    //                 "defaultPrice":"0.0000006100",
                    //             },
                    //         ],
                    //         "coins":[
                    //             {
                    //                 "coin":"sbr",
                    //                 "coinFulName":"Saber",
                    //                 "enableWithdraw":true,
                    //                 "enableDeposit":true,
                    //                 "chains":["SOLANA"],
                    //                 "withdrawFee":"2.0",
                    //                 "minWithdraw":"5.0",
                    //                 "maxWithdraw":"1000000000000000",
                    //             },
                    //         ],
                    //     }
                    //
                    if (this.options['adjustForTimeDifference']) await this.loadTimeDifference();
                    const markets = this.safeValue(response, 'symbols', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'symbol');
                        const lowercaseId = this.safeStringLower(market, 'symbol');
                        const baseId = this.safeString(market, 'baseAsset');
                        const quoteId = this.safeString(market, 'quoteAsset');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const filters = this.safeValue(market, 'filters', []);
                        const filtersByType = this.indexBy(filters, 'filterType');
                        const status = this.safeString(market, 'status');
                        const priceDefault = this.safeInteger(market, 'pricePrecision');
                        const amountDefault = this.safeInteger(market, 'quantityPrecision');
                        const priceFilter = this.safeValue(filtersByType, 'PRICE_FILTER', {});
                        const amountFilter = this.safeValue(filtersByType, 'LOT_SIZE', {});
                        const entry = {
                            'id': id,
                            'lowercaseId': lowercaseId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': status === 'TRADING',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(amountFilter, 'volumeScale', amountDefault),
                                'price': this.safeInteger(priceFilter, 'priceScale', priceDefault),
                                'base': this.safeInteger(market, 'baseAssetPrecision'),
                                'quote': this.safeInteger(market, 'quotePrecision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(amountFilter, 'minQty'),
                                    'max': this.safeNumber(amountFilter, 'maxQty')
                                },
                                'price': {
                                    'min': this.safeNumber(priceFilter, 'minPrice'),
                                    'max': this.safeNumber(priceFilter, 'maxPrice')
                                },
                                'cost': {
                                    'min': this.safeNumber(amountFilter, 'minVal'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        };
                        result.push(entry);
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const timestamp = this.safeInteger(response, 'updateTime');
                    const balances = this.safeValue2(response, 'balances', []);
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'asset');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'free');
                        account['used'] = this.safeString(balance, 'locked');
                        result[code] = account;
                    }
                    result['timestamp'] = timestamp;
                    result['datetime'] = this.iso8601(timestamp);
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.v1PrivateGetAccount(params);
                    //
                    //     {
                    //         "makerCommission":0,
                    //         "takerCommission":0,
                    //         "buyerCommission":0,
                    //         "sellerCommission":0,
                    //         "updateTime":null,
                    //         "balances":[
                    //             {"asset":"sbr","free":"0","locked":"0"},
                    //             {"asset":"ksm","free":"0","locked":"0"},
                    //             {"asset":"neo3s","free":"0","locked":"0"},
                    //         ],
                    //         "canTrade":false,
                    //         "canWithdraw":false,
                    //         "canDeposit":false
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 1000, see https://github.com/Bitrue-exchange/bitrue-official-api-docs#order-book
                    const response = await this.v1PublicGetDepth(this.extend(request, params));
                    //
                    //     {
                    //         "lastUpdateId":1635474910177,
                    //         "bids":[
                    //             ["61436.84","0.05",[]],
                    //             ["61435.77","0.0124",[]],
                    //             ["61434.88","0.012",[]],
                    //         ],
                    //         "asks":[
                    //             ["61452.46","0.0001",[]],
                    //             ["61452.47","0.0597",[]],
                    //             ["61452.76","0.0713",[]],
                    //         ]
                    //     }
                    //
                    const orderbook = this.parseOrderBook(response, symbol);
                    orderbook['nonce'] = this.safeInteger(response, 'lastUpdateId');
                    return orderbook;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker
                    //
                    //     {
                    //         "id":397945892,
                    //         "last":"1.143411",
                    //         "lowestAsk":"1.144223",
                    //         "highestBid":"1.141696",
                    //         "percentChange":"-0.001432",
                    //         "baseVolume":"338287",
                    //         "quoteVolume":"415013.244366",
                    //         "isFrozen":"0",
                    //         "high24hr":"1.370087",
                    //         "low24hr":"1.370087",
                    //     }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'high': this.safeString(ticker, 'high24hr'),
                        'low': this.safeString(ticker, 'low24hr'),
                        'bid': this.safeString(ticker, 'highestBid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'lowestAsk'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': this.safeString(ticker, 'percentChange'),
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'baseVolume'),
                        'quoteVolume': this.safeString(ticker, 'quoteVolume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const uppercaseBaseId = this.safeStringUpper(market, 'baseId');
                    const uppercaseQuoteId = this.safeStringUpper(market, 'quoteId');
                    const request = {
                        'currency': uppercaseQuoteId,
                        'command': 'returnTicker'
                    };
                    const response = await this.klinePublicGetPublicCurrencyJson(this.extend(request, params));
                    //
                    //     {
                    //         "code":"200",
                    //         "msg":"success",
                    //         "data":{
                    //             "DODO3S_USDT":{
                    //                 "id":397945892,
                    //                 "last":"1.143411",
                    //                 "lowestAsk":"1.144223",
                    //                 "highestBid":"1.141696",
                    //                 "percentChange":"-0.001432",
                    //                 "baseVolume":"338287",
                    //                 "quoteVolume":"415013.244366",
                    //                 "isFrozen":"0",
                    //                 "high24hr":"1.370087",
                    //                 "low24hr":"1.370087"
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const id = uppercaseBaseId + '_' + uppercaseQuoteId;
                    const ticker = this.safeValue(data, id);
                    if (ticker === undefined) throw new ExchangeError1(this.id + ' fetchTicker() could not find the ticker for ' + market['symbol']);
                    return this.parseTicker(ticker, market);
                }
                async fetchBidsAsks(symbols, params = {}) {
                    await this.loadMarkets();
                    const defaultType = this.safeString2(this.options, 'fetchBidsAsks', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    let method = undefined;
                    if (type === 'future') method = 'fapiPublicGetTickerBookTicker';
                    else if (type === 'delivery') method = 'dapiPublicGetTickerBookTicker';
                    else method = 'publicGetTickerBookTicker';
                    const response = await this[method](query);
                    return this.parseTickers(response, symbols);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'command': 'returnTicker'
                    };
                    const response = await this.klinePublicGetPublicJson(this.extend(request, params));
                    //
                    //     {
                    //         "code":"200",
                    //         "msg":"success",
                    //         "data":{
                    //             "DODO3S_USDT":{
                    //                 "id":397945892,
                    //                 "last":"1.143411",
                    //                 "lowestAsk":"1.144223",
                    //                 "highestBid":"1.141696",
                    //                 "percentChange":"-0.001432",
                    //                 "baseVolume":"338287",
                    //                 "quoteVolume":"415013.244366",
                    //                 "isFrozen":"0",
                    //                 "high24hr":"1.370087",
                    //                 "low24hr":"1.370087"
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const ids = Object.keys(data);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const [baseId, quoteId] = id.split('_');
                        const marketId = baseId + quoteId;
                        const market = this.safeMarket(marketId);
                        const rawTicker = this.safeValue(data, id);
                        const ticker = this.parseTicker(rawTicker, market);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return result;
                }
                parseTrade(trade, market) {
                    //
                    // aggregate trades
                    //
                    //     {
                    //         "a": 26129,         // Aggregate tradeId
                    //         "p": "0.01633102",  // Price
                    //         "q": "4.70443515",  // Quantity
                    //         "f": 27781,         // First tradeId
                    //         "l": 27781,         // Last tradeId
                    //         "T": 1498793709153, // Timestamp
                    //         "m": true,          // Was the buyer the maker?
                    //         "M": true           // Was the trade the best price match?
                    //     }
                    //
                    // recent public trades and old public trades
                    //
                    //     {
                    //         "id": 28457,
                    //         "price": "4.00000100",
                    //         "qty": "12.00000000",
                    //         "time": 1499865549590,
                    //         "isBuyerMaker": true,
                    //         "isBestMatch": true
                    //     }
                    //
                    // private trades
                    //
                    //     {
                    //         "symbol":"USDCUSDT",
                    //         "id":20725156,
                    //         "orderId":2880918576,
                    //         "origClientOrderId":null,
                    //         "price":"0.9996000000000000",
                    //         "qty":"100.0000000000000000",
                    //         "commission":null,
                    //         "commissionAssert":null,
                    //         "time":1635558511000,
                    //         "isBuyer":false,
                    //         "isMaker":false,
                    //         "isBestMatch":true
                    //     }
                    //
                    const timestamp = this.safeInteger2(trade, 'T', 'time');
                    const priceString = this.safeString2(trade, 'p', 'price');
                    const amountString = this.safeString2(trade, 'q', 'qty');
                    const marketId = this.safeString(trade, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    let id = this.safeString2(trade, 't', 'a');
                    id = this.safeString2(trade, 'id', 'tradeId', id);
                    let side = undefined;
                    const orderId = this.safeString(trade, 'orderId');
                    if ('m' in trade) side = trade['m'] ? 'sell' : 'buy'; // this is reversed intentionally
                    else if ('isBuyerMaker' in trade) side = trade['isBuyerMaker'] ? 'sell' : 'buy';
                    else if ('side' in trade) side = this.safeStringLower(trade, 'side');
                    else if ('isBuyer' in trade) side = trade['isBuyer'] ? 'buy' : 'sell'; // this is a true side
                    let fee = undefined;
                    if ('commission' in trade) fee = {
                        'cost': this.safeString(trade, 'commission'),
                        'currency': this.safeCurrencyCode(this.safeString(trade, 'commissionAssert'))
                    };
                    let takerOrMaker = undefined;
                    if ('isMaker' in trade) takerOrMaker = trade['isMaker'] ? 'maker' : 'taker';
                    if ('maker' in trade) takerOrMaker = trade['maker'] ? 'maker' : 'taker';
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const method = this.safeString(this.options, 'fetchTradesMethod', 'v1PublicGetAggTrades');
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 1000
                    //
                    // Caveats:
                    // - default limit (500) applies only if no other parameters set, trades up
                    //   to the maximum limit may be returned to satisfy other parameters
                    // - if both limit and time window is set and time window contains more
                    //   trades than the limit then the last trades from the window are returned
                    // - 'tradeId' accepted and returned by this method is "aggregate" trade id
                    //   which is different from actual trade id
                    // - setting both fromId and time window results in error
                    const response = await this[method](this.extend(request, params));
                    //
                    // aggregate trades
                    //
                    //     [
                    //         {
                    //             "a": 26129,         // Aggregate tradeId
                    //             "p": "0.01633102",  // Price
                    //             "q": "4.70443515",  // Quantity
                    //             "f": 27781,         // First tradeId
                    //             "l": 27781,         // Last tradeId
                    //             "T": 1498793709153, // Timestamp
                    //             "m": true,          // Was the buyer the maker?
                    //             "M": true           // Was the trade the best price match?
                    //         }
                    //     ]
                    //
                    // recent public trades and historical public trades
                    //
                    //     [
                    //         {
                    //             "id": 28457,
                    //             "price": "4.00000100",
                    //             "qty": "12.00000000",
                    //             "time": 1499865549590,
                    //             "isBuyerMaker": true,
                    //             "isBestMatch": true
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'NEW': 'open',
                        'PARTIALLY_FILLED': 'open',
                        'FILLED': 'closed',
                        'CANCELED': 'canceled',
                        'PENDING_CANCEL': 'canceling',
                        'REJECTED': 'rejected',
                        'EXPIRED': 'expired'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "symbol":"USDCUSDT",
                    //         "orderId":2878854881,
                    //         "clientOrderId":"",
                    //         "transactTime":1635551031276
                    //     }
                    //
                    // fetchOpenOrders
                    //
                    //     {
                    //         "symbol":"USDCUSDT",
                    //         "orderId":"2878854881",
                    //         "clientOrderId":"",
                    //         "price":"1.1000000000000000",
                    //         "origQty":"100.0000000000000000",
                    //         "executedQty":"0.0000000000000000",
                    //         "cummulativeQuoteQty":"0.0000000000000000",
                    //         "status":"NEW",
                    //         "timeInForce":"",
                    //         "type":"LIMIT",
                    //         "side":"SELL",
                    //         "stopPrice":"",
                    //         "icebergQty":"",
                    //         "time":1635551031000,
                    //         "updateTime":1635551031000,
                    //         "isWorking":false
                    //     }
                    //
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const filled = this.safeString(order, 'executedQty');
                    let timestamp = undefined;
                    let lastTradeTimestamp = undefined;
                    if ('time' in order) timestamp = this.safeInteger(order, 'time');
                    else if ('transactTime' in order) timestamp = this.safeInteger(order, 'transactTime');
                    else if ('updateTime' in order) {
                        if (status === 'open') {
                            if (Precise.stringGt(filled, '0')) lastTradeTimestamp = this.safeInteger(order, 'updateTime');
                            else timestamp = this.safeInteger(order, 'updateTime');
                        }
                    }
                    const average = this.safeString(order, 'avgPrice');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'origQty');
                    // - Spot/Margin market: cummulativeQuoteQty
                    // - Futures market: cumQuote.
                    //   Note this is not the actual cost, since Binance futures uses leverage to calculate margins.
                    const cost = this.safeString2(order, 'cummulativeQuoteQty', 'cumQuote');
                    const id = this.safeString(order, 'orderId');
                    let type = this.safeStringLower(order, 'type');
                    const side = this.safeStringLower(order, 'side');
                    const fills = this.safeValue(order, 'fills', []);
                    let clientOrderId = this.safeString(order, 'clientOrderId');
                    if (clientOrderId === '') clientOrderId = undefined;
                    const timeInForce = this.safeString(order, 'timeInForce');
                    const postOnly = type === 'limit_maker' || timeInForce === 'GTX';
                    if (type === 'limit_maker') type = 'limit';
                    const stopPriceString = this.safeString(order, 'stopPrice');
                    const stopPrice = this.parseNumber(this.omitZero(stopPriceString));
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': cost,
                        'average': average,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': undefined,
                        'trades': fills
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const uppercaseType = type.toUpperCase();
                    const validOrderTypes = this.safeValue(market['info'], 'orderTypes');
                    if (!this.inArray(uppercaseType, validOrderTypes)) throw new InvalidOrder(this.id + ' ' + type + ' is not a valid order type in market ' + symbol);
                    const request = {
                        'symbol': market['id'],
                        'side': side.toUpperCase(),
                        'type': uppercaseType,
                        // 'timeInForce': '',
                        'quantity': this.amountToPrecision(symbol, amount)
                    };
                    const clientOrderId = this.safeString2(params, 'newClientOrderId', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        params = this.omit(params, [
                            'newClientOrderId',
                            'clientOrderId'
                        ]);
                        request['newClientOrderId'] = clientOrderId;
                    }
                    if (uppercaseType === 'LIMIT') {
                        if (price === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a price argument');
                        request['price'] = this.priceToPrecision(symbol, price);
                    }
                    const stopPrice = this.safeNumber(params, 'stopPrice');
                    if (stopPrice !== undefined) {
                        params = this.omit(params, 'stopPrice');
                        request['stopPrice'] = this.priceToPrecision(symbol, stopPrice);
                    }
                    const response = await this.v1PrivatePostOrder(this.extend(request, params));
                    //
                    //     {
                    //         "symbol":"USDCUSDT",
                    //         "orderId":2878854881,
                    //         "clientOrderId":"",
                    //         "transactTime":1635551031276
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const clientOrderId = this.safeValue2(params, 'origClientOrderId', 'clientOrderId');
                    if (clientOrderId !== undefined) request['origClientOrderId'] = clientOrderId;
                    else request['orderId'] = id;
                    const query = this.omit(params, [
                        'type',
                        'clientOrderId',
                        'origClientOrderId'
                    ]);
                    const response = await this.v1PrivateGetOrder(this.extend(request, query));
                    return this.parseOrder(response, market);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 1000
                    const response = await this.v1PrivateGetAllOrders(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "symbol": "LTCBTC",
                    //             "orderId": 1,
                    //             "clientOrderId": "myOrder1",
                    //             "price": "0.1",
                    //             "origQty": "1.0",
                    //             "executedQty": "0.0",
                    //             "cummulativeQuoteQty": "0.0",
                    //             "status": "NEW",
                    //             "timeInForce": "GTC",
                    //             "type": "LIMIT",
                    //             "side": "BUY",
                    //             "stopPrice": "0.0",
                    //             "icebergQty": "0.0",
                    //             "time": 1499827319559,
                    //             "updateTime": 1499827319559,
                    //             "isWorking": true
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.v1PrivateGetOpenOrders(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "symbol":"USDCUSDT",
                    //             "orderId":"2878854881",
                    //             "clientOrderId":"",
                    //             "price":"1.1000000000000000",
                    //             "origQty":"100.0000000000000000",
                    //             "executedQty":"0.0000000000000000",
                    //             "cummulativeQuoteQty":"0.0000000000000000",
                    //             "status":"NEW",
                    //             "timeInForce":"",
                    //             "type":"LIMIT",
                    //             "side":"SELL",
                    //             "stopPrice":"",
                    //             "icebergQty":"",
                    //             "time":1635551031000,
                    //             "updateTime":1635551031000,
                    //             "isWorking":false
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const origClientOrderId = this.safeValue2(params, 'origClientOrderId', 'clientOrderId');
                    const request = {
                        'symbol': market['id']
                    };
                    if (origClientOrderId === undefined) request['orderId'] = id;
                    else request['origClientOrderId'] = origClientOrderId;
                    const query = this.omit(params, [
                        'type',
                        'origClientOrderId',
                        'clientOrderId'
                    ]);
                    const response = await this.v1PrivateDeleteOrder(this.extend(request, query));
                    //
                    //     {
                    //         "symbol": "LTCBTC",
                    //         "origClientOrderId": "myOrder1",
                    //         "orderId": 1,
                    //         "clientOrderId": "cancelMyOrder1"
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    const method = this.safeString(this.options, 'fetchMyTradesMethod', 'v2PrivateGetMyTrades');
                    if (symbol === undefined && method === 'v2PrivateGetMyTrades') throw new ArgumentsRequired1(this.id + ' v2PrivateGetMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "symbol":"USDCUSDT",
                    //             "id":20725156,
                    //             "orderId":2880918576,
                    //             "origClientOrderId":null,
                    //             "price":"0.9996000000000000",
                    //             "qty":"100.0000000000000000",
                    //             "commission":null,
                    //             "commissionAssert":null,
                    //             "time":1635558511000,
                    //             "isBuyer":false,
                    //             "isMaker":false,
                    //             "isBestMatch":true
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires a code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin': currency['id'],
                        'status': 1
                    };
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.v1PrivateGetDepositHistory(this.extend(request, params));
                    //
                    //     {
                    //         "code":200,
                    //         "msg":"succ",
                    //         "data":[
                    //             {
                    //                 "id":2659137,
                    //                 "symbol":"USDC",
                    //                 "amount":"200.0000000000000000",
                    //                 "fee":"0.0E-15",
                    //                 "createdAt":1635503169000,
                    //                 "updatedAt":1635503202000,
                    //                 "addressFrom":"0x2faf487a4414fe77e2327f0bf4ae2a264a776ad2",
                    //                 "addressTo":"0x190ceccb1f8bfbec1749180f0ba8922b488d865b",
                    //                 "txid":"0x9970aec41099ac385568859517308707bc7d716df8dabae7b52f5b17351c3ed0",
                    //                 "confirmations":5,
                    //                 "status":0,
                    //                 "tagType":null,
                    //             },
                    //             {
                    //                 "id":2659137,
                    //                 "symbol": "XRP",
                    //                 "amount": "20.0000000000000000",
                    //                 "fee": "0.0E-15",
                    //                 "createdAt": 1544669393000,
                    //                 "updatedAt": 1544669413000,
                    //                 "addressFrom": "",
                    //                 "addressTo": "raLPjTYeGezfdb6crXZzcC8RkLBEwbBHJ5_18113641",
                    //                 "txid": "515B23E1F9864D3AF7F5B4C4FCBED784BAE861854FAB95F4031922B6AAEFC7AC",
                    //                 "confirmations": 7,
                    //                 "status": 1,
                    //                 "tagType": "Tag"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchWithdrawals() requires a code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin': currency['id'],
                        'status': 5
                    };
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.v1PrivateGetWithdrawHistory(this.extend(request, params));
                    //
                    //     {
                    //         "code": 200,
                    //         "msg": "succ",
                    //         "data": {
                    //             "msg": null,
                    //             "amount": 1000,
                    //             "fee": 1,
                    //             "ctime": null,
                    //             "coin": "usdt_erc20",
                    //             "addressTo": "0x2edfae3878d7b6db70ce4abed177ab2636f60c83"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTransactions(data, currency);
                }
                parseTransactionStatusByType(status, type) {
                    const statusesByType = {
                        'deposit': {
                            '0': 'pending',
                            '1': 'ok'
                        },
                        'withdrawal': {
                            '0': 'pending',
                            '5': 'ok',
                            '6': 'canceled'
                        }
                    };
                    const statuses = this.safeValue(statusesByType, type, {});
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "symbol": "XRP",
                    //         "amount": "261.3361000000000000",
                    //         "fee": "0.0E-15",
                    //         "createdAt": 1548816979000,
                    //         "updatedAt": 1548816999000,
                    //         "addressFrom": "",
                    //         "addressTo": "raLPjTYeGezfdb6crXZzcC8RkLBEwbBHJ5_18113641",
                    //         "txid": "86D6EB68A7A28938BCE06BD348F8C07DEF500C5F7FE92069EF8C0551CE0F2C7D",
                    //         "confirmations": 8,
                    //         "status": 1,
                    //         "tagType": "Tag"
                    //     },
                    //     {
                    //         "symbol": "XRP",
                    //         "amount": "20.0000000000000000",
                    //         "fee": "0.0E-15",
                    //         "createdAt": 1544669393000,
                    //         "updatedAt": 1544669413000,
                    //         "addressFrom": "",
                    //         "addressTo": "raLPjTYeGezfdb6crXZzcC8RkLBEwbBHJ5_18113641",
                    //         "txid": "515B23E1F9864D3AF7F5B4C4FCBED784BAE861854FAB95F4031922B6AAEFC7AC",
                    //         "confirmations": 7,
                    //         "status": 1,
                    //         "tagType": "Tag"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "id": 183745,
                    //         "symbol": "usdt_erc20",
                    //         "amount": "8.4000000000000000",
                    //         "fee": "1.6000000000000000",
                    //         "payAmount": "0.0000000000000000",
                    //         "createdAt": 1595336441000,
                    //         "updatedAt": 1595336576000,
                    //         "addressFrom": "",
                    //         "addressTo": "0x2edfae3878d7b6db70ce4abed177ab2636f60c83",
                    //         "txid": "",
                    //         "confirmations": 0,
                    //         "status": 6,
                    //         "tagType": null
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "msg": null,
                    //         "amount": 1000,
                    //         "fee": 1,
                    //         "ctime": null,
                    //         "coin": "usdt_erc20",
                    //         "addressTo": "0x2edfae3878d7b6db70ce4abed177ab2636f60c83"
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const tagType = this.safeString(transaction, 'tagType');
                    let addressTo = this.safeString(transaction, 'addressTo');
                    if (addressTo === '') addressTo = undefined;
                    let addressFrom = this.safeString(transaction, 'addressFrom');
                    if (addressFrom === '') addressFrom = undefined;
                    let tagTo = undefined;
                    let tagFrom = undefined;
                    if (tagType !== undefined) {
                        if (addressTo !== undefined) {
                            const parts = addressTo.split('_');
                            addressTo = this.safeString(parts, 0);
                            tagTo = this.safeString(parts, 1);
                        }
                        if (addressFrom !== undefined) {
                            const parts = addressFrom.split('_');
                            addressFrom = this.safeString(parts, 0);
                            tagFrom = this.safeString(parts, 1);
                        }
                    }
                    let txid = this.safeString(transaction, 'txid');
                    if (txid === '') txid = undefined;
                    const timestamp = this.safeInteger(transaction, 'createdAt');
                    const updated = this.safeInteger(transaction, 'updatedAt');
                    const payAmount = 'payAmount' in transaction;
                    const ctime = 'ctime' in transaction;
                    const type = payAmount || ctime ? 'withdrawal' : 'deposit';
                    const status = this.parseTransactionStatusByType(this.safeString(transaction, 'status'), type);
                    const amount = this.safeNumber(transaction, 'amount');
                    let network = undefined;
                    let currencyId = this.safeString(transaction, 'symbol');
                    if (currencyId !== undefined) {
                        const parts = currencyId.split('_');
                        currencyId = this.safeString(parts, 0);
                        const networkId = this.safeString(parts, 1);
                        if (networkId !== undefined) network = networkId.toUpperCase();
                    }
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const feeCost = this.safeNumber(transaction, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'currency': code,
                        'cost': feeCost
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'address': addressTo,
                        'addressTo': addressTo,
                        'addressFrom': addressFrom,
                        'tag': tagTo,
                        'tagTo': tagTo,
                        'tagFrom': tagFrom,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'internal': false,
                        'fee': fee
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    let chainName = this.safeString(params, 'chainName');
                    if (chainName === undefined) {
                        const networks = this.safeValue(currency, 'networks', {});
                        const network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                        const networkEntry = this.safeValue(networks, network, {});
                        chainName = this.safeString(networkEntry, 'id'); // handle ERC20>ETH alias
                        if (chainName === undefined) throw new ArgumentsRequired1(this.id + ' withdraw() requires a network parameter or a chainName parameter');
                        params = this.omit(params, 'network');
                    }
                    const request = {
                        'coin': currency['id'].toUpperCase(),
                        'amount': amount,
                        'addressTo': address,
                        'chainName': chainName
                    };
                    if (tag !== undefined) request['tag'] = tag;
                    const response = await this.v1PrivatePostWithdrawCommit(this.extend(request, params));
                    //     { id: '9a67628b16ba4988ae20d329333f16bc' }
                    return this.parseTransaction(response, currency);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const [version, access] = api;
                    let url = this.urls['api'][version] + '/' + this.implodeParams(path, params);
                    params = this.omit(params, this.extractParams(path));
                    if (access === 'private') {
                        this.checkRequiredCredentials();
                        const recvWindow = this.safeInteger(this.options, 'recvWindow', 5000);
                        let query = this.urlencode(this.extend({
                            'timestamp': this.nonce(),
                            'recvWindow': recvWindow
                        }, params));
                        const signature = this.hmac(this.encode(query), this.encode(this.secret));
                        query += "&signature=" + signature;
                        headers = {
                            'X-MBX-APIKEY': this.apiKey
                        };
                        if (method === 'GET' || method === 'DELETE') url += '?' + query;
                        else {
                            body = query;
                            headers['Content-Type'] = 'application/x-www-form-urlencoded';
                        }
                    } else if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (code === 418 || code === 429) throw new DDoSProtection(this.id + ' ' + code.toString() + ' ' + reason + ' ' + body);
                    // error response in a form: { "code": -1013, "msg": "Invalid quantity." }
                    // following block cointains legacy checks against message patterns in "msg" property
                    // will switch "code" checks eventually, when we know all of them
                    if (code >= 400) {
                        if (body.indexOf('Price * QTY is zero or less') >= 0) throw new InvalidOrder(this.id + ' order cost = amount * price is zero or less ' + body);
                        if (body.indexOf('LOT_SIZE') >= 0) throw new InvalidOrder(this.id + ' order amount should be evenly divisible by lot size ' + body);
                        if (body.indexOf('PRICE_FILTER') >= 0) throw new InvalidOrder(this.id + ' order price is invalid, i.e. exceeds allowed price precision, exceeds min price or max price limits or is invalid float value in general, use this.priceToPrecision (symbol, amount) ' + body);
                    }
                    if (response === undefined) return; // fallback to default error handler
                    // check success value for wapi endpoints
                    // response in format {'msg': 'The coin does not exist.', 'success': true/false}
                    const success = this.safeValue(response, 'success', true);
                    if (!success) {
                        const message = this.safeString(response, 'msg');
                        let parsedMessage = undefined;
                        if (message !== undefined) {
                            try {
                                parsedMessage = JSON.parse(message);
                            } catch (e) {
                                // do nothing
                                parsedMessage = undefined;
                            }
                            if (parsedMessage !== undefined) response = parsedMessage;
                        }
                    }
                    const message = this.safeString(response, 'msg');
                    if (message !== undefined) {
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, this.id + ' ' + message);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, this.id + ' ' + message);
                    }
                    // checks against error codes
                    const error = this.safeString(response, 'code');
                    if (error !== undefined) {
                        // https://github.com/ccxt/ccxt/issues/6501
                        // https://github.com/ccxt/ccxt/issues/7742
                        if (error === '200' || Precise.stringEquals(error, '0')) return;
                        // a workaround for {"code":-2015,"msg":"Invalid API-key, IP, or permissions for action."}
                        // despite that their message is very confusing, it is raised by Binance
                        // on a temporary ban, the API key is valid, but disabled for a while
                        if (error === '-2015' && this.options['hasAlreadyAuthenticatedSuccessfully']) throw new DDoSProtection(this.id + ' temporary banned: ' + body);
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], error, feedback);
                        throw new ExchangeError1(feedback);
                    }
                    if (!success) throw new ExchangeError1(this.id + ' ' + body);
                }
                calculateRateLimiterCost(api, method, path, params, config = {}, context = {}) {
                    if ('noSymbol' in config && !('symbol' in params)) return config['noSymbol'];
                    else if ('byLimit' in config && 'limit' in params) {
                        const limit = params['limit'];
                        const byLimit = config['byLimit'];
                        for(let i = 0; i < byLimit.length; i++){
                            const entry = byLimit[i];
                            if (limit <= entry[0]) return entry[1];
                        }
                    }
                    return this.safeInteger(config, 'cost', 1);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    43: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, InvalidNonce: InvalidNonce, AuthenticationError: AuthenticationError, OrderNotFound: OrderNotFound, BadRequest: BadRequest } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bitso extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitso',
                        'name': 'Bitso',
                        'countries': [
                            'MX'
                        ],
                        'rateLimit': 2000,
                        'version': 'v3',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchDepositAddress': true,
                            'fetchFundingFee': false,
                            'fetchFundingFees': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87295554-11f98280-c50e-11ea-80d6-15b3bafa8cbf.jpg',
                            'api': 'https://api.bitso.com',
                            'www': 'https://bitso.com',
                            'doc': 'https://bitso.com/api_info',
                            'fees': 'https://bitso.com/fees',
                            'referral': 'https://bitso.com/?ref=itej'
                        },
                        'precisionMode': TICK_SIZE,
                        'options': {
                            'precision': {
                                'XRP': 0.000001,
                                'MXN': 0.01,
                                'TUSD': 0.01
                            },
                            'defaultPrecision': 0.00000001
                        },
                        'timeframes': {
                            '1m': '60',
                            '5m': '300',
                            '15m': '900',
                            '30m': '1800',
                            '1h': '3600',
                            '4h': '14400',
                            '12h': '43200',
                            '1d': '86400',
                            '1w': '604800'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'available_books',
                                    'ticker',
                                    'order_book',
                                    'trades',
                                    'ohlc'
                                ]
                            },
                            'private': {
                                'get': [
                                    'account_status',
                                    'balance',
                                    'fees',
                                    'fundings',
                                    'fundings/{fid}',
                                    'funding_destination',
                                    'kyc_documents',
                                    'ledger',
                                    'ledger/trades',
                                    'ledger/fees',
                                    'ledger/fundings',
                                    'ledger/withdrawals',
                                    'mx_bank_codes',
                                    'open_orders',
                                    'order_trades/{oid}',
                                    'orders/{oid}',
                                    'user_trades',
                                    'user_trades/{tid}',
                                    'withdrawals/',
                                    'withdrawals/{wid}'
                                ],
                                'post': [
                                    'bitcoin_withdrawal',
                                    'debit_card_withdrawal',
                                    'ether_withdrawal',
                                    'ripple_withdrawal',
                                    'bcash_withdrawal',
                                    'litecoin_withdrawal',
                                    'orders',
                                    'phone_number',
                                    'phone_verification',
                                    'phone_withdrawal',
                                    'spei_withdrawal',
                                    'ripple_withdrawal',
                                    'bcash_withdrawal',
                                    'litecoin_withdrawal'
                                ],
                                'delete': [
                                    'orders/{oid}',
                                    'orders/all'
                                ]
                            }
                        },
                        'exceptions': {
                            '0201': AuthenticationError,
                            '104': InvalidNonce,
                            '0304': BadRequest
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetAvailableBooks(params);
                    //
                    //     {
                    //         "success":true,
                    //         "payload":[
                    //             {
                    //                 "book":"btc_mxn",
                    //                 "minimum_price":"500",
                    //                 "maximum_price":"10000000",
                    //                 "minimum_amount":"0.00005",
                    //                 "maximum_amount":"500",
                    //                 "minimum_value":"5",
                    //                 "maximum_value":"10000000",
                    //                 "tick_size":"0.01",
                    //                 "fees":{
                    //                     "flat_rate":{"maker":"0.500","taker":"0.650"},
                    //                     "structure":[
                    //                         {"volume":"1500000","maker":"0.00500","taker":"0.00650"},
                    //                         {"volume":"2000000","maker":"0.00490","taker":"0.00637"},
                    //                         {"volume":"5000000","maker":"0.00480","taker":"0.00624"},
                    //                         {"volume":"7000000","maker":"0.00440","taker":"0.00572"},
                    //                         {"volume":"10000000","maker":"0.00420","taker":"0.00546"},
                    //                         {"volume":"15000000","maker":"0.00400","taker":"0.00520"},
                    //                         {"volume":"35000000","maker":"0.00370","taker":"0.00481"},
                    //                         {"volume":"50000000","maker":"0.00300","taker":"0.00390"},
                    //                         {"volume":"150000000","maker":"0.00200","taker":"0.00260"},
                    //                         {"volume":"250000000","maker":"0.00100","taker":"0.00130"},
                    //                         {"volume":"9999999999","maker":"0.00000","taker":"0.00130"},
                    //                     ]
                    //                 }
                    //             },
                    //         ]
                    //     }
                    const markets = this.safeValue(response, 'payload');
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'book');
                        const [baseId, quoteId] = id.split('_');
                        let base = baseId.toUpperCase();
                        let quote = quoteId.toUpperCase();
                        base = this.safeCurrencyCode(base);
                        quote = this.safeCurrencyCode(quote);
                        const fees = this.safeValue(market, 'fees', {});
                        const flatRate = this.safeValue(fees, 'flat_rate', {});
                        const takerString = this.safeString(flatRate, 'taker');
                        const makerString = this.safeString(flatRate, 'maker');
                        const taker = this.parseNumber(Precise.stringDiv(takerString, '100'));
                        const maker = this.parseNumber(Precise.stringDiv(makerString, '100'));
                        const feeTiers = this.safeValue(fees, 'structure', []);
                        const fee = {
                            'taker': taker,
                            'maker': maker,
                            'percentage': true,
                            'tierBased': true
                        };
                        const takerFees = [];
                        const makerFees = [];
                        for(let j = 0; j < feeTiers.length; j++){
                            const tier = feeTiers[j];
                            const volume = this.safeNumber(tier, 'volume');
                            const takerFee = this.safeNumber(tier, 'taker');
                            const makerFee = this.safeNumber(tier, 'maker');
                            takerFees.push([
                                volume,
                                takerFee
                            ]);
                            makerFees.push([
                                volume,
                                makerFee
                            ]);
                            if (j === 0) {
                                fee['taker'] = takerFee;
                                fee['maker'] = makerFee;
                            }
                        }
                        const tiers = {
                            'taker': takerFees,
                            'maker': makerFees
                        };
                        fee['tiers'] = tiers;
                        const defaultPricePrecision = this.safeNumber(this.options['precision'], quote, this.options['defaultPrecision']);
                        result.push(this.extend({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': taker,
                            'maker': maker,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(this.options['precision'], base, this.options['defaultPrecision']),
                                'price': this.safeNumber(market, 'tick_size', defaultPricePrecision)
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minimum_amount'),
                                    'max': this.safeNumber(market, 'maximum_amount')
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'minimum_price'),
                                    'max': this.safeNumber(market, 'maximum_price')
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minimum_value'),
                                    'max': this.safeNumber(market, 'maximum_value')
                                }
                            },
                            'info': market
                        }, fee));
                    }
                    return result;
                }
                parseBalance(response) {
                    const payload = this.safeValue(response, 'payload', {});
                    const balances = this.safeValue(payload, 'balances');
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'locked');
                        account['total'] = this.safeString(balance, 'total');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalance(params);
                    //
                    //     {
                    //       "success": true,
                    //       "payload": {
                    //         "balances": [
                    //           {
                    //             "currency": "bat",
                    //             "available": "0.00000000",
                    //             "locked": "0.00000000",
                    //             "total": "0.00000000",
                    //             "pending_deposit": "0.00000000",
                    //             "pending_withdrawal": "0.00000000"
                    //           },
                    //           {
                    //             "currency": "bch",
                    //             "available": "0.00000000",
                    //             "locked": "0.00000000",
                    //             "total": "0.00000000",
                    //             "pending_deposit": "0.00000000",
                    //             "pending_withdrawal": "0.00000000"
                    //           },
                    //         ],
                    //       },
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'book': this.marketId(symbol)
                    };
                    const response = await this.publicGetOrderBook(this.extend(request, params));
                    const orderbook = this.safeValue(response, 'payload');
                    const timestamp = this.parse8601(this.safeString(orderbook, 'updated_at'));
                    return this.parseOrderBook(orderbook, symbol, timestamp, 'bids', 'asks', 'price', 'amount');
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "high":"37446.85",
                    //         "last":"36599.54",
                    //         "created_at":"2022-01-28T12:06:11+00:00",
                    //         "book":"btc_usdt",
                    //         "volume":"7.29075419",
                    //         "vwap":"36579.1564400307",
                    //         "low":"35578.52",
                    //         "ask":"36574.76",
                    //         "bid":"36538.22",
                    //         "change_24":"-105.64"
                    //     }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.parse8601(this.safeString(ticker, 'created_at'));
                    const vwap = this.safeString(ticker, 'vwap');
                    const baseVolume = this.safeString(ticker, 'volume');
                    const quoteVolume = Precise.stringMul(baseVolume, vwap);
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': vwap,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'book': market['id']
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    const ticker = this.safeValue(response, 'payload');
                    //
                    //     {
                    //         "success":true,
                    //         "payload":{
                    //             "high":"37446.85",
                    //             "last":"37051.96",
                    //             "created_at":"2022-01-28T17:03:29+00:00",
                    //             "book":"btc_usdt",
                    //             "volume":"6.16176186",
                    //             "vwap":"36582.6293169472",
                    //             "low":"35578.52",
                    //             "ask":"37083.62",
                    //             "bid":"37039.66",
                    //             "change_24":"478.45"
                    //         }
                    //     }
                    //
                    return this.parseTicker(ticker, market);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'book': market['id'],
                        'time_bucket': this.timeframes[timeframe]
                    };
                    if (since !== undefined) {
                        request['start'] = since;
                        if (limit !== undefined) {
                            const duration = this.parseTimeframe(timeframe);
                            request['end'] = this.sum(since, duration * limit * 1000);
                        }
                    } else if (limit !== undefined) {
                        const now = this.milliseconds();
                        request['end'] = now;
                        request['start'] = now - this.parseTimeframe(timeframe) * 1000 * limit;
                    }
                    const response = await this.publicGetOhlc(this.extend(request, params));
                    //
                    //     {
                    //         "success":true,
                    //         "payload": [
                    //             {
                    //                 "bucket_start_time":1648219140000,
                    //                 "first_trade_time":1648219154990,
                    //                 "last_trade_time":1648219189441,
                    //                 "first_rate":"44958.60",
                    //                 "last_rate":"44979.88",
                    //                 "min_rate":"44957.33",
                    //                 "max_rate":"44979.88",
                    //                 "trade_count":8,
                    //                 "volume":"0.00082814",
                    //                 "vwap":"44965.02"
                    //             },
                    //         ]
                    //     }
                    //
                    const payload = this.safeValue(response, 'payload', []);
                    return this.parseOHLCVs(payload, market, timeframe, since, limit);
                }
                parseOHLCV(ohlcv, market, timeframe = '1m') {
                    //
                    //     {
                    //         "bucket_start_time":1648219140000,
                    //         "first_trade_time":1648219154990,
                    //         "last_trade_time":1648219189441,
                    //         "first_rate":"44958.60",
                    //         "last_rate":"44979.88",
                    //         "min_rate":"44957.33",
                    //         "max_rate":"44979.88",
                    //         "trade_count":8,
                    //         "volume":"0.00082814",
                    //         "vwap":"44965.02"
                    //     },
                    //
                    return [
                        this.safeInteger(ohlcv, 'bucket_start_time'),
                        this.safeNumber(ohlcv, 'first_rate'),
                        this.safeNumber(ohlcv, 'max_rate'),
                        this.safeNumber(ohlcv, 'min_rate'),
                        this.safeNumber(ohlcv, 'last_rate'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "book": "btc_usdt",
                    //          "created_at": "2021-11-24T12:14:53+0000",
                    //          "amount": "0.00026562",
                    //          "maker_side": "sell",
                    //          "price": "56471.55",
                    //          "tid": "52557338"
                    //      }
                    //
                    // fetchMyTrades (private)
                    //
                    //      {
                    //          "book": "btc_usdt",
                    //          "created_at": "2021-11-24T12:31:03+0000",
                    //          "minor": "11.30356000",
                    //          "major": "-0.00020000",
                    //          "fees_amount": "0.01119052",
                    //          "fees_currency": "usdt",
                    //          "minor_currency": "usdt",
                    //          "major_currency": "btc",
                    //          "oid": "djTzMIWx2Vi3iMjl",
                    //          "tid": "52559051",
                    //          "price": "56517.80",
                    //          "side": "sell",
                    //          "maker_side": "buy"
                    //      }
                    //
                    // fetchOrderTrades (private)
                    //
                    //      {
                    //          "book": "btc_usdt",
                    //          "created_at": "2021-11-24T12:30:52+0000",
                    //          "minor": "-11.33047916",
                    //          "major": "0.00020020",
                    //          "fees_amount": "0.00000020",
                    //          "fees_currency": "btc",
                    //          "minor_currency": "usdt",
                    //          "major_currency": "btc",
                    //          "oid": "O0D2zcljjjQF5xlG",
                    //          "tid": "52559030",
                    //          "price": "56595.80",
                    //          "side": "buy",
                    //          "maker_side": "sell"
                    //      }
                    //
                    const timestamp = this.parse8601(this.safeString(trade, 'created_at'));
                    const marketId = this.safeString(trade, 'book');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const side = this.safeString2(trade, 'side', 'maker_side');
                    const makerSide = this.safeString(trade, 'maker_side');
                    let takerOrMaker = undefined;
                    if (side === makerSide) takerOrMaker = 'maker';
                    else takerOrMaker = 'taker';
                    let amount = this.safeString2(trade, 'amount', 'major');
                    if (amount !== undefined) amount = Precise.stringAbs(amount);
                    let fee = undefined;
                    const feeCost = this.safeString(trade, 'fees_amount');
                    if (feeCost !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'fees_currency');
                        const feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrency
                        };
                    }
                    let cost = this.safeString(trade, 'minor');
                    if (cost !== undefined) cost = Precise.stringAbs(cost);
                    const price = this.safeString(trade, 'price');
                    const orderId = this.safeString(trade, 'oid');
                    const id = this.safeString(trade, 'tid');
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'book': market['id']
                    };
                    const response = await this.publicGetTrades(this.extend(request, params));
                    return this.parseTrades(response['payload'], market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetFees(params);
                    //
                    //    {
                    //        success: true,
                    //        payload: {
                    //            fees: [
                    //                {
                    //                    book: 'btc_mxn',
                    //                    fee_percent: '0.6500',
                    //                    fee_decimal: '0.00650000',
                    //                    taker_fee_percent: '0.6500',
                    //                    taker_fee_decimal: '0.00650000',
                    //                    maker_fee_percent: '0.5000',
                    //                    maker_fee_decimal: '0.00500000',
                    //                    volume_currency: 'mxn',
                    //                    current_volume: '0.00',
                    //                    next_volume: '1500000.00',
                    //                    next_maker_fee_percent: '0.490',
                    //                    next_taker_fee_percent: '0.637',
                    //                    nextVolume: '1500000.00',
                    //                    nextFee: '0.490',
                    //                    nextTakerFee: '0.637'
                    //                },
                    //                ...
                    //            ],
                    //            deposit_fees: [
                    //                {
                    //                    currency: 'btc',
                    //                    method: 'rewards',
                    //                    fee: '0.00',
                    //                    is_fixed: false
                    //                },
                    //                ...
                    //            ],
                    //            withdrawal_fees: {
                    //                ada: '0.20958100',
                    //                bch: '0.00009437',
                    //                ars: '0',
                    //                btc: '0.00001209',
                    //                ...
                    //            }
                    //        }
                    //    }
                    //
                    const payload = this.safeValue(response, 'payload', {});
                    const fees = this.safeValue(payload, 'fees', []);
                    const result = {};
                    for(let i = 0; i < fees.length; i++){
                        const fee = fees[i];
                        const marketId = this.safeString(fee, 'book');
                        const symbol = this.safeSymbol(marketId, undefined, '_');
                        result[symbol] = {
                            'info': fee,
                            'symbol': symbol,
                            'maker': this.safeNumber(fee, 'maker_fee_decimal'),
                            'taker': this.safeNumber(fee, 'taker_fee_decimal'),
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                async fetchMyTrades(symbol, since, limit = 25, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    // the don't support fetching trades starting from a date yet
                    // use the `marker` extra param for that
                    // this is not a typo, the variable name is 'marker' (don't confuse with 'market')
                    const markerInParams = 'marker' in params;
                    // warn the user with an exception if the user wants to filter
                    // starting from since timestamp, but does not set the trade id with an extra 'marker' param
                    if (since !== undefined && !markerInParams) throw new ExchangeError1(this.id + ' fetchMyTrades() does not support fetching trades starting from a timestamp with the `since` argument, use the `marker` extra param to filter starting from an integer trade id');
                    // convert it to an integer unconditionally
                    if (markerInParams) params = this.extend(params, {
                        'marker': parseInt(params['marker'])
                    });
                    const request = {
                        'book': market['id'],
                        'limit': limit
                    };
                    const response = await this.privateGetUserTrades(this.extend(request, params));
                    return this.parseTrades(response['payload'], market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'book': this.marketId(symbol),
                        'side': side,
                        'type': type,
                        'major': this.amountToPrecision(symbol, amount)
                    };
                    if (type === 'limit') request['price'] = this.priceToPrecision(symbol, price);
                    const response = await this.privatePostOrders(this.extend(request, params));
                    const id = this.safeString(response['payload'], 'oid');
                    return {
                        'info': response,
                        'id': id
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'oid': id
                    };
                    return await this.privateDeleteOrdersOid(this.extend(request, params));
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'partial-fill': 'open',
                        'completed': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    const id = this.safeString(order, 'oid');
                    const side = this.safeString(order, 'side');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const marketId = this.safeString(order, 'book');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const orderType = this.safeString(order, 'type');
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'original_amount');
                    const remaining = this.safeString(order, 'unfilled_amount');
                    const clientOrderId = this.safeString(order, 'client_id');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': orderType,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'remaining': remaining,
                        'filled': undefined,
                        'status': status,
                        'fee': undefined,
                        'average': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchOpenOrders(symbol, since, limit = 25, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    // the don't support fetching trades starting from a date yet
                    // use the `marker` extra param for that
                    // this is not a typo, the variable name is 'marker' (don't confuse with 'market')
                    const markerInParams = 'marker' in params;
                    // warn the user with an exception if the user wants to filter
                    // starting from since timestamp, but does not set the trade id with an extra 'marker' param
                    if (since !== undefined && !markerInParams) throw new ExchangeError1(this.id + ' fetchOpenOrders() does not support fetching orders starting from a timestamp with the `since` argument, use the `marker` extra param to filter starting from an integer trade id');
                    // convert it to an integer unconditionally
                    if (markerInParams) params = this.extend(params, {
                        'marker': parseInt(params['marker'])
                    });
                    const request = {
                        'book': market['id'],
                        'limit': limit
                    };
                    const response = await this.privateGetOpenOrders(this.extend(request, params));
                    const orders = this.parseOrders(response['payload'], market, since, limit);
                    return orders;
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetOrdersOid({
                        'oid': id
                    });
                    const payload = this.safeValue(response, 'payload');
                    if (Array.isArray(payload)) {
                        const numOrders = response['payload'].length;
                        if (numOrders === 1) return this.parseOrder(payload[0]);
                    }
                    throw new OrderNotFound(this.id + ': The order ' + id + ' not found.');
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'oid': id
                    };
                    const response = await this.privateGetOrderTradesOid(this.extend(request, params));
                    return this.parseTrades(response['payload'], market);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'fund_currency': currency['id']
                    };
                    const response = await this.privateGetFundingDestination(this.extend(request, params));
                    let address = this.safeString(response['payload'], 'account_identifier');
                    let tag = undefined;
                    if (address.indexOf('?dt=') >= 0) {
                        const parts = address.split('?dt=');
                        address = this.safeString(parts, 0);
                        tag = this.safeString(parts, 1);
                    }
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async fetchFundingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetFees(params);
                    //
                    //    {
                    //        success: true,
                    //        payload: {
                    //            fees: [
                    //                {
                    //                    book: 'btc_mxn',
                    //                    fee_percent: '0.6500',
                    //                    fee_decimal: '0.00650000',
                    //                    taker_fee_percent: '0.6500',
                    //                    taker_fee_decimal: '0.00650000',
                    //                    maker_fee_percent: '0.5000',
                    //                    maker_fee_decimal: '0.00500000',
                    //                    volume_currency: 'mxn',
                    //                    current_volume: '0.00',
                    //                    next_volume: '1500000.00',
                    //                    next_maker_fee_percent: '0.490',
                    //                    next_taker_fee_percent: '0.637',
                    //                    nextVolume: '1500000.00',
                    //                    nextFee: '0.490',
                    //                    nextTakerFee: '0.637'
                    //                },
                    //                ...
                    //            ],
                    //            deposit_fees: [
                    //                {
                    //                    currency: 'btc',
                    //                    method: 'rewards',
                    //                    fee: '0.00',
                    //                    is_fixed: false
                    //                },
                    //                ...
                    //            ],
                    //            withdrawal_fees: {
                    //                ada: '0.20958100',
                    //                bch: '0.00009437',
                    //                ars: '0',
                    //                btc: '0.00001209',
                    //                ...
                    //            }
                    //        }
                    //    }
                    //
                    const payload = this.safeValue(response, 'payload', {});
                    const depositFees = this.safeValue(payload, 'deposit_fees', []);
                    const deposit = {};
                    for(let i = 0; i < depositFees.length; i++){
                        const depositFee = depositFees[i];
                        const currencyId = this.safeString(depositFee, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        deposit[code] = this.safeNumber(depositFee, 'fee');
                    }
                    const withdraw = {};
                    const withdrawalFees = this.safeValue(payload, 'withdrawal_fees', []);
                    const currencyIds = Object.keys(withdrawalFees);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        withdraw[code] = this.safeNumber(withdrawalFees, currencyId);
                    }
                    return {
                        'info': response,
                        'deposit': deposit,
                        'withdraw': withdraw
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const methods = {
                        'BTC': 'Bitcoin',
                        'ETH': 'Ether',
                        'XRP': 'Ripple',
                        'BCH': 'Bcash',
                        'LTC': 'Litecoin'
                    };
                    const currency = this.currency(code);
                    const method = code in methods ? methods[code] : undefined;
                    if (method === undefined) throw new ExchangeError1(this.id + ' not valid withdraw coin: ' + code);
                    const request = {
                        'amount': amount,
                        'address': address,
                        'destination_tag': tag
                    };
                    const classMethod = 'privatePost' + method + 'Withdrawal';
                    const response = await this[classMethod](this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "payload": [
                    //             {
                    //                 "wid": "c5b8d7f0768ee91d3b33bee648318688",
                    //                 "status": "pending",
                    //                 "created_at": "2016-04-08T17:52:31.000+00:00",
                    //                 "currency": "btc",
                    //                 "method": "Bitcoin",
                    //                 "amount": "0.48650929",
                    //                 "details": {
                    //                     "withdrawal_address": "18MsnATiNiKLqUHDTRKjurwMg7inCrdNEp",
                    //                     "tx_hash": "d4f28394693e9fb5fffcaf730c11f32d1922e5837f76ca82189d3bfe30ded433"
                    //                 }
                    //             },
                    //         ]
                    //     }
                    //
                    const payload = this.safeValue(response, 'payload', []);
                    const first = this.safeValue(payload, 0);
                    return this.parseTransaction(first, currency);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "wid": "c5b8d7f0768ee91d3b33bee648318688",
                    //         "status": "pending",
                    //         "created_at": "2016-04-08T17:52:31.000+00:00",
                    //         "currency": "btc",
                    //         "method": "Bitcoin",
                    //         "amount": "0.48650929",
                    //         "details": {
                    //             "withdrawal_address": "18MsnATiNiKLqUHDTRKjurwMg7inCrdNEp",
                    //             "tx_hash": "d4f28394693e9fb5fffcaf730c11f32d1922e5837f76ca82189d3bfe30ded433"
                    //         }
                    //     }
                    //
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'id': this.safeString(transaction, 'wid'),
                        'txid': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': undefined,
                        'info': transaction
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let endpoint = '/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (method === 'GET') {
                        if (Object.keys(query).length) endpoint += '?' + this.urlencode(query);
                    }
                    const url = this.urls['api'] + endpoint;
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        let request = [
                            nonce,
                            method,
                            endpoint
                        ].join('');
                        if (method !== 'GET') {
                            if (Object.keys(query).length) {
                                body = this.json(query);
                                request += body;
                            }
                        }
                        const signature = this.hmac(this.encode(request), this.encode(this.secret));
                        const auth = this.apiKey + ':' + nonce + ':' + signature;
                        headers = {
                            'Authorization': 'Bitso ' + auth,
                            'Content-Type': 'application/json'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if ('success' in response) {
                        //
                        //     {"success":false,"error":{"code":104,"message":"Cannot perform request - nonce must be higher than 1520307203724237"}}
                        //
                        let success = this.safeValue(response, 'success', false);
                        if (typeof success === 'string') {
                            if (success === 'true' || success === '1') success = true;
                            else success = false;
                        }
                        if (!success) {
                            const feedback = this.id + ' ' + this.json(response);
                            const error = this.safeValue(response, 'error');
                            if (error === undefined) throw new ExchangeError1(feedback);
                            const code = this.safeString(error, 'code');
                            this.throwExactlyMatchedException(this.exceptions, code, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    44: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AuthenticationError: AuthenticationError, BadRequest: BadRequest, ExchangeError: ExchangeError1, NotSupported: NotSupported, PermissionDenied: PermissionDenied, InvalidNonce: InvalidNonce, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, InvalidAddress: InvalidAddress, InvalidOrder: InvalidOrder, ArgumentsRequired: ArgumentsRequired1, OnMaintenance: OnMaintenance, ExchangeNotAvailable: ExchangeNotAvailable } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bitstamp extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitstamp',
                        'name': 'Bitstamp',
                        'countries': [
                            'GB'
                        ],
                        // 8000 requests per 10 minutes = 8000 / 600 = 13.33333333 requests per second => 1000ms / 13.33333333 = 75ms between requests on average
                        'rateLimit': 75,
                        'version': 'v2',
                        'userAgent': this.userAgents['chrome'],
                        'pro': true,
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchFundingFees': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLedger': true,
                            'fetchLeverage': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': true,
                            'fetchTransactions': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27786377-8c8ab57e-5fe9-11e7-8ea4-2b05b6bcceec.jpg',
                            'api': {
                                'public': 'https://www.bitstamp.net/api',
                                'private': 'https://www.bitstamp.net/api'
                            },
                            'www': 'https://www.bitstamp.net',
                            'doc': 'https://www.bitstamp.net/api'
                        },
                        'timeframes': {
                            '1m': '60',
                            '3m': '180',
                            '5m': '300',
                            '15m': '900',
                            '30m': '1800',
                            '1h': '3600',
                            '2h': '7200',
                            '4h': '14400',
                            '6h': '21600',
                            '12h': '43200',
                            '1d': '86400',
                            '1w': '259200'
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'ohlc/{pair}/': 1,
                                    'order_book/{pair}/': 1,
                                    'ticker_hour/{pair}/': 1,
                                    'ticker/{pair}/': 1,
                                    'transactions/{pair}/': 1,
                                    'trading-pairs-info/': 1
                                }
                            },
                            'private': {
                                'post': {
                                    'balance/': 1,
                                    'balance/{pair}/': 1,
                                    'bch_withdrawal/': 1,
                                    'bch_address/': 1,
                                    'user_transactions/': 1,
                                    'user_transactions/{pair}/': 1,
                                    'open_orders/all/': 1,
                                    'open_orders/{pair}/': 1,
                                    'order_status/': 1,
                                    'cancel_order/': 1,
                                    'cancel_all_orders/': 1,
                                    'cancel_all_orders/{pair}/': 1,
                                    'buy/{pair}/': 1,
                                    'buy/market/{pair}/': 1,
                                    'buy/instant/{pair}/': 1,
                                    'sell/{pair}/': 1,
                                    'sell/market/{pair}/': 1,
                                    'sell/instant/{pair}/': 1,
                                    'btc_withdrawal/': 1,
                                    'btc_address/': 1,
                                    'ripple_withdrawal/': 1,
                                    'ripple_address/': 1,
                                    'ltc_withdrawal/': 1,
                                    'ltc_address/': 1,
                                    'eth_withdrawal/': 1,
                                    'eth_address/': 1,
                                    'xrp_withdrawal/': 1,
                                    'xrp_address/': 1,
                                    'xlm_withdrawal/': 1,
                                    'xlm_address/': 1,
                                    'pax_withdrawal/': 1,
                                    'pax_address/': 1,
                                    'link_withdrawal/': 1,
                                    'link_address/': 1,
                                    'usdc_withdrawal/': 1,
                                    'usdc_address/': 1,
                                    'omg_withdrawal/': 1,
                                    'omg_address/': 1,
                                    'dai_withdrawal/': 1,
                                    'dai_address/': 1,
                                    'knc_withdrawal/': 1,
                                    'knc_address/': 1,
                                    'mkr_withdrawal/': 1,
                                    'mkr_address/': 1,
                                    'zrx_withdrawal/': 1,
                                    'zrx_address/': 1,
                                    'gusd_withdrawal/': 1,
                                    'gusd_address/': 1,
                                    'aave_withdrawal/': 1,
                                    'aave_address/': 1,
                                    'bat_withdrawal/': 1,
                                    'bat_address/': 1,
                                    'uma_withdrawal/': 1,
                                    'uma_address/': 1,
                                    'snx_withdrawal/': 1,
                                    'snx_address/': 1,
                                    'uni_withdrawal/': 1,
                                    'uni_address/': 1,
                                    'yfi_withdrawal/': 1,
                                    'yfi_address': 1,
                                    'audio_withdrawal/': 1,
                                    'audio_address/': 1,
                                    'crv_withdrawal/': 1,
                                    'crv_address/': 1,
                                    'algo_withdrawal/': 1,
                                    'algo_address/': 1,
                                    'comp_withdrawal/': 1,
                                    'comp_address/': 1,
                                    'grt_withdrawal': 1,
                                    'grt_address/': 1,
                                    'usdt_withdrawal/': 1,
                                    'usdt_address/': 1,
                                    'eurt_withdrawal/': 1,
                                    'eurt_address/': 1,
                                    'matic_withdrawal/': 1,
                                    'matic_address/': 1,
                                    'sushi_withdrawal/': 1,
                                    'sushi_address/': 1,
                                    'chz_withdrawal/': 1,
                                    'chz_address/': 1,
                                    'enj_withdrawal/': 1,
                                    'enj_address/': 1,
                                    'alpha_withdrawal/': 1,
                                    'alpha_address/': 1,
                                    'ftt_withdrawal/': 1,
                                    'ftt_address/': 1,
                                    'storj_withdrawal/': 1,
                                    'storj_address/': 1,
                                    'axs_withdrawal/': 1,
                                    'axs_address/': 1,
                                    'sand_withdrawal/': 1,
                                    'sand_address/': 1,
                                    'hbar_withdrawal/': 1,
                                    'hbar_address/': 1,
                                    'rgt_withdrawal/': 1,
                                    'rgt_address/': 1,
                                    'fet_withdrawal/': 1,
                                    'fet_address/': 1,
                                    'skl_withdrawal/': 1,
                                    'skl_address/': 1,
                                    'cel_withdrawal/': 1,
                                    'cel_address/': 1,
                                    'sxp_withdrawal/': 1,
                                    'sxp_address/': 1,
                                    'ada_withdrawal/': 1,
                                    'ada_address/': 1,
                                    'slp_withdrawal/': 1,
                                    'slp_address/': 1,
                                    'ftm_withdrawal/': 1,
                                    'ftm_address/': 1,
                                    'perp_withdrawal/': 1,
                                    'perp_address/': 1,
                                    'dydx_withdrawal/': 1,
                                    'dydx_address/': 1,
                                    'gala_withdrawal/': 1,
                                    'gala_address/': 1,
                                    'shib_withdrawal/': 1,
                                    'shib_address/': 1,
                                    'amp_withdrawal/': 1,
                                    'amp_address/': 1,
                                    'sgb_withdrawal/': 1,
                                    'sgb_address/': 1,
                                    'avax_withdrawal/': 1,
                                    'avax_address/': 1,
                                    'wbtc_withdrawal/': 1,
                                    'wbtc_address/': 1,
                                    'ctsi_withdrawal/': 1,
                                    'ctsi_address/': 1,
                                    'cvx_withdrawal/': 1,
                                    'cvx_address/': 1,
                                    'imx_withdrawal/': 1,
                                    'imx_address/': 1,
                                    'nexo_withdrawal/': 1,
                                    'nexo_address/': 1,
                                    'ust_withdrawal/': 1,
                                    'ust_address/': 1,
                                    'ant_withdrawal/': 1,
                                    'ant_address/': 1,
                                    'gods_withdrawal/': 1,
                                    'gods_address/': 1,
                                    'rad_withdrawal/': 1,
                                    'rad_address/': 1,
                                    'transfer-to-main/': 1,
                                    'transfer-from-main/': 1,
                                    'withdrawal-requests/': 1,
                                    'withdrawal/open/': 1,
                                    'withdrawal/status/': 1,
                                    'withdrawal/cancel/': 1,
                                    'liquidation_address/new/': 1,
                                    'liquidation_address/info/': 1,
                                    'btc_unconfirmed/': 1,
                                    'websockets_token/': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.005'),
                                'maker': this.parseNumber('0.005'),
                                'tiers': {
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.005')
                                        ],
                                        [
                                            this.parseNumber('20000'),
                                            this.parseNumber('0.0025')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('0.0024')
                                        ],
                                        [
                                            this.parseNumber('200000'),
                                            this.parseNumber('0.0022')
                                        ],
                                        [
                                            this.parseNumber('400000'),
                                            this.parseNumber('0.0020')
                                        ],
                                        [
                                            this.parseNumber('600000'),
                                            this.parseNumber('0.0015')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.0014')
                                        ],
                                        [
                                            this.parseNumber('2000000'),
                                            this.parseNumber('0.0013')
                                        ],
                                        [
                                            this.parseNumber('4000000'),
                                            this.parseNumber('0.0012')
                                        ],
                                        [
                                            this.parseNumber('20000000'),
                                            this.parseNumber('0.0011')
                                        ],
                                        [
                                            this.parseNumber('50000000'),
                                            this.parseNumber('0.0010')
                                        ],
                                        [
                                            this.parseNumber('100000000'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('500000000'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('2000000000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('6000000000'),
                                            this.parseNumber('0.0001')
                                        ],
                                        [
                                            this.parseNumber('20000000000'),
                                            this.parseNumber('0.00005')
                                        ],
                                        [
                                            this.parseNumber('20000000001'),
                                            this.parseNumber('0')
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.005')
                                        ],
                                        [
                                            this.parseNumber('20000'),
                                            this.parseNumber('0.0025')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('0.0024')
                                        ],
                                        [
                                            this.parseNumber('200000'),
                                            this.parseNumber('0.0022')
                                        ],
                                        [
                                            this.parseNumber('400000'),
                                            this.parseNumber('0.0020')
                                        ],
                                        [
                                            this.parseNumber('600000'),
                                            this.parseNumber('0.0015')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.0014')
                                        ],
                                        [
                                            this.parseNumber('2000000'),
                                            this.parseNumber('0.0013')
                                        ],
                                        [
                                            this.parseNumber('4000000'),
                                            this.parseNumber('0.0012')
                                        ],
                                        [
                                            this.parseNumber('20000000'),
                                            this.parseNumber('0.0011')
                                        ],
                                        [
                                            this.parseNumber('50000000'),
                                            this.parseNumber('0.0010')
                                        ],
                                        [
                                            this.parseNumber('100000000'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('500000000'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('2000000000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('6000000000'),
                                            this.parseNumber('0.0001')
                                        ],
                                        [
                                            this.parseNumber('20000000000'),
                                            this.parseNumber('0.00005')
                                        ],
                                        [
                                            this.parseNumber('20000000001'),
                                            this.parseNumber('0')
                                        ]
                                    ]
                                }
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false,
                                'withdraw': {},
                                'deposit': {
                                    'BTC': 0,
                                    'BCH': 0,
                                    'LTC': 0,
                                    'ETH': 0,
                                    'XRP': 0,
                                    'XLM': 0,
                                    'PAX': 0,
                                    'USD': 7.5,
                                    'EUR': 0
                                }
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'No permission found': PermissionDenied,
                                'API key not found': AuthenticationError,
                                'IP address not allowed': PermissionDenied,
                                'Invalid nonce': InvalidNonce,
                                'Invalid signature': AuthenticationError,
                                'Authentication failed': AuthenticationError,
                                'Missing key, signature and nonce parameters': AuthenticationError,
                                'Wrong API key format': AuthenticationError,
                                'Your account is frozen': PermissionDenied,
                                'Please update your profile with your FATCA information, before using API.': PermissionDenied,
                                'Order not found': OrderNotFound,
                                'Price is more than 20% below market price.': InvalidOrder,
                                "Bitstamp.net is under scheduled maintenance. We'll be back soon.": OnMaintenance,
                                'Order could not be placed.': ExchangeNotAvailable,
                                'Invalid offset.': BadRequest
                            },
                            'broad': {
                                'Minimum order size is': InvalidOrder,
                                'Check your account balance for details.': InsufficientFunds,
                                'Ensure this value has at least': InvalidAddress
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.fetchMarketsFromCache(params);
                    //
                    //     [
                    //         {
                    //             "trading": "Enabled",
                    //             "base_decimals": 8,
                    //             "url_symbol": "btcusd",
                    //             "name": "BTC/USD",
                    //             "instant_and_market_orders": "Enabled",
                    //             "minimum_order": "20.0 USD",
                    //             "counter_decimals": 2,
                    //             "description": "Bitcoin / U.S. dollar"
                    //         }
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const name = this.safeString(market, 'name');
                        let [base, quote] = name.split('/');
                        const baseId = base.toLowerCase();
                        const quoteId = quote.toLowerCase();
                        base = this.safeCurrencyCode(base);
                        quote = this.safeCurrencyCode(quote);
                        const minimumOrder = this.safeString(market, 'minimum_order');
                        const parts = minimumOrder.split(' ');
                        const status = this.safeString(market, 'trading');
                        result.push({
                            'id': this.safeString(market, 'url_symbol'),
                            'marketId': baseId + '_' + quoteId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'future': false,
                            'swap': false,
                            'option': false,
                            'active': status === 'Enabled',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'base_decimals'),
                                'price': this.safeInteger(market, 'counter_decimals')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(parts, 0),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                constructCurrencyObject(id, code, name, precision, minCost, originalPayload) {
                    let currencyType = 'crypto';
                    const description = this.describe();
                    if (this.isFiat(code)) currencyType = 'fiat';
                    return {
                        'id': id,
                        'code': code,
                        'info': originalPayload,
                        'type': currencyType,
                        'name': name,
                        'active': true,
                        'deposit': undefined,
                        'withdraw': undefined,
                        'fee': this.safeNumber(description['fees']['funding']['withdraw'], code),
                        'precision': precision,
                        'limits': {
                            'amount': {
                                'min': Math.pow(10, -precision),
                                'max': undefined
                            },
                            'price': {
                                'min': Math.pow(10, -precision),
                                'max': undefined
                            },
                            'cost': {
                                'min': minCost,
                                'max': undefined
                            },
                            'withdraw': {
                                'min': undefined,
                                'max': undefined
                            }
                        }
                    };
                }
                async fetchMarketsFromCache(params = {}) {
                    // this method is now redundant
                    // currencies are now fetched before markets
                    const options = this.safeValue(this.options, 'fetchMarkets', {});
                    const timestamp = this.safeInteger(options, 'timestamp');
                    const expires = this.safeInteger(options, 'expires', 1000);
                    const now = this.milliseconds();
                    if (timestamp === undefined || now - timestamp > expires) {
                        const response = await this.publicGetTradingPairsInfo(params);
                        this.options['fetchMarkets'] = this.extend(options, {
                            'response': response,
                            'timestamp': now
                        });
                    }
                    return this.safeValue(this.options['fetchMarkets'], 'response');
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.fetchMarketsFromCache(params);
                    //
                    //     [
                    //         {
                    //             "trading": "Enabled",
                    //             "base_decimals": 8,
                    //             "url_symbol": "btcusd",
                    //             "name": "BTC/USD",
                    //             "instant_and_market_orders": "Enabled",
                    //             "minimum_order": "20.0 USD",
                    //             "counter_decimals": 2,
                    //             "description": "Bitcoin / U.S. dollar"
                    //         },
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const name = this.safeString(market, 'name');
                        let [base, quote] = name.split('/');
                        const baseId = base.toLowerCase();
                        const quoteId = quote.toLowerCase();
                        base = this.safeCurrencyCode(base);
                        quote = this.safeCurrencyCode(quote);
                        const description = this.safeString(market, 'description');
                        const [baseDescription, quoteDescription] = description.split(' / ');
                        const minimumOrder = this.safeString(market, 'minimum_order');
                        const parts = minimumOrder.split(' ');
                        const cost = parts[0];
                        if (!(base in result)) {
                            const baseDecimals = this.safeInteger(market, 'base_decimals');
                            result[base] = this.constructCurrencyObject(baseId, base, baseDescription, baseDecimals, undefined, market);
                        }
                        if (!(quote in result)) {
                            const counterDecimals = this.safeInteger(market, 'counter_decimals');
                            result[quote] = this.constructCurrencyObject(quoteId, quote, quoteDescription, counterDecimals, this.parseNumber(cost), market);
                        }
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'pair': this.marketId(symbol)
                    };
                    const response = await this.publicGetOrderBookPair(this.extend(request, params));
                    //
                    //     {
                    //         "timestamp": "1583652948",
                    //         "microtimestamp": "1583652948955826",
                    //         "bids": [
                    //             [ "8750.00", "1.33685271" ],
                    //             [ "8749.39", "0.07700000" ],
                    //             [ "8746.98", "0.07400000" ],
                    //         ]
                    //         "asks": [
                    //             [ "8754.10", "1.51995636" ],
                    //             [ "8754.71", "1.40000000" ],
                    //             [ "8754.72", "2.50000000" ],
                    //         ]
                    //     }
                    //
                    const microtimestamp = this.safeInteger(response, 'microtimestamp');
                    const timestamp = parseInt(microtimestamp / 1000);
                    const orderbook = this.parseOrderBook(response, symbol, timestamp);
                    orderbook['nonce'] = microtimestamp;
                    return orderbook;
                }
                parseTicker(ticker, market) {
                    //
                    // {
                    //     "high": "37534.15",
                    //     "last": "36487.44",
                    //     "timestamp":
                    //     "1643370585",
                    //     "bid": "36475.15",
                    //     "vwap": "36595.67",
                    //     "volume": "2848.49168527",
                    //     "low": "35511.32",
                    //     "ask": "36487.44",
                    //     "open": "37179.62"
                    // }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.safeTimestamp(ticker, 'timestamp');
                    const vwap = this.safeString(ticker, 'vwap');
                    const baseVolume = this.safeString(ticker, 'volume');
                    const quoteVolume = Precise.stringMul(baseVolume, vwap);
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': vwap,
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const ticker = await this.publicGetTickerPair(this.extend(request, params));
                    //
                    // {
                    //     "high": "37534.15",
                    //     "last": "36487.44",
                    //     "timestamp":
                    //     "1643370585",
                    //     "bid": "36475.15",
                    //     "vwap": "36595.67",
                    //     "volume": "2848.49168527",
                    //     "low": "35511.32",
                    //     "ask": "36487.44",
                    //     "open": "37179.62"
                    // }
                    //
                    return this.parseTicker(ticker, market);
                }
                getCurrencyIdFromTransaction(transaction) {
                    //
                    //     {
                    //         "fee": "0.00000000",
                    //         "btc_usd": "0.00",
                    //         "datetime": XXX,
                    //         "usd": 0.0,
                    //         "btc": 0.0,
                    //         "eth": "0.05000000",
                    //         "type": "0",
                    //         "id": XXX,
                    //         "eur": 0.0
                    //     }
                    //
                    const currencyId = this.safeStringLower(transaction, 'currency');
                    if (currencyId !== undefined) return currencyId;
                    transaction = this.omit(transaction, [
                        'fee',
                        'price',
                        'datetime',
                        'type',
                        'status',
                        'id'
                    ]);
                    const ids = Object.keys(transaction);
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        if (id.indexOf('_') < 0) {
                            const value = this.safeNumber(transaction, id);
                            if (value !== undefined && value !== 0) return id;
                        }
                    }
                    return undefined;
                }
                getMarketFromTrade(trade) {
                    trade = this.omit(trade, [
                        'fee',
                        'price',
                        'datetime',
                        'tid',
                        'type',
                        'order_id',
                        'side'
                    ]);
                    const currencyIds = Object.keys(trade);
                    const numCurrencyIds = currencyIds.length;
                    if (numCurrencyIds > 2) throw new ExchangeError1(this.id + ' getMarketFromTrade() too many keys: ' + this.json(currencyIds) + ' in the trade: ' + this.json(trade));
                    if (numCurrencyIds === 2) {
                        let marketId = currencyIds[0] + currencyIds[1];
                        if (marketId in this.markets_by_id) return this.markets_by_id[marketId];
                        marketId = currencyIds[1] + currencyIds[0];
                        if (marketId in this.markets_by_id) return this.markets_by_id[marketId];
                    }
                    return undefined;
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "date": "1637845199",
                    //          "tid": "209895701",
                    //          "amount": "0.00500000",
                    //          "type": "0",             // Transaction type: 0 - buy; 1 - sell
                    //          "price": "4451.25"
                    //      }
                    //
                    // fetchMyTrades, trades returned within fetchOrder (private)
                    //
                    //      {
                    //          "fee": "0.11128",
                    //          "eth_usdt":  4451.25,
                    //          "datetime": "2021-11-25 12:59:59.322000",
                    //          "usdt": "-22.26",
                    //          "order_id":  1429545880227846,
                    //          "usd":  0,
                    //          "btc":  0,
                    //          "eth": "0.00500000",
                    //          "type": "2",                    // Transaction type: 0 - deposit; 1 - withdrawal; 2 - market trade; 14 - sub account transfer; 25 - credited with staked assets; 26 - sent assets to staking; 27 - staking reward; 32 - referral reward; 35 - inter account transfer.
                    //          "id":  209895701,
                    //          "eur":  0
                    //      }
                    //
                    // from fetchOrder (private)
                    //
                    //      {
                    //          "fee": "0.11128",
                    //          "price": "4451.25000000",
                    //          "datetime": "2021-11-25 12:59:59.322000",
                    //          "usdt": "22.25625000",
                    //          "tid": 209895701,
                    //          "eth": "0.00500000",
                    //          "type": 2                       // Transaction type: 0 - deposit; 1 - withdrawal; 2 - market trade
                    //      }
                    //
                    const id = this.safeString2(trade, 'id', 'tid');
                    let symbol = undefined;
                    let side = undefined;
                    let priceString = this.safeString(trade, 'price');
                    let amountString = this.safeString(trade, 'amount');
                    const orderId = this.safeString(trade, 'order_id');
                    const type = undefined;
                    let costString = this.safeString(trade, 'cost');
                    if (market === undefined) {
                        const keys = Object.keys(trade);
                        for(let i = 0; i < keys.length; i++)if (keys[i].indexOf('_') >= 0) {
                            const marketId = keys[i].replace('_', '');
                            if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                        }
                        // if the market is still not defined
                        // try to deduce it from used keys
                        if (market === undefined) market = this.getMarketFromTrade(trade);
                    }
                    const feeCostString = this.safeString(trade, 'fee');
                    let feeCurrency = undefined;
                    if (market !== undefined) {
                        priceString = this.safeString(trade, market['marketId'], priceString);
                        amountString = this.safeString(trade, market['baseId'], amountString);
                        costString = this.safeString(trade, market['quoteId'], costString);
                        feeCurrency = market['quote'];
                        symbol = market['symbol'];
                    }
                    let timestamp = this.safeString2(trade, 'date', 'datetime');
                    if (timestamp !== undefined) {
                        if (timestamp.indexOf(' ') >= 0) // iso8601
                        timestamp = this.parse8601(timestamp);
                        else {
                            // string unix epoch in seconds
                            timestamp = parseInt(timestamp);
                            timestamp = timestamp * 1000;
                        }
                    }
                    // if it is a private trade
                    if ('id' in trade) {
                        if (amountString !== undefined) {
                            const isAmountNeg = Precise.stringLt(amountString, '0');
                            if (isAmountNeg) {
                                side = 'sell';
                                amountString = Precise.stringNeg(amountString);
                            } else side = 'buy';
                        }
                    } else {
                        side = this.safeString(trade, 'type');
                        if (side === '1') side = 'sell';
                        else if (side === '0') side = 'buy';
                        else side = undefined;
                    }
                    if (costString !== undefined) costString = Precise.stringAbs(costString);
                    let fee = undefined;
                    if (feeCostString !== undefined) fee = {
                        'cost': feeCostString,
                        'currency': feeCurrency
                    };
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': orderId,
                        'type': type,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'time': 'hour'
                    };
                    const response = await this.publicGetTransactionsPair(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             date: '1551814435',
                    //             tid: '83581898',
                    //             price: '0.03532850',
                    //             type: '1',
                    //             amount: '0.85945907'
                    //         },
                    //         {
                    //             date: '1551814434',
                    //             tid: '83581896',
                    //             price: '0.03532851',
                    //             type: '1',
                    //             amount: '11.34130961'
                    //         },
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "high": "9064.77",
                    //         "timestamp": "1593961440",
                    //         "volume": "18.49436608",
                    //         "low": "9040.87",
                    //         "close": "9064.77",
                    //         "open": "9040.87"
                    //     }
                    //
                    return [
                        this.safeTimestamp(ohlcv, 'timestamp'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'step': this.timeframes[timeframe]
                    };
                    const duration = this.parseTimeframe(timeframe);
                    if (limit === undefined) {
                        if (since === undefined) throw new ArgumentsRequired1(this.id + ' fetchOHLCV() requires a since argument or a limit argument');
                        else {
                            limit = 1000;
                            const start = parseInt(since / 1000);
                            request['start'] = start;
                            request['end'] = this.sum(start, limit * duration);
                            request['limit'] = limit;
                        }
                    } else {
                        if (since !== undefined) {
                            const start = parseInt(since / 1000);
                            request['start'] = start;
                            request['end'] = this.sum(start, limit * duration);
                        }
                        request['limit'] = Math.min(limit, 1000); // min 1, max 1000
                    }
                    const response = await this.publicGetOhlcPair(this.extend(request, params));
                    //
                    //     {
                    //         "data": {
                    //             "pair": "BTC/USD",
                    //             "ohlc": [
                    //                 {"high": "9064.77", "timestamp": "1593961440", "volume": "18.49436608", "low": "9040.87", "close": "9064.77", "open": "9040.87"},
                    //                 {"high": "9071.59", "timestamp": "1593961500", "volume": "3.48631711", "low": "9058.76", "close": "9061.07", "open": "9064.66"},
                    //                 {"high": "9067.33", "timestamp": "1593961560", "volume": "0.04142833", "low": "9061.94", "close": "9061.94", "open": "9067.33"},
                    //             ],
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const ohlc = this.safeValue(data, 'ohlc', []);
                    return this.parseOHLCVs(ohlc, market, timeframe, since, limit);
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const codes = Object.keys(this.currencies);
                    for(let i = 0; i < codes.length; i++){
                        const code = codes[i];
                        const currency = this.currency(code);
                        const currencyId = currency['id'];
                        const account = this.account();
                        account['free'] = this.safeString(response, currencyId + '_available');
                        account['used'] = this.safeString(response, currencyId + '_reserved');
                        account['total'] = this.safeString(response, currencyId + '_balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostBalance(params);
                    //
                    //     {
                    //         "aave_available": "0.00000000",
                    //         "aave_balance": "0.00000000",
                    //         "aave_reserved": "0.00000000",
                    //         "aave_withdrawal_fee": "0.07000000",
                    //         "aavebtc_fee": "0.000",
                    //         "aaveeur_fee": "0.000",
                    //         "aaveusd_fee": "0.000",
                    //         "bat_available": "0.00000000",
                    //         "bat_balance": "0.00000000",
                    //         "bat_reserved": "0.00000000",
                    //         "bat_withdrawal_fee": "5.00000000",
                    //         "batbtc_fee": "0.000",
                    //         "bateur_fee": "0.000",
                    //         "batusd_fee": "0.000",
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.privatePostBalancePair(this.extend(request, params));
                    return this.parseTradingFee(response, market);
                }
                parseTradingFee(fee, market) {
                    market = this.safeMarket(undefined, market);
                    const feeString = this.safeString(fee, market['id'] + '_fee');
                    const dividedFeeString = Precise.stringDiv(feeString, '100');
                    const tradeFee = this.parseNumber(dividedFeeString);
                    return {
                        'info': fee,
                        'symbol': market['symbol'],
                        'maker': tradeFee,
                        'taker': tradeFee
                    };
                }
                parseTradingFees(fees) {
                    const result = {
                        'info': fees
                    };
                    const symbols = this.symbols;
                    for(let i = 0; i < symbols.length; i++){
                        const symbol = symbols[i];
                        const market = this.market(symbol);
                        const fee = this.parseTradingFee(fees, market);
                        result[symbol] = fee;
                    }
                    return result;
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostBalance(params);
                    return this.parseTradingFees(response);
                }
                parseFundingFees(balance) {
                    const withdraw = {};
                    const ids = Object.keys(balance);
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        if (id.indexOf('_withdrawal_fee') >= 0) {
                            const currencyId = id.split('_')[0];
                            const code = this.safeCurrencyCode(currencyId);
                            withdraw[code] = this.safeNumber(balance, id);
                        }
                    }
                    return {
                        'info': balance,
                        'withdraw': withdraw,
                        'deposit': {}
                    };
                }
                async fetchFundingFees(params = {}) {
                    await this.loadMarkets();
                    const balance = await this.privatePostBalance(params);
                    return this.parseFundingFees(balance);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let method = 'privatePost' + this.capitalize(side);
                    const request = {
                        'pair': market['id'],
                        'amount': this.amountToPrecision(symbol, amount)
                    };
                    if (type === 'market') method += 'Market';
                    else if (type === 'instant') method += 'Instant';
                    else request['price'] = this.priceToPrecision(symbol, price);
                    method += 'Pair';
                    const clientOrderId = this.safeString2(params, 'client_order_id', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['client_order_id'] = clientOrderId;
                        params = this.omit(params, [
                            'client_order_id',
                            'clientOrderId'
                        ]);
                    }
                    const response = await this[method](this.extend(request, params));
                    const order = this.parseOrder(response, market);
                    return this.extend(order, {
                        'type': type
                    });
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    return await this.privatePostCancelOrder(this.extend(request, params));
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    let method = 'privatePostCancelAllOrders';
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['pair'] = market['id'];
                        method = 'privatePostCancelAllOrdersPair';
                    }
                    return await this[method](this.extend(request, params));
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'In Queue': 'open',
                        'Open': 'open',
                        'Finished': 'closed',
                        'Canceled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                async fetchOrderStatus(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const clientOrderId = this.safeValue2(params, 'client_order_id', 'clientOrderId');
                    const request = {};
                    if (clientOrderId !== undefined) {
                        request['client_order_id'] = clientOrderId;
                        params = this.omit(params, [
                            'client_order_id',
                            'clientOrderId'
                        ]);
                    } else request['id'] = id;
                    const response = await this.privatePostOrderStatus(this.extend(request, params));
                    return this.parseOrderStatus(this.safeString(response, 'status'));
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const clientOrderId = this.safeValue2(params, 'client_order_id', 'clientOrderId');
                    const request = {};
                    if (clientOrderId !== undefined) {
                        request['client_order_id'] = clientOrderId;
                        params = this.omit(params, [
                            'client_order_id',
                            'clientOrderId'
                        ]);
                    } else request['id'] = id;
                    const response = await this.privatePostOrderStatus(this.extend(request, params));
                    //
                    //      {
                    //          "status": "Finished",
                    //          "id": 1429545880227846,
                    //          "amount_remaining": "0.00000000",
                    //          "transactions": [
                    //              {
                    //                  "fee": "0.11128",
                    //                  "price": "4451.25000000",
                    //                  "datetime": "2021-11-25 12:59:59.322000",
                    //                  "usdt": "22.25625000",
                    //                  "tid": 209895701,
                    //                  "eth": "0.00500000",
                    //                  "type": 2
                    //              }
                    //         ]
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let method = 'privatePostUserTransactions';
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['pair'] = market['id'];
                        method += 'Pair';
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this[method](this.extend(request, params));
                    const result = this.filterBy(response, 'type', '2');
                    return this.parseTrades(result, market, since, limit);
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privatePostUserTransactions(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "fee": "0.00000000",
                    //             "btc_usd": "0.00",
                    //             "id": 1234567894,
                    //             "usd": 0,
                    //             "btc": 0,
                    //             "datetime": "2018-09-08 09:00:31",
                    //             "type": "1",
                    //             "xrp": "-20.00000000",
                    //             "eur": 0,
                    //         },
                    //         {
                    //             "fee": "0.00000000",
                    //             "btc_usd": "0.00",
                    //             "id": 1134567891,
                    //             "usd": 0,
                    //             "btc": 0,
                    //             "datetime": "2018-09-07 18:47:52",
                    //             "type": "0",
                    //             "xrp": "20.00000000",
                    //             "eur": 0,
                    //         },
                    //     ]
                    //
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const transactions = this.filterByArray(response, 'type', [
                        '0',
                        '1'
                    ], false);
                    return this.parseTransactions(transactions, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (since !== undefined) request['timedelta'] = this.milliseconds() - since;
                    else request['timedelta'] = 50000000; // use max bitstamp approved value
                    const response = await this.privatePostWithdrawalRequests(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             status: 2,
                    //             datetime: '2018-10-17 10:58:13',
                    //             currency: 'BTC',
                    //             amount: '0.29669259',
                    //             address: 'aaaaa',
                    //             type: 1,
                    //             id: 111111,
                    //             transaction_id: 'xxxx',
                    //         },
                    //         {
                    //             status: 2,
                    //             datetime: '2018-10-17 10:55:17',
                    //             currency: 'ETH',
                    //             amount: '1.11010664',
                    //             address: 'aaaa',
                    //             type: 16,
                    //             id: 222222,
                    //             transaction_id: 'xxxxx',
                    //         },
                    //     ]
                    //
                    return this.parseTransactions(response, undefined, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchTransactions
                    //
                    //     {
                    //         "fee": "0.00000000",
                    //         "btc_usd": "0.00",
                    //         "id": 1234567894,
                    //         "usd": 0,
                    //         "btc": 0,
                    //         "datetime": "2018-09-08 09:00:31",
                    //         "type": "1",
                    //         "xrp": "-20.00000000",
                    //         "eur": 0,
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         status: 2,
                    //         datetime: '2018-10-17 10:58:13',
                    //         currency: 'BTC',
                    //         amount: '0.29669259',
                    //         address: 'aaaaa',
                    //         type: 1,
                    //         id: 111111,
                    //         transaction_id: 'xxxx',
                    //     }
                    //
                    //     {
                    //         "id": 3386432,
                    //         "type": 14,
                    //         "amount": "863.21332500",
                    //         "status": 2,
                    //         "address": "rE1sdh25BJQ3qFwngiTBwaq3zPGGYcrjp1?dt=1455",
                    //         "currency": "XRP",
                    //         "datetime": "2018-01-05 15:27:55",
                    //         "transaction_id": "001743B03B0C79BA166A064AC0142917B050347B4CB23BA2AB4B91B3C5608F4C"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(transaction, 'datetime'));
                    const id = this.safeString(transaction, 'id');
                    const currencyId = this.getCurrencyIdFromTransaction(transaction);
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const feeCost = this.safeNumber(transaction, 'fee');
                    let feeCurrency = undefined;
                    let amount = undefined;
                    if ('amount' in transaction) amount = this.safeNumber(transaction, 'amount');
                    else if (currency !== undefined) {
                        amount = this.safeNumber(transaction, currency['id'], amount);
                        feeCurrency = currency['code'];
                    } else if (code !== undefined && currencyId !== undefined) {
                        amount = this.safeNumber(transaction, currencyId, amount);
                        feeCurrency = code;
                    }
                    if (amount !== undefined) // withdrawals have a negative amount
                    amount = Math.abs(amount);
                    let status = 'ok';
                    if ('status' in transaction) status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    let type = undefined;
                    if ('type' in transaction) {
                        // from fetchTransactions
                        const rawType = this.safeString(transaction, 'type');
                        if (rawType === '0') type = 'deposit';
                        else if (rawType === '1') type = 'withdrawal';
                    } else // from fetchWithdrawals
                    type = 'withdrawal';
                    const txid = this.safeString(transaction, 'transaction_id');
                    let tag = undefined;
                    let address = this.safeString(transaction, 'address');
                    if (address !== undefined) {
                        // dt (destination tag) is embedded into the address field
                        const addressParts = address.split('?dt=');
                        const numParts = addressParts.length;
                        if (numParts > 1) {
                            address = addressParts[0];
                            tag = addressParts[1];
                        }
                    }
                    const addressFrom = undefined;
                    const addressTo = address;
                    const tagFrom = undefined;
                    const tagTo = tag;
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'currency': feeCurrency,
                        'cost': feeCost,
                        'rate': undefined
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': addressFrom,
                        'addressTo': addressTo,
                        'address': address,
                        'tagFrom': tagFrom,
                        'tagTo': tagTo,
                        'tag': tag,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'fee': fee
                    };
                }
                parseTransactionStatus(status) {
                    // withdrawals:
                    // 0 (open), 1 (in process), 2 (finished), 3 (canceled) or 4 (failed).
                    const statuses = {
                        '0': 'pending',
                        '1': 'pending',
                        '2': 'ok',
                        '3': 'canceled',
                        '4': 'failed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    // from fetch order:
                    //   { status: 'Finished',
                    //     id: 731693945,
                    //     client_order_id: '',
                    //     transactions:
                    //     [ { fee: '0.000019',
                    //         price: '0.00015803',
                    //         datetime: '2018-01-07 10:45:34.132551',
                    //         btc: '0.0079015000000000',
                    //         tid: 42777395,
                    //         type: 2,
                    //         xrp: '50.00000000' } ] }
                    //
                    // partially filled order:
                    //   { "id": 468646390,
                    //     "client_order_id": "",
                    //     "status": "Canceled",
                    //     "transactions": [{
                    //         "eth": "0.23000000",
                    //         "fee": "0.09",
                    //         "tid": 25810126,
                    //         "usd": "69.8947000000000000",
                    //         "type": 2,
                    //         "price": "303.89000000",
                    //         "datetime": "2017-11-11 07:22:20.710567"
                    //     }]}
                    //
                    // from create order response:
                    //     {
                    //         price: '0.00008012',
                    //         client_order_id: '',
                    //         currency_pair: 'XRP/BTC',
                    //         datetime: '2019-01-31 21:23:36',
                    //         amount: '15.00000000',
                    //         type: '0',
                    //         id: '2814205012'
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const clientOrderId = this.safeString(order, 'client_order_id');
                    let side = this.safeString(order, 'type');
                    if (side !== undefined) side = side === '1' ? 'sell' : 'buy';
                    // there is no timestamp from fetchOrder
                    const timestamp = this.parse8601(this.safeString(order, 'datetime'));
                    const marketId = this.safeStringLower(order, 'currency_pair');
                    const symbol = this.safeSymbol(marketId, market, '/');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const amount = this.safeString(order, 'amount');
                    const transactions = this.safeValue(order, 'transactions', []);
                    const price = this.safeString(order, 'price');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': undefined,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'amount': amount,
                        'filled': undefined,
                        'remaining': undefined,
                        'trades': transactions,
                        'fee': undefined,
                        'info': order,
                        'average': undefined
                    }, market);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        '0': 'transaction',
                        '1': 'transaction',
                        '2': 'trade',
                        '14': 'transfer'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     [
                    //         {
                    //             "fee": "0.00000000",
                    //             "btc_usd": "0.00",
                    //             "id": 1234567894,
                    //             "usd": 0,
                    //             "btc": 0,
                    //             "datetime": "2018-09-08 09:00:31",
                    //             "type": "1",
                    //             "xrp": "-20.00000000",
                    //             "eur": 0,
                    //         },
                    //         {
                    //             "fee": "0.00000000",
                    //             "btc_usd": "0.00",
                    //             "id": 1134567891,
                    //             "usd": 0,
                    //             "btc": 0,
                    //             "datetime": "2018-09-07 18:47:52",
                    //             "type": "0",
                    //             "xrp": "20.00000000",
                    //             "eur": 0,
                    //         },
                    //     ]
                    //
                    const type = this.parseLedgerEntryType(this.safeString(item, 'type'));
                    if (type === 'trade') {
                        const parsedTrade = this.parseTrade(item);
                        let market = undefined;
                        const keys = Object.keys(item);
                        for(let i = 0; i < keys.length; i++)if (keys[i].indexOf('_') >= 0) {
                            const marketId = keys[i].replace('_', '');
                            if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                        }
                        // if the market is still not defined
                        // try to deduce it from used keys
                        if (market === undefined) market = this.getMarketFromTrade(item);
                        const direction = parsedTrade['side'] === 'buy' ? 'in' : 'out';
                        return {
                            'id': parsedTrade['id'],
                            'info': item,
                            'timestamp': parsedTrade['timestamp'],
                            'datetime': parsedTrade['datetime'],
                            'direction': direction,
                            'account': undefined,
                            'referenceId': parsedTrade['order'],
                            'referenceAccount': undefined,
                            'type': type,
                            'currency': market['base'],
                            'amount': parsedTrade['amount'],
                            'before': undefined,
                            'after': undefined,
                            'status': 'ok',
                            'fee': parsedTrade['fee']
                        };
                    } else {
                        const parsedTransaction = this.parseTransaction(item, currency);
                        let direction = undefined;
                        if ('amount' in item) {
                            const amount = this.safeNumber(item, 'amount');
                            direction = amount > 0 ? 'in' : 'out';
                        } else if ('currency' in parsedTransaction && parsedTransaction['currency'] !== undefined) {
                            const currencyCode = this.safeString(parsedTransaction, 'currency');
                            currency = this.currency(currencyCode);
                            const amount = this.safeNumber(item, currency['id']);
                            direction = amount > 0 ? 'in' : 'out';
                        }
                        return {
                            'id': parsedTransaction['id'],
                            'info': item,
                            'timestamp': parsedTransaction['timestamp'],
                            'datetime': parsedTransaction['datetime'],
                            'direction': direction,
                            'account': undefined,
                            'referenceId': parsedTransaction['txid'],
                            'referenceAccount': undefined,
                            'type': type,
                            'currency': parsedTransaction['currency'],
                            'amount': parsedTransaction['amount'],
                            'before': undefined,
                            'after': undefined,
                            'status': parsedTransaction['status'],
                            'fee': parsedTransaction['fee']
                        };
                    }
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privatePostUserTransactions(this.extend(request, params));
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    return this.parseLedger(response, currency, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    let market = undefined;
                    await this.loadMarkets();
                    if (symbol !== undefined) market = this.market(symbol);
                    const response = await this.privatePostOpenOrdersAll(params);
                    //     [
                    //         {
                    //             price: '0.00008012',
                    //             currency_pair: 'XRP/BTC',
                    //             client_order_id: '',
                    //             datetime: '2019-01-31 21:23:36',
                    //             amount: '15.00000000',
                    //             type: '0',
                    //             id: '2814205012',
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit, {
                        'status': 'open',
                        'type': 'limit'
                    });
                }
                getCurrencyName(code) {
                    return code.toLowerCase();
                }
                isFiat(code) {
                    return code === 'USD' || code === 'EUR' || code === 'GBP';
                }
                async fetchDepositAddress(code, params = {}) {
                    if (this.isFiat(code)) throw new NotSupported(this.id + ' fiat fetchDepositAddress() for ' + code + ' is not supported!');
                    const name = this.getCurrencyName(code);
                    const method = 'privatePost' + this.capitalize(name) + 'Address';
                    const response = await this[method](params);
                    const address = this.safeString(response, 'address');
                    const tag = this.safeString2(response, 'memo_id', 'destination_tag');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    // For fiat withdrawals please provide all required additional parameters in the 'params'
                    // Check https://www.bitstamp.net/api/ under 'Open bank withdrawal' for list and description.
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    this.checkAddress(address);
                    const request = {
                        'amount': amount
                    };
                    let currency = undefined;
                    let method = undefined;
                    if (!this.isFiat(code)) {
                        const name = this.getCurrencyName(code);
                        method = 'privatePost' + this.capitalize(name) + 'Withdrawal';
                        if (code === 'XRP') {
                            if (tag !== undefined) request['destination_tag'] = tag;
                        } else if (code === 'XLM' || code === 'HBAR') {
                            if (tag !== undefined) request['memo_id'] = tag;
                        }
                        request['address'] = address;
                    } else {
                        method = 'privatePostWithdrawalOpen';
                        currency = this.currency(code);
                        request['iban'] = address;
                        request['account_currency'] = currency['id'];
                    }
                    const response = await this[method](this.extend(request, params));
                    return this.parseTransaction(response, currency);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/';
                    url += this.version + '/';
                    url += this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        const xAuth = 'BITSTAMP ' + this.apiKey;
                        const xAuthNonce = this.uuid();
                        const xAuthTimestamp = this.milliseconds().toString();
                        const xAuthVersion = 'v2';
                        let contentType = '';
                        headers = {
                            'X-Auth': xAuth,
                            'X-Auth-Nonce': xAuthNonce,
                            'X-Auth-Timestamp': xAuthTimestamp,
                            'X-Auth-Version': xAuthVersion
                        };
                        if (method === 'POST') {
                            if (Object.keys(query).length) {
                                body = this.urlencode(query);
                                contentType = 'application/x-www-form-urlencoded';
                                headers['Content-Type'] = contentType;
                            } else {
                                // sending an empty POST request will trigger
                                // an API0020 error returned by the exchange
                                // therefore for empty requests we send a dummy object
                                // https://github.com/ccxt/ccxt/issues/6846
                                body = this.urlencode({
                                    'foo': 'bar'
                                });
                                contentType = 'application/x-www-form-urlencoded';
                                headers['Content-Type'] = contentType;
                            }
                        }
                        const authBody = body ? body : '';
                        const auth = xAuth + method + url.replace('https://', '') + contentType + xAuthNonce + xAuthTimestamp + xAuthVersion + authBody;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                        headers['X-Auth-Signature'] = signature;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    //     {"error": "No permission found"} // fetchDepositAddress returns this on apiKeys that don't have the permission required
                    //     {"status": "error", "reason": {"__all__": ["Minimum order size is 5.0 EUR."]}}
                    //     reuse of a nonce gives: { status: 'error', reason: 'Invalid nonce', code: 'API0004' }
                    const status = this.safeString(response, 'status');
                    const error = this.safeValue(response, 'error');
                    if (status === 'error' || error !== undefined) {
                        let errors = [];
                        if (typeof error === 'string') errors.push(error);
                        else if (error !== undefined) {
                            const keys = Object.keys(error);
                            for(let i = 0; i < keys.length; i++){
                                const key = keys[i];
                                const value = this.safeValue(error, key);
                                if (Array.isArray(value)) errors = this.arrayConcat(errors, value);
                                else errors.push(value);
                            }
                        }
                        const reason = this.safeValue(response, 'reason', {});
                        if (typeof reason === 'string') errors.push(reason);
                        else {
                            const all = this.safeValue(reason, '__all__', []);
                            for(let i = 0; i < all.length; i++)errors.push(all[i]);
                        }
                        const code = this.safeString(response, 'code');
                        if (code === 'API0005') throw new AuthenticationError(this.id + ' invalid signature, use the uid for the main account if you have subaccounts');
                        const feedback = this.id + ' ' + body;
                        for(let i = 0; i < errors.length; i++){
                            const value = errors[i];
                            this.throwExactlyMatchedException(this.exceptions['exact'], value, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['broad'], value, feedback);
                        }
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    45: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { BadSymbol: BadSymbol, ExchangeError: ExchangeError1 } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bitstamp1 extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitstamp1',
                        'name': 'Bitstamp',
                        'countries': [
                            'GB'
                        ],
                        'rateLimit': 1000,
                        'version': 'v1',
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOrder': undefined,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27786377-8c8ab57e-5fe9-11e7-8ea4-2b05b6bcceec.jpg',
                            'api': 'https://www.bitstamp.net/api',
                            'www': 'https://www.bitstamp.net',
                            'doc': 'https://www.bitstamp.net/api'
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'uid': true
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'ticker',
                                    'ticker_hour',
                                    'order_book',
                                    'transactions',
                                    'eur_usd'
                                ]
                            },
                            'private': {
                                'post': [
                                    'balance',
                                    'user_transactions',
                                    'open_orders',
                                    'order_status',
                                    'cancel_order',
                                    'cancel_all_orders',
                                    'buy',
                                    'sell',
                                    'bitcoin_deposit_address',
                                    'unconfirmed_btc',
                                    'ripple_withdrawal',
                                    'ripple_address',
                                    'withdrawal_requests',
                                    'bitcoin_withdrawal'
                                ]
                            }
                        },
                        'markets': {
                            'BTC/USD': {
                                'id': 'btcusd',
                                'symbol': 'BTC/USD',
                                'base': 'BTC',
                                'quote': 'USD',
                                'baseId': 'btc',
                                'quoteId': 'usd',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            },
                            'BTC/EUR': {
                                'id': 'btceur',
                                'symbol': 'BTC/EUR',
                                'base': 'BTC',
                                'quote': 'EUR',
                                'baseId': 'btc',
                                'quoteId': 'eur',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            },
                            'EUR/USD': {
                                'id': 'eurusd',
                                'symbol': 'EUR/USD',
                                'base': 'EUR',
                                'quote': 'USD',
                                'baseId': 'eur',
                                'quoteId': 'usd',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            },
                            'XRP/USD': {
                                'id': 'xrpusd',
                                'symbol': 'XRP/USD',
                                'base': 'XRP',
                                'quote': 'USD',
                                'baseId': 'xrp',
                                'quoteId': 'usd',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            },
                            'XRP/EUR': {
                                'id': 'xrpeur',
                                'symbol': 'XRP/EUR',
                                'base': 'XRP',
                                'quote': 'EUR',
                                'baseId': 'xrp',
                                'quoteId': 'eur',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            },
                            'XRP/BTC': {
                                'id': 'xrpbtc',
                                'symbol': 'XRP/BTC',
                                'base': 'XRP',
                                'quote': 'BTC',
                                'baseId': 'xrp',
                                'quoteId': 'btc',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            },
                            'LTC/USD': {
                                'id': 'ltcusd',
                                'symbol': 'LTC/USD',
                                'base': 'LTC',
                                'quote': 'USD',
                                'baseId': 'ltc',
                                'quoteId': 'usd',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            },
                            'LTC/EUR': {
                                'id': 'ltceur',
                                'symbol': 'LTC/EUR',
                                'base': 'LTC',
                                'quote': 'EUR',
                                'baseId': 'ltc',
                                'quoteId': 'eur',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            },
                            'LTC/BTC': {
                                'id': 'ltcbtc',
                                'symbol': 'LTC/BTC',
                                'base': 'LTC',
                                'quote': 'BTC',
                                'baseId': 'ltc',
                                'quoteId': 'btc',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            },
                            'ETH/USD': {
                                'id': 'ethusd',
                                'symbol': 'ETH/USD',
                                'base': 'ETH',
                                'quote': 'USD',
                                'baseId': 'eth',
                                'quoteId': 'usd',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            },
                            'ETH/EUR': {
                                'id': 'etheur',
                                'symbol': 'ETH/EUR',
                                'base': 'ETH',
                                'quote': 'EUR',
                                'baseId': 'eth',
                                'quoteId': 'eur',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            },
                            'ETH/BTC': {
                                'id': 'ethbtc',
                                'symbol': 'ETH/BTC',
                                'base': 'ETH',
                                'quote': 'BTC',
                                'baseId': 'eth',
                                'quoteId': 'btc',
                                'maker': 0.005,
                                'taker': 0.005,
                                'type': 'spot',
                                'spot': true
                            }
                        }
                    });
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    if (symbol !== 'BTC/USD') throw new ExchangeError1(this.id + ' ' + this.version + " fetchOrderBook doesn't support " + symbol + ', use it for BTC/USD only');
                    await this.loadMarkets();
                    const orderbook = await this.publicGetOrderBook(params);
                    const timestamp = this.safeTimestamp(orderbook, 'timestamp');
                    return this.parseOrderBook(orderbook, symbol, timestamp);
                }
                parseTicker(ticker, market) {
                    //
                    // {
                    //     "volume": "2836.47827985",
                    //     "last": "36544.93",
                    //     "timestamp": "1643372072",
                    //     "bid": "36535.79",
                    //     "vwap":"36594.20",
                    //     "high": "37534.15",
                    //     "low": "35511.32",
                    //     "ask": "36548.47",
                    //     "open": 37179.62
                    // }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.safeTimestamp(ticker, 'timestamp');
                    const vwap = this.safeString(ticker, 'vwap');
                    const baseVolume = this.safeString(ticker, 'volume');
                    const quoteVolume = Precise.stringMul(baseVolume, vwap);
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': vwap,
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    if (symbol !== 'BTC/USD') throw new ExchangeError1(this.id + ' ' + this.version + " fetchTicker doesn't support " + symbol + ', use it for BTC/USD only');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const ticker = await this.publicGetTicker(params);
                    //
                    // {
                    //     "volume": "2836.47827985",
                    //     "last": "36544.93",
                    //     "timestamp": "1643372072",
                    //     "bid": "36535.79",
                    //     "vwap":"36594.20",
                    //     "high": "37534.15",
                    //     "low": "35511.32",
                    //     "ask": "36548.47",
                    //     "open": 37179.62
                    // }
                    //
                    return this.parseTicker(ticker, market);
                }
                parseTrade(trade, market) {
                    const timestamp = this.safeTimestamp2(trade, 'date', 'datetime');
                    const side = trade['type'] === 0 ? 'buy' : 'sell';
                    const orderId = this.safeString(trade, 'order_id');
                    const id = this.safeString(trade, 'tid');
                    const price = this.safeString(trade, 'price');
                    const amount = this.safeString(trade, 'amount');
                    const marketId = this.safeString(trade, 'currency_pair');
                    market = this.safeMarket(marketId, market);
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    if (symbol !== 'BTC/USD') throw new BadSymbol(this.id + ' ' + this.version + " fetchTrades doesn't support " + symbol + ', use it for BTC/USD only');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'time': 'minute'
                    };
                    const response = await this.publicGetTransactions(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const codes = Object.keys(this.currencies);
                    for(let i = 0; i < codes.length; i++){
                        const code = codes[i];
                        const currency = this.currency(code);
                        const currencyId = currency['id'];
                        const account = this.account();
                        account['free'] = this.safeString(response, currencyId + '_available');
                        account['used'] = this.safeString(response, currencyId + '_reserved');
                        account['total'] = this.safeString(response, currencyId + '_balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    const response = await this.privatePostBalance(params);
                    return this.parseBalance(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (type !== 'limit') throw new ExchangeError1(this.id + ' ' + this.version + ' accepts limit orders only');
                    if (symbol !== 'BTC/USD') throw new ExchangeError1(this.id + ' v1 supports BTC/USD orders only');
                    await this.loadMarkets();
                    const method = 'privatePost' + this.capitalize(side);
                    const request = {
                        'amount': amount,
                        'price': price
                    };
                    const response = await this[method](this.extend(request, params));
                    const id = this.safeString(response, 'id');
                    return {
                        'info': response,
                        'id': id
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    return await this.privatePostCancelOrder({
                        'id': id
                    });
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'In Queue': 'open',
                        'Open': 'open',
                        'Finished': 'closed',
                        'Canceled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                async fetchOrderStatus(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privatePostOrderStatus(this.extend(request, params));
                    return this.parseOrderStatus(response);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const pair = market ? market['id'] : 'all';
                    const request = {
                        'id': pair
                    };
                    const response = await this.privatePostOpenOrdersId(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + this.implodeParams(path, params);
                    let query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const auth = nonce + this.uid + this.apiKey;
                        const signature = this.encode(this.hmac(this.encode(auth), this.encode(this.secret)));
                        query = this.extend({
                            'key': this.apiKey,
                            'signature': signature.toUpperCase(),
                            'nonce': nonce
                        }, query);
                        body = this.urlencode(query);
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    const status = this.safeString(response, 'status');
                    if (status === 'error') throw new ExchangeError1(this.id + ' ' + this.json(response));
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    46: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ArgumentsRequired: ArgumentsRequired1, BadSymbol: BadSymbol, ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, AuthenticationError: AuthenticationError, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, DDoSProtection: DDoSProtection, PermissionDenied: PermissionDenied, AddressPending: AddressPending, OnMaintenance: OnMaintenance, BadRequest: BadRequest, InvalidAddress: InvalidAddress } = require1('./base/errors');
            const { TRUNCATE: TRUNCATE, DECIMAL_PLACES: DECIMAL_PLACES } = require1('./base/functions/number');
            //  ---------------------------------------------------------------------------
            module.exports = class bittrex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bittrex',
                        'name': 'Bittrex',
                        'countries': [
                            'US'
                        ],
                        'version': 'v3',
                        'rateLimit': 1500,
                        'certified': false,
                        'pro': true,
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createMarketOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingFees': undefined,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': 'emulated',
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': true,
                            'fetchTransactions': undefined,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': 'MINUTE_1',
                            '5m': 'MINUTE_5',
                            '1h': 'HOUR_1',
                            '1d': 'DAY_1'
                        },
                        'hostname': 'bittrex.com',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87153921-edf53180-c2c0-11ea-96b9-f2a9a95a455b.jpg',
                            'api': {
                                'public': 'https://api.bittrex.com',
                                'private': 'https://api.bittrex.com'
                            },
                            'www': 'https://bittrex.com',
                            'doc': [
                                'https://bittrex.github.io/api/v3'
                            ],
                            'fees': [
                                'https://bittrex.zendesk.com/hc/en-us/articles/115003684371-BITTREX-SERVICE-FEES-AND-WITHDRAWAL-LIMITATIONS',
                                'https://bittrex.zendesk.com/hc/en-us/articles/115000199651-What-fees-does-Bittrex-charge-'
                            ],
                            'referral': 'https://bittrex.com/Account/Register?referralCode=1ZE-G0G-M3B'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'ping',
                                    'currencies',
                                    'currencies/{symbol}',
                                    'markets',
                                    'markets/tickers',
                                    'markets/summaries',
                                    'markets/{marketSymbol}',
                                    'markets/{marketSymbol}/summary',
                                    'markets/{marketSymbol}/orderbook',
                                    'markets/{marketSymbol}/trades',
                                    'markets/{marketSymbol}/ticker',
                                    'markets/{marketSymbol}/candles/{candleInterval}/recent',
                                    'markets/{marketSymbol}/candles/{candleInterval}/historical/{year}/{month}/{day}',
                                    'markets/{marketSymbol}/candles/{candleInterval}/historical/{year}/{month}',
                                    'markets/{marketSymbol}/candles/{candleInterval}/historical/{year}'
                                ]
                            },
                            'private': {
                                'get': [
                                    'account',
                                    'account/fees/fiat',
                                    'account/fees/fiat/{currencySymbol}',
                                    'account/fees/trading',
                                    'account/fees/trading/{marketSymbol}',
                                    'account/volume',
                                    'addresses',
                                    'addresses/{currencySymbol}',
                                    'balances',
                                    'balances/{currencySymbol}',
                                    'deposits/open',
                                    'deposits/closed',
                                    'deposits/ByTxId/{txId}',
                                    'deposits/{depositId}',
                                    'orders/closed',
                                    'orders/open',
                                    'orders/{orderId}',
                                    'orders/{orderId}/executions',
                                    'ping',
                                    'subaccounts/{subaccountId}',
                                    'subaccounts',
                                    'withdrawals/open',
                                    'withdrawals/closed',
                                    'withdrawals/ByTxId/{txId}',
                                    'withdrawals/{withdrawalId}',
                                    'withdrawals/whitelistAddresses',
                                    'conditional-orders/{conditionalOrderId}',
                                    'conditional-orders/closed',
                                    'conditional-orders/open',
                                    'transfers/sent',
                                    'transfers/received',
                                    'transfers/{transferId}'
                                ],
                                'post': [
                                    'addresses',
                                    'orders',
                                    'subaccounts',
                                    'withdrawals',
                                    'conditional-orders',
                                    'transfers'
                                ],
                                'delete': [
                                    'orders/open',
                                    'orders/{orderId}',
                                    'withdrawals/{withdrawalId}',
                                    'conditional-orders/{conditionalOrderId}'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'maker': this.parseNumber('0.0075'),
                                'taker': this.parseNumber('0.0075')
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'BAD_REQUEST': BadRequest,
                                'STARTDATE_OUT_OF_RANGE': BadRequest,
                                // 'Call to Cancel was throttled. Try again in 60 seconds.': DDoSProtection,
                                // 'Call to GetBalances was throttled. Try again in 60 seconds.': DDoSProtection,
                                'APISIGN_NOT_PROVIDED': AuthenticationError,
                                'APIKEY_INVALID': AuthenticationError,
                                'INVALID_SIGNATURE': AuthenticationError,
                                'INVALID_CURRENCY': ExchangeError1,
                                'INVALID_PERMISSION': AuthenticationError,
                                'INSUFFICIENT_FUNDS': InsufficientFunds,
                                'INVALID_CEILING_MARKET_BUY': InvalidOrder,
                                'INVALID_FIAT_ACCOUNT': InvalidOrder,
                                'INVALID_ORDER_TYPE': InvalidOrder,
                                'QUANTITY_NOT_PROVIDED': InvalidOrder,
                                'MIN_TRADE_REQUIREMENT_NOT_MET': InvalidOrder,
                                'NOT_FOUND': OrderNotFound,
                                'ORDER_NOT_OPEN': OrderNotFound,
                                'INVALID_ORDER': InvalidOrder,
                                'UUID_INVALID': OrderNotFound,
                                'RATE_NOT_PROVIDED': InvalidOrder,
                                'INVALID_MARKET': BadSymbol,
                                'WHITELIST_VIOLATION_IP': PermissionDenied,
                                'DUST_TRADE_DISALLOWED_MIN_VALUE': InvalidOrder,
                                'RESTRICTED_MARKET': BadSymbol,
                                'We are down for scheduled maintenance, but we\u2019ll be back up shortly.': OnMaintenance
                            },
                            'broad': {
                                'throttled': DDoSProtection,
                                'problem': ExchangeNotAvailable
                            }
                        },
                        'options': {
                            'fetchTicker': {
                                'method': 'publicGetMarketsMarketSymbolTicker'
                            },
                            'fetchTickers': {
                                'method': 'publicGetMarketsTickers'
                            },
                            'parseOrderStatus': false,
                            'hasAlreadyAuthenticatedSuccessfully': false,
                            // With certain currencies, like
                            // AEON, BTS, GXS, NXT, SBD, STEEM, STR, XEM, XLM, XMR, XRP
                            // an additional tag / memo / payment id is usually required by exchanges.
                            // With Bittrex some currencies imply the "base address + tag" logic.
                            // The base address for depositing is stored on this.currencies[code]
                            // The base address identifies the exchange as the recipient
                            // while the tag identifies the user account within the exchange
                            // and the tag is retrieved with fetchDepositAddress.
                            'tag': {
                                'NXT': true,
                                'CRYPTO_NOTE_PAYMENTID': true,
                                'BITSHAREX': true,
                                'RIPPLE': true,
                                'NEM': true,
                                'STELLAR': true,
                                'STEEM': true
                            },
                            'subaccountId': undefined,
                            // see the implementation of fetchClosedOrdersV3 below
                            // 'fetchClosedOrdersMethod': 'fetch_closed_orders_v3',
                            'fetchClosedOrdersFilterBySince': true
                        },
                        'commonCurrencies': {
                            'BIFI': 'Bifrost Finance',
                            'BTR': 'BTRIPS',
                            'GMT': 'GMT Token',
                            'MEME': 'Memetic',
                            'MER': 'Mercury',
                            'PROS': 'Pros.Finance',
                            'REPV2': 'REP',
                            'TON': 'Tokamak Network'
                        }
                    });
                }
                costToPrecision(symbol, cost) {
                    return this.decimalToPrecision(cost, TRUNCATE, this.markets[symbol]['precision']['price'], DECIMAL_PLACES);
                }
                feeToPrecision(symbol, fee) {
                    return this.decimalToPrecision(fee, TRUNCATE, this.markets[symbol]['precision']['price'], DECIMAL_PLACES);
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetMarkets(params);
                    //
                    //     [
                    //         {
                    //             "symbol":"LTC-BTC",
                    //             "baseCurrencySymbol":"LTC",
                    //             "quoteCurrencySymbol":"BTC",
                    //             "minTradeSize":"0.01686767",
                    //             "precision":8,
                    //             "status":"ONLINE", // "OFFLINE"
                    //             "createdAt":"2014-02-13T00:00:00Z"
                    //         },
                    //         {
                    //             "symbol":"VDX-USDT",
                    //             "baseCurrencySymbol":"VDX",
                    //             "quoteCurrencySymbol":"USDT",
                    //             "minTradeSize":"300.00000000",
                    //             "precision":8,
                    //             "status":"ONLINE", // "OFFLINE"
                    //             "createdAt":"2019-05-23T00:41:21.843Z",
                    //             "notice":"USDT has swapped to an ERC20-based token as of August 5, 2019."
                    //         }
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const baseId = this.safeString(market, 'baseCurrencySymbol');
                        const quoteId = this.safeString(market, 'quoteCurrencySymbol');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const status = this.safeString(market, 'status');
                        result.push({
                            'id': this.safeString(market, 'symbol'),
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': status === 'ONLINE',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': parseInt('8'),
                                'price': this.safeInteger(market, 'precision', 8)
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minTradeSize'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const indexed = this.indexBy(response, 'currencySymbol');
                    const currencyIds = Object.keys(indexed);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        const balance = indexed[currencyId];
                        account['free'] = this.safeString(balance, 'available');
                        account['total'] = this.safeString(balance, 'total');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalances(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'marketSymbol': this.marketId(symbol)
                    };
                    if (limit !== undefined) {
                        if (limit !== 1 && limit !== 25 && limit !== 500) throw new BadRequest(this.id + ' fetchOrderBook() limit argument must be undefined, 1, 25 or 500, default is 25');
                        request['depth'] = limit;
                    }
                    const response = await this.publicGetMarketsMarketSymbolOrderbook(this.extend(request, params));
                    //
                    //     {
                    //         "bid":[
                    //             {"quantity":"0.01250000","rate":"10718.56200003"},
                    //             {"quantity":"0.10000000","rate":"10718.56200002"},
                    //             {"quantity":"0.39648292","rate":"10718.56200001"},
                    //         ],
                    //         "ask":[
                    //             {"quantity":"0.05100000","rate":"10724.30099631"},
                    //             {"quantity":"0.10000000","rate":"10724.30099632"},
                    //             {"quantity":"0.26000000","rate":"10724.30099634"},
                    //         ]
                    //     }
                    //
                    const sequence = this.safeInteger(this.last_response_headers, 'Sequence');
                    const orderbook = this.parseOrderBook(response, symbol, undefined, 'bid', 'ask', 'rate', 'quantity');
                    orderbook['nonce'] = sequence;
                    return orderbook;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     [
                    //         {
                    //             "symbol":"1ST",
                    //             "name":"Firstblood",
                    //             "coinType":"ETH_CONTRACT",
                    //             "status":"ONLINE",
                    //             "minConfirmations":36,
                    //             "notice":"",
                    //             "txFee":"4.50000000",
                    //             "logoUrl":"https://bittrexblobstorage.blob.core.windows.net/public/5685a7be-1edf-4ba0-a313-b5309bb204f8.png",
                    //             "prohibitedIn":[],
                    //             "baseAddress":"0xfbb1b73c4f0bda4f67dca266ce6ef42f520fbb98",
                    //             "associatedTermsOfService":[]
                    //         }
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        const id = this.safeString(currency, 'symbol');
                        const code = this.safeCurrencyCode(id);
                        const precision = 8; // default precision, todo: fix "magic constants"
                        const fee = this.safeNumber(currency, 'txFee'); // todo: redesign
                        const isActive = this.safeString(currency, 'status');
                        result[code] = {
                            'id': id,
                            'code': code,
                            'address': this.safeString(currency, 'baseAddress'),
                            'info': currency,
                            'type': this.safeString(currency, 'coinType'),
                            'name': this.safeString(currency, 'name'),
                            'active': isActive === 'ONLINE',
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': fee,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': 1 / Math.pow(10, precision),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': fee,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    // ticker
                    //
                    //     {
                    //         "symbol":"ETH-BTC",
                    //         "lastTradeRate":"0.03284496",
                    //         "bidRate":"0.03284523",
                    //         "askRate":"0.03286857"
                    //     }
                    //
                    // summary
                    //
                    //     {
                    //         "symbol":"ETH-BTC",
                    //         "high":"0.03369528",
                    //         "low":"0.03282442",
                    //         "volume":"4307.83794556",
                    //         "quoteVolume":"143.08608869",
                    //         "percentChange":"0.79",
                    //         "updatedAt":"2020-09-29T07:36:57.823Z"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(ticker, 'updatedAt'));
                    const marketId = this.safeString(ticker, 'symbol');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    const percentage = this.safeString(ticker, 'percentChange');
                    const last = this.safeString(ticker, 'lastTradeRate');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bidRate'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'askRate'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': this.safeString(ticker, 'quoteVolume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const options = this.safeValue(this.options, 'fetchTickers', {});
                    const defaultMethod = this.safeString(options, 'method', 'publicGetMarketsTickers');
                    const method = this.safeString(params, 'method', defaultMethod);
                    params = this.omit(params, 'method');
                    const response = await this[method](params);
                    //
                    // publicGetMarketsTickers
                    //
                    //     [
                    //         {
                    //             "symbol":"4ART-BTC",
                    //             "lastTradeRate":"0.00000210",
                    //             "bidRate":"0.00000210",
                    //             "askRate":"0.00000215"
                    //         }
                    //     ]
                    //
                    // publicGetMarketsSummaries
                    //
                    //     [
                    //         {
                    //             "symbol":"4ART-BTC",
                    //             "high":"0.00000206",
                    //             "low":"0.00000196",
                    //             "volume":"14871.32000233",
                    //             "quoteVolume":"0.02932756",
                    //             "percentChange":"1.48",
                    //             "updatedAt":"2020-09-29T07:34:32.757Z"
                    //         }
                    //     ]
                    //
                    const tickers = [];
                    for(let i = 0; i < response.length; i++){
                        const ticker = this.parseTicker(response[i]);
                        tickers.push(ticker);
                    }
                    return this.filterByArray(tickers, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketSymbol': market['id']
                    };
                    const options = this.safeValue(this.options, 'fetchTicker', {});
                    const defaultMethod = this.safeString(options, 'method', 'publicGetMarketsMarketSymbolTicker');
                    const method = this.safeString(params, 'method', defaultMethod);
                    params = this.omit(params, 'method');
                    const response = await this[method](this.extend(request, params));
                    //
                    // publicGetMarketsMarketSymbolTicker
                    //
                    //     {
                    //         "symbol":"ETH-BTC",
                    //         "lastTradeRate":"0.03284496",
                    //         "bidRate":"0.03284523",
                    //         "askRate":"0.03286857"
                    //     }
                    //
                    //
                    // publicGetMarketsMarketSymbolSummary
                    //
                    //     {
                    //         "symbol":"ETH-BTC",
                    //         "high":"0.03369528",
                    //         "low":"0.03282442",
                    //         "volume":"4307.83794556",
                    //         "quoteVolume":"143.08608869",
                    //         "percentChange":"0.79",
                    //         "updatedAt":"2020-09-29T07:36:57.823Z"
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //      {
                    //          "id": "8a614d4e-e455-45b0-9aac-502b0aeb433f",
                    //          "executedAt": "2021-11-25T14:54:44.65Z",
                    //          "quantity": "30.00000000",
                    //          "rate": "1.72923112",
                    //          "takerSide": "SELL"
                    //      }
                    //
                    // private fetchOrderTrades
                    //      {
                    //          "id": "8a614d4e-e455-45b0-9aac-502b0aeb433f",
                    //          "marketSymbol": "ADA-USDT",
                    //          "executedAt": "2021-11-25T14:54:44.65Z",
                    //          "quantity": "30.00000000",
                    //          "rate": "1.72923112",
                    //          "orderId": "6f7abf18-6901-4659-a48c-db0e88440ea4",
                    //          "commission": "0.38907700",
                    //          "isTaker":  true
                    //      }
                    //
                    const timestamp = this.parse8601(this.safeString(trade, 'executedAt'));
                    const id = this.safeString(trade, 'id');
                    const order = this.safeString(trade, 'orderId');
                    const marketId = this.safeString(trade, 'marketSymbol');
                    market = this.safeMarket(marketId, market, '-');
                    const priceString = this.safeString(trade, 'rate');
                    const amountString = this.safeString(trade, 'quantity');
                    let takerOrMaker = undefined;
                    const isTaker = this.safeValue(trade, 'isTaker');
                    if (isTaker !== undefined) takerOrMaker = isTaker ? 'taker' : 'maker';
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'commission');
                    if (feeCostString !== undefined) fee = {
                        'cost': feeCostString,
                        'currency': market['quote']
                    };
                    const side = this.safeStringLower(trade, 'takerSide');
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'id': id,
                        'order': order,
                        'takerOrMaker': takerOrMaker,
                        'type': undefined,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetPing(params);
                    //
                    //     {
                    //         "serverTime": 1594596023162
                    //     }
                    //
                    return this.safeInteger(response, 'serverTime');
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketSymbol': this.marketId(symbol)
                    };
                    const response = await this.publicGetMarketsMarketSymbolTrades(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id":"9c5589db-42fb-436c-b105-5e2edcb95673",
                    //             "executedAt":"2020-10-03T11:48:43.38Z",
                    //             "quantity":"0.17939626",
                    //             "rate":"0.03297952",
                    //             "takerSide":"BUY"
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketSymbol': market['id']
                    };
                    const response = await this.privateGetAccountFeesTradingMarketSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "marketSymbol":"1INCH-ETH",
                    //         "makerRate":"0.00750000",
                    //         "takerRate":"0.00750000"
                    //     }
                    //
                    return this.parseTradingFee(response, market);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountFeesTrading(params);
                    //
                    //     [
                    //         {"marketSymbol":"1ECO-BTC","makerRate":"0.00750000","takerRate":"0.00750000"},
                    //         {"marketSymbol":"1ECO-USDT","makerRate":"0.00750000","takerRate":"0.00750000"},
                    //         {"marketSymbol":"1INCH-BTC","makerRate":"0.00750000","takerRate":"0.00750000"},
                    //         {"marketSymbol":"1INCH-ETH","makerRate":"0.00750000","takerRate":"0.00750000"},
                    //         {"marketSymbol":"1INCH-USD","makerRate":"0.00750000","takerRate":"0.00750000"},
                    //     ]
                    //
                    return this.parseTradingFees(response);
                }
                parseTradingFee(fee, market) {
                    const marketId = this.safeString(fee, 'marketSymbol');
                    const maker = this.safeNumber(fee, 'makerRate');
                    const taker = this.safeNumber(fee, 'takerRate');
                    return {
                        'info': fee,
                        'symbol': this.safeSymbol(marketId, market),
                        'maker': maker,
                        'taker': taker
                    };
                }
                parseTradingFees(fees) {
                    const result = {
                        'info': fees
                    };
                    for(let i = 0; i < fees.length; i++){
                        const fee = this.parseTradingFee(fees[i]);
                        const symbol = fee['symbol'];
                        result[symbol] = fee;
                    }
                    return result;
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "startsAt":"2020-06-12T02:35:00Z",
                    //         "open":"0.02493753",
                    //         "high":"0.02493753",
                    //         "low":"0.02493753",
                    //         "close":"0.02493753",
                    //         "volume":"0.09590123",
                    //         "quoteVolume":"0.00239153"
                    //     }
                    //
                    return [
                        this.parse8601(this.safeString(ohlcv, 'startsAt')),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const reverseId = market['baseId'] + '-' + market['quoteId'];
                    const request = {
                        'candleInterval': this.timeframes[timeframe],
                        'marketSymbol': reverseId
                    };
                    let method = 'publicGetMarketsMarketSymbolCandlesCandleIntervalRecent';
                    if (since !== undefined) {
                        const now = this.milliseconds();
                        const difference = Math.abs(now - since);
                        const sinceDate = this.yyyymmdd(since);
                        const parts = sinceDate.split('-');
                        const sinceYear = this.safeInteger(parts, 0);
                        const sinceMonth = this.safeInteger(parts, 1);
                        const sinceDay = this.safeInteger(parts, 2);
                        if (timeframe === '1d') // if the since argument is beyond one year into the past
                        {
                            if (difference > 31622400000) {
                                method = 'publicGetMarketsMarketSymbolCandlesCandleIntervalHistoricalYear';
                                request['year'] = sinceYear;
                            }
                        } else if (timeframe === '1h') // if the since argument is beyond 31 days into the past
                        {
                            if (difference > 2678400000) {
                                method = 'publicGetMarketsMarketSymbolCandlesCandleIntervalHistoricalYearMonth';
                                request['year'] = sinceYear;
                                request['month'] = sinceMonth;
                            }
                        } else // if the since argument is beyond 1 day into the past
                        if (difference > 86400000) {
                            method = 'publicGetMarketsMarketSymbolCandlesCandleIntervalHistoricalYearMonthDay';
                            request['year'] = sinceYear;
                            request['month'] = sinceMonth;
                            request['day'] = sinceDay;
                        }
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     [
                    //         {"startsAt":"2020-06-12T02:35:00Z","open":"0.02493753","high":"0.02493753","low":"0.02493753","close":"0.02493753","volume":"0.09590123","quoteVolume":"0.00239153"},
                    //         {"startsAt":"2020-06-12T02:40:00Z","open":"0.02491874","high":"0.02491874","low":"0.02490970","close":"0.02490970","volume":"0.04515695","quoteVolume":"0.00112505"},
                    //         {"startsAt":"2020-06-12T02:45:00Z","open":"0.02490753","high":"0.02493143","low":"0.02490753","close":"0.02493143","volume":"0.17769640","quoteVolume":"0.00442663"}
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    const stop = this.safeValue(params, 'stop');
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['marketSymbol'] = market['id'];
                    }
                    let method = 'privateGetOrdersOpen';
                    if (stop) method = 'privateGetConditionalOrdersOpen';
                    const query = this.omit(params, 'stop');
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     [
                    //         {
                    //             "id": "df6cf5ee-fc27-4b61-991a-cc94b6459ac9",
                    //             "marketSymbol": "BTC-USDT",
                    //             "direction": "BUY",
                    //             "type": "LIMIT",
                    //             "quantity": "0.00023277",
                    //             "limit": "30000.00000000",
                    //             "timeInForce": "GOOD_TIL_CANCELLED",
                    //             "fillQuantity": "0.00000000",
                    //             "commission": "0.00000000",
                    //             "proceeds": "0.00000000",
                    //             "status": "OPEN",
                    //             "createdAt": "2022-04-20T02:33:53.16Z",
                    //             "updatedAt": "2022-04-20T02:33:53.16Z"
                    //         }
                    //     ]
                    //
                    // Stop
                    //
                    //     [
                    //         {
                    //             "id": "f64f7c4f-295c-408b-9cbc-601981abf100",
                    //             "marketSymbol": "BTC-USDT",
                    //             "operand": "LTE",
                    //             "triggerPrice": "0.10000000",
                    //             "orderToCreate": {
                    //                 "marketSymbol": "BTC-USDT",
                    //                 "direction": "BUY",
                    //                 "type": "LIMIT",
                    //                 "quantity": "0.00020000",
                    //                 "limit": "30000.00000000",
                    //                 "timeInForce": "GOOD_TIL_CANCELLED"
                    //             },
                    //             "status": "OPEN",
                    //             "createdAt": "2022-04-20T02:38:12.26Z",
                    //             "updatedAt": "2022-04-20T02:38:12.26Z"
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderId': id
                    };
                    const response = await this.privateGetOrdersOrderIdExecutions(this.extend(request, params));
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    return this.parseTrades(response, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    // A ceiling order is a market or limit order that allows you to specify
                    // the amount of quote currency you want to spend (or receive, if selling)
                    // instead of the quantity of the market currency (e.g. buy $100 USD of BTC
                    // at the current market BTC price)
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let uppercaseType = undefined;
                    if (type !== undefined) uppercaseType = type.toUpperCase();
                    const reverseId = market['baseId'] + '-' + market['quoteId'];
                    const stop = this.safeValue(params, 'stop');
                    const stopPrice = this.safeNumber2(params, 'triggerPrice', 'stopPrice');
                    const request = {
                        'marketSymbol': reverseId
                    };
                    let method = 'privatePostOrders';
                    if (stop || stopPrice) {
                        method = 'privatePostConditionalOrders';
                        const operand = this.safeString(params, 'operand');
                        if (operand === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires an operand parameter');
                        const trailingStopPercent = this.safeNumber(params, 'trailingStopPercent');
                        const orderToCreate = this.safeValue(params, 'orderToCreate');
                        const orderToCancel = this.safeValue(params, 'orderToCancel');
                        if (stopPrice === undefined) request['trailingStopPercent'] = this.priceToPrecision(symbol, trailingStopPercent);
                        if (orderToCreate) {
                            const isCeilingLimit = uppercaseType === 'CEILING_LIMIT';
                            const isCeilingMarket = uppercaseType === 'CEILING_MARKET';
                            const isCeilingOrder = isCeilingLimit || isCeilingMarket;
                            let ceiling = undefined;
                            let limit = undefined;
                            let timeInForce = undefined;
                            if (isCeilingOrder) {
                                let cost = undefined;
                                if (isCeilingLimit) {
                                    limit = this.priceToPrecision(symbol, price);
                                    cost = this.safeNumber2(params, 'ceiling', 'cost', amount);
                                } else if (isCeilingMarket) {
                                    cost = this.safeNumber2(params, 'ceiling', 'cost');
                                    if (cost === undefined) {
                                        if (price === undefined) cost = amount;
                                        else cost = amount * price;
                                    }
                                }
                                ceiling = this.costToPrecision(symbol, cost);
                                timeInForce = 'IMMEDIATE_OR_CANCEL';
                            } else if (uppercaseType === 'LIMIT') {
                                limit = this.priceToPrecision(symbol, price);
                                timeInForce = 'GOOD_TIL_CANCELLED';
                            } else timeInForce = 'IMMEDIATE_OR_CANCEL';
                            request['orderToCreate'] = {
                                'marketSymbol': reverseId,
                                'direction': side.toUpperCase(),
                                'type': uppercaseType,
                                'quantity': this.amountToPrecision(symbol, amount),
                                'ceiling': ceiling,
                                'limit': limit,
                                'timeInForce': timeInForce,
                                'clientOrderId': this.safeString(params, 'clientOrderId'),
                                'useAwards': this.safeValue(params, 'useAwards')
                            };
                        }
                        if (orderToCancel) request['orderToCancel'] = orderToCancel;
                        request['triggerPrice'] = this.priceToPrecision(symbol, stopPrice);
                        request['operand'] = operand;
                    } else {
                        if (side !== undefined) request['direction'] = side.toUpperCase();
                        request['type'] = uppercaseType;
                        const isCeilingLimit = uppercaseType === 'CEILING_LIMIT';
                        const isCeilingMarket = uppercaseType === 'CEILING_MARKET';
                        const isCeilingOrder = isCeilingLimit || isCeilingMarket;
                        if (isCeilingOrder) {
                            let cost = undefined;
                            if (isCeilingLimit) {
                                request['limit'] = this.priceToPrecision(symbol, price);
                                cost = this.safeNumber2(params, 'ceiling', 'cost', amount);
                            } else if (isCeilingMarket) {
                                cost = this.safeNumber2(params, 'ceiling', 'cost');
                                if (cost === undefined) {
                                    if (price === undefined) cost = amount;
                                    else cost = amount * price;
                                }
                            }
                            request['ceiling'] = this.costToPrecision(symbol, cost);
                            // bittrex only accepts IMMEDIATE_OR_CANCEL or FILL_OR_KILL for ceiling orders
                            request['timeInForce'] = 'IMMEDIATE_OR_CANCEL';
                        } else {
                            request['quantity'] = this.amountToPrecision(symbol, amount);
                            if (uppercaseType === 'LIMIT') {
                                request['limit'] = this.priceToPrecision(symbol, price);
                                request['timeInForce'] = 'GOOD_TIL_CANCELLED';
                            } else // bittrex does not allow GOOD_TIL_CANCELLED for market orders
                            request['timeInForce'] = 'IMMEDIATE_OR_CANCEL';
                        }
                    }
                    const query = this.omit(params, [
                        'stop',
                        'stopPrice',
                        'ceiling',
                        'cost',
                        'operand',
                        'trailingStopPercent',
                        'orderToCreate',
                        'orderToCancel'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     {
                    //         id: 'f03d5e98-b5ac-48fb-8647-dd4db828a297',
                    //         marketSymbol: 'BTC-USDT',
                    //         direction: 'SELL',
                    //         type: 'LIMIT',
                    //         quantity: '0.01',
                    //         limit: '6000',
                    //         timeInForce: 'GOOD_TIL_CANCELLED',
                    //         fillQuantity: '0.00000000',
                    //         commission: '0.00000000',
                    //         proceeds: '0.00000000',
                    //         status: 'OPEN',
                    //         createdAt: '2020-03-18T02:37:33.42Z',
                    //         updatedAt: '2020-03-18T02:37:33.42Z'
                    //       }
                    //
                    // Stop
                    //
                    //     {
                    //         "id": "9791fe52-a3e5-4ac3-ae03-e327b2993571",
                    //         "marketSymbol": "BTC-USDT",
                    //         "operand": "LTE",
                    //         "triggerPrice": "0.1",
                    //         "orderToCreate": {
                    //             "marketSymbol": "BTC-USDT",
                    //             "direction": "BUY",
                    //             "type": "LIMIT",
                    //             "quantity": "0.0002",
                    //             "limit": "30000",
                    //             "timeInForce": "GOOD_TIL_CANCELLED"
                    //         },
                    //         "status": "OPEN",
                    //         "createdAt": "2022-04-19T21:02:14.17Z",
                    //         "updatedAt": "2022-04-19T21:02:14.17Z"
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const stop = this.safeValue(params, 'stop');
                    let request = {};
                    let method = undefined;
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    if (stop) {
                        method = 'privateDeleteConditionalOrdersConditionalOrderId';
                        request = {
                            'conditionalOrderId': id
                        };
                    } else {
                        method = 'privateDeleteOrdersOrderId';
                        request = {
                            'orderId': id
                        };
                    }
                    const query = this.omit(params, 'stop');
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     [
                    //         {
                    //             "id": "df6cf5ee-fc27-4b61-991a-cc94b6459ac9",
                    //             "marketSymbol": "BTC-USDT",
                    //             "direction": "BUY",
                    //             "type": "LIMIT",
                    //             "quantity": "0.00023277",
                    //             "limit": "30000.00000000",
                    //             "timeInForce": "GOOD_TIL_CANCELLED",
                    //             "fillQuantity": "0.00000000",
                    //             "commission": "0.00000000",
                    //             "proceeds": "0.00000000",
                    //             "status": "CANCELLED",
                    //             "createdAt": "2022-04-20T02:33:53.16Z",
                    //             "updatedAt": "2022-04-20T02:33:53.16Z"
                    //         }
                    //     ]
                    //
                    // Stop
                    //
                    //     [
                    //         {
                    //             "id": "f64f7c4f-295c-408b-9cbc-601981abf100",
                    //             "marketSymbol": "BTC-USDT",
                    //             "operand": "LTE",
                    //             "triggerPrice": "0.10000000",
                    //             "orderToCreate": {
                    //                 "marketSymbol": "BTC-USDT",
                    //                 "direction": "BUY",
                    //                 "type": "LIMIT",
                    //                 "quantity": "0.00020000",
                    //                 "limit": "30000.00000000",
                    //                 "timeInForce": "GOOD_TIL_CANCELLED"
                    //             },
                    //             "status": "CANCELLED",
                    //             "createdAt": "2022-04-20T02:38:12.26Z",
                    //             "updatedAt": "2022-04-20T02:38:12.26Z"
                    //             "closedAt": "2022-04-20T03:47:24.69Z"
                    //         }
                    //     ]
                    //
                    return this.extend(this.parseOrder(response, market), {
                        'id': id,
                        'info': response,
                        'status': 'canceled'
                    });
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['marketSymbol'] = market['id'];
                    }
                    const response = await this.privateDeleteOrdersOpen(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id":"66582be0-5337-4d8c-b212-c356dd525801",
                    //             "statusCode":"SUCCESS",
                    //             "result":{
                    //                 "id":"66582be0-5337-4d8c-b212-c356dd525801",
                    //                 "marketSymbol":"BTC-USDT",
                    //                 "direction":"BUY",
                    //                 "type":"LIMIT",
                    //                 "quantity":"0.01000000",
                    //                 "limit":"3000.00000000",
                    //                 "timeInForce":"GOOD_TIL_CANCELLED",
                    //                 "fillQuantity":"0.00000000",
                    //                 "commission":"0.00000000",
                    //                 "proceeds":"0.00000000",
                    //                 "status":"CLOSED",
                    //                 "createdAt":"2020-10-06T12:31:53.39Z",
                    //                 "updatedAt":"2020-10-06T12:54:28.8Z",
                    //                 "closedAt":"2020-10-06T12:54:28.8Z"
                    //             }
                    //         }
                    //     ]
                    //
                    const orders = [];
                    for(let i = 0; i < response.length; i++){
                        const result = this.safeValue(response[i], 'result', {});
                        orders.push(result);
                    }
                    return this.parseOrders(orders, market);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    // https://support.bittrex.com/hc/en-us/articles/115003723911
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currencySymbol'] = currency['id'];
                    }
                    const response = await this.privateGetDepositsClosed(this.extend(request, params));
                    // we cannot filter by `since` timestamp, as it isn't set by Bittrex
                    // see https://github.com/ccxt/ccxt/issues/4067
                    // return this.parseTransactions (response, currency, since, limit);
                    return this.parseTransactions(response, currency, undefined, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    // https://support.bittrex.com/hc/en-us/articles/115003723911
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currencySymbol'] = currency['id'];
                    }
                    const response = await this.privateGetWithdrawalsClosed(this.extend(request, params));
                    return this.parseTransactions(response, currency, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "id": "d00fdf2e-df9e-48f1-....",
                    //         "currencySymbol": "BTC",
                    //         "quantity": "0.00550000",
                    //         "cryptoAddress": "1PhmYjnJPZH5NUwV8AU...",
                    //         "txId": "d1f1afffe1b9b6614eaee7e8133c85d98...",
                    //         "confirmations": 2,
                    //         "updatedAt": "2020-01-12T16:49:30.41Z",
                    //         "completedAt": "2020-01-12T16:49:30.41Z",
                    //         "status": "COMPLETED",
                    //         "source": "BLOCKCHAIN"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "PaymentUuid" : "e293da98-788c-4188-a8f9-8ec2c33fdfcf",
                    //         "Currency" : "XC",
                    //         "Amount" : 7513.75121715,
                    //         "Address" : "EVnSMgAd7EonF2Dgc4c9K14L12RBaW5S5J",
                    //         "Opened" : "2014-07-08T23:13:31.83",
                    //         "Authorized" : true,
                    //         "PendingPayment" : false,
                    //         "TxCost" : 0.00002000,
                    //         "TxId" : "b4a575c2a71c7e56d02ab8e26bb1ef0a2f6cf2094f6ca2116476a569c1e84f6e",
                    //         "Canceled" : false,
                    //         "InvalidAddress" : false
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "currencySymbol": "string",
                    //         "quantity": "number (double)",
                    //         "cryptoAddress": "string",
                    //         "cryptoAddressTag": "string",
                    //         "fundsTransferMethodId": "string (uuid)",
                    //         "clientWithdrawalId": "string (uuid)"
                    //     }
                    //
                    const id = this.safeString2(transaction, 'id', 'clientWithdrawalId');
                    const amount = this.safeNumber(transaction, 'quantity');
                    const address = this.safeString(transaction, 'cryptoAddress');
                    const txid = this.safeString(transaction, 'txId');
                    const updated = this.parse8601(this.safeString(transaction, 'updatedAt'));
                    const opened = this.parse8601(this.safeString(transaction, 'createdAt'));
                    const timestamp = opened ? opened : updated;
                    const type = opened === undefined ? 'deposit' : 'withdrawal';
                    const currencyId = this.safeString(transaction, 'currencySymbol');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    let status = 'pending';
                    if (type === 'deposit') //
                    // deposits numConfirmations never reach the minConfirmations number
                    // we set all of them to 'ok', otherwise they'd all be 'pending'
                    //
                    //     const numConfirmations = this.safeInteger (transaction, 'Confirmations', 0);
                    //     const minConfirmations = this.safeInteger (currency['info'], 'MinConfirmation');
                    //     if (numConfirmations >= minConfirmations) {
                    //         status = 'ok';
                    //     }
                    //
                    status = 'ok';
                    else {
                        const responseStatus = this.safeString(transaction, 'status');
                        if (responseStatus === 'ERROR_INVALID_ADDRESS') status = 'failed';
                        else if (responseStatus === 'CANCELLED') status = 'canceled';
                        else if (responseStatus === 'PENDING') status = 'pending';
                        else if (responseStatus === 'COMPLETED') status = 'ok';
                        else if (responseStatus === 'AUTHORIZED' && txid !== undefined) status = 'ok';
                    }
                    let feeCost = this.safeNumber(transaction, 'txCost');
                    if (feeCost === undefined) {
                        if (type === 'deposit') // according to https://support.bittrex.com/hc/en-us/articles/115000199651-What-fees-does-Bittrex-charge-
                        feeCost = 0;
                    }
                    return {
                        'info': transaction,
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'status': status,
                        'type': type,
                        'updated': updated,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': {
                            'currency': code,
                            'cost': feeCost
                        }
                    };
                }
                parseTimeInForce(timeInForce) {
                    const timeInForces = {
                        'GOOD_TIL_CANCELLED': 'GTC',
                        'IMMEDIATE_OR_CANCEL': 'IOC',
                        'FILL_OR_KILL': 'FOK',
                        'POST_ONLY_GOOD_TIL_CANCELLED': 'PO'
                    };
                    return this.safeString(timeInForces, timeInForce, timeInForce);
                }
                parseOrder(order, market) {
                    //
                    // Spot createOrder, fetchOpenOrders, fetchClosedOrders, fetchOrder, cancelOrder
                    //
                    //     {
                    //         id: '1be35109-b763-44ce-b6ea-05b6b0735c0c',
                    //         marketSymbol: 'LTC-ETH',
                    //         direction: 'BUY',
                    //         type: 'LIMIT',
                    //         quantity: '0.50000000',
                    //         limit: '0.17846699',
                    //         timeInForce: 'GOOD_TIL_CANCELLED',
                    //         clientOrderId: 'ff156d39-fe01-44ca-8f21-b0afa19ef228',
                    //         fillQuantity: '0.50000000',
                    //         commission: '0.00022286',
                    //         proceeds: '0.08914915',
                    //         status: 'CLOSED',
                    //         createdAt: '2018-06-23T13:14:28.613Z',
                    //         updatedAt: '2018-06-23T13:14:30.19Z',
                    //         closedAt: '2018-06-23T13:14:30.19Z'
                    //     }
                    //
                    // Stop createOrder, fetchOpenOrders, fetchClosedOrders, fetchOrder, cancelOrder
                    //
                    //     {
                    //         "id": "9791fe52-a3e5-4ac3-ae03-e327b2993571",
                    //         "marketSymbol": "BTC-USDT",
                    //         "operand": "LTE",
                    //         "triggerPrice": "0.1",
                    //         "orderToCreate": {
                    //             "marketSymbol": "BTC-USDT",
                    //             "direction": "BUY",
                    //             "type": "LIMIT",
                    //             "quantity": "0.0002",
                    //             "limit": "30000",
                    //             "timeInForce": "GOOD_TIL_CANCELLED"
                    //         },
                    //         "status": "OPEN",
                    //         "createdAt": "2022-04-19T21:02:14.17Z",
                    //         "updatedAt": "2022-04-19T21:02:14.17Z",
                    //         "closedAt": "2022-04-20T03:47:24.69Z"
                    //     }
                    //
                    const marketSymbol = this.safeString(order, 'marketSymbol');
                    market = this.safeMarket(marketSymbol, market, '-');
                    const symbol = market['symbol'];
                    const feeCurrency = market['quote'];
                    const createdAt = this.safeString(order, 'createdAt');
                    const updatedAt = this.safeString(order, 'updatedAt');
                    const closedAt = this.safeString(order, 'closedAt');
                    const clientOrderId = this.safeString(order, 'clientOrderId');
                    let lastTradeTimestamp = undefined;
                    if (closedAt !== undefined) lastTradeTimestamp = this.parse8601(closedAt);
                    else if (updatedAt) lastTradeTimestamp = this.parse8601(updatedAt);
                    const timestamp = this.parse8601(createdAt);
                    let direction = this.safeStringLower(order, 'direction');
                    if (direction === undefined) {
                        let conditionalOrder = this.safeValue(order, 'orderToCreate');
                        if (conditionalOrder === undefined) conditionalOrder = this.safeValue(order, 'orderToCancel');
                        direction = this.safeStringLower(conditionalOrder, 'direction');
                    }
                    let type = this.safeStringLower(order, 'type');
                    if (type === undefined) {
                        let conditionalOrder = this.safeValue(order, 'orderToCreate');
                        if (conditionalOrder === undefined) conditionalOrder = this.safeValue(order, 'orderToCancel');
                        type = this.safeStringLower(conditionalOrder, 'type');
                    }
                    let quantity = this.safeString(order, 'quantity');
                    if (quantity === undefined) {
                        let conditionalOrder = this.safeValue(order, 'orderToCreate');
                        if (conditionalOrder === undefined) conditionalOrder = this.safeValue(order, 'orderToCancel');
                        quantity = this.safeString(conditionalOrder, 'quantity');
                    }
                    let limit = this.safeString(order, 'limit');
                    if (limit === undefined) {
                        let conditionalOrder = this.safeValue(order, 'orderToCreate');
                        if (conditionalOrder === undefined) conditionalOrder = this.safeValue(order, 'orderToCancel');
                        limit = this.safeString(conditionalOrder, 'limit');
                    }
                    let timeInForce = this.parseTimeInForce(this.safeString(order, 'timeInForce'));
                    if (timeInForce === undefined) {
                        let conditionalOrder = this.safeValue(order, 'orderToCreate');
                        if (conditionalOrder === undefined) conditionalOrder = this.safeValue(order, 'orderToCancel');
                        timeInForce = this.parseTimeInForce(this.safeString(conditionalOrder, 'timeInForce'));
                    }
                    const fillQuantity = this.safeString(order, 'fillQuantity');
                    const commission = this.safeNumber(order, 'commission');
                    const proceeds = this.safeString(order, 'proceeds');
                    const status = this.safeStringLower(order, 'status');
                    const postOnly = timeInForce === 'PO';
                    return this.safeOrder({
                        'id': this.safeString(order, 'id'),
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': direction,
                        'price': limit,
                        'stopPrice': this.safeString(order, 'triggerPrice'),
                        'cost': proceeds,
                        'average': undefined,
                        'amount': quantity,
                        'filled': fillQuantity,
                        'remaining': undefined,
                        'status': status,
                        'fee': {
                            'cost': commission,
                            'currency': feeCurrency
                        },
                        'info': order,
                        'trades': undefined
                    }, market);
                }
                parseOrders(orders, market, since, limit, params = {}) {
                    if (this.options['fetchClosedOrdersFilterBySince']) return super.parseOrders(orders, market, since, limit, params);
                    else return super.parseOrders(orders, market, undefined, limit, params);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'CLOSED': 'closed',
                        'OPEN': 'open',
                        'CANCELLED': 'canceled',
                        'CANCELED': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const stop = this.safeValue(params, 'stop');
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    let response = undefined;
                    let method = undefined;
                    try {
                        const request = {};
                        if (stop) {
                            method = 'privateGetConditionalOrdersConditionalOrderId';
                            request['conditionalOrderId'] = id;
                        } else {
                            method = 'privateGetOrdersOrderId';
                            request['orderId'] = id;
                        }
                        const query = this.omit(params, 'stop');
                        response = await this[method](this.extend(request, query));
                    } catch (e) {
                        if (this.last_json_response) {
                            const message = this.safeString(this.last_json_response, 'message');
                            if (message === 'UUID_INVALID') throw new OrderNotFound(this.id + ' fetchOrder() error: ' + this.last_http_response);
                        }
                        throw e;
                    }
                    return this.parseOrder(response, market);
                }
                orderToTrade(order) {
                    // this entire method should be moved to the base class
                    const timestamp = this.safeInteger2(order, 'lastTradeTimestamp', 'timestamp');
                    return {
                        'id': this.safeString(order, 'id'),
                        'side': this.safeString(order, 'side'),
                        'order': this.safeString(order, 'id'),
                        'type': this.safeString(order, 'type'),
                        'price': this.safeNumber(order, 'average'),
                        'amount': this.safeNumber(order, 'filled'),
                        'cost': this.safeNumber(order, 'cost'),
                        'symbol': this.safeString(order, 'symbol'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': this.safeValue(order, 'fee'),
                        'info': order,
                        'takerOrMaker': undefined
                    };
                }
                ordersToTrades(orders) {
                    // this entire method should be moved to the base class
                    const result = [];
                    for(let i = 0; i < orders.length; i++)result.push(this.orderToTrade(orders[i]));
                    return result;
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (limit !== undefined) request['pageSize'] = limit;
                    if (since !== undefined) request['startDate'] = this.ymdhms(since, 'T') + 'Z';
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        symbol = market['symbol'];
                        // because of this line we will have to rethink the entire v3
                        // in other words, markets define all the rest of the API
                        // and v3 market ids are reversed in comparison to v1
                        // v3 has to be a completely separate implementation
                        // otherwise we will have to shuffle symbols and currencies everywhere
                        // which is prone to errors, as was shown here
                        // https://github.com/ccxt/ccxt/pull/5219#issuecomment-499646209
                        request['marketSymbol'] = market['base'] + '-' + market['quote'];
                    }
                    const response = await this.privateGetOrdersClosed(this.extend(request, params));
                    const orders = this.parseOrders(response, market);
                    const trades = this.ordersToTrades(orders);
                    return this.filterBySymbolSinceLimit(trades, symbol, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const stop = this.safeValue(params, 'stop');
                    const request = {};
                    if (limit !== undefined) request['pageSize'] = limit;
                    if (since !== undefined) request['startDate'] = this.ymdhms(since, 'T') + 'Z';
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        // because of this line we will have to rethink the entire v3
                        // in other words, markets define all the rest of the API
                        // and v3 market ids are reversed in comparison to v1
                        // v3 has to be a completely separate implementation
                        // otherwise we will have to shuffle symbols and currencies everywhere
                        // which is prone to errors, as was shown here
                        // https://github.com/ccxt/ccxt/pull/5219#issuecomment-499646209
                        request['marketSymbol'] = market['base'] + '-' + market['quote'];
                    }
                    let method = 'privateGetOrdersClosed';
                    if (stop) method = 'privateGetConditionalOrdersClosed';
                    const query = this.omit(params, 'stop');
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     [
                    //         {
                    //             "id": "df6cf5ee-fc27-4b61-991a-cc94b6459ac9",
                    //             "marketSymbol": "BTC-USDT",
                    //             "direction": "BUY",
                    //             "type": "LIMIT",
                    //             "quantity": "0.00023277",
                    //             "limit": "30000.00000000",
                    //             "timeInForce": "GOOD_TIL_CANCELLED",
                    //             "fillQuantity": "0.00000000",
                    //             "commission": "0.00000000",
                    //             "proceeds": "0.00000000",
                    //             "status": "OPEN",
                    //             "createdAt": "2022-04-20T02:33:53.16Z",
                    //             "updatedAt": "2022-04-20T02:33:53.16Z"
                    //         }
                    //     ]
                    //
                    // Stop
                    //
                    //     [
                    //         {
                    //             "id": "f64f7c4f-295c-408b-9cbc-601981abf100",
                    //             "marketSymbol": "BTC-USDT",
                    //             "operand": "LTE",
                    //             "triggerPrice": "0.10000000",
                    //             "orderToCreate": {
                    //                 "marketSymbol": "BTC-USDT",
                    //                 "direction": "BUY",
                    //                 "type": "LIMIT",
                    //                 "quantity": "0.00020000",
                    //                 "limit": "30000.00000000",
                    //                 "timeInForce": "GOOD_TIL_CANCELLED"
                    //             },
                    //             "status": "OPEN",
                    //             "createdAt": "2022-04-20T02:38:12.26Z",
                    //             "updatedAt": "2022-04-20T02:38:12.26Z"
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currencySymbol': currency['id']
                    };
                    const response = await this.privatePostAddresses(this.extend(request, params));
                    //
                    //     {
                    //         "status":"PROVISIONED",
                    //         "currencySymbol":"XRP",
                    //         "cryptoAddress":"rPVMhWBsfF9iMXYj3aAzJVkPDTFNSyWdKy",
                    //         "cryptoAddressTag":"392034158"
                    //     }
                    //
                    let address = this.safeString(response, 'cryptoAddress');
                    const message = this.safeString(response, 'status');
                    if (!address || message === 'REQUESTED') throw new AddressPending(this.id + ' the address for ' + code + ' is being generated (pending, not ready yet, retry again later)');
                    let tag = this.safeString(response, 'cryptoAddressTag');
                    if (tag === undefined && currency['type'] in this.options['tag']) {
                        tag = address;
                        address = currency['address'];
                    }
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'info': response
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currencySymbol': currency['id']
                    };
                    const response = await this.privateGetAddressesCurrencySymbol(this.extend(request, params));
                    //
                    //     {
                    //         "status":"PROVISIONED",
                    //         "currencySymbol":"XRP",
                    //         "cryptoAddress":"rPVMhWBsfF9iMXYj3aAzJVkPDTFNSyWdKy",
                    //         "cryptoAddressTag":"392034158"
                    //     }
                    //
                    let address = this.safeString(response, 'cryptoAddress');
                    const message = this.safeString(response, 'status');
                    if (!address || message === 'REQUESTED') throw new AddressPending(this.id + ' the address for ' + code + ' is being generated (pending, not ready yet, retry again later)');
                    let tag = this.safeString(response, 'cryptoAddressTag');
                    if (tag === undefined && currency['type'] in this.options['tag']) {
                        tag = address;
                        address = currency['address'];
                    }
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currencySymbol': currency['id'],
                        'quantity': amount,
                        'cryptoAddress': address
                    };
                    if (tag !== undefined) request['cryptoAddressTag'] = tag;
                    const response = await this.privatePostWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         "currencySymbol": "string",
                    //         "quantity": "number (double)",
                    //         "cryptoAddress": "string",
                    //         "cryptoAddressTag": "string",
                    //         "fundsTransferMethodId": "string (uuid)",
                    //         "clientWithdrawalId": "string (uuid)"
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                sign(path, api = 'v3', method = 'GET', params = {}, headers, body) {
                    let url = this.implodeParams(this.urls['api'][api], {
                        'hostname': this.hostname
                    }) + '/';
                    if (api === 'private') {
                        url += this.version + '/';
                        this.checkRequiredCredentials();
                        url += this.implodeParams(path, params);
                        params = this.omit(params, this.extractParams(path));
                        let hashString = '';
                        if (method === 'POST') {
                            body = this.json(params);
                            hashString = body;
                        } else if (Object.keys(params).length) url += '?' + this.rawencode(params);
                        const contentHash = this.hash(this.encode(hashString), 'sha512', 'hex');
                        const timestamp = this.milliseconds().toString();
                        let auth = timestamp + url + method + contentHash;
                        const subaccountId = this.safeValue(this.options, 'subaccountId');
                        if (subaccountId !== undefined) auth += subaccountId;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha512');
                        headers = {
                            'Api-Key': this.apiKey,
                            'Api-Timestamp': timestamp,
                            'Api-Content-Hash': contentHash,
                            'Api-Signature': signature
                        };
                        if (subaccountId !== undefined) headers['Api-Subaccount-Id'] = subaccountId;
                        if (method === 'POST') headers['Content-Type'] = 'application/json';
                    } else {
                        if (api === 'public') url += this.version + '/';
                        url += this.implodeParams(path, params);
                        params = this.omit(params, this.extractParams(path));
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //     { success: false, message: "message" }
                    //
                    if (body[0] === '{') {
                        const feedback = this.id + ' ' + body;
                        let success = this.safeValue(response, 'success');
                        if (success === undefined) {
                            const code = this.safeString(response, 'code');
                            if (code === 'NOT_FOUND' && url.indexOf('addresses') >= 0) throw new InvalidAddress(feedback);
                            if (code !== undefined) {
                                this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                                this.throwBroadlyMatchedException(this.exceptions['broad'], code, feedback);
                            }
                            // throw new ExchangeError (this.id + ' malformed response ' + this.json (response));
                            return;
                        }
                        if (typeof success === 'string') // bleutrade uses string instead of boolean
                        success = success === 'true';
                        if (!success) {
                            const message = this.safeString(response, 'message');
                            if (message === 'APIKEY_INVALID') {
                                if (this.options['hasAlreadyAuthenticatedSuccessfully']) throw new DDoSProtection(feedback);
                                else throw new AuthenticationError(feedback);
                            }
                            // https://github.com/ccxt/ccxt/issues/4932
                            // the following two lines are now redundant, see line 171 in describe()
                            //
                            //     if (message === 'DUST_TRADE_DISALLOWED_MIN_VALUE_50K_SAT')
                            //         throw new InvalidOrder (this.id + ' order cost should be over 50k satoshi ' + this.json (response));
                            //
                            if (message === 'INVALID_ORDER') {
                                // Bittrex will return an ambiguous INVALID_ORDER message
                                // upon canceling already-canceled and closed orders
                                // therefore this special case for cancelOrder
                                // let url = 'https://bittrex.com/api/v1.1/market/cancel?apikey=API_KEY&uuid=ORDER_UUID'
                                const cancel = 'cancel';
                                const indexOfCancel = url.indexOf(cancel);
                                if (indexOfCancel >= 0) {
                                    const urlParts = url.split('?');
                                    const numParts = urlParts.length;
                                    if (numParts > 1) {
                                        const query = urlParts[1];
                                        const params = query.split('&');
                                        const numParams = params.length;
                                        let orderId = undefined;
                                        for(let i = 0; i < numParams; i++){
                                            const param = params[i];
                                            const keyValue = param.split('=');
                                            if (keyValue[0] === 'uuid') {
                                                orderId = keyValue[1];
                                                break;
                                            }
                                        }
                                        if (orderId !== undefined) throw new OrderNotFound(this.id + ' cancelOrder ' + orderId + ' ' + this.json(response));
                                        else throw new OrderNotFound(this.id + ' cancelOrder ' + this.json(response));
                                    }
                                }
                            }
                            this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                            if (message !== undefined) this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    47: [
        function(require1, module, exports) {
            'use strict';
            // ----------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, BadSymbol: BadSymbol, AuthenticationError: AuthenticationError, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, ArgumentsRequired: ArgumentsRequired1, OrderNotFound: OrderNotFound, InvalidAddress: InvalidAddress, BadRequest: BadRequest, RateLimitExceeded: RateLimitExceeded, PermissionDenied: PermissionDenied, ExchangeNotAvailable: ExchangeNotAvailable, AccountSuspended: AccountSuspended, OnMaintenance: OnMaintenance } = require1('./base/errors');
            const { SIGNIFICANT_DIGITS: SIGNIFICANT_DIGITS, DECIMAL_PLACES: DECIMAL_PLACES, TRUNCATE: TRUNCATE, ROUND: ROUND } = require1('./base/functions/number');
            // ----------------------------------------------------------------------------
            module.exports = class bitvavo extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bitvavo',
                        'name': 'Bitvavo',
                        'countries': [
                            'NL'
                        ],
                        'rateLimit': 60,
                        'version': 'v2',
                        'certified': true,
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '2h': '2h',
                            '4h': '4h',
                            '6h': '6h',
                            '8h': '8h',
                            '12h': '12h',
                            '1d': '1d'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/83165440-2f1cf200-a116-11ea-9046-a255d09fb2ed.jpg',
                            'api': {
                                'public': 'https://api.bitvavo.com',
                                'private': 'https://api.bitvavo.com'
                            },
                            'www': 'https://bitvavo.com/',
                            'doc': 'https://docs.bitvavo.com/',
                            'fees': 'https://bitvavo.com/en/fees',
                            'referral': 'https://bitvavo.com/?a=24F34952F7'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'time': 1,
                                    'markets': 1,
                                    'assets': 1,
                                    '{market}/book': 1,
                                    '{market}/trades': 5,
                                    '{market}/candles': 1,
                                    'ticker/price': 1,
                                    'ticker/book': 1,
                                    'ticker/24h': {
                                        'cost': 1,
                                        'noMarket': 25
                                    }
                                }
                            },
                            'private': {
                                'get': {
                                    'account': 1,
                                    'order': 1,
                                    'orders': 5,
                                    'ordersOpen': {
                                        'cost': 1,
                                        'noMarket': 25
                                    },
                                    'trades': 5,
                                    'balance': 5,
                                    'deposit': 1,
                                    'depositHistory': 5,
                                    'withdrawalHistory': 5
                                },
                                'post': {
                                    'order': 1,
                                    'withdrawal': 1
                                },
                                'put': {
                                    'order': 1
                                },
                                'delete': {
                                    'order': 1,
                                    'orders': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.0025'),
                                'maker': this.parseNumber('0.002'),
                                'tiers': {
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.0025')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('0.0020')
                                        ],
                                        [
                                            this.parseNumber('250000'),
                                            this.parseNumber('0.0016')
                                        ],
                                        [
                                            this.parseNumber('500000'),
                                            this.parseNumber('0.0012')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.0010')
                                        ],
                                        [
                                            this.parseNumber('2500000'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('10000000'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('25000000'),
                                            this.parseNumber('0.0004')
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.0015')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('0.0010')
                                        ],
                                        [
                                            this.parseNumber('250000'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('500000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('2500000'),
                                            this.parseNumber('0.0004')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.0004')
                                        ],
                                        [
                                            this.parseNumber('10000000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('25000000'),
                                            this.parseNumber('0.0003')
                                        ]
                                    ]
                                }
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true
                        },
                        'exceptions': {
                            'exact': {
                                '101': ExchangeError1,
                                '102': BadRequest,
                                '103': RateLimitExceeded,
                                '104': RateLimitExceeded,
                                '105': PermissionDenied,
                                '107': ExchangeNotAvailable,
                                '108': ExchangeNotAvailable,
                                '109': ExchangeNotAvailable,
                                '110': BadRequest,
                                '200': BadRequest,
                                '201': BadRequest,
                                '202': BadRequest,
                                '203': BadSymbol,
                                '204': BadRequest,
                                '205': BadRequest,
                                '206': BadRequest,
                                '210': InvalidOrder,
                                '211': InvalidOrder,
                                '212': InvalidOrder,
                                '213': InvalidOrder,
                                '214': InvalidOrder,
                                '215': InvalidOrder,
                                '216': InsufficientFunds,
                                '217': InvalidOrder,
                                '230': ExchangeError1,
                                '231': ExchangeError1,
                                '232': BadRequest,
                                '233': InvalidOrder,
                                '234': InvalidOrder,
                                '235': ExchangeError1,
                                '236': BadRequest,
                                '240': OrderNotFound,
                                '300': AuthenticationError,
                                '301': AuthenticationError,
                                '302': AuthenticationError,
                                '303': AuthenticationError,
                                '304': AuthenticationError,
                                // '304': AuthenticationError, // Authentication is required for this endpoint.
                                '305': AuthenticationError,
                                '306': AuthenticationError,
                                '307': PermissionDenied,
                                '308': AuthenticationError,
                                '309': AuthenticationError,
                                '310': PermissionDenied,
                                '311': PermissionDenied,
                                '312': PermissionDenied,
                                '315': BadRequest,
                                '317': AccountSuspended,
                                '400': ExchangeError1,
                                '401': ExchangeError1,
                                '402': PermissionDenied,
                                '403': PermissionDenied,
                                '404': OnMaintenance,
                                '405': ExchangeError1,
                                '406': BadRequest,
                                '407': ExchangeError1,
                                '408': InsufficientFunds,
                                '409': InvalidAddress,
                                '410': ExchangeError1,
                                '411': BadRequest,
                                '412': InvalidAddress,
                                '413': InvalidAddress,
                                '414': ExchangeError1
                            },
                            'broad': {
                                'start parameter is invalid': BadRequest,
                                'symbol parameter is invalid': BadSymbol,
                                'amount parameter is invalid': InvalidOrder,
                                'orderId parameter is invalid': InvalidOrder
                            }
                        },
                        'options': {
                            'BITVAVO-ACCESS-WINDOW': 10000,
                            'fetchCurrencies': {
                                'expires': 1000
                            }
                        },
                        'precisionMode': SIGNIFICANT_DIGITS,
                        'commonCurrencies': {
                            'MIOTA': 'IOTA'
                        }
                    });
                }
                currencyToPrecision(code, fee) {
                    return this.decimalToPrecision(fee, 0, this.currencies[code]['precision']);
                }
                amountToPrecision(symbol, amount) {
                    // https://docs.bitfinex.com/docs/introduction#amount-precision
                    // The amount field allows up to 8 decimals.
                    // Anything exceeding this will be rounded to the 8th decimal.
                    return this.decimalToPrecision(amount, TRUNCATE, this.markets[symbol]['precision']['amount'], DECIMAL_PLACES);
                }
                priceToPrecision(symbol, price) {
                    price = this.decimalToPrecision(price, ROUND, this.markets[symbol]['precision']['price'], this.precisionMode);
                    // https://docs.bitfinex.com/docs/introduction#price-precision
                    // The precision level of all trading prices is based on significant figures.
                    // All pairs on Bitfinex use up to 5 significant digits and up to 8 decimals (e.g. 1.2345, 123.45, 1234.5, 0.00012345).
                    // Prices submit with a precision larger than 5 will be cut by the API.
                    return this.decimalToPrecision(price, TRUNCATE, 8, DECIMAL_PLACES);
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTime(params);
                    //
                    //     { "time": 1590379519148 }
                    //
                    return this.safeInteger(response, 'time');
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetMarkets(params);
                    const currencies = await this.fetchCurrenciesFromCache(params);
                    const currenciesById = this.indexBy(currencies, 'symbol');
                    //
                    //     [
                    //         {
                    //             "market":"ADA-BTC",
                    //             "status":"trading", // "trading" "halted" "auction"
                    //             "base":"ADA",
                    //             "quote":"BTC",
                    //             "pricePrecision":5,
                    //             "minOrderInBaseAsset":"100",
                    //             "minOrderInQuoteAsset":"0.001",
                    //             "orderTypes": [ "market", "limit" ]
                    //         }
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'market');
                        const baseId = this.safeString(market, 'base');
                        const quoteId = this.safeString(market, 'quote');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const status = this.safeString(market, 'status');
                        const baseCurrency = this.safeValue(currenciesById, baseId);
                        let amountPrecision = undefined;
                        if (baseCurrency !== undefined) amountPrecision = this.safeInteger(baseCurrency, 'decimals', 8);
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': status === 'trading',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': amountPrecision,
                                'price': this.safeInteger(market, 'pricePrecision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minOrderInBaseAsset'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minOrderInQuoteAsset'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrenciesFromCache(params = {}) {
                    // this method is now redundant
                    // currencies are now fetched before markets
                    const options = this.safeValue(this.options, 'fetchCurrencies', {});
                    const timestamp = this.safeInteger(options, 'timestamp');
                    const expires = this.safeInteger(options, 'expires', 1000);
                    const now = this.milliseconds();
                    if (timestamp === undefined || now - timestamp > expires) {
                        const response = await this.publicGetAssets(params);
                        this.options['fetchCurrencies'] = this.extend(options, {
                            'response': response,
                            'timestamp': now
                        });
                    }
                    return this.safeValue(this.options['fetchCurrencies'], 'response');
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.fetchCurrenciesFromCache(params);
                    //
                    //     [
                    //         {
                    //             "symbol":"ADA",
                    //             "name":"Cardano",
                    //             "decimals":6,
                    //             "depositFee":"0",
                    //             "depositConfirmations":15,
                    //             "depositStatus":"OK", // "OK", "MAINTENANCE", "DELISTED"
                    //             "withdrawalFee":"0.2",
                    //             "withdrawalMinAmount":"0.2",
                    //             "withdrawalStatus":"OK", // "OK", "MAINTENANCE", "DELISTED"
                    //             "networks": [ "Mainnet" ], // "ETH", "NEO", "ONT", "SEPA", "VET"
                    //             "message":"",
                    //         },
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        const id = this.safeString(currency, 'symbol');
                        const code = this.safeCurrencyCode(id);
                        const depositStatus = this.safeValue(currency, 'depositStatus');
                        const deposit = depositStatus === 'OK';
                        const withdrawalStatus = this.safeValue(currency, 'withdrawalStatus');
                        const withdrawal = withdrawalStatus === 'OK';
                        const active = deposit && withdrawal;
                        const name = this.safeString(currency, 'name');
                        const precision = this.safeInteger(currency, 'decimals', 8);
                        result[code] = {
                            'id': id,
                            'info': currency,
                            'code': code,
                            'name': name,
                            'active': active,
                            'deposit': deposit,
                            'withdraw': withdrawal,
                            'fee': this.safeNumber(currency, 'withdrawalFee'),
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'withdrawalMinAmount'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.publicGetTicker24h(this.extend(request, params));
                    //
                    //     {
                    //         "market":"ETH-BTC",
                    //         "open":"0.022578",
                    //         "high":"0.023019",
                    //         "low":"0.022573",
                    //         "last":"0.023019",
                    //         "volume":"25.16366324",
                    //         "volumeQuote":"0.57333305",
                    //         "bid":"0.023039",
                    //         "bidSize":"0.53500578",
                    //         "ask":"0.023041",
                    //         "askSize":"0.47859202",
                    //         "timestamp":1590381666900
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker
                    //
                    //     {
                    //         "market":"ETH-BTC",
                    //         "open":"0.022578",
                    //         "high":"0.023019",
                    //         "low":"0.022573",
                    //         "last":"0.023019",
                    //         "volume":"25.16366324",
                    //         "volumeQuote":"0.57333305",
                    //         "bid":"0.023039",
                    //         "bidSize":"0.53500578",
                    //         "ask":"0.023041",
                    //         "askSize":"0.47859202",
                    //         "timestamp":1590381666900
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'market');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const timestamp = this.safeInteger(ticker, 'timestamp');
                    const last = this.safeString(ticker, 'last');
                    const baseVolume = this.safeString(ticker, 'volume');
                    const quoteVolume = this.safeString(ticker, 'volumeQuote');
                    const open = this.safeString(ticker, 'open');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': this.safeString(ticker, 'bidSize'),
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': this.safeString(ticker, 'askSize'),
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTicker24h(params);
                    //
                    //     [
                    //         {
                    //             "market":"ADA-BTC",
                    //             "open":"0.0000059595",
                    //             "high":"0.0000059765",
                    //             "low":"0.0000059595",
                    //             "last":"0.0000059765",
                    //             "volume":"2923.172",
                    //             "volumeQuote":"0.01743483",
                    //             "bid":"0.0000059515",
                    //             "bidSize":"1117.630919",
                    //             "ask":"0.0000059585",
                    //             "askSize":"809.999739",
                    //             "timestamp":1590382266324
                    //         }
                    //     ]
                    //
                    return this.parseTickers(response, symbols);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['start'] = since;
                    const response = await this.publicGetMarketTrades(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id":"94154c98-6e8b-4e33-92a8-74e33fc05650",
                    //             "timestamp":1590382761859,
                    //             "amount":"0.06026079",
                    //             "price":"8095.3",
                    //             "side":"buy"
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "id":"94154c98-6e8b-4e33-92a8-74e33fc05650",
                    //         "timestamp":1590382761859,
                    //         "amount":"0.06026079",
                    //         "price":"8095.3",
                    //         "side":"buy"
                    //     }
                    //
                    // createOrder, fetchOpenOrders, fetchOrders, editOrder (private)
                    //
                    //     {
                    //         "id":"b0c86aa5-6ed3-4a2d-ba3a-be9a964220f4",
                    //         "timestamp":1590505649245,
                    //         "amount":"0.249825",
                    //         "price":"183.49",
                    //         "taker":true,
                    //         "fee":"0.12038925",
                    //         "feeCurrency":"EUR",
                    //         "settled":true
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "id":"b0c86aa5-6ed3-4a2d-ba3a-be9a964220f4",
                    //         "orderId":"af76d6ce-9f7c-4006-b715-bb5d430652d0",
                    //         "timestamp":1590505649245,
                    //         "market":"ETH-EUR",
                    //         "side":"sell",
                    //         "amount":"0.249825",
                    //         "price":"183.49",
                    //         "taker":true,
                    //         "fee":"0.12038925",
                    //         "feeCurrency":"EUR",
                    //         "settled":true
                    //     }
                    //
                    // watchMyTrades (private)
                    //
                    //     {
                    //         event: 'fill',
                    //         timestamp: 1590964470132,
                    //         market: 'ETH-EUR',
                    //         orderId: '85d082e1-eda4-4209-9580-248281a29a9a',
                    //         fillId: '861d2da5-aa93-475c-8d9a-dce431bd4211',
                    //         side: 'sell',
                    //         amount: '0.1',
                    //         price: '211.46',
                    //         taker: true,
                    //         fee: '0.056',
                    //         feeCurrency: 'EUR'
                    //     }
                    //
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const timestamp = this.safeInteger(trade, 'timestamp');
                    const side = this.safeString(trade, 'side');
                    const id = this.safeString2(trade, 'id', 'fillId');
                    const marketId = this.safeString(trade, 'market');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const taker = this.safeValue(trade, 'taker');
                    let takerOrMaker = undefined;
                    if (taker !== undefined) takerOrMaker = taker ? 'taker' : 'maker';
                    const feeCostString = this.safeString(trade, 'fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'feeCurrency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    const orderId = this.safeString(trade, 'orderId');
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccount(params);
                    //
                    //     {
                    //         "fees": {
                    //           "taker": "0.0025",
                    //           "maker": "0.0015",
                    //           "volume": "10000.00"
                    //         }
                    //     }
                    //
                    const fees = this.safeValue(response, 'fees');
                    const maker = this.safeNumber(fees, 'maker');
                    const taker = this.safeNumber(fees, 'taker');
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'market': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['depth'] = limit;
                    const response = await this.publicGetMarketBook(this.extend(request, params));
                    //
                    //     {
                    //         "market":"BTC-EUR",
                    //         "nonce":35883831,
                    //         "bids":[
                    //             ["8097.4","0.6229099"],
                    //             ["8097.2","0.64151283"],
                    //             ["8097.1","0.24966294"],
                    //         ],
                    //         "asks":[
                    //             ["8097.5","1.36916911"],
                    //             ["8098.8","0.33462248"],
                    //             ["8099.3","1.12908646"],
                    //         ]
                    //     }
                    //
                    const orderbook = this.parseOrderBook(response, symbol);
                    orderbook['nonce'] = this.safeInteger(response, 'nonce');
                    return orderbook;
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1590383700000,
                    //         "8088.5",
                    //         "8088.5",
                    //         "8088.5",
                    //         "8088.5",
                    //         "0.04788623"
                    //     ]
                    //
                    return [
                        this.safeInteger(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'interval': this.timeframes[timeframe]
                    };
                    if (since !== undefined) {
                        // https://github.com/ccxt/ccxt/issues/9227
                        const duration = this.parseTimeframe(timeframe);
                        request['start'] = since;
                        if (limit === undefined) limit = 1440;
                        request['end'] = this.sum(since, limit * duration * 1000);
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 1440, max 1440
                    const response = await this.publicGetMarketCandles(this.extend(request, params));
                    //
                    //     [
                    //         [1590383700000,"8088.5","8088.5","8088.5","8088.5","0.04788623"],
                    //         [1590383580000,"8091.3","8091.5","8091.3","8091.5","0.04931221"],
                    //         [1590383520000,"8090.3","8092.7","8090.3","8092.5","0.04001286"],
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'symbol');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'inOrder');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalance(params);
                    //
                    //     [
                    //         {
                    //             "symbol": "BTC",
                    //             "available": "1.57593193",
                    //             "inOrder": "0.74832374"
                    //         }
                    //     ]
                    //
                    return this.parseBalance(response);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'symbol': currency['id']
                    };
                    const response = await this.privateGetDeposit(this.extend(request, params));
                    //
                    //     {
                    //         "address": "0x449889e3234514c45d57f7c5a571feba0c7ad567",
                    //         "paymentId": "10002653"
                    //     }
                    //
                    const address = this.safeString(response, 'address');
                    const tag = this.safeString(response, 'paymentId');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'side': side,
                        'orderType': type
                    };
                    const isStopLimit = type === 'stopLossLimit' || type === 'takeProfitLimit';
                    const isStopMarket = type === 'stopLoss' || type === 'takeProfit';
                    if (type === 'market') {
                        let cost = undefined;
                        if (price !== undefined) cost = amount * price;
                        else cost = this.safeNumber2(params, 'cost', 'amountQuote');
                        if (cost !== undefined) {
                            const precision = market['precision']['price'];
                            request['amountQuote'] = this.decimalToPrecision(cost, TRUNCATE, precision, this.precisionMode);
                        } else request['amount'] = this.amountToPrecision(symbol, amount);
                        params = this.omit(params, [
                            'cost',
                            'amountQuote'
                        ]);
                    } else if (type === 'limit') {
                        request['price'] = this.priceToPrecision(symbol, price);
                        request['amount'] = this.amountToPrecision(symbol, amount);
                    } else if (isStopMarket || isStopLimit) {
                        let stopPrice = this.safeNumber2(params, 'stopPrice', 'triggerAmount');
                        if (stopPrice === undefined) {
                            if (isStopLimit) throw new ArgumentsRequired1(this.id + ' createOrder() requires a stopPrice parameter for a ' + type + ' order');
                            else if (isStopMarket) {
                                if (price === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a price argument or a stopPrice parameter for a ' + type + ' order');
                                else stopPrice = price;
                            }
                        }
                        if (isStopLimit) request['price'] = this.priceToPrecision(symbol, price);
                        params = this.omit(params, [
                            'stopPrice',
                            'triggerAmount'
                        ]);
                        request['triggerAmount'] = this.priceToPrecision(symbol, stopPrice);
                        request['triggerType'] = 'price';
                        request['amount'] = this.amountToPrecision(symbol, amount);
                    }
                    const response = await this.privatePostOrder(this.extend(request, params));
                    //
                    //     {
                    //         "orderId":"af76d6ce-9f7c-4006-b715-bb5d430652d0",
                    //         "market":"ETH-EUR",
                    //         "created":1590505649241,
                    //         "updated":1590505649241,
                    //         "status":"filled",
                    //         "side":"sell",
                    //         "orderType":"market",
                    //         "amount":"0.249825",
                    //         "amountRemaining":"0",
                    //         "onHold":"0",
                    //         "onHoldCurrency":"ETH",
                    //         "filledAmount":"0.249825",
                    //         "filledAmountQuote":"45.84038925",
                    //         "feePaid":"0.12038925",
                    //         "feeCurrency":"EUR",
                    //         "fills":[
                    //             {
                    //                 "id":"b0c86aa5-6ed3-4a2d-ba3a-be9a964220f4",
                    //                 "timestamp":1590505649245,
                    //                 "amount":"0.249825",
                    //                 "price":"183.49",
                    //                 "taker":true,
                    //                 "fee":"0.12038925",
                    //                 "feeCurrency":"EUR",
                    //                 "settled":true
                    //             }
                    //         ],
                    //         "selfTradePrevention":"decrementAndCancel",
                    //         "visible":false,
                    //         "disableMarketProtection":false
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let request = {};
                    const amountRemaining = this.safeNumber(params, 'amountRemaining');
                    params = this.omit(params, 'amountRemaining');
                    if (price !== undefined) request['price'] = this.priceToPrecision(symbol, price);
                    if (amount !== undefined) request['amount'] = this.amountToPrecision(symbol, amount);
                    if (amountRemaining !== undefined) request['amountRemaining'] = this.amountToPrecision(symbol, amountRemaining);
                    request = this.extend(request, params);
                    if (Object.keys(request).length) {
                        request['orderId'] = id;
                        request['market'] = market['id'];
                        const response = await this.privatePutOrder(this.extend(request, params));
                        return this.parseOrder(response, market);
                    } else throw new ArgumentsRequired1(this.id + ' editOrder() requires an amount argument, or a price argument, or non-empty params');
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'orderId': id,
                        'market': market['id']
                    };
                    const response = await this.privateDeleteOrder(this.extend(request, params));
                    //
                    //     {
                    //         "orderId": "2e7ce7fc-44e2-4d80-a4a7-d079c4750b61"
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market'] = market['id'];
                    }
                    const response = await this.privateDeleteOrders(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "orderId": "1be6d0df-d5dc-4b53-a250-3376f3b393e6"
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'orderId': id,
                        'market': market['id']
                    };
                    const response = await this.privateGetOrder(this.extend(request, params));
                    //
                    //     {
                    //         "orderId":"af76d6ce-9f7c-4006-b715-bb5d430652d0",
                    //         "market":"ETH-EUR",
                    //         "created":1590505649241,
                    //         "updated":1590505649241,
                    //         "status":"filled",
                    //         "side":"sell",
                    //         "orderType":"market",
                    //         "amount":"0.249825",
                    //         "amountRemaining":"0",
                    //         "onHold":"0",
                    //         "onHoldCurrency":"ETH",
                    //         "filledAmount":"0.249825",
                    //         "filledAmountQuote":"45.84038925",
                    //         "feePaid":"0.12038925",
                    //         "feeCurrency":"EUR",
                    //         "fills":[
                    //             {
                    //                 "id":"b0c86aa5-6ed3-4a2d-ba3a-be9a964220f4",
                    //                 "timestamp":1590505649245,
                    //                 "amount":"0.249825",
                    //                 "price":"183.49",
                    //                 "taker":true,
                    //                 "fee":"0.12038925",
                    //                 "feeCurrency":"EUR",
                    //                 "settled":true
                    //             }
                    //         ],
                    //         "selfTradePrevention":"decrementAndCancel",
                    //         "visible":false,
                    //         "disableMarketProtection":false
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit; // default 500, max 1000
                    const response = await this.privateGetOrders(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "orderId":"af76d6ce-9f7c-4006-b715-bb5d430652d0",
                    //             "market":"ETH-EUR",
                    //             "created":1590505649241,
                    //             "updated":1590505649241,
                    //             "status":"filled",
                    //             "side":"sell",
                    //             "orderType":"market",
                    //             "amount":"0.249825",
                    //             "amountRemaining":"0",
                    //             "onHold":"0",
                    //             "onHoldCurrency":"ETH",
                    //             "filledAmount":"0.249825",
                    //             "filledAmountQuote":"45.84038925",
                    //             "feePaid":"0.12038925",
                    //             "feeCurrency":"EUR",
                    //             "fills":[
                    //                 {
                    //                     "id":"b0c86aa5-6ed3-4a2d-ba3a-be9a964220f4",
                    //                     "timestamp":1590505649245,
                    //                     "amount":"0.249825",
                    //                     "price":"183.49",
                    //                     "taker":true,
                    //                     "fee":"0.12038925",
                    //                     "feeCurrency":"EUR",
                    //                     "settled":true
                    //                 }
                    //             ],
                    //             "selfTradePrevention":"decrementAndCancel",
                    //             "visible":false,
                    //             "disableMarketProtection":false
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market'] = market['id'];
                    }
                    const response = await this.privateGetOrdersOpen(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "orderId":"af76d6ce-9f7c-4006-b715-bb5d430652d0",
                    //             "market":"ETH-EUR",
                    //             "created":1590505649241,
                    //             "updated":1590505649241,
                    //             "status":"filled",
                    //             "side":"sell",
                    //             "orderType":"market",
                    //             "amount":"0.249825",
                    //             "amountRemaining":"0",
                    //             "onHold":"0",
                    //             "onHoldCurrency":"ETH",
                    //             "filledAmount":"0.249825",
                    //             "filledAmountQuote":"45.84038925",
                    //             "feePaid":"0.12038925",
                    //             "feeCurrency":"EUR",
                    //             "fills":[
                    //                 {
                    //                     "id":"b0c86aa5-6ed3-4a2d-ba3a-be9a964220f4",
                    //                     "timestamp":1590505649245,
                    //                     "amount":"0.249825",
                    //                     "price":"183.49",
                    //                     "taker":true,
                    //                     "fee":"0.12038925",
                    //                     "feeCurrency":"EUR",
                    //                     "settled":true
                    //                 }
                    //             ],
                    //             "selfTradePrevention":"decrementAndCancel",
                    //             "visible":false,
                    //             "disableMarketProtection":false
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'new': 'open',
                        'canceled': 'canceled',
                        'canceledAuction': 'canceled',
                        'canceledSelfTradePrevention': 'canceled',
                        'canceledIOC': 'canceled',
                        'canceledFOK': 'canceled',
                        'canceledMarketProtection': 'canceled',
                        'canceledPostOnly': 'canceled',
                        'filled': 'closed',
                        'partiallyFilled': 'open',
                        'expired': 'canceled',
                        'rejected': 'canceled',
                        'awaitingTrigger': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // cancelOrder, cancelAllOrders
                    //
                    //     {
                    //         "orderId": "2e7ce7fc-44e2-4d80-a4a7-d079c4750b61"
                    //     }
                    //
                    // createOrder, fetchOrder, fetchOpenOrders, fetchOrders, editOrder
                    //
                    //     {
                    //         "orderId":"af76d6ce-9f7c-4006-b715-bb5d430652d0",
                    //         "market":"ETH-EUR",
                    //         "created":1590505649241,
                    //         "updated":1590505649241,
                    //         "status":"filled",
                    //         "side":"sell",
                    //         "orderType":"market",
                    //         "amount":"0.249825",
                    //         "amountRemaining":"0",
                    //         "price": "183.49", // limit orders only
                    //         "onHold":"0",
                    //         "onHoldCurrency":"ETH",
                    //         "filledAmount":"0.249825",
                    //         "filledAmountQuote":"45.84038925",
                    //         "feePaid":"0.12038925",
                    //         "feeCurrency":"EUR",
                    //         "fills":[
                    //             {
                    //                 "id":"b0c86aa5-6ed3-4a2d-ba3a-be9a964220f4",
                    //                 "timestamp":1590505649245,
                    //                 "amount":"0.249825",
                    //                 "price":"183.49",
                    //                 "taker":true,
                    //                 "fee":"0.12038925",
                    //                 "feeCurrency":"EUR",
                    //                 "settled":true
                    //             }
                    //         ],
                    //         "selfTradePrevention":"decrementAndCancel",
                    //         "visible":false,
                    //         "disableMarketProtection":false
                    //         "timeInForce": "GTC",
                    //         "postOnly": true,
                    //     }
                    //
                    const id = this.safeString(order, 'orderId');
                    const timestamp = this.safeInteger(order, 'created');
                    const marketId = this.safeString(order, 'market');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const side = this.safeString(order, 'side');
                    const type = this.safeString(order, 'orderType');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'amount');
                    const remaining = this.safeString(order, 'amountRemaining');
                    const filled = this.safeString(order, 'filledAmount');
                    const cost = this.safeString(order, 'filledAmountQuote');
                    let fee = undefined;
                    const feeCost = this.safeNumber(order, 'feePaid');
                    if (feeCost !== undefined) {
                        const feeCurrencyId = this.safeString(order, 'feeCurrency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrencyCode
                        };
                    }
                    const rawTrades = this.safeValue(order, 'fills', []);
                    const timeInForce = this.safeString(order, 'timeInForce');
                    const postOnly = this.safeValue(order, 'postOnly');
                    // https://github.com/ccxt/ccxt/issues/8489
                    const stopPrice = this.safeNumber(order, 'triggerPrice');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': cost,
                        'average': undefined,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': fee,
                        'trades': rawTrades
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit; // default 500, max 1000
                    const response = await this.privateGetTrades(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id":"b0c86aa5-6ed3-4a2d-ba3a-be9a964220f4",
                    //             "orderId":"af76d6ce-9f7c-4006-b715-bb5d430652d0",
                    //             "timestamp":1590505649245,
                    //             "market":"ETH-EUR",
                    //             "side":"sell",
                    //             "amount":"0.249825",
                    //             "price":"183.49",
                    //             "taker":true,
                    //             "fee":"0.12038925",
                    //             "feeCurrency":"EUR",
                    //             "settled":true
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'symbol': currency['id'],
                        'amount': this.currencyToPrecision(code, amount),
                        'address': address
                    };
                    if (tag !== undefined) request['paymentId'] = tag;
                    const response = await this.privatePostWithdrawal(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "symbol": "BTC",
                    //         "amount": "1.5"
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['symbol'] = currency['id'];
                    }
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit; // default 500, max 1000
                    const response = await this.privateGetWithdrawalHistory(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "timestamp":1590531212000,
                    //             "symbol":"ETH",
                    //             "amount":"0.091",
                    //             "fee":"0.009",
                    //             "status":"awaiting_bitvavo_inspection",
                    //             "address":"0xe42b309f1eE9F0cbf7f54CcF3bc2159eBfA6735b",
                    //             "paymentId": "10002653",
                    //             "txId": "927b3ea50c5bb52c6854152d305dfa1e27fc01d10464cf10825d96d69d235eb3",
                    //         }
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit, {
                        'type': 'withdrawal'
                    });
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['symbol'] = currency['id'];
                    }
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit; // default 500, max 1000
                    const response = await this.privateGetDepositHistory(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "timestamp":1590492401000,
                    //             "symbol":"ETH",
                    //             "amount":"0.249825",
                    //             "fee":"0",
                    //             "status":"completed",
                    //             "txId":"0x5167b473fd37811f9ef22364c3d54726a859ef9d98934b3a1e11d7baa8d2c2e2"
                    //         }
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit, {
                        'type': 'deposit'
                    });
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'awaiting_processing': 'pending',
                        'awaiting_email_confirmation': 'pending',
                        'awaiting_bitvavo_inspection': 'pending',
                        'approved': 'pending',
                        'sending': 'pending',
                        'in_mempool': 'pending',
                        'processed': 'pending',
                        'completed': 'ok',
                        'canceled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "success": true,
                    //         "symbol": "BTC",
                    //         "amount": "1.5"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "timestamp": 1542967486256,
                    //         "symbol": "BTC",
                    //         "amount": "0.99994",
                    //         "address": "BitcoinAddress",
                    //         "paymentId": "10002653",
                    //         "txId": "927b3ea50c5bb52c6854152d305dfa1e27fc01d10464cf10825d96d69d235eb3",
                    //         "fee": "0.00006",
                    //         "status": "awaiting_processing"
                    //     }
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "timestamp":1590492401000,
                    //         "symbol":"ETH",
                    //         "amount":"0.249825",
                    //         "fee":"0",
                    //         "status":"completed",
                    //         "txId":"0x5167b473fd37811f9ef22364c3d54726a859ef9d98934b3a1e11d7baa8d2c2e2"
                    //     }
                    //
                    const id = undefined;
                    const timestamp = this.safeInteger(transaction, 'timestamp');
                    const currencyId = this.safeString(transaction, 'symbol');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const amount = this.safeNumber(transaction, 'amount');
                    const address = this.safeString(transaction, 'address');
                    const txid = this.safeString(transaction, 'txId');
                    let fee = undefined;
                    const feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    let type = undefined;
                    if ('success' in transaction || 'address' in transaction) type = 'withdrawal';
                    else type = 'deposit';
                    const tag = this.safeString(transaction, 'paymentId');
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'addressFrom': undefined,
                        'address': address,
                        'addressTo': address,
                        'tagFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'fee': fee
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const query = this.omit(params, this.extractParams(path));
                    let url = '/' + this.version + '/' + this.implodeParams(path, params);
                    const getOrDelete = method === 'GET' || method === 'DELETE';
                    if (getOrDelete) {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    }
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        let payload = '';
                        if (!getOrDelete) {
                            if (Object.keys(query).length) {
                                body = this.json(query);
                                payload = body;
                            }
                        }
                        const timestamp = this.milliseconds().toString();
                        const auth = timestamp + method + url + payload;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                        const accessWindow = this.safeString(this.options, 'BITVAVO-ACCESS-WINDOW', '10000');
                        headers = {
                            'BITVAVO-ACCESS-KEY': this.apiKey,
                            'BITVAVO-ACCESS-SIGNATURE': signature,
                            'BITVAVO-ACCESS-TIMESTAMP': timestamp,
                            'BITVAVO-ACCESS-WINDOW': accessWindow
                        };
                        if (!getOrDelete) headers['Content-Type'] = 'application/json';
                    }
                    url = this.urls['api'][api] + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //     {"errorCode":308,"error":"The signature length is invalid (HMAC-SHA256 should return a 64 length hexadecimal string)."}
                    //     {"errorCode":203,"error":"symbol parameter is required."}
                    //     {"errorCode":205,"error":"symbol parameter is invalid."}
                    //
                    const errorCode = this.safeString(response, 'errorCode');
                    const error = this.safeString(response, 'error');
                    if (errorCode !== undefined) {
                        const feedback = this.id + ' ' + body;
                        this.throwBroadlyMatchedException(this.exceptions['broad'], error, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
                calculateRateLimiterCost(api, method, path, params, config = {}, context = {}) {
                    if ('noMarket' in config && !('market' in params)) return config['noMarket'];
                    return this.safeValue(config, 'cost', 1);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    48: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, BadRequest: BadRequest, ArgumentsRequired: ArgumentsRequired1, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder } = require1('./base/errors');
            // ---------------------------------------------------------------------------
            module.exports = class bkex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bkex',
                        'name': 'BKEX',
                        'countries': [
                            'BVI'
                        ],
                        'rateLimit': 100,
                        'version': 'v2',
                        'certified': false,
                        'has': {
                            'CORS': undefined,
                            'spot': undefined,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'addMargin': undefined,
                            'cancelAllOrders': undefined,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createDepositAddress': undefined,
                            'createLimitOrder': undefined,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'editOrder': undefined,
                            'fetchAccounts': undefined,
                            'fetchBalance': true,
                            'fetchBidsAsks': undefined,
                            'fetchBorrowRate': undefined,
                            'fetchBorrowRateHistory': undefined,
                            'fetchBorrowRates': undefined,
                            'fetchBorrowRatesPerSymbol': undefined,
                            'fetchCanceledOrders': undefined,
                            'fetchClosedOrder': undefined,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDeposit': false,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': undefined,
                            'fetchDepositAddressesByNetwork': undefined,
                            'fetchDeposits': true,
                            'fetchFundingFee': undefined,
                            'fetchFundingFees': undefined,
                            'fetchFundingHistory': undefined,
                            'fetchFundingRate': undefined,
                            'fetchFundingRateHistory': undefined,
                            'fetchFundingRates': undefined,
                            'fetchIndexOHLCV': undefined,
                            'fetchL2OrderBook': undefined,
                            'fetchLedger': undefined,
                            'fetchLedgerEntry': undefined,
                            'fetchLeverageTiers': undefined,
                            'fetchMarketLeverageTiers': undefined,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': undefined,
                            'fetchMyTrades': undefined,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': false,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': undefined,
                            'fetchOrders': undefined,
                            'fetchOrderTrades': undefined,
                            'fetchPosition': undefined,
                            'fetchPositions': undefined,
                            'fetchPositionsRisk': undefined,
                            'fetchPremiumIndexOHLCV': undefined,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTradingLimits': undefined,
                            'fetchTransactions': undefined,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': true,
                            'loadMarkets': true,
                            'privateAPI': true,
                            'publicAPI': true,
                            'reduceMargin': undefined,
                            'setLeverage': undefined,
                            'setMarginMode': undefined,
                            'setPositionMode': undefined,
                            'signIn': undefined,
                            'transfer': false,
                            'withdraw': false
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '4h': '4h',
                            '6h': '6h',
                            '12h': '12h',
                            '1d': '1d',
                            '1w': '1w'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/158043180-bb079a65-69e8-45a2-b393-f094d334e610.jpg',
                            'api': {
                                'public': 'https://api.bkex.com',
                                'private': 'https://api.bkex.com'
                            },
                            'www': 'https://www.bkex.com/',
                            'doc': [
                                'https://bkexapi.github.io/docs/api_en.htm'
                            ],
                            'fees': [
                                'https://www.bkex.com/help/instruction/33'
                            ]
                        },
                        'api': {
                            'public': {
                                'get': {
                                    '/common/symbols': 1,
                                    '/common/currencys': 1,
                                    '/common/timestamp': 1,
                                    '/q/kline': 1,
                                    '/q/tickers': 1,
                                    '/q/ticker/price': 1,
                                    '/q/depth': 1,
                                    '/q/deals': 1,
                                    // contracts:
                                    '/contract/common/brokerInfo': 1,
                                    '/contract/q/index': 1,
                                    '/contract/q/depth': 1,
                                    '/contract/q/depthMerged': 1,
                                    '/contract/q/trades': 1,
                                    '/contract/q/kline': 1,
                                    '/contract/q/ticker24hr': 1
                                }
                            },
                            'private': {
                                'get': {
                                    '/u/api/info': 1,
                                    '/u/account/balance': 1,
                                    '/u/wallet/address': 1,
                                    '/u/wallet/depositRecord': 1,
                                    '/u/wallet/withdrawRecord': 1,
                                    '/u/order/openOrders': 1,
                                    '/u/order/openOrder/detail': 1,
                                    '/u/order/historyOrders': 1,
                                    // contracts:
                                    '/contract/trade/getOrder': 1,
                                    '/contract/trade/openOrders': 1,
                                    '/contract/trade/historyOrders': 1,
                                    '/contract/trade/myTrades': 1,
                                    '/contract/trade/positions': 1,
                                    '/contract/u/account': 1
                                },
                                'post': {
                                    '/u/account/transfer': 1,
                                    '/u/wallet/withdraw': 1,
                                    '/u/order/create': 1,
                                    '/u/order/cancel': 1,
                                    '/u/order/batchCreate': 1,
                                    '/u/order/batchCancel': 1,
                                    // contracts:
                                    '/contract/trade/order': 1,
                                    '/contract/trade/orderCancel': 1,
                                    '/contract/trade/modifyMargin': 1,
                                    '/contract/ws/dataStream/create': 1,
                                    '/contract/ws/dataStream/update': 1,
                                    '/contract/ws/dataStream/delete': 1
                                },
                                'delete': {}
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.0015'),
                                'taker': this.parseNumber('0.002')
                            }
                        },
                        'options': {
                            'timeframes': {
                                'spot': {},
                                'contract': {}
                            },
                            'defaultType': 'spot',
                            'networks': {
                                'TRX': 'TRC-20',
                                'TRC20': 'TRC-20',
                                'ETH': 'ERC-20',
                                'ERC20': 'ERC-20',
                                'BEP20': 'BEP-20(BSC)'
                            }
                        },
                        'commonCurrencies': {},
                        'exceptions': {
                            'exact': {
                                '1005': InsufficientFunds
                            },
                            'broad': {
                                'Not Enough balance': InsufficientFunds,
                                'Order does not exist': InvalidOrder,
                                'System busy, please try again later': BadRequest
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetCommonSymbols(params);
                    //
                    // {
                    //     "code": "0",
                    //     "data": [
                    //         {
                    //             "minimumOrderSize": "0",
                    //             "minimumTradeVolume": "0E-18",
                    //             "pricePrecision": "11",
                    //             "supportTrade": true,
                    //             "symbol": "COMT_USDT",
                    //             "volumePrecision": 0
                    //         },
                    //     ],
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const data = this.safeValue(response, 'data');
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const id = this.safeString(market, 'symbol');
                        const [baseId, quoteId] = id.split('_');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'future': false,
                            'swap': false,
                            'option': false,
                            'active': this.safeValue(market, 'supportTrade'),
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'volumePrecision'),
                                'price': this.safeInteger(market, 'pricePrecision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minimumOrderSize'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minimumTradeVolume'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCommonCurrencys(params);
                    //
                    // {
                    //     "code": "0",
                    //     "data": [
                    //        {
                    //           "currency": "ETH",
                    //           "maxWithdrawOneDay": "100.000000000000000000",
                    //           "maxWithdrawSingle": "50.000000000000000000",
                    //           "minWithdrawSingle": "0.005000000000000000",
                    //           "supportDeposit": true,
                    //           "supportTrade": true,
                    //           "supportWithdraw": true,
                    //           "withdrawFee": 0.01
                    //        },
                    //     ],
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const result = {};
                    for(let i = 0; i < data.length; i++){
                        const currency = data[i];
                        const id = this.safeString(currency, 'currency');
                        const code = this.safeCurrencyCode(id);
                        const name = this.safeString(currency, 'name');
                        const withdrawEnabled = this.safeValue(currency, 'supportWithdraw');
                        const depositEnabled = this.safeValue(currency, 'supportDeposit');
                        const tradeEnabled = this.safeValue(currency, 'supportTrade');
                        const active = withdrawEnabled && depositEnabled && tradeEnabled;
                        result[code] = {
                            'id': id,
                            'code': code,
                            'name': name,
                            'deposit': depositEnabled,
                            'withdraw': withdrawEnabled,
                            'active': active,
                            'fee': this.safeNumber(currency, 'withdrawFee'),
                            'precision': undefined,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'minWithdrawSingle'),
                                    'max': this.safeNumber(currency, 'maxWithdrawSingle')
                                }
                            },
                            'info': currency
                        };
                    }
                    return result;
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetCommonTimestamp(params);
                    //
                    // {
                    //     "code": '0',
                    //     "data": 1573542445411,
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    return this.safeInteger(response, 'data');
                }
                async fetchStatus(params = {}) {
                    const response = await this.publicGetCommonTimestamp(params);
                    //
                    //     {
                    //         "code": '0',
                    //         "data": 1573542445411,
                    //         "msg": "success",
                    //         "status": 0
                    //     }
                    //
                    const statusRaw = this.safeInteger(response, 'status');
                    const codeRaw = this.safeInteger(response, 'code');
                    return {
                        'status': statusRaw === 0 && codeRaw === 0 ? 'ok' : statusRaw,
                        'updated': this.milliseconds(),
                        'eta': undefined,
                        'info': response
                    };
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'period': this.timeframes[timeframe]
                    };
                    if (limit !== undefined) request['size'] = limit;
                    // their docs says that 'from/to' arguments are mandatory, however that's not true in reality
                    if (since !== undefined) {
                        request['from'] = since;
                        // when 'since' [from] argument is set, then exchange also requires 'to' value to be set. So we have to set 'to' argument depending 'limit' amount (if limit was not provided, then exchange-default 500).
                        if (limit === undefined) limit = 500;
                        const duration = this.parseTimeframe(timeframe);
                        const timerange = limit * duration * 1000;
                        request['to'] = this.sum(request['from'], timerange);
                    }
                    const response = await this.publicGetQKline(request);
                    //
                    // {
                    //     "code": "0",
                    //     "data": [
                    //       {
                    //          "close": "43414.68",
                    //          "high": "43446.47",
                    //          "low": "43403.05",
                    //          "open": "43406.05",
                    //          "quoteVolume": "61500.40099",
                    //          "symbol": "BTC_USDT",
                    //          "ts": "1646152440000",
                    //          "volume": 1.41627
                    //       },
                    //     ],
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    return [
                        this.safeInteger(ohlcv, 'ts'),
                        this.safeFloat(ohlcv, 'open'),
                        this.safeFloat(ohlcv, 'high'),
                        this.safeFloat(ohlcv, 'low'),
                        this.safeFloat(ohlcv, 'close'),
                        this.safeFloat(ohlcv, 'volume')
                    ];
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetQTickers(this.extend(request, params));
                    //
                    // {
                    //     "code": "0",
                    //     "data": [
                    //       {
                    //         "change": "6.52",
                    //         "close": "43573.470000",
                    //         "high": "44940.540000",
                    //         "low": "40799.840000",
                    //         "open": "40905.780000",
                    //         "quoteVolume": "225621691.5991",
                    //         "symbol": "BTC_USDT",
                    //         "ts": "1646156490781",
                    //         "volume": 5210.349
                    //       }
                    //     ],
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const tickers = this.safeValue(response, 'data');
                    const ticker = this.safeValue(tickers, 0);
                    return this.parseTicker(ticker, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbols !== undefined) {
                        if (!Array.isArray(symbols)) throw new BadRequest(this.id + ' fetchTickers() symbols argument should be an array');
                    }
                    if (symbols !== undefined) {
                        const marketIds = this.marketIds(symbols);
                        request['symbol'] = marketIds.join(',');
                    }
                    const response = await this.publicGetQTickers(this.extend(request, params));
                    const tickers = this.safeValue(response, 'data');
                    return this.parseTickers(tickers, symbols, params);
                }
                parseTicker(ticker, market) {
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.safeInteger(ticker, 'ts');
                    const last = this.safeString(ticker, 'close');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': this.safeString(ticker, 'change'),
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': this.safeString(ticker, 'quoteVolume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['depth'] = Math.min(limit, 50);
                    const response = await this.publicGetQDepth(this.extend(request, params));
                    //
                    // {
                    //     "code": "0",
                    //     "data": {
                    //       "ask": [
                    //         ["43820.07","0.86947"],
                    //         ["43820.25","0.07503"],
                    //       ],
                    //       "bid": [
                    //         ["43815.94","0.43743"],
                    //         ["43815.72","0.08901"],
                    //       ],
                    //       "symbol": "BTC_USDT",
                    //       "timestamp": 1646161595841
                    //     },
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseOrderBook(data, symbol, undefined, 'bid', 'ask');
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['size'] = Math.min(limit, 50);
                    const response = await this.publicGetQDeals(this.extend(request, params));
                    //
                    // {
                    //     "code": "0",
                    //     "data": [
                    //       {
                    //         "direction": "S",
                    //         "price": "43930.63",
                    //         "symbol": "BTC_USDT",
                    //         "ts": "1646224171992",
                    //         "volume": 0.030653
                    //       }, // first item is most recent
                    //     ],
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const trades = this.safeValue(response, 'data');
                    return this.parseTrades(trades, market, since, limit);
                }
                parseTrade(trade, market) {
                    const timestamp = this.safeInteger(trade, 'ts');
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const side = this.parseTradeSide(this.safeString(trade, 'direction'));
                    const amount = this.safeNumber(trade, 'volume');
                    const price = this.safeNumber(trade, 'price');
                    const type = undefined;
                    const takerOrMaker = 'taker';
                    let id = this.safeString(trade, 'tid');
                    if (id === undefined) id = this.syntheticTradeId(market, timestamp, side, amount, price, type, takerOrMaker);
                    return this.safeTrade({
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': undefined,
                        'type': type,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': undefined,
                        'info': trade
                    }, market);
                }
                parseTradeSide(side) {
                    const sides = {
                        'B': 'buy',
                        'S': 'sell'
                    };
                    return this.safeString(sides, side, side);
                }
                syntheticTradeId(market, timestamp, side, amount, price, orderType, takerOrMaker) {
                    // TODO: can be unified method? this approach is being used by multiple exchanges (mexc, woo-coinsbit, dydx, ...)
                    let id = '';
                    if (timestamp !== undefined) {
                        id = this.numberToString(timestamp) + '-' + this.safeString(market, 'id', '_');
                        if (side !== undefined) id += '-' + side;
                        if (orderType !== undefined) id += '-' + orderType;
                        if (takerOrMaker !== undefined) id += '-' + takerOrMaker;
                        if (amount !== undefined) id += '-' + this.numberToString(amount);
                        if (price !== undefined) id += '-' + this.numberToString(price);
                    }
                    return id;
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const query = this.omit(params, 'type');
                    const response = await this.privateGetUAccountBalance(query);
                    //
                    // {
                    //     "code": "0",
                    //     "data": {
                    //       "WALLET": [
                    //         {
                    //           "available": "0.221212121000000000",
                    //           "currency": "PHX",
                    //           "frozen": "0E-18",
                    //           "total": 0.221212121
                    //         },
                    //         {
                    //           "available": "44.959577229600000000",
                    //           "currency": "USDT",
                    //           "frozen": "0E-18",
                    //           "total": 44.9595772296
                    //         }
                    //       ]
                    //     },
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const balances = this.safeValue(response, 'data');
                    const wallets = this.safeValue(balances, 'WALLET');
                    const result = {
                        'info': wallets
                    };
                    for(let i = 0; i < wallets.length; i++){
                        const wallet = wallets[i];
                        const currencyId = wallet['currency'];
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeNumber(wallet, 'available');
                        account['used'] = this.safeNumber(wallet, 'frozen');
                        account['total'] = this.safeNumber(wallet, 'total');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateGetUWalletAddress(this.extend(request, params));
                    // NOTE: You can only retrieve addresses of already generated wallets - so should already have generated that COIN deposit address in UI. Otherwise, it seems from API you can't create/obtain addresses for those coins.
                    //
                    // {
                    //     "code": "0",
                    //     "data": [
                    //       {
                    //         "currency": "BTC",
                    //         "address": "1m4k2yUKTSrX6SM9FGgvwMyxQbYtRVi2N",
                    //         "memo": ""
                    //       }
                    //     ],
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseDepositAddress(data, currency);
                }
                parseDepositAddress(data, currency) {
                    const depositObject = this.safeValue(data, 0);
                    const address = this.safeString(depositObject, 'address');
                    const tag = this.safeString(depositObject, 'memo');
                    const currencyId = this.safeString(depositObject, 'currency');
                    currency = this.safeCurrency(currencyId, currency);
                    return {
                        'currency': currency['code'],
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': data
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    if (since !== undefined) {
                        request['startTime'] = since;
                        const endTime = this.milliseconds();
                        request['endTime'] = endTime;
                    }
                    if (limit !== undefined) request['Size'] = limit; // Todo: id api-docs, 'size' is incorrectly required to be in Uppercase
                    const response = await this.privateGetUWalletDepositRecord(this.extend(request, params));
                    //
                    // {
                    //     "code": "0",
                    //     "data": {
                    //       "data": [
                    //         {
                    //           "createTime": "1622274255000",
                    //           "currency": "BNB",
                    //           "fromAddress": "bnb10af52w77pkehgxhnwgeca50q2t2354q4xexa5y",
                    //           "hash": "97B982F497782C2777C0F6AD16CEAAC65A93A364B684A23A71CFBB8C010DEEA6",
                    //           "id": "2021052923441510234383337",
                    //           "status": "0",
                    //           "toAddress": "bnb13w64gkc42c0l45m2p5me4qn35z0a3ej9ldks3j_82784659",
                    //           "volume": 0.073
                    //         }
                    //       ],
                    //       "total": 1
                    //     },
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const dataInner = this.safeValue(data, 'data', []);
                    for(let i = 0; i < dataInner.length; i++)dataInner[i]['transactType'] = 'deposit';
                    return this.parseTransactions(dataInner, currency, since, limit, params);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    if (since !== undefined) {
                        request['startTime'] = since;
                        const endTime = this.milliseconds();
                        request['endTime'] = endTime;
                    }
                    if (limit !== undefined) request['Size'] = limit; // Todo: id api-docs, 'size' is incorrectly required to be in Uppercase
                    const response = await this.privateGetUWalletWithdrawRecord(this.extend(request, params));
                    //
                    // {
                    //     "code": "0",
                    //     "data": {
                    //       "data": [
                    //         {
                    //           ...
                    //         }
                    //       ],
                    //       "total": 1
                    //     },
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const dataInner = this.safeValue(data, 'data', []);
                    for(let i = 0; i < dataInner.length; i++)dataInner[i]['transactType'] = 'withdrawal';
                    return this.parseTransactions(dataInner, currency, since, limit, params);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    // {
                    //   "createTime": "1622274255000",
                    //   "currency": "BNB",
                    //   "fromAddress": "bnb10af52w77pkehgxhnwgeca50q2t2354q4xexa5y",
                    //   "hash": "97B982F497782C2777C0F6AD16CEAAC65A93A364B684A23A71CFBB8C010DEEA6",
                    //   "id": "2021052923441510234383337",
                    //   "status": "0",
                    //   "toAddress": "bnb13w64gkc42c0l45m2p5me4qn35z0a3ej9ldks3j_82784659",
                    //   "volume": 0.073
                    // }
                    //
                    const id = this.safeString(transaction, 'id');
                    const amount = this.safeNumber(transaction, 'volume');
                    const addressTo = this.safeValue(transaction, 'toAddress', {});
                    const addressFrom = this.safeString(transaction, 'fromAddress');
                    const txid = this.safeString(transaction, 'hash');
                    const type = this.safeString(transaction, 'transactType');
                    const timestamp = this.safeInteger(transaction, 'createTime');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    return {
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': undefined,
                        'address': addressTo,
                        'addressTo': addressTo,
                        'addressFrom': addressFrom,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'status': status,
                        'type': type,
                        'updated': undefined,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': {
                            'currency': code,
                            'cost': undefined
                        },
                        'info': transaction
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        '-1': 'failed',
                        '0': 'ok',
                        '3': 'pending',
                        '5': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const direction = side === 'buy' ? 'BID' : 'ASK';
                    const request = {
                        'symbol': market['id'],
                        'type': type.toUpperCase(),
                        'volume': this.amountToPrecision(symbol, amount),
                        'direction': direction
                    };
                    if (type !== 'market' && price !== undefined) request['price'] = this.priceToPrecision(symbol, price);
                    const response = await this.privatePostUOrderCreate(this.extend(request, params));
                    //
                    // {
                    //     "code": "0",
                    //     "data": "2022030302410146630023187",
                    //     "msg": "Create Order Successfully",
                    //     "status": 0
                    // }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const market = symbol !== undefined ? this.market(symbol) : undefined;
                    const request = {
                        'orderId': id
                    };
                    const response = await this.privatePostUOrderCancel(this.extend(request, params));
                    //
                    // {
                    //     "code": "0",
                    //     "data": "2022030303032700030025325",
                    //     "status": 0
                    // }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrders(ids, symbol, params = {}) {
                    if (!Array.isArray(ids)) throw new ArgumentsRequired1(this.id + ' cancelOrders() ids argument should be an array');
                    await this.loadMarkets();
                    const request = {
                        'orders': this.json(ids)
                    };
                    const response = await this.privatePostUOrderBatchCancel(this.extend(request, params));
                    // {
                    //     "code": 0,
                    //     "msg": "success",
                    //     "data": {
                    //        "success": 2,
                    //        "fail": 0,
                    //        "results": ["2019062312313131231"," 2019063123131312313"]
                    //     }
                    // }
                    const data = this.safeValue(response, 'data');
                    const results = this.safeValue(data, 'results');
                    const market = symbol !== undefined ? this.market(symbol) : undefined;
                    return this.parseOrders(results, market, undefined, undefined, params);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['size'] = limit; // Todo: id api-docs, 'size' is incorrectly required to be in Uppercase
                    const response = await this.privateGetUOrderOpenOrders(this.extend(request, params));
                    //
                    // {
                    //     "code": "0",
                    //     "data": {
                    //       "data": [
                    //         {
                    //           "createdTime": "1646248301418",
                    //           "dealVolume": "0E-18",
                    //           "direction": "BID",
                    //           "frozenVolumeByOrder": "2.421300000000000000",
                    //           "id": "2022030303114141830007699",
                    //           "price": "0.150000000000000000",
                    //           "source": "WALLET",
                    //           "status": "0",
                    //           "symbol": "BKK_USDT",
                    //           "totalVolume": "16.142000000000000000",
                    //           "type": "LIMIT"
                    //         }
                    //       ],
                    //       "pageRequest": {
                    //         "asc": false,
                    //         "orderBy": "id",
                    //         "page": "1",
                    //         "size": 10
                    //       },
                    //       "total": 1
                    //     },
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const result = this.safeValue(response, 'data');
                    const innerData = this.safeValue(result, 'data');
                    return this.parseOrders(innerData, market, since, limit, params);
                }
                async fetchOpenOrder(id, symbol, params = {}) {
                    const request = {
                        'orderId': id
                    };
                    const response = await this.privateGetUOrderOpenOrderDetail(this.extend(request, params));
                    //
                    // {
                    //     "code": "0",
                    //     "data": {
                    //       "createdTime": "1646248301418",
                    //       "dealAvgPrice": "0",
                    //       "dealVolume": "0E-18",
                    //       "direction": "BID",
                    //       "frozenVolumeByOrder": "2.421300000000000000",
                    //       "id": "2022030303114141830002452",
                    //       "price": "0.150000000000000000",
                    //       "source": "WALLET",
                    //       "status": "0",
                    //       "symbol": "BKK_USDT",
                    //       "totalVolume": "16.142000000000000000",
                    //       "type": "LIMIT",
                    //       "updateTime": 1646248301418
                    //     },
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const data = this.safeValue(response, 'data');
                    const market = symbol !== undefined ? this.market(symbol) : undefined;
                    return this.parseOrder(data, market);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['size'] = limit; // Todo: id api-docs, 'size' is incorrectly required to be in Uppercase
                    if (since !== undefined) request['startTime'] = since;
                    const response = await this.privateGetUOrderHistoryOrders(this.extend(request, params));
                    //
                    // {
                    //     "code": "0",
                    //     "data": {
                    //       "data": [
                    //         {
                    //           "createdTime": "1646247807000",
                    //           "dealAvgPrice": "0",
                    //           "dealVolume": "0",
                    //           "direction": "BID",
                    //           "frozenVolumeByOrder": "1.65",
                    //           "id": "2022030303032700030025943",
                    //           "price": "0.15",
                    //           "source": "WALLET",
                    //           "status": "2",
                    //           "symbol": "BKK_USDT",
                    //           "totalVolume": "11",
                    //           "type": "LIMIT",
                    //           "updateTime": 1646247852558
                    //         },
                    //       ],
                    //       "pageRequest": {
                    //         "asc": false,
                    //         "orderBy": "id",
                    //         "page": "1",
                    //         "size": 10
                    //       },
                    //       "total": 6
                    //     },
                    //     "msg": "success",
                    //     "status": 0
                    // }
                    //
                    const result = this.safeValue(response, 'data');
                    const innerData = this.safeValue(result, 'data');
                    return this.parseOrders(innerData, market, since, limit, params);
                }
                parseOrder(order, market) {
                    //
                    // fetchOpenOrders
                    //
                    //  {
                    //       "createdTime": "1646248301418",
                    //       "dealVolume": "0E-18",
                    //       "direction": "BID",
                    //       "frozenVolumeByOrder": "2.421300000000000000",
                    //       "id": "2022030303114141830007699",
                    //       "price": "0.150000000000000000",
                    //       "source": "WALLET",
                    //       "status": "0",
                    //       "symbol": "BKK_USDT",
                    //       "totalVolume": "16.142000000000000000",
                    //       "type": "LIMIT"
                    //       "stopPrice":  "0.14",            // present only for 'stop' order types
                    //       "operator":  ">="                // present only for 'stop' order types
                    //       "dealAvgPrice": "0",             // only present in 'fetchOrder' & 'fetchClosedOrders'
                    //       "updateTime": 1646248301418      // only present in 'fetchOrder' & 'fetchClosedOrders'
                    //  }
                    //
                    const timestamp = this.safeInteger(order, 'createdTime');
                    const updateTime = this.safeInteger(order, 'updateTime');
                    const filled = this.safeString(order, 'dealVolume');
                    const side = this.parseOrderSide(this.safeString(order, 'direction'));
                    const id = this.safeString2(order, 'id', 'data');
                    const price = this.safeString(order, 'price');
                    const rawStatus = this.safeString(order, 'status');
                    const rawType = this.safeString(order, 'type');
                    const type = this.parseOrderType(rawType);
                    let postOnly = false;
                    if (rawType === 'LIMIT_MAKER') postOnly = true;
                    let status = undefined;
                    if (timestamp !== undefined) // cancelOrder handling
                    status = this.parseOrderStatus(rawStatus);
                    const marketId = this.safeString(order, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const amount = this.safeString(order, 'totalVolume');
                    const stopPrice = this.safeNumber(order, 'stopPrice');
                    const average = this.safeString(order, 'dealAvgPrice');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': updateTime,
                        'status': status,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'average': average,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'cost': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'info': order
                    }, market);
                }
                parseOrderSide(side) {
                    const sides = {
                        'BID': 'buy',
                        'ASK': 'sell'
                    };
                    return this.safeString(sides, side, side);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '0': 'open',
                        '1': 'closed',
                        '2': 'canceled',
                        '3': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrderType(status) {
                    const statuses = {
                        'MARKET': 'market',
                        'LIMIT': 'limit',
                        'LIMIT_MAKER': 'limit',
                        'STOP_LIMIT': 'limit'
                    };
                    return this.safeString(statuses, status, status);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/' + this.version + this.implodeParams(path, params);
                    params = this.omit(params, this.extractParams(path));
                    let paramsSortedEncoded = '';
                    if (Object.keys(params).length) {
                        paramsSortedEncoded = this.rawencode(this.keysort(params));
                        if (method === 'GET') url += '?' + paramsSortedEncoded;
                    }
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const signature = this.hmac(this.encode(paramsSortedEncoded), this.encode(this.secret), 'sha256');
                        headers = {
                            'Cache-Control': 'no-cache',
                            'Content-type': 'application/x-www-form-urlencoded',
                            'X_ACCESS_KEY': this.apiKey,
                            'X_SIGNATURE': signature
                        };
                        if (method !== 'GET') body = paramsSortedEncoded;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    // success
                    //
                    //   {
                    //      "code": "0",
                    //      "msg": "success",
                    //      "status": 0,
                    //      "data": [...],
                    //   }
                    //
                    //
                    // action error
                    //
                    //   {
                    //     "code":1005,
                    //     "msg":"BKK:Not Enough balance",
                    //     "status":0
                    //   }
                    //
                    //
                    // HTTP error
                    //
                    //   {
                    //      "timestamp": "1646041085490",
                    //      "status": "403",
                    //      "error": "Forbidden",
                    //      "message": "签名错误",
                    //      "path": "/whatever/incorrect/path"
                    //   }
                    //
                    const message = this.safeValue(response, 'msg');
                    if (message === 'success') return;
                    const responseCode = this.safeString(response, 'code');
                    if (responseCode !== '0') {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], responseCode, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    49: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const Precise = require1('./base/Precise');
            // ---------------------------------------------------------------------------
            module.exports = class bl3p extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bl3p',
                        'name': 'BL3P',
                        'countries': [
                            'NL'
                        ],
                        'rateLimit': 1000,
                        'version': '1',
                        'comment': 'An exchange market by BitonicNL',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkOHLCV': false,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/28501752-60c21b82-6feb-11e7-818b-055ee6d0e754.jpg',
                            'api': 'https://api.bl3p.eu',
                            'www': 'https://bl3p.eu',
                            'doc': [
                                'https://github.com/BitonicNL/bl3p-api/tree/master/docs',
                                'https://bl3p.eu/api',
                                'https://bitonic.nl/en/api'
                            ]
                        },
                        'api': {
                            'public': {
                                'get': [
                                    '{market}/ticker',
                                    '{market}/orderbook',
                                    '{market}/trades'
                                ]
                            },
                            'private': {
                                'post': [
                                    '{market}/money/depth/full',
                                    '{market}/money/order/add',
                                    '{market}/money/order/cancel',
                                    '{market}/money/order/result',
                                    '{market}/money/orders',
                                    '{market}/money/orders/history',
                                    '{market}/money/trades/fetch',
                                    'GENMKT/money/info',
                                    'GENMKT/money/deposit_address',
                                    'GENMKT/money/new_deposit_address',
                                    'GENMKT/money/wallet/history',
                                    'GENMKT/money/withdraw'
                                ]
                            }
                        },
                        'markets': {
                            'BTC/EUR': {
                                'id': 'BTCEUR',
                                'symbol': 'BTC/EUR',
                                'base': 'BTC',
                                'quote': 'EUR',
                                'baseId': 'BTC',
                                'quoteId': 'EUR',
                                'maker': 0.0025,
                                'taker': 0.0025,
                                'type': 'spot',
                                'spot': true
                            },
                            'LTC/EUR': {
                                'id': 'LTCEUR',
                                'symbol': 'LTC/EUR',
                                'base': 'LTC',
                                'quote': 'EUR',
                                'baseId': 'LTC',
                                'quoteId': 'EUR',
                                'maker': 0.0025,
                                'taker': 0.0025,
                                'type': 'spot',
                                'spot': true
                            }
                        }
                    });
                }
                parseBalance(response) {
                    const data = this.safeValue(response, 'data', {});
                    const wallets = this.safeValue(data, 'wallets');
                    const result = {
                        'info': data
                    };
                    const codes = Object.keys(this.currencies);
                    for(let i = 0; i < codes.length; i++){
                        const code = codes[i];
                        const currency = this.currency(code);
                        const currencyId = currency['id'];
                        const wallet = this.safeValue(wallets, currencyId, {});
                        const available = this.safeValue(wallet, 'available', {});
                        const balance = this.safeValue(wallet, 'balance', {});
                        const account = this.account();
                        account['free'] = this.safeString(available, 'value');
                        account['total'] = this.safeString(balance, 'value');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGENMKTMoneyInfo(params);
                    return this.parseBalance(response);
                }
                parseBidAsk(bidask, priceKey = 0, amountKey = 1) {
                    const price = this.safeNumber(bidask, priceKey);
                    const size = this.safeNumber(bidask, amountKey);
                    return [
                        price / 100000.0,
                        size / 100000000.0
                    ];
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.publicGetMarketOrderbook(this.extend(request, params));
                    const orderbook = this.safeValue(response, 'data');
                    return this.parseOrderBook(orderbook, symbol, undefined, 'bids', 'asks', 'price_int', 'amount_int');
                }
                parseTicker(ticker, market) {
                    //
                    // {
                    //     "currency":"BTC",
                    //     "last":32654.55595,
                    //     "bid":32552.3642,
                    //     "ask":32703.58231,
                    //     "high":33500,
                    //     "low":31943,
                    //     "timestamp":1643372789,
                    //     "volume":{
                    //         "24h":2.27372413,
                    //         "30d":320.79375456
                    //     }
                    // }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.safeTimestamp(ticker, 'timestamp');
                    const last = this.safeString(ticker, 'last');
                    const volume = this.safeValue(ticker, 'volume', {});
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(volume, '24h'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const ticker = await this.publicGetMarketTicker(this.extend(request, params));
                    //
                    // {
                    //     "currency":"BTC",
                    //     "last":32654.55595,
                    //     "bid":32552.3642,
                    //     "ask":32703.58231,
                    //     "high":33500,
                    //     "low":31943,
                    //     "timestamp":1643372789,
                    //     "volume":{
                    //         "24h":2.27372413,
                    //         "30d":320.79375456
                    //     }
                    // }
                    //
                    return this.parseTicker(ticker, market);
                }
                parseTrade(trade, market) {
                    const id = this.safeString(trade, 'trade_id');
                    const timestamp = this.safeInteger(trade, 'date');
                    const price = this.safeString(trade, 'price_int');
                    const amount = this.safeString(trade, 'amount_int');
                    market = this.safeMarket(undefined, market);
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': undefined,
                        'side': undefined,
                        'order': undefined,
                        'takerOrMaker': undefined,
                        'price': Precise.stringDiv(price, '100000'),
                        'amount': Precise.stringDiv(amount, '100000000'),
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    const market = this.market(symbol);
                    const response = await this.publicGetMarketTrades(this.extend({
                        'market': market['id']
                    }, params));
                    const result = this.parseTrades(response['data']['trades'], market, since, limit);
                    return result;
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGENMKTMoneyInfo(params);
                    //
                    //     {
                    //         result: 'success',
                    //         data: {
                    //             user_id: '13396',
                    //             wallets: {
                    //                 BTC: {
                    //                     balance: {
                    //                         value_int: '0',
                    //                         display: '0.00000000 BTC',
                    //                         currency: 'BTC',
                    //                         value: '0.00000000',
                    //                         display_short: '0.00 BTC'
                    //                     },
                    //                     available: {
                    //                         value_int: '0',
                    //                         display: '0.00000000 BTC',
                    //                         currency: 'BTC',
                    //                         value: '0.00000000',
                    //                         display_short: '0.00 BTC'
                    //                     }
                    //                 },
                    //                 ...
                    //             },
                    //             trade_fee: '0.25'
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const feeString = this.safeString(data, 'trade_fee');
                    const fee = this.parseNumber(Precise.stringDiv(feeString, '100'));
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': data,
                            'symbol': symbol,
                            'maker': fee,
                            'taker': fee,
                            'percentage': true,
                            'tierBased': false
                        };
                    }
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    const market = this.market(symbol);
                    const order = {
                        'market': market['id'],
                        'amount_int': parseInt(amount * 100000000),
                        'fee_currency': market['quote'],
                        'type': side === 'buy' ? 'bid' : 'ask'
                    };
                    if (type === 'limit') order['price_int'] = parseInt(price * 100000.0);
                    const response = await this.privatePostMarketMoneyOrderAdd(this.extend(order, params));
                    const orderId = this.safeString(response['data'], 'order_id');
                    return {
                        'info': response,
                        'id': orderId
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'order_id': id
                    };
                    return await this.privatePostMarketMoneyOrderCancel(this.extend(request, params));
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const request = this.implodeParams(path, params);
                    let url = this.urls['api'] + '/' + this.version + '/' + request;
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce();
                        body = this.urlencode(this.extend({
                            'nonce': nonce
                        }, query));
                        const secret = this.base64ToBinary(this.secret);
                        // eslint-disable-next-line quotes
                        const auth = request + "\0" + body;
                        const signature = this.hmac(this.encode(auth), secret, 'sha512', 'base64');
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Rest-Key': this.apiKey,
                            'Rest-Sign': signature
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6
        }
    ],
    50: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, AuthenticationError: AuthenticationError, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            // ---------------------------------------------------------------------------
            module.exports = class blockchaincom extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'blockchaincom',
                        'secret': undefined,
                        'name': 'Blockchain.com',
                        'countries': [
                            'LX'
                        ],
                        'rateLimit': 500,
                        'version': 'v3',
                        'has': {
                            'CORS': false,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchCanceledOrders': true,
                            'fetchClosedOrders': true,
                            'fetchDeposit': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchL2OrderBook': true,
                            'fetchL3OrderBook': true,
                            'fetchLedger': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': false,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': false,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': true,
                            'fetchWithdrawals': true,
                            'fetchWithdrawalWhitelist': true,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': undefined,
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/147515585-1296e91b-7398-45e5-9d32-f6121538533f.jpeg',
                            'test': {
                                'public': 'https://testnet-api.delta.exchange',
                                'private': 'https://testnet-api.delta.exchange'
                            },
                            'api': {
                                'public': 'https://api.blockchain.com/v3/exchange',
                                'private': 'https://api.blockchain.com/v3/exchange'
                            },
                            'www': 'https://blockchain.com',
                            'doc': [
                                'https://api.blockchain.com/v3'
                            ],
                            'fees': 'https://exchange.blockchain.com/fees'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'tickers': 1,
                                    'tickers/{symbol}': 1,
                                    'symbols': 1,
                                    'symbols/{symbol}': 1,
                                    'l2/{symbol}': 1,
                                    'l3/{symbol}': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'fees': 1,
                                    'orders': 1,
                                    'orders/{orderId}': 1,
                                    'trades': 1,
                                    'fills': 1,
                                    'deposits': 1,
                                    'deposits/{depositId}': 1,
                                    'accounts': 1,
                                    'accounts/{account}/{currency}': 1,
                                    'whitelist': 1,
                                    'whitelist/{currency}': 1,
                                    'withdrawals': 1,
                                    'withdrawals/{withdrawalId}': 1
                                },
                                'post': {
                                    'orders': 1,
                                    'deposits/{currency}': 1,
                                    'withdrawals': 1
                                },
                                'delete': {
                                    'orders': 1,
                                    'orders/{orderId}': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': true,
                                'percentage': true,
                                'tiers': {
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.004')
                                        ],
                                        [
                                            this.parseNumber('10000'),
                                            this.parseNumber('0.0022')
                                        ],
                                        [
                                            this.parseNumber('50000'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('0.0018')
                                        ],
                                        [
                                            this.parseNumber('500000'),
                                            this.parseNumber('0.0018')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.0018')
                                        ],
                                        [
                                            this.parseNumber('2500000'),
                                            this.parseNumber('0.0018')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.0016')
                                        ],
                                        [
                                            this.parseNumber('25000000'),
                                            this.parseNumber('0.0014')
                                        ],
                                        [
                                            this.parseNumber('100000000'),
                                            this.parseNumber('0.0011')
                                        ],
                                        [
                                            this.parseNumber('500000000'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('1000000000'),
                                            this.parseNumber('0.0006')
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('10000'),
                                            this.parseNumber('0.0012')
                                        ],
                                        [
                                            this.parseNumber('50000'),
                                            this.parseNumber('0.001')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('500000'),
                                            this.parseNumber('0.0007000000000000001')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('2500000'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.0004')
                                        ],
                                        [
                                            this.parseNumber('25000000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('100000000'),
                                            this.parseNumber('0.0002')
                                        ],
                                        [
                                            this.parseNumber('500000000'),
                                            this.parseNumber('0.0001')
                                        ],
                                        [
                                            this.parseNumber('1000000000'),
                                            this.parseNumber('0')
                                        ]
                                    ]
                                }
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': false,
                            'secret': true
                        },
                        'precisionMode': TICK_SIZE,
                        'exceptions': {
                            'exact': {
                                '401': AuthenticationError,
                                '404': OrderNotFound
                            },
                            'broad': {}
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    //
                    //     "USDC-GBP": {
                    //         "base_currency": "USDC",
                    //         "base_currency_scale": 6,
                    //         "counter_currency": "GBP",
                    //         "counter_currency_scale": 2,
                    //         "min_price_increment": 10000,
                    //         "min_price_increment_scale": 8,
                    //         "min_order_size": 500000000,
                    //         "min_order_size_scale": 8,
                    //         "max_order_size": 0,
                    //         "max_order_size_scale": 8,
                    //         "lot_size": 10000,
                    //         "lot_size_scale": 8,
                    //         "status": "open",
                    //         "id": 68,
                    //         "auction_price": 0,
                    //         "auction_size": 0,
                    //         "auction_time": "",
                    //         "imbalance": 0
                    //     }
                    //
                    const markets = await this.publicGetSymbols(params);
                    const marketIds = Object.keys(markets);
                    const result = [];
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const market = this.safeValue(markets, marketId);
                        const baseId = this.safeString(market, 'base_currency');
                        const quoteId = this.safeString(market, 'counter_currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const numericId = this.safeNumber(market, 'id');
                        let active = undefined;
                        const marketState = this.safeString(market, 'status');
                        if (marketState === 'open') active = 'true';
                        else active = 'false';
                        // price precision
                        const minPriceIncrementString = this.safeString(market, 'min_price_increment');
                        const minPriceIncrementScaleString = this.safeString(market, 'min_price_increment_scale');
                        const minPriceScalePrecisionString = this.parsePrecision(minPriceIncrementScaleString);
                        const pricePrecisionString = Precise.stringMul(minPriceIncrementString, minPriceScalePrecisionString);
                        const pricePrecision = this.parseNumber(pricePrecisionString);
                        // amount precision
                        const lotSizeString = this.safeString(market, 'lot_size');
                        const lotSizeScaleString = this.safeString(market, 'lot_size_scale');
                        const lotSizeScalePrecisionString = this.parsePrecision(lotSizeScaleString);
                        const amountPrecisionString = Precise.stringMul(lotSizeString, lotSizeScalePrecisionString);
                        const amountPrecision = this.parseNumber(amountPrecisionString);
                        // minimum order size
                        const minOrderSizeString = this.safeString(market, 'min_order_size');
                        const minOrderSizeScaleString = this.safeString(market, 'min_order_size_scale');
                        const minOrderSizeScalePrecisionString = this.parsePrecision(minOrderSizeScaleString);
                        const minOrderSizePreciseString = Precise.stringMul(minOrderSizeString, minOrderSizeScalePrecisionString);
                        const minOrderSize = this.parseNumber(minOrderSizePreciseString);
                        // maximum order size
                        let maxOrderSize = undefined;
                        maxOrderSize = this.safeString(market, 'max_order_size');
                        if (maxOrderSize !== '0') {
                            const maxOrderSizeScaleString = this.safeString(market, 'max_order_size_scale');
                            const maxOrderSizeScalePrecisionString = this.parsePrecision(maxOrderSizeScaleString);
                            const maxOrderSizeString = Precise.stringMul(maxOrderSize, maxOrderSizeScalePrecisionString);
                            maxOrderSize = this.parseNumber(maxOrderSizeString);
                        } else maxOrderSize = undefined;
                        result.push({
                            'info': market,
                            'id': marketId,
                            'numericId': numericId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': active,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': amountPrecision,
                                'price': pricePrecision
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': minOrderSize,
                                    'max': maxOrderSize
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        });
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    return await this.fetchL3OrderBook(symbol, limit, params);
                }
                async fetchL3OrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['depth'] = limit;
                    const response = await this.publicGetL3Symbol(this.extend(request, params));
                    return this.parseOrderBook(response, symbol, undefined, 'bids', 'asks', 'px', 'qty');
                }
                async fetchL2OrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['depth'] = limit;
                    const response = await this.publicGetL2Symbol(this.extend(request, params));
                    return this.parseOrderBook(response, symbol, undefined, 'bids', 'asks', 'px', 'qty');
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //     "symbol": "BTC-USD",
                    //     "price_24h": 47791.86,
                    //     "volume_24h": 362.88635738,
                    //     "last_trade_price": 47587.75
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const last = this.safeString(ticker, 'last_trade_price');
                    const baseVolume = this.safeString(ticker, 'volume_24h');
                    const open = this.safeString(ticker, 'price_24h');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'high': undefined,
                        'low': undefined,
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': undefined,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetTickersSymbol(this.extend(request, params));
                    return this.parseTicker(response, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const tickers = await this.publicGetTickers(params);
                    return this.parseTickers(tickers, symbols);
                }
                parseOrderState(state) {
                    const states = {
                        'OPEN': 'open',
                        'REJECTED': 'rejected',
                        'FILLED': 'closed',
                        'CANCELED': 'canceled',
                        'PART_FILLED': 'open',
                        'EXPIRED': 'expired'
                    };
                    return this.safeString(states, state, state);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         clOrdId: '00001',
                    //         ordType: 'MARKET',
                    //         ordStatus: 'FILLED',
                    //         side: 'BUY',
                    //         symbol: 'USDC-USDT',
                    //         exOrdId: '281775861306290',
                    //         price: null,
                    //         text: 'Fill',
                    //         lastShares: '30.0',
                    //         lastPx: '0.9999',
                    //         leavesQty: '0.0',
                    //         cumQty: '30.0',
                    //         avgPx: '0.9999',
                    //         timestamp: '1633940339619'
                    //     }
                    //
                    const clientOrderId = this.safeString(order, 'clOrdId');
                    const type = this.safeStringLower(order, 'ordType');
                    const statusId = this.safeString(order, 'ordStatus');
                    const state = this.parseOrderState(statusId);
                    const side = this.safeStringLower(order, 'side');
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const exchangeOrderId = this.safeString(order, 'exOrdId');
                    const price = type !== 'market' ? this.safeString(order, 'price') : undefined;
                    const average = this.safeNumber(order, 'avgPx');
                    const timestamp = this.safeInteger(order, 'timestamp');
                    const datetime = this.iso8601(timestamp);
                    const filled = this.safeString(order, 'cumQty');
                    const remaining = this.safeString(order, 'leavesQty');
                    const result = this.safeOrder({
                        'id': exchangeOrderId,
                        'clientOrderId': clientOrderId,
                        'datetime': datetime,
                        'timestamp': timestamp,
                        'lastTradeTimestamp': undefined,
                        'status': state,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'side': side,
                        'price': price,
                        'average': average,
                        'amount': undefined,
                        'filled': filled,
                        'remaining': remaining,
                        'cost': undefined,
                        'trades': [],
                        'fees': {},
                        'info': order
                    });
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const orderType = this.safeString(params, 'ordType', type);
                    const uppercaseOrderType = orderType.toUpperCase();
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'clOrdId', this.uuid16());
                    params = this.omit(params, [
                        'ordType',
                        'clientOrderId',
                        'clOrdId'
                    ]);
                    const request = {
                        // 'stopPx' : limit price
                        // 'timeInForce' : "GTC" for Good Till Cancel, "IOC" for Immediate or Cancel, "FOK" for Fill or Kill, "GTD" Good Till Date
                        // 'expireDate' : expiry date in the format YYYYMMDD
                        // 'minQty' : The minimum quantity required for an IOC fill
                        'ordType': uppercaseOrderType,
                        'symbol': market['id'],
                        'side': side.toUpperCase(),
                        'orderQty': this.amountToPrecision(symbol, amount),
                        'clOrdId': clientOrderId
                    };
                    const stopPrice = this.safeValue2(params, 'stopPx', 'stopPrice');
                    params = this.omit(params, [
                        'stopPx',
                        'stopPrice'
                    ]);
                    if (uppercaseOrderType === 'STOP' || uppercaseOrderType === 'STOPLIMIT') {
                        if (stopPrice === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a stopPx or stopPrice param for a ' + uppercaseOrderType + ' order');
                    }
                    if (stopPrice !== undefined) {
                        if (uppercaseOrderType === 'MARKET') request['ordType'] = 'STOP';
                        else if (uppercaseOrderType === 'LIMIT') request['ordType'] = 'STOPLIMIT';
                    }
                    let priceRequired = false;
                    let stopPriceRequired = false;
                    if (request['ordType'] === 'LIMIT' || request['ordType'] === 'STOPLIMIT') priceRequired = true;
                    if (request['ordType'] === 'STOP' || request['ordType'] === 'STOPLIMIT') stopPriceRequired = true;
                    if (priceRequired) request['price'] = this.priceToPrecision(symbol, price);
                    if (stopPriceRequired) request['stopPx'] = this.priceToPrecision(symbol, stopPrice);
                    const response = await this.privatePostOrders(this.extend(request, params));
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'orderId': id
                    };
                    const response = await this.privateDeleteOrdersOrderId(this.extend(request, params));
                    return {
                        'id': id,
                        'info': response
                    };
                }
                async cancelOrders(ids, symbol, params = {}) {
                    // cancels all open orders if no symbol specified
                    // cancels all open orders of specified symbol, if symbol is specified
                    await this.loadMarkets();
                    const request = {
                    };
                    if (symbol !== undefined) {
                        const marketId = this.marketId(symbol);
                        request['symbol'] = marketId;
                    }
                    const response = await this.privateDeleteOrders(this.extend(request, params));
                    return {
                        'symbol': symbol,
                        'info': response
                    };
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetFees(params);
                    //
                    //     {
                    //         makerRate: "0.002",
                    //         takerRate: "0.004",
                    //         volumeInUSD: "0.0"
                    //     }
                    //
                    const makerFee = this.safeNumber(response, 'makerRate');
                    const takerFee = this.safeNumber(response, 'takerRate');
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': makerFee,
                            'taker': takerFee
                        };
                    }
                    return result;
                }
                async fetchCanceledOrders(symbol, since, limit, params = {}) {
                    const state = 'CANCELED';
                    return await this.fetchOrdersByState(state, symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const state = 'FILLED';
                    return await this.fetchOrdersByState(state, symbol, since, limit, params);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const state = 'OPEN';
                    return await this.fetchOrdersByState(state, symbol, since, limit, params);
                }
                async fetchOrdersByState(state, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        // 'to': unix epoch ms
                        // 'from': unix epoch ms
                        'status': state,
                        'limit': 100
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const response = await this.privateGetOrders(this.extend(request, params));
                    return this.parseOrders(response, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    //     {
                    //         "exOrdId":281685751028507,
                    //         "tradeId":281685434947633,
                    //         "execId":8847494003,
                    //         "side":"BUY",
                    //         "symbol":"AAVE-USDT",
                    //         "price":405.34,
                    //         "qty":0.1,
                    //         "fee":0.162136,
                    //         "timestamp":1634559249687
                    //     }
                    //
                    const orderId = this.safeString(trade, 'exOrdId');
                    const tradeId = this.safeString(trade, 'tradeId');
                    const side = this.safeString(trade, 'side').toLowerCase();
                    const marketId = this.safeString(trade, 'symbol');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'qty');
                    const timestamp = this.safeInteger(trade, 'timestamp');
                    const datetime = this.iso8601(timestamp);
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) {
                        const feeCurrency = market['quote'];
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrency
                        };
                    }
                    return this.safeTrade({
                        'id': tradeId,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'symbol': symbol,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (limit !== undefined) request['limit'] = limit;
                    let market = undefined;
                    if (symbol !== undefined) {
                        request['symbol'] = this.marketId(symbol);
                        market = this.market(symbol);
                    }
                    const trades = await this.privateGetFills(this.extend(request, params));
                    return this.parseTrades(trades, market, since, limit, params); // need to define
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privatePostDepositsCurrency(this.extend(request, params));
                    const rawAddress = this.safeString(response, 'address');
                    let tag = undefined;
                    let address = undefined;
                    if (rawAddress !== undefined) // if a tag or memo is used it is separated by a colon in the 'address' value
                    [address, tag] = rawAddress.split(':');
                    const result = {
                        'info': response
                    };
                    result['currency'] = currency['code'];
                    result['address'] = address;
                    if (tag !== undefined) result['tag'] = tag;
                    return result;
                }
                parseTransactionState(state) {
                    const states = {
                        'COMPLETED': 'ok',
                        'REJECTED': 'failed',
                        'PENDING': 'pending',
                        'FAILED': 'failed',
                        'REFUNDED': 'refunded'
                    };
                    return this.safeString(states, state, state);
                }
                parseTransaction(transaction, currency) {
                    //
                    // deposit
                    //
                    //     {
                    //         "depositId":"748e9180-be0d-4a80-e175-0156150efc95",
                    //         "amount":0.009,
                    //         "currency":"ETH",
                    //         "address":"0xEC6B5929D454C8D9546d4221ace969E1810Fa92c",
                    //         "state":"COMPLETED",
                    //         "txHash":"582114562140e51a80b481c2dfebaf62b4ab9769b8ff54820bb67e34d4a3ab0c",
                    //         "timestamp":1633697196241
                    //     }
                    //
                    // withdrawal
                    //
                    //     {
                    //         "amount":30.0,
                    //         "currency":"USDT",
                    //         "beneficiary":"cab00d11-6e7f-46b7-b453-2e8ef6f101fa", // blockchain specific id
                    //         "withdrawalId":"99df5ef7-eab6-4033-be49-312930fbd1ea",
                    //         "fee":34.005078,
                    //         "state":"COMPLETED",
                    //         "timestamp":1634218452549
                    //     }
                    //
                    let type = undefined;
                    let id = undefined;
                    const amount = this.safeNumber(transaction, 'amount');
                    const timestamp = this.safeInteger(transaction, 'timestamp');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const state = this.safeString(transaction, 'state');
                    if ('depositId' in transaction) {
                        type = 'deposit';
                        id = this.safeString(transaction, 'depositId');
                    } else if ('withdrawalId' in transaction) {
                        type = 'withdrawal';
                        id = this.safeString(transaction, 'withdrawalId');
                    }
                    const feeCost = type === 'withdrawal' ? this.safeNumber(transaction, 'fee') : undefined;
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'currency': code,
                        'cost': feeCost
                    };
                    const address = this.safeString(transaction, 'address');
                    const txid = this.safeString(transaction, 'txhash');
                    const result = {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': address,
                        'addressTo': address,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': this.parseTransactionState(state),
                        'updated': undefined,
                        'comment': undefined,
                        'fee': fee
                    };
                    return result;
                }
                async fetchWithdrawalWhitelist(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetWhitelist();
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        result.push({
                            'beneficiaryId': this.safeString(entry, 'whitelistId'),
                            'name': this.safeString(entry, 'name'),
                            'currency': this.safeString(entry, 'currency'),
                            'info': entry
                        });
                    }
                    return result;
                }
                async fetchWithdrawalWhitelistByCurrency(currency, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'currency': this.currencyId(currency)
                    };
                    const response = await this.privateGetWhitelistCurrency(this.extend(request, params));
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        result.push({
                            'beneficiaryId': this.safeString(entry, 'whitelistId'),
                            'name': this.safeString(entry, 'name'),
                            'currency': this.safeString(entry, 'currency'),
                            'info': entry
                        });
                    }
                    return result;
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'amount': amount,
                        'currency': currency['id'],
                        // 'beneficiary': address/id,
                        'sendMax': false
                    };
                    const response = await this.privatePostWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         amount: "30.0",
                    //         currency: "USDT",
                    //         beneficiary: "adcd43fb-9ba6-41f7-8c0d-7013482cb88f",
                    //         withdrawalId: "99df5ef7-eab6-4033-be49-312930fbd1ea",
                    //         fee: "34.005078",
                    //         state: "PENDING",
                    //         timestamp: "1634218452595"
                    //     },
                    //
                    return this.parseTransaction(response, currency);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    if (since !== undefined) request['from'] = since;
                    const response = await this.privateGetWithdrawals(this.extend(request, params));
                    return this.parseTransactions(response, code, since, limit);
                }
                async fetchWithdrawal(id, code, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'withdrawalId': id
                    };
                    const response = await this.privateGetWithdrawalsWithdrawalId(this.extend(request, params));
                    return this.parseTransaction(response);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    if (since !== undefined) request['from'] = since;
                    const response = await this.privateGetDeposits(this.extend(request, params));
                    return this.parseTransactions(response, code, since, limit);
                }
                async fetchDeposit(id, code, params = {}) {
                    await this.loadMarkets();
                    const depositId = this.safeString(params, 'depositId', id);
                    const request = {
                        'depositId': depositId
                    };
                    const deposit = await this.privateGetDepositsDepositId(this.extend(request, params));
                    return this.parseTransaction(deposit);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const accountName = this.safeString(params, 'account', 'primary');
                    params = this.omit(params, 'account');
                    const request = {
                        'account': accountName
                    };
                    const response = await this.privateGetAccounts(this.extend(request, params));
                    //
                    //     {
                    //         "primary": [
                    //             {
                    //                 "currency":"ETH",
                    //                 "balance":0.009,
                    //                 "available":0.009,
                    //                 "balance_local":30.82869,
                    //                 "available_local":30.82869,
                    //                 "rate":3425.41
                    //             },
                    //             ...
                    //         ]
                    //     }
                    //
                    const balances = this.safeValue(response, accountName);
                    if (balances === undefined) throw new ExchangeError1(this.id + ' fetchBalance() could not find the "' + accountName + '" account');
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < balances.length; i++){
                        const entry = balances[i];
                        const currencyId = this.safeString(entry, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(entry, 'available');
                        account['total'] = this.safeString(entry, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchOrder(id, symbol, params = {}) {
                    // note: only works with exchange-order-id
                    // does not work with clientOrderId
                    await this.loadMarkets();
                    const request = {
                        'orderId': id
                    };
                    const response = await this.privateGetOrdersOrderId(this.extend(request, params));
                    //
                    //     {
                    //         "exOrdId": 11111111,
                    //         "clOrdId": "ABC",
                    //         "ordType": "MARKET",
                    //         "ordStatus": "FILLED",
                    //         "side": "BUY",
                    //         "price": 0.12345,
                    //         "text": "string",
                    //         "symbol": "BTC-USD",
                    //         "lastShares": 0.5678,
                    //         "lastPx": 3500.12,
                    //         "leavesQty": 10,
                    //         "cumQty": 0.123345,
                    //         "avgPx": 345.33,
                    //         "timestamp": 1592830770594
                    //     }
                    //
                    return this.parseOrder(response);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const requestPath = '/' + this.implodeParams(path, params);
                    let url = this.urls['api'][api] + requestPath;
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'private') {
                        this.checkRequiredCredentials();
                        headers = {
                            'X-API-Token': this.secret
                        };
                        if (method === 'GET') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else {
                            body = this.json(query);
                            headers['Content-Type'] = 'application/json';
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    // {"timestamp":"2021-10-21T15:13:58.837+00:00","status":404,"error":"Not Found","message":"","path":"/orders/505050"
                    if (response === undefined) return;
                    const text = this.safeString(response, 'text');
                    if (text !== undefined) {
                        if (text === 'Insufficient Balance') throw new InsufficientFunds(this.id + ' ' + body);
                    }
                    const errorCode = this.safeString(response, 'status');
                    const errorMessage = this.safeString(response, 'error');
                    if (code !== undefined) {
                        const feedback = this.id + ' ' + this.json(response);
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], errorMessage, feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    51: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, AuthenticationError: AuthenticationError, DDoSProtection: DDoSProtection, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class btcalpha extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'btcalpha',
                        'name': 'BTC-Alpha',
                        'countries': [
                            'US'
                        ],
                        'version': 'v1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchDeposit': false,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': undefined,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': false
                        },
                        'timeframes': {
                            '1m': '1',
                            '5m': '5',
                            '15m': '15',
                            '30m': '30',
                            '1h': '60',
                            '4h': '240',
                            '1d': 'D'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/42625213-dabaa5da-85cf-11e8-8f99-aa8f8f7699f0.jpg',
                            'api': 'https://btc-alpha.com/api',
                            'www': 'https://btc-alpha.com',
                            'doc': 'https://btc-alpha.github.io/api-docs',
                            'fees': 'https://btc-alpha.com/fees/',
                            'referral': 'https://btc-alpha.com/?r=123788'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'currencies/',
                                    'pairs/',
                                    'orderbook/{pair_name}/',
                                    'exchanges/',
                                    'charts/{pair}/{type}/chart/'
                                ]
                            },
                            'private': {
                                'get': [
                                    'wallets/',
                                    'orders/own/',
                                    'order/{id}/',
                                    'exchanges/own/',
                                    'deposits/',
                                    'withdraws/'
                                ],
                                'post': [
                                    'order/',
                                    'order-cancel/'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.002'),
                                'taker': this.parseNumber('0.002')
                            },
                            'funding': {
                                'withdraw': {}
                            }
                        },
                        'commonCurrencies': {
                            'CBC': 'Cashbery'
                        },
                        'exceptions': {
                            'exact': {},
                            'broad': {
                                'Out of balance': InsufficientFunds
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetPairs(params);
                    //
                    //    [
                    //        {
                    //            "name": "1INCH_USDT",
                    //            "currency1": "1INCH",
                    //            "currency2": "USDT",
                    //            "price_precision": 4,
                    //            "amount_precision": 2,
                    //            "minimum_order_size": "0.01000000",
                    //            "maximum_order_size": "900000.00000000",
                    //            "minimum_order_value": "10.00000000",
                    //            "liquidity_type": 10
                    //        },
                    //    ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'name');
                        const baseId = this.safeString(market, 'currency1');
                        const quoteId = this.safeString(market, 'currency2');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const pricePrecision = this.safeString(market, 'price_precision');
                        const priceLimit = this.parsePrecision(pricePrecision);
                        const amountLimit = this.safeString(market, 'minimum_order_size');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': parseInt('8'),
                                'price': parseInt(pricePrecision)
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.parseNumber(amountLimit),
                                    'max': this.safeNumber(market, 'maximum_order_size')
                                },
                                'price': {
                                    'min': this.parseNumber(priceLimit),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.parseNumber(Precise.stringMul(priceLimit, amountLimit)),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'pair_name': this.marketId(symbol)
                    };
                    if (limit) {
                        request['limit_sell'] = limit;
                        request['limit_buy'] = limit;
                    }
                    const response = await this.publicGetOrderbookPairName(this.extend(request, params));
                    return this.parseOrderBook(response, symbol, undefined, 'buy', 'sell', 'price', 'amount');
                }
                parseBidsAsks(bidasks, priceKey = 0, amountKey = 1) {
                    const result = [];
                    for(let i = 0; i < bidasks.length; i++){
                        const bidask = bidasks[i];
                        if (bidask) result.push(this.parseBidAsk(bidask, priceKey, amountKey));
                    }
                    return result;
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "id": "202203440",
                    //          "timestamp": "1637856276.264215",
                    //          "pair": "AAVE_USDT",
                    //          "price": "320.79900000",
                    //          "amount": "0.05000000",
                    //          "type": "buy"
                    //      }
                    //
                    // fetchMyTrades (private)
                    //
                    //      {
                    //          "id": "202203440",
                    //          "timestamp": "1637856276.264215",
                    //          "pair": "AAVE_USDT",
                    //          "price": "320.79900000",
                    //          "amount": "0.05000000",
                    //          "type": "buy",
                    //          "my_side": "buy"
                    //      }
                    //
                    const marketId = this.safeString(trade, 'pair');
                    market = this.safeMarket(marketId, market, '_');
                    const timestamp = this.safeTimestamp(trade, 'timestamp');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const id = this.safeString(trade, 'id');
                    const side = this.safeString2(trade, 'my_side', 'type');
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': id,
                        'type': 'limit',
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['pair'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    const trades = await this.publicGetExchanges(this.extend(request, params));
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetDeposits(params);
                    //
                    //     [
                    //         {
                    //             "timestamp": 1485363039.18359,
                    //             "id": 317,
                    //             "currency": "BTC",
                    //             "amount": 530.00000000
                    //         }
                    //     ]
                    //
                    return this.parseTransactions(response, code, since, limit, {
                        'type': 'deposit'
                    });
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency_id'] = currency['id'];
                    }
                    const response = await this.privateGetWithdraws(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id": 403,
                    //             "timestamp": 1485363466.868539,
                    //             "currency": "BTC",
                    //             "amount": 0.53000000,
                    //             "status": 20
                    //         }
                    //     ]
                    //
                    return this.parseTransactions(response, code, since, limit, {
                        'type': 'withdrawal'
                    });
                }
                parseTransaction(transaction, currency) {
                    //
                    //  deposit
                    //      {
                    //          "timestamp": 1485363039.18359,
                    //          "id": 317,
                    //          "currency": "BTC",
                    //          "amount": 530.00000000
                    //      }
                    //
                    //  withdrawal
                    //      {
                    //          "id": 403,
                    //          "timestamp": 1485363466.868539,
                    //          "currency": "BTC",
                    //          "amount": 0.53000000,
                    //          "status": 20
                    //      }
                    //
                    let timestamp = this.safeString(transaction, 'timestamp');
                    timestamp = Precise.stringMul(timestamp, '1000');
                    const currencyId = this.safeString(transaction, 'currency');
                    const statusId = this.safeString(transaction, 'status');
                    return {
                        'id': this.safeString(transaction, 'id'),
                        'info': transaction,
                        'timestamp': this.parseNumber(timestamp),
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'currency': this.safeCurrencyCode(currencyId, currency),
                        'amount': this.safeNumber(transaction, 'amount'),
                        'txid': undefined,
                        'type': undefined,
                        'status': this.parseTransactionStatus(statusId),
                        'comment': undefined,
                        'fee': undefined,
                        'updated': undefined
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        '10': 'pending',
                        '20': 'pending',
                        '30': 'ok',
                        '40': 'failed',
                        '50': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "time":1591296000,
                    //         "open":0.024746,
                    //         "close":0.024728,
                    //         "low":0.024728,
                    //         "high":0.024753,
                    //         "volume":16.624
                    //     }
                    //
                    return [
                        this.safeTimestamp(ohlcv, 'time'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '5m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'type': this.timeframes[timeframe]
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['since'] = parseInt(since / 1000);
                    const response = await this.publicGetChartsPairTypeChart(this.extend(request, params));
                    //
                    //     [
                    //         {"time":1591296000,"open":0.024746,"close":0.024728,"low":0.024728,"high":0.024753,"volume":16.624},
                    //         {"time":1591295700,"open":0.024718,"close":0.02475,"low":0.024711,"high":0.02475,"volume":31.645},
                    //         {"time":1591295400,"open":0.024721,"close":0.024717,"low":0.024711,"high":0.02473,"volume":65.071}
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['used'] = this.safeString(balance, 'reserve');
                        account['total'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetWallets(params);
                    return this.parseBalance(response);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '1': 'open',
                        '2': 'canceled',
                        '3': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // fetchClosedOrders / fetchOrder
                    //     {
                    //       "id": "923763073",
                    //       "date": "1635451090368",
                    //       "type": "sell",
                    //       "pair": "XRP_USDT",
                    //       "price": "1.00000000",
                    //       "amount": "0.00000000",
                    //       "status": "3",
                    //       "amount_filled": "10.00000000",
                    //       "amount_original": "10.0"
                    //       "trades": [],
                    //     }
                    //
                    // createOrder
                    //     {
                    //       "success": true,
                    //       "date": "1635451754.497541",
                    //       "type": "sell",
                    //       "oid": "923776755",
                    //       "price": "1.0",
                    //       "amount": "10.0",
                    //       "amount_filled": "0.0",
                    //       "amount_original": "10.0",
                    //       "trades": []
                    //     }
                    //
                    const marketId = this.safeString(order, 'pair');
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    const success = this.safeValue(order, 'success', false);
                    let timestamp = undefined;
                    if (success) timestamp = this.safeTimestamp(order, 'date');
                    else timestamp = this.safeInteger(order, 'date');
                    const price = this.safeString(order, 'price');
                    const remaining = this.safeString(order, 'amount');
                    const filled = this.safeString(order, 'amount_filled');
                    const amount = this.safeString(order, 'amount_original');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const id = this.safeString2(order, 'oid', 'id');
                    const trades = this.safeValue(order, 'trades');
                    const side = this.safeString2(order, 'my_side', 'type');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'status': status,
                        'symbol': symbol,
                        'type': 'limit',
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'trades': trades,
                        'fee': undefined,
                        'info': order,
                        'lastTradeTimestamp': undefined,
                        'average': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'type': side,
                        'amount': amount,
                        'price': this.priceToPrecision(symbol, price)
                    };
                    const response = await this.privatePostOrder(this.extend(request, params));
                    if (!response['success']) throw new InvalidOrder(this.id + ' ' + this.json(response));
                    const order = this.parseOrder(response, market);
                    amount = order['amount'] > 0 ? order['amount'] : amount;
                    return this.extend(order, {
                        'amount': amount
                    });
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'order': id
                    };
                    const response = await this.privatePostOrderCancel(this.extend(request, params));
                    return response;
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const order = await this.privateGetOrderId(this.extend(request, params));
                    return this.parseOrder(order);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['pair'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    const orders = await this.privateGetOrdersOwn(this.extend(request, params));
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': '1'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': '3'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        request['pair'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    const trades = await this.privateGetExchangesOwn(this.extend(request, params));
                    return this.parseTrades(trades, undefined, since, limit);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const query = this.urlencode(this.keysort(this.omit(params, this.extractParams(path))));
                    let url = this.urls['api'] + '/';
                    if (path !== 'charts/{pair}/{type}/chart/') url += 'v1/';
                    url += this.implodeParams(path, params);
                    headers = {
                        'Accept': 'application/json'
                    };
                    if (api === 'public') {
                        if (query.length) url += '?' + query;
                    } else {
                        this.checkRequiredCredentials();
                        let payload = this.apiKey;
                        if (method === 'POST') {
                            headers['Content-Type'] = 'application/x-www-form-urlencoded';
                            body = query;
                            payload += body;
                        } else if (query.length) url += '?' + query;
                        headers['X-KEY'] = this.apiKey;
                        headers['X-SIGN'] = this.hmac(this.encode(payload), this.encode(this.secret));
                        headers['X-NONCE'] = this.nonce().toString();
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //     {"date":1570599531.4814300537,"error":"Out of balance -9.99243661 BTC"}
                    //
                    const error = this.safeString(response, 'error');
                    const feedback = this.id + ' ' + body;
                    if (error !== undefined) {
                        this.throwExactlyMatchedException(this.exceptions['exact'], error, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], error, feedback);
                    }
                    if (code === 401 || code === 403) throw new AuthenticationError(feedback);
                    else if (code === 429) throw new DDoSProtection(feedback);
                    if (code < 400) return;
                    throw new ExchangeError1(feedback);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    52: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, AuthenticationError: AuthenticationError, PermissionDenied: PermissionDenied, InvalidNonce: InvalidNonce, OrderNotFound: OrderNotFound, DDoSProtection: DDoSProtection } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class btcbox extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'btcbox',
                        'name': 'BtcBox',
                        'countries': [
                            'JP'
                        ],
                        'rateLimit': 1000,
                        'version': 'v1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkOHLCV': false,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': undefined,
                            'fetchTrades': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87327317-98c55400-c53c-11ea-9a11-81f7d951cc74.jpg',
                            'api': 'https://www.btcbox.co.jp/api',
                            'www': 'https://www.btcbox.co.jp/',
                            'doc': 'https://blog.btcbox.jp/en/archives/8762',
                            'fees': 'https://support.btcbox.co.jp/hc/en-us/articles/360001235694-Fees-introduction'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'depth',
                                    'orders',
                                    'ticker'
                                ]
                            },
                            'private': {
                                'post': [
                                    'balance',
                                    'trade_add',
                                    'trade_cancel',
                                    'trade_list',
                                    'trade_view',
                                    'wallet'
                                ]
                            }
                        },
                        'markets': {
                            'BTC/JPY': {
                                'id': 'btc',
                                'symbol': 'BTC/JPY',
                                'base': 'BTC',
                                'quote': 'JPY',
                                'baseId': 'btc',
                                'quoteId': 'jpy',
                                'taker': 0.0005,
                                'maker': 0.0005,
                                'type': 'spot',
                                'spot': true
                            },
                            'ETH/JPY': {
                                'id': 'eth',
                                'symbol': 'ETH/JPY',
                                'base': 'ETH',
                                'quote': 'JPY',
                                'baseId': 'eth',
                                'quoteId': 'jpy',
                                'taker': 0.001,
                                'maker': 0.001,
                                'type': 'spot',
                                'spot': true
                            },
                            'LTC/JPY': {
                                'id': 'ltc',
                                'symbol': 'LTC/JPY',
                                'base': 'LTC',
                                'quote': 'JPY',
                                'baseId': 'ltc',
                                'quoteId': 'jpy',
                                'taker': 0.001,
                                'maker': 0.001,
                                'type': 'spot',
                                'spot': true
                            },
                            'BCH/JPY': {
                                'id': 'bch',
                                'symbol': 'BCH/JPY',
                                'base': 'BCH',
                                'quote': 'JPY',
                                'baseId': 'bch',
                                'quoteId': 'jpy',
                                'taker': 0.001,
                                'maker': 0.001,
                                'type': 'spot',
                                'spot': true
                            }
                        },
                        'exceptions': {
                            '104': AuthenticationError,
                            '105': PermissionDenied,
                            '106': InvalidNonce,
                            '107': InvalidOrder,
                            '200': InsufficientFunds,
                            '201': InvalidOrder,
                            '202': InvalidOrder,
                            '203': OrderNotFound,
                            '401': OrderNotFound,
                            '402': DDoSProtection
                        }
                    });
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const codes = Object.keys(this.currencies);
                    for(let i = 0; i < codes.length; i++){
                        const code = codes[i];
                        const currency = this.currency(code);
                        const currencyId = currency['id'];
                        const free = currencyId + '_balance';
                        if (free in response) {
                            const account = this.account();
                            const used = currencyId + '_lock';
                            account['free'] = this.safeString(response, free);
                            account['used'] = this.safeString(response, used);
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostBalance(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {};
                    const numSymbols = this.symbols.length;
                    if (numSymbols > 1) request['coin'] = market['baseId'];
                    const response = await this.publicGetDepth(this.extend(request, params));
                    return this.parseOrderBook(response, symbol);
                }
                parseTicker(ticker, market) {
                    const timestamp = this.milliseconds();
                    const symbol = this.safeSymbol(undefined, market);
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'vol'),
                        'quoteVolume': this.safeString(ticker, 'volume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {};
                    const numSymbols = this.symbols.length;
                    if (numSymbols > 1) request['coin'] = market['baseId'];
                    const response = await this.publicGetTicker(this.extend(request, params));
                    return this.parseTicker(response, market);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "date":"0",
                    //          "price":3,
                    //          "amount":0.1,
                    //          "tid":"1",
                    //          "type":"buy"
                    //      }
                    //
                    const timestamp = this.safeTimestamp(trade, 'date');
                    market = this.safeMarket(undefined, market);
                    const id = this.safeString(trade, 'tid');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const type = undefined;
                    const side = this.safeString(trade, 'type');
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': type,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {};
                    const numSymbols = this.symbols.length;
                    if (numSymbols > 1) request['coin'] = market['baseId'];
                    const response = await this.publicGetOrders(this.extend(request, params));
                    //
                    //     [
                    //          {
                    //              "date":"0",
                    //              "price":3,
                    //              "amount":0.1,
                    //              "tid":"1",
                    //              "type":"buy"
                    //          },
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'amount': amount,
                        'price': price,
                        'type': side,
                        'coin': market['baseId']
                    };
                    const response = await this.privatePostTradeAdd(this.extend(request, params));
                    //
                    //     {
                    //         "result":true,
                    //         "id":"11"
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    // a special case for btcbox – default symbol is BTC/JPY
                    if (symbol === undefined) symbol = 'BTC/JPY';
                    const market = this.market(symbol);
                    const request = {
                        'id': id,
                        'coin': market['baseId']
                    };
                    const response = await this.privatePostTradeCancel(this.extend(request, params));
                    //
                    //     {"result":true, "id":"11"}
                    //
                    return this.parseOrder(response, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        // TODO: complete list
                        'part': 'open',
                        'all': 'closed',
                        'cancelled': 'canceled',
                        'closed': 'closed',
                        'no': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "id":11,
                    //         "datetime":"2014-10-21 10:47:20",
                    //         "type":"sell",
                    //         "price":42000,
                    //         "amount_original":1.2,
                    //         "amount_outstanding":1.2,
                    //         "status":"closed",
                    //         "trades":[] // no clarification of trade value structure of order endpoint
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const datetimeString = this.safeString(order, 'datetime');
                    let timestamp = undefined;
                    if (datetimeString !== undefined) timestamp = this.parse8601(order['datetime'] + '+09:00'); // Tokyo time
                    const amount = this.safeString(order, 'amount_original');
                    const remaining = this.safeString(order, 'amount_outstanding');
                    const price = this.safeString(order, 'price');
                    // status is set by fetchOrder method only
                    let status = this.parseOrderStatus(this.safeString(order, 'status'));
                    // fetchOrders do not return status, use heuristic
                    if (status === undefined) {
                        if (Precise.stringEquals(remaining, '0')) status = 'closed';
                    }
                    const trades = undefined; // todo: this.parseTrades (order['trades']);
                    market = this.safeMarket(undefined, market);
                    const side = this.safeString(order, 'type');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'amount': amount,
                        'remaining': remaining,
                        'filled': undefined,
                        'side': side,
                        'type': undefined,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'status': status,
                        'symbol': market['symbol'],
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'trades': trades,
                        'fee': undefined,
                        'info': order,
                        'average': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    // a special case for btcbox – default symbol is BTC/JPY
                    if (symbol === undefined) symbol = 'BTC/JPY';
                    const market = this.market(symbol);
                    const request = this.extend({
                        'id': id,
                        'coin': market['baseId']
                    }, params);
                    const response = await this.privatePostTradeView(this.extend(request, params));
                    //
                    //      {
                    //          "id":11,
                    //          "datetime":"2014-10-21 10:47:20",
                    //          "type":"sell",
                    //          "price":42000,
                    //          "amount_original":1.2,
                    //          "amount_outstanding":1.2,
                    //          "status":"closed",
                    //          "trades":[]
                    //      }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchOrdersByType(type, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    // a special case for btcbox – default symbol is BTC/JPY
                    if (symbol === undefined) symbol = 'BTC/JPY';
                    const market = this.market(symbol);
                    const request = {
                        'type': type,
                        'coin': market['baseId']
                    };
                    const response = await this.privatePostTradeList(this.extend(request, params));
                    //
                    // [
                    //      {
                    //          "id":"7",
                    //          "datetime":"2014-10-20 13:27:38",
                    //          "type":"buy",
                    //          "price":42750,
                    //          "amount_original":0.235,
                    //          "amount_outstanding":0.235
                    //      },
                    // ]
                    //
                    const orders = this.parseOrders(response, market, since, limit);
                    // status (open/closed/canceled) is undefined
                    // btcbox does not return status, but we know it's 'open' as we queried for open orders
                    if (type === 'open') for(let i = 0; i < orders.length; i++)orders[i]['status'] = 'open';
                    return orders;
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByType('all', symbol, since, limit, params);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByType('open', symbol, since, limit, params);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + this.version + '/' + path;
                    if (api === 'public') {
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const query = this.extend({
                            'key': this.apiKey,
                            'nonce': nonce
                        }, params);
                        const request = this.urlencode(query);
                        const secret = this.hash(this.encode(this.secret));
                        query['signature'] = this.hmac(this.encode(request), this.encode(secret));
                        body = this.urlencode(query);
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // resort to defaultErrorHandler
                    // typical error response: {"result":false,"code":"401"}
                    if (httpCode >= 400) return; // resort to defaultErrorHandler
                    const result = this.safeValue(response, 'result');
                    if (result === undefined || result === true) return; // either public API (no error codes expected) or success
                    const code = this.safeValue(response, 'code');
                    const feedback = this.id + ' ' + body;
                    this.throwExactlyMatchedException(this.exceptions, code, feedback);
                    throw new ExchangeError1(feedback); // unknown message
                }
                async request(path, api = 'public', method = 'GET', params = {}, headers, body, config = {}, context = {}) {
                    let response = await this.fetch2(path, api, method, params, headers, body, config, context);
                    if (typeof response === 'string') {
                        // sometimes the exchange returns whitespace prepended to json
                        response = this.strip(response);
                        if (!this.isJsonEncodedObject(response)) throw new ExchangeError1(this.id + ' ' + response);
                        response = JSON.parse(response);
                    }
                    return response;
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    53: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ArgumentsRequired: ArgumentsRequired1, ExchangeError: ExchangeError1, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, DDoSProtection: DDoSProtection, BadRequest: BadRequest } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class btcmarkets extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'btcmarkets',
                        'name': 'BTC Markets',
                        'countries': [
                            'AU'
                        ],
                        'rateLimit': 1000,
                        'version': 'v3',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': 'emulated',
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTransactions': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/89731817-b3fb8480-da52-11ea-817f-783b08aaf32b.jpg',
                            'api': {
                                'public': 'https://api.btcmarkets.net',
                                'private': 'https://api.btcmarkets.net'
                            },
                            'www': 'https://btcmarkets.net',
                            'doc': [
                                'https://api.btcmarkets.net/doc/v3',
                                'https://github.com/BTCMarkets/API'
                            ]
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'markets',
                                    'markets/{marketId}/ticker',
                                    'markets/{marketId}/trades',
                                    'markets/{marketId}/orderbook',
                                    'markets/{marketId}/candles',
                                    'markets/tickers',
                                    'markets/orderbooks',
                                    'time'
                                ]
                            },
                            'private': {
                                'get': [
                                    'orders',
                                    'orders/{id}',
                                    'batchorders/{ids}',
                                    'trades',
                                    'trades/{id}',
                                    'withdrawals',
                                    'withdrawals/{id}',
                                    'deposits',
                                    'deposits/{id}',
                                    'transfers',
                                    'transfers/{id}',
                                    'addresses',
                                    'withdrawal-fees',
                                    'assets',
                                    'accounts/me/trading-fees',
                                    'accounts/me/withdrawal-limits',
                                    'accounts/me/balances',
                                    'accounts/me/transactions',
                                    'reports/{id}'
                                ],
                                'post': [
                                    'orders',
                                    'batchorders',
                                    'withdrawals',
                                    'reports'
                                ],
                                'delete': [
                                    'orders',
                                    'orders/{id}',
                                    'batchorders/{ids}'
                                ],
                                'put': [
                                    'orders/{id}'
                                ]
                            }
                        },
                        'timeframes': {
                            '1m': '1m',
                            '1h': '1h',
                            '1d': '1d'
                        },
                        'exceptions': {
                            '3': InvalidOrder,
                            '6': DDoSProtection,
                            'InsufficientFund': InsufficientFunds,
                            'InvalidPrice': InvalidOrder,
                            'InvalidAmount': InvalidOrder,
                            'MissingArgument': InvalidOrder,
                            'OrderAlreadyCancelled': InvalidOrder,
                            'OrderNotFound': OrderNotFound,
                            'OrderStatusIsFinal': InvalidOrder,
                            'InvalidPaginationParameter': BadRequest
                        },
                        'fees': {
                            'percentage': true,
                            'tierBased': true,
                            'maker': this.parseNumber('-0.0005'),
                            'taker': this.parseNumber('0.0020')
                        },
                        'options': {
                            'fees': {
                                'AUD': {
                                    'maker': 0.0085,
                                    'taker': 0.0085
                                }
                            }
                        }
                    });
                }
                async fetchTransactionsWithMethod(method, code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['after'] = since;
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const response = await this[method](this.extend(request, params));
                    return this.parseTransactions(response, currency, since, limit);
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    return await this.fetchTransactionsWithMethod('privateGetTransfers', code, since, limit, params);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    return await this.fetchTransactionsWithMethod('privateGetDeposits', code, since, limit, params);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    return await this.fetchTransactionsWithMethod('privateGetWithdrawals', code, since, limit, params);
                }
                parseTransactionStatus(status) {
                    // todo: find more statuses
                    const statuses = {
                        'Complete': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransactionType(type) {
                    const statuses = {
                        'Withdraw': 'withdrawal',
                        'Deposit': 'deposit'
                    };
                    return this.safeString(statuses, type, type);
                }
                parseTransaction(transaction, currency) {
                    //
                    //    {
                    //         "id": "6500230339",
                    //         "assetName": "XRP",
                    //         "amount": "500",
                    //         "type": "Deposit",
                    //         "creationTime": "2020-07-27T07:52:08.640000Z",
                    //         "status": "Complete",
                    //         "description": "RIPPLE Deposit, XRP 500",
                    //         "fee": "0",
                    //         "lastUpdate": "2020-07-27T07:52:08.665000Z",
                    //         "paymentDetail": {
                    //             "txId": "lsjflsjdfljsd",
                    //             "address": "kjasfkjsdf?dt=873874545"
                    //         }
                    //    }
                    //
                    //    {
                    //         "id": "500985282",
                    //         "assetName": "BTC",
                    //         "amount": "0.42570126",
                    //         "type": "Withdraw",
                    //         "creationTime": "2017-07-29T12:49:03.931000Z",
                    //         "status": "Complete",
                    //         "description": "BTC withdraw from [nick-btcmarkets@snowmonkey.co.uk] to Address: 1B9DsnSYQ54VMqFHVJYdGoLMCYzFwrQzsj amount: 0.42570126 fee: 0.00000000",
                    //         "fee": "0.0005",
                    //         "lastUpdate": "2017-07-29T12:52:20.676000Z",
                    //         "paymentDetail": {
                    //             "txId": "fkjdsfjsfljsdfl",
                    //             "address": "a;daddjas;djas"
                    //         }
                    //    }
                    //
                    //    {
                    //         "id": "505102262",
                    //         "assetName": "XRP",
                    //         "amount": "979.836",
                    //         "type": "Deposit",
                    //         "creationTime": "2017-07-31T08:50:01.053000Z",
                    //         "status": "Complete",
                    //         "description": "Ripple Deposit, X 979.8360",
                    //         "fee": "0",
                    //         "lastUpdate": "2017-07-31T08:50:01.290000Z"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(transaction, 'creationTime'));
                    const lastUpdate = this.parse8601(this.safeString(transaction, 'lastUpdate'));
                    let type = this.parseTransactionType(this.safeStringLower(transaction, 'type'));
                    if (type === 'withdraw') type = 'withdrawal';
                    const cryptoPaymentDetail = this.safeValue(transaction, 'paymentDetail', {});
                    const txid = this.safeString(cryptoPaymentDetail, 'txId');
                    let address = this.safeString(cryptoPaymentDetail, 'address');
                    let tag = undefined;
                    if (address !== undefined) {
                        const addressParts = address.split('?dt=');
                        const numParts = addressParts.length;
                        if (numParts > 1) {
                            address = addressParts[0];
                            tag = addressParts[1];
                        }
                    }
                    const addressTo = address;
                    const tagTo = tag;
                    const addressFrom = undefined;
                    const tagFrom = undefined;
                    const fee = this.safeNumber(transaction, 'fee');
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const currencyId = this.safeString(transaction, 'assetName');
                    const code = this.safeCurrencyCode(currencyId);
                    let amount = this.safeNumber(transaction, 'amount');
                    if (fee) amount -= fee;
                    return {
                        'id': this.safeString(transaction, 'id'),
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': addressTo,
                        'addressFrom': addressFrom,
                        'tag': tag,
                        'tagTo': tagTo,
                        'tagFrom': tagFrom,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': lastUpdate,
                        'fee': {
                            'currency': code,
                            'cost': fee
                        },
                        'info': transaction
                    };
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetMarkets(params);
                    //
                    //     [
                    //         {
                    //             "marketId":"COMP-AUD",
                    //             "baseAssetName":"COMP",
                    //             "quoteAssetName":"AUD",
                    //             "minOrderAmount":"0.00007",
                    //             "maxOrderAmount":"1000000",
                    //             "amountDecimals":"8",
                    //             "priceDecimals":"2"
                    //         }
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const baseId = this.safeString(market, 'baseAssetName');
                        const quoteId = this.safeString(market, 'quoteAssetName');
                        const id = this.safeString(market, 'marketId');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const symbol = base + '/' + quote;
                        const fees = this.safeValue(this.safeValue(this.options, 'fees', {}), quote, this.fees);
                        const pricePrecision = this.safeInteger(market, 'priceDecimals');
                        const amountPrecision = this.safeInteger(market, 'amountDecimals');
                        const minAmount = this.safeNumber(market, 'minOrderAmount');
                        const maxAmount = this.safeNumber(market, 'maxOrderAmount');
                        let minPrice = undefined;
                        if (quote === 'AUD') minPrice = Math.pow(10, -pricePrecision);
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': fees['taker'],
                            'maker': fees['maker'],
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': amountPrecision,
                                'price': pricePrecision
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': minAmount,
                                    'max': maxAmount
                                },
                                'price': {
                                    'min': minPrice,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTime(params);
                    //
                    //     {
                    //         "timestamp": "2019-09-01T18:34:27.045000Z"
                    //     }
                    //
                    return this.parse8601(this.safeString(response, 'timestamp'));
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'assetName');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['used'] = this.safeString(balance, 'locked');
                        account['total'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountsMeBalances(params);
                    return this.parseBalance(response);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         "2020-09-12T18:30:00.000000Z",
                    //         "14409.45", // open
                    //         "14409.45", // high
                    //         "14403.91", // low
                    //         "14403.91", // close
                    //         "0.01571701" // volume
                    //     ]
                    //
                    return [
                        this.parse8601(this.safeString(ohlcv, 0)),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id'],
                        'timeWindow': this.timeframes[timeframe]
                    };
                    if (since !== undefined) request['from'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit; // default is 10, max 200
                    const response = await this.publicGetMarketsMarketIdCandles(this.extend(request, params));
                    //
                    //     [
                    //         ["2020-09-12T18:30:00.000000Z","14409.45","14409.45","14403.91","14403.91","0.01571701"],
                    //         ["2020-09-12T18:21:00.000000Z","14409.45","14409.45","14409.45","14409.45","0.0035"],
                    //         ["2020-09-12T18:03:00.000000Z","14361.37","14361.37","14361.37","14361.37","0.00345221"],
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id']
                    };
                    const response = await this.publicGetMarketsMarketIdOrderbook(this.extend(request, params));
                    //
                    //     {
                    //         "marketId":"BTC-AUD",
                    //         "snapshotId":1599936148941000,
                    //         "asks":[
                    //             ["14459.45","0.00456475"],
                    //             ["14463.56","2"],
                    //             ["14470.91","0.98"],
                    //         ],
                    //         "bids":[
                    //             ["14421.01","0.52"],
                    //             ["14421","0.75"],
                    //             ["14418","0.3521"],
                    //         ]
                    //     }
                    //
                    const timestamp = this.safeIntegerProduct(response, 'snapshotId', 0.001);
                    const orderbook = this.parseOrderBook(response, symbol, timestamp);
                    orderbook['nonce'] = this.safeInteger(response, 'snapshotId');
                    return orderbook;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker
                    //
                    //     {
                    //         "marketId":"BAT-AUD",
                    //         "bestBid":"0.3751",
                    //         "bestAsk":"0.377",
                    //         "lastPrice":"0.3769",
                    //         "volume24h":"56192.97613335",
                    //         "volumeQte24h":"21179.13270465",
                    //         "price24h":"0.0119",
                    //         "pricePct24h":"3.26",
                    //         "low24h":"0.3611",
                    //         "high24h":"0.3799",
                    //         "timestamp":"2020-08-09T18:28:23.280000Z"
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'marketId');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    const timestamp = this.parse8601(this.safeString(ticker, 'timestamp'));
                    const last = this.safeString(ticker, 'lastPrice');
                    const baseVolume = this.safeString(ticker, 'volume24h');
                    const quoteVolume = this.safeString(ticker, 'volumeQte24h');
                    const change = this.safeString(ticker, 'price24h');
                    const percentage = this.safeString(ticker, 'pricePct24h');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high24h'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bestBid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'bestAsk'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': change,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id']
                    };
                    const response = await this.publicGetMarketsMarketIdTicker(this.extend(request, params));
                    //
                    //     {
                    //         "marketId":"BAT-AUD",
                    //         "bestBid":"0.3751",
                    //         "bestAsk":"0.377",
                    //         "lastPrice":"0.3769",
                    //         "volume24h":"56192.97613335",
                    //         "volumeQte24h":"21179.13270465",
                    //         "price24h":"0.0119",
                    //         "pricePct24h":"3.26",
                    //         "low24h":"0.3611",
                    //         "high24h":"0.3799",
                    //         "timestamp":"2020-08-09T18:28:23.280000Z"
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                async fetchTicker2(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': market['id']
                    };
                    const response = await this.publicGetMarketIdTick(this.extend(request, params));
                    return this.parseTicker(response, market);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     {
                    //         "id":"6191646611",
                    //         "price":"539.98",
                    //         "amount":"0.5",
                    //         "timestamp":"2020-08-09T15:21:05.016000Z",
                    //         "side":"Ask"
                    //     }
                    //
                    // private fetchMyTrades
                    //
                    //     {
                    //         "id": "36014819",
                    //         "marketId": "XRP-AUD",
                    //         "timestamp": "2019-06-25T16:01:02.977000Z",
                    //         "price": "0.67",
                    //         "amount": "1.50533262",
                    //         "side": "Ask",
                    //         "fee": "0.00857285",
                    //         "orderId": "3648306",
                    //         "liquidityType": "Taker",
                    //         "clientOrderId": "48"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(trade, 'timestamp'));
                    const marketId = this.safeString(trade, 'marketId');
                    market = this.safeMarket(marketId, market, '-');
                    const feeCurrencyCode = market['quote'] === 'AUD' ? market['quote'] : market['base'];
                    let side = this.safeString(trade, 'side');
                    if (side === 'Bid') side = 'buy';
                    else if (side === 'Ask') side = 'sell';
                    const id = this.safeString(trade, 'id');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const orderId = this.safeString(trade, 'orderId');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) fee = {
                        'cost': feeCostString,
                        'currency': feeCurrencyCode
                    };
                    const takerOrMaker = this.safeStringLower(trade, 'liquidityType');
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'order': orderId,
                        'symbol': market['symbol'],
                        'type': undefined,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'takerOrMaker': takerOrMaker,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        // 'since': 59868345231,
                        'marketId': market['id']
                    };
                    const response = await this.publicGetMarketsMarketIdTrades(this.extend(request, params));
                    //
                    //     [
                    //         {"id":"6191646611","price":"539.98","amount":"0.5","timestamp":"2020-08-09T15:21:05.016000Z","side":"Ask"},
                    //         {"id":"6191646610","price":"539.99","amount":"0.5","timestamp":"2020-08-09T15:21:05.015000Z","side":"Ask"},
                    //         {"id":"6191646590","price":"540","amount":"0.00233785","timestamp":"2020-08-09T15:21:04.171000Z","side":"Bid"},
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id'],
                        // 'price': this.priceToPrecision (symbol, price),
                        'amount': this.amountToPrecision(symbol, amount),
                        // 'type': 'Limit', // "Limit", "Market", "Stop Limit", "Stop", "Take Profit"
                        'side': side === 'buy' ? 'Bid' : 'Ask'
                    };
                    const lowercaseType = type.toLowerCase();
                    const orderTypes = this.safeValue(this.options, 'orderTypes', {
                        'limit': 'Limit',
                        'market': 'Market',
                        'stop': 'Stop',
                        'stop limit': 'Stop Limit',
                        'take profit': 'Take Profit'
                    });
                    request['type'] = this.safeString(orderTypes, lowercaseType, type);
                    let priceIsRequired = false;
                    let triggerPriceIsRequired = false;
                    if (lowercaseType === 'limit') priceIsRequired = true;
                    else if (lowercaseType === 'stop limit') {
                        triggerPriceIsRequired = true;
                        priceIsRequired = true;
                    } else if (lowercaseType === 'take profit') triggerPriceIsRequired = true;
                    else if (lowercaseType === 'stop') triggerPriceIsRequired = true;
                    if (priceIsRequired) {
                        if (price === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a price argument for a ' + type + 'order');
                        else request['price'] = this.priceToPrecision(symbol, price);
                    }
                    if (triggerPriceIsRequired) {
                        const triggerPrice = this.safeNumber(params, 'triggerPrice');
                        params = this.omit(params, 'triggerPrice');
                        if (triggerPrice === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a triggerPrice parameter for a ' + type + 'order');
                        else request['triggerPrice'] = this.priceToPrecision(symbol, triggerPrice);
                    }
                    const clientOrderId = this.safeString(params, 'clientOrderId');
                    if (clientOrderId !== undefined) request['clientOrderId'] = clientOrderId;
                    params = this.omit(params, 'clientOrderId');
                    const response = await this.privatePostOrders(this.extend(request, params));
                    //
                    //     {
                    //         "orderId": "7524",
                    //         "marketId": "BTC-AUD",
                    //         "side": "Bid",
                    //         "type": "Limit",
                    //         "creationTime": "2019-08-30T11:08:21.956000Z",
                    //         "price": "100.12",
                    //         "amount": "1.034",
                    //         "openAmount": "1.034",
                    //         "status": "Accepted",
                    //         "clientOrderId": "1234-5678",
                    //         "timeInForce": "IOC",
                    //         "postOnly": false,
                    //         "selfTrade": "P",
                    //         "triggerAmount": "105",
                    //         "targetAmount": "1000"
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrders(ids, symbol, params = {}) {
                    await this.loadMarkets();
                    for(let i = 0; i < ids.length; i++)ids[i] = parseInt(ids[i]);
                    const request = {
                        'ids': ids
                    };
                    return await this.privateDeleteBatchordersIds(this.extend(request, params));
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    return await this.privateDeleteOrdersId(this.extend(request, params));
                }
                calculateFee(symbol, type, side, amount, price, takerOrMaker = 'taker', params = {}) {
                    const market = this.markets[symbol];
                    const rate = market[takerOrMaker];
                    let currency = undefined;
                    let cost = undefined;
                    if (market['quote'] === 'AUD') {
                        currency = market['quote'];
                        cost = parseFloat(this.costToPrecision(symbol, amount * price));
                    } else {
                        currency = market['base'];
                        cost = parseFloat(this.amountToPrecision(symbol, amount));
                    }
                    return {
                        'type': takerOrMaker,
                        'currency': currency,
                        'rate': rate,
                        'cost': parseFloat(this.feeToPrecision(symbol, rate * cost))
                    };
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'Accepted': 'open',
                        'Placed': 'open',
                        'Partially Matched': 'open',
                        'Fully Matched': 'closed',
                        'Cancelled': 'canceled',
                        'Partially Cancelled': 'canceled',
                        'Failed': 'rejected'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "orderId": "7524",
                    //         "marketId": "BTC-AUD",
                    //         "side": "Bid",
                    //         "type": "Limit",
                    //         "creationTime": "2019-08-30T11:08:21.956000Z",
                    //         "price": "100.12",
                    //         "amount": "1.034",
                    //         "openAmount": "1.034",
                    //         "status": "Accepted",
                    //         "clientOrderId": "1234-5678",
                    //         "timeInForce": "IOC",
                    //         "postOnly": false,
                    //         "selfTrade": "P",
                    //         "triggerAmount": "105",
                    //         "targetAmount": "1000"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(order, 'creationTime'));
                    const marketId = this.safeString(order, 'marketId');
                    market = this.safeMarket(marketId, market, '-');
                    let side = this.safeString(order, 'side');
                    if (side === 'Bid') side = 'buy';
                    else if (side === 'Ask') side = 'sell';
                    const type = this.safeStringLower(order, 'type');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'amount');
                    const remaining = this.safeString(order, 'openAmount');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const id = this.safeString(order, 'orderId');
                    const clientOrderId = this.safeString(order, 'clientOrderId');
                    const timeInForce = this.safeString(order, 'timeInForce');
                    const stopPrice = this.safeNumber(order, 'triggerPrice');
                    const postOnly = this.safeValue(order, 'postOnly');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'cost': undefined,
                        'amount': amount,
                        'filled': undefined,
                        'remaining': remaining,
                        'average': undefined,
                        'status': status,
                        'trades': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetOrdersId(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'status': 'all'
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['marketId'] = market['id'];
                    }
                    if (since !== undefined) request['after'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetOrders(this.extend(request, params));
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'open'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const orders = await this.fetchOrders(symbol, since, limit, params);
                    return this.filterBy(orders, 'status', 'closed');
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['marketId'] = market['id'];
                    }
                    if (since !== undefined) request['after'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetTrades(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id": "36014819",
                    //             "marketId": "XRP-AUD",
                    //             "timestamp": "2019-06-25T16:01:02.977000Z",
                    //             "price": "0.67",
                    //             "amount": "1.50533262",
                    //             "side": "Ask",
                    //             "fee": "0.00857285",
                    //             "orderId": "3648306",
                    //             "liquidityType": "Taker",
                    //             "clientOrderId": "48"
                    //         },
                    //         {
                    //             "id": "3568960",
                    //             "marketId": "GNT-AUD",
                    //             "timestamp": "2019-06-20T08:44:04.488000Z",
                    //             "price": "0.1362",
                    //             "amount": "0.85",
                    //             "side": "Bid",
                    //             "fee": "0.00098404",
                    //             "orderId": "3543015",
                    //             "liquidityType": "Maker"
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let request = '/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.keysort(this.omit(params, this.extractParams(path)));
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const secret = this.base64ToBinary(this.encode(this.secret));
                        let auth = method + request + nonce;
                        if (method === 'GET' || method === 'DELETE') {
                            if (Object.keys(query).length) request += '?' + this.urlencode(query);
                        } else {
                            body = this.json(query);
                            auth += body;
                        }
                        const signature = this.hmac(this.encode(auth), secret, 'sha512', 'base64');
                        headers = {
                            'Accept': 'application/json',
                            'Accept-Charset': 'UTF-8',
                            'Content-Type': 'application/json',
                            'BM-AUTH-APIKEY': this.apiKey,
                            'BM-AUTH-TIMESTAMP': nonce,
                            'BM-AUTH-SIGNATURE': signature
                        };
                    } else if (api === 'public') {
                        if (Object.keys(query).length) request += '?' + this.urlencode(query);
                    }
                    const url = this.urls['api'][api] + request;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if ('success' in response) {
                        if (!response['success']) {
                            const error = this.safeString(response, 'errorCode');
                            const feedback = this.id + ' ' + body;
                            this.throwExactlyMatchedException(this.exceptions, error, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                    // v3 api errors
                    if (code >= 400) {
                        const errorCode = this.safeString(response, 'code');
                        const message = this.safeString(response, 'message');
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions, errorCode, feedback);
                        this.throwExactlyMatchedException(this.exceptions, message, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    54: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class btctradeua extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'btctradeua',
                        'name': 'BTC Trade UA',
                        'countries': [
                            'UA'
                        ],
                        'rateLimit': 3000,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkOHLCV': false,
                            'fetchOpenOrders': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'signIn': true
                        },
                        'urls': {
                            'referral': 'https://btc-trade.com.ua/registration/22689',
                            'logo': 'https://user-images.githubusercontent.com/1294454/27941483-79fc7350-62d9-11e7-9f61-ac47f28fcd96.jpg',
                            'api': 'https://btc-trade.com.ua/api',
                            'www': 'https://btc-trade.com.ua',
                            'doc': 'https://docs.google.com/document/d/1ocYA0yMy_RXd561sfG3qEPZ80kyll36HUxvCRe5GbhE/edit'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'deals/{symbol}',
                                    'trades/sell/{symbol}',
                                    'trades/buy/{symbol}',
                                    'japan_stat/high/{symbol}'
                                ]
                            },
                            'private': {
                                'post': [
                                    'auth',
                                    'ask/{symbol}',
                                    'balance',
                                    'bid/{symbol}',
                                    'buy/{symbol}',
                                    'my_orders/{symbol}',
                                    'order/status/{id}',
                                    'remove/order/{id}',
                                    'sell/{symbol}'
                                ]
                            }
                        },
                        'markets': {
                            'BCH/UAH': {
                                'id': 'bch_uah',
                                'symbol': 'BCH/UAH',
                                'base': 'BCH',
                                'quote': 'UAH',
                                'baseId': 'bch',
                                'quoteId': 'uah',
                                'type': 'spot',
                                'spot': true
                            },
                            'BTC/UAH': {
                                'id': 'btc_uah',
                                'symbol': 'BTC/UAH',
                                'base': 'BTC',
                                'quote': 'UAH',
                                'baseId': 'btc',
                                'quoteId': 'uah',
                                'precision': {
                                    'price': 1
                                },
                                'limits': {
                                    'amount': {
                                        'min': 0.0000000001
                                    }
                                },
                                'type': 'spot',
                                'spot': true
                            },
                            'DASH/BTC': {
                                'id': 'dash_btc',
                                'symbol': 'DASH/BTC',
                                'base': 'DASH',
                                'quote': 'BTC',
                                'baseId': 'dash',
                                'quoteId': 'btc',
                                'type': 'spot',
                                'spot': true
                            },
                            'DASH/UAH': {
                                'id': 'dash_uah',
                                'symbol': 'DASH/UAH',
                                'base': 'DASH',
                                'quote': 'UAH',
                                'baseId': 'dash',
                                'quoteId': 'uah',
                                'type': 'spot',
                                'spot': true
                            },
                            'DOGE/BTC': {
                                'id': 'doge_btc',
                                'symbol': 'DOGE/BTC',
                                'base': 'DOGE',
                                'quote': 'BTC',
                                'baseId': 'doge',
                                'quoteId': 'btc',
                                'type': 'spot',
                                'spot': true
                            },
                            'DOGE/UAH': {
                                'id': 'doge_uah',
                                'symbol': 'DOGE/UAH',
                                'base': 'DOGE',
                                'quote': 'UAH',
                                'baseId': 'doge',
                                'quoteId': 'uah',
                                'type': 'spot',
                                'spot': true
                            },
                            'ETH/UAH': {
                                'id': 'eth_uah',
                                'symbol': 'ETH/UAH',
                                'base': 'ETH',
                                'quote': 'UAH',
                                'baseId': 'eth',
                                'quoteId': 'uah',
                                'type': 'spot',
                                'spot': true
                            },
                            'ITI/UAH': {
                                'id': 'iti_uah',
                                'symbol': 'ITI/UAH',
                                'base': 'ITI',
                                'quote': 'UAH',
                                'baseId': 'iti',
                                'quoteId': 'uah',
                                'type': 'spot',
                                'spot': true
                            },
                            'KRB/UAH': {
                                'id': 'krb_uah',
                                'symbol': 'KRB/UAH',
                                'base': 'KRB',
                                'quote': 'UAH',
                                'baseId': 'krb',
                                'quoteId': 'uah',
                                'type': 'spot',
                                'spot': true
                            },
                            'LTC/BTC': {
                                'id': 'ltc_btc',
                                'symbol': 'LTC/BTC',
                                'base': 'LTC',
                                'quote': 'BTC',
                                'baseId': 'ltc',
                                'quoteId': 'btc',
                                'type': 'spot',
                                'spot': true
                            },
                            'LTC/UAH': {
                                'id': 'ltc_uah',
                                'symbol': 'LTC/UAH',
                                'base': 'LTC',
                                'quote': 'UAH',
                                'baseId': 'ltc',
                                'quoteId': 'uah',
                                'type': 'spot',
                                'spot': true
                            },
                            'NVC/BTC': {
                                'id': 'nvc_btc',
                                'symbol': 'NVC/BTC',
                                'base': 'NVC',
                                'quote': 'BTC',
                                'baseId': 'nvc',
                                'quoteId': 'btc',
                                'type': 'spot',
                                'spot': true
                            },
                            'NVC/UAH': {
                                'id': 'nvc_uah',
                                'symbol': 'NVC/UAH',
                                'base': 'NVC',
                                'quote': 'UAH',
                                'baseId': 'nvc',
                                'quoteId': 'uah',
                                'type': 'spot',
                                'spot': true
                            },
                            'PPC/BTC': {
                                'id': 'ppc_btc',
                                'symbol': 'PPC/BTC',
                                'base': 'PPC',
                                'quote': 'BTC',
                                'baseId': 'ppc',
                                'quoteId': 'btc',
                                'type': 'spot',
                                'spot': true
                            },
                            'SIB/UAH': {
                                'id': 'sib_uah',
                                'symbol': 'SIB/UAH',
                                'base': 'SIB',
                                'quote': 'UAH',
                                'baseId': 'sib',
                                'quoteId': 'uah',
                                'type': 'spot',
                                'spot': true
                            },
                            'XMR/UAH': {
                                'id': 'xmr_uah',
                                'symbol': 'XMR/UAH',
                                'base': 'XMR',
                                'quote': 'UAH',
                                'baseId': 'xmr',
                                'quoteId': 'uah',
                                'type': 'spot',
                                'spot': true
                            },
                            'ZEC/UAH': {
                                'id': 'zec_uah',
                                'symbol': 'ZEC/UAH',
                                'base': 'ZEC',
                                'quote': 'UAH',
                                'baseId': 'zec',
                                'quoteId': 'uah',
                                'type': 'spot',
                                'spot': true
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': 0.001,
                                'taker': 0.001
                            },
                            'funding': {
                                'withdraw': {
                                    'BTC': 0.0006,
                                    'LTC': 0.01,
                                    'NVC': 0.01,
                                    'DOGE': 10
                                }
                            }
                        }
                    });
                }
                async signIn(params = {}) {
                    return await this.privatePostAuth(params);
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const balances = this.safeValue(response, 'accounts');
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostBalance(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const bids = await this.publicGetTradesBuySymbol(this.extend(request, params));
                    const asks = await this.publicGetTradesSellSymbol(this.extend(request, params));
                    const orderbook = {
                        'bids': [],
                        'asks': []
                    };
                    if (bids) {
                        if ('list' in bids) orderbook['bids'] = bids['list'];
                    }
                    if (asks) {
                        if ('list' in asks) orderbook['asks'] = asks['list'];
                    }
                    return this.parseOrderBook(orderbook, symbol, undefined, 'bids', 'asks', 'price', 'currency_trade');
                }
                parseTicker(ticker, market) {
                    //
                    // [
                    //     [1640789101000, 1292663.0, 1311823.61303, 1295794.252, 1311823.61303, 0.030175],
                    //     [1640790902000, 1311823.61303, 1310820.96, 1290000.0, 1290000.0, 0.042533],
                    // ],
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.milliseconds();
                    const result = {
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': undefined,
                        'low': undefined,
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': undefined,
                        'last': undefined,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': undefined,
                        'quoteVolume': undefined,
                        'info': ticker
                    };
                    const tickerLength = ticker.length;
                    if (tickerLength > 0) {
                        const start = Math.max(tickerLength - 48, 0);
                        for(let i = start; i < ticker.length; i++){
                            const candle = ticker[i];
                            if (result['open'] === undefined) result['open'] = this.safeString(candle, 1);
                            const high = this.safeString(candle, 2);
                            if (result['high'] === undefined || high !== undefined && Precise.stringLt(result['high'], high)) result['high'] = high;
                            const low = this.safeString(candle, 3);
                            if (result['low'] === undefined || low !== undefined && Precise.stringLt(result['low'], low)) result['low'] = low;
                            const baseVolume = this.safeString(candle, 5);
                            if (result['baseVolume'] === undefined) result['baseVolume'] = baseVolume;
                            else result['baseVolume'] = Precise.stringAdd(result['baseVolume'], baseVolume);
                        }
                        const last = tickerLength - 1;
                        result['last'] = this.safeString(ticker[last], 4);
                        result['close'] = result['last'];
                    }
                    return this.safeTicker(result, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetJapanStatHighSymbol(this.extend(request, params));
                    const ticker = this.safeValue(response, 'trades');
                    //
                    // {
                    //     "status": true,
                    //     "volume_trade": "0.495703",
                    //     "trades": [
                    //         [1640789101000, 1292663.0, 1311823.61303, 1295794.252, 1311823.61303, 0.030175],
                    //         [1640790902000, 1311823.61303, 1310820.96, 1290000.0, 1290000.0, 0.042533],
                    //     ],
                    // }
                    //
                    return this.parseTicker(ticker, market);
                }
                convertMonthNameToString(cyrillic) {
                    const months = {
                        'Jan': '01',
                        'Feb': '02',
                        'Mar': '03',
                        'Apr': '04',
                        'May': '05',
                        'Jun': '06',
                        'Jul': '07',
                        'Aug': '08',
                        'Sept': '09',
                        'Oct': '10',
                        'Nov': '11',
                        'Dec': '12'
                    };
                    return this.safeString(months, cyrillic);
                }
                parseExchangeSpecificDatetime(cyrillic) {
                    const parts = cyrillic.split(' ');
                    let month = parts[0];
                    let day = parts[1].replace(',', '');
                    if (day.length < 2) day = '0' + day;
                    const year = parts[2].replace(',', '');
                    month = month.replace(',', '');
                    month = month.replace('.', '');
                    month = this.convertMonthNameToString(month);
                    if (!month) throw new ExchangeError1(this.id + ' parseTrade() unrecognized month name: ' + cyrillic);
                    const hms = parts[3];
                    const hmsParts = hms.split(':');
                    let h = this.safeString(hmsParts, 0);
                    let m = '00';
                    const ampm = this.safeString(parts, 4);
                    if (h === 'noon') h = '12';
                    else {
                        let intH = parseInt(h);
                        if (ampm !== undefined && ampm[0] === 'p') {
                            intH = 12 + intH;
                            if (intH > 23) intH = 0;
                        }
                        h = intH.toString();
                        if (h.length < 2) h = '0' + h;
                        m = this.safeString(hmsParts, 1, '00');
                        if (m.length < 2) m = '0' + m;
                    }
                    const ymd = [
                        year,
                        month,
                        day
                    ].join('-');
                    const ymdhms = ymd + 'T' + h + ':' + m + ':00';
                    const timestamp = this.parse8601(ymdhms);
                    // server reports local time, adjust to UTC
                    // a special case for DST
                    // subtract 2 hours during winter
                    const intM = parseInt(m);
                    if (intM < 11 || intM > 2) return timestamp - 7200000;
                    // subtract 3 hours during summer
                    return timestamp - 10800000;
                }
                parseTrade(trade, market) {
                    const timestamp = this.parseExchangeSpecificDatetime(this.safeString(trade, 'pub_date'));
                    const id = this.safeString(trade, 'id');
                    const type = 'limit';
                    const side = this.safeString(trade, 'type');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amnt_trade');
                    market = this.safeMarket(undefined, market);
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': type,
                        'side': side,
                        'order': undefined,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetDealsSymbol(this.extend(request, params));
                    // they report each trade twice (once for both of the two sides of the fill)
                    // deduplicate trades for that reason
                    const trades = [];
                    for(let i = 0; i < response.length; i++){
                        const id = this.safeInteger(response[i], 'id');
                        if (id % 2) trades.push(response[i]);
                    }
                    return this.parseTrades(trades, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (type === 'market') throw new ExchangeError1(this.id + ' createOrder() allows limit orders only');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const method = 'privatePost' + this.capitalize(side) + 'Id';
                    const request = {
                        'count': amount,
                        'currency1': market['quoteId'],
                        'currency': market['baseId'],
                        'price': price
                    };
                    return this[method](this.extend(request, params));
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'id': id
                    };
                    return await this.privatePostRemoveOrderId(this.extend(request, params));
                }
                parseOrder(order, market) {
                    const timestamp = this.milliseconds();
                    const symbol = this.safeSymbol(undefined, market);
                    const side = this.safeString(order, 'type');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'amnt_trade');
                    const remaining = this.safeString(order, 'amnt_trade');
                    return this.safeOrder({
                        'id': this.safeString(order, 'id'),
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': 'open',
                        'symbol': symbol,
                        'type': undefined,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'filled': undefined,
                        'remaining': remaining,
                        'trades': undefined,
                        'info': order,
                        'cost': undefined,
                        'average': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.privatePostMyOrdersSymbol(this.extend(request, params));
                    const orders = this.safeValue(response, 'your_open_orders');
                    return this.parseOrders(orders, market, since, limit);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += this.implodeParams(path, query);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce();
                        body = this.urlencode(this.extend({
                            'out_order_id': nonce,
                            'nonce': nonce
                        }, query));
                        const auth = body + this.secret;
                        headers = {
                            'public-key': this.apiKey,
                            'api-sign': this.hash(this.encode(auth), 'sha256'),
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    55: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class btcturk extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'btcturk',
                        'name': 'BTCTurk',
                        'countries': [
                            'TR'
                        ],
                        'rateLimit': 100,
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'timeframes': {
                            '1d': '1d'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87153926-efbef500-c2c0-11ea-9842-05b63612c4b9.jpg',
                            'api': {
                                'public': 'https://api.btcturk.com/api/v2',
                                'private': 'https://api.btcturk.com/api/v1',
                                'graph': 'https://graph-api.btcturk.com/v1'
                            },
                            'www': 'https://www.btcturk.com',
                            'doc': 'https://github.com/BTCTrader/broker-api-docs'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'orderbook': 1,
                                    'ticker': 0.1,
                                    'trades': 1,
                                    'server/exchangeinfo': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'users/balances': 1,
                                    'openOrders': 1,
                                    'allOrders': 1,
                                    'users/transactions/trade': 1
                                },
                                'post': {
                                    'order': 1,
                                    'cancelOrder': 1
                                },
                                'delete': {
                                    'order': 1
                                }
                            },
                            'graph': {
                                'get': {
                                    'ohlcs': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.0005'),
                                'taker': this.parseNumber('0.0009')
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'FAILED_ORDER_WITH_OPEN_ORDERS': InsufficientFunds,
                                'FAILED_LIMIT_ORDER': InvalidOrder,
                                'FAILED_MARKET_ORDER': InvalidOrder
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetServerExchangeinfo(params);
                    //
                    //     {
                    //       "data": {
                    //         "timeZone": "UTC",
                    //         "serverTime": "1618826678404",
                    //         "symbols": [
                    //           {
                    //             "id": "1",
                    //             "name": "BTCTRY",
                    //             "nameNormalized": "BTC_TRY",
                    //             "status": "TRADING",
                    //             "numerator": "BTC",
                    //             "denominator": "TRY",
                    //             "numeratorScale": "8",
                    //             "denominatorScale": "2",
                    //             "hasFraction": false,
                    //             "filters": [
                    //               {
                    //                 "filterType": "PRICE_FILTER",
                    //                 "minPrice": "0.0000000000001",
                    //                 "maxPrice": "10000000",
                    //                 "tickSize": "10",
                    //                 "minExchangeValue": "99.91",
                    //                 "minAmount": null,
                    //                 "maxAmount": null
                    //               }
                    //             ],
                    //             "orderMethods": [
                    //               "MARKET",
                    //               "LIMIT",
                    //               "STOP_MARKET",
                    //               "STOP_LIMIT"
                    //             ],
                    //             "displayFormat": "#,###",
                    //             "commissionFromNumerator": false,
                    //             "order": "1000",
                    //             "priceRounding": false
                    //           },
                    //         },
                    //       ],
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const markets = this.safeValue(data, 'symbols', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const entry = markets[i];
                        const id = this.safeString(entry, 'name');
                        const baseId = this.safeString(entry, 'numerator');
                        const quoteId = this.safeString(entry, 'denominator');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const filters = this.safeValue(entry, 'filters');
                        let minPrice = undefined;
                        let maxPrice = undefined;
                        let minAmount = undefined;
                        let maxAmount = undefined;
                        let minCost = undefined;
                        for(let j = 0; j < filters.length; j++){
                            const filter = filters[j];
                            const filterType = this.safeString(filter, 'filterType');
                            if (filterType === 'PRICE_FILTER') {
                                minPrice = this.safeNumber(filter, 'minPrice');
                                maxPrice = this.safeNumber(filter, 'maxPrice');
                                minAmount = this.safeNumber(filter, 'minAmount');
                                maxAmount = this.safeNumber(filter, 'maxAmount');
                                minCost = this.safeNumber(filter, 'minExchangeValue');
                            }
                        }
                        const status = this.safeString(entry, 'status');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': status === 'TRADING',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(entry, 'numeratorScale'),
                                'price': this.safeInteger(entry, 'denominatorScale')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': minAmount,
                                    'max': maxAmount
                                },
                                'price': {
                                    'min': minPrice,
                                    'max': maxPrice
                                },
                                'cost': {
                                    'min': minCost,
                                    'max': undefined
                                }
                            },
                            'info': entry
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const data = this.safeValue(response, 'data', []);
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < data.length; i++){
                        const entry = data[i];
                        const currencyId = this.safeString(entry, 'asset');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(entry, 'balance');
                        account['free'] = this.safeString(entry, 'free');
                        account['used'] = this.safeString(entry, 'locked');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetUsersBalances(params);
                    //
                    //     {
                    //       "data": [
                    //         {
                    //           "asset": "TRY",
                    //           "assetname": "Türk Lirası",
                    //           "balance": "0",
                    //           "locked": "0",
                    //           "free": "0",
                    //           "orderFund": "0",
                    //           "requestFund": "0",
                    //           "precision": 2
                    //         }
                    //       ]
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pairSymbol': market['id']
                    };
                    const response = await this.publicGetOrderbook(this.extend(request, params));
                    //     {
                    //       "data": {
                    //         "timestamp": 1618827901241,
                    //         "bids": [
                    //           [
                    //             "460263.00",
                    //             "0.04244000"
                    //           ]
                    //         ]
                    //       }
                    //     }
                    const data = this.safeValue(response, 'data');
                    const timestamp = this.safeInteger(data, 'timestamp');
                    return this.parseOrderBook(data, symbol, timestamp, 'bids', 'asks', 0, 1);
                }
                parseTicker(ticker, market) {
                    //
                    //   {
                    //     "pair": "BTCTRY",
                    //     "pairNormalized": "BTC_TRY",
                    //     "timestamp": 1618826361234,
                    //     "last": 462485,
                    //     "high": 473976,
                    //     "low": 444201,
                    //     "bid": 461928,
                    //     "ask": 462485,
                    //     "open": 456915,
                    //     "volume": 917.41368645,
                    //     "average": 462868.29574589,
                    //     "daily": 5570,
                    //     "dailyPercent": 1.22,
                    //     "denominatorSymbol": "TRY",
                    //     "numeratorSymbol": "BTC",
                    //     "order": 1000
                    //   }
                    //
                    const marketId = this.safeString(ticker, 'pair');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const timestamp = this.safeInteger(ticker, 'timestamp');
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': this.safeString(ticker, 'daily'),
                        'percentage': this.safeString(ticker, 'dailyPercent'),
                        'average': this.safeString(ticker, 'average'),
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTicker(params);
                    const tickers = this.safeValue(response, 'data');
                    return this.parseTickers(tickers, symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const tickers = await this.fetchTickers([
                        symbol
                    ], params);
                    return this.safeValue(tickers, symbol);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades
                    //     {
                    //       "pair": "BTCUSDT",
                    //       "pairNormalized": "BTC_USDT",
                    //       "numerator": "BTC",
                    //       "denominator": "USDT",
                    //       "date": "1618916879083",
                    //       "tid": "637545136790672520",
                    //       "price": "55774",
                    //       "amount": "0.27917100",
                    //       "side": "buy"
                    //     }
                    //
                    // fetchMyTrades
                    //     {
                    //       "price": "56000",
                    //       "numeratorSymbol": "BTC",
                    //       "denominatorSymbol": "USDT",
                    //       "orderType": "buy",
                    //       "orderId": "2606935102",
                    //       "id": "320874372",
                    //       "timestamp": "1618916479593",
                    //       "amount": "0.00020000",
                    //       "fee": "0",
                    //       "tax": "0"
                    //     }
                    //
                    const timestamp = this.safeInteger2(trade, 'date', 'timestamp');
                    const id = this.safeString2(trade, 'tid', 'id');
                    const order = this.safeString(trade, 'orderId');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = Precise.stringAbs(this.safeString(trade, 'amount'));
                    const marketId = this.safeString(trade, 'pair');
                    const symbol = this.safeSymbol(marketId, market);
                    const side = this.safeString2(trade, 'side', 'orderType');
                    let fee = undefined;
                    const feeAmountString = this.safeString(trade, 'fee');
                    if (feeAmountString !== undefined) {
                        const feeCurrency = this.safeString(trade, 'denominatorSymbol');
                        fee = {
                            'cost': Precise.stringAbs(feeAmountString),
                            'currency': this.safeCurrencyCode(feeCurrency)
                        };
                    }
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    // let maxCount = 50;
                    const request = {
                        'pairSymbol': market['id']
                    };
                    if (limit !== undefined) request['last'] = limit;
                    const response = await this.publicGetTrades(this.extend(request, params));
                    //
                    //     {
                    //       "data": [
                    //         {
                    //           "pair": "BTCTRY",
                    //           "pairNormalized": "BTC_TRY",
                    //           "numerator": "BTC",
                    //           "denominator": "TRY",
                    //           "date": 1618828421497,
                    //           "tid": "637544252214980918",
                    //           "price": "462585.00",
                    //           "amount": "0.01618411",
                    //           "side": "sell"
                    //         }
                    //       ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseTrades(data, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //     {
                    //        "pair": "BTCTRY",
                    //        "time": 1508284800,
                    //        "open": 20873.689453125,
                    //        "high": 20925.0,
                    //        "low": 19310.0,
                    //        "close": 20679.55078125,
                    //        "volume": 402.216101626982,
                    //        "total": 8103096.44443274,
                    //        "average": 20146.13,
                    //        "dailyChangeAmount": -194.14,
                    //        "dailyChangePercentage": -0.93
                    //      },
                    return [
                        this.safeTimestamp(ohlcv, 'time'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1d', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['last'] = limit;
                    const response = await this.graphGetOhlcs(this.extend(request, params));
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'orderType': side,
                        'orderMethod': type,
                        'pairSymbol': market['id'],
                        'quantity': this.amountToPrecision(symbol, amount)
                    };
                    if (type !== 'market') request['price'] = this.priceToPrecision(symbol, price);
                    if ('clientOrderId' in params) request['newClientOrderId'] = params['clientOrderId'];
                    else if (!('newClientOrderId' in params)) request['newClientOrderId'] = this.uuid();
                    const response = await this.privatePostOrder(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'id': id
                    };
                    return await this.privateDeleteOrder(this.extend(request, params));
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['pairSymbol'] = market['id'];
                    }
                    const response = await this.privateGetOpenOrders(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    const bids = this.safeValue(data, 'bids', []);
                    const asks = this.safeValue(data, 'asks', []);
                    return this.parseOrders(this.arrayConcat(bids, asks), market, since, limit);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pairSymbol': market['id']
                    };
                    if (limit !== undefined) // default 100 max 1000
                    request['last'] = limit;
                    if (since !== undefined) request['startTime'] = Math.floor(since / 1000);
                    const response = await this.privateGetAllOrders(this.extend(request, params));
                    // {
                    //   "data": [
                    //     {
                    //       "id": "2606012912",
                    //       "price": "55000",
                    //       "amount": "0.0003",
                    //       "quantity": "0.0003",
                    //       "stopPrice": "0",
                    //       "pairSymbol": "BTCUSDT",
                    //       "pairSymbolNormalized": "BTC_USDT",
                    //       "type": "buy",
                    //       "method": "limit",
                    //       "orderClientId": "2ed187bd-59a8-4875-a212-1b793963b85c",
                    //       "time": "1618913189253",
                    //       "updateTime": "1618913189253",
                    //       "status": "Untouched",
                    //       "leftAmount": "0.0003000000000000"
                    //     }
                    //   ]
                    // }
                    const data = this.safeValue(response, 'data');
                    return this.parseOrders(data, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'Untouched': 'open',
                        'Partial': 'open',
                        'Canceled': 'canceled',
                        'Closed': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // fetchOrders / fetchOpenOrders
                    //     {
                    //       "id": 2605984008,
                    //       "price": "55000",
                    //       "amount": "0.00050000",
                    //       "quantity": "0.00050000",
                    //       "stopPrice": "0",
                    //       "pairSymbol": "BTCUSDT",
                    //       "pairSymbolNormalized": "BTC_USDT",
                    //       "type": "buy",
                    //       "method": "limit",
                    //       "orderClientId": "f479bdb6-0965-4f03-95b5-daeb7aa5a3a5",
                    //       "time": 0,
                    //       "updateTime": 1618913083543,
                    //       "status": "Untouched",
                    //       "leftAmount": "0.00050000"
                    //     }
                    //
                    // createOrder
                    //     {
                    //       "id": "2606935102",
                    //       "quantity": "0.0002",
                    //       "price": "56000",
                    //       "stopPrice": null,
                    //       "newOrderClientId": "98e5c491-7ed9-462b-9666-93553180fb28",
                    //       "type": "buy",
                    //       "method": "limit",
                    //       "pairSymbol": "BTCUSDT",
                    //       "pairSymbolNormalized": "BTC_USDT",
                    //       "datetime": "1618916479523"
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const price = this.safeString(order, 'price');
                    const amountString = this.safeString2(order, 'amount', 'quantity');
                    const amount = Precise.stringAbs(amountString);
                    const remaining = this.safeString(order, 'leftAmount');
                    const marketId = this.safeNumber(order, 'pairSymbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const side = this.safeString(order, 'type');
                    const type = this.safeString(order, 'method');
                    const clientOrderId = this.safeString(order, 'orderClientId');
                    const timestamp = this.safeInteger2(order, 'updateTime', 'datetime');
                    const rawStatus = this.safeString(order, 'status');
                    const status = this.parseOrderStatus(rawStatus);
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'price': price,
                        'amount': amount,
                        'remaining': remaining,
                        'filled': undefined,
                        'cost': undefined,
                        'average': undefined,
                        'status': status,
                        'side': side,
                        'type': type,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'fee': undefined
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const response = await this.privateGetUsersTransactionsTrade();
                    //
                    //     {
                    //       "data": [
                    //         {
                    //           "price": "56000",
                    //           "numeratorSymbol": "BTC",
                    //           "denominatorSymbol": "USDT",
                    //           "orderType": "buy",
                    //           "orderId": "2606935102",
                    //           "id": "320874372",
                    //           "timestamp": "1618916479593",
                    //           "amount": "0.00020000",
                    //           "fee": "0",
                    //           "tax": "0"
                    //         }
                    //       ],
                    //       "success": true,
                    //       "message": "SUCCESS",
                    //       "code": "0"
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseTrades(data, market, since, limit);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    if (this.id === 'btctrader') throw new ExchangeError1(this.id + ' is an abstract base API for BTCExchange, BTCTurk');
                    let url = this.urls['api'][api] + '/' + path;
                    if (method === 'GET' || method === 'DELETE') {
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    } else body = this.json(params);
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const secret = this.base64ToBinary(this.secret);
                        const auth = this.apiKey + nonce;
                        headers = {
                            'X-PCK': this.apiKey,
                            'X-Stamp': nonce,
                            'X-Signature': this.hmac(this.encode(auth), secret, 'sha256', 'base64'),
                            'Content-Type': 'application/json'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    const errorCode = this.safeString(response, 'code', '0');
                    const message = this.safeString(response, 'message');
                    const output = message === undefined ? body : message;
                    this.throwExactlyMatchedException(this.exceptions['exact'], message, this.id + ' ' + output);
                    if (errorCode !== '0') throw new ExchangeError1(this.id + ' ' + output);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    56: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AddressPending: AddressPending, AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, NotSupported: NotSupported, PermissionDenied: PermissionDenied, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class buda extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'buda',
                        'name': 'Buda',
                        'countries': [
                            'AR',
                            'CL',
                            'CO',
                            'PE'
                        ],
                        'rateLimit': 1000,
                        'version': 'v2',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingFees': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': undefined,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/47380619-8a029200-d706-11e8-91e0-8a391fe48de3.jpg',
                            'api': 'https://www.buda.com/api',
                            'www': 'https://www.buda.com',
                            'doc': 'https://api.buda.com',
                            'fees': 'https://www.buda.com/comisiones'
                        },
                        'status': {
                            'status': 'error',
                            'updated': undefined,
                            'eta': undefined,
                            'url': undefined
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'pairs',
                                    'markets',
                                    'currencies',
                                    'markets/{market}',
                                    'markets/{market}/ticker',
                                    'markets/{market}/volume',
                                    'markets/{market}/order_book',
                                    'markets/{market}/trades',
                                    'currencies/{currency}/fees/deposit',
                                    'currencies/{currency}/fees/withdrawal',
                                    'tv/history'
                                ],
                                'post': [
                                    'markets/{market}/quotations'
                                ]
                            },
                            'private': {
                                'get': [
                                    'balances',
                                    'balances/{currency}',
                                    'currencies/{currency}/balances',
                                    'orders',
                                    'orders/{id}',
                                    'markets/{market}/orders',
                                    'deposits',
                                    'currencies/{currency}/deposits',
                                    'withdrawals',
                                    'currencies/{currency}/withdrawals',
                                    'currencies/{currency}/receive_addresses',
                                    'currencies/{currency}/receive_addresses/{id}'
                                ],
                                'post': [
                                    'markets/{market}/orders',
                                    'currencies/{currency}/deposits',
                                    'currencies/{currency}/withdrawals',
                                    'currencies/{currency}/simulated_withdrawals',
                                    'currencies/{currency}/receive_addresses'
                                ],
                                'put': [
                                    'orders/{id}'
                                ]
                            }
                        },
                        'timeframes': {
                            '1m': '1',
                            '5m': '5',
                            '30m': '30',
                            '1h': '60',
                            '2h': '120',
                            '1d': 'D',
                            '1w': 'W'
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': 0.008,
                                'maker': 0.004,
                                'tiers': {
                                    'taker': [
                                        [
                                            0,
                                            0.008
                                        ],
                                        [
                                            2000,
                                            0.007
                                        ],
                                        [
                                            20000,
                                            0.006
                                        ],
                                        [
                                            100000,
                                            0.005
                                        ],
                                        [
                                            500000,
                                            0.004
                                        ],
                                        [
                                            2500000,
                                            0.003
                                        ],
                                        [
                                            12500000,
                                            0.002
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            0,
                                            0.004
                                        ],
                                        [
                                            2000,
                                            0.0035
                                        ],
                                        [
                                            20000,
                                            0.003
                                        ],
                                        [
                                            100000,
                                            0.0025
                                        ],
                                        [
                                            500000,
                                            0.002
                                        ],
                                        [
                                            2500000,
                                            0.0015
                                        ],
                                        [
                                            12500000,
                                            0.001
                                        ]
                                    ]
                                }
                            }
                        },
                        'exceptions': {
                            'not_authorized': AuthenticationError,
                            'forbidden': PermissionDenied,
                            'invalid_record': ExchangeError1,
                            'not_found': ExchangeError1,
                            'parameter_missing': ExchangeError1,
                            'bad_parameter': ExchangeError1
                        }
                    });
                }
                async fetchCurrencyInfo(currency, currencies) {
                    if (!currencies) {
                        const response = await this.publicGetCurrencies();
                        //
                        //     {
                        //         "currencies":[
                        //             {
                        //                 "id":"BTC",
                        //                 "symbol":"฿",
                        //                 "managed":true,
                        //                 "input_decimals":8,
                        //                 "display_decimals":8,
                        //                 "timezone":"UTC",
                        //                 "deposit_minimum":["0.0","BTC"],
                        //                 "withdrawal_minimum":["0.00001","BTC"],
                        //                 "max_digits_for_decimals":6,
                        //                 "crypto":true,
                        //                 "address_explorer":"https://blockchair.com/bitcoin/address/",
                        //                 "tx_explorer":"https://blockchair.com/bitcoin/transaction/",
                        //                 "amount_to_micro_multiplier":1000000000000
                        //             }
                        //         ]
                        //     }
                        //
                        currencies = this.safeValue(response, 'currencies');
                    }
                    for(let i = 0; i < currencies.length; i++){
                        const currencyInfo = currencies[i];
                        if (currencyInfo['id'] === currency) return currencyInfo;
                    }
                    return undefined;
                }
                async fetchMarkets(params = {}) {
                    const marketsResponse = await this.publicGetMarkets(params);
                    const markets = this.safeValue(marketsResponse, 'markets');
                    const currenciesResponse = await this.publicGetCurrencies();
                    const currencies = this.safeValue(currenciesResponse, 'currencies');
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const baseId = this.safeString(market, 'base_currency');
                        const quoteId = this.safeString(market, 'quote_currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const baseInfo = await this.fetchCurrencyInfo(baseId, currencies);
                        const quoteInfo = await this.fetchCurrencyInfo(quoteId, currencies);
                        const pricePrecisionString = this.safeString(quoteInfo, 'input_decimals');
                        const minimumOrderAmount = this.safeValue(market, 'minimum_order_amount', []);
                        result.push({
                            'id': this.safeString(market, 'id'),
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(baseInfo, 'input_decimals'),
                                'price': parseInt(pricePrecisionString)
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(minimumOrderAmount, 0),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies();
                    //
                    //     {
                    //         "currencies":[
                    //             {
                    //                 "id":"BTC",
                    //                 "symbol":"฿",
                    //                 "managed":true,
                    //                 "input_decimals":8,
                    //                 "display_decimals":8,
                    //                 "timezone":"UTC",
                    //                 "deposit_minimum":["0.0","BTC"],
                    //                 "withdrawal_minimum":["0.00001","BTC"],
                    //                 "max_digits_for_decimals":6,
                    //                 "crypto":true,
                    //                 "address_explorer":"https://blockchair.com/bitcoin/address/",
                    //                 "tx_explorer":"https://blockchair.com/bitcoin/transaction/",
                    //                 "amount_to_micro_multiplier":1000000000000
                    //             }
                    //         ]
                    //     }
                    //
                    const currencies = response['currencies'];
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const managed = this.safeValue(currency, 'managed', false);
                        if (!managed) continue;
                        const id = this.safeString(currency, 'id');
                        const code = this.safeCurrencyCode(id);
                        const precision = this.safeNumber(currency, 'input_decimals');
                        const minimum = Math.pow(10, -precision);
                        const depositMinimum = this.safeValue(currency, 'deposit_minimum', []);
                        const withdrawalMinimum = this.safeValue(currency, 'withdrawal_minimum', []);
                        const minDeposit = this.safeNumber(depositMinimum, 0);
                        const minWithdraw = this.safeNumber(withdrawalMinimum, 0);
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'name': undefined,
                            'active': true,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': undefined,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': minimum,
                                    'max': undefined
                                },
                                'deposit': {
                                    'min': minDeposit,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': minWithdraw
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchFundingFees(codes, params = {}) {
                    //  by default it will try load withdrawal fees of all currencies (with separate requests)
                    //  however if you define codes = [ 'ETH', 'BTC' ] in args it will only load those
                    await this.loadMarkets();
                    const withdrawFees = {};
                    const depositFees = {};
                    const info = {};
                    if (codes === undefined) codes = Object.keys(this.currencies);
                    for(let i = 0; i < codes.length; i++){
                        const code = codes[i];
                        const currency = this.currency(code);
                        const request = {
                            'currency': currency['id']
                        };
                        const withdrawResponse = await this.publicGetCurrenciesCurrencyFeesWithdrawal(request);
                        const depositResponse = await this.publicGetCurrenciesCurrencyFeesDeposit(request);
                        withdrawFees[code] = this.parseFundingFee(withdrawResponse['fee']);
                        depositFees[code] = this.parseFundingFee(depositResponse['fee']);
                        info[code] = {
                            'withdraw': withdrawResponse,
                            'deposit': depositResponse
                        };
                    }
                    return {
                        'withdraw': withdrawFees,
                        'deposit': depositFees,
                        'info': info
                    };
                }
                parseFundingFee(fee, type) {
                    if (type === undefined) type = fee['name'];
                    if (type === 'withdrawal') type = 'withdraw';
                    return {
                        'type': type,
                        'currency': fee['base'][1],
                        'rate': fee['percent'],
                        'cost': parseFloat(fee['base'][0])
                    };
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.publicGetMarketsMarketTicker(this.extend(request, params));
                    //
                    //     {
                    //         "ticker":{
                    //             "market_id":"ETH-BTC",
                    //             "last_price":["0.07300001","BTC"],
                    //             "min_ask":["0.07716895","BTC"],
                    //             "max_bid":["0.0754966","BTC"],
                    //             "volume":["0.168965697","ETH"],
                    //             "price_variation_24h":"-0.046",
                    //             "price_variation_7d":"-0.085"
                    //         }
                    //     }
                    //
                    const ticker = this.safeValue(response, 'ticker');
                    return this.parseTicker(ticker, market);
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker
                    //
                    //     {
                    //         "market_id":"ETH-BTC",
                    //         "last_price":["0.07300001","BTC"],
                    //         "min_ask":["0.07716895","BTC"],
                    //         "max_bid":["0.0754966","BTC"],
                    //         "volume":["0.168965697","ETH"],
                    //         "price_variation_24h":"-0.046",
                    //         "price_variation_7d":"-0.085"
                    //     }
                    //
                    const timestamp = this.milliseconds();
                    const marketId = this.safeString(ticker, 'market_id');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const lastPrice = this.safeValue(ticker, 'last_price', []);
                    const last = this.safeString(lastPrice, 0);
                    let percentage = this.safeString(ticker, 'price_variation_24h');
                    percentage = Precise.stringMul(percentage, '100');
                    const maxBid = this.safeValue(ticker, 'max_bid', []);
                    const minAsk = this.safeValue(ticker, 'min_ask', []);
                    const baseVolume = this.safeValue(ticker, 'volume', []);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': undefined,
                        'low': undefined,
                        'bid': this.safeString(maxBid, 0),
                        'bidVolume': undefined,
                        'ask': this.safeString(minAsk, 0),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': this.safeString(baseVolume, 0),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    // the since argument works backwards – returns trades up to the specified timestamp
                    // therefore not implemented here
                    // the method is still available for users to be able to traverse backwards in time
                    // by using the timestamp from the first received trade upon each iteration
                    if (limit !== undefined) request['limit'] = limit; // 50 max
                    const response = await this.publicGetMarketsMarketTrades(this.extend(request, params));
                    //
                    //     { trades: {      market_id:   "ETH-BTC",
                    //                      timestamp:    null,
                    //                 last_timestamp:   "1536901277302",
                    //                        entries: [ [ "1540077456791", "0.0063767", "0.03", "sell", 479842 ],
                    //                                   [ "1539916642772", "0.01888263", "0.03019563", "sell", 479438 ],
                    //                                   [ "1539834081787", "0.023718648", "0.031001", "sell", 479069 ],
                    //                                   ... ]
                    //
                    return this.parseTrades(response['trades']['entries'], market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //  [ "1540077456791", "0.0063767", "0.03", "sell", 479842 ]
                    //
                    let timestamp = undefined;
                    let side = undefined;
                    const type = undefined;
                    let priceString = undefined;
                    let amountString = undefined;
                    let id = undefined;
                    const order = undefined;
                    const fee = undefined;
                    let symbol = undefined;
                    if (market) symbol = market['symbol'];
                    if (Array.isArray(trade)) {
                        timestamp = this.safeInteger(trade, 0);
                        priceString = this.safeString(trade, 1);
                        amountString = this.safeString(trade, 2);
                        side = this.safeString(trade, 3);
                        id = this.safeString(trade, 4);
                    }
                    return this.safeTrade({
                        'id': id,
                        'order': order,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.publicGetMarketsMarketOrderBook(this.extend(request, params));
                    const orderbook = this.safeValue(response, 'order_book');
                    return this.parseOrderBook(orderbook, symbol);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (since === undefined) since = this.milliseconds() - 86400000;
                    const request = {
                        'symbol': market['id'],
                        'resolution': this.timeframes[timeframe],
                        'from': since / 1000,
                        'to': this.seconds()
                    };
                    const response = await this.publicGetTvHistory(this.extend(request, params));
                    return this.parseTradingViewOHLCV(response, market, timeframe, since, limit);
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const balances = this.safeValue(response, 'balances');
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'id');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance['available_amount'], 0);
                        account['total'] = this.safeString(balance['amount'], 0);
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalances(params);
                    return this.parseBalance(response);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': parseInt(id)
                    };
                    const response = await this.privateGetOrdersId(this.extend(request, params));
                    const order = this.safeValue(response, 'order');
                    return this.parseOrder(order);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'per': limit
                    };
                    const response = await this.privateGetMarketsMarketOrders(this.extend(request, params));
                    const orders = this.safeValue(response, 'orders');
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'state': 'pending'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'state': 'traded'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    side = side === 'buy' ? 'Bid' : 'Ask';
                    const request = {
                        'market': this.marketId(symbol),
                        'price_type': type,
                        'type': side,
                        'amount': this.amountToPrecision(symbol, amount)
                    };
                    if (type === 'limit') request['limit'] = this.priceToPrecision(symbol, price);
                    const response = await this.privatePostMarketsMarketOrders(this.extend(request, params));
                    const order = this.safeValue(response, 'order');
                    return this.parseOrder(order);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': parseInt(id),
                        'state': 'canceling'
                    };
                    const response = await this.privatePutOrdersId(this.extend(request, params));
                    const order = this.safeValue(response, 'order');
                    return this.parseOrder(order);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'traded': 'closed',
                        'received': 'open',
                        'canceling': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         'id': 63679183,
                    //         'uuid': 'f9697bee-627e-4175-983f-0d5a41963fec',
                    //         'market_id': 'ETH-CLP',
                    //         'account_id': 51590,
                    //         'type': 'Ask',
                    //         'state': 'received',
                    //         'created_at': '2021-01-04T08:29:52.730Z',
                    //         'fee_currency': 'CLP',
                    //         'price_type': 'limit',
                    //         'source': None,
                    //         'limit': ['741000.0', 'CLP'],
                    //         'amount': ['0.001', 'ETH'],
                    //         'original_amount': ['0.001', 'ETH'],
                    //         'traded_amount': ['0.0', 'ETH'],
                    //         'total_exchanged': ['0.0', 'CLP'],
                    //         'paid_fee': ['0.0', 'CLP']
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const datetime = this.iso8601(timestamp);
                    const marketId = this.safeString(order, 'market_id');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const type = this.safeString(order, 'price_type');
                    const side = this.safeStringLower(order, 'type');
                    const status = this.parseOrderStatus(this.safeString(order, 'state'));
                    const originalAmount = this.safeValue(order, 'original_amount', []);
                    const amount = this.safeString(originalAmount, 0);
                    const remainingAmount = this.safeValue(order, 'amount', []);
                    const remaining = this.safeString(remainingAmount, 0);
                    const tradedAmount = this.safeValue(order, 'traded_amount', []);
                    const filled = this.safeString(tradedAmount, 0);
                    const totalExchanged = this.safeValue(order, 'totalExchanged', []);
                    const cost = this.safeString(totalExchanged, 0);
                    const limitPrice = this.safeValue(order, 'limit', []);
                    let price = this.safeString(limitPrice, 0);
                    if (price === undefined) {
                        if (limitPrice !== undefined) price = limitPrice;
                    }
                    const paidFee = this.safeValue(order, 'paid_fee', []);
                    const feeCost = this.safeString(paidFee, 0);
                    let fee = undefined;
                    if (feeCost !== undefined) {
                        const feeCurrencyId = this.safeString(paidFee, 1);
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCost,
                            'code': feeCurrencyCode
                        };
                    }
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'datetime': datetime,
                        'timestamp': timestamp,
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'average': undefined,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'trades': undefined,
                        'fee': fee
                    }, market);
                }
                isFiat(code) {
                    const fiats = {
                        'ARS': true,
                        'CLP': true,
                        'COP': true,
                        'PEN': true
                    };
                    return this.safeValue(fiats, code, false);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (this.isFiat(code)) throw new NotSupported(this.id + ' fetchDepositAddress() for fiat ' + code + ' is not supported');
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateGetCurrenciesCurrencyReceiveAddresses(this.extend(request, params));
                    const receiveAddresses = this.safeValue(response, 'receive_addresses');
                    const addressPool = [];
                    for(let i = 1; i < receiveAddresses.length; i++){
                        const receiveAddress = receiveAddresses[i];
                        if (receiveAddress['ready']) {
                            const address = receiveAddress['address'];
                            this.checkAddress(address);
                            addressPool.push(address);
                        }
                    }
                    const addressPoolLength = addressPool.length;
                    if (addressPoolLength < 1) throw new AddressPending(this.id + ': there are no addresses ready for receiving ' + code + ', retry again later)');
                    const address = addressPool[0];
                    return {
                        'currency': code,
                        'address': address,
                        'tag': undefined,
                        'network': undefined,
                        'info': receiveAddresses
                    };
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (this.isFiat(code)) throw new NotSupported(this.id + ' fetchDepositAddress() of fiat for ' + code + ' is not supported');
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privatePostCurrenciesCurrencyReceiveAddresses(this.extend(request, params));
                    const address = this.safeString(response['receive_address'], 'address'); // the creation is async and returns a null address, returns only the id
                    return {
                        'currency': code,
                        'address': address,
                        'tag': undefined,
                        'info': response
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'rejected': 'failed',
                        'confirmed': 'ok',
                        'anulled': 'canceled',
                        'retained': 'canceled',
                        'pending_confirmation': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    const id = this.safeString(transaction, 'id');
                    const timestamp = this.parse8601(this.safeString(transaction, 'created_at'));
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const amount = parseFloat(transaction['amount'][0]);
                    const fee = parseFloat(transaction['fee'][0]);
                    const feeCurrency = transaction['fee'][1];
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    const type = 'deposit_data' in transaction ? 'deposit' : 'withdrawal';
                    const data = this.safeValue(transaction, type + '_data', {});
                    const address = this.safeValue(data, 'target_address');
                    const txid = this.safeString(data, 'tx_hash');
                    const updated = this.parse8601(this.safeString(data, 'updated_at'));
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': {
                            'cost': fee,
                            'rate': feeCurrency
                        }
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires a currency code argument');
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'per': limit
                    };
                    const response = await this.privateGetCurrenciesCurrencyDeposits(this.extend(request, params));
                    const deposits = this.safeValue(response, 'deposits');
                    return this.parseTransactions(deposits, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires a currency code argument');
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'per': limit
                    };
                    const response = await this.privateGetCurrenciesCurrencyWithdrawals(this.extend(request, params));
                    const withdrawals = this.safeValue(response, 'withdrawals');
                    return this.parseTransactions(withdrawals, currency, since, limit);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'amount': amount,
                        'withdrawal_data': {
                            'target_address': address
                        }
                    };
                    const response = await this.privatePostCurrenciesCurrencyWithdrawals(this.extend(request, params));
                    const withdrawal = this.safeValue(response, 'withdrawal');
                    return this.parseTransaction(withdrawal);
                }
                nonce() {
                    return this.microseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let request = this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (Object.keys(query).length) {
                        if (method === 'GET') request += '?' + this.urlencode(query);
                        else body = this.json(query);
                    }
                    const url = this.urls['api'] + '/' + this.version + '/' + request;
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const components = [
                            method,
                            '/api/' + this.version + '/' + request
                        ];
                        if (body) {
                            const base64Body = this.stringToBase64(body);
                            components.push(this.decode(base64Body));
                        }
                        components.push(nonce);
                        const message = components.join(' ');
                        const signature = this.hmac(this.encode(message), this.encode(this.secret), 'sha384');
                        headers = {
                            'X-SBTC-APIKEY': this.apiKey,
                            'X-SBTC-SIGNATURE': signature,
                            'X-SBTC-NONCE': nonce,
                            'Content-Type': 'application/json'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if (code >= 400) {
                        const errorCode = this.safeString(response, 'code');
                        const message = this.safeString(response, 'message', body);
                        const feedback = this.id + ' ' + message;
                        if (errorCode !== undefined) {
                            this.throwExactlyMatchedException(this.exceptions, errorCode, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    57: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { RateLimitExceeded: RateLimitExceeded, BadSymbol: BadSymbol, OrderNotFound: OrderNotFound, ExchangeError: ExchangeError1, AuthenticationError: AuthenticationError, ArgumentsRequired: ArgumentsRequired1, ExchangeNotAvailable: ExchangeNotAvailable } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class bw extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bw',
                        'name': 'BW',
                        'countries': [
                            'CN'
                        ],
                        'rateLimit': 1500,
                        'version': 'v1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': undefined,
                            'cancelOrder': true,
                            'cancelOrders': undefined,
                            'createDepositAddress': undefined,
                            'createLimitOrder': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'editOrder': undefined,
                            'fetchBalance': true,
                            'fetchBidsAsks': undefined,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingFees': undefined,
                            'fetchL2OrderBook': undefined,
                            'fetchLedger': undefined,
                            'fetchMarkets': true,
                            'fetchMyTrades': undefined,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': undefined,
                            'fetchOrders': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTradingLimits': undefined,
                            'fetchTransactions': undefined,
                            'fetchWithdrawals': true,
                            'withdraw': undefined
                        },
                        'timeframes': {
                            '1m': '1M',
                            '5m': '5M',
                            '15m': '15M',
                            '30m': '30M',
                            '1h': '1H',
                            '1w': '1W'
                        },
                        'hostname': 'bw.com',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/69436317-31128c80-0d52-11ea-91d1-eb7bb5818812.jpg',
                            'api': 'https://www.{hostname}',
                            'www': 'https://www.bw.com',
                            'doc': 'https://github.com/bw-exchange/api_docs_en/wiki',
                            'fees': 'https://www.bw.com/feesRate',
                            'referral': 'https://www.bw.com/regGetCommission/N3JuT1R3bWxKTE0'
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.002'),
                                'maker': this.parseNumber('0.002')
                            },
                            'funding': {}
                        },
                        'exceptions': {
                            'exact': {
                                '999': AuthenticationError,
                                '1000': ExchangeNotAvailable,
                                '2012': OrderNotFound,
                                '5017': BadSymbol,
                                '10001': RateLimitExceeded
                            }
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'api/data/v1/klines',
                                    'api/data/v1/ticker',
                                    'api/data/v1/tickers',
                                    'api/data/v1/trades',
                                    'api/data/v1/entrusts',
                                    'exchange/config/controller/website/marketcontroller/getByWebId',
                                    'exchange/config/controller/website/currencycontroller/getCurrencyList'
                                ]
                            },
                            'private': {
                                'get': [
                                    'exchange/entrust/controller/website/EntrustController/getEntrustById',
                                    'exchange/entrust/controller/website/EntrustController/getUserEntrustRecordFromCacheWithPage',
                                    'exchange/entrust/controller/website/EntrustController/getUserEntrustList',
                                    'exchange/fund/controller/website/fundwebsitecontroller/getwithdrawaddress',
                                    'exchange/fund/controller/website/fundwebsitecontroller/getpayoutcoinrecord',
                                    'exchange/entrust/controller/website/EntrustController/getUserEntrustList'
                                ],
                                'post': [
                                    'exchange/fund/controller/website/fundcontroller/getPayinAddress',
                                    'exchange/fund/controller/website/fundcontroller/getPayinCoinRecord',
                                    'exchange/fund/controller/website/fundcontroller/findbypage',
                                    'exchange/entrust/controller/website/EntrustController/addEntrust',
                                    'exchange/entrust/controller/website/EntrustController/cancelEntrust'
                                ]
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetExchangeConfigControllerWebsiteMarketcontrollerGetByWebId(params);
                    //
                    //    {
                    //        resMsg: {
                    //            method: null,
                    //            code: '1',
                    //            message: 'success !'
                    //        },
                    //        datas: [
                    //            {
                    //                leverMultiple: '10',
                    //                amountDecimal: '4',
                    //                minAmount: '0.0100000000',
                    //                modifyUid: null,
                    //                buyerCurrencyId: '11',
                    //                isCombine: '0',
                    //                priceDecimal: '3',
                    //                combineMarketId: '',
                    //                openPrice: '0',
                    //                leverEnable: true,
                    //                marketId: '291',
                    //                serverId: 'entrust_bw_2',
                    //                isMining: '0',
                    //                webId: '102',
                    //                modifyTime: '1581595375498',
                    //                defaultFee: '0.00200000',
                    //                sellerCurrencyId: '7',
                    //                createTime: '0',
                    //                state: '1',
                    //                name: 'eos_usdt',
                    //                leverType: '2',
                    //                createUid: null,
                    //                orderNum: null,
                    //                openTime: '1574956800000'
                    //            },
                    //        ]
                    //    }
                    //
                    const markets = this.safeValue(response, 'datas', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'marketId');
                        const numericId = parseInt(id);
                        const name = this.safeStringUpper(market, 'name');
                        let [base, quote] = name.split('_');
                        base = this.safeCurrencyCode(base);
                        quote = this.safeCurrencyCode(quote);
                        const baseId = this.safeString(market, 'sellerCurrencyId');
                        const quoteId = this.safeString(market, 'buyerCurrencyId');
                        const state = this.safeInteger(market, 'state');
                        const fee = this.safeNumber(market, 'defaultFee');
                        result.push({
                            'id': id,
                            'numericId': numericId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'baseNumericId': parseInt(baseId),
                            'quoteNumericId': parseInt(quoteId),
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': state === 1,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': fee,
                            'maker': fee,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'amountDecimal'),
                                'price': this.safeInteger(market, 'priceDecimal')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minAmount'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': this.parseNumber('0'),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.parseNumber('0'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetExchangeConfigControllerWebsiteCurrencycontrollerGetCurrencyList(params);
                    //
                    //     {
                    //         "datas":[
                    //             {
                    //                 "currencyId":"456",
                    //                 "name":"pan",
                    //                 "alias":"pan",
                    //                 "logo":"pan.svg",
                    //                 "description":"pan",
                    //                 "descriptionEnglish":"pan",
                    //                 "defaultDecimal":2,
                    //                 "createUid":null,
                    //                 "createTime":1574068133762,
                    //                 "modifyUid":null,
                    //                 "modifyTime":0,
                    //                 "state":1,
                    //                 "mark":"pan",
                    //                 "totalNumber":"0",
                    //                 "publishNumber":"0",
                    //                 "marketValue":"0",
                    //                 "isLegalCoin":0,
                    //                 "needBlockUrl":1,
                    //                 "blockChainUrl":"https://etherscan.io/tx/",
                    //                 "tradeSearchUrl":null,
                    //                 "tokenCoinsId":0,
                    //                 "isMining":"0",
                    //                 "arithmetic":null,
                    //                 "founder":"bw_nxwal",
                    //                 "teamAddress":null,
                    //                 "remark":null,
                    //                 "tokenName":"ethw2",
                    //                 "isMemo":0,
                    //                 "websiteCurrencyId":"7rhqoHLohkG",
                    //                 "drawFlag":0,
                    //                 "rechargeFlag":1,
                    //                 "drawFee":"0.03000000",
                    //                 "onceDrawLimit":100,
                    //                 "dailyDrawLimit":500,
                    //                 "timesFreetrial":"0",
                    //                 "hourFreetrial":"0",
                    //                 "dayFreetrial":"0",
                    //                 "minFee":"0",
                    //                 "inConfigTimes":7,
                    //                 "outConfigTimes":7,
                    //                 "minCash":"0.06000000",
                    //                 "limitAmount":"0",
                    //                 "zbExist":false,
                    //                 "zone":1
                    //             },
                    //         ],
                    //         "resMsg": { "message":"success !", "method":null, "code":"1" }
                    //     }
                    //
                    const currencies = this.safeValue(response, 'datas', []);
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'currencyId');
                        const code = this.safeCurrencyCode(this.safeStringUpper(currency, 'name'));
                        const state = this.safeInteger(currency, 'state');
                        const rechargeFlag = this.safeInteger(currency, 'rechargeFlag');
                        const drawFlag = this.safeInteger(currency, 'drawFlag');
                        const deposit = rechargeFlag === 1;
                        const withdraw = drawFlag === 1;
                        const active = state === 1;
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'name': code,
                            'active': active,
                            'deposit': deposit,
                            'withdraw': withdraw,
                            'fee': this.safeNumber(currency, 'drawFee'),
                            'precision': undefined,
                            'limits': {
                                'amount': {
                                    'min': this.safeNumber(currency, 'limitAmount', 0),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': this.safeNumber(currency, 'onceDrawLimit')
                                }
                            }
                        };
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    //     [
                    //         "281",            // market id
                    //         "9754.4",         // last
                    //         "9968.8",         // high
                    //         "9631.5",         // low
                    //         "47865.6432",     // base volume
                    //         "-2.28",          // change
                    //         // closing price for last 6 hours
                    //         "[[1, 9750.1], [2, 9737.1], [3, 9727.5], [4, 9722], [5, 9722.1], [6, 9754.4]]",
                    //         "9752.12",        // bid
                    //         "9756.69",        // ask
                    //         "469849357.2364"  // quote volume
                    //     ]
                    //
                    const marketId = this.safeString(ticker, 0);
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const timestamp = this.milliseconds();
                    const close = this.safeString(ticker, 1);
                    const bid = this.safeValue(ticker, 'bid', {});
                    const ask = this.safeValue(ticker, 'ask', {});
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 2),
                        'low': this.safeString(ticker, 3),
                        'bid': this.safeString(ticker, 7),
                        'bidVolume': this.safeString(bid, 'quantity'),
                        'ask': this.safeString(ticker, 8),
                        'askVolume': this.safeString(ask, 'quantity'),
                        'vwap': undefined,
                        'open': undefined,
                        'close': close,
                        'last': close,
                        'previousClose': undefined,
                        'change': this.safeString(ticker, 5),
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 4),
                        'quoteVolume': this.safeString(ticker, 9),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id']
                    };
                    const response = await this.publicGetApiDataV1Ticker(this.extend(request, params));
                    //
                    //     {
                    //         "datas": [
                    //             "281",
                    //             "7601.99",
                    //             "8126.5",
                    //             "7474.68",
                    //             "47004.8708",
                    //             "-6.18",
                    //             "[[1, 7800.34], [2, 7626.41], [3, 7609.97], [4, 7569.04], [5, 7577.93], [6, 7601.99]]",
                    //             "7600.24",
                    //             "7603.69",
                    //             "371968300.0119",
                    //         ],
                    //         "resMsg": { "message": "success !", "method": null, "code": "1" }
                    //     }
                    //
                    const ticker = this.safeValue(response, 'datas', []);
                    return this.parseTicker(ticker, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetApiDataV1Tickers(params);
                    //
                    //     {
                    //         "datas": [
                    //             [
                    //                 "4051",
                    //                 "0.00194",
                    //                 "0.00863",
                    //                 "0.0012",
                    //                 "1519020",
                    //                 "-38.22",
                    //                 "[[1, 0.0023], [2, 0.00198], [3, 0.00199], [4, 0.00195], [5, 0.00199], [6, 0.00194]]",
                    //                 "0.00123",
                    //                 "0.0045",
                    //                 "4466.8104",
                    //             ],
                    //         ],
                    //         "resMsg": { "message": "success !", "method": null, "code": "1" },
                    //     }
                    //
                    const datas = this.safeValue(response, 'datas', []);
                    const result = {};
                    for(let i = 0; i < datas.length; i++){
                        const ticker = this.parseTicker(datas[i]);
                        const symbol = ticker['symbol'];
                        if (symbols === undefined || this.inArray(symbol, symbols)) result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id']
                    };
                    if (limit !== undefined) request['dataSize'] = limit;
                    const response = await this.publicGetApiDataV1Entrusts(this.extend(request, params));
                    //
                    //     {
                    //         "datas": {
                    //             "asks": [
                    //                 [ "9740.43", "0.0083" ],
                    //             ],
                    //             "bids": [
                    //                 [ "9734.33", "0.0133" ],
                    //             ],
                    //             "timestamp": "1569303520",
                    //         },
                    //         "resMsg": {
                    //             "message": "success !",
                    //             "method": null,
                    //             "code": "1",
                    //         },
                    //     }
                    //
                    const orderbook = this.safeValue(response, 'datas', []);
                    const timestamp = this.safeTimestamp(orderbook, 'timestamp');
                    return this.parseOrderBook(orderbook, symbol, timestamp);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     [
                    //         "T",          // trade
                    //         "281",        // market id
                    //         "1569303302", // timestamp
                    //         "BTC_USDT",   // market name
                    //         "ask",        // side
                    //         "9745.08",    // price
                    //         "0.0026"      // amount
                    //     ]
                    //
                    // fetchMyTrades (private)
                    //
                    //     ...
                    //
                    const timestamp = this.safeTimestamp(trade, 2);
                    const priceString = this.safeString(trade, 5);
                    const amountString = this.safeString(trade, 6);
                    let marketId = this.safeString(trade, 1);
                    let delimiter = undefined;
                    if (marketId !== undefined) {
                        if (!(marketId in this.markets_by_id)) {
                            delimiter = '_';
                            marketId = this.safeString(trade, 3);
                        }
                    }
                    market = this.safeMarket(marketId, market, delimiter);
                    const sideString = this.safeString(trade, 4);
                    const side = sideString === 'ask' ? 'sell' : 'buy';
                    return this.safeTrade({
                        'id': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': undefined,
                        'type': 'limit',
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': undefined,
                        'info': trade
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id']
                    };
                    if (limit !== undefined) request['dataSize'] = limit; // max 20
                    const response = await this.publicGetApiDataV1Trades(this.extend(request, params));
                    //
                    //     {
                    //         "datas": [
                    //             [
                    //                 "T",          // trade
                    //                 "281",        // market id
                    //                 "1569303302", // timestamp
                    //                 "BTC_USDT",   // market name
                    //                 "ask",        // side
                    //                 "9745.08",    // price
                    //                 "0.0026"      // amount
                    //             ],
                    //         ],
                    //         "resMsg": { "code": "1", "method": null, "message": "success !" },
                    //     }
                    //
                    const trades = this.safeValue(response, 'datas', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetExchangeConfigControllerWebsiteMarketcontrollerGetByWebId();
                    //
                    //    {
                    //        resMsg: { method: null, code: '1', message: 'success !' },
                    //        datas: [
                    //            {
                    //                leverMultiple: '10',
                    //                amountDecimal: '4',
                    //                minAmount: '0.0100000000',
                    //                modifyUid: null,
                    //                buyerCurrencyId: '11',
                    //                isCombine: '0',
                    //                priceDecimal: '3',
                    //                combineMarketId: '',
                    //                openPrice: '0',
                    //                leverEnable: true,
                    //                marketId: '291',
                    //                serverId: 'entrust_bw_2',
                    //                isMining: '0',
                    //                webId: '102',
                    //                modifyTime: '1581595375498',
                    //                defaultFee: '0.00200000',
                    //                sellerCurrencyId: '7',
                    //                createTime: '0',
                    //                state: '1',
                    //                name: 'eos_usdt',
                    //                leverType: '2',
                    //                createUid: null,
                    //                orderNum: null,
                    //                openTime: '1574956800000'
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    const datas = this.safeValue(response, 'datas', []);
                    const result = {};
                    for(let i = 0; i < datas.length; i++){
                        const data = datas[i];
                        const marketId = this.safeString(data, 'name');
                        const symbol = this.safeSymbol(marketId, undefined, '_');
                        const fee = this.safeNumber(data, 'defaultFee');
                        result[symbol] = {
                            'info': data,
                            'symbol': symbol,
                            'maker': fee,
                            'taker': fee,
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         "K",
                    //         "305",
                    //         "eth_btc",
                    //         "1591511280",
                    //         "0.02504",
                    //         "0.02504",
                    //         "0.02504",
                    //         "0.02504",
                    //         "0.0123",
                    //         "0",
                    //         "285740.17",
                    //         "1M",
                    //         "false",
                    //         "0.000308"
                    //     ]
                    //
                    return [
                        this.safeTimestamp(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5),
                        this.safeNumber(ohlcv, 6),
                        this.safeNumber(ohlcv, 7),
                        this.safeNumber(ohlcv, 8)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id'],
                        'type': this.timeframes[timeframe],
                        'dataSize': 500
                    };
                    if (limit !== undefined) request['dataSize'] = limit;
                    const response = await this.publicGetApiDataV1Klines(this.extend(request, params));
                    //
                    //     {
                    //         "datas":[
                    //             ["K","305","eth_btc","1591511280","0.02504","0.02504","0.02504","0.02504","0.0123","0","285740.17","1M","false","0.000308"],
                    //             ["K","305","eth_btc","1591511220","0.02504","0.02504","0.02504","0.02504","0.0006","0","285740.17","1M","false","0.00001502"],
                    //             ["K","305","eth_btc","1591511100","0.02505","0.02505","0.02504","0.02504","0.0012","-0.0399","285740.17","1M","false","0.00003005"],
                    //         ],
                    //         "resMsg":{"code":"1","method":null,"message":"success !"}
                    //     }
                    //
                    const data = this.safeValue(response, 'datas', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                parseBalance(response) {
                    const data = this.safeValue(response, 'datas', {});
                    const balances = this.safeValue(data, 'list', []);
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currencyTypeId');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'amount');
                        account['used'] = this.safeString(balance, 'freeze');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostExchangeFundControllerWebsiteFundcontrollerFindbypage(params);
                    //
                    //     {
                    //         "datas": {
                    //             "totalRow": 6,
                    //             "pageSize": 99,
                    //             "list": [
                    //                 {
                    //                     "amount": "0.000090000000000000", // The current number of tokens available
                    //                     "currencyTypeId": 2,              // Token ID
                    //                     "freeze": "0.009900000000000000", // Current token freezing quantity
                    //                 },
                    //             ],
                    //             "pageNum": 1,
                    //         },
                    //         "resMsg": { "code": "1", "message": "success !" }
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (price === undefined) throw new ExchangeError1(this.id + ' createOrder() allows limit orders only');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'amount': this.amountToPrecision(symbol, amount),
                        'price': this.priceToPrecision(symbol, price),
                        'type': side === 'buy' ? 1 : 0,
                        'rangeType': 0,
                        'marketId': market['id']
                    };
                    const response = await this.privatePostExchangeEntrustControllerWebsiteEntrustControllerAddEntrust(this.extend(request, params));
                    //
                    //     {
                    //         "datas": {
                    //             "entrustId": "E6581105708337483776",
                    //         },
                    //         "resMsg": {
                    //             "message": "success !",
                    //             "method": null,
                    //             "code": "1"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'datas');
                    const id = this.safeString(data, 'entrustId');
                    return {
                        'id': id,
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'average': undefined,
                        'filled': undefined,
                        'remaining': undefined,
                        'status': 'open',
                        'fee': undefined,
                        'trades': undefined,
                        'clientOrderId': undefined
                    };
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '-3': 'canceled',
                        '-2': 'canceled',
                        '-1': 'canceled',
                        '0': 'open',
                        '1': 'canceled',
                        '2': 'closed',
                        '3': 'open',
                        '4': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // fetchOrder, fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "entrustId": "E6581108027628212224", // Order id
                    //         "price": "1450",                     // price
                    //         "rangeType": 0,                      // Commission type 0: limit price commission 1: interval commission
                    //         "amount": "14.05",                   // Order quantity
                    //         "totalMoney": "20372.50",            // Total order amount
                    //         "completeAmount": "0",               // Quantity sold
                    //         "completeTotalMoney": "0",           // Total dealt amount
                    //         "type": 1,                           // 0 = sell, 1 = buy, -1 = cancel
                    //         "entrustType": 0,                    // 0 = ordinary current price commission, 1 = lever commission
                    //         "status": 0,                         //
                    //         "marketId": "318",                   // The market id
                    //         "createTime": 1569058424861,         // Create time
                    //         "availabelAmount": "14.05"           // Outstanding quantity, typo in the docs or in the API, availabel vs available
                    //     }
                    //
                    const marketId = this.safeString(order, 'marketId');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.safeInteger(order, 'createTime');
                    let side = this.safeString(order, 'type');
                    if (side === '0') side = 'sell';
                    else if (side === '1') side = 'buy';
                    const amount = this.safeString(order, 'amount');
                    const price = this.safeString(order, 'price');
                    const filled = this.safeString(order, 'completeAmount');
                    const remaining = this.safeString2(order, 'availabelAmount', 'availableAmount'); // typo in the docs or in the API, availabel vs available
                    const cost = this.safeString(order, 'totalMoney');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    return this.safeOrder({
                        'info': order,
                        'id': this.safeString(order, 'entrustId'),
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': 'limit',
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': cost,
                        'average': undefined,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id'],
                        'entrustId': id
                    };
                    const response = await this.privateGetExchangeEntrustControllerWebsiteEntrustControllerGetEntrustById(this.extend(request, params));
                    //
                    //     {
                    //         "datas": {
                    //             "entrustId": "E6581108027628212224", // Order id
                    //             "price": "1450",                     // price
                    //             "rangeType": 0,                      // Commission type 0: limit price commission 1: interval commission
                    //             "amount": "14.05",                   // Order quantity
                    //             "totalMoney": "20372.50",            // Total order amount
                    //             "completeAmount": "0",               // Quantity sold
                    //             "completeTotalMoney": "0",           // Total dealt amount
                    //             "type": 1,                           // Trade direction, 0: sell, 1: buy, -1: cancel
                    //             "entrustType": 0,                    // Commission type, 0: ordinary current price commission, 1: lever commission
                    //             "status": 0,                         // Order status,-3:fund Freeze exception,Order status to be confirmed  -2: fund freeze failure, order failure, -1: insufficient funds, order failure, 0: pending order, 1: cancelled, 2: dealt, 3: partially dealt
                    //             "marketId": "318",                   // The market id
                    //             "createTime": 1569058424861,         // Create time
                    //             "availabelAmount": "14.05"           // Outstanding quantity
                    //         },
                    //         "resMsg": { "message": "success !", "method": null, "code": "1" }
                    //     }
                    //
                    const order = this.safeValue(response, 'datas', {});
                    return this.parseOrder(order, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id'],
                        'entrustId': id
                    };
                    const response = await this.privatePostExchangeEntrustControllerWebsiteEntrustControllerCancelEntrust(this.extend(request, params));
                    //
                    //     {
                    //         "datas": null,
                    //         "resMsg": { "message": "success !", "method": null, "code": "1" }
                    //     }
                    //
                    return {
                        'info': response,
                        'id': id
                    };
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id']
                    };
                    if (limit !== undefined) request['pageSize'] = limit; // default limit is 20
                    const response = await this.privateGetExchangeEntrustControllerWebsiteEntrustControllerGetUserEntrustRecordFromCacheWithPage(this.extend(request, params));
                    //
                    //     {
                    //         "datas": {
                    //             "pageNum": 1,
                    //             "pageSize": 2,
                    //             "totalPage": 20,
                    //             "totalRow": 40,
                    //             "entrustList": [
                    //                 {
                    //                     "amount": "14.050000000000000000",        // Order quantity
                    //                     "rangeType": 0,                           // Commission type 0: limit price commission 1: interval commission
                    //                     "totalMoney": "20372.500000000000000000", // Total order amount
                    //                     "entrustId": "E6581108027628212224",      // Order id
                    //                     "type": 1,                                // Trade direction, 0: sell, 1: buy, -1: cancel
                    //                     "completeAmount": "0",                    // Quantity sold
                    //                     "marketId": "318",                        // The market id
                    //                     "createTime": 1569058424861,              // Create time
                    //                     "price": "1450.000000000",                // price
                    //                     "completeTotalMoney": "0",                // Quantity sold
                    //                     "entrustType": 0,                         // Commission type, 0: ordinary current price commission, 1: lever commission
                    //                     "status": 0                               // Order status,-3:fund Freeze exception,Order status to be confirmed  -2: fund freeze failure, order failure, -1: insufficient funds, order failure, 0: pending order, 1: cancelled, 2: dealt, 3: partially dealt
                    //                 },
                    //             ],
                    //         },
                    //         "resMsg": { "message": "success !", "method": null, "code": "1" },
                    //     }
                    //
                    const data = this.safeValue(response, 'datas', {});
                    const orders = this.safeValue(data, 'entrustList', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchClosedOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id']
                    };
                    if (limit !== undefined) request['pageSize'] = limit; // default limit is 20
                    if (since !== undefined) request['startDateTime'] = since;
                    const response = await this.privateGetExchangeEntrustControllerWebsiteEntrustControllerGetUserEntrustList(this.extend(request, params));
                    const data = this.safeValue(response, 'datas', {});
                    const orders = this.safeValue(data, 'entrustList', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'marketId': market['id']
                    };
                    if (since !== undefined) request['startDateTime'] = since;
                    if (limit !== undefined) request['pageSize'] = limit; // default limit is 20
                    const response = await this.privateGetExchangeEntrustControllerWebsiteEntrustControllerGetUserEntrustList(this.extend(request, params));
                    //
                    //     {
                    //         "datas": {
                    //             "pageNum": 1,
                    //             "pageSize": 2,
                    //             "totalPage": 20,
                    //             "totalRow": 40,
                    //             "entrustList": [
                    //                 {
                    //                     "amount": "14.050000000000000000",        // Order quantity
                    //                     "rangeType": 0,                           // Commission type 0: limit price commission 1: interval commission
                    //                     "totalMoney": "20372.500000000000000000", // Total order amount
                    //                     "entrustId": "E6581108027628212224",      // Order id
                    //                     "type": 1,                                // Trade direction, 0: sell, 1: buy, -1: cancel
                    //                     "completeAmount": "0",                    // Quantity sold
                    //                     "marketId": "318",                        // The market id
                    //                     "createTime": 1569058424861,              // Create time
                    //                     "price": "1450.000000000",                // price
                    //                     "completeTotalMoney": "0",                // Quantity sold
                    //                     "entrustType": 0,                         // Commission type, 0: ordinary current price commission, 1: lever commission
                    //                     "status": 0                               // Order status,-3:fund Freeze exception,Order status to be confirmed  -2: fund freeze failure, order failure, -1: insufficient funds, order failure, 0: pending order, 1: cancelled, 2: dealt, 3: partially dealt
                    //                 },
                    //             ],
                    //         },
                    //         "resMsg": { "message": "success !", "method": null, "code": "1" },
                    //     }
                    //
                    const data = this.safeValue(response, 'datas', {});
                    const orders = this.safeValue(data, 'entrustList', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.implodeHostname(this.urls['api']) + '/' + path;
                    if (method === 'GET') {
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    } else body = this.json(params);
                    if (api === 'private') {
                        const ms = this.milliseconds().toString();
                        let content = '';
                        if (method === 'GET') {
                            const sortedParams = this.keysort(params);
                            const keys = Object.keys(sortedParams);
                            for(let i = 0; i < keys.length; i++){
                                const key = keys[i];
                                content += key + sortedParams[key].toString();
                            }
                        } else content = body;
                        const signature = this.apiKey + ms + content + this.secret;
                        const hash = this.hash(this.encode(signature), 'md5');
                        if (!headers) headers = {};
                        headers['Apiid'] = this.apiKey;
                        headers['Timestamp'] = ms;
                        headers['Sign'] = hash;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currencyTypeName': currency['name']
                    };
                    const response = await this.privatePostExchangeFundControllerWebsiteFundcontrollerGetPayinAddress(this.extend(request, params));
                    //
                    //     {
                    //         "datas": {
                    //             "isMemo": true,                                // 是否为memo 格式，false：否，true ：是
                    //             "address": "bweosdeposit_787928102918558272",  // 充币地址
                    //             "memo": "787928102918558272",                  // 币种memo
                    //             "account": "bweosdeposit"                      // 币种账户
                    //         },
                    //         "resMsg": { "message": "success !", "method": null, "code": "1" }
                    //     }
                    //
                    const data = this.safeValue(response, 'datas', {});
                    const address = this.safeString(data, 'address');
                    const tag = this.safeString(data, 'memo');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': this.checkAddress(address),
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        '-1': 'canceled',
                        '0': 'pending',
                        '1': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "depositId": "D6574268549744189441",                  // Deposit ID
                    //         "amount": "54.753589700000000000",                    // Deposit amount
                    //         "txId": "INNER_SYSTEM_TRANSFER_1198941",              // Trading ID
                    //         "confirmTimes": 0,                                    // Confirmation number
                    //         "depositAddress": "bweosdeposit_787928102918558272",  // Deposit address
                    //         "createTime": "2019-09-02 20:36:08.0",                // Deposit time
                    //         "status": 1,                                          // Deposit status, 0: not received, 1: received
                    //         "currencyTypeId": 7,                                  // Token ID
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "withdrawalId": "W6527498439872634880",      // Withdrawal ID
                    //         "fees": "0.500000000000000000",              // Withdrawal fee
                    //         "withdrawalAddress": "okbtothemoon_941657",  // Withdrawal address
                    //         "currencyId": "7",                           // Token ID
                    //         "amount": "10.000000000000000000",           // Withdrawal amount
                    //         "state": 1,                                  // Status, 1: normal, -1: delete
                    //         "verifyStatus": 1,                           // Audit status, 0: to be audited, 1: auditing passed, -1: auditing failed
                    //         "createTime": 1556276903656,                 // WIthdrawal time
                    //         "actuallyAmount": "9.500000000000000000",    // Actual amount received
                    //     }
                    //
                    const id = this.safeString(transaction, 'depositId', 'withdrawalId');
                    const address = this.safeString2(transaction, 'depositAddress', 'withdrawalAddress');
                    const currencyId = this.safeString2(transaction, 'currencyId', 'currencyTypeId');
                    let code = undefined;
                    if (currencyId in this.currencies_by_id) currency = this.currencies_by_id[currencyId];
                    if (code === undefined && currency !== undefined) code = currency['code'];
                    const type = 'depositId' in transaction ? 'deposit' : 'withdrawal';
                    const amount = this.safeNumber2(transaction, 'actuallyAmount', 'amount');
                    const status = this.parseTransactionStatus(this.safeString2(transaction, 'verifyStatus', 'state'));
                    const timestamp = this.safeInteger(transaction, 'createTime');
                    const txid = this.safeString(transaction, 'txId');
                    let fee = undefined;
                    const feeCost = this.safeNumber(transaction, 'fees');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'fee': fee
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires a currency code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currencyTypeName': currency['name']
                    };
                    if (limit !== undefined) request['pageSize'] = limit; // default 50
                    const response = await this.privatePostExchangeFundControllerWebsiteFundcontrollerGetPayinCoinRecord(this.extend(request, params));
                    //
                    //     {
                    //         "datas": {
                    //             "totalRow":2,
                    //             "totalPage": 1,
                    //             "pageSize": 2,
                    //             "pageNum": 1,
                    //             "list": [
                    //                 {
                    //                     "depositId": "D6574268549744189441",                  // Deposit ID
                    //                     "amount": "54.753589700000000000",                    // Deposit amount
                    //                     "txId": "INNER_SYSTEM_TRANSFER_1198941",              // Trading ID
                    //                     "confirmTimes": 0,                                    // Confirmation number
                    //                     "depositAddress": "bweosdeposit_787928102918558272",  // Deposit address
                    //                     "createTime": "2019-09-02 20:36:08.0",                // Deposit time
                    //                     "status": 1,                                          // Deposit status, 0: not received, 1: received
                    //                     "currencyTypeId": 7,                                  // Token ID
                    //                 },
                    //             ]
                    //         },
                    //         "resMsg": { "message": "success !", "method": null, "code": "1" },
                    //     }
                    //
                    const data = this.safeValue(response, 'datas', {});
                    const deposits = this.safeValue(data, 'list', []);
                    return this.parseTransactions(deposits, code, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchWithdrawals() requires a currency code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currencyId': currency['id']
                    };
                    if (limit !== undefined) request['pageSize'] = limit; // default 50
                    const response = await this.privateGetExchangeFundControllerWebsiteFundwebsitecontrollerGetpayoutcoinrecord(this.extend(request, params));
                    //
                    //     {
                    //         "datas": {
                    //             "totalRow": 1,
                    //             "totalPage": 1,
                    //             "pageSize": 2,
                    //             "pageNum": 1,
                    //             "list": [
                    //                 {
                    //                     "withdrawalId": "W6527498439872634880",      // Withdrawal ID
                    //                     "fees": "0.500000000000000000",              // Withdrawal fee
                    //                     "withdrawalAddress": "okbtothemoon_941657",  // Withdrawal address
                    //                     "currencyId": "7",                           // Token ID
                    //                     "amount": "10.000000000000000000",           // Withdrawal amount
                    //                     "state": 1,                                  // Status, 1: normal, -1: delete
                    //                     "verifyStatus": 1,                           // Audit status, 0: to be audited, 1: auditing passed, -1: auditing failed
                    //                     "createTime": 1556276903656,                 // WIthdrawal time
                    //                     "actuallyAmount": "9.500000000000000000",    // Actual amount received
                    //                 },
                    //             ],
                    //         },
                    //         "resMsg": { "message": "success !", "method": null, "code": "1" },
                    //     }
                    //
                    const data = this.safeValue(response, 'datas', {});
                    const withdrawals = this.safeValue(data, 'list', []);
                    return this.parseTransactions(withdrawals, code, since, limit);
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (!response) return; // default error handler
                    const resMsg = this.safeValue(response, 'resMsg');
                    const errorCode = this.safeString(resMsg, 'code');
                    if (errorCode !== '1') {
                        const feedback = this.id + ' ' + this.json(response);
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        throw new ExchangeError1(feedback); // unknown error
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    58: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const { AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, PermissionDenied: PermissionDenied, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, BadRequest: BadRequest, RateLimitExceeded: RateLimitExceeded, InvalidNonce: InvalidNonce, NotSupported: NotSupported } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bybit extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bybit',
                        'name': 'Bybit',
                        'countries': [
                            'VG'
                        ],
                        'version': 'v2',
                        'userAgent': undefined,
                        // 50 requests per second for GET requests, 1000ms / 50 = 20ms between requests
                        // 20 requests per second for POST requests, cost = 50 / 20 = 2.5
                        'rateLimit': 20,
                        'hostname': 'bybit.com',
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': false,
                            'swap': true,
                            'future': true,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRates': false,
                            'fetchClosedOrders': true,
                            'fetchDeposits': true,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': false,
                            'fetchIndexOHLCV': true,
                            'fetchLedger': true,
                            'fetchMarketLeverageTiers': true,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchOrderTrades': true,
                            'fetchPositions': true,
                            'fetchPremiumIndexOHLCV': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransactions': undefined,
                            'fetchWithdrawals': true,
                            'setLeverage': true,
                            'setMarginMode': true
                        },
                        'timeframes': {
                            '1m': '1',
                            '3m': '3',
                            '5m': '5',
                            '15m': '15',
                            '30m': '30',
                            '1h': '60',
                            '2h': '120',
                            '4h': '240',
                            '6h': '360',
                            '12h': '720',
                            '1d': 'D',
                            '1w': 'W',
                            '1M': 'M',
                            '1y': 'Y'
                        },
                        'urls': {
                            'test': {
                                'spot': 'https://api-testnet.{hostname}',
                                'futures': 'https://api-testnet.{hostname}',
                                'v2': 'https://api-testnet.{hostname}',
                                'public': 'https://api-testnet.{hostname}',
                                'private': 'https://api-testnet.{hostname}'
                            },
                            'logo': 'https://user-images.githubusercontent.com/51840849/76547799-daff5b80-649e-11ea-87fb-3be9bac08954.jpg',
                            'api': {
                                'spot': 'https://api.{hostname}',
                                'futures': 'https://api.{hostname}',
                                'v2': 'https://api.{hostname}',
                                'public': 'https://api.{hostname}',
                                'private': 'https://api.{hostname}'
                            },
                            'www': 'https://www.bybit.com',
                            'doc': [
                                'https://bybit-exchange.github.io/docs/inverse/',
                                'https://bybit-exchange.github.io/docs/linear/',
                                'https://github.com/bybit-exchange'
                            ],
                            'fees': 'https://help.bybit.com/hc/en-us/articles/360039261154',
                            'referral': 'https://www.bybit.com/app/register?ref=X7Prm'
                        },
                        'api': {
                            // outdated endpoints -----------------------------------------
                            'spot': {
                                'public': {
                                    'get': [
                                        'symbols'
                                    ]
                                },
                                'quote': {
                                    'get': [
                                        'depth',
                                        'depth/merged',
                                        'trades',
                                        'kline',
                                        'ticker/24hr',
                                        'ticker/price',
                                        'ticker/book_ticker'
                                    ]
                                },
                                'private': {
                                    'get': [
                                        'order',
                                        'open-orders',
                                        'history-orders',
                                        'myTrades',
                                        'account',
                                        'time'
                                    ],
                                    'post': [
                                        'order'
                                    ],
                                    'delete': [
                                        'order',
                                        'order/fast'
                                    ]
                                },
                                'order': {
                                    'delete': [
                                        'batch-cancel',
                                        'batch-fast-cancel',
                                        'batch-cancel-by-ids'
                                    ]
                                }
                            },
                            'futures': {
                                'private': {
                                    'get': [
                                        'order/list',
                                        'order',
                                        'stop-order/list',
                                        'stop-order',
                                        'position/list',
                                        'execution/list',
                                        'trade/closed-pnl/list'
                                    ],
                                    'post': [
                                        'order/create',
                                        'order/cancel',
                                        'order/cancelAll',
                                        'order/replace',
                                        'stop-order/create',
                                        'stop-order/cancel',
                                        'stop-order/cancelAll',
                                        'stop-order/replace',
                                        'position/change-position-margin',
                                        'position/trading-stop',
                                        'position/leverage/save',
                                        'position/switch-mode',
                                        'position/switch-isolated',
                                        'position/risk-limit'
                                    ]
                                }
                            },
                            'v2': {
                                'public': {
                                    'get': [
                                        'orderBook/L2',
                                        'kline/list',
                                        'tickers',
                                        'trading-records',
                                        'symbols',
                                        'liq-records',
                                        'mark-price-kline',
                                        'index-price-kline',
                                        'premium-index-kline',
                                        'open-interest',
                                        'big-deal',
                                        'account-ratio',
                                        'time',
                                        'announcement',
                                        'funding/prev-funding-rate',
                                        'risk-limit/list'
                                    ]
                                },
                                'private': {
                                    'get': [
                                        'order/list',
                                        'order',
                                        'stop-order/list',
                                        'stop-order',
                                        'position/list',
                                        'position/fee-rate',
                                        'execution/list',
                                        'trade/closed-pnl/list',
                                        'funding/prev-funding-rate',
                                        'funding/prev-funding',
                                        'funding/predicted-funding',
                                        'account/api-key',
                                        'account/lcp',
                                        'wallet/balance',
                                        'wallet/fund/records',
                                        'wallet/withdraw/list',
                                        'exchange-order/list'
                                    ],
                                    'post': [
                                        'order/create',
                                        'order/cancel',
                                        'order/cancelAll',
                                        'order/replace',
                                        'stop-order/create',
                                        'stop-order/cancel',
                                        'stop-order/cancelAll',
                                        'stop-order/replace',
                                        'position/change-position-margin',
                                        'position/trading-stop',
                                        'position/leverage/save',
                                        'position/switch-mode',
                                        'position/switch-isolated',
                                        'position/risk-limit'
                                    ]
                                }
                            },
                            // new endpoints ------------------------------------------
                            'public': {
                                'get': {
                                    // inverse swap
                                    'v2/public/orderBook/L2': 1,
                                    'v2/public/kline/list': 3,
                                    'v2/public/tickers': 1,
                                    'v2/public/trading-records': 1,
                                    'v2/public/symbols': 1,
                                    'v2/public/mark-price-kline': 3,
                                    'v2/public/index-price-kline': 3,
                                    'v2/public/premium-index-kline': 2,
                                    'v2/public/open-interest': 1,
                                    'v2/public/big-deal': 1,
                                    'v2/public/account-ratio': 1,
                                    'v2/public/funding-rate': 1,
                                    'v2/public/elite-ratio': 1,
                                    'v2/public/funding/prev-funding-rate': 1,
                                    'v2/public/risk-limit/list': 1,
                                    // linear swap USDT
                                    'public/linear/kline': 3,
                                    'public/linear/recent-trading-records': 1,
                                    'public/linear/funding/prev-funding-rate': 1,
                                    'public/linear/mark-price-kline': 1,
                                    'public/linear/index-price-kline': 1,
                                    'public/linear/premium-index-kline': 1,
                                    // spot
                                    'spot/v1/time': 1,
                                    'spot/v1/symbols': 1,
                                    'spot/quote/v1/depth': 1,
                                    'spot/quote/v1/depth/merged': 1,
                                    'spot/quote/v1/trades': 1,
                                    'spot/quote/v1/kline': 1,
                                    'spot/quote/v1/ticker/24hr': 1,
                                    'spot/quote/v1/ticker/price': 1,
                                    'spot/quote/v1/ticker/book_ticker': 1,
                                    // data
                                    'v2/public/time': 1,
                                    'v2/public/announcement': 1,
                                    // USDC endpoints are testnet only as of 2022 Jan 11 ----------
                                    // option USDC (testnet only)
                                    'option/usdc/openapi/public/v1/order-book': 1,
                                    'option/usdc/openapi/public/v1/symbols': 1,
                                    'option/usdc/openapi/public/v1/tick': 1,
                                    'option/usdc/openapi/public/v1/delivery-price': 1,
                                    'option/usdc/openapi/public/v1/query-trade-latest': 1,
                                    // perpetual swap USDC (testnet only)
                                    'perpetual/usdc/openapi/public/v1/order-book': 1,
                                    'perpetual/usdc/openapi/public/v1/symbols': 1,
                                    'perpetual/usdc/openapi/public/v1/tick': 1,
                                    'perpetual/usdc/openapi/public/v1/kline/list': 1,
                                    'perpetual/usdc/openapi/public/v1/mark-price-kline': 1,
                                    'perpetual/usdc/openapi/public/v1/index-price-kline': 1,
                                    'perpetual/usdc/openapi/public/v1/premium-index-kline': 1,
                                    'perpetual/usdc/openapi/public/v1/open-interest': 1,
                                    'perpetual/usdc/openapi/public/v1/big-deal': 1,
                                    'perpetual/usdc/openapi/public/v1/account-ratio': 1,
                                    'perpetual/usdc/openapi/public/v1/prev-funding-rate': 1,
                                    'perpetual/usdc/openapi/public/v1/risk-limit/list': 1
                                },
                                // outdated endpoints--------------------------------------
                                'linear': {
                                    'get': [
                                        'kline',
                                        'recent-trading-records',
                                        'funding/prev-funding-rate',
                                        'mark-price-kline',
                                        'index-price-kline',
                                        'premium-index-kline',
                                        'risk-limit'
                                    ]
                                }
                            },
                            // new endpoints ------------------------------------------
                            'private': {
                                'get': {
                                    // inverse swap
                                    'v2/private/order/list': 5,
                                    'v2/private/order': 5,
                                    'v2/private/stop-order/list': 5,
                                    'v2/private/stop-order': 1,
                                    'v2/private/position/list': 25,
                                    'v2/private/position/fee-rate': 40,
                                    'v2/private/execution/list': 25,
                                    'v2/private/trade/closed-pnl/list': 1,
                                    'v2/public/risk-limit/list': 1,
                                    'v2/public/funding/prev-funding-rate': 25,
                                    'v2/private/funding/prev-funding': 25,
                                    'v2/private/funding/predicted-funding': 25,
                                    'v2/private/account/api-key': 5,
                                    'v2/private/account/lcp': 1,
                                    'v2/private/wallet/balance': 25,
                                    'v2/private/wallet/fund/records': 25,
                                    'v2/private/wallet/withdraw/list': 25,
                                    'v2/private/exchange-order/list': 1,
                                    // linear swap USDT
                                    'private/linear/order/list': 5,
                                    'private/linear/order/search': 5,
                                    'private/linear/stop-order/list': 5,
                                    'private/linear/stop-order/search': 5,
                                    'private/linear/position/list': 25,
                                    'private/linear/trade/execution/list': 25,
                                    'private/linear/trade/closed-pnl/list': 25,
                                    'public/linear/risk-limit': 1,
                                    'private/linear/funding/predicted-funding': 25,
                                    'private/linear/funding/prev-funding': 25,
                                    // inverse futures
                                    'futures/private/order/list': 5,
                                    'futures/private/order': 5,
                                    'futures/private/stop-order/list': 5,
                                    'futures/private/stop-order': 5,
                                    'futures/private/position/list': 25,
                                    'futures/private/execution/list': 25,
                                    'futures/private/trade/closed-pnl/list': 1,
                                    // spot
                                    'spot/v1/account': 2.5,
                                    'spot/v1/order': 2.5,
                                    'spot/v1/open-orders': 2.5,
                                    'spot/v1/history-orders': 2.5,
                                    'spot/v1/myTrades': 2.5,
                                    // account
                                    'asset/v1/private/transfer/list': 50,
                                    'asset/v1/private/sub-member/transfer/list': 50,
                                    'asset/v1/private/sub-member/member-ids': 50
                                },
                                'post': {
                                    // inverse swap
                                    'v2/private/order/create': 30,
                                    'v2/private/order/cancel': 30,
                                    'v2/private/order/cancelAll': 300,
                                    'v2/private/order/replace': 30,
                                    'v2/private/stop-order/create': 30,
                                    'v2/private/stop-order/cancel': 30,
                                    'v2/private/stop-order/cancelAll': 300,
                                    'v2/private/stop-order/replace': 30,
                                    'v2/private/position/change-position-margin': 40,
                                    'v2/private/position/trading-stop': 40,
                                    'v2/private/position/leverage/save': 40,
                                    'v2/private/tpsl/switch-mode': 40,
                                    'v2/private/position/switch-isolated': 2.5,
                                    'v2/private/position/risk-limit': 2.5,
                                    'v2/private/position/switch-mode': 2.5,
                                    // linear swap USDT
                                    'private/linear/order/create': 30,
                                    'private/linear/order/cancel': 30,
                                    'private/linear/order/cancel-all': 300,
                                    'private/linear/order/replace': 30,
                                    'private/linear/stop-order/create': 30,
                                    'private/linear/stop-order/cancel': 30,
                                    'private/linear/stop-order/cancel-all': 300,
                                    'private/linear/stop-order/replace': 30,
                                    'private/linear/position/set-auto-add-margin': 40,
                                    'private/linear/position/switch-isolated': 40,
                                    'private/linear/position/switch-mode': 40,
                                    'private/linear/tpsl/switch-mode': 2.5,
                                    'private/linear/position/add-margin': 40,
                                    'private/linear/position/set-leverage': 40,
                                    'private/linear/position/trading-stop': 40,
                                    'private/linear/position/set-risk': 2.5,
                                    // inverse futures
                                    'futures/private/order/create': 30,
                                    'futures/private/order/cancel': 30,
                                    'futures/private/order/cancelAll': 30,
                                    'futures/private/order/replace': 30,
                                    'futures/private/stop-order/create': 30,
                                    'futures/private/stop-order/cancel': 30,
                                    'futures/private/stop-order/cancelAll': 30,
                                    'futures/private/stop-order/replace': 30,
                                    'futures/private/position/change-position-margin': 40,
                                    'futures/private/position/trading-stop': 40,
                                    'futures/private/position/leverage/save': 40,
                                    'futures/private/position/switch-mode': 40,
                                    'futures/private/tpsl/switch-mode': 40,
                                    'futures/private/position/switch-isolated': 40,
                                    'futures/private/position/risk-limit': 2.5,
                                    // spot
                                    'spot/v1/order': 2.5,
                                    // account
                                    'asset/v1/private/transfer': 150,
                                    'asset/v1/private/sub-member/transfer': 150,
                                    // USDC endpoints are testnet only as of 2022 Jan 11 ----------
                                    // option USDC (testnet only)
                                    'option/usdc/openapi/private/v1/place-order': 2.5,
                                    'option/usdc/openapi/private/v1/batch-place-order': 2.5,
                                    'option/usdc/openapi/private/v1/replace-order': 2.5,
                                    'option/usdc/openapi/private/v1/batch-replace-orders': 2.5,
                                    'option/usdc/openapi/private/v1/cancel-order': 2.5,
                                    'option/usdc/openapi/private/v1/batch-cancel-orders': 2.5,
                                    'option/usdc/openapi/private/v1/cancel-all': 2.5,
                                    'option/usdc/openapi/private/v1/query-active-orders': 2.5,
                                    'option/usdc/openapi/private/v1/query-order-history': 2.5,
                                    'option/usdc/openapi/private/v1/execution-list': 2.5,
                                    'option/usdc/openapi/private/v1/query-transaction-log': 2.5,
                                    'option/usdc/openapi/private/v1/query-wallet-balance': 2.5,
                                    'option/usdc/openapi/private/v1/query-asset-info': 2.5,
                                    'option/usdc/openapi/private/v1/query-margin-info': 2.5,
                                    'option/usdc/openapi/private/v1/query-position': 2.5,
                                    'option/usdc/openapi/private/v1/query-delivery-list': 2.5,
                                    'option/usdc/openapi/private/v1/query-position-exp-date': 2.5,
                                    'option/usdc/openapi/private/v1/mmp-modify': 2.5,
                                    'option/usdc/openapi/private/v1/mmp-reset': 2.5,
                                    // perpetual swap USDC (testnet only)
                                    'perpetual/usdc/openapi/private/v1/place-order': 2.5,
                                    'perpetual/usdc/openapi/private/v1/replace-order': 2.5,
                                    'perpetual/usdc/openapi/private/v1/cancel-order': 2.5,
                                    'perpetual/usdc/openapi/private/v1/cancel-all': 2.5,
                                    'perpetual/usdc/openapi/private/v1/position/leverage/save': 2.5,
                                    'option/usdc/openapi/private/v1/session-settlement': 2.5,
                                    'perpetual/usdc/openapi/public/v1/risk-limit/list': 2.5,
                                    'perpetual/usdc/openapi/private/v1/position/set-risk-limit': 2.5
                                },
                                'delete': {
                                    // spot
                                    'spot/v1/order': 2.5,
                                    'spot/v1/order/fast': 2.5,
                                    'spot/order/batch-cancel': 2.5,
                                    'spot/order/batch-fast-cancel': 2.5,
                                    'spot/order/batch-cancel-by-ids': 2.5
                                },
                                // outdated endpoints -------------------------------------
                                'linear': {
                                    'get': [
                                        'order/list',
                                        'order/search',
                                        'stop-order/list',
                                        'stop-order/search',
                                        'position/list',
                                        'trade/execution/list',
                                        'trade/closed-pnl/list',
                                        'funding/predicted-funding',
                                        'funding/prev-funding'
                                    ],
                                    'post': [
                                        'order/create',
                                        'order/cancel',
                                        'order/cancel-all',
                                        'order/replace',
                                        'stop-order/create',
                                        'stop-order/cancel',
                                        'stop-order/cancel-all',
                                        'stop-order/replace',
                                        'position/set-auto-add-margin',
                                        'position/switch-isolated',
                                        'position/switch-mode',
                                        'tpsl/switch-mode',
                                        'position/add-margin',
                                        'position/set-leverage',
                                        'position/trading-stop',
                                        'position/set-risk'
                                    ]
                                }
                            }
                        },
                        'httpExceptions': {
                            '403': RateLimitExceeded
                        },
                        'exceptions': {
                            'exact': {
                                '-2015': AuthenticationError,
                                '-10009': BadRequest,
                                '10001': BadRequest,
                                '10002': InvalidNonce,
                                '10003': AuthenticationError,
                                '10004': AuthenticationError,
                                '10005': PermissionDenied,
                                '10006': RateLimitExceeded,
                                '10007': AuthenticationError,
                                '10010': PermissionDenied,
                                '10017': BadRequest,
                                '10018': RateLimitExceeded,
                                '20001': OrderNotFound,
                                '20003': InvalidOrder,
                                '20004': InvalidOrder,
                                '20005': InvalidOrder,
                                '20006': InvalidOrder,
                                '20007': InvalidOrder,
                                '20008': InvalidOrder,
                                '20009': InvalidOrder,
                                '20010': InvalidOrder,
                                '20011': InvalidOrder,
                                '20012': InvalidOrder,
                                '20013': InvalidOrder,
                                '20014': InvalidOrder,
                                '20015': InvalidOrder,
                                '20016': InvalidOrder,
                                '20017': InvalidOrder,
                                '20018': InvalidOrder,
                                '20019': InvalidOrder,
                                '20020': InvalidOrder,
                                '20021': InvalidOrder,
                                '20022': BadRequest,
                                '20023': BadRequest,
                                '20031': BadRequest,
                                '20070': BadRequest,
                                '20071': BadRequest,
                                '20084': BadRequest,
                                '30001': BadRequest,
                                '30003': InvalidOrder,
                                '30004': InvalidOrder,
                                '30005': InvalidOrder,
                                '30007': InvalidOrder,
                                '30008': InvalidOrder,
                                '30009': ExchangeError1,
                                '30010': InsufficientFunds,
                                '30011': PermissionDenied,
                                '30012': PermissionDenied,
                                '30013': PermissionDenied,
                                '30014': InvalidOrder,
                                '30015': InvalidOrder,
                                '30016': ExchangeError1,
                                '30017': InvalidOrder,
                                '30018': InvalidOrder,
                                '30019': InvalidOrder,
                                '30020': InvalidOrder,
                                '30021': InvalidOrder,
                                '30022': InvalidOrder,
                                '30023': InvalidOrder,
                                '30024': InvalidOrder,
                                '30025': InvalidOrder,
                                '30026': InvalidOrder,
                                '30027': InvalidOrder,
                                '30028': InvalidOrder,
                                '30029': InvalidOrder,
                                '30030': InvalidOrder,
                                '30031': InsufficientFunds,
                                '30032': InvalidOrder,
                                '30033': RateLimitExceeded,
                                '30034': OrderNotFound,
                                '30035': RateLimitExceeded,
                                '30036': ExchangeError1,
                                '30037': InvalidOrder,
                                '30041': ExchangeError1,
                                '30042': InsufficientFunds,
                                '30043': InvalidOrder,
                                '30044': InvalidOrder,
                                '30045': InvalidOrder,
                                '30049': InsufficientFunds,
                                '30050': ExchangeError1,
                                '30051': ExchangeError1,
                                '30052': ExchangeError1,
                                '30054': ExchangeError1,
                                '30057': ExchangeError1,
                                '30063': ExchangeError1,
                                '30067': InsufficientFunds,
                                '30068': ExchangeError1,
                                '30074': InvalidOrder,
                                '30075': InvalidOrder,
                                '30078': ExchangeError1,
                                // '30084': BadRequest, // Isolated not modified, see handleErrors below
                                '33004': AuthenticationError,
                                '34026': ExchangeError1,
                                '130021': InsufficientFunds
                            },
                            'broad': {
                                'unknown orderInfo': OrderNotFound,
                                'invalid api_key': AuthenticationError
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'options': {
                            'marketTypes': {
                                'BTC/USDT': 'linear',
                                'ETH/USDT': 'linear',
                                'BNB/USDT': 'linear',
                                'ADA/USDT': 'linear',
                                'DOGE/USDT': 'linear',
                                'XRP/USDT': 'linear',
                                'DOT/USDT': 'linear',
                                'UNI/USDT': 'linear',
                                'BCH/USDT': 'linear',
                                'LTC/USDT': 'linear',
                                'SOL/USDT': 'linear',
                                'LINK/USDT': 'linear',
                                'MATIC/USDT': 'linear',
                                'ETC/USDT': 'linear',
                                'FIL/USDT': 'linear',
                                'EOS/USDT': 'linear',
                                'AAVE/USDT': 'linear',
                                'XTZ/USDT': 'linear',
                                'SUSHI/USDT': 'linear',
                                'XEM/USDT': 'linear',
                                'BTC/USD': 'inverse',
                                'ETH/USD': 'inverse',
                                'EOS/USD': 'inverse',
                                'XRP/USD': 'inverse'
                            },
                            'defaultType': 'linear',
                            //
                            // ^
                            // |
                            // | this will be replaced with the following soon |
                            //                                                 |
                            //                                                 v
                            //
                            // 'defaultType': 'swap', // swap, spot, future, option
                            'code': 'BTC',
                            'cancelAllOrders': {
                            },
                            'recvWindow': 5000,
                            'timeDifference': 0,
                            'adjustForTimeDifference': false,
                            'defaultSettle': 'USDT'
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'taker': 0.00075,
                                'maker': -0.00025
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false,
                                'withdraw': {},
                                'deposit': {}
                            }
                        }
                    });
                }
                nonce() {
                    return this.milliseconds() - this.options['timeDifference'];
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetV2PublicTime(params);
                    //
                    //     {
                    //         ret_code: 0,
                    //         ret_msg: 'OK',
                    //         ext_code: '',
                    //         ext_info: '',
                    //         result: {},
                    //         time_now: '1583933682.448826'
                    //     }
                    //
                    return this.safeTimestamp(response, 'time_now');
                }
                async fetchMarkets(params = {}) {
                    if (this.options['adjustForTimeDifference']) await this.loadTimeDifference();
                    let type = undefined;
                    [type, params] = this.handleMarketTypeAndParams('fetchMarkets', undefined, params);
                    if (type === 'spot') {
                        // spot and swap ids are equal
                        // so they can't be loaded together
                        const spotMarkets = await this.fetchSpotMarkets(params);
                        return spotMarkets;
                    }
                    const contractMarkets = await this.fetchSwapAndFutureMarkets(params);
                    const usdcMarkets = await this.fetchUSDCMarkets(params);
                    let markets = contractMarkets;
                    markets = this.arrayConcat(markets, usdcMarkets);
                    return markets;
                }
                async fetchSpotMarkets(params) {
                    const response = await this.publicGetSpotV1Symbols(params);
                    //
                    //     {
                    //         "ret_code":0,
                    //         "ret_msg":"",
                    //         "ext_code":null,
                    //         "ext_info":null,
                    //         "result":[
                    //             {
                    //                 "name":"BTCUSDT",
                    //                 "alias":"BTCUSDT",
                    //                 "baseCurrency":"BTC",
                    //                 "quoteCurrency":"USDT",
                    //                 "basePrecision":"0.000001",
                    //                 "quotePrecision":"0.00000001",
                    //                 "minTradeQuantity":"0.000158",
                    //                 "minTradeAmount":"10",
                    //                 "maxTradeQuantity":"4",
                    //                 "maxTradeAmount":"100000",
                    //                 "minPricePrecision":"0.01",
                    //                 "category":1,
                    //                 "showStatus":true
                    //             },
                    //         ]
                    //     }
                    const markets = this.safeValue(response, 'result', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'name');
                        const baseId = this.safeString(market, 'baseCurrency');
                        const quoteId = this.safeString(market, 'quoteCurrency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const symbol = base + '/' + quote;
                        const active = this.safeValue(market, 'showStatus');
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': active,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': undefined,
                            'maker': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(market, 'basePrecision'),
                                'price': this.safeNumber(market, 'quotePrecision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minTradeQuantity'),
                                    'max': this.safeNumber(market, 'maxTradeQuantity')
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minTradeAmount'),
                                    'max': this.safeNumber(market, 'maxTradeAmount')
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchSwapAndFutureMarkets(params) {
                    const response = await this.publicGetV2PublicSymbols(params);
                    //     {
                    //         "ret_code":0,
                    //         "ret_msg":"OK",
                    //         "ext_code":"",
                    //         "ext_info":"",
                    //         "result":[
                    //             // inverse swap
                    //             {
                    //                 "name":"BTCUSD",
                    //                 "alias":"BTCUSD",
                    //                 "status":"Trading",
                    //                 "base_currency":"BTC",
                    //                 "quote_currency":"USD",
                    //                 "price_scale":2,
                    //                 "taker_fee":"0.00075",
                    //                 "maker_fee":"-0.00025",
                    //                 "leverage_filter":{"min_leverage":1,"max_leverage":100,"leverage_step":"0.01"},
                    //                 "price_filter":{"min_price":"0.5","max_price":"999999","tick_size":"0.5"},
                    //                 "lot_size_filter":{"max_trading_qty":1000000,"min_trading_qty":1,"qty_step":1}
                    //             },
                    //             // linear swap
                    //             {
                    //                 "name":"BTCUSDT",
                    //                 "alias":"BTCUSDT",
                    //                 "status":"Trading",
                    //                 "base_currency":"BTC",
                    //                 "quote_currency":"USDT",
                    //                 "price_scale":2,
                    //                 "taker_fee":"0.00075",
                    //                 "maker_fee":"-0.00025",
                    //                 "leverage_filter":{"min_leverage":1,"max_leverage":100,"leverage_step":"0.01"},
                    //                 "price_filter":{"min_price":"0.5","max_price":"999999","tick_size":"0.5"},
                    //                 "lot_size_filter":{"max_trading_qty":100,"min_trading_qty":0.001, "qty_step":0.001}
                    //             },
                    //  inverse futures
                    //            {
                    //                "name": "BTCUSDU22",
                    //                "alias": "BTCUSD0930",
                    //                "status": "Trading",
                    //                "base_currency": "BTC",
                    //                "quote_currency": "USD",
                    //                "price_scale": "2",
                    //                "taker_fee": "0.0006",
                    //                "maker_fee": "0.0001",
                    //                "funding_interval": "480",
                    //                "leverage_filter": {
                    //                    "min_leverage": "1",
                    //                    "max_leverage": "100",
                    //                    "leverage_step": "0.01"
                    //                },
                    //                "price_filter": {
                    //                    "min_price": "0.5",
                    //                    "max_price": "999999",
                    //                    "tick_size": "0.5"
                    //                },
                    //                "lot_size_filter": {
                    //                    "max_trading_qty": "1000000",
                    //                    "min_trading_qty": "1",
                    //                    "qty_step": "1",
                    //                    "post_only_max_trading_qty": "5000000"
                    //                }
                    //            }
                    //         ],
                    //         "time_now":"1642369942.072113"
                    //     }
                    //
                    const markets = this.safeValue(response, 'result', []);
                    const result = [];
                    const options = this.safeValue(this.options, 'fetchMarkets', {});
                    const linearQuoteCurrencies = this.safeValue(options, 'linear', {
                        'USDT': true
                    });
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'name');
                        const baseId = this.safeString(market, 'base_currency');
                        const quoteId = this.safeString(market, 'quote_currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const linear = quote in linearQuoteCurrencies;
                        let symbol = base + '/' + quote;
                        const baseQuote = base + quote;
                        let type = 'swap';
                        if (baseQuote !== id) type = 'future';
                        const lotSizeFilter = this.safeValue(market, 'lot_size_filter', {});
                        const priceFilter = this.safeValue(market, 'price_filter', {});
                        const leverage = this.safeValue(market, 'leverage_filter', {});
                        const status = this.safeString(market, 'status');
                        let active = undefined;
                        if (status !== undefined) active = status === 'Trading';
                        const swap = type === 'swap';
                        const future = type === 'future';
                        let expiry = undefined;
                        let expiryDatetime = undefined;
                        const settleId = linear ? quoteId : baseId;
                        const settle = this.safeCurrencyCode(settleId);
                        symbol = symbol + ':' + settle;
                        if (future) {
                            // we have to do some gymnastics here because bybit
                            // only provides the day and month regarding the contract expiration
                            const alias = this.safeString(market, 'alias'); // BTCUSD0930
                            const aliasDate = alias.slice(-4); // 0930
                            const aliasMonth = aliasDate.slice(0, 2); // 09
                            const aliasDay = aliasDate.slice(2, 4); // 30
                            const dateNow = this.yyyymmdd(this.milliseconds());
                            const dateParts = dateNow.split('-');
                            const year = this.safeValue(dateParts, 0);
                            const artificial8601Date = year + '-' + aliasMonth + '-' + aliasDay + 'T00:00:00.000Z';
                            expiryDatetime = artificial8601Date;
                            expiry = this.parse8601(expiryDatetime);
                            symbol = symbol + '-' + this.yymmdd(expiry);
                        }
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': type,
                            'spot': false,
                            'margin': undefined,
                            'swap': swap,
                            'future': future,
                            'option': false,
                            'active': active,
                            'contract': true,
                            'linear': linear,
                            'inverse': !linear,
                            'taker': this.safeNumber(market, 'taker_fee'),
                            'maker': this.safeNumber(market, 'maker_fee'),
                            'contractSize': undefined,
                            'expiry': expiry,
                            'expiryDatetime': expiryDatetime,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(lotSizeFilter, 'qty_step'),
                                'price': this.safeNumber(priceFilter, 'tick_size')
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': this.safeNumber(leverage, 'max_leverage', 1)
                                },
                                'amount': {
                                    'min': this.safeNumber(lotSizeFilter, 'min_trading_qty'),
                                    'max': this.safeNumber(lotSizeFilter, 'max_trading_qty')
                                },
                                'price': {
                                    'min': this.safeNumber(priceFilter, 'min_price'),
                                    'max': this.safeNumber(priceFilter, 'max_price')
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchUSDCMarkets(params) {
                    const linearOptionsResponse = await this.publicGetOptionUsdcOpenapiPublicV1Symbols(params);
                    const usdcLinearPerpetualSwaps = await this.publicGetPerpetualUsdcOpenapiPublicV1Symbols(params);
                    //
                    // USDC linear options
                    //     {
                    //         "retCode":0,
                    //         "retMsg":"success",
                    //         "result":{
                    //             "resultTotalSize":424,
                    //             "cursor":"0%2C500",
                    //             "dataList":[
                    //                 {
                    //                     "symbol":"BTC-24JUN22-300000-C",
                    //                     "status":"ONLINE",
                    //                     "baseCoin":"BTC",
                    //                     "quoteCoin":"USD",
                    //                     "settleCoin":"USDC",
                    //                     "takerFee":"0.0003",
                    //                     "makerFee":"0.0003",
                    //                     "minLeverage":"",
                    //                     "maxLeverage":"",
                    //                     "leverageStep":"",
                    //                     "minOrderPrice":"0.5",
                    //                     "maxOrderPrice":"10000000",
                    //                     "minOrderSize":"0.01",
                    //                     "maxOrderSize":"200",
                    //                     "tickSize":"0.5",
                    //                     "minOrderSizeIncrement":"0.01",
                    //                     "basicDeliveryFeeRate":"0.00015",
                    //                     "deliveryTime":"1656057600000"
                    //                 },
                    //                 {
                    //                     "symbol":"BTC-24JUN22-300000-P",
                    //                     "status":"ONLINE",
                    //                     "baseCoin":"BTC",
                    //                     "quoteCoin":"USD",
                    //                     "settleCoin":"USDC",
                    //                     "takerFee":"0.0003",
                    //                     "makerFee":"0.0003",
                    //                     "minLeverage":"",
                    //                     "maxLeverage":"",
                    //                     "leverageStep":"",
                    //                     "minOrderPrice":"0.5",
                    //                     "maxOrderPrice":"10000000",
                    //                     "minOrderSize":"0.01",
                    //                     "maxOrderSize":"200",
                    //                     "tickSize":"0.5",
                    //                     "minOrderSizeIncrement":"0.01",
                    //                     "basicDeliveryFeeRate":"0.00015",
                    //                     "deliveryTime":"1656057600000"
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    // USDC linear perpetual swaps
                    //
                    //     {
                    //         "retCode":0,
                    //         "retMsg":"",
                    //         "result":[
                    //             {
                    //                 "symbol":"BTCPERP",
                    //                 "status":"ONLINE",
                    //                 "baseCoin":"BTC",
                    //                 "quoteCoin":"USD",
                    //                 "takerFeeRate":"0.00075",
                    //                 "makerFeeRate":"-0.00025",
                    //                 "minLeverage":"1",
                    //                 "maxLeverage":"100",
                    //                 "leverageStep":"0.01",
                    //                 "minPrice":"0.50",
                    //                 "maxPrice":"999999.00",
                    //                 "tickSize":"0.50",
                    //                 "maxTradingQty":"5.000",
                    //                 "minTradingQty":"0.001",
                    //                 "qtyStep":"0.001",
                    //                 "deliveryFeeRate":"",
                    //                 "deliveryTime":"0"
                    //             }
                    //         ]
                    //     }
                    //
                    const optionsResponse = this.safeValue(linearOptionsResponse, 'result', []);
                    const options = this.safeValue(optionsResponse, 'dataList', []);
                    const contractsResponse = this.safeValue(usdcLinearPerpetualSwaps, 'result', []);
                    const markets = this.arrayConcat(options, contractsResponse);
                    const result = [];
                    // all markets fetched here are linear
                    const linear = true;
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'symbol');
                        const baseId = this.safeString(market, 'baseCoin');
                        const quoteId = this.safeString(market, 'quoteCoin');
                        let settleId = this.safeString(market, 'settleCoin');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        let settle = this.safeCurrencyCode(settleId);
                        let symbol = base + '/' + quote;
                        let type = 'swap';
                        if (settleId !== undefined) type = 'option';
                        const swap = type === 'swap';
                        const option = type === 'option';
                        const leverage = this.safeValue(market, 'leverage_filter', {});
                        const status = this.safeString(market, 'status');
                        let active = undefined;
                        if (status !== undefined) active = status === 'ONLINE';
                        let expiry = undefined;
                        let expiryDatetime = undefined;
                        let strike = undefined;
                        let optionType = undefined;
                        if (settle === undefined) {
                            settleId = 'USDC';
                            settle = 'USDC';
                        }
                        symbol = symbol + ':' + settle;
                        if (option) {
                            expiry = this.safeInteger(market, 'deliveryTime');
                            expiryDatetime = this.iso8601(expiry);
                            const splitId = id.split('-');
                            strike = this.safeString(splitId, 2);
                            const optionLetter = this.safeString(splitId, 3);
                            symbol = symbol + '-' + this.yymmdd(expiry) + ':' + strike + ':' + optionLetter;
                            if (optionLetter === 'P') optionType = 'put';
                            else if (optionLetter === 'C') optionType = 'call';
                        }
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': type,
                            'spot': false,
                            'margin': undefined,
                            'swap': swap,
                            'future': false,
                            'option': option,
                            'active': active,
                            'contract': true,
                            'linear': linear,
                            'inverse': !linear,
                            'taker': this.safeNumber(market, 'taker_fee'),
                            'maker': this.safeNumber(market, 'maker_fee'),
                            'contractSize': undefined,
                            'expiry': expiry,
                            'expiryDatetime': expiryDatetime,
                            'strike': strike,
                            'optionType': optionType,
                            'precision': {
                                'amount': this.safeNumber(market, 'minOrderSizeIncrement'),
                                'price': this.safeNumber(market, 'tickSize')
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.safeNumber(leverage, 'minLeverage', 1),
                                    'max': this.safeNumber(leverage, 'maxLeverage', 1)
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minOrderSize'),
                                    'max': this.safeNumber(market, 'maxOrderSize')
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'minOrderPrice'),
                                    'max': this.safeNumber(market, 'maxOrderPrice')
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    // spot
                    //
                    //    {
                    //        "time": "1651743420061",
                    //        "symbol": "BTCUSDT",
                    //        "bestBidPrice": "39466.75",
                    //        "bestAskPrice": "39466.83",
                    //        "volume": "4396.082921",
                    //        "quoteVolume": "172664909.03216557",
                    //        "lastPrice": "39466.71",
                    //        "highPrice": "40032.79",
                    //        "lowPrice": "38602.39",
                    //        "openPrice": "39031.53"
                    //    }
                    //
                    // linear usdt/ inverse swap and future
                    //     {
                    //         "symbol": "BTCUSDT",
                    //         "bid_price": "39458",
                    //         "ask_price": "39458.5",
                    //         "last_price": "39458.00",
                    //         "last_tick_direction": "ZeroMinusTick",
                    //         "prev_price_24h": "39059.50",
                    //         "price_24h_pcnt": "0.010202",
                    //         "high_price_24h": "40058.50",
                    //         "low_price_24h": "38575.50",
                    //         "prev_price_1h": "39534.00",
                    //         "price_1h_pcnt": "-0.001922",
                    //         "mark_price": "39472.49",
                    //         "index_price": "39469.81",
                    //         "open_interest": "28343.61",
                    //         "open_value": "0.00",
                    //         "total_turnover": "85303326477.54",
                    //         "turnover_24h": "4221589085.06",
                    //         "total_volume": "30628792.45",
                    //         "volume_24h": "107569.75",
                    //         "funding_rate": "0.0001",
                    //         "predicted_funding_rate": "0.0001",
                    //         "next_funding_time": "2022-05-05T16:00:00Z",
                    //         "countdown_hour": "7",
                    //         "delivery_fee_rate": "",
                    //         "predicted_delivery_price": "",
                    //         "delivery_time": ""
                    //     }
                    //
                    // usdc option/ swap
                    //     {
                    //          "symbol": "BTC-30SEP22-400000-C",
                    //          "bid": "0",
                    //          "bidIv": "0",
                    //          "bidSize": "0",
                    //          "ask": "15",
                    //          "askIv": "1.1234",
                    //          "askSize": "0.01",
                    //          "lastPrice": "5",
                    //          "openInterest": "0.03",
                    //          "indexPrice": "39458.6",
                    //          "markPrice": "0.51901394",
                    //          "markPriceIv": "0.9047",
                    //          "change24h": "0",
                    //          "high24h": "0",
                    //          "low24h": "0",
                    //          "volume24h": "0",
                    //          "turnover24h": "0",
                    //          "totalVolume": "1",
                    //          "totalTurnover": "4",
                    //          "predictedDeliveryPrice": "0",
                    //          "underlyingPrice": "40129.73",
                    //          "delta": "0.00010589",
                    //          "gamma": "0.00000002",
                    //          "vega": "0.10670892",
                    //          "theta": "-0.03262827"
                    //      }
                    //
                    const timestamp = this.safeInteger(ticker, 'time');
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeString2(ticker, 'last_price', 'lastPrice');
                    const open = this.safeString2(ticker, 'prev_price_24h', 'openPrice');
                    let percentage = this.safeString2(ticker, 'price_24h_pcnt', 'change24h');
                    percentage = Precise.stringMul(percentage, '100');
                    let baseVolume = this.safeString2(ticker, 'turnover_24h', 'turnover24h');
                    if (baseVolume === undefined) baseVolume = this.safeString(ticker, 'volume');
                    let quoteVolume = this.safeString2(ticker, 'volume_24h', 'volume24h');
                    if (quoteVolume === undefined) quoteVolume = this.safeString(ticker, 'quoteVolume');
                    let bid = this.safeString2(ticker, 'bid_price', 'bid');
                    if (bid === undefined) bid = this.safeString(ticker, 'bestBidPrice');
                    let ask = this.safeString2(ticker, 'ask_price', 'ask');
                    if (ask === undefined) ask = this.safeString(ticker, 'bestAskPrice');
                    let high = this.safeString2(ticker, 'high_price_24h', 'high24h');
                    if (high === undefined) high = this.safeString(ticker, 'highPrice');
                    let low = this.safeString2(ticker, 'low_price_24h', 'low24h');
                    if (low === undefined) low = this.safeString(ticker, 'lowPrice');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': high,
                        'low': low,
                        'bid': bid,
                        'bidVolume': this.safeString(ticker, 'bidSize'),
                        'ask': ask,
                        'askVolume': this.safeString(ticker, 'askSize'),
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let method = undefined;
                    const isUsdcSettled = market['settle'] === 'USDC';
                    if (market['spot']) method = 'publicGetSpotQuoteV1Ticker24hr';
                    else if (!isUsdcSettled) // inverse perpetual // usdt linear // inverse futures
                    method = 'publicGetV2PublicTickers';
                    else if (market['option']) // usdc option
                    method = 'publicGetOptionUsdcOpenapiPublicV1Tick';
                    else // usdc swap
                    method = 'publicGetPerpetualUsdcOpenapiPublicV1Tick';
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         ret_code: 0,
                    //         ret_msg: 'OK',
                    //         ext_code: '',
                    //         ext_info: '',
                    //         result: [
                    //             {
                    //                 symbol: 'BTCUSD',
                    //                 bid_price: '7680',
                    //                 ask_price: '7680.5',
                    //                 last_price: '7680.00',
                    //                 last_tick_direction: 'MinusTick',
                    //                 prev_price_24h: '7870.50',
                    //                 price_24h_pcnt: '-0.024204',
                    //                 high_price_24h: '8035.00',
                    //                 low_price_24h: '7671.00',
                    //                 prev_price_1h: '7780.00',
                    //                 price_1h_pcnt: '-0.012853',
                    //                 mark_price: '7683.27',
                    //                 index_price: '7682.74',
                    //                 open_interest: 188829147,
                    //                 open_value: '23670.06',
                    //                 total_turnover: '25744224.90',
                    //                 turnover_24h: '102997.83',
                    //                 total_volume: 225448878806,
                    //                 volume_24h: 809919408,
                    //                 funding_rate: '0.0001',
                    //                 predicted_funding_rate: '0.0001',
                    //                 next_funding_time: '2020-03-12T00:00:00Z',
                    //                 countdown_hour: 7
                    //             }
                    //         ],
                    //         time_now: '1583948195.818255'
                    //     }
                    //  usdc ticker
                    //     {
                    //         "retCode": 0,
                    //           "retMsg": "SUCCESS",
                    //           "result": {
                    //                  "symbol": "BTC-28JAN22-250000-C",
                    //                    "bid": "0",
                    //                    "bidIv": "0",
                    //                    "bidSize": "0",
                    //                    "ask": "0",
                    //                    "askIv": "0",
                    //                    "askSize": "0",
                    //                    "lastPrice": "0",
                    //                    "openInterest": "0",
                    //                    "indexPrice": "56171.79000000",
                    //                    "markPrice": "12.72021285",
                    //                    "markPriceIv": "1.1701",
                    //                    "change24h": "0",
                    //                    "high24h": "0",
                    //                    "low24h": "0",
                    //                    "volume24h": "0",
                    //                    "turnover24h": "0",
                    //                    "totalVolume": "0",
                    //                    "totalTurnover": "0",
                    //                    "predictedDeliveryPrice": "0",
                    //                    "underlyingPrice": "57039.61000000",
                    //                    "delta": "0.00184380",
                    //                    "gamma": "0.00000022",
                    //                    "vega": "1.35132531",
                    //                    "theta": "-1.33819821"
                    //          }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    let rawTicker = undefined;
                    if (Array.isArray(result)) rawTicker = this.safeValue(result, 0);
                    else rawTicker = result;
                    const ticker = this.parseTicker(rawTicker, market);
                    return ticker;
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    let type = undefined;
                    let market = undefined;
                    let isUsdcSettled = undefined;
                    if (symbols !== undefined) {
                        const symbol = this.safeValue(symbols, 0);
                        market = this.market(symbol);
                        type = market['type'];
                        isUsdcSettled = market['settle'] === 'USDC';
                    } else {
                        [type, params] = this.handleMarketTypeAndParams('fetchTickers', market, params);
                        if (type !== 'spot') {
                            let defaultSettle = this.safeString(this.options, 'defaultSettle', 'USDT');
                            defaultSettle = this.safeString2(params, 'settle', 'defaultSettle', isUsdcSettled);
                            params = this.omit(params, [
                                'settle',
                                'defaultSettle'
                            ]);
                            isUsdcSettled = defaultSettle === 'USDC';
                        }
                    }
                    let method = undefined;
                    if (type === 'spot') method = 'publicGetSpotQuoteV1Ticker24hr';
                    else if (!isUsdcSettled) // inverse perpetual // usdt linear // inverse futures
                    method = 'publicGetV2PublicTickers';
                    else throw new NotSupported(this.id + ' fetchTickers() is not supported for USDC markets');
                    const response = await this[method](params);
                    const result = this.safeValue(response, 'result', []);
                    const tickers = {};
                    for(let i = 0; i < result.length; i++){
                        const ticker = this.parseTicker(result[i]);
                        const symbol = ticker['symbol'];
                        tickers[symbol] = ticker;
                    }
                    return this.filterByArray(tickers, 'symbol', symbols);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    // inverse perpetual BTC/USD
                    //
                    //     {
                    //         symbol: 'BTCUSD',
                    //         interval: '1',
                    //         open_time: 1583952540,
                    //         open: '7760.5',
                    //         high: '7764',
                    //         low: '7757',
                    //         close: '7763.5',
                    //         volume: '1259766',
                    //         turnover: '162.32773718999994'
                    //     }
                    //
                    // linear perpetual BTC/USDT
                    //
                    //     {
                    //         "id":143536,
                    //         "symbol":"BTCUSDT",
                    //         "period":"15",
                    //         "start_at":1587883500,
                    //         "volume":1.035,
                    //         "open":7540.5,
                    //         "high":7541,
                    //         "low":7540.5,
                    //         "close":7541
                    //     }
                    //
                    // usdc perpetual
                    //     {
                    //         "symbol":"BTCPERP",
                    //         "volume":"0.01",
                    //         "period":"1",
                    //         "openTime":"1636358160",
                    //         "open":"66001.50",
                    //         "high":"66001.50",
                    //         "low":"66001.50",
                    //         "close":"66001.50",
                    //         "turnover":"1188.02"
                    //     }
                    //
                    // spot
                    //     [
                    //         1651837620000, // start tame
                    //         "35831.5", // open
                    //         "35831.5", // high
                    //         "35801.93", // low
                    //         "35817.11", // close
                    //         "1.23453", // volume
                    //         0, // end time
                    //         "44213.97591627", // quote asset volume
                    //         24, // number of trades
                    //         "0", // taker base volume
                    //         "0" // taker quote volume
                    //     ]
                    //
                    if (Array.isArray(ohlcv)) return [
                        this.safeNumber(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                    let timestamp = this.safeTimestamp2(ohlcv, 'open_time', 'openTime');
                    if (timestamp === undefined) timestamp = this.safeTimestamp(ohlcv, 'start_at');
                    return [
                        timestamp,
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber2(ohlcv, 'volume', 'turnover')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const price = this.safeString(params, 'price');
                    params = this.omit(params, 'price');
                    const request = {
                        'symbol': market['id']
                    };
                    const duration = this.parseTimeframe(timeframe);
                    const now = this.seconds();
                    let sinceTimestamp = undefined;
                    if (since === undefined) {
                        if (limit === undefined) throw new ArgumentsRequired1(this.id + ' fetchOHLCV() requires a since argument or a limit argument');
                        else sinceTimestamp = now - limit * duration;
                    } else sinceTimestamp = parseInt(since / 1000);
                    if (limit !== undefined) request['limit'] = limit; // max 200, default 200
                    let method = undefined;
                    let intervalKey = 'interval';
                    let sinceKey = 'from';
                    const isUsdcSettled = market['settle'] === 'USDC';
                    if (market['spot']) method = 'publicGetSpotQuoteV1Kline';
                    else if (market['contract'] && !isUsdcSettled) {
                        if (market['linear']) {
                            // linear swaps/futures
                            const methods = {
                                'mark': 'publicGetPublicLinearMarkPriceKline',
                                'index': 'publicGetPublicLinearIndexPriceKline',
                                'premium': 'publicGetPublicLinearPremiumIndexKline'
                            };
                            method = this.safeValue(methods, price, 'publicGetPublicLinearKline');
                        } else {
                            // inverse swaps/ futures
                            const methods = {
                                'mark': 'publicGetV2PublicMarkPriceKline',
                                'index': 'publicGetV2PublicIndexPriceKline',
                                'premium': 'publicGetV2PublicPremiumPriceKline'
                            };
                            method = this.safeValue(methods, price, 'publicGetV2PublicKlineList');
                        }
                    } else {
                        // usdc markets
                        if (market['option']) throw new NotSupported(this.id + ' fetchOHLCV() is not supported for USDC options markets');
                        intervalKey = 'period';
                        sinceKey = 'startTime';
                        const methods = {
                            'mark': 'publicGetPerpetualUsdcOpenapiPublicV1MarkPriceKline',
                            'index': 'publicGetPerpetualUsdcOpenapiPublicV1IndexPriceKline',
                            'premium': 'publicGetPerpetualUsdcOpenapiPublicV1PremiumPriceKline'
                        };
                        method = this.safeValue(methods, price, 'publicGetPerpetualUsdcOpenapiPublicV1KlineList');
                    }
                    // spot markets use the same interval format as ccxt
                    // so we don't need  to convert it
                    request[intervalKey] = market['spot'] ? timeframe : this.timeframes[timeframe];
                    request[sinceKey] = sinceTimestamp;
                    const response = await this[method](this.extend(request, params));
                    //
                    // inverse perpetual BTC/USD
                    //
                    //     {
                    //         ret_code: 0,
                    //         ret_msg: 'OK',
                    //         ext_code: '',
                    //         ext_info: '',
                    //         result: [
                    //             {
                    //                 symbol: 'BTCUSD',
                    //                 interval: '1',
                    //                 open_time: 1583952540,
                    //                 open: '7760.5',
                    //                 high: '7764',
                    //                 low: '7757',
                    //                 close: '7763.5',
                    //                 volume: '1259766',
                    //                 turnover: '162.32773718999994'
                    //             },
                    //         ],
                    //         time_now: '1583953082.397330'
                    //     }
                    //
                    // linear perpetual BTC/USDT
                    //
                    //     {
                    //         "ret_code":0,
                    //         "ret_msg":"OK",
                    //         "ext_code":"",
                    //         "ext_info":"",
                    //         "result":[
                    //             {
                    //                 "id":143536,
                    //                 "symbol":"BTCUSDT",
                    //                 "period":"15",
                    //                 "start_at":1587883500,
                    //                 "volume":1.035,
                    //                 "open":7540.5,
                    //                 "high":7541,
                    //                 "low":7540.5,
                    //                 "close":7541
                    //             }
                    //         ],
                    //         "time_now":"1587884120.168077"
                    //     }
                    // spot
                    //     {
                    //    "ret_code": "0",
                    //    "ret_msg": null,
                    //     "result": [
                    //         [
                    //             1651837620000,
                    //             "35831.5",
                    //             "35831.5",
                    //             "35801.93",
                    //             "35817.11",
                    //             "1.23453",
                    //             0,
                    //             "44213.97591627",
                    //             24,
                    //             "0",
                    //             "0"
                    //         ]
                    //     ],
                    //     "ext_code": null,
                    //     "ext_info": null
                    // }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseOHLCVs(result, market, timeframe, since, limit);
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const isUsdcSettled = market['settle'] === 'USDC';
                    let method = undefined;
                    if (isUsdcSettled) method = 'publicGetPerpetualUsdcOpenapiPublicV1PrevFundingRate';
                    else method = market['linear'] ? 'publicLinearGetFundingPrevFundingRate' : 'publicGetV2PublicFundingPrevFundingRate';
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "ret_code":0,
                    //         "ret_msg":"OK",
                    //         "ext_code":"",
                    //         "ext_info":"",
                    //         "result":{
                    //             "symbol":"BTCUSDT",
                    //             "funding_rate":0.00006418,
                    //             "funding_rate_timestamp":"2022-03-11T16:00:00.000Z"
                    //         },
                    //         "time_now":"1647040818.724895"
                    //     }
                    //
                    //     {
                    //         "ret_code":0,
                    //         "ret_msg":"OK",
                    //         "ext_code":"",
                    //         "ext_info":"",
                    //         "result":{
                    //             "symbol":"BTCUSD",
                    //             "funding_rate":"0.00009536",
                    //             "funding_rate_timestamp":1647014400
                    //         },
                    //         "time_now":"1647040852.515724"
                    //     }
                    // usdc
                    //     {
                    //         "retCode":0,
                    //         "retMsg":"",
                    //         "result":{
                    //            "symbol":"BTCPERP",
                    //            "fundingRate":"0.00010000",
                    //            "fundingRateTimestamp":"1652112000000"
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    const fundingRate = this.safeNumber2(result, 'funding_rate', 'fundingRate');
                    let fundingTimestamp = this.parse8601(this.safeString(result, 'funding_rate_timestamp'));
                    if (fundingTimestamp === undefined) {
                        fundingTimestamp = this.safeTimestamp2(result, 'funding_rate_timestamp', fundingTimestamp);
                        if (fundingTimestamp === undefined) fundingTimestamp = this.safeInteger(result, 'fundingRateTimestamp');
                    }
                    const currentTime = this.milliseconds();
                    return {
                        'info': result,
                        'symbol': symbol,
                        'markPrice': undefined,
                        'indexPrice': undefined,
                        'interestRate': undefined,
                        'estimatedSettlePrice': undefined,
                        'timestamp': currentTime,
                        'datetime': this.iso8601(currentTime),
                        'fundingRate': fundingRate,
                        'fundingTimestamp': fundingTimestamp,
                        'fundingDatetime': this.iso8601(fundingTimestamp),
                        'nextFundingRate': undefined,
                        'nextFundingTimestamp': undefined,
                        'nextFundingDatetime': undefined,
                        'previousFundingRate': undefined,
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                async fetchIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    if (since === undefined && limit === undefined) throw new ArgumentsRequired1(this.id + ' fetchIndexOHLCV() requires a since argument or a limit argument');
                    const request = {
                        'price': 'index'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchMarkOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    if (since === undefined && limit === undefined) throw new ArgumentsRequired1(this.id + ' fetchMarkOHLCV() requires a since argument or a limit argument');
                    const request = {
                        'price': 'mark'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchPremiumIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    if (since === undefined && limit === undefined) throw new ArgumentsRequired1(this.id + ' fetchPremiumIndexOHLCV() requires a since argument or a limit argument');
                    const request = {
                        'price': 'premiumIndex'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                parseTrade(trade, market) {
                    //
                    //  public spot
                    //
                    //    {
                    //        "price": "39548.68",
                    //        "time": "1651748717850",
                    //        "qty": "0.166872",
                    //        "isBuyerMaker": true
                    //    }
                    //
                    // public linear/inverse swap/future
                    //
                    //     {
                    //         "id": "112348766532",
                    //         "symbol": "BTCUSDT",
                    //         "price": "39536",
                    //         "qty": "0.011",
                    //         "side": "Buy",
                    //         "time": "2022-05-05T11:16:02.000Z",
                    //         "trade_time_ms": "1651749362196"
                    //     }
                    //
                    // public usdc market
                    //
                    //     {
                    //         "symbol": "BTC-30SEP22-400000-C",
                    //         "orderQty": "0.010",
                    //         "orderPrice": "5.00",
                    //         "time": "1651104300208"
                    //     }
                    //
                    // private futures/swap
                    //
                    //      {
                    //          "order_id": "b020b4bc-6fe2-45b5-adbc-dd07794f9746",
                    //          "order_link_id": "",
                    //          "side": "Buy",
                    //          "symbol": "AAVEUSDT",
                    //          "exec_id": "09abe8f0-aea6-514e-942b-7da8cb935120",
                    //          "price": "269.3",
                    //          "order_price": "269.3",
                    //          "order_qty": "0.1",
                    //          "order_type": "Market",
                    //          "fee_rate": "0.00075",
                    //          "exec_price": "256.35",
                    //          "exec_type": "Trade",
                    //          "exec_qty": "0.1",
                    //          "exec_fee": "0.01922625",
                    //          "exec_value": "25.635",
                    //          "leaves_qty": "0",
                    //          "closed_size": "0",
                    //          "last_liquidity_ind": "RemovedLiquidity",
                    //          "trade_time": "1638276374",
                    //          "trade_time_ms": "1638276374312"
                    //      }
                    //
                    // spot
                    //    {
                    //         "id": "1149467000412631552",
                    //         "symbol": "LTCUSDT",
                    //         "symbolName": "LTCUSDT",
                    //         "orderId": "1149467000244912384",
                    //         "ticketId": "2200000000002601358",
                    //         "matchOrderId": "1149465793552007078",
                    //         "price": "100.19",
                    //         "qty": "0.09973",
                    //         "commission": "0.0099919487",
                    //         "commissionAsset": "USDT",
                    //         "time": "1651763144465",
                    //         "isBuyer": false,
                    //         "isMaker": false,
                    //         "fee": {
                    //             "feeTokenId": "USDT",
                    //             "feeTokenName": "USDT",
                    //             "fee": "0.0099919487"
                    //         },
                    //         "feeTokenId": "USDT",
                    //         "feeAmount": "0.0099919487",
                    //         "makerRebate": "0"
                    //     }
                    //
                    const id = this.safeString2(trade, 'id', 'exec_id');
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    let amountString = this.safeString2(trade, 'qty', 'exec_qty');
                    if (amountString === undefined) amountString = this.safeString(trade, 'orderQty');
                    let priceString = this.safeString2(trade, 'exec_price', 'price');
                    if (priceString === undefined) priceString = this.safeString(trade, 'orderPrice');
                    const costString = this.safeString(trade, 'exec_value');
                    let timestamp = this.parse8601(this.safeString(trade, 'time'));
                    if (timestamp === undefined) timestamp = this.safeNumber2(trade, 'trade_time_ms', 'time');
                    let side = this.safeStringLower(trade, 'side');
                    if (side === undefined) {
                        const isBuyer = this.safeValue(trade, 'isBuyer');
                        if (isBuyer !== undefined) side = isBuyer ? 'buy' : 'sell';
                    }
                    const isMaker = this.safeValue(trade, 'isMaker');
                    let takerOrMaker = undefined;
                    if (isMaker !== undefined) takerOrMaker = isMaker ? 'maker' : 'taker';
                    else {
                        const lastLiquidityInd = this.safeString(trade, 'last_liquidity_ind');
                        takerOrMaker = lastLiquidityInd === 'AddedLiquidity' ? 'maker' : 'taker';
                    }
                    const feeCostString = this.safeString(trade, 'exec_fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrencyCode = market['inverse'] ? market['base'] : market['quote'];
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode,
                            'rate': this.safeString(trade, 'fee_rate')
                        };
                    }
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': this.safeString2(trade, 'order_id', 'orderId'),
                        'type': this.safeStringLower(trade, 'order_type'),
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let method = undefined;
                    const request = {
                        'symbol': market['id']
                    };
                    const isUsdcSettled = market['settle'] === 'USDC';
                    if (market['type'] === 'spot') method = 'publicGetSpotQuoteV1Trades';
                    else if (!isUsdcSettled) // inverse perpetual // usdt linear // inverse futures
                    method = market['linear'] ? 'publicGetPublicLinearRecentTradingRecords' : 'publicGetV2PublicTradingRecords';
                    else {
                        // usdc option/ swap
                        method = 'publicGetOptionUsdcOpenapiPublicV1QueryTradeLatest';
                        request['category'] = market['option'] ? 'OPTION' : 'PERPETUAL';
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 500, max 1000
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         ret_code: 0,
                    //         ret_msg: 'OK',
                    //         ext_code: '',
                    //         ext_info: '',
                    //         result: [
                    //             {
                    //                 id: 43785688,
                    //                 symbol: 'BTCUSD',
                    //                 price: 7786,
                    //                 qty: 67,
                    //                 side: 'Sell',
                    //                 time: '2020-03-11T19:18:30.123Z'
                    //             },
                    //         ],
                    //         time_now: '1583954313.393362'
                    //     }
                    //
                    // usdc trades
                    //     {
                    //         "retCode": 0,
                    //           "retMsg": "Success.",
                    //           "result": {
                    //           "resultTotalSize": 2,
                    //             "cursor": "",
                    //             "dataList": [
                    //                  {
                    //                    "id": "3caaa0ca",
                    //                    "symbol": "BTCPERP",
                    //                    "orderPrice": "58445.00",
                    //                    "orderQty": "0.010",
                    //                    "side": "Buy",
                    //                    "time": "1638275679673"
                    //                  }
                    //              ]
                    //         }
                    //     }
                    //
                    let trades = this.safeValue(response, 'result', {});
                    if (!Array.isArray(trades)) trades = this.safeValue(trades, 'dataList', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseOrderBook(orderbook, symbol, timestamp, bidsKey = 'Buy', asksKey = 'Sell', priceKey = 'price', amountKey = 'size') {
                    const market = this.market(symbol);
                    if (market['spot']) {
                        const timestamp = this.safeInteger(orderbook, 'time');
                        return super.parseOrderBook(orderbook, symbol, timestamp, 'bids', 'asks');
                    }
                    const bids = [];
                    const asks = [];
                    for(let i = 0; i < orderbook.length; i++){
                        const bidask = orderbook[i];
                        const side = this.safeString(bidask, 'side');
                        if (side === 'Buy') bids.push(this.parseBidAsk(bidask, priceKey, amountKey));
                        else if (side === 'Sell') asks.push(this.parseBidAsk(bidask, priceKey, amountKey));
                        else throw new ExchangeError1(this.id + ' parseOrderBook() encountered an unrecognized bidask format: ' + this.json(bidask));
                    }
                    return {
                        'symbol': symbol,
                        'bids': this.sortBy(bids, 0, true),
                        'asks': this.sortBy(asks, 0),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'nonce': undefined
                    };
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const isUsdcSettled = market['settle'] === 'USDC';
                    let method = undefined;
                    if (market['spot']) method = 'publicGetSpotQuoteV1Depth';
                    else if (!isUsdcSettled) // inverse perpetual // usdt linear // inverse futures
                    method = 'publicGetV2PublicOrderBookL2';
                    else // usdc option/ swap
                    method = market['option'] ? 'publicGetOptionUsdcOpenapiPublicV1OrderBook' : 'publicGetPerpetualUsdcOpenapiPublicV1OrderBook';
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": null,
                    //         "result": {
                    //             "time": 1620886105740,
                    //             "bids": [
                    //                 ["50005.12","403.0416"]
                    //             ],
                    //             "asks": [
                    //                 ["50006.34", "0.2297" ]
                    //             ]
                    //         },
                    //         "ext_code": null,
                    //         "ext_info": null
                    //     }
                    //
                    // linear/inverse swap/futures
                    //
                    //     {
                    //         ret_code: 0,
                    //         ret_msg: 'OK',
                    //         ext_code: '',
                    //         ext_info: '',
                    //         result: [
                    //             { symbol: 'BTCUSD', price: '7767.5', size: 677956, side: 'Buy' },
                    //             { symbol: 'BTCUSD', price: '7767', size: 580690, side: 'Buy' },
                    //             { symbol: 'BTCUSD', price: '7766.5', size: 475252, side: 'Buy' },
                    //         ],
                    //         time_now: '1583954829.874823'
                    //     }
                    //
                    // usdc markets
                    //
                    //     {
                    //         "retCode": 0,
                    //           "retMsg": "SUCCESS",
                    //           "result": [
                    //           {
                    //             "price": "5000.00000000",
                    //             "size": "2.0000",
                    //             "side": "Buy" // bids
                    //           },
                    //           {
                    //             "price": "5900.00000000",
                    //             "size": "0.9000",
                    //             "side": "Sell" // asks
                    //           }
                    //         ]
                    //    }
                    //
                    const result = this.safeValue(response, 'result', []);
                    const timestamp = this.safeTimestamp(response, 'time_now');
                    return this.parseOrderBook(result, symbol, timestamp, 'Buy', 'Sell', 'price', 'size');
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const balances = this.safeValue(response, 'result', {});
                    const currencyIds = Object.keys(balances);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const balance = balances[currencyId];
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available_balance');
                        account['used'] = this.safeString(balance, 'used_margin');
                        account['total'] = this.safeString(balance, 'equity');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    // note: any funds in the 'spot' account will not be returned or visible from this endpoint
                    await this.loadMarkets();
                    const request = {};
                    const coin = this.safeString(params, 'coin');
                    const code = this.safeString(params, 'code');
                    if (coin !== undefined) request['coin'] = coin;
                    else if (code !== undefined) {
                        const currency = this.currency(code);
                        request['coin'] = currency['id'];
                    }
                    const response = await this.v2PrivateGetWalletBalance(this.extend(request, params));
                    //
                    //     {
                    //         ret_code: 0,
                    //         ret_msg: 'OK',
                    //         ext_code: '',
                    //         ext_info: '',
                    //         result: {
                    //             BTC: {
                    //                 equity: 0,
                    //                 available_balance: 0,
                    //                 used_margin: 0,
                    //                 order_margin: 0,
                    //                 position_margin: 0,
                    //                 occ_closing_fee: 0,
                    //                 occ_funding_fee: 0,
                    //                 wallet_balance: 0,
                    //                 realised_pnl: 0,
                    //                 unrealised_pnl: 0,
                    //                 cum_realised_pnl: 0,
                    //                 given_cash: 0,
                    //                 service_cash: 0
                    //             }
                    //         },
                    //         time_now: '1583937810.370020',
                    //         rate_limit_status: 119,
                    //         rate_limit_reset_ms: 1583937810367,
                    //         rate_limit: 120
                    //     }
                    //
                    return this.parseBalance(response);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        // basic orders
                        'Created': 'open',
                        'Rejected': 'rejected',
                        'New': 'open',
                        'PartiallyFilled': 'open',
                        'Filled': 'closed',
                        'Cancelled': 'canceled',
                        'PendingCancel': 'canceling',
                        // conditional orders
                        'Active': 'open',
                        'Untriggered': 'open',
                        'Triggered': 'closed',
                        // 'Cancelled': 'canceled', // order is cancelled
                        // 'Rejected': 'rejected', // order is triggered but fail to be placed
                        'Deactivated': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTimeInForce(timeInForce) {
                    const timeInForces = {
                        'GoodTillCancel': 'GTC',
                        'ImmediateOrCancel': 'IOC',
                        'FillOrKill': 'FOK',
                        'PostOnly': 'PO'
                    };
                    return this.safeString(timeInForces, timeInForce, timeInForce);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "user_id": 1,
                    //         "order_id": "335fd977-e5a5-4781-b6d0-c772d5bfb95b",
                    //         "symbol": "BTCUSD",
                    //         "side": "Buy",
                    //         "order_type": "Limit",
                    //         "price": 8800,
                    //         "qty": 1,
                    //         "time_in_force": "GoodTillCancel",
                    //         "order_status": "Created",
                    //         "last_exec_time": 0,
                    //         "last_exec_price": 0,
                    //         "leaves_qty": 1,
                    //         "cum_exec_qty": 0, // in contracts, where 1 contract = 1 quote currency unit (USD for inverse contracts)
                    //         "cum_exec_value": 0, // in contract's underlying currency (BTC for inverse contracts)
                    //         "cum_exec_fee": 0,
                    //         "reject_reason": "",
                    //         "order_link_id": "",
                    //         "created_at": "2019-11-30T11:03:43.452Z",
                    //         "updated_at": "2019-11-30T11:03:43.455Z"
                    //     }
                    //
                    // fetchOrder
                    //
                    //     {
                    //         "user_id" : 599946,
                    //         "symbol" : "BTCUSD",
                    //         "side" : "Buy",
                    //         "order_type" : "Limit",
                    //         "price" : "7948",
                    //         "qty" : 10,
                    //         "time_in_force" : "GoodTillCancel",
                    //         "order_status" : "Filled",
                    //         "ext_fields" : {
                    //             "o_req_num" : -1600687220498,
                    //             "xreq_type" : "x_create"
                    //         },
                    //         "last_exec_time" : "1588150113.968422",
                    //         "last_exec_price" : "7948",
                    //         "leaves_qty" : 0,
                    //         "leaves_value" : "0",
                    //         "cum_exec_qty" : 10,
                    //         "cum_exec_value" : "0.00125817",
                    //         "cum_exec_fee" : "-0.00000031",
                    //         "reject_reason" : "",
                    //         "cancel_type" : "",
                    //         "order_link_id" : "",
                    //         "created_at" : "2020-04-29T08:45:24.399146Z",
                    //         "updated_at" : "2020-04-29T08:48:33.968422Z",
                    //         "order_id" : "dd2504b9-0157-406a-99e1-efa522373944"
                    //     }
                    //
                    // fetchOrders linear swaps
                    //
                    //     {
                    //         "order_id":"7917bd70-e7c3-4af5-8147-3285cd99c509",
                    //         "user_id":22919890,
                    //         "symbol":"GMTUSDT",
                    //         "side":"Buy",
                    //         "order_type":"Limit",
                    //         "price":2.9262,
                    //         "qty":50,
                    //         "time_in_force":"GoodTillCancel",
                    //         "order_status":"Filled",
                    //         "last_exec_price":2.9219,
                    //         "cum_exec_qty":50,
                    //         "cum_exec_value":146.095,
                    //         "cum_exec_fee":0.087657,
                    //         "reduce_only":false,
                    //         "close_on_trigger":false,
                    //         "order_link_id":"",
                    //         "created_time":"2022-04-18T17:09:54Z",
                    //         "updated_time":"2022-04-18T17:09:54Z",
                    //         "take_profit":0,
                    //         "stop_loss":0,
                    //         "tp_trigger_by":"UNKNOWN",
                    //         "sl_trigger_by":"UNKNOWN"
                    //     }
                    //
                    // conditional order
                    //
                    //     {
                    //         "user_id":##,
                    //         "symbol":"BTCUSD",
                    //         "side":"Buy",
                    //         "order_type":"Market",
                    //         "price":0,
                    //         "qty":10,
                    //         "time_in_force":"GoodTillCancel",
                    //         "stop_order_type":"Stop",
                    //         "trigger_by":"LastPrice",
                    //         "base_price":11833,
                    //         "order_status":"Untriggered",
                    //         "ext_fields":{
                    //             "stop_order_type":"Stop",
                    //             "trigger_by":"LastPrice",
                    //             "base_price":11833,
                    //             "expected_direction":"Rising",
                    //             "trigger_price":12400,
                    //             "close_on_trigger":true,
                    //             "op_from":"api",
                    //             "remark":"x.x.x.x",
                    //             "o_req_num":0
                    //         },
                    //         "leaves_qty":10,
                    //         "leaves_value":0.00080645,
                    //         "reject_reason":null,
                    //         "cross_seq":-1,
                    //         "created_at":"2020-08-21T09:18:48.000Z",
                    //         "updated_at":"2020-08-21T09:18:48.000Z",
                    //         "trigger_price":12400,
                    //         "stop_order_id":"3f3b54b1-3379-42c7-8510-44f4d9915be0"
                    //     }
                    //
                    const marketId = this.safeString(order, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    let feeCurrency = undefined;
                    const timestamp = this.parse8601(this.safeString2(order, 'created_at', 'created_time'));
                    const id = this.safeString2(order, 'order_id', 'stop_order_id');
                    const type = this.safeStringLower(order, 'order_type');
                    let price = undefined;
                    if (type !== 'market') price = this.safeString(order, 'price');
                    const average = this.safeString(order, 'average_price');
                    const amount = this.safeString(order, 'qty');
                    const cost = this.safeString(order, 'cum_exec_value');
                    const filled = this.safeString(order, 'cum_exec_qty');
                    const remaining = this.safeString(order, 'leaves_qty');
                    const marketTypes = this.safeValue(this.options, 'marketTypes', {});
                    const marketType = this.safeString(marketTypes, symbol);
                    if (marketType === 'linear') feeCurrency = market['quote'];
                    else feeCurrency = market['base'];
                    let lastTradeTimestamp = this.safeTimestamp(order, 'last_exec_time');
                    if (lastTradeTimestamp === 0) lastTradeTimestamp = undefined;
                    const status = this.parseOrderStatus(this.safeString2(order, 'order_status', 'stop_order_status'));
                    const side = this.safeStringLower(order, 'side');
                    const feeCostString = this.safeString(order, 'cum_exec_fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) fee = {
                        'cost': feeCostString,
                        'currency': feeCurrency
                    };
                    let clientOrderId = this.safeString(order, 'order_link_id');
                    if (clientOrderId !== undefined && clientOrderId.length < 1) clientOrderId = undefined;
                    const timeInForce = this.parseTimeInForce(this.safeString(order, 'time_in_force'));
                    const stopPrice = this.safeNumber2(order, 'trigger_price', 'stop_px');
                    const postOnly = timeInForce === 'PO';
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': cost,
                        'average': average,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    let method = undefined;
                    if (market['swap']) {
                        if (market['linear']) method = 'privateLinearGetOrderSearch';
                        else if (market['inverse']) method = 'v2PrivateGetOrder';
                    } else if (market['future']) method = 'futuresPrivateGetOrder';
                    const stopOrderId = this.safeString(params, 'stop_order_id');
                    if (stopOrderId === undefined) {
                        const orderLinkId = this.safeString(params, 'order_link_id');
                        if (orderLinkId === undefined) request['order_id'] = id;
                    } else {
                        if (market['swap']) {
                            if (market['linear']) method = 'privateLinearGetStopOrderSearch';
                            else if (market['inverse']) method = 'v2PrivateGetStopOrder';
                        } else if (market['future']) method = 'futuresPrivateGetStopOrder';
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "OK",
                    //         "ext_code": "",
                    //         "ext_info": "",
                    //         "result": {
                    //             "user_id": 1,
                    //             "symbol": "BTCUSD",
                    //             "side": "Sell",
                    //             "order_type": "Limit",
                    //             "price": "8083",
                    //             "qty": 10,
                    //             "time_in_force": "GoodTillCancel",
                    //             "order_status": "New",
                    //             "ext_fields": { "o_req_num": -308787, "xreq_type": "x_create", "xreq_offset": 4154640 },
                    //             "leaves_qty": 10,
                    //             "leaves_value": "0.00123716",
                    //             "cum_exec_qty": 0,
                    //             "reject_reason": "",
                    //             "order_link_id": "",
                    //             "created_at": "2019-10-21T07:28:19.396246Z",
                    //             "updated_at": "2019-10-21T07:28:19.396246Z",
                    //             "order_id": "efa44157-c355-4a98-b6d6-1d846a936b93"
                    //         },
                    //         "time_now": "1571651135.291930",
                    //         "rate_limit_status": 99, // The remaining number of accesses in one minute
                    //         "rate_limit_reset_ms": 1580885703683,
                    //         "rate_limit": 100
                    //     }
                    //
                    // conditional orders
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "OK",
                    //         "ext_code": "",
                    //         "ext_info": "",
                    //         "result": {
                    //             "user_id": 1,
                    //             "symbol": "BTCUSD",
                    //             "side": "Buy",
                    //             "order_type": "Limit",
                    //             "price": "8000",
                    //             "qty": 1,
                    //             "time_in_force": "GoodTillCancel",
                    //             "order_status": "Untriggered",
                    //             "ext_fields": {},
                    //             "leaves_qty": 1,
                    //             "leaves_value": "0.00013333",
                    //             "cum_exec_qty": 0,
                    //             "cum_exec_value": null,
                    //             "cum_exec_fee": null,
                    //             "reject_reason": "",
                    //             "order_link_id": "",
                    //             "created_at": "2019-12-27T19:56:24.052194Z",
                    //             "updated_at": "2019-12-27T19:56:24.052194Z",
                    //             "order_id": "378a1bbc-a93a-4e75-87f4-502ea754ba36"
                    //         },
                    //         "time_now": "1577476584.386958",
                    //         "rate_limit_status": 99,
                    //         "rate_limit_reset_ms": 1580885703683,
                    //         "rate_limit": 100
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parseOrder(result, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let qty = this.amountToPrecision(symbol, amount);
                    if (market['inverse']) qty = parseInt(qty);
                    else qty = parseFloat(qty);
                    const request = {
                        // orders ---------------------------------------------------------
                        'side': this.capitalize(side),
                        'symbol': market['id'],
                        'order_type': this.capitalize(type),
                        'qty': qty,
                        // 'price': parseFloat (this.priceToPrecision (symbol, price)), // required for limit orders
                        'time_in_force': 'GoodTillCancel'
                    };
                    let priceIsRequired = false;
                    if (type === 'limit') priceIsRequired = true;
                    if (priceIsRequired) {
                        if (price !== undefined) request['price'] = parseFloat(this.priceToPrecision(symbol, price));
                        else throw new ArgumentsRequired1(this.id + ' createOrder() requires a price argument for a ' + type + ' order');
                    }
                    const clientOrderId = this.safeString2(params, 'order_link_id', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['order_link_id'] = clientOrderId;
                        params = this.omit(params, [
                            'order_link_id',
                            'clientOrderId'
                        ]);
                    }
                    const stopPx = this.safeValue2(params, 'stop_px', 'stopPrice');
                    const basePrice = this.safeValue(params, 'base_price');
                    let method = undefined;
                    if (market['swap']) {
                        if (market['linear']) {
                            method = 'privateLinearPostOrderCreate';
                            request['reduce_only'] = false;
                            request['close_on_trigger'] = false;
                        } else if (market['inverse']) method = 'v2PrivatePostOrderCreate';
                    } else if (market['future']) method = 'futuresPrivatePostOrderCreate';
                    if (stopPx !== undefined) {
                        if (basePrice === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires both the stop_px and base_price params for a conditional ' + type + ' order');
                        else {
                            if (market['swap']) {
                                if (market['linear']) method = 'privateLinearPostStopOrderCreate';
                                else if (market['inverse']) method = 'v2PrivatePostStopOrderCreate';
                            } else if (market['future']) method = 'futuresPrivatePostStopOrderCreate';
                            request['stop_px'] = parseFloat(this.priceToPrecision(symbol, stopPx));
                            request['base_price'] = parseFloat(this.priceToPrecision(symbol, basePrice));
                            request['trigger_by'] = 'LastPrice';
                            params = this.omit(params, [
                                'stop_px',
                                'stopPrice',
                                'base_price',
                                'trigger_by'
                            ]);
                        }
                    } else if (basePrice !== undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires both the stop_px and base_price params for a conditional ' + type + ' order');
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "OK",
                    //         "ext_code": "",
                    //         "ext_info": "",
                    //         "result": {
                    //             "user_id": 1,
                    //             "order_id": "335fd977-e5a5-4781-b6d0-c772d5bfb95b",
                    //             "symbol": "BTCUSD",
                    //             "side": "Buy",
                    //             "order_type": "Limit",
                    //             "price": 8800,
                    //             "qty": 1,
                    //             "time_in_force": "GoodTillCancel",
                    //             "order_status": "Created",
                    //             "last_exec_time": 0,
                    //             "last_exec_price": 0,
                    //             "leaves_qty": 1,
                    //             "cum_exec_qty": 0,
                    //             "cum_exec_value": 0,
                    //             "cum_exec_fee": 0,
                    //             "reject_reason": "",
                    //             "order_link_id": "",
                    //             "created_at": "2019-11-30T11:03:43.452Z",
                    //             "updated_at": "2019-11-30T11:03:43.455Z"
                    //         },
                    //         "time_now": "1575111823.458705",
                    //         "rate_limit_status": 98,
                    //         "rate_limit_reset_ms": 1580885703683,
                    //         "rate_limit": 100
                    //     }
                    //
                    // conditional orders
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "ok",
                    //         "ext_code": "",
                    //         "result": {
                    //             "user_id": 1,
                    //             "symbol": "BTCUSD",
                    //             "side": "Buy",
                    //             "order_type": "Limit",
                    //             "price": 8000,
                    //             "qty": 1,
                    //             "time_in_force": "GoodTillCancel",
                    //             "stop_order_type": "Stop",
                    //             "trigger_by": "LastPrice",
                    //             "base_price": 7000,
                    //             "order_status": "Untriggered",
                    //             "ext_fields": {
                    //                 "stop_order_type": "Stop",
                    //                 "trigger_by": "LastPrice",
                    //                 "base_price": 7000,
                    //                 "expected_direction": "Rising",
                    //                 "trigger_price": 7500,
                    //                 "op_from": "api",
                    //                 "remark": "127.0.01",
                    //                 "o_req_num": 0
                    //             },
                    //             "leaves_qty": 1,
                    //             "leaves_value": 0.00013333,
                    //             "reject_reason": null,
                    //             "cross_seq": -1,
                    //             "created_at": "2019-12-27T12:48:24.000Z",
                    //             "updated_at": "2019-12-27T12:48:24.000Z",
                    //             "stop_px": 7500,
                    //             "stop_order_id": "a85cd1c0-a9a4-49d3-a1bd-bab5ebe946d5"
                    //         },
                    //         "ext_info": null,
                    //         "time_now": "1577450904.327654",
                    //         "rate_limit_status": 99,
                    //         "rate_limit_reset_ms": 1577450904335,
                    //         "rate_limit": "100"
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parseOrder(result, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' editOrder() requires an symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        // 'order_id': id, // only for non-conditional orders
                        'symbol': market['id']
                    };
                    let method = undefined;
                    if (market['swap']) {
                        if (market['linear']) method = 'privateLinearPostOrderReplace';
                        else if (market['inverse']) method = 'v2PrivatePostOrderReplace';
                    } else if (market['future']) method = 'futuresPrivatePostOrderReplace';
                    const stopOrderId = this.safeString(params, 'stop_order_id');
                    if (stopOrderId !== undefined) {
                        if (market['swap']) {
                            if (market['linear']) method = 'privateLinearPostStopOrderReplace';
                            else if (market['inverse']) method = 'v2PrivatePostStopOrderReplace';
                        } else if (market['future']) method = 'futuresPrivatePostStopOrderReplace';
                        request['stop_order_id'] = stopOrderId;
                        params = this.omit(params, [
                            'stop_order_id'
                        ]);
                    } else request['order_id'] = id;
                    if (amount !== undefined) {
                        let qty = this.amountToPrecision(symbol, amount);
                        if (market['inverse']) qty = parseInt(qty);
                        else qty = parseFloat(qty);
                        request['p_r_qty'] = qty;
                    }
                    if (price !== undefined) request['p_r_price'] = parseFloat(this.priceToPrecision(symbol, price));
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "ok",
                    //         "ext_code": "",
                    //         "result": { "order_id": "efa44157-c355-4a98-b6d6-1d846a936b93" },
                    //         "time_now": "1539778407.210858",
                    //         "rate_limit_status": 99, // remaining number of accesses in one minute
                    //         "rate_limit_reset_ms": 1580885703683,
                    //         "rate_limit": 100
                    //     }
                    //
                    // conditional orders
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "ok",
                    //         "ext_code": "",
                    //         "result": { "stop_order_id": "378a1bbc-a93a-4e75-87f4-502ea754ba36" },
                    //         "ext_info": null,
                    //         "time_now": "1577475760.604942",
                    //         "rate_limit_status": 96,
                    //         "rate_limit_reset_ms": 1577475760612,
                    //         "rate_limit": "100"
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return {
                        'info': response,
                        'id': this.safeString2(result, 'order_id', 'stop_order_id'),
                        'order_id': this.safeString(result, 'order_id'),
                        'stop_order_id': this.safeString(result, 'stop_order_id')
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    let method = undefined;
                    if (market['swap']) {
                        if (market['linear']) method = 'privateLinearPostOrderCancel';
                        else if (market['inverse']) method = 'v2PrivatePostOrderCancel';
                    } else if (market['future']) method = 'futuresPrivatePostOrderCancel';
                    const stopOrderId = this.safeString(params, 'stop_order_id');
                    if (stopOrderId === undefined) {
                        const orderLinkId = this.safeString(params, 'order_link_id');
                        if (orderLinkId === undefined) request['order_id'] = id;
                    } else {
                        if (market['swap']) {
                            if (market['linear']) method = 'privateLinearPostStopOrderCancel';
                            else if (market['inverse']) method = 'v2PrivatePostStopOrderCancel';
                        } else if (market['future']) method = 'futuresPrivatePostStopOrderCancel';
                    }
                    const response = await this[method](this.extend(request, params));
                    const result = this.safeValue(response, 'result', {});
                    return this.parseOrder(result, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelAllOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const options = this.safeValue(this.options, 'cancelAllOrders', {});
                    let defaultMethod = undefined;
                    if (market['swap']) {
                        if (market['linear']) defaultMethod = 'privateLinearPostOrderCancelAll';
                        else if (market['inverse']) defaultMethod = 'v2PrivatePostOrderCancelAll';
                    } else if (market['future']) defaultMethod = 'futuresPrivatePostOrderCancelAll';
                    const stop = this.safeValue(params, 'stop');
                    if (stop) {
                        if (market['swap']) {
                            if (market['linear']) defaultMethod = 'privateLinearPostStopOrderCancelAll';
                            else if (market['inverse']) defaultMethod = 'v2PrivatePostStopOrderCancelAll';
                        } else if (market['future']) defaultMethod = 'futuresPrivatePostStopOrderCancelAll';
                    }
                    const method = this.safeString(options, 'method', defaultMethod);
                    params = this.omit(params, 'stop');
                    const response = await this[method](this.extend(request, params));
                    const result = this.safeValue(response, 'result', []);
                    return this.parseOrders(result, market);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    const options = this.safeValue(this.options, 'fetchOrders', {});
                    const defaultType = this.safeString(this.options, 'defaultType', 'linear');
                    const marketTypes = this.safeValue(this.options, 'marketTypes', {});
                    const marketType = this.safeString(marketTypes, symbol, defaultType);
                    let defaultMethod = undefined;
                    const marketDefined = market !== undefined;
                    const linear = marketDefined && market['linear'] || marketType === 'linear';
                    const inverse = marketDefined && market['swap'] && market['inverse'] || marketType === 'inverse';
                    const future = marketDefined && market['future'] || marketType === 'future' || marketType === 'futures'; // * (marketType === 'futures') deprecated, use (marketType === 'future')
                    if (linear) defaultMethod = 'privateLinearGetOrderList';
                    else if (inverse) defaultMethod = 'v2PrivateGetOrderList';
                    else if (future) defaultMethod = 'futuresPrivateGetOrderList';
                    let query = params;
                    if ('stop_order_id' in params || 'stop_order_status' in params) {
                        let stopOrderStatus = this.safeValue(params, 'stop_order_status');
                        if (stopOrderStatus !== undefined) {
                            if (Array.isArray(stopOrderStatus)) stopOrderStatus = stopOrderStatus.join(',');
                            request['stop_order_status'] = stopOrderStatus;
                            query = this.omit(params, 'stop_order_status');
                        }
                        if (linear) defaultMethod = 'privateLinearGetStopOrderList';
                        else if (inverse) defaultMethod = 'v2PrivateGetStopOrderList';
                        else if (future) defaultMethod = 'futuresPrivateGetStopOrderList';
                    }
                    const method = this.safeString(options, 'method', defaultMethod);
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "ok",
                    //         "ext_code": "",
                    //         "result": {
                    //             "current_page": 1,
                    //             "last_page": 6,
                    //             "data": [
                    //                 {
                    //                     "user_id": 1,
                    //                     "symbol": "BTCUSD",
                    //                     "side": "Sell",
                    //                     "order_type": "Market",
                    //                     "price": 7074,
                    //                     "qty": 2,
                    //                     "time_in_force": "ImmediateOrCancel",
                    //                     "order_status": "Filled",
                    //                     "ext_fields": {
                    //                         "close_on_trigger": true,
                    //                         "orig_order_type": "BLimit",
                    //                         "prior_x_req_price": 5898.5,
                    //                         "op_from": "pc",
                    //                         "remark": "127.0.0.1",
                    //                         "o_req_num": -34799032763,
                    //                         "xreq_type": "x_create"
                    //                     },
                    //                     "last_exec_time": "1577448481.696421",
                    //                     "last_exec_price": 7070.5,
                    //                     "leaves_qty": 0,
                    //                     "leaves_value": 0,
                    //                     "cum_exec_qty": 2,
                    //                     "cum_exec_value": 0.00028283,
                    //                     "cum_exec_fee": 0.00002,
                    //                     "reject_reason": "NoError",
                    //                     "order_link_id": "",
                    //                     "created_at": "2019-12-27T12:08:01.000Z",
                    //                     "updated_at": "2019-12-27T12:08:01.000Z",
                    //                     "order_id": "f185806b-b801-40ff-adec-52289370ed62"
                    //                 }
                    //             ]
                    //         },
                    //         "ext_info": null,
                    //         "time_now": "1577448922.437871",
                    //         "rate_limit_status": 98,
                    //         "rate_limit_reset_ms": 1580885703683,
                    //         "rate_limit": 100
                    //     }
                    //
                    // linear swaps
                    //
                    //     {
                    //         "ret_code":0,
                    //         "ret_msg":"OK",
                    //         "ext_code":"",
                    //         "ext_info":"",
                    //         "result":{
                    //             "current_page":1,
                    //             "data":[
                    //                 {
                    //                     "order_id":"7917bd70-e7c3-4af5-8147-3285cd99c509",
                    //                     "user_id":22919890,
                    //                     "symbol":"GMTUSDT",
                    //                     "side":"Buy",
                    //                     "order_type":"Limit",
                    //                     "price":2.9262,
                    //                     "qty":50,
                    //                     "time_in_force":"GoodTillCancel",
                    //                     "order_status":"Filled",
                    //                     "last_exec_price":2.9219,
                    //                     "cum_exec_qty":50,
                    //                     "cum_exec_value":146.095,
                    //                     "cum_exec_fee":0.087657,
                    //                     "reduce_only":false,
                    //                     "close_on_trigger":false,
                    //                     "order_link_id":"",
                    //                     "created_time":"2022-04-18T17:09:54Z",
                    //                     "updated_time":"2022-04-18T17:09:54Z",
                    //                     "take_profit":0,
                    //                     "stop_loss":0,
                    //                     "tp_trigger_by":"UNKNOWN",
                    //                     "sl_trigger_by":"UNKNOWN"
                    //                 }
                    //             ]
                    //         },
                    //         "time_now":"1650970113.283952",
                    //         "rate_limit_status":599,
                    //         "rate_limit_reset_ms":1650970113275,
                    //         "rate_limit":600
                    //     }
                    //
                    // conditional orders
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "ok",
                    //         "ext_code": "",
                    //         "result": {
                    //             "current_page": 1,
                    //             "last_page": 1,
                    //             "data": [
                    //                 {
                    //                     "user_id": 1,
                    //                     "stop_order_status": "Untriggered",
                    //                     "symbol": "BTCUSD",
                    //                     "side": "Buy",
                    //                     "order_type": "Limit",
                    //                     "price": 8000,
                    //                     "qty": 1,
                    //                     "time_in_force": "GoodTillCancel",
                    //                     "stop_order_type": "Stop",
                    //                     "trigger_by": "LastPrice",
                    //                     "base_price": 7000,
                    //                     "order_link_id": "",
                    //                     "created_at": "2019-12-27T12:48:24.000Z",
                    //                     "updated_at": "2019-12-27T12:48:24.000Z",
                    //                     "stop_px": 7500,
                    //                     "stop_order_id": "a85cd1c0-a9a4-49d3-a1bd-bab5ebe946d5"
                    //                 },
                    //             ]
                    //         },
                    //         "ext_info": null,
                    //         "time_now": "1577451658.755468",
                    //         "rate_limit_status": 599,
                    //         "rate_limit_reset_ms": 1577451658762,
                    //         "rate_limit": 600
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const data = this.safeValue(result, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const defaultStatuses = [
                        'Rejected',
                        'Filled',
                        'Cancelled'
                    ];
                    const options = this.safeValue(this.options, 'fetchClosedOrders', {});
                    let status = this.safeValue(options, 'order_status', defaultStatuses);
                    if (Array.isArray(status)) status = status.join(',');
                    const request = {};
                    const stopOrderStatus = this.safeValue(params, 'stop_order_status');
                    if (stopOrderStatus === undefined) request['order_status'] = status;
                    else request['stop_order_status'] = stopOrderStatus;
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const defaultStatuses = [
                        'Created',
                        'New',
                        'PartiallyFilled',
                        'PendingCancel'
                    ];
                    const options = this.safeValue(this.options, 'fetchOpenOrders', {});
                    let status = this.safeValue(options, 'order_status', defaultStatuses);
                    if (Array.isArray(status)) status = status.join(',');
                    const request = {};
                    const stopOrderStatus = this.safeValue(params, 'stop_order_status');
                    if (stopOrderStatus === undefined) request['order_status'] = status;
                    else request['stop_order_status'] = stopOrderStatus;
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    const request = {
                        'order_id': id
                    };
                    return await this.fetchMyTrades(symbol, since, limit, this.extend(request, params));
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    const orderId = this.safeString(params, 'order_id');
                    if (orderId !== undefined) {
                        request['order_id'] = orderId;
                        params = this.omit(params, 'order_id');
                    }
                    market = this.market(symbol);
                    const isUsdcSettled = market['settle'] === 'USDC';
                    if (isUsdcSettled) throw new NotSupported(this.id + ' fetchMyTrades() is not supported for market ' + symbol);
                    request['symbol'] = market['id'];
                    if (since !== undefined) request['start_time'] = since;
                    if (limit !== undefined) request['limit'] = limit; // default 20, max 50
                    let method = undefined;
                    if (market['spot']) method = 'privateGetSpotV1MyTrades';
                    else if (market['future']) method = 'privateGetFuturesPrivateExecutionList';
                    else // linear and inverse swaps
                    method = market['linear'] ? 'privateGetPrivateLinearTradeExecutionList' : 'privateGetV2PrivateExecutionList';
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "",
                    //         "ext_code": null,
                    //         "ext_info": null,
                    //         "result": [
                    //            {
                    //                 "id": "931975237315196160",
                    //                 "symbol": "BTCUSDT",
                    //                 "symbolName": "BTCUSDT",
                    //                 "orderId": "931975236946097408",
                    //                 "ticketId": "1057753175328833537",
                    //                 "matchOrderId": "931975113180558592",
                    //                 "price": "20000.00001",
                    //                 "qty": "0.01",
                    //                 "commission": "0.02000000001",
                    //                 "commissionAsset": "USDT",
                    //                 "time": "1625836105890",
                    //                 "isBuyer": false,
                    //                 "isMaker": false,
                    //                 "fee": {
                    //                     "feeTokenId": "USDT",
                    //                     "feeTokenName": "USDT",
                    //                     "fee": "0.02000000001"
                    //                 },
                    //                 "feeTokenId": "USDT",
                    //                 "feeAmount": "0.02000000001",
                    //                 "makerRebate": "0"
                    //            }
                    //         ]
                    //     }
                    //
                    // inverse
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "OK",
                    //         "ext_code": "",
                    //         "ext_info": "",
                    //         "result": {
                    //             "order_id": "Abandoned!!", // Abandoned!!
                    //             "trade_list": [
                    //                 {
                    //                     "closed_size": 0,
                    //                     "cross_seq": 277136382,
                    //                     "exec_fee": "0.0000001",
                    //                     "exec_id": "256e5ef8-abfe-5772-971b-f944e15e0d68",
                    //                     "exec_price": "8178.5",
                    //                     "exec_qty": 1,
                    //                     "exec_time": "1571676941.70682",
                    //                     "exec_type": "Trade", //Exec Type Enum
                    //                     "exec_value": "0.00012227",
                    //                     "fee_rate": "0.00075",
                    //                     "last_liquidity_ind": "RemovedLiquidity", //Liquidity Enum
                    //                     "leaves_qty": 0,
                    //                     "nth_fill": 2,
                    //                     "order_id": "7ad50cb1-9ad0-4f74-804b-d82a516e1029",
                    //                     "order_link_id": "",
                    //                     "order_price": "8178",
                    //                     "order_qty": 1,
                    //                     "order_type": "Market", //Order Type Enum
                    //                     "side": "Buy", //Side Enum
                    //                     "symbol": "BTCUSD", //Symbol Enum
                    //                     "user_id": 1
                    //                 }
                    //             ]
                    //         },
                    //         "time_now": "1577483699.281488",
                    //         "rate_limit_status": 118,
                    //         "rate_limit_reset_ms": 1577483699244737,
                    //         "rate_limit": 120
                    //     }
                    //
                    // linear
                    //
                    //     {
                    //         "ret_code":0,
                    //         "ret_msg":"OK",
                    //         "ext_code":"",
                    //         "ext_info":"",
                    //         "result":{
                    //             "current_page":1,
                    //             "data":[
                    //                 {
                    //                     "order_id":"b59418ec-14d4-4ef9-b9f4-721d5d576974",
                    //                     "order_link_id":"",
                    //                     "side":"Sell",
                    //                     "symbol":"BTCUSDT",
                    //                     "exec_id":"0327284d-faec-5191-bd89-acc5b4fafda9",
                    //                     "price":0.5,
                    //                     "order_price":0.5,
                    //                     "order_qty":0.01,
                    //                     "order_type":"Market",
                    //                     "fee_rate":0.00075,
                    //                     "exec_price":9709.5,
                    //                     "exec_type":"Trade",
                    //                     "exec_qty":0.01,
                    //                     "exec_fee":0.07282125,
                    //                     "exec_value":97.095,
                    //                     "leaves_qty":0,
                    //                     "closed_size":0.01,
                    //                     "last_liquidity_ind":"RemovedLiquidity",
                    //                     "trade_time":1591648052,
                    //                     "trade_time_ms":1591648052861
                    //                 }
                    //             ]
                    //         },
                    //         "time_now":"1591736501.979264",
                    //         "rate_limit_status":119,
                    //         "rate_limit_reset_ms":1591736501974,
                    //         "rate_limit":120
                    //     }
                    //
                    let result = this.safeValue(response, 'result', {});
                    if (!Array.isArray(result)) result = this.safeValue2(result, 'trade_list', 'data', []);
                    return this.parseTrades(result, market, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        // 'coin': currency['id'],
                        // 'currency': currency['id'], // alias
                        // 'start_date': this.iso8601 (since),
                        // 'end_date': this.iso8601 (till),
                        'wallet_fund_type': 'Deposit'
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['coin'] = currency['id'];
                    }
                    if (since !== undefined) request['start_date'] = this.yyyymmdd(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.v2PrivateGetWalletFundRecords(this.extend(request, params));
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "ok",
                    //         "ext_code": "",
                    //         "result": {
                    //             "data": [
                    //                 {
                    //                     "id": 234467,
                    //                     "user_id": 1,
                    //                     "coin": "BTC",
                    //                     "wallet_id": 27913,
                    //                     "type": "Realized P&L",
                    //                     "amount": "-0.00000006",
                    //                     "tx_id": "",
                    //                     "address": "BTCUSD",
                    //                     "wallet_balance": "0.03000330",
                    //                     "exec_time": "2019-12-09T00:00:25.000Z",
                    //                     "cross_seq": 0
                    //                 }
                    //             ]
                    //         },
                    //         "ext_info": null,
                    //         "time_now": "1577481867.115552",
                    //         "rate_limit_status": 119,
                    //         "rate_limit_reset_ms": 1577481867122,
                    //         "rate_limit": 120
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const data = this.safeValue(result, 'data', []);
                    return this.parseTransactions(data, currency, since, limit, {
                        'type': 'deposit'
                    });
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['coin'] = currency['id'];
                    }
                    if (since !== undefined) request['start_date'] = this.yyyymmdd(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.v2PrivateGetWalletWithdrawList(this.extend(request, params));
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "ok",
                    //         "ext_code": "",
                    //         "result": {
                    //             "data": [
                    //                 {
                    //                     "id": 137,
                    //                     "user_id": 1,
                    //                     "coin": "XRP", // Coin Enum
                    //                     "status": "Pending", // Withdraw Status Enum
                    //                     "amount": "20.00000000",
                    //                     "fee": "0.25000000",
                    //                     "address": "rH7H595XYEVTEHU2FySYsWnmfACBnZS9zM",
                    //                     "tx_id": "",
                    //                     "submited_at": "2019-06-11T02:20:24.000Z",
                    //                     "updated_at": "2019-06-11T02:20:24.000Z"
                    //                 },
                    //             ],
                    //             "current_page": 1,
                    //             "last_page": 1
                    //         },
                    //         "ext_info": null,
                    //         "time_now": "1577482295.125488",
                    //         "rate_limit_status": 119,
                    //         "rate_limit_reset_ms": 1577482295132,
                    //         "rate_limit": 120
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const data = this.safeValue(result, 'data', []);
                    return this.parseTransactions(data, currency, since, limit, {
                        'type': 'withdrawal'
                    });
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'ToBeConfirmed': 'pending',
                        'UnderReview': 'pending',
                        'Pending': 'pending',
                        'Success': 'ok',
                        'CancelByUser': 'canceled',
                        'Reject': 'rejected',
                        'Expire': 'expired'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "id": 137,
                    //         "user_id": 1,
                    //         "coin": "XRP", // Coin Enum
                    //         "status": "Pending", // Withdraw Status Enum
                    //         "amount": "20.00000000",
                    //         "fee": "0.25000000",
                    //         "address": "rH7H595XYEVTEHU2FySYsWnmfACBnZS9zM",
                    //         "tx_id": "",
                    //         "submited_at": "2019-06-11T02:20:24.000Z",
                    //         "updated_at": "2019-06-11T02:20:24.000Z"
                    //     }
                    //
                    // fetchDeposits ledger entries
                    //
                    //     {
                    //         "id": 234467,
                    //         "user_id": 1,
                    //         "coin": "BTC",
                    //         "wallet_id": 27913,
                    //         "type": "Realized P&L",
                    //         "amount": "-0.00000006",
                    //         "tx_id": "",
                    //         "address": "BTCUSD",
                    //         "wallet_balance": "0.03000330",
                    //         "exec_time": "2019-12-09T00:00:25.000Z",
                    //         "cross_seq": 0
                    //     }
                    //
                    const currencyId = this.safeString(transaction, 'coin');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const timestamp = this.parse8601(this.safeString2(transaction, 'submited_at', 'exec_time'));
                    const updated = this.parse8601(this.safeString(transaction, 'updated_at'));
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const address = this.safeString(transaction, 'address');
                    const feeCost = this.safeNumber(transaction, 'fee');
                    const type = this.safeStringLower(transaction, 'type');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    return {
                        'info': transaction,
                        'id': this.safeString(transaction, 'id'),
                        'txid': this.safeString(transaction, 'tx_id'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': this.safeNumber(transaction, 'amount'),
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['coin'] = currency['id'];
                    }
                    if (since !== undefined) request['start_date'] = this.yyyymmdd(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.v2PrivateGetWalletFundRecords(this.extend(request, params));
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "ok",
                    //         "ext_code": "",
                    //         "result": {
                    //             "data": [
                    //                 {
                    //                     "id": 234467,
                    //                     "user_id": 1,
                    //                     "coin": "BTC",
                    //                     "wallet_id": 27913,
                    //                     "type": "Realized P&L",
                    //                     "amount": "-0.00000006",
                    //                     "tx_id": "",
                    //                     "address": "BTCUSD",
                    //                     "wallet_balance": "0.03000330",
                    //                     "exec_time": "2019-12-09T00:00:25.000Z",
                    //                     "cross_seq": 0
                    //                 }
                    //             ]
                    //         },
                    //         "ext_info": null,
                    //         "time_now": "1577481867.115552",
                    //         "rate_limit_status": 119,
                    //         "rate_limit_reset_ms": 1577481867122,
                    //         "rate_limit": 120
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const data = this.safeValue(result, 'data', []);
                    return this.parseLedger(data, currency, since, limit);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     {
                    //         "id": 234467,
                    //         "user_id": 1,
                    //         "coin": "BTC",
                    //         "wallet_id": 27913,
                    //         "type": "Realized P&L",
                    //         "amount": "-0.00000006",
                    //         "tx_id": "",
                    //         "address": "BTCUSD",
                    //         "wallet_balance": "0.03000330",
                    //         "exec_time": "2019-12-09T00:00:25.000Z",
                    //         "cross_seq": 0
                    //     }
                    //
                    const currencyId = this.safeString(item, 'coin');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const amount = this.safeNumber(item, 'amount');
                    const after = this.safeNumber(item, 'wallet_balance');
                    const direction = amount < 0 ? 'out' : 'in';
                    let before = undefined;
                    if (after !== undefined && amount !== undefined) {
                        const difference = direction === 'out' ? amount : -amount;
                        before = this.sum(after, difference);
                    }
                    const timestamp = this.parse8601(this.safeString(item, 'exec_time'));
                    const type = this.parseLedgerEntryType(this.safeString(item, 'type'));
                    const id = this.safeString(item, 'id');
                    const referenceId = this.safeString(item, 'tx_id');
                    return {
                        'id': id,
                        'currency': code,
                        'account': this.safeString(item, 'wallet_id'),
                        'referenceAccount': undefined,
                        'referenceId': referenceId,
                        'status': undefined,
                        'amount': amount,
                        'before': before,
                        'after': after,
                        'fee': undefined,
                        'direction': direction,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'type': type,
                        'info': item
                    };
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'Deposit': 'transaction',
                        'Withdraw': 'transaction',
                        'RealisedPNL': 'trade',
                        'Commission': 'fee',
                        'Refund': 'cashback',
                        'Prize': 'prize',
                        'ExchangeOrderWithdraw': 'transaction',
                        'ExchangeOrderDeposit': 'transaction'
                    };
                    return this.safeString(types, type, type);
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (Array.isArray(symbols)) {
                        const length = symbols.length;
                        if (length !== 1) throw new ArgumentsRequired1(this.id + ' fetchPositions() takes an array with exactly one symbol');
                        request['symbol'] = this.marketId(symbols[0]);
                    }
                    const defaultType = this.safeString(this.options, 'defaultType', 'linear');
                    const type = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    let response = undefined;
                    if (type === 'linear') response = await this.privateLinearGetPositionList(this.extend(request, params));
                    else if (type === 'inverse') response = await this.v2PrivateGetPositionList(this.extend(request, params));
                    else if (type === 'inverseFuture') response = await this.futuresPrivateGetPositionList(this.extend(request, params));
                    if (typeof response === 'string' && this.isJsonEncodedObject(response)) response = JSON.parse(response);
                    //
                    //     {
                    //         ret_code: 0,
                    //         ret_msg: 'OK',
                    //         ext_code: '',
                    //         ext_info: '',
                    //         result: [] or {} depending on the request
                    //     }
                    //
                    return this.safeValue(response, 'result');
                }
                async setMarginMode(marginMode, symbol, params = {}) {
                    //
                    // {
                    //     "ret_code": 0,
                    //     "ret_msg": "ok",
                    //     "ext_code": "",
                    //     "result": null,
                    //     "ext_info": null,
                    //     "time_now": "1577477968.175013",
                    //     "rate_limit_status": 74,
                    //     "rate_limit_reset_ms": 1577477968183,
                    //     "rate_limit": 75
                    // }
                    //
                    const leverage = this.safeValue(params, 'leverage');
                    if (leverage === undefined) throw new ArgumentsRequired1(this.id + ' setMarginMode() requires a leverage parameter');
                    marginMode = marginMode.toUpperCase();
                    if (marginMode === 'CROSSED') marginMode = 'CROSS';
                    if (marginMode !== 'ISOLATED' && marginMode !== 'CROSS') throw new BadRequest(this.id + ' setMarginMode() marginMode must be either isolated or cross');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let method = undefined;
                    const defaultType = this.safeString(this.options, 'defaultType', 'linear');
                    const marketTypes = this.safeValue(this.options, 'marketTypes', {});
                    const marketType = this.safeString(marketTypes, symbol, defaultType);
                    const linear = market['linear'] || marketType === 'linear';
                    const inverse = market['swap'] && market['inverse'] || marketType === 'inverse';
                    const future = market['future'] || marketType === 'future' || marketType === 'futures'; // * (marketType === 'futures') deprecated, use (marketType === 'future')
                    if (linear) method = 'privateLinearPostPositionSwitchIsolated';
                    else if (inverse) method = 'v2PrivatePostPositionSwitchIsolated';
                    else if (future) method = 'privateFuturesPostPositionSwitchIsolated';
                    const isIsolated = marginMode === 'ISOLATED';
                    const request = {
                        'symbol': market['id'],
                        'is_isolated': isIsolated,
                        'buy_leverage': leverage,
                        'sell_leverage': leverage
                    };
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "ret_code": 0,
                    //         "ret_msg": "OK",
                    //         "ext_code": "",
                    //         "ext_info": "",
                    //         "result": null,
                    //         "time_now": "1585881597.006026",
                    //         "rate_limit_status": 74,
                    //         "rate_limit_reset_ms": 1585881597004,
                    //         "rate_limit": 75
                    //     }
                    //
                    return response;
                }
                async setLeverage(leverage, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    // WARNING: THIS WILL INCREASE LIQUIDATION PRICE FOR OPEN ISOLATED LONG POSITIONS
                    // AND DECREASE LIQUIDATION PRICE FOR OPEN ISOLATED SHORT POSITIONS
                    const defaultType = this.safeString(this.options, 'defaultType', 'linear');
                    const marketTypes = this.safeValue(this.options, 'marketTypes', {});
                    const marketType = this.safeString(marketTypes, symbol, defaultType);
                    const linear = market['linear'] || marketType === 'linear';
                    const inverse = market['swap'] && market['inverse'] || marketType === 'inverse';
                    const future = market['future'] || marketType === 'future' || marketType === 'futures'; // * (marketType === 'futures') deprecated, use (marketType === 'future')
                    let method = undefined;
                    if (linear) method = 'privateLinearPostPositionSetLeverage';
                    else if (inverse) method = 'v2PrivatePostPositionLeverageSave';
                    else if (future) method = 'privateFuturesPostPositionLeverageSave';
                    let buy_leverage = leverage;
                    let sell_leverage = leverage;
                    if (params['buy_leverage'] && params['sell_leverage'] && linear) {
                        buy_leverage = params['buy_leverage'];
                        sell_leverage = params['sell_leverage'];
                    } else if (!leverage) {
                        if (linear) throw new ArgumentsRequired1(this.id + ' setLeverage() requires either the parameter leverage or params["buy_leverage"] and params["sell_leverage"] for linear contracts');
                        else throw new ArgumentsRequired1(this.id + ' setLeverage() requires parameter leverage for inverse and futures contracts');
                    }
                    if (buy_leverage < 1 || buy_leverage > 100 || sell_leverage < 1 || sell_leverage > 100) throw new BadRequest(this.id + ' setLeverage() leverage should be between 1 and 100');
                    const request = {
                        'symbol': market['id'],
                        'leverage_only': true
                    };
                    if (!linear) request['leverage'] = buy_leverage;
                    else {
                        request['buy_leverage'] = buy_leverage;
                        request['sell_leverage'] = sell_leverage;
                    }
                    return await this[method](this.extend(request, params));
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = undefined;
                    if (Array.isArray(api)) {
                        const type = this.safeString(api, 0);
                        let section = this.safeString(api, 1);
                        if (type === 'spot') {
                            if (section === 'public') section = 'v1';
                            else section += '/v1';
                        }
                        url = this.implodeHostname(this.urls['api'][type]);
                        let request = '/' + type + '/' + section + '/' + path;
                        if (type === 'spot' || type === 'quote') {
                            if (Object.keys(params).length) request += '?' + this.rawencode(params);
                        } else if (section === 'public') {
                            if (Object.keys(params).length) request += '?' + this.rawencode(params);
                        } else if (type === 'public') {
                            if (Object.keys(params).length) request += '?' + this.rawencode(params);
                        } else {
                            this.checkRequiredCredentials();
                            const timestamp = this.nonce();
                            const query = this.extend(params, {
                                'api_key': this.apiKey,
                                'recv_window': this.options['recvWindow'],
                                'timestamp': timestamp
                            });
                            const sortedQuery = this.keysort(query);
                            const auth = this.rawencode(sortedQuery);
                            const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                            if (method === 'POST') {
                                body = this.json(this.extend(query, {
                                    'sign': signature
                                }));
                                headers = {
                                    'Content-Type': 'application/json'
                                };
                            } else request += '?' + this.urlencode(sortedQuery) + '&sign=' + signature;
                        }
                        url += request;
                    } else {
                        url = this.implodeHostname(this.urls['api'][api]) + '/' + path;
                        if (api === 'public') {
                            if (Object.keys(params).length) url += '?' + this.rawencode(params);
                        } else if (api === 'private') {
                            this.checkRequiredCredentials();
                            const timestamp = this.nonce();
                            const query = this.extend(params, {
                                'api_key': this.apiKey,
                                'recv_window': this.options['recvWindow'],
                                'timestamp': timestamp
                            });
                            const sortedQuery = this.keysort(query);
                            const auth = this.rawencode(sortedQuery);
                            const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                            if (method === 'POST') {
                                body = this.json(this.extend(query, {
                                    'sign': signature
                                }));
                                headers = {
                                    'Content-Type': 'application/json'
                                };
                            } else url += '?' + this.urlencode(sortedQuery) + '&sign=' + signature;
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (!response) return; // fallback to default error handler
                    //
                    //     {
                    //         ret_code: 10001,
                    //         ret_msg: 'ReadMapCB: expect { or n, but found \u0000, error ' +
                    //         'found in #0 byte of ...||..., bigger context ' +
                    //         '...||...',
                    //         ext_code: '',
                    //         ext_info: '',
                    //         result: null,
                    //         time_now: '1583934106.590436'
                    //     }
                    //
                    //     {
                    //         "retCode":10001,
                    //         "retMsg":"symbol params err",
                    //         "result":{"symbol":"","bid":"","bidIv":"","bidSize":"","ask":"","askIv":"","askSize":"","lastPrice":"","openInterest":"","indexPrice":"","markPrice":"","markPriceIv":"","change24h":"","high24h":"","low24h":"","volume24h":"","turnover24h":"","totalVolume":"","totalTurnover":"","fundingRate":"","predictedFundingRate":"","nextFundingTime":"","countdownHour":"0","predictedDeliveryPrice":"","underlyingPrice":"","delta":"","gamma":"","vega":"","theta":""}
                    //     }
                    //
                    const errorCode = this.safeString2(response, 'ret_code', 'retCode');
                    if (errorCode !== '0') {
                        if (errorCode === '30084') // not an error
                        // https://github.com/ccxt/ccxt/issues/11268
                        // https://github.com/ccxt/ccxt/pull/11624
                        // POST https://api.bybit.com/v2/private/position/switch-isolated 200 OK
                        // {"ret_code":30084,"ret_msg":"Isolated not modified","ext_code":"","ext_info":"","result":null,"time_now":"1642005219.937988","rate_limit_status":73,"rate_limit_reset_ms":1642005219894,"rate_limit":75}
                        return undefined;
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
                async fetchMarketLeverageTiers(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    market = this.market(symbol);
                    if (market['spot'] || market['option']) throw new BadRequest(this.id + ' fetchLeverageTiers() symbol does not support market ' + symbol);
                    request['symbol'] = market['id'];
                    const isUsdcSettled = market['settle'] === 'USDC';
                    let method = undefined;
                    if (isUsdcSettled) method = 'publicGetPerpetualUsdcOpenapiPublicV1RiskLimitList';
                    else if (market['linear']) method = 'publicLinearGetRiskLimit';
                    else method = 'publicGetV2PublicRiskLimitList';
                    const response = await this[method](this.extend(request, params));
                    //
                    //  publicLinearGetRiskLimit
                    //    {
                    //        ret_code: '0',
                    //        ret_msg: 'OK',
                    //        ext_code: '',
                    //        ext_info: '',
                    //        result: [
                    //            {
                    //                id: '11',
                    //                symbol: 'ETHUSDT',
                    //                limit: '800000',
                    //                maintain_margin: '0.01',
                    //                starting_margin: '0.02',
                    //                section: [
                    //                    '1',  '2',  '3',
                    //                    '5',  '10', '15',
                    //                    '25'
                    //                ],
                    //                is_lowest_risk: '1',
                    //                created_at: '2022-02-04 23:30:33.555252',
                    //                updated_at: '2022-02-04 23:30:33.555254',
                    //                max_leverage: '50'
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    //  v2PublicGetRiskLimitList
                    //    {
                    //        ret_code: '0',
                    //        ret_msg: 'OK',
                    //        ext_code: '',
                    //        ext_info: '',
                    //        result: [
                    //            {
                    //                id: '180',
                    //                is_lowest_risk: '0',
                    //                section: [
                    //                  '1', '2', '3',
                    //                  '4', '5', '7',
                    //                  '8', '9'
                    //                ],
                    //                symbol: 'ETHUSDH22',
                    //                limit: '30000',
                    //                max_leverage: '9',
                    //                starting_margin: '11',
                    //                maintain_margin: '5.5',
                    //                coin: 'ETH',
                    //                created_at: '2021-04-22T15:00:00Z',
                    //                updated_at: '2021-04-22T15:00:00Z'
                    //            },
                    //        ],
                    //        time_now: '1644017569.683191'
                    //    }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parseMarketLeverageTiers(result, market);
                }
                parseMarketLeverageTiers(info, market) {
                    //
                    //    Linear
                    //    [
                    //        {
                    //            id: '11',
                    //            symbol: 'ETHUSDT',
                    //            limit: '800000',
                    //            maintain_margin: '0.01',
                    //            starting_margin: '0.02',
                    //            section: [
                    //                '1',  '2',  '3',
                    //                '5',  '10', '15',
                    //                '25'
                    //            ],
                    //            is_lowest_risk: '1',
                    //            created_at: '2022-02-04 23:30:33.555252',
                    //            updated_at: '2022-02-04 23:30:33.555254',
                    //            max_leverage: '50'
                    //        },
                    //        ...
                    //    ]
                    //
                    //    Inverse
                    //    [
                    //        {
                    //            id: '180',
                    //            is_lowest_risk: '0',
                    //            section: [
                    //                '1', '2', '3',
                    //                '4', '5', '7',
                    //                '8', '9'
                    //            ],
                    //            symbol: 'ETHUSDH22',
                    //            limit: '30000',
                    //            max_leverage: '9',
                    //            starting_margin: '11',
                    //            maintain_margin: '5.5',
                    //            coin: 'ETH',
                    //            created_at: '2021-04-22T15:00:00Z',
                    //            updated_at: '2021-04-22T15:00:00Z'
                    //        }
                    //        ...
                    //    ]
                    //
                    // usdc swap
                    //
                    //    {
                    //        "riskId":"10001",
                    //        "symbol":"BTCPERP",
                    //        "limit":"1000000",
                    //        "startingMargin":"0.0100",
                    //        "maintainMargin":"0.0050",
                    //        "isLowestRisk":true,
                    //        "section":[
                    //           "1",
                    //           "2",
                    //           "3",
                    //           "5",
                    //           "10",
                    //           "25",
                    //           "50",
                    //           "100"
                    //        ],
                    //        "maxLeverage":"100.00"
                    //    }
                    //
                    let minNotional = 0;
                    const tiers = [];
                    for(let i = 0; i < info.length; i++){
                        const item = info[i];
                        const maxNotional = this.safeNumber(item, 'limit');
                        tiers.push({
                            'tier': this.sum(i, 1),
                            'currency': market['base'],
                            'minNotional': minNotional,
                            'maxNotional': maxNotional,
                            'maintenanceMarginRate': this.safeNumber2(item, 'maintain_margin', 'maintainMargin'),
                            'maxLeverage': this.safeNumber2(item, 'max_leverage', 'maxLeverage'),
                            'info': item
                        });
                        minNotional = maxNotional;
                    }
                    return tiers;
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    59: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, BadRequest: BadRequest, AuthenticationError: AuthenticationError, DDoSProtection: DDoSProtection, BadResponse: BadResponse } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class bytetrade extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'bytetrade',
                        'name': 'ByteTrade',
                        'countries': [
                            'HK'
                        ],
                        // 10 requests per second => ( 1000ms / 10 ) = 100
                        'rateLimit': 100,
                        'requiresWeb3': true,
                        'certified': false,
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBidsAsks': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': undefined
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '4h': '4h',
                            '1d': '1d',
                            '5d': '5d',
                            '1w': '1w',
                            '1M': '1M'
                        },
                        'urls': {
                            'test': {
                                'market': 'https://api-v2-test.byte-trade.com',
                                'public': 'https://api-v2-test.byte-trade.com'
                            },
                            'logo': 'https://user-images.githubusercontent.com/1294454/67288762-2f04a600-f4e6-11e9-9fd6-c60641919491.jpg',
                            'api': {
                                'market': 'https://api-v2.bttcdn.com',
                                'public': 'https://api-v2.bttcdn.com'
                            },
                            'www': 'https://www.byte-trade.com',
                            'doc': 'https://docs.byte-trade.com/#description'
                        },
                        'api': {
                            'market': {
                                'get': {
                                    'klines': 1,
                                    'depth': 1,
                                    'trades': 1,
                                    'tickers': 1
                                }
                            },
                            'public': {
                                'get': {
                                    'symbols': 1,
                                    'currencies': 1,
                                    'balance': 1,
                                    'orders/open': 1,
                                    'orders/closed': 1,
                                    'orders/all': 1,
                                    'orders': 1,
                                    'orders/trades': 1,
                                    'depositaddress': 1,
                                    'withdrawals': 1,
                                    'deposits': 1,
                                    'transfers': 1
                                },
                                'post': {
                                    'transaction/createorder': 1,
                                    'transaction/cancelorder': 1,
                                    'transaction/withdraw': 1,
                                    'transaction/transfer': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'taker': 0.0008,
                                'maker': 0.0008
                            }
                        },
                        'commonCurrencies': {
                            '1': 'ByteTrade',
                            '44': 'ByteHub',
                            '48': 'Blocktonic',
                            '133': 'TerraCredit'
                        },
                        'exceptions': {
                            'vertify error': AuthenticationError,
                            'verify error': AuthenticationError,
                            'transaction already in network': BadRequest,
                            'invalid argument': BadRequest
                        },
                        'options': {
                            'orderExpiration': 31536000000
                        }
                    });
                }
                async fetchCurrencies(params = {}) {
                    const currencies = await this.publicGetCurrencies(params);
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'code');
                        let code = undefined;
                        if (id in this.commonCurrencies) code = this.commonCurrencies[id];
                        else code = this.safeString(currency, 'name');
                        const name = this.safeString(currency, 'fullname');
                        // in byte-trade.com DEX, request https://api-v2.byte-trade.com/currencies will return currencies,
                        // the api doc is https://github.com/Bytetrade/bytetrade-official-api-docs/wiki/rest-api#get-currencies-get-currencys-supported-in-bytetradecom
                        // we can see the coin name is none-unique in the result, the coin which code is 18 is the CyberMiles ERC20, and the coin which code is 35 is the CyberMiles main chain, but their name is same.
                        // that is because bytetrade is a DEX, supports people create coin with the same name, but the id(code) of coin is unique, so we should use the id or name and id as the identity of coin.
                        // For coin name and symbol is same with CCXT, I use name@id as the key of commonCurrencies dict.
                        // [{
                        //     "name": "CMT",      // currency name, non-unique
                        //     "code": "18",       // currency id, unique
                        //     "type": "crypto",
                        //     "fullname": "CyberMiles",
                        //     "active": true,
                        //     "chainType": "ethereum",
                        //     "basePrecision": 18,
                        //     "transferPrecision": 10,
                        //     "externalPrecision": 18,
                        //     "chainContractAddress": "0xf85feea2fdd81d51177f6b8f35f0e6734ce45f5f",
                        //     "limits": {
                        //       "deposit": {
                        //         "min": "0",
                        //         "max": "-1"
                        //       },
                        //       "withdraw": {
                        //         "min": "0",
                        //         "max": "-1"
                        //       }
                        //     }
                        //   },
                        //   {
                        //     "name": "CMT",
                        //     "code": "35",
                        //     "type": "crypto",
                        //     "fullname": "CyberMiles",
                        //     "active": true,
                        //     "chainType": "cmt",
                        //     "basePrecision": 18,
                        //     "transferPrecision": 10,
                        //     "externalPrecision": 18,
                        //     "chainContractAddress": "0x0000000000000000000000000000000000000000",
                        //     "limits": {
                        //       "deposit": {
                        //         "min": "1",
                        //         "max": "-1"
                        //       },
                        //       "withdraw": {
                        //         "min": "10",
                        //         "max": "-1"
                        //       }
                        //     }
                        //   }
                        //   ]
                        const active = this.safeValue(currency, 'active');
                        const limits = this.safeValue(currency, 'limits');
                        const deposit = this.safeValue(limits, 'deposit');
                        const amountPrecision = this.safeInteger(currency, 'basePrecision');
                        let maxDeposit = this.safeString(deposit, 'max');
                        if (Precise.stringEquals(maxDeposit, '-1')) maxDeposit = undefined;
                        const withdraw = this.safeValue(limits, 'withdraw');
                        let maxWithdraw = this.safeString(withdraw, 'max');
                        if (Precise.stringEquals(maxWithdraw, '-1')) maxWithdraw = undefined;
                        result[code] = {
                            'id': id,
                            'code': code,
                            'name': name,
                            'active': active,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'precision': amountPrecision,
                            'fee': undefined,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'deposit': {
                                    'min': this.safeNumber(deposit, 'min'),
                                    'max': this.parseNumber(maxDeposit)
                                },
                                'withdraw': {
                                    'min': this.safeNumber(withdraw, 'min'),
                                    'max': this.parseNumber(maxWithdraw)
                                }
                            },
                            'info': currency
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const markets = await this.publicGetSymbols(params);
                    //
                    //     [
                    //         {
                    //             "symbol": "122406567911",
                    //             "name": "BTC/USDT",
                    //             "base": "32",
                    //             "quote": "57",
                    //             "marketStatus": 0,
                    //             "baseName": "BTC",
                    //             "quoteName": "USDT",
                    //             "active": true,
                    //             "maker": "0.0008",
                    //             "taker": "0.0008",
                    //             "precision": {
                    //                 "amount": 6,
                    //                 "price": 2,
                    //                 "minPrice":1
                    //             },
                    //             "limits": {
                    //                 "amount": {
                    //                     "min": "0.000001",
                    //                     "max": "-1"
                    //                 },
                    //                 "price": {
                    //                     "min": "0.01",
                    //                     "max": "-1"
                    //                 }
                    //             }
                    //        }
                    //    ]
                    //
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'symbol');
                        let base = this.safeString(market, 'baseName');
                        let quote = this.safeString(market, 'quoteName');
                        const baseId = this.safeString(market, 'base');
                        const quoteId = this.safeString(market, 'quote');
                        const normalBase = base.split('@' + baseId)[0];
                        let normalQuote = quote.split('@' + quoteId)[0];
                        if (quoteId === '126') normalQuote = 'ZAR'; // The id 126 coin is a special coin whose name on the chain is actually ZAR, but it is changed to ZCN after creation, so it must be changed to ZAR when placing the transaction in the chain
                        const normalSymbol = normalBase + '/' + normalQuote;
                        if (baseId in this.commonCurrencies) base = this.commonCurrencies[baseId];
                        if (quoteId in this.commonCurrencies) quote = this.commonCurrencies[quoteId];
                        const limits = this.safeValue(market, 'limits', {});
                        const amount = this.safeValue(limits, 'amount', {});
                        const price = this.safeValue(limits, 'price', {});
                        const precision = this.safeValue(market, 'precision', {});
                        let maxAmount = this.safeString(amount, 'max');
                        if (Precise.stringEquals(maxAmount, '-1')) maxAmount = undefined;
                        let maxPrice = this.safeString(price, 'max');
                        if (Precise.stringEquals(maxPrice, '-1')) maxPrice = undefined;
                        const entry = {
                            'id': id,
                            'symbol': base + '/' + quote,
                            'normalSymbol': normalSymbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': this.safeString(market, 'active'),
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.safeNumber(market, 'taker'),
                            'maker': this.safeNumber(market, 'maker'),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(precision, 'amount'),
                                'price': this.safeInteger(precision, 'price')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(amount, 'min'),
                                    'max': this.parseNumber(maxAmount)
                                },
                                'price': {
                                    'min': this.safeNumber(price, 'min'),
                                    'max': this.parseNumber(maxPrice)
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        };
                        result.push(entry);
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'code');
                        const code = this.safeCurrencyCode(currencyId, undefined);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'free');
                        account['used'] = this.safeString(balance, 'used');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    if (!('userid' in params) && this.apiKey === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires this.apiKey or userid argument');
                    await this.loadMarkets();
                    const request = {
                        'userid': this.apiKey
                    };
                    const response = await this.publicGetBalance(this.extend(request, params));
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default = maximum = 100
                    const response = await this.marketGetDepth(this.extend(request, params));
                    const timestamp = this.safeValue(response, 'timestamp');
                    const orderbook = this.parseOrderBook(response, symbol, timestamp);
                    return orderbook;
                }
                parseTicker(ticker, market) {
                    const timestamp = this.safeInteger(ticker, 'timestamp');
                    //
                    //     [
                    //         {
                    //             "symbol":"68719476706",
                    //             "name":"ETH/BTC",
                    //             "base":"2",
                    //             "quote":"32",
                    //             "timestamp":1575905991933,
                    //             "datetime":"2019-12-09T15:39:51.933Z",
                    //             "high":"0",
                    //             "low":"0",
                    //             "open":"0",
                    //             "close":"0",
                    //             "last":"0",
                    //             "change":"0",
                    //             "percentage":"0",
                    //             "baseVolume":"0",
                    //             "quoteVolume":"0"
                    //         }
                    //     ]
                    //
                    const marketId = this.safeString(ticker, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': this.safeString(ticker, 'weightedAvgPrice'),
                        'open': this.safeString(ticker, 'open'),
                        'close': this.safeString(ticker, 'close'),
                        'last': this.safeString(ticker, 'last'),
                        'previousClose': undefined,
                        'change': this.safeString(ticker, 'change'),
                        'percentage': this.safeString(ticker, 'percentage'),
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'baseVolume'),
                        'quoteVolume': this.safeString(ticker, 'quoteVolume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.marketGetTickers(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "symbol":"68719476706",
                    //             "name":"ETH/BTC",
                    //             "base":"2",
                    //             "quote":"32",
                    //             "timestamp":1575905991933,
                    //             "datetime":"2019-12-09T15:39:51.933Z",
                    //             "high":"0",
                    //             "low":"0",
                    //             "open":"0",
                    //             "close":"0",
                    //             "last":"0",
                    //             "change":"0",
                    //             "percentage":"0",
                    //             "baseVolume":"0",
                    //             "quoteVolume":"0"
                    //         }
                    //     ]
                    //
                    if (Array.isArray(response)) {
                        const ticker = this.safeValue(response, 0);
                        if (ticker === undefined) throw new BadResponse(this.id + ' fetchTicker() returned an empty response');
                        return this.parseTicker(ticker, market);
                    }
                    return this.parseTicker(response, market);
                }
                async fetchBidsAsks(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.marketGetDepth(params);
                    return this.parseTickers(response, symbols);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.marketGetTickers(params);
                    return this.parseTickers(response, symbols);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1591505760000,
                    //         "242.7",
                    //         "242.76",
                    //         "242.69",
                    //         "242.76",
                    //         "0.1892"
                    //     ]
                    //
                    return [
                        this.safeInteger(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'timeframe': this.timeframes[timeframe]
                    };
                    if (since !== undefined) request['since'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.marketGetKlines(this.extend(request, params));
                    //
                    //     [
                    //         [1591505760000,"242.7","242.76","242.69","242.76","0.1892"],
                    //         [1591505820000,"242.77","242.83","242.7","242.72","0.6378"],
                    //         [1591505880000,"242.72","242.73","242.61","242.72","0.4141"],
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // public trades
                    //  {
                    //      "id":"d38a5bc4b651106f9d6abf9ced671961909be215",
                    //      "timestamp":1642522255864,
                    //      "symbol":"122406567940",
                    //      "side":"sell",
                    //      "price":"0.12",
                    //      "amount":"0.5747"
                    //  }
                    //
                    // private trades
                    //  {
                    //      "id":"905b6ff62b6c90eb5b8c0f7ad0f6bccf018d15e4",
                    //      "timestamp":1642525375299,
                    //      "datetime":"2022-01-18T17:02:55.299Z",
                    //      "symbol":"122406567940",
                    //      "userid":"slimmjimm@gmail.com",
                    //      "otherUserid":"nakamoto@gmail.com",
                    //      "takerOrMaker":"maker",
                    //      "side":"sell",
                    //      "txid":"036a89648352732f26a2b6680331dd7887a5c800",
                    //      "type":"market",
                    //      "order":"84749f1ca91541d97e400f628d5bb7b1e418a738",
                    //      "fee": {
                    //          "cost":"0.000611176192",
                    //          "rate":"0.0008",
                    //          "code":57,"name":"USDT"
                    //          },
                    //      "cost":"0.76397024",
                    //      "price":"0.01216",
                    //      "amount":"62.8265",
                    //      "average":"0.01216",
                    //      "name":"DOGE/USDT"
                    //  }
                    //
                    const timestamp = this.safeInteger(trade, 'timestamp');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const costString = this.safeString(trade, 'cost');
                    const id = this.safeString(trade, 'id');
                    const type = this.safeString(trade, 'type');
                    const takerOrMaker = this.safeString(trade, 'takerOrMaker');
                    const side = this.safeString(trade, 'side');
                    const datetime = this.iso8601(timestamp); // this.safeString (trade, 'datetime');
                    const order = this.safeString(trade, 'order');
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const feeData = this.safeValue(trade, 'fee');
                    const feeCostString = this.safeString(feeData, 'cost');
                    const feeRateString = this.safeString(feeData, 'rate');
                    const feeCode = this.safeString(feeData, 'code');
                    const feeCurrency = this.safeCurrencyCode(feeCode);
                    const fee = {
                        'currency': feeCurrency,
                        'cost': feeCostString,
                        'rate': feeRateString
                    };
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'symbol': market['symbol'],
                        'id': id,
                        'order': order,
                        'type': type,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['since'] = since;
                    if (limit !== undefined) request['limit'] = limit; // default = 100, maximum = 500
                    const response = await this.marketGetTrades(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetSymbols(params);
                    //
                    //     [
                    //         {
                    //             "symbol": "122406567911",
                    //             "name": "BTC/USDT",
                    //             "base": "32",
                    //             "quote": "57",
                    //             "marketStatus": 0,
                    //             "baseName": "BTC",
                    //             "quoteName": "USDT",
                    //             "active": true,
                    //             "maker": "0.0008",
                    //             "taker": "0.0008",
                    //             "precision": {
                    //                 "amount": 6,
                    //                 "price": 2,
                    //                 "minPrice":1
                    //             },
                    //             "limits": {
                    //                 "amount": {
                    //                     "min": "0.000001",
                    //                     "max": "-1"
                    //                 },
                    //                 "price": {
                    //                     "min": "0.01",
                    //                     "max": "-1"
                    //                 }
                    //             }
                    //        }
                    //        ...
                    //    ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const symbolInfo = response[i];
                        const marketId = this.safeString(symbolInfo, 'name');
                        const symbol = this.safeSymbol(marketId);
                        result[symbol] = {
                            'info': symbolInfo,
                            'symbol': symbol,
                            'maker': this.safeNumber(symbolInfo, 'maker'),
                            'taker': this.safeNumber(symbolInfo, 'taker'),
                            'percentage': true
                        };
                    }
                    return result;
                }
                parseOrder(order, market) {
                    const status = this.safeString(order, 'status');
                    let symbol = undefined;
                    const marketId = this.safeString(order, 'symbol');
                    if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                    else {
                        const baseId = this.safeString(order, 'base');
                        const quoteId = this.safeString(order, 'quote');
                        if (baseId !== undefined && quoteId !== undefined) {
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote;
                        }
                    }
                    if (symbol === undefined && market !== undefined) symbol = market['symbol'];
                    const timestamp = this.safeInteger(order, 'timestamp');
                    const datetime = this.safeString(order, 'datetime');
                    const lastTradeTimestamp = this.safeInteger(order, 'lastTradeTimestamp');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'amount');
                    const filled = this.safeString(order, 'filled');
                    const remaining = this.safeString(order, 'remaining');
                    const cost = this.safeString(order, 'cost');
                    const average = this.safeString(order, 'average');
                    const id = this.safeString(order, 'id');
                    const type = this.safeString(order, 'type');
                    const side = this.safeString(order, 'side');
                    const feeData = this.safeValue(order, 'fee');
                    const feeCost = this.safeNumber(feeData, 'cost');
                    const feeRate = this.safeNumber(feeData, 'rate');
                    const feeCode = this.safeString(feeData, 'code');
                    const feeCurrency = this.safeCurrencyCode(feeCode);
                    const fee = {
                        'currency': feeCurrency,
                        'cost': feeCost,
                        'rate': feeRate
                    };
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': cost,
                        'average': average,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    this.checkRequiredDependencies();
                    if (this.apiKey === undefined) throw new ArgumentsRequired1('createOrder() requires this.apiKey or userid in params');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let sideNum = undefined;
                    let typeNum = undefined;
                    if (side === 'sell') sideNum = 1;
                    else sideNum = 2;
                    if (type === 'limit') typeNum = 1;
                    else {
                        typeNum = 2;
                        price = 0;
                    }
                    const normalSymbol = market['normalSymbol'];
                    const baseId = market['baseId'];
                    const baseCurrency = this.currency(market['base']);
                    const amountTruncated = this.amountToPrecision(symbol, amount);
                    const amountTruncatedPrecise = new Precise(amountTruncated);
                    amountTruncatedPrecise.reduce();
                    amountTruncatedPrecise.decimals -= baseCurrency['precision'];
                    const amountChain = amountTruncatedPrecise.toString();
                    const amountChainString = this.numberToString(amountChain);
                    const quoteId = market['quoteId'];
                    const quoteCurrency = this.currency(market['quote']);
                    const priceRounded = this.priceToPrecision(symbol, price);
                    const priceRoundedPrecise = new Precise(priceRounded);
                    priceRoundedPrecise.reduce();
                    priceRoundedPrecise.decimals -= quoteCurrency['precision'];
                    const priceChain = priceRoundedPrecise.toString();
                    const priceChainString = this.numberToString(priceChain);
                    const now = this.milliseconds();
                    const expiryDelta = this.safeInteger(this.options, 'orderExpiration', 31536000000);
                    const expiration = this.milliseconds() + expiryDelta;
                    let datetime = this.iso8601(now);
                    datetime = datetime.split('.')[0];
                    let expirationDatetime = this.iso8601(expiration);
                    expirationDatetime = expirationDatetime.split('.')[0];
                    const defaultDappId = 'Sagittarius';
                    const dappId = this.safeString(params, 'dappId', defaultDappId);
                    const defaultFee = this.safeString(this.options, 'fee', '300000000000000');
                    const totalFeeRate = this.safeString(params, 'totalFeeRate', 8);
                    const chainFeeRate = this.safeString(params, 'chainFeeRate', 1);
                    const fee = this.safeString(params, 'fee', defaultFee);
                    const eightBytes = '18446744073709551616'; // 2 ** 64
                    const allByteStringArray = [
                        this.numberToBE(1, 32),
                        this.numberToLE(Math.floor(now / 1000), 4),
                        this.numberToLE(1, 1),
                        this.numberToLE(Math.floor(expiration / 1000), 4),
                        this.numberToLE(1, 1),
                        this.numberToLE(32, 1),
                        this.numberToLE(0, 8),
                        this.numberToLE(fee, 8),
                        this.numberToLE(this.apiKey.length, 1),
                        this.stringToBinary(this.encode(this.apiKey)),
                        this.numberToLE(sideNum, 1),
                        this.numberToLE(typeNum, 1),
                        this.numberToLE(normalSymbol.length, 1),
                        this.stringToBinary(this.encode(normalSymbol)),
                        this.numberToLE(Precise.stringDiv(amountChainString, eightBytes, 0), 8),
                        this.numberToLE(Precise.stringMod(amountChainString, eightBytes), 8),
                        this.numberToLE(Precise.stringDiv(priceChainString, eightBytes, 0), 8),
                        this.numberToLE(Precise.stringMod(priceChainString, eightBytes), 8),
                        this.numberToLE(0, 2),
                        this.numberToLE(Math.floor(now / 1000), 4),
                        this.numberToLE(Math.floor(expiration / 1000), 4),
                        this.numberToLE(1, 1),
                        this.numberToLE(parseInt(chainFeeRate), 2),
                        this.numberToLE(1, 1),
                        this.numberToLE(parseInt(totalFeeRate), 2),
                        this.numberToLE(parseInt(quoteId), 4),
                        this.numberToLE(parseInt(baseId), 4),
                        this.numberToLE(0, 1),
                        this.numberToLE(1, 1),
                        this.numberToLE(dappId.length, 1),
                        this.stringToBinary(this.encode(dappId)),
                        this.numberToLE(0, 1)
                    ];
                    const txByteStringArray = [
                        this.numberToLE(Math.floor(now / 1000), 4),
                        this.numberToLE(1, 1),
                        this.numberToLE(Math.floor(expiration / 1000), 4),
                        this.numberToLE(1, 1),
                        this.numberToLE(32, 1),
                        this.numberToLE(0, 8),
                        this.numberToLE(fee, 8),
                        this.numberToLE(this.apiKey.length, 1),
                        this.stringToBinary(this.encode(this.apiKey)),
                        this.numberToLE(sideNum, 1),
                        this.numberToLE(typeNum, 1),
                        this.numberToLE(normalSymbol.length, 1),
                        this.stringToBinary(this.encode(normalSymbol)),
                        this.numberToLE(Precise.stringDiv(amountChainString, eightBytes, 0), 8),
                        this.numberToLE(Precise.stringMod(amountChainString, eightBytes), 8),
                        this.numberToLE(Precise.stringDiv(priceChainString, eightBytes, 0), 8),
                        this.numberToLE(Precise.stringMod(priceChainString, eightBytes), 8),
                        this.numberToLE(0, 2),
                        this.numberToLE(Math.floor(now / 1000), 4),
                        this.numberToLE(Math.floor(expiration / 1000), 4),
                        this.numberToLE(1, 1),
                        this.numberToLE(parseInt(chainFeeRate), 2),
                        this.numberToLE(1, 1),
                        this.numberToLE(parseInt(totalFeeRate), 2),
                        this.numberToLE(parseInt(quoteId), 4),
                        this.numberToLE(parseInt(baseId), 4),
                        this.numberToLE(0, 1),
                        this.numberToLE(1, 1),
                        this.numberToLE(dappId.length, 1),
                        this.stringToBinary(this.encode(dappId)),
                        this.numberToLE(0, 1)
                    ];
                    const txbytestring = this.binaryConcatArray(txByteStringArray);
                    const txidhash = this.hash(txbytestring, 'sha256', 'hex');
                    const txid = txidhash.slice(0, 40);
                    const orderidByteStringArray = [
                        this.numberToLE(txid.length, 1),
                        this.stringToBinary(this.encode(txid)),
                        this.numberToBE(0, 4)
                    ];
                    const orderidbytestring = this.binaryConcatArray(orderidByteStringArray);
                    const orderidhash = this.hash(orderidbytestring, 'sha256', 'hex');
                    const orderid = orderidhash.slice(0, 40);
                    const bytestring = this.binaryConcatArray(allByteStringArray);
                    const hash = this.hash(bytestring, 'sha256', 'hex');
                    const signature = this.ecdsa(hash, this.secret, 'secp256k1', undefined, true);
                    const recoveryParam = this.binaryToBase16(this.numberToLE(this.sum(signature['v'], 31), 1));
                    const mySignature = recoveryParam + signature['r'] + signature['s'];
                    const operation = {
                        'now': datetime,
                        'expiration': expirationDatetime,
                        'fee': fee,
                        'creator': this.apiKey,
                        'side': sideNum,
                        'order_type': typeNum,
                        'market_name': normalSymbol,
                        'amount': amountChain,
                        'price': priceChain,
                        'use_btt_as_fee': false,
                        'money_id': parseInt(quoteId),
                        'stock_id': parseInt(baseId),
                        'custom_no_btt_fee_rate': parseInt(totalFeeRate),
                        'custom_btt_fee_rate': parseInt(chainFeeRate)
                    };
                    const fatty = {
                        'timestamp': datetime,
                        'expiration': expirationDatetime,
                        'operations': [
                            [
                                32,
                                operation
                            ]
                        ],
                        'validate_type': 0,
                        'dapp': dappId,
                        'signatures': [
                            mySignature
                        ]
                    };
                    const request = {
                        'trObj': this.json(fatty)
                    };
                    const response = await this.publicPostTransactionCreateorder(request);
                    const timestamp = this.milliseconds();
                    const statusCode = this.safeString(response, 'code');
                    const status = statusCode === '0' ? 'open' : 'failed';
                    return {
                        'info': response,
                        'id': orderid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': undefined,
                        'type': undefined,
                        'side': undefined,
                        'price': undefined,
                        'amount': undefined,
                        'filled': undefined,
                        'remaining': undefined,
                        'cost': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'clientOrderId': undefined,
                        'average': undefined
                    };
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (!('userid' in params) && this.apiKey === undefined) throw new ArgumentsRequired1('fetchOrder() requires this.apiKey or userid argument');
                    await this.loadMarkets();
                    const request = {
                        'userid': this.apiKey
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.markets[symbol];
                        request['symbol'] = market['id'];
                    }
                    request['id'] = id;
                    const response = await this.publicGetOrders(this.extend(request, params));
                    return this.parseOrder(response, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (!('userid' in params) && this.apiKey === undefined) throw new ArgumentsRequired1('fetchOpenOrders() requires this.apiKey or userid argument');
                    await this.loadMarkets();
                    const request = {
                        'userid': this.apiKey
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['since'] = since;
                    const response = await this.publicGetOrdersOpen(this.extend(request, params));
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    if (!('userid' in params) && this.apiKey === undefined) throw new ArgumentsRequired1('fetchClosedOrders() requires this.apiKey or userid argument');
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        'userid': this.apiKey
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['since'] = since;
                    const response = await this.publicGetOrdersClosed(this.extend(request, params));
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (!('userid' in params) && this.apiKey === undefined) throw new ArgumentsRequired1('fetchOrders() requires this.apiKey or userid argument');
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        'userid': this.apiKey
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['since'] = since;
                    const response = await this.publicGetOrdersAll(this.extend(request, params));
                    return this.parseOrders(response, market, since, limit);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (this.apiKey === undefined) throw new ArgumentsRequired1('cancelOrder() requires hasAlreadyAuthenticatedSuccessfully');
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const baseId = market['baseId'];
                    const quoteId = market['quoteId'];
                    const normalSymbol = market['normalSymbol'];
                    const feeAmount = '300000000000000';
                    const now = this.milliseconds();
                    const expiration = 0;
                    let datetime = this.iso8601(now);
                    datetime = datetime.split('.')[0];
                    let expirationDatetime = this.iso8601(expiration);
                    expirationDatetime = expirationDatetime.split('.')[0];
                    const defaultDappId = 'Sagittarius';
                    const dappId = this.safeString(params, 'dappId', defaultDappId);
                    const byteStringArray = [
                        this.numberToBE(1, 32),
                        this.numberToLE(Math.floor(now / 1000), 4),
                        this.numberToLE(1, 1),
                        this.numberToLE(expiration, 4),
                        this.numberToLE(1, 1),
                        this.numberToLE(33, 1),
                        this.numberToLE(0, 8),
                        this.numberToLE(feeAmount, 8),
                        this.numberToLE(this.apiKey.length, 1),
                        this.stringToBinary(this.encode(this.apiKey)),
                        this.numberToLE(normalSymbol.length, 1),
                        this.stringToBinary(this.encode(normalSymbol)),
                        this.base16ToBinary(id),
                        this.numberToLE(parseInt(quoteId), 4),
                        this.numberToLE(parseInt(baseId), 4),
                        this.numberToLE(0, 1),
                        this.numberToLE(1, 1),
                        this.numberToLE(dappId.length, 1),
                        this.stringToBinary(this.encode(dappId)),
                        this.numberToLE(0, 1)
                    ];
                    const bytestring = this.binaryConcatArray(byteStringArray);
                    const hash = this.hash(bytestring, 'sha256', 'hex');
                    const signature = this.ecdsa(hash, this.secret, 'secp256k1', undefined, true);
                    const recoveryParam = this.binaryToBase16(this.numberToLE(this.sum(signature['v'], 31), 1));
                    const mySignature = recoveryParam + signature['r'] + signature['s'];
                    const operation = {
                        'fee': feeAmount,
                        'creator': this.apiKey,
                        'order_id': id,
                        'market_name': normalSymbol,
                        'money_id': parseInt(quoteId),
                        'stock_id': parseInt(baseId)
                    };
                    const fatty = {
                        'timestamp': datetime,
                        'expiration': expirationDatetime,
                        'operations': [
                            [
                                33,
                                operation
                            ]
                        ],
                        'validate_type': 0,
                        'dapp': dappId,
                        'signatures': [
                            mySignature
                        ]
                    };
                    const request = {
                        'trObj': this.json(fatty)
                    };
                    const response = await this.publicPostTransactionCancelorder(request);
                    const timestamp = this.milliseconds();
                    const statusCode = this.safeString(response, 'code');
                    const status = statusCode === '0' ? 'canceled' : 'failed';
                    return {
                        'info': response,
                        'id': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': undefined,
                        'type': undefined,
                        'side': undefined,
                        'price': undefined,
                        'amount': undefined,
                        'filled': undefined,
                        'remaining': undefined,
                        'cost': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'clientOrderId': undefined,
                        'average': undefined
                    };
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (!('userid' in params) && this.apiKey === undefined) throw new ArgumentsRequired1('fetchMyTrades() requires this.apiKey or userid argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'userid': this.apiKey
                    };
                    if (symbol !== undefined) request['symbol'] = market['id'];
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['since'] = since;
                    const response = await this.publicGetOrdersTrades(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (!('userid' in params) && this.apiKey === undefined) throw new ArgumentsRequired1('fetchDeposits() requires this.apiKey or userid argument');
                    let currency = undefined;
                    const request = {
                        'userid': this.apiKey
                    };
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) request['since'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetDeposits(this.extend(request, params));
                    return this.parseTransactions(response, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (!('userid' in params) && this.apiKey === undefined) throw new ArgumentsRequired1('fetchWithdrawals() requires this.apiKey or userid argument');
                    let currency = undefined;
                    const request = {
                        'userid': this.apiKey
                    };
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) request['since'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetWithdrawals(this.extend(request, params));
                    return this.parseTransactions(response, currency, since, limit);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'DEPOSIT_FAILED': 'failed',
                        'FEE_SEND_FAILED': 'failed',
                        'FEE_FAILED': 'failed',
                        'PAY_SEND_FAILED': 'failed',
                        'PAY_FAILED': 'failed',
                        'BTT_FAILED': 'failed',
                        'WITHDDRAW_FAILED': 'failed',
                        'USER_FAILED': 'failed',
                        'FEE_EXECUED': 'pending',
                        'PAY_EXECUED': 'pending',
                        'WITHDDRAW_EXECUTED': 'pending',
                        'USER_EXECUED': 'pending',
                        'BTT_SUCCED': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    const id = this.safeString(transaction, 'id');
                    const address = this.safeString(transaction, 'address');
                    let tag = this.safeString(transaction, 'tag');
                    if (tag !== undefined) {
                        if (tag.length < 1) tag = undefined;
                    }
                    const txid = this.safeValue(transaction, 'txid');
                    const currencyId = this.safeString(transaction, 'code');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const timestamp = this.safeInteger(transaction, 'timestamp');
                    const datetime = this.safeString(transaction, 'datetime');
                    const type = this.safeString(transaction, 'type');
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const amount = this.safeNumber(transaction, 'amount');
                    const feeInfo = this.safeValue(transaction, 'fee');
                    const feeCost = this.safeNumber(feeInfo, 'cost');
                    const feeCurrencyId = this.safeString(feeInfo, 'code');
                    const feeCode = this.safeCurrencyCode(feeCurrencyId, currency);
                    const fee = {
                        'cost': feeCost,
                        'currency': feeCode
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'address': address,
                        'tag': tag,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'fee': fee
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    if (!('userid' in params) && this.apiKey === undefined) throw new ArgumentsRequired1('fetchDepositAddress() requires this.apiKey or userid argument');
                    const currency = this.currency(code);
                    const request = {
                        'userid': this.apiKey,
                        'code': currency['id']
                    };
                    const response = await this.publicGetDepositaddress(request);
                    const firstAddress = this.safeValue(response, 0);
                    const address = this.safeString(firstAddress, 'address');
                    const tag = this.safeString(firstAddress, 'tag');
                    const chainType = this.safeStringUpper(firstAddress, 'chainType');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': chainType,
                        'info': response
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api];
                    url += '/' + path;
                    if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (code === 503) throw new DDoSProtection(this.id + ' ' + code.toString() + ' ' + reason + ' ' + body);
                    if (response === undefined) return; // fallback to default error handler
                    if ('code' in response) {
                        const status = this.safeString(response, 'code');
                        if (status === '1') {
                            const message = this.safeString(response, 'msg');
                            const feedback = this.id + ' ' + body;
                            this.throwExactlyMatchedException(this.exceptions, message, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    60: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, PermissionDenied: PermissionDenied, ExchangeNotAvailable: ExchangeNotAvailable, OnMaintenance: OnMaintenance, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, ArgumentsRequired: ArgumentsRequired1, BadSymbol: BadSymbol, BadRequest: BadRequest, RequestTimeout: RequestTimeout, NetworkError: NetworkError } = require1('./base/errors');
            const { TRUNCATE: TRUNCATE } = require1('./base/functions/number');
            // ---------------------------------------------------------------------------
            module.exports = class cdax extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'cdax',
                        'name': 'CDAX',
                        'countries': [
                            'RU'
                        ],
                        'rateLimit': 100,
                        'userAgent': this.userAgents['chrome39'],
                        'certified': false,
                        'version': 'v1',
                        'accounts': undefined,
                        'accountsById': undefined,
                        'hostname': 'cdax.io',
                        'pro': false,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createOrder': true,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': false,
                            'fetchDepositAddressesByNetwork': false,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchOrderTrades': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTradingLimits': true,
                            'fetchWithdrawals': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1min',
                            '5m': '5min',
                            '15m': '15min',
                            '30m': '30min',
                            '1h': '60min',
                            '4h': '4hour',
                            '1d': '1day',
                            '1w': '1week',
                            '1M': '1mon',
                            '1y': '1year'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/102157692-fd406280-3e90-11eb-8d46-4511b617cd17.jpg',
                            'api': {
                                'market': 'https://{hostname}/api',
                                'public': 'https://{hostname}/api',
                                'private': 'https://{hostname}/api'
                            },
                            'www': 'https://cdax.io',
                            'referral': 'https://cdax.io/invite?invite_code=esc74',
                            'doc': 'https://github.com/cloudapidoc/API_Docs',
                            'fees': 'https://cdax.io/about/fee'
                        },
                        'api': {
                            'market': {
                                'get': {
                                    'history/kline': 1,
                                    'detail/merged': 1,
                                    'depth': 1,
                                    'trade': 1,
                                    'history/trade': 1,
                                    'detail': 1,
                                    'tickers': 1,
                                    'etp': 1
                                }
                            },
                            'public': {
                                'get': {
                                    'common/symbols': 1,
                                    'common/currencys': 1,
                                    'common/timestamp': 1,
                                    'common/exchange': 1,
                                    'settings/currencys': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'account/accounts': 0.2,
                                    'account/accounts/{id}/balance': 0.2,
                                    'account/accounts/{sub-uid}': 1,
                                    'account/history': 4,
                                    'cross-margin/loan-info': 1,
                                    'margin/loan-info': 1,
                                    'fee/fee-rate/get': 1,
                                    'order/openOrders': 0.4,
                                    'order/orders': 0.4,
                                    'order/orders/{id}': 0.4,
                                    'order/orders/{id}/matchresults': 0.4,
                                    'order/orders/getClientOrder': 0.4,
                                    'order/history': 1,
                                    'order/matchresults': 1,
                                    // 'dw/withdraw-virtual/addresses', // 查询虚拟币提现地址（Deprecated）
                                    'query/deposit-withdraw': 1,
                                    // 'margin/loan-info', // duplicate
                                    'margin/loan-orders': 0.2,
                                    'margin/accounts/balance': 0.2,
                                    'cross-margin/loan-orders': 1,
                                    'cross-margin/accounts/balance': 1,
                                    'points/actions': 1,
                                    'points/orders': 1,
                                    'subuser/aggregate-balance': 10,
                                    'stable-coin/exchange_rate': 1,
                                    'stable-coin/quote': 1
                                },
                                'post': {
                                    'account/transfer': 1,
                                    'futures/transfer': 1,
                                    'order/batch-orders': 0.4,
                                    'order/orders/place': 0.2,
                                    'order/orders/submitCancelClientOrder': 0.2,
                                    'order/orders/batchCancelOpenOrders': 0.4,
                                    // 'order/orders', // 创建一个新的订单请求 （仅创建订单，不执行下单）
                                    // 'order/orders/{id}/place', // 执行一个订单 （仅执行已创建的订单）
                                    'order/orders/{id}/submitcancel': 0.2,
                                    'order/orders/batchcancel': 0.4,
                                    // 'dw/balance/transfer', // 资产划转
                                    'dw/withdraw/api/create': 1,
                                    // 'dw/withdraw-virtual/create', // 申请提现虚拟币
                                    // 'dw/withdraw-virtual/{id}/place', // 确认申请虚拟币提现（Deprecated）
                                    'dw/withdraw-virtual/{id}/cancel': 1,
                                    'dw/transfer-in/margin': 10,
                                    'dw/transfer-out/margin': 10,
                                    'margin/orders': 10,
                                    'margin/orders/{id}/repay': 10,
                                    'cross-margin/transfer-in': 1,
                                    'cross-margin/transfer-out': 1,
                                    'cross-margin/orders': 1,
                                    'cross-margin/orders/{id}/repay': 1,
                                    'stable-coin/exchange': 1,
                                    'subuser/transfer': 10
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.002'),
                                'taker': this.parseNumber('0.002')
                            }
                        },
                        'exceptions': {
                            'broad': {
                                'contract is restricted of closing positions on API.  Please contact customer service': OnMaintenance,
                                'maintain': OnMaintenance
                            },
                            'exact': {
                                // err-code
                                'bad-request': BadRequest,
                                'base-date-limit-error': BadRequest,
                                'api-not-support-temp-addr': PermissionDenied,
                                'timeout': RequestTimeout,
                                'gateway-internal-error': ExchangeNotAvailable,
                                'account-frozen-balance-insufficient-error': InsufficientFunds,
                                'invalid-amount': InvalidOrder,
                                'order-limitorder-amount-min-error': InvalidOrder,
                                'order-limitorder-amount-max-error': InvalidOrder,
                                'order-marketorder-amount-min-error': InvalidOrder,
                                'order-limitorder-price-min-error': InvalidOrder,
                                'order-limitorder-price-max-error': InvalidOrder,
                                'order-holding-limit-failed': InvalidOrder,
                                'order-orderprice-precision-error': InvalidOrder,
                                'order-etp-nav-price-max-error': InvalidOrder,
                                'order-orderstate-error': OrderNotFound,
                                'order-queryorder-invalid': OrderNotFound,
                                'order-update-error': ExchangeNotAvailable,
                                'api-signature-check-failed': AuthenticationError,
                                'api-signature-not-valid': AuthenticationError,
                                'base-record-invalid': OrderNotFound,
                                'base-symbol-trade-disabled': BadSymbol,
                                'base-symbol-error': BadSymbol,
                                'system-maintenance': OnMaintenance,
                                // err-msg
                                'invalid symbol': BadSymbol,
                                'symbol trade not open now': BadSymbol
                            }
                        },
                        'options': {
                            'defaultNetwork': 'ERC20',
                            'networks': {
                                'ETH': 'erc20',
                                'TRX': 'trc20',
                                'HRC20': 'hrc20',
                                'HECO': 'hrc20',
                                'HT': 'hrc20',
                                'ALGO': 'algo',
                                'OMNI': ''
                            },
                            // https://github.com/ccxt/ccxt/issues/5376
                            'fetchOrdersByStatesMethod': 'private_get_order_orders',
                            'fetchOpenOrdersMethod': 'fetch_open_orders_v1',
                            'createMarketBuyOrderRequiresPrice': true,
                            'fetchBalanceMethod': 'privateGetAccountAccountsIdBalance',
                            'createOrderMethod': 'privatePostOrderOrdersPlace',
                            'language': 'en-US'
                        },
                        'commonCurrencies': {
                            // https://github.com/ccxt/ccxt/issues/6081
                            // https://github.com/ccxt/ccxt/issues/3365
                            // https://github.com/ccxt/ccxt/issues/2873
                            'GET': 'Themis',
                            'GTC': 'Game.com',
                            'HIT': 'HitChain',
                            'HOT': 'Hydro Protocol',
                            // https://github.com/ccxt/ccxt/issues/7399
                            // https://coinmarketcap.com/currencies/pnetwork/
                            // https://coinmarketcap.com/currencies/penta/markets/
                            // https://en.cryptonomist.ch/blog/eidoo/the-edo-to-pnt-upgrade-what-you-need-to-know-updated/
                            'PNT': 'Penta',
                            'SBTC': 'Super Bitcoin',
                            'BIFI': 'Bitcoin File'
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetCommonTimestamp(params);
                    return this.safeInteger(response, 'data');
                }
                async fetchTradingLimits(symbols, params = {}) {
                    // this method should not be called directly, use loadTradingLimits () instead
                    //  by default it will try load withdrawal fees of all currencies (with separate requests)
                    //  however if you define symbols = [ 'ETH/BTC', 'LTC/BTC' ] in args it will only load those
                    await this.loadMarkets();
                    if (symbols === undefined) symbols = this.symbols;
                    const result = {};
                    for(let i = 0; i < symbols.length; i++){
                        const symbol = symbols[i];
                        result[symbol] = await this.fetchTradingLimitsById(this.marketId(symbol), params);
                    }
                    return result;
                }
                async fetchTradingLimitsById(id, params = {}) {
                    const request = {
                        'symbol': id
                    };
                    const response = await this.publicGetCommonExchange(this.extend(request, params));
                    //
                    //    {
                    //        status:   "ok",
                    //        data: {
                    //            'symbol': "aidocbtc",
                    //            'buy-limit-must-less-than':  1.1,
                    //            'sell-limit-must-greater-than':  0.9,
                    //            'limit-order-must-greater-than':  1,
                    //            'limit-order-must-less-than':  5000000,
                    //            'market-buy-order-must-greater-than':  0.0001,
                    //            'market-buy-order-must-less-than':  100,
                    //            'market-sell-order-must-greater-than':  1,
                    //            'market-sell-order-must-less-than':  500000,
                    //            'circuit-break-when-greater-than':  10000,
                    //            'circuit-break-when-less-than':  10,
                    //            'market-sell-order-rate-must-less-than':  0.1,
                    //            'market-buy-order-rate-must-less-than':  0.1
                    //        }
                    //    }
                    //
                    return this.parseTradingLimits(this.safeValue(response, 'data', {}));
                }
                parseTradingLimits(limits, symbol, params = {}) {
                    //
                    //    {
                    //        'symbol': "aidocbtc",
                    //        'buy-limit-must-less-than':  1.1,
                    //        'sell-limit-must-greater-than':  0.9,
                    //        'limit-order-must-greater-than':  1,
                    //        'limit-order-must-less-than':  5000000,
                    //        'market-buy-order-must-greater-than':  0.0001,
                    //        'market-buy-order-must-less-than':  100,
                    //        'market-sell-order-must-greater-than':  1,
                    //        'market-sell-order-must-less-than':  500000,
                    //        'circuit-break-when-greater-than':  10000,
                    //        'circuit-break-when-less-than':  10,
                    //        'market-sell-order-rate-must-less-than':  0.1,
                    //        'market-buy-order-rate-must-less-than':  0.1
                    //    }
                    //
                    return {
                        'info': limits,
                        'limits': {
                            'amount': {
                                'min': this.safeNumber(limits, 'limit-order-must-greater-than'),
                                'max': this.safeNumber(limits, 'limit-order-must-less-than')
                            }
                        }
                    };
                }
                costToPrecision(symbol, cost) {
                    return this.decimalToPrecision(cost, TRUNCATE, this.markets[symbol]['precision']['cost'], this.precisionMode);
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetCommonSymbols(params);
                    //
                    //    {
                    //        "status": "ok",
                    //        "data": [
                    //            {
                    //                "base-currency": "ckb",
                    //                "quote-currency": "usdt",
                    //                "price-precision": 6,
                    //                "amount-precision": 2,
                    //                "symbol-partition": "default",
                    //                "symbol": "ckbusdt",
                    //                "state": "online",
                    //                "value-precision": 8,
                    //                "min-order-amt": 1,
                    //                "max-order-amt": 140000000,
                    //                "min-order-value": 5,
                    //                "limit-order-min-order-amt": 1,
                    //                "limit-order-max-order-amt": 140000000,
                    //                "limit-order-max-buy-amt": 140000000,
                    //                "limit-order-max-sell-amt": 140000000,
                    //                "sell-market-min-order-amt": 1,
                    //                "sell-market-max-order-amt": 14000000,
                    //                "buy-market-max-order-value": 200000,
                    //                "api-trading": "enabled",
                    //                "tags": ""
                    //            },
                    //        ]
                    //    }
                    //
                    const markets = this.safeValue(response, 'data');
                    const numMarkets = markets.length;
                    if (numMarkets < 1) throw new NetworkError(this.id + ' fetchMarkets() returned empty response: ' + this.json(markets));
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const baseId = this.safeString(market, 'base-currency');
                        const quoteId = this.safeString(market, 'quote-currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const state = this.safeString(market, 'state');
                        result.push({
                            'id': baseId + quoteId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': state === 'online',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': base === 'OMG' ? 0 : 0.002,
                            'maker': base === 'OMG' ? 0 : 0.002,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'amount-precision'),
                                'price': this.safeInteger(market, 'price-precision'),
                                'cost': this.safeInteger(market, 'value-precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': this.safeNumber(market, 'leverage-ratio', 1),
                                    'superMax': this.safeNumber(market, 'super-margin-leverage-ratio', 1)
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min-order-amt'),
                                    'max': this.safeNumber(market, 'max-order-amt')
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min-order-value', 0),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker
                    //
                    //     {
                    //         "amount": 26228.672978342216,
                    //         "open": 9078.95,
                    //         "close": 9146.86,
                    //         "high": 9155.41,
                    //         "id": 209988544334,
                    //         "count": 265846,
                    //         "low": 8988.0,
                    //         "version": 209988544334,
                    //         "ask": [ 9146.87, 0.156134 ],
                    //         "vol": 2.3822168242201668E8,
                    //         "bid": [ 9146.86, 0.080758 ],
                    //     }
                    //
                    // fetchTickers
                    //     {
                    //         symbol: "bhdht",
                    //         open:  2.3938,
                    //         high:  2.4151,
                    //         low:  2.3323,
                    //         close:  2.3909,
                    //         amount:  628.992,
                    //         vol:  1493.71841095,
                    //         count:  2088,
                    //         bid:  2.3643,
                    //         bidSize:  0.7136,
                    //         ask:  2.4061,
                    //         askSize:  0.4156
                    //     }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.safeInteger(ticker, 'ts');
                    let bid = undefined;
                    let bidVolume = undefined;
                    let ask = undefined;
                    let askVolume = undefined;
                    if ('bid' in ticker) {
                        if (Array.isArray(ticker['bid'])) {
                            bid = this.safeString(ticker['bid'], 0);
                            bidVolume = this.safeString(ticker['bid'], 1);
                        } else {
                            bid = this.safeString(ticker, 'bid');
                            bidVolume = this.safeString(ticker, 'bidSize');
                        }
                    }
                    if ('ask' in ticker) {
                        if (Array.isArray(ticker['ask'])) {
                            ask = this.safeString(ticker['ask'], 0);
                            askVolume = this.safeString(ticker['ask'], 1);
                        } else {
                            ask = this.safeString(ticker, 'ask');
                            askVolume = this.safeString(ticker, 'askSize');
                        }
                    }
                    const open = this.safeString(ticker, 'open');
                    const close = this.safeString(ticker, 'close');
                    const baseVolume = this.safeString(ticker, 'amount');
                    const quoteVolume = this.safeString(ticker, 'vol');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': bid,
                        'bidVolume': bidVolume,
                        'ask': ask,
                        'askVolume': askVolume,
                        'vwap': undefined,
                        'open': open,
                        'close': close,
                        'last': close,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'type': 'step0'
                    };
                    const response = await this.marketGetDepth(this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "ch": "market.btcusdt.depth.step0",
                    //         "ts": 1583474832790,
                    //         "tick": {
                    //             "bids": [
                    //                 [ 9100.290000000000000000, 0.200000000000000000 ],
                    //                 [ 9099.820000000000000000, 0.200000000000000000 ],
                    //                 [ 9099.610000000000000000, 0.205000000000000000 ],
                    //             ],
                    //             "asks": [
                    //                 [ 9100.640000000000000000, 0.005904000000000000 ],
                    //                 [ 9101.010000000000000000, 0.287311000000000000 ],
                    //                 [ 9101.030000000000000000, 0.012121000000000000 ],
                    //             ],
                    //             "ts":1583474832008,
                    //             "version":104999698780
                    //         }
                    //     }
                    //
                    if ('tick' in response) {
                        if (!response['tick']) throw new BadSymbol(this.id + ' fetchOrderBook() returned empty response: ' + this.json(response));
                        const tick = this.safeValue(response, 'tick');
                        const timestamp = this.safeInteger(tick, 'ts', this.safeInteger(response, 'ts'));
                        const result = this.parseOrderBook(tick, symbol, timestamp);
                        result['nonce'] = this.safeInteger(tick, 'version');
                        return result;
                    }
                    throw new ExchangeError1(this.id + ' fetchOrderBook() returned unrecognized response: ' + this.json(response));
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.marketGetDetailMerged(this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "ch": "market.btcusdt.detail.merged",
                    //         "ts": 1583494336669,
                    //         "tick": {
                    //             "amount": 26228.672978342216,
                    //             "open": 9078.95,
                    //             "close": 9146.86,
                    //             "high": 9155.41,
                    //             "id": 209988544334,
                    //             "count": 265846,
                    //             "low": 8988.0,
                    //             "version": 209988544334,
                    //             "ask": [ 9146.87, 0.156134 ],
                    //             "vol": 2.3822168242201668E8,
                    //             "bid": [ 9146.86, 0.080758 ],
                    //         }
                    //     }
                    //
                    const ticker = this.parseTicker(response['tick'], market);
                    const timestamp = this.safeInteger(response, 'ts');
                    ticker['timestamp'] = timestamp;
                    ticker['datetime'] = this.iso8601(timestamp);
                    return ticker;
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.marketGetTickers(params);
                    const tickers = this.safeValue(response, 'data');
                    const timestamp = this.safeInteger(response, 'ts');
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const marketId = this.safeString(tickers[i], 'symbol');
                        const market = this.safeMarket(marketId);
                        const symbol = market['symbol'];
                        const ticker = this.parseTicker(tickers[i], market);
                        ticker['timestamp'] = timestamp;
                        ticker['datetime'] = this.iso8601(timestamp);
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "id": "112522757755423628681413936",
                    //          "ts": "1638457111917",
                    //          "trade-id": "100454385963",
                    //          "amount": "13.7962",
                    //          "price": "1.697867",
                    //          "direction": "buy"
                    //      }
                    //
                    // fetchMyTrades (private)
                    //
                    //      {
                    //          "symbol": "adausdt",
                    //          "fee-currency": "usdt",
                    //          "source": "spot-api",
                    //          "order-id": "423628498050504",
                    //          "created-at": "1638455779233",
                    //          "role": "taker",
                    //          "price": "1.672487",
                    //          "match-id": "112521868633",
                    //          "trade-id": "100454375614",
                    //          "filled-amount": "6.8",
                    //          "filled-fees": "0.0227458232",
                    //          "filled-points": "0.0",
                    //          "fee-deduct-currency": "",
                    //          "fee-deduct-state": "done",
                    //          "id": "422419583501532",
                    //          "type": "sell-market"
                    //      },
                    //
                    // fetchOrderTrades (private)
                    //
                    //      {
                    //          "symbol": "adausdt",
                    //          "fee-currency": "usdt",
                    //          "source": "spot-api",
                    //          "match-id": "112521868633",
                    //          "trade-id": "100454375614",
                    //          "role": "taker",
                    //          "order-id": "423628498050504",
                    //          "price": "1.672487",
                    //          "created-at": "1638455779233",
                    //          "filled-amount": "6.8",
                    //          "filled-fees": "0.0227458232",
                    //          "filled-points": "0.0",
                    //          "fee-deduct-currency": "",
                    //          "fee-deduct-state": "done",
                    //          "id": "422419583501532",
                    //          "type": "sell-market"
                    //      }
                    //
                    const marketId = this.safeString(trade, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.safeInteger2(trade, 'ts', 'created-at');
                    const order = this.safeString(trade, 'order-id');
                    let side = this.safeString(trade, 'direction');
                    let type = this.safeString(trade, 'type');
                    if (type !== undefined) {
                        const typeParts = type.split('-');
                        side = typeParts[0];
                        type = typeParts[1];
                    }
                    const takerOrMaker = this.safeString(trade, 'role');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString2(trade, 'filled-amount', 'amount');
                    let fee = undefined;
                    let feeCostString = this.safeString(trade, 'filled-fees');
                    let feeCurrency = this.safeCurrencyCode(this.safeString(trade, 'fee-currency'));
                    const filledPoints = this.safeString(trade, 'filled-points');
                    if (filledPoints !== undefined) {
                        if (feeCostString === undefined || feeCostString === '0.0') {
                            feeCostString = filledPoints;
                            feeCurrency = this.safeCurrencyCode(this.safeString(trade, 'fee-deduct-currency'));
                        }
                    }
                    if (feeCostString !== undefined) fee = {
                        'cost': feeCostString,
                        'currency': feeCurrency
                    };
                    const tradeId = this.safeString2(trade, 'trade-id', 'tradeId');
                    const id = this.safeString(trade, 'id', tradeId);
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'order': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetOrderOrdersIdMatchresults(this.extend(request, params));
                    return this.parseTrades(response['data'], undefined, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['size'] = limit; // 1-100 orders, default is 100
                    if (since !== undefined) request['start-time'] = since; // a date within 120 days from today
                    const response = await this.privateGetOrderMatchresults(this.extend(request, params));
                    return this.parseTrades(response['data'], market, since, limit);
                }
                async fetchTrades(symbol, since, limit = 1000, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this.marketGetHistoryTrade(this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "ch": "market.btcusdt.trade.detail",
                    //         "ts": 1583497692365,
                    //         "data": [
                    //             {
                    //                 "id": 105005170342,
                    //                 "ts": 1583497692182,
                    //                 "data": [
                    //                     {
                    //                         "amount": 0.010411000000000000,
                    //                         "trade-id": 102090736910,
                    //                         "ts": 1583497692182,
                    //                         "id": 10500517034273194594947,
                    //                         "price": 9096.050000000000000000,
                    //                         "direction": "sell"
                    //                     }
                    //                 ]
                    //             },
                    //             // ...
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    let result = [];
                    for(let i = 0; i < data.length; i++){
                        const trades = this.safeValue(data[i], 'data', []);
                        for(let j = 0; j < trades.length; j++){
                            const trade = this.parseTrade(trades[j], market);
                            result.push(trade);
                        }
                    }
                    result = this.sortBy(result, 'timestamp');
                    return this.filterBySymbolSinceLimit(result, market['symbol'], since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "amount":1.2082,
                    //         "open":0.025096,
                    //         "close":0.025095,
                    //         "high":0.025096,
                    //         "id":1591515300,
                    //         "count":6,
                    //         "low":0.025095,
                    //         "vol":0.0303205097
                    //     }
                    //
                    return [
                        this.safeTimestamp(ohlcv, 'id'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'amount')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit = 1000, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'period': this.timeframes[timeframe]
                    };
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this.marketGetHistoryKline(this.extend(request, params));
                    //
                    //     {
                    //         "status":"ok",
                    //         "ch":"market.ethbtc.kline.1min",
                    //         "ts":1591515374371,
                    //         "data":[
                    //             {"amount":0.0,"open":0.025095,"close":0.025095,"high":0.025095,"id":1591515360,"count":0,"low":0.025095,"vol":0.0},
                    //             {"amount":1.2082,"open":0.025096,"close":0.025095,"high":0.025096,"id":1591515300,"count":6,"low":0.025095,"vol":0.0303205097},
                    //             {"amount":0.0648,"open":0.025096,"close":0.025096,"high":0.025096,"id":1591515240,"count":2,"low":0.025096,"vol":0.0016262208},
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async fetchAccounts(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountAccounts(params);
                    return response['data'];
                }
                async fetchCurrencies(params = {}) {
                    const request = {
                        'language': this.options['language']
                    };
                    const response = await this.publicGetSettingsCurrencys(this.extend(request, params));
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "currency-addr-with-tag":false,
                    //                 "fast-confirms":12,
                    //                 "safe-confirms":12,
                    //                 "currency-type":"eth",
                    //                 "quote-currency":true,
                    //                 "withdraw-enable-timestamp":1609430400000,
                    //                 "deposit-enable-timestamp":1609430400000,
                    //                 "currency-partition":"all",
                    //                 "support-sites":["OTC","INSTITUTION","MINEPOOL"],
                    //                 "withdraw-precision":6,
                    //                 "visible-assets-timestamp":1508839200000,
                    //                 "deposit-min-amount":"1",
                    //                 "withdraw-min-amount":"10",
                    //                 "show-precision":"8",
                    //                 "tags":"",
                    //                 "weight":23,
                    //                 "full-name":"Tether USDT",
                    //                 "otc-enable":1,
                    //                 "visible":true,
                    //                 "white-enabled":false,
                    //                 "country-disabled":false,
                    //                 "deposit-enabled":true,
                    //                 "withdraw-enabled":true,
                    //                 "name":"usdt",
                    //                 "state":"online",
                    //                 "display-name":"USDT",
                    //                 "suspend-withdraw-desc":null,
                    //                 "withdraw-desc":"Minimum withdrawal amount: 10 USDT (ERC20). !>_<!To ensure the safety of your funds, your withdrawal request will be manually reviewed if your security strategy or password is changed. Please wait for phone calls or emails from our staff.!>_<!Please make sure that your computer and browser are secure and your information is protected from being tampered or leaked.",
                    //                 "suspend-deposit-desc":null,
                    //                 "deposit-desc":"Please don’t deposit any other digital assets except USDT to the above address. Otherwise, you may lose your assets permanently. !>_<!Depositing to the above address requires confirmations of the entire network. It will arrive after 12 confirmations, and it will be available to withdraw after 12 confirmations. !>_<!Minimum deposit amount: 1 USDT. Any deposits less than the minimum will not be credited or refunded.!>_<!Your deposit address won’t change often. If there are any changes, we will notify you via announcement or email.!>_<!Please make sure that your computer and browser are secure and your information is protected from being tampered or leaked.",
                    //                 "suspend-visible-desc":null
                    //             }
                    //         ]
                    //     }
                    //
                    const currencies = this.safeValue(response, 'data');
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeValue(currency, 'name');
                        const precision = this.safeInteger(currency, 'withdraw-precision');
                        const code = this.safeCurrencyCode(id);
                        const depositEnabled = this.safeValue(currency, 'deposit-enabled');
                        const withdrawEnabled = this.safeValue(currency, 'withdraw-enabled');
                        const countryDisabled = this.safeValue(currency, 'country-disabled');
                        const visible = this.safeValue(currency, 'visible', false);
                        const state = this.safeString(currency, 'state');
                        const active = visible && depositEnabled && withdrawEnabled && state === 'online' && !countryDisabled;
                        const name = this.safeString(currency, 'display-name');
                        result[code] = {
                            'id': id,
                            'code': code,
                            'type': 'crypto',
                            // 'payin': currency['deposit-enabled'],
                            // 'payout': currency['withdraw-enabled'],
                            // 'transfer': undefined,
                            'name': name,
                            'active': active,
                            'deposit': depositEnabled,
                            'withdraw': withdrawEnabled,
                            'fee': undefined,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': Math.pow(10, -precision),
                                    'max': Math.pow(10, precision)
                                },
                                'deposit': {
                                    'min': this.safeNumber(currency, 'deposit-min-amount'),
                                    'max': Math.pow(10, precision)
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'withdraw-min-amount'),
                                    'max': Math.pow(10, precision)
                                }
                            },
                            'info': currency
                        };
                    }
                    return result;
                }
                parseBalance(response) {
                    const balances = this.safeValue(response['data'], 'list', []);
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        let account = undefined;
                        if (code in result) account = result[code];
                        else account = this.account();
                        if (balance['type'] === 'trade') account['free'] = this.safeString(balance, 'balance');
                        if (balance['type'] === 'frozen') account['used'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const method = this.options['fetchBalanceMethod'];
                    const request = {
                        'id': this.accounts[0]['id']
                    };
                    const response = await this[method](this.extend(request, params));
                    return this.parseBalance(response);
                }
                async fetchOrdersByStates(states, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'states': states
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const method = this.safeString(this.options, 'fetchOrdersByStatesMethod', 'private_get_order_orders');
                    const response = await this[method](this.extend(request, params));
                    //
                    //     { status:   "ok",
                    //         data: [ {                  id:  13997833014,
                    //                                symbol: "ethbtc",
                    //                          'account-id':  3398321,
                    //                                amount: "0.045000000000000000",
                    //                                 price: "0.034014000000000000",
                    //                          'created-at':  1545836976871,
                    //                                  type: "sell-limit",
                    //                        'field-amount': "0.045000000000000000",
                    //                   'field-cash-amount': "0.001530630000000000",
                    //                          'field-fees': "0.000003061260000000",
                    //                         'finished-at':  1545837948214,
                    //                                source: "spot-api",
                    //                                 state: "filled",
                    //                         'canceled-at':  0                      }  ] }
                    //
                    return this.parseOrders(response['data'], market, since, limit);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetOrderOrdersId(this.extend(request, params));
                    const order = this.safeValue(response, 'data');
                    return this.parseOrder(order);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByStates('pre-submitted,submitted,partial-filled,filled,partial-canceled,canceled', symbol, since, limit, params);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const method = this.safeString(this.options, 'fetchOpenOrdersMethod', 'fetch_open_orders_v1');
                    return await this[method](symbol, since, limit, params);
                }
                async fetchOpenOrdersV1(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrdersV1() requires a symbol argument');
                    return await this.fetchOrdersByStates('pre-submitted,submitted,partial-filled', symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByStates('filled,partial-canceled,canceled', symbol, since, limit, params);
                }
                async fetchOpenOrdersV2(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    let accountId = this.safeString(params, 'account-id');
                    if (accountId === undefined) {
                        // pick the first account
                        await this.loadAccounts();
                        for(let i = 0; i < this.accounts.length; i++){
                            const account = this.accounts[i];
                            if (account['type'] === 'spot') {
                                accountId = this.safeString(account, 'id');
                                if (accountId !== undefined) break;
                            }
                        }
                    }
                    request['account-id'] = accountId;
                    if (limit !== undefined) request['size'] = limit;
                    const omitted = this.omit(params, 'account-id');
                    const response = await this.privateGetOrderOpenOrders(this.extend(request, omitted));
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "symbol":"ethusdt",
                    //                 "source":"api",
                    //                 "amount":"0.010000000000000000",
                    //                 "account-id":1528640,
                    //                 "created-at":1561597491963,
                    //                 "price":"400.000000000000000000",
                    //                 "filled-amount":"0.0",
                    //                 "filled-cash-amount":"0.0",
                    //                 "filled-fees":"0.0",
                    //                 "id":38477101630,
                    //                 "state":"submitted",
                    //                 "type":"sell-limit"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'partial-filled': 'open',
                        'partial-canceled': 'canceled',
                        'filled': 'closed',
                        'canceled': 'canceled',
                        'submitted': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {                  id:  13997833014,
                    //                    symbol: "ethbtc",
                    //              'account-id':  3398321,
                    //                    amount: "0.045000000000000000",
                    //                     price: "0.034014000000000000",
                    //              'created-at':  1545836976871,
                    //                      type: "sell-limit",
                    //            'field-amount': "0.045000000000000000", // they have fixed it for filled-amount
                    //       'field-cash-amount': "0.001530630000000000", // they have fixed it for filled-cash-amount
                    //              'field-fees': "0.000003061260000000", // they have fixed it for filled-fees
                    //             'finished-at':  1545837948214,
                    //                    source: "spot-api",
                    //                     state: "filled",
                    //             'canceled-at':  0                      }
                    //
                    //     {                  id:  20395337822,
                    //                    symbol: "ethbtc",
                    //              'account-id':  5685075,
                    //                    amount: "0.001000000000000000",
                    //                     price: "0.0",
                    //              'created-at':  1545831584023,
                    //                      type: "buy-market",
                    //            'field-amount': "0.029100000000000000", // they have fixed it for filled-amount
                    //       'field-cash-amount': "0.000999788700000000", // they have fixed it for filled-cash-amount
                    //              'field-fees': "0.000058200000000000", // they have fixed it for filled-fees
                    //             'finished-at':  1545831584181,
                    //                    source: "spot-api",
                    //                     state: "filled",
                    //             'canceled-at':  0                      }
                    //
                    const id = this.safeString(order, 'id');
                    let side = undefined;
                    let type = undefined;
                    const status = this.parseOrderStatus(this.safeString(order, 'state'));
                    const orderType = this.safeString(order, 'type');
                    if (orderType !== undefined) {
                        const parts = orderType.split('-');
                        side = this.safeString(parts, 0);
                        type = this.safeString(parts, 1);
                    }
                    const marketId = this.safeString(order, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const timestamp = this.safeInteger(order, 'created-at');
                    const clientOrderId = this.safeString(order, 'client-order-id');
                    const filledString = this.safeString2(order, 'filled-amount', 'field-amount'); // typo in their API, filled amount
                    const priceString = this.safeString(order, 'price');
                    const costString = this.safeString2(order, 'filled-cash-amount', 'field-cash-amount'); // same typo
                    let amountString = this.safeString(order, 'amount');
                    if (orderType === 'buy-market') amountString = undefined;
                    const feeCostString = this.safeString2(order, 'filled-fees', 'field-fees'); // typo in their API, filled fees
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrency = side === 'sell' ? market['quote'] : market['base'];
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrency
                        };
                    }
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': priceString,
                        'stopPrice': undefined,
                        'average': undefined,
                        'cost': costString,
                        'amount': amountString,
                        'filled': filledString,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const market = this.market(symbol);
                    const request = {
                        'account-id': this.accounts[0]['id'],
                        'symbol': market['id'],
                        'type': side + '-' + type
                    };
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client-order-id'); // must be 64 chars max and unique within 24 hours
                    if (clientOrderId === undefined) {
                        const broker = this.safeValue(this.options, 'broker', {});
                        const brokerId = this.safeString(broker, 'id');
                        request['client-order-id'] = brokerId + this.uuid();
                    } else request['client-order-id'] = clientOrderId;
                    params = this.omit(params, [
                        'clientOrderId',
                        'client-order-id'
                    ]);
                    if (type === 'market' && side === 'buy') {
                        if (this.options['createMarketBuyOrderRequiresPrice']) {
                            if (price === undefined) throw new InvalidOrder(this.id + " market buy order requires price argument to calculate cost (total amount of quote currency to spend for buying, amount * price). To switch off this warning exception and specify cost in the amount argument, set .options['createMarketBuyOrderRequiresPrice'] = false. Make sure you know what you're doing.");
                            else // despite that cost = amount * price is in quote currency and should have quote precision
                            // the exchange API requires the cost supplied in 'amount' to be of base precision
                            // more about it here:
                            // https://github.com/ccxt/ccxt/pull/4395
                            // https://github.com/ccxt/ccxt/issues/7611
                            // we use amountToPrecision here because the exchange requires cost in base precision
                            request['amount'] = this.costToPrecision(symbol, parseFloat(amount) * parseFloat(price));
                        } else request['amount'] = this.costToPrecision(symbol, amount);
                    } else request['amount'] = this.amountToPrecision(symbol, amount);
                    if (type === 'limit' || type === 'ioc' || type === 'limit-maker' || type === 'stop-limit' || type === 'stop-limit-fok') request['price'] = this.priceToPrecision(symbol, price);
                    const method = this.options['createOrderMethod'];
                    const response = await this[method](this.extend(request, params));
                    const timestamp = this.milliseconds();
                    const id = this.safeString(response, 'data');
                    return {
                        'info': response,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': undefined,
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'filled': undefined,
                        'remaining': undefined,
                        'cost': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'clientOrderId': undefined,
                        'average': undefined
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    const response = await this.privatePostOrderOrdersIdSubmitcancel({
                        'id': id
                    });
                    //
                    //     {
                    //         'status': 'ok',
                    //         'data': '10138899000',
                    //     }
                    //
                    return this.extend(this.parseOrder(response), {
                        'id': id,
                        'status': 'canceled'
                    });
                }
                async cancelOrders(ids, symbol, params = {}) {
                    await this.loadMarkets();
                    const clientOrderIds = this.safeValue2(params, 'clientOrderIds', 'client-order-ids');
                    params = this.omit(params, [
                        'clientOrderIds',
                        'client-order-ids'
                    ]);
                    const request = {};
                    if (clientOrderIds === undefined) request['order-ids'] = ids;
                    else request['client-order-ids'] = clientOrderIds;
                    const response = await this.privatePostOrderOrdersBatchcancel(this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": {
                    //             "success": [
                    //                 "5983466"
                    //             ],
                    //             "failed": [
                    //                 {
                    //                     "err-msg": "Incorrect order state",
                    //                     "order-state": 7,
                    //                     "order-id": "",
                    //                     "err-code": "order-orderstate-error",
                    //                     "client-order-id": "first"
                    //                 },
                    //                 {
                    //                     "err-msg": "Incorrect order state",
                    //                     "order-state": 7,
                    //                     "order-id": "",
                    //                     "err-code": "order-orderstate-error",
                    //                     "client-order-id": "second"
                    //                 },
                    //                 {
                    //                     "err-msg": "The record is not found.",
                    //                     "order-id": "",
                    //                     "err-code": "base-not-found",
                    //                     "client-order-id": "third"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    return response;
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const response = await this.privatePostOrderOrdersBatchCancelOpenOrders(this.extend(request, params));
                    //
                    //     {
                    //         code: 200,
                    //         data: {
                    //             "success-count": 2,
                    //             "failed-count": 0,
                    //             "next-id": 5454600
                    //         }
                    //     }
                    //
                    return response;
                }
                currencyToPrecision(code, fee) {
                    return this.decimalToPrecision(fee, 0, this.currencies[code]['precision']);
                }
                safeNetwork(networkId) {
                    const lastCharacterIndex = networkId.length - 1;
                    const lastCharacter = networkId[lastCharacterIndex];
                    if (lastCharacter === '1') networkId = networkId.slice(0, lastCharacterIndex);
                    const networksById = {};
                    return this.safeString(networksById, networkId, networkId);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         currency: "usdt",
                    //         address: "0xf7292eb9ba7bc50358e27f0e025a4d225a64127b",
                    //         addressTag: "",
                    //         chain: "usdterc20", // trc20usdt, hrc20usdt, usdt, algousdt
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'address');
                    let tag = this.safeString(depositAddress, 'addressTag');
                    if (tag === '') tag = undefined;
                    const currencyId = this.safeString(depositAddress, 'currency');
                    currency = this.safeCurrency(currencyId, currency);
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const networkId = this.safeString(depositAddress, 'chain');
                    const networks = this.safeValue(currency, 'networks', {});
                    const networksById = this.indexBy(networks, 'id');
                    const networkValue = this.safeValue(networksById, networkId, networkId);
                    const network = this.safeString(networkValue, 'network');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': network,
                        'info': depositAddress
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    if (limit === undefined || limit > 100) limit = 100;
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const request = {
                        'type': 'deposit',
                        'from': 0
                    };
                    if (currency !== undefined) request['currency'] = currency['id'];
                    if (limit !== undefined) request['size'] = limit; // max 100
                    const response = await this.privateGetQueryDepositWithdraw(this.extend(request, params));
                    // return response
                    return this.parseTransactions(response['data'], currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    if (limit === undefined || limit > 100) limit = 100;
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const request = {
                        'type': 'withdraw',
                        'from': 0
                    };
                    if (currency !== undefined) request['currency'] = currency['id'];
                    if (limit !== undefined) request['size'] = limit; // max 100
                    const response = await this.privateGetQueryDepositWithdraw(this.extend(request, params));
                    // return response
                    return this.parseTransactions(response['data'], currency, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         'id': 8211029,
                    //         'type': 'deposit',
                    //         'currency': 'eth',
                    //         'chain': 'eth',
                    //         'tx-hash': 'bd315....',
                    //         'amount': 0.81162421,
                    //         'address': '4b8b....',
                    //         'address-tag': '',
                    //         'fee': 0,
                    //         'state': 'safe',
                    //         'created-at': 1542180380965,
                    //         'updated-at': 1542180788077
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         'id': 6908275,
                    //         'type': 'withdraw',
                    //         'currency': 'btc',
                    //         'chain': 'btc',
                    //         'tx-hash': 'c1a1a....',
                    //         'amount': 0.80257005,
                    //         'address': '1QR....',
                    //         'address-tag': '',
                    //         'fee': 0.0005,
                    //         'state': 'confirmed',
                    //         'created-at': 1552107295685,
                    //         'updated-at': 1552108032859
                    //     }
                    //
                    const timestamp = this.safeInteger(transaction, 'created-at');
                    const updated = this.safeInteger(transaction, 'updated-at');
                    const code = this.safeCurrencyCode(this.safeString(transaction, 'currency'));
                    let type = this.safeString(transaction, 'type');
                    if (type === 'withdraw') type = 'withdrawal';
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    const tag = this.safeString(transaction, 'address-tag');
                    let feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost !== undefined) feeCost = Math.abs(feeCost);
                    const address = this.safeString(transaction, 'address');
                    const network = this.safeStringUpper(transaction, 'chain');
                    return {
                        'info': transaction,
                        'id': this.safeString2(transaction, 'id', 'data'),
                        'txid': this.safeString(transaction, 'tx-hash'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': this.safeNumber(transaction, 'amount'),
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': {
                            'currency': code,
                            'cost': feeCost,
                            'rate': undefined
                        }
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        // deposit statuses
                        'unknown': 'failed',
                        'confirming': 'pending',
                        'confirmed': 'ok',
                        'safe': 'ok',
                        'orphan': 'failed',
                        // withdrawal statuses
                        'submitted': 'pending',
                        'canceled': 'canceled',
                        'reexamine': 'pending',
                        'reject': 'failed',
                        'pass': 'pending',
                        'wallet-reject': 'failed',
                        // 'confirmed': 'ok', // present in deposit statuses
                        'confirm-error': 'failed',
                        'repealed': 'failed',
                        'wallet-transfer': 'pending',
                        'pre-transfer': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    this.checkAddress(address);
                    const currency = this.currency(code);
                    const request = {
                        'address': address,
                        'amount': amount,
                        'currency': currency['id'].toLowerCase()
                    };
                    if (tag !== undefined) request['addr-tag'] = tag; // only for XRP?
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeStringLower(networks, network, network); // handle ETH>ERC20 alias
                    if (network !== undefined) {
                        // possible chains - usdterc20, trc20usdt, hrc20usdt, usdt, algousdt
                        if (network === 'erc20') request['chain'] = currency['id'] + network;
                        else request['chain'] = network + currency['id'];
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privatePostDwWithdrawApiCreate(this.extend(request, params));
                    return this.parseTransaction(response, currency);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = '/';
                    if (api === 'market') url += api;
                    else if (api === 'public' || api === 'private') url += this.version;
                    else if (api === 'v2Public' || api === 'v2Private') url += 'v2';
                    url += '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'private' || api === 'v2Private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.ymdhms(this.milliseconds(), 'T');
                        let request = {
                            'SignatureMethod': 'HmacSHA256',
                            'SignatureVersion': '2',
                            'AccessKeyId': this.apiKey,
                            'Timestamp': timestamp
                        };
                        if (method !== 'POST') request = this.extend(request, query);
                        request = this.keysort(request);
                        let auth = this.urlencode(request);
                        // unfortunately, PHP demands double quotes for the escaped newline symbol
                        // eslint-disable-next-line quotes
                        const payload = [
                            method,
                            this.hostname,
                            url,
                            auth
                        ].join("\n");
                        const signature = this.hmac(this.encode(payload), this.encode(this.secret), 'sha256', 'base64');
                        auth += '&' + this.urlencode({
                            'Signature': signature
                        });
                        url += '?' + auth;
                        if (method === 'POST') {
                            body = this.json(query);
                            headers = {
                                'Content-Type': 'application/json'
                            };
                        } else headers = {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                    } else if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    url = this.implodeParams(this.urls['api'][api], {
                        'hostname': this.hostname
                    }) + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                calculateRateLimiterCost(api, method, path, params, config = {}, context = {}) {
                    return this.safeInteger(config, 'cost', 1);
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if ('status' in response) {
                        //
                        //     {"status":"error","err-code":"order-limitorder-amount-min-error","err-msg":"limit order amount error, min: `0.001`","data":null}
                        //
                        const status = this.safeString(response, 'status');
                        if (status === 'error') {
                            const code = this.safeString(response, 'err-code');
                            const feedback = this.id + ' ' + body;
                            this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                            this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                            const message = this.safeString(response, 'err-msg');
                            this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    61: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, NullResponse: NullResponse, InvalidOrder: InvalidOrder, NotSupported: NotSupported, InsufficientFunds: InsufficientFunds, InvalidNonce: InvalidNonce, OrderNotFound: OrderNotFound, RateLimitExceeded: RateLimitExceeded, DDoSProtection: DDoSProtection, BadSymbol: BadSymbol } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class cex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'cex',
                        'name': 'CEX.IO',
                        'countries': [
                            'GB',
                            'EU',
                            'CY',
                            'RU'
                        ],
                        'rateLimit': 1500,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDeposit': false,
                            'fetchDepositAddress': true,
                            'fetchDeposits': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': false,
                            'transfer': false,
                            'withdraw': false
                        },
                        'timeframes': {
                            '1m': '1m',
                            '1h': '1h',
                            '1d': '1d'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766442-8ddc33b0-5ed8-11e7-8b98-f786aef0f3c9.jpg',
                            'api': 'https://cex.io/api',
                            'www': 'https://cex.io',
                            'doc': 'https://cex.io/cex-api',
                            'fees': [
                                'https://cex.io/fee-schedule',
                                'https://cex.io/limits-commissions'
                            ],
                            'referral': 'https://cex.io/r/0/up105393824/0/'
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'uid': true
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'currency_profile',
                                    'currency_limits/',
                                    'last_price/{pair}/',
                                    'last_prices/{currencies}/',
                                    'ohlcv/hd/{yyyymmdd}/{pair}',
                                    'order_book/{pair}/',
                                    'ticker/{pair}/',
                                    'tickers/{currencies}/',
                                    'trade_history/{pair}/'
                                ],
                                'post': [
                                    'convert/{pair}',
                                    'price_stats/{pair}'
                                ]
                            },
                            'private': {
                                'post': [
                                    'active_orders_status/',
                                    'archived_orders/{pair}/',
                                    'balance/',
                                    'cancel_order/',
                                    'cancel_orders/{pair}/',
                                    'cancel_replace_order/{pair}/',
                                    'close_position/{pair}/',
                                    'get_address/',
                                    'get_myfee/',
                                    'get_order/',
                                    'get_order_tx/',
                                    'open_orders/{pair}/',
                                    'open_orders/',
                                    'open_position/{pair}/',
                                    'open_positions/{pair}/',
                                    'place_order/{pair}/',
                                    'raw_tx_history'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.0016'),
                                'taker': this.parseNumber('0.0025')
                            },
                            'funding': {
                                'withdraw': {},
                                'deposit': {
                                    // 'USD': amount => amount * 0.035 + 0.25,
                                    // 'EUR': amount => amount * 0.035 + 0.24,
                                    // 'RUB': amount => amount * 0.05 + 15.57,
                                    // 'GBP': amount => amount * 0.035 + 0.2,
                                    'BTC': 0.0,
                                    'ETH': 0.0,
                                    'BCH': 0.0,
                                    'DASH': 0.0,
                                    'BTG': 0.0,
                                    'ZEC': 0.0,
                                    'XRP': 0.0,
                                    'XLM': 0.0
                                }
                            }
                        },
                        'exceptions': {
                            'exact': {},
                            'broad': {
                                'Insufficient funds': InsufficientFunds,
                                'Nonce must be incremented': InvalidNonce,
                                'Invalid Order': InvalidOrder,
                                'Order not found': OrderNotFound,
                                'limit exceeded': RateLimitExceeded,
                                'Invalid API key': AuthenticationError,
                                'There was an error while placing your order': InvalidOrder,
                                'Sorry, too many clients already': DDoSProtection,
                                'Invalid Symbols Pair': BadSymbol
                            }
                        },
                        'options': {
                            'fetchOHLCVWarning': true,
                            'createMarketBuyOrderRequiresPrice': true,
                            'order': {
                                'status': {
                                    'c': 'canceled',
                                    'd': 'closed',
                                    'cd': 'canceled',
                                    'a': 'open'
                                }
                            }
                        }
                    });
                }
                async fetchCurrenciesFromCache(params = {}) {
                    // this method is now redundant
                    // currencies are now fetched before markets
                    const options = this.safeValue(this.options, 'fetchCurrencies', {});
                    const timestamp = this.safeInteger(options, 'timestamp');
                    const expires = this.safeInteger(options, 'expires', 1000);
                    const now = this.milliseconds();
                    if (timestamp === undefined || now - timestamp > expires) {
                        const response = await this.publicGetCurrencyProfile(params);
                        this.options['fetchCurrencies'] = this.extend(options, {
                            'response': response,
                            'timestamp': now
                        });
                    }
                    return this.safeValue(this.options['fetchCurrencies'], 'response');
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.fetchCurrenciesFromCache(params);
                    this.options['currencies'] = {
                        'timestamp': this.milliseconds(),
                        'response': response
                    };
                    //
                    //     {
                    //         "e":"currency_profile",
                    //         "ok":"ok",
                    //         "data":{
                    //             "symbols":[
                    //                 {
                    //                     "code":"GHS",
                    //                     "contract":true,
                    //                     "commodity":true,
                    //                     "fiat":false,
                    //                     "description":"CEX.IO doesn't provide cloud mining services anymore.",
                    //                     "precision":8,
                    //                     "scale":0,
                    //                     "minimumCurrencyAmount":"0.00000001",
                    //                     "minimalWithdrawalAmount":-1
                    //                 },
                    //                 {
                    //                     "code":"BTC",
                    //                     "contract":false,
                    //                     "commodity":false,
                    //                     "fiat":false,
                    //                     "description":"",
                    //                     "precision":8,
                    //                     "scale":0,
                    //                     "minimumCurrencyAmount":"0.00000001",
                    //                     "minimalWithdrawalAmount":0.002
                    //                 },
                    //                 {
                    //                     "code":"ETH",
                    //                     "contract":false,
                    //                     "commodity":false,
                    //                     "fiat":false,
                    //                     "description":"",
                    //                     "precision":8,
                    //                     "scale":2,
                    //                     "minimumCurrencyAmount":"0.00000100",
                    //                     "minimalWithdrawalAmount":0.01
                    //                 }
                    //             ],
                    //             "pairs":[
                    //                 {
                    //                     "symbol1":"BTC",
                    //                     "symbol2":"USD",
                    //                     "pricePrecision":1,
                    //                     "priceScale":"/1000000",
                    //                     "minLotSize":0.002,
                    //                     "minLotSizeS2":20
                    //                 },
                    //                 {
                    //                     "symbol1":"ETH",
                    //                     "symbol2":"USD",
                    //                     "pricePrecision":2,
                    //                     "priceScale":"/10000",
                    //                     "minLotSize":0.1,
                    //                     "minLotSizeS2":20
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const currencies = this.safeValue(data, 'symbols', []);
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'code');
                        const code = this.safeCurrencyCode(id);
                        const precision = this.safeInteger(currency, 'precision');
                        const active = true;
                        result[code] = {
                            'id': id,
                            'code': code,
                            'name': id,
                            'active': active,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'precision': precision,
                            'fee': undefined,
                            'limits': {
                                'amount': {
                                    'min': this.safeNumber(currency, 'minimumCurrencyAmount'),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'minimalWithdrawalAmount'),
                                    'max': undefined
                                }
                            },
                            'info': currency
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const currenciesResponse = await this.fetchCurrenciesFromCache(params);
                    const currenciesData = this.safeValue(currenciesResponse, 'data', {});
                    const currencies = this.safeValue(currenciesData, 'symbols', []);
                    const currenciesById = this.indexBy(currencies, 'code');
                    const pairs = this.safeValue(currenciesData, 'pairs', []);
                    const response = await this.publicGetCurrencyLimits(params);
                    //
                    //     {
                    //         "e":"currency_limits",
                    //         "ok":"ok",
                    //         "data": {
                    //             "pairs":[
                    //                 {
                    //                     "symbol1":"BTC",
                    //                     "symbol2":"USD",
                    //                     "minLotSize":0.002,
                    //                     "minLotSizeS2":20,
                    //                     "maxLotSize":30,
                    //                     "minPrice":"1500",
                    //                     "maxPrice":"35000"
                    //                 },
                    //                 {
                    //                     "symbol1":"BCH",
                    //                     "symbol2":"EUR",
                    //                     "minLotSize":0.1,
                    //                     "minLotSizeS2":20,
                    //                     "maxLotSize":null,
                    //                     "minPrice":"25",
                    //                     "maxPrice":"8192"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const result = [];
                    const markets = this.safeValue(response['data'], 'pairs');
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const baseId = this.safeString(market, 'symbol1');
                        const quoteId = this.safeString(market, 'symbol2');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const baseCurrency = this.safeValue(currenciesById, baseId, {});
                        const quoteCurrency = this.safeValue(currenciesById, quoteId, {});
                        let pricePrecision = this.safeInteger(quoteCurrency, 'precision', 8);
                        for(let j = 0; j < pairs.length; j++){
                            const pair = pairs[j];
                            if (pair['symbol1'] === baseId && pair['symbol2'] === quoteId) // we might need to account for `priceScale` here
                            pricePrecision = this.safeInteger(pair, 'pricePrecision', pricePrecision);
                        }
                        const baseCcyPrecision = this.safeString(baseCurrency, 'precision', '8');
                        const baseCcyScale = this.safeString(baseCurrency, 'scale', '0');
                        result.push({
                            'id': baseId + '/' + quoteId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': parseInt(Precise.stringSub(baseCcyPrecision, baseCcyScale)),
                                'price': pricePrecision
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minLotSize'),
                                    'max': this.safeNumber(market, 'maxLotSize')
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'minPrice'),
                                    'max': this.safeNumber(market, 'maxPrice')
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minLotSizeS2'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const ommited = [
                        'username',
                        'timestamp'
                    ];
                    const balances = this.omit(response, ommited);
                    const currencyIds = Object.keys(balances);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const balance = this.safeValue(balances, currencyId, {});
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        // https://github.com/ccxt/ccxt/issues/5484
                        account['used'] = this.safeString(balance, 'orders', '0');
                        const code = this.safeCurrencyCode(currencyId);
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostBalance(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'pair': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['depth'] = limit;
                    const response = await this.publicGetOrderBookPair(this.extend(request, params));
                    const timestamp = this.safeTimestamp(response, 'timestamp');
                    return this.parseOrderBook(response, symbol, timestamp);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1591403940,
                    //         0.024972,
                    //         0.024972,
                    //         0.024969,
                    //         0.024969,
                    //         0.49999900
                    //     ]
                    //
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (since === undefined) since = this.milliseconds() - 86400000; // yesterday
                    else {
                        if (this.options['fetchOHLCVWarning']) throw new ExchangeError1(this.id + " fetchOHLCV warning: CEX can return historical candles for a certain date only, this might produce an empty or null reply. Set exchange.options['fetchOHLCVWarning'] = false or add ({ 'options': { 'fetchOHLCVWarning': false }}) to constructor params to suppress this warning message.");
                    }
                    const request = {
                        'pair': market['id'],
                        'yyyymmdd': this.yyyymmdd(since, '')
                    };
                    try {
                        const response = await this.publicGetOhlcvHdYyyymmddPair(this.extend(request, params));
                        //
                        //     {
                        //         "time":20200606,
                        //         "data1m":"[[1591403940,0.024972,0.024972,0.024969,0.024969,0.49999900]]",
                        //     }
                        //
                        const key = 'data' + this.timeframes[timeframe];
                        const data = this.safeString(response, key);
                        const ohlcvs = JSON.parse(data);
                        return this.parseOHLCVs(ohlcvs, market, timeframe, since, limit);
                    } catch (e) {
                        if (e instanceof NullResponse) return [];
                    }
                }
                parseTicker(ticker, market) {
                    const timestamp = this.safeTimestamp(ticker, 'timestamp');
                    const volume = this.safeString(ticker, 'volume');
                    const high = this.safeString(ticker, 'high');
                    const low = this.safeString(ticker, 'low');
                    const bid = this.safeString(ticker, 'bid');
                    const ask = this.safeString(ticker, 'ask');
                    const last = this.safeString(ticker, 'last');
                    const symbol = this.safeSymbol(undefined, market);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': high,
                        'low': low,
                        'bid': bid,
                        'bidVolume': undefined,
                        'ask': ask,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': volume,
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const currencies = Object.keys(this.currencies);
                    const request = {
                        'currencies': currencies.join('/')
                    };
                    const response = await this.publicGetTickersCurrencies(this.extend(request, params));
                    const tickers = this.safeValue(response, 'data', []);
                    const result = {};
                    for(let t = 0; t < tickers.length; t++){
                        const ticker = tickers[t];
                        const marketId = this.safeString(ticker, 'pair');
                        const market = this.safeMarket(marketId, undefined, ':');
                        const symbol = market['symbol'];
                        result[symbol] = this.parseTicker(ticker, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const ticker = await this.publicGetTickerPair(this.extend(request, params));
                    return this.parseTicker(ticker, market);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "type": "sell",
                    //          "date": "1638401878",
                    //          "amount": "0.401000",
                    //          "price": "249",
                    //          "tid": "11922"
                    //      }
                    //
                    const timestamp = this.safeTimestamp(trade, 'date');
                    const id = this.safeString(trade, 'tid');
                    const type = undefined;
                    const side = this.safeString(trade, 'type');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    market = this.safeMarket(undefined, market);
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': type,
                        'side': side,
                        'order': undefined,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetTradeHistoryPair(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGetMyfee(params);
                    //
                    //      {
                    //          e: 'get_myfee',
                    //          ok: 'ok',
                    //          data: {
                    //            'BTC:USD': { buy: '0.25', sell: '0.25', buyMaker: '0.15', sellMaker: '0.15' },
                    //            'ETH:USD': { buy: '0.25', sell: '0.25', buyMaker: '0.15', sellMaker: '0.15' },
                    //            ..
                    //          }
                    //      }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        const fee = this.safeValue(data, market['id'], {});
                        const makerString = this.safeString(fee, 'buyMaker');
                        const takerString = this.safeString(fee, 'buy');
                        const maker = this.parseNumber(Precise.stringDiv(makerString, '100'));
                        const taker = this.parseNumber(Precise.stringDiv(takerString, '100'));
                        result[symbol] = {
                            'info': fee,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true
                        };
                    }
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    // for market buy it requires the amount of quote currency to spend
                    if (type === 'market' && side === 'buy') {
                        if (this.options['createMarketBuyOrderRequiresPrice']) {
                            if (price === undefined) throw new InvalidOrder(this.id + " createOrder() requires the price argument with market buy orders to calculate total order cost (amount to spend), where cost = amount * price. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount, or, alternatively, add .options['createMarketBuyOrderRequiresPrice'] = false to supply the cost in the amount argument (the exchange-specific behaviour)");
                            else amount = amount * price;
                        }
                    }
                    await this.loadMarkets();
                    const request = {
                        'pair': this.marketId(symbol),
                        'type': side,
                        'amount': amount
                    };
                    if (type === 'limit') request['price'] = price;
                    else request['order_type'] = type;
                    const response = await this.privatePostPlaceOrderPair(this.extend(request, params));
                    //
                    //     {
                    //         "id": "12978363524",
                    //         "time": 1586610022259,
                    //         "type": "buy",
                    //         "price": "0.033934",
                    //         "amount": "0.10722802",
                    //         "pending": "0.10722802",
                    //         "complete": false
                    //     }
                    //
                    const placedAmount = this.safeNumber(response, 'amount');
                    const remaining = this.safeNumber(response, 'pending');
                    const timestamp = this.safeValue(response, 'time');
                    const complete = this.safeValue(response, 'complete');
                    const status = complete ? 'closed' : 'open';
                    let filled = undefined;
                    if (placedAmount !== undefined && remaining !== undefined) filled = Math.max(placedAmount - remaining, 0);
                    return {
                        'id': this.safeString(response, 'id'),
                        'info': response,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'type': type,
                        'side': this.safeString(response, 'type'),
                        'symbol': symbol,
                        'status': status,
                        'price': this.safeNumber(response, 'price'),
                        'amount': placedAmount,
                        'cost': undefined,
                        'average': undefined,
                        'remaining': remaining,
                        'filled': filled,
                        'fee': undefined,
                        'trades': undefined
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    return await this.privatePostCancelOrder(this.extend(request, params));
                }
                parseOrder(order, market) {
                    // Depending on the call, 'time' can be a unix int, unix string or ISO string
                    // Yes, really
                    let timestamp = this.safeValue(order, 'time');
                    if (typeof timestamp === 'string' && timestamp.indexOf('T') >= 0) // ISO8601 string
                    timestamp = this.parse8601(timestamp);
                    else // either integer or string integer
                    timestamp = parseInt(timestamp);
                    let symbol = undefined;
                    if (market === undefined) {
                        const baseId = this.safeString(order, 'symbol1');
                        const quoteId = this.safeString(order, 'symbol2');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        symbol = base + '/' + quote;
                        if (symbol in this.markets) market = this.market(symbol);
                    }
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const price = this.safeNumber(order, 'price');
                    let amount = this.safeNumber(order, 'amount');
                    // sell orders can have a negative amount
                    // https://github.com/ccxt/ccxt/issues/5338
                    if (amount !== undefined) amount = Math.abs(amount);
                    const remaining = this.safeNumber2(order, 'pending', 'remains');
                    const filled = amount - remaining;
                    let fee = undefined;
                    let cost = undefined;
                    if (market !== undefined) {
                        symbol = market['symbol'];
                        const taCost = this.safeNumber(order, 'ta:' + market['quote']);
                        const ttaCost = this.safeNumber(order, 'tta:' + market['quote']);
                        cost = this.sum(taCost, ttaCost);
                        const baseFee = 'fa:' + market['base'];
                        const baseTakerFee = 'tfa:' + market['base'];
                        const quoteFee = 'fa:' + market['quote'];
                        const quoteTakerFee = 'tfa:' + market['quote'];
                        let feeRate = this.safeNumber(order, 'tradingFeeMaker');
                        if (!feeRate) feeRate = this.safeNumber(order, 'tradingFeeTaker', feeRate);
                        if (feeRate) feeRate /= 100.0; // convert to mathematically-correct percentage coefficients: 1.0 = 100%
                        if (baseFee in order || baseTakerFee in order) {
                            const baseFeeCost = this.safeNumber2(order, baseFee, baseTakerFee);
                            fee = {
                                'currency': market['base'],
                                'rate': feeRate,
                                'cost': baseFeeCost
                            };
                        } else if (quoteFee in order || quoteTakerFee in order) {
                            const quoteFeeCost = this.safeNumber2(order, quoteFee, quoteTakerFee);
                            fee = {
                                'currency': market['quote'],
                                'rate': feeRate,
                                'cost': quoteFeeCost
                            };
                        }
                    }
                    if (!cost) cost = price * filled;
                    const side = order['type'];
                    let trades = undefined;
                    const orderId = order['id'];
                    if ('vtx' in order) {
                        trades = [];
                        for(let i = 0; i < order['vtx'].length; i++){
                            const item = order['vtx'][i];
                            const tradeSide = this.safeString(item, 'type');
                            if (tradeSide === 'cancel') continue;
                            const tradePrice = this.safeNumber(item, 'price');
                            if (tradePrice === undefined) continue;
                            // todo: deal with these
                            if (tradeSide === 'costsNothing') continue;
                            // --
                            // if (side !== tradeSide)
                            //     throw new Error (JSON.stringify (order, null, 2));
                            // if (orderId !== item['order'])
                            //     throw new Error (JSON.stringify (order, null, 2));
                            // --
                            // partial buy trade
                            //   {
                            //     "a": "0.01589885",
                            //     "c": "user:up106404164:a:BTC",
                            //     "d": "order:6065499239:a:BTC",
                            //     "cs": "0.36300000",
                            //     "ds": 0,
                            //     "id": "6067991213",
                            //     "buy": "6065499239",
                            //     "pos": null,
                            //     "pair": null,
                            //     "sell": "6067991206",
                            //     "time": "2018-04-22T23:09:11.773Z",
                            //     "type": "buy",
                            //     "user": "up106404164",
                            //     "order": "6065499239",
                            //     "price": 7146.5,
                            //     "amount": "0.01589885",
                            //     "symbol": "BTC",
                            //     "balance": "0.36300000",
                            //     "symbol2": "EUR",
                            //     "fee_amount": "0.19" }
                            // --
                            // trade with zero amount, but non-zero fee
                            //   {
                            //     "a": "0.00000000",
                            //     "c": "user:up106404164:a:EUR",
                            //     "d": "order:5840654423:a:EUR",
                            //     "cs": 559744,
                            //     "ds": 0,
                            //     "id": "5840654429",
                            //     "buy": "5807238573",
                            //     "pos": null,
                            //     "pair": null,
                            //     "sell": "5840654423",
                            //     "time": "2018-03-15T03:20:14.010Z",
                            //     "type": "sell",
                            //     "user": "up106404164",
                            //     "order": "5840654423",
                            //     "price": 730,
                            //     "amount": "0.00000000",
                            //     "symbol": "EUR",
                            //     "balance": "5597.44000000",
                            //     "symbol2": "BCH",
                            //     "fee_amount": "0.01" }
                            // --
                            // trade which should have an amount of exactly 0.002BTC
                            //   {
                            //     "a": "16.70000000",
                            //     "c": "user:up106404164:a:GBP",
                            //     "d": "order:9927386681:a:GBP",
                            //     "cs": "86.90",
                            //     "ds": 0,
                            //     "id": "9927401610",
                            //     "buy": "9927401601",
                            //     "pos": null,
                            //     "pair": null,
                            //     "sell": "9927386681",
                            //     "time": "2019-08-21T15:25:37.777Z",
                            //     "type": "sell",
                            //     "user": "up106404164",
                            //     "order": "9927386681",
                            //     "price": 8365,
                            //     "amount": "16.70000000",
                            //     "office": "UK",
                            //     "symbol": "GBP",
                            //     "balance": "86.90000000",
                            //     "symbol2": "BTC",
                            //     "fee_amount": "0.03"
                            //   }
                            const tradeTimestamp = this.parse8601(this.safeString(item, 'time'));
                            const tradeAmount = this.safeNumber(item, 'amount');
                            const feeCost = this.safeNumber(item, 'fee_amount');
                            let absTradeAmount = tradeAmount < 0 ? -tradeAmount : tradeAmount;
                            let tradeCost = undefined;
                            if (tradeSide === 'sell') {
                                tradeCost = absTradeAmount;
                                absTradeAmount = this.sum(feeCost, tradeCost) / tradePrice;
                            } else tradeCost = absTradeAmount * tradePrice;
                            trades.push({
                                'id': this.safeString(item, 'id'),
                                'timestamp': tradeTimestamp,
                                'datetime': this.iso8601(tradeTimestamp),
                                'order': orderId,
                                'symbol': symbol,
                                'price': tradePrice,
                                'amount': absTradeAmount,
                                'cost': tradeCost,
                                'side': tradeSide,
                                'fee': {
                                    'cost': feeCost,
                                    'currency': market['quote']
                                },
                                'info': item,
                                'type': undefined,
                                'takerOrMaker': undefined
                            });
                        }
                    }
                    return {
                        'id': orderId,
                        'clientOrderId': undefined,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': price === undefined ? 'market' : 'limit',
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'trades': trades,
                        'fee': fee,
                        'info': order,
                        'average': undefined
                    };
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let method = 'privatePostOpenOrders';
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['pair'] = market['id'];
                        method += 'Pair';
                    }
                    const orders = await this[method](this.extend(request, params));
                    for(let i = 0; i < orders.length; i++)orders[i] = this.extend(orders[i], {
                        'status': 'open'
                    });
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const method = 'privatePostArchivedOrdersPair';
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchClosedOrders() requires a symbol argument');
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this[method](this.extend(request, params));
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id.toString()
                    };
                    const response = await this.privatePostGetOrderTx(this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    //
                    //     {
                    //         "id": "5442731603",
                    //         "type": "sell",
                    //         "time": 1516132358071,
                    //         "lastTxTime": 1516132378452,
                    //         "lastTx": "5442734452",
                    //         "pos": null,
                    //         "user": "up106404164",
                    //         "status": "d",
                    //         "symbol1": "ETH",
                    //         "symbol2": "EUR",
                    //         "amount": "0.50000000",
                    //         "kind": "api",
                    //         "price": "923.3386",
                    //         "tfacf": "1",
                    //         "fa:EUR": "0.55",
                    //         "ta:EUR": "369.77",
                    //         "remains": "0.00000000",
                    //         "tfa:EUR": "0.22",
                    //         "tta:EUR": "91.95",
                    //         "a:ETH:cds": "0.50000000",
                    //         "a:EUR:cds": "461.72",
                    //         "f:EUR:cds": "0.77",
                    //         "tradingFeeMaker": "0.15",
                    //         "tradingFeeTaker": "0.23",
                    //         "tradingFeeStrategy": "userVolumeAmount",
                    //         "tradingFeeUserVolumeAmount": "2896912572",
                    //         "orderId": "5442731603",
                    //         "next": false,
                    //         "vtx": [
                    //             {
                    //                 "id": "5442734452",
                    //                 "type": "sell",
                    //                 "time": "2018-01-16T19:52:58.452Z",
                    //                 "user": "up106404164",
                    //                 "c": "user:up106404164:a:EUR",
                    //                 "d": "order:5442731603:a:EUR",
                    //                 "a": "104.53000000",
                    //                 "amount": "104.53000000",
                    //                 "balance": "932.71000000",
                    //                 "symbol": "EUR",
                    //                 "order": "5442731603",
                    //                 "buy": "5442734443",
                    //                 "sell": "5442731603",
                    //                 "pair": null,
                    //                 "pos": null,
                    //                 "office": null,
                    //                 "cs": "932.71",
                    //                 "ds": 0,
                    //                 "price": 923.3386,
                    //                 "symbol2": "ETH",
                    //                 "fee_amount": "0.16"
                    //             },
                    //             {
                    //                 "id": "5442731609",
                    //                 "type": "sell",
                    //                 "time": "2018-01-16T19:52:38.071Z",
                    //                 "user": "up106404164",
                    //                 "c": "user:up106404164:a:EUR",
                    //                 "d": "order:5442731603:a:EUR",
                    //                 "a": "91.73000000",
                    //                 "amount": "91.73000000",
                    //                 "balance": "563.49000000",
                    //                 "symbol": "EUR",
                    //                 "order": "5442731603",
                    //                 "buy": "5442618127",
                    //                 "sell": "5442731603",
                    //                 "pair": null,
                    //                 "pos": null,
                    //                 "office": null,
                    //                 "cs": "563.49",
                    //                 "ds": 0,
                    //                 "price": 924.0092,
                    //                 "symbol2": "ETH",
                    //                 "fee_amount": "0.22"
                    //             },
                    //             {
                    //                 "id": "5442731604",
                    //                 "type": "sell",
                    //                 "time": "2018-01-16T19:52:38.071Z",
                    //                 "user": "up106404164",
                    //                 "c": "order:5442731603:a:ETH",
                    //                 "d": "user:up106404164:a:ETH",
                    //                 "a": "0.50000000",
                    //                 "amount": "-0.50000000",
                    //                 "balance": "15.80995000",
                    //                 "symbol": "ETH",
                    //                 "order": "5442731603",
                    //                 "buy": null,
                    //                 "sell": null,
                    //                 "pair": null,
                    //                 "pos": null,
                    //                 "office": null,
                    //                 "cs": "0.50000000",
                    //                 "ds": "15.80995000"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseOrder(data);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'limit': limit,
                        'pair': market['id'],
                        'dateFrom': since
                    };
                    const response = await this.privatePostArchivedOrdersPair(this.extend(request, params));
                    const results = [];
                    for(let i = 0; i < response.length; i++){
                        // cancelled (unfilled):
                        //    { id: '4005785516',
                        //     type: 'sell',
                        //     time: '2017-07-18T19:08:34.223Z',
                        //     lastTxTime: '2017-07-18T19:08:34.396Z',
                        //     lastTx: '4005785522',
                        //     pos: null,
                        //     status: 'c',
                        //     symbol1: 'ETH',
                        //     symbol2: 'GBP',
                        //     amount: '0.20000000',
                        //     price: '200.5625',
                        //     remains: '0.20000000',
                        //     'a:ETH:cds': '0.20000000',
                        //     tradingFeeMaker: '0',
                        //     tradingFeeTaker: '0.16',
                        //     tradingFeeUserVolumeAmount: '10155061217',
                        //     orderId: '4005785516' }
                        // --
                        // cancelled (partially filled buy):
                        //    { id: '4084911657',
                        //     type: 'buy',
                        //     time: '2017-08-05T03:18:39.596Z',
                        //     lastTxTime: '2019-03-19T17:37:46.404Z',
                        //     lastTx: '8459265833',
                        //     pos: null,
                        //     status: 'cd',
                        //     symbol1: 'BTC',
                        //     symbol2: 'GBP',
                        //     amount: '0.05000000',
                        //     price: '2241.4692',
                        //     tfacf: '1',
                        //     remains: '0.03910535',
                        //     'tfa:GBP': '0.04',
                        //     'tta:GBP': '24.39',
                        //     'a:BTC:cds': '0.01089465',
                        //     'a:GBP:cds': '112.26',
                        //     'f:GBP:cds': '0.04',
                        //     tradingFeeMaker: '0',
                        //     tradingFeeTaker: '0.16',
                        //     tradingFeeUserVolumeAmount: '13336396963',
                        //     orderId: '4084911657' }
                        // --
                        // cancelled (partially filled sell):
                        //    { id: '4426728375',
                        //     type: 'sell',
                        //     time: '2017-09-22T00:24:20.126Z',
                        //     lastTxTime: '2017-09-22T00:24:30.476Z',
                        //     lastTx: '4426729543',
                        //     pos: null,
                        //     status: 'cd',
                        //     symbol1: 'BCH',
                        //     symbol2: 'BTC',
                        //     amount: '0.10000000',
                        //     price: '0.11757182',
                        //     tfacf: '1',
                        //     remains: '0.09935956',
                        //     'tfa:BTC': '0.00000014',
                        //     'tta:BTC': '0.00007537',
                        //     'a:BCH:cds': '0.10000000',
                        //     'a:BTC:cds': '0.00007537',
                        //     'f:BTC:cds': '0.00000014',
                        //     tradingFeeMaker: '0',
                        //     tradingFeeTaker: '0.18',
                        //     tradingFeeUserVolumeAmount: '3466715450',
                        //     orderId: '4426728375' }
                        // --
                        // filled:
                        //    { id: '5342275378',
                        //     type: 'sell',
                        //     time: '2018-01-04T00:28:12.992Z',
                        //     lastTxTime: '2018-01-04T00:28:12.992Z',
                        //     lastTx: '5342275393',
                        //     pos: null,
                        //     status: 'd',
                        //     symbol1: 'BCH',
                        //     symbol2: 'BTC',
                        //     amount: '0.10000000',
                        //     kind: 'api',
                        //     price: '0.17',
                        //     remains: '0.00000000',
                        //     'tfa:BTC': '0.00003902',
                        //     'tta:BTC': '0.01699999',
                        //     'a:BCH:cds': '0.10000000',
                        //     'a:BTC:cds': '0.01699999',
                        //     'f:BTC:cds': '0.00003902',
                        //     tradingFeeMaker: '0.15',
                        //     tradingFeeTaker: '0.23',
                        //     tradingFeeUserVolumeAmount: '1525951128',
                        //     orderId: '5342275378' }
                        // --
                        // market order (buy):
                        //    { "id": "6281946200",
                        //     "pos": null,
                        //     "time": "2018-05-23T11:55:43.467Z",
                        //     "type": "buy",
                        //     "amount": "0.00000000",
                        //     "lastTx": "6281946210",
                        //     "status": "d",
                        //     "amount2": "20.00",
                        //     "orderId": "6281946200",
                        //     "remains": "0.00000000",
                        //     "symbol1": "ETH",
                        //     "symbol2": "EUR",
                        //     "tfa:EUR": "0.05",
                        //     "tta:EUR": "19.94",
                        //     "a:ETH:cds": "0.03764100",
                        //     "a:EUR:cds": "20.00",
                        //     "f:EUR:cds": "0.05",
                        //     "lastTxTime": "2018-05-23T11:55:43.467Z",
                        //     "tradingFeeTaker": "0.25",
                        //     "tradingFeeUserVolumeAmount": "55998097" }
                        // --
                        // market order (sell):
                        //   { "id": "6282200948",
                        //     "pos": null,
                        //     "time": "2018-05-23T12:42:58.315Z",
                        //     "type": "sell",
                        //     "amount": "-0.05000000",
                        //     "lastTx": "6282200958",
                        //     "status": "d",
                        //     "orderId": "6282200948",
                        //     "remains": "0.00000000",
                        //     "symbol1": "ETH",
                        //     "symbol2": "EUR",
                        //     "tfa:EUR": "0.07",
                        //     "tta:EUR": "26.49",
                        //     "a:ETH:cds": "0.05000000",
                        //     "a:EUR:cds": "26.49",
                        //     "f:EUR:cds": "0.07",
                        //     "lastTxTime": "2018-05-23T12:42:58.315Z",
                        //     "tradingFeeTaker": "0.25",
                        //     "tradingFeeUserVolumeAmount": "56294576" }
                        const order = response[i];
                        const status = this.parseOrderStatus(this.safeString(order, 'status'));
                        const baseId = this.safeString(order, 'symbol1');
                        const quoteId = this.safeString(order, 'symbol2');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const symbol = base + '/' + quote;
                        const side = this.safeString(order, 'type');
                        const baseAmount = this.safeNumber(order, 'a:' + baseId + ':cds');
                        const quoteAmount = this.safeNumber(order, 'a:' + quoteId + ':cds');
                        const fee = this.safeNumber(order, 'f:' + quoteId + ':cds');
                        const amount = this.safeNumber(order, 'amount');
                        const price = this.safeNumber(order, 'price');
                        const remaining = this.safeNumber(order, 'remains');
                        const filled = amount - remaining;
                        let orderAmount = undefined;
                        let cost = undefined;
                        let average = undefined;
                        let type = undefined;
                        if (!price) {
                            type = 'market';
                            orderAmount = baseAmount;
                            cost = quoteAmount;
                            average = orderAmount / cost;
                        } else {
                            const ta = this.safeNumber(order, 'ta:' + quoteId, 0);
                            const tta = this.safeNumber(order, 'tta:' + quoteId, 0);
                            const fa = this.safeNumber(order, 'fa:' + quoteId, 0);
                            const tfa = this.safeNumber(order, 'tfa:' + quoteId, 0);
                            if (side === 'sell') cost = this.sum(this.sum(ta, tta), this.sum(fa, tfa));
                            else cost = this.sum(ta, tta) - this.sum(fa, tfa);
                            type = 'limit';
                            orderAmount = amount;
                            average = cost / filled;
                        }
                        const time = this.safeString(order, 'time');
                        const lastTxTime = this.safeString(order, 'lastTxTime');
                        const timestamp = this.parse8601(time);
                        results.push({
                            'id': this.safeString(order, 'id'),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'lastUpdated': this.parse8601(lastTxTime),
                            'status': status,
                            'symbol': symbol,
                            'side': side,
                            'price': price,
                            'amount': orderAmount,
                            'average': average,
                            'type': type,
                            'filled': filled,
                            'cost': cost,
                            'remaining': remaining,
                            'fee': {
                                'cost': fee,
                                'currency': quote
                            },
                            'info': order
                        });
                    }
                    return results;
                }
                parseOrderStatus(status) {
                    return this.safeString(this.options['order']['status'], status, status);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    if (amount === undefined) throw new ArgumentsRequired1(this.id + ' editOrder() requires a amount argument');
                    if (price === undefined) throw new ArgumentsRequired1(this.id + ' editOrder() requires a price argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    // see: https://cex.io/rest-api#/definitions/CancelReplaceOrderRequest
                    const request = {
                        'pair': market['id'],
                        'type': side,
                        'amount': amount,
                        'price': price,
                        'order_id': id
                    };
                    const response = await this.privatePostCancelReplaceOrderPair(this.extend(request, params));
                    return this.parseOrder(response, market);
                }
                async fetchDepositAddress(code, params = {}) {
                    if (code === 'XRP' || code === 'XLM') // https://github.com/ccxt/ccxt/pull/2327#issuecomment-375204856
                    throw new NotSupported(this.id + ' fetchDepositAddress() does not support XRP and XLM addresses yet (awaiting docs from CEX.io)');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privatePostGetAddress(this.extend(request, params));
                    const address = this.safeString(response, 'data');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': undefined,
                        'network': undefined,
                        'info': response
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const auth = nonce + this.uid + this.apiKey;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                        body = this.json(this.extend({
                            'key': this.apiKey,
                            'signature': signature.toUpperCase(),
                            'nonce': nonce
                        }, query));
                        headers = {
                            'Content-Type': 'application/json'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (Array.isArray(response)) return response; // public endpoints may return []-arrays
                    if (body === 'true') return;
                    if (response === undefined) throw new NullResponse(this.id + ' returned ' + this.json(response));
                    if ('e' in response) {
                        if ('ok' in response) {
                            if (response['ok'] === 'ok') return;
                        }
                    }
                    if ('error' in response) {
                        const message = this.safeString(response, 'error');
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    62: [
        function(require1, module, exports) {
            'use strict';
            // ----------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded, InvalidNonce: InvalidNonce } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            // ----------------------------------------------------------------------------
            module.exports = class coinbase extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'coinbase',
                        'name': 'Coinbase',
                        'countries': [
                            'US'
                        ],
                        'rateLimit': 400,
                        'version': 'v2',
                        'userAgent': this.userAgents['chrome'],
                        'headers': {
                            'CB-VERSION': '2018-05-30'
                        },
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': undefined,
                            'createDepositAddress': true,
                            'createOrder': undefined,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': false,
                            'createStopMarketOrder': false,
                            'createStopOrder': false,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchBidsAsks': undefined,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': undefined,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': undefined,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchL2OrderBook': false,
                            'fetchLedger': true,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyBuys': true,
                            'fetchMySells': true,
                            'fetchMyTrades': undefined,
                            'fetchOHLCV': false,
                            'fetchOpenOrders': undefined,
                            'fetchOrder': undefined,
                            'fetchOrderBook': false,
                            'fetchOrders': undefined,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': undefined,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransactions': undefined,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': undefined
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/40811661-b6eceae2-653a-11e8-829e-10bfadb078cf.jpg',
                            'api': 'https://api.coinbase.com',
                            'www': 'https://www.coinbase.com',
                            'doc': 'https://developers.coinbase.com/api/v2',
                            'fees': 'https://support.coinbase.com/customer/portal/articles/2109597-buy-sell-bank-transfer-fees',
                            'referral': 'https://www.coinbase.com/join/58cbe25a355148797479dbd2'
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'currencies',
                                    'time',
                                    'exchange-rates',
                                    'users/{user_id}',
                                    'prices/{symbol}/buy',
                                    'prices/{symbol}/sell',
                                    'prices/{symbol}/spot'
                                ]
                            },
                            'private': {
                                'get': [
                                    'accounts',
                                    'accounts/{account_id}',
                                    'accounts/{account_id}/addresses',
                                    'accounts/{account_id}/addresses/{address_id}',
                                    'accounts/{account_id}/addresses/{address_id}/transactions',
                                    'accounts/{account_id}/transactions',
                                    'accounts/{account_id}/transactions/{transaction_id}',
                                    'accounts/{account_id}/buys',
                                    'accounts/{account_id}/buys/{buy_id}',
                                    'accounts/{account_id}/sells',
                                    'accounts/{account_id}/sells/{sell_id}',
                                    'accounts/{account_id}/deposits',
                                    'accounts/{account_id}/deposits/{deposit_id}',
                                    'accounts/{account_id}/withdrawals',
                                    'accounts/{account_id}/withdrawals/{withdrawal_id}',
                                    'payment-methods',
                                    'payment-methods/{payment_method_id}',
                                    'user',
                                    'user/auth'
                                ],
                                'post': [
                                    'accounts',
                                    'accounts/{account_id}/primary',
                                    'accounts/{account_id}/addresses',
                                    'accounts/{account_id}/transactions',
                                    'accounts/{account_id}/transactions/{transaction_id}/complete',
                                    'accounts/{account_id}/transactions/{transaction_id}/resend',
                                    'accounts/{account_id}/buys',
                                    'accounts/{account_id}/buys/{buy_id}/commit',
                                    'accounts/{account_id}/sells',
                                    'accounts/{account_id}/sells/{sell_id}/commit',
                                    'accounts/{account_id}/deposists',
                                    'accounts/{account_id}/deposists/{deposit_id}/commit',
                                    'accounts/{account_id}/withdrawals',
                                    'accounts/{account_id}/withdrawals/{withdrawal_id}/commit'
                                ],
                                'put': [
                                    'accounts/{account_id}',
                                    'user'
                                ],
                                'delete': [
                                    'accounts/{id}',
                                    'accounts/{account_id}/transactions/{transaction_id}'
                                ]
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'two_factor_required': AuthenticationError,
                                'param_required': ExchangeError1,
                                'validation_error': ExchangeError1,
                                'invalid_request': ExchangeError1,
                                'personal_details_required': AuthenticationError,
                                'identity_verification_required': AuthenticationError,
                                'jumio_verification_required': AuthenticationError,
                                'jumio_face_match_verification_required': AuthenticationError,
                                'unverified_email': AuthenticationError,
                                'authentication_error': AuthenticationError,
                                'invalid_authentication_method': AuthenticationError,
                                'invalid_token': AuthenticationError,
                                'revoked_token': AuthenticationError,
                                'expired_token': AuthenticationError,
                                'invalid_scope': AuthenticationError,
                                'not_found': ExchangeError1,
                                'rate_limit_exceeded': RateLimitExceeded,
                                'internal_server_error': ExchangeError1
                            },
                            'broad': {
                                'request timestamp expired': InvalidNonce
                            }
                        },
                        'commonCurrencies': {
                            'CGLD': 'CELO'
                        },
                        'options': {
                            'fetchCurrencies': {
                                'expires': 5000
                            },
                            'accounts': [
                                'wallet',
                                'fiat'
                            ]
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTime(params);
                    //
                    //     {
                    //         "data": {
                    //             "epoch": 1589295679,
                    //             "iso": "2020-05-12T15:01:19Z"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.safeTimestamp(data, 'epoch');
                }
                async fetchAccounts(params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'limit': 100
                    };
                    const response = await this.privateGetAccounts(this.extend(request, params));
                    //
                    //     {
                    //         "id": "XLM",
                    //         "name": "XLM Wallet",
                    //         "primary": false,
                    //         "type": "wallet",
                    //         "currency": {
                    //             "code": "XLM",
                    //             "name": "Stellar Lumens",
                    //             "color": "#000000",
                    //             "sort_index": 127,
                    //             "exponent": 7,
                    //             "type": "crypto",
                    //             "address_regex": "^G[A-Z2-7]{55}$",
                    //             "asset_id": "13b83335-5ede-595b-821e-5bcdfa80560f",
                    //             "destination_tag_name": "XLM Memo ID",
                    //             "destination_tag_regex": "^[ -~]{1,28}$"
                    //         },
                    //         "balance": {
                    //             "amount": "0.0000000",
                    //             "currency": "XLM"
                    //         },
                    //         "created_at": null,
                    //         "updated_at": null,
                    //         "resource": "account",
                    //         "resource_path": "/v2/accounts/XLM",
                    //         "allow_deposits": true,
                    //         "allow_withdrawals": true
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const account = data[i];
                        const currency = this.safeValue(account, 'currency', {});
                        const currencyId = this.safeString(currency, 'code');
                        const code = this.safeCurrencyCode(currencyId);
                        result.push({
                            'id': this.safeString(account, 'id'),
                            'type': this.safeString(account, 'type'),
                            'code': code,
                            'info': account
                        });
                    }
                    return result;
                }
                async createDepositAddress(code, params = {}) {
                    let accountId = this.safeString(params, 'account_id');
                    params = this.omit(params, 'account_id');
                    if (accountId === undefined) {
                        await this.loadAccounts();
                        for(let i = 0; i < this.accounts.length; i++){
                            const account = this.accounts[i];
                            if (account['code'] === code && account['type'] === 'wallet') {
                                accountId = account['id'];
                                break;
                            }
                        }
                    }
                    if (accountId === undefined) throw new ExchangeError1(this.id + ' createDepositAddress() could not find the account with matching currency code, specify an `account_id` extra param');
                    const request = {
                        'account_id': accountId
                    };
                    const response = await this.privatePostAccountsAccountIdAddresses(this.extend(request, params));
                    //
                    //     {
                    //         "data": {
                    //             "id": "05b1ebbf-9438-5dd4-b297-2ddedc98d0e4",
                    //             "address": "coinbasebase",
                    //             "address_info": {
                    //                 "address": "coinbasebase",
                    //                 "destination_tag": "287594668"
                    //             },
                    //             "name": null,
                    //             "created_at": "2019-07-01T14:39:29Z",
                    //             "updated_at": "2019-07-01T14:39:29Z",
                    //             "network": "eosio",
                    //             "uri_scheme": "eosio",
                    //             "resource": "address",
                    //             "resource_path": "/v2/accounts/14cfc769-e852-52f3-b831-711c104d194c/addresses/05b1ebbf-9438-5dd4-b297-2ddedc98d0e4",
                    //             "warnings": [
                    //                 {
                    //                     "title": "Only send EOS (EOS) to this address",
                    //                     "details": "Sending any other cryptocurrency will result in permanent loss.",
                    //                     "image_url": "https://dynamic-assets.coinbase.com/deaca3d47b10ed4a91a872e9618706eec34081127762d88f2476ac8e99ada4b48525a9565cf2206d18c04053f278f693434af4d4629ca084a9d01b7a286a7e26/asset_icons/1f8489bb280fb0a0fd643c1161312ba49655040e9aaaced5f9ad3eeaf868eadc.png"
                    //                 },
                    //                 {
                    //                     "title": "Both an address and EOS memo are required to receive EOS",
                    //                     "details": "If you send funds without an EOS memo or with an incorrect EOS memo, your funds cannot be credited to your account.",
                    //                     "image_url": "https://www.coinbase.com/assets/receive-warning-2f3269d83547a7748fb39d6e0c1c393aee26669bfea6b9f12718094a1abff155.png"
                    //                 }
                    //             ],
                    //             "warning_title": "Only send EOS (EOS) to this address",
                    //             "warning_details": "Sending any other cryptocurrency will result in permanent loss.",
                    //             "destination_tag": "287594668",
                    //             "deposit_uri": "eosio:coinbasebase?dt=287594668",
                    //             "callback_url": null
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const tag = this.safeString(data, 'destination_tag');
                    const address = this.safeString(data, 'address');
                    return {
                        'currency': code,
                        'tag': tag,
                        'address': address,
                        'info': response
                    };
                }
                async fetchMySells(symbol, since, limit, params = {}) {
                    // they don't have an endpoint for all historical trades
                    const request = await this.prepareAccountRequest(limit, params);
                    await this.loadMarkets();
                    const query = this.omit(params, [
                        'account_id',
                        'accountId'
                    ]);
                    const sells = await this.privateGetAccountsAccountIdSells(this.extend(request, query));
                    return this.parseTrades(sells['data'], undefined, since, limit);
                }
                async fetchMyBuys(symbol, since, limit, params = {}) {
                    // they don't have an endpoint for all historical trades
                    const request = await this.prepareAccountRequest(limit, params);
                    await this.loadMarkets();
                    const query = this.omit(params, [
                        'account_id',
                        'accountId'
                    ]);
                    const buys = await this.privateGetAccountsAccountIdBuys(this.extend(request, query));
                    return this.parseTrades(buys['data'], undefined, since, limit);
                }
                async fetchTransactionsWithMethod(method, code, since, limit, params = {}) {
                    const request = await this.prepareAccountRequestWithCurrencyCode(code, limit, params);
                    await this.loadMarkets();
                    const query = this.omit(params, [
                        'account_id',
                        'accountId'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    return this.parseTransactions(response['data'], undefined, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    // fiat only, for crypto transactions use fetchLedger
                    return await this.fetchTransactionsWithMethod('privateGetAccountsAccountIdWithdrawals', code, since, limit, params);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    // fiat only, for crypto transactions use fetchLedger
                    return await this.fetchTransactionsWithMethod('privateGetAccountsAccountIdDeposits', code, since, limit, params);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'created': 'pending',
                        'completed': 'ok',
                        'canceled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, market) {
                    //
                    // fiat deposit
                    //
                    //     {
                    //         "id": "f34c19f3-b730-5e3d-9f72",
                    //         "status": "completed",
                    //         "payment_method": {
                    //             "id": "a022b31d-f9c7-5043-98f2",
                    //             "resource": "payment_method",
                    //             "resource_path": "/v2/payment-methods/a022b31d-f9c7-5043-98f2"
                    //         },
                    //         "transaction": {
                    //             "id": "04ed4113-3732-5b0c-af86-b1d2146977d0",
                    //             "resource": "transaction",
                    //             "resource_path": "/v2/accounts/91cd2d36-3a91-55b6-a5d4-0124cf105483/transactions/04ed4113-3732-5b0c-af86"
                    //         },
                    //         "user_reference": "2VTYTH",
                    //         "created_at": "2017-02-09T07:01:18Z",
                    //         "updated_at": "2017-02-09T07:01:26Z",
                    //         "resource": "deposit",
                    //         "resource_path": "/v2/accounts/91cd2d36-3a91-55b6-a5d4-0124cf105483/deposits/f34c19f3-b730-5e3d-9f72",
                    //         "committed": true,
                    //         "payout_at": "2017-02-12T07:01:17Z",
                    //         "instant": false,
                    //         "fee": { "amount": "0.00", "currency": "EUR" },
                    //         "amount": { "amount": "114.02", "currency": "EUR" },
                    //         "subtotal": { "amount": "114.02", "currency": "EUR" },
                    //         "hold_until": null,
                    //         "hold_days": 0,
                    //         "hold_business_days": 0,
                    //         "next_step": null
                    //     }
                    //
                    // fiat_withdrawal
                    //
                    //     {
                    //         "id": "cfcc3b4a-eeb6-5e8c-8058",
                    //         "status": "completed",
                    //         "payment_method": {
                    //             "id": "8b94cfa4-f7fd-5a12-a76a",
                    //             "resource": "payment_method",
                    //             "resource_path": "/v2/payment-methods/8b94cfa4-f7fd-5a12-a76a"
                    //         },
                    //         "transaction": {
                    //             "id": "fcc2550b-5104-5f83-a444",
                    //             "resource": "transaction",
                    //             "resource_path": "/v2/accounts/91cd2d36-3a91-55b6-a5d4-0124cf105483/transactions/fcc2550b-5104-5f83-a444"
                    //         },
                    //         "user_reference": "MEUGK",
                    //         "created_at": "2018-07-26T08:55:12Z",
                    //         "updated_at": "2018-07-26T08:58:18Z",
                    //         "resource": "withdrawal",
                    //         "resource_path": "/v2/accounts/91cd2d36-3a91-55b6-a5d4-0124cf105483/withdrawals/cfcc3b4a-eeb6-5e8c-8058",
                    //         "committed": true,
                    //         "payout_at": "2018-07-31T08:55:12Z",
                    //         "instant": false,
                    //         "fee": { "amount": "0.15", "currency": "EUR" },
                    //         "amount": { "amount": "13130.69", "currency": "EUR" },
                    //         "subtotal": { "amount": "13130.84", "currency": "EUR" },
                    //         "idem": "e549dee5-63ed-4e79-8a96",
                    //         "next_step": null
                    //     }
                    //
                    const subtotalObject = this.safeValue(transaction, 'subtotal', {});
                    const feeObject = this.safeValue(transaction, 'fee', {});
                    const id = this.safeString(transaction, 'id');
                    const timestamp = this.parse8601(this.safeValue(transaction, 'created_at'));
                    const updated = this.parse8601(this.safeValue(transaction, 'updated_at'));
                    const type = this.safeString(transaction, 'resource');
                    const amount = this.safeNumber(subtotalObject, 'amount');
                    const currencyId = this.safeString(subtotalObject, 'currency');
                    const currency = this.safeCurrencyCode(currencyId);
                    const feeCost = this.safeNumber(feeObject, 'amount');
                    const feeCurrencyId = this.safeString(feeObject, 'currency');
                    const feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                    const fee = {
                        'cost': feeCost,
                        'currency': feeCurrency
                    };
                    let status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    if (status === undefined) {
                        const committed = this.safeValue(transaction, 'committed');
                        status = committed ? 'ok' : 'pending';
                    }
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': currency,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                parseTrade(trade, market) {
                    //
                    //     {
                    //         "id": "67e0eaec-07d7-54c4-a72c-2e92826897df",
                    //         "status": "completed",
                    //         "payment_method": {
                    //             "id": "83562370-3e5c-51db-87da-752af5ab9559",
                    //             "resource": "payment_method",
                    //             "resource_path": "/v2/payment-methods/83562370-3e5c-51db-87da-752af5ab9559"
                    //         },
                    //         "transaction": {
                    //             "id": "441b9494-b3f0-5b98-b9b0-4d82c21c252a",
                    //             "resource": "transaction",
                    //             "resource_path": "/v2/accounts/2bbf394c-193b-5b2a-9155-3b4732659ede/transactions/441b9494-b3f0-5b98-b9b0-4d82c21c252a"
                    //         },
                    //         "amount": { "amount": "1.00000000", "currency": "BTC" },
                    //         "total": { "amount": "10.25", "currency": "USD" },
                    //         "subtotal": { "amount": "10.10", "currency": "USD" },
                    //         "created_at": "2015-01-31T20:49:02Z",
                    //         "updated_at": "2015-02-11T16:54:02-08:00",
                    //         "resource": "buy",
                    //         "resource_path": "/v2/accounts/2bbf394c-193b-5b2a-9155-3b4732659ede/buys/67e0eaec-07d7-54c4-a72c-2e92826897df",
                    //         "committed": true,
                    //         "instant": false,
                    //         "fee": { "amount": "0.15", "currency": "USD" },
                    //         "payout_at": "2015-02-18T16:54:00-08:00"
                    //     }
                    //
                    let symbol = undefined;
                    const totalObject = this.safeValue(trade, 'total', {});
                    const amountObject = this.safeValue(trade, 'amount', {});
                    const subtotalObject = this.safeValue(trade, 'subtotal', {});
                    const feeObject = this.safeValue(trade, 'fee', {});
                    const id = this.safeString(trade, 'id');
                    const timestamp = this.parse8601(this.safeValue(trade, 'created_at'));
                    if (market === undefined) {
                        const baseId = this.safeString(amountObject, 'currency');
                        const quoteId = this.safeString(totalObject, 'currency');
                        if (baseId !== undefined && quoteId !== undefined) {
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote;
                        }
                    }
                    const orderId = undefined;
                    const side = this.safeString(trade, 'resource');
                    const type = undefined;
                    const costString = this.safeString(subtotalObject, 'amount');
                    const amountString = this.safeString(amountObject, 'amount');
                    const cost = this.parseNumber(costString);
                    const amount = this.parseNumber(amountString);
                    const price = this.parseNumber(Precise.stringDiv(costString, amountString));
                    const feeCost = this.safeNumber(feeObject, 'amount');
                    const feeCurrencyId = this.safeString(feeObject, 'currency');
                    const feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                    const fee = {
                        'cost': feeCost,
                        'currency': feeCurrency
                    };
                    return {
                        'info': trade,
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': fee
                    };
                }
                async fetchMarkets(params = {}) {
                    const response = await this.fetchCurrenciesFromCache(params);
                    const currencies = this.safeValue(response, 'currencies', {});
                    const exchangeRates = this.safeValue(response, 'exchangeRates', {});
                    const data = this.safeValue(currencies, 'data', []);
                    const dataById = this.indexBy(data, 'id');
                    const rates = this.safeValue(this.safeValue(exchangeRates, 'data', {}), 'rates', {});
                    const baseIds = Object.keys(rates);
                    const result = [];
                    for(let i = 0; i < baseIds.length; i++){
                        const baseId = baseIds[i];
                        const base = this.safeCurrencyCode(baseId);
                        const type = baseId in dataById ? 'fiat' : 'crypto';
                        // https://github.com/ccxt/ccxt/issues/6066
                        if (type === 'crypto') for(let j = 0; j < data.length; j++){
                            const quoteCurrency = data[j];
                            const quoteId = this.safeString(quoteCurrency, 'id');
                            const quote = this.safeCurrencyCode(quoteId);
                            result.push({
                                'id': baseId + '-' + quoteId,
                                'symbol': base + '/' + quote,
                                'base': base,
                                'quote': quote,
                                'settle': undefined,
                                'baseId': baseId,
                                'quoteId': quoteId,
                                'settleId': undefined,
                                'type': 'spot',
                                'spot': true,
                                'margin': false,
                                'swap': false,
                                'future': false,
                                'option': false,
                                'active': undefined,
                                'contract': false,
                                'linear': undefined,
                                'inverse': undefined,
                                'contractSize': undefined,
                                'expiry': undefined,
                                'expiryDatetime': undefined,
                                'strike': undefined,
                                'optionType': undefined,
                                'precision': {
                                    'amount': undefined,
                                    'price': undefined
                                },
                                'limits': {
                                    'leverage': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'amount': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'price': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'cost': {
                                        'min': this.safeNumber(quoteCurrency, 'min_size'),
                                        'max': undefined
                                    }
                                },
                                'info': quoteCurrency
                            });
                        }
                    }
                    return result;
                }
                async fetchCurrenciesFromCache(params = {}) {
                    const options = this.safeValue(this.options, 'fetchCurrencies', {});
                    const timestamp = this.safeInteger(options, 'timestamp');
                    const expires = this.safeInteger(options, 'expires', 1000);
                    const now = this.milliseconds();
                    if (timestamp === undefined || now - timestamp > expires) {
                        const currencies = await this.publicGetCurrencies(params);
                        const exchangeRates = await this.publicGetExchangeRates(params);
                        this.options['fetchCurrencies'] = this.extend(options, {
                            'currencies': currencies,
                            'exchangeRates': exchangeRates,
                            'timestamp': now
                        });
                    }
                    return this.safeValue(this.options, 'fetchCurrencies', {});
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.fetchCurrenciesFromCache(params);
                    const currencies = this.safeValue(response, 'currencies', {});
                    //
                    //     {
                    //         "data":[
                    //             {"id":"AED","name":"United Arab Emirates Dirham","min_size":"0.01000000"},
                    //             {"id":"AFN","name":"Afghan Afghani","min_size":"0.01000000"},
                    //             {"id":"ALL","name":"Albanian Lek","min_size":"0.01000000"},
                    //             {"id":"AMD","name":"Armenian Dram","min_size":"0.01000000"},
                    //             {"id":"ANG","name":"Netherlands Antillean Gulden","min_size":"0.01000000"},
                    //             // ...
                    //         ],
                    //     }
                    //
                    const exchangeRates = this.safeValue(response, 'exchangeRates', {});
                    //
                    //     {
                    //         "data":{
                    //             "currency":"USD",
                    //             "rates":{
                    //                 "AED":"3.67",
                    //                 "AFN":"78.21",
                    //                 "ALL":"110.42",
                    //                 "AMD":"474.18",
                    //                 "ANG":"1.75",
                    //                 // ...
                    //             },
                    //         }
                    //     }
                    //
                    const data = this.safeValue(currencies, 'data', []);
                    const dataById = this.indexBy(data, 'id');
                    const rates = this.safeValue(this.safeValue(exchangeRates, 'data', {}), 'rates', {});
                    const keys = Object.keys(rates);
                    const result = {};
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        const type = key in dataById ? 'fiat' : 'crypto';
                        const currency = this.safeValue(dataById, key, {});
                        const id = this.safeString(currency, 'id', key);
                        const name = this.safeString(currency, 'name');
                        const code = this.safeCurrencyCode(id);
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'type': type,
                            'name': name,
                            'active': true,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': undefined,
                            'precision': undefined,
                            'limits': {
                                'amount': {
                                    'min': this.safeNumber(currency, 'min_size'),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    const response = await this.publicGetExchangeRates(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "currency":"USD",
                    //             "rates":{
                    //                 "AED":"3.6731",
                    //                 "AFN":"103.163942",
                    //                 "ALL":"106.973038",
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const rates = this.safeValue(data, 'rates', {});
                    const quoteId = this.safeString(data, 'currency');
                    const result = {};
                    const baseIds = Object.keys(rates);
                    const delimiter = '-';
                    for(let i = 0; i < baseIds.length; i++){
                        const baseId = baseIds[i];
                        const marketId = baseId + delimiter + quoteId;
                        const market = this.safeMarket(marketId, undefined, delimiter);
                        const symbol = market['symbol'];
                        result[symbol] = this.parseTicker(rates[baseId], market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = this.extend({
                        'symbol': market['id']
                    }, params);
                    const spot = await this.publicGetPricesSymbolSpot(request);
                    //
                    //     {"data":{"base":"BTC","currency":"USD","amount":"48691.23"}}
                    //
                    const buy = await this.publicGetPricesSymbolBuy(request);
                    //
                    //     {"data":{"base":"BTC","currency":"USD","amount":"48691.23"}}
                    //
                    const sell = await this.publicGetPricesSymbolSell(request);
                    //
                    //     {"data":{"base":"BTC","currency":"USD","amount":"48691.23"}}
                    //
                    return this.parseTicker([
                        spot,
                        buy,
                        sell
                    ], market);
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker
                    //
                    //     [
                    //         "48691.23", // spot
                    //         "48691.23", // buy
                    //         "48691.23",  // sell
                    //     ]
                    //
                    // fetchTickers
                    //
                    //     "48691.23"
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    let ask = undefined;
                    let bid = undefined;
                    let last = undefined;
                    const timestamp = this.milliseconds();
                    if (typeof ticker !== 'string') {
                        const [spot, buy, sell] = ticker;
                        const spotData = this.safeValue(spot, 'data', {});
                        const buyData = this.safeValue(buy, 'data', {});
                        const sellData = this.safeValue(sell, 'data', {});
                        last = this.safeString(spotData, 'amount');
                        bid = this.safeString(buyData, 'amount');
                        ask = this.safeString(sellData, 'amount');
                    }
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'bid': bid,
                        'ask': ask,
                        'last': last,
                        'high': undefined,
                        'low': undefined,
                        'bidVolume': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': undefined,
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'limit': 100
                    };
                    const response = await this.privateGetAccounts(this.extend(request, params));
                    const balances = this.safeValue(response, 'data');
                    const accounts = this.safeValue(params, 'type', this.options['accounts']);
                    const result = {
                        'info': response
                    };
                    for(let b = 0; b < balances.length; b++){
                        const balance = balances[b];
                        const type = this.safeString(balance, 'type');
                        if (this.inArray(type, accounts)) {
                            const value = this.safeValue(balance, 'balance');
                            if (value !== undefined) {
                                const currencyId = this.safeString(value, 'currency');
                                const code = this.safeCurrencyCode(currencyId);
                                const total = this.safeString(value, 'amount');
                                const free = total;
                                let account = this.safeValue(result, code);
                                if (account === undefined) {
                                    account = this.account();
                                    account['free'] = free;
                                    account['total'] = total;
                                } else {
                                    account['free'] = Precise.stringAdd(account['free'], total);
                                    account['total'] = Precise.stringAdd(account['total'], total);
                                }
                                result[code] = account;
                            }
                        }
                    }
                    return this.safeBalance(result);
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const request = await this.prepareAccountRequestWithCurrencyCode(code, limit, params);
                    const query = this.omit(params, [
                        'account_id',
                        'accountId'
                    ]);
                    // for pagination use parameter 'starting_after'
                    // the value for the next page can be obtained from the result of the previous call in the 'pagination' field
                    // eg: instance.last_json_response.pagination.next_starting_after
                    const response = await this.privateGetAccountsAccountIdTransactions(this.extend(request, query));
                    return this.parseLedger(response['data'], currency, since, limit);
                }
                parseLedgerEntryStatus(status) {
                    const types = {
                        'completed': 'ok'
                    };
                    return this.safeString(types, status, status);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'buy': 'trade',
                        'sell': 'trade',
                        'fiat_deposit': 'transaction',
                        'fiat_withdrawal': 'transaction',
                        'exchange_deposit': 'transaction',
                        'exchange_withdrawal': 'transaction',
                        'send': 'transaction',
                        'pro_deposit': 'transaction',
                        'pro_withdrawal': 'transaction'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    // crypto deposit transaction
                    //
                    //     {
                    //         id: '34e4816b-4c8c-5323-a01c-35a9fa26e490',
                    //         type: 'send',
                    //         status: 'completed',
                    //         amount: { amount: '28.31976528', currency: 'BCH' },
                    //         native_amount: { amount: '2799.65', currency: 'GBP' },
                    //         description: null,
                    //         created_at: '2019-02-28T12:35:20Z',
                    //         updated_at: '2019-02-28T12:43:24Z',
                    //         resource: 'transaction',
                    //         resource_path: '/v2/accounts/c01d7364-edd7-5f3a-bd1d-de53d4cbb25e/transactions/34e4816b-4c8c-5323-a01c-35a9fa26e490',
                    //         instant_exchange: false,
                    //         network: {
                    //             status: 'confirmed',
                    //             hash: '56222d865dae83774fccb2efbd9829cf08c75c94ce135bfe4276f3fb46d49701',
                    //             transaction_url: 'https://bch.btc.com/56222d865dae83774fccb2efbd9829cf08c75c94ce135bfe4276f3fb46d49701'
                    //         },
                    //         from: { resource: 'bitcoin_cash_network', currency: 'BCH' },
                    //         details: { title: 'Received Bitcoin Cash', subtitle: 'From Bitcoin Cash address' }
                    //     }
                    //
                    // crypto withdrawal transaction
                    //
                    //     {
                    //         id: '459aad99-2c41-5698-ac71-b6b81a05196c',
                    //         type: 'send',
                    //         status: 'completed',
                    //         amount: { amount: '-0.36775642', currency: 'BTC' },
                    //         native_amount: { amount: '-1111.65', currency: 'GBP' },
                    //         description: null,
                    //         created_at: '2019-03-20T08:37:07Z',
                    //         updated_at: '2019-03-20T08:49:33Z',
                    //         resource: 'transaction',
                    //         resource_path: '/v2/accounts/c6afbd34-4bd0-501e-8616-4862c193cd84/transactions/459aad99-2c41-5698-ac71-b6b81a05196c',
                    //         instant_exchange: false,
                    //         network: {
                    //             status: 'confirmed',
                    //             hash: '2732bbcf35c69217c47b36dce64933d103895277fe25738ffb9284092701e05b',
                    //             transaction_url: 'https://blockchain.info/tx/2732bbcf35c69217c47b36dce64933d103895277fe25738ffb9284092701e05b',
                    //             transaction_fee: { amount: '0.00000000', currency: 'BTC' },
                    //             transaction_amount: { amount: '0.36775642', currency: 'BTC' },
                    //             confirmations: 15682
                    //         },
                    //         to: {
                    //             resource: 'bitcoin_address',
                    //             address: '1AHnhqbvbYx3rnZx8uC7NbFZaTe4tafFHX',
                    //             currency: 'BTC',
                    //             address_info: { address: '1AHnhqbvbYx3rnZx8uC7NbFZaTe4tafFHX' }
                    //         },
                    //         idem: 'da0a2f14-a2af-4c5a-a37e-d4484caf582bsend',
                    //         application: {
                    //             id: '5756ab6e-836b-553b-8950-5e389451225d',
                    //             resource: 'application',
                    //             resource_path: '/v2/applications/5756ab6e-836b-553b-8950-5e389451225d'
                    //         },
                    //         details: { title: 'Sent Bitcoin', subtitle: 'To Bitcoin address' }
                    //     }
                    //
                    // withdrawal transaction from coinbase to coinbasepro
                    //
                    //     {
                    //         id: '5b1b9fb8-5007-5393-b923-02903b973fdc',
                    //         type: 'pro_deposit',
                    //         status: 'completed',
                    //         amount: { amount: '-0.00001111', currency: 'BCH' },
                    //         native_amount: { amount: '0.00', currency: 'GBP' },
                    //         description: null,
                    //         created_at: '2019-02-28T13:31:58Z',
                    //         updated_at: '2019-02-28T13:31:58Z',
                    //         resource: 'transaction',
                    //         resource_path: '/v2/accounts/c01d7364-edd7-5f3a-bd1d-de53d4cbb25e/transactions/5b1b9fb8-5007-5393-b923-02903b973fdc',
                    //         instant_exchange: false,
                    //         application: {
                    //             id: '5756ab6e-836b-553b-8950-5e389451225d',
                    //             resource: 'application',
                    //             resource_path: '/v2/applications/5756ab6e-836b-553b-8950-5e389451225d'
                    //         },
                    //         details: { title: 'Transferred Bitcoin Cash', subtitle: 'To Coinbase Pro' }
                    //     }
                    //
                    // withdrawal transaction from coinbase to gdax
                    //
                    //     {
                    //         id: 'badb7313-a9d3-5c07-abd0-00f8b44199b1',
                    //         type: 'exchange_deposit',
                    //         status: 'completed',
                    //         amount: { amount: '-0.43704149', currency: 'BCH' },
                    //         native_amount: { amount: '-51.90', currency: 'GBP' },
                    //         description: null,
                    //         created_at: '2019-03-19T10:30:40Z',
                    //         updated_at: '2019-03-19T10:30:40Z',
                    //         resource: 'transaction',
                    //         resource_path: '/v2/accounts/c01d7364-edd7-5f3a-bd1d-de53d4cbb25e/transactions/badb7313-a9d3-5c07-abd0-00f8b44199b1',
                    //         instant_exchange: false,
                    //         details: { title: 'Transferred Bitcoin Cash', subtitle: 'To GDAX' }
                    //     }
                    //
                    // deposit transaction from gdax to coinbase
                    //
                    //     {
                    //         id: '9c4b642c-8688-58bf-8962-13cef64097de',
                    //         type: 'exchange_withdrawal',
                    //         status: 'completed',
                    //         amount: { amount: '0.57729420', currency: 'BTC' },
                    //         native_amount: { amount: '4418.72', currency: 'GBP' },
                    //         description: null,
                    //         created_at: '2018-02-17T11:33:33Z',
                    //         updated_at: '2018-02-17T11:33:33Z',
                    //         resource: 'transaction',
                    //         resource_path: '/v2/accounts/c6afbd34-4bd0-501e-8616-4862c193cd84/transactions/9c4b642c-8688-58bf-8962-13cef64097de',
                    //         instant_exchange: false,
                    //         details: { title: 'Transferred Bitcoin', subtitle: 'From GDAX' }
                    //     }
                    //
                    // deposit transaction from coinbasepro to coinbase
                    //
                    //     {
                    //         id: '8d6dd0b9-3416-568a-889d-8f112fae9e81',
                    //         type: 'pro_withdrawal',
                    //         status: 'completed',
                    //         amount: { amount: '0.40555386', currency: 'BTC' },
                    //         native_amount: { amount: '1140.27', currency: 'GBP' },
                    //         description: null,
                    //         created_at: '2019-03-04T19:41:58Z',
                    //         updated_at: '2019-03-04T19:41:58Z',
                    //         resource: 'transaction',
                    //         resource_path: '/v2/accounts/c6afbd34-4bd0-501e-8616-4862c193cd84/transactions/8d6dd0b9-3416-568a-889d-8f112fae9e81',
                    //         instant_exchange: false,
                    //         application: {
                    //             id: '5756ab6e-836b-553b-8950-5e389451225d',
                    //             resource: 'application',
                    //             resource_path: '/v2/applications/5756ab6e-836b-553b-8950-5e389451225d'
                    //         },
                    //         details: { title: 'Transferred Bitcoin', subtitle: 'From Coinbase Pro' }
                    //     }
                    //
                    // sell trade
                    //
                    //     {
                    //         id: 'a9409207-df64-585b-97ab-a50780d2149e',
                    //         type: 'sell',
                    //         status: 'completed',
                    //         amount: { amount: '-9.09922880', currency: 'BTC' },
                    //         native_amount: { amount: '-7285.73', currency: 'GBP' },
                    //         description: null,
                    //         created_at: '2017-03-27T15:38:34Z',
                    //         updated_at: '2017-03-27T15:38:34Z',
                    //         resource: 'transaction',
                    //         resource_path: '/v2/accounts/c6afbd34-4bd0-501e-8616-4862c193cd84/transactions/a9409207-df64-585b-97ab-a50780d2149e',
                    //         instant_exchange: false,
                    //         sell: {
                    //             id: 'e3550b4d-8ae6-5de3-95fe-1fb01ba83051',
                    //             resource: 'sell',
                    //             resource_path: '/v2/accounts/c6afbd34-4bd0-501e-8616-4862c193cd84/sells/e3550b4d-8ae6-5de3-95fe-1fb01ba83051'
                    //         },
                    //         details: {
                    //             title: 'Sold Bitcoin',
                    //             subtitle: 'Using EUR Wallet',
                    //             payment_method_name: 'EUR Wallet'
                    //         }
                    //     }
                    //
                    // buy trade
                    //
                    //     {
                    //         id: '63eeed67-9396-5912-86e9-73c4f10fe147',
                    //         type: 'buy',
                    //         status: 'completed',
                    //         amount: { amount: '2.39605772', currency: 'ETH' },
                    //         native_amount: { amount: '98.31', currency: 'GBP' },
                    //         description: null,
                    //         created_at: '2017-03-27T09:07:56Z',
                    //         updated_at: '2017-03-27T09:07:57Z',
                    //         resource: 'transaction',
                    //         resource_path: '/v2/accounts/8902f85d-4a69-5d74-82fe-8e390201bda7/transactions/63eeed67-9396-5912-86e9-73c4f10fe147',
                    //         instant_exchange: false,
                    //         buy: {
                    //             id: '20b25b36-76c6-5353-aa57-b06a29a39d82',
                    //             resource: 'buy',
                    //             resource_path: '/v2/accounts/8902f85d-4a69-5d74-82fe-8e390201bda7/buys/20b25b36-76c6-5353-aa57-b06a29a39d82'
                    //         },
                    //         details: {
                    //             title: 'Bought Ethereum',
                    //             subtitle: 'Using EUR Wallet',
                    //             payment_method_name: 'EUR Wallet'
                    //         }
                    //     }
                    //
                    // fiat deposit transaction
                    //
                    //     {
                    //         id: '04ed4113-3732-5b0c-af86-b1d2146977d0',
                    //         type: 'fiat_deposit',
                    //         status: 'completed',
                    //         amount: { amount: '114.02', currency: 'EUR' },
                    //         native_amount: { amount: '97.23', currency: 'GBP' },
                    //         description: null,
                    //         created_at: '2017-02-09T07:01:21Z',
                    //         updated_at: '2017-02-09T07:01:22Z',
                    //         resource: 'transaction',
                    //         resource_path: '/v2/accounts/91cd2d36-3a91-55b6-a5d4-0124cf105483/transactions/04ed4113-3732-5b0c-af86-b1d2146977d0',
                    //         instant_exchange: false,
                    //         fiat_deposit: {
                    //             id: 'f34c19f3-b730-5e3d-9f72-96520448677a',
                    //             resource: 'fiat_deposit',
                    //             resource_path: '/v2/accounts/91cd2d36-3a91-55b6-a5d4-0124cf105483/deposits/f34c19f3-b730-5e3d-9f72-96520448677a'
                    //         },
                    //         details: {
                    //             title: 'Deposited funds',
                    //             subtitle: 'From SEPA Transfer (GB47 BARC 20..., reference CBADVI)',
                    //             payment_method_name: 'SEPA Transfer (GB47 BARC 20..., reference CBADVI)'
                    //         }
                    //     }
                    //
                    // fiat withdrawal transaction
                    //
                    //     {
                    //         id: '957d98e2-f80e-5e2f-a28e-02945aa93079',
                    //         type: 'fiat_withdrawal',
                    //         status: 'completed',
                    //         amount: { amount: '-11000.00', currency: 'EUR' },
                    //         native_amount: { amount: '-9698.22', currency: 'GBP' },
                    //         description: null,
                    //         created_at: '2017-12-06T13:19:19Z',
                    //         updated_at: '2017-12-06T13:19:19Z',
                    //         resource: 'transaction',
                    //         resource_path: '/v2/accounts/91cd2d36-3a91-55b6-a5d4-0124cf105483/transactions/957d98e2-f80e-5e2f-a28e-02945aa93079',
                    //         instant_exchange: false,
                    //         fiat_withdrawal: {
                    //             id: 'f4bf1fd9-ab3b-5de7-906d-ed3e23f7a4e7',
                    //             resource: 'fiat_withdrawal',
                    //             resource_path: '/v2/accounts/91cd2d36-3a91-55b6-a5d4-0124cf105483/withdrawals/f4bf1fd9-ab3b-5de7-906d-ed3e23f7a4e7'
                    //         },
                    //         details: {
                    //             title: 'Withdrew funds',
                    //             subtitle: 'To HSBC BANK PLC (GB74 MIDL...)',
                    //             payment_method_name: 'HSBC BANK PLC (GB74 MIDL...)'
                    //         }
                    //     }
                    //
                    const amountInfo = this.safeValue(item, 'amount', {});
                    let amount = this.safeNumber(amountInfo, 'amount');
                    let direction = undefined;
                    if (amount < 0) {
                        direction = 'out';
                        amount = -amount;
                    } else direction = 'in';
                    const currencyId = this.safeString(amountInfo, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    //
                    // the address and txid do not belong to the unified ledger structure
                    //
                    //     let address = undefined;
                    //     if (item['to']) {
                    //         address = this.safeString (item['to'], 'address');
                    //     }
                    //     let txid = undefined;
                    //
                    let fee = undefined;
                    const networkInfo = this.safeValue(item, 'network', {});
                    // txid = network['hash']; // txid does not belong to the unified ledger structure
                    const feeInfo = this.safeValue(networkInfo, 'transaction_fee');
                    if (feeInfo !== undefined) {
                        const feeCurrencyId = this.safeString(feeInfo, 'currency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId, currency);
                        const feeAmount = this.safeNumber(feeInfo, 'amount');
                        fee = {
                            'cost': feeAmount,
                            'currency': feeCurrencyCode
                        };
                    }
                    const timestamp = this.parse8601(this.safeValue(item, 'created_at'));
                    const id = this.safeString(item, 'id');
                    const type = this.parseLedgerEntryType(this.safeString(item, 'type'));
                    const status = this.parseLedgerEntryStatus(this.safeString(item, 'status'));
                    const path = this.safeString(item, 'resource_path');
                    let accountId = undefined;
                    if (path !== undefined) {
                        const parts = path.split('/');
                        const numParts = parts.length;
                        if (numParts > 3) accountId = parts[3];
                    }
                    return {
                        'info': item,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'direction': direction,
                        'account': accountId,
                        'referenceId': undefined,
                        'referenceAccount': undefined,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'before': undefined,
                        'after': undefined,
                        'status': status,
                        'fee': fee
                    };
                }
                async findAccountId(code) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    for(let i = 0; i < this.accounts.length; i++){
                        const account = this.accounts[i];
                        if (account['code'] === code) return account['id'];
                    }
                    return undefined;
                }
                prepareAccountRequest(limit, params = {}) {
                    const accountId = this.safeString2(params, 'account_id', 'accountId');
                    if (accountId === undefined) throw new ArgumentsRequired1(this.id + ' prepareAccountRequest() method requires an account_id (or accountId) parameter');
                    const request = {
                        'account_id': accountId
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    return request;
                }
                async prepareAccountRequestWithCurrencyCode(code, limit, params = {}) {
                    let accountId = this.safeString2(params, 'account_id', 'accountId');
                    if (accountId === undefined) {
                        if (code === undefined) throw new ArgumentsRequired1(this.id + ' prepareAccountRequestWithCurrencyCode() method requires an account_id (or accountId) parameter OR a currency code argument');
                        accountId = await this.findAccountId(code);
                        if (accountId === undefined) throw new ExchangeError1(this.id + ' prepareAccountRequestWithCurrencyCode() could not find account id for ' + code);
                    }
                    const request = {
                        'account_id': accountId
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    return request;
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let fullPath = '/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (method === 'GET') {
                        if (Object.keys(query).length) fullPath += '?' + this.urlencode(query);
                    }
                    const url = this.urls['api'] + fullPath;
                    if (api === 'private') {
                        const authorization = this.safeString(this.headers, 'Authorization');
                        if (authorization !== undefined) headers = {
                            'Authorization': authorization,
                            'Content-Type': 'application/json'
                        };
                        else if (this.token) headers = {
                            'Authorization': 'Bearer ' + this.token,
                            'Content-Type': 'application/json'
                        };
                        else {
                            this.checkRequiredCredentials();
                            const nonce = this.nonce().toString();
                            let payload = '';
                            if (method !== 'GET') {
                                if (Object.keys(query).length) {
                                    body = this.json(query);
                                    payload = body;
                                }
                            }
                            const auth = nonce + method + fullPath + payload;
                            const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                            headers = {
                                'CB-ACCESS-KEY': this.apiKey,
                                'CB-ACCESS-SIGN': signature,
                                'CB-ACCESS-TIMESTAMP': nonce,
                                'Content-Type': 'application/json'
                            };
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    const feedback = this.id + ' ' + body;
                    //
                    //    {"error": "invalid_request", "error_description": "The request is missing a required parameter, includes an unsupported parameter value, or is otherwise malformed."}
                    //
                    // or
                    //
                    //    {
                    //      "errors": [
                    //        {
                    //          "id": "not_found",
                    //          "message": "Not found"
                    //        }
                    //      ]
                    //    }
                    //
                    let errorCode = this.safeString(response, 'error');
                    if (errorCode !== undefined) {
                        const errorMessage = this.safeString(response, 'error_description');
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], errorMessage, feedback);
                        throw new ExchangeError1(feedback);
                    }
                    const errors = this.safeValue(response, 'errors');
                    if (errors !== undefined) {
                        if (Array.isArray(errors)) {
                            const numErrors = errors.length;
                            if (numErrors > 0) {
                                errorCode = this.safeString(errors[0], 'id');
                                const errorMessage = this.safeString(errors[0], 'message');
                                if (errorCode !== undefined) {
                                    this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                                    this.throwBroadlyMatchedException(this.exceptions['broad'], errorMessage, feedback);
                                    throw new ExchangeError1(feedback);
                                }
                            }
                        }
                    }
                    const data = this.safeValue(response, 'data');
                    if (data === undefined) throw new ExchangeError1(this.id + ' failed due to a malformed response ' + this.json(response));
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    63: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const coinbasepro = require1('./coinbasepro.js');
            // ---------------------------------------------------------------------------
            module.exports = class coinbaseprime extends coinbasepro {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'coinbaseprime',
                        'name': 'Coinbase Prime',
                        'pro': true,
                        'hostname': 'exchange.coinbase.com',
                        'urls': {
                            'test': {
                                'public': 'https://public.sandbox.exchange.coinbase.com',
                                'private': 'https://public.sandbox.exchange.coinbase.com'
                            },
                            'logo': 'https://user-images.githubusercontent.com/1294454/44539184-29f26e00-a70c-11e8-868f-e907fc236a7c.jpg',
                            'api': {
                                'public': 'https://api.{hostname}',
                                'private': 'https://api.{hostname}'
                            },
                            'www': 'https://exchange.coinbase.com',
                            'doc': 'https://docs.exchange.coinbase.com'
                        }
                    });
                }
            };
        },
        {
            "./coinbasepro.js": 64
        }
    ],
    64: [
        function(require1, module, exports) {
            'use strict';
            // ----------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { InsufficientFunds: InsufficientFunds, ArgumentsRequired: ArgumentsRequired1, ExchangeError: ExchangeError1, InvalidOrder: InvalidOrder, InvalidAddress: InvalidAddress, AuthenticationError: AuthenticationError, NotSupported: NotSupported, OrderNotFound: OrderNotFound, OnMaintenance: OnMaintenance, PermissionDenied: PermissionDenied, RateLimitExceeded: RateLimitExceeded } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            // ----------------------------------------------------------------------------
            module.exports = class coinbasepro extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'coinbasepro',
                        'name': 'Coinbase Pro',
                        'countries': [
                            'US'
                        ],
                        'rateLimit': 100,
                        'userAgent': this.userAgents['chrome'],
                        'pro': true,
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': undefined,
                            'fetchDeposits': true,
                            'fetchLedger': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchOrderTrades': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': true,
                            'fetchWithdrawals': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': 60,
                            '5m': 300,
                            '15m': 900,
                            '1h': 3600,
                            '6h': 21600,
                            '1d': 86400
                        },
                        'hostname': 'pro.coinbase.com',
                        'urls': {
                            'test': {
                                'public': 'https://api-public.sandbox.pro.coinbase.com',
                                'private': 'https://api-public.sandbox.pro.coinbase.com'
                            },
                            'logo': 'https://user-images.githubusercontent.com/1294454/41764625-63b7ffde-760a-11e8-996d-a6328fa9347a.jpg',
                            'api': {
                                'public': 'https://api.{hostname}',
                                'private': 'https://api.{hostname}'
                            },
                            'www': 'https://pro.coinbase.com/',
                            'doc': 'https://docs.pro.coinbase.com',
                            'fees': [
                                'https://docs.pro.coinbase.com/#fees',
                                'https://support.pro.coinbase.com/customer/en/portal/articles/2945310-fees'
                            ]
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'password': true
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'currencies',
                                    'products',
                                    'products/{id}',
                                    'products/{id}/book',
                                    'products/{id}/candles',
                                    'products/{id}/stats',
                                    'products/{id}/ticker',
                                    'products/{id}/trades',
                                    'time',
                                    'products/spark-lines'
                                ]
                            },
                            'private': {
                                'get': [
                                    'accounts',
                                    'accounts/{id}',
                                    'accounts/{id}/holds',
                                    'accounts/{id}/ledger',
                                    'accounts/{id}/transfers',
                                    'coinbase-accounts',
                                    'fills',
                                    'funding',
                                    'fees',
                                    'margin/profile_information',
                                    'margin/buying_power',
                                    'margin/withdrawal_power',
                                    'margin/withdrawal_power_all',
                                    'margin/exit_plan',
                                    'margin/liquidation_history',
                                    'margin/position_refresh_amounts',
                                    'margin/status',
                                    'oracle',
                                    'orders',
                                    'orders/{id}',
                                    'orders/client:{client_oid}',
                                    'otc/orders',
                                    'payment-methods',
                                    'position',
                                    'profiles',
                                    'profiles/{id}',
                                    'reports/{report_id}',
                                    'transfers',
                                    'transfers/{transfer_id}',
                                    'users/self/exchange-limits',
                                    'users/self/hold-balances',
                                    'users/self/trailing-volume',
                                    'withdrawals/fee-estimate'
                                ],
                                'post': [
                                    'conversions',
                                    'deposits/coinbase-account',
                                    'deposits/payment-method',
                                    'coinbase-accounts/{id}/addresses',
                                    'funding/repay',
                                    'orders',
                                    'position/close',
                                    'profiles/margin-transfer',
                                    'profiles/transfer',
                                    'reports',
                                    'withdrawals/coinbase',
                                    'withdrawals/coinbase-account',
                                    'withdrawals/crypto',
                                    'withdrawals/payment-method'
                                ],
                                'delete': [
                                    'orders',
                                    'orders/client:{client_oid}',
                                    'orders/{id}'
                                ]
                            }
                        },
                        'commonCurrencies': {
                            'CGLD': 'CELO'
                        },
                        'precisionMode': TICK_SIZE,
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'maker': 0.004,
                                'taker': 0.006
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false,
                                'withdraw': {
                                    'BCH': 0,
                                    'BTC': 0,
                                    'LTC': 0,
                                    'ETH': 0,
                                    'EUR': 0.15,
                                    'USD': 25
                                },
                                'deposit': {
                                    'BCH': 0,
                                    'BTC': 0,
                                    'LTC': 0,
                                    'ETH': 0,
                                    'EUR': 0.15,
                                    'USD': 10
                                }
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'Insufficient funds': InsufficientFunds,
                                'NotFound': OrderNotFound,
                                'Invalid API Key': AuthenticationError,
                                'invalid signature': AuthenticationError,
                                'Invalid Passphrase': AuthenticationError,
                                'Invalid order id': InvalidOrder,
                                'Private rate limit exceeded': RateLimitExceeded,
                                'Trading pair not available': PermissionDenied,
                                'Product not found': InvalidOrder
                            },
                            'broad': {
                                'Order already done': OrderNotFound,
                                'order not found': OrderNotFound,
                                'price too small': InvalidOrder,
                                'price too precise': InvalidOrder,
                                'under maintenance': OnMaintenance,
                                'size is too small': InvalidOrder,
                                'Cancel only mode': OnMaintenance
                            }
                        }
                    });
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     [
                    //         {
                    //             id: 'XTZ',
                    //             name: 'Tezos',
                    //             min_size: '0.000001',
                    //             status: 'online',
                    //             message: '',
                    //             max_precision: '0.000001',
                    //             convertible_to: [],
                    //             details: {
                    //                 type: 'crypto',
                    //                 symbol: 'Τ',
                    //                 network_confirmations: 60,
                    //                 sort_order: 53,
                    //                 crypto_address_link: 'https://tzstats.com/{{address}}',
                    //                 crypto_transaction_link: 'https://tzstats.com/{{txId}}',
                    //                 push_payment_methods: [ 'crypto' ],
                    //                 group_types: [],
                    //                 display_name: '',
                    //                 processing_time_seconds: 0,
                    //                 min_withdrawal_amount: 1
                    //             }
                    //         }
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        const id = this.safeString(currency, 'id');
                        const name = this.safeString(currency, 'name');
                        const code = this.safeCurrencyCode(id);
                        const details = this.safeValue(currency, 'details', {});
                        const precision = this.safeNumber(currency, 'max_precision');
                        const status = this.safeString(currency, 'status');
                        const active = status === 'online';
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'type': this.safeString(details, 'type'),
                            'name': name,
                            'active': active,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': undefined,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': this.safeNumber(details, 'min_size'),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(details, 'min_withdrawal_amount'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetProducts(params);
                    //
                    //    [
                    //        {
                    //            "id": "ZEC-BTC",
                    //            "base_currency": "ZEC",
                    //            "quote_currency": "BTC",
                    //            "base_min_size": "0.0056",
                    //            "base_max_size": "3600",
                    //            "quote_increment": "0.000001",
                    //            "base_increment": "0.0001",
                    //            "display_name": "ZEC/BTC",
                    //            "min_market_funds": "0.000016",
                    //            "max_market_funds": "12",
                    //            "margin_enabled": false,
                    //            "fx_stablecoin": false,
                    //            "max_slippage_percentage": "0.03000000",
                    //            "post_only": false,
                    //            "limit_only": false,
                    //            "cancel_only": false,
                    //            "trading_disabled": false,
                    //            "status": "online",
                    //            "status_message": "",
                    //            "auction_mode": false
                    //          },
                    //    ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'id');
                        const baseId = this.safeString(market, 'base_currency');
                        const quoteId = this.safeString(market, 'quote_currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const status = this.safeString(market, 'status');
                        result.push(this.extend(this.fees['trading'], {
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': this.safeValue(market, 'margin_enabled'),
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': status === 'online',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(market, 'base_increment'),
                                'price': this.safeNumber(market, 'quote_increment')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'base_min_size'),
                                    'max': this.safeNumber(market, 'base_max_size')
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_market_funds'),
                                    'max': this.safeNumber(market, 'max_market_funds')
                                }
                            },
                            'info': market
                        }));
                    }
                    return result;
                }
                async fetchAccounts(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccounts(params);
                    //
                    //     [
                    //         {
                    //             id: '4aac9c60-cbda-4396-9da4-4aa71e95fba0',
                    //             currency: 'BTC',
                    //             balance: '0.0000000000000000',
                    //             available: '0',
                    //             hold: '0.0000000000000000',
                    //             profile_id: 'b709263e-f42a-4c7d-949a-a95c83d065da'
                    //         },
                    //         {
                    //             id: 'f75fa69a-1ad1-4a80-bd61-ee7faa6135a3',
                    //             currency: 'USDC',
                    //             balance: '0.0000000000000000',
                    //             available: '0',
                    //             hold: '0.0000000000000000',
                    //             profile_id: 'b709263e-f42a-4c7d-949a-a95c83d065da'
                    //         },
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const account = response[i];
                        const accountId = this.safeString(account, 'id');
                        const currencyId = this.safeString(account, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        result.push({
                            'id': accountId,
                            'type': undefined,
                            'currency': code,
                            'info': account
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'hold');
                        account['total'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccounts(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    // level 1 - only the best bid and ask
                    // level 2 - top 50 bids and asks (aggregated)
                    // level 3 - full order book (non aggregated)
                    const request = {
                        'id': this.marketId(symbol),
                        'level': 2
                    };
                    const response = await this.publicGetProductsIdBook(this.extend(request, params));
                    //
                    //     {
                    //         "sequence":1924393896,
                    //         "bids":[
                    //             ["0.01825","24.34811287",2],
                    //             ["0.01824","72.5463",3],
                    //             ["0.01823","424.54298049",6],
                    //         ],
                    //         "asks":[
                    //             ["0.01826","171.10414904",4],
                    //             ["0.01827","22.60427028",1],
                    //             ["0.01828","397.46018784",7],
                    //         ]
                    //     }
                    //
                    const orderbook = this.parseOrderBook(response, symbol);
                    orderbook['nonce'] = this.safeInteger(response, 'sequence');
                    return orderbook;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTickers
                    //
                    //      [
                    //         1639472400, // timestamp
                    //         4.26, // low
                    //         4.38, // high
                    //         4.35, // open
                    //         4.27 // close
                    //      ]
                    //
                    // fetchTicker
                    //
                    //     publicGetProductsIdTicker
                    //
                    //     {
                    //         "trade_id":843439,
                    //         "price":"0.997999",
                    //         "size":"80.29769",
                    //         "time":"2020-01-28T02:13:33.012523Z",
                    //         "bid":"0.997094",
                    //         "ask":"0.998",
                    //         "volume":"1903188.03750000"
                    //     }
                    //
                    //     publicGetProductsIdStats
                    //
                    //     {
                    //         "open": "34.19000000",
                    //         "high": "95.70000000",
                    //         "low": "7.06000000",
                    //         "volume": "2.41000000"
                    //     }
                    //
                    let timestamp = undefined;
                    let bid = undefined;
                    let ask = undefined;
                    let last = undefined;
                    let high = undefined;
                    let low = undefined;
                    let open = undefined;
                    let volume = undefined;
                    const symbol = market === undefined ? undefined : market['symbol'];
                    if (Array.isArray(ticker)) {
                        last = this.safeString(ticker, 4);
                        timestamp = this.milliseconds();
                    } else {
                        timestamp = this.parse8601(this.safeValue(ticker, 'time'));
                        bid = this.safeString(ticker, 'bid');
                        ask = this.safeString(ticker, 'ask');
                        high = this.safeString(ticker, 'high');
                        low = this.safeString(ticker, 'low');
                        open = this.safeString(ticker, 'open');
                        last = this.safeString2(ticker, 'price', 'last');
                        volume = this.safeString(ticker, 'volume');
                    }
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': high,
                        'low': low,
                        'bid': bid,
                        'bidVolume': undefined,
                        'ask': ask,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': volume,
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    const response = await this.publicGetProductsSparkLines(this.extend(request, params));
                    //
                    //     {
                    //         YYY-USD: [
                    //             [
                    //                 1639472400, // timestamp
                    //                 4.26, // low
                    //                 4.38, // high
                    //                 4.35, // open
                    //                 4.27 // close
                    //             ],
                    //             [
                    //                 1639468800,
                    //                 4.31,
                    //                 4.45,
                    //                 4.35,
                    //                 4.35
                    //             ],
                    //         ]
                    //     }
                    //
                    const result = {};
                    const marketIds = Object.keys(response);
                    const delimiter = '-';
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const entry = this.safeValue(response, marketId, []);
                        const first = this.safeValue(entry, 0, []);
                        const market = this.safeMarket(marketId, undefined, delimiter);
                        const symbol = market['symbol'];
                        result[symbol] = this.parseTicker(first, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': market['id']
                    };
                    // publicGetProductsIdTicker or publicGetProductsIdStats
                    const method = this.safeString(this.options, 'fetchTickerMethod', 'publicGetProductsIdTicker');
                    const response = await this[method](this.extend(request, params));
                    //
                    // publicGetProductsIdTicker
                    //
                    //     {
                    //         "trade_id":843439,
                    //         "price":"0.997999",
                    //         "size":"80.29769",
                    //         "time":"2020-01-28T02:13:33.012523Z",
                    //         "bid":"0.997094",
                    //         "ask":"0.998",
                    //         "volume":"1903188.03750000"
                    //     }
                    //
                    // publicGetProductsIdStats
                    //
                    //     {
                    //         "open": "34.19000000",
                    //         "high": "95.70000000",
                    //         "low": "7.06000000",
                    //         "volume": "2.41000000"
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                parseTrade(trade, market) {
                    //
                    //     {
                    //         type: 'match',
                    //         trade_id: 82047307,
                    //         maker_order_id: '0f358725-2134-435e-be11-753912a326e0',
                    //         taker_order_id: '252b7002-87a3-425c-ac73-f5b9e23f3caf',
                    //         order_id: 'd50ec984-77a8-460a-b958-66f114b0de9b',
                    //         side: 'sell',
                    //         size: '0.00513192',
                    //         price: '9314.78',
                    //         product_id: 'BTC-USD',
                    //         profile_id: '6244401d-c078-40d9-b305-7ad3551bc3b0',
                    //         sequence: 12038915443,
                    //         time: '2020-01-31T20:03:41.158814Z'
                    //         created_at: '2014-11-07T22:19:28.578544Z',
                    //         liquidity: 'T',
                    //         fee: '0.00025',
                    //         settled: true,
                    //         usd_volume: '0.0924556000000000',
                    //         user_id: '595eb864313c2b02ddf2937d'
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString2(trade, 'time', 'created_at'));
                    const marketId = this.safeString(trade, 'product_id');
                    market = this.safeMarket(marketId, market, '-');
                    let feeRate = undefined;
                    let takerOrMaker = undefined;
                    let cost = undefined;
                    const feeCurrencyId = this.safeStringLower(market, 'quoteId');
                    if (feeCurrencyId !== undefined) {
                        const costField = feeCurrencyId + '_value';
                        cost = this.safeString(trade, costField);
                        const liquidity = this.safeString(trade, 'liquidity');
                        if (liquidity !== undefined) {
                            takerOrMaker = liquidity === 'T' ? 'taker' : 'maker';
                            feeRate = this.safeString(market, takerOrMaker);
                        }
                    }
                    const feeCost = this.safeString2(trade, 'fill_fees', 'fee');
                    const fee = {
                        'cost': feeCost,
                        'currency': market['quote'],
                        'rate': feeRate
                    };
                    const id = this.safeString(trade, 'trade_id');
                    let side = trade['side'] === 'buy' ? 'sell' : 'buy';
                    const orderId = this.safeString(trade, 'order_id');
                    // Coinbase Pro returns inverted side to fetchMyTrades vs fetchTrades
                    const makerOrderId = this.safeString(trade, 'maker_order_id');
                    const takerOrderId = this.safeString(trade, 'taker_order_id');
                    if (orderId !== undefined || makerOrderId !== undefined && takerOrderId !== undefined) side = trade['side'] === 'buy' ? 'buy' : 'sell';
                    const price = this.safeString(trade, 'price');
                    const amount = this.safeString(trade, 'size');
                    return this.safeTrade({
                        'id': id,
                        'order': orderId,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': undefined,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'fee': fee,
                        'cost': cost
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    // as of 2018-08-23
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'product_id': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetFills(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 100
                    const response = await this.publicGetProductsIdTrades(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetFees(params);
                    //
                    //    {
                    //        "maker_fee_rate": "0.0050",
                    //        "taker_fee_rate": "0.0050",
                    //        "usd_volume": "43806.92"
                    //    }
                    //
                    const maker = this.safeNumber(response, 'maker_fee_rate');
                    const taker = this.safeNumber(response, 'taker_fee_rate');
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1591514160,
                    //         0.02507,
                    //         0.02507,
                    //         0.02507,
                    //         0.02507,
                    //         0.02816506
                    //     ]
                    //
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const granularity = this.timeframes[timeframe];
                    const request = {
                        'id': market['id'],
                        'granularity': granularity
                    };
                    if (since !== undefined) {
                        request['start'] = this.iso8601(since);
                        if (limit === undefined) // https://docs.pro.coinbase.com/#get-historic-rates
                        limit = 300; // max = 300
                        else limit = Math.min(300, limit);
                        request['end'] = this.iso8601(this.sum((limit - 1) * granularity * 1000, since));
                    }
                    const response = await this.publicGetProductsIdCandles(this.extend(request, params));
                    //
                    //     [
                    //         [1591514160,0.02507,0.02507,0.02507,0.02507,0.02816506],
                    //         [1591514100,0.02507,0.02507,0.02507,0.02507,1.63830323],
                    //         [1591514040,0.02505,0.02507,0.02505,0.02507,0.19918178]
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTime(params);
                    //
                    //     {
                    //         "iso":"2020-05-12T08:00:51.504Z",
                    //         "epoch":1589270451.504
                    //     }
                    //
                    return this.safeTimestamp(response, 'epoch');
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'pending': 'open',
                        'active': 'open',
                        'open': 'open',
                        'done': 'closed',
                        'canceled': 'canceled',
                        'canceling': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "id": "d0c5340b-6d6c-49d9-b567-48c4bfca13d2",
                    //         "price": "0.10000000",
                    //         "size": "0.01000000",
                    //         "product_id": "BTC-USD",
                    //         "side": "buy",
                    //         "stp": "dc",
                    //         "type": "limit",
                    //         "time_in_force": "GTC",
                    //         "post_only": false,
                    //         "created_at": "2016-12-08T20:02:28.53864Z",
                    //         "fill_fees": "0.0000000000000000",
                    //         "filled_size": "0.00000000",
                    //         "executed_value": "0.0000000000000000",
                    //         "status": "pending",
                    //         "settled": false
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const marketId = this.safeString(order, 'product_id');
                    market = this.safeMarket(marketId, market, '-');
                    let status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const doneReason = this.safeString(order, 'done_reason');
                    if (status === 'closed' && doneReason === 'canceled') status = 'canceled';
                    const price = this.safeString(order, 'price');
                    const filled = this.safeString(order, 'filled_size');
                    const amount = this.safeString(order, 'size', filled);
                    const cost = this.safeString(order, 'executed_value');
                    const feeCost = this.safeNumber(order, 'fill_fees');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': market['quote'],
                        'rate': undefined
                    };
                    const id = this.safeString(order, 'id');
                    const type = this.safeString(order, 'type');
                    const side = this.safeString(order, 'side');
                    const timeInForce = this.safeString(order, 'time_in_force');
                    const postOnly = this.safeValue(order, 'post_only');
                    const stopPrice = this.safeNumber(order, 'stop_price');
                    const clientOrderId = this.safeString(order, 'client_oid');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'fee': fee,
                        'average': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client_oid');
                    let method = undefined;
                    if (clientOrderId === undefined) {
                        method = 'privateGetOrdersId';
                        request['id'] = id;
                    } else {
                        method = 'privateGetOrdersClientClientOid';
                        request['client_oid'] = clientOrderId;
                        params = this.omit(params, [
                            'clientOrderId',
                            'client_oid'
                        ]);
                    }
                    const response = await this[method](this.extend(request, params));
                    return this.parseOrder(response);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privateGetFills(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'all'
                    };
                    return await this.fetchOpenOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['product_id'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 100
                    const response = await this.privateGetOrders(this.extend(request, params));
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'done'
                    };
                    return await this.fetchOpenOrders(symbol, since, limit, this.extend(request, params));
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        // common params --------------------------------------------------
                        // 'client_oid': clientOrderId,
                        'type': type,
                        'side': side,
                        'product_id': market['id']
                    };
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client_oid');
                    if (clientOrderId !== undefined) request['client_oid'] = clientOrderId;
                    const stopPrice = this.safeNumber2(params, 'stopPrice', 'stop_price');
                    if (stopPrice !== undefined) request['stop_price'] = this.priceToPrecision(symbol, stopPrice);
                    const timeInForce = this.safeString2(params, 'timeInForce', 'time_in_force');
                    if (timeInForce !== undefined) request['time_in_force'] = timeInForce;
                    const postOnly = this.safeValue2(params, 'postOnly', 'post_only', false);
                    if (postOnly) request['post_only'] = true;
                    params = this.omit(params, [
                        'timeInForce',
                        'time_in_force',
                        'stopPrice',
                        'stop_price',
                        'clientOrderId',
                        'client_oid',
                        'postOnly',
                        'post_only'
                    ]);
                    if (type === 'limit') {
                        request['price'] = this.priceToPrecision(symbol, price);
                        request['size'] = this.amountToPrecision(symbol, amount);
                    } else if (type === 'market') {
                        let cost = this.safeNumber2(params, 'cost', 'funds');
                        if (cost === undefined) {
                            if (price !== undefined) cost = amount * price;
                        } else params = this.omit(params, [
                            'cost',
                            'funds'
                        ]);
                        if (cost !== undefined) request['funds'] = this.costToPrecision(symbol, cost);
                        else request['size'] = this.amountToPrecision(symbol, amount);
                    }
                    const response = await this.privatePostOrders(this.extend(request, params));
                    //
                    //     {
                    //         "id": "d0c5340b-6d6c-49d9-b567-48c4bfca13d2",
                    //         "price": "0.10000000",
                    //         "size": "0.01000000",
                    //         "product_id": "BTC-USD",
                    //         "side": "buy",
                    //         "stp": "dc",
                    //         "type": "limit",
                    //         "time_in_force": "GTC",
                    //         "post_only": false,
                    //         "created_at": "2016-12-08T20:02:28.53864Z",
                    //         "fill_fees": "0.0000000000000000",
                    //         "filled_size": "0.00000000",
                    //         "executed_value": "0.0000000000000000",
                    //         "status": "pending",
                    //         "settled": false
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client_oid');
                    let method = undefined;
                    if (clientOrderId === undefined) {
                        method = 'privateDeleteOrdersId';
                        request['id'] = id;
                    } else {
                        method = 'privateDeleteOrdersClientClientOid';
                        request['client_oid'] = clientOrderId;
                        params = this.omit(params, [
                            'clientOrderId',
                            'client_oid'
                        ]);
                    }
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['product_id'] = market['symbol']; // the request will be more performant if you include it
                    }
                    return await this[method](this.extend(request, params));
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['product_id'] = market['symbol']; // the request will be more performant if you include it
                    }
                    return await this.privateDeleteOrders(this.extend(request, params));
                }
                async fetchPaymentMethods(params = {}) {
                    return await this.privateGetPaymentMethods(params);
                }
                async deposit(code, amount, address, params = {}) {
                    /**
         * @method
         * @name coinbasepro#deposit
         * @description Creates a new deposit address, as required by coinbasepro
         * @param {str} code Unified CCXT currency code (e.g. `"USDT"`)
         * @param {float} amount The amount of currency to send in the deposit (e.g. `20`)
         * @param {str} address Not used by coinbasepro
         * @param {dict} params Parameters specific to the exchange API endpoint (e.g. `{"network": "TRX"}`)
         * @returns a [transaction structure]{@link https://docs.ccxt.com/en/latest/manual.html#transaction-structure}
         */ await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'amount': amount
                    };
                    let method = 'privatePostDeposits';
                    if ('payment_method_id' in params) // deposit from a payment_method, like a bank account
                    method += 'PaymentMethod';
                    else if ('coinbase_account_id' in params) // deposit into Coinbase Pro account from a Coinbase account
                    method += 'CoinbaseAccount';
                    else // deposit methodotherwise we did not receive a supported deposit location
                    // relevant docs link for the Googlers
                    // https://docs.pro.coinbase.com/#deposits
                    throw new NotSupported(this.id + ' deposit() requires one of `coinbase_account_id` or `payment_method_id` extra params');
                    const response = await this[method](this.extend(request, params));
                    if (!response) throw new ExchangeError1(this.id + ' deposit() error: ' + this.json(response));
                    return {
                        'info': response,
                        'id': response['id']
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'amount': amount
                    };
                    let method = 'privatePostWithdrawals';
                    if ('payment_method_id' in params) method += 'PaymentMethod';
                    else if ('coinbase_account_id' in params) method += 'CoinbaseAccount';
                    else {
                        method += 'Crypto';
                        request['crypto_address'] = address;
                        if (tag !== undefined) request['destination_tag'] = tag;
                    }
                    const response = await this[method](this.extend(request, params));
                    if (!response) throw new ExchangeError1(this.id + ' withdraw() error: ' + this.json(response));
                    return this.parseTransaction(response, currency);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'transfer': 'transfer',
                        'match': 'trade',
                        'fee': 'fee',
                        'rebate': 'rebate',
                        'conversion': 'trade'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //  {
                    //      id: '12087495079',
                    //      amount: '-0.0100000000000000',
                    //      balance: '0.0645419900000000',
                    //      created_at: '2021-10-28T17:14:32.593168Z',
                    //      type: 'transfer',
                    //      details: {
                    //          from: '2f74edf7-1440-4586-86dc-ae58c5693691',
                    //          profile_transfer_id: '3ef093ad-2482-40d1-8ede-2f89cff5099e',
                    //          to: 'dda99503-4980-4b60-9549-0b770ee51336'
                    //      }
                    //  },
                    //  {
                    //     id: '11740725774',
                    //     amount: '-1.7565669701255000',
                    //     balance: '0.0016490047745000',
                    //     created_at: '2021-10-22T03:47:34.764122Z',
                    //     type: 'fee',
                    //     details: {
                    //         order_id: 'ad06abf4-95ab-432a-a1d8-059ef572e296',
                    //         product_id: 'ETH-DAI',
                    //         trade_id: '1740617'
                    //     }
                    //  }
                    const id = this.safeString(item, 'id');
                    let amountString = this.safeString(item, 'amount');
                    let direction = undefined;
                    const afterString = this.safeString(item, 'balance');
                    const beforeString = Precise.stringSub(afterString, amountString);
                    if (Precise.stringLt(amountString, '0')) {
                        direction = 'out';
                        amountString = Precise.stringAbs(amountString);
                    } else direction = 'in';
                    const amount = this.parseNumber(amountString);
                    const after = this.parseNumber(afterString);
                    const before = this.parseNumber(beforeString);
                    const timestamp = this.parse8601(this.safeValue(item, 'created_at'));
                    const type = this.parseLedgerEntryType(this.safeString(item, 'type'));
                    const code = this.safeCurrencyCode(undefined, currency);
                    const details = this.safeValue(item, 'details', {});
                    let account = undefined;
                    let referenceAccount = undefined;
                    let referenceId = undefined;
                    if (type === 'transfer') {
                        account = this.safeString(details, 'from');
                        referenceAccount = this.safeString(details, 'to');
                        referenceId = this.safeString(details, 'profile_transfer_id');
                    } else referenceId = this.safeString(details, 'order_id');
                    const status = 'ok';
                    return {
                        'id': id,
                        'currency': code,
                        'account': account,
                        'referenceAccount': referenceAccount,
                        'referenceId': referenceId,
                        'status': status,
                        'amount': amount,
                        'before': before,
                        'after': after,
                        'fee': undefined,
                        'direction': direction,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'type': type,
                        'info': item
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    // https://docs.cloud.coinbase.com/exchange/reference/exchangerestapi_getaccountledger
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchLedger() requires a code param');
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const currency = this.currency(code);
                    const accountsByCurrencyCode = this.indexBy(this.accounts, 'currency');
                    const account = this.safeValue(accountsByCurrencyCode, code);
                    if (account === undefined) throw new ExchangeError1(this.id + ' fetchLedger() could not find account id for ' + code);
                    const request = {
                        'id': account['id']
                    };
                    if (since !== undefined) request['start_date'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit; // default 100
                    const response = await this.privateGetAccountsIdLedger(this.extend(request, params));
                    for(let i = 0; i < response.length; i++)response[i]['currency'] = code;
                    return this.parseLedger(response, currency, since, limit);
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    let currency = undefined;
                    let id = this.safeString(params, 'id'); // account id
                    if (id === undefined) {
                        if (code !== undefined) {
                            currency = this.currency(code);
                            const accountsByCurrencyCode = this.indexBy(this.accounts, 'currency');
                            const account = this.safeValue(accountsByCurrencyCode, code);
                            if (account === undefined) throw new ExchangeError1(this.id + ' fetchTransactions() could not find account id for ' + code);
                            id = account['id'];
                        }
                    }
                    const request = {};
                    if (id !== undefined) request['id'] = id;
                    if (limit !== undefined) request['limit'] = limit;
                    let response = undefined;
                    if (id === undefined) {
                        response = await this.privateGetTransfers(this.extend(request, params));
                        for(let i = 0; i < response.length; i++){
                            const account_id = this.safeString(response[i], 'account_id');
                            const account = this.safeValue(this.accountsById, account_id);
                            const code = this.safeString(account, 'currency');
                            response[i]['currency'] = code;
                        }
                    } else {
                        response = await this.privateGetAccountsIdTransfers(this.extend(request, params));
                        for(let i = 0; i < response.length; i++)response[i]['currency'] = code;
                    }
                    return this.parseTransactions(response, currency, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    return this.fetchTransactions(code, since, limit, this.extend({
                        'type': 'deposit'
                    }, params));
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    return this.fetchTransactions(code, since, limit, this.extend({
                        'type': 'withdraw'
                    }, params));
                }
                parseTransactionStatus(transaction) {
                    const canceled = this.safeValue(transaction, 'canceled_at');
                    if (canceled) return 'canceled';
                    const processed = this.safeValue(transaction, 'processed_at');
                    const completed = this.safeValue(transaction, 'completed_at');
                    if (completed) return 'ok';
                    else if (processed && !completed) return 'failed';
                    else return 'pending';
                }
                parseTransaction(transaction, currency) {
                    const details = this.safeValue(transaction, 'details', {});
                    const id = this.safeString(transaction, 'id');
                    const txid = this.safeString(details, 'crypto_transaction_hash');
                    const timestamp = this.parse8601(this.safeString(transaction, 'created_at'));
                    const updated = this.parse8601(this.safeString(transaction, 'processed_at'));
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(transaction);
                    let amount = this.safeNumber(transaction, 'amount');
                    let type = this.safeString(transaction, 'type');
                    let address = this.safeString(details, 'crypto_address');
                    const tag = this.safeString(details, 'destination_tag');
                    address = this.safeString(transaction, 'crypto_address', address);
                    let fee = undefined;
                    if (type === 'withdraw') {
                        type = 'withdrawal';
                        address = this.safeString(details, 'sent_to_address', address);
                        const feeCost = this.safeNumber(details, 'fee');
                        if (feeCost !== undefined) {
                            if (amount !== undefined) amount -= feeCost;
                            fee = {
                                'cost': feeCost,
                                'currency': code
                            };
                        }
                    }
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    let accounts = this.safeValue(this.options, 'coinbaseAccounts');
                    if (accounts === undefined) {
                        accounts = await this.privateGetCoinbaseAccounts();
                        this.options['coinbaseAccounts'] = accounts; // cache it
                        this.options['coinbaseAccountsByCurrencyId'] = this.indexBy(accounts, 'currency');
                    }
                    const currencyId = currency['id'];
                    const account = this.safeValue(this.options['coinbaseAccountsByCurrencyId'], currencyId);
                    if (account === undefined) // eslint-disable-next-line quotes
                    throw new InvalidAddress(this.id + " fetchDepositAddress() could not find currency code " + code + " with id = " + currencyId + " in this.options['coinbaseAccountsByCurrencyId']");
                    const request = {
                        'id': account['id']
                    };
                    const response = await this.privatePostCoinbaseAccountsIdAddresses(this.extend(request, params));
                    const address = this.safeString(response, 'address');
                    const tag = this.safeString(response, 'destination_tag');
                    return {
                        'currency': code,
                        'address': this.checkAddress(address),
                        'tag': tag,
                        'info': response
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let request = '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (method === 'GET') {
                        if (Object.keys(query).length) request += '?' + this.urlencode(query);
                    }
                    const url = this.implodeHostname(this.urls['api'][api]) + request;
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        let payload = '';
                        if (method !== 'GET') {
                            if (Object.keys(query).length) {
                                body = this.json(query);
                                payload = body;
                            }
                        }
                        const what = nonce + method + request + payload;
                        let secret = undefined;
                        try {
                            secret = this.base64ToBinary(this.secret);
                        } catch (e) {
                            throw new AuthenticationError(this.id + ' sign() invalid base64 secret');
                        }
                        const signature = this.hmac(this.encode(what), secret, 'sha256', 'base64');
                        headers = {
                            'CB-ACCESS-KEY': this.apiKey,
                            'CB-ACCESS-SIGN': signature,
                            'CB-ACCESS-TIMESTAMP': nonce,
                            'CB-ACCESS-PASSPHRASE': this.password,
                            'Content-Type': 'application/json'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (code === 400 || code === 404) {
                        if (body[0] === '{') {
                            const message = this.safeString(response, 'message');
                            const feedback = this.id + ' ' + message;
                            this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                            throw new ExchangeError1(feedback); // unknown message
                        }
                        throw new ExchangeError1(this.id + ' ' + body);
                    }
                }
                async request(path, api = 'public', method = 'GET', params = {}, headers, body, config = {}, context = {}) {
                    const response = await this.fetch2(path, api, method, params, headers, body, config, context);
                    if (typeof response !== 'string') {
                        if ('message' in response) throw new ExchangeError1(this.id + ' ' + this.json(response));
                    }
                    return response;
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    65: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { BadSymbol: BadSymbol, ExchangeError: ExchangeError1, AuthenticationError: AuthenticationError } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class coincheck extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'coincheck',
                        'name': 'coincheck',
                        'countries': [
                            'JP',
                            'ID'
                        ],
                        'rateLimit': 1500,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87182088-1d6d6380-c2ec-11ea-9c64-8ab9f9b289f5.jpg',
                            'api': 'https://coincheck.com/api',
                            'www': 'https://coincheck.com',
                            'doc': 'https://coincheck.com/documents/exchange/api',
                            'fees': [
                                'https://coincheck.com/exchange/fee',
                                'https://coincheck.com/info/fee'
                            ]
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'exchange/orders/rate',
                                    'order_books',
                                    'rate/{pair}',
                                    'ticker',
                                    'trades'
                                ]
                            },
                            'private': {
                                'get': [
                                    'accounts',
                                    'accounts/balance',
                                    'accounts/leverage_balance',
                                    'bank_accounts',
                                    'deposit_money',
                                    'exchange/orders/opens',
                                    'exchange/orders/transactions',
                                    'exchange/orders/transactions_pagination',
                                    'exchange/leverage/positions',
                                    'lending/borrows/matches',
                                    'send_money',
                                    'withdraws'
                                ],
                                'post': [
                                    'bank_accounts',
                                    'deposit_money/{id}/fast',
                                    'exchange/orders',
                                    'exchange/transfers/to_leverage',
                                    'exchange/transfers/from_leverage',
                                    'lending/borrows',
                                    'lending/borrows/{id}/repay',
                                    'send_money',
                                    'withdraws'
                                ],
                                'delete': [
                                    'bank_accounts/{id}',
                                    'exchange/orders/{id}',
                                    'withdraws/{id}'
                                ]
                            }
                        },
                        'markets': {
                            'BTC/JPY': {
                                'id': 'btc_jpy',
                                'symbol': 'BTC/JPY',
                                'base': 'BTC',
                                'quote': 'JPY',
                                'baseId': 'btc',
                                'quoteId': 'jpy',
                                'type': 'spot',
                                'spot': true
                            },
                            // 'ETH/JPY': { 'id': 'eth_jpy', 'symbol': 'ETH/JPY', 'base': 'ETH', 'quote': 'JPY', 'baseId': 'eth', 'quoteId': 'jpy' },
                            'ETC/JPY': {
                                'id': 'etc_jpy',
                                'symbol': 'ETC/JPY',
                                'base': 'ETC',
                                'quote': 'JPY',
                                'baseId': 'etc',
                                'quoteId': 'jpy',
                                'type': 'spot',
                                'spot': true
                            },
                            // 'DAO/JPY': { 'id': 'dao_jpy', 'symbol': 'DAO/JPY', 'base': 'DAO', 'quote': 'JPY', 'baseId': 'dao', 'quoteId': 'jpy' },
                            // 'LSK/JPY': { 'id': 'lsk_jpy', 'symbol': 'LSK/JPY', 'base': 'LSK', 'quote': 'JPY', 'baseId': 'lsk', 'quoteId': 'jpy' },
                            'FCT/JPY': {
                                'id': 'fct_jpy',
                                'symbol': 'FCT/JPY',
                                'base': 'FCT',
                                'quote': 'JPY',
                                'baseId': 'fct',
                                'quoteId': 'jpy',
                                'type': 'spot',
                                'spot': true
                            },
                            'MONA/JPY': {
                                'id': 'mona_jpy',
                                'symbol': 'MONA/JPY',
                                'base': 'MONA',
                                'quote': 'JPY',
                                'baseId': 'mona',
                                'quoteId': 'jpy',
                                'type': 'spot',
                                'spot': true
                            },
                            // 'XMR/JPY': { 'id': 'xmr_jpy', 'symbol': 'XMR/JPY', 'base': 'XMR', 'quote': 'JPY', 'baseId': 'xmr', 'quoteId': 'jpy' },
                            // 'REP/JPY': { 'id': 'rep_jpy', 'symbol': 'REP/JPY', 'base': 'REP', 'quote': 'JPY', 'baseId': 'rep', 'quoteId': 'jpy' },
                            // 'XRP/JPY': { 'id': 'xrp_jpy', 'symbol': 'XRP/JPY', 'base': 'XRP', 'quote': 'JPY', 'baseId': 'xrp', 'quoteId': 'jpy' },
                            // 'ZEC/JPY': { 'id': 'zec_jpy', 'symbol': 'ZEC/JPY', 'base': 'ZEC', 'quote': 'JPY', 'baseId': 'zec', 'quoteId': 'jpy' },
                            // 'XEM/JPY': { 'id': 'xem_jpy', 'symbol': 'XEM/JPY', 'base': 'XEM', 'quote': 'JPY', 'baseId': 'xem', 'quoteId': 'jpy' },
                            // 'LTC/JPY': { 'id': 'ltc_jpy', 'symbol': 'LTC/JPY', 'base': 'LTC', 'quote': 'JPY', 'baseId': 'ltc', 'quoteId': 'jpy' },
                            // 'DASH/JPY': { 'id': 'dash_jpy', 'symbol': 'DASH/JPY', 'base': 'DASH', 'quote': 'JPY', 'baseId': 'dash', 'quoteId': 'jpy' },
                            // 'ETH/BTC': { 'id': 'eth_btc', 'symbol': 'ETH/BTC', 'base': 'ETH', 'quote': 'BTC', 'baseId': 'eth', 'quoteId': 'btc' },
                            'ETC/BTC': {
                                'id': 'etc_btc',
                                'symbol': 'ETC/BTC',
                                'base': 'ETC',
                                'quote': 'BTC',
                                'baseId': 'etc',
                                'quoteId': 'btc',
                                'type': 'spot',
                                'spot': true
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0'),
                                'taker': this.parseNumber('0')
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'disabled API Key': AuthenticationError,
                                'invalid authentication': AuthenticationError
                            },
                            'broad': {}
                        }
                    });
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const codes = Object.keys(this.currencies);
                    for(let i = 0; i < codes.length; i++){
                        const code = codes[i];
                        const currency = this.currency(code);
                        const currencyId = currency['id'];
                        if (currencyId in response) {
                            const account = this.account();
                            const reserved = currencyId + '_reserved';
                            account['free'] = this.safeString(response, currencyId);
                            account['used'] = this.safeString(response, reserved);
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountsBalance(params);
                    return this.parseBalance(response);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    // Only BTC/JPY is meaningful
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const response = await this.privateGetExchangeOrdersOpens(params);
                    const rawOrders = this.safeValue(response, 'orders', []);
                    const parsedOrders = this.parseOrders(rawOrders, market, since, limit);
                    const result = [];
                    for(let i = 0; i < parsedOrders.length; i++)result.push(this.extend(parsedOrders[i], {
                        'status': 'open'
                    }));
                    return result;
                }
                parseOrder(order, market) {
                    //
                    // fetchOpenOrders
                    //
                    //     {                        id:  202835,
                    //                      order_type: "buy",
                    //                            rate:  26890,
                    //                            pair: "btc_jpy",
                    //                  pending_amount: "0.5527",
                    //       pending_market_buy_amount:  null,
                    //                  stop_loss_rate:  null,
                    //                      created_at: "2015-01-10T05:55:38.000Z" }
                    //
                    // todo: add formats for fetchOrder, fetchClosedOrders here
                    //
                    const id = this.safeString(order, 'id');
                    const side = this.safeString(order, 'order_type');
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const amount = this.safeString(order, 'pending_amount');
                    const remaining = this.safeString(order, 'pending_amount');
                    const price = this.safeString(order, 'rate');
                    const status = undefined;
                    const marketId = this.safeString(order, 'pair');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'amount': amount,
                        'remaining': remaining,
                        'filled': undefined,
                        'side': side,
                        'type': undefined,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'status': status,
                        'symbol': symbol,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'fee': undefined,
                        'info': order,
                        'average': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetOrderBooks(this.extend(request, params));
                    return this.parseOrderBook(response, symbol);
                }
                parseTicker(ticker, market) {
                    //
                    // {
                    //     "last":4192632.0,
                    //     "bid":4192496.0,
                    //     "ask":4193749.0,
                    //     "high":4332000.0,
                    //     "low":4101047.0,
                    //     "volume":2313.43191762,
                    //     "timestamp":1643374115
                    // }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.safeTimestamp(ticker, 'timestamp');
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    if (symbol !== 'BTC/JPY') throw new BadSymbol(this.id + ' fetchTicker() supports BTC/JPY only');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const ticker = await this.publicGetTicker(this.extend(request, params));
                    //
                    // {
                    //     "last":4192632.0,
                    //     "bid":4192496.0,
                    //     "ask":4193749.0,
                    //     "high":4332000.0,
                    //     "low":4101047.0,
                    //     "volume":2313.43191762,
                    //     "timestamp":1643374115
                    // }
                    //
                    return this.parseTicker(ticker, market);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "id": "206849494",
                    //          "amount": "0.01",
                    //          "rate": "5598346.0",
                    //          "pair": "btc_jpy",
                    //          "order_type": "sell",
                    //          "created_at": "2021-12-08T14:10:33.000Z"
                    //      }
                    //
                    // fetchMyTrades (private) - example from docs
                    //
                    //      {
                    //          "id": 38,
                    //          "order_id": 49,
                    //          "created_at": "2015-11-18T07:02:21.000Z",
                    //          "funds": {
                    //              "btc": "0.1",
                    //              "jpy": "-4096.135"
                    //                  },
                    //           "pair": "btc_jpy",
                    //           "rate": "40900.0",
                    //           "fee_currency": "JPY",
                    //           "fee": "6.135",
                    //           "liquidity": "T",
                    //           "side": "buy"
                    //      }
                    //
                    const timestamp = this.parse8601(this.safeString(trade, 'created_at'));
                    const id = this.safeString(trade, 'id');
                    const priceString = this.safeString(trade, 'rate');
                    const marketId = this.safeString(trade, 'pair');
                    market = this.safeValue(this.markets_by_id, marketId, market);
                    let symbol = undefined;
                    let baseId = undefined;
                    let quoteId = undefined;
                    if (marketId !== undefined) {
                        if (marketId in this.markets_by_id) {
                            market = this.markets_by_id[marketId];
                            baseId = market['baseId'];
                            quoteId = market['quoteId'];
                            symbol = market['symbol'];
                        } else {
                            const ids = marketId.split('_');
                            baseId = ids[0];
                            quoteId = ids[1];
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote;
                        }
                    }
                    if (symbol === undefined) symbol = this.safeSymbol(undefined, market);
                    let takerOrMaker = undefined;
                    let amountString = undefined;
                    let costString = undefined;
                    let side = undefined;
                    let fee = undefined;
                    let orderId = undefined;
                    if ('liquidity' in trade) {
                        if (this.safeString(trade, 'liquidity') === 'T') takerOrMaker = 'taker';
                        else if (this.safeString(trade, 'liquidity') === 'M') takerOrMaker = 'maker';
                        const funds = this.safeValue(trade, 'funds', {});
                        amountString = this.safeString(funds, baseId);
                        costString = this.safeString(funds, quoteId);
                        fee = {
                            'currency': this.safeString(trade, 'fee_currency'),
                            'cost': this.safeString(trade, 'fee')
                        };
                        side = this.safeString(trade, 'side');
                        orderId = this.safeString(trade, 'order_id');
                    } else {
                        amountString = this.safeString(trade, 'amount');
                        side = this.safeString(trade, 'order_type');
                    }
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'order': orderId,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {};
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetExchangeOrdersTransactionsPagination(this.extend(request, params));
                    //
                    //      {
                    //          "success": true,
                    //          "transactions": [
                    //                              {
                    //                                  "id": 38,
                    //                                  "order_id": 49,
                    //                                  "created_at": "2015-11-18T07:02:21.000Z",
                    //                                  "funds": {
                    //                                      "btc": "0.1",
                    //                                      "jpy": "-4096.135"
                    //                                          },
                    //                                  "pair": "btc_jpy",
                    //                                  "rate": "40900.0",
                    //                                  "fee_currency": "JPY",
                    //                                  "fee": "6.135",
                    //                                  "liquidity": "T",
                    //                                  "side": "buy"
                    //                               },
                    //                          ]
                    //      }
                    //
                    const transactions = this.safeValue(response, 'transactions', []);
                    return this.parseTrades(transactions, market, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetTrades(this.extend(request, params));
                    //
                    //      {
                    //          "id": "206849494",
                    //          "amount": "0.01",
                    //          "rate": "5598346.0",
                    //          "pair": "btc_jpy",
                    //          "order_type": "sell",
                    //          "created_at": "2021-12-08T14:10:33.000Z"
                    //      }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccounts(params);
                    //
                    //     {
                    //         success: true,
                    //         id: '7487995',
                    //         email: 'some@email.com',
                    //         identity_status: 'identity_pending',
                    //         bitcoin_address: null,
                    //         lending_leverage: '4',
                    //         taker_fee: '0.0',
                    //         maker_fee: '0.0',
                    //         exchange_fees: {
                    //           btc_jpy: { taker_fee: '0.0', maker_fee: '0.0' },
                    //           etc_jpy: { taker_fee: '0.0', maker_fee: '0.0' },
                    //           fct_jpy: { taker_fee: '0.0', maker_fee: '0.0' },
                    //           mona_jpy: { taker_fee: '0.0', maker_fee: '0.0' },
                    //           plt_jpy: { taker_fee: '0.0', maker_fee: '0.0' }
                    //         }
                    //     }
                    //
                    const fees = this.safeValue(response, 'exchange_fees', {});
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        const fee = this.safeValue(fees, market['id'], {});
                        result[symbol] = {
                            'info': fee,
                            'symbol': symbol,
                            'maker': this.safeNumber(fee, 'maker_fee'),
                            'taker': this.safeNumber(fee, 'taker_fee'),
                            'percentage': true,
                            'tierBased': false
                        };
                    }
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'pair': this.marketId(symbol)
                    };
                    if (type === 'market') {
                        const order_type = type + '_' + side;
                        request['order_type'] = order_type;
                        const prefix = side === 'buy' ? order_type + '_' : '';
                        request[prefix + 'amount'] = amount;
                    } else {
                        request['order_type'] = side;
                        request['rate'] = price;
                        request['amount'] = amount;
                    }
                    const response = await this.privatePostExchangeOrders(this.extend(request, params));
                    const id = this.safeString(response, 'id');
                    return {
                        'info': response,
                        'id': id
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'id': id
                    };
                    return await this.privateDeleteExchangeOrdersId(this.extend(request, params));
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetDepositMoney(this.extend(request, params));
                    // {
                    //   "success": true,
                    //   "deposits": [
                    //     {
                    //       "id": 2,
                    //       "amount": "0.05",
                    //       "currency": "BTC",
                    //       "address": "13PhzoK8me3u5nHzzFD85qT9RqEWR9M4Ty",
                    //       "status": "confirmed",
                    //       "confirmed_at": "2015-06-13T08:29:18.000Z",
                    //       "created_at": "2015-06-13T08:22:18.000Z"
                    //     },
                    //     {
                    //       "id": 1,
                    //       "amount": "0.01",
                    //       "currency": "BTC",
                    //       "address": "13PhzoK8me3u5nHzzFD85qT9RqEWR9M4Ty",
                    //       "status": "received",
                    //       "confirmed_at": "2015-06-13T08:21:18.000Z",
                    //       "created_at": "2015-06-13T08:21:18.000Z"
                    //     }
                    //   ]
                    // }
                    const data = this.safeValue(response, 'deposits', []);
                    return this.parseTransactions(data, currency, since, limit, {
                        'type': 'deposit'
                    });
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const request = {};
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetWithdraws(this.extend(request, params));
                    //  {
                    //   "success": true,
                    //   "pagination": {
                    //     "limit": 25,
                    //     "order": "desc",
                    //     "starting_after": null,
                    //     "ending_before": null
                    //   },
                    //   "data": [
                    //     {
                    //       "id": 398,
                    //       "status": "finished",
                    //       "amount": "242742.0",
                    //       "currency": "JPY",
                    //       "created_at": "2014-12-04T15:00:00.000Z",
                    //       "bank_account_id": 243,
                    //       "fee": "400.0",
                    //       "is_fast": true
                    //     }
                    //   ]
                    // }
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, currency, since, limit, {
                        'type': 'withdrawal'
                    });
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        // withdrawals
                        'pending': 'pending',
                        'processing': 'pending',
                        'finished': 'ok',
                        'canceled': 'canceled',
                        // deposits
                        'confirmed': 'pending',
                        'received': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    // {
                    //       "id": 2,
                    //       "amount": "0.05",
                    //       "currency": "BTC",
                    //       "address": "13PhzoK8me3u5nHzzFD85qT9RqEWR9M4Ty",
                    //       "status": "confirmed",
                    //       "confirmed_at": "2015-06-13T08:29:18.000Z",
                    //       "created_at": "2015-06-13T08:22:18.000Z"
                    //  }
                    //
                    // fetchWithdrawals
                    //
                    //  {
                    //       "id": 398,
                    //       "status": "finished",
                    //       "amount": "242742.0",
                    //       "currency": "JPY",
                    //       "created_at": "2014-12-04T15:00:00.000Z",
                    //       "bank_account_id": 243,
                    //       "fee": "400.0",
                    //       "is_fast": true
                    //  }
                    //
                    const id = this.safeString(transaction, 'id');
                    const timestamp = this.parse8601(this.safeString(transaction, 'created_at'));
                    const address = this.safeString(transaction, 'address');
                    const amount = this.safeNumber(transaction, 'amount');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const updated = this.parse8601(this.safeString(transaction, 'confirmed_at'));
                    let fee = undefined;
                    const feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': undefined,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'internal': undefined,
                        'fee': fee
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        let queryString = '';
                        if (method === 'GET') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(this.keysort(query));
                        } else if (Object.keys(query).length) {
                            body = this.urlencode(this.keysort(query));
                            queryString = body;
                        }
                        const auth = nonce + url + queryString;
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'ACCESS-KEY': this.apiKey,
                            'ACCESS-NONCE': nonce,
                            'ACCESS-SIGNATURE': this.hmac(this.encode(auth), this.encode(this.secret))
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    //     {"success":false,"error":"disabled API Key"}'
                    //     {"success":false,"error":"invalid authentication"}
                    //
                    const success = this.safeValue(response, 'success', true);
                    if (!success) {
                        const error = this.safeString(response, 'error');
                        const feedback = this.id + ' ' + this.json(response);
                        this.throwExactlyMatchedException(this.exceptions['exact'], error, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                        throw new ExchangeError1(this.id + ' ' + this.json(response));
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    66: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, BadRequest: BadRequest, BadSymbol: BadSymbol, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, AuthenticationError: AuthenticationError, PermissionDenied: PermissionDenied, ExchangeNotAvailable: ExchangeNotAvailable, RequestTimeout: RequestTimeout } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class coinex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'coinex',
                        'name': 'CoinEx',
                        'version': 'v1',
                        'countries': [
                            'CN'
                        ],
                        'rateLimit': 50,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': true,
                            'future': false,
                            'option': false,
                            'addMargin': true,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': true,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': true,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': undefined,
                            'fetchLeverageTiers': undefined,
                            'fetchMarketLeverageTiers': undefined,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPosition': true,
                            'fetchPositions': true,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': true,
                            'fetchTransfers': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': true,
                            'setLeverage': true,
                            'setMarginMode': true,
                            'setPositionMode': false,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1min',
                            '3m': '3min',
                            '5m': '5min',
                            '15m': '15min',
                            '30m': '30min',
                            '1h': '1hour',
                            '2h': '2hour',
                            '4h': '4hour',
                            '6h': '6hour',
                            '12h': '12hour',
                            '1d': '1day',
                            '3d': '3day',
                            '1w': '1week'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87182089-1e05fa00-c2ec-11ea-8da9-cc73b45abbbc.jpg',
                            'api': {
                                'public': 'https://api.coinex.com',
                                'private': 'https://api.coinex.com',
                                'perpetualPublic': 'https://api.coinex.com/perpetual',
                                'perpetualPrivate': 'https://api.coinex.com/perpetual'
                            },
                            'www': 'https://www.coinex.com',
                            'doc': 'https://github.com/coinexcom/coinex_exchange_api/wiki',
                            'fees': 'https://www.coinex.com/fees',
                            'referral': 'https://www.coinex.com/register?refer_code=yw5fz'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'amm/market': 1,
                                    'common/currency/rate': 1,
                                    'common/asset/config': 1,
                                    'common/maintain/info': 1,
                                    'common/temp-maintain/info': 1,
                                    'margin/market': 1,
                                    'market/info': 1,
                                    'market/list': 1,
                                    'market/ticker': 1,
                                    'market/ticker/all': 1,
                                    'market/depth': 1,
                                    'market/deals': 1,
                                    'market/kline': 1,
                                    'market/detail': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'account/amm/balance': 1,
                                    'account/investment/balance': 1,
                                    'account/balance/history': 1,
                                    'account/market/fee': 1,
                                    'balance/coin/deposit': 1,
                                    'balance/coin/withdraw': 1,
                                    'balance/info': 1,
                                    'balance/deposit/address/{coin_type}': 1,
                                    'contract/transfer/history': 1,
                                    'credit/info': 1,
                                    'credit/balance': 1,
                                    'investment/transfer/history': 1,
                                    'margin/account': 1,
                                    'margin/config': 1,
                                    'margin/loan/history': 1,
                                    'margin/transfer/history': 1,
                                    'order': 1,
                                    'order/deals': 1,
                                    'order/finished': 1,
                                    'order/pending': 1,
                                    'order/status': 1,
                                    'order/status/batch': 1,
                                    'order/user/deals': 1,
                                    'order/stop/finished': 1,
                                    'order/stop/pending': 1,
                                    'order/user/trade/fee': 1,
                                    'order/market/trade/info': 1,
                                    'sub_account/balance': 1,
                                    'sub_account/transfer/history': 1,
                                    'sub_account/auth/api/{user_auth_id}': 1
                                },
                                'post': {
                                    'balance/coin/withdraw': 1,
                                    'contract/balance/transfer': 1,
                                    'margin/flat': 1,
                                    'margin/loan': 1,
                                    'margin/transfer': 1,
                                    'order/limit/batch': 1,
                                    'order/ioc': 1,
                                    'order/limit': 1,
                                    'order/market': 1,
                                    'order/stop/limit': 1,
                                    'order/stop/market': 1,
                                    'sub_account/transfer': 1,
                                    'sub_account/register': 1,
                                    'sub_account/unfrozen': 1,
                                    'sub_account/frozen': 1,
                                    'sub_account/auth/api': 1
                                },
                                'put': {
                                    'balance/deposit/address/{coin_type}': 1,
                                    'sub_account/auth/api/{user_auth_id}': 1,
                                    'v1/account/settings': 1
                                },
                                'delete': {
                                    'balance/coin/withdraw': 1,
                                    'order/pending/batch': 1,
                                    'order/pending': 1,
                                    'order/stop/pending': 1,
                                    'order/stop/pending/{id}': 1,
                                    'sub_account/auth/api/{user_auth_id}': 1
                                }
                            },
                            'perpetualPublic': {
                                'get': {
                                    'ping': 1,
                                    'time': 1,
                                    'market/list': 1,
                                    'market/limit_config': 1,
                                    'market/ticker': 1,
                                    'market/ticker/all': 1,
                                    'market/depth': 1,
                                    'market/deals': 1,
                                    'market/funding_history': 1,
                                    'market/user_deals': 1,
                                    'market/kline': 1
                                }
                            },
                            'perpetualPrivate': {
                                'get': {
                                    'asset/query': 1,
                                    'order/pending': 1,
                                    'order/finished': 1,
                                    'order/stop_pending': 1,
                                    'order/status': 1,
                                    'order/stop_status': 1,
                                    'position/pending': 1,
                                    'position/funding': 1
                                },
                                'post': {
                                    'market/adjust_leverage': 1,
                                    'market/position_expect': 1,
                                    'order/put_limit': 1,
                                    'order/put_market': 1,
                                    'order/put_stop_limit': 1,
                                    'order/put_stop_market': 1,
                                    'order/cancel': 1,
                                    'order/cancel_all': 1,
                                    'order/cancel_stop': 1,
                                    'order/cancel_stop_all': 1,
                                    'order/close_limit': 1,
                                    'order/close_market': 1,
                                    'position/adjust_margin': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': 0.001,
                                'taker': 0.001
                            },
                            'funding': {
                                'withdraw': {
                                    'BCH': 0.0,
                                    'BTC': 0.001,
                                    'LTC': 0.001,
                                    'ETH': 0.001,
                                    'ZEC': 0.0001,
                                    'DASH': 0.0001
                                }
                            }
                        },
                        'limits': {
                            'amount': {
                                'min': 0.001,
                                'max': undefined
                            }
                        },
                        'precision': {
                            'amount': 8,
                            'price': 8
                        },
                        'options': {
                            'createMarketBuyOrderRequiresPrice': true,
                            'defaultType': 'spot',
                            'defaultSubType': 'linear',
                            'defaultMarginMode': 'isolated'
                        },
                        'commonCurrencies': {
                            'ACM': 'Actinium'
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    let result = [];
                    const [type, query] = this.handleMarketTypeAndParams('fetchMarkets', undefined, params);
                    if (type === 'spot' || type === 'margin') result = await this.fetchSpotMarkets(query);
                    else if (type === 'swap') result = await this.fetchContractMarkets(query);
                    else throw new ExchangeError1(this.id + " does not support the '" + type + "' market type, set exchange.options['defaultType'] to 'spot', 'margin' or 'swap'");
                    return result;
                }
                async fetchSpotMarkets(params) {
                    const response = await this.publicGetMarketInfo(params);
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "WAVESBTC": {
                    //                 "name": "WAVESBTC",
                    //                 "min_amount": "1",
                    //                 "maker_fee_rate": "0.001",
                    //                 "taker_fee_rate": "0.001",
                    //                 "pricing_name": "BTC",
                    //                 "pricing_decimal": 8,
                    //                 "trading_name": "WAVES",
                    //                 "trading_decimal": 8
                    //             }
                    //         }
                    //     }
                    //
                    const markets = this.safeValue(response, 'data', {});
                    const result = [];
                    const keys = Object.keys(markets);
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        const market = markets[key];
                        const id = this.safeString(market, 'name');
                        const tradingName = this.safeString(market, 'trading_name');
                        const baseId = tradingName;
                        const quoteId = this.safeString(market, 'pricing_name');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        let symbol = base + '/' + quote;
                        if (tradingName === id) symbol = id;
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.safeNumber(market, 'taker_fee_rate'),
                            'maker': this.safeNumber(market, 'maker_fee_rate'),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'trading_decimal'),
                                'price': this.safeInteger(market, 'pricing_decimal')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min_amount'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchContractMarkets(params) {
                    const response = await this.perpetualPublicGetMarketList(params);
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "name": "BTCUSD",
                    //                 "type": 2, // 1: USDT-M Contracts, 2: Coin-M Contracts
                    //                 "leverages": ["3", "5", "8", "10", "15", "20", "30", "50", "100"],
                    //                 "stock": "BTC",
                    //                 "money": "USD",
                    //                 "fee_prec": 5,
                    //                 "stock_prec": 8,
                    //                 "money_prec": 1,
                    //                 "amount_prec": 0,
                    //                 "amount_min": "10",
                    //                 "multiplier": "1",
                    //                 "tick_size": "0.1", // Min. Price Increment
                    //                 "available": true
                    //             },
                    //         ],
                    //         "message": "OK"
                    //     }
                    //
                    const markets = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const entry = markets[i];
                        const fees = this.fees;
                        const leverages = this.safeValue(entry, 'leverages', []);
                        const subType = this.safeInteger(entry, 'type');
                        const linear = subType === 1 ? true : false;
                        const inverse = subType === 2 ? true : false;
                        const id = this.safeString(entry, 'name');
                        const baseId = this.safeString(entry, 'stock');
                        const quoteId = this.safeString(entry, 'money');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const settleId = subType === 1 ? 'USDT' : baseId;
                        const settle = this.safeCurrencyCode(settleId);
                        const symbol = base + '/' + quote + ':' + settle;
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': 'swap',
                            'spot': false,
                            'margin': false,
                            'swap': true,
                            'future': false,
                            'option': false,
                            'active': this.safeString(entry, 'available'),
                            'contract': true,
                            'linear': linear,
                            'inverse': inverse,
                            'taker': fees['trading']['taker'],
                            'maker': fees['trading']['maker'],
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(entry, 'stock_prec'),
                                'price': this.safeInteger(entry, 'money_prec')
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.safeString(leverages, 0),
                                    'max': this.safeString(leverages, leverages.length - 1)
                                },
                                'amount': {
                                    'min': this.safeString(entry, 'amount_min'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': entry
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    // Spot fetchTicker, fetchTickers
                    //
                    //     {
                    //         "vol": "293.19415130",
                    //         "low": "38200.00",
                    //         "open": "39514.99",
                    //         "high": "39530.00",
                    //         "last": "38649.57",
                    //         "buy": "38640.20",
                    //         "buy_amount": "0.22800000",
                    //         "sell": "38640.21",
                    //         "sell_amount": "0.02828439"
                    //     }
                    //
                    // Swap fetchTicker, fetchTickers
                    //
                    //     {
                    //         "vol": "7714.2175",
                    //         "low": "38200.00",
                    //         "open": "39569.23",
                    //         "high": "39569.23",
                    //         "last": "38681.37",
                    //         "buy": "38681.36",
                    //         "period": 86400,
                    //         "funding_time": 462,
                    //         "position_amount": "296.7552",
                    //         "funding_rate_last": "0.00009395",
                    //         "funding_rate_next": "0.00000649",
                    //         "funding_rate_predict": "-0.00007176",
                    //         "insurance": "16464465.09431942163278132918",
                    //         "sign_price": "38681.93",
                    //         "index_price": "38681.69500000",
                    //         "sell_total": "16.6039",
                    //         "buy_total": "19.8481",
                    //         "buy_amount": "4.6315",
                    //         "sell": "38681.37",
                    //         "sell_amount": "11.4044"
                    //     }
                    //
                    const timestamp = this.safeInteger(ticker, 'date');
                    const symbol = this.safeSymbol(undefined, market);
                    ticker = this.safeValue(ticker, 'ticker', {});
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString2(ticker, 'vol', 'volume'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const method = market['swap'] ? 'perpetualPublicGetMarketTicker' : 'publicGetMarketTicker';
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "date": 1651306913414,
                    //             "ticker": {
                    //                 "vol": "293.19415130",
                    //                 "low": "38200.00",
                    //                 "open": "39514.99",
                    //                 "high": "39530.00",
                    //                 "last": "38649.57",
                    //                 "buy": "38640.20",
                    //                 "buy_amount": "0.22800000",
                    //                 "sell": "38640.21",
                    //                 "sell_amount": "0.02828439"
                    //             }
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "date": 1651306641500,
                    //             "ticker": {
                    //                 "vol": "7714.2175",
                    //                 "low": "38200.00",
                    //                 "open": "39569.23",
                    //                 "high": "39569.23",
                    //                 "last": "38681.37",
                    //                 "buy": "38681.36",
                    //                 "period": 86400,
                    //                 "funding_time": 462,
                    //                 "position_amount": "296.7552",
                    //                 "funding_rate_last": "0.00009395",
                    //                 "funding_rate_next": "0.00000649",
                    //                 "funding_rate_predict": "-0.00007176",
                    //                 "insurance": "16464465.09431942163278132918",
                    //                 "sign_price": "38681.93",
                    //                 "index_price": "38681.69500000",
                    //                 "sell_total": "16.6039",
                    //                 "buy_total": "19.8481",
                    //                 "buy_amount": "4.6315",
                    //                 "sell": "38681.37",
                    //                 "sell_amount": "11.4044"
                    //             }
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    return this.parseTicker(response['data'], market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTickers', undefined, params);
                    const method = marketType === 'swap' ? 'perpetualPublicGetMarketTickerAll' : 'publicGetMarketTickerAll';
                    const response = await this[method](query);
                    //
                    // Spot
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "date": 1651519857284,
                    //             "ticker": {
                    //                 "PSPUSDT": {
                    //                     "vol": "127131.55227034",
                    //                     "low": "0.0669",
                    //                     "open": "0.0688",
                    //                     "high": "0.0747",
                    //                     "last": "0.0685",
                    //                     "buy": "0.0676",
                    //                     "buy_amount": "702.70117866",
                    //                     "sell": "0.0690",
                    //                     "sell_amount": "686.76861562"
                    //                 },
                    //             }
                    //         },
                    //         "message": "Ok"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "date": 1651520268644,
                    //             "ticker": {
                    //                 "KAVAUSDT": {
                    //                     "vol": "834924",
                    //                     "low": "3.9418",
                    //                     "open": "4.1834",
                    //                     "high": "4.4328",
                    //                     "last": "4.0516",
                    //                     "buy": "4.0443",
                    //                     "period": 86400,
                    //                     "funding_time": 262,
                    //                     "position_amount": "16111",
                    //                     "funding_rate_last": "-0.00069514",
                    //                     "funding_rate_next": "-0.00061009",
                    //                     "funding_rate_predict": "-0.00055812",
                    //                     "insurance": "16532425.53026084124483989548",
                    //                     "sign_price": "4.0516",
                    //                     "index_price": "4.0530",
                    //                     "sell_total": "59446",
                    //                     "buy_total": "62423",
                    //                     "buy_amount": "959",
                    //                     "sell": "4.0466",
                    //                     "sell_amount": "141"
                    //                 },
                    //             }
                    //         },
                    //         "message": "Ok"
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const timestamp = this.safeInteger(data, 'date');
                    const tickers = this.safeValue(data, 'ticker');
                    const marketIds = Object.keys(tickers);
                    const result = {};
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const market = this.safeMarket(marketId);
                        const symbol = market['symbol'];
                        const ticker = this.parseTicker({
                            'date': timestamp,
                            'ticker': tickers[marketId]
                        }, market);
                        ticker['symbol'] = symbol;
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit = 20, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrderBook() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (limit === undefined) limit = 20; // default
                    const request = {
                        'market': this.marketId(symbol),
                        'merge': '0.0000000001',
                        'limit': limit.toString()
                    };
                    const method = market['swap'] ? 'perpetualPublicGetMarketDepth' : 'publicGetMarketDepth';
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "asks": [
                    //                 ["41056.33", "0.31727613"],
                    //                 ["41056.34", "1.05657294"],
                    //                 ["41056.35", "0.02346648"]
                    //             ],
                    //             "bids": [
                    //                 ["41050.61", "0.40618608"],
                    //                 ["41046.98", "0.13800000"],
                    //                 ["41046.56", "0.22579234"]
                    //             ],
                    //             "last": "41050.61",
                    //             "time": 1650573220346
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "asks": [
                    //                 ["40620.90", "0.0384"],
                    //                 ["40625.50", "0.0219"],
                    //                 ["40625.90", "0.3506"]
                    //             ],
                    //             "bids": [
                    //                 ["40620.89", "19.6861"],
                    //                 ["40620.80", "0.0012"],
                    //                 ["40619.87", "0.0365"]
                    //             ],
                    //             "last": "40620.89",
                    //             "time": 1650587672406,
                    //             "sign_price": "40619.32",
                    //             "index_price": "40609.93"
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    const result = this.safeValue(response, 'data', {});
                    const timestamp = this.safeInteger(result, 'time');
                    return this.parseOrderBook(result, symbol, timestamp);
                }
                parseTrade(trade, market) {
                    //
                    // Spot and Swap fetchTrades (public)
                    //
                    //      {
                    //          "id":  2611511379,
                    //          "type": "buy",
                    //          "price": "192.63",
                    //          "amount": "0.02266931",
                    //          "date":  1638990110,
                    //          "date_ms":  1638990110518
                    //      },
                    //
                    // Spot fetchMyTrades (private)
                    //
                    //      {
                    //          "id": 2611520950,
                    //          "order_id": 63286573298,
                    //          "account_id": 0,
                    //          "create_time": 1638990636,
                    //          "type": "sell",
                    //          "role": "taker",
                    //          "price": "192.29",
                    //          "amount": "0.098",
                    //          "fee": "0.03768884",
                    //          "fee_asset": "USDT",
                    //          "market": "AAVEUSDT",
                    //          "deal_money": "18.84442"
                    //      }
                    //
                    // Swap fetchMyTrades (private)
                    //
                    //     {
                    //         "amount": "0.0012",
                    //         "deal_fee": "0.0237528",
                    //         "deal_insurance": "0",
                    //         "deal_margin": "15.8352",
                    //         "deal_order_id": 17797031903,
                    //         "deal_profit": "0",
                    //         "deal_stock": "47.5056",
                    //         "deal_type": 1,
                    //         "deal_user_id": 2969195,
                    //         "fee_asset": "",
                    //         "fee_discount": "0",
                    //         "fee_price": "0",
                    //         "fee_rate": "0.0005",
                    //         "fee_real_rate": "0.0005",
                    //         "id": 379044296,
                    //         "leverage": "3",
                    //         "margin_amount": "15.8352",
                    //         "market": "BTCUSDT",
                    //         "open_price": "39588",
                    //         "order_id": 17797092987,
                    //         "position_amount": "0.0012",
                    //         "position_id": 62052321,
                    //         "position_type": 1,
                    //         "price": "39588",
                    //         "role": 2,
                    //         "side": 2,
                    //         "time": 1650675936.016103,
                    //         "user_id": 3620173
                    //     }
                    //
                    let timestamp = this.safeTimestamp2(trade, 'create_time', 'time');
                    if (timestamp === undefined) timestamp = this.safeInteger(trade, 'date_ms');
                    const tradeId = this.safeString(trade, 'id');
                    const orderId = this.safeString(trade, 'order_id');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const marketId = this.safeString(trade, 'market');
                    const symbol = this.safeSymbol(marketId, market);
                    const costString = this.safeString(trade, 'deal_money');
                    let fee = undefined;
                    const feeCostString = this.safeString2(trade, 'fee', 'deal_fee');
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'fee_asset');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    let takerOrMaker = this.safeString(trade, 'role');
                    if (takerOrMaker === '1') takerOrMaker = 'maker';
                    else if (takerOrMaker === '2') takerOrMaker = 'taker';
                    let side = undefined;
                    if (market['type'] === 'swap') {
                        side = this.safeInteger(trade, 'side');
                        if (side === 1) side = 'sell';
                        else if (side === 2) side = 'buy';
                        if (side === undefined) side = this.safeString(trade, 'type');
                    } else side = this.safeString(trade, 'type');
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': tradeId,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const method = market['swap'] ? 'perpetualPublicGetMarketDeals' : 'publicGetMarketDeals';
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot and Swap
                    //
                    //      {
                    //          "code":    0,
                    //          "data": [
                    //              {
                    //                  "id":  2611511379,
                    //                  "type": "buy",
                    //                  "price": "192.63",
                    //                  "amount": "0.02266931",
                    //                  "date":  1638990110,
                    //                  "date_ms":  1638990110518
                    //                  },
                    //              ],
                    //          "message": "OK"
                    //      }
                    //
                    return this.parseTrades(response['data'], market, since, limit);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.publicGetMarketDetail(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //           "name": "BTCUSDC",
                    //           "min_amount": "0.0005",
                    //           "maker_fee_rate": "0.002",
                    //           "taker_fee_rate": "0.002",
                    //           "pricing_name": "USDC",
                    //           "pricing_decimal": 2,
                    //           "trading_name": "BTC",
                    //           "trading_decimal": 8
                    //         },
                    //         "message": "OK"
                    //      }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTradingFee(data);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetMarketInfo(params);
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "WAVESBTC": {
                    //                 "name": "WAVESBTC",
                    //                 "min_amount": "1",
                    //                 "maker_fee_rate": "0.001",
                    //                 "taker_fee_rate": "0.001",
                    //                 "pricing_name": "BTC",
                    //                 "pricing_decimal": 8,
                    //                 "trading_name": "WAVES",
                    //                 "trading_decimal": 8
                    //             }
                    //             ...
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        const fee = this.safeValue(data, market['id'], {});
                        result[symbol] = this.parseTradingFee(fee, market);
                    }
                    return result;
                }
                parseTradingFee(fee, market) {
                    const marketId = this.safeValue(fee, 'name');
                    const symbol = this.safeSymbol(marketId, market);
                    return {
                        'info': fee,
                        'symbol': symbol,
                        'maker': this.safeNumber(fee, 'maker_fee_rate'),
                        'taker': this.safeNumber(fee, 'taker_fee_rate'),
                        'percentage': true,
                        'tierBased': true
                    };
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1591484400,
                    //         "0.02505349",
                    //         "0.02506988",
                    //         "0.02507000",
                    //         "0.02505304",
                    //         "343.19716223",
                    //         "8.6021323866383196",
                    //         "ETHBTC"
                    //     ]
                    //
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '5m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'type': this.timeframes[timeframe]
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const method = market['swap'] ? 'perpetualPublicGetMarketKline' : 'publicGetMarketKline';
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             [1591484400, "0.02505349", "0.02506988", "0.02507000", "0.02505304", "343.19716223", "8.6021323866383196", "ETHBTC"],
                    //             [1591484700, "0.02506990", "0.02508109", "0.02508109", "0.02506979", "91.59841581", "2.2972047780447000", "ETHBTC"],
                    //             [1591485000, "0.02508106", "0.02507996", "0.02508106", "0.02507500", "65.15307697", "1.6340597822306000", "ETHBTC"],
                    //         ],
                    //         "message": "OK"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             [1650569400, "41524.64", "41489.31", "41564.61", "41480.58", "29.7060", "1233907.099562"],
                    //             [1650569700, "41489.31", "41438.29", "41489.31", "41391.87", "42.4115", "1756154.189061"],
                    //             [1650570000, "41438.29", "41482.21", "41485.05", "41427.31", "22.2892", "924000.317861"]
                    //         ],
                    //         "message": "OK"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async fetchMarginBalance(params = {}) {
                    await this.loadMarkets();
                    const symbol = this.safeString(params, 'symbol');
                    let marketId = this.safeString(params, 'market');
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        marketId = market['id'];
                    } else if (marketId === undefined) throw new ArgumentsRequired1(this.id + ' fetchMarginBalance() fetching a margin account requires a market parameter or a symbol parameter');
                    params = this.omit(params, [
                        'symbol',
                        'market'
                    ]);
                    const request = {
                        'market': marketId
                    };
                    const response = await this.privateGetMarginAccount(this.extend(request, params));
                    //
                    //      {
                    //          "code":    0,
                    //           "data": {
                    //              "account_id":    126,
                    //              "leverage":    3,
                    //              "market_type":   "AAVEUSDT",
                    //              "sell_asset_type":   "AAVE",
                    //              "buy_asset_type":   "USDT",
                    //              "balance": {
                    //                  "sell_type": "0.3",     // borrowed
                    //                  "buy_type": "30"
                    //                  },
                    //              "frozen": {
                    //                  "sell_type": "0",
                    //                  "buy_type": "0"
                    //                  },
                    //              "loan": {
                    //                  "sell_type": "0.3", // loan
                    //                  "buy_type": "0"
                    //                  },
                    //              "interest": {
                    //                  "sell_type": "0.0000125",
                    //                  "buy_type": "0"
                    //                  },
                    //              "can_transfer": {
                    //                  "sell_type": "0.02500646",
                    //                  "buy_type": "4.28635738"
                    //                  },
                    //              "warn_rate":   "",
                    //              "liquidation_price":   ""
                    //              },
                    //          "message": "Success"
                    //      }
                    //
                    const result = {
                        'info': response
                    };
                    const data = this.safeValue(response, 'data', {});
                    const free = this.safeValue(data, 'can_transfer', {});
                    const total = this.safeValue(data, 'balance', {});
                    //
                    const sellAccount = this.account();
                    const sellCurrencyId = this.safeString(data, 'sell_asset_type');
                    const sellCurrencyCode = this.safeCurrencyCode(sellCurrencyId);
                    sellAccount['free'] = this.safeString(free, 'sell_type');
                    sellAccount['total'] = this.safeString(total, 'sell_type');
                    result[sellCurrencyCode] = sellAccount;
                    //
                    const buyAccount = this.account();
                    const buyCurrencyId = this.safeString(data, 'buy_asset_type');
                    const buyCurrencyCode = this.safeCurrencyCode(buyCurrencyId);
                    buyAccount['free'] = this.safeString(free, 'buy_type');
                    buyAccount['total'] = this.safeString(total, 'buy_type');
                    result[buyCurrencyCode] = buyAccount;
                    //
                    return this.safeBalance(result);
                }
                async fetchSpotBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalanceInfo(params);
                    //
                    //     {
                    //       "code": 0,
                    //       "data": {
                    //         "BCH": {                     # BCH account
                    //           "available": "13.60109",   # Available BCH
                    //           "frozen": "0.00000"        # Frozen BCH
                    //         },
                    //         "BTC": {                     # BTC account
                    //           "available": "32590.16",   # Available BTC
                    //           "frozen": "7000.00"        # Frozen BTC
                    //         },
                    //         "ETH": {                     # ETH account
                    //           "available": "5.06000",    # Available ETH
                    //           "frozen": "0.00000"        # Frozen ETH
                    //         }
                    //       },
                    //       "message": "Ok"
                    //     }
                    //
                    const result = {
                        'info': response
                    };
                    const balances = this.safeValue(response, 'data', {});
                    const currencyIds = Object.keys(balances);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const balance = this.safeValue(balances, currencyId, {});
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'frozen');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchSwapBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.perpetualPrivateGetAssetQuery(params);
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "USDT": {
                    //                 "available": "37.24817690383456000000",
                    //                 "balance_total": "37.24817690383456000000",
                    //                 "frozen": "0.00000000000000000000",
                    //                 "margin": "0.00000000000000000000",
                    //                 "profit_unreal": "0.00000000000000000000",
                    //                 "transfer": "37.24817690383456000000"
                    //             }
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    const result = {
                        'info': response
                    };
                    const balances = this.safeValue(response, 'data', {});
                    const currencyIds = Object.keys(balances);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const balance = this.safeValue(balances, currencyId, {});
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'frozen');
                        account['total'] = this.safeString(balance, 'balance_total');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    const accountType = this.safeString(params, 'type', 'main');
                    params = this.omit(params, 'type');
                    if (accountType === 'margin') return await this.fetchMarginBalance(params);
                    else if (accountType === 'swap') return await this.fetchSwapBalance(params);
                    else return await this.fetchSpotBalance(params);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'not_deal': 'open',
                        'part_deal': 'open',
                        'done': 'closed',
                        'cancel': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // fetchOrder
                    //
                    //     {
                    //         "amount": "0.1",
                    //         "asset_fee": "0.22736197736197736197",
                    //         "avg_price": "196.85000000000000000000",
                    //         "create_time": 1537270135,
                    //         "deal_amount": "0.1",
                    //         "deal_fee": "0",
                    //         "deal_money": "19.685",
                    //         "fee_asset": "CET",
                    //         "fee_discount": "0.5",
                    //         "id": 1788259447,
                    //         "left": "0",
                    //         "maker_fee_rate": "0",
                    //         "market": "ETHUSDT",
                    //         "order_type": "limit",
                    //         "price": "170.00000000",
                    //         "status": "done",
                    //         "taker_fee_rate": "0.0005",
                    //         "type": "sell",
                    //     }
                    //
                    // Spot createOrder, cancelOrder, fetchOrder
                    //
                    //      {
                    //          "amount":"1.5",
                    //          "asset_fee":"0",
                    //          "avg_price":"0.14208538",
                    //          "client_id":"",
                    //          "create_time":1650993819,
                    //          "deal_amount":"10.55703267",
                    //          "deal_fee":"0.0029999999971787292",
                    //          "deal_money":"1.4999999985893646",
                    //          "fee_asset":null,
                    //          "fee_discount":"1",
                    //          "finished_time":null,
                    //          "id":74556296907,
                    //          "left":"0.0000000014106354",
                    //          "maker_fee_rate":"0",
                    //          "market":"DOGEUSDT",
                    //          "money_fee":"0.0029999999971787292",
                    //          "order_type":"market",
                    //          "price":"0",
                    //          "status":"done",
                    //          "stock_fee":"0",
                    //          "taker_fee_rate":"0.002",
                    //          "type":"buy"
                    //      }
                    //
                    // Swap createOrder, cancelOrder, fetchOrder
                    //
                    //     {
                    //         "amount": "0.0005",
                    //         "client_id": "",
                    //         "create_time": 1651004578.618224,
                    //         "deal_asset_fee": "0.00000000000000000000",
                    //         "deal_fee": "0.00000000000000000000",
                    //         "deal_profit": "0.00000000000000000000",
                    //         "deal_stock": "0.00000000000000000000",
                    //         "effect_type": 1,
                    //         "fee_asset": "",
                    //         "fee_discount": "0.00000000000000000000",
                    //         "last_deal_amount": "0.00000000000000000000",
                    //         "last_deal_id": 0,
                    //         "last_deal_price": "0.00000000000000000000",
                    //         "last_deal_role": 0,
                    //         "last_deal_time": 0,
                    //         "last_deal_type": 0,
                    //         "left": "0.0005",
                    //         "leverage": "3",
                    //         "maker_fee": "0.00030",
                    //         "market": "BTCUSDT",
                    //         "order_id": 18221659097,
                    //         "position_id": 0,
                    //         "position_type": 1,
                    //         "price": "30000.00",
                    //         "side": 2,
                    //         "source": "api.v1",
                    //         "stop_id": 0,
                    //         "taker_fee": "0.00050",
                    //         "target": 0,
                    //         "type": 1,
                    //         "update_time": 1651004578.618224,
                    //         "user_id": 3620173
                    //     }
                    //
                    // Stop order createOrder
                    //
                    //     {"status":"success"}
                    //
                    // Swap Stop cancelOrder, fetchOrder
                    //
                    //     {
                    //         "amount": "0.0005",
                    //         "client_id": "",
                    //         "create_time": 1651034023.008771,
                    //         "effect_type": 1,
                    //         "fee_asset": "",
                    //         "fee_discount": "0.00000000000000000000",
                    //         "maker_fee": "0.00030",
                    //         "market": "BTCUSDT",
                    //         "order_id": 18256915101,
                    //         "price": "31000.00",
                    //         "side": 2,
                    //         "source": "api.v1",
                    //         "state": 1,
                    //         "stop_price": "31500.00",
                    //         "stop_type": 1,
                    //         "taker_fee": "0.00050",
                    //         "target": 0,
                    //         "type": 1,
                    //         "update_time": 1651034397.193624,
                    //         "user_id": 3620173
                    //     }
                    //
                    //
                    // Spot fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "account_id": 0,
                    //         "amount": "0.0005",
                    //         "asset_fee": "0",
                    //         "avg_price": "0.00",
                    //         "client_id": "",
                    //         "create_time": 1651089247,
                    //         "deal_amount": "0",
                    //         "deal_fee": "0",
                    //         "deal_money": "0",
                    //         "fee_asset": null,
                    //         "fee_discount": "1",
                    //         "finished_time": 0,
                    //         "id": 74660190839,
                    //         "left": "0.0005",
                    //         "maker_fee_rate": "0.002",
                    //         "market": "BTCUSDT",
                    //         "money_fee": "0",
                    //         "order_type": "limit",
                    //         "price": "31000",
                    //         "status": "not_deal",
                    //         "stock_fee": "0",
                    //         "taker_fee_rate": "0.002",
                    //         "type": "buy"
                    //     }
                    //
                    // Swap fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "amount": "0.0005",
                    //         "client_id": "",
                    //         "create_time": 1651030414.088431,
                    //         "deal_asset_fee": "0",
                    //         "deal_fee": "0.00960069",
                    //         "deal_profit": "0.009825",
                    //         "deal_stock": "19.20138",
                    //         "effect_type": 0,
                    //         "fee_asset": "",
                    //         "fee_discount": "0",
                    //         "left": "0",
                    //         "leverage": "3",
                    //         "maker_fee": "0",
                    //         "market": "BTCUSDT",
                    //         "order_id": 18253447431,
                    //         "position_id": 0,
                    //         "position_type": 1,
                    //         "price": "0",
                    //         "side": 1,
                    //         "source": "web",
                    //         "stop_id": 0,
                    //         "taker_fee": "0.0005",
                    //         "target": 0,
                    //         "type": 2,
                    //         "update_time": 1651030414.08847,
                    //         "user_id": 3620173
                    //     }
                    //
                    // Spot Stop fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "account_id": 0,
                    //         "amount": "155",
                    //         "client_id": "",
                    //         "create_time": 1651089182,
                    //         "fee_asset": null,
                    //         "fee_discount": "1",
                    //         "maker_fee": "0.002",
                    //         "market": "BTCUSDT",
                    //         "order_id": 74660111965,
                    //         "order_type": "market",
                    //         "price": "0",
                    //         "state": 0,
                    //         "stop_price": "31500",
                    //         "taker_fee": "0.002",
                    //         "type": "buy"
                    //     }
                    //
                    // Swap Stop fetchOpenOrders
                    //
                    //     {
                    //         "amount": "0.0005",
                    //         "client_id": "",
                    //         "create_time": 1651089147.321691,
                    //         "effect_type": 1,
                    //         "fee_asset": "",
                    //         "fee_discount": "0.00000000000000000000",
                    //         "maker_fee": "0.00030",
                    //         "market": "BTCUSDT",
                    //         "order_id": 18332143848,
                    //         "price": "31000.00",
                    //         "side": 2,
                    //         "source": "api.v1",
                    //         "state": 1,
                    //         "stop_price": "31500.00",
                    //         "stop_type": 1,
                    //         "taker_fee": "0.00050",
                    //         "target": 0,
                    //         "type": 1,
                    //         "update_time": 1651089147.321691,
                    //         "user_id": 3620173
                    //     }
                    //
                    const timestamp = this.safeTimestamp(order, 'create_time');
                    const priceString = this.safeString(order, 'price');
                    const costString = this.safeString(order, 'deal_money');
                    const amountString = this.safeString(order, 'amount');
                    const filledString = this.safeString(order, 'deal_amount');
                    const averageString = this.safeString(order, 'avg_price');
                    const remainingString = this.safeString(order, 'left');
                    const marketId = this.safeString(order, 'market');
                    market = this.safeMarket(marketId, market);
                    const feeCurrencyId = this.safeString(order, 'fee_asset');
                    let feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                    if (feeCurrency === undefined) feeCurrency = market['quote'];
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    let side = this.safeInteger(order, 'side');
                    if (side === 1) side = 'sell';
                    else if (side === 2) side = 'buy';
                    else side = this.safeString(order, 'type');
                    let type = this.safeString(order, 'order_type');
                    if (type === undefined) {
                        type = this.safeInteger(order, 'type');
                        if (type === 1) type = 'limit';
                        else if (type === 2) type = 'market';
                    }
                    return this.safeOrder({
                        'id': this.safeString2(order, 'id', 'order_id'),
                        'clientOrderId': undefined,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'lastTradeTimestamp': this.safeTimestamp(order, 'update_time'),
                        'status': status,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': priceString,
                        'stopPrice': this.safeString(order, 'stop_price'),
                        'cost': costString,
                        'average': averageString,
                        'amount': amountString,
                        'filled': filledString,
                        'remaining': remainingString,
                        'trades': undefined,
                        'fee': {
                            'currency': feeCurrency,
                            'cost': this.safeString(order, 'deal_fee')
                        },
                        'info': order
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const swap = market['swap'];
                    const stopPrice = this.safeString2(params, 'stopPrice', 'stop_price');
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    const positionId = this.safeInteger2(params, 'position_id', 'positionId'); // Required for closing swap positions
                    let timeInForce = this.safeString(params, 'timeInForce'); // Spot: IOC, FOK, PO, GTC, ... NORMAL (default), MAKER_ONLY
                    const reduceOnly = this.safeValue(params, 'reduceOnly');
                    if (reduceOnly !== undefined) {
                        if (market['type'] !== 'swap') throw new InvalidOrder(this.id + ' createOrder() does not support reduceOnly for ' + market['type'] + ' orders, reduceOnly orders are supported for swap markets only');
                    }
                    let method = undefined;
                    const request = {
                        'market': market['id']
                    };
                    if (swap) {
                        method = 'perpetualPrivatePostOrderPut' + this.capitalize(type);
                        side = side === 'buy' ? 2 : 1;
                        if (stopPrice !== undefined) {
                            const stopType = this.safeInteger(params, 'stop_type'); // 1: triggered by the latest transaction, 2: mark price, 3: index price
                            if (stopType === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() swap stop orders require a stop_type parameter');
                            request['stop_price'] = this.priceToPrecision(symbol, stopPrice);
                            request['stop_type'] = this.priceToPrecision(symbol, stopType);
                            request['amount'] = this.amountToPrecision(symbol, amount);
                            request['side'] = side;
                            if (type === 'limit') {
                                method = 'perpetualPrivatePostOrderPutStopLimit';
                                request['price'] = this.priceToPrecision(symbol, price);
                            } else if (type === 'market') method = 'perpetualPrivatePostOrderPutStopMarket';
                            request['amount'] = this.amountToPrecision(symbol, amount);
                        }
                        if (type !== 'market' || stopPrice !== undefined) {
                            if (timeInForce !== undefined || postOnly !== undefined) {
                                let isMakerOrder = false;
                                if (timeInForce === 'PO' || postOnly) isMakerOrder = true;
                                if (isMakerOrder) request['option'] = 1;
                                else {
                                    if (timeInForce === 'IOC') timeInForce = 2;
                                    else if (timeInForce === 'FOK') timeInForce = 3;
                                    else timeInForce = 1;
                                    if (timeInForce !== undefined) request['effect_type'] = timeInForce; // exchange takes 'IOC' and 'FOK'
                                }
                            }
                        }
                        if (type === 'limit' && stopPrice === undefined) {
                            if (reduceOnly) {
                                method = 'perpetualPrivatePostOrderCloseLimit';
                                request['position_id'] = positionId;
                            } else request['side'] = side;
                            request['price'] = this.priceToPrecision(symbol, price);
                            request['amount'] = this.amountToPrecision(symbol, amount);
                        } else if (type === 'market' && stopPrice === undefined) {
                            if (reduceOnly) {
                                method = 'perpetualPrivatePostOrderCloseMarket';
                                request['position_id'] = positionId;
                            } else {
                                request['side'] = side;
                                request['amount'] = this.amountToPrecision(symbol, amount);
                            }
                        }
                    } else {
                        method = 'privatePostOrder' + this.capitalize(type);
                        request['type'] = side;
                        if (type === 'market' && side === 'buy') {
                            if (this.options['createMarketBuyOrderRequiresPrice']) {
                                if (price === undefined) throw new InvalidOrder(this.id + " createOrder() requires the price argument with market buy orders to calculate total order cost (amount to spend), where cost = amount * price. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount, or, alternatively, add .options['createMarketBuyOrderRequiresPrice'] = false to supply the cost in the amount argument (the exchange-specific behaviour)");
                                else {
                                    const amountString = this.amountToPrecision(symbol, amount);
                                    const priceString = this.priceToPrecision(symbol, price);
                                    const costString = Precise.stringMul(amountString, priceString);
                                    const costNumber = this.parseNumber(costString);
                                    request['amount'] = this.costToPrecision(symbol, costNumber);
                                }
                            } else request['amount'] = this.costToPrecision(symbol, amount);
                        } else request['amount'] = this.amountToPrecision(symbol, amount);
                        if (type === 'limit' || type === 'ioc') request['price'] = this.priceToPrecision(symbol, price);
                        if (stopPrice !== undefined) {
                            request['stop_price'] = this.priceToPrecision(symbol, stopPrice);
                            if (type === 'limit') method = 'privatePostOrderStopLimit';
                            else if (type === 'market') method = 'privatePostOrderStopMarket';
                        }
                        if (type !== 'market' || stopPrice !== undefined) // following options cannot be applied to vanilla market orders (but can be applied to stop-market orders)
                        {
                            if (timeInForce !== undefined || postOnly !== undefined) {
                                let isMakerOrder = false;
                                if (timeInForce === 'PO' || postOnly) isMakerOrder = true;
                                if ((isMakerOrder || timeInForce !== 'IOC') && type === 'limit' && stopPrice !== undefined) throw new InvalidOrder(this.id + ' createOrder() only supports the IOC option for stop-limit orders');
                                if (isMakerOrder) request['option'] = 'MAKER_ONLY';
                                else if (timeInForce !== undefined) request['option'] = timeInForce; // exchange takes 'IOC' and 'FOK'
                            }
                        }
                    }
                    params = this.omit(params, [
                        'reduceOnly',
                        'position_id',
                        'positionId',
                        'timeInForce',
                        'postOnly',
                        'stopPrice',
                        'stop_price',
                        'stop_type'
                    ]);
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "amount": "0.0005",
                    //             "asset_fee": "0",
                    //             "avg_price": "0.00",
                    //             "client_id": "",
                    //             "create_time": 1650951627,
                    //             "deal_amount": "0",
                    //             "deal_fee": "0",
                    //             "deal_money": "0",
                    //             "fee_asset": null,
                    //             "fee_discount": "1",
                    //             "finished_time": null,
                    //             "id": 74510932594,
                    //             "left": "0.0005",
                    //             "maker_fee_rate": "0.002",
                    //             "market": "BTCUSDT",
                    //             "money_fee": "0",
                    //             "order_type": "limit",
                    //             "price": "30000",
                    //             "status": "not_deal",
                    //             "stock_fee": "0",
                    //             "taker_fee_rate": "0.002",
                    //             "type": "buy"
                    //         },
                    //         "message": "Success"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "amount": "0.0005",
                    //             "client_id": "",
                    //             "create_time": 1651004578.618224,
                    //             "deal_asset_fee": "0.00000000000000000000",
                    //             "deal_fee": "0.00000000000000000000",
                    //             "deal_profit": "0.00000000000000000000",
                    //             "deal_stock": "0.00000000000000000000",
                    //             "effect_type": 1,
                    //             "fee_asset": "",
                    //             "fee_discount": "0.00000000000000000000",
                    //             "last_deal_amount": "0.00000000000000000000",
                    //             "last_deal_id": 0,
                    //             "last_deal_price": "0.00000000000000000000",
                    //             "last_deal_role": 0,
                    //             "last_deal_time": 0,
                    //             "last_deal_type": 0,
                    //             "left": "0.0005",
                    //             "leverage": "3",
                    //             "maker_fee": "0.00030",
                    //             "market": "BTCUSDT",
                    //             "order_id": 18221659097,
                    //             "position_id": 0,
                    //             "position_type": 1,
                    //             "price": "30000.00",
                    //             "side": 2,
                    //             "source": "api.v1",
                    //             "stop_id": 0,
                    //             "taker_fee": "0.00050",
                    //             "target": 0,
                    //             "type": 1,
                    //             "update_time": 1651004578.618224,
                    //             "user_id": 3620173
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    // Stop Order
                    //
                    //     {"code":0,"data":{"status":"success"},"message":"OK"}
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data, market);
                }
                async createReduceOnlyOrder(symbol, type, side, amount, price, params = {}) {
                    const request = {
                        'reduceOnly': true
                    };
                    return await this.createOrder(symbol, type, side, amount, price, this.extend(request, params));
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const stop = this.safeValue(params, 'stop');
                    const swap = market['swap'];
                    const request = {
                        'market': market['id']
                    };
                    const idRequest = swap ? 'order_id' : 'id';
                    request[idRequest] = id;
                    let method = swap ? 'perpetualPrivatePostOrderCancel' : 'privateDeleteOrderPending';
                    if (stop) {
                        if (swap) method = 'perpetualPrivatePostOrderCancelStop';
                        else method = 'privateDeleteOrderStopPendingId';
                    }
                    const query = this.omit(params, 'stop');
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "amount": "0.0005",
                    //             "asset_fee": "0",
                    //             "avg_price": "0.00",
                    //             "client_id": "",
                    //             "create_time": 1650951627,
                    //             "deal_amount": "0",
                    //             "deal_fee": "0",
                    //             "deal_money": "0",
                    //             "fee_asset": null,
                    //             "fee_discount": "1",
                    //             "finished_time": null,
                    //             "id": 74510932594,
                    //             "left": "0.0005",
                    //             "maker_fee_rate": "0.002",
                    //             "market": "BTCUSDT",
                    //             "money_fee": "0",
                    //             "order_type": "limit",
                    //             "price": "30000",
                    //             "status": "not_deal",
                    //             "stock_fee": "0",
                    //             "taker_fee_rate": "0.002",
                    //             "type": "buy"
                    //         },
                    //         "message": "Success"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "amount": "0.0005",
                    //             "client_id": "",
                    //             "create_time": 1651004578.618224,
                    //             "deal_asset_fee": "0.00000000000000000000",
                    //             "deal_fee": "0.00000000000000000000",
                    //             "deal_profit": "0.00000000000000000000",
                    //             "deal_stock": "0.00000000000000000000",
                    //             "effect_type": 1,
                    //             "fee_asset": "",
                    //             "fee_discount": "0.00000000000000000000",
                    //             "last_deal_amount": "0.00000000000000000000",
                    //             "last_deal_id": 0,
                    //             "last_deal_price": "0.00000000000000000000",
                    //             "last_deal_role": 0,
                    //             "last_deal_time": 0,
                    //             "last_deal_type": 0,
                    //             "left": "0.0005",
                    //             "leverage": "3",
                    //             "maker_fee": "0.00030",
                    //             "market": "BTCUSDT",
                    //             "order_id": 18221659097,
                    //             "position_id": 0,
                    //             "position_type": 1,
                    //             "price": "30000.00",
                    //             "side": 2,
                    //             "source": "api.v1",
                    //             "stop_id": 0,
                    //             "taker_fee": "0.00050",
                    //             "target": 0,
                    //             "type": 1,
                    //             "update_time": 1651004578.618224,
                    //             "user_id": 3620173
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    // Swap Stop
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "amount": "0.0005",
                    //             "client_id": "",
                    //             "create_time": 1651034023.008771,
                    //             "effect_type": 1,
                    //             "fee_asset": "",
                    //             "fee_discount": "0.00000000000000000000",
                    //             "maker_fee": "0.00030",
                    //             "market": "BTCUSDT",
                    //             "order_id": 18256915101,
                    //             "price": "31000.00",
                    //             "side": 2,
                    //             "source": "api.v1",
                    //             "state": 1,
                    //             "stop_price": "31500.00",
                    //             "stop_type": 1,
                    //             "taker_fee": "0.00050",
                    //             "target": 0,
                    //             "type": 1,
                    //             "update_time": 1651034397.193624,
                    //             "user_id": 3620173
                    //         },
                    //         "message":"OK"
                    //     }
                    //
                    // Spot Stop
                    //
                    //     {"code":0,"data":{},"message":"Success"}
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancellAllOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const marketId = market['id'];
                    const accountId = this.safeString(params, 'id', '0');
                    const request = {
                        'market': marketId
                    };
                    const swap = market['swap'];
                    const stop = this.safeValue(params, 'stop');
                    let method = undefined;
                    if (swap) {
                        method = 'perpetualPrivatePostOrderCancelAll';
                        if (stop) method = 'perpetualPrivatePostOrderCancelStopAll';
                    } else {
                        method = 'privateDeleteOrderPending';
                        if (stop) method = 'privateDeleteOrderStopPending';
                        request['account_id'] = accountId;
                    }
                    params = this.omit(params, 'stop');
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //     {"code": 0, "data": null, "message": "Success"}
                    //
                    // Swap
                    //
                    //     {"code": 0, "data": {"status":"success"}, "message": "OK"}
                    //
                    return response;
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const swap = market['swap'];
                    const stop = this.safeValue(params, 'stop');
                    const request = {
                        'market': market['id']
                    };
                    const idRequest = swap ? 'order_id' : 'id';
                    request[idRequest] = id;
                    let method = undefined;
                    if (swap) method = stop ? 'perpetualPrivateGetOrderStopStatus' : 'perpetualPrivateGetOrderStatus';
                    else method = 'privateGetOrder';
                    params = this.omit(params, 'stop');
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "amount": "0.1",
                    //             "asset_fee": "0.22736197736197736197",
                    //             "avg_price": "196.85000000000000000000",
                    //             "create_time": 1537270135,
                    //             "deal_amount": "0.1",
                    //             "deal_fee": "0",
                    //             "deal_money": "19.685",
                    //             "fee_asset": "CET",
                    //             "fee_discount": "0.5",
                    //             "id": 1788259447,
                    //             "left": "0",
                    //             "maker_fee_rate": "0",
                    //             "market": "ETHUSDT",
                    //             "order_type": "limit",
                    //             "price": "170.00000000",
                    //             "status": "done",
                    //             "taker_fee_rate": "0.0005",
                    //             "type": "sell",
                    //         },
                    //         "message": "Ok"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "amount": "0.0005",
                    //             "client_id": "",
                    //             "create_time": 1651004578.618224,
                    //             "deal_asset_fee": "0.00000000000000000000",
                    //             "deal_fee": "0.00000000000000000000",
                    //             "deal_profit": "0.00000000000000000000",
                    //             "deal_stock": "0.00000000000000000000",
                    //             "effect_type": 1,
                    //             "fee_asset": "",
                    //             "fee_discount": "0.00000000000000000000",
                    //             "last_deal_amount": "0.00000000000000000000",
                    //             "last_deal_id": 0,
                    //             "last_deal_price": "0.00000000000000000000",
                    //             "last_deal_role": 0,
                    //             "last_deal_time": 0,
                    //             "last_deal_type": 0,
                    //             "left": "0.0005",
                    //             "leverage": "3",
                    //             "maker_fee": "0.00030",
                    //             "market": "BTCUSDT",
                    //             "order_id": 18221659097,
                    //             "position_id": 0,
                    //             "position_type": 1,
                    //             "price": "30000.00",
                    //             "side": 2,
                    //             "source": "api.v1",
                    //             "stop_id": 0,
                    //             "taker_fee": "0.00050",
                    //             "target": 0,
                    //             "type": 1,
                    //             "update_time": 1651004578.618224,
                    //             "user_id": 3620173
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    // Swap Stop
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "amount": "0.0005",
                    //             "client_id": "",
                    //             "create_time": 1651034023.008771,
                    //             "effect_type": 1,
                    //             "fee_asset": "",
                    //             "fee_discount": "0.00000000000000000000",
                    //             "maker_fee": "0.00030",
                    //             "market": "BTCUSDT",
                    //             "order_id": 18256915101,
                    //             "price": "31000.00",
                    //             "side": 2,
                    //             "source": "api.v1",
                    //             "state": 1,
                    //             "stop_price": "31500.00",
                    //             "stop_type": 1,
                    //             "taker_fee": "0.00050",
                    //             "target": 0,
                    //             "type": 1,
                    //             "update_time": 1651034397.193624,
                    //             "user_id": 3620173
                    //         },
                    //         "message":"OK"
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data, market);
                }
                async fetchOrdersByStatus(status, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    limit = limit === undefined ? 100 : limit;
                    const request = {
                        'limit': limit
                    };
                    const stop = this.safeValue(params, 'stop');
                    const side = this.safeInteger(params, 'side');
                    params = this.omit(params, 'stop');
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market'] = market['id'];
                    }
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrdersByStatus', market, params);
                    let method = undefined;
                    if (marketType === 'swap') {
                        if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrdersByStatus() requires a symbol argument for swap markets');
                        method = 'perpetualPrivateGetOrder' + this.capitalize(status);
                        if (stop) method = 'perpetualPrivateGetOrderStopPending';
                        if (side !== undefined) request['side'] = side;
                        else request['side'] = 0;
                        request['offset'] = 0;
                    } else {
                        method = 'privateGetOrder' + this.capitalize(status);
                        if (stop) method = 'privateGetOrderStop' + this.capitalize(status);
                        request['page'] = 1;
                    }
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "count": 1,
                    //             "curr_page": 1,
                    //             "data": [
                    //                 {
                    //                     "account_id": 0,
                    //                     "amount": "0.0005",
                    //                     "asset_fee": "0",
                    //                     "avg_price": "0.00",
                    //                     "client_id": "",
                    //                     "create_time": 1651089247,
                    //                     "deal_amount": "0",
                    //                     "deal_fee": "0",
                    //                     "deal_money": "0",
                    //                     "fee_asset": null,
                    //                     "fee_discount": "1",
                    //                     "finished_time": 0,
                    //                     "id": 74660190839,
                    //                     "left": "0.0005",
                    //                     "maker_fee_rate": "0.002",
                    //                     "market": "BTCUSDT",
                    //                     "money_fee": "0",
                    //                     "order_type": "limit",
                    //                     "price": "31000",
                    //                     "status": "not_deal",
                    //                     "stock_fee": "0",
                    //                     "taker_fee_rate": "0.002",
                    //                     "type": "buy"
                    //                 }
                    //             ],
                    //             "has_next": false,
                    //             "total": 1
                    //         },
                    //         "message": "Success"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "limit": 100,
                    //             "offset": 0,
                    //             "records": [
                    //                 {
                    //                     "amount": "0.0005",
                    //                     "client_id": "",
                    //                     "create_time": 1651030414.088431,
                    //                     "deal_asset_fee": "0",
                    //                     "deal_fee": "0.00960069",
                    //                     "deal_profit": "0.009825",
                    //                     "deal_stock": "19.20138",
                    //                     "effect_type": 0,
                    //                     "fee_asset": "",
                    //                     "fee_discount": "0",
                    //                     "left": "0",
                    //                     "leverage": "3",
                    //                     "maker_fee": "0",
                    //                     "market": "BTCUSDT",
                    //                     "order_id": 18253447431,
                    //                     "position_id": 0,
                    //                     "position_type": 1,
                    //                     "price": "0",
                    //                     "side": 1,
                    //                     "source": "web",
                    //                     "stop_id": 0,
                    //                     "taker_fee": "0.0005",
                    //                     "target": 0,
                    //                     "type": 2,
                    //                     "update_time": 1651030414.08847,
                    //                     "user_id": 3620173
                    //                 },
                    //             ]
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    // Spot Stop
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "count": 1,
                    //             "curr_page": 1,
                    //             "data": [
                    //                 {
                    //                     "account_id": 0,
                    //                     "amount": "155",
                    //                     "client_id": "",
                    //                     "create_time": 1651089182,
                    //                     "fee_asset": null,
                    //                     "fee_discount": "1",
                    //                     "maker_fee": "0.002",
                    //                     "market": "BTCUSDT",
                    //                     "order_id": 74660111965,
                    //                     "order_type": "market",
                    //                     "price": "0",
                    //                     "state": 0,
                    //                     "stop_price": "31500",
                    //                     "taker_fee": "0.002",
                    //                     "type": "buy"
                    //                 }
                    //             ],
                    //             "has_next": false,
                    //             "total": 0
                    //         },
                    //         "message": "Success"
                    //     }
                    //
                    // Swap Stop
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "limit": 100,
                    //             "offset": 0,
                    //             "records": [
                    //                 {
                    //                     "amount": "0.0005",
                    //                     "client_id": "",
                    //                     "create_time": 1651089147.321691,
                    //                     "effect_type": 1,
                    //                     "fee_asset": "",
                    //                     "fee_discount": "0.00000000000000000000",
                    //                     "maker_fee": "0.00030",
                    //                     "market": "BTCUSDT",
                    //                     "order_id": 18332143848,
                    //                     "price": "31000.00",
                    //                     "side": 2,
                    //                     "source": "api.v1",
                    //                     "state": 1,
                    //                     "stop_price": "31500.00",
                    //                     "stop_type": 1,
                    //                     "taker_fee": "0.00050",
                    //                     "target": 0,
                    //                     "type": 1,
                    //                     "update_time": 1651089147.321691,
                    //                     "user_id": 3620173
                    //                 }
                    //             ],
                    //             "total": 1
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    const tradeRequest = marketType === 'swap' ? 'records' : 'data';
                    const data = this.safeValue(response, 'data');
                    const orders = this.safeValue(data, tradeRequest, []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByStatus('pending', symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByStatus('finished', symbol, since, limit, params);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const swap = market['swap'];
                    if (limit === undefined) limit = 100;
                    const request = {
                        'market': market['id'],
                        'limit': limit,
                        'offset': 0
                    };
                    let method = undefined;
                    if (swap) {
                        method = 'perpetualPublicGetMarketUserDeals';
                        const side = this.safeInteger(params, 'side');
                        if (side === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a side parameter for swap markets');
                        if (since !== undefined) request['start_time'] = since;
                        request['side'] = side;
                        params = this.omit(params, 'side');
                    } else {
                        method = 'privateGetOrderUserDeals';
                        request['page'] = 1;
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //      {
                    //          "code": 0,
                    //          "data": {
                    //              "data": [
                    //                  {
                    //                      "id": 2611520950,
                    //                      "order_id": 63286573298,
                    //                      "account_id": 0,
                    //                      "create_time": 1638990636,
                    //                      "type": "sell",
                    //                      "role": "taker",
                    //                      "price": "192.29",
                    //                      "amount": "0.098",
                    //                      "fee": "0.03768884",
                    //                      "fee_asset": "USDT",
                    //                      "market": "AAVEUSDT",
                    //                      "deal_money": "18.84442"
                    //                          },
                    //                      ],
                    //              "curr_page": 1,
                    //              "has_next": false,
                    //              "count": 3
                    //              },
                    //          "message": "Success"
                    //      }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "limit": 100,
                    //             "offset": 0,
                    //             "records": [
                    //                 {
                    //                     "amount": "0.0012",
                    //                     "deal_fee": "0.0237528",
                    //                     "deal_insurance": "0",
                    //                     "deal_margin": "15.8352",
                    //                     "deal_order_id": 17797031903,
                    //                     "deal_profit": "0",
                    //                     "deal_stock": "47.5056",
                    //                     "deal_type": 1,
                    //                     "deal_user_id": 2969195,
                    //                     "fee_asset": "",
                    //                     "fee_discount": "0",
                    //                     "fee_price": "0",
                    //                     "fee_rate": "0.0005",
                    //                     "fee_real_rate": "0.0005",
                    //                     "id": 379044296,
                    //                     "leverage": "3",
                    //                     "margin_amount": "15.8352",
                    //                     "market": "BTCUSDT",
                    //                     "open_price": "39588",
                    //                     "order_id": 17797092987,
                    //                     "position_amount": "0.0012",
                    //                     "position_id": 62052321,
                    //                     "position_type": 1,
                    //                     "price": "39588",
                    //                     "role": 2,
                    //                     "side": 2,
                    //                     "time": 1650675936.016103,
                    //                     "user_id": 3620173
                    //                 }
                    //             ]
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    const tradeRequest = swap ? 'records' : 'data';
                    const data = this.safeValue(response, 'data');
                    const trades = this.safeValue(data, tradeRequest, []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbols !== undefined) {
                        let symbol = undefined;
                        if (Array.isArray(symbols)) {
                            const symbolsLength = symbols.length;
                            if (symbolsLength > 1) throw new BadRequest(this.id + ' fetchPositions() symbols argument cannot contain more than 1 symbol');
                            symbol = symbols[0];
                        } else symbol = symbols;
                        market = this.market(symbol);
                        request['market'] = market['id'];
                    }
                    const response = await this.perpetualPrivateGetPositionPending(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "adl_sort": 3396,
                    //                 "adl_sort_val": "0.00007786",
                    //                 "amount": "0.0005",
                    //                 "amount_max": "0.0005",
                    //                 "amount_max_margin": "6.42101333333333333333",
                    //                 "bkr_price": "25684.05333333333333346175",
                    //                 "bkr_price_imply": "0.00000000000000000000",
                    //                 "close_left": "0.0005",
                    //                 "create_time": 1651294226.110899,
                    //                 "deal_all": "19.26000000000000000000",
                    //                 "deal_asset_fee": "0.00000000000000000000",
                    //                 "fee_asset": "",
                    //                 "finish_type": 1,
                    //                 "first_price": "38526.08",
                    //                 "insurance": "0.00000000000000000000",
                    //                 "latest_price": "38526.08",
                    //                 "leverage": "3",
                    //                 "liq_amount": "0.00000000000000000000",
                    //                 "liq_order_price": "0",
                    //                 "liq_order_time": 0,
                    //                 "liq_price": "25876.68373333333333346175",
                    //                 "liq_price_imply": "0.00000000000000000000",
                    //                 "liq_profit": "0.00000000000000000000",
                    //                 "liq_time": 0,
                    //                 "mainten_margin": "0.005",
                    //                 "mainten_margin_amount": "0.09631520000000000000",
                    //                 "maker_fee": "0.00000000000000000000",
                    //                 "margin_amount": "6.42101333333333333333",
                    //                 "market": "BTCUSDT",
                    //                 "open_margin": "0.33333333333333333333",
                    //                 "open_margin_imply": "0.00000000000000000000",
                    //                 "open_price": "38526.08000000000000000000",
                    //                 "open_val": "19.26304000000000000000",
                    //                 "open_val_max": "19.26304000000000000000",
                    //                 "position_id": 65847227,
                    //                 "profit_clearing": "-0.00963152000000000000",
                    //                 "profit_real": "-0.00963152000000000000",
                    //                 "profit_unreal": "0.00",
                    //                 "side": 2,
                    //                 "stop_loss_price": "0.00000000000000000000",
                    //                 "stop_loss_type": 0,
                    //                 "sys": 0,
                    //                 "take_profit_price": "0.00000000000000000000",
                    //                 "take_profit_type": 0,
                    //                 "taker_fee": "0.00000000000000000000",
                    //                 "total": 4661,
                    //                 "type": 1,
                    //                 "update_time": 1651294226.111196,
                    //                 "user_id": 3620173
                    //             },
                    //         ],
                    //         "message": "OK"
                    //     }
                    //
                    const position = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < position.length; i++)result.push(this.parsePosition(position[i], market));
                    return this.filterByArray(result, 'symbol', symbols, false);
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.perpetualPrivateGetPositionPending(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "adl_sort": 3396,
                    //                 "adl_sort_val": "0.00007786",
                    //                 "amount": "0.0005",
                    //                 "amount_max": "0.0005",
                    //                 "amount_max_margin": "6.42101333333333333333",
                    //                 "bkr_price": "25684.05333333333333346175",
                    //                 "bkr_price_imply": "0.00000000000000000000",
                    //                 "close_left": "0.0005",
                    //                 "create_time": 1651294226.110899,
                    //                 "deal_all": "19.26000000000000000000",
                    //                 "deal_asset_fee": "0.00000000000000000000",
                    //                 "fee_asset": "",
                    //                 "finish_type": 1,
                    //                 "first_price": "38526.08",
                    //                 "insurance": "0.00000000000000000000",
                    //                 "latest_price": "38526.08",
                    //                 "leverage": "3",
                    //                 "liq_amount": "0.00000000000000000000",
                    //                 "liq_order_price": "0",
                    //                 "liq_order_time": 0,
                    //                 "liq_price": "25876.68373333333333346175",
                    //                 "liq_price_imply": "0.00000000000000000000",
                    //                 "liq_profit": "0.00000000000000000000",
                    //                 "liq_time": 0,
                    //                 "mainten_margin": "0.005",
                    //                 "mainten_margin_amount": "0.09631520000000000000",
                    //                 "maker_fee": "0.00000000000000000000",
                    //                 "margin_amount": "6.42101333333333333333",
                    //                 "market": "BTCUSDT",
                    //                 "open_margin": "0.33333333333333333333",
                    //                 "open_margin_imply": "0.00000000000000000000",
                    //                 "open_price": "38526.08000000000000000000",
                    //                 "open_val": "19.26304000000000000000",
                    //                 "open_val_max": "19.26304000000000000000",
                    //                 "position_id": 65847227,
                    //                 "profit_clearing": "-0.00963152000000000000",
                    //                 "profit_real": "-0.00963152000000000000",
                    //                 "profit_unreal": "0.00",
                    //                 "side": 2,
                    //                 "stop_loss_price": "0.00000000000000000000",
                    //                 "stop_loss_type": 0,
                    //                 "sys": 0,
                    //                 "take_profit_price": "0.00000000000000000000",
                    //                 "take_profit_type": 0,
                    //                 "taker_fee": "0.00000000000000000000",
                    //                 "total": 4661,
                    //                 "type": 1,
                    //                 "update_time": 1651294226.111196,
                    //                 "user_id": 3620173
                    //             }
                    //         ],
                    //         "message": "OK"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parsePosition(data[0], market);
                }
                parsePosition(position, market) {
                    //
                    //     {
                    //         "adl_sort": 3396,
                    //         "adl_sort_val": "0.00007786",
                    //         "amount": "0.0005",
                    //         "amount_max": "0.0005",
                    //         "amount_max_margin": "6.42101333333333333333",
                    //         "bkr_price": "25684.05333333333333346175",
                    //         "bkr_price_imply": "0.00000000000000000000",
                    //         "close_left": "0.0005",
                    //         "create_time": 1651294226.110899,
                    //         "deal_all": "19.26000000000000000000",
                    //         "deal_asset_fee": "0.00000000000000000000",
                    //         "fee_asset": "",
                    //         "finish_type": 1,
                    //         "first_price": "38526.08",
                    //         "insurance": "0.00000000000000000000",
                    //         "latest_price": "38526.08",
                    //         "leverage": "3",
                    //         "liq_amount": "0.00000000000000000000",
                    //         "liq_order_price": "0",
                    //         "liq_order_time": 0,
                    //         "liq_price": "25876.68373333333333346175",
                    //         "liq_price_imply": "0.00000000000000000000",
                    //         "liq_profit": "0.00000000000000000000",
                    //         "liq_time": 0,
                    //         "mainten_margin": "0.005",
                    //         "mainten_margin_amount": "0.09631520000000000000",
                    //         "maker_fee": "0.00000000000000000000",
                    //         "margin_amount": "6.42101333333333333333",
                    //         "market": "BTCUSDT",
                    //         "open_margin": "0.33333333333333333333",
                    //         "open_margin_imply": "0.00000000000000000000",
                    //         "open_price": "38526.08000000000000000000",
                    //         "open_val": "19.26304000000000000000",
                    //         "open_val_max": "19.26304000000000000000",
                    //         "position_id": 65847227,
                    //         "profit_clearing": "-0.00963152000000000000",
                    //         "profit_real": "-0.00963152000000000000",
                    //         "profit_unreal": "0.00",
                    //         "side": 2,
                    //         "stop_loss_price": "0.00000000000000000000",
                    //         "stop_loss_type": 0,
                    //         "sys": 0,
                    //         "take_profit_price": "0.00000000000000000000",
                    //         "take_profit_type": 0,
                    //         "taker_fee": "0.00000000000000000000",
                    //         "total": 4661,
                    //         "type": 1,
                    //         "update_time": 1651294226.111196,
                    //         "user_id": 3620173
                    //     }
                    //
                    const marketId = this.safeString(position, 'market');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const positionId = this.safeInteger(position, 'position_id');
                    const marginModeInteger = this.safeInteger(position, 'type');
                    const marginMode = marginModeInteger === 1 ? 'isolated' : 'cross';
                    const liquidationPrice = this.safeString(position, 'liq_price');
                    const entryPrice = this.safeString(position, 'open_price');
                    const unrealizedPnl = this.safeString(position, 'profit_unreal');
                    const contractSize = this.safeString(position, 'amount');
                    const sideInteger = this.safeInteger(position, 'side');
                    const side = sideInteger === 1 ? 'short' : 'long';
                    const timestamp = this.safeTimestamp(position, 'update_time');
                    const maintenanceMargin = this.safeString(position, 'mainten_margin_amount');
                    const maintenanceMarginPercentage = this.safeString(position, 'mainten_margin');
                    const collateral = this.safeString(position, 'margin_amount');
                    const leverage = this.safeNumber(position, 'leverage');
                    return {
                        'info': position,
                        'id': positionId,
                        'symbol': symbol,
                        'notional': undefined,
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'liquidationPrice': liquidationPrice,
                        'entryPrice': entryPrice,
                        'unrealizedPnl': unrealizedPnl,
                        'percentage': undefined,
                        'contracts': undefined,
                        'contractSize': contractSize,
                        'markPrice': undefined,
                        'side': side,
                        'hedged': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'maintenanceMargin': maintenanceMargin,
                        'maintenanceMarginPercentage': maintenanceMarginPercentage,
                        'collateral': collateral,
                        'initialMargin': undefined,
                        'initialMarginPercentage': undefined,
                        'leverage': leverage,
                        'marginRatio': undefined
                    };
                }
                async setMarginMode(marginMode, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setMarginMode() requires a symbol argument');
                    marginMode = marginMode.toLowerCase();
                    if (marginMode !== 'isolated' && marginMode !== 'cross') throw new BadRequest(this.id + ' setMarginMode() marginMode argument should be isolated or cross');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (market['type'] !== 'swap') throw new BadSymbol(this.id + ' setMarginMode() supports swap contracts only');
                    const defaultMarginMode = this.safeString2(this.options, 'defaultMarginMode', marginMode);
                    let defaultPositionType = undefined;
                    if (defaultMarginMode === 'isolated') defaultPositionType = 1;
                    else if (defaultMarginMode === 'cross') defaultPositionType = 2;
                    const leverage = this.safeInteger(params, 'leverage');
                    const maxLeverage = this.safeInteger(market['limits']['leverage'], 'max', 100);
                    const positionType = this.safeInteger(params, 'position_type', defaultPositionType);
                    if (leverage === undefined) throw new ArgumentsRequired1(this.id + ' setMarginMode() requires a leverage parameter');
                    if (positionType === undefined) throw new ArgumentsRequired1(this.id + ' setMarginMode() requires a position_type parameter that will transfer margin to the specified trading pair');
                    if (leverage < 3 || leverage > maxLeverage) throw new BadRequest(this.id + ' setMarginMode() leverage should be between 3 and ' + maxLeverage.toString() + ' for ' + symbol);
                    const request = {
                        'market': market['id'],
                        'leverage': leverage.toString(),
                        'position_type': positionType
                    };
                    return await this.perpetualPrivatePostMarketAdjustLeverage(this.extend(request, params));
                }
                async setLeverage(leverage, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    await this.loadMarkets();
                    const defaultMarginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode');
                    let defaultPositionType = undefined;
                    if (defaultMarginMode === 'isolated') defaultPositionType = 1;
                    else if (defaultMarginMode === 'cross') defaultPositionType = 2;
                    const positionType = this.safeInteger(params, 'position_type', defaultPositionType);
                    if (positionType === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a position_type parameter that will transfer margin to the specified trading pair');
                    const market = this.market(symbol);
                    const maxLeverage = this.safeInteger(market['limits']['leverage'], 'max', 100);
                    if (market['type'] !== 'swap') throw new BadSymbol(this.id + ' setLeverage() supports swap contracts only');
                    if (leverage < 3 || leverage > maxLeverage) throw new BadRequest(this.id + ' setLeverage() leverage should be between 3 and ' + maxLeverage.toString() + ' for ' + symbol);
                    const request = {
                        'market': market['id'],
                        'leverage': leverage.toString(),
                        'position_type': positionType
                    };
                    return await this.perpetualPrivatePostMarketAdjustLeverage(this.extend(request, params));
                }
                async modifyMarginHelper(symbol, amount, addOrReduce, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'amount': this.amountToPrecision(symbol, amount),
                        'type': addOrReduce
                    };
                    const response = await this.perpetualPrivatePostPositionAdjustMargin(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "adl_sort": 1,
                    //             "adl_sort_val": "0.00004320",
                    //             "amount": "0.0005",
                    //             "amount_max": "0.0005",
                    //             "amount_max_margin": "6.57352000000000000000",
                    //             "bkr_price": "16294.08000000000000011090",
                    //             "bkr_price_imply": "0.00000000000000000000",
                    //             "close_left": "0.0005",
                    //             "create_time": 1651202571.320778,
                    //             "deal_all": "19.72000000000000000000",
                    //             "deal_asset_fee": "0.00000000000000000000",
                    //             "fee_asset": "",
                    //             "finish_type": 1,
                    //             "first_price": "39441.12",
                    //             "insurance": "0.00000000000000000000",
                    //             "latest_price": "39441.12",
                    //             "leverage": "3",
                    //             "liq_amount": "0.00000000000000000000",
                    //             "liq_order_price": "0",
                    //             "liq_order_time": 0,
                    //             "liq_price": "16491.28560000000000011090",
                    //             "liq_price_imply": "0.00000000000000000000",
                    //             "liq_profit": "0.00000000000000000000",
                    //             "liq_time": 0,
                    //             "mainten_margin": "0.005",
                    //             "mainten_margin_amount": "0.09860280000000000000",
                    //             "maker_fee": "0.00000000000000000000",
                    //             "margin_amount": "11.57352000000000000000",
                    //             "market": "BTCUSDT",
                    //             "open_margin": "0.58687582908396110455",
                    //             "open_margin_imply": "0.00000000000000000000",
                    //             "open_price": "39441.12000000000000000000",
                    //             "open_val": "19.72056000000000000000",
                    //             "open_val_max": "19.72056000000000000000",
                    //             "position_id": 65171206,
                    //             "profit_clearing": "-0.00986028000000000000",
                    //             "profit_real": "-0.00986028000000000000",
                    //             "profit_unreal": "0.00",
                    //             "side": 2,
                    //             "stop_loss_price": "0.00000000000000000000",
                    //             "stop_loss_type": 0,
                    //             "sys": 0,
                    //             "take_profit_price": "0.00000000000000000000",
                    //             "take_profit_type": 0,
                    //             "taker_fee": "0.00000000000000000000",
                    //             "total": 3464,
                    //             "type": 1,
                    //             "update_time": 1651202638.911212,
                    //             "user_id": 3620173
                    //         },
                    //         "message":"OK"
                    //     }
                    //
                    const status = this.safeString(response, 'message');
                    const type = addOrReduce === 1 ? 'add' : 'reduce';
                    return this.extend(this.parseModifyMargin(response, market), {
                        'amount': this.parseNumber(amount),
                        'type': type,
                        'status': status
                    });
                }
                parseModifyMargin(data, market) {
                    return {
                        'info': data,
                        'type': undefined,
                        'amount': undefined,
                        'code': market['quote'],
                        'symbol': this.safeSymbol(undefined, market),
                        'status': undefined
                    };
                }
                async addMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 1, params);
                }
                async reduceMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 2, params);
                }
                async fetchFundingHistory(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchFundingHistory() requires a symbol argument');
                    limit = limit === undefined ? 100 : limit;
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'limit': limit
                    };
                    if (since !== undefined) request['start_time'] = since;
                    const response = await this.perpetualPrivateGetPositionFunding(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "limit": 100,
                    //             "offset": 0,
                    //             "records": [
                    //                 {
                    //                     "amount": "0.0012",
                    //                     "asset": "USDT",
                    //                     "funding": "-0.0095688273996",
                    //                     "funding_rate": "0.00020034",
                    //                     "market": "BTCUSDT",
                    //                     "position_id": 62052321,
                    //                     "price": "39802.45",
                    //                     "real_funding_rate": "0.00020034",
                    //                     "side": 2,
                    //                     "time": 1650729623.933885,
                    //                     "type": 1,
                    //                     "user_id": 3620173,
                    //                     "value": "47.76294"
                    //                 },
                    //             ]
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const resultList = this.safeValue(data, 'records', []);
                    const result = [];
                    for(let i = 0; i < resultList.length; i++){
                        const entry = resultList[i];
                        const timestamp = this.safeTimestamp(entry, 'time');
                        const currencyId = this.safeString(entry, 'asset');
                        const code = this.safeCurrencyCode(currencyId);
                        result.push({
                            'info': entry,
                            'symbol': symbol,
                            'code': code,
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'id': this.safeNumber(entry, 'position_id'),
                            'amount': this.safeNumber(entry, 'funding')
                        });
                    }
                    return result;
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (!market['swap']) throw new BadSymbol(this.id + ' fetchFundingRate() supports swap contracts only');
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.perpetualPublicGetMarketTicker(this.extend(request, params));
                    //
                    //     {
                    //          "code": 0,
                    //         "data":
                    //         {
                    //             "date": 1650678472474,
                    //             "ticker": {
                    //                 "vol": "6090.9430",
                    //                 "low": "39180.30",
                    //                 "open": "40474.97",
                    //                 "high": "40798.01",
                    //                 "last": "39659.30",
                    //                 "buy": "39663.79",
                    //                 "period": 86400,
                    //                 "funding_time": 372,
                    //                 "position_amount": "270.1956",
                    //                 "funding_rate_last": "0.00022913",
                    //                 "funding_rate_next": "0.00013158",
                    //                 "funding_rate_predict": "0.00016552",
                    //                 "insurance": "16045554.83969682659674035672",
                    //                 "sign_price": "39652.48",
                    //                 "index_price": "39648.44250000",
                    //                 "sell_total": "22.3913",
                    //                 "buy_total": "19.4498",
                    //                 "buy_amount": "12.8942",
                    //                 "sell": "39663.80",
                    //                 "sell_amount": "0.9388"
                    //             }
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const ticker = this.safeValue(data, 'ticker', {});
                    return this.parseFundingRate(ticker, market);
                }
                parseFundingRate(contract, market) {
                    //
                    // fetchFundingRate
                    //
                    //     {
                    //         "vol": "6090.9430",
                    //         "low": "39180.30",
                    //         "open": "40474.97",
                    //         "high": "40798.01",
                    //         "last": "39659.30",
                    //         "buy": "39663.79",
                    //         "period": 86400,
                    //         "funding_time": 372,
                    //         "position_amount": "270.1956",
                    //         "funding_rate_last": "0.00022913",
                    //         "funding_rate_next": "0.00013158",
                    //         "funding_rate_predict": "0.00016552",
                    //         "insurance": "16045554.83969682659674035672",
                    //         "sign_price": "39652.48",
                    //         "index_price": "39648.44250000",
                    //         "sell_total": "22.3913",
                    //         "buy_total": "19.4498",
                    //         "buy_amount": "12.8942",
                    //         "sell": "39663.80",
                    //         "sell_amount": "0.9388"
                    //     }
                    //
                    return {
                        'info': contract,
                        'symbol': this.safeSymbol(undefined, market),
                        'markPrice': this.safeString(contract, 'sign_price'),
                        'indexPrice': this.safeString(contract, 'index_price'),
                        'interestRate': undefined,
                        'estimatedSettlePrice': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'fundingRate': this.safeString(contract, 'funding_rate_next'),
                        'fundingTimestamp': undefined,
                        'fundingDatetime': undefined,
                        'nextFundingRate': this.safeString(contract, 'funding_rate_predict'),
                        'nextFundingTimestamp': undefined,
                        'nextFundingDatetime': undefined,
                        'previousFundingRate': this.safeString(contract, 'funding_rate_last'),
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (tag) address = address + ':' + tag;
                    const request = {
                        'coin_type': currency['id'],
                        'coin_address': address,
                        'actual_amount': parseFloat(amount),
                        'transfer_method': 'onchain'
                    };
                    const response = await this.privatePostBalanceCoinWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "actual_amount": "1.00000000",
                    //             "amount": "1.00000000",
                    //             "coin_address": "1KAv3pazbTk2JnQ5xTo6fpKK7p1it2RzD4",
                    //             "coin_type": "BCH",
                    //             "coin_withdraw_id": 206,
                    //             "confirmations": 0,
                    //             "create_time": 1524228297,
                    //             "status": "audit",
                    //             "tx_fee": "0",
                    //             "tx_id": ""
                    //         },
                    //         "message": "Ok"
                    //     }
                    //
                    const transaction = this.safeValue(response, 'data', {});
                    return this.parseTransaction(transaction, currency);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'audit': 'pending',
                        'pass': 'pending',
                        'processing': 'pending',
                        'confirming': 'pending',
                        'not_pass': 'failed',
                        'cancel': 'canceled',
                        'finish': 'ok',
                        'fail': 'failed'
                    };
                    return this.safeString(statuses, status, status);
                }
                async fetchFundingRateHistory(symbol, since, limit = 100, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchFundingRateHistory() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'limit': limit,
                        'offset': 0
                    };
                    if (since !== undefined) request['start_time'] = since;
                    const response = await this.perpetualPublicGetMarketFundingHistory(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "offset": 0,
                    //             "limit": 3,
                    //             "records": [
                    //                 {
                    //                     "time": 1650672021.6230309,
                    //                     "market": "BTCUSDT",
                    //                     "asset": "USDT",
                    //                     "funding_rate": "0.00022913",
                    //                     "funding_rate_real": "0.00022913"
                    //                 },
                    //             ]
                    //         },
                    //         "message": "OK"
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const result = this.safeValue(data, 'records');
                    const rates = [];
                    for(let i = 0; i < result.length; i++){
                        const entry = result[i];
                        const marketId = this.safeString(entry, 'market');
                        const symbol = this.safeSymbol(marketId);
                        const timestamp = this.safeTimestamp(entry, 'time');
                        rates.push({
                            'info': entry,
                            'symbol': symbol,
                            'fundingRate': this.safeString(entry, 'funding_rate'),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp)
                        });
                    }
                    const sorted = this.sortBy(rates, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, market['symbol'], since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "actual_amount": "120.00000000",
                    //         "actual_amount_display": "120",
                    //         "add_explorer": "XXX",
                    //         "amount": "120.00000000",
                    //         "amount_display": "120",
                    //         "coin_address": "XXXXXXXX",
                    //         "coin_address_display": "XXXXXXXX",
                    //         "coin_deposit_id": 1866,
                    //         "coin_type": "USDT",
                    //         "confirmations": 0,
                    //         "create_time": 1539595701,
                    //         "explorer": "",
                    //         "remark": "",
                    //         "status": "finish",
                    //         "status_display": "finish",
                    //         "transfer_method": "local",
                    //         "tx_id": "",
                    //         "tx_id_display": "XXXXXXXXXX"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "actual_amount": "0.10000000",
                    //         "amount": "0.10000000",
                    //         "coin_address": "15sr1VdyXQ6sVLqeJUJ1uPzLpmQtgUeBSB",
                    //         "coin_type": "BCH",
                    //         "coin_withdraw_id": 203,
                    //         "confirmations": 11,
                    //         "create_time": 1515806440,
                    //         "status": "finish",
                    //         "tx_fee": "0",
                    //         "tx_id": "896371d0e23d64d1cac65a0b7c9e9093d835affb572fec89dd4547277fbdd2f6"
                    //     }
                    //
                    const id = this.safeString2(transaction, 'coin_withdraw_id', 'coin_deposit_id');
                    const address = this.safeString(transaction, 'coin_address');
                    let tag = this.safeString(transaction, 'remark'); // set but unused
                    if (tag !== undefined) {
                        if (tag.length < 1) tag = undefined;
                    }
                    let txid = this.safeValue(transaction, 'tx_id');
                    if (txid !== undefined) {
                        if (txid.length < 1) txid = undefined;
                    }
                    const currencyId = this.safeString(transaction, 'coin_type');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const timestamp = this.safeTimestamp(transaction, 'create_time');
                    const type = 'coin_withdraw_id' in transaction ? 'withdraw' : 'deposit';
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    let amount = this.safeNumber(transaction, 'amount');
                    let feeCost = this.safeNumber(transaction, 'tx_fee');
                    if (type === 'deposit') feeCost = 0;
                    const fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    // https://github.com/ccxt/ccxt/issues/8321
                    if (amount !== undefined) amount = amount - feeCost;
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'fee': fee
                    };
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('transfer', undefined, params);
                    if (marketType !== 'spot') throw new BadRequest(this.id + ' transfer() requires defaultType to be spot');
                    const currency = this.safeCurrencyCode(code);
                    const amountToPrecision = this.currencyToPrecision(code, amount);
                    let transfer = undefined;
                    if (fromAccount === 'spot' && toAccount === 'swap') transfer = 'in';
                    else if (fromAccount === 'swap' && toAccount === 'spot') transfer = 'out';
                    const request = {
                        'amount': amountToPrecision,
                        'coin_type': currency,
                        'transfer_side': transfer
                    };
                    const response = await this.privatePostContractBalanceTransfer(this.extend(request, query));
                    //
                    //     {"code": 0, "data": null, "message": "Success"}
                    //
                    return this.extend(this.parseTransfer(response, currency), {
                        'amount': this.parseNumber(amountToPrecision),
                        'fromAccount': fromAccount,
                        'toAccount': toAccount
                    });
                }
                parseTransferStatus(status) {
                    const statuses = {
                        '0': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransfer(transfer, currency) {
                    //
                    // fetchTransfers
                    //
                    //     {
                    //         "amount": "10",
                    //         "asset": "USDT",
                    //         "transfer_type": "transfer_out", // from swap to spot
                    //         "created_at": 1651633422
                    //     },
                    //
                    const timestamp = this.safeTimestamp(transfer, 'created_at');
                    const transferType = this.safeString(transfer, 'transfer_type');
                    let fromAccount = undefined;
                    let toAccount = undefined;
                    if (transferType === 'transfer_out') {
                        fromAccount = 'swap';
                        toAccount = 'spot';
                    } else if (transferType === 'transfer_in') {
                        fromAccount = 'spot';
                        toAccount = 'swap';
                    }
                    const currencyId = this.safeString(transfer, 'asset');
                    const currencyCode = this.safeCurrencyCode(currencyId, currency);
                    return {
                        'id': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': currencyCode,
                        'amount': this.safeNumber(transfer, 'amount'),
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'status': this.parseTransferStatus(this.safeString(transfer, 'code'))
                    };
                }
                async fetchTransfers(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {
                        'page': 1,
                        'limit': limit
                    };
                    const page = this.safeInteger(params, 'page');
                    if (page !== undefined) request['page'] = page;
                    if (code !== undefined) {
                        currency = this.safeCurrencyCode(code);
                        request['asset'] = currency['id'];
                    }
                    if (since !== undefined) request['start_time'] = since;
                    params = this.omit(params, 'page');
                    const response = await this.privateGetContractTransferHistory(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "records": [
                    //                 {
                    //                     "amount": "10",
                    //                     "asset": "USDT",
                    //                     "transfer_type": "transfer_out",
                    //                     "created_at": 1651633422
                    //                 },
                    //             ],
                    //             "total": 5
                    //         },
                    //         "message": "Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const transfers = this.safeValue(data, 'records', []);
                    return this.parseTransfers(transfers, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchWithdrawals() requires a currency code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin_type': currency['id']
                    };
                    if (limit !== undefined) request['Limit'] = limit;
                    const response = await this.privateGetBalanceCoinWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "has_next": true,
                    //             "curr_page": 1,
                    //             "count": 10,
                    //             "data": [
                    //                 {
                    //                     "coin_withdraw_id": 203,
                    //                     "create_time": 1513933541,
                    //                     "actual_amount": "0.00100000",
                    //                     "actual_amount_display": "***",
                    //                     "amount": "0.00100000",
                    //                     "amount_display": "******",
                    //                     "coin_address": "1GVVx5UBddLKrckTprNi4VhHSymeQ8tsLF",
                    //                     "app_coin_address_display": "**********",
                    //                     "coin_address_display": "****************",
                    //                     "add_explorer": "https://explorer.viawallet.com/btc/address/1GVVx5UBddLKrckTprNi4VhHSymeQ8tsLF",
                    //                     "coin_type": "BTC",
                    //                     "confirmations": 6,
                    //                     "explorer": "https://explorer.viawallet.com/btc/tx/1GVVx5UBddLKrckTprNi4VhHSymeQ8tsLF",
                    //                     "fee": "0",
                    //                     "remark": "",
                    //                     "smart_contract_name": "BTC",
                    //                     "status": "finish",
                    //                     "status_display": "finish",
                    //                     "transfer_method": "onchain",
                    //                     "tx_fee": "0",
                    //                     "tx_id": "896371d0e23d64d1cac65a0b7c9e9093d835affb572fec89dd4547277fbdd2f6"
                    //                 }, /* many more data points */
                    //             ],
                    //             "total": ***,
                    //             "total_page":***
                    //         },
                    //         "message": "Success"
                    //     }
                    //
                    let data = this.safeValue(response, 'data');
                    if (!Array.isArray(data)) data = this.safeValue(data, 'data', []);
                    return this.parseTransactions(data, currency, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires a currency code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin_type': currency['id']
                    };
                    if (limit !== undefined) request['Limit'] = limit;
                    const response = await this.privateGetBalanceCoinDeposit(this.extend(request, params));
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "actual_amount": "4.65397682",
                    //                 "actual_amount_display": "4.65397682",
                    //                 "add_explorer": "https://etherscan.io/address/0x361XXXXXX",
                    //                 "amount": "4.65397682",
                    //                 "amount_display": "4.65397682",
                    //                 "coin_address": "0x36dabcdXXXXXX",
                    //                 "coin_address_display": "0x361X*****XXXXX",
                    //                 "coin_deposit_id": 966191,
                    //                 "coin_type": "ETH",
                    //                 "confirmations": 30,
                    //                 "create_time": 1531661445,
                    //                 "explorer": "https://etherscan.io/tx/0x361XXXXXX",
                    //                 "remark": "",
                    //                 "status": "finish",
                    //                 "status_display": "finish",
                    //                 "transfer_method": "onchain",
                    //                 "tx_id": "0x361XXXXXX",
                    //                 "tx_id_display": "0x361XXXXXX"
                    //             }
                    //         ],
                    //         "message": "Ok"
                    //     }
                    //
                    let data = this.safeValue(response, 'data');
                    if (!Array.isArray(data)) data = this.safeValue(data, 'data', []);
                    return this.parseTransactions(data, currency, since, limit);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    path = this.implodeParams(path, params);
                    let url = this.urls['api'][api] + '/' + this.version + '/' + path;
                    let query = this.omit(params, this.extractParams(path));
                    this.checkRequiredCredentials();
                    const nonce = this.nonce().toString();
                    if (api === 'perpetualPrivate' || url === 'https://api.coinex.com/perpetual/v1/market/user_deals') {
                        query = this.extend({
                            'access_id': this.apiKey,
                            'timestamp': nonce
                        }, query);
                        query = this.keysort(query);
                        const urlencoded = this.rawencode(query);
                        const signature = this.hash(this.encode(urlencoded + '&secret_key=' + this.secret), 'sha256');
                        headers = {
                            'Authorization': signature.toLowerCase(),
                            'AccessId': this.apiKey
                        };
                        if (method === 'GET') url += '?' + urlencoded;
                        else {
                            headers['Content-Type'] = 'application/x-www-form-urlencoded';
                            body = urlencoded;
                        }
                    } else if (api === 'public' || api === 'perpetualPublic') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        query = this.extend({
                            'access_id': this.apiKey,
                            'tonce': nonce
                        }, query);
                        query = this.keysort(query);
                        const urlencoded = this.rawencode(query);
                        const signature = this.hash(this.encode(urlencoded + '&secret_key=' + this.secret));
                        headers = {
                            'Authorization': signature.toUpperCase(),
                            'Content-Type': 'application/json'
                        };
                        if (method === 'GET' || method === 'DELETE') url += '?' + urlencoded;
                        else body = this.json(query);
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    const code = this.safeString(response, 'code');
                    const data = this.safeValue(response, 'data');
                    const message = this.safeString(response, 'message');
                    if (code !== '0' || message !== 'Success' && message !== 'Succeeded' && message !== 'Ok' && !data) {
                        const responseCodes = {
                            // https://github.com/coinexcom/coinex_exchange_api/wiki/013error_code
                            '23': PermissionDenied,
                            '24': AuthenticationError,
                            '25': AuthenticationError,
                            '34': AuthenticationError,
                            '35': ExchangeNotAvailable,
                            '36': RequestTimeout,
                            '107': InsufficientFunds,
                            '600': OrderNotFound,
                            '601': InvalidOrder,
                            '602': InvalidOrder,
                            '606': InvalidOrder
                        };
                        const ErrorClass = this.safeValue(responseCodes, code, ExchangeError1);
                        throw new ErrorClass(response['message']);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    67: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class coinfalcon extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'coinfalcon',
                        'name': 'CoinFalcon',
                        'countries': [
                            'GB'
                        ],
                        'rateLimit': 1000,
                        'version': 'v1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': false,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradinFee': false,
                            'fetchTradingFees': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/41822275-ed982188-77f5-11e8-92bb-496bcd14ca52.jpg',
                            'api': 'https://coinfalcon.com',
                            'www': 'https://coinfalcon.com',
                            'doc': 'https://docs.coinfalcon.com',
                            'fees': 'https://coinfalcon.com/fees',
                            'referral': 'https://coinfalcon.com/?ref=CFJSVGTUPASB'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'markets',
                                    'markets/{market}',
                                    'markets/{market}/orders',
                                    'markets/{market}/trades'
                                ]
                            },
                            'private': {
                                'get': [
                                    'user/accounts',
                                    'user/orders',
                                    'user/orders/{id}',
                                    'user/orders/{id}/trades',
                                    'user/trades',
                                    'user/fees',
                                    'account/withdrawals/{id}',
                                    'account/withdrawals',
                                    'account/deposit/{id}',
                                    'account/deposits',
                                    'account/deposit_address'
                                ],
                                'post': [
                                    'user/orders',
                                    'account/withdraw'
                                ],
                                'delete': [
                                    'user/orders/{id}',
                                    'account/withdrawals/{id}'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'maker': 0.0,
                                'taker': 0.002
                            }
                        },
                        'precision': {
                            'amount': 8,
                            'price': 8
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetMarkets(params);
                    //
                    //    {
                    //        "data": [
                    //            {
                    //                "name": "ETH-BTC",
                    //                "precision": 6,
                    //                "min_volume": "0.00000001",
                    //                "min_price": "0.000001",
                    //                "volume": "0.015713",
                    //                "last_price": "0.069322",
                    //                "highest_bid": "0.063892",
                    //                "lowest_ask": "0.071437",
                    //                "change_in_24h": "2.85",
                    //                "size_precision": 8,
                    //                "price_precision": 6
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    const markets = this.safeValue(response, 'data');
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const [baseId, quoteId] = market['name'].split('-');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        result.push({
                            'id': market['name'],
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'size_precision'),
                                'price': this.safeInteger(market, 'price_precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minPrice'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'minVolume'),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "name":"ETH-BTC",
                    //         "precision":6,
                    //         "min_volume":"0.00000001",
                    //         "min_price":"0.000001",
                    //         "volume":"0.000452",
                    //         "last_price":"0.079059",
                    //         "highest_bid":"0.073472",
                    //         "lowest_ask":"0.079059",
                    //         "change_in_24h":"8.9",
                    //         "size_precision":8,
                    //         "price_precision":6
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'name');
                    market = this.safeMarket(marketId, market, '-');
                    const timestamp = this.milliseconds();
                    const last = this.safeString(ticker, 'last_price');
                    return this.safeTicker({
                        'symbol': market['symbol'],
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': undefined,
                        'low': undefined,
                        'bid': this.safeString(ticker, 'highest_bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'lowest_ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': this.safeString(ticker, 'change_in_24h'),
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': undefined,
                        'quoteVolume': this.safeString(ticker, 'volume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const tickers = await this.fetchTickers([
                        symbol
                    ], params);
                    return tickers[symbol];
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetMarkets(params);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "name":"ETH-BTC",
                    //                 "precision":6,
                    //                 "min_volume":"0.00000001",
                    //                 "min_price":"0.000001",
                    //                 "volume":"0.000452",
                    //                 "last_price":"0.079059",
                    //                 "highest_bid":"0.073472",
                    //                 "lowest_ask":"0.079059",
                    //                 "change_in_24h":"8.9",
                    //                 "size_precision":8,
                    //                 "price_precision":6
                    //             }
                    //         ]
                    //     }
                    //
                    const tickers = this.safeValue(response, 'data');
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const ticker = this.parseTicker(tickers[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'market': this.marketId(symbol),
                        'level': '3'
                    };
                    const response = await this.publicGetMarketsMarketOrders(this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrderBook(data, symbol, undefined, 'bids', 'asks', 'price', 'size');
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "id":"5ec36295-5c8d-4874-8d66-2609d4938557",
                    //          "price":"4050.06","size":"0.0044",
                    //          "market_name":"ETH-USDT",
                    //          "side":"sell",
                    //          "created_at":"2021-12-07T17:47:36.811000Z"
                    //      }
                    //
                    // fetchMyTrades (private)
                    //
                    //      {
                    //              "id": "0718d520-c796-4061-a16b-915cd13f20c6",
                    //              "price": "0.00000358",
                    //              "size": "50.0",
                    //              "market_name": "DOGE-BTC",
                    //              "order_id": "ff2616d8-58d4-40fd-87ae-937c73eb6f1c",
                    //              "side": "buy",
                    //              "fee': "0.00000036",
                    //              "fee_currency_code": "btc",
                    //              "liquidity": "T",
                    //              "created_at": "2021-12-08T18:26:33.840000Z"
                    //      }
                    //
                    const timestamp = this.parse8601(this.safeString(trade, 'created_at'));
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'size');
                    const symbol = market['symbol'];
                    const tradeId = this.safeString(trade, 'id');
                    const side = this.safeString(trade, 'side');
                    const orderId = this.safeString(trade, 'order_id');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) {
                        const feeCurrencyCode = this.safeString(trade, 'fee_currency_code');
                        fee = {
                            'cost': feeCostString,
                            'currency': this.safeCurrencyCode(feeCurrencyCode)
                        };
                    }
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': tradeId,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (since !== undefined) request['start_time'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetUserTrades(this.extend(request, params));
                    //
                    //      {
                    //          "data": [
                    //              {
                    //                  "id": "0718d520-c796-4061-a16b-915cd13f20c6",
                    //                  "price": "0.00000358",
                    //                  "size": "50.0",
                    //                  "market_name": "DOGE-BTC",
                    //                  "order_id": "ff2616d8-58d4-40fd-87ae-937c73eb6f1c",
                    //                  "side": "buy",
                    //                  "fee': "0.00000036",
                    //                  "fee_currency_code": "btc",
                    //                  "liquidity": "T",
                    //                  "created_at": "2021-12-08T18:26:33.840000Z"
                    //              },
                    //          ]
                    //      }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (since !== undefined) request['since'] = this.iso8601(since);
                    const response = await this.publicGetMarketsMarketTrades(this.extend(request, params));
                    //
                    //      {
                    //          "data":[
                    //              {
                    //                  "id":"5ec36295-5c8d-4874-8d66-2609d4938557",
                    //                  "price":"4050.06","size":"0.0044",
                    //                  "market_name":"ETH-USDT",
                    //                  "side":"sell",
                    //                  "created_at":"2021-12-07T17:47:36.811000Z"
                    //              },
                    //          ]
                    //      }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetUserFees(params);
                    //
                    //    {
                    //        data: {
                    //            maker_fee: '0.0',
                    //            taker_fee: '0.2',
                    //            btc_volume_30d: '0.0'
                    //        }
                    //    }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const makerString = this.safeString(data, 'maker_fee');
                    const takerString = this.safeString(data, 'taker_fee');
                    const maker = this.parseNumber(Precise.stringDiv(makerString, '100'));
                    const taker = this.parseNumber(Precise.stringDiv(takerString, '100'));
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const balances = this.safeValue(response, 'data');
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency_code');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available_balance');
                        account['used'] = this.safeString(balance, 'hold_balance');
                        account['total'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetUserAccounts(params);
                    return this.parseBalance(response);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         "address":"0x77b5051f97efa9cc52c9ad5b023a53fc15c200d3",
                    //         "tag":"0"
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'address');
                    const tag = this.safeString(depositAddress, 'tag');
                    this.checkAddress(address);
                    return {
                        'currency': this.safeCurrencyCode(undefined, currency),
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': depositAddress
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.safeCurrency(code);
                    const request = {
                        'currency': this.safeStringLower(currency, 'id')
                    };
                    const response = await this.privateGetAccountDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         data: {
                    //             address: '0x9918987bbe865a1a9301dc736cf6cf3205956694',
                    //             tag:null
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseDepositAddress(data, currency);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'fulfilled': 'closed',
                        'canceled': 'canceled',
                        'pending': 'open',
                        'open': 'open',
                        'partially_filled': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "id":"8bdd79f4-8414-40a2-90c3-e9f4d6d1eef4"
                    //         "market":"IOT-BTC"
                    //         "price":"0.0000003"
                    //         "size":"4.0"
                    //         "size_filled":"3.0"
                    //         "fee":"0.0075"
                    //         "fee_currency_code":"iot"
                    //         "funds":"0.0"
                    //         "status":"canceled"
                    //         "order_type":"buy"
                    //         "post_only":false
                    //         "operation_type":"market_order"
                    //         "created_at":"2018-01-12T21:14:06.747828Z"
                    //     }
                    //
                    const marketId = this.safeString(order, 'market');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const priceString = this.safeString(order, 'price');
                    const amountString = this.safeString(order, 'size');
                    const filledString = this.safeString(order, 'size_filled');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    let type = this.safeString(order, 'operation_type');
                    if (type !== undefined) {
                        type = type.split('_');
                        type = type[0];
                    }
                    const side = this.safeString(order, 'order_type');
                    const postOnly = this.safeValue(order, 'post_only');
                    return this.safeOrder({
                        'id': this.safeString(order, 'id'),
                        'clientOrderId': undefined,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': postOnly,
                        'side': side,
                        'price': priceString,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'amount': amountString,
                        'filled': filledString,
                        'remaining': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'info': order,
                        'lastTradeTimestamp': undefined,
                        'average': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    // price/size must be string
                    const request = {
                        'market': market['id'],
                        'size': this.amountToPrecision(symbol, amount),
                        'order_type': side
                    };
                    if (type === 'limit') {
                        price = this.priceToPrecision(symbol, price);
                        request['price'] = price.toString();
                    }
                    request['operation_type'] = type + '_order';
                    const response = await this.privatePostUserOrders(this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateDeleteUserOrdersId(this.extend(request, params));
                    const market = this.market(symbol);
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetUserOrdersId(this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market'] = market['id'];
                    }
                    if (since !== undefined) request['since_time'] = this.iso8601(since);
                    // TODO: test status=all if it works for closed orders too
                    const response = await this.privateGetUserOrders(this.extend(request, params));
                    const data = this.safeValue(response, 'data', []);
                    const orders = this.filterByArray(data, 'status', [
                        'pending',
                        'open',
                        'partially_filled'
                    ], false);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = this.safeStringLower(currency, 'id');
                    }
                    if (since !== undefined) request['since_time'] = this.iso8601(since);
                    const response = await this.privateGetAccountDeposits(this.extend(request, params));
                    //
                    //     data: [
                    //         {
                    //             id: '6e2f18b5-f80e-xxx-xxx-xxx',
                    //             amount: '0.1',
                    //             status: 'completed',
                    //             currency_code: 'eth',
                    //             txid: '0xxxx',
                    //             address: '0xxxx',
                    //             tag: null,
                    //             type: 'deposit'
                    //         },
                    //     ]
                    //
                    const transactions = this.safeValue(response, 'data', []);
                    transactions.reverse(); // no timestamp but in reversed order
                    return this.parseTransactions(transactions, currency, undefined, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = this.safeStringLower(currency, 'id');
                    }
                    if (since !== undefined) request['since_time'] = this.iso8601(since);
                    const response = await this.privateGetAccountWithdrawals(this.extend(request, params));
                    //
                    //     data: [
                    //         {
                    //             id: '25f6f144-3666-xxx-xxx-xxx',
                    //             amount: '0.01',
                    //             status: 'completed',
                    //             fee: '0.0005',
                    //             currency_code: 'btc',
                    //             txid: '4xxx',
                    //             address: 'bc1xxx',
                    //             tag: null,
                    //             type: 'withdraw'
                    //         },
                    //     ]
                    //
                    const transactions = this.safeValue(response, 'data', []);
                    transactions.reverse(); // no timestamp but in reversed order
                    return this.parseTransactions(transactions, currency, undefined, limit);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': this.safeStingLower(currency, 'id'),
                        'address': address,
                        'amount': amount
                    };
                    if (tag !== undefined) request['tag'] = tag;
                    const response = await this.privatePostAccountWithdraw(this.extend(request, params));
                    //
                    //     data: [
                    //         {
                    //             id: '25f6f144-3666-xxx-xxx-xxx',
                    //             amount: '0.01',
                    //             status: 'approval_pending',
                    //             fee: '0.0005',
                    //             currency_code: 'btc',
                    //             txid: null,
                    //             address: 'bc1xxx',
                    //             tag: null,
                    //             type: 'withdraw'
                    //         },
                    //     ]
                    //
                    const transaction = this.safeValue(response, 'data', []);
                    return this.parseTransaction(transaction, currency);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'completed': 'ok',
                        'denied': 'failed',
                        'approval_pending': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchWithdrawals, withdraw
                    //
                    //     {
                    //         id: '25f6f144-3666-xxx-xxx-xxx',
                    //         amount: '0.01',
                    //         status: 'completed',
                    //         fee: '0.0005',
                    //         currency_code: 'btc',
                    //         txid: '4xxx',
                    //         address: 'bc1xxx',
                    //         tag: null,
                    //         type: 'withdraw'
                    //     },
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         id: '6e2f18b5-f80e-xxx-xxx-xxx',
                    //         amount: '0.1',
                    //         status: 'completed',
                    //         currency_code: 'eth',
                    //         txid: '0xxxx',
                    //         address: '0xxxx',
                    //         tag: null,
                    //         type: 'deposit'
                    //     },
                    //
                    const id = this.safeString(transaction, 'id');
                    const address = this.safeString(transaction, 'address');
                    const tag = this.safeString(transaction, 'tag');
                    const txid = this.safeString(transaction, 'txid');
                    const currencyId = this.safeString(transaction, 'currency_code');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    let type = this.safeString(transaction, 'type');
                    if (type === 'withdraw') type = 'withdrawal';
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const amountString = this.safeString(transaction, 'amount');
                    const amount = this.parseNumber(amountString);
                    const feeCostString = this.safeString(transaction, 'fee');
                    let feeCost = 0;
                    if (feeCostString !== undefined) feeCost = this.parseNumber(feeCostString);
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'fee': {
                            'currency': code,
                            'cost': feeCost
                        }
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let request = '/api/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) request += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        if (method === 'GET') {
                            if (Object.keys(query).length) request += '?' + this.urlencode(query);
                        } else body = this.json(query);
                        const seconds = this.seconds().toString();
                        let payload = [
                            seconds,
                            method,
                            request
                        ].join('|');
                        if (body) payload += '|' + body;
                        const signature = this.hmac(this.encode(payload), this.encode(this.secret));
                        headers = {
                            'CF-API-KEY': this.apiKey,
                            'CF-API-TIMESTAMP': seconds,
                            'CF-API-SIGNATURE': signature,
                            'Content-Type': 'application/json'
                        };
                    }
                    const url = this.urls['api'] + request;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (code < 400) return;
                    const ErrorClass = this.safeValue({
                        '401': AuthenticationError,
                        '429': RateLimitExceeded
                    }, code, ExchangeError1);
                    throw new ErrorClass(body);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    68: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, RateLimitExceeded: RateLimitExceeded, InsufficientFunds: InsufficientFunds, AuthenticationError: AuthenticationError } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class coinmate extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'coinmate',
                        'name': 'CoinMate',
                        'countries': [
                            'GB',
                            'CZ',
                            'EU'
                        ],
                        'rateLimit': 1000,
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': false,
                            'fetchTransactions': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87460806-1c9f3f00-c616-11ea-8c46-a77018a8f3f4.jpg',
                            'api': 'https://coinmate.io/api',
                            'www': 'https://coinmate.io',
                            'fees': 'https://coinmate.io/fees',
                            'doc': [
                                'https://coinmate.docs.apiary.io',
                                'https://coinmate.io/developers'
                            ],
                            'referral': 'https://coinmate.io?referral=YTFkM1RsOWFObVpmY1ZjMGREQmpTRnBsWjJJNVp3PT0'
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'uid': true
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'orderBook',
                                    'ticker',
                                    'transactions',
                                    'tradingPairs'
                                ]
                            },
                            'private': {
                                'post': [
                                    'balances',
                                    'bitcoinCashWithdrawal',
                                    'bitcoinCashDepositAddresses',
                                    'bitcoinDepositAddresses',
                                    'bitcoinWithdrawal',
                                    'bitcoinWithdrawalFees',
                                    'buyInstant',
                                    'buyLimit',
                                    'cancelOrder',
                                    'cancelOrderWithInfo',
                                    'createVoucher',
                                    'dashDepositAddresses',
                                    'dashWithdrawal',
                                    'ethereumWithdrawal',
                                    'ethereumDepositAddresses',
                                    'litecoinWithdrawal',
                                    'litecoinDepositAddresses',
                                    'openOrders',
                                    'order',
                                    'orderHistory',
                                    'orderById',
                                    'pusherAuth',
                                    'redeemVoucher',
                                    'replaceByBuyLimit',
                                    'replaceByBuyInstant',
                                    'replaceBySellLimit',
                                    'replaceBySellInstant',
                                    'rippleDepositAddresses',
                                    'rippleWithdrawal',
                                    'sellInstant',
                                    'sellLimit',
                                    'transactionHistory',
                                    'traderFees',
                                    'tradeHistory',
                                    'transfer',
                                    'transferHistory',
                                    'unconfirmedBitcoinDeposits',
                                    'unconfirmedBitcoinCashDeposits',
                                    'unconfirmedDashDeposits',
                                    'unconfirmedEthereumDeposits',
                                    'unconfirmedLitecoinDeposits',
                                    'unconfirmedRippleDeposits'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'maker': 0.0012,
                                'taker': 0.0025,
                                'tiers': {
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.0035')
                                        ],
                                        [
                                            this.parseNumber('10000'),
                                            this.parseNumber('0.0023')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('0.0021')
                                        ],
                                        [
                                            this.parseNumber('250000'),
                                            this.parseNumber('0.0020')
                                        ],
                                        [
                                            this.parseNumber('500000'),
                                            this.parseNumber('0.0015')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.0013')
                                        ],
                                        [
                                            this.parseNumber('3000000'),
                                            this.parseNumber('0.0010')
                                        ],
                                        [
                                            this.parseNumber('15000000'),
                                            this.parseNumber('0.0005')
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.003')
                                        ],
                                        [
                                            this.parseNumber('10000'),
                                            this.parseNumber('0.0011')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('0.0010')
                                        ],
                                        [
                                            this.parseNumber('250000'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('500000'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('3000000'),
                                            this.parseNumber('0.0002')
                                        ],
                                        [
                                            this.parseNumber('15000000'),
                                            this.parseNumber('0')
                                        ]
                                    ]
                                }
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'No order with given ID': OrderNotFound
                            },
                            'broad': {
                                'Not enough account balance available': InsufficientFunds,
                                'Incorrect order ID': InvalidOrder,
                                'Minimum Order Size ': InvalidOrder,
                                'TOO MANY REQUESTS': RateLimitExceeded,
                                'Access denied.': AuthenticationError
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetTradingPairs(params);
                    //
                    //     {
                    //         "error":false,
                    //         "errorMessage":null,
                    //         "data": [
                    //             {
                    //                 "name":"BTC_EUR",
                    //                 "firstCurrency":"BTC",
                    //                 "secondCurrency":"EUR",
                    //                 "priceDecimals":2,
                    //                 "lotDecimals":8,
                    //                 "minAmount":0.0002,
                    //                 "tradesWebSocketChannelId":"trades-BTC_EUR",
                    //                 "orderBookWebSocketChannelId":"order_book-BTC_EUR",
                    //                 "tradeStatisticsWebSocketChannelId":"statistics-BTC_EUR"
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const id = this.safeString(market, 'name');
                        const baseId = this.safeString(market, 'firstCurrency');
                        const quoteId = this.safeString(market, 'secondCurrency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const symbol = base + '/' + quote;
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'lotDecimals'),
                                'price': this.safeInteger(market, 'priceDecimals')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minAmount'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'data');
                    const result = {
                        'info': response
                    };
                    const currencyIds = Object.keys(balances);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const balance = this.safeValue(balances, currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'reserved');
                        account['total'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostBalances(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'currencyPair': this.marketId(symbol),
                        'groupByPriceLimit': 'False'
                    };
                    const response = await this.publicGetOrderBook(this.extend(request, params));
                    const orderbook = response['data'];
                    const timestamp = this.safeTimestamp(orderbook, 'timestamp');
                    return this.parseOrderBook(orderbook, symbol, timestamp, 'bids', 'asks', 'price', 'amount');
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'currencyPair': this.marketId(symbol)
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    const ticker = this.safeValue(response, 'data');
                    const timestamp = this.safeTimestamp(ticker, 'timestamp');
                    const last = this.safeNumber(ticker, 'last');
                    return {
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeNumber(ticker, 'high'),
                        'low': this.safeNumber(ticker, 'low'),
                        'bid': this.safeNumber(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeNumber(ticker, 'ask'),
                        'vwap': undefined,
                        'askVolume': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeNumber(ticker, 'amount'),
                        'quoteVolume': undefined,
                        'info': ticker
                    };
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'limit': 1000
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['timestampFrom'] = since;
                    if (code !== undefined) {
                        const currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    const response = await this.privatePostTransferHistory(this.extend(request, params));
                    const items = response['data'];
                    return this.parseTransactions(items, undefined, since, limit);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        // any other types ?
                        'COMPLETED': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // deposits
                    //
                    //     {
                    //         transactionId: 1862815,
                    //         timestamp: 1516803982388,
                    //         amountCurrency: 'LTC',
                    //         amount: 1,
                    //         fee: 0,
                    //         walletType: 'LTC',
                    //         transferType: 'DEPOSIT',
                    //         transferStatus: 'COMPLETED',
                    //         txid:
                    //         'ccb9255dfa874e6c28f1a64179769164025329d65e5201849c2400abd6bce245',
                    //         destination: 'LQrtSKA6LnhcwRrEuiborQJnjFF56xqsFn',
                    //         destinationTag: null
                    //     }
                    //
                    // withdrawals
                    //
                    //     {
                    //         transactionId: 2140966,
                    //         timestamp: 1519314282976,
                    //         amountCurrency: 'EUR',
                    //         amount: 8421.7228,
                    //         fee: 16.8772,
                    //         walletType: 'BANK_WIRE',
                    //         transferType: 'WITHDRAWAL',
                    //         transferStatus: 'COMPLETED',
                    //         txid: null,
                    //         destination: null,
                    //         destinationTag: null
                    //     }
                    //
                    const timestamp = this.safeInteger(transaction, 'timestamp');
                    const amount = this.safeNumber(transaction, 'amount');
                    const fee = this.safeNumber(transaction, 'fee');
                    const txid = this.safeString(transaction, 'txid');
                    const address = this.safeString(transaction, 'destination');
                    const tag = this.safeString(transaction, 'destinationTag');
                    const currencyId = this.safeString(transaction, 'amountCurrency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const type = this.safeStringLower(transaction, 'transferType');
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'transferStatus'));
                    const id = this.safeString(transaction, 'transactionId');
                    const network = this.safeString(transaction, 'walletType');
                    return {
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': code,
                        'amount': amount,
                        'type': type,
                        'txid': txid,
                        'network': network,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'status': status,
                        'fee': {
                            'cost': fee,
                            'currency': code
                        },
                        'info': transaction
                    };
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (limit === undefined) limit = 1000;
                    const request = {
                        'limit': limit
                    };
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        request['currencyPair'] = market['id'];
                    }
                    if (since !== undefined) request['timestampFrom'] = since;
                    const response = await this.privatePostTradeHistory(this.extend(request, params));
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, undefined, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         transactionId: 2671819,
                    //         createdTimestamp: 1529649127605,
                    //         currencyPair: 'LTC_BTC',
                    //         type: 'BUY',
                    //         orderType: 'LIMIT',
                    //         orderId: 101810227,
                    //         amount: 0.01,
                    //         price: 0.01406,
                    //         fee: 0,
                    //         feeType: 'MAKER'
                    //     }
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "timestamp":1561598833416,
                    //         "transactionId":"4156303",
                    //         "price":10950.41,
                    //         "amount":0.004,
                    //         "currencyPair":"BTC_EUR",
                    //         "tradeType":"BUY"
                    //     }
                    //
                    const marketId = this.safeString(trade, 'currencyPair');
                    market = this.safeMarket(marketId, market, '_');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const side = this.safeStringLower2(trade, 'type', 'tradeType');
                    const type = this.safeStringLower(trade, 'orderType');
                    const orderId = this.safeString(trade, 'orderId');
                    const id = this.safeString(trade, 'transactionId');
                    const timestamp = this.safeInteger2(trade, 'timestamp', 'createdTimestamp');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) fee = {
                        'cost': feeCostString,
                        'currency': market['quote']
                    };
                    let takerOrMaker = this.safeString(trade, 'feeType');
                    takerOrMaker = takerOrMaker === 'MAKER' ? 'maker' : 'taker';
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': type,
                        'side': side,
                        'order': orderId,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPair': market['id'],
                        'minutesIntoHistory': 10
                    };
                    const response = await this.publicGetTransactions(this.extend(request, params));
                    //
                    //     {
                    //         "error":false,
                    //         "errorMessage":null,
                    //         "data":[
                    //             {
                    //                 "timestamp":1561598833416,
                    //                 "transactionId":"4156303",
                    //                 "price":10950.41,
                    //                 "amount":0.004,
                    //                 "currencyPair":"BTC_EUR",
                    //                 "tradeType":"BUY"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPair': market['id']
                    };
                    const response = await this.privatePostTraderFees(this.extend(request, params));
                    //
                    //     {
                    //         error: false,
                    //         errorMessage: null,
                    //         data: { maker: '0.3', taker: '0.35', timestamp: '1646253217815' }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const makerString = this.safeString(data, 'maker');
                    const takerString = this.safeString(data, 'taker');
                    const maker = this.parseNumber(Precise.stringDiv(makerString, '100'));
                    const taker = this.parseNumber(Precise.stringDiv(takerString, '100'));
                    return {
                        'info': data,
                        'symbol': symbol,
                        'maker': maker,
                        'taker': taker,
                        'percentage': true,
                        'tierBased': true
                    };
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const response = await this.privatePostOpenOrders(this.extend({}, params));
                    const extension = {
                        'status': 'open'
                    };
                    return this.parseOrders(response['data'], undefined, since, limit, extension);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPair': market['id']
                    };
                    // offset param that appears in other parts of the API doesn't appear to be supported here
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privatePostOrderHistory(this.extend(request, params));
                    return this.parseOrders(response['data'], market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'FILLED': 'closed',
                        'CANCELLED': 'canceled',
                        'PARTIALLY_FILLED': 'open',
                        'OPEN': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrderType(type) {
                    const types = {
                        'LIMIT': 'limit',
                        'MARKET': 'market'
                    };
                    return this.safeString(types, type, type);
                }
                parseOrder(order, market) {
                    //
                    // limit sell
                    //
                    //     {
                    //         id: 781246605,
                    //         timestamp: 1584480015133,
                    //         trailingUpdatedTimestamp: null,
                    //         type: 'SELL',
                    //         currencyPair: 'ETH_BTC',
                    //         price: 0.0345,
                    //         amount: 0.01,
                    //         stopPrice: null,
                    //         originalStopPrice: null,
                    //         marketPriceAtLastUpdate: null,
                    //         marketPriceAtOrderCreation: null,
                    //         orderTradeType: 'LIMIT',
                    //         hidden: false,
                    //         trailing: false,
                    //         clientOrderId: null
                    //     }
                    //
                    // limit buy
                    //
                    //     {
                    //         id: 67527001,
                    //         timestamp: 1517931722613,
                    //         trailingUpdatedTimestamp: null,
                    //         type: 'BUY',
                    //         price: 5897.24,
                    //         remainingAmount: 0.002367,
                    //         originalAmount: 0.1,
                    //         stopPrice: null,
                    //         originalStopPrice: null,
                    //         marketPriceAtLastUpdate: null,
                    //         marketPriceAtOrderCreation: null,
                    //         status: 'CANCELLED',
                    //         orderTradeType: 'LIMIT',
                    //         hidden: false,
                    //         avgPrice: null,
                    //         trailing: false,
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const timestamp = this.safeInteger(order, 'timestamp');
                    const side = this.safeStringLower(order, 'type');
                    const priceString = this.safeString(order, 'price');
                    const amountString = this.safeString(order, 'originalAmount');
                    const remainingString = this.safeString2(order, 'remainingAmount', 'amount');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const type = this.parseOrderType(this.safeString(order, 'orderTradeType'));
                    const averageString = this.safeString(order, 'avgPrice');
                    const marketId = this.safeString(order, 'currencyPair');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const clientOrderId = this.safeString(order, 'clientOrderId');
                    const stopPrice = this.safeNumber(order, 'stopPrice');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': priceString,
                        'stopPrice': stopPrice,
                        'amount': amountString,
                        'cost': undefined,
                        'average': averageString,
                        'filled': undefined,
                        'remaining': remainingString,
                        'status': status,
                        'trades': undefined,
                        'info': order,
                        'fee': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    let method = 'privatePost' + this.capitalize(side);
                    const request = {
                        'currencyPair': this.marketId(symbol)
                    };
                    if (type === 'market') {
                        if (side === 'buy') request['total'] = this.amountToPrecision(symbol, amount); // amount in fiat
                        else request['amount'] = this.amountToPrecision(symbol, amount); // amount in fiat
                        method += 'Instant';
                    } else {
                        request['amount'] = this.amountToPrecision(symbol, amount); // amount in crypto
                        request['price'] = this.priceToPrecision(symbol, price);
                        method += this.capitalize(type);
                    }
                    const response = await this[method](this.extend(request, params));
                    const id = this.safeString(response, 'data');
                    return {
                        'info': response,
                        'id': id
                    };
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderId': id
                    };
                    let market = undefined;
                    if (symbol) market = this.market(symbol);
                    const response = await this.privatePostOrderById(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    //   {"error":false,"errorMessage":null,"data":{"success":true,"remainingAmount":0.01}}
                    const request = {
                        'orderId': id
                    };
                    const response = await this.privatePostCancelOrderWithInfo(this.extend(request, params));
                    return {
                        'info': response
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + path;
                    if (api === 'public') {
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const auth = nonce + this.uid + this.apiKey;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                        body = this.urlencode(this.extend({
                            'clientId': this.uid,
                            'nonce': nonce,
                            'publicKey': this.apiKey,
                            'signature': signature.toUpperCase()
                        }, params));
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response !== undefined) {
                        if ('error' in response) // {"error":true,"errorMessage":"Minimum Order Size 0.01 ETH","data":null}
                        {
                            if (response['error']) {
                                const message = this.safeString(response, 'errorMessage');
                                const feedback = this.id + ' ' + message;
                                this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                                this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                                throw new ExchangeError1(this.id + ' ' + this.json(response));
                            }
                        }
                    }
                    if (code > 400) {
                        if (body) {
                            const feedback = this.id + ' ' + body;
                            this.throwExactlyMatchedException(this.exceptions['exact'], body, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                            throw new ExchangeError1(feedback); // unknown message
                        }
                        throw new ExchangeError1(this.id + ' ' + body);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    69: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { BadSymbol: BadSymbol, BadRequest: BadRequest, ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, OrderNotFound: OrderNotFound, OnMaintenance: OnMaintenance } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class coinone extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'coinone',
                        'name': 'CoinOne',
                        'countries': [
                            'KR'
                        ],
                        // 'enableRateLimit': false,
                        'rateLimit': 667,
                        'version': 'v2',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': undefined,
                            'fetchDepositAddresses': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/38003300-adc12fba-323f-11e8-8525-725f53c4a659.jpg',
                            'api': 'https://api.coinone.co.kr',
                            'www': 'https://coinone.co.kr',
                            'doc': 'https://doc.coinone.co.kr'
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'orderbook/',
                                    'trades/',
                                    'ticker/'
                                ]
                            },
                            'private': {
                                'post': [
                                    'account/deposit_address/',
                                    'account/btc_deposit_address/',
                                    'account/balance/',
                                    'account/daily_balance/',
                                    'account/user_info/',
                                    'account/virtual_account/',
                                    'order/cancel_all/',
                                    'order/cancel/',
                                    'order/limit_buy/',
                                    'order/limit_sell/',
                                    'order/complete_orders/',
                                    'order/limit_orders/',
                                    'order/order_info/',
                                    'transaction/auth_number/',
                                    'transaction/history/',
                                    'transaction/krw/history/',
                                    'transaction/btc/',
                                    'transaction/coin/'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'taker': 0.002,
                                'maker': 0.002
                            }
                        },
                        'precision': {
                            'price': 4,
                            'amount': 4,
                            'cost': 8
                        },
                        'exceptions': {
                            '405': OnMaintenance,
                            '104': OrderNotFound,
                            '108': BadSymbol,
                            '107': BadRequest
                        },
                        'commonCurrencies': {
                            'SOC': 'Soda Coin'
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const request = {
                        'currency': 'all'
                    };
                    const response = await this.publicGetTicker(request);
                    //
                    //    {
                    //        "result": "success",
                    //        "errorCode": "0",
                    //        "timestamp": "1643676668",
                    //        "xec": {
                    //          "currency": "xec",
                    //          "first": "0.0914",
                    //          "low": "0.0894",
                    //          "high": "0.096",
                    //          "last": "0.0937",
                    //          "volume": "1673283662.9797",
                    //          "yesterday_first": "0.0929",
                    //          "yesterday_low": "0.0913",
                    //          "yesterday_high": "0.0978",
                    //          "yesterday_last": "0.0913",
                    //          "yesterday_volume": "1167285865.4571"
                    //        },
                    //        ...
                    //    }
                    //
                    const result = [];
                    const quoteId = 'krw';
                    const quote = this.safeCurrencyCode(quoteId);
                    const baseIds = Object.keys(response);
                    for(let i = 0; i < baseIds.length; i++){
                        const baseId = baseIds[i];
                        const ticker = this.safeValue(response, baseId, {});
                        const currency = this.safeValue(ticker, 'currency');
                        if (currency === undefined) continue;
                        const base = this.safeCurrencyCode(baseId);
                        result.push({
                            'id': baseId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': undefined,
                                'price': undefined
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': ticker
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const balances = this.omit(response, [
                        'errorCode',
                        'result',
                        'normalWallets'
                    ]);
                    const currencyIds = Object.keys(balances);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const balance = balances[currencyId];
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'avail');
                        account['total'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostAccountBalance(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['id'],
                        'format': 'json'
                    };
                    const response = await this.publicGetOrderbook(this.extend(request, params));
                    const timestamp = this.safeTimestamp(response, 'timestamp');
                    return this.parseOrderBook(response, symbol, timestamp, 'bid', 'ask', 'price', 'qty');
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'currency': 'all',
                        'format': 'json'
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    const result = {};
                    const ids = Object.keys(response);
                    const timestamp = this.safeTimestamp(response, 'timestamp');
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        let symbol = id;
                        let market = undefined;
                        if (id in this.markets_by_id) {
                            market = this.markets_by_id[id];
                            symbol = market['symbol'];
                            const ticker = response[id];
                            result[symbol] = this.parseTicker(ticker, market);
                            result[symbol]['timestamp'] = timestamp;
                        }
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['id'],
                        'format': 'json'
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    return this.parseTicker(response, market);
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "currency":"xec",
                    //         "first":"0.1069",
                    //         "low":"0.09",
                    //         "high":"0.1069",
                    //         "last":"0.0911",
                    //         "volume":"4591217267.4974",
                    //         "yesterday_first":"0.1128",
                    //         "yesterday_low":"0.1035",
                    //         "yesterday_high":"0.1167",
                    //         "yesterday_last":"0.1069",
                    //         "yesterday_volume":"4014832231.5102"
                    //     }
                    //
                    const timestamp = this.safeTimestamp(ticker, 'timestamp');
                    const open = this.safeString(ticker, 'first');
                    const last = this.safeString(ticker, 'last');
                    const previousClose = this.safeString(ticker, 'yesterday_last');
                    const symbol = this.safeSymbol(undefined, market);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': previousClose,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "timestamp": "1416893212",
                    //         "price": "420000.0",
                    //         "qty": "0.1",
                    //         "is_ask": "1"
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "timestamp": "1416561032",
                    //         "price": "419000.0",
                    //         "type": "bid",
                    //         "qty": "0.001",
                    //         "feeRate": "-0.0015",
                    //         "fee": "-0.0000015",
                    //         "orderId": "E84A1AC2-8088-4FA0-B093-A3BCDB9B3C85"
                    //     }
                    //
                    const timestamp = this.safeTimestamp(trade, 'timestamp');
                    market = this.safeMarket(undefined, market);
                    const is_ask = this.safeString(trade, 'is_ask');
                    let side = this.safeString(trade, 'type');
                    if (is_ask !== undefined) {
                        if (is_ask === '1') side = 'sell';
                        else if (is_ask === '0') side = 'buy';
                    } else {
                        if (side === 'ask') side = 'sell';
                        else if (side === 'bid') side = 'buy';
                    }
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'qty');
                    const orderId = this.safeString(trade, 'orderId');
                    let feeCostString = this.safeString(trade, 'fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        feeCostString = Precise.stringAbs(feeCostString);
                        let feeRateString = this.safeString(trade, 'feeRate');
                        feeRateString = Precise.stringAbs(feeRateString);
                        const feeCurrencyCode = side === 'sell' ? market['quote'] : market['base'];
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode,
                            'rate': feeRateString
                        };
                    }
                    return this.safeTrade({
                        'id': this.safeString(trade, 'id'),
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'order': orderId,
                        'symbol': market['symbol'],
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['id'],
                        'format': 'json'
                    };
                    const response = await this.publicGetTrades(this.extend(request, params));
                    //
                    //     {
                    //         "result": "success",
                    //         "errorCode": "0",
                    //         "timestamp": "1416895635",
                    //         "currency": "btc",
                    //         "completeOrders": [
                    //             {
                    //                 "timestamp": "1416893212",
                    //                 "price": "420000.0",
                    //                 "qty": "0.1",
                    //                 "is_ask": "1"
                    //             }
                    //         ]
                    //     }
                    //
                    const completeOrders = this.safeValue(response, 'completeOrders', []);
                    return this.parseTrades(completeOrders, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (type !== 'limit') throw new ExchangeError1(this.id + ' createOrder() allows limit orders only');
                    await this.loadMarkets();
                    const request = {
                        'price': price,
                        'currency': this.marketId(symbol),
                        'qty': amount
                    };
                    const method = 'privatePostOrder' + this.capitalize(type) + this.capitalize(side);
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "result": "success",
                    //         "errorCode": "0",
                    //         "orderId": "8a82c561-40b4-4cb3-9bc0-9ac9ffc1d63b"
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'order_id': id,
                        'currency': market['id']
                    };
                    const response = await this.privatePostOrderOrderInfo(this.extend(request, params));
                    //
                    //     {
                    //         "result": "success",
                    //         "errorCode": "0",
                    //         "status": "live",
                    //         "info": {
                    //             "orderId": "32FF744B-D501-423A-8BA1-05BB6BE7814A",
                    //             "currency": "BTC",
                    //             "type": "bid",
                    //             "price": "2922000.0",
                    //             "qty": "115.4950",
                    //             "remainQty": "45.4950",
                    //             "feeRate": "0.0003",
                    //             "fee": "0",
                    //             "timestamp": "1499340941"
                    //         }
                    //     }
                    //
                    const info = this.safeValue(response, 'info', {});
                    info['status'] = this.safeString(info, 'status');
                    return this.parseOrder(info, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'live': 'open',
                        'partially_filled': 'open',
                        'filled': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "result": "success",
                    //         "errorCode": "0",
                    //         "orderId": "8a82c561-40b4-4cb3-9bc0-9ac9ffc1d63b"
                    //     }
                    //
                    // fetchOrder
                    //
                    //     {
                    //         "status": "live", // injected in fetchOrder
                    //         "orderId": "32FF744B-D501-423A-8BA1-05BB6BE7814A",
                    //         "currency": "BTC",
                    //         "type": "bid",
                    //         "price": "2922000.0",
                    //         "qty": "115.4950",
                    //         "remainQty": "45.4950",
                    //         "feeRate": "0.0003",
                    //         "fee": "0",
                    //         "timestamp": "1499340941"
                    //     }
                    //
                    // fetchOpenOrders
                    //
                    //     {
                    //         "index": "0",
                    //         "orderId": "68665943-1eb5-4e4b-9d76-845fc54f5489",
                    //         "timestamp": "1449037367",
                    //         "price": "444000.0",
                    //         "qty": "0.3456",
                    //         "type": "ask",
                    //         "feeRate": "-0.0015"
                    //     }
                    //
                    const id = this.safeString(order, 'orderId');
                    const priceString = this.safeString(order, 'price');
                    const timestamp = this.safeTimestamp(order, 'timestamp');
                    let side = this.safeString(order, 'type');
                    if (side === 'ask') side = 'sell';
                    else if (side === 'bid') side = 'buy';
                    const remainingString = this.safeString(order, 'remainQty');
                    const amountString = this.safeString(order, 'qty');
                    let status = this.safeString(order, 'status');
                    // https://github.com/ccxt/ccxt/pull/7067
                    if (status === 'live') {
                        if (remainingString !== undefined && amountString !== undefined) {
                            const isLessThan = Precise.stringLt(remainingString, amountString);
                            if (isLessThan) status = 'canceled';
                        }
                    }
                    status = this.parseOrderStatus(status);
                    let symbol = undefined;
                    let base = undefined;
                    let quote = undefined;
                    const marketId = this.safeStringLower(order, 'currency');
                    if (marketId !== undefined) {
                        if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                        else {
                            base = this.safeCurrencyCode(marketId);
                            quote = 'KRW';
                            symbol = base + '/' + quote;
                        }
                    }
                    if (symbol === undefined && market !== undefined) {
                        symbol = market['symbol'];
                        base = market['base'];
                        quote = market['quote'];
                    }
                    let fee = undefined;
                    const feeCostString = this.safeString(order, 'fee');
                    if (feeCostString !== undefined) {
                        const feeCurrencyCode = side === 'sell' ? quote : base;
                        fee = {
                            'cost': feeCostString,
                            'rate': this.safeString(order, 'feeRate'),
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': 'limit',
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': priceString,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'average': undefined,
                        'amount': amountString,
                        'filled': undefined,
                        'remaining': remainingString,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    // The returned amount might not be same as the ordered amount. If an order is partially filled, the returned amount means the remaining amount.
                    // For the same reason, the returned amount and remaining are always same, and the returned filled and cost are always zero.
                    if (symbol === undefined) throw new ExchangeError1(this.id + ' fetchOpenOrders() allows fetching closed orders with a specific symbol');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['id']
                    };
                    const response = await this.privatePostOrderLimitOrders(this.extend(request, params));
                    //
                    //     {
                    //         "result": "success",
                    //         "errorCode": "0",
                    //         "limitOrders": [
                    //             {
                    //                 "index": "0",
                    //                 "orderId": "68665943-1eb5-4e4b-9d76-845fc54f5489",
                    //                 "timestamp": "1449037367",
                    //                 "price": "444000.0",
                    //                 "qty": "0.3456",
                    //                 "type": "ask",
                    //                 "feeRate": "-0.0015"
                    //             }
                    //         ]
                    //     }
                    //
                    const limitOrders = this.safeValue(response, 'limitOrders', []);
                    return this.parseOrders(limitOrders, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['id']
                    };
                    const response = await this.privatePostOrderCompleteOrders(this.extend(request, params));
                    //
                    // despite the name of the endpoint it returns trades which may have a duplicate orderId
                    // https://github.com/ccxt/ccxt/pull/7067
                    //
                    //     {
                    //         "result": "success",
                    //         "errorCode": "0",
                    //         "completeOrders": [
                    //             {
                    //                 "timestamp": "1416561032",
                    //                 "price": "419000.0",
                    //                 "type": "bid",
                    //                 "qty": "0.001",
                    //                 "feeRate": "-0.0015",
                    //                 "fee": "-0.0000015",
                    //                 "orderId": "E84A1AC2-8088-4FA0-B093-A3BCDB9B3C85"
                    //             }
                    //         ]
                    //     }
                    //
                    const completeOrders = this.safeValue(response, 'completeOrders', []);
                    return this.parseTrades(completeOrders, market, since, limit);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) // eslint-disable-next-line quotes
                    throw new ArgumentsRequired1(this.id + " cancelOrder() requires a symbol argument. To cancel the order, pass a symbol argument and {'price': 12345, 'qty': 1.2345, 'is_ask': 0} in the params argument of cancelOrder.");
                    const price = this.safeNumber(params, 'price');
                    const qty = this.safeNumber(params, 'qty');
                    const isAsk = this.safeInteger(params, 'is_ask');
                    if (price === undefined || qty === undefined || isAsk === undefined) // eslint-disable-next-line quotes
                    throw new ArgumentsRequired1(this.id + " cancelOrder() requires {'price': 12345, 'qty': 1.2345, 'is_ask': 0} in the params argument.");
                    await this.loadMarkets();
                    const request = {
                        'order_id': id,
                        'price': price,
                        'qty': qty,
                        'is_ask': isAsk,
                        'currency': this.marketId(symbol)
                    };
                    const response = await this.privatePostOrderCancel(this.extend(request, params));
                    //
                    //     {
                    //         "result": "success",
                    //         "errorCode": "0"
                    //     }
                    //
                    return response;
                }
                async fetchDepositAddresses(codes, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostAccountDepositAddress(params);
                    //
                    //     {
                    //         result: 'success',
                    //         errorCode: '0',
                    //         walletAddress: {
                    //             matic: null,
                    //             btc: "mnobqu4i6qMCJWDpf5UimRmr8JCvZ8FLcN",
                    //             xrp: null,
                    //             xrp_tag: '-1',
                    //             kava: null,
                    //             kava_memo: null,
                    //         }
                    //     }
                    //
                    const walletAddress = this.safeValue(response, 'walletAddress', {});
                    const keys = Object.keys(walletAddress);
                    const result = {};
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        const value = walletAddress[key];
                        if (!value || value === '-1') continue;
                        const parts = key.split('_');
                        const currencyId = this.safeValue(parts, 0);
                        const secondPart = this.safeValue(parts, 1);
                        const code = this.safeCurrencyCode(currencyId);
                        let depositAddress = this.safeValue(result, code);
                        if (depositAddress === undefined) depositAddress = {
                            'currency': code,
                            'address': undefined,
                            'tag': undefined,
                            'info': value
                        };
                        const address = this.safeString(depositAddress, 'address', value);
                        this.checkAddress(address);
                        depositAddress['address'] = address;
                        depositAddress['info'] = address;
                        if (secondPart === 'tag' || secondPart === 'memo') {
                            depositAddress['tag'] = value;
                            depositAddress['info'] = [
                                address,
                                value
                            ];
                        }
                        result[code] = depositAddress;
                    }
                    return result;
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const request = this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    let url = this.urls['api'] + '/';
                    if (api === 'public') {
                        url += request;
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        url += this.version + '/' + request;
                        const nonce = this.nonce().toString();
                        const json = this.json(this.extend({
                            'access_token': this.apiKey,
                            'nonce': nonce
                        }, params));
                        const payload = this.stringToBase64(json);
                        body = this.decode(payload);
                        const secret = this.secret.toUpperCase();
                        const signature = this.hmac(payload, this.encode(secret), 'sha512');
                        headers = {
                            'Content-Type': 'application/json',
                            'X-COINONE-PAYLOAD': payload,
                            'X-COINONE-SIGNATURE': signature
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    if ('result' in response) {
                        const result = response['result'];
                        if (result !== 'success') {
                            //
                            //    {  "errorCode": "405",  "status": "maintenance",  "result": "error"}
                            //
                            const errorCode = this.safeString(response, 'errorCode');
                            const feedback = this.id + ' ' + body;
                            this.throwExactlyMatchedException(this.exceptions, errorCode, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    } else throw new ExchangeError1(this.id + ' ' + body);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    70: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class coinspot extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'coinspot',
                        'name': 'CoinSpot',
                        'countries': [
                            'AU'
                        ],
                        'rateLimit': 1000,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkOHLCV': false,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/28208429-3cacdf9a-6896-11e7-854e-4c79a772a30f.jpg',
                            'api': {
                                'public': 'https://www.coinspot.com.au/pubapi',
                                'private': 'https://www.coinspot.com.au/api'
                            },
                            'www': 'https://www.coinspot.com.au',
                            'doc': 'https://www.coinspot.com.au/api',
                            'referral': 'https://www.coinspot.com.au/register?code=PJURCU'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'latest'
                                ]
                            },
                            'private': {
                                'post': [
                                    'orders',
                                    'orders/history',
                                    'my/coin/deposit',
                                    'my/coin/send',
                                    'quote/buy',
                                    'quote/sell',
                                    'my/balances',
                                    'my/orders',
                                    'my/buy',
                                    'my/sell',
                                    'my/buy/cancel',
                                    'my/sell/cancel',
                                    'ro/my/balances',
                                    'ro/my/balances/{cointype}',
                                    'ro/my/deposits',
                                    'ro/my/withdrawals',
                                    'ro/my/transactions',
                                    'ro/my/transactions/{cointype}',
                                    'ro/my/transactions/open',
                                    'ro/my/transactions/{cointype}/open',
                                    'ro/my/sendreceive',
                                    'ro/my/affiliatepayments',
                                    'ro/my/referralpayments'
                                ]
                            }
                        },
                        'markets': {
                            'ADA/AUD': {
                                'id': 'ada',
                                'symbol': 'ADA/AUD',
                                'base': 'ADA',
                                'quote': 'AUD',
                                'baseId': 'ada',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'BTC/AUD': {
                                'id': 'btc',
                                'symbol': 'BTC/AUD',
                                'base': 'BTC',
                                'quote': 'AUD',
                                'baseId': 'btc',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'BTC/USDT': {
                                'id': 'btc',
                                'symbol': 'BTC/USDT',
                                'base': 'BTC',
                                'quote': 'USDT',
                                'baseId': 'btc',
                                'quoteId': 'usdt',
                                'type': 'spot',
                                'spot': true
                            },
                            'ETH/AUD': {
                                'id': 'eth',
                                'symbol': 'ETH/AUD',
                                'base': 'ETH',
                                'quote': 'AUD',
                                'baseId': 'eth',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'XRP/AUD': {
                                'id': 'xrp',
                                'symbol': 'XRP/AUD',
                                'base': 'XRP',
                                'quote': 'AUD',
                                'baseId': 'xrp',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'LTC/AUD': {
                                'id': 'ltc',
                                'symbol': 'LTC/AUD',
                                'base': 'LTC',
                                'quote': 'AUD',
                                'baseId': 'ltc',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'DOGE/AUD': {
                                'id': 'doge',
                                'symbol': 'DOGE/AUD',
                                'base': 'DOGE',
                                'quote': 'AUD',
                                'baseId': 'doge',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'RFOX/AUD': {
                                'id': 'rfox',
                                'symbol': 'RFOX/AUD',
                                'base': 'RFOX',
                                'quote': 'AUD',
                                'baseId': 'rfox',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'POWR/AUD': {
                                'id': 'powr',
                                'symbol': 'POWR/AUD',
                                'base': 'POWR',
                                'quote': 'AUD',
                                'baseId': 'powr',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'NEO/AUD': {
                                'id': 'neo',
                                'symbol': 'NEO/AUD',
                                'base': 'NEO',
                                'quote': 'AUD',
                                'baseId': 'neo',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'TRX/AUD': {
                                'id': 'trx',
                                'symbol': 'TRX/AUD',
                                'base': 'TRX',
                                'quote': 'AUD',
                                'baseId': 'trx',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'EOS/AUD': {
                                'id': 'eos',
                                'symbol': 'EOS/AUD',
                                'base': 'EOS',
                                'quote': 'AUD',
                                'baseId': 'eos',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'XLM/AUD': {
                                'id': 'xlm',
                                'symbol': 'XLM/AUD',
                                'base': 'XLM',
                                'quote': 'AUD',
                                'baseId': 'xlm',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'RHOC/AUD': {
                                'id': 'rhoc',
                                'symbol': 'RHOC/AUD',
                                'base': 'RHOC',
                                'quote': 'AUD',
                                'baseId': 'rhoc',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            },
                            'GAS/AUD': {
                                'id': 'gas',
                                'symbol': 'GAS/AUD',
                                'base': 'GAS',
                                'quote': 'AUD',
                                'baseId': 'gas',
                                'quoteId': 'aud',
                                'type': 'spot',
                                'spot': true
                            }
                        },
                        'commonCurrencies': {
                            'DRK': 'DASH'
                        },
                        'options': {
                            'fetchBalance': 'private_post_my_balances'
                        }
                    });
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const balances = this.safeValue2(response, 'balance', 'balances');
                    if (Array.isArray(balances)) for(let i = 0; i < balances.length; i++){
                        const currencies = balances[i];
                        const currencyIds = Object.keys(currencies);
                        for(let j = 0; j < currencyIds.length; j++){
                            const currencyId = currencyIds[j];
                            const balance = currencies[currencyId];
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            account['total'] = this.safeString(balance, 'balance');
                            result[code] = account;
                        }
                    }
                    else {
                        const currencyIds = Object.keys(balances);
                        for(let i = 0; i < currencyIds.length; i++){
                            const currencyId = currencyIds[i];
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            account['total'] = this.safeString(balances, currencyId);
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const method = this.safeString(this.options, 'fetchBalance', 'private_post_my_balances');
                    const response = await this[method](params);
                    //
                    // read-write api keys
                    //
                    //     ...
                    //
                    // read-only api keys
                    //
                    //     {
                    //         "status":"ok",
                    //         "balances":[
                    //             {
                    //                 "LTC":{"balance":0.1,"audbalance":16.59,"rate":165.95}
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'cointype': market['id']
                    };
                    const orderbook = await this.privatePostOrders(this.extend(request, params));
                    return this.parseOrderBook(orderbook, symbol, undefined, 'buyorders', 'sellorders', 'rate', 'amount');
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "btc":{
                    //             "bid":"51970",
                    //             "ask":"53000",
                    //             "last":"52806.47"
                    //         }
                    //     }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.milliseconds();
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': undefined,
                        'low': undefined,
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': undefined,
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const response = await this.publicGetLatest(params);
                    let id = market['id'];
                    id = id.toLowerCase();
                    const prices = this.safeValue(response, 'prices');
                    //
                    //     {
                    //         "status":"ok",
                    //         "prices":{
                    //             "btc":{
                    //                 "bid":"52732.47000022",
                    //                 "ask":"53268.0699976",
                    //                 "last":"53284.03"
                    //             }
                    //         }
                    //     }
                    //
                    const ticker = this.safeValue(prices, id);
                    return this.parseTicker(ticker, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'cointype': market['id']
                    };
                    const response = await this.privatePostOrdersHistory(this.extend(request, params));
                    //
                    //     {
                    //         "status":"ok",
                    //         "orders":[
                    //             {"amount":0.00102091,"rate":21549.09999991,"total":21.99969168,"coin":"BTC","solddate":1604890646143,"market":"BTC/AUD"},
                    //         ],
                    //     }
                    //
                    const trades = this.safeValue(response, 'orders', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     {
                    //         "amount":0.00102091,
                    //         "rate":21549.09999991,
                    //         "total":21.99969168,
                    //         "coin":"BTC",
                    //         "solddate":1604890646143,
                    //         "market":"BTC/AUD"
                    //     }
                    //
                    const priceString = this.safeString(trade, 'rate');
                    const amountString = this.safeString(trade, 'amount');
                    const costString = this.safeNumber(trade, 'total');
                    const timestamp = this.safeInteger(trade, 'solddate');
                    const marketId = this.safeString(trade, 'market');
                    const symbol = this.safeSymbol(marketId, market, '/');
                    return this.safeTrade({
                        'info': trade,
                        'id': undefined,
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'order': undefined,
                        'type': undefined,
                        'side': undefined,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const method = 'privatePostMy' + this.capitalize(side);
                    if (type === 'market') throw new ExchangeError1(this.id + ' createOrder() allows limit orders only');
                    const request = {
                        'cointype': this.marketId(symbol),
                        'amount': amount,
                        'rate': price
                    };
                    return await this[method](this.extend(request, params));
                }
                async cancelOrder(id, symbol, params = {}) {
                    const side = this.safeString(params, 'side');
                    if (side !== 'buy' && side !== 'sell') throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a side parameter, "buy" or "sell"');
                    params = this.omit(params, 'side');
                    const method = 'privatePostMy' + this.capitalize(side) + 'Cancel';
                    const request = {
                        'id': id
                    };
                    return await this[method](this.extend(request, params));
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const url = this.urls['api'][api] + '/' + path;
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce();
                        body = this.json(this.extend({
                            'nonce': nonce
                        }, params));
                        headers = {
                            'Content-Type': 'application/json',
                            'key': this.apiKey,
                            'sign': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    71: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, BadRequest: BadRequest, InvalidNonce: InvalidNonce, RequestTimeout: RequestTimeout, ExchangeNotAvailable: ExchangeNotAvailable, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, DDoSProtection: DDoSProtection, AuthenticationError: AuthenticationError, BadSymbol: BadSymbol, AccountSuspended: AccountSuspended, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            //  ---------------------------------------------------------------------------
            module.exports = class crex24 extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'crex24',
                        'name': 'CREX24',
                        'countries': [
                            'EE'
                        ],
                        'rateLimit': 500,
                        'version': 'v2',
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchBidsAsks': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingFees': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '3m': '3m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '4h': '4h',
                            '1d': '1d',
                            '1w': '1w',
                            '1M': '1mo'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/47813922-6f12cc00-dd5d-11e8-97c6-70f957712d47.jpg',
                            'api': 'https://api.crex24.com',
                            'www': 'https://crex24.com',
                            'referral': 'https://crex24.com/?refid=slxsjsjtil8xexl9hksr',
                            'doc': 'https://docs.crex24.com/trade-api/v2',
                            'fees': 'https://crex24.com/fees'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'currencies',
                                    'instruments',
                                    'tickers',
                                    'recentTrades',
                                    'orderBook',
                                    'ohlcv',
                                    'tradingFeeSchedules',
                                    'withdrawalFees',
                                    'currencyTransport',
                                    'currenciesWithdrawalFees'
                                ]
                            },
                            'trading': {
                                'get': [
                                    'orderStatus',
                                    'orderTrades',
                                    'activeOrders',
                                    'orderHistory',
                                    'tradeHistory',
                                    'tradingFee',
                                    'tradeFee'
                                ],
                                'post': [
                                    'placeOrder',
                                    'modifyOrder',
                                    'cancelOrdersById',
                                    'cancelOrdersByInstrument',
                                    'cancelAllOrders'
                                ]
                            },
                            'account': {
                                'get': [
                                    'balance',
                                    'depositAddress',
                                    'moneyTransfers',
                                    'moneyTransferStatus',
                                    'previewWithdrawal'
                                ],
                                'post': [
                                    'withdraw'
                                ]
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': 0.001,
                                'maker': -0.0001
                            },
                            // should be deleted, these are outdated and inaccurate
                            'funding': {
                                'tierBased': false,
                                'percentage': false,
                                'withdraw': {},
                                'deposit': {}
                            }
                        },
                        'commonCurrencies': {
                            'ACM': 'Actinium',
                            'BCC': 'BCH',
                            'BIT': 'BitMoney',
                            'BULL': 'BuySell',
                            'CLC': 'CaluraCoin',
                            'CREDIT': 'TerraCredit',
                            'DMS': 'Documentchain',
                            'EGG': 'NestEGG Coin',
                            'EPS': 'Epanus',
                            'FUND': 'FUNDChains',
                            'GHOST': 'GHOSTPRISM',
                            'GM': 'GM Holding',
                            'GMT': 'GMT Token',
                            'GTC': 'GastroCoin',
                            'IQ': 'IQ.Cash',
                            'ONE': 'One Hundred Coin',
                            'PUT': 'PutinCoin',
                            'SBTC': 'SBTCT',
                            'SPH': 'SapphireCoin',
                            'SUPER': 'SuperCoin',
                            'UNI': 'Universe',
                            'YOYO': 'YOYOW'
                        },
                        // exchange-specific options
                        'options': {
                            'networks': {
                                'ETH': 'ERC20',
                                'TRX': 'TRC20',
                                'BSC': 'BEP20'
                            },
                            'fetchOrdersMethod': 'tradingGetOrderHistory',
                            'fetchClosedOrdersMethod': 'tradingGetOrderHistory',
                            'fetchTickersMethod': 'publicGetTicker24hr',
                            'defaultTimeInForce': 'GTC',
                            'hasAlreadyAuthenticatedSuccessfully': false,
                            'warnOnFetchOpenOrdersWithoutSymbol': true,
                            'parseOrderToPrecision': false,
                            'newOrderRespType': 'RESULT',
                            'fetchTradingFees': {
                                'method': 'fetchPrivateTradingFees'
                            }
                        },
                        'exceptions': {
                            'exact': {
                                "Parameter 'filter' contains invalid value.": BadRequest,
                                "Mandatory parameter 'instrument' is missing.": BadRequest,
                                "The value of parameter 'till' must be greater than or equal to the value of parameter 'from'.": BadRequest,
                                'Failed to verify request signature.': AuthenticationError,
                                "Nonce error. Make sure that the value passed in the 'X-CREX24-API-NONCE' header is greater in each consecutive request than in the previous one for the corresponding API-Key provided in 'X-CREX24-API-KEY' header.": InvalidNonce,
                                'Market orders are not supported by the instrument currently.': InvalidOrder,
                                "Parameter 'instrument' contains invalid value.": BadSymbol,
                                "Trading has been disabled for the account until the verification is passed. To initiate the verification process, please log into your account at crex24.com and proceed to 'My account' -> 'Verification'.": AccountSuspended
                            },
                            'broad': {
                                'try again later': ExchangeNotAvailable,
                                'API Key': AuthenticationError,
                                'Insufficient funds': InsufficientFunds,
                                'has been delisted.': BadSymbol,
                                'is currently suspended.': BadSymbol,
                                'Mandatory parameter': BadRequest,
                                'can not trade': AccountSuspended
                            }
                        }
                    });
                }
                nonce() {
                    return this.milliseconds();
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetInstruments(params);
                    //
                    //         [ {
                    //             "symbol": "$PAC-BTC",
                    //             "baseCurrency": "$PAC",
                    //             "quoteCurrency": "BTC",
                    //             "feeCurrency": "BTC",
                    //             "feeSchedule": "OriginalSchedule",
                    //             "tickSize": 0.00000001,
                    //             "minPrice": 0.00000001,
                    //             "maxPrice": 10000000000.0,
                    //             "volumeIncrement": 0.00000001,
                    //             "minVolume": 1.0,
                    //             "maxVolume": 1000000000.0,
                    //             "minQuoteVolume": 0.000000000000001,
                    //             "maxQuoteVolume": 100000000000.0,
                    //             "supportedOrderTypes": [
                    //               "limit"
                    //             ],
                    //             "state": "delisted"
                    //           },
                    //           {
                    //             "symbol": "1INCH-USDT",
                    //             "baseCurrency": "1INCH",
                    //             "quoteCurrency": "USDT",
                    //             "feeCurrency": "USDT",
                    //             "feeSchedule": "FeeSchedule10",
                    //             "tickSize": 0.0001,
                    //             "minPrice": 0.0001,
                    //             "maxPrice": 10000000000.0,
                    //             "volumeIncrement": 0.00000001,
                    //             "minVolume": 0.01,
                    //             "maxVolume": 1000000000.0,
                    //             "minQuoteVolume": 0.000000000000001,
                    //             "maxQuoteVolume": 100000000000.0,
                    //             "supportedOrderTypes": [
                    //               "limit"
                    //             ],
                    //             "state": "active"
                    //           }, ]
                    //
                    const response2 = await this.publicGetTradingFeeSchedules(params);
                    //
                    //     [
                    //         {
                    //             "name": "FeeSchedule05",
                    //             "feeRates": [
                    //                 {
                    //                     "volumeThreshold": 0.0,
                    //                     "maker": 0.0005,
                    //                     "taker": 0.0005
                    //                 },
                    //                 {
                    //                     "volumeThreshold": 5.0,
                    //                     "maker": 0.0004,
                    //                     "taker": 0.0004
                    //                 },
                    //                 {
                    //                     "volumeThreshold": 15.0,
                    //                     "maker": 0.0003,
                    //                     "taker": 0.0003
                    //                 },
                    //                 {
                    //                     "volumeThreshold": 30.0,
                    //                     "maker": 0.0002,
                    //                     "taker": 0.0002
                    //                 },
                    //                 {
                    //                     "volumeThreshold": 50.0,
                    //                     "maker": 0.0001,
                    //                     "taker": 0.0001
                    //                 }
                    //             ]
                    //         },
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'symbol');
                        const baseId = this.safeString(market, 'baseCurrency');
                        const quoteId = this.safeString(market, 'quoteCurrency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        let maker = undefined;
                        let taker = undefined;
                        const feeSchedule = this.safeString(market, 'feeSchedule');
                        for(let j = 0; j < response2.length; j++){
                            const feeScheduleName = this.safeString(response2[j], 'name');
                            if (feeScheduleName === feeSchedule) {
                                const feeRates = this.safeValue(response2[j], 'feeRates', []);
                                for(let k = 0; k < feeRates.length; k++){
                                    const volumeThreshold = this.safeNumber(feeRates[k], 'volumeThreshold');
                                    if (volumeThreshold === 0) {
                                        maker = this.safeNumber(feeRates[k], 'maker');
                                        taker = this.safeNumber(feeRates[k], 'taker');
                                        break;
                                    }
                                }
                                break;
                            }
                        }
                        const state = this.safeString(market, 'state');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': state === 'active',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': taker,
                            'maker': maker,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(market, 'volumeIncrement'),
                                'price': this.safeNumber(market, 'tickSize')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minVolume'),
                                    'max': this.safeNumber(market, 'maxVolume')
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'minPrice'),
                                    'max': this.safeNumber(market, 'maxPrice')
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minQuoteVolume'),
                                    'max': this.safeNumber(market, 'maxQuoteVolume')
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     [ {                   symbol: "$PAC",
                    //                             name: "PACCoin",
                    //                           isFiat:  false,
                    //                  depositsAllowed:  true,
                    //         depositConfirmationCount:  8,
                    //                       minDeposit:  0,
                    //               withdrawalsAllowed:  true,
                    //              withdrawalPrecision:  8,
                    //                    minWithdrawal:  4,
                    //                    maxWithdrawal:  1000000000,
                    //                flatWithdrawalFee:  2,
                    //                       isDelisted:  false       },
                    //       {                   symbol: "ZZC",
                    //                             name: "Zozo",
                    //                           isFiat:  false,
                    //                  depositsAllowed:  false,
                    //         depositConfirmationCount:  8,
                    //                       minDeposit:  0,
                    //               withdrawalsAllowed:  false,
                    //              withdrawalPrecision:  8,
                    //                    minWithdrawal:  0.2,
                    //                    maxWithdrawal:  1000000000,
                    //                flatWithdrawalFee:  0.1,
                    //                       isDelisted:  false       } ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        const id = this.safeString(currency, 'symbol');
                        const code = this.safeCurrencyCode(id);
                        const withdrawalPrecision = this.safeInteger(currency, 'withdrawalPrecision');
                        const precision = Math.pow(10, -withdrawalPrecision);
                        const address = this.safeValue(currency, 'BaseAddress');
                        const deposit = this.safeValue(currency, 'depositsAllowed');
                        const withdraw = this.safeValue(currency, 'withdrawalsAllowed');
                        const delisted = this.safeValue(currency, 'isDelisted');
                        const active = deposit && withdraw && !delisted;
                        const fiat = this.safeValue(currency, 'isFiat');
                        const type = fiat ? 'fiat' : 'crypto';
                        result[code] = {
                            'id': id,
                            'code': code,
                            'address': address,
                            'info': currency,
                            'type': type,
                            'name': this.safeString(currency, 'name'),
                            'active': active,
                            'deposit': deposit,
                            'withdraw': withdraw,
                            'fee': this.safeNumber(currency, 'flatWithdrawalFee'),
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': Math.pow(10, -precision),
                                    'max': Math.pow(10, precision)
                                },
                                'deposit': {
                                    'min': this.safeNumber(currency, 'minDeposit'),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'minWithdrawal'),
                                    'max': this.safeNumber(currency, 'maxWithdrawal')
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchFundingFees(codes, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetCurrenciesWithdrawalFees(params);
                    //
                    //     [
                    //         {
                    //             currency: '1INCH',
                    //             fees: [
                    //                 { feeCurrency: 'BTC', amount: 0.00032 },
                    //                 { feeCurrency: 'ETH', amount: 0.0054 },
                    //                 { feeCurrency: 'DOGE', amount: 63.06669 },
                    //                 { feeCurrency: 'LTC', amount: 0.0912 },
                    //                 { feeCurrency: 'BCH', amount: 0.02364 },
                    //                 { feeCurrency: 'USDT', amount: 12.717 },
                    //                 { feeCurrency: 'USDC', amount: 12.7367 },
                    //                 { feeCurrency: 'TRX', amount: 205.99108 },
                    //                 { feeCurrency: 'EOS', amount: 3.30141 }
                    //             ]
                    //         }
                    //     ]
                    //
                    const withdrawFees = {};
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const currencyId = this.safeString(entry, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const networkList = this.safeValue(entry, 'fees');
                        withdrawFees[code] = {};
                        for(let j = 0; j < networkList.length; j++){
                            const networkEntry = networkList[j];
                            const networkId = this.safeString(networkEntry, 'feeCurrency');
                            const networkCode = this.safeCurrencyCode(networkId);
                            const fee = this.safeNumber(networkEntry, 'amount');
                            withdrawFees[code][networkCode] = fee;
                        }
                    }
                    return {
                        'withdraw': withdrawFees,
                        'deposit': {},
                        'info': response
                    };
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'reserved');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    const response = await this.accountGetBalance(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //           "currency": "ETH",
                    //           "available": 0.0,
                    //           "reserved": 0.0
                    //         }
                    //     ]
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default = maximum = 100
                    const response = await this.publicGetOrderBook(this.extend(request, params));
                    //
                    //     {  buyLevels: [ { price: 0.03099, volume: 0.00610063 },
                    //                     { price: 0.03097, volume: 1.33455158 },
                    //                     { price: 0.03096, volume: 0.0830889 },
                    //                     { price: 0.03095, volume: 0.0820356 },
                    //                     { price: 0.03093, volume: 0.5499419 },
                    //                     { price: 0.03092, volume: 0.23317494 },
                    //                     { price: 0.03091, volume: 0.62105322 },
                    //                     { price: 0.00620041, volume: 0.003 }    ],
                    //       sellLevels: [ { price: 0.03117, volume: 5.47492315 },
                    //                     { price: 0.03118, volume: 1.97744139 },
                    //                     { price: 0.03119, volume: 0.012 },
                    //                     { price: 0.03121, volume: 0.741242 },
                    //                     { price: 0.03122, volume: 0.96178089 },
                    //                     { price: 0.03123, volume: 0.152326 },
                    //                     { price: 0.03124, volume: 2.63462933 },
                    //                     { price: 0.069, volume: 0.004 }            ] }
                    //
                    return this.parseOrderBook(response, symbol, undefined, 'buyLevels', 'sellLevels', 'price', 'volume');
                }
                parseTicker(ticker, market) {
                    //
                    //       {    instrument: "ZZC-USD",
                    //                  last:  0.065,
                    //         percentChange:  0,
                    //                   low:  0.065,
                    //                  high:  0.065,
                    //            baseVolume:  0,
                    //           quoteVolume:  0,
                    //           volumeInBtc:  0,
                    //           volumeInUsd:  0,
                    //                   ask:  0.5,
                    //                   bid:  0.0007,
                    //             timestamp: "2018-10-31T09:21:25Z" }   ]
                    //
                    const timestamp = this.parse8601(this.safeString(ticker, 'timestamp'));
                    const marketId = this.safeString(ticker, 'instrument');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': this.safeString(ticker, 'percentChange'),
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'baseVolume'),
                        'quoteVolume': this.safeString(ticker, 'quoteVolume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument': market['id']
                    };
                    const response = await this.publicGetTickers(this.extend(request, params));
                    //
                    //     [ {    instrument: "$PAC-BTC",
                    //                  last:  3.3e-7,
                    //         percentChange:  3.125,
                    //                   low:  2.7e-7,
                    //                  high:  3.3e-7,
                    //            baseVolume:  191700.79823187,
                    //           quoteVolume:  0.0587930939346704,
                    //           volumeInBtc:  0.0587930939346704,
                    //           volumeInUsd:  376.2006339435353,
                    //                   ask:  3.3e-7,
                    //                   bid:  3.1e-7,
                    //             timestamp: "2018-10-31T09:21:25Z" }   ]
                    //
                    const numTickers = response.length;
                    if (numTickers < 1) throw new ExchangeError1(this.id + ' fetchTicker() could not load quotes for symbol ' + symbol);
                    return this.parseTicker(response[0], market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbols !== undefined) {
                        const ids = this.marketIds(symbols);
                        request['instrument'] = ids.join(',');
                    }
                    const response = await this.publicGetTickers(this.extend(request, params));
                    //
                    //     [ {    instrument: "$PAC-BTC",
                    //                  last:  3.3e-7,
                    //         percentChange:  3.125,
                    //                   low:  2.7e-7,
                    //                  high:  3.3e-7,
                    //            baseVolume:  191700.79823187,
                    //           quoteVolume:  0.0587930939346704,
                    //           volumeInBtc:  0.0587930939346704,
                    //           volumeInUsd:  376.2006339435353,
                    //                   ask:  3.3e-7,
                    //                   bid:  3.1e-7,
                    //             timestamp: "2018-10-31T09:21:25Z" },
                    //       {    instrument: "ZZC-USD",
                    //                  last:  0.065,
                    //         percentChange:  0,
                    //                   low:  0.065,
                    //                  high:  0.065,
                    //            baseVolume:  0,
                    //           quoteVolume:  0,
                    //           volumeInBtc:  0,
                    //           volumeInUsd:  0,
                    //                   ask:  0.5,
                    //                   bid:  0.0007,
                    //             timestamp: "2018-10-31T09:21:25Z" }   ]
                    //
                    return this.parseTickers(response, symbols);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //       {     price:  0.03105,
                    //            volume:  0.11,
                    //              side: "sell",
                    //         timestamp: "2018-10-31T04:19:35Z" }  ]
                    //
                    // private fetchMyTrades
                    //
                    //     {
                    //         "id": 3005866,
                    //         "orderId": 468533093,
                    //         "timestamp": "2018-06-02T16:26:27Z",
                    //         "instrument": "BCH-ETH",
                    //         "side": "buy",
                    //         "price": 1.78882,
                    //         "volume": 0.027,
                    //         "fee": 0.0000483,
                    //         "feeCurrency": "ETH"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(trade, 'timestamp'));
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'volume');
                    const id = this.safeString(trade, 'id');
                    const side = this.safeString(trade, 'side');
                    const orderId = this.safeString(trade, 'orderId');
                    const marketId = this.safeString(trade, 'instrument');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    let fee = undefined;
                    const feeCurrencyId = this.safeString(trade, 'feeCurrency');
                    const feeCode = this.safeCurrencyCode(feeCurrencyId);
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) fee = {
                        'cost': feeCostString,
                        'currency': feeCode
                    };
                    const takerOrMaker = undefined;
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': orderId,
                        'type': undefined,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': priceString,
                        'cost': undefined,
                        'amount': amountString,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // min 1, max 1000, default 100
                    const response = await this.publicGetRecentTrades(this.extend(request, params));
                    //
                    //     [ {     price:  0.03117,
                    //            volume:  0.02597403,
                    //              side: "buy",
                    //         timestamp: "2018-10-31T09:37:46Z" },
                    //       {     price:  0.03105,
                    //            volume:  0.11,
                    //              side: "sell",
                    //         timestamp: "2018-10-31T04:19:35Z" }  ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    let method = this.safeString(params, 'method');
                    params = this.omit(params, 'method');
                    if (method === undefined) {
                        const options = this.safeValue(this.options, 'fetchTradingFees', {});
                        method = this.safeString(options, 'method', 'fetchPrivateTradingFees');
                    }
                    return await this[method](params);
                }
                async fetchPublicTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTradingFeeSchedules(params);
                    //
                    //     [
                    //         {
                    //             name: 'FeeSchedule05',
                    //             feeRates: [
                    //                 { volumeThreshold: 0, maker: 0.0005, taker: 0.0005 },
                    //                 { volumeThreshold: 5, maker: 0.0004, taker: 0.0004 },
                    //                 { volumeThreshold: 15, maker: 0.0003, taker: 0.0003 },
                    //                 { volumeThreshold: 30, maker: 0.0002, taker: 0.0002 },
                    //                 { volumeThreshold: 50, maker: 0.0001, taker: 0.0001 }
                    //             ]
                    //         },
                    //         {
                    //             name: 'OriginalSchedule',
                    //             feeRates: [
                    //                 { volumeThreshold: 0, maker: -0.0001, taker: 0.001 },
                    //                 { volumeThreshold: 5, maker: -0.0002, taker: 0.0009 },
                    //                 { volumeThreshold: 15, maker: -0.0003, taker: 0.0008 },
                    //                 { volumeThreshold: 30, maker: -0.0004, taker: 0.0007 },
                    //                 { volumeThreshold: 50, maker: -0.0005, taker: 0.0006 }
                    //             ]
                    //         }
                    //     ]
                    //
                    const feeSchedulesByName = this.indexBy(response, 'name');
                    const originalSchedule = this.safeValue(feeSchedulesByName, 'OriginalSchedule', {});
                    const feeRates = this.safeValue(originalSchedule, 'feeRates', []);
                    const firstFee = this.safeValue(feeRates, 0, {});
                    const maker = this.safeNumber(firstFee, 'maker');
                    const taker = this.safeNumber(firstFee, 'taker');
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                async fetchPrivateTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.tradingGetTradingFee(params);
                    //
                    //     {
                    //         feeRates: [
                    //             { schedule: 'FeeSchedule05', maker: 0.0005, taker: 0.0005 },
                    //             { schedule: 'FeeSchedule08', maker: 0.0008, taker: 0.0008 },
                    //             { schedule: 'FeeSchedule10', maker: 0.001, taker: 0.001 },
                    //             { schedule: 'FeeSchedule15', maker: 0.0015, taker: 0.0015 },
                    //             { schedule: 'FeeSchedule20', maker: 0.002, taker: 0.002 },
                    //             { schedule: 'FeeSchedule30', maker: 0.003, taker: 0.003 },
                    //             { schedule: 'FeeSchedule40', maker: 0.004, taker: 0.004 },
                    //             { schedule: 'FeeSchedule50', maker: 0.005, taker: 0.005 },
                    //             { schedule: 'OriginalSchedule', maker: -0.0001, taker: 0.001 }
                    //         ],
                    //         tradingVolume: 0,
                    //         lastUpdate: '2022-03-16T04:55:02Z'
                    //     }
                    //
                    const feeRates = this.safeValue(response, 'feeRates', []);
                    const feeRatesBySchedule = this.indexBy(feeRates, 'schedule');
                    const originalSchedule = this.safeValue(feeRatesBySchedule, 'OriginalSchedule', {});
                    const maker = this.safeNumber(originalSchedule, 'maker');
                    const taker = this.safeNumber(originalSchedule, 'taker');
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         timestamp: '2019-09-21T10:36:00Z',
                    //         open: 0.02152,
                    //         high: 0.02156,
                    //         low: 0.02152,
                    //         close: 0.02156,
                    //         volume: 0.01741259
                    //     }
                    //
                    return [
                        this.parse8601(this.safeString(ohlcv, 'timestamp')),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'granularity': this.timeframes[timeframe],
                        'instrument': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // Accepted values: 1 - 1000. If the parameter is not specified, the number of results is limited to 100
                    const response = await this.publicGetOhlcv(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "timestamp": "2020-06-06T17:36:00Z",
                    //             "open": 0.025,
                    //             "high": 0.025,
                    //             "low": 0.02499,
                    //             "close": 0.02499,
                    //             "volume": 0.00643127
                    //         }
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'submitting': 'open',
                        // This status changes during the lifetime of an order and can have different values depending on the value of the parameter Time In Force.
                        'unfilledActive': 'open',
                        'partiallyFilledActive': 'open',
                        'filled': 'closed',
                        'partiallyFilledCancelled': 'canceled',
                        'unfilledCancelled': 'canceled'
                    };
                    return status in statuses ? statuses[status] : status;
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "id": 469594855,
                    //         "timestamp": "2018-06-08T16:59:44Z",
                    //         "instrument": "BTS-BTC",
                    //         "side": "buy",
                    //         "type": "limit",
                    //         "status": "submitting",
                    //         "cancellationReason": null,
                    //         "timeInForce": "GTC",
                    //         "volume": 4.0,
                    //         "price": 0.000025,
                    //         "stopPrice": null,
                    //         "remainingVolume": 4.0,
                    //         "lastUpdate": null,
                    //         "parentOrderId": null,
                    //         "childOrderId": null
                    //     }
                    //
                    // cancelOrder, cancelOrders, cancelAllOrders
                    //
                    //  465448358
                    //
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const marketId = this.safeString(order, 'instrument');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const timestamp = this.parse8601(this.safeString(order, 'timestamp'));
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'volume');
                    const remaining = this.safeString(order, 'remainingVolume');
                    const lastTradeTimestamp = this.parse8601(this.safeString(order, 'lastUpdate'));
                    const id = this.safeString(order, 'id', order); // if order was integer
                    const type = this.safeString(order, 'type');
                    const side = this.safeString(order, 'side');
                    const timeInForce = this.safeString(order, 'timeInForce');
                    const stopPrice = this.safeNumber(order, 'stopPrice');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': undefined,
                        'average': undefined,
                        'filled': undefined,
                        'remaining': remaining,
                        'status': status,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument': market['id'],
                        'volume': this.amountToPrecision(symbol, amount),
                        // The value must comply with the list of order types supported by the instrument (see the value of parameter supportedOrderTypes of the Instrument)
                        // If the parameter is not specified, the default value "limit" is used
                        // More about order types in the corresponding section of documentation
                        'type': type,
                        'side': side
                    };
                    let priceIsRequired = false;
                    let stopPriceIsRequired = false;
                    if (type === 'limit') priceIsRequired = true;
                    else if (type === 'stopLimit') {
                        priceIsRequired = true;
                        stopPriceIsRequired = true;
                    }
                    if (priceIsRequired) {
                        if (price === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a price argument for a ' + type + ' order');
                        request['price'] = this.priceToPrecision(symbol, price);
                    }
                    if (stopPriceIsRequired) {
                        const stopPrice = this.safeNumber(params, 'stopPrice');
                        if (stopPrice === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a stopPrice extra param for a ' + type + ' order');
                        else request['stopPrice'] = this.priceToPrecision(symbol, stopPrice);
                        params = this.omit(params, 'stopPrice');
                    }
                    const response = await this.tradingPostPlaceOrder(this.extend(request, params));
                    //
                    //     {
                    //         "id": 469594855,
                    //         "timestamp": "2018-06-08T16:59:44Z",
                    //         "instrument": "BTS-BTC",
                    //         "side": "buy",
                    //         "type": "limit",
                    //         "status": "submitting",
                    //         "cancellationReason": null,
                    //         "timeInForce": "GTC",
                    //         "volume": 4.0,
                    //         "price": 0.000025,
                    //         "stopPrice": null,
                    //         "remainingVolume": 4.0,
                    //         "lastUpdate": null,
                    //         "parentOrderId": null,
                    //         "childOrderId": null
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.tradingGetOrderStatus(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //           "id": 466747915,
                    //           "timestamp": "2018-05-26T06:43:49Z",
                    //           "instrument": "UNI-BTC",
                    //           "side": "sell",
                    //           "type": "limit",
                    //           "status": "partiallyFilledActive",
                    //           "cancellationReason": null,
                    //           "timeInForce": "GTC",
                    //           "volume": 5700.0,
                    //           "price": 0.000005,
                    //           "stopPrice": null,
                    //           "remainingVolume": 1.948051948052,
                    //           "lastUpdate": null,
                    //           "parentOrderId": null,
                    //           "childOrderId": null
                    //         }
                    //     ]
                    //
                    const numOrders = response.length;
                    if (numOrders < 1) throw new OrderNotFound(this.id + ' fetchOrder() could not fetch order id ' + id);
                    return this.parseOrder(response[0]);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (since !== undefined) request['from'] = this.ymdhms(since, 'T');
                    if (limit !== undefined) request['limit'] = limit;
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        request['instrument'] = market['id'];
                    }
                    const method = this.safeString(this.options, 'fetchOrdersMethod', 'tradingGetOrderHistory');
                    const response = await this[method](this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id": 468535711,
                    //             "timestamp": "2018-06-02T16:42:40Z",
                    //             "instrument": "BTC-EUR",
                    //             "side": "sell",
                    //             "type": "limit",
                    //             "status": "submitting",
                    //             "cancellationReason": null,
                    //             "timeInForce": "GTC",
                    //             "volume": 0.00770733,
                    //             "price": 6724.9,
                    //             "stopPrice": null,
                    //             "remainingVolume": 0.00770733,
                    //             "lastUpdate": "2018-06-02T16:42:40Z",
                    //             "parentOrderId": null,
                    //             "childOrderId": null
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response);
                }
                async fetchOrdersByIds(ids, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': ids.join(',')
                    };
                    const response = await this.tradingGetOrderStatus(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //           "id": 466747915,
                    //           "timestamp": "2018-05-26T06:43:49Z",
                    //           "instrument": "UNI-BTC",
                    //           "side": "sell",
                    //           "type": "limit",
                    //           "status": "partiallyFilledActive",
                    //           "cancellationReason": null,
                    //           "timeInForce": "GTC",
                    //           "volume": 5700.0,
                    //           "price": 0.000005,
                    //           "stopPrice": null,
                    //           "remainingVolume": 1.948051948052,
                    //           "lastUpdate": null,
                    //           "parentOrderId": null,
                    //           "childOrderId": null
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, undefined, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instrument'] = market['id'];
                    }
                    const response = await this.tradingGetActiveOrders(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id": 466747915,
                    //             "timestamp": "2018-05-26T06:43:49Z",
                    //             "instrument": "UNI-BTC",
                    //             "side": "sell",
                    //             "type": "limit",
                    //             "status": "partiallyFilledActive",
                    //             "cancellationReason": null,
                    //             "timeInForce": "GTC",
                    //             "volume": 5700.0,
                    //             "price": 0.000005,
                    //             "stopPrice": null,
                    //             "remainingVolume": 1.948051948052,
                    //             "lastUpdate": null,
                    //             "parentOrderId": null,
                    //             "childOrderId": null
                    //         },
                    //         {
                    //             "id": 466748077,
                    //             "timestamp": "2018-05-26T06:45:29Z",
                    //             "instrument": "PRJ-BTC",
                    //             "side": "sell",
                    //             "type": "limit",
                    //             "status": "partiallyFilledActive",
                    //             "cancellationReason": null,
                    //             "timeInForce": "GTC",
                    //             "volume": 10000.0,
                    //             "price": 0.0000007,
                    //             "stopPrice": null,
                    //             "remainingVolume": 9975.0,
                    //             "lastUpdate": null,
                    //             "parentOrderId": null,
                    //             "childOrderId": null
                    //         },
                    //         ...
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instrument'] = market['id'];
                    }
                    if (since !== undefined) request['from'] = this.ymdhms(since, 'T');
                    if (limit !== undefined) request['limit'] = limit; // min 1, max 1000, default 100
                    const method = this.safeString(this.options, 'fetchClosedOrdersMethod', 'tradingGetOrderHistory');
                    const response = await this[method](this.extend(request, params));
                    //     [
                    //         {
                    //             "id": 468535711,
                    //             "timestamp": "2018-06-02T16:42:40Z",
                    //             "instrument": "BTC-EUR",
                    //             "side": "sell",
                    //             "type": "limit",
                    //             "status": "submitting",
                    //             "cancellationReason": null,
                    //             "timeInForce": "GTC",
                    //             "volume": 0.00770733,
                    //             "price": 6724.9,
                    //             "stopPrice": null,
                    //             "remainingVolume": 0.00770733,
                    //             "lastUpdate": null,
                    //             "parentOrderId": null,
                    //             "childOrderId": null
                    //         },
                    //         {
                    //             "id": 468535707,
                    //             "timestamp": "2018-06-02T16:42:37Z",
                    //             "instrument": "BTG-BTC",
                    //             "side": "buy",
                    //             "type": "limit",
                    //             "status": "unfilledActive",
                    //             "cancellationReason": null,
                    //             "timeInForce": "GTC",
                    //             "volume": 0.0173737,
                    //             "price": 0.00589027,
                    //             "stopPrice": null,
                    //             "remainingVolume": 0.0173737,
                    //             "lastUpdate": null,
                    //             "parentOrderId": null,
                    //             "childOrderId": null
                    //         },
                    //         ...
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async cancelOrder(id, symbol, params = {}) {
                    const response = await this.cancelOrders([
                        id
                    ], symbol, params);
                    return this.safeValue(response, 0);
                }
                async cancelOrders(ids, symbol, params = {}) {
                    if (!Array.isArray(ids)) throw new ArgumentsRequired1(this.id + ' cancelOrders() ids argument should be an array');
                    await this.loadMarkets();
                    const request = {
                        'ids': []
                    };
                    for(let i = 0; i < ids.length; i++){
                        const id = parseInt(ids[i]);
                        request['ids'].push(id);
                    }
                    const response = await this.tradingPostCancelOrdersById(this.extend(request, params));
                    //
                    //     [
                    //         465448358,
                    //         468364313
                    //     ]
                    //
                    return this.parseOrders(response);
                }
                async cancelAllOrders(symbol, params = {}) {
                    let response = undefined;
                    let market = undefined;
                    if (symbol === undefined) response = await this.tradingPostCancelAllOrders(params);
                    else {
                        await this.loadMarkets();
                        market = this.market(symbol);
                        const request = {
                            'instruments': [
                                market['id']
                            ]
                        };
                        response = await this.tradingPostCancelOrdersByInstrument(this.extend(request, params));
                    //
                    //     [
                    //         465441234,
                    //         468364321
                    //     ]
                    //
                    }
                    return this.parseOrders(response, market, undefined, undefined, params);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.tradingGetOrderTrades(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id": 3005866,
                    //             "orderId": 468533093,
                    //             "timestamp": "2018-06-02T16:26:27Z",
                    //             "instrument": "BCH-ETH",
                    //             "side": "buy",
                    //             "price": 1.78882,
                    //             "volume": 0.027,
                    //             "fee": 0.0000483,
                    //             "feeCurrency": "ETH"
                    //         },
                    //         {
                    //             "id": 3005812,
                    //             "orderId": 468515771,
                    //             "timestamp": "2018-06-02T16:16:05Z",
                    //             "instrument": "ETC-BTC",
                    //             "side": "sell",
                    //             "price": 0.00210958,
                    //             "volume": 0.05994006,
                    //             "fee": -0.000000063224,
                    //             "feeCurrency": "BTC"
                    //         },
                    //         ...
                    //     ]
                    //
                    return this.parseTrades(response, undefined, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instrument'] = market['id'];
                    }
                    if (since !== undefined) request['from'] = this.ymdhms(since, 'T');
                    if (limit !== undefined) request['limit'] = limit; // min 1, max 1000, default 100
                    const response = await this.tradingGetTradeHistory(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id": 3005866,
                    //             "orderId": 468533093,
                    //             "timestamp": "2018-06-02T16:26:27Z",
                    //             "instrument": "BCH-ETH",
                    //             "side": "buy",
                    //             "price": 1.78882,
                    //             "volume": 0.027,
                    //             "fee": 0.0000483,
                    //             "feeCurrency": "ETH"
                    //         },
                    //         {
                    //             "id": 3005812,
                    //             "orderId": 468515771,
                    //             "timestamp": "2018-06-02T16:16:05Z",
                    //             "instrument": "ETC-BTC",
                    //             "side": "sell",
                    //             "price": 0.00210958,
                    //             "volume": 0.05994006,
                    //             "fee": -0.000000063224,
                    //             "feeCurrency": "BTC"
                    //         },
                    //         ...
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) request['from'] = this.ymdhms(since, 'T');
                    const response = await this.accountGetMoneyTransfers(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //           "id": 756446,
                    //           "type": "deposit",
                    //           "currency": "ETH",
                    //           "address": "0x451d5a1b7519aa75164f440df78c74aac96023fe",
                    //           "paymentId": null,
                    //           "amount": 0.142,
                    //           "fee": null,
                    //           "txId": "0x2b49098749840a9482c4894be94f94864b498a1306b6874687a5640cc9871918",
                    //           "createdAt": "2018-06-02T19:30:28Z",
                    //           "processedAt": "2018-06-02T21:10:41Z",
                    //           "confirmationsRequired": 12,
                    //           "confirmationCount": 12,
                    //           "status": "success",
                    //           "errorDescription": null
                    //         },
                    //         {
                    //           "id": 754618,
                    //           "type": "deposit",
                    //           "currency": "BTC",
                    //           "address": "1IgNfmERVcier4IhfGEfutkLfu4AcmeiUC",
                    //           "paymentId": null,
                    //           "amount": 0.09,
                    //           "fee": null,
                    //           "txId": "6876541687a9187e987c9187654f7198b9718af974641687b19a87987f91874f",
                    //           "createdAt": "2018-06-02T16:19:44Z",
                    //           "processedAt": "2018-06-02T16:20:50Z",
                    //           "confirmationsRequired": 1,
                    //           "confirmationCount": 1,
                    //           "status": "success",
                    //           "errorDescription": null
                    //         },
                    //         ...
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    const request = {
                        'type': 'deposit'
                    };
                    return this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    const request = {
                        'type': 'withdrawal'
                    };
                    return this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'pending': 'pending',
                        'success': 'ok',
                        'failed': 'failed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    //     {
                    //         "id": 756446,
                    //         "type": "deposit",
                    //         "currency": "ETH",
                    //         "address": "0x451d5a1b7519aa75164f440df78c74aac96023fe",
                    //         "paymentId": null,
                    //         "amount": 0.142,
                    //         "fee": null,
                    //         "txId": "0x2b49098749840a9482c4894be94f94864b498a1306b6874687a5640cc9871918",
                    //         "createdAt": "2018-06-02T19:30:28Z",
                    //         "processedAt": "2018-06-02T21:10:41Z",
                    //         "confirmationsRequired": 12,
                    //         "confirmationCount": 12,
                    //         "status": "success",
                    //         "errorDescription": null,
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const address = this.safeString(transaction, 'address');
                    const tag = this.safeString(transaction, 'paymentId');
                    const txid = this.safeValue(transaction, 'txId');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const type = this.safeString(transaction, 'type');
                    const timestamp = this.parse8601(this.safeString(transaction, 'createdAt'));
                    const updated = this.parse8601(this.safeString(transaction, 'processedAt'));
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const amount = this.safeNumber(transaction, 'amount');
                    const feeCost = this.safeNumber(transaction, 'fee');
                    const fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.accountGetDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         "currency": "BTS",
                    //         "address": "crex24",
                    //         "paymentId": "0fg4da4186741579"
                    //     }
                    //
                    const address = this.safeString(response, 'address');
                    const tag = this.safeString(response, 'paymentId');
                    return {
                        'currency': code,
                        'address': this.checkAddress(address),
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'address': address,
                        'amount': parseFloat(this.currencyToPrecision(code, amount)),
                        // sets whether the specified amount includes fee, can have either of the two values
                        // true - balance will be decreased by amount, whereas [amount - fee] will be transferred to the specified address
                        // false - amount will be deposited to the specified address, whereas the balance will be decreased by [amount + fee]
                        // 'includeFee': false, // the default value is false
                        'feeCurrency': currency['id']
                    };
                    if (tag !== undefined) request['paymentId'] = tag;
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeString(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['transport'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.accountPostWithdraw(this.extend(request, params));
                    return this.parseTransaction(response);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let request = '/' + this.version + '/' + api + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (method === 'GET') {
                        if (Object.keys(query).length) request += '?' + this.urlencode(query);
                    }
                    const url = this.urls['api'] + request;
                    if (api === 'trading' || api === 'account') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const secret = this.base64ToBinary(this.secret);
                        let auth = request + nonce;
                        headers = {
                            'X-CREX24-API-KEY': this.apiKey,
                            'X-CREX24-API-NONCE': nonce
                        };
                        if (method === 'POST') {
                            headers['Content-Type'] = 'application/json';
                            body = this.json(params);
                            auth += body;
                        }
                        headers['X-CREX24-API-SIGN'] = this.hmac(this.encode(auth), secret, 'sha512', 'base64');
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (!this.isJsonEncodedObject(body)) return; // fallback to default error handler
                    if (code >= 200 && code < 300) return; // no error
                    const message = this.safeString(response, 'errorDescription');
                    const feedback = this.id + ' ' + body;
                    this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                    this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                    if (code === 400) throw new BadRequest(feedback);
                    else if (code === 401) throw new AuthenticationError(feedback);
                    else if (code === 403) throw new AuthenticationError(feedback);
                    else if (code === 429) throw new DDoSProtection(feedback);
                    else if (code === 500) throw new ExchangeError1(feedback);
                    else if (code === 503) throw new ExchangeNotAvailable(feedback);
                    else if (code === 504) throw new RequestTimeout(feedback);
                    throw new ExchangeError1(feedback); // unknown message
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    72: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AuthenticationError: AuthenticationError, ArgumentsRequired: ArgumentsRequired1, ExchangeError: ExchangeError1, InsufficientFunds: InsufficientFunds, DDoSProtection: DDoSProtection, InvalidNonce: InvalidNonce, PermissionDenied: PermissionDenied, BadRequest: BadRequest, BadSymbol: BadSymbol, NotSupported: NotSupported, AccountNotEnabled: AccountNotEnabled } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            module.exports = class cryptocom extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'cryptocom',
                        'name': 'Crypto.com',
                        'countries': [
                            'MT'
                        ],
                        'version': 'v2',
                        'rateLimit': 10,
                        'has': {
                            'CORS': false,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchBidsAsks': false,
                            'fetchClosedOrders': 'emulated',
                            'fetchCurrencies': false,
                            'fetchDepositAddress': true,
                            'fetchDepositAddressesByNetwork': true,
                            'fetchDeposits': true,
                            'fetchFundingFees': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRates': false,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPositions': false,
                            'fetchStatus': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': false,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransactions': false,
                            'fetchTransfers': true,
                            'fetchWithdrawals': true,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '4h': '4h',
                            '6h': '6h',
                            '12h': '12h',
                            '1d': '1D',
                            '1w': '7D',
                            '2w': '14D',
                            '1M': '1M'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/147792121-38ed5e36-c229-48d6-b49a-48d05fc19ed4.jpeg',
                            'test': 'https://uat-api.3ona.co/v2',
                            'api': {
                                'spot': 'https://api.crypto.com/v2',
                                'derivatives': 'https://deriv-api.crypto.com/v1'
                            },
                            'www': 'https://crypto.com/',
                            'referral': 'https://crypto.com/exch/5835vstech',
                            'doc': 'https://exchange-docs.crypto.com/',
                            'fees': 'https://crypto.com/exchange/document/fees-limits'
                        },
                        'api': {
                            'spot': {
                                'public': {
                                    'get': {
                                        'public/auth': 1,
                                        'public/get-instruments': 1,
                                        'public/get-book': 1,
                                        'public/get-candlestick': 1,
                                        'public/get-ticker': 1,
                                        'public/get-trades': 1,
                                        'public/margin/get-transfer-currencies': 1,
                                        'public/margin/get-load-currenices': 1,
                                        'public/respond-heartbeat': 1
                                    }
                                },
                                'private': {
                                    'post': {
                                        'private/set-cancel-on-disconnect': 10 / 3,
                                        'private/get-cancel-on-disconnect': 10 / 3,
                                        'private/create-withdrawal': 10 / 3,
                                        'private/get-withdrawal-history': 10 / 3,
                                        'private/get-deposit-history': 10 / 3,
                                        'private/get-deposit-address': 10 / 3,
                                        'private/get-account-summary': 10 / 3,
                                        'private/create-order': 2 / 3,
                                        'private/cancel-order': 2 / 3,
                                        'private/cancel-all-orders': 2 / 3,
                                        'private/get-order-history': 10 / 3,
                                        'private/get-open-orders': 10 / 3,
                                        'private/get-order-detail': 1 / 3,
                                        'private/get-trades': 100,
                                        'private/margin/get-user-config': 10 / 3,
                                        'private/margin/get-account-summary': 10 / 3,
                                        'private/margin/transfer': 10 / 3,
                                        'private/margin/borrow': 10 / 3,
                                        'private/margin/repay': 10 / 3,
                                        'private/margin/get-transfer-history': 10 / 3,
                                        'private/margin/get-borrow-history': 10 / 3,
                                        'private/margin/get-interest-history': 10 / 3,
                                        'private/margin/get-repay-history': 10 / 3,
                                        'private/margin/get-liquidation-history': 10 / 3,
                                        'private/margin/get-liquidation-orders': 10 / 3,
                                        'private/margin/create-order': 2 / 3,
                                        'private/margin/cancel-order': 2 / 3,
                                        'private/margin/cancel-all-orders': 2 / 3,
                                        'private/margin/get-order-history': 10 / 3,
                                        'private/margin/get-open-orders': 10 / 3,
                                        'private/margin/get-order-detail': 1 / 3,
                                        'private/margin/get-trades': 100,
                                        'private/deriv/transfer': 10 / 3,
                                        'private/deriv/get-transfer-history': 10 / 3,
                                        'private/subaccount/get-sub-accounts': 10 / 3,
                                        'private/subaccount/get-transfer-history': 10 / 3,
                                        'private/subaccount/transfer': 10 / 3
                                    }
                                }
                            },
                            'derivatives': {
                                'public': {
                                    'get': {
                                        'public/auth': 10 / 3,
                                        'public/get-instruments': 10 / 3,
                                        'public/get-book': 1,
                                        'public/get-candlestick': 1,
                                        'public/get-trades': 1,
                                        'public/get-tickers': 1,
                                        'public/get-valuations': 1,
                                        'public/get-expired-settlement-price': 10 / 3,
                                        'public/get-insurance': 1
                                    }
                                },
                                'private': {
                                    'post': {
                                        'private/set-cancel-on-disconnect': 10 / 3,
                                        'private/get-cancel-on-disconnect': 10 / 3,
                                        'private/user-balance': 10 / 3,
                                        'private/user-balance-history': 10 / 3,
                                        'private/get-positions': 10 / 3,
                                        'private/create-order': 2 / 3,
                                        'private/cancel-order': 2 / 3,
                                        'private/cancel-all-orders': 2 / 3,
                                        'private/close-position': 10 / 3,
                                        'private/convert-collateral': 10 / 3,
                                        'private/get-order-history': 100,
                                        'private/get-open-orders': 10 / 3,
                                        'private/get-order-detail': 1 / 3,
                                        'private/get-trades': 100,
                                        'private/change-account-leverage': 10 / 3,
                                        'private/get-transactions': 10 / 3
                                    }
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.004'),
                                'taker': this.parseNumber('0.004'),
                                'tiers': {
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.004')
                                        ],
                                        [
                                            this.parseNumber('25000'),
                                            this.parseNumber('0.0035')
                                        ],
                                        [
                                            this.parseNumber('50000'),
                                            this.parseNumber('0.0015')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('0.001')
                                        ],
                                        [
                                            this.parseNumber('250000'),
                                            this.parseNumber('0.0009')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('20000000'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('100000000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('200000000'),
                                            this.parseNumber('0.0004')
                                        ]
                                    ],
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.004')
                                        ],
                                        [
                                            this.parseNumber('25000'),
                                            this.parseNumber('0.0035')
                                        ],
                                        [
                                            this.parseNumber('50000'),
                                            this.parseNumber('0.0025')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('0.0016')
                                        ],
                                        [
                                            this.parseNumber('250000'),
                                            this.parseNumber('0.00015')
                                        ],
                                        [
                                            this.parseNumber('1000000'),
                                            this.parseNumber('0.00014')
                                        ],
                                        [
                                            this.parseNumber('20000000'),
                                            this.parseNumber('0.00013')
                                        ],
                                        [
                                            this.parseNumber('100000000'),
                                            this.parseNumber('0.00012')
                                        ],
                                        [
                                            this.parseNumber('200000000'),
                                            this.parseNumber('0.0001')
                                        ]
                                    ]
                                }
                            }
                        },
                        'options': {
                            'defaultType': 'spot',
                            'accountsByType': {
                                'funding': 'SPOT',
                                'spot': 'SPOT',
                                'derivatives': 'DERIVATIVES',
                                'swap': 'DERIVATIVES',
                                'future': 'DERIVATIVES'
                            }
                        },
                        // https://exchange-docs.crypto.com/spot/index.html#response-and-reason-codes
                        'commonCurrencies': {
                            'USD_STABLE_COIN': 'USDC'
                        },
                        'exceptions': {
                            'exact': {
                                '10001': ExchangeError1,
                                '10002': PermissionDenied,
                                '10003': PermissionDenied,
                                '10004': BadRequest,
                                '10005': PermissionDenied,
                                '10006': DDoSProtection,
                                '10007': InvalidNonce,
                                '10008': BadRequest,
                                '10009': BadRequest,
                                '20001': BadRequest,
                                '20002': InsufficientFunds,
                                '20005': AccountNotEnabled,
                                '30003': BadSymbol,
                                '30004': BadRequest,
                                '30005': BadRequest,
                                '30006': BadRequest,
                                '30007': BadRequest,
                                '30008': BadRequest,
                                '30009': BadRequest,
                                '30010': BadRequest,
                                '30013': BadRequest,
                                '30014': BadRequest,
                                '30016': BadRequest,
                                '30017': BadRequest,
                                '30023': BadRequest,
                                '30024': BadRequest,
                                '30025': BadRequest,
                                '40001': BadRequest,
                                '40002': BadRequest,
                                '40003': BadRequest,
                                '40004': BadRequest,
                                '40005': BadRequest,
                                '40006': BadRequest,
                                '40007': BadRequest,
                                '40101': AuthenticationError,
                                '50001': BadRequest
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    //
                    //    {
                    //        id: 11,
                    //        method: 'public/get-instruments',
                    //        code: 0,
                    //        result: {
                    //            'instruments': [
                    //                {
                    //                    instrument_name: 'NEAR_BTC',
                    //                    quote_currency: 'BTC',
                    //                    base_currency: 'NEAR',
                    //                    price_decimals: '8',
                    //                    quantity_decimals: '2',
                    //                    margin_trading_enabled: true,
                    //                    margin_trading_enabled_5x: true,
                    //                    margin_trading_enabled_10x: true,
                    //                    max_quantity: '100000000',
                    //                    min_quantity: '0.01'
                    //               },
                    //            ]
                    //        }
                    //    }
                    //
                    const response = await this.spotPublicGetPublicGetInstruments(params);
                    const resultResponse = this.safeValue(response, 'result', {});
                    const markets = this.safeValue(resultResponse, 'instruments', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'instrument_name');
                        const baseId = this.safeString(market, 'base_currency');
                        const quoteId = this.safeString(market, 'quote_currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const priceDecimals = this.safeString(market, 'price_decimals');
                        const minPrice = this.parsePrecision(priceDecimals);
                        const minQuantity = this.safeString(market, 'min_quantity');
                        let maxLeverage = this.parseNumber('1');
                        const margin_trading_enabled_5x = this.safeValue(market, 'margin_trading_enabled_5x');
                        if (margin_trading_enabled_5x) maxLeverage = this.parseNumber('5');
                        const margin_trading_enabled_10x = this.safeValue(market, 'margin_trading_enabled_10x');
                        if (margin_trading_enabled_10x) maxLeverage = this.parseNumber('10');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': this.safeValue(market, 'margin_trading_enabled'),
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'quantity_decimals'),
                                'price': parseInt(priceDecimals)
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': maxLeverage
                                },
                                'amount': {
                                    'min': this.parseNumber(minQuantity),
                                    'max': this.safeNumber(market, 'max_quantity')
                                },
                                'price': {
                                    'min': this.parseNumber(minPrice),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.parseNumber(Precise.stringMul(minQuantity, minPrice)),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    const futuresResponse = await this.derivativesPublicGetPublicGetInstruments();
                    //
                    //     {
                    //       id: -1,
                    //       method: 'public/get-instruments',
                    //       code: 0,
                    //       result: {
                    //         data: [
                    //           {
                    //             symbol: '1INCHUSD-PERP',
                    //             inst_type: 'PERPETUAL_SWAP',
                    //             display_name: '1INCHUSD Perpetual',
                    //             base_ccy: '1INCH',
                    //             quote_ccy: 'USD_Stable_Coin',
                    //             quote_decimals: 4,
                    //             quantity_decimals: 0,
                    //             price_tick_size: '0.0001',
                    //             qty_tick_size: '1',
                    //             max_leverage: '50',
                    //             tradable: true,
                    //             expiry_timestamp_ms: 0,
                    //             beta_product: false,
                    //             underlying_symbol: '1INCHUSD-INDEX',
                    //             put_call: 'UNDEFINED',
                    //             strike: '0',
                    //             contract_size: '1'
                    //           },
                    //         ]
                    //       }
                    //     }
                    //
                    const futuresResult = this.safeValue(futuresResponse, 'result', {});
                    const data = this.safeValue(futuresResult, 'data', []);
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const inst_type = this.safeString(market, 'inst_type');
                        const swap = inst_type === 'PERPETUAL_SWAP';
                        const future = inst_type === 'FUTURE';
                        const baseId = this.safeString(market, 'base_ccy');
                        const quoteId = this.safeString(market, 'quote_ccy');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        let symbol = base + '/' + quote + ':' + quote;
                        let expiry = this.safeInteger(market, 'expiry_timestamp_ms');
                        if (expiry === 0) expiry = undefined;
                        let type = 'swap';
                        if (future) {
                            type = 'future';
                            symbol = symbol + '-' + this.yymmdd(expiry);
                        }
                        const contractSize = this.safeNumber(market, 'contract_size');
                        result.push({
                            'id': this.safeString(market, 'symbol'),
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': quote,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': quoteId,
                            'type': type,
                            'spot': false,
                            'margin': false,
                            'swap': swap,
                            'future': future,
                            'option': false,
                            'active': this.safeValue(market, 'tradable'),
                            'contract': true,
                            'linear': true,
                            'inverse': false,
                            'contractSize': contractSize,
                            'expiry': expiry,
                            'expiryDatetime': this.iso8601(expiry),
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'price': this.safeInteger(market, 'quote_decimals'),
                                'amount': this.safeInteger(market, 'quantity_decimals')
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': this.safeNumber(market, 'max_leverage')
                                },
                                'amount': {
                                    'min': this.parseNumber(contractSize),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTickers', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPublicGetPublicGetTicker',
                        'future': 'derivativesPublicGetPublicGetTickers',
                        'swap': 'derivativesPublicGetPublicGetTickers'
                    });
                    const response = await this[method](query);
                    // {
                    //     "code":0,
                    //     "method":"public/get-ticker",
                    //     "result":{
                    //       "data": [
                    //         {"i":"CRO_BTC","b":0.00000890,"k":0.00001179,"a":0.00001042,"t":1591770793901,"v":14905879.59,"h":0.00,"l":0.00,"c":0.00},
                    //         {"i":"EOS_USDT","b":2.7676,"k":2.7776,"a":2.7693,"t":1591770798500,"v":774.51,"h":0.05,"l":0.05,"c":0.00},
                    //         {"i":"BCH_USDT","b":247.49,"k":251.73,"a":251.67,"t":1591770797601,"v":1.01693,"h":0.01292,"l":0.01231,"c":-0.00047},
                    //         {"i":"ETH_USDT","b":239.92,"k":242.59,"a":240.30,"t":1591770798701,"v":0.97575,"h":0.01236,"l":0.01199,"c":-0.00018},
                    //         {"i":"ETH_CRO","b":2693.11,"k":2699.84,"a":2699.55,"t":1591770795053,"v":95.680,"h":8.218,"l":7.853,"c":-0.050}
                    //       ]
                    //     }
                    // }
                    const resultResponse = this.safeValue(response, 'result', {});
                    const tickers = this.safeValue(resultResponse, 'data', []);
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const ticker = tickers[i];
                        const marketId = this.safeString(ticker, 'i');
                        const market = this.safeMarket(marketId, undefined, '_');
                        const symbol = market['symbol'];
                        result[symbol] = this.parseTicker(ticker, market);
                    }
                    return result;
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_name': market['id']
                    };
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTicker', market, params);
                    if (marketType !== 'spot') throw new NotSupported(this.id + ' fetchTicker() only supports spot markets');
                    const response = await this.spotPublicGetPublicGetTicker(this.extend(request, query));
                    // {
                    //     "code":0,
                    //     "method":"public/get-ticker",
                    //     "result":{
                    //       "data": {"i":"CRO_BTC","b":0.00000890,"k":0.00001179,"a":0.00001042,"t":1591770793901,"v":14905879.59,"h":0.00,"l":0.00,"c":0.00}
                    //     }
                    // }
                    const resultResponse = this.safeValue(response, 'result', {});
                    const data = this.safeValue(resultResponse, 'data', {});
                    return this.parseTicker(data, market);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchClosedOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_name': market['id']
                    };
                    if (since !== undefined) // maximum date range is one day
                    request['start_ts'] = since;
                    if (limit !== undefined) request['page_size'] = limit;
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrders', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPrivatePostPrivateGetOrderHistory',
                        'future': 'derivativesPrivatePostPrivateGetOrderHistory',
                        'swap': 'derivativesPrivatePostPrivateGetOrderHistory'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    // spot
                    //     {
                    //       id: 1641026542065,
                    //       method: 'private/get-order-history',
                    //       code: 0,
                    //       result: {
                    //         order_list: [
                    //           {
                    //             status: 'FILLED',
                    //             side: 'BUY',
                    //             price: 0,
                    //             quantity: 110,
                    //             order_id: '2120246337927715937',
                    //             client_oid: '',
                    //             create_time: 1641025064904,
                    //             update_time: 1641025064958,
                    //             type: 'MARKET',
                    //             instrument_name: 'USDC_USDT',
                    //             avg_price: 1.0001,
                    //             cumulative_quantity: 110,
                    //             cumulative_value: 110.011,
                    //             fee_currency: 'USDC',
                    //             exec_inst: '',
                    //             time_in_force: 'GOOD_TILL_CANCEL'
                    //           }
                    //         ]
                    //       }
                    //     }
                    //
                    // swap
                    //     {
                    //       id: 1641026373106,
                    //       method: 'private/get-order-history',
                    //       code: 0,
                    //       result: {
                    //         data: [
                    //           {
                    //             account_id: '85ff689a-7508-4b96-aa79-dc0545d6e637',
                    //             order_id: 13191401932,
                    //             client_oid: '1641025941461',
                    //             order_type: 'LIMIT',
                    //             time_in_force: 'GOOD_TILL_CANCEL',
                    //             side: 'BUY',
                    //             exec_inst: [],
                    //             quantity: '0.0001',
                    //             limit_price: '48000.0',
                    //             order_value: '4.80000000',
                    //             maker_fee_rate: '0.00050',
                    //             taker_fee_rate: '0.00070',
                    //             avg_price: '47253.5',
                    //             trigger_price: '0.0',
                    //             ref_price_type: 'NULL_VAL',
                    //             cumulative_quantity: '0.0001',
                    //             cumulative_value: '4.72535000',
                    //             cumulative_fee: '0.00330775',
                    //             status: 'FILLED',
                    //             update_user_id: 'ce075bef-b600-4277-bd6e-ff9007251e63',
                    //             order_date: '2022-01-01',
                    //             instrument_name: 'BTCUSD-PERP',
                    //             fee_instrument_name: 'USD_Stable_Coin',
                    //             create_time: 1641025941827,
                    //             create_time_ns: '1641025941827994756',
                    //             update_time: 1641025941827
                    //           }
                    //         ]
                    //       }
                    //     }
                    //
                    const data = this.safeValue(response, 'result', {});
                    const orderList = this.safeValue2(data, 'order_list', 'data', []);
                    return this.parseOrders(orderList, market, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_name': market['id']
                    };
                    if (since !== undefined) // maximum date range is one day
                    request['start_ts'] = since;
                    if (limit !== undefined) request['page_size'] = limit;
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTrades', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPublicGetPublicGetTrades',
                        'future': 'derivativesPublicGetPublicGetTrades',
                        'swap': 'derivativesPublicGetPublicGetTrades'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     "code":0,
                    //     "method":"public/get-trades",
                    //     "result": {
                    //          "instrument_name": "BTC_USDT",
                    //          "data:": [
                    //              {"dataTime":1591710781947,"d":465533583799589409,"s":"BUY","p":2.96,"q":16.0,"t":1591710781946,"i":"ICX_CRO"},
                    //              {"dataTime":1591707701899,"d":465430234542863152,"s":"BUY","p":0.007749,"q":115.0,"t":1591707701898,"i":"VET_USDT"},
                    //              {"dataTime":1591710786155,"d":465533724976458209,"s":"SELL","p":25.676,"q":0.55,"t":1591710786154,"i":"XTZ_CRO"},
                    //              {"dataTime":1591710783300,"d":465533629172286576,"s":"SELL","p":2.9016,"q":0.6,"t":1591710783298,"i":"XTZ_USDT"},
                    //              {"dataTime":1591710784499,"d":465533669425626384,"s":"SELL","p":2.7662,"q":0.58,"t":1591710784498,"i":"EOS_USDT"},
                    //              {"dataTime":1591710784700,"d":465533676120104336,"s":"SELL","p":243.21,"q":0.01647,"t":1591710784698,"i":"ETH_USDT"},
                    //              {"dataTime":1591710786600,"d":465533739878620208,"s":"SELL","p":253.06,"q":0.00516,"t":1591710786598,"i":"BCH_USDT"},
                    //              {"dataTime":1591710786900,"d":465533749959572464,"s":"BUY","p":0.9999,"q":0.2,"t":1591710786898,"i":"USDC_USDT"},
                    //              {"dataTime":1591710787500,"d":465533770081010000,"s":"BUY","p":3.159,"q":1.65,"t":1591710787498,"i":"ATOM_USDT"},
                    //            ]
                    //      }
                    // }
                    const resultResponse = this.safeValue(response, 'result', {});
                    const data = this.safeValue(resultResponse, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_name': market['id'],
                        'timeframe': this.timeframes[timeframe]
                    };
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOHLCV', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPublicGetPublicGetCandlestick',
                        'future': 'derivativesPublicGetPublicGetCandlestick',
                        'swap': 'derivativesPublicGetPublicGetCandlestick'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     "code":0,
                    //     "method":"public/get-candlestick",
                    //     "result":{
                    //       "instrument_name":"BTC_USDT",
                    //       "interval":"5m",
                    //       "data":[
                    //         {"t":1596944700000,"o":11752.38,"h":11754.77,"l":11746.65,"c":11753.64,"v":3.694583},
                    //         {"t":1596945000000,"o":11753.63,"h":11754.77,"l":11739.83,"c":11746.17,"v":2.073019},
                    //         {"t":1596945300000,"o":11746.16,"h":11753.24,"l":11738.1,"c":11740.65,"v":0.867247},
                    //         ...
                    //       ]
                    //     }
                    // }
                    const resultResponse = this.safeValue(response, 'result', {});
                    const data = this.safeValue(resultResponse, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_name': market['id']
                    };
                    if (limit) request['depth'] = limit;
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrderBook', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPublicGetPublicGetBook',
                        'future': 'derivativesPublicGetPublicGetBook',
                        'swap': 'derivativesPublicGetPublicGetBook'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     "code":0,
                    //     "method":"public/get-book",
                    //     "result":{
                    //       "bids":[[9668.44,0.006325,1.0],[9659.75,0.006776,1.0],[9653.14,0.011795,1.0],[9647.13,0.019434,1.0],[9634.62,0.013765,1.0],[9633.81,0.021395,1.0],[9628.46,0.037834,1.0],[9627.6,0.020909,1.0],[9621.51,0.026235,1.0],[9620.83,0.026701,1.0]],
                    //       "asks":[[9697.0,0.68251,1.0],[9697.6,1.722864,2.0],[9699.2,1.664177,2.0],[9700.8,1.824953,2.0],[9702.4,0.85778,1.0],[9704.0,0.935792,1.0],[9713.32,0.002926,1.0],[9716.42,0.78923,1.0],[9732.19,0.00645,1.0],[9737.88,0.020216,1.0]],
                    //       "t":1591704180270
                    //     }
                    // }
                    const result = this.safeValue(response, 'result');
                    const data = this.safeValue(result, 'data');
                    const orderBook = this.safeValue(data, 0);
                    const timestamp = this.safeInteger(orderBook, 't');
                    return this.parseOrderBook(orderBook, symbol, timestamp);
                }
                parseSwapBalance(response) {
                    const responseResult = this.safeValue(response, 'result', {});
                    const data = this.safeValue(responseResult, 'data', []);
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < data.length; i++){
                        const balance = data[i];
                        const currencyId = this.safeString(balance, 'instrument_name');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'total_cash_balance');
                        account['free'] = this.safeString(balance, 'total_available_balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                parseSpotBalance(response) {
                    const data = this.safeValue(response, 'result', {});
                    const coinList = this.safeValue(data, 'accounts', []);
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < coinList.length; i++){
                        const balance = coinList[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'balance');
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'order');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchBalance', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPrivatePostPrivateGetAccountSummary',
                        'future': 'derivativesPrivatePostPrivateUserBalance',
                        'swap': 'derivativesPrivatePostPrivateUserBalance'
                    });
                    const response = await this[method](query);
                    // spot
                    //     {
                    //         "id": 11,
                    //         "method": "private/get-account-summary",
                    //         "code": 0,
                    //         "result": {
                    //             "accounts": [
                    //                 {
                    //                     "balance": 99999999.905000000000000000,
                    //                     "available": 99999996.905000000000000000,
                    //                     "order": 3.000000000000000000,
                    //                     "stake": 0,
                    //                     "currency": "CRO"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    // swap
                    //     {
                    //       "id" : 1641025392400,
                    //       "method" : "private/user-balance",
                    //       "code" : 0,
                    //       "result" : {
                    //         "data" : [ {
                    //           "total_available_balance" : "109.56000000",
                    //           "total_margin_balance" : "109.56000000",
                    //           "total_initial_margin" : "0.00000000",
                    //           "total_maintenance_margin" : "0.00000000",
                    //           "total_position_cost" : "0.00000000",
                    //           "total_cash_balance" : "109.56000000",
                    //           "total_collateral_value" : "109.56000000",
                    //           "total_session_unrealized_pnl" : "0.00000000",
                    //           "instrument_name" : "USD_Stable_Coin",
                    //           "total_session_realized_pnl" : "0.00000000",
                    //           "position_balances" : [ {
                    //             "quantity" : "109.56000000",
                    //             "collateral_weight" : "1.000000",
                    //             "collateral_amount" : "109.56000000",
                    //             "market_value" : "109.56000000",
                    //             "max_withdrawal_balance" : "109.56000000",
                    //             "instrument_name" : "USD_Stable_Coin"
                    //           } ],
                    //           "total_effective_leverage" : "0.000000",
                    //           "position_limit" : "3000000.00000000",
                    //           "used_position_limit" : "0.00000000",
                    //           "is_liquidating" : false
                    //         } ]
                    //       }
                    //     }
                    //
                    const parser = this.getSupportedMapping(marketType, {
                        'spot': 'parseSpotBalance',
                        'future': 'parseSwapBalance',
                        'swap': 'parseSwapBalance'
                    });
                    return this[parser](response);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {};
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrder', market, params);
                    if (marketType === 'spot') request['order_id'] = id.toString();
                    else request['order_id'] = parseInt(id);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPrivatePostPrivateGetOrderDetail',
                        'future': 'derivativesPrivatePostPrivateGetOrderDetail',
                        'swap': 'derivativesPrivatePostPrivateGetOrderDetail'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     "id": 11,
                    //     "method": "private/get-order-detail",
                    //     "code": 0,
                    //     "result": {
                    //       "trade_list": [
                    //         {
                    //           "side": "BUY",
                    //           "instrument_name": "ETH_CRO",
                    //           "fee": 0.007,
                    //           "trade_id": "371303044218155296",
                    //           "create_time": 1588902493045,
                    //           "traded_price": 7,
                    //           "traded_quantity": 7,
                    //           "fee_currency": "CRO",
                    //           "order_id": "371302913889488619"
                    //         }
                    //       ],
                    //       "order_info": {
                    //         "status": "FILLED",
                    //         "side": "BUY",
                    //         "order_id": "371302913889488619",
                    //         "client_oid": "9_yMYJDNEeqHxLqtD_2j3g",
                    //         "create_time": 1588902489144,
                    //         "update_time": 1588902493024,
                    //         "type": "LIMIT",
                    //         "instrument_name": "ETH_CRO",
                    //         "cumulative_quantity": 7,
                    //         "cumulative_value": 7,
                    //         "avg_price": 7,
                    //         "fee_currency": "CRO",
                    //         "time_in_force": "GOOD_TILL_CANCEL",
                    //         "exec_inst": "POST_ONLY"
                    //       }
                    //     }
                    // }
                    const result = this.safeValue(response, 'result', {});
                    const order = this.safeValue(result, 'order_info', result);
                    return this.parseOrder(order, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const uppercaseType = type.toUpperCase();
                    const request = {
                        'instrument_name': market['id'],
                        'side': side.toUpperCase(),
                        'type': uppercaseType,
                        'quantity': this.amountToPrecision(symbol, amount)
                    };
                    if (uppercaseType === 'LIMIT' || uppercaseType === 'STOP_LIMIT') request['price'] = this.priceToPrecision(symbol, price);
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    if (postOnly) {
                        request['exec_inst'] = 'POST_ONLY';
                        params = this.omit(params, [
                            'postOnly'
                        ]);
                    }
                    const [marketType, query] = this.handleMarketTypeAndParams('createOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPrivatePostPrivateCreateOrder',
                        'future': 'derivativesPrivatePostPrivateCreateOrder',
                        'swap': 'derivativesPrivatePostPrivateCreateOrder'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     "id": 11,
                    //     "method": "private/create-order",
                    //     "result": {
                    //       "order_id": "337843775021233500",
                    //       "client_oid": "my_order_0002"
                    //     }
                    // }
                    const result = this.safeValue(response, 'result', {});
                    return this.parseOrder(result, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {};
                    const [marketType, query] = this.handleMarketTypeAndParams('cancelAllOrders', market, params);
                    if (marketType === 'spot') {
                        if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelAllOrders() requires a symbol argument for ' + marketType + ' orders');
                        request['instrument_name'] = market['id'];
                    }
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPrivatePostPrivateCancelAllOrders',
                        'future': 'derivativesPrivatePostPrivateCancelAllOrders',
                        'swap': 'derivativesPrivatePostPrivateCancelAllOrders'
                    });
                    return await this[method](this.extend(request, query));
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {};
                    const [marketType, query] = this.handleMarketTypeAndParams('cancelOrder', market, params);
                    if (marketType === 'spot') {
                        if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument for ' + marketType + ' orders');
                        request['instrument_name'] = market['id'];
                        request['order_id'] = id.toString();
                    } else request['order_id'] = parseInt(id);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPrivatePostPrivateCancelOrder',
                        'future': 'derivativesPrivatePostPrivateCancelOrder',
                        'swap': 'derivativesPrivatePostPrivateCancelOrder'
                    });
                    const response = await this[method](this.extend(request, query));
                    const result = this.safeValue(response, 'result', response);
                    return this.parseOrder(result);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instrument_name'] = market['id'];
                    }
                    if (limit !== undefined) request['page_size'] = limit;
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOpenOrders', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPrivatePostPrivateGetOpenOrders',
                        'future': 'derivativesPrivatePostPrivateGetOpenOrders',
                        'swap': 'derivativesPrivatePostPrivateGetOpenOrders'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     "id": 11,
                    //     "method": "private/get-open-orders",
                    //     "code": 0,
                    //     "result": {
                    //       "count": 1177,
                    //       "order_list": [
                    //         {
                    //           "status": "ACTIVE",
                    //           "side": "BUY",
                    //           "price": 1,
                    //           "quantity": 1,
                    //           "order_id": "366543374673423753",
                    //           "client_oid": "my_order_0002",
                    //           "create_time": 1588760643829,
                    //           "update_time": 1588760644292,
                    //           "type": "LIMIT",
                    //           "instrument_name": "ETH_CRO",
                    //           "cumulative_quantity": 0,
                    //           "cumulative_value": 0,
                    //           "avg_price": 0,
                    //           "fee_currency": "CRO",
                    //           "time_in_force": "GOOD_TILL_CANCEL"
                    //         },
                    //         {
                    //           "status": "ACTIVE",
                    //           "side": "BUY",
                    //           "price": 1,
                    //           "quantity": 1,
                    //           "order_id": "366455245775097673",
                    //           "client_oid": "my_order_0002",
                    //           "create_time": 1588758017375,
                    //           "update_time": 1588758017411,
                    //           "type": "LIMIT",
                    //           "instrument_name": "ETH_CRO",
                    //           "cumulative_quantity": 0,
                    //           "cumulative_value": 0,
                    //           "avg_price": 0,
                    //           "fee_currency": "CRO",
                    //           "time_in_force": "GOOD_TILL_CANCEL"
                    //         }
                    //       ]
                    //     }
                    // }
                    const data = this.safeValue(response, 'result', {});
                    const resultList = this.safeValue2(data, 'order_list', 'data', []);
                    return this.parseOrders(resultList, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instrument_name'] = market['id'];
                    }
                    if (since !== undefined) {
                        // maximum date range is one day
                        request['start_ts'] = since;
                        const endTimestamp = this.sum(since, 86400000);
                        request['end_ts'] = endTimestamp;
                    }
                    if (limit !== undefined) request['page_size'] = limit;
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchMyTrades', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPrivatePostPrivateGetTrades',
                        'future': 'derivativesPrivatePostPrivateGetTrades',
                        'swap': 'derivativesPrivatePostPrivateGetTrades'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     "id": 11,
                    //     "method": "private/get-trades",
                    //     "code": 0,
                    //     "result": {
                    //       "trade_list": [
                    //         {
                    //           "side": "SELL",
                    //           "instrument_name": "ETH_CRO",
                    //           "fee": 0.014,
                    //           "trade_id": "367107655537806900",
                    //           "create_time": 1588777459755,
                    //           "traded_price": 7,
                    //           "traded_quantity": 1,
                    //           "fee_currency": "CRO",
                    //           "order_id": "367107623521528450"
                    //         }
                    //       ]
                    //     }
                    // }
                    const data = this.safeValue(response, 'result', {});
                    const resultList = this.safeValue2(data, 'trade_list', 'data', []);
                    return this.parseTrades(resultList, market, since, limit);
                }
                parseAddress(addressString) {
                    let address = undefined;
                    let tag = undefined;
                    let rawTag = undefined;
                    if (addressString.indexOf('?') > 0) {
                        [address, rawTag] = addressString.split('?');
                        const splitted = rawTag.split('=');
                        tag = splitted[1];
                    } else address = addressString;
                    return [
                        address,
                        tag
                    ];
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'amount': amount,
                        'address': address
                    };
                    if (tag !== undefined) request['address_tag'] = tag;
                    const response = await this.spotPrivatePostPrivateCreateWithdrawal(this.extend(request, params));
                    //
                    //    {
                    //        "id":-1,
                    //        "method":"private/create-withdrawal",
                    //        "code":0,
                    //        "result": {
                    //            "id": 2220,
                    //            "amount": 1,
                    //            "fee": 0.0004,
                    //            "symbol": "BTC",
                    //            "address": "2NBqqD5GRJ8wHy1PYyCXTe9ke5226FhavBf",
                    //            "client_wid": "my_withdrawal_002",
                    //            "create_time":1607063412000
                    //        }
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parseTransaction(result, currency);
                }
                async fetchDepositAddressesByNetwork(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.spotPrivatePostPrivateGetDepositAddress(this.extend(request, params));
                    // {
                    //     "id": 11,
                    //     "method": "private/get-deposit-address",
                    //     "code": 0,
                    //     "result": {
                    //          "deposit_address_list": [
                    //              {
                    //                  "currency": "CRO",
                    //                  "create_time": 1615886328000,
                    //                  "id": "12345",
                    //                  "address": "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
                    //                  "status": "1",
                    //                  "network": "CRO"
                    //              },
                    //              {
                    //                  "currency": "CRO",
                    //                  "create_time": 1615886332000,
                    //                  "id": "12346",
                    //                  "address": "yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy",
                    //                  "status": "1",
                    //                  "network": "ETH"
                    //              }
                    //          ]
                    //    }
                    // }
                    const data = this.safeValue(response, 'result', {});
                    const addresses = this.safeValue(data, 'deposit_address_list', []);
                    if (addresses.length === 0) throw new ExchangeError1(this.id + ' fetchDepositAddressesByNetwork() generating address...');
                    const result = {};
                    for(let i = 0; i < addresses.length; i++){
                        const value = this.safeValue(addresses, i);
                        const addressString = this.safeString(value, 'address');
                        const currencyId = this.safeString(value, 'currency');
                        const responseCode = this.safeCurrencyCode(currencyId);
                        const [address, tag] = this.parseAddress(addressString);
                        this.checkAddress(address);
                        const networkId = this.safeString(value, 'network');
                        const network = this.safeNetwork(networkId);
                        result[network] = {
                            'info': value,
                            'currency': responseCode,
                            'address': address,
                            'tag': tag,
                            'network': network
                        };
                    }
                    return result;
                }
                async fetchDepositAddress(code, params = {}) {
                    const network = this.safeStringUpper(params, 'network');
                    params = this.omit(params, [
                        'network'
                    ]);
                    const depositAddresses = await this.fetchDepositAddressesByNetwork(code, params);
                    if (network in depositAddresses) return depositAddresses[network];
                    else {
                        const keys = Object.keys(depositAddresses);
                        return depositAddresses[keys[0]];
                    }
                }
                safeNetwork(networkId) {
                    // stub for now
                    // TODO: figure out which networks are supported on cryptocom
                    return networkId;
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) // 90 days date range
                    request['start_ts'] = since;
                    if (limit !== undefined) request['page_size'] = limit;
                    const response = await this.spotPrivatePostPrivateGetDepositHistory(this.extend(request, params));
                    // {
                    //     "id": 11,
                    //     "method": "private/get-deposit-history",
                    //     "code": 0,
                    //     "result": {
                    //       "deposit_list": [
                    //         {
                    //           "currency": "XRP",
                    //           "fee": 1.0,
                    //           "create_time": 1607063412000,
                    //           "id": "2220",
                    //           "update_time": 1607063460000,
                    //           "amount": 100,
                    //           "address": "2NBqqD5GRJ8wHy1PYyCXTe9ke5226FhavBf?1234567890",
                    //           "status": "1"
                    //         }
                    //       ]
                    //     }
                    // }
                    const data = this.safeValue(response, 'result', {});
                    const depositList = this.safeValue(data, 'deposit_list', []);
                    return this.parseTransactions(depositList, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) // 90 days date range
                    request['start_ts'] = since;
                    if (limit !== undefined) request['page_size'] = limit;
                    const response = await this.spotPrivatePostPrivateGetWithdrawalHistory(this.extend(request, params));
                    //
                    //     {
                    //       id: 1640704829096,
                    //       method: 'private/get-withdrawal-history',
                    //       code: 0,
                    //       result: {
                    //         withdrawal_list: [
                    //           {
                    //             currency: 'DOGE',
                    //             client_wid: '',
                    //             fee: 50,
                    //             create_time: 1640425168000,
                    //             id: '3180557',
                    //             update_time: 1640425168000,
                    //             amount: 1102.64092,
                    //             address: 'DDrGGqmp5Ddo1QH9tUvDfoL4u4rqys5975',
                    //             status: '5',
                    //             txid: 'ce23e9e21b6c38eef953070a05110e6dca2fd2bcc76d3381000547b9ff5290b2/0'
                    //           }
                    //         ]
                    //       }
                    //     }
                    //
                    const data = this.safeValue(response, 'result', {});
                    const withdrawalList = this.safeValue(data, 'withdrawal_list', []);
                    return this.parseTransactions(withdrawalList, currency, since, limit);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    fromAccount = fromAccount.toLowerCase();
                    toAccount = toAccount.toLowerCase();
                    const accountsById = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsById, fromAccount, fromAccount);
                    const toId = this.safeString(accountsById, toAccount, toAccount);
                    const request = {
                        'currency': currency['id'],
                        'amount': parseFloat(amount),
                        'from': fromId,
                        'to': toId
                    };
                    const repsonse = await this.spotPrivatePostPrivateDerivTransfer(this.extend(request, params));
                    //
                    //     {
                    //         "id": 11,
                    //         "method": "private/deriv/transfer",
                    //         "code": 0
                    //     }
                    //
                    return this.parseTransfer(repsonse, currency);
                }
                async fetchTransfers(code, since, limit, params = {}) {
                    if (!('direction' in params)) throw new ArgumentsRequired1(this.id + ' fetchTransfers() requires a direction param to be either "IN" or "OUT"');
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {
                        'direction': 'OUT'
                    };
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    const response = await this.spotPrivatePostPrivateDerivGetTransferHistory(this.extend(request, params));
                    //
                    //     {
                    //       id: '1641032709328',
                    //       method: 'private/deriv/get-transfer-history',
                    //       code: '0',
                    //       result: {
                    //         transfer_list: [
                    //           {
                    //             direction: 'IN',
                    //             time: '1641025185223',
                    //             amount: '109.56',
                    //             status: 'COMPLETED',
                    //             information: 'From Spot Wallet',
                    //             currency: 'USDC'
                    //           }
                    //         ]
                    //       }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const transferList = this.safeValue(result, 'transfer_list', []);
                    return this.parseTransfers(transferList, currency, since, limit, params);
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'COMPLETED': 'ok',
                        'PROCESSING': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //       direction: 'IN',
                    //       time: '1641025185223',
                    //       amount: '109.56',
                    //       status: 'COMPLETED',
                    //       information: 'From Spot Wallet',
                    //       currency: 'USDC'
                    //     }
                    //
                    const timestamp = this.safeInteger(transfer, 'time');
                    const amount = this.safeNumber(transfer, 'amount');
                    const currencyId = this.safeString(transfer, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    const information = this.safeString(transfer, 'information');
                    let fromAccount = undefined;
                    let toAccount = undefined;
                    if (information !== undefined) {
                        const parts = information.split(' ');
                        fromAccount = this.safeStringLower(parts, 1);
                        toAccount = fromAccount === 'spot' ? 'derivative' : 'spot';
                    }
                    const rawStatus = this.safeString(transfer, 'status');
                    const status = this.parseTransferStatus(rawStatus);
                    return {
                        'info': transfer,
                        'id': this.safeString(transfer, 'id'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': code,
                        'amount': amount,
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'status': status
                    };
                }
                parseTicker(ticker, market) {
                    // {
                    //     "i":"CRO_BTC",
                    //     "b":0.00000890,
                    //     "k":0.00001179,
                    //     "a":0.00001042,
                    //     "t":1591770793901,
                    //     "v":14905879.59,
                    //     "h":0.00,
                    //     "l":0.00,
                    //     "c":0.00
                    // }
                    const timestamp = this.safeInteger(ticker, 't');
                    const marketId = this.safeString(ticker, 'i');
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    const last = this.safeString(ticker, 'a');
                    const relativeChange = this.safeString(ticker, 'c');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'h'),
                        'low': this.safeString(ticker, 'l'),
                        'bid': this.safeString(ticker, 'b'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'k'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': relativeChange,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'v'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                parseTrade(trade, market) {
                    //
                    // public/get-trades
                    //
                    // {"dataTime":1591710781947,"d":465533583799589409,"s":"BUY","p":2.96,"q":16.0,"t":1591710781946,"i":"ICX_CRO"},
                    //
                    // private/get-trades
                    //
                    // {
                    //     "side": "SELL",
                    //     "instrument_name": "ETH_CRO",
                    //     "fee": 0.014,
                    //     "trade_id": "367107655537806900",
                    //     "create_time": 1588777459755,
                    //     "traded_price": 7,
                    //     "traded_quantity": 1,
                    //     "fee_currency": "CRO",
                    //     "order_id": "367107623521528450"
                    // }
                    const timestamp = this.safeInteger2(trade, 't', 'create_time');
                    const marketId = this.safeString2(trade, 'i', 'instrument_name');
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    const price = this.safeString2(trade, 'p', 'traded_price');
                    const amount = this.safeString2(trade, 'q', 'traded_quantity');
                    let side = this.safeString2(trade, 's', 'side');
                    if (side !== undefined) side = side.toLowerCase();
                    const id = this.safeString2(trade, 'd', 'trade_id');
                    const takerOrMaker = this.safeStringLower2(trade, 'liquidity_indicator', 'taker_side');
                    const order = this.safeString(trade, 'order_id');
                    let fee = undefined;
                    let feeCost = this.safeString2(trade, 'fee', 'fees');
                    if (feeCost !== undefined) {
                        const contract = this.safeValue(market, 'contract', false);
                        if (contract) feeCost = Precise.stringNeg(feeCost);
                        let feeCurrency = undefined;
                        if (market['spot']) feeCurrency = this.safeString(trade, 'fee_currency');
                        else if (market['linear']) feeCurrency = market['quote'];
                        fee = {
                            'currency': feeCurrency,
                            'cost': feeCost
                        };
                    }
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'order': order,
                        'takerOrMaker': takerOrMaker,
                        'type': undefined,
                        'fee': fee
                    }, market);
                }
                parseOHLCV(ohlcv, market) {
                    //      {"t":1596944700000,"o":11752.38,"h":11754.77,"l":11746.65,"c":11753.64,"v":3.694583}
                    return [
                        this.safeInteger(ohlcv, 't'),
                        this.safeNumber(ohlcv, 'o'),
                        this.safeNumber(ohlcv, 'h'),
                        this.safeNumber(ohlcv, 'l'),
                        this.safeNumber(ohlcv, 'c'),
                        this.safeNumber(ohlcv, 'v')
                    ];
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'ACTIVE': 'open',
                        'CANCELED': 'canceled',
                        'FILLED': 'closed',
                        'REJECTED': 'rejected',
                        'EXPIRED': 'expired'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTimeInForce(timeInForce) {
                    const timeInForces = {
                        'GOOD_TILL_CANCEL': 'GTC',
                        'IMMEDIATE_OR_CANCEL': 'IOC',
                        'FILL_OR_KILL': 'FOK'
                    };
                    return this.safeString(timeInForces, timeInForce, timeInForce);
                }
                parseOrder(order, market) {
                    //       {
                    //         "status": "FILLED",
                    //         "side": "BUY",
                    //         "order_id": "371302913889488619",
                    //         "client_oid": "9_yMYJDNEeqHxLqtD_2j3g",
                    //         "create_time": 1588902489144,
                    //         "update_time": 1588902493024,
                    //         "type": "LIMIT",
                    //         "instrument_name": "ETH_CRO",
                    //         "cumulative_quantity": 7,
                    //         "cumulative_value": 7,
                    //         "avg_price": 7,
                    //         "fee_currency": "CRO",
                    //         "time_in_force": "GOOD_TILL_CANCEL",
                    //         "exec_inst": "POST_ONLY"
                    //       }
                    //
                    //     {
                    //       id: 1641026373106,
                    //       method: 'private/get-order-history',
                    //       code: 0,
                    //       result: {
                    //         data: [
                    //           {
                    //             account_id: '85ff689a-7508-4b96-aa79-dc0545d6e637',
                    //             order_id: 13191401932,
                    //             client_oid: '1641025941461',
                    //             order_type: 'LIMIT',
                    //             time_in_force: 'GOOD_TILL_CANCEL',
                    //             side: 'BUY',
                    //             exec_inst: [],
                    //             quantity: '0.0001',
                    //             limit_price: '48000.0',
                    //             order_value: '4.80000000',
                    //             maker_fee_rate: '0.00050',
                    //             taker_fee_rate: '0.00070',
                    //             avg_price: '47253.5',
                    //             trigger_price: '0.0',
                    //             ref_price_type: 'NULL_VAL',
                    //             cumulative_quantity: '0.0001',
                    //             cumulative_value: '4.72535000',
                    //             cumulative_fee: '0.00330775',
                    //             status: 'FILLED',
                    //             update_user_id: 'ce075bef-b600-4277-bd6e-ff9007251e63',
                    //             order_date: '2022-01-01',
                    //             instrument_name: 'BTCUSD-PERP',
                    //             fee_instrument_name: 'USD_Stable_Coin',
                    //             create_time: 1641025941827,
                    //             create_time_ns: '1641025941827994756',
                    //             update_time: 1641025941827
                    //           }
                    //         ]
                    //       }
                    //     }
                    //
                    const created = this.safeInteger(order, 'create_time');
                    const updated = this.safeInteger(order, 'update_time');
                    const marketId = this.safeString(order, 'instrument_name');
                    const symbol = this.safeSymbol(marketId, market);
                    const amount = this.safeString(order, 'quantity');
                    const filled = this.safeString(order, 'cumulative_quantity');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const id = this.safeString(order, 'order_id');
                    let clientOrderId = this.safeString(order, 'client_oid');
                    if (clientOrderId === '') clientOrderId = undefined;
                    const price = this.safeString2(order, 'price', 'limit_price');
                    const average = this.safeString(order, 'avg_price');
                    const type = this.safeStringLower2(order, 'type', 'order_type');
                    const side = this.safeStringLower(order, 'side');
                    const timeInForce = this.parseTimeInForce(this.safeString(order, 'time_in_force'));
                    const execInst = this.safeString(order, 'exec_inst');
                    let postOnly = undefined;
                    if (execInst !== undefined) postOnly = execInst === 'POST_ONLY';
                    const cost = this.safeString(order, 'cumulative_value');
                    const feeCost = this.safeString(order, 'cumulative_fee');
                    let fee = undefined;
                    if (feeCost !== undefined) {
                        const feeCurrency = this.safeString(order, 'fee_instrument_name');
                        fee = {
                            'cost': feeCost,
                            'currency': this.safeCurrencyCode(feeCurrency)
                        };
                    }
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': created,
                        'datetime': this.iso8601(created),
                        'lastTradeTimestamp': updated,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'cost': cost,
                        'fee': fee,
                        'average': average,
                        'trades': []
                    }, market);
                }
                parseDepositStatus(status) {
                    const statuses = {
                        '0': 'pending',
                        '1': 'ok',
                        '2': 'failed',
                        '3': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseWithdrawalStatus(status) {
                    const statuses = {
                        '0': 'pending',
                        '1': 'pending',
                        '2': 'failed',
                        '3': 'pending',
                        '4': 'failed',
                        '5': 'ok',
                        '6': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "currency": "XRP",
                    //         "fee": 1.0,
                    //         "create_time": 1607063412000,
                    //         "id": "2220",
                    //         "update_time": 1607063460000,
                    //         "amount": 100,
                    //         "address": "2NBqqD5GRJ8wHy1PYyCXTe9ke5226FhavBf?1234567890",
                    //         "status": "1"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "currency": "XRP",
                    //         "client_wid": "my_withdrawal_002",
                    //         "fee": 1.0,
                    //         "create_time": 1607063412000,
                    //         "id": "2220",
                    //         "update_time": 1607063460000,
                    //         "amount": 100,
                    //         "address": "2NBqqD5GRJ8wHy1PYyCXTe9ke5226FhavBf?1234567890",
                    //         "status": "1"
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "id": 2220,
                    //         "amount": 1,
                    //         "fee": 0.0004,
                    //         "symbol": "BTC",
                    //         "address": "2NBqqD5GRJ8wHy1PYyCXTe9ke5226FhavBf",
                    //         "client_wid": "my_withdrawal_002",
                    //         "create_time":1607063412000
                    //     }
                    //
                    let type = undefined;
                    const rawStatus = this.safeString(transaction, 'status');
                    let status = undefined;
                    if ('client_wid' in transaction) {
                        type = 'withdrawal';
                        status = this.parseWithdrawalStatus(rawStatus);
                    } else {
                        type = 'deposit';
                        status = this.parseDepositStatus(rawStatus);
                    }
                    const id = this.safeString(transaction, 'id');
                    const addressString = this.safeString(transaction, 'address');
                    const [address, tag] = this.parseAddress(addressString);
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const timestamp = this.safeInteger(transaction, 'create_time');
                    const amount = this.safeNumber(transaction, 'amount');
                    const txId = this.safeString(transaction, 'txid');
                    const feeCost = this.safeNumber(transaction, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'currency': code,
                        'cost': feeCost
                    };
                    const updated = this.safeInteger(transaction, 'update_time');
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'internal': undefined,
                        'fee': fee
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const [type, access] = api;
                    let url = this.urls['api'][type] + '/' + path;
                    const query = this.omit(params, this.extractParams(path));
                    if (access === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const requestParams = this.extend({}, params);
                        const keysorted = this.keysort(requestParams);
                        const paramsKeys = Object.keys(keysorted);
                        let strSortKey = '';
                        for(let i = 0; i < paramsKeys.length; i++)strSortKey = strSortKey + paramsKeys[i].toString() + requestParams[paramsKeys[i]].toString();
                        const payload = path + nonce + this.apiKey + strSortKey + nonce;
                        const signature = this.hmac(this.encode(payload), this.encode(this.secret));
                        const paramsKeysLength = paramsKeys.length;
                        body = this.json({
                            'id': nonce,
                            'method': path,
                            'params': params,
                            'api_key': this.apiKey,
                            'sig': signature,
                            'nonce': nonce
                        });
                        // fix issue https://github.com/ccxt/ccxt/issues/11179
                        // php always encodes dictionaries as arrays
                        // if an array is empty, php will put it in square brackets
                        // python and js will put it in curly brackets
                        // the code below checks and replaces those brackets in empty requests
                        if (paramsKeysLength === 0) {
                            const paramsString = '{}';
                            const arrayString = '[]';
                            body = body.replace(arrayString, paramsString);
                        }
                        headers = {
                            'Content-Type': 'application/json'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    const errorCode = this.safeString(response, 'code');
                    if (errorCode !== '0') {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        throw new ExchangeError1(this.id + ' ' + body);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    73: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { BadSymbol: BadSymbol, ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, ExchangeNotAvailable: ExchangeNotAvailable, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, DDoSProtection: DDoSProtection, InvalidNonce: InvalidNonce, AuthenticationError: AuthenticationError, BadRequest: BadRequest } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class currencycom extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'currencycom',
                        'name': 'Currency.com',
                        'countries': [
                            'BY'
                        ],
                        'rateLimit': 100,
                        'certified': true,
                        'pro': true,
                        'version': 'v2',
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': true,
                            'swap': true,
                            'future': false,
                            'option': false,
                            'addMargin': undefined,
                            'cancelAllOrders': undefined,
                            'cancelOrder': true,
                            'cancelOrders': undefined,
                            'createDepositAddress': undefined,
                            'createLimitOrder': true,
                            'createMarketOrder': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': 'emulated',
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchBidsAsks': undefined,
                            'fetchBorrowRate': undefined,
                            'fetchBorrowRateHistory': undefined,
                            'fetchBorrowRates': undefined,
                            'fetchBorrowRatesPerSymbol': undefined,
                            'fetchCanceledOrders': undefined,
                            'fetchClosedOrder': undefined,
                            'fetchClosedOrders': undefined,
                            'fetchCurrencies': true,
                            'fetchDeposit': undefined,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': false,
                            'fetchDepositAddressesByNetwork': false,
                            'fetchDeposits': true,
                            'fetchFundingFee': undefined,
                            'fetchFundingFees': undefined,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchL2OrderBook': true,
                            'fetchLedger': true,
                            'fetchLedgerEntry': false,
                            'fetchLeverage': true,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': undefined,
                            'fetchOpenOrders': true,
                            'fetchOrder': undefined,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': undefined,
                            'fetchOrders': undefined,
                            'fetchOrderTrades': undefined,
                            'fetchPosition': undefined,
                            'fetchPositions': true,
                            'fetchPositionsRisk': undefined,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTradingLimits': undefined,
                            'fetchTransactions': true,
                            'fetchTransfers': undefined,
                            'fetchWithdrawal': undefined,
                            'fetchWithdrawals': true,
                            'reduceMargin': undefined,
                            'setLeverage': undefined,
                            'setMarginMode': undefined,
                            'setPositionMode': undefined,
                            'signIn': undefined,
                            'transfer': undefined,
                            'withdraw': undefined
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '10m': '10m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '4h': '4h',
                            '1d': '1d',
                            '1w': '1w'
                        },
                        'hostname': 'backend.currency.com',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/83718672-36745c00-a63e-11ea-81a9-677b1f789a4d.jpg',
                            'api': {
                                'public': 'https://api-adapter.{hostname}/api',
                                'private': 'https://api-adapter.{hostname}/api',
                                'marketcap': 'https://marketcap.{hostname}/api'
                            },
                            'test': {
                                'public': 'https://demo-api-adapter.{hostname}/api',
                                'private': 'https://demo-api-adapter.{hostname}/api'
                            },
                            'www': 'https://www.currency.com',
                            'referral': 'https://currency.com/trading/signup?c=362jaimv&pid=referral',
                            'doc': [
                                'https://currency.com/api'
                            ],
                            'fees': 'https://currency.com/fees-charges'
                        },
                        // rate-limits are described at: https://currency.com/api-get-started
                        'api': {
                            'public': {
                                'get': {
                                    'v1/time': 1,
                                    'v1/exchangeInfo': 1,
                                    'v1/depth': 1,
                                    'v1/aggTrades': 1,
                                    'v1/klines': 1,
                                    'v1/ticker/24hr': 1,
                                    'v2/time': 1,
                                    'v2/exchangeInfo': 1,
                                    'v2/depth': 1,
                                    'v2/aggTrades': 1,
                                    'v2/klines': 1,
                                    'v2/ticker/24hr': 1
                                }
                            },
                            'marketcap': {
                                'get': {
                                    'v1/assets': 1,
                                    'v1/candles': 1,
                                    'v1/orderbook': 1,
                                    'v1/summary': 1,
                                    'v1/ticker': 1,
                                    'v1/token/assets': 1,
                                    'v1/token/orderbook': 1,
                                    'v1/token/summary': 1,
                                    'v1/token/ticker': 1,
                                    'v1/token/trades': 1,
                                    'v1/token_crypto/OHLC': 1,
                                    'v1/token_crypto/assets': 1,
                                    'v1/token_crypto/orderbook': 1,
                                    'v1/token_crypto/summary': 1,
                                    'v1/token_crypto/ticker': 1,
                                    'v1/token_crypto/trades': 1,
                                    'v1/trades': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'v1/account': 1,
                                    'v1/currencies': 1,
                                    'v1/deposits': 1,
                                    'v1/depositAddress': 1,
                                    'v1/ledger': 1,
                                    'v1/leverageSettings': 1,
                                    'v1/myTrades': 1,
                                    'v1/openOrders': 1,
                                    'v1/tradingPositions': 1,
                                    'v1/tradingPositionsHistory': 1,
                                    'v1/transactions': 1,
                                    'v1/withdrawals': 1,
                                    'v2/account': 1,
                                    'v2/currencies': 1,
                                    'v2/deposits': 1,
                                    'v2/depositAddress': 1,
                                    'v2/ledger': 1,
                                    'v2/leverageSettings': 1,
                                    'v2/myTrades': 1,
                                    'v2/openOrders': 1,
                                    'v2/tradingPositions': 1,
                                    'v2/tradingPositionsHistory': 1,
                                    'v2/transactions': 1,
                                    'v2/withdrawals': 1
                                },
                                'post': {
                                    'v1/order': 1,
                                    'v1/updateTradingPosition': 1,
                                    'v1/updateTradingOrder': 1,
                                    'v1/closeTradingPosition': 1,
                                    'v2/order': 1,
                                    'v2/updateTradingPosition': 1,
                                    'v2/updateTradingOrder': 1,
                                    'v2/closeTradingPosition': 1
                                },
                                'delete': {
                                    'v1/order': 1,
                                    'v2/order': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': false,
                                'percentage': true,
                                'taker': this.parseNumber('0.002'),
                                'maker': this.parseNumber('0.002')
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        // exchange-specific options
                        'options': {
                            'defaultTimeInForce': 'GTC',
                            'warnOnFetchOpenOrdersWithoutSymbol': true,
                            'recvWindow': 5000,
                            'timeDifference': 0,
                            'adjustForTimeDifference': false,
                            'parseOrderToPrecision': false,
                            'newOrderRespType': {
                                'market': 'FULL',
                                'limit': 'RESULT',
                                'stop': 'RESULT'
                            },
                            'leverage_markets_suffix': '_LEVERAGE',
                            'collateralCurrencies': [
                                'USD',
                                'EUR',
                                'USDT'
                            ]
                        },
                        'exceptions': {
                            'broad': {
                                'FIELD_VALIDATION_ERROR Cancel is available only for LIMIT order': InvalidOrder,
                                'API key does not exist': AuthenticationError,
                                'Order would trigger immediately.': InvalidOrder,
                                'Account has insufficient balance for requested action.': InsufficientFunds,
                                'Rest API trading is not enabled.': ExchangeNotAvailable,
                                'Combination of parameters invalid': BadRequest,
                                'Invalid limit price': BadRequest,
                                'Only leverage symbol allowed here:': BadSymbol
                            },
                            'exact': {
                                '-1000': ExchangeNotAvailable,
                                '-1013': InvalidOrder,
                                '-1021': InvalidNonce,
                                '-1022': AuthenticationError,
                                '-1030': InvalidOrder,
                                '-1100': InvalidOrder,
                                '-1104': ExchangeError1,
                                '-1025': AuthenticationError,
                                '-1128': BadRequest,
                                '-2010': ExchangeError1,
                                '-2011': OrderNotFound,
                                '-2013': OrderNotFound,
                                '-2014': AuthenticationError,
                                '-2015': AuthenticationError
                            }
                        },
                        'commonCurrencies': {
                            'ACN': 'Accenture',
                            'AMC': 'AMC Entertainment Holdings',
                            'BNS': 'Bank of Nova Scotia',
                            'CAR': 'Avis Budget Group Inc',
                            'CLR': 'Continental Resources',
                            'EDU': 'New Oriental Education & Technology Group Inc',
                            'ETN': 'Eaton',
                            'FOX': 'Fox Corporation',
                            'GM': 'General Motors Co',
                            'IQ': 'iQIYI',
                            'OSK': 'Oshkosh',
                            'PLAY': "Dave & Buster's Entertainment"
                        }
                    });
                }
                nonce() {
                    return this.milliseconds() - this.options['timeDifference'];
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetV2Time(params);
                    //
                    //     {
                    //         "serverTime": 1590998366609
                    //     }
                    //
                    return this.safeInteger(response, 'serverTime');
                }
                async fetchCurrencies(params = {}) {
                    // requires authentication
                    if (!this.checkRequiredCredentials(false)) return undefined;
                    const response = await this.privateGetV2Currencies(params);
                    //
                    //     [
                    //         {
                    //             "name": "Euro",
                    //             "displaySymbol": "EUR.cx",
                    //             "precision": "2",
                    //             "type": "FIAT",
                    //             "minWithdrawal": "90.0",
                    //             "maxWithdrawal": "1.0E+8",
                    //             "commissionMin": "0.02", // some instruments do not have this property
                    //             "commissionPercent": "1.5", // some instruments do not have this property
                    //             "minDeposit": "90.0",
                    //         },
                    //         {
                    //             name: "Bitcoin",
                    //             displaySymbol: "BTC",
                    //             precision: "8",
                    //             type: "CRYPTO", // only a few major currencies have this value, others like USDT have a value of "TOKEN"
                    //             minWithdrawal: "0.00020",
                    //             commissionFixed: "0.00010",
                    //             minDeposit: "0.00010",
                    //         },
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        const id = this.safeString(currency, 'displaySymbol');
                        const code = this.safeCurrencyCode(id);
                        const fee = this.safeNumber(currency, 'commissionFixed');
                        const precision = this.safeInteger(currency, 'precision');
                        result[code] = {
                            'id': id,
                            'code': code,
                            'address': this.safeString(currency, 'baseAddress'),
                            'type': this.safeStringLower(currency, 'type'),
                            'name': this.safeString(currency, 'name'),
                            'active': undefined,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': fee,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'minWithdrawal'),
                                    'max': this.safeNumber(currency, 'maxWithdrawal')
                                },
                                'deposit': {
                                    'min': this.safeNumber(currency, 'minDeposit'),
                                    'max': undefined
                                }
                            },
                            'info': currency
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetV2ExchangeInfo(params);
                    //
                    //     {
                    //         timezone: "UTC",
                    //         serverTime: "1645186287261",
                    //         rateLimits: [
                    //             { rateLimitType: "REQUEST_WEIGHT", interval: "MINUTE", intervalNum: "1", limit: "1200" },
                    //             { rateLimitType: "ORDERS", interval: "SECOND", intervalNum: "1", limit: "10" },
                    //             { rateLimitType: "ORDERS", interval: "DAY", intervalNum: "1", limit: "864000" },
                    //         ],
                    //         exchangeFilters: [],
                    //         symbols: [
                    //             {
                    //                 symbol: "BTC/USDT", // BTC/USDT, BTC/USDT_LEVERAGE
                    //                 name: "Bitcoin / Tether",
                    //                 status: "TRADING", // TRADING, BREAK, HALT
                    //                 baseAsset: "BTC",
                    //                 baseAssetPrecision: "4",
                    //                 quoteAsset: "USDT",
                    //                 quoteAssetId: "USDT", // USDT, USDT_LEVERAGE
                    //                 quotePrecision: "4",
                    //                 orderTypes: [ "LIMIT", "MARKET" ], // LIMIT, MARKET, STOP
                    //                 filters: [
                    //                     { filterType: "LOT_SIZE", minQty: "0.0001", maxQty: "100", stepSize: "0.0001", },
                    //                     { filterType: "MIN_NOTIONAL", minNotional: "5", },
                    //                 ],
                    //                 marketModes: [ "REGULAR" ], // CLOSE_ONLY, LONG_ONLY, REGULAR
                    //                 marketType: "SPOT", // SPOT, LEVERAGE
                    //                 longRate: -0.0684932, // LEVERAGE only
                    //                 shortRate: -0.0684932, // LEVERAGE only
                    //                 swapChargeInterval: 1440, // LEVERAGE only
                    //                 country: "",
                    //                 sector: "",
                    //                 industry: "",
                    //                 tradingHours: "UTC; Mon - 22:00, 22:05 -; Tue - 22:00, 22:05 -; Wed - 22:00, 22:05 -; Thu - 22:00, 22:05 -; Fri - 22:00, 23:01 -; Sat - 22:00, 22:05 -; Sun - 21:00, 22:05 -",
                    //                 tickSize: "0.01",
                    //                 tickValue: "403.4405", // not available in BTC/USDT_LEVERAGE, but available in BTC/USD_LEVERAGE
                    //                 exchangeFee: "0.2", // SPOT only
                    //                 tradingFee: 0.075, // LEVERAGE only
                    //                 makerFee: -0.025, // LEVERAGE only
                    //                 takerFee: 0.06, // LEVERAGE only
                    //                 maxSLGap: 50, // LEVERAGE only
                    //                 minSLGap: 1, // LEVERAGE only
                    //                 maxTPGap: 50, // LEVERAGE only
                    //                 minTPGap: 0.5, // LEVERAGE only
                    //                 assetType: "CRYPTOCURRENCY",
                    //             },
                    //         ]
                    //     }
                    //
                    if (this.options['adjustForTimeDifference']) await this.loadTimeDifference();
                    const markets = this.safeValue(response, 'symbols');
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'symbol');
                        const baseId = this.safeString(market, 'baseAsset');
                        const quoteId = this.safeString(market, 'quoteAsset');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        let symbol = base + '/' + quote;
                        const type = this.safeString(market, 'marketType');
                        const spot = type === 'SPOT';
                        const futures = false;
                        const swap = type === 'LEVERAGE';
                        const margin = swap; // as we decided to set
                        if (swap) {
                            symbol = symbol.replace(this.options['leverage_markets_suffix'], '');
                            symbol += ':' + quote;
                        }
                        const active = this.safeString(market, 'status') === 'TRADING';
                        // to set taker & maker fees, we use one from the below data - pairs either have 'exchangeFee' or 'tradingFee', if none of them (rare cases), then they should have 'takerFee & makerFee'
                        const exchangeFee = this.safeString2(market, 'exchangeFee', 'tradingFee');
                        let makerFee = this.safeString(market, 'makerFee', exchangeFee);
                        let takerFee = this.safeString(market, 'takerFee', exchangeFee);
                        makerFee = Precise.stringDiv(makerFee, '100');
                        takerFee = Precise.stringDiv(takerFee, '100');
                        const filters = this.safeValue(market, 'filters', []);
                        const filtersByType = this.indexBy(filters, 'filterType');
                        let limitPriceMin = undefined;
                        let limitPriceMax = undefined;
                        let precisionPrice = this.safeNumber(market, 'tickSize');
                        if ('PRICE_FILTER' in filtersByType) {
                            const filter = this.safeValue(filtersByType, 'PRICE_FILTER', {});
                            precisionPrice = this.safeNumber(filter, 'tickSize');
                            // PRICE_FILTER reports zero values for maxPrice
                            // since they updated filter types in November 2018
                            // https://github.com/ccxt/ccxt/issues/4286
                            // therefore limits['price']['max'] doesn't have any meaningful value except undefined
                            limitPriceMin = this.safeNumber(filter, 'minPrice');
                            const maxPrice = this.safeNumber(filter, 'maxPrice');
                            if (maxPrice !== undefined && maxPrice > 0) limitPriceMax = maxPrice;
                        }
                        let precisionAmount = this.parseNumber(this.parsePrecision(this.safeString(market, 'baseAssetPrecision')));
                        let limitAmount = {
                            'min': undefined,
                            'max': undefined
                        };
                        if ('LOT_SIZE' in filtersByType) {
                            const filter = this.safeValue(filtersByType, 'LOT_SIZE', {});
                            precisionAmount = this.safeNumber(filter, 'stepSize');
                            limitAmount = {
                                'min': this.safeNumber(filter, 'minQty'),
                                'max': this.safeNumber(filter, 'maxQty')
                            };
                        }
                        let limitMarket = {
                            'min': undefined,
                            'max': undefined
                        };
                        if ('MARKET_LOT_SIZE' in filtersByType) {
                            const filter = this.safeValue(filtersByType, 'MARKET_LOT_SIZE', {});
                            limitMarket = {
                                'min': this.safeNumber(filter, 'minQty'),
                                'max': this.safeNumber(filter, 'maxQty')
                            };
                        }
                        let costMin = undefined;
                        if ('MIN_NOTIONAL' in filtersByType) {
                            const filter = this.safeValue(filtersByType, 'MIN_NOTIONAL', {});
                            costMin = this.safeNumber(filter, 'minNotional');
                        }
                        const isContract = swap || futures;
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': type,
                            'spot': spot,
                            'margin': margin,
                            'swap': swap,
                            'future': futures,
                            'option': false,
                            'active': active,
                            'contract': isContract,
                            'linear': isContract ? true : undefined,
                            'inverse': undefined,
                            'taker': this.parseNumber(takerFee),
                            'maker': this.parseNumber(makerFee),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': precisionAmount,
                                'price': precisionPrice
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': limitAmount,
                                'market': limitMarket,
                                'price': {
                                    'min': limitPriceMin,
                                    'max': limitPriceMax
                                },
                                'cost': {
                                    'min': costMin,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchAccounts(params = {}) {
                    const response = await this.privateGetV2Account(params);
                    //
                    //     {
                    //         "makerCommission": "0.20",
                    //         "takerCommission": "0.20",
                    //         "buyerCommission": "0.20",
                    //         "sellerCommission": "0.20",
                    //         "canTrade": true,
                    //         "canWithdraw": true,
                    //         "canDeposit": true,
                    //         "updateTime": "1645266330",
                    //         "userId": "644722",
                    //         "balances": [
                    //             {
                    //                 "accountId": "120702016179403605",
                    //                 "collateralCurrency": false,
                    //                 "asset": "CAKE",
                    //                 "free": "3.1",
                    //                 "locked": "0.0",
                    //                 "default": false,
                    //             },
                    //             {
                    //                 "accountId": "109698017713125316",
                    //                 "collateralCurrency": true,
                    //                 "asset": "USD",
                    //                 "free": "17.58632",
                    //                 "locked": "0.0",
                    //                 "default": true,
                    //             }
                    //         ]
                    //     }
                    //
                    const accounts = this.safeValue(response, 'balances', []);
                    const result = [];
                    for(let i = 0; i < accounts.length; i++){
                        const account = accounts[i];
                        const accountId = this.safeInteger(account, 'accountId');
                        const currencyId = this.safeString(account, 'asset');
                        const currencyCode = this.safeCurrencyCode(currencyId);
                        result.push({
                            'id': accountId,
                            'type': undefined,
                            'currency': currencyCode,
                            'info': account
                        });
                    }
                    return result;
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetV2Account(params);
                    //
                    //    {
                    //        makerCommission: '0.20',
                    //        takerCommission: '0.20',
                    //        buyerCommission: '0.20',
                    //        sellerCommission: '0.20',
                    //        canTrade: true,
                    //        canWithdraw: true,
                    //        canDeposit: true,
                    //        updateTime: '1645738976',
                    //        userId: '-1924114235',
                    //        balances: []
                    //    }
                    //
                    const makerFee = this.safeNumber(response, 'makerCommission');
                    const takerFee = this.safeNumber(response, 'takerCommission');
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': makerFee,
                            'taker': takerFee,
                            'percentage': true,
                            'tierBased': false
                        };
                    }
                    return result;
                }
                parseBalance(response, type) {
                    //
                    //     {
                    //         "makerCommission":0.20,
                    //         "takerCommission":0.20,
                    //         "buyerCommission":0.20,
                    //         "sellerCommission":0.20,
                    //         "canTrade":true,
                    //         "canWithdraw":true,
                    //         "canDeposit":true,
                    //         "updateTime":1591056268,
                    //         "balances":[
                    //             {
                    //                 "accountId":5470306579272368,
                    //                 "collateralCurrency":true,
                    //                 "asset":"ETH",
                    //                 "free":0.0,
                    //                 "locked":0.0,
                    //                 "default":false,
                    //             },
                    //         ]
                    //     }
                    //
                    const result = {
                        'info': response
                    };
                    const balances = this.safeValue(response, 'balances', []);
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'asset');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'free');
                        account['used'] = this.safeString(balance, 'locked');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetV2Account(params);
                    //
                    //     {
                    //         "makerCommission": "0.20",
                    //         "takerCommission": "0.20",
                    //         "buyerCommission": "0.20",
                    //         "sellerCommission": "0.20",
                    //         "canTrade": true,
                    //         "canWithdraw": true,
                    //         "canDeposit": true,
                    //         "updateTime": "1645266330",
                    //         "userId": "644722",
                    //         "balances": [
                    //             {
                    //                 "accountId": "120702016179403605",
                    //                 "collateralCurrency": false,
                    //                 "asset": "CAKE",
                    //                 "free": "1.784",
                    //                 "locked": "0.0",
                    //                 "default": false,
                    //             },
                    //             {
                    //                 "accountId": "109698017413175316",
                    //                 "collateralCurrency": true,
                    //                 "asset": "USD",
                    //                 "free": "7.58632",
                    //                 "locked": "0.0",
                    //                 "default": true,
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 1000, valid limits 5, 10, 20, 50, 100, 500, 1000, 5000
                    const response = await this.publicGetV2Depth(this.extend(request, params));
                    //
                    //     {
                    //         "lastUpdateId":1590999849037,
                    //         "asks":[
                    //             [0.02495,60.0345],
                    //             [0.02496,34.1],
                    //             ...
                    //         ],
                    //         "bids":[
                    //             [0.02487,72.4144854],
                    //             [0.02486,24.043],
                    //             ...
                    //         ]
                    //     }
                    //
                    const orderbook = this.parseOrderBook(response, symbol);
                    orderbook['nonce'] = this.safeInteger(response, 'lastUpdateId');
                    return orderbook;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker
                    //
                    //     {
                    //         "symbol":"ETH/BTC",
                    //         "priceChange":"0.00030",
                    //         "priceChangePercent":"1.21",
                    //         "weightedAvgPrice":"0.02481",
                    //         "prevClosePrice":"0.02447",
                    //         "lastPrice":"0.02477",
                    //         "lastQty":"60.0",
                    //         "bidPrice":"0.02477",
                    //         "askPrice":"0.02484",
                    //         "openPrice":"0.02447",
                    //         "highPrice":"0.02524",
                    //         "lowPrice":"0.02438",
                    //         "volume":"11.97",
                    //         "quoteVolume":"0.298053",
                    //         "openTime":1590969600000,
                    //         "closeTime":1591000072693
                    //     }
                    //
                    // fetchTickers
                    //
                    //     {
                    //          "symbol": "SHIB/USD_LEVERAGE",
                    //          "weightedAvgPrice": "0.000027595",
                    //          "lastPrice": "0.00002737",
                    //          "lastQty": "1.11111111E8",
                    //          "bidPrice": "0.00002737",
                    //          "askPrice": "0.00002782",
                    //          "highPrice": "0.00002896",
                    //          "lowPrice": "0.00002738",
                    //          "volume": "16472160000",
                    //          "quoteVolume": "454796.3376",
                    //          "openTime": "1645187472000",
                    //          "closeTime": "1645273872000",
                    //     }
                    //
                    // ws:marketData.subscribe
                    //
                    //     {
                    //          "symbolName":"TXN",
                    //          "bid":139.85,
                    //          "bidQty":2500,
                    //          "ofr":139.92000000000002,
                    //          "ofrQty":2500,
                    //          "timestamp":1597850971558
                    //      }
                    //
                    const timestamp = this.safeInteger2(ticker, 'closeTime', 'timestamp');
                    const marketId = this.safeString2(ticker, 'symbol', 'symbolName');
                    market = this.safeMarket(marketId, market, '/');
                    const last = this.safeString(ticker, 'lastPrice');
                    return this.safeTicker({
                        'symbol': market['symbol'],
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'highPrice'),
                        'low': this.safeString(ticker, 'lowPrice'),
                        'bid': this.safeString2(ticker, 'bidPrice', 'bid'),
                        'bidVolume': this.safeString(ticker, 'bidQty'),
                        'ask': this.safeString2(ticker, 'askPrice', 'ofr'),
                        'askVolume': this.safeString(ticker, 'ofrQty'),
                        'vwap': this.safeString(ticker, 'weightedAvgPrice'),
                        'open': this.safeString(ticker, 'openPrice'),
                        'close': last,
                        'last': last,
                        'previousClose': this.safeString(ticker, 'prevClosePrice'),
                        'change': this.safeString(ticker, 'priceChange'),
                        'percentage': this.safeString(ticker, 'priceChangePercent'),
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': this.safeString(ticker, 'quoteVolume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetV2Ticker24hr(this.extend(request, params));
                    //
                    //     {
                    //         "symbol":"ETH/BTC",
                    //         "priceChange":"0.00030",
                    //         "priceChangePercent":"1.21",
                    //         "weightedAvgPrice":"0.02481",
                    //         "prevClosePrice":"0.02447",
                    //         "lastPrice":"0.02477",
                    //         "lastQty":"60.0",
                    //         "bidPrice":"0.02477",
                    //         "askPrice":"0.02484",
                    //         "openPrice":"0.02447",
                    //         "highPrice":"0.02524",
                    //         "lowPrice":"0.02438",
                    //         "volume":"11.97",
                    //         "quoteVolume":"0.298053",
                    //         "openTime":1590969600000,
                    //         "closeTime":1591000072693
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetV2Ticker24hr(params);
                    //
                    //     [
                    //         {
                    //              "symbol": "SHIB/USD_LEVERAGE",
                    //              "weightedAvgPrice": "0.000027595",
                    //              "lastPrice": "0.00002737",
                    //              "lastQty": "1.11111111E8",
                    //              "bidPrice": "0.00002737",
                    //              "askPrice": "0.00002782",
                    //              "highPrice": "0.00002896",
                    //              "lowPrice": "0.00002738",
                    //              "volume": "16472160000",
                    //              "quoteVolume": "454796.3376",
                    //              "openTime": "1645187472000",
                    //              "closeTime": "1645273872000",
                    //         }
                    //     ]
                    //
                    return this.parseTickers(response, symbols);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1590971040000,
                    //         "0.02454",
                    //         "0.02456",
                    //         "0.02452",
                    //         "0.02456",
                    //         249
                    //     ]
                    //
                    return [
                        this.safeInteger(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'interval': this.timeframes[timeframe]
                    };
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit; // default 500, max 1000
                    const response = await this.publicGetV2Klines(this.extend(request, params));
                    //
                    //     [
                    //         [1590971040000,"0.02454","0.02456","0.02452","0.02456",249],
                    //         [1590971100000,"0.02455","0.02457","0.02452","0.02456",300],
                    //         [1590971160000,"0.02455","0.02456","0.02453","0.02454",286],
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public aggregate trades)
                    //
                    //     {
                    //         "a":"1658318071",    // Aggregate tradeId
                    //         "p":"0.02476",       // Price
                    //         "q":"0.0",           // Official doc says: "Quantity (should be ignored)"
                    //         "T":"1591001423382", // Epoch timestamp in MS
                    //         "m":false            // Was the buyer the maker
                    //     }
                    //
                    // createOrder fills (private)
                    //
                    //     {
                    //         "price": "9807.05",
                    //         "qty": "0.01",
                    //         "commission": "0",
                    //         "commissionAsset": "dUSD"
                    //     }
                    //
                    // fetchMyTrades
                    //
                    //     {
                    //         "symbol": "DOGE/USD",
                    //         "id": "116046000",
                    //         "orderId": "00000000-0000-0000-0000-000006dbb8ad",
                    //         "price": "0.14094",
                    //         "qty": "40.0",
                    //         "commission": "0.01",
                    //         "commissionAsset": "USD",
                    //         "time": "1645283022351",
                    //         "buyer": false,
                    //         "maker": false,
                    //         "isBuyer": false,
                    //         "isMaker": false
                    //     }
                    //
                    const timestamp = this.safeInteger2(trade, 'T', 'time');
                    const priceString = this.safeString2(trade, 'p', 'price');
                    const amountString = this.safeString2(trade, 'q', 'qty');
                    const id = this.safeString2(trade, 'a', 'id');
                    let side = undefined;
                    const orderId = this.safeString(trade, 'orderId');
                    let takerOrMaker = undefined;
                    if ('m' in trade) {
                        side = trade['m'] ? 'sell' : 'buy'; // this is reversed intentionally [TODO: needs reason to be mentioned]
                        takerOrMaker = 'taker'; // in public trades, it's always taker
                    } else if ('isBuyer' in trade) {
                        side = trade['isBuyer'] ? 'buy' : 'sell'; // this is a true side
                        takerOrMaker = trade['isMaker'] ? 'maker' : 'taker';
                    }
                    let fee = undefined;
                    if ('commission' in trade) fee = {
                        'cost': this.safeString(trade, 'commission'),
                        'currency': this.safeCurrencyCode(this.safeString(trade, 'commissionAsset'))
                    };
                    const marketId = this.safeString(trade, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    return this.safeTrade({
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 500, max 1000
                    if (since !== undefined) request['startTime'] = since;
                    const response = await this.publicGetV2AggTrades(this.extend(request, params));
                    //
                    // [
                    //     {
                    //         "a":"1658318071",    // Aggregate tradeId
                    //         "p":"0.02476",       // Price
                    //         "q":"0.0",           // Official doc says: "Quantity (should be ignored)"
                    //         "T":"1591001423382", // Epoch timestamp in MS
                    //         "m":false            // Was the buyer the maker
                    //     },
                    // ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    // limit
                    //
                    //     {
                    //         "symbol": "BTC/USD",
                    //         "orderId": "00000000-0000-0000-0000-000006eacaa0",
                    //         "transactTime": "1645281669295",
                    //         "price": "30000.00000000",
                    //         "origQty": "0.0002",
                    //         "executedQty": "0.0",  // positive for BUY, negative for SELL
                    //         "status": "NEW",
                    //         "timeInForce": "GTC",
                    //         "type": "LIMIT",
                    //         "side": "BUY",
                    //     }
                    //
                    // market
                    //
                    //     {
                    //         "symbol": "DOGE/USD",
                    //         "orderId": "00000000-0000-0000-0000-000006eab2ad",
                    //         "transactTime": "1645283022252",
                    //         "price": "0.14066000",
                    //         "origQty": "40",
                    //         "executedQty": "40.0",  // positive for BUY, negative for SELL
                    //         "status": "FILLED",
                    //         "timeInForce": "FOK",
                    //         "type": "MARKET",
                    //         "side": "SELL",
                    //         "fills": [
                    //             {
                    //                 "price": "0.14094",
                    //                 "qty": "40.0",
                    //                 "commission": "0",
                    //                 "commissionAsset": "dUSD",
                    //             },
                    //         ],
                    //     }
                    //
                    // cancelOrder
                    //
                    //     {
                    //         "symbol": "DOGE/USD",
                    //         "orderId": "00000000-0000-0003-0000-000006db714c",
                    //         "price": "0.13",
                    //         "origQty": "30.0",
                    //         "executedQty": "0.0",
                    //         "status": "CANCELED",
                    //         "timeInForce": "GTC",
                    //         "type": "LIMIT",
                    //         "side": "BUY",
                    //     }
                    //
                    // fetchOpenOrders
                    //
                    //   {
                    //       "symbol": "DOGE/USD",
                    //       "orderId": "00000000-0000-0003-0000-000004bcc27a",
                    //       "price": "0.13",
                    //       "origQty": "39.0",
                    //       "executedQty": "0.0",
                    //       "status": "NEW",
                    //       "timeInForce": "GTC",
                    //       "type": "LIMIT",
                    //       "side": "BUY",
                    //       "time": "1645284216240",
                    //       "updateTime": "1645284216240",
                    //       "leverage": false, // whether it's swap or not
                    //       "working": true,
                    //   }
                    //
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '/');
                    const id = this.safeString(order, 'orderId');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'origQty');
                    const filledRaw = this.safeString(order, 'executedQty');
                    const filled = Precise.stringAbs(filledRaw);
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const timeInForce = this.parseOrderTimeInForce(this.safeString(order, 'timeInForce'));
                    const type = this.parseOrderType(this.safeString(order, 'type'));
                    const side = this.parseOrderSide(this.safeString(order, 'side'));
                    const timestamp = this.safeInteger2(order, 'time', 'transactTime');
                    const fills = this.safeValue(order, 'fills');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'average': undefined,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': undefined,
                        'trades': fills
                    }, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'NEW': 'open',
                        'PARTIALLY_FILLED': 'open',
                        'FILLED': 'closed',
                        'CANCELED': 'canceled',
                        'PENDING_CANCEL': 'canceling',
                        'REJECTED': 'rejected',
                        'EXPIRED': 'expired'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrderType(status) {
                    const statuses = {
                        'MARKET': 'market',
                        'LIMIT': 'limit',
                        'STOP': 'stop'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrderTimeInForce(status) {
                    const statuses = {
                        'GTC': 'GTC',
                        'FOK': 'FOK',
                        'IOC': 'IOC'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrderSide(status) {
                    const statuses = {
                        'BUY': 'buy',
                        'SELL': 'sell'
                    };
                    return this.safeString(statuses, status, status);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let accountId = undefined;
                    if (market['margin']) {
                        accountId = this.safeString(this.options, 'accountId');
                        accountId = this.safeString(params, 'accountId', accountId);
                        if (accountId === undefined) throw new ArgumentsRequired1(this.id + " createOrder() requires an accountId parameter or an exchange.options['accountId'] option for " + market['type'] + ' markets');
                    }
                    const newOrderRespType = this.safeValue(this.options['newOrderRespType'], type, 'RESULT');
                    const request = {
                        'symbol': market['id'],
                        'quantity': this.amountToPrecision(symbol, amount),
                        'type': type.toUpperCase(),
                        'side': side.toUpperCase(),
                        'newOrderRespType': newOrderRespType
                    };
                    if (type === 'limit') {
                        request['price'] = this.priceToPrecision(symbol, price);
                        request['timeInForce'] = this.options['defaultTimeInForce'];
                    } else {
                        if (type === 'stop') {
                            request['type'] = 'STOP';
                            request['price'] = this.priceToPrecision(symbol, price);
                        } else if (type === 'market') {
                            const stopPrice = this.safeNumber(params, 'stopPrice');
                            params = this.omit(params, 'stopPrice');
                            if (stopPrice !== undefined) {
                                request['type'] = 'STOP';
                                request['price'] = this.priceToPrecision(symbol, stopPrice);
                            }
                        }
                    }
                    const response = await this.privatePostV2Order(this.extend(request, params));
                    //
                    // limit
                    //
                    //     {
                    //         "symbol": "BTC/USD",
                    //         "orderId": "00000000-0000-0000-0000-000006eaaaa0",
                    //         "transactTime": "1645281669295",
                    //         "price": "30000.00000000",
                    //         "origQty": "0.0002",
                    //         "executedQty": "0.0",  // positive for BUY, negative for SELL
                    //         "status": "NEW",
                    //         "timeInForce": "GTC",
                    //         "type": "LIMIT",
                    //         "side": "BUY",
                    //     }
                    //
                    // market
                    //
                    //     {
                    //         "symbol": "DOGE/USD",
                    //         "orderId": "00000000-0000-0000-0000-000006eab8ad",
                    //         "transactTime": "1645283022252",
                    //         "price": "0.14066000",
                    //         "origQty": "40",
                    //         "executedQty": "40.0",  // positive for BUY, negative for SELL
                    //         "status": "FILLED",
                    //         "timeInForce": "FOK",
                    //         "type": "MARKET",
                    //         "side": "BUY",
                    //         "fills": [
                    //             {
                    //                 "price": "0.14094",
                    //                 "qty": "40.0",
                    //                 "commission": "0",
                    //                 "commissionAsset": "dUSD"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    } else if (this.options['warnOnFetchOpenOrdersWithoutSymbol']) {
                        const symbols = this.symbols;
                        const numSymbols = symbols.length;
                        const fetchOpenOrdersRateLimit = parseInt(numSymbols / 2);
                        throw new ExchangeError1(this.id + ' fetchOpenOrders() WARNING: fetching open orders without specifying a symbol is rate-limited to one call per ' + fetchOpenOrdersRateLimit.toString() + ' seconds. Do not call this method frequently to avoid ban. Set ' + this.id + '.options["warnOnFetchOpenOrdersWithoutSymbol"] = false to suppress this warning message.');
                    }
                    const response = await this.privateGetV2OpenOrders(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "symbol": "DOGE/USD",
                    //             "orderId": "00000000-0000-0003-0000-000004bac57a",
                    //             "price": "0.13",
                    //             "origQty": "39.0",
                    //             "executedQty": "0.0",  // positive for BUY, negative for SELL
                    //             "status": "NEW",
                    //             "timeInForce": "GTC",
                    //             "type": "LIMIT",
                    //             "side": "BUY",
                    //             "time": "1645284216240",
                    //             "updateTime": "1645284216240",
                    //             "leverage": false,
                    //             "working": true
                    //         },
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit, params);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const origClientOrderId = this.safeValue(params, 'origClientOrderId');
                    const request = {
                        'symbol': market['id']
                    };
                    if (origClientOrderId === undefined) request['orderId'] = id;
                    else request['origClientOrderId'] = origClientOrderId;
                    const response = await this.privateDeleteV2Order(this.extend(request, params));
                    //
                    //     {
                    //         "symbol": "DOGE/USD",
                    //         "orderId": "00000000-0000-0003-0000-000006db764c",
                    //         "price": "0.13",
                    //         "origQty": "30.0",
                    //         "executedQty": "0.0",  // positive for BUY, negative for SELL
                    //         "status": "CANCELED",
                    //         "timeInForce": "GTC",
                    //         "type": "LIMIT",
                    //         "side": "BUY",
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetV2MyTrades(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "symbol": "DOGE/USD",
                    //             "id": "116046000",
                    //             "orderId": "00000000-0000-0000-0000-000006dbb8ad",
                    //             "price": "0.14094",
                    //             "qty": "40.0",
                    //             "commission": "0.01",
                    //             "commissionAsset": "USD",
                    //             "time": "1645283022351",
                    //             "buyer": false,
                    //             "maker": false,
                    //             "isBuyer": false,
                    //             "isMaker": false
                    //         },
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    return await this.fetchTransactionsByMethod('privateGetV2Deposits', code, since, limit, params);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    return await this.fetchTransactionsByMethod('privateGetV2Withdrawals', code, since, limit, params);
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    return await this.fetchTransactionsByMethod('privateGetV2Transactions', code, since, limit, params);
                }
                async fetchTransactionsByMethod(method, code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    //     [
                    //       {
                    //         "id": "616769213",
                    //         "balance": "2.088",
                    //         "amount": "1.304",   // negative for 'withdrawal'
                    //         "currency": "CAKE",
                    //         "type": "deposit",
                    //         "timestamp": "1645282121023",
                    //         "paymentMethod": "BLOCKCHAIN",
                    //         "blockchainTransactionHash": "0x57c68c1f2ae74d5eda5a2a00516361d241a5c9e1ee95bf32573523857c38c112",
                    //         "status": "PROCESSED",
                    //         "commission": "0.14", // this property only exists in withdrawal
                    //       },
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit, params);
                }
                parseTransaction(transaction, currency) {
                    const id = this.safeString(transaction, 'id');
                    const txHash = this.safeString(transaction, 'blockchainTransactionHash');
                    const amount = this.safeNumber(transaction, 'amount');
                    const timestamp = this.safeInteger(transaction, 'timestamp');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const state = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    const type = this.parseTransactionType(this.safeString(transaction, 'type'));
                    const feeCost = this.safeString(transaction, 'commission');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'currency': code,
                        'cost': feeCost
                    };
                    const result = {
                        'id': id,
                        'txid': txHash,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': state,
                        'updated': undefined,
                        'comment': undefined,
                        'fee': fee,
                        'info': transaction
                    };
                    return result;
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'APPROVAL': 'pending',
                        'PROCESSED': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransactionType(type) {
                    const types = {
                        'deposit': 'deposit',
                        'withdrawal': 'withdrawal'
                    };
                    return this.safeString(types, type, type);
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetV2Ledger(this.extend(request, params));
                    // in the below example, first item expresses withdrawal/deposit type, second example expresses trade
                    //
                    // [
                    //     {
                    //       "id": "619031398",
                    //       "balance": "0.0",
                    //       "amount": "-1.088",
                    //       "currency": "CAKE",
                    //       "type": "withdrawal",
                    //       "timestamp": "1645460496425",
                    //       "commission": "0.13",
                    //       "paymentMethod": "BLOCKCHAIN", // present in withdrawal/deposit
                    //       "blockchainTransactionHash": "0x400ac905557c3d34638b1c60eba110b3ee0f97f4eb0f7318015ab76e7f16b7d6", // present in withdrawal/deposit
                    //       "status": "PROCESSED"
                    //     },
                    //     {
                    //       "id": "619031034",
                    //       "balance": "8.17223588",
                    //       "amount": "-0.01326294",
                    //       "currency": "USD",
                    //       "type": "exchange_commission",
                    //       "timestamp": "1645460461235",
                    //       "commission": "0.01326294",
                    //       "status": "PROCESSED"
                    //     },
                    // ]
                    //
                    return this.parseLedger(response, currency, since, limit);
                }
                parseLedgerEntry(item, currency) {
                    const id = this.safeString(item, 'id');
                    const amountString = this.safeString(item, 'amount');
                    const amount = Precise.stringAbs(amountString);
                    const timestamp = this.safeInteger(item, 'timestamp');
                    const currencyId = this.safeString(item, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const feeCost = this.safeString(item, 'commission');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'currency': code,
                        'cost': feeCost
                    };
                    const direction = Precise.stringLt(amountString, '0') ? 'out' : 'in';
                    const result = {
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'direction': direction,
                        'account': undefined,
                        'referenceId': this.safeString(item, 'blockchainTransactionHash'),
                        'referenceAccount': undefined,
                        'type': this.parseLedgerEntryType(this.safeString(item, 'type')),
                        'currency': code,
                        'amount': amount,
                        'before': undefined,
                        'after': this.safeString(item, 'balance'),
                        'status': this.parseLedgerEntryStatus(this.safeString(item, 'status')),
                        'fee': fee,
                        'info': item
                    };
                    return result;
                }
                parseLedgerEntryStatus(status) {
                    const statuses = {
                        'APPROVAL': 'pending',
                        'PROCESSED': 'ok',
                        'CANCELLED': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'deposit': 'transaction',
                        'withdrawal': 'transaction',
                        'exchange_commission': 'fee'
                    };
                    return this.safeString(types, type, type);
                }
                async fetchLeverage(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.privateGetV2LeverageSettings(this.extend(request, params));
                    //
                    // {
                    //     "values": [ 1, 2, 5, 10, ],
                    //     "value": "10",
                    // }
                    //
                    return this.safeNumber(response, 'value');
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin': currency['id']
                    };
                    const response = await this.privateGetV2DepositAddress(this.extend(request, params));
                    //
                    //     { "address":"0x97d64eb014ac779194991e7264f01c74c90327f0" }
                    //
                    return this.parseDepositAddress(response, currency);
                }
                parseDepositAddress(depositAddress, currency) {
                    const address = this.safeString(depositAddress, 'address');
                    this.checkAddress(address);
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'currency': currency['code'],
                        'address': address,
                        'tag': undefined,
                        'network': undefined,
                        'info': depositAddress
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/' + path;
                    if (path === 'historicalTrades') headers = {
                        'X-MBX-APIKEY': this.apiKey
                    };
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        let query = this.urlencode(this.extend({
                            'timestamp': this.nonce(),
                            'recvWindow': this.options['recvWindow']
                        }, params));
                        const signature = this.hmac(this.encode(query), this.encode(this.secret));
                        query += "&signature=" + signature;
                        headers = {
                            'X-MBX-APIKEY': this.apiKey
                        };
                        if (method === 'GET' || method === 'DELETE') url += '?' + query;
                        else {
                            body = query;
                            headers['Content-Type'] = 'application/x-www-form-urlencoded';
                        }
                    } else if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    url = this.implodeHostname(url);
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetV2TradingPositions(params);
                    //
                    // {
                    //     "positions": [
                    //       {
                    //         "accountId": "109698017416453793",
                    //         "id": "00a18490-0079-54c4-0000-0000803e73d3",
                    //         "instrumentId": "45463225268524228",
                    //         "orderId": "00a18490-0079-54c4-0000-0000803e73d2",
                    //         "openQuantity": "13.6",
                    //         "openPrice": "0.75724",
                    //         "closeQuantity": "0.0",
                    //         "closePrice": "0",
                    //         "rpl": "-0.007723848",
                    //         "rplConverted": "0",
                    //         "upl": "-0.006664",
                    //         "uplConverted": "-0.006664",
                    //         "swap": "0",
                    //         "swapConverted": "0",
                    //         "fee": "-0.007723848",
                    //         "dividend": "0",
                    //         "margin": "0.2",
                    //         "state": "ACTIVE",
                    //         "currency": "USD",
                    //         "createdTimestamp": "1645473877236",
                    //         "openTimestamp": "1645473877193",
                    //         "type": "NET",
                    //         "cost": "2.0583600",
                    //         "symbol": "XRP/USD_LEVERAGE"
                    //       }
                    //     ]
                    // }
                    //
                    const data = this.safeValue(response, 'positions', []);
                    return this.parsePositions(data);
                }
                parsePositions(positions) {
                    const result = [];
                    for(let i = 0; i < positions.length; i++)result.push(this.parsePosition(positions[i]));
                    return result;
                }
                parsePosition(position, market) {
                    market = this.safeMarket(this.safeString(position, 'symbol'), market);
                    const symbol = market['symbol'];
                    const timestamp = this.safeNumber(position, 'createdTimestamp');
                    const quantityRaw = this.safeString(position, 'openQuantity');
                    const side = Precise.stringGt(quantityRaw, '0') ? 'long' : 'short';
                    const quantity = Precise.stringAbs(quantityRaw);
                    const entryPrice = this.safeNumber(position, 'openPrice');
                    const unrealizedProfit = this.safeNumber(position, 'upl');
                    const marginCoeff = this.safeString(position, 'margin');
                    const leverage = Precise.stringDiv('1', marginCoeff);
                    return {
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'contracts': this.parseNumber(quantity),
                        'contractSize': undefined,
                        'entryPrice': entryPrice,
                        'collateral': undefined,
                        'side': side,
                        // 'realizedProfit': this.safeNumber (position, 'rpl'),
                        'unrealizedProfit': unrealizedProfit,
                        'leverage': leverage,
                        'percentage': undefined,
                        'marginMode': undefined,
                        'marginType': undefined,
                        'notional': undefined,
                        'markPrice': undefined,
                        'liquidationPrice': undefined,
                        'initialMargin': undefined,
                        'initialMarginPercentage': undefined,
                        'maintenanceMargin': this.parseNumber(marginCoeff),
                        'maintenanceMarginPercentage': undefined,
                        'marginRatio': undefined,
                        'info': position
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (httpCode === 418 || httpCode === 429) throw new DDoSProtection(this.id + ' ' + httpCode.toString() + ' ' + reason + ' ' + body);
                    // error response in a form: { "code": -1013, "msg": "Invalid quantity." }
                    // following block cointains legacy checks against message patterns in "msg" property
                    // will switch "code" checks eventually, when we know all of them
                    if (httpCode >= 400) {
                        if (body.indexOf('Price * QTY is zero or less') >= 0) throw new InvalidOrder(this.id + ' order cost = amount * price is zero or less ' + body);
                        if (body.indexOf('LOT_SIZE') >= 0) throw new InvalidOrder(this.id + ' order amount should be evenly divisible by lot size ' + body);
                        if (body.indexOf('PRICE_FILTER') >= 0) throw new InvalidOrder(this.id + ' order price is invalid, i.e. exceeds allowed price precision, exceeds min price or max price limits or is invalid float value in general, use this.priceToPrecision (symbol, amount) ' + body);
                    }
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //     {"code":-1128,"msg":"Combination of optional parameters invalid."}
                    //
                    const errorCode = this.safeString(response, 'code');
                    if (errorCode !== undefined && errorCode !== '0') {
                        const feedback = this.id + ' ' + this.json(response);
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        const message = this.safeString(response, 'msg');
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    74: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, InsufficientFunds: InsufficientFunds, BadRequest: BadRequest, BadSymbol: BadSymbol, InvalidOrder: InvalidOrder, AuthenticationError: AuthenticationError, ArgumentsRequired: ArgumentsRequired1, OrderNotFound: OrderNotFound, ExchangeNotAvailable: ExchangeNotAvailable } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            //  ---------------------------------------------------------------------------
            module.exports = class delta extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'delta',
                        'name': 'Delta Exchange',
                        'countries': [
                            'VC'
                        ],
                        'rateLimit': 300,
                        'version': 'v2',
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchLedger': true,
                            'fetchLeverageTiers': false,
                            'fetchMarketLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrderBook': true,
                            'fetchPosition': true,
                            'fetchPositions': true,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '3m': '3m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '2h': '2h',
                            '4h': '4h',
                            '6h': '6h',
                            '1d': '1d',
                            '7d': '7d',
                            '1w': '1w',
                            '2w': '2w',
                            '1M': '30d'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/99450025-3be60a00-2931-11eb-9302-f4fd8d8589aa.jpg',
                            'test': {
                                'public': 'https://testnet-api.delta.exchange',
                                'private': 'https://testnet-api.delta.exchange'
                            },
                            'api': {
                                'public': 'https://api.delta.exchange',
                                'private': 'https://api.delta.exchange'
                            },
                            'www': 'https://www.delta.exchange',
                            'doc': [
                                'https://docs.delta.exchange'
                            ],
                            'fees': 'https://www.delta.exchange/fees',
                            'referral': 'https://www.delta.exchange/app/signup/?code=IULYNB'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'assets',
                                    'settings',
                                    'indices',
                                    'products',
                                    'tickers',
                                    'tickers/{symbol}',
                                    'l2orderbook/{symbol}',
                                    'trades/{symbol}',
                                    'history/candles',
                                    'history/sparklines'
                                ]
                            },
                            'private': {
                                'get': [
                                    'orders',
                                    'orders/leverage',
                                    'positions',
                                    'positions/margined',
                                    'orders/history',
                                    'fills',
                                    'fills/history/download/csv',
                                    'wallet/balances',
                                    'wallet/transactions',
                                    'wallet/transactions/download',
                                    'deposits/address'
                                ],
                                'post': [
                                    'orders',
                                    'orders/batch',
                                    'orders/leverage',
                                    'positions/change_margin'
                                ],
                                'put': [
                                    'orders',
                                    'orders/batch'
                                ],
                                'delete': [
                                    'orders',
                                    'orders/all',
                                    'orders/batch'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': 0.0015,
                                'maker': 0.001,
                                'tiers': {
                                    'taker': [
                                        [
                                            0,
                                            0.0015
                                        ],
                                        [
                                            100,
                                            0.0013
                                        ],
                                        [
                                            250,
                                            0.0013
                                        ],
                                        [
                                            1000,
                                            0.001
                                        ],
                                        [
                                            5000,
                                            0.0009
                                        ],
                                        [
                                            10000,
                                            0.00075
                                        ],
                                        [
                                            20000,
                                            0.00065
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            0,
                                            0.001
                                        ],
                                        [
                                            100,
                                            0.001
                                        ],
                                        [
                                            250,
                                            0.0009
                                        ],
                                        [
                                            1000,
                                            0.00075
                                        ],
                                        [
                                            5000,
                                            0.0006
                                        ],
                                        [
                                            10000,
                                            0.0005
                                        ],
                                        [
                                            20000,
                                            0.0005
                                        ]
                                    ]
                                }
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': false
                        },
                        'exceptions': {
                            'exact': {
                                // Margin required to place order with selected leverage and quantity is insufficient.
                                'insufficient_margin': InsufficientFunds,
                                'order_size_exceed_available': InvalidOrder,
                                'risk_limits_breached': BadRequest,
                                'invalid_contract': BadSymbol,
                                'immediate_liquidation': InvalidOrder,
                                'out_of_bankruptcy': InvalidOrder,
                                'self_matching_disrupted_post_only': InvalidOrder,
                                'immediate_execution_post_only': InvalidOrder,
                                'bad_schema': BadRequest,
                                'invalid_api_key': AuthenticationError,
                                'invalid_signature': AuthenticationError,
                                'open_order_not_found': OrderNotFound,
                                'unavailable': ExchangeNotAvailable
                            },
                            'broad': {}
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetSettings(params);
                    // full response sample under `fetchStatus`
                    const result = this.safeValue(response, 'result', {});
                    return this.safeIntegerProduct(result, 'server_time', 0.001);
                }
                async fetchStatus(params = {}) {
                    const response = await this.publicGetSettings(params);
                    //
                    //     {
                    //         "result": {
                    //           "deto_liquidity_mining_daily_reward": "40775",
                    //           "deto_msp": "1.0",
                    //           "deto_staking_daily_reward": "23764.08",
                    //           "enabled_wallets": [
                    //             "BTC",
                    //             ...
                    //           ],
                    //           "portfolio_margin_params": {
                    //             "enabled_portfolios": {
                    //               ".DEAVAXUSDT": {
                    //                 "asset_id": 5,
                    //                 "futures_contingency_margin_percent": "1",
                    //                 "interest_rate": "0",
                    //                 "maintenance_margin_multiplier": "0.8",
                    //                 "max_price_shock": "20",
                    //                 "max_short_notional_limit": "2000",
                    //                 "options_contingency_margin_percent": "1",
                    //                 "options_discount_range": "10",
                    //                 "options_liq_band_range_percentage": "25",
                    //                 "settling_asset": "USDT",
                    //                 "sort_priority": 5,
                    //                 "underlying_asset": "AVAX",
                    //                 "volatility_down_shock": "30",
                    //                 "volatility_up_shock": "45"
                    //               },
                    //               ...
                    //             },
                    //             "portfolio_enabled_contracts": [
                    //               "futures",
                    //               "perpetual_futures",
                    //               "call_options",
                    //               "put_options"
                    //             ]
                    //           },
                    //           "server_time": 1650640673500273,
                    //           "trade_farming_daily_reward": "100000",
                    //           "circulating_supply": "140000000",
                    //           "circulating_supply_update_time": "1636752800",
                    //           "deto_referral_mining_daily_reward": "0",
                    //           "deto_total_reward_pool": "100000000",
                    //           "deto_trade_mining_daily_reward": "0",
                    //           "kyc_deposit_limit": "20",
                    //           "kyc_withdrawal_limit": "10000",
                    //           "maintenance_start_time": "1650387600000000",
                    //           "msp_deto_commission_percent": "25",
                    //           "under_maintenance": "false"
                    //         },
                    //         "success": true
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const underMaintenance = this.safeString(result, 'under_maintenance');
                    const status = underMaintenance === 'true' ? 'maintenance' : 'ok';
                    const updated = this.safeIntegerProduct(result, 'server_time', 0.001, this.milliseconds());
                    return {
                        'status': status,
                        'updated': updated,
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetAssets(params);
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "base_withdrawal_fee":"0.0005",
                    //                 "deposit_status":"enabled",
                    //                 "id":2,
                    //                 "interest_credit":true,
                    //                 "interest_slabs":[
                    //                     {"limit":"0.1","rate":"0"},
                    //                     {"limit":"1","rate":"0.05"},
                    //                     {"limit":"5","rate":"0.075"},
                    //                     {"limit":"10","rate":"0.1"},
                    //                     {"limit":"9999999999999999","rate":"0"}
                    //                 ],
                    //                 "kyc_deposit_limit":"10",
                    //                 "kyc_withdrawal_limit":"2",
                    //                 "min_withdrawal_amount":"0.001",
                    //                 "minimum_precision":4,
                    //                 "name":"Bitcoin",
                    //                 "precision":8,
                    //                 "sort_priority":1,
                    //                 "symbol":"BTC",
                    //                 "variable_withdrawal_fee":"0",
                    //                 "withdrawal_status":"enabled"
                    //             },
                    //         ],
                    //         "success":true
                    //     }
                    //
                    const currencies = this.safeValue(response, 'result', []);
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'symbol');
                        const numericId = this.safeInteger(currency, 'id');
                        const code = this.safeCurrencyCode(id);
                        const depositStatus = this.safeString(currency, 'deposit_status');
                        const withdrawalStatus = this.safeString(currency, 'withdrawal_status');
                        const depositsEnabled = depositStatus === 'enabled';
                        const withdrawalsEnabled = withdrawalStatus === 'enabled';
                        const active = depositsEnabled && withdrawalsEnabled;
                        const precision = this.safeInteger(currency, 'precision');
                        result[code] = {
                            'id': id,
                            'numericId': numericId,
                            'code': code,
                            'name': this.safeString(currency, 'name'),
                            'info': currency,
                            'active': active,
                            'deposit': depositsEnabled,
                            'withdraw': withdrawalsEnabled,
                            'fee': this.safeNumber(currency, 'base_withdrawal_fee'),
                            'precision': 1 / Math.pow(10, precision),
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'min_withdrawal_amount'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async loadMarkets(reload = false, params = {}) {
                    const markets = await super.loadMarkets(reload, params);
                    const currenciesByNumericId = this.safeValue(this.options, 'currenciesByNumericId');
                    if (currenciesByNumericId === undefined || reload) this.options['currenciesByNumericId'] = this.indexBy(this.currencies, 'numericId');
                    const marketsByNumericId = this.safeValue(this.options, 'marketsByNumericId');
                    if (marketsByNumericId === undefined || reload) this.options['marketsByNumericId'] = this.indexBy(this.markets, 'numericId');
                    return markets;
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetProducts(params);
                    //
                    //     {
                    //         "meta":{
                    //             "after":null,
                    //             "before":null,
                    //             "limit":100,
                    //             "total_count":81
                    //         },
                    //         "result":[
                    //             {
                    //                 "annualized_funding":"5.475000000000000000",
                    //                 "is_quanto":false,
                    //                 "ui_config":{
                    //                     "default_trading_view_candle":"15",
                    //                     "leverage_slider_values":[1,3,5,10,25,50],
                    //                     "price_clubbing_values":[0.001,0.005,0.05,0.1,0.5,1,5],
                    //                     "show_bracket_orders":false,
                    //                     "sort_priority":29,
                    //                     "tags":[]
                    //                 },
                    //                 "basis_factor_max_limit":"0.15",
                    //                 "symbol":"P-LINK-D-151120",
                    //                 "id":1584,
                    //                 "default_leverage":"5.000000000000000000",
                    //                 "maker_commission_rate":"0.0005",
                    //                 "contract_unit_currency":"LINK",
                    //                 "strike_price":"12.507948",
                    //                 "settling_asset":{
                    //                     // asset structure
                    //                 },
                    //                 "auction_start_time":null,
                    //                 "auction_finish_time":null,
                    //                 "settlement_time":"2020-11-15T12:00:00Z",
                    //                 "launch_time":"2020-11-14T11:55:05Z",
                    //                 "spot_index":{
                    //                     // index structure
                    //                 },
                    //                 "trading_status":"operational",
                    //                 "tick_size":"0.001",
                    //                 "position_size_limit":100000,
                    //                 "notional_type":"vanilla", // vanilla, inverse
                    //                 "price_band":"0.4",
                    //                 "barrier_price":null,
                    //                 "description":"Daily LINK PUT options quoted in USDT and settled in USDT",
                    //                 "insurance_fund_margin_contribution":"1",
                    //                 "quoting_asset":{
                    //                     // asset structure
                    //                 },
                    //                 "liquidation_penalty_factor":"0.2",
                    //                 "product_specs":{"max_volatility":3,"min_volatility":0.3,"spot_price_band":"0.40"},
                    //                 "initial_margin_scaling_factor":"0.0001",
                    //                 "underlying_asset":{
                    //                     // asset structure
                    //                 },
                    //                 "state":"live",
                    //                 "contract_value":"1",
                    //                 "initial_margin":"2",
                    //                 "impact_size":5000,
                    //                 "settlement_price":null,
                    //                 "contract_type":"put_options", // put_options, call_options, move_options, perpetual_futures, interest_rate_swaps, futures, spreads
                    //                 "taker_commission_rate":"0.0005",
                    //                 "maintenance_margin":"1",
                    //                 "short_description":"LINK Daily PUT Options",
                    //                 "maintenance_margin_scaling_factor":"0.00005",
                    //                 "funding_method":"mark_price",
                    //                 "max_leverage_notional":"20000"
                    //             },
                    //         ],
                    //         "success":true
                    //     }
                    //
                    const markets = this.safeValue(response, 'result', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        let type = this.safeString(market, 'contract_type');
                        // const settlingAsset = this.safeValue (market, 'settling_asset', {});
                        const quotingAsset = this.safeValue(market, 'quoting_asset', {});
                        const underlyingAsset = this.safeValue(market, 'underlying_asset', {});
                        const settlingAsset = this.safeValue(market, 'settling_asset');
                        const baseId = this.safeString(underlyingAsset, 'symbol');
                        const quoteId = this.safeString(quotingAsset, 'symbol');
                        const settleId = this.safeString(settlingAsset, 'symbol');
                        const id = this.safeString(market, 'symbol');
                        const numericId = this.safeInteger(market, 'id');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const settle = this.safeCurrencyCode(settleId);
                        const callOptions = type === 'call_options';
                        const putOptions = type === 'put_options';
                        const moveOptions = type === 'move_options';
                        const spot = type === 'spot';
                        const swap = type === 'perpetual_futures';
                        const future = type === 'futures';
                        const option = callOptions || putOptions || moveOptions;
                        const strike = this.safeString(market, 'strike_price');
                        const expiryDatetime = this.safeString(market, 'settlement_time');
                        const expiry = this.parse8601(expiryDatetime);
                        const contractSize = this.safeNumber(market, 'contract_value');
                        const linear = settle === base;
                        let optionType = undefined;
                        let symbol = base + '/' + quote;
                        if (swap || future || option) {
                            symbol = symbol + ':' + settle;
                            if (future || option) {
                                symbol = symbol + '-' + this.yymmdd(expiry);
                                if (option) {
                                    type = 'option';
                                    let letter = 'C';
                                    optionType = 'call';
                                    if (putOptions) {
                                        letter = 'P';
                                        optionType = 'put';
                                    } else if (moveOptions) {
                                        letter = 'M';
                                        optionType = 'move';
                                    }
                                    symbol = symbol + ':' + strike + ':' + letter;
                                } else type = 'future';
                            } else type = 'swap';
                        } else symbol = id;
                        const state = this.safeString(market, 'state');
                        result.push({
                            'id': id,
                            'numericId': numericId,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': type,
                            'spot': spot,
                            'margin': spot ? undefined : false,
                            'swap': swap,
                            'future': future,
                            'option': option,
                            'active': state === 'live',
                            'contract': !spot,
                            'linear': spot ? undefined : linear,
                            'inverse': spot ? undefined : !linear,
                            'taker': this.safeNumber(market, 'taker_commission_rate'),
                            'maker': this.safeNumber(market, 'maker_commission_rate'),
                            'contractSize': contractSize,
                            'expiry': expiry,
                            'expiryDatetime': expiryDatetime,
                            'strike': this.parseNumber(strike),
                            'optionType': optionType,
                            'precision': {
                                'amount': this.parseNumber('1'),
                                'price': this.safeNumber(market, 'tick_size')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.parseNumber('1'),
                                    'max': this.safeNumber(market, 'position_size_limit')
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_size'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker, fetchTickers
                    //
                    //     {
                    //         "close":15837.5,
                    //         "high":16354,
                    //         "low":15751.5,
                    //         "mark_price":"15820.100867",
                    //         "open":16140.5,
                    //         "product_id":139,
                    //         "size":640552,
                    //         "spot_price":"15827.050000000001",
                    //         "symbol":"BTCUSDT",
                    //         "timestamp":1605373550208262,
                    //         "turnover":10298630.3735,
                    //         "turnover_symbol":"USDT",
                    //         "turnover_usd":10298630.3735,
                    //         "volume":640.5520000000001
                    //     }
                    //
                    const timestamp = this.safeIntegerProduct(ticker, 'timestamp', 0.001);
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeString(ticker, 'close');
                    const open = this.safeString(ticker, 'open');
                    const baseVolume = this.safeString(ticker, 'volume');
                    const quoteVolume = this.safeString(ticker, 'turnover');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetTickersSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "result":{
                    //             "close":15837.5,
                    //             "high":16354,
                    //             "low":15751.5,
                    //             "mark_price":"15820.100867",
                    //             "open":16140.5,
                    //             "product_id":139,
                    //             "size":640552,
                    //             "spot_price":"15827.050000000001",
                    //             "symbol":"BTCUSDT",
                    //             "timestamp":1605373550208262,
                    //             "turnover":10298630.3735,
                    //             "turnover_symbol":"USDT",
                    //             "turnover_usd":10298630.3735,
                    //             "volume":640.5520000000001
                    //         },
                    //         "success":true
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseTicker(result, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTickers(params);
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "close":0.003966,
                    //                 "high":0.004032,
                    //                 "low":0.003606,
                    //                 "mark_price":"0.00396328",
                    //                 "open":0.003996,
                    //                 "product_id":1327,
                    //                 "size":6242,
                    //                 "spot_price":"0.0039555",
                    //                 "symbol":"AAVEBTC",
                    //                 "timestamp":1605374143864107,
                    //                 "turnover":23.997904999999996,
                    //                 "turnover_symbol":"BTC",
                    //                 "turnover_usd":387957.4544782897,
                    //                 "volume":6242
                    //             },
                    //         ],
                    //         "success":true
                    //     }
                    //
                    const tickers = this.safeValue(response, 'result', []);
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const ticker = this.parseTicker(tickers[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['depth'] = limit;
                    const response = await this.publicGetL2orderbookSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "result":{
                    //             "buy":[
                    //                 {"price":"15814.0","size":912},
                    //                 {"price":"15813.5","size":1279},
                    //                 {"price":"15813.0","size":1634},
                    //             ],
                    //             "sell":[
                    //                 {"price":"15814.5","size":625},
                    //                 {"price":"15815.0","size":982},
                    //                 {"price":"15815.5","size":1328},
                    //             ],
                    //             "symbol":"BTCUSDT"
                    //         },
                    //         "success":true
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseOrderBook(result, symbol, undefined, 'buy', 'sell', 'price', 'size');
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     {
                    //         "buyer_role":"maker",
                    //         "price":"15896.5",
                    //         "seller_role":"taker",
                    //         "size":241,
                    //         "symbol":"BTCUSDT",
                    //         "timestamp":1605376684714595
                    //     }
                    //
                    // private fetchMyTrades
                    //
                    //     {
                    //         "commission":"0.008335000000000000",
                    //         "created_at":"2020-11-16T19:07:19Z",
                    //         "fill_type":"normal",
                    //         "id":"e7ff05c233a74245b72381f8dd91d1ce",
                    //         "meta_data":{
                    //             "effective_commission_rate":"0.0005",
                    //             "order_price":"16249",
                    //             "order_size":1,
                    //             "order_type":"market_order",
                    //             "order_unfilled_size":0,
                    //             "trading_fee_credits_used":"0"
                    //         },
                    //         "order_id":"152999629",
                    //         "price":"16669",
                    //         "product":{
                    //             "contract_type":"perpetual_futures",
                    //             "contract_unit_currency":"BTC",
                    //             "contract_value":"0.001",
                    //             "id":139,
                    //             "notional_type":"vanilla",
                    //             "quoting_asset":{"minimum_precision":2,"precision":6,"symbol":"USDT"},
                    //             "settling_asset":{"minimum_precision":2,"precision":6,"symbol":"USDT"},
                    //             "symbol":"BTCUSDT",
                    //             "tick_size":"0.5",
                    //             "underlying_asset":{"minimum_precision":4,"precision":8,"symbol":"BTC"}
                    //         },
                    //         "product_id":139,
                    //         "role":"taker",
                    //         "side":"sell",
                    //         "size":1
                    //     }
                    //
                    const id = this.safeString(trade, 'id');
                    const orderId = this.safeString(trade, 'order_id');
                    let timestamp = this.parse8601(this.safeString(trade, 'created_at'));
                    timestamp = this.safeIntegerProduct(trade, 'timestamp', 0.001, timestamp);
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'size');
                    const product = this.safeValue(trade, 'product', {});
                    const marketId = this.safeString(product, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const sellerRole = this.safeString(trade, 'seller_role');
                    let side = this.safeString(trade, 'side');
                    if (side === undefined) {
                        if (sellerRole === 'taker') side = 'sell';
                        else if (sellerRole === 'maker') side = 'buy';
                    }
                    const takerOrMaker = this.safeString(trade, 'role');
                    const metaData = this.safeValue(trade, 'meta_data', {});
                    let type = this.safeString(metaData, 'order_type');
                    if (type !== undefined) type = type.replace('_order', '');
                    const feeCostString = this.safeString(trade, 'commission');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const settlingAsset = this.safeValue(product, 'settling_asset', {});
                        const feeCurrencyId = this.safeString(settlingAsset, 'symbol');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeTrade({
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'takerOrMaker': takerOrMaker,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetTradesSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "buyer_role":"maker",
                    //                 "price":"15896.5",
                    //                 "seller_role":"taker",
                    //                 "size":241,
                    //                 "symbol":"BTCUSDT",
                    //                 "timestamp":1605376684714595
                    //             }
                    //         ],
                    //         "success":true
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseTrades(result, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "time":1605393120,
                    //         "open":15989,
                    //         "high":15989,
                    //         "low":15987.5,
                    //         "close":15987.5,
                    //         "volume":565
                    //     }
                    //
                    return [
                        this.safeTimestamp(ohlcv, 'time'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'resolution': this.timeframes[timeframe]
                    };
                    const duration = this.parseTimeframe(timeframe);
                    limit = limit ? limit : 2000; // max 2000
                    if (since === undefined) {
                        const end = this.seconds();
                        request['end'] = end;
                        request['start'] = end - limit * duration;
                    } else {
                        const start = parseInt(since / 1000);
                        request['start'] = start;
                        request['end'] = this.sum(start, limit * duration);
                    }
                    const response = await this.publicGetHistoryCandles(this.extend(request, params));
                    //
                    //     {
                    //         "success":true,
                    //         "result":[
                    //             {"time":1605393120,"open":15989,"high":15989,"low":15987.5,"close":15987.5,"volume":565},
                    //             {"time":1605393180,"open":15966,"high":15966,"low":15959,"close":15959,"volume":24},
                    //             {"time":1605393300,"open":15973,"high":15973,"low":15973,"close":15973,"volume":1288},
                    //         ]
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseOHLCVs(result, market, timeframe, since, limit);
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'result', []);
                    const result = {
                        'info': response
                    };
                    const currenciesByNumericId = this.safeValue(this.options, 'currenciesByNumericId', {});
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'asset_id');
                        const currency = this.safeValue(currenciesByNumericId, currencyId);
                        const code = currency === undefined ? currencyId : currency['code'];
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'balance');
                        account['free'] = this.safeString(balance, 'available_balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetWalletBalances(params);
                    //
                    //     {
                    //         "result":[
                    //             {
                    //                 "asset_id":1,
                    //                 "available_balance":"0",
                    //                 "balance":"0",
                    //                 "commission":"0",
                    //                 "id":154883,
                    //                 "interest_credit":"0",
                    //                 "order_margin":"0",
                    //                 "pending_referral_bonus":"0",
                    //                 "pending_trading_fee_credit":"0",
                    //                 "position_margin":"0",
                    //                 "trading_fee_credit":"0",
                    //                 "user_id":22142
                    //             },
                    //         ],
                    //         "success":true
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'product_id': market['numericId']
                    };
                    const response = await this.privateGetPositions(this.extend(request, params));
                    //
                    //     {
                    //         "result":{
                    //             "entry_price":null,
                    //             "size":0,
                    //             "timestamp":1605454074268079
                    //         },
                    //         "success":true
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return result;
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetPositionsMargined(params);
                    //
                    //     {
                    //         "success": true,
                    //         "result": [
                    //             {
                    //                 "user_id": 0,
                    //                 "size": 0,
                    //                 "entry_price": "string",
                    //                 "margin": "string",
                    //                 "liquidation_price": "string",
                    //                 "bankruptcy_price": "string",
                    //                 "adl_level": 0,
                    //                 "product_id": 0
                    //             }
                    //         ]
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return result;
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'open': 'open',
                        'pending': 'open',
                        'closed': 'closed',
                        'cancelled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder, cancelOrder, editOrder, fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "average_fill_price":null,
                    //         "bracket_order":null,
                    //         "bracket_stop_loss_limit_price":null,
                    //         "bracket_stop_loss_price":null,
                    //         "bracket_take_profit_limit_price":null,
                    //         "bracket_take_profit_price":null,
                    //         "bracket_trail_amount":null,
                    //         "cancellation_reason":null,
                    //         "client_order_id":null,
                    //         "close_on_trigger":"false",
                    //         "commission":"0",
                    //         "created_at":"2020-11-16T02:38:26Z",
                    //         "id":152870626,
                    //         "limit_price":"10000",
                    //         "meta_data":{"source":"api"},
                    //         "order_type":"limit_order",
                    //         "paid_commission":"0",
                    //         "product_id":139,
                    //         "reduce_only":false,
                    //         "side":"buy",
                    //         "size":0,
                    //         "state":"open",
                    //         "stop_order_type":null,
                    //         "stop_price":null,
                    //         "stop_trigger_method":"mark_price",
                    //         "time_in_force":"gtc",
                    //         "trail_amount":null,
                    //         "unfilled_size":0,
                    //         "user_id":22142
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const clientOrderId = this.safeString(order, 'client_order_id');
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const marketId = this.safeString(order, 'product_id');
                    const marketsByNumericId = this.safeValue(this.options, 'marketsByNumericId', {});
                    market = this.safeValue(marketsByNumericId, marketId, market);
                    const symbol = market === undefined ? marketId : market['symbol'];
                    const status = this.parseOrderStatus(this.safeString(order, 'state'));
                    const side = this.safeString(order, 'side');
                    let type = this.safeString(order, 'order_type');
                    type = type.replace('_order', '');
                    const price = this.safeString(order, 'limit_price');
                    const amount = this.safeString(order, 'size');
                    const remaining = this.safeString(order, 'unfilled_size');
                    const average = this.safeString(order, 'average_fill_price');
                    let fee = undefined;
                    const feeCostString = this.safeString(order, 'paid_commission');
                    if (feeCostString !== undefined) {
                        let feeCurrencyCode = undefined;
                        if (market !== undefined) {
                            const settlingAsset = this.safeValue(market['info'], 'settling_asset', {});
                            const feeCurrencyId = this.safeString(settlingAsset, 'symbol');
                            feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        }
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'average': average,
                        'filled': undefined,
                        'remaining': remaining,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const orderType = type + '_order';
                    const market = this.market(symbol);
                    const request = {
                        'product_id': market['numericId'],
                        // 'limit_price': this.priceToPrecision (symbol, price),
                        'size': this.amountToPrecision(symbol, amount),
                        'side': side,
                        'order_type': orderType
                    };
                    if (type === 'limit') request['limit_price'] = this.priceToPrecision(symbol, price);
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client_order_id');
                    params = this.omit(params, [
                        'clientOrderId',
                        'client_order_id'
                    ]);
                    if (clientOrderId !== undefined) request['client_order_id'] = clientOrderId;
                    const response = await this.privatePostOrders(this.extend(request, params));
                    //
                    //     {
                    //         "result":{
                    //             "average_fill_price":null,
                    //             "bracket_order":null,
                    //             "bracket_stop_loss_limit_price":null,
                    //             "bracket_stop_loss_price":null,
                    //             "bracket_take_profit_limit_price":null,
                    //             "bracket_take_profit_price":null,
                    //             "bracket_trail_amount":null,
                    //             "cancellation_reason":null,
                    //             "client_order_id":null,
                    //             "close_on_trigger":"false",
                    //             "commission":"0",
                    //             "created_at":"2020-11-16T02:38:26Z",
                    //             "id":152870626,
                    //             "limit_price":"10000",
                    //             "meta_data":{"source":"api"},
                    //             "order_type":"limit_order",
                    //             "paid_commission":"0",
                    //             "product_id":139,
                    //             "reduce_only":false,
                    //             "side":"buy",
                    //             "size":0,
                    //             "state":"open",
                    //             "stop_order_type":null,
                    //             "stop_price":null,
                    //             "stop_trigger_method":"mark_price",
                    //             "time_in_force":"gtc",
                    //             "trail_amount":null,
                    //             "unfilled_size":0,
                    //             "user_id":22142
                    //         },
                    //         "success":true
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseOrder(result, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': parseInt(id),
                        'product_id': market['numericId']
                    };
                    if (amount !== undefined) request['size'] = parseInt(this.amountToPrecision(symbol, amount));
                    if (price !== undefined) request['limit_price'] = this.priceToPrecision(symbol, price);
                    const response = await this.privatePutOrders(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "result": {
                    //             "id": "ashb1212",
                    //             "product_id": 27,
                    //             "limit_price": "9200",
                    //             "side": "buy",
                    //             "size": 100,
                    //             "unfilled_size": 50,
                    //             "user_id": 1,
                    //             "order_type": "limit_order",
                    //             "state": "open",
                    //             "created_at": "..."
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parseOrder(result, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': parseInt(id),
                        'product_id': market['numericId']
                    };
                    const response = await this.privateDeleteOrders(this.extend(request, params));
                    //
                    //     {
                    //         "result":{
                    //             "average_fill_price":null,
                    //             "bracket_order":null,
                    //             "bracket_stop_loss_limit_price":null,
                    //             "bracket_stop_loss_price":null,
                    //             "bracket_take_profit_limit_price":null,
                    //             "bracket_take_profit_price":null,
                    //             "bracket_trail_amount":null,
                    //             "cancellation_reason":"cancelled_by_user",
                    //             "client_order_id":null,
                    //             "close_on_trigger":"false",
                    //             "commission":"0",
                    //             "created_at":"2020-11-16T02:38:26Z",
                    //             "id":152870626,
                    //             "limit_price":"10000",
                    //             "meta_data":{"source":"api"},
                    //             "order_type":"limit_order",
                    //             "paid_commission":"0",
                    //             "product_id":139,
                    //             "reduce_only":false,
                    //             "side":"buy",
                    //             "size":0,
                    //             "state":"cancelled",
                    //             "stop_order_type":null,
                    //             "stop_price":null,
                    //             "stop_trigger_method":"mark_price",
                    //             "time_in_force":"gtc",
                    //             "trail_amount":null,
                    //             "unfilled_size":0,
                    //             "user_id":22142
                    //         },
                    //         "success":true
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parseOrder(result, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelAllOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'product_id': market['numericId']
                    };
                    const response = this.privateDeleteOrdersAll(this.extend(request, params));
                    //
                    //     {
                    //         "result":{},
                    //         "success":true
                    //     }
                    //
                    return response;
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersWithMethod('privateGetOrders', symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersWithMethod('privateGetOrdersHistory', symbol, since, limit, params);
                }
                async fetchOrdersWithMethod(method, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['product_ids'] = market['numericId']; // accepts a comma-separated list of ids
                    }
                    if (since !== undefined) request['start_time'] = since.toString() + '000';
                    if (limit !== undefined) request['page_size'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "result": [
                    //             {
                    //                 "id": "ashb1212",
                    //                 "product_id": 27,
                    //                 "limit_price": "9200",
                    //                 "side": "buy",
                    //                 "size": 100,
                    //                 "unfilled_size": 50,
                    //                 "user_id": 1,
                    //                 "order_type": "limit_order",
                    //                 "state": "open",
                    //                 "created_at": "..."
                    //             }
                    //         ],
                    //         "meta": {
                    //             "after": "string",
                    //             "before": "string"
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseOrders(result, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['product_ids'] = market['numericId']; // accepts a comma-separated list of ids
                    }
                    if (since !== undefined) request['start_time'] = since.toString() + '000';
                    if (limit !== undefined) request['page_size'] = limit;
                    const response = await this.privateGetFills(this.extend(request, params));
                    //
                    //     {
                    //         "meta":{
                    //             "after":null,
                    //             "before":null,
                    //             "limit":10,
                    //             "total_count":2
                    //         },
                    //         "result":[
                    //             {
                    //                 "commission":"0.008335000000000000",
                    //                 "created_at":"2020-11-16T19:07:19Z",
                    //                 "fill_type":"normal",
                    //                 "id":"e7ff05c233a74245b72381f8dd91d1ce",
                    //                 "meta_data":{
                    //                     "effective_commission_rate":"0.0005",
                    //                     "order_price":"16249",
                    //                     "order_size":1,
                    //                     "order_type":"market_order",
                    //                     "order_unfilled_size":0,
                    //                     "trading_fee_credits_used":"0"
                    //                 },
                    //                 "order_id":"152999629",
                    //                 "price":"16669",
                    //                 "product":{
                    //                     "contract_type":"perpetual_futures",
                    //                     "contract_unit_currency":"BTC",
                    //                     "contract_value":"0.001",
                    //                     "id":139,
                    //                     "notional_type":"vanilla",
                    //                     "quoting_asset":{"minimum_precision":2,"precision":6,"symbol":"USDT"},
                    //                     "settling_asset":{"minimum_precision":2,"precision":6,"symbol":"USDT"},
                    //                     "symbol":"BTCUSDT",
                    //                     "tick_size":"0.5",
                    //                     "underlying_asset":{"minimum_precision":4,"precision":8,"symbol":"BTC"}
                    //                 },
                    //                 "product_id":139,
                    //                 "role":"taker",
                    //                 "side":"sell",
                    //                 "size":1
                    //             }
                    //         ],
                    //         "success":true
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseTrades(result, market, since, limit);
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['asset_id'] = currency['numericId'];
                    }
                    if (limit !== undefined) request['page_size'] = limit;
                    const response = await this.privateGetWalletTransactions(this.extend(request, params));
                    //
                    //     {
                    //         "meta":{"after":null,"before":null,"limit":10,"total_count":1},
                    //         "result":[
                    //             {
                    //                 "amount":"29.889184",
                    //                 "asset_id":5,
                    //                 "balance":"29.889184",
                    //                 "created_at":"2020-11-15T21:25:01Z",
                    //                 "meta_data":{
                    //                     "deposit_id":3884,
                    //                     "transaction_id":"0x41a60174849828530abb5008e98fc63c9b598288743ec4ba9620bcce900a3b8d"
                    //                 },
                    //                 "transaction_type":"deposit",
                    //                 "user_id":22142,
                    //                 "uuid":"70bb5679da3c4637884e2dc63efaa846"
                    //             }
                    //         ],
                    //         "success":true
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseLedger(result, currency, since, limit);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'pnl': 'pnl',
                        'deposit': 'transaction',
                        'withdrawal': 'transaction',
                        'commission': 'fee',
                        'conversion': 'trade',
                        // 'perpetual_futures_funding': 'perpetual_futures_funding',
                        // 'withdrawal_cancellation': 'withdrawal_cancellation',
                        'referral_bonus': 'referral',
                        'commission_rebate': 'rebate'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     {
                    //         "amount":"29.889184",
                    //         "asset_id":5,
                    //         "balance":"29.889184",
                    //         "created_at":"2020-11-15T21:25:01Z",
                    //         "meta_data":{
                    //             "deposit_id":3884,
                    //             "transaction_id":"0x41a60174849828530abb5008e98fc63c9b598288743ec4ba9620bcce900a3b8d"
                    //         },
                    //         "transaction_type":"deposit",
                    //         "user_id":22142,
                    //         "uuid":"70bb5679da3c4637884e2dc63efaa846"
                    //     }
                    //
                    const id = this.safeString(item, 'uuid');
                    let direction = undefined;
                    const account = undefined;
                    const metaData = this.safeValue(item, 'meta_data', {});
                    const referenceId = this.safeString(metaData, 'transaction_id');
                    const referenceAccount = undefined;
                    let type = this.safeString(item, 'transaction_type');
                    if (type === 'deposit' || type === 'commission_rebate' || type === 'referral_bonus' || type === 'pnl' || type === 'withdrawal_cancellation' || type === 'promo_credit') direction = 'in';
                    else if (type === 'withdrawal' || type === 'commission' || type === 'conversion' || type === 'perpetual_futures_funding') direction = 'out';
                    type = this.parseLedgerEntryType(type);
                    const currencyId = this.safeInteger(item, 'asset_id');
                    const currenciesByNumericId = this.safeValue(this.options, 'currenciesByNumericId');
                    currency = this.safeValue(currenciesByNumericId, currencyId, currency);
                    const code = currency === undefined ? undefined : currency['code'];
                    const amount = this.safeNumber(item, 'amount');
                    const timestamp = this.parse8601(this.safeString(item, 'created_at'));
                    const after = this.safeNumber(item, 'balance');
                    const before = Math.max(0, after - amount);
                    const status = 'ok';
                    return {
                        'info': item,
                        'id': id,
                        'direction': direction,
                        'account': account,
                        'referenceId': referenceId,
                        'referenceAccount': referenceAccount,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'before': before,
                        'after': after,
                        'status': status,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': undefined
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'asset_symbol': currency['id']
                    };
                    const response = await this.privateGetDepositsAddress(this.extend(request, params));
                    //
                    //     {
                    //         "success":true,
                    //         "result":{
                    //             "id":19628,
                    //             "user_id":22142,
                    //             "address":"0x0eda26523397534f814d553a065d8e46b4188e9a",
                    //             "status":"active",
                    //             "updated_at":"2020-11-15T20:25:53.000Z",
                    //             "created_at":"2020-11-15T20:25:53.000Z",
                    //             "asset_symbol":"USDT",
                    //             "custodian":"onc"
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const address = this.safeString(result, 'address');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': undefined,
                        'network': undefined,
                        'info': response
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const requestPath = '/' + this.version + '/' + this.implodeParams(path, params);
                    let url = this.urls['api'][api] + requestPath;
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.seconds().toString();
                        headers = {
                            'api-key': this.apiKey,
                            'timestamp': timestamp
                        };
                        let auth = method + timestamp + requestPath;
                        if (method === 'GET' || method === 'DELETE') {
                            if (Object.keys(query).length) {
                                const queryString = '?' + this.urlencode(query);
                                auth += queryString;
                                url += queryString;
                            }
                        } else {
                            body = this.json(query);
                            auth += body;
                            headers['Content-Type'] = 'application/json';
                        }
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                        headers['signature'] = signature;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    // {"error":{"code":"insufficient_margin","context":{"available_balance":"0.000000000000000000","required_additional_balance":"1.618626000000000000000000000"}},"success":false}
                    //
                    const error = this.safeValue(response, 'error', {});
                    const errorCode = this.safeString(error, 'code');
                    if (errorCode !== undefined) {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], errorCode, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    75: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const { AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, PermissionDenied: PermissionDenied, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, DDoSProtection: DDoSProtection, NotSupported: NotSupported, ExchangeNotAvailable: ExchangeNotAvailable, InsufficientFunds: InsufficientFunds, BadRequest: BadRequest, InvalidAddress: InvalidAddress, OnMaintenance: OnMaintenance } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class deribit extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'deribit',
                        'name': 'Deribit',
                        'countries': [
                            'NL'
                        ],
                        'version': 'v2',
                        'userAgent': undefined,
                        // 20 requests per second for non-matching-engine endpoints, 1000ms / 20 = 50ms between requests
                        // 5 requests per second for matching-engine endpoints, cost = (1000ms / rateLimit) / 5 = 4
                        'rateLimit': 50,
                        'has': {
                            'CORS': true,
                            'spot': false,
                            'margin': false,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchHistoricalVolatility': true,
                            'fetchIndexOHLCV': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': undefined,
                            'fetchOrderTrades': true,
                            'fetchPosition': true,
                            'fetchPositions': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': undefined,
                            'fetchWithdrawals': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1',
                            '3m': '3',
                            '5m': '5',
                            '10m': '10',
                            '15m': '15',
                            '30m': '30',
                            '1h': '60',
                            '2h': '120',
                            '3h': '180',
                            '6h': '360',
                            '12h': '720',
                            '1d': '1D'
                        },
                        'urls': {
                            'test': 'https://test.deribit.com',
                            'logo': 'https://user-images.githubusercontent.com/1294454/41933112-9e2dd65a-798b-11e8-8440-5bab2959fcb8.jpg',
                            'api': 'https://www.deribit.com',
                            'www': 'https://www.deribit.com',
                            'doc': [
                                'https://docs.deribit.com/v2',
                                'https://github.com/deribit'
                            ],
                            'fees': 'https://www.deribit.com/pages/information/fees',
                            'referral': {
                                'url': 'https://www.deribit.com/reg-1189.4038',
                                'discount': 0.1
                            }
                        },
                        'api': {
                            'public': {
                                'get': {
                                    // Authentication
                                    'auth': 1,
                                    'exchange_token': 1,
                                    'fork_token': 1,
                                    // Session management
                                    'set_heartbeat': 1,
                                    'disable_heartbeat': 1,
                                    // Supporting
                                    'get_time': 1,
                                    'hello': 1,
                                    'test': 1,
                                    // Subscription management
                                    'subscribe': 1,
                                    'unsubscribe': 1,
                                    'unsubscribe_all': 1,
                                    // Account management
                                    'get_announcements': 1,
                                    // Market data
                                    'get_book_summary_by_currency': 1,
                                    'get_book_summary_by_instrument': 1,
                                    'get_contract_size': 1,
                                    'get_currencies': 1,
                                    'get_delivery_prices': 1,
                                    'get_funding_chart_data': 1,
                                    'get_funding_rate_history': 1,
                                    'get_funding_rate_value': 1,
                                    'get_historical_volatility': 1,
                                    'get_index': 1,
                                    'get_index_price': 1,
                                    'get_index_price_names': 1,
                                    'get_instrument': 1,
                                    'get_instruments': 1,
                                    'get_last_settlements_by_currency': 1,
                                    'get_last_settlements_by_instrument': 1,
                                    'get_last_trades_by_currency': 1,
                                    'get_last_trades_by_currency_and_time': 1,
                                    'get_last_trades_by_instrument': 1,
                                    'get_last_trades_by_instrument_and_time': 1,
                                    'get_mark_price_history': 1,
                                    'get_order_book': 1,
                                    'get_trade_volumes': 1,
                                    'get_tradingview_chart_data': 1,
                                    'get_volatility_index_data': 1,
                                    'ticker': 1
                                }
                            },
                            'private': {
                                'get': {
                                    // Authentication
                                    'logout': 1,
                                    // Session management
                                    'enable_cancel_on_disconnect': 1,
                                    'disable_cancel_on_disconnect': 1,
                                    'get_cancel_on_disconnect': 1,
                                    // Subscription management
                                    'subscribe': 1,
                                    'unsubscribe': 1,
                                    'unsubscribe_all': 1,
                                    // Account management
                                    'change_api_key_name': 1,
                                    'change_scope_in_api_key': 1,
                                    'change_subaccount_name': 1,
                                    'create_api_key': 1,
                                    'create_subaccount': 1,
                                    'disable_api_key': 1,
                                    'disable_tfa_for_subaccount': 1,
                                    'enable_affiliate_program': 1,
                                    'enable_api_key': 1,
                                    'get_access_log': 1,
                                    'get_account_summary': 1,
                                    'get_affiliate_program_info': 1,
                                    'get_email_language': 1,
                                    'get_new_announcements': 1,
                                    'get_portfolio_margins': 1,
                                    'get_position': 1,
                                    'get_positions': 1,
                                    'get_subaccounts': 1,
                                    'get_subaccounts_details': 1,
                                    'get_transaction_log': 1,
                                    'list_api_keys': 1,
                                    'remove_api_key': 1,
                                    'remove_subaccount': 1,
                                    'reset_api_key': 1,
                                    'set_announcement_as_read': 1,
                                    'set_api_key_as_default': 1,
                                    'set_email_for_subaccount': 1,
                                    'set_email_language': 1,
                                    'set_password_for_subaccount': 1,
                                    'toggle_notifications_from_subaccount': 1,
                                    'toggle_subaccount_login': 1,
                                    // Block Trade
                                    'execute_block_trade': 4,
                                    'get_block_trade': 1,
                                    'get_last_block_trades_by_currency': 1,
                                    'invalidate_block_trade_signature': 1,
                                    'verify_block_trade': 4,
                                    // Trading
                                    'buy': 4,
                                    'sell': 4,
                                    'edit': 4,
                                    'edit_by_label': 4,
                                    'cancel': 4,
                                    'cancel_all': 4,
                                    'cancel_all_by_currency': 4,
                                    'cancel_all_by_instrument': 4,
                                    'cancel_by_label': 4,
                                    'close_position': 4,
                                    'get_margins': 1,
                                    'get_mmp_config': 1,
                                    'get_open_orders_by_currency': 1,
                                    'get_open_orders_by_instrument': 1,
                                    'get_order_history_by_currency': 1,
                                    'get_order_history_by_instrument': 1,
                                    'get_order_margin_by_ids': 1,
                                    'get_order_state': 1,
                                    'get_stop_order_history': 1,
                                    'get_trigger_order_history': 1,
                                    'get_user_trades_by_currency': 1,
                                    'get_user_trades_by_currency_and_time': 1,
                                    'get_user_trades_by_instrument': 1,
                                    'get_user_trades_by_instrument_and_time': 1,
                                    'get_user_trades_by_order': 1,
                                    'reset_mmp': 1,
                                    'set_mmp_config': 1,
                                    'get_settlement_history_by_instrument': 1,
                                    'get_settlement_history_by_currency': 1,
                                    // Wallet
                                    'cancel_transfer_by_id': 1,
                                    'cancel_withdrawal': 1,
                                    'create_deposit_address': 1,
                                    'get_current_deposit_address': 1,
                                    'get_deposits': 1,
                                    'get_transfers': 1,
                                    'get_withdrawals': 1,
                                    'submit_transfer_to_subaccount': 1,
                                    'submit_transfer_to_user': 1,
                                    'withdraw': 1
                                }
                            }
                        },
                        'exceptions': {
                            // 0 or absent Success, No error.
                            '9999': PermissionDenied,
                            '10000': AuthenticationError,
                            '10001': ExchangeError1,
                            '10002': InvalidOrder,
                            '10003': InvalidOrder,
                            '10004': OrderNotFound,
                            '10005': InvalidOrder,
                            '10006': InvalidOrder,
                            '10007': InvalidOrder,
                            '10008': InvalidOrder,
                            '10009': InsufficientFunds,
                            '10010': OrderNotFound,
                            '10011': InvalidOrder,
                            '10012': InvalidOrder,
                            '10013': PermissionDenied,
                            '10014': PermissionDenied,
                            '10015': PermissionDenied,
                            '10016': PermissionDenied,
                            '10017': PermissionDenied,
                            '10018': PermissionDenied,
                            '10019': PermissionDenied,
                            '10020': ExchangeError1,
                            '10021': InvalidOrder,
                            '10022': InvalidOrder,
                            '10023': InvalidOrder,
                            '10024': InvalidOrder,
                            '10025': InvalidOrder,
                            '10026': InvalidOrder,
                            '10027': InvalidOrder,
                            '10028': DDoSProtection,
                            '10029': OrderNotFound,
                            '10030': ExchangeError1,
                            '10031': ExchangeError1,
                            '10032': InvalidOrder,
                            '10033': NotSupported,
                            '10034': InvalidOrder,
                            '10035': InvalidOrder,
                            '10036': InvalidOrder,
                            '10040': ExchangeNotAvailable,
                            '10041': OnMaintenance,
                            '10043': InvalidOrder,
                            '10044': InvalidOrder,
                            '10045': InvalidOrder,
                            '10046': InvalidOrder,
                            '10047': DDoSProtection,
                            '10048': ExchangeError1,
                            '11008': InvalidOrder,
                            '11029': BadRequest,
                            '11030': ExchangeError1,
                            '11031': ExchangeError1,
                            '11035': DDoSProtection,
                            '11036': InvalidOrder,
                            '11037': BadRequest,
                            '11038': InvalidOrder,
                            '11039': InvalidOrder,
                            '11041': InvalidOrder,
                            '11042': PermissionDenied,
                            '11043': BadRequest,
                            '11044': InvalidOrder,
                            '11045': BadRequest,
                            '11046': BadRequest,
                            '11047': BadRequest,
                            '11048': ExchangeError1,
                            '11049': BadRequest,
                            '11050': BadRequest,
                            '11051': OnMaintenance,
                            '11052': ExchangeError1,
                            '11053': ExchangeError1,
                            '11090': InvalidAddress,
                            '11091': InvalidAddress,
                            '11092': InvalidAddress,
                            '11093': DDoSProtection,
                            '11094': ExchangeError1,
                            '11095': ExchangeError1,
                            '11096': ExchangeError1,
                            '12000': AuthenticationError,
                            '12001': DDoSProtection,
                            '12002': ExchangeError1,
                            '12998': AuthenticationError,
                            '12003': AuthenticationError,
                            '12004': AuthenticationError,
                            '12005': AuthenticationError,
                            '12100': ExchangeError1,
                            '12999': AuthenticationError,
                            '13000': AuthenticationError,
                            '13001': AuthenticationError,
                            '13002': PermissionDenied,
                            '13003': AuthenticationError,
                            '13004': AuthenticationError,
                            '13005': AuthenticationError,
                            '13006': AuthenticationError,
                            '13007': AuthenticationError,
                            '13008': ExchangeError1,
                            '13009': AuthenticationError,
                            '13010': BadRequest,
                            '13011': BadRequest,
                            '13012': PermissionDenied,
                            '13013': BadRequest,
                            '13014': BadRequest,
                            '13015': BadRequest,
                            '13016': BadRequest,
                            '13017': ExchangeError1,
                            '13018': ExchangeError1,
                            '13019': ExchangeError1,
                            '13020': ExchangeError1,
                            '13021': PermissionDenied,
                            '13025': ExchangeError1,
                            '-32602': BadRequest,
                            '-32601': BadRequest,
                            '-32700': BadRequest,
                            '-32000': BadRequest
                        },
                        'precisionMode': TICK_SIZE,
                        'options': {
                            'code': 'BTC',
                            'fetchBalance': {
                                'code': 'BTC'
                            },
                            'fetchPositions': {
                                'code': 'BTC'
                            }
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetGetTime(params);
                    //
                    //     {
                    //         jsonrpc: '2.0',
                    //         result: 1583922446019,
                    //         usIn: 1583922446019955,
                    //         usOut: 1583922446019956,
                    //         usDiff: 1,
                    //         testnet: false
                    //     }
                    //
                    return this.safeInteger(response, 'result');
                }
                codeFromOptions(methodName, params = {}) {
                    const defaultCode = this.safeValue(this.options, 'code', 'BTC');
                    const options = this.safeValue(this.options, methodName, {});
                    const code = this.safeValue(options, 'code', defaultCode);
                    return this.safeValue(params, 'code', code);
                }
                async fetchStatus(params = {}) {
                    const response = await this.publicGetStatus(params);
                    //
                    //     {
                    //         "jsonrpc": "2.0",
                    //         "result": {
                    //             "locked": "false" // true, partial, false
                    //         },
                    //         "usIn": 1650641690226788,
                    //         "usOut": 1650641690226836,
                    //         "usDiff": 48,
                    //         "testnet": false
                    //     }
                    //
                    const result = this.safeString(response, 'result');
                    const locked = this.safeString(result, 'locked');
                    const updateTime = this.safeIntegerProduct(response, 'usIn', 0.001, this.milliseconds());
                    return {
                        'status': locked === 'false' ? 'ok' : 'maintenance',
                        'updated': updateTime,
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchMarkets(params = {}) {
                    const currenciesResponse = await this.publicGetGetCurrencies(params);
                    //
                    //     {
                    //         jsonrpc: '2.0',
                    //         result: [
                    //             {
                    //                 withdrawal_priorities: [
                    //                     { value: 0.15, name: 'very_low' },
                    //                     { value: 1.5, name: 'very_high' },
                    //                 ],
                    //                 withdrawal_fee: 0.0005,
                    //                 min_withdrawal_fee: 0.0005,
                    //                 min_confirmations: 1,
                    //                 fee_precision: 4,
                    //                 currency_long: 'Bitcoin',
                    //                 currency: 'BTC',
                    //                 coin_type: 'BITCOIN'
                    //             }
                    //         ],
                    //         usIn: 1583761588590479,
                    //         usOut: 1583761588590544,
                    //         usDiff: 65,
                    //         testnet: false
                    //     }
                    //
                    const currenciesResult = this.safeValue(currenciesResponse, 'result', []);
                    const result = [];
                    for(let i = 0; i < currenciesResult.length; i++){
                        const currencyId = this.safeString(currenciesResult[i], 'currency');
                        const request = {
                            'currency': currencyId
                        };
                        const instrumentsResponse = await this.publicGetGetInstruments(this.extend(request, params));
                        //
                        //     {
                        //         "jsonrpc":"2.0",
                        //         "result":[
                        //             {
                        //                 "tick_size":0.0005,
                        //                 "taker_commission":0.0003,
                        //                 "strike":52000.0,
                        //                 "settlement_period":"month",
                        //                 "settlement_currency":"BTC",
                        //                 "quote_currency":"BTC",
                        //                 "option_type":"put", // put, call
                        //                 "min_trade_amount":0.1,
                        //                 "maker_commission":0.0003,
                        //                 "kind":"option",
                        //                 "is_active":true,
                        //                 "instrument_name":"BTC-24JUN22-52000-P",
                        //                 "expiration_timestamp":1656057600000,
                        //                 "creation_timestamp":1648199543000,
                        //                 "counter_currency":"USD",
                        //                 "contract_size":1.0,
                        //                 "block_trade_commission":0.0003,
                        //                 "base_currency":"BTC"
                        //             },
                        //             {
                        //                 "tick_size":0.5,
                        //                 "taker_commission":0.0005,
                        //                 "settlement_period":"month", // month, week
                        //                 "settlement_currency":"BTC",
                        //                 "quote_currency":"USD",
                        //                 "min_trade_amount":10.0,
                        //                 "max_liquidation_commission":0.0075,
                        //                 "max_leverage":50,
                        //                 "maker_commission":0.0,
                        //                 "kind":"future",
                        //                 "is_active":true,
                        //                 "instrument_name":"BTC-27MAY22",
                        //                 "future_type":"reversed",
                        //                 "expiration_timestamp":1653638400000,
                        //                 "creation_timestamp":1648195209000,
                        //                 "counter_currency":"USD",
                        //                 "contract_size":10.0,
                        //                 "block_trade_commission":0.0001,
                        //                 "base_currency":"BTC"
                        //             },
                        //             {
                        //                 "tick_size":0.5,
                        //                 "taker_commission":0.0005,
                        //                 "settlement_period":"perpetual",
                        //                 "settlement_currency":"BTC",
                        //                 "quote_currency":"USD",
                        //                 "min_trade_amount":10.0,
                        //                 "max_liquidation_commission":0.0075,
                        //                 "max_leverage":50,
                        //                 "maker_commission":0.0,
                        //                 "kind":"future",
                        //                 "is_active":true,
                        //                 "instrument_name":"BTC-PERPETUAL",
                        //                 "future_type":"reversed",
                        //                 "expiration_timestamp":32503708800000,
                        //                 "creation_timestamp":1534242287000,
                        //                 "counter_currency":"USD",
                        //                 "contract_size":10.0,
                        //                 "block_trade_commission":0.0001,
                        //                 "base_currency":"BTC"
                        //             },
                        //         ],
                        //         "usIn":1648691472831791,
                        //         "usOut":1648691472831896,
                        //         "usDiff":105,
                        //         "testnet":false
                        //     }
                        //
                        const instrumentsResult = this.safeValue(instrumentsResponse, 'result', []);
                        for(let k = 0; k < instrumentsResult.length; k++){
                            const market = instrumentsResult[k];
                            const id = this.safeString(market, 'instrument_name');
                            const baseId = this.safeString(market, 'base_currency');
                            const quoteId = this.safeString(market, 'counter_currency');
                            const settleId = this.safeString(market, 'settlement_currency');
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            const settle = this.safeCurrencyCode(settleId);
                            const kind = this.safeString(market, 'kind');
                            const settlementPeriod = this.safeValue(market, 'settlement_period');
                            const swap = settlementPeriod === 'perpetual';
                            const future = !swap && kind === 'future';
                            const option = kind === 'option';
                            let symbol = base + '/' + quote + ':' + settle;
                            const expiry = this.safeInteger(market, 'expiration_timestamp');
                            let strike = undefined;
                            let optionType = undefined;
                            let type = 'swap';
                            if (option || future) {
                                symbol = symbol + '-' + this.yymmdd(expiry, '');
                                if (option) {
                                    type = 'option';
                                    strike = this.safeNumber(market, 'strike');
                                    optionType = this.safeString(market, 'option_type');
                                    const letter = optionType === 'call' ? 'C' : 'P';
                                    symbol = symbol + ':' + this.numberToString(strike) + ':' + letter;
                                } else type = 'future';
                            }
                            const minTradeAmount = this.safeNumber(market, 'min_trade_amount');
                            const tickSize = this.safeNumber(market, 'tick_size');
                            result.push({
                                'id': id,
                                'symbol': symbol,
                                'base': base,
                                'quote': quote,
                                'settle': settle,
                                'baseId': baseId,
                                'quoteId': quoteId,
                                'settleId': settleId,
                                'type': type,
                                'spot': false,
                                'margin': false,
                                'swap': swap,
                                'future': future,
                                'option': option,
                                'active': this.safeValue(market, 'is_active'),
                                'contract': true,
                                'linear': false,
                                'inverse': true,
                                'taker': this.safeNumber(market, 'taker_commission'),
                                'maker': this.safeNumber(market, 'maker_commission'),
                                'contractSize': this.safeNumber(market, 'contract_size'),
                                'expiry': expiry,
                                'expiryDatetime': this.iso8601(expiry),
                                'strike': strike,
                                'optionType': optionType,
                                'precision': {
                                    'amount': minTradeAmount,
                                    'price': tickSize
                                },
                                'limits': {
                                    'leverage': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'amount': {
                                        'min': minTradeAmount,
                                        'max': undefined
                                    },
                                    'price': {
                                        'min': tickSize,
                                        'max': undefined
                                    },
                                    'cost': {
                                        'min': undefined,
                                        'max': undefined
                                    }
                                },
                                'info': market
                            });
                        }
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const balance = this.safeValue(response, 'result', {});
                    const currencyId = this.safeString(balance, 'currency');
                    const currencyCode = this.safeCurrencyCode(currencyId);
                    const account = this.account();
                    account['free'] = this.safeString(balance, 'available_funds');
                    account['used'] = this.safeString(balance, 'maintenance_margin');
                    account['total'] = this.safeString(balance, 'equity');
                    result[currencyCode] = account;
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const code = this.codeFromOptions('fetchBalance', params);
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateGetGetAccountSummary(this.extend(request, params));
                    //
                    //     {
                    //         jsonrpc: '2.0',
                    //         result: {
                    //             total_pl: 0,
                    //             session_upl: 0,
                    //             session_rpl: 0,
                    //             session_funding: 0,
                    //             portfolio_margining_enabled: false,
                    //             options_vega: 0,
                    //             options_theta: 0,
                    //             options_session_upl: 0,
                    //             options_session_rpl: 0,
                    //             options_pl: 0,
                    //             options_gamma: 0,
                    //             options_delta: 0,
                    //             margin_balance: 0.00062359,
                    //             maintenance_margin: 0,
                    //             limits: {
                    //                 non_matching_engine_burst: 300,
                    //                 non_matching_engine: 200,
                    //                 matching_engine_burst: 20,
                    //                 matching_engine: 2
                    //             },
                    //             initial_margin: 0,
                    //             futures_session_upl: 0,
                    //             futures_session_rpl: 0,
                    //             futures_pl: 0,
                    //             equity: 0.00062359,
                    //             deposit_address: '13tUtNsJSZa1F5GeCmwBywVrymHpZispzw',
                    //             delta_total: 0,
                    //             currency: 'BTC',
                    //             balance: 0.00062359,
                    //             available_withdrawal_funds: 0.00062359,
                    //             available_funds: 0.00062359
                    //         },
                    //         usIn: 1583775838115975,
                    //         usOut: 1583775838116520,
                    //         usDiff: 545,
                    //         testnet: false
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateGetCreateDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         'jsonrpc': '2.0',
                    //         'id': 7538,
                    //         'result': {
                    //             'address': '2N8udZGBc1hLRCFsU9kGwMPpmYUwMFTuCwB',
                    //             'creation_timestamp': 1550575165170,
                    //             'currency': 'BTC',
                    //             'type': 'deposit'
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const address = this.safeString(result, 'address');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': undefined,
                        'info': response
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateGetGetCurrentDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         jsonrpc: '2.0',
                    //         result: {
                    //             type: 'deposit',
                    //             status: 'ready',
                    //             requires_confirmation: true,
                    //             currency: 'BTC',
                    //             creation_timestamp: 1514694684651,
                    //             address: '13tUtNsJSZa1F5GeCmwBywVrymHpZispzw'
                    //         },
                    //         usIn: 1583785137274288,
                    //         usOut: 1583785137274454,
                    //         usDiff: 166,
                    //         testnet: false
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const address = this.safeString(result, 'address');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': undefined,
                        'network': undefined,
                        'info': response
                    };
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker /public/ticker
                    //
                    //     {
                    //         timestamp: 1583778859480,
                    //         stats: { volume: 60627.57263769, low: 7631.5, high: 8311.5 },
                    //         state: 'open',
                    //         settlement_price: 7903.21,
                    //         open_interest: 111543850,
                    //         min_price: 7634,
                    //         max_price: 7866.51,
                    //         mark_price: 7750.02,
                    //         last_price: 7750.5,
                    //         instrument_name: 'BTC-PERPETUAL',
                    //         index_price: 7748.01,
                    //         funding_8h: 0.0000026,
                    //         current_funding: 0,
                    //         best_bid_price: 7750,
                    //         best_bid_amount: 19470,
                    //         best_ask_price: 7750.5,
                    //         best_ask_amount: 343280
                    //     }
                    //
                    // fetchTicker /public/get_book_summary_by_instrument
                    // fetchTickers /public/get_book_summary_by_currency
                    //
                    //     {
                    //         volume: 124.1,
                    //         underlying_price: 7856.445926872601,
                    //         underlying_index: 'SYN.BTC-10MAR20',
                    //         quote_currency: 'USD',
                    //         open_interest: 121.8,
                    //         mid_price: 0.01975,
                    //         mark_price: 0.01984559,
                    //         low: 0.0095,
                    //         last: 0.0205,
                    //         interest_rate: 0,
                    //         instrument_name: 'BTC-10MAR20-7750-C',
                    //         high: 0.0295,
                    //         estimated_delivery_price: 7856.29,
                    //         creation_timestamp: 1583783678366,
                    //         bid_price: 0.0185,
                    //         base_currency: 'BTC',
                    //         ask_price: 0.021
                    //     },
                    //
                    const timestamp = this.safeInteger2(ticker, 'timestamp', 'creation_timestamp');
                    const marketId = this.safeString(ticker, 'instrument_name');
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeString2(ticker, 'last_price', 'last');
                    const stats = this.safeValue(ticker, 'stats', ticker);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString2(stats, 'high', 'max_price'),
                        'low': this.safeString2(stats, 'low', 'min_price'),
                        'bid': this.safeString2(ticker, 'best_bid_price', 'bid_price'),
                        'bidVolume': this.safeString(ticker, 'best_bid_amount'),
                        'ask': this.safeString2(ticker, 'best_ask_price', 'ask_price'),
                        'askVolume': this.safeString(ticker, 'best_ask_amount'),
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': undefined,
                        'quoteVolume': this.safeString(stats, 'volume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_name': market['id']
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    //
                    //     {
                    //         jsonrpc: '2.0',
                    //         result: {
                    //             timestamp: 1583778859480,
                    //             stats: { volume: 60627.57263769, low: 7631.5, high: 8311.5 },
                    //             state: 'open',
                    //             settlement_price: 7903.21,
                    //             open_interest: 111543850,
                    //             min_price: 7634,
                    //             max_price: 7866.51,
                    //             mark_price: 7750.02,
                    //             last_price: 7750.5,
                    //             instrument_name: 'BTC-PERPETUAL',
                    //             index_price: 7748.01,
                    //             funding_8h: 0.0000026,
                    //             current_funding: 0,
                    //             best_bid_price: 7750,
                    //             best_bid_amount: 19470,
                    //             best_ask_price: 7750.5,
                    //             best_ask_amount: 343280
                    //         },
                    //         usIn: 1583778859483941,
                    //         usOut: 1583778859484075,
                    //         usDiff: 134,
                    //         testnet: false
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parseTicker(result, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const code = this.codeFromOptions('fetchTickers', params);
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.publicGetGetBookSummaryByCurrency(this.extend(request, params));
                    //
                    //     {
                    //         jsonrpc: '2.0',
                    //         result: [
                    //             {
                    //                 volume: 124.1,
                    //                 underlying_price: 7856.445926872601,
                    //                 underlying_index: 'SYN.BTC-10MAR20',
                    //                 quote_currency: 'USD',
                    //                 open_interest: 121.8,
                    //                 mid_price: 0.01975,
                    //                 mark_price: 0.01984559,
                    //                 low: 0.0095,
                    //                 last: 0.0205,
                    //                 interest_rate: 0,
                    //                 instrument_name: 'BTC-10MAR20-7750-C',
                    //                 high: 0.0295,
                    //                 estimated_delivery_price: 7856.29,
                    //                 creation_timestamp: 1583783678366,
                    //                 bid_price: 0.0185,
                    //                 base_currency: 'BTC',
                    //                 ask_price: 0.021
                    //             },
                    //         ],
                    //         usIn: 1583783678361966,
                    //         usOut: 1583783678372069,
                    //         usDiff: 10103,
                    //         testnet: false
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    const tickers = {};
                    for(let i = 0; i < result.length; i++){
                        const ticker = this.parseTicker(result[i]);
                        const symbol = ticker['symbol'];
                        tickers[symbol] = ticker;
                    }
                    return this.filterByArray(tickers, 'symbol', symbols);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_name': market['id'],
                        'resolution': this.timeframes[timeframe]
                    };
                    const duration = this.parseTimeframe(timeframe);
                    const now = this.milliseconds();
                    if (since === undefined) {
                        if (limit === undefined) throw new ArgumentsRequired1(this.id + ' fetchOHLCV() requires a since argument or a limit argument');
                        else {
                            request['start_timestamp'] = now - (limit - 1) * duration * 1000;
                            request['end_timestamp'] = now;
                        }
                    } else {
                        request['start_timestamp'] = since;
                        if (limit === undefined) request['end_timestamp'] = now;
                        else request['end_timestamp'] = this.sum(since, limit * duration * 1000);
                    }
                    const response = await this.publicGetGetTradingviewChartData(this.extend(request, params));
                    //
                    //     {
                    //         jsonrpc: '2.0',
                    //         result: {
                    //             volume: [ 3.6680847969999992, 22.682721123, 3.011587939, 0 ],
                    //             ticks: [ 1583916960000, 1583917020000, 1583917080000, 1583917140000 ],
                    //             status: 'ok',
                    //             open: [ 7834, 7839, 7833.5, 7833 ],
                    //             low: [ 7834, 7833.5, 7832.5, 7833 ],
                    //             high: [ 7839.5, 7839, 7833.5, 7833 ],
                    //             cost: [ 28740, 177740, 23590, 0 ],
                    //             close: [ 7839.5, 7833.5, 7833, 7833 ]
                    //         },
                    //         usIn: 1583917166709801,
                    //         usOut: 1583917166710175,
                    //         usDiff: 374,
                    //         testnet: false
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const ohlcvs = this.convertTradingViewToOHLCV(result, 'ticks', 'open', 'high', 'low', 'close', 'volume', true);
                    return this.parseOHLCVs(ohlcvs, market, timeframe, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "trade_seq":132564271,
                    //          "trade_id":"195402220",
                    //          "timestamp":1639684927932,
                    //          "tick_direction":0,
                    //          "price":47946.5,
                    //          "mark_price":47944.13,
                    //          "instrument_name":"BTC-PERPETUAL",
                    //          "index_price":47925.45,
                    //          "direction":"buy",
                    //          "amount":580.0
                    //      }
                    //
                    //
                    // fetchMyTrades, fetchOrderTrades (private)
                    //
                    //     {
                    //         "trade_seq": 3,
                    //         "trade_id": "ETH-34066",
                    //         "timestamp": 1550219814585,
                    //         "tick_direction": 1,
                    //         "state": "open",
                    //         "self_trade": false,
                    //         "reduce_only": false,
                    //         "price": 0.04,
                    //         "post_only": false,
                    //         "order_type": "limit",
                    //         "order_id": "ETH-334607",
                    //         "matching_id": null,
                    //         "liquidity": "M",
                    //         "iv": 56.83,
                    //         "instrument_name": "ETH-22FEB19-120-C",
                    //         "index_price": 121.37,
                    //         "fee_currency": "ETH",
                    //         "fee": 0.0011,
                    //         "direction": "buy",
                    //         "amount": 11
                    //     }
                    //
                    const id = this.safeString(trade, 'trade_id');
                    const marketId = this.safeString(trade, 'instrument_name');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.safeInteger(trade, 'timestamp');
                    const side = this.safeString(trade, 'direction');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const liquidity = this.safeString(trade, 'liquidity');
                    let takerOrMaker = undefined;
                    if (liquidity !== undefined) // M = maker, T = taker, MT = both
                    takerOrMaker = liquidity === 'M' ? 'maker' : 'taker';
                    const feeCostString = this.safeString(trade, 'fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'fee_currency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': this.safeString(trade, 'order_id'),
                        'type': this.safeString(trade, 'order_type'),
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_name': market['id'],
                        'include_old': true
                    };
                    const method = since === undefined ? 'publicGetGetLastTradesByInstrument' : 'publicGetGetLastTradesByInstrumentAndTime';
                    if (since !== undefined) request['start_timestamp'] = since;
                    if (limit !== undefined) request['count'] = limit; // default 10
                    const response = await this[method](this.extend(request, params));
                    //
                    //      {
                    //          "jsonrpc":"2.0",
                    //          "result": {
                    //              "trades": [
                    //                  {
                    //                      "trade_seq":132564271,
                    //                      "trade_id":"195402220",
                    //                      "timestamp":1639684927932,
                    //                      "tick_direction":0,
                    //                      "price":47946.5,
                    //                      "mark_price":47944.13,
                    //                      "instrument_name":"BTC-PERPETUAL",
                    //                      "index_price":47925.45,
                    //                      "direction":"buy","amount":580.0
                    //                  }
                    //              ],
                    //              "has_more":true
                    //          },
                    //          "usIn":1639684931934671,
                    //          "usOut":1639684931935337,
                    //          "usDiff":666,
                    //          "testnet":false
                    //      }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const trades = this.safeValue(result, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const code = this.codeFromOptions('fetchTradingFees', params);
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'extended': true
                    };
                    const response = await this.privateGetGetAccountSummary(this.extend(request, params));
                    //
                    //     {
                    //         jsonrpc: '2.0',
                    //         result: {
                    //             total_pl: 0,
                    //             session_upl: 0,
                    //             session_rpl: 0,
                    //             session_funding: 0,
                    //             portfolio_margining_enabled: false,
                    //             options_vega: 0,
                    //             options_theta: 0,
                    //             options_session_upl: 0,
                    //             options_session_rpl: 0,
                    //             options_pl: 0,
                    //             options_gamma: 0,
                    //             options_delta: 0,
                    //             margin_balance: 0.00062359,
                    //             maintenance_margin: 0,
                    //             limits: {
                    //                 non_matching_engine_burst: 300,
                    //                 non_matching_engine: 200,
                    //                 matching_engine_burst: 20,
                    //                 matching_engine: 2
                    //             },
                    //             initial_margin: 0,
                    //             futures_session_upl: 0,
                    //             futures_session_rpl: 0,
                    //             futures_pl: 0,
                    //             equity: 0.00062359,
                    //             deposit_address: '13tUtNsJSZa1F5GeCmwBywVrymHpZispzw',
                    //             delta_total: 0,
                    //             currency: 'BTC',
                    //             balance: 0.00062359,
                    //             available_withdrawal_funds: 0.00062359,
                    //             available_funds: 0.00062359,
                    //             fees: [
                    //                 currency: '',
                    //                 instrument_type: 'perpetual',
                    //                 fee_type: 'relative',
                    //                 maker_fee: 0,
                    //                 taker_fee: 0,
                    //             ],
                    //         },
                    //         usIn: 1583775838115975,
                    //         usOut: 1583775838116520,
                    //         usDiff: 545,
                    //         testnet: false
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const fees = this.safeValue(result, 'fees', []);
                    let perpetualFee = {};
                    let futureFee = {};
                    let optionFee = {};
                    for(let i = 0; i < fees.length; i++){
                        const fee = fees[i];
                        const instrumentType = this.safeString(fee, 'instrument_type');
                        if (instrumentType === 'future') futureFee = {
                            'info': fee,
                            'maker': this.safeNumber(fee, 'maker_fee'),
                            'taker': this.safeNumber(fee, 'taker_fee')
                        };
                        else if (instrumentType === 'perpetual') perpetualFee = {
                            'info': fee,
                            'maker': this.safeNumber(fee, 'maker_fee'),
                            'taker': this.safeNumber(fee, 'taker_fee')
                        };
                        else if (instrumentType === 'option') optionFee = {
                            'info': fee,
                            'maker': this.safeNumber(fee, 'maker_fee'),
                            'taker': this.safeNumber(fee, 'taker_fee')
                        };
                    }
                    const parsedFees = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        let fee = {
                            'info': market,
                            'symbol': symbol,
                            'percentage': true,
                            'tierBased': true,
                            'maker': market['maker'],
                            'taker': market['taker']
                        };
                        if (market['swap']) fee = this.extend(fee, perpetualFee);
                        else if (market['future']) fee = this.extend(fee, futureFee);
                        else if (market['option']) fee = this.extend(fee, optionFee);
                        parsedFees[symbol] = fee;
                    }
                    return parsedFees;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_name': market['id']
                    };
                    if (limit !== undefined) request['depth'] = limit;
                    const response = await this.publicGetGetOrderBook(this.extend(request, params));
                    //
                    //     {
                    //         jsonrpc: '2.0',
                    //         result: {
                    //             timestamp: 1583781354740,
                    //             stats: { volume: 61249.66735634, low: 7631.5, high: 8311.5 },
                    //             state: 'open',
                    //             settlement_price: 7903.21,
                    //             open_interest: 111536690,
                    //             min_price: 7695.13,
                    //             max_price: 7929.49,
                    //             mark_price: 7813.06,
                    //             last_price: 7814.5,
                    //             instrument_name: 'BTC-PERPETUAL',
                    //             index_price: 7810.12,
                    //             funding_8h: 0.0000031,
                    //             current_funding: 0,
                    //             change_id: 17538025952,
                    //             bids: [
                    //                 [7814, 351820],
                    //                 [7813.5, 207490],
                    //                 [7813, 32160],
                    //             ],
                    //             best_bid_price: 7814,
                    //             best_bid_amount: 351820,
                    //             best_ask_price: 7814.5,
                    //             best_ask_amount: 11880,
                    //             asks: [
                    //                 [7814.5, 11880],
                    //                 [7815, 18100],
                    //                 [7815.5, 2640],
                    //             ],
                    //         },
                    //         usIn: 1583781354745804,
                    //         usOut: 1583781354745932,
                    //         usDiff: 128,
                    //         testnet: false
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const timestamp = this.safeInteger(result, 'timestamp');
                    const nonce = this.safeInteger(result, 'change_id');
                    const orderbook = this.parseOrderBook(result, symbol, timestamp);
                    orderbook['nonce'] = nonce;
                    return orderbook;
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'open': 'open',
                        'cancelled': 'canceled',
                        'filled': 'closed',
                        'rejected': 'rejected',
                        'untriggered': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTimeInForce(timeInForce) {
                    const timeInForces = {
                        'good_til_cancelled': 'GTC',
                        'fill_or_kill': 'FOK',
                        'immediate_or_cancel': 'IOC'
                    };
                    return this.safeString(timeInForces, timeInForce, timeInForce);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "time_in_force": "good_til_cancelled",
                    //         "reduce_only": false,
                    //         "profit_loss": 0,
                    //         "price": "market_price",
                    //         "post_only": false,
                    //         "order_type": "market",
                    //         "order_state": "filled",
                    //         "order_id": "ETH-349249",
                    //         "max_show": 40,
                    //         "last_update_timestamp": 1550657341322,
                    //         "label": "market0000234",
                    //         "is_liquidation": false,
                    //         "instrument_name": "ETH-PERPETUAL",
                    //         "filled_amount": 40,
                    //         "direction": "buy",
                    //         "creation_timestamp": 1550657341322,
                    //         "commission": 0.000139,
                    //         "average_price": 143.81,
                    //         "api": true,
                    //         "amount": 40,
                    //         "trades": [], // injected by createOrder
                    //     }
                    //
                    const timestamp = this.safeInteger(order, 'creation_timestamp');
                    const lastUpdate = this.safeInteger(order, 'last_update_timestamp');
                    const id = this.safeString(order, 'order_id');
                    let priceString = this.safeString(order, 'price');
                    if (priceString === 'market_price') // for market orders we get a literal 'market_price' string here
                    priceString = undefined;
                    const averageString = this.safeString(order, 'average_price');
                    const amountString = this.safeString(order, 'amount');
                    const filledString = this.safeString(order, 'filled_amount');
                    let lastTradeTimestamp = undefined;
                    if (filledString !== undefined) {
                        const isFilledPositive = Precise.stringGt(filledString, '0');
                        if (isFilledPositive) lastTradeTimestamp = lastUpdate;
                    }
                    const status = this.parseOrderStatus(this.safeString(order, 'order_state'));
                    const marketId = this.safeString(order, 'instrument_name');
                    market = this.safeMarket(marketId, market);
                    const side = this.safeStringLower(order, 'direction');
                    let feeCostString = this.safeString(order, 'commission');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        feeCostString = Precise.stringAbs(feeCostString);
                        fee = {
                            'cost': feeCostString,
                            'currency': market['base']
                        };
                    }
                    const type = this.safeString(order, 'order_type');
                    // injected in createOrder
                    let trades = this.safeValue(order, 'trades');
                    if (trades !== undefined) trades = this.parseTrades(trades, market);
                    const timeInForce = this.parseTimeInForce(this.safeString(order, 'time_in_force'));
                    const stopPrice = this.safeValue(order, 'stop_price');
                    const postOnly = this.safeValue(order, 'post_only');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': priceString,
                        'stopPrice': stopPrice,
                        'amount': amountString,
                        'cost': undefined,
                        'average': averageString,
                        'filled': filledString,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': trades
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privateGetGetOrderState(this.extend(request, params));
                    //
                    //     {
                    //         "jsonrpc": "2.0",
                    //         "id": 4316,
                    //         "result": {
                    //             "time_in_force": "good_til_cancelled",
                    //             "reduce_only": false,
                    //             "profit_loss": 0.051134,
                    //             "price": 118.94,
                    //             "post_only": false,
                    //             "order_type": "limit",
                    //             "order_state": "filled",
                    //             "order_id": "ETH-331562",
                    //             "max_show": 37,
                    //             "last_update_timestamp": 1550219810944,
                    //             "label": "",
                    //             "is_liquidation": false,
                    //             "instrument_name": "ETH-PERPETUAL",
                    //             "filled_amount": 37,
                    //             "direction": "sell",
                    //             "creation_timestamp": 1550219749176,
                    //             "commission": 0.000031,
                    //             "average_price": 118.94,
                    //             "api": false,
                    //             "amount": 37
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parseOrder(result);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_name': market['id'],
                        // for perpetual and futures the amount is in USD
                        // for options it is in corresponding cryptocurrency contracts, e.g., BTC or ETH
                        'amount': this.amountToPrecision(symbol, amount),
                        'type': type
                    };
                    let priceIsRequired = false;
                    let stopPriceIsRequired = false;
                    if (type === 'limit') priceIsRequired = true;
                    else if (type === 'stop_limit') {
                        priceIsRequired = true;
                        stopPriceIsRequired = true;
                    }
                    if (priceIsRequired) {
                        if (price !== undefined) request['price'] = this.priceToPrecision(symbol, price);
                        else throw new ArgumentsRequired1(this.id + ' createOrder() requires a price argument for a ' + type + ' order');
                    }
                    if (stopPriceIsRequired) {
                        const stopPrice = this.safeNumber2(params, 'stop_price', 'stopPrice');
                        if (stopPrice === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a stop_price or stopPrice param for a ' + type + ' order');
                        else request['stop_price'] = this.priceToPrecision(symbol, stopPrice);
                        params = this.omit(params, [
                            'stop_price',
                            'stopPrice'
                        ]);
                    }
                    const method = 'privateGet' + this.capitalize(side);
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "jsonrpc": "2.0",
                    //         "id": 5275,
                    //         "result": {
                    //             "trades": [
                    //                 {
                    //                     "trade_seq": 14151,
                    //                     "trade_id": "ETH-37435",
                    //                     "timestamp": 1550657341322,
                    //                     "tick_direction": 2,
                    //                     "state": "closed",
                    //                     "self_trade": false,
                    //                     "price": 143.81,
                    //                     "order_type": "market",
                    //                     "order_id": "ETH-349249",
                    //                     "matching_id": null,
                    //                     "liquidity": "T",
                    //                     "label": "market0000234",
                    //                     "instrument_name": "ETH-PERPETUAL",
                    //                     "index_price": 143.73,
                    //                     "fee_currency": "ETH",
                    //                     "fee": 0.000139,
                    //                     "direction": "buy",
                    //                     "amount": 40
                    //                 }
                    //             ],
                    //             "order": {
                    //                 "time_in_force": "good_til_cancelled",
                    //                 "reduce_only": false,
                    //                 "profit_loss": 0,
                    //                 "price": "market_price",
                    //                 "post_only": false,
                    //                 "order_type": "market",
                    //                 "order_state": "filled",
                    //                 "order_id": "ETH-349249",
                    //                 "max_show": 40,
                    //                 "last_update_timestamp": 1550657341322,
                    //                 "label": "market0000234",
                    //                 "is_liquidation": false,
                    //                 "instrument_name": "ETH-PERPETUAL",
                    //                 "filled_amount": 40,
                    //                 "direction": "buy",
                    //                 "creation_timestamp": 1550657341322,
                    //                 "commission": 0.000139,
                    //                 "average_price": 143.81,
                    //                 "api": true,
                    //                 "amount": 40
                    //             }
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const order = this.safeValue(result, 'order');
                    const trades = this.safeValue(result, 'trades', []);
                    order['trades'] = trades;
                    return this.parseOrder(order, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    if (amount === undefined) throw new ArgumentsRequired1(this.id + ' editOrder() requires an amount argument');
                    if (price === undefined) throw new ArgumentsRequired1(this.id + ' editOrder() requires a price argument');
                    await this.loadMarkets();
                    const request = {
                        'order_id': id,
                        // for perpetual and futures the amount is in USD
                        // for options it is in corresponding cryptocurrency contracts, e.g., BTC or ETH
                        'amount': this.amountToPrecision(symbol, amount),
                        'price': this.priceToPrecision(symbol, price)
                    };
                    const response = await this.privateGetEdit(this.extend(request, params));
                    const result = this.safeValue(response, 'result', {});
                    const order = this.safeValue(result, 'order');
                    const trades = this.safeValue(result, 'trades', []);
                    order['trades'] = trades;
                    return this.parseOrder(order);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privateGetCancel(this.extend(request, params));
                    const result = this.safeValue(response, 'result', {});
                    return this.parseOrder(result);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let method = undefined;
                    if (symbol === undefined) method = 'privateGetCancelAll';
                    else {
                        method = 'privateGetCancelAllByInstrument';
                        const market = this.market(symbol);
                        request['instrument_name'] = market['id'];
                    }
                    const response = await this[method](this.extend(request, params));
                    return response;
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    let method = undefined;
                    if (symbol === undefined) {
                        const code = this.codeFromOptions('fetchOpenOrders', params);
                        const currency = this.currency(code);
                        request['currency'] = currency['id'];
                        method = 'privateGetGetOpenOrdersByCurrency';
                    } else {
                        market = this.market(symbol);
                        request['instrument_name'] = market['id'];
                        method = 'privateGetGetOpenOrdersByInstrument';
                    }
                    const response = await this[method](this.extend(request, params));
                    const result = this.safeValue(response, 'result', []);
                    return this.parseOrders(result, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    let method = undefined;
                    if (symbol === undefined) {
                        const code = this.codeFromOptions('fetchClosedOrders', params);
                        const currency = this.currency(code);
                        request['currency'] = currency['id'];
                        method = 'privateGetGetOrderHistoryByCurrency';
                    } else {
                        market = this.market(symbol);
                        request['instrument_name'] = market['id'];
                        method = 'privateGetGetOrderHistoryByInstrument';
                    }
                    const response = await this[method](this.extend(request, params));
                    const result = this.safeValue(response, 'result', []);
                    return this.parseOrders(result, market, since, limit);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privateGetGetUserTradesByOrder(this.extend(request, params));
                    //
                    //     {
                    //         "jsonrpc": "2.0",
                    //         "id": 9367,
                    //         "result": {
                    //             "trades": [
                    //                 {
                    //                     "trade_seq": 3,
                    //                     "trade_id": "ETH-34066",
                    //                     "timestamp": 1550219814585,
                    //                     "tick_direction": 1,
                    //                     "state": "open",
                    //                     "self_trade": false,
                    //                     "reduce_only": false,
                    //                     "price": 0.04,
                    //                     "post_only": false,
                    //                     "order_type": "limit",
                    //                     "order_id": "ETH-334607",
                    //                     "matching_id": null,
                    //                     "liquidity": "M",
                    //                     "iv": 56.83,
                    //                     "instrument_name": "ETH-22FEB19-120-C",
                    //                     "index_price": 121.37,
                    //                     "fee_currency": "ETH",
                    //                     "fee": 0.0011,
                    //                     "direction": "buy",
                    //                     "amount": 11
                    //                 },
                    //             ],
                    //             "has_more": true
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseTrades(result, undefined, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'include_old': true
                    };
                    let market = undefined;
                    let method = undefined;
                    if (symbol === undefined) {
                        const code = this.codeFromOptions('fetchMyTrades', params);
                        const currency = this.currency(code);
                        request['currency'] = currency['id'];
                        if (since === undefined) method = 'privateGetGetUserTradesByCurrency';
                        else {
                            method = 'privateGetGetUserTradesByCurrencyAndTime';
                            request['start_timestamp'] = since;
                        }
                    } else {
                        market = this.market(symbol);
                        request['instrument_name'] = market['id'];
                        if (since === undefined) method = 'privateGetGetUserTradesByInstrument';
                        else {
                            method = 'privateGetGetUserTradesByInstrumentAndTime';
                            request['start_timestamp'] = since;
                        }
                    }
                    if (limit !== undefined) request['count'] = limit; // default 10
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "jsonrpc": "2.0",
                    //         "id": 9367,
                    //         "result": {
                    //             "trades": [
                    //                 {
                    //                     "trade_seq": 3,
                    //                     "trade_id": "ETH-34066",
                    //                     "timestamp": 1550219814585,
                    //                     "tick_direction": 1,
                    //                     "state": "open",
                    //                     "self_trade": false,
                    //                     "reduce_only": false,
                    //                     "price": 0.04,
                    //                     "post_only": false,
                    //                     "order_type": "limit",
                    //                     "order_id": "ETH-334607",
                    //                     "matching_id": null,
                    //                     "liquidity": "M",
                    //                     "iv": 56.83,
                    //                     "instrument_name": "ETH-22FEB19-120-C",
                    //                     "index_price": 121.37,
                    //                     "fee_currency": "ETH",
                    //                     "fee": 0.0011,
                    //                     "direction": "buy",
                    //                     "amount": 11
                    //                 },
                    //             ],
                    //             "has_more": true
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const trades = this.safeValue(result, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires a currency code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    if (limit !== undefined) request['count'] = limit;
                    const response = await this.privateGetGetDeposits(this.extend(request, params));
                    //
                    //     {
                    //         "jsonrpc": "2.0",
                    //         "id": 5611,
                    //         "result": {
                    //             "count": 1,
                    //             "data": [
                    //                 {
                    //                     "address": "2N35qDKDY22zmJq9eSyiAerMD4enJ1xx6ax",
                    //                     "amount": 5,
                    //                     "currency": "BTC",
                    //                     "received_timestamp": 1549295017670,
                    //                     "state": "completed",
                    //                     "transaction_id": "230669110fdaf0a0dbcdc079b6b8b43d5af29cc73683835b9bc6b3406c065fda",
                    //                     "updated_timestamp": 1549295130159
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const data = this.safeValue(result, 'data', []);
                    return this.parseTransactions(data, currency, since, limit, params);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchWithdrawals() requires a currency code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    if (limit !== undefined) request['count'] = limit;
                    const response = await this.privateGetGetWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         "jsonrpc": "2.0",
                    //         "id": 2745,
                    //         "result": {
                    //             "count": 1,
                    //             "data": [
                    //                 {
                    //                     "address": "2NBqqD5GRJ8wHy1PYyCXTe9ke5226FhavBz",
                    //                     "amount": 0.5,
                    //                     "confirmed_timestamp": null,
                    //                     "created_timestamp": 1550571443070,
                    //                     "currency": "BTC",
                    //                     "fee": 0.0001,
                    //                     "id": 1,
                    //                     "priority": 0.15,
                    //                     "state": "unconfirmed",
                    //                     "transaction_id": null,
                    //                     "updated_timestamp": 1550571443070
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const data = this.safeValue(result, 'data', []);
                    return this.parseTransactions(data, currency, since, limit, params);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'completed': 'ok',
                        'unconfirmed': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "address": "2NBqqD5GRJ8wHy1PYyCXTe9ke5226FhavBz",
                    //         "amount": 0.5,
                    //         "confirmed_timestamp": null,
                    //         "created_timestamp": 1550571443070,
                    //         "currency": "BTC",
                    //         "fee": 0.0001,
                    //         "id": 1,
                    //         "priority": 0.15,
                    //         "state": "unconfirmed",
                    //         "transaction_id": null,
                    //         "updated_timestamp": 1550571443070
                    //     }
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "address": "2N35qDKDY22zmJq9eSyiAerMD4enJ1xx6ax",
                    //         "amount": 5,
                    //         "currency": "BTC",
                    //         "received_timestamp": 1549295017670,
                    //         "state": "completed",
                    //         "transaction_id": "230669110fdaf0a0dbcdc079b6b8b43d5af29cc73683835b9bc6b3406c065fda",
                    //         "updated_timestamp": 1549295130159
                    //     }
                    //
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const timestamp = this.safeInteger2(transaction, 'created_timestamp', 'received_timestamp');
                    const updated = this.safeInteger(transaction, 'updated_timestamp');
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    const address = this.safeString(transaction, 'address');
                    const feeCost = this.safeNumber(transaction, 'fee');
                    let type = 'deposit';
                    let fee = undefined;
                    if (feeCost !== undefined) {
                        type = 'withdrawal';
                        fee = {
                            'cost': feeCost,
                            'currency': code
                        };
                    }
                    return {
                        'info': transaction,
                        'id': this.safeString(transaction, 'id'),
                        'txid': this.safeString(transaction, 'transaction_id'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': this.safeNumber(transaction, 'amount'),
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                parsePosition(position, market) {
                    //
                    //     {
                    //         "jsonrpc": "2.0",
                    //         "id": 404,
                    //         "result": {
                    //             "average_price": 0,
                    //             "delta": 0,
                    //             "direction": "buy",
                    //             "estimated_liquidation_price": 0,
                    //             "floating_profit_loss": 0,
                    //             "index_price": 3555.86,
                    //             "initial_margin": 0,
                    //             "instrument_name": "BTC-PERPETUAL",
                    //             "leverage": 100,
                    //             "kind": "future",
                    //             "maintenance_margin": 0,
                    //             "mark_price": 3556.62,
                    //             "open_orders_margin": 0.000165889,
                    //             "realized_profit_loss": 0,
                    //             "settlement_price": 3555.44,
                    //             "size": 0,
                    //             "size_currency": 0,
                    //             "total_profit_loss": 0
                    //         }
                    //     }
                    //
                    const contract = this.safeString(position, 'instrument_name');
                    market = this.safeMarket(contract, market);
                    const size = this.safeString(position, 'size');
                    let side = this.safeString(position, 'direction');
                    side = side === 'buy' ? 'long' : 'short';
                    const maintenanceRate = this.safeString(position, 'maintenance_margin');
                    const markPrice = this.safeString(position, 'mark_price');
                    const notionalString = Precise.stringMul(markPrice, size);
                    const unrealisedPnl = this.safeString(position, 'floating_profit_loss');
                    const initialMarginString = this.safeString(position, 'initial_margin');
                    const percentage = Precise.stringMul(Precise.stringDiv(unrealisedPnl, initialMarginString), '100');
                    const currentTime = this.milliseconds();
                    return {
                        'info': position,
                        'symbol': this.safeString(market, 'symbol'),
                        'timestamp': currentTime,
                        'datetime': this.iso8601(currentTime),
                        'initialMargin': this.parseNumber(initialMarginString),
                        'initialMarginPercentage': this.parseNumber(Precise.stringDiv(initialMarginString, notionalString)),
                        'maintenanceMargin': this.parseNumber(Precise.stringMul(maintenanceRate, notionalString)),
                        'maintenanceMarginPercentage': this.parseNumber(maintenanceRate),
                        'entryPrice': this.safeString(position, 'average_price'),
                        'notional': this.parseNumber(notionalString),
                        'leverage': this.safeNumber(position, 'leverage'),
                        'unrealizedPnl': this.parseNumber(unrealisedPnl),
                        'contracts': this.parseNumber(size),
                        'contractSize': this.safeValue(market, 'contractSize'),
                        'marginRatio': undefined,
                        'liquidationPrice': this.safeNumber(position, 'estimated_liquidation_price'),
                        'markPrice': markPrice,
                        'collateral': undefined,
                        'marginMode': undefined,
                        'marginType': undefined,
                        'side': side,
                        'percentage': this.parseNumber(percentage)
                    };
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instrument_name': market['id']
                    };
                    const response = await this.privateGetGetPosition(this.extend(request, params));
                    //
                    //     {
                    //         "jsonrpc": "2.0",
                    //         "id": 404,
                    //         "result": {
                    //             "average_price": 0,
                    //             "delta": 0,
                    //             "direction": "buy",
                    //             "estimated_liquidation_price": 0,
                    //             "floating_profit_loss": 0,
                    //             "index_price": 3555.86,
                    //             "initial_margin": 0,
                    //             "instrument_name": "BTC-PERPETUAL",
                    //             "leverage": 100,
                    //             "kind": "future",
                    //             "maintenance_margin": 0,
                    //             "mark_price": 3556.62,
                    //             "open_orders_margin": 0.000165889,
                    //             "realized_profit_loss": 0,
                    //             "settlement_price": 3555.44,
                    //             "size": 0,
                    //             "size_currency": 0,
                    //             "total_profit_loss": 0
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parsePosition(result);
                }
                parsePositions(positions) {
                    const result = [];
                    for(let i = 0; i < positions.length; i++)result.push(this.parsePosition(positions[i]));
                    return result;
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    let code = undefined;
                    if (symbols === undefined) code = this.codeFromOptions('fetchPositions', params);
                    else if (typeof symbols === 'string') code = symbols;
                    else if (Array.isArray(symbols)) {
                        const length = symbols.length;
                        if (length !== 1) throw new BadRequest(this.id + ' fetchPositions() symbols argument cannot contain more than 1 symbol');
                        const market = this.market(symbols[0]);
                        code = market['base'];
                    }
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateGetGetPositions(this.extend(request, params));
                    //
                    //     {
                    //         "jsonrpc": "2.0",
                    //         "id": 2236,
                    //         "result": [
                    //             {
                    //                 "average_price": 7440.18,
                    //                 "delta": 0.006687487,
                    //                 "direction": "buy",
                    //                 "estimated_liquidation_price": 1.74,
                    //                 "floating_profit_loss": 0,
                    //                 "index_price": 7466.79,
                    //                 "initial_margin": 0.000197283,
                    //                 "instrument_name": "BTC-PERPETUAL",
                    //                 "kind": "future",
                    //                 "leverage": 34,
                    //                 "maintenance_margin": 0.000143783,
                    //                 "mark_price": 7476.65,
                    //                 "open_orders_margin": 0.000197288,
                    //                 "realized_funding": -1e-8,
                    //                 "realized_profit_loss": -9e-9,
                    //                 "settlement_price": 7476.65,
                    //                 "size": 50,
                    //                 "size_currency": 0.006687487,
                    //                 "total_profit_loss": 0.000032781
                    //             },
                    //         ]
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parsePositions(result);
                }
                async fetchHistoricalVolatility(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.publicGetGetHistoricalVolatility(this.extend(request, params));
                    //
                    //     {
                    //         "jsonrpc": "2.0",
                    //         "result": [
                    //             [1640142000000,63.828320460740585],
                    //             [1640142000000,63.828320460740585],
                    //             [1640145600000,64.03821964123213]
                    //         ],
                    //         "usIn": 1641515379467734,
                    //         "usOut": 1641515379468095,
                    //         "usDiff": 361,
                    //         "testnet": false
                    //     }
                    //
                    const volatilityResult = this.safeValue(response, 'result', {});
                    const result = [];
                    for(let i = 0; i < volatilityResult.length; i++){
                        const timestamp = this.safeInteger(volatilityResult[i], 0);
                        const volatility = this.safeNumber(volatilityResult[i], 1);
                        result.push({
                            'info': response,
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'volatility': volatility
                        });
                    }
                    return result;
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'address': address,
                        'amount': amount
                    };
                    if (this.twofa !== undefined) request['tfa'] = this.oath();
                    const response = await this.privateGetWithdraw(this.extend(request, params));
                    return this.parseTransaction(response, currency);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let request = "/api/" + this.version + '/' + api + '/' + path;
                    if (api === 'public') {
                        if (Object.keys(params).length) request += '?' + this.urlencode(params);
                    }
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const timestamp = this.milliseconds().toString();
                        const requestBody = '';
                        if (Object.keys(params).length) request += '?' + this.urlencode(params);
                        const requestData = method + "\n" + request + "\n" + requestBody + "\n"; // eslint-disable-line quotes
                        const auth = timestamp + "\n" + nonce + "\n" + requestData; // eslint-disable-line quotes
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha256');
                        headers = {
                            'Authorization': 'deri-hmac-sha256 id=' + this.apiKey + ',ts=' + timestamp + ',sig=' + signature + ',' + 'nonce=' + nonce
                        };
                    }
                    const url = this.urls['api'] + request;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (!response) return; // fallback to default error handler
                    //
                    //     {
                    //         jsonrpc: '2.0',
                    //         error: {
                    //             message: 'Invalid params',
                    //             data: { reason: 'invalid currency', param: 'currency' },
                    //             code: -32602
                    //         },
                    //         testnet: false,
                    //         usIn: 1583763842150374,
                    //         usOut: 1583763842150410,
                    //         usDiff: 36
                    //     }
                    //
                    const error = this.safeValue(response, 'error');
                    if (error !== undefined) {
                        const errorCode = this.safeString(error, 'code');
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions, errorCode, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    76: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AccountSuspended: AccountSuspended, BadRequest: BadRequest, BadResponse: BadResponse, NetworkError: NetworkError, DDoSProtection: DDoSProtection, AuthenticationError: AuthenticationError, PermissionDenied: PermissionDenied, ExchangeError: ExchangeError1, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, InvalidNonce: InvalidNonce, OrderNotFound: OrderNotFound, InvalidAddress: InvalidAddress, RateLimitExceeded: RateLimitExceeded, BadSymbol: BadSymbol } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class digifinex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'digifinex',
                        'name': 'DigiFinex',
                        'countries': [
                            'SG'
                        ],
                        'version': 'v3',
                        'rateLimit': 900,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': false,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchLedger': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchWithdrawals': true,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1',
                            '5m': '5',
                            '15m': '15',
                            '30m': '30',
                            '1h': '60',
                            '4h': '240',
                            '12h': '720',
                            '1d': '1D',
                            '1w': '1W'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87443315-01283a00-c5fe-11ea-8628-c2a0feaf07ac.jpg',
                            'api': 'https://openapi.digifinex.com',
                            'www': 'https://www.digifinex.com',
                            'doc': [
                                'https://docs.digifinex.com'
                            ],
                            'fees': 'https://digifinex.zendesk.com/hc/en-us/articles/360000328422-Fee-Structure-on-DigiFinex',
                            'referral': 'https://www.digifinex.com/en-ww/from/DhOzBg?channelCode=ljaUPp'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    '{market}/symbols',
                                    'kline',
                                    'margin/currencies',
                                    'margin/symbols',
                                    'markets',
                                    'order_book',
                                    'ping',
                                    'spot/symbols',
                                    'time',
                                    'trades',
                                    'trades/symbols',
                                    'ticker',
                                    'currencies'
                                ]
                            },
                            'private': {
                                'get': [
                                    '{market}/financelog',
                                    '{market}/mytrades',
                                    '{market}/order',
                                    '{market}/order/detail',
                                    '{market}/order/current',
                                    '{market}/order/history',
                                    'margin/assets',
                                    'margin/financelog',
                                    'margin/mytrades',
                                    'margin/order',
                                    'margin/order/current',
                                    'margin/order/history',
                                    'margin/positions',
                                    'otc/financelog',
                                    'spot/assets',
                                    'spot/financelog',
                                    'spot/mytrades',
                                    'spot/order',
                                    'spot/order/current',
                                    'spot/order/history',
                                    'deposit/address',
                                    'deposit/history',
                                    'withdraw/history'
                                ],
                                'post': [
                                    '{market}/order/cancel',
                                    '{market}/order/new',
                                    '{market}/order/batch_new',
                                    'margin/order/cancel',
                                    'margin/order/new',
                                    'margin/position/close',
                                    'spot/order/cancel',
                                    'spot/order/new',
                                    'transfer',
                                    'withdraw/new',
                                    'withdraw/cancel'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'maker': this.parseNumber('0.002'),
                                'taker': this.parseNumber('0.002')
                            }
                        },
                        'exceptions': {
                            'exact': {
                                '10001': [
                                    BadRequest,
                                    "Wrong request method, please check it's a GET ot POST request"
                                ],
                                '10002': [
                                    AuthenticationError,
                                    'Invalid ApiKey'
                                ],
                                '10003': [
                                    AuthenticationError,
                                    "Sign doesn't match"
                                ],
                                '10004': [
                                    BadRequest,
                                    'Illegal request parameters'
                                ],
                                '10005': [
                                    DDoSProtection,
                                    'Request frequency exceeds the limit'
                                ],
                                '10006': [
                                    PermissionDenied,
                                    'Unauthorized to execute this request'
                                ],
                                '10007': [
                                    PermissionDenied,
                                    'IP address Unauthorized'
                                ],
                                '10008': [
                                    InvalidNonce,
                                    'Timestamp for this request is invalid, timestamp must within 1 minute'
                                ],
                                '10009': [
                                    NetworkError,
                                    'Unexist endpoint, please check endpoint URL'
                                ],
                                '10011': [
                                    AccountSuspended,
                                    'ApiKey expired. Please go to client side to re-create an ApiKey'
                                ],
                                '20001': [
                                    PermissionDenied,
                                    'Trade is not open for this trading pair'
                                ],
                                '20002': [
                                    PermissionDenied,
                                    'Trade of this trading pair is suspended'
                                ],
                                '20003': [
                                    InvalidOrder,
                                    'Invalid price or amount'
                                ],
                                '20007': [
                                    InvalidOrder,
                                    'Price precision error'
                                ],
                                '20008': [
                                    InvalidOrder,
                                    'Amount precision error'
                                ],
                                '20009': [
                                    InvalidOrder,
                                    'Amount is less than the minimum requirement'
                                ],
                                '20010': [
                                    InvalidOrder,
                                    'Cash Amount is less than the minimum requirement'
                                ],
                                '20011': [
                                    InsufficientFunds,
                                    'Insufficient balance'
                                ],
                                '20012': [
                                    BadRequest,
                                    'Invalid trade type, valid value: buy/sell)'
                                ],
                                '20013': [
                                    InvalidOrder,
                                    'No order info found'
                                ],
                                '20014': [
                                    BadRequest,
                                    'Invalid date, Valid format: 2018-07-25)'
                                ],
                                '20015': [
                                    BadRequest,
                                    'Date exceeds the limit'
                                ],
                                '20018': [
                                    PermissionDenied,
                                    'Your trading rights have been banned by the system'
                                ],
                                '20019': [
                                    BadSymbol,
                                    'Wrong trading pair symbol. Correct format:"usdt_btc". Quote asset is in the front'
                                ],
                                '20020': [
                                    DDoSProtection,
                                    "You have violated the API operation trading rules and temporarily forbid trading. At present, we have certain restrictions on the user's transaction rate and withdrawal rate."
                                ],
                                '50000': [
                                    ExchangeError1,
                                    'Exception error'
                                ],
                                '20021': [
                                    BadRequest,
                                    'Invalid currency'
                                ],
                                '20022': [
                                    BadRequest,
                                    'The ending timestamp must be larger than the starting timestamp'
                                ],
                                '20023': [
                                    BadRequest,
                                    'Invalid transfer type'
                                ],
                                '20024': [
                                    BadRequest,
                                    'Invalid amount'
                                ],
                                '20025': [
                                    BadRequest,
                                    'This currency is not transferable at the moment'
                                ],
                                '20026': [
                                    InsufficientFunds,
                                    'Transfer amount exceed your balance'
                                ],
                                '20027': [
                                    PermissionDenied,
                                    'Abnormal account status'
                                ],
                                '20028': [
                                    PermissionDenied,
                                    'Blacklist for transfer'
                                ],
                                '20029': [
                                    PermissionDenied,
                                    'Transfer amount exceed your daily limit'
                                ],
                                '20030': [
                                    BadRequest,
                                    'You have no position on this trading pair'
                                ],
                                '20032': [
                                    PermissionDenied,
                                    'Withdrawal limited'
                                ],
                                '20033': [
                                    BadRequest,
                                    'Wrong Withdrawal ID'
                                ],
                                '20034': [
                                    PermissionDenied,
                                    'Withdrawal service of this crypto has been closed'
                                ],
                                '20035': [
                                    PermissionDenied,
                                    'Withdrawal limit'
                                ],
                                '20036': [
                                    ExchangeError1,
                                    'Withdrawal cancellation failed'
                                ],
                                '20037': [
                                    InvalidAddress,
                                    'The withdrawal address, Tag or chain type is not included in the withdrawal management list'
                                ],
                                '20038': [
                                    InvalidAddress,
                                    'The withdrawal address is not on the white list'
                                ],
                                '20039': [
                                    ExchangeError1,
                                    "Can't be canceled in current status"
                                ],
                                '20040': [
                                    RateLimitExceeded,
                                    'Withdraw too frequently; limitation: 3 times a minute, 100 times a day'
                                ],
                                '20041': [
                                    PermissionDenied,
                                    'Beyond the daily withdrawal limit'
                                ],
                                '20042': [
                                    BadSymbol,
                                    'Current trading pair does not support API trading'
                                ]
                            },
                            'broad': {}
                        },
                        'options': {
                            'defaultType': 'spot',
                            'types': [
                                'spot',
                                'margin',
                                'otc'
                            ],
                            'accountsByType': {
                                'spot': '1',
                                'margin': '2',
                                'OTC': '3'
                            }
                        },
                        'commonCurrencies': {
                            'BHT': 'Black House Test',
                            'EPS': 'Epanus',
                            'FREE': 'FreeRossDAO',
                            'MBN': 'Mobilian Coin',
                            'TEL': 'TEL666'
                        }
                    });
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "deposit_status":1,
                    //                 "min_deposit_amount":10,
                    //                 "withdraw_fee_rate":0,
                    //                 "min_withdraw_amount":10,
                    //                 "min_withdraw_fee":5,
                    //                 "currency":"USDT",
                    //                 "withdraw_status":0,
                    //                 "chain":"OMNI"
                    //             },
                    //             {
                    //                 "deposit_status":1,
                    //                 "min_deposit_amount":10,
                    //                 "withdraw_fee_rate":0,
                    //                 "min_withdraw_amount":10,
                    //                 "min_withdraw_fee":3,
                    //                 "currency":"USDT",
                    //                 "withdraw_status":1,
                    //                 "chain":"ERC20"
                    //             },
                    //             {
                    //                 "deposit_status":0,
                    //                 "min_deposit_amount":0,
                    //                 "withdraw_fee_rate":0,
                    //                 "min_withdraw_amount":0,
                    //                 "min_withdraw_fee":0,
                    //                 "currency":"DGF13",
                    //                 "withdraw_status":0,
                    //                 "chain":""
                    //             },
                    //         ],
                    //         "code":200
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = {};
                    for(let i = 0; i < data.length; i++){
                        const currency = data[i];
                        const id = this.safeString(currency, 'currency');
                        const code = this.safeCurrencyCode(id);
                        const depositStatus = this.safeInteger(currency, 'deposit_status', 1);
                        const withdrawStatus = this.safeInteger(currency, 'withdraw_status', 1);
                        const deposit = depositStatus > 0;
                        const withdraw = withdrawStatus > 0;
                        const active = deposit && withdraw;
                        const fee = this.safeNumber(currency, 'withdraw_fee_rate');
                        if (code in result) {
                            if (Array.isArray(result[code]['info'])) result[code]['info'].push(currency);
                            else result[code]['info'] = [
                                result[code]['info'],
                                currency
                            ];
                        } else result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'type': undefined,
                            'name': undefined,
                            'active': active,
                            'deposit': deposit,
                            'withdraw': withdraw,
                            'fee': fee,
                            'precision': 8,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'min_withdraw_amount'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const options = this.safeValue(this.options, 'fetchMarkets', {});
                    const method = this.safeString(options, 'method', 'fetch_markets_v2');
                    return await this[method](params);
                }
                async fetchMarketsV2(params = {}) {
                    const response = await this.publicGetTradesSymbols(params);
                    //
                    //     {
                    //         "symbol_list":[
                    //             {
                    //                 "order_types":["LIMIT","MARKET"],
                    //                 "quote_asset":"USDT",
                    //                 "minimum_value":2,
                    //                 "amount_precision":4,
                    //                 "status":"TRADING",
                    //                 "minimum_amount":0.0001,
                    //                 "symbol":"BTC_USDT",
                    //                 "is_allow":1,
                    //                 "zone":"MAIN",
                    //                 "base_asset":"BTC",
                    //                 "price_precision":2
                    //             }
                    //         ],
                    //         "code":0
                    //     }
                    //
                    const markets = this.safeValue(response, 'symbol_list', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'symbol');
                        const baseId = this.safeString(market, 'base_asset');
                        const quoteId = this.safeString(market, 'quote_asset');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        //
                        // The status is documented in the exchange API docs as follows:
                        // TRADING, HALT (delisted), BREAK (trading paused)
                        // https://docs.digifinex.vip/en-ww/v3/#/public/spot/symbols
                        // However, all spot markets actually have status === 'HALT'
                        // despite that they appear to be active on the exchange website.
                        // Apparently, we can't trust this status.
                        // const status = this.safeString (market, 'status');
                        // const active = (status === 'TRADING');
                        //
                        const isAllowed = this.safeInteger(market, 'is_allow', 1);
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': isAllowed ? true : false,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'amount_precision'),
                                'price': this.safeInteger(market, 'price_precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minimum_amount'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minimum_value'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchMarketsV1(params = {}) {
                    const response = await this.publicGetMarkets(params);
                    //
                    //     {
                    //         "data": [
                    //             {
                    //                 "volume_precision":4,
                    //                 "price_precision":2,
                    //                 "market":"btc_usdt",
                    //                 "min_amount":2,
                    //                 "min_volume":0.0001
                    //             },
                    //         ],
                    //         "date":1564507456,
                    //         "code":0
                    //     }
                    //
                    const markets = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'market');
                        const [baseId, quoteId] = id.split('_');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'price': this.safeInteger(market, 'price_precision'),
                                'amount': this.safeInteger(market, 'volume_precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min_volume'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_amount'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'list', []);
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['used'] = this.safeString(balance, 'frozen');
                        account['free'] = this.safeString(balance, 'free');
                        account['total'] = this.safeString(balance, 'total');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    const method = 'privateGet' + this.capitalize(type) + 'Assets';
                    const response = await this[method](params);
                    //
                    //     {
                    //         "code": 0,
                    //         "list": [
                    //             {
                    //                 "currency": "BTC",
                    //                 "free": 4723846.89208129,
                    //                 "total": 0
                    //             }
                    //         ]
                    //     }
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 10, max 150
                    const response = await this.publicGetOrderBook(this.extend(request, params));
                    //
                    //     {
                    //         "bids": [
                    //             [9605.77,0.0016],
                    //             [9605.46,0.0003],
                    //             [9602.04,0.0127],
                    //         ],
                    //         "asks": [
                    //             [9627.22,0.025803],
                    //             [9627.12,0.168543],
                    //             [9626.52,0.0011529],
                    //         ],
                    //         "date":1564509499,
                    //         "code":0
                    //     }
                    //
                    const timestamp = this.safeTimestamp(response, 'date');
                    return this.parseOrderBook(response, symbol, timestamp);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTicker(params);
                    //
                    //    {
                    //        "ticker": [{
                    //            "vol": 40717.4461,
                    //            "change": -1.91,
                    //            "base_vol": 392447999.65374,
                    //            "sell": 9592.23,
                    //            "last": 9592.22,
                    //            "symbol": "btc_usdt",
                    //            "low": 9476.24,
                    //            "buy": 9592.03,
                    //            "high": 9793.87
                    //        }],
                    //        "date": 1589874294,
                    //        "code": 0
                    //    }
                    //
                    const result = {};
                    const tickers = this.safeValue(response, 'ticker', []);
                    const date = this.safeInteger(response, 'date');
                    for(let i = 0; i < tickers.length; i++){
                        const rawTicker = this.extend({
                            'date': date
                        }, tickers[i]);
                        const ticker = this.parseTicker(rawTicker);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    //
                    //    {
                    //        "ticker": [{
                    //            "vol": 40717.4461,
                    //            "change": -1.91,
                    //            "base_vol": 392447999.65374,
                    //            "sell": 9592.23,
                    //            "last": 9592.22,
                    //            "symbol": "btc_usdt",
                    //            "low": 9476.24,
                    //            "buy": 9592.03,
                    //            "high": 9793.87
                    //        }],
                    //        "date": 1589874294,
                    //        "code": 0
                    //    }
                    //
                    const date = this.safeInteger(response, 'date');
                    const tickers = this.safeValue(response, 'ticker', []);
                    const firstTicker = this.safeValue(tickers, 0, {});
                    const result = this.extend({
                        'date': date
                    }, firstTicker);
                    return this.parseTicker(result, market);
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker, fetchTickers
                    //
                    //     {
                    //         "last":0.021957,
                    //         "symbol": "btc_usdt",
                    //         "base_vol":2249.3521732227,
                    //         "change":-0.6,
                    //         "vol":102443.5111,
                    //         "sell":0.021978,
                    //         "low":0.021791,
                    //         "buy":0.021946,
                    //         "high":0.022266,
                    //         "date"1564518452, // injected from fetchTicker/fetchTickers
                    //     }
                    //
                    const marketId = this.safeStringUpper(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const timestamp = this.safeTimestamp(ticker, 'date');
                    const last = this.safeString(ticker, 'last');
                    const percentage = this.safeString(ticker, 'change');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'vol'),
                        'quoteVolume': this.safeString(ticker, 'base_vol'),
                        'info': ticker
                    }, market, false);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "date":1564520003,
                    //         "id":1596149203,
                    //         "amount":0.7073,
                    //         "type":"buy",
                    //         "price":0.02193,
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "symbol": "BTC_USDT",
                    //         "order_id": "6707cbdcda0edfaa7f4ab509e4cbf966",
                    //         "id": 28457,
                    //         "price": 0.1,
                    //         "amount": 0,
                    //         "fee": 0.096,
                    //         "fee_currency": "USDT",
                    //         "timestamp": 1499865549,
                    //         "side": "buy", // or "side": "sell_market"
                    //         "is_maker": true
                    //     }
                    //
                    const id = this.safeString(trade, 'id');
                    const orderId = this.safeString(trade, 'order_id');
                    const timestamp = this.safeTimestamp2(trade, 'date', 'timestamp');
                    let side = this.safeString2(trade, 'type', 'side');
                    const parts = side.split('_');
                    side = this.safeString(parts, 0);
                    const type = this.safeString(parts, 1);
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const marketId = this.safeString(trade, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const takerOrMaker = this.safeValue(trade, 'is_maker');
                    const feeCostString = this.safeString(trade, 'fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'fee_currency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': type,
                        'order': orderId,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'takerOrMaker': takerOrMaker,
                        'fee': fee
                    }, market);
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTime(params);
                    //
                    //     {
                    //         "server_time": 1589873762,
                    //         "code": 0
                    //     }
                    //
                    return this.safeTimestamp(response, 'server_time');
                }
                async fetchStatus(params = {}) {
                    const response = await this.publicGetPing(params);
                    //
                    //     {
                    //         "msg": "pong",
                    //         "code": 0
                    //     }
                    //
                    const code = this.safeInteger(response, 'code');
                    const status = code === 0 ? 'ok' : 'maintenance';
                    return {
                        'status': status,
                        'updated': this.milliseconds(),
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 500
                    const response = await this.publicGetTrades(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "date":1564520003,
                    //                 "id":1596149203,
                    //                 "amount":0.7073,
                    //                 "type":"buy",
                    //                 "price":0.02193,
                    //             },
                    //             {
                    //                 "date":1564520002,
                    //                 "id":1596149165,
                    //                 "amount":0.3232,
                    //                 "type":"sell",
                    //                 "price":0.021927,
                    //             },
                    //         ],
                    //         "code": 0,
                    //         "date": 1564520003,
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1556712900,
                    //         2205.899,
                    //         0.029967,
                    //         0.02997,
                    //         0.029871,
                    //         0.029927
                    //     ]
                    //
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 5),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 1)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'period': this.timeframes[timeframe]
                    };
                    if (since !== undefined) {
                        const startTime = parseInt(since / 1000);
                        request['start_time'] = startTime;
                        if (limit !== undefined) {
                            const duration = this.parseTimeframe(timeframe);
                            request['end_time'] = this.sum(startTime, limit * duration);
                        }
                    } else if (limit !== undefined) {
                        const endTime = this.seconds();
                        const duration = this.parseTimeframe(timeframe);
                        request['startTime'] = this.sum(endTime, -limit * duration);
                    }
                    const response = await this.publicGetKline(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "data":[
                    //             [1556712900,2205.899,0.029967,0.02997,0.029871,0.029927],
                    //             [1556713800,1912.9174,0.029992,0.030014,0.029955,0.02996],
                    //             [1556714700,1556.4795,0.029974,0.030019,0.029969,0.02999],
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    const orderType = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    const request = {
                        'market': orderType,
                        'symbol': market['id'],
                        'amount': this.amountToPrecision(symbol, amount)
                    };
                    let suffix = '';
                    if (type === 'market') suffix = '_market';
                    else request['price'] = this.priceToPrecision(symbol, price);
                    request['type'] = side + suffix;
                    const response = await this.privatePostMarketOrderNew(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "order_id": "198361cecdc65f9c8c9bb2fa68faec40"
                    //     }
                    //
                    const result = this.parseOrder(response, market);
                    return this.extend(result, {
                        'symbol': symbol,
                        'side': side,
                        'type': type,
                        'amount': amount,
                        'price': price
                    });
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    const orderType = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    const request = {
                        'market': orderType,
                        'order_id': id
                    };
                    const response = await this.privatePostMarketOrderCancel(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "success": [
                    //             "198361cecdc65f9c8c9bb2fa68faec40",
                    //             "3fb0d98e51c18954f10d439a9cf57de0"
                    //         ],
                    //         "error": [
                    //             "78a7104e3c65cc0c5a212a53e76d0205"
                    //         ]
                    //     }
                    //
                    const canceledOrders = this.safeValue(response, 'success', []);
                    const numCanceledOrders = canceledOrders.length;
                    if (numCanceledOrders !== 1) throw new OrderNotFound(this.id + ' cancelOrder() ' + id + ' not found');
                    return response;
                }
                async cancelOrders(ids, symbol, params = {}) {
                    await this.loadMarkets();
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    const orderType = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    const request = {
                        'market': orderType,
                        'order_id': ids.join(',')
                    };
                    const response = await this.privatePostCancelOrder(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "success": [
                    //             "198361cecdc65f9c8c9bb2fa68faec40",
                    //             "3fb0d98e51c18954f10d439a9cf57de0"
                    //         ],
                    //         "error": [
                    //             "78a7104e3c65cc0c5a212a53e76d0205"
                    //         ]
                    //     }
                    //
                    const canceledOrders = this.safeValue(response, 'success', []);
                    const numCanceledOrders = canceledOrders.length;
                    if (numCanceledOrders < 1) throw new OrderNotFound(this.id + ' cancelOrders() error');
                    return response;
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '0': 'open',
                        '1': 'open',
                        '2': 'closed',
                        '3': 'canceled',
                        '4': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "code": 0,
                    //         "order_id": "198361cecdc65f9c8c9bb2fa68faec40"
                    //     }
                    //
                    // fetchOrder, fetchOpenOrders, fetchOrders
                    //
                    //     {
                    //         "symbol": "BTC_USDT",
                    //         "order_id": "dd3164b333a4afa9d5730bb87f6db8b3",
                    //         "created_date": 1562303547,
                    //         "finished_date": 0,
                    //         "price": 0.1,
                    //         "amount": 1,
                    //         "cash_amount": 1,
                    //         "executed_amount": 0,
                    //         "avg_price": 0,
                    //         "status": 1,
                    //         "type": "buy",
                    //         "kind": "margin"
                    //     }
                    //
                    const id = this.safeString(order, 'order_id');
                    const timestamp = this.safeTimestamp(order, 'created_date');
                    const lastTradeTimestamp = this.safeTimestamp(order, 'finished_date');
                    let side = this.safeString(order, 'type');
                    let type = undefined;
                    if (side !== undefined) {
                        const parts = side.split('_');
                        const numParts = parts.length;
                        if (numParts > 1) {
                            side = parts[0];
                            type = parts[1];
                        } else type = 'limit';
                    }
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const amountString = this.safeString(order, 'amount');
                    const filledString = this.safeString(order, 'executed_amount');
                    const priceString = this.safeString(order, 'price');
                    const averageString = this.safeString(order, 'avg_price');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': priceString,
                        'stopPrice': undefined,
                        'amount': amountString,
                        'filled': filledString,
                        'remaining': undefined,
                        'cost': undefined,
                        'average': averageString,
                        'status': status,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    const orderType = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        'market': orderType
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const response = await this.privateGetMarketOrderCurrent(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "symbol": "BTC_USDT",
                    //                 "order_id": "dd3164b333a4afa9d5730bb87f6db8b3",
                    //                 "created_date": 1562303547,
                    //                 "finished_date": 0,
                    //                 "price": 0.1,
                    //                 "amount": 1,
                    //                 "cash_amount": 1,
                    //                 "executed_amount": 0,
                    //                 "avg_price": 0,
                    //                 "status": 1,
                    //                 "type": "buy",
                    //                 "kind": "margin"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    const orderType = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        'market': orderType
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['start_time'] = parseInt(since / 1000); // default 3 days from now, max 30 days
                    if (limit !== undefined) request['limit'] = limit; // default 10, max 100
                    const response = await this.privateGetMarketOrderHistory(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "symbol": "BTC_USDT",
                    //                 "order_id": "dd3164b333a4afa9d5730bb87f6db8b3",
                    //                 "created_date": 1562303547,
                    //                 "finished_date": 0,
                    //                 "price": 0.1,
                    //                 "amount": 1,
                    //                 "cash_amount": 1,
                    //                 "executed_amount": 0,
                    //                 "avg_price": 0,
                    //                 "status": 1,
                    //                 "type": "buy",
                    //                 "kind": "margin"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchOrder(id, symbol, params = {}) {
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    const orderType = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'market': orderType,
                        'order_id': id
                    };
                    const response = await this.privateGetMarketOrder(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "symbol": "BTC_USDT",
                    //                 "order_id": "dd3164b333a4afa9d5730bb87f6db8b3",
                    //                 "created_date": 1562303547,
                    //                 "finished_date": 0,
                    //                 "price": 0.1,
                    //                 "amount": 1,
                    //                 "cash_amount": 1,
                    //                 "executed_amount": 0,
                    //                 "avg_price": 0,
                    //                 "status": 1,
                    //                 "type": "buy",
                    //                 "kind": "margin"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const order = this.safeValue(data, 0);
                    if (order === undefined) throw new OrderNotFound(this.id + ' fetchOrder() order ' + id + ' not found');
                    return this.parseOrder(order, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    const orderType = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        'market': orderType
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['start_time'] = parseInt(since / 1000); // default 3 days from now, max 30 days
                    if (limit !== undefined) request['limit'] = limit; // default 10, max 100
                    const response = await this.privateGetMarketMytrades(this.extend(request, params));
                    //
                    //      {
                    //          "list":[
                    //              {
                    //                  "timestamp":1639506068,
                    //                  "is_maker":false,
                    //                  "id":"8975951332",
                    //                  "amount":31.83,
                    //                  "side":"sell_market",
                    //                  "symbol":"DOGE_USDT",
                    //                  "fee_currency":"USDT",
                    //                  "fee":0.01163774826
                    //                  ,"order_id":"32b169792f4a7a19e5907dc29fc123d4",
                    //                  "price":0.182811
                    //                }
                    //             ],
                    //           "code": 0
                    //      }
                    //
                    const data = this.safeValue(response, 'list', []);
                    return this.parseTrades(data, market, since, limit);
                }
                parseLedgerEntryType(type) {
                    const types = {};
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     {
                    //         "currency_mark": "BTC",
                    //         "type": 100234,
                    //         "num": 28457,
                    //         "balance": 0.1,
                    //         "time": 1546272000
                    //     }
                    //
                    const id = this.safeString(item, 'num');
                    const account = undefined;
                    const type = this.parseLedgerEntryType(this.safeString(item, 'type'));
                    const code = this.safeCurrencyCode(this.safeString(item, 'currency_mark'), currency);
                    const timestamp = this.safeTimestamp(item, 'time');
                    const before = undefined;
                    const after = this.safeNumber(item, 'balance');
                    const status = 'ok';
                    return {
                        'info': item,
                        'id': id,
                        'direction': undefined,
                        'account': account,
                        'referenceId': undefined,
                        'referenceAccount': undefined,
                        'type': type,
                        'currency': code,
                        'amount': undefined,
                        'before': before,
                        'after': after,
                        'status': status,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': undefined
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    const orderType = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    await this.loadMarkets();
                    const request = {
                        'market': orderType
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency_mark'] = currency['id'];
                    }
                    if (since !== undefined) request['start_time'] = parseInt(since / 1000);
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 1000
                    const response = await this.privateGetMarketFinancelog(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "data": {
                    //             "total": 521,
                    //             "finance": [
                    //                 {
                    //                     "currency_mark": "BTC",
                    //                     "type": 100234,
                    //                     "num": 28457,
                    //                     "balance": 0.1,
                    //                     "time": 1546272000
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const items = this.safeValue(data, 'finance', []);
                    return this.parseLedger(items, currency, since, limit);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         "addressTag":"",
                    //         "address":"0xf1104d9f8624f89775a3e9d480fc0e75a8ef4373",
                    //         "currency":"USDT",
                    //         "chain":"ERC20"
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'address');
                    const tag = this.safeString(depositAddress, 'addressTag');
                    const currencyId = this.safeStringUpper(depositAddress, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    return {
                        'info': depositAddress,
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateGetDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "addressTag":"",
                    //                 "address":"0xf1104d9f8624f89775a3e9d480fc0e75a8ef4373",
                    //                 "currency":"USDT",
                    //                 "chain":"ERC20"
                    //             }
                    //         ],
                    //         "code":200
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const addresses = this.parseDepositAddresses(data);
                    const address = this.safeValue(addresses, code);
                    if (address === undefined) throw new InvalidAddress(this.id + ' fetchDepositAddress() did not return an address for ' + code + ' - create the deposit address in the user settings on the exchange website first.');
                    return address;
                }
                async fetchTransactionsByType(type, code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {
                    };
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['size'] = Math.min(500, limit);
                    const method = type === 'deposit' ? 'privateGetDepositHistory' : 'privateGetWithdrawHistory';
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "code": 200,
                    //         "data": [
                    //             {
                    //                 "id": 1171,
                    //                 "currency": "xrp",
                    //                 "hash": "ed03094b84eafbe4bc16e7ef766ee959885ee5bcb265872baaa9c64e1cf86c2b",
                    //                 "chain": "",
                    //                 "amount": 7.457467,
                    //                 "address": "rae93V8d2mdoUQHwBDBdM4NHCMehRJAsbm",
                    //                 "memo": "100040",
                    //                 "fee": 0,
                    //                 "state": "safe",
                    //                 "created_date": "2020-04-20 11:23:00",
                    //                 "finished_date": "2020-04-20 13:23:00"
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, currency, since, limit, {
                        'type': type
                    });
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    return await this.fetchTransactionsByType('deposit', code, since, limit, params);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    return await this.fetchTransactionsByType('withdrawal', code, since, limit, params);
                }
                parseTransactionStatus(status) {
                    // deposit state includes: 1 (in deposit), 2 (to be confirmed), 3 (successfully deposited), 4 (stopped)
                    // withdrawal state includes: 1 (application in progress), 2 (to be confirmed), 3 (completed), 4 (rejected)
                    const statuses = {
                        '1': 'pending',
                        '2': 'pending',
                        '3': 'ok',
                        '4': 'failed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "code": 200,
                    //         "withdraw_id": 700
                    //     }
                    //
                    // fetchDeposits, fetchWithdrawals
                    //
                    //     {
                    //         "id": 1171,
                    //         "currency": "xrp",
                    //         "hash": "ed03094b84eafbe4bc16e7ef766ee959885ee5bcb265872baaa9c64e1cf86c2b",
                    //         "chain": "",
                    //         "amount": 7.457467,
                    //         "address": "rae93V8d2mdoUQHwBDBdM4NHCMehRJAsbm",
                    //         "memo": "100040",
                    //         "fee": 0,
                    //         "state": "safe",
                    //         "created_date": "2020-04-20 11:23:00",
                    //         "finished_date": "2020-04-20 13:23:00"
                    //     }
                    //
                    const id = this.safeString2(transaction, 'id', 'withdraw_id');
                    const address = this.safeString(transaction, 'address');
                    let tag = this.safeString(transaction, 'memo'); // set but unused
                    if (tag !== undefined) {
                        if (tag.length < 1) tag = undefined;
                    }
                    const txid = this.safeString(transaction, 'hash');
                    const currencyId = this.safeStringUpper(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const timestamp = this.parse8601(this.safeString(transaction, 'created_date'));
                    const updated = this.parse8601(this.safeString(transaction, 'finished_date'));
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    const amount = this.safeNumber(transaction, 'amount');
                    const feeCost = this.safeNumber(transaction, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'currency': code,
                        'cost': feeCost
                    };
                    let network = this.safeString(transaction, 'chain');
                    if (network === '') network = undefined;
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'tagFrom': undefined,
                        'type': undefined,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        '0': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //         "code": 0
                    //     }
                    //
                    return {
                        'info': transfer,
                        'id': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'currency': this.safeCurrencyCode(undefined, currency),
                        'amount': this.safeNumber(transfer, 'amount'),
                        'fromAccount': this.safeString(transfer, 'fromAccount'),
                        'toAccount': this.safeString(transfer, 'toAccount'),
                        'status': this.parseTransferStatus(this.safeString(transfer, 'code'))
                    };
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                    const toId = this.safeString(accountsByType, toAccount, toAccount);
                    const request = {
                        'currency_mark': currency['id'],
                        'num': parseFloat(this.currencyToPrecision(code, amount)),
                        'from': fromId,
                        'to': toId
                    };
                    const response = await this.privatePostTransfer(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0
                    //     }
                    //
                    const transfer = this.parseTransfer(response, currency);
                    return this.extend(transfer, {
                        'amount': amount,
                        'currency': code,
                        'fromAccount': fromAccount,
                        'toAccount': toAccount
                    });
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        // 'chain': 'ERC20', 'OMNI', 'TRC20', // required for USDT
                        'address': address,
                        'amount': parseFloat(amount),
                        'currency': currency['id']
                    };
                    if (tag !== undefined) request['memo'] = tag;
                    const response = await this.privatePostWithdrawNew(this.extend(request, params));
                    //
                    //     {
                    //         "code": 200,
                    //         "withdraw_id": 700
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const version = this.version;
                    let url = this.urls['api'] + '/' + version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    const urlencoded = this.urlencode(this.keysort(query));
                    if (api === 'private') {
                        const nonce = this.nonce().toString();
                        const auth = urlencoded;
                        // the signature is not time-limited :\
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                        if (method === 'GET') {
                            if (urlencoded) url += '?' + urlencoded;
                        } else if (method === 'POST') {
                            headers = {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            };
                            if (urlencoded) body = urlencoded;
                        }
                        headers = {
                            'ACCESS-KEY': this.apiKey,
                            'ACCESS-SIGN': signature,
                            'ACCESS-TIMESTAMP': nonce
                        };
                    } else if (urlencoded) url += '?' + urlencoded;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(statusCode, statusText, url, method, responseHeaders, responseBody, response, requestHeaders, requestBody) {
                    if (!response) return; // fall back to default error handler
                    const code = this.safeString(response, 'code');
                    if (code === '0' || code === '200') return; // no error
                    const feedback = this.id + ' ' + responseBody;
                    if (code === undefined) throw new BadResponse(feedback);
                    const unknownError = [
                        ExchangeError1,
                        feedback
                    ];
                    const [ExceptionClass, message] = this.safeValue(this.exceptions['exact'], code, unknownError);
                    throw new ExceptionClass(message);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    77: [
        function(require1, module, exports) {
            'use strict';
            // ----------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, BadSymbol: BadSymbol } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            // ----------------------------------------------------------------------------
            module.exports = class eqonex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'eqonex',
                        'name': 'EQONEX',
                        'countries': [
                            'US',
                            'SG'
                        ],
                        'rateLimit': 10,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': undefined,
                            'future': undefined,
                            'option': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchCanceledOrders': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchTicker': undefined,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTradingLimits': true,
                            'fetchWithdrawals': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': 1,
                            '5m': 2,
                            '15m': 3,
                            '1h': 4,
                            '6h': 5,
                            '1d': 6,
                            '7d': 7,
                            '1w': 7
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/122649755-1a076c80-d138-11eb-8f2e-9a9166a03d79.jpg',
                            'test': {
                                'public': 'https://testnet.eqonex.com/api',
                                'private': 'https://testnet.eqonex.com/api'
                            },
                            'api': {
                                'public': 'https://eqonex.com/api',
                                'private': 'https://eqonex.com/api'
                            },
                            'www': 'https://eqonex.com',
                            'doc': [
                                'https://developer.eqonex.com'
                            ],
                            'referral': 'https://eqonex.com?referredByCode=zpa8kij4ouvBFup3'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'health',
                                    'getInstruments',
                                    'getInstrumentPairs',
                                    'getOrderBook',
                                    'getRisk',
                                    'getTradeHistory',
                                    'getFundingRateHistory',
                                    'getChart',
                                    'getExchangeInfo'
                                ]
                            },
                            'private': {
                                'post': [
                                    'logon',
                                    'order',
                                    'cancelOrder',
                                    'cancelReplaceOrder',
                                    'getOrder',
                                    'getOrders',
                                    'getOrderStatus',
                                    'getOrderHistory',
                                    'userTrades',
                                    'getPositions',
                                    'cancelAll',
                                    'getUserHistory',
                                    'getRisk',
                                    'getDepositAddresses',
                                    'getDepositHistory',
                                    'getWithdrawRequests',
                                    'sendWithdrawRequest',
                                    'getTransferHistory'
                                ]
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'uid': true
                        },
                        'exceptions': {
                            'broad': {
                                'symbol not found': BadSymbol
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const request = {
                        'verbose': true
                    };
                    const response = await this.publicGetGetInstrumentPairs(this.extend(request, params));
                    //
                    //    {
                    //        "instrumentPairs": [
                    //            {
                    //                "instrumentId":303,
                    //                "symbol":"BTC/USDC[220325]",
                    //                "quoteId":1,
                    //                "baseId":3,
                    //                "price_scale":2,
                    //                "quantity_scale":6,
                    //                "securityStatus":1,
                    //                "securityDesc":"BTC Dated Future",
                    //                "assetType":"DATED_FUTURE",
                    //                "currency":"BTC",
                    //                "contAmtCurr":"USDC",
                    //                "settlCurrency":"USDC",
                    //                "commCurrency":"USDC",
                    //                "cfiCode":"FFCPSX",
                    //                "securityExchange":"EQOS",
                    //                "micCode":"EQOD",
                    //                "instrumentPricePrecision":2,
                    //                "minPriceIncrement":1.0,
                    //                "minPriceIncrementAmount":1.0,
                    //                "roundLot":100,
                    //                "minTradeVol":0.000100,
                    //                "maxTradeVol":0.000000,
                    //                "qtyType":0,
                    //                "contractMultiplier":1.0,
                    //                "auctionStartTime":0,
                    //                "auctionDuration":0,
                    //                "auctionFrequency":0,
                    //                "auctionPrice":0,
                    //                "auctionVolume":0,
                    //                "marketStatus":"OPEN",
                    //                "underlyingSymbol":"BTC/USDC",
                    //                "underlyingSecurityId":52,
                    //                "underlyingSecuritySource":"M",
                    //                "underlyingSecurityExchange":"EQOC",
                    //                "issueDate":1643256000000,
                    //                "maturityDate":"2022-03-25",
                    //                "maturityTime":"2022-03-25T08:00:00Z",
                    //                "contractExpireTime":1648195200000
                    //            }
                    //            ...
                    //        ]
                    //    }
                    //
                    const instrumentPairs = this.safeValue(response, 'instrumentPairs', []);
                    const markets = [];
                    for(let i = 0; i < instrumentPairs.length; i++){
                        const market = this.parseMarket(instrumentPairs[i]);
                        markets.push(market);
                    }
                    return markets;
                }
                parseMarket(market) {
                    //
                    //    {
                    //        "instrumentPairs": [
                    //            {
                    //                "instrumentId":303,
                    //                "symbol":"BTC/USDC[220325]",
                    //                "quoteId":1,
                    //                "baseId":3,
                    //                "price_scale":2,
                    //                "quantity_scale":6,
                    //                "securityStatus":1,
                    //                "securityDesc":"BTC Dated Future",
                    //                "assetType":"DATED_FUTURE",
                    //                "currency":"BTC",
                    //                "contAmtCurr":"USDC",
                    //                "settlCurrency":"USDC",
                    //                "commCurrency":"USDC",
                    //                "cfiCode":"FFCPSX",
                    //                "securityExchange":"EQOS",
                    //                "micCode":"EQOD",
                    //                "instrumentPricePrecision":2,
                    //                "minPriceIncrement":1.0,
                    //                "minPriceIncrementAmount":1.0,
                    //                "roundLot":100,
                    //                "minTradeVol":0.000100,
                    //                "maxTradeVol":0.000000,
                    //                "qtyType":0,
                    //                "contractMultiplier":1.0,
                    //                "auctionStartTime":0,
                    //                "auctionDuration":0,
                    //                "auctionFrequency":0,
                    //                "auctionPrice":0,
                    //                "auctionVolume":0,
                    //                "marketStatus":"OPEN",
                    //                "underlyingSymbol":"BTC/USDC",
                    //                "underlyingSecurityId":52,
                    //                "underlyingSecuritySource":"M",
                    //                "underlyingSecurityExchange":"EQOC",
                    //                "issueDate":1643256000000,
                    //                "maturityDate":"2022-03-25",
                    //                "maturityTime":"2022-03-25T08:00:00Z",
                    //                "contractExpireTime":1648195200000
                    //            }
                    //            ...
                    //        ]
                    //    }
                    //
                    const assetType = this.safeString(market, 'assetType');
                    const spot = assetType === 'PAIR';
                    const swap = assetType === 'PERPETUAL_SWAP';
                    const future = assetType === 'DATED_FUTURE';
                    const contract = swap || future;
                    const id = this.safeString(market, 'instrumentId');
                    const baseId = this.safeString(market, 'currency');
                    const quoteId = this.safeString(market, 'contAmtCurr');
                    const settleId = contract ? this.safeString(market, 'settlCurrency') : undefined;
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    const settle = this.safeCurrencyCode(settleId);
                    let symbol = base + '/' + quote;
                    const uppercaseId = this.safeString(market, 'symbol');
                    let type = 'spot';
                    let linear = undefined;
                    let inverse = undefined;
                    const expiry = this.safeNumber(market, 'contractExpireTime');
                    if (contract) {
                        symbol = symbol + ':' + settle;
                        linear = quote === settle;
                        inverse = !linear;
                        if (swap) type = 'swap';
                        else if (future) {
                            symbol = symbol + '-' + this.yymmdd(expiry);
                            type = 'future';
                        } else {
                            symbol = uppercaseId;
                            type = assetType;
                        }
                    }
                    const status = this.safeInteger(market, 'securityStatus');
                    return {
                        'id': id,
                        'uppercaseId': uppercaseId,
                        'symbol': symbol,
                        'base': base,
                        'quote': quote,
                        'settle': settle,
                        'baseId': baseId,
                        'quoteId': quoteId,
                        'settleId': settleId,
                        'type': type,
                        'spot': spot,
                        'margin': false,
                        'swap': swap,
                        'future': future,
                        'option': false,
                        'active': status === 1,
                        'contract': contract,
                        'linear': linear,
                        'inverse': inverse,
                        'contractSize': this.safeNumber(market, 'contractMultiplier'),
                        'expiry': expiry,
                        'expiryDatetime': this.iso8601(expiry),
                        'strike': undefined,
                        'optionType': undefined,
                        'precision': {
                            'amount': this.safeInteger(market, 'quantity_scale'),
                            'price': this.safeInteger(market, 'price_scale')
                        },
                        'limits': {
                            'leverage': {
                                'min': undefined,
                                'max': undefined
                            },
                            'amount': {
                                'min': this.safeNumber(market, 'minTradeVol'),
                                'max': undefined
                            },
                            'price': {
                                'min': undefined,
                                'max': undefined
                            },
                            'cost': {
                                'min': undefined,
                                'max': undefined
                            }
                        },
                        'info': market
                    };
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetGetInstruments(params);
                    //
                    //     {
                    //         "instruments": [
                    //             [
                    //                 3,     // id
                    //                 "BTC", // symbol
                    //                 2,     // price_scale
                    //                 6,     // amount_scale
                    //                 1,     // status
                    //                 0,     // withdraw_fee
                    //                 "BTC", // name
                    //                 true,  // withdrawal_pct
                    //             ],
                    //         ]
                    //     }
                    //
                    const currencies = {};
                    const instruments = this.safeValue(response, 'instruments', []);
                    for(let i = 0; i < instruments.length; i++){
                        const currency = this.parseCurrency(instruments[i]);
                        const code = currency['code'];
                        currencies[code] = currency;
                    }
                    return currencies;
                }
                parseCurrency(currency) {
                    //
                    //     [
                    //         3,     // 0 id
                    //         "BTC", // 1 symbol
                    //         2,     // 2 price_scale
                    //         6,     // 3 amount_scale
                    //         1,     // 4 status
                    //         0,     // 5 withdraw_fee
                    //         "BTC", // 6 name
                    //         true,  // 7 withdrawal_pct
                    //     ],
                    //
                    const id = this.safeString(currency, 0);
                    const uppercaseId = this.safeString(currency, 1);
                    const code = this.safeCurrencyCode(uppercaseId);
                    const priceScale = this.safeInteger(currency, 2);
                    const amountScale = this.safeInteger(currency, 3);
                    const precision = Math.max(priceScale, amountScale);
                    const name = this.safeString(currency, 6);
                    const status = this.safeInteger(currency, 4);
                    const active = status === 1;
                    const fee = this.safeNumber(currency, 5); // withdraw_fee
                    return {
                        'id': id,
                        'info': currency,
                        'uppercaseId': uppercaseId,
                        'code': code,
                        'name': name,
                        'precision': precision,
                        'fee': fee,
                        'active': active,
                        'deposit': undefined,
                        'withdraw': undefined,
                        'limits': {
                            'amount': {
                                'min': undefined,
                                'max': undefined
                            },
                            'withdraw': {
                                'min': undefined,
                                'max': undefined
                            }
                        }
                    };
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pairId': parseInt(market['id']),
                        'timespan': this.timeframes[timeframe]
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetGetChart(this.extend(request, params));
                    //
                    //     {
                    //         "pairId":57,
                    //         "t":1,
                    //         "s":"ETH/BTC",
                    //         "lastPx":44099,
                    //         "lastQty":100000,
                    //         "o":0.043831000000000016,
                    //         "h":0.04427100000000002,
                    //         "l":0.032000000000000015,
                    //         "c":0.04409900000000002,
                    //         "v":0.21267333000000016,
                    //         "q":4.850000000000001,
                    //         "chart":[
                    //             [1612519260000,44099,44099,44099,44099,0,441],
                    //             [1612519200000,44099,44099,44099,44099,0,440],
                    //             [1612519140000,44269,44271,44269,44271,0,439],
                    //         ]
                    //     }
                    //
                    const chart = this.safeValue(response, 'chart', []);
                    return this.parseOHLCVs(chart, market, timeframe, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1612519260000, // timestamp
                    //         44099,         // open
                    //         44099,         // high
                    //         44099,         // low
                    //         44099,         // close
                    //         0,             // base volume
                    //         441,           // seqNumber
                    //     ]
                    //
                    const timestamp = this.safeInteger(ohlcv, 0);
                    const open = this.parseNumber(this.convertFromScale(this.safeString(ohlcv, 1), market['precision']['price']));
                    const high = this.parseNumber(this.convertFromScale(this.safeString(ohlcv, 2), market['precision']['price']));
                    const low = this.parseNumber(this.convertFromScale(this.safeString(ohlcv, 3), market['precision']['price']));
                    const close = this.parseNumber(this.convertFromScale(this.safeString(ohlcv, 4), market['precision']['price']));
                    const volume = this.parseNumber(this.convertFromScale(this.safeString(ohlcv, 5), market['precision']['amount']));
                    return [
                        timestamp,
                        open,
                        high,
                        low,
                        close,
                        volume
                    ];
                }
                parseBidAsk(bidask, priceKey = 0, amountKey = 1, market) {
                    if (market === undefined) throw new ArgumentsRequired1(this.id + ' parseBidAsk() requires a market argument');
                    const priceString = this.safeString(bidask, priceKey);
                    const amountString = this.safeString(bidask, amountKey);
                    return [
                        this.parseNumber(this.convertFromScale(priceString, market['precision']['price'])),
                        this.parseNumber(this.convertFromScale(amountString, market['precision']['amount']))
                    ];
                }
                parseOrderBook(orderbook, symbol, timestamp, bidsKey = 'bids', asksKey = 'asks', priceKey = 0, amountKey = 1, market) {
                    const result = {
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'nonce': undefined
                    };
                    const sides = [
                        bidsKey,
                        asksKey
                    ];
                    for(let i = 0; i < sides.length; i++){
                        const side = sides[i];
                        const orders = [];
                        const bidasks = this.safeValue(orderbook, side);
                        for(let k = 0; k < bidasks.length; k++)orders.push(this.parseBidAsk(bidasks[k], priceKey, amountKey, market));
                        result[side] = orders;
                    }
                    result[bidsKey] = this.sortBy(result[bidsKey], 0, true);
                    result[asksKey] = this.sortBy(result[asksKey], 0);
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pairId': parseInt(market['id'])
                    };
                    const response = await this.publicGetGetOrderBook(this.extend(request, params));
                    //
                    //     {
                    //         "bids":[
                    //             [4000480,30000,1612644984667],
                    //             [3999304,200000,1612644984667],
                    //             [3998862,50000,1612644984667],
                    //         ],
                    //         "asks":[
                    //             [4001962,1790000,1612644984667],
                    //             [4002616,1000,1612644984667],
                    //             [4003889,1000,1612644984667],
                    //         ],
                    //         "usdMark":40011.02,
                    //         "marketStatus":0,
                    //         "estFundingRate":0.0,
                    //         "fundingRateTime":0,
                    //         "auctionPrice":0.0,
                    //         "auctionVolume":0.0
                    //     }
                    //
                    return this.parseOrderBook(response, symbol, undefined, 'bids', 'asks', 0, 1, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pairId': parseInt(market['id'])
                    };
                    const response = await this.publicGetGetTradeHistory(this.extend(request, params));
                    //
                    //     {
                    //         "trades":[
                    //             [4022800,47000,"20210206-21:39:12.886",256323,1],
                    //             [4023066,1000,"20210206-21:38:55.030",256322,1],
                    //             [4022406,50000,"20210206-21:36:56.334",256321,1],
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, 'trades', []);
                    return this.parseTrades(trades, market, since, limit, params);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     [
                    //         4022800,                 // 0 price
                    //         47000,                   // 1 quantity
                    //         "20210206-21:39:12.886", // 2 timestamp
                    //         256323,                  // 3 sequence number
                    //         1                        // 4 taker side 1 = buy, 2 = sell
                    //     ]
                    //
                    // private fetchMyTrades
                    //
                    //     {
                    //         "account":3583,
                    //         "commission":"-0.015805",
                    //         "commCurrency":"USDC",
                    //         "execId":265757,
                    //         "ordType":"2",
                    //         "ordStatus":"2",
                    //         "execType":"F",
                    //         "aggressorIndicator":true,
                    //         "orderId":388953019,
                    //         "price":"1842.04",
                    //         "qty":"0.010000",
                    //         "lastPx":"1756.22",
                    //         "avgPx":"1756.22",
                    //         "cumQty":"0.010000",
                    //         "quoteQty":"0.010000",
                    //         "side":"BUY",
                    //         "symbol":"ETH/USDC",
                    //         "clOrdId":"1613106766970339107",
                    //         "submitterId":3583,
                    //         "targetStrategy":"0",
                    //         "time":1613106766971,
                    //         "date":"20210212-05:12:46.971"
                    //     }
                    //
                    let id = undefined;
                    let timestamp = undefined;
                    let orderId = undefined;
                    let type = undefined;
                    let side = undefined;
                    let priceString = undefined;
                    let amountString = undefined;
                    let fee = undefined;
                    let marketId = undefined;
                    if (Array.isArray(trade)) {
                        id = this.safeString(trade, 3);
                        priceString = this.convertFromScale(this.safeString(trade, 0), market['precision']['price']);
                        amountString = this.convertFromScale(this.safeString(trade, 1), market['precision']['amount']);
                        timestamp = this.toMilliseconds(this.safeString(trade, 2));
                        const takerSide = this.safeInteger(trade, 4);
                        if (takerSide === 1) side = 'buy';
                        else if (takerSide === 2) side = 'sell';
                    } else {
                        id = this.safeString(trade, 'execId');
                        timestamp = this.safeInteger(trade, 'time');
                        marketId = this.safeString(trade, 'symbol');
                        orderId = this.safeString(trade, 'orderId');
                        side = this.safeStringLower(trade, 'side');
                        type = this.parseOrderType(this.safeString(trade, 'ordType'));
                        priceString = this.safeString(trade, 'lastPx');
                        amountString = this.safeString(trade, 'qty');
                        let feeCostString = this.safeString(trade, 'commission');
                        if (feeCostString !== undefined) {
                            feeCostString = Precise.stringNeg(feeCostString);
                            const feeCurrencyId = this.safeString(trade, 'commCurrency');
                            const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                            fee = {
                                'cost': feeCostString,
                                'currency': feeCurrencyCode
                            };
                        }
                    }
                    market = this.safeMarket(marketId, market);
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': orderId,
                        'type': type,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                parseBalance(response) {
                    const positions = this.safeValue(response, 'positions', []);
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < positions.length; i++){
                        const position = positions[i];
                        const assetType = this.safeString(position, 'assetType');
                        if (assetType === 'ASSET') {
                            const currencyId = this.safeString(position, 'symbol');
                            const code = this.safeCurrencyCode(currencyId);
                            const quantityString = this.safeString(position, 'quantity');
                            const availableQuantityString = this.safeString(position, 'availableQuantity');
                            const scale = this.safeInteger(position, 'quantity_scale');
                            const account = this.account();
                            account['free'] = this.convertFromScale(availableQuantityString, scale);
                            account['total'] = this.convertFromScale(quantityString, scale);
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGetPositions(params);
                    //     {
                    //         "positions":[
                    //             {
                    //                 "instrumentId":1,
                    //                 "userId":3583,
                    //                 "quantity":0,
                    //                 "availableQuantity":0,
                    //                 "quantity_scale":6,
                    //                 "symbol":"USDC",
                    //                 "assetType":"ASSET",
                    //                 "usdCostBasis":0.0,
                    //                 "usdAvgCostBasis":0.0,
                    //                 "usdValue":0.0,
                    //                 "usdUnrealized":0.0,
                    //                 "usdRealized":0.0,
                    //                 "baseUsdMark":1.0,
                    //                 "settleCoinUsdMark":0.0,
                    //                 "settleCoinUnrealized":0.0,
                    //                 "settleCoinRealized":0.0
                    //             },
                    //         ]
                    //     }
                    return this.parseBalance(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const orderSide = side === 'buy' ? 1 : 2;
                    const quantityScale = this.getScale(amount);
                    const request = {
                        // 'id': 0,
                        // 'account': 0, // required for institutional users
                        'instrumentId': parseInt(market['id']),
                        'symbol': market['uppercaseId'],
                        // 'clOrdId': '',
                        'side': orderSide,
                        // 'ordType': 1, // 1 = market, 2 = limit, 3 = stop market, 4 = stop limit
                        // 'price': this.priceToPrecision (symbol, price), // required for limit and stop limit orders
                        // 'price_scale': this.getScale (price),
                        'quantity': this.convertToScale(this.numberToString(amount), quantityScale),
                        'quantity_scale': quantityScale
                    };
                    if (type === 'market') request['ordType'] = 1;
                    else if (type === 'limit') {
                        request['ordType'] = 2;
                        const priceScale = this.getScale(price);
                        request['price'] = this.convertToScale(this.numberToString(price), priceScale);
                        request['priceScale'] = priceScale;
                    } else {
                        const stopPrice = this.safeNumber2(params, 'stopPrice', 'stopPx');
                        params = this.omit(params, [
                            'stopPrice',
                            'stopPx'
                        ]);
                        if (stopPrice === undefined) {
                            if (type === 'stop') {
                                if (price === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a price argument or a stopPrice parameter or a stopPx parameter for ' + type + ' orders');
                                request['ordType'] = 3;
                                request['stopPx'] = this.convertToScale(this.numberToString(price), this.getScale(price));
                            } else if (type === 'stop limit') throw new ArgumentsRequired1(this.id + ' createOrder() requires a stopPrice parameter or a stopPx parameter for ' + type + ' orders');
                        } else {
                            if (type === 'stop') {
                                request['ordType'] = 3;
                                request['stopPx'] = this.convertToScale(this.numberToString(stopPrice), this.getScale(stopPrice));
                            } else if (type === 'stop limit') {
                                request['ordType'] = 4;
                                const priceScale = this.getScale(price);
                                const stopPriceScale = this.getScale(stopPrice);
                                request['price_scale'] = priceScale;
                                request['stopPx_scale'] = stopPriceScale;
                                request['stopPx'] = this.convertToScale(this.numberToString(stopPrice), stopPriceScale);
                                request['price'] = this.convertToScale(this.numberToString(price), priceScale);
                            }
                        }
                    }
                    const response = await this.privatePostOrder(this.extend(request, params));
                    //
                    //     {
                    //         "status":"sent",
                    //         "id":385617863,
                    //         "instrumentId":53,
                    //         "clOrdId":"1613037510849637345",
                    //         "userId":3583,
                    //         "price":2000,
                    //         "quantity":200,
                    //         "ordType":2
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'origOrderId': parseInt(id),
                        'instrumentId': parseInt(market['id'])
                    };
                    const response = await this.privatePostCancelOrder(this.extend(request, params));
                    //
                    //     {
                    //         "status":"sent",
                    //         "id":0,
                    //         "origOrderId":385613629,
                    //         "instrumentId":53,
                    //         "userId":3583,
                    //         "price":0,
                    //         "quantity":0,
                    //         "ordType":0
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const orderSide = side === 'buy' ? 1 : 2;
                    const quantityScale = this.getScale(amount);
                    const request = {
                        // 'id': 0,
                        'origOrderId': id,
                        // 'account': 0, // required for institutional users
                        'instrumentId': parseInt(market['id']),
                        'symbol': market['uppercaseId'],
                        // 'clOrdId': '',
                        'side': orderSide,
                        // 'ordType': 1, // 1 = market, 2 = limit, 3 = stop market, 4 = stop limit
                        // 'price': this.priceToPrecision (symbol, price), // required for limit and stop limit orders
                        // 'price_scale': this.getScale (price),
                        'quantity': this.convertToScale(this.numberToString(amount), quantityScale),
                        'quantity_scale': quantityScale
                    };
                    if (type === 'market') request['ordType'] = 1;
                    else if (type === 'limit') {
                        request['ordType'] = 2;
                        request['price'] = this.convertToScale(this.numberToString(price), this.getScale(price));
                    } else {
                        const stopPrice = this.safeNumber2(params, 'stopPrice', 'stopPx');
                        params = this.omit(params, [
                            'stopPrice',
                            'stopPx'
                        ]);
                        if (stopPrice === undefined) {
                            if (type === 'stop') {
                                if (price === undefined) throw new ArgumentsRequired1(this.id + ' editOrder() requires a price argument or a stopPrice parameter or a stopPx parameter for ' + type + ' orders');
                                request['ordType'] = 3;
                                request['stopPx'] = this.convertToScale(this.numberToString(price), this.getScale(price));
                            } else if (type === 'stop limit') throw new ArgumentsRequired1(this.id + ' editOrder() requires a stopPrice parameter or a stopPx parameter for ' + type + ' orders');
                        } else {
                            if (type === 'stop') {
                                request['ordType'] = 3;
                                request['stopPx'] = this.convertToScale(this.numberToString(stopPrice), this.getScale(stopPrice));
                            } else if (type === 'stop limit') {
                                request['ordType'] = 4;
                                const priceScale = this.getScale(price);
                                const stopPriceScale = this.getScale(stopPrice);
                                request['price_scale'] = priceScale;
                                request['stopPx_scale'] = stopPriceScale;
                                request['stopPx'] = this.convertToScale(this.numberToString(stopPrice), stopPriceScale);
                                request['price'] = this.convertToScale(this.numberToString(price), priceScale);
                            }
                        }
                    }
                    const response = await this.privatePostOrder(this.extend(request, params));
                    //
                    //     {
                    //         "status":"sent",
                    //         "id":385617863,
                    //         "instrumentId":53,
                    //         "clOrdId":"1613037510849637345",
                    //         "userId":3583,
                    //         "price":2000,
                    //         "quantity":200,
                    //         "ordType":2
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderId': parseInt(id)
                    };
                    const response = await this.privatePostGetOrderStatus(this.extend(request, params));
                    //
                    //     {
                    //         "orderId":388953019,
                    //         "clOrdId":"1613106766970339107",
                    //         "symbol":"ETH/USDC",
                    //         "instrumentId":53,
                    //         "side":"1",
                    //         "userId":3583,
                    //         "account":3583,
                    //         "execType":"F",
                    //         "ordType":"2",
                    //         "ordStatus":"2",
                    //         "timeInForce":"3",
                    //         "timeStamp":"20210212-05:12:46.971",
                    //         "execId":265757,
                    //         "targetStrategy":0,
                    //         "isHidden":false,
                    //         "isReduceOnly":false,
                    //         "isLiquidation":false,
                    //         "fee":0,
                    //         "fee_scale":6,
                    //         "feeInstrumentId":1,
                    //         "price":184204,
                    //         "price_scale":2,
                    //         "quantity":10000,
                    //         "quantity_scale":6,
                    //         "leavesQty":0,
                    //         "leavesQty_scale":6,
                    //         "cumQty":10000,
                    //         "cumQty_scale":6,
                    //         "lastPx":175622,
                    //         "lastPx_scale":2,
                    //         "avgPx":175622,
                    //         "avgPx_scale":2,
                    //         "lastQty":10000,
                    //         "lastQty_scale":6
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'ordStatus': '2'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchCanceledOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'ordStatus': '4'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instrumentId'] = parseInt(market['id']);
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privatePostGetOrders(this.extend(request, params));
                    //
                    //     {
                    //         "isInitialSnap":false,
                    //         "orders":[
                    //             {
                    //                 "orderId":385613629,
                    //                 "orderUpdateSeq":1,
                    //                 "clOrdId":"1613037448945798198",
                    //                 "symbol":"ETH/USDC",
                    //                 "instrumentId":53,
                    //                 "side":"1",
                    //                 "userId":3583,
                    //                 "account":3583,
                    //                 "execType":"4",
                    //                 "ordType":"2",
                    //                 "ordStatus":"C",
                    //                 "timeInForce":"3",
                    //                 "timeStamp":"20210211-09:57:28.944",
                    //                 "execId":0,
                    //                 "targetStrategy":0,
                    //                 "isHidden":false,
                    //                 "isReduceOnly":false,
                    //                 "isLiquidation":false,
                    //                 "fee":0,
                    //                 "feeTotal":0,
                    //                 "fee_scale":0,
                    //                 "feeInstrumentId":0,
                    //                 "price":999,
                    //                 "price_scale":2,
                    //                 "quantity":10000000,
                    //                 "quantity_scale":6,
                    //                 "leavesQty":10000000,
                    //                 "leavesQty_scale":6,
                    //                 "cumQty":0,
                    //                 "cumQty_scale":0,
                    //                 "lastPx":0,
                    //                 "lastPx_scale":2,
                    //                 "avgPx":0,
                    //                 "avgPx_scale":0,
                    //                 "lastQty":0,
                    //                 "lastQty_scale":6
                    //             }
                    //         ]
                    //     }
                    //
                    const orders = this.safeValue(response, 'orders', []);
                    return this.parseOrders(orders, market, since, limit, params);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instrumentId'] = market['id'];
                    }
                    if (since !== undefined) request['startTime'] = since;
                    const response = await this.privatePostUserTrades(this.extend(request, params));
                    //
                    //     {
                    //         "trades":[
                    //             {
                    //                 "account":3583,
                    //                 "commission":"-0.015805",
                    //                 "commCurrency":"USDC",
                    //                 "execId":265757,
                    //                 "ordType":"2",
                    //                 "ordStatus":"2",
                    //                 "execType":"F",
                    //                 "aggressorIndicator":true,
                    //                 "orderId":388953019,
                    //                 "price":"1842.04",
                    //                 "qty":"0.010000",
                    //                 "lastPx":"1756.22",
                    //                 "avgPx":"1756.22",
                    //                 "cumQty":"0.010000",
                    //                 "quoteQty":"0.010000",
                    //                 "side":"BUY",
                    //                 "symbol":"ETH/USDC",
                    //                 "clOrdId":"1613106766970339107",
                    //                 "submitterId":3583,
                    //                 "targetStrategy":"0",
                    //                 "time":1613106766971,
                    //                 "date":"20210212-05:12:46.971"
                    //             }
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, 'trades', []);
                    return this.parseTrades(trades, market, since, limit, params);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'instrumentId': parseInt(currency['id'])
                    };
                    const response = await this.privatePostGetDepositAddresses(this.extend(request, params));
                    //
                    //     {
                    //         "addresses":[
                    //             {"instrumentId":1,"userId":3583,"symbol":"USDC","address":"0xdff47af071ea3c537e57278290516cda32a78b97","status":1}
                    //         ]
                    //     }
                    //
                    const addresses = this.safeValue(response, 'addresses', []);
                    const address = this.safeValue(addresses, 0);
                    return this.parseDepositAddress(address, currency);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         "instrumentId":1,
                    //         "userId":3583,
                    //         "symbol":"USDC",
                    //         "address":"0xdff47af071ea3c537e57278290516cda32a78b97",
                    //         "status":1
                    //     }
                    //
                    const currencyId = this.safeString(depositAddress, 'symbol');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const address = this.safeString(depositAddress, 'address');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': undefined,
                        'network': undefined,
                        'info': depositAddress
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['instrumentId'] = parseInt(currency['id']);
                    }
                    const response = await this.privatePostGetDepositHistory(this.extend(request, params));
                    //
                    //     {
                    //         "deposits":[
                    //             {
                    //                 "id":4309,
                    //                 "instrumentId":1,
                    //                 "userId":3583,
                    //                 "symbol":"USDC",
                    //                 "address":"null",
                    //                 "timestamp":"1613021112189",
                    //                 "status":1,
                    //                 "balance":0.0,
                    //                 "balance_change":100.0,
                    //                 "confirms":1,
                    //                 "transactionId":"caba4500-489f-424e-abd7-b4dabc09a800"
                    //             }
                    //         ]
                    //     }
                    //
                    const deposits = this.safeValue(response, 'deposits', []);
                    return this.parseTransactions(deposits, currency, since, limit, {
                        'type': 'deposit'
                    });
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['instrumentId'] = parseInt(currency['id']);
                    }
                    const response = await this.privatePostGetWithdrawRequests(this.extend(request, params));
                    //
                    //     {
                    //         "addresses":[
                    //             {
                    //                 "id":3841,
                    //                 "instrumentId":3,
                    //                 "userId":4245,
                    //                 "symbol":"BTC",
                    //                 "address":"XXXXXYYYYYZZZZZ",
                    //                 "timestamp":"20200806-11:04:35.053",
                    //                 "status":0,
                    //                 "balance":1,
                    //                 "balance_scale":3,
                    //                 "confirms":0,
                    //                 "transactionId":"null"
                    //             }
                    //         ]
                    //     }
                    //
                    const withdrawals = this.safeValue(response, 'addresses', []);
                    return this.parseTransactions(withdrawals, currency, since, limit, {
                        'type': 'withdrawal'
                    });
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits, fetchWithdrawals
                    //
                    //     {
                    //         "id":4309,
                    //         "instrumentId":1,
                    //         "userId":3583,
                    //         "symbol":"USDC",
                    //         "address":"null",
                    //         "timestamp":"1613021112189",
                    //         "status":1,
                    //         "balance":0.0,
                    //         "balance_change":100.0,
                    //         "confirms":1,
                    //         "transactionId":"caba4500-489f-424e-abd7-b4dabc09a800"
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "instrumentId": 1,
                    //         "userId": 23750,
                    //         "symbol": "USDC",
                    //         "timestamp": "20200201-05:37:16.584",
                    //         "status": 1,
                    //         "userUuid": "b9e33713-c28f-468f-99bd-f6deab0dd854",
                    //         "currencyCode": "USDC",
                    //         "address": "2MvW97yT6E2Kq8bWc1aj1DqfbgMzjRNk2LE",
                    //         "quantity": 20,
                    //         "requestUuid": "56782b34-8a78-4f5f-b164-4b8f7d583b7f",
                    //         "transactionUuid": "1004eb0f-41e1-41e9-9d48-8eefcc6c09f2",
                    //         "transactionId": "WS23436",
                    //         "destinationWalletAlias": "Test",
                    //         "quantity_scale": 0
                    //     }
                    //
                    const id = this.safeString(transaction, 'id', 'transactionId');
                    const txid = this.safeString(transaction, 'transactionUuid');
                    const timestamp = this.safeInteger(transaction, 'timestamp');
                    let address = this.safeString(transaction, 'address');
                    if (address === 'null') address = undefined;
                    const type = this.safeString(transaction, 'type');
                    let amount = this.safeNumber(transaction, 'balance_change');
                    if (amount === undefined) {
                        amount = this.safeString(transaction, 'quantity');
                        const amountScale = this.safeInteger(transaction, 'quantity_scale');
                        amount = this.parseNumber(this.convertFromScale(amount, amountScale));
                    }
                    const currencyId = this.safeString(transaction, 'symbol');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'comment': undefined,
                        'fee': undefined
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        '0': 'pending',
                        '1': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const scale = this.getScale(amount);
                    const quantity = this.convertToScale(amount, scale);
                    const request = {
                        'instrumentId': parseInt(currency['id']),
                        'symbol': currency['uppercaseId'],
                        'quantity': quantity,
                        'quantity_scale': scale,
                        'address': address
                    };
                    const response = await this.privatePostSendWithdrawRequest(this.extend(request, params));
                    //
                    //     {
                    //         "instrumentId": 1,
                    //         "userId": 23750,
                    //         "symbol": "USDC",
                    //         "timestamp": "20200201-05:37:16.584",
                    //         "status": 1,
                    //         "userUuid": "b9e33713-c28f-468f-99bd-f6deab0dd854",
                    //         "currencyCode": "USDC",
                    //         "address": "2MvW97yT6E2Kq8bWc1aj1DqfbgMzjRNk2LE",
                    //         "quantity": 20,
                    //         "requestUuid": "56782b34-8a78-4f5f-b164-4b8f7d583b7f",
                    //         "transactionUuid": "1004eb0f-41e1-41e9-9d48-8eefcc6c09f2",
                    //         "transactionId": "WS23436",
                    //         "destinationWalletAlias": "Test",
                    //         "quantity_scale": 0
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetGetExchangeInfo(params);
                    //
                    //     {
                    //         tradingLimits: [],
                    //         withdrawLimits: [{ All: '0.0', Type: 'percent' }],
                    //         futuresFees: [
                    //             { tier: '0', maker: '0.000300', taker: '0.000500' },
                    //             { tier: '1', maker: '0.000200', taker: '0.000400' },
                    //             { tier: '2', maker: '0.000180', taker: '0.000400' },
                    //         ],
                    //         spotFees: [
                    //             { tier: '0', maker: '0.000900', taker: '0.001500', volume: '0' },
                    //             { tier: '1', maker: '0.000600', taker: '0.001250', volume: '200000' },
                    //             { tier: '2', maker: '0.000540', taker: '0.001200', volume: '2500000' },
                    //         ],
                    //         referrals: { earning: '0.30', discount: '0.05', duration: '180' }
                    //     }
                    //
                    const spotFees = this.safeValue(response, 'spotFees', []);
                    const firstSpotFee = this.safeValue(spotFees, 0, {});
                    const spotMakerFee = this.safeNumber(firstSpotFee, 'maker');
                    const spotTakerFee = this.safeNumber(firstSpotFee, 'taker');
                    const futureFees = this.safeValue(response, 'futuresFees', []);
                    const firstFutureFee = this.safeValue(futureFees, 0, {});
                    const futureMakerFee = this.safeNumber(firstFutureFee, 'maker');
                    const futureTakerFee = this.safeNumber(firstFutureFee, 'taker');
                    const spotTakerTiers = [];
                    const spotMakerTiers = [];
                    const result = {};
                    for(let i = 0; i < spotFees.length; i++){
                        const spotFee = spotFees[i];
                        const volume = this.safeNumber(spotFee, 'volume');
                        spotTakerTiers.push([
                            volume,
                            this.safeNumber(spotFee, 'taker')
                        ]);
                        spotMakerTiers.push([
                            volume,
                            this.safeNumber(spotFee, 'maker')
                        ]);
                    }
                    const spotTiers = {
                        'taker': spotTakerTiers,
                        'maker': spotMakerTiers
                    };
                    const futureTakerTiers = [];
                    const futureMakerTiers = [];
                    for(let i = 0; i < futureFees.length; i++){
                        const futureFee = futureFees[i];
                        futureTakerTiers.push([
                            undefined,
                            this.safeNumber(futureFee, 'taker')
                        ]);
                        futureMakerTiers.push([
                            undefined,
                            this.safeNumber(futureFee, 'maker')
                        ]);
                    }
                    const futureTiers = {
                        'taker': futureTakerTiers,
                        'maker': futureMakerTiers
                    };
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        const fee = {
                            'info': response,
                            'symbol': symbol,
                            'percentage': true,
                            'tierBased': true
                        };
                        if (this.safeValue(market, 'spot')) {
                            fee['maker'] = spotMakerFee;
                            fee['taker'] = spotTakerFee;
                            fee['tiers'] = spotTiers;
                        } else if (this.safeValue(market, 'contract')) {
                            fee['maker'] = futureMakerFee;
                            fee['taker'] = futureTakerFee;
                            fee['tiers'] = futureTiers;
                        }
                        result[symbol] = fee;
                    }
                    return result;
                }
                async fetchTradingLimits(symbols, params = {}) {
                    await this.loadMarkets();
                    // getExchangeInfo
                    const response = await this.publicGetGetExchangeInfo(params);
                    const tradingLimits = this.safeValue(response, 'tradingLimits', []);
                    // To-do parsing response when available
                    return {
                        'info': tradingLimits,
                        'limits': {
                            'amount': {
                                'min': undefined,
                                'max': undefined
                            },
                            'price': {
                                'min': undefined,
                                'max': undefined
                            },
                            'cost': {
                                'min': undefined,
                                'max': undefined
                            }
                        }
                    };
                }
                async fetchFundingLimits(params = {}) {
                    // getExchangeInfo
                    const response = await this.publicGetGetExchangeInfo(params);
                    const withdrawLimits = this.safeValue(response, 'withdrawLimits', []);
                    // TO-DO parse response when available
                    return {
                        'info': withdrawLimits,
                        'withdraw': undefined
                    };
                }
                parseOrder(order, market) {
                    //
                    // createOrder, editOrder, cancelOrder
                    //
                    //     {
                    //         "status":"sent",
                    //         "id":385617863,
                    //         "instrumentId":53,
                    //         "clOrdId":"1613037510849637345",
                    //         "userId":3583,
                    //         "price":2000,
                    //         "quantity":200,
                    //         "ordType":2
                    //     }
                    //
                    // fetchOrders, fetchOrder
                    //
                    //     {
                    //         "orderId":385613629,
                    //         "orderUpdateSeq":1,
                    //         "clOrdId":"1613037448945798198",
                    //         "symbol":"ETH/USDC",
                    //         "instrumentId":53,
                    //         "side":"1",
                    //         "userId":3583,
                    //         "account":3583,
                    //         "execType":"4",
                    //         "ordType":"2",
                    //         "ordStatus":"C",
                    //         "timeInForce":"3",
                    //         "timeStamp":"20210211-09:57:28.944",
                    //         "execId":0,
                    //         "targetStrategy":0,
                    //         "isHidden":false,
                    //         "isReduceOnly":false,
                    //         "isLiquidation":false,
                    //         "fee":0,
                    //         "feeTotal":0,
                    //         "fee_scale":0,
                    //         "feeInstrumentId":0,
                    //         "price":999,
                    //         "price_scale":2,
                    //         "quantity":10000000,
                    //         "quantity_scale":6,
                    //         "leavesQty":10000000,
                    //         "leavesQty_scale":6,
                    //         "cumQty":0,
                    //         "cumQty_scale":0,
                    //         "lastPx":0,
                    //         "lastPx_scale":2,
                    //         "avgPx":0,
                    //         "avgPx_scale":0,
                    //         "lastQty":0,
                    //         "lastQty_scale":6
                    //     }
                    //
                    let id = this.safeString2(order, 'orderId', 'id');
                    id = this.safeString(order, 'origOrderId', id);
                    const clientOrderId = this.safeString(order, 'clOrdId');
                    const type = this.parseOrderType(this.safeString(order, 'ordType'));
                    const side = this.parseOrderSide(this.safeString(order, 'side'));
                    const status = this.parseOrderStatus(this.safeString(order, 'ordStatus'));
                    const marketId = this.safeString(order, 'instrumentId');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.toMilliseconds(this.safeString(order, 'timeStamp'));
                    const lastTradeTimestamp = undefined;
                    let priceString = this.safeString(order, 'price');
                    const priceScale = this.safeInteger(order, 'price_scale');
                    priceString = this.convertFromScale(priceString, priceScale);
                    let amountString = this.safeString(order, 'quantity');
                    const amountScale = this.safeInteger(order, 'quantity_scale');
                    amountString = this.convertFromScale(amountString, amountScale);
                    let filledString = this.safeString(order, 'cumQty');
                    const filledScale = this.safeInteger(order, 'cumQty_scale');
                    filledString = this.convertFromScale(filledString, filledScale);
                    let remainingString = this.safeString(order, 'leavesQty');
                    const remainingScale = this.safeInteger(order, 'leavesQty_scale');
                    remainingString = this.convertFromScale(remainingString, remainingScale);
                    let fee = undefined;
                    const currencyId = this.safeInteger(order, 'feeInstrumentId');
                    const feeCurrencyCode = this.safeCurrencyCode(currencyId);
                    let feeCostString = undefined;
                    let feeCost = this.safeString(order, 'feeTotal');
                    const feeScale = this.safeInteger(order, 'fee_scale');
                    if (feeCost !== undefined) {
                        feeCost = Precise.stringNeg(feeCost);
                        feeCostString = this.convertFromScale(feeCost, feeScale);
                    }
                    if (feeCost !== undefined) fee = {
                        'currency': feeCurrencyCode,
                        'cost': feeCostString,
                        'rate': undefined
                    };
                    let timeInForce = this.parseTimeInForce(this.safeString(order, 'timeInForce'));
                    if (timeInForce === '0') timeInForce = undefined;
                    const stopPriceScale = this.safeInteger(order, 'stopPx_scale', 0);
                    const stopPrice = this.parseNumber(this.convertFromScale(this.safeString(order, 'stopPx'), stopPriceScale));
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': undefined,
                        'side': side,
                        'price': priceString,
                        'stopPrice': stopPrice,
                        'amount': amountString,
                        'cost': undefined,
                        'average': undefined,
                        'filled': filledString,
                        'remaining': remainingString,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '0': 'open',
                        '1': 'open',
                        '2': 'closed',
                        '3': 'open',
                        '4': 'canceled',
                        '5': 'canceled',
                        '6': 'canceling',
                        '7': 'canceled',
                        '8': 'rejected',
                        '9': 'canceled',
                        'A': 'open',
                        'B': 'open',
                        'C': 'expired',
                        'D': 'open',
                        'E': 'canceling',
                        'F': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrderSide(side) {
                    const sides = {
                        '1': 'buy',
                        '2': 'sell'
                    };
                    return this.safeString(sides, side, side);
                }
                parseOrderType(type) {
                    const types = {
                        '1': 'market',
                        '2': 'limit',
                        '3': 'stop',
                        '4': 'stop limit'
                    };
                    return this.safeString(types, type, type);
                }
                parseTimeInForce(timeInForce) {
                    const timeInForces = {
                        '1': 'GTC',
                        '3': 'IOC',
                        '4': 'FOK',
                        '5': 'GTX',
                        '6': 'GTD'
                    };
                    return this.safeString(timeInForces, timeInForce, timeInForce);
                }
                toMilliseconds(dateString) {
                    if (dateString === undefined) return dateString;
                    // '20200328-10:31:01.575' -> '2020-03-28 12:42:48.000'
                    const splits = dateString.split('-');
                    const partOne = this.safeString(splits, 0);
                    const partTwo = this.safeString(splits, 1);
                    if (partOne === undefined || partTwo === undefined) return undefined;
                    if (partOne.length !== 8) return undefined;
                    const date = partOne.slice(0, 4) + '-' + partOne.slice(4, 6) + '-' + partOne.slice(6, 8);
                    return this.parse8601(date + ' ' + partTwo);
                }
                convertFromScale(number, scale) {
                    if (number === undefined || scale === undefined) return undefined;
                    const precise = new Precise(number);
                    precise.decimals = precise.decimals + scale;
                    precise.reduce();
                    return precise.toString();
                }
                getScale(num) {
                    const s = this.numberToString(num);
                    return this.precisionFromString(s);
                }
                convertToScale(number, scale) {
                    if (number === undefined || scale === undefined) return undefined;
                    const precise = new Precise(number);
                    precise.decimals = precise.decimals - scale;
                    precise.reduce();
                    const preciseString = precise.toString();
                    return parseInt(preciseString);
                }
                nonce() {
                    return this.milliseconds();
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    const error = this.safeString(response, 'error');
                    if (error !== undefined) {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions, error, feedback);
                        this.throwBroadlyMatchedException(this.exceptions, body, feedback);
                        throw new ExchangeError1(this.id + ' ' + body);
                    }
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.implodeParams(path, params);
                    let query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'private') {
                        // special case for getUserHistory
                        const format = this.safeValue(params, 'format');
                        const type = this.safeValue(params, 'type');
                        const extension = {};
                        if (format !== undefined) extension['format'] = format;
                        if (type !== undefined) extension['type'] = type;
                        if (Object.keys(extension).length) url += '?' + this.urlencode(extension);
                        params = this.omit(params, [
                            'format',
                            'type'
                        ]);
                        this.checkRequiredCredentials();
                        const nonce = this.nonce();
                        query = this.extend(query, {
                            'userId': this.uid,
                            'nonce': nonce
                        });
                        params['nonce'] = this.nonce();
                        body = this.json(query);
                        const signature = this.hmac(this.encode(body), this.encode(this.secret), 'sha384');
                        headers = {
                            'Content-Type': 'application/json',
                            'requestToken': this.apiKey,
                            'signature': signature
                        };
                    }
                    url = this.urls['api'][api] + '/' + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    78: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ArgumentsRequired: ArgumentsRequired1, ExchangeError: ExchangeError1, OrderNotFound: OrderNotFound, AuthenticationError: AuthenticationError, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, InvalidNonce: InvalidNonce, OnMaintenance: OnMaintenance, RateLimitExceeded: RateLimitExceeded, BadRequest: BadRequest, PermissionDenied: PermissionDenied } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class exmo extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'exmo',
                        'name': 'EXMO',
                        'countries': [
                            'LT'
                        ],
                        'rateLimit': 350,
                        'version': 'v1.1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchFundingFees': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': 'emulated',
                            'fetchOrderBook': true,
                            'fetchOrderBooks': true,
                            'fetchOrderTrades': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawals': true,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1',
                            '5m': '5',
                            '15m': '15',
                            '30m': '30',
                            '45m': '45',
                            '1h': '60',
                            '2h': '120',
                            '3h': '180',
                            '4h': '240',
                            '1d': 'D',
                            '1w': 'W',
                            '1M': 'M'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766491-1b0ea956-5eda-11e7-9225-40d67b481b8d.jpg',
                            'api': {
                                'public': 'https://api.exmo.com',
                                'private': 'https://api.exmo.com',
                                'web': 'https://exmo.me'
                            },
                            'www': 'https://exmo.me',
                            'referral': 'https://exmo.me/?ref=131685',
                            'doc': [
                                'https://exmo.me/en/api_doc?ref=131685'
                            ],
                            'fees': 'https://exmo.com/en/docs/fees'
                        },
                        'api': {
                            'web': {
                                'get': [
                                    'ctrl/feesAndLimits',
                                    'en/docs/fees'
                                ]
                            },
                            'public': {
                                'get': [
                                    'currency',
                                    'currency/list/extended',
                                    'order_book',
                                    'pair_settings',
                                    'ticker',
                                    'trades',
                                    'candles_history',
                                    'required_amount',
                                    'payments/providers/crypto/list'
                                ]
                            },
                            'private': {
                                'post': [
                                    'user_info',
                                    'order_create',
                                    'order_cancel',
                                    'stop_market_order_create',
                                    'stop_market_order_cancel',
                                    'user_open_orders',
                                    'user_trades',
                                    'user_cancelled_orders',
                                    'order_trades',
                                    'deposit_address',
                                    'withdraw_crypt',
                                    'withdraw_get_txid',
                                    'excode_create',
                                    'excode_load',
                                    'code_check',
                                    'wallet_history',
                                    'wallet_operations',
                                    'margin/user/order/create',
                                    'margin/user/order/update',
                                    'margin/user/order/cancel',
                                    'margin/user/position/close',
                                    'margin/user/position/margin_add',
                                    'margin/user/position/margin_remove',
                                    'margin/currency/list',
                                    'margin/pair/list',
                                    'margin/settings',
                                    'margin/funding/list',
                                    'margin/user/info',
                                    'margin/user/order/list',
                                    'margin/user/order/history',
                                    'margin/user/order/trades',
                                    'margin/user/order/max_quantity',
                                    'margin/user/position/list',
                                    'margin/user/position/margin_remove_info',
                                    'margin/user/position/margin_add_info',
                                    'margin/user/wallet/list',
                                    'margin/user/wallet/history',
                                    'margin/user/trade/list',
                                    'margin/trades',
                                    'margin/liquidation/feed'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': true,
                                'percentage': true,
                                'maker': this.parseNumber('0.004'),
                                'taker': this.parseNumber('0.004')
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false
                            }
                        },
                        'options': {
                            'networks': {
                                'ETH': 'ERC20',
                                'TRX': 'TRC20'
                            },
                            'fetchTradingFees': {
                                'method': 'fetchPrivateTradingFees'
                            }
                        },
                        'commonCurrencies': {
                            'GMT': 'GMT Token'
                        },
                        'exceptions': {
                            'exact': {
                                '40005': AuthenticationError,
                                '40009': InvalidNonce,
                                '40015': ExchangeError1,
                                '40016': OnMaintenance,
                                '40017': AuthenticationError,
                                '40032': PermissionDenied,
                                '40033': PermissionDenied,
                                '40034': RateLimitExceeded,
                                '50052': InsufficientFunds,
                                '50054': InsufficientFunds,
                                '50304': OrderNotFound,
                                '50173': OrderNotFound,
                                '50277': InvalidOrder,
                                '50319': InvalidOrder,
                                '50321': InvalidOrder,
                                '50381': InvalidOrder
                            },
                            'broad': {
                                'range period is too long': BadRequest,
                                'invalid syntax': BadRequest,
                                'API rate limit exceeded': RateLimitExceeded
                            }
                        }
                    });
                }
                async fetchTradingFees(params = {}) {
                    let method = this.safeString(params, 'method');
                    params = this.omit(params, 'method');
                    if (method === undefined) {
                        const options = this.safeValue(this.options, 'fetchTradingFees', {});
                        method = this.safeString(options, 'method', 'fetchPrivateTradingFees');
                    }
                    return await this[method](params);
                }
                async fetchPrivateTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostMarginPairList(params);
                    //
                    //     {
                    //         pairs: [{
                    //             name: 'EXM_USD',
                    //             buy_price: '0.02728391',
                    //             sell_price: '0.0276',
                    //             last_trade_price: '0.0276',
                    //             ticker_updated: '1646956050056696046',
                    //             is_fair_price: true,
                    //             max_price_precision: '8',
                    //             min_order_quantity: '1',
                    //             max_order_quantity: '50000',
                    //             min_order_price: '0.00000001',
                    //             max_order_price: '1000',
                    //             max_position_quantity: '50000',
                    //             trade_taker_fee: '0.05',
                    //             trade_maker_fee: '0',
                    //             liquidation_fee: '0.5',
                    //             max_leverage: '3',
                    //             default_leverage: '3',
                    //             liquidation_level: '5',
                    //             margin_call_level: '7.5',
                    //             position: '1',
                    //             updated: '1638976144797807397'
                    //         }
                    //         ...
                    //         ]
                    //     }
                    //
                    const pairs = this.safeValue(response, 'pairs', []);
                    const result = {};
                    for(let i = 0; i < pairs.length; i++){
                        const pair = pairs[i];
                        const marketId = this.safeString(pair, 'name');
                        const symbol = this.safeSymbol(marketId, undefined, '_');
                        const makerString = this.safeString(pair, 'trade_maker_fee');
                        const takerString = this.safeString(pair, 'trade_taker_fee');
                        const maker = this.parseNumber(Precise.stringDiv(makerString, '100'));
                        const taker = this.parseNumber(Precise.stringDiv(takerString, '100'));
                        result[symbol] = {
                            'info': pair,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                async fetchPublicTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetPairSettings(params);
                    //
                    //     {
                    //         BTC_USD: {
                    //             min_quantity: '0.00002',
                    //             max_quantity: '1000',
                    //             min_price: '1',
                    //             max_price: '150000',
                    //             max_amount: '500000',
                    //             min_amount: '1',
                    //             price_precision: '2',
                    //             commission_taker_percent: '0.3',
                    //             commission_maker_percent: '0.3'
                    //         },
                    //     }
                    //
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        const fee = this.safeValue(response, market['id'], {});
                        const makerString = this.safeString(fee, 'commission_maker_percent');
                        const takerString = this.safeString(fee, 'commission_taker_percent');
                        const maker = this.parseNumber(Precise.stringDiv(makerString, '100'));
                        const taker = this.parseNumber(Precise.stringDiv(takerString, '100'));
                        result[symbol] = {
                            'info': fee,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                parseFixedFloatValue(input) {
                    if (input === undefined || input === '-') return undefined;
                    if (input === '') return 0;
                    const isPercentage = input.indexOf('%') >= 0;
                    const parts = input.split(' ');
                    const value = parts[0].replace('%', '');
                    const result = parseFloat(value);
                    if (result > 0 && isPercentage) throw new ExchangeError1(this.id + ' parseFixedFloatValue() detected an unsupported non-zero percentage-based fee ' + input);
                    return result;
                }
                async fetchFundingFees(params = {}) {
                    await this.loadMarkets();
                    const currencyList = await this.publicGetCurrencyListExtended(params);
                    //
                    //     [
                    //         {"name":"VLX","description":"Velas"},
                    //         {"name":"RUB","description":"Russian Ruble"},
                    //         {"name":"BTC","description":"Bitcoin"},
                    //         {"name":"USD","description":"US Dollar"}
                    //     ]
                    //
                    const cryptoList = await this.publicGetPaymentsProvidersCryptoList(params);
                    //
                    //     {
                    //         "BTC":[
                    //             { "type":"deposit", "name":"BTC", "currency_name":"BTC", "min":"0.001", "max":"0", "enabled":true,"comment":"Minimum deposit amount is 0.001 BTC. We do not support BSC and BEP20 network, please consider this when sending funds", "commission_desc":"0%", "currency_confirmations":1 },
                    //             { "type":"withdraw", "name":"BTC", "currency_name":"BTC", "min":"0.001", "max":"350", "enabled":true,"comment":"Do not withdraw directly to the Crowdfunding or ICO address as your account will not be credited with tokens from such sales.", "commission_desc":"0.0005 BTC", "currency_confirmations":6 }
                    //         ],
                    //         "ETH":[
                    //             { "type":"withdraw", "name":"ETH", "currency_name":"ETH", "min":"0.01", "max":"500", "enabled":true,"comment":"Do not withdraw directly to the Crowdfunding or ICO address as your account will not be credited with tokens from such sales.", "commission_desc":"0.004 ETH", "currency_confirmations":4 },
                    //             { "type":"deposit", "name":"ETH", "currency_name":"ETH", "min":"0.01", "max":"0", "enabled":true,"comment":"Minimum deposit amount is 0.01 ETH. We do not support BSC and BEP20 network, please consider this when sending funds", "commission_desc":"0%", "currency_confirmations":1 }
                    //         ],
                    //         "USDT":[
                    //             { "type":"deposit", "name":"USDT (OMNI)", "currency_name":"USDT", "min":"10", "max":"0", "enabled":false,"comment":"Minimum deposit amount is 10 USDT", "commission_desc":"0%", "currency_confirmations":2 },
                    //             { "type":"withdraw", "name":"USDT (OMNI)", "currency_name":"USDT", "min":"10", "max":"100000", "enabled":false,"comment":"Do not withdraw directly to the Crowdfunding or ICO address as your account will not be credited with tokens from such sales.", "commission_desc":"5 USDT", "currency_confirmations":6 },
                    //             { "type":"deposit", "name":"USDT (ERC20)", "currency_name":"USDT", "min":"10", "max":"0", "enabled":true,"comment":"Minimum deposit amount is 10 USDT", "commission_desc":"0%", "currency_confirmations":2 },
                    //             {
                    //                 "type":"withdraw",
                    //                 "name":"USDT (ERC20)",
                    //                 "currency_name":"USDT",
                    //                 "min":"55",
                    //                 "max":"200000",
                    //                 "enabled":true,
                    //                 "comment":"Caution! Do not withdraw directly to a crowdfund or ICO address, as your account will not be credited with tokens from such sales. Recommendation: Due to the high load of ERC20 network, using TRC20 address for withdrawal is recommended.",
                    //                 "commission_desc":"10 USDT",
                    //                 "currency_confirmations":6
                    //             },
                    //             { "type":"deposit", "name":"USDT (TRC20)", "currency_name":"USDT", "min":"10", "max":"100000", "enabled":true,"comment":"Minimum deposit amount is 10 USDT. Only TRON main network supported", "commission_desc":"0%", "currency_confirmations":2 },
                    //             { "type":"withdraw", "name":"USDT (TRC20)", "currency_name":"USDT", "min":"10", "max":"150000", "enabled":true,"comment":"Caution! Do not withdraw directly to a crowdfund or ICO address, as your account will not be credited with tokens from such sales. Only TRON main network supported.", "commission_desc":"1 USDT", "currency_confirmations":6 }
                    //         ],
                    //         "XLM":[
                    //             { "type":"deposit", "name":"XLM", "currency_name":"XLM", "min":"1", "max":"1000000", "enabled":true,"comment":"Attention! A deposit without memo(invoice) will not be credited. Minimum deposit amount is 1 XLM. We do not support BSC and BEP20 network, please consider this when sending funds", "commission_desc":"0%", "currency_confirmations":1 },
                    //             { "type":"withdraw", "name":"XLM", "currency_name":"XLM", "min":"21", "max":"1000000", "enabled":true,"comment":"Caution! Do not withdraw directly to a crowdfund or ICO address, as your account will not be credited with tokens from such sales.", "commission_desc":"0.01 XLM", "currency_confirmations":1 }
                    //         ],
                    //     }
                    //
                    const result = {
                        'info': cryptoList,
                        'withdraw': {},
                        'deposit': {}
                    };
                    for(let i = 0; i < currencyList.length; i++){
                        const currency = currencyList[i];
                        const currencyId = this.safeString(currency, 'name');
                        const code = this.safeCurrencyCode(currencyId);
                        const providers = this.safeValue(cryptoList, currencyId, []);
                        for(let j = 0; j < providers.length; j++){
                            const provider = providers[j];
                            const type = this.safeString(provider, 'type');
                            const commissionDesc = this.safeString(provider, 'commission_desc');
                            const newFee = this.parseFixedFloatValue(commissionDesc);
                            const previousFee = this.safeNumber(result[type], code);
                            if (previousFee === undefined || newFee !== undefined && newFee < previousFee) result[type][code] = newFee;
                        }
                    }
                    // cache them for later use
                    this.options['fundingFees'] = result;
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    //
                    const currencyList = await this.publicGetCurrencyListExtended(params);
                    //
                    //     [
                    //         {"name":"VLX","description":"Velas"},
                    //         {"name":"RUB","description":"Russian Ruble"},
                    //         {"name":"BTC","description":"Bitcoin"},
                    //         {"name":"USD","description":"US Dollar"}
                    //     ]
                    //
                    const cryptoList = await this.publicGetPaymentsProvidersCryptoList(params);
                    //
                    //     {
                    //         "BTC":[
                    //             { "type":"deposit", "name":"BTC", "currency_name":"BTC", "min":"0.001", "max":"0", "enabled":true,"comment":"Minimum deposit amount is 0.001 BTC. We do not support BSC and BEP20 network, please consider this when sending funds", "commission_desc":"0%", "currency_confirmations":1 },
                    //             { "type":"withdraw", "name":"BTC", "currency_name":"BTC", "min":"0.001", "max":"350", "enabled":true,"comment":"Do not withdraw directly to the Crowdfunding or ICO address as your account will not be credited with tokens from such sales.", "commission_desc":"0.0005 BTC", "currency_confirmations":6 }
                    //         ],
                    //         "ETH":[
                    //             { "type":"withdraw", "name":"ETH", "currency_name":"ETH", "min":"0.01", "max":"500", "enabled":true,"comment":"Do not withdraw directly to the Crowdfunding or ICO address as your account will not be credited with tokens from such sales.", "commission_desc":"0.004 ETH", "currency_confirmations":4 },
                    //             { "type":"deposit", "name":"ETH", "currency_name":"ETH", "min":"0.01", "max":"0", "enabled":true,"comment":"Minimum deposit amount is 0.01 ETH. We do not support BSC and BEP20 network, please consider this when sending funds", "commission_desc":"0%", "currency_confirmations":1 }
                    //         ],
                    //         "USDT":[
                    //             { "type":"deposit", "name":"USDT (OMNI)", "currency_name":"USDT", "min":"10", "max":"0", "enabled":false,"comment":"Minimum deposit amount is 10 USDT", "commission_desc":"0%", "currency_confirmations":2 },
                    //             { "type":"withdraw", "name":"USDT (OMNI)", "currency_name":"USDT", "min":"10", "max":"100000", "enabled":false,"comment":"Do not withdraw directly to the Crowdfunding or ICO address as your account will not be credited with tokens from such sales.", "commission_desc":"5 USDT", "currency_confirmations":6 },
                    //             { "type":"deposit", "name":"USDT (ERC20)", "currency_name":"USDT", "min":"10", "max":"0", "enabled":true,"comment":"Minimum deposit amount is 10 USDT", "commission_desc":"0%", "currency_confirmations":2 },
                    //             {
                    //                 "type":"withdraw",
                    //                 "name":"USDT (ERC20)",
                    //                 "currency_name":"USDT",
                    //                 "min":"55",
                    //                 "max":"200000",
                    //                 "enabled":true,
                    //                 "comment":"Caution! Do not withdraw directly to a crowdfund or ICO address, as your account will not be credited with tokens from such sales. Recommendation: Due to the high load of ERC20 network, using TRC20 address for withdrawal is recommended.",
                    //                 "commission_desc":"10 USDT",
                    //                 "currency_confirmations":6
                    //             },
                    //             { "type":"deposit", "name":"USDT (TRC20)", "currency_name":"USDT", "min":"10", "max":"100000", "enabled":true,"comment":"Minimum deposit amount is 10 USDT. Only TRON main network supported", "commission_desc":"0%", "currency_confirmations":2 },
                    //             { "type":"withdraw", "name":"USDT (TRC20)", "currency_name":"USDT", "min":"10", "max":"150000", "enabled":true,"comment":"Caution! Do not withdraw directly to a crowdfund or ICO address, as your account will not be credited with tokens from such sales. Only TRON main network supported.", "commission_desc":"1 USDT", "currency_confirmations":6 }
                    //         ],
                    //         "XLM":[
                    //             { "type":"deposit", "name":"XLM", "currency_name":"XLM", "min":"1", "max":"1000000", "enabled":true,"comment":"Attention! A deposit without memo(invoice) will not be credited. Minimum deposit amount is 1 XLM. We do not support BSC and BEP20 network, please consider this when sending funds", "commission_desc":"0%", "currency_confirmations":1 },
                    //             { "type":"withdraw", "name":"XLM", "currency_name":"XLM", "min":"21", "max":"1000000", "enabled":true,"comment":"Caution! Do not withdraw directly to a crowdfund or ICO address, as your account will not be credited with tokens from such sales.", "commission_desc":"0.01 XLM", "currency_confirmations":1 }
                    //         ],
                    //     }
                    //
                    const result = {};
                    for(let i = 0; i < currencyList.length; i++){
                        const currency = currencyList[i];
                        const currencyId = this.safeString(currency, 'name');
                        const name = this.safeString(currency, 'description');
                        const providers = this.safeValue(cryptoList, currencyId);
                        let active = false;
                        let type = 'crypto';
                        const limits = {
                            'deposit': {
                                'min': undefined,
                                'max': undefined
                            },
                            'withdraw': {
                                'min': undefined,
                                'max': undefined
                            }
                        };
                        let fee = undefined;
                        let depositEnabled = undefined;
                        let withdrawEnabled = undefined;
                        if (providers === undefined) {
                            active = true;
                            type = 'fiat';
                        } else for(let j = 0; j < providers.length; j++){
                            const provider = providers[j];
                            const type = this.safeString(provider, 'type');
                            const minValue = this.safeNumber(provider, 'min');
                            let maxValue = this.safeNumber(provider, 'max');
                            if (maxValue === 0.0) maxValue = undefined;
                            const activeProvider = this.safeValue(provider, 'enabled');
                            if (type === 'deposit') {
                                if (activeProvider && !depositEnabled) depositEnabled = true;
                                else if (!activeProvider) depositEnabled = false;
                            } else if (type === 'withdraw') {
                                if (activeProvider && !withdrawEnabled) withdrawEnabled = true;
                                else if (!activeProvider) withdrawEnabled = false;
                            }
                            if (activeProvider) {
                                active = true;
                                if (limits[type]['min'] === undefined || minValue < limits[type]['min']) {
                                    limits[type]['min'] = minValue;
                                    limits[type]['max'] = maxValue;
                                    if (type === 'withdraw') {
                                        const commissionDesc = this.safeString(provider, 'commission_desc');
                                        fee = this.parseFixedFloatValue(commissionDesc);
                                    }
                                }
                            }
                        }
                        const code = this.safeCurrencyCode(currencyId);
                        result[code] = {
                            'id': currencyId,
                            'code': code,
                            'name': name,
                            'type': type,
                            'active': active,
                            'deposit': depositEnabled,
                            'withdraw': withdrawEnabled,
                            'fee': fee,
                            'precision': 8,
                            'limits': limits,
                            'info': providers
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetPairSettings(params);
                    //
                    //     {
                    //         "BTC_USD":{
                    //             "min_quantity":"0.0001",
                    //             "max_quantity":"1000",
                    //             "min_price":"1",
                    //             "max_price":"30000",
                    //             "max_amount":"500000",
                    //             "min_amount":"1",
                    //             "price_precision":8,
                    //             "commission_taker_percent":"0.4",
                    //             "commission_maker_percent":"0.4"
                    //         },
                    //     }
                    //
                    const keys = Object.keys(response);
                    const result = [];
                    for(let i = 0; i < keys.length; i++){
                        const id = keys[i];
                        const market = response[id];
                        const symbol = id.replace('_', '/');
                        const [baseId, quoteId] = symbol.split('/');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const takerString = this.safeString(market, 'commission_taker_percent');
                        const makerString = this.safeString(market, 'commission_maker_percent');
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.parseNumber(Precise.stringDiv(takerString, '100')),
                            'maker': this.parseNumber(Precise.stringDiv(makerString, '100')),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': parseInt('8'),
                                'price': this.safeInteger(market, 'price_precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min_quantity'),
                                    'max': this.safeNumber(market, 'max_quantity')
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'min_price'),
                                    'max': this.safeNumber(market, 'max_price')
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_amount'),
                                    'max': this.safeNumber(market, 'max_amount')
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'resolution': this.timeframes[timeframe]
                    };
                    const options = this.safeValue(this.options, 'fetchOHLCV');
                    const maxLimit = this.safeInteger(options, 'maxLimit', 3000);
                    const duration = this.parseTimeframe(timeframe);
                    const now = this.milliseconds();
                    if (since === undefined) {
                        if (limit === undefined) throw new ArgumentsRequired1(this.id + ' fetchOHLCV() requires a since argument or a limit argument');
                        else {
                            if (limit > maxLimit) throw new BadRequest(this.id + ' fetchOHLCV() will serve ' + maxLimit.toString() + ' candles at most');
                            request['from'] = parseInt(now / 1000) - limit * duration - 1;
                            request['to'] = parseInt(now / 1000);
                        }
                    } else {
                        request['from'] = parseInt(since / 1000) - 1;
                        if (limit === undefined) request['to'] = parseInt(now / 1000);
                        else {
                            if (limit > maxLimit) throw new BadRequest(this.id + ' fetchOHLCV() will serve ' + maxLimit.toString() + ' candles at most');
                            const to = this.sum(since, limit * duration * 1000);
                            request['to'] = parseInt(to / 1000);
                        }
                    }
                    const response = await this.publicGetCandlesHistory(this.extend(request, params));
                    //
                    //     {
                    //         "candles":[
                    //             {"t":1584057600000,"o":0.02235144,"c":0.02400233,"h":0.025171,"l":0.02221,"v":5988.34031761},
                    //             {"t":1584144000000,"o":0.0240373,"c":0.02367413,"h":0.024399,"l":0.0235,"v":2027.82522329},
                    //             {"t":1584230400000,"o":0.02363458,"c":0.02319242,"h":0.0237948,"l":0.02223196,"v":1707.96944997},
                    //         ]
                    //     }
                    //
                    const candles = this.safeValue(response, 'candles', []);
                    return this.parseOHLCVs(candles, market, timeframe, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "t":1584057600000,
                    //         "o":0.02235144,
                    //         "c":0.02400233,
                    //         "h":0.025171,
                    //         "l":0.02221,
                    //         "v":5988.34031761
                    //     }
                    //
                    return [
                        this.safeInteger(ohlcv, 't'),
                        this.safeNumber(ohlcv, 'o'),
                        this.safeNumber(ohlcv, 'h'),
                        this.safeNumber(ohlcv, 'l'),
                        this.safeNumber(ohlcv, 'c'),
                        this.safeNumber(ohlcv, 'v')
                    ];
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const free = this.safeValue(response, 'balances', {});
                    const used = this.safeValue(response, 'reserved', {});
                    const currencyIds = Object.keys(free);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        if (currencyId in free) account['free'] = this.safeString(free, currencyId);
                        if (currencyId in used) account['used'] = this.safeString(used, currencyId);
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostUserInfo(params);
                    //
                    //     {
                    //         "uid":131685,
                    //         "server_date":1628999600,
                    //         "balances":{
                    //             "EXM":"0",
                    //             "USD":"0",
                    //             "EUR":"0",
                    //             "GBP":"0",
                    //         },
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetOrderBook(this.extend(request, params));
                    const result = this.safeValue(response, market['id']);
                    return this.parseOrderBook(result, symbol, undefined, 'bid', 'ask');
                }
                async fetchOrderBooks(symbols, limit, params = {}) {
                    await this.loadMarkets();
                    let ids = undefined;
                    if (symbols === undefined) {
                        ids = this.ids.join(',');
                        // max URL length is 2083 symbols, including http schema, hostname, tld, etc...
                        if (ids.length > 2048) {
                            const numIds = this.ids.length;
                            throw new ExchangeError1(this.id + ' fetchOrderBooks() has ' + numIds.toString() + ' symbols exceeding max URL length, you are required to specify a list of symbols in the first argument to fetchOrderBooks');
                        }
                    } else {
                        ids = this.marketIds(symbols);
                        ids = ids.join(',');
                    }
                    const request = {
                        'pair': ids
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetOrderBook(this.extend(request, params));
                    const result = {};
                    const marketIds = Object.keys(response);
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        let symbol = marketId;
                        if (marketId in this.markets_by_id) {
                            const market = this.markets_by_id[marketId];
                            symbol = market['symbol'];
                        }
                        result[symbol] = this.parseOrderBook(response[marketId], symbol, undefined, 'bid', 'ask');
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "buy_price":"0.00002996",
                    //         "sell_price":"0.00003002",
                    //         "last_trade":"0.00002992",
                    //         "high":"0.00003028",
                    //         "low":"0.00002935",
                    //         "avg":"0.00002963",
                    //         "vol":"1196546.3163222",
                    //         "vol_curr":"35.80066578",
                    //         "updated":1642291733
                    //     }
                    //
                    const timestamp = this.safeTimestamp(ticker, 'updated');
                    market = this.safeMarket(undefined, market);
                    const last = this.safeString(ticker, 'last_trade');
                    return this.safeTicker({
                        'symbol': market['symbol'],
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy_price'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell_price'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': this.safeString(ticker, 'avg'),
                        'baseVolume': this.safeString(ticker, 'vol'),
                        'quoteVolume': this.safeString(ticker, 'vol_curr'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTicker(params);
                    //
                    //     {
                    //         "ADA_BTC":{
                    //             "buy_price":"0.00002996",
                    //             "sell_price":"0.00003002",
                    //             "last_trade":"0.00002992",
                    //             "high":"0.00003028",
                    //             "low":"0.00002935",
                    //             "avg":"0.00002963",
                    //             "vol":"1196546.3163222",
                    //             "vol_curr":"35.80066578",
                    //             "updated":1642291733
                    //         }
                    //     }
                    //
                    const result = {};
                    const marketIds = Object.keys(response);
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const market = this.safeMarket(marketId, undefined, '_');
                        const symbol = market['symbol'];
                        const ticker = this.safeValue(response, marketId);
                        result[symbol] = this.parseTicker(ticker, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTicker(params);
                    const market = this.market(symbol);
                    return this.parseTicker(response[market['id']], market);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "trade_id":165087520,
                    //         "date":1587470005,
                    //         "type":"buy",
                    //         "quantity":"1.004",
                    //         "price":"0.02491461",
                    //         "amount":"0.02501426"
                    //     },
                    //
                    // fetchMyTrades, fetchOrderTrades
                    //
                    //     {
                    //         "trade_id": 3,
                    //         "date": 1435488248,
                    //         "type": "buy",
                    //         "pair": "BTC_USD",
                    //         "order_id": 12345,
                    //         "quantity": 1,
                    //         "price": 100,
                    //         "amount": 100,
                    //         "exec_type": "taker",
                    //         "commission_amount": "0.02",
                    //         "commission_currency": "BTC",
                    //         "commission_percent": "0.2"
                    //     }
                    //
                    const timestamp = this.safeTimestamp(trade, 'date');
                    let symbol = undefined;
                    const id = this.safeString(trade, 'trade_id');
                    const orderId = this.safeString(trade, 'order_id');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'quantity');
                    const costString = this.safeString(trade, 'amount');
                    const side = this.safeString(trade, 'type');
                    const type = undefined;
                    const marketId = this.safeString(trade, 'pair');
                    if (marketId !== undefined) {
                        if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                        else {
                            const [baseId, quoteId] = marketId.split('_');
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote;
                        }
                    }
                    if (symbol === undefined && market !== undefined) symbol = market['symbol'];
                    const takerOrMaker = this.safeString(trade, 'exec_type');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'commission_amount');
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'commission_currency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        let feeRateString = this.safeString(trade, 'commission_percent');
                        if (feeRateString !== undefined) feeRateString = Precise.stringDiv(feeRateString, '1000', 18);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode,
                            'rate': feeRateString
                        };
                    }
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': orderId,
                        'type': type,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetTrades(this.extend(request, params));
                    //
                    //     {
                    //         "ETH_BTC":[
                    //             {
                    //                 "trade_id":165087520,
                    //                 "date":1587470005,
                    //                 "type":"buy",
                    //                 "quantity":"1.004",
                    //                 "price":"0.02491461",
                    //                 "amount":"0.02501426"
                    //             },
                    //             {
                    //                 "trade_id":165087369,
                    //                 "date":1587469938,
                    //                 "type":"buy",
                    //                 "quantity":"0.94",
                    //                 "price":"0.02492348",
                    //                 "amount":"0.02342807"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, market['id'], []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    // a symbol is required but it can be a single string, or a non-empty array
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument (a single symbol or an array)');
                    await this.loadMarkets();
                    let pair = undefined;
                    let market = undefined;
                    if (Array.isArray(symbol)) {
                        const numSymbols = symbol.length;
                        if (numSymbols < 1) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a non-empty symbol array');
                        const marketIds = this.marketIds(symbol);
                        pair = marketIds.join(',');
                    } else {
                        market = this.market(symbol);
                        pair = market['id'];
                    }
                    const request = {
                        'pair': pair
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privatePostUserTrades(this.extend(request, params));
                    let result = [];
                    const marketIds = Object.keys(response);
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        let symbol = undefined;
                        if (marketId in this.markets_by_id) {
                            market = this.markets_by_id[marketId];
                            symbol = market['symbol'];
                        } else {
                            const [baseId, quoteId] = marketId.split('_');
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote;
                        }
                        const items = response[marketId];
                        const trades = this.parseTrades(items, market, since, limit, {
                            'symbol': symbol
                        });
                        result = this.arrayConcat(result, trades);
                    }
                    return this.filterBySinceLimit(result, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const prefix = type === 'market' ? type + '_' : '';
                    const orderType = prefix + side;
                    let orderPrice = price;
                    if (type === 'market' && price === undefined) orderPrice = 0;
                    const request = {
                        'pair': market['id'],
                        // 'leverage': 2,
                        'quantity': this.amountToPrecision(symbol, amount),
                        // spot - buy, sell, market_buy, market_sell, market_buy_total, market_sell_total
                        // margin - limit_buy, limit_sell, market_buy, market_sell, stop_buy, stop_sell, stop_limit_buy, stop_limit_sell, trailing_stop_buy, trailing_stop_sell
                        'type': orderType,
                        'price': this.priceToPrecision(symbol, orderPrice)
                    };
                    let method = 'privatePostOrderCreate';
                    let clientOrderId = this.safeValue2(params, 'client_id', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        clientOrderId = this.safeInteger2(params, 'client_id', 'clientOrderId');
                        if (clientOrderId === undefined) throw new BadRequest(this.id + ' createOrder() client order id must be an integer / numeric literal');
                        else request['client_id'] = clientOrderId;
                        params = this.omit(params, [
                            'client_id',
                            'clientOrderId'
                        ]);
                    }
                    if (type === 'stop' || type === 'stop_limit' || type === 'trailing_stop') {
                        const stopPrice = this.safeNumber2(params, 'stop_price', 'stopPrice');
                        if (stopPrice === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a stopPrice extra param for a ' + type + ' order');
                        else {
                            params = this.omit(params, [
                                'stopPrice',
                                'stop_price'
                            ]);
                            request['stop_price'] = this.priceToPrecision(symbol, stopPrice);
                            method = 'privatePostMarginUserOrderCreate';
                        }
                    }
                    const response = await this[method](this.extend(request, params));
                    const id = this.safeString(response, 'order_id');
                    const timestamp = this.milliseconds();
                    const status = 'open';
                    return {
                        'id': id,
                        'info': response,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'price': price,
                        'cost': undefined,
                        'amount': amount,
                        'remaining': amount,
                        'filled': 0.0,
                        'fee': undefined,
                        'trades': undefined,
                        'clientOrderId': clientOrderId,
                        'average': undefined
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    return await this.privatePostOrderCancel(this.extend(request, params));
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id.toString()
                    };
                    const response = await this.privatePostOrderTrades(this.extend(request, params));
                    //
                    //     {
                    //         "type": "buy",
                    //         "in_currency": "BTC",
                    //         "in_amount": "1",
                    //         "out_currency": "USD",
                    //         "out_amount": "100",
                    //         "trades": [
                    //             {
                    //                 "trade_id": 3,
                    //                 "date": 1435488248,
                    //                 "type": "buy",
                    //                 "pair": "BTC_USD",
                    //                 "order_id": 12345,
                    //                 "quantity": 1,
                    //                 "price": 100,
                    //                 "amount": 100
                    //             }
                    //         ]
                    //     }
                    //
                    const order = this.parseOrder(response);
                    return this.extend(order, {
                        'id': id.toString()
                    });
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'order_id': id.toString()
                    };
                    const response = await this.privatePostOrderTrades(this.extend(request, params));
                    //
                    //     {
                    //         "type": "buy",
                    //         "in_currency": "BTC",
                    //         "in_amount": "1",
                    //         "out_currency": "USD",
                    //         "out_amount": "100",
                    //         "trades": [
                    //             {
                    //                 "trade_id": 3,
                    //                 "date": 1435488248,
                    //                 "type": "buy",
                    //                 "pair": "BTC_USD",
                    //                 "order_id": 12345,
                    //                 "quantity": 1,
                    //                 "price": 100,
                    //                 "amount": 100,
                    //                 "exec_type": "taker",
                    //                 "commission_amount": "0.02",
                    //                 "commission_currency": "BTC",
                    //                 "commission_percent": "0.2"
                    //             }
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, 'trades');
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        symbol = market['symbol'];
                    }
                    const response = await this.privatePostUserOpenOrders(params);
                    const marketIds = Object.keys(response);
                    let orders = [];
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        let market = undefined;
                        if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                        const parsedOrders = this.parseOrders(response[marketId], market);
                        orders = this.arrayConcat(orders, parsedOrders);
                    }
                    return this.filterBySymbolSinceLimit(orders, symbol, since, limit);
                }
                parseOrder(order, market) {
                    //
                    // fetchOrders, fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "order_id": "14",
                    //         "created": "1435517311",
                    //         "type": "buy",
                    //         "pair": "BTC_USD",
                    //         "price": "100",
                    //         "quantity": "1",
                    //         "amount": "100"
                    //     }
                    //
                    // fetchOrder
                    //
                    //     {
                    //         "type": "buy",
                    //         "in_currency": "BTC",
                    //         "in_amount": "1",
                    //         "out_currency": "USD",
                    //         "out_amount": "100",
                    //         "trades": [
                    //             {
                    //                 "trade_id": 3,
                    //                 "date": 1435488248,
                    //                 "type": "buy",
                    //                 "pair": "BTC_USD",
                    //                 "order_id": 12345,
                    //                 "quantity": 1,
                    //                 "price": 100,
                    //                 "amount": 100
                    //             }
                    //         ]
                    //     }
                    //
                    let id = this.safeString(order, 'order_id');
                    let timestamp = this.safeTimestamp(order, 'created');
                    let symbol = undefined;
                    const side = this.safeString(order, 'type');
                    if (market === undefined) {
                        let marketId = undefined;
                        if ('pair' in order) marketId = order['pair'];
                        else if ('in_currency' in order && 'out_currency' in order) {
                            if (side === 'buy') marketId = order['in_currency'] + '_' + order['out_currency'];
                            else marketId = order['out_currency'] + '_' + order['in_currency'];
                        }
                        if (marketId !== undefined && marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                    }
                    let amount = this.safeNumber(order, 'quantity');
                    if (amount === undefined) {
                        const amountField = side === 'buy' ? 'in_amount' : 'out_amount';
                        amount = this.safeNumber(order, amountField);
                    }
                    let price = this.safeNumber(order, 'price');
                    let cost = this.safeNumber(order, 'amount');
                    let filled = 0.0;
                    const trades = [];
                    const transactions = this.safeValue(order, 'trades', []);
                    let feeCost = undefined;
                    let lastTradeTimestamp = undefined;
                    let average = undefined;
                    const numTransactions = transactions.length;
                    if (numTransactions > 0) {
                        feeCost = 0;
                        for(let i = 0; i < numTransactions; i++){
                            const trade = this.parseTrade(transactions[i], market);
                            if (id === undefined) id = trade['order'];
                            if (timestamp === undefined) timestamp = trade['timestamp'];
                            if (timestamp > trade['timestamp']) timestamp = trade['timestamp'];
                            filled = this.sum(filled, trade['amount']);
                            feeCost = this.sum(feeCost, trade['fee']['cost']);
                            trades.push(trade);
                        }
                        lastTradeTimestamp = trades[numTransactions - 1]['timestamp'];
                    }
                    let status = this.safeString(order, 'status'); // in case we need to redefine it for canceled orders
                    let remaining = undefined;
                    if (amount !== undefined) {
                        remaining = amount - filled;
                        if (filled >= amount) status = 'closed';
                        else status = 'open';
                    }
                    if (market === undefined) market = this.getMarketFromTrades(trades);
                    let feeCurrency = undefined;
                    if (market !== undefined) {
                        symbol = market['symbol'];
                        feeCurrency = market['quote'];
                    }
                    if (cost === undefined) {
                        if (price !== undefined) cost = price * filled;
                    } else if (filled > 0) {
                        if (average === undefined) average = cost / filled;
                        if (price === undefined) price = cost / filled;
                    }
                    const fee = {
                        'cost': feeCost,
                        'currency': feeCurrency
                    };
                    const clientOrderId = this.safeInteger(order, 'client_id');
                    return {
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'status': status,
                        'symbol': symbol,
                        'type': 'limit',
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'average': average,
                        'trades': trades,
                        'fee': fee,
                        'info': order
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostDepositAddress(params);
                    const depositAddress = this.safeString(response, code);
                    let address = undefined;
                    let tag = undefined;
                    if (depositAddress) {
                        const addressAndTag = depositAddress.split(',');
                        address = addressAndTag[0];
                        const numParts = addressAndTag.length;
                        if (numParts > 1) tag = addressAndTag[1];
                    }
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                getMarketFromTrades(trades) {
                    const tradesBySymbol = this.indexBy(trades, 'pair');
                    const symbols = Object.keys(tradesBySymbol);
                    const numSymbols = symbols.length;
                    if (numSymbols === 1) return this.markets[symbols[0]];
                    return undefined;
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'amount': amount,
                        'currency': currency['id'],
                        'address': address
                    };
                    if (tag !== undefined) request['invoice'] = tag;
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeString(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['transport'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privatePostWithdrawCrypt(this.extend(request, params));
                    return this.parseTransaction(response, currency);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'transferred': 'ok',
                        'paid': 'ok',
                        'pending': 'pending',
                        'processing': 'pending',
                        'verifying': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchTransactions
                    //
                    //          {
                    //            "dt": 1461841192,
                    //            "type": "deposit",
                    //            "curr": "RUB",
                    //            "status": "processing",
                    //            "provider": "Qiwi (LA) [12345]",
                    //            "amount": "1",
                    //            "account": "",
                    //            "txid": "ec46f784ad976fd7f7539089d1a129fe46...",
                    //          }
                    //
                    // fetchWithdrawals
                    //
                    //          {
                    //             "operation_id": 47412538520634344,
                    //             "created": 1573760013,
                    //             "updated": 1573760013,
                    //             "type": "withdraw",
                    //             "currency": "DOGE",
                    //             "status": "Paid",
                    //             "amount": "300",
                    //             "provider": "DOGE",
                    //             "commission": "0",
                    //             "account": "DOGE: DBVy8pF1f8yxaCVEHqHeR7kkcHecLQ8nRS",
                    //             "order_id": 69670170,
                    //             "provider_type": "crypto",
                    //             "crypto_address": "DBVy8pF1f8yxaCVEHqHeR7kkcHecLQ8nRS",
                    //             "card_number": "",
                    //             "wallet_address": "",
                    //             "email": "",
                    //             "phone": "",
                    //             "extra": {
                    //                 "txid": "f2b66259ae1580f371d38dd27e31a23fff8c04122b65ee3ab5a3f612d579c792",
                    //                 "confirmations": null,
                    //                 "excode": "",
                    //                 "invoice": ""
                    //             },
                    //             "error": ""
                    //          },
                    //
                    const id = this.safeString2(transaction, 'order_id', 'task_id');
                    const timestamp = this.safeTimestamp2(transaction, 'dt', 'created');
                    const updated = this.safeTimestamp(transaction, 'updated');
                    let amount = this.safeNumber(transaction, 'amount');
                    if (amount !== undefined) amount = Math.abs(amount);
                    const status = this.parseTransactionStatus(this.safeStringLower(transaction, 'status'));
                    let txid = this.safeString(transaction, 'txid');
                    if (txid === undefined) {
                        const extra = this.safeValue(transaction, 'extra', {});
                        const extraTxid = this.safeString(extra, 'txid');
                        if (extraTxid !== '') txid = extraTxid;
                    }
                    const type = this.safeString(transaction, 'type');
                    const currencyId = this.safeString2(transaction, 'curr', 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    let address = undefined;
                    const tag = undefined;
                    let comment = undefined;
                    const account = this.safeString(transaction, 'account');
                    if (type === 'deposit') comment = account;
                    else if (type === 'withdrawal') {
                        address = account;
                        if (address !== undefined) {
                            const parts = address.split(':');
                            const numParts = parts.length;
                            if (numParts === 2) {
                                address = this.safeString(parts, 1);
                                address = address.replace(' ', '');
                            }
                        }
                    }
                    let fee = undefined;
                    // fixed funding fees only (for now)
                    if (!this.fees['funding']['percentage']) {
                        const key = type === 'withdrawal' ? 'withdraw' : 'deposit';
                        let feeCost = this.safeNumber(transaction, 'commission');
                        if (feeCost === undefined) feeCost = this.safeNumber(this.options['fundingFees'][key], code);
                        // users don't pay for cashbacks, no fees for that
                        const provider = this.safeString(transaction, 'provider');
                        if (provider === 'cashback') feeCost = 0;
                        if (feeCost !== undefined) {
                            // withdrawal amount includes the fee
                            if (type === 'withdrawal') amount = amount - feeCost;
                            fee = {
                                'cost': feeCost,
                                'currency': code,
                                'rate': undefined
                            };
                        }
                    }
                    const network = this.safeString(transaction, 'provider');
                    return {
                        'info': transaction,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': code,
                        'amount': amount,
                        'network': network,
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'tagFrom': undefined,
                        'status': status,
                        'type': type,
                        'updated': updated,
                        'comment': comment,
                        'txid': txid,
                        'fee': fee
                    };
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (since !== undefined) request['date'] = parseInt(since / 1000);
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const response = await this.privatePostWalletHistory(this.extend(request, params));
                    //
                    //     {
                    //       "result": true,
                    //       "error": "",
                    //       "begin": "1493942400",
                    //       "end": "1494028800",
                    //       "history": [
                    //          {
                    //            "dt": 1461841192,
                    //            "type": "deposit",
                    //            "curr": "RUB",
                    //            "status": "processing",
                    //            "provider": "Qiwi (LA) [12345]",
                    //            "amount": "1",
                    //            "account": "",
                    //            "txid": "ec46f784ad976fd7f7539089d1a129fe46...",
                    //          },
                    //          {
                    //            "dt": 1463414785,
                    //            "type": "withdrawal",
                    //            "curr": "USD",
                    //            "status": "paid",
                    //            "provider": "EXCODE",
                    //            "amount": "-1",
                    //            "account": "EX-CODE_19371_USDda...",
                    //            "txid": "",
                    //          },
                    //       ],
                    //     }
                    //
                    return this.parseTransactions(response['history'], currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {
                        'type': 'withdraw'
                    };
                    if (limit !== undefined) request['limit'] = limit; // default: 100, maximum: 100
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    const response = await this.privatePostWalletOperations(this.extend(request, params));
                    //
                    //     {
                    //         "items": [
                    //         {
                    //             "operation_id": 47412538520634344,
                    //             "created": 1573760013,
                    //             "updated": 1573760013,
                    //             "type": "withdraw",
                    //             "currency": "DOGE",
                    //             "status": "Paid",
                    //             "amount": "300",
                    //             "provider": "DOGE",
                    //             "commission": "0",
                    //             "account": "DOGE: DBVy8pF1f8yxaCVEHqHeR7kkcHecLQ8nRS",
                    //             "order_id": 69670170,
                    //             "extra": {
                    //                 "txid": "f2b66259ae1580f371d38dd27e31a23fff8c04122b65ee3ab5a3f612d579c792",
                    //                 "excode": "",
                    //                 "invoice": ""
                    //             },
                    //             "error": ""
                    //         },
                    //     ],
                    //         "count": 23
                    //     }
                    //
                    return this.parseTransactions(response['items'], currency, since, limit);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/';
                    if (api !== 'web') url += this.version + '/';
                    url += path;
                    if (api === 'public' || api === 'web') {
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    } else if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce();
                        body = this.urlencode(this.extend({
                            'nonce': nonce
                        }, params));
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Key': this.apiKey,
                            'Sign': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if ('result' in response || 'errmsg' in response) {
                        //
                        //     {"result":false,"error":"Error 50052: Insufficient funds"}
                        //     {"s":"error","errmsg":"strconv.ParseInt: parsing \"\": invalid syntax"}
                        //
                        let success = this.safeValue(response, 'result', false);
                        if (typeof success === 'string') {
                            if (success === 'true' || success === '1') success = true;
                            else success = false;
                        }
                        if (!success) {
                            let code = undefined;
                            const message = this.safeString2(response, 'error', 'errmsg');
                            const errorParts = message.split(':');
                            const numParts = errorParts.length;
                            if (numParts > 1) {
                                const errorSubParts = errorParts[0].split(' ');
                                const numSubParts = errorSubParts.length;
                                code = numSubParts > 1 ? errorSubParts[1] : errorSubParts[0];
                            }
                            const feedback = this.id + ' ' + body;
                            this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    79: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const ndax = require1('./ndax.js');
            //  ---------------------------------------------------------------------------
            module.exports = class flowbtc extends ndax {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'flowbtc',
                        'name': 'flowBTC',
                        'countries': [
                            'BR'
                        ],
                        'rateLimit': 1000,
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87443317-01c0d080-c5fe-11ea-95c2-9ebe1a8fafd9.jpg',
                            'api': {
                                'public': 'https://api.flowbtc.com.br:8443/ap/',
                                'private': 'https://api.flowbtc.com.br:8443/ap/'
                            },
                            'www': 'https://www.flowbtc.com.br',
                            'doc': 'https://www.flowbtc.com.br/api.html'
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': 0.0025,
                                'taker': 0.005
                            }
                        }
                    });
                }
            };
        },
        {
            "./ndax.js": 107
        }
    ],
    80: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const hitbtc = require1('./hitbtc.js');
            //  ---------------------------------------------------------------------------
            module.exports = class fmfwio extends hitbtc {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'fmfwio',
                        'name': 'FMFW.io',
                        'countries': [
                            'KN'
                        ],
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/159177712-b685b40c-5269-4cea-ac83-f7894c49525d.jpg',
                            'api': {
                                'public': 'https://api.fmfw.io',
                                'private': 'https://api.fmfw.io'
                            },
                            'www': 'https://fmfw.io',
                            'doc': 'https://api.fmfw.io/api/2/explore/',
                            'fees': 'https://fmfw.io/fees-and-limits',
                            'referral': 'https://fmfw.io/referral/da948b21d6c92d69'
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.005'),
                                'taker': this.parseNumber('0.005')
                            }
                        }
                    });
                }
            };
        },
        {
            "./hitbtc.js": 85
        }
    ],
    81: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const { ExchangeError: ExchangeError1, InvalidOrder: InvalidOrder, BadRequest: BadRequest, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded, ExchangeNotAvailable: ExchangeNotAvailable, CancelPending: CancelPending, ArgumentsRequired: ArgumentsRequired1, PermissionDenied: PermissionDenied, BadSymbol: BadSymbol, DuplicateOrderId: DuplicateOrderId, BadResponse: BadResponse } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class ftx extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'ftx',
                        'name': 'FTX',
                        'countries': [
                            'BS'
                        ],
                        //  hard limit of 7 requests per 200ms => 35 requests per 1000ms => 1000ms / 35 = 28.5714 ms between requests
                        // 10 withdrawal requests per 30 seconds = (1000ms / rateLimit) / (1/3) = 90.1
                        // cancels do not count towards rateLimit
                        // only 'order-making' requests count towards ratelimit
                        'rateLimit': 28.57,
                        'certified': true,
                        'pro': true,
                        'hostname': 'ftx.com',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/67149189-df896480-f2b0-11e9-8816-41593e17f9ec.jpg',
                            'www': 'https://ftx.com',
                            'api': {
                                'public': 'https://{hostname}',
                                'private': 'https://{hostname}'
                            },
                            'doc': 'https://github.com/ftexchange/ftx',
                            'fees': 'https://ftexchange.zendesk.com/hc/en-us/articles/360024479432-Fees',
                            'referral': {
                                'url': 'https://ftx.com/#a=ccxt',
                                'discount': 0.05
                            }
                        },
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': true,
                            'swap': true,
                            'future': true,
                            'option': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowInterest': true,
                            'fetchBorrowRate': true,
                            'fetchBorrowRateHistories': true,
                            'fetchBorrowRateHistory': true,
                            'fetchBorrowRates': true,
                            'fetchClosedOrders': undefined,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingFees': undefined,
                            'fetchFundingHistory': true,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': true,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': true,
                            'fetchLeverageTiers': false,
                            'fetchMarketLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': false,
                            'fetchPositions': true,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': false,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransfer': undefined,
                            'fetchTransfers': undefined,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': true,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '15s': '15',
                            '1m': '60',
                            '5m': '300',
                            '15m': '900',
                            '1h': '3600',
                            '4h': '14400',
                            '1d': '86400',
                            '3d': '259200',
                            '1w': '604800',
                            '2w': '1209600',
                            // the exchange does not align candles to the start of the month
                            // it can only fetch candles in fixed intervals of multiples of whole days
                            // that works for all timeframes, except the monthly timeframe
                            // because months have varying numbers of days
                            '1M': '2592000'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'coins': 1,
                                    // markets
                                    'markets': 1,
                                    'markets/{market_name}': 1,
                                    'markets/{market_name}/orderbook': 1,
                                    'markets/{market_name}/trades': 1,
                                    'markets/{market_name}/candles': 1,
                                    // futures
                                    'futures': 1,
                                    'futures/{future_name}': 1,
                                    'futures/{future_name}/stats': 1,
                                    'funding_rates': 1,
                                    'indexes/{index_name}/weights': 1,
                                    'expired_futures': 1,
                                    'indexes/{market_name}/candles': 1,
                                    // wallet
                                    'wallet/coins': 1,
                                    // leverage tokens
                                    'lt/tokens': 1,
                                    'lt/{token_name}': 1,
                                    // etfs
                                    'etfs/rebalance_info': 1,
                                    // options
                                    'options/requests': 1,
                                    'options/trades': 1,
                                    'options/historical_volumes/BTC': 1,
                                    'stats/24h_options_volume': 1,
                                    'options/open_interest/BTC': 1,
                                    'options/historical_open_interest/BTC': 1,
                                    // spot margin
                                    'spot_margin/history': 1,
                                    'spot_margin/borrow_summary': 1,
                                    // nfts
                                    'nft/nfts': 1,
                                    'nft/{nft_id}': 1,
                                    'nft/{nft_id}/trades': 1,
                                    'nft/all_trades': 1,
                                    'nft/{nft_id}/account_info': 1,
                                    'nft/collections': 1,
                                    // ftx pay
                                    'ftxpay/apps/{user_specific_id}/details': 1
                                },
                                'post': {
                                    'ftxpay/apps/{user_specific_id}/orders': 1
                                }
                            },
                            'private': {
                                'get': {
                                    // subaccounts
                                    'subaccounts': 1,
                                    'subaccounts/{nickname}/balances': 1,
                                    // account
                                    'account': 1,
                                    'positions': 1,
                                    // wallet
                                    'wallet/balances': 1,
                                    'wallet/all_balances': 1,
                                    'wallet/deposit_address/{coin}': 1,
                                    'wallet/deposits': 1,
                                    'wallet/withdrawals': 1,
                                    'wallet/airdrops': 1,
                                    'wallet/withdrawal_fee': 1,
                                    'wallet/saved_addresses': 1,
                                    // orders
                                    'orders': 1,
                                    'orders/history': 1,
                                    'orders/{order_id}': 1,
                                    'orders/by_client_id/{client_order_id}': 1,
                                    // conditional orders
                                    'conditional_orders': 1,
                                    'conditional_orders/{conditional_order_id}/triggers': 1,
                                    'conditional_orders/history': 1,
                                    'fills': 1,
                                    'funding_payments': 1,
                                    // leverage tokens
                                    'lt/balances': 1,
                                    'lt/creations': 1,
                                    'lt/redemptions': 1,
                                    // options
                                    'options/my_requests': 1,
                                    'options/requests/{request_id}/quotes': 1,
                                    'options/my_quotes': 1,
                                    'options/account_info': 1,
                                    'options/positions': 1,
                                    'options/fills': 1,
                                    // staking
                                    'staking/stakes': 1,
                                    'staking/unstake_requests': 1,
                                    'staking/balances': 1,
                                    'staking/staking_rewards': 1,
                                    // otc
                                    'otc/quotes/{quoteId}': 1,
                                    // spot margin
                                    'spot_margin/borrow_rates': 1,
                                    'spot_margin/lending_rates': 1,
                                    'spot_margin/market_info': 1,
                                    'spot_margin/borrow_history': 1,
                                    'spot_margin/lending_history': 1,
                                    'spot_margin/offers': 1,
                                    'spot_margin/lending_info': 1,
                                    // nfts
                                    'nft/balances': 1,
                                    'nft/bids': 1,
                                    'nft/deposits': 1,
                                    'nft/withdrawals': 1,
                                    'nft/fills': 1,
                                    'nft/gallery/{gallery_id}': 1,
                                    'nft/gallery_settings': 1,
                                    // latency statistics
                                    'stats/latency_stats': 1,
                                    // pnl
                                    'pnl/historical_changes': 1
                                },
                                'post': {
                                    // subaccounts
                                    'subaccounts': 1,
                                    'subaccounts/update_name': 1,
                                    'subaccounts/transfer': 1,
                                    // account
                                    'account/leverage': 1,
                                    // wallet
                                    'wallet/deposit_address/list': 1,
                                    'wallet/withdrawals': 90,
                                    'wallet/saved_addresses': 1,
                                    // orders
                                    'orders': 1,
                                    'conditional_orders': 1,
                                    'orders/{order_id}/modify': 1,
                                    'orders/by_client_id/{client_order_id}/modify': 1,
                                    'conditional_orders/{order_id}/modify': 1,
                                    // leverage tokens
                                    'lt/{token_name}/create': 1,
                                    'lt/{token_name}/redeem': 1,
                                    // options
                                    'options/requests': 1,
                                    'options/requests/{request_id}/quotes': 1,
                                    'options/quotes/{quote_id}/accept': 1,
                                    // staking
                                    'staking/unstake_requests': 1,
                                    'srm_stakes/stakes': 1,
                                    // otc
                                    'otc/quotes/{quote_id}/accept': 1,
                                    'otc/quotes': 1,
                                    // spot margin
                                    'spot_margin/offers': 1,
                                    // nfts
                                    'nft/offer': 1,
                                    'nft/buy': 1,
                                    'nft/auction': 1,
                                    'nft/edit_auction': 1,
                                    'nft/cancel_auction': 1,
                                    'nft/bids': 1,
                                    'nft/redeem': 1,
                                    'nft/gallery_settings': 1,
                                    // ftx pay
                                    'ftxpay/apps/{user_specific_id}/orders': 1
                                },
                                'delete': {
                                    // subaccounts
                                    'subaccounts': 1,
                                    // wallet
                                    'wallet/saved_addresses/{saved_address_id}': 1,
                                    // orders
                                    'orders/{order_id}': 1,
                                    'orders/by_client_id/{client_order_id}': 1,
                                    'orders': 1,
                                    'conditional_orders/{order_id}': 1,
                                    // options
                                    'options/requests/{request_id}': 1,
                                    'options/quotes/{quote_id}': 1,
                                    // staking
                                    'staking/unstake_requests/{request_id}': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'maker': this.parseNumber('0.0002'),
                                'taker': this.parseNumber('0.0007'),
                                'tiers': {
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('2000000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.00055')
                                        ],
                                        [
                                            this.parseNumber('10000000'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('25000000'),
                                            this.parseNumber('0.0045')
                                        ],
                                        [
                                            this.parseNumber('50000000'),
                                            this.parseNumber('0.0004')
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.0002')
                                        ],
                                        [
                                            this.parseNumber('2000000'),
                                            this.parseNumber('0.00015')
                                        ],
                                        [
                                            this.parseNumber('5000000'),
                                            this.parseNumber('0.0001')
                                        ],
                                        [
                                            this.parseNumber('10000000'),
                                            this.parseNumber('0.00005')
                                        ],
                                        [
                                            this.parseNumber('25000000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('50000000'),
                                            this.parseNumber('0')
                                        ]
                                    ]
                                }
                            },
                            'funding': {
                                'withdraw': {}
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'Slow down': RateLimitExceeded,
                                'Size too small for provide': InvalidOrder,
                                'Not enough balances': InsufficientFunds,
                                'InvalidPrice': InvalidOrder,
                                'Size too small': InvalidOrder,
                                'Size too large': InvalidOrder,
                                'Invalid price': InvalidOrder,
                                'Missing parameter price': InvalidOrder,
                                'Order not found': OrderNotFound,
                                'Order already closed': InvalidOrder,
                                'Trigger price too high': InvalidOrder,
                                'Trigger price too low': InvalidOrder,
                                'Order already queued for cancellation': CancelPending,
                                'Duplicate client order ID': DuplicateOrderId,
                                'Spot orders cannot be reduce-only': InvalidOrder,
                                'Invalid reduce-only order': InvalidOrder,
                                'Account does not have enough balances': InsufficientFunds,
                                'Not authorized for subaccount-specific access': PermissionDenied,
                                'Not approved to trade this product': PermissionDenied
                            },
                            'broad': {
                                // {"error":"Not logged in","success":false}
                                // {"error":"Not logged in: Invalid API key","success":false}
                                'Not logged in': AuthenticationError,
                                'Account does not have enough margin for order': InsufficientFunds,
                                'Invalid parameter': BadRequest,
                                'The requested URL was not found on the server': BadRequest,
                                'No such coin': BadRequest,
                                'No such subaccount': AuthenticationError,
                                'No such future': BadSymbol,
                                'No such market': BadSymbol,
                                'Do not send more than': RateLimitExceeded,
                                'Cannot send more than': RateLimitExceeded,
                                'An unexpected error occurred': ExchangeNotAvailable,
                                'Please retry request': ExchangeNotAvailable,
                                'Please try again': ExchangeNotAvailable,
                                'Try again': ExchangeNotAvailable,
                                'Only have permissions for subaccount': PermissionDenied
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'options': {
                            // support for canceling conditional orders
                            // https://github.com/ccxt/ccxt/issues/6669
                            'fetchMarkets': {
                                // the expiry datetime may be undefined for expiring futures, https://github.com/ccxt/ccxt/pull/12692
                                'throwOnUndefinedExpiry': false
                            },
                            'cancelOrder': {
                                'method': 'privateDeleteOrdersOrderId'
                            },
                            'fetchOpenOrders': {
                                'method': 'privateGetOrders'
                            },
                            'fetchOrders': {
                                'method': 'privateGetOrdersHistory'
                            },
                            'sign': {
                                'ftx.com': 'FTX',
                                'ftx.us': 'FTXUS'
                            },
                            'networks': {
                                'SOL': 'sol',
                                'SPL': 'sol',
                                'TRX': 'trx',
                                'TRC20': 'trx',
                                'ETH': 'erc20',
                                'ERC20': 'erc20',
                                'OMNI': 'omni',
                                'BEP2': 'bep2',
                                'BNB': 'bep2',
                                'BEP20': 'bsc',
                                'BSC': 'bsc'
                            }
                        },
                        'commonCurrencies': {
                            'AMC': 'AMC Entertainment Holdings',
                            'STARS': 'StarLaunch'
                        }
                    });
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCoins(params);
                    const currencies = this.safeValue(response, 'result', []);
                    //
                    //     {
                    //         "success":true,
                    //         "result": [
                    //             {"id":"BTC","name":"Bitcoin"},
                    //             {"id":"ETH","name":"Ethereum"},
                    //             {"id":"ETHMOON","name":"10X Long Ethereum Token","underlying":"ETH"},
                    //             {"id":"EOSBULL","name":"3X Long EOS Token","underlying":"EOS"},
                    //         ],
                    //     }
                    //
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'id');
                        const code = this.safeCurrencyCode(id);
                        const name = this.safeString(currency, 'name');
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'type': undefined,
                            'name': name,
                            'active': undefined,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': undefined,
                            'precision': undefined,
                            'limits': {
                                'withdraw': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetMarkets(params);
                    //
                    //     {
                    //         'success': true,
                    //         "result": [
                    //             {
                    //                 "ask":170.37,
                    //                 "baseCurrency":null,
                    //                 "bid":170.31,
                    //                 "change1h":-0.019001554672655036,
                    //                 "change24h":-0.024841165359738997,
                    //                 "changeBod":-0.03816406029469881,
                    //                 "enabled":true,
                    //                 "last":170.37,
                    //                 "name":"ETH-PERP",
                    //                 "price":170.37,
                    //                 "priceIncrement":0.01,
                    //                 "quoteCurrency":null,
                    //                 "quoteVolume24h":7742164.59889,
                    //                 "sizeIncrement":0.001,
                    //                 "type":"future",
                    //                 "underlying":"ETH",
                    //                 "volumeUsd24h":7742164.59889
                    //             },
                    //             {
                    //                 "ask":170.44,
                    //                 "baseCurrency":"ETH",
                    //                 "bid":170.41,
                    //                 "change1h":-0.018485459257126403,
                    //                 "change24h":-0.023825887743413515,
                    //                 "changeBod":-0.037605872388481086,
                    //                 "enabled":true,
                    //                 "last":172.72,
                    //                 "name":"ETH/USD",
                    //                 "price":170.44,
                    //                 "priceIncrement":0.01,
                    //                 "quoteCurrency":"USD",
                    //                 "quoteVolume24h":382802.0252,
                    //                 "sizeIncrement":0.001,
                    //                 "type":"spot",
                    //                 "underlying":null,
                    //                 "volumeUsd24h":382802.0252
                    //             },
                    //         ],
                    //     }
                    //
                    //     {
                    //         name: "BTC-PERP",
                    //         enabled:  true,
                    //         postOnly:  false,
                    //         priceIncrement: "1.0",
                    //         sizeIncrement: "0.0001",
                    //         minProvideSize: "0.001",
                    //         last: "60397.0",
                    //         bid: "60387.0",
                    //         ask: "60388.0",
                    //         price: "60388.0",
                    //         type: "future",
                    //         baseCurrency:  null,
                    //         quoteCurrency:  null,
                    //         underlying: "BTC",
                    //         restricted:  false,
                    //         highLeverageFeeExempt:  true,
                    //         change1h: "-0.0036463231533270636",
                    //         change24h: "-0.01844838515677064",
                    //         changeBod: "-0.010130151132675475",
                    //         quoteVolume24h: "2892083192.6099",
                    //         volumeUsd24h: "2892083192.6099"
                    //     }
                    //
                    let allFuturesResponse = undefined;
                    if (this.has['future'] && this.hostname !== 'ftx.us') allFuturesResponse = await this.publicGetFutures();
                    //
                    //    {
                    //        success: true,
                    //        result: [
                    //            {
                    //                name: "1INCH-PERP",
                    //                underlying: "1INCH",
                    //                description: "1INCH Token Perpetual Futures",
                    //                type: "perpetual",
                    //                expiry: null,
                    //                perpetual: true,
                    //                expired: false,
                    //                enabled: true,
                    //                postOnly: false,
                    //                priceIncrement: "0.0001",
                    //                sizeIncrement: "1.0",
                    //                last: "2.5556",
                    //                bid: "2.5555",
                    //                ask: "2.5563",
                    //                index: "2.5612449804010833",
                    //                mark: "2.5587",
                    //                imfFactor: "0.0005",
                    //                lowerBound: "2.4315",
                    //                upperBound: "2.6893",
                    //                underlyingDescription: "1INCH Token",
                    //                expiryDescription: "Perpetual",
                    //                moveStart: null,
                    //                marginPrice: "2.5587",
                    //                positionLimitWeight: "20.0",
                    //                group: "perpetual",
                    //                change1h: "0.00799716356760164",
                    //                change24h: "0.004909276569004792",
                    //                changeBod: "0.008394419484511705",
                    //                volumeUsd24h: "17834492.0818",
                    //                volume: "7224898.0",
                    //                openInterest: "5597917.0",
                    //                openInterestUsd: "14323390.2279",
                    //            },
                    //            ...
                    //        ],
                    //    }
                    //
                    const result = [];
                    const markets = this.safeValue(response, 'result', []);
                    const allFutures = this.safeValue(allFuturesResponse, 'result', []);
                    const allFuturesDict = this.indexBy(allFutures, 'name');
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'name');
                        const future = this.safeValue(allFuturesDict, id);
                        const marketType = this.safeString(market, 'type');
                        const contract = marketType === 'future';
                        const baseId = this.safeString2(market, 'baseCurrency', 'underlying');
                        const quoteId = this.safeString(market, 'quoteCurrency', 'USD');
                        const settleId = contract ? 'USD' : undefined;
                        let base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const settle = this.safeCurrencyCode(settleId);
                        const spot = !contract;
                        const margin = !contract;
                        const perpetual = this.safeValue(future, 'perpetual', false);
                        const swap = perpetual;
                        const option = false;
                        const isFuture = contract && !swap;
                        let expiry = undefined;
                        const expiryDatetime = this.safeString(future, 'expiry');
                        let type = 'spot';
                        let symbol = base + '/' + quote;
                        if (swap) {
                            type = 'swap';
                            symbol = base + '/' + quote + ':' + settle;
                        } else if (isFuture) {
                            type = 'future';
                            expiry = this.parse8601(expiryDatetime);
                            if (expiry === undefined) {
                                // it is likely a future that is expiring in this moment
                                const options = this.safeValue(this.options, 'fetchMarkets', {});
                                const throwOnUndefinedExpiry = this.safeValue(options, 'throwOnUndefinedExpiry', false);
                                if (throwOnUndefinedExpiry) throw new BadResponse(this.id + " symbol '" + id + "' is a future contract with an invalid expiry datetime.");
                                else continue;
                            }
                            const parsedId = id.split('-');
                            const length = parsedId.length;
                            if (length > 2) {
                                // handling for MOVE contracts
                                // BTC-MOVE-2022Q1
                                // BTC-MOVE-0106
                                // BTC-MOVE-WK-0121
                                parsedId.pop();
                                // remove expiry
                                // [ 'BTC', 'MOVE' ]
                                // [ 'BTC', 'MOVE' ]
                                // [ 'BTC', 'MOVE', 'WK' ]
                                base = parsedId.join('-');
                            }
                            symbol = base + '/' + quote + ':' + settle + '-' + this.yymmdd(expiry, '');
                        }
                        // check if a market is a spot or future market
                        const sizeIncrement = this.safeString(market, 'sizeIncrement');
                        const minProvideSize = this.safeString(market, 'minProvideSize');
                        let minAmountString = sizeIncrement;
                        if (minProvideSize !== undefined) minAmountString = Precise.stringGt(minProvideSize, sizeIncrement) ? sizeIncrement : minProvideSize;
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': type,
                            'spot': spot,
                            'margin': margin,
                            'swap': swap,
                            'future': isFuture,
                            'option': option,
                            'active': this.safeValue(market, 'enabled'),
                            'contract': contract,
                            'linear': contract ? true : undefined,
                            'inverse': contract ? false : undefined,
                            'contractSize': this.parseNumber('1'),
                            'expiry': expiry,
                            'expiryDatetime': this.iso8601(expiry),
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.parseNumber(sizeIncrement),
                                'price': this.safeNumber(market, 'priceIncrement')
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': this.parseNumber('20')
                                },
                                'amount': {
                                    'min': this.parseNumber(minAmountString),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "ask":171.29,
                    //         "baseCurrency":null, // base currency for spot markets
                    //         "bid":171.24,
                    //         "change1h":-0.0012244897959183673,
                    //         "change24h":-0.031603346901854366,
                    //         "changeBod":-0.03297013492914808,
                    //         "enabled":true,
                    //         "last":171.44,
                    //         "name":"ETH-PERP",
                    //         "price":171.29,
                    //         "priceIncrement":0.01,
                    //         "quoteCurrency":null, // quote currency for spot markets
                    //         "quoteVolume24h":8570651.12113,
                    //         "sizeIncrement":0.001,
                    //         "type":"future",
                    //         "underlying":"ETH", // null for spot markets
                    //         "volumeUsd24h":8570651.12113,
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'name');
                    if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeString(ticker, 'last');
                    const timestamp = this.safeTimestamp(ticker, 'time', this.milliseconds());
                    let percentage = this.safeString(ticker, 'change24h');
                    if (percentage !== undefined) percentage = Precise.stringMul(percentage, '100');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': this.safeString(ticker, 'bidSize'),
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': this.safeString(ticker, 'askSize'),
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': undefined,
                        'quoteVolume': this.safeString(ticker, 'quoteVolume24h'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_name': market['id']
                    };
                    const response = await this.publicGetMarketsMarketName(this.extend(request, params));
                    //
                    //     {
                    //         "success":true,
                    //         "result":{
                    //             "ask":171.29,
                    //             "baseCurrency":null, // base currency for spot markets
                    //             "bid":171.24,
                    //             "change1h":-0.0012244897959183673,
                    //             "change24h":-0.031603346901854366,
                    //             "changeBod":-0.03297013492914808,
                    //             "enabled":true,
                    //             "last":171.44,
                    //             "name":"ETH-PERP",
                    //             "price":171.29,
                    //             "priceIncrement":0.01,
                    //             "quoteCurrency":null, // quote currency for spot markets
                    //             "quoteVolume24h":8570651.12113,
                    //             "sizeIncrement":0.001,
                    //             "type":"future",
                    //             "underlying":"ETH", // null for spot markets
                    //             "volumeUsd24h":8570651.12113,
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseTicker(result, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetMarkets(params);
                    //
                    //     {
                    //         'success': true,
                    //         "result": [
                    //             {
                    //                 "ask":170.44,
                    //                 "baseCurrency":"ETH",
                    //                 "bid":170.41,
                    //                 "change1h":-0.018485459257126403,
                    //                 "change24h":-0.023825887743413515,
                    //                 "changeBod":-0.037605872388481086,
                    //                 "enabled":true,
                    //                 "last":172.72,
                    //                 "name":"ETH/USD",
                    //                 "price":170.44,
                    //                 "priceIncrement":0.01,
                    //                 "quoteCurrency":"USD",
                    //                 "quoteVolume24h":382802.0252,
                    //                 "sizeIncrement":0.001,
                    //                 "type":"spot",
                    //                 "underlying":null,
                    //                 "volumeUsd24h":382802.0252
                    //             },
                    //         ],
                    //     }
                    //
                    const tickers = this.safeValue(response, 'result', []);
                    return this.parseTickers(tickers, symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_name': market['id']
                    };
                    if (limit !== undefined) request['depth'] = limit; // max 100, default 20
                    const response = await this.publicGetMarketsMarketNameOrderbook(this.extend(request, params));
                    //
                    //     {
                    //         "success":true,
                    //         "result":{
                    //             "asks":[
                    //                 [171.95,279.865],
                    //                 [171.98,102.42],
                    //                 [171.99,124.11],
                    //             ],
                    //             "bids":[
                    //                 [171.93,69.749],
                    //                 [171.9,288.325],
                    //                 [171.88,87.47],
                    //             ],
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseOrderBook(result, symbol);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "close":177.23,
                    //         "high":177.45,
                    //         "low":177.2,
                    //         "open":177.43,
                    //         "startTime":"2019-10-17T13:27:00+00:00",
                    //         "time":1571318820000.0,
                    //         "volume":0.0
                    //     }
                    //
                    return [
                        this.safeInteger(ohlcv, 'time'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                getMarketId(symbol, key, params = {}) {
                    const parts = this.getMarketParams(symbol, key, params);
                    return this.safeString(parts, 1, symbol);
                }
                getMarketParams(symbol, key, params = {}) {
                    let market = undefined;
                    let marketId = undefined;
                    if (symbol in this.markets) {
                        market = this.market(symbol);
                        marketId = market['id'];
                    } else marketId = this.safeString(params, key, symbol);
                    return [
                        market,
                        marketId
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const [market, marketId] = this.getMarketParams(symbol, 'market_name', params);
                    // max 1501 candles, including the current candle when since is not specified
                    const maxLimit = 5000;
                    const defaultLimit = 1500;
                    limit = limit === undefined ? defaultLimit : Math.min(limit, maxLimit);
                    const request = {
                        'resolution': this.timeframes[timeframe],
                        'market_name': marketId,
                        // 'start_time': parseInt (since / 1000),
                        // 'end_time': this.seconds (),
                        'limit': limit
                    };
                    const price = this.safeString(params, 'price');
                    params = this.omit(params, 'price');
                    if (since !== undefined) {
                        const startTime = parseInt(since / 1000);
                        request['start_time'] = startTime;
                        const duration = this.parseTimeframe(timeframe);
                        const endTime = this.sum(startTime, limit * duration);
                        request['end_time'] = Math.min(endTime, this.seconds());
                        if (duration > 86400) {
                            const wholeDaysInTimeframe = parseInt(duration / 86400);
                            request['limit'] = Math.min(limit * wholeDaysInTimeframe, maxLimit);
                        }
                    }
                    let method = 'publicGetMarketsMarketNameCandles';
                    if (price === 'index') {
                        if (symbol in this.markets) request['market_name'] = market['baseId'];
                        method = 'publicGetIndexesMarketNameCandles';
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "result":[
                    //             {
                    //                 "close":177.23,
                    //                 "high":177.45,
                    //                 "low":177.2,
                    //                 "open":177.43,
                    //                 "startTime":"2019-10-17T13:27:00+00:00",
                    //                 "time":1571318820000.0,
                    //                 "volume":0.0
                    //             },
                    //             {
                    //                 "close":177.26,
                    //                 "high":177.33,
                    //                 "low":177.23,
                    //                 "open":177.23,
                    //                 "startTime":"2019-10-17T13:28:00+00:00",
                    //                 "time":1571318880000.0,
                    //                 "volume":0.0
                    //             },
                    //         ],
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseOHLCVs(result, market, timeframe, since, limit);
                }
                async fetchIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'index'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "id":1715826,
                    //         "liquidation":false,
                    //         "price":171.62,
                    //         "side":"buy",
                    //         "size":2.095,
                    //         "time":"2019-10-18T12:59:54.288166+00:00"
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "fee": 20.1374935,
                    //         "feeRate": 0.0005,
                    //         "feeCurrency": "USD",
                    //         "future": "EOS-0329",
                    //         "id": 11215,
                    //         "liquidity": "taker",
                    //         "market": "EOS-0329",
                    //         "baseCurrency": null,
                    //         "quoteCurrency": null,
                    //         "orderId": 8436981,
                    //         "price": 4.201,
                    //         "side": "buy",
                    //         "size": 9587,
                    //         "time": "2019-03-27T19:15:10.204619+00:00",
                    //         "type": "order"
                    //     }
                    //
                    //     {
                    //         "baseCurrency": "BTC",
                    //         "fee": 0,
                    //         "feeCurrency": "USD",
                    //         "feeRate": 0,
                    //         "future": null,
                    //         "id": 664079556,
                    //         "liquidity": "taker",
                    //         "market": null,
                    //         "orderId": null,
                    //         "price": 34830.61359,
                    //         "quoteCurrency": "USD",
                    //         "side": "sell",
                    //         "size": 0.0005996,
                    //         "time": "2021-01-15T16:05:29.246135+00:00",
                    //         "tradeId": null,
                    //         "type": "otc"
                    //     }
                    //
                    //     with -ve fee
                    //     {
                    //         "id": 1171258927,
                    //         "fee": -0.0000713875,
                    //         "side": "sell",
                    //         "size": 1,
                    //         "time": "2021-03-11T13:34:35.523627+00:00",
                    //         "type": "order",
                    //         "price": 14.2775,
                    //         "future": null,
                    //         "market": "SOL/USD",
                    //         "feeRate": -0.000005,
                    //         "orderId": 33182929044,
                    //         "tradeId": 582936801,
                    //         "liquidity": "maker",
                    //         "feeCurrency": "USD",
                    //         "baseCurrency": "SOL",
                    //         "quoteCurrency": "USD"
                    //     }
                    //
                    //     // from OTC order
                    //     {
                    //         "id": 1172129651,
                    //         "fee": 0,
                    //         "side": "sell",
                    //         "size": 1.47568846,
                    //         "time": "2021-03-11T15:04:46.893383+00:00",
                    //         "type": "otc",
                    //         "price": 14.60932598,
                    //         "future": null,
                    //         "market": null,
                    //         "feeRate": 0,
                    //         "orderId": null,
                    //         "tradeId": null,
                    //         "liquidity": "taker",
                    //         "feeCurrency": "USD",
                    //         "baseCurrency": "BCHA",
                    //         "quoteCurrency": "USD"
                    //     }
                    //
                    const id = this.safeString(trade, 'id');
                    const takerOrMaker = this.safeString(trade, 'liquidity');
                    // a workaround for the OTC trades, they don't have a symbol
                    const baseId = this.safeString(trade, 'baseCurrency');
                    const quoteId = this.safeString(trade, 'quoteCurrency');
                    let defaultMarketId = undefined;
                    if (baseId !== undefined && quoteId !== undefined) defaultMarketId = baseId + '/' + quoteId;
                    const marketId = this.safeString(trade, 'market', defaultMarketId);
                    market = this.safeMarket(marketId, market, '/');
                    const symbol = market['symbol'];
                    const timestamp = this.parse8601(this.safeString(trade, 'time'));
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'size');
                    const side = this.safeString(trade, 'side');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'feeCurrency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode,
                            'rate': this.safeString(trade, 'feeRate')
                        };
                    }
                    const orderId = this.safeString(trade, 'orderId');
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': orderId,
                        'type': undefined,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const [market, marketId] = this.getMarketParams(symbol, 'market_name', params);
                    const request = {
                        'market_name': marketId
                    };
                    if (since !== undefined) {
                        // the exchange aligns results to end_time returning 5000 trades max
                        // the user must set the end_time (in seconds) close enough to start_time
                        // for a proper pagination, fetch the most recent trades first
                        // then set the end_time parameter to the timestamp of the last trade
                        // start_time and end_time must be in seconds, divided by a thousand
                        request['start_time'] = parseInt(since / 1000);
                        // start_time doesn't work without end_time
                        request['end_time'] = this.seconds();
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetMarketsMarketNameTrades(this.extend(request, params));
                    //
                    //     {
                    //         "success":true,
                    //         "result":[
                    //             {
                    //                 "id":1715826,
                    //                 "liquidation":false,
                    //                 "price":171.62,
                    //                 "side":"buy",
                    //                 "size":2.095,
                    //                 "time":"2019-10-18T12:59:54.288166+00:00"
                    //             },
                    //             {
                    //                 "id":1715763,
                    //                 "liquidation":false,
                    //                 "price":171.89,
                    //                 "side":"sell",
                    //                 "size":1.477,
                    //                 "time":"2019-10-18T12:58:38.443734+00:00"
                    //             },
                    //         ],
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseTrades(result, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccount(params);
                    //
                    //     {
                    //         "success": true,
                    //         "result": {
                    //             "backstopProvider": true,
                    //             "collateral": 3568181.02691129,
                    //             "freeCollateral": 1786071.456884368,
                    //             "initialMarginRequirement": 0.12222384240257728,
                    //             "liquidating": false,
                    //             "maintenanceMarginRequirement": 0.07177992558058484,
                    //             "makerFee": 0.0002,
                    //             "marginFraction": 0.5588433331419503,
                    //             "openMarginFraction": 0.2447194090423075,
                    //             "takerFee": 0.0005,
                    //             "totalAccountValue": 3568180.98341129,
                    //             "totalPositionSize": 6384939.6992,
                    //             "username": "user@domain.com",
                    //             "positions": [
                    //                 {
                    //                     "cost": -31.7906,
                    //                     "entryPrice": 138.22,
                    //                     "future": "ETH-PERP",
                    //                     "initialMarginRequirement": 0.1,
                    //                     "longOrderSize": 1744.55,
                    //                     "maintenanceMarginRequirement": 0.04,
                    //                     "netSize": -0.23,
                    //                     "openSize": 1744.32,
                    //                     "realizedPnl": 3.39441714,
                    //                     "shortOrderSize": 1732.09,
                    //                     "side": "sell",
                    //                     "size": 0.23,
                    //                     "unrealizedPnl": 0,
                    //                 },
                    //             ],
                    //         },
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const maker = this.safeNumber(result, 'makerFee');
                    const taker = this.safeNumber(result, 'takerFee');
                    const tradingFees = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        tradingFees[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return tradingFees;
                }
                async fetchFundingRateHistory(symbol, since, limit, params = {}) {
                    //
                    // Gets a history of funding rates with their timestamps
                    //  (param) symbol: Future currency pair (e.g. "BTC-PERP")
                    //  (param) limit: Not used by ftx
                    //  (param) since: Unix timestamp in miliseconds for the time of the earliest requested funding rate
                    //  (param) params: Object containing more params for the request
                    //             - until: Unix timestamp in miliseconds for the time of the earliest requested funding rate
                    //  return: [{symbol, fundingRate, timestamp}]
                    //
                    await this.loadMarkets();
                    const request = {};
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        symbol = market['symbol'];
                        request['future'] = market['id'];
                    }
                    if (since !== undefined) request['start_time'] = parseInt(since / 1000);
                    const till = this.safeInteger(params, 'till'); // unified in milliseconds
                    const endTime = this.safeString(params, 'end_time'); // exchange-specific in seconds
                    params = this.omit(params, [
                        'end_time',
                        'till'
                    ]);
                    if (till !== undefined) request['end_time'] = parseInt(till / 1000);
                    else if (endTime !== undefined) request['end_time'] = endTime;
                    const response = await this.publicGetFundingRates(this.extend(request, params));
                    //
                    //     {
                    //        "success": true,
                    //        "result": [
                    //          {
                    //            "future": "BTC-PERP",
                    //            "rate": 0.0025,
                    //            "time": "2019-06-02T08:00:00+00:00"
                    //          }
                    //        ]
                    //      }
                    //
                    const result = this.safeValue(response, 'result');
                    const rates = [];
                    for(let i = 0; i < result.length; i++){
                        const entry = result[i];
                        const marketId = this.safeString(entry, 'future');
                        const timestamp = this.parse8601(this.safeString(result[i], 'time'));
                        rates.push({
                            'info': entry,
                            'symbol': this.safeSymbol(marketId),
                            'fundingRate': this.safeNumber(entry, 'rate'),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp)
                        });
                    }
                    const sorted = this.sortBy(rates, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, symbol, since, limit);
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const balances = this.safeValue(response, 'result', []);
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const code = this.safeCurrencyCode(this.safeString(balance, 'coin'));
                        const account = this.account();
                        account['free'] = this.safeString2(balance, 'availableWithoutBorrow', 'free');
                        account['total'] = this.safeString(balance, 'total');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetWalletBalances(params);
                    //
                    //     {
                    //         "success": true,
                    //         "result": [
                    //             {
                    //                 "coin": "USDTBEAR",
                    //                 "free": 2320.2,
                    //                 "total": 2340.2
                    //             },
                    //         ],
                    //     }
                    //
                    return this.parseBalance(response);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'new': 'open',
                        'open': 'open',
                        'closed': 'closed',
                        'triggered': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // limit orders - fetchOrder, fetchOrders, fetchOpenOrders, createOrder, editOrder
                    //
                    //     {
                    //         "createdAt": "2019-03-05T09:56:55.728933+00:00",
                    //         "filledSize": 0,
                    //         "future": "XRP-PERP",
                    //         "id": 9596912,
                    //         "market": "XRP-PERP",
                    //         "price": 0.306525,
                    //         "remainingSize": 31431,
                    //         "side": "sell",
                    //         "size": 31431,
                    //         "status": "open",
                    //         "type": "limit",
                    //         "reduceOnly": false,
                    //         "ioc": false,
                    //         "postOnly": false,
                    //         "clientId": null,
                    //     }
                    //
                    // market orders - fetchOrder, fetchOrders, fetchOpenOrders, createOrder
                    //
                    //     {
                    //         "avgFillPrice": 2666.0,
                    //         "clientId": None,
                    //         "createdAt": "2020-02-12T00: 53: 49.009726+00: 00",
                    //         "filledSize": 0.0007,
                    //         "future": None,
                    //         "id": 3109208514,
                    //         "ioc": True,
                    //         "market": "BNBBULL/USD",
                    //         "postOnly": False,
                    //         "price": None,
                    //         "reduceOnly": False,
                    //         "remainingSize": 0.0,
                    //         "side": "buy",
                    //         "size": 0.0007,
                    //         "status": "closed",
                    //         "type": "market"
                    //     }
                    //
                    // createOrder (conditional, "stop", "trailingStop", or "takeProfit")
                    //
                    //     {
                    //         "createdAt": "2019-03-05T09:56:55.728933+00:00",
                    //         "future": "XRP-PERP",
                    //         "id": 9596912,
                    //         "market": "XRP-PERP",
                    //         "triggerPrice": 0.306525,
                    //         "orderId": null,
                    //         "side": "sell",
                    //         "size": 31431,
                    //         "status": "open",
                    //         "type": "stop",
                    //         "orderPrice": null,
                    //         "error": null,
                    //         "triggeredAt": null,
                    //         "reduceOnly": false
                    //     }
                    //
                    // editOrder (conditional, stop, trailing stop, take profit)
                    //
                    //     {
                    //         "createdAt": "2019-03-05T09:56:55.728933+00:00",
                    //         "future": "XRP-PERP",
                    //         "id": 9596912,
                    //         "market": "XRP-PERP",
                    //         "triggerPrice": 0.306225,
                    //         "orderId": null,
                    //         "side": "sell",
                    //         "size": 31431,
                    //         "status": "open",
                    //         "type": "stop",
                    //         "orderPrice": null,
                    //         "error": null,
                    //         "triggeredAt": null,
                    //         "reduceOnly": false,
                    //         "orderType": "market",
                    //         "filledSize": 0,
                    //         "avgFillPrice": null,
                    //         "retryUntilFilled": false
                    //     }
                    //
                    // canceled order with a closed status
                    //
                    //     {
                    //         "avgFillPrice":null,
                    //         "clientId":null,
                    //         "createdAt":"2020-09-01T13:45:57.119695+00:00",
                    //         "filledSize":0.0,
                    //         "future":null,
                    //         "id":8553541288,
                    //         "ioc":false,
                    //         "liquidation":false,
                    //         "market":"XRP/USDT",
                    //         "postOnly":false,
                    //         "price":0.5,
                    //         "reduceOnly":false,
                    //         "remainingSize":0.0,
                    //         "side":"sell",
                    //         "size":46.0,
                    //         "status":"closed",
                    //         "type":"limit"
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const timestamp = this.parse8601(this.safeString(order, 'createdAt'));
                    let status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const amount = this.safeString(order, 'size');
                    const filled = this.safeString(order, 'filledSize');
                    let remaining = this.safeString(order, 'remainingSize');
                    if (Precise.stringEquals(remaining, '0')) {
                        remaining = Precise.stringSub(amount, filled);
                        if (Precise.stringGt(remaining, '0')) status = 'canceled';
                    }
                    const marketId = this.safeString(order, 'market');
                    market = this.safeMarket(marketId, market);
                    let symbol = market['symbol'];
                    if (symbol === undefined) // support for delisted market ids
                    // https://github.com/ccxt/ccxt/issues/7113
                    symbol = marketId;
                    const side = this.safeString(order, 'side');
                    const type = this.safeString(order, 'type');
                    const average = this.safeString(order, 'avgFillPrice');
                    const price = this.safeString2(order, 'price', 'triggerPrice', average);
                    const lastTradeTimestamp = this.parse8601(this.safeString(order, 'triggeredAt'));
                    const clientOrderId = this.safeString(order, 'clientId');
                    const stopPrice = this.safeNumber(order, 'triggerPrice');
                    const postOnly = this.safeValue(order, 'postOnly');
                    const ioc = this.safeValue(order, 'ioc');
                    let timeInForce = undefined;
                    if (ioc) timeInForce = 'IOC';
                    if (postOnly) timeInForce = 'PO';
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': undefined,
                        'average': average,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'side': side,
                        // 'price': 0.306525, // send null for market orders
                        'type': type,
                        'size': parseFloat(this.amountToPrecision(symbol, amount))
                    };
                    const clientOrderId = this.safeString2(params, 'clientId', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['clientId'] = clientOrderId;
                        params = this.omit(params, [
                            'clientId',
                            'clientOrderId'
                        ]);
                    }
                    let method = undefined;
                    const stopPrice = this.safeValue2(params, 'stopPrice', 'triggerPrice');
                    params = this.omit(params, [
                        'stopPrice',
                        'triggerPrice'
                    ]);
                    if ((type === 'limit' || type === 'market') && stopPrice === undefined) {
                        method = 'privatePostOrders';
                        if (type === 'limit') request['price'] = parseFloat(this.priceToPrecision(symbol, price));
                        else if (type === 'market') request['price'] = null;
                        const timeInForce = this.safeString(params, 'timeInForce');
                        const postOnly = this.safeValue(params, 'postOnly', false);
                        params = this.omit(params, [
                            'timeInForce',
                            'postOnly'
                        ]);
                        if (timeInForce !== undefined) {
                            if (!(timeInForce === 'IOC' || timeInForce === 'PO')) throw new InvalidOrder(this.id + ' createOrder () does not accept timeInForce: ' + timeInForce + ' orders, only IOC and PO orders are allowed');
                        }
                        const maker = timeInForce === 'PO' || postOnly;
                        if (type === 'market' && maker) throw new InvalidOrder(this.id + ' createOrder () does not accept postOnly: true or timeInForce: PO for market orders');
                        const ioc = timeInForce === 'IOC';
                        if (maker) request['postOnly'] = true;
                        if (ioc) request['ioc'] = true;
                    } else if (type === 'stop' || type === 'takeProfit' || stopPrice !== undefined) {
                        method = 'privatePostConditionalOrders';
                        if (stopPrice === undefined) throw new ArgumentsRequired1(this.id + ' createOrder () requires a stopPrice parameter or a triggerPrice parameter for ' + type + ' orders');
                        else request['triggerPrice'] = parseFloat(this.priceToPrecision(symbol, stopPrice));
                        if (type === 'limit' && price === undefined) throw new ArgumentsRequired1(this.id + ' createOrder () requires a price argument for stop limit orders');
                        if (price !== undefined) request['orderPrice'] = parseFloat(this.priceToPrecision(symbol, price)); // optional, order type is limit if this is specified, otherwise market
                        if (type === 'limit' || type === 'market') // default to stop orders for main argument
                        request['type'] = 'stop';
                    } else if (type === 'trailingStop') {
                        const trailValue = this.safeNumber(params, 'trailValue', price);
                        if (trailValue === undefined) throw new ArgumentsRequired1(this.id + ' createOrder () requires a trailValue parameter or a price argument (negative or positive) for a ' + type + ' order');
                        method = 'privatePostConditionalOrders';
                        request['trailValue'] = parseFloat(this.priceToPrecision(symbol, trailValue)); // negative for "sell", positive for "buy"
                    } else throw new InvalidOrder(this.id + ' createOrder () does not support order type ' + type + ', only limit, market, stop, trailingStop, or takeProfit orders are supported');
                    const response = await this[method](this.extend(request, params));
                    //
                    // orders
                    //
                    //     {
                    //         "success": true,
                    //         "result": [
                    //             {
                    //                 "createdAt": "2019-03-05T09:56:55.728933+00:00",
                    //                 "filledSize": 0,
                    //                 "future": "XRP-PERP",
                    //                 "id": 9596912,
                    //                 "market": "XRP-PERP",
                    //                 "price": 0.306525,
                    //                 "remainingSize": 31431,
                    //                 "side": "sell",
                    //                 "size": 31431,
                    //                 "status": "open",
                    //                 "type": "limit",
                    //                 "reduceOnly": false,
                    //                 "ioc": false,
                    //                 "postOnly": false,
                    //                 "clientId": null,
                    //             }
                    //         ]
                    //     }
                    //
                    // conditional orders
                    //
                    //     {
                    //         "success": true,
                    //         "result": [
                    //             {
                    //                 "createdAt": "2019-03-05T09:56:55.728933+00:00",
                    //                 "future": "XRP-PERP",
                    //                 "id": 9596912,
                    //                 "market": "XRP-PERP",
                    //                 "triggerPrice": 0.306525,
                    //                 "orderId": null,
                    //                 "side": "sell",
                    //                 "size": 31431,
                    //                 "status": "open",
                    //                 "type": "stop",
                    //                 "orderPrice": null,
                    //                 "error": null,
                    //                 "triggeredAt": null,
                    //                 "reduceOnly": false
                    //             }
                    //         ]
                    //     }
                    //
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseOrder(result, market);
                }
                async createReduceOnlyOrder(symbol, type, side, amount, price, params = {}) {
                    const request = {
                        'reduceOnly': true
                    };
                    return await this.createOrder(symbol, type, side, amount, price, this.extend(request, params));
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {};
                    let method = undefined;
                    const clientOrderId = this.safeString2(params, 'client_order_id', 'clientOrderId');
                    const triggerPrice = this.safeNumber(params, 'triggerPrice');
                    const orderPrice = this.safeNumber(params, 'orderPrice');
                    const trailValue = this.safeNumber(params, 'trailValue');
                    params = this.omit(params, [
                        'client_order_id',
                        'clientOrderId',
                        'triggerPrice',
                        'orderPrice',
                        'trailValue'
                    ]);
                    const triggerPriceIsDefined = triggerPrice !== undefined;
                    const orderPriceIsDefined = orderPrice !== undefined;
                    const trailValueIsDefined = trailValue !== undefined;
                    if (triggerPriceIsDefined || orderPriceIsDefined || trailValueIsDefined) {
                        method = 'privatePostConditionalOrdersOrderIdModify';
                        request['order_id'] = id;
                        if (triggerPriceIsDefined) request['triggerPrice'] = parseFloat(this.priceToPrecision(symbol, triggerPrice));
                        if (orderPriceIsDefined) // only for stop limit or take profit limit orders
                        request['orderPrice'] = parseFloat(this.priceToPrecision(symbol, orderPrice));
                        if (trailValueIsDefined) // negative for sell orders, positive for buy orders
                        request['trailValue'] = parseFloat(this.priceToPrecision(symbol, trailValue));
                    } else {
                        if (clientOrderId === undefined) {
                            method = 'privatePostOrdersOrderIdModify';
                            request['order_id'] = id;
                        } else {
                            method = 'privatePostOrdersByClientIdClientOrderIdModify';
                            request['client_order_id'] = clientOrderId;
                        // request['clientId'] = clientOrderId;
                        }
                        if (price !== undefined) request['price'] = parseFloat(this.priceToPrecision(symbol, price));
                    }
                    if (amount !== undefined) request['size'] = parseFloat(this.amountToPrecision(symbol, amount));
                    const response = await this[method](this.extend(request, params));
                    //
                    // regular order
                    //
                    //     {
                    //         "success": true,
                    //         "result": {
                    //             "createdAt": "2019-03-05T11:56:55.728933+00:00",
                    //             "filledSize": 0,
                    //             "future": "XRP-PERP",
                    //             "id": 9596932,
                    //             "market": "XRP-PERP",
                    //             "price": 0.326525,
                    //             "remainingSize": 31431,
                    //             "side": "sell",
                    //             "size": 31431,
                    //             "status": "open",
                    //             "type": "limit",
                    //             "reduceOnly": false,
                    //             "ioc": false,
                    //             "postOnly": false,
                    //             "clientId": null,
                    //         }
                    //     }
                    //
                    // conditional trigger order
                    //
                    //     {
                    //         "success": true,
                    //         "result": {
                    //             "createdAt": "2019-03-05T09:56:55.728933+00:00",
                    //             "future": "XRP-PERP",
                    //             "id": 9596912,
                    //             "market": "XRP-PERP",
                    //             "triggerPrice": 0.306225,
                    //             "orderId": null,
                    //             "side": "sell",
                    //             "size": 31431,
                    //             "status": "open",
                    //             "type": "stop",
                    //             "orderPrice": null,
                    //             "error": null,
                    //             "triggeredAt": null,
                    //             "reduceOnly": false,
                    //             "orderType": "market",
                    //             "filledSize": 0,
                    //             "avgFillPrice": null,
                    //             "retryUntilFilled": false
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseOrder(result, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    // support for canceling conditional orders
                    // https://github.com/ccxt/ccxt/issues/6669
                    const options = this.safeValue(this.options, 'cancelOrder', {});
                    const defaultMethod = this.safeString(options, 'method', 'privateDeleteOrdersOrderId');
                    let method = this.safeString(params, 'method', defaultMethod);
                    const type = this.safeValue(params, 'type');
                    const clientOrderId = this.safeValue2(params, 'client_order_id', 'clientOrderId');
                    if (clientOrderId === undefined) {
                        request['order_id'] = parseInt(id);
                        if (type === 'stop' || type === 'trailingStop' || type === 'takeProfit') method = 'privateDeleteConditionalOrdersOrderId';
                    } else {
                        request['client_order_id'] = clientOrderId;
                        method = 'privateDeleteOrdersByClientIdClientOrderId';
                    }
                    const query = this.omit(params, [
                        'method',
                        'type',
                        'client_order_id',
                        'clientOrderId'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //         "success": true,
                    //         "result": "Order queued for cancelation"
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return result;
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    const marketId = this.getMarketId(symbol, 'market', params);
                    if (marketId !== undefined) request['market'] = marketId;
                    const response = await this.privateDeleteOrders(this.extend(request, params));
                    const result = this.safeValue(response, 'result', {});
                    //
                    //     {
                    //         "success": true,
                    //         "result": "Orders queued for cancelation"
                    //     }
                    //
                    return result;
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    const clientOrderId = this.safeValue2(params, 'client_order_id', 'clientOrderId');
                    let method = 'privateGetOrdersOrderId';
                    if (clientOrderId === undefined) request['order_id'] = id;
                    else {
                        request['client_order_id'] = clientOrderId;
                        params = this.omit(params, [
                            'client_order_id',
                            'clientOrderId'
                        ]);
                        method = 'privateGetOrdersByClientIdClientOrderId';
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "result": {
                    //             "createdAt": "2019-03-05T09:56:55.728933+00:00",
                    //             "filledSize": 10,
                    //             "future": "XRP-PERP",
                    //             "id": 9596912,
                    //             "market": "XRP-PERP",
                    //             "price": 0.306525,
                    //             "avgFillPrice": 0.306526,
                    //             "remainingSize": 31421,
                    //             "side": "sell",
                    //             "size": 31431,
                    //             "status": "open",
                    //             "type": "limit",
                    //             "reduceOnly": false,
                    //             "ioc": false,
                    //             "postOnly": false,
                    //             "clientId": null
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseOrder(result);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    const [market, marketId] = this.getMarketParams(symbol, 'market', params);
                    if (marketId !== undefined) request['market'] = marketId;
                    // support for canceling conditional orders
                    // https://github.com/ccxt/ccxt/issues/6669
                    const options = this.safeValue(this.options, 'fetchOpenOrders', {});
                    const defaultMethod = this.safeString(options, 'method', 'privateGetOrders');
                    let method = this.safeString(params, 'method', defaultMethod);
                    const type = this.safeValue(params, 'type');
                    const stop = this.safeValue(params, 'stop');
                    if (stop || type === 'stop' || type === 'trailingStop' || type === 'takeProfit') method = 'privateGetConditionalOrders';
                    const query = this.omit(params, [
                        'method',
                        'type',
                        'stop'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //         "success": true,
                    //         "result": [
                    //             {
                    //                 "createdAt": "2019-03-05T09:56:55.728933+00:00",
                    //                 "filledSize": 10,
                    //                 "future": "XRP-PERP",
                    //                 "id": 9596912,
                    //                 "market": "XRP-PERP",
                    //                 "price": 0.306525,
                    //                 "avgFillPrice": 0.306526,
                    //                 "remainingSize": 31421,
                    //                 "side": "sell",
                    //                 "size": 31431,
                    //                 "status": "open",
                    //                 "type": "limit",
                    //                 "reduceOnly": false,
                    //                 "ioc": false,
                    //                 "postOnly": false,
                    //                 "clientId": null
                    //             }
                    //         ]
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseOrders(result, market, since, limit);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    const [market, marketId] = this.getMarketParams(symbol, 'market', params);
                    if (marketId !== undefined) request['market'] = marketId;
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 100
                    if (since !== undefined) request['start_time'] = parseInt(since / 1000);
                    // support for canceling conditional orders
                    // https://github.com/ccxt/ccxt/issues/6669
                    const options = this.safeValue(this.options, 'fetchOrders', {});
                    const defaultMethod = this.safeString(options, 'method', 'privateGetOrdersHistory');
                    let method = this.safeString(params, 'method', defaultMethod);
                    const type = this.safeValue(params, 'type');
                    if (type === 'stop' || type === 'trailingStop' || type === 'takeProfit') method = 'privateGetConditionalOrdersHistory';
                    const query = this.omit(params, [
                        'method',
                        'type'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //         "success": true,
                    //         "result": [
                    //             {
                    //                 "createdAt": "2019-03-05T09:56:55.728933+00:00",
                    //                 "filledSize": 10,
                    //                 "future": "XRP-PERP",
                    //                 "id": 9596912,
                    //                 "market": "XRP-PERP",
                    //                 "price": 0.306525,
                    //                 "avgFillPrice": 0.306526,
                    //                 "remainingSize": 31421,
                    //                 "side": "sell",
                    //                 "size": 31431,
                    //                 "status": "open",
                    //                 "type": "limit",
                    //                 "reduceOnly": false,
                    //                 "ioc": false,
                    //                 "postOnly": false,
                    //                 "clientId": null
                    //             }
                    //         ]
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseOrders(result, market, since, limit);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    const request = {
                        'orderId': id
                    };
                    return await this.fetchMyTrades(symbol, since, limit, this.extend(request, params));
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const [market, marketId] = this.getMarketParams(symbol, 'market', params);
                    const request = {};
                    if (marketId !== undefined) request['market'] = marketId;
                    if (since !== undefined) {
                        request['start_time'] = parseInt(since / 1000);
                        request['end_time'] = this.seconds();
                    }
                    const response = await this.privateGetFills(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "result": [
                    //             {
                    //                 "fee": 20.1374935,
                    //                 "feeRate": 0.0005,
                    //                 "future": "EOS-0329",
                    //                 "id": 11215,
                    //                 "liquidity": "taker",
                    //                 "market": "EOS-0329",
                    //                 "baseCurrency": null,
                    //                 "quoteCurrency": null,
                    //                 "orderId": 8436981,
                    //                 "price": 4.201,
                    //                 "side": "buy",
                    //                 "size": 9587,
                    //                 "time": "2019-03-27T19:15:10.204619+00:00",
                    //                 "type": "order"
                    //             }
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, 'result', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin': currency['id'],
                        'source': fromAccount,
                        'destination': toAccount,
                        'size': amount
                    };
                    const response = await this.privatePostSubaccountsTransfer(this.extend(request, params));
                    //
                    //     {
                    //         success: true,
                    //         result: {
                    //             id: '31222278',
                    //             coin: 'USDT',
                    //             size: '1.0',
                    //             time: '2022-04-01T11:18:27.194188+00:00',
                    //             notes: 'Transfer from main account to testSubaccount',
                    //             status: 'complete'
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseTransfer(result, currency);
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //         id: '31222278',
                    //         coin: 'USDT',
                    //         size: '1.0',
                    //         time: '2022-04-01T11:18:27.194188+00:00',
                    //         notes: 'Transfer from main account to testSubaccount',
                    //         status: 'complete'
                    //     }
                    //
                    const currencyId = this.safeString(transfer, 'coin');
                    const notes = this.safeString(transfer, 'notes', '');
                    const status = this.safeString(transfer, 'status');
                    const fromTo = notes.replace('Transfer from ', '');
                    const parts = fromTo.split(' to ');
                    let fromAccount = this.safeString(parts, 0);
                    fromAccount = fromAccount.replace(' account', '');
                    let toAccount = this.safeString(parts, 1);
                    toAccount = toAccount.replace(' account', '');
                    return {
                        'info': transfer,
                        'id': this.safeString(transfer, 'id'),
                        'timestamp': undefined,
                        'datetime': this.safeString(transfer, 'time'),
                        'currency': this.safeCurrencyCode(currencyId, currency),
                        'amount': this.safeNumber(transfer, 'size'),
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'status': this.parseTransferStatus(status)
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'complete': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    this.checkAddress(address);
                    const currency = this.currency(code);
                    const request = {
                        'coin': currency['id'],
                        'size': amount,
                        'address': address
                    };
                    if (this.password !== undefined) request['password'] = this.password;
                    if (tag !== undefined) request['tag'] = tag;
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeStringLower(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['method'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privatePostWalletWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "result": {
                    //             "coin": "USDTBEAR",
                    //             "address": "0x83a127952d266A6eA306c40Ac62A4a70668FE3BE",
                    //             "tag": "null",
                    //             "fee": 0,
                    //             "id": 1,
                    //             "size": "20.2",
                    //             "status": "requested",
                    //             "time": "2019-03-05T09:56:55.728933+00:00",
                    //             "txid": "null"
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseTransaction(result, currency);
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'showAvgPrice': true
                    };
                    const response = await this.privateGetPositions(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "result": [
                    //             {
                    //                 "cost": -31.7906,
                    //                 "entryPrice": 138.22,
                    //                 "estimatedLiquidationPrice": 152.1,
                    //                 "future": "ETH-PERP",
                    //                 "initialMarginRequirement": 0.1,
                    //                 "longOrderSize": 1744.55,
                    //                 "maintenanceMarginRequirement": 0.04,
                    //                 "netSize": -0.23,
                    //                 "openSize": 1744.32,
                    //                 "realizedPnl": 3.39441714,
                    //                 "shortOrderSize": 1732.09,
                    //                 "recentAverageOpenPrice": 278.98,
                    //                 "recentPnl": 2.44,
                    //                 "recentBreakEvenPrice": 278.98,
                    //                 "side": "sell",
                    //                 "size": 0.23,
                    //                 "unrealizedPnl": 0,
                    //                 "collateralUsed": 3.17906
                    //             }
                    //         ]
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    const results = [];
                    for(let i = 0; i < result.length; i++)results.push(this.parsePosition(result[i]));
                    return this.filterByArray(results, 'symbol', symbols, false);
                }
                parsePosition(position, market) {
                    //
                    //   {
                    //     "future": "XMR-PERP",
                    //     "size": "0.0",
                    //     "side": "buy",
                    //     "netSize": "0.0",
                    //     "longOrderSize": "0.0",
                    //     "shortOrderSize": "0.0",
                    //     "cost": "0.0",
                    //     "entryPrice": null,
                    //     "unrealizedPnl": "0.0",
                    //     "realizedPnl": "0.0",
                    //     "initialMarginRequirement": "0.02",
                    //     "maintenanceMarginRequirement": "0.006",
                    //     "openSize": "0.0",
                    //     "collateralUsed": "0.0",
                    //     "estimatedLiquidationPrice": null
                    //   }
                    //
                    const contractsString = this.safeString(position, 'size');
                    const rawSide = this.safeString(position, 'side');
                    const side = rawSide === 'buy' ? 'long' : 'short';
                    const marketId = this.safeString(position, 'future');
                    const symbol = this.safeSymbol(marketId, market);
                    const liquidationPriceString = this.safeString(position, 'estimatedLiquidationPrice');
                    const initialMarginPercentage = this.safeString(position, 'initialMarginRequirement');
                    const leverage = parseInt(Precise.stringDiv('1', initialMarginPercentage, 0));
                    // on ftx the entryPrice is actually the mark price
                    const markPriceString = this.safeString(position, 'entryPrice');
                    const notionalString = Precise.stringMul(contractsString, markPriceString);
                    const initialMargin = Precise.stringMul(notionalString, initialMarginPercentage);
                    const maintenanceMarginPercentageString = this.safeString(position, 'maintenanceMarginRequirement');
                    const maintenanceMarginString = Precise.stringMul(notionalString, maintenanceMarginPercentageString);
                    const unrealizedPnlString = this.safeString(position, 'recentPnl');
                    const percentage = this.parseNumber(Precise.stringMul(Precise.stringDiv(unrealizedPnlString, initialMargin, 4), '100'));
                    const entryPriceString = this.safeString(position, 'recentAverageOpenPrice');
                    let difference = undefined;
                    let collateral = undefined;
                    let marginRatio = undefined;
                    if (entryPriceString !== undefined && Precise.stringGt(liquidationPriceString, '0')) {
                        // collateral = maintenanceMargin ± ((markPrice - liquidationPrice) * size)
                        if (side === 'long') difference = Precise.stringSub(markPriceString, liquidationPriceString);
                        else difference = Precise.stringSub(liquidationPriceString, markPriceString);
                        const loss = Precise.stringMul(difference, contractsString);
                        collateral = Precise.stringAdd(loss, maintenanceMarginString);
                        marginRatio = this.parseNumber(Precise.stringDiv(maintenanceMarginString, collateral, 4));
                    }
                    // ftx has a weird definition of realizedPnl
                    // it keeps the historical record of the realizedPnl per contract forever
                    // so we cannot use this data
                    return {
                        'info': position,
                        'symbol': symbol,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'initialMargin': this.parseNumber(initialMargin),
                        'initialMarginPercentage': this.parseNumber(initialMarginPercentage),
                        'maintenanceMargin': this.parseNumber(maintenanceMarginString),
                        'maintenanceMarginPercentage': this.parseNumber(maintenanceMarginPercentageString),
                        'entryPrice': this.parseNumber(entryPriceString),
                        'notional': this.parseNumber(notionalString),
                        'leverage': leverage,
                        'unrealizedPnl': this.parseNumber(unrealizedPnlString),
                        'contracts': this.parseNumber(contractsString),
                        'contractSize': this.safeValue(market, 'contractSize'),
                        'marginRatio': marginRatio,
                        'liquidationPrice': this.parseNumber(liquidationPriceString),
                        'markPrice': this.parseNumber(markPriceString),
                        'collateral': this.parseNumber(collateral),
                        'marginMode': 'cross',
                        'marginType': 'cross',
                        'side': side,
                        'percentage': percentage
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin': currency['id']
                    };
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeStringLower(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['method'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privateGetWalletDepositAddressCoin(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "result": {
                    //             "address": "0x83a127952d266A6eA306c40Ac62A4a70668FE3BE",
                    //             "tag": null,
                    //             "method": "erc20",
                    //             "coin": null
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const networkId = this.safeString(result, 'method');
                    const address = this.safeString(result, 'address');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': this.safeString(result, 'tag'),
                        'network': this.safeNetwork(networkId),
                        'info': response
                    };
                }
                safeNetwork(networkId) {
                    const networksById = {
                        'trx': 'TRC20',
                        'erc20': 'ERC20',
                        'sol': 'SOL',
                        'bsc': 'BEP20',
                        'bep2': 'BEP2'
                    };
                    return this.safeString(networksById, networkId, networkId);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        // what are other statuses here?
                        'confirmed': 'ok',
                        'complete': 'ok',
                        'cancelled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     airdrop
                    //
                    //     {
                    //         "id": 9147072,
                    //         "coin": "SRM_LOCKED",
                    //         "size": 3.12,
                    //         "time": "2021-04-27T23:59:03.565983+00:00",
                    //         "notes": "SRM Airdrop for FTT holdings",
                    //         "status": "complete"
                    //     }
                    //
                    //     regular deposits
                    //
                    //     {
                    //         "coin": "TUSD",
                    //         "confirmations": 64,
                    //         "confirmedTime": "2019-03-05T09:56:55.728933+00:00",
                    //         "fee": 0,
                    //         "id": 1,
                    //         "sentTime": "2019-03-05T09:56:55.735929+00:00",
                    //         "size": "99.0",
                    //         "status": "confirmed",
                    //         "time": "2019-03-05T09:56:55.728933+00:00",
                    //         "txid": "0x8078356ae4b06a036d64747546c274af19581f1c78c510b60505798a7ffcaf1"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "coin": "TUSD",
                    //         "address": "0x83a127952d266A6eA306c40Ac62A4a70668FE3BE",
                    //         "tag": "null",
                    //         "fee": 0,
                    //         "id": 1,
                    //         "size": "99.0",
                    //         "status": "complete",
                    //         "time": "2019-03-05T09:56:55.728933+00:00",
                    //         "txid": "0x8078356ae4b06a036d64747546c274af19581f1c78c510b60505798a7ffcaf1"
                    //     }
                    //
                    //     {
                    //         "coin": 'BTC',
                    //         "id": 1969806,
                    //         "notes": 'Transfer to Dd6gi7m2Eg4zzBbPAxuwfEaHs6tYvyUX5hbPpsTcNPXo',
                    //         "size": 0.003,
                    //         "status": 'complete',
                    //         "time": '2021-02-03T20:28:54.918146+00:00'
                    //     }
                    //
                    const code = this.safeCurrencyCode(this.safeString(transaction, 'coin'));
                    const id = this.safeString(transaction, 'id');
                    const amount = this.safeNumber(transaction, 'size');
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const timestamp = this.parse8601(this.safeString(transaction, 'time'));
                    const txid = this.safeString(transaction, 'txid');
                    let tag = undefined;
                    let address = this.safeValue(transaction, 'address');
                    if (typeof address !== 'string') {
                        tag = this.safeString(address, 'tag');
                        address = this.safeString(address, 'address');
                    }
                    if (address === undefined) {
                        // parse address from internal transfer
                        const notes = this.safeString(transaction, 'notes');
                        if (notes !== undefined && notes.indexOf('Transfer to') >= 0) address = notes.slice(12);
                    }
                    const fee = this.safeNumber(transaction, 'fee');
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': address,
                        'addressTo': address,
                        'tagFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'type': undefined,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'fee': {
                            'currency': code,
                            'cost': fee,
                            'rate': undefined
                        }
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetWalletDeposits(params);
                    //
                    //     {
                    //         "success": true,
                    //         "result": {
                    //             "coin": "TUSD",
                    //             "confirmations": 64,
                    //             "confirmedTime": "2019-03-05T09:56:55.728933+00:00",
                    //             "fee": 0,
                    //             "id": 1,
                    //             "sentTime": "2019-03-05T09:56:55.735929+00:00",
                    //             "size": "99.0",
                    //             "status": "confirmed",
                    //             "time": "2019-03-05T09:56:55.728933+00:00",
                    //             "txid": "0x8078356ae4b06a036d64747546c274af19581f1c78c510b60505798a7ffcaf1"
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    return this.parseTransactions(result, currency, since, limit, {
                        'type': 'deposit'
                    });
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetWalletWithdrawals(params);
                    //
                    //     {
                    //         "success": true,
                    //         "result": {
                    //             "coin": "TUSD",
                    //             "address": "0x83a127952d266A6eA306c40Ac62A4a70668FE3BE",
                    //             "tag": "null",
                    //             "fee": 0,
                    //             "id": 1,
                    //             "size": "99.0",
                    //             "status": "complete",
                    //             "time": "2019-03-05T09:56:55.728933+00:00",
                    //             "txid": "0x8078356ae4b06a036d64747546c274af19581f1c78c510b60505798a7ffcaf1"
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    return this.parseTransactions(result, currency, since, limit, {
                        'type': 'withdrawal'
                    });
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let request = '/api/' + this.implodeParams(path, params);
                    const signOptions = this.safeValue(this.options, 'sign', {});
                    const headerPrefix = this.safeString(signOptions, this.hostname, 'FTX');
                    const subaccountField = headerPrefix + '-SUBACCOUNT';
                    const chosenSubaccount = this.safeString2(params, subaccountField, 'subaccount');
                    if (chosenSubaccount !== undefined) params = this.omit(params, [
                        subaccountField,
                        'subaccount'
                    ]);
                    const query = this.omit(params, this.extractParams(path));
                    const baseUrl = this.implodeHostname(this.urls['api'][api]);
                    let url = baseUrl + request;
                    if (method !== 'POST') {
                        if (Object.keys(query).length) {
                            const suffix = '?' + this.urlencode(query);
                            url += suffix;
                            request += suffix;
                        }
                    }
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.milliseconds().toString();
                        let auth = timestamp + method + request;
                        headers = {};
                        if (method === 'POST' || method === 'DELETE') {
                            body = this.json(query);
                            auth += body;
                            headers['Content-Type'] = 'application/json';
                        }
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha256');
                        headers[headerPrefix + '-KEY'] = this.apiKey;
                        headers[headerPrefix + '-TS'] = timestamp;
                        headers[headerPrefix + '-SIGN'] = signature;
                        if (chosenSubaccount !== undefined) headers[subaccountField] = chosenSubaccount;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to the default error handler
                    //
                    //     {"error":"Invalid parameter start_time","success":false}
                    //     {"error":"Not enough balances","success":false}
                    //
                    const success = this.safeValue(response, 'success');
                    if (!success) {
                        const feedback = this.id + ' ' + body;
                        const error = this.safeString(response, 'error');
                        this.throwExactlyMatchedException(this.exceptions['exact'], error, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], error, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
                async setLeverage(leverage, symbol, params = {}) {
                    // WARNING: THIS WILL INCREASE LIQUIDATION PRICE FOR OPEN ISOLATED LONG POSITIONS
                    // AND DECREASE LIQUIDATION PRICE FOR OPEN ISOLATED SHORT POSITIONS
                    if (leverage < 1 || leverage > 20) throw new BadRequest(this.id + ' setLeverage () leverage should be between 1 and 20');
                    const request = {
                        'leverage': leverage
                    };
                    return await this.privatePostAccountLeverage(this.extend(request, params));
                }
                parseIncome(income, market) {
                    //
                    //   {
                    //       "future": "ETH-PERP",
                    //        "id": 33830,
                    //        "payment": 0.0441342,
                    //        "time": "2019-05-15T18:00:00+00:00",
                    //        "rate": 0.0001
                    //   }
                    //
                    const marketId = this.safeString(income, 'future');
                    const symbol = this.safeSymbol(marketId, market);
                    const amount = this.safeNumber(income, 'payment');
                    const code = this.safeCurrencyCode('USD');
                    const id = this.safeString(income, 'id');
                    const time = this.safeString(income, 'time');
                    const timestamp = this.parse8601(time);
                    const rate = this.safe_number(income, 'rate');
                    return {
                        'info': income,
                        'symbol': symbol,
                        'code': code,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'id': id,
                        'amount': amount,
                        'rate': rate
                    };
                }
                parseIncomes(incomes, market, since, limit) {
                    const result = [];
                    for(let i = 0; i < incomes.length; i++){
                        const entry = incomes[i];
                        const parsed = this.parseIncome(entry, market);
                        result.push(parsed);
                    }
                    const sorted = this.sortBy(result, 'timestamp');
                    return this.filterBySinceLimit(sorted, since, limit, 'timestamp');
                }
                async fetchFundingHistory(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['future'] = market['id'];
                    }
                    if (since !== undefined) request['startTime'] = since;
                    const response = await this.privateGetFundingPayments(this.extend(request, params));
                    const result = this.safeValue(response, 'result', []);
                    return this.parseIncomes(result, market, since, limit);
                }
                parseFundingRate(fundingRate, market) {
                    //
                    // perp
                    //     {
                    //       "volume": "71294.7636",
                    //       "nextFundingRate": "0.000033",
                    //       "nextFundingTime": "2021-10-14T20:00:00+00:00",
                    //       "openInterest": "47142.994"
                    //     }
                    //
                    // delivery
                    //     {
                    //       "volume": "4998.727",
                    //       "predictedExpirationPrice": "3798.820141757",
                    //       "openInterest": "48307.96"
                    //     }
                    //
                    const fundingRateDatetimeRaw = this.safeString(fundingRate, 'nextFundingTime');
                    const fundingRateTimestamp = this.parse8601(fundingRateDatetimeRaw);
                    const estimatedSettlePrice = this.safeNumber(fundingRate, 'predictedExpirationPrice');
                    return {
                        'info': fundingRate,
                        'symbol': market['symbol'],
                        'markPrice': undefined,
                        'indexPrice': undefined,
                        'interestRate': this.parseNumber('0'),
                        'estimatedSettlePrice': estimatedSettlePrice,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'fundingRate': this.safeNumber(fundingRate, 'nextFundingRate'),
                        'fundingTimestamp': fundingRateTimestamp,
                        'fundingDatetime': this.iso8601(fundingRateTimestamp),
                        'nextFundingRate': undefined,
                        'nextFundingTimestamp': undefined,
                        'nextFundingDatetime': undefined,
                        'previousFundingRate': undefined,
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'future_name': market['id']
                    };
                    const response = await this.publicGetFuturesFutureNameStats(this.extend(request, params));
                    //
                    //     {
                    //       "success": true,
                    //       "result": {
                    //         "volume": "71294.7636",
                    //         "nextFundingRate": "0.000033",
                    //         "nextFundingTime": "2021-10-14T20:00:00+00:00",
                    //         "openInterest": "47142.994"
                    //       }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseFundingRate(result, market);
                }
                async fetchBorrowRates(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetSpotMarginBorrowRates(params);
                    //
                    //     {
                    //         "success":true,
                    //         "result":[
                    //             {"coin":"1INCH","previous":4.8763e-6,"estimate":4.8048e-6},
                    //             {"coin":"AAPL","previous":0.0000326469,"estimate":0.0000326469},
                    //             {"coin":"AAVE","previous":1.43e-6,"estimate":1.43e-6},
                    //         ]
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parseBorrowRates(result, 'coin');
                }
                async fetchBorrowRateHistories(codes, since, limit, params = {}) {
                    /**
         * @method
         * @name ftx#fetchBorrowRateHistory
         * @description Gets the history of the borrow rate for mutiple currencies
         * @param {str} code Unified currency code
         * @param {int} since Timestamp in ms of the earliest time to fetch the borrow rate
         * @param {int} limit Max number of [borrow rate structures]{@link https://docs.ccxt.com/en/latest/manual.html#borrow-rate-structure} to return per currency, max=48 for multiple currencies, max=5000 for a single currency
         * @param {dict} params Exchange specific parameters
         * @param {dict} params.till Timestamp in ms of the latest time to fetch the borrow rate
         * @returns A dictionary of [borrow rate structures]{@link https://docs.ccxt.com/en/latest/manual.html#borrow-rate-structure} with unified currency codes as keys
         */ await this.loadMarkets();
                    const request = {};
                    let numCodes = 0;
                    let endTime = this.safeNumber2(params, 'till', 'end_time');
                    if (codes !== undefined) numCodes = codes.length;
                    if (numCodes === 1) {
                        const millisecondsPer5000Hours = 18000000000;
                        if (limit !== undefined && limit > 5000) throw new BadRequest(this.id + ' fetchBorrowRateHistories () limit cannot exceed 5000 for a single currency');
                        if (endTime !== undefined && since !== undefined && endTime - since > millisecondsPer5000Hours) throw new BadRequest(this.id + ' fetchBorrowRateHistories () requires the time range between the since time and the end time to be less than 5000 hours for a single currency');
                        const currency = this.currency(codes[0]);
                        request['coin'] = currency['id'];
                    } else {
                        const millisecondsPer2Days = 172800000;
                        if (limit !== undefined && limit > 48) throw new BadRequest(this.id + ' fetchBorrowRateHistories () limit cannot exceed 48 for multiple currencies');
                        if (endTime !== undefined && since !== undefined && endTime - since > millisecondsPer2Days) throw new BadRequest(this.id + ' fetchBorrowRateHistories () requires the time range between the since time and the end time to be less than 48 hours for multiple currencies');
                    }
                    const millisecondsPerHour = 3600000;
                    if (since !== undefined) {
                        request['start_time'] = parseInt(since / 1000);
                        if (endTime === undefined) {
                            const now = this.milliseconds();
                            const sinceLimit = limit === undefined ? 2 : limit;
                            endTime = this.sum(since, millisecondsPerHour * (sinceLimit - 1));
                            endTime = Math.min(endTime, now);
                        }
                    } else if (limit !== undefined) {
                        if (endTime === undefined) endTime = this.milliseconds();
                        const startTime = this.sum(endTime - millisecondsPerHour * limit, 1000);
                        request['start_time'] = parseInt(startTime / 1000);
                    }
                    if (endTime !== undefined) request['end_time'] = parseInt(endTime / 1000);
                    const response = await this.publicGetSpotMarginHistory(this.extend(request, params));
                    //
                    //    {
                    //        "success": true,
                    //        "result": [
                    //            {
                    //                "coin": "PYPL",
                    //                "time": "2022-01-24T13:00:00+00:00",
                    //                "size": 0.00500172,
                    //                "rate": 1e-6
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parseBorrowRateHistories(result, codes, since, limit);
                }
                async fetchBorrowRateHistory(code, since, limit, params = {}) {
                    /**
         * @method
         * @name ftx#fetchBorrowRateHistory
         * @description Gets the history of the borrow rate for a currency
         * @param {str} code Unified currency code
         * @param {int} since Timestamp in ms of the earliest time to fetch the borrow rate
         * @param {int} limit Max number of [borrow rate structures]{@link https://docs.ccxt.com/en/latest/manual.html#borrow-rate-structure} to return, max=5000
         * @param {dict} params Exchange specific parameters
         * @param {dict} params.till Timestamp in ms of the latest time to fetch the borrow rate
         * @returns An array of [borrow rate structures]{@link https://docs.ccxt.com/en/latest/manual.html#borrow-rate-structure}
         */ const histories = await this.fetchBorrowRateHistories([
                        code
                    ], since, limit, params);
                    const borrowRateHistory = this.safeValue(histories, code);
                    if (borrowRateHistory === undefined) throw new BadRequest(this.id + ' fetchBorrowRateHistory () returned no data for ' + code);
                    return borrowRateHistory;
                }
                parseBorrowRateHistories(response, codes, since, limit) {
                    // How to calculate borrow rate
                    // https://help.ftx.com/hc/en-us/articles/360053007671-Spot-Margin-Trading-Explainer
                    const takerFee = this.fees['trading']['taker'].toString();
                    const spotMarginBorrowRate = Precise.stringMul('500', takerFee);
                    const borrowRateHistories = {};
                    for(let i = 0; i < response.length; i++){
                        const item = response[i];
                        const code = this.safeCurrencyCode(this.safeString(item, 'coin'));
                        if (codes === undefined || this.inArray(code, codes)) {
                            if (!(code in borrowRateHistories)) borrowRateHistories[code] = [];
                            const lendingRate = this.safeString(item, 'rate');
                            const borrowRate = Precise.stringMul(lendingRate, Precise.stringAdd('1', spotMarginBorrowRate));
                            const borrowRateStructure = this.extend(this.parseBorrowRate(item), {
                                'rate': borrowRate
                            });
                            borrowRateHistories[code].push(borrowRateStructure);
                        }
                    }
                    const keys = Object.keys(borrowRateHistories);
                    for(let i = 0; i < keys.length; i++){
                        const code = keys[i];
                        borrowRateHistories[code] = this.filterByCurrencySinceLimit(borrowRateHistories[code], code, since, limit);
                    }
                    return borrowRateHistories;
                }
                parseBorrowRates(response, codeKey) {
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const item = response[i];
                        const currency = this.safeString(item, codeKey);
                        const code = this.safeCurrencyCode(currency);
                        const borrowRate = this.parseBorrowRate(item);
                        result[code] = borrowRate;
                    }
                    return result;
                }
                parseBorrowRate(info, currency) {
                    //
                    //    {
                    //        "coin": "1INCH",
                    //        "previous": 0.0000462375,
                    //        "estimate": 0.0000462375
                    //    }
                    //
                    const coin = this.safeString(info, 'coin');
                    const datetime = this.safeString(info, 'time');
                    const timestamp = this.parse8601(datetime);
                    return {
                        'currency': this.safeCurrencyCode(coin),
                        'rate': this.safeNumber(info, 'previous'),
                        'period': 3600000,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'info': info
                    };
                }
                async fetchBorrowInterest(code, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (since !== undefined) request['start_time'] = parseInt(since / 1000);
                    const response = await this.privateGetSpotMarginBorrowHistory(this.extend(request, params));
                    //
                    //     {
                    //         "success":true,
                    //         "result":[
                    //             {"coin":"USDT","time":"2021-12-26T01:00:00+00:00","size":4593.74214725,"rate":3.3003e-6,"cost":0.0151607272085692,"feeUsd":0.0151683341034461},
                    //             {"coin":"USDT","time":"2021-12-26T00:00:00+00:00","size":4593.97110361,"rate":3.3003e-6,"cost":0.0151614828332441,"feeUsd":0.015169697173028324},
                    //             {"coin":"USDT","time":"2021-12-25T23:00:00+00:00","size":4594.20005922,"rate":3.3003e-6,"cost":0.0151622384554438,"feeUsd":0.015170200298479137},
                    //         ]
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    const interest = this.parseBorrowInterests(result);
                    return this.filterByCurrencySinceLimit(interest, code, since, limit);
                }
                parseBorrowInterest(info, market) {
                    const coin = this.safeString(info, 'coin');
                    const datetime = this.safeString(info, 'time');
                    return {
                        'account': 'cross',
                        'symbol': undefined,
                        'marginMode': 'cross',
                        'marginType': 'cross',
                        'currency': this.safeCurrencyCode(coin),
                        'interest': this.safeNumber(info, 'cost'),
                        'interestRate': this.safeNumber(info, 'rate'),
                        'amountBorrowed': this.safeNumber(info, 'size'),
                        'timestamp': this.parse8601(datetime),
                        'datetime': datetime,
                        'info': info
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    82: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const ftx = require1('./ftx.js');
            module.exports = class ftxus extends ftx {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'ftxus',
                        'name': 'FTX US',
                        'countries': [
                            'US'
                        ],
                        'certified': false,
                        'hostname': 'ftx.us',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': undefined,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkOHLCV': false,
                            'fetchPremiumIndexOHLCV': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/141506670-12f6115f-f425-4cd8-b892-b51d157ca01f.jpg',
                            'www': 'https://ftx.us/',
                            'docs': 'https://docs.ftx.us/',
                            'fees': 'https://help.ftx.us/hc/en-us/articles/360043579273-Fees'
                        }
                    });
                }
            };
        },
        {
            "./ftx.js": 81
        }
    ],
    83: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const Precise = require1('./base/Precise');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const { ExchangeError: ExchangeError1, BadRequest: BadRequest, ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, PermissionDenied: PermissionDenied, AccountSuspended: AccountSuspended, InsufficientFunds: InsufficientFunds, RateLimitExceeded: RateLimitExceeded, ExchangeNotAvailable: ExchangeNotAvailable, BadSymbol: BadSymbol, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, NotSupported: NotSupported, AccountNotEnabled: AccountNotEnabled } = require1('./base/errors');
            module.exports = class gateio extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'gateio',
                        'name': 'Gate.io',
                        'countries': [
                            'KR'
                        ],
                        'rateLimit': 10 / 3,
                        'version': 'v4',
                        'certified': true,
                        'pro': true,
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/31784029-0313c702-b509-11e7-9ccc-bc0da6a0e435.jpg',
                            'doc': 'https://www.gate.io/docs/apiv4/en/index.html',
                            'www': 'https://gate.io/',
                            'api': {
                                'public': {
                                    'wallet': 'https://api.gateio.ws/api/v4',
                                    'futures': 'https://api.gateio.ws/api/v4',
                                    'margin': 'https://api.gateio.ws/api/v4',
                                    'delivery': 'https://api.gateio.ws/api/v4',
                                    'spot': 'https://api.gateio.ws/api/v4',
                                    'options': 'https://api.gateio.ws/api/v4'
                                },
                                'private': {
                                    'withdrawals': 'https://api.gateio.ws/api/v4',
                                    'wallet': 'https://api.gateio.ws/api/v4',
                                    'futures': 'https://api.gateio.ws/api/v4',
                                    'margin': 'https://api.gateio.ws/api/v4',
                                    'delivery': 'https://api.gateio.ws/api/v4',
                                    'spot': 'https://api.gateio.ws/api/v4',
                                    'options': 'https://api.gateio.ws/api/v4'
                                }
                            },
                            'test': {
                                'public': {
                                    'futures': 'https://fx-api-testnet.gateio.ws/api/v4',
                                    'delivery': 'https://fx-api-testnet.gateio.ws/api/v4'
                                },
                                'private': {
                                    'futures': 'https://fx-api-testnet.gateio.ws/api/v4',
                                    'delivery': 'https://fx-api-testnet.gateio.ws/api/v4'
                                }
                            },
                            'referral': {
                                'url': 'https://www.gate.io/ref/2436035',
                                'discount': 0.2
                            }
                        },
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': true,
                            'swap': true,
                            'future': true,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createMarketOrder': false,
                            'createOrder': true,
                            'createPostOnlyOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': false,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingFees': true,
                            'fetchFundingHistory': true,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': true,
                            'fetchFundingRates': true,
                            'fetchIndexOHLCV': true,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': true,
                            'fetchMarketLeverageTiers': 'emulated',
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': true,
                            'fetchMyTrades': true,
                            'fetchNetworkDepositAddress': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPositions': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': false,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': true,
                            'fetchWithdrawals': true,
                            'setLeverage': true,
                            'setMarginMode': false,
                            'transfer': true,
                            'withdraw': true
                        },
                        'api': {
                            'public': {
                                'wallet': {
                                    'get': {
                                        'wallet/currency_chains': 1.5
                                    }
                                },
                                'spot': {
                                    'get': {
                                        'currencies': 1,
                                        'currencies/{currency}': 1,
                                        'currency_pairs': 1,
                                        'currency_pairs/{currency_pair}': 1,
                                        'tickers': 1,
                                        'order_book': 1,
                                        'trades': 1,
                                        'candlesticks': 1
                                    }
                                },
                                'margin': {
                                    'get': {
                                        'currency_pairs': 1,
                                        'currency_pairs/{currency_pair}': 1,
                                        'cross/currencies': 1,
                                        'cross/currencies/{currency}': 1,
                                        'funding_book': 1
                                    }
                                },
                                'futures': {
                                    'get': {
                                        '{settle}/contracts': 1.5,
                                        '{settle}/contracts/{contract}': 1.5,
                                        '{settle}/order_book': 1.5,
                                        '{settle}/trades': 1.5,
                                        '{settle}/candlesticks': 1.5,
                                        '{settle}/tickers': 1.5,
                                        '{settle}/funding_rate': 1.5,
                                        '{settle}/insurance': 1.5,
                                        '{settle}/contract_stats': 1.5,
                                        '{settle}/liq_orders': 1.5
                                    }
                                },
                                'delivery': {
                                    'get': {
                                        '{settle}/contracts': 1.5,
                                        '{settle}/contracts/{contract}': 1.5,
                                        '{settle}/order_book': 1.5,
                                        '{settle}/trades': 1.5,
                                        '{settle}/candlesticks': 1.5,
                                        '{settle}/tickers': 1.5,
                                        '{settle}/insurance': 1.5
                                    }
                                },
                                'options': {
                                    'get': {
                                        'underlyings': 1.5,
                                        'expirations': 1.5,
                                        'contracts': 1.5,
                                        'contracts/{contract}': 1.5,
                                        'settlements': 1.5,
                                        'settlements/{contract}': 1.5,
                                        'order_book': 1.5,
                                        'tickers': 1.5,
                                        'underlying/tickers/{underlying}': 1.5,
                                        'candlesticks': 1.5,
                                        'underlying/candlesticks': 1.5,
                                        'trades': 1.5
                                    }
                                }
                            },
                            'private': {
                                'withdrawals': {
                                    'post': {
                                        '': 3000
                                    },
                                    'delete': {
                                        '{withdrawal_id}': 300
                                    }
                                },
                                'wallet': {
                                    'get': {
                                        'deposit_address': 300,
                                        'withdrawals': 300,
                                        'deposits': 300,
                                        'sub_account_transfers': 300,
                                        'withdraw_status': 300,
                                        'sub_account_balances': 300,
                                        'fee': 300,
                                        'total_balance': 300
                                    },
                                    'post': {
                                        'transfers': 300,
                                        'sub_account_transfers': 300
                                    }
                                },
                                'spot': {
                                    'get': {
                                        'accounts': 1,
                                        'open_orders': 1,
                                        'orders': 1,
                                        'orders/{order_id}': 1,
                                        'my_trades': 1,
                                        'price_orders': 1,
                                        'price_orders/{order_id}': 1
                                    },
                                    'post': {
                                        'batch_orders': 1,
                                        'orders': 1,
                                        'cancel_batch_orders': 1,
                                        'price_orders': 1
                                    },
                                    'delete': {
                                        'orders': 1,
                                        'orders/{order_id}': 1,
                                        'price_orders': 1,
                                        'price_orders/{order_id}': 1
                                    }
                                },
                                'margin': {
                                    'get': {
                                        'accounts': 1.5,
                                        'account_book': 1.5,
                                        'funding_accounts': 1.5,
                                        'loans': 1.5,
                                        'loans/{loan_id}': 1.5,
                                        'loans/{loan_id}/repayment': 1.5,
                                        'loan_records': 1.5,
                                        'loan_records/{load_record_id}': 1.5,
                                        'auto_repay': 1.5,
                                        'transferable': 1.5,
                                        'cross/accounts': 1.5,
                                        'cross/account_book': 1.5,
                                        'cross/loans': 1.5,
                                        'cross/loans/{loan_id}': 1.5,
                                        'cross/loans/repayments': 1.5,
                                        'cross/transferable': 1.5,
                                        'loan_records/{loan_record_id}': 1.5,
                                        'borrowable': 1.5,
                                        'cross/repayments': 1.5,
                                        'cross/borrowable': 1.5
                                    },
                                    'post': {
                                        'loans': 1.5,
                                        'merged_loans': 1.5,
                                        'loans/{loan_id}/repayment': 1.5,
                                        'auto_repay': 1.5,
                                        'cross/loans': 1.5,
                                        'cross/loans/repayments': 1.5,
                                        'cross/repayments': 1.5
                                    },
                                    'patch': {
                                        'loans/{loan_id}': 1.5,
                                        'loan_records/{loan_record_id}': 1.5
                                    },
                                    'delete': {
                                        'loans/{loan_id}': 1.5
                                    }
                                },
                                'futures': {
                                    'get': {
                                        '{settle}/accounts': 1.5,
                                        '{settle}/account_book': 1.5,
                                        '{settle}/positions': 1.5,
                                        '{settle}/positions/{contract}': 1.5,
                                        '{settle}/orders': 1.5,
                                        '{settle}/orders/{order_id}': 1.5,
                                        '{settle}/my_trades': 1.5,
                                        '{settle}/position_close': 1.5,
                                        '{settle}/liquidates': 1.5,
                                        '{settle}/price_orders': 1.5,
                                        '{settle}/price_orders/{order_id}': 1.5,
                                        '{settle}/dual_comp/positions/{contract}': 1.5
                                    },
                                    'post': {
                                        '{settle}/positions/{contract}/margin': 1.5,
                                        '{settle}/positions/{contract}/leverage': 1.5,
                                        '{settle}/positions/{contract}/risk_limit': 1.5,
                                        '{settle}/dual_mode': 1.5,
                                        '{settle}/dual_comp/positions/{contract}': 1.5,
                                        '{settle}/dual_comp/positions/{contract}/margin': 1.5,
                                        '{settle}/dual_comp/positions/{contract}/leverage': 1.5,
                                        '{settle}/dual_comp/positions/{contract}/risk_limit': 1.5,
                                        '{settle}/orders': 1.5,
                                        '{settle}/price_orders': 1.5
                                    },
                                    'delete': {
                                        '{settle}/orders': 1.5,
                                        '{settle}/orders/{order_id}': 1.5,
                                        '{settle}/price_orders': 1.5,
                                        '{settle}/price_orders/{order_id}': 1.5
                                    }
                                },
                                'delivery': {
                                    'get': {
                                        '{settle}/accounts': 1.5,
                                        '{settle}/account_book': 1.5,
                                        '{settle}/positions': 1.5,
                                        '{settle}/positions/{contract}': 1.5,
                                        '{settle}/orders': 1.5,
                                        '{settle}/orders/{order_id}': 1.5,
                                        '{settle}/my_trades': 1.5,
                                        '{settle}/position_close': 1.5,
                                        '{settle}/liquidates': 1.5,
                                        '{settle}/price_orders': 1.5,
                                        '{settle}/price_orders/{order_id}': 1.5,
                                        '{settle}/settlements': 1.5
                                    },
                                    'post': {
                                        '{settle}/positions/{contract}/margin': 1.5,
                                        '{settle}/positions/{contract}/leverage': 1.5,
                                        '{settle}/positions/{contract}/risk_limit': 1.5,
                                        '{settle}/orders': 1.5,
                                        '{settle}/price_orders': 1.5
                                    },
                                    'delete': {
                                        '{settle}/orders': 1.5,
                                        '{settle}/orders/{order_id}': 1.5,
                                        '{settle}/price_orders': 1.5,
                                        '{settle}/price_orders/{order_id}': 1.5
                                    }
                                },
                                'options': {
                                    'get': {
                                        'accounts': 1.5,
                                        'account_book': 1.5,
                                        'positions': 1.5,
                                        'positions/{contract}': 1.5,
                                        'position_close': 1.5,
                                        'orders': 1.5,
                                        'orders/{order_id}': 1.5,
                                        'my_trades': 1.5
                                    },
                                    'post': {
                                        'orders': 1.5
                                    },
                                    'delete': {
                                        'orders': 1.5,
                                        'orders/{order_id}': 1.5
                                    }
                                }
                            }
                        },
                        'timeframes': {
                            '10s': '10s',
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '4h': '4h',
                            '8h': '8h',
                            '1d': '1d',
                            '7d': '7d',
                            '1w': '7d'
                        },
                        // copied from gateiov2
                        'commonCurrencies': {
                            '88MPH': 'MPH',
                            'AXIS': 'Axis DeFi',
                            'BIFI': 'Bitcoin File',
                            'BOX': 'DefiBox',
                            'BTCBEAR': 'BEAR',
                            'BTCBULL': 'BULL',
                            'BYN': 'BeyondFi',
                            'EGG': 'Goose Finance',
                            'GTC': 'Game.com',
                            'GTC_HT': 'Game.com HT',
                            'GTC_BSC': 'Game.com BSC',
                            'HIT': 'HitChain',
                            'MM': 'Million',
                            'MPH': 'Morpher',
                            'RAI': 'Rai Reflex Index',
                            'SBTC': 'Super Bitcoin',
                            'TNC': 'Trinity Network Credit',
                            'TON': 'TONToken',
                            'VAI': 'VAIOT'
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true
                        },
                        'headers': {
                            'X-Gate-Channel-Id': 'ccxt'
                        },
                        'options': {
                            'createOrder': {
                                'expiration': 86400
                            },
                            'networks': {
                                'TRC20': 'TRX',
                                'ERC20': 'ETH',
                                'BEP20': 'BSC'
                            },
                            'accountsByType': {
                                'funding': 'spot',
                                'spot': 'spot',
                                'margin': 'margin',
                                'cross_margin': 'cross_margin',
                                'cross': 'cross_margin',
                                'isolated': 'margin',
                                'swap': 'futures',
                                'future': 'delivery',
                                'futures': 'futures',
                                'delivery': 'delivery'
                            },
                            'defaultType': 'spot',
                            'swap': {
                                'fetchMarkets': {
                                    'settlementCurrencies': [
                                        'usdt',
                                        'btc'
                                    ]
                                }
                            },
                            'future': {
                                'fetchMarkets': {
                                    'settlementCurrencies': [
                                        'usdt',
                                        'btc'
                                    ]
                                }
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'feeSide': 'get',
                                'percentage': true,
                                'maker': this.parseNumber('0.002'),
                                'taker': this.parseNumber('0.002'),
                                'tiers': {
                                    // volume is in BTC
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('1.5'),
                                            this.parseNumber('0.00185')
                                        ],
                                        [
                                            this.parseNumber('3'),
                                            this.parseNumber('0.00175')
                                        ],
                                        [
                                            this.parseNumber('6'),
                                            this.parseNumber('0.00165')
                                        ],
                                        [
                                            this.parseNumber('12.5'),
                                            this.parseNumber('0.00155')
                                        ],
                                        [
                                            this.parseNumber('25'),
                                            this.parseNumber('0.00145')
                                        ],
                                        [
                                            this.parseNumber('75'),
                                            this.parseNumber('0.00135')
                                        ],
                                        [
                                            this.parseNumber('200'),
                                            this.parseNumber('0.00125')
                                        ],
                                        [
                                            this.parseNumber('500'),
                                            this.parseNumber('0.00115')
                                        ],
                                        [
                                            this.parseNumber('1250'),
                                            this.parseNumber('0.00105')
                                        ],
                                        [
                                            this.parseNumber('2500'),
                                            this.parseNumber('0.00095')
                                        ],
                                        [
                                            this.parseNumber('3000'),
                                            this.parseNumber('0.00085')
                                        ],
                                        [
                                            this.parseNumber('6000'),
                                            this.parseNumber('0.00075')
                                        ],
                                        [
                                            this.parseNumber('11000'),
                                            this.parseNumber('0.00065')
                                        ],
                                        [
                                            this.parseNumber('20000'),
                                            this.parseNumber('0.00055')
                                        ],
                                        [
                                            this.parseNumber('40000'),
                                            this.parseNumber('0.00055')
                                        ],
                                        [
                                            this.parseNumber('75000'),
                                            this.parseNumber('0.00055')
                                        ]
                                    ],
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.002')
                                        ],
                                        [
                                            this.parseNumber('1.5'),
                                            this.parseNumber('0.00195')
                                        ],
                                        [
                                            this.parseNumber('3'),
                                            this.parseNumber('0.00185')
                                        ],
                                        [
                                            this.parseNumber('6'),
                                            this.parseNumber('0.00175')
                                        ],
                                        [
                                            this.parseNumber('12.5'),
                                            this.parseNumber('0.00165')
                                        ],
                                        [
                                            this.parseNumber('25'),
                                            this.parseNumber('0.00155')
                                        ],
                                        [
                                            this.parseNumber('75'),
                                            this.parseNumber('0.00145')
                                        ],
                                        [
                                            this.parseNumber('200'),
                                            this.parseNumber('0.00135')
                                        ],
                                        [
                                            this.parseNumber('500'),
                                            this.parseNumber('0.00125')
                                        ],
                                        [
                                            this.parseNumber('1250'),
                                            this.parseNumber('0.00115')
                                        ],
                                        [
                                            this.parseNumber('2500'),
                                            this.parseNumber('0.00105')
                                        ],
                                        [
                                            this.parseNumber('3000'),
                                            this.parseNumber('0.00095')
                                        ],
                                        [
                                            this.parseNumber('6000'),
                                            this.parseNumber('0.00085')
                                        ],
                                        [
                                            this.parseNumber('11000'),
                                            this.parseNumber('0.00075')
                                        ],
                                        [
                                            this.parseNumber('20000'),
                                            this.parseNumber('0.00065')
                                        ],
                                        [
                                            this.parseNumber('40000'),
                                            this.parseNumber('0.00065')
                                        ],
                                        [
                                            this.parseNumber('75000'),
                                            this.parseNumber('0.00065')
                                        ]
                                    ]
                                }
                            },
                            'swap': {
                                'tierBased': true,
                                'feeSide': 'base',
                                'percentage': true,
                                'maker': this.parseNumber('0.0'),
                                'taker': this.parseNumber('0.0005'),
                                'tiers': {
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.0000')
                                        ],
                                        [
                                            this.parseNumber('1.5'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('3'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('6'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('12.5'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('25'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('75'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('200'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('500'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('1250'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('2500'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('3000'),
                                            this.parseNumber('-0.00008')
                                        ],
                                        [
                                            this.parseNumber('6000'),
                                            this.parseNumber('-0.01000')
                                        ],
                                        [
                                            this.parseNumber('11000'),
                                            this.parseNumber('-0.01002')
                                        ],
                                        [
                                            this.parseNumber('20000'),
                                            this.parseNumber('-0.01005')
                                        ],
                                        [
                                            this.parseNumber('40000'),
                                            this.parseNumber('-0.02000')
                                        ],
                                        [
                                            this.parseNumber('75000'),
                                            this.parseNumber('-0.02005')
                                        ]
                                    ],
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.00050')
                                        ],
                                        [
                                            this.parseNumber('1.5'),
                                            this.parseNumber('0.00048')
                                        ],
                                        [
                                            this.parseNumber('3'),
                                            this.parseNumber('0.00046')
                                        ],
                                        [
                                            this.parseNumber('6'),
                                            this.parseNumber('0.00044')
                                        ],
                                        [
                                            this.parseNumber('12.5'),
                                            this.parseNumber('0.00042')
                                        ],
                                        [
                                            this.parseNumber('25'),
                                            this.parseNumber('0.00040')
                                        ],
                                        [
                                            this.parseNumber('75'),
                                            this.parseNumber('0.00038')
                                        ],
                                        [
                                            this.parseNumber('200'),
                                            this.parseNumber('0.00036')
                                        ],
                                        [
                                            this.parseNumber('500'),
                                            this.parseNumber('0.00034')
                                        ],
                                        [
                                            this.parseNumber('1250'),
                                            this.parseNumber('0.00032')
                                        ],
                                        [
                                            this.parseNumber('2500'),
                                            this.parseNumber('0.00030')
                                        ],
                                        [
                                            this.parseNumber('3000'),
                                            this.parseNumber('0.00030')
                                        ],
                                        [
                                            this.parseNumber('6000'),
                                            this.parseNumber('0.00030')
                                        ],
                                        [
                                            this.parseNumber('11000'),
                                            this.parseNumber('0.00030')
                                        ],
                                        [
                                            this.parseNumber('20000'),
                                            this.parseNumber('0.00030')
                                        ],
                                        [
                                            this.parseNumber('40000'),
                                            this.parseNumber('0.00030')
                                        ],
                                        [
                                            this.parseNumber('75000'),
                                            this.parseNumber('0.00030')
                                        ]
                                    ]
                                }
                            }
                        },
                        // https://www.gate.io/docs/apiv4/en/index.html#label-list
                        'exceptions': {
                            'exact': {
                                'INVALID_PARAM_VALUE': BadRequest,
                                'INVALID_PROTOCOL': BadRequest,
                                'INVALID_ARGUMENT': BadRequest,
                                'INVALID_REQUEST_BODY': BadRequest,
                                'MISSING_REQUIRED_PARAM': ArgumentsRequired1,
                                'BAD_REQUEST': BadRequest,
                                'INVALID_CONTENT_TYPE': BadRequest,
                                'NOT_ACCEPTABLE': BadRequest,
                                'METHOD_NOT_ALLOWED': BadRequest,
                                'NOT_FOUND': ExchangeError1,
                                'INVALID_CREDENTIALS': AuthenticationError,
                                'INVALID_KEY': AuthenticationError,
                                'IP_FORBIDDEN': AuthenticationError,
                                'READ_ONLY': PermissionDenied,
                                'INVALID_SIGNATURE': AuthenticationError,
                                'MISSING_REQUIRED_HEADER': AuthenticationError,
                                'REQUEST_EXPIRED': AuthenticationError,
                                'ACCOUNT_LOCKED': AccountSuspended,
                                'FORBIDDEN': PermissionDenied,
                                'SUB_ACCOUNT_NOT_FOUND': ExchangeError1,
                                'SUB_ACCOUNT_LOCKED': AccountSuspended,
                                'MARGIN_BALANCE_EXCEPTION': ExchangeError1,
                                'MARGIN_TRANSFER_FAILED': ExchangeError1,
                                'TOO_MUCH_FUTURES_AVAILABLE': ExchangeError1,
                                'FUTURES_BALANCE_NOT_ENOUGH': InsufficientFunds,
                                'ACCOUNT_EXCEPTION': ExchangeError1,
                                'SUB_ACCOUNT_TRANSFER_FAILED': ExchangeError1,
                                'ADDRESS_NOT_USED': ExchangeError1,
                                'TOO_FAST': RateLimitExceeded,
                                'WITHDRAWAL_OVER_LIMIT': ExchangeError1,
                                'API_WITHDRAW_DISABLED': ExchangeNotAvailable,
                                'INVALID_WITHDRAW_ID': ExchangeError1,
                                'INVALID_WITHDRAW_CANCEL_STATUS': ExchangeError1,
                                'INVALID_PRECISION': InvalidOrder,
                                'INVALID_CURRENCY': BadSymbol,
                                'INVALID_CURRENCY_PAIR': BadSymbol,
                                'POC_FILL_IMMEDIATELY': ExchangeError1,
                                'ORDER_NOT_FOUND': OrderNotFound,
                                'CLIENT_ID_NOT_FOUND': OrderNotFound,
                                'ORDER_CLOSED': InvalidOrder,
                                'ORDER_CANCELLED': InvalidOrder,
                                'QUANTITY_NOT_ENOUGH': InvalidOrder,
                                'BALANCE_NOT_ENOUGH': InsufficientFunds,
                                'MARGIN_NOT_SUPPORTED': InvalidOrder,
                                'MARGIN_BALANCE_NOT_ENOUGH': InsufficientFunds,
                                'AMOUNT_TOO_LITTLE': InvalidOrder,
                                'AMOUNT_TOO_MUCH': InvalidOrder,
                                'REPEATED_CREATION': InvalidOrder,
                                'LOAN_NOT_FOUND': OrderNotFound,
                                'LOAN_RECORD_NOT_FOUND': OrderNotFound,
                                'NO_MATCHED_LOAN': ExchangeError1,
                                'NOT_MERGEABLE': ExchangeError1,
                                'NO_CHANGE': ExchangeError1,
                                'REPAY_TOO_MUCH': ExchangeError1,
                                'TOO_MANY_CURRENCY_PAIRS': InvalidOrder,
                                'TOO_MANY_ORDERS': InvalidOrder,
                                'MIXED_ACCOUNT_TYPE': InvalidOrder,
                                'AUTO_BORROW_TOO_MUCH': ExchangeError1,
                                'TRADE_RESTRICTED': InsufficientFunds,
                                'USER_NOT_FOUND': AccountNotEnabled,
                                'CONTRACT_NO_COUNTER': ExchangeError1,
                                'CONTRACT_NOT_FOUND': BadSymbol,
                                'RISK_LIMIT_EXCEEDED': ExchangeError1,
                                'INSUFFICIENT_AVAILABLE': InsufficientFunds,
                                'LIQUIDATE_IMMEDIATELY': InvalidOrder,
                                'LEVERAGE_TOO_HIGH': InvalidOrder,
                                'LEVERAGE_TOO_LOW': InvalidOrder,
                                'ORDER_NOT_OWNED': ExchangeError1,
                                'ORDER_FINISHED': ExchangeError1,
                                'POSITION_CROSS_MARGIN': ExchangeError1,
                                'POSITION_IN_LIQUIDATION': ExchangeError1,
                                'POSITION_IN_CLOSE': ExchangeError1,
                                'POSITION_EMPTY': InvalidOrder,
                                'REMOVE_TOO_MUCH': ExchangeError1,
                                'RISK_LIMIT_NOT_MULTIPLE': ExchangeError1,
                                'RISK_LIMIT_TOO_HIGH': ExchangeError1,
                                'RISK_LIMIT_TOO_lOW': ExchangeError1,
                                'PRICE_TOO_DEVIATED': InvalidOrder,
                                'SIZE_TOO_LARGE': InvalidOrder,
                                'SIZE_TOO_SMALL': InvalidOrder,
                                'PRICE_OVER_LIQUIDATION': InvalidOrder,
                                'PRICE_OVER_BANKRUPT': InvalidOrder,
                                'ORDER_POC_IMMEDIATE': InvalidOrder,
                                'INCREASE_POSITION': InvalidOrder,
                                'CONTRACT_IN_DELISTING': ExchangeError1,
                                'INTERNAL': ExchangeNotAvailable,
                                'SERVER_ERROR': ExchangeNotAvailable,
                                'TOO_BUSY': ExchangeNotAvailable,
                                'CROSS_ACCOUNT_NOT_FOUND': ExchangeError1
                            }
                        },
                        'broad': {}
                    });
                }
                async fetchMarkets(params = {}) {
                    let result = [];
                    const [type, query] = this.handleMarketTypeAndParams('fetchMarkets', undefined, params);
                    if (type === 'spot' || type === 'margin') result = await this.fetchSpotMarkets(query);
                    if (type === 'swap' || type === 'future') result = await this.fetchContractMarkets(query); // futures and swaps
                    if (type === 'option') result = await this.fetchOptionMarkets(query);
                    const resultLength = result.length;
                    if (resultLength === 0) throw new ExchangeError1(this.id + " does not support '" + type + "' type, set exchange.options['defaultType'] to " + "'spot', 'margin', 'swap', 'future' or 'option'"); // eslint-disable-line quotes
                    return result;
                }
                async fetchSpotMarkets(params) {
                    const marginResponse = await this.publicMarginGetCurrencyPairs(params);
                    const spotMarketsResponse = await this.publicSpotGetCurrencyPairs(params);
                    const marginMarkets = this.indexBy(marginResponse, 'id');
                    //
                    //  Spot
                    //
                    //     [
                    //         {
                    //             "id": "QTUM_ETH",
                    //             "base": "QTUM",
                    //             "quote": "ETH",
                    //             "fee": "0.2",
                    //             "min_base_amount": "0.01",
                    //             "min_quote_amount": "0.001",
                    //             "amount_precision": 3,
                    //             "precision": 6,
                    //             "trade_status": "tradable",
                    //             "sell_start": 0,
                    //             "buy_start": 0
                    //         }
                    //     ]
                    //
                    //  Margin
                    //
                    //     [
                    //         {
                    //             "id": "ETH_USDT",
                    //             "base": "ETH",
                    //             "quote": "USDT",
                    //             "leverage": 3,
                    //             "min_base_amount": "0.01",
                    //             "min_quote_amount": "100",
                    //             "max_quote_amount": "1000000"
                    //         }
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < spotMarketsResponse.length; i++){
                        const spotMarket = spotMarketsResponse[i];
                        const id = this.safeString(spotMarket, 'id');
                        const marginMarket = this.safeValue(marginMarkets, id);
                        const market = this.deepExtend(marginMarket, spotMarket);
                        const [baseId, quoteId] = id.split('_');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const takerPercent = this.safeString(market, 'fee');
                        const makerPercent = this.safeString(market, 'maker_fee_rate', takerPercent);
                        const amountPrecisionString = this.safeString(market, 'amount_precision');
                        const pricePrecisionString = this.safeString(market, 'precision');
                        const tradeStatus = this.safeString(market, 'trade_status');
                        const leverage = this.safeNumber(market, 'leverage');
                        const defaultMinAmountLimit = this.parseNumber(this.parsePrecision(amountPrecisionString));
                        const margin = leverage !== undefined;
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': margin,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': tradeStatus === 'tradable',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            // Fee is in %, so divide by 100
                            'taker': this.parseNumber(Precise.stringDiv(takerPercent, '100')),
                            'maker': this.parseNumber(Precise.stringDiv(makerPercent, '100')),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.parseNumber(this.parsePrecision(amountPrecisionString)),
                                'price': this.parseNumber(this.parsePrecision(pricePrecisionString))
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': this.safeNumber(market, 'leverage', 1)
                                },
                                'amount': {
                                    'min': this.safeNumber(spotMarket, 'min_base_amount', defaultMinAmountLimit),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_quote_amount'),
                                    'max': this.safeNumber(market, 'max_quote_amount')
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchContractMarkets(params) {
                    const result = [];
                    const swapSettlementCurrencies = this.getSettlementCurrencies('swap', 'fetchMarkets');
                    const futureSettlementCurrencies = this.getSettlementCurrencies('future', 'fetchMarkets');
                    for(let c = 0; c < swapSettlementCurrencies.length; c++){
                        const settleId = swapSettlementCurrencies[c];
                        const query = params;
                        query['settle'] = settleId;
                        const response = await this.publicFuturesGetSettleContracts(query);
                        for(let i = 0; i < response.length; i++){
                            const parsedMarket = this.parseContractMarket(response[i], settleId);
                            result.push(parsedMarket);
                        }
                    }
                    for(let c = 0; c < futureSettlementCurrencies.length; c++){
                        const settleId = futureSettlementCurrencies[c];
                        const query = params;
                        query['settle'] = settleId;
                        const response = await this.publicDeliveryGetSettleContracts(query);
                        for(let i = 0; i < response.length; i++){
                            const parsedMarket = this.parseContractMarket(response[i], settleId);
                            result.push(parsedMarket);
                        }
                    }
                    return result;
                }
                parseContractMarket(market, settleId) {
                    //
                    //  Perpetual swap
                    //
                    //    {
                    //        "name": "BTC_USDT",
                    //        "type": "direct",
                    //        "quanto_multiplier": "0.0001",
                    //        "ref_discount_rate": "0",
                    //        "order_price_deviate": "0.5",
                    //        "maintenance_rate": "0.005",
                    //        "mark_type": "index",
                    //        "last_price": "38026",
                    //        "mark_price": "37985.6",
                    //        "index_price": "37954.92",
                    //        "funding_rate_indicative": "0.000219",
                    //        "mark_price_round": "0.01",
                    //        "funding_offset": 0,
                    //        "in_delisting": false,
                    //        "risk_limit_base": "1000000",
                    //        "interest_rate": "0.0003",
                    //        "order_price_round": "0.1",
                    //        "order_size_min": 1,
                    //        "ref_rebate_rate": "0.2",
                    //        "funding_interval": 28800,
                    //        "risk_limit_step": "1000000",
                    //        "leverage_min": "1",
                    //        "leverage_max": "100",
                    //        "risk_limit_max": "8000000",
                    //        "maker_fee_rate": "-0.00025",
                    //        "taker_fee_rate": "0.00075",
                    //        "funding_rate": "0.002053",
                    //        "order_size_max": 1000000,
                    //        "funding_next_apply": 1610035200,
                    //        "short_users": 977,
                    //        "config_change_time": 1609899548,
                    //        "trade_size": 28530850594,
                    //        "position_size": 5223816,
                    //        "long_users": 455,
                    //        "funding_impact_value": "60000",
                    //        "orders_limit": 50,
                    //        "trade_id": 10851092,
                    //        "orderbook_id": 2129638396
                    //    }
                    //
                    //  Delivery Futures
                    //
                    //    {
                    //        "name": "BTC_USDT_20200814",
                    //        "underlying": "BTC_USDT",
                    //        "cycle": "WEEKLY",
                    //        "type": "direct",
                    //        "quanto_multiplier": "0.0001",
                    //        "mark_type": "index",
                    //        "last_price": "9017",
                    //        "mark_price": "9019",
                    //        "index_price": "9005.3",
                    //        "basis_rate": "0.185095",
                    //        "basis_value": "13.7",
                    //        "basis_impact_value": "100000",
                    //        "settle_price": "0",
                    //        "settle_price_interval": 60,
                    //        "settle_price_duration": 1800,
                    //        "settle_fee_rate": "0.0015",
                    //        "expire_time": 1593763200,
                    //        "order_price_round": "0.1",
                    //        "mark_price_round": "0.1",
                    //        "leverage_min": "1",
                    //        "leverage_max": "100",
                    //        "maintenance_rate": "1000000",
                    //        "risk_limit_base": "140.726652109199",
                    //        "risk_limit_step": "1000000",
                    //        "risk_limit_max": "8000000",
                    //        "maker_fee_rate": "-0.00025",
                    //        "taker_fee_rate": "0.00075",
                    //        "ref_discount_rate": "0",
                    //        "ref_rebate_rate": "0.2",
                    //        "order_price_deviate": "0.5",
                    //        "order_size_min": 1,
                    //        "order_size_max": 1000000,
                    //        "orders_limit": 50,
                    //        "orderbook_id": 63,
                    //        "trade_id": 26,
                    //        "trade_size": 435,
                    //        "position_size": 130,
                    //        "config_change_time": 1593158867,
                    //        "in_delisting": false
                    //    }
                    //
                    const id = this.safeString(market, 'name');
                    const parts = id.split('_');
                    const baseId = this.safeString(parts, 0);
                    const quoteId = this.safeString(parts, 1);
                    const date = this.safeString(parts, 2);
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    const settle = this.safeCurrencyCode(settleId);
                    const expiry = this.safeTimestamp(market, 'expire_time');
                    let symbol = '';
                    let marketType = 'swap';
                    if (date !== undefined) {
                        symbol = base + '/' + quote + ':' + settle + '-' + this.yymmdd(expiry, '');
                        marketType = 'future';
                    } else symbol = base + '/' + quote + ':' + settle;
                    const priceDeviate = this.safeString(market, 'order_price_deviate');
                    const markPrice = this.safeString(market, 'mark_price');
                    const minMultiplier = Precise.stringSub('1', priceDeviate);
                    const maxMultiplier = Precise.stringAdd('1', priceDeviate);
                    const minPrice = Precise.stringMul(minMultiplier, markPrice);
                    const maxPrice = Precise.stringMul(maxMultiplier, markPrice);
                    const takerPercent = this.safeString(market, 'taker_fee_rate');
                    const makerPercent = this.safeString(market, 'maker_fee_rate', takerPercent);
                    const isLinear = quote === settle;
                    return {
                        'id': id,
                        'symbol': symbol,
                        'base': base,
                        'quote': quote,
                        'settle': settle,
                        'baseId': baseId,
                        'quoteId': quoteId,
                        'settleId': settleId,
                        'type': marketType,
                        'spot': false,
                        'margin': false,
                        'swap': marketType === 'swap',
                        'future': marketType === 'future',
                        'option': marketType === 'option',
                        'active': true,
                        'contract': true,
                        'linear': isLinear,
                        'inverse': !isLinear,
                        'taker': this.parseNumber(Precise.stringDiv(takerPercent, '100')),
                        'maker': this.parseNumber(Precise.stringDiv(makerPercent, '100')),
                        'contractSize': this.safeNumber(market, 'quanto_multiplier'),
                        'expiry': expiry,
                        'expiryDatetime': this.iso8601(expiry),
                        'strike': undefined,
                        'optionType': undefined,
                        'precision': {
                            'amount': this.parseNumber('1'),
                            'price': this.safeNumber(market, 'order_price_round')
                        },
                        'limits': {
                            'leverage': {
                                'min': this.safeNumber(market, 'leverage_min'),
                                'max': this.safeNumber(market, 'leverage_max')
                            },
                            'amount': {
                                'min': this.safeNumber(market, 'order_size_min'),
                                'max': this.safeNumber(market, 'order_size_max')
                            },
                            'price': {
                                'min': this.parseNumber(minPrice),
                                'max': this.parseNumber(maxPrice)
                            },
                            'cost': {
                                'min': undefined,
                                'max': undefined
                            }
                        },
                        'info': market
                    };
                }
                async fetchOptionMarkets(params = {}) {
                    const result = [];
                    const underlyings = await this.fetchOptionUnderlyings();
                    for(let i = 0; i < underlyings.length; i++){
                        const underlying = underlyings[i];
                        const query = params;
                        query['underlying'] = underlying;
                        const response = await this.publicOptionsGetContracts(query);
                        //
                        //    [
                        //        {
                        //            "orders_limit": "50",
                        //            "order_size_max": "100000",
                        //            "mark_price_round": "0.1",
                        //            "order_size_min": "1",
                        //            "position_limit": "1000000",
                        //            "orderbook_id": "575967",
                        //            "order_price_deviate": "0.9",
                        //            "is_call": true, // true means Call false means Put
                        //            "last_price": "93.9",
                        //            "bid1_size": "0",
                        //            "bid1_price": "0",
                        //            "taker_fee_rate": "0.0004",
                        //            "underlying": "BTC_USDT",
                        //            "create_time": "1646381188",
                        //            "price_limit_fee_rate": "0.1",
                        //            "maker_fee_rate": "0.0004",
                        //            "trade_id": "727",
                        //            "order_price_round": "0.1",
                        //            "settle_fee_rate": "0.0001",
                        //            "trade_size": "1982",
                        //            "ref_rebate_rate": "0",
                        //            "name": "BTC_USDT-20220311-44000-C",
                        //            "underlying_price": "39194.26",
                        //            "strike_price": "44000",
                        //            "multiplier": "0.0001",
                        //            "ask1_price": "0",
                        //            "ref_discount_rate": "0",
                        //            "expiration_time": "1646985600",
                        //            "mark_price": "12.15",
                        //            "position_size": "4",
                        //            "ask1_size": "0",
                        //            "tag": "WEEK"
                        //        }
                        //    ]
                        //
                        for(let i = 0; i < response.length; i++){
                            const market = response[i];
                            const id = this.safeString(market, 'name');
                            const parts = underlying.split('_');
                            const baseId = this.safeString(parts, 0);
                            const quoteId = this.safeString(parts, 1);
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            let symbol = base + '/' + quote;
                            const expiry = this.safeTimestamp(market, 'expiration_time');
                            const strike = this.safeString(market, 'strike_price');
                            const isCall = this.safeValue(market, 'is_call');
                            const optionLetter = isCall ? 'C' : 'P';
                            const optionType = isCall ? 'call' : 'put';
                            symbol = symbol + ':' + quote + '-' + this.yymmdd(expiry) + ':' + strike + ':' + optionLetter;
                            const priceDeviate = this.safeString(market, 'order_price_deviate');
                            const markPrice = this.safeString(market, 'mark_price');
                            const minMultiplier = Precise.stringSub('1', priceDeviate);
                            const maxMultiplier = Precise.stringAdd('1', priceDeviate);
                            const minPrice = Precise.stringMul(minMultiplier, markPrice);
                            const maxPrice = Precise.stringMul(maxMultiplier, markPrice);
                            const takerPercent = this.safeString(market, 'taker_fee_rate');
                            const makerPercent = this.safeString(market, 'maker_fee_rate', takerPercent);
                            result.push({
                                'id': id,
                                'symbol': symbol,
                                'base': base,
                                'quote': quote,
                                'settle': quote,
                                'baseId': baseId,
                                'quoteId': quoteId,
                                'settleId': quoteId,
                                'type': 'option',
                                'spot': false,
                                'margin': false,
                                'swap': false,
                                'future': false,
                                'option': true,
                                'active': true,
                                'contract': true,
                                'linear': true,
                                'inverse': false,
                                'taker': this.parseNumber(Precise.stringDiv(takerPercent, '100')),
                                'maker': this.parseNumber(Precise.stringDiv(makerPercent, '100')),
                                'contractSize': this.parseNumber('1'),
                                'expiry': expiry,
                                'expiryDatetime': this.iso8601(expiry),
                                'strike': strike,
                                'optionType': optionType,
                                'precision': {
                                    'amount': this.parseNumber('1'),
                                    'price': this.safeNumber(market, 'order_price_round')
                                },
                                'limits': {
                                    'leverage': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'amount': {
                                        'min': this.safeNumber(market, 'order_size_min'),
                                        'max': this.safeNumber(market, 'order_size_max')
                                    },
                                    'price': {
                                        'min': this.parseNumber(minPrice),
                                        'max': this.parseNumber(maxPrice)
                                    },
                                    'cost': {
                                        'min': undefined,
                                        'max': undefined
                                    }
                                },
                                'info': market
                            });
                        }
                    }
                    return result;
                }
                async fetchOptionUnderlyings() {
                    const underlyingsResponse = await this.publicOptionsGetUnderlyings();
                    //
                    //    [
                    //        {
                    //            "index_time": "1646915796",
                    //            "name": "BTC_USDT",
                    //            "index_price": "39142.73"
                    //        }
                    //    ]
                    //
                    const underlyings = [];
                    for(let i = 0; i < underlyingsResponse.length; i++){
                        const underlying = underlyingsResponse[i];
                        const name = this.safeString(underlying, 'name');
                        if (name !== undefined) underlyings.push(name);
                    }
                    return underlyings;
                }
                prepareRequest(market, type, params = {}) {
                    /**
         * @ignore
         * @method
         * @name gateio#prepareRequest
         * @description Fills request params contract, settle, currency_pair, market and account where applicable
         * @param {dict} market CCXT market, required when type is undefined
         * @param {str} type 'spot', 'swap', or 'future', required when market is undefined
         * @param {dict} params request parameters
         * @returns the api request object, and the new params object with non-needed parameters removed
         */ // * Do not call for multi spot order methods like cancelAllOrders and fetchOpenOrders. Use multiOrderSpotPrepareRequest instead
                    const request = {};
                    if (market !== undefined) {
                        if (market['contract']) {
                            request['contract'] = market['id'];
                            request['settle'] = market['settleId'];
                        } else request['currency_pair'] = market['id'];
                    } else {
                        const swap = type === 'swap';
                        const future = type === 'future';
                        if (swap || future) {
                            const defaultSettle = swap ? 'usdt' : 'btc';
                            const settle = this.safeStringLower(params, 'settle', defaultSettle);
                            params = this.omit(params, 'settle');
                            request['settle'] = settle;
                        }
                    }
                    return [
                        request,
                        params
                    ];
                }
                spotOrderPrepareRequest(market, stop = false, params = {}) {
                    /**
         * @ignore
         * @method
         * @name gateio#multiOrderSpotPrepareRequest
         * @description Fills request params currency_pair, market and account where applicable for spot order methods like fetchOpenOrders, cancelAllOrders
         * @param {dict} market CCXT market
         * @param {bool} stop true if for a stop order
         * @param {dict} params request parameters
         * @returns the api request object, and the new params object with non-needed parameters removed
         */ const [marginMode, query] = this.getMarginMode(stop, params);
                    const request = {};
                    if (!stop) {
                        if (market === undefined) throw new ArgumentsRequired1(this.id + ' spotOrderPrepareRequest() requires a market argument for non-stop orders');
                        request['account'] = marginMode;
                        request['currency_pair'] = market['id']; // Should always be set for non-stop
                    }
                    return [
                        request,
                        query
                    ];
                }
                multiOrderSpotPrepareRequest(market, stop = false, params = {}) {
                    /**
         * @ignore
         * @method
         * @name gateio#multiOrderSpotPrepareRequest
         * @description Fills request params currency_pair, market and account where applicable for spot order methods like fetchOpenOrders, cancelAllOrders
         * @param {dict} market CCXT market
         * @param {bool} stop true if for a stop order
         * @param {dict} params request parameters
         * @returns the api request object, and the new params object with non-needed parameters removed
         */ const [marginMode, query] = this.getMarginMode(stop, params);
                    const request = {
                        'account': marginMode
                    };
                    if (market !== undefined) {
                        if (stop) // gateio spot and margin stop orders use the term market instead of currency_pair, and normal instead of spot. Neither parameter is used when fetching/cancelling a single order. They are used for creating a single stop order, but createOrder does not call this method
                        request['market'] = market['id'];
                        else request['currency_pair'] = market['id'];
                    }
                    return [
                        request,
                        query
                    ];
                }
                getMarginMode(stop, params) {
                    /**
         * @ignore
         * @method
         * @name gateio#getMarginMode
         * @description Gets the margin type for this api call
         * @param {bool} stop True if for a stop order
         * @param {dict} params Request params
         * @returns The marginMode and the updated request params with marginMode removed, marginMode value is the value that can be read by the "account" property specified in gateios api docs
         */ const defaultMarginMode = this.safeStringLower2(this.options, 'defaultMarginMode', 'marginMode', 'spot'); // 'margin' is isolated margin on gateio's api
                    let marginMode = this.safeStringLower2(params, 'marginMode', 'account', defaultMarginMode);
                    params = this.omit(params, [
                        'marginMode',
                        'account'
                    ]);
                    if (marginMode === 'cross') marginMode = 'cross_margin';
                    else if (marginMode === 'isolated') marginMode = 'margin';
                    else if (marginMode === '') marginMode = 'spot';
                    if (stop) {
                        if (marginMode === 'spot') // gateio spot stop orders use the term normal instead of spot
                        marginMode = 'normal';
                        if (marginMode === 'cross_margin') throw new BadRequest(this.id + ' getMarginMode() does not support stop orders for cross margin');
                    }
                    return [
                        marginMode,
                        params
                    ];
                }
                getSettlementCurrencies(type, method) {
                    const options = this.safeValue(this.options, type, {}); // [ 'BTC', 'USDT' ] unified codes
                    const fetchMarketsContractOptions = this.safeValue(options, method, {});
                    const defaultSettle = type === 'swap' ? [
                        'usdt'
                    ] : [
                        'btc'
                    ];
                    return this.safeValue(fetchMarketsContractOptions, 'settlementCurrencies', defaultSettle);
                }
                async fetchCurrencies(params = {}) {
                    // sandbox/testnet only supports future markets
                    const apiBackup = this.safeValue(this.urls, 'apiBackup');
                    if (apiBackup !== undefined) return undefined;
                    const response = await this.publicSpotGetCurrencies(params);
                    //
                    //    {
                    //        "currency": "BCN",
                    //        "delisted": false,
                    //        "withdraw_disabled": true,
                    //        "withdraw_delayed": false,
                    //        "deposit_disabled": true,
                    //        "trade_disabled": false
                    //    }
                    //
                    const result = {};
                    // TODO: remove magic constants
                    const amountPrecision = this.parseNumber('1e-6');
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const currencyId = this.safeString(entry, 'currency');
                        const currencyIdLower = this.safeStringLower(entry, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const delisted = this.safeValue(entry, 'delisted');
                        const withdrawDisabled = this.safeValue(entry, 'withdraw_disabled', false);
                        const depositDisabled = this.safeValue(entry, 'deposit_disabled', false);
                        const tradeDisabled = this.safeValue(entry, 'trade_disabled', false);
                        const withdrawEnabled = !withdrawDisabled;
                        const depositEnabled = !depositDisabled;
                        const tradeEnabled = !tradeDisabled;
                        const listed = !delisted;
                        const active = listed && tradeEnabled && withdrawEnabled && depositEnabled;
                        result[code] = {
                            'id': currencyId,
                            'lowerCaseId': currencyIdLower,
                            'name': undefined,
                            'code': code,
                            'precision': amountPrecision,
                            'info': entry,
                            'active': active,
                            'deposit': depositEnabled,
                            'withdraw': withdrawEnabled,
                            'fee': undefined,
                            'fees': [],
                            'limits': this.limits
                        };
                    }
                    return result;
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (!market['swap']) throw new BadSymbol(this.id + ' fetchFundingRate() supports swap contracts only');
                    const [request, query] = this.prepareRequest(market, undefined, params);
                    const response = await this.publicFuturesGetSettleContractsContract(this.extend(request, query));
                    //
                    //    [
                    //        {
                    //            "name": "BTC_USDT",
                    //            "type": "direct",
                    //            "quanto_multiplier": "0.0001",
                    //            "ref_discount_rate": "0",
                    //            "order_price_deviate": "0.5",
                    //            "maintenance_rate": "0.005",
                    //            "mark_type": "index",
                    //            "last_price": "38026",
                    //            "mark_price": "37985.6",
                    //            "index_price": "37954.92",
                    //            "funding_rate_indicative": "0.000219",
                    //            "mark_price_round": "0.01",
                    //            "funding_offset": 0,
                    //            "in_delisting": false,
                    //            "risk_limit_base": "1000000",
                    //            "interest_rate": "0.0003",
                    //            "order_price_round": "0.1",
                    //            "order_size_min": 1,
                    //            "ref_rebate_rate": "0.2",
                    //            "funding_interval": 28800,
                    //            "risk_limit_step": "1000000",
                    //            "leverage_min": "1",
                    //            "leverage_max": "100",
                    //            "risk_limit_max": "8000000",
                    //            "maker_fee_rate": "-0.00025",
                    //            "taker_fee_rate": "0.00075",
                    //            "funding_rate": "0.002053",
                    //            "order_size_max": 1000000,
                    //            "funding_next_apply": 1610035200,
                    //            "short_users": 977,
                    //            "config_change_time": 1609899548,
                    //            "trade_size": 28530850594,
                    //            "position_size": 5223816,
                    //            "long_users": 455,
                    //            "funding_impact_value": "60000",
                    //            "orders_limit": 50,
                    //            "trade_id": 10851092,
                    //            "orderbook_id": 2129638396
                    //        }
                    //    ]
                    //
                    return this.parseFundingRate(response);
                }
                async fetchFundingRates(symbols, params = {}) {
                    await this.loadMarkets();
                    const [request, query] = this.prepareRequest(undefined, 'swap', params);
                    const response = await this.publicFuturesGetSettleContracts(this.extend(request, query));
                    //
                    //    [
                    //        {
                    //            "name": "BTC_USDT",
                    //            "type": "direct",
                    //            "quanto_multiplier": "0.0001",
                    //            "ref_discount_rate": "0",
                    //            "order_price_deviate": "0.5",
                    //            "maintenance_rate": "0.005",
                    //            "mark_type": "index",
                    //            "last_price": "38026",
                    //            "mark_price": "37985.6",
                    //            "index_price": "37954.92",
                    //            "funding_rate_indicative": "0.000219",
                    //            "mark_price_round": "0.01",
                    //            "funding_offset": 0,
                    //            "in_delisting": false,
                    //            "risk_limit_base": "1000000",
                    //            "interest_rate": "0.0003",
                    //            "order_price_round": "0.1",
                    //            "order_size_min": 1,
                    //            "ref_rebate_rate": "0.2",
                    //            "funding_interval": 28800,
                    //            "risk_limit_step": "1000000",
                    //            "leverage_min": "1",
                    //            "leverage_max": "100",
                    //            "risk_limit_max": "8000000",
                    //            "maker_fee_rate": "-0.00025",
                    //            "taker_fee_rate": "0.00075",
                    //            "funding_rate": "0.002053",
                    //            "order_size_max": 1000000,
                    //            "funding_next_apply": 1610035200,
                    //            "short_users": 977,
                    //            "config_change_time": 1609899548,
                    //            "trade_size": 28530850594,
                    //            "position_size": 5223816,
                    //            "long_users": 455,
                    //            "funding_impact_value": "60000",
                    //            "orders_limit": 50,
                    //            "trade_id": 10851092,
                    //            "orderbook_id": 2129638396
                    //        }
                    //    ]
                    //
                    const result = this.parseFundingRates(response);
                    return this.filterByArray(result, 'symbol', symbols);
                }
                parseFundingRate(contract, market) {
                    //
                    //    {
                    //        "name": "BTC_USDT",
                    //        "type": "direct",
                    //        "quanto_multiplier": "0.0001",
                    //        "ref_discount_rate": "0",
                    //        "order_price_deviate": "0.5",
                    //        "maintenance_rate": "0.005",
                    //        "mark_type": "index",
                    //        "last_price": "38026",
                    //        "mark_price": "37985.6",
                    //        "index_price": "37954.92",
                    //        "funding_rate_indicative": "0.000219",
                    //        "mark_price_round": "0.01",
                    //        "funding_offset": 0,
                    //        "in_delisting": false,
                    //        "risk_limit_base": "1000000",
                    //        "interest_rate": "0.0003",
                    //        "order_price_round": "0.1",
                    //        "order_size_min": 1,
                    //        "ref_rebate_rate": "0.2",
                    //        "funding_interval": 28800,
                    //        "risk_limit_step": "1000000",
                    //        "leverage_min": "1",
                    //        "leverage_max": "100",
                    //        "risk_limit_max": "8000000",
                    //        "maker_fee_rate": "-0.00025",
                    //        "taker_fee_rate": "0.00075",
                    //        "funding_rate": "0.002053",
                    //        "order_size_max": 1000000,
                    //        "funding_next_apply": 1610035200,
                    //        "short_users": 977,
                    //        "config_change_time": 1609899548,
                    //        "trade_size": 28530850594,
                    //        "position_size": 5223816,
                    //        "long_users": 455,
                    //        "funding_impact_value": "60000",
                    //        "orders_limit": 50,
                    //        "trade_id": 10851092,
                    //        "orderbook_id": 2129638396
                    //    }
                    //
                    const marketId = this.safeString(contract, 'name');
                    const symbol = this.safeSymbol(marketId, market);
                    const markPrice = this.safeNumber(contract, 'mark_price');
                    const indexPrice = this.safeNumber(contract, 'index_price');
                    const interestRate = this.safeNumber(contract, 'interest_rate');
                    const fundingRate = this.safeNumber(contract, 'funding_rate');
                    const fundingTime = this.safeInteger(contract, 'funding_next_apply') * 1000;
                    const fundingRateIndicative = this.safeNumber(contract, 'funding_rate_indicative');
                    return {
                        'info': contract,
                        'symbol': symbol,
                        'markPrice': markPrice,
                        'indexPrice': indexPrice,
                        'interestRate': interestRate,
                        'estimatedSettlePrice': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'fundingRate': fundingRate,
                        'fundingTimestamp': fundingTime,
                        'fundingDatetime': this.iso8601(fundingTime),
                        'nextFundingRate': fundingRateIndicative,
                        'nextFundingTimestamp': undefined,
                        'nextFundingDatetime': undefined,
                        'previousFundingRate': undefined,
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                async fetchNetworkDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateWalletGetDepositAddress(this.extend(request, params));
                    const addresses = this.safeValue(response, 'multichain_addresses');
                    const currencyId = this.safeString(response, 'currency');
                    code = this.safeCurrencyCode(currencyId);
                    const result = {};
                    for(let i = 0; i < addresses.length; i++){
                        const entry = addresses[i];
                        //
                        //    {
                        //        "chain": "ETH",
                        //        "address": "0x359a697945E79C7e17b634675BD73B33324E9408",
                        //        "payment_id": "",
                        //        "payment_name": "",
                        //        "obtain_failed": "0"
                        //    }
                        //
                        const obtainFailed = this.safeInteger(entry, 'obtain_failed');
                        if (obtainFailed) continue;
                        const network = this.safeString(entry, 'chain');
                        const address = this.safeString(entry, 'address');
                        let tag = this.safeString(entry, 'payment_id');
                        const tagLength = tag.length;
                        tag = tagLength ? tag : undefined;
                        result[network] = {
                            'info': entry,
                            'code': code,
                            'address': address,
                            'tag': tag
                        };
                    }
                    return result;
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateWalletGetDepositAddress(this.extend(request, params));
                    //
                    //    {
                    //        "currency": "XRP",
                    //        "address": "rHcFoo6a9qT5NHiVn1THQRhsEGcxtYCV4d 391331007",
                    //        "multichain_addresses": [
                    //            {
                    //                "chain": "XRP",
                    //                "address": "rHcFoo6a9qT5NHiVn1THQRhsEGcxtYCV4d",
                    //                "payment_id": "391331007",
                    //                "payment_name": "Tag",
                    //                "obtain_failed": 0
                    //            }
                    //        ]
                    //    }
                    //
                    const currencyId = this.safeString(response, 'currency');
                    code = this.safeCurrencyCode(currencyId);
                    const addressField = this.safeString(response, 'address');
                    let tag = undefined;
                    let address = undefined;
                    if (addressField.indexOf(' ') >= 0) {
                        const splitted = addressField.split(' ');
                        address = splitted[0];
                        tag = splitted[1];
                    } else address = addressField;
                    return {
                        'info': response,
                        'code': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined
                    };
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency_pair': market['id']
                    };
                    const response = await this.privateWalletGetFee(this.extend(request, params));
                    //
                    //    {
                    //        "user_id": 1486602,
                    //        "taker_fee": "0.002",
                    //        "maker_fee": "0.002",
                    //        "gt_discount": true,
                    //        "gt_taker_fee": "0.0015",
                    //        "gt_maker_fee": "0.0015",
                    //        "loan_fee": "0.18",
                    //        "point_type": "0",
                    //        "futures_taker_fee": "0.0005",
                    //        "futures_maker_fee": "0"
                    //    }
                    //
                    return this.parseTradingFee(response, market);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateWalletGetFee(params);
                    //
                    //    {
                    //        "user_id": 1486602,
                    //        "taker_fee": "0.002",
                    //        "maker_fee": "0.002",
                    //        "gt_discount": true,
                    //        "gt_taker_fee": "0.0015",
                    //        "gt_maker_fee": "0.0015",
                    //        "loan_fee": "0.18",
                    //        "point_type": "0",
                    //        "futures_taker_fee": "0.0005",
                    //        "futures_maker_fee": "0"
                    //    }
                    //
                    return this.parseTradingFees(response);
                }
                parseTradingFees(response) {
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        result[symbol] = this.parseTradingFee(response, market);
                    }
                    return result;
                }
                parseTradingFee(info, market) {
                    //
                    //    {
                    //        "user_id": 1486602,
                    //        "taker_fee": "0.002",
                    //        "maker_fee": "0.002",
                    //        "gt_discount": true,
                    //        "gt_taker_fee": "0.0015",
                    //        "gt_maker_fee": "0.0015",
                    //        "loan_fee": "0.18",
                    //        "point_type": "0",
                    //        "futures_taker_fee": "0.0005",
                    //        "futures_maker_fee": "0"
                    //    }
                    //
                    const contract = this.safeValue(market, 'contract');
                    const takerKey = contract ? 'futures_taker_fee' : 'taker_fee';
                    const makerKey = contract ? 'futures_maker_fee' : 'maker_fee';
                    return {
                        'info': info,
                        'symbol': this.safeString(market, 'symbol'),
                        'maker': this.safeNumber(info, makerKey),
                        'taker': this.safeNumber(info, takerKey)
                    };
                }
                async fetchFundingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateWalletGetWithdrawStatus(params);
                    //
                    //    {
                    //        "currency": "MTN",
                    //        "name": "Medicalchain",
                    //        "name_cn": "Medicalchain",
                    //        "deposit": "0",
                    //        "withdraw_percent": "0%",
                    //        "withdraw_fix": "900",
                    //        "withdraw_day_limit": "500000",
                    //        "withdraw_day_limit_remain": "500000",
                    //        "withdraw_amount_mini": "900.1",
                    //        "withdraw_eachtime_limit": "90000000000",
                    //        "withdraw_fix_on_chains": {
                    //            "ETH": "900"
                    //        }
                    //    }
                    //
                    const withdrawFees = {};
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const currencyId = this.safeString(entry, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        withdrawFees[code] = {};
                        let withdrawFix = this.safeValue(entry, 'withdraw_fix_on_chains');
                        if (withdrawFix === undefined) {
                            withdrawFix = {};
                            withdrawFix[code] = this.safeNumber(entry, 'withdraw_fix');
                        }
                        const keys = Object.keys(withdrawFix);
                        for(let i = 0; i < keys.length; i++){
                            const key = keys[i];
                            withdrawFees[code][key] = this.parseNumber(withdrawFix[key]);
                        }
                    }
                    return {
                        'info': response,
                        'withdraw': withdrawFees,
                        'deposit': {}
                    };
                }
                async fetchFundingHistory(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    // let defaultType = 'future';
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const [type, query] = this.handleMarketTypeAndParams('fetchFundingHistory', market, params);
                    const [request, requestParams] = this.prepareRequest(market, type, query);
                    request['type'] = 'fund'; // 'dnw' 'pnl' 'fee' 'refr' 'fund' 'point_dnw' 'point_fee' 'point_refr'
                    if (since !== undefined) request['from'] = since / 1000;
                    if (limit !== undefined) request['limit'] = limit;
                    const method = this.getSupportedMapping(type, {
                        'swap': 'privateFuturesGetSettleAccountBook',
                        'future': 'privateDeliveryGetSettleAccountBook'
                    });
                    const response = await this[method](this.extend(request, requestParams));
                    //
                    //    [
                    //        {
                    //            "time": 1646899200,
                    //            "change": "-0.027722",
                    //            "balance": "11.653120591841",
                    //            "text": "XRP_USDT",
                    //            "type": "fund"
                    //        },
                    //        ...
                    //    ]
                    //
                    return this.parseFundingHistories(response, symbol, since, limit);
                }
                parseFundingHistories(response, symbol, since, limit) {
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const funding = this.parseFundingHistory(entry);
                        result.push(funding);
                    }
                    const sorted = this.sortBy(result, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, symbol, since, limit);
                }
                parseFundingHistory(info, market) {
                    //
                    //    {
                    //        "time": 1646899200,
                    //        "change": "-0.027722",
                    //        "balance": "11.653120591841",
                    //        "text": "XRP_USDT",
                    //        "type": "fund"
                    //    }
                    //
                    const timestamp = this.safeTimestamp(info, 'time');
                    const marketId = this.safeString(info, 'text');
                    market = this.safeMarket(marketId, market);
                    return {
                        'info': info,
                        'symbol': this.safeString(market, 'symbol'),
                        'code': this.safeString(market, 'settle'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'id': undefined,
                        'amount': this.safeNumber(info, 'change')
                    };
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    //
                    //     const request = {
                    //         'currency_pair': market['id'],
                    //         'interval': '0', // depth, 0 means no aggregation is applied, default to 0
                    //         'limit': limit, // maximum number of order depth data in asks or bids
                    //         'with_id': true, // return order book ID
                    //     };
                    //
                    const [request, query] = this.prepareRequest(market, undefined, params);
                    const method = this.getSupportedMapping(market['type'], {
                        'spot': 'publicSpotGetOrderBook',
                        'margin': 'publicSpotGetOrderBook',
                        'swap': 'publicFuturesGetSettleOrderBook',
                        'future': 'publicDeliveryGetSettleOrderBook'
                    });
                    if (limit !== undefined) request['limit'] = limit; // default 10, max 100
                    request['with_id'] = true;
                    const response = await this[method](this.extend(request, query));
                    //
                    // SPOT
                    //
                    //     {
                    //         "id": 6358770031
                    //         "current": 1634345973275,
                    //         "update": 1634345973271,
                    //         "asks": [
                    //             ["2.2241","12449.827"],
                    //             ["2.2242","200"],
                    //             ["2.2244","826.931"],
                    //             ["2.2248","3876.107"],
                    //             ["2.225","2377.252"],
                    //             ["2.22509","439.484"],
                    //             ["2.2251","1489.313"],
                    //             ["2.2253","714.582"],
                    //             ["2.2254","1349.784"],
                    //             ["2.2256","234.701"]],
                    //          "bids": [
                    //             ["2.2236","32.465"],
                    //             ["2.2232","243.983"],
                    //             ["2.2231","32.207"],
                    //             ["2.223","449.827"],
                    //             ["2.2228","7.918"],
                    //             ["2.2227","12703.482"],
                    //             ["2.2226","143.033"],
                    //             ["2.2225","143.027"],
                    //             ["2.2224","1369.352"],
                    //             ["2.2223","756.063"]
                    //         ]
                    //     }
                    //
                    // Perpetual Swap
                    //
                    //     {
                    //         "id": 6358770031
                    //         "current": 1634350208.745,
                    //         "asks": [
                    //             {"s": 24909, "p": "61264.8"},
                    //             {"s": 81, "p": "61266.6"},
                    //             {"s": 2000, "p": "61267.6"},
                    //             {"s": 490, "p": "61270.2"},
                    //             {"s": 12, "p": "61270.4"},
                    //             {"s": 11782, "p": "61273.2"},
                    //             {"s": 14666, "p": "61273.3"},
                    //             {"s": 22541, "p": "61273.4"},
                    //             {"s": 33, "p": "61273.6"},
                    //             {"s": 11980, "p": "61274.5"}
                    //         ],
                    //         "bids": [
                    //             {"s": 41844, "p": "61264.7"},
                    //             {"s": 13783, "p": "61263.3"},
                    //             {"s": 1143, "p": "61259.8"},
                    //             {"s": 81, "p": "61258.7"},
                    //             {"s": 2471, "p": "61257.8"},
                    //             {"s": 2471, "p": "61257.7"},
                    //             {"s": 2471, "p": "61256.5"},
                    //             {"s": 3, "p": "61254.2"},
                    //             {"s": 114, "p": "61252.4"},
                    //             {"s": 14372, "p": "61248.6"}
                    //         ],
                    //         "update": 1634350208.724
                    //     }
                    //
                    let timestamp = this.safeInteger(response, 'current');
                    if (!market['spot']) timestamp = timestamp * 1000;
                    const priceKey = market['spot'] ? 0 : 'p';
                    const amountKey = market['spot'] ? 1 : 's';
                    const nonce = this.safeInteger(response, 'id');
                    const result = this.parseOrderBook(response, symbol, timestamp, 'bids', 'asks', priceKey, amountKey);
                    result['nonce'] = nonce;
                    return result;
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [request, query] = this.prepareRequest(market, undefined, params);
                    const method = this.getSupportedMapping(market['type'], {
                        'spot': 'publicSpotGetTickers',
                        'margin': 'publicSpotGetTickers',
                        'swap': 'publicFuturesGetSettleTickers',
                        'future': 'publicDeliveryGetSettleTickers'
                    });
                    const response = await this[method](this.extend(request, query));
                    const ticker = this.safeValue(response, 0);
                    return this.parseTicker(ticker, market);
                }
                parseTicker(ticker, market) {
                    //
                    // SPOT
                    //
                    //     {
                    //         "currency_pair": "KFC_USDT",
                    //         "last": "7.255",
                    //         "lowest_ask": "7.298",
                    //         "highest_bid": "7.218",
                    //         "change_percentage": "-1.18",
                    //         "base_volume": "1219.053687865",
                    //         "quote_volume": "8807.40299875455",
                    //         "high_24h": "7.262",
                    //         "low_24h": "7.095"
                    //     }
                    //
                    // LINEAR/DELIVERY
                    //
                    //     {
                    //         "contract": "BTC_USDT",
                    //         "last": "6432",
                    //         "low_24h": "6278",
                    //         "high_24h": "6790",
                    //         "change_percentage": "4.43",
                    //         "total_size": "32323904",
                    //         "volume_24h": "184040233284",
                    //         "volume_24h_btc": "28613220",
                    //         "volume_24h_usd": "184040233284",
                    //         "volume_24h_base": "28613220",
                    //         "volume_24h_quote": "184040233284",
                    //         "volume_24h_settle": "28613220",
                    //         "mark_price": "6534",
                    //         "funding_rate": "0.0001",
                    //         "funding_rate_indicative": "0.0001",
                    //         "index_price": "6531"
                    //     }
                    //
                    const marketId = this.safeString2(ticker, 'currency_pair', 'contract');
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeString(ticker, 'last');
                    const ask = this.safeString(ticker, 'lowest_ask');
                    const bid = this.safeString(ticker, 'highest_bid');
                    const high = this.safeString(ticker, 'high_24h');
                    const low = this.safeString(ticker, 'low_24h');
                    const baseVolume = this.safeString2(ticker, 'base_volume', 'volume_24h_base');
                    const quoteVolume = this.safeString2(ticker, 'quote_volume', 'volume_24h_quote');
                    const percentage = this.safeString(ticker, 'change_percentage');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'high': high,
                        'low': low,
                        'bid': bid,
                        'bidVolume': undefined,
                        'ask': ask,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const [type, query] = this.handleMarketTypeAndParams('fetchTickers', undefined, params);
                    const [request, requestParams] = this.prepareRequest(undefined, type, query);
                    const method = this.getSupportedMapping(type, {
                        'spot': 'publicSpotGetTickers',
                        'margin': 'publicSpotGetTickers',
                        'swap': 'publicFuturesGetSettleTickers',
                        'future': 'publicDeliveryGetSettleTickers'
                    });
                    const response = await this[method](this.extend(request, requestParams));
                    return this.parseTickers(response, symbols);
                }
                fetchBalanceHelper(entry) {
                    const account = this.account();
                    account['used'] = this.safeString2(entry, 'freeze', 'locked');
                    account['free'] = this.safeString(entry, 'available');
                    account['total'] = this.safeString(entry, 'total');
                    return account;
                }
                async fetchBalance(params = {}) {
                    /**
         * @param {dict} params exchange specific parameters
         * @param {str} params.type spot, margin, swap or future, if not provided this.options['defaultType'] is used
         * @param {str} params.settle 'btc' or 'usdt' - settle currency for perpetual swap and future - default="usdt" for swap and "btc" for future
         * @param {str} params.marginMode 'cross' or 'isolated' - marginMode for margin trading if not provided this.options['defaultMarginMode'] is used
         * @param {str} params.symbol margin only - unified ccxt symbol
         */ await this.loadMarkets();
                    const symbol = this.safeString(params, 'symbol');
                    params = this.omit(params, 'symbol');
                    const [type, query] = this.handleMarketTypeAndParams('fetchBalance', undefined, params);
                    const [request, requestParams] = this.prepareRequest(undefined, type, query);
                    const [marginMode, requestQuery] = this.getMarginMode(false, requestParams);
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        request['currency_pair'] = market['id'];
                    }
                    const method = this.getSupportedMapping(type, {
                        'spot': this.getSupportedMapping(marginMode, {
                            'spot': 'privateSpotGetAccounts',
                            'margin': 'privateMarginGetAccounts',
                            'cross_margin': 'privateMarginGetCrossAccounts'
                        }),
                        'funding': 'privateMarginGetFundingAccounts',
                        'swap': 'privateFuturesGetSettleAccounts',
                        'future': 'privateDeliveryGetSettleAccounts'
                    });
                    let response = await this[method](this.extend(request, requestQuery));
                    const contract = type === 'swap' || type === 'future';
                    if (contract) response = [
                        response
                    ];
                    //
                    // Spot / margin funding
                    //
                    //     [
                    //         {
                    //             "currency": "DBC",
                    //             "available": "0",
                    //             "locked": "0"
                    //             "lent": "0", // margin funding only
                    //             "total_lent": "0" // margin funding only
                    //         },
                    //         ...
                    //     ]
                    //
                    //  Margin
                    //
                    //    [
                    //        {
                    //            "currency_pair": "DOGE_USDT",
                    //            "locked": false,
                    //            "risk": "9999.99",
                    //            "base": {
                    //                "currency": "DOGE",
                    //                "available": "0",
                    //                "locked": "0",
                    //                "borrowed": "0",
                    //                "interest": "0"
                    //            },
                    //            "quote": {
                    //                "currency": "USDT",
                    //                "available": "0.73402",
                    //                "locked": "0",
                    //                "borrowed": "0",
                    //                "interest": "0"
                    //            }
                    //        },
                    //        ...
                    //    ]
                    //
                    // Cross margin
                    //
                    //    {
                    //        "user_id": 10406147,
                    //        "locked": false,
                    //        "balances": {
                    //            "USDT": {
                    //                "available": "1",
                    //                "freeze": "0",
                    //                "borrowed": "0",
                    //                "interest": "0"
                    //            }
                    //        },
                    //        "total": "1",
                    //        "borrowed": "0",
                    //        "interest": "0",
                    //        "risk": "9999.99"
                    //    }
                    //
                    //  Perpetual Swap
                    //
                    //    {
                    //        order_margin: "0",
                    //        point: "0",
                    //        bonus: "0",
                    //        history: {
                    //            dnw: "2.1321",
                    //            pnl: "11.5351",
                    //            refr: "0",
                    //            point_fee: "0",
                    //            fund: "-0.32340576684",
                    //            bonus_dnw: "0",
                    //            point_refr: "0",
                    //            bonus_offset: "0",
                    //            fee: "-0.20132775",
                    //            point_dnw: "0",
                    //        },
                    //        unrealised_pnl: "13.315100000006",
                    //        total: "12.51345151332",
                    //        available: "0",
                    //        in_dual_mode: false,
                    //        currency: "USDT",
                    //        position_margin: "12.51345151332",
                    //        user: "6333333",
                    //    }
                    //
                    // Delivery Future
                    //
                    //    {
                    //        order_margin: "0",
                    //        point: "0",
                    //        history: {
                    //            dnw: "1",
                    //            pnl: "0",
                    //            refr: "0",
                    //            point_fee: "0",
                    //            point_dnw: "0",
                    //            settle: "0",
                    //            settle_fee: "0",
                    //            point_refr: "0",
                    //            fee: "0",
                    //        },
                    //        unrealised_pnl: "0",
                    //        total: "1",
                    //        available: "1",
                    //        currency: "USDT",
                    //        position_margin: "0",
                    //        user: "6333333",
                    //    }
                    //
                    const result = {
                        'info': response
                    };
                    const crossMargin = marginMode === 'cross_margin';
                    const margin = marginMode === 'margin';
                    let data = response;
                    if ('balances' in data) {
                        const flatBalances = [];
                        const balances = this.safeValue(data, 'balances', []);
                        // inject currency and create an artificial balance object
                        // so it can follow the existent flow
                        const keys = Object.keys(balances);
                        for(let i = 0; i < keys.length; i++){
                            const currencyId = keys[i];
                            const content = balances[currencyId];
                            content['currency'] = currencyId;
                            flatBalances.push(content);
                        }
                        data = flatBalances;
                    }
                    for(let i = 0; i < data.length; i++){
                        const entry = data[i];
                        if (margin && !crossMargin) {
                            const marketId = this.safeString(entry, 'currency_pair');
                            const symbol = this.safeSymbol(marketId, undefined, '_');
                            const base = this.safeValue(entry, 'base', {});
                            const quote = this.safeValue(entry, 'quote', {});
                            const baseCode = this.safeCurrencyCode(this.safeString(base, 'currency', {}));
                            const quoteCode = this.safeCurrencyCode(this.safeString(quote, 'currency', {}));
                            const subResult = {};
                            subResult[baseCode] = this.fetchBalanceHelper(base);
                            subResult[quoteCode] = this.fetchBalanceHelper(quote);
                            result[symbol] = this.safeBalance(subResult);
                        } else {
                            const code = this.safeCurrencyCode(this.safeString(entry, 'currency', {}));
                            result[code] = this.fetchBalanceHelper(entry);
                        }
                    }
                    return margin && !crossMargin ? result : this.safeBalance(result);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const price = this.safeString(params, 'price');
                    let request = {};
                    [request, params] = this.prepareRequest(market, undefined, params);
                    request['interval'] = this.timeframes[timeframe];
                    let method = 'publicSpotGetCandlesticks';
                    if (market['contract']) {
                        const maxLimit = 1999;
                        limit = limit === undefined ? maxLimit : Math.min(limit, maxLimit);
                        if (market['future']) method = 'publicDeliveryGetSettleCandlesticks';
                        else if (market['swap']) method = 'publicFuturesGetSettleCandlesticks';
                        const isMark = price === 'mark';
                        const isIndex = price === 'index';
                        if (isMark || isIndex) {
                            request['contract'] = price + '_' + market['id'];
                            params = this.omit(params, 'price');
                        }
                    } else {
                        const maxLimit = 1000;
                        limit = limit === undefined ? maxLimit : Math.min(limit, maxLimit);
                        request['limit'] = limit;
                    }
                    if (since !== undefined) {
                        const duration = this.parseTimeframe(timeframe);
                        request['from'] = parseInt(since / 1000);
                        const toTimestamp = this.sum(request['from'], limit * duration - 1);
                        const currentTimestamp = this.seconds();
                        request['to'] = Math.min(toTimestamp, currentTimestamp);
                    }
                    const response = await this[method](this.extend(request, params));
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                async fetchMarkOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'mark'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchFundingRateHistory(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchFundingRateHistory() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (!market['swap']) throw new BadSymbol(this.id + ' fetchFundingRateHistory() supports swap contracts only');
                    const [request, query] = this.prepareRequest(market, undefined, params);
                    if (limit !== undefined) request['limit'] = limit;
                    const method = 'publicFuturesGetSettleFundingRate';
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //         "r": "0.00063521",
                    //         "t": "1621267200000",
                    //     }
                    //
                    const rates = [];
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const timestamp = this.safeTimestamp(entry, 't');
                        rates.push({
                            'info': entry,
                            'symbol': symbol,
                            'fundingRate': this.safeNumber(entry, 'r'),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp)
                        });
                    }
                    const sorted = this.sortBy(rates, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, market['symbol'], since, limit);
                }
                async fetchIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'index'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                parseOHLCV(ohlcv, market) {
                    //
                    // Spot market candles
                    //
                    //     [
                    //         "1626163200",           // Unix timestamp in seconds
                    //         "346711.933138181617",  // Trading volume
                    //         "33165.23",             // Close price
                    //         "33260",                // Highest price
                    //         "33117.6",              // Lowest price
                    //         "33184.47"              // Open price
                    //     ]
                    //
                    // Mark and Index price candles
                    //
                    //     {
                    //          "t":1632873600,         // Unix timestamp in seconds
                    //          "o": "41025",           // Open price
                    //          "h": "41882.17",        // Highest price
                    //          "c": "41776.92",        // Close price
                    //          "l": "40783.94"         // Lowest price
                    //     }
                    //
                    if (Array.isArray(ohlcv)) return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 5),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 1)
                    ];
                    else // Mark and Index price candles
                    return [
                        this.safeTimestamp(ohlcv, 't'),
                        this.safeNumber(ohlcv, 'o'),
                        this.safeNumber(ohlcv, 'h'),
                        this.safeNumber(ohlcv, 'l'),
                        this.safeNumber(ohlcv, 'c'),
                        this.safeNumber(ohlcv, 'v')
                    ];
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    //
                    // spot
                    //
                    //     const request = {
                    //         'currency_pair': market['id'],
                    //         'limit': limit, // maximum number of records to be returned in a single list
                    //         'last_id': 'id', // specify list staring point using the id of last record in previous list-query results
                    //         'reverse': false, // true to retrieve records where id is smaller than the specified last_id, false to retrieve records where id is larger than the specified last_id
                    //     };
                    //
                    // swap, future
                    //
                    //     const request = {
                    //         'settle': market['settleId'],
                    //         'contract': market['id'],
                    //         'limit': limit, // maximum number of records to be returned in a single list
                    //         'last_id': 'id', // specify list staring point using the id of last record in previous list-query results
                    //         'from': since / 1000), // starting time in seconds, if not specified, to and limit will be used to limit response items
                    //         'to': this.seconds (), // end time in seconds, default to current time
                    //     };
                    //
                    const [request, query] = this.prepareRequest(market, undefined, params);
                    const method = this.getSupportedMapping(market['type'], {
                        'spot': 'publicSpotGetTrades',
                        'margin': 'publicSpotGetTrades',
                        'swap': 'publicFuturesGetSettleTrades',
                        'future': 'publicDeliveryGetSettleTrades'
                    });
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 1000
                    if (since !== undefined && market['contract']) request['from'] = parseInt(since / 1000);
                    const response = await this[method](this.extend(request, query));
                    //
                    // spot
                    //
                    //     [
                    //         {
                    //             id: "1852958144",
                    //             create_time: "1634673259",
                    //             create_time_ms: "1634673259378.105000",
                    //             currency_pair: "ADA_USDT",
                    //             side: "sell",
                    //             amount: "307.078",
                    //             price: "2.104",
                    //         }
                    //     ]
                    //
                    // perpetual swap
                    //
                    //     [
                    //         {
                    //              size: "2",
                    //              id: "2522911",
                    //              create_time_ms: "1634673380.182",
                    //              create_time: "1634673380.182",
                    //              contract: "ADA_USDT",
                    //              price: "2.10486",
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    /**
         * @method
         * @name gateio#fetchMyTrades
         * @description Fetch personal trading history
         * @param {str} symbol The symbol for the market to fetch trades for
         * @param {int} since The earliest timestamp, in ms, that fetched trades were made
         * @param {int} limit The max number of trades to fetch
         * @param {dict} params Exchange specific parameters
         * @param {str} params.marginMode 'cross' or 'isolated' - marginMode for margin trading if not provided this.options['defaultMarginMode'] is used
         * @param {str} params.type 'spot', 'swap', or 'future', if not provided this.options['defaultMarginMode'] is used
         * @param {int} params.till The latest timestamp, in ms, that fetched trades were made
         * @param {int} params.page *spot only* Page number
         * @param {str} params.order_id *spot only* Filter trades with specified order ID. symbol is also required if this field is present
         * @param {str} params.order *contract only* Futures order ID, return related data only if specified
         * @param {int} params.offset *contract only* list offset, starting from 0
         * @param {str} params.last_id *contract only* specify list staring point using the id of last record in previous list-query results
         * @param {int} params.count_total *contract only* whether to return total number matched, default to 0(no return)
         * @returns a list of [order structures]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ await this.loadMarkets();
                    let type = undefined;
                    let marginMode = undefined;
                    let request = {};
                    const market = symbol !== undefined ? this.market(symbol) : undefined;
                    const till = this.safeNumber(params, 'till');
                    params = this.omit(params, 'till');
                    [type, params] = this.handleMarketTypeAndParams('fetchMyTrades', market, params);
                    const contract = type === 'swap' || type === 'future';
                    if (contract) [request, params] = this.prepareRequest(market, type, params);
                    else {
                        if (market !== undefined) request['currency_pair'] = market['id']; // Should always be set for non-stop
                        [marginMode, params] = this.getMarginMode(false, params);
                        request['account'] = marginMode;
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 1000
                    if (since !== undefined) request['from'] = parseInt(since / 1000);
                    if (till !== undefined) request['to'] = parseInt(till / 1000);
                    const method = this.getSupportedMapping(type, {
                        'spot': 'privateSpotGetMyTrades',
                        'margin': 'privateSpotGetMyTrades',
                        'swap': 'privateFuturesGetSettleMyTrades',
                        'future': 'privateDeliveryGetSettleMyTrades'
                    });
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     [
                    //         {
                    //             "id": "2876130500",
                    //             "create_time": "1645464610",
                    //             "create_time_ms": "1645464610777.399200",
                    //             "currency_pair": "DOGE_USDT",
                    //             "side": "sell",
                    //             "role": "taker",
                    //             "amount": "10.97",
                    //             "price": "0.137384",
                    //             "order_id": "125924049993",
                    //             "fee": "0.00301420496",
                    //             "fee_currency": "USDT",
                    //             "point_fee": "0",
                    //             "gt_fee": "0"
                    //         }
                    //     ]
                    //
                    // perpetual swap
                    //
                    //     [
                    //         {
                    //             "size": -5,
                    //             "order_id": "130264979823",
                    //             "id": 26884791,
                    //             "role": "taker",
                    //             "create_time": 1645465199.5472,
                    //             "contract": "DOGE_USDT",
                    //             "price": "0.136888"
                    //         }
                    //     ]
                    //
                    // future
                    //
                    //     [
                    //         {
                    //             "id": 121234231,
                    //             "create_time": 1514764800.123,
                    //             "contract": "BTC_USDT",
                    //             "order_id": "21893289839",
                    //             "size": 100,
                    //             "price": "100.123",
                    //             "role": "taker"
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // public
                    //
                    //     {
                    //         "id": "1334253759",
                    //         "create_time": "1626342738",
                    //         "create_time_ms": "1626342738331.497000",
                    //         "currency_pair": "BTC_USDT",
                    //         "side": "sell",
                    //         "amount": "0.0022",
                    //         "price": "32452.16"
                    //     }
                    //
                    // public ws
                    //
                    //     {
                    //         id: 221994511,
                    //         time: 1580311438.618647,
                    //         price: '9309',
                    //         amount: '0.0019',
                    //         type: 'sell'
                    //     }
                    //
                    // spot rest
                    //
                    //     {
                    //         "id": "2876130500",
                    //         "create_time": "1645464610",
                    //         "create_time_ms": "1645464610777.399200",
                    //         "currency_pair": "DOGE_USDT",
                    //         "side": "sell",
                    //         "role": "taker",
                    //         "amount": "10.97",
                    //         "price": "0.137384",
                    //         "order_id": "125924049993",
                    //         "fee": "0.00301420496",
                    //         "fee_currency": "USDT",
                    //         "point_fee": "0","gt_fee":"0"
                    //     }
                    //
                    // perpetual swap rest
                    //
                    //     {
                    //         "size": -5,
                    //         "order_id": "130264979823",
                    //         "id": 26884791,
                    //         "role": "taker",
                    //         "create_time": 1645465199.5472,
                    //         "contract": "DOGE_USDT",
                    //         "price": "0.136888"
                    //     }
                    //
                    // future rest
                    //
                    //     {
                    //         "id": 121234231,
                    //         "create_time": 1514764800.123,
                    //         "contract": "BTC_USDT",
                    //         "order_id": "21893289839",
                    //         "size": 100,
                    //         "price": "100.123",
                    //         "role": "taker"
                    //     }
                    //
                    const id = this.safeString(trade, 'id');
                    let timestamp = this.safeTimestamp2(trade, 'time', 'create_time');
                    timestamp = this.safeInteger(trade, 'create_time_ms', timestamp);
                    const marketId = this.safeString2(trade, 'currency_pair', 'contract');
                    const symbol = this.safeSymbol(marketId, market);
                    let amountString = this.safeString2(trade, 'amount', 'size');
                    const priceString = this.safeString(trade, 'price');
                    const contractSide = Precise.stringLt(amountString, '0') ? 'sell' : 'buy';
                    amountString = Precise.stringAbs(amountString);
                    const side = this.safeString2(trade, 'side', 'type', contractSide);
                    const orderId = this.safeString(trade, 'order_id');
                    const gtFee = this.safeString(trade, 'gt_fee');
                    let feeCurrency = undefined;
                    let feeCostString = undefined;
                    if (gtFee === '0') {
                        feeCurrency = this.safeString(trade, 'fee_currency');
                        feeCostString = this.safeString(trade, 'fee');
                    } else {
                        feeCurrency = 'GT';
                        feeCostString = gtFee;
                    }
                    const fee = {
                        'cost': feeCostString,
                        'currency': feeCurrency
                    };
                    const takerOrMaker = this.safeString(trade, 'role');
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) {
                        const start = parseInt(since / 1000);
                        request['from'] = start;
                        request['to'] = this.sum(start, 2592000);
                    }
                    const response = await this.privateWalletGetDeposits(this.extend(request, params));
                    return this.parseTransactions(response, currency);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) {
                        const start = parseInt(since / 1000);
                        request['from'] = start;
                        request['to'] = this.sum(start, 2592000);
                    }
                    const response = await this.privateWalletGetWithdrawals(this.extend(request, params));
                    return this.parseTransactions(response, currency);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'address': address,
                        'amount': this.currencyToPrecision(code, amount)
                    };
                    if (tag !== undefined) request['memo'] = tag;
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeStringLower(networks, network, network); // handle ETH>ERC20 alias
                    if (network !== undefined) {
                        request['chain'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privateWithdrawalsPost(this.extend(request, params));
                    //
                    //    {
                    //        "id": "w13389675",
                    //        "currency": "USDT",
                    //        "amount": "50",
                    //        "address": "TUu2rLFrmzUodiWfYki7QCNtv1akL682p1",
                    //        "memo": null
                    //    }
                    //
                    return this.parseTransaction(response, currency);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'PEND': 'pending',
                        'REQUEST': 'pending',
                        'DMOVE': 'pending',
                        'CANCEL': 'failed',
                        'DONE': 'ok',
                        'BCODE': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransactionType(type) {
                    const types = {
                        'd': 'deposit',
                        'w': 'withdrawal'
                    };
                    return this.safeString(types, type, type);
                }
                parseTransaction(transaction, currency) {
                    //
                    // deposits
                    //
                    //    {
                    //        "id": "d33361395",
                    //        "currency": "USDT_TRX",
                    //        "address": "TErdnxenuLtXfnMafLbfappYdHtnXQ5U4z",
                    //        "amount": "100",
                    //        "txid": "ae9374de34e558562fe18cbb1bf9ab4d9eb8aa7669d65541c9fa2a532c1474a0",
                    //        "timestamp": "1626345819",
                    //        "status": "DONE",
                    //        "memo": ""
                    //    }
                    //
                    // withdraw
                    //
                    //    {
                    //        "id": "w13389675",
                    //        "currency": "USDT",
                    //        "amount": "50",
                    //        "address": "TUu2rLFrmzUodiWfYki7QCNtv1akL682p1",
                    //        "memo": null
                    //    }
                    //
                    const id = this.safeString(transaction, 'id');
                    let type = undefined;
                    let amount = this.safeString(transaction, 'amount');
                    if (id[0] === 'b') {
                        // GateCode handling
                        type = Precise.stringGt(amount, '0') ? 'deposit' : 'withdrawal';
                        amount = Precise.stringAbs(amount);
                    } else if (id !== undefined) type = this.parseTransactionType(id[0]);
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    const txid = this.safeString(transaction, 'txid');
                    const rawStatus = this.safeString(transaction, 'status');
                    const status = this.parseTransactionStatus(rawStatus);
                    const address = this.safeString(transaction, 'address');
                    const fee = this.safeNumber(transaction, 'fee');
                    let tag = this.safeString(transaction, 'memo');
                    if (tag === '') tag = undefined;
                    const timestamp = this.safeTimestamp(transaction, 'timestamp');
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'currency': code,
                        'amount': this.parseNumber(amount),
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'status': status,
                        'type': type,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'updated': undefined,
                        'fee': fee
                    };
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    /**
         * @method
         * @name gateio#createOrder
         * @description Create an order on the exchange
         * @param {str} symbol Unified CCXT market symbol
         * @param {str} type "limit" or "market" *"market" is contract only*
         * @param {str} side "buy" or "sell"
         * @param {float} amount the amount of currency to trade
         * @param {float} price *ignored in "market" orders* the price at which the order is to be fullfilled at in units of the quote currency
         * @param {dict} params  Extra parameters specific to the exchange API endpoint
         * @param {float} params.stopPrice The price at which a trigger order is triggered at
         * @param {str} params.timeInForce "GTC", "IOC", or "PO"
         * @param {str} params.marginMode 'cross' or 'isolated' - marginMode for margin trading if not provided this.options['defaultMarginMode'] is used
         * @param {int} params.iceberg Amount to display for the iceberg order, Null or 0 for normal orders, Set to -1 to hide the order completely
         * @param {str} params.text User defined information
         * @param {str} params.account *spot and margin only* "spot", "margin" or "cross_margin"
         * @param {bool} params.auto_borrow *margin only* Used in margin or cross margin trading to allow automatic loan of insufficient amount if balance is not enough
         * @param {str} params.settle *contract only* Unified Currency Code for settle currency
         * @param {bool} params.reduceOnly *contract only* Indicates if this order is to reduce the size of a position
         * @param {bool} params.close *contract only* Set as true to close the position, with size set to 0
         * @param {bool} params.auto_size *contract only* Set side to close dual-mode position, close_long closes the long side, while close_short the short one, size also needs to be set to 0
         * @returns [An order structure]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ await this.loadMarkets();
                    const market = this.market(symbol);
                    const contract = market['contract'];
                    const stopPrice = this.safeNumber(params, 'stopPrice');
                    let methodTail = 'Orders';
                    const reduceOnly = this.safeValue2(params, 'reduce_only', 'reduceOnly');
                    const defaultTimeInForce = this.safeValue2(params, 'tif', 'time_in_force', 'gtc');
                    let timeInForce = this.safeValue(params, 'timeInForce', defaultTimeInForce);
                    let postOnly = false;
                    [type, postOnly, timeInForce, params] = this.isPostOnly(type, timeInForce, undefined, params);
                    params = this.omit(params, [
                        'stopPrice',
                        'reduce_only',
                        'reduceOnly',
                        'tif',
                        'time_in_force',
                        'timeInForce'
                    ]);
                    if (postOnly) timeInForce = 'poc';
                    const isLimitOrder = type === 'limit';
                    const isMarketOrder = type === 'market';
                    if (isLimitOrder && price === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a price argument for ' + type + ' orders');
                    if (contract) {
                        const amountToPrecision = this.amountToPrecision(symbol, amount);
                        const signedAmount = side === 'sell' ? Precise.stringNeg(amountToPrecision) : amountToPrecision;
                        amount = parseInt(signedAmount);
                        if (isMarketOrder) {
                            timeInForce = 'ioc';
                            price = 0;
                        }
                    } else if (!isLimitOrder) // Gateio doesn't have market orders for spot
                    throw new InvalidOrder(this.id + ' createOrder() does not support ' + type + ' orders for ' + market['type'] + ' markets');
                    let request = undefined;
                    const trigger = this.safeValue(params, 'trigger');
                    if (stopPrice === undefined && trigger === undefined) {
                        if (contract) {
                            // contract order
                            request = {
                                'contract': market['id'],
                                'size': amount,
                                // 'iceberg': 0, // int64, display size for iceberg order, 0 for non-iceberg, note that you will have to pay the taker fee for the hidden size
                                'price': this.priceToPrecision(symbol, price),
                                // 'close': false, // true to close the position, with size set to 0
                                // 'reduce_only': false, // St as true to be reduce-only order
                                // 'tif': 'gtc', // gtc, ioc, poc PendingOrCancelled == postOnly order
                                // 'text': clientOrderId, // 't-abcdef1234567890',
                                // 'auto_size': '', // close_long, close_short, note size also needs to be set to 0
                                'settle': market['settleId']
                            };
                            if (reduceOnly !== undefined) request['reduce_only'] = reduceOnly;
                            if (timeInForce !== undefined) request['tif'] = timeInForce;
                        } else {
                            let marginMode = undefined;
                            [marginMode, params] = this.getMarginMode(false, params);
                            // spot order
                            request = {
                                // 'text': clientOrderId, // 't-abcdef1234567890',
                                'currency_pair': market['id'],
                                'type': type,
                                'account': marginMode,
                                'side': side,
                                'amount': this.amountToPrecision(symbol, amount),
                                'price': this.priceToPrecision(symbol, price)
                            };
                            if (timeInForce !== undefined) request['time_in_force'] = timeInForce;
                        }
                        let clientOrderId = this.safeString2(params, 'text', 'clientOrderId');
                        if (clientOrderId !== undefined) {
                            // user-defined, must follow the rules if not empty
                            //     prefixed with t-
                            //     no longer than 28 bytes without t- prefix
                            //     can only include 0-9, A-Z, a-z, underscores (_), hyphens (-) or dots (.)
                            if (clientOrderId.length > 28) throw new BadRequest(this.id + ' createOrder() clientOrderId or text param must be up to 28 characters');
                            params = this.omit(params, [
                                'text',
                                'clientOrderId'
                            ]);
                            if (clientOrderId[0] !== 't') clientOrderId = 't-' + clientOrderId;
                            request['text'] = clientOrderId;
                        }
                    } else {
                        if (contract) {
                            // contract conditional order
                            const rule = side === 'buy' ? 1 : 2;
                            request = {
                                'initial': {
                                    'contract': market['id'],
                                    'size': amount,
                                    'price': this.priceToPrecision(symbol, price)
                                },
                                'trigger': {
                                    // 'strategy_type': 0, // 0 = by price, 1 = by price gap, only 0 is supported currently
                                    // 'price_type': 0, // 0 latest deal price, 1 mark price, 2 index price
                                    'price': this.priceToPrecision(symbol, stopPrice),
                                    'rule': rule
                                },
                                'settle': market['settleId']
                            };
                            const expiration = this.safeInteger(params, 'expiration');
                            if (expiration !== undefined) {
                                request['trigger']['expiration'] = expiration;
                                params = this.omit(params, 'expiration');
                            }
                            if (reduceOnly !== undefined) request['initial']['reduce_only'] = reduceOnly;
                            if (timeInForce !== undefined) request['initial']['tif'] = timeInForce;
                        } else {
                            // spot conditional order
                            const options = this.safeValue(this.options, 'createOrder', {});
                            let marginMode = undefined;
                            [marginMode, params] = this.getMarginMode(true, params);
                            const defaultExpiration = this.safeInteger(options, 'expiration');
                            const expiration = this.safeInteger(params, 'expiration', defaultExpiration);
                            const rule = side === 'buy' ? '>=' : '<=';
                            const triggerPrice = this.safeValue(trigger, 'price', stopPrice);
                            request = {
                                'trigger': {
                                    'price': this.priceToPrecision(symbol, triggerPrice),
                                    'rule': rule,
                                    'expiration': expiration
                                },
                                'put': {
                                    'type': type,
                                    'side': side,
                                    'price': this.priceToPrecision(symbol, price),
                                    'amount': this.amountToPrecision(symbol, amount),
                                    'account': marginMode,
                                    'time_in_force': timeInForce
                                },
                                'market': market['id']
                            };
                        }
                        methodTail = 'PriceOrders';
                    }
                    const method = this.getSupportedMapping(market['type'], {
                        'spot': 'privateSpotPost' + methodTail,
                        'margin': 'privateSpotPost' + methodTail,
                        'swap': 'privateFuturesPostSettle' + methodTail,
                        'future': 'privateDeliveryPostSettle' + methodTail
                    });
                    const response = await this[method](this.deepExtend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "id": "95282841887",
                    //         "text": "apiv4",
                    //         "create_time": "1637383156",
                    //         "update_time": "1637383156",
                    //         "create_time_ms": 1637383156017,
                    //         "update_time_ms": 1637383156017,
                    //         "status": "open",
                    //         "currency_pair": "ETH_USDT",
                    //         "type": "limit",
                    //         "account": "spot",
                    //         "side": "buy",
                    //         "amount": "0.01",
                    //         "price": "3500",
                    //         "time_in_force": "gtc",
                    //         "iceberg": "0",
                    //         "left": "0.01",
                    //         "fill_price": "0",
                    //         "filled_total": "0",
                    //         "fee": "0",
                    //         "fee_currency": "ETH",
                    //         "point_fee": "0",
                    //         "gt_fee": "0",
                    //         "gt_discount": false,
                    //         "rebated_fee": "0",
                    //         "rebated_fee_currency": "USDT"
                    //     }
                    //
                    // spot conditional
                    //
                    //     {"id": 5891843}
                    //
                    // future and perpetual swaps
                    //
                    //     {
                    //         "id": 95938572327,
                    //         "contract": "ETH_USDT",
                    //         "mkfr": "0",
                    //         "tkfr": "0.0005",
                    //         "tif": "gtc",
                    //         "is_reduce_only": false,
                    //         "create_time": 1637384600.08,
                    //         "price": "3000",
                    //         "size": 1,
                    //         "refr": "0",
                    //         "left": 1,
                    //         "text": "api",
                    //         "fill_price": "0",
                    //         "user": 2436035,
                    //         "status": "open",
                    //         "is_liq": false,
                    //         "refu": 0,
                    //         "is_close": false,
                    //         "iceberg": 0
                    //     }
                    //
                    // futures and perpetual swaps conditionals
                    //
                    //     {"id": 7615567}
                    //
                    return this.parseOrder(response, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '_new': 'open',
                        'filled': 'closed',
                        'cancelled': 'canceled',
                        'liquidated': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // SPOT
                    // createOrder/cancelOrder/fetchOrder
                    //
                    //    {
                    //        "id": "62364648575",
                    //        "text": "apiv4",
                    //        "create_time": "1626354834",
                    //        "update_time": "1626354834",
                    //        "create_time_ms": "1626354833544",
                    //        "update_time_ms": "1626354833544",
                    //        "status": "open",
                    //        "currency_pair": "BTC_USDT",
                    //        "type": "limit",
                    //        "account": "spot",
                    //        "side": "buy",
                    //        "amount": "0.0001",
                    //        "price": "30000",
                    //        "time_in_force": "gtc",
                    //        "iceberg": "0",
                    //        "left": "0.0001",
                    //        "fill_price": "0",
                    //        "filled_total": "0",
                    //        "fee": "0",
                    //        "fee_currency": "BTC",
                    //        "point_fee": "0",
                    //        "gt_fee": "0",
                    //        "gt_discount": true,
                    //        "rebated_fee": "0",
                    //        "rebated_fee_currency": "USDT"
                    //     }
                    //
                    // SPOT TRIGGER ORDERS
                    // createOrder
                    //
                    //    {
                    //        "id": 12604556
                    //    }
                    //
                    // fetchOrder/cancelOrder
                    //
                    //    {
                    //        "market": "ADA_USDT",
                    //        "user": 6392049,
                    //        "trigger": {
                    //            "price": "1.08", // stopPrice
                    //            "rule": "\u003e=",
                    //            "expiration": 86400
                    //        },
                    //        "put": {
                    //            "type": "limit",
                    //            "side": "buy",
                    //            "price": "1.08", // order price
                    //            "amount": "1.00000000000000000000",
                    //            "account": "normal",
                    //            "time_in_force": "gtc"
                    //        },
                    //        "id": 71639298,
                    //        "ctime": 1643945985,
                    //        "status": "open"
                    //    }
                    //
                    // FUTURE AND SWAP
                    // createOrder/cancelOrder/fetchOrder
                    //
                    //    {
                    //        "id": 123028481731,
                    //        "contract": "ADA_USDT",
                    //        "mkfr": "-0.00005",
                    //        "tkfr": "0.00048",
                    //        "tif": "ioc",
                    //        "is_reduce_only": false,
                    //        "create_time": 1643950262.68,
                    //        "finish_time": 1643950262.68,
                    //        "price": "0",
                    //        "size": 1,
                    //        "refr": "0",
                    //        "left":0,
                    //        "text": "api",
                    //        "fill_price": "1.05273",
                    //        "user":6329238,
                    //        "finish_as": "filled",
                    //        "status": "finished",
                    //        "is_liq": false,
                    //        "refu":0,
                    //        "is_close": false,
                    //        "iceberg": 0
                    //    }
                    //
                    // TRIGGER ORDERS (FUTURE AND SWAP)
                    // createOrder
                    //
                    //    {
                    //        "id": 12604556
                    //    }
                    //
                    // fetchOrder/cancelOrder
                    //
                    //    {
                    //        "user": 6320300,
                    //        "trigger": {
                    //            "strategy_type": 0,
                    //            "price_type": 0,
                    //            "price": "1.03", // stopPrice
                    //            "rule": 2,
                    //            "expiration": 0
                    //        },
                    //        "initial": {
                    //            "contract": "ADA_USDT",
                    //            "size": -1,
                    //            "price": "1.02",
                    //            "tif": "gtc",
                    //            "text": "",
                    //            "iceberg": 0,
                    //            "is_close": false,
                    //            "is_reduce_only": false,
                    //            "auto_size": ""
                    //        },
                    //        "id": 126393906,
                    //        "trade_id": 0,
                    //        "status": "open",
                    //        "reason": "",
                    //        "create_time": 1643953482,
                    //        "finish_time": 1643953482,
                    //        "is_stop_order": false,
                    //        "stop_trigger": {
                    //            "rule": 0,
                    //            "trigger_price": "",
                    //            "order_price": ""
                    //        },
                    //        "me_order_id": 0,
                    //        "order_type": ""
                    //    }
                    //
                    const put = this.safeValue2(order, 'put', 'initial');
                    const trigger = this.safeValue(order, 'trigger');
                    let contract = this.safeString(put, 'contract');
                    let type = this.safeString(put, 'type');
                    let timeInForce = this.safeStringUpper2(put, 'time_in_force', 'tif');
                    let amount = this.safeString2(put, 'amount', 'size');
                    let side = this.safeString(put, 'side');
                    let price = this.safeString(put, 'price');
                    contract = this.safeString(order, 'contract', contract);
                    type = this.safeString(order, 'type', type);
                    timeInForce = this.safeStringUpper2(order, 'time_in_force', 'tif', timeInForce);
                    if (timeInForce === 'POC') timeInForce = 'PO';
                    const postOnly = timeInForce === 'PO';
                    amount = this.safeString2(order, 'amount', 'size', amount);
                    side = this.safeString(order, 'side', side);
                    price = this.safeString(order, 'price', price);
                    let remaining = this.safeString(order, 'left');
                    let filled = Precise.stringSub(amount, remaining);
                    let cost = this.safeString(order, 'filled_total');
                    let rawStatus = undefined;
                    let average = undefined;
                    if (put) {
                        remaining = amount;
                        filled = '0';
                        cost = '0';
                    }
                    if (contract) {
                        const isMarketOrder = Precise.stringEquals(price, '0') && timeInForce === 'IOC';
                        type = isMarketOrder ? 'market' : 'limit';
                        side = Precise.stringGt(amount, '0') ? 'buy' : 'sell';
                        rawStatus = this.safeString(order, 'finish_as', 'open');
                        average = this.safeNumber(order, 'fill_price');
                    } else rawStatus = this.safeString(order, 'status');
                    let timestamp = this.safeInteger(order, 'create_time_ms');
                    if (timestamp === undefined) timestamp = this.safeTimestamp2(order, 'create_time', 'ctime');
                    let lastTradeTimestamp = this.safeInteger(order, 'update_time_ms');
                    if (lastTradeTimestamp === undefined) lastTradeTimestamp = this.safeTimestamp2(order, 'update_time', 'finish_time');
                    const exchangeSymbol = this.safeString2(order, 'currency_pair', 'market', contract);
                    // Everything below this(above return) is related to fees
                    const fees = [];
                    const gtFee = this.safeString(order, 'gt_fee');
                    if (gtFee) fees.push({
                        'currency': 'GT',
                        'cost': gtFee
                    });
                    const fee = this.safeString(order, 'fee');
                    if (fee) fees.push({
                        'currency': this.safeCurrencyCode(this.safeString(order, 'fee_currency')),
                        'cost': fee
                    });
                    const rebate = this.safeString(order, 'rebated_fee');
                    if (rebate) fees.push({
                        'currency': this.safeCurrencyCode(this.safeString(order, 'rebated_fee_currency')),
                        'cost': Precise.stringNeg(rebate)
                    });
                    const numFeeCurrencies = fees.length;
                    const multipleFeeCurrencies = numFeeCurrencies > 1;
                    const status = this.parseOrderStatus(rawStatus);
                    return this.safeOrder({
                        'id': this.safeString(order, 'id'),
                        'clientOrderId': this.safeString(order, 'text'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'status': status,
                        'symbol': this.safeSymbol(exchangeSymbol),
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': this.parseNumber(price),
                        'stopPrice': this.safeNumber(trigger, 'price'),
                        'average': average,
                        'amount': this.parseNumber(Precise.stringAbs(amount)),
                        'cost': Precise.stringAbs(cost),
                        'filled': this.parseNumber(Precise.stringAbs(filled)),
                        'remaining': this.parseNumber(Precise.stringAbs(remaining)),
                        'fee': multipleFeeCurrencies ? undefined : this.safeValue(fees, 0),
                        'fees': multipleFeeCurrencies ? fees : [],
                        'trades': undefined,
                        'info': order
                    }, market);
                }
                async createReduceOnlyOrder(symbol, type, side, amount, price, params = {}) {
                    const request = {
                        'reduceOnly': true
                    };
                    return await this.createOrder(symbol, type, side, amount, price, this.extend(request, params));
                }
                async fetchOrder(id, symbol, params = {}) {
                    /**
         * @method
         * @name gateio#fetchOrder
         * @description Retrieves information on an order
         * @param {str} id Order id
         * @param {str} symbol Unified market symbol, *required for spot and margin*
         * @param {dict} params Parameters specified by the exchange api
         * @param {bool} params.stop True if the order being fetched is a trigger order
         * @param {str} params.marginMode 'cross' or 'isolated' - marginMode for margin trading if not provided this.options['defaultMarginMode'] is used
         * @param {str} params.type 'spot', 'swap', or 'future', if not provided this.options['defaultMarginMode'] is used
         * @param {str} params.settle 'btc' or 'usdt' - settle currency for perpetual swap and future - market settle currency is used if symbol !== undefined, default="usdt" for swap and "btc" for future
         * @returns An [order structure]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ await this.loadMarkets();
                    const stop = this.safeValue2(params, 'is_stop_order', 'stop', false);
                    params = this.omit(params, [
                        'is_stop_order',
                        'stop'
                    ]);
                    let clientOrderId = this.safeString2(params, 'text', 'clientOrderId');
                    let orderId = id;
                    if (clientOrderId !== undefined) {
                        params = this.omit(params, [
                            'text',
                            'clientOrderId'
                        ]);
                        if (clientOrderId[0] !== 't') clientOrderId = 't-' + clientOrderId;
                        orderId = clientOrderId;
                    }
                    const market = symbol === undefined ? undefined : this.market(symbol);
                    const [type, query] = this.handleMarketTypeAndParams('fetchOrder', market, params);
                    const contract = type === 'swap' || type === 'future';
                    const [request, requestParams] = contract ? this.prepareRequest(market, type, query) : this.spotOrderPrepareRequest(market, stop, query);
                    request['order_id'] = orderId;
                    const methodMiddle = stop ? 'PriceOrders' : 'Orders';
                    const method = this.getSupportedMapping(type, {
                        'spot': 'privateSpotGet' + methodMiddle + 'OrderId',
                        'margin': 'privateSpotGet' + methodMiddle + 'OrderId',
                        'swap': 'privateFuturesGetSettle' + methodMiddle + 'OrderId',
                        'future': 'privateDeliveryGetSettle' + methodMiddle + 'OrderId'
                    });
                    const response = await this[method](this.extend(request, requestParams));
                    return this.parseOrder(response, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    /**
         * @description fetches all open orders
         * @param {str} symbol Unified market symbol
         * @param {int} since earliest time in ms for orders in the response
         * @param {int} limit max number of order structures to return
         * @param {dict} params exchange specific params
         * @param {bool} params.stop true for fetching stop orders
         * @param {str} params.type spot, margin, swap or future, if not provided this.options['defaultType'] is used
         * @param {str} params.marginMode 'cross' or 'isolated' - marginMode for type='margin', if not provided this.options['defaultMarginMode'] is used
         * @returns An array of order structures
         */ return await this.fetchOrdersByStatus('open', symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    /**
         * @method
         * @name gateio#fetchClosedOrders
         * @description fetches all closed orders
         * @param {str} symbol Unified market symbol of the market to fetch orders for
         * @param {int} since earliest time in ms for orders in the response
         * @param {int} limit max number of order structures to return
         * @param {dict} params exchange specific params
         * @param {bool} params.stop true for fetching stop orders
         * @param {str} params.type spot, swap or future, if not provided this.options['defaultType'] is used
         * @param {str} params.marginMode 'cross' or 'isolated' - marginMode for margin trading if not provided this.options['defaultMarginMode'] is used
         * @returns An array of [order structures]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ return await this.fetchOrdersByStatus('finished', symbol, since, limit, params);
                }
                async fetchOrdersByStatus(status, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = symbol === undefined ? undefined : this.market(symbol);
                    const stop = this.safeValue(params, 'stop');
                    params = this.omit(params, 'stop');
                    const [type, query] = this.handleMarketTypeAndParams('fetchOrdersByStatus', market, params);
                    const spot = type === 'spot' || type === 'margin';
                    const [request, requestParams] = spot ? this.multiOrderSpotPrepareRequest(market, stop, query) : this.prepareRequest(market, type, query);
                    if (spot && !stop && market === undefined && status === 'open') throw new ArgumentsRequired1(this.id + ' fetchOrdersByStatus requires a symbol argument for spot non-stop open orders');
                    if (status === 'closed') status = 'finished';
                    request['status'] = status;
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined && spot) request['from'] = parseInt(since / 1000);
                    const methodTail = stop ? 'PriceOrders' : 'Orders';
                    const method = this.getSupportedMapping(type, {
                        'spot': 'privateSpotGet' + methodTail,
                        'margin': 'privateSpotGet' + methodTail,
                        'swap': 'privateFuturesGetSettle' + methodTail,
                        'future': 'privateDeliveryGetSettle' + methodTail
                    });
                    const response = await this[method](this.extend(request, requestParams));
                    //
                    // SPOT
                    //
                    //    [
                    //        {
                    //           "id": "8834234273",
                    //           "text": "3",
                    //           "create_time": "1635406193",
                    //           "update_time": "1635406193",
                    //           "create_time_ms": 1635406193361,
                    //           "update_time_ms": 1635406193361,
                    //           "status": "closed",
                    //           "currency_pair": "BTC_USDT",
                    //           "type": "limit",
                    //           "account": "spot", // margin for margin orders
                    //           "side": "sell",
                    //           "amount": "0.0002",
                    //           "price": "58904.01",
                    //           "time_in_force": "gtc",
                    //           "iceberg": "0",
                    //           "left": "0.0000",
                    //           "fill_price": "11.790516",
                    //           "filled_total": "11.790516",
                    //           "fee": "0.023581032",
                    //           "fee_currency": "USDT",
                    //           "point_fee": "0",
                    //           "gt_fee": "0",
                    //           "gt_discount": false,
                    //           "rebated_fee_currency": "BTC"
                    //        }
                    //    ]
                    //
                    // Spot Stop
                    //
                    //    [
                    //        {
                    //            "market": "ADA_USDT",
                    //            "user": 10406147,
                    //            "trigger": {
                    //                "price": "0.65",
                    //                "rule": "\u003c=",
                    //                "expiration": 86400
                    //            },
                    //            "put": {
                    //                "type": "limit",
                    //                "side": "sell",
                    //                "price": "0.65",
                    //                "amount": "2.00000000000000000000",
                    //                "account": "normal",  // margin for margin orders
                    //                "time_in_force": "gtc"
                    //            },
                    //            "id": 8449909,
                    //            "ctime": 1652188982,
                    //            "status": "open"
                    //        }
                    //    ]
                    //
                    // Perpetual Swap
                    //
                    //    [
                    //        {
                    //           "status": "finished",
                    //           "size": -1,
                    //           "left": 0,
                    //           "id": 82750739203,
                    //           "is_liq": false,
                    //           "is_close": false,
                    //           "contract": "BTC_USDT",
                    //           "text": "web",
                    //           "fill_price": "60721.3",
                    //           "finish_as": "filled",
                    //           "iceberg": 0,
                    //           "tif": "ioc",
                    //           "is_reduce_only": true,
                    //           "create_time": 1635403475.412,
                    //           "finish_time": 1635403475.4127,
                    //           "price": "0"
                    //        }
                    //    ]
                    //
                    const orders = this.parseOrders(response, market, since, limit);
                    return this.filterBySymbolSinceLimit(orders, symbol, since, limit);
                }
                async cancelOrder(id, symbol, params = {}) {
                    /**
         * @method
         * @name gateio#cancelOrder
         * @description Cancels an open order
         * @param {str} id Order id
         * @param {str} symbol Unified market symbol
         * @param {dict} params Parameters specified by the exchange api
         * @param {bool} params.stop True if the order to be cancelled is a trigger order
         * @returns An [order structure]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ await this.loadMarkets();
                    const market = symbol === undefined ? undefined : this.market(symbol);
                    const stop = this.safeValue2(params, 'is_stop_order', 'stop', false);
                    params = this.omit(params, [
                        'is_stop_order',
                        'stop'
                    ]);
                    const [type, query] = this.handleMarketTypeAndParams('cancelOrder', market, params);
                    const [request, requestParams] = type === 'spot' || type === 'margin' ? this.spotOrderPrepareRequest(market, stop, query) : this.prepareRequest(market, type, query);
                    request['order_id'] = id;
                    const pathMiddle = stop ? 'Price' : '';
                    const method = this.getSupportedMapping(type, {
                        'spot': 'privateSpotDelete' + pathMiddle + 'OrdersOrderId',
                        'margin': 'privateSpotDelete' + pathMiddle + 'OrdersOrderId',
                        'swap': 'privateFuturesDeleteSettle' + pathMiddle + 'OrdersOrderId',
                        'future': 'privateDeliveryDeleteSettle' + pathMiddle + 'OrdersOrderId'
                    });
                    const response = await this[method](this.extend(request, requestParams));
                    //
                    // spot
                    //
                    //     {
                    //         "id": "95282841887",
                    //         "text": "apiv4",
                    //         "create_time": "1637383156",
                    //         "update_time": "1637383235",
                    //         "create_time_ms": 1637383156017,
                    //         "update_time_ms": 1637383235085,
                    //         "status": "cancelled",
                    //         "currency_pair": "ETH_USDT",
                    //         "type": "limit",
                    //         "account": "spot",
                    //         "side": "buy",
                    //         "amount": "0.01",
                    //         "price": "3500",
                    //         "time_in_force": "gtc",
                    //         "iceberg": "0",
                    //         "left": "0.01",
                    //         "fill_price": "0",
                    //         "filled_total": "0",
                    //         "fee": "0",
                    //         "fee_currency": "ETH",
                    //         "point_fee": "0",
                    //         "gt_fee": "0",
                    //         "gt_discount": false,
                    //         "rebated_fee": "0",
                    //         "rebated_fee_currency": "USDT"
                    //     }
                    //
                    // spot conditional
                    //
                    //     {
                    //         "market": "ETH_USDT",
                    //         "user": 2436035,
                    //         "trigger": {
                    //             "price": "3500",
                    //             "rule": "\u003c=",
                    //             "expiration": 86400
                    //         },
                    //         "put": {
                    //             "type": "limit",
                    //             "side": "buy",
                    //             "price": "3500",
                    //             "amount": "0.01000000000000000000",
                    //             "account": "normal",
                    //             "time_in_force": "gtc"
                    //         },
                    //         "id": 5891843,
                    //         "ctime": 1637382379,
                    //         "ftime": 1637382673,
                    //         "status": "canceled"
                    //     }
                    //
                    // perpetual swaps
                    //
                    //     {
                    //         id: "82241928192",
                    //         contract: "BTC_USDT",
                    //         mkfr: "0",
                    //         tkfr: "0.0005",
                    //         tif: "gtc",
                    //         is_reduce_only: false,
                    //         create_time: "1635196145.06",
                    //         finish_time: "1635196233.396",
                    //         price: "61000",
                    //         size: "4",
                    //         refr: "0",
                    //         left: "4",
                    //         text: "web",
                    //         fill_price: "0",
                    //         user: "6693577",
                    //         finish_as: "cancelled",
                    //         status: "finished",
                    //         is_liq: false,
                    //         refu: "0",
                    //         is_close: false,
                    //         iceberg: "0",
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = symbol === undefined ? undefined : this.market(symbol);
                    const stop = this.safeValue(params, 'stop');
                    params = this.omit(params, 'stop');
                    const [type, query] = this.handleMarketTypeAndParams('cancelAllOrders', market, params);
                    const [request, requestParams] = type === 'spot' ? this.multiOrderSpotPrepareRequest(market, stop, query) : this.prepareRequest(market, type, query);
                    const methodTail = stop ? 'PriceOrders' : 'Orders';
                    const method = this.getSupportedMapping(type, {
                        'spot': 'privateSpotDelete' + methodTail,
                        'margin': 'privateSpotDelete' + methodTail,
                        'swap': 'privateFuturesDeleteSettle' + methodTail,
                        'future': 'privateDeliveryDeleteSettle' + methodTail
                    });
                    const response = await this[method](this.extend(request, requestParams));
                    //
                    //    [
                    //        {
                    //            "id": 139797004085,
                    //            "contract": "ADA_USDT",
                    //            "mkfr": "0",
                    //            "tkfr": "0.0005",
                    //            "tif": "gtc",
                    //            "is_reduce_only": false,
                    //            "create_time": 1647911169.343,
                    //            "finish_time": 1647911226.849,
                    //            "price": "0.8",
                    //            "size": 1,
                    //            "refr": "0.3",
                    //            "left": 1,
                    //            "text": "api",
                    //            "fill_price": "0",
                    //            "user": 6693577,
                    //            "finish_as": "cancelled",
                    //            "status": "finished",
                    //            "is_liq": false,
                    //            "refu": 2436035,
                    //            "is_close": false,
                    //            "iceberg": 0
                    //        }
                    //        ...
                    //    ]
                    //
                    return this.parseOrders(response, market);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    /**
         * @method
         * @name gateio#transfer
         * @description makes internal transfers of funds between accounts on the same exchange
         * @param {str} code unified currency code for currency being transferred
         * @param {float} amount the amount of currency to transfer
         * @param {str} fromAccount the account to transfer currency from
         * @param {str} toAccount the account to transfer currency to
         * @param {dict} params Exchange specific parameters
         * @param {dict} params.symbol Unified market symbol *required for type == margin*
         * @returns A [transfer structure]{@link https://docs.ccxt.com/en/latest/manual.html#transfer-structure}
         */ await this.loadMarkets();
                    const currency = this.currency(code);
                    const fromId = this.parseAccount(fromAccount);
                    const toId = this.parseAccount(toAccount);
                    const truncated = this.currencyToPrecision(code, amount);
                    const request = {
                        'currency': currency['id'],
                        'amount': truncated
                    };
                    if (!(fromId in this.options['accountsByType'])) {
                        request['from'] = 'margin';
                        request['currency_pair'] = fromId;
                    } else request['from'] = fromId;
                    if (!(toId in this.options['accountsByType'])) {
                        request['to'] = 'margin';
                        request['currency_pair'] = toId;
                    } else request['to'] = toId;
                    if (fromId === 'margin' || toId === 'margin') {
                        const symbol = this.safeString2(params, 'symbol', 'currency_pair');
                        if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' transfer requires params["symbol"] for isolated margin transfers');
                        const market = this.market(symbol);
                        request['currency_pair'] = market['id'];
                        params = this.omit(params, 'symbol');
                    }
                    if (toId === 'futures' || toId === 'delivery' || fromId === 'futures' || fromId === 'delivery') request['settle'] = currency['lowerCaseId'];
                    const response = await this.privateWalletPostTransfers(this.extend(request, params));
                    //
                    // according to the docs (however actual response seems to be an empty string '')
                    //
                    //    {
                    //        "currency": "BTC",
                    //        "from": "spot",
                    //        "to": "margin",
                    //        "amount": "1",
                    //        "currency_pair": "BTC_USDT"
                    //    }
                    //
                    const transfer = this.parseTransfer(response, currency);
                    return this.extend(transfer, {
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'amount': this.parseNumber(truncated)
                    });
                }
                parseAccount(account) {
                    const accountsByType = this.options['accountsByType'];
                    if (account in accountsByType) return accountsByType[account];
                    else if (account in this.markets) {
                        const market = this.market(account);
                        return market['id'];
                    } else {
                        const keys = Object.keys(accountsByType);
                        throw new ExchangeError1(this.id + ' accounts must be one of ' + keys.join(', ') + ' or an isolated margin symbol');
                    }
                }
                parseTransfer(transfer, currency) {
                    const timestamp = this.milliseconds();
                    return {
                        'id': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': this.safeCurrencyCode(undefined, currency),
                        'amount': undefined,
                        'fromAccount': undefined,
                        'toAccount': undefined,
                        'status': undefined,
                        'info': transfer
                    };
                }
                async setLeverage(leverage, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    // WARNING: THIS WILL INCREASE LIQUIDATION PRICE FOR OPEN ISOLATED LONG POSITIONS
                    // AND DECREASE LIQUIDATION PRICE FOR OPEN ISOLATED SHORT POSITIONS
                    if (leverage < 0 || leverage > 100) throw new BadRequest(this.id + ' setLeverage() leverage should be between 1 and 100');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const method = this.getSupportedMapping(market['type'], {
                        'swap': 'privateFuturesPostSettlePositionsContractLeverage',
                        'future': 'privateDeliveryPostSettlePositionsContractLeverage'
                    });
                    const [request, query] = this.prepareRequest(market, undefined, params);
                    const defaultMarginMode = this.safeString2(this.options, 'marginMode', 'defaultMarginMode');
                    const crossLeverageLimit = this.safeString(query, 'cross_leverage_limit');
                    let marginMode = this.safeString(query, 'marginMode', defaultMarginMode);
                    if (crossLeverageLimit !== undefined) {
                        marginMode = 'cross';
                        leverage = crossLeverageLimit;
                    }
                    if (marginMode === 'cross' || marginMode === 'cross_margin') request['query'] = {
                        'cross_leverage_limit': leverage.toString(),
                        'leverage': '0'
                    };
                    else request['query'] = {
                        'leverage': leverage.toString()
                    };
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //         "value": "0",
                    //         "leverage": "5",
                    //         "mode": "single",
                    //         "realised_point": "0",
                    //         "contract": "BTC_USDT",
                    //         "entry_price": "0",
                    //         "mark_price": "62035.86",
                    //         "history_point": "0",
                    //         "realised_pnl": "0",
                    //         "close_order": null,
                    //         "size": 0,
                    //         "cross_leverage_limit": "0",
                    //         "pending_orders": 0,
                    //         "adl_ranking": 6,
                    //         "maintenance_rate": "0.005",
                    //         "unrealised_pnl": "0",
                    //         "user": 2436035,
                    //         "leverage_max": "100",
                    //         "history_pnl": "0",
                    //         "risk_limit": "1000000",
                    //         "margin": "0",
                    //         "last_close_pnl": "0",
                    //         "liq_price": "0"
                    //     }
                    //
                    return response;
                }
                parsePosition(position, market) {
                    //
                    //     {
                    //         value: "12.475572",
                    //         leverage: "0",
                    //         mode: "single",
                    //         realised_point: "0",
                    //         contract: "BTC_USDT",
                    //         entry_price: "62422.6",
                    //         mark_price: "62377.86",
                    //         history_point: "0",
                    //         realised_pnl: "-0.00624226",
                    //         close_order:  null,
                    //         size: "2",
                    //         cross_leverage_limit: "25",
                    //         pending_orders: "0",
                    //         adl_ranking: "5",
                    //         maintenance_rate: "0.005",
                    //         unrealised_pnl: "-0.008948",
                    //         user: "663337",
                    //         leverage_max: "100",
                    //         history_pnl: "14.98868396636",
                    //         risk_limit: "1000000",
                    //         margin: "0.740721495056",
                    //         last_close_pnl: "-0.041996015",
                    //         liq_price: "59058.58"
                    //     }
                    //
                    const contract = this.safeString(position, 'contract');
                    market = this.safeMarket(contract, market);
                    const size = this.safeString(position, 'size');
                    let side = undefined;
                    if (Precise.stringGt(size, '0')) side = 'long';
                    else if (Precise.stringLt(size, '0')) side = 'short';
                    const maintenanceRate = this.safeString(position, 'maintenance_rate');
                    const notional = this.safeString(position, 'value');
                    const leverage = this.safeString(position, 'leverage');
                    let marginMode = undefined;
                    if (leverage === '0') marginMode = 'cross';
                    else marginMode = 'isolated';
                    const unrealisedPnl = this.safeString(position, 'unrealised_pnl');
                    // Initial Position Margin = ( Position Value / Leverage ) + Close Position Fee
                    // *The default leverage under the full position is the highest leverage in the market.
                    // *Trading fee is charged as Taker Fee Rate (0.075%).
                    const takerFee = '0.00075';
                    const feePaid = Precise.stringMul(takerFee, notional);
                    const initialMarginString = Precise.stringAdd(Precise.stringDiv(notional, leverage), feePaid);
                    const percentage = Precise.stringMul(Precise.stringDiv(unrealisedPnl, initialMarginString), '100');
                    return {
                        'info': position,
                        'symbol': this.safeString(market, 'symbol'),
                        'timestamp': undefined,
                        'datetime': undefined,
                        'initialMargin': this.parseNumber(initialMarginString),
                        'initialMarginPercentage': this.parseNumber(Precise.stringDiv(initialMarginString, notional)),
                        'maintenanceMargin': this.parseNumber(Precise.stringMul(maintenanceRate, notional)),
                        'maintenanceMarginPercentage': this.parseNumber(maintenanceRate),
                        'entryPrice': this.safeNumber(position, 'entry_price'),
                        'notional': this.parseNumber(notional),
                        'leverage': this.safeNumber(position, 'leverage'),
                        'unrealizedPnl': this.parseNumber(unrealisedPnl),
                        'contracts': this.parseNumber(Precise.stringAbs(size)),
                        'contractSize': this.safeValue(market, 'contractSize'),
                        // 'realisedPnl': position['realised_pnl'],
                        'marginRatio': undefined,
                        'liquidationPrice': this.safeNumber(position, 'liq_price'),
                        'markPrice': this.safeNumber(position, 'mark_price'),
                        'collateral': this.safeNumber(position, 'margin'),
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'side': side,
                        'percentage': this.parseNumber(percentage)
                    };
                }
                parsePositions(positions) {
                    const result = [];
                    for(let i = 0; i < positions.length; i++)result.push(this.parsePosition(positions[i]));
                    return result;
                }
                async fetchPositions(symbols, params = {}) {
                    /**
         * @method
         * @name gateio#fetchPositions
         * @description Fetch trades positions
         * @param {[str]} symbols Not used by Gateio, but parsed internally by CCXT
         * @param {dict} params exchange specific parameters
         * @param {str} params.settle 'btc' or 'usdt' - settle currency for perpetual swap and future - default="usdt" for swap and "btc" for future
         * @param {str} params.type swap or future, if not provided this.options['defaultType'] is used
         * @returns An array of [position structures]{@link https://docs.ccxt.com/en/latest/manual.html#position-structure}
         */ await this.loadMarkets();
                    const [type, query] = this.handleMarketTypeAndParams('fetchPositions', undefined, params);
                    const [request, requestParams] = this.prepareRequest(undefined, type, query);
                    const method = this.getSupportedMapping(type, {
                        'swap': 'privateFuturesGetSettlePositions',
                        'future': 'privateDeliveryGetSettlePositions'
                    });
                    const response = await this[method](this.extend(request, requestParams));
                    //
                    //     [
                    //         {
                    //             value: "12.475572",
                    //             leverage: "0",
                    //             mode: "single",
                    //             realised_point: "0",
                    //             contract: "BTC_USDT",
                    //             entry_price: "62422.6",
                    //             mark_price: "62377.86",
                    //             history_point: "0",
                    //             realised_pnl: "-0.00624226",
                    //             close_order:  null,
                    //             size: "2",
                    //             cross_leverage_limit: "25",
                    //             pending_orders: "0",
                    //             adl_ranking: "5",
                    //             maintenance_rate: "0.005",
                    //             unrealised_pnl: "-0.008948",
                    //             user: "6693577",
                    //             leverage_max: "100",
                    //             history_pnl: "14.98868396636",
                    //             risk_limit: "1000000",
                    //             margin: "0.740721495056",
                    //             last_close_pnl: "-0.041996015",
                    //             liq_price: "59058.58"
                    //         }
                    //     ]
                    //
                    const result = this.parsePositions(response);
                    return this.filterByArray(result, 'symbol', symbols, false);
                }
                async fetchLeverageTiers(symbols, params = {}) {
                    await this.loadMarkets();
                    const [type, query] = this.handleMarketTypeAndParams('fetchLeverageTiers', undefined, params);
                    const [request, requestParams] = this.prepareRequest(undefined, type, query);
                    if (type !== 'future' && type !== 'swap') throw new BadRequest(this.id + ' fetchLeverageTiers only supports swap and future');
                    const method = this.getSupportedMapping(type, {
                        'swap': 'publicFuturesGetSettleContracts',
                        'future': 'publicDeliveryGetSettleContracts'
                    });
                    const response = await this[method](this.extend(request, requestParams));
                    //
                    // Perpetual swap
                    //
                    //    [
                    //        {
                    //            "name": "BTC_USDT",
                    //            "type": "direct",
                    //            "quanto_multiplier": "0.0001",
                    //            "ref_discount_rate": "0",
                    //            "order_price_deviate": "0.5",
                    //            "maintenance_rate": "0.005",
                    //            "mark_type": "index",
                    //            "last_price": "38026",
                    //            "mark_price": "37985.6",
                    //            "index_price": "37954.92",
                    //            "funding_rate_indicative": "0.000219",
                    //            "mark_price_round": "0.01",
                    //            "funding_offset": 0,
                    //            "in_delisting": false,
                    //            "risk_limit_base": "1000000",
                    //            "interest_rate": "0.0003",
                    //            "order_price_round": "0.1",
                    //            "order_size_min": 1,
                    //            "ref_rebate_rate": "0.2",
                    //            "funding_interval": 28800,
                    //            "risk_limit_step": "1000000",
                    //            "leverage_min": "1",
                    //            "leverage_max": "100",
                    //            "risk_limit_max": "8000000",
                    //            "maker_fee_rate": "-0.00025",
                    //            "taker_fee_rate": "0.00075",
                    //            "funding_rate": "0.002053",
                    //            "order_size_max": 1000000,
                    //            "funding_next_apply": 1610035200,
                    //            "short_users": 977,
                    //            "config_change_time": 1609899548,
                    //            "trade_size": 28530850594,
                    //            "position_size": 5223816,
                    //            "long_users": 455,
                    //            "funding_impact_value": "60000",
                    //            "orders_limit": 50,
                    //            "trade_id": 10851092,
                    //            "orderbook_id": 2129638396
                    //        }
                    //    ]
                    //
                    // Delivery Futures
                    //
                    //    [
                    //        {
                    //            "name": "BTC_USDT_20200814",
                    //            "underlying": "BTC_USDT",
                    //            "cycle": "WEEKLY",
                    //            "type": "direct",
                    //            "quanto_multiplier": "0.0001",
                    //            "mark_type": "index",
                    //            "last_price": "9017",
                    //            "mark_price": "9019",
                    //            "index_price": "9005.3",
                    //            "basis_rate": "0.185095",
                    //            "basis_value": "13.7",
                    //            "basis_impact_value": "100000",
                    //            "settle_price": "0",
                    //            "settle_price_interval": 60,
                    //            "settle_price_duration": 1800,
                    //            "settle_fee_rate": "0.0015",
                    //            "expire_time": 1593763200,
                    //            "order_price_round": "0.1",
                    //            "mark_price_round": "0.1",
                    //            "leverage_min": "1",
                    //            "leverage_max": "100",
                    //            "maintenance_rate": "1000000",
                    //            "risk_limit_base": "140.726652109199",
                    //            "risk_limit_step": "1000000",
                    //            "risk_limit_max": "8000000",
                    //            "maker_fee_rate": "-0.00025",
                    //            "taker_fee_rate": "0.00075",
                    //            "ref_discount_rate": "0",
                    //            "ref_rebate_rate": "0.2",
                    //            "order_price_deviate": "0.5",
                    //            "order_size_min": 1,
                    //            "order_size_max": 1000000,
                    //            "orders_limit": 50,
                    //            "orderbook_id": 63,
                    //            "trade_id": 26,
                    //            "trade_size": 435,
                    //            "position_size": 130,
                    //            "config_change_time": 1593158867,
                    //            "in_delisting": false
                    //        }
                    //    ]
                    //
                    return this.parseLeverageTiers(response, symbols, 'name');
                }
                parseMarketLeverageTiers(info, market) {
                    /**
         * @ignore
         * @method
         * @description https://www.gate.io/help/futures/perpetual/22162/instrctions-of-risk-limit
         * @param {dict} info Exchange market response for 1 market
         * @param {dict} market CCXT market
         */ //
                    // Perpetual swap
                    //
                    //    {
                    //        "name": "BTC_USDT",
                    //        "type": "direct",
                    //        "quanto_multiplier": "0.0001",
                    //        "ref_discount_rate": "0",
                    //        "order_price_deviate": "0.5",
                    //        "maintenance_rate": "0.005",
                    //        "mark_type": "index",
                    //        "last_price": "38026",
                    //        "mark_price": "37985.6",
                    //        "index_price": "37954.92",
                    //        "funding_rate_indicative": "0.000219",
                    //        "mark_price_round": "0.01",
                    //        "funding_offset": 0,
                    //        "in_delisting": false,
                    //        "risk_limit_base": "1000000",
                    //        "interest_rate": "0.0003",
                    //        "order_price_round": "0.1",
                    //        "order_size_min": 1,
                    //        "ref_rebate_rate": "0.2",
                    //        "funding_interval": 28800,
                    //        "risk_limit_step": "1000000",
                    //        "leverage_min": "1",
                    //        "leverage_max": "100",
                    //        "risk_limit_max": "8000000",
                    //        "maker_fee_rate": "-0.00025",
                    //        "taker_fee_rate": "0.00075",
                    //        "funding_rate": "0.002053",
                    //        "order_size_max": 1000000,
                    //        "funding_next_apply": 1610035200,
                    //        "short_users": 977,
                    //        "config_change_time": 1609899548,
                    //        "trade_size": 28530850594,
                    //        "position_size": 5223816,
                    //        "long_users": 455,
                    //        "funding_impact_value": "60000",
                    //        "orders_limit": 50,
                    //        "trade_id": 10851092,
                    //        "orderbook_id": 2129638396
                    //    }
                    //
                    // Delivery Futures
                    //
                    //    {
                    //        "name": "BTC_USDT_20200814",
                    //        "underlying": "BTC_USDT",
                    //        "cycle": "WEEKLY",
                    //        "type": "direct",
                    //        "quanto_multiplier": "0.0001",
                    //        "mark_type": "index",
                    //        "last_price": "9017",
                    //        "mark_price": "9019",
                    //        "index_price": "9005.3",
                    //        "basis_rate": "0.185095",
                    //        "basis_value": "13.7",
                    //        "basis_impact_value": "100000",
                    //        "settle_price": "0",
                    //        "settle_price_interval": 60,
                    //        "settle_price_duration": 1800,
                    //        "settle_fee_rate": "0.0015",
                    //        "expire_time": 1593763200,
                    //        "order_price_round": "0.1",
                    //        "mark_price_round": "0.1",
                    //        "leverage_min": "1",
                    //        "leverage_max": "100",
                    //        "maintenance_rate": "1000000",
                    //        "risk_limit_base": "140.726652109199",
                    //        "risk_limit_step": "1000000",
                    //        "risk_limit_max": "8000000",
                    //        "maker_fee_rate": "-0.00025",
                    //        "taker_fee_rate": "0.00075",
                    //        "ref_discount_rate": "0",
                    //        "ref_rebate_rate": "0.2",
                    //        "order_price_deviate": "0.5",
                    //        "order_size_min": 1,
                    //        "order_size_max": 1000000,
                    //        "orders_limit": 50,
                    //        "orderbook_id": 63,
                    //        "trade_id": 26,
                    //        "trade_size": 435,
                    //        "position_size": 130,
                    //        "config_change_time": 1593158867,
                    //        "in_delisting": false
                    //    }
                    //
                    const maintenanceMarginUnit = this.safeString(info, 'maintenance_rate'); // '0.005',
                    const leverageMax = this.safeString(info, 'leverage_max'); // '100',
                    const riskLimitStep = this.safeString(info, 'risk_limit_step'); // '1000000',
                    const riskLimitMax = this.safeString(info, 'risk_limit_max'); // '16000000',
                    const initialMarginUnit = Precise.stringDiv('1', leverageMax);
                    let maintenanceMarginRate = maintenanceMarginUnit;
                    let initialMarginRatio = initialMarginUnit;
                    let floor = '0';
                    const tiers = [];
                    while(Precise.stringLt(floor, riskLimitMax)){
                        const cap = Precise.stringAdd(floor, riskLimitStep);
                        tiers.push({
                            'tier': this.parseNumber(Precise.stringDiv(cap, riskLimitStep)),
                            'currency': this.safeString(market, 'settle'),
                            'minNotional': this.parseNumber(floor),
                            'maxNotional': this.parseNumber(cap),
                            'maintenanceMarginRate': this.parseNumber(maintenanceMarginRate),
                            'maxLeverage': this.parseNumber(Precise.stringDiv('1', initialMarginRatio)),
                            'info': info
                        });
                        maintenanceMarginRate = Precise.stringAdd(maintenanceMarginRate, maintenanceMarginUnit);
                        initialMarginRatio = Precise.stringAdd(initialMarginRatio, initialMarginUnit);
                        floor = cap;
                    }
                    return tiers;
                }
                sign(path, api = [], method = 'GET', params = {}, headers, body) {
                    const authentication = api[0]; // public, private
                    const type = api[1]; // spot, margin, future, delivery
                    let query = this.omit(params, this.extractParams(path));
                    path = this.implodeParams(path, params);
                    const endPart = path === '' ? '' : '/' + path;
                    const entirePath = '/' + type + endPart;
                    let url = this.urls['api'][authentication][type];
                    if (url === undefined) throw new NotSupported(this.id + ' does not have a testnet for the ' + type + ' market type.');
                    url += entirePath;
                    if (authentication === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        let queryString = '';
                        if (method === 'GET' || method === 'DELETE') {
                            if (Object.keys(query).length) {
                                queryString = this.urlencode(query);
                                url += '?' + queryString;
                            }
                        } else {
                            const urlQueryParams = this.safeValue(query, 'query', {});
                            if (Object.keys(urlQueryParams).length) {
                                queryString = this.urlencode(urlQueryParams);
                                url += '?' + queryString;
                            }
                            query = this.omit(query, 'query');
                            body = this.json(query);
                        }
                        const bodyPayload = body === undefined ? '' : body;
                        const bodySignature = this.hash(this.encode(bodyPayload), 'sha512');
                        const timestamp = this.seconds();
                        const timestampString = timestamp.toString();
                        const signaturePath = '/api/' + this.version + entirePath;
                        const payloadArray = [
                            method.toUpperCase(),
                            signaturePath,
                            queryString,
                            bodySignature,
                            timestampString
                        ];
                        // eslint-disable-next-line quotes
                        const payload = payloadArray.join("\n");
                        const signature = this.hmac(this.encode(payload), this.encode(this.secret), 'sha512');
                        headers = {
                            'KEY': this.apiKey,
                            'Timestamp': timestampString,
                            'SIGN': signature,
                            'Content-Type': 'application/json'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    //    {"label": "ORDER_NOT_FOUND", "message": "Order not found"}
                    //    {"label": "INVALID_PARAM_VALUE", "message": "invalid argument: status"}
                    //    {"label": "INVALID_PARAM_VALUE", "message": "invalid argument: Trigger.rule"}
                    //    {"label": "INVALID_PARAM_VALUE", "message": "invalid argument: trigger.expiration invalid range"}
                    //    {"label": "INVALID_ARGUMENT", "detail": "invalid size"}
                    //
                    const label = this.safeString(response, 'label');
                    if (label !== undefined) {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], label, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    84: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, BadRequest: BadRequest, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, InvalidNonce: InvalidNonce, InsufficientFunds: InsufficientFunds, AuthenticationError: AuthenticationError, PermissionDenied: PermissionDenied, NotSupported: NotSupported, OnMaintenance: OnMaintenance, RateLimitExceeded: RateLimitExceeded, ExchangeNotAvailable: ExchangeNotAvailable } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class gemini extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'gemini',
                        'name': 'Gemini',
                        'countries': [
                            'US'
                        ],
                        // 600 requests a minute = 10 requests per second => 1000ms / 10 = 100ms between requests (private endpoints)
                        // 120 requests a minute = 2 requests per second => ( 1000ms / rateLimit ) / 2 = 5 (public endpoints)
                        'rateLimit': 100,
                        'version': 'v1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBidsAsks': undefined,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': undefined,
                            'fetchDepositAddress': undefined,
                            'fetchDepositAddressesByNetwork': true,
                            'fetchDeposits': undefined,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': undefined,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': true,
                            'fetchWithdrawals': undefined,
                            'postOnly': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27816857-ce7be644-6096-11e7-82d6-3c257263229c.jpg',
                            'api': {
                                'public': 'https://api.gemini.com',
                                'private': 'https://api.gemini.com',
                                'web': 'https://docs.gemini.com'
                            },
                            'www': 'https://gemini.com/',
                            'doc': [
                                'https://docs.gemini.com/rest-api',
                                'https://docs.sandbox.gemini.com'
                            ],
                            'test': {
                                'public': 'https://api.sandbox.gemini.com',
                                'private': 'https://api.sandbox.gemini.com',
                                // use the true doc instead of the sandbox doc
                                // since they differ in parsing
                                // https://github.com/ccxt/ccxt/issues/7874
                                // https://github.com/ccxt/ccxt/issues/7894
                                'web': 'https://docs.gemini.com'
                            },
                            'fees': [
                                'https://gemini.com/api-fee-schedule',
                                'https://gemini.com/trading-fees',
                                'https://gemini.com/transfer-fees'
                            ]
                        },
                        'api': {
                            'web': {
                                'get': [
                                    'rest-api'
                                ]
                            },
                            'public': {
                                'get': {
                                    'v1/symbols': 5,
                                    'v1/symbols/details/{symbol}': 5,
                                    'v1/pubticker/{symbol}': 5,
                                    'v2/ticker/{symbol}': 5,
                                    'v2/candles/{symbol}/{timeframe}': 5,
                                    'v1/trades/{symbol}': 5,
                                    'v1/auction/{symbol}': 5,
                                    'v1/auction/{symbol}/history': 5,
                                    'v1/pricefeed': 5,
                                    'v1/book/{symbol}': 5,
                                    'v1/earn/rates': 5
                                }
                            },
                            'private': {
                                'post': {
                                    'v1/order/new': 1,
                                    'v1/order/cancel': 1,
                                    'v1/wrap/{symbol}': 1,
                                    'v1/order/cancel/session': 1,
                                    'v1/order/cancel/all': 1,
                                    'v1/order/status': 1,
                                    'v1/orders': 1,
                                    'v1/mytrades': 1,
                                    'v1/notionalvolume': 1,
                                    'v1/tradevolume': 1,
                                    'v1/clearing/new': 1,
                                    'v1/clearing/status': 1,
                                    'v1/clearing/cancel': 1,
                                    'v1/clearing/confirm': 1,
                                    'v1/balances': 1,
                                    'v1/notionalbalances/{currency}': 1,
                                    'v1/transfers': 1,
                                    'v1/addresses/{network}': 1,
                                    'v1/deposit/{network}/newAddress': 1,
                                    'v1/deposit/{currency}/newAddress': 1,
                                    'v1/withdraw/{currency}': 1,
                                    'v1/account/transfer/{currency}': 1,
                                    'v1/payments/addbank': 1,
                                    'v1/payments/methods': 1,
                                    'v1/payments/sen/withdraw': 1,
                                    'v1/balances/earn': 1,
                                    'v1/earn/interest': 1,
                                    'v1/approvedAddresses/{network}/request': 1,
                                    'v1/approvedAddresses/account/{network}': 1,
                                    'v1/approvedAddresses/{network}/remove': 1,
                                    'v1/account': 1,
                                    'v1/account/create': 1,
                                    'v1/account/list': 1,
                                    'v1/heartbeat': 1
                                }
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'fees': {
                            'trading': {
                                'taker': 0.004,
                                'maker': 0.002
                            }
                        },
                        'httpExceptions': {
                            '400': BadRequest,
                            '403': PermissionDenied,
                            '404': OrderNotFound,
                            '406': InsufficientFunds,
                            '429': RateLimitExceeded,
                            '500': ExchangeError1,
                            '502': ExchangeNotAvailable,
                            '503': OnMaintenance
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1hr',
                            '6h': '6hr',
                            '1d': '1day'
                        },
                        'exceptions': {
                            'exact': {
                                'AuctionNotOpen': BadRequest,
                                'ClientOrderIdTooLong': BadRequest,
                                'ClientOrderIdMustBeString': BadRequest,
                                'ConflictingOptions': BadRequest,
                                'EndpointMismatch': BadRequest,
                                'EndpointNotFound': BadRequest,
                                'IneligibleTiming': BadRequest,
                                'InsufficientFunds': InsufficientFunds,
                                'InvalidJson': BadRequest,
                                'InvalidNonce': InvalidNonce,
                                'InvalidOrderType': InvalidOrder,
                                'InvalidPrice': InvalidOrder,
                                'InvalidQuantity': InvalidOrder,
                                'InvalidSide': InvalidOrder,
                                'InvalidSignature': AuthenticationError,
                                'InvalidSymbol': BadRequest,
                                'InvalidTimestampInPayload': BadRequest,
                                'Maintenance': OnMaintenance,
                                'MarketNotOpen': InvalidOrder,
                                'MissingApikeyHeader': AuthenticationError,
                                'MissingOrderField': InvalidOrder,
                                'MissingRole': AuthenticationError,
                                'MissingPayloadHeader': AuthenticationError,
                                'MissingSignatureHeader': AuthenticationError,
                                'NoSSL': AuthenticationError,
                                'OptionsMustBeArray': BadRequest,
                                'OrderNotFound': OrderNotFound,
                                'RateLimit': RateLimitExceeded,
                                'System': ExchangeError1,
                                'UnsupportedOption': BadRequest
                            },
                            'broad': {
                                'The Gemini Exchange is currently undergoing maintenance.': OnMaintenance,
                                'We are investigating technical issues with the Gemini Exchange.': ExchangeNotAvailable
                            }
                        },
                        'options': {
                            'fetchMarketsMethod': 'fetch_markets_from_web',
                            'fetchTickerMethod': 'fetchTickerV1',
                            'networkIds': {
                                'bitcoin': 'BTC',
                                'ethereum': 'ERC20',
                                'bitcoincash': 'BCH',
                                'litecoin': 'LTC',
                                'zcash': 'ZEC',
                                'filecoin': 'FIL',
                                'dogecoin': 'DOGE',
                                'tezos': 'XTZ'
                            },
                            'networks': {
                                'BTC': 'bitcoin',
                                'ERC20': 'ethereum',
                                'BCH': 'bitcoincash',
                                'LTC': 'litecoin',
                                'ZEC': 'zcash',
                                'FIL': 'filecoin',
                                'DOGE': 'dogecoin',
                                'XTZ': 'tezos'
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const method = this.safeValue(this.options, 'fetchMarketsMethod', 'fetch_markets_from_api');
                    return await this[method](params);
                }
                async fetchMarketsFromWeb(params = {}) {
                    const response = await this.webGetRestApi(params);
                    const sections = response.split('<h1 id="symbols-and-minimums">Symbols and minimums</h1>');
                    const numSections = sections.length;
                    const error = this.id + ' fetchMarketsFromWeb() the ' + this.name + ' API doc HTML markup has changed, breaking the parser of order limits and precision info for ' + this.name + ' markets.';
                    if (numSections !== 2) throw new NotSupported(error);
                    const tables = sections[1].split('tbody>');
                    const numTables = tables.length;
                    if (numTables < 2) throw new NotSupported(error);
                    const rows = tables[1].split("\n<tr>\n"); // eslint-disable-line quotes
                    const numRows = rows.length;
                    if (numRows < 2) throw new NotSupported(error);
                    const result = [];
                    // skip the first element (empty string)
                    for(let i = 1; i < numRows; i++){
                        const row = rows[i];
                        const cells = row.split("</td>\n"); // eslint-disable-line quotes
                        const numCells = cells.length;
                        if (numCells < 5) throw new NotSupported(error);
                        //     [
                        //         '<td>btcusd', // currency
                        //         '<td>0.00001 BTC (1e-5)', // min order size
                        //         '<td>0.00000001 BTC (1e-8)', // tick size
                        //         '<td>0.01 USD', // quote currency price increment
                        //         '</tr>'
                        //     ]
                        const marketId = cells[0].replace('<td>', '');
                        // const base = this.safeCurrencyCode (baseId);
                        const minAmountString = cells[1].replace('<td>', '');
                        const minAmountParts = minAmountString.split(' ');
                        const minAmount = this.safeNumber(minAmountParts, 0);
                        const amountPrecisionString = cells[2].replace('<td>', '');
                        const amountPrecisionParts = amountPrecisionString.split(' ');
                        const idLength = marketId.length - 0;
                        const startingIndex = idLength - 3;
                        const pricePrecisionString = cells[3].replace('<td>', '');
                        const pricePrecisionParts = pricePrecisionString.split(' ');
                        const quoteId = this.safeStringLower(pricePrecisionParts, 1, marketId.slice(startingIndex, idLength));
                        const baseId = this.safeStringLower(amountPrecisionParts, 1, marketId.replace(quoteId, ''));
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        result.push({
                            'id': marketId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(amountPrecisionParts, 0),
                                'price': this.safeNumber(pricePrecisionParts, 0)
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': minAmount,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': row
                        });
                    }
                    return result;
                }
                async fetchMarketsFromAPI(params = {}) {
                    const response = await this.publicGetV1Symbols(params);
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const marketId = response[i];
                        const market = marketId;
                        const idLength = marketId.length - 0;
                        const baseId = marketId.slice(0, idLength - 3);
                        const quoteId = marketId.slice(idLength - 3, idLength);
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        result.push({
                            'id': marketId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'price': undefined,
                                'amount': undefined
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    if (limit !== undefined) {
                        request['limit_bids'] = limit;
                        request['limit_asks'] = limit;
                    }
                    const response = await this.publicGetV1BookSymbol(this.extend(request, params));
                    return this.parseOrderBook(response, symbol, undefined, 'bids', 'asks', 'price', 'amount');
                }
                async fetchTickerV1(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetV1PubtickerSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "bid":"9117.95",
                    //         "ask":"9117.96",
                    //         "volume":{
                    //             "BTC":"1615.46861748",
                    //             "USD":"14727307.57545006088",
                    //             "timestamp":1594982700000
                    //         },
                    //         "last":"9115.23"
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                async fetchTickerV2(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetV2TickerSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "symbol":"BTCUSD",
                    //         "open":"9080.58",
                    //         "high":"9184.53",
                    //         "low":"9063.56",
                    //         "close":"9116.08",
                    //         // Hourly prices descending for past 24 hours
                    //         "changes":["9117.33","9105.69","9106.23","9120.35","9098.57","9114.53","9113.55","9128.01","9113.63","9133.49","9133.49","9137.75","9126.73","9103.91","9119.33","9123.04","9124.44","9117.57","9114.22","9102.33","9076.67","9074.72","9074.97","9092.05"],
                    //         "bid":"9115.86",
                    //         "ask":"9115.87"
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                async fetchTickerV1AndV2(symbol, params = {}) {
                    const tickerA = await this.fetchTickerV1(symbol, params);
                    const tickerB = await this.fetchTickerV2(symbol, params);
                    return this.deepExtend(tickerA, {
                        'open': tickerB['open'],
                        'high': tickerB['high'],
                        'low': tickerB['low'],
                        'change': tickerB['change'],
                        'percentage': tickerB['percentage'],
                        'average': tickerB['average'],
                        'info': tickerB['info']
                    });
                }
                async fetchTicker(symbol, params = {}) {
                    const method = this.safeValue(this.options, 'fetchTickerMethod', 'fetchTickerV1');
                    return await this[method](symbol, params);
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTickers
                    //
                    //     {
                    //         "pair": "BATUSD",
                    //         "price": "0.20687",
                    //         "percentChange24h": "0.0146"
                    //     }
                    //
                    // fetchTickerV1
                    //
                    //     {
                    //         "bid":"9117.95",
                    //         "ask":"9117.96",
                    //         "volume":{
                    //             "BTC":"1615.46861748",
                    //             "USD":"14727307.57545006088",
                    //             "timestamp":1594982700000
                    //         },
                    //         "last":"9115.23"
                    //     }
                    //
                    // fetchTickerV2
                    //
                    //     {
                    //         "symbol":"BTCUSD",
                    //         "open":"9080.58",
                    //         "high":"9184.53",
                    //         "low":"9063.56",
                    //         "close":"9116.08",
                    //         // Hourly prices descending for past 24 hours
                    //         "changes":["9117.33","9105.69","9106.23","9120.35","9098.57","9114.53","9113.55","9128.01","9113.63","9133.49","9133.49","9137.75","9126.73","9103.91","9119.33","9123.04","9124.44","9117.57","9114.22","9102.33","9076.67","9074.72","9074.97","9092.05"],
                    //         "bid":"9115.86",
                    //         "ask":"9115.87"
                    //     }
                    //
                    const volume = this.safeValue(ticker, 'volume', {});
                    const timestamp = this.safeInteger(volume, 'timestamp');
                    let symbol = undefined;
                    const marketId = this.safeStringLower(ticker, 'pair');
                    market = this.safeMarket(marketId, market);
                    let baseId = undefined;
                    let quoteId = undefined;
                    let base = undefined;
                    let quote = undefined;
                    if (marketId !== undefined && market === undefined) {
                        const idLength = marketId.length - 0;
                        if (idLength === 7) {
                            baseId = marketId.slice(0, 4);
                            quoteId = marketId.slice(4, 7);
                        } else {
                            baseId = marketId.slice(0, 3);
                            quoteId = marketId.slice(3, 6);
                        }
                        base = this.safeCurrencyCode(baseId);
                        quote = this.safeCurrencyCode(quoteId);
                        symbol = base + '/' + quote;
                    }
                    if (symbol === undefined && market !== undefined) {
                        symbol = market['symbol'];
                        baseId = this.safeStringUpper(market, 'baseId');
                        quoteId = this.safeStringUpper(market, 'quoteId');
                    }
                    const price = this.safeString(ticker, 'price');
                    const last = this.safeString2(ticker, 'last', 'close', price);
                    const percentage = this.safeString(ticker, 'percentChange24h');
                    const open = this.safeString(ticker, 'open');
                    const baseVolume = this.safeString(volume, baseId);
                    const quoteVolume = this.safeString(volume, quoteId);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetV1Pricefeed(params);
                    //
                    //     [
                    //         {
                    //             "pair": "BATUSD",
                    //             "price": "0.20687",
                    //             "percentChange24h": "0.0146"
                    //         },
                    //         {
                    //             "pair": "LINKETH",
                    //             "price": "0.018",
                    //             "percentChange24h": "0.0000"
                    //         },
                    //     ]
                    //
                    return this.parseTickers(response, symbols);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     {
                    //         "timestamp":1601617445,
                    //         "timestampms":1601617445144,
                    //         "tid":14122489752,
                    //         "price":"0.46476",
                    //         "amount":"28.407209",
                    //         "exchange":"gemini",
                    //         "type":"buy"
                    //     }
                    //
                    // private fetchTrades
                    //
                    //      {
                    //          "price":"3900.00",
                    //          "amount":"0.00996",
                    //          "timestamp":1638891173,
                    //          "timestampms":1638891173518,
                    //          "type":"Sell",
                    //          "aggressor":false,
                    //          "fee_currency":"EUR",
                    //          "fee_amount":"0.00",
                    //          "tid":73621746145,
                    //          "order_id":"73621746059",
                    //          "exchange":"gemini",
                    //          "is_auction_fill":false,
                    //          "is_clearing_fill":false,
                    //          "symbol":"ETHEUR",
                    //          "client_order_id":"1638891171610"
                    //      }
                    //
                    const timestamp = this.safeInteger(trade, 'timestampms');
                    const id = this.safeString(trade, 'tid');
                    const orderId = this.safeString(trade, 'order_id');
                    const feeCurrencyId = this.safeString(trade, 'fee_currency');
                    const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                    const fee = {
                        'cost': this.safeString(trade, 'fee_amount'),
                        'currency': feeCurrencyCode
                    };
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const side = this.safeStringLower(trade, 'type');
                    const symbol = this.safeSymbol(undefined, market);
                    return this.safeTrade({
                        'id': id,
                        'order': orderId,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'cost': undefined,
                        'amount': amountString,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetV1TradesSymbol(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "timestamp":1601617445,
                    //             "timestampms":1601617445144,
                    //             "tid":14122489752,
                    //             "price":"0.46476",
                    //             "amount":"28.407209",
                    //             "exchange":"gemini",
                    //             "type":"buy"
                    //         },
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['total'] = this.safeString(balance, 'amount');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostV1Notionalvolume(params);
                    //
                    //      {
                    //          "web_maker_fee_bps": 25,
                    //          "web_taker_fee_bps": 35,
                    //          "web_auction_fee_bps": 25,
                    //          "api_maker_fee_bps": 10,
                    //          "api_taker_fee_bps": 35,
                    //          "api_auction_fee_bps": 20,
                    //          "fix_maker_fee_bps": 10,
                    //          "fix_taker_fee_bps": 35,
                    //          "fix_auction_fee_bps": 20,
                    //          "block_maker_fee_bps": 0,
                    //          "block_taker_fee_bps": 50,
                    //          "notional_30d_volume": 150.00,
                    //          "last_updated_ms": 1551371446000,
                    //          "date": "2019-02-28",
                    //          "notional_1d_volume": [
                    //              {
                    //                  "date": "2019-02-22",
                    //                  "notional_volume": 75.00
                    //              },
                    //              {
                    //                  "date": "2019-02-14",
                    //                  "notional_volume": 75.00
                    //              }
                    //          ]
                    //     }
                    //
                    const makerBps = this.safeString(response, 'api_maker_fee_bps');
                    const takerBps = this.safeString(response, 'api_taker_fee_bps');
                    const makerString = Precise.stringDiv(makerBps, '10000');
                    const takerString = Precise.stringDiv(takerBps, '10000');
                    const maker = this.parseNumber(makerString);
                    const taker = this.parseNumber(takerString);
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostV1Balances(params);
                    return this.parseBalance(response);
                }
                parseOrder(order, market) {
                    //
                    // createOrder (private)
                    //
                    //      {
                    //          "order_id":"106027397702",
                    //          "id":"106027397702",
                    //          "symbol":"etheur",
                    //          "exchange":"gemini",
                    //          "avg_execution_price":"2877.48",
                    //          "side":"sell",
                    //          "type":"exchange limit",
                    //          "timestamp":"1650398122",
                    //          "timestampms":1650398122308,
                    //          "is_live":false,
                    //          "is_cancelled":false,
                    //          "is_hidden":false,
                    //          "was_forced":false,
                    //          "executed_amount":"0.014434",
                    //          "client_order_id":"1650398121695",
                    //          "options":[],
                    //          "price":"2800.00",
                    //          "original_amount":"0.014434",
                    //          "remaining_amount":"0"
                    //      }
                    //
                    // fetchOrder (private)
                    //
                    //      {
                    //          "order_id":"106028543717",
                    //          "id":"106028543717",
                    //          "symbol":"etheur",
                    //          "exchange":"gemini",
                    //          "avg_execution_price":"0.00",
                    //          "side":"buy",
                    //          "type":"exchange limit",
                    //          "timestamp":"1650398446",
                    //          "timestampms":1650398446375,
                    //          "is_live":true,
                    //          "is_cancelled":false,
                    //          "is_hidden":false,
                    //          "was_forced":false,
                    //          "executed_amount":"0",
                    //          "client_order_id":"1650398445709",
                    //          "options":[],
                    //          "price":"2000.00",
                    //          "original_amount":"0.01",
                    //          "remaining_amount":"0.01"
                    //      }
                    //
                    // fetchOpenOrders (private)
                    //
                    //      {
                    //          "order_id":"106028543717",
                    //          "id":"106028543717",
                    //          "symbol":"etheur",
                    //          "exchange":"gemini",
                    //          "avg_execution_price":"0.00",
                    //          "side":"buy",
                    //          "type":"exchange limit",
                    //          "timestamp":"1650398446",
                    //          "timestampms":1650398446375,
                    //          "is_live":true,
                    //          "is_cancelled":false,
                    //          "is_hidden":false,
                    //          "was_forced":false,
                    //          "executed_amount":"0",
                    //          "client_order_id":"1650398445709",
                    //          "options":[],
                    //          "price":"2000.00",
                    //          "original_amount":"0.01",
                    //          "remaining_amount":"0.01"
                    //      }
                    //
                    // cancelOrder (private)
                    //
                    //      {
                    //          "order_id":"106028543717",
                    //          "id":"106028543717",
                    //          "symbol":"etheur",
                    //          "exchange":"gemini",
                    //          "avg_execution_price":"0.00",
                    //          "side":"buy",
                    //          "type":"exchange limit",
                    //          "timestamp":"1650398446",
                    //          "timestampms":1650398446375,
                    //          "is_live":false,
                    //          "is_cancelled":true,
                    //          "is_hidden":false,
                    //          "was_forced":false,
                    //          "executed_amount":"0",
                    //          "client_order_id":"1650398445709",
                    //          "reason":"Requested",
                    //          "options":[],
                    //          "price":"2000.00",
                    //          "original_amount":"0.01",
                    //          "remaining_amount":"0.01"
                    //      }
                    //
                    const timestamp = this.safeInteger(order, 'timestampms');
                    const amount = this.safeString(order, 'original_amount');
                    const remaining = this.safeString(order, 'remaining_amount');
                    const filled = this.safeString(order, 'executed_amount');
                    let status = 'closed';
                    if (order['is_live']) status = 'open';
                    if (order['is_cancelled']) status = 'canceled';
                    const price = this.safeString(order, 'price');
                    const average = this.safeString(order, 'avg_execution_price');
                    let type = this.safeString(order, 'type');
                    if (type === 'exchange limit') type = 'limit';
                    else if (type === 'market buy' || type === 'market sell') type = 'market';
                    else type = order['type'];
                    const fee = undefined;
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const id = this.safeString(order, 'order_id');
                    const side = this.safeStringLower(order, 'side');
                    const clientOrderId = this.safeString(order, 'client_order_id');
                    const optionsArray = this.safeValue(order, 'options', []);
                    const option = this.safeString(optionsArray, 0);
                    let timeInForce = 'GTC';
                    let postOnly = false;
                    if (option !== undefined) {
                        if (option === 'immediate-or-cancel') timeInForce = 'IOC';
                        else if (option === 'fill-or-kill') timeInForce = 'FOK';
                        else if (option === 'maker-or-cancel') {
                            timeInForce = 'PO';
                            postOnly = true;
                        }
                    }
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'average': average,
                        'cost': undefined,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privatePostV1OrderStatus(this.extend(request, params));
                    //
                    //      {
                    //          "order_id":"106028543717",
                    //          "id":"106028543717",
                    //          "symbol":"etheur",
                    //          "exchange":"gemini",
                    //          "avg_execution_price":"0.00",
                    //          "side":"buy",
                    //          "type":"exchange limit",
                    //          "timestamp":"1650398446",
                    //          "timestampms":1650398446375,
                    //          "is_live":true,
                    //          "is_cancelled":false,
                    //          "is_hidden":false,
                    //          "was_forced":false,
                    //          "executed_amount":"0",
                    //          "client_order_id":"1650398445709",
                    //          "options":[],
                    //          "price":"2000.00",
                    //          "original_amount":"0.01",
                    //          "remaining_amount":"0.01"
                    //      }
                    //
                    return this.parseOrder(response);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostV1Orders(params);
                    //
                    //      [
                    //          {
                    //              "order_id":"106028543717",
                    //              "id":"106028543717",
                    //              "symbol":"etheur",
                    //              "exchange":"gemini",
                    //              "avg_execution_price":"0.00",
                    //              "side":"buy",
                    //              "type":"exchange limit",
                    //              "timestamp":"1650398446",
                    //              "timestampms":1650398446375,
                    //              "is_live":true,
                    //              "is_cancelled":false,
                    //              "is_hidden":false,
                    //              "was_forced":false,
                    //              "executed_amount":"0",
                    //              "client_order_id":"1650398445709",
                    //              "options":[],
                    //              "price":"2000.00",
                    //              "original_amount":"0.01",
                    //              "remaining_amount":"0.01"
                    //          }
                    //      ]
                    //
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol); // throws on non-existent symbol
                    return this.parseOrders(response, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    if (type === 'market') throw new ExchangeError1(this.id + ' createOrder() allows limit orders only');
                    let clientOrderId = this.safeString2(params, 'clientOrderId', 'client_order_id');
                    params = this.omit(params, [
                        'clientOrderId',
                        'client_order_id'
                    ]);
                    if (clientOrderId === undefined) clientOrderId = this.nonce();
                    const amountString = this.amountToPrecision(symbol, amount);
                    const priceString = this.priceToPrecision(symbol, price);
                    const request = {
                        'client_order_id': clientOrderId.toString(),
                        'symbol': this.marketId(symbol),
                        'amount': amountString,
                        'price': priceString,
                        'side': side,
                        'type': 'exchange limit'
                    };
                    type = this.safeString(params, 'type', type);
                    params = this.omit(params, 'type');
                    const rawStopPrice = this.safeString2(params, 'stop_price', 'stopPrice');
                    params = this.omit(params, [
                        'stop_price',
                        'stopPrice',
                        'type'
                    ]);
                    if (type === 'stopLimit') throw new ArgumentsRequired1(this.id + ' createOrder() requires a stopPrice parameter or a stop_price parameter for ' + type + ' orders');
                    if (rawStopPrice !== undefined) {
                        request['stop_price'] = this.priceToPrecision(symbol, rawStopPrice);
                        request['type'] = 'exchange stop limit';
                    } else {
                        // No options can be applied to stop-limit orders at this time.
                        const timeInForce = this.safeString(params, 'timeInForce');
                        params = this.omit(params, 'timeInForce');
                        if (timeInForce !== undefined) {
                            if (timeInForce === 'IOC' || timeInForce === 'immediate-or-cancel') request['options'] = [
                                'immediate-or-cancel'
                            ];
                            else if (timeInForce === 'FOK' || timeInForce === 'fill-or-kill') request['options'] = [
                                'fill-or-kill'
                            ];
                            else if (timeInForce === 'PO') request['options'] = [
                                'maker-or-cancel'
                            ];
                        }
                        const postOnly = this.safeValue(params, 'postOnly', false);
                        params = this.omit(params, 'postOnly');
                        if (postOnly) request['options'] = [
                            'maker-or-cancel'
                        ];
                        // allowing override for auction-only and indication-of-interest order options
                        const options = this.safeString(params, 'options');
                        if (options !== undefined) request['options'] = [
                            options
                        ];
                    }
                    const response = await this.privatePostV1OrderNew(this.extend(request, params));
                    //
                    //      {
                    //          "order_id":"106027397702",
                    //          "id":"106027397702",
                    //          "symbol":"etheur",
                    //          "exchange":"gemini",
                    //          "avg_execution_price":"2877.48",
                    //          "side":"sell",
                    //          "type":"exchange limit",
                    //          "timestamp":"1650398122",
                    //          "timestampms":1650398122308,
                    //          "is_live":false,
                    //          "is_cancelled":false,
                    //          "is_hidden":false,
                    //          "was_forced":false,
                    //          "executed_amount":"0.014434",
                    //          "client_order_id":"1650398121695",
                    //          "options":[],
                    //          "price":"2800.00",
                    //          "original_amount":"0.014434",
                    //          "remaining_amount":"0"
                    //      }
                    //
                    return this.parseOrder(response);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privatePostV1OrderCancel(this.extend(request, params));
                    //
                    //      {
                    //          "order_id":"106028543717",
                    //          "id":"106028543717",
                    //          "symbol":"etheur",
                    //          "exchange":"gemini",
                    //          "avg_execution_price":"0.00",
                    //          "side":"buy",
                    //          "type":"exchange limit",
                    //          "timestamp":"1650398446",
                    //          "timestampms":1650398446375,
                    //          "is_live":false,
                    //          "is_cancelled":true,
                    //          "is_hidden":false,
                    //          "was_forced":false,
                    //          "executed_amount":"0",
                    //          "client_order_id":"1650398445709",
                    //          "reason":"Requested",
                    //          "options":[],
                    //          "price":"2000.00",
                    //          "original_amount":"0.01",
                    //          "remaining_amount":"0.01"
                    //      }
                    //
                    return this.parseOrder(response);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit_trades'] = limit;
                    if (since !== undefined) request['timestamp'] = parseInt(since / 1000);
                    const response = await this.privatePostV1Mytrades(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'amount': amount,
                        'address': address
                    };
                    const response = await this.privatePostV1WithdrawCurrency(this.extend(request, params));
                    //
                    //   for BTC
                    //     {
                    //         "address":"mi98Z9brJ3TgaKsmvXatuRahbFRUFKRUdR",
                    //         "amount":"1",
                    //         "withdrawalId":"02176a83-a6b1-4202-9b85-1c1c92dd25c4",
                    //         "message":"You have requested a transfer of 1 BTC to mi98Z9brJ3TgaKsmvXatuRahbFRUFKRUdR. This withdrawal will be sent to the blockchain within the next 60 seconds."
                    //     }
                    //
                    //   for ETH
                    //     {
                    //         "address":"0xA63123350Acc8F5ee1b1fBd1A6717135e82dBd28",
                    //         "amount":"2.34567",
                    //         "txHash":"0x28267179f92926d85c5516bqc063b2631935573d8915258e95d9572eedcc8cc"
                    //     }
                    //
                    //   for error (other variations of error messages are also expected)
                    //     {
                    //         "result":"error",
                    //         "reason":"CryptoAddressWhitelistsNotEnabled",
                    //         "message":"Cryptocurrency withdrawal address whitelists are not enabled for account 24. Please contact support@gemini.com for information on setting up a withdrawal address whitelist."
                    //     }
                    //
                    const result = this.safeString(response, 'result');
                    if (result === 'error') throw new ExchangeError1(this.id + ' withdraw() failed: ' + this.json(response));
                    return this.parseTransaction(response, currency);
                }
                nonce() {
                    return this.milliseconds();
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (limit !== undefined) request['limit_transfers'] = limit;
                    if (since !== undefined) request['timestamp'] = since;
                    const response = await this.privatePostV1Transfers(this.extend(request, params));
                    return this.parseTransactions(response);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //   for BTC
                    //     {
                    //         "address":"mi98Z9brJ3TgaKsmvXatuRahbFRUFKRUdR",
                    //         "amount":"1",
                    //         "withdrawalId":"02176a83-a6b1-4202-9b85-1c1c92dd25c4",
                    //         "message":"You have requested a transfer of 1 BTC to mi98Z9brJ3TgaKsmvXatuRahbFRUFKRUdR. This withdrawal will be sent to the blockchain within the next 60 seconds."
                    //     }
                    //
                    //   for ETH
                    //     {
                    //         "address":"0xA63123350Acc8F5ee1b1fBd1A6717135e82dBd28",
                    //         "amount":"2.34567",
                    //         "txHash":"0x28267179f92926d85c5516bqc063b2631935573d8915258e95d9572eedcc8cc"
                    //     }
                    //
                    const timestamp = this.safeInteger(transaction, 'timestampms');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const address = this.safeString(transaction, 'destination');
                    const type = this.safeStringLower(transaction, 'type');
                    // if status field is available, then it's complete
                    const statusRaw = this.safeString(transaction, 'status');
                    let fee = undefined;
                    const feeAmount = this.safeNumber(transaction, 'feeAmount');
                    if (feeAmount !== undefined) fee = {
                        'cost': feeAmount,
                        'currency': code
                    };
                    return {
                        'info': transaction,
                        'id': this.safeString2(transaction, 'eid', 'withdrawalId'),
                        'txid': this.safeString(transaction, 'txHash'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': this.safeNumber(transaction, 'amount'),
                        'currency': code,
                        'status': this.parseTransactionStatus(statusRaw),
                        'updated': undefined,
                        'fee': fee
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'Advanced': 'ok',
                        'Complete': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //      {
                    //          address: "0xed6494Fe7c1E56d1bd6136e89268C51E32d9708B",
                    //          timestamp: "1636813923098",
                    //          addressVersion: "eV1"                                         }
                    //      }
                    //
                    const address = this.safeString(depositAddress, 'address');
                    return {
                        'currency': currency,
                        'network': undefined,
                        'address': address,
                        'tag': undefined,
                        'info': depositAddress
                    };
                }
                async fetchDepositAddressesByNetwork(code, params = {}) {
                    await this.loadMarkets();
                    const network = this.safeString(params, 'network');
                    if (network === undefined) throw new ArgumentsRequired1(this.id + ' fetchDepositAddressesByNetwork() requires a network parameter');
                    params = this.omit(params, 'network');
                    const networks = this.safeValue(this.options, 'networks', {});
                    const networkId = this.safeString(networks, network, network);
                    const networkIds = this.safeValue(this.options, 'networkIds', {});
                    const networkCode = this.safeString(networkIds, networkId, network);
                    const request = {
                        'network': networkId
                    };
                    const response = await this.privatePostV1AddressesNetwork(this.extend(request, params));
                    const results = this.parseDepositAddresses(response, [
                        code
                    ], false, {
                        'network': networkCode,
                        'currency': code
                    });
                    return this.groupBy(results, 'network');
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const apiKey = this.apiKey;
                        if (apiKey.indexOf('account') < 0) throw new AuthenticationError(this.id + ' sign() requires an account-key, master-keys are not-supported');
                        const nonce = this.nonce();
                        const request = this.extend({
                            'request': url,
                            'nonce': nonce
                        }, query);
                        let payload = this.json(request);
                        payload = this.stringToBase64(payload);
                        const signature = this.hmac(payload, this.encode(this.secret), 'sha384');
                        headers = {
                            'Content-Type': 'text/plain',
                            'X-GEMINI-APIKEY': this.apiKey,
                            'X-GEMINI-PAYLOAD': this.decode(payload),
                            'X-GEMINI-SIGNATURE': signature
                        };
                    } else if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    url = this.urls['api'][api] + url;
                    if (method === 'POST' || method === 'DELETE') body = this.json(query);
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) {
                        if (typeof body === 'string') {
                            const feedback = this.id + ' ' + body;
                            this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                        }
                        return; // fallback to default error handler
                    }
                    //
                    //     {
                    //         "result": "error",
                    //         "reason": "BadNonce",
                    //         "message": "Out-of-sequence nonce <1234> precedes previously used nonce <2345>"
                    //     }
                    //
                    const result = this.safeString(response, 'result');
                    if (result === 'error') {
                        const reason = this.safeString(response, 'reason');
                        const message = this.safeString(response, 'message');
                        const feedback = this.id + ' ' + message;
                        this.throwExactlyMatchedException(this.exceptions['exact'], reason, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privatePostV1DepositCurrencyNewAddress(this.extend(request, params));
                    const address = this.safeString(response, 'address');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': undefined,
                        'info': response
                    };
                }
                async fetchOHLCV(symbol, timeframe = '5m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'timeframe': this.timeframes[timeframe],
                        'symbol': market['id']
                    };
                    const response = await this.publicGetV2CandlesSymbolTimeframe(this.extend(request, params));
                    //
                    //     [
                    //         [1591515000000,0.02509,0.02509,0.02509,0.02509,0],
                    //         [1591514700000,0.02503,0.02509,0.02503,0.02509,44.6405],
                    //         [1591514400000,0.02503,0.02503,0.02503,0.02503,0],
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    85: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { BadSymbol: BadSymbol, PermissionDenied: PermissionDenied, ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, RequestTimeout: RequestTimeout, AuthenticationError: AuthenticationError } = require1('./base/errors');
            const { TRUNCATE: TRUNCATE, DECIMAL_PLACES: DECIMAL_PLACES, TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            // ---------------------------------------------------------------------------
            module.exports = class hitbtc extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'hitbtc',
                        'name': 'HitBTC',
                        'countries': [
                            'HK'
                        ],
                        // 300 requests per second => 1000ms / 300 = 3.333ms between requests on average (Trading)
                        // 100 requests per second => ( 1000ms / rateLimit ) / 100 => cost = 3.0003 (Market Data)
                        // 10 requests per second => ( 1000ms / rateLimit ) / 10 => cost = 30.003 (Other Requests)
                        'rateLimit': 3.333,
                        'version': '2',
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': undefined,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': undefined,
                            'fetchOrderTrades': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': false,
                            'fetchTransactions': true,
                            'fetchWithdrawals': undefined,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': 'M1',
                            '3m': 'M3',
                            '5m': 'M5',
                            '15m': 'M15',
                            '30m': 'M30',
                            '1h': 'H1',
                            '4h': 'H4',
                            '1d': 'D1',
                            '1w': 'D7',
                            '1M': '1M'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766555-8eaec20e-5edc-11e7-9c5b-6dc69fc42f5e.jpg',
                            'test': {
                                'public': 'https://api.demo.hitbtc.com',
                                'private': 'https://api.demo.hitbtc.com'
                            },
                            'api': {
                                'public': 'https://api.hitbtc.com',
                                'private': 'https://api.hitbtc.com'
                            },
                            'www': 'https://hitbtc.com',
                            'referral': 'https://hitbtc.com/?ref_id=5a5d39a65d466',
                            'doc': [
                                'https://api.hitbtc.com/v2'
                            ],
                            'fees': [
                                'https://hitbtc.com/fees-and-limits',
                                'https://support.hitbtc.com/hc/en-us/articles/115005148605-Fees-and-limits'
                            ]
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'currency': 3,
                                    'currency/{currency}': 3,
                                    'symbol': 3,
                                    'symbol/{symbol}': 3,
                                    'ticker': 3,
                                    'ticker/{symbol}': 3,
                                    'trades': 3,
                                    'trades/{symbol}': 3,
                                    'orderbook': 3,
                                    'orderbook/{symbol}': 3,
                                    'candles': 3,
                                    'candles/{symbol}': 3
                                }
                            },
                            'private': {
                                'get': {
                                    'trading/balance': 30,
                                    'order': 30,
                                    'order/{clientOrderId}': 30,
                                    'trading/fee/all': 30,
                                    'trading/fee/{symbol}': 30,
                                    'margin/account': 30,
                                    'margin/account/{symbol}': 30,
                                    'margin/position': 30,
                                    'margin/position/{symbol}': 30,
                                    'margin/order': 30,
                                    'margin/order/{clientOrderId}': 30,
                                    'history/order': 30,
                                    'history/trades': 30,
                                    'history/order/{orderId}/trades': 30,
                                    'account/balance': 30,
                                    'account/crypto/address/{currency}': 30,
                                    'account/crypto/addresses/{currency}': 30,
                                    'account/crypto/used-addresses/{currency}': 30,
                                    'account/crypto/estimate-withdraw': 30,
                                    'account/crypto/is-mine/{address}': 30,
                                    'account/transactions': 30,
                                    'account/transactions/{id}': 30,
                                    'sub-acc': 30,
                                    'sub-acc/acl': 30,
                                    'sub-acc/balance/{subAccountUserID}': 30,
                                    'sub-acc/deposit-address/{subAccountUserId}/{currency}': 30
                                },
                                'post': {
                                    'order': 1,
                                    'margin/order': 1,
                                    'account/crypto/address/{currency}': 1,
                                    'account/crypto/withdraw': 1,
                                    'account/crypto/transfer-convert': 1,
                                    'account/transfer': 1,
                                    'account/transfer/internal': 1,
                                    'sub-acc/freeze': 1,
                                    'sub-acc/activate': 1,
                                    'sub-acc/transfer': 1
                                },
                                'put': {
                                    'order/{clientOrderId}': 1,
                                    'margin/account/{symbol}': 1,
                                    'margin/order/{clientOrderId}': 1,
                                    'account/crypto/withdraw/{id}': 1,
                                    'sub-acc/acl/{subAccountUserId}': 1
                                },
                                'delete': {
                                    'order': 1,
                                    'order/{clientOrderId}': 1,
                                    'margin/account': 1,
                                    'margin/account/{symbol}': 1,
                                    'margin/position': 1,
                                    'margin/position/{symbol}': 1,
                                    'margin/order': 1,
                                    'margin/order/{clientOrderId}': 1,
                                    'account/crypto/withdraw/{id}': 1
                                },
                                // outdated?
                                'patch': {
                                    'order/{clientOrderId}': 1
                                }
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': 0.001,
                                'taker': 0.002
                            }
                        },
                        'options': {
                            'networks': {
                                'ETH': 'T20',
                                'ERC20': 'T20',
                                'TRX': 'TTRX',
                                'TRC20': 'TTRX',
                                'OMNI': ''
                            },
                            'defaultTimeInForce': 'FOK',
                            'accountsByType': {
                                'funding': 'bank',
                                'spot': 'exchange'
                            },
                            'fetchBalanceMethod': {
                                'account': 'account',
                                'bank': 'account',
                                'main': 'account',
                                'funding': 'account',
                                'exchange': 'trading',
                                'spot': 'trading',
                                'trade': 'trading',
                                'trading': 'trading'
                            }
                        },
                        'commonCurrencies': {
                            'AUTO': 'Cube',
                            'BCC': 'BCC',
                            'BDP': 'BidiPass',
                            'BET': 'DAO.Casino',
                            'BIT': 'BitRewards',
                            'BOX': 'BOX Token',
                            'CPT': 'Cryptaur',
                            'GET': 'Themis',
                            'GMT': 'GMT Token',
                            'HSR': 'HC',
                            'IQ': 'IQ.Cash',
                            'LNC': 'LinkerCoin',
                            'PLA': 'PlayChip',
                            'PNT': 'Penta',
                            'SBTC': 'Super Bitcoin',
                            'STEPN': 'GMT',
                            'STX': 'STOX',
                            'TV': 'Tokenville',
                            'USD': 'USDT',
                            'XMT': 'MTL',
                            'XPNT': 'PNT'
                        },
                        'exceptions': {
                            '504': RequestTimeout,
                            '1002': AuthenticationError,
                            '1003': PermissionDenied,
                            '2010': InvalidOrder,
                            '2001': BadSymbol,
                            '2011': InvalidOrder,
                            '2020': InvalidOrder,
                            '20002': OrderNotFound,
                            '20001': InsufficientFunds,
                            '20010': BadSymbol,
                            '20045': InvalidOrder
                        }
                    });
                }
                feeToPrecision(symbol, fee) {
                    return this.decimalToPrecision(fee, TRUNCATE, 8, DECIMAL_PLACES);
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetSymbol(params);
                    //
                    //     [
                    //         {
                    //             "id":"BCNBTC",
                    //             "baseCurrency":"BCN",
                    //             "quoteCurrency":"BTC",
                    //             "quantityIncrement":"100",
                    //             "tickSize":"0.00000000001",
                    //             "takeLiquidityRate":"0.002",
                    //             "provideLiquidityRate":"0.001",
                    //             "feeCurrency":"BTC"
                    //         }
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'id');
                        const baseId = this.safeString(market, 'baseCurrency');
                        const quoteId = this.safeString(market, 'quoteCurrency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        // bequant fix
                        let symbol = base + '/' + quote;
                        if (id.indexOf('_') >= 0) symbol = id;
                        const lotString = this.safeString(market, 'quantityIncrement');
                        const stepString = this.safeString(market, 'tickSize');
                        const lot = this.parseNumber(lotString);
                        const step = this.parseNumber(stepString);
                        const feeCurrencyId = this.safeString(market, 'feeCurrency');
                        result.push(this.extend(this.fees['trading'], {
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.safeNumber(market, 'takeLiquidityRate'),
                            'maker': this.safeNumber(market, 'provideLiquidityRate'),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'feeCurrency': this.safeCurrencyCode(feeCurrencyId),
                            'precision': {
                                'amount': lot,
                                'price': step
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': lot,
                                    'max': undefined
                                },
                                'price': {
                                    'min': step,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.parseNumber(Precise.stringMul(lotString, stepString)),
                                    'max': undefined
                                }
                            },
                            'info': market
                        }));
                    }
                    return result;
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    // account can be "exchange" or "bank", with aliases "main" or "trading" respectively
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const requestAmount = this.currencyToPrecision(code, amount);
                    const request = {
                        'currency': currency['id'],
                        'amount': requestAmount
                    };
                    let type = this.safeString(params, 'type');
                    if (type === undefined) {
                        const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                        const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                        const toId = this.safeString(accountsByType, toAccount, toAccount);
                        if (fromId === toId) throw new ExchangeError1(this.id + ' transfer() from and to cannot be the same account');
                        type = fromId + 'To' + this.capitalize(toId);
                    }
                    request['type'] = type;
                    const response = await this.privatePostAccountTransfer(this.extend(request, params));
                    //
                    //     {
                    //         'id': '2db6ebab-fb26-4537-9ef8-1a689472d236'
                    //     }
                    //
                    const transfer = this.parseTransfer(response, currency);
                    return this.extend(transfer, {
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'amount': this.parseNumber(requestAmount)
                    });
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //         'id': '2db6ebab-fb26-4537-9ef8-1a689472d236'
                    //     }
                    //
                    const timestamp = this.milliseconds();
                    return {
                        'id': this.safeString(transfer, 'id'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': this.safeCurrencyCode(undefined, currency),
                        'amount': undefined,
                        'fromAccount': undefined,
                        'toAccount': undefined,
                        'status': undefined,
                        'info': transfer
                    };
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrency(params);
                    //
                    //     [
                    //         {
                    //             "id":"XPNT",
                    //             "fullName":"pToken",
                    //             "crypto":true,
                    //             "payinEnabled":true,
                    //             "payinPaymentId":false,
                    //             "payinConfirmations":9,
                    //             "payoutEnabled":true,
                    //             "payoutIsPaymentId":false,
                    //             "transferEnabled":true,
                    //             "delisted":false,
                    //             "payoutFee":"26.510000000000",
                    //             "precisionPayout":18,
                    //             "precisionTransfer":8
                    //         }
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        const id = this.safeString(currency, 'id');
                        // todo: will need to rethink the fees
                        // to add support for multiple withdrawal/deposit methods and
                        // differentiated fees for each particular method
                        const decimals = this.safeInteger(currency, 'precisionTransfer', 8);
                        const precision = 1 / Math.pow(10, decimals);
                        const code = this.safeCurrencyCode(id);
                        const payin = this.safeValue(currency, 'payinEnabled');
                        const payout = this.safeValue(currency, 'payoutEnabled');
                        const transfer = this.safeValue(currency, 'transferEnabled');
                        let active = payin && payout && transfer;
                        if ('disabled' in currency) {
                            if (currency['disabled']) active = false;
                        }
                        let type = 'fiat';
                        if ('crypto' in currency && currency['crypto']) type = 'crypto';
                        const name = this.safeString(currency, 'fullName');
                        result[code] = {
                            'id': id,
                            'code': code,
                            'type': type,
                            'payin': payin,
                            'payout': payout,
                            'transfer': transfer,
                            'info': currency,
                            'name': name,
                            'active': active,
                            'deposit': payin,
                            'withdraw': payout,
                            'fee': this.safeNumber(currency, 'payoutFee'),
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': 1 / Math.pow(10, decimals),
                                    'max': Math.pow(10, decimals)
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': Math.pow(10, precision)
                                }
                            }
                        };
                    }
                    return result;
                }
                parseTradingFee(fee, market) {
                    //
                    //
                    //     {
                    //         takeLiquidityRate: '0.001',
                    //         provideLiquidityRate: '-0.0001'
                    //     }
                    //
                    return {
                        'info': fee,
                        'symbol': this.safeSymbol(undefined, market),
                        'maker': this.safeNumber(fee, 'provideLiquidityRate'),
                        'taker': this.safeNumber(fee, 'takeLiquidityRate'),
                        'percentage': true,
                        'tierBased': true
                    };
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.privateGetTradingFeeSymbol(request);
                    //
                    //     {
                    //         takeLiquidityRate: '0.001',
                    //         provideLiquidityRate: '-0.0001'
                    //     }
                    //
                    return this.parseTradingFee(response, market);
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'reserved');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const type = this.safeString(params, 'type', 'trading');
                    const fetchBalanceAccounts = this.safeValue(this.options, 'fetchBalanceMethod', {});
                    const typeId = this.safeString(fetchBalanceAccounts, type);
                    if (typeId === undefined) throw new ExchangeError1(this.id + ' fetchBalance() account type must be either main or trading');
                    const method = 'privateGet' + this.capitalize(typeId) + 'Balance';
                    const query = this.omit(params, 'type');
                    const response = await this[method](query);
                    //
                    //     [
                    //         {"currency":"SPI","available":"0","reserved":"0"},
                    //         {"currency":"GRPH","available":"0","reserved":"0"},
                    //         {"currency":"DGTX","available":"0","reserved":"0"},
                    //     ]
                    //
                    return this.parseBalance(response);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "timestamp":"2015-08-20T19:01:00.000Z",
                    //         "open":"0.006",
                    //         "close":"0.006",
                    //         "min":"0.006",
                    //         "max":"0.006",
                    //         "volume":"0.003",
                    //         "volumeQuote":"0.000018"
                    //     }
                    //
                    return [
                        this.parse8601(this.safeString(ohlcv, 'timestamp')),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'max'),
                        this.safeNumber(ohlcv, 'min'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'period': this.timeframes[timeframe]
                    };
                    if (since !== undefined) request['from'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetCandlesSymbol(this.extend(request, params));
                    //
                    //     [
                    //         {"timestamp":"2015-08-20T19:01:00.000Z","open":"0.006","close":"0.006","min":"0.006","max":"0.006","volume":"0.003","volumeQuote":"0.000018"},
                    //         {"timestamp":"2015-08-20T19:03:00.000Z","open":"0.006","close":"0.006","min":"0.006","max":"0.006","volume":"0.013","volumeQuote":"0.000078"},
                    //         {"timestamp":"2015-08-20T19:06:00.000Z","open":"0.0055","close":"0.005","min":"0.005","max":"0.0055","volume":"0.003","volumeQuote":"0.0000155"},
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['limit'] = limit; // default = 100, 0 = unlimited
                    const response = await this.publicGetOrderbookSymbol(this.extend(request, params));
                    return this.parseOrderBook(response, symbol, undefined, 'bid', 'ask', 'price', 'size');
                }
                parseTicker(ticker, market) {
                    const timestamp = this.parse8601(ticker['timestamp']);
                    const symbol = this.safeSymbol(undefined, market);
                    const baseVolume = this.safeString(ticker, 'volume');
                    const quoteVolume = this.safeString(ticker, 'volumeQuote');
                    const open = this.safeString(ticker, 'open');
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTicker(params);
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const ticker = response[i];
                        const marketId = this.safeString(ticker, 'symbol');
                        const market = this.safeMarket(marketId);
                        const symbol = market['symbol'];
                        result[symbol] = this.parseTicker(ticker, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetTickerSymbol(this.extend(request, params));
                    if ('message' in response) throw new ExchangeError1(this.id + ' ' + response['message']);
                    return this.parseTicker(response, market);
                }
                parseTrade(trade, market) {
                    // createMarketOrder
                    //
                    //  {       fee: "0.0004644",
                    //           id:  386394956,
                    //        price: "0.4644",
                    //     quantity: "1",
                    //    timestamp: "2018-10-25T16:41:44.780Z" }
                    //
                    // fetchTrades
                    //
                    // { id: 974786185,
                    //   price: '0.032462',
                    //   quantity: '0.3673',
                    //   side: 'buy',
                    //   timestamp: '2020-10-16T12:57:39.846Z' }
                    //
                    // fetchMyTrades
                    //
                    // { id: 277210397,
                    //   clientOrderId: '6e102f3e7f3f4e04aeeb1cdc95592f1a',
                    //   orderId: 28102855393,
                    //   symbol: 'ETHBTC',
                    //   side: 'sell',
                    //   quantity: '0.002',
                    //   price: '0.073365',
                    //   fee: '0.000000147',
                    //   timestamp: '2018-04-28T18:39:55.345Z' }
                    //
                    //  {
                    //      "id":1568938909,
                    //      "orderId":793293348428,
                    //      "clientOrderId":"fbc5c5b753e8476cb14697458cb928ef",
                    //      "symbol":"DOGEUSD",
                    //      "side":"sell",
                    //      "quantity":"100",
                    //      "price":"0.03904191",
                    //      "fee":"0.009760477500",
                    //      "timestamp":"2022-01-25T15:15:41.353Z",
                    //      "taker":true
                    //  }
                    //
                    const timestamp = this.parse8601(trade['timestamp']);
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) {
                        const feeCurrencyCode = market ? market['feeCurrency'] : undefined;
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    // we use clientOrderId as the order id with this exchange intentionally
                    // because most of their endpoints will require clientOrderId
                    // explained here: https://github.com/ccxt/ccxt/issues/5674
                    const orderId = this.safeString(trade, 'clientOrderId');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'quantity');
                    const side = this.safeString(trade, 'side');
                    const id = this.safeString(trade, 'id');
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['asset'] = currency['id'];
                    }
                    if (since !== undefined) request['startTime'] = since;
                    const response = await this.privateGetAccountTransactions(this.extend(request, params));
                    return this.parseTransactions(response, currency, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // transactions
                    //
                    //     {
                    //         id: 'd53ee9df-89bf-4d09-886e-849f8be64647',
                    //         index: 1044718371,
                    //         type: 'payout', // payout, payin
                    //         status: 'success',
                    //         currency: 'ETH',
                    //         amount: '4.522683200000000000000000',
                    //         createdAt: '2018-06-07T00:43:32.426Z',
                    //         updatedAt: '2018-06-07T00:45:36.447Z',
                    //         hash: '0x973e5683dfdf80a1fb1e0b96e19085b6489221d2ddf864daa46903c5ec283a0f',
                    //         address: '0xC5a59b21948C1d230c8C54f05590000Eb3e1252c',
                    //         fee: '0.00958',
                    //     },
                    //     {
                    //         id: 'e6c63331-467e-4922-9edc-019e75d20ba3',
                    //         index: 1044714672,
                    //         type: 'exchangeToBank', // exchangeToBank, bankToExchange, withdraw
                    //         status: 'success',
                    //         currency: 'ETH',
                    //         amount: '4.532263200000000000',
                    //         createdAt: '2018-06-07T00:42:39.543Z',
                    //         updatedAt: '2018-06-07T00:42:39.683Z',
                    //     },
                    //
                    // withdraw
                    //
                    //     {
                    //         "id": "d2ce578f-647d-4fa0-b1aa-4a27e5ee597b"
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const timestamp = this.parse8601(this.safeString(transaction, 'createdAt'));
                    const updated = this.parse8601(this.safeString(transaction, 'updatedAt'));
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const amount = this.safeNumber(transaction, 'amount');
                    const address = this.safeString(transaction, 'address');
                    const txid = this.safeString(transaction, 'hash');
                    let fee = undefined;
                    const feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    const type = this.parseTransactionType(this.safeString(transaction, 'type'));
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'pending': 'pending',
                        'failed': 'failed',
                        'success': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransactionType(type) {
                    const types = {
                        'payin': 'deposit',
                        'payout': 'withdrawal',
                        'withdraw': 'withdrawal'
                    };
                    return this.safeString(types, type, type);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) {
                        request['sort'] = 'ASC';
                        request['from'] = this.iso8601(since);
                    }
                    const response = await this.publicGetTradesSymbol(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    // we use clientOrderId as the order id with this exchange intentionally
                    // because most of their endpoints will require clientOrderId
                    // explained here: https://github.com/ccxt/ccxt/issues/5674
                    // their max accepted length is 32 characters
                    const uuid = this.uuid();
                    const parts = uuid.split('-');
                    let clientOrderId = parts.join('');
                    clientOrderId = clientOrderId.slice(0, 32);
                    amount = parseFloat(amount);
                    const request = {
                        'clientOrderId': clientOrderId,
                        'symbol': market['id'],
                        'side': side,
                        'quantity': this.amountToPrecision(symbol, amount),
                        'type': type
                    };
                    if (type === 'limit') request['price'] = this.priceToPrecision(symbol, price);
                    else request['timeInForce'] = this.options['defaultTimeInForce'];
                    const response = await this.privatePostOrder(this.extend(request, params));
                    const order = this.parseOrder(response);
                    if (order['status'] === 'rejected') throw new InvalidOrder(this.id + ' order was rejected by the exchange ' + this.json(order));
                    return order;
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    // we use clientOrderId as the order id with this exchange intentionally
                    // because most of their endpoints will require clientOrderId
                    // explained here: https://github.com/ccxt/ccxt/issues/5674
                    // their max accepted length is 32 characters
                    const uuid = this.uuid();
                    const parts = uuid.split('-');
                    let requestClientId = parts.join('');
                    requestClientId = requestClientId.slice(0, 32);
                    const request = {
                        'clientOrderId': id,
                        'requestClientId': requestClientId
                    };
                    if (amount !== undefined) request['quantity'] = this.amountToPrecision(symbol, amount);
                    if (price !== undefined) request['price'] = this.priceToPrecision(symbol, price);
                    const response = await this.privatePatchOrderClientOrderId(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    // we use clientOrderId as the order id with this exchange intentionally
                    // because most of their endpoints will require clientOrderId
                    // explained here: https://github.com/ccxt/ccxt/issues/5674
                    const request = {
                        'clientOrderId': id
                    };
                    const response = await this.privateDeleteOrderClientOrderId(this.extend(request, params));
                    return this.parseOrder(response);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'new': 'open',
                        'suspended': 'open',
                        'partiallyFilled': 'open',
                        'filled': 'closed',
                        'canceled': 'canceled',
                        'expired': 'failed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createMarketOrder
                    //
                    //     {
                    //         clientOrderId: "fe36aa5e190149bf9985fb673bbb2ea0",
                    //         createdAt: "2018-10-25T16:41:44.780Z",
                    //         cumQuantity: "1",
                    //         id: "66799540063",
                    //         quantity: "1",
                    //         side: "sell",
                    //         status: "filled",
                    //         symbol: "XRPUSDT",
                    //         timeInForce: "FOK",
                    //         tradesReport: [
                    //             {
                    //                 fee: "0.0004644",
                    //                 id:  386394956,
                    //                 price: "0.4644",
                    //                 quantity: "1",
                    //                 timestamp: "2018-10-25T16:41:44.780Z"
                    //             }
                    //         ],
                    //         type: "market",
                    //         updatedAt: "2018-10-25T16:41:44.780Z"
                    //     }
                    //
                    //     {
                    //         "id": 119499457455,
                    //         "clientOrderId": "87baab109d58401b9202fa0749cb8288",
                    //         "symbol": "ETHUSD",
                    //         "side": "buy",
                    //         "status": "filled",
                    //         "type": "market",
                    //         "timeInForce": "FOK",
                    //         "quantity": "0.0007",
                    //         "price": "181.487",
                    //         "avgPrice": "164.989",
                    //         "cumQuantity": "0.0007",
                    //         "createdAt": "2019-04-17T13:27:38.062Z",
                    //         "updatedAt": "2019-04-17T13:27:38.062Z"
                    //     }
                    //
                    const created = this.parse8601(this.safeString(order, 'createdAt'));
                    const updated = this.parse8601(this.safeString(order, 'updatedAt'));
                    const marketId = this.safeString(order, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const amount = this.safeString(order, 'quantity');
                    const filled = this.safeString(order, 'cumQuantity');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    // we use clientOrderId as the order id with this exchange intentionally
                    // because most of their endpoints will require clientOrderId
                    // explained here: https://github.com/ccxt/ccxt/issues/5674
                    const id = this.safeString(order, 'clientOrderId');
                    const clientOrderId = id;
                    const price = this.safeString(order, 'price');
                    const type = this.safeString(order, 'type');
                    const side = this.safeString(order, 'side');
                    const trades = this.safeValue(order, 'tradesReport');
                    const fee = undefined;
                    const average = this.safeString(order, 'avgPrice');
                    const timeInForce = this.safeString(order, 'timeInForce');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': created,
                        'datetime': this.iso8601(created),
                        'lastTradeTimestamp': updated,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'average': average,
                        'amount': amount,
                        'cost': undefined,
                        'filled': filled,
                        'remaining': undefined,
                        'fee': fee,
                        'trades': trades,
                        'info': order
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    // we use clientOrderId as the order id with this exchange intentionally
                    // because most of their endpoints will require clientOrderId
                    // explained here: https://github.com/ccxt/ccxt/issues/5674
                    const request = {
                        'clientOrderId': id
                    };
                    const response = await this.privateGetHistoryOrder(this.extend(request, params));
                    const numOrders = response.length;
                    if (numOrders > 0) return this.parseOrder(response[0]);
                    throw new OrderNotFound(this.id + ' order ' + id + ' not found');
                }
                async fetchOpenOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    // we use clientOrderId as the order id with this exchange intentionally
                    // because most of their endpoints will require clientOrderId
                    // explained here: https://github.com/ccxt/ccxt/issues/5674
                    const request = {
                        'clientOrderId': id
                    };
                    const response = await this.privateGetOrderClientOrderId(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const response = await this.privateGetOrder(this.extend(request, params));
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['from'] = this.iso8601(since);
                    const response = await this.privateGetHistoryOrder(this.extend(request, params));
                    const parsedOrders = this.parseOrders(response, market);
                    const orders = [];
                    for(let i = 0; i < parsedOrders.length; i++){
                        const order = parsedOrders[i];
                        const status = order['status'];
                        if (status === 'closed' || status === 'canceled') orders.push(order);
                    }
                    return this.filterBySinceLimit(orders, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['from'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetHistoryTrades(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id": 9535486,
                    //             "clientOrderId": "f8dbaab336d44d5ba3ff578098a68454",
                    //             "orderId": 816088377,
                    //             "symbol": "ETHBTC",
                    //             "side": "sell",
                    //             "quantity": "0.061",
                    //             "price": "0.045487",
                    //             "fee": "0.000002775",
                    //             "timestamp": "2017-05-17T12:32:57.848Z"
                    //         },
                    //         {
                    //             "id": 9535437,
                    //             "clientOrderId": "27b9bfc068b44194b1f453c7af511ed6",
                    //             "orderId": 816088021,
                    //             "symbol": "ETHBTC",
                    //             "side": "buy",
                    //             "quantity": "0.038",
                    //             "price": "0.046000",
                    //             "fee": "-0.000000174",
                    //             "timestamp": "2017-05-17T12:30:57.848Z"
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    // The id needed here is the exchange's id, and not the clientOrderID,
                    // which is the id that is stored in the unified order id
                    // To get the exchange's id you need to grab it from order['info']['id']
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'orderId': id
                    };
                    const response = await this.privateGetHistoryOrderOrderIdTrades(this.extend(request, params));
                    const numOrders = response.length;
                    if (numOrders > 0) return this.parseTrades(response, market, since, limit);
                    throw new OrderNotFound(this.id + ' order ' + id + ' not found, ' + this.id + '.fetchOrderTrades() requires an exchange-specific order id, you need to grab it from order["info"]["id"]');
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privatePostAccountCryptoAddressCurrency(this.extend(request, params));
                    const address = this.safeString(response, 'address');
                    this.checkAddress(address);
                    const tag = this.safeString(response, 'paymentId');
                    return {
                        'currency': currency,
                        'address': address,
                        'tag': tag,
                        'info': response
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const network = this.safeString(params, 'network');
                    if (network !== undefined) {
                        params = this.omit(params, 'network');
                        const networks = this.safeValue(this.options, 'networks');
                        const endpart = this.safeString(networks, network, network);
                        request['currency'] += endpart;
                    }
                    const response = await this.privateGetAccountCryptoAddressCurrency(this.extend(request, params));
                    const address = this.safeString(response, 'address');
                    this.checkAddress(address);
                    const tag = this.safeString(response, 'paymentId');
                    return {
                        'currency': currency['code'],
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async convertCurrencyNetwork(code, amount, fromNetwork, toNetwork, params) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const networks = this.safeValue(this.options, 'networks', {});
                    fromNetwork = this.safeString(networks, fromNetwork, fromNetwork); // handle ETH>ERC20 alias
                    toNetwork = this.safeString(networks, toNetwork, toNetwork); // handle ETH>ERC20 alias
                    if (fromNetwork === toNetwork) throw new ExchangeError1(this.id + ' convertCurrencyNetwork() fromNetwork cannot be the same as toNetwork');
                    const request = {
                        'fromCurrency': currency['id'] + fromNetwork,
                        'toCurrency': currency['id'] + toNetwork,
                        'amount': parseFloat(this.currencyToPrecision(code, amount))
                    };
                    const response = await this.privatePostAccountCryptoTransferConvert(this.extend(request, params));
                    return {
                        'info': response
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    this.checkAddress(address);
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'amount': parseFloat(amount),
                        'address': address
                    };
                    if (tag) request['paymentId'] = tag;
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeString(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['currency'] += network; // when network the currency need to be changed to currency + network
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privatePostAccountCryptoWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "id": "d2ce578f-647d-4fa0-b1aa-4a27e5ee597b"
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = '/api/' + this.version + '/';
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        url += api + '/' + this.implodeParams(path, params);
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        url += this.implodeParams(path, params);
                        if (method === 'GET') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else if (Object.keys(query).length) body = this.json(query);
                        const payload = this.encode(this.apiKey + ':' + this.secret);
                        const auth = this.stringToBase64(payload);
                        headers = {
                            'Authorization': 'Basic ' + this.decode(auth),
                            'Content-Type': 'application/json'
                        };
                    }
                    url = this.urls['api'][api] + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    if (code >= 400) {
                        const feedback = this.id + ' ' + body;
                        // {"code":504,"message":"Gateway Timeout","description":""}
                        if (code === 503 || code === 504) throw new ExchangeNotAvailable(feedback);
                        // fallback to default error handler on rate limit errors
                        // {"code":429,"message":"Too many requests","description":"Too many requests"}
                        if (code === 429) return;
                        // {"error":{"code":20002,"message":"Order not found","description":""}}
                        if (body[0] === '{') {
                            if ('error' in response) {
                                const errorCode = this.safeString(response['error'], 'code');
                                this.throwExactlyMatchedException(this.exceptions, errorCode, feedback);
                                const message = this.safeString(response['error'], 'message');
                                if (message === 'Duplicate clientOrderId') throw new InvalidOrder(feedback);
                            }
                        }
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    86: [
        function(require1, module, exports) {
            const Exchange = require1('./base/Exchange');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            const { BadSymbol: BadSymbol, BadRequest: BadRequest, OnMaintenance: OnMaintenance, AccountSuspended: AccountSuspended, PermissionDenied: PermissionDenied, ExchangeError: ExchangeError1, RateLimitExceeded: RateLimitExceeded, ExchangeNotAvailable: ExchangeNotAvailable, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, AuthenticationError: AuthenticationError, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            module.exports = class hitbtc3 extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'hitbtc3',
                        'name': 'HitBTC',
                        'countries': [
                            'HK'
                        ],
                        // 300 requests per second => 1000ms / 300 = 3.333 (Trading: placing, replacing, deleting)
                        // 30 requests per second => ( 1000ms / rateLimit ) / 30 = cost = 10 (Market Data and other Public Requests)
                        // 20 requests per second => ( 1000ms / rateLimit ) / 20 = cost = 15 (All Other)
                        'rateLimit': 3.333,
                        'version': '3',
                        'pro': true,
                        'has': {
                            'CORS': false,
                            'spot': true,
                            'margin': true,
                            'swap': true,
                            'future': false,
                            'option': undefined,
                            'addMargin': true,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': undefined,
                            'fetchBorrowRateHistories': undefined,
                            'fetchBorrowRateHistory': undefined,
                            'fetchBorrowRates': undefined,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': undefined,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': true,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': true,
                            'fetchLeverage': true,
                            'fetchLeverageTiers': undefined,
                            'fetchMarketLeverageTiers': undefined,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': true,
                            'fetchOrders': false,
                            'fetchOrderTrades': true,
                            'fetchPosition': true,
                            'fetchPositions': true,
                            'fetchPremiumIndexOHLCV': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': true,
                            'fetchTransactions': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': true,
                            'setLeverage': true,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': true,
                            'withdraw': true
                        },
                        'precisionMode': TICK_SIZE,
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766555-8eaec20e-5edc-11e7-9c5b-6dc69fc42f5e.jpg',
                            'test': {
                                'public': 'https://api.demo.hitbtc.com',
                                'private': 'https://api.demo.hitbtc.com'
                            },
                            'api': {
                                'public': 'https://api.hitbtc.com/api/3',
                                'private': 'https://api.hitbtc.com/api/3'
                            },
                            'www': 'https://hitbtc.com',
                            'referral': 'https://hitbtc.com/?ref_id=5a5d39a65d466',
                            'doc': [
                                'https://api.hitbtc.com',
                                'https://github.com/hitbtc-com/hitbtc-api/blob/master/APIv2.md'
                            ],
                            'fees': [
                                'https://hitbtc.com/fees-and-limits',
                                'https://support.hitbtc.com/hc/en-us/articles/115005148605-Fees-and-limits'
                            ]
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'public/currency': 10,
                                    'public/symbol': 10,
                                    'public/ticker': 10,
                                    'public/price/rate': 10,
                                    'public/trades': 10,
                                    'public/orderbook': 10,
                                    'public/candles': 10,
                                    'public/futures/info': 10,
                                    'public/futures/history/funding': 10,
                                    'public/futures/candles/index_price': 10,
                                    'public/futures/candles/mark_price': 10,
                                    'public/futures/candles/premium_index': 10,
                                    'public/futures/candles/open_interest': 10
                                }
                            },
                            'private': {
                                'get': {
                                    'spot/balance': 15,
                                    'spot/order': 15,
                                    'spot/order/{client_order_id}': 15,
                                    'spot/fee': 15,
                                    'spot/fee/{symbol}': 15,
                                    'spot/history/order': 15,
                                    'spot/history/trade': 15,
                                    'margin/account': 15,
                                    'margin/account/isolated/{symbol}': 15,
                                    'margin/order': 15,
                                    'margin/order/{client_order_id}': 15,
                                    'margin/history/clearing': 15,
                                    'margin/history/order': 15,
                                    'margin/history/positions': 15,
                                    'margin/history/trade': 15,
                                    'futures/balance': 15,
                                    'futures/account': 15,
                                    'futures/account/isolated/{symbol}': 15,
                                    'futures/order': 15,
                                    'futures/order/{client_order_id}': 15,
                                    'futures/fee': 15,
                                    'futures/fee/{symbol}': 15,
                                    'futures/history/clearing': 15,
                                    'futures/history/order': 15,
                                    'futures/history/positions': 15,
                                    'futures/history/trade': 15,
                                    'wallet/balance': 15,
                                    'wallet/crypto/address': 15,
                                    'wallet/crypto/address/recent-deposit': 15,
                                    'wallet/crypto/address/recent-withdraw': 15,
                                    'wallet/crypto/address/check-mine': 15,
                                    'wallet/transactions': 15,
                                    'wallet/crypto/check-offchain-available': 15,
                                    'wallet/crypto/fee/estimate': 15,
                                    'sub-account': 15,
                                    'sub-account/acl': 15,
                                    'sub-account/balance/{subAccID}': 15,
                                    'sub-account/crypto/address/{subAccID}/{currency}': 15
                                },
                                'post': {
                                    'spot/order': 1,
                                    'margin/order': 1,
                                    'futures/order': 1,
                                    'wallet/convert': 15,
                                    'wallet/crypto/withdraw': 15,
                                    'wallet/transfer': 15,
                                    'sub-account/freeze': 15,
                                    'sub-account/activate': 15,
                                    'sub-account/transfer': 15,
                                    'sub-account/acl': 15
                                },
                                'patch': {
                                    'spot/order/{client_order_id}': 1,
                                    'margin/order/{client_order_id}': 1,
                                    'futures/order/{client_order_id}': 1
                                },
                                'delete': {
                                    'spot/order': 1,
                                    'spot/order/{client_order_id}': 1,
                                    'margin/position': 1,
                                    'margin/position/isolated/{symbol}': 1,
                                    'margin/order': 1,
                                    'margin/order/{client_order_id}': 1,
                                    'futures/position': 1,
                                    'futures/position/isolated/{symbol}': 1,
                                    'futures/order': 1,
                                    'futures/order/{client_order_id}': 1,
                                    'wallet/crypto/withdraw/{id}': 1
                                },
                                'put': {
                                    'margin/account/isolated/{symbol}': 1,
                                    'futures/account/isolated/{symbol}': 1,
                                    'wallet/crypto/withdraw/{id}': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.0009'),
                                'maker': this.parseNumber('0.0009'),
                                'tiers': {
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.0009')
                                        ],
                                        [
                                            this.parseNumber('10'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('100'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('500'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('1000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('5000'),
                                            this.parseNumber('0.0002')
                                        ],
                                        [
                                            this.parseNumber('10000'),
                                            this.parseNumber('0.0001')
                                        ],
                                        [
                                            this.parseNumber('20000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('50000'),
                                            this.parseNumber('-0.0001')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('-0.0001')
                                        ]
                                    ],
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.0009')
                                        ],
                                        [
                                            this.parseNumber('10'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('100'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('500'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('1000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('5000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('10000'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('20000'),
                                            this.parseNumber('0.0004')
                                        ],
                                        [
                                            this.parseNumber('50000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('100000'),
                                            this.parseNumber('0.0002')
                                        ]
                                    ]
                                }
                            }
                        },
                        'timeframes': {
                            '1m': 'M1',
                            '3m': 'M3',
                            '5m': 'M5',
                            '15m': 'M15',
                            '30m': 'M30',
                            '1h': 'H1',
                            '4h': 'H4',
                            '1d': 'D1',
                            '1w': 'D7',
                            '1M': '1M'
                        },
                        'exceptions': {
                            'exact': {
                                '429': RateLimitExceeded,
                                '500': ExchangeError1,
                                '503': ExchangeNotAvailable,
                                '504': ExchangeNotAvailable,
                                '600': PermissionDenied,
                                '800': ExchangeError1,
                                '1002': AuthenticationError,
                                '1003': PermissionDenied,
                                '1004': AuthenticationError,
                                '1005': AuthenticationError,
                                '2001': BadSymbol,
                                '2002': BadRequest,
                                '2003': BadRequest,
                                '2010': BadRequest,
                                '2011': BadRequest,
                                '2012': BadRequest,
                                '2020': BadRequest,
                                '2022': BadRequest,
                                '10001': BadRequest,
                                '10021': AccountSuspended,
                                '10022': BadRequest,
                                '20001': InsufficientFunds,
                                '20002': OrderNotFound,
                                '20003': ExchangeError1,
                                '20004': ExchangeError1,
                                '20005': ExchangeError1,
                                '20006': ExchangeError1,
                                '20007': ExchangeError1,
                                '20008': InvalidOrder,
                                '20009': InvalidOrder,
                                '20010': OnMaintenance,
                                '20011': ExchangeError1,
                                '20012': ExchangeError1,
                                '20014': ExchangeError1,
                                '20016': ExchangeError1,
                                '20031': ExchangeError1,
                                '20032': ExchangeError1,
                                '20033': ExchangeError1,
                                '20034': ExchangeError1,
                                '20040': ExchangeError1,
                                '20041': ExchangeError1,
                                '20042': ExchangeError1,
                                '20043': ExchangeError1,
                                '20044': PermissionDenied,
                                '20045': InvalidOrder,
                                '20080': ExchangeError1,
                                '21001': ExchangeError1,
                                '21003': AccountSuspended,
                                '21004': AccountSuspended
                            },
                            'broad': {}
                        },
                        'options': {
                            'networks': {
                                'ETH': 'USDT20',
                                'ERC20': 'USDT20',
                                'TRX': 'USDTRX',
                                'TRC20': 'USDTRX',
                                'OMNI': 'USDT'
                            },
                            'accountsByType': {
                                'spot': 'spot',
                                'funding': 'wallet',
                                'future': 'derivatives'
                            }
                        },
                        'commonCurrencies': {
                            'AUTO': 'Cube',
                            'BCC': 'BCC',
                            'BDP': 'BidiPass',
                            'BET': 'DAO.Casino',
                            'BIT': 'BitRewards',
                            'BOX': 'BOX Token',
                            'CPT': 'Cryptaur',
                            'GET': 'Themis',
                            'GMT': 'GMT Token',
                            'HSR': 'HC',
                            'IQ': 'IQ.Cash',
                            'LNC': 'LinkerCoin',
                            'PLA': 'PlayChip',
                            'PNT': 'Penta',
                            'SBTC': 'Super Bitcoin',
                            'STEPN': 'GMT',
                            'STX': 'STOX',
                            'TV': 'Tokenville',
                            'USD': 'USDT',
                            'XMT': 'MTL',
                            'XPNT': 'PNT'
                        }
                    });
                }
                nonce() {
                    return this.milliseconds();
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetPublicSymbol(params);
                    //
                    //     {
                    //         "AAVEUSDT_PERP":{
                    //             "type":"futures",
                    //             "expiry":null,
                    //             "underlying":"AAVE",
                    //             "base_currency":null,
                    //             "quote_currency":"USDT",
                    //             "quantity_increment":"0.01",
                    //             "tick_size":"0.001",
                    //             "take_rate":"0.0005",
                    //             "make_rate":"0.0002",
                    //             "fee_currency":"USDT",
                    //             "margin_trading":true,
                    //             "max_initial_leverage":"50.00"
                    //         },
                    //         "MANAUSDT":{
                    //             "type":"spot",
                    //             "base_currency":"MANA",
                    //             "quote_currency":"USDT",
                    //             "quantity_increment":"1",
                    //             "tick_size":"0.0000001",
                    //             "take_rate":"0.0025",
                    //             "make_rate":"0.001",
                    //             "fee_currency":"USDT",
                    //             "margin_trading":true,
                    //             "max_initial_leverage":"5.00"
                    //         },
                    //     }
                    //
                    const result = [];
                    const ids = Object.keys(response);
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const market = this.safeValue(response, id);
                        const marketType = this.safeString(market, 'type');
                        const expiry = this.safeInteger(market, 'expiry');
                        const contract = marketType === 'futures';
                        const spot = marketType === 'spot';
                        const marginTrading = this.safeValue(market, 'margin_trading', false);
                        const margin = spot && marginTrading;
                        const future = expiry !== undefined;
                        const swap = contract && !future;
                        const option = false;
                        const baseId = this.safeString2(market, 'base_currency', 'underlying');
                        const quoteId = this.safeString(market, 'quote_currency');
                        const feeCurrencyId = this.safeString(market, 'fee_currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                        let settleId = undefined;
                        let settle = undefined;
                        let symbol = base + '/' + quote;
                        let type = 'spot';
                        let contractSize = undefined;
                        let linear = undefined;
                        let inverse = undefined;
                        if (contract) {
                            contractSize = this.parseNumber('1');
                            settleId = feeCurrencyId;
                            settle = this.safeCurrencyCode(settleId);
                            linear = quote !== undefined && quote === settle;
                            inverse = !linear;
                            symbol = symbol + ':' + settle;
                            if (future) {
                                symbol = symbol + '-' + expiry;
                                type = 'future';
                            } else type = 'swap';
                        }
                        const lotString = this.safeString(market, 'quantity_increment');
                        const stepString = this.safeString(market, 'tick_size');
                        const lot = this.parseNumber(lotString);
                        const step = this.parseNumber(stepString);
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': type,
                            'spot': spot,
                            'margin': margin,
                            'swap': swap,
                            'future': future,
                            'option': option,
                            'active': true,
                            'contract': contract,
                            'linear': linear,
                            'inverse': inverse,
                            'taker': this.safeNumber(market, 'take_rate'),
                            'maker': this.safeNumber(market, 'make_rate'),
                            'contractSize': contractSize,
                            'expiry': expiry,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'feeCurrency': feeCurrency,
                            'precision': {
                                'amount': lot,
                                'price': step
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': this.safeNumber(market, 'max_initial_leverage', 1)
                                },
                                'amount': {
                                    'min': lot,
                                    'max': undefined
                                },
                                'price': {
                                    'min': step,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.parseNumber(Precise.stringMul(lotString, stepString)),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetPublicCurrency(params);
                    //
                    //     {
                    //       "WEALTH": {
                    //         "full_name": "ConnectWealth",
                    //         "payin_enabled": false,
                    //         "payout_enabled": false,
                    //         "transfer_enabled": true,
                    //         "precision_transfer": "0.001",
                    //         "networks": [
                    //           {
                    //             "network": "ETH",
                    //             "protocol": "ERC20",
                    //             "default": true,
                    //             "payin_enabled": false,
                    //             "payout_enabled": false,
                    //             "precision_payout": "0.001",
                    //             "payout_fee": "0.016800000000",
                    //             "payout_is_payment_id": false,
                    //             "payin_payment_id": false,
                    //             "payin_confirmations": "2"
                    //           }
                    //         ]
                    //       }
                    //     }
                    //
                    const result = {};
                    const currencies = Object.keys(response);
                    for(let i = 0; i < currencies.length; i++){
                        const currencyId = currencies[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const entry = response[currencyId];
                        const name = this.safeString(entry, 'full_name');
                        const precision = this.safeNumber(entry, 'precision_transfer');
                        const payinEnabled = this.safeValue(entry, 'payin_enabled', false);
                        const payoutEnabled = this.safeValue(entry, 'payout_enabled', false);
                        const transferEnabled = this.safeValue(entry, 'transfer_enabled', false);
                        const active = payinEnabled && payoutEnabled && transferEnabled;
                        const rawNetworks = this.safeValue(entry, 'networks', []);
                        const networks = {};
                        let fee = undefined;
                        let depositEnabled = undefined;
                        let withdrawEnabled = undefined;
                        for(let j = 0; j < rawNetworks.length; j++){
                            const rawNetwork = rawNetworks[j];
                            let networkId = this.safeString(rawNetwork, 'protocol');
                            if (networkId.length === 0) networkId = this.safeString(rawNetwork, 'network');
                            const network = this.safeNetwork(networkId);
                            fee = this.safeNumber(rawNetwork, 'payout_fee');
                            const precision = this.safeNumber(rawNetwork, 'precision_payout');
                            const payinEnabledNetwork = this.safeValue(entry, 'payin_enabled', false);
                            const payoutEnabledNetwork = this.safeValue(entry, 'payout_enabled', false);
                            const activeNetwork = payinEnabledNetwork && payoutEnabledNetwork;
                            if (payinEnabledNetwork && !depositEnabled) depositEnabled = true;
                            else if (!payinEnabledNetwork) depositEnabled = false;
                            if (payoutEnabledNetwork && !withdrawEnabled) withdrawEnabled = true;
                            else if (!payoutEnabledNetwork) withdrawEnabled = false;
                            networks[network] = {
                                'info': rawNetwork,
                                'id': networkId,
                                'network': network,
                                'fee': fee,
                                'active': activeNetwork,
                                'deposit': payinEnabledNetwork,
                                'withdraw': payoutEnabledNetwork,
                                'precision': precision,
                                'limits': {
                                    'withdraw': {
                                        'min': undefined,
                                        'max': undefined
                                    }
                                }
                            };
                        }
                        const networksKeys = Object.keys(networks);
                        const networksLength = networksKeys.length;
                        result[code] = {
                            'info': entry,
                            'code': code,
                            'id': currencyId,
                            'precision': precision,
                            'name': name,
                            'active': active,
                            'deposit': depositEnabled,
                            'withdraw': withdrawEnabled,
                            'networks': networks,
                            'fee': networksLength <= 1 ? fee : undefined,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                safeNetwork(networkId) {
                    if (networkId === undefined) return undefined;
                    else return networkId.toUpperCase();
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const network = this.safeStringUpper(params, 'network');
                    if (network !== undefined && code === 'USDT') {
                        const networks = this.safeValue(this.options, 'networks');
                        const parsedNetwork = this.safeString(networks, network);
                        if (parsedNetwork !== undefined) request['currency'] = parsedNetwork;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privateGetWalletCryptoAddress(this.extend(request, params));
                    //
                    //  [{"currency":"ETH","address":"0xd0d9aea60c41988c3e68417e2616065617b7afd3"}]
                    //
                    const firstAddress = this.safeValue(response, 0);
                    const address = this.safeString(firstAddress, 'address');
                    const currencyId = this.safeString(firstAddress, 'currency');
                    const tag = this.safeString(firstAddress, 'payment_id');
                    const parsedCode = this.safeCurrencyCode(currencyId);
                    return {
                        'info': response,
                        'address': address,
                        'tag': tag,
                        'code': parsedCode,
                        'network': undefined
                    };
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const currencyId = this.safeString(entry, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(entry, 'available');
                        account['used'] = this.safeString(entry, 'reserved');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    const type = this.safeStringLower(params, 'type', 'spot');
                    params = this.omit(params, [
                        'type'
                    ]);
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const account = this.safeString(accountsByType, type, type);
                    let response = undefined;
                    if (account === 'wallet') response = await this.privateGetWalletBalance(params);
                    else if (account === 'spot') response = await this.privateGetSpotBalance(params);
                    else if (account === 'derivatives') response = await this.privateGetFuturesBalance(params);
                    else {
                        const keys = Object.keys(accountsByType);
                        throw new BadRequest(this.id + ' fetchBalance() type parameter must be one of ' + keys.join(', '));
                    }
                    //
                    //     [
                    //       {
                    //         "currency": "PAXG",
                    //         "available": "0",
                    //         "reserved": "0",
                    //         "reserved_margin": "0",
                    //       },
                    //       ...
                    //     ]
                    //
                    return this.parseBalance(response);
                }
                async fetchTicker(symbol, params = {}) {
                    const response = await this.fetchTickers([
                        symbol
                    ], params);
                    return this.safeValue(response, symbol);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbols !== undefined) {
                        const marketIds = this.marketIds(symbols);
                        const delimited = marketIds.join(',');
                        request['symbols'] = delimited;
                    }
                    const response = await this.publicGetPublicTicker(this.extend(request, params));
                    //
                    //     {
                    //       "BTCUSDT": {
                    //         "ask": "63049.06",
                    //         "bid": "63046.41",
                    //         "last": "63048.36",
                    //         "low": "62010.00",
                    //         "high": "66657.99",
                    //         "open": "64839.75",
                    //         "volume": "15272.13278",
                    //         "volume_quote": "976312127.6277998",
                    //         "timestamp": "2021-10-22T04:25:47.573Z"
                    //       }
                    //     }
                    //
                    const result = {};
                    const keys = Object.keys(response);
                    for(let i = 0; i < keys.length; i++){
                        const marketId = keys[i];
                        const market = this.safeMarket(marketId);
                        const symbol = market['symbol'];
                        const entry = response[marketId];
                        result[symbol] = this.parseTicker(entry, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //       "ask": "62756.01",
                    //       "bid": "62754.09",
                    //       "last": "62755.87",
                    //       "low": "62010.00",
                    //       "high": "66657.99",
                    //       "open": "65089.27",
                    //       "volume": "16719.50366",
                    //       "volume_quote": "1063422878.8156828",
                    //       "timestamp": "2021-10-22T07:29:14.585Z"
                    //     }
                    //
                    const timestamp = this.parse8601(ticker['timestamp']);
                    const symbol = this.safeSymbol(undefined, market);
                    const baseVolume = this.safeString(ticker, 'volume');
                    const quoteVolume = this.safeString(ticker, 'volume_quote');
                    const open = this.safeString(ticker, 'open');
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        // symbol is optional for hitbtc fetchTrades
                        request['symbols'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['from'] = since;
                    const response = await this.publicGetPublicTrades(this.extend(request, params));
                    const marketIds = Object.keys(response);
                    let trades = [];
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const market = this.market(marketId);
                        const rawTrades = response[marketId];
                        const parsed = this.parseTrades(rawTrades, market);
                        trades = this.arrayConcat(trades, parsed);
                    }
                    return trades;
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['from'] = since;
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchMyTrades', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateGetSpotHistoryTrade',
                        'swap': 'privateGetFuturesHistoryTrade',
                        'margin': 'privateGetMarginHistoryTrade'
                    });
                    const response = await this[method](this.extend(request, query));
                    return this.parseTrades(response, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // createOrder (market)
                    //
                    //  {
                    //      id: '1569252895',
                    //      position_id: '0',
                    //      quantity: '10',
                    //      price: '0.03919424',
                    //      fee: '0.000979856000',
                    //      timestamp: '2022-01-25T19:38:36.153Z',
                    //      taker: true
                    //  }
                    //
                    // fetchTrades
                    //
                    //  {
                    //      id: 974786185,
                    //      price: '0.032462',
                    //      qty: '0.3673',
                    //      side: 'buy',
                    //      timestamp: '2020-10-16T12:57:39.846Z'
                    //  }
                    //
                    // fetchMyTrades spot
                    //
                    //  {
                    //      id: 277210397,
                    //      clientOrderId: '6e102f3e7f3f4e04aeeb1cdc95592f1a',
                    //      orderId: 28102855393,
                    //      symbol: 'ETHBTC',
                    //      side: 'sell',
                    //      quantity: '0.002',
                    //      price: '0.073365',
                    //      fee: '0.000000147',
                    //      timestamp: '2018-04-28T18:39:55.345Z',
                    //      taker: true
                    //  }
                    //
                    // fetchMyTrades swap and margin
                    //
                    //  {
                    //      "id": 4718564,
                    //      "order_id": 58730811958,
                    //      "client_order_id": "475c47d97f867f09726186eb22b4c3d4",
                    //      "symbol": "BTCUSDT_PERP",
                    //      "side": "sell",
                    //      "quantity": "0.0001",
                    //      "price": "41118.51",
                    //      "fee": "0.002055925500",
                    //      "timestamp": "2022-03-17T05:23:17.795Z",
                    //      "taker": true,
                    //      "position_id": 2350122,
                    //      "pnl": "0.002255000000",
                    //      "liquidation": false
                    //  }
                    //
                    const timestamp = this.parse8601(trade['timestamp']);
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    const taker = this.safeValue(trade, 'taker');
                    let takerOrMaker = undefined;
                    if (taker !== undefined) takerOrMaker = taker ? 'taker' : 'maker';
                    if (feeCostString !== undefined) {
                        const info = this.safeValue(market, 'info', {});
                        const feeCurrency = this.safeString(info, 'fee_currency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrency);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    // we use clientOrderId as the order id with this exchange intentionally
                    // because most of their endpoints will require clientOrderId
                    // explained here: https://github.com/ccxt/ccxt/issues/5674
                    const orderId = this.safeString(trade, 'clientOrderId');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString2(trade, 'quantity', 'qty');
                    const side = this.safeString(trade, 'side');
                    const id = this.safeString(trade, 'id');
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTransactionsHelper(types, code, since, limit, params) {
                    await this.loadMarkets();
                    const request = {
                        'types': types
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currencies'] = currency['id'];
                    }
                    if (since !== undefined) request['from'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetWalletTransactions(this.extend(request, params));
                    //
                    //     [
                    //       {
                    //         "id": "101609495",
                    //         "created_at": "2018-03-06T22:05:06.507Z",
                    //         "updated_at": "2018-03-06T22:11:45.03Z",
                    //         "status": "SUCCESS",
                    //         "type": "DEPOSIT",
                    //         "subtype": "BLOCKCHAIN",
                    //         "native": {
                    //           "tx_id": "e20b0965-4024-44d0-b63f-7fb8996a6706",
                    //           "index": "881652766",
                    //           "currency": "ETH",
                    //           "amount": "0.01418088",
                    //           "hash": "d95dbbff3f9234114f1211ab0ba2a94f03f394866fd5749d74a1edab80e6c5d3",
                    //           "address": "0xd9259302c32c0a0295d86a39185c9e14f6ba0a0d",
                    //           "confirmations": "20",
                    //           "senders": [
                    //             "0x243bec9256c9a3469da22103891465b47583d9f1"
                    //           ]
                    //         }
                    //       }
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit, params);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'PENDING': 'pending',
                        'FAILED': 'failed',
                        'SUCCESS': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransactionType(type) {
                    const types = {
                        'DEPOSIT': 'deposit',
                        'WITHDRAW': 'withdrawal'
                    };
                    return this.safeString(types, type, type);
                }
                parseTransaction(transaction, currency) {
                    //
                    // transaction
                    //
                    //     {
                    //       "id": "101609495",
                    //       "created_at": "2018-03-06T22:05:06.507Z",
                    //       "updated_at": "2018-03-06T22:11:45.03Z",
                    //       "status": "SUCCESS",
                    //       "type": "DEPOSIT", // DEPOSIT, WITHDRAW, ..
                    //       "subtype": "BLOCKCHAIN",
                    //       "native": {
                    //         "tx_id": "e20b0965-4024-44d0-b63f-7fb8996a6706",
                    //         "index": "881652766",
                    //         "currency": "ETH",
                    //         "amount": "0.01418088",
                    //         "hash": "d95dbbff3f9234114f1211ab0ba2a94f03f394866fd5749d74a1edab80e6c5d3",
                    //         "address": "0xd9259302c32c0a0295d86a39185c9e14f6ba0a0d",
                    //         "confirmations": "20",
                    //         "senders": [
                    //           "0x243bec9256c9a3469da22103891465b47583d9f1"
                    //         ],
                    //         "fee": "1.22" // only for WITHDRAW
                    //       }
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "id":"084cfcd5-06b9-4826-882e-fdb75ec3625d"
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const timestamp = this.parse8601(this.safeString(transaction, 'created_at'));
                    const updated = this.parse8601(this.safeString(transaction, 'updated_at'));
                    const type = this.parseTransactionType(this.safeString(transaction, 'type'));
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const native = this.safeValue(transaction, 'native', {});
                    const currencyId = this.safeString(native, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    const txhash = this.safeString(native, 'hash');
                    const address = this.safeString(native, 'address');
                    const addressTo = address;
                    const tag = this.safeString(native, 'payment_id');
                    const tagTo = tag;
                    const sender = this.safeValue(native, 'senders');
                    const addressFrom = this.safeString(sender, 0);
                    const amount = this.safeNumber(native, 'amount');
                    let fee = undefined;
                    const feeCost = this.safeNumber(native, 'fee');
                    if (feeCost !== undefined) fee = {
                        'code': code,
                        'cost': feeCost
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txhash,
                        'code': code,
                        'amount': amount,
                        'network': undefined,
                        'address': address,
                        'addressFrom': addressFrom,
                        'addressTo': addressTo,
                        'tag': tag,
                        'tagFrom': undefined,
                        'tagTo': tagTo,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'updated': updated,
                        'status': status,
                        'type': type,
                        'fee': fee
                    };
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    return await this.fetchTransactionsHelper('DEPOSIT,WITHDRAW', code, since, limit, params);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    return await this.fetchTransactionsHelper('DEPOSIT', code, since, limit, params);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    return await this.fetchTransactionsHelper('WITHDRAW', code, since, limit, params);
                }
                async fetchOrderBooks(symbols, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbols !== undefined) {
                        const marketIds = this.marketIds(symbols);
                        request['symbols'] = marketIds.join(',');
                    }
                    if (limit !== undefined) request['depth'] = limit;
                    const response = await this.publicGetPublicOrderbook(this.extend(request, params));
                    const result = {};
                    const marketIds = Object.keys(response);
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const orderbook = response[marketId];
                        const symbol = this.safeSymbol(marketId);
                        const timestamp = this.parse8601(this.safeString(orderbook, 'timestamp'));
                        result[symbol] = this.parseOrderBook(response[marketId], symbol, timestamp, 'bid', 'ask');
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    const result = await this.fetchOrderBooks([
                        symbol
                    ], limit, params);
                    return result[symbol];
                }
                parseTradingFee(fee, market) {
                    //
                    //     {
                    //         "symbol":"ARVUSDT", // returned from fetchTradingFees only
                    //         "take_rate":"0.0009",
                    //         "make_rate":"0.0009"
                    //     }
                    //
                    const taker = this.safeNumber(fee, 'take_rate');
                    const maker = this.safeNumber(fee, 'make_rate');
                    const marketId = this.safeString(fee, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    return {
                        'info': fee,
                        'symbol': symbol,
                        'taker': taker,
                        'maker': maker
                    };
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const method = this.getSupportedMapping(market['type'], {
                        'spot': 'privateGetSpotFeeSymbol',
                        'swap': 'privateGetFuturesFeeSymbol'
                    });
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "take_rate":"0.0009",
                    //         "make_rate":"0.0009"
                    //     }
                    //
                    return this.parseTradingFee(response, market);
                }
                async fetchTradingFees(symbols, params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTradingFees', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateGetSpotFee',
                        'swap': 'privateGetFuturesFee'
                    });
                    const response = await this[method](query);
                    //
                    //     [
                    //         {
                    //             "symbol":"ARVUSDT",
                    //             "take_rate":"0.0009",
                    //             "make_rate":"0.0009"
                    //         }
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const fee = this.parseTradingFee(response[i]);
                        const symbol = fee['symbol'];
                        result[symbol] = fee;
                    }
                    return result;
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbols': market['id'],
                        'period': this.timeframes[timeframe]
                    };
                    if (since !== undefined) request['from'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const price = this.safeString(params, 'price');
                    params = this.omit(params, 'price');
                    let method = 'publicGetPublicCandles';
                    if (price === 'mark') method = 'publicGetPublicFuturesCandlesMarkPrice';
                    else if (price === 'index') method = 'publicGetPublicFuturesCandlesIndexPrice';
                    else if (price === 'premiumIndex') method = 'publicGetPublicFuturesCandlesPremiumIndex';
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot and Swap
                    //
                    //     {
                    //         "ETHUSDT": [
                    //             {
                    //                 "timestamp": "2021-10-25T07:38:00.000Z",
                    //                 "open": "4173.391",
                    //                 "close": "4170.923",
                    //                 "min": "4170.923",
                    //                 "max": "4173.986",
                    //                 "volume": "0.1879",
                    //                 "volume_quote": "784.2517846"
                    //             }
                    //         ]
                    //     }
                    //
                    // Mark, Index and Premium Index
                    //
                    //     {
                    //         "BTCUSDT_PERP": [
                    //             {
                    //                 "timestamp": "2022-04-01T01:28:00.000Z",
                    //                 "open": "45146.39",
                    //                 "close": "45219.43",
                    //                 "min": "45146.39",
                    //                 "max": "45219.43"
                    //             },
                    //         ]
                    //     }
                    //
                    const ohlcvs = this.safeValue(response, market['id']);
                    return this.parseOHLCVs(ohlcvs, market, timeframe, since, limit);
                }
                async fetchMarkOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'mark'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'index'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchPremiumIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'premiumIndex'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                parseOHLCV(ohlcv, market) {
                    //
                    // Spot and Swap
                    //
                    //     {
                    //         "timestamp":"2015-08-20T19:01:00.000Z",
                    //         "open":"0.006",
                    //         "close":"0.006",
                    //         "min":"0.006",
                    //         "max":"0.006",
                    //         "volume":"0.003",
                    //         "volume_quote":"0.000018"
                    //     }
                    //
                    // Mark, Index and Premium Index
                    //
                    //     {
                    //         "timestamp": "2022-04-01T01:28:00.000Z",
                    //         "open": "45146.39",
                    //         "close": "45219.43",
                    //         "min": "45146.39",
                    //         "max": "45219.43"
                    //     },
                    //
                    return [
                        this.parse8601(this.safeString(ohlcv, 'timestamp')),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'max'),
                        this.safeNumber(ohlcv, 'min'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['from'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchClosedOrders', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateGetSpotHistoryOrder',
                        'swap': 'privateGetFuturesHistoryOrder',
                        'margin': 'privateGetMarginHistoryOrder'
                    });
                    const response = await this[method](this.extend(request, query));
                    const parsed = this.parseOrders(response, market, since, limit);
                    return this.filterByArray(parsed, 'status', [
                        'closed',
                        'canceled'
                    ], false);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateGetSpotHistoryOrder',
                        'swap': 'privateGetFuturesHistoryOrder',
                        'margin': 'privateGetMarginHistoryOrder'
                    });
                    const request = {
                        'client_order_id': id
                    };
                    const response = await this[method](this.extend(request, query));
                    //
                    //     [
                    //       {
                    //         "id": "685965182082",
                    //         "client_order_id": "B3CBm9uGg9oYQlw96bBSEt38-6gbgBO0",
                    //         "symbol": "BTCUSDT",
                    //         "side": "buy",
                    //         "status": "new",
                    //         "type": "limit",
                    //         "time_in_force": "GTC",
                    //         "quantity": "0.00010",
                    //         "quantity_cumulative": "0",
                    //         "price": "50000.00",
                    //         "price_average": "0",
                    //         "created_at": "2021-10-26T11:40:09.287Z",
                    //         "updated_at": "2021-10-26T11:40:09.287Z"
                    //       }
                    //     ]
                    //
                    const order = this.safeValue(response, 0);
                    return this.parseOrder(order, market);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'order_id': id
                    };
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrderTrades', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateGetSpotHistoryTrade',
                        'swap': 'privateGetFuturesHistoryTrade',
                        'margin': 'privateGetMarginHistoryTrade'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     [
                    //       {
                    //         "id": 1393448977,
                    //         "order_id": 653496804534,
                    //         "client_order_id": "065f6f0ff9d54547848454182263d7b4",
                    //         "symbol": "DICEETH",
                    //         "side": "buy",
                    //         "quantity": "1.4",
                    //         "price": "0.00261455",
                    //         "fee": "0.000003294333",
                    //         "timestamp": "2021-09-19T05:35:56.601Z",
                    //         "taker": true
                    //       }
                    //     ]
                    //
                    // Swap and Margin
                    //
                    //     [
                    //         {
                    //             "id": 4718551,
                    //             "order_id": 58730748700,
                    //             "client_order_id": "dcbcd8549e3445ee922665946002ef67",
                    //             "symbol": "BTCUSDT_PERP",
                    //             "side": "buy",
                    //             "quantity": "0.0001",
                    //             "price": "41095.96",
                    //             "fee": "0.002054798000",
                    //             "timestamp": "2022-03-17T05:23:02.217Z",
                    //             "taker": true,
                    //             "position_id": 2350122,
                    //             "pnl": "0",
                    //             "liquidation": false
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOpenOrders', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateGetSpotOrder',
                        'swap': 'privateGetFuturesOrder',
                        'margin': 'privateGetMarginOrder'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    //     [
                    //       {
                    //         "id": "488953123149",
                    //         "client_order_id": "103ad305301e4c3590045b13de15b36e",
                    //         "symbol": "BTCUSDT",
                    //         "side": "buy",
                    //         "status": "new",
                    //         "type": "limit",
                    //         "time_in_force": "GTC",
                    //         "quantity": "0.00001",
                    //         "quantity_cumulative": "0",
                    //         "price": "0.01",
                    //         "post_only": false,
                    //         "created_at": "2021-04-13T13:06:16.567Z",
                    //         "updated_at": "2021-04-13T13:06:16.567Z"
                    //       }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOpenOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOpenOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateGetSpotOrderClientOrderId',
                        'swap': 'privateGetFuturesOrderClientOrderId',
                        'margin': 'privateGetMarginOrderClientOrderId'
                    });
                    const request = {
                        'client_order_id': id
                    };
                    const response = await this[method](this.extend(request, query));
                    return this.parseOrder(response, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const [marketType, query] = this.handleMarketTypeAndParams('cancelAllOrders', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateDeleteSpotOrder',
                        'swap': 'privateDeleteFuturesOrder',
                        'margin': 'privateDeleteMarginOrder'
                    });
                    const response = await this[method](this.extend(request, query));
                    return this.parseOrders(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        'client_order_id': id
                    };
                    if (symbol !== undefined) market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('cancelOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privateDeleteSpotOrderClientOrderId',
                        'swap': 'privateDeleteFuturesOrderClientOrderId',
                        'margin': 'privateDeleteMarginOrderClientOrderId'
                    });
                    const response = await this[method](this.extend(request, query));
                    return this.parseOrder(response, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        'client_order_id': id,
                        'quantity': this.amountToPrecision(symbol, amount)
                    };
                    if (type === 'limit' || type === 'stopLimit') {
                        if (price === undefined) throw new ExchangeError1(this.id + ' editOrder() limit order requires price');
                        request['price'] = this.priceToPrecision(symbol, price);
                    }
                    if (symbol !== undefined) market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('editOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privatePatchSpotOrderClientOrderId',
                        'swap': 'privatePatchFuturesOrderClientOrderId',
                        'margin': 'privatePatchMarginOrderClientOrderId'
                    });
                    const response = await this[method](this.extend(request, query));
                    return this.parseOrder(response, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const reduceOnly = this.safeValue2(params, 'reduce_only', 'reduceOnly');
                    if (reduceOnly !== undefined) {
                        if (market['type'] !== 'swap' && market['type'] !== 'margin') throw new InvalidOrder(this.id + ' createOrder() does not support reduce_only for ' + market['type'] + ' orders, reduce_only orders are supported for swap and margin markets only');
                    }
                    const request = {
                        'type': type,
                        'side': side,
                        'quantity': this.amountToPrecision(symbol, amount),
                        'symbol': market['id']
                    };
                    const timeInForce = this.safeString2(params, 'timeInForce', 'time_in_force');
                    const expireTime = this.safeString(params, 'expire_time');
                    const stopPrice = this.safeNumber2(params, 'stopPrice', 'stop_price');
                    if (type === 'limit' || type === 'stopLimit' || type === 'takeProfitLimit') {
                        if (price === undefined) throw new ExchangeError1(this.id + ' createOrder() requires a price argument for limit orders');
                        request['price'] = this.priceToPrecision(symbol, price);
                    }
                    if (timeInForce === 'GTD') {
                        if (expireTime === undefined) throw new ExchangeError1(this.id + ' createOrder() requires an expire_time parameter for a GTD order');
                        request['expire_time'] = expireTime;
                    }
                    if (type === 'stopLimit' || type === 'stopMarket' || type === 'takeProfitLimit' || type === 'takeProfitMarket') {
                        if (stopPrice === undefined) throw new ExchangeError1(this.id + ' createOrder() requires a stopPrice parameter for stop-loss and take-profit orders');
                        request['stop_price'] = this.priceToPrecision(symbol, stopPrice);
                    }
                    const [marketType, query] = this.handleMarketTypeAndParams('createOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'privatePostSpotOrder',
                        'swap': 'privatePostFuturesOrder',
                        'margin': 'privatePostMarginOrder'
                    });
                    const response = await this[method](this.extend(request, query));
                    return this.parseOrder(response, market);
                }
                async createReduceOnlyOrder(symbol, type, side, amount, price, params = {}) {
                    const request = {
                        'reduce_only': true
                    };
                    return await this.createOrder(symbol, type, side, amount, price, this.extend(request, params));
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'new': 'open',
                        'suspended': 'open',
                        'partiallyFilled': 'open',
                        'filled': 'closed',
                        'canceled': 'canceled',
                        'expired': 'failed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // limit
                    //     {
                    //       "id": 488953123149,
                    //       "client_order_id": "103ad305301e4c3590045b13de15b36e",
                    //       "symbol": "BTCUSDT",
                    //       "side": "buy",
                    //       "status": "new",
                    //       "type": "limit",
                    //       "time_in_force": "GTC",
                    //       "quantity": "0.00001",
                    //       "quantity_cumulative": "0",
                    //       "price": "0.01",
                    //       "price_average": "0.01",
                    //       "post_only": false,
                    //       "created_at": "2021-04-13T13:06:16.567Z",
                    //       "updated_at": "2021-04-13T13:06:16.567Z"
                    //     }
                    //
                    // market
                    //     {
                    //       "id": "685877626834",
                    //       "client_order_id": "Yshl7G-EjaREyXQYaGbsmdtVbW-nzQwu",
                    //       "symbol": "BTCUSDT",
                    //       "side": "buy",
                    //       "status": "filled",
                    //       "type": "market",
                    //       "time_in_force": "GTC",
                    //       "quantity": "0.00010",
                    //       "quantity_cumulative": "0.00010",
                    //       "post_only": false,
                    //       "created_at": "2021-10-26T08:55:55.1Z",
                    //       "updated_at": "2021-10-26T08:55:55.1Z",
                    //       "trades": [
                    //         {
                    //           "id": "1437229630",
                    //           "position_id": "0",
                    //           "quantity": "0.00010",
                    //           "price": "62884.78",
                    //           "fee": "0.005659630200",
                    //           "timestamp": "2021-10-26T08:55:55.1Z",
                    //           "taker": true
                    //         }
                    //       ]
                    //     }
                    //
                    // swap and margin
                    //
                    //     {
                    //         "id": 58418961892,
                    //         "client_order_id": "r42gdPjNMZN-H_xs8RKl2wljg_dfgdg4",
                    //         "symbol": "BTCUSDT_PERP",
                    //         "side": "buy",
                    //         "status": "new",
                    //         "type": "limit",
                    //         "time_in_force": "GTC",
                    //         "quantity": "0.0005",
                    //         "quantity_cumulative": "0",
                    //         "price": "30000.00",
                    //         "post_only": false,
                    //         "reduce_only": false,
                    //         "created_at": "2022-03-16T08:16:53.039Z",
                    //         "updated_at": "2022-03-16T08:16:53.039Z"
                    //     }
                    //
                    const id = this.safeString(order, 'client_order_id');
                    // we use clientOrderId as the order id with this exchange intentionally
                    // because most of their endpoints will require clientOrderId
                    // explained here: https://github.com/ccxt/ccxt/issues/5674
                    const side = this.safeString(order, 'side');
                    const type = this.safeString(order, 'type');
                    const amount = this.safeString(order, 'quantity');
                    const price = this.safeString(order, 'price');
                    const average = this.safeString(order, 'price_average');
                    const created = this.safeString(order, 'created_at');
                    const timestamp = this.parse8601(created);
                    const updated = this.safeString(order, 'updated_at');
                    let lastTradeTimestamp = undefined;
                    if (updated !== created) lastTradeTimestamp = this.parse8601(updated);
                    const filled = this.safeString(order, 'quantity_cumulative');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const marketId = this.safeString(order, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const postOnly = this.safeValue(order, 'post_only');
                    const timeInForce = this.safeString(order, 'time_in_force');
                    const rawTrades = this.safeValue(order, 'trades');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'price': price,
                        'amount': amount,
                        'type': type,
                        'side': side,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'filled': filled,
                        'remaining': undefined,
                        'cost': undefined,
                        'status': status,
                        'average': average,
                        'trades': rawTrades,
                        'fee': undefined
                    }, market);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    // account can be "spot", "wallet", or "derivatives"
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const requestAmount = this.currencyToPrecision(code, amount);
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    fromAccount = fromAccount.toLowerCase();
                    toAccount = toAccount.toLowerCase();
                    const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                    const toId = this.safeString(accountsByType, toAccount, toAccount);
                    if (fromId === toId) throw new BadRequest(this.id + ' transfer() fromAccount and toAccount arguments cannot be the same account');
                    const request = {
                        'currency': currency['id'],
                        'amount': requestAmount,
                        'source': fromId,
                        'destination': toId
                    };
                    const response = await this.privatePostWalletTransfer(this.extend(request, params));
                    //
                    //     [
                    //         '2db6ebab-fb26-4537-9ef8-1a689472d236'
                    //     ]
                    //
                    const transfer = this.parseTransfer(response, currency);
                    return this.extend(transfer, {
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'amount': this.parseNumber(requestAmount)
                    });
                }
                parseTransfer(transfer, currency) {
                    //
                    // transfer
                    //
                    //     [
                    //         '2db6ebab-fb26-4537-9ef8-1a689472d236'
                    //     ]
                    //
                    const timestamp = this.milliseconds();
                    return {
                        'id': this.safeString(transfer, 0),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': this.safeCurrencyCode(undefined, currency),
                        'amount': undefined,
                        'fromAccount': undefined,
                        'toAccount': undefined,
                        'status': undefined,
                        'info': transfer
                    };
                }
                async convertCurrencyNetwork(code, amount, fromNetwork, toNetwork, params) {
                    await this.loadMarkets();
                    if (code !== 'USDT') throw new ExchangeError1(this.id + ' convertCurrencyNetwork() only supports USDT currently');
                    const networks = this.safeValue(this.options, 'networks', {});
                    fromNetwork = fromNetwork.toUpperCase();
                    toNetwork = toNetwork.toUpperCase();
                    fromNetwork = this.safeString(networks, fromNetwork); // handle ETH>ERC20 alias
                    toNetwork = this.safeString(networks, toNetwork); // handle ETH>ERC20 alias
                    if (fromNetwork === toNetwork) throw new BadRequest(this.id + ' convertCurrencyNetwork() fromNetwork cannot be the same as toNetwork');
                    if (fromNetwork === undefined || toNetwork === undefined) {
                        const keys = Object.keys(networks);
                        throw new ArgumentsRequired1(this.id + ' convertCurrencyNetwork() requires a fromNetwork parameter and a toNetwork parameter, supported networks are ' + keys.join(', '));
                    }
                    const request = {
                        'from_currency': fromNetwork,
                        'to_currency': toNetwork,
                        'amount': this.currencyToPrecision(code, amount)
                    };
                    const response = await this.privatePostWalletConvert(this.extend(request, params));
                    // {"result":["587a1868-e62d-4d8e-b27c-dbdb2ee96149","e168df74-c041-41f2-b76c-e43e4fed5bc7"]}
                    return {
                        'info': response
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    this.checkAddress(address);
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'amount': amount,
                        'address': address
                    };
                    if (tag !== undefined) request['payment_id'] = tag;
                    const networks = this.safeValue(this.options, 'networks', {});
                    const network = this.safeStringUpper(params, 'network');
                    if (network !== undefined && code === 'USDT') {
                        const parsedNetwork = this.safeString(networks, network);
                        if (parsedNetwork !== undefined) request['currency'] = parsedNetwork;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privatePostWalletCryptoWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "id":"084cfcd5-06b9-4826-882e-fdb75ec3625d"
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                async fetchFundingRateHistory(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        symbol = market['symbol'];
                        request['symbols'] = market['id'];
                    }
                    if (since !== undefined) request['from'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetPublicFuturesHistoryFunding(this.extend(request, params));
                    //
                    //    {
                    //        "BTCUSDT_PERP": [
                    //            {
                    //                "timestamp": "2021-07-29T16:00:00.271Z",
                    //                "funding_rate": "0.0001",
                    //                "avg_premium_index": "0.000061858585213222",
                    //                "next_funding_time": "2021-07-30T00:00:00.000Z",
                    //                "interest_rate": "0.0001"
                    //            },
                    //            ...
                    //        ],
                    //        ...
                    //    }
                    //
                    const contracts = Object.keys(response);
                    const rates = [];
                    for(let i = 0; i < contracts.length; i++){
                        const marketId = contracts[i];
                        const market = this.safeMarket(marketId);
                        const fundingRateData = response[marketId];
                        for(let i = 0; i < fundingRateData.length; i++){
                            const entry = fundingRateData[i];
                            const symbol = this.safeSymbol(market['symbol']);
                            const fundingRate = this.safeNumber(entry, 'funding_rate');
                            const datetime = this.safeString(entry, 'timestamp');
                            rates.push({
                                'info': entry,
                                'symbol': symbol,
                                'fundingRate': fundingRate,
                                'timestamp': this.parse8601(datetime),
                                'datetime': datetime
                            });
                        }
                    }
                    const sorted = this.sortBy(rates, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, symbol, since, limit);
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchPositions', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'swap': 'privateGetFuturesAccount',
                        'margin': 'privateGetMarginAccount'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    //     [
                    //         {
                    //             "symbol": "ETHUSDT_PERP",
                    //             "type": "isolated",
                    //             "leverage": "10.00",
                    //             "created_at": "2022-03-19T07:54:35.24Z",
                    //             "updated_at": "2022-03-19T07:54:58.922Z",
                    //             currencies": [
                    //                 {
                    //                     "code": "USDT",
                    //                     "margin_balance": "7.478100643043",
                    //                     "reserved_orders": "0",
                    //                     "reserved_positions": "0.303530761300"
                    //                 }
                    //             ],
                    //             "positions": [
                    //                 {
                    //                     "id": 2470568,
                    //                     "symbol": "ETHUSDT_PERP",
                    //                     "quantity": "0.001",
                    //                     "price_entry": "2927.509",
                    //                     "price_margin_call": "0",
                    //                     "price_liquidation": "0",
                    //                     "pnl": "0",
                    //                     "created_at": "2022-03-19T07:54:35.24Z",
                    //                     "updated_at": "2022-03-19T07:54:58.922Z"
                    //                 }
                    //             ]
                    //         },
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++)result.push(this.parsePosition(response[i]));
                    return result;
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchPosition', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'swap': 'privateGetFuturesAccountIsolatedSymbol',
                        'margin': 'privateGetMarginAccountIsolatedSymbol'
                    });
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this[method](this.extend(request, query));
                    //
                    //     [
                    //         {
                    //             "symbol": "ETHUSDT_PERP",
                    //             "type": "isolated",
                    //             "leverage": "10.00",
                    //             "created_at": "2022-03-19T07:54:35.24Z",
                    //             "updated_at": "2022-03-19T07:54:58.922Z",
                    //             currencies": [
                    //                 {
                    //                     "code": "USDT",
                    //                     "margin_balance": "7.478100643043",
                    //                     "reserved_orders": "0",
                    //                     "reserved_positions": "0.303530761300"
                    //                 }
                    //             ],
                    //             "positions": [
                    //                 {
                    //                     "id": 2470568,
                    //                     "symbol": "ETHUSDT_PERP",
                    //                     "quantity": "0.001",
                    //                     "price_entry": "2927.509",
                    //                     "price_margin_call": "0",
                    //                     "price_liquidation": "0",
                    //                     "pnl": "0",
                    //                     "created_at": "2022-03-19T07:54:35.24Z",
                    //                     "updated_at": "2022-03-19T07:54:58.922Z"
                    //                 }
                    //             ]
                    //         },
                    //     ]
                    //
                    return this.parsePosition(response, market);
                }
                parsePosition(position, market) {
                    //
                    //     [
                    //         {
                    //             "symbol": "ETHUSDT_PERP",
                    //             "type": "isolated",
                    //             "leverage": "10.00",
                    //             "created_at": "2022-03-19T07:54:35.24Z",
                    //             "updated_at": "2022-03-19T07:54:58.922Z",
                    //             currencies": [
                    //                 {
                    //                     "code": "USDT",
                    //                     "margin_balance": "7.478100643043",
                    //                     "reserved_orders": "0",
                    //                     "reserved_positions": "0.303530761300"
                    //                 }
                    //             ],
                    //             "positions": [
                    //                 {
                    //                     "id": 2470568,
                    //                     "symbol": "ETHUSDT_PERP",
                    //                     "quantity": "0.001",
                    //                     "price_entry": "2927.509",
                    //                     "price_margin_call": "0",
                    //                     "price_liquidation": "0",
                    //                     "pnl": "0",
                    //                     "created_at": "2022-03-19T07:54:35.24Z",
                    //                     "updated_at": "2022-03-19T07:54:58.922Z"
                    //                 }
                    //             ]
                    //         },
                    //     ]
                    //
                    const marginMode = this.safeString(position, 'type');
                    const leverage = this.safeNumber(position, 'leverage');
                    const datetime = this.safeString(position, 'updated_at');
                    const positions = this.safeValue(position, 'positions', []);
                    let liquidationPrice = undefined;
                    let entryPrice = undefined;
                    let contracts = undefined;
                    for(let i = 0; i < positions.length; i++){
                        const entry = positions[i];
                        liquidationPrice = this.safeNumber(entry, 'price_liquidation');
                        entryPrice = this.safeNumber(entry, 'price_entry');
                        contracts = this.safeNumber(entry, 'quantity');
                    }
                    const currencies = this.safeValue(position, 'currencies', []);
                    let collateral = undefined;
                    for(let i = 0; i < currencies.length; i++){
                        const entry = currencies[i];
                        collateral = this.safeNumber(entry, 'margin_balance');
                    }
                    const marketId = this.safeString(position, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    return {
                        'info': position,
                        'symbol': symbol,
                        'notional': undefined,
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'liquidationPrice': liquidationPrice,
                        'entryPrice': entryPrice,
                        'unrealizedPnl': undefined,
                        'percentage': undefined,
                        'contracts': contracts,
                        'contractSize': undefined,
                        'markPrice': undefined,
                        'side': undefined,
                        'hedged': undefined,
                        'timestamp': this.parse8601(datetime),
                        'datetime': datetime,
                        'maintenanceMargin': undefined,
                        'maintenanceMarginPercentage': undefined,
                        'collateral': collateral,
                        'initialMargin': undefined,
                        'initialMarginPercentage': undefined,
                        'leverage': leverage,
                        'marginRatio': undefined
                    };
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (!market['swap']) throw new BadSymbol(this.id + ' fetchFundingRate() supports swap contracts only');
                    const request = {};
                    if (symbol !== undefined) {
                        symbol = market['symbol'];
                        request['symbols'] = market['id'];
                    }
                    const response = await this.publicGetPublicFuturesInfo(this.extend(request, params));
                    //
                    //     {
                    //         "BTCUSDT_PERP": {
                    //             "contract_type": "perpetual",
                    //             "mark_price": "42307.43",
                    //             "index_price": "42303.27",
                    //             "funding_rate": "0.0001",
                    //             "open_interest": "30.9826",
                    //             "next_funding_time": "2022-03-22T16:00:00.000Z",
                    //             "indicative_funding_rate": "0.0001",
                    //             "premium_index": "0",
                    //             "avg_premium_index": "0.000029587712038098",
                    //             "interest_rate": "0.0001",
                    //             "timestamp": "2022-03-22T08:08:26.687Z"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, market['id'], {});
                    return this.parseFundingRate(data, market);
                }
                parseFundingRate(contract, market) {
                    //
                    //     {
                    //         "contract_type": "perpetual",
                    //         "mark_price": "42307.43",
                    //         "index_price": "42303.27",
                    //         "funding_rate": "0.0001",
                    //         "open_interest": "30.9826",
                    //         "next_funding_time": "2022-03-22T16:00:00.000Z",
                    //         "indicative_funding_rate": "0.0001",
                    //         "premium_index": "0",
                    //         "avg_premium_index": "0.000029587712038098",
                    //         "interest_rate": "0.0001",
                    //         "timestamp": "2022-03-22T08:08:26.687Z"
                    //     }
                    //
                    const nextFundingDatetime = this.safeString(contract, 'next_funding_time');
                    const datetime = this.safeString(contract, 'timestamp');
                    return {
                        'info': contract,
                        'symbol': this.safeSymbol(undefined, market),
                        'markPrice': this.safeNumber(contract, 'mark_price'),
                        'indexPrice': this.safeNumber(contract, 'index_price'),
                        'interestRate': this.safeNumber(contract, 'interest_rate'),
                        'estimatedSettlePrice': undefined,
                        'timestamp': this.parse8601(datetime),
                        'datetime': datetime,
                        'fundingRate': this.safeNumber(contract, 'funding_rate'),
                        'fundingTimestamp': undefined,
                        'fundingDatetime': undefined,
                        'nextFundingRate': this.safeNumber(contract, 'indicative_funding_rate'),
                        'nextFundingTimestamp': this.parse8601(nextFundingDatetime),
                        'nextFundingDatetime': nextFundingDatetime,
                        'previousFundingRate': undefined,
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                async modifyMarginHelper(symbol, amount, type, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const leverage = this.safeString(params, 'leverage');
                    if (market['type'] === 'swap') {
                        if (leverage === undefined) throw new ArgumentsRequired1(this.id + ' modifyMarginHelper() requires a leverage parameter for swap markets');
                    }
                    amount = this.amountToPrecision(symbol, amount);
                    const request = {
                        'symbol': market['id'],
                        'margin_balance': amount
                    };
                    if (leverage !== undefined) request['leverage'] = leverage;
                    const [marketType, query] = this.handleMarketTypeAndParams('modifyMarginHelper', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'swap': 'privatePutFuturesAccountIsolatedSymbol',
                        'margin': 'privatePutMarginAccountIsolatedSymbol'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //         "symbol": "BTCUSDT_PERP",
                    //         "type": "isolated",
                    //         "leverage": "8.00",
                    //         "created_at": "2022-03-30T23:34:27.161Z",
                    //         "updated_at": "2022-03-30T23:34:27.161Z",
                    //         "currencies": [
                    //             {
                    //                 "code": "USDT",
                    //                 "margin_balance": "7.000000000000",
                    //                 "reserved_orders": "0",
                    //                 "reserved_positions": "0"
                    //             }
                    //         ],
                    //         "positions": null
                    //     }
                    //
                    return this.extend(this.parseModifyMargin(response, market), {
                        'amount': this.safeNumber(amount),
                        'type': type
                    });
                }
                parseModifyMargin(data, market) {
                    const currencies = this.safeValue(data, 'currencies', []);
                    const currencyInfo = this.safeValue(currencies, 0);
                    return {
                        'info': data,
                        'type': undefined,
                        'amount': undefined,
                        'code': this.safeString(currencyInfo, 'code'),
                        'symbol': market['symbol'],
                        'status': undefined
                    };
                }
                async reduceMargin(symbol, amount, params = {}) {
                    if (amount !== 0) throw new BadRequest(this.id + ' reduceMargin() on hitbtc3 requires the amount to be 0 and that will remove the entire margin amount');
                    return await this.modifyMarginHelper(symbol, amount, 'reduce', params);
                }
                async addMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 'add', params);
                }
                async fetchLeverage(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const method = this.getSupportedMapping(market['type'], {
                        'spot': 'privateGetMarginAccountIsolatedSymbol',
                        'margin': 'privateGetMarginAccountIsolatedSymbol',
                        'swap': 'privateGetFuturesAccountIsolatedSymbol'
                    });
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "symbol": "BTCUSDT",
                    //         "type": "isolated",
                    //         "leverage": "12.00",
                    //         "created_at": "2022-03-29T22:31:29.067Z",
                    //         "updated_at": "2022-03-30T00:00:00.125Z",
                    //         "currencies": [
                    //             {
                    //                 "code": "USDT",
                    //                 "margin_balance": "20.824360374174",
                    //                 "reserved_orders": "0",
                    //                 "reserved_positions": "0.973330435000"
                    //             }
                    //         ],
                    //         "positions": [
                    //             {
                    //                 "id": 631301,
                    //                 "symbol": "BTCUSDT",
                    //                 "quantity": "0.00022",
                    //                 "price_entry": "47425.57",
                    //                 "price_margin_call": "",
                    //                 "price_liquidation": "0",
                    //                 "pnl": "0",
                    //                 "created_at": "2022-03-29T22:31:29.067Z",
                    //                 "updated_at": "2022-03-30T00:00:00.125Z"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.safeNumber(response, 'leverage');
                }
                async setLeverage(leverage, symbol, params = {}) {
                    await this.loadMarkets();
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    if (params['margin_balance'] === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a margin_balance parameter that will transfer margin to the specified trading pair');
                    const market = this.market(symbol);
                    const amount = this.safeNumber(params, 'margin_balance');
                    const maxLeverage = this.safeInteger(market['limits']['leverage'], 'max', 50);
                    if (market['type'] !== 'swap') throw new BadSymbol(this.id + ' setLeverage() supports swap contracts only');
                    if (leverage < 1 || leverage > maxLeverage) throw new BadRequest(this.id + ' setLeverage() leverage should be between 1 and ' + maxLeverage.toString() + ' for ' + symbol);
                    const request = {
                        'symbol': market['id'],
                        'leverage': leverage.toString(),
                        'margin_balance': this.amountToPrecision(symbol, amount)
                    };
                    return await this.privatePutFuturesAccountIsolatedSymbol(this.extend(request, params));
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    //
                    //     {
                    //       "error": {
                    //         "code": 20001,
                    //         "message": "Insufficient funds",
                    //         "description": "Check that the funds are sufficient, given commissions"
                    //       }
                    //     }
                    //
                    //     {
                    //       "error": {
                    //         "code": "600",
                    //         "message": "Action not allowed"
                    //       }
                    //     }
                    //
                    const error = this.safeValue(response, 'error');
                    const errorCode = this.safeString(error, 'code');
                    if (errorCode !== undefined) {
                        const feedback = this.id + ' ' + body;
                        const message = this.safeString2(error, 'message', 'description');
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const query = this.omit(params, this.extractParams(path));
                    const implodedPath = this.implodeParams(path, params);
                    let url = this.urls['api'][api] + '/' + implodedPath;
                    let getRequest = undefined;
                    const keys = Object.keys(query);
                    const queryLength = keys.length;
                    headers = {
                        'Content-Type': 'application/json'
                    };
                    if (method === 'GET') {
                        if (queryLength) {
                            getRequest = '?' + this.urlencode(query);
                            url = url + getRequest;
                        }
                    } else body = this.json(params);
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.nonce().toString();
                        const payload = [
                            method,
                            '/api/3/' + implodedPath
                        ];
                        if (method === 'GET') {
                            if (getRequest !== undefined) payload.push(getRequest);
                        } else payload.push(body);
                        payload.push(timestamp);
                        const payloadString = payload.join('');
                        const signature = this.hmac(this.encode(payloadString), this.encode(this.secret), 'sha256', 'hex');
                        const secondPayload = this.apiKey + ':' + signature + ':' + timestamp;
                        const encoded = this.decode(this.stringToBase64(secondPayload));
                        headers['Authorization'] = 'HS256 ' + encoded;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    87: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { BadRequest: BadRequest, AuthenticationError: AuthenticationError, NetworkError: NetworkError, ArgumentsRequired: ArgumentsRequired1, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class hollaex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'hollaex',
                        'name': 'HollaEx',
                        'countries': [
                            'KR'
                        ],
                        // 4 requests per second => 1000ms / 4 = 250 ms between requests
                        'rateLimit': 250,
                        'version': 'v2',
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createLimitBuyOrder': true,
                            'createLimitSellOrder': true,
                            'createMarketBuyOrder': true,
                            'createMarketSellOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': 'emulated',
                            'fetchDepositAddresses': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': undefined,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '1h': '1h',
                            '4h': '4h',
                            '1d': '1d',
                            '1w': '1w'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/75841031-ca375180-5ddd-11ea-8417-b975674c23cb.jpg',
                            'test': {
                                'rest': 'https://api.sandbox.hollaex.com'
                            },
                            'api': {
                                'rest': 'https://api.hollaex.com'
                            },
                            'www': 'https://hollaex.com',
                            'doc': 'https://apidocs.hollaex.com',
                            'referral': 'https://pro.hollaex.com/signup?affiliation_code=QSWA6G'
                        },
                        'precisionMode': TICK_SIZE,
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'health': 1,
                                    'constants': 1,
                                    'kit': 1,
                                    'tiers': 1,
                                    'ticker': 1,
                                    'tickers': 1,
                                    'orderbook': 1,
                                    'orderbooks': 1,
                                    'trades': 1,
                                    'chart': 1,
                                    'charts': 1,
                                    // TradingView
                                    'udf/config': 1,
                                    'udf/history': 1,
                                    'udf/symbols': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'user': 1,
                                    'user/balance': 1,
                                    'user/deposits': 1,
                                    'user/withdrawals': 1,
                                    'user/withdrawal/fee': 1,
                                    'user/trades': 1,
                                    'orders': 1,
                                    'order': 1
                                },
                                'post': {
                                    'user/withdrawal': 1,
                                    'order': 1
                                },
                                'delete': {
                                    'order/all': 1,
                                    'order': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': 0.001,
                                'maker': 0.001
                            }
                        },
                        'exceptions': {
                            'broad': {
                                'Invalid token': AuthenticationError,
                                'Order not found': OrderNotFound,
                                'Insufficient balance': InsufficientFunds
                            },
                            'exact': {
                                '400': BadRequest,
                                '403': AuthenticationError,
                                '404': BadRequest,
                                '405': BadRequest,
                                '410': BadRequest,
                                '429': BadRequest,
                                '500': NetworkError,
                                '503': NetworkError
                            }
                        },
                        'options': {
                            // how many seconds before the authenticated request expires
                            'api-expires': parseInt(this.timeout / 1000),
                            'networks': {
                                'BTC': 'btc',
                                'ETH': 'eth',
                                'ERC20': 'eth',
                                'TRX': 'trx',
                                'TRC20': 'trx',
                                'XRP': 'xrp',
                                'XLM': 'xlm'
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetConstants(params);
                    //
                    //     {
                    //         coins: {
                    //             xmr: {
                    //                 id: 7,
                    //                 fullname: "Monero",
                    //                 symbol: "xmr",
                    //                 active: true,
                    //                 allow_deposit: true,
                    //                 allow_withdrawal: true,
                    //                 withdrawal_fee: 0.02,
                    //                 min: 0.001,
                    //                 max: 100000,
                    //                 increment_unit: 0.001,
                    //                 deposit_limits: { '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0 },
                    //                 withdrawal_limits: { '1': 10, '2': 15, '3': 100, '4': 100, '5': 200, '6': 300, '7': 350, '8': 400, '9': 500, '10': -1 },
                    //                 created_at: "2019-12-09T07:14:02.720Z",
                    //                 updated_at: "2020-01-16T12:12:53.162Z"
                    //             },
                    //             // ...
                    //         },
                    //         pairs: {
                    //             'btc-usdt': {
                    //                 id: 2,
                    //                 name: "btc-usdt",
                    //                 pair_base: "btc",
                    //                 pair_2: "usdt",
                    //                 taker_fees: { '1': 0.3, '2': 0.25, '3': 0.2, '4': 0.18, '5': 0.1, '6': 0.09, '7': 0.08, '8': 0.06, '9': 0.04, '10': 0 },
                    //                 maker_fees: { '1': 0.1, '2': 0.08, '3': 0.05, '4': 0.03, '5': 0, '6': 0, '7': 0, '8': 0, '9': 0, '10': 0 },
                    //                 min_size: 0.0001,
                    //                 max_size: 1000,
                    //                 min_price: 100,
                    //                 max_price: 100000,
                    //                 increment_size: 0.0001,
                    //                 increment_price: 0.05,
                    //                 active: true,
                    //                 created_at: "2019-12-09T07:15:54.537Z",
                    //                 updated_at: "2019-12-09T07:15:54.537Z"
                    //             },
                    //         },
                    //         config: { tiers: 10 },
                    //         status: true
                    //     }
                    //
                    const pairs = this.safeValue(response, 'pairs', {});
                    const keys = Object.keys(pairs);
                    const result = [];
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        const market = pairs[key];
                        const baseId = this.safeString(market, 'pair_base');
                        const quoteId = this.safeString(market, 'pair_2');
                        const base = this.commonCurrencyCode(baseId.toUpperCase());
                        const quote = this.commonCurrencyCode(quoteId.toUpperCase());
                        result.push({
                            'id': this.safeString(market, 'name'),
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': this.safeValue(market, 'active'),
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(market, 'increment_size'),
                                'price': this.safeNumber(market, 'increment_price')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min_size'),
                                    'max': this.safeNumber(market, 'max_size')
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'min_price'),
                                    'max': this.safeNumber(market, 'max_price')
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetConstants(params);
                    //
                    //     {
                    //         "coins":{
                    //             "bch":{
                    //                 "id":4,
                    //                 "fullname":"Bitcoin Cash",
                    //                 "symbol":"bch",
                    //                 "active":true,
                    //                 "verified":true,
                    //                 "allow_deposit":true,
                    //                 "allow_withdrawal":true,
                    //                 "withdrawal_fee":0.0001,
                    //                 "min":0.001,
                    //                 "max":100000,
                    //                 "increment_unit":0.001,
                    //                 "logo":"https://bitholla.s3.ap-northeast-2.amazonaws.com/icon/BCH-hollaex-asset-01.svg",
                    //                 "code":"bch",
                    //                 "is_public":true,
                    //                 "meta":{},
                    //                 "estimated_price":null,
                    //                 "description":null,
                    //                 "type":"blockchain",
                    //                 "network":null,
                    //                 "standard":null,
                    //                 "issuer":"HollaEx",
                    //                 "withdrawal_fees":null,
                    //                 "created_at":"2019-08-09T10:45:43.367Z",
                    //                 "updated_at":"2021-12-13T03:08:32.372Z",
                    //                 "created_by":1,
                    //                 "owner_id":1
                    //             },
                    //         },
                    //         "network":"https://api.hollaex.network"
                    //     }
                    //
                    const coins = this.safeValue(response, 'coins', {});
                    const keys = Object.keys(coins);
                    const result = {};
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        const currency = coins[key];
                        const id = this.safeString(currency, 'symbol');
                        const numericId = this.safeInteger(currency, 'id');
                        const code = this.safeCurrencyCode(id);
                        const name = this.safeString(currency, 'fullname');
                        const depositEnabled = this.safeValue(currency, 'allow_deposit');
                        const withdrawEnabled = this.safeValue(currency, 'allow_withdrawal');
                        const isActive = this.safeValue(currency, 'active');
                        const active = isActive && depositEnabled && withdrawEnabled;
                        const fee = this.safeNumber(currency, 'withdrawal_fee');
                        const precision = this.safeNumber(currency, 'increment_unit');
                        const withdrawalLimits = this.safeValue(currency, 'withdrawal_limits', []);
                        result[code] = {
                            'id': id,
                            'numericId': numericId,
                            'code': code,
                            'info': currency,
                            'name': name,
                            'active': active,
                            'deposit': depositEnabled,
                            'withdraw': withdrawEnabled,
                            'fee': fee,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': this.safeNumber(currency, 'min'),
                                    'max': this.safeNumber(currency, 'max')
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': this.safeValue(withdrawalLimits, 0)
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchOrderBooks(symbols, limit, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetOrderbooks(params);
                    const result = {};
                    const marketIds = Object.keys(response);
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const orderbook = response[marketId];
                        const symbol = this.safeSymbol(marketId, undefined, '-');
                        const timestamp = this.parse8601(this.safeString(orderbook, 'timestamp'));
                        result[symbol] = this.parseOrderBook(response[marketId], timestamp);
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const marketId = this.marketId(symbol);
                    const request = {
                        'symbol': marketId
                    };
                    const response = await this.publicGetOrderbooks(this.extend(request, params));
                    //
                    //     {
                    //         "btc-usdt": {
                    //             "bids": [
                    //                 [ 8836.4, 1.022 ],
                    //                 [ 8800, 0.0668 ],
                    //                 [ 8797.75, 0.2398 ],
                    //             ],
                    //             "asks": [
                    //                 [ 8839.35, 1.5334 ],
                    //                 [ 8852.6, 0.0579 ],
                    //                 [ 8860.45, 0.1815 ],
                    //             ],
                    //             "timestamp": "2020-03-03T02:27:25.147Z"
                    //         },
                    //         "eth-usdt": {},
                    //         // ...
                    //     }
                    //
                    const orderbook = this.safeValue(response, marketId);
                    const timestamp = this.parse8601(this.safeString(orderbook, 'timestamp'));
                    return this.parseOrderBook(orderbook, symbol, timestamp);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    //
                    //     {
                    //         open: 8615.55,
                    //         close: 8841.05,
                    //         high: 8921.1,
                    //         low: 8607,
                    //         last: 8841.05,
                    //         volume: 20.2802,
                    //         timestamp: '2020-03-03T03:11:18.964Z'
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTickers(this.extend(params));
                    //
                    //     {
                    //         "bch-usdt": {
                    //             "time": "2020-03-02T04:29:45.011Z",
                    //             "open": 341.65,
                    //             "close":337.9,
                    //             "high":341.65,
                    //             "low":337.3,
                    //             "last":337.9,
                    //             "volume":0.054,
                    //             "symbol":"bch-usdt"
                    //         },
                    //         // ...
                    //     }
                    //
                    return this.parseTickers(response, symbols);
                }
                parseTickers(response, symbols, params = {}) {
                    const result = {};
                    const keys = Object.keys(response);
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        const ticker = response[key];
                        const marketId = this.safeString(ticker, 'symbol', key);
                        const market = this.safeMarket(marketId, undefined, '-');
                        const symbol = market['symbol'];
                        result[symbol] = this.extend(this.parseTicker(ticker, market), params);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker
                    //
                    //     {
                    //         open: 8615.55,
                    //         close: 8841.05,
                    //         high: 8921.1,
                    //         low: 8607,
                    //         last: 8841.05,
                    //         volume: 20.2802,
                    //         timestamp: '2020-03-03T03:11:18.964Z',
                    //     }
                    //
                    // fetchTickers
                    //
                    //     {
                    //         "time": "2020-03-02T04:29:45.011Z",
                    //         "open": 341.65,
                    //         "close": 337.9,
                    //         "high": 341.65,
                    //         "low": 337.3,
                    //         "last": 337.9,
                    //         "volume": 0.054,
                    //         "symbol": "bch-usdt"
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'symbol');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    const timestamp = this.parse8601(this.safeString2(ticker, 'time', 'timestamp'));
                    const close = this.safeString(ticker, 'close');
                    return this.safeTicker({
                        'symbol': symbol,
                        'info': ticker,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open'),
                        'close': close,
                        'last': this.safeString(ticker, 'last', close),
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': undefined
                    }, market, false);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetTrades(this.extend(request, params));
                    //
                    //     {
                    //         "btc-usdt": [
                    //             {
                    //                 "size": 0.5,
                    //                 "price": 8830,
                    //                 "side": "buy",
                    //                 "timestamp": "2020-03-03T04:44:33.034Z"
                    //             },
                    //             // ...
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, market['id'], []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "size": 0.5,
                    //         "price": 8830,
                    //         "side": "buy",
                    //         "timestamp": "2020-03-03T04:44:33.034Z"
                    //     }
                    //
                    // fetchMyTrades (private)
                    //  {
                    //      "side":"sell",
                    //      "symbol":"doge-usdt",
                    //      "size":70,
                    //      "price":0.147411,
                    //      "timestamp":"2022-01-26T17:53:34.650Z",
                    //      "order_id":"cba78ecb-4187-4da2-9d2f-c259aa693b5a",
                    //      "fee":0.01031877,"fee_coin":"usdt"
                    //  }
                    //
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    const datetime = this.safeString(trade, 'timestamp');
                    const timestamp = this.parse8601(datetime);
                    const side = this.safeString(trade, 'side');
                    const orderId = this.safeString(trade, 'order_id');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'size');
                    const feeCostString = this.safeString(trade, 'fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) fee = {
                        'cost': feeCostString,
                        'currency': market['quote']
                    };
                    return this.safeTrade({
                        'info': trade,
                        'id': undefined,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'symbol': symbol,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTiers(params);
                    //
                    //     {
                    //         '1': {
                    //             id: '1',
                    //             name: 'Silver',
                    //             icon: '',
                    //             description: 'Your crypto journey starts here! Make your first deposit to start trading, and verify your account to level up!',
                    //             deposit_limit: '0',
                    //             withdrawal_limit: '1000',
                    //             fees: {
                    //                 maker: {
                    //                     'eth-btc': '0.1',
                    //                     'ada-usdt': '0.1',
                    //                     ...
                    //                 },
                    //                 taker: {
                    //                     'eth-btc': '0.1',
                    //                     'ada-usdt': '0.1',
                    //                     ...
                    //                 }
                    //             },
                    //             note: '<ul>\n<li>Login and verify email</li>\n</ul>\n',
                    //             created_at: '2021-03-22T03:51:39.129Z',
                    //             updated_at: '2021-11-01T02:51:56.214Z'
                    //         },
                    //         ...
                    //     }
                    //
                    const firstTier = this.safeValue(response, '1', {});
                    const fees = this.safeValue(firstTier, 'fees', {});
                    const makerFees = this.safeValue(fees, 'maker', {});
                    const takerFees = this.safeValue(fees, 'taker', {});
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        const makerString = this.safeString(makerFees, market['id']);
                        const takerString = this.safeString(takerFees, market['id']);
                        result[symbol] = {
                            'info': fees,
                            'symbol': symbol,
                            'maker': this.parseNumber(Precise.stringDiv(makerString, '100')),
                            'taker': this.parseNumber(Precise.stringDiv(takerString, '100')),
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                async fetchOHLCV(symbol, timeframe = '1h', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'resolution': this.timeframes[timeframe]
                    };
                    const duration = this.parseTimeframe(timeframe);
                    if (since === undefined) {
                        if (limit === undefined) throw new ArgumentsRequired1(this.id + " fetchOHLCV() requires a 'since' or a 'limit' argument");
                        else {
                            const end = this.seconds();
                            const start = end - duration * limit;
                            request['to'] = end;
                            request['from'] = start;
                        }
                    } else if (limit === undefined) {
                        request['from'] = parseInt(since / 1000);
                        request['to'] = this.seconds();
                    } else {
                        const start = parseInt(since / 1000);
                        request['from'] = start;
                        request['to'] = this.sum(start, duration * limit);
                    }
                    const response = await this.publicGetChart(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "time":"2020-03-02T20:00:00.000Z",
                    //             "close":8872.1,
                    //             "high":8872.1,
                    //             "low":8858.6,
                    //             "open":8858.6,
                    //             "symbol":"btc-usdt",
                    //             "volume":1.2922
                    //         },
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseOHLCV(response, market, timeframe = '1h', since, limit) {
                    //
                    //     {
                    //         "time":"2020-03-02T20:00:00.000Z",
                    //         "close":8872.1,
                    //         "high":8872.1,
                    //         "low":8858.6,
                    //         "open":8858.6,
                    //         "symbol":"btc-usdt",
                    //         "volume":1.2922
                    //     }
                    //
                    return [
                        this.parse8601(this.safeString(response, 'time')),
                        this.safeNumber(response, 'open'),
                        this.safeNumber(response, 'high'),
                        this.safeNumber(response, 'low'),
                        this.safeNumber(response, 'close'),
                        this.safeNumber(response, 'volume')
                    ];
                }
                parseBalance(response) {
                    const timestamp = this.parse8601(this.safeString(response, 'updated_at'));
                    const result = {
                        'info': response,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    };
                    const currencyIds = Object.keys(this.currencies_by_id);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(response, currencyId + '_available');
                        account['total'] = this.safeString(response, currencyId + '_balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetUserBalance(params);
                    //
                    //     {
                    //         "updated_at": "2020-03-02T22:27:38.428Z",
                    //         "btc_balance": 0,
                    //         "btc_pending": 0,
                    //         "btc_available": 0,
                    //         "eth_balance": 0,
                    //         "eth_pending": 0,
                    //         "eth_available": 0,
                    //         // ...
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOpenOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privateGetOrder(this.extend(request, params));
                    //
                    //     {
                    //         "id": "string",
                    //         "side": "sell",
                    //         "symbol": "xht-usdt",
                    //         "size": 0.1,
                    //         "filled": 0,
                    //         "stop": null,
                    //         "fee": 0,
                    //         "fee_coin": "usdt",
                    //         "type": "limit",
                    //         "price": 1.09,
                    //         "status": "new",
                    //         "created_by": 116,
                    //         "created_at": "2021-02-17T02:32:38.910Z",
                    //         "updated_at": "2021-02-17T02:32:38.910Z",
                    //         "User": {
                    //             "id": 116,
                    //             "email": "fight@club.com",
                    //             "username": "narrator",
                    //             "exchange_id": 176
                    //         }
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'open': true
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'open': false
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privateGetOrder(this.extend(request, params));
                    //             {
                    //                 "id": "string",
                    //                 "side": "sell",
                    //                 "symbol": "xht-usdt",
                    //                 "size": 0.1,
                    //                 "filled": 0,
                    //                 "stop": null,
                    //                 "fee": 0,
                    //                 "fee_coin": "usdt",
                    //                 "type": "limit",
                    //                 "price": 1.09,
                    //                 "status": "new",
                    //                 "created_by": 116,
                    //                 "created_at": "2021-02-17T02:32:38.910Z",
                    //                 "updated_at": "2021-02-17T02:32:38.910Z",
                    //                 "User": {
                    //                     "id": 116,
                    //                     "email": "fight@club.com",
                    //                     "username": "narrator",
                    //                     "exchange_id": 176
                    //                 }
                    //             }
                    const order = response;
                    if (order === undefined) throw new OrderNotFound(this.id + ' fetchOrder() could not find order id ' + id);
                    return this.parseOrder(order);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['start_date'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit; // default 50, max 100
                    const response = await this.privateGetOrders(this.extend(request, params));
                    //
                    //     {
                    //         "count": 1,
                    //         "data": [
                    //             {
                    //                 "id": "string",
                    //                 "side": "sell",
                    //                 "symbol": "xht-usdt",
                    //                 "size": 0.1,
                    //                 "filled": 0,
                    //                 "stop": null,
                    //                 "fee": 0,
                    //                 "fee_coin": "usdt",
                    //                 "type": "limit",
                    //                 "price": 1.09,
                    //                 "status": "new",
                    //                 "created_by": 116,
                    //                 "created_at": "2021-02-17T02:32:38.910Z",
                    //                 "updated_at": "2021-02-17T02:32:38.910Z",
                    //                 "User": {
                    //                     "id": 116,
                    //                     "email": "fight@club.com",
                    //                     "username": "narrator",
                    //                     "exchange_id": 176
                    //                 }
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'new': 'open',
                        'pfilled': 'open',
                        'filled': 'closed',
                        'canceled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder, fetchOpenOrder, fetchOpenOrders
                    //
                    //     {
                    //         "id": "string",
                    //         "side": "sell",
                    //         "symbol": "xht-usdt",
                    //         "size": 0.1,
                    //         "filled": 0,
                    //         "stop": null,
                    //         "fee": 0,
                    //         "fee_coin": "usdt",
                    //         "type": "limit",
                    //         "price": 1.09,
                    //         "status": "new",
                    //         "created_by": 116,
                    //         "created_at": "2021-02-17T02:32:38.910Z",
                    //         "updated_at": "2021-02-17T02:32:38.910Z",
                    //         "User": {
                    //             "id": 116,
                    //             "email": "fight@club.com",
                    //             "username": "narrator",
                    //             "exchange_id": 176
                    //         },
                    //         "fee_structure": {
                    //             "maker": 0.2,
                    //             "taker": 0.2
                    //         },
                    //     }
                    //
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const id = this.safeString(order, 'id');
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const type = this.safeString(order, 'type');
                    const side = this.safeString(order, 'side');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'size');
                    const filled = this.safeString(order, 'filled');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'cost': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'info': order,
                        'average': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'side': side,
                        'size': this.normalizeNumberIfNeeded(amount),
                        'type': type
                    };
                    if (type !== 'market') {
                        const convertedPrice = parseFloat(this.priceToPrecision(symbol, price));
                        request['price'] = this.normalizeNumberIfNeeded(convertedPrice);
                    }
                    const stopPrice = this.safeNumber2(params, 'stopPrice', 'stop');
                    if (stopPrice !== undefined) {
                        request['stop'] = this.normalizeNumberIfNeeded(parseFloat(this.priceToPrecision(symbol, stopPrice)));
                        params = this.omit(params, [
                            'stopPrice',
                            'stop'
                        ]);
                    }
                    const response = await this.privatePostOrder(this.extend(request, params));
                    //
                    //     {
                    //         "fee": 0,
                    //         "meta": {},
                    //         "symbol": "xht-usdt",
                    //         "side": "sell",
                    //         "size": 0.1,
                    //         "type": "limit",
                    //         "price": 1,
                    //         "fee_structure": {
                    //             "maker": 0.2,
                    //             "taker": 0.2
                    //         },
                    //         "fee_coin": "usdt",
                    //         "id": "string",
                    //         "created_by": 116,
                    //         "filled": 0,
                    //         "status": "new",
                    //         "updated_at": "2021-02-17T03:03:19.231Z",
                    //         "created_at": "2021-02-17T03:03:19.231Z",
                    //         "stop": null
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privateDeleteOrder(this.extend(request, params));
                    //
                    //     {
                    //         "title": "string",
                    //         "symbol": "xht-usdt",
                    //         "side": "sell",
                    //         "size": 1,
                    //         "type": "limit",
                    //         "price": 0.1,
                    //         "id": "string",
                    //         "created_by": 34,
                    //         "filled": 0
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async cancelAllOrders(symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + " cancelAllOrders() requires a 'symbol' argument");
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    market = this.market(symbol);
                    request['symbol'] = market['id'];
                    const response = await this.privateDeleteOrderAll(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "title": "string",
                    //             "symbol": "xht-usdt",
                    //             "side": "sell",
                    //             "size": 1,
                    //             "type": "limit",
                    //             "price": 0.1,
                    //             "id": "string",
                    //             "created_by": 34,
                    //             "filled": 0
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 50, max 100
                    if (since !== undefined) request['start_date'] = this.iso8601(since);
                    const response = await this.privateGetUserTrades(this.extend(request, params));
                    //
                    //     {
                    //         "count": 1,
                    //         "data": [
                    //             {
                    //                 "side": "buy",
                    //                 "symbol": "eth-usdt",
                    //                 "size": 0.086,
                    //                 "price": 226.19,
                    //                 "timestamp": "2020-03-03T08:03:55.459Z",
                    //                 "fee": 0.1
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         "currency":"usdt",
                    //         "address":"TECLD9XBH31XpyykdHU3uEAeUK7E6Lrmik",
                    //         "network":"trx",
                    //         "standard":null,
                    //         "is_valid":true,
                    //         "created_at":"2021-05-12T02:43:05.446Z"
                    //     }
                    //
                    let address = this.safeString(depositAddress, 'address');
                    let tag = undefined;
                    if (address !== undefined) {
                        const parts = address.split(':');
                        address = this.safeString(parts, 0);
                        tag = this.safeString(parts, 1);
                    }
                    this.checkAddress(address);
                    const currencyId = this.safeString(depositAddress, 'currency');
                    currency = this.safeCurrency(currencyId, currency);
                    const network = this.safeString(depositAddress, 'network');
                    return {
                        'currency': currency['code'],
                        'address': address,
                        'tag': tag,
                        'network': network,
                        'info': depositAddress
                    };
                }
                async fetchDepositAddresses(codes, params = {}) {
                    await this.loadMarkets();
                    const network = this.safeString(params, 'network');
                    params = this.omit(params, 'network');
                    const response = await this.privateGetUser(params);
                    //
                    //     {
                    //         "id":620,
                    //         "email":"igor.kroitor@gmail.com",
                    //         "full_name":"",
                    //         "gender":false,
                    //         "nationality":"",
                    //         "dob":null,
                    //         "phone_number":"",
                    //         "address":{"city":"","address":"","country":"","postal_code":""},
                    //         "id_data":{"note":"","type":"","number":"","status":0,"issued_date":"","expiration_date":""},
                    //         "bank_account":[],
                    //         "crypto_wallet":{},
                    //         "verification_level":1,
                    //         "email_verified":true,
                    //         "otp_enabled":true,
                    //         "activated":true,
                    //         "username":"igor.kroitor",
                    //         "affiliation_code":"QSWA6G",
                    //         "settings":{
                    //             "chat":{"set_username":false},
                    //             "risk":{"popup_warning":false,"order_portfolio_percentage":20},
                    //             "audio":{"public_trade":false,"order_completed":true,"order_partially_completed":true},
                    //             "language":"en",
                    //             "interface":{"theme":"white","order_book_levels":10},
                    //             "notification":{"popup_order_completed":true,"popup_order_confirmation":true,"popup_order_partially_filled":true}
                    //         },
                    //         "affiliation_rate":0,
                    //         "network_id":10620,
                    //         "discount":0,
                    //         "created_at":"2021-03-24T02:37:57.379Z",
                    //         "updated_at":"2021-03-24T02:37:57.379Z",
                    //         "balance":{
                    //             "btc_balance":0,
                    //             "btc_available":0,
                    //             "eth_balance":0.000914,
                    //             "eth_available":0.000914,
                    //             "updated_at":"2020-03-04T04:03:27.174Z
                    //         "},
                    //         "wallet":[
                    //             {"currency":"usdt","address":"TECLD9XBH31XpyykdHU3uEAeUK7E6Lrmik","network":"trx","standard":null,"is_valid":true,"created_at":"2021-05-12T02:43:05.446Z"},
                    //             {"currency":"xrp","address":"rGcSzmuRx8qngPRnrvpCKkP9V4njeCPGCv:286741597","network":"xrp","standard":null,"is_valid":true,"created_at":"2021-05-12T02:49:01.273Z"}
                    //         ]
                    //     }
                    //
                    const wallet = this.safeValue(response, 'wallet', []);
                    const addresses = network === undefined ? wallet : this.filterBy(wallet, 'network', network);
                    return this.parseDepositAddresses(addresses, codes);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 50, max 100
                    if (since !== undefined) request['start_date'] = this.iso8601(since);
                    const response = await this.privateGetUserDeposits(this.extend(request, params));
                    //
                    //     {
                    //         "count": 1,
                    //         "data": [
                    //             {
                    //                 "id": 539,
                    //                 "amount": 20,
                    //                 "fee": 0,
                    //                 "address": "0x5c0cc98270d7089408fcbcc8e2131287f5be2306",
                    //                 "transaction_id": "0xd4006327a5ec2c41adbdcf566eaaba6597c3d45906abe78ea1a4a022647c2e28",
                    //                 "status": true,
                    //                 "dismissed": false,
                    //                 "rejected": false,
                    //                 "description": "",
                    //                 "type": "deposit",
                    //                 "currency": "usdt",
                    //                 "created_at": "2020-03-03T07:56:36.198Z",
                    //                 "updated_at": "2020-03-03T08:00:05.674Z",
                    //                 "user_id": 620
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, currency, since, limit);
                }
                async fetchWithdrawal(id, code, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'transaction_id': id
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    const response = await this.privateGetUserWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         "count": 1,
                    //         "data": [
                    //             {
                    //                 "id": 539,
                    //                 "amount": 20,
                    //                 "fee": 0,
                    //                 "address": "0x5c0cc98270d7089408fcbcc8e2131287f5be2306",
                    //                 "transaction_id": "0xd4006327a5ec2c41adbdcf566eaaba6597c3d45906abe78ea1a4a022647c2e28",
                    //                 "status": true,
                    //                 "dismissed": false,
                    //                 "rejected": false,
                    //                 "description": "",
                    //                 "type": "withdrawal",
                    //                 "currency": "usdt",
                    //                 "created_at": "2020-03-03T07:56:36.198Z",
                    //                 "updated_at": "2020-03-03T08:00:05.674Z",
                    //                 "user_id": 620
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const transaction = this.safeValue(data, 0, {});
                    return this.parseTransaction(transaction, currency);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 50, max 100
                    if (since !== undefined) request['start_date'] = this.iso8601(since);
                    const response = await this.privateGetUserWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         "count": 1,
                    //         "data": [
                    //             {
                    //                 "id": 539,
                    //                 "amount": 20,
                    //                 "fee": 0,
                    //                 "address": "0x5c0cc98270d7089408fcbcc8e2131287f5be2306",
                    //                 "transaction_id": "0xd4006327a5ec2c41adbdcf566eaaba6597c3d45906abe78ea1a4a022647c2e28",
                    //                 "status": true,
                    //                 "dismissed": false,
                    //                 "rejected": false,
                    //                 "description": "",
                    //                 "type": "withdrawal",
                    //                 "currency": "usdt",
                    //                 "created_at": "2020-03-03T07:56:36.198Z",
                    //                 "updated_at": "2020-03-03T08:00:05.674Z",
                    //                 "user_id": 620
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, currency, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchWithdrawals, fetchDeposits
                    //
                    //     {
                    //         "id": 539,
                    //         "amount": 20,
                    //         "fee": 0,
                    //         "address": "0x5c0cc98270d7089408fcbcc8e2131287f5be2306",
                    //         "transaction_id": "0xd4006327a5ec2c41adbdcf566eaaba6597c3d45906abe78ea1a4a022647c2e28",
                    //         "status": true,
                    //         "dismissed": false,
                    //         "rejected": false,
                    //         "description": "",
                    //         "type": "withdrawal",
                    //         "currency": "usdt",
                    //         "created_at": "2020-03-03T07:56:36.198Z",
                    //         "updated_at": "2020-03-03T08:00:05.674Z",
                    //         "user_id": 620
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         message: 'Withdrawal request is in the queue and will be processed.',
                    //         transaction_id: '1d1683c3-576a-4d53-8ff5-27c93fd9758a',
                    //         amount: 1,
                    //         currency: 'xht',
                    //         fee: 0,
                    //         fee_coin: 'xht'
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const txid = this.safeString(transaction, 'transaction_id');
                    const timestamp = this.parse8601(this.safeString(transaction, 'created_at'));
                    const updated = this.parse8601(this.safeString(transaction, 'updated_at'));
                    const type = this.safeString(transaction, 'type');
                    const amount = this.safeNumber(transaction, 'amount');
                    let address = this.safeString(transaction, 'address');
                    let addressTo = undefined;
                    const addressFrom = undefined;
                    let tag = undefined;
                    let tagTo = undefined;
                    const tagFrom = undefined;
                    if (address !== undefined) {
                        const parts = address.split(':');
                        address = this.safeString(parts, 0);
                        tag = this.safeString(parts, 1);
                        addressTo = address;
                        tagTo = tag;
                    }
                    const currencyId = this.safeString(transaction, 'currency');
                    currency = this.safeCurrency(currencyId, currency);
                    let status = this.safeValue(transaction, 'status');
                    const dismissed = this.safeValue(transaction, 'dismissed');
                    const rejected = this.safeValue(transaction, 'rejected');
                    if (status) status = 'ok';
                    else if (dismissed) status = 'canceled';
                    else if (rejected) status = 'failed';
                    else status = 'pending';
                    const feeCurrencyId = this.safeString(transaction, 'fee_coin');
                    const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId, currency);
                    const feeCost = this.safeNumber(transaction, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'currency': feeCurrencyCode,
                        'cost': feeCost
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': addressFrom,
                        'address': address,
                        'addressTo': addressTo,
                        'tagFrom': tagFrom,
                        'tag': tag,
                        'tagTo': tagTo,
                        'type': type,
                        'amount': amount,
                        'currency': currency['code'],
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (tag !== undefined) address += ':' + tag;
                    const network = this.safeString(params, 'network');
                    if (network === undefined) throw new ArgumentsRequired1(this.id + ' withdraw() requires a network parameter');
                    params = this.omit(params, 'network');
                    const networks = this.safeValue(this.options, 'networks', {});
                    const networkId = this.safeStringLower2(networks, network, code, network);
                    const request = {
                        'currency': currency['id'],
                        'amount': amount,
                        'address': address,
                        'network': networkId
                    };
                    const response = await this.privatePostUserWithdrawal(this.extend(request, params));
                    //
                    //     {
                    //         message: 'Withdrawal request is in the queue and will be processed.',
                    //         transaction_id: '1d1683c3-576a-4d53-8ff5-27c93fd9758a',
                    //         amount: 1,
                    //         currency: 'xht',
                    //         fee: 0,
                    //         fee_coin: 'xht'
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                normalizeNumberIfNeeded(number) {
                    if (number % 1 === 0) number = parseInt(number);
                    return number;
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const query = this.omit(params, this.extractParams(path));
                    path = '/' + this.version + '/' + this.implodeParams(path, params);
                    if (method === 'GET' || method === 'DELETE') {
                        if (Object.keys(query).length) path += '?' + this.urlencode(query);
                    }
                    const url = this.urls['api']['rest'] + path;
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const defaultExpires = this.safeInteger2(this.options, 'api-expires', 'expires', parseInt(this.timeout / 1000));
                        const expires = this.sum(this.seconds(), defaultExpires);
                        const expiresString = expires.toString();
                        let auth = method + path + expiresString;
                        headers = {
                            'api-key': this.apiKey,
                            'api-expires': expiresString
                        };
                        if (method === 'POST') {
                            headers['Content-type'] = 'application/json';
                            if (Object.keys(query).length) {
                                body = this.json(query);
                                auth += body;
                            }
                        }
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                        headers['api-signature'] = signature;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    if (code >= 400 && code <= 503) {
                        //
                        //  { "message": "Invalid token" }
                        //
                        const feedback = this.id + ' ' + body;
                        const message = this.safeString(response, 'message');
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        const status = code.toString();
                        this.throwExactlyMatchedException(this.exceptions['exact'], status, feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    88: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AccountNotEnabled: AccountNotEnabled, ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, PermissionDenied: PermissionDenied, ExchangeNotAvailable: ExchangeNotAvailable, OnMaintenance: OnMaintenance, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, BadSymbol: BadSymbol, BadRequest: BadRequest, RateLimitExceeded: RateLimitExceeded, RequestTimeout: RequestTimeout, NetworkError: NetworkError, InvalidAddress: InvalidAddress, NotSupported: NotSupported } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE, TRUNCATE: TRUNCATE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class huobi extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'huobi',
                        'name': 'Huobi',
                        'countries': [
                            'CN'
                        ],
                        'rateLimit': 100,
                        'userAgent': this.userAgents['chrome100'],
                        'certified': true,
                        'version': 'v1',
                        'accounts': undefined,
                        'accountsById': undefined,
                        'hostname': 'api.huobi.pro',
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': true,
                            'swap': true,
                            'future': true,
                            'option': undefined,
                            'addMargin': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createDepositAddress': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchBidsAsks': undefined,
                            'fetchBorrowInterest': true,
                            'fetchBorrowRate': undefined,
                            'fetchBorrowRateHistories': undefined,
                            'fetchBorrowRateHistory': undefined,
                            'fetchBorrowRates': true,
                            'fetchBorrowRatesPerSymbol': true,
                            'fetchCanceledOrders': undefined,
                            'fetchClosedOrder': undefined,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDeposit': undefined,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': undefined,
                            'fetchDepositAddressesByNetwork': true,
                            'fetchDeposits': true,
                            'fetchFundingFee': undefined,
                            'fetchFundingFees': undefined,
                            'fetchFundingHistory': true,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': true,
                            'fetchFundingRates': true,
                            'fetchIndexOHLCV': true,
                            'fetchL3OrderBook': undefined,
                            'fetchLedger': true,
                            'fetchLedgerEntry': undefined,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': true,
                            'fetchMarketLeverageTiers': true,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': true,
                            'fetchMyBuys': undefined,
                            'fetchMySells': undefined,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': undefined,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': undefined,
                            'fetchOrders': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': true,
                            'fetchPositions': true,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': true,
                            'fetchStatus': undefined,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': false,
                            'fetchTradingLimits': true,
                            'fetchTransactions': undefined,
                            'fetchTransfers': undefined,
                            'fetchWithdrawAddressesByNetwork': true,
                            'fetchWithdrawal': undefined,
                            'fetchWithdrawals': true,
                            'fetchWithdrawalWhitelist': undefined,
                            'reduceMargin': undefined,
                            'setLeverage': true,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'signIn': undefined,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1min',
                            '5m': '5min',
                            '15m': '15min',
                            '30m': '30min',
                            '1h': '60min',
                            '4h': '4hour',
                            '1d': '1day',
                            '1w': '1week',
                            '1M': '1mon',
                            '1y': '1year'
                        },
                        'urls': {
                            // 'test': {
                            //     'market': 'https://api.testnet.huobi.pro',
                            //     'public': 'https://api.testnet.huobi.pro',
                            //     'private': 'https://api.testnet.huobi.pro',
                            // },
                            'logo': 'https://user-images.githubusercontent.com/1294454/76137448-22748a80-604e-11ea-8069-6e389271911d.jpg',
                            'hostnames': {
                                'contract': 'api.hbdm.com',
                                'spot': 'api.huobi.pro'
                            },
                            'api': {
                                'contract': 'https://{hostname}',
                                'spot': 'https://{hostname}',
                                'market': 'https://{hostname}',
                                'public': 'https://{hostname}',
                                'private': 'https://{hostname}',
                                'v2Public': 'https://{hostname}',
                                'v2Private': 'https://{hostname}'
                            },
                            'www': 'https://www.huobi.com',
                            'referral': {
                                'url': 'https://www.huobi.com/en-us/topic/double-reward/?invite_code=6rmm2223',
                                'discount': 0.15
                            },
                            'doc': [
                                'https://huobiapi.github.io/docs/spot/v1/cn/',
                                'https://huobiapi.github.io/docs/dm/v1/cn/',
                                'https://huobiapi.github.io/docs/coin_margined_swap/v1/cn/',
                                'https://huobiapi.github.io/docs/usdt_swap/v1/cn/',
                                'https://huobiapi.github.io/docs/option/v1/cn/'
                            ],
                            'fees': 'https://www.huobi.com/about/fee/'
                        },
                        'api': {
                            // ------------------------------------------------------------
                            // old api definitions
                            'v2Public': {
                                'get': {
                                    'reference/currencies': 1,
                                    'market-status': 1
                                }
                            },
                            'v2Private': {
                                'get': {
                                    'account/ledger': 1,
                                    'account/withdraw/quota': 1,
                                    'account/withdraw/address': 1,
                                    'account/deposit/address': 1,
                                    'account/repayment': 5,
                                    'reference/transact-fee-rate': 1,
                                    'account/asset-valuation': 0.2,
                                    'point/account': 5,
                                    'sub-user/user-list': 1,
                                    'sub-user/user-state': 1,
                                    'sub-user/account-list': 1,
                                    'sub-user/deposit-address': 1,
                                    'sub-user/query-deposit': 1,
                                    'user/api-key': 1,
                                    'user/uid': 1,
                                    'algo-orders/opening': 1,
                                    'algo-orders/history': 1,
                                    'algo-orders/specific': 1,
                                    'c2c/offers': 1,
                                    'c2c/offer': 1,
                                    'c2c/transactions': 1,
                                    'c2c/repayment': 1,
                                    'c2c/account': 1,
                                    'etp/reference': 1,
                                    'etp/transactions': 5,
                                    'etp/transaction': 5,
                                    'etp/rebalance': 1,
                                    'etp/limit': 1
                                },
                                'post': {
                                    'account/transfer': 1,
                                    'account/repayment': 5,
                                    'point/transfer': 5,
                                    'sub-user/management': 1,
                                    'sub-user/creation': 1,
                                    'sub-user/tradable-market': 1,
                                    'sub-user/transferability': 1,
                                    'sub-user/api-key-generation': 1,
                                    'sub-user/api-key-modification': 1,
                                    'sub-user/api-key-deletion': 1,
                                    'sub-user/deduct-mode': 1,
                                    'algo-orders': 1,
                                    'algo-orders/cancel-all-after': 1,
                                    'algo-orders/cancellation': 1,
                                    'c2c/offer': 1,
                                    'c2c/cancellation': 1,
                                    'c2c/cancel-all': 1,
                                    'c2c/repayment': 1,
                                    'c2c/transfer': 1,
                                    'etp/creation': 5,
                                    'etp/redemption': 5,
                                    'etp/{transactId}/cancel': 10,
                                    'etp/batch-cancel': 50
                                }
                            },
                            'market': {
                                'get': {
                                    'history/kline': 1,
                                    'detail/merged': 1,
                                    'depth': 1,
                                    'trade': 1,
                                    'history/trade': 1,
                                    'detail': 1,
                                    'tickers': 1,
                                    'etp': 1
                                }
                            },
                            'public': {
                                'get': {
                                    'common/symbols': 1,
                                    'common/currencys': 1,
                                    'common/timestamp': 1,
                                    'common/exchange': 1,
                                    'settings/currencys': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'account/accounts': 0.2,
                                    'account/accounts/{id}/balance': 0.2,
                                    'account/accounts/{sub-uid}': 1,
                                    'account/history': 4,
                                    'cross-margin/loan-info': 1,
                                    'margin/loan-info': 1,
                                    'fee/fee-rate/get': 1,
                                    'order/openOrders': 0.4,
                                    'order/orders': 0.4,
                                    'order/orders/{id}': 0.4,
                                    'order/orders/{id}/matchresults': 0.4,
                                    'order/orders/getClientOrder': 0.4,
                                    'order/history': 1,
                                    'order/matchresults': 1,
                                    // 'dw/withdraw-virtual/addresses', // 查询虚拟币提现地址（Deprecated）
                                    'query/deposit-withdraw': 1,
                                    // 'margin/loan-info', // duplicate
                                    'margin/loan-orders': 0.2,
                                    'margin/accounts/balance': 0.2,
                                    'cross-margin/loan-orders': 1,
                                    'cross-margin/accounts/balance': 1,
                                    'points/actions': 1,
                                    'points/orders': 1,
                                    'subuser/aggregate-balance': 10,
                                    'stable-coin/exchange_rate': 1,
                                    'stable-coin/quote': 1
                                },
                                'post': {
                                    'account/transfer': 1,
                                    'futures/transfer': 1,
                                    'order/batch-orders': 0.4,
                                    'order/orders/place': 0.2,
                                    'order/orders/submitCancelClientOrder': 0.2,
                                    'order/orders/batchCancelOpenOrders': 0.4,
                                    // 'order/orders', // 创建一个新的订单请求 （仅创建订单，不执行下单）
                                    // 'order/orders/{id}/place', // 执行一个订单 （仅执行已创建的订单）
                                    'order/orders/{id}/submitcancel': 0.2,
                                    'order/orders/batchcancel': 0.4,
                                    // 'dw/balance/transfer', // 资产划转
                                    'dw/withdraw/api/create': 1,
                                    // 'dw/withdraw-virtual/create', // 申请提现虚拟币
                                    // 'dw/withdraw-virtual/{id}/place', // 确认申请虚拟币提现（Deprecated）
                                    'dw/withdraw-virtual/{id}/cancel': 1,
                                    'dw/transfer-in/margin': 10,
                                    'dw/transfer-out/margin': 10,
                                    'margin/orders': 10,
                                    'margin/orders/{id}/repay': 10,
                                    'cross-margin/transfer-in': 1,
                                    'cross-margin/transfer-out': 1,
                                    'cross-margin/orders': 1,
                                    'cross-margin/orders/{id}/repay': 1,
                                    'stable-coin/exchange': 1,
                                    'subuser/transfer': 10
                                }
                            },
                            // ------------------------------------------------------------
                            // new api definitions
                            // 'https://status.huobigroup.com/api/v2/summary.json': 1,
                            // 'https://status-dm.huobigroup.com/api/v2/summary.json': 1,
                            // 'https://status-swap.huobigroup.com/api/v2/summary.json': 1,
                            // 'https://status-linear-swap.huobigroup.com/api/v2/summary.json': 1,
                            'spot': {
                                'public': {
                                    'get': {
                                        'v2/market-status': 1,
                                        'v1/common/symbols': 1,
                                        'v1/common/currencys': 1,
                                        'v2/reference/currencies': 1,
                                        'v1/common/timestamp': 1,
                                        'v1/common/exchange': 1,
                                        // Market Data
                                        'market/history/candles': 1,
                                        'market/history/kline': 1,
                                        'market/detail/merged': 1,
                                        'market/tickers': 1,
                                        'market/depth': 1,
                                        'market/trade': 1,
                                        'market/history/trade': 1,
                                        'market/detail/': 1,
                                        'market/etp': 1,
                                        // ETP
                                        'v2/etp/reference': 1,
                                        'v2/etp/rebalance': 1
                                    }
                                },
                                'private': {
                                    'get': {
                                        // Account
                                        'v1/account/accounts': 0.2,
                                        'v1/account/accounts/{account-id}/balance': 0.2,
                                        'v2/account/valuation': 1,
                                        'v2/account/asset-valuation': 0.2,
                                        'v1/account/history': 4,
                                        'v2/account/ledger': 1,
                                        'v2/point/account': 5,
                                        // Wallet (Deposit and Withdraw)
                                        'v2/account/deposit/address': 1,
                                        'v2/account/withdraw/quota': 1,
                                        'v2/account/withdraw/address': 1,
                                        'v2/reference/currencies': 1,
                                        'v1/query/deposit-withdraw': 1,
                                        // Sub user management
                                        'v2/user/api-key': 1,
                                        'v2/user/uid': 1,
                                        'v2/sub-user/user-list': 1,
                                        'v2/sub-user/user-state': 1,
                                        'v2/sub-user/account-list': 1,
                                        'v2/sub-user/deposit-address': 1,
                                        'v2/sub-user/query-deposit': 1,
                                        'v1/subuser/aggregate-balance': 10,
                                        'v1/account/accounts/{sub-uid}': 1,
                                        // Trading
                                        'v1/order/openOrders': 0.4,
                                        'v1/order/orders/{order-id}': 0.4,
                                        'v1/order/orders/getClientOrder': 0.4,
                                        'v1/order/orders/{order-id}/matchresults': 0.4,
                                        'v1/order/orders': 0.4,
                                        'v1/order/history': 1,
                                        'v1/order/matchresults': 1,
                                        'v2/reference/transact-fee-rate': 1,
                                        // Conditional Order
                                        'v2/algo-orders/opening': 1,
                                        'v2/algo-orders/history': 1,
                                        'v2/algo-orders/specific': 1,
                                        // Margin Loan (Cross/Isolated)
                                        'v1/margin/loan-info': 1,
                                        'v1/margin/loan-orders': 0.2,
                                        'v1/margin/accounts/balance': 0.2,
                                        'v1/cross-margin/loan-info': 1,
                                        'v1/cross-margin/loan-orders': 1,
                                        'v1/cross-margin/accounts/balance': 1,
                                        'v2/account/repayment': 5,
                                        // Stable Coin Exchange
                                        'v1/stable-coin/quote': 1,
                                        // ETP
                                        'v2/etp/transactions': 5,
                                        'v2/etp/transaction': 5,
                                        'v2/etp/limit': 1
                                    },
                                    'post': {
                                        // Account
                                        'v1/account/transfer': 1,
                                        'v1/futures/transfer': 1,
                                        'v2/point/transfer': 5,
                                        'v2/account/transfer': 1,
                                        // Wallet (Deposit and Withdraw)
                                        'v1/dw/withdraw/api/create': 1,
                                        'v1/dw/withdraw-virtual/{withdraw-id}/cancel': 1,
                                        // Sub user management
                                        'v2/sub-user/deduct-mode': 1,
                                        'v2/sub-user/creation': 1,
                                        'v2/sub-user/management': 1,
                                        'v2/sub-user/tradable-market': 1,
                                        'v2/sub-user/transferability': 1,
                                        'v2/sub-user/api-key-generation': 1,
                                        'v2/sub-user/api-key-modification': 1,
                                        'v2/sub-user/api-key-deletion': 1,
                                        'v1/subuser/transfer': 10,
                                        // Trading
                                        'v1/order/orders/place': 0.2,
                                        'v1/order/batch-orders': 0.4,
                                        'v1/order/orders/{order-id}/submitcancel': 0.2,
                                        'v1/order/orders/submitCancelClientOrder': 0.2,
                                        'v1/order/orders/batchCancelOpenOrders': 0.4,
                                        'v1/order/orders/batchcancel': 0.4,
                                        'v2/algo-orders/cancel-all-after': 1,
                                        // Conditional Order
                                        'v2/algo-orders': 1,
                                        'v2/algo-orders/cancellation': 1,
                                        // Margin Loan (Cross/Isolated)
                                        'v2/account/repayment': 5,
                                        'v1/dw/transfer-in/margin': 10,
                                        'v1/dw/transfer-out/margin': 10,
                                        'v1/margin/orders': 10,
                                        'v1/margin/orders/{order-id}/repay': 10,
                                        'v1/cross-margin/transfer-in': 1,
                                        'v1/cross-margin/transfer-out': 1,
                                        'v1/cross-margin/orders': 1,
                                        'v1/cross-margin/orders/{order-id}/repay': 1,
                                        // Stable Coin Exchange
                                        'v1/stable-coin/exchange': 1,
                                        // ETP
                                        'v2/etp/creation': 5,
                                        'v2/etp/redemption': 5,
                                        'v2/etp/{transactId}/cancel': 10,
                                        'v2/etp/batch-cancel': 50
                                    }
                                }
                            },
                            'contract': {
                                'public': {
                                    'get': {
                                        'api/v1/timestamp': 1,
                                        // Future Market Data interface
                                        'api/v1/contract_contract_info': 1,
                                        'api/v1/contract_index': 1,
                                        'api/v1/contract_price_limit': 1,
                                        'api/v1/contract_open_interest': 1,
                                        'api/v1/contract_delivery_price': 1,
                                        'market/depth': 1,
                                        'market/bbo': 1,
                                        'market/history/kline': 1,
                                        'index/market/history/mark_price_kline': 1,
                                        'market/detail/merged': 1,
                                        'market/detail/batch_merged': 1,
                                        'market/trade': 1,
                                        'market/history/trade': 1,
                                        'api/v1/contract_risk_info': 1,
                                        'api/v1/contract_insurance_fund': 1,
                                        'api/v1/contract_adjustfactor': 1,
                                        'api/v1/contract_his_open_interest': 1,
                                        'api/v1/contract_ladder_margin': 1,
                                        'api/v1/contract_api_state': 1,
                                        'api/v1/contract_elite_account_ratio': 1,
                                        'api/v1/contract_elite_position_ratio': 1,
                                        'api/v1/contract_liquidation_orders': 1,
                                        'api/v1/contract_settlement_records': 1,
                                        'index/market/history/index': 1,
                                        'index/market/history/basis': 1,
                                        'api/v1/contract_estimated_settlement_price': 1,
                                        // Swap Market Data interface
                                        'swap-api/v1/swap_contract_info': 1,
                                        'swap-api/v1/swap_index': 1,
                                        'swap-api/v1/swap_price_limit': 1,
                                        'swap-api/v1/swap_open_interest': 1,
                                        'swap-ex/market/depth': 1,
                                        'swap-ex/market/bbo': 1,
                                        'swap-ex/market/history/kline': 1,
                                        'index/market/history/swap_mark_price_kline': 1,
                                        'swap-ex/market/detail/merged': 1,
                                        'swap-ex/market/detail/batch_merged': 1,
                                        'swap-ex/market/trade': 1,
                                        'swap-ex/market/history/trade': 1,
                                        'swap-api/v1/swap_risk_info': 1,
                                        'swap-api/v1/swap_insurance_fund': 1,
                                        'swap-api/v1/swap_adjustfactor': 1,
                                        'swap-api/v1/swap_his_open_interest': 1,
                                        'swap-api/v1/swap_ladder_margin': 1,
                                        'swap-api/v1/swap_api_state': 1,
                                        'swap-api/v1/swap_elite_account_ratio': 1,
                                        'swap-api/v1/swap_elite_position_ratio': 1,
                                        'swap-api/v1/swap_estimated_settlement_price': 1,
                                        'swap-api/v1/swap_liquidation_orders': 1,
                                        'swap-api/v1/swap_settlement_records': 1,
                                        'swap-api/v1/swap_funding_rate': 1,
                                        'swap-api/v1/swap_batch_funding_rate': 1,
                                        'swap-api/v1/swap_historical_funding_rate': 1,
                                        'index/market/history/swap_premium_index_kline': 1,
                                        'index/market/history/swap_estimated_rate_kline': 1,
                                        'index/market/history/swap_basis': 1,
                                        // Swap Market Data interface
                                        'linear-swap-api/v1/swap_contract_info': 1,
                                        'linear-swap-api/v1/swap_index': 1,
                                        'linear-swap-api/v1/swap_price_limit': 1,
                                        'linear-swap-api/v1/swap_open_interest': 1,
                                        'linear-swap-ex/market/depth': 1,
                                        'linear-swap-ex/market/bbo': 1,
                                        'linear-swap-ex/market/history/kline': 1,
                                        'index/market/history/linear_swap_mark_price_kline': 1,
                                        'linear-swap-ex/market/detail/merged': 1,
                                        'linear-swap-ex/market/detail/batch_merged': 1,
                                        'linear-swap-ex/market/trade': 1,
                                        'linear-swap-ex/market/history/trade': 1,
                                        'linear-swap-api/v1/swap_risk_info': 1,
                                        'swap-api/v1/linear-swap-api/v1/swap_insurance_fund': 1,
                                        'linear-swap-api/v1/swap_adjustfactor': 1,
                                        'linear-swap-api/v1/swap_cross_adjustfactor': 1,
                                        'linear-swap-api/v1/swap_his_open_interest': 1,
                                        'linear-swap-api/v1/swap_ladder_margin': 1,
                                        'linear-swap-api/v1/swap_cross_ladder_margin': 1,
                                        'linear-swap-api/v1/swap_api_state': 1,
                                        'linear-swap-api/v1/swap_cross_transfer_state': 1,
                                        'linear-swap-api/v1/swap_cross_trade_state': 1,
                                        'linear-swap-api/v1/swap_elite_account_ratio': 1,
                                        'linear-swap-api/v1/swap_elite_position_ratio': 1,
                                        'linear-swap-api/v1/swap_liquidation_orders': 1,
                                        'linear-swap-api/v1/swap_settlement_records': 1,
                                        'linear-swap-api/v1/swap_funding_rate': 1,
                                        'linear-swap-api/v1/swap_batch_funding_rate': 1,
                                        'linear-swap-api/v1/swap_historical_funding_rate': 1,
                                        'index/market/history/linear_swap_premium_index_kline': 1,
                                        'index/market/history/linear_swap_estimated_rate_kline': 1,
                                        'index/market/history/linear_swap_basis': 1,
                                        'linear-swap-api/v1/swap_estimated_settlement_price': 1
                                    }
                                },
                                'private': {
                                    'get': {
                                        // Future Account Interface
                                        'api/v1/contract_api_trading_status': 1,
                                        // Swap Account Interface
                                        'swap-api/v1/swap_api_trading_status': 1,
                                        // Swap Account Interface
                                        'linear-swap-api/v1/swap_api_trading_status': 1
                                    },
                                    'post': {
                                        // Future Account Interface
                                        'api/v1/contract_balance_valuation': 1,
                                        'api/v1/contract_account_info': 1,
                                        'api/v1/contract_position_info': 1,
                                        'api/v1/contract_sub_auth': 1,
                                        'api/v1/contract_sub_account_list': 1,
                                        'api/v1/contract_sub_account_info_list': 1,
                                        'api/v1/contract_sub_account_info': 1,
                                        'api/v1/contract_sub_position_info': 1,
                                        'api/v1/contract_financial_record': 1,
                                        'api/v1/contract_financial_record_exact': 1,
                                        'api/v1/contract_user_settlement_records': 1,
                                        'api/v1/contract_order_limit': 1,
                                        'api/v1/contract_fee': 1,
                                        'api/v1/contract_transfer_limit': 1,
                                        'api/v1/contract_position_limit': 1,
                                        'api/v1/contract_account_position_info': 1,
                                        'api/v1/contract_master_sub_transfer': 1,
                                        'api/v1/contract_master_sub_transfer_record': 1,
                                        'api/v1/contract_available_level_rate': 1,
                                        // Future Trade Interface
                                        'api/v1/contract_order': 1,
                                        'v1/contract_batchorder': 1,
                                        'api/v1/contract_cancel': 1,
                                        'api/v1/contract_cancelall': 1,
                                        'api/v1/contract_switch_lever_rate': 1,
                                        'api/v1/lightning_close_position': 1,
                                        'api/v1/contract_order_info': 1,
                                        'api/v1/contract_order_detail': 1,
                                        'api/v1/contract_openorders': 1,
                                        'api/v1/contract_hisorders': 1,
                                        'api/v1/contract_hisorders_exact': 1,
                                        'api/v1/contract_matchresults': 1,
                                        'api/v1/contract_matchresults_exact': 1,
                                        // Contract Strategy Order Interface
                                        'api/v1/contract_trigger_order': 1,
                                        'api/v1/contract_trigger_cancel': 1,
                                        'api/v1/contract_trigger_cancelall': 1,
                                        'api/v1/contract_trigger_openorders': 1,
                                        'api/v1/contract_trigger_hisorders': 1,
                                        'api/v1/contract_tpsl_order': 1,
                                        'api/v1/contract_tpsl_cancel': 1,
                                        'api/v1/contract_tpsl_cancelall': 1,
                                        'api/v1/contract_tpsl_openorders': 1,
                                        'api/v1/contract_tpsl_hisorders': 1,
                                        'api/v1/contract_relation_tpsl_order': 1,
                                        'api/v1/contract_track_order': 1,
                                        'api/v1/contract_track_cancel': 1,
                                        'api/v1/contract_track_cancelall': 1,
                                        'api/v1/contract_track_openorders': 1,
                                        'api/v1/contract_track_hisorders': 1,
                                        // Swap Account Interface
                                        'swap-api/v1/swap_balance_valuation': 1,
                                        'swap-api/v1/swap_account_info': 1,
                                        'swap-api/v1/swap_position_info': 1,
                                        'swap-api/v1/swap_account_position_info': 1,
                                        'swap-api/v1/swap_sub_auth': 1,
                                        'swap-api/v1/swap_sub_account_list': 1,
                                        'swap-api/v1/swap_sub_account_info_list': 1,
                                        'swap-api/v1/swap_sub_account_info': 1,
                                        'swap-api/v1/swap_sub_position_info': 1,
                                        'swap-api/v1/swap_financial_record': 1,
                                        'swap-api/v1/swap_financial_record_exact': 1,
                                        'swap-api/v1/swap_user_settlement_records': 1,
                                        'swap-api/v1/swap_available_level_rate': 1,
                                        'swap-api/v1/swap_order_limit': 1,
                                        'swap-api/v1/swap_fee': 1,
                                        'swap-api/v1/swap_transfer_limit': 1,
                                        'swap-api/v1/swap_position_limit': 1,
                                        'swap-api/v1/swap_master_sub_transfer': 1,
                                        'swap-api/v1/swap_master_sub_transfer_record': 1,
                                        // Swap Trade Interface
                                        'swap-api/v1/swap_order': 1,
                                        'swap-api/v1/swap_batchorder': 1,
                                        'swap-api/v1/swap_cancel': 1,
                                        'swap-api/v1/swap_cancelall': 1,
                                        'swap-api/v1/swap_lightning_close_position': 1,
                                        'swap-api/v1/swap_switch_lever_rate': 1,
                                        'swap-api/v1/swap_order_info': 1,
                                        'swap-api/v1/swap_order_detail': 1,
                                        'swap-api/v1/swap_openorders': 1,
                                        'swap-api/v1/swap_hisorders': 1,
                                        'swap-api/v1/swap_hisorders_exact': 1,
                                        'swap-api/v1/swap_matchresults': 1,
                                        'swap-api/v1/swap_matchresults_exact': 1,
                                        // Swap Strategy Order Interface
                                        'swap-api/v1/swap_trigger_order': 1,
                                        'swap-api/v1/swap_trigger_cancel': 1,
                                        'swap-api/v1/swap_trigger_cancelall': 1,
                                        'swap-api/v1/swap_trigger_openorders': 1,
                                        'swap-api/v1/swap_trigger_hisorders': 1,
                                        'swap-api/v1/swap_tpsl_order': 1,
                                        'swap-api/v1/swap_tpsl_cancel': 1,
                                        'swap-api/v1/swap_tpsl_cancelall': 1,
                                        'swap-api/v1/swap_tpsl_openorders': 1,
                                        'swap-api/v1/swap_tpsl_hisorders': 1,
                                        'swap-api/v1/swap_relation_tpsl_order': 1,
                                        'swap-api/v1/swap_track_order': 1,
                                        'swap-api/v1/swap_track_cancel': 1,
                                        'swap-api/v1/swap_track_cancelall': 1,
                                        'swap-api/v1/swap_track_openorders': 1,
                                        'swap-api/v1/swap_track_hisorders': 1,
                                        // Swap Account Interface
                                        'linear-swap-api/v1/swap_lever_position_limit': 1,
                                        'linear-swap-api/v1/swap_cross_lever_position_limit': 1,
                                        'linear-swap-api/v1/swap_balance_valuation': 1,
                                        'linear-swap-api/v1/swap_account_info': 1,
                                        'linear-swap-api/v1/swap_cross_account_info': 1,
                                        'linear-swap-api/v1/swap_position_info': 1,
                                        'linear-swap-api/v1/swap_cross_position_info': 1,
                                        'linear-swap-api/v1/swap_account_position_info': 1,
                                        'linear-swap-api/v1/swap_cross_account_position_info': 1,
                                        'linear-swap-api/v1/swap_sub_auth': 1,
                                        'linear-swap-api/v1/swap_sub_account_list': 1,
                                        'linear-swap-api/v1/swap_cross_sub_account_list': 1,
                                        'linear-swap-api/v1/swap_sub_account_info_list': 1,
                                        'linear-swap-api/v1/swap_cross_sub_account_info_list': 1,
                                        'linear-swap-api/v1/swap_sub_account_info': 1,
                                        'linear-swap-api/v1/swap_cross_sub_account_info': 1,
                                        'linear-swap-api/v1/swap_sub_position_info': 1,
                                        'linear-swap-api/v1/swap_cross_sub_position_info': 1,
                                        'linear-swap-api/v1/swap_financial_record': 1,
                                        'linear-swap-api/v1/swap_financial_record_exact': 1,
                                        'linear-swap-api/v1/swap_user_settlement_records': 1,
                                        'linear-swap-api/v1/swap_cross_user_settlement_records': 1,
                                        'linear-swap-api/v1/swap_available_level_rate': 1,
                                        'linear-swap-api/v1/swap_cross_available_level_rate': 1,
                                        'linear-swap-api/v1/swap_order_limit': 1,
                                        'linear-swap-api/v1/swap_fee': 1,
                                        'linear-swap-api/v1/swap_transfer_limit': 1,
                                        'linear-swap-api/v1/swap_cross_transfer_limit': 1,
                                        'linear-swap-api/v1/swap_position_limit': 1,
                                        'linear-swap-api/v1/swap_cross_position_limit': 1,
                                        'linear-swap-api/v1/swap_master_sub_transfer': 1,
                                        'linear-swap-api/v1/swap_master_sub_transfer_record': 1,
                                        'linear-swap-api/v1/swap_transfer_inner': 1,
                                        // Swap Trade Interface
                                        'linear-swap-api/v1/swap_order': 1,
                                        'linear-swap-api/v1/swap_cross_order': 1,
                                        'linear-swap-api/v1/swap_batchorder': 1,
                                        'linear-swap-api/v1/swap_cross_batchorder': 1,
                                        'linear-swap-api/v1/swap_cancel': 1,
                                        'linear-swap-api/v1/swap_cross_cancel': 1,
                                        'linear-swap-api/v1/swap_cancelall': 1,
                                        'linear-swap-api/v1/swap_cross_cancelall': 1,
                                        'linear-swap-api/v1/swap_switch_lever_rate': 1,
                                        'linear-swap-api/v1/swap_cross_switch_lever_rate': 1,
                                        'linear-swap-api/v1/swap_lightning_close_position': 1,
                                        'linear-swap-api/v1/swap_cross_lightning_close_position': 1,
                                        'linear-swap-api/v1/swap_order_info': 1,
                                        'linear-swap-api/v1/swap_cross_order_info': 1,
                                        'linear-swap-api/v1/swap_order_detail': 1,
                                        'linear-swap-api/v1/swap_cross_order_detail': 1,
                                        'linear-swap-api/v1/swap_openorders': 1,
                                        'linear-swap-api/v1/swap_cross_openorders': 1,
                                        'linear-swap-api/v1/swap_hisorders': 1,
                                        'linear-swap-api/v1/swap_cross_hisorders': 1,
                                        'linear-swap-api/v1/swap_hisorders_exact': 1,
                                        'linear-swap-api/v1/swap_cross_hisorders_exact': 1,
                                        'linear-swap-api/v1/swap_matchresults': 1,
                                        'linear-swap-api/v1/swap_cross_matchresults': 1,
                                        'linear-swap-api/v1/swap_matchresults_exact': 1,
                                        'linear-swap-api/v1/swap_cross_matchresults_exact': 1,
                                        'linear-swap-api/v1/swap_switch_position_mode': 1,
                                        'linear-swap-api/v1/swap_cross_switch_position_mode': 1,
                                        // Swap Strategy Order Interface
                                        'linear-swap-api/v1/swap_trigger_order': 1,
                                        'linear-swap-api/v1/swap_cross_trigger_order': 1,
                                        'linear-swap-api/v1/swap_trigger_cancel': 1,
                                        'linear-swap-api/v1/swap_cross_trigger_cancel': 1,
                                        'linear-swap-api/v1/swap_trigger_cancelall': 1,
                                        'linear-swap-api/v1/swap_cross_trigger_cancelall': 1,
                                        'linear-swap-api/v1/swap_trigger_openorders': 1,
                                        'linear-swap-api/v1/swap_cross_trigger_openorders': 1,
                                        'linear-swap-api/v1/swap_trigger_hisorders': 1,
                                        'linear-swap-api/v1/swap_cross_trigger_hisorders': 1,
                                        'linear-swap-api/v1/swap_tpsl_order': 1,
                                        'linear-swap-api/v1/swap_cross_tpsl_order': 1,
                                        'linear-swap-api/v1/swap_tpsl_cancel': 1,
                                        'linear-swap-api/v1/swap_cross_tpsl_cancel': 1,
                                        'linear-swap-api/v1/swap_tpsl_cancelall': 1,
                                        'linear-swap-api/v1/swap_cross_tpsl_cancelall': 1,
                                        'linear-swap-api/v1/swap_tpsl_openorders': 1,
                                        'linear-swap-api/v1/swap_cross_tpsl_openorders': 1,
                                        'linear-swap-api/v1/swap_tpsl_hisorders': 1,
                                        'linear-swap-api/v1/swap_cross_tpsl_hisorders': 1,
                                        'linear-swap-api/v1/swap_relation_tpsl_order': 1,
                                        'linear-swap-api/v1/swap_cross_relation_tpsl_order': 1,
                                        'linear-swap-api/v1/swap_track_order': 1,
                                        'linear-swap-api/v1/swap_cross_track_order': 1,
                                        'linear-swap-api/v1/swap_track_cancel': 1,
                                        'linear-swap-api/v1/swap_cross_track_cancel': 1,
                                        'linear-swap-api/v1/swap_track_cancelall': 1,
                                        'linear-swap-api/v1/swap_cross_track_cancelall': 1,
                                        'linear-swap-api/v1/swap_track_openorders': 1,
                                        'linear-swap-api/v1/swap_cross_track_openorders': 1,
                                        'linear-swap-api/v1/swap_track_hisorders': 1,
                                        'linear-swap-api/v1/swap_cross_track_hisorders': 1
                                    }
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.002'),
                                'taker': this.parseNumber('0.002')
                            }
                        },
                        'exceptions': {
                            'broad': {
                                'contract is restricted of closing positions on API.  Please contact customer service': OnMaintenance,
                                'maintain': OnMaintenance
                            },
                            'exact': {
                                // err-code
                                '1010': AccountNotEnabled,
                                '1017': OrderNotFound,
                                '1034': InvalidOrder,
                                '1036': InvalidOrder,
                                '1039': InvalidOrder,
                                '1041': InvalidOrder,
                                '1047': InsufficientFunds,
                                '1066': BadSymbol,
                                '1067': InvalidOrder,
                                '1013': BadSymbol,
                                '1094': InvalidOrder,
                                '1220': AccountNotEnabled,
                                'bad-request': BadRequest,
                                'validation-format-error': BadRequest,
                                'validation-constraints-required': BadRequest,
                                'base-date-limit-error': BadRequest,
                                'api-not-support-temp-addr': PermissionDenied,
                                'timeout': RequestTimeout,
                                'gateway-internal-error': ExchangeNotAvailable,
                                'account-frozen-balance-insufficient-error': InsufficientFunds,
                                'invalid-amount': InvalidOrder,
                                'order-limitorder-amount-min-error': InvalidOrder,
                                'order-limitorder-amount-max-error': InvalidOrder,
                                'order-marketorder-amount-min-error': InvalidOrder,
                                'order-limitorder-price-min-error': InvalidOrder,
                                'order-limitorder-price-max-error': InvalidOrder,
                                'order-invalid-price': InvalidOrder,
                                'order-holding-limit-failed': InvalidOrder,
                                'order-orderprice-precision-error': InvalidOrder,
                                'order-etp-nav-price-max-error': InvalidOrder,
                                'order-orderstate-error': OrderNotFound,
                                'order-queryorder-invalid': OrderNotFound,
                                'order-update-error': ExchangeNotAvailable,
                                'api-signature-check-failed': AuthenticationError,
                                'api-signature-not-valid': AuthenticationError,
                                'base-record-invalid': OrderNotFound,
                                'base-symbol-trade-disabled': BadSymbol,
                                'base-symbol-error': BadSymbol,
                                'system-maintenance': OnMaintenance,
                                'base-request-exceed-frequency-limit': RateLimitExceeded,
                                // err-msg
                                'invalid symbol': BadSymbol,
                                'symbol trade not open now': BadSymbol,
                                'require-symbol': BadSymbol,
                                'invalid-address': BadRequest,
                                'base-currency-chain-error': BadRequest,
                                'dw-insufficient-balance': InsufficientFunds
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'options': {
                            'fetchMarkets': {
                                'types': {
                                    'spot': true,
                                    'future': {
                                        'linear': true,
                                        'inverse': true
                                    },
                                    'swap': {
                                        'linear': true,
                                        'inverse': true
                                    }
                                }
                            },
                            'defaultType': 'spot',
                            'defaultSubType': 'inverse',
                            'defaultNetwork': 'ERC20',
                            'networks': {
                                'ETH': 'erc20',
                                'TRX': 'trc20',
                                'HRC20': 'hrc20',
                                'HECO': 'hrc20',
                                'HT': 'hrc20',
                                'ALGO': 'algo',
                                'OMNI': ''
                            },
                            // https://github.com/ccxt/ccxt/issues/5376
                            'fetchOrdersByStatesMethod': 'spot_private_get_v1_order_orders',
                            'createMarketBuyOrderRequiresPrice': true,
                            'language': 'en-US',
                            'broker': {
                                'id': 'AA03022abc'
                            },
                            'accountsByType': {
                                'spot': 'pro',
                                'funding': 'pro',
                                'future': 'futures'
                            },
                            'typesByAccount': {
                                'pro': 'spot',
                                'futures': 'future'
                            },
                            'spot': {
                                'stopOrderTypes': {
                                    'stop-limit': true,
                                    'buy-stop-limit': true,
                                    'sell-stop-limit': true,
                                    'stop-limit-fok': true,
                                    'buy-stop-limit-fok': true,
                                    'sell-stop-limit-fok': true
                                },
                                'limitOrderTypes': {
                                    'limit': true,
                                    'buy-limit': true,
                                    'sell-limit': true,
                                    'ioc': true,
                                    'buy-ioc': true,
                                    'sell-ioc': true,
                                    'limit-maker': true,
                                    'buy-limit-maker': true,
                                    'sell-limit-maker': true,
                                    'stop-limit': true,
                                    'buy-stop-limit': true,
                                    'sell-stop-limit': true,
                                    'limit-fok': true,
                                    'buy-limit-fok': true,
                                    'sell-limit-fok': true,
                                    'stop-limit-fok': true,
                                    'buy-stop-limit-fok': true,
                                    'sell-stop-limit-fok': true
                                }
                            }
                        },
                        'commonCurrencies': {
                            // https://github.com/ccxt/ccxt/issues/6081
                            // https://github.com/ccxt/ccxt/issues/3365
                            // https://github.com/ccxt/ccxt/issues/2873
                            'GET': 'Themis',
                            'GTC': 'Game.com',
                            'HIT': 'HitChain',
                            'HOT': 'Hydro Protocol',
                            // https://github.com/ccxt/ccxt/issues/7399
                            // https://coinmarketcap.com/currencies/pnetwork/
                            // https://coinmarketcap.com/currencies/penta/markets/
                            // https://en.cryptonomist.ch/blog/eidoo/the-edo-to-pnt-upgrade-what-you-need-to-know-updated/
                            'PNT': 'Penta',
                            'SBTC': 'Super Bitcoin',
                            'BIFI': 'Bitcoin File'
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const options = this.safeValue(this.options, 'fetchTime', {});
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    let type = this.safeString(options, 'type', defaultType);
                    type = this.safeString(params, 'type', type);
                    let method = 'spotPublicGetV1CommonTimestamp';
                    if (type === 'future' || type === 'swap') method = 'contractPublicGetApiV1Timestamp';
                    const response = await this[method](params);
                    //
                    // spot
                    //
                    //     {"status":"ok","data":1637504261099}
                    //
                    // future, swap
                    //
                    //     {"status":"ok","ts":1637504164707}
                    //
                    return this.safeInteger2(response, 'data', 'ts');
                }
                parseTradingFee(fee, market) {
                    //
                    //     {
                    //         "symbol":"btcusdt",
                    //         "actualMakerRate":"0.002",
                    //         "actualTakerRate":"0.002",
                    //         "takerFeeRate":"0.002",
                    //         "makerFeeRate":"0.002"
                    //     }
                    //
                    const marketId = this.safeString(fee, 'symbol');
                    return {
                        'info': fee,
                        'symbol': this.safeSymbol(marketId, market),
                        'maker': this.safeNumber(fee, 'actualMakerRate'),
                        'taker': this.safeNumber(fee, 'actualTakerRate')
                    };
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbols': market['id']
                    };
                    const response = await this.spotPrivateGetV2ReferenceTransactFeeRate(this.extend(request, params));
                    //
                    //     {
                    //         "code":200,
                    //         "data":[
                    //             {
                    //                 "symbol":"btcusdt",
                    //                 "actualMakerRate":"0.002",
                    //                 "actualTakerRate":"0.002",
                    //                 "takerFeeRate":"0.002",
                    //                 "makerFeeRate":"0.002"
                    //             }
                    //         ],
                    //         "success":true
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const first = this.safeValue(data, 0, {});
                    return this.parseTradingFee(first, market);
                }
                async fetchTradingLimits(symbols, params = {}) {
                    // this method should not be called directly, use loadTradingLimits () instead
                    //  by default it will try load withdrawal fees of all currencies (with separate requests)
                    //  however if you define symbols = [ 'ETH/BTC', 'LTC/BTC' ] in args it will only load those
                    await this.loadMarkets();
                    if (symbols === undefined) symbols = this.symbols;
                    const result = {};
                    for(let i = 0; i < symbols.length; i++){
                        const symbol = symbols[i];
                        result[symbol] = await this.fetchTradingLimitsById(this.marketId(symbol), params);
                    }
                    return result;
                }
                async fetchTradingLimitsById(id, params = {}) {
                    const request = {
                        'symbol': id
                    };
                    const response = await this.spotPublicGetV1CommonExchange(this.extend(request, params));
                    //
                    //     { status:   "ok",
                    //         data: {                                  symbol: "aidocbtc",
                    //                              'buy-limit-must-less-than':  1.1,
                    //                          'sell-limit-must-greater-than':  0.9,
                    //                         'limit-order-must-greater-than':  1,
                    //                            'limit-order-must-less-than':  5000000,
                    //                    'market-buy-order-must-greater-than':  0.0001,
                    //                       'market-buy-order-must-less-than':  100,
                    //                   'market-sell-order-must-greater-than':  1,
                    //                      'market-sell-order-must-less-than':  500000,
                    //                       'circuit-break-when-greater-than':  10000,
                    //                          'circuit-break-when-less-than':  10,
                    //                 'market-sell-order-rate-must-less-than':  0.1,
                    //                  'market-buy-order-rate-must-less-than':  0.1        } }
                    //
                    return this.parseTradingLimits(this.safeValue(response, 'data', {}));
                }
                parseTradingLimits(limits, symbol, params = {}) {
                    //
                    //   {                                  symbol: "aidocbtc",
                    //                  'buy-limit-must-less-than':  1.1,
                    //              'sell-limit-must-greater-than':  0.9,
                    //             'limit-order-must-greater-than':  1,
                    //                'limit-order-must-less-than':  5000000,
                    //        'market-buy-order-must-greater-than':  0.0001,
                    //           'market-buy-order-must-less-than':  100,
                    //       'market-sell-order-must-greater-than':  1,
                    //          'market-sell-order-must-less-than':  500000,
                    //           'circuit-break-when-greater-than':  10000,
                    //              'circuit-break-when-less-than':  10,
                    //     'market-sell-order-rate-must-less-than':  0.1,
                    //      'market-buy-order-rate-must-less-than':  0.1        }
                    //
                    return {
                        'info': limits,
                        'limits': {
                            'amount': {
                                'min': this.safeNumber(limits, 'limit-order-must-greater-than'),
                                'max': this.safeNumber(limits, 'limit-order-must-less-than')
                            }
                        }
                    };
                }
                costToPrecision(symbol, cost) {
                    return this.decimalToPrecision(cost, TRUNCATE, this.markets[symbol]['precision']['cost'], this.precisionMode);
                }
                async fetchMarkets(params = {}) {
                    const options = this.safeValue(this.options, 'fetchMarkets', {});
                    const types = this.safeValue(options, 'types', {});
                    let allMarkets = [];
                    let promises = [];
                    const keys = Object.keys(types);
                    for(let i = 0; i < keys.length; i++){
                        const type = keys[i];
                        const value = this.safeValue(types, type);
                        if (value === true) promises.push(this.fetchMarketsByTypeAndSubType(type, undefined, params));
                        else {
                            const subKeys = Object.keys(value);
                            for(let j = 0; j < subKeys.length; j++){
                                const subType = subKeys[j];
                                const subValue = this.safeValue(value, subType);
                                if (subValue) promises.push(this.fetchMarketsByTypeAndSubType(type, subType, params));
                            }
                        }
                    }
                    promises = await Promise.all(promises);
                    for(let i = 0; i < promises.length; i++)allMarkets = this.arrayConcat(allMarkets, promises[i]);
                    return allMarkets;
                }
                async fetchMarketsByTypeAndSubType(type, subType, params = {}) {
                    let method = 'spotPublicGetV1CommonSymbols';
                    const query = this.omit(params, [
                        'type',
                        'subType'
                    ]);
                    const spot = type === 'spot';
                    const contract = type !== 'spot';
                    const future = type === 'future';
                    const swap = type === 'swap';
                    let linear = undefined;
                    let inverse = undefined;
                    const request = {};
                    if (contract) {
                        linear = subType === 'linear';
                        inverse = subType === 'inverse';
                        if (linear) {
                            method = 'contractPublicGetLinearSwapApiV1SwapContractInfo';
                            if (future) request['business_type'] = 'futures';
                        } else if (inverse) {
                            if (future) method = 'contractPublicGetApiV1ContractContractInfo';
                            else if (swap) method = 'contractPublicGetSwapApiV1SwapContractInfo';
                        }
                    }
                    const response = await this[method](this.extend(request, query));
                    //
                    // spot
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "base-currency":"xrp3s",
                    //                 "quote-currency":"usdt",
                    //                 "price-precision":4,
                    //                 "amount-precision":4,
                    //                 "symbol-partition":"innovation",
                    //                 "symbol":"xrp3susdt",
                    //                 "state":"online",
                    //                 "value-precision":8,
                    //                 "min-order-amt":0.01,
                    //                 "max-order-amt":1616.4353,
                    //                 "min-order-value":5,
                    //                 "limit-order-min-order-amt":0.01,
                    //                 "limit-order-max-order-amt":1616.4353,
                    //                 "limit-order-max-buy-amt":1616.4353,
                    //                 "limit-order-max-sell-amt":1616.4353,
                    //                 "sell-market-min-order-amt":0.01,
                    //                 "sell-market-max-order-amt":1616.4353,
                    //                 "buy-market-max-order-value":2500,
                    //                 "max-order-value":2500,
                    //                 "underlying":"xrpusdt",
                    //                 "mgmt-fee-rate":0.035000000000000000,
                    //                 "charge-time":"23:55:00",
                    //                 "rebal-time":"00:00:00",
                    //                 "rebal-threshold":-5,
                    //                 "init-nav":10.000000000000000000,
                    //                 "api-trading":"enabled",
                    //                 "tags":"etp,nav,holdinglimit"
                    //             },
                    //         ]
                    //     }
                    //
                    // inverse future
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "symbol":"BTC",
                    //                 "contract_code":"BTC211126",
                    //                 "contract_type":"this_week",
                    //                 "contract_size":100.000000000000000000,
                    //                 "price_tick":0.010000000000000000,
                    //                 "delivery_date":"20211126",
                    //                 "delivery_time":"1637913600000",
                    //                 "create_date":"20211112",
                    //                 "contract_status":1,
                    //                 "settlement_time":"1637481600000"
                    //             },
                    //         ],
                    //         "ts":1637474595140
                    //     }
                    //
                    // linear futures
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "symbol":"BTC",
                    //                 "contract_code":"BTC-USDT-211231",
                    //                 "contract_size":0.001000000000000000,
                    //                 "price_tick":0.100000000000000000,
                    //                 "delivery_date":"20211231",
                    //                 "delivery_time":"1640937600000",
                    //                 "create_date":"20211228",
                    //                 "contract_status":1,
                    //                 "settlement_date":"1640764800000",
                    //                 "support_margin_mode":"cross",
                    //                 "business_type":"futures",
                    //                 "pair":"BTC-USDT",
                    //                 "contract_type":"this_week" // next_week, quarter
                    //             },
                    //         ],
                    //         "ts":1640736207263
                    //     }
                    //
                    // swaps
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "symbol":"BTC",
                    //                 "contract_code":"BTC-USDT",
                    //                 "contract_size":0.001000000000000000,
                    //                 "price_tick":0.100000000000000000,
                    //                 "delivery_time":"",
                    //                 "create_date":"20201021",
                    //                 "contract_status":1,
                    //                 "settlement_date":"1637481600000",
                    //                 "support_margin_mode":"all", // isolated
                    //             },
                    //         ],
                    //         "ts":1637474774467
                    //     }
                    //
                    const markets = this.safeValue(response, 'data');
                    const numMarkets = markets.length;
                    if (numMarkets < 1) throw new NetworkError(this.id + ' fetchMarkets() returned an empty response: ' + this.json(markets));
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        let baseId = undefined;
                        let quoteId = undefined;
                        let settleId = undefined;
                        let id = undefined;
                        let lowercaseId = undefined;
                        let lowercaseBaseId = undefined;
                        if (contract) {
                            id = this.safeString(market, 'contract_code');
                            lowercaseId = id.toLowerCase();
                            if (swap) {
                                const parts = id.split('-');
                                baseId = this.safeString(market, 'symbol');
                                lowercaseBaseId = baseId.toLowerCase();
                                quoteId = this.safeStringLower(parts, 1);
                                settleId = inverse ? baseId : quoteId;
                            } else if (future) {
                                baseId = this.safeString(market, 'symbol');
                                lowercaseBaseId = baseId.toLowerCase();
                                if (inverse) {
                                    quoteId = 'USD';
                                    settleId = baseId;
                                } else {
                                    const pair = this.safeString(market, 'pair');
                                    const parts = pair.split('-');
                                    quoteId = this.safeString(parts, 1);
                                    settleId = quoteId;
                                }
                            }
                        } else {
                            baseId = this.safeString(market, 'base-currency');
                            lowercaseBaseId = baseId.toLowerCase();
                            quoteId = this.safeString(market, 'quote-currency');
                            id = baseId + quoteId;
                            lowercaseId = id.toLowerCase();
                        }
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const settle = this.safeCurrencyCode(settleId);
                        let symbol = base + '/' + quote;
                        let expiry = undefined;
                        if (contract) {
                            if (inverse) symbol += ':' + base;
                            else if (linear) symbol += ':' + quote;
                            if (future) {
                                expiry = this.safeInteger(market, 'delivery_time');
                                symbol += '-' + this.yymmdd(expiry);
                            }
                        }
                        const contractSize = this.safeNumber(market, 'contract_size');
                        let pricePrecision = undefined;
                        let amountPrecision = undefined;
                        let costPrecision = undefined;
                        if (spot) {
                            pricePrecision = this.safeString(market, 'price-precision');
                            pricePrecision = this.parseNumber('1e-' + pricePrecision);
                            amountPrecision = this.safeString(market, 'amount-precision');
                            amountPrecision = this.parseNumber('1e-' + amountPrecision);
                            costPrecision = this.safeString(market, 'value-precision');
                            costPrecision = this.parseNumber('1e-' + costPrecision);
                        } else {
                            pricePrecision = this.safeNumber(market, 'price_tick');
                            amountPrecision = 1;
                        }
                        let maker = undefined;
                        let taker = undefined;
                        if (spot) {
                            maker = base === 'OMG' ? 0 : 0.002;
                            taker = base === 'OMG' ? 0 : 0.002;
                        }
                        const minAmount = this.safeNumber(market, 'min-order-amt');
                        const maxAmount = this.safeNumber(market, 'max-order-amt');
                        const minCost = this.safeNumber(market, 'min-order-value', 0);
                        let active = undefined;
                        if (spot) {
                            const state = this.safeString(market, 'state');
                            active = state === 'online';
                        } else if (contract) {
                            const contractStatus = this.safeInteger(market, 'contract_status');
                            active = contractStatus === 1;
                        }
                        const leverageRatio = this.safeString(market, 'leverage-ratio', '1');
                        const superLeverageRatio = this.safeString(market, 'super-margin-leverage-ratio', '1');
                        const hasLeverage = Precise.stringGt(leverageRatio, '1') || Precise.stringGt(superLeverageRatio, '1');
                        // 0 Delisting
                        // 1 Listing
                        // 2 Pending Listing
                        // 3 Suspension
                        // 4 Suspending of Listing
                        // 5 In Settlement
                        // 6 Delivering
                        // 7 Settlement Completed
                        // 8 Delivered
                        // 9 Suspending of Trade
                        result.push({
                            'id': id,
                            'lowercaseId': lowercaseId,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'lowercaseBaseId': lowercaseBaseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': type,
                            'spot': spot,
                            'margin': spot && hasLeverage,
                            'swap': swap,
                            'future': future,
                            'option': false,
                            'active': active,
                            'contract': contract,
                            'linear': linear,
                            'inverse': inverse,
                            'taker': taker,
                            'maker': maker,
                            'contractSize': contractSize,
                            'expiry': expiry,
                            'expiryDatetime': this.iso8601(expiry),
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': amountPrecision,
                                'price': pricePrecision,
                                'cost': costPrecision
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': this.parseNumber(leverageRatio),
                                    'superMax': this.parseNumber(superLeverageRatio)
                                },
                                'amount': {
                                    'min': minAmount,
                                    'max': maxAmount
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': minCost,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker
                    //
                    //     {
                    //         "amount": 26228.672978342216,
                    //         "open": 9078.95,
                    //         "close": 9146.86,
                    //         "high": 9155.41,
                    //         "id": 209988544334,
                    //         "count": 265846,
                    //         "low": 8988.0,
                    //         "version": 209988544334,
                    //         "ask": [ 9146.87, 0.156134 ],
                    //         "vol": 2.3822168242201668E8,
                    //         "bid": [ 9146.86, 0.080758 ],
                    //     }
                    //
                    // fetchTickers
                    //
                    //     {
                    //         symbol: "bhdht",
                    //         open:  2.3938,
                    //         high:  2.4151,
                    //         low:  2.3323,
                    //         close:  2.3909,
                    //         amount:  628.992,
                    //         vol:  1493.71841095,
                    //         count:  2088,
                    //         bid:  2.3643,
                    //         bidSize:  0.7136,
                    //         ask:  2.4061,
                    //         askSize:  0.4156
                    //     }
                    //
                    const marketId = this.safeString2(ticker, 'symbol', 'contract_code');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.safeInteger(ticker, 'ts');
                    let bid = undefined;
                    let bidVolume = undefined;
                    let ask = undefined;
                    let askVolume = undefined;
                    if ('bid' in ticker) {
                        if (Array.isArray(ticker['bid'])) {
                            bid = this.safeString(ticker['bid'], 0);
                            bidVolume = this.safeString(ticker['bid'], 1);
                        } else {
                            bid = this.safeString(ticker, 'bid');
                            bidVolume = this.safeString(ticker, 'bidSize');
                        }
                    }
                    if ('ask' in ticker) {
                        if (Array.isArray(ticker['ask'])) {
                            ask = this.safeString(ticker['ask'], 0);
                            askVolume = this.safeString(ticker['ask'], 1);
                        } else {
                            ask = this.safeString(ticker, 'ask');
                            askVolume = this.safeString(ticker, 'askSize');
                        }
                    }
                    const open = this.safeString(ticker, 'open');
                    const close = this.safeString(ticker, 'close');
                    const baseVolume = this.safeString(ticker, 'amount');
                    const quoteVolume = this.safeString(ticker, 'vol');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': bid,
                        'bidVolume': bidVolume,
                        'ask': ask,
                        'askVolume': askVolume,
                        'vwap': undefined,
                        'open': open,
                        'close': close,
                        'last': close,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {};
                    let fieldName = 'symbol';
                    let method = 'spotPublicGetMarketDetailMerged';
                    if (market['linear']) {
                        method = 'contractPublicGetLinearSwapExMarketDetailMerged';
                        fieldName = 'contract_code';
                    } else if (market['inverse']) {
                        if (market['future']) method = 'contractPublicGetMarketDetailMerged';
                        else if (market['swap']) {
                            method = 'contractPublicGetSwapExMarketDetailMerged';
                            fieldName = 'contract_code';
                        }
                    }
                    request[fieldName] = market['id'];
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "status": "ok",
                    //         "ch": "market.btcusdt.detail.merged",
                    //         "ts": 1583494336669,
                    //         "tick": {
                    //             "amount": 26228.672978342216,
                    //             "open": 9078.95,
                    //             "close": 9146.86,
                    //             "high": 9155.41,
                    //             "id": 209988544334,
                    //             "count": 265846,
                    //             "low": 8988.0,
                    //             "version": 209988544334,
                    //             "ask": [ 9146.87, 0.156134 ],
                    //             "vol": 2.3822168242201668E8,
                    //             "bid": [ 9146.86, 0.080758 ],
                    //         }
                    //     }
                    //
                    // future, swap
                    //
                    //     {
                    //         "ch":"market.BTC211126.detail.merged",
                    //         "status":"ok",
                    //         "tick":{
                    //             "amount":"669.3385682049668320322569544150680718474",
                    //             "ask":[59117.44,48],
                    //             "bid":[59082,48],
                    //             "close":"59087.97",
                    //             "count":5947,
                    //             "high":"59892.62",
                    //             "id":1637502670,
                    //             "low":"57402.87",
                    //             "open":"57638",
                    //             "ts":1637502670059,
                    //             "vol":"394598"
                    //         },
                    //         "ts":1637502670059
                    //     }
                    //
                    const tick = this.safeValue(response, 'tick', {});
                    const ticker = this.parseTicker(tick, market);
                    const timestamp = this.safeInteger(response, 'ts');
                    ticker['timestamp'] = timestamp;
                    ticker['datetime'] = this.iso8601(timestamp);
                    return ticker;
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const options = this.safeValue(this.options, 'fetchTickers', {});
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    let type = this.safeString(options, 'type', defaultType);
                    type = this.safeString(params, 'type', type);
                    let method = 'spotPublicGetMarketTickers';
                    const defaultSubType = this.safeString(this.options, 'defaultSubType', 'inverse');
                    let subType = this.safeString(options, 'subType', defaultSubType);
                    subType = this.safeString(params, 'subType', subType);
                    const request = {};
                    const future = type === 'future';
                    const swap = type === 'swap';
                    const linear = subType === 'linear';
                    const inverse = subType === 'inverse';
                    if (future || swap) {
                        if (linear) {
                            method = 'contractPublicGetLinearSwapExMarketDetailBatchMerged';
                            if (future) request['business_type'] = 'futures';
                        } else if (inverse) {
                            if (future) method = 'contractPublicGetMarketDetailBatchMerged';
                            else if (swap) method = 'contractPublicGetSwapExMarketDetailBatchMerged';
                        }
                    }
                    params = this.omit(params, [
                        'type',
                        'subType'
                    ]);
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "symbol":"hbcbtc",
                    //                 "open":5.313E-5,
                    //                 "high":5.34E-5,
                    //                 "low":5.112E-5,
                    //                 "close":5.175E-5,
                    //                 "amount":1183.87,
                    //                 "vol":0.0618599229,
                    //                 "count":205,
                    //                 "bid":5.126E-5,
                    //                 "bidSize":5.25,
                    //                 "ask":5.214E-5,
                    //                 "askSize":150.0
                    //             },
                    //         ],
                    //         "status":"ok",
                    //         "ts":1639547261293
                    //     }
                    //
                    // inverse swaps, linear swaps, inverse futures
                    //
                    //     {
                    //         "status":"ok",
                    //         "ticks":[
                    //             {
                    //                 "id":1637504679,
                    //                 "ts":1637504679372,
                    //                 "ask":[0.10644,100],
                    //                 "bid":[0.10624,26],
                    //                 "symbol":"TRX_CW",
                    //                 "open":"0.10233",
                    //                 "close":"0.10644",
                    //                 "low":"0.1017",
                    //                 "high":"0.10725",
                    //                 "amount":"2340267.415144052378486261756692535687481566",
                    //                 "count":882,
                    //                 "vol":"24706"
                    //             }
                    //         ],
                    //         "ts":1637504679376
                    //     }
                    //
                    // linear futures
                    //
                    //     {
                    //         "status":"ok",
                    //         "ticks":[
                    //             {
                    //                 "id":1640745627,
                    //                 "ts":1640745627957,
                    //                 "ask":[48079.1,20],
                    //                 "bid":[47713.8,125],
                    //                 "business_type":"futures",
                    //                 "contract_code":"BTC-USDT-CW",
                    //                 "open":"49011.8",
                    //                 "close":"47934",
                    //                 "low":"47292.3",
                    //                 "high":"49011.8",
                    //                 "amount":"17.398",
                    //                 "count":1515,
                    //                 "vol":"17398",
                    //                 "trade_turnover":"840726.5048"
                    //             }
                    //         ],
                    //         "ts":1640745627988
                    //     }
                    //
                    const tickers = this.safeValue2(response, 'data', 'ticks', []);
                    const timestamp = this.safeInteger(response, 'ts');
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const ticker = this.parseTicker(tickers[i]);
                        // the market ids for linear futures are non-standard and differ from all the other endpoints
                        // we are doing a linear-matching here
                        if (future && linear) for(let j = 0; j < this.symbols.length; j++){
                            const symbol = this.symbols[j];
                            const market = this.market(symbol);
                            const contractType = this.safeString(market['info'], 'contract_type');
                            if (contractType === 'this_week' && ticker['symbol'] === market['baseId'] + '-' + market['quoteId'] + '-CW') {
                                ticker['symbol'] = market['symbol'];
                                break;
                            } else if (contractType === 'next_week' && ticker['symbol'] === market['baseId'] + '-' + market['quoteId'] + '-NW') {
                                ticker['symbol'] = market['symbol'];
                                break;
                            } else if (contractType === 'this_quarter' && ticker['symbol'] === market['baseId'] + '-' + market['quoteId'] + '-CQ') {
                                ticker['symbol'] = market['symbol'];
                                break;
                            } else if (contractType === 'next_quarter' && ticker['symbol'] === market['baseId'] + '-' + market['quoteId'] + '-NQ') {
                                ticker['symbol'] = market['symbol'];
                                break;
                            }
                        }
                        const symbol = ticker['symbol'];
                        ticker['timestamp'] = timestamp;
                        ticker['datetime'] = this.iso8601(timestamp);
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        //
                        // from the API docs
                        //
                        //     to get depth data within step 150, use step0, step1, step2, step3, step4, step5, step14, step15（merged depth data 0-5,14-15, when step is 0，depth data will not be merged
                        //     to get depth data within step 20, use step6, step7, step8, step9, step10, step11, step12, step13(merged depth data 7-13), when step is 6, depth data will not be merged
                        //
                        'type': 'step0'
                    };
                    let fieldName = 'symbol';
                    let method = 'spotPublicGetMarketDepth';
                    if (market['linear']) {
                        method = 'contractPublicGetLinearSwapExMarketDepth';
                        fieldName = 'contract_code';
                    } else if (market['inverse']) {
                        if (market['future']) method = 'contractPublicGetMarketDepth';
                        else if (market['swap']) {
                            method = 'contractPublicGetSwapExMarketDepth';
                            fieldName = 'contract_code';
                        }
                    } else if (limit !== undefined) {
                        // Valid depths are 5, 10, 20 or empty https://huobiapi.github.io/docs/spot/v1/en/#get-market-depth
                        if (limit !== 5 && limit !== 10 && limit !== 20 && limit !== 150) throw new BadRequest(this.id + ' fetchOrderBook() limit argument must be undefined, 5, 10, 20, or 150, default is 150');
                        // only set the depth if it is not 150
                        // 150 is the implicit default on the exchange side for step0 and no orderbook aggregation
                        // it is not accepted by the exchange if you set it explicitly
                        if (limit !== 150) request['depth'] = limit;
                    }
                    request[fieldName] = market['id'];
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot, future, swap
                    //
                    //     {
                    //         "status": "ok",
                    //         "ch": "market.btcusdt.depth.step0",
                    //         "ts": 1583474832790,
                    //         "tick": {
                    //             "bids": [
                    //                 [ 9100.290000000000000000, 0.200000000000000000 ],
                    //                 [ 9099.820000000000000000, 0.200000000000000000 ],
                    //                 [ 9099.610000000000000000, 0.205000000000000000 ],
                    //             ],
                    //             "asks": [
                    //                 [ 9100.640000000000000000, 0.005904000000000000 ],
                    //                 [ 9101.010000000000000000, 0.287311000000000000 ],
                    //                 [ 9101.030000000000000000, 0.012121000000000000 ],
                    //             ],
                    //             "ch":"market.BTC-USD.depth.step0",
                    //             "ts":1583474832008,
                    //             "id":1637554816,
                    //             "mrid":121654491624,
                    //             "version":104999698780
                    //         }
                    //     }
                    //
                    if ('tick' in response) {
                        if (!response['tick']) throw new BadSymbol(this.id + ' fetchOrderBook() returned empty response: ' + this.json(response));
                        const tick = this.safeValue(response, 'tick');
                        const timestamp = this.safeInteger(tick, 'ts', this.safeInteger(response, 'ts'));
                        const result = this.parseOrderBook(tick, symbol, timestamp);
                        result['nonce'] = this.safeInteger(tick, 'version');
                        return result;
                    }
                    throw new ExchangeError1(this.id + ' fetchOrderBook() returned unrecognized response: ' + this.json(response));
                }
                parseTrade(trade, market) {
                    //
                    // spot fetchTrades (public)
                    //
                    //     {
                    //         "amount": 0.010411000000000000,
                    //         "trade-id": 102090736910,
                    //         "ts": 1583497692182,
                    //         "id": 10500517034273194594947,
                    //         "price": 9096.050000000000000000,
                    //         "direction": "sell"
                    //     }
                    //
                    // spot fetchMyTrades (private)
                    //
                    //     {
                    //          'symbol': 'swftcbtc',
                    //          'fee-currency': 'swftc',
                    //          'filled-fees': '0',
                    //          'source': 'spot-api',
                    //          'id': 83789509854000,
                    //          'type': 'buy-limit',
                    //          'order-id': 83711103204909,
                    //          'filled-points': '0.005826843283532154',
                    //          'fee-deduct-currency': 'ht',
                    //          'filled-amount': '45941.53',
                    //          'price': '0.0000001401',
                    //          'created-at': 1597933260729,
                    //          'match-id': 100087455560,
                    //          'role': 'maker',
                    //          'trade-id': 100050305348
                    //     }
                    //
                    // linear swap isolated margin fetchOrder details
                    //
                    //     {
                    //         "trade_id": 131560927,
                    //         "trade_price": 13059.800000000000000000,
                    //         "trade_volume": 1.000000000000000000,
                    //         "trade_turnover": 13.059800000000000000,
                    //         "trade_fee": -0.005223920000000000,
                    //         "created_at": 1603703614715,
                    //         "role": "taker",
                    //         "fee_asset": "USDT",
                    //         "profit": 0,
                    //         "real_profit": 0,
                    //         "id": "131560927-770334322963152896-1"
                    //     }
                    //
                    // inverse swap cross margin fetchMyTrades
                    //
                    //     {
                    //         "contract_type":"swap",
                    //         "pair":"O3-USDT",
                    //         "business_type":"swap",
                    //         "query_id":652123190,
                    //         "match_id":28306009409,
                    //         "order_id":941137865226903553,
                    //         "symbol":"O3",
                    //         "contract_code":"O3-USDT",
                    //         "direction":"sell",
                    //         "offset":"open",
                    //         "trade_volume":100.000000000000000000,
                    //         "trade_price":0.398500000000000000,
                    //         "trade_turnover":39.850000000000000000,
                    //         "trade_fee":-0.007970000000000000,
                    //         "offset_profitloss":0E-18,
                    //         "create_date":1644426352999,
                    //         "role":"Maker",
                    //         "order_source":"api",
                    //         "order_id_str":"941137865226903553",
                    //         "id":"28306009409-941137865226903553-1",
                    //         "fee_asset":"USDT",
                    //         "margin_mode":"cross",
                    //         "margin_account":"USDT",
                    //         "real_profit":0E-18,
                    //         "trade_partition":"USDT"
                    //     }
                    //
                    const marketId = this.safeString2(trade, 'contract_code', 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    let timestamp = this.safeInteger2(trade, 'ts', 'created-at');
                    timestamp = this.safeInteger2(trade, 'created_at', 'create_date', timestamp);
                    const order = this.safeString2(trade, 'order-id', 'order_id');
                    let side = this.safeString(trade, 'direction');
                    let type = this.safeString(trade, 'type');
                    if (type !== undefined) {
                        const typeParts = type.split('-');
                        side = typeParts[0];
                        type = typeParts[1];
                    }
                    const takerOrMaker = this.safeStringLower(trade, 'role');
                    const priceString = this.safeString2(trade, 'price', 'trade_price');
                    let amountString = this.safeString2(trade, 'filled-amount', 'amount');
                    amountString = this.safeString(trade, 'trade_volume', amountString);
                    const costString = this.safeString(trade, 'trade_turnover');
                    let fee = undefined;
                    let feeCost = this.safeString2(trade, 'filled-fees', 'trade_fee');
                    const feeCurrencyId = this.safeString2(trade, 'fee-currency', 'fee_asset');
                    let feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                    const filledPoints = this.safeString(trade, 'filled-points');
                    if (filledPoints !== undefined) {
                        if (feeCost === undefined || Precise.stringEquals(feeCost, '0')) {
                            const feeDeductCurrency = this.safeString(trade, 'fee-deduct-currency');
                            if (feeDeductCurrency !== '') {
                                feeCost = filledPoints;
                                feeCurrency = this.safeCurrencyCode(feeDeductCurrency);
                            }
                        }
                    }
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': feeCurrency
                    };
                    const tradeId = this.safeString2(trade, 'trade-id', 'tradeId');
                    const id = this.safeString2(trade, 'trade_id', 'id', tradeId);
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'order': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    let marketType = undefined;
                    [marketType, params] = this.handleMarketTypeAndParams('fetchOrderTrades', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'fetchSpotOrderTrades'
                    });
                    return await this[method](id, symbol, since, limit, params);
                }
                async fetchSpotOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order-id': id
                    };
                    const response = await this.spotPrivateGetV1OrderOrdersOrderIdMatchresults(this.extend(request, params));
                    return this.parseTrades(response['data'], undefined, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let marketType = undefined;
                    [marketType, params] = this.handleMarketTypeAndParams('fetchMyTrades', undefined, params);
                    const request = {
                    };
                    let method = undefined;
                    let market = undefined;
                    if (marketType === 'spot') {
                        if (symbol !== undefined) {
                            market = this.market(symbol);
                            request['symbol'] = market['id'];
                        }
                        if (limit !== undefined) request['size'] = limit; // default 100, max 500
                        if (since !== undefined) request['start-time'] = since; // a date within 120 days from today
                        method = 'spotPrivateGetV1OrderMatchresults';
                    } else {
                        if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol for ' + marketType + ' orders');
                        const market = this.market(symbol);
                        request['contract_code'] = market['id'];
                        request['trade_type'] = 0; // 0 all, 1 open long, 2 open short, 3 close short, 4 close long, 5 liquidate long positions, 6 liquidate short positions
                        if (market['linear']) {
                            const defaultMargin = market['future'] ? 'cross' : 'isolated';
                            const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                            if (marginMode === 'isolated') method = 'contractPrivatePostLinearSwapApiV1SwapMatchresultsExact';
                            else if (marginMode === 'cross') method = 'contractPrivatePostLinearSwapApiV1SwapCrossMatchresultsExact';
                        } else if (market['inverse']) {
                            if (marketType === 'future') {
                                method = 'contractPrivatePostApiV1ContractMatchresultsExact';
                                request['symbol'] = market['settleId'];
                            } else if (marketType === 'swap') method = 'contractPrivatePostSwapApiV1SwapMatchresultsExact';
                            else throw new NotSupported(this.id + ' fetchMyTrades() does not support ' + marketType + ' markets');
                        }
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": [
                    //             {
                    //                 "symbol": "polyusdt",
                    //                 "fee-currency": "poly",
                    //                 "source": "spot-web",
                    //                 "price": "0.338",
                    //                 "created-at": 1629443051839,
                    //                 "role": "taker",
                    //                 "order-id": 345487249132375,
                    //                 "match-id": 5014,
                    //                 "trade-id": 1085,
                    //                 "filled-amount": "147.928994082840236",
                    //                 "filled-fees": "0",
                    //                 "filled-points": "0.1",
                    //                 "fee-deduct-currency": "hbpoint",
                    //                 "fee-deduct-state": "done",
                    //                 "id": 313288753120940,
                    //                 "type": "buy-market"
                    //             }
                    //         ]
                    //     }
                    //
                    // contracts
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": {
                    //             "trades": [
                    //                 {
                    //                     "query_id": 2424420723,
                    //                     "match_id": 113891764710,
                    //                     "order_id": 773135295142658048,
                    //                     "symbol": "ADA",
                    //                     "contract_type": "quarter", // swap
                    //                     "business_type": "futures", // swap
                    //                     "contract_code": "ADA201225",
                    //                     "direction": "buy",
                    //                     "offset": "open",
                    //                     "trade_volume": 1,
                    //                     "trade_price": 0.092,
                    //                     "trade_turnover": 10,
                    //                     "trade_fee": -0.021739130434782608,
                    //                     "offset_profitloss": 0,
                    //                     "create_date": 1604371703183,
                    //                     "role": "Maker",
                    //                     "order_source": "web",
                    //                     "order_id_str": "773135295142658048",
                    //                     "fee_asset": "ADA",
                    //                     "margin_mode": "isolated", // cross
                    //                     "margin_account": "BTC-USDT",
                    //                     "real_profit": 0,
                    //                     "id": "113891764710-773135295142658048-1",
                    //                     "trade_partition":"USDT",
                    //                 }
                    //             ],
                    //             "remain_size": 15,
                    //             "next_id": 2424413094
                    //         },
                    //         "ts": 1604372202243
                    //     }
                    //
                    let trades = this.safeValue(response, 'data');
                    if (!Array.isArray(trades)) trades = this.safeValue(trades, 'trades');
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchTrades(symbol, since, limit = 1000, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                    };
                    let fieldName = 'symbol';
                    let method = 'spotPublicGetMarketHistoryTrade';
                    if (market['future']) {
                        if (market['inverse']) method = 'contractPublicGetMarketHistoryTrade';
                        else if (market['linear']) {
                            method = 'contractPublicGetLinearSwapExMarketHistoryTrade';
                            fieldName = 'contract_code';
                        }
                    } else if (market['swap']) {
                        if (market['inverse']) method = 'contractPublicGetSwapExMarketHistoryTrade';
                        else if (market['linear']) method = 'contractPublicGetLinearSwapExMarketHistoryTrade';
                        fieldName = 'contract_code';
                    }
                    request[fieldName] = market['id'];
                    if (limit !== undefined) request['size'] = limit; // max 2000
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "ch": "market.btcusdt.trade.detail",
                    //         "ts": 1583497692365,
                    //         "data": [
                    //             {
                    //                 "id": 105005170342,
                    //                 "ts": 1583497692182,
                    //                 "data": [
                    //                     {
                    //                         "amount": 0.010411000000000000,
                    //                         "trade-id": 102090736910,
                    //                         "ts": 1583497692182,
                    //                         "id": 10500517034273194594947,
                    //                         "price": 9096.050000000000000000,
                    //                         "direction": "sell"
                    //                     }
                    //                 ]
                    //             },
                    //             // ...
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    let result = [];
                    for(let i = 0; i < data.length; i++){
                        const trades = this.safeValue(data[i], 'data', []);
                        for(let j = 0; j < trades.length; j++){
                            const trade = this.parseTrade(trades[j], market);
                            result.push(trade);
                        }
                    }
                    result = this.sortBy(result, 'timestamp');
                    return this.filterBySymbolSinceLimit(result, market['symbol'], since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "amount":1.2082,
                    //         "open":0.025096,
                    //         "close":0.025095,
                    //         "high":0.025096,
                    //         "id":1591515300,
                    //         "count":6,
                    //         "low":0.025095,
                    //         "vol":0.0303205097
                    //     }
                    //
                    return [
                        this.safeTimestamp(ohlcv, 'id'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'amount')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'period': this.timeframes[timeframe]
                    };
                    let fieldName = 'symbol';
                    const price = this.safeString(params, 'price');
                    params = this.omit(params, 'price');
                    let method = 'spotPublicGetMarketHistoryCandles';
                    if (market['spot']) {
                        if (since !== undefined) request['from'] = parseInt(since / 1000);
                        if (limit !== undefined) request['size'] = limit; // max 2000
                    } else if (market['future']) {
                        if (market['inverse']) {
                            if (price === 'mark') method = 'contractPublicGetIndexMarketHistoryMarkPriceKline';
                            else if (price === 'index') method = 'contractPublicGetIndexMarketHistoryIndex';
                            else if (price === 'premiumIndex') throw new BadRequest(this.id + ' ' + market['type'] + ' has no api endpoint for ' + price + ' kline data');
                            else method = 'contractPublicGetMarketHistoryKline';
                        } else if (market['linear']) {
                            if (price === 'mark') method = 'contractPublicGetIndexMarketHistoryLinearSwapMarkPriceKline';
                            else if (price === 'index') throw new BadRequest(this.id + ' ' + market['type'] + ' has no api endpoint for ' + price + ' kline data');
                            else if (price === 'premiumIndex') method = 'contractPublicGetIndexMarketHistoryLinearSwapPremiumIndexKline';
                            else method = 'contractPublicGetLinearSwapExMarketHistoryKline';
                            fieldName = 'contract_code';
                        }
                    } else if (market['swap']) {
                        if (market['inverse']) {
                            if (price === 'mark') method = 'contractPublicGetIndexMarketHistorySwapMarkPriceKline';
                            else if (price === 'index') throw new BadRequest(this.id + ' ' + market['type'] + ' has no api endpoint for ' + price + ' kline data');
                            else if (price === 'premiumIndex') method = 'contractPublicGetIndexMarketHistorySwapPremiumIndexKline';
                            else method = 'contractPublicGetSwapExMarketHistoryKline';
                        } else if (market['linear']) {
                            if (price === 'mark') method = 'contractPublicGetIndexMarketHistoryLinearSwapMarkPriceKline';
                            else if (price === 'index') throw new BadRequest(this.id + ' ' + market['type'] + ' has no api endpoint for ' + price + ' kline data');
                            else if (price === 'premiumIndex') method = 'contractPublicGetIndexMarketHistoryLinearSwapPremiumIndexKline';
                            else method = 'contractPublicGetLinearSwapExMarketHistoryKline';
                        }
                        fieldName = 'contract_code';
                    }
                    if (market['contract']) {
                        if (limit === undefined) limit = 2000;
                        if (price === undefined) {
                            const duration = this.parseTimeframe(timeframe);
                            if (since === undefined) {
                                const now = this.seconds();
                                request['from'] = now - duration * (limit - 1);
                                request['to'] = now;
                            } else {
                                const start = parseInt(since / 1000);
                                request['from'] = start;
                                request['to'] = this.sum(start, duration * (limit - 1));
                            }
                        }
                    }
                    request[fieldName] = market['id'];
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "status":"ok",
                    //         "ch":"market.ethbtc.kline.1min",
                    //         "ts":1591515374371,
                    //         "data":[
                    //             {"amount":0.0,"open":0.025095,"close":0.025095,"high":0.025095,"id":1591515360,"count":0,"low":0.025095,"vol":0.0},
                    //             {"amount":1.2082,"open":0.025096,"close":0.025095,"high":0.025096,"id":1591515300,"count":6,"low":0.025095,"vol":0.0303205097},
                    //             {"amount":0.0648,"open":0.025096,"close":0.025096,"high":0.025096,"id":1591515240,"count":2,"low":0.025096,"vol":0.0016262208},
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async fetchIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'index'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchMarkOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'mark'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchPremiumIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'premiumIndex'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchAccounts(params = {}) {
                    await this.loadMarkets();
                    const response = await this.spotPrivateGetV1AccountAccounts(params);
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {"id":5202591,"type":"point","subtype":"","state":"working"},
                    //             {"id":1528640,"type":"spot","subtype":"","state":"working"},
                    //         ]
                    //     }
                    //
                    return response['data'];
                }
                async fetchAccountIdByType(type, params = {}) {
                    const accounts = await this.loadAccounts();
                    const accountId = this.safeValue(params, 'account-id');
                    if (accountId !== undefined) return accountId;
                    const indexedAccounts = this.indexBy(accounts, 'type');
                    const defaultAccount = this.safeValue(accounts, 0, {});
                    const account = this.safeValue(indexedAccounts, type, defaultAccount);
                    return this.safeString(account, 'id');
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.spotPublicGetV2ReferenceCurrencies();
                    //     {
                    //       "code": 200,
                    //       "data": [
                    //         {
                    //           "currency": "sxp",
                    //           "assetType": "1",
                    //           "chains": [
                    //             {
                    //               "chain": "sxp",
                    //               "displayName": "ERC20",
                    //               "baseChain": "ETH",
                    //               "baseChainProtocol": "ERC20",
                    //               "isDynamic": true,
                    //               "numOfConfirmations": "12",
                    //               "numOfFastConfirmations": "12",
                    //               "depositStatus": "allowed",
                    //               "minDepositAmt": "0.23",
                    //               "withdrawStatus": "allowed",
                    //               "minWithdrawAmt": "0.23",
                    //               "withdrawPrecision": "8",
                    //               "maxWithdrawAmt": "227000.000000000000000000",
                    //               "withdrawQuotaPerDay": "227000.000000000000000000",
                    //               "withdrawQuotaPerYear": null,
                    //               "withdrawQuotaTotal": null,
                    //               "withdrawFeeType": "fixed",
                    //               "transactFeeWithdraw": "11.1653",
                    //               "addrWithTag": false,
                    //               "addrDepositTag": false
                    //             }
                    //           ],
                    //           "instStatus": "normal"
                    //         }
                    //       ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = {};
                    for(let i = 0; i < data.length; i++){
                        const entry = data[i];
                        const currencyId = this.safeString(entry, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const chains = this.safeValue(entry, 'chains', []);
                        const networks = {};
                        const instStatus = this.safeString(entry, 'instStatus');
                        const currencyActive = instStatus === 'normal';
                        let fee = undefined;
                        let minPrecision = undefined;
                        let minWithdraw = undefined;
                        let maxWithdraw = undefined;
                        let deposit = undefined;
                        let withdraw = undefined;
                        for(let j = 0; j < chains.length; j++){
                            const chain = chains[j];
                            const networkId = this.safeString(chain, 'chain');
                            let baseChainProtocol = this.safeString(chain, 'baseChainProtocol');
                            const huobiToken = 'h' + currencyId;
                            if (baseChainProtocol === undefined) {
                                if (huobiToken === networkId) baseChainProtocol = 'ERC20';
                                else baseChainProtocol = this.safeString(chain, 'displayName');
                            }
                            const network = this.safeNetwork(baseChainProtocol);
                            minWithdraw = this.safeNumber(chain, 'minWithdrawAmt');
                            maxWithdraw = this.safeNumber(chain, 'maxWithdrawAmt');
                            const withdrawStatus = this.safeString(chain, 'withdrawStatus');
                            const depositStatus = this.safeString(chain, 'depositStatus');
                            const withdrawEnabled = withdrawStatus === 'allowed';
                            const depositEnabled = depositStatus === 'allowed';
                            const active = withdrawEnabled && depositEnabled;
                            let precision = this.safeString(chain, 'withdrawPrecision');
                            if (precision !== undefined) {
                                precision = this.parseNumber('1e-' + precision);
                                minPrecision = minPrecision === undefined ? precision : Math.max(precision, minPrecision);
                            }
                            if (withdrawEnabled && !withdraw) withdraw = true;
                            else if (!withdrawEnabled) withdraw = false;
                            if (depositEnabled && !deposit) deposit = true;
                            else if (!depositEnabled) deposit = false;
                            fee = this.safeNumber(chain, 'transactFeeWithdraw');
                            networks[network] = {
                                'info': chain,
                                'id': networkId,
                                'network': network,
                                'limits': {
                                    'withdraw': {
                                        'min': minWithdraw,
                                        'max': maxWithdraw
                                    }
                                },
                                'active': active,
                                'deposit': depositEnabled,
                                'withdraw': withdrawEnabled,
                                'fee': fee,
                                'precision': precision
                            };
                        }
                        const networksKeys = Object.keys(networks);
                        const networkLength = networksKeys.length;
                        result[code] = {
                            'info': entry,
                            'code': code,
                            'id': currencyId,
                            'active': currencyActive,
                            'deposit': deposit,
                            'withdraw': withdraw,
                            'fee': networkLength <= 1 ? fee : undefined,
                            'name': undefined,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': networkLength <= 1 ? minWithdraw : undefined,
                                    'max': networkLength <= 1 ? maxWithdraw : undefined
                                }
                            },
                            'precision': minPrecision,
                            'networks': networks
                        };
                    }
                    return result;
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const options = this.safeValue(this.options, 'fetchTickers', {});
                    const defaultType = this.safeString(this.options, 'defaultType', 'spot');
                    let type = this.safeString(options, 'type', defaultType);
                    type = this.safeString(params, 'type', type);
                    params = this.omit(params, 'type');
                    const request = {};
                    let method = undefined;
                    const spot = type === 'spot';
                    const future = type === 'future';
                    const swap = type === 'swap';
                    const defaultSubType = this.safeString(this.options, 'defaultSubType', 'inverse');
                    let subType = this.safeString(options, 'subType', defaultSubType);
                    subType = this.safeString(params, 'subType', subType);
                    const inverse = subType === 'inverse';
                    const linear = subType === 'linear';
                    const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', 'isolated');
                    const isolated = marginMode === 'isolated';
                    const cross = marginMode === 'cross';
                    if (spot) {
                        await this.loadAccounts();
                        const accountId = await this.fetchAccountIdByType(type, params);
                        request['account-id'] = accountId;
                        method = 'spotPrivateGetV1AccountAccountsAccountIdBalance';
                    } else if (linear) {
                        if (marginMode === 'isolated') method = 'contractPrivatePostLinearSwapApiV1SwapAccountInfo';
                        else method = 'contractPrivatePostLinearSwapApiV1SwapCrossAccountInfo';
                    } else if (inverse) {
                        if (future) method = 'contractPrivatePostApiV1ContractAccountInfo';
                        else if (swap) method = 'contractPrivatePostSwapApiV1SwapAccountInfo';
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":{
                    //             "id":1528640,
                    //             "type":"spot",
                    //             "state":"working",
                    //             "list":[
                    //                 {"currency":"lun","type":"trade","balance":"0","seq-num":"0"},
                    //                 {"currency":"lun","type":"frozen","balance":"0","seq-num":"0"},
                    //                 {"currency":"ht","type":"frozen","balance":"0","seq-num":"145"},
                    //             ]
                    //         },
                    //         "ts":1637644827566
                    //     }
                    //
                    // future, swap isolated
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "symbol":"BTC",
                    //                 "margin_balance":0,
                    //                 "margin_position":0E-18,
                    //                 "margin_frozen":0,
                    //                 "margin_available":0E-18,
                    //                 "profit_real":0,
                    //                 "profit_unreal":0,
                    //                 "risk_rate":null,
                    //                 "withdraw_available":0,
                    //                 "liquidation_price":null,
                    //                 "lever_rate":5,
                    //                 "adjust_factor":0.025000000000000000,
                    //                 "margin_static":0,
                    //                 "is_debit":0, // future only
                    //                 "contract_code":"BTC-USD", // swap only
                    //                 "margin_asset":"USDT", // linear only
                    //                 "margin_mode":"isolated", // linear only
                    //                 "margin_account":"BTC-USDT" // linear only
                    //                 "transfer_profit_ratio":null // inverse only
                    //             },
                    //         ],
                    //         "ts":1637644827566
                    //     }
                    //
                    // linear cross futures and linear cross swap
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "futures_contract_detail":[
                    //                     {
                    //                         "symbol":"ETH",
                    //                         "contract_code":"ETH-USDT-220325",
                    //                         "margin_position":0,
                    //                         "margin_frozen":0,
                    //                         "margin_available":200.000000000000000000,
                    //                         "profit_unreal":0E-18,
                    //                         "liquidation_price":null,
                    //                         "lever_rate":5,
                    //                         "adjust_factor":0.060000000000000000,
                    //                         "contract_type":"quarter",
                    //                         "pair":"ETH-USDT",
                    //                         "business_type":"futures"
                    //                     },
                    //                 ],
                    //                 "margin_mode":"cross",
                    //                 "margin_account":"USDT",
                    //                 "margin_asset":"USDT",
                    //                 "margin_balance":200.000000000000000000,
                    //                 "margin_static":200.000000000000000000,
                    //                 "margin_position":0,
                    //                 "margin_frozen":0,
                    //                 "profit_real":0E-18,
                    //                 "profit_unreal":0,
                    //                 "withdraw_available":2E+2,
                    //                 "risk_rate":null,
                    //                 "contract_detail":[
                    //                     {
                    //                         "symbol":"MANA",
                    //                         "contract_code":"MANA-USDT",
                    //                         "margin_position":0,
                    //                         "margin_frozen":0,
                    //                         "margin_available":200.000000000000000000,
                    //                         "profit_unreal":0E-18,
                    //                         "liquidation_price":null,
                    //                         "lever_rate":5,
                    //                         "adjust_factor":0.100000000000000000,
                    //                         "contract_type":"swap",
                    //                         "pair":"MANA-USDT",
                    //                         "business_type":"swap"
                    //                     },
                    //                 ]
                    //             }
                    //         ],
                    //         "ts":1640915104870
                    //     }
                    //
                    const result = {
                        'info': response
                    };
                    const data = this.safeValue(response, 'data');
                    if (spot) {
                        const balances = this.safeValue(data, 'list', []);
                        for(let i = 0; i < balances.length; i++){
                            const balance = balances[i];
                            const currencyId = this.safeString(balance, 'currency');
                            const code = this.safeCurrencyCode(currencyId);
                            let account = undefined;
                            if (code in result) account = result[code];
                            else account = this.account();
                            if (balance['type'] === 'trade') account['free'] = this.safeString(balance, 'balance');
                            if (balance['type'] === 'frozen') account['used'] = this.safeString(balance, 'balance');
                            result[code] = account;
                        }
                    } else if (linear) {
                        const first = this.safeValue(data, 0, {});
                        if (cross) {
                            const account = this.account();
                            account['free'] = this.safeString(first, 'margin_balance', 'margin_available');
                            account['used'] = this.safeString(first, 'margin_frozen');
                            const currencyId = this.safeString2(first, 'margin_asset', 'symbol');
                            const code = this.safeCurrencyCode(currencyId);
                            result[code] = account;
                        } else if (isolated) {
                            for(let i = 0; i < data.length; i++){
                                const balance = data[i];
                                const marketId = this.safeString2(balance, 'contract_code', 'margin_account');
                                const market = this.safeMarket(marketId);
                                const currencyId = this.safeString(balance, 'margin_asset');
                                const currency = this.safeCurrency(currencyId);
                                const code = this.safeString(market, 'settle', currency['code']);
                                // the exchange outputs positions for delisted markets
                                // https://www.huobi.com/support/en-us/detail/74882968522337
                                // we skip it if the market was delisted
                                if (code !== undefined) {
                                    const account = this.account();
                                    account['free'] = this.safeString(balance, 'margin_balance');
                                    account['used'] = this.safeString(balance, 'margin_frozen');
                                    const accountsByCode = {};
                                    accountsByCode[code] = account;
                                    const symbol = market['symbol'];
                                    result[symbol] = this.safeBalance(accountsByCode);
                                }
                            }
                            return result;
                        }
                    } else if (inverse) for(let i = 0; i < data.length; i++){
                        const balance = data[i];
                        const currencyId = this.safeString(balance, 'symbol');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'margin_available');
                        account['used'] = this.safeString(balance, 'margin_frozen');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    let marketType = undefined;
                    [marketType, params] = this.handleMarketTypeAndParams('fetchOrder', undefined, params);
                    const request = {
                    };
                    let method = undefined;
                    let market = undefined;
                    if (marketType === 'spot') {
                        const clientOrderId = this.safeString(params, 'clientOrderId');
                        method = 'spotPrivateGetV1OrderOrdersOrderId';
                        if (clientOrderId !== undefined) method = 'spotPrivateGetV1OrderOrdersGetClientOrder';
                        else request['order-id'] = id;
                    } else {
                        if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol for ' + marketType + ' orders');
                        market = this.market(symbol);
                        request['contract_code'] = market['id'];
                        if (market['linear']) {
                            const defaultMargin = market['future'] ? 'cross' : 'isolated';
                            const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                            if (marginMode === 'isolated') method = 'contractPrivatePostLinearSwapApiV1SwapOrderInfo';
                            else if (marginMode === 'cross') method = 'contractPrivatePostLinearSwapApiV1SwapCrossOrderInfo';
                        } else if (market['inverse']) {
                            if (marketType === 'future') {
                                method = 'contractPrivatePostApiV1ContractOrderInfo';
                                request['symbol'] = market['settleId'];
                            } else if (marketType === 'swap') method = 'contractPrivatePostSwapApiV1SwapOrderInfo';
                            else throw new NotSupported(this.id + ' fetchOrder() does not support ' + marketType + ' markets');
                        }
                        const clientOrderId = this.safeString2(params, 'client_order_id', 'clientOrderId');
                        if (clientOrderId === undefined) request['order_id'] = id;
                        else {
                            request['client_order_id'] = clientOrderId;
                            params = this.omit(params, [
                                'client_order_id',
                                'clientOrderId'
                            ]);
                        }
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":{
                    //             "id":438398393065481,
                    //             "symbol":"ethusdt",
                    //             "account-id":1528640,
                    //             "client-order-id":"AA03022abc2163433e-006b-480e-9ad1-d4781478c5e7",
                    //             "amount":"0.100000000000000000",
                    //             "price":"3000.000000000000000000",
                    //             "created-at":1640549994642,
                    //             "type":"buy-limit",
                    //             "field-amount":"0.0",
                    //             "field-cash-amount":"0.0",
                    //             "field-fees":"0.0",
                    //             "finished-at":0,
                    //             "source":"spot-api",
                    //             "state":"submitted",
                    //             "canceled-at":0
                    //         }
                    //     }
                    //
                    // linear swap cross margin
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "business_type":"swap",
                    //                 "contract_type":"swap",
                    //                 "pair":"BTC-USDT",
                    //                 "symbol":"BTC",
                    //                 "contract_code":"BTC-USDT",
                    //                 "volume":1,
                    //                 "price":3000,
                    //                 "order_price_type":"limit",
                    //                 "order_type":1,
                    //                 "direction":"buy",
                    //                 "offset":"open",
                    //                 "lever_rate":1,
                    //                 "order_id":924912513206878210,
                    //                 "client_order_id":null,
                    //                 "created_at":1640557927189,
                    //                 "trade_volume":0,
                    //                 "trade_turnover":0,
                    //                 "fee":0,
                    //                 "trade_avg_price":null,
                    //                 "margin_frozen":3.000000000000000000,
                    //                 "profit":0,
                    //                 "status":3,
                    //                 "order_source":"api",
                    //                 "order_id_str":"924912513206878210",
                    //                 "fee_asset":"USDT",
                    //                 "liquidation_type":"0",
                    //                 "canceled_at":0,
                    //                 "margin_asset":"USDT",
                    //                 "margin_account":"USDT",
                    //                 "margin_mode":"cross",
                    //                 "is_tpsl":0,
                    //                 "real_profit":0
                    //             }
                    //         ],
                    //         "ts":1640557982556
                    //     }
                    //
                    // linear swap isolated margin detail
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": {
                    //             "symbol": "BTC",
                    //             "contract_code": "BTC-USDT",
                    //             "instrument_price": 0,
                    //             "final_interest": 0,
                    //             "adjust_value": 0,
                    //             "lever_rate": 10,
                    //             "direction": "sell",
                    //             "offset": "open",
                    //             "volume": 1.000000000000000000,
                    //             "price": 13059.800000000000000000,
                    //             "created_at": 1603703614712,
                    //             "canceled_at": 0,
                    //             "order_source": "api",
                    //             "order_price_type": "opponent",
                    //             "margin_frozen": 0,
                    //             "profit": 0,
                    //             "trades": [
                    //                 {
                    //                     "trade_id": 131560927,
                    //                     "trade_price": 13059.800000000000000000,
                    //                     "trade_volume": 1.000000000000000000,
                    //                     "trade_turnover": 13.059800000000000000,
                    //                     "trade_fee": -0.005223920000000000,
                    //                     "created_at": 1603703614715,
                    //                     "role": "taker",
                    //                     "fee_asset": "USDT",
                    //                     "profit": 0,
                    //                     "real_profit": 0,
                    //                     "id": "131560927-770334322963152896-1"
                    //                 }
                    //             ],
                    //             "total_page": 1,
                    //             "current_page": 1,
                    //             "total_size": 1,
                    //             "liquidation_type": "0",
                    //             "fee_asset": "USDT",
                    //             "fee": -0.005223920000000000,
                    //             "order_id": 770334322963152896,
                    //             "order_id_str": "770334322963152896",
                    //             "client_order_id": 57012021045,
                    //             "order_type": "1",
                    //             "status": 6,
                    //             "trade_avg_price": 13059.800000000000000000,
                    //             "trade_turnover": 13.059800000000000000,
                    //             "trade_volume": 1.000000000000000000,
                    //             "margin_asset": "USDT",
                    //             "margin_mode": "isolated",
                    //             "margin_account": "BTC-USDT",
                    //             "real_profit": 0,
                    //             "is_tpsl": 0
                    //         },
                    //         "ts": 1603703678477
                    //     }
                    let order = this.safeValue(response, 'data');
                    if (Array.isArray(order)) order = this.safeValue(order, 0);
                    return this.parseOrder(order);
                }
                async fetchSpotOrdersByStates(states, symbol, since, limit, params = {}) {
                    const method = this.safeString(this.options, 'fetchOrdersByStatesMethod', 'spot_private_get_v1_order_orders'); // spot_private_get_v1_order_history
                    if (method === 'spot_private_get_v1_order_orders') {
                        if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    }
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        // spot_private_get_v1_order_orders GET /v1/order/orders ----------
                        // 'symbol': market['id'], // required
                        // 'types': 'buy-market,sell-market,buy-limit,sell-limit,buy-ioc,sell-ioc,buy-stop-limit,sell-stop-limit,buy-limit-fok,sell-limit-fok,buy-stop-limit-fok,sell-stop-limit-fok',
                        // 'start-time': since, // max window of 48h within a range of 180 days, within past 2 hours for cancelled orders
                        // 'end-time': this.milliseconds (),
                        'states': states
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) {
                        request['start-time'] = since; // a window of 48 hours within 180 days
                        request['end-time'] = this.sum(since, 172800000);
                    }
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot_private_get_v1_order_orders GET /v1/order/orders
                    //
                    //     {
                    //         status: "ok",
                    //         data: [
                    //             {
                    //                 id: 13997833014,
                    //                 symbol: "ethbtc",
                    //                 'account-id': 3398321,
                    //                 'client-order-id': "23456",
                    //                 amount: "0.045000000000000000",
                    //                 price: "0.034014000000000000",
                    //                 'created-at': 1545836976871,
                    //                 type: "sell-limit",
                    //                 'field-amount': "0.045000000000000000",
                    //                 'field-cash-amount': "0.001530630000000000",
                    //                 'field-fees': "0.000003061260000000",
                    //                 'finished-at': 1545837948214,
                    //                 source: "spot-api",
                    //                 state: "filled",
                    //                 'canceled-at': 0
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchSpotOrders(symbol, since, limit, params = {}) {
                    return await this.fetchSpotOrdersByStates('pre-submitted,submitted,partial-filled,filled,partial-canceled,canceled', symbol, since, limit, params);
                }
                async fetchClosedSpotOrders(symbol, since, limit, params = {}) {
                    return await this.fetchSpotOrdersByStates('filled,partial-canceled,canceled', symbol, since, limit, params);
                }
                async fetchContractOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchContractOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let marketType = undefined;
                    [marketType, params] = this.handleMarketTypeAndParams('fetchOrders', market, params);
                    const request = {
                        // POST /api/v1/contract_hisorders inverse futures ----------------
                        // 'symbol': market['settleId'], // BTC, ETH, ...
                        // 'order_type': '1', // 1 limit，3 opponent，4 lightning, 5 trigger order, 6 pst_only, 7 optimal_5, 8 optimal_10, 9 optimal_20, 10 fok, 11 ioc
                        // POST /swap-api/v1/swap_hisorders inverse swap ------------------
                        // POST /linear-swap-api/v1/swap_hisorders linear isolated --------
                        // POST /linear-swap-api/v1/swap_cross_hisorders linear cross -----
                        'contract_code': market['id'],
                        'trade_type': 0,
                        'type': 1,
                        'status': '0',
                        'create_date': 90
                    };
                    let method = undefined;
                    request['contract_code'] = market['id'];
                    if (market['linear']) {
                        const defaultMargin = market['future'] ? 'cross' : 'isolated';
                        const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                        method = this.getSupportedMapping(marginMode, {
                            'isolated': 'contractPrivatePostLinearSwapApiV1SwapHisorders',
                            'cross': 'contractPrivatePostLinearSwapApiV1SwapCrossHisorders'
                        });
                    } else if (market['inverse']) {
                        method = this.getSupportedMapping(marketType, {
                            'future': 'contractPrivatePostApiV1ContractHisorders',
                            'swap': 'contractPrivatePostSwapApiV1SwapHisorders'
                        });
                        if (marketType === 'future') request['symbol'] = market['settleId'];
                    }
                    if (limit !== undefined) request['page_size'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": {
                    //             "orders": [
                    //                 {
                    //                     "order_id": 773131315209248768,
                    //                     "contract_code": "ADA201225",
                    //                     "symbol": "ADA",
                    //                     "lever_rate": 20,
                    //                     "direction": "buy",
                    //                     "offset": "close",
                    //                     "volume": 1,
                    //                     "price": 0.0925,
                    //                     "create_date": 1604370469629,
                    //                     "update_time": 1603704221118,
                    //                     "order_source": "web",
                    //                     "order_price_type": 6,
                    //                     "order_type": 1,
                    //                     "margin_frozen": 0,
                    //                     "profit": 0,
                    //                     "contract_type": "quarter",
                    //                     "trade_volume": 0,
                    //                     "trade_turnover": 0,
                    //                     "fee": 0,
                    //                     "trade_avg_price": 0,
                    //                     "status": 3,
                    //                     "order_id_str": "773131315209248768",
                    //                     "fee_asset": "ADA",
                    //                     "liquidation_type": "0",
                    //                     "is_tpsl": 0,
                    //                     "real_profit": 0
                    //                     "pair": "BTC-USDT",
                    //                     "business_type": "futures",
                    //                     "margin_asset": "USDT",
                    //                     "margin_mode": "cross",
                    //                     "margin_account": "USDT",
                    //                 }
                    //             ],
                    //             "total_page": 19,
                    //             "current_page": 1,
                    //             "total_size": 19
                    //         },
                    //         "ts": 1604370617322
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const orders = this.safeValue(data, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchClosedContractOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': '5,6,7'
                    };
                    return await this.fetchContractOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let marketType = undefined;
                    [marketType, params] = this.handleMarketTypeAndParams('fetchOrders', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'fetchSpotOrders',
                        'swap': 'fetchContractOrders',
                        'future': 'fetchContractOrders'
                    });
                    if (method === undefined) throw new NotSupported(this.id + ' fetchOrders() does not support ' + marketType + ' markets yet');
                    const contract = marketType === 'swap' || marketType === 'future';
                    if (contract && symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument for ' + marketType + ' orders');
                    return await this[method](symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let marketType = undefined;
                    [marketType, params] = this.handleMarketTypeAndParams('fetchClosedOrders', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'fetchClosedSpotOrders',
                        'swap': 'fetchClosedContractOrders',
                        'future': 'fetchClosedContractOrders'
                    });
                    if (method === undefined) throw new NotSupported(this.id + ' fetchClosedOrders() does not support ' + marketType + ' markets yet');
                    return await this[method](symbol, since, limit, params);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let marketType = undefined;
                    [marketType, params] = this.handleMarketTypeAndParams('fetchOpenOrders', undefined, params);
                    const request = {
                    };
                    let method = undefined;
                    let market = undefined;
                    if (marketType === 'spot') {
                        method = 'spotPrivateGetV1OrderOpenOrders';
                        if (symbol !== undefined) {
                            market = this.market(symbol);
                            request['symbol'] = market['id'];
                        }
                        // todo replace with fetchAccountIdByType
                        let accountId = this.safeString(params, 'account-id');
                        if (accountId === undefined) {
                            // pick the first account
                            await this.loadAccounts();
                            for(let i = 0; i < this.accounts.length; i++){
                                const account = this.accounts[i];
                                if (account['type'] === 'spot') {
                                    accountId = this.safeString(account, 'id');
                                    if (accountId !== undefined) break;
                                }
                            }
                        }
                        request['account-id'] = accountId;
                        if (limit !== undefined) request['size'] = limit;
                        params = this.omit(params, 'account-id');
                    } else {
                        if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol for ' + marketType + ' orders');
                        const market = this.market(symbol);
                        request['contract_code'] = market['id'];
                        if (market['linear']) {
                            const defaultMargin = market['future'] ? 'cross' : 'isolated';
                            const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                            if (marginMode === 'isolated') method = 'contractPrivatePostLinearSwapApiV1SwapOpenorders';
                            else if (marginMode === 'cross') method = 'contractPrivatePostLinearSwapApiV1SwapCrossOpenorders';
                        } else if (market['inverse']) {
                            if (market['future']) {
                                method = 'contractPrivatePostApiV1ContractOpenorders';
                                request['symbol'] = market['settleId'];
                            } else if (market['swap']) method = 'contractPrivatePostSwapApiV1SwapOpenorders';
                        }
                        if (limit !== undefined) request['page_size'] = limit;
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "symbol":"ethusdt",
                    //                 "source":"api",
                    //                 "amount":"0.010000000000000000",
                    //                 "account-id":1528640,
                    //                 "created-at":1561597491963,
                    //                 "price":"400.000000000000000000",
                    //                 "filled-amount":"0.0",
                    //                 "filled-cash-amount":"0.0",
                    //                 "filled-fees":"0.0",
                    //                 "id":38477101630,
                    //                 "state":"submitted",
                    //                 "type":"sell-limit"
                    //             }
                    //         ]
                    //     }
                    //
                    // futures
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": {
                    //             "orders": [
                    //                 {
                    //                     "symbol": "ADA",
                    //                     "contract_code": "ADA201225",
                    //                     "contract_type": "quarter",
                    //                     "volume": 1,
                    //                     "price": 0.0925,
                    //                     "order_price_type": "post_only",
                    //                     "order_type": 1,
                    //                     "direction": "buy",
                    //                     "offset": "close",
                    //                     "lever_rate": 20,
                    //                     "order_id": 773131315209248768,
                    //                     "client_order_id": null,
                    //                     "created_at": 1604370469629,
                    //                     "trade_volume": 0,
                    //                     "trade_turnover": 0,
                    //                     "fee": 0,
                    //                     "trade_avg_price": null,
                    //                     "margin_frozen": 0,
                    //                     "profit": 0,
                    //                     "status": 3,
                    //                     "order_source": "web",
                    //                     "order_id_str": "773131315209248768",
                    //                     "fee_asset": "ADA",
                    //                     "liquidation_type": null,
                    //                     "canceled_at": null,
                    //                     "is_tpsl": 0,
                    //                     "update_time": 1606975980467,
                    //                     "real_profit": 0
                    //                 }
                    //             ],
                    //             "total_page": 1,
                    //             "current_page": 1,
                    //             "total_size": 1
                    //         },
                    //         "ts": 1604370488518
                    //     }
                    //
                    let orders = this.safeValue(response, 'data');
                    if (!Array.isArray(orders)) orders = this.safeValue(orders, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        // spot
                        'partial-filled': 'open',
                        'partial-canceled': 'canceled',
                        'filled': 'closed',
                        'canceled': 'canceled',
                        'submitted': 'open',
                        'created': 'open',
                        // contract
                        '1': 'open',
                        '2': 'open',
                        '3': 'open',
                        '4': 'open',
                        '5': 'canceled',
                        '6': 'closed',
                        '7': 'canceled',
                        '11': 'canceling'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // spot
                    //
                    //     {
                    //         id:  13997833014,
                    //         symbol: "ethbtc",
                    //         'account-id':  3398321,
                    //         amount: "0.045000000000000000",
                    //         price: "0.034014000000000000",
                    //         'created-at':  1545836976871,
                    //         type: "sell-limit",
                    //         'field-amount': "0.045000000000000000", // they have fixed it for filled-amount
                    //         'field-cash-amount': "0.001530630000000000", // they have fixed it for filled-cash-amount
                    //         'field-fees': "0.000003061260000000", // they have fixed it for filled-fees
                    //         'finished-at':  1545837948214,
                    //         source: "spot-api",
                    //         state: "filled",
                    //         'canceled-at':  0
                    //     }
                    //
                    //     {
                    //         id:  20395337822,
                    //         symbol: "ethbtc",
                    //         'account-id':  5685075,
                    //         amount: "0.001000000000000000",
                    //         price: "0.0",
                    //         'created-at':  1545831584023,
                    //         type: "buy-market",
                    //         'field-amount': "0.029100000000000000", // they have fixed it for filled-amount
                    //         'field-cash-amount': "0.000999788700000000", // they have fixed it for filled-cash-amount
                    //         'field-fees': "0.000058200000000000", // they have fixed it for filled-fees
                    //         'finished-at':  1545831584181,
                    //         source: "spot-api",
                    //         state: "filled",
                    //         'canceled-at':  0
                    //     }
                    //
                    // linear swap cross margin createOrder
                    //
                    //     {
                    //         "order_id":924660854912552960,
                    //         "order_id_str":"924660854912552960"
                    //     }
                    //
                    // contracts fetchOrder
                    //
                    //     {
                    //         "business_type":"swap",
                    //         "contract_type":"swap",
                    //         "pair":"BTC-USDT",
                    //         "symbol":"BTC",
                    //         "contract_code":"BTC-USDT",
                    //         "volume":1,
                    //         "price":3000,
                    //         "order_price_type":"limit",
                    //         "order_type":1,
                    //         "direction":"buy",
                    //         "offset":"open",
                    //         "lever_rate":1,
                    //         "order_id":924912513206878210,
                    //         "client_order_id":null,
                    //         "created_at":1640557927189,
                    //         "trade_volume":0,
                    //         "trade_turnover":0,
                    //         "fee":0,
                    //         "trade_avg_price":null,
                    //         "margin_frozen":3.000000000000000000,
                    //         "profit":0,
                    //         "status":3,
                    //         "order_source":"api",
                    //         "order_id_str":"924912513206878210",
                    //         "fee_asset":"USDT",
                    //         "liquidation_type":"0",
                    //         "canceled_at":0,
                    //         "margin_asset":"USDT",
                    //         "margin_account":"USDT",
                    //         "margin_mode":"cross",
                    //         "is_tpsl":0,
                    //         "real_profit":0
                    //     }
                    //
                    // contracts fetchOrder detailed
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": {
                    //             "symbol": "BTC",
                    //             "contract_code": "BTC-USDT",
                    //             "instrument_price": 0,
                    //             "final_interest": 0,
                    //             "adjust_value": 0,
                    //             "lever_rate": 10,
                    //             "direction": "sell",
                    //             "offset": "open",
                    //             "volume": 1.000000000000000000,
                    //             "price": 13059.800000000000000000,
                    //             "created_at": 1603703614712,
                    //             "canceled_at": 0,
                    //             "order_source": "api",
                    //             "order_price_type": "opponent",
                    //             "margin_frozen": 0,
                    //             "profit": 0,
                    //             "trades": [
                    //                 {
                    //                     "trade_id": 131560927,
                    //                     "trade_price": 13059.800000000000000000,
                    //                     "trade_volume": 1.000000000000000000,
                    //                     "trade_turnover": 13.059800000000000000,
                    //                     "trade_fee": -0.005223920000000000,
                    //                     "created_at": 1603703614715,
                    //                     "role": "taker",
                    //                     "fee_asset": "USDT",
                    //                     "profit": 0,
                    //                     "real_profit": 0,
                    //                     "id": "131560927-770334322963152896-1"
                    //                 }
                    //             ],
                    //             "total_page": 1,
                    //             "current_page": 1,
                    //             "total_size": 1,
                    //             "liquidation_type": "0",
                    //             "fee_asset": "USDT",
                    //             "fee": -0.005223920000000000,
                    //             "order_id": 770334322963152896,
                    //             "order_id_str": "770334322963152896",
                    //             "client_order_id": 57012021045,
                    //             "order_type": "1",
                    //             "status": 6,
                    //             "trade_avg_price": 13059.800000000000000000,
                    //             "trade_turnover": 13.059800000000000000,
                    //             "trade_volume": 1.000000000000000000,
                    //             "margin_asset": "USDT",
                    //             "margin_mode": "isolated",
                    //             "margin_account": "BTC-USDT",
                    //             "real_profit": 0,
                    //             "is_tpsl": 0
                    //         },
                    //         "ts": 1603703678477
                    //     }
                    //
                    const id = this.safeString2(order, 'id', 'order_id_str');
                    let side = this.safeString(order, 'direction');
                    let type = this.safeString(order, 'order_price_type');
                    if ('type' in order) {
                        const orderType = order['type'].split('-');
                        side = orderType[0];
                        type = orderType[1];
                    }
                    const status = this.parseOrderStatus(this.safeString2(order, 'state', 'status'));
                    const marketId = this.safeString2(order, 'contract_code', 'symbol');
                    market = this.safeMarket(marketId, market);
                    const timestamp = this.safeInteger2(order, 'created_at', 'created-at');
                    const clientOrderId = this.safeString2(order, 'client_order_id', 'client-order-id');
                    const amount = this.safeString2(order, 'volume', 'amount');
                    let filled = this.safeString2(order, 'filled-amount', 'field-amount'); // typo in their API, filled amount
                    filled = this.safeString(order, 'trade_volume', filled);
                    const price = this.safeString(order, 'price');
                    let cost = this.safeString2(order, 'filled-cash-amount', 'field-cash-amount'); // same typo
                    cost = this.safeString(order, 'trade_turnover', cost);
                    let feeCost = this.safeString2(order, 'filled-fees', 'field-fees'); // typo in their API, filled feeSide
                    feeCost = this.safeString(order, 'fee', feeCost);
                    let fee = undefined;
                    if (feeCost !== undefined) {
                        let feeCurrency = undefined;
                        const feeCurrencyId = this.safeString(order, 'fee_asset');
                        if (feeCurrencyId !== undefined) feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                        else feeCurrency = side === 'sell' ? market['quote'] : market['base'];
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrency
                        };
                    }
                    const stopPrice = this.safeString(order, 'stop-price');
                    const average = this.safeString(order, 'trade_avg_price');
                    const trades = this.safeValue(order, 'trades');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'average': average,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': trades
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('createOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'createSpotOrder',
                        'swap': 'createContractOrder',
                        'future': 'createContractOrder'
                    });
                    if (method === undefined) throw new NotSupported(this.id + ' createOrder() does not support ' + marketType + ' markets yet');
                    return await this[method](symbol, type, side, amount, price, query);
                }
                async createSpotOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const market = this.market(symbol);
                    const accountId = await this.fetchAccountIdByType(market['type']);
                    const request = {
                        // spot -----------------------------------------------------------
                        'account-id': accountId,
                        'symbol': market['id']
                    };
                    let orderType = type.replace('buy-', '');
                    orderType = orderType.replace('sell-', '');
                    const options = this.safeValue(this.options, market['type'], {});
                    const stopPrice = this.safeString2(params, 'stopPrice', 'stop-price');
                    if (stopPrice === undefined) {
                        const stopOrderTypes = this.safeValue(options, 'stopOrderTypes', {});
                        if (orderType in stopOrderTypes) throw new ArgumentsRequired1(this.id + ' createOrder() requires a stopPrice or a stop-price parameter for a stop order');
                    } else {
                        const stopOperator = this.safeString(params, 'operator');
                        if (stopOperator === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires an operator parameter "gte" or "lte" for a stop order');
                        params = this.omit(params, [
                            'stopPrice',
                            'stop-price'
                        ]);
                        request['stop-price'] = this.priceToPrecision(symbol, stopPrice);
                        request['operator'] = stopOperator;
                        if (orderType === 'limit' || orderType === 'limit-fok') orderType = 'stop-' + orderType;
                        else if (orderType !== 'stop-limit' && orderType !== 'stop-limit-fok') throw new NotSupported(this.id + ' createOrder() does not support ' + type + ' orders');
                    }
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    if (postOnly) orderType = 'limit-maker';
                    request['type'] = side + '-' + orderType;
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client-order-id'); // must be 64 chars max and unique within 24 hours
                    if (clientOrderId === undefined) {
                        const broker = this.safeValue(this.options, 'broker', {});
                        const brokerId = this.safeString(broker, 'id');
                        request['client-order-id'] = brokerId + this.uuid();
                    } else request['client-order-id'] = clientOrderId;
                    params = this.omit(params, [
                        'clientOrderId',
                        'client-order-id',
                        'postOnly'
                    ]);
                    if (orderType === 'market' && side === 'buy') {
                        if (this.options['createMarketBuyOrderRequiresPrice']) {
                            if (price === undefined) throw new InvalidOrder(this.id + " market buy order requires price argument to calculate cost (total amount of quote currency to spend for buying, amount * price). To switch off this warning exception and specify cost in the amount argument, set .options['createMarketBuyOrderRequiresPrice'] = false. Make sure you know what you're doing.");
                            else // despite that cost = amount * price is in quote currency and should have quote precision
                            // the exchange API requires the cost supplied in 'amount' to be of base precision
                            // more about it here:
                            // https://github.com/ccxt/ccxt/pull/4395
                            // https://github.com/ccxt/ccxt/issues/7611
                            // we use amountToPrecision here because the exchange requires cost in base precision
                            request['amount'] = this.costToPrecision(symbol, parseFloat(amount) * parseFloat(price));
                        } else request['amount'] = this.costToPrecision(symbol, amount);
                    } else request['amount'] = this.amountToPrecision(symbol, amount);
                    const limitOrderTypes = this.safeValue(options, 'limitOrderTypes', {});
                    if (orderType in limitOrderTypes) request['price'] = this.priceToPrecision(symbol, price);
                    const response = await this.spotPrivatePostV1OrderOrdersPlace(this.extend(request, params));
                    //
                    // spot
                    //
                    //     {"status":"ok","data":"438398393065481"}
                    //
                    const id = this.safeString(response, 'data');
                    return {
                        'info': response,
                        'id': id,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'lastTradeTimestamp': undefined,
                        'status': undefined,
                        'symbol': undefined,
                        'type': undefined,
                        'side': undefined,
                        'price': undefined,
                        'amount': undefined,
                        'filled': undefined,
                        'remaining': undefined,
                        'cost': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'clientOrderId': undefined,
                        'average': undefined
                    };
                }
                async createContractOrder(symbol, type, side, amount, price, params = {}) {
                    const offset = this.safeString(params, 'offset');
                    if (offset === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a string offset parameter for contract orders, open or close');
                    const stopPrice = this.safeString(params, 'stopPrice');
                    if (stopPrice !== undefined) throw new NotSupported(this.id + ' createOrder() supports tp_trigger_price + tp_order_price for take profit orders and/or sl_trigger_price + sl_order price for stop loss orders, stop orders are supported only with open long orders and open short orders');
                    const market = this.market(symbol);
                    const request = {
                        // 'symbol': 'BTC', // optional, case-insenstive, both uppercase and lowercase are supported, "BTC", "ETH", ...
                        // 'contract_type': 'this_week', // optional, this_week, next_week, quarter, next_quarter
                        'contract_code': market['id'],
                        // 'client_order_id': clientOrderId, // optional, must be less than 9223372036854775807
                        // 'price': this.priceToPrecision (symbol, price), // optional
                        'volume': this.amountToPrecision(symbol, amount),
                        'direction': side,
                        'offset': offset,
                        //
                        //     direction buy, offset open = open long
                        //     direction sell, offset close = close long
                        //     direction sell, offset open = open short
                        //     direction buy, offset close = close short
                        //
                        // 'reduce_only': 0, // 1 or 0, in hedge mode it is invalid, and in one-way mode its value is 0 when not filled
                        'lever_rate': 1
                    };
                    const stopLossOrderPrice = this.safeString(params, 'sl_order_price');
                    const stopLossTriggerPrice = this.safeString(params, 'sl_trigger_price');
                    const takeProfitOrderPrice = this.safeString(params, 'tp_order_price');
                    const takeProfitTriggerPrice = this.safeString(params, 'tp_trigger_price');
                    const isOpenOrder = offset === 'open';
                    let isStopOrder = false;
                    if (stopLossTriggerPrice !== undefined) {
                        request['sl_trigger_price'] = this.priceToPrecision(symbol, stopLossTriggerPrice);
                        isStopOrder = true;
                        if (price !== undefined) request['sl_order_price'] = this.priceToPrecision(symbol, price);
                    }
                    if (stopLossOrderPrice !== undefined) {
                        request['sl_order_price'] = this.priceToPrecision(symbol, stopLossOrderPrice);
                        isStopOrder = true;
                    }
                    if (takeProfitTriggerPrice !== undefined) {
                        request['tp_trigger_price'] = this.priceToPrecision(symbol, takeProfitTriggerPrice);
                        isStopOrder = true;
                        if (price !== undefined) request['tp_order_price'] = this.priceToPrecision(symbol, price);
                    }
                    if (takeProfitOrderPrice !== undefined) {
                        request['tp_order_price'] = this.priceToPrecision(symbol, takeProfitOrderPrice);
                        isStopOrder = true;
                    }
                    if (isStopOrder && !isOpenOrder) throw new NotSupported(this.id + ' createOrder() supports tp_trigger_price + tp_order_price for take profit orders and/or sl_trigger_price + sl_order price for stop loss orders, stop orders are supported only with open long orders and open short orders');
                    params = this.omit(params, [
                        'sl_order_price',
                        'sl_trigger_price',
                        'tp_order_price',
                        'tp_trigger_price'
                    ]);
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    if (postOnly) type = 'post_only';
                    if (type === 'limit' || type === 'ioc' || type === 'fok' || type === 'post_only') request['price'] = this.priceToPrecision(symbol, price);
                    request['order_price_type'] = type;
                    const broker = this.safeValue(this.options, 'broker', {});
                    const brokerId = this.safeString(broker, 'id');
                    request['channel_code'] = brokerId;
                    const clientOrderId = this.safeString2(params, 'client_order_id', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['client_order_id'] = clientOrderId;
                        params = this.omit(params, [
                            'client_order_id',
                            'clientOrderId'
                        ]);
                    }
                    let method = undefined;
                    if (market['linear']) {
                        const defaultMargin = market['future'] ? 'cross' : 'isolated';
                        const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                        if (marginMode === 'isolated') method = 'contractPrivatePostLinearSwapApiV1SwapOrder';
                        else if (marginMode === 'cross') method = 'contractPrivatePostLinearSwapApiV1SwapCrossOrder';
                    } else if (market['inverse']) {
                        if (market['swap']) method = 'contractPrivatePostSwapApiV1SwapOrder';
                        else if (market['future']) method = 'contractPrivatePostApiV1ContractOrder';
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // linear swap cross margin
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":{
                    //             "order_id":924660854912552960,
                    //             "order_id_str":"924660854912552960"
                    //         },
                    //         "ts":1640497927185
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    let marketType = undefined;
                    [marketType, params] = this.handleMarketTypeAndParams('cancelOrder', undefined, params);
                    const request = {
                    };
                    let method = undefined;
                    let market = undefined;
                    if (marketType === 'spot') {
                        const clientOrderId = this.safeString2(params, 'client-order-id', 'clientOrderId');
                        method = 'spotPrivatePostV1OrderOrdersOrderIdSubmitcancel';
                        if (clientOrderId === undefined) request['order-id'] = id;
                        else {
                            request['client-order-id'] = clientOrderId;
                            method = 'spotPrivatePostV1OrderOrdersSubmitCancelClientOrder';
                            params = this.omit(params, [
                                'client-order-id',
                                'clientOrderId'
                            ]);
                        }
                    } else {
                        if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol for ' + marketType + ' orders');
                        market = this.market(symbol);
                        request['contract_code'] = market['id'];
                        if (market['linear']) {
                            const defaultMargin = market['future'] ? 'cross' : 'isolated';
                            const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                            if (marginMode === 'isolated') method = 'contractPrivatePostLinearSwapApiV1SwapCancel';
                            else if (marginMode === 'cross') method = 'contractPrivatePostLinearSwapApiV1SwapCrossCancel';
                        } else if (market['inverse']) {
                            if (market['future']) {
                                method = 'contractPrivatePostApiV1ContractCancel';
                                request['symbol'] = market['settleId'];
                            } else if (market['swap']) method = 'contractPrivatePostSwapApiV1SwapCancel';
                        } else throw new NotSupported(this.id + ' cancelOrder() does not support ' + marketType + ' markets');
                        const clientOrderId = this.safeString2(params, 'client_order_id', 'clientOrderId');
                        if (clientOrderId === undefined) request['order_id'] = id;
                        else {
                            request['client_order_id'] = clientOrderId;
                            params = this.omit(params, [
                                'client_order_id',
                                'clientOrderId'
                            ]);
                        }
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         'status': 'ok',
                    //         'data': '10138899000',
                    //     }
                    //
                    // linear swap cross margin
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":{
                    //             "errors":[],
                    //             "successes":"924660854912552960"
                    //         },
                    //         "ts":1640504486089
                    //     }
                    //
                    return this.extend(this.parseOrder(response, market), {
                        'id': id,
                        'status': 'canceled'
                    });
                }
                async cancelOrders(ids, symbol, params = {}) {
                    await this.loadMarkets();
                    let marketType = undefined;
                    [marketType, params] = this.handleMarketTypeAndParams('cancelOrder', undefined, params);
                    const request = {
                    };
                    let method = undefined;
                    if (marketType === 'spot') {
                        let clientOrderIds = this.safeValue2(params, 'client-order-id', 'clientOrderId');
                        clientOrderIds = this.safeValue2(params, 'client-order-ids', 'clientOrderIds', clientOrderIds);
                        if (clientOrderIds === undefined) {
                            if (typeof clientOrderIds === 'string') request['order-ids'] = ids;
                            else request['order-ids'] = ids.join(',');
                        } else {
                            if (typeof clientOrderIds === 'string') request['client-order-ids'] = clientOrderIds;
                            else request['client-order-ids'] = clientOrderIds.join(',');
                            params = this.omit(params, [
                                'client-order-id',
                                'client-order-ids',
                                'clientOrderId',
                                'clientOrderIds'
                            ]);
                        }
                        method = 'spotPrivatePostV1OrderOrdersBatchcancel';
                    } else {
                        if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrders() requires a symbol for ' + marketType + ' orders');
                        const market = this.market(symbol);
                        request['contract_code'] = market['id'];
                        if (market['linear']) {
                            const defaultMargin = market['future'] ? 'cross' : 'isolated';
                            const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                            if (marginMode === 'isolated') method = 'contractPrivatePostLinearSwapApiV1SwapCancel';
                            else if (marginMode === 'cross') method = 'contractPrivatePostLinearSwapApiV1SwapCrossCancel';
                        } else if (market['inverse']) {
                            if (market['future']) {
                                method = 'contractPrivatePostApiV1ContractCancel';
                                request['symbol'] = market['settleId'];
                            } else if (market['swap']) method = 'contractPrivatePostSwapApiV1SwapCancel';
                            else throw new NotSupported(this.id + ' cancelOrders() does not support ' + marketType + ' markets');
                        }
                        let clientOrderIds = this.safeString2(params, 'client_order_id', 'clientOrderId');
                        clientOrderIds = this.safeString2(params, 'client_order_ids', 'clientOrderIds', clientOrderIds);
                        if (clientOrderIds === undefined) request['order_id'] = ids.join(',');
                        else {
                            request['client_order_id'] = clientOrderIds;
                            params = this.omit(params, [
                                'client_order_id',
                                'client_order_ids',
                                'clientOrderId',
                                'clientOrderIds'
                            ]);
                        }
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": {
                    //             "success": [
                    //                 "5983466"
                    //             ],
                    //             "failed": [
                    //                 {
                    //                     "err-msg": "Incorrect order state",
                    //                     "order-state": 7,
                    //                     "order-id": "",
                    //                     "err-code": "order-orderstate-error",
                    //                     "client-order-id": "first"
                    //                 },
                    //                 {
                    //                     "err-msg": "Incorrect order state",
                    //                     "order-state": 7,
                    //                     "order-id": "",
                    //                     "err-code": "order-orderstate-error",
                    //                     "client-order-id": "second"
                    //                 },
                    //                 {
                    //                     "err-msg": "The record is not found.",
                    //                     "order-id": "",
                    //                     "err-code": "base-not-found",
                    //                     "client-order-id": "third"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    // contracts
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": {
                    //             "errors": [
                    //                 {
                    //                     "order_id": "769206471845261312",
                    //                     "err_code": 1061,
                    //                     "err_msg": "This order doesnt exist."
                    //                 }
                    //             ],
                    //             "successes": "773120304138219520"
                    //         },
                    //         "ts": 1604367997451
                    //     }
                    //
                    return response;
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    let marketType = undefined;
                    [marketType, params] = this.handleMarketTypeAndParams('cancelOrder', undefined, params);
                    const request = {
                    };
                    let market = undefined;
                    let method = undefined;
                    if (marketType === 'spot') {
                        if (symbol !== undefined) {
                            market = this.market(symbol);
                            request['symbol'] = market['id'];
                        }
                        method = 'spotPrivatePostV1OrderOrdersBatchCancelOpenOrders';
                    } else {
                        if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrders() requires a symbol for ' + marketType + ' orders');
                        const market = this.market(symbol);
                        request['contract_code'] = market['id'];
                        if (market['linear']) {
                            const defaultMargin = market['future'] ? 'cross' : 'isolated';
                            const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                            if (marginMode === 'isolated') method = 'contractPrivatePostLinearSwapApiV1SwapCancelallall';
                            else if (marginMode === 'cross') method = 'contractPrivatePostLinearSwapApiV1SwapCrossCancelall';
                        } else if (market['inverse']) {
                            if (marketType === 'future') {
                                method = 'contractPrivatePostApiV1ContractCancelall';
                                request['symbol'] = market['settleId'];
                            } else if (marketType === 'swap') method = 'contractPrivatePostSwapApiV1SwapCancelall';
                            else throw new NotSupported(this.id + ' cancelOrders() does not support ' + marketType + ' markets');
                        }
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         code: 200,
                    //         data: {
                    //             "success-count": 2,
                    //             "failed-count": 0,
                    //             "next-id": 5454600
                    //         }
                    //     }
                    //
                    return response;
                }
                currencyToPrecision(code, fee) {
                    return this.decimalToPrecision(fee, 0, this.currencies[code]['precision']);
                }
                safeNetwork(networkId) {
                    const lastCharacterIndex = networkId.length - 1;
                    const lastCharacter = networkId[lastCharacterIndex];
                    if (lastCharacter === '1') networkId = networkId.slice(0, lastCharacterIndex);
                    const networksById = {};
                    return this.safeString(networksById, networkId, networkId);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         currency: "usdt",
                    //         address: "0xf7292eb9ba7bc50358e27f0e025a4d225a64127b",
                    //         addressTag: "",
                    //         chain: "usdterc20", // trc20usdt, hrc20usdt, usdt, algousdt
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'address');
                    let tag = this.safeString(depositAddress, 'addressTag');
                    if (tag === '') tag = undefined;
                    const currencyId = this.safeString(depositAddress, 'currency');
                    currency = this.safeCurrency(currencyId, currency);
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const networkId = this.safeString(depositAddress, 'chain');
                    const networks = this.safeValue(currency, 'networks', {});
                    const networksById = this.indexBy(networks, 'id');
                    const networkValue = this.safeValue(networksById, networkId, networkId);
                    const network = this.safeString(networkValue, 'network');
                    const note = this.safeString(depositAddress, 'note');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': network,
                        'note': note,
                        'info': depositAddress
                    };
                }
                async fetchDepositAddressesByNetwork(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.spotPrivateGetV2AccountDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         code: 200,
                    //         data: [
                    //             {
                    //                 currency: "eth",
                    //                 address: "0xf7292eb9ba7bc50358e27f0e025a4d225a64127b",
                    //                 addressTag: "",
                    //                 chain: "eth"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const parsed = this.parseDepositAddresses(data, [
                        code
                    ], false);
                    return this.indexBy(parsed, 'network');
                }
                async fetchDepositAddress(code, params = {}) {
                    const rawNetwork = this.safeStringUpper(params, 'network');
                    const networks = this.safeValue(this.options, 'networks', {});
                    const network = this.safeStringUpper(networks, rawNetwork, rawNetwork);
                    params = this.omit(params, 'network');
                    const response = await this.fetchDepositAddressesByNetwork(code, params);
                    let result = undefined;
                    if (network === undefined) {
                        result = this.safeValue(response, code);
                        if (result === undefined) {
                            const alias = this.safeString(networks, code, code);
                            result = this.safeValue(response, alias);
                            if (result === undefined) {
                                const defaultNetwork = this.safeString(this.options, 'defaultNetwork', 'ERC20');
                                result = this.safeValue(response, defaultNetwork);
                                if (result === undefined) {
                                    const values = Object.values(response);
                                    result = this.safeValue(values, 0);
                                    if (result === undefined) throw new InvalidAddress(this.id + ' fetchDepositAddress() cannot find deposit address for ' + code);
                                }
                            }
                        }
                        return result;
                    }
                    result = this.safeValue(response, network);
                    if (result === undefined) throw new InvalidAddress(this.id + ' fetchDepositAddress() cannot find ' + network + ' deposit address for ' + code);
                    return result;
                }
                async fetchWithdrawAddressesByNetwork(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.spotPrivateGetV2AccountWithdrawAddress(this.extend(request, params));
                    //
                    //     {
                    //         code: 200,
                    //         data: [
                    //             {
                    //                 currency: "eth",
                    //                 chain: "eth"
                    //                 note: "Binance - TRC20",
                    //                 addressTag: "",
                    //                 address: "0xf7292eb9ba7bc50358e27f0e025a4d225a64127b",
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const parsed = this.parseDepositAddresses(data, [
                        code
                    ], false);
                    return this.indexBy(parsed, 'network');
                }
                async fetchWithdrawAddress(code, params = {}) {
                    const rawNetwork = this.safeStringUpper(params, 'network');
                    const networks = this.safeValue(this.options, 'networks', {});
                    const network = this.safeStringUpper(networks, rawNetwork, rawNetwork);
                    params = this.omit(params, 'network');
                    const response = await this.fetchWithdrawAddressesByNetwork(code, params);
                    let result = undefined;
                    if (network === undefined) {
                        result = this.safeValue(response, code);
                        if (result === undefined) {
                            const alias = this.safeString(networks, code, code);
                            result = this.safeValue(response, alias);
                            if (result === undefined) {
                                const defaultNetwork = this.safeString(this.options, 'defaultNetwork', 'ERC20');
                                result = this.safeValue(response, defaultNetwork);
                                if (result === undefined) {
                                    const values = Object.values(response);
                                    result = this.safeValue(values, 0);
                                    if (result === undefined) throw new InvalidAddress(this.id + ' fetchWithdrawAddress() cannot find withdraw address for ' + code);
                                }
                            }
                        }
                        return result;
                    }
                    result = this.safeValue(response, network);
                    if (result === undefined) throw new InvalidAddress(this.id + ' fetchWithdrawAddress() cannot find ' + network + ' withdraw address for ' + code);
                    return result;
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    if (limit === undefined || limit > 100) limit = 100;
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const request = {
                        'type': 'deposit',
                        'from': 0
                    };
                    if (currency !== undefined) request['currency'] = currency['id'];
                    if (limit !== undefined) request['size'] = limit; // max 100
                    const response = await this.spotPrivateGetV1QueryDepositWithdraw(this.extend(request, params));
                    // return response
                    return this.parseTransactions(response['data'], currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    if (limit === undefined || limit > 100) limit = 100;
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const request = {
                        'type': 'withdraw',
                        'from': 0
                    };
                    if (currency !== undefined) request['currency'] = currency['id'];
                    if (limit !== undefined) request['size'] = limit; // max 100
                    const response = await this.spotPrivateGetV1QueryDepositWithdraw(this.extend(request, params));
                    // return response
                    return this.parseTransactions(response['data'], currency, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         'id': 8211029,
                    //         'type': 'deposit',
                    //         'currency': 'eth',
                    //         'chain': 'eth',
                    //         'tx-hash': 'bd315....',
                    //         'amount': 0.81162421,
                    //         'address': '4b8b....',
                    //         'address-tag': '',
                    //         'fee': 0,
                    //         'state': 'safe',
                    //         'created-at': 1542180380965,
                    //         'updated-at': 1542180788077
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         'id': 6908275,
                    //         'type': 'withdraw',
                    //         'currency': 'btc',
                    //         'chain': 'btc',
                    //         'tx-hash': 'c1a1a....',
                    //         'amount': 0.80257005,
                    //         'address': '1QR....',
                    //         'address-tag': '',
                    //         'fee': 0.0005,
                    //         'state': 'confirmed',
                    //         'created-at': 1552107295685,
                    //         'updated-at': 1552108032859
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": "99562054"
                    //     }
                    //
                    const timestamp = this.safeInteger(transaction, 'created-at');
                    const updated = this.safeInteger(transaction, 'updated-at');
                    const code = this.safeCurrencyCode(this.safeString(transaction, 'currency'));
                    let type = this.safeString(transaction, 'type');
                    if (type === 'withdraw') type = 'withdrawal';
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    const tag = this.safeString(transaction, 'address-tag');
                    let feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost !== undefined) feeCost = Math.abs(feeCost);
                    const address = this.safeString(transaction, 'address');
                    const network = this.safeStringUpper(transaction, 'chain');
                    return {
                        'info': transaction,
                        'id': this.safeString2(transaction, 'id', 'data'),
                        'txid': this.safeString(transaction, 'tx-hash'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': this.safeNumber(transaction, 'amount'),
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': {
                            'currency': code,
                            'cost': feeCost,
                            'rate': undefined
                        }
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        // deposit statuses
                        'unknown': 'failed',
                        'confirming': 'pending',
                        'confirmed': 'ok',
                        'safe': 'ok',
                        'orphan': 'failed',
                        // withdrawal statuses
                        'submitted': 'pending',
                        'canceled': 'canceled',
                        'reexamine': 'pending',
                        'reject': 'failed',
                        'pass': 'pending',
                        'wallet-reject': 'failed',
                        // 'confirmed': 'ok', // present in deposit statuses
                        'confirm-error': 'failed',
                        'repealed': 'failed',
                        'wallet-transfer': 'pending',
                        'pre-transfer': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    this.checkAddress(address);
                    const currency = this.currency(code);
                    const request = {
                        'address': address,
                        'amount': amount,
                        'currency': currency['id'].toLowerCase()
                    };
                    if (tag !== undefined) request['addr-tag'] = tag; // only for XRP?
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeStringLower(networks, network, network); // handle ETH>ERC20 alias
                    if (network !== undefined) {
                        // possible chains - usdterc20, trc20usdt, hrc20usdt, usdt, algousdt
                        if (network === 'erc20') request['chain'] = currency['id'] + network;
                        else request['chain'] = network + currency['id'];
                        params = this.omit(params, 'network');
                    }
                    const response = await this.spotPrivatePostV1DwWithdrawApiCreate(this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": "99562054"
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                parseTransfer(transfer, currency) {
                    //
                    // transfer
                    //
                    //     {
                    //         "data": 12345,
                    //         "status": "ok"
                    //     }
                    //
                    const id = this.safeString(transfer, 'data');
                    const code = this.safeCurrencyCode(undefined, currency);
                    return {
                        'info': transfer,
                        'id': id,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'currency': code,
                        'amount': undefined,
                        'fromAccount': undefined,
                        'toAccount': undefined,
                        'status': undefined
                    };
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    let type = this.safeString(params, 'type');
                    if (type === undefined) {
                        const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                        fromAccount = fromAccount.toLowerCase(); // pro, futures
                        toAccount = toAccount.toLowerCase(); // pro, futures
                        const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                        const toId = this.safeString(accountsByType, toAccount, toAccount);
                        type = fromId + '-to-' + toId;
                    }
                    const request = {
                        'currency': currency['id'],
                        'amount': parseFloat(this.currencyToPrecision(code, amount)),
                        'type': type
                    };
                    const response = await this.spotPrivatePostFuturesTransfer(this.extend(request, params));
                    //
                    //     {
                    //         "data": 12345,
                    //         "status": "ok"
                    //     }
                    //
                    const transfer = this.parseTransfer(response, currency);
                    return this.extend(transfer, {
                        'amount': amount,
                        'currency': code,
                        'fromAccount': fromAccount,
                        'toAccount': toAccount
                    });
                }
                async fetchBorrowRatesPerSymbol(params = {}) {
                    await this.loadMarkets();
                    const response = await this.spotPrivateGetV1MarginLoanInfo(params);
                    // {
                    //     "status": "ok",
                    //     "data": [
                    //         {
                    //             "symbol": "1inchusdt",
                    //             "currencies": [
                    //                 {
                    //                     "currency": "1inch",
                    //                     "interest-rate": "0.00098",
                    //                     "min-loan-amt": "90.000000000000000000",
                    //                     "max-loan-amt": "1000.000000000000000000",
                    //                     "loanable-amt": "0.0",
                    //                     "actual-rate": "0.00098"
                    //                 },
                    //                 {
                    //                     "currency": "usdt",
                    //                     "interest-rate": "0.00098",
                    //                     "min-loan-amt": "100.000000000000000000",
                    //                     "max-loan-amt": "1000.000000000000000000",
                    //                     "loanable-amt": "0.0",
                    //                     "actual-rate": "0.00098"
                    //                 }
                    //             ]
                    //         },
                    //         ...
                    //     ]
                    // }
                    const timestamp = this.milliseconds();
                    const data = this.safeValue(response, 'data');
                    const rates = {
                        'info': response
                    };
                    for(let i = 0; i < data.length; i++){
                        const rate = data[i];
                        const currencies = this.safeValue(rate, 'currencies');
                        const symbolRates = {};
                        for(let j = 0; j < currencies.length; j++){
                            const currency = currencies[j];
                            const currencyId = this.safeString(currency, 'currency');
                            const code = this.safeCurrencyCode(currencyId, 'currency');
                            symbolRates[code] = {
                                'currency': code,
                                'rate': this.safeNumber(currency, 'actual-rate'),
                                'span': 86400000,
                                'timestamp': timestamp,
                                'datetime': this.iso8601(timestamp)
                            };
                        }
                        const market = this.markets_by_id[this.safeString(rate, 'symbol')];
                        const symbol = market['symbol'];
                        rates[symbol] = symbolRates;
                    }
                    return rates;
                }
                async fetchBorrowRates(params = {}) {
                    await this.loadMarkets();
                    const response = await this.spotPrivateGetV1MarginLoanInfo(params);
                    // {
                    //     "status": "ok",
                    //     "data": [
                    //         {
                    //             "symbol": "1inchusdt",
                    //             "currencies": [
                    //                 {
                    //                     "currency": "1inch",
                    //                     "interest-rate": "0.00098",
                    //                     "min-loan-amt": "90.000000000000000000",
                    //                     "max-loan-amt": "1000.000000000000000000",
                    //                     "loanable-amt": "0.0",
                    //                     "actual-rate": "0.00098"
                    //                 },
                    //                 {
                    //                     "currency": "usdt",
                    //                     "interest-rate": "0.00098",
                    //                     "min-loan-amt": "100.000000000000000000",
                    //                     "max-loan-amt": "1000.000000000000000000",
                    //                     "loanable-amt": "0.0",
                    //                     "actual-rate": "0.00098"
                    //                 }
                    //             ]
                    //         },
                    //         ...
                    //     ]
                    // }
                    const timestamp = this.milliseconds();
                    const data = this.safeValue(response, 'data');
                    const rates = {};
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const currencies = this.safeValue(market, 'currencies');
                        for(let j = 0; j < currencies.length; j++){
                            const currency = currencies[j];
                            const currencyId = this.safeString(currency, 'currency');
                            const code = this.safeCurrencyCode(currencyId, 'currency');
                            rates[code] = {
                                'currency': code,
                                'rate': this.safeNumber(currency, 'actual-rate'),
                                'span': 86400000,
                                'timestamp': timestamp,
                                'datetime': this.iso8601(timestamp),
                                'info': undefined
                            };
                        }
                    }
                    return rates;
                }
                async fetchFundingRateHistory(symbol, since, limit, params = {}) {
                    //
                    // Gets a history of funding rates with their timestamps
                    //  (param) symbol: Future currency pair
                    //  (param) limit: not used by huobi
                    //  (param) since: not used by huobi
                    //  (param) params: Object containing more params for the request
                    //  return: [{symbol, fundingRate, timestamp, dateTime}]
                    //
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchFundingRateHistory() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'contract_code': market['id']
                    };
                    let method = undefined;
                    if (market['inverse']) method = 'contractPublicGetSwapApiV1SwapHistoricalFundingRate';
                    else if (market['linear']) method = 'contractPublicGetLinearSwapApiV1SwapHistoricalFundingRate';
                    else throw new NotSupported(this.id + ' fetchFundingRateHistory() supports inverse and linear swaps only');
                    const response = await this[method](this.extend(request, params));
                    //
                    // {
                    //     "status": "ok",
                    //     "data": {
                    //         "total_page": 62,
                    //         "current_page": 1,
                    //         "total_size": 1237,
                    //         "data": [
                    //             {
                    //                 "avg_premium_index": "-0.000208064395065541",
                    //                 "funding_rate": "0.000100000000000000",
                    //                 "realized_rate": "0.000100000000000000",
                    //                 "funding_time": "1638921600000",
                    //                 "contract_code": "BTC-USDT",
                    //                 "symbol": "BTC",
                    //                 "fee_asset": "USDT"
                    //             },
                    //         ]
                    //     },
                    //     "ts": 1638939294277
                    // }
                    //
                    const data = this.safeValue(response, 'data');
                    const result = this.safeValue(data, 'data');
                    const rates = [];
                    for(let i = 0; i < result.length; i++){
                        const entry = result[i];
                        const marketId = this.safeString(entry, 'contract_code');
                        const symbol = this.safeSymbol(marketId);
                        const timestamp = this.safeString(entry, 'funding_time');
                        rates.push({
                            'info': entry,
                            'symbol': symbol,
                            'fundingRate': this.safeNumber(entry, 'funding_rate'),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp)
                        });
                    }
                    const sorted = this.sortBy(rates, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, market['symbol'], since, limit);
                }
                parseFundingRate(fundingRate, market) {
                    //
                    // {
                    //      "status": "ok",
                    //      "data": {
                    //         "estimated_rate": "0.000100000000000000",
                    //         "funding_rate": "0.000100000000000000",
                    //         "contract_code": "BCH-USD",
                    //         "symbol": "BCH",
                    //         "fee_asset": "BCH",
                    //         "funding_time": "1639094400000",
                    //         "next_funding_time": "1639123200000"
                    //     },
                    //     "ts": 1639085854775
                    // }
                    //
                    const nextFundingRate = this.safeNumber(fundingRate, 'estimated_rate');
                    const fundingTimestamp = this.safeInteger(fundingRate, 'funding_time');
                    const nextFundingTimestamp = this.safeInteger(fundingRate, 'next_funding_time');
                    const marketId = this.safeString(fundingRate, 'contract_code');
                    const symbol = this.safeSymbol(marketId, market);
                    return {
                        'info': fundingRate,
                        'symbol': symbol,
                        'markPrice': undefined,
                        'indexPrice': undefined,
                        'interestRate': undefined,
                        'estimatedSettlePrice': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'fundingRate': this.safeNumber(fundingRate, 'funding_rate'),
                        'fundingTimestamp': fundingTimestamp,
                        'fundingDatetime': this.iso8601(fundingTimestamp),
                        'nextFundingRate': nextFundingRate,
                        'nextFundingTimestamp': nextFundingTimestamp,
                        'nextFundingDatetime': this.iso8601(nextFundingTimestamp),
                        'previousFundingRate': undefined,
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let method = undefined;
                    if (market['inverse']) method = 'contractPublicGetSwapApiV1SwapFundingRate';
                    else if (market['linear']) method = 'contractPublicGetLinearSwapApiV1SwapFundingRate';
                    else throw new NotSupported(this.id + ' fetchFundingRateHistory() supports inverse and linear swaps only');
                    const request = {
                        'contract_code': market['id']
                    };
                    const response = await this[method](this.extend(request, params));
                    //
                    // {
                    //     "status": "ok",
                    //     "data": {
                    //         "estimated_rate": "0.000100000000000000",
                    //         "funding_rate": "0.000100000000000000",
                    //         "contract_code": "BTC-USDT",
                    //         "symbol": "BTC",
                    //         "fee_asset": "USDT",
                    //         "funding_time": "1603699200000",
                    //         "next_funding_time": "1603728000000"
                    //     },
                    //     "ts": 1603696494714
                    // }
                    //
                    const result = this.safeValue(response, 'data', {});
                    return this.parseFundingRate(result, market);
                }
                async fetchFundingRates(symbols, params = {}) {
                    await this.loadMarkets();
                    const options = this.safeValue(this.options, 'fetchFundingRates', {});
                    const defaultSubType = this.safeString(this.options, 'defaultSubType', 'inverse');
                    let subType = this.safeString(options, 'subType', defaultSubType);
                    subType = this.safeString(params, 'subType', subType);
                    const request = {
                    };
                    const method = this.getSupportedMapping(subType, {
                        'linear': 'contractPublicGetLinearSwapApiV1SwapBatchFundingRate',
                        'inverse': 'contractPublicGetSwapApiV1SwapBatchFundingRate'
                    });
                    params = this.omit(params, 'subType');
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": [
                    //             {
                    //                 "estimated_rate": "0.000100000000000000",
                    //                 "funding_rate": "0.000100000000000000",
                    //                 "contract_code": "MANA-USDT",
                    //                 "symbol": "MANA",
                    //                 "fee_asset": "USDT",
                    //                 "funding_time": "1643356800000",
                    //                 "next_funding_time": "1643385600000",
                    //                 "trade_partition":"USDT"
                    //             },
                    //         ],
                    //         "ts": 1643346173103
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = this.parseFundingRates(data);
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchBorrowInterest(code, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const defaultMargin = this.safeString(params, 'marginMode', 'cross'); // cross or isolated
                    const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                    const request = {};
                    if (since !== undefined) request['start-date'] = this.yyyymmdd(since);
                    if (limit !== undefined) request['size'] = limit;
                    let market = undefined;
                    let method = undefined;
                    if (marginMode === 'isolated') {
                        method = 'privateGetMarginLoanOrders';
                        if (symbol !== undefined) {
                            market = this.market(symbol);
                            request['symbol'] = market['id'];
                        }
                    } else {
                        method = 'privateGetCrossMarginLoanOrders';
                        if (code !== undefined) {
                            const currency = this.currency(code);
                            request['currency'] = currency['id'];
                        }
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //    {
                    //        "status":"ok",
                    //        "data":[
                    //            {
                    //                "loan-balance":"0.100000000000000000",
                    //                "interest-balance":"0.000200000000000000",
                    //                "loan-amount":"0.100000000000000000",
                    //                "accrued-at":1511169724531,
                    //                "interest-amount":"0.000200000000000000",
                    //                "filled-points":"0.2",
                    //                "filled-ht":"0.2",
                    //                "currency":"btc",
                    //                "id":394,
                    //                "state":"accrual",
                    //                "account-id":17747,
                    //                "user-id":119913,
                    //                "created-at":1511169724531
                    //            }
                    //        ]
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    const interest = this.parseBorrowInterests(data, market);
                    return this.filterByCurrencySinceLimit(interest, code, since, limit);
                }
                parseBorrowInterest(info, market) {
                    // isolated
                    //    {
                    //        "interest-rate":"0.000040830000000000",
                    //        "user-id":35930539,
                    //        "account-id":48916071,
                    //        "updated-at":1649320794195,
                    //        "deduct-rate":"1",
                    //        "day-interest-rate":"0.000980000000000000",
                    //        "hour-interest-rate":"0.000040830000000000",
                    //        "loan-balance":"100.790000000000000000",
                    //        "interest-balance":"0.004115260000000000",
                    //        "loan-amount":"100.790000000000000000",
                    //        "paid-coin":"0.000000000000000000",
                    //        "accrued-at":1649320794148,
                    //        "created-at":1649320794148,
                    //        "interest-amount":"0.004115260000000000",
                    //        "deduct-amount":"0",
                    //        "deduct-currency":"",
                    //        "paid-point":"0.000000000000000000",
                    //        "currency":"usdt",
                    //        "symbol":"ltcusdt",
                    //        "id":20242721,
                    //    }
                    //
                    // cross
                    //   {
                    //       "id":3416576,
                    //       "user-id":35930539,
                    //       "account-id":48956839,
                    //       "currency":"usdt",
                    //       "loan-amount":"102",
                    //       "loan-balance":"102",
                    //       "interest-amount":"0.00416466",
                    //       "interest-balance":"0.00416466",
                    //       "created-at":1649322735333,
                    //       "accrued-at":1649322735382,
                    //       "state":"accrual",
                    //       "filled-points":"0",
                    //       "filled-ht":"0"
                    //   }
                    //
                    const marketId = this.safeString(info, 'symbol');
                    const marginMode = marketId === undefined ? 'cross' : 'isolated';
                    market = this.safeMarket(marketId);
                    const symbol = this.safeString(market, 'symbol');
                    const timestamp = this.safeNumber(info, 'accrued-at');
                    return {
                        'account': marginMode === 'isolated' ? symbol : 'cross',
                        'symbol': symbol,
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'currency': this.safeCurrencyCode(this.safeString(info, 'currency')),
                        'interest': this.safeNumber(info, 'interest-amount'),
                        'interestRate': this.safeNumber(info, 'interest-rate'),
                        'amountBorrowed': this.safeNumber(info, 'loan-amount'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'info': info
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = '/';
                    const query = this.omit(params, this.extractParams(path));
                    if (typeof api === 'string') {
                        // signing implementation for the old endpoints
                        if (api === 'market') url += api;
                        else if (api === 'public' || api === 'private') url += this.version;
                        else if (api === 'v2Public' || api === 'v2Private') url += 'v2';
                        url += '/' + this.implodeParams(path, params);
                        if (api === 'private' || api === 'v2Private') {
                            this.checkRequiredCredentials();
                            const timestamp = this.ymdhms(this.milliseconds(), 'T');
                            let request = {
                                'SignatureMethod': 'HmacSHA256',
                                'SignatureVersion': '2',
                                'AccessKeyId': this.apiKey,
                                'Timestamp': timestamp
                            };
                            if (method !== 'POST') request = this.extend(request, query);
                            request = this.keysort(request);
                            let auth = this.urlencode(request);
                            // unfortunately, PHP demands double quotes for the escaped newline symbol
                            const payload = [
                                method,
                                this.hostname,
                                url,
                                auth
                            ].join("\n"); // eslint-disable-line quotes
                            const signature = this.hmac(this.encode(payload), this.encode(this.secret), 'sha256', 'base64');
                            auth += '&' + this.urlencode({
                                'Signature': signature
                            });
                            url += '?' + auth;
                            if (method === 'POST') {
                                body = this.json(query);
                                headers = {
                                    'Content-Type': 'application/json'
                                };
                            } else headers = {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            };
                        } else if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        url = this.implodeParams(this.urls['api'][api], {
                            'hostname': this.hostname
                        }) + url;
                    } else {
                        // signing implementation for the new endpoints
                        // const [ type, access ] = api;
                        const type = this.safeString(api, 0);
                        const access = this.safeString(api, 1);
                        url += this.implodeParams(path, params);
                        const hostname = this.safeString(this.urls['hostnames'], type);
                        if (access === 'public') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else if (access === 'private') {
                            this.checkRequiredCredentials();
                            const timestamp = this.ymdhms(this.milliseconds(), 'T');
                            let request = {
                                'SignatureMethod': 'HmacSHA256',
                                'SignatureVersion': '2',
                                'AccessKeyId': this.apiKey,
                                'Timestamp': timestamp
                            };
                            if (method !== 'POST') request = this.extend(request, query);
                            request = this.keysort(request);
                            let auth = this.urlencode(request);
                            // unfortunately, PHP demands double quotes for the escaped newline symbol
                            const payload = [
                                method,
                                hostname,
                                url,
                                auth
                            ].join("\n"); // eslint-disable-line quotes
                            const signature = this.hmac(this.encode(payload), this.encode(this.secret), 'sha256', 'base64');
                            auth += '&' + this.urlencode({
                                'Signature': signature
                            });
                            url += '?' + auth;
                            if (method === 'POST') {
                                body = this.json(query);
                                headers = {
                                    'Content-Type': 'application/json'
                                };
                            } else headers = {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            };
                        }
                        url = this.implodeParams(this.urls['api'][type], {
                            'hostname': hostname
                        }) + url;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                calculateRateLimiterCost(api, method, path, params, config = {}, context = {}) {
                    return this.safeInteger(config, 'cost', 1);
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if ('status' in response) {
                        //
                        //     {"status":"error","err-code":"order-limitorder-amount-min-error","err-msg":"limit order amount error, min: `0.001`","data":null}
                        //
                        const status = this.safeString(response, 'status');
                        if (status === 'error') {
                            const code = this.safeString2(response, 'err-code', 'err_code');
                            const feedback = this.id + ' ' + body;
                            this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                            this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                            const message = this.safeString2(response, 'err-msg', 'err_msg');
                            this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
                async fetchFundingHistory(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchFundingHistory', market, params);
                    let method = undefined;
                    const request = {
                        'type': '30,31'
                    };
                    if (market['linear']) {
                        method = 'contractPrivatePostLinearSwapApiV1SwapFinancialRecordExact';
                        //
                        // {
                        //   status: 'ok',
                        //   data: {
                        //     financial_record: [
                        //       {
                        //         id: '1320088022',
                        //         type: '30',
                        //         amount: '0.004732510000000000',
                        //         ts: '1641168019321',
                        //         contract_code: 'BTC-USDT',
                        //         asset: 'USDT',
                        //         margin_account: 'BTC-USDT',
                        //         face_margin_account: ''
                        //       },
                        //     ],
                        //     remain_size: '0',
                        //     next_id: null
                        //   },
                        //   ts: '1641189898425'
                        // }
                        const defaultMargin = market['future'] ? 'cross' : 'isolated';
                        const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                        if (marginMode === 'isolated') request['margin_account'] = market['id'];
                        else request['margin_account'] = market['quoteId'];
                    } else {
                        if (marketType === 'swap') {
                            method = 'contractPrivatePostSwapApiV1SwapFinancialRecordExact';
                            request['contract_code'] = market['id'];
                        } else throw new ExchangeError1(this.id + ' fetchFundingHistory() only makes sense for swap contracts');
                    //
                    // swap
                    //     {
                    //       status: 'ok',
                    //       data: {
                    //         financial_record: [
                    //           {
                    //             id: '1667436164',
                    //             symbol: 'BTC',
                    //             type: '30',
                    //             amount: '3.9755491985E-8',
                    //             ts: '1641168097323',
                    //             contract_code: 'BTC-USD'
                    //           },
                    //         ],
                    //         remain_size: '0',
                    //         next_id: null
                    //       },
                    //       ts: '1641190296379'
                    //     }
                    //
                    }
                    const response = await this[method](this.extend(request, query));
                    const data = this.safeValue(response, 'data', {});
                    const financialRecord = this.safeValue(data, 'financial_record', []);
                    return this.parseIncomes(financialRecord, market, since, limit);
                }
                async setLeverage(leverage, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchPosition', market, params);
                    let method = undefined;
                    if (market['linear']) {
                        const defaultMargin = market['future'] ? 'cross' : 'isolated';
                        const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                        method = this.getSupportedMapping(marginMode, {
                            'isolated': 'contractPrivatePostLinearSwapApiV1SwapSwitchLeverRate',
                            'cross': 'contractPrivatePostLinearSwapApiV1SwapCrossSwitchLeverRate'
                        });
                    //
                    //     {
                    //       status: 'ok',
                    //       data: {
                    //         contract_code: 'BTC-USDT',
                    //         lever_rate: '100',
                    //         margin_mode: 'isolated'
                    //       },
                    //       ts: '1641184710649'
                    //     }
                    //
                    } else method = this.getSupportedMapping(marketType, {
                        'future': 'contractPrivatePostApiV1ContractSwitchLeverRate',
                        'swap': 'contractPrivatePostSwapApiV1SwapSwitchLeverRate'
                    });
                    const request = {
                        'lever_rate': leverage
                    };
                    if (marketType === 'future' && market['inverse']) request['symbol'] = market['settleId'];
                    else request['contract_code'] = market['id'];
                    const response = await this[method](this.extend(request, query));
                    return response;
                }
                parseIncome(income, market) {
                    //
                    //     {
                    //       id: '1667161118',
                    //       symbol: 'BTC',
                    //       type: '31',
                    //       amount: '-2.11306593188E-7',
                    //       ts: '1641139308983',
                    //       contract_code: 'BTC-USD'
                    //     }
                    //
                    const marketId = this.safeString(income, 'contract_code');
                    const symbol = this.safeSymbol(marketId, market);
                    const amount = this.safeNumber(income, 'amount');
                    const timestamp = this.safeInteger(income, 'ts');
                    const id = this.safeString(income, 'id');
                    const currencyId = this.safeString2(income, 'symbol', 'asset');
                    const code = this.safeCurrencyCode(currencyId);
                    return {
                        'info': income,
                        'symbol': symbol,
                        'code': code,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'id': id,
                        'amount': amount
                    };
                }
                parseIncomes(incomes, market, since, limit) {
                    const result = [];
                    for(let i = 0; i < incomes.length; i++){
                        const entry = incomes[i];
                        const parsed = this.parseIncome(entry, market);
                        result.push(parsed);
                    }
                    const sorted = this.sortBy(result, 'timestamp');
                    return this.filterBySinceLimit(sorted, since, limit, 'timestamp');
                }
                parsePosition(position, market) {
                    //
                    //     {
                    //       symbol: 'BTC',
                    //       contract_code: 'BTC-USDT',
                    //       volume: '1.000000000000000000',
                    //       available: '1.000000000000000000',
                    //       frozen: '0E-18',
                    //       cost_open: '47162.000000000000000000',
                    //       cost_hold: '47151.300000000000000000',
                    //       profit_unreal: '0.007300000000000000',
                    //       profit_rate: '-0.000144183876850008',
                    //       lever_rate: '2',
                    //       position_margin: '23.579300000000000000',
                    //       direction: 'buy',
                    //       profit: '-0.003400000000000000',
                    //       last_price: '47158.6',
                    //       margin_asset: 'USDT',
                    //       margin_mode: 'isolated',
                    //       margin_account: 'BTC-USDT',
                    //       margin_balance: '24.973020070000000000',
                    //       margin_position: '23.579300000000000000',
                    //       margin_frozen: '0',
                    //       margin_available: '1.393720070000000000',
                    //       profit_real: '0E-18',
                    //       risk_rate: '1.044107779705080303',
                    //       withdraw_available: '1.386420070000000000000000000000000000',
                    //       liquidation_price: '22353.229148614609571788',
                    //       adjust_factor: '0.015000000000000000',
                    //       margin_static: '24.965720070000000000'
                    //     }
                    //
                    market = this.safeMarket(this.safeString(position, 'contract_code'));
                    const symbol = market['symbol'];
                    const contracts = this.safeString(position, 'volume');
                    const contractSize = this.safeValue(market, 'contractSize');
                    const contractSizeString = this.numberToString(contractSize);
                    const entryPrice = this.safeNumber(position, 'cost_hold');
                    const initialMargin = this.safeString(position, 'position_margin');
                    const rawSide = this.safeString(position, 'direction');
                    const side = rawSide === 'buy' ? 'long' : 'short';
                    const unrealizedProfit = this.safeNumber(position, 'profit_unreal');
                    let marginMode = this.safeString(position, 'margin_mode');
                    const leverage = this.safeString(position, 'lever_rate');
                    const percentage = Precise.stringMul(this.safeString(position, 'profit_rate'), '100');
                    const lastPrice = this.safeString(position, 'last_price');
                    const faceValue = Precise.stringMul(contracts, contractSizeString);
                    let notional = undefined;
                    if (market['linear']) notional = Precise.stringMul(faceValue, lastPrice);
                    else {
                        notional = Precise.stringDiv(faceValue, lastPrice);
                        marginMode = 'cross';
                    }
                    const intialMarginPercentage = Precise.stringDiv(initialMargin, notional);
                    const collateral = this.safeString(position, 'margin_balance');
                    const liquidationPrice = this.safeNumber(position, 'liquidation_price');
                    const adjustmentFactor = this.safeString(position, 'adjust_factor');
                    const maintenanceMarginPercentage = Precise.stringDiv(adjustmentFactor, leverage);
                    const maintenanceMargin = Precise.stringMul(maintenanceMarginPercentage, notional);
                    const marginRatio = Precise.stringDiv(maintenanceMargin, collateral);
                    return {
                        'info': position,
                        'symbol': symbol,
                        'contracts': this.parseNumber(contracts),
                        'contractSize': contractSize,
                        'entryPrice': entryPrice,
                        'collateral': this.parseNumber(collateral),
                        'side': side,
                        'unrealizedProfit': unrealizedProfit,
                        'leverage': this.parseNumber(leverage),
                        'percentage': this.parseNumber(percentage),
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'notional': this.parseNumber(notional),
                        'markPrice': undefined,
                        'liquidationPrice': liquidationPrice,
                        'initialMargin': this.parseNumber(initialMargin),
                        'initialMarginPercentage': this.parseNumber(intialMarginPercentage),
                        'maintenanceMargin': this.parseNumber(maintenanceMargin),
                        'maintenanceMarginPercentage': this.parseNumber(maintenanceMarginPercentage),
                        'marginRatio': this.parseNumber(marginRatio),
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', 'isolated');
                    const defaultSubType = this.safeString(this.options, 'defaultSubType', 'inverse');
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchPositions', undefined, params);
                    let method = undefined;
                    if (defaultSubType === 'linear') method = this.getSupportedMapping(marginMode, {
                        'isolated': 'contractPrivatePostLinearSwapApiV1SwapPositionInfo',
                        'cross': 'contractPrivatePostLinearSwapApiV1SwapCrossPositionInfo'
                    });
                    else method = this.getSupportedMapping(marketType, {
                        'future': 'contractPrivatePostApiV1ContractPositionInfo',
                        'swap': 'contractPrivatePostSwapApiV1SwapPositionInfo'
                    });
                    const response = await this[method](query);
                    const data = this.safeValue(response, 'data');
                    const timestamp = this.safeInteger(response, 'ts');
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const position = data[i];
                        const parsed = this.parsePosition(position);
                        result.push(this.extend(parsed, {
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp)
                        }));
                    }
                    return this.filterByArray(result, 'symbol', symbols, false);
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', 'isolated');
                    marginMode = this.safeString2(params, 'marginMode', 'defaultMarginMode', marginMode);
                    params = this.omit(params, [
                        'defaultMarginMode',
                        'marginMode'
                    ]);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchPosition', market, params);
                    let method = undefined;
                    if (market['linear']) method = this.getSupportedMapping(marginMode, {
                        'isolated': 'contractPrivatePostLinearSwapApiV1SwapAccountPositionInfo',
                        'cross': 'contractPrivatePostLinearSwapApiV1SwapCrossAccountPositionInfo'
                    });
                    else method = this.getSupportedMapping(marketType, {
                        'future': 'contractPrivatePostApiV1ContractAccountPositionInfo',
                        'swap': 'contractPrivatePostSwapApiV1SwapAccountPositionInfo'
                    });
                    const request = {};
                    if (market['future'] && market['inverse']) request['symbol'] = market['settleId'];
                    else {
                        if (marginMode === 'cross') request['margin_account'] = 'USDT'; // only allowed value
                        request['contract_code'] = market['id'];
                    }
                    const response = await this[method](this.extend(request, query));
                    const data = this.safeValue(response, 'data');
                    let account = undefined;
                    if (marginMode === 'cross') account = data;
                    else account = this.safeValue(data, 0);
                    const omitted = this.omit(account, [
                        'positions'
                    ]);
                    const positions = this.safeValue(account, 'positions');
                    let position = undefined;
                    if (market['future'] && market['inverse']) for(let i = 0; i < positions.length; i++){
                        const entry = positions[i];
                        if (entry['contract_code'] === market['id']) {
                            position = entry;
                            break;
                        }
                    }
                    else position = this.safeValue(positions, 0);
                    const timestamp = this.safeInteger(response, 'ts');
                    const parsed = this.parsePosition(this.extend(position, omitted));
                    return this.extend(parsed, {
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    });
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'trade': 'trade',
                        'etf': 'trade',
                        'transact-fee': 'fee',
                        'fee-deduction': 'fee',
                        'transfer': 'transfer',
                        'credit': 'credit',
                        'liquidation': 'trade',
                        'interest': 'credit',
                        'deposit': 'deposit',
                        'withdraw': 'withdrawal',
                        'withdraw-fee': 'fee',
                        'exchange': 'exchange',
                        'other-types': 'transfer',
                        'rebate': 'rebate'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     {
                    //         "accountId": 10000001,
                    //         "currency": "usdt",
                    //         "transactAmt": 10.000000000000000000,
                    //         "transactType": "transfer",
                    //         "transferType": "margin-transfer-out",
                    //         "transactId": 0,
                    //         "transactTime": 1629882331066,
                    //         "transferer": 28483123,
                    //         "transferee": 13496526
                    //     }
                    //
                    const id = this.safeString(item, 'transactId');
                    const currencyId = this.safeString(item, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const amount = this.safeNumber(item, 'transactAmt');
                    const transferType = this.safeString(item, 'transferType');
                    const type = this.parseLedgerEntryType(transferType);
                    const direction = this.safeString(item, 'direction');
                    const timestamp = this.safeInteger(item, 'transactTime');
                    const datetime = this.iso8601(timestamp);
                    const account = this.safeString(item, 'accountId');
                    return {
                        'id': id,
                        'direction': direction,
                        'account': account,
                        'referenceId': id,
                        'referenceAccount': account,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'before': undefined,
                        'after': undefined,
                        'status': undefined,
                        'fee': undefined,
                        'info': item
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const accountId = await this.fetchAccountIdByType('spot', params);
                    const request = {
                        'accountId': accountId
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit; // max 500
                    const response = await this.spotPrivateGetV2AccountLedger(this.extend(request, params));
                    //
                    //     {
                    //         "code": 200,
                    //         "message": "success",
                    //         "data": [
                    //             {
                    //                 "accountId": 10000001,
                    //                 "currency": "usdt",
                    //                 "transactAmt": 10.000000000000000000,
                    //                 "transactType": "transfer",
                    //                 "transferType": "margin-transfer-out",
                    //                 "transactId": 0,
                    //                 "transactTime": 1629882331066,
                    //                 "transferer": 28483123,
                    //                 "transferee": 13496526
                    //             },
                    //             {
                    //                 "accountId": 10000001,
                    //                 "currency": "usdt",
                    //                 "transactAmt": -10.000000000000000000,
                    //                 "transactType": "transfer",
                    //                 "transferType": "margin-transfer-in",
                    //                 "transactId": 0,
                    //                 "transactTime": 1629882096562,
                    //                 "transferer": 13496526,
                    //                 "transferee": 28483123
                    //             }
                    //         ],
                    //         "nextId": 1624316679,
                    //         "ok": true
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseLedger(data, currency, since, limit);
                }
                async fetchLeverageTiers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.contractPublicGetLinearSwapApiV1SwapAdjustfactor(params);
                    //
                    //    {
                    //        "status": "ok",
                    //        "data": [
                    //            {
                    //                "symbol": "MANA",
                    //                "contract_code": "MANA-USDT",
                    //                "margin_mode": "isolated",
                    //                "trade_partition": "USDT",
                    //                "list": [
                    //                    {
                    //                        "lever_rate": 75,
                    //                        "ladders": [
                    //                            {
                    //                                "ladder": 0,
                    //                                "min_size": 0,
                    //                                "max_size": 999,
                    //                                "adjust_factor": 0.7
                    //                            },
                    //                            ...
                    //                        ]
                    //                    }
                    //                    ...
                    //                ]
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseLeverageTiers(data, symbols, 'contract_code');
                }
                async fetchMarketLeverageTiers(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        if (!market['contract']) throw new BadRequest(this.id + ' fetchLeverageTiers() symbol supports contract markets only');
                        request['contract_code'] = market['id'];
                    }
                    const response = await this.contractPublicGetLinearSwapApiV1SwapAdjustfactor(this.extend(request, params));
                    //
                    //    {
                    //        "status": "ok",
                    //        "data": [
                    //            {
                    //                "symbol": "MANA",
                    //                "contract_code": "MANA-USDT",
                    //                "margin_mode": "isolated",
                    //                "trade_partition": "USDT",
                    //                "list": [
                    //                    {
                    //                        "lever_rate": 75,
                    //                        "ladders": [
                    //                            {
                    //                                "ladder": 0,
                    //                                "min_size": 0,
                    //                                "max_size": 999,
                    //                                "adjust_factor": 0.7
                    //                            },
                    //                            ...
                    //                        ]
                    //                    }
                    //                    ...
                    //                ]
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    const tiers = this.parseLeverageTiers(data, [
                        symbol
                    ], 'contract_code');
                    return this.safeValue(tiers, symbol);
                }
                parseLeverageTiers(response, symbols, marketIdKey) {
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const item = response[i];
                        const list = this.safeValue(item, 'list', []);
                        const tiers = [];
                        const currency = this.safeString(item, 'trade_partition');
                        const id = this.safeString(item, marketIdKey);
                        const symbol = this.safeSymbol(id);
                        if (this.inArray(symbols, symbol)) {
                            for(let j = 0; j < list.length; j++){
                                const obj = list[j];
                                const leverage = this.safeString(obj, 'lever_rate');
                                const ladders = this.safeValue(obj, 'ladders', []);
                                for(let k = 0; k < ladders.length; k++){
                                    const bracket = ladders[k];
                                    const adjustFactor = this.safeString(bracket, 'adjust_factor');
                                    tiers.push({
                                        'tier': this.safeInteger(bracket, 'ladder'),
                                        'currency': this.safeCurrencyCode(currency),
                                        'minNotional': this.safeNumber(bracket, 'min_size'),
                                        'maxNotional': this.safeNumber(bracket, 'max_size'),
                                        'maintenanceMarginRate': this.parseNumber(Precise.stringDiv(adjustFactor, leverage)),
                                        'maxLeverage': this.parseNumber(leverage),
                                        'info': bracket
                                    });
                                }
                            }
                            result[symbol] = tiers;
                        }
                    }
                    return result;
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    89: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, PermissionDenied: PermissionDenied, ExchangeNotAvailable: ExchangeNotAvailable, OnMaintenance: OnMaintenance, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, ArgumentsRequired: ArgumentsRequired1, BadSymbol: BadSymbol, BadRequest: BadRequest, RequestTimeout: RequestTimeout, NetworkError: NetworkError } = require1('./base/errors');
            const { TRUNCATE: TRUNCATE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            // ---------------------------------------------------------------------------
            module.exports = class huobijp extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'huobijp',
                        'name': 'Huobi Japan',
                        'countries': [
                            'JP'
                        ],
                        'rateLimit': 100,
                        'userAgent': this.userAgents['chrome39'],
                        'certified': false,
                        'version': 'v1',
                        'accounts': undefined,
                        'accountsById': undefined,
                        'hostname': 'api-cloud.huobi.co.jp',
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createOrder': true,
                            'createStopLimitOrder': false,
                            'createStopMarketOrder': false,
                            'createStopOrder': false,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': false,
                            'fetchDepositAddressesByNetwork': false,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchOrderTrades': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingLimits': true,
                            'fetchWithdrawals': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1min',
                            '5m': '5min',
                            '15m': '15min',
                            '30m': '30min',
                            '1h': '60min',
                            '4h': '4hour',
                            '1d': '1day',
                            '1w': '1week',
                            '1M': '1mon',
                            '1y': '1year'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/85734211-85755480-b705-11ea-8b35-0b7f1db33a2f.jpg',
                            'api': {
                                'market': 'https://{hostname}',
                                'public': 'https://{hostname}',
                                'private': 'https://{hostname}',
                                'v2Public': 'https://{hostname}',
                                'v2Private': 'https://{hostname}'
                            },
                            'www': 'https://www.huobi.co.jp',
                            'referral': 'https://www.huobi.co.jp/register/?invite_code=znnq3',
                            'doc': 'https://api-doc.huobi.co.jp',
                            'fees': 'https://www.huobi.co.jp/support/fee'
                        },
                        'api': {
                            'v2Public': {
                                'get': {
                                    'reference/currencies': 1,
                                    'market-status': 1
                                }
                            },
                            'v2Private': {
                                'get': {
                                    'account/ledger': 1,
                                    'account/withdraw/quota': 1,
                                    'account/withdraw/address': 1,
                                    'account/deposit/address': 1,
                                    'account/repayment': 5,
                                    'reference/transact-fee-rate': 1,
                                    'account/asset-valuation': 0.2,
                                    'point/account': 5,
                                    'sub-user/user-list': 1,
                                    'sub-user/user-state': 1,
                                    'sub-user/account-list': 1,
                                    'sub-user/deposit-address': 1,
                                    'sub-user/query-deposit': 1,
                                    'user/api-key': 1,
                                    'user/uid': 1,
                                    'algo-orders/opening': 1,
                                    'algo-orders/history': 1,
                                    'algo-orders/specific': 1,
                                    'c2c/offers': 1,
                                    'c2c/offer': 1,
                                    'c2c/transactions': 1,
                                    'c2c/repayment': 1,
                                    'c2c/account': 1,
                                    'etp/reference': 1,
                                    'etp/transactions': 5,
                                    'etp/transaction': 5,
                                    'etp/rebalance': 1,
                                    'etp/limit': 1
                                },
                                'post': {
                                    'account/transfer': 1,
                                    'account/repayment': 5,
                                    'point/transfer': 5,
                                    'sub-user/management': 1,
                                    'sub-user/creation': 1,
                                    'sub-user/tradable-market': 1,
                                    'sub-user/transferability': 1,
                                    'sub-user/api-key-generation': 1,
                                    'sub-user/api-key-modification': 1,
                                    'sub-user/api-key-deletion': 1,
                                    'sub-user/deduct-mode': 1,
                                    'algo-orders': 1,
                                    'algo-orders/cancel-all-after': 1,
                                    'algo-orders/cancellation': 1,
                                    'c2c/offer': 1,
                                    'c2c/cancellation': 1,
                                    'c2c/cancel-all': 1,
                                    'c2c/repayment': 1,
                                    'c2c/transfer': 1,
                                    'etp/creation': 5,
                                    'etp/redemption': 5,
                                    'etp/{transactId}/cancel': 10,
                                    'etp/batch-cancel': 50
                                }
                            },
                            'market': {
                                'get': {
                                    'history/kline': 1,
                                    'detail/merged': 1,
                                    'depth': 1,
                                    'trade': 1,
                                    'history/trade': 1,
                                    'detail': 1,
                                    'tickers': 1,
                                    'etp': 1
                                }
                            },
                            'public': {
                                'get': {
                                    'common/symbols': 1,
                                    'common/currencys': 1,
                                    'common/timestamp': 1,
                                    'common/exchange': 1,
                                    'settings/currencys': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'account/accounts': 0.2,
                                    'account/accounts/{id}/balance': 0.2,
                                    'account/accounts/{sub-uid}': 1,
                                    'account/history': 4,
                                    'cross-margin/loan-info': 1,
                                    'margin/loan-info': 1,
                                    'fee/fee-rate/get': 1,
                                    'order/openOrders': 0.4,
                                    'order/orders': 0.4,
                                    'order/orders/{id}': 0.4,
                                    'order/orders/{id}/matchresults': 0.4,
                                    'order/orders/getClientOrder': 0.4,
                                    'order/history': 1,
                                    'order/matchresults': 1,
                                    // 'dw/withdraw-virtual/addresses', // 查询虚拟币提现地址（Deprecated）
                                    'query/deposit-withdraw': 1,
                                    // 'margin/loan-info', // duplicate
                                    'margin/loan-orders': 0.2,
                                    'margin/accounts/balance': 0.2,
                                    'cross-margin/loan-orders': 1,
                                    'cross-margin/accounts/balance': 1,
                                    'points/actions': 1,
                                    'points/orders': 1,
                                    'subuser/aggregate-balance': 10,
                                    'stable-coin/exchange_rate': 1,
                                    'stable-coin/quote': 1
                                },
                                'post': {
                                    'account/transfer': 1,
                                    'futures/transfer': 1,
                                    'order/batch-orders': 0.4,
                                    'order/orders/place': 0.2,
                                    'order/orders/submitCancelClientOrder': 0.2,
                                    'order/orders/batchCancelOpenOrders': 0.4,
                                    // 'order/orders', // 创建一个新的订单请求 （仅创建订单，不执行下单）
                                    // 'order/orders/{id}/place', // 执行一个订单 （仅执行已创建的订单）
                                    'order/orders/{id}/submitcancel': 0.2,
                                    'order/orders/batchcancel': 0.4,
                                    // 'dw/balance/transfer', // 资产划转
                                    'dw/withdraw/api/create': 1,
                                    // 'dw/withdraw-virtual/create', // 申请提现虚拟币
                                    // 'dw/withdraw-virtual/{id}/place', // 确认申请虚拟币提现（Deprecated）
                                    'dw/withdraw-virtual/{id}/cancel': 1,
                                    'dw/transfer-in/margin': 10,
                                    'dw/transfer-out/margin': 10,
                                    'margin/orders': 10,
                                    'margin/orders/{id}/repay': 10,
                                    'cross-margin/transfer-in': 1,
                                    'cross-margin/transfer-out': 1,
                                    'cross-margin/orders': 1,
                                    'cross-margin/orders/{id}/repay': 1,
                                    'stable-coin/exchange': 1,
                                    'subuser/transfer': 10
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.002'),
                                'taker': this.parseNumber('0.002')
                            }
                        },
                        'exceptions': {
                            'broad': {
                                'contract is restricted of closing positions on API.  Please contact customer service': OnMaintenance,
                                'maintain': OnMaintenance
                            },
                            'exact': {
                                // err-code
                                'bad-request': BadRequest,
                                'base-date-limit-error': BadRequest,
                                'api-not-support-temp-addr': PermissionDenied,
                                'timeout': RequestTimeout,
                                'gateway-internal-error': ExchangeNotAvailable,
                                'account-frozen-balance-insufficient-error': InsufficientFunds,
                                'invalid-amount': InvalidOrder,
                                'order-limitorder-amount-min-error': InvalidOrder,
                                'order-limitorder-amount-max-error': InvalidOrder,
                                'order-marketorder-amount-min-error': InvalidOrder,
                                'order-limitorder-price-min-error': InvalidOrder,
                                'order-limitorder-price-max-error': InvalidOrder,
                                'order-holding-limit-failed': InvalidOrder,
                                'order-orderprice-precision-error': InvalidOrder,
                                'order-etp-nav-price-max-error': InvalidOrder,
                                'order-orderstate-error': OrderNotFound,
                                'order-queryorder-invalid': OrderNotFound,
                                'order-update-error': ExchangeNotAvailable,
                                'api-signature-check-failed': AuthenticationError,
                                'api-signature-not-valid': AuthenticationError,
                                'base-record-invalid': OrderNotFound,
                                'base-symbol-trade-disabled': BadSymbol,
                                'base-symbol-error': BadSymbol,
                                'system-maintenance': OnMaintenance,
                                // err-msg
                                'invalid symbol': BadSymbol,
                                'symbol trade not open now': BadSymbol,
                                'invalid-address': BadRequest,
                                'base-currency-chain-error': BadRequest,
                                'dw-insufficient-balance': InsufficientFunds
                            }
                        },
                        'options': {
                            'defaultNetwork': 'ERC20',
                            'networks': {
                                'ETH': 'erc20',
                                'TRX': 'trc20',
                                'HRC20': 'hrc20',
                                'HECO': 'hrc20',
                                'HT': 'hrc20',
                                'ALGO': 'algo',
                                'OMNI': ''
                            },
                            // https://github.com/ccxt/ccxt/issues/5376
                            'fetchOrdersByStatesMethod': 'private_get_order_orders',
                            'fetchOpenOrdersMethod': 'fetch_open_orders_v1',
                            'createMarketBuyOrderRequiresPrice': true,
                            'fetchMarketsMethod': 'publicGetCommonSymbols',
                            'fetchBalanceMethod': 'privateGetAccountAccountsIdBalance',
                            'createOrderMethod': 'privatePostOrderOrdersPlace',
                            'language': 'en-US',
                            'broker': {
                                'id': 'AA03022abc'
                            }
                        },
                        'commonCurrencies': {
                            // https://github.com/ccxt/ccxt/issues/6081
                            // https://github.com/ccxt/ccxt/issues/3365
                            // https://github.com/ccxt/ccxt/issues/2873
                            'GET': 'Themis',
                            'GTC': 'Game.com',
                            'HIT': 'HitChain',
                            'HOT': 'Hydro Protocol',
                            // https://github.com/ccxt/ccxt/issues/7399
                            // https://coinmarketcap.com/currencies/pnetwork/
                            // https://coinmarketcap.com/currencies/penta/markets/
                            // https://en.cryptonomist.ch/blog/eidoo/the-edo-to-pnt-upgrade-what-you-need-to-know-updated/
                            'PNT': 'Penta',
                            'SBTC': 'Super Bitcoin',
                            'BIFI': 'Bitcoin File'
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetCommonTimestamp(params);
                    return this.safeInteger(response, 'data');
                }
                async fetchTradingLimits(symbols, params = {}) {
                    // this method should not be called directly, use loadTradingLimits () instead
                    //  by default it will try load withdrawal fees of all currencies (with separate requests)
                    //  however if you define symbols = [ 'ETH/BTC', 'LTC/BTC' ] in args it will only load those
                    await this.loadMarkets();
                    if (symbols === undefined) symbols = this.symbols;
                    const result = {};
                    for(let i = 0; i < symbols.length; i++){
                        const symbol = symbols[i];
                        result[symbol] = await this.fetchTradingLimitsById(this.marketId(symbol), params);
                    }
                    return result;
                }
                async fetchTradingLimitsById(id, params = {}) {
                    const request = {
                        'symbol': id
                    };
                    const response = await this.publicGetCommonExchange(this.extend(request, params));
                    //
                    //     { status:   "ok",
                    //         data: {                                  symbol: "aidocbtc",
                    //                              'buy-limit-must-less-than':  1.1,
                    //                          'sell-limit-must-greater-than':  0.9,
                    //                         'limit-order-must-greater-than':  1,
                    //                            'limit-order-must-less-than':  5000000,
                    //                    'market-buy-order-must-greater-than':  0.0001,
                    //                       'market-buy-order-must-less-than':  100,
                    //                   'market-sell-order-must-greater-than':  1,
                    //                      'market-sell-order-must-less-than':  500000,
                    //                       'circuit-break-when-greater-than':  10000,
                    //                          'circuit-break-when-less-than':  10,
                    //                 'market-sell-order-rate-must-less-than':  0.1,
                    //                  'market-buy-order-rate-must-less-than':  0.1        } }
                    //
                    return this.parseTradingLimits(this.safeValue(response, 'data', {}));
                }
                parseTradingLimits(limits, symbol, params = {}) {
                    //
                    //   {                                  symbol: "aidocbtc",
                    //                  'buy-limit-must-less-than':  1.1,
                    //              'sell-limit-must-greater-than':  0.9,
                    //             'limit-order-must-greater-than':  1,
                    //                'limit-order-must-less-than':  5000000,
                    //        'market-buy-order-must-greater-than':  0.0001,
                    //           'market-buy-order-must-less-than':  100,
                    //       'market-sell-order-must-greater-than':  1,
                    //          'market-sell-order-must-less-than':  500000,
                    //           'circuit-break-when-greater-than':  10000,
                    //              'circuit-break-when-less-than':  10,
                    //     'market-sell-order-rate-must-less-than':  0.1,
                    //      'market-buy-order-rate-must-less-than':  0.1        }
                    //
                    return {
                        'info': limits,
                        'limits': {
                            'amount': {
                                'min': this.safeNumber(limits, 'limit-order-must-greater-than'),
                                'max': this.safeNumber(limits, 'limit-order-must-less-than')
                            }
                        }
                    };
                }
                costToPrecision(symbol, cost) {
                    return this.decimalToPrecision(cost, TRUNCATE, this.markets[symbol]['precision']['cost'], this.precisionMode);
                }
                async fetchMarkets(params = {}) {
                    const method = this.options['fetchMarketsMethod'];
                    const response = await this[method](params);
                    //
                    //    {
                    //        "status": "ok",
                    //        "data": [
                    //            {
                    //                "base-currency": "xrp",
                    //                "quote-currency": "btc",
                    //                "price-precision": 9,
                    //                "amount-precision": 2,
                    //                "symbol-partition": "default",
                    //                "symbol": "xrpbtc",
                    //                "state": "online",
                    //                "value-precision": 8,
                    //                "min-order-amt": 1,
                    //                "max-order-amt": 5000000,
                    //                "min-order-value": 0.0001,
                    //                "limit-order-min-order-amt": 1,
                    //                "limit-order-max-order-amt": 5000000,
                    //                "limit-order-max-buy-amt": 5000000,
                    //                "limit-order-max-sell-amt": 5000000,
                    //                "sell-market-min-order-amt": 1,
                    //                "sell-market-max-order-amt": 500000,
                    //                "buy-market-max-order-value": 100,
                    //                "leverage-ratio": 5,
                    //                "super-margin-leverage-ratio": 3,
                    //                "api-trading": "enabled",
                    //                "tags": ""
                    //            }
                    //            ...
                    //         ]
                    //    }
                    //
                    const markets = this.safeValue(response, 'data');
                    const numMarkets = markets.length;
                    if (numMarkets < 1) throw new NetworkError(this.id + ' fetchMarkets() returned empty response: ' + this.json(markets));
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const baseId = this.safeString(market, 'base-currency');
                        const quoteId = this.safeString(market, 'quote-currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const state = this.safeString(market, 'state');
                        const leverageRatio = this.safeString(market, 'leverage-ratio', '1');
                        const superLeverageRatio = this.safeString(market, 'super-margin-leverage-ratio', '1');
                        const margin = Precise.stringGt(leverageRatio, '1') || Precise.stringGt(superLeverageRatio, '1');
                        const fee = base === 'OMG' ? 0 : 0.002;
                        result.push({
                            'id': baseId + quoteId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': margin,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': state === 'online',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': fee,
                            'maker': fee,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'price': this.safeInteger(market, 'price-precision'),
                                'amount': this.safeInteger(market, 'amount-precision'),
                                'cost': this.safeInteger(market, 'value-precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': this.parseNumber(leverageRatio),
                                    'superMax': this.parseNumber(superLeverageRatio)
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min-order-amt'),
                                    'max': this.safeNumber(market, 'max-order-amt')
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min-order-value'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker
                    //
                    //     {
                    //         "amount": 26228.672978342216,
                    //         "open": 9078.95,
                    //         "close": 9146.86,
                    //         "high": 9155.41,
                    //         "id": 209988544334,
                    //         "count": 265846,
                    //         "low": 8988.0,
                    //         "version": 209988544334,
                    //         "ask": [ 9146.87, 0.156134 ],
                    //         "vol": 2.3822168242201668E8,
                    //         "bid": [ 9146.86, 0.080758 ],
                    //     }
                    //
                    // fetchTickers
                    //     {
                    //         symbol: "bhdht",
                    //         open:  2.3938,
                    //         high:  2.4151,
                    //         low:  2.3323,
                    //         close:  2.3909,
                    //         amount:  628.992,
                    //         vol:  1493.71841095,
                    //         count:  2088,
                    //         bid:  2.3643,
                    //         bidSize:  0.7136,
                    //         ask:  2.4061,
                    //         askSize:  0.4156
                    //     }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.safeInteger(ticker, 'ts');
                    let bid = undefined;
                    let bidVolume = undefined;
                    let ask = undefined;
                    let askVolume = undefined;
                    if ('bid' in ticker) {
                        if (Array.isArray(ticker['bid'])) {
                            bid = this.safeString(ticker['bid'], 0);
                            bidVolume = this.safeString(ticker['bid'], 1);
                        } else {
                            bid = this.safeString(ticker, 'bid');
                            bidVolume = this.safeString(ticker, 'bidSize');
                        }
                    }
                    if ('ask' in ticker) {
                        if (Array.isArray(ticker['ask'])) {
                            ask = this.safeString(ticker['ask'], 0);
                            askVolume = this.safeString(ticker['ask'], 1);
                        } else {
                            ask = this.safeString(ticker, 'ask');
                            askVolume = this.safeString(ticker, 'askSize');
                        }
                    }
                    const open = this.safeString(ticker, 'open');
                    const close = this.safeString(ticker, 'close');
                    const baseVolume = this.safeString(ticker, 'amount');
                    const quoteVolume = this.safeString(ticker, 'vol');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': bid,
                        'bidVolume': bidVolume,
                        'ask': ask,
                        'askVolume': askVolume,
                        'vwap': undefined,
                        'open': open,
                        'close': close,
                        'last': close,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'type': 'step0'
                    };
                    const response = await this.marketGetDepth(this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "ch": "market.btcusdt.depth.step0",
                    //         "ts": 1583474832790,
                    //         "tick": {
                    //             "bids": [
                    //                 [ 9100.290000000000000000, 0.200000000000000000 ],
                    //                 [ 9099.820000000000000000, 0.200000000000000000 ],
                    //                 [ 9099.610000000000000000, 0.205000000000000000 ],
                    //             ],
                    //             "asks": [
                    //                 [ 9100.640000000000000000, 0.005904000000000000 ],
                    //                 [ 9101.010000000000000000, 0.287311000000000000 ],
                    //                 [ 9101.030000000000000000, 0.012121000000000000 ],
                    //             ],
                    //             "ts":1583474832008,
                    //             "version":104999698780
                    //         }
                    //     }
                    //
                    if ('tick' in response) {
                        if (!response['tick']) throw new BadSymbol(this.id + ' fetchOrderBook() returned empty response: ' + this.json(response));
                        const tick = this.safeValue(response, 'tick');
                        const timestamp = this.safeInteger(tick, 'ts', this.safeInteger(response, 'ts'));
                        const result = this.parseOrderBook(tick, symbol, timestamp);
                        result['nonce'] = this.safeInteger(tick, 'version');
                        return result;
                    }
                    throw new ExchangeError1(this.id + ' fetchOrderBook() returned unrecognized response: ' + this.json(response));
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.marketGetDetailMerged(this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "ch": "market.btcusdt.detail.merged",
                    //         "ts": 1583494336669,
                    //         "tick": {
                    //             "amount": 26228.672978342216,
                    //             "open": 9078.95,
                    //             "close": 9146.86,
                    //             "high": 9155.41,
                    //             "id": 209988544334,
                    //             "count": 265846,
                    //             "low": 8988.0,
                    //             "version": 209988544334,
                    //             "ask": [ 9146.87, 0.156134 ],
                    //             "vol": 2.3822168242201668E8,
                    //             "bid": [ 9146.86, 0.080758 ],
                    //         }
                    //     }
                    //
                    const ticker = this.parseTicker(response['tick'], market);
                    const timestamp = this.safeInteger(response, 'ts');
                    ticker['timestamp'] = timestamp;
                    ticker['datetime'] = this.iso8601(timestamp);
                    return ticker;
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.marketGetTickers(params);
                    const tickers = this.safeValue(response, 'data');
                    const timestamp = this.safeInteger(response, 'ts');
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const marketId = this.safeString(tickers[i], 'symbol');
                        const market = this.safeMarket(marketId);
                        const symbol = market['symbol'];
                        const ticker = this.parseTicker(tickers[i], market);
                        ticker['timestamp'] = timestamp;
                        ticker['datetime'] = this.iso8601(timestamp);
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "amount": 0.010411000000000000,
                    //         "trade-id": 102090736910,
                    //         "ts": 1583497692182,
                    //         "id": 10500517034273194594947,
                    //         "price": 9096.050000000000000000,
                    //         "direction": "sell"
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //          'symbol': 'swftcbtc',
                    //          'fee-currency': 'swftc',
                    //          'filled-fees': '0',
                    //          'source': 'spot-api',
                    //          'id': 83789509854000,
                    //          'type': 'buy-limit',
                    //          'order-id': 83711103204909,
                    //          'filled-points': '0.005826843283532154',
                    //          'fee-deduct-currency': 'ht',
                    //          'filled-amount': '45941.53',
                    //          'price': '0.0000001401',
                    //          'created-at': 1597933260729,
                    //          'match-id': 100087455560,
                    //          'role': 'maker',
                    //          'trade-id': 100050305348
                    //     },
                    //
                    const marketId = this.safeString(trade, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.safeInteger2(trade, 'ts', 'created-at');
                    const order = this.safeString(trade, 'order-id');
                    let side = this.safeString(trade, 'direction');
                    let type = this.safeString(trade, 'type');
                    if (type !== undefined) {
                        const typeParts = type.split('-');
                        side = typeParts[0];
                        type = typeParts[1];
                    }
                    const takerOrMaker = this.safeString(trade, 'role');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString2(trade, 'filled-amount', 'amount');
                    const price = this.parseNumber(priceString);
                    const amount = this.parseNumber(amountString);
                    const cost = this.parseNumber(Precise.stringMul(priceString, amountString));
                    let fee = undefined;
                    let feeCost = this.safeNumber(trade, 'filled-fees');
                    let feeCurrency = this.safeCurrencyCode(this.safeString(trade, 'fee-currency'));
                    const filledPoints = this.safeNumber(trade, 'filled-points');
                    if (filledPoints !== undefined) {
                        if (feeCost === undefined || feeCost === 0.0) {
                            feeCost = filledPoints;
                            feeCurrency = this.safeCurrencyCode(this.safeString(trade, 'fee-deduct-currency'));
                        }
                    }
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': feeCurrency
                    };
                    const tradeId = this.safeString2(trade, 'trade-id', 'tradeId');
                    const id = this.safeString(trade, 'id', tradeId);
                    return {
                        'id': id,
                        'info': trade,
                        'order': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': fee
                    };
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetOrderOrdersIdMatchresults(this.extend(request, params));
                    return this.parseTrades(response['data'], undefined, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['size'] = limit; // 1-100 orders, default is 100
                    if (since !== undefined) request['start-time'] = since; // a date within 120 days from today
                    const response = await this.privateGetOrderMatchresults(this.extend(request, params));
                    return this.parseTrades(response['data'], market, since, limit);
                }
                async fetchTrades(symbol, since, limit = 1000, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this.marketGetHistoryTrade(this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "ch": "market.btcusdt.trade.detail",
                    //         "ts": 1583497692365,
                    //         "data": [
                    //             {
                    //                 "id": 105005170342,
                    //                 "ts": 1583497692182,
                    //                 "data": [
                    //                     {
                    //                         "amount": 0.010411000000000000,
                    //                         "trade-id": 102090736910,
                    //                         "ts": 1583497692182,
                    //                         "id": 10500517034273194594947,
                    //                         "price": 9096.050000000000000000,
                    //                         "direction": "sell"
                    //                     }
                    //                 ]
                    //             },
                    //             // ...
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    let result = [];
                    for(let i = 0; i < data.length; i++){
                        const trades = this.safeValue(data[i], 'data', []);
                        for(let j = 0; j < trades.length; j++){
                            const trade = this.parseTrade(trades[j], market);
                            result.push(trade);
                        }
                    }
                    result = this.sortBy(result, 'timestamp');
                    return this.filterBySymbolSinceLimit(result, market['symbol'], since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "amount":1.2082,
                    //         "open":0.025096,
                    //         "close":0.025095,
                    //         "high":0.025096,
                    //         "id":1591515300,
                    //         "count":6,
                    //         "low":0.025095,
                    //         "vol":0.0303205097
                    //     }
                    //
                    return [
                        this.safeTimestamp(ohlcv, 'id'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'amount')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit = 1000, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'period': this.timeframes[timeframe]
                    };
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this.marketGetHistoryKline(this.extend(request, params));
                    //
                    //     {
                    //         "status":"ok",
                    //         "ch":"market.ethbtc.kline.1min",
                    //         "ts":1591515374371,
                    //         "data":[
                    //             {"amount":0.0,"open":0.025095,"close":0.025095,"high":0.025095,"id":1591515360,"count":0,"low":0.025095,"vol":0.0},
                    //             {"amount":1.2082,"open":0.025096,"close":0.025095,"high":0.025096,"id":1591515300,"count":6,"low":0.025095,"vol":0.0303205097},
                    //             {"amount":0.0648,"open":0.025096,"close":0.025096,"high":0.025096,"id":1591515240,"count":2,"low":0.025096,"vol":0.0016262208},
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async fetchAccounts(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountAccounts(params);
                    return response['data'];
                }
                async fetchCurrencies(params = {}) {
                    const request = {
                        'language': this.options['language']
                    };
                    const response = await this.publicGetSettingsCurrencys(this.extend(request, params));
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "currency-addr-with-tag":false,
                    //                 "fast-confirms":12,
                    //                 "safe-confirms":12,
                    //                 "currency-type":"eth",
                    //                 "quote-currency":true,
                    //                 "withdraw-enable-timestamp":1609430400000,
                    //                 "deposit-enable-timestamp":1609430400000,
                    //                 "currency-partition":"all",
                    //                 "support-sites":["OTC","INSTITUTION","MINEPOOL"],
                    //                 "withdraw-precision":6,
                    //                 "visible-assets-timestamp":1508839200000,
                    //                 "deposit-min-amount":"1",
                    //                 "withdraw-min-amount":"10",
                    //                 "show-precision":"8",
                    //                 "tags":"",
                    //                 "weight":23,
                    //                 "full-name":"Tether USDT",
                    //                 "otc-enable":1,
                    //                 "visible":true,
                    //                 "white-enabled":false,
                    //                 "country-disabled":false,
                    //                 "deposit-enabled":true,
                    //                 "withdraw-enabled":true,
                    //                 "name":"usdt",
                    //                 "state":"online",
                    //                 "display-name":"USDT",
                    //                 "suspend-withdraw-desc":null,
                    //                 "withdraw-desc":"Minimum withdrawal amount: 10 USDT (ERC20). !>_<!To ensure the safety of your funds, your withdrawal request will be manually reviewed if your security strategy or password is changed. Please wait for phone calls or emails from our staff.!>_<!Please make sure that your computer and browser are secure and your information is protected from being tampered or leaked.",
                    //                 "suspend-deposit-desc":null,
                    //                 "deposit-desc":"Please don’t deposit any other digital assets except USDT to the above address. Otherwise, you may lose your assets permanently. !>_<!Depositing to the above address requires confirmations of the entire network. It will arrive after 12 confirmations, and it will be available to withdraw after 12 confirmations. !>_<!Minimum deposit amount: 1 USDT. Any deposits less than the minimum will not be credited or refunded.!>_<!Your deposit address won’t change often. If there are any changes, we will notify you via announcement or email.!>_<!Please make sure that your computer and browser are secure and your information is protected from being tampered or leaked.",
                    //                 "suspend-visible-desc":null
                    //             }
                    //         ]
                    //     }
                    //
                    const currencies = this.safeValue(response, 'data');
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeValue(currency, 'name');
                        const precision = this.safeInteger(currency, 'withdraw-precision');
                        const code = this.safeCurrencyCode(id);
                        const depositEnabled = this.safeValue(currency, 'deposit-enabled');
                        const withdrawEnabled = this.safeValue(currency, 'withdraw-enabled');
                        const countryDisabled = this.safeValue(currency, 'country-disabled');
                        const visible = this.safeValue(currency, 'visible', false);
                        const state = this.safeString(currency, 'state');
                        const active = visible && depositEnabled && withdrawEnabled && state === 'online' && !countryDisabled;
                        const name = this.safeString(currency, 'display-name');
                        result[code] = {
                            'id': id,
                            'code': code,
                            'type': 'crypto',
                            // 'payin': currency['deposit-enabled'],
                            // 'payout': currency['withdraw-enabled'],
                            // 'transfer': undefined,
                            'name': name,
                            'active': active,
                            'deposit': depositEnabled,
                            'withdraw': withdrawEnabled,
                            'fee': undefined,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': Math.pow(10, -precision),
                                    'max': Math.pow(10, precision)
                                },
                                'deposit': {
                                    'min': this.safeNumber(currency, 'deposit-min-amount'),
                                    'max': Math.pow(10, precision)
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'withdraw-min-amount'),
                                    'max': Math.pow(10, precision)
                                }
                            },
                            'info': currency
                        };
                    }
                    return result;
                }
                parseBalance(response) {
                    const balances = this.safeValue(response['data'], 'list', []);
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        let account = undefined;
                        if (code in result) account = result[code];
                        else account = this.account();
                        if (balance['type'] === 'trade') account['free'] = this.safeString(balance, 'balance');
                        if (balance['type'] === 'frozen') account['used'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const method = this.options['fetchBalanceMethod'];
                    const request = {
                        'id': this.accounts[0]['id']
                    };
                    const response = await this[method](this.extend(request, params));
                    return this.parseBalance(response);
                }
                async fetchOrdersByStates(states, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'states': states
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const method = this.safeString(this.options, 'fetchOrdersByStatesMethod', 'private_get_order_orders');
                    const response = await this[method](this.extend(request, params));
                    //
                    //     { status:   "ok",
                    //         data: [ {                  id:  13997833014,
                    //                                symbol: "ethbtc",
                    //                          'account-id':  3398321,
                    //                                amount: "0.045000000000000000",
                    //                                 price: "0.034014000000000000",
                    //                          'created-at':  1545836976871,
                    //                                  type: "sell-limit",
                    //                        'field-amount': "0.045000000000000000",
                    //                   'field-cash-amount': "0.001530630000000000",
                    //                          'field-fees': "0.000003061260000000",
                    //                         'finished-at':  1545837948214,
                    //                                source: "spot-api",
                    //                                 state: "filled",
                    //                         'canceled-at':  0                      }  ] }
                    //
                    return this.parseOrders(response['data'], market, since, limit);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetOrderOrdersId(this.extend(request, params));
                    const order = this.safeValue(response, 'data');
                    return this.parseOrder(order);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByStates('pre-submitted,submitted,partial-filled,filled,partial-canceled,canceled', symbol, since, limit, params);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const method = this.safeString(this.options, 'fetchOpenOrdersMethod', 'fetch_open_orders_v1');
                    return await this[method](symbol, since, limit, params);
                }
                async fetchOpenOrdersV1(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrdersV1() requires a symbol argument');
                    return await this.fetchOrdersByStates('pre-submitted,submitted,partial-filled', symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByStates('filled,partial-canceled,canceled', symbol, since, limit, params);
                }
                async fetchOpenOrdersV2(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    let accountId = this.safeString(params, 'account-id');
                    if (accountId === undefined) {
                        // pick the first account
                        await this.loadAccounts();
                        for(let i = 0; i < this.accounts.length; i++){
                            const account = this.accounts[i];
                            if (account['type'] === 'spot') {
                                accountId = this.safeString(account, 'id');
                                if (accountId !== undefined) break;
                            }
                        }
                    }
                    request['account-id'] = accountId;
                    if (limit !== undefined) request['size'] = limit;
                    const omitted = this.omit(params, 'account-id');
                    const response = await this.privateGetOrderOpenOrders(this.extend(request, omitted));
                    //
                    //     {
                    //         "status":"ok",
                    //         "data":[
                    //             {
                    //                 "symbol":"ethusdt",
                    //                 "source":"api",
                    //                 "amount":"0.010000000000000000",
                    //                 "account-id":1528640,
                    //                 "created-at":1561597491963,
                    //                 "price":"400.000000000000000000",
                    //                 "filled-amount":"0.0",
                    //                 "filled-cash-amount":"0.0",
                    //                 "filled-fees":"0.0",
                    //                 "id":38477101630,
                    //                 "state":"submitted",
                    //                 "type":"sell-limit"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'partial-filled': 'open',
                        'partial-canceled': 'canceled',
                        'filled': 'closed',
                        'canceled': 'canceled',
                        'submitted': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {                  id:  13997833014,
                    //                    symbol: "ethbtc",
                    //              'account-id':  3398321,
                    //                    amount: "0.045000000000000000",
                    //                     price: "0.034014000000000000",
                    //              'created-at':  1545836976871,
                    //                      type: "sell-limit",
                    //            'field-amount': "0.045000000000000000", // they have fixed it for filled-amount
                    //       'field-cash-amount': "0.001530630000000000", // they have fixed it for filled-cash-amount
                    //              'field-fees': "0.000003061260000000", // they have fixed it for filled-fees
                    //             'finished-at':  1545837948214,
                    //                    source: "spot-api",
                    //                     state: "filled",
                    //             'canceled-at':  0                      }
                    //
                    //     {                  id:  20395337822,
                    //                    symbol: "ethbtc",
                    //              'account-id':  5685075,
                    //                    amount: "0.001000000000000000",
                    //                     price: "0.0",
                    //              'created-at':  1545831584023,
                    //                      type: "buy-market",
                    //            'field-amount': "0.029100000000000000", // they have fixed it for filled-amount
                    //       'field-cash-amount': "0.000999788700000000", // they have fixed it for filled-cash-amount
                    //              'field-fees': "0.000058200000000000", // they have fixed it for filled-fees
                    //             'finished-at':  1545831584181,
                    //                    source: "spot-api",
                    //                     state: "filled",
                    //             'canceled-at':  0                      }
                    //
                    const id = this.safeString(order, 'id');
                    let side = undefined;
                    let type = undefined;
                    let status = undefined;
                    if ('type' in order) {
                        const orderType = order['type'].split('-');
                        side = orderType[0];
                        type = orderType[1];
                        status = this.parseOrderStatus(this.safeString(order, 'state'));
                    }
                    const marketId = this.safeString(order, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const timestamp = this.safeInteger(order, 'created-at');
                    const clientOrderId = this.safeString(order, 'client-order-id');
                    const amount = this.safeString(order, 'amount');
                    const filled = this.safeString2(order, 'filled-amount', 'field-amount'); // typo in their API, filled amount
                    const price = this.safeString(order, 'price');
                    const cost = this.safeString2(order, 'filled-cash-amount', 'field-cash-amount'); // same typo
                    const feeCost = this.safeString2(order, 'filled-fees', 'field-fees'); // typo in their API, filled fees
                    let fee = undefined;
                    if (feeCost !== undefined) {
                        const feeCurrency = side === 'sell' ? market['quote'] : market['base'];
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrency
                        };
                    }
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'average': undefined,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const market = this.market(symbol);
                    const request = {
                        'account-id': this.accounts[0]['id'],
                        'symbol': market['id'],
                        'type': side + '-' + type
                    };
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client-order-id'); // must be 64 chars max and unique within 24 hours
                    if (clientOrderId === undefined) {
                        const broker = this.safeValue(this.options, 'broker', {});
                        const brokerId = this.safeString(broker, 'id');
                        request['client-order-id'] = brokerId + this.uuid();
                    } else request['client-order-id'] = clientOrderId;
                    params = this.omit(params, [
                        'clientOrderId',
                        'client-order-id'
                    ]);
                    if (type === 'market' && side === 'buy') {
                        if (this.options['createMarketBuyOrderRequiresPrice']) {
                            if (price === undefined) throw new InvalidOrder(this.id + " market buy order requires price argument to calculate cost (total amount of quote currency to spend for buying, amount * price). To switch off this warning exception and specify cost in the amount argument, set .options['createMarketBuyOrderRequiresPrice'] = false. Make sure you know what you're doing.");
                            else // despite that cost = amount * price is in quote currency and should have quote precision
                            // the exchange API requires the cost supplied in 'amount' to be of base precision
                            // more about it here:
                            // https://github.com/ccxt/ccxt/pull/4395
                            // https://github.com/ccxt/ccxt/issues/7611
                            // we use amountToPrecision here because the exchange requires cost in base precision
                            request['amount'] = this.costToPrecision(symbol, parseFloat(amount) * parseFloat(price));
                        } else request['amount'] = this.costToPrecision(symbol, amount);
                    } else request['amount'] = this.amountToPrecision(symbol, amount);
                    if (type === 'limit' || type === 'ioc' || type === 'limit-maker' || type === 'stop-limit' || type === 'stop-limit-fok') request['price'] = this.priceToPrecision(symbol, price);
                    const method = this.options['createOrderMethod'];
                    const response = await this[method](this.extend(request, params));
                    const timestamp = this.milliseconds();
                    const id = this.safeString(response, 'data');
                    return {
                        'info': response,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': undefined,
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'filled': undefined,
                        'remaining': undefined,
                        'cost': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'clientOrderId': undefined,
                        'average': undefined
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    const response = await this.privatePostOrderOrdersIdSubmitcancel({
                        'id': id
                    });
                    //
                    //     {
                    //         'status': 'ok',
                    //         'data': '10138899000',
                    //     }
                    //
                    return this.extend(this.parseOrder(response), {
                        'id': id,
                        'status': 'canceled'
                    });
                }
                async cancelOrders(ids, symbol, params = {}) {
                    await this.loadMarkets();
                    const clientOrderIds = this.safeValue2(params, 'clientOrderIds', 'client-order-ids');
                    params = this.omit(params, [
                        'clientOrderIds',
                        'client-order-ids'
                    ]);
                    const request = {};
                    if (clientOrderIds === undefined) request['order-ids'] = ids;
                    else request['client-order-ids'] = clientOrderIds;
                    const response = await this.privatePostOrderOrdersBatchcancel(this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": {
                    //             "success": [
                    //                 "5983466"
                    //             ],
                    //             "failed": [
                    //                 {
                    //                     "err-msg": "Incorrect order state",
                    //                     "order-state": 7,
                    //                     "order-id": "",
                    //                     "err-code": "order-orderstate-error",
                    //                     "client-order-id": "first"
                    //                 },
                    //                 {
                    //                     "err-msg": "Incorrect order state",
                    //                     "order-state": 7,
                    //                     "order-id": "",
                    //                     "err-code": "order-orderstate-error",
                    //                     "client-order-id": "second"
                    //                 },
                    //                 {
                    //                     "err-msg": "The record is not found.",
                    //                     "order-id": "",
                    //                     "err-code": "base-not-found",
                    //                     "client-order-id": "third"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    return response;
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const response = await this.privatePostOrderOrdersBatchCancelOpenOrders(this.extend(request, params));
                    //
                    //     {
                    //         code: 200,
                    //         data: {
                    //             "success-count": 2,
                    //             "failed-count": 0,
                    //             "next-id": 5454600
                    //         }
                    //     }
                    //
                    return response;
                }
                currencyToPrecision(code, fee) {
                    return this.decimalToPrecision(fee, 0, this.currencies[code]['precision']);
                }
                safeNetwork(networkId) {
                    const lastCharacterIndex = networkId.length - 1;
                    const lastCharacter = networkId[lastCharacterIndex];
                    if (lastCharacter === '1') networkId = networkId.slice(0, lastCharacterIndex);
                    const networksById = {};
                    return this.safeString(networksById, networkId, networkId);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         currency: "usdt",
                    //         address: "0xf7292eb9ba7bc50358e27f0e025a4d225a64127b",
                    //         addressTag: "",
                    //         chain: "usdterc20", // trc20usdt, hrc20usdt, usdt, algousdt
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'address');
                    let tag = this.safeString(depositAddress, 'addressTag');
                    if (tag === '') tag = undefined;
                    const currencyId = this.safeString(depositAddress, 'currency');
                    currency = this.safeCurrency(currencyId, currency);
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const networkId = this.safeString(depositAddress, 'chain');
                    const networks = this.safeValue(currency, 'networks', {});
                    const networksById = this.indexBy(networks, 'id');
                    const networkValue = this.safeValue(networksById, networkId, networkId);
                    const network = this.safeString(networkValue, 'network');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': network,
                        'info': depositAddress
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    if (limit === undefined || limit > 100) limit = 100;
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const request = {
                        'type': 'deposit',
                        'from': 0
                    };
                    if (currency !== undefined) request['currency'] = currency['id'];
                    if (limit !== undefined) request['size'] = limit; // max 100
                    const response = await this.privateGetQueryDepositWithdraw(this.extend(request, params));
                    // return response
                    return this.parseTransactions(response['data'], currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    if (limit === undefined || limit > 100) limit = 100;
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const request = {
                        'type': 'withdraw',
                        'from': 0
                    };
                    if (currency !== undefined) request['currency'] = currency['id'];
                    if (limit !== undefined) request['size'] = limit; // max 100
                    const response = await this.privateGetQueryDepositWithdraw(this.extend(request, params));
                    // return response
                    return this.parseTransactions(response['data'], currency, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         'id': 8211029,
                    //         'type': 'deposit',
                    //         'currency': 'eth',
                    //         'chain': 'eth',
                    //         'tx-hash': 'bd315....',
                    //         'amount': 0.81162421,
                    //         'address': '4b8b....',
                    //         'address-tag': '',
                    //         'fee': 0,
                    //         'state': 'safe',
                    //         'created-at': 1542180380965,
                    //         'updated-at': 1542180788077
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         'id': 6908275,
                    //         'type': 'withdraw',
                    //         'currency': 'btc',
                    //         'chain': 'btc',
                    //         'tx-hash': 'c1a1a....',
                    //         'amount': 0.80257005,
                    //         'address': '1QR....',
                    //         'address-tag': '',
                    //         'fee': 0.0005,
                    //         'state': 'confirmed',
                    //         'created-at': 1552107295685,
                    //         'updated-at': 1552108032859
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": "99562054"
                    //     }
                    //
                    const timestamp = this.safeInteger(transaction, 'created-at');
                    const updated = this.safeInteger(transaction, 'updated-at');
                    const code = this.safeCurrencyCode(this.safeString(transaction, 'currency'));
                    let type = this.safeString(transaction, 'type');
                    if (type === 'withdraw') type = 'withdrawal';
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    const tag = this.safeString(transaction, 'address-tag');
                    let feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost !== undefined) feeCost = Math.abs(feeCost);
                    const address = this.safeString(transaction, 'address');
                    const network = this.safeStringUpper(transaction, 'chain');
                    return {
                        'info': transaction,
                        'id': this.safeString2(transaction, 'id', 'data'),
                        'txid': this.safeString(transaction, 'tx-hash'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': this.safeNumber(transaction, 'amount'),
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': {
                            'currency': code,
                            'cost': feeCost,
                            'rate': undefined
                        }
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        // deposit statuses
                        'unknown': 'failed',
                        'confirming': 'pending',
                        'confirmed': 'ok',
                        'safe': 'ok',
                        'orphan': 'failed',
                        // withdrawal statuses
                        'submitted': 'pending',
                        'canceled': 'canceled',
                        'reexamine': 'pending',
                        'reject': 'failed',
                        'pass': 'pending',
                        'wallet-reject': 'failed',
                        // 'confirmed': 'ok', // present in deposit statuses
                        'confirm-error': 'failed',
                        'repealed': 'failed',
                        'wallet-transfer': 'pending',
                        'pre-transfer': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    this.checkAddress(address);
                    const currency = this.currency(code);
                    const request = {
                        'address': address,
                        'amount': amount,
                        'currency': currency['id'].toLowerCase()
                    };
                    if (tag !== undefined) request['addr-tag'] = tag; // only for XRP?
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeStringLower(networks, network, network); // handle ETH>ERC20 alias
                    if (network !== undefined) {
                        // possible chains - usdterc20, trc20usdt, hrc20usdt, usdt, algousdt
                        if (network === 'erc20') request['chain'] = currency['id'] + network;
                        else request['chain'] = network + currency['id'];
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privatePostDwWithdrawApiCreate(this.extend(request, params));
                    //
                    //     {
                    //         "status": "ok",
                    //         "data": "99562054"
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = '/';
                    if (api === 'market') url += api;
                    else if (api === 'public' || api === 'private') url += this.version;
                    else if (api === 'v2Public' || api === 'v2Private') url += 'v2';
                    url += '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'private' || api === 'v2Private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.ymdhms(this.milliseconds(), 'T');
                        let request = {
                            'SignatureMethod': 'HmacSHA256',
                            'SignatureVersion': '2',
                            'AccessKeyId': this.apiKey,
                            'Timestamp': timestamp
                        };
                        if (method !== 'POST') request = this.extend(request, query);
                        request = this.keysort(request);
                        let auth = this.urlencode(request);
                        // unfortunately, PHP demands double quotes for the escaped newline symbol
                        // eslint-disable-next-line quotes
                        const payload = [
                            method,
                            this.hostname,
                            url,
                            auth
                        ].join("\n");
                        const signature = this.hmac(this.encode(payload), this.encode(this.secret), 'sha256', 'base64');
                        auth += '&' + this.urlencode({
                            'Signature': signature
                        });
                        url += '?' + auth;
                        if (method === 'POST') {
                            body = this.json(query);
                            headers = {
                                'Content-Type': 'application/json'
                            };
                        } else headers = {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                    } else if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    url = this.implodeParams(this.urls['api'][api], {
                        'hostname': this.hostname
                    }) + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                calculateRateLimiterCost(api, method, path, params, config = {}, context = {}) {
                    return this.safeInteger(config, 'cost', 1);
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if ('status' in response) {
                        //
                        //     {"status":"error","err-code":"order-limitorder-amount-min-error","err-msg":"limit order amount error, min: `0.001`","data":null}
                        //
                        const status = this.safeString(response, 'status');
                        if (status === 'error') {
                            const code = this.safeString(response, 'err-code');
                            const feedback = this.id + ' ' + body;
                            this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                            this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                            const message = this.safeString(response, 'err-msg');
                            this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    90: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const huobi = require1('./huobi.js');
            // ---------------------------------------------------------------------------
            module.exports = class huobipro extends huobi {
                describe() {
                    // this is an alias for backward-compatibility
                    // to be removed soon
                    return this.deepExtend(super.describe(), {
                        'id': 'huobipro',
                        'alias': true
                    });
                }
            };
        },
        {
            "./huobi.js": 88
        }
    ],
    91: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { PAD_WITH_ZERO: PAD_WITH_ZERO } = require1('./base/functions/number');
            const { InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, DDoSProtection: DDoSProtection, BadRequest: BadRequest, NotSupported: NotSupported, InvalidAddress: InvalidAddress, AuthenticationError: AuthenticationError } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            // ---------------------------------------------------------------------------
            module.exports = class idex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'idex',
                        'name': 'IDEX',
                        'countries': [
                            'US'
                        ],
                        // public data endpoints 5 requests a second => 1000ms / 5 = 200ms between requests roughly (without Authentication)
                        // all endpoints 10 requests a second => (1000ms / rateLimit) / 10 => 1 / 2 (with Authentication)
                        'rateLimit': 200,
                        'version': 'v3',
                        'pro': true,
                        'certified': true,
                        'requiresWeb3': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': undefined,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': undefined,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '6h': '6h',
                            '1d': '1d'
                        },
                        'urls': {
                            'test': {
                                'MATIC': 'https://api-sandbox-matic.idex.io'
                            },
                            'logo': 'https://user-images.githubusercontent.com/51840849/94481303-2f222100-01e0-11eb-97dd-bc14c5943a86.jpg',
                            'api': {
                                'MATIC': 'https://api-matic.idex.io'
                            },
                            'www': 'https://idex.io',
                            'doc': [
                                'https://docs.idex.io/'
                            ]
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'ping': 1,
                                    'time': 1,
                                    'exchange': 1,
                                    'assets': 1,
                                    'markets': 1,
                                    'tickers': 1,
                                    'candles': 1,
                                    'trades': 1,
                                    'orderbook': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'user': 1,
                                    'wallets': 1,
                                    'balances': 1,
                                    'orders': 1,
                                    'fills': 1,
                                    'deposits': 1,
                                    'withdrawals': 1,
                                    'wsToken': 1
                                },
                                'post': {
                                    'wallets': 1,
                                    'orders': 1,
                                    'orders/test': 1,
                                    'withdrawals': 1
                                },
                                'delete': {
                                    'orders': 1
                                }
                            }
                        },
                        'options': {
                            'defaultTimeInForce': 'gtc',
                            'defaultSelfTradePrevention': 'cn',
                            'network': 'MATIC'
                        },
                        'exceptions': {
                            'INVALID_ORDER_QUANTITY': InvalidOrder,
                            'INSUFFICIENT_FUNDS': InsufficientFunds,
                            'SERVICE_UNAVAILABLE': ExchangeNotAvailable,
                            'EXCEEDED_RATE_LIMIT': DDoSProtection,
                            'INVALID_PARAMETER': BadRequest,
                            'WALLET_NOT_ASSOCIATED': InvalidAddress,
                            'INVALID_WALLET_SIGNATURE': AuthenticationError
                        },
                        'requiredCredentials': {
                            'walletAddress': true,
                            'privateKey': true,
                            'apiKey': true,
                            'secret': true
                        },
                        'paddingMode': PAD_WITH_ZERO,
                        'commonCurrencies': {}
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetMarkets(params);
                    //
                    // [
                    //   {
                    //     market: 'DIL-ETH',
                    //     status: 'active',
                    //     baseAsset: 'DIL',
                    //     baseAssetPrecision: 8,
                    //     quoteAsset: 'ETH',
                    //     quoteAssetPrecision: 8
                    //   }, ...
                    // ]
                    //
                    const response2 = await this.publicGetExchange();
                    //
                    // {
                    //     "timeZone": "UTC",
                    //     "serverTime": 1590408000000,
                    //     "ethereumDepositContractAddress": "0x...",
                    //     "ethUsdPrice": "206.46",
                    //     "gasPrice": 7,
                    //     "volume24hUsd": "10416227.98",
                    //     "makerFeeRate": "0.001",
                    //     "takerFeeRate": "0.002",
                    //     "makerTradeMinimum": "0.15000000",
                    //     "takerTradeMinimum": "0.05000000",
                    //     "withdrawalMinimum": "0.04000000"
                    // }
                    //
                    const maker = this.safeNumber(response2, 'makerFeeRate');
                    const taker = this.safeNumber(response2, 'takerFeeRate');
                    const makerMin = this.safeString(response2, 'makerTradeMinimum');
                    const takerMin = this.safeString(response2, 'takerTradeMinimum');
                    const minCostETH = this.parseNumber(Precise.stringMin(makerMin, takerMin));
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const marketId = this.safeString(entry, 'market');
                        const baseId = this.safeString(entry, 'baseAsset');
                        const quoteId = this.safeString(entry, 'quoteAsset');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const basePrecisionString = this.safeString(entry, 'baseAssetPrecision');
                        const quotePrecisionString = this.safeString(entry, 'quoteAssetPrecision');
                        const basePrecision = this.parsePrecision(basePrecisionString);
                        const quotePrecision = this.parsePrecision(quotePrecisionString);
                        const status = this.safeString(entry, 'status');
                        let minCost = undefined;
                        if (quote === 'ETH') minCost = minCostETH;
                        result.push({
                            'id': marketId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': status === 'active',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': taker,
                            'maker': maker,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': parseInt(basePrecisionString),
                                'price': parseInt(quotePrecisionString)
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.parseNumber(basePrecision),
                                    'max': undefined
                                },
                                'price': {
                                    'min': this.parseNumber(quotePrecision),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': minCost,
                                    'max': undefined
                                }
                            },
                            'info': entry
                        });
                    }
                    return result;
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    // [
                    //   {
                    //     market: 'DIL-ETH',
                    //     time: 1598367493008,
                    //     open: '0.09695361',
                    //     high: '0.10245881',
                    //     low: '0.09572507',
                    //     close: '0.09917079',
                    //     closeQuantity: '0.71320950',
                    //     baseVolume: '309.17380612',
                    //     quoteVolume: '30.57633981',
                    //     percentChange: '2.28',
                    //     numTrades: 205,
                    //     ask: '0.09910476',
                    //     bid: '0.09688340',
                    //     sequence: 3902
                    //   }
                    // ]
                    const response = await this.publicGetTickers(this.extend(request, params));
                    const ticker = this.safeValue(response, 0);
                    return this.parseTicker(ticker, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    // [
                    //   {
                    //     market: 'DIL-ETH',
                    //     time: 1598367493008,
                    //     open: '0.09695361',
                    //     high: '0.10245881',
                    //     low: '0.09572507',
                    //     close: '0.09917079',
                    //     closeQuantity: '0.71320950',
                    //     baseVolume: '309.17380612',
                    //     quoteVolume: '30.57633981',
                    //     percentChange: '2.28',
                    //     numTrades: 205,
                    //     ask: '0.09910476',
                    //     bid: '0.09688340',
                    //     sequence: 3902
                    //   }, ...
                    // ]
                    const response = await this.publicGetTickers(params);
                    return this.parseTickers(response, symbols);
                }
                parseTicker(ticker, market) {
                    // {
                    //   market: 'DIL-ETH',
                    //   time: 1598367493008,
                    //   open: '0.09695361',
                    //   high: '0.10245881',
                    //   low: '0.09572507',
                    //   close: '0.09917079',
                    //   closeQuantity: '0.71320950',
                    //   baseVolume: '309.17380612',
                    //   quoteVolume: '30.57633981',
                    //   percentChange: '2.28',
                    //   numTrades: 205,
                    //   ask: '0.09910476',
                    //   bid: '0.09688340',
                    //   sequence: 3902
                    // }
                    const marketId = this.safeString(ticker, 'market');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    const timestamp = this.safeInteger(ticker, 'time');
                    const close = this.safeString(ticker, 'close');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open'),
                        'close': close,
                        'last': close,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': this.safeString(ticker, 'percentChange'),
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'baseVolume'),
                        'quoteVolume': this.safeString(ticker, 'quoteVolume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'interval': timeframe
                    };
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetCandles(this.extend(request, params));
                    if (Array.isArray(response)) // [
                    //   {
                    //     start: 1598345580000,
                    //     open: '0.09771286',
                    //     high: '0.09771286',
                    //     low: '0.09771286',
                    //     close: '0.09771286',
                    //     volume: '1.45340410',
                    //     sequence: 3853
                    //   }, ...
                    // ]
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                    else //  {"nextTime":1595536440000}
                    return [];
                }
                parseOHLCV(ohlcv, market) {
                    // {
                    //   start: 1598345580000,
                    //   open: '0.09771286',
                    //   high: '0.09771286',
                    //   low: '0.09771286',
                    //   close: '0.09771286',
                    //   volume: '1.45340410',
                    //   sequence: 3853
                    // }
                    const timestamp = this.safeInteger(ohlcv, 'start');
                    const open = this.safeNumber(ohlcv, 'open');
                    const high = this.safeNumber(ohlcv, 'high');
                    const low = this.safeNumber(ohlcv, 'low');
                    const close = this.safeNumber(ohlcv, 'close');
                    const volume = this.safeNumber(ohlcv, 'volume');
                    return [
                        timestamp,
                        open,
                        high,
                        low,
                        close,
                        volume
                    ];
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    // [
                    //   {
                    //     fillId: 'b5467d00-b13e-3fa9-8216-dd66735550fc',
                    //     price: '0.09771286',
                    //     quantity: '1.45340410',
                    //     quoteQuantity: '0.14201627',
                    //     time: 1598345638994,
                    //     makerSide: 'buy',
                    //     sequence: 3853
                    //   }, ...
                    // ]
                    const response = await this.publicGetTrades(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // public trades
                    //  {
                    //      "fillId":"a4883704-850b-3c4b-8588-020b5e4c62f1",
                    //      "price":"0.20377008",
                    //      "quantity":"47.58448728",
                    //      "quoteQuantity":"9.69629509",
                    //      "time":1642091300873,
                    //      "makerSide":"buy",
                    //      "type":"hybrid",        // one of either: "orderBook", "hybrid", or "pool"
                    //      "sequence":31876
                    //  }
                    //
                    // private trades
                    //  {
                    //      "fillId":"83429066-9334-3582-b710-78858b2f0d6b",
                    //      "price":"0.20717368",
                    //      "quantity":"15.00000000",
                    //      "quoteQuantity":"3.10760523",
                    //      "orderBookQuantity":"0.00000003",
                    //      "orderBookQuoteQuantity":"0.00000001",
                    //      "poolQuantity":"14.99999997",
                    //      "poolQuoteQuantity":"3.10760522",
                    //      "time":1642083351215,
                    //      "makerSide":"sell",
                    //      "sequence":31795,
                    //      "market":"IDEX-USDC",
                    //      "orderId":"4fe993f0-747b-11ec-bd08-79d4a0b6e47c",
                    //      "side":"buy",
                    //      "fee":"0.03749989",
                    //      "feeAsset":"IDEX",
                    //      "gas":"0.40507261",
                    //      "liquidity":"taker",
                    //      "type":"hybrid",
                    //      "txId":"0x69f6d82a762d12e3201efd0b3e9cc1969351e3c6ea3cf07c47c66bf24a459815",
                    //      "txStatus":"mined"
                    //  }
                    //
                    const id = this.safeString(trade, 'fillId');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'quantity');
                    const costString = this.safeString(trade, 'quoteQuantity');
                    const timestamp = this.safeInteger(trade, 'time');
                    const marketId = this.safeString(trade, 'market');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    // this code handles the duality of public vs private trades
                    const makerSide = this.safeString(trade, 'makerSide');
                    const oppositeSide = makerSide === 'buy' ? 'sell' : 'buy';
                    const side = this.safeString(trade, 'side', oppositeSide);
                    const takerOrMaker = this.safeString(trade, 'liquidity', 'taker');
                    const feeCostString = this.safeString(trade, 'fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'feeAsset');
                        fee = {
                            'cost': feeCostString,
                            'currency': this.safeCurrencyCode(feeCurrencyId)
                        };
                    }
                    const orderId = this.safeString(trade, 'orderId');
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': orderId,
                        'type': 'limit',
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTradingFees(params = {}) {
                    this.checkRequiredCredentials();
                    await this.loadMarkets();
                    const nonce = this.uuidv1();
                    const request = {
                        'nonce': nonce
                    };
                    let response = undefined;
                    response = await this.privateGetUser(this.extend(request, params));
                    //
                    //     {
                    //         depositEnabled: true,
                    //         orderEnabled: true,
                    //         cancelEnabled: true,
                    //         withdrawEnabled: true,
                    //         totalPortfolioValueUsd: '0.00',
                    //         makerFeeRate: '0.0000',
                    //         takerFeeRate: '0.0025',
                    //         takerIdexFeeRate: '0.0005',
                    //         takerLiquidityProviderFeeRate: '0.0020'
                    //     }
                    //
                    const maker = this.safeNumber(response, 'makerFeeRate');
                    const taker = this.safeNumber(response, 'takerFeeRate');
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': maker,
                            'taker': taker,
                            'percentage': true,
                            'tierBased': false
                        };
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'level': 2
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    // {
                    //   sequence: 36416753,
                    //   bids: [
                    //     [ '0.09672815', '8.22284267', 1 ],
                    //     [ '0.09672814', '1.83685554', 1 ],
                    //     [ '0.09672143', '4.10962617', 1 ],
                    //     [ '0.09658884', '4.03863759', 1 ],
                    //     [ '0.09653781', '3.35730684', 1 ],
                    //     [ '0.09624660', '2.54163586', 1 ],
                    //     [ '0.09617490', '1.93065030', 1 ]
                    //   ],
                    //   asks: [
                    //     [ '0.09910476', '3.22840154', 1 ],
                    //     [ '0.09940587', '3.39796593', 1 ],
                    //     [ '0.09948189', '4.25088898', 1 ],
                    //     [ '0.09958362', '2.42195784', 1 ],
                    //     [ '0.09974393', '4.25234367', 1 ],
                    //     [ '0.09995250', '3.40192141', 1 ]
                    //   ]
                    // }
                    const response = await this.publicGetOrderbook(this.extend(request, params));
                    const nonce = this.safeInteger(response, 'sequence');
                    return {
                        'symbol': symbol,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'nonce': nonce,
                        'bids': this.parseSide(response, 'bids'),
                        'asks': this.parseSide(response, 'asks')
                    };
                }
                parseSide(book, side) {
                    const bookSide = this.safeValue(book, side, []);
                    const result = [];
                    for(let i = 0; i < bookSide.length; i++){
                        const order = bookSide[i];
                        const price = this.safeNumber(order, 0);
                        const amount = this.safeNumber(order, 1);
                        const orderCount = this.safeInteger(order, 2);
                        result.push([
                            price,
                            amount,
                            orderCount
                        ]);
                    }
                    const descending = side === 'bids';
                    return this.sortBy(result, 0, descending);
                }
                async fetchCurrencies(params = {}) {
                    // [
                    //   {
                    //     name: 'Ether',
                    //     symbol: 'ETH',
                    //     contractAddress: '0x0000000000000000000000000000000000000000',
                    //     assetDecimals: 18,
                    //     exchangeDecimals: 8
                    //   }, ..
                    // ]
                    const response = await this.publicGetAssets(params);
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const name = this.safeString(entry, 'name');
                        const currencyId = this.safeString(entry, 'symbol');
                        const precisionString = this.safeString(entry, 'exchangeDecimals');
                        const code = this.safeCurrencyCode(currencyId);
                        const precision = this.parsePrecision(precisionString);
                        const lot = this.parseNumber(precision);
                        result[code] = {
                            'id': currencyId,
                            'code': code,
                            'info': entry,
                            'type': undefined,
                            'name': name,
                            'active': undefined,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': undefined,
                            'precision': parseInt(precisionString),
                            'limits': {
                                'amount': {
                                    'min': lot,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': lot,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const currencyId = this.safeString(entry, 'asset');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(entry, 'quantity');
                        account['free'] = this.safeString(entry, 'availableForTrade');
                        account['used'] = this.safeString(entry, 'locked');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    this.checkRequiredCredentials();
                    await this.loadMarkets();
                    const nonce1 = this.uuidv1();
                    const request = {
                        'nonce': nonce1,
                        'wallet': this.walletAddress
                    };
                    // [
                    //   {
                    //     asset: 'DIL',
                    //     quantity: '0.00000000',
                    //     availableForTrade: '0.00000000',
                    //     locked: '0.00000000',
                    //     usdValue: null
                    //   }, ...
                    // ]
                    const extendedRequest = this.extend(request, params);
                    if (extendedRequest['wallet'] === undefined) throw new BadRequest(this.id + ' fetchBalance() wallet is undefined, set this.walletAddress or "address" in params');
                    let response = undefined;
                    try {
                        response = await this.privateGetBalances(extendedRequest);
                    } catch (e) {
                        if (e instanceof InvalidAddress) {
                            const walletAddress = extendedRequest['wallet'];
                            await this.associateWallet(walletAddress);
                            response = await this.privateGetBalances(extendedRequest);
                        } else throw e;
                    }
                    return this.parseBalance(response);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    this.checkRequiredCredentials();
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        'nonce': this.uuidv1(),
                        'wallet': this.walletAddress
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market'] = market['id'];
                    }
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    // [
                    //   {
                    //     fillId: '48582d10-b9bb-3c4b-94d3-e67537cf2472',
                    //     price: '0.09905990',
                    //     quantity: '0.40000000',
                    //     quoteQuantity: '0.03962396',
                    //     time: 1598873478762,
                    //     makerSide: 'sell',
                    //     sequence: 5053,
                    //     market: 'DIL-ETH',
                    //     orderId: '7cdc8e90-eb7d-11ea-9e60-4118569f6e63',
                    //     side: 'buy',
                    //     fee: '0.00080000',
                    //     feeAsset: 'DIL',
                    //     gas: '0.00857497',
                    //     liquidity: 'taker',
                    //     txId: '0xeaa02b112c0b8b61bc02fa1776a2b39d6c614e287c1af90df0a2e591da573e65',
                    //     txStatus: 'mined'
                    //   }
                    // ]
                    const extendedRequest = this.extend(request, params);
                    if (extendedRequest['wallet'] === undefined) throw new BadRequest(this.id + ' fetchMyTrades() walletAddress is undefined, set this.walletAddress or "address" in params');
                    let response = undefined;
                    try {
                        response = await this.privateGetFills(extendedRequest);
                    } catch (e) {
                        if (e instanceof InvalidAddress) {
                            const walletAddress = extendedRequest['wallet'];
                            await this.associateWallet(walletAddress);
                            response = await this.privateGetFills(extendedRequest);
                        } else throw e;
                    }
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchOrder(id, symbol, params = {}) {
                    const request = {
                        'orderId': id
                    };
                    return await this.fetchOrdersHelper(symbol, undefined, undefined, this.extend(request, params));
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'closed': false
                    };
                    return await this.fetchOrdersHelper(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'closed': true
                    };
                    return await this.fetchOrdersHelper(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrdersHelper(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'nonce': this.uuidv1(),
                        'wallet': this.walletAddress
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market'] = market['id'];
                    }
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetOrders(this.extend(request, params));
                    // fetchClosedOrders / fetchOpenOrders
                    // [
                    //   {
                    //     "market": "DIL-ETH",
                    //     "orderId": "7cdc8e90-eb7d-11ea-9e60-4118569f6e63",
                    //     "wallet": "0x0AB991497116f7F5532a4c2f4f7B1784488628e1",
                    //     "time": 1598873478650,
                    //     "status": "filled",
                    //     "type": "limit",
                    //     "side": "buy",
                    //     "originalQuantity": "0.40000000",
                    //     "executedQuantity": "0.40000000",
                    //     "cumulativeQuoteQuantity": "0.03962396",
                    //     "avgExecutionPrice": "0.09905990",
                    //     "price": "1.00000000",
                    //     "fills": [
                    //       {
                    //         "fillId": "48582d10-b9bb-3c4b-94d3-e67537cf2472",
                    //         "price": "0.09905990",
                    //         "quantity": "0.40000000",
                    //         "quoteQuantity": "0.03962396",
                    //         "time": 1598873478650,
                    //         "makerSide": "sell",
                    //         "sequence": 5053,
                    //         "fee": "0.00080000",
                    //         "feeAsset": "DIL",
                    //         "gas": "0.00857497",
                    //         "liquidity": "taker",
                    //         "txId": "0xeaa02b112c0b8b61bc02fa1776a2b39d6c614e287c1af90df0a2e591da573e65",
                    //         "txStatus": "mined"
                    //       }
                    //     ]
                    //   }
                    // ]
                    // fetchOrder
                    // { market: 'DIL-ETH',
                    //   orderId: '7cdc8e90-eb7d-11ea-9e60-4118569f6e63',
                    //   wallet: '0x0AB991497116f7F5532a4c2f4f7B1784488628e1',
                    //   time: 1598873478650,
                    //   status: 'filled',
                    //   type: 'limit',
                    //   side: 'buy',
                    //   originalQuantity: '0.40000000',
                    //   executedQuantity: '0.40000000',
                    //   cumulativeQuoteQuantity: '0.03962396',
                    //   avgExecutionPrice: '0.09905990',
                    //   price: '1.00000000',
                    //   fills:
                    //    [ { fillId: '48582d10-b9bb-3c4b-94d3-e67537cf2472',
                    //        price: '0.09905990',
                    //        quantity: '0.40000000',
                    //        quoteQuantity: '0.03962396',
                    //        time: 1598873478650,
                    //        makerSide: 'sell',
                    //        sequence: 5053,
                    //        fee: '0.00080000',
                    //        feeAsset: 'DIL',
                    //        gas: '0.00857497',
                    //        liquidity: 'taker',
                    //        txId: '0xeaa02b112c0b8b61bc02fa1776a2b39d6c614e287c1af90df0a2e591da573e65',
                    //        txStatus: 'mined' } ] }
                    if (Array.isArray(response)) return this.parseOrders(response, market, since, limit);
                    else return this.parseOrder(response, market);
                }
                parseOrderStatus(status) {
                    // https://docs.idex.io/#order-states-amp-lifecycle
                    const statuses = {
                        'active': 'open',
                        'partiallyFilled': 'open',
                        'rejected': 'canceled',
                        'filled': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "market": "DIL-ETH",
                    //         "orderId": "7cdc8e90-eb7d-11ea-9e60-4118569f6e63",
                    //         "wallet": "0x0AB991497116f7F5532a4c2f4f7B1784488628e1",
                    //         "time": 1598873478650,
                    //         "status": "filled",
                    //         "type": "limit",
                    //         "side": "buy",
                    //         "originalQuantity": "0.40000000",
                    //         "executedQuantity": "0.40000000",
                    //         "cumulativeQuoteQuantity": "0.03962396",
                    //         "avgExecutionPrice": "0.09905990",
                    //         "price": "1.00000000",
                    //         "fills": [
                    //             {
                    //             "fillId": "48582d10-b9bb-3c4b-94d3-e67537cf2472",
                    //             "price": "0.09905990",
                    //             "quantity": "0.40000000",
                    //             "quoteQuantity": "0.03962396",
                    //             "time": 1598873478650,
                    //             "makerSide": "sell",
                    //             "sequence": 5053,
                    //             "fee": "0.00080000",
                    //             "feeAsset": "DIL",
                    //             "gas": "0.00857497",
                    //             "liquidity": "taker",
                    //             "txId": "0xeaa02b112c0b8b61bc02fa1776a2b39d6c614e287c1af90df0a2e591da573e65",
                    //             "txStatus": "mined"
                    //             }
                    //         ]
                    //     }
                    //
                    const timestamp = this.safeInteger(order, 'time');
                    const fills = this.safeValue(order, 'fills', []);
                    const id = this.safeString(order, 'orderId');
                    const clientOrderId = this.safeString(order, 'clientOrderId');
                    const marketId = this.safeString(order, 'market');
                    const side = this.safeString(order, 'side');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const type = this.safeString(order, 'type');
                    const amount = this.safeString(order, 'originalQuantity');
                    const filled = this.safeString(order, 'executedQuantity');
                    const average = this.safeString(order, 'avgExecutionPrice');
                    const price = this.safeString(order, 'price');
                    const rawStatus = this.safeString(order, 'status');
                    const timeInForce = this.safeStringUpper(order, 'timeInForce');
                    const status = this.parseOrderStatus(rawStatus);
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'average': average,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': undefined,
                        'trades': fills
                    }, market);
                }
                async associateWallet(walletAddress, params = {}) {
                    const nonce = this.uuidv1();
                    const noPrefix = this.remove0xPrefix(walletAddress);
                    const byteArray = [
                        this.base16ToBinary(nonce),
                        this.base16ToBinary(noPrefix)
                    ];
                    const binary = this.binaryConcatArray(byteArray);
                    const hash = this.hash(binary, 'keccak', 'hex');
                    const signature = this.signMessageString(hash, this.privateKey);
                    // {
                    //   address: '0x0AB991497116f7F5532a4c2f4f7B1784488628e1',
                    //   totalPortfolioValueUsd: '0.00',
                    //   time: 1598468353626
                    // }
                    const request = {
                        'parameters': {
                            'nonce': nonce,
                            'wallet': walletAddress
                        },
                        'signature': signature
                    };
                    const result = await this.privatePostWallets(request);
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    // https://docs.idex.io/#create-order
                    this.checkRequiredCredentials();
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const nonce = this.uuidv1();
                    let typeEnum = undefined;
                    const stopLossTypeEnums = {
                        'stopLoss': 3,
                        'stopLossLimit': 4,
                        'takeProfit': 5,
                        'takeProfitLimit': 6
                    };
                    let stopPriceString = undefined;
                    if (type === 'stopLossLimit' || type === 'takeProfitLimit' || 'stopPrice' in params) {
                        if (!('stopPrice' in params)) throw new BadRequest(this.id + ' createOrder() stopPrice is a required parameter for ' + type + 'orders');
                        stopPriceString = this.priceToPrecision(symbol, params['stopPrice']);
                    }
                    const limitTypeEnums = {
                        'limit': 1,
                        'limitMaker': 2
                    };
                    let priceString = undefined;
                    const typeLower = type.toLowerCase();
                    const limitOrder = typeLower.indexOf('limit') >= 0;
                    if (type in limitTypeEnums) {
                        typeEnum = limitTypeEnums[type];
                        priceString = this.priceToPrecision(symbol, price);
                    } else if (type in stopLossTypeEnums) {
                        typeEnum = stopLossTypeEnums[type];
                        priceString = this.priceToPrecision(symbol, price);
                    } else if (type === 'market') typeEnum = 0;
                    else throw new BadRequest(this.id + ' ' + type + ' is not a valid order type');
                    let amountEnum = 0; // base quantity
                    if ('quoteOrderQuantity' in params) {
                        if (type !== 'market') throw new NotSupported(this.id + ' createOrder() quoteOrderQuantity is not supported for ' + type + ' orders, only supported for market orders');
                        amountEnum = 1;
                        amount = this.safeNumber(params, 'quoteOrderQuantity');
                    }
                    const sideEnum = side === 'buy' ? 0 : 1;
                    const walletBytes = this.remove0xPrefix(this.walletAddress);
                    const network = this.safeString(this.options, 'network', 'ETH');
                    const orderVersion = this.getSupportedMapping(network, {
                        'ETH': 1,
                        'BSC': 2,
                        'MATIC': 4
                    });
                    const amountString = this.amountToPrecision(symbol, amount);
                    // https://docs.idex.io/#time-in-force
                    const timeInForceEnums = {
                        'gtc': 0,
                        'ioc': 2,
                        'fok': 3
                    };
                    const defaultTimeInForce = this.safeString(this.options, 'defaultTimeInForce', 'gtc');
                    const timeInForce = this.safeString(params, 'timeInForce', defaultTimeInForce);
                    let timeInForceEnum = undefined;
                    if (timeInForce in timeInForceEnums) timeInForceEnum = timeInForceEnums[timeInForce];
                    else {
                        const allOptions = Object.keys(timeInForceEnums);
                        const asString = allOptions.join(', ');
                        throw new BadRequest(this.id + ' ' + timeInForce + ' is not a valid timeInForce, please choose one of ' + asString);
                    }
                    // https://docs.idex.io/#self-trade-prevention
                    const selfTradePreventionEnums = {
                        'dc': 0,
                        'co': 1,
                        'cn': 2,
                        'cb': 3
                    };
                    const defaultSelfTradePrevention = this.safeString(this.options, 'defaultSelfTradePrevention', 'cn');
                    const selfTradePrevention = this.safeString(params, 'selfTradePrevention', defaultSelfTradePrevention);
                    let selfTradePreventionEnum = undefined;
                    if (selfTradePrevention in selfTradePreventionEnums) selfTradePreventionEnum = selfTradePreventionEnums[selfTradePrevention];
                    else {
                        const allOptions = Object.keys(selfTradePreventionEnums);
                        const asString = allOptions.join(', ');
                        throw new BadRequest(this.id + ' ' + selfTradePrevention + ' is not a valid selfTradePrevention, please choose one of ' + asString);
                    }
                    const byteArray = [
                        this.numberToBE(orderVersion, 1),
                        this.base16ToBinary(nonce),
                        this.base16ToBinary(walletBytes),
                        this.stringToBinary(this.encode(market['id'])),
                        this.numberToBE(typeEnum, 1),
                        this.numberToBE(sideEnum, 1),
                        this.stringToBinary(this.encode(amountString)),
                        this.numberToBE(amountEnum, 1)
                    ];
                    if (limitOrder) {
                        const encodedPrice = this.stringToBinary(this.encode(priceString));
                        byteArray.push(encodedPrice);
                    }
                    if (type in stopLossTypeEnums) {
                        const encodedPrice = this.stringToBinary(this.encode(stopPriceString || priceString));
                        byteArray.push(encodedPrice);
                    }
                    const clientOrderId = this.safeString(params, 'clientOrderId');
                    if (clientOrderId !== undefined) byteArray.push(this.stringToBinary(this.encode(clientOrderId)));
                    const after = [
                        this.numberToBE(timeInForceEnum, 1),
                        this.numberToBE(selfTradePreventionEnum, 1),
                        this.numberToBE(0, 8)
                    ];
                    const allBytes = this.arrayConcat(byteArray, after);
                    const binary = this.binaryConcatArray(allBytes);
                    const hash = this.hash(binary, 'keccak', 'hex');
                    const signature = this.signMessageString(hash, this.privateKey);
                    const request = {
                        'parameters': {
                            'nonce': nonce,
                            'market': market['id'],
                            'side': side,
                            'type': type,
                            'wallet': this.walletAddress,
                            'selfTradePrevention': selfTradePrevention
                        },
                        'signature': signature
                    };
                    if (type !== 'market') request['parameters']['timeInForce'] = timeInForce;
                    if (limitOrder) request['parameters']['price'] = priceString;
                    if (type in stopLossTypeEnums) request['parameters']['stopPrice'] = stopPriceString || priceString;
                    if (amountEnum === 0) request['parameters']['quantity'] = amountString;
                    else request['parameters']['quoteOrderQuantity'] = amountString;
                    if (clientOrderId !== undefined) request['parameters']['clientOrderId'] = clientOrderId;
                    // {
                    //   market: 'DIL-ETH',
                    //   orderId: '7cdc8e90-eb7d-11ea-9e60-4118569f6e63',
                    //   wallet: '0x0AB991497116f7F5532a4c2f4f7B1784488628e1',
                    //   time: 1598873478650,
                    //   status: 'filled',
                    //   type: 'limit',
                    //   side: 'buy',
                    //   originalQuantity: '0.40000000',
                    //   executedQuantity: '0.40000000',
                    //   cumulativeQuoteQuantity: '0.03962396',
                    //   price: '1.00000000',
                    //   fills: [
                    //     {
                    //       fillId: '48582d10-b9bb-3c4b-94d3-e67537cf2472',
                    //       price: '0.09905990',
                    //       quantity: '0.40000000',
                    //       quoteQuantity: '0.03962396',
                    //       time: 1598873478650,
                    //       makerSide: 'sell',
                    //       sequence: 5053,
                    //       fee: '0.00080000',
                    //       feeAsset: 'DIL',
                    //       gas: '0.00857497',
                    //       liquidity: 'taker',
                    //       txStatus: 'pending'
                    //     }
                    //   ],
                    //   avgExecutionPrice: '0.09905990'
                    // }
                    // we don't use extend here because it is a signed endpoint
                    const response = await this.privatePostOrders(request);
                    return this.parseOrder(response, market);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkRequiredCredentials();
                    await this.loadMarkets();
                    const nonce = this.uuidv1();
                    const amountString = this.currencyToPrecision(code, amount);
                    const currency = this.currency(code);
                    const walletBytes = this.remove0xPrefix(this.walletAddress);
                    const byteArray = [
                        this.base16ToBinary(nonce),
                        this.base16ToBinary(walletBytes),
                        this.stringToBinary(this.encode(currency['id'])),
                        this.stringToBinary(this.encode(amountString)),
                        this.numberToBE(1, 1)
                    ];
                    const binary = this.binaryConcatArray(byteArray);
                    const hash = this.hash(binary, 'keccak', 'hex');
                    const signature = this.signMessageString(hash, this.privateKey);
                    const request = {
                        'parameters': {
                            'nonce': nonce,
                            'wallet': address,
                            'asset': currency['id'],
                            'quantity': amountString
                        },
                        'signature': signature
                    };
                    const response = await this.privatePostWithdrawals(request);
                    //
                    //     {
                    //         withdrawalId: 'a61dcff0-ec4d-11ea-8b83-c78a6ecb3180',
                    //         asset: 'ETH',
                    //         assetContractAddress: '0x0000000000000000000000000000000000000000',
                    //         quantity: '0.20000000',
                    //         time: 1598962883190,
                    //         fee: '0.00024000',
                    //         txStatus: 'pending',
                    //         txId: null
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                async cancelOrder(id, symbol, params = {}) {
                    this.checkRequiredCredentials();
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const nonce = this.uuidv1();
                    const walletBytes = this.remove0xPrefix(this.walletAddress);
                    const byteArray = [
                        this.base16ToBinary(nonce),
                        this.base16ToBinary(walletBytes),
                        this.stringToBinary(this.encode(id))
                    ];
                    const binary = this.binaryConcatArray(byteArray);
                    const hash = this.hash(binary, 'keccak', 'hex');
                    const signature = this.signMessageString(hash, this.privateKey);
                    const request = {
                        'parameters': {
                            'nonce': nonce,
                            'wallet': this.walletAddress,
                            'orderId': id
                        },
                        'signature': signature
                    };
                    // [ { orderId: '688336f0-ec50-11ea-9842-b332f8a34d0e' } ]
                    const response = await this.privateDeleteOrders(this.extend(request, params));
                    const canceledOrder = this.safeValue(response, 0);
                    return this.parseOrder(canceledOrder, market);
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    const errorCode = this.safeString(response, 'code');
                    const message = this.safeString(response, 'message');
                    if (errorCode in this.exceptions) {
                        const Exception1 = this.exceptions[errorCode];
                        throw new Exception1(this.id + ' ' + message);
                    }
                    if (errorCode !== undefined) throw new ExchangeError1(this.id + ' ' + message);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    params = this.extend({
                        'method': 'privateGetDeposits'
                    }, params);
                    return this.fetchTransactionsHelper(code, since, limit, params);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    params = this.extend({
                        'method': 'privateGetWithdrawals'
                    }, params);
                    return this.fetchTransactionsHelper(code, since, limit, params);
                }
                async fetchTransactionsHelper(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const nonce = this.uuidv1();
                    const request = {
                        'nonce': nonce,
                        'wallet': this.walletAddress
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['asset'] = currency['id'];
                    }
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    // [
                    //   {
                    //     depositId: 'e9970cc0-eb6b-11ea-9e89-09a5ebc1f98e',
                    //     asset: 'ETH',
                    //     quantity: '1.00000000',
                    //     txId: '0xcd4aac3171d7131cc9e795568c67938675185ac17641553ef54c8a7c294c8142',
                    //     txTime: 1598865853000,
                    //     confirmationTime: 1598865930231
                    //   }
                    // ]
                    const method = params['method'];
                    params = this.omit(params, 'method');
                    const response = await this[method](this.extend(request, params));
                    return this.parseTransactions(response, currency, since, limit);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'mined': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         depositId: 'e9970cc0-eb6b-11ea-9e89-09a5ebc1f98f',
                    //         asset: 'ETH',
                    //         quantity: '1.00000000',
                    //         txId: '0xcd4aac3171d7131cc9e795568c67938675185ac17641553ef54c8a7c294c8142',
                    //         txTime: 1598865853000,
                    //         confirmationTime: 1598865930231
                    //     }
                    //
                    // fetchWithdrwalas
                    //
                    //     {
                    //         withdrawalId: 'a62d8760-ec4d-11ea-9fa6-47904c19499b',
                    //         asset: 'ETH',
                    //         assetContractAddress: '0x0000000000000000000000000000000000000000',
                    //         quantity: '0.20000000',
                    //         time: 1598962883288,
                    //         fee: '0.00024000',
                    //         txId: '0x305e9cdbaa85ad029f50578d13d31d777c085de573ed5334d95c19116d8c03ce',
                    //         txStatus: 'mined'
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         withdrawalId: 'a61dcff0-ec4d-11ea-8b83-c78a6ecb3180',
                    //         asset: 'ETH',
                    //         assetContractAddress: '0x0000000000000000000000000000000000000000',
                    //         quantity: '0.20000000',
                    //         time: 1598962883190,
                    //         fee: '0.00024000',
                    //         txStatus: 'pending',
                    //         txId: null
                    //     }
                    //
                    let type = undefined;
                    if ('depositId' in transaction) type = 'deposit';
                    else if ('withdrawId' in transaction || 'withdrawalId' in transaction) type = 'withdrawal';
                    let id = this.safeString2(transaction, 'depositId', 'withdrawId');
                    id = this.safeString(transaction, 'withdrawalId', id);
                    const code = this.safeCurrencyCode(this.safeString(transaction, 'asset'), currency);
                    const amount = this.safeNumber(transaction, 'quantity');
                    const txid = this.safeString(transaction, 'txId');
                    const timestamp = this.safeInteger(transaction, 'txTime');
                    let fee = undefined;
                    if ('fee' in transaction) fee = {
                        'cost': this.safeNumber(transaction, 'fee'),
                        'currency': 'ETH'
                    };
                    const rawStatus = this.safeString(transaction, 'txStatus');
                    const status = this.parseTransactionStatus(rawStatus);
                    const updated = this.safeInteger(transaction, 'confirmationTime');
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                calculateRateLimiterCost(api, method, path, params, config = {}, context = {}) {
                    const hasApiKey = this.apiKey !== undefined;
                    const hasSecret = this.secret !== undefined;
                    const hasWalletAddress = this.walletAddress !== undefined;
                    const hasPrivateKey = this.privateKey !== undefined;
                    const defaultCost = this.safeValue(config, 'cost', 1);
                    const authenticated = hasApiKey && hasSecret && hasWalletAddress && hasPrivateKey;
                    return authenticated ? defaultCost / 2 : defaultCost;
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const network = this.safeString(this.options, 'network', 'ETH');
                    const version = this.safeString(this.options, 'version', 'v1');
                    let url = this.urls['api'][network] + '/' + version + '/' + path;
                    const keys = Object.keys(params);
                    const length = keys.length;
                    let query = undefined;
                    if (length > 0) {
                        if (method === 'GET') {
                            query = this.urlencode(params);
                            url = url + '?' + query;
                        } else body = this.json(params);
                    }
                    headers = {
                        'Content-Type': 'application/json'
                    };
                    if (this.apiKey !== undefined) headers['IDEX-API-Key'] = this.apiKey;
                    if (api === 'private') {
                        let payload = undefined;
                        if (method === 'GET') payload = query;
                        else payload = body;
                        headers['IDEX-HMAC-Signature'] = this.hmac(this.encode(payload), this.encode(this.secret), 'sha256', 'hex');
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    92: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class independentreserve extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'independentreserve',
                        'name': 'Independent Reserve',
                        'countries': [
                            'AU',
                            'NZ'
                        ],
                        'rateLimit': 1000,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87182090-1e9e9080-c2ec-11ea-8e49-563db9a38f37.jpg',
                            'api': {
                                'public': 'https://api.independentreserve.com/Public',
                                'private': 'https://api.independentreserve.com/Private'
                            },
                            'www': 'https://www.independentreserve.com',
                            'doc': 'https://www.independentreserve.com/API'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'GetValidPrimaryCurrencyCodes',
                                    'GetValidSecondaryCurrencyCodes',
                                    'GetValidLimitOrderTypes',
                                    'GetValidMarketOrderTypes',
                                    'GetValidOrderTypes',
                                    'GetValidTransactionTypes',
                                    'GetMarketSummary',
                                    'GetOrderBook',
                                    'GetAllOrders',
                                    'GetTradeHistorySummary',
                                    'GetRecentTrades',
                                    'GetFxRates',
                                    'GetOrderMinimumVolumes',
                                    'GetCryptoWithdrawalFees'
                                ]
                            },
                            'private': {
                                'post': [
                                    'GetOpenOrders',
                                    'GetClosedOrders',
                                    'GetClosedFilledOrders',
                                    'GetOrderDetails',
                                    'GetAccounts',
                                    'GetTransactions',
                                    'GetFiatBankAccounts',
                                    'GetDigitalCurrencyDepositAddress',
                                    'GetDigitalCurrencyDepositAddresses',
                                    'GetTrades',
                                    'GetBrokerageFees',
                                    'GetDigitalCurrencyWithdrawal',
                                    'PlaceLimitOrder',
                                    'PlaceMarketOrder',
                                    'CancelOrder',
                                    'SynchDigitalCurrencyDepositAddressWithBlockchain',
                                    'RequestFiatWithdrawal',
                                    'WithdrawFiatCurrency',
                                    'WithdrawDigitalCurrency'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'taker': 0.005,
                                'maker': 0.005,
                                'percentage': true,
                                'tierBased': false
                            }
                        },
                        'commonCurrencies': {
                            'PLA': 'PlayChip'
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const baseCurrencies = await this.publicGetGetValidPrimaryCurrencyCodes(params);
                    const quoteCurrencies = await this.publicGetGetValidSecondaryCurrencyCodes(params);
                    const limits = await this.publicGetGetOrderMinimumVolumes(params);
                    //
                    //     {
                    //         "Xbt": 0.0001,
                    //         "Bch": 0.001,
                    //         "Bsv": 0.001,
                    //         "Eth": 0.001,
                    //         "Ltc": 0.01,
                    //         "Xrp": 1,
                    //     }
                    //
                    const result = [];
                    for(let i = 0; i < baseCurrencies.length; i++){
                        const baseId = baseCurrencies[i];
                        const base = this.safeCurrencyCode(baseId);
                        const minAmount = this.safeNumber(limits, baseId);
                        for(let j = 0; j < quoteCurrencies.length; j++){
                            const quoteId = quoteCurrencies[j];
                            const quote = this.safeCurrencyCode(quoteId);
                            const id = baseId + '/' + quoteId;
                            result.push({
                                'id': id,
                                'symbol': base + '/' + quote,
                                'base': base,
                                'quote': quote,
                                'settle': undefined,
                                'baseId': baseId,
                                'quoteId': quoteId,
                                'settleId': undefined,
                                'type': 'spot',
                                'spot': true,
                                'margin': false,
                                'swap': false,
                                'future': false,
                                'option': false,
                                'active': undefined,
                                'contract': false,
                                'linear': undefined,
                                'inverse': undefined,
                                'contractSize': undefined,
                                'expiry': undefined,
                                'expiryDatetime': undefined,
                                'strike': undefined,
                                'optionType': undefined,
                                'precision': this.precision,
                                'limits': {
                                    'leverage': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'amount': {
                                        'min': minAmount,
                                        'max': undefined
                                    },
                                    'price': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'cost': {
                                        'min': undefined,
                                        'max': undefined
                                    }
                                },
                                'info': id
                            });
                        }
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'CurrencyCode');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'AvailableBalance');
                        account['total'] = this.safeString(balance, 'TotalBalance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGetAccounts(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'primaryCurrencyCode': market['baseId'],
                        'secondaryCurrencyCode': market['quoteId']
                    };
                    const response = await this.publicGetGetOrderBook(this.extend(request, params));
                    const timestamp = this.parse8601(this.safeString(response, 'CreatedTimestampUtc'));
                    return this.parseOrderBook(response, symbol, timestamp, 'BuyOrders', 'SellOrders', 'Price', 'Volume');
                }
                parseTicker(ticker, market) {
                    // {
                    //     "DayHighestPrice":43489.49,
                    //     "DayLowestPrice":41998.32,
                    //     "DayAvgPrice":42743.9,
                    //     "DayVolumeXbt":44.54515625000,
                    //     "DayVolumeXbtInSecondaryCurrrency":0.12209818,
                    //     "CurrentLowestOfferPrice":43619.64,
                    //     "CurrentHighestBidPrice":43153.58,
                    //     "LastPrice":43378.43,
                    //     "PrimaryCurrencyCode":"Xbt",
                    //     "SecondaryCurrencyCode":"Usd",
                    //     "CreatedTimestampUtc":"2022-01-14T22:52:29.5029223Z"
                    // }
                    const timestamp = this.parse8601(this.safeString(ticker, 'CreatedTimestampUtc'));
                    const baseId = this.safeString(ticker, 'PrimaryCurrencyCode');
                    const quoteId = this.safeString(ticker, 'SecondaryCurrencyCode');
                    let defaultMarketId = undefined;
                    if (baseId !== undefined && quoteId !== undefined) defaultMarketId = baseId + '/' + quoteId;
                    market = this.safeMarket(defaultMarketId, market, '/');
                    const symbol = market['symbol'];
                    const last = this.safeString(ticker, 'LastPrice');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'DayHighestPrice'),
                        'low': this.safeString(ticker, 'DayLowestPrice'),
                        'bid': this.safeString(ticker, 'CurrentHighestBidPrice'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'CurrentLowestOfferPrice'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': this.safeString(ticker, 'DayAvgPrice'),
                        'baseVolume': this.safeString(ticker, 'DayVolumeXbtInSecondaryCurrrency'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'primaryCurrencyCode': market['baseId'],
                        'secondaryCurrencyCode': market['quoteId']
                    };
                    const response = await this.publicGetGetMarketSummary(this.extend(request, params));
                    // {
                    //     "DayHighestPrice":43489.49,
                    //     "DayLowestPrice":41998.32,
                    //     "DayAvgPrice":42743.9,
                    //     "DayVolumeXbt":44.54515625000,
                    //     "DayVolumeXbtInSecondaryCurrrency":0.12209818,
                    //     "CurrentLowestOfferPrice":43619.64,
                    //     "CurrentHighestBidPrice":43153.58,
                    //     "LastPrice":43378.43,
                    //     "PrimaryCurrencyCode":"Xbt",
                    //     "SecondaryCurrencyCode":"Usd",
                    //     "CreatedTimestampUtc":"2022-01-14T22:52:29.5029223Z"
                    // }
                    return this.parseTicker(response, market);
                }
                parseOrder(order, market) {
                    //
                    // fetchOrder
                    //
                    //     {
                    //         "OrderGuid": "c7347e4c-b865-4c94-8f74-d934d4b0b177",
                    //         "CreatedTimestampUtc": "2014-09-23T12:39:34.3817763Z",
                    //         "Type": "MarketBid",
                    //         "VolumeOrdered": 5.0,
                    //         "VolumeFilled": 5.0,
                    //         "Price": null,
                    //         "AvgPrice": 100.0,
                    //         "ReservedAmount": 0.0,
                    //         "Status": "Filled",
                    //         "PrimaryCurrencyCode": "Xbt",
                    //         "SecondaryCurrencyCode": "Usd"
                    //     }
                    //
                    // fetchOpenOrders & fetchClosedOrders
                    //
                    //     {
                    //         "OrderGuid": "b8f7ad89-e4e4-4dfe-9ea3-514d38b5edb3",
                    //         "CreatedTimestampUtc": "2020-09-08T03:04:18.616367Z",
                    //         "OrderType": "LimitOffer",
                    //         "Volume": 0.0005,
                    //         "Outstanding": 0.0005,
                    //         "Price": 113885.83,
                    //         "AvgPrice": 113885.83,
                    //         "Value": 56.94,
                    //         "Status": "Open",
                    //         "PrimaryCurrencyCode": "Xbt",
                    //         "SecondaryCurrencyCode": "Usd",
                    //         "FeePercent": 0.005,
                    //     }
                    //
                    let symbol = undefined;
                    const baseId = this.safeString(order, 'PrimaryCurrencyCode');
                    const quoteId = this.safeString(order, 'SecondaryCurrencyCode');
                    let base = undefined;
                    let quote = undefined;
                    if (baseId !== undefined && quoteId !== undefined) {
                        base = this.safeCurrencyCode(baseId);
                        quote = this.safeCurrencyCode(quoteId);
                        symbol = base + '/' + quote;
                    } else if (market !== undefined) {
                        symbol = market['symbol'];
                        base = market['base'];
                        quote = market['quote'];
                    }
                    let orderType = this.safeString2(order, 'Type', 'OrderType');
                    let side = undefined;
                    if (orderType.indexOf('Bid') >= 0) side = 'buy';
                    else if (orderType.indexOf('Offer') >= 0) side = 'sell';
                    if (orderType.indexOf('Market') >= 0) orderType = 'market';
                    else if (orderType.indexOf('Limit') >= 0) orderType = 'limit';
                    const timestamp = this.parse8601(this.safeString(order, 'CreatedTimestampUtc'));
                    const amount = this.safeString2(order, 'VolumeOrdered', 'Volume');
                    const filled = this.safeString(order, 'VolumeFilled');
                    const remaining = this.safeString(order, 'Outstanding');
                    const feeRate = this.safeNumber(order, 'FeePercent');
                    let feeCost = undefined;
                    if (feeRate !== undefined && filled !== undefined) feeCost = feeRate * filled;
                    const fee = {
                        'rate': feeRate,
                        'cost': feeCost,
                        'currency': base
                    };
                    const id = this.safeString(order, 'OrderGuid');
                    const status = this.parseOrderStatus(this.safeString(order, 'Status'));
                    const cost = this.safeString(order, 'Value');
                    const average = this.safeString(order, 'AvgPrice');
                    const price = this.safeString(order, 'Price');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': orderType,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': cost,
                        'average': average,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'Open': 'open',
                        'PartiallyFilled': 'open',
                        'Filled': 'closed',
                        'PartiallyFilledAndCancelled': 'canceled',
                        'Cancelled': 'canceled',
                        'PartiallyFilledAndExpired': 'canceled',
                        'Expired': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGetOrderDetails(this.extend({
                        'orderGuid': id
                    }, params));
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    return this.parseOrder(response, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = this.ordered({});
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['primaryCurrencyCode'] = market['baseId'];
                        request['secondaryCurrencyCode'] = market['quoteId'];
                    }
                    if (limit === undefined) limit = 50;
                    request['pageIndex'] = 1;
                    request['pageSize'] = limit;
                    const response = await this.privatePostGetOpenOrders(this.extend(request, params));
                    const data = this.safeValue(response, 'Data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = this.ordered({});
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['primaryCurrencyCode'] = market['baseId'];
                        request['secondaryCurrencyCode'] = market['quoteId'];
                    }
                    if (limit === undefined) limit = 50;
                    request['pageIndex'] = 1;
                    request['pageSize'] = limit;
                    const response = await this.privatePostGetClosedOrders(this.extend(request, params));
                    const data = this.safeValue(response, 'Data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit = 50, params = {}) {
                    await this.loadMarkets();
                    const pageIndex = this.safeInteger(params, 'pageIndex', 1);
                    if (limit === undefined) limit = 50;
                    const request = this.ordered({
                        'pageIndex': pageIndex,
                        'pageSize': limit
                    });
                    const response = await this.privatePostGetTrades(this.extend(request, params));
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    return this.parseTrades(response['Data'], market, since, limit);
                }
                parseTrade(trade, market) {
                    const timestamp = this.parse8601(trade['TradeTimestampUtc']);
                    const id = this.safeString(trade, 'TradeGuid');
                    const orderId = this.safeString(trade, 'OrderGuid');
                    const priceString = this.safeString2(trade, 'Price', 'SecondaryCurrencyTradePrice');
                    const amountString = this.safeString2(trade, 'VolumeTraded', 'PrimaryCurrencyAmount');
                    const price = this.parseNumber(priceString);
                    const amount = this.parseNumber(amountString);
                    const cost = this.parseNumber(Precise.stringMul(priceString, amountString));
                    const baseId = this.safeString(trade, 'PrimaryCurrencyCode');
                    const quoteId = this.safeString(trade, 'SecondaryCurrencyCode');
                    let marketId = undefined;
                    if (baseId !== undefined && quoteId !== undefined) marketId = baseId + '/' + quoteId;
                    const symbol = this.safeSymbol(marketId, market, '/');
                    let side = this.safeString(trade, 'OrderType');
                    if (side !== undefined) {
                        if (side.indexOf('Bid') >= 0) side = 'buy';
                        else if (side.indexOf('Offer') >= 0) side = 'sell';
                    }
                    return {
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': undefined
                    };
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'primaryCurrencyCode': market['baseId'],
                        'secondaryCurrencyCode': market['quoteId'],
                        'numberOfRecentTradesToRetrieve': 50
                    };
                    const response = await this.publicGetGetRecentTrades(this.extend(request, params));
                    return this.parseTrades(response['Trades'], market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGetBrokerageFees(params);
                    //
                    //     [
                    //         {
                    //             "CurrencyCode": "Xbt",
                    //             "Fee": 0.005
                    //         }
                    //         ...
                    //     ]
                    //
                    const fees = {};
                    for(let i = 0; i < response.length; i++){
                        const fee = response[i];
                        const currencyId = this.safeString(fee, 'CurrencyCode');
                        const code = this.safeCurrencyCode(currencyId);
                        const tradingFee = this.safeNumber(fee, 'Fee');
                        fees[code] = {
                            'info': fee,
                            'fee': tradingFee
                        };
                    }
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        const fee = this.safeValue(fees, market['base'], {});
                        result[symbol] = {
                            'info': this.safeValue(fee, 'info'),
                            'symbol': symbol,
                            'maker': this.safeNumber(fee, 'fee'),
                            'taker': this.safeNumber(fee, 'fee'),
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const capitalizedOrderType = this.capitalize(type);
                    const method = 'privatePostPlace' + capitalizedOrderType + 'Order';
                    let orderType = capitalizedOrderType;
                    orderType += side === 'sell' ? 'Offer' : 'Bid';
                    const request = this.ordered({
                        'primaryCurrencyCode': market['baseId'],
                        'secondaryCurrencyCode': market['quoteId'],
                        'orderType': orderType
                    });
                    if (type === 'limit') request['price'] = price;
                    request['volume'] = amount;
                    const response = await this[method](this.extend(request, params));
                    return {
                        'info': response,
                        'id': response['OrderGuid']
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderGuid': id
                    };
                    return await this.privatePostCancelOrder(this.extend(request, params));
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/' + path;
                    if (api === 'public') {
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce();
                        const auth = [
                            url,
                            'apiKey=' + this.apiKey,
                            'nonce=' + nonce.toString()
                        ];
                        const keys = Object.keys(params);
                        for(let i = 0; i < keys.length; i++){
                            const key = keys[i];
                            const value = params[key].toString();
                            auth.push(key + '=' + value);
                        }
                        const message = auth.join(',');
                        const signature = this.hmac(this.encode(message), this.encode(this.secret));
                        const query = this.ordered({});
                        query['apiKey'] = this.apiKey;
                        query['nonce'] = nonce;
                        query['signature'] = signature.toUpperCase();
                        for(let i = 0; i < keys.length; i++){
                            const key = keys[i];
                            query[key] = params[key];
                        }
                        body = this.json(query);
                        headers = {
                            'Content-Type': 'application/json'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6
        }
    ],
    93: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, AuthenticationError: AuthenticationError, BadSymbol: BadSymbol } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class indodax extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'indodax',
                        'name': 'INDODAX',
                        'countries': [
                            'ID'
                        ],
                        // 10 requests per second for making trades => 1000ms / 10 = 100ms
                        // 180 requests per minute (public endpoints) = 2 requests per second => cost = (1000ms / rateLimit) / 2 = 5
                        'rateLimit': 100,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': undefined,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': undefined,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': undefined,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': true
                        },
                        'version': '2.0',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87070508-9358c880-c221-11ea-8dc5-5391afbbb422.jpg',
                            'api': {
                                'public': 'https://indodax.com/api',
                                'private': 'https://indodax.com/tapi'
                            },
                            'www': 'https://www.indodax.com',
                            'doc': 'https://github.com/btcid/indodax-official-api-docs',
                            'referral': 'https://indodax.com/ref/testbitcoincoid/1'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'server_time': 5,
                                    'pairs': 5,
                                    'price_increments': 5,
                                    'summaries': 5,
                                    'ticker_all': 5,
                                    '{pair}/ticker': 5,
                                    '{pair}/trades': 5,
                                    '{pair}/depth': 5
                                }
                            },
                            'private': {
                                'post': {
                                    'getInfo': 4,
                                    'transHistory': 4,
                                    'trade': 1,
                                    'tradeHistory': 4,
                                    'openOrders': 4,
                                    'orderHistory': 4,
                                    'getOrder': 4,
                                    'cancelOrder': 4,
                                    'withdrawFee': 4,
                                    'withdrawCoin': 4,
                                    'listDownline': 4,
                                    'checkDownline': 4,
                                    'createVoucher': 4
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': 0,
                                'taker': 0.003
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'invalid_pair': BadSymbol,
                                'Insufficient balance.': InsufficientFunds,
                                'invalid order.': OrderNotFound,
                                'Invalid credentials. API not found or session has expired.': AuthenticationError,
                                'Invalid credentials. Bad sign.': AuthenticationError
                            },
                            'broad': {
                                'Minimum price': InvalidOrder,
                                'Minimum order': InvalidOrder
                            }
                        },
                        // exchange-specific options
                        'options': {
                            'recvWindow': 5000,
                            'timeDifference': 0,
                            'adjustForTimeDifference': false
                        },
                        'commonCurrencies': {
                            'STR': 'XLM',
                            'BCHABC': 'BCH',
                            'BCHSV': 'BSV',
                            'DRK': 'DASH',
                            'NEM': 'XEM'
                        }
                    });
                }
                nonce() {
                    return this.milliseconds() - this.options['timeDifference'];
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetServerTime(params);
                    //
                    //     {
                    //         "timezone": "UTC",
                    //         "server_time": 1571205969552
                    //     }
                    //
                    return this.safeInteger(response, 'server_time');
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetPairs(params);
                    //
                    //     [
                    //         {
                    //             "id": "btcidr",
                    //             "symbol": "BTCIDR",
                    //             "base_currency": "idr",
                    //             "traded_currency": "btc",
                    //             "traded_currency_unit": "BTC",
                    //             "description": "BTC/IDR",
                    //             "ticker_id": "btc_idr",
                    //             "volume_precision": 0,
                    //             "price_precision": 1000,
                    //             "price_round": 8,
                    //             "pricescale": 1000,
                    //             "trade_min_base_currency": 10000,
                    //             "trade_min_traded_currency": 0.00007457,
                    //             "has_memo": false,
                    //             "memo_name": false,
                    //             "has_payment_id": false,
                    //             "trade_fee_percent": 0.3,
                    //             "url_logo": "https://indodax.com/v2/logo/svg/color/btc.svg",
                    //             "url_logo_png": "https://indodax.com/v2/logo/png/color/btc.png",
                    //             "is_maintenance": 0
                    //         }
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'ticker_id');
                        const baseId = this.safeString(market, 'traded_currency');
                        const quoteId = this.safeString(market, 'base_currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const isMaintenance = this.safeInteger(market, 'is_maintenance');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': isMaintenance ? false : true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.safeNumber(market, 'trade_fee_percent'),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'percentage': true,
                            'precision': {
                                'amount': parseInt('8'),
                                'price': this.safeInteger(market, 'price_round')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'trade_min_traded_currency'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'trade_min_base_currency'),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'return', {});
                    const free = this.safeValue(balances, 'balance', {});
                    const used = this.safeValue(balances, 'balance_hold', {});
                    const timestamp = this.safeTimestamp(balances, 'server_time');
                    const result = {
                        'info': response,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    };
                    const currencyIds = Object.keys(free);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(free, currencyId);
                        account['used'] = this.safeString(used, currencyId);
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGetInfo(params);
                    //
                    //     {
                    //         "success":1,
                    //         "return":{
                    //             "server_time":1619562628,
                    //             "balance":{
                    //                 "idr":167,
                    //                 "btc":"0.00000000",
                    //                 "1inch":"0.00000000",
                    //             },
                    //             "balance_hold":{
                    //                 "idr":0,
                    //                 "btc":"0.00000000",
                    //                 "1inch":"0.00000000",
                    //             },
                    //             "address":{
                    //                 "btc":"1KMntgzvU7iTSgMBWc11nVuJjAyfW3qJyk",
                    //                 "1inch":"0x1106c8bb3172625e1f411c221be49161dac19355",
                    //                 "xrp":"rwWr7KUZ3ZFwzgaDGjKBysADByzxvohQ3C",
                    //                 "zrx":"0x1106c8bb3172625e1f411c221be49161dac19355"
                    //             },
                    //             "user_id":"276011",
                    //             "name":"",
                    //             "email":"testbitcoincoid@mailforspam.com",
                    //             "profile_picture":null,
                    //             "verification_status":"unverified",
                    //             "gauth_enable":true
                    //         }
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'pair': this.marketId(symbol)
                    };
                    const orderbook = await this.publicGetPairDepth(this.extend(request, params));
                    return this.parseOrderBook(orderbook, symbol, undefined, 'buy', 'sell');
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "high":"0.01951",
                    //         "low":"0.01877",
                    //         "vol_eth":"39.38839319",
                    //         "vol_btc":"0.75320886",
                    //         "last":"0.01896",
                    //         "buy":"0.01896",
                    //         "sell":"0.019",
                    //         "server_time":1565248908
                    //     }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.safeTimestamp(ticker, 'server_time');
                    const baseVolume = 'vol_' + market['baseId'].toLowerCase();
                    const quoteVolume = 'vol_' + market['quoteId'].toLowerCase();
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, baseVolume),
                        'quoteVolume': this.safeString(ticker, quoteVolume),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetPairTicker(this.extend(request, params));
                    //
                    //     {
                    //         "ticker": {
                    //             "high":"0.01951",
                    //             "low":"0.01877",
                    //             "vol_eth":"39.38839319",
                    //             "vol_btc":"0.75320886",
                    //             "last":"0.01896",
                    //             "buy":"0.01896",
                    //             "sell":"0.019",
                    //             "server_time":1565248908
                    //         }
                    //     }
                    //
                    const ticker = this.safeValue(response, 'ticker', {});
                    return this.parseTicker(ticker, market);
                }
                parseTrade(trade, market) {
                    const timestamp = this.safeTimestamp(trade, 'date');
                    return this.safeTrade({
                        'id': this.safeString(trade, 'tid'),
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': this.safeSymbol(undefined, market),
                        'type': undefined,
                        'side': this.safeString(trade, 'type'),
                        'order': undefined,
                        'takerOrMaker': undefined,
                        'price': this.safeString(trade, 'price'),
                        'amount': this.safeString(trade, 'amount'),
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetPairTrades(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'open': 'open',
                        'filled': 'closed',
                        'cancelled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "order_id": "12345",
                    //         "submit_time": "1392228122",
                    //         "price": "8000000",
                    //         "type": "sell",
                    //         "order_ltc": "100000000",
                    //         "remain_ltc": "100000000"
                    //     }
                    //
                    // market closed orders - note that the price is very high
                    // and does not reflect actual price the order executed at
                    //
                    //     {
                    //       "order_id": "49326856",
                    //       "type": "sell",
                    //       "price": "1000000000",
                    //       "submit_time": "1618314671",
                    //       "finish_time": "1618314671",
                    //       "status": "filled",
                    //       "order_xrp": "30.45000000",
                    //       "remain_xrp": "0.00000000"
                    //     }
                    let side = undefined;
                    if ('type' in order) side = order['type'];
                    const status = this.parseOrderStatus(this.safeString(order, 'status', 'open'));
                    let symbol = undefined;
                    let cost = undefined;
                    const price = this.safeString(order, 'price');
                    let amount = undefined;
                    let remaining = undefined;
                    if (market !== undefined) {
                        symbol = market['symbol'];
                        let quoteId = market['quoteId'];
                        let baseId = market['baseId'];
                        if (market['quoteId'] === 'idr' && 'order_rp' in order) quoteId = 'rp';
                        if (market['baseId'] === 'idr' && 'remain_rp' in order) baseId = 'rp';
                        cost = this.safeString(order, 'order_' + quoteId);
                        if (!cost) {
                            amount = this.safeString(order, 'order_' + baseId);
                            remaining = this.safeString(order, 'remain_' + baseId);
                        }
                    }
                    const timestamp = this.safeInteger(order, 'submit_time');
                    const fee = undefined;
                    const id = this.safeString(order, 'order_id');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': 'limit',
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': cost,
                        'average': undefined,
                        'amount': amount,
                        'filled': undefined,
                        'remaining': remaining,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    });
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'order_id': id
                    };
                    const response = await this.privatePostGetOrder(this.extend(request, params));
                    const orders = response['return'];
                    const order = this.parseOrder(this.extend({
                        'id': id
                    }, orders['order']), market);
                    return this.extend({
                        'info': response
                    }, order);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {};
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['pair'] = market['id'];
                    }
                    const response = await this.privatePostOpenOrders(this.extend(request, params));
                    const rawOrders = response['return']['orders'];
                    // { success: 1, return: { orders: null }} if no orders
                    if (!rawOrders) return [];
                    // { success: 1, return: { orders: [ ... objects ] }} for orders fetched by symbol
                    if (symbol !== undefined) return this.parseOrders(rawOrders, market, since, limit);
                    // { success: 1, return: { orders: { marketid: [ ... objects ] }}} if all orders are fetched
                    const marketIds = Object.keys(rawOrders);
                    let exchangeOrders = [];
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const marketOrders = rawOrders[marketId];
                        market = this.markets_by_id[marketId];
                        const parsedOrders = this.parseOrders(marketOrders, market, since, limit);
                        exchangeOrders = this.arrayConcat(exchangeOrders, parsedOrders);
                    }
                    return exchangeOrders;
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        symbol = market['symbol'];
                        request['pair'] = market['id'];
                    }
                    const response = await this.privatePostOrderHistory(this.extend(request, params));
                    let orders = this.parseOrders(response['return']['orders'], market);
                    orders = this.filterBy(orders, 'status', 'closed');
                    return this.filterBySymbolSinceLimit(orders, symbol, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (type !== 'limit') throw new ExchangeError1(this.id + ' createOrder() allows limit orders only');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'type': side,
                        'price': price
                    };
                    const currency = market['baseId'];
                    if (side === 'buy') request[market['quoteId']] = amount * price;
                    else request[market['baseId']] = amount;
                    request[currency] = amount;
                    const result = await this.privatePostTrade(this.extend(request, params));
                    const data = this.safeValue(result, 'return', {});
                    const id = this.safeString(data, 'order_id');
                    return {
                        'info': result,
                        'id': id
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    const side = this.safeValue(params, 'side');
                    if (side === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires an extra "side" param');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'order_id': id,
                        'pair': market['id'],
                        'type': side
                    };
                    return await this.privatePostCancelOrder(this.extend(request, params));
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    // Custom string you need to provide to identify each withdrawal.
                    // Will be passed to callback URL (assigned via website to the API key)
                    // so your system can identify the request and confirm it.
                    // Alphanumeric, max length 255.
                    const requestId = this.milliseconds();
                    // Alternatively:
                    // let requestId = this.uuid ();
                    const request = {
                        'currency': currency['id'],
                        'withdraw_amount': amount,
                        'withdraw_address': address,
                        'request_id': requestId.toString()
                    };
                    if (tag) request['withdraw_memo'] = tag;
                    const response = await this.privatePostWithdrawCoin(this.extend(request, params));
                    //
                    //     {
                    //         "success": 1,
                    //         "status": "approved",
                    //         "withdraw_currency": "xrp",
                    //         "withdraw_address": "rwWr7KUZ3ZFwzgaDGjKBysADByzxvohQ3C",
                    //         "withdraw_amount": "10000.00000000",
                    //         "fee": "2.00000000",
                    //         "amount_after_fee": "9998.00000000",
                    //         "submit_time": "1509469200",
                    //         "withdraw_id": "xrp-12345",
                    //         "txid": "",
                    //         "withdraw_memo": "123123"
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "success": 1,
                    //         "status": "approved",
                    //         "withdraw_currency": "xrp",
                    //         "withdraw_address": "rwWr7KUZ3ZFwzgaDGjKBysADByzxvohQ3C",
                    //         "withdraw_amount": "10000.00000000",
                    //         "fee": "2.00000000",
                    //         "amount_after_fee": "9998.00000000",
                    //         "submit_time": "1509469200",
                    //         "withdraw_id": "xrp-12345",
                    //         "txid": "",
                    //         "withdraw_memo": "123123"
                    //     }
                    //
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'id': this.safeString(transaction, 'withdraw_id'),
                        'txid': this.safeString(transaction, 'txid'),
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': undefined,
                        'info': transaction
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api];
                    if (api === 'public') url += '/' + this.implodeParams(path, params);
                    else {
                        this.checkRequiredCredentials();
                        body = this.urlencode(this.extend({
                            'method': path,
                            'timestamp': this.nonce(),
                            'recvWindow': this.options['recvWindow']
                        }, params));
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Key': this.apiKey,
                            'Sign': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    // { success: 0, error: "invalid order." }
                    // or
                    // [{ data, ... }, { ... }, ... ]
                    if (Array.isArray(response)) return; // public endpoints may return []-arrays
                    const error = this.safeValue(response, 'error', '');
                    if (!('success' in response) && error === '') return; // no 'success' property on public responses
                    if (this.safeInteger(response, 'success', 0) === 1) {
                        // { success: 1, return: { orders: [] }}
                        if (!('return' in response)) throw new ExchangeError1(this.id + ': malformed response: ' + this.json(response));
                        else return;
                    }
                    const feedback = this.id + ' ' + body;
                    this.throwExactlyMatchedException(this.exceptions['exact'], error, feedback);
                    this.throwBroadlyMatchedException(this.exceptions['broad'], error, feedback);
                    throw new ExchangeError1(feedback); // unknown message
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    94: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, AuthenticationError: AuthenticationError, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class itbit extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'itbit',
                        'name': 'itBit',
                        'countries': [
                            'US'
                        ],
                        'rateLimit': 2000,
                        'version': 'v1',
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransactions': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27822159-66153620-60ad-11e7-89e7-005f6d7f3de0.jpg',
                            'api': 'https://api.itbit.com',
                            'www': 'https://www.itbit.com',
                            'doc': [
                                'https://api.itbit.com/docs',
                                'https://www.itbit.com/api'
                            ]
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'markets/{symbol}/ticker',
                                    'markets/{symbol}/order_book',
                                    'markets/{symbol}/trades'
                                ]
                            },
                            'private': {
                                'get': [
                                    'wallets',
                                    'wallets/{walletId}',
                                    'wallets/{walletId}/balances/{currencyCode}',
                                    'wallets/{walletId}/funding_history',
                                    'wallets/{walletId}/trades',
                                    'wallets/{walletId}/orders',
                                    'wallets/{walletId}/orders/{id}'
                                ],
                                'post': [
                                    'wallet_transfers',
                                    'wallets',
                                    'wallets/{walletId}/cryptocurrency_deposits',
                                    'wallets/{walletId}/cryptocurrency_withdrawals',
                                    'wallets/{walletId}/orders',
                                    'wire_withdrawal'
                                ],
                                'delete': [
                                    'wallets/{walletId}/orders/{id}'
                                ]
                            }
                        },
                        'markets': {
                            'BTC/USD': {
                                'id': 'XBTUSD',
                                'symbol': 'BTC/USD',
                                'base': 'BTC',
                                'quote': 'USD',
                                'baseId': 'XBT',
                                'quoteId': 'USD',
                                'type': 'spot',
                                'spot': true
                            },
                            'BTC/SGD': {
                                'id': 'XBTSGD',
                                'symbol': 'BTC/SGD',
                                'base': 'BTC',
                                'quote': 'SGD',
                                'baseId': 'XBT',
                                'quoteId': 'SGD',
                                'type': 'spot',
                                'spot': true
                            },
                            'BTC/EUR': {
                                'id': 'XBTEUR',
                                'symbol': 'BTC/EUR',
                                'base': 'BTC',
                                'quote': 'EUR',
                                'baseId': 'XBT',
                                'quoteId': 'EUR',
                                'type': 'spot',
                                'spot': true
                            },
                            'ETH/USD': {
                                'id': 'ETHUSD',
                                'symbol': 'ETH/USD',
                                'base': 'ETH',
                                'quote': 'USD',
                                'baseId': 'ETH',
                                'quoteId': 'USD',
                                'type': 'spot',
                                'spot': true
                            },
                            'ETH/EUR': {
                                'id': 'ETHEUR',
                                'symbol': 'ETH/EUR',
                                'base': 'ETH',
                                'quote': 'EUR',
                                'baseId': 'ETH',
                                'quoteId': 'EUR',
                                'type': 'spot',
                                'spot': true
                            },
                            'ETH/SGD': {
                                'id': 'ETHSGD',
                                'symbol': 'ETH/SGD',
                                'base': 'ETH',
                                'quote': 'SGD',
                                'baseId': 'ETH',
                                'quoteId': 'SGD',
                                'type': 'spot',
                                'spot': true
                            },
                            'PAXGUSD': {
                                'id': 'PAXGUSD',
                                'symbol': 'PAXG/USD',
                                'base': 'PAXG',
                                'quote': 'USD',
                                'baseId': 'PAXG',
                                'quoteId': 'USD',
                                'type': 'spot',
                                'spot': true
                            },
                            'BCHUSD': {
                                'id': 'BCHUSD',
                                'symbol': 'BCH/USD',
                                'base': 'BCH',
                                'quote': 'USD',
                                'baseId': 'BCH',
                                'quoteId': 'USD',
                                'type': 'spot',
                                'spot': true
                            },
                            'LTCUSD': {
                                'id': 'LTCUSD',
                                'symbol': 'LTC/USD',
                                'base': 'LTC',
                                'quote': 'USD',
                                'baseId': 'LTC',
                                'quoteId': 'USD',
                                'type': 'spot',
                                'spot': true
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': -0.0003,
                                'taker': 0.35 / 100
                            }
                        },
                        'commonCurrencies': {
                            'XBT': 'BTC'
                        }
                    });
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    const orderbook = await this.publicGetMarketsSymbolOrderBook(this.extend(request, params));
                    return this.parseOrderBook(orderbook, symbol);
                }
                parseTicker(ticker, market) {
                    //
                    // {
                    //     "pair":"XBTUSD",
                    //     "bid":"36734.50",
                    //     "bidAmt":"0.01000000",
                    //     "ask":"36734.75",
                    //     "askAmt":"0.30750480",
                    //     "lastPrice":"36721.75",
                    //     "lastAmt":"0.00070461",
                    //     "volume24h":"275.50596346",
                    //     "volumeToday":"118.19025141",
                    //     "high24h":"37510.50",
                    //     "low24h":"35542.75",
                    //     "highToday":"37510.50",
                    //     "lowToday":"36176.50",
                    //     "openToday":"37156.50",
                    //     "vwapToday":"37008.22463903",
                    //     "vwap24h":"36580.27146808",
                    //     "serverTimeUTC":"2022-01-28T14:46:32.4472864Z"
                    // }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const serverTimeUTC = this.safeString(ticker, 'serverTimeUTC');
                    if (!serverTimeUTC) throw new ExchangeError1(this.id + ' fetchTicker() returned a bad response: ' + this.json(ticker));
                    const timestamp = this.parse8601(serverTimeUTC);
                    const vwap = this.safeString(ticker, 'vwap24h');
                    const baseVolume = this.safeString(ticker, 'volume24h');
                    const quoteVolume = Precise.stringMul(baseVolume, vwap);
                    const last = this.safeString(ticker, 'lastPrice');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high24h'),
                        'low': this.safeString(ticker, 'low24h'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': vwap,
                        'open': this.safeString(ticker, 'openToday'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const ticker = await this.publicGetMarketsSymbolTicker(this.extend(request, params));
                    //
                    // {
                    //     "pair":"XBTUSD",
                    //     "bid":"36734.50",
                    //     "bidAmt":"0.01000000",
                    //     "ask":"36734.75",
                    //     "askAmt":"0.30750480",
                    //     "lastPrice":"36721.75",
                    //     "lastAmt":"0.00070461",
                    //     "volume24h":"275.50596346",
                    //     "volumeToday":"118.19025141",
                    //     "high24h":"37510.50",
                    //     "low24h":"35542.75",
                    //     "highToday":"37510.50",
                    //     "lowToday":"36176.50",
                    //     "openToday":"37156.50",
                    //     "vwapToday":"37008.22463903",
                    //     "vwap24h":"36580.27146808",
                    //     "serverTimeUTC":"2022-01-28T14:46:32.4472864Z"
                    // }
                    //
                    return this.parseTicker(ticker, market);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         timestamp: "2015-05-22T17:45:34.7570000Z",
                    //         matchNumber: "5CR1JEUBBM8J",
                    //         price: "351.45000000",
                    //         amount: "0.00010000"
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "orderId": "248ffda4-83a0-4033-a5bb-8929d523f59f",
                    //         "timestamp": "2015-05-11T14:48:01.9870000Z",
                    //         "instrument": "XBTUSD",
                    //         "direction": "buy",                      // buy or sell
                    //         "currency1": "XBT",                      // base currency
                    //         "currency1Amount": "0.00010000",         // order amount in base currency
                    //         "currency2": "USD",                      // quote currency
                    //         "currency2Amount": "0.0250530000000000", // order cost in quote currency
                    //         "rate": "250.53000000",
                    //         "commissionPaid": "0.00000000",   // net trade fee paid after using any available rebate balance
                    //         "commissionCurrency": "USD",
                    //         "rebatesApplied": "-0.000125265", // negative values represent amount of rebate balance used for trades removing liquidity from order book; positive values represent amount of rebate balance earned from trades adding liquidity to order book
                    //         "rebateCurrency": "USD",
                    //         "executionId": "23132"
                    //     }
                    //
                    const id = this.safeString2(trade, 'executionId', 'matchNumber');
                    const timestamp = this.parse8601(this.safeString(trade, 'timestamp'));
                    const side = this.safeString(trade, 'direction');
                    const orderId = this.safeString(trade, 'orderId');
                    let feeCost = this.safeNumber(trade, 'commissionPaid');
                    const feeCurrencyId = this.safeString(trade, 'commissionCurrency');
                    const feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                    let rebatesApplied = this.safeNumber(trade, 'rebatesApplied');
                    if (rebatesApplied !== undefined) rebatesApplied = -rebatesApplied;
                    const rebateCurrencyId = this.safeString(trade, 'rebateCurrency');
                    const rebateCurrency = this.safeCurrencyCode(rebateCurrencyId);
                    const priceString = this.safeString2(trade, 'price', 'rate');
                    const amountString = this.safeString2(trade, 'currency1Amount', 'amount');
                    const price = this.parseNumber(priceString);
                    const amount = this.parseNumber(amountString);
                    const cost = this.parseNumber(Precise.stringMul(priceString, amountString));
                    let symbol = undefined;
                    const marketId = this.safeString(trade, 'instrument');
                    if (marketId !== undefined) {
                        if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                        else {
                            const baseId = this.safeString(trade, 'currency1');
                            const quoteId = this.safeString(trade, 'currency2');
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote;
                        }
                    }
                    if (symbol === undefined) {
                        if (market !== undefined) symbol = market['symbol'];
                    }
                    const result = {
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': undefined
                    };
                    if (feeCost !== undefined) {
                        if (rebatesApplied !== undefined) {
                            if (feeCurrency === rebateCurrency) {
                                feeCost = this.sum(feeCost, rebatesApplied);
                                result['fee'] = {
                                    'cost': feeCost,
                                    'currency': feeCurrency
                                };
                            } else result['fees'] = [
                                {
                                    'cost': feeCost,
                                    'currency': feeCurrency
                                },
                                {
                                    'cost': rebatesApplied,
                                    'currency': rebateCurrency
                                }
                            ];
                        } else result['fee'] = {
                            'cost': feeCost,
                            'currency': feeCurrency
                        };
                    }
                    if (!('fee' in result)) {
                        if (!('fees' in result)) result['fee'] = undefined;
                    }
                    return result;
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const walletId = this.safeString(params, 'walletId');
                    if (walletId === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a walletId parameter');
                    const request = {
                        'walletId': walletId
                    };
                    if (limit !== undefined) request['perPage'] = limit; // default 50, max 50
                    const response = await this.privateGetWalletsWalletIdFundingHistory(this.extend(request, params));
                    //     { bankName: 'USBC (usd)',
                    //         withdrawalId: 94740,
                    //         holdingPeriodCompletionDate: '2018-04-16T07:57:05.9606869',
                    //         time: '2018-04-16T07:57:05.9600000',
                    //         currency: 'USD',
                    //         transactionType: 'Withdrawal',
                    //         amount: '2186.72000000',
                    //         walletName: 'Wallet',
                    //         status: 'completed' },
                    //
                    //     { "time": "2018-01-02T19:52:22.4176503",
                    //     "amount": "0.50000000",
                    //     "status": "completed",
                    //     "txnHash": "1b6fff67ed83cb9e9a38ca4976981fc047322bc088430508fe764a127d3ace95",
                    //     "currency": "XBT",
                    //     "walletName": "Wallet",
                    //     "transactionType": "Deposit",
                    //     "destinationAddress": "3AAWTH9et4e8o51YKp9qPpmujrNXKwHWNX"}
                    const items = response['fundingHistory'];
                    const result = [];
                    for(let i = 0; i < items.length; i++){
                        const item = items[i];
                        const time = this.safeString(item, 'time');
                        const timestamp = this.parse8601(time);
                        const currency = this.safeString(item, 'currency');
                        const destinationAddress = this.safeString(item, 'destinationAddress');
                        const txnHash = this.safeString(item, 'txnHash');
                        const transactionType = this.safeStringLower(item, 'transactionType');
                        const transactionStatus = this.safeString(item, 'status');
                        const status = this.parseTransferStatus(transactionStatus);
                        result.push({
                            'id': this.safeString(item, 'withdrawalId'),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'currency': this.safeCurrencyCode(currency),
                            'address': destinationAddress,
                            'tag': undefined,
                            'txid': txnHash,
                            'type': transactionType,
                            'status': status,
                            'amount': this.safeNumber(item, 'amount'),
                            'fee': undefined,
                            'info': item
                        });
                    }
                    return result;
                }
                parseTransferStatus(status) {
                    const options = {
                        'cancelled': 'canceled',
                        'completed': 'ok'
                    };
                    return this.safeString(options, status, 'pending');
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const walletId = this.safeString(params, 'walletId');
                    if (walletId === undefined) throw new ExchangeError1(this.id + ' fetchMyTrades() requires a walletId parameter');
                    const request = {
                        'walletId': walletId
                    };
                    if (since !== undefined) request['rangeStart'] = this.ymdhms(since, 'T');
                    if (limit !== undefined) request['perPage'] = limit; // default 50, max 50
                    const response = await this.privateGetWalletsWalletIdTrades(this.extend(request, params));
                    //
                    //     {
                    //         "totalNumberOfRecords": "2",
                    //         "currentPageNumber": "1",
                    //         "latestExecutionId": "332", // most recent execution at time of response
                    //         "recordsPerPage": "50",
                    //         "tradingHistory": [
                    //             {
                    //                 "orderId": "248ffda4-83a0-4033-a5bb-8929d523f59f",
                    //                 "timestamp": "2015-05-11T14:48:01.9870000Z",
                    //                 "instrument": "XBTUSD",
                    //                 "direction": "buy",                      // buy or sell
                    //                 "currency1": "XBT",                      // base currency
                    //                 "currency1Amount": "0.00010000",         // order amount in base currency
                    //                 "currency2": "USD",                      // quote currency
                    //                 "currency2Amount": "0.0250530000000000", // order cost in quote currency
                    //                 "rate": "250.53000000",
                    //                 "commissionPaid": "0.00000000",   // net trade fee paid after using any available rebate balance
                    //                 "commissionCurrency": "USD",
                    //                 "rebatesApplied": "-0.000125265", // negative values represent amount of rebate balance used for trades removing liquidity from order book; positive values represent amount of rebate balance earned from trades adding liquidity to order book
                    //                 "rebateCurrency": "USD",
                    //                 "executionId": "23132"
                    //             },
                    //         ],
                    //     }
                    //
                    const trades = this.safeValue(response, 'tradingHistory', []);
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetMarketsSymbolTrades(this.extend(request, params));
                    //
                    //     {
                    //         count: 3,
                    //         recentTrades: [
                    //             {
                    //                 timestamp: "2015-05-22T17:45:34.7570000Z",
                    //                 matchNumber: "5CR1JEUBBM8J",
                    //                 price: "351.45000000",
                    //                 amount: "0.00010000"
                    //             },
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, 'recentTrades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseBalance(response) {
                    const balances = response[0]['balances'];
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'availableBalance');
                        account['total'] = this.safeString(balance, 'totalBalance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.fetchWallets(params);
                    return this.parseBalance(response);
                }
                async fetchWallets(params = {}) {
                    await this.loadMarkets();
                    if (!this.uid) throw new AuthenticationError(this.id + ' fetchWallets() requires uid API credential');
                    const request = {
                        'userId': this.uid
                    };
                    return await this.privateGetWallets(this.extend(request, params));
                }
                async fetchWallet(walletId, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'walletId': walletId
                    };
                    return await this.privateGetWalletsWalletId(this.extend(request, params));
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'open'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'filled'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const walletIdInParams = 'walletId' in params;
                    if (!walletIdInParams) throw new ExchangeError1(this.id + ' fetchOrders() requires a walletId parameter');
                    const walletId = params['walletId'];
                    const request = {
                        'walletId': walletId
                    };
                    const response = await this.privateGetWalletsWalletIdOrders(this.extend(request, params));
                    return this.parseOrders(response, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'submitted': 'open',
                        'open': 'open',
                        'filled': 'closed',
                        'cancelled': 'canceled',
                        'rejected': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "id": "13d6af57-8b0b-41e5-af30-becf0bcc574d",
                    //         "walletId": "7e037345-1288-4c39-12fe-d0f99a475a98",
                    //         "side": "buy",
                    //         "instrument": "XBTUSD",
                    //         "type": "limit",
                    //         "currency": "XBT",
                    //         "amount": "2.50000000",
                    //         "displayAmount": "2.50000000",
                    //         "price": "650.00000000",
                    //         "volumeWeightedAveragePrice": "0.00000000",
                    //         "amountFilled": "0.00000000",
                    //         "createdTime": "2014-02-11T17:05:15Z",
                    //         "status": "submitted",
                    //         "funds": null,
                    //         "metadata": {},
                    //         "clientOrderIdentifier": null,
                    //         "postOnly": "False"
                    //     }
                    //
                    const side = this.safeString(order, 'side');
                    const type = this.safeString(order, 'type');
                    const symbol = this.markets_by_id[order['instrument']]['symbol'];
                    const timestamp = this.parse8601(order['createdTime']);
                    const amount = this.safeString(order, 'amount');
                    const filled = this.safeString(order, 'amountFilled');
                    const fee = undefined;
                    const price = this.safeString(order, 'price');
                    const average = this.safeString(order, 'volumeWeightedAveragePrice');
                    const clientOrderId = this.safeString(order, 'clientOrderIdentifier');
                    const id = this.safeString(order, 'id');
                    const postOnlyString = this.safeString(order, 'postOnly');
                    const postOnly = postOnlyString === 'True';
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': this.parseOrderStatus(this.safeString(order, 'status')),
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'average': average,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'fee': fee,
                        // 'trades': this.parseTrades (order['trades'], market),
                        'trades': undefined
                    }, market);
                }
                nonce() {
                    return this.milliseconds();
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    if (type === 'market') throw new ExchangeError1(this.id + ' createOrder() allows limit orders only');
                    const walletIdInParams = 'walletId' in params;
                    if (!walletIdInParams) throw new ExchangeError1(this.id + ' createOrder() requires a walletId parameter');
                    amount = amount.toString();
                    price = price.toString();
                    const market = this.market(symbol);
                    const request = {
                        'side': side,
                        'type': type,
                        'currency': market['id'].replace(market['quote'], ''),
                        'amount': amount,
                        'display': amount,
                        'price': price,
                        'instrument': market['id']
                    };
                    const response = await this.privatePostWalletsWalletIdOrders(this.extend(request, params));
                    return {
                        'info': response,
                        'id': response['id']
                    };
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const walletIdInParams = 'walletId' in params;
                    if (!walletIdInParams) throw new ExchangeError1(this.id + ' fetchOrder() requires a walletId parameter');
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetWalletsWalletIdOrdersId(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async cancelOrder(id, symbol, params = {}) {
                    const walletIdInParams = 'walletId' in params;
                    if (!walletIdInParams) throw new ExchangeError1(this.id + ' cancelOrder() requires a walletId parameter');
                    const request = {
                        'id': id
                    };
                    return await this.privateDeleteWalletsWalletIdOrdersId(this.extend(request, params));
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (method === 'GET' && Object.keys(query).length) url += '?' + this.urlencode(query);
                    if (method === 'POST' && Object.keys(query).length) body = this.json(query);
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const timestamp = nonce;
                        const authBody = method === 'POST' ? body : '';
                        const auth = [
                            method,
                            url,
                            authBody,
                            nonce,
                            timestamp
                        ];
                        const message = nonce + this.json(auth).replace('\\/', '/');
                        const hash = this.hash(this.encode(message), 'sha256', 'binary');
                        const binaryUrl = this.stringToBinary(this.encode(url));
                        const binhash = this.binaryConcat(binaryUrl, hash);
                        const signature = this.hmac(binhash, this.encode(this.secret), 'sha512', 'base64');
                        headers = {
                            'Authorization': this.apiKey + ':' + signature,
                            'Content-Type': 'application/json',
                            'X-Auth-Timestamp': timestamp,
                            'X-Auth-Nonce': nonce
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    const code = this.safeString(response, 'code');
                    if (code !== undefined) throw new ExchangeError1(this.id + ' ' + this.json(response));
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    95: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { BadSymbol: BadSymbol, BadRequest: BadRequest, ExchangeNotAvailable: ExchangeNotAvailable, ArgumentsRequired: ArgumentsRequired1, PermissionDenied: PermissionDenied, AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, OrderNotFound: OrderNotFound, DDoSProtection: DDoSProtection, InvalidNonce: InvalidNonce, InsufficientFunds: InsufficientFunds, CancelPending: CancelPending, InvalidOrder: InvalidOrder, InvalidAddress: InvalidAddress, RateLimitExceeded: RateLimitExceeded, OnMaintenance: OnMaintenance } = require1('./base/errors');
            const { TRUNCATE: TRUNCATE, DECIMAL_PLACES: DECIMAL_PLACES } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class kraken extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'kraken',
                        'name': 'Kraken',
                        'countries': [
                            'US'
                        ],
                        'version': '0',
                        'rateLimit': 3000,
                        'certified': false,
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': true,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowInterest': false,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLedger': true,
                            'fetchLedgerEntry': true,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderTrades': 'emulated',
                            'fetchPositions': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': false,
                            'fetchWithdrawals': true,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'withdraw': true
                        },
                        'marketsByAltname': {},
                        'timeframes': {
                            '1m': 1,
                            '5m': 5,
                            '15m': 15,
                            '30m': 30,
                            '1h': 60,
                            '4h': 240,
                            '1d': 1440,
                            '1w': 10080,
                            '2w': 21600
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/76173629-fc67fb00-61b1-11ea-84fe-f2de582f58a3.jpg',
                            'api': {
                                'public': 'https://api.kraken.com',
                                'private': 'https://api.kraken.com',
                                'zendesk': 'https://kraken.zendesk.com/api/v2/help_center/en-us/articles'
                            },
                            'www': 'https://www.kraken.com',
                            'doc': 'https://www.kraken.com/features/api',
                            'fees': 'https://www.kraken.com/en-us/features/fee-schedule'
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': 0.0026,
                                'maker': 0.0016,
                                'tiers': {
                                    'taker': [
                                        [
                                            0,
                                            0.0026
                                        ],
                                        [
                                            50000,
                                            0.0024
                                        ],
                                        [
                                            100000,
                                            0.0022
                                        ],
                                        [
                                            250000,
                                            0.0020
                                        ],
                                        [
                                            500000,
                                            0.0018
                                        ],
                                        [
                                            1000000,
                                            0.0016
                                        ],
                                        [
                                            2500000,
                                            0.0014
                                        ],
                                        [
                                            5000000,
                                            0.0012
                                        ],
                                        [
                                            10000000,
                                            0.0001
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            0,
                                            0.0016
                                        ],
                                        [
                                            50000,
                                            0.0014
                                        ],
                                        [
                                            100000,
                                            0.0012
                                        ],
                                        [
                                            250000,
                                            0.0010
                                        ],
                                        [
                                            500000,
                                            0.0008
                                        ],
                                        [
                                            1000000,
                                            0.0006
                                        ],
                                        [
                                            2500000,
                                            0.0004
                                        ],
                                        [
                                            5000000,
                                            0.0002
                                        ],
                                        [
                                            10000000,
                                            0.0
                                        ]
                                    ]
                                }
                            }
                        },
                        'handleContentTypeApplicationZip': true,
                        'api': {
                            'zendesk': {
                                'get': [
                                    // we should really refrain from putting fixed fee numbers and stop hardcoding
                                    // we will be using their web APIs to scrape all numbers from these articles
                                    '360000292886',
                                    '201893608'
                                ]
                            },
                            'public': {
                                'get': [
                                    'Assets',
                                    'AssetPairs',
                                    'Depth',
                                    'OHLC',
                                    'Spread',
                                    'Ticker',
                                    'Time',
                                    'Trades'
                                ]
                            },
                            'private': {
                                'post': {
                                    'AddOrder': 0,
                                    'AddExport': 1,
                                    'Balance': 1,
                                    'CancelAll': 1,
                                    'CancelOrder': 0,
                                    'ClosedOrders': 2,
                                    'DepositAddresses': 1,
                                    'DepositMethods': 1,
                                    'DepositStatus': 1,
                                    'ExportStatus': 1,
                                    'GetWebSocketsToken': 1,
                                    'Ledgers': 2,
                                    'OpenOrders': 1,
                                    'OpenPositions': 1,
                                    'QueryLedgers': 1,
                                    'QueryOrders': 1,
                                    'QueryTrades': 1,
                                    'RetrieveExport': 1,
                                    'RemoveExport': 1,
                                    'TradeBalance': 1,
                                    'TradesHistory': 2,
                                    'TradeVolume': 1,
                                    'Withdraw': 1,
                                    'WithdrawCancel': 1,
                                    'WithdrawInfo': 1,
                                    'WithdrawStatus': 1,
                                    // staking
                                    'Stake': 1,
                                    'Unstake': 1,
                                    'Staking/Assets': 1,
                                    'Staking/Pending': 1,
                                    'Staking/Transactions': 1
                                }
                            }
                        },
                        'commonCurrencies': {
                            'XBT': 'BTC',
                            'XBT.M': 'BTC.M',
                            'XDG': 'DOGE',
                            'REPV2': 'REP',
                            'REP': 'REPV1'
                        },
                        'options': {
                            'delistedMarketsById': {},
                            // cannot withdraw/deposit these
                            'inactiveCurrencies': [
                                'CAD',
                                'USD',
                                'JPY',
                                'GBP'
                            ],
                            'networks': {
                                'ETH': 'ERC20',
                                'TRX': 'TRC20'
                            },
                            'depositMethods': {
                                '1INCH': '1inch (1INCH)',
                                'AAVE': 'Aave',
                                'ADA': 'ADA',
                                'ALGO': 'Algorand',
                                'ANKR': 'ANKR (ANKR)',
                                'ANT': 'Aragon (ANT)',
                                'ATOM': 'Cosmos',
                                'AXS': 'Axie Infinity Shards (AXS)',
                                'BADGER': 'Bager DAO (BADGER)',
                                'BAL': 'Balancer (BAL)',
                                'BAND': 'Band Protocol (BAND)',
                                'BAT': 'BAT',
                                'BCH': 'Bitcoin Cash',
                                'BNC': 'Bifrost (BNC)',
                                'BNT': 'Bancor (BNT)',
                                'BTC': 'Bitcoin',
                                'CHZ': 'Chiliz (CHZ)',
                                'COMP': 'Compound (COMP)',
                                'CQT': '\tCovalent Query Token (CQT)',
                                'CRV': 'Curve DAO Token (CRV)',
                                'CTSI': 'Cartesi (CTSI)',
                                'DAI': 'Dai',
                                'DASH': 'Dash',
                                'DOGE': 'Dogecoin',
                                'DOT': 'Polkadot',
                                'DYDX': 'dYdX (DYDX)',
                                'ENJ': 'Enjin Coin (ENJ)',
                                'EOS': 'EOS',
                                'ETC': 'Ether Classic (Hex)',
                                'ETH': 'Ether (Hex)',
                                'EWT': 'Energy Web Token',
                                'FEE': 'Kraken Fee Credit',
                                'FIL': 'Filecoin',
                                'FLOW': 'Flow',
                                'GHST': 'Aavegotchi (GHST)',
                                'GNO': 'GNO',
                                'GRT': 'GRT',
                                'ICX': 'Icon',
                                'INJ': 'Injective Protocol (INJ)',
                                'KAR': 'Karura (KAR)',
                                'KAVA': 'Kava',
                                'KEEP': 'Keep Token (KEEP)',
                                'KNC': 'Kyber Network (KNC)',
                                'KSM': 'Kusama',
                                'LINK': 'Link',
                                'LPT': 'Livepeer Token (LPT)',
                                'LRC': 'Loopring (LRC)',
                                'LSK': 'Lisk',
                                'LTC': 'Litecoin',
                                'MANA': 'MANA',
                                'MATIC': 'Polygon (MATIC)',
                                'MINA': 'Mina',
                                'MIR': 'Mirror Protocol (MIR)',
                                'MKR': 'Maker (MKR)',
                                'MLN': 'MLN',
                                'MOVR': 'Moonriver (MOVR)',
                                'NANO': 'NANO',
                                'OCEAN': 'OCEAN',
                                'OGN': 'Origin Protocol (OGN)',
                                'OMG': 'OMG',
                                'OXT': 'Orchid (OXT)',
                                'OXY': 'Oxygen (OXY)',
                                'PAXG': 'PAX (Gold)',
                                'PERP': 'Perpetual Protocol (PERP)',
                                'PHA': 'Phala (PHA)',
                                'QTUM': 'QTUM',
                                'RARI': 'Rarible (RARI)',
                                'RAY': 'Raydium (RAY)',
                                'REN': 'Ren Protocol (REN)',
                                'REP': 'REPv2',
                                'REPV1': 'REP',
                                'SAND': 'The Sandbox (SAND)',
                                'SC': 'Siacoin',
                                'SDN': 'Shiden (SDN)',
                                'SOL': 'Solana',
                                'SNX': 'Synthetix  Network (SNX)',
                                'SRM': 'Serum',
                                'STORJ': 'Storj (STORJ)',
                                'SUSHI': 'Sushiswap (SUSHI)',
                                'TBTC': 'tBTC',
                                'TRX': 'Tron',
                                'UNI': 'UNI',
                                'USDC': 'USDC',
                                'USDT': 'Tether USD (ERC20)',
                                'USDT-TRC20': 'Tether USD (TRC20)',
                                'WAVES': 'Waves',
                                'WBTC': 'Wrapped Bitcoin (WBTC)',
                                'XLM': 'Stellar XLM',
                                'XMR': 'Monero',
                                'XRP': 'Ripple XRP',
                                'XTZ': 'XTZ',
                                'YFI': 'YFI',
                                'ZEC': 'Zcash (Transparent)',
                                'ZRX': '0x (ZRX)'
                            }
                        },
                        'exceptions': {
                            'EQuery:Invalid asset pair': BadSymbol,
                            'EAPI:Invalid key': AuthenticationError,
                            'EFunding:Unknown withdraw key': InvalidAddress,
                            'EFunding:Invalid amount': InsufficientFunds,
                            'EService:Unavailable': ExchangeNotAvailable,
                            'EDatabase:Internal error': ExchangeNotAvailable,
                            'EService:Busy': ExchangeNotAvailable,
                            'EQuery:Unknown asset': BadSymbol,
                            'EAPI:Rate limit exceeded': DDoSProtection,
                            'EOrder:Rate limit exceeded': DDoSProtection,
                            'EGeneral:Internal error': ExchangeNotAvailable,
                            'EGeneral:Temporary lockout': DDoSProtection,
                            'EGeneral:Permission denied': PermissionDenied,
                            'EOrder:Unknown order': InvalidOrder,
                            'EOrder:Order minimum not met': InvalidOrder,
                            'EGeneral:Invalid arguments': BadRequest,
                            'ESession:Invalid session': AuthenticationError,
                            'EAPI:Invalid nonce': InvalidNonce,
                            'EFunding:No funding method': BadRequest,
                            'EFunding:Unknown asset': BadSymbol,
                            'EService:Market in post_only mode': OnMaintenance
                        }
                    });
                }
                costToPrecision(symbol, cost) {
                    return this.decimalToPrecision(cost, TRUNCATE, this.markets[symbol]['precision']['price'], DECIMAL_PLACES);
                }
                feeToPrecision(symbol, fee) {
                    return this.decimalToPrecision(fee, TRUNCATE, this.markets[symbol]['precision']['amount'], DECIMAL_PLACES);
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetAssetPairs(params);
                    //
                    //     {
                    //         "error":[],
                    //         "result":{
                    //             "ADAETH":{
                    //                 "altname":"ADAETH",
                    //                 "wsname":"ADA\/ETH",
                    //                 "aclass_base":"currency",
                    //                 "base":"ADA",
                    //                 "aclass_quote":"currency",
                    //                 "quote":"XETH",
                    //                 "lot":"unit",
                    //                 "pair_decimals":7,
                    //                 "lot_decimals":8,
                    //                 "lot_multiplier":1,
                    //                 "leverage_buy":[],
                    //                 "leverage_sell":[],
                    //                 "fees":[
                    //                     [0,0.26],
                    //                     [50000,0.24],
                    //                     [100000,0.22],
                    //                     [250000,0.2],
                    //                     [500000,0.18],
                    //                     [1000000,0.16],
                    //                     [2500000,0.14],
                    //                     [5000000,0.12],
                    //                     [10000000,0.1]
                    //                 ],
                    //                 "fees_maker":[
                    //                     [0,0.16],
                    //                     [50000,0.14],
                    //                     [100000,0.12],
                    //                     [250000,0.1],
                    //                     [500000,0.08],
                    //                     [1000000,0.06],
                    //                     [2500000,0.04],
                    //                     [5000000,0.02],
                    //                     [10000000,0]
                    //                 ],
                    //                 "fee_volume_currency":"ZUSD",
                    //                 "margin_call":80,
                    //                 "margin_stop":40,
                    //                 "ordermin": "1"
                    //             },
                    //         }
                    //     }
                    //
                    const markets = this.safeValue(response, 'result', {});
                    const keys = Object.keys(markets);
                    let result = [];
                    for(let i = 0; i < keys.length; i++){
                        const id = keys[i];
                        const market = markets[id];
                        const baseId = this.safeString(market, 'base');
                        const quoteId = this.safeString(market, 'quote');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const darkpool = id.indexOf('.d') >= 0;
                        const altname = this.safeString(market, 'altname');
                        const makerFees = this.safeValue(market, 'fees_maker', []);
                        const firstMakerFee = this.safeValue(makerFees, 0, []);
                        const firstMakerFeeRate = this.safeNumber(firstMakerFee, 1);
                        let maker = undefined;
                        if (firstMakerFeeRate !== undefined) maker = parseFloat(firstMakerFeeRate) / 100;
                        const takerFees = this.safeValue(market, 'fees', []);
                        const firstTakerFee = this.safeValue(takerFees, 0, []);
                        const firstTakerFeeRate = this.safeNumber(firstTakerFee, 1);
                        let taker = undefined;
                        if (firstTakerFeeRate !== undefined) taker = parseFloat(firstTakerFeeRate) / 100;
                        const leverageBuy = this.safeValue(market, 'leverage_buy', []);
                        const leverageBuyLength = leverageBuy.length;
                        const precisionPrice = this.safeString(market, 'pair_decimals');
                        result.push({
                            'id': id,
                            'symbol': darkpool ? altname : base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'darkpool': darkpool,
                            'altname': market['altname'],
                            'type': 'spot',
                            'spot': true,
                            'margin': leverageBuyLength > 0,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': taker,
                            'maker': maker,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'lot_decimals'),
                                'price': this.safeInteger(market, 'pair_decimals')
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': this.safeNumber(leverageBuy, leverageBuyLength - 1, 1)
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'ordermin'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': this.parseNumber(this.parsePrecision(precisionPrice)),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    result = this.appendInactiveMarkets(result);
                    this.marketsByAltname = this.indexBy(result, 'altname');
                    return result;
                }
                safeCurrency(currencyId, currency) {
                    if (currencyId !== undefined) {
                        if (currencyId.length > 3) {
                            if (currencyId.indexOf('X') === 0 || currencyId.indexOf('Z') === 0) {
                                if (currencyId.indexOf('.') > 0) return super.safeCurrency(currencyId, currency);
                                else currencyId = currencyId.slice(1);
                            }
                        }
                    }
                    return super.safeCurrency(currencyId, currency);
                }
                appendInactiveMarkets(result) {
                    // result should be an array to append to
                    const precision = {
                        'amount': 8,
                        'price': 8
                    };
                    const costLimits = {
                        'min': 0,
                        'max': undefined
                    };
                    const priceLimits = {
                        'min': Math.pow(10, -precision['price']),
                        'max': undefined
                    };
                    const amountLimits = {
                        'min': Math.pow(10, -precision['amount']),
                        'max': Math.pow(10, precision['amount'])
                    };
                    const limits = {
                        'amount': amountLimits,
                        'price': priceLimits,
                        'cost': costLimits
                    };
                    const defaults = {
                        'darkpool': false,
                        'info': undefined,
                        'maker': undefined,
                        'taker': undefined,
                        'active': false,
                        'precision': precision,
                        'limits': limits
                    };
                    const markets = [];
                    for(let i = 0; i < markets.length; i++)result.push(this.extend(defaults, markets[i]));
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetAssets(params);
                    //
                    //     {
                    //         "error": [],
                    //         "result": {
                    //             "ADA": { "aclass": "currency", "altname": "ADA", "decimals": 8, "display_decimals": 6 },
                    //             "BCH": { "aclass": "currency", "altname": "BCH", "decimals": 10, "display_decimals": 5 },
                    //             ...
                    //         },
                    //     }
                    //
                    const currencies = this.safeValue(response, 'result');
                    const ids = Object.keys(currencies);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const currency = currencies[id];
                        // todo: will need to rethink the fees
                        // see: https://support.kraken.com/hc/en-us/articles/201893608-What-are-the-withdrawal-fees-
                        // to add support for multiple withdrawal/deposit methods and
                        // differentiated fees for each particular method
                        const code = this.safeCurrencyCode(this.safeString(currency, 'altname'));
                        const precision = this.safeInteger(currency, 'decimals');
                        // assumes all currencies are active except those listed above
                        const active = !this.inArray(code, this.options['inactiveCurrencies']);
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'name': code,
                            'active': active,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': undefined,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': Math.pow(10, -precision),
                                    'max': Math.pow(10, precision)
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': Math.pow(10, precision)
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'fee-info': true
                    };
                    const response = await this.privatePostTradeVolume(this.extend(request, params));
                    //
                    //     {
                    //        error: [],
                    //        result: {
                    //          currency: 'ZUSD',
                    //          volume: '0.0000',
                    //          fees: {
                    //            XXBTZUSD: {
                    //              fee: '0.2600',
                    //              minfee: '0.1000',
                    //              maxfee: '0.2600',
                    //              nextfee: '0.2400',
                    //              tiervolume: '0.0000',
                    //              nextvolume: '50000.0000'
                    //            }
                    //          },
                    //          fees_maker: {
                    //            XXBTZUSD: {
                    //              fee: '0.1600',
                    //              minfee: '0.0000',
                    //              maxfee: '0.1600',
                    //              nextfee: '0.1400',
                    //              tiervolume: '0.0000',
                    //              nextvolume: '50000.0000'
                    //            }
                    //          }
                    //        }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseTradingFee(result, market);
                }
                parseTradingFee(response, market) {
                    const makerFees = this.safeValue(response, 'fees_maker', {});
                    const takerFees = this.safeValue(response, 'fees', {});
                    const symbolMakerFee = this.safeValue(makerFees, market['id'], {});
                    const symbolTakerFee = this.safeValue(takerFees, market['id'], {});
                    return {
                        'info': response,
                        'symbol': market['symbol'],
                        'maker': this.safeNumber(symbolMakerFee, 'fee'),
                        'taker': this.safeNumber(symbolTakerFee, 'fee'),
                        'percentage': true,
                        'tierBased': true
                    };
                }
                parseBidAsk(bidask, priceKey = 0, amountKey = 1) {
                    const price = this.safeNumber(bidask, priceKey);
                    const amount = this.safeNumber(bidask, amountKey);
                    const timestamp = this.safeInteger(bidask, 2);
                    return [
                        price,
                        amount,
                        timestamp
                    ];
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (market['darkpool']) throw new ExchangeError1(this.id + ' fetchOrderBook() does not provide an order book for darkpool symbol ' + symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['count'] = limit; // 100
                    const response = await this.publicGetDepth(this.extend(request, params));
                    //
                    //     {
                    //         "error":[],
                    //         "result":{
                    //             "XETHXXBT":{
                    //                 "asks":[
                    //                     ["0.023480","4.000",1586321307],
                    //                     ["0.023490","50.095",1586321306],
                    //                     ["0.023500","28.535",1586321302],
                    //                 ],
                    //                 "bids":[
                    //                     ["0.023470","59.580",1586321307],
                    //                     ["0.023460","20.000",1586321301],
                    //                     ["0.023440","67.832",1586321306],
                    //                 ]
                    //             }
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    let orderbook = this.safeValue(result, market['id']);
                    // sometimes kraken returns wsname instead of market id
                    // https://github.com/ccxt/ccxt/issues/8662
                    const marketInfo = this.safeValue(market, 'info', {});
                    const wsName = this.safeValue(marketInfo, 'wsname');
                    if (wsName !== undefined) orderbook = this.safeValue(result, wsName, orderbook);
                    return this.parseOrderBook(orderbook, symbol);
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "a":["2432.77000","1","1.000"],
                    //         "b":["2431.37000","2","2.000"],
                    //         "c":["2430.58000","0.04408910"],
                    //         "v":["4147.94474901","8896.96086304"],
                    //         "p":["2456.22239","2568.63032"],
                    //         "t":[3907,10056],
                    //         "l":["2302.18000","2302.18000"],
                    //         "h":["2621.14000","2860.01000"],
                    //         "o":"2571.56000"
                    //     }
                    //
                    const timestamp = this.milliseconds();
                    const symbol = this.safeSymbol(undefined, market);
                    const v = this.safeValue(ticker, 'v', []);
                    const baseVolume = this.safeString(v, 1);
                    const p = this.safeValue(ticker, 'p', []);
                    const vwap = this.safeString(p, 1);
                    const quoteVolume = Precise.stringMul(baseVolume, vwap);
                    const c = this.safeValue(ticker, 'c', []);
                    const last = this.safeString(c, 0);
                    const high = this.safeValue(ticker, 'h', []);
                    const low = this.safeValue(ticker, 'l', []);
                    const bid = this.safeValue(ticker, 'b', []);
                    const ask = this.safeValue(ticker, 'a', []);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(high, 1),
                        'low': this.safeString(low, 1),
                        'bid': this.safeString(bid, 0),
                        'bidVolume': undefined,
                        'ask': this.safeString(ask, 0),
                        'askVolume': undefined,
                        'vwap': vwap,
                        'open': this.safeString(ticker, 'o'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    if (symbols === undefined) throw new ArgumentsRequired1(this.id + ' fetchTickers() requires a symbols argument, an array of symbols');
                    await this.loadMarkets();
                    const marketIds = [];
                    for(let i = 0; i < symbols.length; i++){
                        const symbol = symbols[i];
                        const market = this.markets[symbol];
                        if (market['active'] && !market['darkpool']) marketIds.push(market['id']);
                    }
                    const request = {
                        'pair': marketIds.join(',')
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    const tickers = response['result'];
                    const ids = Object.keys(tickers);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const market = this.markets_by_id[id];
                        const symbol = market['symbol'];
                        const ticker = tickers[id];
                        result[symbol] = this.parseTicker(ticker, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const darkpool = symbol.indexOf('.d') >= 0;
                    if (darkpool) throw new ExchangeError1(this.id + ' fetchTicker() does not provide a ticker for darkpool symbol ' + symbol);
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    const ticker = response['result'][market['id']];
                    return this.parseTicker(ticker, market);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1591475640,
                    //         "0.02500",
                    //         "0.02500",
                    //         "0.02500",
                    //         "0.02500",
                    //         "0.02500",
                    //         "9.12201000",
                    //         5
                    //     ]
                    //
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 6)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'interval': this.timeframes[timeframe]
                    };
                    if (since !== undefined) request['since'] = parseInt((since - 1) / 1000);
                    const response = await this.publicGetOHLC(this.extend(request, params));
                    //
                    //     {
                    //         "error":[],
                    //         "result":{
                    //             "XETHXXBT":[
                    //                 [1591475580,"0.02499","0.02499","0.02499","0.02499","0.00000","0.00000000",0],
                    //                 [1591475640,"0.02500","0.02500","0.02500","0.02500","0.02500","9.12201000",5],
                    //                 [1591475700,"0.02499","0.02499","0.02499","0.02499","0.02499","1.28681415",2],
                    //                 [1591475760,"0.02499","0.02499","0.02499","0.02499","0.02499","0.08800000",1],
                    //             ],
                    //             "last":1591517580
                    //         }
                    //     }
                    const result = this.safeValue(response, 'result', {});
                    const ohlcvs = this.safeValue(result, market['id'], []);
                    return this.parseOHLCVs(ohlcvs, market, timeframe, since, limit);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'trade': 'trade',
                        'withdrawal': 'transaction',
                        'deposit': 'transaction',
                        'transfer': 'transfer',
                        'margin': 'margin'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     {
                    //         'LTFK7F-N2CUX-PNY4SX': {
                    //             refid: "TSJTGT-DT7WN-GPPQMJ",
                    //             time:  1520102320.555,
                    //             type: "trade",
                    //             aclass: "currency",
                    //             asset: "XETH",
                    //             amount: "0.1087194600",
                    //             fee: "0.0000000000",
                    //             balance: "0.2855851000"
                    //         },
                    //         ...
                    //     }
                    //
                    const id = this.safeString(item, 'id');
                    let direction = undefined;
                    const account = undefined;
                    const referenceId = this.safeString(item, 'refid');
                    const referenceAccount = undefined;
                    const type = this.parseLedgerEntryType(this.safeString(item, 'type'));
                    const code = this.safeCurrencyCode(this.safeString(item, 'asset'), currency);
                    let amount = this.safeNumber(item, 'amount');
                    if (amount < 0) {
                        direction = 'out';
                        amount = Math.abs(amount);
                    } else direction = 'in';
                    const time = this.safeNumber(item, 'time');
                    let timestamp = undefined;
                    if (time !== undefined) timestamp = parseInt(time * 1000);
                    const fee = {
                        'cost': this.safeNumber(item, 'fee'),
                        'currency': code
                    };
                    const before = undefined;
                    const after = this.safeNumber(item, 'balance');
                    const status = 'ok';
                    return {
                        'info': item,
                        'id': id,
                        'direction': direction,
                        'account': account,
                        'referenceId': referenceId,
                        'referenceAccount': referenceAccount,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'before': before,
                        'after': after,
                        'status': status,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': fee
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    // https://www.kraken.com/features/api#get-ledgers-info
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['asset'] = currency['id'];
                    }
                    if (since !== undefined) request['start'] = parseInt(since / 1000);
                    const response = await this.privatePostLedgers(this.extend(request, params));
                    // {  error: [],
                    //   result: { ledger: { 'LPUAIB-TS774-UKHP7X': {   refid: "A2B4HBV-L4MDIE-JU4N3N",
                    //                                                   time:  1520103488.314,
                    //                                                   type: "withdrawal",
                    //                                                 aclass: "currency",
                    //                                                  asset: "XETH",
                    //                                                 amount: "-0.2805800000",
                    //                                                    fee: "0.0050000000",
                    //                                                balance: "0.0000051000"           },
                    const result = this.safeValue(response, 'result', {});
                    const ledger = this.safeValue(result, 'ledger', {});
                    const keys = Object.keys(ledger);
                    const items = [];
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        const value = ledger[key];
                        value['id'] = key;
                        items.push(value);
                    }
                    return this.parseLedger(items, currency, since, limit);
                }
                async fetchLedgerEntriesByIds(ids, code, params = {}) {
                    // https://www.kraken.com/features/api#query-ledgers
                    await this.loadMarkets();
                    ids = ids.join(',');
                    const request = this.extend({
                        'id': ids
                    }, params);
                    const response = await this.privatePostQueryLedgers(request);
                    // {  error: [],
                    //   result: { 'LPUAIB-TS774-UKHP7X': {   refid: "A2B4HBV-L4MDIE-JU4N3N",
                    //                                         time:  1520103488.314,
                    //                                         type: "withdrawal",
                    //                                       aclass: "currency",
                    //                                        asset: "XETH",
                    //                                       amount: "-0.2805800000",
                    //                                          fee: "0.0050000000",
                    //                                      balance: "0.0000051000"           } } }
                    const result = response['result'];
                    const keys = Object.keys(result);
                    const items = [];
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        const value = result[key];
                        value['id'] = key;
                        items.push(value);
                    }
                    return this.parseLedger(items);
                }
                async fetchLedgerEntry(id, code, params = {}) {
                    const items = await this.fetchLedgerEntriesByIds([
                        id
                    ], code, params);
                    return items[0];
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     [
                    //         "0.032310", // price
                    //         "4.28169434", // amount
                    //         1541390792.763, // timestamp
                    //         "s", // sell or buy
                    //         "l", // limit or market
                    //         ""
                    //     ]
                    //
                    // fetchOrderTrades (private)
                    //
                    //     {
                    //         id: 'TIMIRG-WUNNE-RRJ6GT', // injected from outside
                    //         ordertxid: 'OQRPN2-LRHFY-HIFA7D',
                    //         postxid: 'TKH2SE-M7IF5-CFI7LT',
                    //         pair: 'USDCUSDT',
                    //         time: 1586340086.457,
                    //         type: 'sell',
                    //         ordertype: 'market',
                    //         price: '0.99860000',
                    //         cost: '22.16892001',
                    //         fee: '0.04433784',
                    //         vol: '22.20000000',
                    //         margin: '0.00000000',
                    //         misc: ''
                    //     }
                    //
                    let timestamp = undefined;
                    let side = undefined;
                    let type = undefined;
                    let price = undefined;
                    let amount = undefined;
                    let id = undefined;
                    let orderId = undefined;
                    let fee = undefined;
                    let symbol = undefined;
                    if (Array.isArray(trade)) {
                        timestamp = this.safeTimestamp(trade, 2);
                        side = trade[3] === 's' ? 'sell' : 'buy';
                        type = trade[4] === 'l' ? 'limit' : 'market';
                        price = this.safeString(trade, 0);
                        amount = this.safeString(trade, 1);
                        const tradeLength = trade.length;
                        if (tradeLength > 6) id = this.safeString(trade, 6); // artificially added as per #1794
                    } else if (typeof trade === 'string') id = trade;
                    else if ('ordertxid' in trade) {
                        const marketId = this.safeString(trade, 'pair');
                        const foundMarket = this.findMarketByAltnameOrId(marketId);
                        if (foundMarket !== undefined) market = foundMarket;
                        else if (marketId !== undefined) // delisted market ids go here
                        market = this.getDelistedMarketById(marketId);
                        orderId = this.safeString(trade, 'ordertxid');
                        id = this.safeString2(trade, 'id', 'postxid');
                        timestamp = this.safeTimestamp(trade, 'time');
                        side = this.safeString(trade, 'type');
                        type = this.safeString(trade, 'ordertype');
                        price = this.safeString(trade, 'price');
                        amount = this.safeString(trade, 'vol');
                        if ('fee' in trade) {
                            let currency = undefined;
                            if (market !== undefined) currency = market['quote'];
                            fee = {
                                'cost': this.safeString(trade, 'fee'),
                                'currency': currency
                            };
                        }
                    }
                    if (market !== undefined) symbol = market['symbol'];
                    const cost = this.safeString(trade, 'cost');
                    return this.safeTrade({
                        'id': id,
                        'order': orderId,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const id = market['id'];
                    const request = {
                        'pair': id
                    };
                    // https://support.kraken.com/hc/en-us/articles/218198197-How-to-pull-all-trade-data-using-the-Kraken-REST-API
                    // https://github.com/ccxt/ccxt/issues/5677
                    if (since !== undefined) {
                        // php does not format it properly
                        // therefore we use string concatenation here
                        request['since'] = since * 1e6;
                        request['since'] = since.toString() + '000000'; // expected to be in nanoseconds
                    }
                    // https://github.com/ccxt/ccxt/issues/5698
                    if (limit !== undefined && limit !== 1000) {
                        const fetchTradesWarning = this.safeValue(this.options, 'fetchTradesWarning', true);
                        if (fetchTradesWarning) throw new ExchangeError1(this.id + ' fetchTrades() cannot serve ' + limit.toString() + " trades without breaking the pagination, see https://github.com/ccxt/ccxt/issues/5698 for more details. Set exchange.options['fetchTradesWarning'] to acknowledge this warning and silence it.");
                    }
                    const response = await this.publicGetTrades(this.extend(request, params));
                    //
                    //     {
                    //         "error": [],
                    //         "result": {
                    //             "XETHXXBT": [
                    //                 ["0.032310","4.28169434",1541390792.763,"s","l",""]
                    //             ],
                    //             "last": "1541439421200678657"
                    //         }
                    //     }
                    //
                    const result = response['result'];
                    const trades = result[id];
                    // trades is a sorted array: last (most recent trade) goes last
                    const length = trades.length;
                    if (length <= 0) return [];
                    const lastTrade = trades[length - 1];
                    const lastTradeId = this.safeString(result, 'last');
                    lastTrade.push(lastTradeId);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'result', {});
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const currencyIds = Object.keys(balances);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(balances, currencyId);
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostBalance(params);
                    //
                    //     {
                    //         "error":[],
                    //         "result":{
                    //             "ZUSD":"58.8649",
                    //             "KFEE":"4399.43",
                    //             "XXBT":"0.0000034506",
                    //         }
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'type': side,
                        'ordertype': type,
                        'volume': this.amountToPrecision(symbol, amount)
                    };
                    const clientOrderId = this.safeString2(params, 'userref', 'clientOrderId');
                    params = this.omit(params, [
                        'userref',
                        'clientOrderId'
                    ]);
                    if (clientOrderId !== undefined) request['userref'] = clientOrderId;
                    //
                    //     market
                    //     limit (price = limit price)
                    //     stop-loss (price = stop loss price)
                    //     take-profit (price = take profit price)
                    //     stop-loss-limit (price = stop loss trigger price, price2 = triggered limit price)
                    //     take-profit-limit (price = take profit trigger price, price2 = triggered limit price)
                    //     settle-position
                    //
                    if (type === 'limit') request['price'] = this.priceToPrecision(symbol, price);
                    else if (type === 'stop-loss' || type === 'take-profit') {
                        const stopPrice = this.safeNumber2(params, 'price', 'stopPrice', price);
                        if (stopPrice === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a price argument or a price/stopPrice parameter for a ' + type + ' order');
                        else request['price'] = this.priceToPrecision(symbol, stopPrice);
                    } else if (type === 'stop-loss-limit' || type === 'take-profit-limit') {
                        const stopPrice = this.safeNumber2(params, 'price', 'stopPrice');
                        const limitPrice = this.safeNumber(params, 'price2');
                        const stopPriceDefined = stopPrice !== undefined;
                        const limitPriceDefined = limitPrice !== undefined;
                        if (stopPriceDefined && limitPriceDefined) {
                            request['price'] = this.priceToPrecision(symbol, stopPrice);
                            request['price2'] = this.priceToPrecision(symbol, limitPrice);
                        } else if (price === undefined || !(stopPriceDefined || limitPriceDefined)) throw new ArgumentsRequired1(this.id + ' createOrder() requires a price argument and/or price/stopPrice/price2 parameters for a ' + type + ' order');
                        else {
                            if (stopPriceDefined) {
                                request['price'] = this.priceToPrecision(symbol, stopPrice);
                                request['price2'] = this.priceToPrecision(symbol, price);
                            } else if (limitPriceDefined) {
                                request['price'] = this.priceToPrecision(symbol, price);
                                request['price2'] = this.priceToPrecision(symbol, limitPrice);
                            }
                        }
                    }
                    let close = this.safeValue(params, 'close');
                    if (close !== undefined) {
                        close = this.extend({}, close);
                        const closePrice = this.safeValue(close, 'price');
                        if (closePrice !== undefined) close['price'] = this.priceToPrecision(symbol, closePrice);
                        const closePrice2 = this.safeValue(close, 'price2'); // stopPrice
                        if (closePrice2 !== undefined) close['price2'] = this.priceToPrecision(symbol, closePrice2);
                        request['close'] = close;
                    }
                    params = this.omit(params, [
                        'price',
                        'stopPrice',
                        'price2',
                        'close'
                    ]);
                    const response = await this.privatePostAddOrder(this.extend(request, params));
                    //
                    //     {
                    //         error: [],
                    //         result: {
                    //             descr: { order: 'buy 0.02100000 ETHUSDT @ limit 330.00' },
                    //             txid: [ 'OEKVV2-IH52O-TPL6GZ' ]
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    return this.parseOrder(result);
                }
                findMarketByAltnameOrId(id) {
                    if (id in this.marketsByAltname) return this.marketsByAltname[id];
                    else if (id in this.markets_by_id) return this.markets_by_id[id];
                    return undefined;
                }
                getDelistedMarketById(id) {
                    if (id === undefined) return id;
                    let market = this.safeValue(this.options['delistedMarketsById'], id);
                    if (market !== undefined) return market;
                    const baseIdStart = 0;
                    let baseIdEnd = 3;
                    let quoteIdStart = 3;
                    let quoteIdEnd = 6;
                    if (id.length === 8) {
                        baseIdEnd = 4;
                        quoteIdStart = 4;
                        quoteIdEnd = 8;
                    } else if (id.length === 7) {
                        baseIdEnd = 4;
                        quoteIdStart = 4;
                        quoteIdEnd = 7;
                    }
                    const baseId = id.slice(baseIdStart, baseIdEnd);
                    const quoteId = id.slice(quoteIdStart, quoteIdEnd);
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    const symbol = base + '/' + quote;
                    market = {
                        'symbol': symbol,
                        'base': base,
                        'quote': quote,
                        'baseId': baseId,
                        'quoteId': quoteId
                    };
                    this.options['delistedMarketsById'][id] = market;
                    return market;
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'pending': 'open',
                        'open': 'open',
                        'closed': 'closed',
                        'canceled': 'canceled',
                        'expired': 'expired'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder for regular orders
                    //
                    //     {
                    //         descr: { order: 'buy 0.02100000 ETHUSDT @ limit 330.00' },
                    //         txid: [ 'OEKVV2-IH52O-TPL6GZ' ]
                    //     }
                    //     {
                    //         "txid": [ "TX_ID_HERE" ],
                    //         "descr": { "order":"buy 0.12345678 ETHEUR @ market" },
                    //     }
                    //
                    //
                    // createOrder for stop orders
                    //
                    //     {
                    //         "txid":["OSILNC-VQI5Q-775ZDQ"],
                    //         "descr":{"order":"sell 167.28002676 ADAXBT @ stop loss 0.00003280 -> limit 0.00003212"}
                    //     }
                    //
                    //
                    //     {
                    //         "txid":["OVHMJV-BZW2V-6NZFWF"],
                    //         "descr":{"order":"sell 0.00100000 ETHUSD @ stop loss 2677.00 -> limit 2577.00 with 5:1 leverage"}
                    //     }
                    //
                    const description = this.safeValue(order, 'descr', {});
                    const orderDescription = this.safeString(description, 'order');
                    let side = undefined;
                    let type = undefined;
                    let marketId = undefined;
                    let price = undefined;
                    let amount = undefined;
                    let stopPrice = undefined;
                    if (orderDescription !== undefined) {
                        const parts = orderDescription.split(' ');
                        side = this.safeString(parts, 0);
                        amount = this.safeString(parts, 1);
                        marketId = this.safeString(parts, 2);
                        type = this.safeString(parts, 4);
                        if (type === 'stop') {
                            stopPrice = this.safeString(parts, 6);
                            price = this.safeString(parts, 9);
                        } else if (type === 'limit') price = this.safeString(parts, 5);
                    }
                    side = this.safeString(description, 'type', side);
                    type = this.safeString(description, 'ordertype', type);
                    marketId = this.safeString(description, 'pair', marketId);
                    const foundMarket = this.findMarketByAltnameOrId(marketId);
                    let symbol = undefined;
                    if (foundMarket !== undefined) market = foundMarket;
                    else if (marketId !== undefined) // delisted market ids go here
                    market = this.getDelistedMarketById(marketId);
                    const timestamp = this.safeTimestamp(order, 'opentm');
                    amount = this.safeString(order, 'vol', amount);
                    const filled = this.safeString(order, 'vol_exec');
                    let fee = undefined;
                    // kraken truncates the cost in the api response so we will ignore it and calculate it from average & filled
                    // const cost = this.safeString (order, 'cost');
                    price = this.safeString(description, 'price', price);
                    if (price === undefined || Precise.stringEquals(price, '0')) price = this.safeString(description, 'price2');
                    if (price === undefined || Precise.stringEquals(price, '0')) price = this.safeString(order, 'price', price);
                    const average = this.safeNumber(order, 'price');
                    if (market !== undefined) {
                        symbol = market['symbol'];
                        if ('fee' in order) {
                            const flags = order['oflags'];
                            const feeCost = this.safeString(order, 'fee');
                            fee = {
                                'cost': feeCost,
                                'rate': undefined
                            };
                            if (flags.indexOf('fciq') >= 0) fee['currency'] = market['quote'];
                            else if (flags.indexOf('fcib') >= 0) fee['currency'] = market['base'];
                        }
                    }
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    let id = this.safeString(order, 'id');
                    if (id === undefined) {
                        const txid = this.safeValue(order, 'txid');
                        id = this.safeString(txid, 0);
                    }
                    const clientOrderId = this.safeString(order, 'userref');
                    const rawTrades = this.safeValue(order, 'trades');
                    stopPrice = this.safeNumber(order, 'stopprice', stopPrice);
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'cost': undefined,
                        'amount': amount,
                        'filled': filled,
                        'average': average,
                        'remaining': undefined,
                        'fee': fee,
                        'trades': rawTrades
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const clientOrderId = this.safeValue2(params, 'userref', 'clientOrderId');
                    const request = {
                        'trades': true
                    };
                    let query = params;
                    if (clientOrderId !== undefined) {
                        request['userref'] = clientOrderId;
                        query = this.omit(params, [
                            'userref',
                            'clientOrderId'
                        ]);
                    } else request['txid'] = id;
                    const response = await this.privatePostQueryOrders(this.extend(request, query));
                    //
                    //     {
                    //         "error":[],
                    //         "result":{
                    //             "OTLAS3-RRHUF-NDWH5A":{
                    //                 "refid":null,
                    //                 "userref":null,
                    //                 "status":"closed",
                    //                 "reason":null,
                    //                 "opentm":1586822919.3342,
                    //                 "closetm":1586822919.365,
                    //                 "starttm":0,
                    //                 "expiretm":0,
                    //                 "descr":{
                    //                     "pair":"XBTUSDT",
                    //                     "type":"sell",
                    //                     "ordertype":"market",
                    //                     "price":"0",
                    //                     "price2":"0",
                    //                     "leverage":"none",
                    //                     "order":"sell 0.21804000 XBTUSDT @ market",
                    //                     "close":""
                    //                 },
                    //                 "vol":"0.21804000",
                    //                 "vol_exec":"0.21804000",
                    //                 "cost":"1493.9",
                    //                 "fee":"3.8",
                    //                 "price":"6851.5",
                    //                 "stopprice":"0.00000",
                    //                 "limitprice":"0.00000",
                    //                 "misc":"",
                    //                 "oflags":"fciq",
                    //                 "trades":["TT5UC3-GOIRW-6AZZ6R"]
                    //             }
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    if (!(id in result)) throw new OrderNotFound(this.id + ' fetchOrder() could not find order id ' + id);
                    const order = this.parseOrder(this.extend({
                        'id': id
                    }, result[id]));
                    return this.extend({
                        'info': response
                    }, order);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    const orderTrades = this.safeValue(params, 'trades');
                    const tradeIds = [];
                    if (orderTrades === undefined) throw new ArgumentsRequired1(this.id + " fetchOrderTrades() requires a unified order structure in the params argument or a 'trades' param (an array of trade id strings)");
                    else for(let i = 0; i < orderTrades.length; i++){
                        const orderTrade = orderTrades[i];
                        if (typeof orderTrade === 'string') tradeIds.push(orderTrade);
                        else tradeIds.push(orderTrade['id']);
                    }
                    await this.loadMarkets();
                    const options = this.safeValue(this.options, 'fetchOrderTrades', {});
                    const batchSize = this.safeInteger(options, 'batchSize', 20);
                    const numTradeIds = tradeIds.length;
                    let numBatches = parseInt(numTradeIds / batchSize);
                    numBatches = this.sum(numBatches, 1);
                    let result = [];
                    for(let j = 0; j < numBatches; j++){
                        const requestIds = [];
                        for(let k = 0; k < batchSize; k++){
                            const index = this.sum(j * batchSize, k);
                            if (index < numTradeIds) requestIds.push(tradeIds[index]);
                        }
                        const request = {
                            'txid': requestIds.join(',')
                        };
                        const response = await this.privatePostQueryTrades(request);
                        //
                        //     {
                        //         error: [],
                        //         result: {
                        //             'TIMIRG-WUNNE-RRJ6GT': {
                        //                 ordertxid: 'OQRPN2-LRHFY-HIFA7D',
                        //                 postxid: 'TKH2SE-M7IF5-CFI7LT',
                        //                 pair: 'USDCUSDT',
                        //                 time: 1586340086.457,
                        //                 type: 'sell',
                        //                 ordertype: 'market',
                        //                 price: '0.99860000',
                        //                 cost: '22.16892001',
                        //                 fee: '0.04433784',
                        //                 vol: '22.20000000',
                        //                 margin: '0.00000000',
                        //                 misc: ''
                        //             }
                        //         }
                        //     }
                        //
                        const rawTrades = this.safeValue(response, 'result');
                        const ids = Object.keys(rawTrades);
                        for(let i = 0; i < ids.length; i++)rawTrades[ids[i]]['id'] = ids[i];
                        const trades = this.parseTrades(rawTrades, undefined, since, limit);
                        const tradesFilteredBySymbol = this.filterBySymbol(trades, symbol);
                        result = this.arrayConcat(result, tradesFilteredBySymbol);
                    }
                    return result;
                }
                async fetchOrdersByIds(ids, symbol, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostQueryOrders(this.extend({
                        'trades': true,
                        'txid': ids.join(',')
                    }, params));
                    const result = this.safeValue(response, 'result', {});
                    const orders = [];
                    const orderIds = Object.keys(result);
                    for(let i = 0; i < orderIds.length; i++){
                        const id = orderIds[i];
                        const item = result[id];
                        const order = this.parseOrder(this.extend({
                            'id': id
                        }, item));
                        orders.push(order);
                    }
                    return orders;
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    if (since !== undefined) request['start'] = parseInt(since / 1000);
                    const response = await this.privatePostTradesHistory(this.extend(request, params));
                    //
                    //     {
                    //         "error": [],
                    //         "result": {
                    //             "trades": {
                    //                 "GJ3NYQ-XJRTF-THZABF": {
                    //                     "ordertxid": "TKH2SE-ZIF5E-CFI7LT",
                    //                     "postxid": "OEN3VX-M7IF5-JNBJAM",
                    //                     "pair": "XICNXETH",
                    //                     "time": 1527213229.4491,
                    //                     "type": "sell",
                    //                     "ordertype": "limit",
                    //                     "price": "0.001612",
                    //                     "cost": "0.025792",
                    //                     "fee": "0.000026",
                    //                     "vol": "16.00000000",
                    //                     "margin": "0.000000",
                    //                     "misc": ""
                    //                 },
                    //                 ...
                    //             },
                    //             "count": 9760,
                    //         },
                    //     }
                    //
                    const trades = response['result']['trades'];
                    const ids = Object.keys(trades);
                    for(let i = 0; i < ids.length; i++)trades[ids[i]]['id'] = ids[i];
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    return this.parseTrades(trades, market, since, limit);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    let response = undefined;
                    const clientOrderId = this.safeValue2(params, 'userref', 'clientOrderId', id);
                    const request = {
                        'txid': clientOrderId
                    };
                    params = this.omit(params, [
                        'userref',
                        'clientOrderId'
                    ]);
                    try {
                        response = await this.privatePostCancelOrder(this.extend(request, params));
                    } catch (e) {
                        if (this.last_http_response) {
                            if (this.last_http_response.indexOf('EOrder:Unknown order') >= 0) throw new OrderNotFound(this.id + ' cancelOrder() error ' + this.last_http_response);
                        }
                        throw e;
                    }
                    return response;
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    return await this.privatePostCancelAll(params);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (since !== undefined) request['start'] = parseInt(since / 1000);
                    let query = params;
                    const clientOrderId = this.safeValue2(params, 'userref', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['userref'] = clientOrderId;
                        query = this.omit(params, [
                            'userref',
                            'clientOrderId'
                        ]);
                    }
                    const response = await this.privatePostOpenOrders(this.extend(request, query));
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const result = this.safeValue(response, 'result', {});
                    const orders = this.safeValue(result, 'open', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (since !== undefined) request['start'] = parseInt(since / 1000);
                    let query = params;
                    const clientOrderId = this.safeValue2(params, 'userref', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['userref'] = clientOrderId;
                        query = this.omit(params, [
                            'userref',
                            'clientOrderId'
                        ]);
                    }
                    const response = await this.privatePostClosedOrders(this.extend(request, query));
                    //
                    //     {
                    //         "error":[],
                    //         "result":{
                    //             "closed":{
                    //                 "OETZYO-UL524-QJMXCT":{
                    //                     "refid":null,
                    //                     "userref":null,
                    //                     "status":"canceled",
                    //                     "reason":"User requested",
                    //                     "opentm":1601489313.3898,
                    //                     "closetm":1601489346.5507,
                    //                     "starttm":0,
                    //                     "expiretm":0,
                    //                     "descr":{
                    //                         "pair":"ETHUSDT",
                    //                         "type":"buy",
                    //                         "ordertype":"limit",
                    //                         "price":"330.00",
                    //                         "price2":"0",
                    //                         "leverage":"none",
                    //                         "order":"buy 0.02100000 ETHUSDT @ limit 330.00",
                    //                         "close":""
                    //                     },
                    //                     "vol":"0.02100000",
                    //                     "vol_exec":"0.00000000",
                    //                     "cost":"0.00000",
                    //                     "fee":"0.00000",
                    //                     "price":"0.00000",
                    //                     "stopprice":"0.00000",
                    //                     "limitprice":"0.00000",
                    //                     "misc":"",
                    //                     "oflags":"fciq"
                    //                 },
                    //             },
                    //             "count":16
                    //         }
                    //     }
                    //
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const result = this.safeValue(response, 'result', {});
                    const orders = this.safeValue(result, 'closed', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                parseTransactionStatus(status) {
                    // IFEX transaction states
                    const statuses = {
                        'Initial': 'pending',
                        'Pending': 'pending',
                        'Success': 'ok',
                        'Settled': 'pending',
                        'Failure': 'failed',
                        'Partial': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         method: "Ether (Hex)",
                    //         aclass: "currency",
                    //         asset: "XETH",
                    //         refid: "Q2CANKL-LBFVEE-U4Y2WQ",
                    //         txid: "0x57fd704dab1a73c20e24c8696099b695d596924b401b261513cfdab23…",
                    //         info: "0x615f9ba7a9575b0ab4d571b2b36b1b324bd83290",
                    //         amount: "7.9999257900",
                    //         fee: "0.0000000000",
                    //         time:  1529223212,
                    //         status: "Success"
                    //     }
                    //
                    // there can be an additional 'status-prop' field present
                    // deposit pending review by exchange => 'on-hold'
                    // the deposit is initiated by the exchange => 'return'
                    //
                    //      {
                    //          type: 'deposit',
                    //          method: 'Fidor Bank AG (Wire Transfer)',
                    //          aclass: 'currency',
                    //          asset: 'ZEUR',
                    //          refid: 'xxx-xxx-xxx',
                    //          txid: '12341234',
                    //          info: 'BANKCODEXXX',
                    //          amount: '38769.08',
                    //          fee: '0.0000',
                    //          time: 1644306552,
                    //          status: 'Success',
                    //          status-prop: 'on-hold'
                    //      }
                    //
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         method: "Ether",
                    //         aclass: "currency",
                    //         asset: "XETH",
                    //         refid: "A2BF34S-O7LBNQ-UE4Y4O",
                    //         txid: "0x288b83c6b0904d8400ef44e1c9e2187b5c8f7ea3d838222d53f701a15b5c274d",
                    //         info: "0x7cb275a5e07ba943fee972e165d80daa67cb2dd0",
                    //         amount: "9.9950000000",
                    //         fee: "0.0050000000",
                    //         time:  1530481750,
                    //         status: "Success"
                    //         status-prop: 'on-hold' // this field might not be present in some cases
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "refid": "AGBSO6T-UFMTTQ-I7KGS6"
                    //     }
                    //
                    const id = this.safeString(transaction, 'refid');
                    const txid = this.safeString(transaction, 'txid');
                    const timestamp = this.safeTimestamp(transaction, 'time');
                    const currencyId = this.safeString(transaction, 'asset');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const address = this.safeString(transaction, 'info');
                    const amount = this.safeNumber(transaction, 'amount');
                    let status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const statusProp = this.safeString(transaction, 'status-prop');
                    const isOnHoldDeposit = statusProp === 'on-hold';
                    const isCancellationRequest = statusProp === 'cancel-pending';
                    const isOnHoldWithdrawal = statusProp === 'onhold';
                    if (isOnHoldDeposit || isCancellationRequest || isOnHoldWithdrawal) status = 'pending';
                    const type = this.safeString(transaction, 'type'); // injected from the outside
                    let feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost === undefined) {
                        if (type === 'deposit') feeCost = 0;
                    }
                    return {
                        'info': transaction,
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'status': status,
                        'type': type,
                        'updated': undefined,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': {
                            'currency': code,
                            'cost': feeCost
                        }
                    };
                }
                parseTransactionsByType(type, transactions, code, since, limit) {
                    const result = [];
                    for(let i = 0; i < transactions.length; i++){
                        const transaction = this.parseTransaction(this.extend({
                            'type': type
                        }, transactions[i]));
                        result.push(transaction);
                    }
                    return this.filterByCurrencySinceLimit(result, code, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    // https://www.kraken.com/en-us/help/api#deposit-status
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchDeposits() requires a currency code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'asset': currency['id']
                    };
                    const response = await this.privatePostDepositStatus(this.extend(request, params));
                    //
                    //     {  error: [],
                    //       result: [ { method: "Ether (Hex)",
                    //                   aclass: "currency",
                    //                    asset: "XETH",
                    //                    refid: "Q2CANKL-LBFVEE-U4Y2WQ",
                    //                     txid: "0x57fd704dab1a73c20e24c8696099b695d596924b401b261513cfdab23…",
                    //                     info: "0x615f9ba7a9575b0ab4d571b2b36b1b324bd83290",
                    //                   amount: "7.9999257900",
                    //                      fee: "0.0000000000",
                    //                     time:  1529223212,
                    //                   status: "Success"                                                       } ] }
                    //
                    return this.parseTransactionsByType('deposit', response['result'], code, since, limit);
                }
                async fetchTime(params = {}) {
                    // https://www.kraken.com/en-us/features/api#get-server-time
                    const response = await this.publicGetTime(params);
                    //
                    //    {
                    //        "error": [],
                    //        "result": {
                    //            "unixtime": 1591502873,
                    //            "rfc1123": "Sun,  7 Jun 20 04:07:53 +0000"
                    //        }
                    //    }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.safeTimestamp(result, 'unixtime');
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    // https://www.kraken.com/en-us/help/api#withdraw-status
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchWithdrawals() requires a currency code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'asset': currency['id']
                    };
                    const response = await this.privatePostWithdrawStatus(this.extend(request, params));
                    //
                    //     {  error: [],
                    //       result: [ { method: "Ether",
                    //                   aclass: "currency",
                    //                    asset: "XETH",
                    //                    refid: "A2BF34S-O7LBNQ-UE4Y4O",
                    //                     txid: "0x298c83c7b0904d8400ef43e1c9e2287b518f7ea3d838822d53f704a1565c274d",
                    //                     info: "0x7cb275a5e07ba943fee972e165d80daa67cb2dd0",
                    //                   amount: "9.9950000000",
                    //                      fee: "0.0050000000",
                    //                     time:  1530481750,
                    //                   status: "Success"                                                             } ] }
                    //
                    return this.parseTransactionsByType('withdrawal', response['result'], code, since, limit);
                }
                async createDepositAddress(code, params = {}) {
                    const request = {
                        'new': 'true'
                    };
                    return await this.fetchDepositAddress(code, this.extend(request, params));
                }
                async fetchDepositMethods(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'asset': currency['id']
                    };
                    const response = await this.privatePostDepositMethods(this.extend(request, params));
                    //
                    //     {
                    //         "error":[],
                    //         "result":[
                    //             {"method":"Ether (Hex)","limit":false,"gen-address":true}
                    //         ]
                    //     }
                    //
                    //     {
                    //         "error":[],
                    //         "result":[
                    //             {"method":"Tether USD (ERC20)","limit":false,"address-setup-fee":"0.00000000","gen-address":true},
                    //             {"method":"Tether USD (TRC20)","limit":false,"address-setup-fee":"0.00000000","gen-address":true}
                    //         ]
                    //     }
                    //
                    //     {
                    //         "error":[],
                    //         "result":[
                    //             {"method":"Bitcoin","limit":false,"fee":"0.0000000000","gen-address":true}
                    //         ]
                    //     }
                    //
                    return this.safeValue(response, 'result');
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    let network = this.safeStringUpper(params, 'network');
                    const networks = this.safeValue(this.options, 'networks', {});
                    network = this.safeString(networks, network, network); // support ETH > ERC20 aliases
                    params = this.omit(params, 'network');
                    if (code === 'USDT' && network === 'TRC20') code = code + '-' + network;
                    const defaultDepositMethods = this.safeValue(this.options, 'depositMethods', {});
                    const defaultDepositMethod = this.safeString(defaultDepositMethods, code);
                    let depositMethod = this.safeString(params, 'method', defaultDepositMethod);
                    // if the user has specified an exchange-specific method in params
                    // we pass it as is, otherwise we take the 'network' unified param
                    if (depositMethod === undefined) {
                        const depositMethods = await this.fetchDepositMethods(code);
                        if (network !== undefined) // find best matching deposit method, or fallback to the first one
                        for(let i = 0; i < depositMethods.length; i++){
                            const entry = this.safeString(depositMethods[i], 'method');
                            if (entry.indexOf(network) >= 0) {
                                depositMethod = entry;
                                break;
                            }
                        }
                        // if depositMethod was not specified, fallback to the first available deposit method
                        if (depositMethod === undefined) {
                            const firstDepositMethod = this.safeValue(depositMethods, 0, {});
                            depositMethod = this.safeString(firstDepositMethod, 'method');
                        }
                    }
                    const request = {
                        'asset': currency['id'],
                        'method': depositMethod
                    };
                    const response = await this.privatePostDepositAddresses(this.extend(request, params));
                    //
                    //     {
                    //         "error":[],
                    //         "result":[
                    //             {"address":"0x77b5051f97efa9cc52c9ad5b023a53fc15c200d3","expiretm":"0"}
                    //         ]
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    const firstResult = this.safeValue(result, 0, {});
                    if (firstResult === undefined) throw new InvalidAddress(this.id + ' privatePostDepositAddresses() returned no addresses for ' + code);
                    return this.parseDepositAddress(firstResult, currency);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         "address":"0x77b5051f97efa9cc52c9ad5b023a53fc15c200d3",
                    //         "expiretm":"0"
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'address');
                    const tag = this.safeString(depositAddress, 'tag');
                    currency = this.safeCurrency(undefined, currency);
                    const code = currency['code'];
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': depositAddress
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    if ('key' in params) {
                        await this.loadMarkets();
                        const currency = this.currency(code);
                        const request = {
                            'asset': currency['id'],
                            'amount': amount
                        };
                        const response = await this.privatePostWithdraw(this.extend(request, params));
                        //
                        //     {
                        //         "error": [],
                        //         "result": {
                        //             "refid": "AGBSO6T-UFMTTQ-I7KGS6"
                        //         }
                        //     }
                        //
                        const result = this.safeValue(response, 'result', {});
                        return this.parseTransaction(result, currency);
                    }
                    throw new ExchangeError1(this.id + " withdraw() requires a 'key' parameter (withdrawal key name, as set up on your account)");
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    const response = await this.privatePostOpenPositions(this.extend(request, params));
                    //
                    // no consolidation
                    //
                    //     {
                    //         error: [],
                    //         result: {
                    //             'TGUFMY-FLESJ-VYIX3J': {
                    //                 ordertxid: "O3LRNU-ZKDG5-XNCDFR",
                    //                 posstatus: "open",
                    //                 pair: "ETHUSDT",
                    //                 time:  1611557231.4584,
                    //                 type: "buy",
                    //                 ordertype: "market",
                    //                 cost: "28.49800",
                    //                 fee: "0.07979",
                    //                 vol: "0.02000000",
                    //                 vol_closed: "0.00000000",
                    //                 margin: "14.24900",
                    //                 terms: "0.0200% per 4 hours",
                    //                 rollovertm: "1611571631",
                    //                 misc: "",
                    //                 oflags: ""
                    //             }
                    //         }
                    //     }
                    //
                    // consolidation by market
                    //
                    //     {
                    //         error: [],
                    //         result: [
                    //             {
                    //                 pair: "ETHUSDT",
                    //                 positions: "1",
                    //                 type: "buy",
                    //                 leverage: "2.00000",
                    //                 cost: "28.49800",
                    //                 fee: "0.07979",
                    //                 vol: "0.02000000",
                    //                 vol_closed: "0.00000000",
                    //                 margin: "14.24900"
                    //             }
                    //         ]
                    //     }
                    //
                    const result = this.safeValue(response, 'result');
                    // todo unify parsePosition/parsePositions
                    return result;
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = '/' + this.version + '/' + api + '/' + path;
                    if (api === 'public') {
                        if (Object.keys(params).length) // urlencodeNested is used to address https://github.com/ccxt/ccxt/issues/12872
                        url += '?' + this.urlencodeNested(params);
                    } else if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        // urlencodeNested is used to address https://github.com/ccxt/ccxt/issues/12872
                        body = this.urlencodeNested(this.extend({
                            'nonce': nonce
                        }, params));
                        const auth = this.encode(nonce + body);
                        const hash = this.hash(auth, 'sha256', 'binary');
                        const binary = this.stringToBinary(this.encode(url));
                        const binhash = this.binaryConcat(binary, hash);
                        const secret = this.base64ToBinary(this.secret);
                        const signature = this.hmac(binhash, secret, 'sha512', 'base64');
                        headers = {
                            'API-Key': this.apiKey,
                            'API-Sign': signature,
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                    } else url = '/' + path;
                    url = this.urls['api'][api] + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (code === 520) throw new ExchangeNotAvailable(this.id + ' ' + code.toString() + ' ' + reason);
                    // todo: rewrite this for "broad" exceptions matching
                    if (body.indexOf('Invalid order') >= 0) throw new InvalidOrder(this.id + ' ' + body);
                    if (body.indexOf('Invalid nonce') >= 0) throw new InvalidNonce(this.id + ' ' + body);
                    if (body.indexOf('Insufficient funds') >= 0) throw new InsufficientFunds(this.id + ' ' + body);
                    if (body.indexOf('Cancel pending') >= 0) throw new CancelPending(this.id + ' ' + body);
                    if (body.indexOf('Invalid arguments:volume') >= 0) throw new InvalidOrder(this.id + ' ' + body);
                    if (body.indexOf('Rate limit exceeded') >= 0) throw new RateLimitExceeded(this.id + ' ' + body);
                    if (response === undefined) return;
                    if (body[0] === '{') {
                        if (typeof response !== 'string') {
                            if ('error' in response) {
                                const numErrors = response['error'].length;
                                if (numErrors) {
                                    const message = this.id + ' ' + body;
                                    for(let i = 0; i < response['error'].length; i++){
                                        const error = response['error'][i];
                                        this.throwExactlyMatchedException(this.exceptions, error, message);
                                    }
                                    throw new ExchangeError1(message);
                                }
                            }
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    96: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, AccountSuspended: AccountSuspended, InvalidNonce: InvalidNonce, NotSupported: NotSupported, BadRequest: BadRequest, AuthenticationError: AuthenticationError, BadSymbol: BadSymbol, RateLimitExceeded: RateLimitExceeded, PermissionDenied: PermissionDenied, InvalidAddress: InvalidAddress } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class kucoin extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'kucoin',
                        'name': 'KuCoin',
                        'countries': [
                            'SC'
                        ],
                        // note "only some endpoints are rate-limited"
                        // so I set the 'ratelimit' on those which supposedly 'arent ratelimited'
                        // to the limit of the cheapest endpoint
                        // 60 requests in 3 seconds = 20 requests per second => ( 1000ms / 20 ) = 50 ms between requests on average
                        'rateLimit': 50,
                        'version': 'v2',
                        'certified': false,
                        'pro': true,
                        'comment': 'Platform 2.0',
                        'quoteJsonNumbers': false,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRates': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingFee': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchL3OrderBook': true,
                            'fetchLedger': true,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrdersByStatus': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': false,
                            'fetchWithdrawals': true,
                            'transfer': true,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87295558-132aaf80-c50e-11ea-9801-a2fb0c57c799.jpg',
                            'referral': 'https://www.kucoin.com/?rcode=E5wkqe',
                            'api': {
                                'public': 'https://api.kucoin.com',
                                'private': 'https://api.kucoin.com',
                                'futuresPrivate': 'https://api-futures.kucoin.com',
                                'futuresPublic': 'https://api-futures.kucoin.com'
                            },
                            'test': {
                                'public': 'https://openapi-sandbox.kucoin.com',
                                'private': 'https://openapi-sandbox.kucoin.com',
                                'futuresPrivate': 'https://api-sandbox-futures.kucoin.com',
                                'futuresPublic': 'https://api-sandbox-futures.kucoin.com'
                            },
                            'www': 'https://www.kucoin.com',
                            'doc': [
                                'https://docs.kucoin.com'
                            ]
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'password': true
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'timestamp': 1,
                                    'status': 1,
                                    'symbols': 1,
                                    'markets': 1,
                                    'market/allTickers': 1,
                                    'market/orderbook/level{level}_{limit}': 1,
                                    'market/orderbook/level2_20': 1,
                                    'market/orderbook/level2_100': 1,
                                    'market/histories': 1,
                                    'market/candles': 1,
                                    'market/stats': 1,
                                    'currencies': 1,
                                    'currencies/{currency}': 1,
                                    'prices': 1,
                                    'mark-price/{symbol}/current': 1,
                                    'margin/config': 1
                                },
                                'post': {
                                    'bullet-public': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'market/orderbook/level{level}': 1,
                                    'market/orderbook/level2': {
                                        'v3': 2
                                    },
                                    'market/orderbook/level3': 1,
                                    'accounts': 1,
                                    'accounts/{accountId}': 1,
                                    // 'accounts/{accountId}/ledgers': 1, Deprecated endpoint
                                    'accounts/ledgers': 3.333,
                                    'accounts/{accountId}/holds': 1,
                                    'accounts/transferable': 1,
                                    'base-fee': 1,
                                    'sub/user': 1,
                                    'sub-accounts': 1,
                                    'sub-accounts/{subUserId}': 1,
                                    'deposit-addresses': 1,
                                    'deposits': 10,
                                    'hist-deposits': 10,
                                    'hist-orders': 1,
                                    'hist-withdrawals': 10,
                                    'withdrawals': 10,
                                    'withdrawals/quotas': 1,
                                    'orders': 2,
                                    'order/client-order/{clientOid}': 1,
                                    'orders/{orderId}': 1,
                                    'limit/orders': 1,
                                    'fills': 6.66667,
                                    'limit/fills': 1,
                                    'margin/account': 1,
                                    'margin/borrow': 1,
                                    'margin/borrow/outstanding': 1,
                                    'margin/borrow/borrow/repaid': 1,
                                    'margin/lend/active': 1,
                                    'margin/lend/done': 1,
                                    'margin/lend/trade/unsettled': 1,
                                    'margin/lend/trade/settled': 1,
                                    'margin/lend/assets': 1,
                                    'margin/market': 1,
                                    'margin/trade/last': 1,
                                    'stop-order/{orderId}': 1,
                                    'stop-order': 1,
                                    'stop-order/queryOrderByClientOid': 1,
                                    'trade-fees': 1.3333
                                },
                                'post': {
                                    'accounts': 1,
                                    'accounts/inner-transfer': {
                                        'v2': 1
                                    },
                                    'accounts/sub-transfer': {
                                        'v2': 25
                                    },
                                    'deposit-addresses': 1,
                                    'withdrawals': 1,
                                    'orders': 4,
                                    'orders/multi': 20,
                                    'margin/borrow': 1,
                                    'margin/order': 1,
                                    'margin/repay/all': 1,
                                    'margin/repay/single': 1,
                                    'margin/lend': 1,
                                    'margin/toggle-auto-lend': 1,
                                    'bullet-private': 1,
                                    'stop-order': 1
                                },
                                'delete': {
                                    'withdrawals/{withdrawalId}': 1,
                                    'orders': 20,
                                    'orders/client-order/{clientOid}': 1,
                                    'orders/{orderId}': 1,
                                    'margin/lend/{orderId}': 1,
                                    'stop-order/cancelOrderByClientOid': 1,
                                    'stop-order/{orderId}': 1,
                                    'stop-order/cancel': 1
                                }
                            },
                            'futuresPublic': {
                                // cheapest futures 'limited' endpoint is 40  requests per 3 seconds = 14.333 per second => cost = 20/14.333 = 1.3953
                                'get': {
                                    'contracts/active': 1.3953,
                                    'contracts/{symbol}': 1.3953,
                                    'ticker': 1.3953,
                                    'level2/snapshot': 2,
                                    'level2/depth20': 1.3953,
                                    'level2/depth100': 1.3953,
                                    'level2/message/query': 1.3953,
                                    'level3/message/query': 1.3953,
                                    'level3/snapshot': 1.3953,
                                    'trade/history': 1.3953,
                                    'interest/query': 1.3953,
                                    'index/query': 1.3953,
                                    'mark-price/{symbol}/current': 1.3953,
                                    'premium/query': 1.3953,
                                    'funding-rate/{symbol}/current': 1.3953,
                                    'timestamp': 1.3953,
                                    'status': 1.3953,
                                    'kline/query': 1.3953
                                },
                                'post': {
                                    'bullet-public': 1.3953
                                }
                            },
                            'futuresPrivate': {
                                'get': {
                                    'account-overview': 2,
                                    'transaction-history': 6.666,
                                    'deposit-address': 1.3953,
                                    'deposit-list': 1.3953,
                                    'withdrawals/quotas': 1.3953,
                                    'withdrawal-list': 1.3953,
                                    'transfer-list': 1.3953,
                                    'orders': 1.3953,
                                    'stopOrders': 1.3953,
                                    'recentDoneOrders': 1.3953,
                                    'orders/{order-id}': 1.3953,
                                    'orders/byClientOid': 1.3953,
                                    'fills': 6.666,
                                    'recentFills': 6.666,
                                    'openOrderStatistics': 1.3953,
                                    'position': 1.3953,
                                    'positions': 6.666,
                                    'funding-history': 6.666
                                },
                                'post': {
                                    'withdrawals': 1.3953,
                                    'transfer-out': 1.3953,
                                    'orders': 1.3953,
                                    'position/margin/auto-deposit-status': 1.3953,
                                    'position/margin/deposit-margin': 1.3953,
                                    'bullet-private': 1.3953
                                },
                                'delete': {
                                    'withdrawals/{withdrawalId}': 1.3953,
                                    'cancel/transfer-out': 1.3953,
                                    'orders/{order-id}': 1.3953,
                                    'orders': 6.666,
                                    'stopOrders': 1.3953
                                }
                            }
                        },
                        'timeframes': {
                            '1m': '1min',
                            '3m': '3min',
                            '5m': '5min',
                            '15m': '15min',
                            '30m': '30min',
                            '1h': '1hour',
                            '2h': '2hour',
                            '4h': '4hour',
                            '6h': '6hour',
                            '8h': '8hour',
                            '12h': '12hour',
                            '1d': '1day',
                            '1w': '1week'
                        },
                        'exceptions': {
                            'exact': {
                                'order not exist': OrderNotFound,
                                'order not exist.': OrderNotFound,
                                'order_not_exist': OrderNotFound,
                                'order_not_exist_or_not_allow_to_cancel': InvalidOrder,
                                'Order size below the minimum requirement.': InvalidOrder,
                                'The withdrawal amount is below the minimum requirement.': ExchangeError1,
                                'Unsuccessful! Exceeded the max. funds out-transfer limit': InsufficientFunds,
                                '400': BadRequest,
                                '401': AuthenticationError,
                                '403': NotSupported,
                                '404': NotSupported,
                                '405': NotSupported,
                                '429': RateLimitExceeded,
                                '500': ExchangeNotAvailable,
                                '503': ExchangeNotAvailable,
                                '101030': PermissionDenied,
                                '200004': InsufficientFunds,
                                '230003': InsufficientFunds,
                                '260100': InsufficientFunds,
                                '300000': InvalidOrder,
                                '400000': BadSymbol,
                                '400001': AuthenticationError,
                                '400002': InvalidNonce,
                                '400003': AuthenticationError,
                                '400004': AuthenticationError,
                                '400005': AuthenticationError,
                                '400006': AuthenticationError,
                                '400007': AuthenticationError,
                                '400008': NotSupported,
                                '400100': BadRequest,
                                '400200': InvalidOrder,
                                '400350': InvalidOrder,
                                '400370': InvalidOrder,
                                '400500': InvalidOrder,
                                '400600': BadSymbol,
                                '400760': InvalidOrder,
                                '401000': BadRequest,
                                '411100': AccountSuspended,
                                '415000': BadRequest,
                                '500000': ExchangeNotAvailable,
                                '260220': InvalidAddress
                            },
                            'broad': {
                                'Exceeded the access frequency': RateLimitExceeded,
                                'require more permission': PermissionDenied
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.001'),
                                'maker': this.parseNumber('0.001'),
                                'tiers': {
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.001')
                                        ],
                                        [
                                            this.parseNumber('50'),
                                            this.parseNumber('0.001')
                                        ],
                                        [
                                            this.parseNumber('200'),
                                            this.parseNumber('0.0009')
                                        ],
                                        [
                                            this.parseNumber('500'),
                                            this.parseNumber('0.0008')
                                        ],
                                        [
                                            this.parseNumber('1000'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('2000'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('4000'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('8000'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('15000'),
                                            this.parseNumber('0.00045')
                                        ],
                                        [
                                            this.parseNumber('25000'),
                                            this.parseNumber('0.0004')
                                        ],
                                        [
                                            this.parseNumber('40000'),
                                            this.parseNumber('0.00035')
                                        ],
                                        [
                                            this.parseNumber('60000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('80000'),
                                            this.parseNumber('0.00025')
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.001')
                                        ],
                                        [
                                            this.parseNumber('50'),
                                            this.parseNumber('0.0009')
                                        ],
                                        [
                                            this.parseNumber('200'),
                                            this.parseNumber('0.0007')
                                        ],
                                        [
                                            this.parseNumber('500'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('1000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('2000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('4000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('8000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('15000'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('25000'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('40000'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('60000'),
                                            this.parseNumber('-0.00005')
                                        ],
                                        [
                                            this.parseNumber('80000'),
                                            this.parseNumber('-0.00005')
                                        ]
                                    ]
                                }
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false,
                                'withdraw': {},
                                'deposit': {}
                            }
                        },
                        'commonCurrencies': {
                            'HOT': 'HOTNOW',
                            'EDGE': 'DADI',
                            'WAX': 'WAXP',
                            'TRY': 'Trias',
                            'VAI': 'VAIOT'
                        },
                        'options': {
                            'version': 'v1',
                            'symbolSeparator': '-',
                            'fetchMyTradesMethod': 'private_get_fills',
                            'fetchBalance': 'trade',
                            'fetchMarkets': {
                                'fetchTickersFees': true
                            },
                            // endpoint versions
                            'versions': {
                                'public': {
                                    'GET': {
                                        'currencies/{currency}': 'v2',
                                        'status': 'v1',
                                        'market/orderbook/level2_20': 'v1',
                                        'market/orderbook/level2_100': 'v1',
                                        'market/orderbook/level{level}_{limit}': 'v1'
                                    }
                                },
                                'private': {
                                    'GET': {
                                        'market/orderbook/level2': 'v3',
                                        'market/orderbook/level3': 'v3',
                                        'market/orderbook/level{level}': 'v3'
                                    },
                                    'POST': {
                                        'accounts/inner-transfer': 'v2',
                                        'accounts/sub-transfer': 'v2'
                                    }
                                },
                                'futuresPrivate': {
                                    'GET': {
                                        'account-overview': 'v1',
                                        'positions': 'v1'
                                    },
                                    'POST': {
                                        'transfer-out': 'v2'
                                    }
                                },
                                'futuresPublic': {
                                    'GET': {
                                        'level3/snapshot': 'v2'
                                    }
                                }
                            },
                            'accountsByType': {
                                'spot': 'trade',
                                'margin': 'margin',
                                'main': 'main',
                                'funding': 'main',
                                'future': 'contract',
                                'mining': 'pool'
                            },
                            'networks': {
                                'ETH': 'eth',
                                'ERC20': 'eth',
                                'TRX': 'trx',
                                'TRC20': 'trx',
                                'KCC': 'kcc',
                                'TERRA': 'luna'
                            }
                        }
                    });
                }
                nonce() {
                    return this.milliseconds();
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTimestamp(params);
                    //
                    //     {
                    //         "code":"200000",
                    //         "msg":"success",
                    //         "data":1546837113087
                    //     }
                    //
                    return this.safeInteger(response, 'data');
                }
                async fetchStatus(params = {}) {
                    const response = await this.publicGetStatus(params);
                    //
                    //     {
                    //         "code":"200000",
                    //         "data":{
                    //             "status":"open", //open, close, cancelonly
                    //             "msg":"upgrade match engine" //remark for operation
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const status = this.safeString(data, 'status');
                    return {
                        'status': status === 'open' ? 'ok' : 'maintenance',
                        'updated': this.milliseconds(),
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetSymbols(params);
                    //
                    //     {
                    //         "code": "200000",
                    //         "data": [
                    //             {
                    //                 "symbol": "XLM-USDT",
                    //                 "name": "XLM-USDT",
                    //                 "baseCurrency": "XLM",
                    //                 "quoteCurrency": "USDT",
                    //                 "feeCurrency": "USDT",
                    //                 "market": "USDS",
                    //                 "baseMinSize": "0.1",
                    //                 "quoteMinSize": "0.01",
                    //                 "baseMaxSize": "10000000000",
                    //                 "quoteMaxSize": "99999999",
                    //                 "baseIncrement": "0.0001",
                    //                 "quoteIncrement": "0.000001",
                    //                 "priceIncrement": "0.000001",
                    //                 "priceLimitRate": "0.1",
                    //                 "isMarginEnabled": true,
                    //                 "enableTrading": true
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const options = this.safeValue(this.options, 'fetchMarkets', {});
                    const fetchTickersFees = this.safeValue(options, 'fetchTickersFees', true);
                    let tickersResponse = {};
                    if (fetchTickersFees) tickersResponse = await this.publicGetMarketAllTickers(params);
                    //
                    //     {
                    //         "code": "200000",
                    //         "data": {
                    //             "time":1602832092060,
                    //             "ticker":[
                    //                 {
                    //                     "symbol": "BTC-USDT",   // symbol
                    //                     "symbolName":"BTC-USDT", // Name of trading pairs, it would change after renaming
                    //                     "buy": "11328.9",   // bestAsk
                    //                     "sell": "11329",    // bestBid
                    //                     "changeRate": "-0.0055",    // 24h change rate
                    //                     "changePrice": "-63.6", // 24h change price
                    //                     "high": "11610",    // 24h highest price
                    //                     "low": "11200", // 24h lowest price
                    //                     "vol": "2282.70993217", // 24h volume，the aggregated trading volume in BTC
                    //                     "volValue": "25984946.157790431",   // 24h total, the trading volume in quote currency of last 24 hours
                    //                     "last": "11328.9",  // last price
                    //                     "averagePrice": "11360.66065903",   // 24h average transaction price yesterday
                    //                     "takerFeeRate": "0.001",    // Basic Taker Fee
                    //                     "makerFeeRate": "0.001",    // Basic Maker Fee
                    //                     "takerCoefficient": "1",    // Taker Fee Coefficient
                    //                     "makerCoefficient": "1" // Maker Fee Coefficient
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const tickersData = this.safeValue(tickersResponse, 'data', {});
                    const tickers = this.safeValue(tickersData, 'ticker', []);
                    const tickersByMarketId = this.indexBy(tickers, 'symbol');
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const id = this.safeString(market, 'symbol');
                        const [baseId, quoteId] = id.split('-');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const baseMaxSize = this.safeNumber(market, 'baseMaxSize');
                        const baseMinSizeString = this.safeString(market, 'baseMinSize');
                        const quoteMaxSizeString = this.safeString(market, 'quoteMaxSize');
                        const baseMinSize = this.parseNumber(baseMinSizeString);
                        const quoteMaxSize = this.parseNumber(quoteMaxSizeString);
                        const quoteMinSize = this.safeNumber(market, 'quoteMinSize');
                        // const quoteIncrement = this.safeNumber (market, 'quoteIncrement');
                        const ticker = this.safeValue(tickersByMarketId, id, {});
                        const makerFeeRate = this.safeString(ticker, 'makerFeeRate');
                        const takerFeeRate = this.safeString(ticker, 'makerFeeRate');
                        const makerCoefficient = this.safeString(ticker, 'makerCoefficient');
                        const takerCoefficient = this.safeString(ticker, 'takerCoefficient');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': this.safeValue(market, 'isMarginEnabled'),
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': this.safeValue(market, 'enableTrading'),
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.parseNumber(Precise.stringMul(takerFeeRate, takerCoefficient)),
                            'maker': this.parseNumber(Precise.stringMul(makerFeeRate, makerCoefficient)),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.precisionFromString(this.safeString(market, 'baseIncrement')),
                                'price': this.precisionFromString(this.safeString(market, 'priceIncrement'))
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': baseMinSize,
                                    'max': baseMaxSize
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': quoteMinSize,
                                    'max': quoteMaxSize
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     {
                    //         "currency": "OMG",
                    //         "name": "OMG",
                    //         "fullName": "OmiseGO",
                    //         "precision": 8,
                    //         "confirms": 12,
                    //         "withdrawalMinSize": "4",
                    //         "withdrawalMinFee": "1.25",
                    //         "isWithdrawEnabled": false,
                    //         "isDepositEnabled": false,
                    //         "isMarginEnabled": false,
                    //         "isDebitEnabled": false
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = {};
                    for(let i = 0; i < data.length; i++){
                        const entry = data[i];
                        const id = this.safeString(entry, 'currency');
                        const name = this.safeString(entry, 'fullName');
                        const code = this.safeCurrencyCode(id);
                        const precision = this.safeInteger(entry, 'precision');
                        const isWithdrawEnabled = this.safeValue(entry, 'isWithdrawEnabled', false);
                        const isDepositEnabled = this.safeValue(entry, 'isDepositEnabled', false);
                        const fee = this.safeNumber(entry, 'withdrawalMinFee');
                        const active = isWithdrawEnabled && isDepositEnabled;
                        result[code] = {
                            'id': id,
                            'name': name,
                            'code': code,
                            'precision': precision,
                            'info': entry,
                            'active': active,
                            'deposit': isDepositEnabled,
                            'withdraw': isWithdrawEnabled,
                            'fee': fee,
                            'limits': this.limits
                        };
                    }
                    return result;
                }
                async fetchAccounts(params = {}) {
                    const response = await this.privateGetAccounts(params);
                    //
                    //     {
                    //         code: "200000",
                    //         data: [
                    //             {
                    //                 balance: "0.00009788",
                    //                 available: "0.00009788",
                    //                 holds: "0",
                    //                 currency: "BTC",
                    //                 id: "5c6a4fd399a1d81c4f9cc4d0",
                    //                 type: "trade"
                    //             },
                    //             {
                    //                 balance: "0.00000001",
                    //                 available: "0.00000001",
                    //                 holds: "0",
                    //                 currency: "ETH",
                    //                 id: "5c6a49ec99a1d819392e8e9f",
                    //                 type: "trade"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const account = data[i];
                        const accountId = this.safeString(account, 'id');
                        const currencyId = this.safeString(account, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const type = this.safeString(account, 'type'); // main or trade
                        result.push({
                            'id': accountId,
                            'type': type,
                            'currency': code,
                            'info': account
                        });
                    }
                    return result;
                }
                async fetchFundingFee(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateGetWithdrawalsQuotas(this.extend(request, params));
                    const data = response['data'];
                    const withdrawFees = {};
                    withdrawFees[code] = this.safeNumber(data, 'withdrawMinFee');
                    return {
                        'info': response,
                        'withdraw': withdrawFees,
                        'deposit': {}
                    };
                }
                isFuturesMethod(methodName, params) {
                    //
                    // Helper
                    // @methodName (string): The name of the method
                    // @params (dict): The parameters passed into {methodName}
                    // @return: true if the method used is meant for futures trading, false otherwise
                    //
                    const defaultType = this.safeString2(this.options, methodName, 'defaultType', 'trade');
                    const requestedType = this.safeString(params, 'type', defaultType);
                    const accountsByType = this.safeValue(this.options, 'accountsByType');
                    const type = this.safeString(accountsByType, requestedType);
                    if (type === undefined) {
                        const keys = Object.keys(accountsByType);
                        throw new ExchangeError1(this.id + ' isFuturesMethod() type must be one of ' + keys.join(', '));
                    }
                    params = this.omit(params, 'type');
                    return type === 'contract' || type === 'future' || type === 'futures'; // * (type === 'futures') deprecated, use (type === 'future')
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "symbol": "BTC-USDT",   // symbol
                    //         "symbolName":"BTC-USDT", // Name of trading pairs, it would change after renaming
                    //         "buy": "11328.9",   // bestAsk
                    //         "sell": "11329",    // bestBid
                    //         "changeRate": "-0.0055",    // 24h change rate
                    //         "changePrice": "-63.6", // 24h change price
                    //         "high": "11610",    // 24h highest price
                    //         "low": "11200", // 24h lowest price
                    //         "vol": "2282.70993217", // 24h volume，the aggregated trading volume in BTC
                    //         "volValue": "25984946.157790431",   // 24h total, the trading volume in quote currency of last 24 hours
                    //         "last": "11328.9",  // last price
                    //         "averagePrice": "11360.66065903",   // 24h average transaction price yesterday
                    //         "takerFeeRate": "0.001",    // Basic Taker Fee
                    //         "makerFeeRate": "0.001",    // Basic Maker Fee
                    //         "takerCoefficient": "1",    // Taker Fee Coefficient
                    //         "makerCoefficient": "1" // Maker Fee Coefficient
                    //     }
                    //
                    //     {
                    //         "trading": true,
                    //         "symbol": "KCS-BTC",
                    //         "buy": 0.00011,
                    //         "sell": 0.00012,
                    //         "sort": 100,
                    //         "volValue": 3.13851792584,   //total
                    //         "baseCurrency": "KCS",
                    //         "market": "BTC",
                    //         "quoteCurrency": "BTC",
                    //         "symbolCode": "KCS-BTC",
                    //         "datetime": 1548388122031,
                    //         "high": 0.00013,
                    //         "vol": 27514.34842,
                    //         "low": 0.0001,
                    //         "changePrice": -1.0e-5,
                    //         "changeRate": -0.0769,
                    //         "lastTradedPrice": 0.00012,
                    //         "board": 0,
                    //         "mark": 0
                    //     }
                    //
                    // market/ticker ws subscription
                    //
                    //     {
                    //         bestAsk: '62258.9',
                    //         bestAskSize: '0.38579986',
                    //         bestBid: '62258.8',
                    //         bestBidSize: '0.0078381',
                    //         price: '62260.7',
                    //         sequence: '1621383297064',
                    //         size: '0.00002841',
                    //         time: 1634641777363
                    //     }
                    //
                    let percentage = this.safeString(ticker, 'changeRate');
                    if (percentage !== undefined) percentage = Precise.stringMul(percentage, '100');
                    let last = this.safeString2(ticker, 'last', 'lastTradedPrice');
                    last = this.safeString(ticker, 'price', last);
                    const marketId = this.safeString(ticker, 'symbol');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    const baseVolume = this.safeString(ticker, 'vol');
                    const quoteVolume = this.safeString(ticker, 'volValue');
                    const timestamp = this.safeInteger2(ticker, 'time', 'datetime');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString2(ticker, 'buy', 'bestBid'),
                        'bidVolume': this.safeString(ticker, 'bestBidSize'),
                        'ask': this.safeString2(ticker, 'sell', 'bestAsk'),
                        'askVolume': this.safeString(ticker, 'bestAskSize'),
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': this.safeString(ticker, 'changePrice'),
                        'percentage': percentage,
                        'average': this.safeString(ticker, 'averagePrice'),
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetMarketAllTickers(params);
                    //
                    //     {
                    //         "code": "200000",
                    //         "data": {
                    //             "time":1602832092060,
                    //             "ticker":[
                    //                 {
                    //                     "symbol": "BTC-USDT",   // symbol
                    //                     "symbolName":"BTC-USDT", // Name of trading pairs, it would change after renaming
                    //                     "buy": "11328.9",   // bestAsk
                    //                     "sell": "11329",    // bestBid
                    //                     "changeRate": "-0.0055",    // 24h change rate
                    //                     "changePrice": "-63.6", // 24h change price
                    //                     "high": "11610",    // 24h highest price
                    //                     "low": "11200", // 24h lowest price
                    //                     "vol": "2282.70993217", // 24h volume，the aggregated trading volume in BTC
                    //                     "volValue": "25984946.157790431",   // 24h total, the trading volume in quote currency of last 24 hours
                    //                     "last": "11328.9",  // last price
                    //                     "averagePrice": "11360.66065903",   // 24h average transaction price yesterday
                    //                     "takerFeeRate": "0.001",    // Basic Taker Fee
                    //                     "makerFeeRate": "0.001",    // Basic Maker Fee
                    //                     "takerCoefficient": "1",    // Taker Fee Coefficient
                    //                     "makerCoefficient": "1" // Maker Fee Coefficient
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const tickers = this.safeValue(data, 'ticker', []);
                    const time = this.safeInteger(data, 'time');
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        tickers[i]['time'] = time;
                        const ticker = this.parseTicker(tickers[i]);
                        const symbol = this.safeString(ticker, 'symbol');
                        if (symbol !== undefined) result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetMarketStats(this.extend(request, params));
                    //
                    //     {
                    //         "code": "200000",
                    //         "data": {
                    //             "time": 1602832092060,  // time
                    //             "symbol": "BTC-USDT",   // symbol
                    //             "buy": "11328.9",   // bestAsk
                    //             "sell": "11329",    // bestBid
                    //             "changeRate": "-0.0055",    // 24h change rate
                    //             "changePrice": "-63.6", // 24h change price
                    //             "high": "11610",    // 24h highest price
                    //             "low": "11200", // 24h lowest price
                    //             "vol": "2282.70993217", // 24h volume，the aggregated trading volume in BTC
                    //             "volValue": "25984946.157790431",   // 24h total, the trading volume in quote currency of last 24 hours
                    //             "last": "11328.9",  // last price
                    //             "averagePrice": "11360.66065903",   // 24h average transaction price yesterday
                    //             "takerFeeRate": "0.001",    // Basic Taker Fee
                    //             "makerFeeRate": "0.001",    // Basic Maker Fee
                    //             "takerCoefficient": "1",    // Taker Fee Coefficient
                    //             "makerCoefficient": "1" // Maker Fee Coefficient
                    //         }
                    //     }
                    //
                    return this.parseTicker(response['data'], market);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         "1545904980",             // Start time of the candle cycle
                    //         "0.058",                  // opening price
                    //         "0.049",                  // closing price
                    //         "0.058",                  // highest price
                    //         "0.049",                  // lowest price
                    //         "0.018",                  // base volume
                    //         "0.000945",               // quote volume
                    //     ]
                    //
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '15m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const marketId = market['id'];
                    const request = {
                        'symbol': marketId,
                        'type': this.timeframes[timeframe]
                    };
                    const duration = this.parseTimeframe(timeframe) * 1000;
                    let endAt = this.milliseconds(); // required param
                    if (since !== undefined) {
                        request['startAt'] = parseInt(Math.floor(since / 1000));
                        if (limit === undefined) // https://docs.kucoin.com/#get-klines
                        // https://docs.kucoin.com/#details
                        // For each query, the system would return at most 1500 pieces of data.
                        // To obtain more data, please page the data by time.
                        limit = this.safeInteger(this.options, 'fetchOHLCVLimit', 1500);
                        endAt = this.sum(since, limit * duration);
                    } else if (limit !== undefined) {
                        since = endAt - limit * duration;
                        request['startAt'] = parseInt(Math.floor(since / 1000));
                    }
                    request['endAt'] = parseInt(Math.floor(endAt / 1000));
                    const response = await this.publicGetMarketCandles(this.extend(request, params));
                    //
                    //     {
                    //         "code":"200000",
                    //         "data":[
                    //             ["1591517700","0.025078","0.025069","0.025084","0.025064","18.9883256","0.4761861079404"],
                    //             ["1591516800","0.025089","0.025079","0.025089","0.02506","99.4716622","2.494143499081"],
                    //             ["1591515900","0.025079","0.02509","0.025091","0.025068","59.83701271","1.50060885172798"],
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privatePostDepositAddresses(this.extend(request, params));
                    // BCH {"code":"200000","data":{"address":"bitcoincash:qza3m4nj9rx7l9r0cdadfqxts6f92shvhvr5ls4q7z","memo":""}}
                    // BTC {"code":"200000","data":{"address":"36SjucKqQpQSvsak9A7h6qzFjrVXpRNZhE","memo":""}}
                    const data = this.safeValue(response, 'data', {});
                    let address = this.safeString(data, 'address');
                    // BCH/BSV is returned with a "bitcoincash:" prefix, which we cut off here and only keep the address
                    if (address !== undefined) address = address.replace('bitcoincash:', '');
                    const tag = this.safeString(data, 'memo');
                    if (code !== 'NIM') // contains spaces
                    this.checkAddress(address);
                    return {
                        'info': response,
                        'currency': code,
                        'network': this.safeString(data, 'chain'),
                        'address': address,
                        'tag': tag
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    // same as for withdraw
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeStringLower(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['chain'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privateGetDepositAddresses(this.extend(request, params));
                    // BCH {"code":"200000","data":{"address":"bitcoincash:qza3m4nj9rx7l9r0cdadfqxts6f92shvhvr5ls4q7z","memo":""}}
                    // BTC {"code":"200000","data":{"address":"36SjucKqQpQSvsak9A7h6qzFjrVXpRNZhE","memo":""}}
                    const data = this.safeValue(response, 'data', {});
                    const address = this.safeString(data, 'address');
                    let tag = this.safeString(data, 'memo');
                    if (tag === '') tag = undefined;
                    if (code !== 'NIM') // contains spaces
                    this.checkAddress(address);
                    return {
                        'info': response,
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': network
                    };
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const marketId = this.marketId(symbol);
                    const level = this.safeInteger(params, 'level', 2);
                    const request = {
                        'symbol': marketId
                    };
                    let method = 'publicGetMarketOrderbookLevelLevelLimit';
                    const isAuthenticated = this.checkRequiredCredentials(false);
                    let response = undefined;
                    if (!isAuthenticated) {
                        if (level === 2) {
                            request['level'] = level;
                            if (limit !== undefined) {
                                if (limit === 20 || limit === 100) request['limit'] = limit;
                                else throw new ExchangeError1(this.id + ' fetchOrderBook() limit argument must be 20 or 100');
                            }
                            request['limit'] = limit ? limit : 100;
                            method = 'publicGetMarketOrderbookLevelLevelLimit';
                            response = await this[method](this.extend(request, params));
                        }
                    } else {
                        method = 'privateGetMarketOrderbookLevel2'; // recommended (v3)
                        response = await this[method](this.extend(request, params));
                    }
                    //
                    // public (v1) market/orderbook/level2_20 and market/orderbook/level2_100
                    //
                    //     {
                    //         "sequence": "3262786978",
                    //         "time": 1550653727731,
                    //         "bids": [
                    //             ["6500.12", "0.45054140"],
                    //             ["6500.11", "0.45054140"],
                    //         ],
                    //         "asks": [
                    //             ["6500.16", "0.57753524"],
                    //             ["6500.15", "0.57753524"],
                    //         ]
                    //     }
                    //
                    // private (v3) market/orderbook/level2
                    //
                    //     {
                    //         "sequence": "3262786978",
                    //         "time": 1550653727731,
                    //         "bids": [
                    //             ["6500.12", "0.45054140"],
                    //             ["6500.11", "0.45054140"],
                    //         ],
                    //         "asks": [
                    //             ["6500.16", "0.57753524"],
                    //             ["6500.15", "0.57753524"],
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const timestamp = this.safeInteger(data, 'time');
                    const orderbook = this.parseOrderBook(data, symbol, timestamp, 'bids', 'asks', level - 2, level - 1);
                    orderbook['nonce'] = this.safeInteger(data, 'sequence');
                    return orderbook;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    /**
         * @method
         * @name kucoin#createOrder
         * @description Create an order on the exchange
         * @param {str} symbol Unified CCXT market symbol
         * @param {str} type "limit" or "market"
         * @param {str} side "buy" or "sell"
         * @param {float} amount the amount of currency to trade
         * @param {float} price *ignored in "market" orders* the price at which the order is to be fullfilled at in units of the quote currency
         * @param {dict} params  Extra parameters specific to the exchange API endpoint
         * @param {str} params.clientOid client order id, defaults to uuid if not passed
         * @param {str} params.remark remark for the order, length cannot exceed 100 utf8 characters
         * @param {str} params.tradeType 'TRADE', // TRADE, MARGIN_TRADE // not used with margin orders
         * limit orders ---------------------------------------------------
         * @param {str} params.timeInForce GTC, GTT, IOC, or FOK, default is GTC, limit orders only
         * @param {float} params.cancelAfter long, // cancel after n seconds, requires timeInForce to be GTT
         * @param {str} params.postOnly Post only flag, invalid when timeInForce is IOC or FOK
         * @param {bool} params.hidden false, // Order will not be displayed in the order book
         * @param {bool} params.iceberg false, // Only a portion of the order is displayed in the order book
         * @param {str} params.visibleSize this.amountToPrecision (symbol, visibleSize), // The maximum visible size of an iceberg order
         * market orders --------------------------------------------------
         * @param {str} params.funds // Amount of quote currency to use
         * stop orders ----------------------------------------------------
         * @param {str} params.stop  Either loss or entry, the default is loss. Requires stopPrice to be defined
         * @param {float} params.stopPrice The price at which a trigger order is triggered at
         * margin orders --------------------------------------------------
         * @param {float} params.leverage Leverage size of the order
         * @param {str} params.stp '', // self trade prevention, CN, CO, CB or DC
         * @param {str} params.marginMode 'cross', // cross (cross mode) and isolated (isolated mode), set to cross by default, the isolated mode will be released soon, stay tuned
         * @param {bool} params.autoBorrow false, // The system will first borrow you funds at the optimal interest rate and then place an order for you
         * @returns an [order structure]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ await this.loadMarkets();
                    const marketId = this.marketId(symbol);
                    // required param, cannot be used twice
                    const clientOrderId = this.safeString2(params, 'clientOid', 'clientOrderId', this.uuid());
                    params = this.omit(params, [
                        'clientOid',
                        'clientOrderId'
                    ]);
                    const request = {
                        'clientOid': clientOrderId,
                        'side': side,
                        'symbol': marketId,
                        'type': type
                    };
                    const quoteAmount = this.safeNumber2(params, 'cost', 'funds');
                    let amountString = undefined;
                    let costString = undefined;
                    if (type === 'market') {
                        if (quoteAmount !== undefined) {
                            params = this.omit(params, [
                                'cost',
                                'funds'
                            ]);
                            // kucoin uses base precision even for quote values
                            costString = this.amountToPrecision(symbol, quoteAmount);
                            request['funds'] = costString;
                        } else {
                            amountString = this.amountToPrecision(symbol, amount);
                            request['size'] = this.amountToPrecision(symbol, amount);
                        }
                    } else {
                        amountString = this.amountToPrecision(symbol, amount);
                        request['size'] = amountString;
                        request['price'] = this.priceToPrecision(symbol, price);
                    }
                    const stopPrice = this.safeString(params, 'stopPrice');
                    const tradeType = this.safeString(params, 'tradeType');
                    params = this.omit(params, 'stopPrice');
                    let method = 'privatePostOrders';
                    if (stopPrice !== undefined) {
                        request['stopPrice'] = this.priceToPrecision(symbol, stopPrice);
                        request['stop'] = 'loss';
                        method = 'privatePostStopOrder';
                    } else if (tradeType === 'MARGIN_TRADE') method = 'privatePostMarginOrder';
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         code: '200000',
                    //         data: {
                    //             "orderId": "5bd6e9286d99522a52e458de"
                    //         }
                    //    }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const timestamp = this.milliseconds();
                    const id = this.safeString(data, 'orderId');
                    const order = {
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'info': data,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'price': price,
                        'amount': this.parseNumber(amountString),
                        'cost': this.parseNumber(costString),
                        'average': undefined,
                        'filled': undefined,
                        'remaining': undefined,
                        'status': undefined,
                        'fee': undefined,
                        'trades': undefined
                    };
                    return order;
                }
                async cancelOrder(id, symbol, params = {}) {
                    /**
         * @method
         * @name kucoin#cancelOrder
         * @description Cancels an order
         * @param {str} id Order id
         * @param {str} symbol Not used by kucoin
         * @param {dict} params Exchange specific parameters
         * @param {bool} params.stop True if cancelling a stop order
         * @returns Response fromt the exchange
         */ await this.loadMarkets();
                    const request = {};
                    const clientOrderId = this.safeString2(params, 'clientOid', 'clientOrderId');
                    const stop = this.safeValue(params, 'stop');
                    let method = 'privateDeleteOrdersOrderId';
                    if (clientOrderId !== undefined) {
                        request['clientOid'] = clientOrderId;
                        if (stop) method = 'privateDeleteStopOrderCancelOrderByClientOid';
                        else method = 'privateDeleteOrdersClientOrderClientOid';
                    } else {
                        if (stop) method = 'privateDeleteStopOrderOrderId';
                        request['orderId'] = id;
                    }
                    params = this.omit(params, [
                        'clientOid',
                        'clientOrderId',
                        'stop'
                    ]);
                    return await this[method](this.extend(request, params));
                }
                async cancelAllOrders(symbol, params = {}) {
                    /**
         * @method
         * @name kucoin#cancelAllOrders
         * @description Cancels all open orders, or cancels all orders in a market for one symbol, stop orders must be cancelled separately
         * @param {str} symbol Unified symbol indicating the market to cancel orders in
         * @param {dict} params Exchange specific parameters
         * @param {bool} params.stop true if cancelling all stop orders
         * @param {str} params.tradeType The type of trading, "TRADE" for Spot Trading, "MARGIN_TRADE" for Margin Trading
         * @param {str} params.orderIds *stop orders only* Comma seperated order IDs
         * @returns Response from the exchange
         */ await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    let method = 'privateDeleteOrders';
                    const stop = this.safeValue(params, 'stop');
                    if (stop) method = 'privateDeleteStopOrderCancel';
                    return await this[method](this.extend(request, params));
                }
                async fetchOrdersByStatus(status, symbol, since, limit, params = {}) {
                    /**
         * @method
         * @name kucoin#fetchOrdersByStatus
         * @description fetch a list of orders
         * @param {str} status *not used for stop orders* 'open' or 'closed'
         * @param {str} symbol unified market symbol
         * @param {int} since timestamp in ms of the earliest order
         * @param {int} limit max number of orders to return
         * @param {dict} params exchange specific params
         * @param {int} params.till end time in ms
         * @param {bool} params.stop true if fetching stop orders
         * @param {str} params.side buy or sell
         * @param {str} params.type limit, market, limit_stop or market_stop
         * @param {str} params.tradeType TRADE for spot trading, MARGIN_TRADE for Margin Trading
         * @param {int} params.currentPage *stop orders only* current page
         * @param {str} params.orderIds *stop orders only* comma seperated order ID list
         * @returns An [array of order structures]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ await this.loadMarkets();
                    let lowercaseStatus = status.toLowerCase();
                    if (lowercaseStatus === 'open') lowercaseStatus = 'active';
                    else if (lowercaseStatus === 'closed') lowercaseStatus = 'done';
                    const request = {
                        'status': lowercaseStatus
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['startAt'] = since;
                    if (limit !== undefined) request['pageSize'] = limit;
                    const till = this.safeInteger(params, 'till');
                    if (till) request['endAt'] = till;
                    const stop = this.safeValue(params, 'stop');
                    params = this.omit(params, 'stop');
                    let method = 'privateGetOrders';
                    if (stop) method = 'privateGetStopOrder';
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         code: '200000',
                    //         data: {
                    //             "currentPage": 1,
                    //             "pageSize": 1,
                    //             "totalNum": 153408,
                    //             "totalPage": 153408,
                    //             "items": [
                    //                 {
                    //                     "id": "5c35c02703aa673ceec2a168",   //orderid
                    //                     "symbol": "BTC-USDT",   //symbol
                    //                     "opType": "DEAL",      // operation type,deal is pending order,cancel is cancel order
                    //                     "type": "limit",       // order type,e.g. limit,markrt,stop_limit.
                    //                     "side": "buy",         // transaction direction,include buy and sell
                    //                     "price": "10",         // order price
                    //                     "size": "2",           // order quantity
                    //                     "funds": "0",          // order funds
                    //                     "dealFunds": "0.166",  // deal funds
                    //                     "dealSize": "2",       // deal quantity
                    //                     "fee": "0",            // fee
                    //                     "feeCurrency": "USDT", // charge fee currency
                    //                     "stp": "",             // self trade prevention,include CN,CO,DC,CB
                    //                     "stop": "",            // stop type
                    //                     "stopTriggered": false,  // stop order is triggered
                    //                     "stopPrice": "0",      // stop price
                    //                     "timeInForce": "GTC",  // time InForce,include GTC,GTT,IOC,FOK
                    //                     "postOnly": false,     // postOnly
                    //                     "hidden": false,       // hidden order
                    //                     "iceberg": false,      // iceberg order
                    //                     "visibleSize": "0",    // display quantity for iceberg order
                    //                     "cancelAfter": 0,      // cancel orders time，requires timeInForce to be GTT
                    //                     "channel": "IOS",      // order source
                    //                     "clientOid": "",       // user-entered order unique mark
                    //                     "remark": "",          // remark
                    //                     "tags": "",            // tag order source
                    //                     "isActive": false,     // status before unfilled or uncancelled
                    //                     "cancelExist": false,   // order cancellation transaction record
                    //                     "createdAt": 1547026471000  // time
                    //                 },
                    //             ]
                    //         }
                    //    }
                    const responseData = this.safeValue(response, 'data', {});
                    const orders = this.safeValue(responseData, 'items', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    /**
         * @method
         * @name kucoin#fetchClosedOrders
         * @description fetch a list of orders
         * @param {str} symbol unified market symbol
         * @param {int} since timestamp in ms of the earliest order
         * @param {int} limit max number of orders to return
         * @param {dict} params exchange specific params
         * @param {int} params.till end time in ms
         * @param {str} params.side buy or sell
         * @param {str} params.type limit, market, limit_stop or market_stop
         * @param {str} params.tradeType TRADE for spot trading, MARGIN_TRADE for Margin Trading
         * @returns An [array of order structures]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ return await this.fetchOrdersByStatus('done', symbol, since, limit, params);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    /**
         * @method
         * @name kucoin#fetchOrdersByStatus
         * @description fetch a list of orders
         * @param {str} symbol unified market symbol
         * @param {int} since timestamp in ms of the earliest order
         * @param {int} limit max number of orders to return
         * @param {dict} params exchange specific params
         * @param {int} params.till end time in ms
         * @param {bool} params.stop true if fetching stop orders
         * @param {str} params.side buy or sell
         * @param {str} params.type limit, market, limit_stop or market_stop
         * @param {str} params.tradeType TRADE for spot trading, MARGIN_TRADE for Margin Trading
         * @param {int} params.currentPage *stop orders only* current page
         * @param {str} params.orderIds *stop orders only* comma seperated order ID list
         * @returns An [array of order structures]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ return await this.fetchOrdersByStatus('active', symbol, since, limit, params);
                }
                async fetchOrder(id, symbol, params = {}) {
                    /**
         * @method
         * @name kucoin#fetchOrder
         * @description fetch an order
         * @param {str} id Order id
         * @param {str} symbol not sent to exchange except for stop orders with clientOid, but used internally by CCXT to filter
         * @param {dict} params exchange specific parameters
         * @param {bool} params.stop true if fetching a stop order
         * @param {bool} params.clientOid unique order id created by users to identify their orders
         * @returns An [order structure]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ await this.loadMarkets();
                    const request = {};
                    const clientOrderId = this.safeString2(params, 'clientOid', 'clientOrderId');
                    const stop = this.safeValue(params, 'stop');
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    params = this.omit(params, 'stop');
                    let method = 'privateGetOrdersOrderId';
                    if (clientOrderId !== undefined) {
                        request['clientOid'] = clientOrderId;
                        if (stop) {
                            method = 'privateGetStopOrderQueryOrderByClientOid';
                            if (symbol !== undefined) request['symbol'] = market['id'];
                        } else method = 'privateGetOrderClientOrderClientOid';
                    } else {
                        // a special case for undefined ids
                        // otherwise a wrong endpoint for all orders will be triggered
                        // https://github.com/ccxt/ccxt/issues/7234
                        if (id === undefined) throw new InvalidOrder(this.id + ' fetchOrder() requires an order id');
                        if (stop) method = 'privateGetStopOrderOrderId';
                        request['orderId'] = id;
                    }
                    params = this.omit(params, [
                        'clientOid',
                        'clientOrderId'
                    ]);
                    const response = await this[method](this.extend(request, params));
                    let responseData = this.safeValue(response, 'data');
                    if (method === 'privateGetStopOrderQueryOrderByClientOid') responseData = this.safeValue(responseData, 0);
                    return this.parseOrder(responseData, market);
                }
                parseOrder(order, market) {
                    //
                    // fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "id": "5c35c02703aa673ceec2a168",   //orderid
                    //         "symbol": "BTC-USDT",   //symbol
                    //         "opType": "DEAL",      // operation type,deal is pending order,cancel is cancel order
                    //         "type": "limit",       // order type,e.g. limit,markrt,stop_limit.
                    //         "side": "buy",         // transaction direction,include buy and sell
                    //         "price": "10",         // order price
                    //         "size": "2",           // order quantity
                    //         "funds": "0",          // order funds
                    //         "dealFunds": "0.166",  // deal funds
                    //         "dealSize": "2",       // deal quantity
                    //         "fee": "0",            // fee
                    //         "feeCurrency": "USDT", // charge fee currency
                    //         "stp": "",             // self trade prevention,include CN,CO,DC,CB
                    //         "stop": "",            // stop type
                    //         "stopTriggered": false,  // stop order is triggered
                    //         "stopPrice": "0",      // stop price
                    //         "timeInForce": "GTC",  // time InForce,include GTC,GTT,IOC,FOK
                    //         "postOnly": false,     // postOnly
                    //         "hidden": false,       // hidden order
                    //         "iceberg": false,      // iceberg order
                    //         "visibleSize": "0",    // display quantity for iceberg order
                    //         "cancelAfter": 0,      // cancel orders time，requires timeInForce to be GTT
                    //         "channel": "IOS",      // order source
                    //         "clientOid": "",       // user-entered order unique mark
                    //         "remark": "",          // remark
                    //         "tags": "",            // tag order source
                    //         "isActive": false,     // status before unfilled or uncancelled
                    //         "cancelExist": false,   // order cancellation transaction record
                    //         "createdAt": 1547026471000  // time
                    //     }
                    //
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const orderId = this.safeString(order, 'id');
                    const type = this.safeString(order, 'type');
                    const timestamp = this.safeInteger(order, 'createdAt');
                    const datetime = this.iso8601(timestamp);
                    const price = this.safeString(order, 'price');
                    // price is zero for market order
                    // omitZero is called in safeOrder2
                    const side = this.safeString(order, 'side');
                    const feeCurrencyId = this.safeString(order, 'feeCurrency');
                    const feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                    const feeCost = this.safeNumber(order, 'fee');
                    const amount = this.safeString(order, 'size');
                    const filled = this.safeString(order, 'dealSize');
                    const cost = this.safeString(order, 'dealFunds');
                    // bool
                    const isActive = this.safeValue(order, 'isActive', false);
                    const cancelExist = this.safeValue(order, 'cancelExist', false);
                    const stop = this.safeString(order, 'stop');
                    const stopTriggered = this.safeValue(order, 'stopTriggered', false);
                    let status = isActive ? 'open' : 'closed';
                    const cancelExistWithStop = cancelExist || !isActive && stop && !stopTriggered;
                    status = cancelExistWithStop ? 'canceled' : status;
                    const fee = {
                        'currency': feeCurrency,
                        'cost': feeCost
                    };
                    const clientOrderId = this.safeString(order, 'clientOid');
                    const timeInForce = this.safeString(order, 'timeInForce');
                    const stopPrice = this.safeNumber(order, 'stopPrice');
                    const postOnly = this.safeValue(order, 'postOnly');
                    return this.safeOrder({
                        'id': orderId,
                        'clientOrderId': clientOrderId,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'amount': amount,
                        'price': price,
                        'stopPrice': stopPrice,
                        'cost': cost,
                        'filled': filled,
                        'remaining': undefined,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'fee': fee,
                        'status': status,
                        'info': order,
                        'lastTradeTimestamp': undefined,
                        'average': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['pageSize'] = limit;
                    const method = this.options['fetchMyTradesMethod'];
                    let parseResponseData = false;
                    if (method === 'private_get_fills') // does not return trades earlier than 2019-02-18T00:00:00Z
                    {
                        if (since !== undefined) // only returns trades up to one week after the since param
                        request['startAt'] = since;
                    } else if (method === 'private_get_limit_fills') // does not return trades earlier than 2019-02-18T00:00:00Z
                    // takes no params
                    // only returns first 1000 trades (not only "in the last 24 hours" as stated in the docs)
                    parseResponseData = true;
                    else if (method === 'private_get_hist_orders') // despite that this endpoint is called `HistOrders`
                    // it returns historical trades instead of orders
                    // returns trades earlier than 2019-02-18T00:00:00Z only
                    {
                        if (since !== undefined) request['startAt'] = parseInt(since / 1000);
                    } else throw new ExchangeError1(this.id + ' fetchMyTradesMethod() invalid method');
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "currentPage": 1,
                    //         "pageSize": 50,
                    //         "totalNum": 1,
                    //         "totalPage": 1,
                    //         "items": [
                    //             {
                    //                 "symbol":"BTC-USDT",       // symbol
                    //                 "tradeId":"5c35c02709e4f67d5266954e",        // trade id
                    //                 "orderId":"5c35c02703aa673ceec2a168",        // order id
                    //                 "counterOrderId":"5c1ab46003aa676e487fa8e3", // counter order id
                    //                 "side":"buy",              // transaction direction,include buy and sell
                    //                 "liquidity":"taker",       // include taker and maker
                    //                 "forceTaker":true,         // forced to become taker
                    //                 "price":"0.083",           // order price
                    //                 "size":"0.8424304",        // order quantity
                    //                 "funds":"0.0699217232",    // order funds
                    //                 "fee":"0",                 // fee
                    //                 "feeRate":"0",             // fee rate
                    //                 "feeCurrency":"USDT",      // charge fee currency
                    //                 "stop":"",                 // stop type
                    //                 "type":"limit",            // order type, e.g. limit, market, stop_limit.
                    //                 "createdAt":1547026472000  // time
                    //             },
                    //             //------------------------------------------------------
                    //             // v1 (historical) trade response structure
                    //             {
                    //                 "symbol": "SNOV-ETH",
                    //                 "dealPrice": "0.0000246",
                    //                 "dealValue": "0.018942",
                    //                 "amount": "770",
                    //                 "fee": "0.00001137",
                    //                 "side": "sell",
                    //                 "createdAt": 1540080199
                    //                 "id":"5c4d389e4c8c60413f78e2e5",
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    let trades = undefined;
                    if (parseResponseData) trades = data;
                    else trades = this.safeValue(data, 'items', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    // pagination is not supported on the exchange side anymore
                    // if (since !== undefined) {
                    //     request['startAt'] = Math.floor (since / 1000);
                    // }
                    // if (limit !== undefined) {
                    //     request['pageSize'] = limit;
                    // }
                    const response = await this.publicGetMarketHistories(this.extend(request, params));
                    //
                    //     {
                    //         "code": "200000",
                    //         "data": [
                    //             {
                    //                 "sequence": "1548764654235",
                    //                 "side": "sell",
                    //                 "size":"0.6841354",
                    //                 "price":"0.03202",
                    //                 "time":1548848575203567174
                    //             }
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, 'data', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "sequence": "1548764654235",
                    //         "side": "sell",
                    //         "size":"0.6841354",
                    //         "price":"0.03202",
                    //         "time":1548848575203567174
                    //     }
                    //
                    //     {
                    //         sequence: '1568787654360',
                    //         symbol: 'BTC-USDT',
                    //         side: 'buy',
                    //         size: '0.00536577',
                    //         price: '9345',
                    //         takerOrderId: '5e356c4a9f1a790008f8d921',
                    //         time: '1580559434436443257',
                    //         type: 'match',
                    //         makerOrderId: '5e356bffedf0010008fa5d7f',
                    //         tradeId: '5e356c4aeefabd62c62a1ece'
                    //     }
                    //
                    // fetchMyTrades (private) v2
                    //
                    //     {
                    //         "symbol":"BTC-USDT",
                    //         "tradeId":"5c35c02709e4f67d5266954e",
                    //         "orderId":"5c35c02703aa673ceec2a168",
                    //         "counterOrderId":"5c1ab46003aa676e487fa8e3",
                    //         "side":"buy",
                    //         "liquidity":"taker",
                    //         "forceTaker":true,
                    //         "price":"0.083",
                    //         "size":"0.8424304",
                    //         "funds":"0.0699217232",
                    //         "fee":"0",
                    //         "feeRate":"0",
                    //         "feeCurrency":"USDT",
                    //         "stop":"",
                    //         "type":"limit",
                    //         "createdAt":1547026472000
                    //     }
                    //
                    // fetchMyTrades v2 alternative format since 2019-05-21 https://github.com/ccxt/ccxt/pull/5162
                    //
                    //     {
                    //         symbol: "OPEN-BTC",
                    //         forceTaker:  false,
                    //         orderId: "5ce36420054b4663b1fff2c9",
                    //         fee: "0",
                    //         feeCurrency: "",
                    //         type: "",
                    //         feeRate: "0",
                    //         createdAt: 1558417615000,
                    //         size: "12.8206",
                    //         stop: "",
                    //         price: "0",
                    //         funds: "0",
                    //         tradeId: "5ce390cf6e0db23b861c6e80"
                    //     }
                    //
                    // fetchMyTrades (private) v1 (historical)
                    //
                    //     {
                    //         "symbol": "SNOV-ETH",
                    //         "dealPrice": "0.0000246",
                    //         "dealValue": "0.018942",
                    //         "amount": "770",
                    //         "fee": "0.00001137",
                    //         "side": "sell",
                    //         "createdAt": 1540080199
                    //         "id":"5c4d389e4c8c60413f78e2e5",
                    //     }
                    //
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market, '-');
                    const id = this.safeString2(trade, 'tradeId', 'id');
                    const orderId = this.safeString(trade, 'orderId');
                    const takerOrMaker = this.safeString(trade, 'liquidity');
                    let timestamp = this.safeInteger(trade, 'time');
                    if (timestamp !== undefined) timestamp = parseInt(timestamp / 1000000);
                    else {
                        timestamp = this.safeInteger(trade, 'createdAt');
                        // if it's a historical v1 trade, the exchange returns timestamp in seconds
                        if ('dealValue' in trade && timestamp !== undefined) timestamp = timestamp * 1000;
                    }
                    const priceString = this.safeString2(trade, 'price', 'dealPrice');
                    const amountString = this.safeString2(trade, 'size', 'amount');
                    const side = this.safeString(trade, 'side');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'feeCurrency');
                        let feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                        if (feeCurrency === undefined) feeCurrency = side === 'sell' ? market['quote'] : market['base'];
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrency,
                            'rate': this.safeString(trade, 'feeRate')
                        };
                    }
                    let type = this.safeString(trade, 'type');
                    if (type === 'match') type = undefined;
                    const costString = this.safeString2(trade, 'funds', 'dealValue');
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': type,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbols': market['id']
                    };
                    const response = await this.privateGetTradeFees(this.extend(request, params));
                    //
                    //     {
                    //         code: '200000',
                    //         data: [
                    //           {
                    //             symbol: 'BTC-USDT',
                    //             takerFeeRate: '0.001',
                    //             makerFeeRate: '0.001'
                    //           }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const first = this.safeValue(data, 0);
                    const marketId = this.safeString(first, 'symbol');
                    return {
                        'info': response,
                        'symbol': this.safeSymbol(marketId, market),
                        'maker': this.safeNumber(first, 'makerFeeRate'),
                        'taker': this.safeNumber(first, 'takerFeeRate'),
                        'percentage': true,
                        'tierBased': true
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    this.checkAddress(address);
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'address': address,
                        'amount': amount
                    };
                    if (tag !== undefined) request['memo'] = tag;
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeStringLower(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['chain'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privatePostWithdrawals(this.extend(request, params));
                    //
                    // https://github.com/ccxt/ccxt/issues/5558
                    //
                    //     {
                    //         "code":  200000,
                    //         "data": {
                    //             "withdrawalId":  "5bffb63303aa675e8bbe18f9"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTransaction(data, currency);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'SUCCESS': 'ok',
                        'PROCESSING': 'ok',
                        'FAILURE': 'failed'
                    };
                    return this.safeString(statuses, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "address": "0x5f047b29041bcfdbf0e4478cdfa753a336ba6989",
                    //         "memo": "5c247c8a03aa677cea2a251d",
                    //         "amount": 1,
                    //         "fee": 0.0001,
                    //         "currency": "KCS",
                    //         "isInner": false,
                    //         "walletTxId": "5bbb57386d99522d9f954c5a@test004",
                    //         "status": "SUCCESS",
                    //         "createdAt": 1544178843000,
                    //         "updatedAt": 1544178891000
                    //         "remark":"foobar"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "id": "5c2dc64e03aa675aa263f1ac",
                    //         "address": "0x5bedb060b8eb8d823e2414d82acce78d38be7fe9",
                    //         "memo": "",
                    //         "currency": "ETH",
                    //         "amount": 1.0000000,
                    //         "fee": 0.0100000,
                    //         "walletTxId": "3e2414d82acce78d38be7fe9",
                    //         "isInner": false,
                    //         "status": "FAILURE",
                    //         "createdAt": 1546503758000,
                    //         "updatedAt": 1546504603000
                    //         "remark":"foobar"
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "withdrawalId":  "5bffb63303aa675e8bbe18f9"
                    //     }
                    //
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    let address = this.safeString(transaction, 'address');
                    const amount = this.safeNumber(transaction, 'amount');
                    let txid = this.safeString(transaction, 'walletTxId');
                    if (txid !== undefined) {
                        const txidParts = txid.split('@');
                        const numTxidParts = txidParts.length;
                        if (numTxidParts > 1) {
                            if (address === undefined) {
                                if (txidParts[1].length > 1) address = txidParts[1];
                            }
                        }
                        txid = txidParts[0];
                    }
                    let type = txid === undefined ? 'withdrawal' : 'deposit';
                    const rawStatus = this.safeString(transaction, 'status');
                    const status = this.parseTransactionStatus(rawStatus);
                    let fee = undefined;
                    const feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost !== undefined) {
                        let rate = undefined;
                        if (amount !== undefined) rate = feeCost / amount;
                        fee = {
                            'cost': feeCost,
                            'rate': rate,
                            'currency': code
                        };
                    }
                    const tag = this.safeString(transaction, 'memo');
                    let timestamp = this.safeInteger2(transaction, 'createdAt', 'createAt');
                    const id = this.safeString2(transaction, 'id', 'withdrawalId');
                    let updated = this.safeInteger(transaction, 'updatedAt');
                    const isV1 = !('createdAt' in transaction);
                    // if it's a v1 structure
                    if (isV1) {
                        type = 'address' in transaction ? 'withdrawal' : 'deposit';
                        if (timestamp !== undefined) timestamp = timestamp * 1000;
                        if (updated !== undefined) updated = updated * 1000;
                    }
                    const comment = this.safeString(transaction, 'remark');
                    return {
                        'id': id,
                        'info': transaction,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'tagFrom': undefined,
                        'currency': code,
                        'amount': amount,
                        'txid': txid,
                        'type': type,
                        'status': status,
                        'comment': comment,
                        'fee': fee,
                        'updated': updated
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['pageSize'] = limit;
                    let method = 'privateGetDeposits';
                    if (since !== undefined) {
                        // if since is earlier than 2019-02-18T00:00:00Z
                        if (since < 1550448000000) {
                            request['startAt'] = parseInt(since / 1000);
                            method = 'privateGetHistDeposits';
                        } else request['startAt'] = since;
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         code: '200000',
                    //         data: {
                    //             "currentPage": 1,
                    //             "pageSize": 5,
                    //             "totalNum": 2,
                    //             "totalPage": 1,
                    //             "items": [
                    //                 //--------------------------------------------------
                    //                 // version 2 deposit response structure
                    //                 {
                    //                     "address": "0x5f047b29041bcfdbf0e4478cdfa753a336ba6989",
                    //                     "memo": "5c247c8a03aa677cea2a251d",
                    //                     "amount": 1,
                    //                     "fee": 0.0001,
                    //                     "currency": "KCS",
                    //                     "isInner": false,
                    //                     "walletTxId": "5bbb57386d99522d9f954c5a@test004",
                    //                     "status": "SUCCESS",
                    //                     "createdAt": 1544178843000,
                    //                     "updatedAt": 1544178891000
                    //                     "remark":"foobar"
                    //                 },
                    //                 //--------------------------------------------------
                    //                 // version 1 (historical) deposit response structure
                    //                 {
                    //                     "currency": "BTC",
                    //                     "createAt": 1528536998,
                    //                     "amount": "0.03266638",
                    //                     "walletTxId": "55c643bc2c68d6f17266383ac1be9e454038864b929ae7cee0bc408cc5c869e8@12ffGWmMMD1zA1WbFm7Ho3JZ1w6NYXjpFk@234",
                    //                     "isInner": false,
                    //                     "status": "SUCCESS",
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const responseData = response['data']['items'];
                    return this.parseTransactions(responseData, currency, since, limit, {
                        'type': 'deposit'
                    });
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['pageSize'] = limit;
                    let method = 'privateGetWithdrawals';
                    if (since !== undefined) {
                        // if since is earlier than 2019-02-18T00:00:00Z
                        if (since < 1550448000000) {
                            request['startAt'] = parseInt(since / 1000);
                            method = 'privateGetHistWithdrawals';
                        } else request['startAt'] = since;
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         code: '200000',
                    //         data: {
                    //             "currentPage": 1,
                    //             "pageSize": 5,
                    //             "totalNum": 2,
                    //             "totalPage": 1,
                    //             "items": [
                    //                 //--------------------------------------------------
                    //                 // version 2 withdrawal response structure
                    //                 {
                    //                     "id": "5c2dc64e03aa675aa263f1ac",
                    //                     "address": "0x5bedb060b8eb8d823e2414d82acce78d38be7fe9",
                    //                     "memo": "",
                    //                     "currency": "ETH",
                    //                     "amount": 1.0000000,
                    //                     "fee": 0.0100000,
                    //                     "walletTxId": "3e2414d82acce78d38be7fe9",
                    //                     "isInner": false,
                    //                     "status": "FAILURE",
                    //                     "createdAt": 1546503758000,
                    //                     "updatedAt": 1546504603000
                    //                 },
                    //                 //--------------------------------------------------
                    //                 // version 1 (historical) withdrawal response structure
                    //                 {
                    //                     "currency": "BTC",
                    //                     "createAt": 1526723468,
                    //                     "amount": "0.534",
                    //                     "address": "33xW37ZSW4tQvg443Pc7NLCAs167Yc2XUV",
                    //                     "walletTxId": "aeacea864c020acf58e51606169240e96774838dcd4f7ce48acf38e3651323f4",
                    //                     "isInner": false,
                    //                     "status": "SUCCESS"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const responseData = response['data']['items'];
                    return this.parseTransactions(responseData, currency, since, limit, {
                        'type': 'withdrawal'
                    });
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const defaultType = this.safeString2(this.options, 'fetchBalance', 'defaultType', 'spot');
                    const requestedType = this.safeString(params, 'type', defaultType);
                    const accountsByType = this.safeValue(this.options, 'accountsByType');
                    const type = this.safeString(accountsByType, requestedType, requestedType);
                    params = this.omit(params, 'type');
                    const request = {
                        'type': type
                    };
                    const response = await this.privateGetAccounts(this.extend(request, params));
                    //
                    //     {
                    //         "code":"200000",
                    //         "data":[
                    //             {"balance":"0.00009788","available":"0.00009788","holds":"0","currency":"BTC","id":"5c6a4fd399a1d81c4f9cc4d0","type":"trade"},
                    //             {"balance":"3.41060034","available":"3.41060034","holds":"0","currency":"SOUL","id":"5c6a4d5d99a1d8182d37046d","type":"trade"},
                    //             {"balance":"0.01562641","available":"0.01562641","holds":"0","currency":"NEO","id":"5c6a4f1199a1d8165a99edb1","type":"trade"},
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < data.length; i++){
                        const balance = data[i];
                        const balanceType = this.safeString(balance, 'type');
                        if (balanceType === type) {
                            const currencyId = this.safeString(balance, 'currency');
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            account['total'] = this.safeString(balance, 'balance');
                            account['free'] = this.safeString(balance, 'available');
                            account['used'] = this.safeString(balance, 'holds');
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const requestedAmount = this.currencyToPrecision(code, amount);
                    const accountsById = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsById, fromAccount, fromAccount);
                    const toId = this.safeString(accountsById, toAccount, toAccount);
                    if (fromId === 'contract') {
                        if (toId !== 'main') throw new ExchangeError1(this.id + ' transfer() only supports transferring from futures account to main account');
                        const request = {
                            'currency': currency['id'],
                            'amount': requestedAmount
                        };
                        if (!('bizNo' in params)) // it doesn't like more than 24 characters
                        request['bizNo'] = this.uuid22();
                        const response = await this.futuresPrivatePostTransferOut(this.extend(request, params));
                        //
                        //     {
                        //         'code': '200000',
                        //         'data': {
                        //             'applyId': '605a87217dff1500063d485d',
                        //             'bizNo': 'bcd6e5e1291f4905af84dc',
                        //             'payAccountType': 'CONTRACT',
                        //             'payTag': 'DEFAULT',
                        //             'remark': '',
                        //             'recAccountType': 'MAIN',
                        //             'recTag': 'DEFAULT',
                        //             'recRemark': '',
                        //             'recSystem': 'KUCOIN',
                        //             'status': 'PROCESSING',
                        //             'currency': 'XBT',
                        //             'amount': '0.00001',
                        //             'fee': '0',
                        //             'sn': '573688685663948',
                        //             'reason': '',
                        //             'createdAt': 1616545569000,
                        //             'updatedAt': 1616545569000
                        //         }
                        //     }
                        //
                        const data = this.safeValue(response, 'data');
                        return this.parseTransfer(data, currency);
                    } else {
                        const request = {
                            'currency': currency['id'],
                            'from': fromId,
                            'to': toId,
                            'amount': requestedAmount
                        };
                        if (!('clientOid' in params)) request['clientOid'] = this.uuid();
                        const response = await this.privatePostAccountsInnerTransfer(this.extend(request, params));
                        //
                        //     {
                        //         'code': '200000',
                        //         'data': {
                        //              'orderId': '605a6211e657f00006ad0ad6'
                        //         }
                        //     }
                        //
                        const data = this.safeValue(response, 'data');
                        return this.parseTransfer(data, currency);
                    }
                }
                parseTransfer(transfer, currency) {
                    //
                    // transfer (spot)
                    //
                    //     {
                    //         'orderId': '605a6211e657f00006ad0ad6'
                    //     }
                    //
                    //
                    // transfer (futures)
                    //
                    //     {
                    //         'applyId': '605a87217dff1500063d485d',
                    //         'bizNo': 'bcd6e5e1291f4905af84dc',
                    //         'payAccountType': 'CONTRACT',
                    //         'payTag': 'DEFAULT',
                    //         'remark': '',
                    //         'recAccountType': 'MAIN',
                    //         'recTag': 'DEFAULT',
                    //         'recRemark': '',
                    //         'recSystem': 'KUCOIN',
                    //         'status': 'PROCESSING',
                    //         'currency': 'XBT',
                    //         'amount': '0.00001',
                    //         'fee': '0',
                    //         'sn': '573688685663948',
                    //         'reason': '',
                    //         'createdAt': 1616545569000,
                    //         'updatedAt': 1616545569000
                    //     }
                    //
                    const timestamp = this.safeInteger(transfer, 'createdAt');
                    const currencyId = this.safeString(transfer, 'currency');
                    const rawStatus = this.safeString(transfer, 'status');
                    const accountFromRaw = this.safeString(transfer, 'payAccountType');
                    const accountToRaw = this.safeString(transfer, 'recAccountType');
                    const accountsByType = this.safeValue(this.options, 'accountsByType');
                    const accountFrom = this.safeString(accountsByType, accountFromRaw.toLowerCase());
                    const accountTo = this.safeString(accountsByType, accountToRaw.toLowerCase());
                    return {
                        'id': this.safeString2(transfer, 'applyId', 'orderId'),
                        'currency': this.safeCurrencyCode(currencyId, currency),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'amount': this.safeNumber(transfer, 'amount'),
                        'fromAccount': accountFrom,
                        'toAccount': accountTo,
                        'status': this.parseTransferStatus(rawStatus),
                        'info': transfer
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'PROCESSING': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'Assets Transferred in After Upgrading': 'transfer',
                        'Deposit': 'transaction',
                        'Withdrawal': 'transaction',
                        'Transfer': 'transfer',
                        'Trade_Exchange': 'trade',
                        // 'Vote for Coin': 'Vote for Coin', // Vote for Coin
                        'KuCoin Bonus': 'bonus',
                        'Referral Bonus': 'referral',
                        'Rewards': 'bonus',
                        // 'Distribution': 'Distribution', // Distribution, such as get GAS by holding NEO
                        'Airdrop/Fork': 'airdrop',
                        'Other rewards': 'bonus',
                        'Fee Rebate': 'rebate',
                        'Buy Crypto': 'trade',
                        'Sell Crypto': 'sell',
                        'Public Offering Purchase': 'trade',
                        // 'Send red envelope': 'Send red envelope', // Send red envelope
                        // 'Open red envelope': 'Open red envelope', // Open red envelope
                        // 'Staking': 'Staking', // Staking
                        // 'LockDrop Vesting': 'LockDrop Vesting', // LockDrop Vesting
                        // 'Staking Profits': 'Staking Profits', // Staking Profits
                        // 'Redemption': 'Redemption', // Redemption
                        'Refunded Fees': 'fee',
                        'KCS Pay Fees': 'fee',
                        'Margin Trade': 'trade',
                        'Loans': 'Loans',
                        // 'Borrowings': 'Borrowings', // Borrowings
                        // 'Debt Repayment': 'Debt Repayment', // Debt Repayment
                        // 'Loans Repaid': 'Loans Repaid', // Loans Repaid
                        // 'Lendings': 'Lendings', // Lendings
                        // 'Pool transactions': 'Pool transactions', // Pool-X transactions
                        'Instant Exchange': 'trade',
                        'Sub-account transfer': 'transfer',
                        'Liquidation Fees': 'fee'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     {
                    //         "id": "611a1e7c6a053300067a88d9", //unique key for each ledger entry
                    //         "currency": "USDT", //Currency
                    //         "amount": "10.00059547", //The total amount of assets (fees included) involved in assets changes such as transaction, withdrawal and bonus distribution.
                    //         "fee": "0", //Deposit or withdrawal fee
                    //         "balance": "0", //Total assets of a currency remaining funds after transaction
                    //         "accountType": "MAIN", //Account Type
                    //         "bizType": "Loans Repaid", //business type
                    //         "direction": "in", //side, in or out
                    //         "createdAt": 1629101692950, //Creation time
                    //         "context": "{\"borrowerUserId\":\"601ad03e50dc810006d242ea\",\"loanRepayDetailNo\":\"611a1e7cc913d000066cf7ec\"}" //Business core parameters
                    //     }
                    //
                    const id = this.safeString(item, 'id');
                    const currencyId = this.safeString(item, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const amount = this.safeNumber(item, 'amount');
                    const balanceAfter = undefined;
                    // const balanceAfter = this.safeNumber (item, 'balance'); only returns zero string
                    const bizType = this.safeString(item, 'bizType');
                    const type = this.parseLedgerEntryType(bizType);
                    const direction = this.safeString(item, 'direction');
                    const timestamp = this.safeInteger(item, 'createdAt');
                    const datetime = this.iso8601(timestamp);
                    const account = this.safeString(item, 'accountType'); // MAIN, TRADE, MARGIN, or CONTRACT
                    const context = this.safeString(item, 'context'); // contains other information about the ledger entry
                    //
                    // withdrawal transaction
                    //
                    //     "{\"orderId\":\"617bb2d09e7b3b000196dac8\",\"txId\":\"0x79bb9855f86b351a45cab4dc69d78ca09586a94c45dde49475722b98f401b054\"}"
                    //
                    // deposit to MAIN, trade via MAIN
                    //
                    //     "{\"orderId\":\"617ab9949e7b3b0001948081\",\"txId\":\"0x7a06b16bbd6b03dbc3d96df5683b15229fc35e7184fd7179a5f3a310bd67d1fa@default@0\"}"
                    //
                    // sell trade
                    //
                    //     "{\"symbol\":\"ETH-USDT\",\"orderId\":\"617adcd1eb3fa20001dd29a1\",\"tradeId\":\"617adcd12e113d2b91222ff9\"}"
                    //
                    let referenceId = undefined;
                    if (context !== undefined && context !== '') {
                        const parsed = JSON.parse(context);
                        const orderId = this.safeString(parsed, 'orderId');
                        const tradeId = this.safeString(parsed, 'tradeId');
                        // transactions only have an orderId but for trades we wish to use tradeId
                        if (tradeId !== undefined) referenceId = tradeId;
                        else referenceId = orderId;
                    }
                    let fee = undefined;
                    const feeCost = this.safeNumber(item, 'fee');
                    let feeCurrency = undefined;
                    if (feeCost !== 0) {
                        feeCurrency = code;
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrency
                        };
                    }
                    return {
                        'id': id,
                        'direction': direction,
                        'account': account,
                        'referenceId': referenceId,
                        'referenceAccount': account,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'before': undefined,
                        'after': balanceAfter,
                        'status': undefined,
                        'fee': fee,
                        'info': item
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const request = {
                    };
                    if (since !== undefined) request['startAt'] = since;
                    // atm only single currency retrieval is supported
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    const response = await this.privateGetAccountsLedgers(this.extend(request, params));
                    //
                    //     {
                    //         "code":"200000",
                    //         "data":{
                    //             "currentPage":1,
                    //             "pageSize":50,
                    //             "totalNum":1,
                    //             "totalPage":1,
                    //             "items":[
                    //                 {
                    //                     "id":"617cc528729f5f0001c03ceb",
                    //                     "currency":"GAS",
                    //                     "amount":"0.00000339",
                    //                     "fee":"0",
                    //                     "balance":"0",
                    //                     "accountType":"MAIN",
                    //                     "bizType":"Distribution",
                    //                     "direction":"in",
                    //                     "createdAt":1635566888183,
                    //                     "context":"{\"orderId\":\"617cc47a1c47ed0001ce3606\",\"description\":\"Holding NEO,distribute GAS(2021/10/30)\"}"
                    //                 }
                    //                 {
                    //                     "id": "611a1e7c6a053300067a88d9",//unique key
                    //                     "currency": "USDT", //Currency
                    //                     "amount": "10.00059547", //Change amount of the funds
                    //                     "fee": "0", //Deposit or withdrawal fee
                    //                     "balance": "0", //Total assets of a currency
                    //                     "accountType": "MAIN", //Account Type
                    //                     "bizType": "Loans Repaid", //business type
                    //                     "direction": "in", //side, in or out
                    //                     "createdAt": 1629101692950, //Creation time
                    //                     "context": "{\"borrowerUserId\":\"601ad03e50dc810006d242ea\",\"loanRepayDetailNo\":\"611a1e7cc913d000066cf7ec\"}"
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const items = this.safeValue(data, 'items');
                    return this.parseLedger(items, currency, since, limit);
                }
                calculateRateLimiterCost(api, method, path, params, config = {}, context = {}) {
                    const versions = this.safeValue(this.options, 'versions', {});
                    const apiVersions = this.safeValue(versions, api, {});
                    const methodVersions = this.safeValue(apiVersions, method, {});
                    const defaultVersion = this.safeString(methodVersions, path, this.options['version']);
                    const version = this.safeString(params, 'version', defaultVersion);
                    if (version === 'v3' && 'v3' in config) return config['v3'];
                    else if (version === 'v2' && 'v2' in config) return config['v2'];
                    else if (version === 'v1' && 'v1' in config) return config['v1'];
                    return this.safeInteger(config, 'cost', 1);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    //
                    // the v2 URL is https://openapi-v2.kucoin.com/api/v1/endpoint
                    //                                †                 ↑
                    //
                    const versions = this.safeValue(this.options, 'versions', {});
                    const apiVersions = this.safeValue(versions, api, {});
                    const methodVersions = this.safeValue(apiVersions, method, {});
                    const defaultVersion = this.safeString(methodVersions, path, this.options['version']);
                    const version = this.safeString(params, 'version', defaultVersion);
                    params = this.omit(params, 'version');
                    let endpoint = '/api/' + version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    let endpart = '';
                    headers = headers !== undefined ? headers : {};
                    if (Object.keys(query).length) {
                        if (method === 'GET' || method === 'DELETE') endpoint += '?' + this.rawencode(query);
                        else {
                            body = this.json(query);
                            endpart = body;
                            headers['Content-Type'] = 'application/json';
                        }
                    }
                    const url = this.urls['api'][api] + endpoint;
                    if (api === 'private' || api === 'futuresPrivate') {
                        this.checkRequiredCredentials();
                        const timestamp = this.nonce().toString();
                        headers = this.extend({
                            'KC-API-KEY-VERSION': '2',
                            'KC-API-KEY': this.apiKey,
                            'KC-API-TIMESTAMP': timestamp
                        }, headers);
                        const apiKeyVersion = this.safeString(headers, 'KC-API-KEY-VERSION');
                        if (apiKeyVersion === '2') {
                            const passphrase = this.hmac(this.encode(this.password), this.encode(this.secret), 'sha256', 'base64');
                            headers['KC-API-PASSPHRASE'] = passphrase;
                        } else headers['KC-API-PASSPHRASE'] = this.password;
                        const payload = timestamp + method + endpoint + endpart;
                        const signature = this.hmac(this.encode(payload), this.encode(this.secret), 'sha256', 'base64');
                        headers['KC-API-SIGN'] = signature;
                        const partner = this.safeValue(this.options, 'partner', {});
                        const partnerId = this.safeString(partner, 'id');
                        const partnerSecret = this.safeString(partner, 'secret');
                        if (partnerId !== undefined && partnerSecret !== undefined) {
                            const partnerPayload = timestamp + partnerId + this.apiKey;
                            const partnerSignature = this.hmac(this.encode(partnerPayload), this.encode(partnerSecret), 'sha256', 'base64');
                            headers['KC-API-PARTNER-SIGN'] = partnerSignature;
                            headers['KC-API-PARTNER'] = partnerId;
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (!response) {
                        this.throwBroadlyMatchedException(this.exceptions['broad'], body, body);
                        return;
                    }
                    //
                    // bad
                    //     { "code": "400100", "msg": "validation.createOrder.clientOidIsRequired" }
                    // good
                    //     { code: '200000', data: { ... }}
                    //
                    const errorCode = this.safeString(response, 'code');
                    const message = this.safeString(response, 'msg', '');
                    const feedback = this.id + ' ' + message;
                    this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                    this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                    this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    97: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const { ArgumentsRequired: ArgumentsRequired1, ExchangeNotAvailable: ExchangeNotAvailable, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, AccountSuspended: AccountSuspended, InvalidNonce: InvalidNonce, NotSupported: NotSupported, BadRequest: BadRequest, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded, PermissionDenied: PermissionDenied } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            const kucoin = require1('./kucoin.js');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            //  ---------------------------------------------------------------------------
            module.exports = class kucoinfutures extends kucoin {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'kucoinfutures',
                        'name': 'KuCoin Futures',
                        'countries': [
                            'SC'
                        ],
                        'rateLimit': 75,
                        'version': 'v1',
                        'certified': false,
                        'pro': false,
                        'comment': 'Platform 2.0',
                        'quoteJsonNumbers': false,
                        'has': {
                            'CORS': undefined,
                            'spot': false,
                            'margin': false,
                            'swap': true,
                            'future': true,
                            'option': false,
                            'addMargin': true,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': false,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingFee': true,
                            'fetchFundingHistory': true,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': false,
                            'fetchIndexOHLCV': false,
                            'fetchL3OrderBook': true,
                            'fetchLedger': true,
                            'fetchLeverageTiers': false,
                            'fetchMarketLeverageTiers': true,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPositions': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': false,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchWithdrawals': true,
                            'setMarginMode': false,
                            'transfer': true,
                            'withdraw': undefined
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/147508995-9e35030a-d046-43a1-a006-6fabd981b554.jpg',
                            'doc': [
                                'https://docs.kucoin.com/futures',
                                'https://docs.kucoin.com'
                            ],
                            'www': 'https://futures.kucoin.com/',
                            'referral': 'https://futures.kucoin.com/?rcode=E5wkqe',
                            'api': {
                                'public': 'https://openapi-v2.kucoin.com',
                                'private': 'https://openapi-v2.kucoin.com',
                                'futuresPrivate': 'https://api-futures.kucoin.com',
                                'futuresPublic': 'https://api-futures.kucoin.com'
                            },
                            'test': {
                                'public': 'https://openapi-sandbox.kucoin.com',
                                'private': 'https://openapi-sandbox.kucoin.com',
                                'futuresPrivate': 'https://api-sandbox-futures.kucoin.com',
                                'futuresPublic': 'https://api-sandbox-futures.kucoin.com'
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'password': true
                        },
                        'api': {
                            'futuresPublic': {
                                'get': {
                                    'contracts/active': 1,
                                    'contracts/{symbol}': 1,
                                    'contracts/risk-limit/{symbol}': 1,
                                    'ticker': 1,
                                    'level2/snapshot': 1.33,
                                    'level2/depth{limit}': 1,
                                    'level2/message/query': 1,
                                    'level3/message/query': 1,
                                    'level3/snapshot': 1,
                                    'trade/history': 1,
                                    'interest/query': 1,
                                    'index/query': 1,
                                    'mark-price/{symbol}/current': 1,
                                    'premium/query': 1,
                                    'funding-rate/{symbol}/current': 1,
                                    'timestamp': 1,
                                    'status': 1,
                                    'kline/query': 1
                                },
                                'post': {
                                    'bullet-public': 1
                                }
                            },
                            'futuresPrivate': {
                                'get': {
                                    'account-overview': 1.33,
                                    'transaction-history': 4.44,
                                    'deposit-address': 1,
                                    'deposit-list': 1,
                                    'withdrawals/quotas': 1,
                                    'withdrawal-list': 1,
                                    'transfer-list': 1,
                                    'orders': 1.33,
                                    'stopOrders': 1,
                                    'recentDoneOrders': 1,
                                    'orders/{orderId}': 1,
                                    'orders/byClientOid': 1,
                                    'fills': 4.44,
                                    'recentFills': 4.44,
                                    'openOrderStatistics': 1,
                                    'position': 1,
                                    'positions': 4.44,
                                    'funding-history': 4.44
                                },
                                'post': {
                                    'withdrawals': 1,
                                    'transfer-out': 1,
                                    'orders': 1.33,
                                    'position/margin/auto-deposit-status': 1,
                                    'position/margin/deposit-margin': 1,
                                    'bullet-private': 1
                                },
                                'delete': {
                                    'withdrawals/{withdrawalId}': 1,
                                    'cancel/transfer-out': 1,
                                    'orders/{orderId}': 1,
                                    'orders': 4.44,
                                    'stopOrders': 1
                                }
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'exceptions': {
                            'exact': {
                                '400': BadRequest,
                                '401': AuthenticationError,
                                '403': NotSupported,
                                '404': NotSupported,
                                '405': NotSupported,
                                '415': BadRequest,
                                '429': RateLimitExceeded,
                                '500': ExchangeNotAvailable,
                                '503': ExchangeNotAvailable,
                                '100001': InvalidOrder,
                                '100004': BadRequest,
                                '101030': PermissionDenied,
                                '200004': InsufficientFunds,
                                '230003': InsufficientFunds,
                                '260100': InsufficientFunds,
                                '300003': InsufficientFunds,
                                '300012': InvalidOrder,
                                '400001': AuthenticationError,
                                '400002': InvalidNonce,
                                '400003': AuthenticationError,
                                '400004': AuthenticationError,
                                '400005': AuthenticationError,
                                '400006': AuthenticationError,
                                '400007': AuthenticationError,
                                '404000': NotSupported,
                                '400100': BadRequest,
                                '411100': AccountSuspended,
                                '500000': ExchangeNotAvailable
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.0006'),
                                'maker': this.parseNumber('0.0002'),
                                'tiers': {
                                    'taker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('50'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('200'),
                                            this.parseNumber('0.0006')
                                        ],
                                        [
                                            this.parseNumber('500'),
                                            this.parseNumber('0.0005')
                                        ],
                                        [
                                            this.parseNumber('1000'),
                                            this.parseNumber('0.0004')
                                        ],
                                        [
                                            this.parseNumber('2000'),
                                            this.parseNumber('0.0004')
                                        ],
                                        [
                                            this.parseNumber('4000'),
                                            this.parseNumber('0.00038')
                                        ],
                                        [
                                            this.parseNumber('8000'),
                                            this.parseNumber('0.00035')
                                        ],
                                        [
                                            this.parseNumber('15000'),
                                            this.parseNumber('0.00032')
                                        ],
                                        [
                                            this.parseNumber('25000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('40000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('60000'),
                                            this.parseNumber('0.0003')
                                        ],
                                        [
                                            this.parseNumber('80000'),
                                            this.parseNumber('0.0003')
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            this.parseNumber('0'),
                                            this.parseNumber('0.02')
                                        ],
                                        [
                                            this.parseNumber('50'),
                                            this.parseNumber('0.015')
                                        ],
                                        [
                                            this.parseNumber('200'),
                                            this.parseNumber('0.01')
                                        ],
                                        [
                                            this.parseNumber('500'),
                                            this.parseNumber('0.01')
                                        ],
                                        [
                                            this.parseNumber('1000'),
                                            this.parseNumber('0.01')
                                        ],
                                        [
                                            this.parseNumber('2000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('4000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('8000'),
                                            this.parseNumber('0')
                                        ],
                                        [
                                            this.parseNumber('15000'),
                                            this.parseNumber('-0.003')
                                        ],
                                        [
                                            this.parseNumber('25000'),
                                            this.parseNumber('-0.006')
                                        ],
                                        [
                                            this.parseNumber('40000'),
                                            this.parseNumber('-0.009')
                                        ],
                                        [
                                            this.parseNumber('60000'),
                                            this.parseNumber('-0.012')
                                        ],
                                        [
                                            this.parseNumber('80000'),
                                            this.parseNumber('-0.015')
                                        ]
                                    ]
                                }
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false,
                                'withdraw': {},
                                'deposit': {}
                            }
                        },
                        'commonCurrencies': {
                            'HOT': 'HOTNOW',
                            'EDGE': 'DADI',
                            'WAX': 'WAXP',
                            'TRY': 'Trias',
                            'VAI': 'VAIOT',
                            'XBT': 'BTC'
                        },
                        'timeframes': {
                            '1m': 1,
                            '3m': undefined,
                            '5m': 5,
                            '15m': 15,
                            '30m': 30,
                            '1h': 60,
                            '2h': 120,
                            '4h': 240,
                            '6h': undefined,
                            '8h': 480,
                            '12h': 720,
                            '1d': 1440,
                            '1w': 10080
                        },
                        'options': {
                            'version': 'v1',
                            'symbolSeparator': '-',
                            'defaultType': 'swap',
                            'code': 'USDT',
                            'marginModes': {},
                            'marginTypes': {},
                            // endpoint versions
                            'versions': {
                                'futuresPrivate': {
                                    'POST': {
                                        'transfer-out': 'v2'
                                    }
                                },
                                'futuresPublic': {
                                    'GET': {
                                        'level3/snapshot': 'v2'
                                    }
                                }
                            },
                            'networks': {
                                'OMNI': 'omni',
                                'ERC20': 'eth',
                                'TRC20': 'trx'
                            }
                        }
                    });
                }
                async fetchAccounts(params = {}) {
                    throw new BadRequest(this.id + ' fetchAccounts() is not supported yet');
                }
                async fetchStatus(params = {}) {
                    const response = await this.futuresPublicGetStatus(params);
                    //
                    //     {
                    //         "code":"200000",
                    //         "data":{
                    //             "status": "open", // open, close, cancelonly
                    //             "msg": "upgrade match engine" // remark for operation when status not open
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const status = this.safeString(data, 'status');
                    return {
                        'status': status === 'open' ? 'ok' : 'maintenance',
                        'updated': this.milliseconds(),
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchMarkets(params = {}) {
                    const response = await this.futuresPublicGetContractsActive(params);
                    //
                    //    {
                    //        "code": "200000",
                    //        "data": {
                    //            "symbol": "ETHUSDTM",
                    //            "rootSymbol": "USDT",
                    //            "type": "FFWCSX",
                    //            "firstOpenDate": 1591086000000,
                    //            "expireDate": null,
                    //            "settleDate": null,
                    //            "baseCurrency": "ETH",
                    //            "quoteCurrency": "USDT",
                    //            "settleCurrency": "USDT",
                    //            "maxOrderQty": 1000000,
                    //            "maxPrice": 1000000.0000000000,
                    //            "lotSize": 1,
                    //            "tickSize": 0.05,
                    //            "indexPriceTickSize": 0.01,
                    //            "multiplier": 0.01,
                    //            "initialMargin": 0.01,
                    //            "maintainMargin": 0.005,
                    //            "maxRiskLimit": 1000000,
                    //            "minRiskLimit": 1000000,
                    //            "riskStep": 500000,
                    //            "makerFeeRate": 0.00020,
                    //            "takerFeeRate": 0.00060,
                    //            "takerFixFee": 0.0000000000,
                    //            "makerFixFee": 0.0000000000,
                    //            "settlementFee": null,
                    //            "isDeleverage": true,
                    //            "isQuanto": true,
                    //            "isInverse": false,
                    //            "markMethod": "FairPrice",
                    //            "fairMethod": "FundingRate",
                    //            "fundingBaseSymbol": ".ETHINT8H",
                    //            "fundingQuoteSymbol": ".USDTINT8H",
                    //            "fundingRateSymbol": ".ETHUSDTMFPI8H",
                    //            "indexSymbol": ".KETHUSDT",
                    //            "settlementSymbol": "",
                    //            "status": "Open",
                    //            "fundingFeeRate": 0.000535,
                    //            "predictedFundingFeeRate": 0.002197,
                    //            "openInterest": "8724443",
                    //            "turnoverOf24h": 341156641.03354263,
                    //            "volumeOf24h": 74833.54000000,
                    //            "markPrice": 4534.07,
                    //            "indexPrice":4531.92,
                    //            "lastTradePrice": 4545.4500000000,
                    //            "nextFundingRateTime": 25481884,
                    //            "maxLeverage": 100,
                    //            "sourceExchanges":  [
                    //                "huobi",
                    //                "Okex",
                    //                "Binance",
                    //                "Kucoin",
                    //                "Poloniex",
                    //                "Hitbtc"
                    //            ],
                    //            "premiumsSymbol1M": ".ETHUSDTMPI",
                    //            "premiumsSymbol8H": ".ETHUSDTMPI8H",
                    //            "fundingBaseSymbol1M": ".ETHINT",
                    //            "fundingQuoteSymbol1M": ".USDTINT",
                    //            "lowPrice": 4456.90,
                    //            "highPrice":  4674.25,
                    //            "priceChgPct": 0.0046,
                    //            "priceChg": 21.15
                    //        }
                    //    }
                    //
                    const result = [];
                    const data = this.safeValue(response, 'data');
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const id = this.safeString(market, 'symbol');
                        const expiry = this.safeInteger(market, 'expireDate');
                        const future = expiry ? true : false;
                        const swap = !future;
                        const baseId = this.safeString(market, 'baseCurrency');
                        const quoteId = this.safeString(market, 'quoteCurrency');
                        const settleId = this.safeString(market, 'settleCurrency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const settle = this.safeCurrencyCode(settleId);
                        let symbol = base + '/' + quote + ':' + settle;
                        let type = 'swap';
                        if (future) {
                            symbol = symbol + '-' + this.yymmdd(expiry, '');
                            type = 'future';
                        }
                        const baseMaxSize = this.safeNumber(market, 'baseMaxSize');
                        const baseMinSizeString = this.safeString(market, 'baseMinSize');
                        const quoteMaxSizeString = this.safeString(market, 'quoteMaxSize');
                        const baseMinSize = this.parseNumber(baseMinSizeString);
                        const quoteMaxSize = this.parseNumber(quoteMaxSizeString);
                        const quoteMinSize = this.safeNumber(market, 'quoteMinSize');
                        const inverse = this.safeValue(market, 'isInverse');
                        const status = this.safeString(market, 'status');
                        const multiplier = this.safeString(market, 'multiplier');
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': type,
                            'spot': false,
                            'margin': false,
                            'swap': swap,
                            'future': future,
                            'option': false,
                            'active': status === 'Open',
                            'contract': true,
                            'linear': !inverse,
                            'inverse': inverse,
                            'taker': this.safeNumber(market, 'takerFeeRate'),
                            'maker': this.safeNumber(market, 'makerFeeRate'),
                            'contractSize': this.parseNumber(Precise.stringAbs(multiplier)),
                            'expiry': expiry,
                            'expiryDatetime': this.iso8601(expiry),
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(market, 'lotSize'),
                                'price': this.safeNumber(market, 'tickSize')
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.parseNumber('1'),
                                    'max': this.safeNumber(market, 'maxLeverage')
                                },
                                'amount': {
                                    'min': baseMinSize,
                                    'max': baseMaxSize
                                },
                                'price': {
                                    'min': undefined,
                                    'max': this.parseNumber(Precise.stringDiv(quoteMaxSizeString, baseMinSizeString))
                                },
                                'cost': {
                                    'min': quoteMinSize,
                                    'max': quoteMaxSize
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchTime(params = {}) {
                    const response = await this.futuresPublicGetTimestamp(params);
                    //
                    //    {
                    //        code: "200000",
                    //        data: 1637385119302,
                    //    }
                    //
                    return this.safeNumber(response, 'data');
                }
                async fetchOHLCV(symbol, timeframe = '15m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const marketId = market['id'];
                    const request = {
                        'symbol': marketId,
                        'granularity': this.timeframes[timeframe]
                    };
                    const duration = this.parseTimeframe(timeframe) * 1000;
                    let endAt = this.milliseconds();
                    if (since !== undefined) {
                        request['from'] = since;
                        if (limit === undefined) limit = this.safeInteger(this.options, 'fetchOHLCVLimit', 200);
                        endAt = this.sum(since, limit * duration);
                    } else if (limit !== undefined) {
                        since = endAt - limit * duration;
                        request['from'] = since;
                    }
                    request['to'] = endAt;
                    const response = await this.futuresPublicGetKlineQuery(this.extend(request, params));
                    //
                    //    {
                    //        "code": "200000",
                    //        "data": [
                    //            [1636459200000, 4779.3, 4792.1, 4768.7, 4770.3, 78051],
                    //            [1636460100000, 4770.25, 4778.55, 4757.55, 4777.25, 80164],
                    //            [1636461000000, 4777.25, 4791.45, 4774.5, 4791.3, 51555]
                    //        ]
                    //    }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //    [
                    //        "1545904980000",          // Start time of the candle cycle
                    //        "0.058",                  // opening price
                    //        "0.049",                  // closing price
                    //        "0.058",                  // highest price
                    //        "0.049",                  // lowest price
                    //        "0.018",                  // base volume
                    //        "0.000945",               // quote volume
                    //    ]
                    //
                    return [
                        this.safeInteger(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async createDepositAddress(code, params = {}) {
                    throw new BadRequest(this.id + ' createDepositAddress() is not supported yet');
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const currencyId = currency['id'];
                    const request = {
                        'currency': currencyId
                    };
                    const response = await this.futuresPrivateGetDepositAddress(this.extend(request, params));
                    //
                    //    {
                    //        "code": "200000",
                    //        "data": {
                    //            "address": "0x78d3ad1c0aa1bf068e19c94a2d7b16c9c0fcd8b1",//Deposit address
                    //            "memo": null//Address tag. If the returned value is null, it means that the requested token has no memo. If you are to transfer funds from another platform to KuCoin Futures and if the token to be //transferred has memo(tag), you need to fill in the memo to ensure the transferred funds will be sent //to the address you specified.
                    //        }
                    //    }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const address = this.safeString(data, 'address');
                    if (currencyId !== 'NIM') // contains spaces
                    this.checkAddress(address);
                    return {
                        'info': response,
                        'currency': currencyId,
                        'address': address,
                        'tag': this.safeString(data, 'memo'),
                        'network': this.safeString(data, 'chain')
                    };
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const level = this.safeNumber(params, 'level');
                    if (level !== 2 && level !== undefined) throw new BadRequest(this.id + ' fetchOrderBook() can only return level 2');
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) {
                        if (limit === 20 || limit === 100) request['limit'] = limit;
                        else throw new BadRequest(this.id + ' fetchOrderBook() limit argument must be 20 or 100');
                    } else request['limit'] = 20;
                    const response = await this.futuresPublicGetLevel2DepthLimit(this.extend(request, params));
                    //
                    //     {
                    //         "code": "200000",
                    //         "data": {
                    //           "symbol": "XBTUSDM",      //Symbol
                    //           "sequence": 100,          //Ticker sequence number
                    //           "asks": [
                    //                 ["5000.0", 1000],   //Price, quantity
                    //                 ["6000.0", 1983]    //Price, quantity
                    //           ],
                    //           "bids": [
                    //                 ["3200.0", 800],    //Price, quantity
                    //                 ["3100.0", 100]     //Price, quantity
                    //           ],
                    //           "ts": 1604643655040584408  // timestamp
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const timestamp = parseInt(this.safeInteger(data, 'ts') / 1000000);
                    const orderbook = this.parseOrderBook(data, symbol, timestamp, 'bids', 'asks', 0, 1);
                    orderbook['nonce'] = this.safeInteger(data, 'sequence');
                    return orderbook;
                }
                async fetchL3OrderBook(symbol, limit, params = {}) {
                    throw new BadRequest(this.id + ' fetchL3OrderBook() is not supported yet');
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.futuresPublicGetTicker(this.extend(request, params));
                    //
                    //    {
                    //        "code": "200000",
                    //        "data": {
                    //            "sequence": 1638444978558,
                    //            "symbol": "ETHUSDTM",
                    //            "side": "sell",
                    //            "size": 4,
                    //            "price": "4229.35",
                    //            "bestBidSize": 2160,
                    //            "bestBidPrice": "4229.0",
                    //            "bestAskPrice": "4229.05",
                    //            "tradeId": "61aaa8b777a0c43055fe4851",
                    //            "ts": 1638574296209786785,
                    //            "bestAskSize": 36,
                    //        }
                    //    }
                    //
                    return this.parseTicker(response['data'], market);
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "code": "200000",
                    //         "data": {
                    //             "sequence":  1629930362547,
                    //             "symbol": "ETHUSDTM",
                    //             "side": "buy",
                    //             "size":  130,
                    //             "price": "4724.7",
                    //             "bestBidSize":  5,
                    //             "bestBidPrice": "4724.6",
                    //             "bestAskPrice": "4724.65",
                    //             "tradeId": "618d2a5a77a0c4431d2335f4",
                    //             "ts":  1636641371963227600,
                    //             "bestAskSize":  1789
                    //          }
                    //     }
                    //
                    const last = this.safeString(ticker, 'price');
                    const marketId = this.safeString(ticker, 'symbol');
                    market = this.safeMarket(marketId, market, '-');
                    const timestamp = Precise.stringDiv(this.safeString(ticker, 'ts'), '1000000');
                    return this.safeTicker({
                        'symbol': market['symbol'],
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': undefined,
                        'low': undefined,
                        'bid': this.safeString(ticker, 'bestBidPrice'),
                        'bidVolume': this.safeString(ticker, 'bestBidSize'),
                        'ask': this.safeString(ticker, 'bestAskPrice'),
                        'askVolume': this.safeString(ticker, 'bestAskSize'),
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': undefined,
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchFundingHistory(symbol, since, limit, params = {}) {
                    //
                    // Private
                    // @param symbol (string): The pair for which the contract was traded
                    // @param since (number): The unix start time of the first funding payment requested
                    // @param limit (number): The number of results to return
                    // @param params (dict): Additional parameters to send to the API
                    // @param return: Data for the history of the accounts funding payments for futures contracts
                    //
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchFundingHistory() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['startAt'] = since;
                    if (limit !== undefined) // * Since is ignored if limit is defined
                    request['maxCount'] = limit;
                    const response = await this.futuresPrivateGetFundingHistory(this.extend(request, params));
                    //
                    //    {
                    //        "code": "200000",
                    //        "data": {
                    //            "dataList": [
                    //                {
                    //                    "id": 239471298749817,
                    //                    "symbol": "ETHUSDTM",
                    //                    "timePoint": 1638532800000,
                    //                    "fundingRate": 0.000100,
                    //                    "markPrice": 4612.8300000000,
                    //                    "positionQty": 12,
                    //                    "positionCost": 553.5396000000,
                    //                    "funding": -0.0553539600,
                    //                    "settleCurrency": "USDT"
                    //                },
                    //                ...
                    //            ],
                    //            "hasMore": true
                    //        }
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    const dataList = this.safeValue(data, 'dataList');
                    const fees = [];
                    for(let i = 0; i < dataList.length; i++){
                        const listItem = dataList[i];
                        const timestamp = this.safeInteger(listItem, 'timePoint');
                        fees.push({
                            'info': listItem,
                            'symbol': symbol,
                            'code': this.safeCurrencyCode(this.safeString(listItem, 'settleCurrency')),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'id': this.safeNumber(listItem, 'id'),
                            'amount': this.safeNumber(listItem, 'funding'),
                            'fundingRate': this.safeNumber(listItem, 'fundingRate'),
                            'markPrice': this.safeNumber(listItem, 'markPrice'),
                            'positionQty': this.safeNumber(listItem, 'positionQty'),
                            'positionCost': this.safeNumber(listItem, 'positionCost')
                        });
                    }
                    return fees;
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.futuresPrivateGetPositions(params);
                    //
                    //    {
                    //        "code": "200000",
                    //        "data": [
                    //            {
                    //                "id": "615ba79f83a3410001cde321",
                    //                "symbol": "ETHUSDTM",
                    //                "autoDeposit": false,
                    //                "maintMarginReq": 0.005,
                    //                "riskLimit": 1000000,
                    //                "realLeverage": 18.61,
                    //                "crossMode": false,
                    //                "delevPercentage": 0.86,
                    //                "openingTimestamp": 1638563515618,
                    //                "currentTimestamp": 1638576872774,
                    //                "currentQty": 2,
                    //                "currentCost": 83.64200000,
                    //                "currentComm": 0.05018520,
                    //                "unrealisedCost": 83.64200000,
                    //                "realisedGrossCost": 0.00000000,
                    //                "realisedCost": 0.05018520,
                    //                "isOpen": true,
                    //                "markPrice": 4225.01,
                    //                "markValue": 84.50020000,
                    //                "posCost": 83.64200000,
                    //                "posCross": 0.0000000000,
                    //                "posInit": 3.63660870,
                    //                "posComm": 0.05236717,
                    //                "posLoss": 0.00000000,
                    //                "posMargin": 3.68897586,
                    //                "posMaint": 0.50637594,
                    //                "maintMargin": 4.54717586,
                    //                "realisedGrossPnl": 0.00000000,
                    //                "realisedPnl": -0.05018520,
                    //                "unrealisedPnl": 0.85820000,
                    //                "unrealisedPnlPcnt": 0.0103,
                    //                "unrealisedRoePcnt": 0.2360,
                    //                "avgEntryPrice": 4182.10,
                    //                "liquidationPrice": 4023.00,
                    //                "bankruptPrice": 4000.25,
                    //                "settleCurrency": "USDT",
                    //                "isInverse": false
                    //            }
                    //        ]
                    //    }
                    //
                    return this.parsePositions(this.safeValue(response, 'data'));
                }
                parsePositions(positions) {
                    const result = [];
                    for(let i = 0; i < positions.length; i++)result.push(this.parsePosition(positions[i]));
                    return result;
                }
                parsePosition(position, market) {
                    //
                    //    {
                    //        "code": "200000",
                    //        "data": [
                    //            {
                    //                "id": "615ba79f83a3410001cde321",         // Position ID
                    //                "symbol": "ETHUSDTM",                     // Symbol
                    //                "autoDeposit": false,                     // Auto deposit margin or not
                    //                "maintMarginReq": 0.005,                  // Maintenance margin requirement
                    //                "riskLimit": 1000000,                     // Risk limit
                    //                "realLeverage": 25.92,                    // Leverage of the order
                    //                "crossMode": false,                       // Cross mode or not
                    //                "delevPercentage": 0.76,                  // ADL ranking percentile
                    //                "openingTimestamp": 1638578546031,        // Open time
                    //                "currentTimestamp": 1638578563580,        // Current timestamp
                    //                "currentQty": 2,                          // Current postion quantity
                    //                "currentCost": 83.787,                    // Current postion value
                    //                "currentComm": 0.0167574,                 // Current commission
                    //                "unrealisedCost": 83.787,                 // Unrealised value
                    //                "realisedGrossCost": 0.0,                 // Accumulated realised gross profit value
                    //                "realisedCost": 0.0167574,                // Current realised position value
                    //                "isOpen": true,                           // Opened position or not
                    //                "markPrice": 4183.38,                     // Mark price
                    //                "markValue": 83.6676,                     // Mark value
                    //                "posCost": 83.787,                        // Position value
                    //                "posCross": 0.0,                          // added margin
                    //                "posInit": 3.35148,                       // Leverage margin
                    //                "posComm": 0.05228309,                    // Bankruptcy cost
                    //                "posLoss": 0.0,                           // Funding fees paid out
                    //                "posMargin": 3.40376309,                  // Position margin
                    //                "posMaint": 0.50707892,                   // Maintenance margin
                    //                "maintMargin": 3.28436309,                // Position margin
                    //                "realisedGrossPnl": 0.0,                  // Accumulated realised gross profit value
                    //                "realisedPnl": -0.0167574,                // Realised profit and loss
                    //                "unrealisedPnl": -0.1194,                 // Unrealised profit and loss
                    //                "unrealisedPnlPcnt": -0.0014,             // Profit-loss ratio of the position
                    //                "unrealisedRoePcnt": -0.0356,             // Rate of return on investment
                    //                "avgEntryPrice": 4189.35,                 // Average entry price
                    //                "liquidationPrice": 4044.55,              // Liquidation price
                    //                "bankruptPrice": 4021.75,                 // Bankruptcy price
                    //                "settleCurrency": "USDT",                 // Currency used to clear and settle the trades
                    //                "isInverse": false
                    //            }
                    //        ]
                    //    }
                    //
                    const symbol = this.safeString(position, 'symbol');
                    market = this.safeMarket(symbol, market);
                    const timestamp = this.safeNumber(position, 'currentTimestamp');
                    const size = this.safeString(position, 'currentQty');
                    let side = undefined;
                    if (Precise.stringGt(size, '0')) side = 'long';
                    else if (Precise.stringLt(size, '0')) side = 'short';
                    const notional = Precise.stringAbs(this.safeString(position, 'posCost'));
                    const initialMargin = this.safeString(position, 'posInit');
                    const initialMarginPercentage = Precise.stringDiv(initialMargin, notional);
                    // const marginRatio = Precise.stringDiv (maintenanceRate, collateral);
                    const unrealisedPnl = this.safeString(position, 'unrealisedPnl');
                    const crossMode = this.safeValue(position, 'crossMode');
                    // currently crossMode is always set to false and only isolated positions are supported
                    const marginMode = crossMode ? 'cross' : 'isolated';
                    return {
                        'info': position,
                        'symbol': this.safeString(market, 'symbol'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'initialMargin': this.parseNumber(initialMargin),
                        'initialMarginPercentage': this.parseNumber(initialMarginPercentage),
                        'maintenanceMargin': this.safeNumber(position, 'posMaint'),
                        'maintenanceMarginPercentage': this.safeNumber(position, 'maintMarginReq'),
                        'entryPrice': this.safeNumber(position, 'avgEntryPrice'),
                        'notional': this.parseNumber(notional),
                        'leverage': this.safeNumber(position, 'realLeverage'),
                        'unrealizedPnl': this.parseNumber(unrealisedPnl),
                        'contracts': this.parseNumber(Precise.stringAbs(size)),
                        'contractSize': this.safeValue(market, 'contractSize'),
                        //     realisedPnl: position['realised_pnl'],
                        'marginRatio': undefined,
                        'liquidationPrice': this.safeNumber(position, 'liquidationPrice'),
                        'markPrice': this.safeNumber(position, 'markPrice'),
                        'collateral': this.safeNumber(position, 'maintMargin'),
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'side': side,
                        'percentage': this.parseNumber(Precise.stringDiv(unrealisedPnl, initialMargin))
                    };
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    /**
         * @method
         * @name kucoinfutures#createOrder
         * @description Create an order on the exchange
         * @param {str} symbol Unified CCXT market symbol
         * @param {str} type "limit" or "market"
         * @param {str} side "buy" or "sell"
         * @param {float} amount the amount of currency to trade
         * @param {float} price *ignored in "market" orders* the price at which the order is to be fullfilled at in units of the quote currency
         * @param {dict} params  Extra parameters specific to the exchange API endpoint
         * @param {float} params.leverage Leverage size of the order
         * @param {float} params.stopPrice The price at which a trigger order is triggered at
         * @param {bool} params.reduceOnly A mark to reduce the position size only. Set to false by default. Need to set the position size when reduceOnly is true.
         * @param {str} params.timeInForce GTC, GTT, IOC, or FOK, default is GTC, limit orders only
         * @param {str} params.postOnly Post only flag, invalid when timeInForce is IOC or FOK
         * @param {str} params.clientOid client order id, defaults to uuid if not passed
         * @param {str} params.remark remark for the order, length cannot exceed 100 utf8 characters
         * @param {str} params.stop 'up' or 'down', defaults to 'up' if side is sell and 'down' if side is buy, requires stopPrice
         * @param {str} params.stopPriceType  TP, IP or MP, defaults to TP
         * @param {bool} params.closeOrder set to true to close position
         * @param {bool} params.forceHold A mark to forcely hold the funds for an order, even though it's an order to reduce the position size. This helps the order stay on the order book and not get canceled when the position size changes. Set to false by default.
         * @returns an [order structure]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ await this.loadMarkets();
                    const market = this.market(symbol);
                    // required param, cannot be used twice
                    const clientOrderId = this.safeString2(params, 'clientOid', 'clientOrderId', this.uuid());
                    params = this.omit(params, [
                        'clientOid',
                        'clientOrderId'
                    ]);
                    if (amount < 1) throw new InvalidOrder(this.id + ' createOrder() minimum contract order amount is 1');
                    const preciseAmount = parseInt(this.amountToPrecision(symbol, amount));
                    const request = {
                        'clientOid': clientOrderId,
                        'side': side,
                        'symbol': market['id'],
                        'type': type,
                        'size': preciseAmount,
                        'leverage': 1
                    };
                    const stopPrice = this.safeNumber(params, 'stopPrice');
                    if (stopPrice) {
                        request['stop'] = side === 'buy' ? 'up' : 'down';
                        const stopPriceType = this.safeString(params, 'stopPriceType', 'TP');
                        request['stopPriceType'] = stopPriceType;
                    }
                    const uppercaseType = type.toUpperCase();
                    let timeInForce = this.safeString(params, 'timeInForce');
                    if (uppercaseType === 'LIMIT') {
                        if (price === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a price argument for limit orders');
                        else request['price'] = this.priceToPrecision(symbol, price);
                        if (timeInForce !== undefined) {
                            timeInForce = timeInForce.toUpperCase();
                            request['timeInForce'] = timeInForce;
                        }
                    }
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    const hidden = this.safeValue(params, 'hidden');
                    if (postOnly && hidden !== undefined) throw new BadRequest(this.id + ' createOrder() does not support the postOnly parameter together with a hidden parameter');
                    const iceberg = this.safeValue(params, 'iceberg');
                    if (iceberg) {
                        const visibleSize = this.safeValue(params, 'visibleSize');
                        if (visibleSize === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a visibleSize parameter for iceberg orders');
                    }
                    params = this.omit(params, 'timeInForce'); // Time in force only valid for limit orders, exchange error when gtc for market orders
                    const response = await this.futuresPrivatePostOrders(this.extend(request, params));
                    //
                    //    {
                    //        code: "200000",
                    //        data: {
                    //            orderId: "619717484f1d010001510cde",
                    //        },
                    //    }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return {
                        'id': this.safeString(data, 'orderId'),
                        'clientOrderId': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'lastTradeTimestamp': undefined,
                        'symbol': undefined,
                        'type': undefined,
                        'side': undefined,
                        'price': undefined,
                        'amount': undefined,
                        'cost': undefined,
                        'average': undefined,
                        'filled': undefined,
                        'remaining': undefined,
                        'status': undefined,
                        'fee': undefined,
                        'trades': undefined,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'stopPrice': undefined,
                        'info': response
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderId': id
                    };
                    const response = await this.futuresPrivateDeleteOrdersOrderId(this.extend(request, params));
                    //
                    //   {
                    //       code: "200000",
                    //       data: {
                    //           cancelledOrderIds: [
                    //                "619714b8b6353000014c505a",
                    //           ],
                    //       },
                    //   }
                    //
                    return this.safeValue(response, 'data');
                }
                async cancelAllOrders(symbol, params = {}) {
                    /**
         * @method
         * @name kucoinfutures#cancelAllOrders
         * @description Cancels all orders in one api call
         * @param {str} symbol Assign to cancel only the orders in the market matching the unified symbol
         * @param {dict} params Exchange specific parameters
         * @param {dict} params.stop When true, all the trigger orders will be cancelled
         * @returns Response from the exchange
         */ await this.loadMarkets();
                    const request = {};
                    if (symbol !== undefined) request['symbol'] = this.marketId(symbol);
                    const stop = this.safeValue(params, 'stop');
                    const method = stop ? 'futuresPrivateDeleteStopOrders' : 'futuresPrivateDeleteOrders';
                    const response = await this[method](this.extend(request, params));
                    //
                    //   {
                    //       code: "200000",
                    //       data: {
                    //           cancelledOrderIds: [
                    //                "619714b8b6353000014c505a",
                    //           ],
                    //       },
                    //   }
                    //
                    return this.safeValue(response, 'data');
                }
                async addMargin(symbol, amount, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const uuid = this.uuid();
                    const request = {
                        'symbol': market['id'],
                        'margin': amount,
                        'bizNo': uuid
                    };
                    return await this.futuresPrivatePostPositionMarginDepositMargin(this.extend(request, params));
                }
                async fetchOrdersByStatus(status, symbol, since, limit, params = {}) {
                    /**
         * @method
         * @name kucoinfutures#fetchOrdersByStatus
         * @description fetches a list of orders placed on the exchange
         * @param {str} status 'active' or 'closed', only 'active' is valid for stop orders
         * @param {str} symbol unified symbol for the market to retrieve orders from
         * @param {int} since timestamp in ms of the earliest order to retrieve
         * @param {int} limit The maximum number of orders to retrieve
         * @param {dict} params exchange specific parameters
         * @param {bool} params.stop set to true to retrieve untriggered stop orders
         * @param {int} params.till End time in ms
         * @param {str} params.side buy or sell
         * @param {str} params.type limit or market
         * @returns An [array of order structures]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ await this.loadMarkets();
                    const stop = this.safeValue(params, 'stop');
                    params = this.omit(params, 'stop');
                    if (status === 'closed') status = 'done';
                    else if (status === 'open') status = 'active';
                    const request = {};
                    if (!stop) request['status'] = status;
                    else if (status !== 'active') throw new BadRequest(this.id + ' fetchOrdersByStatus() can only fetch untriggered stop orders');
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['startAt'] = since;
                    const till = this.safeInteger(params, 'till', 'endAt');
                    if (till !== undefined) request['endAt'] = till;
                    const method = stop ? 'futuresPrivateGetStopOrders' : 'futuresPrivateGetOrders';
                    const response = await this[method](this.extend(request, params));
                    const responseData = this.safeValue(response, 'data', {});
                    const orders = this.safeValue(responseData, 'items', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    /**
         * @method
         * @name kucoinfutures#fetchClosedOrders
         * @description fetch a list of orders
         * @param {str} symbol unified market symbol
         * @param {int} since timestamp in ms of the earliest order
         * @param {int} limit max number of orders to return
         * @param {dict} params exchange specific params
         * @param {int} params.till end time in ms
         * @param {str} params.side buy or sell
         * @param {str} params.type limit, or market
         * @returns An [array of order structures]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ return await this.fetchOrdersByStatus('done', symbol, since, limit, params);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let method = 'futuresPrivateGetOrdersOrderId';
                    if (id === undefined) {
                        const clientOrderId = this.safeString2(params, 'clientOid', 'clientOrderId');
                        if (clientOrderId === undefined) throw new InvalidOrder(this.id + ' fetchOrder() requires parameter id or params.clientOid');
                        request['clientOid'] = clientOrderId;
                        method = 'futuresPrivateGetOrdersByClientOid';
                        params = this.omit(params, [
                            'clientOid',
                            'clientOrderId'
                        ]);
                    } else request['orderId'] = id;
                    const response = await this[method](this.extend(request, params));
                    const market = symbol !== undefined ? this.market(symbol) : undefined;
                    const responseData = this.safeValue(response, 'data');
                    return this.parseOrder(responseData, market);
                }
                parseOrder(order, market) {
                    const marketId = this.safeString(order, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const orderId = this.safeString(order, 'id');
                    const type = this.safeString(order, 'type');
                    const timestamp = this.safeInteger(order, 'createdAt');
                    const datetime = this.iso8601(timestamp);
                    const price = this.safeString(order, 'price');
                    // price is zero for market order
                    // omitZero is called in safeOrder2
                    const side = this.safeString(order, 'side');
                    const feeCurrencyId = this.safeString(order, 'feeCurrency');
                    const feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                    const feeCost = this.safeNumber(order, 'fee');
                    const amount = this.safeString(order, 'size');
                    const filled = this.safeString(order, 'dealSize');
                    const rawCost = this.safeString2(order, 'dealFunds', 'filledValue');
                    const leverage = this.safeString(order, 'leverage');
                    const cost = Precise.stringDiv(rawCost, leverage);
                    let average = undefined;
                    if (Precise.stringGt(filled, '0')) {
                        const contractSize = this.safeString(market, 'contractSize');
                        if (market['linear']) average = Precise.stringDiv(rawCost, Precise.stringMul(contractSize, filled));
                        else average = Precise.stringDiv(Precise.stringMul(contractSize, filled), rawCost);
                    }
                    // precision reported by their api is 8 d.p.
                    // const average = Precise.stringDiv (rawCost, Precise.stringMul (filled, market['contractSize']));
                    // bool
                    const isActive = this.safeValue(order, 'isActive', false);
                    const cancelExist = this.safeValue(order, 'cancelExist', false);
                    let status = isActive ? 'open' : 'closed';
                    status = cancelExist ? 'canceled' : status;
                    const fee = {
                        'currency': feeCurrency,
                        'cost': feeCost
                    };
                    const clientOrderId = this.safeString(order, 'clientOid');
                    const timeInForce = this.safeString(order, 'timeInForce');
                    const stopPrice = this.safeNumber(order, 'stopPrice');
                    const postOnly = this.safeValue(order, 'postOnly');
                    return this.safeOrder({
                        'id': orderId,
                        'clientOrderId': clientOrderId,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'amount': amount,
                        'price': price,
                        'stopPrice': stopPrice,
                        'cost': cost,
                        'filled': filled,
                        'remaining': undefined,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'fee': fee,
                        'status': status,
                        'info': order,
                        'lastTradeTimestamp': undefined,
                        'average': average,
                        'trades': undefined
                    }, market);
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    const response = await this.futuresPublicGetFundingRateSymbolCurrent(this.extend(request, params));
                    //
                    //    {
                    //        code: "200000",
                    //        data: {
                    //            symbol: ".ETHUSDTMFPI8H",
                    //            granularity: 28800000,
                    //            timePoint: 1637380800000,
                    //            value: 0.0001,
                    //            predictedValue: 0.0001,
                    //        },
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    const fundingTimestamp = this.safeNumber(data, 'timePoint');
                    return {
                        'info': data,
                        'symbol': symbol,
                        'markPrice': undefined,
                        'indexPrice': undefined,
                        'interestRate': undefined,
                        'estimatedSettlePrice': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'fundingRate': this.safeNumber(data, 'value'),
                        'fundingTimestamp': fundingTimestamp,
                        'fundingDatetime': this.iso8601(fundingTimestamp),
                        'nextFundingRate': this.safeNumber(data, 'predictedValue'),
                        'nextFundingTimestamp': undefined,
                        'nextFundingDatetime': undefined,
                        'previousFundingRate': undefined,
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const data = this.safeValue(response, 'data');
                    const currencyId = this.safeString(data, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    const account = this.account();
                    account['free'] = this.safeString(data, 'availableBalance');
                    account['total'] = this.safeString(data, 'accountEquity');
                    result[code] = account;
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    // only fetches one balance at a time
                    let defaultCode = this.safeString(this.options, 'code');
                    const fetchBalanceOptions = this.safeValue(this.options, 'fetchBalance', {});
                    defaultCode = this.safeString(fetchBalanceOptions, 'code', defaultCode);
                    const code = this.safeString(params, 'code', defaultCode);
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.futuresPrivateGetAccountOverview(this.extend(request, params));
                    //
                    //     {
                    //         code: '200000',
                    //         data: {
                    //             accountEquity: 0.00005,
                    //             unrealisedPNL: 0,
                    //             marginBalance: 0.00005,
                    //             positionMargin: 0,
                    //             orderMargin: 0,
                    //             frozenFunds: 0,
                    //             availableBalance: 0.00005,
                    //             currency: 'XBT'
                    //         }
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    if (toAccount !== 'main' && toAccount !== 'funding' || fromAccount !== 'futures' && fromAccount !== 'future' && fromAccount !== 'contract') throw new BadRequest(this.id + ' transfer() only supports transfers from contract(future) account to main(funding) account');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const amountToPrecision = this.currencyToPrecision(code, amount);
                    const request = {
                        'currency': this.safeString(currency, 'id'),
                        'amount': amountToPrecision
                    };
                    // transfer from usdm futures wallet to spot wallet
                    const response = await this.futuresPrivatePostTransferOut(this.extend(request, params));
                    //
                    //    {
                    //        "code": "200000",
                    //        "data": {
                    //            "applyId": "5bffb63303aa675e8bbe18f9" // Transfer-out request ID
                    //        }
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.extend(this.parseTransfer(data, currency), {
                        'amount': this.parseNumber(amountToPrecision),
                        'fromAccount': 'future',
                        'toAccount': 'spot'
                    });
                }
                parseTransfer(transfer, currency) {
                    //
                    // transfer
                    //
                    //     {
                    //            "applyId": "5bffb63303aa675e8bbe18f9" // Transfer-out request ID
                    //     }
                    //
                    const timestamp = this.safeString(transfer, 'updatedAt');
                    return {
                        'id': this.safeString(transfer, 'applyId'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': this.safeCurrencyCode(undefined, currency),
                        'amount': undefined,
                        'fromAccount': undefined,
                        'toAccount': undefined,
                        'status': this.safeString(transfer, 'status'),
                        'info': transfer
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'PROCESSING': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['startAt'] = since;
                    const response = await this.futuresPrivateGetFills(this.extend(request, params));
                    //
                    //    {
                    //        "code": "200000",
                    //        "data": {
                    //          "currentPage": 1,
                    //          "pageSize": 1,
                    //          "totalNum": 251915,
                    //          "totalPage": 251915,
                    //          "items": [
                    //              {
                    //                  "symbol": "XBTUSDM",  // Ticker symbol of the contract
                    //                  "tradeId": "5ce24c1f0c19fc3c58edc47c",  // Trade ID
                    //                  "orderId": "5ce24c16b210233c36ee321d",  // Order ID
                    //                  "side": "sell",  // Transaction side
                    //                  "liquidity": "taker",  // Liquidity- taker or maker
                    //                  "price": "8302",  // Filled price
                    //                  "size": 10,  // Filled amount
                    //                  "value": "0.001204529",  // Order value
                    //                  "feeRate": "0.0005",  // Floating fees
                    //                  "fixFee": "0.00000006",  // Fixed fees
                    //                  "feeCurrency": "XBT",  // Charging currency
                    //                  "stop": "",  // A mark to the stop order type
                    //                  "fee": "0.0000012022",  // Transaction fee
                    //                  "orderType": "limit",  // Order type
                    //                  "tradeType": "trade",  // Trade type (trade, liquidation, ADL or settlement)
                    //                  "createdAt": 1558334496000,  // Time the order created
                    //                  "settleCurrency": "XBT", // settlement currency
                    //                  "tradeTime": 1558334496000000000 // trade time in nanosecond
                    //              }
                    //            ]
                    //        }
                    //    }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const trades = this.safeValue(data, 'items', {});
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.futuresPublicGetTradeHistory(this.extend(request, params));
                    //
                    //      {
                    //          "code": "200000",
                    //          "data": [
                    //              {
                    //                  "sequence": 32114961,
                    //                  "side": "buy",
                    //                  "size": 39,
                    //                  "price": "4001.6500000000",
                    //                  "takerOrderId": "61c20742f172110001e0ebe4",
                    //                  "makerOrderId": "61c2073fcfc88100010fcb5d",
                    //                  "tradeId": "61c2074277a0c473e69029b8",
                    //                  "ts": 1640105794099993896   // filled time
                    //              }
                    //          ]
                    //      }
                    //
                    const trades = this.safeValue(response, 'data', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "sequence": 32114961,
                    //         "side": "buy",
                    //         "size": 39,
                    //         "price": "4001.6500000000",
                    //         "takerOrderId": "61c20742f172110001e0ebe4",
                    //         "makerOrderId": "61c2073fcfc88100010fcb5d",
                    //         "tradeId": "61c2074277a0c473e69029b8",
                    //         "ts": 1640105794099993896   // filled time
                    //     }
                    //
                    // fetchMyTrades (private) v2
                    //
                    //     {
                    //         "symbol":"BTC-USDT",
                    //         "tradeId":"5c35c02709e4f67d5266954e",
                    //         "orderId":"5c35c02703aa673ceec2a168",
                    //         "counterOrderId":"5c1ab46003aa676e487fa8e3",
                    //         "side":"buy",
                    //         "liquidity":"taker",
                    //         "forceTaker":true,
                    //         "price":"0.083",
                    //         "size":"0.8424304",
                    //         "funds":"0.0699217232",
                    //         "fee":"0",
                    //         "feeRate":"0",
                    //         "feeCurrency":"USDT",
                    //         "stop":"",
                    //         "type":"limit",
                    //         "createdAt":1547026472000
                    //     }
                    //
                    // fetchMyTrades (private) v1
                    //
                    //      {
                    //          "symbol":"DOGEUSDTM",
                    //          "tradeId":"620ec41a96bab27b5f4ced56",
                    //          "orderId":"620ec41a0d1d8a0001560bd0",
                    //          "side":"sell",
                    //          "liquidity":"taker",
                    //          "forceTaker":true,
                    //          "price":"0.13969",
                    //          "size":1,
                    //          "value":"13.969",
                    //          "feeRate":"0.0006",
                    //          "fixFee":"0",
                    //          "feeCurrency":"USDT",
                    //          "stop":"",
                    //          "tradeTime":1645134874858018058,
                    //          "fee":"0.0083814",
                    //          "settleCurrency":"USDT",
                    //          "orderType":"market",
                    //          "tradeType":"trade",
                    //          "createdAt":1645134874858
                    //      }
                    //
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market, '-');
                    const id = this.safeString2(trade, 'tradeId', 'id');
                    const orderId = this.safeString(trade, 'orderId');
                    const takerOrMaker = this.safeString(trade, 'liquidity');
                    let timestamp = this.safeInteger(trade, 'time');
                    if (timestamp !== undefined) timestamp = parseInt(timestamp / 1000000);
                    else {
                        timestamp = this.safeInteger(trade, 'createdAt');
                        // if it's a historical v1 trade, the exchange returns timestamp in seconds
                        if ('dealValue' in trade && timestamp !== undefined) timestamp = timestamp * 1000;
                    }
                    const priceString = this.safeString2(trade, 'price', 'dealPrice');
                    const amountString = this.safeString2(trade, 'size', 'amount');
                    const side = this.safeString(trade, 'side');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'fee');
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'feeCurrency');
                        let feeCurrency = this.safeCurrencyCode(feeCurrencyId);
                        if (feeCurrency === undefined) feeCurrency = side === 'sell' ? market['quote'] : market['base'];
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrency,
                            'rate': this.safeString(trade, 'feeRate')
                        };
                    }
                    let type = this.safeString2(trade, 'type', 'orderType');
                    if (type === 'match') type = undefined;
                    let costString = this.safeString2(trade, 'funds', 'value');
                    if (costString === undefined) {
                        const contractSize = this.safeString(market, 'contractSize');
                        const contractCost = Precise.stringMul(priceString, amountString);
                        costString = Precise.stringMul(contractCost, contractSize);
                    }
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': type,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['pageSize'] = limit;
                    if (since !== undefined) request['startAt'] = since;
                    const response = await this.futuresPrivateGetDepositList(this.extend(request, params));
                    //
                    //     {
                    //         code: '200000',
                    //         data: {
                    //             "currentPage": 1,
                    //             "pageSize": 5,
                    //             "totalNum": 2,
                    //             "totalPage": 1,
                    //             "items": [
                    //                 {
                    //                     "address": "0x5f047b29041bcfdbf0e4478cdfa753a336ba6989",
                    //                     "memo": "5c247c8a03aa677cea2a251d",
                    //                     "amount": 1,
                    //                     "fee": 0.0001,
                    //                     "currency": "KCS",
                    //                     "isInner": false,
                    //                     "walletTxId": "5bbb57386d99522d9f954c5a@test004",
                    //                     "status": "SUCCESS",
                    //                     "createdAt": 1544178843000,
                    //                     "updatedAt": 1544178891000
                    //                     "remark":"foobar"
                    //                 },
                    //                 ...
                    //             ]
                    //         }
                    //     }
                    //
                    const responseData = response['data']['items'];
                    return this.parseTransactions(responseData, currency, since, limit, {
                        'type': 'deposit'
                    });
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['pageSize'] = limit;
                    if (since !== undefined) request['startAt'] = since;
                    const response = await this.futuresPrivateGetWithdrawalList(this.extend(request, params));
                    //
                    //     {
                    //         code: '200000',
                    //         data: {
                    //             "currentPage": 1,
                    //             "pageSize": 5,
                    //             "totalNum": 2,
                    //             "totalPage": 1,
                    //             "items": [
                    //                 {
                    //                     "id": "5c2dc64e03aa675aa263f1ac",
                    //                     "address": "0x5bedb060b8eb8d823e2414d82acce78d38be7fe9",
                    //                     "memo": "",
                    //                     "currency": "ETH",
                    //                     "amount": 1.0000000,
                    //                     "fee": 0.0100000,
                    //                     "walletTxId": "3e2414d82acce78d38be7fe9",
                    //                     "isInner": false,
                    //                     "status": "FAILURE",
                    //                     "createdAt": 1546503758000,
                    //                     "updatedAt": 1546504603000
                    //                 },
                    //                 ...
                    //             ]
                    //         }
                    //     }
                    //
                    const responseData = response['data']['items'];
                    return this.parseTransactions(responseData, currency, since, limit, {
                        'type': 'withdrawal'
                    });
                }
                async fetchFundingFee(code, params = {}) {
                    throw new BadRequest(this.id + ' fetchFundingFee() is not supported yet');
                }
                async fetchLedger(code, since, limit, params = {}) {
                    throw new BadRequest(this.id + ' fetchLedger() is not supported yet');
                }
                async fetchMarketLeverageTiers(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (!market['contract']) throw new BadRequest(this.id + ' fetchLeverageTiers() supports contract markets only');
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.futuresPublicGetContractsRiskLimitSymbol(this.extend(request, params));
                    //
                    //    {
                    //        "code": "200000",
                    //        "data": [
                    //            {
                    //                "symbol": "ETHUSDTM",
                    //                "level": 1,
                    //                "maxRiskLimit": 300000,
                    //                "minRiskLimit": 0,
                    //                "maxLeverage": 100,
                    //                "initialMargin": 0.0100000000,
                    //                "maintainMargin": 0.0050000000
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseMarketLeverageTiers(data, market);
                }
                parseMarketLeverageTiers(info, market) {
                    /**
         * @ignore
         * @method
         * @param {dict} info Exchange market response for 1 market
         * @param {dict} market CCXT market
         */ //
                    //    {
                    //        "symbol": "ETHUSDTM",
                    //        "level": 1,
                    //        "maxRiskLimit": 300000,
                    //        "minRiskLimit": 0,
                    //        "maxLeverage": 100,
                    //        "initialMargin": 0.0100000000,
                    //        "maintainMargin": 0.0050000000
                    //    }
                    //
                    const tiers = [];
                    for(let i = 0; i < info.length; i++){
                        const tier = info[i];
                        tiers.push({
                            'tier': this.safeNumber(tier, 'level'),
                            'currency': market['base'],
                            'minNotional': this.safeNumber(tier, 'minRiskLimit'),
                            'maxNotional': this.safeNumber(tier, 'maxRiskLimit'),
                            'maintenanceMarginRate': this.safeNumber(tier, 'maintainMargin'),
                            'maxLeverage': this.safeNumber(tier, 'maxLeverage'),
                            'info': tier
                        });
                    }
                    return tiers;
                }
            };
        },
        {
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14,
            "./kucoin.js": 96
        }
    ],
    98: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ArgumentsRequired: ArgumentsRequired1, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, NotSupported: NotSupported } = require1('./base/errors');
            // ---------------------------------------------------------------------------
            module.exports = class kuna extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'kuna',
                        'name': 'Kuna',
                        'countries': [
                            'UA'
                        ],
                        'rateLimit': 1000,
                        'version': 'v2',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchL3OrderBook': true,
                            'fetchLeverage': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': 'emulated',
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setPositionMode': false,
                            'withdraw': undefined
                        },
                        'timeframes': undefined,
                        'urls': {
                            'extension': '.json',
                            'referral': 'https://kuna.io?r=kunaid-gvfihe8az7o4',
                            'logo': 'https://user-images.githubusercontent.com/51840849/87153927-f0578b80-c2c0-11ea-84b6-74612568e9e1.jpg',
                            'api': {
                                'xreserve': 'https://api.xreserve.fund',
                                'v3': 'https://api.kuna.io',
                                'public': 'https://kuna.io',
                                'private': 'https://kuna.io'
                            },
                            'www': 'https://kuna.io',
                            'doc': 'https://kuna.io/documents/api',
                            'fees': 'https://kuna.io/documents/api'
                        },
                        'api': {
                            'xreserve': {
                                'get': {
                                    'nonce': 1,
                                    'fee': 1,
                                    'delegated-transactions': 1
                                },
                                'post': {
                                    'delegate-transfer': 1
                                }
                            },
                            'v3': {
                                'public': {
                                    'get': {
                                        'timestamp': 1,
                                        'currencies': 1,
                                        'markets': 1,
                                        'tickers': 1,
                                        'k': 1,
                                        'trades_history': 1,
                                        'fees': 1,
                                        'exchange-rates': 1,
                                        'exchange-rates/currency': 1,
                                        'book/market': 1,
                                        'kuna_codes/code/check': 1,
                                        'landing_page_statistic': 1,
                                        'translations/locale': 1,
                                        'trades/market/hist': 1
                                    },
                                    'post': {
                                        'http_test': 1,
                                        'deposit_channels': 1,
                                        'withdraw_channels': 1,
                                        'subscription_plans': 1,
                                        'send_to': 1,
                                        'confirm_token': 1,
                                        'kunaid': 1,
                                        'withdraw/prerequest': 1,
                                        'deposit/prerequest': 1,
                                        'deposit/exchange-rates': 1
                                    }
                                },
                                'sign': {
                                    'get': {
                                        'reset_password/token': 1
                                    },
                                    'post': {
                                        'signup/google': 1,
                                        'signup/resend_confirmation': 1,
                                        'signup': 1,
                                        'signin': 1,
                                        'signin/two_factor': 1,
                                        'signin/resend_confirm_device': 1,
                                        'signin/confirm_device': 1,
                                        'reset_password': 1,
                                        'cool-signin': 1
                                    },
                                    'put': {
                                        'reset_password/token': 1,
                                        'signup/code/confirm': 1
                                    }
                                },
                                'private': {
                                    'post': {
                                        'auth/w/order/submit': 1,
                                        'auth/r/orders': 1,
                                        'auth/r/orders/market': 1,
                                        'auth/r/orders/markets': 1,
                                        'auth/api_tokens/delete': 1,
                                        'auth/api_tokens/create': 1,
                                        'auth/api_tokens': 1,
                                        'auth/signin_history/uniq': 1,
                                        'auth/signin_history': 1,
                                        'auth/disable_withdraw_confirmation': 1,
                                        'auth/change_password': 1,
                                        'auth/deposit_address': 1,
                                        'auth/announcements/accept': 1,
                                        'auth/announcements/unaccepted': 1,
                                        'auth/otp/deactivate': 1,
                                        'auth/otp/activate': 1,
                                        'auth/otp/secret': 1,
                                        'auth/r/order/market/:order_id/trades': 1,
                                        'auth/r/orders/market/hist': 1,
                                        'auth/r/orders/hist': 1,
                                        'auth/r/orders/hist/markets': 1,
                                        'auth/r/orders/details': 1,
                                        'auth/assets-history': 1,
                                        'auth/assets-history/withdraws': 1,
                                        'auth/assets-history/deposits': 1,
                                        'auth/r/wallets': 1,
                                        'auth/markets/favorites': 1,
                                        'auth/markets/favorites/list': 1,
                                        'auth/me/update': 1,
                                        'auth/me': 1,
                                        'auth/fund_sources': 1,
                                        'auth/fund_sources/list': 1,
                                        'auth/withdraw/resend_confirmation': 1,
                                        'auth/withdraw': 1,
                                        'auth/withdraw/details': 1,
                                        'auth/withdraw/info': 1,
                                        'auth/payment_addresses': 1,
                                        'auth/deposit/prerequest': 1,
                                        'auth/deposit/exchange-rates': 1,
                                        'auth/deposit': 1,
                                        'auth/deposit/details': 1,
                                        'auth/deposit/info': 1,
                                        'auth/kuna_codes/count': 1,
                                        'auth/kuna_codes/details': 1,
                                        'auth/kuna_codes/edit': 1,
                                        'auth/kuna_codes/send-pdf': 1,
                                        'auth/kuna_codes': 1,
                                        'auth/kuna_codes/redeemed-by-me': 1,
                                        'auth/kuna_codes/issued-by-me': 1,
                                        'auth/payment_requests/invoice': 1,
                                        'auth/payment_requests/type': 1,
                                        'auth/referral_program/weekly_earnings': 1,
                                        'auth/referral_program/stats': 1,
                                        'auth/merchant/payout_services': 1,
                                        'auth/merchant/withdraw': 1,
                                        'auth/merchant/payment_services': 1,
                                        'auth/merchant/deposit': 1,
                                        'auth/verification/auth_token': 1,
                                        'auth/kunaid_purchase/create': 1,
                                        'auth/devices/list': 1,
                                        'auth/sessions/list': 1,
                                        'auth/subscriptions/reactivate': 1,
                                        'auth/subscriptions/cancel': 1,
                                        'auth/subscriptions/prolong': 1,
                                        'auth/subscriptions/create': 1,
                                        'auth/subscriptions/list': 1,
                                        'auth/kuna_ids/list': 1,
                                        'order/cancel/multi': 1,
                                        'order/cancel': 1
                                    },
                                    'put': {
                                        'auth/fund_sources/id': 1,
                                        'auth/kuna_codes/redeem': 1
                                    },
                                    'delete': {
                                        'auth/markets/favorites': 1,
                                        'auth/fund_sources': 1,
                                        'auth/devices': 1,
                                        'auth/devices/list': 1,
                                        'auth/sessions/list': 1,
                                        'auth/sessions': 1
                                    }
                                }
                            },
                            'public': {
                                'get': [
                                    'depth',
                                    'k_with_pending_trades',
                                    'k',
                                    'markets',
                                    'order_book',
                                    'order_book/{market}',
                                    'tickers',
                                    'tickers/{market}',
                                    'timestamp',
                                    'trades',
                                    'trades/{market}'
                                ]
                            },
                            'private': {
                                'get': [
                                    'members/me',
                                    'deposits',
                                    'deposit',
                                    'deposit_address',
                                    'orders',
                                    'order',
                                    'trades/my',
                                    'withdraws',
                                    'withdraw'
                                ],
                                'post': [
                                    'orders',
                                    'orders/multi',
                                    'orders/clear',
                                    'order/delete',
                                    'withdraw'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'taker': this.parseNumber('0.0025'),
                                'maker': this.parseNumber('0.0025')
                            },
                            'funding': {
                                'withdraw': {
                                    'UAH': '1%',
                                    'BTC': 0.001,
                                    'BCH': 0.001,
                                    'ETH': 0.01,
                                    'WAVES': 0.01,
                                    'GOL': 0.0,
                                    'GBG': 0.0
                                },
                                'deposit': {
                                }
                            }
                        },
                        'commonCurrencies': {
                            'PLA': 'Plair'
                        },
                        'exceptions': {
                            '2002': InsufficientFunds,
                            '2003': OrderNotFound
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTimestamp(params);
                    //
                    //     1594911427
                    //
                    return response * 1000;
                }
                async fetchMarkets(params = {}) {
                    const quotes = [
                        'btc',
                        'rub',
                        'uah',
                        'usd',
                        'usdt',
                        'usdc'
                    ];
                    const markets = [];
                    const response = await this.publicGetTickers(params);
                    //
                    //    {
                    //        shibuah: {
                    //            at: '1644463685',
                    //            ticker: {
                    //                buy: '0.000911',
                    //                sell: '0.00092',
                    //                low: '0.000872',
                    //                high: '0.000963',
                    //                last: '0.000911',
                    //                vol: '1539278096.0',
                    //                price: '1434244.211249'
                    //            }
                    //        }
                    //    }
                    //
                    const ids = Object.keys(response);
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        for(let j = 0; j < quotes.length; j++){
                            const quoteId = quotes[j];
                            // usd gets matched before usdt in usdtusd USDT/USD
                            // https://github.com/ccxt/ccxt/issues/9868
                            const slicedId = id.slice(1);
                            const index = slicedId.indexOf(quoteId);
                            const slice = slicedId.slice(index);
                            if (index > 0 && slice === quoteId) {
                                // usd gets matched before usdt in usdtusd USDT/USD
                                // https://github.com/ccxt/ccxt/issues/9868
                                const baseId = id[0] + slicedId.replace(quoteId, '');
                                const base = this.safeCurrencyCode(baseId);
                                const quote = this.safeCurrencyCode(quoteId);
                                markets.push({
                                    'id': id,
                                    'symbol': base + '/' + quote,
                                    'base': base,
                                    'quote': quote,
                                    'settle': undefined,
                                    'baseId': baseId,
                                    'quoteId': quoteId,
                                    'settleId': undefined,
                                    'type': 'spot',
                                    'spot': true,
                                    'margin': false,
                                    'swap': false,
                                    'future': false,
                                    'option': false,
                                    'active': undefined,
                                    'contract': false,
                                    'linear': undefined,
                                    'inverse': undefined,
                                    'contractSize': undefined,
                                    'expiry': undefined,
                                    'expiryDatetime': undefined,
                                    'strike': undefined,
                                    'optionType': undefined,
                                    'precision': {
                                        'amount': undefined,
                                        'price': undefined
                                    },
                                    'limits': {
                                        'leverage': {
                                            'min': undefined,
                                            'max': undefined
                                        },
                                        'amount': {
                                            'min': undefined,
                                            'max': undefined
                                        },
                                        'price': {
                                            'min': undefined,
                                            'max': undefined
                                        },
                                        'cost': {
                                            'min': undefined,
                                            'max': undefined
                                        }
                                    },
                                    'info': undefined
                                });
                            }
                        }
                    }
                    return markets;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default = 300
                    const orderbook = await this.publicGetDepth(this.extend(request, params));
                    const timestamp = this.safeTimestamp(orderbook, 'timestamp');
                    return this.parseOrderBook(orderbook, symbol, timestamp);
                }
                parseTicker(ticker, market) {
                    const timestamp = this.safeTimestamp(ticker, 'at');
                    ticker = ticker['ticker'];
                    const symbol = this.safeSymbol(undefined, market);
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'vol'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTickers(params);
                    const ids = Object.keys(response);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        let market = undefined;
                        let symbol = id;
                        if (id in this.markets_by_id) {
                            market = this.markets_by_id[id];
                            symbol = market['symbol'];
                        } else {
                            let base = id.slice(0, 3);
                            let quote = id.slice(3, 6);
                            base = base.toUpperCase();
                            quote = quote.toUpperCase();
                            base = this.safeCurrencyCode(base);
                            quote = this.safeCurrencyCode(quote);
                            symbol = base + '/' + quote;
                        }
                        result[symbol] = this.parseTicker(response[id], market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.publicGetTickersMarket(this.extend(request, params));
                    return this.parseTicker(response, market);
                }
                async fetchL3OrderBook(symbol, limit, params = {}) {
                    return await this.fetchOrderBook(symbol, limit, params);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.publicGetTrades(this.extend(request, params));
                    //
                    //      [
                    //          {
                    //              "id":11353466,
                    //              "price":"3000.16",
                    //              "volume":"0.000397",
                    //              "funds":"1.19106352",
                    //              "market":"ethusdt",
                    //              "created_at":"2022-04-12T18:32:36Z",
                    //              "side":null,
                    //              "trend":"sell"
                    //          },
                    //      ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "id":11353466,
                    //          "price":"3000.16",
                    //          "volume":"0.000397",
                    //          "funds":"1.19106352",
                    //          "market":"ethusdt",
                    //          "created_at":"2022-04-12T18:32:36Z",
                    //          "side":null,
                    //          "trend":"sell"
                    //      }
                    //
                    // fetchMyTrades (private)
                    //
                    //      {
                    //          "id":11353719,
                    //          "price":"0.13566",
                    //          "volume":"99.0",
                    //          "funds":"13.43034",
                    //          "market":"dogeusdt",
                    //          "created_at":"2022-04-12T18:58:44Z",
                    //          "side":"ask",
                    //          "order_id":1665670371,
                    //          "trend":"buy"
                    //      }
                    //
                    const timestamp = this.parse8601(this.safeString(trade, 'created_at'));
                    let symbol = undefined;
                    if (market) symbol = market['symbol'];
                    let side = this.safeString2(trade, 'side', 'trend');
                    if (side !== undefined) {
                        const sideMap = {
                            'ask': 'sell',
                            'bid': 'buy'
                        };
                        side = this.safeString(sideMap, side, side);
                    }
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'volume');
                    const costString = this.safeNumber(trade, 'funds');
                    const orderId = this.safeString(trade, 'order_id');
                    const id = this.safeString(trade, 'id');
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'order': orderId,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': undefined
                    }, market);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const trades = await this.fetchTrades(symbol, since, limit, params);
                    const ohlcvc = this.buildOHLCVC(trades, timeframe, since, limit);
                    const result = [];
                    for(let i = 0; i < ohlcvc.length; i++){
                        const ohlcv = ohlcvc[i];
                        result.push([
                            ohlcv[0],
                            ohlcv[1],
                            ohlcv[2],
                            ohlcv[3],
                            ohlcv[4],
                            ohlcv[5]
                        ]);
                    }
                    return result;
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'accounts');
                    const result = {
                        'info': balances
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'balance');
                        account['used'] = this.safeString(balance, 'locked');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetMembersMe(params);
                    return this.parseBalance(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'market': this.marketId(symbol),
                        'side': side,
                        'volume': amount.toString(),
                        'ord_type': type
                    };
                    if (type === 'limit') request['price'] = price.toString();
                    const response = await this.privatePostOrders(this.extend(request, params));
                    const marketId = this.safeValue(response, 'market');
                    const market = this.safeValue(this.markets_by_id, marketId);
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privatePostOrderDelete(this.extend(request, params));
                    const order = this.parseOrder(response);
                    const status = order['status'];
                    if (status === 'closed' || status === 'canceled') throw new OrderNotFound(this.id + ' ' + this.json(order));
                    return order;
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'done': 'closed',
                        'wait': 'open',
                        'cancel': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    const marketId = this.safeString(order, 'market');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const status = this.parseOrderStatus(this.safeString(order, 'state'));
                    const type = this.safeString(order, 'type');
                    const side = this.safeString(order, 'side');
                    const id = this.safeString(order, 'id');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': this.safeString(order, 'price'),
                        'stopPrice': undefined,
                        'amount': this.safeString(order, 'volume'),
                        'filled': this.safeString(order, 'executed_volume'),
                        'remaining': this.safeString(order, 'remaining_volume'),
                        'trades': undefined,
                        'fee': undefined,
                        'info': order,
                        'cost': undefined,
                        'average': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': parseInt(id)
                    };
                    const response = await this.privateGetOrder(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.privateGetOrders(this.extend(request, params));
                    // todo emulation of fetchClosedOrders, fetchOrders, fetchOrder
                    // with order cache + fetchOpenOrders
                    // as in BTC-e, Liqui, Yobit, DSX, Tidex, WEX
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    //
                    //      [
                    //          {
                    //              "id":11353719,
                    //              "price":"0.13566",
                    //              "volume":"99.0",
                    //              "funds":"13.43034",
                    //              "market":"dogeusdt",
                    //              "created_at":"2022-04-12T18:58:44Z",
                    //              "side":"ask",
                    //              "order_id":1665670371,
                    //              "trend":"buy"
                    //          },
                    //      ]
                    //
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.privateGetTradesMy(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                nonce() {
                    return this.milliseconds();
                }
                encodeParams(params) {
                    if ('orders' in params) {
                        const orders = params['orders'];
                        let query = this.urlencode(this.keysort(this.omit(params, 'orders')));
                        for(let i = 0; i < orders.length; i++){
                            const order = orders[i];
                            const keys = Object.keys(order);
                            for(let k = 0; k < keys.length; k++){
                                const key = keys[k];
                                const value = order[key];
                                query += '&orders%5B%5D%5B' + key + '%5D=' + value.toString();
                            }
                        }
                        return query;
                    }
                    return this.urlencode(this.keysort(params));
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = undefined;
                    if (Array.isArray(api)) {
                        const [version, access] = api;
                        url = this.urls['api'][version] + '/' + version + '/' + this.implodeParams(path, params);
                        if (access === 'public') {
                            if (method === 'GET') {
                                if (Object.keys(params).length) url += '?' + this.urlencode(params);
                            } else if (method === 'POST' || method === 'PUT') {
                                headers = {
                                    'Content-Type': 'application/json'
                                };
                                body = this.json(params);
                            }
                        } else if (access === 'private') throw new NotSupported(this.id + ' private v3 API is not supported yet');
                    } else {
                        let request = '/api/' + this.version + '/' + this.implodeParams(path, params);
                        if ('extension' in this.urls) request += this.urls['extension'];
                        const query = this.omit(params, this.extractParams(path));
                        url = this.urls['api'][api] + request;
                        if (api === 'public') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else {
                            this.checkRequiredCredentials();
                            const nonce = this.nonce().toString();
                            const query = this.encodeParams(this.extend({
                                'access_key': this.apiKey,
                                'tonce': nonce
                            }, params));
                            const auth = method + '|' + request + '|' + query;
                            const signed = this.hmac(this.encode(auth), this.encode(this.secret));
                            const suffix = query + '&signature=' + signed;
                            if (method === 'GET') url += '?' + suffix;
                            else {
                                body = suffix;
                                headers = {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                };
                            }
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    if (code === 400) {
                        const error = this.safeValue(response, 'error');
                        const errorCode = this.safeString(error, 'code');
                        const feedback = this.id + ' ' + this.json(response);
                        this.throwExactlyMatchedException(this.exceptions, errorCode, feedback);
                    // fallback to default error handler
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    99: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, AuthenticationError: AuthenticationError, ArgumentsRequired: ArgumentsRequired1, InvalidNonce: InvalidNonce, BadRequest: BadRequest, ExchangeNotAvailable: ExchangeNotAvailable, PermissionDenied: PermissionDenied, AccountSuspended: AccountSuspended, RateLimitExceeded: RateLimitExceeded, InsufficientFunds: InsufficientFunds, BadSymbol: BadSymbol, InvalidOrder: InvalidOrder } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            //  ---------------------------------------------------------------------------
            module.exports = class latoken extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'latoken',
                        'name': 'Latoken',
                        'countries': [
                            'KY'
                        ],
                        'version': 'v2',
                        'rateLimit': 1000,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': undefined,
                            'future': undefined,
                            'option': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchCurrencies': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': false,
                            'fetchTransactions': true,
                            'fetchTransfer': false,
                            'fetchTransfers': true,
                            'transfer': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/61511972-24c39f00-aa01-11e9-9f7c-471f1d6e5214.jpg',
                            'api': 'https://api.latoken.com',
                            'www': 'https://latoken.com',
                            'doc': [
                                'https://api.latoken.com'
                            ],
                            'fees': 'https://latoken.com/fees',
                            'referral': 'https://latoken.com/invite?r=mvgp2djk'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'book/{currency}/{quote}': 1,
                                    'chart/week': 1,
                                    'chart/week/{currency}/{quote}': 1,
                                    'currency': 1,
                                    'currency/available': 1,
                                    'currency/quotes': 1,
                                    'currency/{currency}': 1,
                                    'pair': 1,
                                    'pair/available': 1,
                                    'ticker': 1,
                                    'ticker/{base}/{quote}': 1,
                                    'time': 1,
                                    'trade/history/{currency}/{quote}': 1,
                                    'trade/fee/{currency}/{quote}': 1,
                                    'trade/feeLevels': 1,
                                    'transaction/bindings': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'auth/account': 1,
                                    'auth/account/currency/{currency}/{type}': 1,
                                    'auth/order': 1,
                                    'auth/order/getOrder/{id}': 1,
                                    'auth/order/pair/{currency}/{quote}': 1,
                                    'auth/order/pair/{currency}/{quote}/active': 1,
                                    'auth/stopOrder': 1,
                                    'auth/stopOrder/getOrder/{id}': 1,
                                    'auth/stopOrder/pair/{currency}/{quote}': 1,
                                    'auth/stopOrder/pair/{currency}/{quote}/active': 1,
                                    'auth/trade': 1,
                                    'auth/trade/pair/{currency}/{quote}': 1,
                                    'auth/trade/fee/{currency}/{quote}': 1,
                                    'auth/transaction': 1,
                                    'auth/transaction/bindings': 1,
                                    'auth/transaction/bindings/{currency}': 1,
                                    'auth/transaction/{id}': 1,
                                    'auth/transfer': 1
                                },
                                'post': {
                                    'auth/order/cancel': 1,
                                    'auth/order/cancelAll': 1,
                                    'auth/order/cancelAll/{currency}/{quote}': 1,
                                    'auth/order/place': 1,
                                    'auth/spot/deposit': 1,
                                    'auth/spot/withdraw': 1,
                                    'auth/stopOrder/cancel': 1,
                                    'auth/stopOrder/cancelAll': 1,
                                    'auth/stopOrder/cancelAll/{currency}/{quote}': 1,
                                    'auth/stopOrder/place': 1,
                                    'auth/transaction/depositAddress': 1,
                                    'auth/transaction/withdraw': 1,
                                    'auth/transaction/withdraw/cancel': 1,
                                    'auth/transaction/withdraw/confirm': 1,
                                    'auth/transaction/withdraw/resendCode': 1,
                                    'auth/transfer/email': 1,
                                    'auth/transfer/id': 1,
                                    'auth/transfer/phone': 1
                                }
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.0049'),
                                'taker': this.parseNumber('0.0049')
                            }
                        },
                        'commonCurrencies': {
                            'BUX': 'Buxcoin',
                            'CBT': 'Community Business Token',
                            'CTC': 'CyberTronchain',
                            'DMD': 'Diamond Coin',
                            'FREN': 'Frenchie',
                            'GDX': 'GoldenX',
                            'GEC': 'Geco One',
                            'GEM': 'NFTmall',
                            'GMT': 'GMT Token',
                            'IMC': 'IMCoin',
                            'MT': 'Monarch',
                            'TPAY': 'Tetra Pay',
                            'TRADE': 'Smart Trade Coin',
                            'TSL': 'Treasure SL',
                            'UNO': 'Unobtanium',
                            'WAR': 'Warrior Token'
                        },
                        'exceptions': {
                            'exact': {
                                'INTERNAL_ERROR': ExchangeError1,
                                'SERVICE_UNAVAILABLE': ExchangeNotAvailable,
                                'NOT_AUTHORIZED': AuthenticationError,
                                'FORBIDDEN': PermissionDenied,
                                'BAD_REQUEST': BadRequest,
                                'NOT_FOUND': ExchangeError1,
                                'ACCESS_DENIED': PermissionDenied,
                                'REQUEST_REJECTED': ExchangeError1,
                                'HTTP_MEDIA_TYPE_NOT_SUPPORTED': BadRequest,
                                'MEDIA_TYPE_NOT_ACCEPTABLE': BadRequest,
                                'METHOD_ARGUMENT_NOT_VALID': BadRequest,
                                'VALIDATION_ERROR': BadRequest,
                                'ACCOUNT_EXPIRED': AccountSuspended,
                                'BAD_CREDENTIALS': AuthenticationError,
                                'COOKIE_THEFT': AuthenticationError,
                                'CREDENTIALS_EXPIRED': AccountSuspended,
                                'INSUFFICIENT_AUTHENTICATION': AuthenticationError,
                                'UNKNOWN_LOCATION': AuthenticationError,
                                'TOO_MANY_REQUESTS': RateLimitExceeded,
                                'INSUFFICIENT_FUNDS': InsufficientFunds,
                                'ORDER_VALIDATION': InvalidOrder
                            },
                            'broad': {
                                'invalid API key, signature or digest': AuthenticationError,
                                'request expired or bad': InvalidNonce,
                                'For input string': BadRequest,
                                'Unable to resolve currency by tag': BadSymbol,
                                'Unable to place order because pair is in inactive state': BadSymbol
                            }
                        },
                        'options': {
                            'defaultType': 'spot',
                            'types': {
                                'wallet': 'ACCOUNT_TYPE_WALLET',
                                'spot': 'ACCOUNT_TYPE_SPOT'
                            },
                            'accounts': {
                                'ACCOUNT_TYPE_WALLET': 'wallet',
                                'ACCOUNT_TYPE_SPOT': 'spot'
                            },
                            'fetchTradingFee': {
                                'method': 'fetchPrivateTradingFee'
                            }
                        }
                    });
                }
                nonce() {
                    return this.milliseconds() - this.options['timeDifference'];
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTime(params);
                    //
                    //     {
                    //         "serverTime": 1570615577321
                    //     }
                    //
                    return this.safeInteger(response, 'serverTime');
                }
                async fetchMarkets(params = {}) {
                    const currencies = await this.fetchCurrenciesFromCache(params);
                    //
                    //     [
                    //         {
                    //             "id":"1a075819-9e0b-48fc-8784-4dab1d186d6d",
                    //             "status":"CURRENCY_STATUS_ACTIVE",
                    //             "type":"CURRENCY_TYPE_ALTERNATIVE", // CURRENCY_TYPE_CRYPTO, CURRENCY_TYPE_IEO
                    //             "name":"MyCryptoBank",
                    //             "tag":"MCB",
                    //             "description":"",
                    //             "logo":"",
                    //             "decimals":18,
                    //             "created":1572912000000,
                    //             "tier":1,
                    //             "assetClass":"ASSET_CLASS_UNKNOWN",
                    //             "minTransferAmount":0
                    //         },
                    //         {
                    //             "id":"db02758e-2507-46a5-a805-7bc60355b3eb",
                    //             "status":"CURRENCY_STATUS_ACTIVE",
                    //             "type":"CURRENCY_TYPE_FUTURES_CONTRACT",
                    //             "name":"BTC USDT Futures Contract",
                    //             "tag":"BTCUSDT",
                    //             "description":"",
                    //             "logo":"",
                    //             "decimals":8,
                    //             "created":1589459984395,
                    //             "tier":1,
                    //             "assetClass":"ASSET_CLASS_UNKNOWN",
                    //             "minTransferAmount":0
                    //         },
                    //     ]
                    //
                    const response = await this.publicGetPair(params);
                    //
                    //     [
                    //         {
                    //             "id":"dba4289b-6b46-4d94-bf55-49eec9a163ad",
                    //             "status":"PAIR_STATUS_ACTIVE", // CURRENCY_STATUS_INACTIVE
                    //             "baseCurrency":"fb9b53d6-bbf6-472f-b6ba-73cc0d606c9b",
                    //             "quoteCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f",
                    //             "priceTick":"0.000000100000000000",
                    //             "priceDecimals":7,
                    //             "quantityTick":"0.010000000",
                    //             "quantityDecimals":2,
                    //             "costDisplayDecimals":7,
                    //             "created":1572957210501,
                    //             "minOrderQuantity":"0",
                    //             "maxOrderCostUsd":"999999999999999999",
                    //             "minOrderCostUsd":"0",
                    //             "externalSymbol":""
                    //         }
                    //     ]
                    //
                    if (this.safeValue(this.options, 'adjustForTimeDifference', true)) await this.loadTimeDifference();
                    const currenciesById = this.indexBy(currencies, 'id');
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'id');
                        // the exchange shows them inverted
                        const baseId = this.safeString(market, 'baseCurrency');
                        const quoteId = this.safeString(market, 'quoteCurrency');
                        const baseCurrency = this.safeValue(currenciesById, baseId);
                        const quoteCurrency = this.safeValue(currenciesById, quoteId);
                        if (baseCurrency !== undefined && quoteCurrency !== undefined) {
                            const base = this.safeCurrencyCode(this.safeString(baseCurrency, 'tag'));
                            const quote = this.safeCurrencyCode(this.safeString(quoteCurrency, 'tag'));
                            const lowercaseQuote = quote.toLowerCase();
                            const capitalizedQuote = this.capitalize(lowercaseQuote);
                            const status = this.safeString(market, 'status');
                            result.push({
                                'id': id,
                                'symbol': base + '/' + quote,
                                'base': base,
                                'quote': quote,
                                'settle': undefined,
                                'baseId': baseId,
                                'quoteId': quoteId,
                                'settleId': undefined,
                                'type': 'spot',
                                'spot': true,
                                'margin': false,
                                'swap': false,
                                'future': false,
                                'option': false,
                                'active': status === 'PAIR_STATUS_ACTIVE',
                                'contract': false,
                                'linear': undefined,
                                'inverse': undefined,
                                'contractSize': undefined,
                                'expiry': undefined,
                                'expiryDatetime': undefined,
                                'strike': undefined,
                                'optionType': undefined,
                                'precision': {
                                    'amount': this.safeNumber(market, 'quantityTick'),
                                    'price': this.safeNumber(market, 'priceTick')
                                },
                                'limits': {
                                    'leverage': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'amount': {
                                        'min': this.safeNumber(market, 'minOrderQuantity'),
                                        'max': undefined
                                    },
                                    'price': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'cost': {
                                        'min': this.safeNumber(market, 'minOrderCost' + capitalizedQuote),
                                        'max': this.safeNumber(market, 'maxOrderCost' + capitalizedQuote)
                                    }
                                },
                                'info': market
                            });
                        }
                    }
                    return result;
                }
                async fetchCurrenciesFromCache(params = {}) {
                    // this method is now redundant
                    // currencies are now fetched before markets
                    const options = this.safeValue(this.options, 'fetchCurrencies', {});
                    const timestamp = this.safeInteger(options, 'timestamp');
                    const expires = this.safeInteger(options, 'expires', 1000);
                    const now = this.milliseconds();
                    if (timestamp === undefined || now - timestamp > expires) {
                        const response = await this.publicGetCurrency(params);
                        this.options['fetchCurrencies'] = this.extend(options, {
                            'response': response,
                            'timestamp': now
                        });
                    }
                    return this.safeValue(this.options['fetchCurrencies'], 'response');
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.fetchCurrenciesFromCache(params);
                    //
                    //     [
                    //         {
                    //             "id":"1a075819-9e0b-48fc-8784-4dab1d186d6d",
                    //             "status":"CURRENCY_STATUS_ACTIVE",
                    //             "type":"CURRENCY_TYPE_ALTERNATIVE", // CURRENCY_TYPE_CRYPTO, CURRENCY_TYPE_IEO
                    //             "name":"MyCryptoBank",
                    //             "tag":"MCB",
                    //             "description":"",
                    //             "logo":"",
                    //             "decimals":18,
                    //             "created":1572912000000,
                    //             "tier":1,
                    //             "assetClass":"ASSET_CLASS_UNKNOWN",
                    //             "minTransferAmount":0
                    //         },
                    //         {
                    //             "id":"db02758e-2507-46a5-a805-7bc60355b3eb",
                    //             "status":"CURRENCY_STATUS_ACTIVE",
                    //             "type":"CURRENCY_TYPE_FUTURES_CONTRACT",
                    //             "name":"BTC USDT Futures Contract",
                    //             "tag":"BTCUSDT",
                    //             "description":"",
                    //             "logo":"",
                    //             "decimals":8,
                    //             "created":1589459984395,
                    //             "tier":1,
                    //             "assetClass":"ASSET_CLASS_UNKNOWN",
                    //             "minTransferAmount":0
                    //         },
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        const id = this.safeString(currency, 'id');
                        const tag = this.safeString(currency, 'tag');
                        const code = this.safeCurrencyCode(tag);
                        const decimals = this.safeString(currency, 'decimals');
                        const precision = this.parseNumber('1e-' + decimals);
                        const fee = this.safeNumber(currency, 'fee');
                        const currencyType = this.safeString(currency, 'type');
                        const parts = currencyType.split('_');
                        const numParts = parts.length;
                        const lastPart = this.safeValue(parts, numParts - 1);
                        const type = lastPart.toLowerCase();
                        const status = this.safeString(currency, 'status');
                        const active = status === 'CURRENCY_STATUS_ACTIVE';
                        const name = this.safeString(currency, 'name');
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'name': name,
                            'type': type,
                            'active': active,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': fee,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': this.safeNumber(currency, 'minTransferAmount'),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAuthAccount(params);
                    //
                    //     [
                    //         {
                    //             id: "e5852e02-8711-431c-9749-a6f5503c6dbe",
                    //             status: "ACCOUNT_STATUS_ACTIVE",
                    //             type: "ACCOUNT_TYPE_WALLET",
                    //             timestamp: "1635920106506",
                    //             currency: "0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //             available: "100.000000",
                    //             blocked: "0.000000"
                    //         },
                    //         {
                    //             id: "369df204-acbc-467e-a25e-b16e3cc09cf6",
                    //             status: "ACCOUNT_STATUS_ACTIVE",
                    //             type: "ACCOUNT_TYPE_SPOT",
                    //             timestamp: "1635920106504",
                    //             currency: "0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //             available: "100.000000",
                    //             blocked: "0.000000"
                    //         }
                    //     ]
                    //
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    let maxTimestamp = undefined;
                    const defaultType = this.safeString2(this.options, 'fetchBalance', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    const types = this.safeValue(this.options, 'types', {});
                    const accountType = this.safeString(types, type, type);
                    const balancesByType = this.groupBy(response, 'type');
                    const balances = this.safeValue(balancesByType, accountType, []);
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const timestamp = this.safeInteger(balance, 'timestamp');
                        if (timestamp !== undefined) {
                            if (maxTimestamp === undefined) maxTimestamp = timestamp;
                            else maxTimestamp = Math.max(maxTimestamp, timestamp);
                        }
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'blocked');
                        result[code] = account;
                    }
                    result['timestamp'] = maxTimestamp;
                    result['datetime'] = this.iso8601(maxTimestamp);
                    return this.safeBalance(result);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['baseId'],
                        'quote': market['quoteId']
                    };
                    if (limit !== undefined) request['limit'] = limit; // max 1000
                    const response = await this.publicGetBookCurrencyQuote(this.extend(request, params));
                    //
                    //     {
                    //         "ask":[
                    //             {"price":"4428.76","quantity":"0.08136","cost":"360.3239136","accumulated":"360.3239136"},
                    //             {"price":"4429.77","quantity":"1.11786","cost":"4951.8626922","accumulated":"5312.1866058"},
                    //             {"price":"4430.94","quantity":"1.78418","cost":"7905.5945292","accumulated":"13217.781135"},
                    //         ],
                    //         "bid":[
                    //             {"price":"4428.43","quantity":"0.13675","cost":"605.5878025","accumulated":"605.5878025"},
                    //             {"price":"4428.19","quantity":"0.03619","cost":"160.2561961","accumulated":"765.8439986"},
                    //             {"price":"4428.15","quantity":"0.02926","cost":"129.567669","accumulated":"895.4116676"},
                    //         ],
                    //         "totalAsk":"53.14814",
                    //         "totalBid":"112216.9029791"
                    //     }
                    //
                    return this.parseOrderBook(response, symbol, undefined, 'bid', 'ask', 'price', 'quantity');
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "symbol":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f/0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //         "baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f",
                    //         "quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //         "volume24h":"76411867.852585600000000000",
                    //         "volume7d":"637809926.759451100000000000",
                    //         "change24h":"2.5300",
                    //         "change7d":"5.1300",
                    //         "lastPrice":"4426.9"
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeString(ticker, 'lastPrice');
                    const change = this.safeString(ticker, 'change24h');
                    const timestamp = this.nonce();
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'low': this.safeString(ticker, 'low'),
                        'high': this.safeString(ticker, 'high'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': change,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': undefined,
                        'quoteVolume': this.safeString(ticker, 'volume24h'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'base': market['baseId'],
                        'quote': market['quoteId']
                    };
                    const response = await this.publicGetTickerBaseQuote(this.extend(request, params));
                    //
                    //     {
                    //         "symbol":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f/0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //         "baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f",
                    //         "quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //         "volume24h":"76411867.852585600000000000",
                    //         "volume7d":"637809926.759451100000000000",
                    //         "change24h":"2.5300",
                    //         "change7d":"5.1300",
                    //         "lastPrice":"4426.9"
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTicker(params);
                    //
                    //     [
                    //         {
                    //             "symbol":"DASH/BTC",
                    //             "baseCurrency":"ed75c263-4ab9-494b-8426-031dab1c7cc1",
                    //             "quoteCurrency":"92151d82-df98-4d88-9a4d-284fa9eca49f",
                    //             "volume24h":"1.977753278000000000",
                    //             "volume7d":"18.964342670000000000",
                    //             "change24h":"-1.4800",
                    //             "change7d":"-5.5200",
                    //             "lastPrice":"0.003066"
                    //         },
                    //     ]
                    //
                    return this.parseTickers(response, symbols);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "id":"c152f814-8eeb-44f0-8f3f-e5c568f2ffcf",
                    //         "isMakerBuyer":false,
                    //         "baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f",
                    //         "quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //         "price":"4435.56",
                    //         "quantity":"0.32534",
                    //         "cost":"1443.0650904",
                    //         "timestamp":1635854642725,
                    //         "makerBuyer":false
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "id":"02e02533-b4bf-4ba9-9271-24e2108dfbf7",
                    //         "isMakerBuyer":false,
                    //         "direction":"TRADE_DIRECTION_BUY",
                    //         "baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f",
                    //         "quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //         "price":"4564.32",
                    //         "quantity":"0.01000",
                    //         "cost":"45.6432",
                    //         "fee":"0.223651680000000000",
                    //         "order":"c9cac6a0-484c-4892-88e7-ad51b39f2ce1",
                    //         "timestamp":1635921580399,
                    //         "makerBuyer":false
                    //     }
                    //
                    const type = undefined;
                    const timestamp = this.safeInteger(trade, 'timestamp');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'quantity');
                    const costString = this.safeString(trade, 'cost');
                    const makerBuyer = this.safeValue(trade, 'makerBuyer');
                    let side = this.safeString(trade, 'direction');
                    if (side === undefined) side = makerBuyer ? 'sell' : 'buy';
                    else {
                        if (side === 'TRADE_DIRECTION_BUY') side = 'buy';
                        else if (side === 'TRADE_DIRECTION_SELL') side = 'sell';
                    }
                    const isBuy = side === 'buy';
                    const takerOrMaker = makerBuyer && isBuy ? 'maker' : 'taker';
                    const baseId = this.safeString(trade, 'baseCurrency');
                    const quoteId = this.safeString(trade, 'quoteCurrency');
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    const symbol = base + '/' + quote;
                    if (symbol in this.markets) market = this.market(symbol);
                    const id = this.safeString(trade, 'id');
                    const orderId = this.safeString(trade, 'order');
                    const feeCost = this.safeString(trade, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': quote
                    };
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': orderId,
                        'type': type,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['baseId'],
                        'quote': market['quoteId']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 1000
                    const response = await this.publicGetTradeHistoryCurrencyQuote(this.extend(request, params));
                    //
                    //     [
                    //         {"id":"c152f814-8eeb-44f0-8f3f-e5c568f2ffcf","isMakerBuyer":false,"baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f","quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5","price":"4435.56","quantity":"0.32534","cost":"1443.0650904","timestamp":1635854642725,"makerBuyer":false},
                    //         {"id":"cfecbefb-3d11-43d7-b9d4-fa16211aad8a","isMakerBuyer":false,"baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f","quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5","price":"4435.13","quantity":"0.26540","cost":"1177.083502","timestamp":1635854641114,"makerBuyer":false},
                    //         {"id":"f43d3ec8-db94-49f3-b534-91dbc2779296","isMakerBuyer":true,"baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f","quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5","price":"4435.00","quantity":"0.41738","cost":"1851.0803","timestamp":1635854640323,"makerBuyer":true},
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTradingFee(symbol, params = {}) {
                    let method = this.safeString(params, 'method');
                    params = this.omit(params, 'method');
                    if (method === undefined) {
                        const options = this.safeValue(this.options, 'fetchTradingFee', {});
                        method = this.safeString(options, 'method', 'fetchPrivateTradingFee');
                    }
                    return await this[method](symbol, params);
                }
                async fetchPublicTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['baseId'],
                        'quote': market['quoteId']
                    };
                    const response = await this.publicGetTradeFeeCurrencyQuote(this.extend(request, params));
                    //
                    //     {
                    //         makerFee: '0.004900000000000000',
                    //         takerFee: '0.004900000000000000',
                    //         type: 'FEE_SCHEME_TYPE_PERCENT_QUOTE',
                    //         take: 'FEE_SCHEME_TAKE_PROPORTION'
                    //     }
                    //
                    return {
                        'info': response,
                        'symbol': symbol,
                        'maker': this.safeNumber(response, 'makerFee'),
                        'taker': this.safeNumber(response, 'takerFee')
                    };
                }
                async fetchPrivateTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['baseId'],
                        'quote': market['quoteId']
                    };
                    const response = await this.privateGetAuthTradeFeeCurrencyQuote(this.extend(request, params));
                    //
                    //     {
                    //         makerFee: '0.004900000000000000',
                    //         takerFee: '0.004900000000000000',
                    //         type: 'FEE_SCHEME_TYPE_PERCENT_QUOTE',
                    //         take: 'FEE_SCHEME_TAKE_PROPORTION'
                    //     }
                    //
                    return {
                        'info': response,
                        'symbol': symbol,
                        'maker': this.safeNumber(response, 'makerFee'),
                        'taker': this.safeNumber(response, 'takerFee')
                    };
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let method = 'privateGetAuthTrade';
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['currency'] = market['baseId'];
                        request['quote'] = market['quoteId'];
                        method = 'privateGetAuthTradePairCurrencyQuote';
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 100
                    const response = await this[method](this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id":"02e02533-b4bf-4ba9-9271-24e2108dfbf7",
                    //             "isMakerBuyer":false,
                    //             "direction":"TRADE_DIRECTION_BUY",
                    //             "baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f",
                    //             "quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //             "price":"4564.32",
                    //             "quantity":"0.01000",
                    //             "cost":"45.6432",
                    //             "fee":"0.223651680000000000",
                    //             "order":"c9cac6a0-484c-4892-88e7-ad51b39f2ce1",
                    //             "timestamp":1635921580399,
                    //             "makerBuyer":false
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'ORDER_STATUS_PLACED': 'open',
                        'ORDER_STATUS_CLOSED': 'closed',
                        'ORDER_STATUS_CANCELLED': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrderType(status) {
                    const statuses = {
                        'ORDER_TYPE_MARKET': 'market',
                        'ORDER_TYPE_LIMIT': 'limit'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTimeInForce(timeInForce) {
                    const timeInForces = {
                        'ORDER_CONDITION_GOOD_TILL_CANCELLED': 'GTC',
                        'ORDER_CONDITION_IMMEDIATE_OR_CANCEL': 'IOC',
                        'ORDER_CONDITION_FILL_OR_KILL': 'FOK'
                    };
                    return this.safeString(timeInForces, timeInForce, timeInForce);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "orderId":"1563460093.134037.704945@0370:2",
                    //         "cliOrdId":"",
                    //         "pairId":370,
                    //         "symbol":"ETHBTC",
                    //         "side":"sell",
                    //         "orderType":"limit",
                    //         "price":1.0,
                    //         "amount":1.0
                    //     }
                    //
                    // fetchOrder, fetchOpenOrders, fetchOrders
                    //
                    //     {
                    //         "id":"a76bd262-3560-4bfb-98ac-1cedd394f4fc",
                    //         "status":"ORDER_STATUS_PLACED",
                    //         "side":"ORDER_SIDE_BUY",
                    //         "condition":"ORDER_CONDITION_GOOD_TILL_CANCELLED",
                    //         "type":"ORDER_TYPE_LIMIT",
                    //         "baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f",
                    //         "quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //         "clientOrderId":"web-macos_chrome_1a6a6659-6f7c-4fac-be0b-d1d7ac06d",
                    //         "price":"4000.00",
                    //         "quantity":"0.01",
                    //         "cost":"40.000000000000000000",
                    //         "filled":"0",
                    //         "trader":"7244bb3a-b6b2-446a-ac78-fa4bce5b59a9",
                    //         "creator":"ORDER_CREATOR_USER",
                    //         "creatorId":"",
                    //         "timestamp":1635920767648
                    //     }
                    //
                    // cancelOrder
                    //
                    //     {
                    //         "message":"cancellation request successfully submitted",
                    //         "status":"SUCCESS",
                    //         "id":"a631426d-3543-45ba-941e-75f7825afb0f"
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const timestamp = this.safeInteger(order, 'timestamp');
                    const baseId = this.safeString(order, 'baseCurrency');
                    const quoteId = this.safeString(order, 'quoteCurrency');
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    let symbol = undefined;
                    if (base !== undefined && quote !== undefined) {
                        symbol = base + '/' + quote;
                        if (symbol in this.markets) market = this.market(symbol);
                    }
                    const orderSide = this.safeString(order, 'side');
                    let side = undefined;
                    if (orderSide !== undefined) {
                        const parts = orderSide.split('_');
                        const partsLength = parts.length;
                        side = this.safeStringLower(parts, partsLength - 1);
                    }
                    const type = this.parseOrderType(this.safeString(order, 'type'));
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'quantity');
                    const filled = this.safeString(order, 'filled');
                    const cost = this.safeString(order, 'cost');
                    let status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const message = this.safeString(order, 'message');
                    if (message !== undefined) {
                        if (message.indexOf('cancel') >= 0) status = 'canceled';
                        else if (message.indexOf('accept') >= 0) status = 'open';
                    }
                    const clientOrderId = this.safeString(order, 'clientOrderId');
                    const timeInForce = this.parseTimeInForce(this.safeString(order, 'condition'));
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'average': undefined,
                        'remaining': undefined,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['baseId'],
                        'quote': market['quoteId']
                    };
                    const response = await this.privateGetAuthOrderPairCurrencyQuoteActive(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id":"a76bd262-3560-4bfb-98ac-1cedd394f4fc",
                    //             "status":"ORDER_STATUS_PLACED",
                    //             "side":"ORDER_SIDE_BUY",
                    //             "condition":"ORDER_CONDITION_GOOD_TILL_CANCELLED",
                    //             "type":"ORDER_TYPE_LIMIT",
                    //             "baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f",
                    //             "quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //             "clientOrderId":"web-macos_chrome_1a6a6659-6f7c-4fac-be0b-d1d7ac06d",
                    //             "price":"4000.00",
                    //             "quantity":"0.01000",
                    //             "cost":"40.00",
                    //             "filled":"0.00000",
                    //             "trader":"7244bb3a-b6b2-446a-ac78-fa4bce5b59a9",
                    //             "creator":"USER",
                    //             "creatorId":"",
                    //             "timestamp":1635920767648
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let method = 'privateGetAuthOrder';
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['currency'] = market['baseId'];
                        request['quote'] = market['quoteId'];
                        method = 'privateGetAuthOrderPairCurrencyQuote';
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 100
                    const response = await this[method](this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "id":"a76bd262-3560-4bfb-98ac-1cedd394f4fc",
                    //             "status":"ORDER_STATUS_PLACED",
                    //             "side":"ORDER_SIDE_BUY",
                    //             "condition":"ORDER_CONDITION_GOOD_TILL_CANCELLED",
                    //             "type":"ORDER_TYPE_LIMIT",
                    //             "baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f",
                    //             "quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //             "clientOrderId":"web-macos_chrome_1a6a6659-6f7c-4fac-be0b-d1d7ac06d",
                    //             "price":"4000.00",
                    //             "quantity":"0.01000",
                    //             "cost":"40.00",
                    //             "filled":"0.00000",
                    //             "trader":"7244bb3a-b6b2-446a-ac78-fa4bce5b59a9",
                    //             "creator":"USER",
                    //             "creatorId":"",
                    //             "timestamp":1635920767648
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetAuthOrderGetOrderId(this.extend(request, params));
                    //
                    //     {
                    //         "id":"a76bd262-3560-4bfb-98ac-1cedd394f4fc",
                    //         "status":"ORDER_STATUS_PLACED",
                    //         "side":"ORDER_SIDE_BUY",
                    //         "condition":"ORDER_CONDITION_GOOD_TILL_CANCELLED",
                    //         "type":"ORDER_TYPE_LIMIT",
                    //         "baseCurrency":"620f2019-33c0-423b-8a9d-cde4d7f8ef7f",
                    //         "quoteCurrency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //         "clientOrderId":"web-macos_chrome_1a6a6659-6f7c-4fac-be0b-d1d7ac06d",
                    //         "price":"4000.00",
                    //         "quantity":"0.01",
                    //         "cost":"40.000000000000000000",
                    //         "filled":"0",
                    //         "trader":"7244bb3a-b6b2-446a-ac78-fa4bce5b59a9",
                    //         "creator":"ORDER_CREATOR_USER",
                    //         "creatorId":"",
                    //         "timestamp":1635920767648
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const uppercaseType = type.toUpperCase();
                    const request = {
                        'baseCurrency': market['baseId'],
                        'quoteCurrency': market['quoteId'],
                        'side': side.toUpperCase(),
                        'condition': 'GTC',
                        'type': uppercaseType,
                        'clientOrderId': this.uuid()
                    };
                    if (uppercaseType === 'LIMIT') request['price'] = this.priceToPrecision(symbol, price);
                    request['quantity'] = this.amountToPrecision(symbol, amount);
                    request['timestamp'] = this.seconds();
                    const response = await this.privatePostAuthOrderPlace(this.extend(request, params));
                    //
                    //     {
                    //         "orderId":"1563460093.134037.704945@0370:2",
                    //         "cliOrdId":"",
                    //         "pairId":370,
                    //         "symbol":"ETHBTC",
                    //         "side":"sell",
                    //         "orderType":"limit",
                    //         "price":1.0,
                    //         "amount":1.0
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privatePostAuthOrderCancel(this.extend(request, params));
                    //
                    //     {
                    //         "id": "12345678-1234-1244-1244-123456789012",
                    //         "message": "cancellation request successfully submitted",
                    //         "status": "SUCCESS",
                    //         "error": "",
                    //         "errors": { }
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let method = 'privatePostAuthOrderCancelAll';
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['currency'] = market['baseId'];
                        request['quote'] = market['quoteId'];
                        method = 'privatePostAuthOrderCancelAllCurrencyQuote';
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "message":"cancellation request successfully submitted",
                    //         "status":"SUCCESS"
                    //     }
                    //
                    return response;
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    const response = await this.privateGetAuthTransaction(this.extend(request, params));
                    //
                    //     {
                    //         "hasNext":false,
                    //         "content":[
                    //             {
                    //                 "id":"fbf7d0d1-2629-4ad8-9def-7a1dba423362",
                    //                 "status":"TRANSACTION_STATUS_CONFIRMED",
                    //                 "type":"TRANSACTION_TYPE_DEPOSIT",
                    //                 "senderAddress":"",
                    //                 "recipientAddress":"0x3c46fa2e3f9023bc4897828ed173f8ecb3a554bc",
                    //                 "amount":"200.000000000000000000",
                    //                 "transactionFee":"0.000000000000000000",
                    //                 "timestamp":1635893208404,
                    //                 "transactionHash":"0x28bad3b74a042df13d64ddfbca855566a51bf7f190b8cd565c236a18d5cd493f#42",
                    //                 "blockHeight":13540262,
                    //                 "currency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //                 "memo":null,
                    //                 "paymentProvider":"a8d6d1cb-f84a-4e9d-aa82-c6a08b356ee1",
                    //                 "requiresCode":false
                    //             }
                    //         ],
                    //         "first":true,
                    //         "hasContent":true,
                    //         "pageSize":10
                    //     }
                    //
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const content = this.safeValue(response, 'content', []);
                    return this.parseTransactions(content, currency, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    //     {
                    //         "id":"fbf7d0d1-2629-4ad8-9def-7a1dba423362",
                    //         "status":"TRANSACTION_STATUS_CONFIRMED",
                    //         "type":"TRANSACTION_TYPE_DEPOSIT",
                    //         "senderAddress":"",
                    //         "recipientAddress":"0x3c46fa2e3f9023bc4897828ed173f8ecb3a554bc",
                    //         "amount":"200.000000000000000000",
                    //         "transactionFee":"0.000000000000000000",
                    //         "timestamp":1635893208404,
                    //         "transactionHash":"0x28bad3b74a042df13d64ddfbca855566a51bf7f190b8cd565c236a18d5cd493f#42",
                    //         "blockHeight":13540262,
                    //         "currency":"0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //         "memo":null,
                    //         "paymentProvider":"a8d6d1cb-f84a-4e9d-aa82-c6a08b356ee1",
                    //         "requiresCode":false
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const timestamp = this.safeInteger(transaction, 'timestamp');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const amount = this.safeNumber(transaction, 'amount');
                    let addressFrom = this.safeString(transaction, 'senderAddress');
                    if (addressFrom === '') addressFrom = undefined;
                    let addressTo = this.safeString(transaction, 'recipientAddress');
                    if (addressTo === '') addressTo = undefined;
                    const txid = this.safeString(transaction, 'transactionHash');
                    const tagTo = this.safeString(transaction, 'memo');
                    let fee = undefined;
                    const feeCost = this.safeNumber(transaction, 'transactionFee');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    const type = this.parseTransactionType(this.safeString(transaction, 'type'));
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': addressFrom,
                        'addressTo': addressTo,
                        'address': addressTo,
                        'tagFrom': undefined,
                        'tagTo': tagTo,
                        'tag': tagTo,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'fee': fee
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'TRANSACTION_STATUS_CONFIRMED': 'ok',
                        'TRANSACTION_STATUS_EXECUTED': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransactionType(type) {
                    const types = {
                        'TRANSACTION_TYPE_DEPOSIT': 'deposit',
                        'TRANSACTION_TYPE_WITHDRAWAL': 'withdrawal'
                    };
                    return this.safeString(types, type, type);
                }
                async fetchTransfers(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const response = await this.privateGetAuthTransfer(params);
                    //
                    //     {
                    //         "hasNext": true,
                    //         "content": [
                    //             {
                    //             "id": "ebd6312f-cb4f-45d1-9409-4b0b3027f21e",
                    //             "status": "TRANSFER_STATUS_COMPLETED",
                    //             "type": "TRANSFER_TYPE_WITHDRAW_SPOT",
                    //             "fromAccount": "c429c551-adbb-4078-b74b-276bea308a36",
                    //             "toAccount": "631c6203-bd62-4734-a04d-9b2a951f43b9",
                    //             "transferringFunds": 1259.0321785,
                    //             "usdValue": 1259.032179,
                    //             "rejectReason": null,
                    //             "timestamp": 1633515579530,
                    //             "direction": "INTERNAL",
                    //             "method": "TRANSFER_METHOD_UNKNOWN",
                    //             "recipient": null,
                    //             "sender": null,
                    //             "currency": "0c3a106d-bde3-4c13-a26e-3fd2394529e5",
                    //             "codeRequired": false,
                    //             "fromUser": "ce555f3f-585d-46fb-9ae6-487f66738073",
                    //             "toUser": "ce555f3f-585d-46fb-9ae6-487f66738073",
                    //             "fee": 0
                    //             },
                    //             ...
                    //         ],
                    //         "first": true,
                    //         "pageSize": 20,
                    //         "hasContent": true
                    //     }
                    //
                    const transfers = this.safeValue(response, 'content', []);
                    return this.parseTransfers(transfers, currency, since, limit);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    let method = undefined;
                    if (toAccount.includes('@')) method = 'privatePostAuthTransferEmail';
                    else if (toAccount.length === 36) method = 'privatePostAuthTransferId';
                    else method = 'privatePostAuthTransferPhone';
                    const request = {
                        'currency': currency['id'],
                        'recipient': toAccount,
                        'value': this.currencyToPrecision(code, amount)
                    };
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "id": "e6fc4ace-7750-44e4-b7e9-6af038ac7107",
                    //         "status": "TRANSFER_STATUS_COMPLETED",
                    //         "type": "TRANSFER_TYPE_DEPOSIT_SPOT",
                    //         "fromAccount": "3bf61015-bf32-47a6-b237-c9f70df772ad",
                    //         "toAccount": "355eb279-7c7e-4515-814a-575a49dc0325",
                    //         "transferringFunds": "500000.000000000000000000",
                    //         "usdValue": "0.000000000000000000",
                    //         "rejectReason": "",
                    //         "timestamp": 1576844438402,
                    //         "direction": "INTERNAL",
                    //         "method": "TRANSFER_METHOD_UNKNOWN",
                    //         "recipient": "",
                    //         "sender": "",
                    //         "currency": "40af7879-a8cc-4576-a42d-7d2749821b58",
                    //         "codeRequired": false,
                    //         "fromUser": "cd555555-666d-46fb-9ae6-487f66738073",
                    //         "toUser": "cd555555-666d-46fb-9ae6-487f66738073",
                    //         "fee": 0
                    //     }
                    //
                    return this.parseTransfer(response);
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //         "id": "e6fc4ace-7750-44e4-b7e9-6af038ac7107",
                    //         "status": "TRANSFER_STATUS_COMPLETED",
                    //         "type": "TRANSFER_TYPE_DEPOSIT_SPOT",
                    //         "fromAccount": "3bf61015-bf32-47a6-b237-c9f70df772ad",
                    //         "toAccount": "355eb279-7c7e-4515-814a-575a49dc0325",
                    //         "transferringFunds": "500000.000000000000000000",
                    //         "usdValue": "0.000000000000000000",
                    //         "rejectReason": "",
                    //         "timestamp": 1576844438402,
                    //         "direction": "INTERNAL",
                    //         "method": "TRANSFER_METHOD_UNKNOWN",
                    //         "recipient": "",
                    //         "sender": "",
                    //         "currency": "40af7879-a8cc-4576-a42d-7d2749821b58",
                    //         "codeRequired": false,
                    //         "fromUser": "cd555555-666d-46fb-9ae6-487f66738073",
                    //         "toUser": "cd555555-666d-46fb-9ae6-487f66738073",
                    //         "fee": 0
                    //     }
                    //
                    const timestamp = this.safeTimestamp(transfer, 'timestamp');
                    const currencyId = this.safeString(transfer, 'currency');
                    const status = this.safeString(transfer, 'status');
                    return {
                        'info': transfer,
                        'id': this.safeString(transfer, 'id'),
                        'timestamp': this.safeNumber(transfer),
                        'datetime': this.iso8601(timestamp),
                        'currency': this.safeCurrencyCode(currencyId, currency),
                        'amount': this.safeNumber(transfer, 'transferringFunds'),
                        'fromAccount': this.safeString(transfer, 'fromAccount'),
                        'toAccount': this.safeString(transfer, 'toAccount'),
                        'status': this.parseTransferStatus(status)
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'TRANSFER_STATUS_COMPLETED': 'ok',
                        'TRANSFER_STATUS_PENDING': 'pending',
                        'TRANSFER_STATUS_REJECTED': 'failed',
                        'TRANSFER_STATUS_UNVERIFIED': 'pending',
                        'TRANSFER_STATUS_CANCELLED': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                sign(path, api = 'public', method = 'GET', params, headers, body) {
                    const request = '/' + this.version + '/' + this.implodeParams(path, params);
                    let requestString = request;
                    const query = this.omit(params, this.extractParams(path));
                    const urlencodedQuery = this.urlencode(query);
                    if (method === 'GET') {
                        if (Object.keys(query).length) requestString += '?' + urlencodedQuery;
                    }
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const auth = method + request + urlencodedQuery;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha512');
                        headers = {
                            'X-LA-APIKEY': this.apiKey,
                            'X-LA-SIGNATURE': signature,
                            'X-LA-DIGEST': 'HMAC-SHA512'
                        };
                        if (method === 'POST') {
                            headers['Content-Type'] = 'application/json';
                            body = this.json(query);
                        }
                    }
                    const url = this.urls['api'] + requestString;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (!response) return;
                    //
                    // {"result":false,"message":"invalid API key, signature or digest","error":"BAD_REQUEST","status":"FAILURE"}
                    // {"result":false,"message":"request expired or bad <timeAlive>/<timestamp> format","error":"BAD_REQUEST","status":"FAILURE"}
                    // {"message":"Internal Server Error","error":"INTERNAL_ERROR","status":"FAILURE"}
                    // {"result":false,"message":"Internal error","error":"For input string: \"NaN\"","status":"FAILURE"}
                    //
                    const message = this.safeString(response, 'message');
                    const feedback = this.id + ' ' + body;
                    if (message !== undefined) {
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                    }
                    const error = this.safeString(response, 'error');
                    const errorMessage = this.safeString(error, 'message');
                    if (error !== undefined || errorMessage !== undefined) {
                        this.throwExactlyMatchedException(this.exceptions['exact'], error, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    100: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, DDoSProtection: DDoSProtection, AuthenticationError: AuthenticationError, InvalidOrder: InvalidOrder, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class lbank extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'lbank',
                        'name': 'LBank',
                        'countries': [
                            'CN'
                        ],
                        'version': 'v1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': undefined,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': 'minute1',
                            '5m': 'minute5',
                            '15m': 'minute15',
                            '30m': 'minute30',
                            '1h': 'hour1',
                            '2h': 'hour2',
                            '4h': 'hour4',
                            '6h': 'hour6',
                            '8h': 'hour8',
                            '12h': 'hour12',
                            '1d': 'day1',
                            '1w': 'week1'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/38063602-9605e28a-3302-11e8-81be-64b1e53c4cfb.jpg',
                            'api': 'https://api.lbank.info',
                            'www': 'https://www.lbank.info',
                            'doc': 'https://github.com/LBank-exchange/lbank-official-api-docs',
                            'fees': 'https://www.lbank.info/fees.html',
                            'referral': 'https://www.lbex.io/invite?icode=7QCY'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'currencyPairs',
                                    'ticker',
                                    'depth',
                                    'trades',
                                    'kline',
                                    'accuracy'
                                ]
                            },
                            'private': {
                                'post': [
                                    'user_info',
                                    'create_order',
                                    'cancel_order',
                                    'orders_info',
                                    'orders_info_history',
                                    'withdraw',
                                    'withdrawCancel',
                                    'withdraws',
                                    'withdrawConfigs'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.001'),
                                'taker': this.parseNumber('0.001')
                            },
                            'funding': {
                                'withdraw': {}
                            }
                        },
                        'commonCurrencies': {
                            'GMT': 'GMT Token',
                            'PNT': 'Penta',
                            'VET_ERC20': 'VEN'
                        },
                        'options': {
                            'cacheSecretAsPem': true
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetAccuracy(params);
                    //
                    //    [
                    //        {
                    //            "symbol": "btc_usdt",
                    //            "quantityAccuracy": "4",
                    //            "minTranQua": "0.0001",
                    //            "priceAccuracy": "2"
                    //        },
                    //        ...
                    //    ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = market['symbol'];
                        const parts = id.split('_');
                        let baseId = undefined;
                        let quoteId = undefined;
                        const numParts = parts.length;
                        // lbank will return symbols like "vet_erc20_usdt"
                        if (numParts > 2) {
                            baseId = parts[0] + '_' + parts[1];
                            quoteId = parts[2];
                        } else {
                            baseId = parts[0];
                            quoteId = parts[1];
                        }
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'quantityAccuracy'),
                                'price': this.safeInteger(market, 'priceAccuracy')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeFloat(market, 'minTranQua'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': id
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "symbol":"btc_usdt",
                    //         "ticker":{
                    //             "high":43416.06,
                    //             "vol":7031.7427,
                    //             "low":41804.26,
                    //             "change":1.33,
                    //             "turnover":300302447.81,
                    //             "latest":43220.4
                    //         },
                    //         "timestamp":1642201617747
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'symbol');
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    const timestamp = this.safeInteger(ticker, 'timestamp');
                    const info = ticker;
                    ticker = info['ticker'];
                    const last = this.safeString(ticker, 'latest');
                    const percentage = this.safeString(ticker, 'change');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'vol'),
                        'quoteVolume': this.safeString(ticker, 'turnover'),
                        'info': info
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    // {
                    //     "symbol":"btc_usdt",
                    //     "ticker":{
                    //         "high":43416.06,
                    //         "vol":7031.7427,
                    //         "low":41804.26,
                    //         "change":1.33,
                    //         "turnover":300302447.81,
                    //         "latest":43220.4
                    //         },
                    //     "timestamp":1642201617747
                    // }
                    return this.parseTicker(response, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': 'all'
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const ticker = this.parseTicker(response[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit = 60, params = {}) {
                    await this.loadMarkets();
                    let size = 60;
                    if (limit !== undefined) size = Math.min(limit, size);
                    const request = {
                        'symbol': this.marketId(symbol),
                        'size': size
                    };
                    const response = await this.publicGetDepth(this.extend(request, params));
                    return this.parseOrderBook(response, symbol);
                }
                parseTrade(trade, market) {
                    market = this.safeMarket(undefined, market);
                    const timestamp = this.safeInteger(trade, 'date_ms');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const price = this.parseNumber(priceString);
                    const amount = this.parseNumber(amountString);
                    const cost = this.parseNumber(Precise.stringMul(priceString, amountString));
                    const id = this.safeString(trade, 'tid');
                    const type = undefined;
                    let side = this.safeString(trade, 'type');
                    side = side.replace('_market', '');
                    return {
                        'id': id,
                        'info': this.safeValue(trade, 'info', trade),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': undefined,
                        'type': type,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': undefined
                    };
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'size': 100
                    };
                    if (since !== undefined) request['time'] = parseInt(since);
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this.publicGetTrades(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1590969600,
                    //         0.02451657,
                    //         0.02452675,
                    //         0.02443701,
                    //         0.02447814,
                    //         238.38210000
                    //     ]
                    //
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '5m', since, limit = 1000, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (since === undefined) throw new ArgumentsRequired1(this.id + ' fetchOHLCV() requires a `since` argument');
                    if (limit === undefined) throw new ArgumentsRequired1(this.id + ' fetchOHLCV() requires a `limit` argument');
                    const request = {
                        'symbol': market['id'],
                        'type': this.timeframes[timeframe],
                        'size': limit,
                        'time': parseInt(since / 1000)
                    };
                    const response = await this.publicGetKline(this.extend(request, params));
                    //
                    //     [
                    //         [1590969600,0.02451657,0.02452675,0.02443701,0.02447814,238.38210000],
                    //         [1590969660,0.02447814,0.02449883,0.02443209,0.02445973,212.40270000],
                    //         [1590969720,0.02445973,0.02452067,0.02445909,0.02446151,266.16920000],
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const info = this.safeValue(response, 'info', {});
                    const free = this.safeValue(info, 'free', {});
                    const freeze = this.safeValue(info, 'freeze', {});
                    const asset = this.safeValue(info, 'asset', {});
                    const currencyIds = Object.keys(free);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(free, currencyId);
                        account['used'] = this.safeString(freeze, currencyId);
                        account['total'] = this.safeString(asset, currencyId);
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostUserInfo(params);
                    //
                    //     {
                    //         "result":"true",
                    //         "info":{
                    //             "freeze":{
                    //                 "iog":"0.00000000",
                    //                 "ssc":"0.00000000",
                    //                 "eon":"0.00000000",
                    //             },
                    //             "asset":{
                    //                 "iog":"0.00000000",
                    //                 "ssc":"0.00000000",
                    //                 "eon":"0.00000000",
                    //             },
                    //             "free":{
                    //                 "iog":"0.00000000",
                    //                 "ssc":"0.00000000",
                    //                 "eon":"0.00000000",
                    //             },
                    //         }
                    //     }
                    //
                    return this.parseBalance(response);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '-1': 'cancelled',
                        '0': 'open',
                        '1': 'open',
                        '2': 'closed',
                        '4': 'closed'
                    };
                    return this.safeString(statuses, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "symbol"："eth_btc",
                    //         "amount"：10.000000,
                    //         "create_time"：1484289832081,
                    //         "price"：5000.000000,
                    //         "avg_price"：5277.301200,
                    //         "type"："sell",
                    //         "order_id"："ab704110-af0d-48fd-a083-c218f19a4a55",
                    //         "deal_amount"：10.000000,
                    //         "status"：2
                    //     }
                    //
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const timestamp = this.safeInteger(order, 'create_time');
                    // Limit Order Request Returns: Order Price
                    // Market Order Returns: cny amount of market order
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'amount');
                    const filled = this.safeString(order, 'deal_amount');
                    const average = this.safeString(order, 'avg_price');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const id = this.safeString(order, 'order_id');
                    const type = this.safeString(order, 'order_type');
                    const side = this.safeString(order, 'type');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'info': this.safeValue(order, 'info', order),
                        'average': average
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let order = {
                        'symbol': market['id'],
                        'type': side,
                        'amount': amount
                    };
                    if (type === 'market') order['type'] += '_market';
                    else order['price'] = price;
                    const response = await this.privatePostCreateOrder(this.extend(order, params));
                    order = this.omit(order, 'type');
                    order['order_id'] = response['order_id'];
                    order['type'] = side;
                    order['order_type'] = type;
                    order['create_time'] = this.milliseconds();
                    order['info'] = response;
                    return this.parseOrder(order, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'order_id': id
                    };
                    const response = await this.privatePostCancelOrder(this.extend(request, params));
                    return response;
                }
                async fetchOrder(id, symbol, params = {}) {
                    // Id can be a list of ids delimited by a comma
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'order_id': id
                    };
                    const response = await this.privatePostOrdersInfo(this.extend(request, params));
                    const data = this.safeValue(response, 'orders', []);
                    const orders = this.parseOrders(data, market);
                    const numOrders = orders.length;
                    if (numOrders === 1) return orders[0];
                    else return orders;
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (limit === undefined) limit = 100;
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'current_page': 1,
                        'page_length': limit
                    };
                    const response = await this.privatePostOrdersInfoHistory(this.extend(request, params));
                    const data = this.safeValue(response, 'orders', []);
                    return this.parseOrders(data, undefined, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        symbol = market['symbol'];
                    }
                    const orders = await this.fetchOrders(symbol, since, limit, params);
                    const closed = this.filterBy(orders, 'status', 'closed');
                    const canceled = this.filterBy(orders, 'status', 'cancelled'); // cancelled orders may be partially filled
                    const allOrders = this.arrayConcat(closed, canceled);
                    return this.filterBySymbolSinceLimit(allOrders, symbol, since, limit);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    // mark and fee are optional params, mark is a note and must be less than 255 characters
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'assetCode': currency['id'],
                        'amount': amount,
                        'account': address
                    };
                    if (tag !== undefined) request['memo'] = tag;
                    const response = this.privatePostWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         'result': 'true',
                    //         'withdrawId': 90082,
                    //         'fee':0.001
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         'result': 'true',
                    //         'withdrawId': 90082,
                    //         'fee':0.001
                    //     }
                    //
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'id': this.safeString2(transaction, 'id', 'withdrawId'),
                        'txid': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': undefined,
                        'info': transaction
                    };
                }
                convertSecretToPem(secret) {
                    const lineLength = 64;
                    const secretLength = secret.length - 0;
                    let numLines = parseInt(secretLength / lineLength);
                    numLines = this.sum(numLines, 1);
                    let pem = "-----BEGIN PRIVATE KEY-----\n"; // eslint-disable-line
                    for(let i = 0; i < numLines; i++){
                        const start = i * lineLength;
                        const end = this.sum(start, lineLength);
                        pem += this.secret.slice(start, end) + "\n"; // eslint-disable-line
                    }
                    return pem + '-----END PRIVATE KEY-----';
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const query = this.omit(params, this.extractParams(path));
                    let url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
                    // Every endpoint ends with ".do"
                    url += '.do';
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        const query = this.keysort(this.extend({
                            'api_key': this.apiKey
                        }, params));
                        const queryString = this.rawencode(query);
                        const message = this.hash(this.encode(queryString)).toUpperCase();
                        const cacheSecretAsPem = this.safeValue(this.options, 'cacheSecretAsPem', true);
                        let pem = undefined;
                        if (cacheSecretAsPem) {
                            pem = this.safeValue(this.options, 'pem');
                            if (pem === undefined) {
                                pem = this.convertSecretToPem(this.secret);
                                this.options['pem'] = pem;
                            }
                        } else pem = this.convertSecretToPem(this.secret);
                        const sign = this.binaryToBase64(this.rsa(message, this.encode(pem), 'RS256'));
                        query['sign'] = sign;
                        body = this.urlencode(query);
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    const success = this.safeString(response, 'result');
                    if (success === 'false') {
                        const errorCode = this.safeString(response, 'error_code');
                        const message = this.safeString({
                            '10000': 'Internal error',
                            '10001': 'The required parameters can not be empty',
                            '10002': 'verification failed',
                            '10003': 'Illegal parameters',
                            '10004': 'User requests are too frequent',
                            '10005': 'Key does not exist',
                            '10006': 'user does not exist',
                            '10007': 'Invalid signature',
                            '10008': 'This currency pair is not supported',
                            '10009': 'Limit orders can not be missing orders and the number of orders',
                            '10010': 'Order price or order quantity must be greater than 0',
                            '10011': 'Market orders can not be missing the amount of the order',
                            '10012': 'market sell orders can not be missing orders',
                            '10013': 'is less than the minimum trading position 0.001',
                            '10014': 'Account number is not enough',
                            '10015': 'The order type is wrong',
                            '10016': 'Account balance is not enough',
                            '10017': 'Abnormal server',
                            '10018': 'order inquiry can not be more than 50 less than one',
                            '10019': 'withdrawal orders can not be more than 3 less than one',
                            '10020': 'less than the minimum amount of the transaction limit of 0.001',
                            '10022': 'Insufficient key authority'
                        }, errorCode, this.json(response));
                        const ErrorClass = this.safeValue({
                            '10002': AuthenticationError,
                            '10004': DDoSProtection,
                            '10005': AuthenticationError,
                            '10006': AuthenticationError,
                            '10007': AuthenticationError,
                            '10009': InvalidOrder,
                            '10010': InvalidOrder,
                            '10011': InvalidOrder,
                            '10012': InvalidOrder,
                            '10013': InvalidOrder,
                            '10014': InvalidOrder,
                            '10015': InvalidOrder,
                            '10016': InvalidOrder,
                            '10022': AuthenticationError
                        }, errorCode, ExchangeError1);
                        throw new ErrorClass(message);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    101: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, InvalidAddress: InvalidAddress, DuplicateOrderId: DuplicateOrderId, ArgumentsRequired: ArgumentsRequired1, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, InvalidNonce: InvalidNonce, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded, PermissionDenied: PermissionDenied, BadRequest: BadRequest, BadSymbol: BadSymbol } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class lbank2 extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'lbank2',
                        'name': 'LBank',
                        'countries': [
                            'CN'
                        ],
                        'version': 'v2',
                        // 50 per second for making and cancelling orders 1000ms / 50 = 20
                        // 20 per second for all other requests, cost = 50 / 20 = 2.5
                        'rateLimit': 20,
                        'has': {
                            'CORS': false,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': false,
                            'fetchFundingFees': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchIsolatedPositions': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': false,
                            'fetchTrades': true,
                            'fetchTradingFees': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': false
                        },
                        'timeframes': {
                            '1m': 'minute1',
                            '5m': 'minute5',
                            '15m': 'minute15',
                            '30m': 'minute30',
                            '1h': 'hour1',
                            '2h': 'hour2',
                            '4h': 'hour4',
                            '6h': 'hour6',
                            '8h': 'hour8',
                            '12h': 'hour12',
                            '1d': 'day1',
                            '1w': 'week1'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/38063602-9605e28a-3302-11e8-81be-64b1e53c4cfb.jpg',
                            'api': 'https://api.lbank.info',
                            'api2': 'https://api.lbkex.com',
                            'www': 'https://www.lbank.info',
                            'doc': 'https://github.com/LBank-exchange/lbank-official-api-docs',
                            'fees': 'https://lbankinfo.zendesk.com/hc/en-gb/articles/360012072873-Trading-Fees',
                            'referral': 'https://www.lbex.io/invite?icode=7QCY'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'currencyPairs': 2.5,
                                    'accuracy': 2.5,
                                    'usdToCny': 2.5,
                                    'withdrawConfigs': 2.5,
                                    'timestamp': 2.5,
                                    'ticker/24h': 2.5,
                                    'ticker': 2.5,
                                    'depth': 2.5,
                                    'incrDepth': 2.5,
                                    'trades': 2.5,
                                    'kline': 2.5,
                                    // new quote endpoints
                                    'supplement/system_ping': 2.5,
                                    'supplement/incrDepth': 2.5,
                                    'supplement/trades': 2.5,
                                    'supplement/ticker/price': 2.5,
                                    'supplement/ticker/bookTicker': 2.5
                                },
                                'post': {
                                    'supplement/system_status': 2.5
                                }
                            },
                            'private': {
                                'post': {
                                    // account
                                    'user_info': 2.5,
                                    'subscribe/get_key': 2.5,
                                    'subscribe/refresh_key': 2.5,
                                    'subscribe/destroy_key': 2.5,
                                    'get_deposit_address': 2.5,
                                    'deposit_history': 2.5,
                                    // order
                                    'create_order': 1,
                                    'batch_create_order': 1,
                                    'cancel_order': 1,
                                    'cancel_clientOrders': 1,
                                    'orders_info': 2.5,
                                    'orders_info_history': 2.5,
                                    'order_transaction_detail': 2.5,
                                    'transaction_history': 2.5,
                                    'orders_info_no_deal': 2.5,
                                    // withdraw
                                    'withdraw': 2.5,
                                    'withdrawCancel': 2.5,
                                    'withdraws': 2.5,
                                    'supplement/user_info': 2.5,
                                    'supplement/withdraw': 2.5,
                                    'supplement/deposit_history': 2.5,
                                    'supplement/withdraws': 2.5,
                                    'supplement/get_deposit_address': 2.5,
                                    'supplement/asset_detail': 2.5,
                                    'supplement/customer_trade_fee': 2.5,
                                    'supplement/api_Restrictions': 2.5,
                                    // new quote endpoints
                                    'supplement/system_ping': 2.5,
                                    // new order endpoints
                                    'supplement/create_order_test': 1,
                                    'supplement/create_order': 1,
                                    'supplement/cancel_order': 1,
                                    'supplement/cancel_order_by_symbol': 1,
                                    'supplement/orders_info': 2.5,
                                    'supplement/orders_info_no_deal': 2.5,
                                    'supplement/orders_info_history': 2.5,
                                    'supplement/user_info_account': 2.5,
                                    'supplement/transaction_history': 2.5
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.001'),
                                'taker': this.parseNumber('0.001')
                            },
                            'funding': {
                                'withdraw': {}
                            }
                        },
                        'commonCurrencies': {
                            'VET_ERC20': 'VEN',
                            'PNT': 'Penta'
                        },
                        'options': {
                            'cacheSecretAsPem': true,
                            'fetchTrades': {
                                'method': 'publicGetTrades'
                            },
                            'fetchFundingFees': {
                                'method': 'fetchPrivateFundingFees'
                            },
                            'fetchDepositAddress': {
                                'method': 'fetchDepositAddressDefault'
                            },
                            'createOrder': {
                                'method': 'privatePostSupplementCreateOrder'
                            },
                            'fetchOrder': {
                                'method': 'fetchOrderSupplement'
                            },
                            'fetchBalance': {
                                'method': 'privatePostSupplementUserInfo'
                            },
                            'networks': {
                                'ERC20': 'erc20',
                                'ETH': 'erc20',
                                'TRC20': 'trc20',
                                'TRX': 'trc20',
                                'OMNI': 'omni',
                                'ASA': 'asa',
                                'BEP20': 'bep20(bsc)',
                                'BSC': 'bep20(bsc)',
                                'HT': 'heco',
                                'BNB': 'bep2',
                                'BTC': 'btc',
                                'DOGE': 'dogecoin',
                                'MATIC': 'matic',
                                'POLYGON': 'matic',
                                'OEC': 'oec',
                                'BTCTRON': 'btctron',
                                'XRP': 'xrp'
                            },
                            'inverse-networks': {
                                'erc20': 'ERC20',
                                'trc20': 'TRC20',
                                'omni': 'OMNI',
                                'asa': 'ASA',
                                'bep20(bsc)': 'BSC',
                                'bep20': 'BSC',
                                'heco': 'HT',
                                'bep2': 'BNB',
                                'btc': 'BTC',
                                'dogecoin': 'DOGE',
                                'matic': 'MATIC',
                                'oec': 'OEC',
                                'btctron': 'BTCTRON',
                                'xrp': 'XRP'
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    // needs to return a list of unified market structures
                    const response = await this.publicGetAccuracy();
                    const data = this.safeValue(response, 'data');
                    //      [
                    //          {
                    //              symbol: 'snx3s_usdt',
                    //              quantityAccuracy: '2',
                    //              minTranQua: '0.01',
                    //              priceAccuracy: '6'
                    //          }
                    //     ]
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const marketId = this.safeString(market, 'symbol');
                        const parts = marketId.split('_');
                        const baseId = parts[0];
                        const quoteId = parts[1];
                        const base = baseId.toUpperCase();
                        const quote = quoteId.toUpperCase();
                        let symbol = base + '/' + quote;
                        const productTypes = {
                            '3l': true,
                            '5l': true,
                            '3s': true,
                            '5s': true
                        };
                        const ending = baseId.slice(-2);
                        const isLeveragedProduct = this.safeValue(productTypes, ending, false);
                        if (isLeveragedProduct) symbol += ':' + quote;
                        let linear = undefined;
                        if (isLeveragedProduct === true) linear = true;
                        result.push({
                            'id': marketId,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': isLeveragedProduct,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': isLeveragedProduct,
                            'linear': linear,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'quantityAccuracy'),
                                'price': this.safeInteger(market, 'priceAccuracy')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeInteger(market, 'minTranQua'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    //      {
                    //          "symbol":"btc_usdt",
                    //          "ticker": {
                    //              "high":40200.88,
                    //              "vol":7508.3096,
                    //              "low":38239.38,
                    //              "change":0.75,
                    //              "turnover":292962771.34,
                    //              "latest":39577.95
                    //               },
                    //           "timestamp":1647005189792
                    //      }
                    //
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.safeString(ticker, 'timestamp');
                    const tickerData = this.safeValue(ticker, 'ticker');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(tickerData, 'high'),
                        'low': this.safeString(tickerData, 'low'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': undefined,
                        'last': this.safeString(tickerData, 'latest'),
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': this.safeString(tickerData, 'change'),
                        'average': undefined,
                        'baseVolume': this.safeString(tickerData, 'vol'),
                        'quoteVolume': this.safeString(tickerData, 'turnover'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    // preferred ticker/24h endpoint is down
                    const response = await this.publicGetTicker(this.extend(request, params));
                    //
                    //      {
                    //          "result":"true",
                    //          "data": [
                    //              {
                    //                  "symbol":"btc_usdt",
                    //                  "ticker":{
                    //                          "high":40200.88,
                    //                          "vol":7508.3096,
                    //                          "low":38239.38,
                    //                          "change":0.75,
                    //                          "turnover":292962771.34,
                    //                          "latest":39577.95
                    //                      },
                    //                  "timestamp":1647005189792
                    //               }
                    //                   ],
                    //          "error_code":0,"ts":1647005190755
                    //      }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const first = this.safeValue(data, 0, {});
                    return this.parseTicker(first, market);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetSupplementIncrDepth(this.extend(request, params));
                    const orderbook = response['data'];
                    const timestamp = this.milliseconds();
                    return this.parseOrderBook(orderbook, symbol, timestamp);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (old) publicGetTrades
                    //
                    //      {
                    //          "date_ms":1647021989789,
                    //          "amount":0.0028,
                    //          "price":38804.2,
                    //          "type":"buy",
                    //          "tid":"52d5616ee35c43019edddebe59b3e094"
                    //      }
                    //
                    //
                    // fetchTrades (new) publicGetTradesSupplement
                    //
                    //      {
                    //          "quoteQty":1675.048485,
                    //          "price":0.127545,
                    //          "qty":13133,
                    //          "id":"3589541dc22e4357b227283650f714e2",
                    //          "time":1648058297110,
                    //          "isBuyerMaker":false
                    //      }
                    //
                    // fetchMyTrades (private)
                    //
                    //      {
                    //          "orderUuid":"38b4e7a4-14f6-45fd-aba1-1a37024124a0",
                    //          "tradeFeeRate":0.0010000000,
                    //          "dealTime":1648500944496,
                    //          "dealQuantity":30.00000000000000000000,
                    //          "tradeFee":0.00453300000000000000,
                    //          "txUuid":"11f3850cc6214ea3b495adad3a032794",
                    //          "dealPrice":0.15111300000000000000,
                    //          "dealVolumePrice":4.53339000000000000000,
                    //          "tradeType":"sell_market"
                    //      }
                    //
                    let timestamp = this.safeInteger2(trade, 'date_ms', 'time');
                    if (timestamp === undefined) timestamp = this.safeInteger(trade, 'dealTime');
                    let amountString = this.safeString2(trade, 'amount', 'qty');
                    if (amountString === undefined) amountString = this.safeString(trade, 'dealQuantity');
                    let priceString = this.safeString(trade, 'price');
                    if (priceString === undefined) priceString = this.safeString(trade, 'dealPrice');
                    let costString = this.safeString(trade, 'quoteQty');
                    if (costString === undefined) costString = this.safeString(trade, 'dealVolumePrice');
                    let side = this.safeString2(trade, 'tradeType', 'type');
                    let type = undefined;
                    let takerOrMaker = undefined;
                    if (side !== undefined) {
                        const parts = side.split('_');
                        side = this.safeString(parts, 0);
                        const typePart = this.safeString(parts, 1);
                        type = 'limit';
                        takerOrMaker = 'taker';
                        if (typePart !== undefined) {
                            if (typePart === 'market') type = 'market';
                            else if (typePart === 'maker') takerOrMaker = 'maker';
                        }
                    }
                    let id = this.safeString2(trade, 'tid', 'id');
                    if (id === undefined) id = this.safeString(trade, 'txUuid');
                    const order = this.safeString(trade, 'orderUuid');
                    const symbol = this.safeSymbol(undefined, market);
                    let fee = undefined;
                    const feeCost = this.safeString(trade, 'tradeFee');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': undefined,
                        'rate': this.safeString(trade, 'tradeFeeRate')
                    };
                    return this.safeTrade({
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': order,
                        'type': type,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['time'] = since;
                    if (limit !== undefined) request['size'] = limit;
                    else request['size'] = 600; // max
                    let method = this.safeString(params, 'method');
                    params = this.omit(params, 'method');
                    if (method === undefined) {
                        const options = this.safeValue(this.options, 'fetchTrades', {});
                        method = this.safeString(options, 'method', 'publicGetTrades');
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //      {
                    //          "result":"true",
                    //          "data": [
                    //              {
                    //                  "date_ms":1647021989789,
                    //                  "amount":0.0028,
                    //                  "price":38804.2,
                    //                  "type":"buy",
                    //                  "tid":"52d5616ee35c43019edddebe59b3e094"
                    //               }
                    //           ],
                    //           "error_code":0,
                    //           "ts":1647021999308
                    //      }
                    const trades = this.safeValue(response, 'data', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //   [
                    //     1482311500, // timestamp
                    //     5423.23,    // open
                    //     5472.80,    // high
                    //     5516.09,    // low
                    //     5462,       // close
                    //     234.3250    // volume
                    //   ],
                    //
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    // endpoint doesnt work
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (since === undefined) throw new ArgumentsRequired1(this.id + ' fetchOHLCV () requires a since argument');
                    if (limit === undefined) limit = 100;
                    const request = {
                        'symbol': market['id'],
                        'type': this.timeframes[timeframe],
                        'time': parseInt(since / 1000),
                        'size': limit
                    };
                    const response = await this.publicGetKline(this.extend(request, params));
                    const ohlcvs = this.safeValue(response, 'data', []);
                    //
                    //
                    // [
                    //   [
                    //     1482311500,
                    //     5423.23,
                    //     5472.80,
                    //     5516.09,
                    //     5462,
                    //     234.3250
                    //   ],
                    //   [
                    //     1482311400,
                    //     5432.52,
                    //     5459.87,
                    //     5414.30,
                    //     5428.23,
                    //     213.7329
                    //   ]
                    // ]
                    //
                    return this.parseOHLCVs(ohlcvs, market, timeframe, since, limit);
                }
                parseBalance(response) {
                    //
                    // privatePostUserInfo
                    //
                    //      {
                    //          "toBtc": {
                    //              "egc:": "0",
                    //              "iog": "0",
                    //              "ksm": "0",
                    //              },
                    //          "freeze": {
                    //              "egc": "0",
                    //              "iog": "0",
                    //              "ksm": "0" ,
                    //              },
                    //          "asset": {
                    //              "egc": "0",
                    //              "iog": "0",
                    //              "ksm": "0",
                    //              },
                    //          "free": {
                    //              "egc": "0",
                    //              "iog": "0",
                    //              "ksm": "0",
                    //              }
                    //      }
                    //
                    // privatePostSupplementUserInfoAccount
                    //
                    //      {
                    //          "balances":[
                    //              {
                    //                  "asset":"lbk",
                    //                  "free":"0",
                    //                  "locked":"0"
                    //              }, ...
                    //          ]
                    //      }
                    //
                    // privatePostSupplementUserInfo
                    //
                    //      [
                    //          {
                    //              "usableAmt":"31.45130723",
                    //              "assetAmt":"31.45130723",
                    //              "networkList":[
                    //                  {
                    //                      "isDefault":true,
                    //                      "withdrawFeeRate":"",
                    //                      "name":"bep20(bsc)",
                    //                      "withdrawMin":30,
                    //                      "minLimit":0.0001,
                    //                      "minDeposit":0.0001,
                    //                      "feeAssetCode":"doge",
                    //                      "withdrawFee":"30",
                    //                      "type":1,
                    //                      "coin":"doge",
                    //                      "network":"bsc"
                    //                  },
                    //                  {
                    //                      "isDefault":false,
                    //                      "withdrawFeeRate":"",
                    //                      "name":"dogecoin",
                    //                      "withdrawMin":10,
                    //                      "minLimit":0.0001,
                    //                      "minDeposit":10,
                    //                      "feeAssetCode":"doge",
                    //                      "withdrawFee":"10",
                    //                      "type":1,
                    //                      "coin":"doge",
                    //                      "network":"dogecoin"
                    //                  }
                    //              ],
                    //              "freezeAmt":"0",
                    //              "coin":"doge"
                    //          }, ...
                    //      ]
                    //
                    const timestamp = this.safeInteger(response, 'ts');
                    const result = {
                        'info': response,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    };
                    const data = this.safeValue(response, 'data');
                    // from privatePostUserInfo
                    const toBtc = this.safeValue(data, 'toBtc');
                    if (toBtc !== undefined) {
                        const used = this.safeValue(data, 'freeze', {});
                        const free = this.safeValue(data, 'free', {});
                        const currencies = Object.keys(free);
                        for(let i = 0; i < currencies.length; i++){
                            const currencyId = currencies[i];
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            account['used'] = this.safeString(used, currencyId);
                            account['free'] = this.safeString(free, currencyId);
                            result[code] = account;
                        }
                        return this.safeBalance(result);
                    }
                    // from privatePostSupplementUserInfoAccount
                    const balances = this.safeValue(data, 'balances');
                    if (balances !== undefined) {
                        for(let i = 0; i < balances.length; i++){
                            const item = balances[i];
                            const currencyId = this.safeString(item, 'asset');
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            account['free'] = this.safeString(item, 'free');
                            account['used'] = this.safeString(item, 'locked');
                            result[code] = account;
                        }
                        return this.safeBalance(result);
                    }
                    // from privatePostSupplementUserInfo
                    const isArray = Array.isArray(data);
                    if (isArray === true) {
                        for(let i = 0; i < data.length; i++){
                            const item = data[i];
                            const currencyId = this.safeString(item, 'coin');
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            account['free'] = this.safeString(item, 'usableAmt');
                            account['used'] = this.safeString(item, 'freezeAmt');
                            result[code] = account;
                        }
                        return this.safeBalance(result);
                    }
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    let method = this.safeString(params, 'method');
                    if (method === undefined) {
                        const options = this.safeValue(this.options, 'fetchBalance', {});
                        method = this.safeString(options, 'method', 'privatePostSupplementUserInfo');
                    }
                    const response = await this[method]();
                    return this.parseBalance(response);
                }
                parseTradingFee(fee, market) {
                    //
                    //      {
                    //          "symbol":"skt_usdt",
                    //          "makerCommission":"0.10",
                    //          "takerCommission":"0.10"
                    //      }
                    //
                    const marketId = this.safeString(fee, 'symbol');
                    const symbol = this.safeSymbol(marketId);
                    return {
                        'info': fee,
                        'symbol': symbol,
                        'maker': this.safeNumber(fee, 'makerCommission'),
                        'taker': this.safeNumber(fee, 'takerCommission')
                    };
                }
                async fetchTradingFee(symbol, params = {}) {
                    const market = this.market(symbol);
                    const result = await this.fetchTradingFees(this.extend(params, {
                        'category': market['id']
                    }));
                    return result;
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    const response = await this.privatePostSupplementCustomerTradeFee(this.extend(request, params));
                    const fees = this.safeValue(response, 'data', []);
                    const result = {};
                    for(let i = 0; i < fees.length; i++){
                        const fee = this.parseTradingFee(fees[i]);
                        const symbol = fee['symbol'];
                        result[symbol] = fee;
                    }
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const clientOrderId = this.safeString2(params, 'custom_id', 'clientOrderId');
                    const postOnly = this.safeString(params, 'postOnly', false);
                    const timeInForce = this.safeStringUpper(params, 'timeInForce');
                    params = this.omit(params, [
                        'custom_id',
                        'clientOrderId',
                        'timeInForce',
                        'postOnly'
                    ]);
                    if (type === 'limit') {
                        type = side;
                        if (side === 'sell') {
                            if (timeInForce === 'FOK') type = 'sell_fok';
                            if (timeInForce === 'IOC') type = 'sell_ioc';
                            if (postOnly || timeInForce === 'PO') type = 'sell_maker';
                        }
                        if (side === 'buy') {
                            if (timeInForce === 'FOK') type = 'buy_fok';
                            if (timeInForce === 'IOC') type = 'buy_ioc';
                            if (postOnly || timeInForce === 'PO') type = 'buy_maker';
                        }
                    }
                    if (type === 'market') {
                        if (side === 'sell') type = 'sell_market';
                        if (side === 'buy') type = 'buy_market';
                    }
                    const request = {
                        'symbol': market['id'],
                        'amount': this.amountToPrecision(symbol, amount),
                        'type': type
                    };
                    if (price !== undefined) request['price'] = this.priceToPrecision(symbol, price);
                    else request['price'] = 1; // required unused number > 0 even for market orders
                    if (clientOrderId !== undefined) request['custom_id'] = clientOrderId;
                    let method = undefined;
                    method = this.safeString(params, 'method');
                    params = this.omit(params, 'method');
                    if (method === undefined) {
                        const options = this.safeValue(this.options, 'createOrder', {});
                        method = this.safeString(options, 'method', 'privatePostSupplementCreateOrder');
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //      {
                    //          "result":true,
                    //          "data":{
                    //              "symbol":"doge_usdt",
                    //              "order_id":"0cf8a3de-4597-4296-af45-be7abaa06b07"
                    //              },
                    //          "error_code":0,
                    //          "ts":1648162321043
                    //      }
                    //
                    const result = this.safeValue(response, 'data', {});
                    return {
                        'id': this.safeString(result, 'order_id'),
                        'info': result
                    };
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '-1': 'cancelled',
                        '0': 'open',
                        '1': 'open',
                        '2': 'closed',
                        '3': 'closed',
                        '4': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // fetchOrderSupplement (private)
                    //
                    //      {
                    //          "cummulativeQuoteQty":0,
                    //          "symbol":"doge_usdt",
                    //          "executedQty":0,
                    //          "orderId":"53d2d53e-70fb-4398-b722-f48571a5f61e",
                    //          "origQty":1E+2,
                    //          "price":0.05,
                    //          "clientOrderId":null,
                    //          "origQuoteOrderQty":5,
                    //          "updateTime":1648163406000,
                    //          "time":1648163139387,
                    //          "type":"buy_maker",
                    //          "status":-1
                    //      }
                    //
                    //
                    // fetchOrderDefault (private)
                    //
                    //      {
                    //          "symbol":"shib_usdt",
                    //          "amount":1,
                    //          "create_time":1649367863356,
                    //          "price":0.0000246103,
                    //          "avg_price":0.00002466180000000104,
                    //          "type":"buy_market",
                    //          "order_id":"abe8b92d-86d9-4d6d-b71e-d14f5fb53ddf",
                    //          "custom_id": "007",                                 // field only present if user creates it at order time
                    //          "deal_amount":40548.54065802,
                    //          "status":2
                    //      }
                    //
                    // fetchOpenOrders (private)
                    //
                    //      {
                    //          "cummulativeQuoteQty":0,
                    //          "symbol":"doge_usdt",
                    //          "executedQty":0,
                    //          "orderId":"73878edf-008d-4e4c-8041-df1f1b2cd8bb",
                    //          "origQty":100,
                    //          "price":0.05,
                    //          "origQuoteOrderQty":5,
                    //          "updateTime":1648501762000,
                    //          "time":1648501762353,
                    //          "type":"buy",
                    //          "status":0
                    //      }
                    //
                    // fetchOrders (private)
                    //
                    //      {
                    //          "cummulativeQuoteQty":0,
                    //          "symbol":"doge_usdt",
                    //          "executedQty":0,
                    //          "orderId":"2cadc7cc-b5f6-486b-a5b4-d6ac49a9c186",
                    //          "origQty":100,
                    //          "price":0.05,
                    //          "origQuoteOrderQty":5,
                    //          "updateTime":1648501384000,
                    //          "time":1648501363889,
                    //          "type":"buy",
                    //          "status":-1
                    //      }
                    //
                    const id = this.safeString2(order, 'orderId', 'order_id');
                    const clientOrderId = this.safeString2(order, 'clientOrderId', 'custom_id');
                    const timestamp = this.safeString2(order, 'time', 'create_time');
                    const rawStatus = this.safeString(order, 'status');
                    const marketId = this.safeString(order, 'symbol');
                    market = this.safeMarket(marketId, market);
                    let timeInForce = undefined;
                    let postOnly = false;
                    let type = 'limit';
                    let side = this.safeString(order, 'type'); // buy, sell, buy_market, sell_market, buy_maker,sell_maker,buy_ioc,sell_ioc, buy_fok, sell_fok
                    const parts = side.split('_');
                    side = this.safeString(parts, 0);
                    const typePart = this.safeString(parts, 1); // market, maker, ioc, fok or undefined (limit)
                    if (typePart === 'market') type = 'market';
                    if (typePart === 'maker') {
                        postOnly = true;
                        timeInForce = 'PO';
                    }
                    if (typePart === 'ioc') timeInForce = 'IOC';
                    if (typePart === 'fok') timeInForce = 'FOK';
                    const price = this.safeString(order, 'price');
                    const costString = this.safeString(order, 'cummulativeQuoteQty');
                    const amountString = this.safeString2(order, 'origQty', 'amount');
                    const filledString = this.safeString2(order, 'executedQty', 'deal_amount');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'lastTradeTimestamp': undefined,
                        'status': this.parseOrderStatus(rawStatus),
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': costString,
                        'amount': amountString,
                        'filled': filledString,
                        'remaining': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'info': order,
                        'average': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    let method = this.safeString(params, 'method');
                    if (method === undefined) {
                        const options = this.safeValue(this.options, 'fetchOrder', {});
                        method = this.safeString(options, 'method', 'fetchOrderSupplement');
                    }
                    const result = await this[method](id, symbol, params);
                    return result;
                }
                async fetchOrderSupplement(id, symbol, params = {}) {
                    await this.loadMarkets();
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder () requires a symbol argument');
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'orderId': id
                    };
                    const response = await this.privatePostSupplementOrdersInfo(this.extend(request, params));
                    //
                    //      {
                    //          "result":true,
                    //          "data":{
                    //              "cummulativeQuoteQty":0,
                    //              "symbol":"doge_usdt",
                    //              "executedQty":0,
                    //              "orderId":"53d2d53e-70fb-4398-b722-f48571a5f61e",
                    //              "origQty":1E+2,
                    //              "price":0.05,
                    //              "clientOrderId":null,
                    //              "origQuoteOrderQty":5,
                    //              "updateTime":1648163406000,
                    //              "time":1648163139387,
                    //              "type":"buy_maker",
                    //              "status":-1
                    //              },
                    //          "error_code":0,
                    //          "ts":1648164471827
                    //      }
                    //
                    const result = this.safeValue(response, 'data', {});
                    return this.parseOrder(result);
                }
                async fetchOrderDefault(id, symbol, params = {}) {
                    // Id can be a list of ids delimited by a comma
                    await this.loadMarkets();
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder () requires a symbol argument');
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'order_id': id
                    };
                    const response = await this.privatePostOrdersInfo(this.extend(request, params));
                    //
                    //      {
                    //          "result":true,
                    //          "data":[
                    //              {
                    //                  "symbol":"doge_usdt",
                    //                  "amount":18,
                    //                  "create_time":1647455223186,
                    //                  "price":0,
                    //                  "avg_price":0.113344,
                    //                  "type":"sell_market",
                    //                  "order_id":"d4ca1ddd-40d9-42c1-9717-5de435865bec",
                    //                  "deal_amount":18,
                    //                  "status":2
                    //                }
                    //            ],
                    //          "error_code":0,
                    //          "ts":1647455270776
                    //      }
                    //
                    const result = this.safeValue(response, 'data', []);
                    const numOrders = result.length;
                    if (numOrders === 1) return this.parseOrder(result[0]);
                    else {
                        const parsedOrders = [];
                        for(let i = 0; i < numOrders; i++){
                            const parsedOrder = this.parseOrder(result[i]);
                            parsedOrders.push(parsedOrder);
                        }
                        return parsedOrders;
                    }
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades () requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    since = this.safeValue(params, 'start_date', since);
                    params = this.omit(params, 'start_date');
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['size'] = limit;
                    if (since !== undefined) request['start_date'] = this.ymd(since, '-'); // max query 2 days ago
                    const response = await this.privatePostTransactionHistory(this.extend(request, params));
                    //
                    //      {
                    //          "result":true,
                    //          "data":[
                    //              {
                    //                  "orderUuid":"38b4e7a4-14f6-45fd-aba1-1a37024124a0",
                    //                  "tradeFeeRate":0.0010000000,
                    //                  "dealTime":1648500944496,
                    //                  "dealQuantity":30.00000000000000000000,
                    //                  "tradeFee":0.00453300000000000000,
                    //                  "txUuid":"11f3850cc6214ea3b495adad3a032794",
                    //                  "dealPrice":0.15111300000000000000,
                    //                  "dealVolumePrice":4.53339000000000000000,
                    //                  "tradeType":"sell_market"
                    //              }
                    //          ],
                    //          "error_code":0,
                    //          "ts":1648509742164
                    //      }
                    //
                    const trades = this.safeValue(response, 'data', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    // default query is for cancelled and completely filled orders
                    // does not return open orders unless specified explicitly
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (limit === undefined) limit = 100;
                    const request = {
                        'symbol': market['id'],
                        'current_page': 1,
                        'page_length': limit
                    };
                    const response = await this.privatePostSupplementOrdersInfoHistory(this.extend(request, params));
                    //
                    //      {
                    //          "result":true,
                    //          "data":{
                    //              "total":1,
                    //              "page_length":100,
                    //              "orders":[
                    //                  {
                    //                      "cummulativeQuoteQty":0,
                    //                      "symbol":"doge_usdt",
                    //                      "executedQty":0,
                    //                      "orderId":"2cadc7cc-b5f6-486b-a5b4-d6ac49a9c186",
                    //                      "origQty":100,
                    //                      "price":0.05,
                    //                      "origQuoteOrderQty":5,
                    //                      "updateTime":1648501384000,
                    //                      "time":1648501363889,
                    //                      "type":"buy",
                    //                      "status":-1
                    //                  }, ...
                    //              ],
                    //              "current_page":1
                    //          },
                    //          "error_code":0,
                    //          "ts":1648505706348
                    //      }
                    //
                    const result = this.safeValue(response, 'data', {});
                    const orders = this.safeValue(result, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (limit === undefined) limit = 100;
                    const request = {
                        'symbol': market['id'],
                        'current_page': 1,
                        'page_length': limit
                    };
                    const response = await this.privatePostSupplementOrdersInfoNoDeal(this.extend(request, params));
                    //
                    //      {
                    //          "result":true,
                    //          "data":{
                    //              "total":1,
                    //              "page_length":100,
                    //              "orders":[
                    //                  {
                    //                      "cummulativeQuoteQty":0,
                    //                      "symbol":"doge_usdt",
                    //                      "executedQty":0,
                    //                      "orderId":"73878edf-008d-4e4c-8041-df1f1b2cd8bb",
                    //                      "origQty":100,
                    //                      "price":0.05,
                    //                      "origQuoteOrderQty":5,
                    //                      "updateTime":1648501762000,
                    //                      "time":1648501762353,
                    //                      "type":"buy",
                    //                      "status":0
                    //                  }, ...
                    //             ],
                    //             "current_page":1
                    //         },
                    //         "error_code":0,
                    //         "ts":1648506110196
                    //     }
                    //
                    const result = this.safeValue(response, 'data', {});
                    const orders = this.safeValue(result, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const clientOrderId = this.safeString2(params, 'origClientOrderId', 'clientOrderId');
                    params = this.omit(params, [
                        'origClientOrderId',
                        'clientOrderId'
                    ]);
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (clientOrderId !== undefined) request['origClientOrderId'] = clientOrderId;
                    request['orderId'] = id;
                    const response = await this.privatePostSupplementCancelOrder(this.extend(request, params));
                    //
                    //   {
                    //      "result":true,
                    //      "data":{
                    //          "executedQty":0.0,
                    //          "price":0.05,
                    //          "origQty":100.0,
                    //          "tradeType":"buy",
                    //          "status":0
                    //          },
                    //      "error_code":0,
                    //      "ts":1648501286196
                    //  }
                    const result = this.safeValue(response, 'data', {});
                    return result;
                }
                async cancelAllOrders(symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelAllOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.privatePostSupplementCancelOrderBySymbol(this.extend(request, params));
                    //
                    //      {
                    //          "result":"true",
                    //          "data":[
                    //              {
                    //                  "executedQty":0.00000000000000000000,
                    //                  "orderId":"293ef71b-3e67-4962-af93-aa06990a045f",
                    //                  "price":0.05000000000000000000,
                    //                  "origQty":100.00000000000000000000,
                    //                  "tradeType":"buy",
                    //                  "status":0
                    //              },
                    //          ],
                    //          "error_code":0,
                    //          "ts":1648506641469
                    //      }
                    //
                    const result = this.safeValue(response, 'data', []);
                    return result;
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    let method = this.safeString(params, 'method');
                    params = this.omit(params, 'method');
                    if (method === undefined) {
                        const options = this.safeValue(this.options, 'fetchDepositAddress', {});
                        method = this.safeString(options, 'method', 'fetchPrivateTradingFees');
                    }
                    return await this[method](code, params);
                }
                async fetchDepositAddressDefault(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'assetCode': currency['id']
                    };
                    const networks = this.safeValue(this.options, 'networks');
                    let network = this.safeStringUpper(params, 'network');
                    network = this.safeString(networks, network, network);
                    if (network !== undefined) {
                        request['netWork'] = network; // ... yes, really lol
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privatePostGetDepositAddress(this.extend(request, params));
                    //
                    //      {
                    //          "result":true,
                    //          "data":{
                    //              "assetCode":"usdt",
                    //              "address":"0xc85689d37ca650bf2f2161364cdedee21eb6ca53",
                    //              "memo":null,
                    //              "netWork":"bep20(bsc)"
                    //              },
                    //          "error_code":0,
                    //          "ts":1648075865103
                    //      }
                    //
                    const result = this.safeValue(response, 'data');
                    const address = this.safeString(result, 'address');
                    const tag = this.safeString(result, 'memo');
                    const networkId = this.safeString(result, 'netWork');
                    const inverseNetworks = this.safeValue(this.options, 'inverse-networks', {});
                    const networkCode = this.safeStringUpper(inverseNetworks, networkId, networkId);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': networkCode,
                        'info': response
                    };
                }
                async fetchDepositAddressSupplement(code, params = {}) {
                    // returns the address for whatever the default network is...
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin': currency['id']
                    };
                    const networks = this.safeValue(this.options, 'networks');
                    let network = this.safeStringUpper(params, 'network');
                    network = this.safeString(networks, network, network);
                    if (network !== undefined) {
                        request['networkName'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privatePostSupplementGetDepositAddress(this.extend(request, params));
                    //
                    //      {
                    //          "result":true,
                    //          "data":{
                    //              "address":"TDxtabCC8iQwaxUUrPcE4WL2jArGAfvQ5A",
                    //              "memo":null,
                    //              "coin":"usdt"
                    //              },
                    //          "error_code":0,
                    //          "ts":1648073818880
                    //     }
                    //
                    const result = this.safeValue(response, 'data');
                    const address = this.safeString(result, 'address');
                    const tag = this.safeString(result, 'memo');
                    const inverseNetworks = this.safeValue(this.options, 'inverse-networks', {});
                    const networkCode = this.safeStringUpper(inverseNetworks, network, network);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': networkCode,
                        'info': response
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const fee = this.safeString(params, 'fee');
                    params = this.omit(params, 'fee');
                    if (fee === undefined) throw new ArgumentsRequired1(this.id + ' withdraw () requires a fee argument to be supplied in params, the relevant coin network fee can be found by calling fetchFundingFees (), note: if no network param is supplied then the default network will be used, this can also be found in fetchFundingFees ()');
                    const currency = this.currency(code);
                    const request = {
                        'address': address,
                        'coin': currency['id'],
                        'amount': amount,
                        'fee': fee
                    };
                    if (tag !== undefined) request['memo'] = tag;
                    const network = this.safeStringUpper2(params, 'network', 'networkName');
                    params = this.omit(params, [
                        'network',
                        'networkName'
                    ]);
                    const networks = this.safeValue(this.options, 'networks');
                    const networkId = this.safeString(networks, network, network);
                    if (networkId !== undefined) request['networkName'] = networkId;
                    const response = await this.privatePostSupplementWithdraw(this.extend(request, params));
                    //
                    //      {
                    //          "result":true,
                    //          "data": {
                    //              "fee":10.00000000000000000000,
                    //              "withdrawId":1900376
                    //              },
                    //          "error_code":0,
                    //          "ts":1648992501414
                    //      }
                    //
                    const result = this.safeValue(response, 'data', {});
                    return {
                        'info': result,
                        'id': this.safeString(result, 'withdrawId')
                    };
                }
                parseDepositStatus(status) {
                    const statuses = {
                        '1': 'pending',
                        '2': 'ok',
                        '3': 'failed',
                        '4': 'cancelled',
                        '5': 'transfer'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseWithdrawalStatus(status) {
                    const statuses = {
                        '1': 'pending',
                        '2': 'cancelled',
                        '3': 'failed',
                        '4': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits (private)
                    //
                    //      {
                    //          "insertTime":1649012310000,
                    //          "amount":9.00000000000000000000,
                    //          "address":"TYASr5UV6HEcXatwdFQfmLVUqQQQMUxHLS",
                    //          "networkName":"trc20",
                    //          "txId":"081e4e9351dd0274922168da5f2d14ea6c495b1c3b440244f4a6dd9fe196bf2b",
                    //          "coin":"usdt",
                    //          "status":"2"
                    //      }
                    //
                    //
                    // fetchWithdrawals (private)
                    //
                    //      {
                    //          "amount":2.00000000000000000000,
                    //          "address":"TBjrW5JHDyPZjFc5nrRMhRWUDaJmhGhmD6",
                    //          "fee":1.00000000000000000000,
                    //          "networkName":"trc20",
                    //          "coid":"usdt",
                    //          "transferType":"数字资产提现",
                    //          "txId":"47eeee2763ad49b8817524dacfa7d092fb58f8b0ab7e5d25473314df1a793c3d",
                    //          "id":1902194,
                    //          "applyTime":1649014002000,
                    //          "status":"4"
                    //      }
                    //
                    const id = this.safeString(transaction, 'id');
                    let type = undefined;
                    if (id === undefined) type = 'deposit';
                    else type = 'withdrawal';
                    const txid = this.safeString(transaction, 'txId');
                    const timestamp = this.safeString2(transaction, 'insertTime', 'applyTime');
                    const networks = this.safeValue(this.options, 'inverse-networks', {});
                    const networkId = this.safeString(transaction, 'networkName');
                    const network = this.safeString(networks, networkId, networkId);
                    const address = this.safeString(transaction, 'address');
                    let addressFrom = undefined;
                    let addressTo = undefined;
                    if (type === 'deposit') addressFrom = address;
                    else addressTo = address;
                    const amount = this.safeNumber(transaction, 'amount');
                    const currencyId = this.safeString2(transaction, 'coin', 'coid');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const statusId = this.safeString(transaction, 'status');
                    let status = undefined;
                    if (type === 'deposit') status = this.parseDepositStatus(statusId);
                    else status = this.parseWithdrawalStatus(statusId);
                    let fee = undefined;
                    const feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'address': address,
                        'addressTo': addressTo,
                        'addressFrom': addressFrom,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'comment': undefined,
                        'internal': status === 'transfer',
                        'fee': fee
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    if (code !== undefined) {
                        const currency = this.currency(code);
                        request['coin'] = currency['id'];
                    }
                    if (since !== undefined) request['startTime'] = since;
                    const response = await this.privatePostSupplementDepositHistory(this.extend(request, params));
                    //
                    //      {
                    //          "result":true,
                    //          "data": {
                    //              "total":1,
                    //              "depositOrders": [
                    //                  {
                    //                      "insertTime":1649012310000,
                    //                      "amount":9.00000000000000000000,
                    //                      "address":"TYASr5UV6HEcXatwdFQfmLVUqQQQMUxHLS",
                    //                      "networkName":"trc20",
                    //                      "txId":"081e4e9351dd0274922168da5f2d14ea6c495b1c3b440244f4a6dd9fe196bf2b",
                    //                      "coin":"usdt",
                    //                      "status":"2"
                    //                  },
                    //              ],
                    //              "page_length":20,
                    //              "current_page":1
                    //          },
                    //          "error_code":0,
                    //          "ts":1649719721758
                    //      }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const deposits = this.safeValue(data, 'depositOrders', []);
                    return this.parseTransactions(deposits, code, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    if (code !== undefined) {
                        const currency = this.currency(code);
                        request['coin'] = currency['id'];
                    }
                    if (since !== undefined) request['startTime'] = since;
                    const response = await this.privatePostSupplementWithdraws(this.extend(request, params));
                    //
                    //      {
                    //          "result":true,
                    //          "data": {
                    //              "total":1,
                    //              "withdraws": [
                    //                  {
                    //                      "amount":2.00000000000000000000,
                    //                      "address":"TBjrW5JHDyPZjFc5nrRMhRWUDaJmhGhmD6",
                    //                      "fee":1.00000000000000000000,
                    //                      "networkName":"trc20",
                    //                      "coid":"usdt",
                    //                      "transferType":"数字资产提现",
                    //                      "txId":"47eeee2763ad49b8817524dacfa7d092fb58f8b0ab7e5d25473314df1a793c3d",
                    //                      "id":1902194,
                    //                      "applyTime":1649014002000,
                    //                      "status":"4"
                    //                  },
                    //              ],
                    //              "page_length":20,
                    //              "current_page":1
                    //          },
                    //          "error_code":0,
                    //          "ts":1649720362362
                    //      }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const withdraws = this.safeValue(data, 'withdraws', []);
                    return this.parseTransactions(withdraws, code, since, limit);
                }
                async fetchFundingFees(params = {}) {
                    // private only returns information for currencies with non-zero balance
                    await this.loadMarkets();
                    const isAuthorized = this.checkRequiredCredentials(false);
                    let result = undefined;
                    if (isAuthorized === true) {
                        let method = this.safeString(params, 'method');
                        params = this.omit(params, 'method');
                        if (method === undefined) {
                            const options = this.safeValue(this.options, 'fetchFundingFees', {});
                            method = this.safeString(options, 'method', 'fetchPrivateFundingFees');
                        }
                        result = await this[method](params);
                    } else result = await this.fetchPublicFundingFees(params);
                    return result;
                }
                async fetchPrivateFundingFees(params = {}) {
                    // complete response
                    // incl. for coins which undefined in public method
                    await this.loadMarkets();
                    const response = await this.privatePostSupplementUserInfo();
                    const result = this.safeValue(response, 'data', []);
                    const withdrawFees = {};
                    for(let i = 0; i < result.length; i++){
                        const entry = result[i];
                        const currencyId = this.safeString(entry, 'coin');
                        const code = this.safeCurrencyCode(currencyId);
                        const networkList = this.safeValue(entry, 'networkList', []);
                        withdrawFees[code] = {};
                        for(let j = 0; j < networkList.length; j++){
                            const networkEntry = networkList[j];
                            const networkId = this.safeString(networkEntry, 'name');
                            const networkCode = this.safeString(this.options['inverse-networks'], networkId, networkId);
                            const fee = this.safeNumber(networkEntry, 'withdrawFee');
                            if (fee !== undefined) withdrawFees[code][networkCode] = fee;
                        }
                    }
                    return {
                        'withdraw': withdrawFees,
                        'deposit': {},
                        'info': response
                    };
                }
                async fetchPublicFundingFees(params = {}) {
                    // extremely incomplete response
                    // vast majority fees undefined
                    await this.loadMarkets();
                    const code = this.safeString2(params, 'coin', 'assetCode');
                    params = this.omit(params, [
                        'coin',
                        'assetCode'
                    ]);
                    const request = {};
                    if (code !== undefined) {
                        const currency = this.currency(code);
                        request['assetCode'] = currency['id'];
                    }
                    const response = await this.publicGetWithdrawConfigs(this.extend(request, params));
                    const result = this.safeValue(response, 'data', []);
                    const withdrawFees = {};
                    for(let i = 0; i < result.length; i++){
                        const item = result[i];
                        const canWithdraw = this.safeString(item, 'canWithDraw');
                        if (canWithdraw === 'true') {
                            const currencyId = this.safeString(item, 'assetCode');
                            const code = this.safeCurrencyCode(currencyId);
                            const chain = this.safeString(item, 'chain');
                            let network = this.safeString(this.options['inverse-networks'], chain, chain);
                            if (network === undefined) network = code;
                            const fee = this.safeString(item, 'fee');
                            if (withdrawFees[code] === undefined) withdrawFees[code] = {};
                            withdrawFees[code][network] = fee;
                        }
                    }
                    return {
                        'withdraw': withdrawFees,
                        'deposit': {},
                        'info': response
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let query = this.omit(params, this.extractParams(path));
                    let url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
                    // Every endpoint ends with ".do"
                    url += '.do';
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(this.keysort(query));
                    } else {
                        this.checkRequiredCredentials();
                        const timestamp = this.milliseconds().toString();
                        const echostr = this.uuid22() + this.uuid16();
                        query = this.extend({
                            'api_key': this.apiKey
                        }, query);
                        let signatureMethod = undefined;
                        if (this.secret.length > 32) signatureMethod = 'RSA';
                        else signatureMethod = 'HmacSHA256';
                        const auth = this.rawencode(this.keysort(this.extend({
                            'echostr': echostr,
                            'signature_method': signatureMethod,
                            'timestamp': timestamp
                        }, query)));
                        const encoded = this.encode(auth);
                        const hash = this.hash(encoded);
                        const uppercaseHash = hash.toUpperCase();
                        let sign = undefined;
                        if (signatureMethod === 'RSA') {
                            const cacheSecretAsPem = this.safeValue(this.options, 'cacheSecretAsPem', true);
                            let pem = undefined;
                            if (cacheSecretAsPem) {
                                pem = this.safeValue(this.options, 'pem');
                                if (pem === undefined) {
                                    pem = this.convertSecretToPem(this.encode(this.secret));
                                    this.options['pem'] = pem;
                                }
                            } else pem = this.convertSecretToPem(this.encode(this.secret));
                            sign = this.binaryToBase64(this.rsa(this.encode(uppercaseHash), this.encode(pem), 'RS256'));
                        } else if (signatureMethod === 'HmacSHA256') sign = this.hmac(this.encode(uppercaseHash), this.encode(this.secret));
                        query['sign'] = sign;
                        body = this.urlencode(this.keysort(query));
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'timestamp': timestamp,
                            'signature_method': signatureMethod,
                            'echostr': echostr
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                convertSecretToPem(secret) {
                    const lineLength = 64;
                    const secretLength = secret.length - 0;
                    let numLines = parseInt(secretLength / lineLength);
                    numLines = this.sum(numLines, 1);
                    let pem = "-----BEGIN PRIVATE KEY-----\n"; // eslint-disable-line
                    for(let i = 0; i < numLines; i++){
                        const start = i * lineLength;
                        const end = this.sum(start, lineLength);
                        pem += this.secret.slice(start, end) + "\n"; // eslint-disable-line
                    }
                    return pem + '-----END PRIVATE KEY-----';
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    const success = this.safeString(response, 'result');
                    if (success === 'false') {
                        const errorCode = this.safeString(response, 'error_code');
                        const message = this.safeString({
                            '10000': 'Internal error',
                            '10001': 'The required parameters can not be empty',
                            '10002': 'Validation failed',
                            '10003': 'Invalid parameter',
                            '10004': 'Request too frequent',
                            '10005': 'Secret key does not exist',
                            '10006': 'User does not exist',
                            '10007': 'Invalid signature',
                            '10008': 'Invalid Trading Pair',
                            '10009': 'Price and/or Amount are required for limit order',
                            '10010': 'Price and/or Amount must be less than minimum requirement',
                            // '10011': 'Market orders can not be missing the amount of the order',
                            // '10012': 'market sell orders can not be missing orders',
                            '10013': 'The amount is too small',
                            '10014': 'Insufficient amount of money in the account',
                            '10015': 'Invalid order type',
                            '10016': 'Insufficient account balance',
                            '10017': 'Server Error',
                            '10018': 'Page size should be between 1 and 50',
                            '10019': 'Cancel NO more than 3 orders in one request',
                            '10020': 'Volume < 0.001',
                            '10021': 'Price < 0.01',
                            '10022': 'Invalid authorization',
                            '10023': 'Market Order is not supported yet',
                            '10024': 'User cannot trade on this pair',
                            '10025': 'Order has been filled',
                            '10026': 'Order has been cancelld',
                            '10027': 'Order is cancelling',
                            '10028': 'Wrong query time',
                            '10029': 'from is not in the query time',
                            '10030': 'from do not match the transaction type of inqury',
                            '10031': 'echostr length must be valid and length must be from 30 to 40',
                            '10033': 'Failed to create order',
                            '10036': 'customID duplicated',
                            '10100': 'Has no privilege to withdraw',
                            '10101': 'Invalid fee rate to withdraw',
                            '10102': 'Too little to withdraw',
                            '10103': 'Exceed daily limitation of withdraw',
                            '10104': 'Cancel was rejected',
                            '10105': 'Request has been cancelled',
                            '10106': 'None trade time',
                            '10107': 'Start price exception',
                            '10108': 'can not create order',
                            '10109': 'wallet address is not mapping',
                            '10110': 'transfer fee is not mapping',
                            '10111': 'mount > 0',
                            '10112': 'fee is too lower',
                            '10113': 'transfer fee is 0',
                            '10600': 'intercepted by replay attacks filter, check timestamp',
                            '10601': 'Interface closed unavailable',
                            '10701': 'invalid asset code',
                            '10702': 'not allowed deposit'
                        }, errorCode, this.json(response));
                        const ErrorClass = this.safeValue({
                            '10001': BadRequest,
                            '10002': AuthenticationError,
                            '10003': BadRequest,
                            '10004': RateLimitExceeded,
                            '10005': AuthenticationError,
                            '10006': AuthenticationError,
                            '10007': AuthenticationError,
                            '10008': BadSymbol,
                            '10009': InvalidOrder,
                            '10010': InvalidOrder,
                            '10013': InvalidOrder,
                            '10014': InsufficientFunds,
                            '10015': InvalidOrder,
                            '10016': InsufficientFunds,
                            '10017': ExchangeError1,
                            '10018': BadRequest,
                            '10019': BadRequest,
                            '10020': BadRequest,
                            '10021': InvalidOrder,
                            '10022': PermissionDenied,
                            '10023': InvalidOrder,
                            '10024': PermissionDenied,
                            '10025': InvalidOrder,
                            '10026': InvalidOrder,
                            '10027': InvalidOrder,
                            '10028': BadRequest,
                            '10029': BadRequest,
                            '10030': BadRequest,
                            '10031': InvalidNonce,
                            '10033': ExchangeError1,
                            '10036': DuplicateOrderId,
                            '10100': PermissionDenied,
                            '10101': BadRequest,
                            '10102': InsufficientFunds,
                            '10103': ExchangeError1,
                            '10104': ExchangeError1,
                            '10105': ExchangeError1,
                            '10106': BadRequest,
                            '10107': BadRequest,
                            '10108': ExchangeError1,
                            '10109': InvalidAddress,
                            '10110': ExchangeError1,
                            '10111': BadRequest,
                            '10112': BadRequest,
                            '10113': BadRequest,
                            '10600': BadRequest,
                            '10601': ExchangeError1,
                            '10701': BadSymbol,
                            '10702': PermissionDenied
                        }, errorCode, ExchangeError1);
                        throw new ErrorClass(message);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    102: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, InvalidNonce: InvalidNonce, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, AuthenticationError: AuthenticationError, DDoSProtection: DDoSProtection, NotSupported: NotSupported, BadSymbol: BadSymbol } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class liquid extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'liquid',
                        'name': 'Liquid',
                        'countries': [
                            'JP',
                            'CN',
                            'TW'
                        ],
                        'version': '2',
                        'rateLimit': 1000,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': false,
                            'option': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': true,
                            'fetchWithdrawals': true,
                            'transfer': false,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/45798859-1a872600-bcb4-11e8-8746-69291ce87b04.jpg',
                            'api': 'https://api.liquid.com',
                            'www': 'https://www.liquid.com',
                            'doc': [
                                'https://developers.liquid.com'
                            ],
                            'fees': 'https://help.liquid.com/getting-started-with-liquid/the-platform/fee-structure',
                            'referral': 'https://www.liquid.com/sign-up/?affiliate=SbzC62lt30976'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'currencies',
                                    'products',
                                    'products/{id}',
                                    'products/{id}/price_levels',
                                    'executions',
                                    'ir_ladders/{currency}',
                                    'fees'
                                ]
                            },
                            'private': {
                                'get': [
                                    'accounts',
                                    'accounts/balance',
                                    'accounts/main_asset',
                                    'accounts/{id}',
                                    'accounts/{currency}/reserved_balance_details',
                                    'crypto_accounts',
                                    'crypto_withdrawal',
                                    'crypto_withdrawals',
                                    'crypto_withdrawals/crypto_networks',
                                    'executions/me',
                                    'fiat_accounts',
                                    'fund_infos',
                                    'loan_bids',
                                    'loans',
                                    'orders',
                                    'orders/{id}',
                                    'orders/{id}/trades',
                                    'trades',
                                    'trades/{id}/loans',
                                    'trading_accounts',
                                    'trading_accounts/{id}',
                                    'transactions',
                                    'withdrawals',
                                    'user/fee_tier',
                                    'user/fees',
                                    'trading_accounts/{id}',
                                    'bank_accounts',
                                    'accounts/{currency}/reserved_balance_details'
                                ],
                                'post': [
                                    'crypto_withdrawals',
                                    'fund_infos',
                                    'fiat_accounts',
                                    'loan_bids',
                                    'orders',
                                    'withdrawals',
                                    'fees/estimate'
                                ],
                                'put': [
                                    'crypto_withdrawal/{id}/cancel',
                                    'loan_bids/{id}/close',
                                    'loans/{id}',
                                    'orders/{id}',
                                    'orders/{id}/cancel',
                                    'trades/{id}',
                                    'trades/{id}/adjust_margin',
                                    'trades/{id}/close',
                                    'trades/close_all',
                                    'trading_accounts/{id}',
                                    'withdrawals/{id}/cancel'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': 0.0030,
                                'maker': 0.0000,
                                'tiers': {
                                    'perpetual': {
                                        'maker': [
                                            [
                                                0,
                                                0.0000
                                            ],
                                            [
                                                25000,
                                                0.0000
                                            ],
                                            [
                                                50000,
                                                -0.00025
                                            ],
                                            [
                                                100000,
                                                -0.00025
                                            ],
                                            [
                                                1000000,
                                                -0.00025
                                            ],
                                            [
                                                10000000,
                                                -0.00025
                                            ],
                                            [
                                                25000000,
                                                -0.00025
                                            ],
                                            [
                                                50000000,
                                                -0.00025
                                            ],
                                            [
                                                75000000,
                                                -0.00025
                                            ],
                                            [
                                                100000000,
                                                -0.00025
                                            ],
                                            [
                                                200000000,
                                                -0.00025
                                            ],
                                            [
                                                300000000,
                                                -0.00025
                                            ]
                                        ],
                                        'taker': [
                                            [
                                                0,
                                                0.00120
                                            ],
                                            [
                                                25000,
                                                0.00115
                                            ],
                                            [
                                                50000,
                                                0.00110
                                            ],
                                            [
                                                100000,
                                                0.00105
                                            ],
                                            [
                                                1000000,
                                                0.00100
                                            ],
                                            [
                                                10000000,
                                                0.00095
                                            ],
                                            [
                                                25000000,
                                                0.00090
                                            ],
                                            [
                                                50000000,
                                                0.00085
                                            ],
                                            [
                                                75000000,
                                                0.00080
                                            ],
                                            [
                                                100000000,
                                                0.00075
                                            ],
                                            [
                                                200000000,
                                                0.00070
                                            ],
                                            [
                                                300000000,
                                                0.00065
                                            ]
                                        ]
                                    },
                                    'spot': {
                                        'taker': [
                                            [
                                                0,
                                                0.003
                                            ],
                                            [
                                                10000,
                                                0.0029
                                            ],
                                            [
                                                20000,
                                                0.0028
                                            ],
                                            [
                                                50000,
                                                0.0026
                                            ],
                                            [
                                                100000,
                                                0.0020
                                            ],
                                            [
                                                1000000,
                                                0.0016
                                            ],
                                            [
                                                5000000,
                                                0.0012
                                            ],
                                            [
                                                10000000,
                                                0.0010
                                            ],
                                            [
                                                25000000,
                                                0.0009
                                            ],
                                            [
                                                50000000,
                                                0.0008
                                            ],
                                            [
                                                100000000,
                                                0.0007
                                            ],
                                            [
                                                200000000,
                                                0.0006
                                            ],
                                            [
                                                500000000,
                                                0.0004
                                            ],
                                            [
                                                1000000000,
                                                0.0003
                                            ]
                                        ],
                                        'maker': [
                                            [
                                                0,
                                                0.0000
                                            ],
                                            [
                                                10000,
                                                0.0020
                                            ],
                                            [
                                                20000,
                                                0.0019
                                            ],
                                            [
                                                50000,
                                                0.0018
                                            ],
                                            [
                                                100000,
                                                0.0016
                                            ],
                                            [
                                                1000000,
                                                0.0008
                                            ],
                                            [
                                                5000000,
                                                0.0007
                                            ],
                                            [
                                                10000000,
                                                0.0005
                                            ],
                                            [
                                                25000000,
                                                0.0000
                                            ],
                                            [
                                                50000000,
                                                0.0000
                                            ],
                                            [
                                                100000000,
                                                0.0000
                                            ],
                                            [
                                                200000000,
                                                0.0000
                                            ],
                                            [
                                                500000000,
                                                0.0000
                                            ],
                                            [
                                                1000000000,
                                                0.0000
                                            ]
                                        ]
                                    }
                                }
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'exceptions': {
                            'API rate limit exceeded. Please retry after 300s': DDoSProtection,
                            'API Authentication failed': AuthenticationError,
                            'Nonce is too small': InvalidNonce,
                            'Order not found': OrderNotFound,
                            'Can not update partially filled order': InvalidOrder,
                            'Can not update non-live order': OrderNotFound,
                            'not_enough_free_balance': InsufficientFunds,
                            'must_be_positive': InvalidOrder,
                            'less_than_order_size': InvalidOrder,
                            'price_too_high': InvalidOrder,
                            'price_too_small': InvalidOrder,
                            'product_disabled': BadSymbol
                        },
                        'commonCurrencies': {
                            'BIFI': 'BIFIF',
                            'HOT': 'HOT Token',
                            'MIOTA': 'IOTA',
                            'P-BTC': 'BTC',
                            'TON': 'Tokamak Network'
                        },
                        'options': {
                            'cancelOrderException': true,
                            'networks': {
                                'ETH': 'ERC20',
                                'TRX': 'TRC20',
                                'XLM': 'Stellar',
                                'ALGO': 'Algorand'
                            },
                            'swap': {
                                'fetchMarkets': {
                                    'settlementCurrencies': [
                                        'BTC',
                                        'ETH',
                                        'XRP',
                                        'QASH',
                                        'USD',
                                        'JPY',
                                        'EUR',
                                        'SGD',
                                        'AUD'
                                    ]
                                }
                            }
                        }
                    });
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     [
                    //         {
                    //             currency_type: 'fiat',
                    //             currency: 'USD',
                    //             symbol: '$',
                    //             assets_precision: 2,
                    //             quoting_precision: 5,
                    //             minimum_withdrawal: '15.0',
                    //             withdrawal_fee: 5,
                    //             minimum_fee: null,
                    //             minimum_order_quantity: null,
                    //             display_precision: 2,
                    //             depositable: true,
                    //             withdrawable: true,
                    //             discount_fee: 0.5,
                    //             credit_card_fundable: false,
                    //             lendable: false,
                    //             position_fundable: true,
                    //             has_memo: false,
                    //             stable_currency: null,
                    //             root_currency: 'USD',
                    //             minimum_loan_bid_quantity: '0.0',
                    //             maximum_order_taker_quantity: null,
                    //             name: 'United States Dollar'
                    //         },
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        const id = this.safeString(currency, 'currency');
                        const code = this.safeCurrencyCode(id);
                        const name = this.safeString(currency, 'name');
                        const depositable = this.safeValue(currency, 'depositable');
                        const withdrawable = this.safeValue(currency, 'withdrawable');
                        const active = depositable && withdrawable;
                        const amountPrecision = this.safeInteger(currency, 'assets_precision');
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'name': name,
                            'active': active,
                            'deposit': depositable,
                            'withdraw': withdrawable,
                            'fee': this.safeNumber(currency, 'withdrawal_fee'),
                            'precision': amountPrecision,
                            'limits': {
                                'amount': {
                                    'min': Math.pow(10, -amountPrecision),
                                    'max': Math.pow(10, amountPrecision)
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'minimum_withdrawal'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const spot = await this.publicGetProducts(params);
                    //
                    //     [
                    //         {
                    //             "id":"637",
                    //             "product_type":"CurrencyPair",
                    //             "code":"CASH",
                    //             "name":null,
                    //             "market_ask":"0.00000797",
                    //             "market_bid":"0.00000727",
                    //             "indicator":null,
                    //             "currency":"BTC",
                    //             "currency_pair_code":"TFTBTC",
                    //             "symbol":null,
                    //             "btc_minimum_withdraw":null,
                    //             "fiat_minimum_withdraw":null,
                    //             "pusher_channel":"product_cash_tftbtc_637",
                    //             "taker_fee":"0.0",
                    //             "maker_fee":"0.0",
                    //             "low_market_bid":"0.00000685",
                    //             "high_market_ask":"0.00000885",
                    //             "volume_24h":"3696.0755956",
                    //             "last_price_24h":"0.00000716",
                    //             "last_traded_price":"0.00000766",
                    //             "last_traded_quantity":"1748.0377978",
                    //             "average_price":null,
                    //             "quoted_currency":"BTC",
                    //             "base_currency":"TFT",
                    //             "tick_size":"0.00000001",
                    //             "disabled":false,
                    //             "margin_enabled":false,
                    //             "cfd_enabled":false,
                    //             "perpetual_enabled":false,
                    //             "last_event_timestamp":"1596962820.000797146",
                    //             "timestamp":"1596962820.000797146",
                    //             "multiplier_up":"9.0",
                    //             "multiplier_down":"0.1",
                    //             "average_time_interval":null
                    //         },
                    //     ]
                    //
                    const perpetual = await this.publicGetProducts({
                        'perpetual': '1'
                    });
                    //
                    //     [
                    //         {
                    //             "id":"604",
                    //             "product_type":"Perpetual",
                    //             "code":"CASH",
                    //             "name":null,
                    //             "market_ask":"11721.5",
                    //             "market_bid":"11719.0",
                    //             "indicator":null,
                    //             "currency":"USD",
                    //             "currency_pair_code":"P-BTCUSD",
                    //             "symbol":"$",
                    //             "btc_minimum_withdraw":null,
                    //             "fiat_minimum_withdraw":null,
                    //             "pusher_channel":"product_cash_p-btcusd_604",
                    //             "taker_fee":"0.0012",
                    //             "maker_fee":"0.0",
                    //             "low_market_bid":"11624.5",
                    //             "high_market_ask":"11859.0",
                    //             "volume_24h":"0.271",
                    //             "last_price_24h":"11621.5",
                    //             "last_traded_price":"11771.5",
                    //             "last_traded_quantity":"0.09",
                    //             "average_price":"11771.5",
                    //             "quoted_currency":"USD",
                    //             "base_currency":"P-BTC",
                    //             "tick_size":"0.5",
                    //             "disabled":false,
                    //             "margin_enabled":false,
                    //             "cfd_enabled":false,
                    //             "perpetual_enabled":true,
                    //             "last_event_timestamp":"1596963309.418853092",
                    //             "timestamp":"1596963309.418853092",
                    //             "multiplier_up":null,
                    //             "multiplier_down":"0.1",
                    //             "average_time_interval":300,
                    //             "index_price":"11682.8124",
                    //             "mark_price":"11719.96781",
                    //             "funding_rate":"0.00273",
                    //             "fair_price":"11720.2745"
                    //         },
                    //     ]
                    //
                    const currencies = await this.fetchCurrencies();
                    const currenciesByCode = this.indexBy(currencies, 'code');
                    const result = [];
                    const markets = this.arrayConcat(spot, perpetual);
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'id');
                        const baseId = this.safeString(market, 'base_currency');
                        const quoteId = this.safeString(market, 'quoted_currency');
                        const productType = this.safeString(market, 'product_type');
                        const swap = productType === 'Perpetual';
                        const type = swap ? 'swap' : 'spot';
                        const spot = !swap;
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const disabled = this.safeValue(market, 'disabled', false);
                        const baseCurrency = this.safeValue(currenciesByCode, base);
                        let minAmount = undefined;
                        if (baseCurrency !== undefined) minAmount = this.safeNumber(baseCurrency['info'], 'minimum_order_quantity');
                        const lastPrice = this.safeNumber(market, 'last_traded_price');
                        let minPrice = undefined;
                        let maxPrice = undefined;
                        if (lastPrice) {
                            const multiplierDown = this.safeNumber(market, 'multiplier_down');
                            const multiplierUp = this.safeNumber(market, 'multiplier_up');
                            if (multiplierDown !== undefined) minPrice = lastPrice * multiplierDown;
                            if (multiplierUp !== undefined) maxPrice = lastPrice * multiplierUp;
                        }
                        const margin = this.safeValue(market, 'margin_enabled');
                        const symbol = base + '/' + quote;
                        const maker = this.fees['trading']['maker'];
                        const taker = this.fees['trading']['taker'];
                        const parsedMarket = {
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': type,
                            'spot': spot,
                            'margin': spot && margin,
                            'swap': swap,
                            'future': false,
                            'option': false,
                            'active': !disabled,
                            'contract': swap,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': taker,
                            'maker': maker,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.parseNumber('0.00000001'),
                                'price': this.safeNumber(market, 'tick_size')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': minAmount,
                                    'max': undefined
                                },
                                'price': {
                                    'min': minPrice,
                                    'max': maxPrice
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        };
                        if (swap) {
                            const settlementCurrencies = this.options['fetchMarkets']['settlementCurrencies'];
                            for(let i = 0; i < settlementCurrencies.length; i++){
                                const settle = settlementCurrencies[i];
                                parsedMarket['settle'] = settle;
                                parsedMarket['symbol'] = symbol + ':' + settle;
                                parsedMarket['linear'] = quote === settle;
                                parsedMarket['inverse'] = base === settle;
                                parsedMarket['taker'] = this.safeNumber(market, 'taker_fee', taker);
                                parsedMarket['maker'] = this.safeNumber(market, 'maker_fee', maker);
                                parsedMarket['contractSize'] = this.parseNumber('1');
                                result.push(parsedMarket);
                            }
                        } else result.push(parsedMarket);
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const crypto = this.safeValue(response, 'crypto_accounts', []);
                    const fiat = this.safeValue(response, 'fiat_accounts', []);
                    for(let i = 0; i < crypto.length; i++){
                        const balance = crypto[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'balance');
                        account['used'] = this.safeString(balance, 'reserved_balance');
                        result[code] = account;
                    }
                    for(let i = 0; i < fiat.length; i++){
                        const balance = fiat[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'balance');
                        account['used'] = this.safeString(balance, 'reserved_balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccounts(params);
                    //
                    //     {
                    //         crypto_accounts: [
                    //             {
                    //                 id: 2221179,
                    //                 currency: 'USDT',
                    //                 balance: '0.0',
                    //                 reserved_balance: '0.0',
                    //                 pusher_channel: 'user_xxxxx_account_usdt',
                    //                 lowest_offer_interest_rate: null,
                    //                 highest_offer_interest_rate: null,
                    //                 address: '0',
                    //                 currency_symbol: 'USDT',
                    //                 minimum_withdraw: null,
                    //                 currency_type: 'crypto'
                    //             },
                    //         ],
                    //         fiat_accounts: [
                    //             {
                    //                 id: 1112734,
                    //                 currency: 'USD',
                    //                 balance: '0.0',
                    //                 reserved_balance: '0.0',
                    //                 pusher_channel: 'user_xxxxx_account_usd',
                    //                 lowest_offer_interest_rate: null,
                    //                 highest_offer_interest_rate: null,
                    //                 currency_symbol: '$',
                    //                 send_to_btc_address: null,
                    //                 exchange_rate: '1.0',
                    //                 currency_type: 'fiat'
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': this.marketId(symbol)
                    };
                    const response = await this.publicGetProductsIdPriceLevels(this.extend(request, params));
                    return this.parseOrderBook(response, symbol, undefined, 'buy_price_levels', 'sell_price_levels');
                }
                parseTicker(ticker, market) {
                    const timestamp = this.milliseconds();
                    let last = undefined;
                    if ('last_traded_price' in ticker) {
                        if (ticker['last_traded_price']) {
                            const length = ticker['last_traded_price'].length;
                            if (length > 0) last = this.safeString(ticker, 'last_traded_price');
                        }
                    }
                    const marketId = this.safeString(ticker, 'id');
                    market = this.safeMarket(marketId, market);
                    let symbol = market['symbol'];
                    const baseId = this.safeString(ticker, 'base_currency');
                    const quoteId = this.safeString(ticker, 'quoted_currency');
                    if (baseId !== undefined && quoteId !== undefined) symbol = this.safeCurrencyCode(baseId) + '/' + this.safeCurrencyCode(quoteId);
                    const open = this.safeString(ticker, 'last_price_24h');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high_market_ask'),
                        'low': this.safeString(ticker, 'low_market_bid'),
                        'bid': this.safeString(ticker, 'market_bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'market_ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume_24h'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetProducts(params);
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const ticker = this.parseTicker(response[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': market['id']
                    };
                    const response = await this.publicGetProductsId(this.extend(request, params));
                    return this.parseTicker(response, market);
                }
                parseTrade(trade, market) {
                    // {             id:  12345,
                    //         quantity: "6.789",
                    //            price: "98765.4321",
                    //       taker_side: "sell",
                    //       created_at:  1512345678,
                    //          my_side: "buy"           }
                    const timestamp = this.safeTimestamp(trade, 'created_at');
                    const orderId = this.safeString(trade, 'order_id');
                    // 'taker_side' gets filled for both fetchTrades and fetchMyTrades
                    const takerSide = this.safeString(trade, 'taker_side');
                    // 'my_side' gets filled for fetchMyTrades only and may differ from 'taker_side'
                    const mySide = this.safeString(trade, 'my_side');
                    const side = mySide !== undefined ? mySide : takerSide;
                    let takerOrMaker = undefined;
                    if (mySide !== undefined) takerOrMaker = takerSide === mySide ? 'taker' : 'maker';
                    const price = this.safeString(trade, 'price');
                    const amount = this.safeString(trade, 'quantity');
                    const id = this.safeString(trade, 'id');
                    market = this.safeMarket(undefined, market);
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'product_id': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) // timestamp should be in seconds, whereas we use milliseconds in since and everywhere
                    request['timestamp'] = parseInt(since / 1000);
                    const response = await this.publicGetExecutions(this.extend(request, params));
                    const result = since !== undefined ? response : response['models'];
                    return this.parseTrades(result, market, since, limit);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': market['id']
                    };
                    const response = await this.publicGetProductsId(this.extend(request, params));
                    //
                    //     {
                    //         "id":"637",
                    //         "product_type":"CurrencyPair",
                    //         "code":"CASH",
                    //         "name":null,
                    //         "market_ask":"0.00000797",
                    //         "market_bid":"0.00000727",
                    //         "indicator":null,
                    //         "currency":"BTC",
                    //         "currency_pair_code":"TFTBTC",
                    //         "symbol":null,
                    //         "btc_minimum_withdraw":null,
                    //         "fiat_minimum_withdraw":null,
                    //         "pusher_channel":"product_cash_tftbtc_637",
                    //         "taker_fee":"0.0",
                    //         "maker_fee":"0.0",
                    //         "low_market_bid":"0.00000685",
                    //         "high_market_ask":"0.00000885",
                    //         "volume_24h":"3696.0755956",
                    //         "last_price_24h":"0.00000716",
                    //         "last_traded_price":"0.00000766",
                    //         "last_traded_quantity":"1748.0377978",
                    //         "average_price":null,
                    //         "quoted_currency":"BTC",
                    //         "base_currency":"TFT",
                    //         "tick_size":"0.00000001",
                    //         "disabled":false,
                    //         "margin_enabled":false,
                    //         "cfd_enabled":false,
                    //         "perpetual_enabled":false,
                    //         "last_event_timestamp":"1596962820.000797146",
                    //         "timestamp":"1596962820.000797146",
                    //         "multiplier_up":"9.0",
                    //         "multiplier_down":"0.1",
                    //         "average_time_interval":null
                    //     }
                    //
                    return this.parseTradingFee(response, market);
                }
                parseTradingFee(fee, market) {
                    const marketId = this.safeString(fee, 'id');
                    const symbol = this.safeSymbol(marketId, market);
                    return {
                        'info': fee,
                        'symbol': symbol,
                        'maker': this.safeNumber(fee, 'maker_fee'),
                        'taker': this.safeNumber(fee, 'taker_fee'),
                        'percentage': true,
                        'tierBased': true
                    };
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const spot = await this.publicGetProducts(params);
                    //
                    //     [
                    //         {
                    //             "id":"637",
                    //             "product_type":"CurrencyPair",
                    //             "code":"CASH",
                    //             "name":null,
                    //             "market_ask":"0.00000797",
                    //             "market_bid":"0.00000727",
                    //             "indicator":null,
                    //             "currency":"BTC",
                    //             "currency_pair_code":"TFTBTC",
                    //             "symbol":null,
                    //             "btc_minimum_withdraw":null,
                    //             "fiat_minimum_withdraw":null,
                    //             "pusher_channel":"product_cash_tftbtc_637",
                    //             "taker_fee":"0.0",
                    //             "maker_fee":"0.0",
                    //             "low_market_bid":"0.00000685",
                    //             "high_market_ask":"0.00000885",
                    //             "volume_24h":"3696.0755956",
                    //             "last_price_24h":"0.00000716",
                    //             "last_traded_price":"0.00000766",
                    //             "last_traded_quantity":"1748.0377978",
                    //             "average_price":null,
                    //             "quoted_currency":"BTC",
                    //             "base_currency":"TFT",
                    //             "tick_size":"0.00000001",
                    //             "disabled":false,
                    //             "margin_enabled":false,
                    //             "cfd_enabled":false,
                    //             "perpetual_enabled":false,
                    //             "last_event_timestamp":"1596962820.000797146",
                    //             "timestamp":"1596962820.000797146",
                    //             "multiplier_up":"9.0",
                    //             "multiplier_down":"0.1",
                    //             "average_time_interval":null
                    //         },
                    //     ]
                    //
                    const perpetual = await this.publicGetProducts({
                        'perpetual': '1'
                    });
                    //
                    //     [
                    //         {
                    //             "id":"604",
                    //             "product_type":"Perpetual",
                    //             "code":"CASH",
                    //             "name":null,
                    //             "market_ask":"11721.5",
                    //             "market_bid":"11719.0",
                    //             "indicator":null,
                    //             "currency":"USD",
                    //             "currency_pair_code":"P-BTCUSD",
                    //             "symbol":"$",
                    //             "btc_minimum_withdraw":null,
                    //             "fiat_minimum_withdraw":null,
                    //             "pusher_channel":"product_cash_p-btcusd_604",
                    //             "taker_fee":"0.0012",
                    //             "maker_fee":"0.0",
                    //             "low_market_bid":"11624.5",
                    //             "high_market_ask":"11859.0",
                    //             "volume_24h":"0.271",
                    //             "last_price_24h":"11621.5",
                    //             "last_traded_price":"11771.5",
                    //             "last_traded_quantity":"0.09",
                    //             "average_price":"11771.5",
                    //             "quoted_currency":"USD",
                    //             "base_currency":"P-BTC",
                    //             "tick_size":"0.5",
                    //             "disabled":false,
                    //             "margin_enabled":false,
                    //             "cfd_enabled":false,
                    //             "perpetual_enabled":true,
                    //             "last_event_timestamp":"1596963309.418853092",
                    //             "timestamp":"1596963309.418853092",
                    //             "multiplier_up":null,
                    //             "multiplier_down":"0.1",
                    //             "average_time_interval":300,
                    //             "index_price":"11682.8124",
                    //             "mark_price":"11719.96781",
                    //             "funding_rate":"0.00273",
                    //             "fair_price":"11720.2745"
                    //         },
                    //     ]
                    //
                    const markets = this.arrayConcat(spot, perpetual);
                    const result = {};
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const marketId = this.safeString(market, 'id');
                        const symbol = this.safeSymbol(marketId, market);
                        result[symbol] = this.parseTradingFee(market);
                    }
                    return result;
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    // the `with_details` param is undocumented - it adds the order_id to the results
                    const request = {
                        'product_id': market['id'],
                        'with_details': true
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetExecutionsMe(this.extend(request, params));
                    return this.parseTrades(response['models'], market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client_order_id');
                    params = this.omit(params, [
                        'clientOrderId',
                        'client_order_id'
                    ]);
                    const request = {
                        'order_type': type,
                        'product_id': this.marketId(symbol),
                        'side': side,
                        'quantity': this.amountToPrecision(symbol, amount)
                    };
                    if (clientOrderId !== undefined) request['client_order_id'] = clientOrderId;
                    if (type === 'limit' || type === 'limit_post_only' || type === 'market_with_range' || type === 'stop') request['price'] = this.priceToPrecision(symbol, price);
                    const response = await this.privatePostOrders(this.extend(request, params));
                    //
                    //     {
                    //         "id": 2157474,
                    //         "order_type": "limit",
                    //         "quantity": "0.01",
                    //         "disc_quantity": "0.0",
                    //         "iceberg_total_quantity": "0.0",
                    //         "side": "sell",
                    //         "filled_quantity": "0.0",
                    //         "price": "500.0",
                    //         "created_at": 1462123639,
                    //         "updated_at": 1462123639,
                    //         "status": "live",
                    //         "leverage_level": 1,
                    //         "source_exchange": "QUOINE",
                    //         "product_id": 1,
                    //         "product_code": "CASH",
                    //         "funding_currency": "USD",
                    //         "currency_pair_code": "BTCUSD",
                    //         "order_fee": "0.0",
                    //         "client_order_id": null,
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privatePutOrdersIdCancel(this.extend(request, params));
                    const order = this.parseOrder(response);
                    if (order['status'] === 'closed') {
                        if (this.options['cancelOrderException']) throw new OrderNotFound(this.id + ' order closed already: ' + this.json(response));
                    }
                    return order;
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    if (price === undefined) throw new ArgumentsRequired1(this.id + ' editOrder() requires the price argument');
                    const request = {
                        'order': {
                            'quantity': this.amountToPrecision(symbol, amount),
                            'price': this.priceToPrecision(symbol, price)
                        },
                        'id': id
                    };
                    const response = await this.privatePutOrdersId(this.extend(request, params));
                    return this.parseOrder(response);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'live': 'open',
                        'filled': 'closed',
                        'cancelled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "id": 2157474,
                    //         "order_type": "limit",
                    //         "quantity": "0.01",
                    //         "disc_quantity": "0.0",
                    //         "iceberg_total_quantity": "0.0",
                    //         "side": "sell",
                    //         "filled_quantity": "0.0",
                    //         "price": "500.0",
                    //         "created_at": 1462123639,
                    //         "updated_at": 1462123639,
                    //         "status": "live",
                    //         "leverage_level": 1,
                    //         "source_exchange": "QUOINE",
                    //         "product_id": 1,
                    //         "product_code": "CASH",
                    //         "funding_currency": "USD",
                    //         "currency_pair_code": "BTCUSD",
                    //         "order_fee": "0.0"
                    //         "client_order_id": null,
                    //     }
                    //
                    // fetchOrder, fetchOrders, fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "id": 2157479,
                    //         "order_type": "limit",
                    //         "quantity": "0.01",
                    //         "disc_quantity": "0.0",
                    //         "iceberg_total_quantity": "0.0",
                    //         "side": "sell",
                    //         "filled_quantity": "0.01",
                    //         "price": "500.0",
                    //         "created_at": 1462123639,
                    //         "updated_at": 1462123639,
                    //         "status": "filled",
                    //         "leverage_level": 2,
                    //         "source_exchange": "QUOINE",
                    //         "product_id": 1,
                    //         "product_code": "CASH",
                    //         "funding_currency": "USD",
                    //         "currency_pair_code": "BTCUSD",
                    //         "order_fee": "0.0",
                    //         "executions": [
                    //             {
                    //                 "id": 4566133,
                    //                 "quantity": "0.01",
                    //                 "price": "500.0",
                    //                 "taker_side": "buy",
                    //                 "my_side": "sell",
                    //                 "created_at": 1465396785
                    //             }
                    //         ]
                    //     }
                    //
                    const orderId = this.safeString(order, 'id');
                    const timestamp = this.safeTimestamp(order, 'created_at');
                    const marketId = this.safeString(order, 'product_id');
                    market = this.safeValue(this.markets_by_id, marketId);
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const amount = this.safeNumber(order, 'quantity');
                    let filled = this.safeNumber(order, 'filled_quantity');
                    const price = this.safeNumber(order, 'price');
                    const type = this.safeString(order, 'order_type');
                    let tradeCost = 0;
                    let tradeFilled = 0;
                    let average = this.safeNumber(order, 'average_price');
                    const trades = this.parseTrades(this.safeValue(order, 'executions', []), market, undefined, undefined, {
                        'order': orderId,
                        'type': type
                    });
                    const numTrades = trades.length;
                    for(let i = 0; i < numTrades; i++){
                        // php copies values upon assignment, but not references them
                        // todo rewrite this (shortly)
                        const trade = trades[i];
                        trade['order'] = orderId;
                        trade['type'] = type;
                        tradeFilled = this.sum(tradeFilled, trade['amount']);
                        tradeCost = this.sum(tradeCost, trade['cost']);
                    }
                    let cost = undefined;
                    let lastTradeTimestamp = undefined;
                    if (numTrades > 0) {
                        lastTradeTimestamp = trades[numTrades - 1]['timestamp'];
                        if (!average && tradeFilled > 0) average = tradeCost / tradeFilled;
                        if (cost === undefined) cost = tradeCost;
                        if (filled === undefined) filled = tradeFilled;
                    }
                    let remaining = undefined;
                    if (amount !== undefined && filled !== undefined) remaining = amount - filled;
                    const side = this.safeString(order, 'side');
                    const clientOrderId = this.safeString(order, 'client_order_id');
                    return {
                        'id': orderId,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'status': status,
                        'symbol': market['symbol'],
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'filled': filled,
                        'cost': cost,
                        'remaining': remaining,
                        'average': average,
                        'trades': trades,
                        'fee': {
                            'currency': market['quote'],
                            'cost': this.safeNumber(order, 'order_fee')
                        },
                        'info': order
                    };
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetOrdersId(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        // 'funding_currency': market['quoteId'], // filter orders based on "funding" currency (quote currency)
                        // 'product_id': market['id'],
                        // 'status': 'live', // 'filled', 'cancelled'
                        // 'trading_type': 'spot', // 'margin', 'cfd'
                        'with_details': 1
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['product_id'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetOrders(this.extend(request, params));
                    //
                    //     {
                    //         "models": [
                    //             {
                    //                 "id": 2157474,
                    //                 "order_type": "limit",
                    //                 "quantity": "0.01",
                    //                 "disc_quantity": "0.0",
                    //                 "iceberg_total_quantity": "0.0",
                    //                 "side": "sell",
                    //                 "filled_quantity": "0.0",
                    //                 "price": "500.0",
                    //                 "created_at": 1462123639,
                    //                 "updated_at": 1462123639,
                    //                 "status": "live",
                    //                 "leverage_level": 1,
                    //                 "source_exchange": "QUOINE",
                    //                 "product_id": 1,
                    //                 "product_code": "CASH",
                    //                 "funding_currency": "USD",
                    //                 "currency_pair_code": "BTCUSD",
                    //                 "order_fee": "0.0",
                    //                 "executions": [], // optional
                    //             }
                    //         ],
                    //         "current_page": 1,
                    //         "total_pages": 1
                    //     }
                    //
                    const orders = this.safeValue(response, 'models', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'live'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'filled'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        // 'auth_code': '', // optional 2fa code
                        'crypto_withdrawal': {
                            'currency': currency['id'],
                            'address': address,
                            'amount': amount
                        }
                    };
                    if (tag !== undefined) {
                        if (code === 'XRP') request['crypto_withdrawal']['payment_id'] = tag;
                        else if (code === 'XLM') {
                            request['crypto_withdrawal']['memo_type'] = 'text'; // overrideable via params
                            request['crypto_withdrawal']['memo_value'] = tag;
                        } else throw new NotSupported(this.id + ' withdraw() only supports a tag along the address for XRP or XLM');
                    }
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    if (network === undefined) {
                        const paramsCwArray = this.safeValue(params, 'crypto_withdrawal', {});
                        network = this.safeStringUpper(paramsCwArray, 'network');
                    }
                    network = this.safeString(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['crypto_withdrawal']['network'] = network;
                        params = this.omit(params, 'network');
                        params['crypto_withdrawal'] = this.omit(params['crypto_withdrawal'], 'network');
                    }
                    const response = await this.privatePostCryptoWithdrawals(this.deepExtend(request, params));
                    //
                    //     {
                    //         "id": 1353,
                    //         "address": "1BvBMSEYstWetqTFn5Au4m4GFg7xJaNVN2",
                    //         "amount": 1.0,
                    //         "state": "pending",
                    //         "currency": "BTC",
                    //         "withdrawal_fee": 0.0,
                    //         "created_at": 1568016450,
                    //         "updated_at": 1568016450,
                    //         "payment_id": null
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const response = await this.privateGetCryptoWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         models: [
                    //             {
                    //                 id: '2',
                    //                 address: '1BvBMSEYstWetqTFn5Au4m4GFg7xJaNVN2',
                    //                 amount: '0.01',
                    //                 state: 'processed',
                    //                 currency: 'BTC',
                    //                 withdrawal_fee: '0.0005',
                    //                 created_at: '1614718276',
                    //                 updated_at: '1614720926',
                    //                 payment_id: null,
                    //                 transaction_hash: 'xxxxxxxx...',
                    //                 broadcasted_at: '1614720762',
                    //                 wallet_label: 'btc',
                    //                 chain_name: 'Bitcoin',
                    //                 network: null
                    //             },
                    //         ],
                    //         current_page: '1',
                    //         total_pages: '1'
                    //     }
                    //
                    const transactions = this.safeValue(response, 'models', []);
                    return this.parseTransactions(transactions, currency, since, limit);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'pending': 'pending',
                        'cancelled': 'canceled',
                        'approved': 'ok',
                        'processing': 'pending',
                        'processed': 'ok',
                        'reverted': 'failed',
                        'to_be_reviewed': 'pending',
                        'declined': 'failed',
                        'broadcasted': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         id: '1',
                    //         address: '1BvBMSEYstWetqTFn5Au4m4GFg7xJaNVN2',
                    //         amount: '0.01',
                    //         state: 'pending',
                    //         currency: 'BTC',
                    //         withdrawal_fee: '0.0007',
                    //         created_at: '1626000533',
                    //         updated_at: '1626000533',
                    //         payment_id: null,
                    //         transaction_hash: null,
                    //         broadcasted_at: null,
                    //         wallet_label: null,
                    //         chain_name: 'Bitcoin',
                    //         network: null
                    //     },
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         id: '2',
                    //         address: '1BvBMSEYstWetqTFn5Au4m4GFg7xJaNVN2',
                    //         amount: '0.01',
                    //         state: 'processed',
                    //         currency: 'BTC',
                    //         withdrawal_fee: '0.0005',
                    //         created_at: '1614718276',
                    //         updated_at: '1614720926',
                    //         payment_id: '',
                    //         transaction_hash: 'xxxxxxxx...',
                    //         broadcasted_at: '1614720762',
                    //         wallet_label: 'btc',
                    //         chain_name: 'Bitcoin',
                    //         network: null
                    //     },
                    //
                    // fetchDeposits
                    //
                    //     ...
                    //
                    const id = this.safeString(transaction, 'id');
                    const address = this.safeString(transaction, 'address');
                    const tag = this.safeString2(transaction, 'payment_id', 'memo_value');
                    const txid = this.safeString(transaction, 'transaction_hash');
                    const currencyId = this.safeString2(transaction, 'currency', 'asset');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const timestamp = this.safeTimestamp(transaction, 'created_at');
                    const updated = this.safeTimestamp(transaction, 'updated_at');
                    const type = 'withdrawal';
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    const amountString = this.safeString(transaction, 'amount');
                    const feeCostString = this.safeString(transaction, 'withdrawal_fee');
                    const amount = this.parseNumber(Precise.stringSub(amountString, feeCostString));
                    const network = this.safeString(transaction, 'chain_name');
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': {
                            'currency': code,
                            'cost': this.parseNumber(feeCostString)
                        }
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    headers = {
                        'X-Quoine-API-Version': this.version,
                        'Content-Type': 'application/json'
                    };
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        if (method === 'GET') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else if (Object.keys(query).length) body = this.json(query);
                        const nonce = this.nonce();
                        const request = {
                            'path': url,
                            'token_id': this.apiKey,
                            'iat': Math.floor(nonce / 1000)
                        };
                        if (!('client_order_id' in query)) request['nonce'] = nonce;
                        headers['X-Quoine-Auth'] = this.jwt(request, this.encode(this.secret));
                    } else if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    url = this.urls['api'] + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (code >= 200 && code < 300) return;
                    if (code === 401) {
                        // expected non-json response
                        this.throwExactlyMatchedException(this.exceptions, body, body);
                        return;
                    }
                    if (code === 429) throw new DDoSProtection(this.id + ' ' + body);
                    if (response === undefined) return;
                    const feedback = this.id + ' ' + body;
                    const message = this.safeString(response, 'message');
                    const errors = this.safeValue(response, 'errors');
                    if (message !== undefined) //
                    //  { "message": "Order not found" }
                    //
                    this.throwExactlyMatchedException(this.exceptions, message, feedback);
                    else if (errors !== undefined) {
                        //
                        //  { "errors": { "user": ["not_enough_free_balance"] }}
                        //  { "errors": { "quantity": ["less_than_order_size"] }}
                        //  { "errors": { "order": ["Can not update partially filled order"] }}
                        //
                        const types = Object.keys(errors);
                        for(let i = 0; i < types.length; i++){
                            const type = types[i];
                            const errorMessages = errors[type];
                            for(let j = 0; j < errorMessages.length; j++){
                                const message = errorMessages[j];
                                this.throwExactlyMatchedException(this.exceptions, message, feedback);
                            }
                        }
                    } else throw new ExchangeError1(feedback);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    103: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class luno extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'luno',
                        'name': 'luno',
                        'countries': [
                            'GB',
                            'SG',
                            'ZA'
                        ],
                        // 300 calls per minute = 5 calls per second = 1000ms / 5 = 200ms between requests
                        'rateLimit': 200,
                        'version': '1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLedger': true,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFees': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'urls': {
                            'referral': 'https://www.luno.com/invite/44893A',
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766607-8c1a69d8-5ede-11e7-930c-540b5eb9be24.jpg',
                            'api': {
                                'public': 'https://api.luno.com/api',
                                'private': 'https://api.luno.com/api',
                                'exchange': 'https://api.luno.com/api/exchange'
                            },
                            'www': 'https://www.luno.com',
                            'doc': [
                                'https://www.luno.com/en/api',
                                'https://npmjs.org/package/bitx',
                                'https://github.com/bausmeier/node-bitx'
                            ]
                        },
                        'api': {
                            'exchange': {
                                'get': {
                                    'markets': 1
                                }
                            },
                            'public': {
                                'get': {
                                    'orderbook': 1,
                                    'orderbook_top': 1,
                                    'ticker': 1,
                                    'tickers': 1,
                                    'trades': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'accounts/{id}/pending': 1,
                                    'accounts/{id}/transactions': 1,
                                    'balance': 1,
                                    'beneficiaries': 1,
                                    'fee_info': 1,
                                    'funding_address': 1,
                                    'listorders': 1,
                                    'listtrades': 1,
                                    'orders/{id}': 1,
                                    'quotes/{id}': 1,
                                    'withdrawals': 1,
                                    'withdrawals/{id}': 1,
                                    'transfers': 1
                                },
                                'post': {
                                    'accounts': 1,
                                    'accounts/{id}/name': 1,
                                    'postorder': 1,
                                    'marketorder': 1,
                                    'stoporder': 1,
                                    'funding_address': 1,
                                    'withdrawals': 1,
                                    'send': 1,
                                    'quotes': 1,
                                    'oauth2/grant': 1
                                },
                                'put': {
                                    'accounts/{id}/name': 1,
                                    'quotes/{id}': 1
                                },
                                'delete': {
                                    'quotes/{id}': 1,
                                    'withdrawals/{id}': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.001'),
                                'maker': this.parseNumber('0')
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.exchangeGetMarkets(params);
                    //
                    //     {
                    //         "markets":[
                    //             {
                    //                 "market_id":"BCHXBT",
                    //                 "trading_status":"ACTIVE",
                    //                 "base_currency":"BCH",
                    //                 "counter_currency":"XBT",
                    //                 "min_volume":"0.01",
                    //                 "max_volume":"100.00",
                    //                 "volume_scale":2,
                    //                 "min_price":"0.0001",
                    //                 "max_price":"1.00",
                    //                 "price_scale":6,
                    //                 "fee_scale":8,
                    //             },
                    //         ]
                    //     }
                    //
                    const result = [];
                    const markets = this.safeValue(response, 'markets', []);
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'market_id');
                        const baseId = this.safeString(market, 'base_currency');
                        const quoteId = this.safeString(market, 'counter_currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const status = this.safeString(market, 'trading_status');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': status === 'ACTIVE',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'volume_scale'),
                                'price': this.safeInteger(market, 'price_scale')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min_volume'),
                                    'max': this.safeNumber(market, 'max_volume')
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'min_price'),
                                    'max': this.safeNumber(market, 'max_price')
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchAccounts(params = {}) {
                    const response = await this.privateGetBalance(params);
                    const wallets = this.safeValue(response, 'balance', []);
                    const result = [];
                    for(let i = 0; i < wallets.length; i++){
                        const account = wallets[i];
                        const accountId = this.safeString(account, 'account_id');
                        const currencyId = this.safeString(account, 'asset');
                        const code = this.safeCurrencyCode(currencyId);
                        result.push({
                            'id': accountId,
                            'type': undefined,
                            'currency': code,
                            'info': account
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const wallets = this.safeValue(response, 'balance', []);
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < wallets.length; i++){
                        const wallet = wallets[i];
                        const currencyId = this.safeString(wallet, 'asset');
                        const code = this.safeCurrencyCode(currencyId);
                        const reserved = this.safeString(wallet, 'reserved');
                        const unconfirmed = this.safeString(wallet, 'unconfirmed');
                        const balance = this.safeString(wallet, 'balance');
                        const reservedUnconfirmed = Precise.stringAdd(reserved, unconfirmed);
                        const balanceUnconfirmed = Precise.stringAdd(balance, unconfirmed);
                        if (code in result) {
                            result[code]['used'] = Precise.stringAdd(result[code]['used'], reservedUnconfirmed);
                            result[code]['total'] = Precise.stringAdd(result[code]['total'], balanceUnconfirmed);
                        } else {
                            const account = this.account();
                            account['used'] = reservedUnconfirmed;
                            account['total'] = balanceUnconfirmed;
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalance(params);
                    //
                    //     {
                    //         'balance': [
                    //             {'account_id': '119...1336','asset': 'XBT','balance': '0.00','reserved': '0.00','unconfirmed': '0.00'},
                    //             {'account_id': '66...289','asset': 'XBT','balance': '0.00','reserved': '0.00','unconfirmed': '0.00'},
                    //             {'account_id': '718...5300','asset': 'ETH','balance': '0.00','reserved': '0.00','unconfirmed': '0.00'},
                    //             {'account_id': '818...7072','asset': 'ZAR','balance': '0.001417','reserved': '0.00','unconfirmed': '0.00'}]}
                    //         ]
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    let method = 'publicGetOrderbook';
                    if (limit !== undefined) {
                        if (limit <= 100) method += 'Top'; // get just the top of the orderbook when limit is low
                    }
                    const request = {
                        'pair': this.marketId(symbol)
                    };
                    const response = await this[method](this.extend(request, params));
                    const timestamp = this.safeInteger(response, 'timestamp');
                    return this.parseOrderBook(response, symbol, timestamp, 'bids', 'asks', 'price', 'volume');
                }
                parseOrderStatus(status) {
                    const statuses = {
                        // todo add other statuses
                        'PENDING': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "base": "string",
                    //         "completed_timestamp": "string",
                    //         "counter": "string",
                    //         "creation_timestamp": "string",
                    //         "expiration_timestamp": "string",
                    //         "fee_base": "string",
                    //         "fee_counter": "string",
                    //         "limit_price": "string",
                    //         "limit_volume": "string",
                    //         "order_id": "string",
                    //         "pair": "string",
                    //         "state": "PENDING",
                    //         "type": "BID"
                    //     }
                    //
                    const timestamp = this.safeInteger(order, 'creation_timestamp');
                    let status = this.parseOrderStatus(this.safeString(order, 'state'));
                    status = status === 'open' ? status : status;
                    let side = undefined;
                    const orderType = this.safeString(order, 'type');
                    if (orderType === 'ASK' || orderType === 'SELL') side = 'sell';
                    else if (orderType === 'BID' || orderType === 'BUY') side = 'buy';
                    const marketId = this.safeString(order, 'pair');
                    market = this.safeMarket(marketId, market);
                    const price = this.safeString(order, 'limit_price');
                    const amount = this.safeString(order, 'limit_volume');
                    const quoteFee = this.safeNumber(order, 'fee_counter');
                    const baseFee = this.safeNumber(order, 'fee_base');
                    const filled = this.safeString(order, 'base');
                    const cost = this.safeString(order, 'counter');
                    let fee = undefined;
                    if (quoteFee !== undefined) fee = {
                        'cost': quoteFee,
                        'currency': market['quote']
                    };
                    else if (baseFee !== undefined) fee = {
                        'cost': baseFee,
                        'currency': market['base']
                    };
                    const id = this.safeString(order, 'order_id');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': market['symbol'],
                        'type': undefined,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'filled': filled,
                        'cost': cost,
                        'remaining': undefined,
                        'trades': undefined,
                        'fee': fee,
                        'info': order,
                        'average': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetOrdersId(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async fetchOrdersByState(state, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (state !== undefined) request['state'] = state;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['pair'] = market['id'];
                    }
                    const response = await this.privateGetListorders(this.extend(request, params));
                    const orders = this.safeValue(response, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByState(undefined, symbol, since, limit, params);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByState('PENDING', symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByState('COMPLETE', symbol, since, limit, params);
                }
                parseTicker(ticker, market) {
                    // {
                    //     "pair":"XBTAUD",
                    //     "timestamp":1642201439301,
                    //     "bid":"59972.30000000",
                    //     "ask":"59997.99000000",
                    //     "last_trade":"59997.99000000",
                    //     "rolling_24_hour_volume":"1.89510000",
                    //     "status":"ACTIVE"
                    // }
                    const timestamp = this.safeInteger(ticker, 'timestamp');
                    const marketId = this.safeString(ticker, 'pair');
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeString(ticker, 'last_trade');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': undefined,
                        'low': undefined,
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'rolling_24_hour_volume'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTickers(params);
                    const tickers = this.indexBy(response['tickers'], 'pair');
                    const ids = Object.keys(tickers);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const market = this.safeMarket(id);
                        const symbol = market['symbol'];
                        const ticker = tickers[id];
                        result[symbol] = this.parseTicker(ticker, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    // {
                    //     "pair":"XBTAUD",
                    //     "timestamp":1642201439301,
                    //     "bid":"59972.30000000",
                    //     "ask":"59997.99000000",
                    //     "last_trade":"59997.99000000",
                    //     "rolling_24_hour_volume":"1.89510000",
                    //     "status":"ACTIVE"
                    // }
                    return this.parseTicker(response, market);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "sequence":276989,
                    //          "timestamp":1648651276949,
                    //          "price":"35773.20000000",
                    //          "volume":"0.00300000",
                    //          "is_buy":false
                    //      }
                    //
                    // fetchMyTrades (private)
                    //
                    //      {
                    //          "pair":"LTCXBT",
                    //          "sequence":3256813,
                    //          "order_id":"BXEX6XHHDT5EGW2",
                    //          "type":"ASK",
                    //          "timestamp":1648652135235,
                    //          "price":"0.002786",
                    //          "volume":"0.10",
                    //          "base":"0.10",
                    //          "counter":"0.0002786",
                    //          "fee_base":"0.0001",
                    //          "fee_counter":"0.00",
                    //          "is_buy":false,
                    //          "client_order_id":""
                    //      }
                    //
                    // For public trade data (is_buy === True) indicates 'buy' side but for private trade data
                    // is_buy indicates maker or taker. The value of "type" (ASK/BID) indicate sell/buy side.
                    // Private trade data includes ID field which public trade data does not.
                    const orderId = this.safeString(trade, 'order_id');
                    const id = this.safeString(trade, 'sequence');
                    let takerOrMaker = undefined;
                    let side = undefined;
                    if (orderId !== undefined) {
                        const type = this.safeString(trade, 'type');
                        if (type === 'ASK' || type === 'SELL') side = 'sell';
                        else if (type === 'BID' || type === 'BUY') side = 'buy';
                        if (side === 'sell' && trade['is_buy']) takerOrMaker = 'maker';
                        else if (side === 'buy' && !trade['is_buy']) takerOrMaker = 'maker';
                        else takerOrMaker = 'taker';
                    } else side = trade['is_buy'] ? 'buy' : 'sell';
                    const feeBaseString = this.safeString(trade, 'fee_base');
                    const feeCounterString = this.safeString(trade, 'fee_counter');
                    let feeCurrency = undefined;
                    let feeCost = undefined;
                    if (feeBaseString !== undefined) {
                        if (!Precise.stringEquals(feeBaseString, '0.0')) {
                            feeCurrency = market['base'];
                            feeCost = feeBaseString;
                        }
                    } else if (feeCounterString !== undefined) {
                        if (!Precise.stringEquals(feeCounterString, '0.0')) {
                            feeCurrency = market['quote'];
                            feeCost = feeCounterString;
                        }
                    }
                    const timestamp = this.safeInteger(trade, 'timestamp');
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': this.safeString(trade, 'price'),
                        'amount': this.safeString(trade, 'volume'),
                        // Does not include potential fee costs
                        'cost': this.safeString(trade, 'counter'),
                        'fee': {
                            'cost': feeCost,
                            'currency': feeCurrency
                        }
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (since !== undefined) request['since'] = since;
                    const response = await this.publicGetTrades(this.extend(request, params));
                    //
                    //      {
                    //          "trades":[
                    //              {
                    //                  "sequence":276989,
                    //                  "timestamp":1648651276949,
                    //                  "price":"35773.20000000",
                    //                  "volume":"0.00300000",
                    //                  "is_buy":false
                    //              },...
                    //          ]
                    //      }
                    //
                    const trades = this.safeValue(response, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (since !== undefined) request['since'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetListtrades(this.extend(request, params));
                    //
                    //      {
                    //          "trades":[
                    //              {
                    //                  "pair":"LTCXBT",
                    //                  "sequence":3256813,
                    //                  "order_id":"BXEX6XHHDT5EGW2",
                    //                  "type":"ASK",
                    //                  "timestamp":1648652135235,
                    //                  "price":"0.002786",
                    //                  "volume":"0.10",
                    //                  "base":"0.10",
                    //                  "counter":"0.0002786",
                    //                  "fee_base":"0.0001",
                    //                  "fee_counter":"0.00",
                    //                  "is_buy":false,
                    //                  "client_order_id":""
                    //              },...
                    //          ]
                    //      }
                    //
                    const trades = this.safeValue(response, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetFeeInfo(params);
                    return {
                        'info': response,
                        'maker': this.safeNumber(response, 'maker_fee'),
                        'taker': this.safeNumber(response, 'taker_fee')
                    };
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    let method = 'privatePost';
                    const request = {
                        'pair': this.marketId(symbol)
                    };
                    if (type === 'market') {
                        method += 'Marketorder';
                        request['type'] = side.toUpperCase();
                        // todo add createMarketBuyOrderRequires price logic as it is implemented in the other exchanges
                        if (side === 'buy') request['counter_volume'] = parseFloat(this.amountToPrecision(symbol, amount));
                        else request['base_volume'] = parseFloat(this.amountToPrecision(symbol, amount));
                    } else {
                        method += 'Postorder';
                        request['volume'] = parseFloat(this.amountToPrecision(symbol, amount));
                        request['price'] = parseFloat(this.priceToPrecision(symbol, price));
                        request['type'] = side === 'buy' ? 'BID' : 'ASK';
                    }
                    const response = await this[method](this.extend(request, params));
                    return {
                        'info': response,
                        'id': response['order_id']
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    return await this.privatePostStoporder(this.extend(request, params));
                }
                async fetchLedgerByEntries(code, entry = -1, limit = 1, params = {}) {
                    // by default without entry number or limit number, return most recent entry
                    const since = undefined;
                    const request = {
                        'min_row': entry,
                        'max_row': this.sum(entry, limit)
                    };
                    return await this.fetchLedger(code, since, limit, this.extend(request, params));
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    let currency = undefined;
                    let id = this.safeString(params, 'id'); // account id
                    let min_row = this.safeValue(params, 'min_row');
                    let max_row = this.safeValue(params, 'max_row');
                    if (id === undefined) {
                        if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchLedger() requires a currency code argument if no account id specified in params');
                        currency = this.currency(code);
                        const accountsByCurrencyCode = this.indexBy(this.accounts, 'currency');
                        const account = this.safeValue(accountsByCurrencyCode, code);
                        if (account === undefined) throw new ExchangeError1(this.id + ' fetchLedger() could not find account id for ' + code);
                        id = account['id'];
                    }
                    if (min_row === undefined && max_row === undefined) {
                        max_row = 0; // Default to most recent transactions
                        min_row = -1000; // Maximum number of records supported
                    } else if (min_row === undefined || max_row === undefined) throw new ExchangeError1(this.id + " fetchLedger() require both params 'max_row' and 'min_row' or neither to be defined");
                    if (limit !== undefined && max_row - min_row > limit) {
                        if (max_row <= 0) min_row = max_row - limit;
                        else if (min_row > 0) max_row = min_row + limit;
                    }
                    if (max_row - min_row > 1000) throw new ExchangeError1(this.id + " fetchLedger() requires the params 'max_row' - 'min_row' <= 1000");
                    const request = {
                        'id': id,
                        'min_row': min_row,
                        'max_row': max_row
                    };
                    const response = await this.privateGetAccountsIdTransactions(this.extend(params, request));
                    const entries = this.safeValue(response, 'transactions', []);
                    return this.parseLedger(entries, currency, since, limit);
                }
                parseLedgerComment(comment) {
                    const words = comment.split(' ');
                    const types = {
                        'Withdrawal': 'fee',
                        'Trading': 'fee',
                        'Payment': 'transaction',
                        'Sent': 'transaction',
                        'Deposit': 'transaction',
                        'Received': 'transaction',
                        'Released': 'released',
                        'Reserved': 'reserved',
                        'Sold': 'trade',
                        'Bought': 'trade',
                        'Failure': 'failed'
                    };
                    let referenceId = undefined;
                    const firstWord = this.safeString(words, 0);
                    const thirdWord = this.safeString(words, 2);
                    const fourthWord = this.safeString(words, 3);
                    let type = this.safeString(types, firstWord, undefined);
                    if (type === undefined && thirdWord === 'fee') type = 'fee';
                    if (type === 'reserved' && fourthWord === 'order') referenceId = this.safeString(words, 4);
                    return {
                        'type': type,
                        'referenceId': referenceId
                    };
                }
                parseLedgerEntry(entry, currency) {
                    // const details = this.safeValue (entry, 'details', {});
                    const id = this.safeString(entry, 'row_index');
                    const account_id = this.safeString(entry, 'account_id');
                    const timestamp = this.safeValue(entry, 'timestamp');
                    const currencyId = this.safeString(entry, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const available_delta = this.safeNumber(entry, 'available_delta');
                    const balance_delta = this.safeNumber(entry, 'balance_delta');
                    const after = this.safeNumber(entry, 'balance');
                    const comment = this.safeString(entry, 'description');
                    let before = after;
                    let amount = 0.0;
                    const result = this.parseLedgerComment(comment);
                    const type = result['type'];
                    const referenceId = result['referenceId'];
                    let direction = undefined;
                    let status = undefined;
                    if (balance_delta !== 0.0) {
                        before = after - balance_delta; // TODO: float precision
                        status = 'ok';
                        amount = Math.abs(balance_delta);
                    } else if (available_delta < 0.0) {
                        status = 'pending';
                        amount = Math.abs(available_delta);
                    } else if (available_delta > 0.0) {
                        status = 'canceled';
                        amount = Math.abs(available_delta);
                    }
                    if (balance_delta > 0 || available_delta > 0) direction = 'in';
                    else if (balance_delta < 0 || available_delta < 0) direction = 'out';
                    return {
                        'id': id,
                        'direction': direction,
                        'account': account_id,
                        'referenceId': referenceId,
                        'referenceAccount': undefined,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'before': before,
                        'after': after,
                        'status': status,
                        'fee': undefined,
                        'info': entry
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const auth = this.stringToBase64(this.apiKey + ':' + this.secret);
                        headers = {
                            'Authorization': 'Basic ' + this.decode(auth)
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    const error = this.safeValue(response, 'error');
                    if (error !== undefined) throw new ExchangeError1(this.id + ' ' + this.json(response));
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    104: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { NotSupported: NotSupported, ExchangeError: ExchangeError1, BadRequest: BadRequest, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, DuplicateOrderId: DuplicateOrderId } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class lykke extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'lykke',
                        'name': 'Lykke',
                        'countries': [
                            'UK'
                        ],
                        'version': '2',
                        // 300 requests per minute per method => 60000ms / 300 = 200 (/api/orders/*)
                        // 120 requests per minute per method => ( 60000ms / rateLimit ) / 120 = cost = 2.5 (/api/*)
                        'rateLimit': 200,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'editOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': false,
                            'fetchFundingFees': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': 'emulated',
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': false,
                            'fetchOrderTrades': false,
                            'fetchPositions': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': false,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransactions': true,
                            'fetchWithdrawals': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'withdraw': true
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/155840500-1ea4fdf0-47c0-4daa-9597-c6c1cd51b9ec.jpg',
                            'api': {
                                'public': 'https://hft-apiv2.lykke.com/api',
                                'private': 'https://hft-apiv2.lykke.com/api'
                            },
                            'www': 'https://www.lykke.com',
                            'doc': [
                                'https://hft-apiv2.lykke.com/swagger/ui/index.html',
                                'https://lykkecity.github.io/Trading-API'
                            ],
                            'fees': 'https://support.lykke.com/hc/en-us/articles/115002141125-What-are-the-fees-and-charges-'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'assetpairs': 2.5,
                                    'assetpairs/{id}': 2.5,
                                    'assets': 2.5,
                                    'assets/{id}': 2.5,
                                    'isalive': 2.5,
                                    'orderbooks': 2.5,
                                    'tickers': 2.5,
                                    'prices': 2.5,
                                    'trades/public/{assetPairId}': 2.5
                                }
                            },
                            'private': {
                                'get': {
                                    'balance': 2.5,
                                    'trades': 2.5,
                                    'trades/order/{orderId}': 2.5,
                                    'orders/active': 1,
                                    'orders/closed': 1,
                                    'orders/{orderId}': 1,
                                    'operations': 2.5,
                                    'operations/deposits/addresses': 2.5,
                                    'operations/deposits/addresses/{assetId}': 2.5
                                },
                                'post': {
                                    'orders/limit': 1,
                                    'orders/market': 1,
                                    'orders/bulk': 1,
                                    'operations/withdrawals': 2.5,
                                    'operations/deposits/addresses': 2.5
                                },
                                'delete': {
                                    'orders': 1,
                                    'orders/{orderId}': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': 0,
                                'taker': 0
                            }
                        },
                        'exceptions': {
                            'exact': {
                                '1001': ExchangeError1,
                                '1100': ExchangeError1,
                                '1101': ExchangeError1,
                                '2000': BadRequest,
                                '2001': InsufficientFunds,
                                '2202': DuplicateOrderId,
                                '2003': ExchangeError1,
                                '2004': NotSupported,
                                '2005': ExchangeError1,
                                '2006': InsufficientFunds,
                                '2007': InsufficientFunds,
                                '2008': InsufficientFunds,
                                '2009': ExchangeError1,
                                '2010': InsufficientFunds,
                                '2011': InvalidOrder,
                                '2012': InvalidOrder,
                                '2013': InvalidOrder,
                                '2014': InvalidOrder,
                                '2015': InvalidOrder,
                                '2016': InvalidOrder,
                                '2017': InvalidOrder,
                                '2018': InvalidOrder,
                                '2019': InvalidOrder,
                                '2020': InvalidOrder,
                                '2021': InvalidOrder,
                                '2022': InvalidOrder,
                                '2023': ExchangeError1
                            },
                            'broad': {}
                        },
                        'commonCurrencies': {}
                    });
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetAssets(params);
                    const currencies = this.safeValue(response, 'payload', []);
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 "assetId":"115a60c2-0da1-40f9-a7f2-41da723b9074",
                    //                 "name":"Monaco Token",
                    //                 "symbol":"MCO",
                    //                 "accuracy":6,
                    //                 "multiplierPower":8,
                    //                 "assetAddress":"",
                    //                 "blockchainIntegrationLayerId":"",
                    //                 "blockchain":"ethereum",
                    //                 "type":"erc20Token",
                    //                 "isTradable":true,
                    //                 "isTrusted":true,
                    //                 "kycNeeded":false,
                    //                 "blockchainWithdrawal":true,
                    //                 "cashoutMinimalAmount":0.1,
                    //                 "lowVolumeAmount":null,
                    //                 "lykkeEntityId":"LYKKE NL",
                    //                 "siriusAssetId":0,
                    //                 "siriusBlockchainId":null,
                    //                 "blockchainIntegrationType":"none",
                    //                 "blockchainDepositEnabled":false,
                    //                 "isDisabled":false
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'assetId');
                        const code = this.safeString(currency, 'symbol');
                        const name = this.safeString(currency, 'name');
                        const type = this.safeString(currency, 'type');
                        const deposit = this.safeValue(currency, 'blockchainDepositEnabled');
                        const withdraw = this.safeValue(currency, 'blockchainWithdrawal');
                        const isDisabled = this.safeValue(currency, 'isDisabled');
                        const active = !isDisabled;
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'type': type,
                            'name': name,
                            'active': active,
                            'deposit': deposit,
                            'withdraw': withdraw,
                            'fee': undefined,
                            'precision': this.safeInteger(currency, 'accuracy'),
                            'limits': {
                                'withdraw': {
                                    'min': this.safeValue(currency, 'cashoutMinimalAmount'),
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeValue(currency, 'lowVolumeAmount'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetAssetpairs(params);
                    const markets = this.safeValue(response, 'payload', []);
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 "assetPairId":"AAVEBTC",
                    //                 "baseAssetId":"c9e55548-dae5-44fc-bebd-e72249cb19f3",
                    //                 "quoteAssetId":"BTC",
                    //                 "name":"AAVE/BTC",
                    //                 "priceAccuracy":6,
                    //                 "baseAssetAccuracy":6,
                    //                 "quoteAssetAccuracy":8,
                    //                 "minVolume":0.001,
                    //                 "minOppositeVolume":0.0001
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'assetPairId');
                        const name = this.safeString(market, 'name');
                        const baseAssetId = this.safeString(market, 'baseAssetId');
                        const quoteAssetId = this.safeString(market, 'quoteAssetId');
                        const [baseId, quoteId] = name.split('/');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const symbol = base + '/' + quote;
                        const precision = {
                            'price': this.safeInteger(market, 'priceAccuracy'),
                            'amount': this.safeInteger(market, 'baseAssetAccuracy')
                        };
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'baseId': baseAssetId,
                            'quoteId': quoteAssetId,
                            'settle': undefined,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'contract': false,
                            'active': true,
                            'info': market,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': this.safeNumber(market, 'minVolume'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minOppositeVolume'),
                                    'max': undefined
                                },
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTickers
                    //
                    //     publicGetTickers
                    //
                    //     {
                    //         "assetPairId":"BTCUSD",
                    //         "volumeBase":2.56905016,
                    //         "volumeQuote":95653.8730,
                    //         "priceChange":-0.0367945778541765034194707584,
                    //         "lastPrice":36840.0,
                    //         "high":38371.645,
                    //         "low":35903.356,
                    //         "timestamp":1643295740729
                    //     }
                    //
                    // fetchTicker
                    //
                    //     publicGetTickers
                    //
                    //     {
                    //         "assetPairId":"BTCUSD",
                    //         "volumeBase":2.56905016,
                    //         "volumeQuote":95653.8730,
                    //         "priceChange":-0.0367945778541765034194707584,
                    //         "lastPrice":36840.0,
                    //         "high":38371.645,
                    //         "low":35903.356,
                    //         "timestamp":1643295740729
                    //     }
                    //
                    //     publicGetPrices
                    //
                    //     {
                    //         "assetPairId":"BTCUSD",
                    //         "bid":36181.521,
                    //         "ask":36244.492,
                    //         "timestamp":1643305510990
                    //     }
                    //
                    const timestamp = this.safeInteger(ticker, 'timestamp');
                    const marketId = this.safeString(ticker, 'assetPairId');
                    market = this.safeMarket(marketId, market);
                    const close = this.safeString(ticker, 'lastPrice');
                    return this.safeTicker({
                        'symbol': this.safeString(market, 'symbol'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': close,
                        'last': close,
                        'previousClose': undefined,
                        'change': this.safeString(ticker, 'priceChange'),
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volumeBase'),
                        'quoteVolume': this.safeString(ticker, 'volumeQuote'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'assetPairIds': market['id']
                    };
                    // publicGetTickers or publicGetPrices
                    const method = this.safeString(this.options, 'fetchTickerMethod', 'publicGetTickers');
                    const response = await this[method](this.extend(request, params));
                    const ticker = this.safeValue(response, 'payload', []);
                    //
                    // publicGetTickers
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 "assetPairId":"BTCUSD",
                    //                 "volumeBase":0.78056880,
                    //                 "volumeQuote":29782.5169,
                    //                 "priceChange":0.0436602362590968619931324699,
                    //                 "lastPrice":38626.885,
                    //                 "high":38742.896,
                    //                 "low":36872.498,
                    //                 "timestamp":1643687822840
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    // publicGetPrices
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 "assetPairId":"BTCUSD",
                    //                 "bid":38597.936,
                    //                 "ask":38640.311,
                    //                 "timestamp":1643688350847
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    return this.parseTicker(this.safeValue(ticker, 0, {}), market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTickers(params);
                    const tickers = this.safeValue(response, 'payload', []);
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 "assetPairId":"BTCUSD",
                    //                 "volumeBase":0.78056880,
                    //                 "volumeQuote":29782.5169,
                    //                 "priceChange":0.0436602362590968619931324699,
                    //                 "lastPrice":38626.885,
                    //                 "high":38742.896,
                    //                 "low":36872.498,
                    //                 "timestamp":1643687822840
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    return this.parseTickers(tickers, symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'assetPairId': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['depth'] = limit; // default 0
                    const response = await this.publicGetOrderbooks(this.extend(request, params));
                    const payload = this.safeValue(response, 'payload', []);
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 assetPairId: 'BTCUSD',
                    //                 timestamp: '1643298038203',
                    //                 bids: [
                    //                     {
                    //                         "v":0.59034382,
                    //                         "p":36665.329
                    //                     }
                    //                 ],
                    //                 asks: [
                    //                     {
                    //                         "v":-0.003,
                    //                         "p":36729.686
                    //                     }
                    //                 ]
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    const orderbook = this.safeValue(payload, 0, {});
                    const timestamp = this.safeString(orderbook, 'timestamp');
                    return this.parseOrderBook(orderbook, symbol, timestamp, 'bids', 'asks', 'p', 'v');
                }
                parseTrade(trade, market) {
                    //
                    //  public fetchTrades
                    //
                    //     {
                    //         "id":"71df1f0c-be4e-4d45-b809-c108fad5f2a8",
                    //         "assetPairId":"BTCUSD",
                    //         "timestamp":1643345958414,
                    //         "volume":0.00010996,
                    //         "price":37205.723,
                    //         "side":"buy"
                    //      }
                    //
                    //  private fetchMyTrades
                    //         {
                    //             "id":"813a3ffa-1c4b-45cb-b13f-1c077ea2748b",
                    //             "timestamp":1644155923357,
                    //             "assetPairId":"BCHEUR",
                    //             "orderId":"1b367978-7e4f-454b-b870-64040d484443",
                    //             "role":"Taker",
                    //             "side":"sell",
                    //             "price":280.569,
                    //             "baseVolume":0.01,
                    //             "quoteVolume":2.8056,
                    //             "baseAssetId":"2a34d6a6-5839-40e5-836f-c1178fa09b89",
                    //             "quoteAssetId":"EUR",
                    //             "fee":null
                    //         }
                    //
                    const marketId = this.safeString(trade, 'assetPairId');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const id = this.safeString2(trade, 'id', 'id');
                    const orderId = this.safeString(trade, 'orderId');
                    const timestamp = this.safeInteger(trade, 'timestamp');
                    const price = this.safeString2(trade, 'price', 'price');
                    let amount = this.safeString2(trade, 'volume', 'amount');
                    if (amount === undefined) amount = this.safeString2(trade, 'baseVolume', 'amount');
                    const side = this.safeStringLower(trade, 'side');
                    const fee = {
                        'cost': this.parseNumber('0'),
                        'currency': market['quote']
                    };
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'order': orderId,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'assetPairId': market['id']
                    };
                    if (limit !== undefined) request['take'] = limit;
                    const response = await this.publicGetTradesPublicAssetPairId(this.extend(request, params));
                    const result = this.safeValue(response, 'payload', []);
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 "id":"71df1f0c-be4e-4d45-b809-c108fad5f2a8",
                    //                 "assetPairId":"BTCUSD",
                    //                 "timestamp":1643345958414,
                    //                 "volume":0.00010996,
                    //                 "price":37205.723,
                    //                 "side":"buy"
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    return this.parseTrades(result, market, since, limit);
                }
                parseBalance(response) {
                    //
                    //     [
                    //         {
                    //             "assetId":"2a34d6a6-5839-40e5-836f-c1178fa09b89",
                    //             "available":0.1,
                    //             "reserved":0.0,
                    //             "timestamp":1644146723620
                    //         }
                    //     ]
                    //
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'assetId');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        const free = this.safeString(balance, 'available');
                        const used = this.safeString(balance, 'reserved');
                        account['free'] = free;
                        account['used'] = used;
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalance(params);
                    const payload = this.safeValue(response, 'payload', []);
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 "assetId":"2a34d6a6-5839-40e5-836f-c1178fa09b89",
                    //                 "available":0.1,
                    //                 "reserved":0.0,
                    //                 "timestamp":1644146723620
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    return this.parseBalance(payload);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'Open': 'open',
                        'Pending': 'open',
                        'InOrderBook': 'open',
                        'Processing': 'open',
                        'Matched': 'closed',
                        'Cancelled': 'canceled',
                        'Rejected': 'rejected',
                        'Replaced': 'canceled',
                        'Placed': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "id":"1b367978-7e4f-454b-b870-64040d484443",
                    //         "timestamp":1644155923357,
                    //         "lastTradeTimestamp":1644155923357,
                    //         "status":"Matched",
                    //         "assetPairId":"BCHEUR",
                    //         "type":"Market",
                    //         "side":"Sell",
                    //         "price":280.569,
                    //         "volume":0.01,
                    //         "filledVolume":0.01,
                    //         "remainingVolume":0.0,
                    //         "cost":2.80569
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const marketId = this.safeString(order, 'assetPairId');
                    const symbol = this.safeSymbol(marketId, market);
                    const type = this.safeStringLower(order, 'type');
                    const lastTradeTimestamp = this.safeInteger(order, 'lastTradeTimestamp');
                    const timestamp = this.safeInteger(order, 'timestamp');
                    const price = this.safeString(order, 'price');
                    const side = this.safeStringLower(order, 'side');
                    const amount = this.safeString(order, 'volume');
                    const remaining = this.safeString(order, 'remainingVolume');
                    const filled = this.safeString(order, 'filledVolume');
                    const cost = this.safeString(order, 'cost');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': cost,
                        'average': undefined,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const query = {
                        'assetPairId': market['id'],
                        'side': this.capitalize(side),
                        'volume': parseFloat(this.amountToPrecision(symbol, amount))
                    };
                    if (type === 'limit') query['price'] = parseFloat(this.priceToPrecision(symbol, price));
                    const method = 'privatePostOrders' + this.capitalize(type);
                    const result = await this[method](this.extend(query, params));
                    //
                    // market
                    //
                    //         {
                    //             "payload":{
                    //                 "orderId":"2b98ec26-8410-49b6-9f37-1fb2150e2299",
                    //                 "price":280.699
                    //             },
                    //             "error":null
                    //         }
                    //
                    // limit
                    //
                    //         {
                    //             "payload":{
                    //                 "orderId":"27be8802-30be-40ca-bf40-ec886b309c5b"
                    //             },
                    //             "error":null
                    //         }
                    //
                    const payload = this.safeValue(result, 'payload');
                    const id = this.safeString(payload, 'orderId');
                    if (type === 'market') price = this.safeNumber(payload, 'price');
                    return {
                        'id': id,
                        'info': result,
                        'clientOrderId': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'average': undefined,
                        'filled': undefined,
                        'remaining': undefined,
                        'status': undefined,
                        'fee': undefined,
                        'trades': undefined
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'orderId': id
                    };
                    //
                    //     {
                    //         "payload":null,
                    //         "error":null
                    //     }
                    //
                    return await this.privateDeleteOrdersOrderId(this.extend(request, params));
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['assetPairId'] = market['id'];
                    }
                    //
                    //     {
                    //         "payload":null,
                    //         "error":null
                    //     }
                    //
                    return await this.privateDeleteOrders(this.extend(request, params));
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderId': id
                    };
                    const response = await this.privateGetOrdersOrderId(this.extend(request, params));
                    const payload = this.safeValue(response, 'payload');
                    //
                    //     {
                    //         "payload":{
                    //             "id":"1b367978-7e4f-454b-b870-64040d484443",
                    //             "timestamp":1644155923357,
                    //             "lastTradeTimestamp":1644155923357,
                    //             "status":"Matched",
                    //             "assetPairId":"BCHEUR",
                    //             "type":"Market",
                    //             "side":"Sell",
                    //             "price":280.569,
                    //             "volume":0.01,
                    //             "filledVolume":0.01,
                    //             "remainingVolume":0.0,
                    //             "cost":2.80569
                    //         },
                    //         "error":null
                    //     }
                    //
                    return this.parseOrder(payload);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                    };
                    if (limit !== undefined) request['take'] = limit;
                    const response = await this.privateGetOrdersActive(this.extend(request, params));
                    const payload = this.safeValue(response, 'payload');
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 "id":"b26f58f5-8542-4b4c-9815-91562b523cc3",
                    //                 "timestamp":1644157177155,
                    //                 "lastTradeTimestamp":null,
                    //                 "status":"Placed",
                    //                 "assetPairId":"BCHEUR",
                    //                 "type":"Limit",
                    //                 "side":"Sell",
                    //                 "price":666.666,
                    //                 "volume":0.01,
                    //                 "filledVolume":0.00,
                    //                 "remainingVolume":0.01,
                    //                 "cost":0.00000
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    return this.parseOrders(payload, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                    };
                    if (limit !== undefined) request['take'] = limit;
                    const response = await this.privateGetOrdersClosed(this.extend(request, params));
                    const payload = this.safeValue(response, 'payload');
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 "id":"1b367978-7e4f-454b-b870-64040d484443",
                    //                 "timestamp":1644155923357,
                    //                 "lastTradeTimestamp":1644155923357,
                    //                 "status":"Matched",
                    //                 "assetPairId":"BCHEUR",
                    //                 "type":"Market",
                    //                 "side":"Sell",
                    //                 "price":280.569,
                    //                 "volume":0.01,
                    //                 "filledVolume":0.01,
                    //                 "remainingVolume":0.0,
                    //                 "cost":2.80569
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    return this.parseOrders(payload, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (limit !== undefined) request['take'] = limit; // How many maximum items have to be returned, max 1000 default 100.
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['assetPairId'] = market['id'];
                    }
                    if (since !== undefined) request['from'] = since;
                    const response = await this.privateGetTrades(this.extend(request, params));
                    const payload = this.safeValue(response, 'payload');
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 "id":"813a3ffa-1c4b-45cb-b13f-1c077ea2748b",
                    //                 "timestamp":1644155923357,
                    //                 "assetPairId":"BCHEUR",
                    //                 "orderId":"1b367978-7e4f-454b-b870-64040d484443",
                    //                 "role":"Taker",
                    //                 "side":"sell",
                    //                 "price":280.569,
                    //                 "baseVolume":0.01,
                    //                 "quoteVolume":2.8056,
                    //                 "baseAssetId":"2a34d6a6-5839-40e5-836f-c1178fa09b89",
                    //                 "quoteAssetId":"EUR",
                    //                 "fee":null
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    return this.parseTrades(payload, market, since, limit);
                }
                parseBidAsk(bidask, priceKey = 0, amountKey = 1) {
                    const price = this.safeString(bidask, priceKey);
                    const amount = Precise.stringAbs(this.safeString(bidask, amountKey));
                    return [
                        this.parseNumber(price),
                        this.parseNumber(amount)
                    ];
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'assetId': this.safeString(currency, 'id')
                    };
                    const response = await this.privateGetOperationsDepositsAddressesAssetId(this.extend(request, params));
                    //
                    //     {
                    //         "assetId":"2a34d6a6-5839-40e5-836f-c1178fa09b89",
                    //         "symbol":"BCH",
                    //         "address":null,
                    //         "baseAddress":null,
                    //         "addressExtension":null,
                    //         "state":"Active"
                    //     }
                    //
                    const address = this.safeString(response, 'baseAddress');
                    const tag = this.safeString(response, 'addressExtension');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //     "3035b1ad-2005-4587-a986-1f7966be78e0"
                    //
                    // fetchTransactions
                    //     {
                    //         "operationId":"787201c8-f1cc-45c0-aec1-fa06eeea426b",
                    //         "assetId":"2a34d6a6-5839-40e5-836f-c1178fa09b89",
                    //         "totalVolume":0.1,
                    //         "fee":0.0,
                    //         "type":"deposit",
                    //         "timestamp":1644146723620
                    //     }
                    //
                    let id = undefined;
                    let assetId = undefined;
                    let code = undefined;
                    let amount = undefined;
                    let fee = undefined;
                    let type = undefined;
                    let timestamp = undefined;
                    if (typeof transaction === 'string') id = transaction;
                    else {
                        id = this.safeString(transaction, 'operationId');
                        assetId = this.safeString(transaction, 'assetId');
                        code = this.safeCurrencyCode(assetId, currency);
                        amount = this.safeNumber(transaction, 'totalVolume');
                        type = this.safeString(transaction, 'type');
                        timestamp = this.safeInteger(transaction, 'timestamp');
                        const feeCost = this.safeNumber(transaction, 'fee');
                        fee = {
                            'currency': code,
                            'cost': feeCost
                        };
                    }
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': undefined,
                        'updated': undefined,
                        'fee': fee
                    };
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    if (limit !== undefined) request['take'] = limit;
                    const response = await this.privateGetOperations(this.extend(request, params));
                    const payload = this.safeValue(response, 'payload', []);
                    //
                    //     {
                    //         "payload":[
                    //             {
                    //                 "operationId":"787201c8-f1cc-45c0-aec1-fa06eeea426b",
                    //                 "assetId":"2a34d6a6-5839-40e5-836f-c1178fa09b89",
                    //                 "totalVolume":0.1,
                    //                 "fee":0.0,
                    //                 "type":"deposit",
                    //                 "timestamp":1644146723620
                    //             }
                    //         ],
                    //         "error":null
                    //     }
                    //
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    return this.parseTransactions(payload, currency, since, limit);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    await this.loadMarkets();
                    this.checkAddress(address);
                    const currency = this.currency(code);
                    const request = {
                        'assetId': currency['id'],
                        'volume': parseFloat(this.currencyToPrecision(code, amount)),
                        'destinationAddress': address
                    };
                    if (tag !== undefined) request['destinationAddressExtension'] = tag;
                    const response = await this.privatePostOperationsWithdrawals(this.extend(request, params));
                    //
                    //     "3035b1ad-2005-4587-a986-1f7966be78e0"
                    //
                    return this.parseTransaction(response, currency);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    };
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'private') {
                        if (method === 'GET' || method === 'DELETE') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        }
                        this.checkRequiredCredentials();
                        headers['Authorization'] = 'Bearer ' + this.apiKey;
                        if (method === 'POST') {
                            if (Object.keys(params).length) body = this.json(params);
                        }
                        if (path === 'operations/withdrawals') headers['X-Request-ID'] = this.uuid();
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    const error = this.safeValue(response, 'error', {});
                    const errorCode = this.safeString(error, 'code');
                    if (errorCode !== undefined && errorCode !== '0') {
                        const feedback = this.id + ' ' + body;
                        const message = this.safeString(error, 'message');
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    105: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, InvalidOrder: InvalidOrder } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class mercado extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'mercado',
                        'name': 'Mercado Bitcoin',
                        'countries': [
                            'BR'
                        ],
                        'rateLimit': 1000,
                        'version': 'v3',
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createMarketOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': 'emulated',
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': undefined,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '6h': '6h',
                            '12h': '12h',
                            '1d': '1d',
                            '3d': '3d',
                            '1w': '1w',
                            '2w': '2w'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27837060-e7c58714-60ea-11e7-9192-f05e86adb83f.jpg',
                            'api': {
                                'public': 'https://www.mercadobitcoin.net/api',
                                'private': 'https://www.mercadobitcoin.net/tapi',
                                'v4Public': 'https://www.mercadobitcoin.com.br/v4'
                            },
                            'www': 'https://www.mercadobitcoin.com.br',
                            'doc': [
                                'https://www.mercadobitcoin.com.br/api-doc',
                                'https://www.mercadobitcoin.com.br/trade-api'
                            ]
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'coins',
                                    '{coin}/orderbook/',
                                    '{coin}/ticker/',
                                    '{coin}/trades/',
                                    '{coin}/trades/{from}/',
                                    '{coin}/trades/{from}/{to}',
                                    '{coin}/day-summary/{year}/{month}/{day}/'
                                ]
                            },
                            'private': {
                                'post': [
                                    'cancel_order',
                                    'get_account_info',
                                    'get_order',
                                    'get_withdrawal',
                                    'list_system_messages',
                                    'list_orders',
                                    'list_orderbook',
                                    'place_buy_order',
                                    'place_sell_order',
                                    'place_market_buy_order',
                                    'place_market_sell_order',
                                    'withdraw_coin'
                                ]
                            },
                            'v4Public': {
                                'get': [
                                    '{coin}/candle/'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': 0.003,
                                'taker': 0.007
                            }
                        },
                        'options': {
                            'limits': {
                                'BTC': 0.001,
                                'BCH': 0.001,
                                'ETH': 0.01,
                                'LTC': 0.01,
                                'XRP': 0.1
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetCoins(params);
                    //
                    //     [
                    //         "BCH",
                    //         "BTC",
                    //         "ETH",
                    //         "LTC",
                    //         "XRP",
                    //         "MBPRK01",
                    //         "MBPRK02",
                    //         "MBPRK03",
                    //         "MBPRK04",
                    //         "MBCONS01",
                    //         "USDC",
                    //         "WBX",
                    //         "CHZ",
                    //         "MBCONS02",
                    //         "PAXG",
                    //         "MBVASCO01",
                    //         "LINK"
                    //     ]
                    //
                    const result = [];
                    const amountLimits = this.safeValue(this.options, 'limits', {});
                    for(let i = 0; i < response.length; i++){
                        const coin = response[i];
                        const baseId = coin;
                        const quoteId = 'BRL';
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const id = quote + base;
                        const priceLimit = '1e-5';
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': parseInt('8'),
                                'price': parseInt('5')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(amountLimits, baseId),
                                    'max': undefined
                                },
                                'price': {
                                    'min': this.parseNumber(priceLimit),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': coin
                        });
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'coin': market['base']
                    };
                    const response = await this.publicGetCoinOrderbook(this.extend(request, params));
                    return this.parseOrderBook(response, symbol);
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "high":"103.96000000",
                    //         "low":"95.00000000",
                    //         "vol":"2227.67806598",
                    //         "last":"97.91591000",
                    //         "buy":"95.52760000",
                    //         "sell":"97.91475000",
                    //         "open":"99.79955000",
                    //         "date":1643382606
                    //     }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.safeTimestamp(ticker, 'date');
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'vol'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'coin': market['base']
                    };
                    const response = await this.publicGetCoinTicker(this.extend(request, params));
                    const ticker = this.safeValue(response, 'ticker', {});
                    //
                    //     {
                    //         "ticker": {
                    //             "high":"1549.82293000",
                    //             "low":"1503.00011000",
                    //             "vol":"81.82827101",
                    //             "last":"1533.15000000",
                    //             "buy":"1533.21018000",
                    //             "sell":"1540.09000000",
                    //             "open":"1524.71089000",
                    //             "date":1643691671
                    //         }
                    //     }
                    //
                    return this.parseTicker(ticker, market);
                }
                parseTrade(trade, market) {
                    const timestamp = this.safeTimestamp2(trade, 'date', 'executed_timestamp');
                    market = this.safeMarket(undefined, market);
                    const id = this.safeString2(trade, 'tid', 'operation_id');
                    const type = undefined;
                    const side = this.safeString(trade, 'type');
                    const price = this.safeString(trade, 'price');
                    const amount = this.safeString2(trade, 'amount', 'quantity');
                    const feeCost = this.safeString(trade, 'fee_rate');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': undefined
                    };
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': undefined,
                        'type': type,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let method = 'publicGetCoinTrades';
                    const request = {
                        'coin': market['base']
                    };
                    if (since !== undefined) {
                        method += 'From';
                        request['from'] = parseInt(since / 1000);
                    }
                    const to = this.safeInteger(params, 'to');
                    if (to !== undefined) method += 'To';
                    const response = await this[method](this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                parseBalance(response) {
                    const data = this.safeValue(response, 'response_data', {});
                    const balances = this.safeValue(data, 'balance', {});
                    const result = {
                        'info': response
                    };
                    const currencyIds = Object.keys(balances);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        if (currencyId in balances) {
                            const balance = this.safeValue(balances, currencyId, {});
                            const account = this.account();
                            account['free'] = this.safeString(balance, 'available');
                            account['total'] = this.safeString(balance, 'total');
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGetAccountInfo(params);
                    return this.parseBalance(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'coin_pair': this.marketId(symbol)
                    };
                    let method = this.capitalize(side) + 'Order';
                    if (type === 'limit') {
                        method = 'privatePostPlace' + method;
                        request['limit_price'] = this.priceToPrecision(symbol, price);
                        request['quantity'] = this.amountToPrecision(symbol, amount);
                    } else {
                        method = 'privatePostPlaceMarket' + method;
                        if (side === 'buy') {
                            if (price === undefined) throw new InvalidOrder(this.id + ' createOrder() requires the price argument with market buy orders to calculate total order cost (amount to spend), where cost = amount * price. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount');
                            request['cost'] = this.priceToPrecision(symbol, amount * price);
                        } else request['quantity'] = this.amountToPrecision(symbol, amount);
                    }
                    const response = await this[method](this.extend(request, params));
                    // TODO: replace this with a call to parseOrder for unification
                    return {
                        'info': response,
                        'id': response['response_data']['order']['order_id'].toString()
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'coin_pair': market['id'],
                        'order_id': id
                    };
                    const response = await this.privatePostCancelOrder(this.extend(request, params));
                    //
                    //     {
                    //         response_data: {
                    //             order: {
                    //                 order_id: 2176769,
                    //                 coin_pair: 'BRLBCH',
                    //                 order_type: 2,
                    //                 status: 3,
                    //                 has_fills: false,
                    //                 quantity: '0.10000000',
                    //                 limit_price: '1996.15999',
                    //                 executed_quantity: '0.00000000',
                    //                 executed_price_avg: '0.00000',
                    //                 fee: '0.00000000',
                    //                 created_timestamp: '1536956488',
                    //                 updated_timestamp: '1536956499',
                    //                 operations: []
                    //             }
                    //         },
                    //         status_code: 100,
                    //         server_unix_timestamp: '1536956499'
                    //     }
                    //
                    const responseData = this.safeValue(response, 'response_data', {});
                    const order = this.safeValue(responseData, 'order', {});
                    return this.parseOrder(order, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '2': 'open',
                        '3': 'canceled',
                        '4': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "order_id": 4,
                    //         "coin_pair": "BRLBTC",
                    //         "order_type": 1,
                    //         "status": 2,
                    //         "has_fills": true,
                    //         "quantity": "2.00000000",
                    //         "limit_price": "900.00000",
                    //         "executed_quantity": "1.00000000",
                    //         "executed_price_avg": "900.00000",
                    //         "fee": "0.00300000",
                    //         "created_timestamp": "1453838494",
                    //         "updated_timestamp": "1453838494",
                    //         "operations": [
                    //             {
                    //                 "operation_id": 1,
                    //                 "quantity": "1.00000000",
                    //                 "price": "900.00000",
                    //                 "fee_rate": "0.30",
                    //                 "executed_timestamp": "1453838494",
                    //             },
                    //         ],
                    //     }
                    //
                    const id = this.safeString(order, 'order_id');
                    const order_type = this.safeString(order, 'order_type');
                    let side = undefined;
                    if ('order_type' in order) side = order_type === '1' ? 'buy' : 'sell';
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const marketId = this.safeString(order, 'coin_pair');
                    market = this.safeMarket(marketId, market);
                    const timestamp = this.safeTimestamp(order, 'created_timestamp');
                    const fee = {
                        'cost': this.safeString(order, 'fee'),
                        'currency': market['quote']
                    };
                    const price = this.safeString(order, 'limit_price');
                    // price = this.safeNumber (order, 'executed_price_avg', price);
                    const average = this.safeString(order, 'executed_price_avg');
                    const amount = this.safeString(order, 'quantity');
                    const filled = this.safeString(order, 'executed_quantity');
                    const lastTradeTimestamp = this.safeTimestamp(order, 'updated_timestamp');
                    const rawTrades = this.safeValue(order, 'operations', []);
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': market['symbol'],
                        'type': 'limit',
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'average': average,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': rawTrades
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'coin_pair': market['id'],
                        'order_id': parseInt(id)
                    };
                    const response = await this.privatePostGetOrder(this.extend(request, params));
                    const responseData = this.safeValue(response, 'response_data', {});
                    const order = this.safeValue(responseData, 'order');
                    return this.parseOrder(order, market);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin': currency['id'],
                        'quantity': amount.toFixed(10),
                        'address': address
                    };
                    if (code === 'BRL') {
                        const account_ref = 'account_ref' in params;
                        if (!account_ref) throw new ArgumentsRequired1(this.id + ' withdraw() requires account_ref parameter to withdraw ' + code);
                    } else if (code !== 'LTC') {
                        const tx_fee = 'tx_fee' in params;
                        if (!tx_fee) throw new ArgumentsRequired1(this.id + ' withdraw() requires tx_fee parameter to withdraw ' + code);
                        if (code === 'XRP') {
                            if (tag === undefined) {
                                if (!('destination_tag' in params)) throw new ArgumentsRequired1(this.id + ' withdraw() requires a tag argument or destination_tag parameter to withdraw ' + code);
                            } else request['destination_tag'] = tag;
                        }
                    }
                    const response = await this.privatePostWithdrawCoin(this.extend(request, params));
                    //
                    //     {
                    //         "response_data": {
                    //             "withdrawal": {
                    //                 "id": 1,
                    //                 "coin": "BRL",
                    //                 "quantity": "300.56",
                    //                 "net_quantity": "291.68",
                    //                 "fee": "8.88",
                    //                 "account": "bco: 341, ag: 1111, cta: 23456-X",
                    //                 "status": 1,
                    //                 "created_timestamp": "1453912088",
                    //                 "updated_timestamp": "1453912088"
                    //             }
                    //         },
                    //         "status_code": 100,
                    //         "server_unix_timestamp": "1453912088"
                    //     }
                    //
                    const responseData = this.safeValue(response, 'response_data', {});
                    const withdrawal = this.safeValue(responseData, 'withdrawal');
                    return this.parseTransaction(withdrawal, currency);
                }
                parseTransaction(transaction, currency) {
                    //
                    //     {
                    //         "id": 1,
                    //         "coin": "BRL",
                    //         "quantity": "300.56",
                    //         "net_quantity": "291.68",
                    //         "fee": "8.88",
                    //         "account": "bco: 341, ag: 1111, cta: 23456-X",
                    //         "status": 1,
                    //         "created_timestamp": "1453912088",
                    //         "updated_timestamp": "1453912088"
                    //     }
                    //
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'id': this.safeString(transaction, 'id'),
                        'txid': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': undefined,
                        'info': transaction
                    };
                }
                parseOHLCV(ohlcv, market) {
                    return [
                        this.safeTimestamp(ohlcv, 'timestamp'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '5m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'precision': this.timeframes[timeframe],
                        'coin': market['id'].toLowerCase()
                    };
                    if (limit !== undefined && since !== undefined) {
                        request['from'] = parseInt(since / 1000);
                        request['to'] = this.sum(request['from'], limit * this.parseTimeframe(timeframe));
                    } else if (since !== undefined) {
                        request['from'] = parseInt(since / 1000);
                        request['to'] = this.sum(this.seconds(), 1);
                    } else if (limit !== undefined) {
                        request['to'] = this.seconds();
                        request['from'] = request['to'] - limit * this.parseTimeframe(timeframe);
                    }
                    const response = await this.v4PublicGetCoinCandle(this.extend(request, params));
                    const candles = this.safeValue(response, 'candles', []);
                    return this.parseOHLCVs(candles, market, timeframe, since, limit);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'coin_pair': market['id']
                    };
                    const response = await this.privatePostListOrders(this.extend(request, params));
                    const responseData = this.safeValue(response, 'response_data', {});
                    const orders = this.safeValue(responseData, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'coin_pair': market['id'],
                        'status_list': '[2]'
                    };
                    const response = await this.privatePostListOrders(this.extend(request, params));
                    const responseData = this.safeValue(response, 'response_data', {});
                    const orders = this.safeValue(responseData, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'coin_pair': market['id'],
                        'has_fills': true
                    };
                    const response = await this.privatePostListOrders(this.extend(request, params));
                    const responseData = this.safeValue(response, 'response_data', {});
                    const ordersRaw = this.safeValue(responseData, 'orders', []);
                    const orders = this.parseOrders(ordersRaw, market, since, limit);
                    const trades = this.ordersToTrades(orders);
                    return this.filterBySymbolSinceLimit(trades, market['symbol'], since, limit);
                }
                ordersToTrades(orders) {
                    const result = [];
                    for(let i = 0; i < orders.length; i++){
                        const trades = this.safeValue(orders[i], 'trades', []);
                        for(let y = 0; y < trades.length; y++)result.push(trades[y]);
                    }
                    return result;
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/';
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public' || api === 'v4Public') {
                        url += this.implodeParams(path, params);
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        url += this.version + '/';
                        const nonce = this.nonce();
                        body = this.urlencode(this.extend({
                            'tapi_method': path,
                            'tapi_nonce': nonce
                        }, params));
                        const auth = '/tapi/' + this.version + '/' + '?' + body;
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'TAPI-ID': this.apiKey,
                            'TAPI-MAC': this.hmac(this.encode(auth), this.encode(this.secret), 'sha512')
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    // todo add a unified standard handleErrors with this.exceptions in describe()
                    //
                    //     {"status":503,"message":"Maintenancing, try again later","result":null}
                    //
                    const errorMessage = this.safeValue(response, 'error_message');
                    if (errorMessage !== undefined) throw new ExchangeError1(this.id + ' ' + this.json(response));
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    106: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AccountNotEnabled: AccountNotEnabled, InvalidAddress: InvalidAddress, ExchangeError: ExchangeError1, BadRequest: BadRequest, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded, BadSymbol: BadSymbol, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, ArgumentsRequired: ArgumentsRequired1, OrderNotFound: OrderNotFound, PermissionDenied: PermissionDenied, NotSupported: NotSupported } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            // ---------------------------------------------------------------------------
            module.exports = class mexc extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'mexc',
                        'name': 'MEXC Global',
                        'countries': [
                            'SC'
                        ],
                        'rateLimit': 50,
                        'version': 'v2',
                        'certified': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': true,
                            'future': false,
                            'option': false,
                            'addMargin': true,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createMarketOrder': false,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': false,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchCanceledOrders': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDepositAddressesByNetwork': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': true,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': true,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': true,
                            'fetchLeverage': undefined,
                            'fetchLeverageTiers': true,
                            'fetchMarketLeverageTiers': 'emulated',
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': true,
                            'fetchPositions': true,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': true,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransfer': true,
                            'fetchTransfers': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': true,
                            'setLeverage': true,
                            'setMarginMode': false,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '1d': '1d',
                            '1w': '1w',
                            '1M': '1M'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/137283979-8b2a818d-8633-461b-bfca-de89e8c446b2.jpg',
                            'api': {
                                'spot': {
                                    'public': 'https://www.mexc.com/open/api/v2',
                                    'private': 'https://www.mexc.com/open/api/v2'
                                },
                                'contract': {
                                    'public': 'https://contract.mexc.com/api/v1/contract',
                                    'private': 'https://contract.mexc.com/api/v1/private'
                                }
                            },
                            'www': 'https://www.mexc.com/',
                            'doc': [
                                'https://mxcdevelop.github.io/APIDoc/'
                            ],
                            'fees': [
                                'https://www.mexc.com/fee'
                            ],
                            'referral': 'https://m.mexc.com/auth/signup?inviteCode=1FQ1G'
                        },
                        'api': {
                            'contract': {
                                'public': {
                                    'get': {
                                        'ping': 2,
                                        'detail': 2,
                                        'support_currencies': 2,
                                        'depth/{symbol}': 2,
                                        'depth_commits/{symbol}/{limit}': 2,
                                        'index_price/{symbol}': 2,
                                        'fair_price/{symbol}': 2,
                                        'funding_rate/{symbol}': 2,
                                        'kline/{symbol}': 2,
                                        'kline/index_price/{symbol}': 2,
                                        'kline/fair_price/{symbol}': 2,
                                        'deals/{symbol}': 2,
                                        'ticker': 2,
                                        'risk_reverse': 2,
                                        'risk_reverse/history': 2,
                                        'funding_rate/history': 2
                                    }
                                },
                                'private': {
                                    'get': {
                                        'account/assets': 2,
                                        'account/asset/{currency}': 2,
                                        'account/transfer_record': 2,
                                        'position/list/history_positions': 2,
                                        'position/open_positions': 2,
                                        'position/funding_records': 2,
                                        'order/list/open_orders/{symbol}': 2,
                                        'order/list/history_orders': 2,
                                        'order/external/{symbol}/{external_oid}': 2,
                                        'order/get/{order_id}': 2,
                                        'order/batch_query': 8,
                                        'order/deal_details/{order_id}': 2,
                                        'order/list/order_deals': 2,
                                        'planorder/list/orders': 2,
                                        'stoporder/list/orders': 2,
                                        'stoporder/order_details/{stop_order_id}': 2,
                                        'account/risk_limit': 2,
                                        'account/tiered_fee_rate': 2
                                    },
                                    'post': {
                                        'position/change_margin': 2,
                                        'position/change_leverage': 2,
                                        'order/submit': 2,
                                        'order/submit_batch': 40,
                                        'order/cancel': 2,
                                        'order/cancel_with_external': 2,
                                        'order/cancel_all': 2,
                                        'account/change_risk_level': 2,
                                        'planorder/place': 2,
                                        'planorder/cancel': 2,
                                        'planorder/cancel_all': 2,
                                        'stoporder/cancel': 2,
                                        'stoporder/cancel_all': 2,
                                        'stoporder/change_price': 2,
                                        'stoporder/change_plan_price': 2
                                    }
                                }
                            },
                            'spot': {
                                'public': {
                                    'get': {
                                        'market/symbols': 1,
                                        'market/coin/list': 2,
                                        'common/timestamp': 1,
                                        'common/ping': 1,
                                        'market/ticker': 1,
                                        'market/depth': 1,
                                        'market/deals': 1,
                                        'market/kline': 1,
                                        'market/api_default_symbols': 2
                                    }
                                },
                                'private': {
                                    'get': {
                                        'account/info': 1,
                                        'order/open_orders': 1,
                                        'order/list': 1,
                                        'order/query': 1,
                                        'order/deals': 1,
                                        'order/deal_detail': 1,
                                        'asset/deposit/address/list': 2,
                                        'asset/deposit/list': 2,
                                        'asset/address/list': 2,
                                        'asset/withdraw/list': 2,
                                        'asset/internal/transfer/record': 10,
                                        'account/balance': 10,
                                        'asset/internal/transfer/info': 10,
                                        'market/api_symbols': 2
                                    },
                                    'post': {
                                        'order/place': 1,
                                        'order/place_batch': 1,
                                        'asset/withdraw': 2,
                                        'asset/internal/transfer': 10
                                    },
                                    'delete': {
                                        'order/cancel': 1,
                                        'order/cancel_by_symbol': 1,
                                        'asset/withdraw': 2
                                    }
                                }
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': 0.002,
                                'taker': 0.002
                            }
                        },
                        'options': {
                            'timeframes': {
                                'spot': {
                                    '1m': '1m',
                                    '5m': '5m',
                                    '15m': '15m',
                                    '30m': '30m',
                                    '1h': '1h',
                                    '1d': '1d',
                                    '1M': '1M'
                                },
                                'contract': {
                                    '1m': 'Min1',
                                    '5m': 'Min5',
                                    '15m': 'Min15',
                                    '30m': 'Min30',
                                    '1h': 'Min60',
                                    '4h': 'Hour4',
                                    '8h': 'Hour8',
                                    '1d': 'Day1',
                                    '1w': 'Week1',
                                    '1M': 'Month1'
                                }
                            },
                            'defaultType': 'spot',
                            'networks': {
                                'TRX': 'TRC-20',
                                'TRC20': 'TRC-20',
                                'ETH': 'ERC-20',
                                'ERC20': 'ERC-20',
                                'BEP20': 'BEP20(BSC)'
                            },
                            'accountsByType': {
                                'spot': 'MAIN',
                                'swap': 'CONTRACT'
                            },
                            'transfer': {
                                'accountsById': {
                                    'MAIN': 'spot',
                                    'CONTRACT': 'swap'
                                },
                                'status': {
                                    'SUCCESS': 'ok',
                                    'FAILED': 'failed',
                                    'WAIT': 'pending'
                                }
                            },
                            'fetchOrdersByState': {
                                'method': 'spotPrivateGetOrderList'
                            },
                            'cancelOrder': {
                                'method': 'spotPrivateDeleteOrderCancel'
                            }
                        },
                        'commonCurrencies': {
                            'BEYONDPROTOCOL': 'BEYOND',
                            'BIFI': 'BIFIF',
                            'BYN': 'BeyondFi',
                            'COFI': 'COFIX',
                            'DFI': 'DfiStarter',
                            'DFT': 'dFuture',
                            'DRK': 'DRK',
                            'EGC': 'Egoras Credit',
                            'FLUX1': 'FLUX',
                            'FLUX': 'FLUX1',
                            'FREE': 'FreeRossDAO',
                            'GMT': 'GMT Token',
                            'HERO': 'Step Hero',
                            'MIMO': 'Mimosa',
                            'PROS': 'Pros.Finance',
                            'SIN': 'Sin City Token',
                            'STEPN': 'GMT'
                        },
                        'exceptions': {
                            'exact': {
                                '400': BadRequest,
                                '401': AuthenticationError,
                                '402': AuthenticationError,
                                '403': PermissionDenied,
                                '429': RateLimitExceeded,
                                '703': PermissionDenied,
                                '1000': AccountNotEnabled,
                                '1002': InvalidOrder,
                                '10072': AuthenticationError,
                                '10073': AuthenticationError,
                                '10075': PermissionDenied,
                                '10101': InsufficientFunds,
                                '10216': InvalidAddress,
                                '10232': BadSymbol,
                                '30000': BadSymbol,
                                '30001': InvalidOrder,
                                '30002': InvalidOrder,
                                '30003': InvalidOrder,
                                '30004': InsufficientFunds,
                                '30005': InvalidOrder,
                                '30010': InvalidOrder,
                                '30016': BadSymbol,
                                '30019': InvalidOrder,
                                '30020': BadSymbol,
                                '30021': BadSymbol,
                                '33333': BadSymbol
                            },
                            'broad': {
                                'price and quantity must be positive': InvalidOrder
                            }
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTime', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPublicGetCommonTimestamp',
                        'swap': 'contractPublicGetPing'
                    });
                    const response = await this[method](this.extend(query));
                    //
                    // spot
                    //
                    //     {
                    //         "code":200,
                    //         "data":1633375641837
                    //     }
                    //
                    // contract
                    //
                    //     {
                    //         "success":true,
                    //         "code":0,
                    //         "data":1634095541710
                    //     }
                    //
                    return this.safeInteger(response, 'data');
                }
                async fetchStatus(params = {}) {
                    const response = await this.spotPublicGetCommonPing(params);
                    //
                    //     { "code":200 }
                    //
                    const code = this.safeInteger(response, 'code');
                    const status = code === 200 ? 'ok' : 'maintenance';
                    return {
                        'status': status,
                        'updated': this.milliseconds(),
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.spotPublicGetMarketCoinList(params);
                    //
                    //     {
                    //         "code":200,
                    //         "data":[
                    //             {
                    //                 "currency":"AGLD",
                    //                 "coins":[
                    //                     {
                    //                         "chain":"ERC20",
                    //                         "precision":18,
                    //                         "fee":8.09,
                    //                         "is_withdraw_enabled":true,
                    //                         "is_deposit_enabled":true,
                    //                         "deposit_min_confirm":16,
                    //                         "withdraw_limit_max":500000.0,
                    //                         "withdraw_limit_min":14.0
                    //                     }
                    //                 ],
                    //                 "full_name":"Adventure Gold"
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = {};
                    for(let i = 0; i < data.length; i++){
                        const currency = data[i];
                        const id = this.safeString(currency, 'currency');
                        const code = this.safeCurrencyCode(id);
                        const name = this.safeString(currency, 'full_name');
                        let currencyActive = false;
                        let currencyPrecision = undefined;
                        let currencyFee = undefined;
                        let currencyWithdrawMin = undefined;
                        let currencyWithdrawMax = undefined;
                        const networks = {};
                        const chains = this.safeValue(currency, 'coins', []);
                        let depositEnabled = false;
                        let withdrawEnabled = false;
                        for(let j = 0; j < chains.length; j++){
                            const chain = chains[j];
                            const networkId = this.safeString(chain, 'chain');
                            const network = this.safeNetwork(networkId);
                            const isDepositEnabled = this.safeValue(chain, 'is_deposit_enabled', false);
                            const isWithdrawEnabled = this.safeValue(chain, 'is_withdraw_enabled', false);
                            const active = isDepositEnabled && isWithdrawEnabled;
                            currencyActive = active || currencyActive;
                            const precisionDigits = this.safeInteger(chain, 'precision');
                            const precision = 1 / Math.pow(10, precisionDigits);
                            const withdrawMin = this.safeString(chain, 'withdraw_limit_min');
                            const withdrawMax = this.safeString(chain, 'withdraw_limit_max');
                            currencyWithdrawMin = currencyWithdrawMin === undefined ? withdrawMin : currencyWithdrawMin;
                            currencyWithdrawMax = currencyWithdrawMax === undefined ? withdrawMax : currencyWithdrawMax;
                            if (Precise.stringGt(currencyWithdrawMin, withdrawMin)) currencyWithdrawMin = withdrawMin;
                            if (Precise.stringLt(currencyWithdrawMax, withdrawMax)) currencyWithdrawMax = withdrawMax;
                            if (isDepositEnabled) depositEnabled = true;
                            if (isWithdrawEnabled) withdrawEnabled = true;
                            networks[network] = {
                                'info': chain,
                                'id': networkId,
                                'network': network,
                                'active': active,
                                'deposit': isDepositEnabled,
                                'withdraw': isWithdrawEnabled,
                                'fee': this.safeNumber(chain, 'fee'),
                                'precision': precision,
                                'limits': {
                                    'withdraw': {
                                        'min': withdrawMin,
                                        'max': withdrawMax
                                    }
                                }
                            };
                        }
                        const networkKeys = Object.keys(networks);
                        const networkKeysLength = networkKeys.length;
                        if (networkKeysLength === 1 || 'NONE' in networks) {
                            const defaultNetwork = this.safeValue2(networks, 'NONE', networkKeysLength - 1);
                            if (defaultNetwork !== undefined) {
                                currencyFee = defaultNetwork['fee'];
                                currencyPrecision = defaultNetwork['precision'];
                            }
                        }
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'name': name,
                            'active': currencyActive,
                            'deposit': depositEnabled,
                            'withdraw': withdrawEnabled,
                            'fee': currencyFee,
                            'precision': currencyPrecision,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': currencyWithdrawMin,
                                    'max': currencyWithdrawMax
                                }
                            },
                            'networks': networks
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const defaultType = this.safeString2(this.options, 'fetchMarkets', 'defaultType', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    const spot = type === 'spot';
                    const swap = type === 'swap';
                    if (!spot && !swap) throw new ExchangeError1(this.id + " does not support '" + type + "' type, set exchange.options['defaultType'] to 'spot', 'margin', 'delivery' or 'future'"); // eslint-disable-line quotes
                    if (spot) return await this.fetchSpotMarkets(query);
                    else if (swap) return await this.fetchContractMarkets(query);
                }
                async fetchContractMarkets(params = {}) {
                    const response = await this.contractPublicGetDetail(params);
                    //
                    //     {
                    //         "success":true,
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "symbol":"BTC_USDT",
                    //                 "displayName":"BTC_USDT永续",
                    //                 "displayNameEn":"BTC_USDT SWAP",
                    //                 "positionOpenType":3,
                    //                 "baseCoin":"BTC",
                    //                 "quoteCoin":"USDT",
                    //                 "settleCoin":"USDT",
                    //                 "contractSize":0.0001,
                    //                 "minLeverage":1,
                    //                 "maxLeverage":125,
                    //                 "priceScale":2,
                    //                 "volScale":0,
                    //                 "amountScale":4,
                    //                 "priceUnit":0.5,
                    //                 "volUnit":1,
                    //                 "minVol":1,
                    //                 "maxVol":1000000,
                    //                 "bidLimitPriceRate":0.1,
                    //                 "askLimitPriceRate":0.1,
                    //                 "takerFeeRate":0.0006,
                    //                 "makerFeeRate":0.0002,
                    //                 "maintenanceMarginRate":0.004,
                    //                 "initialMarginRate":0.008,
                    //                 "riskBaseVol":10000,
                    //                 "riskIncrVol":200000,
                    //                 "riskIncrMmr":0.004,
                    //                 "riskIncrImr":0.004,
                    //                 "riskLevelLimit":5,
                    //                 "priceCoefficientVariation":0.1,
                    //                 "indexOrigin":["BINANCE","GATEIO","HUOBI","MXC"],
                    //                 "state":0, // 0 enabled, 1 delivery, 2 completed, 3 offline, 4 pause
                    //                 "isNew":false,
                    //                 "isHot":true,
                    //                 "isHidden":false
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const id = this.safeString(market, 'symbol');
                        const baseId = this.safeString(market, 'baseCoin');
                        const quoteId = this.safeString(market, 'quoteCoin');
                        const settleId = this.safeString(market, 'settleCoin');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const settle = this.safeCurrencyCode(settleId);
                        const state = this.safeString(market, 'state');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote + ':' + settle,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': 'swap',
                            'spot': false,
                            'margin': false,
                            'swap': true,
                            'future': false,
                            'option': false,
                            'active': state === '0',
                            'contract': true,
                            'linear': true,
                            'inverse': false,
                            'taker': this.safeNumber(market, 'takerFeeRate'),
                            'maker': this.safeNumber(market, 'makerFeeRate'),
                            'contractSize': this.safeNumber(market, 'contractSize'),
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(market, 'volUnit'),
                                'price': this.safeNumber(market, 'priceUnit')
                            },
                            'limits': {
                                'leverage': {
                                    'min': this.safeNumber(market, 'minLeverage'),
                                    'max': this.safeNumber(market, 'maxLeverage')
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minVol'),
                                    'max': this.safeNumber(market, 'maxVol')
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchSpotMarkets(params = {}) {
                    const response = await this.spotPublicGetMarketSymbols(params);
                    //
                    //     {
                    //         "code":200,
                    //         "data":[
                    //             {
                    //                 "symbol":"DFD_USDT",
                    //                 "state":"ENABLED",
                    //                 "countDownMark":1,
                    //                 "vcoinName":"DFD",
                    //                 "vcoinStatus":1,
                    //                 "price_scale":4,
                    //                 "quantity_scale":2,
                    //                 "min_amount":"5", // not an amount = cost
                    //                 "max_amount":"5000000",
                    //                 "maker_fee_rate":"0.002",
                    //                 "taker_fee_rate":"0.002",
                    //                 "limited":true,
                    //                 "etf_mark":0,
                    //                 "symbol_partition":"ASSESS"
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const id = this.safeString(market, 'symbol');
                        const [baseId, quoteId] = id.split('_');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const priceScale = this.safeString(market, 'price_scale');
                        const quantityScale = this.safeString(market, 'quantity_scale');
                        const state = this.safeString(market, 'state');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': state === 'ENABLED',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.safeNumber(market, 'taker_fee_rate'),
                            'maker': this.safeNumber(market, 'maker_fee_rate'),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.parseNumber(this.parsePrecision(quantityScale)),
                                'price': this.parseNumber(this.parsePrecision(priceScale))
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_amount'),
                                    'max': this.safeNumber(market, 'max_amount')
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTickers', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPublicGetMarketTicker',
                        'swap': 'contractPublicGetTicker'
                    });
                    const response = await this[method](this.extend(query));
                    //
                    //     {
                    //         "success":true,
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "symbol":"NKN_USDT",
                    //                 "lastPrice":0.36199,
                    //                 "bid1":0.35908,
                    //                 "ask1":0.36277,
                    //                 "volume24":657754,
                    //                 "amount24":239024.53998,
                    //                 "holdVol":149969,
                    //                 "lower24Price":0.34957,
                    //                 "high24Price":0.37689,
                    //                 "riseFallRate":0.0117,
                    //                 "riseFallValue":0.00419,
                    //                 "indexPrice":0.36043,
                    //                 "fairPrice":0.36108,
                    //                 "fundingRate":0.000535,
                    //                 "maxBidPrice":0.43251,
                    //                 "minAskPrice":0.28834,
                    //                 "timestamp":1634163352075
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTickers(data, symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    let method = undefined;
                    if (market['spot']) method = 'spotPublicGetMarketTicker';
                    else if (market['swap']) method = 'contractPublicGetTicker';
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "code":200,
                    //         "data":[
                    //             {
                    //                 "symbol":"BTC_USDT",
                    //                 "volume":"880.821523",
                    //                 "high":"49496.95", // highest price over the past 24 hours
                    //                 "low":"46918.4", // lowest
                    //                 "bid":"49297.64", // current buying price == the best price you can sell for
                    //                 "ask":"49297.75", // current selling price == the best price you can buy for
                    //                 "open":"48764.9", // open price 24h ago
                    //                 "last":"49297.73", // last = close
                    //                 "time":1633378200000, // timestamp
                    //                 "change_rate":"0.0109265" // (last / open) - 1
                    //             }
                    //         ]
                    //     }
                    //
                    // swap / contract
                    //
                    //     {
                    //         "success":true,
                    //         "code":0,
                    //         "data":{
                    //             "symbol":"ETH_USDT",
                    //             "lastPrice":3581.3,
                    //             "bid1":3581.25,
                    //             "ask1":3581.5,
                    //             "volume24":4045530,
                    //             "amount24":141331823.5755,
                    //             "holdVol":5832946,
                    //             "lower24Price":3413.4,
                    //             "high24Price":3588.7,
                    //             "riseFallRate":0.0275,
                    //             "riseFallValue":95.95,
                    //             "indexPrice":3580.7852,
                    //             "fairPrice":3581.08,
                    //             "fundingRate":0.000063,
                    //             "maxBidPrice":3938.85,
                    //             "minAskPrice":3222.7,
                    //             "timestamp":1634162885016
                    //         }
                    //     }
                    //
                    if (market['spot']) {
                        const data = this.safeValue(response, 'data', []);
                        const ticker = this.safeValue(data, 0);
                        return this.parseTicker(ticker, market);
                    } else if (market['swap']) {
                        const data = this.safeValue(response, 'data', {});
                        return this.parseTicker(data, market);
                    }
                }
                parseTicker(ticker, market) {
                    //
                    // spot
                    //
                    //     {
                    //         "symbol":"BTC_USDT",
                    //         "volume":"880.821523",
                    //         "high":"49496.95",
                    //         "low":"46918.4",
                    //         "bid":"49297.64",
                    //         "ask":"49297.75",
                    //         "open":"48764.9",
                    //         "last":"49297.73",
                    //         "time":1633378200000,
                    //         "change_rate":"0.0109265"
                    //     }
                    //
                    // contract
                    //
                    //     {
                    //         "symbol":"ETH_USDT",
                    //         "lastPrice":3581.3,
                    //         "bid1":3581.25,
                    //         "ask1":3581.5,
                    //         "volume24":4045530,
                    //         "amount24":141331823.5755,
                    //         "holdVol":5832946,
                    //         "lower24Price":3413.4,
                    //         "high24Price":3588.7,
                    //         "riseFallRate":0.0275,
                    //         "riseFallValue":95.95,
                    //         "indexPrice":3580.7852,
                    //         "fairPrice":3581.08,
                    //         "fundingRate":0.000063,
                    //         "maxBidPrice":3938.85,
                    //         "minAskPrice":3222.7,
                    //         "timestamp":1634162885016
                    //     }
                    //
                    const timestamp = this.safeInteger2(ticker, 'time', 'timestamp');
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const baseVolume = this.safeString2(ticker, 'volume', 'volume24');
                    const quoteVolume = this.safeString(ticker, 'amount24');
                    const open = this.safeString(ticker, 'open');
                    const last = this.safeString2(ticker, 'last', 'lastPrice');
                    const change = this.safeString(ticker, 'riseFallValue');
                    const riseFallRate = this.safeString(ticker, 'riseFallRate');
                    const percentage = Precise.stringAdd(riseFallRate, '1');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString2(ticker, 'high', 'high24Price'),
                        'low': this.safeString2(ticker, 'low', 'lower24Price'),
                        'bid': this.safeString2(ticker, 'bid', 'bid1'),
                        'bidVolume': undefined,
                        'ask': this.safeString2(ticker, 'ask', 'ask1'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': change,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    let method = undefined;
                    if (market['spot']) {
                        method = 'spotPublicGetMarketDepth';
                        if (limit === undefined) limit = 100; // the spot api requires a limit
                        request['depth'] = limit;
                    } else if (market['swap']) {
                        method = 'contractPublicGetDepthSymbol';
                        if (limit !== undefined) request['limit'] = limit;
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "code":200,
                    //         "data":{
                    //             "asks":[
                    //                 {"price":"49060.56","quantity":"0.099842"},
                    //                 {"price":"49060.58","quantity":"0.016003"},
                    //                 {"price":"49060.6","quantity":"0.023677"}
                    //             ],
                    //             "bids":[
                    //                 {"price":"49060.45","quantity":"1.693009"},
                    //                 {"price":"49060.44","quantity":"0.000843"},
                    //                 {"price":"49059.98","quantity":"0.735"},
                    //             ],
                    //             "version":"202454074",
                    //         }
                    //     }
                    //
                    // swap / contract
                    //
                    //     {
                    //         "success":true,
                    //         "code":0,
                    //         "data":{
                    //             "asks":[
                    //                 [3445.7,48379,1],
                    //                 [3445.75,34994,1],
                    //                 [3445.8,68634,2],
                    //             ],
                    //             "bids":[
                    //                 [3445.55,44081,1],
                    //                 [3445.5,24857,1],
                    //                 [3445.45,50272,1],
                    //             ],
                    //             "version":2827730444,
                    //             "timestamp":1634117846232
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const priceKey = market['spot'] ? 'price' : 0;
                    const amountKey = market['spot'] ? 'quantity' : 1;
                    const timestamp = this.safeInteger(data, 'timestamp');
                    const orderbook = this.parseOrderBook(data, symbol, timestamp, 'bids', 'asks', priceKey, amountKey);
                    orderbook['nonce'] = this.safeInteger(data, 'version');
                    return orderbook;
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 100
                    let method = undefined;
                    if (market['spot']) method = 'spotPublicGetMarketDeals';
                    else if (market['swap']) method = 'contractPublicGetDealsSymbol';
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "code":200,
                    //         "data":[
                    //             {"trade_time":1633381766725,"trade_price":"0.068981","trade_quantity":"0.005","trade_type":"BID"},
                    //             {"trade_time":1633381732705,"trade_price":"0.068979","trade_quantity":"0.006","trade_type":"BID"},
                    //             {"trade_time":1633381694604,"trade_price":"0.068975","trade_quantity":"0.011","trade_type":"ASK"},
                    //         ]
                    //     }
                    //
                    // swap / contract
                    //
                    //     {
                    //         "success":true,
                    //         "code":0,
                    //         "data":[
                    //             {"p":3598.85,"v":52,"T":1,"O":2,"M":2,"t":1634169038038},
                    //             {"p":3599.2,"v":15,"T":2,"O":3,"M":1,"t":1634169035603},
                    //             {"p":3600.15,"v":229,"T":2,"O":1,"M":2,"t":1634169026354},
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     spot
                    //
                    //     {
                    //         "trade_time":1633381766725,
                    //         "trade_price":"0.068981",
                    //         "trade_quantity":"0.005",
                    //         "trade_type":"BID"
                    //     }
                    //
                    //     swap / contract
                    //
                    //     {
                    //         "p":3598.85,
                    //         "v":52,
                    //         "T":1, // 1 buy, 2 sell
                    //         "O":2, // 1 opens a position, 2 does not open a position
                    //         "M":2, // self-trading, 1 yes, 2 no
                    //         "t":1634169038038
                    //     }
                    //
                    // private fetchMyTrades, fetchOrderTrades
                    //
                    //     {
                    //         "id":"b160b8f072d9403e96289139d5544809",
                    //         "symbol":"USDC_USDT",
                    //         "quantity":"150",
                    //         "price":"0.9997",
                    //         "amount":"149.955",
                    //         "fee":"0.29991",
                    //         "trade_type":"ASK",
                    //         "order_id":"d798765285374222990bbd14decb86cd",
                    //         "is_taker":true,
                    //         "fee_currency":"USDT",
                    //         "create_time":1633984904000
                    //     }
                    //
                    let timestamp = this.safeInteger2(trade, 'create_time', 'trade_time');
                    timestamp = this.safeInteger(trade, 't', timestamp);
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    let priceString = this.safeString2(trade, 'price', 'trade_price');
                    priceString = this.safeString(trade, 'p', priceString);
                    let amountString = this.safeString2(trade, 'quantity', 'trade_quantity');
                    amountString = this.safeString(trade, 'v', amountString);
                    const costString = this.safeString(trade, 'amount');
                    let side = this.safeString2(trade, 'trade_type', 'T');
                    if (side === 'BID' || side === '1') side = 'buy';
                    else if (side === 'ASK' || side === '2') side = 'sell';
                    let id = this.safeString2(trade, 'id', 'trade_time');
                    if (id === undefined) {
                        id = this.safeString(trade, 't', id);
                        if (id !== undefined) id += '-' + market['id'] + '-' + amountString;
                    }
                    const feeCostString = this.safeString(trade, 'fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'fee_currency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    const orderId = this.safeString(trade, 'order_id');
                    const isTaker = this.safeValue(trade, 'is_taker', true);
                    const takerOrMaker = isTaker ? 'taker' : 'maker';
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.spotPublicGetMarketSymbols(params);
                    //
                    //     {
                    //         "code":200,
                    //         "data":[
                    //             {
                    //                 "symbol":"DFD_USDT",
                    //                 "state":"ENABLED",
                    //                 "countDownMark":1,
                    //                 "vcoinName":"DFD",
                    //                 "vcoinStatus":1,
                    //                 "price_scale":4,
                    //                 "quantity_scale":2,
                    //                 "min_amount":"5", // not an amount = cost
                    //                 "max_amount":"5000000",
                    //                 "maker_fee_rate":"0.002",
                    //                 "taker_fee_rate":"0.002",
                    //                 "limited":true,
                    //                 "etf_mark":0,
                    //                 "symbol_partition":"ASSESS"
                    //             },
                    //             ...
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = {};
                    for(let i = 0; i < data.length; i++){
                        const fee = data[i];
                        const marketId = this.safeString(fee, 'symbol');
                        const market = this.safeMarket(marketId, undefined, '_');
                        const symbol = market['symbol'];
                        result[symbol] = {
                            'info': fee,
                            'symbol': symbol,
                            'maker': this.safeNumber(fee, 'maker_fee_rate'),
                            'taker': this.safeNumber(fee, 'taker_fee_rate'),
                            'percentage': true,
                            'tierBased': false
                        };
                    }
                    return result;
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const options = this.safeValue(this.options, 'timeframes', {});
                    const timeframes = this.safeValue(options, market['type'], {});
                    const timeframeValue = this.safeString(timeframes, timeframe);
                    if (timeframeValue === undefined) throw new NotSupported(this.id + ' fetchOHLCV() does not support ' + timeframe + ' timeframe for ' + market['type'] + ' markets');
                    const request = {
                        'symbol': market['id'],
                        'interval': timeframeValue
                    };
                    let method = undefined;
                    if (market['spot']) {
                        method = 'spotPublicGetMarketKline';
                        if (since !== undefined) request['start_time'] = parseInt(since / 1000);
                        if (limit !== undefined) request['limit'] = limit; // default 100
                    } else if (market['swap']) {
                        method = 'contractPublicGetKlineSymbol';
                        if (since !== undefined) request['start'] = parseInt(since / 1000);
                    // request['end'] = this.seconds ();
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "code":200,
                    //         "data":[
                    //             [1633377000,"49227.47","49186.21","49227.47","49169.48","0.5984809999999999","29434.259665989997"],
                    //             [1633377060,"49186.21","49187.03","49206.64","49169.18","0.3658478","17990.651234393"],
                    //             [1633377120,"49187.03","49227.2","49227.2","49174.4","0.0687651","3382.353190352"],
                    //         ],
                    //     }
                    //
                    // swap / contract
                    //
                    //     {
                    //         "success":true,
                    //         "code":0,
                    //         "data":{
                    //             "time":[1634052300,1634052360,1634052420],
                    //             "open":[3492.2,3491.3,3495.65],
                    //             "close":[3491.3,3495.65,3495.2],
                    //             "high":[3495.85,3496.55,3499.4],
                    //             "low":[3491.15,3490.9,3494.2],
                    //             "vol":[1740.0,351.0,314.0],
                    //             "amount":[60793.623,12260.4885,10983.1375],
                    //         }
                    //     }
                    //
                    if (market['spot']) {
                        const data = this.safeValue(response, 'data', []);
                        return this.parseOHLCVs(data, market, timeframe, since, limit);
                    } else if (market['swap']) {
                        const data = this.safeValue(response, 'data', {});
                        const result = this.convertTradingViewToOHLCV(data, 'time', 'open', 'high', 'low', 'close', 'vol');
                        return this.parseOHLCVs(result, market, timeframe, since, limit);
                    }
                }
                parseOHLCV(ohlcv, market) {
                    //
                    // the ordering in spot candles is OCHLV
                    //
                    //     [
                    //         1633377000, // 0 timestamp (unix seconds)
                    //         "49227.47", // 1 open price
                    //         "49186.21", // 2 closing price
                    //         "49227.47", // 3 high
                    //         "49169.48", // 4 low
                    //         "0.5984809999999999", // 5 base volume
                    //         "29434.259665989997", // 6 quote volume
                    //     ]
                    //
                    // the ordering in swap / contract candles is OHLCV
                    //
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, market['spot'] ? 3 : 2),
                        this.safeNumber(ohlcv, market['spot'] ? 4 : 3),
                        this.safeNumber(ohlcv, market['spot'] ? 2 : 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchPremiumIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'premiumIndex'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'index'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchMarkOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'mark'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchBalance', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPrivateGetAccountInfo',
                        'margin': 'spotPrivateGetAccountInfo',
                        'swap': 'contractPrivateGetAccountAssets'
                    });
                    const spot = marketType === 'spot';
                    const response = await this[method](query);
                    //
                    // spot
                    //
                    //     {
                    //         code: "200",
                    //         data: {
                    //             USDC: { frozen: "0", available: "150" }
                    //         }
                    //     }
                    //
                    // swap / contract
                    //
                    //     {
                    //         "success":true,
                    //         "code":0,
                    //         "data":[
                    //             {"currency":"BSV","positionMargin":0,"availableBalance":0,"cashBalance":0,"frozenBalance":0,"equity":0,"unrealized":0,"bonus":0},
                    //             {"currency":"BCH","positionMargin":0,"availableBalance":0,"cashBalance":0,"frozenBalance":0,"equity":0,"unrealized":0,"bonus":0},
                    //             {"currency":"CRV","positionMargin":0,"availableBalance":0,"cashBalance":0,"frozenBalance":0,"equity":0,"unrealized":0,"bonus":0},
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const currentTime = this.milliseconds();
                    const result = {
                        'info': response,
                        'timestamp': currentTime,
                        'datetime': this.iso8601(currentTime)
                    };
                    if (spot) {
                        const currencyIds = Object.keys(data);
                        for(let i = 0; i < currencyIds.length; i++){
                            const currencyId = currencyIds[i];
                            const code = this.safeCurrencyCode(currencyId);
                            const balance = this.safeValue(data, currencyId, {});
                            const account = this.account();
                            account['free'] = this.safeString(balance, 'available');
                            account['used'] = this.safeString(balance, 'frozen');
                            result[code] = account;
                        }
                    } else for(let i = 0; i < data.length; i++){
                        const balance = data[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'availableBalance');
                        account['used'] = this.safeString(balance, 'frozenBalance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                safeNetwork(networkId) {
                    if (networkId.indexOf('BSC') >= 0) return 'BEP20';
                    const parts = networkId.split(' ');
                    networkId = parts.join('');
                    networkId = networkId.replace('-20', '20');
                    const networksById = {
                        'ETH': 'ETH',
                        'ERC20': 'ERC20',
                        'BEP20(BSC)': 'BEP20',
                        'TRX': 'TRC20'
                    };
                    return this.safeString(networksById, networkId, networkId);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {"chain":"ERC-20","address":"0x55cbd73db24eafcca97369e3f2db74b2490586e6"},
                    //     {"chain":"MATIC","address":"0x05aa3236f1970eae0f8feb17ec19435b39574d74"},
                    //     {"chain":"TRC20","address":"TGaPfhW41EXD3sAfs1grLF6DKfugfqANNw"},
                    //     {"chain":"SOL","address":"5FSpUKuh2gjw4mF89T2e7sEjzUA1SkRKjBChFqP43KhV"},
                    //     {"chain":"ALGO","address":"B3XTZND2JJTSYR7R2TQVCUDT4QSSYVAIZYDPWVBX34DGAYATBU3AUV43VU"}
                    //
                    //
                    const address = this.safeString(depositAddress, 'address');
                    const code = this.safeCurrencyCode(undefined, currency);
                    const networkId = this.safeString(depositAddress, 'chain');
                    const network = this.safeNetwork(networkId);
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': undefined,
                        'network': network,
                        'info': depositAddress
                    };
                }
                async fetchDepositAddressesByNetwork(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.spotPrivateGetAssetDepositAddressList(this.extend(request, params));
                    //
                    //     {
                    //         "code":200,
                    //         "data":{
                    //             "currency":"USDC",
                    //             "chains":[
                    //                 {"chain":"ERC-20","address":"0x55cbd73db24eafcca97369e3f2db74b2490586e6"},
                    //                 {"chain":"MATIC","address":"0x05aa3236f1970eae0f8feb17ec19435b39574d74"},
                    //                 {"chain":"TRC20","address":"TGaPfhW41EXD3sAfs1grLF6DKfugfqANNw"},
                    //                 {"chain":"SOL","address":"5FSpUKuh2gjw4mF89T2e7sEjzUA1SkRKjBChFqP43KhV"},
                    //                 {"chain":"ALGO","address":"B3XTZND2JJTSYR7R2TQVCUDT4QSSYVAIZYDPWVBX34DGAYATBU3AUV43VU"}
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const chains = this.safeValue(data, 'chains', []);
                    const depositAddresses = [];
                    for(let i = 0; i < chains.length; i++){
                        const depositAddress = this.parseDepositAddress(chains[i], currency);
                        depositAddresses.push(depositAddress);
                    }
                    return this.indexBy(depositAddresses, 'network');
                }
                async fetchDepositAddress(code, params = {}) {
                    const rawNetwork = this.safeStringUpper(params, 'network');
                    params = this.omit(params, 'network');
                    const response = await this.fetchDepositAddressesByNetwork(code, params);
                    const networks = this.safeValue(this.options, 'networks', {});
                    const network = this.safeString(networks, rawNetwork, rawNetwork);
                    let result = undefined;
                    if (network === undefined) {
                        result = this.safeValue(response, code);
                        if (result === undefined) {
                            const alias = this.safeString(networks, code, code);
                            result = this.safeValue(response, alias);
                            if (result === undefined) {
                                const defaultNetwork = this.safeString(this.options, 'defaultNetwork', 'ERC20');
                                result = this.safeValue(response, defaultNetwork);
                                if (result === undefined) {
                                    const values = Object.values(response);
                                    result = this.safeValue(values, 0);
                                    if (result === undefined) throw new InvalidAddress(this.id + ' fetchDepositAddress() cannot find deposit address for ' + code);
                                }
                            }
                        }
                        return result;
                    }
                    // TODO: add support for all aliases here
                    result = this.safeValue(response, rawNetwork);
                    if (result === undefined) throw new InvalidAddress(this.id + ' fetchDepositAddress() cannot find ' + network + ' deposit address for ' + code);
                    return result;
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) request['start_time'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.spotPrivateGetAssetDepositList(this.extend(request, params));
                    //
                    //     {
                    //         "code":200,
                    //         "data":{
                    //             "page_size":20,
                    //             "total_page":1,
                    //             "total_size":1,
                    //             "page_num":1,
                    //             "result_list":[
                    //                 {
                    //                     "currency":"USDC",
                    //                     "amount":150.0,
                    //                     "fee":0.0,
                    //                     "confirmations":19,
                    //                     "address":"0x55cbd73db24eafcca97369e3f2db74b2490586e6",
                    //                     "state":"SUCCESS",
                    //                     "tx_id":"0xc65a9b09e1b71def81bf8bb3ec724c0c1b2b4c82200c8c142e4ea4c1469fd789:0",
                    //                     "require_confirmations":12,
                    //                     "create_time":"2021-10-11T18:58:25.000+00:00",
                    //                     "update_time":"2021-10-11T19:01:06.000+00:00"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const resultList = this.safeValue(data, 'result_list', []);
                    return this.parseTransactions(resultList, code, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) request['start_time'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.spotPrivateGetAssetWithdrawList(this.extend(request, params));
                    //
                    //     {
                    //         "code":200,
                    //         "data":{
                    //             "page_size":20,
                    //             "total_page":1,
                    //             "total_size":1,
                    //             "page_num":1,
                    //             "result_list":[
                    //                 {
                    //                     "id":"4b450616042a48c99dd45cacb4b092a7",
                    //                     "currency":"USDT-TRX",
                    //                     "address":"TRHKnx74Gb8UVcpDCMwzZVe4NqXfkdtPak",
                    //                     "amount":30.0,
                    //                     "fee":1.0,
                    //                     "remark":"this is my first withdrawal remark",
                    //                     "state":"WAIT",
                    //                     "create_time":"2021-10-11T20:45:08.000+00:00"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const resultList = this.safeValue(data, 'result_list', []);
                    return this.parseTransactions(resultList, code, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "currency":"USDC",
                    //         "amount":150.0,
                    //         "fee":0.0,
                    //         "confirmations":19,
                    //         "address":"0x55cbd73db24eafcca97369e3f2db74b2490586e6",
                    //         "state":"SUCCESS",
                    //         "tx_id":"0xc65a9b09e1b71def81bf8bb3ec724c0c1b2b4c82200c8c142e4ea4c1469fd789:0",
                    //         "require_confirmations":12,
                    //         "create_time":"2021-10-11T18:58:25.000+00:00",
                    //         "update_time":"2021-10-11T19:01:06.000+00:00"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "id":"4b450616042a48c99dd45cacb4b092a7",
                    //         "currency":"USDT-TRX",
                    //         "address":"TRHKnx74Gb8UVcpDCMwzZVe4NqXfkdtPak",
                    //         "amount":30.0,
                    //         "fee":1.0,
                    //         "remark":"this is my first withdrawal remark",
                    //         "state":"WAIT",
                    //         "create_time":"2021-10-11T20:45:08.000+00:00"
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const type = id === undefined ? 'deposit' : 'withdrawal';
                    const timestamp = this.parse8601(this.safeString(transaction, 'create_time'));
                    const updated = this.parse8601(this.safeString(transaction, 'update_time'));
                    let currencyId = this.safeString(transaction, 'currency');
                    let network = undefined;
                    if (currencyId !== undefined && currencyId.indexOf('-') >= 0) {
                        const parts = currencyId.split('-');
                        currencyId = this.safeString(parts, 0);
                        const networkId = this.safeString(parts, 1);
                        network = this.safeNetwork(networkId);
                    }
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    let amountString = this.safeString(transaction, 'amount');
                    const address = this.safeString(transaction, 'address');
                    const txid = this.safeString(transaction, 'tx_id');
                    let fee = undefined;
                    const feeCostString = this.safeString(transaction, 'fee');
                    if (feeCostString !== undefined) fee = {
                        'cost': this.parseNumber(feeCostString),
                        'currency': code
                    };
                    if (type === 'withdrawal') // mexc withdrawal amount includes the fee
                    amountString = Precise.stringSub(amountString, feeCostString);
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': this.parseNumber(amountString),
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'WAIT': 'pending',
                        'WAIT_PACKAGING': 'pending',
                        'SUCCESS': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.fetchPositions(this.extend(request, params));
                    const firstPosition = this.safeValue(response, 0);
                    return this.parsePosition(firstPosition, market);
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.contractPrivateGetPositionOpenPositions(params);
                    //
                    //     {
                    //         "success": true,
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "positionId": 1394650,
                    //                 "symbol": "ETH_USDT",
                    //                 "positionType": 1,
                    //                 "openType": 1,
                    //                 "state": 1,
                    //                 "holdVol": 1,
                    //                 "frozenVol": 0,
                    //                 "closeVol": 0,
                    //                 "holdAvgPrice": 1217.3,
                    //                 "openAvgPrice": 1217.3,
                    //                 "closeAvgPrice": 0,
                    //                 "liquidatePrice": 1211.2,
                    //                 "oim": 0.1290338,
                    //                 "im": 0.1290338,
                    //                 "holdFee": 0,
                    //                 "realised": -0.0073,
                    //                 "leverage": 100,
                    //                 "createTime": 1609991676000,
                    //                 "updateTime": 1609991676000,
                    //                 "autoAddIm": false
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parsePositions(data);
                }
                parsePosition(position, market) {
                    //
                    //     {
                    //         "positionId": 1394650,
                    //         "symbol": "ETH_USDT",
                    //         "positionType": 1,
                    //         "openType": 1,
                    //         "state": 1,
                    //         "holdVol": 1,
                    //         "frozenVol": 0,
                    //         "closeVol": 0,
                    //         "holdAvgPrice": 1217.3,
                    //         "openAvgPrice": 1217.3,
                    //         "closeAvgPrice": 0,
                    //         "liquidatePrice": 1211.2,
                    //         "oim": 0.1290338,
                    //         "im": 0.1290338,
                    //         "holdFee": 0,
                    //         "realised": -0.0073,
                    //         "leverage": 100,
                    //         "createTime": 1609991676000,
                    //         "updateTime": 1609991676000,
                    //         "autoAddIm": false
                    //     }
                    //
                    market = this.safeMarket(this.safeString(position, 'symbol'), market);
                    const symbol = market['symbol'];
                    const contracts = this.safeString(position, 'holdVol');
                    const entryPrice = this.safeNumber(position, 'openAvgPrice');
                    const initialMargin = this.safeString(position, 'im');
                    const rawSide = this.safeString(position, 'positionType');
                    const side = rawSide === '1' ? 'long' : 'short';
                    const openType = this.safeString(position, 'margin_mode');
                    const marginMode = openType === '1' ? 'isolated' : 'cross';
                    const leverage = this.safeString(position, 'leverage');
                    const liquidationPrice = this.safeNumber(position, 'liquidatePrice');
                    const timestamp = this.safeNumber(position, 'updateTime');
                    return {
                        'info': position,
                        'symbol': symbol,
                        'contracts': this.parseNumber(contracts),
                        'contractSize': undefined,
                        'entryPrice': entryPrice,
                        'collateral': undefined,
                        'side': side,
                        'unrealizedProfit': undefined,
                        'leverage': this.parseNumber(leverage),
                        'percentage': undefined,
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'notional': undefined,
                        'markPrice': undefined,
                        'liquidationPrice': liquidationPrice,
                        'initialMargin': this.parseNumber(initialMargin),
                        'initialMarginPercentage': undefined,
                        'maintenanceMargin': undefined,
                        'maintenanceMarginPercentage': undefined,
                        'marginRatio': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    };
                }
                parsePositions(positions) {
                    const result = [];
                    for(let i = 0; i < positions.length; i++)result.push(this.parsePosition(positions[i]));
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('createOrder', market, params);
                    if (marketType === 'spot') return await this.createSpotOrder(symbol, type, side, amount, price, query);
                    else if (marketType === 'swap') return await this.createSwapOrder(symbol, type, side, amount, price, query);
                }
                async createSpotOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let orderSide = undefined;
                    if (side === 'buy') orderSide = 'BID';
                    else if (side === 'sell') orderSide = 'ASK';
                    let orderType = type.toUpperCase();
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    if (postOnly) orderType = 'POST_ONLY';
                    else if (orderType === 'LIMIT') orderType = 'LIMIT_ORDER';
                    else if (orderType !== 'POST_ONLY' && orderType !== 'IMMEDIATE_OR_CANCEL') throw new InvalidOrder(this.id + ' createOrder() does not support ' + type + ' order type, specify one of LIMIT, LIMIT_ORDER, POST_ONLY or IMMEDIATE_OR_CANCEL');
                    const request = {
                        'symbol': market['id'],
                        'price': this.priceToPrecision(symbol, price),
                        'quantity': this.amountToPrecision(symbol, amount),
                        'trade_type': orderSide,
                        'order_type': orderType
                    };
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client_order_id');
                    if (clientOrderId !== undefined) request['client_order_id'] = clientOrderId;
                    params = this.omit(params, [
                        'type',
                        'clientOrderId',
                        'client_order_id',
                        'postOnly'
                    ]);
                    const response = await this.spotPrivatePostOrderPlace(this.extend(request, params));
                    //
                    //     {"code":200,"data":"2ff3163e8617443cb9c6fc19d42b1ca4"}
                    //
                    return this.parseOrder(response, market);
                }
                async createSwapOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const openType = this.safeInteger(params, 'openType');
                    if (openType === undefined) throw new ArgumentsRequired1(this.id + ' createSwapOrder() requires an integer openType parameter, 1 for isolated margin, 2 for cross margin');
                    if (type !== 'limit' && type !== 'market' && type !== 1 && type !== 2 && type !== 3 && type !== 4 && type !== 5 && type !== 6) throw new InvalidOrder(this.id + ' createSwapOrder() order type must either limit, market, or 1 for limit orders, 2 for post-only orders, 3 for IOC orders, 4 for FOK orders, 5 for market orders or 6 to convert market price to current price');
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    if (postOnly) type = 2;
                    else if (type === 'limit') type = 1;
                    else if (type === 'market') type = 6;
                    if (side !== 1 && side !== 2 && side !== 3 && side !== 4) throw new InvalidOrder(this.id + ' createSwapOrder() order side must be 1 open long, 2 close short, 3 open short or 4 close long');
                    const request = {
                        'symbol': market['id'],
                        // 'price': parseFloat (this.priceToPrecision (symbol, price)),
                        'vol': parseFloat(this.amountToPrecision(symbol, amount)),
                        // 'leverage': int, // required for isolated margin
                        'side': side,
                        //
                        // supported order types
                        //
                        //     1 limit
                        //     2 post only maker (PO)
                        //     3 transact or cancel instantly (IOC)
                        //     4 transact completely or cancel completely (FOK)
                        //     5 market orders
                        //     6 convert market price to current price
                        //
                        'type': type,
                        'openType': openType
                    };
                    let method = 'contractPrivatePostOrderSubmit';
                    const stopPrice = this.safeNumber2(params, 'triggerPrice', 'stopPrice');
                    params = this.omit(params, [
                        'stopPrice',
                        'triggerPrice'
                    ]);
                    if (stopPrice !== undefined) {
                        method = 'contractPrivatePostPlanorderPlace';
                        request['triggerPrice'] = this.priceToPrecision(symbol, stopPrice);
                        request['triggerType'] = this.safeInteger(params, 'triggerType', 1);
                        request['executeCycle'] = this.safeInteger(params, 'executeCycle', 1);
                        request['trend'] = this.safeInteger(params, 'trend', 1);
                        request['orderType'] = this.safeInteger(params, 'orderType', 1);
                    }
                    if (type !== 5 && type !== 6 && type !== 'market') request['price'] = parseFloat(this.priceToPrecision(symbol, price));
                    if (openType === 1) {
                        const leverage = this.safeInteger(params, 'leverage');
                        if (leverage === undefined) throw new ArgumentsRequired1(this.id + ' createSwapOrder() requires a leverage parameter for isolated margin orders');
                    }
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'externalOid');
                    if (clientOrderId !== undefined) request['externalOid'] = clientOrderId;
                    params = this.omit(params, [
                        'clientOrderId',
                        'externalOid',
                        'postOnly'
                    ]);
                    const response = await this[method](this.extend(request, params));
                    //
                    // Swap
                    //     {"code":200,"data":"2ff3163e8617443cb9c6fc19d42b1ca4"}
                    //
                    // Trigger
                    //     {"success":true,"code":0,"data":259208506303929856}
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const options = this.safeValue(this.options, 'cancelOrder', {});
                    const defaultMethod = this.safeString(options, 'method', 'spotPrivateDeleteOrderCancel');
                    let method = this.safeString(params, 'method', defaultMethod);
                    const stop = this.safeValue(params, 'stop');
                    let request = {};
                    if (market['type'] === 'spot') {
                        method = 'spotPrivateDeleteOrderCancel';
                        const clientOrderId = this.safeString2(params, 'clientOrderId', 'client_order_ids');
                        if (clientOrderId !== undefined) {
                            params = this.omit(params, [
                                'clientOrderId',
                                'client_order_ids'
                            ]);
                            request['client_order_ids'] = clientOrderId;
                        } else request['order_ids'] = id;
                    } else if (stop) {
                        method = 'contractPrivatePostPlanorderCancel';
                        request = [];
                        if (Array.isArray(id)) for(let i = 0; i < id.length; i++)request.push({
                            'symbol': market['id'],
                            'orderId': id[i]
                        });
                        else if (typeof id === 'string') request.push({
                            'symbol': market['id'],
                            'orderId': id
                        });
                    } else if (market['type'] === 'swap') {
                        method = 'contractPrivatePostOrderCancel';
                        request = [
                            id
                        ];
                    }
                    const response = await this[method](request); // dont extend with params, otherwise ARRAY will be turned into OBJECT
                    //
                    // Spot
                    //
                    //     {"code":200,"data":{"965245851c444078a11a7d771323613b":"success"}}
                    //
                    // Swap
                    //
                    //     {
                    //         "success": true,
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "orderId": 268726891790294528,
                    //                 "errorCode": 0,
                    //                 "errorMsg": "success"
                    //             }
                    //         ]
                    //     }
                    //
                    // Trigger
                    //
                    //     {
                    //         "success": true,
                    //         "code": 0
                    //     }
                    //
                    let data = this.safeValue(response, 'data', []);
                    if (stop) data = response;
                    return this.parseOrder(data, market);
                }
                parseOrderStatus(status, market) {
                    let statuses = {};
                    if (market['type'] === 'spot') statuses = {
                        'NEW': 'open',
                        'FILLED': 'closed',
                        'PARTIALLY_FILLED': 'open',
                        'CANCELED': 'canceled',
                        'PARTIALLY_CANCELED': 'canceled'
                    };
                    else if (market['type'] === 'swap') statuses = {
                        '2': 'open',
                        '3': 'closed',
                        '4': 'canceled'
                    };
                    else statuses = {
                        '1': 'open',
                        '2': 'canceled',
                        '3': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    // spot
                    //
                    //     {"code":200,"data":"2ff3163e8617443cb9c6fc19d42b1ca4"}
                    //
                    // swap / contract
                    //
                    //     { "success": true, "code": 0, "data": 102057569836905984 }
                    //
                    // spot fetchOpenOrders
                    //
                    //     {
                    //         "id":"965245851c444078a11a7d771323613b",
                    //         "symbol":"ETH_USDT",
                    //         "price":"3430",
                    //         "quantity":"0.01",
                    //         "state":"NEW",
                    //         "type":"BID",
                    //         "remain_quantity":"0.01",
                    //         "remain_amount":"34.3",
                    //         "create_time":1633989029039,
                    //         "client_order_id":"",
                    //         "order_type":"LIMIT_ORDER"
                    //     }
                    //
                    // swap fetchOpenOrders, fetchClosedOrders, fetchCanceledOrders
                    //
                    //     {
                    //         "orderId": "266578267438402048",
                    //         "symbol": "BTC_USDT",
                    //         "positionId": 0,
                    //         "price": 30000,
                    //         "vol": 11,
                    //         "leverage": 20,
                    //         "side": 1,
                    //         "category": 1,
                    //         "orderType": 1,
                    //         "dealAvgPrice": 0,
                    //         "dealVol": 0,
                    //         "orderMargin": 1.6896,
                    //         "takerFee": 0,
                    //         "makerFee": 0,
                    //         "profit": 0,
                    //         "feeCurrency": "USDT",
                    //         "openType": 1,
                    //         "state": 2,
                    //         "externalOid": "_m_8d673a31c47642d9a59993aca61ae394",
                    //         "errorCode": 0,
                    //         "usedMargin": 0,
                    //         "createTime": 1649227612000,
                    //         "updateTime": 1649227611000,
                    //         "positionMode": 1
                    //     }
                    //
                    // spot fetchClosedOrders, fetchCanceledOrders, fetchOrder
                    //
                    //     {
                    //         "id":"d798765285374222990bbd14decb86cd",
                    //         "symbol":"USDC_USDT",
                    //         "price":"0.9988",
                    //         "quantity":"150",
                    //         "state":"FILLED", // CANCELED
                    //         "type":"ASK", // BID
                    //         "deal_quantity":"150",
                    //         "deal_amount":"149.955",
                    //         "create_time":1633984904000,
                    //         "order_type":"MARKET_ORDER" // LIMIT_ORDER
                    //     }
                    //
                    // trigger fetchClosedOrders, fetchCanceledOrders, fetchOpenOrders
                    //
                    //     {
                    //         "id": "266583973507973632",
                    //         "symbol": "BTC_USDT",
                    //         "leverage": 20,
                    //         "side": 1,
                    //         "triggerPrice": 30000,
                    //         "price": 31000,
                    //         "vol": 11,
                    //         "openType": 1,
                    //         "triggerType": 2,
                    //         "state": 2,
                    //         "executeCycle": 87600,
                    //         "trend": 1,
                    //         "orderType": 1,
                    //         "errorCode": 0,
                    //         "createTime": 1649228972000,
                    //         "updateTime": 1649230287000
                    //     }
                    //
                    // spot cancelOrder
                    //
                    //     {"965245851c444078a11a7d771323613b":"success"}
                    //
                    // swap cancelOrder
                    //
                    //     {
                    //         "orderId": 268726891790294528,
                    //         "errorCode": 0,
                    //         "errorMsg": "success"
                    //     }
                    //
                    // trigger cancelOrder
                    //
                    //     {
                    //         "success": true,
                    //         "code": 0
                    //     }
                    //
                    let id = this.safeString2(order, 'data', 'id');
                    let status = undefined;
                    if (id === undefined) {
                        const keys = Object.keys(order);
                        id = this.safeString(keys, 0);
                        const state = this.safeString(order, id);
                        if (state === 'success') status = 'canceled';
                    }
                    const state = this.safeString(order, 'state');
                    const timestamp = this.safeInteger2(order, 'create_time', 'createTime');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString2(order, 'quantity', 'vol');
                    const remaining = this.safeString(order, 'remain_quantity');
                    const filled = this.safeString2(order, 'deal_quantity', 'dealVol');
                    const cost = this.safeString2(order, 'deal_amount', 'dealAvgPrice');
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const sideCheck = this.safeInteger(order, 'side');
                    let side = undefined;
                    const bidOrAsk = this.safeString(order, 'type');
                    if (bidOrAsk === 'BID') side = 'buy';
                    else if (bidOrAsk === 'ASK') side = 'sell';
                    if (sideCheck === 1) side = 'open long';
                    else if (side === 2) side = 'close short';
                    else if (side === 3) side = 'open short';
                    else if (side === 4) side = 'close long';
                    status = this.parseOrderStatus(state, market);
                    let clientOrderId = this.safeString2(order, 'client_order_id', 'orderId');
                    if (clientOrderId === '') clientOrderId = undefined;
                    let orderType = this.safeStringLower(order, 'order_type');
                    if (orderType !== undefined) orderType = orderType.replace('_order', '');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': this.safeInteger(order, 'updateTime'),
                        'status': status,
                        'symbol': symbol,
                        'type': orderType,
                        'timeInForce': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'average': undefined,
                        'amount': amount,
                        'cost': cost,
                        'filled': filled,
                        'remaining': remaining,
                        'fee': undefined,
                        'trades': undefined,
                        'info': order
                    }, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOpenOrders', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPrivateGetOrderOpenOrders',
                        'swap': 'contractPrivateGetOrderListOpenOrdersSymbol'
                    });
                    const stop = this.safeValue(params, 'stop');
                    if (stop) return await this.fetchOrdersByState('1', symbol, since, limit, params);
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     {
                    //         "code":200,
                    //         "data":[
                    //             {
                    //                 "id":"965245851c444078a11a7d771323613b",
                    //                 "symbol":"ETH_USDT",
                    //                 "price":"3430",
                    //                 "quantity":"0.01",
                    //                 "state":"NEW",
                    //                 "type":"BID",
                    //                 "remain_quantity":"0.01",
                    //                 "remain_amount":"34.3",
                    //                 "create_time":1633989029039,
                    //                 "client_order_id":"",
                    //                 "order_type":"LIMIT_ORDER"
                    //             },
                    //         ]
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "success": true,
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "orderId": "266578267438402048",
                    //                 "symbol": "BTC_USDT",
                    //                 "positionId": 0,
                    //                 "price": 30000,
                    //                 "vol": 11,
                    //                 "leverage": 20,
                    //                 "side": 1,
                    //                 "category": 1,
                    //                 "orderType": 1,
                    //                 "dealAvgPrice": 0,
                    //                 "dealVol": 0,
                    //                 "orderMargin": 1.6896,
                    //                 "takerFee": 0,
                    //                 "makerFee": 0,
                    //                 "profit": 0,
                    //                 "feeCurrency": "USDT",
                    //                 "openType": 1,
                    //                 "state": 2,
                    //                 "externalOid": "_m_8d673a31c47642d9a59993aca61ae394",
                    //                 "errorCode": 0,
                    //                 "usedMargin": 0,
                    //                 "createTime": 1649227612000,
                    //                 "updateTime": 1649227611000,
                    //                 "positionMode": 1
                    //             }
                    //         ]
                    //     }
                    //
                    // Trigger
                    //
                    //     {
                    //         "success": true,
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "id": "267198217203040768",
                    //                 "symbol": "BTC_USDT",
                    //                 "leverage": 20,
                    //                 "side": 1,
                    //                 "triggerPrice": 31111,
                    //                 "price": 31115,
                    //                 "vol": 2,
                    //                 "openType": 1,
                    //                 "triggerType": 2,
                    //                 "state": 1,
                    //                 "executeCycle": 87600,
                    //                 "trend": 1,
                    //                 "orderType": 1,
                    //                 "errorCode": 0,
                    //                 "createTime": 1649375419000,
                    //                 "updateTime": 1649375419000
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrder', market, params);
                    const request = {
                        'order_ids': id
                    };
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotPrivateGetOrderQuery',
                        'swap': 'contractPrivateGetOrderBatchQuery'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     {
                    //         "code":200,
                    //         "data":[
                    //             {
                    //                 "id":"2ff3163e8617443cb9c6fc19d42b1ca4",
                    //                 "symbol":"ETH_USDT",
                    //                 "price":"3420",
                    //                 "quantity":"0.01",
                    //                 "state":"CANCELED",
                    //                 "type":"BID",
                    //                 "deal_quantity":"0",
                    //                 "deal_amount":"0",
                    //                 "create_time":1633988662000,
                    //                 "order_type":"LIMIT_ORDER"
                    //             }
                    //         ]
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "success": true,
                    //         "code": 0,
                    //         "data": [
                    //             {
                    //                 "orderId": "259208506647860224",
                    //                 "symbol": "BTC_USDT",
                    //                 "positionId": 0,
                    //                 "price": 30000,
                    //                 "vol": 10,
                    //                 "leverage": 20,
                    //                 "side": 1,
                    //                 "category": 1,
                    //                 "orderType": 1,
                    //                 "dealAvgPrice": 0,
                    //                 "dealVol": 0,
                    //                 "orderMargin": 1.536,
                    //                 "takerFee": 0,
                    //                 "makerFee": 0,
                    //                 "profit": 0,
                    //                 "feeCurrency": "USDT",
                    //                 "openType": 1,
                    //                 "state": 4,
                    //                 "externalOid": "planorder_279208506303929856_10",
                    //                 "errorCode": 0,
                    //                 "usedMargin": 0,
                    //                 "createTime": 1647470524000,
                    //                 "updateTime": 1647470540000,
                    //                 "positionMode": 1
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const firstOrder = this.safeValue(data, 0);
                    if (firstOrder === undefined) throw new OrderNotFound(this.id + ' fetchOrder() could not find the order id ' + id);
                    return this.parseOrder(firstOrder, market);
                }
                async fetchOrdersByState(state, symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrdersByState() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        // 'start_time': since, // default 7 days, max 30 days
                        // 'limit': limit, // default 50, max 1000
                        // 'trade_type': 'BID', // BID / ASK
                        'states': state
                    };
                    const stop = this.safeValue(params, 'stop');
                    const limitRequest = stop ? 'page_size' : 'limit';
                    if (limit !== undefined) request[limitRequest] = limit;
                    if (since !== undefined) request['start_time'] = since;
                    const options = this.safeValue(this.options, 'fetchOrdersByState', {});
                    const defaultMethod = this.safeString(options, 'method', 'spotPrivateGetOrderList');
                    let method = this.safeString(params, 'method', defaultMethod);
                    method = this.getSupportedMapping(market['type'], {
                        'spot': 'spotPrivateGetOrderList',
                        'swap': 'contractPrivateGetOrderListHistoryOrders'
                    });
                    if (stop) method = 'contractPrivateGetPlanorderListOrders';
                    const query = this.omit(params, [
                        'method',
                        'stop'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchCanceledOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchCanceledOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const stop = this.safeValue(params, 'stop');
                    let state = 'CANCELED';
                    if (market['type'] === 'swap') state = '4';
                    else if (stop) state = '2';
                    return await this.fetchOrdersByState(state, symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchClosedOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const stop = this.safeValue(params, 'stop');
                    let state = 'FILLED';
                    if (stop || market['type'] === 'swap') state = '3';
                    return await this.fetchOrdersByState(state, symbol, since, limit, params);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    let method = this.getSupportedMapping(market['type'], {
                        'spot': 'spotPrivateDeleteOrderCancelBySymbol',
                        'swap': 'contractPrivatePostOrderCancelAll'
                    });
                    const stop = this.safeValue(params, 'stop');
                    if (stop) method = 'contractPrivatePostPlanorderCancelAll';
                    const query = this.omit(params, [
                        'method',
                        'stop'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     {
                    //         "code": 200,
                    //         "data": [
                    //             {
                    //                 "msg": "success",
                    //                 "order_id": "75ecf99feef04538b78e4622beaba6eb",
                    //                 "client_order_id": "a9329e86f2094b0d8b58e92c25029554"
                    //             },
                    //             {
                    //                 "msg": "success",
                    //                 "order_id": "139413c48f8b4c018f452ce796586bcf"
                    //             },
                    //             {
                    //                 "msg": "success",
                    //                 "order_id": "b58ef34c570e4917981f276d44091484"
                    //             }
                    //         ]
                    //     }
                    //
                    // Swap and Trigger
                    //
                    //     {
                    //         "success": true,
                    //         "code": 0
                    //     }
                    //
                    return response;
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['start_time'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.spotPrivateGetOrderDeals(this.extend(request, params));
                    //
                    //     {
                    //         "code":200,
                    //         "data":[
                    //             {
                    //                 "id":"b160b8f072d9403e96289139d5544809",
                    //                 "symbol":"USDC_USDT",
                    //                 "quantity":"150",
                    //                 "price":"0.9997",
                    //                 "amount":"149.955",
                    //                 "fee":"0.29991",
                    //                 "trade_type":"ASK",
                    //                 "order_id":"d798765285374222990bbd14decb86cd",
                    //                 "is_taker":true,
                    //                 "fee_currency":"USDT",
                    //                 "create_time":1633984904000
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'order_id': id
                    };
                    const response = await this.spotPrivateGetOrderDealDetail(this.extend(request, params));
                    //
                    //     {
                    //         "code":200,
                    //         "data":[
                    //             {
                    //                 "id":"b160b8f072d9403e96289139d5544809",
                    //                 "symbol":"USDC_USDT",
                    //                 "quantity":"150",
                    //                 "price":"0.9997",
                    //                 "amount":"149.955",
                    //                 "fee":"0.29991",
                    //                 "trade_type":"ASK",
                    //                 "order_id":"d798765285374222990bbd14decb86cd",
                    //                 "is_taker":true,
                    //                 "fee_currency":"USDT",
                    //                 "create_time":1633984904000
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async modifyMarginHelper(symbol, amount, addOrReduce, params = {}) {
                    const positionId = this.safeInteger(params, 'positionId');
                    if (positionId === undefined) throw new ArgumentsRequired1(this.id + ' modifyMarginHelper() requires a positionId parameter');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    amount = this.amountToPrecision(symbol, amount);
                    const request = {
                        'positionId': positionId,
                        'amount': amount,
                        'type': addOrReduce
                    };
                    const response = await this.contractPrivatePostPositionChangeMargin(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "code": 0
                    //     }
                    //
                    const type = addOrReduce === 'ADD' ? 'add' : 'reduce';
                    return this.extend(this.parseModifyMargin(response, market), {
                        'amount': this.safeNumber(amount),
                        'type': type
                    });
                }
                parseModifyMargin(data, market) {
                    const statusRaw = this.safeString(data, 'success');
                    const status = statusRaw === true ? 'ok' : 'failed';
                    return {
                        'info': data,
                        'type': undefined,
                        'amount': undefined,
                        'code': undefined,
                        'symbol': this.safeSymbol(undefined, market),
                        'status': status
                    };
                }
                async reduceMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 'SUB', params);
                }
                async addMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 'ADD', params);
                }
                async setLeverage(leverage, symbol, params = {}) {
                    const positionId = this.safeInteger(params, 'positionId');
                    if (positionId === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a positionId parameter');
                    await this.loadMarkets();
                    const request = {
                        'positionId': positionId,
                        'leverage': leverage
                    };
                    return await this.contractPrivatePostPositionChangeLeverage(this.extend(request, params));
                }
                async fetchTransfer(id, code, params = {}) {
                    const request = {
                        'transact_id': id
                    };
                    const response = await this.spotPrivateGetAssetInternalTransferInfo(this.extend(request, params));
                    //
                    //     {
                    //         code: '200',
                    //         data: {
                    //             currency: 'USDT',
                    //             amount: '1',
                    //             transact_id: '954877a2ef54499db9b28a7cf9ebcf41',
                    //             from: 'MAIN',
                    //             to: 'CONTRACT',
                    //             transact_state: 'SUCCESS'
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTransfer(data);
                }
                async fetchTransfers(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) request['start_time'] = since;
                    if (limit !== undefined) {
                        if (limit > 50) throw new ExchangeError1('This exchange supports a maximum limit of 50');
                        request['page-size'] = limit;
                    }
                    const response = await this.spotPrivateGetAssetInternalTransferRecord(this.extend(request, params));
                    //
                    //     {
                    //         code: '200',
                    //         data: {
                    //             total_page: '1',
                    //             total_size: '5',
                    //             result_list: [{
                    //                     currency: 'USDT',
                    //                     amount: '1',
                    //                     transact_id: '954877a2ef54499db9b28a7cf9ebcf41',
                    //                     from: 'MAIN',
                    //                     to: 'CONTRACT',
                    //                     transact_state: 'SUCCESS'
                    //                 },
                    //                 ...
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const resultList = this.safeValue(data, 'result_list', []);
                    return this.parseTransfers(resultList, currency, since, limit);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                    const toId = this.safeString(accountsByType, toAccount, toAccount);
                    const request = {
                        'currency': currency['id'],
                        'amount': amount,
                        'from': fromId,
                        'to': toId
                    };
                    const response = await this.spotPrivatePostAssetInternalTransfer(this.extend(request, params));
                    //
                    //     {
                    //         code: '200',
                    //         data: {
                    //             currency: 'USDT',
                    //             amount: '1',
                    //             transact_id: 'b60c1df8e7b24b268858003f374ecb75',
                    //             from: 'MAIN',
                    //             to: 'CONTRACT',
                    //             transact_state: 'WAIT'
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTransfer(data, currency);
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //         currency: 'USDT',
                    //         amount: '1',
                    //         transact_id: 'b60c1df8e7b24b268858003f374ecb75',
                    //         from: 'MAIN',
                    //         to: 'CONTRACT',
                    //         transact_state: 'WAIT'
                    //     }
                    //
                    const transferOptions = this.safeValue(this.options, 'transfer', {});
                    const transferStatusById = this.safeValue(transferOptions, 'status', {});
                    const currencyId = this.safeString(transfer, 'currency');
                    const id = this.safeString(transfer, 'transact_id');
                    const fromId = this.safeString(transfer, 'from');
                    const toId = this.safeString(transfer, 'to');
                    const accountsById = this.safeValue(transferOptions, 'accountsById', {});
                    const fromAccount = this.safeString(accountsById, fromId);
                    const toAccount = this.safeString(accountsById, toId);
                    const statusId = this.safeString(transfer, 'transact_state');
                    return {
                        'info': transfer,
                        'id': id,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'currency': this.safeCurrencyCode(currencyId, currency),
                        'amount': this.safeNumber(transfer, 'amount'),
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'status': this.safeString(transferStatusById, statusId)
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeString2(params, 'network', 'chain'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeString(networks, network, network); // handle ETH > ERC-20 alias
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (tag !== undefined) address += ':' + tag;
                    const request = {
                        'currency': currency['id'],
                        'address': address,
                        'amount': amount
                    };
                    if (network !== undefined) {
                        request['chain'] = network;
                        params = this.omit(params, [
                            'network',
                            'chain'
                        ]);
                    }
                    const response = await this.spotPrivatePostAssetWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "code":200,
                    //         "data": {
                    //             "withdrawId":"25fb2831fb6d4fc7aa4094612a26c81d"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return {
                        'info': data,
                        'id': this.safeString(data, 'withdrawId')
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const [section, access] = api;
                    let url = this.urls['api'][section][access] + '/' + this.implodeParams(path, params);
                    params = this.omit(params, this.extractParams(path));
                    if (access === 'public') {
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    } else {
                        this.checkRequiredCredentials();
                        const timestamp = this.milliseconds().toString();
                        let auth = '';
                        headers = {
                            'ApiKey': this.apiKey,
                            'Request-Time': timestamp,
                            'Content-Type': 'application/json'
                        };
                        if (method === 'POST') {
                            auth = this.json(params);
                            body = auth;
                        } else {
                            params = this.keysort(params);
                            if (Object.keys(params).length) {
                                auth += this.urlencode(params);
                                url += '?' + auth;
                            }
                        }
                        auth = this.apiKey + timestamp + auth;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha256');
                        headers['Signature'] = signature;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //     {"code":10232,"msg":"The currency not exist"}
                    //     {"code":10216,"msg":"No available deposit address"}
                    //
                    //     {
                    //         "success":true,
                    //         "code":0,
                    //         "data":1634095541710
                    //     }
                    //
                    const success = this.safeValue(response, 'success', false);
                    if (success === true) return;
                    const responseCode = this.safeString(response, 'code');
                    if (responseCode !== '200' && responseCode !== '0') {
                        const feedback = this.id + ' ' + body;
                        this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], responseCode, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
                async fetchFundingHistory(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['page_size'] = limit;
                    const response = await this.contractPrivateGetPositionFundingRecords(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "code": 0,
                    //         "data": {
                    //             "pageSize": 20,
                    //             "totalCount": 2,
                    //             "totalPage": 1,
                    //             "currentPage": 1,
                    //             "resultList": [
                    //                 {
                    //                     "id": 7423910,
                    //                     "symbol": "BTC_USDT",
                    //                     "positionType": 1,
                    //                     "positionValue": 29.30024,
                    //                     "funding": 0.00076180624,
                    //                     "rate": -0.000026,
                    //                     "settleTime": 1643299200000
                    //                 },
                    //                 {
                    //                     "id": 7416473,
                    //                     "symbol": "BTC_USDT",
                    //                     "positionType": 1,
                    //                     "positionValue": 28.9188,
                    //                     "funding": 0.0014748588,
                    //                     "rate": -0.000051,
                    //                     "settleTime": 1643270400000
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const resultList = this.safeValue(data, 'resultList', []);
                    const result = [];
                    for(let i = 0; i < resultList.length; i++){
                        const entry = resultList[i];
                        const timestamp = this.safeString(entry, 'settleTime');
                        result.push({
                            'info': entry,
                            'symbol': symbol,
                            'code': undefined,
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'id': this.safeNumber(entry, 'id'),
                            'amount': this.safeNumber(entry, 'funding')
                        });
                    }
                    return result;
                }
                parseFundingRate(fundingRate, market) {
                    //
                    //     {
                    //         "symbol": "BTC_USDT",
                    //         "fundingRate": 0.000014,
                    //         "maxFundingRate": 0.003,
                    //         "minFundingRate": -0.003,
                    //         "collectCycle": 8,
                    //         "nextSettleTime": 1643241600000,
                    //         "timestamp": 1643240373359
                    //     }
                    //
                    const nextFundingRate = this.safeNumber(fundingRate, 'fundingRate');
                    const nextFundingTimestamp = this.safeInteger(fundingRate, 'nextSettleTime');
                    const marketId = this.safeString(fundingRate, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.safeInteger(fundingRate, 'timestamp');
                    const datetime = this.iso8601(timestamp);
                    return {
                        'info': fundingRate,
                        'symbol': symbol,
                        'markPrice': undefined,
                        'indexPrice': undefined,
                        'interestRate': undefined,
                        'estimatedSettlePrice': undefined,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'fundingRate': undefined,
                        'fundingTimestamp': undefined,
                        'fundingDatetime': undefined,
                        'nextFundingRate': nextFundingRate,
                        'nextFundingTimestamp': nextFundingTimestamp,
                        'nextFundingDatetime': this.iso8601(nextFundingTimestamp),
                        'previousFundingRate': undefined,
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.contractPublicGetFundingRateSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "code": 0,
                    //         "data": {
                    //             "symbol": "BTC_USDT",
                    //             "fundingRate": 0.000014,
                    //             "maxFundingRate": 0.003,
                    //             "minFundingRate": -0.003,
                    //             "collectCycle": 8,
                    //             "nextSettleTime": 1643241600000,
                    //             "timestamp": 1643240373359
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'data', {});
                    return this.parseFundingRate(result, market);
                }
                async fetchFundingRateHistory(symbol, since, limit, params = {}) {
                    //
                    // Gets a history of funding rates with their timestamps
                    //  (param) symbol: Future currency pair
                    //  (param) limit: mexc limit is page_size default 20, maximum is 100
                    //  (param) since: not used by mexc
                    //  (param) params: Object containing more params for the request
                    //  return: [{symbol, fundingRate, timestamp, dateTime}]
                    //
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchFundingRateHistory() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['page_size'] = limit;
                    const response = await this.contractPublicGetFundingRateHistory(this.extend(request, params));
                    //
                    // {
                    //     "success": true,
                    //     "code": 0,
                    //     "data": {
                    //         "pageSize": 2,
                    //         "totalCount": 21,
                    //         "totalPage": 11,
                    //         "currentPage": 1,
                    //         "resultList": [
                    //             {
                    //                 "symbol": "BTC_USDT",
                    //                 "fundingRate": 0.000266,
                    //                 "settleTime": 1609804800000
                    //             },
                    //             {
                    //                 "symbol": "BTC_USDT",
                    //                 "fundingRate": 0.00029,
                    //                 "settleTime": 1609776000000
                    //             }
                    //         ]
                    //     }
                    // }
                    //
                    const data = this.safeValue(response, 'data');
                    const result = this.safeValue(data, 'resultList');
                    const rates = [];
                    for(let i = 0; i < result.length; i++){
                        const entry = result[i];
                        const marketId = this.safeString(entry, 'symbol');
                        const symbol = this.safeSymbol(marketId);
                        const timestamp = this.safeString(entry, 'settleTime');
                        rates.push({
                            'info': entry,
                            'symbol': symbol,
                            'fundingRate': this.safeNumber(entry, 'fundingRate'),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp)
                        });
                    }
                    const sorted = this.sortBy(rates, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, market['symbol'], since, limit);
                }
                async fetchLeverageTiers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.contractPublicGetDetail(params);
                    //
                    //     {
                    //         "success":true,
                    //         "code":0,
                    //         "data":[
                    //             {
                    //                 "symbol": "BTC_USDT",
                    //                 "displayName": "BTC_USDT永续",
                    //                 "displayNameEn": "BTC_USDT SWAP",
                    //                 "positionOpenType": 3,
                    //                 "baseCoin": "BTC",
                    //                 "quoteCoin": "USDT",
                    //                 "settleCoin": "USDT",
                    //                 "contractSize": 0.0001,
                    //                 "minLeverage": 1,
                    //                 "maxLeverage": 125,
                    //                 "priceScale": 2,
                    //                 "volScale": 0,
                    //                 "amountScale": 4,
                    //                 "priceUnit": 0.5,
                    //                 "volUnit": 1,
                    //                 "minVol": 1,
                    //                 "maxVol": 1000000,
                    //                 "bidLimitPriceRate": 0.1,
                    //                 "askLimitPriceRate": 0.1,
                    //                 "takerFeeRate": 0.0006,
                    //                 "makerFeeRate": 0.0002,
                    //                 "maintenanceMarginRate": 0.004,
                    //                 "initialMarginRate": 0.008,
                    //                 "riskBaseVol": 10000,
                    //                 "riskIncrVol": 200000,
                    //                 "riskIncrMmr": 0.004,
                    //                 "riskIncrImr": 0.004,
                    //                 "riskLevelLimit": 5,
                    //                 "priceCoefficientVariation": 0.1,
                    //                 "indexOrigin": ["BINANCE","GATEIO","HUOBI","MXC"],
                    //                 "state": 0, // 0 enabled, 1 delivery, 2 completed, 3 offline, 4 pause
                    //                 "isNew": false,
                    //                 "isHot": true,
                    //                 "isHidden": false
                    //             },
                    //             ...
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseLeverageTiers(data, symbols, 'symbol');
                }
                parseMarketLeverageTiers(info, market) {
                    /**
         * @ignore
         * @method
         * @param {dict} info Exchange response for 1 market
         * @param {dict} market CCXT market
         */ //
                    //    {
                    //        "symbol": "BTC_USDT",
                    //        "displayName": "BTC_USDT永续",
                    //        "displayNameEn": "BTC_USDT SWAP",
                    //        "positionOpenType": 3,
                    //        "baseCoin": "BTC",
                    //        "quoteCoin": "USDT",
                    //        "settleCoin": "USDT",
                    //        "contractSize": 0.0001,
                    //        "minLeverage": 1,
                    //        "maxLeverage": 125,
                    //        "priceScale": 2,
                    //        "volScale": 0,
                    //        "amountScale": 4,
                    //        "priceUnit": 0.5,
                    //        "volUnit": 1,
                    //        "minVol": 1,
                    //        "maxVol": 1000000,
                    //        "bidLimitPriceRate": 0.1,
                    //        "askLimitPriceRate": 0.1,
                    //        "takerFeeRate": 0.0006,
                    //        "makerFeeRate": 0.0002,
                    //        "maintenanceMarginRate": 0.004,
                    //        "initialMarginRate": 0.008,
                    //        "riskBaseVol": 10000,
                    //        "riskIncrVol": 200000,
                    //        "riskIncrMmr": 0.004,
                    //        "riskIncrImr": 0.004,
                    //        "riskLevelLimit": 5,
                    //        "priceCoefficientVariation": 0.1,
                    //        "indexOrigin": ["BINANCE","GATEIO","HUOBI","MXC"],
                    //        "state": 0, // 0 enabled, 1 delivery, 2 completed, 3 offline, 4 pause
                    //        "isNew": false,
                    //        "isHot": true,
                    //        "isHidden": false
                    //    }
                    //
                    let maintenanceMarginRate = this.safeString(info, 'maintenanceMarginRate');
                    let initialMarginRate = this.safeString(info, 'initialMarginRate');
                    const maxVol = this.safeString(info, 'maxVol');
                    const riskIncrVol = this.safeString(info, 'riskIncrVol');
                    const riskIncrMmr = this.safeString(info, 'riskIncrMmr');
                    const riskIncrImr = this.safeString(info, 'riskIncrImr');
                    let floor = '0';
                    const tiers = [];
                    const quoteId = this.safeString(info, 'quoteCoin');
                    while(Precise.stringLt(floor, maxVol)){
                        const cap = Precise.stringAdd(floor, riskIncrVol);
                        tiers.push({
                            'tier': this.parseNumber(Precise.stringDiv(cap, riskIncrVol)),
                            'currency': this.safeCurrencyCode(quoteId),
                            'minNotional': this.parseNumber(floor),
                            'maxNotional': this.parseNumber(cap),
                            'maintenanceMarginRate': this.parseNumber(maintenanceMarginRate),
                            'maxLeverage': this.parseNumber(Precise.stringDiv('1', initialMarginRate)),
                            'info': info
                        });
                        initialMarginRate = Precise.stringAdd(initialMarginRate, riskIncrImr);
                        maintenanceMarginRate = Precise.stringAdd(maintenanceMarginRate, riskIncrMmr);
                        floor = cap;
                    }
                    return tiers;
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    107: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, AuthenticationError: AuthenticationError, InsufficientFunds: InsufficientFunds, BadSymbol: BadSymbol, OrderNotFound: OrderNotFound } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            // ---------------------------------------------------------------------------
            module.exports = class ndax extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'ndax',
                        'name': 'NDAX',
                        'countries': [
                            'CA'
                        ],
                        'rateLimit': 1000,
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'editOrder': true,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLedger': true,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'signIn': true,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '60',
                            '5m': '300',
                            '15m': '900',
                            '30m': '1800',
                            '1h': '3600',
                            '2h': '7200',
                            '4h': '14400',
                            '6h': '21600',
                            '12h': '43200',
                            '1d': '86400',
                            '1w': '604800',
                            '1M': '2419200',
                            '4M': '9676800'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/108623144-67a3ef00-744e-11eb-8140-75c6b851e945.jpg',
                            'test': {
                                'public': 'https://ndaxmarginstaging.cdnhop.net:8443/AP',
                                'private': 'https://ndaxmarginstaging.cdnhop.net:8443/AP'
                            },
                            'api': {
                                'public': 'https://api.ndax.io:8443/AP',
                                'private': 'https://api.ndax.io:8443/AP'
                            },
                            'www': 'https://ndax.io',
                            'doc': [
                                'https://apidoc.ndax.io/'
                            ],
                            'fees': 'https://ndax.io/fees',
                            'referral': 'https://one.ndax.io/bfQiSL'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'Activate2FA': 1,
                                    'Authenticate2FA': 1,
                                    'AuthenticateUser': 1,
                                    'GetL2Snapshot': 1,
                                    'GetLevel1': 1,
                                    'GetValidate2FARequiredEndpoints': 1,
                                    'LogOut': 1,
                                    'GetTickerHistory': 1,
                                    'GetProduct': 1,
                                    'GetProducts': 1,
                                    'GetInstrument': 1,
                                    'GetInstruments': 1,
                                    'Ping': 1,
                                    'trades': 1,
                                    'GetLastTrades': 1,
                                    'SubscribeLevel1': 1,
                                    'SubscribeLevel2': 1,
                                    'SubscribeTicker': 1,
                                    'SubscribeTrades': 1,
                                    'SubscribeBlockTrades': 1,
                                    'UnsubscribeBlockTrades': 1,
                                    'UnsubscribeLevel1': 1,
                                    'UnsubscribeLevel2': 1,
                                    'UnsubscribeTicker': 1,
                                    'UnsubscribeTrades': 1,
                                    'Authenticate': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'GetUserAccountInfos': 1,
                                    'GetUserAccounts': 1,
                                    'GetUserAffiliateCount': 1,
                                    'GetUserAffiliateTag': 1,
                                    'GetUserConfig': 1,
                                    'GetAllUnredactedUserConfigsForUser': 1,
                                    'GetUnredactedUserConfigByKey': 1,
                                    'GetUserDevices': 1,
                                    'GetUserReportTickets': 1,
                                    'GetUserReportWriterResultRecords': 1,
                                    'GetAccountInfo': 1,
                                    'GetAccountPositions': 1,
                                    'GetAllAccountConfigs': 1,
                                    'GetTreasuryProductsForAccount': 1,
                                    'GetAccountTrades': 1,
                                    'GetAccountTransactions': 1,
                                    'GetOpenTradeReports': 1,
                                    'GetAllOpenTradeReports': 1,
                                    'GetTradesHistory': 1,
                                    'GetOpenOrders': 1,
                                    'GetOpenQuotes': 1,
                                    'GetOrderFee': 1,
                                    'GetOrderHistory': 1,
                                    'GetOrdersHistory': 1,
                                    'GetOrderStatus': 1,
                                    'GetOmsFeeTiers': 1,
                                    'GetAccountDepositTransactions': 1,
                                    'GetAccountWithdrawTransactions': 1,
                                    'GetAllDepositRequestInfoTemplates': 1,
                                    'GetDepositInfo': 1,
                                    'GetDepositRequestInfoTemplate': 1,
                                    'GetDeposits': 1,
                                    'GetDepositTicket': 1,
                                    'GetDepositTickets': 1,
                                    'GetOMSWithdrawFees': 1,
                                    'GetWithdrawFee': 1,
                                    'GetWithdraws': 1,
                                    'GetWithdrawTemplate': 1,
                                    'GetWithdrawTemplateTypes': 1,
                                    'GetWithdrawTicket': 1,
                                    'GetWithdrawTickets': 1
                                },
                                'post': {
                                    'AddUserAffiliateTag': 1,
                                    'CancelUserReport': 1,
                                    'RegisterNewDevice': 1,
                                    'SubscribeAccountEvents': 1,
                                    'UpdateUserAffiliateTag': 1,
                                    'GenerateTradeActivityReport': 1,
                                    'GenerateTransactionActivityReport': 1,
                                    'GenerateTreasuryActivityReport': 1,
                                    'ScheduleTradeActivityReport': 1,
                                    'ScheduleTransactionActivityReport': 1,
                                    'ScheduleTreasuryActivityReport': 1,
                                    'CancelAllOrders': 1,
                                    'CancelOrder': 1,
                                    'CancelQuote': 1,
                                    'CancelReplaceOrder': 1,
                                    'CreateQuote': 1,
                                    'ModifyOrder': 1,
                                    'SendOrder': 1,
                                    'SubmitBlockTrade': 1,
                                    'UpdateQuote': 1,
                                    'CancelWithdraw': 1,
                                    'CreateDepositTicket': 1,
                                    'CreateWithdrawTicket': 1,
                                    'SubmitDepositTicketComment': 1,
                                    'SubmitWithdrawTicketComment': 1,
                                    'GetOrderHistoryByOrderId': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': 0.002,
                                'taker': 0.0025
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'uid': true,
                            // these credentials are required for signIn() and withdraw()
                            'login': true,
                            'password': true
                        },
                        'precisionMode': TICK_SIZE,
                        'exceptions': {
                            'exact': {
                                'Not_Enough_Funds': InsufficientFunds,
                                'Server Error': ExchangeError1,
                                'Resource Not Found': OrderNotFound
                            },
                            'broad': {
                                'Invalid InstrumentId': BadSymbol,
                                'This endpoint requires 2FACode along with the payload': AuthenticationError
                            }
                        },
                        'options': {
                            'omsId': 1,
                            'orderTypes': {
                                'Market': 1,
                                'Limit': 2,
                                'StopMarket': 3,
                                'StopLimit': 4,
                                'TrailingStopMarket': 5,
                                'TrailingStopLimit': 6,
                                'BlockTrade': 7
                            }
                        }
                    });
                }
                async signIn(params = {}) {
                    this.checkRequiredCredentials();
                    if (this.login === undefined || this.password === undefined) throw new AuthenticationError(this.id + ' signIn() requires exchange.login, exchange.password');
                    let request = {
                        'grant_type': 'client_credentials'
                    };
                    const response = await this.publicGetAuthenticate(this.extend(request, params));
                    //
                    //     {
                    //         "Authenticated":true,
                    //         "Requires2FA":true,
                    //         "AuthType":"Google",
                    //         "AddtlInfo":"",
                    //         "Pending2FaToken": "6f5c4e66-f3ee-493e-9227-31cc0583b55f"
                    //     }
                    //
                    let sessionToken = this.safeString(response, 'SessionToken');
                    if (sessionToken !== undefined) {
                        this.options['sessionToken'] = sessionToken;
                        return response;
                    }
                    const pending2faToken = this.safeString(response, 'Pending2FaToken');
                    if (pending2faToken !== undefined) {
                        if (this.twofa === undefined) throw new AuthenticationError(this.id + ' signIn() requires exchange.twofa credentials');
                        this.options['pending2faToken'] = pending2faToken;
                        request = {
                            'Code': this.oath()
                        };
                        const response = await this.publicGetAuthenticate2FA(this.extend(request, params));
                        //
                        //     {
                        //         "Authenticated": true,
                        //         "UserId":57765,
                        //         "SessionToken":"4a2a5857-c4e5-4fac-b09e-2c4c30b591a0"
                        //     }
                        //
                        sessionToken = this.safeString(response, 'SessionToken');
                        this.options['sessionToken'] = sessionToken;
                        return response;
                    }
                    return response;
                }
                async fetchCurrencies(params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    const request = {
                        'omsId': omsId
                    };
                    const response = await this.publicGetGetProducts(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "OMSId":1,
                    //             "ProductId":1,
                    //             "Product":"BTC",
                    //             "ProductFullName":"Bitcoin",
                    //             "ProductType":"CryptoCurrency",
                    //             "DecimalPlaces":8,
                    //             "TickSize":0.0000000100000000000000000000,
                    //             "NoFees":false,
                    //             "IsDisabled":false,
                    //             "MarginEnabled":false
                    //         },
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        const id = this.safeString(currency, 'ProductId');
                        const name = this.safeString(currency, 'ProductFullName');
                        const type = this.safeString(currency, 'ProductType');
                        const code = this.safeCurrencyCode(this.safeString(currency, 'Product'));
                        const precision = this.safeNumber(currency, 'TickSize');
                        const isDisabled = this.safeValue(currency, 'IsDisabled');
                        const active = !isDisabled;
                        result[code] = {
                            'id': id,
                            'name': name,
                            'code': code,
                            'type': type,
                            'precision': precision,
                            'info': currency,
                            'active': active,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': undefined,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    const request = {
                        'omsId': omsId
                    };
                    const response = await this.publicGetGetInstruments(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "OMSId":1,
                    //             "InstrumentId":3,
                    //             "Symbol":"LTCBTC",
                    //             "Product1":3,
                    //             "Product1Symbol":"LTC",
                    //             "Product2":1,
                    //             "Product2Symbol":"BTC",
                    //             "InstrumentType":"Standard",
                    //             "VenueInstrumentId":3,
                    //             "VenueId":1,
                    //             "SortIndex":0,
                    //             "SessionStatus":"Running",
                    //             "PreviousSessionStatus":"Stopped",
                    //             "SessionStatusDateTime":"2020-11-25T19:42:15.245Z",
                    //             "SelfTradePrevention":true,
                    //             "QuantityIncrement":0.0000000100000000000000000000,
                    //             "PriceIncrement":0.0000000100000000000000000000,
                    //             "MinimumQuantity":0.0100000000000000000000000000,
                    //             "MinimumPrice":0.0000010000000000000000000000,
                    //             "VenueSymbol":"LTCBTC",
                    //             "IsDisable":false,
                    //             "MasterDataId":0,
                    //             "PriceCollarThreshold":0.0000000000000000000000000000,
                    //             "PriceCollarPercent":0.0000000000000000000000000000,
                    //             "PriceCollarEnabled":false,
                    //             "PriceFloorLimit":0.0000000000000000000000000000,
                    //             "PriceFloorLimitEnabled":false,
                    //             "PriceCeilingLimit":0.0000000000000000000000000000,
                    //             "PriceCeilingLimitEnabled":false,
                    //             "CreateWithMarketRunning":true,
                    //             "AllowOnlyMarketMakerCounterParty":false,
                    //             "PriceCollarIndexDifference":0.0000000000000000000000000000,
                    //             "PriceCollarConvertToOtcEnabled":false,
                    //             "PriceCollarConvertToOtcClientUserId":0,
                    //             "PriceCollarConvertToOtcAccountId":0,
                    //             "PriceCollarConvertToOtcThreshold":0.0000000000000000000000000000,
                    //             "OtcConvertSizeThreshold":0.0000000000000000000000000000,
                    //             "OtcConvertSizeEnabled":false,
                    //             "OtcTradesPublic":true,
                    //             "PriceTier":0
                    //         },
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'InstrumentId');
                        // const lowercaseId = this.safeStringLower (market, 'symbol');
                        const baseId = this.safeString(market, 'Product1');
                        const quoteId = this.safeString(market, 'Product2');
                        const base = this.safeCurrencyCode(this.safeString(market, 'Product1Symbol'));
                        const quote = this.safeCurrencyCode(this.safeString(market, 'Product2Symbol'));
                        const sessionStatus = this.safeString(market, 'SessionStatus');
                        const isDisable = this.safeValue(market, 'IsDisable');
                        const sessionRunning = sessionStatus === 'Running';
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': sessionRunning && !isDisable,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(market, 'QuantityIncrement'),
                                'price': this.safeNumber(market, 'PriceIncrement')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'MinimumQuantity'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'MinimumPrice'),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseOrderBook(orderbook, symbol, timestamp, bidsKey = 'bids', asksKey = 'asks', priceKey = 6, amountKey = 8) {
                    let nonce = undefined;
                    const result = {
                        'symbol': symbol,
                        'bids': [],
                        'asks': [],
                        'timestamp': undefined,
                        'datetime': undefined,
                        'nonce': undefined
                    };
                    for(let i = 0; i < orderbook.length; i++){
                        const level = orderbook[i];
                        if (timestamp === undefined) timestamp = this.safeInteger(level, 2);
                        else {
                            const newTimestamp = this.safeInteger(level, 2);
                            timestamp = Math.max(timestamp, newTimestamp);
                        }
                        if (nonce === undefined) nonce = this.safeInteger(level, 0);
                        else {
                            const newNonce = this.safeInteger(level, 0);
                            nonce = Math.max(nonce, newNonce);
                        }
                        const bidask = this.parseBidAsk(level, priceKey, amountKey);
                        const levelSide = this.safeInteger(level, 9);
                        const side = levelSide ? asksKey : bidsKey;
                        result[side].push(bidask);
                    }
                    result['bids'] = this.sortBy(result['bids'], 0, true);
                    result['asks'] = this.sortBy(result['asks'], 0);
                    result['timestamp'] = timestamp;
                    result['datetime'] = this.iso8601(timestamp);
                    result['nonce'] = nonce;
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    limit = limit === undefined ? 100 : limit; // default 100
                    const request = {
                        'omsId': omsId,
                        'InstrumentId': market['id'],
                        'Depth': limit
                    };
                    const response = await this.publicGetGetL2Snapshot(this.extend(request, params));
                    //
                    //     [
                    //         [
                    //             0,   // 0 MDUpdateId
                    //             1,   // 1 Number of Unique Accounts
                    //             123, // 2 ActionDateTime in Posix format X 1000
                    //             0,   // 3 ActionType 0 (New), 1 (Update), 2(Delete)
                    //             0.0, // 4 LastTradePrice
                    //             0,   // 5 Number of Orders
                    //             0.0, // 6 Price
                    //             0,   // 7 ProductPairCode
                    //             0.0, // 8 Quantity
                    //             0,   // 9 Side
                    //         ],
                    //         [97244115,1,1607456142963,0,19069.32,1,19069.31,8,0.140095,0],
                    //         [97244115,0,1607456142963,0,19069.32,1,19068.64,8,0.0055,0],
                    //         [97244115,0,1607456142963,0,19069.32,1,19068.26,8,0.021291,0],
                    //         [97244115,1,1607456142964,0,19069.32,1,19069.32,8,0.099636,1],
                    //         [97244115,0,1607456142964,0,19069.32,1,19069.98,8,0.1,1],
                    //         [97244115,0,1607456142964,0,19069.32,1,19069.99,8,0.141604,1],
                    //     ]
                    //
                    return this.parseOrderBook(response, symbol);
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker
                    //
                    //     {
                    //         "OMSId":1,
                    //         "InstrumentId":8,
                    //         "BestBid":19069.31,
                    //         "BestOffer":19069.32,
                    //         "LastTradedPx":19069.32,
                    //         "LastTradedQty":0.0001,
                    //         "LastTradeTime":1607040406424,
                    //         "SessionOpen":19069.32,
                    //         "SessionHigh":19069.32,
                    //         "SessionLow":19069.32,
                    //         "SessionClose":19069.32,
                    //         "Volume":0.0001,
                    //         "CurrentDayVolume":0.0001,
                    //         "CurrentDayNotional":1.906932,
                    //         "CurrentDayNumTrades":1,
                    //         "CurrentDayPxChange":0.00,
                    //         "Rolling24HrVolume":0.000000000000000000000000000,
                    //         "Rolling24HrNotional":0.00000000000000000000000,
                    //         "Rolling24NumTrades":0,
                    //         "Rolling24HrPxChange":0,
                    //         "TimeStamp":"1607040406425",
                    //         "BidQty":0,
                    //         "AskQty":0,
                    //         "BidOrderCt":0,
                    //         "AskOrderCt":0,
                    //         "Rolling24HrPxChangePercent":0,
                    //     }
                    //
                    const timestamp = this.safeInteger(ticker, 'TimeStamp');
                    const marketId = this.safeString(ticker, 'InstrumentId');
                    market = this.safeMarket(marketId, market);
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeNumber(ticker, 'LastTradedPx');
                    const percentage = this.safeNumber(ticker, 'Rolling24HrPxChangePercent');
                    const change = this.safeNumber(ticker, 'Rolling24HrPxChange');
                    const open = this.safeNumber(ticker, 'SessionOpen');
                    const baseVolume = this.safeNumber(ticker, 'Rolling24HrVolume');
                    const quoteVolume = this.safeNumber(ticker, 'Rolling24HrNotional');
                    const vwap = this.vwap(baseVolume, quoteVolume);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeNumber(ticker, 'SessionHigh'),
                        'low': this.safeNumber(ticker, 'SessionLow'),
                        'bid': this.safeNumber(ticker, 'BestBid'),
                        'bidVolume': undefined,
                        'ask': this.safeNumber(ticker, 'BestOffer'),
                        'askVolume': undefined,
                        'vwap': vwap,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': change,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market);
                }
                async fetchTicker(symbol, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'omsId': omsId,
                        'InstrumentId': market['id']
                    };
                    const response = await this.publicGetGetLevel1(this.extend(request, params));
                    //
                    //     {
                    //         "OMSId":1,
                    //         "InstrumentId":8,
                    //         "BestBid":19069.31,
                    //         "BestOffer":19069.32,
                    //         "LastTradedPx":19069.32,
                    //         "LastTradedQty":0.0001,
                    //         "LastTradeTime":1607040406424,
                    //         "SessionOpen":19069.32,
                    //         "SessionHigh":19069.32,
                    //         "SessionLow":19069.32,
                    //         "SessionClose":19069.32,
                    //         "Volume":0.0001,
                    //         "CurrentDayVolume":0.0001,
                    //         "CurrentDayNotional":1.906932,
                    //         "CurrentDayNumTrades":1,
                    //         "CurrentDayPxChange":0.00,
                    //         "Rolling24HrVolume":0.000000000000000000000000000,
                    //         "Rolling24HrNotional":0.00000000000000000000000,
                    //         "Rolling24NumTrades":0,
                    //         "Rolling24HrPxChange":0,
                    //         "TimeStamp":"1607040406425",
                    //         "BidQty":0,
                    //         "AskQty":0,
                    //         "BidOrderCt":0,
                    //         "AskOrderCt":0,
                    //         "Rolling24HrPxChangePercent":0,
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1501603632000, // 0 DateTime
                    //         2700.33,       // 1 High
                    //         2687.01,       // 2 Low
                    //         2687.01,       // 3 Open
                    //         2687.01,       // 4 Close
                    //         24.86100992,   // 5 Volume
                    //         0,             // 6 Inside Bid Price
                    //         2870.95,       // 7 Inside Ask Price
                    //         1              // 8 InstrumentId
                    //     ]
                    //
                    return [
                        this.safeInteger(ohlcv, 0),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'omsId': omsId,
                        'InstrumentId': market['id'],
                        'Interval': this.timeframes[timeframe]
                    };
                    const duration = this.parseTimeframe(timeframe);
                    const now = this.milliseconds();
                    if (since === undefined) {
                        if (limit !== undefined) {
                            request['FromDate'] = this.ymdhms(now - duration * limit * 1000);
                            request['ToDate'] = this.ymdhms(now);
                        }
                    } else {
                        request['FromDate'] = this.ymdhms(since);
                        if (limit === undefined) request['ToDate'] = this.ymdhms(now);
                        else request['ToDate'] = this.ymdhms(this.sum(since, duration * limit * 1000));
                    }
                    const response = await this.publicGetGetTickerHistory(this.extend(request, params));
                    //
                    //     [
                    //         [1607299260000,19069.32,19069.32,19069.32,19069.32,0,19069.31,19069.32,8,1607299200000],
                    //         [1607299320000,19069.32,19069.32,19069.32,19069.32,0,19069.31,19069.32,8,1607299260000],
                    //         [1607299380000,19069.32,19069.32,19069.32,19069.32,0,19069.31,19069.32,8,1607299320000],
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     [
                    //         6913253,       //  0 TradeId
                    //         8,             //  1 ProductPairCode
                    //         0.03340802,    //  2 Quantity
                    //         19116.08,      //  3 Price
                    //         2543425077,    //  4 Order1
                    //         2543425482,    //  5 Order2
                    //         1606935922416, //  6 Tradetime
                    //         0,             //  7 Direction
                    //         1,             //  8 TakerSide
                    //         0,             //  9 BlockTrade
                    //         0,             // 10 Either Order1ClientId or Order2ClientId
                    //     ]
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "OMSId":1,
                    //         "ExecutionId":16916567,
                    //         "TradeId":14476351,
                    //         "OrderId":2543565231,
                    //         "AccountId":449,
                    //         "AccountName":"igor@ccxt.trade",
                    //         "SubAccountId":0,
                    //         "ClientOrderId":0,
                    //         "InstrumentId":8,
                    //         "Side":"Sell",
                    //         "OrderType":"Market",
                    //         "Quantity":0.1230000000000000000000000000,
                    //         "RemainingQuantity":0.0000000000000000000000000000,
                    //         "Price":19069.310000000000000000000000,
                    //         "Value":2345.5251300000000000000000000,
                    //         "CounterParty":"7",
                    //         "OrderTradeRevision":1,
                    //         "Direction":"NoChange",
                    //         "IsBlockTrade":false,
                    //         "Fee":1.1727625650000000000000000000,
                    //         "FeeProductId":8,
                    //         "OrderOriginator":446,
                    //         "UserName":"igor@ccxt.trade",
                    //         "TradeTimeMS":1607565031569,
                    //         "MakerTaker":"Taker",
                    //         "AdapterTradeId":0,
                    //         "InsideBid":19069.310000000000000000000000,
                    //         "InsideBidSize":0.2400950000000000000000000000,
                    //         "InsideAsk":19069.320000000000000000000000,
                    //         "InsideAskSize":0.0997360000000000000000000000,
                    //         "IsQuote":false,
                    //         "CounterPartyClientUserId":1,
                    //         "NotionalProductId":2,
                    //         "NotionalRate":1.0000000000000000000000000000,
                    //         "NotionalValue":2345.5251300000000000000000000,
                    //         "NotionalHoldAmount":0,
                    //         "TradeTime":637431618315686826
                    //     }
                    //
                    // fetchOrderTrades
                    //
                    //     {
                    //         "Side":"Sell",
                    //         "OrderId":2543565235,
                    //         "Price":18600.000000000000000000000000,
                    //         "Quantity":0.0000000000000000000000000000,
                    //         "DisplayQuantity":0.0000000000000000000000000000,
                    //         "Instrument":8,
                    //         "Account":449,
                    //         "AccountName":"igor@ccxt.trade",
                    //         "OrderType":"Limit",
                    //         "ClientOrderId":0,
                    //         "OrderState":"FullyExecuted",
                    //         "ReceiveTime":1607585844956,
                    //         "ReceiveTimeTicks":637431826449564182,
                    //         "LastUpdatedTime":1607585844959,
                    //         "LastUpdatedTimeTicks":637431826449593893,
                    //         "OrigQuantity":0.1230000000000000000000000000,
                    //         "QuantityExecuted":0.1230000000000000000000000000,
                    //         "GrossValueExecuted":2345.3947500000000000000000000,
                    //         "ExecutableValue":0.0000000000000000000000000000,
                    //         "AvgPrice":19068.250000000000000000000000,
                    //         "CounterPartyId":0,
                    //         "ChangeReason":"Trade",
                    //         "OrigOrderId":2543565235,
                    //         "OrigClOrdId":0,
                    //         "EnteredBy":446,
                    //         "UserName":"igor@ccxt.trade",
                    //         "IsQuote":false,
                    //         "InsideAsk":19069.320000000000000000000000,
                    //         "InsideAskSize":0.0997360000000000000000000000,
                    //         "InsideBid":19068.250000000000000000000000,
                    //         "InsideBidSize":1.3300010000000000000000000000,
                    //         "LastTradePrice":19068.250000000000000000000000,
                    //         "RejectReason":"",
                    //         "IsLockedIn":false,
                    //         "CancelReason":"",
                    //         "OrderFlag":"0",
                    //         "UseMargin":false,
                    //         "StopPrice":0.0000000000000000000000000000,
                    //         "PegPriceType":"Unknown",
                    //         "PegOffset":0.0000000000000000000000000000,
                    //         "PegLimitOffset":0.0000000000000000000000000000,
                    //         "IpAddress":"x.x.x.x",
                    //         "ClientOrderIdUuid":null,
                    //         "OMSId":1
                    //     }
                    //
                    let priceString = undefined;
                    let amountString = undefined;
                    let costString = undefined;
                    let timestamp = undefined;
                    let id = undefined;
                    let marketId = undefined;
                    let side = undefined;
                    let orderId = undefined;
                    let takerOrMaker = undefined;
                    let fee = undefined;
                    let type = undefined;
                    if (Array.isArray(trade)) {
                        priceString = this.safeString(trade, 3);
                        amountString = this.safeString(trade, 2);
                        timestamp = this.safeInteger(trade, 6);
                        id = this.safeString(trade, 0);
                        marketId = this.safeString(trade, 1);
                        const takerSide = this.safeValue(trade, 8);
                        side = takerSide ? 'sell' : 'buy';
                        orderId = this.safeString(trade, 4);
                    } else {
                        timestamp = this.safeInteger2(trade, 'TradeTimeMS', 'ReceiveTime');
                        id = this.safeString(trade, 'TradeId');
                        orderId = this.safeString2(trade, 'OrderId', 'OrigOrderId');
                        marketId = this.safeString2(trade, 'InstrumentId', 'Instrument');
                        priceString = this.safeString(trade, 'Price');
                        amountString = this.safeString(trade, 'Quantity');
                        costString = this.safeString2(trade, 'Value', 'GrossValueExecuted');
                        takerOrMaker = this.safeStringLower(trade, 'MakerTaker');
                        side = this.safeStringLower(trade, 'Side');
                        type = this.safeStringLower(trade, 'OrderType');
                        const feeCostString = this.safeString(trade, 'Fee');
                        if (feeCostString !== undefined) {
                            const feeCurrencyId = this.safeString(trade, 'FeeProductId');
                            const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                            fee = {
                                'cost': feeCostString,
                                'currency': feeCurrencyCode
                            };
                        }
                    }
                    const symbol = this.safeSymbol(marketId, market);
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'order': orderId,
                        'type': type,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'omsId': omsId,
                        'InstrumentId': market['id']
                    };
                    if (limit !== undefined) request['Count'] = limit;
                    const response = await this.publicGetGetLastTrades(this.extend(request, params));
                    //
                    //     [
                    //         [6913253,8,0.03340802,19116.08,2543425077,2543425482,1606935922416,0,1,0,0],
                    //         [6913254,8,0.01391671,19117.42,2543427510,2543427811,1606935927998,1,1,0,0],
                    //         [6913255,8,0.000006,19107.81,2543430495,2543430793,1606935933881,2,0,0,0],
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchAccounts(params = {}) {
                    if (!this.login) throw new AuthenticationError(this.id + ' fetchAccounts() requires exchange.login email credential');
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    this.checkRequiredCredentials();
                    const request = {
                        'omsId': omsId,
                        'UserId': this.uid,
                        'UserName': this.login
                    };
                    const response = await this.privateGetGetUserAccounts(this.extend(request, params));
                    //
                    //     [ 449 ] // comma-separated list of account ids
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const accountId = this.safeString(response, i);
                        result.push({
                            'id': accountId,
                            'type': undefined,
                            'currency': undefined,
                            'info': accountId
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'ProductId');
                        if (currencyId in this.currencies_by_id) {
                            const code = this.safeCurrencyCode(currencyId);
                            const account = this.account();
                            account['total'] = this.safeString(balance, 'Amount');
                            account['used'] = this.safeString(balance, 'Hold');
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    params = this.omit(params, [
                        'accountId',
                        'AccountId'
                    ]);
                    const request = {
                        'omsId': omsId,
                        'AccountId': accountId
                    };
                    const response = await this.privateGetGetAccountPositions(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "OMSId":1,
                    //             "AccountId":449,
                    //             "ProductSymbol":"BTC",
                    //             "ProductId":1,
                    //             "Amount":10.000000000000000000000000000,
                    //             "Hold":0,
                    //             "PendingDeposits":0.0000000000000000000000000000,
                    //             "PendingWithdraws":0.0000000000000000000000000000,
                    //             "TotalDayDeposits":10.000000000000000000000000000,
                    //             "TotalMonthDeposits":10.000000000000000000000000000,
                    //             "TotalYearDeposits":10.000000000000000000000000000,
                    //             "TotalDayDepositNotional":10.000000000000000000000000000,
                    //             "TotalMonthDepositNotional":10.000000000000000000000000000,
                    //             "TotalYearDepositNotional":10.000000000000000000000000000,
                    //             "TotalDayWithdraws":0,
                    //             "TotalMonthWithdraws":0,
                    //             "TotalYearWithdraws":0,
                    //             "TotalDayWithdrawNotional":0,
                    //             "TotalMonthWithdrawNotional":0,
                    //             "TotalYearWithdrawNotional":0,
                    //             "NotionalProductId":8,
                    //             "NotionalProductSymbol":"USDT",
                    //             "NotionalValue":10.000000000000000000000000000,
                    //             "NotionalHoldAmount":0,
                    //             "NotionalRate":1
                    //         },
                    //     ]
                    //
                    return this.parseBalance(response);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'Trade': 'trade',
                        'Deposit': 'transaction',
                        'Withdraw': 'transaction',
                        'Transfer': 'transfer',
                        'OrderHold': 'trade',
                        'WithdrawHold': 'transaction',
                        'DepositHold': 'transaction',
                        'MarginHold': 'trade',
                        'ManualHold': 'trade',
                        'ManualEntry': 'trade',
                        'MarginAcquisition': 'trade',
                        'MarginRelinquish': 'trade',
                        'MarginQuoteHold': 'trade'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     {
                    //         "TransactionId":2663709493,
                    //         "ReferenceId":68,
                    //         "OMSId":1,
                    //         "AccountId":449,
                    //         "CR":10.000000000000000000000000000,
                    //         "DR":0.0000000000000000000000000000,
                    //         "Counterparty":3,
                    //         "TransactionType":"Other",
                    //         "ReferenceType":"Deposit",
                    //         "ProductId":1,
                    //         "Balance":10.000000000000000000000000000,
                    //         "TimeStamp":1607532331591
                    //     }
                    //
                    const id = this.safeString(item, 'TransactionId');
                    const account = this.safeString(item, 'AccountId');
                    const referenceId = this.safeString(item, 'ReferenceId');
                    const referenceAccount = this.safeString(item, 'Counterparty');
                    const type = this.parseLedgerEntryType(this.safeString(item, 'ReferenceType'));
                    const currencyId = this.safeString(item, 'ProductId');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const credit = this.safeNumber(item, 'CR');
                    const debit = this.safeNumber(item, 'DR');
                    let amount = undefined;
                    let direction = undefined;
                    if (credit > 0) {
                        amount = credit;
                        direction = 'in';
                    } else if (debit > 0) {
                        amount = debit;
                        direction = 'out';
                    }
                    const timestamp = this.safeInteger(item, 'TimeStamp');
                    let before = undefined;
                    const after = this.safeNumber(item, 'Balance');
                    if (direction === 'out') before = this.sum(after, amount);
                    else if (direction === 'in') before = Math.max(0, after - amount);
                    const status = 'ok';
                    return {
                        'info': item,
                        'id': id,
                        'direction': direction,
                        'account': account,
                        'referenceId': referenceId,
                        'referenceAccount': referenceAccount,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'before': before,
                        'after': after,
                        'status': status,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': undefined
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    params = this.omit(params, [
                        'accountId',
                        'AccountId'
                    ]);
                    const request = {
                        'omsId': omsId,
                        'AccountId': accountId
                    };
                    if (limit !== undefined) request['Depth'] = limit;
                    const response = await this.privateGetGetAccountTransactions(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "TransactionId":2663709493,
                    //             "ReferenceId":68,
                    //             "OMSId":1,
                    //             "AccountId":449,
                    //             "CR":10.000000000000000000000000000,
                    //             "DR":0.0000000000000000000000000000,
                    //             "Counterparty":3,
                    //             "TransactionType":"Other",
                    //             "ReferenceType":"Deposit",
                    //             "ProductId":1,
                    //             "Balance":10.000000000000000000000000000,
                    //             "TimeStamp":1607532331591
                    //         },
                    //     ]
                    //
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    return this.parseLedger(response, currency, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'Accepted': 'open',
                        'Rejected': 'rejected',
                        'Working': 'open',
                        'Canceled': 'canceled',
                        'Expired': 'expired',
                        'FullyExecuted': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "status":"Accepted",
                    //         "errormsg":"",
                    //         "OrderId": 2543565231
                    //     }
                    //
                    // editOrder
                    //
                    //     {
                    //         "ReplacementOrderId": 1234,
                    //         "ReplacementClOrdId": 1561,
                    //         "OrigOrderId": 5678,
                    //         "OrigClOrdId": 91011,
                    //     }
                    //
                    // fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "Side":"Buy",
                    //         "OrderId":2543565233,
                    //         "Price":19010,
                    //         "Quantity":0.345,
                    //         "DisplayQuantity":0.345,
                    //         "Instrument":8,
                    //         "Account":449,
                    //         "AccountName":"igor@ccxt.trade",
                    //         "OrderType":"Limit",
                    //         "ClientOrderId":0,
                    //         "OrderState":"Working",
                    //         "ReceiveTime":1607579326003,
                    //         "ReceiveTimeTicks":637431761260028981,
                    //         "LastUpdatedTime":1607579326005,
                    //         "LastUpdatedTimeTicks":637431761260054714,
                    //         "OrigQuantity":0.345,
                    //         "QuantityExecuted":0,
                    //         "GrossValueExecuted":0,
                    //         "ExecutableValue":0,
                    //         "AvgPrice":0,
                    //         "CounterPartyId":0,
                    //         "ChangeReason":"NewInputAccepted",
                    //         "OrigOrderId":2543565233,
                    //         "OrigClOrdId":0,
                    //         "EnteredBy":446,
                    //         "UserName":"igor@ccxt.trade",
                    //         "IsQuote":false,
                    //         "InsideAsk":19069.32,
                    //         "InsideAskSize":0.099736,
                    //         "InsideBid":19068.25,
                    //         "InsideBidSize":1.330001,
                    //         "LastTradePrice":19068.25,
                    //         "RejectReason":"",
                    //         "IsLockedIn":false,
                    //         "CancelReason":"",
                    //         "OrderFlag":"AddedToBook",
                    //         "UseMargin":false,
                    //         "StopPrice":0,
                    //         "PegPriceType":"Unknown",
                    //         "PegOffset":0,
                    //         "PegLimitOffset":0,
                    //         "IpAddress":null,
                    //         "ClientOrderIdUuid":null,
                    //         "OMSId":1
                    //     }
                    //
                    const id = this.safeString2(order, 'ReplacementOrderId', 'OrderId');
                    const timestamp = this.safeInteger(order, 'ReceiveTime');
                    const lastTradeTimestamp = this.safeInteger(order, 'LastUpdatedTime');
                    const marketId = this.safeString(order, 'Instrument');
                    const symbol = this.safeSymbol(marketId, market);
                    const side = this.safeStringLower(order, 'Side');
                    const type = this.safeStringLower(order, 'OrderType');
                    const clientOrderId = this.safeString2(order, 'ReplacementClOrdId', 'ClientOrderId');
                    const price = this.safeString(order, 'Price');
                    const amount = this.safeString(order, 'OrigQuantity');
                    const filled = this.safeString(order, 'QuantityExecuted');
                    const cost = this.safeString(order, 'GrossValueExecuted');
                    const average = this.safeString(order, 'AvgPrice');
                    const stopPrice = this.parseNumber(this.omitZero(this.safeString(order, 'StopPrice')));
                    const status = this.parseOrderStatus(this.safeString(order, 'OrderState'));
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'average': average,
                        'remaining': undefined,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    const clientOrderId = this.safeInteger2(params, 'ClientOrderId', 'clientOrderId');
                    params = this.omit(params, [
                        'accountId',
                        'AccountId',
                        'clientOrderId',
                        'ClientOrderId'
                    ]);
                    const market = this.market(symbol);
                    const orderSide = side === 'buy' ? 0 : 1;
                    const request = {
                        'InstrumentId': parseInt(market['id']),
                        'omsId': omsId,
                        'AccountId': accountId,
                        'TimeInForce': 1,
                        // 'ClientOrderId': clientOrderId, // defaults to 0
                        // If this order is order A, OrderIdOCO refers to the order ID of an order B (which is not the order being created by this call).
                        // If order B executes, then order A created by this call is canceled.
                        // You can also set up order B to watch order A in the same way, but that may require an update to order B to make it watch this one, which could have implications for priority in the order book.
                        // See CancelReplaceOrder and ModifyOrder.
                        // 'OrderIdOCO': 0, // The order ID if One Cancels the Other.
                        // 'UseDisplayQuantity': false, // If you enter a Limit order with a reserve, you must set UseDisplayQuantity to true
                        'Side': orderSide,
                        'Quantity': parseFloat(this.amountToPrecision(symbol, amount)),
                        'OrderType': this.safeInteger(this.options['orderTypes'], this.capitalize(type))
                    };
                    // If OrderType=1 (Market), Side=0 (Buy), and LimitPrice is supplied, the Market order will execute up to the value specified
                    if (price !== undefined) request['LimitPrice'] = parseFloat(this.priceToPrecision(symbol, price));
                    if (clientOrderId !== undefined) request['ClientOrderId'] = clientOrderId;
                    const response = await this.privatePostSendOrder(this.extend(request, params));
                    //
                    //     {
                    //         "status":"Accepted",
                    //         "errormsg":"",
                    //         "OrderId": 2543565231
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    const clientOrderId = this.safeInteger2(params, 'ClientOrderId', 'clientOrderId');
                    params = this.omit(params, [
                        'accountId',
                        'AccountId',
                        'clientOrderId',
                        'ClientOrderId'
                    ]);
                    const market = this.market(symbol);
                    const orderSide = side === 'buy' ? 0 : 1;
                    const request = {
                        'OrderIdToReplace': parseInt(id),
                        'InstrumentId': parseInt(market['id']),
                        'omsId': omsId,
                        'AccountId': accountId,
                        'TimeInForce': 1,
                        // 'ClientOrderId': clientOrderId, // defaults to 0
                        // If this order is order A, OrderIdOCO refers to the order ID of an order B (which is not the order being created by this call).
                        // If order B executes, then order A created by this call is canceled.
                        // You can also set up order B to watch order A in the same way, but that may require an update to order B to make it watch this one, which could have implications for priority in the order book.
                        // See CancelReplaceOrder and ModifyOrder.
                        // 'OrderIdOCO': 0, // The order ID if One Cancels the Other.
                        // 'UseDisplayQuantity': false, // If you enter a Limit order with a reserve, you must set UseDisplayQuantity to true
                        'Side': orderSide,
                        'Quantity': parseFloat(this.amountToPrecision(symbol, amount)),
                        'OrderType': this.safeInteger(this.options['orderTypes'], this.capitalize(type))
                    };
                    // If OrderType=1 (Market), Side=0 (Buy), and LimitPrice is supplied, the Market order will execute up to the value specified
                    if (price !== undefined) request['LimitPrice'] = parseFloat(this.priceToPrecision(symbol, price));
                    if (clientOrderId !== undefined) request['ClientOrderId'] = clientOrderId;
                    const response = await this.privatePostCancelReplaceOrder(this.extend(request, params));
                    //
                    //     {
                    //         "replacementOrderId": 1234,
                    //         "replacementClOrdId": 1561,
                    //         "origOrderId": 5678,
                    //         "origClOrdId": 91011,
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    params = this.omit(params, [
                        'accountId',
                        'AccountId'
                    ]);
                    const request = {
                        'omsId': omsId,
                        'AccountId': accountId
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['InstrumentId'] = market['id'];
                    }
                    if (since !== undefined) request['StartTimeStamp'] = parseInt(since / 1000);
                    if (limit !== undefined) request['Depth'] = limit;
                    const response = await this.privateGetGetTradesHistory(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "OMSId":1,
                    //             "ExecutionId":16916567,
                    //             "TradeId":14476351,
                    //             "OrderId":2543565231,
                    //             "AccountId":449,
                    //             "AccountName":"igor@ccxt.trade",
                    //             "SubAccountId":0,
                    //             "ClientOrderId":0,
                    //             "InstrumentId":8,
                    //             "Side":"Sell",
                    //             "OrderType":"Market",
                    //             "Quantity":0.1230000000000000000000000000,
                    //             "RemainingQuantity":0.0000000000000000000000000000,
                    //             "Price":19069.310000000000000000000000,
                    //             "Value":2345.5251300000000000000000000,
                    //             "CounterParty":"7",
                    //             "OrderTradeRevision":1,
                    //             "Direction":"NoChange",
                    //             "IsBlockTrade":false,
                    //             "Fee":1.1727625650000000000000000000,
                    //             "FeeProductId":8,
                    //             "OrderOriginator":446,
                    //             "UserName":"igor@ccxt.trade",
                    //             "TradeTimeMS":1607565031569,
                    //             "MakerTaker":"Taker",
                    //             "AdapterTradeId":0,
                    //             "InsideBid":19069.310000000000000000000000,
                    //             "InsideBidSize":0.2400950000000000000000000000,
                    //             "InsideAsk":19069.320000000000000000000000,
                    //             "InsideAskSize":0.0997360000000000000000000000,
                    //             "IsQuote":false,
                    //             "CounterPartyClientUserId":1,
                    //             "NotionalProductId":2,
                    //             "NotionalRate":1.0000000000000000000000000000,
                    //             "NotionalValue":2345.5251300000000000000000000,
                    //             "NotionalHoldAmount":0,
                    //             "TradeTime":637431618315686826
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async cancelAllOrders(symbol, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    params = this.omit(params, [
                        'accountId',
                        'AccountId'
                    ]);
                    const request = {
                        'omsId': omsId,
                        'AccountId': accountId
                    };
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        request['IntrumentId'] = market['id'];
                    }
                    const response = await this.privatePostCancelAllOrders(this.extend(request, params));
                    //
                    //     {
                    //         "result":true,
                    //         "errormsg":null,
                    //         "errorcode":0,
                    //         "detail":null
                    //     }
                    //
                    return response;
                }
                async cancelOrder(id, symbol, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    // const defaultAccountId = this.safeInteger2 (this.options, 'accountId', 'AccountId', parseInt (this.accounts[0]['id']));
                    // const accountId = this.safeInteger2 (params, 'accountId', 'AccountId', defaultAccountId);
                    // params = this.omit (params, [ 'accountId', 'AccountId' ]);
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'omsId': omsId
                    };
                    const clientOrderId = this.safeInteger2(params, 'clientOrderId', 'ClOrderId');
                    if (clientOrderId !== undefined) request['ClOrderId'] = clientOrderId;
                    else request['OrderId'] = parseInt(id);
                    params = this.omit(params, [
                        'clientOrderId',
                        'ClOrderId'
                    ]);
                    const response = await this.privatePostCancelOrder(this.extend(request, params));
                    const order = this.parseOrder(response, market);
                    return this.extend(order, {
                        'id': id,
                        'clientOrderId': clientOrderId
                    });
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    params = this.omit(params, [
                        'accountId',
                        'AccountId'
                    ]);
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'omsId': omsId,
                        'AccountId': accountId
                    };
                    const response = await this.privateGetGetOpenOrders(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "Side":"Buy",
                    //             "OrderId":2543565233,
                    //             "Price":19010,
                    //             "Quantity":0.345,
                    //             "DisplayQuantity":0.345,
                    //             "Instrument":8,
                    //             "Account":449,
                    //             "AccountName":"igor@ccxt.trade",
                    //             "OrderType":"Limit",
                    //             "ClientOrderId":0,
                    //             "OrderState":"Working",
                    //             "ReceiveTime":1607579326003,
                    //             "ReceiveTimeTicks":637431761260028981,
                    //             "LastUpdatedTime":1607579326005,
                    //             "LastUpdatedTimeTicks":637431761260054714,
                    //             "OrigQuantity":0.345,
                    //             "QuantityExecuted":0,
                    //             "GrossValueExecuted":0,
                    //             "ExecutableValue":0,
                    //             "AvgPrice":0,
                    //             "CounterPartyId":0,
                    //             "ChangeReason":"NewInputAccepted",
                    //             "OrigOrderId":2543565233,
                    //             "OrigClOrdId":0,
                    //             "EnteredBy":446,
                    //             "UserName":"igor@ccxt.trade",
                    //             "IsQuote":false,
                    //             "InsideAsk":19069.32,
                    //             "InsideAskSize":0.099736,
                    //             "InsideBid":19068.25,
                    //             "InsideBidSize":1.330001,
                    //             "LastTradePrice":19068.25,
                    //             "RejectReason":"",
                    //             "IsLockedIn":false,
                    //             "CancelReason":"",
                    //             "OrderFlag":"AddedToBook",
                    //             "UseMargin":false,
                    //             "StopPrice":0,
                    //             "PegPriceType":"Unknown",
                    //             "PegOffset":0,
                    //             "PegLimitOffset":0,
                    //             "IpAddress":null,
                    //             "ClientOrderIdUuid":null,
                    //             "OMSId":1
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    params = this.omit(params, [
                        'accountId',
                        'AccountId'
                    ]);
                    const request = {
                        'omsId': omsId,
                        'AccountId': accountId
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['InstrumentId'] = market['id'];
                    }
                    if (since !== undefined) request['StartTimeStamp'] = parseInt(since / 1000);
                    if (limit !== undefined) request['Depth'] = limit;
                    const response = await this.privateGetGetOrdersHistory(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "Side":"Buy",
                    //             "OrderId":2543565233,
                    //             "Price":19010.000000000000000000000000,
                    //             "Quantity":0.0000000000000000000000000000,
                    //             "DisplayQuantity":0.3450000000000000000000000000,
                    //             "Instrument":8,
                    //             "Account":449,
                    //             "AccountName":"igor@ccxt.trade",
                    //             "OrderType":"Limit",
                    //             "ClientOrderId":0,
                    //             "OrderState":"Canceled",
                    //             "ReceiveTime":1607579326003,
                    //             "ReceiveTimeTicks":637431761260028981,
                    //             "LastUpdatedTime":1607580965346,
                    //             "LastUpdatedTimeTicks":637431777653463754,
                    //             "OrigQuantity":0.3450000000000000000000000000,
                    //             "QuantityExecuted":0.0000000000000000000000000000,
                    //             "GrossValueExecuted":0.0000000000000000000000000000,
                    //             "ExecutableValue":0.0000000000000000000000000000,
                    //             "AvgPrice":0.0000000000000000000000000000,
                    //             "CounterPartyId":0,
                    //             "ChangeReason":"UserModified",
                    //             "OrigOrderId":2543565233,
                    //             "OrigClOrdId":0,
                    //             "EnteredBy":446,
                    //             "UserName":"igor@ccxt.trade",
                    //             "IsQuote":false,
                    //             "InsideAsk":19069.320000000000000000000000,
                    //             "InsideAskSize":0.0997360000000000000000000000,
                    //             "InsideBid":19068.250000000000000000000000,
                    //             "InsideBidSize":1.3300010000000000000000000000,
                    //             "LastTradePrice":19068.250000000000000000000000,
                    //             "RejectReason":"",
                    //             "IsLockedIn":false,
                    //             "CancelReason":"UserModified",
                    //             "OrderFlag":"AddedToBook, RemovedFromBook",
                    //             "UseMargin":false,
                    //             "StopPrice":0.0000000000000000000000000000,
                    //             "PegPriceType":"Unknown",
                    //             "PegOffset":0.0000000000000000000000000000,
                    //             "PegLimitOffset":0.0000000000000000000000000000,
                    //             "IpAddress":"x.x.x.x",
                    //             "ClientOrderIdUuid":null,
                    //             "OMSId":1
                    //         },
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOrder(id, symbol, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    params = this.omit(params, [
                        'accountId',
                        'AccountId'
                    ]);
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'omsId': omsId,
                        'AccountId': accountId,
                        'OrderId': parseInt(id)
                    };
                    const response = await this.privateGetGetOrderStatus(this.extend(request, params));
                    //
                    //     {
                    //         "Side":"Sell",
                    //         "OrderId":2543565232,
                    //         "Price":0.0000000000000000000000000000,
                    //         "Quantity":0.0000000000000000000000000000,
                    //         "DisplayQuantity":0.0000000000000000000000000000,
                    //         "Instrument":8,
                    //         "Account":449,
                    //         "AccountName":"igor@ccxt.trade",
                    //         "OrderType":"Market",
                    //         "ClientOrderId":0,
                    //         "OrderState":"FullyExecuted",
                    //         "ReceiveTime":1607569475591,
                    //         "ReceiveTimeTicks":637431662755912377,
                    //         "LastUpdatedTime":1607569475596,
                    //         "LastUpdatedTimeTicks":637431662755960902,
                    //         "OrigQuantity":1.0000000000000000000000000000,
                    //         "QuantityExecuted":1.0000000000000000000000000000,
                    //         "GrossValueExecuted":19068.270478610000000000000000,
                    //         "ExecutableValue":0.0000000000000000000000000000,
                    //         "AvgPrice":19068.270478610000000000000000,
                    //         "CounterPartyId":0,
                    //         "ChangeReason":"Trade",
                    //         "OrigOrderId":2543565232,
                    //         "OrigClOrdId":0,
                    //         "EnteredBy":446,
                    //         "UserName":"igor@ccxt.trade",
                    //         "IsQuote":false,
                    //         "InsideAsk":19069.320000000000000000000000,
                    //         "InsideAskSize":0.0997360000000000000000000000,
                    //         "InsideBid":19069.310000000000000000000000,
                    //         "InsideBidSize":0.2400950000000000000000000000,
                    //         "LastTradePrice":19069.310000000000000000000000,
                    //         "RejectReason":"",
                    //         "IsLockedIn":false,
                    //         "CancelReason":"",
                    //         "OrderFlag":"0",
                    //         "UseMargin":false,
                    //         "StopPrice":0.0000000000000000000000000000,
                    //         "PegPriceType":"Unknown",
                    //         "PegOffset":0.0000000000000000000000000000,
                    //         "PegLimitOffset":0.0000000000000000000000000000,
                    //         "IpAddress":"x.x.x.x",
                    //         "ClientOrderIdUuid":null,
                    //         "OMSId":1
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    // const defaultAccountId = this.safeInteger2 (this.options, 'accountId', 'AccountId', parseInt (this.accounts[0]['id']));
                    // const accountId = this.safeInteger2 (params, 'accountId', 'AccountId', defaultAccountId);
                    // params = this.omit (params, [ 'accountId', 'AccountId' ]);
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'OMSId': parseInt(omsId),
                        // 'AccountId': accountId,
                        'OrderId': parseInt(id)
                    };
                    const response = await this.privatePostGetOrderHistoryByOrderId(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "Side":"Sell",
                    //             "OrderId":2543565235,
                    //             "Price":18600.000000000000000000000000,
                    //             "Quantity":0.0000000000000000000000000000,
                    //             "DisplayQuantity":0.0000000000000000000000000000,
                    //             "Instrument":8,
                    //             "Account":449,
                    //             "AccountName":"igor@ccxt.trade",
                    //             "OrderType":"Limit",
                    //             "ClientOrderId":0,
                    //             "OrderState":"FullyExecuted",
                    //             "ReceiveTime":1607585844956,
                    //             "ReceiveTimeTicks":637431826449564182,
                    //             "LastUpdatedTime":1607585844959,
                    //             "LastUpdatedTimeTicks":637431826449593893,
                    //             "OrigQuantity":0.1230000000000000000000000000,
                    //             "QuantityExecuted":0.1230000000000000000000000000,
                    //             "GrossValueExecuted":2345.3947500000000000000000000,
                    //             "ExecutableValue":0.0000000000000000000000000000,
                    //             "AvgPrice":19068.250000000000000000000000,
                    //             "CounterPartyId":0,
                    //             "ChangeReason":"Trade",
                    //             "OrigOrderId":2543565235,
                    //             "OrigClOrdId":0,
                    //             "EnteredBy":446,
                    //             "UserName":"igor@ccxt.trade",
                    //             "IsQuote":false,
                    //             "InsideAsk":19069.320000000000000000000000,
                    //             "InsideAskSize":0.0997360000000000000000000000,
                    //             "InsideBid":19068.250000000000000000000000,
                    //             "InsideBidSize":1.3300010000000000000000000000,
                    //             "LastTradePrice":19068.250000000000000000000000,
                    //             "RejectReason":"",
                    //             "IsLockedIn":false,
                    //             "CancelReason":"",
                    //             "OrderFlag":"0",
                    //             "UseMargin":false,
                    //             "StopPrice":0.0000000000000000000000000000,
                    //             "PegPriceType":"Unknown",
                    //             "PegOffset":0.0000000000000000000000000000,
                    //             "PegLimitOffset":0.0000000000000000000000000000,
                    //             "IpAddress":"x.x.x.x",
                    //             "ClientOrderIdUuid":null,
                    //             "OMSId":1
                    //         },
                    //     ]
                    //
                    const grouped = this.groupBy(response, 'ChangeReason');
                    const trades = this.safeValue(grouped, 'Trade', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchDepositAddress(code, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    params = this.omit(params, [
                        'accountId',
                        'AccountId'
                    ]);
                    const currency = this.currency(code);
                    const request = {
                        'omsId': omsId,
                        'AccountId': accountId,
                        'ProductId': currency['id'],
                        'GenerateNewKey': false
                    };
                    const response = await this.privateGetGetDepositInfo(this.extend(request, params));
                    //
                    //     {
                    //         "result":true,
                    //         "errormsg":null,
                    //         "statuscode":0,
                    //         "AssetManagerId":1,
                    //         "AccountId":57922,
                    //         "AssetId":16,
                    //         "ProviderId":23,
                    //         "DepositInfo":"[\"0x8A27564b5c30b91C93B1591821642420F323a210\"]"
                    //     }
                    //
                    return this.parseDepositAddress(response, currency);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    // fetchDepositAddress, createDepositAddress
                    //
                    //     {
                    //         "result":true,
                    //         "errormsg":null,
                    //         "statuscode":0,
                    //         "AssetManagerId":1,
                    //         "AccountId":449,
                    //         "AssetId":1,
                    //         "ProviderId":1,
                    //         "DepositInfo":"[\"r3e95RwVsLH7yCbnMfyh7SA8FdwUJCB4S2?memo=241452010\"]"
                    //     }
                    //
                    const depositInfoString = this.safeString(depositAddress, 'DepositInfo');
                    const depositInfo = JSON.parse(depositInfoString);
                    const depositInfoLength = depositInfo.length;
                    const lastString = this.safeString(depositInfo, depositInfoLength - 1);
                    const parts = lastString.split('?memo=');
                    const address = this.safeString(parts, 0);
                    const tag = this.safeString(parts, 1);
                    let code = undefined;
                    if (currency !== undefined) code = currency['code'];
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': depositAddress
                    };
                }
                async createDepositAddress(code, params = {}) {
                    const request = {
                        'GenerateNewKey': true
                    };
                    return await this.fetchDepositAddress(code, this.extend(request, params));
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    params = this.omit(params, [
                        'accountId',
                        'AccountId'
                    ]);
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const request = {
                        'omsId': omsId,
                        'AccountId': accountId
                    };
                    const response = await this.privateGetGetDeposits(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "OMSId":1,
                    //             "DepositId":44,
                    //             "AccountId":449,
                    //             "SubAccountId":0,
                    //             "ProductId":4,
                    //             "Amount":200.00000000000000000000000000,
                    //             "LastUpdateTimeStamp":637431291261187806,
                    //             "ProductType":"CryptoCurrency",
                    //             "TicketStatus":"FullyProcessed",
                    //             "DepositInfo":"{}",
                    //             "DepositCode":"ab0e23d5-a9ce-4d94-865f-9ab464fb1de3",
                    //             "TicketNumber":71,
                    //             "NotionalProductId":13,
                    //             "NotionalValue":200.00000000000000000000000000,
                    //             "FeeAmount":0.0000000000000000000000000000,
                    //         },
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    params = this.omit(params, [
                        'accountId',
                        'AccountId'
                    ]);
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const request = {
                        'omsId': omsId,
                        'AccountId': accountId
                    };
                    const response = await this.privateGetGetWithdraws(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "Amount": 0.0,
                    //             "FeeAmount": 0.0,
                    //             "NotionalValue": 0.0,
                    //             "WithdrawId": 0,
                    //             "AssetManagerId": 0,
                    //             "AccountId": 0,
                    //             "AssetId": 0,
                    //             "TemplateForm": "{\"TemplateType\": \"TetherRPCWithdraw\",\"Comment\": \"TestWithdraw\",\"ExternalAddress\": \"ms6C3pKAAr8gRCcnVebs8VRkVrjcvqNYv3\"}",
                    //             "TemplateFormType": "TetherRPCWithdraw",
                    //             "omsId": 0,
                    //             "TicketStatus": 0,
                    //             "TicketNumber": 0,
                    //             "WithdrawTransactionDetails": "",
                    //             "WithdrawType": "",
                    //             "WithdrawCode": "490b4fa3-53fc-44f4-bd29-7e16be86fba3",
                    //             "AssetType": 0,
                    //             "Reaccepted": true,
                    //             "NotionalProductId": 0
                    //         },
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit);
                }
                parseTransactionStatusByType(status, type) {
                    const statusesByType = {
                        'deposit': {
                            'New': 'pending',
                            'AdminProcessing': 'pending',
                            'Accepted': 'pending',
                            'Rejected': 'rejected',
                            'SystemProcessing': 'pending',
                            'FullyProcessed': 'ok',
                            'Failed': 'failed',
                            'Pending': 'pending',
                            'Confirmed': 'pending',
                            'AmlProcessing': 'pending',
                            'AmlAccepted': 'pending',
                            'AmlRejected': 'rejected',
                            'AmlFailed': 'failed',
                            'LimitsAccepted': 'pending',
                            'LimitsRejected': 'rejected'
                        },
                        'withdrawal': {
                            'New': 'pending',
                            'AdminProcessing': 'pending',
                            'Accepted': 'pending',
                            'Rejected': 'rejected',
                            'SystemProcessing': 'pending',
                            'FullyProcessed': 'ok',
                            'Failed': 'failed',
                            'Pending': 'pending',
                            'Pending2Fa': 'pending',
                            'AutoAccepted': 'pending',
                            'Delayed': 'pending',
                            'UserCanceled': 'canceled',
                            'AdminCanceled': 'canceled',
                            'AmlProcessing': 'pending',
                            'AmlAccepted': 'pending',
                            'AmlRejected': 'rejected',
                            'AmlFailed': 'failed',
                            'LimitsAccepted': 'pending',
                            'LimitsRejected': 'rejected',
                            'Submitted': 'pending',
                            'Confirmed': 'pending',
                            'ManuallyConfirmed': 'pending',
                            'Confirmed2Fa': 'pending'
                        }
                    };
                    const statuses = this.safeValue(statusesByType, type, {});
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "OMSId":1,
                    //         "DepositId":44,
                    //         "AccountId":449,
                    //         "SubAccountId":0,
                    //         "ProductId":4,
                    //         "Amount":200.00000000000000000000000000,
                    //         "LastUpdateTimeStamp":637431291261187806,
                    //         "ProductType":"CryptoCurrency",
                    //         "TicketStatus":"FullyProcessed",
                    //         "DepositInfo":"{}",
                    //         "DepositCode":"ab0e23d5-a9ce-4d94-865f-9ab464fb1de3",
                    //         "TicketNumber":71,
                    //         "NotionalProductId":13,
                    //         "NotionalValue":200.00000000000000000000000000,
                    //         "FeeAmount":0.0000000000000000000000000000,
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "Amount": 0.0,
                    //         "FeeAmount": 0.0,
                    //         "NotionalValue": 0.0,
                    //         "WithdrawId": 0,
                    //         "AssetManagerId": 0,
                    //         "AccountId": 0,
                    //         "AssetId": 0,
                    //         "TemplateForm": "{\"TemplateType\": \"TetherRPCWithdraw\",\"Comment\": \"TestWithdraw\",\"ExternalAddress\": \"ms6C3pKAAr8gRCcnVebs8VRkVrjcvqNYv3\"}",
                    //         "TemplateFormType": "TetherRPCWithdraw",
                    //         "omsId": 0,
                    //         "TicketStatus": 0,
                    //         "TicketNumber": 0,
                    //         "WithdrawTransactionDetails": "",
                    //         "WithdrawType": "",
                    //         "WithdrawCode": "490b4fa3-53fc-44f4-bd29-7e16be86fba3",
                    //         "AssetType": 0,
                    //         "Reaccepted": true,
                    //         "NotionalProductId": 0
                    //     }
                    //
                    let id = undefined;
                    let txid = undefined;
                    const currencyId = this.safeString(transaction, 'ProductId');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    let timestamp = undefined;
                    let type = undefined;
                    if ('DepositId' in transaction) {
                        id = this.safeString(transaction, 'DepositId');
                        type = 'deposit';
                    } else if ('WithdrawId' in transaction) {
                        id = this.safeString(transaction, 'WithdrawId');
                        type = 'withdrawal';
                    }
                    const templateFormString = this.safeString(transaction, 'TemplateForm');
                    let address = undefined;
                    let updated = this.safeInteger(transaction, 'LastUpdateTimeStamp');
                    if (templateFormString !== undefined) {
                        const templateForm = JSON.parse(templateFormString);
                        address = this.safeString(templateForm, 'ExternalAddress');
                        txid = this.safeString(templateForm, 'TxId');
                        timestamp = this.safeInteger(templateForm, 'TimeSubmitted');
                        updated = this.safeInteger(templateForm, 'LastUpdated', updated);
                    }
                    const addressTo = address;
                    const status = this.parseTransactionStatusByType(this.safeString(transaction, 'TicketStatus'), type);
                    const amount = this.safeNumber(transaction, 'Amount');
                    const feeCost = this.safeNumber(transaction, 'FeeAmount');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'currency': code,
                        'cost': feeCost
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'address': address,
                        'addressTo': addressTo,
                        'addressFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    // this method required login, password and twofa key
                    const sessionToken = this.safeString(this.options, 'sessionToken');
                    if (sessionToken === undefined) throw new AuthenticationError(this.id + ' call signIn() method to obtain a session token');
                    if (this.twofa === undefined) throw new AuthenticationError(this.id + ' withdraw() requires exchange.twofa credentials');
                    this.checkAddress(address);
                    const omsId = this.safeInteger(this.options, 'omsId', 1);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeInteger2(this.options, 'accountId', 'AccountId', parseInt(this.accounts[0]['id']));
                    const accountId = this.safeInteger2(params, 'accountId', 'AccountId', defaultAccountId);
                    params = this.omit(params, [
                        'accountId',
                        'AccountId'
                    ]);
                    const currency = this.currency(code);
                    const withdrawTemplateTypesRequest = {
                        'omsId': omsId,
                        'AccountId': accountId,
                        'ProductId': currency['id']
                    };
                    const withdrawTemplateTypesResponse = await this.privateGetGetWithdrawTemplateTypes(withdrawTemplateTypesRequest);
                    //
                    //     {
                    //         result: true,
                    //         errormsg: null,
                    //         statuscode: "0",
                    //         TemplateTypes: [
                    //             { AccountProviderId: "14", TemplateName: "ToExternalBitcoinAddress", AccountProviderName: "BitgoRPC-BTC" },
                    //             { AccountProviderId: "20", TemplateName: "ToExternalBitcoinAddress", AccountProviderName: "TrezorBTC" },
                    //             { AccountProviderId: "31", TemplateName: "BTC", AccountProviderName: "BTC Fireblocks 1" }
                    //         ]
                    //     }
                    //
                    const templateTypes = this.safeValue(withdrawTemplateTypesResponse, 'TemplateTypes', []);
                    const firstTemplateType = this.safeValue(templateTypes, 0);
                    if (firstTemplateType === undefined) throw new ExchangeError1(this.id + ' withdraw() could not find a withdraw template type for ' + currency['code']);
                    const templateName = this.safeString(firstTemplateType, 'TemplateName');
                    const withdrawTemplateRequest = {
                        'omsId': omsId,
                        'AccountId': accountId,
                        'ProductId': currency['id'],
                        'TemplateType': templateName,
                        'AccountProviderId': firstTemplateType['AccountProviderId']
                    };
                    const withdrawTemplateResponse = await this.privateGetGetWithdrawTemplate(withdrawTemplateRequest);
                    //
                    //     {
                    //         result: true,
                    //         errormsg: null,
                    //         statuscode: "0",
                    //         Template: "{\"TemplateType\":\"ToExternalBitcoinAddress\",\"Comment\":\"\",\"ExternalAddress\":\"\"}"
                    //     }
                    //
                    const template = this.safeString(withdrawTemplateResponse, 'Template');
                    if (template === undefined) throw new ExchangeError1(this.id + ' withdraw() could not find a withdraw template for ' + currency['code']);
                    const withdrawTemplate = JSON.parse(template);
                    withdrawTemplate['ExternalAddress'] = address;
                    if (tag !== undefined) {
                        if ('Memo' in withdrawTemplate) withdrawTemplate['Memo'] = tag;
                    }
                    const withdrawPayload = {
                        'omsId': omsId,
                        'AccountId': accountId,
                        'ProductId': currency['id'],
                        'TemplateForm': this.json(withdrawTemplate),
                        'TemplateType': templateName
                    };
                    const withdrawRequest = {
                        'TfaType': 'Google',
                        'TFaCode': this.oath(),
                        'Payload': this.json(withdrawPayload)
                    };
                    const response = await this.privatePostCreateWithdrawTicket(this.deepExtend(withdrawRequest, params));
                    return this.parseTransaction(response, currency);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/' + this.implodeParams(path, params);
                    let query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (path === 'Authenticate') {
                            const auth = this.login + ':' + this.password;
                            const auth64 = this.stringToBase64(auth);
                            headers = {
                                'Authorization': 'Basic ' + this.decode(auth64)
                            };
                        } else if (path === 'Authenticate2FA') {
                            const pending2faToken = this.safeString(this.options, 'pending2faToken');
                            if (pending2faToken !== undefined) {
                                headers = {
                                    'Pending2FaToken': pending2faToken
                                };
                                query = this.omit(query, 'pending2faToken');
                            }
                        }
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'private') {
                        this.checkRequiredCredentials();
                        const sessionToken = this.safeString(this.options, 'sessionToken');
                        if (sessionToken === undefined) {
                            const nonce = this.nonce().toString();
                            const auth = nonce + this.uid + this.apiKey;
                            const signature = this.hmac(this.encode(auth), this.encode(this.secret));
                            headers = {
                                'Nonce': nonce,
                                'APIKey': this.apiKey,
                                'Signature': signature,
                                'UserId': this.uid
                            };
                        } else headers = {
                            'APToken': sessionToken
                        };
                        if (method === 'POST') {
                            headers['Content-Type'] = 'application/json';
                            body = this.json(query);
                        } else if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (code === 404) throw new AuthenticationError(this.id + ' ' + body);
                    if (response === undefined) return;
                    //
                    //     {"status":"Rejected","errormsg":"Not_Enough_Funds","errorcode":101}
                    //     {"result":false,"errormsg":"Server Error","errorcode":102,"detail":null}
                    //
                    const message = this.safeString(response, 'errormsg');
                    if (message !== undefined && message !== '') {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    108: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, PermissionDenied: PermissionDenied, BadRequest: BadRequest, CancelPending: CancelPending, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, RateLimitExceeded: RateLimitExceeded, InvalidOrder: InvalidOrder, AccountSuspended: AccountSuspended, BadSymbol: BadSymbol, OnMaintenance: OnMaintenance, ArgumentsRequired: ArgumentsRequired1, AccountNotEnabled: AccountNotEnabled } = require1('./base/errors');
            const { TRUNCATE: TRUNCATE } = require1('./base/functions/number');
            //  ---------------------------------------------------------------------------
            module.exports = class novadax extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'novadax',
                        'name': 'NovaDAX',
                        'countries': [
                            'BR'
                        ],
                        // 60 requests per second = 1000ms / 60 = 16.6667ms between requests (public endpoints, limited by IP address)
                        // 20 requests per second => cost = 60 / 20 = 3 (private endpoints, limited by API Key)
                        'rateLimit': 16.6667,
                        'version': 'v1',
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransactions': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': 'ONE_MIN',
                            '5m': 'FIVE_MIN',
                            '15m': 'FIFTEEN_MIN',
                            '30m': 'HALF_HOU',
                            '1h': 'ONE_HOU',
                            '1d': 'ONE_DAY',
                            '1w': 'ONE_WEE',
                            '1M': 'ONE_MON'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/92337550-2b085500-f0b3-11ea-98e7-5794fb07dd3b.jpg',
                            'api': {
                                'public': 'https://api.novadax.com',
                                'private': 'https://api.novadax.com'
                            },
                            'www': 'https://www.novadax.com.br',
                            'doc': [
                                'https://doc.novadax.com/pt-BR/'
                            ],
                            'fees': 'https://www.novadax.com.br/fees-and-limits',
                            'referral': 'https://www.novadax.com.br/?s=ccxt'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'common/symbol': 1.2,
                                    'common/symbols': 1.2,
                                    'common/timestamp': 1.2,
                                    'market/tickers': 1.2,
                                    'market/ticker': 1.2,
                                    'market/depth': 1.2,
                                    'market/trades': 1.2,
                                    'market/kline/history': 1.2
                                }
                            },
                            'private': {
                                'get': {
                                    'orders/get': 3,
                                    'orders/list': 3,
                                    'orders/fill': 3,
                                    'orders/fills': 3,
                                    'account/getBalance': 3,
                                    'account/subs': 3,
                                    'account/subs/balance': 3,
                                    'account/subs/transfer/record': 3,
                                    'wallet/query/deposit-withdraw': 3
                                },
                                'post': {
                                    'orders/create': 3,
                                    'orders/cancel': 3,
                                    'account/withdraw/coin': 3,
                                    'account/subs/transfer': 3
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'taker': this.parseNumber('0.005'),
                                'maker': this.parseNumber('0.0025')
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true
                        },
                        'exceptions': {
                            'exact': {
                                'A99999': ExchangeError1,
                                // 'A10000': ExchangeError, // 200 Success Successful request
                                'A10001': BadRequest,
                                'A10002': ExchangeError1,
                                'A10003': AuthenticationError,
                                'A10004': RateLimitExceeded,
                                'A10005': PermissionDenied,
                                'A10006': AccountSuspended,
                                'A10007': AccountNotEnabled,
                                'A10011': BadSymbol,
                                'A10012': BadSymbol,
                                'A10013': OnMaintenance,
                                'A30001': OrderNotFound,
                                'A30002': InvalidOrder,
                                'A30003': InvalidOrder,
                                'A30004': InvalidOrder,
                                'A30005': InvalidOrder,
                                'A30006': InvalidOrder,
                                'A30007': InsufficientFunds,
                                'A30008': InvalidOrder,
                                'A30009': InvalidOrder,
                                'A30010': CancelPending,
                                'A30011': InvalidOrder,
                                'A30012': InvalidOrder,
                                'A40004': InsufficientFunds
                            },
                            'broad': {}
                        },
                        'options': {
                            'fetchOHLCV': {
                                'volume': 'amount'
                            },
                            'transfer': {
                                'fillResponseFromRequest': true
                            }
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetCommonTimestamp(params);
                    //
                    //     {
                    //         "code":"A10000",
                    //         "data":1599090512080,
                    //         "message":"Success"
                    //     }
                    //
                    return this.safeInteger(response, 'data');
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetCommonSymbols(params);
                    //
                    //     {
                    //         "code":"A10000",
                    //         "data":[
                    //             {
                    //                 "amountPrecision":8,
                    //                 "baseCurrency":"BTC",
                    //                 "minOrderAmount":"0.001",
                    //                 "minOrderValue":"25",
                    //                 "pricePrecision":2,
                    //                 "quoteCurrency":"BRL",
                    //                 "status":"ONLINE",
                    //                 "symbol":"BTC_BRL",
                    //                 "valuePrecision":2
                    //             },
                    //         ],
                    //         "message":"Success"
                    //     }
                    //
                    const result = [];
                    const data = this.safeValue(response, 'data', []);
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const baseId = this.safeString(market, 'baseCurrency');
                        const quoteId = this.safeString(market, 'quoteCurrency');
                        const id = this.safeString(market, 'symbol');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const status = this.safeString(market, 'status');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': status === 'ONLINE',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'amountPrecision'),
                                'price': this.safeInteger(market, 'pricePrecision'),
                                'cost': this.safeInteger(market, 'valuePrecision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minOrderAmount'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minOrderValue'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker, fetchTickers
                    //
                    //     {
                    //         "ask":"61946.1",
                    //         "baseVolume24h":"164.41930186",
                    //         "bid":"61815",
                    //         "high24h":"64930.72",
                    //         "lastPrice":"61928.41",
                    //         "low24h":"61156.32",
                    //         "open24h":"64512.46",
                    //         "quoteVolume24h":"10308157.95",
                    //         "symbol":"BTC_BRL",
                    //         "timestamp":1599091115090
                    //     }
                    //
                    const timestamp = this.safeInteger(ticker, 'timestamp');
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const open = this.safeNumber(ticker, 'open24h');
                    const last = this.safeNumber(ticker, 'lastPrice');
                    const baseVolume = this.safeNumber(ticker, 'baseVolume24h');
                    const quoteVolume = this.safeNumber(ticker, 'quoteVolume24h');
                    const vwap = this.vwap(baseVolume, quoteVolume);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeNumber(ticker, 'high24h'),
                        'low': this.safeNumber(ticker, 'low24h'),
                        'bid': this.safeNumber(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeNumber(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': vwap,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.publicGetMarketTicker(this.extend(request, params));
                    //
                    //     {
                    //         "code":"A10000",
                    //         "data":{
                    //             "ask":"61946.1",
                    //             "baseVolume24h":"164.41930186",
                    //             "bid":"61815",
                    //             "high24h":"64930.72",
                    //             "lastPrice":"61928.41",
                    //             "low24h":"61156.32",
                    //             "open24h":"64512.46",
                    //             "quoteVolume24h":"10308157.95",
                    //             "symbol":"BTC_BRL",
                    //             "timestamp":1599091115090
                    //         },
                    //         "message":"Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTicker(data, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetMarketTickers(params);
                    //
                    //     {
                    //         "code":"A10000",
                    //         "data":[
                    //             {
                    //                 "ask":"61879.36",
                    //                 "baseVolume24h":"164.40955092",
                    //                 "bid":"61815",
                    //                 "high24h":"64930.72",
                    //                 "lastPrice":"61820.04",
                    //                 "low24h":"61156.32",
                    //                 "open24h":"64624.19",
                    //                 "quoteVolume24h":"10307493.92",
                    //                 "symbol":"BTC_BRL",
                    //                 "timestamp":1599091291083
                    //             },
                    //         ],
                    //         "message":"Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = {};
                    for(let i = 0; i < data.length; i++){
                        const ticker = this.parseTicker(data[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 10, max 20
                    const response = await this.publicGetMarketDepth(this.extend(request, params));
                    //
                    //     {
                    //         "code":"A10000",
                    //         "data":{
                    //             "asks":[
                    //                 ["0.037159","0.3741"],
                    //                 ["0.037215","0.2706"],
                    //                 ["0.037222","1.8459"],
                    //             ],
                    //             "bids":[
                    //                 ["0.037053","0.3857"],
                    //                 ["0.036969","0.8101"],
                    //                 ["0.036953","1.5226"],
                    //             ],
                    //             "timestamp":1599280414448
                    //         },
                    //         "message":"Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const timestamp = this.safeInteger(data, 'timestamp');
                    return this.parseOrderBook(data, symbol, timestamp, 'bids', 'asks');
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     {
                    //         "amount":"0.0632",
                    //         "price":"0.037288",
                    //         "side":"BUY",
                    //         "timestamp":1599279694576
                    //     }
                    //
                    // private fetchOrderTrades
                    //
                    //      {
                    //          "id": "608717046691139584",
                    //          "orderId": "608716957545402368",
                    //          "symbol": "BTC_BRL",
                    //          "side": "BUY",
                    //          "amount": "0.0988",
                    //          "price": "45514.76",
                    //          "fee": "0.0000988 BTC",
                    //          "feeAmount": "0.0000988",
                    //          "feeCurrency": "BTC",
                    //          "role": "MAKER",
                    //          "timestamp": 1565171053345
                    //       }
                    //
                    // private fetchMyTrades (same endpoint as fetchOrderTrades)
                    //
                    //      {
                    //          "id": "608717046691139584",
                    //          "orderId": "608716957545402368",
                    //          "symbol": "BTC_BRL",
                    //          "side": "BUY",
                    //          "amount": "0.0988",
                    //          "price": "45514.76",
                    //          "fee": "0.0000988 BTC",
                    //          "feeAmount": "0.0000988",
                    //          "feeCurrency": "BTC",
                    //          "role": "MAKER",
                    //          "timestamp": 1565171053345
                    //       }
                    //
                    const id = this.safeString(trade, 'id');
                    const orderId = this.safeString(trade, 'orderId');
                    const timestamp = this.safeInteger(trade, 'timestamp');
                    const side = this.safeStringLower(trade, 'side');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const marketId = this.safeString(trade, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const takerOrMaker = this.safeStringLower(trade, 'role');
                    const feeString = this.safeString(trade, 'fee');
                    let fee = undefined;
                    if (feeString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'feeCurrency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': this.safeString(trade, 'feeAmount'),
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeTrade({
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'takerOrMaker': takerOrMaker,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 100
                    const response = await this.publicGetMarketTrades(this.extend(request, params));
                    //
                    //     {
                    //         "code":"A10000",
                    //         "data":[
                    //             {"amount":"0.0632","price":"0.037288","side":"BUY","timestamp":1599279694576},
                    //             {"amount":"0.0052","price":"0.03715","side":"SELL","timestamp":1599276606852},
                    //             {"amount":"0.0058","price":"0.037188","side":"SELL","timestamp":1599275187812},
                    //         ],
                    //         "message":"Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'unit': this.timeframes[timeframe]
                    };
                    const duration = this.parseTimeframe(timeframe);
                    const now = this.seconds();
                    if (limit === undefined) limit = 3000; // max
                    if (since === undefined) {
                        request['from'] = now - limit * duration;
                        request['to'] = now;
                    } else {
                        const startFrom = parseInt(since / 1000);
                        request['from'] = startFrom;
                        request['to'] = this.sum(startFrom, limit * duration);
                    }
                    const response = await this.publicGetMarketKlineHistory(this.extend(request, params));
                    //
                    //     {
                    //         "code": "A10000",
                    //         "data": [
                    //             {
                    //                 "amount": 8.25709100,
                    //                 "closePrice": 62553.20,
                    //                 "count": 29,
                    //                 "highPrice": 62592.87,
                    //                 "lowPrice": 62553.20,
                    //                 "openPrice": 62554.23,
                    //                 "score": 1602501480,
                    //                 "symbol": "BTC_BRL",
                    //                 "vol": 516784.2504067500
                    //             }
                    //         ],
                    //         "message": "Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "amount": 8.25709100,
                    //         "closePrice": 62553.20,
                    //         "count": 29,
                    //         "highPrice": 62592.87,
                    //         "lowPrice": 62553.20,
                    //         "openPrice": 62554.23,
                    //         "score": 1602501480,
                    //         "symbol": "BTC_BRL",
                    //         "vol": 516784.2504067500
                    //     }
                    //
                    const options = this.safeValue(this.options, 'fetchOHLCV', {});
                    const volumeField = this.safeString(options, 'volume', 'amount'); // or vol
                    return [
                        this.safeTimestamp(ohlcv, 'score'),
                        this.safeNumber(ohlcv, 'openPrice'),
                        this.safeNumber(ohlcv, 'highPrice'),
                        this.safeNumber(ohlcv, 'lowPrice'),
                        this.safeNumber(ohlcv, 'closePrice'),
                        this.safeNumber(ohlcv, volumeField)
                    ];
                }
                parseBalance(response) {
                    const data = this.safeValue(response, 'data', []);
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < data.length; i++){
                        const balance = data[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'balance');
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'hold');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountGetBalance(params);
                    //
                    //     {
                    //         "code": "A10000",
                    //         "data": [
                    //             {
                    //                 "available": "1.23",
                    //                 "balance": "0.23",
                    //                 "currency": "BTC",
                    //                 "hold": "1"
                    //             }
                    //         ],
                    //         "message": "Success"
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let uppercaseType = type.toUpperCase();
                    const uppercaseSide = side.toUpperCase();
                    const request = {
                        'symbol': market['id'],
                        'side': uppercaseSide
                    };
                    const stopPrice = this.safeNumber(params, 'stopPrice');
                    if (stopPrice === undefined) {
                        if (uppercaseType === 'STOP_LIMIT' || uppercaseType === 'STOP_MARKET') throw new ArgumentsRequired1(this.id + ' createOrder() requires a stopPrice parameter for ' + uppercaseType + ' orders');
                    } else {
                        if (uppercaseType === 'LIMIT') uppercaseType = 'STOP_LIMIT';
                        else if (uppercaseType === 'MARKET') uppercaseType = 'STOP_MARKET';
                        const defaultOperator = uppercaseSide === 'BUY' ? 'LTE' : 'GTE';
                        request['operator'] = this.safeString(params, 'operator', defaultOperator);
                        request['stopPrice'] = this.priceToPrecision(symbol, stopPrice);
                        params = this.omit(params, 'stopPrice');
                    }
                    if (uppercaseType === 'LIMIT' || uppercaseType === 'STOP_LIMIT') {
                        request['price'] = this.priceToPrecision(symbol, price);
                        request['amount'] = this.amountToPrecision(symbol, amount);
                    } else if (uppercaseType === 'MARKET' || uppercaseType === 'STOP_MARKET') {
                        if (uppercaseSide === 'SELL') request['amount'] = this.amountToPrecision(symbol, amount);
                        else if (uppercaseSide === 'BUY') {
                            let value = this.safeNumber(params, 'value');
                            const createMarketBuyOrderRequiresPrice = this.safeValue(this.options, 'createMarketBuyOrderRequiresPrice', true);
                            if (createMarketBuyOrderRequiresPrice) {
                                if (price !== undefined) {
                                    if (value === undefined) value = amount * price;
                                } else if (value === undefined) throw new InvalidOrder(this.id + " createOrder() requires the price argument with market buy orders to calculate total order cost (amount to spend), where cost = amount * price. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount, or, alternatively, add .options['createMarketBuyOrderRequiresPrice'] = false and supply the total cost value in the 'amount' argument or in the 'value' extra parameter (the exchange-specific behaviour)");
                            } else value = value === undefined ? amount : value;
                            const precision = market['precision']['price'];
                            request['value'] = this.decimalToPrecision(value, TRUNCATE, precision, this.precisionMode);
                        }
                    }
                    request['type'] = uppercaseType;
                    const response = await this.privatePostOrdersCreate(this.extend(request, params));
                    //
                    //     {
                    //         "code": "A10000",
                    //         "data": {
                    //             "amount": "0.001",
                    //             "averagePrice": null,
                    //             "filledAmount": "0",
                    //             "filledFee": "0",
                    //             "filledValue": "0",
                    //             "id": "870613508008464384",
                    //             "operator": "GTE",
                    //             "price": "210000",
                    //             "side": "BUY",
                    //             "status": "SUBMITTED",
                    //             "stopPrice": "211000",
                    //             "symbol": "BTC_BRL",
                    //             "timestamp": 1627612035528,
                    //             "type": "STOP_LIMIT",
                    //             "value": "210"
                    //         },
                    //         "message": "Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privatePostOrdersCancel(this.extend(request, params));
                    //
                    //     {
                    //         "code": "A10000",
                    //         "data": {
                    //             "result": true
                    //         },
                    //         "message": "Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetOrdersGet(this.extend(request, params));
                    //
                    //     {
                    //         "code": "A10000",
                    //         "data": {
                    //             "id": "608695623247466496",
                    //             "symbol": "BTC_BRL",
                    //             "type": "MARKET",
                    //             "side": "SELL",
                    //             "price": null,
                    //             "averagePrice": "0",
                    //             "amount": "0.123",
                    //             "filledAmount": "0",
                    //             "value": null,
                    //             "filledValue": "0",
                    //             "filledFee": "0",
                    //             "status": "REJECTED",
                    //             "timestamp": 1565165945588
                    //         },
                    //         "message": "Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 100
                    if (since !== undefined) request['fromTimestamp'] = since;
                    const response = await this.privateGetOrdersList(this.extend(request, params));
                    //
                    //     {
                    //         "code": "A10000",
                    //         "data": [
                    //             {
                    //                 "id": "608695678650028032",
                    //                 "symbol": "BTC_BRL",
                    //                 "type": "MARKET",
                    //                 "side": "SELL",
                    //                 "price": null,
                    //                 "averagePrice": "0",
                    //                 "amount": "0.123",
                    //                 "filledAmount": "0",
                    //                 "value": null,
                    //                 "filledValue": "0",
                    //                 "filledFee": "0",
                    //                 "status": "REJECTED",
                    //                 "timestamp": 1565165958796
                    //             },
                    //         ],
                    //         "message": "Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'SUBMITTED,PROCESSING,PARTIAL_FILLED,CANCELING'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'FILLED,CANCELED,REJECTED'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const response = await this.privateGetOrdersFill(this.extend(request, params));
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const data = this.safeValue(response, 'data', []);
                    //
                    //      {
                    //          "code": "A10000",
                    //          "data": [
                    //              {
                    //                  "id": "608717046691139584",
                    //                  "orderId": "608716957545402368",
                    //                  "symbol": "BTC_BRL",
                    //                  "side": "BUY",
                    //                  "amount": "0.0988",
                    //                  "price": "45514.76",
                    //                  "fee": "0.0000988 BTC",
                    //                  "feeAmount": "0.0000988",
                    //                  "feeCurrency": "BTC",
                    //                  "role": "MAKER",
                    //                  "timestamp": 1565171053345
                    //              },
                    //          ],
                    //          "message": "Success"
                    //      }
                    //
                    return this.parseTrades(data, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'SUBMITTED': 'open',
                        'PROCESSING': 'open',
                        'PARTIAL_FILLED': 'open',
                        'CANCELING': 'open',
                        'FILLED': 'closed',
                        'CANCELED': 'canceled',
                        'REJECTED': 'rejected'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder, fetchOrders, fetchOrder
                    //
                    //     {
                    //         "amount": "0.001",
                    //         "averagePrice": null,
                    //         "filledAmount": "0",
                    //         "filledFee": "0",
                    //         "filledValue": "0",
                    //         "id": "870613508008464384",
                    //         "operator": "GTE",
                    //         "price": "210000",
                    //         "side": "BUY",
                    //         "status": "SUBMITTED",
                    //         "stopPrice": "211000",
                    //         "symbol": "BTC_BRL",
                    //         "timestamp": 1627612035528,
                    //         "type": "STOP_LIMIT",
                    //         "value": "210"
                    //     }
                    //
                    // cancelOrder
                    //
                    //     {
                    //         "result": true
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const amount = this.safeString(order, 'amount');
                    const price = this.safeString(order, 'price');
                    const cost = this.safeString2(order, 'filledValue', 'value');
                    const type = this.safeStringLower(order, 'type');
                    const side = this.safeStringLower(order, 'side');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const timestamp = this.safeInteger(order, 'timestamp');
                    const average = this.safeString(order, 'averagePrice');
                    const filled = this.safeString(order, 'filledAmount');
                    let fee = undefined;
                    const feeCost = this.safeNumber(order, 'filledFee');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': undefined
                    };
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const stopPrice = this.safeNumber(order, 'stopPrice');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': cost,
                        'average': average,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (fromAccount !== 'main' && toAccount !== 'main') throw new ExchangeError1(this.id + ' transfer() supports transfers between main account and subaccounts only');
                    // master-transfer-in = from master account to subaccount
                    // master-transfer-out = from subaccount to master account
                    const type = fromAccount === 'main' ? 'master-transfer-in' : 'master-transfer-out';
                    const request = {
                        'transferAmount': this.currencyToPrecision(code, amount),
                        'currency': currency['id'],
                        'subId': type === 'master-transfer-in' ? toAccount : fromAccount,
                        'transferType': type
                    };
                    const response = await this.privatePostAccountSubsTransfer(this.extend(request, params));
                    //
                    //    {
                    //        "code":"A10000",
                    //        "message":"Success",
                    //        "data":40
                    //    }
                    //
                    const transfer = this.parseTransfer(response, currency);
                    const transferOptions = this.safeValue(this.options, 'transfer', {});
                    const fillResponseFromRequest = this.safeValue(transferOptions, 'fillResponseFromRequest', true);
                    if (fillResponseFromRequest) {
                        transfer['fromAccount'] = fromAccount;
                        transfer['toAccount'] = toAccount;
                        transfer['amount'] = amount;
                    }
                    return transfer;
                }
                parseTransfer(transfer, currency) {
                    //
                    //    {
                    //        "code":"A10000",
                    //        "message":"Success",
                    //        "data":40
                    //    }
                    //
                    const id = this.safeString(transfer, 'data');
                    const status = this.safeString(transfer, 'message');
                    return {
                        'info': transfer,
                        'id': id,
                        'amount': undefined,
                        'code': this.safeCurrencyCode(undefined, currency),
                        'fromAccount': undefined,
                        'toAccount': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'status': status
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'SUCCESS': 'pending'
                    };
                    return this.safeString(statuses, status, 'failed');
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'code': currency['id'],
                        'amount': this.currencyToPrecision(code, amount),
                        'wallet': address
                    };
                    if (tag !== undefined) request['tag'] = tag;
                    const response = await this.privatePostAccountWithdrawCoin(this.extend(request, params));
                    //
                    //     {
                    //         "code":"A10000",
                    //         "data": "DR123",
                    //         "message":"Success"
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                async fetchAccounts(params = {}) {
                    const response = await this.privateGetAccountSubs(params);
                    //
                    //     {
                    //         "code": "A10000",
                    //         "data": [
                    //             {
                    //                 "subId": "CA648856083527372800",
                    //                 "state": "Normal",
                    //                 "subAccount": "003",
                    //                 "subIdentify": "003"
                    //             }
                    //         ],
                    //         "message": "Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const account = data[i];
                        const accountId = this.safeString(account, 'subId');
                        const type = this.safeString(account, 'subAccount');
                        result.push({
                            'id': accountId,
                            'type': type,
                            'currency': undefined,
                            'info': account
                        });
                    }
                    return result;
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    const request = {
                        'type': 'coin_in'
                    };
                    return await this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    const request = {
                        'type': 'coin_out'
                    };
                    return await this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this.privateGetWalletQueryDepositWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "code": "A10000",
                    //         "data": [
                    //             {
                    //                 "id": "DR562339304588709888",
                    //                 "type": "COIN_IN",
                    //                 "currency": "XLM",
                    //                 "chain": "XLM",
                    //                 "address": "GCUTK7KHPJC3ZQJ3OMWWFHAK2OXIBRD4LNZQRCCOVE7A2XOPP2K5PU5Q",
                    //                 "addressTag": "1000009",
                    //                 "amount": 1.0,
                    //                 "state": "SUCCESS",
                    //                 "txHash": "39210645748822f8d4ce673c7559aa6622e6e9cdd7073bc0fcae14b1edfda5f4",
                    //                 "createdAt": 1554113737000,
                    //                 "updatedAt": 1601371273000
                    //             }
                    //         ],
                    //         "message": "Success"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, currency, since, limit);
                }
                parseTransactionStatus(status) {
                    // Pending the record is wait broadcast to chain
                    // x/M confirming the comfirming state of tx, the M is total confirmings needed
                    // SUCCESS the record is success full
                    // FAIL the record failed
                    const parts = status.split(' ');
                    status = this.safeString(parts, 1, status);
                    const statuses = {
                        'Pending': 'pending',
                        'confirming': 'pending',
                        'SUCCESS': 'ok',
                        'FAIL': 'failed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "code":"A10000",
                    //         "data": "DR123",
                    //         "message":"Success"
                    //     }
                    //
                    // fetchTransactions
                    //
                    //     {
                    //         "id": "DR562339304588709888",
                    //         "type": "COIN_IN",
                    //         "currency": "XLM",
                    //         "chain": "XLM",
                    //         "address": "GCUTK7KHPJC3ZQJ3OMWWFHAK2OXIBRD4LNZQRCCOVE7A2XOPP2K5PU5Q",
                    //         "addressTag": "1000009",
                    //         "amount": 1.0,
                    //         "state": "SUCCESS",
                    //         "txHash": "39210645748822f8d4ce673c7559aa6622e6e9cdd7073bc0fcae14b1edfda5f4",
                    //         "createdAt": 1554113737000,
                    //         "updatedAt": 1601371273000
                    //     }
                    //
                    const id = this.safeString2(transaction, 'id', 'data');
                    let type = this.safeString(transaction, 'type');
                    if (type === 'COIN_IN') type = 'deposit';
                    else if (type === 'COIN_OUT') type = 'withdraw';
                    const amount = this.safeNumber(transaction, 'amount');
                    const address = this.safeString(transaction, 'address');
                    const tag = this.safeString(transaction, 'addressTag');
                    const txid = this.safeString(transaction, 'txHash');
                    const timestamp = this.safeInteger(transaction, 'createdAt');
                    const updated = this.safeInteger(transaction, 'updatedAt');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    const network = this.safeString(transaction, 'chain');
                    return {
                        'info': transaction,
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': network,
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'tagFrom': undefined,
                        'status': status,
                        'type': type,
                        'updated': updated,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': undefined
                    };
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['fromTimestamp'] = since;
                    const response = await this.privateGetOrdersFills(this.extend(request, params));
                    //
                    //      {
                    //          "code": "A10000",
                    //          "data": [
                    //              {
                    //                  "id": "608717046691139584",
                    //                  "orderId": "608716957545402368",
                    //                  "symbol": "BTC_BRL",
                    //                  "side": "BUY",
                    //                  "amount": "0.0988",
                    //                  "price": "45514.76",
                    //                  "fee": "0.0000988 BTC",
                    //                  "feeAmount": "0.0000988",
                    //                  "feeCurrency": "BTC",
                    //                  "role": "MAKER",
                    //                  "timestamp": 1565171053345
                    //              },
                    //          ],
                    //          "message": "Success"
                    //      }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const request = '/' + this.version + '/' + this.implodeParams(path, params);
                    let url = this.urls['api'][api] + request;
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.milliseconds().toString();
                        headers = {
                            'X-Nova-Access-Key': this.apiKey,
                            'X-Nova-Timestamp': timestamp
                        };
                        let queryString = undefined;
                        if (method === 'POST') {
                            body = this.json(query);
                            queryString = this.hash(body, 'md5');
                            headers['Content-Type'] = 'application/json';
                        } else {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                            queryString = this.urlencode(this.keysort(query));
                        }
                        const auth = method + "\n" + request + "\n" + queryString + "\n" + timestamp; // eslint-disable-line quotes
                        headers['X-Nova-Signature'] = this.hmac(this.encode(auth), this.encode(this.secret));
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    //     {"code":"A10003","data":[],"message":"Authentication failed, Invalid accessKey."}
                    //
                    const errorCode = this.safeString(response, 'code');
                    if (errorCode !== 'A10000') {
                        const message = this.safeString(response, 'message');
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    109: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, AuthenticationError: AuthenticationError, ArgumentsRequired: ArgumentsRequired1, BadRequest: BadRequest, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, PermissionDenied: PermissionDenied } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class oceanex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'oceanex',
                        'name': 'OceanEx',
                        'countries': [
                            'BS'
                        ],
                        'version': 'v1',
                        'rateLimit': 3000,
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/58385970-794e2d80-8001-11e9-889c-0567cd79b78e.jpg',
                            'api': 'https://api.oceanex.pro',
                            'www': 'https://www.oceanex.pro.com',
                            'doc': 'https://api.oceanex.pro/doc/v1',
                            'referral': 'https://oceanex.pro/signup?referral=VE24QX'
                        },
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createMarketOrder': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchFundingFees': undefined,
                            'fetchMarkets': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': true,
                            'fetchOrders': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTradingLimits': undefined
                        },
                        'timeframes': {
                            '1m': '1',
                            '5m': '5',
                            '15m': '15',
                            '30m': '30',
                            '1h': '60',
                            '2h': '120',
                            '4h': '240',
                            '6h': '360',
                            '12h': '720',
                            '1d': '1440',
                            '3d': '4320',
                            '1w': '10080'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'markets',
                                    'tickers/{pair}',
                                    'tickers_multi',
                                    'order_book',
                                    'order_book/multi',
                                    'fees/trading',
                                    'trades',
                                    'timestamp'
                                ],
                                'post': [
                                    'k'
                                ]
                            },
                            'private': {
                                'get': [
                                    'key',
                                    'members/me',
                                    'orders',
                                    'orders/filter'
                                ],
                                'post': [
                                    'orders',
                                    'orders/multi',
                                    'order/delete',
                                    'order/delete/multi',
                                    'orders/clear'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.001'),
                                'taker': this.parseNumber('0.001')
                            }
                        },
                        'commonCurrencies': {
                            'PLA': 'Plair'
                        },
                        'exceptions': {
                            'codes': {
                                '-1': BadRequest,
                                '-2': BadRequest,
                                '1001': BadRequest,
                                '1004': ArgumentsRequired1,
                                '1006': AuthenticationError,
                                '1008': AuthenticationError,
                                '1010': AuthenticationError,
                                '1011': PermissionDenied,
                                '2001': AuthenticationError,
                                '2002': InvalidOrder,
                                '2004': OrderNotFound,
                                '9003': PermissionDenied
                            },
                            'exact': {
                                'market does not have a valid value': BadRequest,
                                'side does not have a valid value': BadRequest,
                                'Account::AccountError: Cannot lock funds': InsufficientFunds,
                                'The account does not exist': AuthenticationError
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const request = {
                        'show_details': true
                    };
                    const response = await this.publicGetMarkets(this.extend(request, params));
                    //
                    //    {
                    //        id: 'xtzusdt',
                    //        name: 'XTZ/USDT',
                    //        ask_precision: '8',
                    //        bid_precision: '8',
                    //        enabled: true,
                    //        price_precision: '4',
                    //        amount_precision: '3',
                    //        usd_precision: '4',
                    //        minimum_trading_amount: '1.0'
                    //    },
                    //
                    const result = [];
                    const markets = this.safeValue(response, 'data');
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeValue(market, 'id');
                        const name = this.safeValue(market, 'name');
                        let [baseId, quoteId] = name.split('/');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        baseId = baseId.toLowerCase();
                        quoteId = quoteId.toLowerCase();
                        const symbol = base + '/' + quote;
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'amount_precision'),
                                'price': this.safeInteger(market, 'price_precision'),
                                'base': this.safeInteger(market, 'ask_precision'),
                                'quote': this.safeInteger(market, 'bid_precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minimum_trading_amount'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetTickersPair(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "message":"Operation successful",
                    //         "data": {
                    //             "at":1559431729,
                    //             "ticker": {
                    //                 "buy":"0.0065",
                    //                 "sell":"0.00677",
                    //                 "low":"0.00677",
                    //                 "high":"0.00677",
                    //                 "last":"0.00677",
                    //                 "vol":"2000.0"
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTicker(data, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    if (symbols === undefined) symbols = this.symbols;
                    const marketIds = this.marketIds(symbols);
                    const request = {
                        'markets': marketIds
                    };
                    const response = await this.publicGetTickersMulti(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "message":"Operation successful",
                    //         "data": {
                    //             "at":1559431729,
                    //             "ticker": {
                    //                 "buy":"0.0065",
                    //                 "sell":"0.00677",
                    //                 "low":"0.00677",
                    //                 "high":"0.00677",
                    //                 "last":"0.00677",
                    //                 "vol":"2000.0"
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const result = {};
                    for(let i = 0; i < data.length; i++){
                        const ticker = data[i];
                        const marketId = this.safeString(ticker, 'market');
                        const market = this.safeMarket(marketId);
                        const symbol = market['symbol'];
                        result[symbol] = this.parseTicker(ticker, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                parseTicker(data, market) {
                    //
                    //         {
                    //             "at":1559431729,
                    //             "ticker": {
                    //                 "buy":"0.0065",
                    //                 "sell":"0.00677",
                    //                 "low":"0.00677",
                    //                 "high":"0.00677",
                    //                 "last":"0.00677",
                    //                 "vol":"2000.0"
                    //             }
                    //         }
                    //
                    const ticker = this.safeValue(data, 'ticker', {});
                    const timestamp = this.safeTimestamp(data, 'at');
                    const symbol = this.safeSymbol(undefined, market);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': this.safeString(ticker, 'last'),
                        'last': this.safeString(ticker, 'last'),
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetOrderBook(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "message":"Operation successful",
                    //         "data": {
                    //             "timestamp":1559433057,
                    //             "asks": [
                    //                 ["100.0","20.0"],
                    //                 ["4.74","2000.0"],
                    //                 ["1.74","4000.0"],
                    //             ],
                    //             "bids":[
                    //                 ["0.0065","5482873.4"],
                    //                 ["0.00649","4781956.2"],
                    //                 ["0.00648","2876006.8"],
                    //             ],
                    //         }
                    //     }
                    //
                    const orderbook = this.safeValue(response, 'data', {});
                    const timestamp = this.safeTimestamp(orderbook, 'timestamp');
                    return this.parseOrderBook(orderbook, symbol, timestamp);
                }
                async fetchOrderBooks(symbols, limit, params = {}) {
                    await this.loadMarkets();
                    if (symbols === undefined) symbols = this.symbols;
                    const marketIds = this.marketIds(symbols);
                    const request = {
                        'markets': marketIds
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetOrderBookMulti(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "message":"Operation successful",
                    //         "data": [
                    //             {
                    //                 "timestamp":1559433057,
                    //                 "market": "bagvet",
                    //                 "asks": [
                    //                     ["100.0","20.0"],
                    //                     ["4.74","2000.0"],
                    //                     ["1.74","4000.0"],
                    //                 ],
                    //                 "bids":[
                    //                     ["0.0065","5482873.4"],
                    //                     ["0.00649","4781956.2"],
                    //                     ["0.00648","2876006.8"],
                    //                 ],
                    //             },
                    //             ...,
                    //         ],
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = {};
                    for(let i = 0; i < data.length; i++){
                        const orderbook = data[i];
                        const marketId = this.safeString(orderbook, 'market');
                        const symbol = this.safeSymbol(marketId);
                        const timestamp = this.safeTimestamp(orderbook, 'timestamp');
                        result[symbol] = this.parseOrderBook(orderbook, symbol, timestamp);
                    }
                    return result;
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetTrades(this.extend(request, params));
                    //
                    //      {
                    //          "code":0,
                    //          "message":"Operation successful",
                    //          "data": [
                    //              {
                    //                  "id":220247666,
                    //                  "price":"3098.62",
                    //                  "volume":"0.00196",
                    //                  "funds":"6.0732952",
                    //                  "market":"ethusdt",
                    //                  "created_at":"2022-04-19T19:03:15Z",
                    //                  "created_on":1650394995,
                    //                  "side":"bid"
                    //              },
                    //          ]
                    //      }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseTrades(data, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "id":220247666,
                    //          "price":"3098.62",
                    //          "volume":"0.00196",
                    //          "funds":"6.0732952",
                    //          "market":"ethusdt",
                    //          "created_at":"2022-04-19T19:03:15Z",
                    //          "created_on":1650394995,
                    //          "side":"bid"
                    //      }
                    //
                    let side = this.safeValue(trade, 'side');
                    if (side === 'bid') side = 'buy';
                    else if (side === 'ask') side = 'sell';
                    const marketId = this.safeValue(trade, 'market');
                    const symbol = this.safeSymbol(marketId, market);
                    let timestamp = this.safeTimestamp(trade, 'created_on');
                    if (timestamp === undefined) timestamp = this.parse8601(this.safeString(trade, 'created_at'));
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'volume');
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': this.safeString(trade, 'id'),
                        'order': undefined,
                        'type': 'limit',
                        'takerOrMaker': undefined,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTimestamp(params);
                    //
                    //     {"code":0,"message":"Operation successful","data":1559433420}
                    //
                    return this.safeTimestamp(response, 'data');
                }
                async fetchTradingFees(params = {}) {
                    const response = await this.publicGetFeesTrading(params);
                    const data = this.safeValue(response, 'data');
                    const result = {};
                    for(let i = 0; i < data.length; i++){
                        const group = data[i];
                        const maker = this.safeValue(group, 'ask_fee', {});
                        const taker = this.safeValue(group, 'bid_fee', {});
                        const marketId = this.safeString(group, 'market');
                        const symbol = this.safeSymbol(marketId);
                        result[symbol] = {
                            'info': group,
                            'symbol': symbol,
                            'maker': this.safeNumber(maker, 'value'),
                            'taker': this.safeNumber(taker, 'value'),
                            'percentage': true
                        };
                    }
                    return result;
                }
                async fetchKey(params = {}) {
                    const response = await this.privateGetKey(params);
                    return this.safeValue(response, 'data');
                }
                parseBalance(response) {
                    const data = this.safeValue(response, 'data');
                    const balances = this.safeValue(data, 'accounts');
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeValue(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'balance');
                        account['used'] = this.safeString(balance, 'locked');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetMembersMe(params);
                    return this.parseBalance(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'side': side,
                        'ord_type': type,
                        'volume': this.amountToPrecision(symbol, amount)
                    };
                    if (type === 'limit') request['price'] = this.priceToPrecision(symbol, price);
                    const response = await this.privatePostOrders(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    let ids = id;
                    if (!Array.isArray(id)) ids = [
                        id
                    ];
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'ids': ids
                    };
                    const response = await this.privateGetOrders(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    const dataLength = data.length;
                    if (data === undefined) throw new OrderNotFound(this.id + ' could not found matching order');
                    if (Array.isArray(id)) return this.parseOrders(data, market);
                    if (dataLength === 0) throw new OrderNotFound(this.id + ' could not found matching order');
                    return this.parseOrder(data[0], market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'states': [
                            'wait'
                        ]
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'states': [
                            'done',
                            'cancel'
                        ]
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a `symbol` argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const states = this.safeValue(params, 'states', [
                        'wait',
                        'done',
                        'cancel'
                    ]);
                    const query = this.omit(params, 'states');
                    const request = {
                        'market': market['id'],
                        'states': states,
                        'need_price': 'True'
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetOrdersFilter(this.extend(request, query));
                    const data = this.safeValue(response, 'data', []);
                    let result = [];
                    for(let i = 0; i < data.length; i++){
                        const orders = this.safeValue(data[i], 'orders', []);
                        const status = this.parseOrderStatus(this.safeValue(data[i], 'state'));
                        const parsedOrders = this.parseOrders(orders, market, since, limit, {
                            'status': status
                        });
                        result = this.arrayConcat(result, parsedOrders);
                    }
                    return result;
                }
                parseOHLCV(ohlcv, market) {
                    // [
                    //    1559232000,
                    //    8889.22,
                    //    9028.52,
                    //    8889.22,
                    //    9028.52
                    //    0.3121
                    // ]
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'period': this.timeframes[timeframe]
                    };
                    if (since !== undefined) request['timestamp'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicPostK(this.extend(request, params));
                    const ohlcvs = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(ohlcvs, market, timeframe, since, limit);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "created_at": "2019-01-18T00:38:18Z",
                    //         "trades_count": 0,
                    //         "remaining_volume": "0.2",
                    //         "price": "1001.0",
                    //         "created_on": "1547771898",
                    //         "side": "buy",
                    //         "volume": "0.2",
                    //         "state": "wait",
                    //         "ord_type": "limit",
                    //         "avg_price": "0.0",
                    //         "executed_volume": "0.0",
                    //         "id": 473797,
                    //         "market": "veteth"
                    //     }
                    //
                    const status = this.parseOrderStatus(this.safeValue(order, 'state'));
                    const marketId = this.safeString2(order, 'market', 'market_id');
                    const symbol = this.safeSymbol(marketId, market);
                    let timestamp = this.safeTimestamp(order, 'created_on');
                    if (timestamp === undefined) timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const price = this.safeString(order, 'price');
                    const average = this.safeString(order, 'avg_price');
                    const amount = this.safeString(order, 'volume');
                    const remaining = this.safeString(order, 'remaining_volume');
                    const filled = this.safeString(order, 'executed_volume');
                    return this.safeOrder({
                        'info': order,
                        'id': this.safeString(order, 'id'),
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': this.safeValue(order, 'ord_type'),
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': this.safeValue(order, 'side'),
                        'price': price,
                        'stopPrice': undefined,
                        'average': average,
                        'amount': amount,
                        'remaining': remaining,
                        'filled': filled,
                        'status': status,
                        'cost': undefined,
                        'trades': undefined,
                        'fee': undefined
                    }, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'wait': 'open',
                        'done': 'closed',
                        'cancel': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                async createOrders(symbol, orders, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'orders': orders
                    };
                    // orders: [{"side":"buy", "volume":.2, "price":1001}, {"side":"sell", "volume":0.2, "price":1002}]
                    const response = await this.privatePostOrdersMulti(this.extend(request, params));
                    const data = response['data'];
                    return this.parseOrders(data);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostOrderDelete(this.extend({
                        'id': id
                    }, params));
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data);
                }
                async cancelOrders(ids, symbol, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostOrderDeleteMulti(this.extend({
                        'ids': ids
                    }, params));
                    const data = this.safeValue(response, 'data');
                    return this.parseOrders(data);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostOrdersClear(params);
                    const data = this.safeValue(response, 'data');
                    return this.parseOrders(data);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (path === 'tickers_multi' || path === 'order_book/multi') {
                            let request = '?';
                            const markets = this.safeValue(params, 'markets');
                            for(let i = 0; i < markets.length; i++)request += 'markets[]=' + markets[i] + '&';
                            const limit = this.safeValue(params, 'limit');
                            if (limit !== undefined) request += 'limit=' + limit;
                            url += request;
                        } else if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'private') {
                        this.checkRequiredCredentials();
                        const request = {
                            'uid': this.apiKey,
                            'data': query
                        };
                        // to set the private key:
                        // const fs = require ('fs')
                        // exchange.secret = fs.readFileSync ('oceanex.pem', 'utf8')
                        const jwt_token = this.jwt(request, this.encode(this.secret), 'RS256');
                        url += '?user_jwt=' + jwt_token;
                    }
                    headers = {
                        'Content-Type': 'application/json'
                    };
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    //
                    //     {"code":1011,"message":"This IP 'x.x.x.x' is not allowed","data":{}}
                    //
                    if (response === undefined) return;
                    const errorCode = this.safeString(response, 'code');
                    const message = this.safeString(response, 'message');
                    if (errorCode !== undefined && errorCode !== '0') {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['codes'], errorCode, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    110: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, OnMaintenance: OnMaintenance, ArgumentsRequired: ArgumentsRequired1, BadRequest: BadRequest, AccountSuspended: AccountSuspended, InvalidAddress: InvalidAddress, PermissionDenied: PermissionDenied, DDoSProtection: DDoSProtection, InsufficientFunds: InsufficientFunds, InvalidNonce: InvalidNonce, CancelPending: CancelPending, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, AuthenticationError: AuthenticationError, RequestTimeout: RequestTimeout, NotSupported: NotSupported, BadSymbol: BadSymbol, RateLimitExceeded: RateLimitExceeded } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE, TRUNCATE: TRUNCATE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class okcoin extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'okcoin',
                        'name': 'OKCoin',
                        'countries': [
                            'CN',
                            'US'
                        ],
                        'version': 'v3',
                        // cheapest endpoint is 100 requests per 2 seconds
                        // 50 requests per second => 1000 / 50 = 20ms
                        'rateLimit': 20,
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': true,
                            'option': undefined,
                            'cancelOrder': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchLedger': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': undefined,
                            'fetchOrderTrades': true,
                            'fetchPosition': true,
                            'fetchPositions': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTransactions': undefined,
                            'fetchWithdrawals': true,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '60',
                            '3m': '180',
                            '5m': '300',
                            '15m': '900',
                            '30m': '1800',
                            '1h': '3600',
                            '2h': '7200',
                            '4h': '14400',
                            '6h': '21600',
                            '12h': '43200',
                            '1d': '86400',
                            '1w': '604800',
                            '1M': '2678400',
                            '3M': '8035200',
                            '6M': '16070400',
                            '1y': '31536000'
                        },
                        'hostname': 'okcoin.com',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87295551-102fbf00-c50e-11ea-90a9-462eebba5829.jpg',
                            'api': {
                                'rest': 'https://www.{hostname}'
                            },
                            'www': 'https://www.okcoin.com',
                            'doc': 'https://www.okcoin.com/docs/en/',
                            'fees': 'https://www.okcoin.com/coin-fees',
                            'referral': 'https://www.okcoin.com/account/register?flag=activity&channelId=600001513',
                            'test': {
                                'rest': 'https://testnet.okex.com'
                            }
                        },
                        'api': {
                            'general': {
                                'get': {
                                    'time': 8.3334
                                }
                            },
                            'account': {
                                'get': {
                                    'wallet': 8.3334,
                                    'sub-account': 1000,
                                    'asset-valuation': 1000,
                                    'wallet/{currency}': 8.3334,
                                    'withdrawal/history': 8.3334,
                                    'withdrawal/history/{currency}': 8.3334,
                                    'ledger': 5,
                                    'deposit/address': 8.3334,
                                    'deposit/history': 8.3334,
                                    'deposit/history/{currency}': 8.3334,
                                    'currencies': 8.3334,
                                    'withdrawal/fee': 8.3334,
                                    'deposit-lightning': 50,
                                    'withdrawal-lightning': 50,
                                    'fiat/deposit/detail': 5,
                                    'fiat/deposit/details': 8.3334,
                                    'fiat/withdraw/detail': 5,
                                    'fiat/withdraw/details': 8.3334,
                                    'fiat/channel': 8.3334
                                },
                                'post': {
                                    'transfer': 100,
                                    'withdrawal': 8.3334,
                                    'fiat/cancel_deposit': 1,
                                    'fiat/deposit': 8.3334,
                                    'fiat/withdraw': 8.3334,
                                    'fiat/cancel_withdrawal': 1
                                }
                            },
                            // TODO fix signing issue in sign ()
                            // all other endpoints of the format
                            // api/account/v3/wallet
                            // otc endpoints actually of the format: (exchanged places)
                            // api/v3/otc/rfq/instruments
                            'otc': {
                                'get': {
                                    'rfq/instruments': 50,
                                    'rfq/trade': 50,
                                    'rfq/history': 50
                                },
                                'post': {
                                    'rfq/quote': 50,
                                    'rfq/trade': 50
                                }
                            },
                            // TODO fix signing issue as above
                            'users': {
                                'get': {
                                    'subaccount-info': 20,
                                    'account-info': 20,
                                    'subaccount/apikey': 20
                                },
                                'post': {
                                    'create-subaccount': 5,
                                    'delete-subaccount': 5,
                                    'subaccount/apikey': 50,
                                    'subacount/delete-apikey': 20,
                                    'subacount/modify-apikey': 20
                                }
                            },
                            'earning': {
                                'get': {
                                    'offers': 5,
                                    'orders': 5,
                                    'positions': 8.3334
                                },
                                'post': {
                                    'purchase': 5,
                                    'redeem': 5,
                                    'cancel': 5
                                }
                            },
                            'spot': {
                                'get': {
                                    'accounts': 5,
                                    'accounts/{currency}': 5,
                                    'accounts/{currency}/ledger': 5,
                                    'orders': 10,
                                    'orders_pending': 5,
                                    'orders/{order_id}': 5,
                                    'orders/{client_oid}': 5,
                                    'trade_fee': 5,
                                    'fills': 10,
                                    'algo': 5,
                                    // public
                                    'instruments': 5,
                                    'instruments/{instrument_id}/book': 5,
                                    'instruments/ticker': 5,
                                    'instruments/{instrument_id}/ticker': 5,
                                    'instruments/{instrument_id}/trades': 5,
                                    'instruments/{instrument_id}/candles': 5
                                },
                                'post': {
                                    'order_algo': 2.5,
                                    'orders': 1,
                                    'batch_orders': 2,
                                    'cancel_orders/{order_id}': 1,
                                    'cancel_orders/{client_oid}': 1,
                                    'cancel_batch_algos': 5,
                                    'cancel_batch_orders': 5,
                                    'amend_order/{instrument_id}': 2.5,
                                    'amend_batch_orders': 5
                                }
                            },
                            'margin': {
                                'get': {
                                    'accounts': 5,
                                    'accounts/{instrument_id}': 5,
                                    'accounts/{instrument_id}/ledger': 5,
                                    'accounts/availability': 5,
                                    'accounts/{instrument_id}/availability': 5,
                                    'accounts/borrowed': 5,
                                    'accounts/{instrument_id}/borrowed': 5,
                                    'orders': 10,
                                    'accounts/{instrument_id}/leverage': 1,
                                    'orders/{order_id}': 5,
                                    'orders/{client_oid}': 5,
                                    'orders_pending': 5,
                                    'fills': 10,
                                    // public
                                    'instruments/{instrument_id}/mark_price': 5
                                },
                                'post': {
                                    'accounts/borrow': 1,
                                    'accounts/repayment': 1,
                                    'orders': 1,
                                    'batch_orders': 2,
                                    'cancel_orders': 1,
                                    'cancel_orders/{order_id}': 1,
                                    'cancel_orders/{client_oid}': 1,
                                    'cancel_batch_orders': 2,
                                    'amend_order/{instrument_id}': 2.5,
                                    'amend_batch_orders': 5,
                                    'accounts/{instrument_id}/leverage': 1
                                }
                            },
                            'system': {
                                'get': {
                                    'status': 250
                                }
                            },
                            'market': {
                                'get': {
                                    'oracle': 250
                                }
                            },
                            'futures': {
                                'get': [
                                    'position',
                                    '{instrument_id}/position',
                                    'accounts',
                                    'accounts/{underlying}',
                                    'accounts/{underlying}/leverage',
                                    'accounts/{underlying}/ledger',
                                    'order_algo/{instrument_id}',
                                    'orders/{instrument_id}',
                                    'orders/{instrument_id}/{order_id}',
                                    'orders/{instrument_id}/{client_oid}',
                                    'fills',
                                    'trade_fee',
                                    'accounts/{instrument_id}/holds',
                                    'order_algo/{instrument_id}',
                                    // public
                                    'instruments',
                                    'instruments/{instrument_id}/book',
                                    'instruments/ticker',
                                    'instruments/{instrument_id}/ticker',
                                    'instruments/{instrument_id}/trades',
                                    'instruments/{instrument_id}/candles',
                                    'instruments/{instrument_id}/history/candles',
                                    'instruments/{instrument_id}/index',
                                    'rate',
                                    'instruments/{instrument_id}/estimated_price',
                                    'instruments/{instrument_id}/open_interest',
                                    'instruments/{instrument_id}/price_limit',
                                    'instruments/{instrument_id}/mark_price',
                                    'instruments/{instrument_id}/liquidation'
                                ],
                                'post': [
                                    'accounts/{underlying}/leverage',
                                    'order',
                                    'amend_order/{instrument_id}',
                                    'orders',
                                    'cancel_order/{instrument_id}/{order_id}',
                                    'cancel_order/{instrument_id}/{client_oid}',
                                    'cancel_batch_orders/{instrument_id}',
                                    'accounts/margin_mode',
                                    'close_position',
                                    'cancel_all',
                                    'order_algo',
                                    'cancel_algos'
                                ]
                            },
                            'swap': {
                                'get': [
                                    'position',
                                    '{instrument_id}/position',
                                    'accounts',
                                    '{instrument_id}/accounts',
                                    'accounts/{instrument_id}/settings',
                                    'accounts/{instrument_id}/ledger',
                                    'orders/{instrument_id}',
                                    'orders/{instrument_id}/{order_id}',
                                    'orders/{instrument_id}/{client_oid}',
                                    'fills',
                                    'accounts/{instrument_id}/holds',
                                    'trade_fee',
                                    'order_algo/{instrument_id}',
                                    // public
                                    'instruments',
                                    'instruments/{instrument_id}/depth',
                                    'instruments/ticker',
                                    'instruments/{instrument_id}/ticker',
                                    'instruments/{instrument_id}/trades',
                                    'instruments/{instrument_id}/candles',
                                    'instruments/{instrument_id}/history/candles',
                                    'instruments/{instrument_id}/index',
                                    'rate',
                                    'instruments/{instrument_id}/open_interest',
                                    'instruments/{instrument_id}/price_limit',
                                    'instruments/{instrument_id}/liquidation',
                                    'instruments/{instrument_id}/funding_time',
                                    'instruments/{instrument_id}/mark_price',
                                    'instruments/{instrument_id}/historical_funding_rate'
                                ],
                                'post': [
                                    'accounts/{instrument_id}/leverage',
                                    'order',
                                    'amend_order/{instrument_id}',
                                    'orders',
                                    'cancel_order/{instrument_id}/{order_id}',
                                    'cancel_order/{instrument_id}/{client_oid}',
                                    'cancel_batch_orders/{instrument_id}',
                                    'order_algo',
                                    'cancel_algos',
                                    'close_position',
                                    'cancel_all',
                                    'order_algo',
                                    'cancel_algos'
                                ]
                            },
                            'option': {
                                'get': [
                                    'accounts',
                                    'position',
                                    '{underlying}/position',
                                    'accounts/{underlying}',
                                    'orders/{underlying}',
                                    'fills/{underlying}',
                                    'accounts/{underlying}/ledger',
                                    'trade_fee',
                                    'orders/{underlying}/{order_id}',
                                    'orders/{underlying}/{client_oid}',
                                    // public
                                    'underlying',
                                    'instruments/{underlying}',
                                    'instruments/{underlying}/summary',
                                    'instruments/{underlying}/summary/{instrument_id}',
                                    'instruments/{instrument_id}/book',
                                    'instruments/{instrument_id}/trades',
                                    'instruments/{instrument_id}/ticker',
                                    'instruments/{instrument_id}/candles'
                                ],
                                'post': [
                                    'order',
                                    'orders',
                                    'cancel_order/{underlying}/{order_id}',
                                    'cancel_order/{underlying}/{client_oid}',
                                    'cancel_batch_orders/{underlying}',
                                    'amend_order/{underlying}',
                                    'amend_batch_orders/{underlying}'
                                ]
                            },
                            'information': {
                                'get': [
                                    '{currency}/long_short_ratio',
                                    '{currency}/volume',
                                    '{currency}/taker',
                                    '{currency}/sentiment',
                                    '{currency}/margin'
                                ]
                            },
                            'index': {
                                'get': [
                                    '{instrument_id}/constituents'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'taker': 0.002,
                                'maker': 0.001
                            },
                            'spot': {
                                'taker': 0.0015,
                                'maker': 0.0010
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'password': true
                        },
                        'exceptions': {
                            // http error codes
                            // 400 Bad Request — Invalid request format
                            // 401 Unauthorized — Invalid API Key
                            // 403 Forbidden — You do not have access to the requested resource
                            // 404 Not Found
                            // 429 Client Error: Too Many Requests for url
                            // 500 Internal Server Error — We had a problem with our server
                            'exact': {
                                '1': ExchangeError1,
                                // undocumented
                                'failure to get a peer from the ring-balancer': ExchangeNotAvailable,
                                'Server is busy, please try again.': ExchangeNotAvailable,
                                'An unexpected error occurred': ExchangeError1,
                                'System error': ExchangeError1,
                                '4010': PermissionDenied,
                                // common
                                // '0': ExchangeError, // 200 successful,when the order placement / cancellation / operation is successful
                                '4001': ExchangeError1,
                                '4002': ExchangeError1,
                                // --------------------------------------------------------
                                '30001': AuthenticationError,
                                '30002': AuthenticationError,
                                '30003': AuthenticationError,
                                '30004': AuthenticationError,
                                '30005': InvalidNonce,
                                '30006': AuthenticationError,
                                '30007': BadRequest,
                                '30008': RequestTimeout,
                                '30009': ExchangeError1,
                                '30010': AuthenticationError,
                                '30011': PermissionDenied,
                                '30012': AuthenticationError,
                                '30013': AuthenticationError,
                                '30014': DDoSProtection,
                                '30015': AuthenticationError,
                                '30016': ExchangeError1,
                                '30017': ExchangeError1,
                                '30018': ExchangeError1,
                                '30019': ExchangeNotAvailable,
                                '30020': BadRequest,
                                '30021': BadRequest,
                                '30022': PermissionDenied,
                                '30023': BadRequest,
                                '30024': BadSymbol,
                                '30025': BadRequest,
                                '30026': DDoSProtection,
                                '30027': AuthenticationError,
                                '30028': PermissionDenied,
                                '30029': AccountSuspended,
                                '30030': ExchangeNotAvailable,
                                '30031': BadRequest,
                                '30032': BadSymbol,
                                '30033': BadRequest,
                                '30034': ExchangeError1,
                                '30035': ExchangeError1,
                                '30036': ExchangeError1,
                                '30037': ExchangeNotAvailable,
                                // '30038': AuthenticationError, // { "code": 30038, "message": "user does not exist" }
                                '30038': OnMaintenance,
                                '30044': RequestTimeout,
                                // futures
                                '32001': AccountSuspended,
                                '32002': PermissionDenied,
                                '32003': CancelPending,
                                '32004': ExchangeError1,
                                '32005': InvalidOrder,
                                '32006': InvalidOrder,
                                '32007': InvalidOrder,
                                '32008': InvalidOrder,
                                '32009': InvalidOrder,
                                '32010': ExchangeError1,
                                '32011': ExchangeError1,
                                '32012': ExchangeError1,
                                '32013': ExchangeError1,
                                '32014': ExchangeError1,
                                '32015': ExchangeError1,
                                '32016': ExchangeError1,
                                '32017': ExchangeError1,
                                '32018': ExchangeError1,
                                '32019': ExchangeError1,
                                '32020': ExchangeError1,
                                '32021': ExchangeError1,
                                '32022': ExchangeError1,
                                '32023': ExchangeError1,
                                '32024': ExchangeError1,
                                '32025': ExchangeError1,
                                '32026': ExchangeError1,
                                '32027': ExchangeError1,
                                '32028': ExchangeError1,
                                '32029': ExchangeError1,
                                '32030': InvalidOrder,
                                '32031': ArgumentsRequired1,
                                '32038': AuthenticationError,
                                '32040': ExchangeError1,
                                '32044': ExchangeError1,
                                '32045': ExchangeError1,
                                '32046': ExchangeError1,
                                '32047': ExchangeError1,
                                '32048': InvalidOrder,
                                '32049': ExchangeError1,
                                '32050': InvalidOrder,
                                '32051': InvalidOrder,
                                '32052': ExchangeError1,
                                '32053': ExchangeError1,
                                '32057': ExchangeError1,
                                '32054': ExchangeError1,
                                '32055': InvalidOrder,
                                '32056': ExchangeError1,
                                '32058': ExchangeError1,
                                '32059': InvalidOrder,
                                '32060': InvalidOrder,
                                '32061': InvalidOrder,
                                '32062': InvalidOrder,
                                '32063': InvalidOrder,
                                '32064': ExchangeError1,
                                '32065': ExchangeError1,
                                '32066': ExchangeError1,
                                '32067': ExchangeError1,
                                '32068': ExchangeError1,
                                '32069': ExchangeError1,
                                '32070': ExchangeError1,
                                '32071': ExchangeError1,
                                '32072': ExchangeError1,
                                '32073': ExchangeError1,
                                '32074': ExchangeError1,
                                '32075': ExchangeError1,
                                '32076': ExchangeError1,
                                '32077': ExchangeError1,
                                '32078': ExchangeError1,
                                '32079': ExchangeError1,
                                '32080': ExchangeError1,
                                '32083': ExchangeError1,
                                // token and margin trading
                                '33001': PermissionDenied,
                                '33002': AccountSuspended,
                                '33003': InsufficientFunds,
                                '33004': ExchangeError1,
                                '33005': ExchangeError1,
                                '33006': ExchangeError1,
                                '33007': ExchangeError1,
                                '33008': InsufficientFunds,
                                '33009': ExchangeError1,
                                '33010': ExchangeError1,
                                '33011': ExchangeError1,
                                '33012': ExchangeError1,
                                '33013': InvalidOrder,
                                '33014': OrderNotFound,
                                '33015': InvalidOrder,
                                '33016': ExchangeError1,
                                '33017': InsufficientFunds,
                                '33018': ExchangeError1,
                                '33020': ExchangeError1,
                                '33021': BadRequest,
                                '33022': InvalidOrder,
                                '33023': ExchangeError1,
                                '33024': InvalidOrder,
                                '33025': InvalidOrder,
                                '33026': ExchangeError1,
                                '33027': InvalidOrder,
                                '33028': InvalidOrder,
                                '33029': InvalidOrder,
                                '33034': ExchangeError1,
                                '33035': ExchangeError1,
                                '33036': ExchangeError1,
                                '33037': ExchangeError1,
                                '33038': ExchangeError1,
                                '33039': ExchangeError1,
                                '33040': ExchangeError1,
                                '33041': ExchangeError1,
                                '33042': ExchangeError1,
                                '33043': ExchangeError1,
                                '33044': ExchangeError1,
                                '33045': ExchangeError1,
                                '33046': ExchangeError1,
                                '33047': ExchangeError1,
                                '33048': ExchangeError1,
                                '33049': ExchangeError1,
                                '33050': ExchangeError1,
                                '33051': ExchangeError1,
                                '33059': BadRequest,
                                '33060': BadRequest,
                                '33061': ExchangeError1,
                                '33062': ExchangeError1,
                                '33063': ExchangeError1,
                                '33064': ExchangeError1,
                                '33065': ExchangeError1,
                                '33085': InvalidOrder,
                                // account
                                '21009': ExchangeError1,
                                '34001': PermissionDenied,
                                '34002': InvalidAddress,
                                '34003': ExchangeError1,
                                '34004': ExchangeError1,
                                '34005': ExchangeError1,
                                '34006': ExchangeError1,
                                '34007': ExchangeError1,
                                '34008': InsufficientFunds,
                                '34009': ExchangeError1,
                                '34010': ExchangeError1,
                                '34011': ExchangeError1,
                                '34012': ExchangeError1,
                                '34013': ExchangeError1,
                                '34014': ExchangeError1,
                                '34015': ExchangeError1,
                                '34016': PermissionDenied,
                                '34017': AccountSuspended,
                                '34018': AuthenticationError,
                                '34019': PermissionDenied,
                                '34020': PermissionDenied,
                                '34021': InvalidAddress,
                                '34022': ExchangeError1,
                                '34023': PermissionDenied,
                                '34026': RateLimitExceeded,
                                '34036': ExchangeError1,
                                '34037': ExchangeError1,
                                '34038': ExchangeError1,
                                '34039': ExchangeError1,
                                // swap
                                '35001': ExchangeError1,
                                '35002': ExchangeError1,
                                '35003': ExchangeError1,
                                '35004': ExchangeError1,
                                '35005': AuthenticationError,
                                '35008': InvalidOrder,
                                '35010': InvalidOrder,
                                '35012': InvalidOrder,
                                '35014': InvalidOrder,
                                '35015': InvalidOrder,
                                '35017': ExchangeError1,
                                '35019': InvalidOrder,
                                '35020': InvalidOrder,
                                '35021': InvalidOrder,
                                '35022': BadRequest,
                                '35024': BadRequest,
                                '35025': InsufficientFunds,
                                '35026': BadRequest,
                                '35029': OrderNotFound,
                                '35030': InvalidOrder,
                                '35031': InvalidOrder,
                                '35032': ExchangeError1,
                                '35037': ExchangeError1,
                                '35039': InsufficientFunds,
                                '35040': InvalidOrder,
                                '35044': ExchangeError1,
                                '35046': InsufficientFunds,
                                '35047': InsufficientFunds,
                                '35048': ExchangeError1,
                                '35049': InvalidOrder,
                                '35050': InvalidOrder,
                                '35052': InsufficientFunds,
                                '35053': ExchangeError1,
                                '35055': InsufficientFunds,
                                '35057': ExchangeError1,
                                '35058': ExchangeError1,
                                '35059': BadRequest,
                                '35060': BadRequest,
                                '35061': BadRequest,
                                '35062': InvalidOrder,
                                '35063': InvalidOrder,
                                '35064': InvalidOrder,
                                '35066': InvalidOrder,
                                '35067': InvalidOrder,
                                '35068': InvalidOrder,
                                '35069': InvalidOrder,
                                '35070': InvalidOrder,
                                '35071': InvalidOrder,
                                '35072': InvalidOrder,
                                '35073': InvalidOrder,
                                '35074': InvalidOrder,
                                '35075': InvalidOrder,
                                '35076': InvalidOrder,
                                '35077': InvalidOrder,
                                '35078': InvalidOrder,
                                '35079': InvalidOrder,
                                '35080': InvalidOrder,
                                '35081': InvalidOrder,
                                '35082': InvalidOrder,
                                '35083': InvalidOrder,
                                '35084': InvalidOrder,
                                '35085': InvalidOrder,
                                '35086': InvalidOrder,
                                '35087': InvalidOrder,
                                '35088': InvalidOrder,
                                '35089': InvalidOrder,
                                '35090': ExchangeError1,
                                '35091': ExchangeError1,
                                '35092': ExchangeError1,
                                '35093': ExchangeError1,
                                '35094': ExchangeError1,
                                '35095': BadRequest,
                                '35096': ExchangeError1,
                                '35097': ExchangeError1,
                                '35098': ExchangeError1,
                                '35099': ExchangeError1,
                                '35102': RateLimitExceeded,
                                // option
                                '36001': BadRequest,
                                '36002': BadRequest,
                                '36005': ExchangeError1,
                                '36101': AuthenticationError,
                                '36102': PermissionDenied,
                                '36103': PermissionDenied,
                                '36104': PermissionDenied,
                                '36105': PermissionDenied,
                                '36106': PermissionDenied,
                                '36107': PermissionDenied,
                                '36108': InsufficientFunds,
                                '36109': PermissionDenied,
                                '36201': PermissionDenied,
                                '36202': PermissionDenied,
                                '36203': InvalidOrder,
                                '36204': ExchangeError1,
                                '36205': BadRequest,
                                '36206': BadRequest,
                                '36207': InvalidOrder,
                                '36208': InvalidOrder,
                                '36209': InvalidOrder,
                                '36210': InvalidOrder,
                                '36211': InvalidOrder,
                                '36212': InvalidOrder,
                                '36213': InvalidOrder,
                                '36214': ExchangeError1,
                                '36216': OrderNotFound,
                                '36217': InvalidOrder,
                                '36218': InvalidOrder,
                                '36219': InvalidOrder,
                                '36220': InvalidOrder,
                                '36221': InvalidOrder,
                                '36222': InvalidOrder,
                                '36223': InvalidOrder,
                                '36224': InvalidOrder,
                                '36225': InvalidOrder,
                                '36226': InvalidOrder,
                                '36227': InvalidOrder,
                                '36228': InvalidOrder,
                                '36229': InvalidOrder,
                                '36230': InvalidOrder
                            },
                            'broad': {}
                        },
                        'precisionMode': TICK_SIZE,
                        'options': {
                            'fetchOHLCV': {
                                'type': 'Candles'
                            },
                            'createMarketBuyOrderRequiresPrice': true,
                            'fetchMarkets': [
                                'spot'
                            ],
                            'defaultType': 'spot',
                            'accountsByType': {
                                'spot': '1',
                                'margin': '5',
                                'funding': '6'
                            },
                            'accountsById': {
                                '1': 'spot',
                                '5': 'margin',
                                '6': 'funding'
                            },
                            'auth': {
                                'time': 'public',
                                'currencies': 'private',
                                'instruments': 'public',
                                'rate': 'public',
                                '{instrument_id}/constituents': 'public'
                            },
                            'warnOnFetchCurrenciesWithoutAuthorization': false
                        },
                        'commonCurrencies': {
                            // OKEX refers to ERC20 version of Aeternity (AEToken)
                            'AE': 'AET',
                            'BOX': 'DefiBox',
                            'HOT': 'Hydro Protocol',
                            'HSR': 'HC',
                            'MAG': 'Maggie',
                            'SBTC': 'Super Bitcoin',
                            'TRADE': 'Unitrade',
                            'YOYO': 'YOYOW',
                            'WIN': 'WinToken'
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.generalGetTime(params);
                    //
                    //     {
                    //         "iso": "2015-01-07T23:47:25.201Z",
                    //         "epoch": 1420674445.201
                    //     }
                    //
                    return this.parse8601(this.safeString(response, 'iso'));
                }
                async fetchMarkets(params = {}) {
                    const types = this.safeValue(this.options, 'fetchMarkets');
                    let result = [];
                    for(let i = 0; i < types.length; i++){
                        const markets = await this.fetchMarketsByType(types[i], params);
                        result = this.arrayConcat(result, markets);
                    }
                    return result;
                }
                parseMarkets(markets) {
                    const result = [];
                    for(let i = 0; i < markets.length; i++)result.push(this.parseMarket(markets[i]));
                    return result;
                }
                parseMarket(market) {
                    //
                    // spot markets
                    //
                    //     {
                    //         base_currency: "EOS",
                    //         instrument_id: "EOS-OKB",
                    //         min_size: "0.01",
                    //         quote_currency: "OKB",
                    //         size_increment: "0.000001",
                    //         tick_size: "0.0001"
                    //     }
                    //
                    // futures markets
                    //
                    //     {
                    //         instrument_id: "XRP-USD-200320",
                    //         underlying_index: "XRP",
                    //         quote_currency: "USD",
                    //         tick_size: "0.0001",
                    //         contract_val: "10",
                    //         listing: "2020-03-06",
                    //         delivery: "2020-03-20",
                    //         trade_increment: "1",
                    //         alias: "this_week",
                    //         underlying: "XRP-USD",
                    //         base_currency: "XRP",
                    //         settlement_currency: "XRP",
                    //         is_inverse: "true",
                    //         contract_val_currency: "USD",
                    //     }
                    //
                    // swap markets
                    //
                    //     {
                    //         instrument_id: "BSV-USD-SWAP",
                    //         underlying_index: "BSV",
                    //         quote_currency: "USD",
                    //         coin: "BSV",
                    //         contract_val: "10",
                    //         listing: "2018-12-21T07:53:47.000Z",
                    //         delivery: "2020-03-14T08:00:00.000Z",
                    //         size_increment: "1",
                    //         tick_size: "0.01",
                    //         base_currency: "BSV",
                    //         underlying: "BSV-USD",
                    //         settlement_currency: "BSV",
                    //         is_inverse: "true",
                    //         contract_val_currency: "USD"
                    //     }
                    //
                    // options markets
                    //
                    //     {
                    //         instrument_id: 'BTC-USD-200327-4000-C',
                    //         underlying: 'BTC-USD',
                    //         settlement_currency: 'BTC',
                    //         contract_val: '0.1000',
                    //         option_type: 'C',
                    //         strike: '4000',
                    //         tick_size: '0.0005',
                    //         lot_size: '1.0000',
                    //         listing: '2019-12-25T08:30:36.302Z',
                    //         delivery: '2020-03-27T08:00:00.000Z',
                    //         state: '2',
                    //         trading_start_time: '2019-12-25T08:30:36.302Z',
                    //         timestamp: '2020-03-13T08:05:09.456Z',
                    //     }
                    //
                    const id = this.safeString(market, 'instrument_id');
                    let optionType = this.safeValue(market, 'option_type');
                    const contractVal = this.safeNumber(market, 'contract_val');
                    const contract = contractVal !== undefined;
                    const futuresAlias = this.safeString(market, 'alias');
                    let marketType = 'spot';
                    const spot = !contract;
                    const option = optionType !== undefined;
                    const future = !option && futuresAlias !== undefined;
                    const swap = contract && !future && !option;
                    let baseId = this.safeString(market, 'base_currency');
                    let quoteId = this.safeString(market, 'quote_currency');
                    const settleId = this.safeString(market, 'settlement_currency');
                    if (option) {
                        const underlying = this.safeString(market, 'underlying');
                        const parts = underlying.split('-');
                        baseId = this.safeString(parts, 0);
                        quoteId = this.safeString(parts, 1);
                        marketType = 'option';
                    } else if (future) {
                        baseId = this.safeString(market, 'underlying_index');
                        marketType = 'futures';
                    } else if (swap) marketType = 'swap';
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    const settle = this.safeCurrencyCode(settleId);
                    let symbol = base + '/' + quote;
                    let expiryDatetime = this.safeString(market, 'delivery');
                    let expiry = undefined;
                    const strike = this.safeValue(market, 'strike');
                    if (contract) {
                        symbol = symbol + ':' + settle;
                        if (future || option) {
                            if (future) expiryDatetime += 'T00:00:00Z';
                            expiry = this.parse8601(expiryDatetime);
                            symbol = symbol + '-' + this.yymmdd(expiry);
                            if (option) {
                                symbol = symbol + ':' + strike + ':' + optionType;
                                optionType = optionType === 'C' ? 'call' : 'put';
                            }
                        }
                    }
                    const lotSize = this.safeNumber2(market, 'lot_size', 'trade_increment');
                    const minPrice = this.safeString(market, 'tick_size');
                    const minAmountString = this.safeString2(market, 'min_size', 'base_min_size');
                    const minAmount = this.parseNumber(minAmountString);
                    let minCost = undefined;
                    if (minAmount !== undefined && minPrice !== undefined) minCost = this.parseNumber(Precise.stringMul(minPrice, minAmountString));
                    const fees = this.safeValue2(this.fees, marketType, 'trading', {});
                    const maxLeverageString = this.safeString(market, 'max_leverage', '1');
                    const maxLeverage = this.parseNumber(Precise.stringMax(maxLeverageString, '1'));
                    const precisionPrice = this.parseNumber(minPrice);
                    return this.extend(fees, {
                        'id': id,
                        'symbol': symbol,
                        'base': base,
                        'quote': quote,
                        'settle': settle,
                        'baseId': baseId,
                        'quoteId': quoteId,
                        'settleId': settleId,
                        'type': marketType,
                        'spot': spot,
                        'margin': spot && Precise.stringGt(maxLeverageString, '1'),
                        'swap': swap,
                        'future': future,
                        'futures': future,
                        'option': option,
                        'active': true,
                        'contract': contract,
                        'linear': contract ? quote === settle : undefined,
                        'inverse': contract ? base === settle : undefined,
                        'contractSize': contractVal,
                        'expiry': expiry,
                        'expiryDatetime': this.iso8601(expiry),
                        'strike': strike,
                        'optionType': optionType,
                        'precision': {
                            'amount': this.safeNumber(market, 'size_increment', lotSize),
                            'price': precisionPrice
                        },
                        'limits': {
                            'leverage': {
                                'min': this.parseNumber('1'),
                                'max': this.parseNumber(maxLeverage)
                            },
                            'amount': {
                                'min': minAmount,
                                'max': undefined
                            },
                            'price': {
                                'min': precisionPrice,
                                'max': undefined
                            },
                            'cost': {
                                'min': minCost,
                                'max': undefined
                            }
                        },
                        'info': market
                    });
                }
                async fetchMarketsByType(type, params = {}) {
                    if (type === 'option') {
                        const underlying = await this.optionGetUnderlying(params);
                        let result = [];
                        for(let i = 0; i < underlying.length; i++){
                            const response = await this.optionGetInstrumentsUnderlying({
                                'underlying': underlying[i]
                            });
                            //
                            // options markets
                            //
                            //     [
                            //         {
                            //             instrument_id: 'BTC-USD-200327-4000-C',
                            //             underlying: 'BTC-USD',
                            //             settlement_currency: 'BTC',
                            //             contract_val: '0.1000',
                            //             option_type: 'C',
                            //             strike: '4000',
                            //             tick_size: '0.0005',
                            //             lot_size: '1.0000',
                            //             listing: '2019-12-25T08:30:36.302Z',
                            //             delivery: '2020-03-27T08:00:00.000Z',
                            //             state: '2',
                            //             trading_start_time: '2019-12-25T08:30:36.302Z',
                            //             timestamp: '2020-03-13T08:05:09.456Z',
                            //         },
                            //     ]
                            //
                            result = this.arrayConcat(result, response);
                        }
                        return this.parseMarkets(result);
                    } else if (type === 'spot' || type === 'futures' || type === 'swap') {
                        const method = type + 'GetInstruments';
                        const response = await this[method](params);
                        //
                        // spot markets
                        //
                        //     [
                        //         {
                        //             base_currency: "EOS",
                        //             instrument_id: "EOS-OKB",
                        //             min_size: "0.01",
                        //             quote_currency: "OKB",
                        //             size_increment: "0.000001",
                        //             tick_size: "0.0001"
                        //         }
                        //     ]
                        //
                        // futures markets
                        //
                        //     [
                        //         {
                        //             instrument_id: "XRP-USD-200320",
                        //             underlying_index: "XRP",
                        //             quote_currency: "USD",
                        //             tick_size: "0.0001",
                        //             contract_val: "10",
                        //             listing: "2020-03-06",
                        //             delivery: "2020-03-20",
                        //             trade_increment: "1",
                        //             alias: "this_week",
                        //             underlying: "XRP-USD",
                        //             base_currency: "XRP",
                        //             settlement_currency: "XRP",
                        //             is_inverse: "true",
                        //             contract_val_currency: "USD",
                        //         }
                        //     ]
                        //
                        // swap markets
                        //
                        //     [
                        //         {
                        //             instrument_id: "BSV-USD-SWAP",
                        //             underlying_index: "BSV",
                        //             quote_currency: "USD",
                        //             coin: "BSV",
                        //             contract_val: "10",
                        //             listing: "2018-12-21T07:53:47.000Z",
                        //             delivery: "2020-03-14T08:00:00.000Z",
                        //             size_increment: "1",
                        //             tick_size: "0.01",
                        //             base_currency: "BSV",
                        //             underlying: "BSV-USD",
                        //             settlement_currency: "BSV",
                        //             is_inverse: "true",
                        //             contract_val_currency: "USD"
                        //         }
                        //     ]
                        //
                        return this.parseMarkets(response);
                    } else throw new NotSupported(this.id + ' fetchMarketsByType() does not support market type ' + type);
                }
                async fetchCurrencies(params = {}) {
                    // despite that their docs say these endpoints are public:
                    //     https://www.okex.com/api/account/v3/withdrawal/fee
                    //     https://www.okex.com/api/account/v3/currencies
                    // it will still reply with { "code":30001, "message": "OK-ACCESS-KEY header is required" }
                    // if you attempt to access it without authentication
                    if (!this.checkRequiredCredentials(false)) {
                        if (this.options['warnOnFetchCurrenciesWithoutAuthorization']) throw new ExchangeError1(this.id + ' fetchCurrencies() is a private API endpoint that requires authentication with API keys. Set the API keys on the exchange instance or exchange.options["warnOnFetchCurrenciesWithoutAuthorization"] = false to suppress this warning message.');
                        return undefined;
                    } else {
                        const response = await this.accountGetCurrencies(params);
                        //
                        //     [
                        //         {
                        //             name: '',
                        //             currency: 'BTC',
                        //             can_withdraw: '1',
                        //             can_deposit: '1',
                        //             min_withdrawal: '0.0100000000000000'
                        //         },
                        //     ]
                        //
                        const result = {};
                        for(let i = 0; i < response.length; i++){
                            const currency = response[i];
                            const id = this.safeString(currency, 'currency');
                            const code = this.safeCurrencyCode(id);
                            const precision = 0.00000001; // default precision, todo: fix "magic constants"
                            const name = this.safeString(currency, 'name');
                            const canDeposit = this.safeInteger(currency, 'can_deposit');
                            const canWithdraw = this.safeInteger(currency, 'can_withdraw');
                            const depositEnabled = canDeposit === 1;
                            const withdrawEnabled = canWithdraw === 1;
                            const active = canDeposit && canWithdraw ? true : false;
                            result[code] = {
                                'id': id,
                                'code': code,
                                'info': currency,
                                'type': undefined,
                                'name': name,
                                'active': active,
                                'deposit': depositEnabled,
                                'withdraw': withdrawEnabled,
                                'fee': undefined,
                                'precision': precision,
                                'limits': {
                                    'amount': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'withdraw': {
                                        'min': this.safeNumber(currency, 'min_withdrawal'),
                                        'max': undefined
                                    }
                                }
                            };
                        }
                        return result;
                    }
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let method = market['type'] + 'GetInstrumentsInstrumentId';
                    method += market['type'] === 'swap' ? 'Depth' : 'Book';
                    const request = {
                        'instrument_id': market['id']
                    };
                    if (limit !== undefined) request['size'] = limit; // max 200
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {      asks: [ ["0.02685268", "0.242571", "1"],
                    //                    ["0.02685493", "0.164085", "1"],
                    //                    ...
                    //                    ["0.02779", "1.039", "1"],
                    //                    ["0.027813", "0.0876", "1"]        ],
                    //            bids: [ ["0.02684052", "10.371849", "1"],
                    //                    ["0.02684051", "3.707", "4"],
                    //                    ...
                    //                    ["0.02634963", "0.132934", "1"],
                    //                    ["0.02634962", "0.264838", "2"]    ],
                    //       timestamp:   "2018-12-17T20:24:16.159Z"            }
                    //
                    // swap
                    //
                    //     {
                    //         "asks":[
                    //             ["916.21","94","0","1"]
                    //         ],
                    //         "bids":[
                    //             ["916.1","15","0","1"]
                    //         ],
                    //         "time":"2021-04-16T02:04:48.282Z"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString2(response, 'timestamp', 'time'));
                    return this.parseOrderBook(response, symbol, timestamp);
                }
                parseTicker(ticker, market) {
                    //
                    //     {         best_ask: "0.02665472",
                    //               best_bid: "0.02665221",
                    //          instrument_id: "ETH-BTC",
                    //             product_id: "ETH-BTC",
                    //                   last: "0.02665472",
                    //                    ask: "0.02665472", // missing in the docs
                    //                    bid: "0.02665221", // not mentioned in the docs
                    //               open_24h: "0.02645482",
                    //               high_24h: "0.02714633",
                    //                low_24h: "0.02614109",
                    //        base_volume_24h: "572298.901923",
                    //              timestamp: "2018-12-17T21:20:07.856Z",
                    //       quote_volume_24h: "15094.86831261"            }
                    //
                    const timestamp = this.parse8601(this.safeString(ticker, 'timestamp'));
                    const marketId = this.safeString(ticker, 'instrument_id');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    const last = this.safeString(ticker, 'last');
                    const open = this.safeString(ticker, 'open_24h');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high_24h'),
                        'low': this.safeString(ticker, 'low_24h'),
                        'bid': this.safeString(ticker, 'best_bid'),
                        'bidVolume': this.safeString(ticker, 'best_bid_size'),
                        'ask': this.safeString(ticker, 'best_ask'),
                        'askVolume': this.safeString(ticker, 'best_ask_size'),
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'base_volume_24h'),
                        'quoteVolume': this.safeString(ticker, 'quote_volume_24h'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const method = market['type'] + 'GetInstrumentsInstrumentIdTicker';
                    const request = {
                        'instrument_id': market['id']
                    };
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {         best_ask: "0.02665472",
                    //               best_bid: "0.02665221",
                    //          instrument_id: "ETH-BTC",
                    //             product_id: "ETH-BTC",
                    //                   last: "0.02665472",
                    //                    ask: "0.02665472",
                    //                    bid: "0.02665221",
                    //               open_24h: "0.02645482",
                    //               high_24h: "0.02714633",
                    //                low_24h: "0.02614109",
                    //        base_volume_24h: "572298.901923",
                    //              timestamp: "2018-12-17T21:20:07.856Z",
                    //       quote_volume_24h: "15094.86831261"            }
                    //
                    return this.parseTicker(response);
                }
                async fetchTickersByType(type, symbols, params = {}) {
                    await this.loadMarkets();
                    const method = type + 'GetInstrumentsTicker';
                    const response = await this[method](params);
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const ticker = this.parseTicker(response[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTickers(symbols, params = {}) {
                    const defaultType = this.safeString2(this.options, 'fetchTickers', 'defaultType');
                    const type = this.safeString(params, 'type', defaultType);
                    return await this.fetchTickersByType(type, symbols, this.omit(params, 'type'));
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     spot trades
                    //
                    //         {
                    //             time: "2018-12-17T23:31:08.268Z",
                    //             timestamp: "2018-12-17T23:31:08.268Z",
                    //             trade_id: "409687906",
                    //             price: "0.02677805",
                    //             size: "0.923467",
                    //             side: "sell"
                    //         }
                    //
                    //     futures trades, swap trades
                    //
                    //         {
                    //             trade_id: "1989230840021013",
                    //             side: "buy",
                    //             price: "92.42",
                    //             qty: "184", // missing in swap markets
                    //             size: "5", // missing in futures markets
                    //             timestamp: "2018-12-17T23:26:04.613Z"
                    //         }
                    //
                    // fetchOrderTrades (private)
                    //
                    //     spot trades, margin trades
                    //
                    //         {
                    //             "created_at":"2019-03-15T02:52:56.000Z",
                    //             "exec_type":"T", // whether the order is taker or maker
                    //             "fee":"0.00000082",
                    //             "instrument_id":"BTC-USDT",
                    //             "ledger_id":"3963052721",
                    //             "liquidity":"T", // whether the order is taker or maker
                    //             "order_id":"2482659399697408",
                    //             "price":"3888.6",
                    //             "product_id":"BTC-USDT",
                    //             "side":"buy",
                    //             "size":"0.00055306",
                    //             "timestamp":"2019-03-15T02:52:56.000Z"
                    //         },
                    //
                    //     futures trades, swap trades
                    //
                    //         {
                    //             "trade_id":"197429674631450625",
                    //             "instrument_id":"EOS-USD-SWAP",
                    //             "order_id":"6a-7-54d663a28-0",
                    //             "price":"3.633",
                    //             "order_qty":"1.0000",
                    //             "fee":"-0.000551",
                    //             "created_at":"2019-03-21T04:41:58.0Z", // missing in swap trades
                    //             "timestamp":"2019-03-25T05:56:31.287Z", // missing in futures trades
                    //             "exec_type":"M", // whether the order is taker or maker
                    //             "side":"short", // "buy" in futures trades
                    //         }
                    //
                    let symbol = undefined;
                    const marketId = this.safeString(trade, 'instrument_id');
                    let base = undefined;
                    let quote = undefined;
                    if (marketId in this.markets_by_id) {
                        market = this.markets_by_id[marketId];
                        symbol = market['symbol'];
                        base = market['base'];
                        quote = market['quote'];
                    } else if (marketId !== undefined) {
                        const parts = marketId.split('-');
                        const numParts = parts.length;
                        if (numParts === 2) {
                            const [baseId, quoteId] = parts;
                            base = this.safeCurrencyCode(baseId);
                            quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote;
                        } else symbol = marketId;
                    }
                    if (symbol === undefined && market !== undefined) {
                        symbol = market['symbol'];
                        base = market['base'];
                        quote = market['quote'];
                    }
                    const timestamp = this.parse8601(this.safeString2(trade, 'timestamp', 'created_at'));
                    const priceString = this.safeString(trade, 'price');
                    let amountString = this.safeString2(trade, 'size', 'qty');
                    amountString = this.safeString(trade, 'order_qty', amountString);
                    let takerOrMaker = this.safeString2(trade, 'exec_type', 'liquidity');
                    if (takerOrMaker === 'M') takerOrMaker = 'maker';
                    else if (takerOrMaker === 'T') takerOrMaker = 'taker';
                    const side = this.safeString(trade, 'side');
                    const feeCostString = this.safeString(trade, 'fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrency = side === 'buy' ? base : quote;
                        fee = {
                            // fee is either a positive number (invitation rebate)
                            // or a negative number (transaction fee deduction)
                            // therefore we need to invert the fee
                            // more about it https://github.com/ccxt/ccxt/issues/5909
                            'cost': Precise.stringNeg(feeCostString),
                            'currency': feeCurrency
                        };
                    }
                    const orderId = this.safeString(trade, 'order_id');
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': this.safeString2(trade, 'trade_id', 'ledger_id'),
                        'order': orderId,
                        'type': undefined,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const method = market['type'] + 'GetInstrumentsInstrumentIdTrades';
                    if (limit === undefined || limit > 100) limit = 100; // maximum = default = 100
                    const request = {
                        'instrument_id': market['id'],
                        'limit': limit
                    };
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot markets
                    //
                    //     [
                    //         {
                    //             time: "2018-12-17T23:31:08.268Z",
                    //             timestamp: "2018-12-17T23:31:08.268Z",
                    //             trade_id: "409687906",
                    //             price: "0.02677805",
                    //             size: "0.923467",
                    //             side: "sell"
                    //         }
                    //     ]
                    //
                    // futures markets, swap markets
                    //
                    //     [
                    //         {
                    //             trade_id: "1989230840021013",
                    //             side: "buy",
                    //             price: "92.42",
                    //             qty: "184", // missing in swap markets
                    //             size: "5", // missing in futures markets
                    //             timestamp: "2018-12-17T23:26:04.613Z"
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    // spot markets
                    //
                    //     {
                    //         close: "0.02684545",
                    //         high: "0.02685084",
                    //         low: "0.02683312",
                    //         open: "0.02683894",
                    //         time: "2018-12-17T20:28:00.000Z",
                    //         volume: "101.457222"
                    //     }
                    //
                    // futures markets
                    //
                    //     [
                    //         1545072720000,
                    //         0.3159,
                    //         0.3161,
                    //         0.3144,
                    //         0.3149,
                    //         22886,
                    //         725179.26172331,
                    //     ]
                    //
                    if (Array.isArray(ohlcv)) {
                        const numElements = ohlcv.length;
                        const volumeIndex = numElements > 6 ? 6 : 5;
                        let timestamp = this.safeValue(ohlcv, 0);
                        if (typeof timestamp === 'string') timestamp = this.parse8601(timestamp);
                        return [
                            timestamp,
                            this.safeNumber(ohlcv, 1),
                            this.safeNumber(ohlcv, 2),
                            this.safeNumber(ohlcv, 3),
                            this.safeNumber(ohlcv, 4),
                            // this.safeNumber (ohlcv, 5),         // Quote Volume
                            // this.safeNumber (ohlcv, 6),         // Base Volume
                            this.safeNumber(ohlcv, volumeIndex)
                        ];
                    } else return [
                        this.parse8601(this.safeString(ohlcv, 'time')),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const duration = this.parseTimeframe(timeframe);
                    const request = {
                        'instrument_id': market['id'],
                        'granularity': this.timeframes[timeframe]
                    };
                    const options = this.safeValue(this.options, 'fetchOHLCV', {});
                    const defaultType = this.safeString(options, 'type', 'Candles'); // Candles or HistoryCandles
                    const type = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    const method = market['type'] + 'GetInstrumentsInstrumentId' + type;
                    if (type === 'Candles') {
                        if (since !== undefined) {
                            if (limit !== undefined) request['end'] = this.iso8601(this.sum(since, limit * duration * 1000));
                            request['start'] = this.iso8601(since);
                        } else if (limit !== undefined) {
                            const now = this.milliseconds();
                            request['start'] = this.iso8601(now - limit * duration * 1000);
                            request['end'] = this.iso8601(now);
                        }
                    } else if (type === 'HistoryCandles') {
                        if (market['option']) throw new NotSupported(this.id + ' fetchOHLCV() does not have ' + type + ' for ' + market['type'] + ' markets');
                        if (since !== undefined) {
                            if (limit === undefined) limit = 300; // default
                            request['start'] = this.iso8601(this.sum(since, limit * duration * 1000));
                            request['end'] = this.iso8601(since);
                        } else if (limit !== undefined) {
                            const now = this.milliseconds();
                            request['end'] = this.iso8601(now - limit * duration * 1000);
                            request['start'] = this.iso8601(now);
                        }
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot markets
                    //
                    //     [
                    //         {
                    //             close: "0.02683401",
                    //             high: "0.02683401",
                    //             low: "0.02683401",
                    //             open: "0.02683401",
                    //             time: "2018-12-17T23:47:00.000Z",
                    //             volume: "0"
                    //         },
                    //         {
                    //             close: "0.02684545",
                    //             high: "0.02685084",
                    //             low: "0.02683312",
                    //             open: "0.02683894",
                    //             time: "2018-12-17T20:28:00.000Z",
                    //             volume: "101.457222"
                    //         }
                    //     ]
                    //
                    // futures
                    //
                    //     [
                    //         [
                    //             1545090660000,
                    //             0.3171,
                    //             0.3174,
                    //             0.3171,
                    //             0.3173,
                    //             1648,
                    //             51930.38579450868
                    //         ],
                    //         [
                    //             1545072720000,
                    //             0.3159,
                    //             0.3161,
                    //             0.3144,
                    //             0.3149,
                    //             22886,
                    //             725179.26172331
                    //         ]
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseAccountBalance(response) {
                    //
                    // account
                    //
                    //     [
                    //         {
                    //             balance:  0,
                    //             available:  0,
                    //             currency: "BTC",
                    //             hold:  0
                    //         },
                    //         {
                    //             balance:  0,
                    //             available:  0,
                    //             currency: "ETH",
                    //             hold:  0
                    //         }
                    //     ]
                    //
                    // spot
                    //
                    //     [
                    //         {
                    //             frozen: "0",
                    //             hold: "0",
                    //             id: "2149632",
                    //             currency: "BTC",
                    //             balance: "0.0000000497717339",
                    //             available: "0.0000000497717339",
                    //             holds: "0"
                    //         },
                    //         {
                    //             frozen: "0",
                    //             hold: "0",
                    //             id: "2149632",
                    //             currency: "ICN",
                    //             balance: "0.00000000925",
                    //             available: "0.00000000925",
                    //             holds: "0"
                    //         }
                    //     ]
                    //
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'balance');
                        account['used'] = this.safeString(balance, 'hold');
                        account['free'] = this.safeString(balance, 'available');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                parseMarginBalance(response) {
                    //
                    //     [
                    //         {
                    //             "currency:BTC": {
                    //                 "available":"0",
                    //                 "balance":"0",
                    //                 "borrowed":"0",
                    //                 "can_withdraw":"0",
                    //                 "frozen":"0",
                    //                 "hold":"0",
                    //                 "holds":"0",
                    //                 "lending_fee":"0"
                    //             },
                    //             "currency:USDT": {
                    //                 "available":"100",
                    //                 "balance":"100",
                    //                 "borrowed":"0",
                    //                 "can_withdraw":"100",
                    //                 "frozen":"0",
                    //                 "hold":"0",
                    //                 "holds":"0",
                    //                 "lending_fee":"0"
                    //             },
                    //             "instrument_id":"BTC-USDT",
                    //             "liquidation_price":"0",
                    //             "product_id":"BTC-USDT",
                    //             "risk_rate":""
                    //         },
                    //     ]
                    //
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const marketId = this.safeString(balance, 'instrument_id');
                        const market = this.safeValue(this.markets_by_id, marketId);
                        let symbol = undefined;
                        if (market === undefined) {
                            const [baseId, quoteId] = marketId.split('-');
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote;
                        } else symbol = market['symbol'];
                        const omittedBalance = this.omit(balance, [
                            'instrument_id',
                            'liquidation_price',
                            'product_id',
                            'risk_rate',
                            'margin_ratio',
                            'maint_margin_ratio',
                            'tiers'
                        ]);
                        const keys = Object.keys(omittedBalance);
                        const accounts = {};
                        for(let k = 0; k < keys.length; k++){
                            const key = keys[k];
                            const marketBalance = balance[key];
                            if (key.indexOf(':') >= 0) {
                                const parts = key.split(':');
                                const currencyId = parts[1];
                                const code = this.safeCurrencyCode(currencyId);
                                const account = this.account();
                                account['total'] = this.safeString(marketBalance, 'balance');
                                account['used'] = this.safeString(marketBalance, 'hold');
                                account['free'] = this.safeString(marketBalance, 'available');
                                accounts[code] = account;
                            } else throw new NotSupported(this.id + ' margin balance response format has changed!');
                        }
                        result[symbol] = this.safeBalance(accounts);
                    }
                    return result;
                }
                parseFuturesBalance(response) {
                    //
                    //     {
                    //         "info":{
                    //             "eos":{
                    //                 "auto_margin":"0",
                    //                 "contracts": [
                    //                     {
                    //                         "available_qty":"40.37069445",
                    //                         "fixed_balance":"0",
                    //                         "instrument_id":"EOS-USD-190329",
                    //                         "margin_for_unfilled":"0",
                    //                         "margin_frozen":"0",
                    //                         "realized_pnl":"0",
                    //                         "unrealized_pnl":"0"
                    //                     },
                    //                     {
                    //                         "available_qty":"40.37069445",
                    //                         "fixed_balance":"14.54895721",
                    //                         "instrument_id":"EOS-USD-190628",
                    //                         "margin_for_unfilled":"0",
                    //                         "margin_frozen":"10.64042157",
                    //                         "realized_pnl":"-3.90853564",
                    //                         "unrealized_pnl":"-0.259"
                    //                     },
                    //                 ],
                    //                 "equity":"50.75220665",
                    //                 "margin_mode":"fixed",
                    //                 "total_avail_balance":"40.37069445"
                    //             },
                    //         }
                    //     }
                    //
                    // their root field name is "info", so our info will contain their info
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const info = this.safeValue(response, 'info', {});
                    const ids = Object.keys(info);
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const code = this.safeCurrencyCode(id);
                        const balance = this.safeValue(info, id, {});
                        const account = this.account();
                        const totalAvailBalance = this.safeString(balance, 'total_avail_balance');
                        if (this.safeString(balance, 'margin_mode') === 'fixed') {
                            const contracts = this.safeValue(balance, 'contracts', []);
                            let free = totalAvailBalance;
                            for(let i = 0; i < contracts.length; i++){
                                const contract = contracts[i];
                                const fixedBalance = this.safeString(contract, 'fixed_balance');
                                const realizedPnl = this.safeString(contract, 'realized_pnl');
                                const marginFrozen = this.safeString(contract, 'margin_frozen');
                                const marginForUnfilled = this.safeString(contract, 'margin_for_unfilled');
                                const margin = Precise.stringSub(Precise.stringSub(Precise.stringAdd(fixedBalance, realizedPnl), marginFrozen), marginForUnfilled);
                                free = Precise.stringAdd(free, margin);
                            }
                            account['free'] = free;
                        } else {
                            const realizedPnl = this.safeString(balance, 'realized_pnl');
                            const unrealizedPnl = this.safeString(balance, 'unrealized_pnl');
                            const marginFrozen = this.safeString(balance, 'margin_frozen');
                            const marginForUnfilled = this.safeString(balance, 'margin_for_unfilled');
                            const positive = Precise.stringAdd(Precise.stringAdd(totalAvailBalance, realizedPnl), unrealizedPnl);
                            account['free'] = Precise.stringSub(Precise.stringSub(positive, marginFrozen), marginForUnfilled);
                        }
                        // it may be incorrect to use total, free and used for swap accounts
                        account['total'] = this.safeString(balance, 'equity');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                parseSwapBalance(response) {
                    //
                    //     {
                    //         "info": [
                    //             {
                    //                 "equity":"3.0139",
                    //                 "fixed_balance":"0.0000",
                    //                 "instrument_id":"EOS-USD-SWAP",
                    //                 "margin":"0.5523",
                    //                 "margin_frozen":"0.0000",
                    //                 "margin_mode":"crossed",
                    //                 "margin_ratio":"1.0913",
                    //                 "realized_pnl":"-0.0006",
                    //                 "timestamp":"2019-03-25T03:46:10.336Z",
                    //                 "total_avail_balance":"3.0000",
                    //                 "unrealized_pnl":"0.0145"
                    //             }
                    //         ]
                    //     }
                    //
                    // their root field name is "info", so our info will contain their info
                    const result = {
                        'info': response
                    };
                    let timestamp = undefined;
                    const info = this.safeValue(response, 'info', []);
                    for(let i = 0; i < info.length; i++){
                        const balance = info[i];
                        const marketId = this.safeString(balance, 'instrument_id');
                        let symbol = marketId;
                        if (marketId in this.markets_by_id) symbol = this.markets_by_id[marketId]['symbol'];
                        const balanceTimestamp = this.parse8601(this.safeString(balance, 'timestamp'));
                        timestamp = timestamp === undefined ? balanceTimestamp : Math.max(timestamp, balanceTimestamp);
                        const account = this.account();
                        // it may be incorrect to use total, free and used for swap accounts
                        account['total'] = this.safeString(balance, 'equity');
                        account['free'] = this.safeString(balance, 'total_avail_balance');
                        result[symbol] = account;
                    }
                    result['timestamp'] = timestamp;
                    result['datetime'] = this.iso8601(timestamp);
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    const defaultType = this.safeString2(this.options, 'fetchBalance', 'defaultType');
                    const type = this.safeString(params, 'type', defaultType);
                    if (type === undefined) throw new ArgumentsRequired1(this.id + " fetchBalance() requires a type parameter (one of 'account', 'spot', 'margin', 'futures', 'swap')");
                    await this.loadMarkets();
                    const suffix = type === 'account' ? 'Wallet' : 'Accounts';
                    const method = type + 'Get' + suffix;
                    const query = this.omit(params, 'type');
                    const response = await this[method](query);
                    //
                    // account
                    //
                    //     [
                    //         {
                    //             balance:  0,
                    //             available:  0,
                    //             currency: "BTC",
                    //             hold:  0
                    //         },
                    //         {
                    //             balance:  0,
                    //             available:  0,
                    //             currency: "ETH",
                    //             hold:  0
                    //         }
                    //     ]
                    //
                    // spot
                    //
                    //     [
                    //         {
                    //             frozen: "0",
                    //             hold: "0",
                    //             id: "2149632",
                    //             currency: "BTC",
                    //             balance: "0.0000000497717339",
                    //             available: "0.0000000497717339",
                    //             holds: "0"
                    //         },
                    //         {
                    //             frozen: "0",
                    //             hold: "0",
                    //             id: "2149632",
                    //             currency: "ICN",
                    //             balance: "0.00000000925",
                    //             available: "0.00000000925",
                    //             holds: "0"
                    //         }
                    //     ]
                    //
                    // margin
                    //
                    //     [
                    //         {
                    //             "currency:BTC": {
                    //                 "available":"0",
                    //                 "balance":"0",
                    //                 "borrowed":"0",
                    //                 "can_withdraw":"0",
                    //                 "frozen":"0",
                    //                 "hold":"0",
                    //                 "holds":"0",
                    //                 "lending_fee":"0"
                    //             },
                    //             "currency:USDT": {
                    //                 "available":"100",
                    //                 "balance":"100",
                    //                 "borrowed":"0",
                    //                 "can_withdraw":"100",
                    //                 "frozen":"0",
                    //                 "hold":"0",
                    //                 "holds":"0",
                    //                 "lending_fee":"0"
                    //             },
                    //             "instrument_id":"BTC-USDT",
                    //             "liquidation_price":"0",
                    //             "product_id":"BTC-USDT",
                    //             "risk_rate":""
                    //         },
                    //     ]
                    //
                    // futures
                    //
                    //     {
                    //         "info":{
                    //             "eos":{
                    //                 "auto_margin":"0",
                    //                 "contracts": [
                    //                     {
                    //                         "available_qty":"40.37069445",
                    //                         "fixed_balance":"0",
                    //                         "instrument_id":"EOS-USD-190329",
                    //                         "margin_for_unfilled":"0",
                    //                         "margin_frozen":"0",
                    //                         "realized_pnl":"0",
                    //                         "unrealized_pnl":"0"
                    //                     },
                    //                     {
                    //                         "available_qty":"40.37069445",
                    //                         "fixed_balance":"14.54895721",
                    //                         "instrument_id":"EOS-USD-190628",
                    //                         "margin_for_unfilled":"0",
                    //                         "margin_frozen":"10.64042157",
                    //                         "realized_pnl":"-3.90853564",
                    //                         "unrealized_pnl":"-0.259"
                    //                     },
                    //                 ],
                    //                 "equity":"50.75220665",
                    //                 "margin_mode":"fixed",
                    //                 "total_avail_balance":"40.37069445"
                    //             },
                    //         }
                    //     }
                    //
                    // swap
                    //
                    //     {
                    //         "info": [
                    //             {
                    //                 "equity":"3.0139",
                    //                 "fixed_balance":"0.0000",
                    //                 "instrument_id":"EOS-USD-SWAP",
                    //                 "margin":"0.5523",
                    //                 "margin_frozen":"0.0000",
                    //                 "margin_mode":"crossed",
                    //                 "margin_ratio":"1.0913",
                    //                 "realized_pnl":"-0.0006",
                    //                 "timestamp":"2019-03-25T03:46:10.336Z",
                    //                 "total_avail_balance":"3.0000",
                    //                 "unrealized_pnl":"0.0145"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseBalanceByType(type, response);
                }
                parseBalanceByType(type, response) {
                    if (type === 'account' || type === 'spot') return this.parseAccountBalance(response);
                    else if (type === 'margin') return this.parseMarginBalance(response);
                    else if (type === 'futures') return this.parseFuturesBalance(response);
                    else if (type === 'swap') return this.parseSwapBalance(response);
                    throw new NotSupported(this.id + " fetchBalance does not support the '" + type + "' type (the type must be one of 'account', 'spot', 'margin', 'futures', 'swap')");
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let request = {
                        'instrument_id': market['id']
                    };
                    const clientOrderId = this.safeString2(params, 'client_oid', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['client_oid'] = clientOrderId;
                        params = this.omit(params, [
                            'client_oid',
                            'clientOrderId'
                        ]);
                    }
                    let method = undefined;
                    if (market['futures'] || market['swap']) {
                        const size = market['futures'] ? this.numberToString(amount) : this.amountToPrecision(symbol, amount);
                        request = this.extend(request, {
                            'type': type,
                            'size': size
                        });
                        const orderType = this.safeString(params, 'order_type');
                        // order_type === '4' means a market order
                        const isMarketOrder = type === 'market' || orderType === '4';
                        if (isMarketOrder) request['order_type'] = '4';
                        else request['price'] = this.priceToPrecision(symbol, price);
                        if (market['futures']) request['leverage'] = '10'; // or '20'
                        method = market['type'] + 'PostOrder';
                    } else {
                        const marginTrading = this.safeString(params, 'margin_trading', '1'); // 1 = spot, 2 = margin
                        request = this.extend(request, {
                            'side': side,
                            'type': type,
                            'margin_trading': marginTrading
                        });
                        if (type === 'limit') {
                            request['price'] = this.priceToPrecision(symbol, price);
                            request['size'] = this.amountToPrecision(symbol, amount);
                        } else if (type === 'market') {
                            // for market buy it requires the amount of quote currency to spend
                            if (side === 'buy') {
                                let notional = this.safeNumber(params, 'notional');
                                const createMarketBuyOrderRequiresPrice = this.safeValue(this.options, 'createMarketBuyOrderRequiresPrice', true);
                                if (createMarketBuyOrderRequiresPrice) {
                                    if (price !== undefined) {
                                        if (notional === undefined) notional = amount * price;
                                    } else if (notional === undefined) throw new InvalidOrder(this.id + " createOrder() requires the price argument with market buy orders to calculate total order cost (amount to spend), where cost = amount * price. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount, or, alternatively, add .options['createMarketBuyOrderRequiresPrice'] = false and supply the total cost value in the 'amount' argument or in the 'notional' extra parameter (the exchange-specific behaviour)");
                                } else notional = notional === undefined ? amount : notional;
                                const precision = market['precision']['price'];
                                request['notional'] = this.decimalToPrecision(notional, TRUNCATE, precision, this.precisionMode);
                            } else request['size'] = this.amountToPrecision(symbol, amount);
                        }
                        method = marginTrading === '2' ? 'marginPostOrders' : 'spotPostOrders';
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "client_oid":"oktspot79",
                    //         "error_code":"",
                    //         "error_message":"",
                    //         "order_id":"2510789768709120",
                    //         "result":true
                    //     }
                    //
                    const order = this.parseOrder(response, market);
                    return this.extend(order, {
                        'type': type,
                        'side': side
                    });
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let type = undefined;
                    if (market['futures'] || market['swap']) type = market['type'];
                    else {
                        const defaultType = this.safeString2(this.options, 'cancelOrder', 'defaultType', market['type']);
                        type = this.safeString(params, 'type', defaultType);
                    }
                    if (type === undefined) throw new ArgumentsRequired1(this.id + " cancelOrder() requires a type parameter (one of 'spot', 'margin', 'futures', 'swap').");
                    let method = type + 'PostCancelOrder';
                    const request = {
                        'instrument_id': market['id']
                    };
                    if (market['futures'] || market['swap']) method += 'InstrumentId';
                    else method += 's';
                    const clientOrderId = this.safeString2(params, 'client_oid', 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        method += 'ClientOid';
                        request['client_oid'] = clientOrderId;
                    } else {
                        method += 'OrderId';
                        request['order_id'] = id;
                    }
                    const query = this.omit(params, [
                        'type',
                        'client_oid',
                        'clientOrderId'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    const result = 'result' in response ? response : this.safeValue(response, market['id'], {});
                    //
                    // spot, margin
                    //
                    //     {
                    //         "btc-usdt": [
                    //             {
                    //                 "result":true,
                    //                 "client_oid":"a123",
                    //                 "order_id": "2510832677225473"
                    //             }
                    //         ]
                    //     }
                    //
                    // futures, swap
                    //
                    //     {
                    //         "result": true,
                    //         "client_oid": "oktfuture10", // missing if requested by order_id
                    //         "order_id": "2517535534836736",
                    //         "instrument_id": "EOS-USD-190628"
                    //     }
                    //
                    return this.parseOrder(result, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '-2': 'failed',
                        '-1': 'canceled',
                        '0': 'open',
                        '1': 'open',
                        '2': 'closed',
                        '3': 'open',
                        '4': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrderSide(side) {
                    const sides = {
                        '1': 'buy',
                        '2': 'sell',
                        '3': 'sell',
                        '4': 'buy'
                    };
                    return this.safeString(sides, side, side);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "client_oid":"oktspot79",
                    //         "error_code":"",
                    //         "error_message":"",
                    //         "order_id":"2510789768709120",
                    //         "result":true
                    //     }
                    //
                    // cancelOrder
                    //
                    //     {
                    //         "result": true,
                    //         "client_oid": "oktfuture10", // missing if requested by order_id
                    //         "order_id": "2517535534836736",
                    //         // instrument_id is missing for spot/margin orders
                    //         // available in futures and swap orders only
                    //         "instrument_id": "EOS-USD-190628",
                    //     }
                    //
                    // fetchOrder, fetchOrdersByState, fetchOpenOrders, fetchClosedOrders
                    //
                    //     // spot and margin orders
                    //
                    //     {
                    //         "client_oid":"oktspot76",
                    //         "created_at":"2019-03-18T07:26:49.000Z",
                    //         "filled_notional":"3.9734",
                    //         "filled_size":"0.001", // filled_qty in futures and swap orders
                    //         "funds":"", // this is most likely the same as notional
                    //         "instrument_id":"BTC-USDT",
                    //         "notional":"",
                    //         "order_id":"2500723297813504",
                    //         "order_type":"0",
                    //         "price":"4013",
                    //         "product_id":"BTC-USDT", // missing in futures and swap orders
                    //         "side":"buy",
                    //         "size":"0.001",
                    //         "status":"filled",
                    //         "state": "2",
                    //         "timestamp":"2019-03-18T07:26:49.000Z",
                    //         "type":"limit"
                    //     }
                    //
                    //     // futures and swap orders
                    //
                    //     {
                    //         "instrument_id":"EOS-USD-190628",
                    //         "size":"10",
                    //         "timestamp":"2019-03-20T10:04:55.000Z",
                    //         "filled_qty":"10", // filled_size in spot and margin orders
                    //         "fee":"-0.00841043",
                    //         "order_id":"2512669605501952",
                    //         "price":"3.668",
                    //         "price_avg":"3.567", // missing in spot and margin orders
                    //         "status":"2",
                    //         "state": "2",
                    //         "type":"4",
                    //         "contract_val":"10",
                    //         "leverage":"10", // missing in swap, spot and margin orders
                    //         "client_oid":"",
                    //         "pnl":"1.09510794", // missing in swap, spo and margin orders
                    //         "order_type":"0"
                    //     }
                    //
                    const id = this.safeString(order, 'order_id');
                    const timestamp = this.parse8601(this.safeString(order, 'timestamp'));
                    let side = this.safeString(order, 'side');
                    const type = this.safeString(order, 'type');
                    if (side !== 'buy' && side !== 'sell') side = this.parseOrderSide(type);
                    const marketId = this.safeString(order, 'instrument_id');
                    market = this.safeMarket(marketId, market);
                    let amount = this.safeString(order, 'size');
                    const filled = this.safeString2(order, 'filled_size', 'filled_qty');
                    let remaining = undefined;
                    if (amount !== undefined) {
                        if (filled !== undefined) {
                            amount = Precise.stringMax(amount, filled);
                            remaining = Precise.stringMax('0', Precise.stringSub(amount, filled));
                        }
                    }
                    if (type === 'market') remaining = '0';
                    let cost = this.safeString2(order, 'filled_notional', 'funds');
                    const price = this.safeString(order, 'price');
                    let average = this.safeString(order, 'price_avg');
                    if (cost === undefined) {
                        if (filled !== undefined && average !== undefined) cost = Precise.stringMul(average, filled);
                    } else if (average === undefined && filled !== undefined && Precise.stringGt(filled, '0')) average = Precise.stringDiv(cost, filled);
                    const status = this.parseOrderStatus(this.safeString(order, 'state'));
                    const feeCost = this.safeNumber(order, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined) {
                        const feeCurrency = undefined;
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrency
                        };
                    }
                    let clientOrderId = this.safeString(order, 'client_oid');
                    if (clientOrderId !== undefined && clientOrderId.length < 1) clientOrderId = undefined; // fix empty clientOrderId string
                    const stopPrice = this.safeNumber(order, 'trigger_price');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'average': average,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const defaultType = this.safeString2(this.options, 'fetchOrder', 'defaultType', market['type']);
                    const type = this.safeString(params, 'type', defaultType);
                    if (type === undefined) throw new ArgumentsRequired1(this.id + " fetchOrder() requires a type parameter (one of 'spot', 'margin', 'futures', 'swap').");
                    const instrumentId = market['futures'] || market['swap'] ? 'InstrumentId' : '';
                    let method = type + 'GetOrders' + instrumentId;
                    const request = {
                        'instrument_id': market['id']
                    };
                    const clientOid = this.safeString(params, 'client_oid');
                    if (clientOid !== undefined) {
                        method += 'ClientOid';
                        request['client_oid'] = clientOid;
                    } else {
                        method += 'OrderId';
                        request['order_id'] = id;
                    }
                    const query = this.omit(params, 'type');
                    const response = await this[method](this.extend(request, query));
                    //
                    // spot, margin
                    //
                    //     {
                    //         "client_oid":"oktspot70",
                    //         "created_at":"2019-03-15T02:52:56.000Z",
                    //         "filled_notional":"3.8886",
                    //         "filled_size":"0.001",
                    //         "funds":"",
                    //         "instrument_id":"BTC-USDT",
                    //         "notional":"",
                    //         "order_id":"2482659399697408",
                    //         "order_type":"0",
                    //         "price":"3927.3",
                    //         "product_id":"BTC-USDT",
                    //         "side":"buy",
                    //         "size":"0.001",
                    //         "status":"filled",
                    //         "state": "2",
                    //         "timestamp":"2019-03-15T02:52:56.000Z",
                    //         "type":"limit"
                    //     }
                    //
                    // futures, swap
                    //
                    //     {
                    //         "instrument_id":"EOS-USD-190628",
                    //         "size":"10",
                    //         "timestamp":"2019-03-20T02:46:38.000Z",
                    //         "filled_qty":"10",
                    //         "fee":"-0.0080819",
                    //         "order_id":"2510946213248000",
                    //         "price":"3.712",
                    //         "price_avg":"3.712",
                    //         "status":"2",
                    //         "state": "2",
                    //         "type":"2",
                    //         "contract_val":"10",
                    //         "leverage":"10",
                    //         "client_oid":"", // missing in swap orders
                    //         "pnl":"0", // missing in swap orders
                    //         "order_type":"0"
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async fetchOrdersByState(state, symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrdersByState() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let type = undefined;
                    if (market['futures'] || market['swap']) type = market['type'];
                    else {
                        const defaultType = this.safeString2(this.options, 'fetchOrder', 'defaultType', market['type']);
                        type = this.safeString(params, 'type', defaultType);
                    }
                    if (type === undefined) throw new ArgumentsRequired1(this.id + " fetchOrdersByState() requires a type parameter (one of 'spot', 'margin', 'futures', 'swap').");
                    const request = {
                        'instrument_id': market['id'],
                        // '-2': failed,
                        // '-1': cancelled,
                        //  '0': open ,
                        //  '1': partially filled,
                        //  '2': fully filled,
                        //  '3': submitting,
                        //  '4': cancelling,
                        //  '6': incomplete（open+partially filled),
                        //  '7': complete（cancelled+fully filled),
                        'state': state
                    };
                    let method = type + 'GetOrders';
                    if (market['futures'] || market['swap']) method += 'InstrumentId';
                    const query = this.omit(params, 'type');
                    const response = await this[method](this.extend(request, query));
                    //
                    // spot, margin
                    //
                    //     [
                    //         // in fact, this documented API response does not correspond
                    //         // to their actual API response for spot markets
                    //         // OKEX v3 API returns a plain array of orders (see below)
                    //         [
                    //             {
                    //                 "client_oid":"oktspot76",
                    //                 "created_at":"2019-03-18T07:26:49.000Z",
                    //                 "filled_notional":"3.9734",
                    //                 "filled_size":"0.001",
                    //                 "funds":"",
                    //                 "instrument_id":"BTC-USDT",
                    //                 "notional":"",
                    //                 "order_id":"2500723297813504",
                    //                 "order_type":"0",
                    //                 "price":"4013",
                    //                 "product_id":"BTC-USDT",
                    //                 "side":"buy",
                    //                 "size":"0.001",
                    //                 "status":"filled",
                    //                 "state": "2",
                    //                 "timestamp":"2019-03-18T07:26:49.000Z",
                    //                 "type":"limit"
                    //             },
                    //         ],
                    //         {
                    //             "before":"2500723297813504",
                    //             "after":"2500650881647616"
                    //         }
                    //     ]
                    //
                    // futures, swap
                    //
                    //     {
                    //         "result":true,  // missing in swap orders
                    //         "order_info": [
                    //             {
                    //                 "instrument_id":"EOS-USD-190628",
                    //                 "size":"10",
                    //                 "timestamp":"2019-03-20T10:04:55.000Z",
                    //                 "filled_qty":"10",
                    //                 "fee":"-0.00841043",
                    //                 "order_id":"2512669605501952",
                    //                 "price":"3.668",
                    //                 "price_avg":"3.567",
                    //                 "status":"2",
                    //                 "state": "2",
                    //                 "type":"4",
                    //                 "contract_val":"10",
                    //                 "leverage":"10", // missing in swap orders
                    //                 "client_oid":"",
                    //                 "pnl":"1.09510794", // missing in swap orders
                    //                 "order_type":"0"
                    //             },
                    //         ]
                    //     }
                    //
                    let orders = undefined;
                    if (market['swap'] || market['futures']) orders = this.safeValue(response, 'order_info', []);
                    else {
                        orders = response;
                        const responseLength = response.length;
                        if (responseLength < 1) return [];
                        // in fact, this documented API response does not correspond
                        // to their actual API response for spot markets
                        // OKEX v3 API returns a plain array of orders
                        if (responseLength > 1) {
                            const before = this.safeValue(response[1], 'before');
                            if (before !== undefined) orders = response[0];
                        }
                    }
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    // '-2': failed,
                    // '-1': cancelled,
                    //  '0': open ,
                    //  '1': partially filled,
                    //  '2': fully filled,
                    //  '3': submitting,
                    //  '4': cancelling,
                    //  '6': incomplete（open+partially filled),
                    //  '7': complete（cancelled+fully filled),
                    return await this.fetchOrdersByState('6', symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    // '-2': failed,
                    // '-1': cancelled,
                    //  '0': open ,
                    //  '1': partially filled,
                    //  '2': fully filled,
                    //  '3': submitting,
                    //  '4': cancelling,
                    //  '6': incomplete（open+partially filled),
                    //  '7': complete（cancelled+fully filled),
                    return await this.fetchOrdersByState('7', symbol, since, limit, params);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         address: '0x696abb81974a8793352cbd33aadcf78eda3cfdfa',
                    //         currency: 'eth'
                    //         tag: 'abcde12345', // will be missing if the token does not require a deposit tag
                    //         payment_id: 'abcde12345', // will not be returned if the token does not require a payment_id
                    //         // can_deposit: 1, // 0 or 1, documented but missing
                    //         // can_withdraw: 1, // 0 or 1, documented but missing
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'address');
                    let tag = this.safeString2(depositAddress, 'tag', 'payment_id');
                    tag = this.safeString2(depositAddress, 'memo', 'Memo', tag);
                    const currencyId = this.safeString(depositAddress, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'info': depositAddress
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const parts = code.split('-');
                    const currency = this.currency(parts[0]);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.accountGetDepositAddress(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             address: '0x696abb81974a8793352cbd33aadcf78eda3cfdfa',
                    //             currency: 'eth'
                    //         }
                    //     ]
                    //
                    const addressesByCode = this.parseDepositAddresses(response);
                    const address = this.safeValue(addressesByCode, code);
                    if (address === undefined) throw new InvalidAddress(this.id + ' fetchDepositAddress() cannot return nonexistent addresses, you should create withdrawal addresses with the exchange website first');
                    return address;
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                    const toId = this.safeString(accountsByType, toAccount, toAccount);
                    const request = {
                        'amount': this.currencyToPrecision(code, amount),
                        'currency': currency['id'],
                        'from': fromId,
                        'to': toId,
                        'type': '0'
                    };
                    if (fromId === 'main') {
                        request['type'] = '1';
                        request['sub_account'] = toId;
                        request['to'] = '0';
                    } else if (toId === 'main') {
                        request['type'] = '2';
                        request['sub_account'] = fromId;
                        request['from'] = '0';
                        request['to'] = '6';
                    } else if (fromId === '5' || toId === '5') {
                        let marketId = this.safeString2(params, 'instrument_id', 'to_instrument_id');
                        if (marketId === undefined) {
                            const symbol = this.safeString(params, 'symbol');
                            if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' transfer() requires an exchange-specific instrument_id parameter or a unified symbol parameter');
                            else {
                                params = this.omit(params, 'symbol');
                                const market = this.market(symbol);
                                marketId = market['id'];
                            }
                            if (fromId === '5') request['instrument_id'] = marketId;
                            if (toId === '5') request['to_instrument_id'] = marketId;
                        }
                    }
                    const response = await this.accountPostTransfer(this.extend(request, params));
                    //
                    //      {
                    //          "transfer_id": "754147",
                    //          "currency": "ETC",
                    //          "from": "6",
                    //          "amount": "0.1",
                    //          "to": "1",
                    //          "result": true
                    //      }
                    //
                    return this.parseTransfer(response, currency);
                }
                parseTransfer(transfer, currency) {
                    //
                    //      {
                    //          "transfer_id": "754147",
                    //          "currency": "ETC",
                    //          "from": "6",
                    //          "amount": "0.1",
                    //          "to": "1",
                    //          "result": true
                    //      }
                    //
                    const accountsById = this.safeValue(this.options, 'accountsById', {});
                    return {
                        'info': transfer,
                        'id': this.safeString(transfer, 'transfer_id'),
                        'timestamp': undefined,
                        'datetime': undefined,
                        'currency': this.safeCurrencyCode(this.safeString(transfer, 'currency'), currency),
                        'amount': this.safeNumber(transfer, 'amount'),
                        'fromAccount': this.safeString(accountsById, this.safeString(transfer, 'from')),
                        'toAccount': this.safeString(accountsById, this.safeString(transfer, 'to')),
                        'status': this.parseTransferStatus(this.safeString(transfer, 'result'))
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'true': 'ok'
                    };
                    return this.safeString(statuses, status, 'failed');
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (tag) address = address + ':' + tag;
                    const fee = this.safeString(params, 'fee');
                    if (fee === undefined) throw new ArgumentsRequired1(this.id + " withdraw() requires a 'fee' string parameter, network transaction fee must be \u2265 0. Withdrawals to OKCoin or OKEx are fee-free, please set '0'. Withdrawing to external digital asset address requires network transaction fee.");
                    const request = {
                        'currency': currency['id'],
                        'to_address': address,
                        'destination': '4',
                        'amount': this.numberToString(amount),
                        'fee': fee
                    };
                    if ('password' in params) request['trade_pwd'] = params['password'];
                    else if ('trade_pwd' in params) request['trade_pwd'] = params['trade_pwd'];
                    else if (this.password) request['trade_pwd'] = this.password;
                    const query = this.omit(params, [
                        'fee',
                        'password',
                        'trade_pwd'
                    ]);
                    if (!('trade_pwd' in request)) throw new ExchangeError1(this.id + ' withdraw() requires this.password set on the exchange instance or a password / trade_pwd parameter');
                    const response = await this.accountPostWithdrawal(this.extend(request, query));
                    //
                    //     {
                    //         "amount":"0.1",
                    //         "withdrawal_id":"67485",
                    //         "currency":"btc",
                    //         "result":true
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let method = 'accountGetDepositHistory';
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                        method += 'Currency';
                    }
                    const response = await this[method](this.extend(request, params));
                    return this.parseTransactions(response, currency, since, limit, params);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let method = 'accountGetWithdrawalHistory';
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                        method += 'Currency';
                    }
                    const response = await this[method](this.extend(request, params));
                    return this.parseTransactions(response, currency, since, limit, params);
                }
                parseTransactionStatus(status) {
                    //
                    // deposit statuses
                    //
                    //     {
                    //         '0': 'waiting for confirmation',
                    //         '1': 'confirmation account',
                    //         '2': 'recharge success'
                    //     }
                    //
                    // withdrawal statues
                    //
                    //     {
                    //        '-3': 'pending cancel',
                    //        '-2': 'cancelled',
                    //        '-1': 'failed',
                    //         '0': 'pending',
                    //         '1': 'sending',
                    //         '2': 'sent',
                    //         '3': 'email confirmation',
                    //         '4': 'manual confirmation',
                    //         '5': 'awaiting identity confirmation'
                    //     }
                    //
                    const statuses = {
                        '-3': 'pending',
                        '-2': 'canceled',
                        '-1': 'failed',
                        '0': 'pending',
                        '1': 'pending',
                        '2': 'ok',
                        '3': 'pending',
                        '4': 'pending',
                        '5': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "amount":"0.1",
                    //         "withdrawal_id":"67485",
                    //         "currency":"btc",
                    //         "result":true
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         amount: "4.72100000",
                    //         withdrawal_id: "1729116",
                    //         fee: "0.01000000eth",
                    //         txid: "0xf653125bbf090bcfe4b5e8e7b8f586a9d87aa7de94598702758c0802b…",
                    //         currency: "ETH",
                    //         from: "7147338839",
                    //         to: "0x26a3CB49578F07000575405a57888681249c35Fd",
                    //         timestamp: "2018-08-17T07:03:42.000Z",
                    //         status: "2"
                    //     }
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "amount": "4.19511659",
                    //         "txid": "14c9a8c925647cdb7e5b2937ea9aefe2b29b2c273150ad3f44b3b8a4635ed437",
                    //         "currency": "XMR",
                    //         "from": "",
                    //         "to": "48PjH3ksv1fiXniKvKvyH5UtFs5WhfS2Vf7U3TwzdRJtCc7HJWvCQe56dRahyhQyTAViXZ8Nzk4gQg6o4BJBMUoxNy8y8g7",
                    //         "tag": "1234567",
                    //         "deposit_id": 11571659, <-- we can use this
                    //         "timestamp": "2019-10-01T14:54:19.000Z",
                    //         "status": "2"
                    //     }
                    //
                    let type = undefined;
                    let id = undefined;
                    let address = undefined;
                    const withdrawalId = this.safeString(transaction, 'withdrawal_id');
                    const addressFrom = this.safeString(transaction, 'from');
                    const addressTo = this.safeString(transaction, 'to');
                    const tagTo = this.safeString(transaction, 'tag');
                    if (withdrawalId !== undefined) {
                        type = 'withdrawal';
                        id = withdrawalId;
                        address = addressTo;
                    } else {
                        // the payment_id will appear on new deposits but appears to be removed from the response after 2 months
                        id = this.safeString2(transaction, 'payment_id', 'deposit_id');
                        type = 'deposit';
                        address = addressTo;
                    }
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    const amount = this.safeNumber(transaction, 'amount');
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const txid = this.safeString(transaction, 'txid');
                    const timestamp = this.parse8601(this.safeString(transaction, 'timestamp'));
                    let feeCost = undefined;
                    if (type === 'deposit') feeCost = 0;
                    else if (currencyId !== undefined) {
                        const feeWithCurrencyId = this.safeString(transaction, 'fee');
                        if (feeWithCurrencyId !== undefined) {
                            // https://github.com/ccxt/ccxt/pull/5748
                            const lowercaseCurrencyId = currencyId.toLowerCase();
                            const feeWithoutCurrencyId = feeWithCurrencyId.replace(lowercaseCurrencyId, '');
                            feeCost = parseFloat(feeWithoutCurrencyId);
                        }
                    }
                    // todo parse tags
                    return {
                        'info': transaction,
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': undefined,
                        'addressFrom': addressFrom,
                        'addressTo': addressTo,
                        'address': address,
                        'tagFrom': undefined,
                        'tagTo': tagTo,
                        'tag': tagTo,
                        'status': status,
                        'type': type,
                        'updated': undefined,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': {
                            'currency': code,
                            'cost': feeCost
                        }
                    };
                }
                parseMyTrade(pair, market) {
                    // check that trading symbols match in both entries
                    const userTrade = this.safeValue(pair, 1);
                    const otherTrade = this.safeValue(pair, 0);
                    const firstMarketId = this.safeString(otherTrade, 'instrument_id');
                    const secondMarketId = this.safeString(userTrade, 'instrument_id');
                    if (firstMarketId !== secondMarketId) throw new NotSupported(this.id + ' parseMyTrade() received unrecognized response format, differing instrument_ids in one fill, the exchange API might have changed, paste your verbose output: https://github.com/ccxt/ccxt/wiki/FAQ#what-is-required-to-get-help');
                    const marketId = firstMarketId;
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const quoteId = market['quoteId'];
                    let side = undefined;
                    let amountString = undefined;
                    let costString = undefined;
                    const receivedCurrencyId = this.safeString(userTrade, 'currency');
                    let feeCurrencyId = undefined;
                    if (receivedCurrencyId === quoteId) {
                        side = this.safeString(otherTrade, 'side');
                        amountString = this.safeString(otherTrade, 'size');
                        costString = this.safeString(userTrade, 'size');
                        feeCurrencyId = this.safeString(otherTrade, 'currency');
                    } else {
                        side = this.safeString(userTrade, 'side');
                        amountString = this.safeString(userTrade, 'size');
                        costString = this.safeString(otherTrade, 'size');
                        feeCurrencyId = this.safeString(userTrade, 'currency');
                    }
                    const id = this.safeString(userTrade, 'trade_id');
                    const priceString = this.safeString(userTrade, 'price');
                    const feeCostFirstString = this.safeString(otherTrade, 'fee');
                    const feeCostSecondString = this.safeString(userTrade, 'fee');
                    const feeCurrencyCodeFirst = this.safeCurrencyCode(this.safeString(otherTrade, 'currency'));
                    const feeCurrencyCodeSecond = this.safeCurrencyCode(this.safeString(userTrade, 'currency'));
                    let fee = undefined;
                    let fees = undefined;
                    // fee is either a positive number (invitation rebate)
                    // or a negative number (transaction fee deduction)
                    // therefore we need to invert the fee
                    // more about it https://github.com/ccxt/ccxt/issues/5909
                    if (feeCostFirstString !== undefined && !Precise.stringEquals(feeCostFirstString, '0')) {
                        if (feeCostSecondString !== undefined && !Precise.stringEquals(feeCostSecondString, '0')) fees = [
                            {
                                'cost': Precise.stringNeg(feeCostFirstString),
                                'currency': feeCurrencyCodeFirst
                            },
                            {
                                'cost': Precise.stringNeg(feeCostSecondString),
                                'currency': feeCurrencyCodeSecond
                            }
                        ];
                        else fee = {
                            'cost': Precise.stringNeg(feeCostFirstString),
                            'currency': feeCurrencyCodeFirst
                        };
                    } else if (feeCostSecondString !== undefined && !Precise.stringEquals(feeCostSecondString, '0')) fee = {
                        'cost': Precise.stringNeg(feeCostSecondString),
                        'currency': feeCurrencyCodeSecond
                    };
                    else fee = {
                        'cost': '0',
                        'currency': this.safeCurrencyCode(feeCurrencyId)
                    };
                    //
                    // simplified structures to show the underlying semantics
                    //
                    //     // market/limit sell
                    //
                    //     {
                    //         "currency":"USDT",
                    //         "fee":"-0.04647925", // ←--- fee in received quote currency
                    //         "price":"129.13", // ←------ price
                    //         "size":"30.98616393", // ←-- cost
                    //     },
                    //     {
                    //         "currency":"ETH",
                    //         "fee":"0",
                    //         "price":"129.13",
                    //         "size":"0.23996099", // ←--- amount
                    //     },
                    //
                    //     // market/limit buy
                    //
                    //     {
                    //         "currency":"ETH",
                    //         "fee":"-0.00036049", // ←--- fee in received base currency
                    //         "price":"129.16", // ←------ price
                    //         "size":"0.240322", // ←----- amount
                    //     },
                    //     {
                    //         "currency":"USDT",
                    //         "fee":"0",
                    //         "price":"129.16",
                    //         "size":"31.03998952", // ←-- cost
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString2(userTrade, 'timestamp', 'created_at'));
                    let takerOrMaker = this.safeString2(userTrade, 'exec_type', 'liquidity');
                    if (takerOrMaker === 'M') takerOrMaker = 'maker';
                    else if (takerOrMaker === 'T') takerOrMaker = 'taker';
                    const orderId = this.safeString(userTrade, 'order_id');
                    return this.safeTrade({
                        'info': pair,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': orderId,
                        'type': undefined,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee,
                        'fees': fees
                    }, market);
                }
                parseMyTrades(trades, market, since, limit, params = {}) {
                    const grouped = this.groupBy(trades, 'trade_id');
                    const tradeIds = Object.keys(grouped);
                    const result = [];
                    for(let i = 0; i < tradeIds.length; i++){
                        const tradeId = tradeIds[i];
                        const pair = grouped[tradeId];
                        // make sure it has exactly 2 trades, no more, no less
                        const numTradesInPair = pair.length;
                        if (numTradesInPair === 2) {
                            const trade = this.parseMyTrade(pair);
                            result.push(trade);
                        }
                    }
                    market = this.safeMarket(undefined, market);
                    return this.filterBySymbolSinceLimit(result, market['symbol'], since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    // okex actually returns ledger entries instead of fills here, so each fill in the order
                    // is represented by two trades with opposite buy/sell sides, not one :\
                    // this aspect renders the 'fills' endpoint unusable for fetchOrderTrades
                    // until either OKEX fixes the API or we workaround this on our side somehow
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (limit !== undefined && limit > 100) limit = 100;
                    const request = {
                        'instrument_id': market['id']
                    };
                    const defaultType = this.safeString2(this.options, 'fetchMyTrades', 'defaultType');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    const method = type + 'GetFills';
                    const response = await this[method](this.extend(request, query));
                    //
                    //     [
                    //         // sell
                    //         {
                    //             "created_at":"2020-03-29T11:55:25.000Z",
                    //             "currency":"USDT",
                    //             "exec_type":"T",
                    //             "fee":"-0.04647925",
                    //             "instrument_id":"ETH-USDT",
                    //             "ledger_id":"10562924353",
                    //             "liquidity":"T",
                    //             "order_id":"4636470489136128",
                    //             "price":"129.13",
                    //             "product_id":"ETH-USDT",
                    //             "side":"buy",
                    //             "size":"30.98616393",
                    //             "timestamp":"2020-03-29T11:55:25.000Z",
                    //             "trade_id":"18551601"
                    //         },
                    //         {
                    //             "created_at":"2020-03-29T11:55:25.000Z",
                    //             "currency":"ETH",
                    //             "exec_type":"T",
                    //             "fee":"0",
                    //             "instrument_id":"ETH-USDT",
                    //             "ledger_id":"10562924352",
                    //             "liquidity":"T",
                    //             "order_id":"4636470489136128",
                    //             "price":"129.13",
                    //             "product_id":"ETH-USDT",
                    //             "side":"sell",
                    //             "size":"0.23996099",
                    //             "timestamp":"2020-03-29T11:55:25.000Z",
                    //             "trade_id":"18551601"
                    //         },
                    //         // buy
                    //         {
                    //             "created_at":"2020-03-29T11:55:16.000Z",
                    //             "currency":"ETH",
                    //             "exec_type":"T",
                    //             "fee":"-0.00036049",
                    //             "instrument_id":"ETH-USDT",
                    //             "ledger_id":"10562922669",
                    //             "liquidity":"T",
                    //             "order_id": "4636469894136832",
                    //             "price":"129.16",
                    //             "product_id":"ETH-USDT",
                    //             "side":"buy",
                    //             "size":"0.240322",
                    //             "timestamp":"2020-03-29T11:55:16.000Z",
                    //             "trade_id":"18551600"
                    //         },
                    //         {
                    //             "created_at":"2020-03-29T11:55:16.000Z",
                    //             "currency":"USDT",
                    //             "exec_type":"T",
                    //             "fee":"0",
                    //             "instrument_id":"ETH-USDT",
                    //             "ledger_id":"10562922668",
                    //             "liquidity":"T",
                    //             "order_id":"4636469894136832",
                    //             "price":"129.16",
                    //             "product_id":"ETH-USDT",
                    //             "side":"sell",
                    //             "size":"31.03998952",
                    //             "timestamp":"2020-03-29T11:55:16.000Z",
                    //             "trade_id":"18551600"
                    //         }
                    //     ]
                    //
                    return this.parseMyTrades(response, market, since, limit, params);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    const request = {
                        // 'instrument_id': market['id'],
                        'order_id': id
                    };
                    return await this.fetchMyTrades(symbol, since, limit, this.extend(request, params));
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let method = undefined;
                    const request = {
                        'instrument_id': market['id']
                    };
                    const type = market['type'];
                    if (type === 'futures' || type === 'swap') method = type + 'GetInstrumentIdPosition';
                    else if (type === 'option') {
                        const underlying = this.safeString(params, 'underlying');
                        if (underlying === undefined) throw new ArgumentsRequired1(this.id + ' fetchPosition() requires an underlying parameter for ' + type + ' market ' + symbol);
                        method = type + 'GetUnderlyingPosition';
                    } else throw new NotSupported(this.id + ' fetchPosition() does not support ' + type + ' market ' + symbol + ', supported market types are futures, swap or option');
                    const response = await this[method](this.extend(request, params));
                    //
                    // futures
                    //
                    //     crossed margin mode
                    //
                    //     {
                    //         "result": true,
                    //         "holding": [
                    //             {
                    //                 "long_qty": "2",
                    //                 "long_avail_qty": "2",
                    //                 "long_avg_cost": "8260",
                    //                 "long_settlement_price": "8260",
                    //                 "realised_pnl": "0.00020928",
                    //                 "short_qty": "2",
                    //                 "short_avail_qty": "2",
                    //                 "short_avg_cost": "8259.99",
                    //                 "short_settlement_price": "8259.99",
                    //                 "liquidation_price": "113.81",
                    //                 "instrument_id": "BTC-USD-191227",
                    //                 "leverage": "10",
                    //                 "created_at": "2019-09-25T07:58:42.129Z",
                    //                 "updated_at": "2019-10-08T14:02:51.029Z",
                    //                 "margin_mode": "crossed",
                    //                 "short_margin": "0.00242197",
                    //                 "short_pnl": "6.63E-6",
                    //                 "short_pnl_ratio": "0.002477997",
                    //                 "short_unrealised_pnl": "6.63E-6",
                    //                 "long_margin": "0.00242197",
                    //                 "long_pnl": "-6.65E-6",
                    //                 "long_pnl_ratio": "-0.002478",
                    //                 "long_unrealised_pnl": "-6.65E-6",
                    //                 "long_settled_pnl": "0",
                    //                 "short_settled_pnl": "0",
                    //                 "last": "8257.57"
                    //             }
                    //         ],
                    //         "margin_mode": "crossed"
                    //     }
                    //
                    //     fixed margin mode
                    //
                    //     {
                    //         "result": true,
                    //         "holding": [
                    //             {
                    //                 "long_qty": "4",
                    //                 "long_avail_qty": "4",
                    //                 "long_margin": "0.00323844",
                    //                 "long_liqui_price": "7762.09",
                    //                 "long_pnl_ratio": "0.06052306",
                    //                 "long_avg_cost": "8234.43",
                    //                 "long_settlement_price": "8234.43",
                    //                 "realised_pnl": "-0.00000296",
                    //                 "short_qty": "2",
                    //                 "short_avail_qty": "2",
                    //                 "short_margin": "0.00241105",
                    //                 "short_liqui_price": "9166.74",
                    //                 "short_pnl_ratio": "0.03318052",
                    //                 "short_avg_cost": "8295.13",
                    //                 "short_settlement_price": "8295.13",
                    //                 "instrument_id": "BTC-USD-191227",
                    //                 "long_leverage": "15",
                    //                 "short_leverage": "10",
                    //                 "created_at": "2019-09-25T07:58:42.129Z",
                    //                 "updated_at": "2019-10-08T13:12:09.438Z",
                    //                 "margin_mode": "fixed",
                    //                 "short_margin_ratio": "0.10292507",
                    //                 "short_maint_margin_ratio": "0.005",
                    //                 "short_pnl": "7.853E-5",
                    //                 "short_unrealised_pnl": "7.853E-5",
                    //                 "long_margin_ratio": "0.07103743",
                    //                 "long_maint_margin_ratio": "0.005",
                    //                 "long_pnl": "1.9841E-4",
                    //                 "long_unrealised_pnl": "1.9841E-4",
                    //                 "long_settled_pnl": "0",
                    //                 "short_settled_pnl": "0",
                    //                 "last": "8266.99"
                    //             }
                    //         ],
                    //         "margin_mode": "fixed"
                    //     }
                    //
                    // swap
                    //
                    //     crossed margin mode
                    //
                    //     {
                    //         "margin_mode": "crossed",
                    //         "timestamp": "2019-09-27T03:49:02.018Z",
                    //         "holding": [
                    //             {
                    //                 "avail_position": "3",
                    //                 "avg_cost": "59.49",
                    //                 "instrument_id": "LTC-USD-SWAP",
                    //                 "last": "55.98",
                    //                 "leverage": "10.00",
                    //                 "liquidation_price": "4.37",
                    //                 "maint_margin_ratio": "0.0100",
                    //                 "margin": "0.0536",
                    //                 "position": "3",
                    //                 "realized_pnl": "0.0000",
                    //                 "unrealized_pnl": "0",
                    //                 "settled_pnl": "-0.0330",
                    //                 "settlement_price": "55.84",
                    //                 "side": "long",
                    //                 "timestamp": "2019-09-27T03:49:02.018Z"
                    //             },
                    //         ]
                    //     }
                    //
                    //     fixed margin mode
                    //
                    //     {
                    //         "margin_mode": "fixed",
                    //         "timestamp": "2019-09-27T03:47:37.230Z",
                    //         "holding": [
                    //             {
                    //                 "avail_position": "20",
                    //                 "avg_cost": "8025.0",
                    //                 "instrument_id": "BTC-USD-SWAP",
                    //                 "last": "8113.1",
                    //                 "leverage": "15.00",
                    //                 "liquidation_price": "7002.6",
                    //                 "maint_margin_ratio": "0.0050",
                    //                 "margin": "0.0454",
                    //                 "position": "20",
                    //                 "realized_pnl": "-0.0001",
                    //                 "unrealized_pnl": "0",
                    //                 "settled_pnl": "0.0076",
                    //                 "settlement_price": "8279.2",
                    //                 "side": "long",
                    //                 "timestamp": "2019-09-27T03:47:37.230Z"
                    //             }
                    //         ]
                    //     }
                    //
                    // option
                    //
                    //     {
                    //         "holding":[
                    //             {
                    //                 "instrument_id":"BTC-USD-190927-12500-C",
                    //                 "position":"20",
                    //                 "avg_cost":"3.26",
                    //                 "avail_position":"20",
                    //                 "settlement_price":"0.017",
                    //                 "total_pnl":"50",
                    //                 "pnl_ratio":"0.3",
                    //                 "realized_pnl":"40",
                    //                 "unrealized_pnl":"10",
                    //                 "pos_margin":"100",
                    //                 "option_value":"70",
                    //                 "created_at":"2019-08-30T03:09:20.315Z",
                    //                 "updated_at":"2019-08-30T03:40:18.318Z"
                    //             },
                    //             {
                    //                 "instrument_id":"BTC-USD-190927-12500-P",
                    //                 "position":"20",
                    //                 "avg_cost":"3.26",
                    //                 "avail_position":"20",
                    //                 "settlement_price":"0.019",
                    //                 "total_pnl":"50",
                    //                 "pnl_ratio":"0.3",
                    //                 "realized_pnl":"40",
                    //                 "unrealized_pnl":"10",
                    //                 "pos_margin":"100",
                    //                 "option_value":"70",
                    //                 "created_at":"2019-08-30T03:09:20.315Z",
                    //                 "updated_at":"2019-08-30T03:40:18.318Z"
                    //             }
                    //         ]
                    //     }
                    //
                    // todo unify parsePosition/parsePositions
                    return response;
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    let method = undefined;
                    const defaultType = this.safeString2(this.options, 'fetchPositions', 'defaultType');
                    const type = this.safeString(params, 'type', defaultType);
                    if (type === 'futures' || type === 'swap') method = type + 'GetPosition';
                    else if (type === 'option') {
                        const underlying = this.safeString(params, 'underlying');
                        if (underlying === undefined) throw new ArgumentsRequired1(this.id + ' fetchPositions() requires an underlying parameter for ' + type + ' markets');
                        method = type + 'GetUnderlyingPosition';
                    } else throw new NotSupported(this.id + ' fetchPositions() does not support ' + type + ' markets, supported market types are futures, swap or option');
                    params = this.omit(params, 'type');
                    const response = await this[method](params);
                    //
                    // futures
                    //
                    //     ...
                    //
                    //
                    // swap
                    //
                    //     ...
                    //
                    // option
                    //
                    //     {
                    //         "holding":[
                    //             {
                    //                 "instrument_id":"BTC-USD-190927-12500-C",
                    //                 "position":"20",
                    //                 "avg_cost":"3.26",
                    //                 "avail_position":"20",
                    //                 "settlement_price":"0.017",
                    //                 "total_pnl":"50",
                    //                 "pnl_ratio":"0.3",
                    //                 "realized_pnl":"40",
                    //                 "unrealized_pnl":"10",
                    //                 "pos_margin":"100",
                    //                 "option_value":"70",
                    //                 "created_at":"2019-08-30T03:09:20.315Z",
                    //                 "updated_at":"2019-08-30T03:40:18.318Z"
                    //             },
                    //             {
                    //                 "instrument_id":"BTC-USD-190927-12500-P",
                    //                 "position":"20",
                    //                 "avg_cost":"3.26",
                    //                 "avail_position":"20",
                    //                 "settlement_price":"0.019",
                    //                 "total_pnl":"50",
                    //                 "pnl_ratio":"0.3",
                    //                 "realized_pnl":"40",
                    //                 "unrealized_pnl":"10",
                    //                 "pos_margin":"100",
                    //                 "option_value":"70",
                    //                 "created_at":"2019-08-30T03:09:20.315Z",
                    //                 "updated_at":"2019-08-30T03:40:18.318Z"
                    //             }
                    //         ]
                    //     }
                    //
                    // todo unify parsePosition/parsePositions
                    return response;
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const defaultType = this.safeString2(this.options, 'fetchLedger', 'defaultType');
                    const type = this.safeString(params, 'type', defaultType);
                    const query = this.omit(params, 'type');
                    const suffix = type === 'account' ? '' : 'Accounts';
                    let argument = '';
                    const request = {
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    let currency = undefined;
                    if (type === 'spot') {
                        if (code === undefined) throw new ArgumentsRequired1(this.id + " fetchLedger() requires a currency code argument for '" + type + "' markets");
                        argument = 'Currency';
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    } else if (type === 'futures') {
                        if (code === undefined) throw new ArgumentsRequired1(this.id + " fetchLedger() requires an underlying symbol for '" + type + "' markets");
                        argument = 'Underlying';
                        const market = this.market(code); // we intentionally put a market inside here for the margin and swap ledgers
                        const marketInfo = this.safeValue(market, 'info', {});
                        const settlementCurrencyId = this.safeString(marketInfo, 'settlement_currency');
                        const settlementCurrencyCode = this.safeCurrencyCode(settlementCurrencyId);
                        currency = this.currency(settlementCurrencyCode);
                        const underlyingId = this.safeString(marketInfo, 'underlying');
                        request['underlying'] = underlyingId;
                    } else if (type === 'margin' || type === 'swap') {
                        if (code === undefined) throw new ArgumentsRequired1(this.id + " fetchLedger() requires a code argument (a market symbol) for '" + type + "' markets");
                        argument = 'InstrumentId';
                        const market = this.market(code); // we intentionally put a market inside here for the margin and swap ledgers
                        currency = this.currency(market['base']);
                        request['instrument_id'] = market['id'];
                    //
                    //     if (type === 'margin') {
                    //         //
                    //         //      3. Borrow
                    //         //      4. Repayment
                    //         //      5. Interest
                    //         //      7. Buy
                    //         //      8. Sell
                    //         //      9. From capital account
                    //         //     10. From C2C
                    //         //     11. From Futures
                    //         //     12. From Spot
                    //         //     13. From ETT
                    //         //     14. To capital account
                    //         //     15. To C2C
                    //         //     16. To Spot
                    //         //     17. To Futures
                    //         //     18. To ETT
                    //         //     19. Mandatory Repayment
                    //         //     20. From Piggybank
                    //         //     21. To Piggybank
                    //         //     22. From Perpetual
                    //         //     23. To Perpetual
                    //         //     24. Liquidation Fee
                    //         //     54. Clawback
                    //         //     59. Airdrop Return.
                    //         //
                    //         request['type'] = 'number'; // All types will be returned if this filed is left blank
                    //     }
                    //
                    } else if (type === 'account') {
                        if (code !== undefined) {
                            currency = this.currency(code);
                            request['currency'] = currency['id'];
                        }
                    } else throw new NotSupported(this.id + " fetchLedger does not support the '" + type + "' type (the type must be one of 'account', 'spot', 'margin', 'futures', 'swap')");
                    const method = type + 'Get' + suffix + argument + 'Ledger';
                    const response = await this[method](this.extend(request, query));
                    //
                    // transfer     funds transfer in/out
                    // trade        funds moved as a result of a trade, spot and margin accounts only
                    // rebate       fee rebate as per fee schedule, spot and margin accounts only
                    // match        open long/open short/close long/close short (futures) or a change in the amount because of trades (swap)
                    // fee          fee, futures only
                    // settlement   settlement/clawback/settle long/settle short
                    // liquidation  force close long/force close short/deliver close long/deliver close short
                    // funding      funding fee, swap only
                    // margin       a change in the amount after adjusting margin, swap only
                    //
                    // account
                    //
                    //     [
                    //         {
                    //             "amount":0.00051843,
                    //             "balance":0.00100941,
                    //             "currency":"BTC",
                    //             "fee":0,
                    //             "ledger_id":8987285,
                    //             "timestamp":"2018-10-12T11:01:14.000Z",
                    //             "typename":"Get from activity"
                    //         }
                    //     ]
                    //
                    // spot
                    //
                    //     [
                    //         {
                    //             "timestamp":"2019-03-18T07:08:25.000Z",
                    //             "ledger_id":"3995334780",
                    //             "created_at":"2019-03-18T07:08:25.000Z",
                    //             "currency":"BTC",
                    //             "amount":"0.0009985",
                    //             "balance":"0.0029955",
                    //             "type":"trade",
                    //             "details":{
                    //                 "instrument_id":"BTC-USDT",
                    //                 "order_id":"2500650881647616",
                    //                 "product_id":"BTC-USDT"
                    //             }
                    //         }
                    //     ]
                    //
                    // margin
                    //
                    //     [
                    //         [
                    //             {
                    //                 "created_at":"2019-03-20T03:45:05.000Z",
                    //                 "ledger_id":"78918186",
                    //                 "timestamp":"2019-03-20T03:45:05.000Z",
                    //                 "currency":"EOS",
                    //                 "amount":"0", // ?
                    //                 "balance":"0.59957711",
                    //                 "type":"transfer",
                    //                 "details":{
                    //                     "instrument_id":"EOS-USDT",
                    //                     "order_id":"787057",
                    //                     "product_id":"EOS-USDT"
                    //                 }
                    //             }
                    //         ],
                    //         {
                    //             "before":"78965766",
                    //             "after":"78918186"
                    //         }
                    //     ]
                    //
                    // futures
                    //
                    //     [
                    //         {
                    //             "ledger_id":"2508090544914461",
                    //             "timestamp":"2019-03-19T14:40:24.000Z",
                    //             "amount":"-0.00529521",
                    //             "balance":"0",
                    //             "currency":"EOS",
                    //             "type":"fee",
                    //             "details":{
                    //                 "order_id":"2506982456445952",
                    //                 "instrument_id":"EOS-USD-190628"
                    //             }
                    //         }
                    //     ]
                    //
                    // swap
                    //
                    //     [
                    //         {
                    //             "amount":"0.004742",
                    //             "fee":"-0.000551",
                    //             "type":"match",
                    //             "instrument_id":"EOS-USD-SWAP",
                    //             "ledger_id":"197429674941902848",
                    //             "timestamp":"2019-03-25T05:56:31.286Z"
                    //         },
                    //     ]
                    //
                    const responseLength = response.length;
                    if (responseLength < 1) return [];
                    const isArray = Array.isArray(response[0]);
                    const isMargin = type === 'margin';
                    const entries = isMargin && isArray ? response[0] : response;
                    if (type === 'swap') {
                        const ledgerEntries = this.parseLedger(entries);
                        return this.filterBySymbolSinceLimit(ledgerEntries, code, since, limit);
                    }
                    return this.parseLedger(entries, currency, since, limit);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'transfer': 'transfer',
                        'trade': 'trade',
                        'rebate': 'rebate',
                        'match': 'trade',
                        'fee': 'fee',
                        'settlement': 'trade',
                        'liquidation': 'trade',
                        'funding': 'fee',
                        'margin': 'margin'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //
                    // account
                    //
                    //     {
                    //         "amount":0.00051843,
                    //         "balance":0.00100941,
                    //         "currency":"BTC",
                    //         "fee":0,
                    //         "ledger_id":8987285,
                    //         "timestamp":"2018-10-12T11:01:14.000Z",
                    //         "typename":"Get from activity"
                    //     }
                    //
                    // spot
                    //
                    //     {
                    //         "timestamp":"2019-03-18T07:08:25.000Z",
                    //         "ledger_id":"3995334780",
                    //         "created_at":"2019-03-18T07:08:25.000Z",
                    //         "currency":"BTC",
                    //         "amount":"0.0009985",
                    //         "balance":"0.0029955",
                    //         "type":"trade",
                    //         "details":{
                    //             "instrument_id":"BTC-USDT",
                    //             "order_id":"2500650881647616",
                    //             "product_id":"BTC-USDT"
                    //         }
                    //     }
                    //
                    // margin
                    //
                    //     {
                    //         "created_at":"2019-03-20T03:45:05.000Z",
                    //         "ledger_id":"78918186",
                    //         "timestamp":"2019-03-20T03:45:05.000Z",
                    //         "currency":"EOS",
                    //         "amount":"0", // ?
                    //         "balance":"0.59957711",
                    //         "type":"transfer",
                    //         "details":{
                    //             "instrument_id":"EOS-USDT",
                    //             "order_id":"787057",
                    //             "product_id":"EOS-USDT"
                    //         }
                    //     }
                    //
                    // futures
                    //
                    //     {
                    //         "ledger_id":"2508090544914461",
                    //         "timestamp":"2019-03-19T14:40:24.000Z",
                    //         "amount":"-0.00529521",
                    //         "balance":"0",
                    //         "currency":"EOS",
                    //         "type":"fee",
                    //         "details":{
                    //             "order_id":"2506982456445952",
                    //             "instrument_id":"EOS-USD-190628"
                    //         }
                    //     }
                    //
                    // swap
                    //
                    //     {
                    //         "amount":"0.004742",
                    //         "fee":"-0.000551",
                    //         "type":"match",
                    //         "instrument_id":"EOS-USD-SWAP",
                    //         "ledger_id":"197429674941902848",
                    //         "timestamp":"2019-03-25T05:56:31.286Z"
                    //     },
                    //
                    const id = this.safeString(item, 'ledger_id');
                    const account = undefined;
                    const details = this.safeValue(item, 'details', {});
                    const referenceId = this.safeString(details, 'order_id');
                    const referenceAccount = undefined;
                    const type = this.parseLedgerEntryType(this.safeString(item, 'type'));
                    const code = this.safeCurrencyCode(this.safeString(item, 'currency'), currency);
                    const amount = this.safeNumber(item, 'amount');
                    const timestamp = this.parse8601(this.safeString(item, 'timestamp'));
                    const fee = {
                        'cost': this.safeNumber(item, 'fee'),
                        'currency': code
                    };
                    const before = undefined;
                    const after = this.safeNumber(item, 'balance');
                    const status = 'ok';
                    const marketId = this.safeString(item, 'instrument_id');
                    let symbol = undefined;
                    if (marketId in this.markets_by_id) {
                        const market = this.markets_by_id[marketId];
                        symbol = market['symbol'];
                    }
                    return {
                        'info': item,
                        'id': id,
                        'account': account,
                        'referenceId': referenceId,
                        'referenceAccount': referenceAccount,
                        'type': type,
                        'currency': code,
                        'symbol': symbol,
                        'amount': amount,
                        'before': before,
                        'after': after,
                        'status': status,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': fee
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const isArray = Array.isArray(params);
                    let request = '/api/' + api + '/' + this.version + '/';
                    request += isArray ? path : this.implodeParams(path, params);
                    const query = isArray ? params : this.omit(params, this.extractParams(path));
                    let url = this.implodeHostname(this.urls['api']['rest']) + request;
                    const type = this.getPathAuthenticationType(path);
                    if (type === 'public' || type === 'information') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (type === 'private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.iso8601(this.milliseconds());
                        headers = {
                            'OK-ACCESS-KEY': this.apiKey,
                            'OK-ACCESS-PASSPHRASE': this.password,
                            'OK-ACCESS-TIMESTAMP': timestamp
                        };
                        let auth = timestamp + method + request;
                        if (method === 'GET') {
                            if (Object.keys(query).length) {
                                const urlencodedQuery = '?' + this.urlencode(query);
                                url += urlencodedQuery;
                                auth += urlencodedQuery;
                            }
                        } else {
                            if (isArray || Object.keys(query).length) {
                                body = this.json(query);
                                auth += body;
                            }
                            headers['Content-Type'] = 'application/json';
                        }
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha256', 'base64');
                        headers['OK-ACCESS-SIGN'] = signature;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                getPathAuthenticationType(path) {
                    // https://github.com/ccxt/ccxt/issues/6651
                    // a special case to handle the optionGetUnderlying interefering with
                    // other endpoints containing this keyword
                    if (path === 'underlying') return 'public';
                    const auth = this.safeValue(this.options, 'auth', {});
                    const key = this.findBroadlyMatchedKey(auth, path);
                    return this.safeString(auth, key, 'private');
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (!response) return; // fallback to default error handler
                    const feedback = this.id + ' ' + body;
                    if (code === 503) // {"message":"name resolution failed"}
                    throw new ExchangeNotAvailable(feedback);
                    //
                    //     {"error_message":"Order does not exist","result":"true","error_code":"35029","order_id":"-1"}
                    //
                    const message = this.safeString(response, 'message');
                    const errorCode = this.safeString2(response, 'code', 'error_code');
                    const nonEmptyMessage = message !== undefined && message !== '';
                    const nonZeroErrorCode = errorCode !== undefined && errorCode !== '0';
                    if (nonEmptyMessage) {
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                    }
                    if (nonZeroErrorCode) this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                    if (nonZeroErrorCode || nonEmptyMessage) throw new ExchangeError1(feedback); // unknown message
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    111: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const okx = require1('./okx.js');
            // ---------------------------------------------------------------------------
            module.exports = class okex extends okx {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'okex',
                        'alias': true
                    });
                }
            };
        },
        {
            "./okx.js": 113
        }
    ],
    112: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const okex = require1('./okex.js');
            // ---------------------------------------------------------------------------
            module.exports = class okex5 extends okex {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'okex5',
                        'alias': true
                    });
                }
            };
        },
        {
            "./okex.js": 111
        }
    ],
    113: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, OnMaintenance: OnMaintenance, ArgumentsRequired: ArgumentsRequired1, BadRequest: BadRequest, AccountSuspended: AccountSuspended, InvalidAddress: InvalidAddress, PermissionDenied: PermissionDenied, InsufficientFunds: InsufficientFunds, InvalidNonce: InvalidNonce, InvalidOrder: InvalidOrder, OrderNotFound: OrderNotFound, AuthenticationError: AuthenticationError, RequestTimeout: RequestTimeout, BadSymbol: BadSymbol, RateLimitExceeded: RateLimitExceeded, NetworkError: NetworkError, CancelPending: CancelPending, NotSupported: NotSupported, AccountNotEnabled: AccountNotEnabled } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE, TRUNCATE: TRUNCATE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class okx extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'okx',
                        'name': 'OKX',
                        'countries': [
                            'CN',
                            'US'
                        ],
                        'version': 'v5',
                        'rateLimit': 100,
                        'pro': true,
                        'certified': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': true,
                            'swap': true,
                            'future': true,
                            'option': undefined,
                            'addMargin': true,
                            'cancelAllOrders': undefined,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createDepositAddress': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': undefined,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchBidsAsks': undefined,
                            'fetchBorrowRate': true,
                            'fetchBorrowRateHistories': true,
                            'fetchBorrowRateHistory': true,
                            'fetchBorrowRates': true,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchCanceledOrders': true,
                            'fetchClosedOrder': undefined,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDeposit': undefined,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': undefined,
                            'fetchDepositAddressesByNetwork': true,
                            'fetchDeposits': true,
                            'fetchFundingFee': undefined,
                            'fetchFundingFees': undefined,
                            'fetchFundingHistory': true,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': true,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': true,
                            'fetchL3OrderBook': undefined,
                            'fetchLedger': true,
                            'fetchLedgerEntry': undefined,
                            'fetchLeverage': true,
                            'fetchLeverageTiers': false,
                            'fetchMarketLeverageTiers': true,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': true,
                            'fetchMyBuys': undefined,
                            'fetchMySells': undefined,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': undefined,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': undefined,
                            'fetchOrders': undefined,
                            'fetchOrderTrades': true,
                            'fetchPosition': true,
                            'fetchPositions': true,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': undefined,
                            'fetchTradingLimits': undefined,
                            'fetchTransactions': undefined,
                            'fetchTransfer': true,
                            'fetchTransfers': false,
                            'fetchWithdrawal': undefined,
                            'fetchWithdrawals': true,
                            'fetchWithdrawalWhitelist': undefined,
                            'reduceMargin': true,
                            'setLeverage': true,
                            'setMarginMode': true,
                            'setPositionMode': true,
                            'signIn': undefined,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '3m': '3m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1H',
                            '2h': '2H',
                            '4h': '4H',
                            '6h': '6Hutc',
                            '12h': '12Hutc',
                            '1d': '1Dutc',
                            '1w': '1Wutc',
                            '1M': '1Mutc',
                            '3M': '3Mutc',
                            '6M': '6Mutc',
                            '1y': '1Yutc'
                        },
                        'hostname': 'www.okx.com',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/152485636-38b19e4a-bece-4dec-979a-5982859ffc04.jpg',
                            'api': {
                                'rest': 'https://{hostname}'
                            },
                            'www': 'https://www.okx.com',
                            'doc': 'https://www.okx.com/docs-v5/en/',
                            'fees': 'https://www.okx.com/pages/products/fees.html',
                            'referral': 'https://www.okx.com/join/1888677',
                            'test': {
                                'rest': 'https://{hostname}'
                            }
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'market/tickers': 1,
                                    'market/ticker': 1,
                                    'market/index-tickers': 1,
                                    'market/books': 1,
                                    'market/candles': 1,
                                    'market/history-candles': 1,
                                    'market/index-candles': 1,
                                    'market/mark-price-candles': 1,
                                    'market/trades': 1,
                                    'market/platform-24-volume': 10,
                                    'market/open-oracle': 100,
                                    'market/index-components': 1,
                                    // 'market/oracle',
                                    'public/instruments': 1,
                                    'public/delivery-exercise-history': 0.5,
                                    'public/open-interest': 1,
                                    'public/funding-rate': 1,
                                    'public/funding-rate-history': 1,
                                    'public/price-limit': 1,
                                    'public/opt-summary': 1,
                                    'public/estimated-price': 2,
                                    'public/discount-rate-interest-free-quota': 10,
                                    'public/time': 2,
                                    'public/liquidation-orders': 0.5,
                                    'public/mark-price': 2,
                                    // 'public/tier',
                                    'public/position-tiers': 2,
                                    'public/underlying': 1,
                                    'public/interest-rate-loan-quota': 10,
                                    'public/vip-interest-rate-loan-quota': 10,
                                    'rubik/stat/trading-data/support-coin': 4,
                                    'rubik/stat/taker-volume': 4,
                                    'rubik/stat/margin/loan-ratio': 4,
                                    // long/short
                                    'rubik/stat/contracts/long-short-account-ratio': 4,
                                    'rubik/stat/contracts/open-interest-volume': 4,
                                    'rubik/stat/option/open-interest-volume': 4,
                                    // put/call
                                    'rubik/stat/option/open-interest-volume-ratio': 4,
                                    'rubik/stat/option/open-interest-volume-expiry': 4,
                                    'rubik/stat/option/open-interest-volume-strike': 4,
                                    'rubik/stat/option/taker-block-volume': 4,
                                    'system/status': 100,
                                    'asset/lending-rate-summary': 5 / 3,
                                    'asset/lending-rate-history': 5 / 3,
                                    'market/exchange-rate': 20
                                }
                            },
                            'private': {
                                'get': {
                                    'account/account-position-risk': 2,
                                    'account/balance': 2,
                                    'account/positions': 2,
                                    'account/bills': 5 / 3,
                                    'account/bills-archive': 5 / 3,
                                    'account/config': 4,
                                    'account/max-size': 1,
                                    'account/max-avail-size': 1,
                                    'account/leverage-info': 1,
                                    'account/max-loan': 1,
                                    'account/trade-fee': 4,
                                    'account/interest-accrued': 4,
                                    'account/interest-rate': 4,
                                    'account/max-withdrawal': 1,
                                    'account/risk-state': 2,
                                    'account/borrow-repay-history': 4,
                                    'account/interest-limits': 4,
                                    'asset/asset-valuation': 0.2,
                                    'asset/deposit-address': 5 / 3,
                                    'asset/balances': 5 / 3,
                                    'asset/transfer-state': 10,
                                    'asset/deposit-history': 5 / 3,
                                    'asset/withdrawal-history': 5 / 3,
                                    'asset/currencies': 5 / 3,
                                    'asset/bills': 5 / 3,
                                    'asset/piggy-balance': 5 / 3,
                                    'asset/deposit-lightning': 5,
                                    'asset/lending-history': 5 / 3,
                                    'asset/saving-balance': 5 / 3,
                                    'trade/order': 1 / 3,
                                    'trade/orders-pending': 1,
                                    'trade/orders-history': 0.5,
                                    'trade/orders-history-archive': 1,
                                    'trade/fills': 1 / 3,
                                    'trade/fills-history': 2,
                                    'trade/orders-algo-pending': 1,
                                    'trade/orders-algo-history': 1,
                                    'account/subaccount/balances': 10,
                                    'asset/subaccount/bills': 5 / 3,
                                    'users/subaccount/list': 10,
                                    'users/subaccount/apikey': 10,
                                    'users/entrust-subaccount-list': 10,
                                    // broker
                                    'broker/nd/info': 10,
                                    'broker/nd/subaccount-info': 10,
                                    'asset/broker/nd/subaccount-deposit-address': 4,
                                    'asset/broker/nd/subaccount-deposit-history': 4,
                                    'broker/nd/rebate-daily': 1,
                                    // convert
                                    'asset/convert/currencies': 5 / 3,
                                    'asset/convert/currency-pair': 5 / 3,
                                    'asset/convert/estimate-quote': 5,
                                    'asset/convert/trade': 5,
                                    'asset/convert/history': 5 / 3,
                                    // options
                                    'account/greeks': 2
                                },
                                'post': {
                                    'account/set-position-mode': 4,
                                    'account/set-leverage': 1,
                                    'account/position/margin-balance': 1,
                                    'account/set-greeks': 4,
                                    'account/set-isolated-mode': 4,
                                    'account/simulated_margin': 10,
                                    'account/borrow-repay': 5 / 3,
                                    'asset/transfer': 10,
                                    'asset/withdrawal': 5 / 3,
                                    'asset/purchase_redempt': 5 / 3,
                                    'asset/withdrawal-lightning': 5,
                                    'asset/set-lending-rate': 5 / 3,
                                    'asset/cancel-withdrawal': 5 / 3,
                                    'asset/convert-dust-assets': 10,
                                    'trade/order': 1 / 3,
                                    'trade/batch-orders': 1 / 15,
                                    'trade/cancel-order': 1 / 3,
                                    'trade/cancel-batch-orders': 1 / 15,
                                    'trade/amend-order': 1 / 3,
                                    'trade/amend-batch-orders': 1 / 3,
                                    'trade/close-position': 1,
                                    'trade/order-algo': 1,
                                    'trade/cancel-algos': 1,
                                    'trade/cancel-advance-algos': 1,
                                    'users/subaccount/delete-apikey': 10,
                                    'users/subaccount/modify-apikey': 10,
                                    'users/subaccount/apikey': 10,
                                    'asset/subaccount/transfer': 10,
                                    'asset/subaccount/set-transfer-out': 10,
                                    // broker
                                    'broker/nd/create-subaccount': 10,
                                    'broker/nd/delete-subaccount': 10,
                                    'broker/nd/set-subaccount-level': 4,
                                    'broker/nd/set-subaccount-fee-rate': 4,
                                    'asset/broker/nd/subaccount-deposit-address': 4
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'taker': this.parseNumber('0.0015'),
                                'maker': this.parseNumber('0.0010')
                            },
                            'spot': {
                                'taker': this.parseNumber('0.0015'),
                                'maker': this.parseNumber('0.0010')
                            },
                            'future': {
                                'taker': this.parseNumber('0.0005'),
                                'maker': this.parseNumber('0.0002')
                            },
                            'swap': {
                                'taker': this.parseNumber('0.00050'),
                                'maker': this.parseNumber('0.00020')
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true,
                            'password': true
                        },
                        'exceptions': {
                            'exact': {
                                // Public error codes from 50000-53999
                                // General Class
                                '1': ExchangeError1,
                                '2': ExchangeError1,
                                '50000': BadRequest,
                                '50001': OnMaintenance,
                                '50002': BadRequest,
                                '50004': RequestTimeout,
                                '50005': ExchangeNotAvailable,
                                '50006': BadRequest,
                                '50007': AccountSuspended,
                                '50008': AuthenticationError,
                                '50009': AccountSuspended,
                                '50010': ExchangeError1,
                                '50011': RateLimitExceeded,
                                '50012': ExchangeError1,
                                '50013': ExchangeNotAvailable,
                                '50014': BadRequest,
                                '50015': ExchangeError1,
                                '50016': ExchangeError1,
                                '50017': ExchangeError1,
                                '50018': ExchangeError1,
                                '50019': ExchangeError1,
                                '50020': ExchangeError1,
                                '50021': ExchangeError1,
                                '50022': ExchangeError1,
                                '50023': ExchangeError1,
                                '50024': BadRequest,
                                '50025': ExchangeError1,
                                '50026': ExchangeError1,
                                '50027': PermissionDenied,
                                '50028': ExchangeError1,
                                // API Class
                                '50100': ExchangeError1,
                                '50101': AuthenticationError,
                                '50102': InvalidNonce,
                                '50103': AuthenticationError,
                                '50104': AuthenticationError,
                                '50105': AuthenticationError,
                                '50106': AuthenticationError,
                                '50107': AuthenticationError,
                                '50108': ExchangeError1,
                                '50109': ExchangeError1,
                                '50110': PermissionDenied,
                                '50111': AuthenticationError,
                                '50112': AuthenticationError,
                                '50113': AuthenticationError,
                                '50114': AuthenticationError,
                                '50115': BadRequest,
                                // Trade Class
                                '51000': BadRequest,
                                '51001': BadSymbol,
                                '51002': BadSymbol,
                                '51003': BadRequest,
                                '51004': InvalidOrder,
                                '51005': InvalidOrder,
                                '51006': InvalidOrder,
                                '51007': InvalidOrder,
                                '51008': InsufficientFunds,
                                '51009': AccountSuspended,
                                '51010': AccountNotEnabled,
                                '51011': InvalidOrder,
                                '51012': BadSymbol,
                                '51014': BadSymbol,
                                '51015': BadSymbol,
                                '51016': InvalidOrder,
                                '51017': ExchangeError1,
                                '51018': ExchangeError1,
                                '51019': ExchangeError1,
                                '51020': InvalidOrder,
                                '51021': BadSymbol,
                                '51022': BadSymbol,
                                '51023': ExchangeError1,
                                '51024': AccountSuspended,
                                '51025': ExchangeError1,
                                '51026': BadSymbol,
                                '51027': BadSymbol,
                                '51028': BadSymbol,
                                '51029': BadSymbol,
                                '51030': BadSymbol,
                                '51031': InvalidOrder,
                                '51100': InvalidOrder,
                                '51101': InvalidOrder,
                                '51102': InvalidOrder,
                                '51103': InvalidOrder,
                                '51104': InvalidOrder,
                                '51105': InvalidOrder,
                                '51106': InvalidOrder,
                                '51107': InvalidOrder,
                                '51108': InvalidOrder,
                                '51109': InvalidOrder,
                                '51110': InvalidOrder,
                                '51111': BadRequest,
                                '51112': InvalidOrder,
                                '51113': RateLimitExceeded,
                                '51115': InvalidOrder,
                                '51116': InvalidOrder,
                                '51117': InvalidOrder,
                                '51118': InvalidOrder,
                                '51119': InsufficientFunds,
                                '51120': InvalidOrder,
                                '51121': InvalidOrder,
                                '51122': InvalidOrder,
                                '51124': InvalidOrder,
                                '51125': InvalidOrder,
                                '51126': InvalidOrder,
                                '51127': InsufficientFunds,
                                '51128': InvalidOrder,
                                '51129': InvalidOrder,
                                '51130': BadSymbol,
                                '51131': InsufficientFunds,
                                '51132': InvalidOrder,
                                '51133': InvalidOrder,
                                '51134': InvalidOrder,
                                '51135': InvalidOrder,
                                '51136': InvalidOrder,
                                '51137': InvalidOrder,
                                '51138': InvalidOrder,
                                '51139': InvalidOrder,
                                '51201': InvalidOrder,
                                '51202': InvalidOrder,
                                '51203': InvalidOrder,
                                '51204': InvalidOrder,
                                '51205': InvalidOrder,
                                '51250': InvalidOrder,
                                '51251': InvalidOrder,
                                '51252': InvalidOrder,
                                '51253': InvalidOrder,
                                '51254': InvalidOrder,
                                '51255': InvalidOrder,
                                '51256': InvalidOrder,
                                '51257': InvalidOrder,
                                '51258': InvalidOrder,
                                '51259': InvalidOrder,
                                '51260': InvalidOrder,
                                '51261': InvalidOrder,
                                '51262': InvalidOrder,
                                '51263': InvalidOrder,
                                '51264': InvalidOrder,
                                '51265': InvalidOrder,
                                '51267': InvalidOrder,
                                '51268': InvalidOrder,
                                '51269': InvalidOrder,
                                '51270': InvalidOrder,
                                '51271': InvalidOrder,
                                '51272': InvalidOrder,
                                '51273': InvalidOrder,
                                '51274': InvalidOrder,
                                '51275': InvalidOrder,
                                '51276': InvalidOrder,
                                '51277': InvalidOrder,
                                '51278': InvalidOrder,
                                '51279': InvalidOrder,
                                '51280': InvalidOrder,
                                '51400': OrderNotFound,
                                '51401': OrderNotFound,
                                '51402': OrderNotFound,
                                '51403': InvalidOrder,
                                '51404': InvalidOrder,
                                '51405': ExchangeError1,
                                '51406': ExchangeError1,
                                '51407': BadRequest,
                                '51408': ExchangeError1,
                                '51409': ExchangeError1,
                                '51410': CancelPending,
                                '51500': ExchangeError1,
                                '51501': ExchangeError1,
                                '51502': InsufficientFunds,
                                '51503': ExchangeError1,
                                '51506': ExchangeError1,
                                '51508': ExchangeError1,
                                '51509': ExchangeError1,
                                '51510': ExchangeError1,
                                '51511': ExchangeError1,
                                '51600': ExchangeError1,
                                '51601': ExchangeError1,
                                '51602': ExchangeError1,
                                '51603': OrderNotFound,
                                // Data class
                                '52000': ExchangeError1,
                                // SPOT/MARGIN error codes 54000-54999
                                '54000': ExchangeError1,
                                '54001': ExchangeError1,
                                // FUNDING error codes 58000-58999
                                '58000': ExchangeError1,
                                '58001': AuthenticationError,
                                '58002': PermissionDenied,
                                '58003': ExchangeError1,
                                '58004': AccountSuspended,
                                '58005': ExchangeError1,
                                '58006': ExchangeError1,
                                '58007': ExchangeError1,
                                '58100': ExchangeError1,
                                '58101': AccountSuspended,
                                '58102': RateLimitExceeded,
                                '58103': ExchangeError1,
                                '58104': ExchangeError1,
                                '58105': ExchangeError1,
                                '58106': ExchangeError1,
                                '58107': ExchangeError1,
                                '58108': ExchangeError1,
                                '58109': ExchangeError1,
                                '58110': ExchangeError1,
                                '58111': ExchangeError1,
                                '58112': ExchangeError1,
                                '58114': ExchangeError1,
                                '58115': ExchangeError1,
                                '58116': ExchangeError1,
                                '58117': ExchangeError1,
                                '58200': ExchangeError1,
                                '58201': ExchangeError1,
                                '58202': ExchangeError1,
                                '58203': InvalidAddress,
                                '58204': AccountSuspended,
                                '58205': ExchangeError1,
                                '58206': ExchangeError1,
                                '58207': InvalidAddress,
                                '58208': ExchangeError1,
                                '58209': ExchangeError1,
                                '58210': ExchangeError1,
                                '58211': ExchangeError1,
                                '58212': ExchangeError1,
                                '58213': AuthenticationError,
                                '58300': ExchangeError1,
                                '58350': InsufficientFunds,
                                // Account error codes 59000-59999
                                '59000': ExchangeError1,
                                '59001': ExchangeError1,
                                '59100': ExchangeError1,
                                '59101': ExchangeError1,
                                '59102': ExchangeError1,
                                '59103': InsufficientFunds,
                                '59104': ExchangeError1,
                                '59105': ExchangeError1,
                                '59106': ExchangeError1,
                                '59107': ExchangeError1,
                                '59108': InsufficientFunds,
                                '59109': ExchangeError1,
                                '59200': InsufficientFunds,
                                '59201': InsufficientFunds,
                                '59300': ExchangeError1,
                                '59301': ExchangeError1,
                                '59401': ExchangeError1,
                                '59500': ExchangeError1,
                                '59501': ExchangeError1,
                                '59502': ExchangeError1,
                                '59503': ExchangeError1,
                                '59504': ExchangeError1,
                                '59505': ExchangeError1,
                                '59506': ExchangeError1,
                                '59507': ExchangeError1,
                                '59508': AccountSuspended,
                                // WebSocket error Codes from 60000-63999
                                '60001': AuthenticationError,
                                '60002': AuthenticationError,
                                '60003': AuthenticationError,
                                '60004': AuthenticationError,
                                '60005': AuthenticationError,
                                '60006': InvalidNonce,
                                '60007': AuthenticationError,
                                '60008': AuthenticationError,
                                '60009': AuthenticationError,
                                '60010': AuthenticationError,
                                '60011': AuthenticationError,
                                '60012': BadRequest,
                                '60013': BadRequest,
                                '60014': RateLimitExceeded,
                                '60015': NetworkError,
                                '60016': ExchangeNotAvailable,
                                '60017': BadRequest,
                                '60018': BadRequest,
                                '60019': BadRequest,
                                '63999': ExchangeError1
                            },
                            'broad': {}
                        },
                        'httpExceptions': {
                            '429': ExchangeNotAvailable
                        },
                        'precisionMode': TICK_SIZE,
                        'options': {
                            'defaultNetwork': 'ERC20',
                            'networks': {
                                'ETH': 'ERC20',
                                'TRX': 'TRC20',
                                'OMNI': 'Omni',
                                'SOLANA': 'Solana',
                                'POLYGON': 'Polygon',
                                'OEC': 'OEC',
                                'ALGO': 'ALGO'
                            },
                            'layerTwo': {
                                'Lightning': true,
                                'Liquid': true
                            },
                            'fetchOHLCV': {
                            },
                            'createOrder': 'privatePostTradeBatchOrders',
                            'createMarketBuyOrderRequiresPrice': false,
                            'fetchMarkets': [
                                'spot',
                                'future',
                                'swap',
                                'option'
                            ],
                            'defaultType': 'spot',
                            // 'fetchBalance': {
                            //     'type': 'spot', // 'funding', 'trading', 'spot'
                            // },
                            'fetchLedger': {
                                'method': 'privateGetAccountBills'
                            },
                            // 1 = SPOT, 3 = FUTURES, 5 = MARGIN, 6 = FUNDING, 9 = SWAP, 12 = OPTION, 18 = Unified account
                            'fetchOrder': {
                                'method': 'privateGetTradeOrder'
                            },
                            'fetchOpenOrders': {
                                'method': 'privateGetTradeOrdersPending'
                            },
                            'cancelOrders': {
                                'method': 'privatePostTradeCancelBatchOrders'
                            },
                            'fetchCanceledOrders': {
                                'method': 'privateGetTradeOrdersHistory'
                            },
                            'algoOrderTypes': {
                                'conditional': true,
                                'trigger': true,
                                'oco': true,
                                'move_order_stop': true,
                                'iceberg': true,
                                'twap': true
                            },
                            'accountsByType': {
                                'spot': '1',
                                'future': '3',
                                'futures': '3',
                                'margin': '5',
                                'funding': '6',
                                'swap': '9',
                                'option': '12',
                                'trading': '18'
                            },
                            'accountsById': {
                                '1': 'spot',
                                '3': 'future',
                                '5': 'margin',
                                '6': 'funding',
                                '9': 'swap',
                                '12': 'option',
                                '18': 'trading'
                            },
                            'exchangeType': {
                                'spot': 'SPOT',
                                'margin': 'MARGIN',
                                'swap': 'SWAP',
                                'future': 'FUTURES',
                                'futures': 'FUTURES',
                                'option': 'OPTION',
                                'SPOT': 'SPOT',
                                'MARGIN': 'MARGIN',
                                'SWAP': 'SWAP',
                                'FUTURES': 'FUTURES',
                                'OPTION': 'OPTION'
                            },
                            'brokerId': 'e847386590ce4dBC'
                        },
                        'commonCurrencies': {
                            // the exchange refers to ERC20 version of Aeternity (AEToken)
                            'AE': 'AET',
                            'BOX': 'DefiBox',
                            'HOT': 'Hydro Protocol',
                            'HSR': 'HC',
                            'MAG': 'Maggie',
                            'SBTC': 'Super Bitcoin',
                            'TRADE': 'Unitrade',
                            'YOYO': 'YOYOW',
                            'WIN': 'WinToken'
                        }
                    });
                }
                handleMarketTypeAndParams(methodName, market, params = {}) {
                    const instType = this.safeString(params, 'instType');
                    params = this.omit(params, 'instType');
                    const type = this.safeString(params, 'type');
                    if (type === undefined && instType !== undefined) params['type'] = instType;
                    return super.handleMarketTypeAndParams(methodName, market, params);
                }
                convertToInstrumentType(type) {
                    const exchangeTypes = this.safeValue(this.options, 'exchangeType', {});
                    return this.safeString(exchangeTypes, type, type);
                }
                async fetchStatus(params = {}) {
                    const response = await this.publicGetSystemStatus(params);
                    //
                    // Note, if there is no maintenance around, the 'data' array is empty
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "begin": "1621328400000",
                    //                 "end": "1621329000000",
                    //                 "href": "https://www.okx.com/support/hc/en-us/articles/360060882172",
                    //                 "scheDesc": "",
                    //                 "serviceType": "1", // 0 WebSocket, 1 Spot/Margin, 2 Futures, 3 Perpetual, 4 Options, 5 Trading service
                    //                 "state": "scheduled", // ongoing, completed, canceled
                    //                 "system": "classic", // classic, unified
                    //                 "title": "Classic Spot System Upgrade"
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const dataLength = data.length;
                    const timestamp = this.milliseconds();
                    const update = {
                        'updated': timestamp,
                        'status': dataLength === 0 ? 'ok' : 'maintenance',
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                    for(let i = 0; i < data.length; i++){
                        const event = data[i];
                        const state = this.safeString(event, 'state');
                        if (state === 'ongoing') {
                            update['eta'] = this.safeInteger(event, 'end');
                            update['status'] = 'maintenance';
                        }
                    }
                    return update;
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetPublicTime(params);
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {"ts": "1621247923668"}
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const first = this.safeValue(data, 0, {});
                    return this.safeInteger(first, 'ts');
                }
                async fetchAccounts(params = {}) {
                    const response = await this.privateGetAccountConfig(params);
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "acctLv": "2",
                    //                 "autoLoan": false,
                    //                 "ctIsoMode": "automatic",
                    //                 "greeksType": "PA",
                    //                 "level": "Lv1",
                    //                 "levelTmp": "",
                    //                 "mgnIsoMode": "automatic",
                    //                 "posMode": "long_short_mode",
                    //                 "uid": "88018754289672195"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const account = data[i];
                        const accountId = this.safeString(account, 'uid');
                        const type = this.safeString(account, 'acctLv');
                        result.push({
                            'id': accountId,
                            'type': type,
                            'currency': undefined,
                            'info': account
                        });
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const types = this.safeValue(this.options, 'fetchMarkets');
                    let promises = [];
                    let result = [];
                    for(let i = 0; i < types.length; i++)promises.push(this.fetchMarketsByType(types[i], params));
                    // why not both ¯\_(ツ)_/¯
                    promises = await Promise.all(promises);
                    for(let i = 0; i < promises.length; i++)result = this.arrayConcat(result, promises[i]);
                    return result;
                }
                parseMarkets(markets) {
                    const result = [];
                    for(let i = 0; i < markets.length; i++)result.push(this.parseMarket(markets[i]));
                    return result;
                }
                parseMarket(market) {
                    //
                    //     {
                    //         "alias": "", // this_week, next_week, quarter, next_quarter
                    //         "baseCcy": "BTC",
                    //         "category": "1",
                    //         "ctMult": "",
                    //         "ctType": "", // inverse, linear
                    //         "ctVal": "",
                    //         "ctValCcy": "",
                    //         "expTime": "",
                    //         "instId": "BTC-USDT", // BTC-USD-210521, CSPR-USDT-SWAP, BTC-USD-210517-44000-C
                    //         "instType": "SPOT", // SPOT, FUTURES, SWAP, OPTION
                    //         "lever": "10",
                    //         "listTime": "1548133413000",
                    //         "lotSz": "0.00000001",
                    //         "minSz": "0.00001",
                    //         "optType": "",
                    //         "quoteCcy": "USDT",
                    //         "settleCcy": "",
                    //         "state": "live",
                    //         "stk": "",
                    //         "tickSz": "0.1",
                    //         "uly": ""
                    //     }
                    //
                    //     {
                    //         alias: "",
                    //         baseCcy: "",
                    //         category: "1",
                    //         ctMult: "0.1",
                    //         ctType: "",
                    //         ctVal: "1",
                    //         ctValCcy: "BTC",
                    //         expTime: "1648195200000",
                    //         instId: "BTC-USD-220325-194000-P",
                    //         instType: "OPTION",
                    //         lever: "",
                    //         listTime: "1631262612280",
                    //         lotSz: "1",
                    //         minSz: "1",
                    //         optType: "P",
                    //         quoteCcy: "",
                    //         settleCcy: "BTC",
                    //         state: "live",
                    //         stk: "194000",
                    //         tickSz: "0.0005",
                    //         uly: "BTC-USD"
                    //     }
                    //
                    const id = this.safeString(market, 'instId');
                    let type = this.safeStringLower(market, 'instType');
                    if (type === 'futures') type = 'future';
                    const spot = type === 'spot';
                    const future = type === 'future';
                    const swap = type === 'swap';
                    const option = type === 'option';
                    const contract = swap || future || option;
                    let baseId = this.safeString(market, 'baseCcy');
                    let quoteId = this.safeString(market, 'quoteCcy');
                    const settleId = this.safeString(market, 'settleCcy');
                    const settle = this.safeCurrencyCode(settleId);
                    const underlying = this.safeString(market, 'uly');
                    if (underlying !== undefined && !spot) {
                        const parts = underlying.split('-');
                        baseId = this.safeString(parts, 0);
                        quoteId = this.safeString(parts, 1);
                    }
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    let symbol = base + '/' + quote;
                    let expiry = undefined;
                    let strikePrice = undefined;
                    let optionType = undefined;
                    if (contract) {
                        symbol = symbol + ':' + settle;
                        expiry = this.safeInteger(market, 'expTime');
                        if (future) {
                            const ymd = this.yymmdd(expiry);
                            symbol = symbol + '-' + ymd;
                        } else if (option) {
                            strikePrice = this.safeString(market, 'stk');
                            optionType = this.safeString(market, 'optType');
                            symbol = symbol + '-' + strikePrice + '-' + optionType;
                            optionType = optionType === 'P' ? 'put' : 'call';
                        }
                    }
                    const tickSize = this.safeString(market, 'tickSz');
                    const minAmountString = this.safeString(market, 'minSz');
                    const minAmount = this.parseNumber(minAmountString);
                    const fees = this.safeValue2(this.fees, type, 'trading', {});
                    const precisionPrice = this.parseNumber(tickSize);
                    let maxLeverage = this.safeString(market, 'lever', '1');
                    if (maxLeverage === '') maxLeverage = '1';
                    maxLeverage = Precise.stringMax(maxLeverage, '1');
                    return this.extend(fees, {
                        'id': id,
                        'symbol': symbol,
                        'base': base,
                        'quote': quote,
                        'settle': settle,
                        'baseId': baseId,
                        'quoteId': quoteId,
                        'settleId': settleId,
                        'type': type,
                        'spot': spot,
                        'margin': spot && Precise.stringGt(maxLeverage, '1'),
                        'swap': swap,
                        'future': future,
                        'option': option,
                        'active': true,
                        'contract': contract,
                        'linear': contract ? quoteId === settleId : undefined,
                        'inverse': contract ? baseId === settleId : undefined,
                        'contractSize': contract ? this.safeNumber(market, 'ctVal') : undefined,
                        'expiry': expiry,
                        'expiryDatetime': this.iso8601(expiry),
                        'strike': strikePrice,
                        'optionType': optionType,
                        'precision': {
                            'amount': this.safeNumber(market, 'lotSz'),
                            'price': precisionPrice
                        },
                        'limits': {
                            'leverage': {
                                'min': this.parseNumber('1'),
                                'max': this.parseNumber(maxLeverage)
                            },
                            'amount': {
                                'min': minAmount,
                                'max': undefined
                            },
                            'price': {
                                'min': precisionPrice,
                                'max': undefined
                            },
                            'cost': {
                                'min': undefined,
                                'max': undefined
                            }
                        },
                        'info': market
                    });
                }
                async fetchMarketsByType(type, params = {}) {
                    const request = {
                        'instType': this.convertToInstrumentType(type)
                    };
                    if (type === 'option') {
                        const defaultUnderlying = this.safeValue(this.options, 'defaultUnderlying', 'BTC-USD');
                        const currencyId = this.safeString2(params, 'uly', 'marketId', defaultUnderlying);
                        if (currencyId === undefined) throw new ArgumentsRequired1(this.id + ' fetchMarketsByType() requires an underlying uly or marketId parameter for options markets');
                        else request['uly'] = currencyId;
                    }
                    const response = await this.publicGetPublicInstruments(this.extend(request, params));
                    //
                    // spot, future, swap, option
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "alias": "", // this_week, next_week, quarter, next_quarter
                    //                 "baseCcy": "BTC",
                    //                 "category": "1",
                    //                 "ctMult": "",
                    //                 "ctType": "", // inverse, linear
                    //                 "ctVal": "",
                    //                 "ctValCcy": "",
                    //                 "expTime": "",
                    //                 "instId": "BTC-USDT", // BTC-USD-210521, CSPR-USDT-SWAP, BTC-USD-210517-44000-C
                    //                 "instType": "SPOT", // SPOT, FUTURES, SWAP, OPTION
                    //                 "lever": "10",
                    //                 "listTime": "1548133413000",
                    //                 "lotSz": "0.00000001",
                    //                 "minSz": "0.00001",
                    //                 "optType": "",
                    //                 "quoteCcy": "USDT",
                    //                 "settleCcy": "",
                    //                 "state": "live",
                    //                 "stk": "",
                    //                 "tickSz": "0.1",
                    //                 "uly": ""
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseMarkets(data);
                }
                safeNetwork(networkId) {
                    const networksById = {
                        'Bitcoin': 'BTC',
                        'Omni': 'OMNI',
                        'TRON': 'TRC20'
                    };
                    return this.safeString(networksById, networkId, networkId);
                }
                async fetchCurrencies(params = {}) {
                    // this endpoint requires authentication
                    // while fetchCurrencies is a public API method by design
                    // therefore we check the keys here
                    // and fallback to generating the currencies from the markets
                    if (!this.checkRequiredCredentials(false)) return undefined;
                    //
                    // has['fetchCurrencies'] is currently set to true, but an unauthorized request returns
                    //
                    //     {"msg":"Request header “OK_ACCESS_KEY“ can't be empty.","code":"50103"}
                    //
                    const response = await this.privateGetAssetCurrencies(params);
                    //
                    //     {
                    //         "code" :"0",
                    //         "data": [
                    //             {
                    //                 "canDep": true,
                    //                 "canInternal": true,
                    //                 "canWd": true,
                    //                 "ccy": "USDT",
                    //                 "chain": "USDT-ERC20",
                    //                 "maxFee": "40",
                    //                 "minFee": "20",
                    //                 "minWd": "2",
                    //                 "name": ""
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = {};
                    const dataByCurrencyId = this.groupBy(data, 'ccy');
                    const currencyIds = Object.keys(dataByCurrencyId);
                    const precision = this.parseNumber('0.00000001'); // default precision, todo: fix "magic constants"
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const currency = this.safeCurrency(currencyId);
                        const code = currency['code'];
                        const chains = dataByCurrencyId[currencyId];
                        const networks = {};
                        let currencyActive = false;
                        let depositEnabled = undefined;
                        let withdrawEnabled = undefined;
                        for(let j = 0; j < chains.length; j++){
                            const chain = chains[j];
                            const canDeposit = this.safeValue(chain, 'canDep');
                            const canWithdraw = this.safeValue(chain, 'canWd');
                            const canInternal = this.safeValue(chain, 'canInternal');
                            const active = canDeposit && canWithdraw && canInternal ? true : false;
                            currencyActive = currencyActive === undefined ? active : currencyActive;
                            const networkId = this.safeString(chain, 'chain');
                            if (canDeposit && !depositEnabled) depositEnabled = true;
                            else if (!canDeposit) depositEnabled = false;
                            if (canWithdraw && !withdrawEnabled) withdrawEnabled = true;
                            else if (!canWithdraw) withdrawEnabled = false;
                            if (networkId.indexOf('-') >= 0) {
                                const parts = networkId.split('-');
                                const chainPart = this.safeString(parts, 1, networkId);
                                let network = this.safeNetwork(chainPart);
                                const mainNet = this.safeValue(chain, 'mainNet', false);
                                const layerTwo = this.safeValue(this.options, 'layerTwo', {
                                    'Liquid': true,
                                    'Lightning': true
                                });
                                if (mainNet && !(chainPart in layerTwo)) // BTC lighting and liquid are both mainnet but not the same as BTC-Bitcoin
                                network = code;
                                networks[network] = {
                                    'info': chain,
                                    'id': networkId,
                                    'network': network,
                                    'active': active,
                                    'deposit': canDeposit,
                                    'withdraw': canWithdraw,
                                    'fee': this.safeNumber(chain, 'minFee'),
                                    'precision': undefined,
                                    'limits': {
                                        'withdraw': {
                                            'min': this.safeNumber(chain, 'minWd'),
                                            'max': undefined
                                        }
                                    }
                                };
                            }
                        }
                        result[code] = {
                            'info': undefined,
                            'code': code,
                            'id': currencyId,
                            'name': undefined,
                            'active': currencyActive,
                            'deposit': depositEnabled,
                            'withdraw': withdrawEnabled,
                            'fee': undefined,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'networks': networks
                        };
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instId': market['id']
                    };
                    limit = limit === undefined ? 20 : limit;
                    if (limit !== undefined) request['sz'] = limit; // max 400
                    const response = await this.publicGetMarketBooks(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "asks": [
                    //                     ["0.07228","4.211619","0","2"], // price, amount, liquidated orders, total open orders
                    //                     ["0.0723","299.880364","0","2"],
                    //                     ["0.07231","3.72832","0","1"],
                    //                 ],
                    //                 "bids": [
                    //                     ["0.07221","18.5","0","1"],
                    //                     ["0.0722","18.5","0","1"],
                    //                     ["0.07219","0.505407","0","1"],
                    //                 ],
                    //                 "ts": "1621438475342"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const first = this.safeValue(data, 0, {});
                    const timestamp = this.safeInteger(first, 'ts');
                    return this.parseOrderBook(first, symbol, timestamp);
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "instType": "SPOT",
                    //         "instId": "ETH-BTC",
                    //         "last": "0.07319",
                    //         "lastSz": "0.044378",
                    //         "askPx": "0.07322",
                    //         "askSz": "4.2",
                    //         "bidPx": "0.0732",
                    //         "bidSz": "6.050058",
                    //         "open24h": "0.07801",
                    //         "high24h": "0.07975",
                    //         "low24h": "0.06019",
                    //         "volCcy24h": "11788.887619",
                    //         "vol24h": "167493.829229",
                    //         "ts": "1621440583784",
                    //         "sodUtc0": "0.07872",
                    //         "sodUtc8": "0.07345"
                    //     }
                    //
                    const timestamp = this.safeInteger(ticker, 'ts');
                    const marketId = this.safeString(ticker, 'instId');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    const last = this.safeString(ticker, 'last');
                    const open = this.safeString(ticker, 'open24h');
                    const spot = this.safeValue(market, 'spot', false);
                    const quoteVolume = spot ? this.safeString(ticker, 'volCcy24h') : undefined;
                    const baseVolume = this.safeString(ticker, 'vol24h');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high24h'),
                        'low': this.safeString(ticker, 'low24h'),
                        'bid': this.safeString(ticker, 'bidPx'),
                        'bidVolume': this.safeString(ticker, 'bidSz'),
                        'ask': this.safeString(ticker, 'askPx'),
                        'askVolume': this.safeString(ticker, 'askSz'),
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instId': market['id']
                    };
                    const response = await this.publicGetMarketTicker(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "instType": "SPOT",
                    //                 "instId": "ETH-BTC",
                    //                 "last": "0.07319",
                    //                 "lastSz": "0.044378",
                    //                 "askPx": "0.07322",
                    //                 "askSz": "4.2",
                    //                 "bidPx": "0.0732",
                    //                 "bidSz": "6.050058",
                    //                 "open24h": "0.07801",
                    //                 "high24h": "0.07975",
                    //                 "low24h": "0.06019",
                    //                 "volCcy24h": "11788.887619",
                    //                 "vol24h": "167493.829229",
                    //                 "ts": "1621440583784",
                    //                 "sodUtc0": "0.07872",
                    //                 "sodUtc8": "0.07345"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const first = this.safeValue(data, 0, {});
                    return this.parseTicker(first, market);
                }
                async fetchTickersByType(type, symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'instType': this.convertToInstrumentType(type)
                    };
                    if (type === 'option') {
                        const defaultUnderlying = this.safeValue(this.options, 'defaultUnderlying', 'BTC-USD');
                        const currencyId = this.safeString2(params, 'uly', 'marketId', defaultUnderlying);
                        if (currencyId === undefined) throw new ArgumentsRequired1(this.id + ' fetchTickersByType() requires an underlying uly or marketId parameter for options markets');
                        else request['uly'] = currencyId;
                    }
                    const response = await this.publicGetMarketTickers(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "instType": "SPOT",
                    //                 "instId": "BCD-BTC",
                    //                 "last": "0.0000769",
                    //                 "lastSz": "5.4788",
                    //                 "askPx": "0.0000777",
                    //                 "askSz": "3.2197",
                    //                 "bidPx": "0.0000757",
                    //                 "bidSz": "4.7509",
                    //                 "open24h": "0.0000885",
                    //                 "high24h": "0.0000917",
                    //                 "low24h": "0.0000596",
                    //                 "volCcy24h": "9.2877",
                    //                 "vol24h": "124824.1985",
                    //                 "ts": "1621441741434",
                    //                 "sodUtc0": "0.0000905",
                    //                 "sodUtc8": "0.0000729"
                    //             },
                    //         ]
                    //     }
                    //
                    const tickers = this.safeValue(response, 'data', []);
                    return this.parseTickers(tickers, symbols);
                }
                async fetchTickers(symbols, params = {}) {
                    const [type, query] = this.handleMarketTypeAndParams('fetchTickers', undefined, params);
                    return await this.fetchTickersByType(type, symbols, query);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     {
                    //         "instId": "ETH-BTC",
                    //         "side": "sell",
                    //         "sz": "0.119501",
                    //         "px": "0.07065",
                    //         "tradeId": "15826757",
                    //         "ts": "1621446178316"
                    //     }
                    //
                    // private fetchMyTrades
                    //
                    //     {
                    //         "side": "buy",
                    //         "fillSz": "0.007533",
                    //         "fillPx": "2654.98",
                    //         "fee": "-0.000007533",
                    //         "ordId": "317321390244397056",
                    //         "instType": "SPOT",
                    //         "instId": "ETH-USDT",
                    //         "clOrdId": "",
                    //         "posSide": "net",
                    //         "billId": "317321390265368576",
                    //         "tag": "0",
                    //         "execType": "T",
                    //         "tradeId": "107601752",
                    //         "feeCcy": "ETH",
                    //         "ts": "1621927314985"
                    //     }
                    //
                    const id = this.safeString(trade, 'tradeId');
                    const marketId = this.safeString(trade, 'instId');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    const timestamp = this.safeInteger(trade, 'ts');
                    const price = this.safeString2(trade, 'fillPx', 'px');
                    const amount = this.safeString2(trade, 'fillSz', 'sz');
                    const side = this.safeString(trade, 'side');
                    const orderId = this.safeString(trade, 'ordId');
                    const feeCostString = this.safeString(trade, 'fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCostSigned = Precise.stringNeg(feeCostString);
                        const feeCurrencyId = this.safeString(trade, 'feeCcy');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostSigned,
                            'currency': feeCurrencyCode
                        };
                    }
                    let takerOrMaker = this.safeString(trade, 'execType');
                    if (takerOrMaker === 'T') takerOrMaker = 'taker';
                    else if (takerOrMaker === 'M') takerOrMaker = 'maker';
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': orderId,
                        'type': undefined,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instId': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 100
                    const response = await this.publicGetMarketTrades(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {"instId":"ETH-BTC","side":"sell","sz":"0.119501","px":"0.07065","tradeId":"15826757","ts":"1621446178316"},
                    //             {"instId":"ETH-BTC","side":"sell","sz":"0.03","px":"0.07068","tradeId":"15826756","ts":"1621446178066"},
                    //             {"instId":"ETH-BTC","side":"buy","sz":"0.507","px":"0.07069","tradeId":"15826755","ts":"1621446175085"},
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         "1621447080000", // timestamp
                    //         "0.07073", // open
                    //         "0.07073", // high
                    //         "0.07064", // low
                    //         "0.07064", // close
                    //         "12.08863", // base volume
                    //         "0.854309" // quote volume
                    //     ]
                    //
                    return [
                        this.safeInteger(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const price = this.safeString(params, 'price');
                    params = this.omit(params, 'price');
                    if (limit === undefined) limit = 100; // default 100, max 100
                    const request = {
                        'instId': market['id'],
                        'bar': this.timeframes[timeframe],
                        'limit': limit
                    };
                    let defaultType = 'Candles';
                    if (since !== undefined) {
                        const duration = this.parseTimeframe(timeframe);
                        const now = this.milliseconds();
                        const difference = now - since;
                        // if the since timestamp is more than limit candles back in the past
                        if (difference > limit * duration * 1000) defaultType = 'HistoryCandles';
                        const durationInMilliseconds = duration * 1000;
                        const startTime = Math.max(since - 1, 0);
                        request['before'] = startTime;
                        request['after'] = this.sum(startTime, durationInMilliseconds * limit);
                    }
                    const options = this.safeValue(this.options, 'fetchOHLCV', {});
                    defaultType = this.safeString(options, 'type', defaultType); // Candles or HistoryCandles
                    const type = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    let method = 'publicGetMarket' + type;
                    if (price === 'mark') method = 'publicGetMarketMarkPriceCandles';
                    else if (price === 'index') method = 'publicGetMarketIndexCandles';
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             ["1621447080000","0.07073","0.07073","0.07064","0.07064","12.08863","0.854309"],
                    //             ["1621447020000","0.0708","0.0709","0.0707","0.07072","58.517435","4.143309"],
                    //             ["1621446960000","0.0707","0.07082","0.0707","0.07076","53.850841","3.810921"],
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async fetchFundingRateHistory(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchFundingRateHistory() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instId': market['id']
                    };
                    if (since !== undefined) request['before'] = Math.max(since - 1, 0);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetPublicFundingRateHistory(this.extend(request, params));
                    //
                    //     {
                    //         "code":"0",
                    //         "msg":"",
                    //         "data":[
                    //             {
                    //                 "instType":"SWAP",
                    //                 "instId":"BTC-USDT-SWAP",
                    //                 "fundingRate":"0.018",
                    //                 "realizedRate":"0.017",
                    //                 "fundingTime":"1597026383085"
                    //             },
                    //             {
                    //                 "instType":"SWAP",
                    //                 "instId":"BTC-USDT-SWAP",
                    //                 "fundingRate":"0.018",
                    //                 "realizedRate":"0.017",
                    //                 "fundingTime":"1597026383085"
                    //             }
                    //         ]
                    //     }
                    //
                    const rates = [];
                    const data = this.safeValue(response, 'data');
                    for(let i = 0; i < data.length; i++){
                        const rate = data[i];
                        const timestamp = this.safeNumber(rate, 'fundingTime');
                        rates.push({
                            'symbol': this.safeSymbol(this.safeString(rate, 'instId')),
                            'fundingRate': this.safeNumber(rate, 'realizedRate'),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp)
                        });
                    }
                    const sorted = this.sortBy(rates, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, market['symbol'], since, limit);
                }
                async fetchIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'index'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchMarkOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'mark'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                parseBalanceByType(type, response) {
                    if (type === 'funding') return this.parseFundingBalance(response);
                    else return this.parseTradingBalance(response);
                }
                parseTradingBalance(response) {
                    const result = {
                        'info': response
                    };
                    const data = this.safeValue(response, 'data', []);
                    const first = this.safeValue(data, 0, {});
                    const timestamp = this.safeInteger(first, 'uTime');
                    const details = this.safeValue(first, 'details', []);
                    for(let i = 0; i < details.length; i++){
                        const balance = details[i];
                        const currencyId = this.safeString(balance, 'ccy');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        // it may be incorrect to use total, free and used for swap accounts
                        const eq = this.safeString(balance, 'eq');
                        const availEq = this.safeString(balance, 'availEq');
                        if (eq.length < 1 || availEq.length < 1) {
                            account['free'] = this.safeString(balance, 'availBal');
                            account['used'] = this.safeString(balance, 'frozenBal');
                        } else {
                            account['total'] = eq;
                            account['free'] = availEq;
                        }
                        result[code] = account;
                    }
                    result['timestamp'] = timestamp;
                    result['datetime'] = this.iso8601(timestamp);
                    return this.safeBalance(result);
                }
                parseFundingBalance(response) {
                    const result = {
                        'info': response
                    };
                    const data = this.safeValue(response, 'data', []);
                    for(let i = 0; i < data.length; i++){
                        const balance = data[i];
                        const currencyId = this.safeString(balance, 'ccy');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        // it may be incorrect to use total, free and used for swap accounts
                        account['total'] = this.safeString(balance, 'bal');
                        account['free'] = this.safeString(balance, 'availBal');
                        account['used'] = this.safeString(balance, 'frozenBal');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                parseTradingFee(fee, market) {
                    //
                    //     {
                    //         "category": "1",
                    //         "delivery": "",
                    //         "exercise": "",
                    //         "instType": "SPOT",
                    //         "level": "Lv1",
                    //         "maker": "-0.0008",
                    //         "taker": "-0.001",
                    //         "ts": "1639043138472"
                    //     }
                    //
                    return {
                        'info': fee,
                        'symbol': this.safeSymbol(undefined, market),
                        'maker': this.safeNumber(fee, 'maker'),
                        'taker': this.safeNumber(fee, 'taker')
                    };
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instType': this.convertToInstrumentType(market['type'])
                    };
                    if (market['spot']) request['instId'] = market['id'];
                    else if (market['swap'] || market['future'] || market['option']) request['uly'] = market['baseId'] + '-' + market['quoteId'];
                    else throw new NotSupported(this.id + ' fetchTradingFee() supports spot, swap, future or option markets only');
                    const response = await this.privateGetAccountTradeFee(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "category": "1",
                    //                 "delivery": "",
                    //                 "exercise": "",
                    //                 "instType": "SPOT",
                    //                 "level": "Lv1",
                    //                 "maker": "-0.0008",
                    //                 "taker": "-0.001",
                    //                 "ts": "1639043138472"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const first = this.safeValue(data, 0, {});
                    return this.parseTradingFee(first, market);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchBalance', undefined, params);
                    let method = undefined;
                    if (marketType === 'funding') method = 'privateGetAssetBalances';
                    else method = 'privateGetAccountBalance';
                    const request = {
                    };
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "adjEq": "",
                    //                 "details": [
                    //                     {
                    //                         "availBal": "",
                    //                         "availEq": "28.21006347",
                    //                         "cashBal": "28.21006347",
                    //                         "ccy": "USDT",
                    //                         "crossLiab": "",
                    //                         "disEq": "28.2687404020176",
                    //                         "eq":"28 .21006347",
                    //                         "eqUsd": "28.2687404020176",
                    //                         "frozenBal": "0",
                    //                         "interest": "",
                    //                         "isoEq": "0",
                    //                         "isoLiab": "",
                    //                         "liab": "",
                    //                         "maxLoan": "",
                    //                         "mgnRatio": "",
                    //                         "notionalLever": "0",
                    //                         "ordFrozen": "0",
                    //                         "twap": "0",
                    //                         "uTime": "1621556539861",
                    //                         "upl": "0",
                    //                         "uplLiab": ""
                    //                     }
                    //                 ],
                    //                 "imr": "",
                    //                 "isoEq": "0",
                    //                 "mgnRatio": "",
                    //                 "mmr": "",
                    //                 "notionalUsd": "",
                    //                 "ordFroz": "",
                    //                 "totalEq": "28.2687404020176",
                    //                 "uTime": "1621556553510"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "adjEq": "",
                    //                 "details": [
                    //                     {
                    //                         "availBal": "0.049",
                    //                         "availEq": "",
                    //                         "cashBal": "0.049",
                    //                         "ccy": "BTC",
                    //                         "crossLiab": "",
                    //                         "disEq": "1918.55678",
                    //                         "eq": "0.049",
                    //                         "eqUsd": "1918.55678",
                    //                         "frozenBal": "0",
                    //                         "interest": "",
                    //                         "isoEq": "",
                    //                         "isoLiab": "",
                    //                         "liab": "",
                    //                         "maxLoan": "",
                    //                         "mgnRatio": "",
                    //                         "notionalLever": "",
                    //                         "ordFrozen": "0",
                    //                         "twap": "0",
                    //                         "uTime": "1621973128591",
                    //                         "upl": "",
                    //                         "uplLiab": ""
                    //                     }
                    //                 ],
                    //                 "imr": "",
                    //                 "isoEq": "",
                    //                 "mgnRatio": "",
                    //                 "mmr": "",
                    //                 "notionalUsd": "",
                    //                 "ordFroz": "",
                    //                 "totalEq": "1918.55678",
                    //                 "uTime": "1622045126908"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    // funding
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "availBal": "0.00005426",
                    //                 "bal": 0.0000542600000000,
                    //                 "ccy": "BTC",
                    //                 "frozenBal": "0"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    return this.parseBalanceByType(marketType, response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instId': market['id'],
                        //
                        //     Simple:
                        //     - SPOT and OPTION buyer: cash
                        //
                        //     Single-currency margin:
                        //     - Isolated MARGIN: isolated
                        //     - Cross MARGIN: cross
                        //     - Cross SPOT: cash
                        //     - Cross FUTURES/SWAP/OPTION: cross
                        //     - Isolated FUTURES/SWAP/OPTION: isolated
                        //
                        //     Multi-currency margin:
                        //     - Isolated MARGIN: isolated
                        //     - Cross SPOT: cross
                        //     - Cross FUTURES/SWAP/OPTION: cross
                        //     - Isolated FUTURES/SWAP/OPTION: isolated
                        //
                        // 'ccy': currency['id'], // only applicable to cross MARGIN orders in single-currency margin
                        // 'clOrdId': clientOrderId, // up to 32 characters, must be unique
                        // 'tag': tag, // up to 8 characters
                        //
                        //     In long/short mode, side and posSide need to be combined
                        //
                        //     buy with long means open long
                        //     sell with long means close long
                        //     sell with short means open short
                        //     buy with short means close short
                        //
                        'side': side,
                        // 'posSide': 'long', // long, short, // required in the long/short mode, and can only be long or short
                        'ordType': type
                    };
                    const tdMode = this.safeStringLower(params, 'tdMode');
                    if (market['spot']) request['tdMode'] = 'cash';
                    else if (market['contract']) {
                        if (tdMode === undefined) throw new ArgumentsRequired1(this.id + ' params["tdMode"] is required to be either "isolated" or "cross"');
                        else if (tdMode !== 'isolated' && tdMode !== 'cross') throw new BadRequest(this.id + ' params["tdMode"] must be either "isolated" or "cross"');
                    }
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    if (postOnly) {
                        request['ordType'] = 'post_only';
                        params = this.omit(params, [
                            'postOnly'
                        ]);
                    }
                    const clientOrderId = this.safeString2(params, 'clOrdId', 'clientOrderId');
                    if (clientOrderId === undefined) {
                        const brokerId = this.safeString(this.options, 'brokerId');
                        if (brokerId !== undefined) request['clOrdId'] = brokerId + this.uuid16();
                    } else {
                        request['clOrdId'] = clientOrderId;
                        params = this.omit(params, [
                            'clOrdId',
                            'clientOrderId'
                        ]);
                    }
                    request['sz'] = this.amountToPrecision(symbol, amount);
                    if (type === 'market') {
                        if (market['type'] === 'spot' && side === 'buy') {
                            // spot market buy: "sz" can refer either to base currency units or to quote currency units
                            // see documentation: https://www.okx.com/docs-v5/en/#rest-api-trade-place-order
                            const defaultTgtCcy = this.safeString(this.options, 'tgtCcy', 'base_ccy');
                            const tgtCcy = this.safeString(params, 'tgtCcy', defaultTgtCcy);
                            if (tgtCcy === 'quote_ccy') {
                                // quote_ccy: sz refers to units of quote currency
                                request['tgtCcy'] = 'quote_ccy';
                                let notional = this.safeNumber(params, 'sz');
                                const createMarketBuyOrderRequiresPrice = this.safeValue(this.options, 'createMarketBuyOrderRequiresPrice', true);
                                if (createMarketBuyOrderRequiresPrice) {
                                    if (price !== undefined) {
                                        if (notional === undefined) notional = amount * price;
                                    } else if (notional === undefined) throw new InvalidOrder(this.id + " createOrder() requires the price argument with market buy orders to calculate total order cost (amount to spend), where cost = amount * price. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount, or, alternatively, add .options['createMarketBuyOrderRequiresPrice'] = false and supply the total cost value in the 'amount' argument or in the 'sz' extra parameter (the exchange-specific behaviour)");
                                } else notional = notional === undefined ? amount : notional;
                                const precision = market['precision']['price'];
                                request['sz'] = this.decimalToPrecision(notional, TRUNCATE, precision, this.precisionMode);
                            } else // base_ccy: sz refers to units of base currency
                            request['tgtCcy'] = 'base_ccy';
                            params = this.omit(params, [
                                'tgtCcy'
                            ]);
                        }
                    } else // non-market orders
                    request['px'] = this.priceToPrecision(symbol, price);
                    let extendedRequest = undefined;
                    let defaultMethod = this.safeString(this.options, 'createOrder', 'privatePostTradeBatchOrders'); // or privatePostTradeOrder or privatePostTradeOrderAlgo
                    const stopPrice = this.safeNumber2(params, 'triggerPx', 'stopPrice');
                    params = this.omit(params, [
                        'triggerPx',
                        'stopPrice'
                    ]);
                    if (stopPrice) {
                        defaultMethod = 'privatePostTradeOrderAlgo';
                        request['ordType'] = 'trigger';
                        request['triggerPx'] = this.priceToPrecision(symbol, stopPrice);
                        if (type === 'market') price = -1;
                        request['orderPx'] = this.priceToPrecision(symbol, price);
                    }
                    if (defaultMethod === 'privatePostTradeOrder' || defaultMethod === 'privatePostTradeOrderAlgo') extendedRequest = this.extend(request, params);
                    else if (defaultMethod === 'privatePostTradeBatchOrders') // keep the request body the same
                    // submit a single order in an array to the batch order endpoint
                    // because it has a lower ratelimit
                    extendedRequest = [
                        this.extend(request, params)
                    ];
                    else throw new ExchangeError1(this.id + ' this.options["createOrder"] must be either privatePostTradeBatchOrders or privatePostTradeOrder');
                    const response = await this[defaultMethod](extendedRequest);
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "clOrdId": "oktswap6",
                    //                 "ordId": "312269865356374016",
                    //                 "tag": "",
                    //                 "sCode": "0",
                    //                 "sMsg": ""
                    //             }
                    //         ]
                    //     }
                    //
                    // Trigger Order
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "algoId": "422774258702659590",
                    //                 "sCode": "0",
                    //                 "sMsg": ""
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const first = this.safeValue(data, 0);
                    const order = this.parseOrder(first, market);
                    return this.extend(order, {
                        'type': type,
                        'side': side
                    });
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instId': market['id']
                    };
                    const clientOrderId = this.safeString2(params, 'clOrdId', 'clientOrderId');
                    if (clientOrderId !== undefined) request['clOrdId'] = clientOrderId;
                    else request['ordId'] = id;
                    const query = this.omit(params, [
                        'clOrdId',
                        'clientOrderId'
                    ]);
                    const response = await this.privatePostTradeCancelOrder(this.extend(request, query));
                    // {"code":"0","data":[{"clOrdId":"","ordId":"317251910906576896","sCode":"0","sMsg":""}],"msg":""}
                    const data = this.safeValue(response, 'data', []);
                    const order = this.safeValue(data, 0);
                    return this.parseOrder(order, market);
                }
                async cancelOrders(ids, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = [];
                    const options = this.safeValue(this.options, 'cancelOrders', {});
                    const defaultMethod = this.safeString(options, 'method', 'privatePostTradeCancelBatchOrders');
                    let method = this.safeString(params, 'method', defaultMethod);
                    const clientOrderId = this.safeValue2(params, 'clOrdId', 'clientOrderId');
                    const algoId = this.safeValue(params, 'algoId');
                    const stop = this.safeValue(params, 'stop');
                    if (clientOrderId === undefined) {
                        if (stop || algoId !== undefined) {
                            method = 'privatePostTradeCancelAlgos';
                            if (Array.isArray(algoId)) for(let i = 0; i < algoId.length; i++)request.push({
                                'instId': market['id'],
                                'algoId': algoId[i]
                            });
                            else if (typeof algoId === 'string') request.push({
                                'instId': market['id'],
                                'algoId': algoId
                            });
                        } else {
                            if (typeof ids === 'string') {
                                const orderIds = ids.split(',');
                                for(let i = 0; i < orderIds.length; i++)request.push({
                                    'instId': market['id'],
                                    'ordId': orderIds[i]
                                });
                            } else for(let i = 0; i < ids.length; i++)request.push({
                                'instId': market['id'],
                                'ordId': ids[i]
                            });
                        }
                    } else if (Array.isArray(clientOrderId)) for(let i = 0; i < clientOrderId.length; i++)request.push({
                        'instId': market['id'],
                        'clOrdId': clientOrderId[i]
                    });
                    else if (typeof clientOrderId === 'string') request.push({
                        'instId': market['id'],
                        'clOrdId': clientOrderId
                    });
                    const response = await this[method](request); // dont extend with params, otherwise ARRAY will be turned into OBJECT
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "clOrdId": "e123456789ec4dBC1123456ba123b45e",
                    //                 "ordId": "405071912345641543",
                    //                 "sCode": "0",
                    //                 "sMsg": ""
                    //             },
                    //             ...
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    // Algo order
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "algoId": "431375349042380800",
                    //                 "sCode": "0",
                    //                 "sMsg": ""
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const ordersData = this.safeValue(response, 'data', []);
                    return this.parseOrders(ordersData, market, undefined, undefined, params);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'canceled': 'canceled',
                        'live': 'open',
                        'partially_filled': 'open',
                        'filled': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "clOrdId": "oktswap6",
                    //         "ordId": "312269865356374016",
                    //         "tag": "",
                    //         "sCode": "0",
                    //         "sMsg": ""
                    //     }
                    //
                    // Spot and Swap fetchOrder, fetchOpenOrders
                    //
                    //     {
                    //         "accFillSz": "0",
                    //         "avgPx": "",
                    //         "cTime": "1621910749815",
                    //         "category": "normal",
                    //         "ccy": "",
                    //         "clOrdId": "",
                    //         "fee": "0",
                    //         "feeCcy": "ETH",
                    //         "fillPx": "",
                    //         "fillSz": "0",
                    //         "fillTime": "",
                    //         "instId": "ETH-USDT",
                    //         "instType": "SPOT",
                    //         "lever": "",
                    //         "ordId": "317251910906576896",
                    //         "ordType": "limit",
                    //         "pnl": "0",
                    //         "posSide": "net",
                    //         "px": "2000",
                    //         "rebate": "0",
                    //         "rebateCcy": "USDT",
                    //         "side": "buy",
                    //         "slOrdPx": "",
                    //         "slTriggerPx": "",
                    //         "state": "live",
                    //         "sz": "0.001",
                    //         "tag": "",
                    //         "tdMode": "cash",
                    //         "tpOrdPx": "",
                    //         "tpTriggerPx": "",
                    //         "tradeId": "",
                    //         "uTime": "1621910749815"
                    //     }
                    //
                    // Algo Order fetchOrder, fetchOpenOrders, fetchCanceledOrders
                    //
                    //     {
                    //         "activePx": "",
                    //         "activePxType": "",
                    //         "actualPx": "",
                    //         "actualSide": "buy",
                    //         "actualSz": "0",
                    //         "algoId": "431375349042380800",
                    //         "cTime": "1649119897778",
                    //         "callbackRatio": "",
                    //         "callbackSpread": "",
                    //         "ccy": "",
                    //         "ctVal": "0.01",
                    //         "instId": "BTC-USDT-SWAP",
                    //         "instType": "SWAP",
                    //         "last": "46538.9",
                    //         "lever": "125",
                    //         "moveTriggerPx": "",
                    //         "notionalUsd": "467.059",
                    //         "ordId": "",
                    //         "ordPx": "50000",
                    //         "ordType": "trigger",
                    //         "posSide": "long",
                    //         "pxLimit": "",
                    //         "pxSpread": "",
                    //         "pxVar": "",
                    //         "side": "buy",
                    //         "slOrdPx": "",
                    //         "slTriggerPx": "",
                    //         "slTriggerPxType": "",
                    //         "state": "live",
                    //         "sz": "1",
                    //         "szLimit": "",
                    //         "tag": "",
                    //         "tdMode": "isolated",
                    //         "tgtCcy": "",
                    //         "timeInterval": "",
                    //         "tpOrdPx": "",
                    //         "tpTriggerPx": "",
                    //         "tpTriggerPxType": "",
                    //         "triggerPx": "50000",
                    //         "triggerPxType": "last",
                    //         "triggerTime": "",
                    //         "uly": "BTC-USDT"
                    //     }
                    //
                    const id = this.safeString(order, 'ordId');
                    const timestamp = this.safeInteger(order, 'cTime');
                    const lastTradeTimestamp = this.safeInteger(order, 'fillTime');
                    const side = this.safeString(order, 'side');
                    let type = this.safeString(order, 'ordType');
                    let postOnly = undefined;
                    let timeInForce = undefined;
                    if (type === 'post_only') {
                        postOnly = true;
                        type = 'limit';
                    } else if (type === 'fok') {
                        timeInForce = 'FOK';
                        type = 'limit';
                    } else if (type === 'ioc') {
                        timeInForce = 'IOC';
                        type = 'limit';
                    }
                    const marketId = this.safeString(order, 'instId');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const filled = this.safeString(order, 'accFillSz');
                    const price = this.safeString2(order, 'px', 'ordPx');
                    const average = this.safeString(order, 'avgPx');
                    const status = this.parseOrderStatus(this.safeString(order, 'state'));
                    const feeCostString = this.safeString(order, 'fee');
                    let amount = undefined;
                    let cost = undefined;
                    // spot market buy: "sz" can refer either to base currency units or to quote currency units
                    // see documentation: https://www.okx.com/docs-v5/en/#rest-api-trade-place-order
                    const defaultTgtCcy = this.safeString(this.options, 'tgtCcy', 'base_ccy');
                    const tgtCcy = this.safeString(order, 'tgtCcy', defaultTgtCcy);
                    const instType = this.safeString(order, 'instType');
                    if (side === 'buy' && type === 'market' && instType === 'SPOT' && tgtCcy === 'quote_ccy') // "sz" refers to the cost
                    cost = this.safeString(order, 'sz');
                    else // "sz" refers to the trade currency amount
                    amount = this.safeString(order, 'sz');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCostSigned = Precise.stringNeg(feeCostString);
                        const feeCurrencyId = this.safeString(order, 'feeCcy');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': this.parseNumber(feeCostSigned),
                            'currency': feeCurrencyCode
                        };
                    }
                    let clientOrderId = this.safeString(order, 'clOrdId');
                    if (clientOrderId !== undefined && clientOrderId.length < 1) clientOrderId = undefined; // fix empty clientOrderId string
                    const stopPrice = this.safeNumber2(order, 'slTriggerPx', 'triggerPx');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'average': average,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    /**
         * @method
         * @name okx#fetchOrder
         * @description Fetch an order by the id
         * @param {string} id The order id
         * @param {string} symbol Unified market symbol
         * @param {dict} params Extra and exchange specific parameters
         * @param {integer} params.till Timestamp in ms of the latest time to retrieve orders for
         * @param {boolean} params.stop True if fetching trigger orders
         * @param {string} params.ordType "conditional", "oco", "trigger", "move_order_stop", "iceberg", or "twap"
         * @param {string} params.algoId Algo ID
         * @returns [An order structure]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
        */ if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'instId': market['id']
                    };
                    const clientOrderId = this.safeString2(params, 'clOrdId', 'clientOrderId');
                    const options = this.safeValue(this.options, 'fetchOrder', {});
                    const algoOrderTypes = this.safeValue(this.options, 'algoOrderTypes', {});
                    const defaultMethod = this.safeString(options, 'method', 'privateGetTradeOrder');
                    let method = this.safeString(params, 'method', defaultMethod);
                    const ordType = this.safeString(params, 'ordType');
                    const stop = this.safeValue(params, 'stop');
                    if (stop || ordType in algoOrderTypes) {
                        if (ordType === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires an ordType parameter');
                        method = 'privateGetTradeOrdersAlgoHistory';
                        request['algoId'] = id;
                    } else if (clientOrderId !== undefined) request['clOrdId'] = clientOrderId;
                    else request['ordId'] = id;
                    const query = this.omit(params, [
                        'method',
                        'stop',
                        'clOrdId',
                        'clientOrderId'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot and Swap
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "accFillSz": "0",
                    //                 "avgPx": "",
                    //                 "cTime": "1621910749815",
                    //                 "category": "normal",
                    //                 "ccy": "",
                    //                 "clOrdId": "",
                    //                 "fee": "0",
                    //                 "feeCcy": "ETH",
                    //                 "fillPx": "",
                    //                 "fillSz": "0",
                    //                 "fillTime": "",
                    //                 "instId": "ETH-USDT",
                    //                 "instType": "SPOT",
                    //                 "lever": "",
                    //                 "ordId": "317251910906576896",
                    //                 "ordType": "limit",
                    //                 "pnl": "0",
                    //                 "posSide": "net",
                    //                 "px":"20 00",
                    //                 "rebate": "0",
                    //                 "rebateCcy": "USDT",
                    //                 "side": "buy",
                    //                 "slOrdPx": "",
                    //                 "slTriggerPx": "",
                    //                 "state": "live",
                    //                 "sz":"0. 001",
                    //                 "tag": "",
                    //                 "tdMode": "cash",
                    //                 "tpOrdPx": "",
                    //                 "tpTriggerPx": "",
                    //                 "tradeId": "",
                    //                 "uTime": "1621910749815"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    // Algo order
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "activePx": "",
                    //                 "activePxType": "",
                    //                 "actualPx": "",
                    //                 "actualSide": "buy",
                    //                 "actualSz": "0",
                    //                 "algoId": "432912085631369216",
                    //                 "cTime": "1649486284333",
                    //                 "callbackRatio": "",
                    //                 "callbackSpread": "",
                    //                 "ccy": "",
                    //                 "ctVal": "0.01",
                    //                 "instId": "BTC-USDT-SWAP",
                    //                 "instType": "SWAP",
                    //                 "last": "42458.6",
                    //                 "lever": "125",
                    //                 "moveTriggerPx": "",
                    //                 "notionalUsd": "1699.856",
                    //                 "ordId": "",
                    //                 "ordPx": "30000",
                    //                 "ordType": "trigger",
                    //                 "posSide": "long",
                    //                 "pxLimit": "",
                    //                 "pxSpread": "",
                    //                 "pxVar": "",
                    //                 "side": "buy",
                    //                 "slOrdPx": "",
                    //                 "slTriggerPx": "",
                    //                 "slTriggerPxType": "",
                    //                 "state": "live",
                    //                 "sz": "4",
                    //                 "szLimit": "",
                    //                 "tag": "",
                    //                 "tdMode": "isolated",
                    //                 "tgtCcy": "",
                    //                 "timeInterval": "",
                    //                 "tpOrdPx": "",
                    //                 "tpTriggerPx": "",
                    //                 "tpTriggerPxType": "",
                    //                 "triggerPx": "31000",
                    //                 "triggerPxType": "last",
                    //                 "triggerTime": "",
                    //                 "uly": "BTC-USDT"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const order = this.safeValue(data, 0);
                    return this.parseOrder(order, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    /**
         * @method
         * @name okx#fetchOpenOrders
         * @description Fetch orders that are still open
         * @param {str} symbol Unified market symbol
         * @param {int} since Timestamp in ms of the earliest time to retrieve orders for
         * @param {int} limit Number of results per request. The maximum is 100; The default is 100
         * @param {dict} params Extra and exchange specific parameters
         * @param {int} params.till Timestamp in ms of the latest time to retrieve orders for
         * @param {bool} params.stop True if fetching trigger orders
         * @param {str} params.ordType "conditional", "oco", "trigger", "move_order_stop", "iceberg", or "twap"
         * @param {str} params.algoId Algo ID
         * @returns [An order structure]{@link https://docs.ccxt.com/en/latest/manual.html#order-structure}
         */ await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instId'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 100
                    const options = this.safeValue(this.options, 'fetchOpenOrders', {});
                    const algoOrderTypes = this.safeValue(this.options, 'algoOrderTypes', {});
                    const defaultMethod = this.safeString(options, 'method', 'privateGetTradeOrdersPending');
                    let method = this.safeString(params, 'method', defaultMethod);
                    const ordType = this.safeString(params, 'ordType');
                    const stop = this.safeValue(params, 'stop');
                    if (stop || ordType in algoOrderTypes) method = 'privateGetTradeOrdersAlgoPending';
                    const query = this.omit(params, [
                        'method',
                        'stop'
                    ]);
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "accFillSz": "0",
                    //                 "avgPx": "",
                    //                 "cTime": "1621910749815",
                    //                 "category": "normal",
                    //                 "ccy": "",
                    //                 "clOrdId": "",
                    //                 "fee": "0",
                    //                 "feeCcy": "ETH",
                    //                 "fillPx": "",
                    //                 "fillSz": "0",
                    //                 "fillTime": "",
                    //                 "instId": "ETH-USDT",
                    //                 "instType": "SPOT",
                    //                 "lever": "",
                    //                 "ordId": "317251910906576896",
                    //                 "ordType": "limit",
                    //                 "pnl": "0",
                    //                 "posSide": "net",
                    //                 "px":"20 00",
                    //                 "rebate": "0",
                    //                 "rebateCcy": "USDT",
                    //                 "side": "buy",
                    //                 "slOrdPx": "",
                    //                 "slTriggerPx": "",
                    //                 "state": "live",
                    //                 "sz":"0. 001",
                    //                 "tag": "",
                    //                 "tdMode": "cash",
                    //                 "tpOrdPx": "",
                    //                 "tpTriggerPx": "",
                    //                 "tradeId": "",
                    //                 "uTime": "1621910749815"
                    //             }
                    //         ],
                    //         "msg":""
                    //     }
                    //
                    // Algo order
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "activePx": "",
                    //                 "activePxType": "",
                    //                 "actualPx": "",
                    //                 "actualSide": "buy",
                    //                 "actualSz": "0",
                    //                 "algoId": "431375349042380800",
                    //                 "cTime": "1649119897778",
                    //                 "callbackRatio": "",
                    //                 "callbackSpread": "",
                    //                 "ccy": "",
                    //                 "ctVal": "0.01",
                    //                 "instId": "BTC-USDT-SWAP",
                    //                 "instType": "SWAP",
                    //                 "last": "46538.9",
                    //                 "lever": "125",
                    //                 "moveTriggerPx": "",
                    //                 "notionalUsd": "467.059",
                    //                 "ordId": "",
                    //                 "ordPx": "50000",
                    //                 "ordType": "trigger",
                    //                 "posSide": "long",
                    //                 "pxLimit": "",
                    //                 "pxSpread": "",
                    //                 "pxVar": "",
                    //                 "side": "buy",
                    //                 "slOrdPx": "",
                    //                 "slTriggerPx": "",
                    //                 "slTriggerPxType": "",
                    //                 "state": "live",
                    //                 "sz": "1",
                    //                 "szLimit": "",
                    //                 "tag": "",
                    //                 "tdMode": "isolated",
                    //                 "tgtCcy": "",
                    //                 "timeInterval": "",
                    //                 "tpOrdPx": "",
                    //                 "tpTriggerPx": "",
                    //                 "tpTriggerPxType": "",
                    //                 "triggerPx": "50000",
                    //                 "triggerPxType": "last",
                    //                 "triggerTime": "",
                    //                 "uly": "BTC-USDT"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchCanceledOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instId'] = market['id'];
                    }
                    const [type, query] = this.handleMarketTypeAndParams('fetchCanceledOrders', market, params);
                    request['instType'] = this.convertToInstrumentType(type);
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 100
                    request['state'] = 'canceled';
                    const options = this.safeValue(this.options, 'fetchCanceledOrders', {});
                    const algoOrderTypes = this.safeValue(this.options, 'algoOrderTypes', {});
                    const defaultMethod = this.safeString(options, 'method', 'privateGetTradeOrdersHistory');
                    let method = this.safeString(params, 'method', defaultMethod);
                    const ordType = this.safeString(params, 'ordType');
                    const stop = this.safeValue(params, 'stop');
                    if (stop || ordType in algoOrderTypes) method = 'privateGetTradeOrdersAlgoHistory';
                    const send = this.omit(query, [
                        'method',
                        'stop'
                    ]);
                    const response = await this[method](this.extend(request, send));
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "accFillSz": "0",
                    //                 "avgPx": "",
                    //                 "cTime": "1644037822494",
                    //                 "category": "normal",
                    //                 "ccy": "",
                    //                 "clOrdId": "",
                    //                 "fee": "0",
                    //                 "feeCcy": "BTC",
                    //                 "fillPx": "",
                    //                 "fillSz": "0",
                    //                 "fillTime": "",
                    //                 "instId": "BTC-USDT",
                    //                 "instType": "SPOT",
                    //                 "lever": "",
                    //                 "ordId": "410059580352409602",
                    //                 "ordType": "limit",
                    //                 "pnl": "0",
                    //                 "posSide": "net",
                    //                 "px": "30000",
                    //                 "rebate": "0",
                    //                 "rebateCcy": "USDT",
                    //                 "side": "buy",
                    //                 "slOrdPx": "",
                    //                 "slTriggerPx": "",
                    //                 "slTriggerPxType": "",
                    //                 "source": "",
                    //                 "state": "canceled",
                    //                 "sz": "0.0005452",
                    //                 "tag": "",
                    //                 "tdMode": "cash",
                    //                 "tgtCcy": "",
                    //                 "tpOrdPx": "",
                    //                 "tpTriggerPx": "",
                    //                 "tpTriggerPxType": "",
                    //                 "tradeId": "",
                    //                 "uTime": "1644038165667"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    // Algo order
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "activePx": "",
                    //                 "activePxType": "",
                    //                 "actualPx": "",
                    //                 "actualSide": "buy",
                    //                 "actualSz": "0",
                    //                 "algoId": "433845797218942976",
                    //                 "cTime": "1649708898523",
                    //                 "callbackRatio": "",
                    //                 "callbackSpread": "",
                    //                 "ccy": "",
                    //                 "ctVal": "0.01",
                    //                 "instId": "BTC-USDT-SWAP",
                    //                 "instType": "SWAP",
                    //                 "last": "39950.4",
                    //                 "lever": "125",
                    //                 "moveTriggerPx": "",
                    //                 "notionalUsd": "1592.1760000000002",
                    //                 "ordId": "",
                    //                 "ordPx": "29000",
                    //                 "ordType": "trigger",
                    //                 "posSide": "long",
                    //                 "pxLimit": "",
                    //                 "pxSpread": "",
                    //                 "pxVar": "",
                    //                 "side": "buy",
                    //                 "slOrdPx": "",
                    //                 "slTriggerPx": "",
                    //                 "slTriggerPxType": "",
                    //                 "state": "canceled",
                    //                 "sz": "4",
                    //                 "szLimit": "",
                    //                 "tag": "",
                    //                 "tdMode": "isolated",
                    //                 "tgtCcy": "",
                    //                 "timeInterval": "",
                    //                 "tpOrdPx": "",
                    //                 "tpTriggerPx": "",
                    //                 "tpTriggerPxType": "",
                    //                 "triggerPx": "30000",
                    //                 "triggerPxType": "last",
                    //                 "triggerTime": "",
                    //                 "uly": "BTC-USDT"
                    //             },
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instId'] = market['id'];
                    }
                    const [type, query] = this.handleMarketTypeAndParams('fetchClosedOrders', market, params);
                    request['instType'] = this.convertToInstrumentType(type);
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 100
                    request['state'] = 'filled';
                    const method = this.safeString(this.options, 'method', 'privateGetTradeOrdersHistory');
                    const response = await this[method](this.extend(request, query));
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "accFillSz": "0",
                    //                 "avgPx": "",
                    //                 "cTime": "1621910749815",
                    //                 "category": "normal",
                    //                 "ccy": "",
                    //                 "clOrdId": "",
                    //                 "fee": "0",
                    //                 "feeCcy": "ETH",
                    //                 "fillPx": "",
                    //                 "fillSz": "0",
                    //                 "fillTime": "",
                    //                 "instId": "ETH-USDT",
                    //                 "instType": "SPOT",
                    //                 "lever": "",
                    //                 "ordId": "317251910906576896",
                    //                 "ordType": "limit",
                    //                 "pnl": "0",
                    //                 "posSide": "net",
                    //                 "px": "2000",
                    //                 "rebate": "0",
                    //                 "rebateCcy": "USDT",
                    //                 "side": "buy",
                    //                 "slOrdPx": "",
                    //                 "slTriggerPx": "",
                    //                 "state": "live",
                    //                 "sz": "0.001",
                    //                 "tag": "",
                    //                 "tdMode": "cash",
                    //                 "tpOrdPx": "",
                    //                 "tpTriggerPx": "",
                    //                 "tradeId": "",
                    //                 "uTime": "1621910749815"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instId'] = market['id'];
                    }
                    const [type, query] = this.handleMarketTypeAndParams('fetchMyTrades', market, params);
                    request['instType'] = this.convertToInstrumentType(type);
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 100
                    const response = await this.privateGetTradeFillsHistory(this.extend(request, query));
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "side": "buy",
                    //                 "fillSz": "0.007533",
                    //                 "fillPx": "2654.98",
                    //                 "fee": "-0.000007533",
                    //                 "ordId": "317321390244397056",
                    //                 "instType": "SPOT",
                    //                 "instId": "ETH-USDT",
                    //                 "clOrdId": "",
                    //                 "posSide": "net",
                    //                 "billId": "317321390265368576",
                    //                 "tag": "0",
                    //                 "execType": "T",
                    //                 "tradeId": "107601752",
                    //                 "feeCcy": "ETH",
                    //                 "ts": "1621927314985"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit, query);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    const request = {
                        // 'instrument_id': market['id'],
                        'ordId': id
                    };
                    return await this.fetchMyTrades(symbol, since, limit, this.extend(request, params));
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const options = this.safeValue(this.options, 'fetchLedger', {});
                    let method = this.safeString(options, 'method');
                    method = this.safeString(params, 'method', method);
                    params = this.omit(params, 'method');
                    const request = {
                    };
                    const [type, query] = this.handleMarketTypeAndParams('fetchLedger', undefined, params);
                    if (type !== undefined) request['instType'] = this.convertToInstrumentType(type);
                    if (limit !== undefined) request['limit'] = limit;
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['ccy'] = currency['id'];
                    }
                    const response = await this[method](this.extend(request, query));
                    //
                    // privateGetAccountBills, privateGetAccountBillsArchive
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "bal": "0.0000819307998198",
                    //                 "balChg": "-664.2679586599999802",
                    //                 "billId": "310394313544966151",
                    //                 "ccy": "USDT",
                    //                 "fee": "0",
                    //                 "from": "",
                    //                 "instId": "LTC-USDT",
                    //                 "instType": "SPOT",
                    //                 "mgnMode": "cross",
                    //                 "notes": "",
                    //                 "ordId": "310394313519800320",
                    //                 "pnl": "0",
                    //                 "posBal": "0",
                    //                 "posBalChg": "0",
                    //                 "subType": "2",
                    //                 "sz": "664.26795866",
                    //                 "to": "",
                    //                 "ts": "1620275771196",
                    //                 "type": "2"
                    //             }
                    //         ]
                    //     }
                    //
                    // privateGetAssetBills
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "billId": "12344",
                    //                 "ccy": "BTC",
                    //                 "balChg": "2",
                    //                 "bal": "12",
                    //                 "type": "1",
                    //                 "ts": "1597026383085"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseLedger(data, currency, since, limit);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        '1': 'transfer',
                        '2': 'trade',
                        '3': 'trade',
                        '4': 'rebate',
                        '5': 'trade',
                        '6': 'transfer',
                        '7': 'trade',
                        '8': 'fee',
                        '9': 'trade',
                        '10': 'trade',
                        '11': 'trade'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    // privateGetAccountBills, privateGetAccountBillsArchive
                    //
                    //     {
                    //         "bal": "0.0000819307998198",
                    //         "balChg": "-664.2679586599999802",
                    //         "billId": "310394313544966151",
                    //         "ccy": "USDT",
                    //         "fee": "0",
                    //         "from": "",
                    //         "instId": "LTC-USDT",
                    //         "instType": "SPOT",
                    //         "mgnMode": "cross",
                    //         "notes": "",
                    //         "ordId": "310394313519800320",
                    //         "pnl": "0",
                    //         "posBal": "0",
                    //         "posBalChg": "0",
                    //         "subType": "2",
                    //         "sz": "664.26795866",
                    //         "to": "",
                    //         "ts": "1620275771196",
                    //         "type": "2"
                    //     }
                    //
                    // privateGetAssetBills
                    //
                    //     {
                    //         "billId": "12344",
                    //         "ccy": "BTC",
                    //         "balChg": "2",
                    //         "bal": "12",
                    //         "type": "1",
                    //         "ts": "1597026383085"
                    //     }
                    //
                    const id = this.safeString(item, 'billId');
                    const account = undefined;
                    const referenceId = this.safeString(item, 'ordId');
                    const referenceAccount = undefined;
                    const type = this.parseLedgerEntryType(this.safeString(item, 'type'));
                    const code = this.safeCurrencyCode(this.safeString(item, 'ccy'), currency);
                    const amountString = this.safeString(item, 'balChg');
                    const amount = this.parseNumber(amountString);
                    const timestamp = this.safeInteger(item, 'ts');
                    const feeCostString = this.safeString(item, 'fee');
                    let fee = undefined;
                    if (feeCostString !== undefined) fee = {
                        'cost': this.parseNumber(Precise.stringNeg(feeCostString)),
                        'currency': code
                    };
                    const before = undefined;
                    const afterString = this.safeString(item, 'bal');
                    const after = this.parseNumber(afterString);
                    const status = 'ok';
                    const marketId = this.safeString(item, 'instId');
                    let symbol = undefined;
                    if (marketId in this.markets_by_id) {
                        const market = this.markets_by_id[marketId];
                        symbol = market['symbol'];
                    }
                    return {
                        'id': id,
                        'info': item,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'account': account,
                        'referenceId': referenceId,
                        'referenceAccount': referenceAccount,
                        'type': type,
                        'currency': code,
                        'symbol': symbol,
                        'amount': amount,
                        'before': before,
                        'after': after,
                        'status': status,
                        'fee': fee
                    };
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         "addr": "okbtothemoon",
                    //         "memo": "971668", // may be missing
                    //         "tag":"52055", // may be missing
                    //         "pmtId": "", // may be missing
                    //         "ccy": "BTC",
                    //         "to": "6", // 1 SPOT, 3 FUTURES, 6 FUNDING, 9 SWAP, 12 OPTION, 18 Unified account
                    //         "selected": true
                    //     }
                    //
                    //     {
                    //         "ccy":"usdt-erc20",
                    //         "to":"6",
                    //         "addr":"0x696abb81974a8793352cbd33aadcf78eda3cfdfa",
                    //         "selected":true
                    //     }
                    //
                    //     {
                    //        "chain": "ETH-OKExChain",
                    //        "ctAddr": "72315c",
                    //        "ccy": "ETH",
                    //        "to": "6",
                    //        "addr": "0x1c9f2244d1ccaa060bd536827c18925db10db102",
                    //        "selected": true
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'addr');
                    let tag = this.safeString2(depositAddress, 'tag', 'pmtId');
                    tag = this.safeString(depositAddress, 'memo', tag);
                    const currencyId = this.safeString(depositAddress, 'ccy');
                    currency = this.safeCurrency(currencyId, currency);
                    const code = currency['code'];
                    const chain = this.safeString(depositAddress, 'chain');
                    const networks = this.safeValue(currency, 'networks', {});
                    const networksById = this.indexBy(networks, 'id');
                    let networkData = this.safeValue(networksById, chain);
                    // inconsistent naming responses from exchange
                    // with respect to network naming provided in currency info vs address chain-names and ids
                    //
                    // response from address endpoint:
                    //      {
                    //          "chain": "USDT-Polygon",
                    //          "ctAddr": "",
                    //          "ccy": "USDT",
                    //          "to":"6" ,
                    //          "addr": "0x1903441e386cc49d937f6302955b5feb4286dcfa",
                    //          "selected": true
                    //      }
                    // network information from currency['networks'] field:
                    // Polygon: {
                    //        info: {
                    //            canDep: false,
                    //            canInternal: false,
                    //            canWd: false,
                    //            ccy: 'USDT',
                    //            chain: 'USDT-Polygon-Bridge',
                    //            mainNet: false,
                    //            maxFee: '26.879528',
                    //            minFee: '13.439764',
                    //            minWd: '0.001',
                    //            name: ''
                    //        },
                    //        id: 'USDT-Polygon-Bridge',
                    //        network: 'Polygon',
                    //        active: false,
                    //        deposit: false,
                    //        withdraw: false,
                    //        fee: 13.439764,
                    //        precision: undefined,
                    //        limits: {
                    //            withdraw: {
                    //                min: 0.001,
                    //                max: undefined
                    //            }
                    //        }
                    //     },
                    //
                    if (chain === 'USDT-Polygon') networkData = this.safeValue(networksById, 'USDT-Polygon-Bridge');
                    const network = this.safeString(networkData, 'network');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': network,
                        'info': depositAddress
                    };
                }
                async fetchDepositAddressesByNetwork(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'ccy': currency['id']
                    };
                    const response = await this.privateGetAssetDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "addr": "okbtothemoon",
                    //                 "memo": "971668", // may be missing
                    //                 "tag":"52055", // may be missing
                    //                 "pmtId": "", // may be missing
                    //                 "ccy": "BTC",
                    //                 "to": "6", // 1 SPOT, 3 FUTURES, 6 FUNDING, 9 SWAP, 12 OPTION, 18 Unified account
                    //                 "selected": true
                    //             },
                    //             // {"ccy":"usdt-erc20","to":"6","addr":"0x696abb81974a8793352cbd33aadcf78eda3cfdfa","selected":true},
                    //             // {"ccy":"usdt-trc20","to":"6","addr":"TRrd5SiSZrfQVRKm4e9SRSbn2LNTYqCjqx","selected":true},
                    //             // {"ccy":"usdt_okexchain","to":"6","addr":"0x696abb81974a8793352cbd33aadcf78eda3cfdfa","selected":true},
                    //             // {"ccy":"usdt_kip20","to":"6","addr":"0x696abb81974a8793352cbd33aadcf78eda3cfdfa","selected":true},
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const filtered = this.filterBy(data, 'selected', true);
                    const parsed = this.parseDepositAddresses(filtered, [
                        code
                    ], false);
                    return this.indexBy(parsed, 'network');
                }
                async fetchDepositAddress(code, params = {}) {
                    const rawNetwork = this.safeStringUpper(params, 'network');
                    const networks = this.safeValue(this.options, 'networks', {});
                    const network = this.safeString(networks, rawNetwork, rawNetwork);
                    params = this.omit(params, 'network');
                    const response = await this.fetchDepositAddressesByNetwork(code, params);
                    let result = undefined;
                    if (network === undefined) {
                        result = this.safeValue(response, code);
                        if (result === undefined) {
                            const alias = this.safeString(networks, code, code);
                            result = this.safeValue(response, alias);
                            if (result === undefined) {
                                const defaultNetwork = this.safeString(this.options, 'defaultNetwork', 'ERC20');
                                result = this.safeValue(response, defaultNetwork);
                                if (result === undefined) {
                                    const values = Object.values(response);
                                    result = this.safeValue(values, 0);
                                    if (result === undefined) throw new InvalidAddress(this.id + ' fetchDepositAddress() cannot find deposit address for ' + code);
                                }
                            }
                        }
                        return result;
                    }
                    result = this.safeValue(response, network);
                    if (result === undefined) throw new InvalidAddress(this.id + ' fetchDepositAddress() cannot find ' + network + ' deposit address for ' + code);
                    return result;
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (tag !== undefined) address = address + ':' + tag;
                    const fee = this.safeString(params, 'fee');
                    if (fee === undefined) throw new ArgumentsRequired1(this.id + " withdraw() requires a 'fee' string parameter, network transaction fee must be \u2265 0. Withdrawals to OKCoin or OKX are fee-free, please set '0'. Withdrawing to external digital asset address requires network transaction fee.");
                    const request = {
                        'ccy': currency['id'],
                        'toAddr': address,
                        'dest': '4',
                        'amt': this.numberToString(amount),
                        'fee': this.numberToString(fee)
                    };
                    if ('password' in params) request['pwd'] = params['password'];
                    else if ('pwd' in params) request['pwd'] = params['pwd'];
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeString(networks, network, network); // handle ETH>ERC20 alias
                    if (network !== undefined) {
                        request['chain'] = currency['id'] + '-' + network;
                        params = this.omit(params, 'network');
                    }
                    const query = this.omit(params, [
                        'fee',
                        'password',
                        'pwd'
                    ]);
                    if (!('pwd' in request)) throw new ExchangeError1(this.id + ' withdraw() requires a password parameter or a pwd parameter, it must be the funding password, not the API passphrase');
                    const response = await this.privatePostAssetWithdrawal(this.extend(request, query));
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "amt": "0.1",
                    //                 "wdId": "67485",
                    //                 "ccy": "BTC"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const transaction = this.safeValue(data, 0);
                    return this.parseTransaction(transaction, currency);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['ccy'] = currency['id'];
                    }
                    if (since !== undefined) request['before'] = Math.max(since - 1, 0);
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 100
                    const response = await this.privateGetAssetDepositHistory(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "amt": "0.01044408",
                    //                 "txId": "1915737_3_0_0_asset",
                    //                 "ccy": "BTC",
                    //                 "from": "13801825426",
                    //                 "to": "",
                    //                 "ts": "1597026383085",
                    //                 "state": "2",
                    //                 "depId": "4703879"
                    //             },
                    //             {
                    //                 "amt": "491.6784211",
                    //                 "txId": "1744594_3_184_0_asset",
                    //                 "ccy": "OKB",
                    //                 "from": "",
                    //                 "to": "",
                    //                 "ts": "1597026383085",
                    //                 "state": "2",
                    //                 "depId": "4703809"
                    //             },
                    //             {
                    //                 "amt": "223.18782496",
                    //                 "txId": "6d892c669225b1092c780bf0da0c6f912fc7dc8f6b8cc53b003288624c",
                    //                 "ccy": "USDT",
                    //                 "from": "",
                    //                 "to": "39kK4XvgEuM7rX9frgyHoZkWqx4iKu1spD",
                    //                 "ts": "1597026383085",
                    //                 "state": "2",
                    //                 "depId": "4703779"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, currency, since, limit, params);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['ccy'] = currency['id'];
                    }
                    if (since !== undefined) request['before'] = Math.max(since - 1, 0);
                    if (limit !== undefined) request['limit'] = limit; // default 100, max 100
                    const response = await this.privateGetAssetWithdrawalHistory(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "amt": "0.094",
                    //                 "wdId": "4703879",
                    //                 "fee": "0.01000000eth",
                    //                 "txId": "0x62477bac6509a04512819bb1455e923a60dea5966c7caeaa0b24eb8fb0432b85",
                    //                 "ccy": "ETH",
                    //                 "from": "13426335357",
                    //                 "to": "0xA41446125D0B5b6785f6898c9D67874D763A1519",
                    //                 "ts": "1597026383085",
                    //                 "state": "2"
                    //             },
                    //             {
                    //                 "amt": "0.01",
                    //                 "wdId": "4703879",
                    //                 "fee": "0.00000000btc",
                    //                 "txId": "",
                    //                 "ccy": "BTC",
                    //                 "from": "13426335357",
                    //                 "to": "13426335357",
                    //                 "ts": "1597026383085",
                    //                 "state": "2"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTransactions(data, currency, since, limit, params);
                }
                parseTransactionStatus(status) {
                    //
                    // deposit statuses
                    //
                    //     {
                    //         '0': 'waiting for confirmation',
                    //         '1': 'deposit credited',
                    //         '2': 'deposit successful'
                    //     }
                    //
                    // withdrawal statuses
                    //
                    //     {
                    //        '-3': 'pending cancel',
                    //        '-2': 'canceled',
                    //        '-1': 'failed',
                    //         '0': 'pending',
                    //         '1': 'sending',
                    //         '2': 'sent',
                    //         '3': 'awaiting email verification',
                    //         '4': 'awaiting manual verification',
                    //         '5': 'awaiting identity verification'
                    //     }
                    //
                    const statuses = {
                        '-3': 'pending',
                        '-2': 'canceled',
                        '-1': 'failed',
                        '0': 'pending',
                        '1': 'pending',
                        '2': 'ok',
                        '3': 'pending',
                        '4': 'pending',
                        '5': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "amt": "0.1",
                    //         "wdId": "67485",
                    //         "ccy": "BTC"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "amt": "0.094",
                    //         "wdId": "4703879",
                    //         "fee": "0.01000000eth",
                    //         "txId": "0x62477bac6509a04512819bb1455e923a60dea5966c7caeaa0b24eb8fb0432b85",
                    //         "ccy": "ETH",
                    //         "from": "13426335357",
                    //         "to": "0xA41446125D0B5b6785f6898c9D67874D763A1519",
                    //         'tag': string,
                    //         'pmtId': string,
                    //         'memo': string,
                    //         "ts": "1597026383085",
                    //         "state": "2"
                    //     }
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "amt": "0.01044408",
                    //         "txId": "1915737_3_0_0_asset",
                    //         "ccy": "BTC",
                    //         "from": "13801825426",
                    //         "to": "",
                    //         "ts": "1597026383085",
                    //         "state": "2",
                    //         "depId": "4703879"
                    //     }
                    //
                    let type = undefined;
                    let id = undefined;
                    const withdrawalId = this.safeString(transaction, 'wdId');
                    const addressFrom = this.safeString(transaction, 'from');
                    const addressTo = this.safeString(transaction, 'to');
                    const address = addressTo;
                    let tagTo = this.safeString2(transaction, 'tag', 'memo');
                    tagTo = this.safeString2(transaction, 'pmtId', tagTo);
                    if (withdrawalId !== undefined) {
                        type = 'withdrawal';
                        id = withdrawalId;
                    } else {
                        // the payment_id will appear on new deposits but appears to be removed from the response after 2 months
                        id = this.safeString(transaction, 'depId');
                        type = 'deposit';
                    }
                    const currencyId = this.safeString(transaction, 'ccy');
                    const code = this.safeCurrencyCode(currencyId);
                    const amount = this.safeNumber(transaction, 'amt');
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'state'));
                    const txid = this.safeString(transaction, 'txId');
                    const timestamp = this.safeInteger(transaction, 'ts');
                    let feeCost = undefined;
                    if (type === 'deposit') feeCost = 0;
                    else feeCost = this.safeNumber(transaction, 'fee');
                    // todo parse tags
                    return {
                        'info': transaction,
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': undefined,
                        'addressFrom': addressFrom,
                        'addressTo': addressTo,
                        'address': address,
                        'tagFrom': undefined,
                        'tagTo': tagTo,
                        'tag': tagTo,
                        'status': status,
                        'type': type,
                        'updated': undefined,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': {
                            'currency': code,
                            'cost': feeCost
                        }
                    };
                }
                async fetchLeverage(symbol, params = {}) {
                    await this.loadMarkets();
                    const marginMode = this.safeStringLower(params, 'mgnMode');
                    params = this.omit(params, [
                        'mgnMode'
                    ]);
                    if (marginMode !== 'cross' && marginMode !== 'isolated') throw new BadRequest(this.id + ' fetchLeverage() requires a mgnMode parameter that must be either cross or isolated');
                    const market = this.market(symbol);
                    const request = {
                        'instId': market['id'],
                        'mgnMode': marginMode
                    };
                    const response = await this.privateGetAccountLeverageInfo(this.extend(request, params));
                    //
                    //     {
                    //        "code": "0",
                    //        "data": [
                    //            {
                    //                "instId": "BTC-USDT-SWAP",
                    //                "lever": "5.00000000",
                    //                "mgnMode": "isolated",
                    //                "posSide": "net"
                    //            }
                    //        ],
                    //        "msg": ""
                    //     }
                    //
                    return response;
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const [type, query] = this.handleMarketTypeAndParams('fetchPosition', market, params);
                    const request = {
                        // instType String No Instrument type, MARGIN, SWAP, FUTURES, OPTION
                        'instId': market['id']
                    };
                    if (type !== undefined) request['instType'] = this.convertToInstrumentType(type);
                    const response = await this.privateGetAccountPositions(query);
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "adl": "1",
                    //                 "availPos": "1",
                    //                 "avgPx": "2566.31",
                    //                 "cTime": "1619507758793",
                    //                 "ccy": "ETH",
                    //                 "deltaBS": "",
                    //                 "deltaPA": "",
                    //                 "gammaBS": "",
                    //                 "gammaPA": "",
                    //                 "imr": "",
                    //                 "instId": "ETH-USD-210430",
                    //                 "instType": "FUTURES",
                    //                 "interest": "0",
                    //                 "last": "2566.22",
                    //                 "lever": "10",
                    //                 "liab": "",
                    //                 "liabCcy": "",
                    //                 "liqPx": "2352.8496681818233",
                    //                 "margin": "0.0003896645377994",
                    //                 "mgnMode": "isolated",
                    //                 "mgnRatio": "11.731726509588816",
                    //                 "mmr": "0.0000311811092368",
                    //                 "optVal": "",
                    //                 "pTime": "1619507761462",
                    //                 "pos": "1",
                    //                 "posCcy": "",
                    //                 "posId": "307173036051017730",
                    //                 "posSide": "long",
                    //                 "thetaBS": "",
                    //                 "thetaPA": "",
                    //                 "tradeId": "109844",
                    //                 "uTime": "1619507761462",
                    //                 "upl": "-0.0000009932766034",
                    //                 "uplRatio": "-0.0025490556801078",
                    //                 "vegaBS": "",
                    //                 "vegaPA": ""
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const position = this.safeValue(data, 0);
                    if (position === undefined) return position;
                    return this.parsePosition(position);
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    // const defaultType = this.safeString2 (this.options, 'fetchPositions', 'defaultType');
                    // const type = this.safeString (params, 'type', defaultType);
                    const request = {
                    };
                    const [type, query] = this.handleMarketTypeAndParams('fetchPositions', undefined, params);
                    if (type !== undefined) {
                        if (type === 'swap' || type === 'future') request['instType'] = this.convertToInstrumentType(type);
                    }
                    const response = await this.privateGetAccountPositions(this.extend(request, query));
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "adl": "1",
                    //                 "availPos": "1",
                    //                 "avgPx": "2566.31",
                    //                 "cTime": "1619507758793",
                    //                 "ccy": "ETH",
                    //                 "deltaBS": "",
                    //                 "deltaPA": "",
                    //                 "gammaBS": "",
                    //                 "gammaPA": "",
                    //                 "imr": "",
                    //                 "instId": "ETH-USD-210430",
                    //                 "instType": "FUTURES",
                    //                 "interest": "0",
                    //                 "last": "2566.22",
                    //                 "lever": "10",
                    //                 "liab": "",
                    //                 "liabCcy": "",
                    //                 "liqPx": "2352.8496681818233",
                    //                 "margin": "0.0003896645377994",
                    //                 "mgnMode": "isolated",
                    //                 "mgnRatio": "11.731726509588816",
                    //                 "mmr": "0.0000311811092368",
                    //                 "optVal": "",
                    //                 "pTime": "1619507761462",
                    //                 "pos": "1",
                    //                 "posCcy": "",
                    //                 "posId": "307173036051017730",
                    //                 "posSide": "long",
                    //                 "thetaBS": "",
                    //                 "thetaPA": "",
                    //                 "tradeId": "109844",
                    //                 "uTime": "1619507761462",
                    //                 "upl": "-0.0000009932766034",
                    //                 "uplRatio": "-0.0025490556801078",
                    //                 "vegaBS": "",
                    //                 "vegaPA": ""
                    //             }
                    //         ]
                    //     }
                    //
                    const positions = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < positions.length; i++){
                        const entry = positions[i];
                        const instrument = this.safeString(entry, 'instType');
                        if (instrument === 'FUTURES' || instrument === 'SWAP') result.push(this.parsePosition(positions[i]));
                    }
                    return this.filterByArray(result, 'symbol', symbols, false);
                }
                parsePosition(position, market) {
                    //
                    //     {
                    //        "adl": "3",
                    //        "availPos": "1",
                    //        "avgPx": "34131.1",
                    //        "cTime": "1627227626502",
                    //        "ccy": "USDT",
                    //        "deltaBS": "",
                    //        "deltaPA": "",
                    //        "gammaBS": "",
                    //        "gammaPA": "",
                    //        "imr": "170.66093041794787",
                    //        "instId": "BTC-USDT-SWAP",
                    //        "instType": "SWAP",
                    //        "interest": "0",
                    //        "last": "34134.4",
                    //        "lever": "2",
                    //        "liab": "",
                    //        "liabCcy": "",
                    //        "liqPx": "12608.959083877446",
                    //        "markPx": "4786.459271773621",
                    //        "margin": "",
                    //        "mgnMode": "cross",
                    //        "mgnRatio": "140.49930117599155",
                    //        "mmr": "1.3652874433435829",
                    //        "notionalUsd": "341.5130010779638",
                    //        "optVal": "",
                    //        "pos": "1",
                    //        "posCcy": "",
                    //        "posId": "339552508062380036",
                    //        "posSide": "long",
                    //        "thetaBS": "",
                    //        "thetaPA": "",
                    //        "tradeId": "98617799",
                    //        "uTime": "1627227626502",
                    //        "upl": "0.0108608358957281",
                    //        "uplRatio": "0.0000636418743944",
                    //        "vegaBS": "",
                    //        "vegaPA": ""
                    //    }
                    //
                    const marketId = this.safeString(position, 'instId');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const contractsString = this.safeString(position, 'pos');
                    const contractsAbs = Precise.stringAbs(contractsString);
                    let contracts = undefined;
                    let side = this.safeString(position, 'posSide');
                    const hedged = side !== 'net';
                    if (contractsString !== undefined) {
                        contracts = this.parseNumber(contractsAbs);
                        if (side === 'net') {
                            if (Precise.stringGt(contractsString, '0')) side = 'long';
                            else side = 'short';
                        }
                    }
                    const contractSize = this.safeValue(market, 'contractSize');
                    const contractSizeString = this.numberToString(contractSize);
                    const markPriceString = this.safeString(position, 'markPx');
                    let notionalString = this.safeString(position, 'notionalUsd');
                    if (market['inverse']) notionalString = Precise.stringDiv(Precise.stringMul(contractsAbs, contractSizeString), markPriceString);
                    const notional = this.parseNumber(notionalString);
                    const marginMode = this.safeString(position, 'mgnMode');
                    let initialMarginString = undefined;
                    const entryPriceString = this.safeString(position, 'avgPx');
                    const unrealizedPnlString = this.safeString(position, 'upl');
                    const leverageString = this.safeString(position, 'lever');
                    let initialMarginPercentage = undefined;
                    let collateralString = undefined;
                    if (marginMode === 'cross') {
                        initialMarginString = this.safeString(position, 'imr');
                        collateralString = Precise.stringAdd(initialMarginString, unrealizedPnlString);
                    } else if (marginMode === 'isolated') {
                        initialMarginPercentage = Precise.stringDiv('1', leverageString);
                        collateralString = this.safeString(position, 'margin');
                    }
                    const maintenanceMarginString = this.safeString(position, 'mmr');
                    const maintenanceMargin = this.parseNumber(maintenanceMarginString);
                    let maintenanceMarginPercentage = Precise.stringDiv(maintenanceMarginString, notionalString);
                    if (initialMarginPercentage === undefined) initialMarginPercentage = this.parseNumber(Precise.stringDiv(initialMarginString, notionalString, 4));
                    else if (initialMarginString === undefined) initialMarginString = Precise.stringMul(initialMarginPercentage, notionalString);
                    const rounder = '0.00005'; // round to closest 0.01%
                    maintenanceMarginPercentage = this.parseNumber(Precise.stringDiv(Precise.stringAdd(maintenanceMarginPercentage, rounder), '1', 4));
                    const liquidationPrice = this.safeNumber(position, 'liqPx');
                    const percentageString = this.safeString(position, 'uplRatio');
                    const percentage = this.parseNumber(Precise.stringMul(percentageString, '100'));
                    const timestamp = this.safeInteger(position, 'uTime');
                    const marginRatio = this.parseNumber(Precise.stringDiv(maintenanceMarginString, collateralString, 4));
                    return {
                        'info': position,
                        'symbol': symbol,
                        'notional': notional,
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'liquidationPrice': liquidationPrice,
                        'entryPrice': this.parseNumber(entryPriceString),
                        'unrealizedPnl': this.parseNumber(unrealizedPnlString),
                        'percentage': percentage,
                        'contracts': contracts,
                        'contractSize': contractSize,
                        'markPrice': this.parseNumber(markPriceString),
                        'side': side,
                        'hedged': hedged,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'maintenanceMargin': maintenanceMargin,
                        'maintenanceMarginPercentage': maintenanceMarginPercentage,
                        'collateral': this.parseNumber(collateralString),
                        'initialMargin': this.parseNumber(initialMarginString),
                        'initialMarginPercentage': this.parseNumber(initialMarginPercentage),
                        'leverage': this.parseNumber(leverageString),
                        'marginRatio': marginRatio
                    };
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                    const toId = this.safeString(accountsByType, toAccount, toAccount);
                    const request = {
                        'ccy': currency['id'],
                        'amt': this.currencyToPrecision(code, amount),
                        'type': '0',
                        'from': fromId,
                        'to': toId
                    };
                    if (fromId === 'master') {
                        request['type'] = '1';
                        request['subAcct'] = toId;
                        request['from'] = this.safeString(params, 'from', '6');
                        request['to'] = this.safeString(params, 'to', '6');
                    } else if (toId === 'master') {
                        request['type'] = '2';
                        request['subAcct'] = fromId;
                        request['from'] = this.safeString(params, 'from', '6');
                        request['to'] = this.safeString(params, 'to', '6');
                    }
                    const response = await this.privatePostAssetTransfer(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "msg": "",
                    //         "data": [
                    //             {
                    //                 "transId": "754147",
                    //                 "ccy": "USDT",
                    //                 "from": "6",
                    //                 "amt": "0.1",
                    //                 "to": "18"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const rawTransfer = this.safeValue(data, 0, {});
                    return this.parseTransfer(rawTransfer, currency);
                }
                parseTransfer(transfer, currency) {
                    //
                    // transfer
                    //
                    //     {
                    //         "transId": "754147",
                    //         "ccy": "USDT",
                    //         "from": "6",
                    //         "amt": "0.1",
                    //         "to": "18"
                    //     }
                    //
                    // fetchTransfer
                    //
                    //     {
                    //         "amt": "5",
                    //         "ccy": "USDT",
                    //         "from": "18",
                    //         "instId": "",
                    //         "state": "success",
                    //         "subAcct": "",
                    //         "to": "6",
                    //         "toInstId": "",
                    //         "transId": "464424732",
                    //         "type": "0"
                    //     }
                    //
                    const id = this.safeString(transfer, 'transId');
                    const currencyId = this.safeString(transfer, 'ccy');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const amount = this.safeNumber(transfer, 'amt');
                    const fromAccountId = this.safeString(transfer, 'from');
                    const toAccountId = this.safeString(transfer, 'to');
                    const accountsById = this.safeValue(this.options, 'accountsById', {});
                    const fromAccount = this.safeString(accountsById, fromAccountId);
                    const toAccount = this.safeString(accountsById, toAccountId);
                    const timestamp = this.milliseconds();
                    const status = this.safeString(transfer, 'state');
                    return {
                        'info': transfer,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': code,
                        'amount': amount,
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'status': status
                    };
                }
                async fetchTransfer(id, code, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'transId': id
                    };
                    const response = await this.privateGetAssetTransferState(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "amt": "5",
                    //                 "ccy": "USDT",
                    //                 "from": "18",
                    //                 "instId": "",
                    //                 "state": "success",
                    //                 "subAcct": "",
                    //                 "to": "6",
                    //                 "toInstId": "",
                    //                 "transId": "464424732",
                    //                 "type": "0"
                    //             }
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const transfer = this.safeValue(data, 0);
                    return this.parseTransfer(transfer);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const isArray = Array.isArray(params);
                    const request = '/api/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    let url = this.implodeHostname(this.urls['api']['rest']) + request;
                    // const type = this.getPathAuthenticationType (path);
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.iso8601(this.milliseconds());
                        headers = {
                            'OK-ACCESS-KEY': this.apiKey,
                            'OK-ACCESS-PASSPHRASE': this.password,
                            'OK-ACCESS-TIMESTAMP': timestamp
                        };
                        let auth = timestamp + method + request;
                        if (method === 'GET') {
                            if (Object.keys(query).length) {
                                const urlencodedQuery = '?' + this.urlencode(query);
                                url += urlencodedQuery;
                                auth += urlencodedQuery;
                            }
                        } else {
                            if (isArray || Object.keys(query).length) {
                                body = this.json(query);
                                auth += body;
                            }
                            headers['Content-Type'] = 'application/json';
                        }
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha256', 'base64');
                        headers['OK-ACCESS-SIGN'] = signature;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                parseFundingRate(fundingRate, market) {
                    //
                    //    {
                    //        "fundingRate": "0.00027815",
                    //        "fundingTime": "1634256000000",
                    //        "instId": "BTC-USD-SWAP",
                    //        "instType": "SWAP",
                    //        "nextFundingRate": "0.00017",
                    //        "nextFundingTime": "1634284800000"
                    //    }
                    //
                    // in the response above nextFundingRate is actually two funding rates from now
                    //
                    const nextFundingRateTimestamp = this.safeInteger(fundingRate, 'nextFundingTime');
                    const marketId = this.safeString(fundingRate, 'instId');
                    const symbol = this.safeSymbol(marketId, market);
                    const nextFundingRate = this.safeNumber(fundingRate, 'nextFundingRate');
                    const fundingTime = this.safeInteger(fundingRate, 'fundingTime');
                    // https://www.okx.com/support/hc/en-us/articles/360053909272-Ⅸ-Introduction-to-perpetual-swap-funding-fee
                    // > The current interest is 0.
                    return {
                        'info': fundingRate,
                        'symbol': symbol,
                        'markPrice': undefined,
                        'indexPrice': undefined,
                        'interestRate': this.parseNumber('0'),
                        'estimatedSettlePrice': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'fundingRate': this.safeNumber(fundingRate, 'fundingRate'),
                        'fundingTimestamp': fundingTime,
                        'fundingDatetime': this.iso8601(fundingTime),
                        'nextFundingRate': nextFundingRate,
                        'nextFundingTimestamp': nextFundingRateTimestamp,
                        'nextFundingDatetime': this.iso8601(nextFundingRateTimestamp),
                        'previousFundingRate': undefined,
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (!market['swap']) throw new ExchangeError1(this.id + ' fetchFundingRate() is only valid for swap markets');
                    const request = {
                        'instId': market['id']
                    };
                    const response = await this.publicGetPublicFundingRate(this.extend(request, params));
                    //
                    //    {
                    //        "code": "0",
                    //        "data": [
                    //            {
                    //                "fundingRate": "0.00027815",
                    //                "fundingTime": "1634256000000",
                    //                "instId": "BTC-USD-SWAP",
                    //                "instType": "SWAP",
                    //                "nextFundingRate": "0.00017",
                    //                "nextFundingTime": "1634284800000"
                    //            }
                    //        ],
                    //        "msg": ""
                    //    }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const entry = this.safeValue(data, 0, {});
                    return this.parseFundingRate(entry, market);
                }
                async fetchFundingHistory(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        // 'instType': 'SPOT', // SPOT, MARGIN, SWAP, FUTURES, OPTION
                        // 'ccy': currency['id'],
                        // 'mgnMode': 'isolated', // isolated, cross
                        // 'ctType': 'linear', // linear, inverse, only applicable to FUTURES/SWAP
                        'type': '8'
                    };
                    if (limit !== undefined) request['limit'] = limit.toString(); // default 100, max 100
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        symbol = market['symbol'];
                        if (market['contract']) {
                            if (market['linear']) {
                                request['ctType'] = 'linear';
                                request['ccy'] = market['quoteId'];
                            } else {
                                request['ctType'] = 'inverse';
                                request['ccy'] = market['baseId'];
                            }
                        }
                    }
                    const [type, query] = this.handleMarketTypeAndParams('fetchFundingHistory', market, params);
                    if (type === 'swap') request['instType'] = this.convertToInstrumentType(type);
                    // AccountBillsArchive has the same cost as AccountBills but supports three months of data
                    const response = await this.privateGetAccountBillsArchive(this.extend(request, query));
                    //
                    //    {
                    //        "bal": "0.0242946200998573",
                    //        "balChg": "0.0000148752712240",
                    //        "billId": "377970609204146187",
                    //        "ccy": "ETH",
                    //        "execType": "",
                    //        "fee": "0",
                    //        "from": "",
                    //        "instId": "ETH-USD-SWAP",
                    //        "instType": "SWAP",
                    //        "mgnMode": "isolated",
                    //        "notes": "",
                    //        "ordId": "",
                    //        "pnl": "0.000014875271224",
                    //        "posBal": "0",
                    //        "posBalChg": "0",
                    //        "subType": "174",
                    //        "sz": "9",
                    //        "to": "",
                    //        "ts": "1636387215588",
                    //        "type": "8"
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const entry = data[i];
                        const timestamp = this.safeInteger(entry, 'ts');
                        const instId = this.safeString(entry, 'instId');
                        const market = this.safeMarket(instId);
                        const currencyId = this.safeString(entry, 'ccy');
                        const code = this.safeCurrencyCode(currencyId);
                        result.push({
                            'info': entry,
                            'symbol': market['symbol'],
                            'code': code,
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'id': this.safeString(entry, 'billId'),
                            'amount': this.safeNumber(entry, 'balChg')
                        });
                    }
                    const sorted = this.sortBy(result, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, symbol, since, limit);
                }
                async setLeverage(leverage, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    // WARNING: THIS WILL INCREASE LIQUIDATION PRICE FOR OPEN ISOLATED LONG POSITIONS
                    // AND DECREASE LIQUIDATION PRICE FOR OPEN ISOLATED SHORT POSITIONS
                    if (leverage < 1 || leverage > 125) throw new BadRequest(this.id + ' setLeverage() leverage should be between 1 and 125');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const marginMode = this.safeStringLower(params, 'mgnMode');
                    params = this.omit(params, [
                        'mgnMode'
                    ]);
                    if (marginMode !== 'cross' && marginMode !== 'isolated') throw new BadRequest(this.id + ' setLeverage() params["mgnMode"] must be either cross or isolated');
                    const request = {
                        'lever': leverage,
                        'mgnMode': marginMode,
                        'instId': market['id']
                    };
                    const response = await this.privatePostAccountSetLeverage(this.extend(request, params));
                    //
                    //     {
                    //       "code": "0",
                    //       "data": [
                    //         {
                    //           "instId": "BTC-USDT-SWAP",
                    //           "lever": "5",
                    //           "mgnMode": "isolated",
                    //           "posSide": "long"
                    //         }
                    //       ],
                    //       "msg": ""
                    //     }
                    //
                    return response;
                }
                async setPositionMode(hedged, symbol, params = {}) {
                    let hedgeMode = undefined;
                    if (hedged) hedgeMode = 'long_short_mode';
                    else hedgeMode = 'net_mode';
                    const request = {
                        'posMode': hedgeMode
                    };
                    const response = await this.privatePostAccountSetPositionMode(this.extend(request, params));
                    //
                    //    {
                    //        "code": "0",
                    //        "data": [
                    //            {
                    //                "posMode": "net_mode"
                    //            }
                    //        ],
                    //        "msg": ""
                    //    }
                    //
                    return response;
                }
                async setMarginMode(marginMode, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    // WARNING: THIS WILL INCREASE LIQUIDATION PRICE FOR OPEN ISOLATED LONG POSITIONS
                    // AND DECREASE LIQUIDATION PRICE FOR OPEN ISOLATED SHORT POSITIONS
                    marginMode = marginMode.toLowerCase();
                    if (marginMode !== 'cross' && marginMode !== 'isolated') throw new BadRequest(this.id + ' setMarginMode() marginMode must be either cross or isolated');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const lever = this.safeInteger(params, 'lever');
                    if (lever === undefined || lever < 1 || lever > 125) throw new BadRequest(this.id + ' setMarginMode() params["lever"] should be between 1 and 125');
                    params = this.omit(params, [
                        'lever'
                    ]);
                    const request = {
                        'lever': lever,
                        'mgnMode': marginMode,
                        'instId': market['id']
                    };
                    const response = await this.privatePostAccountSetLeverage(this.extend(request, params));
                    //
                    //     {
                    //       "code": "0",
                    //       "data": [
                    //         {
                    //           "instId": "BTC-USDT-SWAP",
                    //           "lever": "5",
                    //           "mgnMode": "isolated",
                    //           "posSide": "long"
                    //         }
                    //       ],
                    //       "msg": ""
                    //     }
                    //
                    return response;
                }
                async fetchBorrowRates(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccountInterestRate(params);
                    //
                    //    {
                    //        "code": "0",
                    //        "data": [
                    //            {
                    //                "ccy": "BTC",
                    //                "interestRate": "0.00000833"
                    //            }
                    //            ...
                    //        ],
                    //    }
                    //
                    const timestamp = this.milliseconds();
                    const data = this.safeValue(response, 'data');
                    const rates = {};
                    for(let i = 0; i < data.length; i++){
                        const rate = data[i];
                        const code = this.safeCurrencyCode(this.safeString(rate, 'ccy'));
                        rates[code] = {
                            'currency': code,
                            'rate': this.safeNumber(rate, 'interestRate'),
                            'period': 86400000,
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'info': rate
                        };
                    }
                    return rates;
                }
                async fetchBorrowRate(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'ccy': currency['id']
                    };
                    const response = await this.privateGetAccountInterestRate(this.extend(request, params));
                    //
                    //    {
                    //        "code": "0",
                    //        "data": [
                    //             {
                    //                "ccy": "USDT",
                    //                "interestRate": "0.00002065"
                    //             }
                    //             ...
                    //        ],
                    //        "msg": ""
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    const rate = this.safeValue(data, 0);
                    return this.parseBorrowRate(rate);
                }
                parseBorrowRate(info, currency) {
                    //
                    //    {
                    //        "amt": "992.10341195",
                    //        "ccy": "BTC",
                    //        "rate": "0.01",
                    //        "ts": "1643954400000"
                    //    }
                    //
                    const ccy = this.safeString(info, 'ccy');
                    const timestamp = this.safeInteger(info, 'ts');
                    return {
                        'currency': this.safeCurrencyCode(ccy),
                        'rate': this.safeNumber2(info, 'interestRate', 'rate'),
                        'period': 86400000,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'info': info
                    };
                }
                parseBorrowRateHistories(response, codes, since, limit) {
                    //
                    //    [
                    //        {
                    //            "amt": "992.10341195",
                    //            "ccy": "BTC",
                    //            "rate": "0.01",
                    //            "ts": "1643954400000"
                    //        },
                    //        ...
                    //    ]
                    //
                    const borrowRateHistories = {};
                    for(let i = 0; i < response.length; i++){
                        const item = response[i];
                        const code = this.safeCurrencyCode(this.safeString(item, 'ccy'));
                        if (codes === undefined || codes.includes(code)) {
                            if (!(code in borrowRateHistories)) borrowRateHistories[code] = [];
                            const borrowRateStructure = this.parseBorrowRate(item);
                            borrowRateHistories[code].push(borrowRateStructure);
                        }
                    }
                    const keys = Object.keys(borrowRateHistories);
                    for(let i = 0; i < keys.length; i++){
                        const code = keys[i];
                        borrowRateHistories[code] = this.filterByCurrencySinceLimit(borrowRateHistories[code], code, since, limit);
                    }
                    return borrowRateHistories;
                }
                parseBorrowRateHistory(response, code, since, limit) {
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const item = response[i];
                        const borrowRate = this.parseBorrowRate(item);
                        result.push(borrowRate);
                    }
                    const sorted = this.sortBy(result, 'timestamp');
                    return this.filterByCurrencySinceLimit(sorted, code, since, limit);
                }
                async fetchBorrowRateHistories(codes, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    if (since !== undefined) request['before'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetAssetLendingRateHistory(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "amt": "992.10341195",
                    //                 "ccy": "BTC",
                    //                 "rate": "0.01",
                    //                 "ts": "1643954400000"
                    //             },
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseBorrowRateHistories(data, codes, since, limit);
                }
                async fetchBorrowRateHistory(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'ccy': currency['id']
                    };
                    if (since !== undefined) request['before'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetAssetLendingRateHistory(this.extend(request, params));
                    //
                    //     {
                    //         "code": "0",
                    //         "data": [
                    //             {
                    //                 "amt": "992.10341195",
                    //                 "ccy": "BTC",
                    //                 "rate": "0.01",
                    //                 "ts": "1643954400000"
                    //             },
                    //         ],
                    //         "msg": ""
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseBorrowRateHistory(data, code, since, limit);
                }
                async modifyMarginHelper(symbol, amount, type, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const posSide = this.safeString(params, 'posSide', 'net');
                    params = this.omit(params, [
                        'posSide'
                    ]);
                    const request = {
                        'instId': market['id'],
                        'amt': amount,
                        'type': type,
                        'posSide': posSide
                    };
                    const response = await this.privatePostAccountPositionMarginBalance(this.extend(request, params));
                    //
                    //     {
                    //       "code": "0",
                    //       "data": [
                    //         {
                    //           "amt": "0.01",
                    //           "instId": "ETH-USD-SWAP",
                    //           "posSide": "net",
                    //           "type": "reduce"
                    //         }
                    //       ],
                    //       "msg": ""
                    //     }
                    //
                    return this.parseModifyMargin(response, market);
                }
                parseModifyMargin(data, market) {
                    const innerData = this.safeValue(data, 'data', []);
                    const entry = this.safeValue(innerData, 0, {});
                    const errorCode = this.safeString(data, 'code');
                    const status = errorCode === '0' ? 'ok' : 'failed';
                    const amountRaw = this.safeNumber(entry, 'amt');
                    const typeRaw = this.safeString(entry, 'type');
                    const type = typeRaw === 'reduce' ? 'reduce' : 'add';
                    const marketId = this.safeString(entry, 'instId');
                    const responseMarket = this.safeMarket(marketId, market);
                    const code = responseMarket['inverse'] ? responseMarket['base'] : responseMarket['quote'];
                    return {
                        'info': data,
                        'type': type,
                        'amount': amountRaw,
                        'code': code,
                        'symbol': responseMarket['symbol'],
                        'status': status
                    };
                }
                async reduceMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 'reduce', params);
                }
                async addMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 'add', params);
                }
                async fetchMarketLeverageTiers(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const type = market['spot'] ? 'MARGIN' : this.convertToInstrumentType(market['type']);
                    const uly = this.safeString(market['info'], 'uly');
                    if (!uly) throw new BadRequest(this.id + ' fetchLeverageTiers() cannot fetch leverage tiers for ' + symbol);
                    const request = {
                        'instType': type,
                        'tdMode': this.safeString(params, 'tdMode', 'isolated'),
                        'uly': uly
                    };
                    if (type === 'MARGIN') request['instId'] = market['id'];
                    const response = await this.publicGetPublicPositionTiers(this.extend(request, params));
                    //
                    //    {
                    //        "code": "0",
                    //        "data": [
                    //            {
                    //                "baseMaxLoan": "500",
                    //                "imr": "0.1",
                    //                "instId": "ETH-USDT",
                    //                "maxLever": "10",
                    //                "maxSz": "500",
                    //                "minSz": "0",
                    //                "mmr": "0.03",
                    //                "optMgnFactor": "0",
                    //                "quoteMaxLoan": "200000",
                    //                "tier": "1",
                    //                "uly": ""
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseMarketLeverageTiers(data, market);
                }
                parseMarketLeverageTiers(info, market) {
                    /**
         * @ignore
         * @method
         * @param {dict} info Exchange response for 1 market
         * @param {dict} market CCXT market
         */ //
                    //    [
                    //        {
                    //            "baseMaxLoan": "500",
                    //            "imr": "0.1",
                    //            "instId": "ETH-USDT",
                    //            "maxLever": "10",
                    //            "maxSz": "500",
                    //            "minSz": "0",
                    //            "mmr": "0.03",
                    //            "optMgnFactor": "0",
                    //            "quoteMaxLoan": "200000",
                    //            "tier": "1",
                    //            "uly": ""
                    //        },
                    //        ...
                    //    ]
                    //
                    const tiers = [];
                    for(let i = 0; i < info.length; i++){
                        const tier = info[i];
                        tiers.push({
                            'tier': this.safeInteger(tier, 'tier'),
                            'currency': market['quote'],
                            'minNotional': this.safeNumber(tier, 'minSz'),
                            'maxNotional': this.safeNumber(tier, 'maxSz'),
                            'maintenanceMarginRate': this.safeNumber(tier, 'mmr'),
                            'maxLeverage': this.safeNumber(tier, 'maxLever'),
                            'info': tier
                        });
                    }
                    return tiers;
                }
                async fetchBorrowInterest(code, symbol, since, limit, params = {}) {
                    /**
         * @method
         * @name okx#fetchBorrowInterest
         * @description Obtain the amount of interest that has accrued for margin trading
         * @param {str} code The unified currency code for the currency of the interest
         * @param {str} symbol The market symbol of an isolated margin market, if undefined, the interest for cross margin markets is returned
         * @param {int} since Timestamp in ms of the earliest time to receive interest records for
         * @param {int} limit The number of [borrow interest structures]{@link https://docs.ccxt.com/en/latest/manual.html#borrow-interest-structure} to retrieve
         * @param {dict} params Exchange specific parameters
         * @param {int} params.type Loan type 1 - VIP loans 2 - Market loans *Default is Market loans*
         * @returns An array of [borrow interest structures]{@link https://docs.ccxt.com/en/latest/manual.html#borrow-interest-structure}
         */ await this.loadMarkets();
                    const request = {
                        'mgnMode': symbol !== undefined ? 'isolated' : 'cross'
                    };
                    let market = undefined;
                    if (code !== undefined) {
                        const currency = this.currency(code);
                        request['ccy'] = currency['id'];
                    }
                    if (since !== undefined) request['before'] = since - 1;
                    if (limit !== undefined) request['limit'] = limit;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['instId'] = market['id'];
                    }
                    const response = await this.privateGetAccountInterestAccrued(this.extend(request, params));
                    //
                    //    {
                    //        "code": "0",
                    //        "data": [
                    //            {
                    //                "ccy": "USDT",
                    //                "instId": "",
                    //                "interest": "0.0003960833333334",
                    //                "interestRate": "0.0000040833333333",
                    //                "liab": "97",
                    //                "mgnMode": "",
                    //                "ts": "1637312400000",
                    //                "type": "1"
                    //            },
                    //            ...
                    //        ],
                    //        "msg": ""
                    //    }
                    //
                    const data = this.safeValue(response, 'data');
                    const interest = this.parseBorrowInterests(data);
                    return this.filterByCurrencySinceLimit(interest, code, since, limit);
                }
                parseBorrowInterest(info, market) {
                    const instId = this.safeString(info, 'instId');
                    let account = 'cross'; // todo rename it to margin/marginMode and separate it from the symbol
                    if (instId !== undefined) {
                        market = this.safeMarket(instId, market);
                        account = this.safeString(market, 'symbol');
                    }
                    const timestamp = this.safeNumber(info, 'ts');
                    const marginMode = instId === undefined ? 'cross' : 'isolated';
                    return {
                        'account': account,
                        'symbol': this.safeString(market, 'symbol'),
                        'marginType': marginMode,
                        'marginMode': marginMode,
                        'currency': this.safeCurrencyCode(this.safeString(info, 'ccy')),
                        'interest': this.safeNumber(info, 'interest'),
                        'interestRate': this.safeNumber(info, 'interestRate'),
                        'amountBorrowed': this.safeNumber(info, 'liab'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'info': info
                    };
                }
                setSandboxMode(enable) {
                    super.setSandboxMode(enable);
                    if (enable) this.headers['x-simulated-trading'] = '1';
                    else if ('x-simulated-trading' in this.headers) this.headers = this.omit(this.headers, 'x-simulated-trading');
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (!response) return; // fallback to default error handler
                    //
                    //    {
                    //        "code": "1",
                    //        "data": [
                    //            {
                    //                "clOrdId": "",
                    //                "ordId": "",
                    //                "sCode": "51119",
                    //                "sMsg": "Order placement failed due to insufficient balance. ",
                    //                "tag": ""
                    //            }
                    //        ],
                    //        "msg": ""
                    //    },
                    //    {
                    //        "code": "58001",
                    //        "data": [],
                    //        "msg": "Incorrect trade password"
                    //    }
                    //
                    const code = this.safeString(response, 'code');
                    if (code !== '0') {
                        const feedback = this.id + ' ' + body;
                        const data = this.safeValue(response, 'data', []);
                        for(let i = 0; i < data.length; i++){
                            const error = data[i];
                            const errorCode = this.safeString(error, 'sCode');
                            const message = this.safeString(error, 'sMsg');
                            this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        }
                        this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    114: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1 } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class paymium extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'paymium',
                        'name': 'Paymium',
                        'countries': [
                            'FR',
                            'EU'
                        ],
                        'rateLimit': 2000,
                        'version': 'v1',
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkOHLCV': false,
                            'fetchOrderBook': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'transfer': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87153930-f0f02200-c2c0-11ea-9c0a-40337375ae89.jpg',
                            'api': 'https://paymium.com/api',
                            'www': 'https://www.paymium.com',
                            'fees': 'https://www.paymium.com/page/help/fees',
                            'doc': [
                                'https://github.com/Paymium/api-documentation',
                                'https://www.paymium.com/page/developers',
                                'https://paymium.github.io/api-documentation/'
                            ],
                            'referral': 'https://www.paymium.com/page/sign-up?referral=eDAzPoRQFMvaAB8sf-qj'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'countries',
                                    'data/{currency}/ticker',
                                    'data/{currency}/trades',
                                    'data/{currency}/depth',
                                    'bitcoin_charts/{id}/trades',
                                    'bitcoin_charts/{id}/depth'
                                ]
                            },
                            'private': {
                                'get': [
                                    'user',
                                    'user/addresses',
                                    'user/addresses/{address}',
                                    'user/orders',
                                    'user/orders/{uuid}',
                                    'user/price_alerts',
                                    'merchant/get_payment/{uuid}'
                                ],
                                'post': [
                                    'user/addresses',
                                    'user/orders',
                                    'user/withdrawals',
                                    'user/email_transfers',
                                    'user/payment_requests',
                                    'user/price_alerts',
                                    'merchant/create_payment'
                                ],
                                'delete': [
                                    'user/orders/{uuid}',
                                    'user/orders/{uuid}/cancel',
                                    'user/price_alerts/{id}'
                                ]
                            }
                        },
                        'markets': {
                            'BTC/EUR': {
                                'id': 'eur',
                                'symbol': 'BTC/EUR',
                                'base': 'BTC',
                                'quote': 'EUR',
                                'baseId': 'btc',
                                'quoteId': 'eur',
                                'type': 'spot',
                                'spot': true
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('-0.001'),
                                'taker': this.parseNumber('0.005')
                            }
                        }
                    });
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const currencies = Object.keys(this.currencies);
                    for(let i = 0; i < currencies.length; i++){
                        const code = currencies[i];
                        const currency = this.currency(code);
                        const currencyId = currency['id'];
                        const free = 'balance_' + currencyId;
                        if (free in response) {
                            const account = this.account();
                            const used = 'locked_' + currencyId;
                            account['free'] = this.safeString(response, free);
                            account['used'] = this.safeString(response, used);
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetUser(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'currency': this.marketId(symbol)
                    };
                    const response = await this.publicGetDataCurrencyDepth(this.extend(request, params));
                    return this.parseOrderBook(response, symbol, undefined, 'bids', 'asks', 'price', 'amount');
                }
                parseTicker(ticker, market) {
                    //
                    // {
                    //     "high":"33740.82",
                    //     "low":"32185.15",
                    //     "volume":"4.7890433",
                    //     "bid":"33313.53",
                    //     "ask":"33497.97",
                    //     "midpoint":"33405.75",
                    //     "vwap":"32802.5263553",
                    //     "at":1643381654,
                    //     "price":"33143.91",
                    //     "open":"33116.86",
                    //     "variation":"0.0817",
                    //     "currency":"EUR",
                    //     "trade_id":"ce2f5152-3ac5-412d-9b24-9fa72338474c",
                    //     "size":"0.00041087"
                    // }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.safeTimestamp(ticker, 'at');
                    const vwap = this.safeString(ticker, 'vwap');
                    const baseVolume = this.safeString(ticker, 'volume');
                    const quoteVolume = Precise.stringMul(baseVolume, vwap);
                    const last = this.safeString(ticker, 'price');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': vwap,
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': this.safeString(ticker, 'variation'),
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['id']
                    };
                    const ticker = await this.publicGetDataCurrencyTicker(this.extend(request, params));
                    //
                    // {
                    //     "high":"33740.82",
                    //     "low":"32185.15",
                    //     "volume":"4.7890433",
                    //     "bid":"33313.53",
                    //     "ask":"33497.97",
                    //     "midpoint":"33405.75",
                    //     "vwap":"32802.5263553",
                    //     "at":1643381654,
                    //     "price":"33143.91",
                    //     "open":"33116.86",
                    //     "variation":"0.0817",
                    //     "currency":"EUR",
                    //     "trade_id":"ce2f5152-3ac5-412d-9b24-9fa72338474c",
                    //     "size":"0.00041087"
                    // }
                    //
                    return this.parseTicker(ticker, market);
                }
                parseTrade(trade, market) {
                    const timestamp = this.safeTimestamp(trade, 'created_at_int');
                    const id = this.safeString(trade, 'uuid');
                    market = this.safeMarket(undefined, market);
                    const side = this.safeString(trade, 'side');
                    const price = this.safeString(trade, 'price');
                    const amountField = 'traded_' + market['base'].toLowerCase();
                    const amount = this.safeString(trade, amountField);
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currency': market['id']
                    };
                    const response = await this.publicGetDataCurrencyTrades(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostUserAddresses(params);
                    //
                    //     {
                    //         "address": "1HdjGr6WCTcnmW1tNNsHX7fh4Jr5C2PeKe",
                    //         "valid_until": 1620041926,
                    //         "currency": "BTC",
                    //         "label": "Savings"
                    //     }
                    //
                    return this.parseDepositAddress(response);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'address': code
                    };
                    const response = await this.privateGetUserAddressesAddress(this.extend(request, params));
                    //
                    //     {
                    //         "address": "1HdjGr6WCTcnmW1tNNsHX7fh4Jr5C2PeKe",
                    //         "valid_until": 1620041926,
                    //         "currency": "BTC",
                    //         "label": "Savings"
                    //     }
                    //
                    return this.parseDepositAddress(response);
                }
                async fetchDepositAddresses(codes, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetUserAddresses(params);
                    //
                    //     [
                    //         {
                    //             "address": "1HdjGr6WCTcnmW1tNNsHX7fh4Jr5C2PeKe",
                    //             "valid_until": 1620041926,
                    //             "currency": "BTC",
                    //             "label": "Savings"
                    //         }
                    //     ]
                    //
                    return this.parseDepositAddresses(response, codes);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         "address": "1HdjGr6WCTcnmW1tNNsHX7fh4Jr5C2PeKe",
                    //         "valid_until": 1620041926,
                    //         "currency": "BTC",
                    //         "label": "Savings"
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'address');
                    const currencyId = this.safeString(depositAddress, 'currency');
                    return {
                        'info': depositAddress,
                        'currency': this.safeCurrencyCode(currencyId, currency),
                        'address': address,
                        'tag': undefined,
                        'network': undefined
                    };
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'type': this.capitalize(type) + 'Order',
                        'currency': this.marketId(symbol),
                        'direction': side,
                        'amount': amount
                    };
                    if (type !== 'market') request['price'] = price;
                    const response = await this.privatePostUserOrders(this.extend(request, params));
                    return {
                        'info': response,
                        'id': response['uuid']
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'uuid': id
                    };
                    return await this.privateDeleteUserOrdersUuidCancel(this.extend(request, params));
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (toAccount.indexOf('@') < 0) throw new ExchangeError1(this.id + ' transfer() only allows transfers to an email address');
                    if (code !== 'BTC' && code !== 'EUR') throw new ExchangeError1(this.id + ' transfer() only allows BTC or EUR');
                    const request = {
                        'currency': currency['id'],
                        'amount': this.currencyToPrecision(code, amount),
                        'email': toAccount
                    };
                    const response = await this.privatePostUserEmailTransfers(this.extend(request, params));
                    //
                    //     {
                    //         "uuid": "968f4580-e26c-4ad8-8bcd-874d23d55296",
                    //         "type": "Transfer",
                    //         "currency": "BTC",
                    //         "currency_amount": "string",
                    //         "created_at": "2013-10-24T10:34:37.000Z",
                    //         "updated_at": "2013-10-24T10:34:37.000Z",
                    //         "amount": "1.0",
                    //         "state": "executed",
                    //         "currency_fee": "0.0",
                    //         "btc_fee": "0.0",
                    //         "comment": "string",
                    //         "traded_btc": "string",
                    //         "traded_currency": "string",
                    //         "direction": "buy",
                    //         "price": "string",
                    //         "account_operations": [
                    //             {
                    //                 "uuid": "968f4580-e26c-4ad8-8bcd-874d23d55296",
                    //                 "amount": "1.0",
                    //                 "currency": "BTC",
                    //                 "created_at": "2013-10-24T10:34:37.000Z",
                    //                 "created_at_int": 1389094259,
                    //                 "name": "account_operation",
                    //                 "address": "1FPDBXNqSkZMsw1kSkkajcj8berxDQkUoc",
                    //                 "tx_hash": "string",
                    //                 "is_trading_account": true
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseTransfer(response, currency);
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //         "uuid": "968f4580-e26c-4ad8-8bcd-874d23d55296",
                    //         "type": "Transfer",
                    //         "currency": "BTC",
                    //         "currency_amount": "string",
                    //         "created_at": "2013-10-24T10:34:37.000Z",
                    //         "updated_at": "2013-10-24T10:34:37.000Z",
                    //         "amount": "1.0",
                    //         "state": "executed",
                    //         "currency_fee": "0.0",
                    //         "btc_fee": "0.0",
                    //         "comment": "string",
                    //         "traded_btc": "string",
                    //         "traded_currency": "string",
                    //         "direction": "buy",
                    //         "price": "string",
                    //         "account_operations": [
                    //             {
                    //                 "uuid": "968f4580-e26c-4ad8-8bcd-874d23d55296",
                    //                 "amount": "1.0",
                    //                 "currency": "BTC",
                    //                 "created_at": "2013-10-24T10:34:37.000Z",
                    //                 "created_at_int": 1389094259,
                    //                 "name": "account_operation",
                    //                 "address": "1FPDBXNqSkZMsw1kSkkajcj8berxDQkUoc",
                    //                 "tx_hash": "string",
                    //                 "is_trading_account": true
                    //             }
                    //         ]
                    //     }
                    //
                    const currencyId = this.safeString(transfer, 'currency');
                    const updatedAt = this.safeString(transfer, 'updated_at');
                    const timetstamp = this.parseDate(updatedAt);
                    const accountOperations = this.safeValue(transfer, 'account_operations');
                    const firstOperation = this.safeValue(accountOperations, 0, {});
                    const status = this.safeString(transfer, 'state');
                    return {
                        'info': transfer,
                        'id': this.safeString(transfer, 'uuid'),
                        'timestamp': timetstamp,
                        'datetime': this.iso8601(timetstamp),
                        'currency': this.safeCurrencyCode(currencyId, currency),
                        'amount': this.safeNumber(transfer, 'amount'),
                        'fromAccount': undefined,
                        'toAccount': this.safeString(firstOperation, 'address'),
                        'status': this.parseTransferStatus(status)
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'executed': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        let auth = nonce + url;
                        headers = {
                            'Api-Key': this.apiKey,
                            'Api-Nonce': nonce
                        };
                        if (method === 'POST') {
                            if (Object.keys(query).length) {
                                body = this.json(query);
                                auth += body;
                                headers['Content-Type'] = 'application/json';
                            }
                        } else if (Object.keys(query).length) {
                            const queryString = this.urlencode(query);
                            auth += queryString;
                            url += '?' + queryString;
                        }
                        headers['Api-Signature'] = this.hmac(this.encode(auth), this.encode(this.secret));
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    const errors = this.safeValue(response, 'errors');
                    if (errors !== undefined) throw new ExchangeError1(this.id + ' ' + this.json(response));
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    115: [
        function(require1, module, exports) {
            'use strict';
            // ----------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, BadSymbol: BadSymbol, AuthenticationError: AuthenticationError, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, ArgumentsRequired: ArgumentsRequired1, OrderNotFound: OrderNotFound, BadRequest: BadRequest, PermissionDenied: PermissionDenied, AccountSuspended: AccountSuspended, CancelPending: CancelPending, DDoSProtection: DDoSProtection, DuplicateOrderId: DuplicateOrderId, RateLimitExceeded: RateLimitExceeded } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            // ----------------------------------------------------------------------------
            module.exports = class phemex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'phemex',
                        'name': 'Phemex',
                        'countries': [
                            'CN'
                        ],
                        'rateLimit': 100,
                        'version': 'v1',
                        'certified': false,
                        'pro': true,
                        'hostname': 'api.phemex.com',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': true,
                            'future': false,
                            'option': false,
                            'addMargin': true,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': true,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistories': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPositions': true,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchWithdrawals': true,
                            'reduceMargin': true,
                            'setLeverage': true,
                            'setMarginMode': true,
                            'setPositionMode': false,
                            'transfer': true,
                            'withdraw': undefined
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/85225056-221eb600-b3d7-11ea-930d-564d2690e3f6.jpg',
                            'test': {
                                'v1': 'https://testnet-api.phemex.com/v1',
                                'public': 'https://testnet-api.phemex.com/exchange/public',
                                'private': 'https://testnet-api.phemex.com'
                            },
                            'api': {
                                'v1': 'https://{hostname}/v1',
                                'public': 'https://{hostname}/exchange/public',
                                'private': 'https://{hostname}'
                            },
                            'www': 'https://phemex.com',
                            'doc': 'https://github.com/phemex/phemex-api-docs',
                            'fees': 'https://phemex.com/fees-conditions',
                            'referral': {
                                'url': 'https://phemex.com/register?referralCode=EDNVJ',
                                'discount': 0.1
                            }
                        },
                        'timeframes': {
                            '1m': '60',
                            '3m': '180',
                            '5m': '300',
                            '15m': '900',
                            '30m': '1800',
                            '1h': '3600',
                            '2h': '7200',
                            '3h': '10800',
                            '4h': '14400',
                            '6h': '21600',
                            '12h': '43200',
                            '1d': '86400',
                            '1w': '604800',
                            '1M': '2592000'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'cfg/v2/products',
                                    'cfg/fundingRates',
                                    'products',
                                    'nomics/trades',
                                    'md/kline'
                                ]
                            },
                            'v1': {
                                'get': [
                                    'md/orderbook',
                                    'md/trade',
                                    'md/ticker/24hr',
                                    'md/ticker/24hr/all',
                                    'md/spot/ticker/24hr',
                                    'md/spot/ticker/24hr/all',
                                    'exchange/public/products'
                                ]
                            },
                            'private': {
                                'get': [
                                    // spot
                                    'spot/orders/active',
                                    // 'spot/orders/active', // ?symbol=<symbol>&clOrDID=<clOrdID>
                                    'spot/orders',
                                    'spot/wallets',
                                    'exchange/spot/order',
                                    'exchange/spot/order/trades',
                                    // swap
                                    'accounts/accountPositions',
                                    'accounts/positions',
                                    'api-data/futures/funding-fees',
                                    'orders/activeList',
                                    'exchange/order/list',
                                    'exchange/order',
                                    // 'exchange/order', // ?symbol=<symbol>&clOrdID=<clOrdID1,clOrdID2>
                                    'exchange/order/trade',
                                    'phemex-user/users/children',
                                    'phemex-user/wallets/v2/depositAddress',
                                    'phemex-user/wallets/tradeAccountDetail',
                                    'phemex-user/order/closedPositionList',
                                    'exchange/margins/transfer',
                                    'exchange/wallets/confirm/withdraw',
                                    'exchange/wallets/withdrawList',
                                    'exchange/wallets/depositList',
                                    'exchange/wallets/v2/depositAddress',
                                    'api-data/spots/funds',
                                    'assets/convert',
                                    // transfer
                                    'assets/transfer',
                                    'assets/spots/sub-accounts/transfer',
                                    'assets/futures/sub-accounts/transfer',
                                    'assets/quote',
                                    'assets/convert'
                                ],
                                'post': [
                                    // spot
                                    'spot/orders',
                                    // swap
                                    'orders',
                                    'positions/assign',
                                    'exchange/wallets/transferOut',
                                    'exchange/wallets/transferIn',
                                    'exchange/margins',
                                    'exchange/wallets/createWithdraw',
                                    'exchange/wallets/cancelWithdraw',
                                    'exchange/wallets/createWithdrawAddress',
                                    // transfer
                                    'assets/transfer',
                                    'assets/spots/sub-accounts/transfer',
                                    'assets/futures/sub-accounts/transfer',
                                    'assets/universal-transfer',
                                    'assets/convert'
                                ],
                                'put': [
                                    // spot
                                    'spot/orders',
                                    // swap
                                    'orders/replace',
                                    'positions/leverage',
                                    'positions/riskLimit'
                                ],
                                'delete': [
                                    // spot
                                    'spot/orders',
                                    'spot/orders/all',
                                    // 'spot/orders', // ?symbol=<symbol>&clOrdID=<clOrdID>
                                    // swap
                                    'orders/cancel',
                                    'orders',
                                    'orders/all'
                                ]
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'taker': this.parseNumber('0.001'),
                                'maker': this.parseNumber('0.001')
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true
                        },
                        'exceptions': {
                            'exact': {
                                // not documented
                                '412': BadRequest,
                                '6001': BadRequest,
                                // documented
                                '19999': BadRequest,
                                '10001': DuplicateOrderId,
                                '10002': OrderNotFound,
                                '10003': CancelPending,
                                '10004': CancelPending,
                                '10005': CancelPending,
                                '11001': InsufficientFunds,
                                '11002': InvalidOrder,
                                '11003': InsufficientFunds,
                                '11004': InvalidOrder,
                                '11005': InsufficientFunds,
                                '11006': ExchangeError1,
                                '11007': ExchangeError1,
                                '11008': ExchangeError1,
                                '11009': ExchangeError1,
                                '11010': InsufficientFunds,
                                '11011': InvalidOrder,
                                '11012': InvalidOrder,
                                '11013': InvalidOrder,
                                '11014': InvalidOrder,
                                '11015': InvalidOrder,
                                '11016': BadRequest,
                                '11017': ExchangeError1,
                                '11018': ExchangeError1,
                                '11019': ExchangeError1,
                                '11020': ExchangeError1,
                                '11021': ExchangeError1,
                                '11022': AccountSuspended,
                                '11023': ExchangeError1,
                                '11024': ExchangeError1,
                                '11025': BadRequest,
                                '11026': ExchangeError1,
                                '11027': BadSymbol,
                                '11028': BadSymbol,
                                '11029': ExchangeError1,
                                '11030': ExchangeError1,
                                '11031': DDoSProtection,
                                '11032': DDoSProtection,
                                '11033': DuplicateOrderId,
                                '11034': InvalidOrder,
                                '11035': InvalidOrder,
                                '11036': InvalidOrder,
                                '11037': InvalidOrder,
                                '11038': InvalidOrder,
                                '11039': InvalidOrder,
                                '11040': InvalidOrder,
                                '11041': InvalidOrder,
                                '11042': InvalidOrder,
                                '11043': InvalidOrder,
                                '11044': InvalidOrder,
                                '11045': InvalidOrder,
                                '11046': InvalidOrder,
                                '11047': InvalidOrder,
                                '11048': InvalidOrder,
                                '11049': InvalidOrder,
                                '11050': InvalidOrder,
                                '11051': InvalidOrder,
                                '11052': InvalidOrder,
                                '11053': InvalidOrder,
                                '11054': InvalidOrder,
                                '11055': InvalidOrder,
                                '11056': InvalidOrder,
                                '11057': InvalidOrder,
                                '11058': InvalidOrder,
                                '11059': InvalidOrder,
                                '11060': InvalidOrder,
                                '11061': CancelPending,
                                '11062': InvalidOrder,
                                '11063': InvalidOrder,
                                '11064': InvalidOrder,
                                '11065': InvalidOrder,
                                '11066': InvalidOrder,
                                '11067': InvalidOrder,
                                '11068': InvalidOrder,
                                '11069': ExchangeError1,
                                '11070': BadSymbol,
                                '11071': InvalidOrder,
                                '11072': InvalidOrder,
                                '11073': InvalidOrder,
                                '11074': InvalidOrder,
                                '11075': InvalidOrder,
                                '11076': InvalidOrder,
                                '11077': InvalidOrder,
                                '11078': InvalidOrder,
                                '11079': InvalidOrder,
                                '11080': InvalidOrder,
                                '11081': InvalidOrder,
                                '11082': InsufficientFunds,
                                '11083': InvalidOrder,
                                '11084': InvalidOrder,
                                '11085': DuplicateOrderId,
                                '11086': InvalidOrder,
                                '11087': InvalidOrder,
                                '11088': InvalidOrder,
                                '11089': InvalidOrder,
                                '11090': InvalidOrder,
                                '11091': InvalidOrder,
                                '11092': InvalidOrder,
                                '11093': InvalidOrder,
                                '11094': InvalidOrder,
                                '11095': InvalidOrder,
                                '11096': InvalidOrder,
                                '11097': BadRequest,
                                '11098': BadRequest,
                                '11099': ExchangeError1,
                                '11100': InsufficientFunds,
                                '11101': InsufficientFunds,
                                '11102': BadRequest,
                                '11103': BadRequest,
                                '11104': BadRequest,
                                '11105': InsufficientFunds,
                                '11106': InsufficientFunds,
                                '11107': ExchangeError1,
                                '11108': InvalidOrder,
                                '11109': InvalidOrder,
                                '11110': InvalidOrder,
                                '11111': InvalidOrder,
                                '11112': InvalidOrder,
                                '11113': BadRequest,
                                '11114': InvalidOrder,
                                '11115': InvalidOrder,
                                '11116': InvalidOrder,
                                '11117': InvalidOrder,
                                '11118': InvalidOrder,
                                '11119': InvalidOrder,
                                '11120': InvalidOrder,
                                '11121': InvalidOrder,
                                '11122': InvalidOrder,
                                '11123': InvalidOrder,
                                '11124': InvalidOrder,
                                '11125': InvalidOrder,
                                '11126': InvalidOrder,
                                '11128': InvalidOrder,
                                '11129': InvalidOrder,
                                '11130': InvalidOrder,
                                '11131': InvalidOrder,
                                '11132': InvalidOrder,
                                '11133': InvalidOrder,
                                '11134': InvalidOrder,
                                // not documented
                                '30000': BadRequest,
                                '30018': BadRequest,
                                '34003': PermissionDenied,
                                '35104': InsufficientFunds,
                                '39995': RateLimitExceeded,
                                '39996': PermissionDenied
                            },
                            'broad': {
                                '401 Insufficient privilege': PermissionDenied,
                                '401 Request IP mismatch': PermissionDenied,
                                'Failed to find api-key': AuthenticationError,
                                'Missing required parameter': BadRequest,
                                'API Signature verification failed': AuthenticationError,
                                'Api key not found': AuthenticationError
                            }
                        },
                        'options': {
                            'brokerId': 'ccxt2022',
                            'x-phemex-request-expiry': 60,
                            'createOrderByQuoteRequiresPrice': true,
                            'networks': {
                                'TRC20': 'TRX',
                                'ERC20': 'ETH'
                            },
                            'defaultNetworks': {
                                'USDT': 'ETH'
                            },
                            'defaultSubType': 'linear',
                            'accountsByType': {
                                'spot': 'spot',
                                'future': 'future'
                            },
                            'transfer': {
                                'fillResponseFromRequest': true
                            }
                        }
                    });
                }
                parseSafeNumber(value) {
                    if (value === undefined) return value;
                    let parts = value.split(',');
                    value = parts.join('');
                    parts = value.split(' ');
                    return this.safeNumber(parts, 0);
                }
                parseSwapMarket(market) {
                    //
                    //     {
                    //         "symbol":"BTCUSD",
                    //         "displaySymbol":"BTC / USD",
                    //         "indexSymbol":".BTC",
                    //         "markSymbol":".MBTC",
                    //         "fundingRateSymbol":".BTCFR",
                    //         "fundingRate8hSymbol":".BTCFR8H",
                    //         "contractUnderlyingAssets":"USD",
                    //         "settleCurrency":"BTC",
                    //         "quoteCurrency":"USD",
                    //         "contractSize":"1 USD",
                    //         "lotSize":1,
                    //         "tickSize":0.5,
                    //         "priceScale":4,
                    //         "ratioScale":8,
                    //         "pricePrecision":1,
                    //         "minPriceEp":5000,
                    //         "maxPriceEp":10000000000,
                    //         "maxOrderQty":1000000,
                    //         "type":"Perpetual",
                    //         "status":"Listed",
                    //         "tipOrderQty":1000000,
                    //         "steps":"50",
                    //         "riskLimits":[
                    //             {"limit":100,"initialMargin":"1.0%","initialMarginEr":1000000,"maintenanceMargin":"0.5%","maintenanceMarginEr":500000},
                    //             {"limit":150,"initialMargin":"1.5%","initialMarginEr":1500000,"maintenanceMargin":"1.0%","maintenanceMarginEr":1000000},
                    //             {"limit":200,"initialMargin":"2.0%","initialMarginEr":2000000,"maintenanceMargin":"1.5%","maintenanceMarginEr":1500000},
                    //         ],
                    //         "underlyingSymbol":".BTC",
                    //         "baseCurrency":"BTC",
                    //         "settlementCurrency":"BTC",
                    //         "valueScale":8,
                    //         "defaultLeverage":0,
                    //         "maxLeverage":100,
                    //         "initMarginEr":"1000000",
                    //         "maintMarginEr":"500000",
                    //         "defaultRiskLimitEv":10000000000,
                    //         "deleverage":true,
                    //         "makerFeeRateEr":-250000,
                    //         "takerFeeRateEr":750000,
                    //         "fundingInterval":8,
                    //         "marketUrl":"https://phemex.com/trade/BTCUSD",
                    //         "description":"BTCUSD is a BTC/USD perpetual contract priced on the .BTC Index. Each contract is worth 1 USD of Bitcoin. Funding is paid and received every 8 hours. At UTC time: 00:00, 08:00, 16:00.",
                    //     }
                    //
                    const id = this.safeString(market, 'symbol');
                    const baseId = this.safeString2(market, 'baseCurrency', 'contractUnderlyingAssets');
                    const quoteId = this.safeString(market, 'quoteCurrency');
                    const settleId = this.safeString(market, 'settleCurrency');
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    const settle = this.safeCurrencyCode(settleId);
                    let inverse = false;
                    if (settleId !== quoteId) inverse = true;
                    const priceScale = this.safeInteger(market, 'priceScale');
                    const ratioScale = this.safeInteger(market, 'ratioScale');
                    const valueScale = this.safeInteger(market, 'valueScale');
                    const minPriceEp = this.safeString(market, 'minPriceEp');
                    const maxPriceEp = this.safeString(market, 'maxPriceEp');
                    const makerFeeRateEr = this.safeString(market, 'makerFeeRateEr');
                    const takerFeeRateEr = this.safeString(market, 'takerFeeRateEr');
                    const status = this.safeString(market, 'status');
                    const contractSizeString = this.safeString(market, 'contractSize', ' ');
                    let contractSize = undefined;
                    if (contractSizeString.indexOf(' ')) {
                        // "1 USD"
                        // "0.005 ETH"
                        const parts = contractSizeString.split(' ');
                        contractSize = this.parseNumber(parts[0]);
                    } else // "1.0"
                    contractSize = this.parseNumber(contractSizeString);
                    return {
                        'id': id,
                        'symbol': base + '/' + quote + ':' + settle,
                        'base': base,
                        'quote': quote,
                        'settle': settle,
                        'baseId': baseId,
                        'quoteId': quoteId,
                        'settleId': settleId,
                        'type': 'swap',
                        'spot': false,
                        'margin': false,
                        'swap': true,
                        'future': false,
                        'option': false,
                        'active': status === 'Listed',
                        'contract': true,
                        'linear': !inverse,
                        'inverse': inverse,
                        'taker': this.parseNumber(this.fromEn(takerFeeRateEr, ratioScale)),
                        'maker': this.parseNumber(this.fromEn(makerFeeRateEr, ratioScale)),
                        'contractSize': contractSize,
                        'expiry': undefined,
                        'expiryDatetime': undefined,
                        'strike': undefined,
                        'optionType': undefined,
                        'priceScale': priceScale,
                        'valueScale': valueScale,
                        'ratioScale': ratioScale,
                        'precision': {
                            'amount': this.safeNumber(market, 'lotSize'),
                            'price': this.safeNumber(market, 'tickSize')
                        },
                        'limits': {
                            'leverage': {
                                'min': this.parseNumber('1'),
                                'max': this.safeNumber(market, 'maxLeverage')
                            },
                            'amount': {
                                'min': undefined,
                                'max': undefined
                            },
                            'price': {
                                'min': this.parseNumber(this.fromEn(minPriceEp, priceScale)),
                                'max': this.parseNumber(this.fromEn(maxPriceEp, priceScale))
                            },
                            'cost': {
                                'min': undefined,
                                'max': this.parseNumber(this.safeString(market, 'maxOrderQty'))
                            }
                        },
                        'info': market
                    };
                }
                parseSpotMarket(market) {
                    //
                    //     {
                    //         "symbol":"sBTCUSDT",
                    //         "displaySymbol":"BTC / USDT",
                    //         "quoteCurrency":"USDT",
                    //         "pricePrecision":2,
                    //         "type":"Spot",
                    //         "baseCurrency":"BTC",
                    //         "baseTickSize":"0.000001 BTC",
                    //         "baseTickSizeEv":100,
                    //         "quoteTickSize":"0.01 USDT",
                    //         "quoteTickSizeEv":1000000,
                    //         "minOrderValue":"10 USDT",
                    //         "minOrderValueEv":1000000000,
                    //         "maxBaseOrderSize":"1000 BTC",
                    //         "maxBaseOrderSizeEv":100000000000,
                    //         "maxOrderValue":"5,000,000 USDT",
                    //         "maxOrderValueEv":500000000000000,
                    //         "defaultTakerFee":"0.001",
                    //         "defaultTakerFeeEr":100000,
                    //         "defaultMakerFee":"0.001",
                    //         "defaultMakerFeeEr":100000,
                    //         "baseQtyPrecision":6,
                    //         "quoteQtyPrecision":2,
                    //         "status":"Listed",
                    //         "tipOrderQty":20
                    //     }
                    //
                    const type = this.safeStringLower(market, 'type');
                    const id = this.safeString(market, 'symbol');
                    const quoteId = this.safeString(market, 'quoteCurrency');
                    const baseId = this.safeString(market, 'baseCurrency');
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    const status = this.safeString(market, 'status');
                    const precisionAmount = this.parseSafeNumber(this.safeString(market, 'baseTickSize'));
                    const precisionPrice = this.parseSafeNumber(this.safeString(market, 'quoteTickSize'));
                    return {
                        'id': id,
                        'symbol': base + '/' + quote,
                        'base': base,
                        'quote': quote,
                        'settle': undefined,
                        'baseId': baseId,
                        'quoteId': quoteId,
                        'settleId': undefined,
                        'type': type,
                        'spot': true,
                        'margin': false,
                        'swap': false,
                        'future': false,
                        'option': false,
                        'active': status === 'Listed',
                        'contract': false,
                        'linear': undefined,
                        'inverse': undefined,
                        'taker': this.safeNumber(market, 'defaultTakerFee'),
                        'maker': this.safeNumber(market, 'defaultMakerFee'),
                        'contractSize': undefined,
                        'expiry': undefined,
                        'expiryDatetime': undefined,
                        'strike': undefined,
                        'optionType': undefined,
                        'priceScale': 8,
                        'valueScale': 8,
                        'ratioScale': 8,
                        'precision': {
                            'amount': precisionAmount,
                            'price': precisionPrice
                        },
                        'limits': {
                            'leverage': {
                                'min': undefined,
                                'max': undefined
                            },
                            'amount': {
                                'min': precisionAmount,
                                'max': this.parseSafeNumber(this.safeString(market, 'maxBaseOrderSize'))
                            },
                            'price': {
                                'min': precisionPrice,
                                'max': undefined
                            },
                            'cost': {
                                'min': this.parseSafeNumber(this.safeString(market, 'minOrderValue')),
                                'max': this.parseSafeNumber(this.safeString(market, 'maxOrderValue'))
                            }
                        },
                        'info': market
                    };
                }
                async fetchMarkets(params = {}) {
                    const v2Products = await this.publicGetCfgV2Products(params);
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"OK",
                    //         "data":{
                    //             "ratioScale":8,
                    //             "currencies":[
                    //                 {"currency":"BTC","valueScale":8,"minValueEv":1,"maxValueEv":5000000000000000000,"name":"Bitcoin"},
                    //                 {"currency":"USD","valueScale":4,"minValueEv":1,"maxValueEv":500000000000000,"name":"USD"},
                    //                 {"currency":"USDT","valueScale":8,"minValueEv":1,"maxValueEv":5000000000000000000,"name":"TetherUS"},
                    //             ],
                    //             "products":[
                    //                 {
                    //                     "symbol":"BTCUSD",
                    //                     "displaySymbol":"BTC / USD",
                    //                     "indexSymbol":".BTC",
                    //                     "markSymbol":".MBTC",
                    //                     "fundingRateSymbol":".BTCFR",
                    //                     "fundingRate8hSymbol":".BTCFR8H",
                    //                     "contractUnderlyingAssets":"USD",
                    //                     "settleCurrency":"BTC",
                    //                     "quoteCurrency":"USD",
                    //                     "contractSize":1.0,
                    //                     "lotSize":1,
                    //                     "tickSize":0.5,
                    //                     "priceScale":4,
                    //                     "ratioScale":8,
                    //                     "pricePrecision":1,
                    //                     "minPriceEp":5000,
                    //                     "maxPriceEp":10000000000,
                    //                     "maxOrderQty":1000000,
                    //                     "type":"Perpetual"
                    //                 },
                    //                 {
                    //                     "symbol":"sBTCUSDT",
                    //                     "displaySymbol":"BTC / USDT",
                    //                     "quoteCurrency":"USDT",
                    //                     "pricePrecision":2,
                    //                     "type":"Spot",
                    //                     "baseCurrency":"BTC",
                    //                     "baseTickSize":"0.000001 BTC",
                    //                     "baseTickSizeEv":100,
                    //                     "quoteTickSize":"0.01 USDT",
                    //                     "quoteTickSizeEv":1000000,
                    //                     "minOrderValue":"10 USDT",
                    //                     "minOrderValueEv":1000000000,
                    //                     "maxBaseOrderSize":"1000 BTC",
                    //                     "maxBaseOrderSizeEv":100000000000,
                    //                     "maxOrderValue":"5,000,000 USDT",
                    //                     "maxOrderValueEv":500000000000000,
                    //                     "defaultTakerFee":"0.001",
                    //                     "defaultTakerFeeEr":100000,
                    //                     "defaultMakerFee":"0.001",
                    //                     "defaultMakerFeeEr":100000,
                    //                     "baseQtyPrecision":6,
                    //                     "quoteQtyPrecision":2
                    //                 },
                    //             ],
                    //             "riskLimits":[
                    //                 {
                    //                     "symbol":"BTCUSD",
                    //                     "steps":"50",
                    //                     "riskLimits":[
                    //                         {"limit":100,"initialMargin":"1.0%","initialMarginEr":1000000,"maintenanceMargin":"0.5%","maintenanceMarginEr":500000},
                    //                         {"limit":150,"initialMargin":"1.5%","initialMarginEr":1500000,"maintenanceMargin":"1.0%","maintenanceMarginEr":1000000},
                    //                         {"limit":200,"initialMargin":"2.0%","initialMarginEr":2000000,"maintenanceMargin":"1.5%","maintenanceMarginEr":1500000},
                    //                     ]
                    //                 },
                    //             ],
                    //             "leverages":[
                    //                 {"initialMargin":"1.0%","initialMarginEr":1000000,"options":[1,2,3,5,10,25,50,100]},
                    //                 {"initialMargin":"1.5%","initialMarginEr":1500000,"options":[1,2,3,5,10,25,50,66]},
                    //                 {"initialMargin":"2.0%","initialMarginEr":2000000,"options":[1,2,3,5,10,25,33,50]},
                    //             ]
                    //         }
                    //     }
                    //
                    const v1Products = await this.v1GetExchangePublicProducts(params);
                    const v1ProductsData = this.safeValue(v1Products, 'data', []);
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"OK",
                    //         "data":[
                    //             {
                    //                 "symbol":"BTCUSD",
                    //                 "underlyingSymbol":".BTC",
                    //                 "quoteCurrency":"USD",
                    //                 "baseCurrency":"BTC",
                    //                 "settlementCurrency":"BTC",
                    //                 "maxOrderQty":1000000,
                    //                 "maxPriceEp":100000000000000,
                    //                 "lotSize":1,
                    //                 "tickSize":"0.5",
                    //                 "contractSize":"1 USD",
                    //                 "priceScale":4,
                    //                 "ratioScale":8,
                    //                 "valueScale":8,
                    //                 "defaultLeverage":0,
                    //                 "maxLeverage":100,
                    //                 "initMarginEr":"1000000",
                    //                 "maintMarginEr":"500000",
                    //                 "defaultRiskLimitEv":10000000000,
                    //                 "deleverage":true,
                    //                 "makerFeeRateEr":-250000,
                    //                 "takerFeeRateEr":750000,
                    //                 "fundingInterval":8,
                    //                 "marketUrl":"https://phemex.com/trade/BTCUSD",
                    //                 "description":"BTCUSD is a BTC/USD perpetual contract priced on the .BTC Index. Each contract is worth 1 USD of Bitcoin. Funding is paid and received every 8 hours. At UTC time: 00:00, 08:00, 16:00.",
                    //                 "type":"Perpetual"
                    //             },
                    //         ]
                    //     }
                    //
                    const v2ProductsData = this.safeValue(v2Products, 'data', {});
                    const products = this.safeValue(v2ProductsData, 'products', []);
                    const riskLimits = this.safeValue(v2ProductsData, 'riskLimits', []);
                    const riskLimitsById = this.indexBy(riskLimits, 'symbol');
                    const v1ProductsById = this.indexBy(v1ProductsData, 'symbol');
                    const result = [];
                    for(let i = 0; i < products.length; i++){
                        let market = products[i];
                        const type = this.safeStringLower(market, 'type');
                        if (type === 'perpetual') {
                            const id = this.safeString(market, 'symbol');
                            const riskLimitValues = this.safeValue(riskLimitsById, id, {});
                            market = this.extend(market, riskLimitValues);
                            const v1ProductsValues = this.safeValue(v1ProductsById, id, {});
                            market = this.extend(market, v1ProductsValues);
                            market = this.parseSwapMarket(market);
                        } else market = this.parseSpotMarket(market);
                        result.push(market);
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCfgV2Products(params);
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"OK",
                    //         "data":{
                    //             ...,
                    //             "currencies":[
                    //                 {"currency":"BTC","valueScale":8,"minValueEv":1,"maxValueEv":5000000000000000000,"name":"Bitcoin"},
                    //                 {"currency":"USD","valueScale":4,"minValueEv":1,"maxValueEv":500000000000000,"name":"USD"},
                    //                 {"currency":"USDT","valueScale":8,"minValueEv":1,"maxValueEv":5000000000000000000,"name":"TetherUS"},
                    //             ],
                    //             ...
                    //         }
                    //     }
                    const data = this.safeValue(response, 'data', {});
                    const currencies = this.safeValue(data, 'currencies', []);
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'currency');
                        const name = this.safeString(currency, 'name');
                        const code = this.safeCurrencyCode(id);
                        const valueScaleString = this.safeString(currency, 'valueScale');
                        const valueScale = parseInt(valueScaleString);
                        const minValueEv = this.safeString(currency, 'minValueEv');
                        const maxValueEv = this.safeString(currency, 'maxValueEv');
                        let minAmount = undefined;
                        let maxAmount = undefined;
                        let precision = undefined;
                        if (valueScale !== undefined) {
                            const precisionString = this.parsePrecision(valueScaleString);
                            precision = this.parseNumber(precisionString);
                            minAmount = this.parseNumber(Precise.stringMul(minValueEv, precisionString));
                            maxAmount = this.parseNumber(Precise.stringMul(maxValueEv, precisionString));
                        }
                        result[code] = {
                            'id': id,
                            'info': currency,
                            'code': code,
                            'name': name,
                            'active': undefined,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': undefined,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': minAmount,
                                    'max': maxAmount
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'valueScale': valueScale
                        };
                    }
                    return result;
                }
                parseBidAsk(bidask, priceKey = 0, amountKey = 1, market) {
                    if (market === undefined) throw new ArgumentsRequired1(this.id + ' parseBidAsk() requires a market argument');
                    let amount = this.safeString(bidask, amountKey);
                    if (market['spot']) amount = this.fromEv(amount, market);
                    return [
                        this.parseNumber(this.fromEp(this.safeString(bidask, priceKey), market)),
                        this.parseNumber(amount)
                    ];
                }
                parseOrderBook(orderbook, symbol, timestamp, bidsKey = 'bids', asksKey = 'asks', priceKey = 0, amountKey = 1, market) {
                    const result = {
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'nonce': undefined
                    };
                    const sides = [
                        bidsKey,
                        asksKey
                    ];
                    for(let i = 0; i < sides.length; i++){
                        const side = sides[i];
                        const orders = [];
                        const bidasks = this.safeValue(orderbook, side);
                        for(let k = 0; k < bidasks.length; k++)orders.push(this.parseBidAsk(bidasks[k], priceKey, amountKey, market));
                        result[side] = orders;
                    }
                    result[bidsKey] = this.sortBy(result[bidsKey], 0, true);
                    result[asksKey] = this.sortBy(result[asksKey], 0);
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.v1GetMdOrderbook(this.extend(request, params));
                    //
                    //     {
                    //         "error": null,
                    //         "id": 0,
                    //         "result": {
                    //             "book": {
                    //                 "asks": [
                    //                     [ 23415000000, 105262000 ],
                    //                     [ 23416000000, 147914000 ],
                    //                     [ 23419000000, 160914000 ],
                    //                 ],
                    //                 "bids": [
                    //                     [ 23360000000, 32995000 ],
                    //                     [ 23359000000, 221887000 ],
                    //                     [ 23356000000, 284599000 ],
                    //                 ],
                    //             },
                    //             "depth": 30,
                    //             "sequence": 1592059928,
                    //             "symbol": "sETHUSDT",
                    //             "timestamp": 1592387340020000955,
                    //             "type": "snapshot"
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const book = this.safeValue(result, 'book', {});
                    const timestamp = this.safeIntegerProduct(result, 'timestamp', 0.000001);
                    const orderbook = this.parseOrderBook(book, symbol, timestamp, 'bids', 'asks', 0, 1, market);
                    orderbook['nonce'] = this.safeInteger(result, 'sequence');
                    return orderbook;
                }
                toEn(n, scale) {
                    const stringN = n.toString();
                    const precise = new Precise(stringN);
                    precise.decimals = precise.decimals - scale;
                    precise.reduce();
                    const stringValue = precise.toString();
                    return parseInt(parseFloat(stringValue));
                }
                toEv(amount, market) {
                    if (amount === undefined || market === undefined) return amount;
                    return this.toEn(amount, market['valueScale']);
                }
                toEp(price, market) {
                    if (price === undefined || market === undefined) return price;
                    return this.toEn(price, market['priceScale']);
                }
                fromEn(en, scale) {
                    if (en === undefined) return undefined;
                    const precise = new Precise(en);
                    precise.decimals = this.sum(precise.decimals, scale);
                    precise.reduce();
                    return precise.toString();
                }
                fromEp(ep, market) {
                    if (ep === undefined || market === undefined) return ep;
                    return this.fromEn(ep, this.safeInteger(market, 'priceScale'));
                }
                fromEv(ev, market) {
                    if (ev === undefined || market === undefined) return ev;
                    return this.fromEn(ev, this.safeInteger(market, 'valueScale'));
                }
                fromEr(er, market) {
                    if (er === undefined || market === undefined) return er;
                    return this.fromEn(er, this.safeInteger(market, 'ratioScale'));
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1592467200, // timestamp
                    //         300, // interval
                    //         23376000000, // last
                    //         23322000000, // open
                    //         23381000000, // high
                    //         23315000000, // low
                    //         23367000000, // close
                    //         208671000, // base volume
                    //         48759063370, // quote volume
                    //     ]
                    //
                    let baseVolume = undefined;
                    if (market !== undefined && market['spot']) baseVolume = this.parseNumber(this.fromEv(this.safeString(ohlcv, 7), market));
                    else baseVolume = this.safeNumber(ohlcv, 7);
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.parseNumber(this.fromEp(this.safeString(ohlcv, 3), market)),
                        this.parseNumber(this.fromEp(this.safeString(ohlcv, 4), market)),
                        this.parseNumber(this.fromEp(this.safeString(ohlcv, 5), market)),
                        this.parseNumber(this.fromEp(this.safeString(ohlcv, 6), market)),
                        baseVolume
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        // 'symbol': market['id'],
                        'resolution': this.timeframes[timeframe]
                    };
                    const duration = this.parseTimeframe(timeframe);
                    const now = this.seconds();
                    // the exchange does not return the last 1m candle
                    if (since !== undefined) {
                        if (limit === undefined) limit = 2000; // max 2000
                        since = parseInt(since / 1000);
                        request['from'] = since;
                        // time ranges ending in the future are not accepted
                        // https://github.com/ccxt/ccxt/issues/8050
                        request['to'] = Math.min(now, this.sum(since, duration * limit));
                    } else if (limit !== undefined) {
                        limit = Math.min(limit, 2000);
                        request['from'] = now - duration * this.sum(limit, 1);
                        request['to'] = now;
                    } else throw new ArgumentsRequired1(this.id + ' fetchOHLCV() requires a since argument, or a limit argument, or both');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    request['symbol'] = market['id'];
                    const response = await this.publicGetMdKline(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"OK",
                    //         "data":{
                    //             "total":-1,
                    //             "rows":[
                    //                 [1592467200,300,23376000000,23322000000,23381000000,23315000000,23367000000,208671000,48759063370],
                    //                 [1592467500,300,23367000000,23314000000,23390000000,23311000000,23331000000,234820000,54848948710],
                    //                 [1592467800,300,23331000000,23385000000,23391000000,23326000000,23387000000,152931000,35747882250],
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const rows = this.safeValue(data, 'rows', []);
                    return this.parseOHLCVs(rows, market, timeframe, since, limit);
                }
                parseTicker(ticker, market) {
                    //
                    // spot
                    //
                    //     {
                    //         "askEp": 943836000000,
                    //         "bidEp": 943601000000,
                    //         "highEp": 955946000000,
                    //         "lastEp": 943803000000,
                    //         "lowEp": 924973000000,
                    //         "openEp": 948693000000,
                    //         "symbol": "sBTCUSDT",
                    //         "timestamp": 1592471203505728630,
                    //         "turnoverEv": 111822826123103,
                    //         "volumeEv": 11880532281
                    //     }
                    //
                    // swap
                    //
                    //     {
                    //         "askEp": 2332500,
                    //         "bidEp": 2331000,
                    //         "fundingRateEr": 10000,
                    //         "highEp": 2380000,
                    //         "indexEp": 2329057,
                    //         "lastEp": 2331500,
                    //         "lowEp": 2274000,
                    //         "markEp": 2329232,
                    //         "openEp": 2337500,
                    //         "openInterest": 1298050,
                    //         "predFundingRateEr": 19921,
                    //         "symbol": "ETHUSD",
                    //         "timestamp": 1592474241582701416,
                    //         "turnoverEv": 47228362330,
                    //         "volume": 4053863
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const timestamp = this.safeIntegerProduct(ticker, 'timestamp', 0.000001);
                    const last = this.fromEp(this.safeString(ticker, 'lastEp'), market);
                    const quoteVolume = this.fromEv(this.safeString(ticker, 'turnoverEv'), market);
                    let baseVolume = this.safeString(ticker, 'volume');
                    if (baseVolume === undefined) baseVolume = this.fromEv(this.safeString(ticker, 'volumeEv'), market);
                    const open = this.fromEp(this.safeString(ticker, 'openEp'), market);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.fromEp(this.safeString(ticker, 'highEp'), market),
                        'low': this.fromEp(this.safeString(ticker, 'lowEp'), market),
                        'bid': this.fromEp(this.safeString(ticker, 'bidEp'), market),
                        'bidVolume': undefined,
                        'ask': this.fromEp(this.safeString(ticker, 'askEp'), market),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const method = market['spot'] ? 'v1GetMdSpotTicker24hr' : 'v1GetMdTicker24hr';
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "error": null,
                    //         "id": 0,
                    //         "result": {
                    //             "askEp": 943836000000,
                    //             "bidEp": 943601000000,
                    //             "highEp": 955946000000,
                    //             "lastEp": 943803000000,
                    //             "lowEp": 924973000000,
                    //             "openEp": 948693000000,
                    //             "symbol": "sBTCUSDT",
                    //             "timestamp": 1592471203505728630,
                    //             "turnoverEv": 111822826123103,
                    //             "volumeEv": 11880532281
                    //         }
                    //     }
                    //
                    // swap
                    //
                    //     {
                    //         "error": null,
                    //         "id": 0,
                    //         "result": {
                    //             "askEp": 2332500,
                    //             "bidEp": 2331000,
                    //             "fundingRateEr": 10000,
                    //             "highEp": 2380000,
                    //             "indexEp": 2329057,
                    //             "lastEp": 2331500,
                    //             "lowEp": 2274000,
                    //             "markEp": 2329232,
                    //             "openEp": 2337500,
                    //             "openInterest": 1298050,
                    //             "predFundingRateEr": 19921,
                    //             "symbol": "ETHUSD",
                    //             "timestamp": 1592474241582701416,
                    //             "turnoverEv": 47228362330,
                    //             "volume": 4053863
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseTicker(result, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.v1GetMdTrade(this.extend(request, params));
                    //
                    //     {
                    //         "error": null,
                    //         "id": 0,
                    //         "result": {
                    //             "sequence": 1315644947,
                    //             "symbol": "BTCUSD",
                    //             "trades": [
                    //                 [ 1592541746712239749, 13156448570000, "Buy", 93070000, 40173 ],
                    //                 [ 1592541740434625085, 13156447110000, "Sell", 93065000, 5000 ],
                    //                 [ 1592541732958241616, 13156441390000, "Buy", 93070000, 3460 ],
                    //             ],
                    //             "type": "snapshot"
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    const trades = this.safeValue(result, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     [
                    //         1592541746712239749,
                    //         13156448570000,
                    //         "Buy",
                    //         93070000,
                    //         40173
                    //     ]
                    //
                    // fetchMyTrades (private)
                    //
                    // spot
                    //
                    //     {
                    //         "qtyType": "ByQuote",
                    //         "transactTimeNs": 1589450974800550100,
                    //         "clOrdID": "8ba59d40-df25-d4b0-14cf-0703f44e9690",
                    //         "orderID": "b2b7018d-f02f-4c59-b4cf-051b9c2d2e83",
                    //         "symbol": "sBTCUSDT",
                    //         "side": "Buy",
                    //         "priceEP": 970056000000,
                    //         "baseQtyEv": 0,
                    //         "quoteQtyEv": 1000000000,
                    //         "action": "New",
                    //         "execStatus": "MakerFill",
                    //         "ordStatus": "Filled",
                    //         "ordType": "Limit",
                    //         "execInst": "None",
                    //         "timeInForce": "GoodTillCancel",
                    //         "stopDirection": "UNSPECIFIED",
                    //         "tradeType": "Trade",
                    //         "stopPxEp": 0,
                    //         "execId": "c6bd8979-07ba-5946-b07e-f8b65135dbb1",
                    //         "execPriceEp": 970056000000,
                    //         "execBaseQtyEv": 103000,
                    //         "execQuoteQtyEv": 999157680,
                    //         "leavesBaseQtyEv": 0,
                    //         "leavesQuoteQtyEv": 0,
                    //         "execFeeEv": 0,
                    //         "feeRateEr": 0
                    //     }
                    //
                    // swap
                    //
                    //     {
                    //         "transactTimeNs": 1578026629824704800,
                    //         "symbol": "BTCUSD",
                    //         "currency": "BTC",
                    //         "action": "Replace",
                    //         "side": "Sell",
                    //         "tradeType": "Trade",
                    //         "execQty": 700,
                    //         "execPriceEp": 71500000,
                    //         "orderQty": 700,
                    //         "priceEp": 71500000,
                    //         "execValueEv": 9790209,
                    //         "feeRateEr": -25000,
                    //         "execFeeEv": -2447,
                    //         "ordType": "Limit",
                    //         "execID": "b01671a1-5ddc-5def-b80a-5311522fd4bf",
                    //         "orderID": "b63bc982-be3a-45e0-8974-43d6375fb626",
                    //         "clOrdID": "uuid-1577463487504",
                    //         "execStatus": "MakerFill"
                    //     }
                    //
                    let priceString = undefined;
                    let amountString = undefined;
                    let timestamp = undefined;
                    let id = undefined;
                    let side = undefined;
                    let costString = undefined;
                    let type = undefined;
                    let fee = undefined;
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    let orderId = undefined;
                    let takerOrMaker = undefined;
                    if (Array.isArray(trade)) {
                        const tradeLength = trade.length;
                        timestamp = this.safeIntegerProduct(trade, 0, 0.000001);
                        if (tradeLength > 4) id = this.safeString(trade, tradeLength - 4);
                        side = this.safeStringLower(trade, tradeLength - 3);
                        priceString = this.fromEp(this.safeString(trade, tradeLength - 2), market);
                        amountString = this.fromEv(this.safeString(trade, tradeLength - 1), market);
                    } else {
                        timestamp = this.safeIntegerProduct(trade, 'transactTimeNs', 0.000001);
                        id = this.safeString2(trade, 'execId', 'execID');
                        orderId = this.safeString(trade, 'orderID');
                        side = this.safeStringLower(trade, 'side');
                        type = this.parseOrderType(this.safeString(trade, 'ordType'));
                        const execStatus = this.safeString(trade, 'execStatus');
                        if (execStatus === 'MakerFill') takerOrMaker = 'maker';
                        priceString = this.fromEp(this.safeString(trade, 'execPriceEp'), market);
                        amountString = this.fromEv(this.safeString(trade, 'execBaseQtyEv'), market);
                        amountString = this.safeString(trade, 'execQty', amountString);
                        costString = this.fromEv(this.safeString2(trade, 'execQuoteQtyEv', 'execValueEv'), market);
                        const feeCostString = this.fromEv(this.safeString(trade, 'execFeeEv'), market);
                        if (feeCostString !== undefined) {
                            const feeRateString = this.fromEr(this.safeString(trade, 'feeRateEr'), market);
                            let feeCurrencyCode = undefined;
                            if (market['spot']) feeCurrencyCode = side === 'buy' ? market['base'] : market['quote'];
                            else {
                                const info = this.safeValue(market, 'info');
                                if (info !== undefined) {
                                    const settlementCurrencyId = this.safeString(info, 'settlementCurrency');
                                    feeCurrencyCode = this.safeCurrencyCode(settlementCurrencyId);
                                }
                            }
                            fee = {
                                'cost': this.parseNumber(feeCostString),
                                'rate': this.parseNumber(feeRateString),
                                'currency': feeCurrencyCode
                            };
                        }
                    }
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'order': orderId,
                        'type': type,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                parseSpotBalance(response) {
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"",
                    //         "data":[
                    //             {
                    //                 "currency":"USDT",
                    //                 "balanceEv":0,
                    //                 "lockedTradingBalanceEv":0,
                    //                 "lockedWithdrawEv":0,
                    //                 "lastUpdateTimeNs":1592065834511322514,
                    //                 "walletVid":0
                    //             },
                    //             {
                    //                 "currency":"ETH",
                    //                 "balanceEv":0,
                    //                 "lockedTradingBalanceEv":0,
                    //                 "lockedWithdrawEv":0,
                    //                 "lastUpdateTimeNs":1592065834511322514,
                    //                 "walletVid":0
                    //             }
                    //         ]
                    //     }
                    //
                    let timestamp = undefined;
                    const result = {
                        'info': response
                    };
                    const data = this.safeValue(response, 'data', []);
                    for(let i = 0; i < data.length; i++){
                        const balance = data[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const currency = this.safeValue(this.currencies, code, {});
                        const scale = this.safeInteger(currency, 'valueScale', 8);
                        const account = this.account();
                        const balanceEv = this.safeString(balance, 'balanceEv');
                        const lockedTradingBalanceEv = this.safeString(balance, 'lockedTradingBalanceEv');
                        const lockedWithdrawEv = this.safeString(balance, 'lockedWithdrawEv');
                        const total = this.fromEn(balanceEv, scale);
                        const lockedTradingBalance = this.fromEn(lockedTradingBalanceEv, scale);
                        const lockedWithdraw = this.fromEn(lockedWithdrawEv, scale);
                        const used = Precise.stringAdd(lockedTradingBalance, lockedWithdraw);
                        const lastUpdateTimeNs = this.safeIntegerProduct(balance, 'lastUpdateTimeNs', 0.000001);
                        timestamp = timestamp === undefined ? lastUpdateTimeNs : Math.max(timestamp, lastUpdateTimeNs);
                        account['total'] = total;
                        account['used'] = used;
                        result[code] = account;
                    }
                    result['timestamp'] = timestamp;
                    result['datetime'] = this.iso8601(timestamp);
                    return this.safeBalance(result);
                }
                parseSwapBalance(response) {
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"",
                    //         "data":{
                    //             "account":{
                    //                 "accountId":6192120001,
                    //                 "currency":"BTC",
                    //                 "accountBalanceEv":1254744,
                    //                 "totalUsedBalanceEv":0,
                    //                 "bonusBalanceEv":1254744
                    //             },
                    //             "positions":[
                    //                 {
                    //                     "accountID":6192120001,
                    //                     "symbol":"BTCUSD",
                    //                     "currency":"BTC",
                    //                     "side":"None",
                    //                     "positionStatus":"Normal",
                    //                     "crossMargin":false,
                    //                     "leverageEr":0,
                    //                     "leverage":0E-8,
                    //                     "initMarginReqEr":1000000,
                    //                     "initMarginReq":0.01000000,
                    //                     "maintMarginReqEr":500000,
                    //                     "maintMarginReq":0.00500000,
                    //                     "riskLimitEv":10000000000,
                    //                     "riskLimit":100.00000000,
                    //                     "size":0,
                    //                     "value":0E-8,
                    //                     "valueEv":0,
                    //                     "avgEntryPriceEp":0,
                    //                     "avgEntryPrice":0E-8,
                    //                     "posCostEv":0,
                    //                     "posCost":0E-8,
                    //                     "assignedPosBalanceEv":0,
                    //                     "assignedPosBalance":0E-8,
                    //                     "bankruptCommEv":0,
                    //                     "bankruptComm":0E-8,
                    //                     "bankruptPriceEp":0,
                    //                     "bankruptPrice":0E-8,
                    //                     "positionMarginEv":0,
                    //                     "positionMargin":0E-8,
                    //                     "liquidationPriceEp":0,
                    //                     "liquidationPrice":0E-8,
                    //                     "deleveragePercentileEr":0,
                    //                     "deleveragePercentile":0E-8,
                    //                     "buyValueToCostEr":1150750,
                    //                     "buyValueToCost":0.01150750,
                    //                     "sellValueToCostEr":1149250,
                    //                     "sellValueToCost":0.01149250,
                    //                     "markPriceEp":96359083,
                    //                     "markPrice":9635.90830000,
                    //                     "markValueEv":0,
                    //                     "markValue":null,
                    //                     "unRealisedPosLossEv":0,
                    //                     "unRealisedPosLoss":null,
                    //                     "estimatedOrdLossEv":0,
                    //                     "estimatedOrdLoss":0E-8,
                    //                     "usedBalanceEv":0,
                    //                     "usedBalance":0E-8,
                    //                     "takeProfitEp":0,
                    //                     "takeProfit":null,
                    //                     "stopLossEp":0,
                    //                     "stopLoss":null,
                    //                     "realisedPnlEv":0,
                    //                     "realisedPnl":null,
                    //                     "cumRealisedPnlEv":0,
                    //                     "cumRealisedPnl":null
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const result = {
                        'info': response
                    };
                    const data = this.safeValue(response, 'data', {});
                    const balance = this.safeValue(data, 'account', {});
                    const currencyId = this.safeString(balance, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    const currency = this.currency(code);
                    const account = this.account();
                    const accountBalanceEv = this.safeString(balance, 'accountBalanceEv');
                    const totalUsedBalanceEv = this.safeString(balance, 'totalUsedBalanceEv');
                    const valueScale = this.safeInteger(currency, 'valueScale', 8);
                    account['total'] = this.fromEn(accountBalanceEv, valueScale);
                    account['used'] = this.fromEn(totalUsedBalanceEv, valueScale);
                    result[code] = account;
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const defaultType = this.safeString2(this.options, 'defaultType', 'fetchBalance', 'spot');
                    const type = this.safeString(params, 'type', defaultType);
                    let method = 'privateGetSpotWallets';
                    const request = {};
                    if (type === 'swap') {
                        const code = this.safeString(params, 'code');
                        if (code !== undefined) {
                            const currency = this.currency(code);
                            request['currency'] = currency['id'];
                            params = this.omit(params, 'code');
                        } else {
                            const currency = this.safeString(params, 'currency');
                            if (currency === undefined) throw new ArgumentsRequired1(this.id + ' fetchBalance() requires a code parameter or a currency parameter for ' + type + ' type');
                        }
                        method = 'privateGetAccountsAccountPositions';
                    }
                    params = this.omit(params, 'type');
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"",
                    //         "data":[
                    //             {
                    //                 "currency":"USDT",
                    //                 "balanceEv":0,
                    //                 "lockedTradingBalanceEv":0,
                    //                 "lockedWithdrawEv":0,
                    //                 "lastUpdateTimeNs":1592065834511322514,
                    //                 "walletVid":0
                    //             },
                    //             {
                    //                 "currency":"ETH",
                    //                 "balanceEv":0,
                    //                 "lockedTradingBalanceEv":0,
                    //                 "lockedWithdrawEv":0,
                    //                 "lastUpdateTimeNs":1592065834511322514,
                    //                 "walletVid":0
                    //             }
                    //         ]
                    //     }
                    //
                    // swap
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"",
                    //         "data":{
                    //             "account":{
                    //                 "accountId":6192120001,
                    //                 "currency":"BTC",
                    //                 "accountBalanceEv":1254744,
                    //                 "totalUsedBalanceEv":0,
                    //                 "bonusBalanceEv":1254744
                    //             },
                    //             "positions":[
                    //                 {
                    //                     "accountID":6192120001,
                    //                     "symbol":"BTCUSD",
                    //                     "currency":"BTC",
                    //                     "side":"None",
                    //                     "positionStatus":"Normal",
                    //                     "crossMargin":false,
                    //                     "leverageEr":0,
                    //                     "leverage":0E-8,
                    //                     "initMarginReqEr":1000000,
                    //                     "initMarginReq":0.01000000,
                    //                     "maintMarginReqEr":500000,
                    //                     "maintMarginReq":0.00500000,
                    //                     "riskLimitEv":10000000000,
                    //                     "riskLimit":100.00000000,
                    //                     "size":0,
                    //                     "value":0E-8,
                    //                     "valueEv":0,
                    //                     "avgEntryPriceEp":0,
                    //                     "avgEntryPrice":0E-8,
                    //                     "posCostEv":0,
                    //                     "posCost":0E-8,
                    //                     "assignedPosBalanceEv":0,
                    //                     "assignedPosBalance":0E-8,
                    //                     "bankruptCommEv":0,
                    //                     "bankruptComm":0E-8,
                    //                     "bankruptPriceEp":0,
                    //                     "bankruptPrice":0E-8,
                    //                     "positionMarginEv":0,
                    //                     "positionMargin":0E-8,
                    //                     "liquidationPriceEp":0,
                    //                     "liquidationPrice":0E-8,
                    //                     "deleveragePercentileEr":0,
                    //                     "deleveragePercentile":0E-8,
                    //                     "buyValueToCostEr":1150750,
                    //                     "buyValueToCost":0.01150750,
                    //                     "sellValueToCostEr":1149250,
                    //                     "sellValueToCost":0.01149250,
                    //                     "markPriceEp":96359083,
                    //                     "markPrice":9635.90830000,
                    //                     "markValueEv":0,
                    //                     "markValue":null,
                    //                     "unRealisedPosLossEv":0,
                    //                     "unRealisedPosLoss":null,
                    //                     "estimatedOrdLossEv":0,
                    //                     "estimatedOrdLoss":0E-8,
                    //                     "usedBalanceEv":0,
                    //                     "usedBalance":0E-8,
                    //                     "takeProfitEp":0,
                    //                     "takeProfit":null,
                    //                     "stopLossEp":0,
                    //                     "stopLoss":null,
                    //                     "realisedPnlEv":0,
                    //                     "realisedPnl":null,
                    //                     "cumRealisedPnlEv":0,
                    //                     "cumRealisedPnl":null
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const result = type === 'swap' ? this.parseSwapBalance(response) : this.parseSpotBalance(response);
                    return result;
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'Created': 'open',
                        'Untriggered': 'open',
                        'Deactivated': 'closed',
                        'Triggered': 'open',
                        'Rejected': 'rejected',
                        'New': 'open',
                        'PartiallyFilled': 'open',
                        'Filled': 'closed',
                        'Canceled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrderType(type) {
                    const types = {
                        'Limit': 'limit',
                        'Market': 'market'
                    };
                    return this.safeString(types, type, type);
                }
                parseTimeInForce(timeInForce) {
                    const timeInForces = {
                        'GoodTillCancel': 'GTC',
                        'PostOnly': 'PO',
                        'ImmediateOrCancel': 'IOC',
                        'FillOrKill': 'FOK'
                    };
                    return this.safeString(timeInForces, timeInForce, timeInForce);
                }
                parseSpotOrder(order, market) {
                    //
                    // spot
                    //
                    //     {
                    //         "orderID": "d1d09454-cabc-4a23-89a7-59d43363f16d",
                    //         "clOrdID": "309bcd5c-9f6e-4a68-b775-4494542eb5cb",
                    //         "priceEp": 0,
                    //         "action": "New",
                    //         "trigger": "UNSPECIFIED",
                    //         "pegPriceType": "UNSPECIFIED",
                    //         "stopDirection": "UNSPECIFIED",
                    //         "bizError": 0,
                    //         "symbol": "sBTCUSDT",
                    //         "side": "Buy",
                    //         "baseQtyEv": 0,
                    //         "ordType": "Limit",
                    //         "timeInForce": "GoodTillCancel",
                    //         "ordStatus": "Created",
                    //         "cumFeeEv": 0,
                    //         "cumBaseQtyEv": 0,
                    //         "cumQuoteQtyEv": 0,
                    //         "leavesBaseQtyEv": 0,
                    //         "leavesQuoteQtyEv": 0,
                    //         "avgPriceEp": 0,
                    //         "cumBaseAmountEv": 0,
                    //         "cumQuoteAmountEv": 0,
                    //         "quoteQtyEv": 0,
                    //         "qtyType": "ByBase",
                    //         "stopPxEp": 0,
                    //         "pegOffsetValueEp": 0
                    //     }
                    //
                    //     {
                    //         "orderID":"99232c3e-3d6a-455f-98cc-2061cdfe91bc",
                    //         "stopPxEp":0,
                    //         "avgPriceEp":0,
                    //         "qtyType":"ByBase",
                    //         "leavesBaseQtyEv":0,
                    //         "leavesQuoteQtyEv":0,
                    //         "baseQtyEv":"1000000000",
                    //         "feeCurrency":"4",
                    //         "stopDirection":"UNSPECIFIED",
                    //         "symbol":"sETHUSDT",
                    //         "side":"Buy",
                    //         "quoteQtyEv":250000000000,
                    //         "priceEp":25000000000,
                    //         "ordType":"Limit",
                    //         "timeInForce":"GoodTillCancel",
                    //         "ordStatus":"Rejected",
                    //         "execStatus":"NewRejected",
                    //         "createTimeNs":1592675305266037130,
                    //         "cumFeeEv":0,
                    //         "cumBaseValueEv":0,
                    //         "cumQuoteValueEv":0
                    //     }
                    //
                    const id = this.safeString(order, 'orderID');
                    let clientOrderId = this.safeString(order, 'clOrdID');
                    if (clientOrderId !== undefined && clientOrderId.length < 1) clientOrderId = undefined;
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const price = this.fromEp(this.safeString(order, 'priceEp'), market);
                    const amount = this.fromEv(this.safeString(order, 'baseQtyEv'), market);
                    const remaining = this.omitZero(this.fromEv(this.safeString(order, 'leavesBaseQtyEv'), market));
                    const filled = this.fromEv(this.safeString2(order, 'cumBaseQtyEv', 'cumBaseValueEv'), market);
                    const cost = this.fromEv(this.safeString2(order, 'cumQuoteValueEv', 'quoteQtyEv'), market);
                    const average = this.fromEp(this.safeString(order, 'avgPriceEp'), market);
                    const status = this.parseOrderStatus(this.safeString(order, 'ordStatus'));
                    const side = this.safeStringLower(order, 'side');
                    const type = this.parseOrderType(this.safeString(order, 'ordType'));
                    const timestamp = this.safeIntegerProduct2(order, 'actionTimeNs', 'createTimeNs', 0.000001);
                    let fee = undefined;
                    const feeCost = this.fromEv(this.safeString(order, 'cumFeeEv'), market);
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': undefined
                    };
                    const timeInForce = this.parseTimeInForce(this.safeString(order, 'timeInForce'));
                    const stopPrice = this.parseNumber(this.omitZero(this.fromEp(this.safeString(order, 'stopPxEp', market))));
                    const postOnly = timeInForce === 'PO';
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': cost,
                        'average': average,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                parseSwapOrder(order, market) {
                    //
                    //     {
                    //         "bizError":0,
                    //         "orderID":"7a1ad384-44a3-4e54-a102-de4195a29e32",
                    //         "clOrdID":"",
                    //         "symbol":"ETHUSD",
                    //         "side":"Buy",
                    //         "actionTimeNs":1592668973945065381,
                    //         "transactTimeNs":0,
                    //         "orderType":"Market",
                    //         "priceEp":2267500,
                    //         "price":226.75000000,
                    //         "orderQty":1,
                    //         "displayQty":0,
                    //         "timeInForce":"ImmediateOrCancel",
                    //         "reduceOnly":false,
                    //         "closedPnlEv":0,
                    //         "closedPnl":0E-8,
                    //         "closedSize":0,
                    //         "cumQty":0,
                    //         "cumValueEv":0,
                    //         "cumValue":0E-8,
                    //         "leavesQty":1,
                    //         "leavesValueEv":11337,
                    //         "leavesValue":1.13370000,
                    //         "stopDirection":"UNSPECIFIED",
                    //         "stopPxEp":0,
                    //         "stopPx":0E-8,
                    //         "trigger":"UNSPECIFIED",
                    //         "pegOffsetValueEp":0,
                    //         "execStatus":"PendingNew",
                    //         "pegPriceType":"UNSPECIFIED",
                    //         "ordStatus":"Created",
                    //         "execInst": "ReduceOnly"
                    //     }
                    //
                    const id = this.safeString(order, 'orderID');
                    let clientOrderId = this.safeString(order, 'clOrdID');
                    if (clientOrderId !== undefined && clientOrderId.length < 1) clientOrderId = undefined;
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const status = this.parseOrderStatus(this.safeString(order, 'ordStatus'));
                    const side = this.safeStringLower(order, 'side');
                    const type = this.parseOrderType(this.safeString(order, 'orderType'));
                    const price = this.parseNumber(this.fromEp(this.safeString(order, 'priceEp'), market));
                    const amount = this.safeNumber(order, 'orderQty');
                    const filled = this.safeNumber(order, 'cumQty');
                    const remaining = this.safeNumber(order, 'leavesQty');
                    const timestamp = this.safeIntegerProduct(order, 'actionTimeNs', 0.000001);
                    const cost = this.safeNumber(order, 'cumValue');
                    let lastTradeTimestamp = this.safeIntegerProduct(order, 'transactTimeNs', 0.000001);
                    if (lastTradeTimestamp === 0) lastTradeTimestamp = undefined;
                    const timeInForce = this.parseTimeInForce(this.safeString(order, 'timeInForce'));
                    const stopPrice = this.safeNumber(order, 'stopPx');
                    const postOnly = timeInForce === 'PO';
                    return {
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'datetime': this.iso8601(timestamp),
                        'timestamp': timestamp,
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'cost': cost,
                        'average': undefined,
                        'status': status,
                        'fee': undefined,
                        'trades': undefined
                    };
                }
                parseOrder(order, market) {
                    if ('closedPnl' in order) return this.parseSwapOrder(order, market);
                    return this.parseSpotOrder(order, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    side = this.capitalize(side);
                    type = this.capitalize(type);
                    const reduceOnly = this.safeValue(params, 'reduceOnly');
                    const request = {
                        // common
                        'symbol': market['id'],
                        'side': side,
                        'ordType': type
                    };
                    const clientOrderId = this.safeString2(params, 'clOrdID', 'clientOrderId');
                    if (clientOrderId === undefined) {
                        const brokerId = this.safeString(this.options, 'brokerId');
                        if (brokerId !== undefined) request['clOrdID'] = brokerId + this.uuid16();
                    } else {
                        request['clOrdID'] = clientOrderId;
                        params = this.omit(params, [
                            'clOrdID',
                            'clientOrderId'
                        ]);
                    }
                    const stopPrice = this.safeString2(params, 'stopPx', 'stopPrice');
                    if (stopPrice !== undefined) request['stopPxEp'] = this.toEp(stopPrice, market);
                    params = this.omit(params, [
                        'stopPx',
                        'stopPrice'
                    ]);
                    if (market['spot']) {
                        let qtyType = this.safeValue(params, 'qtyType', 'ByBase');
                        if (type === 'Market' || type === 'Stop' || type === 'MarketIfTouched') {
                            if (price !== undefined) qtyType = 'ByQuote';
                        }
                        request['qtyType'] = qtyType;
                        if (qtyType === 'ByQuote') {
                            let cost = this.safeNumber(params, 'cost');
                            params = this.omit(params, 'cost');
                            if (this.options['createOrderByQuoteRequiresPrice']) {
                                if (price !== undefined) cost = amount * price;
                                else if (cost === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() ' + qtyType + ' requires a price argument or a cost parameter');
                            }
                            cost = cost === undefined ? amount : cost;
                            const costString = cost.toString();
                            request['quoteQtyEv'] = this.toEv(costString, market);
                        } else {
                            const amountString = amount.toString();
                            request['baseQtyEv'] = this.toEv(amountString, market);
                        }
                    } else if (market['swap']) {
                        if (reduceOnly !== undefined) request['reduceOnly'] = reduceOnly;
                        request['orderQty'] = parseInt(amount);
                        if (stopPrice !== undefined) {
                            const triggerType = this.safeString(params, 'triggerType', 'ByMarkPrice');
                            request['triggerType'] = triggerType;
                        }
                    }
                    if (type === 'Limit' || type === 'StopLimit' || type === 'LimitIfTouched') {
                        const priceString = price.toString();
                        request['priceEp'] = this.toEp(priceString, market);
                    }
                    const takeProfitPrice = this.safeString(params, 'takeProfitPrice');
                    if (takeProfitPrice !== undefined) {
                        request['takeProfitEp'] = this.toEp(takeProfitPrice, market);
                        params = this.omit(params, 'takeProfitPrice');
                    }
                    const stopLossPrice = this.safeString(params, 'stopLossPrice');
                    if (stopLossPrice !== undefined) {
                        request['stopLossEp'] = this.toEp(stopLossPrice, market);
                        params = this.omit(params, 'stopLossPrice');
                    }
                    const method = market['spot'] ? 'privatePostSpotOrders' : 'privatePostOrders';
                    params = this.omit(params, 'reduceOnly');
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "code": 0,
                    //         "msg": "",
                    //         "data": {
                    //             "orderID": "d1d09454-cabc-4a23-89a7-59d43363f16d",
                    //             "clOrdID": "309bcd5c-9f6e-4a68-b775-4494542eb5cb",
                    //             "priceEp": 0,
                    //             "action": "New",
                    //             "trigger": "UNSPECIFIED",
                    //             "pegPriceType": "UNSPECIFIED",
                    //             "stopDirection": "UNSPECIFIED",
                    //             "bizError": 0,
                    //             "symbol": "sBTCUSDT",
                    //             "side": "Buy",
                    //             "baseQtyEv": 0,
                    //             "ordType": "Limit",
                    //             "timeInForce": "GoodTillCancel",
                    //             "ordStatus": "Created",
                    //             "cumFeeEv": 0,
                    //             "cumBaseQtyEv": 0,
                    //             "cumQuoteQtyEv": 0,
                    //             "leavesBaseQtyEv": 0,
                    //             "leavesQuoteQtyEv": 0,
                    //             "avgPriceEp": 0,
                    //             "cumBaseAmountEv": 0,
                    //             "cumQuoteAmountEv": 0,
                    //             "quoteQtyEv": 0,
                    //             "qtyType": "ByBase",
                    //             "stopPxEp": 0,
                    //             "pegOffsetValueEp": 0
                    //         }
                    //     }
                    //
                    // swap
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"",
                    //         "data":{
                    //             "bizError":0,
                    //             "orderID":"7a1ad384-44a3-4e54-a102-de4195a29e32",
                    //             "clOrdID":"",
                    //             "symbol":"ETHUSD",
                    //             "side":"Buy",
                    //             "actionTimeNs":1592668973945065381,
                    //             "transactTimeNs":0,
                    //             "orderType":"Market",
                    //             "priceEp":2267500,
                    //             "price":226.75000000,
                    //             "orderQty":1,
                    //             "displayQty":0,
                    //             "timeInForce":"ImmediateOrCancel",
                    //             "reduceOnly":false,
                    //             "closedPnlEv":0,
                    //             "closedPnl":0E-8,
                    //             "closedSize":0,
                    //             "cumQty":0,
                    //             "cumValueEv":0,
                    //             "cumValue":0E-8,
                    //             "leavesQty":1,
                    //             "leavesValueEv":11337,
                    //             "leavesValue":1.13370000,
                    //             "stopDirection":"UNSPECIFIED",
                    //             "stopPxEp":0,
                    //             "stopPx":0E-8,
                    //             "trigger":"UNSPECIFIED",
                    //             "pegOffsetValueEp":0,
                    //             "execStatus":"PendingNew",
                    //             "pegPriceType":"UNSPECIFIED",
                    //             "ordStatus":"Created"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async createReduceOnlyOrder(symbol, type, side, amount, price, params = {}) {
                    const request = {
                        'reduceOnly': true
                    };
                    return await this.createOrder(symbol, type, side, amount, price, this.extend(request, params));
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' editOrder() requires a symbol argument');
                    if (type !== undefined) throw new ArgumentsRequired1(this.id + ' editOrder() type changing is not implemented. Try to cancel & recreate order for that purpose');
                    if (side !== undefined) throw new ArgumentsRequired1(this.id + ' editOrder() side changing is not implemented. Try to cancel & recreate order for that purpose');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'clOrdID');
                    params = this.omit(params, [
                        'clientOrderId',
                        'clOrdID'
                    ]);
                    if (clientOrderId !== undefined) request['clOrdID'] = clientOrderId;
                    else request['orderID'] = id;
                    if (price !== undefined) request['priceEp'] = this.toEp(price, market);
                    // Note the uppercase 'V' in 'baseQtyEV' request. that is exchange's requirement at this moment. However, to avoid mistakes from user side, let's support lowercased 'baseQtyEv' too
                    const finalQty = this.safeString(params, 'baseQtyEv');
                    params = this.omit(params, [
                        'baseQtyEv'
                    ]);
                    if (finalQty !== undefined) request['baseQtyEV'] = finalQty;
                    else if (amount !== undefined) request['baseQtyEV'] = this.toEv(amount, market);
                    const stopPrice = this.safeString2(params, 'stopPx', 'stopPrice');
                    if (stopPrice !== undefined) request['stopPxEp'] = this.toEp(stopPrice, market);
                    params = this.omit(params, [
                        'stopPx',
                        'stopPrice'
                    ]);
                    const method = market['spot'] ? 'privatePutSpotOrders' : 'privatePutOrdersReplace';
                    const response = await this[method](this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'clOrdID');
                    params = this.omit(params, [
                        'clientOrderId',
                        'clOrdID'
                    ]);
                    if (clientOrderId !== undefined) request['clOrdID'] = clientOrderId;
                    else request['orderID'] = id;
                    const method = market['spot'] ? 'privateDeleteSpotOrders' : 'privateDeleteOrdersCancel';
                    const response = await this[method](this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const request = {
                    };
                    const market = this.market(symbol);
                    let method = 'privateDeleteSpotOrdersAll';
                    if (market['swap']) method = 'privateDeleteOrdersAll';
                    request['symbol'] = market['id'];
                    return await this[method](this.extend(request, params));
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const method = market['spot'] ? 'privateGetSpotOrdersActive' : 'privateGetExchangeOrder';
                    const request = {
                        'symbol': market['id']
                    };
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'clOrdID');
                    params = this.omit(params, [
                        'clientOrderId',
                        'clOrdID'
                    ]);
                    if (clientOrderId !== undefined) request['clOrdID'] = clientOrderId;
                    else request['orderID'] = id;
                    const response = await this[method](this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    let order = data;
                    if (Array.isArray(data)) {
                        const numOrders = data.length;
                        if (numOrders < 1) {
                            if (clientOrderId !== undefined) throw new OrderNotFound(this.id + ' fetchOrder() ' + symbol + ' order with clientOrderId ' + clientOrderId + ' not found');
                            else throw new OrderNotFound(this.id + ' fetchOrder() ' + symbol + ' order with id ' + id + ' not found');
                        }
                        order = this.safeValue(data, 0, {});
                    }
                    return this.parseOrder(order, market);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const method = market['spot'] ? 'privateGetSpotOrders' : 'privateGetExchangeOrderList';
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this[method](this.extend(request, params));
                    const data = this.safeValue(response, 'data', {});
                    const rows = this.safeValue(data, 'rows', []);
                    return this.parseOrders(rows, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const method = market['spot'] ? 'privateGetSpotOrders' : 'privateGetOrdersActiveList';
                    const request = {
                        'symbol': market['id']
                    };
                    let response = undefined;
                    try {
                        response = await this[method](this.extend(request, params));
                    } catch (e) {
                        if (e instanceof OrderNotFound) return [];
                    }
                    const data = this.safeValue(response, 'data', {});
                    if (Array.isArray(data)) return this.parseOrders(data, market, since, limit);
                    else {
                        const rows = this.safeValue(data, 'rows', []);
                        return this.parseOrders(rows, market, since, limit);
                    }
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchClosedOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const method = market['spot'] ? 'privateGetExchangeSpotOrder' : 'privateGetExchangeOrderList';
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['start'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"OK",
                    //         "data":{
                    //             "total":8,
                    //             "rows":[
                    //                 {
                    //                     "orderID":"99232c3e-3d6a-455f-98cc-2061cdfe91bc",
                    //                     "stopPxEp":0,
                    //                     "avgPriceEp":0,
                    //                     "qtyType":"ByBase",
                    //                     "leavesBaseQtyEv":0,
                    //                     "leavesQuoteQtyEv":0,
                    //                     "baseQtyEv":"1000000000",
                    //                     "feeCurrency":"4",
                    //                     "stopDirection":"UNSPECIFIED",
                    //                     "symbol":"sETHUSDT",
                    //                     "side":"Buy",
                    //                     "quoteQtyEv":250000000000,
                    //                     "priceEp":25000000000,
                    //                     "ordType":"Limit",
                    //                     "timeInForce":"GoodTillCancel",
                    //                     "ordStatus":"Rejected",
                    //                     "execStatus":"NewRejected",
                    //                     "createTimeNs":1592675305266037130,
                    //                     "cumFeeEv":0,
                    //                     "cumBaseValueEv":0,
                    //                     "cumQuoteValueEv":0
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    if (Array.isArray(data)) return this.parseOrders(data, market, since, limit);
                    else {
                        const rows = this.safeValue(data, 'rows', []);
                        return this.parseOrders(rows, market, since, limit);
                    }
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const method = market['spot'] ? 'privateGetExchangeSpotOrderTrades' : 'privateGetExchangeOrderTrade';
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['start'] = since;
                    if (market['swap'] && limit !== undefined) request['limit'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    // spot
                    //
                    //     {
                    //         "code": 0,
                    //         "msg": "OK",
                    //         "data": {
                    //             "total": 1,
                    //             "rows": [
                    //                 {
                    //                     "qtyType": "ByQuote",
                    //                     "transactTimeNs": 1589450974800550100,
                    //                     "clOrdID": "8ba59d40-df25-d4b0-14cf-0703f44e9690",
                    //                     "orderID": "b2b7018d-f02f-4c59-b4cf-051b9c2d2e83",
                    //                     "symbol": "sBTCUSDT",
                    //                     "side": "Buy",
                    //                     "priceEP": 970056000000,
                    //                     "baseQtyEv": 0,
                    //                     "quoteQtyEv": 1000000000,
                    //                     "action": "New",
                    //                     "execStatus": "MakerFill",
                    //                     "ordStatus": "Filled",
                    //                     "ordType": "Limit",
                    //                     "execInst": "None",
                    //                     "timeInForce": "GoodTillCancel",
                    //                     "stopDirection": "UNSPECIFIED",
                    //                     "tradeType": "Trade",
                    //                     "stopPxEp": 0,
                    //                     "execId": "c6bd8979-07ba-5946-b07e-f8b65135dbb1",
                    //                     "execPriceEp": 970056000000,
                    //                     "execBaseQtyEv": 103000,
                    //                     "execQuoteQtyEv": 999157680,
                    //                     "leavesBaseQtyEv": 0,
                    //                     "leavesQuoteQtyEv": 0,
                    //                     "execFeeEv": 0,
                    //                     "feeRateEr": 0
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    //
                    // swap
                    //
                    //     {
                    //         "code": 0,
                    //         "msg": "OK",
                    //         "data": {
                    //             "total": 79,
                    //             "rows": [
                    //                 {
                    //                     "transactTimeNs": 1606054879331565300,
                    //                     "symbol": "BTCUSD",
                    //                     "currency": "BTC",
                    //                     "action": "New",
                    //                     "side": "Buy",
                    //                     "tradeType": "Trade",
                    //                     "execQty": 5,
                    //                     "execPriceEp": 182990000,
                    //                     "orderQty": 5,
                    //                     "priceEp": 183870000,
                    //                     "execValueEv": 27323,
                    //                     "feeRateEr": 75000,
                    //                     "execFeeEv": 21,
                    //                     "ordType": "Market",
                    //                     "execID": "5eee56a4-04a9-5677-8eb0-c2fe22ae3645",
                    //                     "orderID": "ee0acb82-f712-4543-a11d-d23efca73197",
                    //                     "clOrdID": "",
                    //                     "execStatus": "TakerFill"
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const rows = this.safeValue(data, 'rows', []);
                    return this.parseTrades(rows, market, since, limit);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const defaultNetworks = this.safeValue(this.options, 'defaultNetworks');
                    const defaultNetwork = this.safeStringUpper(defaultNetworks, code);
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network', defaultNetwork);
                    network = this.safeString(networks, network, network);
                    if (network === undefined) request['chainName'] = currency['id'];
                    else {
                        request['chainName'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privateGetPhemexUserWalletsV2DepositAddress(this.extend(request, params));
                    //     {
                    //         "code":0,
                    //         "msg":"OK",
                    //         "data":{
                    //             "address":"0x5bfbf60e0fa7f63598e6cfd8a7fd3ffac4ccc6ad",
                    //             "tag":null
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const address = this.safeString(data, 'address');
                    const tag = this.safeString(data, 'tag');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const response = await this.privateGetExchangeWalletsDepositList(params);
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"OK",
                    //         "data":[
                    //             {
                    //                 "id":29200,
                    //                 "currency":"USDT",
                    //                 "currencyCode":3,
                    //                 "txHash":"0x0bdbdc47807769a03b158d5753f54dfc58b92993d2f5e818db21863e01238e5d",
                    //                 "address":"0x5bfbf60e0fa7f63598e6cfd8a7fd3ffac4ccc6ad",
                    //                 "amountEv":3000000000,
                    //                 "confirmations":13,
                    //                 "type":"Deposit",
                    //                 "status":"Success",
                    //                 "createdAt":1592722565000
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTransactions(data, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const response = await this.privateGetExchangeWalletsWithdrawList(params);
                    //
                    //     {
                    //         "code":0,
                    //         "msg":"OK",
                    //         "data":[
                    //             {
                    //                 "address": "1Lxxxxxxxxxxx"
                    //                 "amountEv": 200000
                    //                 "currency": "BTC"
                    //                 "currencyCode": 1
                    //                 "expiredTime": 0
                    //                 "feeEv": 50000
                    //                 "rejectReason": null
                    //                 "status": "Succeed"
                    //                 "txHash": "44exxxxxxxxxxxxxxxxxxxxxx"
                    //                 "withdrawStatus: ""
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTransactions(data, currency, since, limit);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'Success': 'ok',
                        'Succeed': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     ...
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "id":29200,
                    //         "currency":"USDT",
                    //         "currencyCode":3,
                    //         "txHash":"0x0bdbdc47807769a03b158d5753f54dfc58b92993d2f5e818db21863e01238e5d",
                    //         "address":"0x5bfbf60e0fa7f63598e6cfd8a7fd3ffac4ccc6ad",
                    //         "amountEv":3000000000,
                    //         "confirmations":13,
                    //         "type":"Deposit",
                    //         "status":"Success",
                    //         "createdAt":1592722565000
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "address": "1Lxxxxxxxxxxx"
                    //         "amountEv": 200000
                    //         "currency": "BTC"
                    //         "currencyCode": 1
                    //         "expiredTime": 0
                    //         "feeEv": 50000
                    //         "rejectReason": null
                    //         "status": "Succeed"
                    //         "txHash": "44exxxxxxxxxxxxxxxxxxxxxx"
                    //         "withdrawStatus: ""
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const address = this.safeString(transaction, 'address');
                    const tag = undefined;
                    const txid = this.safeString(transaction, 'txHash');
                    const currencyId = this.safeString(transaction, 'currency');
                    currency = this.safeCurrency(currencyId, currency);
                    const code = currency['code'];
                    const timestamp = this.safeInteger2(transaction, 'createdAt', 'submitedAt');
                    let type = this.safeStringLower(transaction, 'type');
                    const feeCost = this.parseNumber(this.fromEn(this.safeString(transaction, 'feeEv'), currency['valueScale']));
                    let fee = undefined;
                    if (feeCost !== undefined) {
                        type = 'withdrawal';
                        fee = {
                            'cost': feeCost,
                            'currency': code
                        };
                    }
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const amount = this.parseNumber(this.fromEn(this.safeString(transaction, 'amountEv'), currency['valueScale']));
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'fee': fee
                    };
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    const defaultSubType = this.safeString(this.options, 'defaultSubType', 'linear');
                    let code = this.safeString(params, 'code');
                    if (code === undefined) code = defaultSubType === 'linear' ? 'USD' : 'BTC';
                    else params = this.omit(params, 'code');
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateGetAccountsAccountPositions(this.extend(request, params));
                    //
                    //     {
                    //         "code":0,"msg":"",
                    //         "data":{
                    //             "account":{
                    //                 "accountId":6192120001,
                    //                 "currency":"BTC",
                    //                 "accountBalanceEv":1254744,
                    //                 "totalUsedBalanceEv":0,
                    //                 "bonusBalanceEv":1254744
                    //             },
                    //             "positions":[
                    //                 {
                    //                     "accountID":6192120001,
                    //                     "symbol":"BTCUSD",
                    //                     "currency":"BTC",
                    //                     "side":"None",
                    //                     "positionStatus":"Normal",
                    //                     "crossMargin":false,
                    //                     "leverageEr":100000000,
                    //                     "leverage":1.00000000,
                    //                     "initMarginReqEr":100000000,
                    //                     "initMarginReq":1.00000000,
                    //                     "maintMarginReqEr":500000,
                    //                     "maintMarginReq":0.00500000,
                    //                     "riskLimitEv":10000000000,
                    //                     "riskLimit":100.00000000,
                    //                     "size":0,
                    //                     "value":0E-8,
                    //                     "valueEv":0,
                    //                     "avgEntryPriceEp":0,
                    //                     "avgEntryPrice":0E-8,
                    //                     "posCostEv":0,
                    //                     "posCost":0E-8,
                    //                     "assignedPosBalanceEv":0,
                    //                     "assignedPosBalance":0E-8,
                    //                     "bankruptCommEv":0,
                    //                     "bankruptComm":0E-8,
                    //                     "bankruptPriceEp":0,
                    //                     "bankruptPrice":0E-8,
                    //                     "positionMarginEv":0,
                    //                     "positionMargin":0E-8,
                    //                     "liquidationPriceEp":0,
                    //                     "liquidationPrice":0E-8,
                    //                     "deleveragePercentileEr":0,
                    //                     "deleveragePercentile":0E-8,
                    //                     "buyValueToCostEr":100225000,
                    //                     "buyValueToCost":1.00225000,
                    //                     "sellValueToCostEr":100075000,
                    //                     "sellValueToCost":1.00075000,
                    //                     "markPriceEp":135736070,
                    //                     "markPrice":13573.60700000,
                    //                     "markValueEv":0,
                    //                     "markValue":null,
                    //                     "unRealisedPosLossEv":0,
                    //                     "unRealisedPosLoss":null,
                    //                     "estimatedOrdLossEv":0,
                    //                     "estimatedOrdLoss":0E-8,
                    //                     "usedBalanceEv":0,
                    //                     "usedBalance":0E-8,
                    //                     "takeProfitEp":0,
                    //                     "takeProfit":null,
                    //                     "stopLossEp":0,
                    //                     "stopLoss":null,
                    //                     "cumClosedPnlEv":0,
                    //                     "cumFundingFeeEv":0,
                    //                     "cumTransactFeeEv":0,
                    //                     "realisedPnlEv":0,
                    //                     "realisedPnl":null,
                    //                     "cumRealisedPnlEv":0,
                    //                     "cumRealisedPnl":null
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const positions = this.safeValue(data, 'positions', []);
                    const result = [];
                    for(let i = 0; i < positions.length; i++){
                        const position = positions[i];
                        result.push(this.parsePosition(position));
                    }
                    return this.filterByArray(result, 'symbol', symbols, false);
                }
                parsePosition(position, market) {
                    //
                    //   {
                    //     userID: '811370',
                    //     accountID: '8113700002',
                    //     symbol: 'ETHUSD',
                    //     currency: 'USD',
                    //     side: 'Buy',
                    //     positionStatus: 'Normal',
                    //     crossMargin: false,
                    //     leverageEr: '200000000',
                    //     leverage: '2.00000000',
                    //     initMarginReqEr: '50000000',
                    //     initMarginReq: '0.50000000',
                    //     maintMarginReqEr: '1000000',
                    //     maintMarginReq: '0.01000000',
                    //     riskLimitEv: '5000000000',
                    //     riskLimit: '500000.00000000',
                    //     size: '1',
                    //     value: '22.22370000',
                    //     valueEv: '222237',
                    //     avgEntryPriceEp: '44447400',
                    //     avgEntryPrice: '4444.74000000',
                    //     posCostEv: '111202',
                    //     posCost: '11.12020000',
                    //     assignedPosBalanceEv: '111202',
                    //     assignedPosBalance: '11.12020000',
                    //     bankruptCommEv: '84',
                    //     bankruptComm: '0.00840000',
                    //     bankruptPriceEp: '22224000',
                    //     bankruptPrice: '2222.40000000',
                    //     positionMarginEv: '111118',
                    //     positionMargin: '11.11180000',
                    //     liquidationPriceEp: '22669000',
                    //     liquidationPrice: '2266.90000000',
                    //     deleveragePercentileEr: '0',
                    //     deleveragePercentile: '0E-8',
                    //     buyValueToCostEr: '50112500',
                    //     buyValueToCost: '0.50112500',
                    //     sellValueToCostEr: '50187500',
                    //     sellValueToCost: '0.50187500',
                    //     markPriceEp: '31332499',
                    //     markPrice: '3133.24990000',
                    //     markValueEv: '0',
                    //     markValue: null,
                    //     unRealisedPosLossEv: '0',
                    //     unRealisedPosLoss: null,
                    //     estimatedOrdLossEv: '0',
                    //     estimatedOrdLoss: '0E-8',
                    //     usedBalanceEv: '111202',
                    //     usedBalance: '11.12020000',
                    //     takeProfitEp: '0',
                    //     takeProfit: null,
                    //     stopLossEp: '0',
                    //     stopLoss: null,
                    //     cumClosedPnlEv: '-1546',
                    //     cumFundingFeeEv: '1605',
                    //     cumTransactFeeEv: '8438',
                    //     realisedPnlEv: '0',
                    //     realisedPnl: null,
                    //     cumRealisedPnlEv: '0',
                    //     cumRealisedPnl: null,
                    //     transactTimeNs: '1641571200001885324',
                    //     takerFeeRateEr: '0',
                    //     makerFeeRateEr: '0',
                    //     term: '6',
                    //     lastTermEndTimeNs: '1607711882505745356',
                    //     lastFundingTimeNs: '1641571200000000000',
                    //     curTermRealisedPnlEv: '-1567',
                    //     execSeq: '12112761561'
                    //   }
                    //
                    const marketId = this.safeString(position, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const collateral = this.safeString(position, 'positionMargin');
                    const notionalString = this.safeString(position, 'value');
                    const maintenanceMarginPercentageString = this.safeString(position, 'maintMarginReq');
                    const maintenanceMarginString = Precise.stringMul(notionalString, maintenanceMarginPercentageString);
                    const initialMarginString = this.safeString(position, 'assignedPosBalance');
                    const initialMarginPercentageString = Precise.stringDiv(initialMarginString, notionalString);
                    const liquidationPrice = this.safeNumber(position, 'liquidationPrice');
                    const markPriceString = this.safeString(position, 'markPrice');
                    const contracts = this.safeString(position, 'size');
                    const contractSize = this.safeValue(market, 'contractSize');
                    const contractSizeString = this.numberToString(contractSize);
                    const leverage = this.safeNumber(position, 'leverage');
                    const entryPriceString = this.safeString(position, 'avgEntryPrice');
                    const rawSide = this.safeString(position, 'side');
                    const side = rawSide === 'Buy' ? 'long' : 'short';
                    let priceDiff = undefined;
                    const currency = this.safeString(position, 'currency');
                    if (currency === 'USD') {
                        if (side === 'long') priceDiff = Precise.stringSub(markPriceString, entryPriceString);
                        else priceDiff = Precise.stringSub(entryPriceString, markPriceString);
                    } else // inverse
                    if (side === 'long') priceDiff = Precise.stringSub(Precise.stringDiv('1', entryPriceString), Precise.stringDiv('1', markPriceString));
                    else priceDiff = Precise.stringSub(Precise.stringDiv('1', markPriceString), Precise.stringDiv('1', entryPriceString));
                    const unrealizedPnl = Precise.stringMul(Precise.stringMul(priceDiff, contracts), contractSizeString);
                    const percentage = Precise.stringMul(Precise.stringDiv(unrealizedPnl, initialMarginString), '100');
                    const marginRatio = Precise.stringDiv(maintenanceMarginString, collateral);
                    return {
                        'info': position,
                        'symbol': symbol,
                        'contracts': this.parseNumber(contracts),
                        'contractSize': contractSize,
                        'unrealizedPnl': this.parseNumber(unrealizedPnl),
                        'leverage': leverage,
                        'liquidationPrice': liquidationPrice,
                        'collateral': this.parseNumber(collateral),
                        'notional': this.parseNumber(notionalString),
                        'markPrice': this.parseNumber(markPriceString),
                        'entryPrice': this.parseNumber(entryPriceString),
                        'timestamp': undefined,
                        'initialMargin': this.parseNumber(initialMarginString),
                        'initialMarginPercentage': this.parseNumber(initialMarginPercentageString),
                        'maintenanceMargin': this.parseNumber(maintenanceMarginString),
                        'maintenanceMarginPercentage': this.parseNumber(maintenanceMarginPercentageString),
                        'marginRatio': this.parseNumber(marginRatio),
                        'datetime': undefined,
                        'marginMode': undefined,
                        'marginType': undefined,
                        'side': side,
                        'hedged': false,
                        'percentage': this.parseNumber(percentage)
                    };
                }
                async fetchFundingHistory(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchFundingHistory() requires a symbol argument');
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit > 200) throw new BadRequest(this.id + ' fetchFundingHistory() limit argument cannot exceed 200');
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetApiDataFuturesFundingFees(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "msg": "OK",
                    //         "data": {
                    //             "rows": [
                    //                 {
                    //                     "symbol": "BTCUSD",
                    //                     "currency": "BTC",
                    //                     "execQty": 18,
                    //                     "side": "Buy",
                    //                     "execPriceEp": 360086455,
                    //                     "execValueEv": 49987,
                    //                     "fundingRateEr": 10000,
                    //                     "feeRateEr": 10000,
                    //                     "execFeeEv": 5,
                    //                     "createTime": 1651881600000
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const rows = this.safeValue(data, 'rows', []);
                    const result = [];
                    for(let i = 0; i < rows.length; i++){
                        const entry = rows[i];
                        const timestamp = this.safeInteger(entry, 'createTime');
                        result.push({
                            'info': entry,
                            'symbol': this.safeString(entry, 'symbol'),
                            'code': this.safeCurrencyCode(this.safeString(entry, 'currency')),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'id': undefined,
                            'amount': this.fromEv(this.safeString(entry, 'execFeeEv'), market)
                        });
                    }
                    return result;
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (!market['swap']) throw new BadSymbol(this.id + ' fetchFundingRate() supports swap contracts only');
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.v1GetMdTicker24hr(this.extend(request, params));
                    //
                    //     {
                    //         "error": null,
                    //         "id": 0,
                    //         "result": {
                    //             "askEp": 2332500,
                    //             "bidEp": 2331000,
                    //             "fundingRateEr": 10000,
                    //             "highEp": 2380000,
                    //             "indexEp": 2329057,
                    //             "lastEp": 2331500,
                    //             "lowEp": 2274000,
                    //             "markEp": 2329232,
                    //             "openEp": 2337500,
                    //             "openInterest": 1298050,
                    //             "predFundingRateEr": 19921,
                    //             "symbol": "ETHUSD",
                    //             "timestamp": 1592474241582701416,
                    //             "turnoverEv": 47228362330,
                    //             "volume": 4053863
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'result', {});
                    return this.parseFundingRate(result, market);
                }
                parseFundingRate(contract, market) {
                    //
                    //     {
                    //         "askEp": 2332500,
                    //         "bidEp": 2331000,
                    //         "fundingRateEr": 10000,
                    //         "highEp": 2380000,
                    //         "indexEp": 2329057,
                    //         "lastEp": 2331500,
                    //         "lowEp": 2274000,
                    //         "markEp": 2329232,
                    //         "openEp": 2337500,
                    //         "openInterest": 1298050,
                    //         "predFundingRateEr": 19921,
                    //         "symbol": "ETHUSD",
                    //         "timestamp": 1592474241582701416,
                    //         "turnoverEv": 47228362330,
                    //         "volume": 4053863
                    //     }
                    //
                    const marketId = this.safeString(contract, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.safeIntegerProduct(contract, 'timestamp', 0.000001);
                    return {
                        'info': contract,
                        'symbol': symbol,
                        'markPrice': this.fromEp(this.safeString(contract, 'markEp'), market),
                        'indexPrice': this.fromEp(this.safeString(contract, 'indexEp'), market),
                        'interestRate': undefined,
                        'estimatedSettlePrice': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fundingRate': this.fromEr(this.safeString(contract, 'fundingRateEr'), market),
                        'fundingTimestamp': undefined,
                        'fundingDatetime': undefined,
                        'nextFundingRate': this.fromEr(this.safeString(contract, 'predFundingRateEr'), market),
                        'nextFundingTimestamp': undefined,
                        'nextFundingDatetime': undefined,
                        'previousFundingRate': undefined,
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                async modifyMarginHelper(symbol, amount, addOrReduce, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'posBalanceEv': this.toEv(amount, market)
                    };
                    const response = await this.privatePostPositionsAssign(this.extend(request, params));
                    //
                    //     {
                    //         "code": 0,
                    //         "msg": "",
                    //         "data": "OK"
                    //     }
                    //
                    return this.extend(this.parseModifyMargin(response, market), {
                        'amount': amount,
                        'type': addOrReduce
                    });
                }
                parseMarginStatus(status) {
                    const statuses = {
                        '0': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseModifyMargin(data, market) {
                    market = this.safeMarket(undefined, market);
                    const inverse = this.safeValue(market, 'inverse');
                    const codeCurrency = inverse ? 'base' : 'quote';
                    return {
                        'info': data,
                        'type': undefined,
                        'amount': undefined,
                        'code': market[codeCurrency],
                        'symbol': this.safeSymbol(undefined, market),
                        'status': this.parseMarginStatus(this.safeString(data, 'code'))
                    };
                }
                async addMargin(symbol, amount, params = {}) {
                    return await this.modifyMarginHelper(symbol, amount, 'add', params);
                }
                async reduceMargin(symbol, amount, params = {}) {
                    if (amount > 0) throw new BadRequest(this.id + ' reduceMargin() amount parameter must be a negative value');
                    return await this.modifyMarginHelper(symbol, amount, 'reduce', params);
                }
                async setMarginMode(marginMode, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setMarginMode() requires a symbol argument');
                    marginMode = marginMode.toLowerCase();
                    if (marginMode !== 'isolated' && marginMode !== 'cross') throw new BadRequest(this.id + ' setMarginMode() marginMode argument should be isolated or cross');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (market['type'] !== 'swap') throw new BadSymbol(this.id + ' setMarginMode() supports swap contracts only');
                    let leverage = this.safeInteger(params, 'leverage');
                    if (marginMode === 'cross') leverage = 0;
                    if (leverage === undefined) throw new ArgumentsRequired1(this.id + ' setMarginMode() requires a leverage parameter');
                    const request = {
                        'symbol': market['id'],
                        'leverage': leverage
                    };
                    return await this.privatePutPositionsLeverage(this.extend(request, params));
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const query = this.omit(params, this.extractParams(path));
                    const requestPath = '/' + this.implodeParams(path, params);
                    let url = requestPath;
                    let queryString = '';
                    if (method === 'GET' || method === 'DELETE' || method === 'PUT' || url === '/positions/assign') {
                        if (Object.keys(query).length) {
                            queryString = this.urlencodeWithArrayRepeat(query);
                            url += '?' + queryString;
                        }
                    }
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.seconds();
                        const xPhemexRequestExpiry = this.safeInteger(this.options, 'x-phemex-request-expiry', 60);
                        const expiry = this.sum(timestamp, xPhemexRequestExpiry);
                        const expiryString = expiry.toString();
                        headers = {
                            'x-phemex-access-token': this.apiKey,
                            'x-phemex-request-expiry': expiryString
                        };
                        let payload = '';
                        if (method === 'POST') {
                            payload = this.json(params);
                            body = payload;
                            headers['Content-Type'] = 'application/json';
                        }
                        const auth = requestPath + queryString + expiryString + payload;
                        headers['x-phemex-request-signature'] = this.hmac(this.encode(auth), this.encode(this.secret));
                    }
                    url = this.implodeHostname(this.urls['api'][api]) + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                async setLeverage(leverage, symbol, params = {}) {
                    // WARNING: THIS WILL INCREASE LIQUIDATION PRICE FOR OPEN ISOLATED LONG POSITIONS
                    // AND DECREASE LIQUIDATION PRICE FOR OPEN ISOLATED SHORT POSITIONS
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    if (leverage < 1 || leverage > 100) throw new BadRequest(this.id + ' setLeverage() leverage should be between 1 and 100');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'leverage': leverage
                    };
                    return await this.privatePutPositionsLeverage(this.extend(request, params));
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                    const toId = this.safeString(accountsByType, toAccount, toAccount);
                    const scaledAmmount = this.toEv(amount, currency);
                    let direction = undefined;
                    let transfer = undefined;
                    if (fromId === 'spot' && toId === 'future') direction = 2;
                    else if (fromId === 'future' && toId === 'spot') direction = 1;
                    if (direction !== undefined) {
                        const request = {
                            'currency': currency['id'],
                            'moveOp': direction,
                            'amountEv': scaledAmmount
                        };
                        const response = await this.privatePostAssetsTransfer(this.extend(request, params));
                        //
                        //     {
                        //         code: '0',
                        //         msg: 'OK',
                        //         data: {
                        //             linkKey: '8564eba4-c9ec-49d6-9b8c-2ec5001a0fb9',
                        //             userId: '4018340',
                        //             currency: 'USD',
                        //             amountEv: '10',
                        //             side: '2',
                        //             status: '10'
                        //         }
                        //     }
                        //
                        const data = this.safeValue(response, 'data', {});
                        transfer = this.parseTransfer(data, currency);
                    } else {
                        const request = {
                            'fromUserId': fromId,
                            'toUserId': toId,
                            'amountEv': scaledAmmount,
                            'currency': currency['id'],
                            'bizType': this.safeString(params, 'bizType', 'SPOT')
                        };
                        const response = await this.privatePostAssetsUniversalTransfer(this.extend(request, params));
                        //
                        //     {
                        //         code: '0',
                        //         msg: 'OK',
                        //         data: 'API-923db826-aaaa-aaaa-aaaa-4d98c3a7c9fd'
                        //     }
                        //
                        transfer = this.parseTransfer(response);
                    }
                    const transferOptions = this.safeValue(this.options, 'transfer', {});
                    const fillResponseFromRequest = this.safeValue(transferOptions, 'fillResponseFromRequest', true);
                    if (fillResponseFromRequest) {
                        if (transfer['fromAccount'] === undefined) transfer['fromAccount'] = fromAccount;
                        if (transfer['toAccount'] === undefined) transfer['toAccount'] = toAccount;
                        if (transfer['amount'] === undefined) transfer['amount'] = amount;
                        if (transfer['currency'] === undefined) transfer['currency'] = code;
                    }
                    return transfer;
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //         linkKey: '8564eba4-c9ec-49d6-9b8c-2ec5001a0fb9',
                    //         userId: '4018340',
                    //         currency: 'USD',
                    //         amountEv: '10',
                    //         side: '2',
                    //         status: '10'
                    //     }
                    //
                    const id = this.safeString(transfer, 'linkKey');
                    const status = this.safeString(transfer, 'status');
                    const amountEv = this.safeString(transfer, 'amountEv');
                    const amountTransfered = this.fromEv(amountEv, currency);
                    const currencyId = this.safeString(transfer, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const side = this.safeInteger(transfer, 'side');
                    let fromId = undefined;
                    let toId = undefined;
                    if (side === 1) {
                        fromId = 'future';
                        toId = 'spot';
                    } else if (side === 2) {
                        fromId = 'spot';
                        toId = 'future';
                    }
                    return {
                        'info': transfer,
                        'id': id,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'currency': code,
                        'amount': amountTransfered,
                        'fromAccount': fromId,
                        'toAccount': toId,
                        'status': this.parseTransferStatus(status)
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        '3': 'rejected',
                        '6': 'canceled',
                        '10': 'ok',
                        '11': 'failed'
                    };
                    return this.safeString(statuses, status, status);
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //     {"code":30018,"msg":"phemex.data.size.uplimt","data":null}
                    //     {"code":412,"msg":"Missing parameter - resolution","data":null}
                    //     {"code":412,"msg":"Missing parameter - to","data":null}
                    //     {"error":{"code":6001,"message":"invalid argument"},"id":null,"result":null}
                    //
                    const error = this.safeValue(response, 'error', response);
                    const errorCode = this.safeString(error, 'code');
                    const message = this.safeString(error, 'msg');
                    if (errorCode !== undefined && errorCode !== '0') {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    116: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, RequestTimeout: RequestTimeout, AuthenticationError: AuthenticationError, PermissionDenied: PermissionDenied, RateLimitExceeded: RateLimitExceeded, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, AccountSuspended: AccountSuspended, CancelPending: CancelPending, InvalidNonce: InvalidNonce, OnMaintenance: OnMaintenance, BadSymbol: BadSymbol } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class poloniex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'poloniex',
                        'name': 'Poloniex',
                        'countries': [
                            'US'
                        ],
                        'rateLimit': 166.667,
                        'certified': false,
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': undefined,
                            'future': undefined,
                            'option': undefined,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrder': 'emulated',
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': true,
                            'fetchOpenOrders': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawals': true,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '5m': 300,
                            '15m': 900,
                            '30m': 1800,
                            '2h': 7200,
                            '4h': 14400,
                            '1d': 86400
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766817-e9456312-5ee6-11e7-9b3c-b628ca5626a5.jpg',
                            'api': {
                                'public': 'https://poloniex.com/public',
                                'private': 'https://poloniex.com/tradingApi'
                            },
                            'www': 'https://www.poloniex.com',
                            'doc': 'https://docs.poloniex.com',
                            'fees': 'https://poloniex.com/fees',
                            'referral': 'https://poloniex.com/signup?c=UBFZJRPJ'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'return24hVolume': 1,
                                    'returnChartData': 1,
                                    'returnCurrencies': 1,
                                    'returnLoanOrders': 1,
                                    'returnOrderBook': 1,
                                    'returnTicker': 1,
                                    'returnTradeHistory': 1
                                }
                            },
                            'private': {
                                'post': {
                                    'buy': 1,
                                    'cancelLoanOffer': 1,
                                    'cancelOrder': 1,
                                    'cancelAllOrders': 1,
                                    'closeMarginPosition': 1,
                                    'createLoanOffer': 1,
                                    'generateNewAddress': 1,
                                    'getMarginPosition': 1,
                                    'marginBuy': 1,
                                    'marginSell': 1,
                                    'moveOrder': 1,
                                    'returnActiveLoans': 1,
                                    'returnAvailableAccountBalances': 1,
                                    'returnBalances': 1,
                                    'returnCompleteBalances': 1,
                                    'returnDepositAddresses': 1,
                                    'returnDepositsWithdrawals': 1,
                                    'returnFeeInfo': 1,
                                    'returnLendingHistory': 1,
                                    'returnMarginAccountSummary': 1,
                                    'returnOpenLoanOffers': 1,
                                    'returnOpenOrders': 1,
                                    'returnOrderTrades': 1,
                                    'returnOrderStatus': 1,
                                    'returnTradableBalances': 1,
                                    'returnTradeHistory': 1,
                                    'sell': 1,
                                    'toggleAutoRenew': 1,
                                    'transferBalance': 1,
                                    'withdraw': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                // starting from Jan 8 2020
                                'maker': this.parseNumber('0.0009'),
                                'taker': this.parseNumber('0.0009')
                            },
                            'funding': {}
                        },
                        'limits': {
                            'amount': {
                                'min': 0.000001,
                                'max': undefined
                            },
                            'price': {
                                'min': 0.00000001,
                                'max': 1000000000
                            },
                            'cost': {
                                'min': 0.00000000,
                                'max': 1000000000
                            }
                        },
                        'precision': {
                            'amount': 8,
                            'price': 8
                        },
                        'commonCurrencies': {
                            'AIR': 'AirCoin',
                            'APH': 'AphroditeCoin',
                            'BCC': 'BTCtalkcoin',
                            'BCHABC': 'BCHABC',
                            'BDG': 'Badgercoin',
                            'BTM': 'Bitmark',
                            'CON': 'Coino',
                            'GOLD': 'GoldEagles',
                            'GPUC': 'GPU',
                            'HOT': 'Hotcoin',
                            'ITC': 'Information Coin',
                            'KEY': 'KEYCoin',
                            'MASK': 'NFTX Hashmasks Index',
                            'MEME': 'Degenerator Meme',
                            'PLX': 'ParallaxCoin',
                            'REPV2': 'REP',
                            'STR': 'XLM',
                            'SOC': 'SOCC',
                            'TRADE': 'Unitrade',
                            'XAP': 'API Coin',
                            // this is not documented in the API docs for Poloniex
                            // https://github.com/ccxt/ccxt/issues/7084
                            // when the user calls withdraw ('USDT', amount, address, tag, params)
                            // with params = { 'currencyToWithdrawAs': 'USDTTRON' }
                            // or params = { 'currencyToWithdrawAs': 'USDTETH' }
                            // fetchWithdrawals ('USDT') returns the corresponding withdrawals
                            // with a USDTTRON or a USDTETH currency id, respectfully
                            // therefore we have map them back to the original code USDT
                            // otherwise the returned withdrawals are filtered out
                            'USDTTRON': 'USDT',
                            'USDTETH': 'USDT'
                        },
                        'options': {
                            'networks': {
                                'ERC20': 'ETH',
                                'TRX': 'TRON',
                                'TRC20': 'TRON'
                            },
                            'limits': {
                                'cost': {
                                    'min': {
                                        'BTC': 0.0001,
                                        'ETH': 0.0001,
                                        'USDT': 1.0,
                                        'TRX': 100,
                                        'BNB': 0.06,
                                        'USDC': 1.0,
                                        'USDJ': 1.0,
                                        'TUSD': 0.0001,
                                        'DAI': 1.0,
                                        'PAX': 1.0,
                                        'BUSD': 1.0
                                    }
                                }
                            },
                            'accountsByType': {
                                'spot': 'exchange',
                                'margin': 'margin',
                                'future': 'futures',
                                'lending': 'lending'
                            },
                            'accountsById': {
                                'exchange': 'spot',
                                'margin': 'margin',
                                'futures': 'future',
                                'lending': 'lending'
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'You may only place orders that reduce your position.': InvalidOrder,
                                'Invalid order number, or you are not the person who placed the order.': OrderNotFound,
                                'Permission denied': PermissionDenied,
                                'Permission denied.': PermissionDenied,
                                'Connection timed out. Please try again.': RequestTimeout,
                                'Internal error. Please try again.': ExchangeNotAvailable,
                                'Currently in maintenance mode.': OnMaintenance,
                                'Order not found, or you are not the person who placed it.': OrderNotFound,
                                'Invalid API key/secret pair.': AuthenticationError,
                                'Please do not make more than 8 API calls per second.': RateLimitExceeded,
                                'This IP has been temporarily throttled. Please ensure your requests are valid and try again in one minute.': RateLimitExceeded,
                                'Rate must be greater than zero.': InvalidOrder,
                                'Invalid currency pair.': BadSymbol,
                                'Invalid currencyPair parameter.': BadSymbol,
                                'Trading is disabled in this market.': BadSymbol,
                                'Invalid orderNumber parameter.': OrderNotFound,
                                'Order is beyond acceptable bounds.': InvalidOrder,
                                'This account is closed.': AccountSuspended
                            },
                            'broad': {
                                'Total must be at least': InvalidOrder,
                                'This account is frozen': AccountSuspended,
                                'This account is locked.': AccountSuspended,
                                'Not enough': InsufficientFunds,
                                'Nonce must be greater': InvalidNonce,
                                'You have already called cancelOrder': CancelPending,
                                'Amount must be at least': InvalidOrder,
                                'is either completed or does not exist': OrderNotFound,
                                'Error pulling ': ExchangeError1
                            }
                        }
                    });
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "date":1590913773,
                    //         "high":0.02491611,
                    //         "low":0.02491611,
                    //         "open":0.02491611,
                    //         "close":0.02491611,
                    //         "volume":0,
                    //         "quoteVolume":0,
                    //         "weightedAverage":0.02491611
                    //     }
                    //
                    return [
                        this.safeTimestamp(ohlcv, 'date'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'quoteVolume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '5m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPair': market['id'],
                        'period': this.timeframes[timeframe]
                    };
                    if (since === undefined) {
                        request['end'] = this.seconds();
                        if (limit === undefined) request['start'] = request['end'] - this.parseTimeframe('1w'); // max range = 1 week
                        else request['start'] = request['end'] - limit * this.parseTimeframe(timeframe);
                    } else {
                        request['start'] = parseInt(since / 1000);
                        if (limit !== undefined) {
                            const end = this.sum(request['start'], limit * this.parseTimeframe(timeframe));
                            request['end'] = end;
                        }
                    }
                    const response = await this.publicGetReturnChartData(this.extend(request, params));
                    //
                    //     [
                    //         {"date":1590913773,"high":0.02491611,"low":0.02491611,"open":0.02491611,"close":0.02491611,"volume":0,"quoteVolume":0,"weightedAverage":0.02491611},
                    //         {"date":1590913800,"high":0.02495324,"low":0.02489501,"open":0.02491797,"close":0.02493693,"volume":0.0927415,"quoteVolume":3.7227869,"weightedAverage":0.02491185},
                    //         {"date":1590914100,"high":0.02498596,"low":0.02488503,"open":0.02493033,"close":0.02497896,"volume":0.21196348,"quoteVolume":8.50291888,"weightedAverage":0.02492832},
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                async loadMarkets(reload = false, params = {}) {
                    const markets = await super.loadMarkets(reload, params);
                    const currenciesByNumericId = this.safeValue(this.options, 'currenciesByNumericId');
                    if (currenciesByNumericId === undefined || reload) this.options['currenciesByNumericId'] = this.indexBy(this.currencies, 'numericId');
                    return markets;
                }
                async fetchMarkets(params = {}) {
                    const markets = await this.publicGetReturnTicker(params);
                    const keys = Object.keys(markets);
                    const result = [];
                    for(let i = 0; i < keys.length; i++){
                        const id = keys[i];
                        const market = markets[id];
                        const [quoteId, baseId] = id.split('_');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const isFrozen = this.safeString(market, 'isFrozen');
                        const marginEnabled = this.safeInteger(market, 'marginTradingEnabled');
                        // these are known defaults
                        result.push({
                            'id': id,
                            'numericId': this.safeInteger(market, 'id'),
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': marginEnabled === 1,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': isFrozen !== '1',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': parseInt('8'),
                                'price': parseInt('8')
                            },
                            'limits': this.extend(this.limits, {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeValue(this.options['limits']['cost']['min'], quote),
                                    'max': undefined
                                }
                            }),
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const currencyIds = Object.keys(response);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const balance = this.safeValue(response, currencyId, {});
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'onOrders');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'account': 'all'
                    };
                    const response = await this.privatePostReturnCompleteBalances(this.extend(request, params));
                    //
                    //     {
                    //         "1CR":{"available":"0.00000000","onOrders":"0.00000000","btcValue":"0.00000000"},
                    //         "ABY":{"available":"0.00000000","onOrders":"0.00000000","btcValue":"0.00000000"},
                    //         "AC":{"available":"0.00000000","onOrders":"0.00000000","btcValue":"0.00000000"},
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostReturnFeeInfo(params);
                    //
                    //     {
                    //         makerFee: '0.00100000',
                    //         takerFee: '0.00200000',
                    //         marginMakerFee: '0.00100000',
                    //         marginTakerFee: '0.00200000',
                    //         thirtyDayVolume: '106.08463302',
                    //         nextTier: 500000,
                    //     }
                    //
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': this.safeNumber(response, 'makerFee'),
                            'taker': this.safeNumber(response, 'takerFee'),
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'currencyPair': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['depth'] = limit; // 100
                    const response = await this.publicGetReturnOrderBook(this.extend(request, params));
                    const orderbook = this.parseOrderBook(response, symbol);
                    orderbook['nonce'] = this.safeInteger(response, 'seq');
                    return orderbook;
                }
                async fetchOrderBooks(symbols, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'currencyPair': 'all'
                    };
                    if (limit !== undefined) request['depth'] = limit; // 100
                    const response = await this.publicGetReturnOrderBook(this.extend(request, params));
                    const marketIds = Object.keys(response);
                    const result = {};
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        let symbol = undefined;
                        if (marketId in this.markets_by_id) symbol = this.markets_by_id[marketId]['symbol'];
                        else {
                            const [quoteId, baseId] = marketId.split('_');
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote;
                        }
                        const orderbook = this.parseOrderBook(response[marketId], symbol);
                        orderbook['nonce'] = this.safeInteger(response[marketId], 'seq');
                        result[symbol] = orderbook;
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    // {
                    //     id: '121',
                    //     last: '43196.31469670',
                    //     lowestAsk: '43209.61843169',
                    //     highestBid: '43162.41965234',
                    //     percentChange: '0.00963340',
                    //     baseVolume: '13444643.33799658',
                    //     quoteVolume: '315.84780115',
                    //     isFrozen: '0',
                    //     postOnly: '0',
                    //     marginTradingEnabled: '1',
                    //     high24hr: '43451.84481934',
                    //     low24hr: '41749.89529736'
                    // }
                    const timestamp = this.milliseconds();
                    const symbol = this.safeSymbol(undefined, market);
                    const last = this.safeString(ticker, 'last');
                    const relativeChange = this.safeString(ticker, 'percentChange');
                    const percentage = Precise.stringMul(relativeChange, '100');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high24hr'),
                        'low': this.safeString(ticker, 'low24hr'),
                        'bid': this.safeString(ticker, 'highestBid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'lowestAsk'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': percentage,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'quoteVolume'),
                        'quoteVolume': this.safeString(ticker, 'baseVolume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetReturnTicker(params);
                    const ids = Object.keys(response);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        let symbol = undefined;
                        let market = undefined;
                        if (id in this.markets_by_id) {
                            market = this.markets_by_id[id];
                            symbol = market['symbol'];
                        } else {
                            const [quoteId, baseId] = id.split('_');
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote;
                            market = {
                                'symbol': symbol
                            };
                        }
                        const ticker = response[id];
                        result[symbol] = this.parseTicker(ticker, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetReturnCurrencies(params);
                    //
                    //     {
                    //       "id": "293",
                    //       "name": "0x",
                    //       "humanType": "Sweep to Main Account",
                    //       "currencyType": "address",
                    //       "txFee": "17.21877546",
                    //       "minConf": "12",
                    //       "depositAddress": null,
                    //       "disabled": "0",
                    //       "frozen": "0",
                    //       "hexColor": "003831",
                    //       "blockchain": "ETH",
                    //       "delisted": "0",
                    //       "isGeofenced": 0
                    //     }
                    //
                    const ids = Object.keys(response);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const currency = response[id];
                        const precision = 8; // default precision, todo: fix "magic constants"
                        const amountLimit = '1e-8';
                        const code = this.safeCurrencyCode(id);
                        const delisted = this.safeInteger(currency, 'delisted', 0);
                        const disabled = this.safeInteger(currency, 'disabled', 0);
                        const listed = !delisted;
                        const enabled = !disabled;
                        const active = enabled && listed;
                        const numericId = this.safeInteger(currency, 'id');
                        const fee = this.safeNumber(currency, 'txFee');
                        result[code] = {
                            'id': id,
                            'numericId': numericId,
                            'code': code,
                            'info': currency,
                            'name': currency['name'],
                            'active': active,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': fee,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': this.parseNumber(amountLimit),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': fee,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const response = await this.publicGetReturnTicker(params);
                    // {
                    //     "BTC_BTS":{
                    //        "id":14,
                    //        "last":"0.00000073",
                    //        "lowestAsk":"0.00000075",
                    //        "highestBid":"0.00000073",
                    //        "percentChange":"0.01388888",
                    //        "baseVolume":"0.01413528",
                    //        "quoteVolume":"19431.16872167",
                    //        "isFrozen":"0",
                    //        "postOnly":"0",
                    //        "marginTradingEnabled":"0",
                    //        "high24hr":"0.00000074",
                    //        "low24hr":"0.00000071"
                    //     },
                    //     ...
                    // }
                    const ticker = response[market['id']];
                    return this.parseTicker(ticker, market);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades
                    //
                    //      {
                    //          globalTradeID: "667563407",
                    //          tradeID: "1984256",
                    //          date: "2022-03-01 20:06:06",
                    //          type: "buy",
                    //          rate: "0.13361871",
                    //          amount: "28.40841257",
                    //          total: "3.79589544",
                    //          orderNumber: "159992152911"
                    //      }
                    //
                    // fetchMyTrades
                    //
                    //     {
                    //       globalTradeID: 471030550,
                    //       tradeID: '42582',
                    //       date: '2020-06-16 09:47:50',
                    //       rate: '0.000079980000',
                    //       amount: '75215.00000000',
                    //       total: '6.01569570',
                    //       fee: '0.00095000',
                    //       feeDisplay: '0.26636100 TRX (0.07125%)',
                    //       orderNumber: '5963454848',
                    //       type: 'sell',
                    //       category: 'exchange'
                    //     }
                    //
                    // createOrder (taker trades)
                    //
                    //     {
                    //         'amount': '200.00000000',
                    //         'date': '2019-12-15 16:04:10',
                    //         'rate': '0.00000355',
                    //         'total': '0.00071000',
                    //         'tradeID': '119871',
                    //         'type': 'buy',
                    //         'takerAdjustment': '200.00000000'
                    //     }
                    //
                    const id = this.safeString2(trade, 'globalTradeID', 'tradeID');
                    const orderId = this.safeString(trade, 'orderNumber');
                    const timestamp = this.parse8601(this.safeString(trade, 'date'));
                    const marketId = this.safeString(trade, 'currencyPair');
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    const side = this.safeString(trade, 'type');
                    let fee = undefined;
                    const priceString = this.safeString(trade, 'rate');
                    const amountString = this.safeString(trade, 'amount');
                    const costString = this.safeString(trade, 'total');
                    const feeDisplay = this.safeString(trade, 'feeDisplay');
                    if (feeDisplay !== undefined) {
                        const parts = feeDisplay.split(' ');
                        const feeCostString = this.safeString(parts, 0);
                        if (feeCostString !== undefined) {
                            const feeCurrencyId = this.safeString(parts, 1);
                            const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                            let feeRateString = this.safeString(parts, 2);
                            if (feeRateString !== undefined) {
                                feeRateString = feeRateString.replace('(', '');
                                const feeRateParts = feeRateString.split('%');
                                feeRateString = this.safeString(feeRateParts, 0);
                                feeRateString = Precise.stringDiv(feeRateString, '100');
                            }
                            fee = {
                                'cost': feeCostString,
                                'currency': feeCurrencyCode,
                                'rate': feeRateString
                            };
                        }
                    } else {
                        const feeCostString = this.safeString(trade, 'fee');
                        if (feeCostString !== undefined && market !== undefined) {
                            const feeCurrencyCode = side === 'buy' ? market['base'] : market['quote'];
                            const feeBase = side === 'buy' ? amountString : costString;
                            const feeRateString = Precise.stringDiv(feeCostString, feeBase);
                            fee = {
                                'cost': feeCostString,
                                'currency': feeCurrencyCode,
                                'rate': feeRateString
                            };
                        }
                    }
                    let takerOrMaker = undefined;
                    const takerAdjustment = this.safeNumber(trade, 'takerAdjustment');
                    if (takerAdjustment !== undefined) takerOrMaker = 'taker';
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': orderId,
                        'type': 'limit',
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': priceString,
                        'amount': amountString,
                        'cost': costString,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPair': market['id']
                    };
                    if (since !== undefined) {
                        request['start'] = parseInt(since / 1000);
                        request['end'] = this.seconds(); // last 50000 trades by default
                    }
                    const trades = await this.publicGetReturnTradeHistory(this.extend(request, params));
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const pair = market ? market['id'] : 'all';
                    const request = {
                        'currencyPair': pair
                    };
                    if (since !== undefined) {
                        request['start'] = parseInt(since / 1000);
                        request['end'] = this.sum(this.seconds(), 1); // adding 1 is a fix for #3411
                    }
                    // limit is disabled (does not really work as expected)
                    if (limit !== undefined) request['limit'] = parseInt(limit);
                    const response = await this.privatePostReturnTradeHistory(this.extend(request, params));
                    //
                    // specific market (symbol defined)
                    //
                    //     [
                    //         {
                    //             globalTradeID: 470912587,
                    //             tradeID: '42543',
                    //             date: '2020-06-15 17:31:22',
                    //             rate: '0.000083840000',
                    //             amount: '95237.60321429',
                    //             total: '7.98472065',
                    //             fee: '0.00095000',
                    //             feeDisplay: '0.36137761 TRX (0.07125%)',
                    //             orderNumber: '5926344995',
                    //             type: 'sell',
                    //             category: 'exchange'
                    //         },
                    //         {
                    //             globalTradeID: 470974497,
                    //             tradeID: '42560',
                    //             date: '2020-06-16 00:41:23',
                    //             rate: '0.000078220000',
                    //             amount: '1000000.00000000',
                    //             total: '78.22000000',
                    //             fee: '0.00095000',
                    //             feeDisplay: '3.48189819 TRX (0.07125%)',
                    //             orderNumber: '5945490830',
                    //             type: 'sell',
                    //             category: 'exchange'
                    //         }
                    //     ]
                    //
                    // all markets (symbol undefined)
                    //
                    //     {
                    //        BTC_GNT: [{
                    //             globalTradeID: 470839947,
                    //             tradeID: '4322347',
                    //             date: '2020-06-15 12:25:24',
                    //             rate: '0.000005810000',
                    //             amount: '1702.04429303',
                    //             total: '0.00988887',
                    //             fee: '0.00095000',
                    //             feeDisplay: '4.18235294 TRX (0.07125%)',
                    //             orderNumber: '102290272520',
                    //             type: 'buy',
                    //             category: 'exchange'
                    //     }, {
                    //             globalTradeID: 470895902,
                    //             tradeID: '4322413',
                    //             date: '2020-06-15 16:19:00',
                    //             rate: '0.000005980000',
                    //             amount: '18.66879219',
                    //             total: '0.00011163',
                    //             fee: '0.00095000',
                    //             feeDisplay: '0.04733727 TRX (0.07125%)',
                    //             orderNumber: '102298304480',
                    //             type: 'buy',
                    //             category: 'exchange'
                    //         }],
                    //     }
                    //
                    let result = [];
                    if (market !== undefined) result = this.parseTrades(response, market);
                    else if (response) {
                        const ids = Object.keys(response);
                        for(let i = 0; i < ids.length; i++){
                            const id = ids[i];
                            let market = undefined;
                            if (id in this.markets_by_id) {
                                market = this.markets_by_id[id];
                                const trades = this.parseTrades(response[id], market);
                                for(let j = 0; j < trades.length; j++)result.push(trades[j]);
                            } else {
                                const [quoteId, baseId] = id.split('_');
                                const base = this.safeCurrencyCode(baseId);
                                const quote = this.safeCurrencyCode(quoteId);
                                const symbol = base + '/' + quote;
                                const trades = response[id];
                                for(let j = 0; j < trades.length; j++){
                                    const market = {
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote
                                    };
                                    result.push(this.parseTrade(trades[j], market));
                                }
                            }
                        }
                    }
                    return this.filterBySinceLimit(result, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'Open': 'open',
                        'Partially filled': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // fetchOpenOrder
                    //
                    //     {
                    //         status: 'Open',
                    //         rate: '0.40000000',
                    //         amount: '1.00000000',
                    //         currencyPair: 'BTC_ETH',
                    //         date: '2018-10-17 17:04:50',
                    //         total: '0.40000000',
                    //         type: 'buy',
                    //         startingAmount: '1.00000',
                    //     }
                    //
                    // fetchOpenOrders
                    //
                    //     {
                    //         orderNumber: '514514894224',
                    //         type: 'buy',
                    //         rate: '0.00001000',
                    //         startingAmount: '100.00000000',
                    //         amount: '100.00000000',
                    //         total: '0.00100000',
                    //         date: '2018-10-23 17:38:53',
                    //         margin: 0,
                    //     }
                    //
                    // createOrder
                    //
                    //     {
                    //         'orderNumber': '9805453960',
                    //         'resultingTrades': [
                    //             {
                    //                 'amount': '200.00000000',
                    //                 'date': '2019-12-15 16:04:10',
                    //                 'rate': '0.00000355',
                    //                 'total': '0.00071000',
                    //                 'tradeID': '119871',
                    //                 'type': 'buy',
                    //                 'takerAdjustment': '200.00000000',
                    //             },
                    //         ],
                    //         'fee': '0.00000000',
                    //         'clientOrderId': '12345',
                    //         'currencyPair': 'BTC_MANA',
                    //         // 'resultingTrades' in editOrder
                    //         'resultingTrades': {
                    //             'BTC_MANA': [],
                    //          }
                    //     }
                    //
                    let timestamp = this.safeInteger(order, 'timestamp');
                    if (timestamp === undefined) timestamp = this.parse8601(this.safeString(order, 'date'));
                    const marketId = this.safeString(order, 'currencyPair');
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    let resultingTrades = this.safeValue(order, 'resultingTrades');
                    if (!Array.isArray(resultingTrades)) resultingTrades = this.safeValue(resultingTrades, this.safeString(market, 'id', marketId));
                    const price = this.safeString2(order, 'price', 'rate');
                    const remaining = this.safeString(order, 'amount');
                    const amount = this.safeString(order, 'startingAmount');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const side = this.safeString(order, 'type');
                    const id = this.safeString(order, 'orderNumber');
                    let fee = undefined;
                    const feeCurrency = this.safeString(order, 'tokenFeeCurrency');
                    let feeCost = undefined;
                    let feeCurrencyCode = undefined;
                    const rate = this.safeString(order, 'fee');
                    if (feeCurrency === undefined) feeCurrencyCode = side === 'buy' ? market['base'] : market['quote'];
                    else {
                        // poloniex accepts a 30% discount to pay fees in TRX
                        feeCurrencyCode = this.safeCurrencyCode(feeCurrency);
                        feeCost = this.safeString(order, 'tokenFee');
                    }
                    if (feeCost !== undefined) fee = {
                        'rate': rate,
                        'cost': feeCost,
                        'currency': feeCurrencyCode
                    };
                    const clientOrderId = this.safeString(order, 'clientOrderId');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': 'limit',
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'average': undefined,
                        'amount': amount,
                        'filled': undefined,
                        'remaining': remaining,
                        'trades': resultingTrades,
                        'fee': fee
                    }, market);
                }
                parseOpenOrders(orders, market, result) {
                    for(let i = 0; i < orders.length; i++){
                        const order = orders[i];
                        const extended = this.extend(order, {
                            'status': 'open',
                            'type': 'limit',
                            'side': order['type'],
                            'price': order['rate']
                        });
                        result.push(this.parseOrder(extended, market));
                    }
                    return result;
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const pair = market ? market['id'] : 'all';
                    const request = {
                        'currencyPair': pair
                    };
                    const response = await this.privatePostReturnOpenOrders(this.extend(request, params));
                    const extension = {
                        'status': 'open'
                    };
                    if (market === undefined) {
                        const marketIds = Object.keys(response);
                        let openOrders = [];
                        for(let i = 0; i < marketIds.length; i++){
                            const marketId = marketIds[i];
                            const orders = response[marketId];
                            const m = this.markets_by_id[marketId];
                            openOrders = this.arrayConcat(openOrders, this.parseOrders(orders, m, undefined, undefined, extension));
                        }
                        return this.filterBySinceLimit(openOrders, since, limit);
                    } else return this.parseOrders(response, market, since, limit, extension);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (type === 'market') throw new ExchangeError1(this.id + ' createOrder() does not accept market orders');
                    await this.loadMarkets();
                    const method = 'privatePost' + this.capitalize(side);
                    const market = this.market(symbol);
                    amount = this.amountToPrecision(symbol, amount);
                    const request = {
                        'currencyPair': market['id'],
                        'rate': this.priceToPrecision(symbol, price),
                        'amount': amount
                    };
                    const clientOrderId = this.safeString(params, 'clientOrderId');
                    if (clientOrderId !== undefined) {
                        request['clientOrderId'] = clientOrderId;
                        params = this.omit(params, 'clientOrderId');
                    }
                    // remember the timestamp before issuing the request
                    let response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         'orderNumber': '9805453960',
                    //         'resultingTrades': [
                    //             {
                    //                 'amount': '200.00000000',
                    //                 'date': '2019-12-15 16:04:10',
                    //                 'rate': '0.00000355',
                    //                 'total': '0.00071000',
                    //                 'tradeID': '119871',
                    //                 'type': 'buy',
                    //                 'takerAdjustment': '200.00000000',
                    //             },
                    //         ],
                    //         'fee': '0.00000000',
                    //         'currencyPair': 'BTC_MANA',
                    //     }
                    //
                    response = this.extend(response, {
                        'type': side
                    });
                    return this.parseOrder(response, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    price = parseFloat(price);
                    const request = {
                        'orderNumber': id,
                        'rate': this.priceToPrecision(symbol, price)
                    };
                    if (amount !== undefined) request['amount'] = this.amountToPrecision(symbol, amount);
                    const response = await this.privatePostMoveOrder(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    const clientOrderId = this.safeValue(params, 'clientOrderId');
                    if (clientOrderId === undefined) request['orderNumber'] = id;
                    else request['clientOrderId'] = clientOrderId;
                    params = this.omit(params, 'clientOrderId');
                    return await this.privatePostCancelOrder(this.extend(request, params));
                }
                async cancelAllOrders(symbol, params = {}) {
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['currencyPair'] = market['id'];
                    }
                    const response = await this.privatePostCancelAllOrders(this.extend(request, params));
                    //
                    //     {
                    //         "success": 1,
                    //         "message": "Orders canceled",
                    //         "orderNumbers": [
                    //             503749,
                    //             888321,
                    //             7315825,
                    //             7316824
                    //         ]
                    //     }
                    //
                    return response;
                }
                async fetchOpenOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    id = id.toString();
                    const request = {
                        'orderNumber': id
                    };
                    const response = await this.privatePostReturnOrderStatus(this.extend(request, params));
                    //
                    //     {
                    //         success: 1,
                    //         result: {
                    //             '6071071': {
                    //                 status: 'Open',
                    //                 rate: '0.40000000',
                    //                 amount: '1.00000000',
                    //                 currencyPair: 'BTC_ETH',
                    //                 date: '2018-10-17 17:04:50',
                    //                 total: '0.40000000',
                    //                 type: 'buy',
                    //                 startingAmount: '1.00000',
                    //             },
                    //         },
                    //     }
                    //
                    const result = this.safeValue(response['result'], id);
                    if (result === undefined) throw new OrderNotFound(this.id + ' order id ' + id + ' not found');
                    return this.extend(this.parseOrder(result), {
                        'id': id
                    });
                }
                async fetchClosedOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderNumber': id
                    };
                    const response = await this.privatePostReturnOrderTrades(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "globalTradeID":570264000,
                    //             "tradeID":8026283,
                    //             "currencyPair":"USDT_LTC",
                    //             "type":"sell",
                    //             "rate":"144.73833409",
                    //             "amount":"0.18334460",
                    //             "total":"26.53699196",
                    //             "fee":"0.00155000",
                    //             "date":"2021-07-04 15:16:20"
                    //         }
                    //     ]
                    //
                    const firstTrade = this.safeValue(response, 0);
                    if (firstTrade === undefined) throw new OrderNotFound(this.id + ' order id ' + id + ' not found');
                    id = this.safeValue(firstTrade, 'globalTradeID', id);
                    return this.safeOrder({
                        'info': response,
                        'id': id,
                        'clientOrderId': this.safeValue(firstTrade, 'clientOrderId'),
                        'timestamp': undefined,
                        'datetime': undefined,
                        'lastTradeTimestamp': undefined,
                        'status': 'closed',
                        'symbol': undefined,
                        'type': undefined,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': undefined,
                        'price': undefined,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'average': undefined,
                        'amount': undefined,
                        'filled': undefined,
                        'remaining': undefined,
                        'trades': response,
                        'fee': undefined
                    });
                }
                async fetchOrderStatus(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const orders = await this.fetchOpenOrders(symbol, undefined, undefined, params);
                    const indexed = this.indexBy(orders, 'id');
                    return id in indexed ? 'open' : 'closed';
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderNumber': id
                    };
                    const trades = await this.privatePostReturnOrderTrades(this.extend(request, params));
                    return this.parseTrades(trades);
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    // USDT, USDTETH, USDTTRON
                    let currencyId = undefined;
                    let currency = undefined;
                    if (code in this.currencies) {
                        currency = this.currency(code);
                        currencyId = currency['id'];
                    } else currencyId = code;
                    const request = {
                        'currency': currencyId
                    };
                    const response = await this.privatePostGenerateNewAddress(this.extend(request, params));
                    let address = undefined;
                    let tag = undefined;
                    const success = this.safeString(response, 'success');
                    if (success === '1') address = this.safeString(response, 'response');
                    this.checkAddress(address);
                    if (currency !== undefined) {
                        const depositAddress = this.safeString(currency['info'], 'depositAddress');
                        if (depositAddress !== undefined) {
                            tag = address;
                            address = depositAddress;
                        }
                    }
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'info': response
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostReturnDepositAddresses(params);
                    // USDT, USDTETH, USDTTRON
                    let currencyId = undefined;
                    let currency = undefined;
                    if (code in this.currencies) {
                        currency = this.currency(code);
                        currencyId = currency['id'];
                    } else currencyId = code;
                    let address = this.safeString(response, currencyId);
                    let tag = undefined;
                    this.checkAddress(address);
                    if (currency !== undefined) {
                        const depositAddress = this.safeString(currency['info'], 'depositAddress');
                        if (depositAddress !== undefined) {
                            tag = address;
                            address = depositAddress;
                        }
                    }
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    amount = this.currencyToPrecision(code, amount);
                    const accountsByType = this.safeValue(this.options, 'accountsByType', {});
                    const fromId = this.safeString(accountsByType, fromAccount, fromAccount);
                    const toId = this.safeString(accountsByType, toAccount, fromAccount);
                    const request = {
                        'amount': amount,
                        'currency': currency['id'],
                        'fromAccount': fromId,
                        'toAccount': toId
                    };
                    const response = await this.privatePostTransferBalance(this.extend(request, params));
                    //
                    //    {
                    //        success: '1',
                    //        message: 'Transferred 1.00000000 USDT from exchange to lending account.'
                    //    }
                    //
                    return this.parseTransfer(response, currency);
                }
                parseTransferStatus(status) {
                    const statuses = {
                        '1': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransfer(transfer, currency) {
                    //
                    //    {
                    //        success: '1',
                    //        message: 'Transferred 1.00000000 USDT from exchange to lending account.'
                    //    }
                    //
                    const message = this.safeString(transfer, 'message');
                    const words = message.split(' ');
                    const amount = this.safeNumber(words, 1);
                    const currencyId = this.safeString(words, 2);
                    const fromAccountId = this.safeString(words, 4);
                    const toAccountId = this.safeString(words, 6);
                    const accountsById = this.safeValue(this.options, 'accountsById', {});
                    return {
                        'info': transfer,
                        'id': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'currency': this.safeCurrencyCode(currencyId, currency),
                        'amount': amount,
                        'fromAccount': this.safeString(accountsById, fromAccountId),
                        'toAccount': this.safeString(accountsById, toAccountId),
                        'status': this.parseOrderStatus(this.safeString(transfer, 'success', 'failed'))
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'amount': amount,
                        'address': address
                    };
                    if (tag !== undefined) request['paymentId'] = tag;
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeString(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['currency'] += network; // when network the currency need to be changed to currency+network https://docs.poloniex.com/#withdraw on MultiChain Currencies section
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privatePostWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         response: 'Withdrew 1.00000000 USDT.',
                    //         email2FA: false,
                    //         withdrawalNumber: 13449869
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                async fetchTransactionsHelper(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const year = 31104000; // 60 * 60 * 24 * 30 * 12 = one year of history, why not
                    const now = this.seconds();
                    const start = since !== undefined ? parseInt(since / 1000) : now - 10 * year;
                    const request = {
                        'start': start,
                        'end': now
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privatePostReturnDepositsWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         "adjustments":[],
                    //         "deposits":[
                    //             {
                    //                 currency: "BTC",
                    //                 address: "1MEtiqJWru53FhhHrfJPPvd2tC3TPDVcmW",
                    //                 amount: "0.01063000",
                    //                 confirmations:  1,
                    //                 txid: "952b0e1888d6d491591facc0d37b5ebec540ac1efb241fdbc22bcc20d1822fb6",
                    //                 timestamp:  1507916888,
                    //                 status: "COMPLETE"
                    //             },
                    //             {
                    //                 currency: "ETH",
                    //                 address: "0x20108ba20b65c04d82909e91df06618107460197",
                    //                 amount: "4.00000000",
                    //                 confirmations: 38,
                    //                 txid: "0x4be260073491fe63935e9e0da42bd71138fdeb803732f41501015a2d46eb479d",
                    //                 timestamp: 1525060430,
                    //                 status: "COMPLETE"
                    //             }
                    //         ],
                    //         "withdrawals":[
                    //             {
                    //                 "withdrawalNumber":13449869,
                    //                 "currency":"USDTTRON", // not documented in API docs, see commonCurrencies in describe()
                    //                 "address":"TXGaqPW23JdRWhsVwS2mRsGsegbdnAd3Rw",
                    //                 "amount":"1.00000000",
                    //                 "fee":"0.00000000",
                    //                 "timestamp":1591573420,
                    //                 "status":"COMPLETE: dadf427224b3d44b38a2c13caa4395e4666152556ca0b2f67dbd86a95655150f",
                    //                 "ipAddress":"x.x.x.x",
                    //                 "canCancel":0,
                    //                 "canResendEmail":0,
                    //                 "paymentID":null,
                    //                 "scope":"crypto"
                    //             },
                    //             {
                    //                 withdrawalNumber: 8224394,
                    //                 currency: "EMC2",
                    //                 address: "EYEKyCrqTNmVCpdDV8w49XvSKRP9N3EUyF",
                    //                 amount: "63.10796020",
                    //                 fee: "0.01000000",
                    //                 timestamp: 1510819838,
                    //                 status: "COMPLETE: d37354f9d02cb24d98c8c4fc17aa42f475530b5727effdf668ee5a43ce667fd6",
                    //                 ipAddress: "x.x.x.x"
                    //             },
                    //             {
                    //                 withdrawalNumber: 9290444,
                    //                 currency: "ETH",
                    //                 address: "0x191015ff2e75261d50433fbd05bd57e942336149",
                    //                 amount: "0.15500000",
                    //                 fee: "0.00500000",
                    //                 timestamp: 1514099289,
                    //                 status: "COMPLETE: 0x12d444493b4bca668992021fd9e54b5292b8e71d9927af1f076f554e4bea5b2d",
                    //                 ipAddress: "x.x.x.x"
                    //             },
                    //             {
                    //                 withdrawalNumber: 11518260,
                    //                 currency: "BTC",
                    //                 address: "8JoDXAmE1GY2LRK8jD1gmAmgRPq54kXJ4t",
                    //                 amount: "0.20000000",
                    //                 fee: "0.00050000",
                    //                 timestamp: 1527918155,
                    //                 status: "COMPLETE: 1864f4ebb277d90b0b1ff53259b36b97fa1990edc7ad2be47c5e0ab41916b5ff",
                    //                 ipAddress: "x.x.x.x"
                    //             }
                    //         ]
                    //     }
                    //
                    return response;
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const response = await this.fetchTransactionsHelper(code, since, limit, params);
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const withdrawals = this.safeValue(response, 'withdrawals', []);
                    const deposits = this.safeValue(response, 'deposits', []);
                    const withdrawalTransactions = this.parseTransactions(withdrawals, currency, since, limit);
                    const depositTransactions = this.parseTransactions(deposits, currency, since, limit);
                    const transactions = this.arrayConcat(depositTransactions, withdrawalTransactions);
                    return this.filterByCurrencySinceLimit(this.sortBy(transactions, 'timestamp'), code, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    const response = await this.fetchTransactionsHelper(code, since, limit, params);
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const withdrawals = this.safeValue(response, 'withdrawals', []);
                    const transactions = this.parseTransactions(withdrawals, currency, since, limit);
                    return this.filterByCurrencySinceLimit(transactions, code, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    const response = await this.fetchTransactionsHelper(code, since, limit, params);
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const deposits = this.safeValue(response, 'deposits', []);
                    const transactions = this.parseTransactions(deposits, currency, since, limit);
                    return this.filterByCurrencySinceLimit(transactions, code, since, limit);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'COMPLETE': 'ok',
                        'AWAITING APPROVAL': 'pending',
                        'PENDING': 'pending',
                        'PROCESSING': 'pending',
                        'COMPLETE ERROR': 'failed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // deposits
                    //
                    //     {
                    //         "txid": "f49d489616911db44b740612d19464521179c76ebe9021af85b6de1e2f8d68cd",
                    //         "type": "deposit",
                    //         "amount": "49798.01987021",
                    //         "status": "COMPLETE",
                    //         "address": "DJVJZ58tJC8UeUv9Tqcdtn6uhWobouxFLT",
                    //         "currency": "DOGE",
                    //         "timestamp": 1524321838,
                    //         "confirmations": 3371,
                    //         "depositNumber": 134587098
                    //     }
                    //
                    // withdrawals
                    //
                    //     {
                    //         "fee": "0.00050000",
                    //         "type": "withdrawal",
                    //         "amount": "0.40234387",
                    //         "status": "COMPLETE: fbabb2bf7d81c076f396f3441166d5f60f6cea5fdfe69e02adcc3b27af8c2746",
                    //         "address": "1EdAqY4cqHoJGAgNfUFER7yZpg1Jc9DUa3",
                    //         "currency": "BTC",
                    //         "canCancel": 0,
                    //         "ipAddress": "x.x.x.x",
                    //         "paymentID": null,
                    //         "timestamp": 1523834337,
                    //         "canResendEmail": 0,
                    //         "withdrawalNumber": 11162900
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         response: 'Withdrew 1.00000000 USDT.',
                    //         email2FA: false,
                    //         withdrawalNumber: 13449869
                    //     }
                    //
                    const timestamp = this.safeTimestamp(transaction, 'timestamp');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    let status = this.safeString(transaction, 'status', 'pending');
                    let txid = this.safeString(transaction, 'txid');
                    if (status !== undefined) {
                        const parts = status.split(': ');
                        const numParts = parts.length;
                        status = parts[0];
                        if (numParts > 1 && txid === undefined) txid = parts[1];
                        status = this.parseTransactionStatus(status);
                    }
                    const defaultType = 'withdrawalNumber' in transaction ? 'withdrawal' : 'deposit';
                    const type = this.safeString(transaction, 'type', defaultType);
                    const id = this.safeString2(transaction, 'withdrawalNumber', 'depositNumber');
                    let amount = this.safeNumber(transaction, 'amount');
                    const address = this.safeString(transaction, 'address');
                    const tag = this.safeString(transaction, 'paymentID');
                    // according to https://poloniex.com/fees/
                    const feeCost = this.safeNumber(transaction, 'fee', 0);
                    if (type === 'withdrawal') // poloniex withdrawal amount includes the fee
                    amount = amount - feeCost;
                    return {
                        'info': transaction,
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'status': status,
                        'type': type,
                        'updated': undefined,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': {
                            'currency': code,
                            'cost': feeCost
                        }
                    };
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPair': market['id']
                    };
                    const response = await this.privatePostGetMarginPosition(this.extend(request, params));
                    //
                    //     {
                    //         type: "none",
                    //         amount: "0.00000000",
                    //         total: "0.00000000",
                    //         basePrice: "0.00000000",
                    //         liquidationPrice: -1,
                    //         pl: "0.00000000",
                    //         lendingFees: "0.00000000"
                    //     }
                    //
                    // todo unify parsePosition/parsePositions
                    return response;
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api];
                    const query = this.extend({
                        'command': path
                    }, params);
                    if (api === 'public') url += '?' + this.urlencode(query);
                    else {
                        this.checkRequiredCredentials();
                        query['nonce'] = this.nonce();
                        body = this.urlencode(query);
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Key': this.apiKey,
                            'Sign': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    // {"error":"Permission denied."}
                    if ('error' in response) {
                        const message = response['error'];
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    117: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ExchangeNotAvailable: ExchangeNotAvailable, BadResponse: BadResponse, BadRequest: BadRequest, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, AuthenticationError: AuthenticationError, ArgumentsRequired: ArgumentsRequired1, InvalidAddress: InvalidAddress, RateLimitExceeded: RateLimitExceeded, DDoSProtection: DDoSProtection, BadSymbol: BadSymbol } = require1('./base/errors');
            const { TRUNCATE: TRUNCATE, TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class probit extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'probit',
                        'name': 'ProBit',
                        'countries': [
                            'SC',
                            'KR'
                        ],
                        'rateLimit': 50,
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createMarketOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'signIn': true,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '3m': '3m',
                            '5m': '5m',
                            '10m': '10m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '4h': '4h',
                            '6h': '6h',
                            '12h': '12h',
                            '1d': '1D',
                            '1w': '1W',
                            '1M': '1M'
                        },
                        'version': 'v1',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/79268032-c4379480-7ea2-11ea-80b3-dd96bb29fd0d.jpg',
                            'api': {
                                'accounts': 'https://accounts.probit.com',
                                'public': 'https://api.probit.com/api/exchange',
                                'private': 'https://api.probit.com/api/exchange'
                            },
                            'www': 'https://www.probit.com',
                            'doc': [
                                'https://docs-en.probit.com',
                                'https://docs-ko.probit.com'
                            ],
                            'fees': 'https://support.probit.com/hc/en-us/articles/360020968611-Trading-Fees',
                            'referral': 'https://www.probit.com/r/34608773'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'market': 1,
                                    'currency': 1,
                                    'currency_with_platform': 1,
                                    'time': 1,
                                    'ticker': 1,
                                    'order_book': 1,
                                    'trade': 1,
                                    'candle': 1
                                }
                            },
                            'private': {
                                'post': {
                                    'new_order': 2,
                                    'cancel_order': 1,
                                    'withdrawal': 2
                                },
                                'get': {
                                    'balance': 1,
                                    'order': 1,
                                    'open_order': 1,
                                    'order_history': 1,
                                    'trade_history': 1,
                                    'deposit_address': 1
                                }
                            },
                            'accounts': {
                                'post': {
                                    'token': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.002'),
                                'taker': this.parseNumber('0.002')
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'UNAUTHORIZED': AuthenticationError,
                                'INVALID_ARGUMENT': BadRequest,
                                'TRADING_UNAVAILABLE': ExchangeNotAvailable,
                                'NOT_ENOUGH_BALANCE': InsufficientFunds,
                                'NOT_ALLOWED_COMBINATION': BadRequest,
                                'INVALID_ORDER': InvalidOrder,
                                'RATE_LIMIT_EXCEEDED': RateLimitExceeded,
                                'MARKET_UNAVAILABLE': ExchangeNotAvailable,
                                'INVALID_MARKET': BadSymbol,
                                'MARKET_CLOSED': BadSymbol,
                                'MARKET_NOT_FOUND': BadSymbol,
                                'INVALID_CURRENCY': BadRequest,
                                'TOO_MANY_OPEN_ORDERS': DDoSProtection,
                                'DUPLICATE_ADDRESS': InvalidAddress,
                                'invalid_grant': AuthenticationError
                            }
                        },
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': true
                        },
                        'precisionMode': TICK_SIZE,
                        'options': {
                            'createMarketBuyOrderRequiresPrice': true,
                            'timeInForce': {
                                'limit': 'gtc',
                                'market': 'ioc'
                            },
                            'networks': {
                                'BEP20': 'BSC',
                                'ERC20': 'ETH',
                                'TRC20': 'TRON',
                                'TRX': 'TRON'
                            }
                        },
                        'commonCurrencies': {
                            'AUTO': 'Cube',
                            'AZU': 'Azultec',
                            'BCC': 'BCC',
                            'BDP': 'BidiPass',
                            'BIRD': 'Birdchain',
                            'BTCBEAR': 'BEAR',
                            'BTCBULL': 'BULL',
                            'CBC': 'CryptoBharatCoin',
                            'CHE': 'Chellit',
                            'CLR': 'Color Platform',
                            'CTK': 'Cryptyk',
                            'CTT': 'Castweet',
                            'DIP': 'Dipper',
                            'DKT': 'DAKOTA',
                            'EGC': 'EcoG9coin',
                            'EPS': 'Epanus',
                            'FX': 'Fanzy',
                            'GDT': 'Gorilla Diamond',
                            'GM': 'GM Holding',
                            'GOGOL': 'GOL',
                            'GOL': 'Goldofir',
                            'GRB': 'Global Reward Bank',
                            'HBC': 'Hybrid Bank Cash',
                            'HUSL': 'The Hustle App',
                            'LAND': 'Landbox',
                            'LBK': 'Legal Block',
                            'ORC': 'Oracle System',
                            'PXP': 'PIXSHOP COIN',
                            'PYE': 'CreamPYE',
                            'ROOK': 'Reckoon',
                            'SOC': 'Soda Coin',
                            'SST': 'SocialSwap',
                            'TCT': 'Top Coin Token',
                            'TOR': 'Torex',
                            'TPAY': 'Tetra Pay',
                            'UNI': 'UNICORN Token',
                            'UNISWAP': 'UNI'
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetMarket(params);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "id":"MONA-USDT",
                    //                 "base_currency_id":"MONA",
                    //                 "quote_currency_id":"USDT",
                    //                 "min_price":"0.001",
                    //                 "max_price":"9999999999999999",
                    //                 "price_increment":"0.001",
                    //                 "min_quantity":"0.0001",
                    //                 "max_quantity":"9999999999999999",
                    //                 "quantity_precision":4,
                    //                 "min_cost":"1",
                    //                 "max_cost":"9999999999999999",
                    //                 "cost_precision":8,
                    //                 "taker_fee_rate":"0.2",
                    //                 "maker_fee_rate":"0.2",
                    //                 "show_in_ui":true,
                    //                 "closed":false
                    //             },
                    //         ]
                    //     }
                    //
                    const markets = this.safeValue(response, 'data', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'id');
                        const baseId = this.safeString(market, 'base_currency_id');
                        const quoteId = this.safeString(market, 'quote_currency_id');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const closed = this.safeValue(market, 'closed', false);
                        const amountPrecision = this.safeString(market, 'quantity_precision');
                        const costPrecision = this.safeString(market, 'cost_precision');
                        const amountTickSize = this.parsePrecision(amountPrecision);
                        const costTickSize = this.parsePrecision(costPrecision);
                        const takerFeeRate = this.safeString(market, 'taker_fee_rate');
                        const taker = Precise.stringDiv(takerFeeRate, '100');
                        const makerFeeRate = this.safeString(market, 'maker_fee_rate');
                        const maker = Precise.stringDiv(makerFeeRate, '100');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': !closed,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.parseNumber(taker),
                            'maker': this.parseNumber(maker),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.parseNumber(amountTickSize),
                                'price': this.safeNumber(market, 'price_increment'),
                                'cost': this.parseNumber(costTickSize)
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min_quantity'),
                                    'max': this.safeNumber(market, 'max_quantity')
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'min_price'),
                                    'max': this.safeNumber(market, 'max_price')
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_cost'),
                                    'max': this.safeNumber(market, 'max_cost')
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencyWithPlatform(params);
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "id":"USDT",
                    //                 "display_name":{"ko-kr":"테더","en-us":"Tether"},
                    //                 "show_in_ui":true,
                    //                 "platform":[
                    //                     {
                    //                         "id":"ETH",
                    //                         "priority":1,
                    //                         "deposit":true,
                    //                         "withdrawal":true,
                    //                         "currency_id":"USDT",
                    //                         "precision":6,
                    //                         "min_confirmation_count":15,
                    //                         "require_destination_tag":false,
                    //                         "display_name":{"name":{"ko-kr":"ERC-20","en-us":"ERC-20"}},
                    //                         "min_deposit_amount":"0",
                    //                         "min_withdrawal_amount":"1",
                    //                         "withdrawal_fee":[
                    //                             {"amount":"0.01","priority":2,"currency_id":"ETH"},
                    //                             {"amount":"1.5","priority":1,"currency_id":"USDT"},
                    //                         ],
                    //                         "deposit_fee":{},
                    //                         "suspended_reason":"",
                    //                         "deposit_suspended":false,
                    //                         "withdrawal_suspended":false
                    //                     },
                    //                     {
                    //                         "id":"OMNI",
                    //                         "priority":2,
                    //                         "deposit":true,
                    //                         "withdrawal":true,
                    //                         "currency_id":"USDT",
                    //                         "precision":6,
                    //                         "min_confirmation_count":3,
                    //                         "require_destination_tag":false,
                    //                         "display_name":{"name":{"ko-kr":"OMNI","en-us":"OMNI"}},
                    //                         "min_deposit_amount":"0",
                    //                         "min_withdrawal_amount":"5",
                    //                         "withdrawal_fee":[{"amount":"5","priority":1,"currency_id":"USDT"}],
                    //                         "deposit_fee":{},
                    //                         "suspended_reason":"wallet_maintenance",
                    //                         "deposit_suspended":false,
                    //                         "withdrawal_suspended":false
                    //                     }
                    //                 ],
                    //                 "stakeable":false,
                    //                 "unstakeable":false,
                    //                 "auto_stake":false,
                    //                 "auto_stake_amount":"0"
                    //             }
                    //         ]
                    //     }
                    //
                    const currencies = this.safeValue(response, 'data');
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'id');
                        const code = this.safeCurrencyCode(id);
                        const displayName = this.safeValue(currency, 'display_name');
                        const name = this.safeString(displayName, 'en-us');
                        const platforms = this.safeValue(currency, 'platform', []);
                        const platformsByPriority = this.sortBy(platforms, 'priority');
                        const platform = this.safeValue(platformsByPriority, 0, {});
                        const precision = this.safeInteger(platform, 'precision');
                        const depositSuspended = this.safeValue(platform, 'deposit_suspended');
                        const withdrawalSuspended = this.safeValue(platform, 'withdrawal_suspended');
                        const deposit = !depositSuspended;
                        const withdraw = !withdrawalSuspended;
                        const active = deposit && withdraw;
                        const withdrawalFees = this.safeValue(platform, 'withdrawal_fee', {});
                        const fees = [];
                        // sometimes the withdrawal fee is an empty object
                        // [ { 'amount': '0.015', 'priority': 1, 'currency_id': 'ETH' }, {} ]
                        for(let j = 0; j < withdrawalFees.length; j++){
                            const withdrawalFee = withdrawalFees[j];
                            const amount = this.safeNumber(withdrawalFee, 'amount');
                            const priority = this.safeInteger(withdrawalFee, 'priority');
                            if (amount !== undefined && priority !== undefined) fees.push(withdrawalFee);
                        }
                        const withdrawalFeesByPriority = this.sortBy(fees, 'priority');
                        const withdrawalFee = this.safeValue(withdrawalFeesByPriority, 0, {});
                        const fee = this.safeNumber(withdrawalFee, 'amount');
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'name': name,
                            'active': active,
                            'deposit': deposit,
                            'withdraw': withdraw,
                            'fee': fee,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'deposit': {
                                    'min': this.safeNumber(platform, 'min_deposit_amount'),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(platform, 'min_withdrawal_amount'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const data = this.safeValue(response, 'data');
                    for(let i = 0; i < data.length; i++){
                        const balance = data[i];
                        const currencyId = this.safeString(balance, 'currency_id');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'total');
                        account['free'] = this.safeString(balance, 'available');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalance(params);
                    //
                    //     {
                    //         data: [
                    //             {
                    //                 "currency_id":"XRP",
                    //                 "total":"100",
                    //                 "available":"0",
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_id': market['id']
                    };
                    const response = await this.publicGetOrderBook(this.extend(request, params));
                    //
                    //     {
                    //         data: [
                    //             { side: 'buy', price: '0.000031', quantity: '10' },
                    //             { side: 'buy', price: '0.00356007', quantity: '4.92156877' },
                    //             { side: 'sell', price: '0.1857', quantity: '0.17' },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const dataBySide = this.groupBy(data, 'side');
                    return this.parseOrderBook(dataBySide, symbol, undefined, 'buy', 'sell', 'price', 'quantity');
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbols !== undefined) {
                        const marketIds = this.marketIds(symbols);
                        request['market_ids'] = marketIds.join(',');
                    }
                    const response = await this.publicGetTicker(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "last":"0.022902",
                    //                 "low":"0.021693",
                    //                 "high":"0.024093",
                    //                 "change":"-0.000047",
                    //                 "base_volume":"15681.986",
                    //                 "quote_volume":"360.514403624",
                    //                 "market_id":"ETH-BTC",
                    //                 "time":"2020-04-12T18:43:38.000Z"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTickers(data, symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_ids': market['id']
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "last":"0.022902",
                    //                 "low":"0.021693",
                    //                 "high":"0.024093",
                    //                 "change":"-0.000047",
                    //                 "base_volume":"15681.986",
                    //                 "quote_volume":"360.514403624",
                    //                 "market_id":"ETH-BTC",
                    //                 "time":"2020-04-12T18:43:38.000Z"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const ticker = this.safeValue(data, 0);
                    if (ticker === undefined) throw new BadResponse(this.id + ' fetchTicker() returned an empty response');
                    return this.parseTicker(ticker, market);
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "last":"0.022902",
                    //         "low":"0.021693",
                    //         "high":"0.024093",
                    //         "change":"-0.000047",
                    //         "base_volume":"15681.986",
                    //         "quote_volume":"360.514403624",
                    //         "market_id":"ETH-BTC",
                    //         "time":"2020-04-12T18:43:38.000Z"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(ticker, 'time'));
                    const marketId = this.safeString(ticker, 'market_id');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const close = this.safeString(ticker, 'last');
                    const change = this.safeString(ticker, 'change');
                    const baseVolume = this.safeString(ticker, 'base_volume');
                    const quoteVolume = this.safeString(ticker, 'quote_volume');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': close,
                        'last': close,
                        'previousClose': undefined,
                        'change': change,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                        'limit': 100,
                        'start_time': this.iso8601(0),
                        'end_time': this.iso8601(this.milliseconds())
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market_id'] = market['id'];
                    }
                    if (since !== undefined) request['start_time'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetTradeHistory(this.extend(request, params));
                    //
                    //     {
                    //         data: [
                    //             {
                    //                 "id":"BTC-USDT:183566",
                    //                 "order_id":"17209376",
                    //                 "side":"sell",
                    //                 "fee_amount":"0.657396569175",
                    //                 "fee_currency_id":"USDT",
                    //                 "status":"settled",
                    //                 "price":"6573.96569175",
                    //                 "quantity":"0.1",
                    //                 "cost":"657.396569175",
                    //                 "time":"2018-08-10T06:06:46.000Z",
                    //                 "market_id":"BTC-USDT"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_id': market['id'],
                        'limit': 100,
                        'start_time': '1970-01-01T00:00:00.000Z',
                        'end_time': this.iso8601(this.milliseconds())
                    };
                    if (since !== undefined) request['start_time'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetTrade(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "id":"ETH-BTC:3331886",
                    //                 "price":"0.022981",
                    //                 "quantity":"12.337",
                    //                 "time":"2020-04-12T20:55:42.371Z",
                    //                 "side":"sell",
                    //                 "tick_direction":"down"
                    //             },
                    //             {
                    //                 "id":"ETH-BTC:3331885",
                    //                 "price":"0.022982",
                    //                 "quantity":"6.472",
                    //                 "time":"2020-04-12T20:55:39.652Z",
                    //                 "side":"sell",
                    //                 "tick_direction":"down"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "id":"ETH-BTC:3331886",
                    //         "price":"0.022981",
                    //         "quantity":"12.337",
                    //         "time":"2020-04-12T20:55:42.371Z",
                    //         "side":"sell",
                    //         "tick_direction":"down"
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "id":"BTC-USDT:183566",
                    //         "order_id":"17209376",
                    //         "side":"sell",
                    //         "fee_amount":"0.657396569175",
                    //         "fee_currency_id":"USDT",
                    //         "status":"settled",
                    //         "price":"6573.96569175",
                    //         "quantity":"0.1",
                    //         "cost":"657.396569175",
                    //         "time":"2018-08-10T06:06:46.000Z",
                    //         "market_id":"BTC-USDT"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(trade, 'time'));
                    const id = this.safeString(trade, 'id');
                    let marketId = undefined;
                    if (id !== undefined) {
                        const parts = id.split(':');
                        marketId = this.safeString(parts, 0);
                    }
                    marketId = this.safeString(trade, 'market_id', marketId);
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const side = this.safeString(trade, 'side');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'quantity');
                    const orderId = this.safeString(trade, 'order_id');
                    const feeCostString = this.safeString(trade, 'fee_amount');
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'fee_currency_id');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTime(params);
                    //
                    //     { "data":"2020-04-12T18:54:25.390Z" }
                    //
                    const timestamp = this.parse8601(this.safeString(response, 'data'));
                    return timestamp;
                }
                normalizeOHLCVTimestamp(timestamp, timeframe, after = false) {
                    const duration = this.parseTimeframe(timeframe);
                    if (timeframe === '1M') {
                        const iso8601 = this.iso8601(timestamp);
                        const parts = iso8601.split('-');
                        const year = this.safeString(parts, 0);
                        let month = this.safeInteger(parts, 1);
                        if (after) month = this.sum(month, 1);
                        if (month < 10) month = '0' + month.toString();
                        else month = month.toString();
                        return year + '-' + month + '-01T00:00:00.000Z';
                    } else if (timeframe === '1w') {
                        timestamp = parseInt(timestamp / 1000);
                        const firstSunday = 259200; // 1970-01-04T00:00:00.000Z
                        const difference = timestamp - firstSunday;
                        const numWeeks = Math.floor(difference / duration);
                        let previousSunday = this.sum(firstSunday, numWeeks * duration);
                        if (after) previousSunday = this.sum(previousSunday, duration);
                        return this.iso8601(previousSunday * 1000);
                    } else {
                        timestamp = parseInt(timestamp / 1000);
                        timestamp = duration * parseInt(timestamp / duration);
                        if (after) timestamp = this.sum(timestamp, duration);
                        return this.iso8601(timestamp * 1000);
                    }
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const interval = this.timeframes[timeframe];
                    limit = limit === undefined ? 100 : limit;
                    let requestLimit = this.sum(limit, 1);
                    requestLimit = Math.min(1000, requestLimit); // max 1000
                    const request = {
                        'market_ids': market['id'],
                        'interval': interval,
                        'sort': 'asc',
                        'limit': requestLimit
                    };
                    const now = this.milliseconds();
                    const duration = this.parseTimeframe(timeframe);
                    let startTime = since;
                    let endTime = now;
                    if (since === undefined) {
                        if (limit === undefined) throw new ArgumentsRequired1(this.id + ' fetchOHLCV() requires either a since argument or a limit argument');
                        else startTime = now - limit * duration * 1000;
                    } else if (limit === undefined) endTime = now;
                    else endTime = this.sum(since, this.sum(limit, 1) * duration * 1000);
                    const startTimeNormalized = this.normalizeOHLCVTimestamp(startTime, timeframe);
                    const endTimeNormalized = this.normalizeOHLCVTimestamp(endTime, timeframe, true);
                    request['start_time'] = startTimeNormalized;
                    request['end_time'] = endTimeNormalized;
                    const response = await this.publicGetCandle(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "market_id":"ETH-BTC",
                    //                 "open":"0.02811",
                    //                 "close":"0.02811",
                    //                 "low":"0.02811",
                    //                 "high":"0.02811",
                    //                 "base_volume":"0.0005",
                    //                 "quote_volume":"0.000014055",
                    //                 "start_time":"2018-11-30T18:19:00.000Z",
                    //                 "end_time":"2018-11-30T18:20:00.000Z"
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "market_id":"ETH-BTC",
                    //         "open":"0.02811",
                    //         "close":"0.02811",
                    //         "low":"0.02811",
                    //         "high":"0.02811",
                    //         "base_volume":"0.0005",
                    //         "quote_volume":"0.000014055",
                    //         "start_time":"2018-11-30T18:19:00.000Z",
                    //         "end_time":"2018-11-30T18:20:00.000Z"
                    //     }
                    //
                    return [
                        this.parse8601(this.safeString(ohlcv, 'start_time')),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'base_volume')
                    ];
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    since = this.parse8601(since);
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market_id'] = market['id'];
                    }
                    const response = await this.privateGetOpenOrder(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'start_time': this.iso8601(0),
                        'end_time': this.iso8601(this.milliseconds()),
                        'limit': 100
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market_id'] = market['id'];
                    }
                    if (since) request['start_time'] = this.iso8601(since);
                    if (limit) request['limit'] = limit;
                    const response = await this.privateGetOrderHistory(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_id': market['id']
                    };
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client_order_id');
                    if (clientOrderId !== undefined) request['client_order_id'] = clientOrderId;
                    else request['order_id'] = id;
                    const query = this.omit(params, [
                        'clientOrderId',
                        'client_order_id'
                    ]);
                    const response = await this.privateGetOrder(this.extend(request, query));
                    const data = this.safeValue(response, 'data', []);
                    const order = this.safeValue(data, 0);
                    return this.parseOrder(order, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'open': 'open',
                        'cancelled': 'canceled',
                        'filled': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         id: string,
                    //         user_id: string,
                    //         market_id: string,
                    //         type: 'orderType',
                    //         side: 'side',
                    //         quantity: string,
                    //         limit_price: string,
                    //         time_in_force: 'timeInForce',
                    //         filled_cost: string,
                    //         filled_quantity: string,
                    //         open_quantity: string,
                    //         cancelled_quantity: string,
                    //         status: 'orderStatus',
                    //         time: 'date',
                    //         client_order_id: string,
                    //     }
                    //
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const id = this.safeString(order, 'id');
                    const type = this.safeString(order, 'type');
                    const side = this.safeString(order, 'side');
                    const marketId = this.safeString(order, 'market_id');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const timestamp = this.parse8601(this.safeString(order, 'time'));
                    let price = this.safeString(order, 'limit_price');
                    const filled = this.safeString(order, 'filled_quantity');
                    let remaining = this.safeString(order, 'open_quantity');
                    const canceledAmount = this.safeString(order, 'cancelled_quantity');
                    if (canceledAmount !== undefined) remaining = Precise.stringAdd(remaining, canceledAmount);
                    const amount = this.safeString(order, 'quantity', Precise.stringAdd(filled, remaining));
                    const cost = this.safeString2(order, 'filled_cost', 'cost');
                    if (type === 'market') price = undefined;
                    let clientOrderId = this.safeString(order, 'client_order_id');
                    if (clientOrderId === '') clientOrderId = undefined;
                    const timeInForce = this.safeStringUpper(order, 'time_in_force');
                    return this.safeOrder({
                        'id': id,
                        'info': order,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': timeInForce,
                        'side': side,
                        'status': status,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'average': undefined,
                        'cost': cost,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                costToPrecision(symbol, cost) {
                    return this.decimalToPrecision(cost, TRUNCATE, this.markets[symbol]['precision']['cost'], this.precisionMode);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const options = this.safeValue(this.options, 'timeInForce');
                    const defaultTimeInForce = this.safeValue(options, type);
                    const timeInForce = this.safeString2(params, 'timeInForce', 'time_in_force', defaultTimeInForce);
                    const request = {
                        'market_id': market['id'],
                        'type': type,
                        'side': side,
                        'time_in_force': timeInForce
                    };
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'client_order_id');
                    if (clientOrderId !== undefined) request['client_order_id'] = clientOrderId;
                    let costToPrecision = undefined;
                    if (type === 'limit') {
                        request['limit_price'] = this.priceToPrecision(symbol, price);
                        request['quantity'] = this.amountToPrecision(symbol, amount);
                    } else if (type === 'market') {
                        // for market buy it requires the amount of quote currency to spend
                        if (side === 'buy') {
                            let cost = this.safeNumber(params, 'cost');
                            const createMarketBuyOrderRequiresPrice = this.safeValue(this.options, 'createMarketBuyOrderRequiresPrice', true);
                            if (createMarketBuyOrderRequiresPrice) {
                                if (price !== undefined) {
                                    if (cost === undefined) cost = amount * price;
                                } else if (cost === undefined) throw new InvalidOrder(this.id + " createOrder() requires the price argument for market buy orders to calculate total order cost (amount to spend), where cost = amount * price. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount, or, alternatively, add .options['createMarketBuyOrderRequiresPrice'] = false and supply the total cost value in the 'amount' argument or in the 'cost' extra parameter (the exchange-specific behaviour)");
                            } else cost = cost === undefined ? amount : cost;
                            costToPrecision = this.costToPrecision(symbol, cost);
                            request['cost'] = costToPrecision;
                        } else request['quantity'] = this.amountToPrecision(symbol, amount);
                    }
                    const query = this.omit(params, [
                        'timeInForce',
                        'time_in_force',
                        'clientOrderId',
                        'client_order_id'
                    ]);
                    const response = await this.privatePostNewOrder(this.extend(request, query));
                    //
                    //     {
                    //         data: {
                    //             id: string,
                    //             user_id: string,
                    //             market_id: string,
                    //             type: 'orderType',
                    //             side: 'side',
                    //             quantity: string,
                    //             limit_price: string,
                    //             time_in_force: 'timeInForce',
                    //             filled_cost: string,
                    //             filled_quantity: string,
                    //             open_quantity: string,
                    //             cancelled_quantity: string,
                    //             status: 'orderStatus',
                    //             time: 'date',
                    //             client_order_id: string,
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const order = this.parseOrder(data, market);
                    // a workaround for incorrect huge amounts
                    // returned by the exchange on market buys
                    if (type === 'market' && side === 'buy') {
                        order['amount'] = undefined;
                        order['cost'] = this.parseNumber(costToPrecision);
                        order['remaining'] = undefined;
                    }
                    return order;
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_id': market['id'],
                        'order_id': id
                    };
                    const response = await this.privatePostCancelOrder(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data);
                }
                parseDepositAddress(depositAddress, currency) {
                    const address = this.safeString(depositAddress, 'address');
                    const tag = this.safeString(depositAddress, 'destination_tag');
                    const currencyId = this.safeString(depositAddress, 'currency_id');
                    const code = this.safeCurrencyCode(currencyId);
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': depositAddress
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency_id': currency['id']
                    };
                    const response = await this.privateGetDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         "data":[
                    //             {
                    //                 "currency_id":"ETH",
                    //                 "address":"0x12e2caf3c4051ba1146e612f532901a423a9898a",
                    //                 "destination_tag":null
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const firstAddress = this.safeValue(data, 0);
                    if (firstAddress === undefined) throw new InvalidAddress(this.id + ' fetchDepositAddress() returned an empty response');
                    return this.parseDepositAddress(firstAddress, currency);
                }
                async fetchDepositAddresses(codes, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (codes) {
                        const currencyIds = [];
                        for(let i = 0; i < codes.length; i++){
                            const currency = this.currency(codes[i]);
                            currencyIds.push(currency['id']);
                        }
                        request['currency_id'] = codes.join(',');
                    }
                    const response = await this.privateGetDepositAddress(this.extend(request, params));
                    const data = this.safeValue(response, 'data', []);
                    return this.parseDepositAddresses(data);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    // In order to use this method
                    // you need to allow API withdrawal from the API Settings Page, and
                    // and register the list of withdrawal addresses and destination tags on the API Settings page
                    // you can only withdraw to the registered addresses using the API
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (tag === undefined) tag = '';
                    const request = {
                        'currency_id': currency['id'],
                        // 'platform_id': 'ETH', // if omitted it will use the default platform for the currency
                        'address': address,
                        'destination_tag': tag,
                        'amount': this.numberToString(amount)
                    };
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeString(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['platform_id'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.privatePostWithdrawal(this.extend(request, params));
                    const data = this.safeValue(response, 'data');
                    return this.parseTransaction(data, currency);
                }
                parseTransaction(transaction, currency) {
                    const id = this.safeString(transaction, 'id');
                    const amount = this.safeNumber(transaction, 'amount');
                    const address = this.safeString(transaction, 'address');
                    const tag = this.safeString(transaction, 'destination_tag');
                    const txid = this.safeString(transaction, 'hash');
                    const timestamp = this.parse8601(this.safeString(transaction, 'time'));
                    const type = this.safeString(transaction, 'type');
                    const currencyId = this.safeString(transaction, 'currency_id');
                    const code = this.safeCurrencyCode(currencyId);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const feeCost = this.safeNumber(transaction, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined && feeCost !== 0) fee = {
                        'currency': code,
                        'cost': feeCost
                    };
                    return {
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': address,
                        'addressTo': address,
                        'tagFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'status': status,
                        'type': type,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'updated': undefined,
                        'fee': fee,
                        'info': transaction
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'requested': 'pending',
                        'pending': 'pending',
                        'confirming': 'pending',
                        'confirmed': 'pending',
                        'applying': 'pending',
                        'done': 'ok',
                        'cancelled': 'canceled',
                        'cancelling': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/';
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'accounts') {
                        this.checkRequiredCredentials();
                        url += this.implodeParams(path, params);
                        const auth = this.apiKey + ':' + this.secret;
                        const auth64 = this.stringToBase64(auth);
                        headers = {
                            'Authorization': 'Basic ' + this.decode(auth64),
                            'Content-Type': 'application/json'
                        };
                        if (Object.keys(query).length) body = this.json(query);
                    } else {
                        url += this.version + '/';
                        if (api === 'public') {
                            url += this.implodeParams(path, params);
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else if (api === 'private') {
                            const now = this.milliseconds();
                            this.checkRequiredCredentials();
                            const expires = this.safeInteger(this.options, 'expires');
                            if (expires === undefined || expires < now) throw new AuthenticationError(this.id + ' access token expired, call signIn() method');
                            const accessToken = this.safeString(this.options, 'accessToken');
                            headers = {
                                'Authorization': 'Bearer ' + accessToken
                            };
                            url += this.implodeParams(path, params);
                            if (method === 'GET') {
                                if (Object.keys(query).length) url += '?' + this.urlencode(query);
                            } else if (Object.keys(query).length) {
                                body = this.json(query);
                                headers['Content-Type'] = 'application/json';
                            }
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                async signIn(params = {}) {
                    this.checkRequiredCredentials();
                    const request = {
                        'grant_type': 'client_credentials'
                    };
                    const response = await this.accountsPostToken(this.extend(request, params));
                    //
                    //     {
                    //         access_token: '0ttDv/2hTTn3bLi8GP1gKaneiEQ6+0hOBenPrxNQt2s=',
                    //         token_type: 'bearer',
                    //         expires_in: 900
                    //     }
                    //
                    const expiresIn = this.safeInteger(response, 'expires_in');
                    const accessToken = this.safeString(response, 'access_token');
                    this.options['accessToken'] = accessToken;
                    this.options['expires'] = this.sum(this.milliseconds(), expiresIn * 1000);
                    return response;
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if ('errorCode' in response) {
                        const errorCode = this.safeString(response, 'errorCode');
                        const message = this.safeString(response, 'message');
                        if (errorCode !== undefined) {
                            const feedback = this.id + ' ' + body;
                            this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    118: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded, BadSymbol: BadSymbol } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class qtrade extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'qtrade',
                        'name': 'qTrade',
                        'countries': [
                            'US'
                        ],
                        'rateLimit': 1000,
                        'version': 'v1',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/80491487-74a99c00-896b-11ea-821e-d307e832f13e.jpg',
                            'api': 'https://api.qtrade.io',
                            'www': 'https://qtrade.io',
                            'doc': 'https://qtrade-exchange.github.io/qtrade-docs',
                            'referral': 'https://qtrade.io/?ref=BKOQWVFGRH2C',
                            'fees': 'https://qtrade.io/fees'
                        },
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDeposit': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': false,
                            'fetchTransactions': undefined,
                            'fetchTransfer': false,
                            'fetchTransfers': true,
                            'fetchWithdrawal': true,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '5m': 'fivemin',
                            '15m': 'fifteenmin',
                            '30m': 'thirtymin',
                            '1h': 'onehour',
                            '2h': 'twohour',
                            '4h': 'fourhour',
                            '1d': 'oneday'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'ticker/{market_string}',
                                    'tickers',
                                    'currency/{code}',
                                    'currencies',
                                    'common',
                                    'market/{market_string}',
                                    'markets',
                                    'market/{market_string}/trades',
                                    'orderbook/{market_string}',
                                    'market/{market_string}/ohlcv/{interval}'
                                ]
                            },
                            'private': {
                                'get': [
                                    'me',
                                    'balances',
                                    'balances_all',
                                    'market/{market_string}',
                                    'orders',
                                    'order/{order_id}',
                                    'trades',
                                    'withdraw/{withdraw_id}',
                                    'withdraws',
                                    'deposit/{deposit_id}',
                                    'deposits',
                                    'transfers'
                                ],
                                'post': [
                                    'cancel_order',
                                    'withdraw',
                                    'deposit_address/{currency}',
                                    'sell_limit',
                                    'buy_limit'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'quote',
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.005'),
                                'maker': this.parseNumber('0.0')
                            },
                            'funding': {
                                'withdraw': {}
                            }
                        },
                        'commonCurrencies': {
                            'BTM': 'Bitmark'
                        },
                        'exceptions': {
                            'exact': {
                                'invalid_auth': AuthenticationError,
                                'insuff_funds': InsufficientFunds,
                                'market_not_found': BadSymbol,
                                'too_small': InvalidOrder,
                                'limit_exceeded': RateLimitExceeded
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetMarkets(params);
                    //
                    //     {
                    //         "data":{
                    //             "markets":[
                    //                 {
                    //                     "id":5,
                    //                     "market_currency":"BAC",
                    //                     "base_currency":"BTC",
                    //                     "maker_fee":"0.0025",
                    //                     "taker_fee":"0.0025",
                    //                     "metadata":{
                    //                         "delisting_date":"7/15/2018",
                    //                         "market_notices":[
                    //                             {
                    //                                 "message":"Delisting Notice: This market has been delisted due to low volume. Please cancel your orders and withdraw your funds by 7/15/2018.",
                    //                                 "type":"warning"
                    //                             }
                    //                         ]
                    //                     },
                    //                     "can_trade":false,
                    //                     "can_cancel":true,
                    //                     "can_view":false,
                    //                     "market_string":"BAC_BTC",
                    //                     "minimum_sell_amount":"0.0001",
                    //                     "minimum_buy_value":"0.0001",
                    //                     "market_precision":8,
                    //                     "base_precision":8
                    //                 },
                    //             ],
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const markets = this.safeValue(data, 'markets', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const marketId = this.safeString(market, 'market_string');
                        const numericId = this.safeInteger(market, 'id');
                        const baseId = this.safeString(market, 'market_currency');
                        const quoteId = this.safeString(market, 'base_currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const canView = this.safeValue(market, 'can_view', false);
                        const canTrade = this.safeValue(market, 'can_trade', false);
                        const active = canTrade && canView;
                        result.push({
                            'id': marketId,
                            'numericId': numericId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': active,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.safeNumber(market, 'taker_fee'),
                            'maker': this.safeNumber(market, 'maker_fee'),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'market_precision'),
                                'price': this.safeInteger(market, 'base_precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minimum_sell_value'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minimum_buy_value'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     {
                    //         "data":{
                    //             "currencies":[
                    //                 {
                    //                     "code":"DGB",
                    //                     "long_name":"Digibyte",
                    //                     "type":"bitcoin_like",
                    //                     "precision":8,
                    //                     "config":{
                    //                         "price":0.0035,
                    //                         "withdraw_fee":"10",
                    //                         "deposit_types":[
                    //                             {
                    //                                 "label":"Address",
                    //                                 "lookup_mode":"address",
                    //                                 "render_type":"address",
                    //                                 "deposit_type":"address",
                    //                                 "lookup_config":{}
                    //                             }
                    //                         ],
                    //                         "default_signer":103,
                    //                         "address_version":30,
                    //                         "satoshi_per_byte":300,
                    //                         "required_confirmations":200,
                    //                         "required_generate_confirmations":300
                    //                     },
                    //                     "metadata":{},
                    //                     "minimum_order":"0.0001",
                    //                     "status":"ok",
                    //                     "can_withdraw":true,
                    //                     "delisted":false,
                    //                     "deposit_disabled":false,
                    //                     "withdraw_disabled":false,
                    //                     "deposit_warn_codes":[],
                    //                     "withdraw_warn_codes":[]
                    //                 },
                    //             ],
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const currencies = this.safeValue(data, 'currencies', []);
                    const result = {};
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'code');
                        const code = this.safeCurrencyCode(id);
                        const name = this.safeString(currency, 'long_name');
                        const type = this.safeString(currency, 'type');
                        const canWithdraw = this.safeValue(currency, 'can_withdraw', true);
                        const withdrawDisabled = this.safeValue(currency, 'withdraw_disabled', false);
                        const depositDisabled = this.safeValue(currency, 'deposit_disabled', false);
                        const deposit = !depositDisabled;
                        const withdraw = canWithdraw && !withdrawDisabled;
                        const config = this.safeValue(currency, 'config', {});
                        const status = this.safeString(currency, 'status');
                        const active = withdraw && deposit && status === 'ok';
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'type': type,
                            'name': name,
                            'fee': this.safeNumber(config, 'withdraw_fee'),
                            'precision': this.safeInteger(currency, 'precision'),
                            'active': active,
                            'deposit': deposit,
                            'withdraw': withdraw,
                            'limits': {
                                'amount': {
                                    'min': this.safeNumber(currency, 'minimum_order'),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "time":"2019-12-07T22:55:00Z",
                    //         "open":"0.00197",
                    //         "high":"0.00197",
                    //         "low":"0.00197",
                    //         "close":"0.00197",
                    //         "volume":"0.00016676",
                    //         "market_volume":"0.08465047"
                    //     }
                    //
                    return [
                        this.parse8601(this.safeString(ohlcv, 'time')),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'market_volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '5m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_string': market['id'],
                        'interval': this.timeframes[timeframe]
                    };
                    const response = await this.publicGetMarketMarketStringOhlcvInterval(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "slices":[
                    //                 {"time":"2019-12-07T22:55:00Z","open":"0.00197","high":"0.00197","low":"0.00197","close":"0.00197","volume":"0.00016676","market_volume":"0.08465047"},
                    //                 {"time":"2019-12-07T23:00:00Z","open":"0.00197","high":"0.00197","low":"0.00197","close":"0.00197","volume":"0","market_volume":"0"},
                    //                 {"time":"2019-12-07T23:05:00Z","open":"0.00197","high":"0.00197","low":"0.00197","close":"0.00197","volume":"0","market_volume":"0"},
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const ohlcvs = this.safeValue(data, 'slices', []);
                    return this.parseOHLCVs(ohlcvs, market, timeframe, since, limit);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const marketId = this.marketId(symbol);
                    const request = {
                        'market_string': marketId
                    };
                    const response = await this.publicGetOrderbookMarketString(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "buy":{
                    //                 "0.00700015":"4.76196367",
                    //                 "0.00700017":"1.89755391",
                    //                 "0.00700018":"2.13214088",
                    //             },
                    //             "last_change":1588539869958811,
                    //             "sell":{
                    //                 "0.02418662":"0.19513696",
                    //                 "0.02465627":"0.2439212",
                    //                 "0.02530277":"0.663475931274359255",
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const orderbook = {};
                    const sides = {
                        'buy': 'bids',
                        'sell': 'asks'
                    };
                    const keys = Object.keys(sides);
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        const side = sides[key];
                        const bidasks = this.safeValue(data, key, {});
                        const prices = Object.keys(bidasks);
                        const result = [];
                        for(let j = 0; j < prices.length; j++){
                            const priceAsString = prices[j];
                            const price = this.safeNumber(prices, j);
                            const amount = this.safeNumber(bidasks, priceAsString);
                            result.push([
                                price,
                                amount
                            ]);
                        }
                        orderbook[side] = result;
                    }
                    const timestamp = this.safeIntegerProduct(data, 'last_change', 0.001);
                    return this.parseOrderBook(orderbook, symbol, timestamp);
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker, fetchTickers
                    //
                    //     {
                    //         "ask":"0.02423119",
                    //         "bid":"0.0230939",
                    //         "day_avg_price":"0.0247031874349301",
                    //         "day_change":"-0.0237543162270376",
                    //         "day_high":"0.02470552",
                    //         "day_low":"0.02470172",
                    //         "day_open":"0.02530277",
                    //         "day_volume_base":"0.00268074",
                    //         "day_volume_market":"0.10851798",
                    //         "id":41,
                    //         "id_hr":"ETH_BTC",
                    //         "last":"0.02470172",
                    //         "last_change":1588533365354609
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'id_hr');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const timestamp = this.safeIntegerProduct(ticker, 'last_change', 0.001);
                    const previous = this.safeString(ticker, 'day_open');
                    const last = this.safeString(ticker, 'last');
                    const day_change = this.safeString(ticker, 'day_change');
                    const average = this.safeString(ticker, 'day_avg_price');
                    const baseVolume = this.safeString(ticker, 'day_volume_market');
                    const quoteVolume = this.safeString(ticker, 'day_volume_base');
                    const percentage = Precise.stringMul(day_change, '100');
                    const change = Precise.stringMul(day_change, previous);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'day_high'),
                        'low': this.safeString(ticker, 'day_low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': previous,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': change,
                        'percentage': percentage,
                        'average': average,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTickers(params);
                    //
                    //     {
                    //         "data":{
                    //             "markets":[
                    //                 {
                    //                     "ask":"0.0000003",
                    //                     "bid":"0.00000029",
                    //                     "day_avg_price":"0.0000002999979728",
                    //                     "day_change":"0.0344827586206897",
                    //                     "day_high":"0.0000003",
                    //                     "day_low":"0.0000003",
                    //                     "day_open":"0.00000029",
                    //                     "day_volume_base":"0.00591958",
                    //                     "day_volume_market":"19732.06666665",
                    //                     "id":36,
                    //                     "id_hr":"DOGE_BTC",
                    //                     "last":"0.0000003",
                    //                     "last_change":1588534202130778
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const tickers = this.safeValue(data, 'markets', []);
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const ticker = this.parseTicker(tickers[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_string': market['id']
                    };
                    const response = await this.publicGetTickerMarketString(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "ask":"0.02423119",
                    //             "bid":"0.0230939",
                    //             "day_avg_price":"0.0247031874349301",
                    //             "day_change":"-0.0237543162270376",
                    //             "day_high":"0.02470552",
                    //             "day_low":"0.02470172",
                    //             "day_open":"0.02530277",
                    //             "day_volume_base":"0.00268074",
                    //             "day_volume_market":"0.10851798",
                    //             "id":41,
                    //             "id_hr":"ETH_BTC",
                    //             "last":"0.02470172",
                    //             "last_change":1588533365354609
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTicker(data, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_string': market['id']
                    };
                    const response = await this.publicGetMarketMarketStringTrades(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "trades":[
                    //                 {
                    //                     "id":85507,
                    //                     "amount":"0.09390502",
                    //                     "price":"0.02556325",
                    //                     "base_volume":"0.00240051",
                    //                     "seller_taker":true,
                    //                     "side":"sell",
                    //                     "created_at":"0001-01-01T00:00:00Z",
                    //                     "created_at_ts":1581560391338718
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const trades = this.safeValue(data, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'desc': true
                    };
                    let market = undefined;
                    const numericId = this.safeValue(params, 'market_id');
                    if (numericId !== undefined) request['market_id'] = numericId; // mutually exclusive with market_string
                    else if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market_string'] = market['id'];
                    }
                    const response = await this.privateGetTrades(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "trades":[
                    //                 {
                    //                     "id":107331,
                    //                     "market_amount":"0.1082536946986",
                    //                     "price":"0.0230939",
                    //                     "base_amount":"0.00249999",
                    //                     "order_id":13790596,
                    //                     "market_id":41,
                    //                     "market_string":"ETH_BTC",
                    //                     "taker":true,
                    //                     "base_fee":"0.00001249",
                    //                     "side":"sell",
                    //                     "created_at":"2020-05-04T06:08:18.513413Z"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const trades = this.safeValue(data, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "id":85507,
                    //         "amount":"0.09390502",
                    //         "price":"0.02556325",
                    //         "base_volume":"0.00240051",
                    //         "seller_taker":true,
                    //         "side":"sell",
                    //         "created_at":"0001-01-01T00:00:00Z",
                    //         "created_at_ts":1581560391338718
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "id":107331,
                    //         "market_amount":"0.1082536946986",
                    //         "price":"0.0230939",
                    //         "base_amount":"0.00249999",
                    //         "order_id":13790596,
                    //         "market_id":41,
                    //         "market_string":"ETH_BTC",
                    //         "taker":true,
                    //         "base_fee":"0.00001249",
                    //         "side":"sell",
                    //         "created_at":"2020-05-04T06:08:18.513413Z"
                    //     }
                    //
                    // createOrder, fetchOrders, fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "base_amount": "9.58970687",
                    //         "base_fee": "0.02397426",
                    //         "created_at": "0001-01-01T00:00:00Z",
                    //         "id": 0,
                    //         "market_amount": "0.97179355",
                    //         "price": "9.86804952",
                    //         "taker": true
                    //     }
                    //
                    const id = this.safeString(trade, 'id');
                    let timestamp = this.safeIntegerProduct(trade, 'created_at_ts', 0.001);
                    if (timestamp === undefined) timestamp = this.parse8601(this.safeString(trade, 'created_at'));
                    const side = this.safeString(trade, 'side');
                    const marketId = this.safeString(trade, 'market_string');
                    market = this.safeMarket(marketId, market);
                    const cost = this.safeString2(trade, 'base_volume', 'base_amount');
                    const price = this.safeString(trade, 'price');
                    const amount = this.safeString2(trade, 'market_amount', 'amount');
                    let fee = undefined;
                    const feeCost = this.safeString(trade, 'base_fee');
                    if (feeCost !== undefined) {
                        const feeCurrencyCode = market === undefined ? undefined : market['quote'];
                        fee = {
                            'currency': feeCurrencyCode,
                            'cost': feeCost
                        };
                    }
                    const taker = this.safeValue(trade, 'taker', true);
                    const takerOrMaker = taker ? 'taker' : 'maker';
                    const orderId = this.safeString(trade, 'order_id');
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': fee
                    }, market);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_string': market['id']
                    };
                    const response = await this.publicGetMarketMarketString(this.extend(request, params));
                    //
                    //     {
                    //         data: {
                    //             market: {
                    //                 id: '41',
                    //                 market_currency: 'ETH',
                    //                 base_currency: 'BTC',
                    //                 maker_fee: '0',
                    //                 taker_fee: '0.005',
                    //                 metadata: {},
                    //                 can_trade: true,
                    //                 can_cancel: true,
                    //                 can_view: true,
                    //                 market_string: 'ETH_BTC',
                    //                 minimum_sell_amount: '0.001',
                    //                 minimum_buy_value: '0.0001',
                    //                 market_precision: '18',
                    //                 base_precision: '8'
                    //             },
                    //             recent_trades: []
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const marketData = this.safeValue(data, 'market', {});
                    return {
                        'info': marketData,
                        'symbol': symbol,
                        'maker': this.safeNumber(marketData, 'maker_fee'),
                        'taker': this.safeNumber(marketData, 'taker_fee'),
                        'percentage': true,
                        'tierBased': true
                    };
                }
                parseBalance(response) {
                    const data = this.safeValue(response, 'data', {});
                    let balances = this.safeValue(data, 'balances', []);
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = code in result ? result[code] : this.account();
                        account['free'] = this.safeString(balance, 'balance');
                        account['used'] = '0';
                        result[code] = account;
                    }
                    balances = this.safeValue(data, 'order_balances', []);
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = code in result ? result[code] : this.account();
                        account['used'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalancesAll(params);
                    //
                    //     {
                    //         "data":{
                    //             "balances": [
                    //                 { "balance": "100000000", "currency": "BCH" },
                    //                 { "balance": "99992435.78253015", "currency": "LTC" },
                    //                 { "balance": "99927153.76074182", "currency": "BTC" },
                    //             ],
                    //             "order_balances":[],
                    //             "limit_used":0,
                    //             "limit_remaining":4000,
                    //             "limit":4000
                    //         }
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (type !== 'limit') throw new InvalidOrder(this.id + ' createOrder() allows limit orders only');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'amount': this.amountToPrecision(symbol, amount),
                        'market_id': market['numericId'],
                        'price': this.priceToPrecision(symbol, price)
                    };
                    const method = side === 'sell' ? 'privatePostSellLimit' : 'privatePostBuyLimit';
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "data": {
                    //             "order": {
                    //                 "created_at": "2018-04-06T20:46:52.899248Z",
                    //                 "id": 13253,
                    //                 "market_amount": "1",
                    //                 "market_amount_remaining": "0",
                    //                 "market_id": 1,
                    //                 "open": false,
                    //                 "order_type": "sell_limit",
                    //                 "price": "0.01",
                    //                 "trades": [
                    //                     {
                    //                         "base_amount": "0.27834267",
                    //                         "base_fee": "0.00069585",
                    //                         "created_at": "0001-01-01T00:00:00Z",
                    //                         "id": 0,
                    //                         "market_amount": "0.02820645",
                    //                         "price": "9.86805058",
                    //                         "taker": true
                    //                     },
                    //                     {
                    //                         "base_amount": "9.58970687",
                    //                         "base_fee": "0.02397426",
                    //                         "created_at": "0001-01-01T00:00:00Z",
                    //                         "id": 0,
                    //                         "market_amount": "0.97179355",
                    //                         "price": "9.86804952",
                    //                         "taker": true
                    //                     }
                    //                 ]
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const order = this.safeValue(data, 'order', {});
                    return this.parseOrder(order, market);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "created_at": "2018-04-06T20:46:52.899248Z",
                    //         "id": 13253,
                    //         "market_amount": "1",
                    //         "market_amount_remaining": "0",
                    //         "market_id": 1,
                    //         "open": false,
                    //         "order_type": "sell_limit",
                    //         "price": "0.01",
                    //         "trades": [
                    //             {
                    //                 "base_amount": "0.27834267",
                    //                 "base_fee": "0.00069585",
                    //                 "created_at": "0001-01-01T00:00:00Z",
                    //                 "id": 0,
                    //                 "market_amount": "0.02820645",
                    //                 "price": "9.86805058",
                    //                 "taker": true
                    //             },
                    //             {
                    //                 "base_amount": "9.58970687",
                    //                 "base_fee": "0.02397426",
                    //                 "created_at": "0001-01-01T00:00:00Z",
                    //                 "id": 0,
                    //                 "market_amount": "0.97179355",
                    //                 "price": "9.86804952",
                    //                 "taker": true
                    //             }
                    //         ]
                    //     }
                    //
                    // fetchOrder
                    //
                    //     {
                    //         id: 13790596,
                    //         market_amount: "0.15",
                    //         market_amount_remaining: "0",
                    //         created_at: "2020-05-04T06:08:18.513413Z",
                    //         price: "0.0230939",
                    //         base_amount: "0",
                    //         order_type: "sell_limit",
                    //         market_id: 41,
                    //         market_string: "ETH_BTC",
                    //         open: false,
                    //         trades: [
                    //             {
                    //                 id: 107331,
                    //                 market_amount: "0.1082536946986",
                    //                 price: "0.0230939",
                    //                 base_amount: "0.00249999",
                    //                 taker: true,
                    //                 base_fee: "0.00001249",
                    //                 created_at: "2020-05-04T06:08:18.513413Z",
                    //             }
                    //         ],
                    //         close_reason: "canceled"
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const sideType = this.safeString(order, 'order_type');
                    let orderType = undefined;
                    let side = undefined;
                    if (sideType !== undefined) {
                        const parts = sideType.split('_');
                        side = this.safeString(parts, 0);
                        orderType = this.safeString(parts, 1);
                    }
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'market_amount');
                    const remaining = this.safeString(order, 'market_amount_remaining');
                    const open = this.safeValue(order, 'open', false);
                    const closeReason = this.safeString(order, 'close_reason');
                    let status = undefined;
                    if (open) status = 'open';
                    else if (closeReason === 'canceled') status = 'canceled';
                    else status = 'closed';
                    const marketId = this.safeString(order, 'market_string');
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    const rawTrades = this.safeValue(order, 'trades', []);
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': orderType,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'average': undefined,
                        'amount': amount,
                        'remaining': remaining,
                        'filled': undefined,
                        'status': status,
                        'fee': undefined,
                        'fees': undefined,
                        'cost': undefined,
                        'trades': rawTrades
                    }, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'id': parseInt(id)
                    };
                    // successful cancellation returns 200 with no payload
                    return await this.privatePostCancelOrder(this.extend(request, params));
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privateGetOrderOrderId(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "order":{
                    //                 "id":13790596,
                    //                 "market_amount":"0.15",
                    //                 "market_amount_remaining":"0.0417463053014",
                    //                 "created_at":"2020-05-04T06:08:18.513413Z",
                    //                 "price":"0.0230939",
                    //                 "order_type":"sell_limit",
                    //                 "market_id":41,
                    //                 "market_string":"ETH_BTC",
                    //                 "open":true,
                    //                 "trades":[
                    //                     {
                    //                         "id":107331,
                    //                         "market_amount":"0.1082536946986",
                    //                         "price":"0.0230939",
                    //                         "base_amount":"0.00249999",
                    //                         "taker":true,
                    //                         "base_fee":"0.00001249",
                    //                         "created_at":"2020-05-04T06:08:18.513413Z"
                    //                     }
                    //                 ]
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const order = this.safeValue(data, 'order', {});
                    return this.parseOrder(order);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    const numericId = this.safeValue(params, 'market_id');
                    if (numericId !== undefined) request['market_id'] = numericId; // mutually exclusive with market_string
                    else if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market_string'] = market['id'];
                    }
                    const response = await this.privateGetOrders(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "orders":[
                    //                 {
                    //                     "id":13790596,
                    //                     "market_amount":"0.15",
                    //                     "market_amount_remaining":"0.0417463053014",
                    //                     "created_at":"2020-05-04T06:08:18.513413Z",
                    //                     "price":"0.0230939",
                    //                     "order_type":"sell_limit",
                    //                     "market_id":41,
                    //                     "market_string":"ETH_BTC",
                    //                     "open":true,
                    //                     "trades":[
                    //                         {
                    //                             "id":107331,
                    //                             "market_amount":"0.1082536946986",
                    //                             "price":"0.0230939",
                    //                             "base_amount":"0.00249999",
                    //                             "taker":true,
                    //                             "base_fee":"0.00001249",
                    //                             "created_at":"2020-05-04T06:08:18.513413Z"
                    //                         }
                    //                     ]
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const orders = this.safeValue(data, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'open': true
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'open': false
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         "address":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //         "currency_status":"ok",
                    //         "deposit_methods":{
                    //             "address":{
                    //                 "deposit_type":"address",
                    //                 "render_type":"address",
                    //                 "label":"Address",
                    //                 "address":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //             },
                    //         },
                    //     }
                    //
                    const code = currency === undefined ? undefined : currency['code'];
                    let address = this.safeString(depositAddress, 'address');
                    let tag = undefined;
                    if (address !== undefined) {
                        const parts = address.split(':');
                        address = this.safeString(parts, 0);
                        tag = this.safeString(parts, 1);
                    }
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': depositAddress
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privatePostDepositAddressCurrency(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "address":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //             "currency_status":"ok",
                    //             "deposit_methods":{
                    //                 "address":{
                    //                     "deposit_type":"address",
                    //                     "render_type":"address",
                    //                     "label":"Address",
                    //                     "address":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //                 },
                    //             },
                    //         },
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseDepositAddress(data, currency);
                }
                async fetchDeposit(id, code, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'deposit_id': id
                    };
                    const response = await this.privateGetDepositDepositId(this.extend(request, params));
                    //
                    //     {
                    //         "data":{
                    //             "deposit":{
                    //                 "id":"0xaa6e65ed274c4786e5dec3671de96f81021cacdbc453b1a133ab84356f3620a0",
                    //                 "amount":"0.13",
                    //                 "currency":"ETH",
                    //                 "address":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //                 "status":"credited",
                    //                 "relay_status":"",
                    //                 "network_data":{
                    //                     "confirms":87,
                    //                     "sweep_txid":"0xa16e65ed274d4686e5dec3671de96f81021cacdbc453b1a133ab85356f3630a0",
                    //                     "sweep_balance":"0.150000000000000000",
                    //                     "confirms_required":80,
                    //                     "unsigned_sweep_tx":{
                    //                         "chainId":1,
                    //                         "from":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //                         "gas":"0x5208",
                    //                         "gasPrice":"0x19b45a500",
                    //                         "nonce":"0x0",
                    //                         "to":"0x76Cd80202a2C31e9D8F595a31ed071CE7F75BB93",
                    //                         "value":"0x214646b6347d800"
                    //                     },
                    //                     "txid":"0xaa6e65ed274c4786e5dec3671de96f81021cacdbc453b1a133ab84356f3620a0",
                    //                     "tx_index":"0x6f",
                    //                     "tx_value":"0.130000000000000000",
                    //                     "key_index":311,
                    //                     "blockheight":9877869,
                    //                     "signed_sweep_tx":{
                    //                         "hash":"0xa16e65ed274d4686e5dec3671de96f81021cacdbc453b1a133ab85356f3630a0",
                    //                         "rawTransaction":"0xd86c8085019b45a1008252099476cb80202b2c31e9d7f595a31fd071ce7f75bb93880214646b6347d8008046a08c6e3bfe8b25bff2b6851c87ea17c63d7b23591210ab0779a568eaa43dc40435a030e964bb2b667072ea7cbc8ab554403e3f3ead9b554743f2fdc2b1e06e998df9"
                    //                     },
                    //                     "estimated_sweep_tx_fee":144900000000000
                    //                 },
                    //                 "created_at":"2020-05-04T05:38:42.145162Z"
                    //             }
                    //         }
                    //     }
                    const data = this.safeValue(response, 'data', {});
                    const deposit = this.safeValue(data, 'deposit', {});
                    return this.parseTransaction(deposit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const response = await this.privateGetDeposits(params);
                    //
                    //     {
                    //         "data":{
                    //             "deposits":[
                    //                 {
                    //                     "id":"0xaa6e65ed274c4786e5dec3671de96f81021cacdbc453b1a133ab84356f3620a0",
                    //                     "amount":"0.13",
                    //                     "currency":"ETH",
                    //                     "address":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //                     "status":"credited",
                    //                     "relay_status":"",
                    //                     "network_data":{
                    //                         "confirms":87,
                    //                         "sweep_txid":"0xa16e65ed274d4686e5dec3671de96f81021cacdbc453b1a133ab85356f3630a0",
                    //                         "sweep_balance":"0.150000000000000000",
                    //                         "confirms_required":80,
                    //                         "unsigned_sweep_tx":{
                    //                             "chainId":1,
                    //                             "from":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //                             "gas":"0x5208",
                    //                             "gasPrice":"0x19b45a500",
                    //                             "nonce":"0x0",
                    //                             "to":"0x76Cd80202a2C31e9D8F595a31ed071CE7F75BB93",
                    //                             "value":"0x214646b6347d800"
                    //                         },
                    //                         "txid":"0xaa6e65ed274c4786e5dec3671de96f81021cacdbc453b1a133ab84356f3620a0",
                    //                         "tx_index":"0x6f",
                    //                         "tx_value":"0.130000000000000000",
                    //                         "key_index":311,
                    //                         "blockheight":9877869,
                    //                         "signed_sweep_tx":{
                    //                             "hash":"0xa16e65ed274d4686e5dec3671de96f81021cacdbc453b1a133ab85356f3630a0",
                    //                             "rawTransaction":"0xd86c8085019b45a1008252099476cb80202b2c31e9d7f595a31fd071ce7f75bb93880214646b6347d8008046a08c6e3bfe8b25bff2b6851c87ea17c63d7b23591210ab0779a568eaa43dc40435a030e964bb2b667072ea7cbc8ab554403e3f3ead9b554743f2fdc2b1e06e998df9"
                    //                         },
                    //                         "estimated_sweep_tx_fee":144900000000000
                    //                     },
                    //                     "created_at":"2020-05-04T05:38:42.145162Z"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const deposits = this.safeValue(data, 'deposits', []);
                    return this.parseTransactions(deposits, currency, since, limit);
                }
                async fetchTransfers(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const response = await this.privateGetTransfers(params);
                    //
                    //     {
                    //         "data": {
                    //             "transfers": [
                    //                 {
                    //                     "amount": "0.5",
                    //                     "created_at": "2018-12-10T00:06:41.066665Z",
                    //                     "currency": "BTC",
                    //                     "id": 9,
                    //                     "reason_code": "referral_payout",
                    //                     "reason_metadata": {
                    //                         "note": "January referral earnings"
                    //                     },
                    //                     "sender_email": "qtrade",
                    //                     "sender_id": 218
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const transfers = this.safeValue(data, 'transfers', []);
                    return this.parseTransfers(transfers, currency, since, limit);
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //         "amount": "0.5",
                    //         "created_at": "2018-12-10T00:06:41.066665Z",
                    //         "currency": "BTC",
                    //         "id": 9,
                    //         "reason_code": "referral_payout",
                    //         "reason_metadata": {
                    //             "note": "January referral earnings"
                    //         },
                    //         "sender_email": "qtrade",
                    //         "sender_id": 218
                    //     }
                    //
                    const currencyId = this.safeString(transfer, 'currency');
                    const dateTime = this.safeString(transfer, 'created_at');
                    return {
                        'info': transfer,
                        'id': this.safeString(transfer, 'id'),
                        'timestamp': this.parse8601(dateTime),
                        'datetime': dateTime,
                        'currency': this.safeCurrencyCode(currencyId, currency),
                        'amount': this.safeNumber(transfer, 'amount'),
                        'fromAccount': this.safeString(transfer, 'sender_id'),
                        'toAccount': undefined,
                        'status': 'ok'
                    };
                }
                async fetchWithdrawal(id, code, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'withdraw_id': id
                    };
                    const response = await this.privateGetWithdrawWithdrawId(this.extend(request, params));
                    //
                    //     {
                    //         data: {
                    //             withdraw: {
                    //                 "id":25524,
                    //                 "amount":"0.0417463053014",
                    //                 "user_id":0,
                    //                 "currency":"ETH",
                    //                 "network_data":{
                    //                     "unsigned_tx":{
                    //                         "chainId":1,
                    //                         "from":"0x76Cd80202a2C31e9D8F595a31ed071CE7F75BB93",
                    //                         "gas":"0x5208",
                    //                         "gasPrice":"0x20c8558e9",
                    //                         "nonce":"0xf3",
                    //                         "to":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //                         "value":"0x71712bcd113308"
                    //                     },
                    //                     "estimated_tx_fee":184800004893000,
                    //                     "confirms_required":80,
                    //                     "txid":"0x79439b62473d61d99ce1dc6c3b8a417da36d45323a394bb0d4af870608fef38d",
                    //                     "confirms":83,
                    //                     "signed_tx":{
                    //                         "hash":"0x79439b62473d61d99ce1dc6c3b8a417da36d45323a394bb0d4af870608fef38d",
                    //                         "rawTransaction":"0xf86c81f385021c8558e98252089401b0a9b7b4cde774af0f3e87cb4f1c2ccdba08068771712acd1133078025a0088157d119d924d47413c81b91b9f18ff148623a2ef13dab1895ca3ba546b771a046a021b1e1f64d1a60bb66c19231f641b352326188a9ed3b931b698a939f78d0"
                    //                     }
                    //                 },
                    //                 "address":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //                 "status":"confirmed",
                    //                 "relay_status":"",
                    //                 "created_at":"2020-05-05T06:32:19.907061Z",
                    //                 "cancel_requested":false
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const withdrawal = this.safeValue(data, 'withdraw', {});
                    return this.parseTransaction(withdrawal);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    if (code !== undefined) currency = this.currency(code);
                    const response = await this.privateGetWithdraws(params);
                    //     {
                    //         "data":{
                    //             "withdraws":[
                    //                 {
                    //                     "id":25524,
                    //                     "amount":"0.0417463053014",
                    //                     "user_id":0,
                    //                     "currency":"ETH",
                    //                     "network_data":{
                    //                         "unsigned_tx":{
                    //                             "chainId":1,
                    //                             "from":"0x76Cd80202a2C31e9D8F595a31ed071CE7F75BB93",
                    //                             "gas":"0x5208",
                    //                             "gasPrice":"0x20c8558e9",
                    //                             "nonce":"0xf3",
                    //                             "to":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //                             "value":"0x71712bcd113308"
                    //                         },
                    //                         "estimated_tx_fee":184800004893000,
                    //                         "confirms_required":80,
                    //                         "txid":"0x79439b62473d61d99ce1dc6c3b8a417da36d45323a394bb0d4af870608fef38d",
                    //                         "confirms":83,
                    //                         "signed_tx":{
                    //                             "hash":"0x79439b62473d61d99ce1dc6c3b8a417da36d45323a394bb0d4af870608fef38d",
                    //                             "rawTransaction":"0xf86c81f385021c8558e98252089401b0a9b7b4cde774af0f3e87cb4f1c2ccdba08068771712acd1133078025a0088157d119d924d47413c81b91b9f18ff148623a2ef13dab1895ca3ba546b771a046a021b1e1f64d1a60bb66c19231f641b352326188a9ed3b931b698a939f78d0"
                    //                         }
                    //                     },
                    //                     "address":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //                     "status":"confirmed",
                    //                     "relay_status":"",
                    //                     "created_at":"2020-05-05T06:32:19.907061Z",
                    //                     "cancel_requested":false
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const withdrawals = this.safeValue(data, 'withdraws', []);
                    return this.parseTransactions(withdrawals, currency, since, limit);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits, fetchDeposit
                    //
                    //     {
                    //         "id":"0xaa6e65ed274c4786e5dec3671de96f81021cacdbc453b1a133ab84356f3620a0",
                    //         "amount":"0.13",
                    //         "currency":"ETH",
                    //         "address":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //         "status":"credited",
                    //         "relay_status":"",
                    //         "network_data":{
                    //             "confirms":87,
                    //             "sweep_txid":"0xa16e65ed274d4686e5dec3671de96f81021cacdbc453b1a133ab85356f3630a0",
                    //             "sweep_balance":"0.150000000000000000",
                    //             "confirms_required":80,
                    //             "unsigned_sweep_tx":{
                    //                 "chainId":1,
                    //                 "from":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //                 "gas":"0x5208",
                    //                 "gasPrice":"0x19b45a500",
                    //                 "nonce":"0x0",
                    //                 "to":"0x76Cd80202a2C31e9D8F595a31ed071CE7F75BB93",
                    //                 "value":"0x214646b6347d800"
                    //             },
                    //             "txid":"0xaa6e65ed274c4786e5dec3671de96f81021cacdbc453b1a133ab84356f3620a0",
                    //             "tx_index":"0x6f",
                    //             "tx_value":"0.130000000000000000",
                    //             "key_index":311,
                    //             "blockheight":9877869,
                    //             "signed_sweep_tx":{
                    //                 "hash":"0xa16e65ed274d4686e5dec3671de96f81021cacdbc453b1a133ab85356f3630a0",
                    //                 "rawTransaction":"0xd86c8085019b45a1008252099476cb80202b2c31e9d7f595a31fd071ce7f75bb93880214646b6347d8008046a08c6e3bfe8b25bff2b6851c87ea17c63d7b23591210ab0779a568eaa43dc40435a030e964bb2b667072ea7cbc8ab554403e3f3ead9b554743f2fdc2b1e06e998df9"
                    //             },
                    //             "estimated_sweep_tx_fee":144900000000000
                    //         },
                    //         "created_at":"2020-05-04T05:38:42.145162Z"
                    //     }
                    //
                    // fetchWithdrawals, fetchWithdrawal
                    //
                    //     {
                    //         "id":25524,
                    //         "amount":"0.0417463053014",
                    //         "user_id":0,
                    //         "currency":"ETH",
                    //         "network_data":{
                    //             "unsigned_tx":{
                    //                 "chainId":1,
                    //                 "from":"0x76Cd80202a2C31e9D8F595a31ed071CE7F75BB93",
                    //                 "gas":"0x5208",
                    //                 "gasPrice":"0x20c8558e9",
                    //                 "nonce":"0xf3",
                    //                 "to":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //                 "value":"0x71712bcd113308"
                    //             },
                    //             "estimated_tx_fee":184800004893000,
                    //             "confirms_required":80,
                    //             "txid":"0x79439b62473d61d99ce1dc6c3b8a417da36d45323a394bb0d4af870608fef38d",
                    //             "confirms":83,
                    //             "signed_tx":{
                    //                 "hash":"0x79439b62473d61d99ce1dc6c3b8a417da36d45323a394bb0d4af870608fef38d",
                    //                 "rawTransaction":"0xf86c81f385021c8558e98252089401b0a9b7b4cde774af0f3e87cb4f1c2ccdba08068771712acd1133078025a0088157d119d924d47413c81b91b9f18ff148623a2ef13dab1895ca3ba546b771a046a021b1e1f64d1a60bb66c19231f641b352326188a9ed3b931b698a939f78d0"
                    //             }
                    //         },
                    //         "address":"0xe0cd26f9A60118555247aE6769A5d241D91f07f2",
                    //         "status":"confirmed",
                    //         "relay_status":"",
                    //         "created_at":"2020-05-05T06:32:19.907061Z",
                    //         "cancel_requested":false
                    //     }
                    //
                    // withdraw
                    //
                    //     {
                    //         "code": "initiated",
                    //         "id": 3,
                    //         "result": "Withdraw initiated. Please allow 3-5 minutes for our system to process."
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(transaction, 'created_at'));
                    const id = this.safeString(transaction, 'id');
                    const networkData = this.safeValue(transaction, 'network_data', {});
                    const unsignedTx = this.safeValue(networkData, 'unsigned_tx', {});
                    const addressFrom = this.safeString(unsignedTx, 'from');
                    const txid = this.safeString(networkData, 'txid');
                    let address = this.safeString(transaction, 'address');
                    let tag = undefined;
                    if (address !== undefined) {
                        const parts = address.split(':');
                        const numParts = parts.length;
                        if (numParts > 1) {
                            address = this.safeString(parts, 0);
                            tag = this.safeString(parts, 1);
                        }
                    }
                    const addressTo = address;
                    const tagFrom = undefined;
                    const tagTo = tag;
                    const cancelRequested = this.safeValue(transaction, 'cancel_requested');
                    const type = cancelRequested === undefined ? 'deposit' : 'withdrawal';
                    const amount = this.safeNumber(transaction, 'amount');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    let status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const statusCode = this.safeString(transaction, 'code');
                    if (cancelRequested) status = 'canceled';
                    else if (status === undefined) status = this.parseTransactionStatus(statusCode);
                    const fee = undefined;
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': addressFrom,
                        'addressTo': addressTo,
                        'address': address,
                        'tagFrom': tagFrom,
                        'tagTo': tagTo,
                        'tag': tag,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': undefined,
                        'fee': fee
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'initiated': 'pending',
                        'needs_create': 'pending',
                        'credited': 'ok',
                        'confirmed': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'address': address,
                        'amount': amount,
                        'currency': currency['id']
                    };
                    if (tag !== undefined) request['address'] += ':' + tag;
                    const response = await this.privatePostWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "data": {
                    //             "code": "initiated",
                    //             "id": 3,
                    //             "result": "Withdraw initiated. Please allow 3-5 minutes for our system to process."
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const result = this.parseTransaction(data);
                    return this.extend(result, {
                        'currency': code,
                        'address': address,
                        'addressTo': address,
                        'tag': tag,
                        'tagTo': tag,
                        'amount': amount
                    });
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = '/' + this.version + '/';
                    if (api === 'private') url += 'user/';
                    url += this.implodeParams(path, params);
                    const request = this.omit(params, this.extractParams(path));
                    if (method === 'POST') body = this.json(request);
                    else if (Object.keys(request).length) url += '?' + this.urlencode(request);
                    if (api === 'private') {
                        const timestamp = this.milliseconds().toString();
                        const bodyAsString = method === 'POST' ? body : '';
                        const auth = [
                            method,
                            url,
                            timestamp,
                            bodyAsString,
                            this.secret
                        ].join("\n"); // eslint-disable-line quotes
                        const hash = this.hash(this.encode(auth), 'sha256', 'base64');
                        let key = this.apiKey;
                        if (typeof key !== 'string') key = key.toString();
                        const signature = 'HMAC-SHA256 ' + key + ':' + hash;
                        headers = {
                            'Authorization': signature,
                            'HMAC-Timestamp': timestamp
                        };
                        if (method === 'POST') headers['Content-Type'] = 'application/json';
                    }
                    url = this.urls['api'] + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    //
                    //     {"errors":[{"code":"insuff_funds","title":"Your available balance is too low for that action"}]}
                    //     {"errors":[{"code": "invalid_auth","title": "Invalid HMAC signature"}]}
                    //
                    if (response === undefined) return;
                    const errors = this.safeValue(response, 'errors', []);
                    const numErrors = errors.length;
                    if (numErrors < 1) return;
                    const feedback = this.id + ' ' + body;
                    for(let i = 0; i < errors.length; i++){
                        const error = errors[i];
                        const errorCode = this.safeString(error, 'code');
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                    }
                    throw new ExchangeError1(feedback); // unknown message
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    119: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, BadSymbol: BadSymbol, BadRequest: BadRequest, InvalidOrder: InvalidOrder, ArgumentsRequired: ArgumentsRequired1, OrderNotFound: OrderNotFound, InsufficientFunds: InsufficientFunds, DDoSProtection: DDoSProtection } = require1('./base/errors');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            //  ---------------------------------------------------------------------------
            module.exports = class ripio extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'ripio',
                        'name': 'Ripio',
                        'countries': [
                            'AR',
                            'BR'
                        ],
                        'rateLimit': 50,
                        'version': 'v1',
                        'pro': true,
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/94507548-a83d6a80-0218-11eb-9998-28b9cec54165.jpg',
                            'api': {
                                'public': 'https://api.exchange.ripio.com/api',
                                'private': 'https://api.exchange.ripio.com/api'
                            },
                            'www': 'https://exchange.ripio.com',
                            'doc': [
                                'https://exchange.ripio.com/en/api/'
                            ],
                            'fees': 'https://exchange.ripio.com/en/fee'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'rate/all/',
                                    'rate/{pair}/',
                                    'orderbook/{pair}/',
                                    'tradehistory/{pair}/',
                                    'pair/',
                                    'currency/',
                                    'orderbook/{pair}/depth/'
                                ]
                            },
                            'private': {
                                'get': [
                                    'balances/exchange_balances/',
                                    'order/{pair}/{order_id}/',
                                    'order/{pair}/',
                                    'trade/{pair}/'
                                ],
                                'post': [
                                    'order/{pair}/',
                                    'order/{pair}/{order_id}/cancel/'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': 0,
                                'maker': 0
                            }
                        },
                        'precisionMode': TICK_SIZE,
                        'requiredCredentials': {
                            'apiKey': true,
                            'secret': false
                        },
                        'exceptions': {
                            'exact': {},
                            'broad': {
                                'Authentication credentials were not provided': AuthenticationError,
                                'Disabled pair': BadSymbol,
                                'Invalid order type': InvalidOrder,
                                'Your balance is not enough': InsufficientFunds,
                                "Order couldn't be created": ExchangeError1,
                                // {"status_code":404,"errors":{"order":["Order 286e560e-b8a2-464b-8b84-15a7e2a67eab not found."]},"message":"An error has occurred, please check the form."}
                                // {"status_code":404,"errors":{"trade":["Trade <trade_id> not found."]},"message":"An error has occurred, please check the form."}
                                'not found': OrderNotFound,
                                'Invalid pair': BadSymbol,
                                'amount must be a number': BadRequest,
                                'Total must be at least': InvalidOrder,
                                'Account not found': BadRequest,
                                'Wrong password provided': AuthenticationError,
                                'User tokens limit': DDoSProtection,
                                'Something unexpected ocurred': ExchangeError1,
                                // {'status_code': 404, 'errors': {'account_balance': ['Exchange balance <currency>not found.']},'message': 'An error has occurred, please check the form.'}
                                // {'status_code': 404, 'errors': {'account_balance': ['Account balance <id> not found.']},'message': 'An error has occurred, please check the form.'}
                                'account_balance': BadRequest
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetPair(params);
                    //
                    //     {
                    //         "next":null,
                    //         "previous":null,
                    //         "results":[
                    //             {
                    //                 "base":"BTC",
                    //                 "base_name":"Bitcoin",
                    //                 "quote":"USDC",
                    //                 "quote_name":"USD Coin",
                    //                 "symbol":"BTC_USDC",
                    //                 "fees":[
                    //                     {
                    //                         "traded_volume": 0.0,
                    //                         "maker_fee": 0.0,
                    //                         "taker_fee": 0.0,
                    //                         "cancellation_fee": 0.0
                    //                     }
                    //                 ],
                    //                 "country":"ZZ",
                    //                 "enabled":true,
                    //                 "priority":10,
                    //                 "min_amount":"0.00001",
                    //                 "price_tick":"0.000001",
                    //                 "min_value":"10",
                    //                 "limit_price_threshold":"25.00"
                    //             },
                    //         ]
                    //     }
                    //
                    const result = [];
                    const results = this.safeValue(response, 'results', []);
                    for(let i = 0; i < results.length; i++){
                        const market = results[i];
                        const baseId = this.safeString(market, 'base');
                        const quoteId = this.safeString(market, 'quote');
                        const id = this.safeString(market, 'symbol');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const fees = this.safeValue(market, 'fees', []);
                        const firstFee = this.safeValue(fees, 0, {});
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': this.safeValue(market, 'enabled', true),
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.safeNumber(firstFee, 'taker_fee', 0.0),
                            'maker': this.safeNumber(firstFee, 'maker_fee', 0.0),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeNumber(market, 'min_amount'),
                                'price': this.safeNumber(market, 'price_tick')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min_amount'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_value'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrency(params);
                    //
                    //     {
                    //         "next":null,
                    //         "previous":null,
                    //         "results":[
                    //             {
                    //                 "name":"Argentine Peso",
                    //                 "symbol":"$",
                    //                 "currency":"ARS",
                    //                 "country":"AR",
                    //                 "decimal_places":"2",
                    //                 "enabled":true
                    //             },
                    //             {
                    //                 "name":"Bitcoin Cash",
                    //                 "symbol":"BCH",
                    //                 "currency":"BCH",
                    //                 "country":"AR",
                    //                 "decimal_places":"8",
                    //                 "enabled":true
                    //             },
                    //             {
                    //                 "name":"Bitcoin",
                    //                 "symbol":"BTC",
                    //                 "currency":"BTC",
                    //                 "country":"AR",
                    //                 "decimal_places":"8",
                    //                 "enabled":true
                    //             }
                    //         ]
                    //     }
                    //
                    const results = this.safeValue(response, 'results', []);
                    const result = {};
                    for(let i = 0; i < results.length; i++){
                        const currency = results[i];
                        const id = this.safeString(currency, 'currency');
                        const code = this.safeCurrencyCode(id);
                        const name = this.safeString(currency, 'name');
                        const active = this.safeValue(currency, 'enabled', true);
                        const precision = this.safeInteger(currency, 'decimal_places');
                        result[code] = {
                            'id': id,
                            'code': code,
                            'name': name,
                            'info': currency,
                            'active': active,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': undefined,
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker, fetchTickers
                    //
                    //     {
                    //         "pair":"BTC_USDC",
                    //         "last_price":"10850.02",
                    //         "low":"10720.03",
                    //         "high":"10909.99",
                    //         "variation":"1.21",
                    //         "volume":"0.83868",
                    //         "base":"BTC",
                    //         "base_name":"Bitcoin",
                    //         "quote":"USDC",
                    //         "quote_name":"USD Coin",
                    //         "bid":"10811.00",
                    //         "ask":"10720.03",
                    //         "avg":"10851.47",
                    //         "ask_volume":"0.00140",
                    //         "bid_volume":"0.00185",
                    //         "created_at":"2020-09-28 21:44:51.228920+00:00"
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(ticker, 'created_at'));
                    const marketId = this.safeString(ticker, 'pair');
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    const last = this.safeString(ticker, 'last_price');
                    const average = this.safeString(ticker, 'avg');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': this.safeString(ticker, 'bid_volume'),
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': this.safeString(ticker, 'ask_volume'),
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': average,
                        'baseVolume': undefined,
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetRatePair(this.extend(request, params));
                    //
                    //     {
                    //         "pair":"BTC_USDC",
                    //         "last_price":"10850.02",
                    //         "low":"10720.03",
                    //         "high":"10909.99",
                    //         "variation":"1.21",
                    //         "volume":"0.83868",
                    //         "base":"BTC",
                    //         "base_name":"Bitcoin",
                    //         "quote":"USDC",
                    //         "quote_name":"USD Coin",
                    //         "bid":"10811.00",
                    //         "ask":"10720.03",
                    //         "avg":"10851.47",
                    //         "ask_volume":"0.00140",
                    //         "bid_volume":"0.00185",
                    //         "created_at":"2020-09-28 21:44:51.228920+00:00"
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetRateAll(params);
                    //
                    //     [
                    //         {
                    //             "pair":"BTC_USDC",
                    //             "last_price":"10850.02",
                    //             "low":"10720.03",
                    //             "high":"10909.99",
                    //             "variation":"1.21",
                    //             "volume":"0.83868",
                    //             "base":"BTC",
                    //             "base_name":"Bitcoin",
                    //             "quote":"USDC",
                    //             "quote_name":"USD Coin",
                    //             "bid":"10811.00",
                    //             "ask":"10720.03",
                    //             "avg":"10851.47",
                    //             "ask_volume":"0.00140",
                    //             "bid_volume":"0.00185",
                    //             "created_at":"2020-09-28 21:44:51.228920+00:00"
                    //         }
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const ticker = this.parseTicker(response[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'pair': this.marketId(symbol)
                    };
                    const response = await this.publicGetOrderbookPair(this.extend(request, params));
                    //
                    //     {
                    //         "buy":[
                    //             {"amount":"0.00230","total":"24.95","price":"10850.02"},
                    //             {"amount":"0.07920","total":"858.52","price":"10840.00"},
                    //             {"amount":"0.00277","total":"30.00","price":"10833.03"},
                    //         ],
                    //         "sell":[
                    //             {"amount":"0.03193","total":"348.16","price":"10904.00"},
                    //             {"amount":"0.00210","total":"22.90","price":"10905.70"},
                    //             {"amount":"0.00300","total":"32.72","price":"10907.98"},
                    //         ],
                    //         "updated_id":47225
                    //     }
                    //
                    const orderbook = this.parseOrderBook(response, symbol, undefined, 'buy', 'sell', 'price', 'amount');
                    orderbook['nonce'] = this.safeInteger(response, 'updated_id');
                    return orderbook;
                }
                parseTrade(trade, market) {
                    //
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "created_at":1649899167,
                    //          "amount":"0.00852",
                    //          "price":"3106.000000",
                    //          "side":"SELL",
                    //          "pair":"ETH_USDC",
                    //          "taker_fee":"0",
                    //          "taker_side":"SELL",
                    //          "maker_fee":"0"
                    //      }
                    //
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "created_at":1601322501,
                    //         "amount":"0.00276",
                    //         "price":"10850.020000",
                    //         "side":"SELL",
                    //         "pair":"BTC_USDC",
                    //         "taker_fee":"0",
                    //         "taker_side":"SELL",
                    //         "maker_fee":"0",
                    //         "taker":2577953,
                    //         "maker":2577937
                    //     }
                    //
                    // createOrder fills
                    //
                    //     {
                    //         "pair":"BTC_USDC",
                    //         "exchanged":0.002,
                    //         "match_price":10593.99,
                    //         "maker_fee":0.0,
                    //         "taker_fee":0.0,
                    //         "timestamp":1601730306942
                    //     }
                    //
                    const id = this.safeString(trade, 'id');
                    let timestamp = this.safeInteger(trade, 'timestamp');
                    timestamp = this.safeTimestamp(trade, 'created_at', timestamp);
                    let side = this.safeString(trade, 'side');
                    const takerSide = this.safeString(trade, 'taker_side');
                    const takerOrMaker = takerSide === side ? 'taker' : 'maker';
                    if (side !== undefined) side = side.toLowerCase();
                    const priceString = this.safeString2(trade, 'price', 'match_price');
                    const amountString = this.safeString2(trade, 'amount', 'exchanged');
                    const marketId = this.safeString(trade, 'pair');
                    market = this.safeMarket(marketId, market);
                    const feeCostString = this.safeString(trade, takerOrMaker + '_fee');
                    const orderId = this.safeString(trade, takerOrMaker);
                    let fee = undefined;
                    if (feeCostString !== undefined) fee = {
                        'cost': feeCostString,
                        'currency': side === 'buy' ? market['base'] : market['quote']
                    };
                    return this.safeTrade({
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': undefined,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'takerOrMaker': takerOrMaker,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const response = await this.publicGetTradehistoryPair(this.extend(request, params));
                    //
                    //      [
                    //          {
                    //              "created_at":1649899167,
                    //              "amount":"0.00852",
                    //              "price":"3106.000000",
                    //              "side":"SELL",
                    //              "pair":"ETH_USDC",
                    //              "taker_fee":"0",
                    //              "taker_side":"SELL",
                    //              "maker_fee":"0"
                    //          }
                    //      ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetPair(params);
                    //
                    //     {
                    //         next: null,
                    //         previous: null,
                    //         results: [
                    //             {
                    //                 base: 'BTC',
                    //                 base_name: 'Bitcoin',
                    //                 quote: 'USDC',
                    //                 quote_name: 'USD Coin',
                    //                 symbol: 'BTC_USDC',
                    //                 fees: [
                    //                     {
                    //                         traded_volume: '0.0',
                    //                         maker_fee: '0.0',
                    //                         taker_fee: '0.0',
                    //                         cancellation_fee: '0.0'
                    //                     }
                    //                 ],
                    //                 country: 'ZZ',
                    //                 enabled: true,
                    //                 priority: '10',
                    //                 min_amount: '0.0000100000',
                    //                 price_tick: '0.000001',
                    //                 min_value: '10',
                    //                 limit_price_threshold: '25.00'
                    //             },
                    //         ]
                    //     }
                    //
                    const results = this.safeValue(response, 'results', []);
                    const result = {};
                    for(let i = 0; i < results.length; i++){
                        const pair = results[i];
                        const marketId = this.safeString(pair, 'symbol');
                        const symbol = this.safeSymbol(marketId, undefined, '_');
                        const fees = this.safeValue(pair, 'fees', []);
                        const fee = this.safeValue(fees, 0, {});
                        result[symbol] = {
                            'info': pair,
                            'symbol': symbol,
                            'maker': this.safeNumber(fee, 'maker_fee'),
                            'taker': this.safeNumber(fee, 'taker_fee'),
                            'tierBased': false
                        };
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'symbol');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'locked');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalancesExchangeBalances(params);
                    //
                    //     [
                    //         {
                    //             "id":603794,
                    //             "currency":"USD Coin",
                    //             "symbol":"USDC",
                    //             "available":"0",
                    //             "locked":"0",
                    //             "code":"exchange",
                    //             "balance_type":"crypto"
                    //         },
                    //     ]
                    //
                    return this.parseBalance(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const uppercaseType = type.toUpperCase();
                    const uppercaseSide = side.toUpperCase();
                    const request = {
                        'pair': market['id'],
                        'order_type': uppercaseType,
                        'side': uppercaseSide,
                        'amount': this.amountToPrecision(symbol, amount)
                    };
                    if (uppercaseType === 'LIMIT') request['limit_price'] = this.priceToPrecision(symbol, price);
                    const response = await this.privatePostOrderPair(this.extend(request, params));
                    //
                    //     {
                    //         "order_id": "160f523c-f6ef-4cd1-a7c9-1a8ede1468d8",
                    //         "pair": "BTC_ARS",
                    //         "side": "BUY",
                    //         "amount": "0.00400",
                    //         "notional": null,
                    //         "fill_or_kill": false,
                    //         "all_or_none": false,
                    //         "order_type": "LIMIT",
                    //         "status": "OPEN",
                    //         "created_at": 1578413945,
                    //         "filled": "0.00000",
                    //         "limit_price": "10.00",
                    //         "stop_price": null,
                    //         "distance": null
                    //     }
                    //
                    // createOrder market type
                    //
                    //     {
                    //         "order_id":"d6b60c01-8624-44f2-9e6c-9e8cd677ea5c",
                    //         "pair":"BTC_USDC",
                    //         "side":"BUY",
                    //         "amount":"0.00200",
                    //         "notional":"50",
                    //         "fill_or_kill":false,
                    //         "all_or_none":false,
                    //         "order_type":"MARKET",
                    //         "status":"OPEN",
                    //         "created_at":1601730306,
                    //         "filled":"0.00000",
                    //         "fill_price":10593.99,
                    //         "fee":0.0,
                    //         "fills":[
                    //             {
                    //                 "pair":"BTC_USDC",
                    //                 "exchanged":0.002,
                    //                 "match_price":10593.99,
                    //                 "maker_fee":0.0,
                    //                 "taker_fee":0.0,
                    //                 "timestamp":1601730306942
                    //             }
                    //         ],
                    //         "filled_at":"2020-10-03T13:05:06.942186Z",
                    //         "limit_price":"0.000000",
                    //         "stop_price":null,
                    //         "distance":null
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'order_id': id
                    };
                    const response = await this.privatePostOrderPairOrderIdCancel(this.extend(request, params));
                    //
                    //     {
                    //         "order_id": "286e560e-b8a2-464b-8b84-15a7e2a67eab",
                    //         "pair": "BTC_ARS",
                    //         "side": "SELL",
                    //         "amount": "0.00100",
                    //         "notional": null,
                    //         "fill_or_kill": false,
                    //         "all_or_none": false,
                    //         "order_type": "LIMIT",
                    //         "status": "CANC",
                    //         "created_at": 1575472707,
                    //         "filled": "0.00000",
                    //         "limit_price": "681000.00",
                    //         "stop_price": null,
                    //         "distance": null
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'order_id': id
                    };
                    const response = await this.privateGetOrderPairOrderId(this.extend(request, params));
                    //
                    //     {
                    //         "order_id": "0b4ff48e-cfd6-42db-8d8c-3b536da447af",
                    //         "pair": "BTC_ARS",
                    //         "side": "BUY",
                    //         "amount": "0.00100",
                    //         "notional": null,
                    //         "fill_or_kill": false,
                    //         "all_or_none": false,
                    //         "order_type": "LIMIT",
                    //         "status": "OPEN",
                    //         "created_at": 1575472944,
                    //         "filled": "0.00000",
                    //         "limit_price": "661000.00",
                    //         "stop_price": null,
                    //         "distance": null
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['offset'] = limit;
                    const response = await this.privateGetOrderPair(this.extend(request, params));
                    //
                    //     {
                    //         "next": "https://api.exchange.ripio.com/api/v1/order/BTC_ARS/?limit=20&offset=20&page=1&page_size=25&status=OPEN%2CPART",
                    //         "previous": null,
                    //         "results": {
                    //             "data": [
                    //                 {
                    //                     "order_id": "ca74280b-6966-4b73-a720-68709078922b",
                    //                     "pair": "BTC_ARS",
                    //                     "side": "SELL",
                    //                     "amount": "0.00100",
                    //                     "notional": null,
                    //                     "fill_or_kill": false,
                    //                     "all_or_none": false,
                    //                     "order_type": "LIMIT",
                    //                     "status": "OPEN",
                    //                     "created_at": 1578340134,
                    //                     "filled": "0.00000",
                    //                     "limit_price": "665000.00",
                    //                     "stop_price": null,
                    //                     "distance": null
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    const results = this.safeValue(response, 'results', {});
                    const data = this.safeValue(results, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'OPEN,PART'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'CLOS,CANC,COMP'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'OPEN': 'open',
                        'PART': 'open',
                        'CLOS': 'canceled',
                        'CANC': 'canceled',
                        'COMP': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder, cancelOrder, fetchOpenOrders, fetchClosedOrders, fetchOrders, fetchOrder
                    //
                    //     {
                    //         "order_id": "286e560e-b8a2-464b-8b84-15a7e2a67eab",
                    //         "pair": "BTC_ARS",
                    //         "side": "SELL",
                    //         "amount": "0.00100",
                    //         "notional": null,
                    //         "fill_or_kill": false,
                    //         "all_or_none": false,
                    //         "order_type": "LIMIT",
                    //         "status": "CANC",
                    //         "created_at": 1575472707,
                    //         "filled": "0.00000",
                    //         "limit_price": "681000.00",
                    //         "stop_price": null,
                    //         "distance": null
                    //     }
                    //
                    //     {
                    //         "order_id":"d6b60c01-8624-44f2-9e6c-9e8cd677ea5c",
                    //         "pair":"BTC_USDC",
                    //         "side":"BUY",
                    //         "amount":"0.00200",
                    //         "notional":"50",
                    //         "fill_or_kill":false,
                    //         "all_or_none":false,
                    //         "order_type":"MARKET",
                    //         "status":"OPEN",
                    //         "created_at":1601730306,
                    //         "filled":"0.00000",
                    //         "fill_price":10593.99,
                    //         "fee":0.0,
                    //         "fills":[
                    //             {
                    //                 "pair":"BTC_USDC",
                    //                 "exchanged":0.002,
                    //                 "match_price":10593.99,
                    //                 "maker_fee":0.0,
                    //                 "taker_fee":0.0,
                    //                 "timestamp":1601730306942
                    //             }
                    //         ],
                    //         "filled_at":"2020-10-03T13:05:06.942186Z",
                    //         "limit_price":"0.000000",
                    //         "stop_price":null,
                    //         "distance":null
                    //     }
                    //
                    const id = this.safeString(order, 'order_id');
                    const amount = this.safeNumber(order, 'amount');
                    let cost = this.safeNumber(order, 'notional');
                    const type = this.safeStringLower(order, 'order_type');
                    const priceField = type === 'market' ? 'fill_price' : 'limit_price';
                    const price = this.safeNumber(order, priceField);
                    const side = this.safeStringLower(order, 'side');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const timestamp = this.safeTimestamp(order, 'created_at');
                    let average = this.safeValue(order, 'fill_price');
                    let filled = this.safeNumber(order, 'filled');
                    let remaining = undefined;
                    const fills = this.safeValue(order, 'fills');
                    let trades = undefined;
                    let lastTradeTimestamp = undefined;
                    if (fills !== undefined) {
                        const numFills = fills.length;
                        if (numFills > 0) {
                            filled = 0;
                            cost = 0;
                            trades = this.parseTrades(fills, market, undefined, undefined, {
                                'order': id,
                                'side': side
                            });
                            for(let i = 0; i < trades.length; i++){
                                const trade = trades[i];
                                filled = this.sum(trade['amount'], filled);
                                cost = this.sum(trade['cost'], cost);
                                lastTradeTimestamp = trade['timestamp'];
                            }
                            if (average === undefined && filled > 0) average = cost / filled;
                        }
                    }
                    if (filled !== undefined) {
                        if (cost === undefined && price !== undefined) cost = price * filled;
                        if (amount !== undefined) remaining = Math.max(0, amount - filled);
                    }
                    const marketId = this.safeString(order, 'pair');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const stopPrice = this.safeNumber(order, 'stop_price');
                    return {
                        'id': id,
                        'clientOrderId': undefined,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': cost,
                        'average': average,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': undefined,
                        'trades': trades
                    };
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetTradePair(this.extend(request, params));
                    //
                    //     {
                    //         "next": "https://api.exchange.ripio.com/api/v1/trade/<pair>/?limit=20&offset=20",
                    //         "previous": null,
                    //         "results": {
                    //             "data": [
                    //                 {
                    //                     "created_at": 1578414028,
                    //                     "amount": "0.00100",
                    //                     "price": "665000.00",
                    //                     "side": "BUY",
                    //                     "taker_fee": "0",
                    //                     "taker_side": "BUY",
                    //                     "match_price": "66500000",
                    //                     "maker_fee": "0",
                    //                     "taker": 4892,
                    //                     "maker": 4889
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    const results = this.safeValue(response, 'results', {});
                    const data = this.safeValue(results, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const request = '/' + this.version + '/' + this.implodeParams(path, params);
                    let url = this.urls['api'][api] + request;
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'private') {
                        this.checkRequiredCredentials();
                        if (method === 'POST') body = this.json(query);
                        else if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        headers = {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.apiKey
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    //      {"detail":"Authentication credentials were not provided."}
                    //      {"status_code":400,"errors":{"pair":["Invalid pair FOOBAR"]},"message":"An error has occurred, please check the form."}
                    //      {"status_code":400,"errors":{"order_type":["Invalid order type. Valid options: ['MARKET', 'LIMIT']"]},"message":"An error has occurred, please check the form."}
                    //      {"status_code":400,"errors":{"non_field_errors":"Something unexpected ocurred!"},"message":"Seems like an unexpected error occurred. Please try again later or write us to support@ripio.com if the problem persists."}
                    //      {"status_code":400,"errors":{"pair":["Invalid/Disabled pair BTC_ARS"]},"message":"An error has occurred, please check the form."}
                    //
                    const detail = this.safeString(response, 'detail');
                    if (detail !== undefined) {
                        const feedback = this.id + ' ' + body;
                        // this.throwExactlyMatchedException (this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], detail, feedback);
                    }
                    const errors = this.safeValue(response, 'errors');
                    if (errors !== undefined) {
                        const feedback = this.id + ' ' + body;
                        const keys = Object.keys(errors);
                        for(let i = 0; i < keys.length; i++){
                            const key = keys[i];
                            const error = this.safeValue(errors, key, []);
                            const message = this.safeString(error, 0);
                            // this.throwExactlyMatchedException (this.exceptions['exact'], message, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        }
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    120: [
        function(require1, module, exports) {
            (function(module, exports) {
                'use strict';
                // Utils
                function assert(val, msg) {
                    if (!val) throw new Error(msg || 'Assertion failed');
                }
                // Could use `inherits` module, but don't want to move from single file
                // architecture yet.
                function inherits(ctor, superCtor) {
                    ctor.super_ = superCtor;
                    var TempCtor = function() {};
                    TempCtor.prototype = superCtor.prototype;
                    ctor.prototype = new TempCtor();
                    ctor.prototype.constructor = ctor;
                }
                // BN
                function BN(number, base, endian) {
                    if (BN.isBN(number)) return number;
                    this.negative = 0;
                    this.words = null;
                    this.length = 0;
                    // Reduction context
                    this.red = null;
                    if (number !== null) {
                        if (base === 'le' || base === 'be') {
                            endian = base;
                            base = 10;
                        }
                        this._init(number || 0, base || 10, endian || 'be');
                    }
                }
                if (typeof module === 'object') module.exports = BN;
                else exports.BN = BN;
                BN.BN = BN;
                BN.wordSize = 26;
                var Buffer;
                try {
                    Buffer = require1('buffer').Buffer;
                } catch (e) {}
                BN.isBN = function isBN(num) {
                    if (num instanceof BN) return true;
                    return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
                };
                BN.max = function max(left, right) {
                    if (left.cmp(right) > 0) return left;
                    return right;
                };
                BN.min = function min(left, right) {
                    if (left.cmp(right) < 0) return left;
                    return right;
                };
                BN.prototype._init = function init(number, base, endian) {
                    if (typeof number === 'number') return this._initNumber(number, base, endian);
                    if (typeof number === 'object') return this._initArray(number, base, endian);
                    if (base === 'hex') base = 16;
                    assert(base === (base | 0) && base >= 2 && base <= 36);
                    number = number.toString().replace(/\s+/g, '');
                    var start = 0;
                    if (number[0] === '-') start++;
                    if (base === 16) this._parseHex(number, start);
                    else this._parseBase(number, base, start);
                    if (number[0] === '-') this.negative = 1;
                    this._strip();
                    if (endian !== 'le') return;
                    this._initArray(this.toArray(), base, endian);
                };
                BN.prototype._initNumber = function _initNumber(number, base, endian) {
                    if (number < 0) {
                        this.negative = 1;
                        number = -number;
                    }
                    if (number < 0x4000000) {
                        this.words = [
                            number & 0x3ffffff
                        ];
                        this.length = 1;
                    } else if (number < 0x10000000000000) {
                        this.words = [
                            number & 0x3ffffff,
                            number / 0x4000000 & 0x3ffffff
                        ];
                        this.length = 2;
                    } else {
                        assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
                        this.words = [
                            number & 0x3ffffff,
                            number / 0x4000000 & 0x3ffffff,
                            1
                        ];
                        this.length = 3;
                    }
                    if (endian !== 'le') return;
                    // Reverse the bytes
                    this._initArray(this.toArray(), base, endian);
                };
                BN.prototype._initArray = function _initArray(number, base, endian) {
                    // Perhaps a Uint8Array
                    assert(typeof number.length === 'number');
                    if (number.length <= 0) {
                        this.words = [
                            0
                        ];
                        this.length = 1;
                        return this;
                    }
                    this.length = Math.ceil(number.length / 3);
                    this.words = new Array(this.length);
                    for(var i = 0; i < this.length; i++)this.words[i] = 0;
                    var j, w;
                    var off = 0;
                    if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
                        w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
                        this.words[j] |= w << off & 0x3ffffff;
                        this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                        off += 24;
                        if (off >= 26) {
                            off -= 26;
                            j++;
                        }
                    }
                    else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
                        w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
                        this.words[j] |= w << off & 0x3ffffff;
                        this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                        off += 24;
                        if (off >= 26) {
                            off -= 26;
                            j++;
                        }
                    }
                    return this._strip();
                };
                function parseHex(str, start, end) {
                    var r = 0;
                    var len = Math.min(str.length, end);
                    var z = 0;
                    for(var i = start; i < len; i++){
                        var c = str.charCodeAt(i) - 48;
                        r <<= 4;
                        var b;
                        // 'a' - 'f'
                        if (c >= 49 && c <= 54) b = c - 49 + 0xa;
                        else if (c >= 17 && c <= 22) b = c - 17 + 0xa;
                        else b = c;
                        r |= b;
                        z |= b;
                    }
                    assert(!(z & 0xf0), 'Invalid character in ' + str);
                    return r;
                }
                BN.prototype._parseHex = function _parseHex(number, start) {
                    // Create possibly bigger array to ensure that it fits the number
                    this.length = Math.ceil((number.length - start) / 6);
                    this.words = new Array(this.length);
                    for(var i = 0; i < this.length; i++)this.words[i] = 0;
                    var j, w;
                    // Scan 24-bit chunks and add them to the number
                    var off = 0;
                    for(i = number.length - 6, j = 0; i >= start; i -= 6){
                        w = parseHex(number, i, i + 6);
                        this.words[j] |= w << off & 0x3ffffff;
                        // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
                        this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
                        off += 24;
                        if (off >= 26) {
                            off -= 26;
                            j++;
                        }
                    }
                    if (i + 6 !== start) {
                        w = parseHex(number, start, i + 6);
                        this.words[j] |= w << off & 0x3ffffff;
                        this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
                    }
                    this._strip();
                };
                function parseBase(str, start, end, mul) {
                    var r = 0;
                    var b = 0;
                    var len = Math.min(str.length, end);
                    for(var i = start; i < len; i++){
                        var c = str.charCodeAt(i) - 48;
                        r *= mul;
                        // 'a'
                        if (c >= 49) b = c - 49 + 0xa;
                        else if (c >= 17) b = c - 17 + 0xa;
                        else b = c;
                        assert(c >= 0 && b < mul, 'Invalid character');
                        r += b;
                    }
                    return r;
                }
                BN.prototype._parseBase = function _parseBase(number, base, start) {
                    // Initialize as zero
                    this.words = [
                        0
                    ];
                    this.length = 1;
                    // Find length of limb in base
                    for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
                    limbLen--;
                    limbPow = limbPow / base | 0;
                    var total = number.length - start;
                    var mod = total % limbLen;
                    var end = Math.min(total, total - mod) + start;
                    var word = 0;
                    for(var i = start; i < end; i += limbLen){
                        word = parseBase(number, i, i + limbLen, base);
                        this.imuln(limbPow);
                        if (this.words[0] + word < 0x4000000) this.words[0] += word;
                        else this._iaddn(word);
                    }
                    if (mod !== 0) {
                        var pow = 1;
                        word = parseBase(number, i, number.length, base);
                        for(i = 0; i < mod; i++)pow *= base;
                        this.imuln(pow);
                        if (this.words[0] + word < 0x4000000) this.words[0] += word;
                        else this._iaddn(word);
                    }
                };
                BN.prototype.copy = function copy(dest) {
                    dest.words = new Array(this.length);
                    for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
                    dest.length = this.length;
                    dest.negative = this.negative;
                    dest.red = this.red;
                };
                BN.prototype._move = function _move(dest) {
                    dest.words = this.words;
                    dest.length = this.length;
                    dest.negative = this.negative;
                    dest.red = this.red;
                };
                BN.prototype.clone = function clone() {
                    var r = new BN(null);
                    this.copy(r);
                    return r;
                };
                BN.prototype._expand = function _expand(size) {
                    while(this.length < size)this.words[this.length++] = 0;
                    return this;
                };
                // Remove leading `0` from `this`
                BN.prototype._strip = function strip() {
                    while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
                    return this._normSign();
                };
                BN.prototype._normSign = function _normSign() {
                    // -0 = 0
                    if (this.length === 1 && this.words[0] === 0) this.negative = 0;
                    return this;
                };
                // Check Symbol.for because not everywhere where Symbol defined
                // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
                if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
                else BN.prototype.inspect = inspect;
                function inspect() {
                    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
                }
                /*

    var zeros = [];
    var groupSizes = [];
    var groupBases = [];

    var s = '';
    var i = -1;
    while (++i < BN.wordSize) {
      zeros[i] = s;
      s += '0';
    }
    groupSizes[0] = 0;
    groupSizes[1] = 0;
    groupBases[0] = 0;
    groupBases[1] = 0;
    var base = 2 - 1;
    while (++base < 36 + 1) {
      var groupSize = 0;
      var groupBase = 1;
      while (groupBase < (1 << BN.wordSize) / base) {
        groupBase *= base;
        groupSize += 1;
      }
      groupSizes[base] = groupSize;
      groupBases[base] = groupBase;
    }

    */ var zeros = [
                    '',
                    '0',
                    '00',
                    '000',
                    '0000',
                    '00000',
                    '000000',
                    '0000000',
                    '00000000',
                    '000000000',
                    '0000000000',
                    '00000000000',
                    '000000000000',
                    '0000000000000',
                    '00000000000000',
                    '000000000000000',
                    '0000000000000000',
                    '00000000000000000',
                    '000000000000000000',
                    '0000000000000000000',
                    '00000000000000000000',
                    '000000000000000000000',
                    '0000000000000000000000',
                    '00000000000000000000000',
                    '000000000000000000000000',
                    '0000000000000000000000000'
                ];
                var groupSizes = [
                    0,
                    0,
                    25,
                    16,
                    12,
                    11,
                    10,
                    9,
                    8,
                    8,
                    7,
                    7,
                    7,
                    7,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5
                ];
                var groupBases = [
                    0,
                    0,
                    33554432,
                    43046721,
                    16777216,
                    48828125,
                    60466176,
                    40353607,
                    16777216,
                    43046721,
                    10000000,
                    19487171,
                    35831808,
                    62748517,
                    7529536,
                    11390625,
                    16777216,
                    24137569,
                    34012224,
                    47045881,
                    64000000,
                    4084101,
                    5153632,
                    6436343,
                    7962624,
                    9765625,
                    11881376,
                    14348907,
                    17210368,
                    20511149,
                    24300000,
                    28629151,
                    33554432,
                    39135393,
                    45435424,
                    52521875,
                    60466176
                ];
                BN.prototype.toString = function toString(base, padding) {
                    base = base || 10;
                    padding = padding | 0 || 1;
                    var out;
                    if (base === 16 || base === 'hex') {
                        out = '';
                        var off = 0;
                        var carry = 0;
                        for(var i = 0; i < this.length; i++){
                            var w = this.words[i];
                            var word = ((w << off | carry) & 0xffffff).toString(16);
                            carry = w >>> 24 - off & 0xffffff;
                            if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                            else out = word + out;
                            off += 2;
                            if (off >= 26) {
                                off -= 26;
                                i--;
                            }
                        }
                        if (carry !== 0) out = carry.toString(16) + out;
                        while(out.length % padding !== 0)out = '0' + out;
                        if (this.negative !== 0) out = '-' + out;
                        return out;
                    }
                    if (base === (base | 0) && base >= 2 && base <= 36) {
                        // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
                        var groupSize = groupSizes[base];
                        // var groupBase = Math.pow(base, groupSize);
                        var groupBase = groupBases[base];
                        out = '';
                        var c = this.clone();
                        c.negative = 0;
                        while(!c.isZero()){
                            var r = c.modrn(groupBase).toString(base);
                            c = c.idivn(groupBase);
                            if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                            else out = r + out;
                        }
                        if (this.isZero()) out = '0' + out;
                        while(out.length % padding !== 0)out = '0' + out;
                        if (this.negative !== 0) out = '-' + out;
                        return out;
                    }
                    assert(false, 'Base should be between 2 and 36');
                };
                BN.prototype.toNumber = function toNumber() {
                    var ret = this.words[0];
                    if (this.length === 2) ret += this.words[1] * 0x4000000;
                    else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
                    ret += 0x10000000000000 + this.words[1] * 0x4000000;
                    else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
                    return this.negative !== 0 ? -ret : ret;
                };
                BN.prototype.toJSON = function toJSON() {
                    return this.toString(16, 2);
                };
                if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
                    return this.toArrayLike(Buffer, endian, length);
                };
                BN.prototype.toArray = function toArray(endian, length) {
                    return this.toArrayLike(Array, endian, length);
                };
                var allocate = function allocate(ArrayType, size) {
                    if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
                    return new ArrayType(size);
                };
                BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
                    this._strip();
                    var byteLength = this.byteLength();
                    var reqLength = length || Math.max(1, byteLength);
                    assert(byteLength <= reqLength, 'byte array longer than desired length');
                    assert(reqLength > 0, 'Requested array length <= 0');
                    var res = allocate(ArrayType, reqLength);
                    var postfix = endian === 'le' ? 'LE' : 'BE';
                    this['_toArrayLike' + postfix](res, byteLength);
                    return res;
                };
                BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
                    var position = 0;
                    var carry = 0;
                    for(var i = 0, shift = 0; i < this.length; i++){
                        var word = this.words[i] << shift | carry;
                        res[position++] = word & 0xff;
                        if (position < res.length) res[position++] = word >> 8 & 0xff;
                        if (position < res.length) res[position++] = word >> 16 & 0xff;
                        if (shift === 6) {
                            if (position < res.length) res[position++] = word >> 24 & 0xff;
                            carry = 0;
                            shift = 0;
                        } else {
                            carry = word >>> 24;
                            shift += 2;
                        }
                    }
                    if (position < res.length) {
                        res[position++] = carry;
                        while(position < res.length)res[position++] = 0;
                    }
                };
                BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
                    var position = res.length - 1;
                    var carry = 0;
                    for(var i = 0, shift = 0; i < this.length; i++){
                        var word = this.words[i] << shift | carry;
                        res[position--] = word & 0xff;
                        if (position >= 0) res[position--] = word >> 8 & 0xff;
                        if (position >= 0) res[position--] = word >> 16 & 0xff;
                        if (shift === 6) {
                            if (position >= 0) res[position--] = word >> 24 & 0xff;
                            carry = 0;
                            shift = 0;
                        } else {
                            carry = word >>> 24;
                            shift += 2;
                        }
                    }
                    if (position >= 0) {
                        res[position--] = carry;
                        while(position >= 0)res[position--] = 0;
                    }
                };
                if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
                    return 32 - Math.clz32(w);
                };
                else BN.prototype._countBits = function _countBits(w) {
                    var t = w;
                    var r = 0;
                    if (t >= 0x1000) {
                        r += 13;
                        t >>>= 13;
                    }
                    if (t >= 0x40) {
                        r += 7;
                        t >>>= 7;
                    }
                    if (t >= 0x8) {
                        r += 4;
                        t >>>= 4;
                    }
                    if (t >= 0x02) {
                        r += 2;
                        t >>>= 2;
                    }
                    return r + t;
                };
                BN.prototype._zeroBits = function _zeroBits(w) {
                    // Short-cut
                    if (w === 0) return 26;
                    var t = w;
                    var r = 0;
                    if ((t & 0x1fff) === 0) {
                        r += 13;
                        t >>>= 13;
                    }
                    if ((t & 0x7f) === 0) {
                        r += 7;
                        t >>>= 7;
                    }
                    if ((t & 0xf) === 0) {
                        r += 4;
                        t >>>= 4;
                    }
                    if ((t & 0x3) === 0) {
                        r += 2;
                        t >>>= 2;
                    }
                    if ((t & 0x1) === 0) r++;
                    return r;
                };
                // Return number of used bits in a BN
                BN.prototype.bitLength = function bitLength() {
                    var w = this.words[this.length - 1];
                    var hi = this._countBits(w);
                    return (this.length - 1) * 26 + hi;
                };
                function toBitArray(num) {
                    var w = new Array(num.bitLength());
                    for(var bit = 0; bit < w.length; bit++){
                        var off = bit / 26 | 0;
                        var wbit = bit % 26;
                        w[bit] = num.words[off] >>> wbit & 0x01;
                    }
                    return w;
                }
                // Number of trailing zero bits
                BN.prototype.zeroBits = function zeroBits() {
                    if (this.isZero()) return 0;
                    var r = 0;
                    for(var i = 0; i < this.length; i++){
                        var b = this._zeroBits(this.words[i]);
                        r += b;
                        if (b !== 26) break;
                    }
                    return r;
                };
                BN.prototype.byteLength = function byteLength() {
                    return Math.ceil(this.bitLength() / 8);
                };
                BN.prototype.toTwos = function toTwos(width) {
                    if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
                    return this.clone();
                };
                BN.prototype.fromTwos = function fromTwos(width) {
                    if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
                    return this.clone();
                };
                BN.prototype.isNeg = function isNeg() {
                    return this.negative !== 0;
                };
                // Return negative clone of `this`
                BN.prototype.neg = function neg() {
                    return this.clone().ineg();
                };
                BN.prototype.ineg = function ineg() {
                    if (!this.isZero()) this.negative ^= 1;
                    return this;
                };
                // Or `num` with `this` in-place
                BN.prototype.iuor = function iuor(num) {
                    while(this.length < num.length)this.words[this.length++] = 0;
                    for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
                    return this._strip();
                };
                BN.prototype.ior = function ior(num) {
                    assert((this.negative | num.negative) === 0);
                    return this.iuor(num);
                };
                // Or `num` with `this`
                BN.prototype.or = function or(num) {
                    if (this.length > num.length) return this.clone().ior(num);
                    return num.clone().ior(this);
                };
                BN.prototype.uor = function uor(num) {
                    if (this.length > num.length) return this.clone().iuor(num);
                    return num.clone().iuor(this);
                };
                // And `num` with `this` in-place
                BN.prototype.iuand = function iuand(num) {
                    // b = min-length(num, this)
                    var b;
                    if (this.length > num.length) b = num;
                    else b = this;
                    for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
                    this.length = b.length;
                    return this._strip();
                };
                BN.prototype.iand = function iand(num) {
                    assert((this.negative | num.negative) === 0);
                    return this.iuand(num);
                };
                // And `num` with `this`
                BN.prototype.and = function and(num) {
                    if (this.length > num.length) return this.clone().iand(num);
                    return num.clone().iand(this);
                };
                BN.prototype.uand = function uand(num) {
                    if (this.length > num.length) return this.clone().iuand(num);
                    return num.clone().iuand(this);
                };
                // Xor `num` with `this` in-place
                BN.prototype.iuxor = function iuxor(num) {
                    // a.length > b.length
                    var a;
                    var b;
                    if (this.length > num.length) {
                        a = this;
                        b = num;
                    } else {
                        a = num;
                        b = this;
                    }
                    for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
                    if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
                    this.length = a.length;
                    return this._strip();
                };
                BN.prototype.ixor = function ixor(num) {
                    assert((this.negative | num.negative) === 0);
                    return this.iuxor(num);
                };
                // Xor `num` with `this`
                BN.prototype.xor = function xor(num) {
                    if (this.length > num.length) return this.clone().ixor(num);
                    return num.clone().ixor(this);
                };
                BN.prototype.uxor = function uxor(num) {
                    if (this.length > num.length) return this.clone().iuxor(num);
                    return num.clone().iuxor(this);
                };
                // Not ``this`` with ``width`` bitwidth
                BN.prototype.inotn = function inotn(width) {
                    assert(typeof width === 'number' && width >= 0);
                    var bytesNeeded = Math.ceil(width / 26) | 0;
                    var bitsLeft = width % 26;
                    // Extend the buffer with leading zeroes
                    this._expand(bytesNeeded);
                    if (bitsLeft > 0) bytesNeeded--;
                    // Handle complete words
                    for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
                    // Handle the residue
                    if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
                    // And remove leading zeroes
                    return this._strip();
                };
                BN.prototype.notn = function notn(width) {
                    return this.clone().inotn(width);
                };
                // Set `bit` of `this`
                BN.prototype.setn = function setn(bit, val) {
                    assert(typeof bit === 'number' && bit >= 0);
                    var off = bit / 26 | 0;
                    var wbit = bit % 26;
                    this._expand(off + 1);
                    if (val) this.words[off] = this.words[off] | 1 << wbit;
                    else this.words[off] = this.words[off] & ~(1 << wbit);
                    return this._strip();
                };
                // Add `num` to `this` in-place
                BN.prototype.iadd = function iadd(num) {
                    var r;
                    // negative + positive
                    if (this.negative !== 0 && num.negative === 0) {
                        this.negative = 0;
                        r = this.isub(num);
                        this.negative ^= 1;
                        return this._normSign();
                    // positive + negative
                    } else if (this.negative === 0 && num.negative !== 0) {
                        num.negative = 0;
                        r = this.isub(num);
                        num.negative = 1;
                        return r._normSign();
                    }
                    // a.length > b.length
                    var a, b;
                    if (this.length > num.length) {
                        a = this;
                        b = num;
                    } else {
                        a = num;
                        b = this;
                    }
                    var carry = 0;
                    for(var i = 0; i < b.length; i++){
                        r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                        this.words[i] = r & 0x3ffffff;
                        carry = r >>> 26;
                    }
                    for(; carry !== 0 && i < a.length; i++){
                        r = (a.words[i] | 0) + carry;
                        this.words[i] = r & 0x3ffffff;
                        carry = r >>> 26;
                    }
                    this.length = a.length;
                    if (carry !== 0) {
                        this.words[this.length] = carry;
                        this.length++;
                    // Copy the rest of the words
                    } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
                    return this;
                };
                // Add `num` to `this`
                BN.prototype.add = function add(num) {
                    var res;
                    if (num.negative !== 0 && this.negative === 0) {
                        num.negative = 0;
                        res = this.sub(num);
                        num.negative ^= 1;
                        return res;
                    } else if (num.negative === 0 && this.negative !== 0) {
                        this.negative = 0;
                        res = num.sub(this);
                        this.negative = 1;
                        return res;
                    }
                    if (this.length > num.length) return this.clone().iadd(num);
                    return num.clone().iadd(this);
                };
                // Subtract `num` from `this` in-place
                BN.prototype.isub = function isub(num) {
                    // this - (-num) = this + num
                    if (num.negative !== 0) {
                        num.negative = 0;
                        var r = this.iadd(num);
                        num.negative = 1;
                        return r._normSign();
                    // -this - num = -(this + num)
                    } else if (this.negative !== 0) {
                        this.negative = 0;
                        this.iadd(num);
                        this.negative = 1;
                        return this._normSign();
                    }
                    // At this point both numbers are positive
                    var cmp = this.cmp(num);
                    // Optimization - zeroify
                    if (cmp === 0) {
                        this.negative = 0;
                        this.length = 1;
                        this.words[0] = 0;
                        return this;
                    }
                    // a > b
                    var a, b;
                    if (cmp > 0) {
                        a = this;
                        b = num;
                    } else {
                        a = num;
                        b = this;
                    }
                    var carry = 0;
                    for(var i = 0; i < b.length; i++){
                        r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                        carry = r >> 26;
                        this.words[i] = r & 0x3ffffff;
                    }
                    for(; carry !== 0 && i < a.length; i++){
                        r = (a.words[i] | 0) + carry;
                        carry = r >> 26;
                        this.words[i] = r & 0x3ffffff;
                    }
                    // Copy rest of the words
                    if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
                    this.length = Math.max(this.length, i);
                    if (a !== this) this.negative = 1;
                    return this._strip();
                };
                // Subtract `num` from `this`
                BN.prototype.sub = function sub(num) {
                    return this.clone().isub(num);
                };
                function smallMulTo(self1, num, out) {
                    out.negative = num.negative ^ self1.negative;
                    var len = self1.length + num.length | 0;
                    out.length = len;
                    len = len - 1 | 0;
                    // Peel one iteration (compiler can't do it, because of code complexity)
                    var a = self1.words[0] | 0;
                    var b = num.words[0] | 0;
                    var r = a * b;
                    var lo = r & 0x3ffffff;
                    var carry = r / 0x4000000 | 0;
                    out.words[0] = lo;
                    for(var k = 1; k < len; k++){
                        // Sum all words with the same `i + j = k` and accumulate `ncarry`,
                        // note that ncarry could be >= 0x3ffffff
                        var ncarry = carry >>> 26;
                        var rword = carry & 0x3ffffff;
                        var maxJ = Math.min(k, num.length - 1);
                        for(var j = Math.max(0, k - self1.length + 1); j <= maxJ; j++){
                            var i = k - j | 0;
                            a = self1.words[i] | 0;
                            b = num.words[j] | 0;
                            r = a * b + rword;
                            ncarry += r / 0x4000000 | 0;
                            rword = r & 0x3ffffff;
                        }
                        out.words[k] = rword | 0;
                        carry = ncarry | 0;
                    }
                    if (carry !== 0) out.words[k] = carry | 0;
                    else out.length--;
                    return out._strip();
                }
                // TODO(indutny): it may be reasonable to omit it for users who don't need
                // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
                // multiplication (like elliptic secp256k1).
                var comb10MulTo = function comb10MulTo(self1, num, out) {
                    var a = self1.words;
                    var b = num.words;
                    var o = out.words;
                    var c = 0;
                    var lo;
                    var mid;
                    var hi;
                    var a0 = a[0] | 0;
                    var al0 = a0 & 0x1fff;
                    var ah0 = a0 >>> 13;
                    var a1 = a[1] | 0;
                    var al1 = a1 & 0x1fff;
                    var ah1 = a1 >>> 13;
                    var a2 = a[2] | 0;
                    var al2 = a2 & 0x1fff;
                    var ah2 = a2 >>> 13;
                    var a3 = a[3] | 0;
                    var al3 = a3 & 0x1fff;
                    var ah3 = a3 >>> 13;
                    var a4 = a[4] | 0;
                    var al4 = a4 & 0x1fff;
                    var ah4 = a4 >>> 13;
                    var a5 = a[5] | 0;
                    var al5 = a5 & 0x1fff;
                    var ah5 = a5 >>> 13;
                    var a6 = a[6] | 0;
                    var al6 = a6 & 0x1fff;
                    var ah6 = a6 >>> 13;
                    var a7 = a[7] | 0;
                    var al7 = a7 & 0x1fff;
                    var ah7 = a7 >>> 13;
                    var a8 = a[8] | 0;
                    var al8 = a8 & 0x1fff;
                    var ah8 = a8 >>> 13;
                    var a9 = a[9] | 0;
                    var al9 = a9 & 0x1fff;
                    var ah9 = a9 >>> 13;
                    var b0 = b[0] | 0;
                    var bl0 = b0 & 0x1fff;
                    var bh0 = b0 >>> 13;
                    var b1 = b[1] | 0;
                    var bl1 = b1 & 0x1fff;
                    var bh1 = b1 >>> 13;
                    var b2 = b[2] | 0;
                    var bl2 = b2 & 0x1fff;
                    var bh2 = b2 >>> 13;
                    var b3 = b[3] | 0;
                    var bl3 = b3 & 0x1fff;
                    var bh3 = b3 >>> 13;
                    var b4 = b[4] | 0;
                    var bl4 = b4 & 0x1fff;
                    var bh4 = b4 >>> 13;
                    var b5 = b[5] | 0;
                    var bl5 = b5 & 0x1fff;
                    var bh5 = b5 >>> 13;
                    var b6 = b[6] | 0;
                    var bl6 = b6 & 0x1fff;
                    var bh6 = b6 >>> 13;
                    var b7 = b[7] | 0;
                    var bl7 = b7 & 0x1fff;
                    var bh7 = b7 >>> 13;
                    var b8 = b[8] | 0;
                    var bl8 = b8 & 0x1fff;
                    var bh8 = b8 >>> 13;
                    var b9 = b[9] | 0;
                    var bl9 = b9 & 0x1fff;
                    var bh9 = b9 >>> 13;
                    out.negative = self1.negative ^ num.negative;
                    out.length = 19;
                    /* k = 0 */ lo = Math.imul(al0, bl0);
                    mid = Math.imul(al0, bh0);
                    mid = mid + Math.imul(ah0, bl0) | 0;
                    hi = Math.imul(ah0, bh0);
                    var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
                    w0 &= 0x3ffffff;
                    /* k = 1 */ lo = Math.imul(al1, bl0);
                    mid = Math.imul(al1, bh0);
                    mid = mid + Math.imul(ah1, bl0) | 0;
                    hi = Math.imul(ah1, bh0);
                    lo = lo + Math.imul(al0, bl1) | 0;
                    mid = mid + Math.imul(al0, bh1) | 0;
                    mid = mid + Math.imul(ah0, bl1) | 0;
                    hi = hi + Math.imul(ah0, bh1) | 0;
                    var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
                    w1 &= 0x3ffffff;
                    /* k = 2 */ lo = Math.imul(al2, bl0);
                    mid = Math.imul(al2, bh0);
                    mid = mid + Math.imul(ah2, bl0) | 0;
                    hi = Math.imul(ah2, bh0);
                    lo = lo + Math.imul(al1, bl1) | 0;
                    mid = mid + Math.imul(al1, bh1) | 0;
                    mid = mid + Math.imul(ah1, bl1) | 0;
                    hi = hi + Math.imul(ah1, bh1) | 0;
                    lo = lo + Math.imul(al0, bl2) | 0;
                    mid = mid + Math.imul(al0, bh2) | 0;
                    mid = mid + Math.imul(ah0, bl2) | 0;
                    hi = hi + Math.imul(ah0, bh2) | 0;
                    var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
                    w2 &= 0x3ffffff;
                    /* k = 3 */ lo = Math.imul(al3, bl0);
                    mid = Math.imul(al3, bh0);
                    mid = mid + Math.imul(ah3, bl0) | 0;
                    hi = Math.imul(ah3, bh0);
                    lo = lo + Math.imul(al2, bl1) | 0;
                    mid = mid + Math.imul(al2, bh1) | 0;
                    mid = mid + Math.imul(ah2, bl1) | 0;
                    hi = hi + Math.imul(ah2, bh1) | 0;
                    lo = lo + Math.imul(al1, bl2) | 0;
                    mid = mid + Math.imul(al1, bh2) | 0;
                    mid = mid + Math.imul(ah1, bl2) | 0;
                    hi = hi + Math.imul(ah1, bh2) | 0;
                    lo = lo + Math.imul(al0, bl3) | 0;
                    mid = mid + Math.imul(al0, bh3) | 0;
                    mid = mid + Math.imul(ah0, bl3) | 0;
                    hi = hi + Math.imul(ah0, bh3) | 0;
                    var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
                    w3 &= 0x3ffffff;
                    /* k = 4 */ lo = Math.imul(al4, bl0);
                    mid = Math.imul(al4, bh0);
                    mid = mid + Math.imul(ah4, bl0) | 0;
                    hi = Math.imul(ah4, bh0);
                    lo = lo + Math.imul(al3, bl1) | 0;
                    mid = mid + Math.imul(al3, bh1) | 0;
                    mid = mid + Math.imul(ah3, bl1) | 0;
                    hi = hi + Math.imul(ah3, bh1) | 0;
                    lo = lo + Math.imul(al2, bl2) | 0;
                    mid = mid + Math.imul(al2, bh2) | 0;
                    mid = mid + Math.imul(ah2, bl2) | 0;
                    hi = hi + Math.imul(ah2, bh2) | 0;
                    lo = lo + Math.imul(al1, bl3) | 0;
                    mid = mid + Math.imul(al1, bh3) | 0;
                    mid = mid + Math.imul(ah1, bl3) | 0;
                    hi = hi + Math.imul(ah1, bh3) | 0;
                    lo = lo + Math.imul(al0, bl4) | 0;
                    mid = mid + Math.imul(al0, bh4) | 0;
                    mid = mid + Math.imul(ah0, bl4) | 0;
                    hi = hi + Math.imul(ah0, bh4) | 0;
                    var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
                    w4 &= 0x3ffffff;
                    /* k = 5 */ lo = Math.imul(al5, bl0);
                    mid = Math.imul(al5, bh0);
                    mid = mid + Math.imul(ah5, bl0) | 0;
                    hi = Math.imul(ah5, bh0);
                    lo = lo + Math.imul(al4, bl1) | 0;
                    mid = mid + Math.imul(al4, bh1) | 0;
                    mid = mid + Math.imul(ah4, bl1) | 0;
                    hi = hi + Math.imul(ah4, bh1) | 0;
                    lo = lo + Math.imul(al3, bl2) | 0;
                    mid = mid + Math.imul(al3, bh2) | 0;
                    mid = mid + Math.imul(ah3, bl2) | 0;
                    hi = hi + Math.imul(ah3, bh2) | 0;
                    lo = lo + Math.imul(al2, bl3) | 0;
                    mid = mid + Math.imul(al2, bh3) | 0;
                    mid = mid + Math.imul(ah2, bl3) | 0;
                    hi = hi + Math.imul(ah2, bh3) | 0;
                    lo = lo + Math.imul(al1, bl4) | 0;
                    mid = mid + Math.imul(al1, bh4) | 0;
                    mid = mid + Math.imul(ah1, bl4) | 0;
                    hi = hi + Math.imul(ah1, bh4) | 0;
                    lo = lo + Math.imul(al0, bl5) | 0;
                    mid = mid + Math.imul(al0, bh5) | 0;
                    mid = mid + Math.imul(ah0, bl5) | 0;
                    hi = hi + Math.imul(ah0, bh5) | 0;
                    var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
                    w5 &= 0x3ffffff;
                    /* k = 6 */ lo = Math.imul(al6, bl0);
                    mid = Math.imul(al6, bh0);
                    mid = mid + Math.imul(ah6, bl0) | 0;
                    hi = Math.imul(ah6, bh0);
                    lo = lo + Math.imul(al5, bl1) | 0;
                    mid = mid + Math.imul(al5, bh1) | 0;
                    mid = mid + Math.imul(ah5, bl1) | 0;
                    hi = hi + Math.imul(ah5, bh1) | 0;
                    lo = lo + Math.imul(al4, bl2) | 0;
                    mid = mid + Math.imul(al4, bh2) | 0;
                    mid = mid + Math.imul(ah4, bl2) | 0;
                    hi = hi + Math.imul(ah4, bh2) | 0;
                    lo = lo + Math.imul(al3, bl3) | 0;
                    mid = mid + Math.imul(al3, bh3) | 0;
                    mid = mid + Math.imul(ah3, bl3) | 0;
                    hi = hi + Math.imul(ah3, bh3) | 0;
                    lo = lo + Math.imul(al2, bl4) | 0;
                    mid = mid + Math.imul(al2, bh4) | 0;
                    mid = mid + Math.imul(ah2, bl4) | 0;
                    hi = hi + Math.imul(ah2, bh4) | 0;
                    lo = lo + Math.imul(al1, bl5) | 0;
                    mid = mid + Math.imul(al1, bh5) | 0;
                    mid = mid + Math.imul(ah1, bl5) | 0;
                    hi = hi + Math.imul(ah1, bh5) | 0;
                    lo = lo + Math.imul(al0, bl6) | 0;
                    mid = mid + Math.imul(al0, bh6) | 0;
                    mid = mid + Math.imul(ah0, bl6) | 0;
                    hi = hi + Math.imul(ah0, bh6) | 0;
                    var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
                    w6 &= 0x3ffffff;
                    /* k = 7 */ lo = Math.imul(al7, bl0);
                    mid = Math.imul(al7, bh0);
                    mid = mid + Math.imul(ah7, bl0) | 0;
                    hi = Math.imul(ah7, bh0);
                    lo = lo + Math.imul(al6, bl1) | 0;
                    mid = mid + Math.imul(al6, bh1) | 0;
                    mid = mid + Math.imul(ah6, bl1) | 0;
                    hi = hi + Math.imul(ah6, bh1) | 0;
                    lo = lo + Math.imul(al5, bl2) | 0;
                    mid = mid + Math.imul(al5, bh2) | 0;
                    mid = mid + Math.imul(ah5, bl2) | 0;
                    hi = hi + Math.imul(ah5, bh2) | 0;
                    lo = lo + Math.imul(al4, bl3) | 0;
                    mid = mid + Math.imul(al4, bh3) | 0;
                    mid = mid + Math.imul(ah4, bl3) | 0;
                    hi = hi + Math.imul(ah4, bh3) | 0;
                    lo = lo + Math.imul(al3, bl4) | 0;
                    mid = mid + Math.imul(al3, bh4) | 0;
                    mid = mid + Math.imul(ah3, bl4) | 0;
                    hi = hi + Math.imul(ah3, bh4) | 0;
                    lo = lo + Math.imul(al2, bl5) | 0;
                    mid = mid + Math.imul(al2, bh5) | 0;
                    mid = mid + Math.imul(ah2, bl5) | 0;
                    hi = hi + Math.imul(ah2, bh5) | 0;
                    lo = lo + Math.imul(al1, bl6) | 0;
                    mid = mid + Math.imul(al1, bh6) | 0;
                    mid = mid + Math.imul(ah1, bl6) | 0;
                    hi = hi + Math.imul(ah1, bh6) | 0;
                    lo = lo + Math.imul(al0, bl7) | 0;
                    mid = mid + Math.imul(al0, bh7) | 0;
                    mid = mid + Math.imul(ah0, bl7) | 0;
                    hi = hi + Math.imul(ah0, bh7) | 0;
                    var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
                    w7 &= 0x3ffffff;
                    /* k = 8 */ lo = Math.imul(al8, bl0);
                    mid = Math.imul(al8, bh0);
                    mid = mid + Math.imul(ah8, bl0) | 0;
                    hi = Math.imul(ah8, bh0);
                    lo = lo + Math.imul(al7, bl1) | 0;
                    mid = mid + Math.imul(al7, bh1) | 0;
                    mid = mid + Math.imul(ah7, bl1) | 0;
                    hi = hi + Math.imul(ah7, bh1) | 0;
                    lo = lo + Math.imul(al6, bl2) | 0;
                    mid = mid + Math.imul(al6, bh2) | 0;
                    mid = mid + Math.imul(ah6, bl2) | 0;
                    hi = hi + Math.imul(ah6, bh2) | 0;
                    lo = lo + Math.imul(al5, bl3) | 0;
                    mid = mid + Math.imul(al5, bh3) | 0;
                    mid = mid + Math.imul(ah5, bl3) | 0;
                    hi = hi + Math.imul(ah5, bh3) | 0;
                    lo = lo + Math.imul(al4, bl4) | 0;
                    mid = mid + Math.imul(al4, bh4) | 0;
                    mid = mid + Math.imul(ah4, bl4) | 0;
                    hi = hi + Math.imul(ah4, bh4) | 0;
                    lo = lo + Math.imul(al3, bl5) | 0;
                    mid = mid + Math.imul(al3, bh5) | 0;
                    mid = mid + Math.imul(ah3, bl5) | 0;
                    hi = hi + Math.imul(ah3, bh5) | 0;
                    lo = lo + Math.imul(al2, bl6) | 0;
                    mid = mid + Math.imul(al2, bh6) | 0;
                    mid = mid + Math.imul(ah2, bl6) | 0;
                    hi = hi + Math.imul(ah2, bh6) | 0;
                    lo = lo + Math.imul(al1, bl7) | 0;
                    mid = mid + Math.imul(al1, bh7) | 0;
                    mid = mid + Math.imul(ah1, bl7) | 0;
                    hi = hi + Math.imul(ah1, bh7) | 0;
                    lo = lo + Math.imul(al0, bl8) | 0;
                    mid = mid + Math.imul(al0, bh8) | 0;
                    mid = mid + Math.imul(ah0, bl8) | 0;
                    hi = hi + Math.imul(ah0, bh8) | 0;
                    var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
                    w8 &= 0x3ffffff;
                    /* k = 9 */ lo = Math.imul(al9, bl0);
                    mid = Math.imul(al9, bh0);
                    mid = mid + Math.imul(ah9, bl0) | 0;
                    hi = Math.imul(ah9, bh0);
                    lo = lo + Math.imul(al8, bl1) | 0;
                    mid = mid + Math.imul(al8, bh1) | 0;
                    mid = mid + Math.imul(ah8, bl1) | 0;
                    hi = hi + Math.imul(ah8, bh1) | 0;
                    lo = lo + Math.imul(al7, bl2) | 0;
                    mid = mid + Math.imul(al7, bh2) | 0;
                    mid = mid + Math.imul(ah7, bl2) | 0;
                    hi = hi + Math.imul(ah7, bh2) | 0;
                    lo = lo + Math.imul(al6, bl3) | 0;
                    mid = mid + Math.imul(al6, bh3) | 0;
                    mid = mid + Math.imul(ah6, bl3) | 0;
                    hi = hi + Math.imul(ah6, bh3) | 0;
                    lo = lo + Math.imul(al5, bl4) | 0;
                    mid = mid + Math.imul(al5, bh4) | 0;
                    mid = mid + Math.imul(ah5, bl4) | 0;
                    hi = hi + Math.imul(ah5, bh4) | 0;
                    lo = lo + Math.imul(al4, bl5) | 0;
                    mid = mid + Math.imul(al4, bh5) | 0;
                    mid = mid + Math.imul(ah4, bl5) | 0;
                    hi = hi + Math.imul(ah4, bh5) | 0;
                    lo = lo + Math.imul(al3, bl6) | 0;
                    mid = mid + Math.imul(al3, bh6) | 0;
                    mid = mid + Math.imul(ah3, bl6) | 0;
                    hi = hi + Math.imul(ah3, bh6) | 0;
                    lo = lo + Math.imul(al2, bl7) | 0;
                    mid = mid + Math.imul(al2, bh7) | 0;
                    mid = mid + Math.imul(ah2, bl7) | 0;
                    hi = hi + Math.imul(ah2, bh7) | 0;
                    lo = lo + Math.imul(al1, bl8) | 0;
                    mid = mid + Math.imul(al1, bh8) | 0;
                    mid = mid + Math.imul(ah1, bl8) | 0;
                    hi = hi + Math.imul(ah1, bh8) | 0;
                    lo = lo + Math.imul(al0, bl9) | 0;
                    mid = mid + Math.imul(al0, bh9) | 0;
                    mid = mid + Math.imul(ah0, bl9) | 0;
                    hi = hi + Math.imul(ah0, bh9) | 0;
                    var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
                    w9 &= 0x3ffffff;
                    /* k = 10 */ lo = Math.imul(al9, bl1);
                    mid = Math.imul(al9, bh1);
                    mid = mid + Math.imul(ah9, bl1) | 0;
                    hi = Math.imul(ah9, bh1);
                    lo = lo + Math.imul(al8, bl2) | 0;
                    mid = mid + Math.imul(al8, bh2) | 0;
                    mid = mid + Math.imul(ah8, bl2) | 0;
                    hi = hi + Math.imul(ah8, bh2) | 0;
                    lo = lo + Math.imul(al7, bl3) | 0;
                    mid = mid + Math.imul(al7, bh3) | 0;
                    mid = mid + Math.imul(ah7, bl3) | 0;
                    hi = hi + Math.imul(ah7, bh3) | 0;
                    lo = lo + Math.imul(al6, bl4) | 0;
                    mid = mid + Math.imul(al6, bh4) | 0;
                    mid = mid + Math.imul(ah6, bl4) | 0;
                    hi = hi + Math.imul(ah6, bh4) | 0;
                    lo = lo + Math.imul(al5, bl5) | 0;
                    mid = mid + Math.imul(al5, bh5) | 0;
                    mid = mid + Math.imul(ah5, bl5) | 0;
                    hi = hi + Math.imul(ah5, bh5) | 0;
                    lo = lo + Math.imul(al4, bl6) | 0;
                    mid = mid + Math.imul(al4, bh6) | 0;
                    mid = mid + Math.imul(ah4, bl6) | 0;
                    hi = hi + Math.imul(ah4, bh6) | 0;
                    lo = lo + Math.imul(al3, bl7) | 0;
                    mid = mid + Math.imul(al3, bh7) | 0;
                    mid = mid + Math.imul(ah3, bl7) | 0;
                    hi = hi + Math.imul(ah3, bh7) | 0;
                    lo = lo + Math.imul(al2, bl8) | 0;
                    mid = mid + Math.imul(al2, bh8) | 0;
                    mid = mid + Math.imul(ah2, bl8) | 0;
                    hi = hi + Math.imul(ah2, bh8) | 0;
                    lo = lo + Math.imul(al1, bl9) | 0;
                    mid = mid + Math.imul(al1, bh9) | 0;
                    mid = mid + Math.imul(ah1, bl9) | 0;
                    hi = hi + Math.imul(ah1, bh9) | 0;
                    var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
                    w10 &= 0x3ffffff;
                    /* k = 11 */ lo = Math.imul(al9, bl2);
                    mid = Math.imul(al9, bh2);
                    mid = mid + Math.imul(ah9, bl2) | 0;
                    hi = Math.imul(ah9, bh2);
                    lo = lo + Math.imul(al8, bl3) | 0;
                    mid = mid + Math.imul(al8, bh3) | 0;
                    mid = mid + Math.imul(ah8, bl3) | 0;
                    hi = hi + Math.imul(ah8, bh3) | 0;
                    lo = lo + Math.imul(al7, bl4) | 0;
                    mid = mid + Math.imul(al7, bh4) | 0;
                    mid = mid + Math.imul(ah7, bl4) | 0;
                    hi = hi + Math.imul(ah7, bh4) | 0;
                    lo = lo + Math.imul(al6, bl5) | 0;
                    mid = mid + Math.imul(al6, bh5) | 0;
                    mid = mid + Math.imul(ah6, bl5) | 0;
                    hi = hi + Math.imul(ah6, bh5) | 0;
                    lo = lo + Math.imul(al5, bl6) | 0;
                    mid = mid + Math.imul(al5, bh6) | 0;
                    mid = mid + Math.imul(ah5, bl6) | 0;
                    hi = hi + Math.imul(ah5, bh6) | 0;
                    lo = lo + Math.imul(al4, bl7) | 0;
                    mid = mid + Math.imul(al4, bh7) | 0;
                    mid = mid + Math.imul(ah4, bl7) | 0;
                    hi = hi + Math.imul(ah4, bh7) | 0;
                    lo = lo + Math.imul(al3, bl8) | 0;
                    mid = mid + Math.imul(al3, bh8) | 0;
                    mid = mid + Math.imul(ah3, bl8) | 0;
                    hi = hi + Math.imul(ah3, bh8) | 0;
                    lo = lo + Math.imul(al2, bl9) | 0;
                    mid = mid + Math.imul(al2, bh9) | 0;
                    mid = mid + Math.imul(ah2, bl9) | 0;
                    hi = hi + Math.imul(ah2, bh9) | 0;
                    var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
                    w11 &= 0x3ffffff;
                    /* k = 12 */ lo = Math.imul(al9, bl3);
                    mid = Math.imul(al9, bh3);
                    mid = mid + Math.imul(ah9, bl3) | 0;
                    hi = Math.imul(ah9, bh3);
                    lo = lo + Math.imul(al8, bl4) | 0;
                    mid = mid + Math.imul(al8, bh4) | 0;
                    mid = mid + Math.imul(ah8, bl4) | 0;
                    hi = hi + Math.imul(ah8, bh4) | 0;
                    lo = lo + Math.imul(al7, bl5) | 0;
                    mid = mid + Math.imul(al7, bh5) | 0;
                    mid = mid + Math.imul(ah7, bl5) | 0;
                    hi = hi + Math.imul(ah7, bh5) | 0;
                    lo = lo + Math.imul(al6, bl6) | 0;
                    mid = mid + Math.imul(al6, bh6) | 0;
                    mid = mid + Math.imul(ah6, bl6) | 0;
                    hi = hi + Math.imul(ah6, bh6) | 0;
                    lo = lo + Math.imul(al5, bl7) | 0;
                    mid = mid + Math.imul(al5, bh7) | 0;
                    mid = mid + Math.imul(ah5, bl7) | 0;
                    hi = hi + Math.imul(ah5, bh7) | 0;
                    lo = lo + Math.imul(al4, bl8) | 0;
                    mid = mid + Math.imul(al4, bh8) | 0;
                    mid = mid + Math.imul(ah4, bl8) | 0;
                    hi = hi + Math.imul(ah4, bh8) | 0;
                    lo = lo + Math.imul(al3, bl9) | 0;
                    mid = mid + Math.imul(al3, bh9) | 0;
                    mid = mid + Math.imul(ah3, bl9) | 0;
                    hi = hi + Math.imul(ah3, bh9) | 0;
                    var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
                    w12 &= 0x3ffffff;
                    /* k = 13 */ lo = Math.imul(al9, bl4);
                    mid = Math.imul(al9, bh4);
                    mid = mid + Math.imul(ah9, bl4) | 0;
                    hi = Math.imul(ah9, bh4);
                    lo = lo + Math.imul(al8, bl5) | 0;
                    mid = mid + Math.imul(al8, bh5) | 0;
                    mid = mid + Math.imul(ah8, bl5) | 0;
                    hi = hi + Math.imul(ah8, bh5) | 0;
                    lo = lo + Math.imul(al7, bl6) | 0;
                    mid = mid + Math.imul(al7, bh6) | 0;
                    mid = mid + Math.imul(ah7, bl6) | 0;
                    hi = hi + Math.imul(ah7, bh6) | 0;
                    lo = lo + Math.imul(al6, bl7) | 0;
                    mid = mid + Math.imul(al6, bh7) | 0;
                    mid = mid + Math.imul(ah6, bl7) | 0;
                    hi = hi + Math.imul(ah6, bh7) | 0;
                    lo = lo + Math.imul(al5, bl8) | 0;
                    mid = mid + Math.imul(al5, bh8) | 0;
                    mid = mid + Math.imul(ah5, bl8) | 0;
                    hi = hi + Math.imul(ah5, bh8) | 0;
                    lo = lo + Math.imul(al4, bl9) | 0;
                    mid = mid + Math.imul(al4, bh9) | 0;
                    mid = mid + Math.imul(ah4, bl9) | 0;
                    hi = hi + Math.imul(ah4, bh9) | 0;
                    var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
                    w13 &= 0x3ffffff;
                    /* k = 14 */ lo = Math.imul(al9, bl5);
                    mid = Math.imul(al9, bh5);
                    mid = mid + Math.imul(ah9, bl5) | 0;
                    hi = Math.imul(ah9, bh5);
                    lo = lo + Math.imul(al8, bl6) | 0;
                    mid = mid + Math.imul(al8, bh6) | 0;
                    mid = mid + Math.imul(ah8, bl6) | 0;
                    hi = hi + Math.imul(ah8, bh6) | 0;
                    lo = lo + Math.imul(al7, bl7) | 0;
                    mid = mid + Math.imul(al7, bh7) | 0;
                    mid = mid + Math.imul(ah7, bl7) | 0;
                    hi = hi + Math.imul(ah7, bh7) | 0;
                    lo = lo + Math.imul(al6, bl8) | 0;
                    mid = mid + Math.imul(al6, bh8) | 0;
                    mid = mid + Math.imul(ah6, bl8) | 0;
                    hi = hi + Math.imul(ah6, bh8) | 0;
                    lo = lo + Math.imul(al5, bl9) | 0;
                    mid = mid + Math.imul(al5, bh9) | 0;
                    mid = mid + Math.imul(ah5, bl9) | 0;
                    hi = hi + Math.imul(ah5, bh9) | 0;
                    var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
                    w14 &= 0x3ffffff;
                    /* k = 15 */ lo = Math.imul(al9, bl6);
                    mid = Math.imul(al9, bh6);
                    mid = mid + Math.imul(ah9, bl6) | 0;
                    hi = Math.imul(ah9, bh6);
                    lo = lo + Math.imul(al8, bl7) | 0;
                    mid = mid + Math.imul(al8, bh7) | 0;
                    mid = mid + Math.imul(ah8, bl7) | 0;
                    hi = hi + Math.imul(ah8, bh7) | 0;
                    lo = lo + Math.imul(al7, bl8) | 0;
                    mid = mid + Math.imul(al7, bh8) | 0;
                    mid = mid + Math.imul(ah7, bl8) | 0;
                    hi = hi + Math.imul(ah7, bh8) | 0;
                    lo = lo + Math.imul(al6, bl9) | 0;
                    mid = mid + Math.imul(al6, bh9) | 0;
                    mid = mid + Math.imul(ah6, bl9) | 0;
                    hi = hi + Math.imul(ah6, bh9) | 0;
                    var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
                    w15 &= 0x3ffffff;
                    /* k = 16 */ lo = Math.imul(al9, bl7);
                    mid = Math.imul(al9, bh7);
                    mid = mid + Math.imul(ah9, bl7) | 0;
                    hi = Math.imul(ah9, bh7);
                    lo = lo + Math.imul(al8, bl8) | 0;
                    mid = mid + Math.imul(al8, bh8) | 0;
                    mid = mid + Math.imul(ah8, bl8) | 0;
                    hi = hi + Math.imul(ah8, bh8) | 0;
                    lo = lo + Math.imul(al7, bl9) | 0;
                    mid = mid + Math.imul(al7, bh9) | 0;
                    mid = mid + Math.imul(ah7, bl9) | 0;
                    hi = hi + Math.imul(ah7, bh9) | 0;
                    var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
                    w16 &= 0x3ffffff;
                    /* k = 17 */ lo = Math.imul(al9, bl8);
                    mid = Math.imul(al9, bh8);
                    mid = mid + Math.imul(ah9, bl8) | 0;
                    hi = Math.imul(ah9, bh8);
                    lo = lo + Math.imul(al8, bl9) | 0;
                    mid = mid + Math.imul(al8, bh9) | 0;
                    mid = mid + Math.imul(ah8, bl9) | 0;
                    hi = hi + Math.imul(ah8, bh9) | 0;
                    var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
                    w17 &= 0x3ffffff;
                    /* k = 18 */ lo = Math.imul(al9, bl9);
                    mid = Math.imul(al9, bh9);
                    mid = mid + Math.imul(ah9, bl9) | 0;
                    hi = Math.imul(ah9, bh9);
                    var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                    c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
                    w18 &= 0x3ffffff;
                    o[0] = w0;
                    o[1] = w1;
                    o[2] = w2;
                    o[3] = w3;
                    o[4] = w4;
                    o[5] = w5;
                    o[6] = w6;
                    o[7] = w7;
                    o[8] = w8;
                    o[9] = w9;
                    o[10] = w10;
                    o[11] = w11;
                    o[12] = w12;
                    o[13] = w13;
                    o[14] = w14;
                    o[15] = w15;
                    o[16] = w16;
                    o[17] = w17;
                    o[18] = w18;
                    if (c !== 0) {
                        o[19] = c;
                        out.length++;
                    }
                    return out;
                };
                // Polyfill comb
                if (!Math.imul) comb10MulTo = smallMulTo;
                function bigMulTo(self1, num, out) {
                    out.negative = num.negative ^ self1.negative;
                    out.length = self1.length + num.length;
                    var carry = 0;
                    var hncarry = 0;
                    for(var k = 0; k < out.length - 1; k++){
                        // Sum all words with the same `i + j = k` and accumulate `ncarry`,
                        // note that ncarry could be >= 0x3ffffff
                        var ncarry = hncarry;
                        hncarry = 0;
                        var rword = carry & 0x3ffffff;
                        var maxJ = Math.min(k, num.length - 1);
                        for(var j = Math.max(0, k - self1.length + 1); j <= maxJ; j++){
                            var i = k - j;
                            var a = self1.words[i] | 0;
                            var b = num.words[j] | 0;
                            var r = a * b;
                            var lo = r & 0x3ffffff;
                            ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                            lo = lo + rword | 0;
                            rword = lo & 0x3ffffff;
                            ncarry = ncarry + (lo >>> 26) | 0;
                            hncarry += ncarry >>> 26;
                            ncarry &= 0x3ffffff;
                        }
                        out.words[k] = rword;
                        carry = ncarry;
                        ncarry = hncarry;
                    }
                    if (carry !== 0) out.words[k] = carry;
                    else out.length--;
                    return out._strip();
                }
                function jumboMulTo(self1, num, out) {
                    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
                    // var fftm = new FFTM();
                    // return fftm.mulp(self, num, out);
                    return bigMulTo(self1, num, out);
                }
                BN.prototype.mulTo = function mulTo(num, out) {
                    var res;
                    var len = this.length + num.length;
                    if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
                    else if (len < 63) res = smallMulTo(this, num, out);
                    else if (len < 1024) res = bigMulTo(this, num, out);
                    else res = jumboMulTo(this, num, out);
                    return res;
                };
                // Cooley-Tukey algorithm for FFT
                // slightly revisited to rely on looping instead of recursion
                function FFTM(x, y) {
                    this.x = x;
                    this.y = y;
                }
                FFTM.prototype.makeRBT = function makeRBT(N) {
                    var t = new Array(N);
                    var l = BN.prototype._countBits(N) - 1;
                    for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
                    return t;
                };
                // Returns binary-reversed representation of `x`
                FFTM.prototype.revBin = function revBin(x, l, N) {
                    if (x === 0 || x === N - 1) return x;
                    var rb = 0;
                    for(var i = 0; i < l; i++){
                        rb |= (x & 1) << l - i - 1;
                        x >>= 1;
                    }
                    return rb;
                };
                // Performs "tweedling" phase, therefore 'emulating'
                // behaviour of the recursive algorithm
                FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
                    for(var i = 0; i < N; i++){
                        rtws[i] = rws[rbt[i]];
                        itws[i] = iws[rbt[i]];
                    }
                };
                FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
                    this.permute(rbt, rws, iws, rtws, itws, N);
                    for(var s = 1; s < N; s <<= 1){
                        var l = s << 1;
                        var rtwdf = Math.cos(2 * Math.PI / l);
                        var itwdf = Math.sin(2 * Math.PI / l);
                        for(var p = 0; p < N; p += l){
                            var rtwdf_ = rtwdf;
                            var itwdf_ = itwdf;
                            for(var j = 0; j < s; j++){
                                var re = rtws[p + j];
                                var ie = itws[p + j];
                                var ro = rtws[p + j + s];
                                var io = itws[p + j + s];
                                var rx = rtwdf_ * ro - itwdf_ * io;
                                io = rtwdf_ * io + itwdf_ * ro;
                                ro = rx;
                                rtws[p + j] = re + ro;
                                itws[p + j] = ie + io;
                                rtws[p + j + s] = re - ro;
                                itws[p + j + s] = ie - io;
                                /* jshint maxdepth : false */ if (j !== l) {
                                    rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                                    itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                                    rtwdf_ = rx;
                                }
                            }
                        }
                    }
                };
                FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
                    var N = Math.max(m, n) | 1;
                    var odd = N & 1;
                    var i = 0;
                    for(N = N / 2 | 0; N; N = N >>> 1)i++;
                    return 1 << i + 1 + odd;
                };
                FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
                    if (N <= 1) return;
                    for(var i = 0; i < N / 2; i++){
                        var t = rws[i];
                        rws[i] = rws[N - i - 1];
                        rws[N - i - 1] = t;
                        t = iws[i];
                        iws[i] = -iws[N - i - 1];
                        iws[N - i - 1] = -t;
                    }
                };
                FFTM.prototype.normalize13b = function normalize13b(ws, N) {
                    var carry = 0;
                    for(var i = 0; i < N / 2; i++){
                        var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
                        ws[i] = w & 0x3ffffff;
                        if (w < 0x4000000) carry = 0;
                        else carry = w / 0x4000000 | 0;
                    }
                    return ws;
                };
                FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
                    var carry = 0;
                    for(var i = 0; i < len; i++){
                        carry = carry + (ws[i] | 0);
                        rws[2 * i] = carry & 0x1fff;
                        carry = carry >>> 13;
                        rws[2 * i + 1] = carry & 0x1fff;
                        carry = carry >>> 13;
                    }
                    // Pad with zeroes
                    for(i = 2 * len; i < N; ++i)rws[i] = 0;
                    assert(carry === 0);
                    assert((carry & -8192) === 0);
                };
                FFTM.prototype.stub = function stub(N) {
                    var ph = new Array(N);
                    for(var i = 0; i < N; i++)ph[i] = 0;
                    return ph;
                };
                FFTM.prototype.mulp = function mulp(x, y, out) {
                    var N = 2 * this.guessLen13b(x.length, y.length);
                    var rbt = this.makeRBT(N);
                    var _ = this.stub(N);
                    var rws = new Array(N);
                    var rwst = new Array(N);
                    var iwst = new Array(N);
                    var nrws = new Array(N);
                    var nrwst = new Array(N);
                    var niwst = new Array(N);
                    var rmws = out.words;
                    rmws.length = N;
                    this.convert13b(x.words, x.length, rws, N);
                    this.convert13b(y.words, y.length, nrws, N);
                    this.transform(rws, _, rwst, iwst, N, rbt);
                    this.transform(nrws, _, nrwst, niwst, N, rbt);
                    for(var i = 0; i < N; i++){
                        var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                        iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                        rwst[i] = rx;
                    }
                    this.conjugate(rwst, iwst, N);
                    this.transform(rwst, iwst, rmws, _, N, rbt);
                    this.conjugate(rmws, _, N);
                    this.normalize13b(rmws, N);
                    out.negative = x.negative ^ y.negative;
                    out.length = x.length + y.length;
                    return out._strip();
                };
                // Multiply `this` by `num`
                BN.prototype.mul = function mul(num) {
                    var out = new BN(null);
                    out.words = new Array(this.length + num.length);
                    return this.mulTo(num, out);
                };
                // Multiply employing FFT
                BN.prototype.mulf = function mulf(num) {
                    var out = new BN(null);
                    out.words = new Array(this.length + num.length);
                    return jumboMulTo(this, num, out);
                };
                // In-place Multiplication
                BN.prototype.imul = function imul(num) {
                    return this.clone().mulTo(num, this);
                };
                BN.prototype.imuln = function imuln(num) {
                    var isNegNum = num < 0;
                    if (isNegNum) num = -num;
                    assert(typeof num === 'number');
                    assert(num < 0x4000000);
                    // Carry
                    var carry = 0;
                    for(var i = 0; i < this.length; i++){
                        var w = (this.words[i] | 0) * num;
                        var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
                        carry >>= 26;
                        carry += w / 0x4000000 | 0;
                        // NOTE: lo is 27bit maximum
                        carry += lo >>> 26;
                        this.words[i] = lo & 0x3ffffff;
                    }
                    if (carry !== 0) {
                        this.words[i] = carry;
                        this.length++;
                    }
                    return isNegNum ? this.ineg() : this;
                };
                BN.prototype.muln = function muln(num) {
                    return this.clone().imuln(num);
                };
                // `this` * `this`
                BN.prototype.sqr = function sqr() {
                    return this.mul(this);
                };
                // `this` * `this` in-place
                BN.prototype.isqr = function isqr() {
                    return this.imul(this.clone());
                };
                // Math.pow(`this`, `num`)
                BN.prototype.pow = function pow(num) {
                    var w = toBitArray(num);
                    if (w.length === 0) return new BN(1);
                    // Skip leading zeroes
                    var res = this;
                    for(var i = 0; i < w.length; i++, res = res.sqr()){
                        if (w[i] !== 0) break;
                    }
                    if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
                        if (w[i] === 0) continue;
                        res = res.mul(q);
                    }
                    return res;
                };
                // Shift-left in-place
                BN.prototype.iushln = function iushln(bits) {
                    assert(typeof bits === 'number' && bits >= 0);
                    var r = bits % 26;
                    var s = (bits - r) / 26;
                    var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
                    var i;
                    if (r !== 0) {
                        var carry = 0;
                        for(i = 0; i < this.length; i++){
                            var newCarry = this.words[i] & carryMask;
                            var c = (this.words[i] | 0) - newCarry << r;
                            this.words[i] = c | carry;
                            carry = newCarry >>> 26 - r;
                        }
                        if (carry) {
                            this.words[i] = carry;
                            this.length++;
                        }
                    }
                    if (s !== 0) {
                        for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
                        for(i = 0; i < s; i++)this.words[i] = 0;
                        this.length += s;
                    }
                    return this._strip();
                };
                BN.prototype.ishln = function ishln(bits) {
                    // TODO(indutny): implement me
                    assert(this.negative === 0);
                    return this.iushln(bits);
                };
                // Shift-right in-place
                // NOTE: `hint` is a lowest bit before trailing zeroes
                // NOTE: if `extended` is present - it will be filled with destroyed bits
                BN.prototype.iushrn = function iushrn(bits, hint, extended) {
                    assert(typeof bits === 'number' && bits >= 0);
                    var h;
                    if (hint) h = (hint - hint % 26) / 26;
                    else h = 0;
                    var r = bits % 26;
                    var s = Math.min((bits - r) / 26, this.length);
                    var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                    var maskedWords = extended;
                    h -= s;
                    h = Math.max(0, h);
                    // Extended mode, copy masked part
                    if (maskedWords) {
                        for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
                        maskedWords.length = s;
                    }
                    if (s === 0) ;
                    else if (this.length > s) {
                        this.length -= s;
                        for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
                    } else {
                        this.words[0] = 0;
                        this.length = 1;
                    }
                    var carry = 0;
                    for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
                        var word = this.words[i] | 0;
                        this.words[i] = carry << 26 - r | word >>> r;
                        carry = word & mask;
                    }
                    // Push carried bits as a mask
                    if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
                    if (this.length === 0) {
                        this.words[0] = 0;
                        this.length = 1;
                    }
                    return this._strip();
                };
                BN.prototype.ishrn = function ishrn(bits, hint, extended) {
                    // TODO(indutny): implement me
                    assert(this.negative === 0);
                    return this.iushrn(bits, hint, extended);
                };
                // Shift-left
                BN.prototype.shln = function shln(bits) {
                    return this.clone().ishln(bits);
                };
                BN.prototype.ushln = function ushln(bits) {
                    return this.clone().iushln(bits);
                };
                // Shift-right
                BN.prototype.shrn = function shrn(bits) {
                    return this.clone().ishrn(bits);
                };
                BN.prototype.ushrn = function ushrn(bits) {
                    return this.clone().iushrn(bits);
                };
                // Test if n bit is set
                BN.prototype.testn = function testn(bit) {
                    assert(typeof bit === 'number' && bit >= 0);
                    var r = bit % 26;
                    var s = (bit - r) / 26;
                    var q = 1 << r;
                    // Fast case: bit is much higher than all existing words
                    if (this.length <= s) return false;
                    // Check bit and return
                    var w = this.words[s];
                    return !!(w & q);
                };
                // Return only lowers bits of number (in-place)
                BN.prototype.imaskn = function imaskn(bits) {
                    assert(typeof bits === 'number' && bits >= 0);
                    var r = bits % 26;
                    var s = (bits - r) / 26;
                    assert(this.negative === 0, 'imaskn works only with positive numbers');
                    if (this.length <= s) return this;
                    if (r !== 0) s++;
                    this.length = Math.min(s, this.length);
                    if (r !== 0) {
                        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                        this.words[this.length - 1] &= mask;
                    }
                    return this._strip();
                };
                // Return only lowers bits of number
                BN.prototype.maskn = function maskn(bits) {
                    return this.clone().imaskn(bits);
                };
                // Add plain number `num` to `this`
                BN.prototype.iaddn = function iaddn(num) {
                    assert(typeof num === 'number');
                    assert(num < 0x4000000);
                    if (num < 0) return this.isubn(-num);
                    // Possible sign change
                    if (this.negative !== 0) {
                        if (this.length === 1 && (this.words[0] | 0) <= num) {
                            this.words[0] = num - (this.words[0] | 0);
                            this.negative = 0;
                            return this;
                        }
                        this.negative = 0;
                        this.isubn(num);
                        this.negative = 1;
                        return this;
                    }
                    // Add without checks
                    return this._iaddn(num);
                };
                BN.prototype._iaddn = function _iaddn(num) {
                    this.words[0] += num;
                    // Carry
                    for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
                        this.words[i] -= 0x4000000;
                        if (i === this.length - 1) this.words[i + 1] = 1;
                        else this.words[i + 1]++;
                    }
                    this.length = Math.max(this.length, i + 1);
                    return this;
                };
                // Subtract plain number `num` from `this`
                BN.prototype.isubn = function isubn(num) {
                    assert(typeof num === 'number');
                    assert(num < 0x4000000);
                    if (num < 0) return this.iaddn(-num);
                    if (this.negative !== 0) {
                        this.negative = 0;
                        this.iaddn(num);
                        this.negative = 1;
                        return this;
                    }
                    this.words[0] -= num;
                    if (this.length === 1 && this.words[0] < 0) {
                        this.words[0] = -this.words[0];
                        this.negative = 1;
                    } else // Carry
                    for(var i = 0; i < this.length && this.words[i] < 0; i++){
                        this.words[i] += 0x4000000;
                        this.words[i + 1] -= 1;
                    }
                    return this._strip();
                };
                BN.prototype.addn = function addn(num) {
                    return this.clone().iaddn(num);
                };
                BN.prototype.subn = function subn(num) {
                    return this.clone().isubn(num);
                };
                BN.prototype.iabs = function iabs() {
                    this.negative = 0;
                    return this;
                };
                BN.prototype.abs = function abs() {
                    return this.clone().iabs();
                };
                BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
                    var len = num.length + shift;
                    var i;
                    this._expand(len);
                    var w;
                    var carry = 0;
                    for(i = 0; i < num.length; i++){
                        w = (this.words[i + shift] | 0) + carry;
                        var right = (num.words[i] | 0) * mul;
                        w -= right & 0x3ffffff;
                        carry = (w >> 26) - (right / 0x4000000 | 0);
                        this.words[i + shift] = w & 0x3ffffff;
                    }
                    for(; i < this.length - shift; i++){
                        w = (this.words[i + shift] | 0) + carry;
                        carry = w >> 26;
                        this.words[i + shift] = w & 0x3ffffff;
                    }
                    if (carry === 0) return this._strip();
                    // Subtraction overflow
                    assert(carry === -1);
                    carry = 0;
                    for(i = 0; i < this.length; i++){
                        w = -(this.words[i] | 0) + carry;
                        carry = w >> 26;
                        this.words[i] = w & 0x3ffffff;
                    }
                    this.negative = 1;
                    return this._strip();
                };
                BN.prototype._wordDiv = function _wordDiv(num, mode) {
                    var shift = this.length - num.length;
                    var a = this.clone();
                    var b = num;
                    // Normalize
                    var bhi = b.words[b.length - 1] | 0;
                    var bhiBits = this._countBits(bhi);
                    shift = 26 - bhiBits;
                    if (shift !== 0) {
                        b = b.ushln(shift);
                        a.iushln(shift);
                        bhi = b.words[b.length - 1] | 0;
                    }
                    // Initialize quotient
                    var m = a.length - b.length;
                    var q;
                    if (mode !== 'mod') {
                        q = new BN(null);
                        q.length = m + 1;
                        q.words = new Array(q.length);
                        for(var i = 0; i < q.length; i++)q.words[i] = 0;
                    }
                    var diff = a.clone()._ishlnsubmul(b, 1, m);
                    if (diff.negative === 0) {
                        a = diff;
                        if (q) q.words[m] = 1;
                    }
                    for(var j = m - 1; j >= 0; j--){
                        var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
                        // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
                        // (0x7ffffff)
                        qj = Math.min(qj / bhi | 0, 0x3ffffff);
                        a._ishlnsubmul(b, qj, j);
                        while(a.negative !== 0){
                            qj--;
                            a.negative = 0;
                            a._ishlnsubmul(b, 1, j);
                            if (!a.isZero()) a.negative ^= 1;
                        }
                        if (q) q.words[j] = qj;
                    }
                    if (q) q._strip();
                    a._strip();
                    // Denormalize
                    if (mode !== 'div' && shift !== 0) a.iushrn(shift);
                    return {
                        div: q || null,
                        mod: a
                    };
                };
                // NOTE: 1) `mode` can be set to `mod` to request mod only,
                //       to `div` to request div only, or be absent to
                //       request both div & mod
                //       2) `positive` is true if unsigned mod is requested
                BN.prototype.divmod = function divmod(num, mode, positive) {
                    assert(!num.isZero());
                    if (this.isZero()) return {
                        div: new BN(0),
                        mod: new BN(0)
                    };
                    var div, mod, res;
                    if (this.negative !== 0 && num.negative === 0) {
                        res = this.neg().divmod(num, mode);
                        if (mode !== 'mod') div = res.div.neg();
                        if (mode !== 'div') {
                            mod = res.mod.neg();
                            if (positive && mod.negative !== 0) mod.iadd(num);
                        }
                        return {
                            div: div,
                            mod: mod
                        };
                    }
                    if (this.negative === 0 && num.negative !== 0) {
                        res = this.divmod(num.neg(), mode);
                        if (mode !== 'mod') div = res.div.neg();
                        return {
                            div: div,
                            mod: res.mod
                        };
                    }
                    if ((this.negative & num.negative) !== 0) {
                        res = this.neg().divmod(num.neg(), mode);
                        if (mode !== 'div') {
                            mod = res.mod.neg();
                            if (positive && mod.negative !== 0) mod.isub(num);
                        }
                        return {
                            div: res.div,
                            mod: mod
                        };
                    }
                    // Both numbers are positive at this point
                    // Strip both numbers to approximate shift value
                    if (num.length > this.length || this.cmp(num) < 0) return {
                        div: new BN(0),
                        mod: this
                    };
                    // Very short reduction
                    if (num.length === 1) {
                        if (mode === 'div') return {
                            div: this.divn(num.words[0]),
                            mod: null
                        };
                        if (mode === 'mod') return {
                            div: null,
                            mod: new BN(this.modrn(num.words[0]))
                        };
                        return {
                            div: this.divn(num.words[0]),
                            mod: new BN(this.modrn(num.words[0]))
                        };
                    }
                    return this._wordDiv(num, mode);
                };
                // Find `this` / `num`
                BN.prototype.div = function div(num) {
                    return this.divmod(num, 'div', false).div;
                };
                // Find `this` % `num`
                BN.prototype.mod = function mod(num) {
                    return this.divmod(num, 'mod', false).mod;
                };
                BN.prototype.umod = function umod(num) {
                    return this.divmod(num, 'mod', true).mod;
                };
                // Find Round(`this` / `num`)
                BN.prototype.divRound = function divRound(num) {
                    var dm = this.divmod(num);
                    // Fast case - exact division
                    if (dm.mod.isZero()) return dm.div;
                    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
                    var half = num.ushrn(1);
                    var r2 = num.andln(1);
                    var cmp = mod.cmp(half);
                    // Round down
                    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
                    // Round up
                    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
                };
                BN.prototype.modrn = function modrn(num) {
                    var isNegNum = num < 0;
                    if (isNegNum) num = -num;
                    assert(num <= 0x3ffffff);
                    var p = 67108864 % num;
                    var acc = 0;
                    for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
                    return isNegNum ? -acc : acc;
                };
                // WARNING: DEPRECATED
                BN.prototype.modn = function modn(num) {
                    return this.modrn(num);
                };
                // In-place division by number
                BN.prototype.idivn = function idivn(num) {
                    var isNegNum = num < 0;
                    if (isNegNum) num = -num;
                    assert(num <= 0x3ffffff);
                    var carry = 0;
                    for(var i = this.length - 1; i >= 0; i--){
                        var w = (this.words[i] | 0) + carry * 0x4000000;
                        this.words[i] = w / num | 0;
                        carry = w % num;
                    }
                    this._strip();
                    return isNegNum ? this.ineg() : this;
                };
                BN.prototype.divn = function divn(num) {
                    return this.clone().idivn(num);
                };
                BN.prototype.egcd = function egcd(p) {
                    assert(p.negative === 0);
                    assert(!p.isZero());
                    var x = this;
                    var y = p.clone();
                    if (x.negative !== 0) x = x.umod(p);
                    else x = x.clone();
                    // A * x + B * y = x
                    var A = new BN(1);
                    var B = new BN(0);
                    // C * x + D * y = y
                    var C = new BN(0);
                    var D = new BN(1);
                    var g = 0;
                    while(x.isEven() && y.isEven()){
                        x.iushrn(1);
                        y.iushrn(1);
                        ++g;
                    }
                    var yp = y.clone();
                    var xp = x.clone();
                    while(!x.isZero()){
                        for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                        if (i > 0) {
                            x.iushrn(i);
                            while(i-- > 0){
                                if (A.isOdd() || B.isOdd()) {
                                    A.iadd(yp);
                                    B.isub(xp);
                                }
                                A.iushrn(1);
                                B.iushrn(1);
                            }
                        }
                        for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                        if (j > 0) {
                            y.iushrn(j);
                            while(j-- > 0){
                                if (C.isOdd() || D.isOdd()) {
                                    C.iadd(yp);
                                    D.isub(xp);
                                }
                                C.iushrn(1);
                                D.iushrn(1);
                            }
                        }
                        if (x.cmp(y) >= 0) {
                            x.isub(y);
                            A.isub(C);
                            B.isub(D);
                        } else {
                            y.isub(x);
                            C.isub(A);
                            D.isub(B);
                        }
                    }
                    return {
                        a: C,
                        b: D,
                        gcd: y.iushln(g)
                    };
                };
                // This is reduced incarnation of the binary EEA
                // above, designated to invert members of the
                // _prime_ fields F(p) at a maximal speed
                BN.prototype._invmp = function _invmp(p) {
                    assert(p.negative === 0);
                    assert(!p.isZero());
                    var a = this;
                    var b = p.clone();
                    if (a.negative !== 0) a = a.umod(p);
                    else a = a.clone();
                    var x1 = new BN(1);
                    var x2 = new BN(0);
                    var delta = b.clone();
                    while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
                        for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                        if (i > 0) {
                            a.iushrn(i);
                            while(i-- > 0){
                                if (x1.isOdd()) x1.iadd(delta);
                                x1.iushrn(1);
                            }
                        }
                        for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                        if (j > 0) {
                            b.iushrn(j);
                            while(j-- > 0){
                                if (x2.isOdd()) x2.iadd(delta);
                                x2.iushrn(1);
                            }
                        }
                        if (a.cmp(b) >= 0) {
                            a.isub(b);
                            x1.isub(x2);
                        } else {
                            b.isub(a);
                            x2.isub(x1);
                        }
                    }
                    var res;
                    if (a.cmpn(1) === 0) res = x1;
                    else res = x2;
                    if (res.cmpn(0) < 0) res.iadd(p);
                    return res;
                };
                BN.prototype.gcd = function gcd(num) {
                    if (this.isZero()) return num.abs();
                    if (num.isZero()) return this.abs();
                    var a = this.clone();
                    var b = num.clone();
                    a.negative = 0;
                    b.negative = 0;
                    // Remove common factor of two
                    for(var shift = 0; a.isEven() && b.isEven(); shift++){
                        a.iushrn(1);
                        b.iushrn(1);
                    }
                    do {
                        while(a.isEven())a.iushrn(1);
                        while(b.isEven())b.iushrn(1);
                        var r = a.cmp(b);
                        if (r < 0) {
                            // Swap `a` and `b` to make `a` always bigger than `b`
                            var t = a;
                            a = b;
                            b = t;
                        } else if (r === 0 || b.cmpn(1) === 0) break;
                        a.isub(b);
                    }while (true);
                    return b.iushln(shift);
                };
                // Invert number in the field F(num)
                BN.prototype.invm = function invm(num) {
                    return this.egcd(num).a.umod(num);
                };
                BN.prototype.isEven = function isEven() {
                    return (this.words[0] & 1) === 0;
                };
                BN.prototype.isOdd = function isOdd() {
                    return (this.words[0] & 1) === 1;
                };
                // And first word and num
                BN.prototype.andln = function andln(num) {
                    return this.words[0] & num;
                };
                // Increment at the bit position in-line
                BN.prototype.bincn = function bincn(bit) {
                    assert(typeof bit === 'number');
                    var r = bit % 26;
                    var s = (bit - r) / 26;
                    var q = 1 << r;
                    // Fast case: bit is much higher than all existing words
                    if (this.length <= s) {
                        this._expand(s + 1);
                        this.words[s] |= q;
                        return this;
                    }
                    // Add bit and propagate, if needed
                    var carry = q;
                    for(var i = s; carry !== 0 && i < this.length; i++){
                        var w = this.words[i] | 0;
                        w += carry;
                        carry = w >>> 26;
                        w &= 0x3ffffff;
                        this.words[i] = w;
                    }
                    if (carry !== 0) {
                        this.words[i] = carry;
                        this.length++;
                    }
                    return this;
                };
                BN.prototype.isZero = function isZero() {
                    return this.length === 1 && this.words[0] === 0;
                };
                BN.prototype.cmpn = function cmpn(num) {
                    var negative = num < 0;
                    if (this.negative !== 0 && !negative) return -1;
                    if (this.negative === 0 && negative) return 1;
                    this._strip();
                    var res;
                    if (this.length > 1) res = 1;
                    else {
                        if (negative) num = -num;
                        assert(num <= 0x3ffffff, 'Number is too big');
                        var w = this.words[0] | 0;
                        res = w === num ? 0 : w < num ? -1 : 1;
                    }
                    if (this.negative !== 0) return -res | 0;
                    return res;
                };
                // Compare two numbers and return:
                // 1 - if `this` > `num`
                // 0 - if `this` == `num`
                // -1 - if `this` < `num`
                BN.prototype.cmp = function cmp(num) {
                    if (this.negative !== 0 && num.negative === 0) return -1;
                    if (this.negative === 0 && num.negative !== 0) return 1;
                    var res = this.ucmp(num);
                    if (this.negative !== 0) return -res | 0;
                    return res;
                };
                // Unsigned comparison
                BN.prototype.ucmp = function ucmp(num) {
                    // At this point both numbers have the same sign
                    if (this.length > num.length) return 1;
                    if (this.length < num.length) return -1;
                    var res = 0;
                    for(var i = this.length - 1; i >= 0; i--){
                        var a = this.words[i] | 0;
                        var b = num.words[i] | 0;
                        if (a === b) continue;
                        if (a < b) res = -1;
                        else if (a > b) res = 1;
                        break;
                    }
                    return res;
                };
                BN.prototype.gtn = function gtn(num) {
                    return this.cmpn(num) === 1;
                };
                BN.prototype.gt = function gt(num) {
                    return this.cmp(num) === 1;
                };
                BN.prototype.gten = function gten(num) {
                    return this.cmpn(num) >= 0;
                };
                BN.prototype.gte = function gte(num) {
                    return this.cmp(num) >= 0;
                };
                BN.prototype.ltn = function ltn(num) {
                    return this.cmpn(num) === -1;
                };
                BN.prototype.lt = function lt(num) {
                    return this.cmp(num) === -1;
                };
                BN.prototype.lten = function lten(num) {
                    return this.cmpn(num) <= 0;
                };
                BN.prototype.lte = function lte(num) {
                    return this.cmp(num) <= 0;
                };
                BN.prototype.eqn = function eqn(num) {
                    return this.cmpn(num) === 0;
                };
                BN.prototype.eq = function eq(num) {
                    return this.cmp(num) === 0;
                };
                //
                // A reduce context, could be using montgomery or something better, depending
                // on the `m` itself.
                //
                BN.red = function red(num) {
                    return new Red(num);
                };
                BN.prototype.toRed = function toRed(ctx) {
                    assert(!this.red, 'Already a number in reduction context');
                    assert(this.negative === 0, 'red works only with positives');
                    return ctx.convertTo(this)._forceRed(ctx);
                };
                BN.prototype.fromRed = function fromRed() {
                    assert(this.red, 'fromRed works only with numbers in reduction context');
                    return this.red.convertFrom(this);
                };
                BN.prototype._forceRed = function _forceRed(ctx) {
                    this.red = ctx;
                    return this;
                };
                BN.prototype.forceRed = function forceRed(ctx) {
                    assert(!this.red, 'Already a number in reduction context');
                    return this._forceRed(ctx);
                };
                BN.prototype.redAdd = function redAdd(num) {
                    assert(this.red, 'redAdd works only with red numbers');
                    return this.red.add(this, num);
                };
                BN.prototype.redIAdd = function redIAdd(num) {
                    assert(this.red, 'redIAdd works only with red numbers');
                    return this.red.iadd(this, num);
                };
                BN.prototype.redSub = function redSub(num) {
                    assert(this.red, 'redSub works only with red numbers');
                    return this.red.sub(this, num);
                };
                BN.prototype.redISub = function redISub(num) {
                    assert(this.red, 'redISub works only with red numbers');
                    return this.red.isub(this, num);
                };
                BN.prototype.redShl = function redShl(num) {
                    assert(this.red, 'redShl works only with red numbers');
                    return this.red.shl(this, num);
                };
                BN.prototype.redMul = function redMul(num) {
                    assert(this.red, 'redMul works only with red numbers');
                    this.red._verify2(this, num);
                    return this.red.mul(this, num);
                };
                BN.prototype.redIMul = function redIMul(num) {
                    assert(this.red, 'redMul works only with red numbers');
                    this.red._verify2(this, num);
                    return this.red.imul(this, num);
                };
                BN.prototype.redSqr = function redSqr() {
                    assert(this.red, 'redSqr works only with red numbers');
                    this.red._verify1(this);
                    return this.red.sqr(this);
                };
                BN.prototype.redISqr = function redISqr() {
                    assert(this.red, 'redISqr works only with red numbers');
                    this.red._verify1(this);
                    return this.red.isqr(this);
                };
                // Square root over p
                BN.prototype.redSqrt = function redSqrt() {
                    assert(this.red, 'redSqrt works only with red numbers');
                    this.red._verify1(this);
                    return this.red.sqrt(this);
                };
                BN.prototype.redInvm = function redInvm() {
                    assert(this.red, 'redInvm works only with red numbers');
                    this.red._verify1(this);
                    return this.red.invm(this);
                };
                // Return negative clone of `this` % `red modulo`
                BN.prototype.redNeg = function redNeg() {
                    assert(this.red, 'redNeg works only with red numbers');
                    this.red._verify1(this);
                    return this.red.neg(this);
                };
                BN.prototype.redPow = function redPow(num) {
                    assert(this.red && !num.red, 'redPow(normalNum)');
                    this.red._verify1(this);
                    return this.red.pow(this, num);
                };
                // Prime numbers with efficient reduction
                var primes = {
                    k256: null,
                    p224: null,
                    p192: null,
                    p25519: null
                };
                // Pseudo-Mersenne prime
                function MPrime(name, p) {
                    // P = 2 ^ N - K
                    this.name = name;
                    this.p = new BN(p, 16);
                    this.n = this.p.bitLength();
                    this.k = new BN(1).iushln(this.n).isub(this.p);
                    this.tmp = this._tmp();
                }
                MPrime.prototype._tmp = function _tmp() {
                    var tmp = new BN(null);
                    tmp.words = new Array(Math.ceil(this.n / 13));
                    return tmp;
                };
                MPrime.prototype.ireduce = function ireduce(num) {
                    // Assumes that `num` is less than `P^2`
                    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
                    var r = num;
                    var rlen;
                    do {
                        this.split(r, this.tmp);
                        r = this.imulK(r);
                        r = r.iadd(this.tmp);
                        rlen = r.bitLength();
                    }while (rlen > this.n);
                    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
                    if (cmp === 0) {
                        r.words[0] = 0;
                        r.length = 1;
                    } else if (cmp > 0) r.isub(this.p);
                    else r._strip();
                    return r;
                };
                MPrime.prototype.split = function split(input, out) {
                    input.iushrn(this.n, 0, out);
                };
                MPrime.prototype.imulK = function imulK(num) {
                    return num.imul(this.k);
                };
                function K256() {
                    MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
                }
                inherits(K256, MPrime);
                K256.prototype.split = function split(input, output) {
                    // 256 = 9 * 26 + 22
                    var mask = 0x3fffff;
                    var outLen = Math.min(input.length, 9);
                    for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
                    output.length = outLen;
                    if (input.length <= 9) {
                        input.words[0] = 0;
                        input.length = 1;
                        return;
                    }
                    // Shift by 9 limbs
                    var prev = input.words[9];
                    output.words[output.length++] = prev & mask;
                    for(i = 10; i < input.length; i++){
                        var next = input.words[i] | 0;
                        input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
                        prev = next;
                    }
                    prev >>>= 22;
                    input.words[i - 10] = prev;
                    if (prev === 0 && input.length > 10) input.length -= 10;
                    else input.length -= 9;
                };
                K256.prototype.imulK = function imulK(num) {
                    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
                    num.words[num.length] = 0;
                    num.words[num.length + 1] = 0;
                    num.length += 2;
                    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
                    var lo = 0;
                    for(var i = 0; i < num.length; i++){
                        var w = num.words[i] | 0;
                        lo += w * 0x3d1;
                        num.words[i] = lo & 0x3ffffff;
                        lo = w * 0x40 + (lo / 0x4000000 | 0);
                    }
                    // Fast length reduction
                    if (num.words[num.length - 1] === 0) {
                        num.length--;
                        if (num.words[num.length - 1] === 0) num.length--;
                    }
                    return num;
                };
                function P224() {
                    MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
                }
                inherits(P224, MPrime);
                function P192() {
                    MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
                }
                inherits(P192, MPrime);
                function P25519() {
                    // 2 ^ 255 - 19
                    MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
                }
                inherits(P25519, MPrime);
                P25519.prototype.imulK = function imulK(num) {
                    // K = 0x13
                    var carry = 0;
                    for(var i = 0; i < num.length; i++){
                        var hi = (num.words[i] | 0) * 0x13 + carry;
                        var lo = hi & 0x3ffffff;
                        hi >>>= 26;
                        num.words[i] = lo;
                        carry = hi;
                    }
                    if (carry !== 0) num.words[num.length++] = carry;
                    return num;
                };
                // Exported mostly for testing purposes, use plain name instead
                BN._prime = function prime(name) {
                    // Cached version of prime
                    if (primes[name]) return primes[name];
                    var prime;
                    if (name === 'k256') prime = new K256();
                    else if (name === 'p224') prime = new P224();
                    else if (name === 'p192') prime = new P192();
                    else if (name === 'p25519') prime = new P25519();
                    else throw new Error('Unknown prime ' + name);
                    primes[name] = prime;
                    return prime;
                };
                //
                // Base reduction engine
                //
                function Red(m) {
                    if (typeof m === 'string') {
                        var prime = BN._prime(m);
                        this.m = prime.p;
                        this.prime = prime;
                    } else {
                        assert(m.gtn(1), 'modulus must be greater than 1');
                        this.m = m;
                        this.prime = null;
                    }
                }
                Red.prototype._verify1 = function _verify1(a) {
                    assert(a.negative === 0, 'red works only with positives');
                    assert(a.red, 'red works only with red numbers');
                };
                Red.prototype._verify2 = function _verify2(a, b) {
                    assert((a.negative | b.negative) === 0, 'red works only with positives');
                    assert(a.red && a.red === b.red, 'red works only with red numbers');
                };
                Red.prototype.imod = function imod(a) {
                    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
                    a.umod(this.m)._forceRed(this)._move(a);
                    return a;
                };
                Red.prototype.neg = function neg(a) {
                    if (a.isZero()) return a.clone();
                    return this.m.sub(a)._forceRed(this);
                };
                Red.prototype.add = function add(a, b) {
                    this._verify2(a, b);
                    var res = a.add(b);
                    if (res.cmp(this.m) >= 0) res.isub(this.m);
                    return res._forceRed(this);
                };
                Red.prototype.iadd = function iadd(a, b) {
                    this._verify2(a, b);
                    var res = a.iadd(b);
                    if (res.cmp(this.m) >= 0) res.isub(this.m);
                    return res;
                };
                Red.prototype.sub = function sub(a, b) {
                    this._verify2(a, b);
                    var res = a.sub(b);
                    if (res.cmpn(0) < 0) res.iadd(this.m);
                    return res._forceRed(this);
                };
                Red.prototype.isub = function isub(a, b) {
                    this._verify2(a, b);
                    var res = a.isub(b);
                    if (res.cmpn(0) < 0) res.iadd(this.m);
                    return res;
                };
                Red.prototype.shl = function shl(a, num) {
                    this._verify1(a);
                    return this.imod(a.ushln(num));
                };
                Red.prototype.imul = function imul(a, b) {
                    this._verify2(a, b);
                    return this.imod(a.imul(b));
                };
                Red.prototype.mul = function mul(a, b) {
                    this._verify2(a, b);
                    return this.imod(a.mul(b));
                };
                Red.prototype.isqr = function isqr(a) {
                    return this.imul(a, a.clone());
                };
                Red.prototype.sqr = function sqr(a) {
                    return this.mul(a, a);
                };
                Red.prototype.sqrt = function sqrt(a) {
                    if (a.isZero()) return a.clone();
                    var mod3 = this.m.andln(3);
                    assert(mod3 % 2 === 1);
                    // Fast case
                    if (mod3 === 3) {
                        var pow = this.m.add(new BN(1)).iushrn(2);
                        return this.pow(a, pow);
                    }
                    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
                    //
                    // Find Q and S, that Q * 2 ^ S = (P - 1)
                    var q = this.m.subn(1);
                    var s = 0;
                    while(!q.isZero() && q.andln(1) === 0){
                        s++;
                        q.iushrn(1);
                    }
                    assert(!q.isZero());
                    var one = new BN(1).toRed(this);
                    var nOne = one.redNeg();
                    // Find quadratic non-residue
                    // NOTE: Max is such because of generalized Riemann hypothesis.
                    var lpow = this.m.subn(1).iushrn(1);
                    var z = this.m.bitLength();
                    z = new BN(2 * z * z).toRed(this);
                    while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
                    var c = this.pow(z, q);
                    var r = this.pow(a, q.addn(1).iushrn(1));
                    var t = this.pow(a, q);
                    var m = s;
                    while(t.cmp(one) !== 0){
                        var tmp = t;
                        for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
                        assert(i < m);
                        var b = this.pow(c, new BN(1).iushln(m - i - 1));
                        r = r.redMul(b);
                        c = b.redSqr();
                        t = t.redMul(c);
                        m = i;
                    }
                    return r;
                };
                Red.prototype.invm = function invm(a) {
                    var inv = a._invmp(this.m);
                    if (inv.negative !== 0) {
                        inv.negative = 0;
                        return this.imod(inv).redNeg();
                    } else return this.imod(inv);
                };
                Red.prototype.pow = function pow(a, num) {
                    if (num.isZero()) return new BN(1).toRed(this);
                    if (num.cmpn(1) === 0) return a.clone();
                    var windowSize = 4;
                    var wnd = new Array(1 << windowSize);
                    wnd[0] = new BN(1).toRed(this);
                    wnd[1] = a;
                    for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
                    var res = wnd[0];
                    var current = 0;
                    var currentLen = 0;
                    var start = num.bitLength() % 26;
                    if (start === 0) start = 26;
                    for(i = num.length - 1; i >= 0; i--){
                        var word = num.words[i];
                        for(var j = start - 1; j >= 0; j--){
                            var bit = word >> j & 1;
                            if (res !== wnd[0]) res = this.sqr(res);
                            if (bit === 0 && current === 0) {
                                currentLen = 0;
                                continue;
                            }
                            current <<= 1;
                            current |= bit;
                            currentLen++;
                            if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                            res = this.mul(res, wnd[current]);
                            currentLen = 0;
                            current = 0;
                        }
                        start = 26;
                    }
                    return res;
                };
                Red.prototype.convertTo = function convertTo(num) {
                    var r = num.umod(this.m);
                    return r === num ? r.clone() : r;
                };
                Red.prototype.convertFrom = function convertFrom(num) {
                    var res = num.clone();
                    res.red = null;
                    return res;
                };
                //
                // Montgomery method engine
                //
                BN.mont = function mont(num) {
                    return new Mont(num);
                };
                function Mont(m) {
                    Red.call(this, m);
                    this.shift = this.m.bitLength();
                    if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
                    this.r = new BN(1).iushln(this.shift);
                    this.r2 = this.imod(this.r.sqr());
                    this.rinv = this.r._invmp(this.m);
                    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
                    this.minv = this.minv.umod(this.r);
                    this.minv = this.r.sub(this.minv);
                }
                inherits(Mont, Red);
                Mont.prototype.convertTo = function convertTo(num) {
                    return this.imod(num.ushln(this.shift));
                };
                Mont.prototype.convertFrom = function convertFrom(num) {
                    var r = this.imod(num.mul(this.rinv));
                    r.red = null;
                    return r;
                };
                Mont.prototype.imul = function imul(a, b) {
                    if (a.isZero() || b.isZero()) {
                        a.words[0] = 0;
                        a.length = 1;
                        return a;
                    }
                    var t = a.imul(b);
                    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
                    var u = t.isub(c).iushrn(this.shift);
                    var res = u;
                    if (u.cmp(this.m) >= 0) res = u.isub(this.m);
                    else if (u.cmpn(0) < 0) res = u.iadd(this.m);
                    return res._forceRed(this);
                };
                Mont.prototype.mul = function mul(a, b) {
                    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
                    var t = a.mul(b);
                    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
                    var u = t.isub(c).iushrn(this.shift);
                    var res = u;
                    if (u.cmp(this.m) >= 0) res = u.isub(this.m);
                    else if (u.cmpn(0) < 0) res = u.iadd(this.m);
                    return res._forceRed(this);
                };
                Mont.prototype.invm = function invm(a) {
                    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
                    var res = this.imod(a._invmp(this.m).mul(this.r2));
                    return res._forceRed(this);
                };
            })(typeof module === 'undefined' || module, this);
        },
        {
            "buffer": 182
        }
    ],
    121: [
        function(require1, module, exports) {
            (function(root, factory) {
                if (typeof exports === "object") // CommonJS
                module.exports = exports = factory();
                else if (typeof define === "function" && define.amd) // AMD
                define([], factory);
                else // Global (browser)
                root.CryptoJS = factory();
            })(this, function() {
                /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined1) {
                    /*
	     * Local polyfil of Object.create
	     */ var create = Object.create || function() {
                        function F() {}
                        return function(obj) {
                            var subtype;
                            F.prototype = obj;
                            subtype = new F();
                            F.prototype = null;
                            return subtype;
                        };
                    }();
                    /**
	     * CryptoJS namespace.
	     */ var C = {};
                    /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
                    /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
                        return {
                            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                                // Spawn
                                var subtype = create(this);
                                // Augment
                                if (overrides) subtype.mixIn(overrides);
                                // Create default initializer
                                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                                    subtype.$super.init.apply(this, arguments);
                                };
                                // Initializer's prototype is the subtype object
                                subtype.init.prototype = subtype;
                                // Reference supertype
                                subtype.$super = this;
                                return subtype;
                            },
                            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                                var instance = this.extend();
                                instance.init.apply(instance, arguments);
                                return instance;
                            },
                            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                                for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                                // IE won't copy toString using the loop above
                                if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                            },
                            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                                return this.init.prototype.extend(this);
                            }
                        };
                    }();
                    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
                        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                            words = this.words = words || [];
                            if (sigBytes != undefined1) this.sigBytes = sigBytes;
                            else this.sigBytes = words.length * 4;
                        },
                        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                            return (encoder || Hex).stringify(this);
                        },
                        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                            // Shortcuts
                            var thisWords = this.words;
                            var thatWords = wordArray.words;
                            var thisSigBytes = this.sigBytes;
                            var thatSigBytes = wordArray.sigBytes;
                            // Clamp excess bits
                            this.clamp();
                            // Concat
                            if (thisSigBytes % 4) // Copy one byte at a time
                            for(var i = 0; i < thatSigBytes; i++){
                                var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                            }
                            else // Copy one word at a time
                            for(var i = 0; i < thatSigBytes; i += 4)thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
                            this.sigBytes += thatSigBytes;
                            // Chainable
                            return this;
                        },
                        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                            // Shortcuts
                            var words = this.words;
                            var sigBytes = this.sigBytes;
                            // Clamp
                            words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                            words.length = Math1.ceil(sigBytes / 4);
                        },
                        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                            var clone = Base.clone.call(this);
                            clone.words = this.words.slice(0);
                            return clone;
                        },
                        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                            var words = [];
                            var r = function(m_w) {
                                var m_w = m_w;
                                var m_z = 0x3ade68b1;
                                var mask = 0xffffffff;
                                return function() {
                                    m_z = 0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10) & mask;
                                    m_w = 0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10) & mask;
                                    var result = (m_z << 0x10) + m_w & mask;
                                    result /= 0x100000000;
                                    result += 0.5;
                                    return result * (Math1.random() > .5 ? 1 : -1);
                                };
                            };
                            for(var i = 0, rcache; i < nBytes; i += 4){
                                var _r = r((rcache || Math1.random()) * 0x100000000);
                                rcache = _r() * 0x3ade67b7;
                                words.push(_r() * 0x100000000 | 0);
                            }
                            return new WordArray.init(words, nBytes);
                        }
                    });
                    /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
                    /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
                        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                            // Shortcuts
                            var words = wordArray.words;
                            var sigBytes = wordArray.sigBytes;
                            // Convert
                            var hexChars = [];
                            for(var i = 0; i < sigBytes; i++){
                                var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                hexChars.push((bite >>> 4).toString(16));
                                hexChars.push((bite & 0x0f).toString(16));
                            }
                            return hexChars.join('');
                        },
                        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                            // Shortcut
                            var hexStrLength = hexStr.length;
                            // Convert
                            var words = [];
                            for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                            return new WordArray.init(words, hexStrLength / 2);
                        }
                    };
                    /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
                        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                            // Shortcuts
                            var words = wordArray.words;
                            var sigBytes = wordArray.sigBytes;
                            // Convert
                            var latin1Chars = [];
                            for(var i = 0; i < sigBytes; i++){
                                var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                latin1Chars.push(String.fromCharCode(bite));
                            }
                            return latin1Chars.join('');
                        },
                        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                            // Shortcut
                            var latin1StrLength = latin1Str.length;
                            // Convert
                            var words = [];
                            for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                            return new WordArray.init(words, latin1StrLength);
                        }
                    };
                    /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
                        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                            try {
                                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                            } catch (e) {
                                throw new Error('Malformed UTF-8 data');
                            }
                        },
                        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
                        }
                    };
                    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
                        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                            // Initial values
                            this._data = new WordArray.init();
                            this._nDataBytes = 0;
                        },
                        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                            // Convert string to WordArray, else assume WordArray already
                            if (typeof data == 'string') data = Utf8.parse(data);
                            // Append
                            this._data.concat(data);
                            this._nDataBytes += data.sigBytes;
                        },
                        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                            // Shortcuts
                            var data = this._data;
                            var dataWords = data.words;
                            var dataSigBytes = data.sigBytes;
                            var blockSize = this.blockSize;
                            var blockSizeBytes = blockSize * 4;
                            // Count blocks ready
                            var nBlocksReady = dataSigBytes / blockSizeBytes;
                            if (doFlush) // Round up to include partial blocks
                            nBlocksReady = Math1.ceil(nBlocksReady);
                            else // Round down to include only full blocks,
                            // less the number of blocks that must remain in the buffer
                            nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                            // Count words ready
                            var nWordsReady = nBlocksReady * blockSize;
                            // Count bytes ready
                            var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                            // Process blocks
                            if (nWordsReady) {
                                for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                                this._doProcessBlock(dataWords, offset);
                                // Remove processed words
                                var processedWords = dataWords.splice(0, nWordsReady);
                                data.sigBytes -= nBytesReady;
                            }
                            // Return processed words
                            return new WordArray.init(processedWords, nBytesReady);
                        },
                        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                            var clone = Base.clone.call(this);
                            clone._data = this._data.clone();
                            return clone;
                        },
                        _minBufferSize: 0
                    });
                    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
                        /**
	         * Configuration options.
	         */ cfg: Base.extend(),
                        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                            // Apply config defaults
                            this.cfg = this.cfg.extend(cfg);
                            // Set initial values
                            this.reset();
                        },
                        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                            // Reset data buffer
                            BufferedBlockAlgorithm.reset.call(this);
                            // Perform concrete-hasher logic
                            this._doReset();
                        },
                        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                            // Append
                            this._append(messageUpdate);
                            // Update the hash
                            this._process();
                            // Chainable
                            return this;
                        },
                        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                            // Final message update
                            if (messageUpdate) this._append(messageUpdate);
                            // Perform concrete-hasher logic
                            var hash = this._doFinalize();
                            return hash;
                        },
                        blockSize: 16,
                        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                            return function(message, cfg) {
                                return new hasher.init(cfg).finalize(message);
                            };
                        },
                        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                            return function(message, key) {
                                return new C_algo.HMAC.init(hasher, key).finalize(message);
                            };
                        }
                    });
                    /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
                    return C;
                }(Math);
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var C_enc = C.enc;
                    /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
                        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                            // Shortcuts
                            var words = wordArray.words;
                            var sigBytes = wordArray.sigBytes;
                            var map = this._map;
                            // Clamp excess bits
                            wordArray.clamp();
                            // Convert
                            var base64Chars = [];
                            for(var i = 0; i < sigBytes; i += 3){
                                var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                                var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                                var triplet = byte1 << 16 | byte2 << 8 | byte3;
                                for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                            }
                            // Add padding
                            var paddingChar = map.charAt(64);
                            if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                            return base64Chars.join('');
                        },
                        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                            // Shortcuts
                            var base64StrLength = base64Str.length;
                            var map = this._map;
                            var reverseMap = this._reverseMap;
                            if (!reverseMap) {
                                reverseMap = this._reverseMap = [];
                                for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                            }
                            // Ignore padding
                            var paddingChar = map.charAt(64);
                            if (paddingChar) {
                                var paddingIndex = base64Str.indexOf(paddingChar);
                                if (paddingIndex !== -1) base64StrLength = paddingIndex;
                            }
                            // Convert
                            return parseLoop(base64Str, base64StrLength, reverseMap);
                        },
                        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
                    };
                    function parseLoop(base64Str, base64StrLength, reverseMap) {
                        var words = [];
                        var nBytes = 0;
                        for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                            var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                            var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                            words[nBytes >>> 2] |= (bits1 | bits2) << 24 - nBytes % 4 * 8;
                            nBytes++;
                        }
                        return WordArray.create(words, nBytes);
                    }
                })();
                (function(Math1) {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var Hasher = C_lib.Hasher;
                    var C_algo = C.algo;
                    // Constants table
                    var T = [];
                    // Compute constants
                    (function() {
                        for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
                    })();
                    /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
                        _doReset: function() {
                            this._hash = new WordArray.init([
                                0x67452301,
                                0xefcdab89,
                                0x98badcfe,
                                0x10325476
                            ]);
                        },
                        _doProcessBlock: function(M, offset) {
                            // Swap endian
                            for(var i = 0; i < 16; i++){
                                // Shortcuts
                                var offset_i = offset + i;
                                var M_offset_i = M[offset_i];
                                M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                            }
                            // Shortcuts
                            var H = this._hash.words;
                            var M_offset_0 = M[offset + 0];
                            var M_offset_1 = M[offset + 1];
                            var M_offset_2 = M[offset + 2];
                            var M_offset_3 = M[offset + 3];
                            var M_offset_4 = M[offset + 4];
                            var M_offset_5 = M[offset + 5];
                            var M_offset_6 = M[offset + 6];
                            var M_offset_7 = M[offset + 7];
                            var M_offset_8 = M[offset + 8];
                            var M_offset_9 = M[offset + 9];
                            var M_offset_10 = M[offset + 10];
                            var M_offset_11 = M[offset + 11];
                            var M_offset_12 = M[offset + 12];
                            var M_offset_13 = M[offset + 13];
                            var M_offset_14 = M[offset + 14];
                            var M_offset_15 = M[offset + 15];
                            // Working varialbes
                            var a = H[0];
                            var b = H[1];
                            var c = H[2];
                            var d = H[3];
                            // Computation
                            a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                            d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                            c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                            b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                            a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                            d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                            c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                            b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                            a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                            d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                            a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                            b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                            a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                            d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                            b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                            a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                            d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                            b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                            a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                            d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                            c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                            b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                            a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                            d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                            c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                            b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                            a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                            d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                            a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                            d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                            c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                            a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                            d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                            c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                            b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                            a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                            b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                            a = II(a, b, c, d, M_offset_0, 6, T[48]);
                            d = II(d, a, b, c, M_offset_7, 10, T[49]);
                            c = II(c, d, a, b, M_offset_14, 15, T[50]);
                            b = II(b, c, d, a, M_offset_5, 21, T[51]);
                            a = II(a, b, c, d, M_offset_12, 6, T[52]);
                            d = II(d, a, b, c, M_offset_3, 10, T[53]);
                            c = II(c, d, a, b, M_offset_10, 15, T[54]);
                            b = II(b, c, d, a, M_offset_1, 21, T[55]);
                            a = II(a, b, c, d, M_offset_8, 6, T[56]);
                            d = II(d, a, b, c, M_offset_15, 10, T[57]);
                            c = II(c, d, a, b, M_offset_6, 15, T[58]);
                            b = II(b, c, d, a, M_offset_13, 21, T[59]);
                            a = II(a, b, c, d, M_offset_4, 6, T[60]);
                            d = II(d, a, b, c, M_offset_11, 10, T[61]);
                            c = II(c, d, a, b, M_offset_2, 15, T[62]);
                            b = II(b, c, d, a, M_offset_9, 21, T[63]);
                            // Intermediate hash value
                            H[0] = H[0] + a | 0;
                            H[1] = H[1] + b | 0;
                            H[2] = H[2] + c | 0;
                            H[3] = H[3] + d | 0;
                        },
                        _doFinalize: function() {
                            // Shortcuts
                            var data = this._data;
                            var dataWords = data.words;
                            var nBitsTotal = this._nDataBytes * 8;
                            var nBitsLeft = data.sigBytes * 8;
                            // Add padding
                            dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                            var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                            var nBitsTotalL = nBitsTotal;
                            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                            data.sigBytes = (dataWords.length + 1) * 4;
                            // Hash final blocks
                            this._process();
                            // Shortcuts
                            var hash = this._hash;
                            var H = hash.words;
                            // Swap endian
                            for(var i = 0; i < 4; i++){
                                // Shortcut
                                var H_i = H[i];
                                H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                            }
                            // Return final computed hash
                            return hash;
                        },
                        clone: function() {
                            var clone = Hasher.clone.call(this);
                            clone._hash = this._hash.clone();
                            return clone;
                        }
                    });
                    function FF(a, b, c, d, x, s, t) {
                        var n = a + (b & c | ~b & d) + x + t;
                        return (n << s | n >>> 32 - s) + b;
                    }
                    function GG(a, b, c, d, x, s, t) {
                        var n = a + (b & d | c & ~d) + x + t;
                        return (n << s | n >>> 32 - s) + b;
                    }
                    function HH(a, b, c, d, x, s, t) {
                        var n = a + (b ^ c ^ d) + x + t;
                        return (n << s | n >>> 32 - s) + b;
                    }
                    function II(a, b, c, d, x, s, t) {
                        var n = a + (c ^ (b | ~d)) + x + t;
                        return (n << s | n >>> 32 - s) + b;
                    }
                    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
                    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
                })(Math);
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var Hasher = C_lib.Hasher;
                    var C_algo = C.algo;
                    // Reusable object
                    var W = [];
                    /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
                        _doReset: function() {
                            this._hash = new WordArray.init([
                                0x67452301,
                                0xefcdab89,
                                0x98badcfe,
                                0x10325476,
                                0xc3d2e1f0
                            ]);
                        },
                        _doProcessBlock: function(M, offset) {
                            // Shortcut
                            var H = this._hash.words;
                            // Working variables
                            var a = H[0];
                            var b = H[1];
                            var c = H[2];
                            var d = H[3];
                            var e = H[4];
                            // Computation
                            for(var i = 0; i < 80; i++){
                                if (i < 16) W[i] = M[offset + i] | 0;
                                else {
                                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                                    W[i] = n << 1 | n >>> 31;
                                }
                                var t = (a << 5 | a >>> 27) + e + W[i];
                                if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                                else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                                else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                                else t += (b ^ c ^ d) - 0x359d3e2a;
                                e = d;
                                d = c;
                                c = b << 30 | b >>> 2;
                                b = a;
                                a = t;
                            }
                            // Intermediate hash value
                            H[0] = H[0] + a | 0;
                            H[1] = H[1] + b | 0;
                            H[2] = H[2] + c | 0;
                            H[3] = H[3] + d | 0;
                            H[4] = H[4] + e | 0;
                        },
                        _doFinalize: function() {
                            // Shortcuts
                            var data = this._data;
                            var dataWords = data.words;
                            var nBitsTotal = this._nDataBytes * 8;
                            var nBitsLeft = data.sigBytes * 8;
                            // Add padding
                            dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                            data.sigBytes = dataWords.length * 4;
                            // Hash final blocks
                            this._process();
                            // Return final computed hash
                            return this._hash;
                        },
                        clone: function() {
                            var clone = Hasher.clone.call(this);
                            clone._hash = this._hash.clone();
                            return clone;
                        }
                    });
                    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
                    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
                })();
                (function(Math1) {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var Hasher = C_lib.Hasher;
                    var C_algo = C.algo;
                    // Initialization and round constants tables
                    var H = [];
                    var K = [];
                    // Compute constants
                    (function() {
                        function isPrime(n) {
                            var sqrtN = Math1.sqrt(n);
                            for(var factor = 2; factor <= sqrtN; factor++){
                                if (!(n % factor)) return false;
                            }
                            return true;
                        }
                        function getFractionalBits(n) {
                            return (n - (n | 0)) * 0x100000000 | 0;
                        }
                        var n = 2;
                        var nPrime = 0;
                        while(nPrime < 64){
                            if (isPrime(n)) {
                                if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                                K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                                nPrime++;
                            }
                            n++;
                        }
                    })();
                    // Reusable object
                    var W = [];
                    /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
                        _doReset: function() {
                            this._hash = new WordArray.init(H.slice(0));
                        },
                        _doProcessBlock: function(M, offset) {
                            // Shortcut
                            var H = this._hash.words;
                            // Working variables
                            var a = H[0];
                            var b = H[1];
                            var c = H[2];
                            var d = H[3];
                            var e = H[4];
                            var f = H[5];
                            var g = H[6];
                            var h = H[7];
                            // Computation
                            for(var i = 0; i < 64; i++){
                                if (i < 16) W[i] = M[offset + i] | 0;
                                else {
                                    var gamma0x = W[i - 15];
                                    var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                                    var gamma1x = W[i - 2];
                                    var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                                }
                                var ch = e & f ^ ~e & g;
                                var maj = a & b ^ a & c ^ b & c;
                                var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                                var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                                var t1 = h + sigma1 + ch + K[i] + W[i];
                                var t2 = sigma0 + maj;
                                h = g;
                                g = f;
                                f = e;
                                e = d + t1 | 0;
                                d = c;
                                c = b;
                                b = a;
                                a = t1 + t2 | 0;
                            }
                            // Intermediate hash value
                            H[0] = H[0] + a | 0;
                            H[1] = H[1] + b | 0;
                            H[2] = H[2] + c | 0;
                            H[3] = H[3] + d | 0;
                            H[4] = H[4] + e | 0;
                            H[5] = H[5] + f | 0;
                            H[6] = H[6] + g | 0;
                            H[7] = H[7] + h | 0;
                        },
                        _doFinalize: function() {
                            // Shortcuts
                            var data = this._data;
                            var dataWords = data.words;
                            var nBitsTotal = this._nDataBytes * 8;
                            var nBitsLeft = data.sigBytes * 8;
                            // Add padding
                            dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                            data.sigBytes = dataWords.length * 4;
                            // Hash final blocks
                            this._process();
                            // Return final computed hash
                            return this._hash;
                        },
                        clone: function() {
                            var clone = Hasher.clone.call(this);
                            clone._hash = this._hash.clone();
                            return clone;
                        }
                    });
                    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
                    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
                })(Math);
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var C_enc = C.enc;
                    /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
                        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                            // Shortcuts
                            var words = wordArray.words;
                            var sigBytes = wordArray.sigBytes;
                            // Convert
                            var utf16Chars = [];
                            for(var i = 0; i < sigBytes; i += 2){
                                var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                                utf16Chars.push(String.fromCharCode(codePoint));
                            }
                            return utf16Chars.join('');
                        },
                        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                            // Shortcut
                            var utf16StrLength = utf16Str.length;
                            // Convert
                            var words = [];
                            for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                            return WordArray.create(words, utf16StrLength * 2);
                        }
                    };
                    /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
                        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                            // Shortcuts
                            var words = wordArray.words;
                            var sigBytes = wordArray.sigBytes;
                            // Convert
                            var utf16Chars = [];
                            for(var i = 0; i < sigBytes; i += 2){
                                var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                                utf16Chars.push(String.fromCharCode(codePoint));
                            }
                            return utf16Chars.join('');
                        },
                        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                            // Shortcut
                            var utf16StrLength = utf16Str.length;
                            // Convert
                            var words = [];
                            for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                            return WordArray.create(words, utf16StrLength * 2);
                        }
                    };
                    function swapEndian(word) {
                        return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
                    }
                })();
                (function() {
                    // Check if typed arrays are supported
                    if (typeof ArrayBuffer != 'function') return;
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    // Reference original init
                    var superInit = WordArray.init;
                    // Augment WordArray.init to handle typed arrays
                    var subInit = WordArray.init = function(typedArray) {
                        // Convert buffers to uint8
                        if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
                        // Convert other array views to uint8
                        if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
                        // Handle Uint8Array
                        if (typedArray instanceof Uint8Array) {
                            // Shortcut
                            var typedArrayByteLength = typedArray.byteLength;
                            // Extract bytes
                            var words = [];
                            for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                            // Initialize this word array
                            superInit.call(this, words, typedArrayByteLength);
                        } else // Else call normal init
                        superInit.apply(this, arguments);
                    };
                    subInit.prototype = WordArray;
                })();
                /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var Hasher = C_lib.Hasher;
                    var C_algo = C.algo;
                    // Constants table
                    var _zl = WordArray.create([
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        7,
                        4,
                        13,
                        1,
                        10,
                        6,
                        15,
                        3,
                        12,
                        0,
                        9,
                        5,
                        2,
                        14,
                        11,
                        8,
                        3,
                        10,
                        14,
                        4,
                        9,
                        15,
                        8,
                        1,
                        2,
                        7,
                        0,
                        6,
                        13,
                        11,
                        5,
                        12,
                        1,
                        9,
                        11,
                        10,
                        0,
                        8,
                        12,
                        4,
                        13,
                        3,
                        7,
                        15,
                        14,
                        5,
                        6,
                        2,
                        4,
                        0,
                        5,
                        9,
                        7,
                        12,
                        2,
                        10,
                        14,
                        1,
                        3,
                        8,
                        11,
                        6,
                        15,
                        13
                    ]);
                    var _zr = WordArray.create([
                        5,
                        14,
                        7,
                        0,
                        9,
                        2,
                        11,
                        4,
                        13,
                        6,
                        15,
                        8,
                        1,
                        10,
                        3,
                        12,
                        6,
                        11,
                        3,
                        7,
                        0,
                        13,
                        5,
                        10,
                        14,
                        15,
                        8,
                        12,
                        4,
                        9,
                        1,
                        2,
                        15,
                        5,
                        1,
                        3,
                        7,
                        14,
                        6,
                        9,
                        11,
                        8,
                        12,
                        2,
                        10,
                        0,
                        4,
                        13,
                        8,
                        6,
                        4,
                        1,
                        3,
                        11,
                        15,
                        0,
                        5,
                        12,
                        2,
                        13,
                        9,
                        7,
                        10,
                        14,
                        12,
                        15,
                        10,
                        4,
                        1,
                        5,
                        8,
                        7,
                        6,
                        2,
                        13,
                        14,
                        0,
                        3,
                        9,
                        11
                    ]);
                    var _sl = WordArray.create([
                        11,
                        14,
                        15,
                        12,
                        5,
                        8,
                        7,
                        9,
                        11,
                        13,
                        14,
                        15,
                        6,
                        7,
                        9,
                        8,
                        7,
                        6,
                        8,
                        13,
                        11,
                        9,
                        7,
                        15,
                        7,
                        12,
                        15,
                        9,
                        11,
                        7,
                        13,
                        12,
                        11,
                        13,
                        6,
                        7,
                        14,
                        9,
                        13,
                        15,
                        14,
                        8,
                        13,
                        6,
                        5,
                        12,
                        7,
                        5,
                        11,
                        12,
                        14,
                        15,
                        14,
                        15,
                        9,
                        8,
                        9,
                        14,
                        5,
                        6,
                        8,
                        6,
                        5,
                        12,
                        9,
                        15,
                        5,
                        11,
                        6,
                        8,
                        13,
                        12,
                        5,
                        12,
                        13,
                        14,
                        11,
                        8,
                        5,
                        6
                    ]);
                    var _sr = WordArray.create([
                        8,
                        9,
                        9,
                        11,
                        13,
                        15,
                        15,
                        5,
                        7,
                        7,
                        8,
                        11,
                        14,
                        14,
                        12,
                        6,
                        9,
                        13,
                        15,
                        7,
                        12,
                        8,
                        9,
                        11,
                        7,
                        7,
                        12,
                        7,
                        6,
                        15,
                        13,
                        11,
                        9,
                        7,
                        15,
                        11,
                        8,
                        6,
                        6,
                        14,
                        12,
                        13,
                        5,
                        14,
                        13,
                        13,
                        7,
                        5,
                        15,
                        5,
                        8,
                        11,
                        14,
                        14,
                        6,
                        14,
                        6,
                        9,
                        12,
                        9,
                        12,
                        5,
                        15,
                        8,
                        8,
                        5,
                        12,
                        9,
                        12,
                        5,
                        14,
                        6,
                        8,
                        13,
                        6,
                        5,
                        15,
                        13,
                        11,
                        11
                    ]);
                    var _hl = WordArray.create([
                        0x00000000,
                        0x5A827999,
                        0x6ED9EBA1,
                        0x8F1BBCDC,
                        0xA953FD4E
                    ]);
                    var _hr = WordArray.create([
                        0x50A28BE6,
                        0x5C4DD124,
                        0x6D703EF3,
                        0x7A6D76E9,
                        0x00000000
                    ]);
                    /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
                        _doReset: function() {
                            this._hash = WordArray.create([
                                0x67452301,
                                0xEFCDAB89,
                                0x98BADCFE,
                                0x10325476,
                                0xC3D2E1F0
                            ]);
                        },
                        _doProcessBlock: function(M, offset) {
                            // Swap endian
                            for(var i = 0; i < 16; i++){
                                // Shortcuts
                                var offset_i = offset + i;
                                var M_offset_i = M[offset_i];
                                // Swap
                                M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                            }
                            // Shortcut
                            var H = this._hash.words;
                            var hl = _hl.words;
                            var hr = _hr.words;
                            var zl = _zl.words;
                            var zr = _zr.words;
                            var sl = _sl.words;
                            var sr = _sr.words;
                            // Working variables
                            var al, bl, cl, dl, el;
                            var ar, br, cr, dr, er;
                            ar = al = H[0];
                            br = bl = H[1];
                            cr = cl = H[2];
                            dr = dl = H[3];
                            er = el = H[4];
                            // Computation
                            var t;
                            for(var i = 0; i < 80; i += 1){
                                t = al + M[offset + zl[i]] | 0;
                                if (i < 16) t += f1(bl, cl, dl) + hl[0];
                                else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                                else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                                else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                                else t += f5(bl, cl, dl) + hl[4];
                                t = t | 0;
                                t = rotl(t, sl[i]);
                                t = t + el | 0;
                                al = el;
                                el = dl;
                                dl = rotl(cl, 10);
                                cl = bl;
                                bl = t;
                                t = ar + M[offset + zr[i]] | 0;
                                if (i < 16) t += f5(br, cr, dr) + hr[0];
                                else if (i < 32) t += f4(br, cr, dr) + hr[1];
                                else if (i < 48) t += f3(br, cr, dr) + hr[2];
                                else if (i < 64) t += f2(br, cr, dr) + hr[3];
                                else t += f1(br, cr, dr) + hr[4];
                                t = t | 0;
                                t = rotl(t, sr[i]);
                                t = t + er | 0;
                                ar = er;
                                er = dr;
                                dr = rotl(cr, 10);
                                cr = br;
                                br = t;
                            }
                            // Intermediate hash value
                            t = H[1] + cl + dr | 0;
                            H[1] = H[2] + dl + er | 0;
                            H[2] = H[3] + el + ar | 0;
                            H[3] = H[4] + al + br | 0;
                            H[4] = H[0] + bl + cr | 0;
                            H[0] = t;
                        },
                        _doFinalize: function() {
                            // Shortcuts
                            var data = this._data;
                            var dataWords = data.words;
                            var nBitsTotal = this._nDataBytes * 8;
                            var nBitsLeft = data.sigBytes * 8;
                            // Add padding
                            dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                            data.sigBytes = (dataWords.length + 1) * 4;
                            // Hash final blocks
                            this._process();
                            // Shortcuts
                            var hash = this._hash;
                            var H = hash.words;
                            // Swap endian
                            for(var i = 0; i < 5; i++){
                                // Shortcut
                                var H_i = H[i];
                                // Swap
                                H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                            }
                            // Return final computed hash
                            return hash;
                        },
                        clone: function() {
                            var clone = Hasher.clone.call(this);
                            clone._hash = this._hash.clone();
                            return clone;
                        }
                    });
                    function f1(x, y, z) {
                        return x ^ y ^ z;
                    }
                    function f2(x, y, z) {
                        return x & y | ~x & z;
                    }
                    function f3(x, y, z) {
                        return (x | ~y) ^ z;
                    }
                    function f4(x, y, z) {
                        return x & z | y & ~z;
                    }
                    function f5(x, y, z) {
                        return x ^ (y | ~z);
                    }
                    function rotl(x, n) {
                        return x << n | x >>> 32 - n;
                    }
                    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
                    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
                })(Math);
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var Base = C_lib.Base;
                    var C_enc = C.enc;
                    var Utf8 = C_enc.Utf8;
                    var C_algo = C.algo;
                    /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
                        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                            // Init hasher
                            hasher = this._hasher = new hasher.init();
                            // Convert string to WordArray, else assume WordArray already
                            if (typeof key == 'string') key = Utf8.parse(key);
                            // Shortcuts
                            var hasherBlockSize = hasher.blockSize;
                            var hasherBlockSizeBytes = hasherBlockSize * 4;
                            // Allow arbitrary length keys
                            if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                            // Clamp excess bits
                            key.clamp();
                            // Clone key for inner and outer pads
                            var oKey = this._oKey = key.clone();
                            var iKey = this._iKey = key.clone();
                            // Shortcuts
                            var oKeyWords = oKey.words;
                            var iKeyWords = iKey.words;
                            // XOR keys with pad constants
                            for(var i = 0; i < hasherBlockSize; i++){
                                oKeyWords[i] ^= 0x5c5c5c5c;
                                iKeyWords[i] ^= 0x36363636;
                            }
                            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                            // Set initial values
                            this.reset();
                        },
                        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                            // Shortcut
                            var hasher = this._hasher;
                            // Reset
                            hasher.reset();
                            hasher.update(this._iKey);
                        },
                        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                            this._hasher.update(messageUpdate);
                            // Chainable
                            return this;
                        },
                        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                            // Shortcut
                            var hasher = this._hasher;
                            // Compute HMAC
                            var innerHash = hasher.finalize(messageUpdate);
                            hasher.reset();
                            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                            return hmac;
                        }
                    });
                })();
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var Base = C_lib.Base;
                    var WordArray = C_lib.WordArray;
                    var C_algo = C.algo;
                    var SHA1 = C_algo.SHA1;
                    var HMAC = C_algo.HMAC;
                    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
                        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                            keySize: 4,
                            hasher: SHA1,
                            iterations: 1
                        }),
                        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                            this.cfg = this.cfg.extend(cfg);
                        },
                        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                            // Shortcut
                            var cfg = this.cfg;
                            // Init HMAC
                            var hmac = HMAC.create(cfg.hasher, password);
                            // Initial values
                            var derivedKey = WordArray.create();
                            var blockIndex = WordArray.create([
                                0x00000001
                            ]);
                            // Shortcuts
                            var derivedKeyWords = derivedKey.words;
                            var blockIndexWords = blockIndex.words;
                            var keySize = cfg.keySize;
                            var iterations = cfg.iterations;
                            // Generate key
                            while(derivedKeyWords.length < keySize){
                                var block = hmac.update(salt).finalize(blockIndex);
                                hmac.reset();
                                // Shortcuts
                                var blockWords = block.words;
                                var blockWordsLength = blockWords.length;
                                // Iterations
                                var intermediate = block;
                                for(var i = 1; i < iterations; i++){
                                    intermediate = hmac.finalize(intermediate);
                                    hmac.reset();
                                    // Shortcut
                                    var intermediateWords = intermediate.words;
                                    // XOR intermediate with block
                                    for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                                }
                                derivedKey.concat(block);
                                blockIndexWords[0]++;
                            }
                            derivedKey.sigBytes = keySize * 4;
                            return derivedKey;
                        }
                    });
                    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
                        return PBKDF2.create(cfg).compute(password, salt);
                    };
                })();
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var Base = C_lib.Base;
                    var WordArray = C_lib.WordArray;
                    var C_algo = C.algo;
                    var MD5 = C_algo.MD5;
                    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
                        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                            keySize: 4,
                            hasher: MD5,
                            iterations: 1
                        }),
                        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                            this.cfg = this.cfg.extend(cfg);
                        },
                        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                            // Shortcut
                            var cfg = this.cfg;
                            // Init hasher
                            var hasher = cfg.hasher.create();
                            // Initial values
                            var derivedKey = WordArray.create();
                            // Shortcuts
                            var derivedKeyWords = derivedKey.words;
                            var keySize = cfg.keySize;
                            var iterations = cfg.iterations;
                            // Generate key
                            while(derivedKeyWords.length < keySize){
                                if (block) hasher.update(block);
                                var block = hasher.update(password).finalize(salt);
                                hasher.reset();
                                // Iterations
                                for(var i = 1; i < iterations; i++){
                                    block = hasher.finalize(block);
                                    hasher.reset();
                                }
                                derivedKey.concat(block);
                            }
                            derivedKey.sigBytes = keySize * 4;
                            return derivedKey;
                        }
                    });
                    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
                        return EvpKDF.create(cfg).compute(password, salt);
                    };
                })();
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var C_algo = C.algo;
                    var SHA256 = C_algo.SHA256;
                    /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
                        _doReset: function() {
                            this._hash = new WordArray.init([
                                0xc1059ed8,
                                0x367cd507,
                                0x3070dd17,
                                0xf70e5939,
                                0xffc00b31,
                                0x68581511,
                                0x64f98fa7,
                                0xbefa4fa4
                            ]);
                        },
                        _doFinalize: function() {
                            var hash = SHA256._doFinalize.call(this);
                            hash.sigBytes -= 4;
                            return hash;
                        }
                    });
                    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
                    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
                })();
                (function(undefined1) {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var Base = C_lib.Base;
                    var X32WordArray = C_lib.WordArray;
                    /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
                    /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
                        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                            this.high = high;
                            this.low = low;
                        }
                    });
                    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
                        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                            words = this.words = words || [];
                            if (sigBytes != undefined1) this.sigBytes = sigBytes;
                            else this.sigBytes = words.length * 8;
                        },
                        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                            // Shortcuts
                            var x64Words = this.words;
                            var x64WordsLength = x64Words.length;
                            // Convert
                            var x32Words = [];
                            for(var i = 0; i < x64WordsLength; i++){
                                var x64Word = x64Words[i];
                                x32Words.push(x64Word.high);
                                x32Words.push(x64Word.low);
                            }
                            return X32WordArray.create(x32Words, this.sigBytes);
                        },
                        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                            var clone = Base.clone.call(this);
                            // Clone "words" array
                            var words = clone.words = this.words.slice(0);
                            // Clone each X64Word object
                            var wordsLength = words.length;
                            for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                            return clone;
                        }
                    });
                })();
                (function(Math1) {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var Hasher = C_lib.Hasher;
                    var C_x64 = C.x64;
                    var X64Word = C_x64.Word;
                    var C_algo = C.algo;
                    // Constants tables
                    var RHO_OFFSETS = [];
                    var PI_INDEXES = [];
                    var ROUND_CONSTANTS = [];
                    // Compute Constants
                    (function() {
                        // Compute rho offset constants
                        var x = 1, y = 0;
                        for(var t = 0; t < 24; t++){
                            RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                            var newX = y % 5;
                            var newY = (2 * x + 3 * y) % 5;
                            x = newX;
                            y = newY;
                        }
                        // Compute pi index constants
                        for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
                        // Compute round constants
                        var LFSR = 0x01;
                        for(var i = 0; i < 24; i++){
                            var roundConstantMsw = 0;
                            var roundConstantLsw = 0;
                            for(var j = 0; j < 7; j++){
                                if (LFSR & 0x01) {
                                    var bitPosition = (1 << j) - 1;
                                    if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                                    else roundConstantMsw ^= 1 << bitPosition - 32;
                                }
                                // Compute next LFSR
                                if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                                LFSR = LFSR << 1 ^ 0x71;
                                else LFSR <<= 1;
                            }
                            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
                        }
                    })();
                    // Reusable objects for temporary values
                    var T = [];
                    (function() {
                        for(var i = 0; i < 25; i++)T[i] = X64Word.create();
                    })();
                    /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
                        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                            outputLength: 512
                        }),
                        _doReset: function() {
                            var state = this._state = [];
                            for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
                        },
                        _doProcessBlock: function(M, offset) {
                            // Shortcuts
                            var state = this._state;
                            var nBlockSizeLanes = this.blockSize / 2;
                            // Absorb
                            for(var i = 0; i < nBlockSizeLanes; i++){
                                // Shortcuts
                                var M2i = M[offset + 2 * i];
                                var M2i1 = M[offset + 2 * i + 1];
                                // Swap endian
                                M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                                M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                                // Absorb message into state
                                var lane = state[i];
                                lane.high ^= M2i1;
                                lane.low ^= M2i;
                            }
                            // Rounds
                            for(var round = 0; round < 24; round++){
                                // Theta
                                for(var x = 0; x < 5; x++){
                                    // Mix column lanes
                                    var tMsw = 0, tLsw = 0;
                                    for(var y = 0; y < 5; y++){
                                        var lane = state[x + 5 * y];
                                        tMsw ^= lane.high;
                                        tLsw ^= lane.low;
                                    }
                                    // Temporary values
                                    var Tx = T[x];
                                    Tx.high = tMsw;
                                    Tx.low = tLsw;
                                }
                                for(var x = 0; x < 5; x++){
                                    // Shortcuts
                                    var Tx4 = T[(x + 4) % 5];
                                    var Tx1 = T[(x + 1) % 5];
                                    var Tx1Msw = Tx1.high;
                                    var Tx1Lsw = Tx1.low;
                                    // Mix surrounding columns
                                    var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                                    var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                                    for(var y = 0; y < 5; y++){
                                        var lane = state[x + 5 * y];
                                        lane.high ^= tMsw;
                                        lane.low ^= tLsw;
                                    }
                                }
                                // Rho Pi
                                for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                                    // Shortcuts
                                    var lane = state[laneIndex];
                                    var laneMsw = lane.high;
                                    var laneLsw = lane.low;
                                    var rhoOffset = RHO_OFFSETS[laneIndex];
                                    // Rotate lanes
                                    if (rhoOffset < 32) {
                                        var tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                                        var tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                                    } else /* if (rhoOffset >= 32) */ {
                                        var tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                                        var tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                                    }
                                    // Transpose lanes
                                    var TPiLane = T[PI_INDEXES[laneIndex]];
                                    TPiLane.high = tMsw;
                                    TPiLane.low = tLsw;
                                }
                                // Rho pi at x = y = 0
                                var T0 = T[0];
                                var state0 = state[0];
                                T0.high = state0.high;
                                T0.low = state0.low;
                                // Chi
                                for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                                    // Shortcuts
                                    var laneIndex = x + 5 * y;
                                    var lane = state[laneIndex];
                                    var TLane = T[laneIndex];
                                    var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                                    var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                                    // Mix rows
                                    lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                                    lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                                }
                                // Iota
                                var lane = state[0];
                                var roundConstant = ROUND_CONSTANTS[round];
                                lane.high ^= roundConstant.high;
                                lane.low ^= roundConstant.low;
                            }
                        },
                        _doFinalize: function() {
                            // Shortcuts
                            var data = this._data;
                            var dataWords = data.words;
                            var nBitsTotal = this._nDataBytes * 8;
                            var nBitsLeft = data.sigBytes * 8;
                            var blockSizeBits = this.blockSize * 32;
                            // Add padding
                            dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                            dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                            data.sigBytes = dataWords.length * 4;
                            // Hash final blocks
                            this._process();
                            // Shortcuts
                            var state = this._state;
                            var outputLengthBytes = this.cfg.outputLength / 8;
                            var outputLengthLanes = outputLengthBytes / 8;
                            // Squeeze
                            var hashWords = [];
                            for(var i = 0; i < outputLengthLanes; i++){
                                // Shortcuts
                                var lane = state[i];
                                var laneMsw = lane.high;
                                var laneLsw = lane.low;
                                // Swap endian
                                laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                                laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                                // Squeeze state to retrieve hash
                                hashWords.push(laneLsw);
                                hashWords.push(laneMsw);
                            }
                            // Return final computed hash
                            return new WordArray.init(hashWords, outputLengthBytes);
                        },
                        clone: function() {
                            var clone = Hasher.clone.call(this);
                            var state = clone._state = this._state.slice(0);
                            for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                            return clone;
                        }
                    });
                    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
                    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
                })(Math);
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var Hasher = C_lib.Hasher;
                    var C_x64 = C.x64;
                    var X64Word = C_x64.Word;
                    var X64WordArray = C_x64.WordArray;
                    var C_algo = C.algo;
                    function X64Word_create() {
                        return X64Word.create.apply(X64Word, arguments);
                    }
                    // Constants
                    var K = [
                        X64Word_create(0x428a2f98, 0xd728ae22),
                        X64Word_create(0x71374491, 0x23ef65cd),
                        X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
                        X64Word_create(0xe9b5dba5, 0x8189dbbc),
                        X64Word_create(0x3956c25b, 0xf348b538),
                        X64Word_create(0x59f111f1, 0xb605d019),
                        X64Word_create(0x923f82a4, 0xaf194f9b),
                        X64Word_create(0xab1c5ed5, 0xda6d8118),
                        X64Word_create(0xd807aa98, 0xa3030242),
                        X64Word_create(0x12835b01, 0x45706fbe),
                        X64Word_create(0x243185be, 0x4ee4b28c),
                        X64Word_create(0x550c7dc3, 0xd5ffb4e2),
                        X64Word_create(0x72be5d74, 0xf27b896f),
                        X64Word_create(0x80deb1fe, 0x3b1696b1),
                        X64Word_create(0x9bdc06a7, 0x25c71235),
                        X64Word_create(0xc19bf174, 0xcf692694),
                        X64Word_create(0xe49b69c1, 0x9ef14ad2),
                        X64Word_create(0xefbe4786, 0x384f25e3),
                        X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
                        X64Word_create(0x240ca1cc, 0x77ac9c65),
                        X64Word_create(0x2de92c6f, 0x592b0275),
                        X64Word_create(0x4a7484aa, 0x6ea6e483),
                        X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
                        X64Word_create(0x76f988da, 0x831153b5),
                        X64Word_create(0x983e5152, 0xee66dfab),
                        X64Word_create(0xa831c66d, 0x2db43210),
                        X64Word_create(0xb00327c8, 0x98fb213f),
                        X64Word_create(0xbf597fc7, 0xbeef0ee4),
                        X64Word_create(0xc6e00bf3, 0x3da88fc2),
                        X64Word_create(0xd5a79147, 0x930aa725),
                        X64Word_create(0x06ca6351, 0xe003826f),
                        X64Word_create(0x14292967, 0x0a0e6e70),
                        X64Word_create(0x27b70a85, 0x46d22ffc),
                        X64Word_create(0x2e1b2138, 0x5c26c926),
                        X64Word_create(0x4d2c6dfc, 0x5ac42aed),
                        X64Word_create(0x53380d13, 0x9d95b3df),
                        X64Word_create(0x650a7354, 0x8baf63de),
                        X64Word_create(0x766a0abb, 0x3c77b2a8),
                        X64Word_create(0x81c2c92e, 0x47edaee6),
                        X64Word_create(0x92722c85, 0x1482353b),
                        X64Word_create(0xa2bfe8a1, 0x4cf10364),
                        X64Word_create(0xa81a664b, 0xbc423001),
                        X64Word_create(0xc24b8b70, 0xd0f89791),
                        X64Word_create(0xc76c51a3, 0x0654be30),
                        X64Word_create(0xd192e819, 0xd6ef5218),
                        X64Word_create(0xd6990624, 0x5565a910),
                        X64Word_create(0xf40e3585, 0x5771202a),
                        X64Word_create(0x106aa070, 0x32bbd1b8),
                        X64Word_create(0x19a4c116, 0xb8d2d0c8),
                        X64Word_create(0x1e376c08, 0x5141ab53),
                        X64Word_create(0x2748774c, 0xdf8eeb99),
                        X64Word_create(0x34b0bcb5, 0xe19b48a8),
                        X64Word_create(0x391c0cb3, 0xc5c95a63),
                        X64Word_create(0x4ed8aa4a, 0xe3418acb),
                        X64Word_create(0x5b9cca4f, 0x7763e373),
                        X64Word_create(0x682e6ff3, 0xd6b2b8a3),
                        X64Word_create(0x748f82ee, 0x5defb2fc),
                        X64Word_create(0x78a5636f, 0x43172f60),
                        X64Word_create(0x84c87814, 0xa1f0ab72),
                        X64Word_create(0x8cc70208, 0x1a6439ec),
                        X64Word_create(0x90befffa, 0x23631e28),
                        X64Word_create(0xa4506ceb, 0xde82bde9),
                        X64Word_create(0xbef9a3f7, 0xb2c67915),
                        X64Word_create(0xc67178f2, 0xe372532b),
                        X64Word_create(0xca273ece, 0xea26619c),
                        X64Word_create(0xd186b8c7, 0x21c0c207),
                        X64Word_create(0xeada7dd6, 0xcde0eb1e),
                        X64Word_create(0xf57d4f7f, 0xee6ed178),
                        X64Word_create(0x06f067aa, 0x72176fba),
                        X64Word_create(0x0a637dc5, 0xa2c898a6),
                        X64Word_create(0x113f9804, 0xbef90dae),
                        X64Word_create(0x1b710b35, 0x131c471b),
                        X64Word_create(0x28db77f5, 0x23047d84),
                        X64Word_create(0x32caab7b, 0x40c72493),
                        X64Word_create(0x3c9ebe0a, 0x15c9bebc),
                        X64Word_create(0x431d67c4, 0x9c100d4c),
                        X64Word_create(0x4cc5d4be, 0xcb3e42b6),
                        X64Word_create(0x597f299c, 0xfc657e2a),
                        X64Word_create(0x5fcb6fab, 0x3ad6faec),
                        X64Word_create(0x6c44198c, 0x4a475817)
                    ];
                    // Reusable objects
                    var W = [];
                    (function() {
                        for(var i = 0; i < 80; i++)W[i] = X64Word_create();
                    })();
                    /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
                        _doReset: function() {
                            this._hash = new X64WordArray.init([
                                new X64Word.init(0x6a09e667, 0xf3bcc908),
                                new X64Word.init(0xbb67ae85, 0x84caa73b),
                                new X64Word.init(0x3c6ef372, 0xfe94f82b),
                                new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                                new X64Word.init(0x510e527f, 0xade682d1),
                                new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                                new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                                new X64Word.init(0x5be0cd19, 0x137e2179)
                            ]);
                        },
                        _doProcessBlock: function(M, offset) {
                            // Shortcuts
                            var H = this._hash.words;
                            var H0 = H[0];
                            var H1 = H[1];
                            var H2 = H[2];
                            var H3 = H[3];
                            var H4 = H[4];
                            var H5 = H[5];
                            var H6 = H[6];
                            var H7 = H[7];
                            var H0h = H0.high;
                            var H0l = H0.low;
                            var H1h = H1.high;
                            var H1l = H1.low;
                            var H2h = H2.high;
                            var H2l = H2.low;
                            var H3h = H3.high;
                            var H3l = H3.low;
                            var H4h = H4.high;
                            var H4l = H4.low;
                            var H5h = H5.high;
                            var H5l = H5.low;
                            var H6h = H6.high;
                            var H6l = H6.low;
                            var H7h = H7.high;
                            var H7l = H7.low;
                            // Working variables
                            var ah = H0h;
                            var al = H0l;
                            var bh = H1h;
                            var bl = H1l;
                            var ch = H2h;
                            var cl = H2l;
                            var dh = H3h;
                            var dl = H3l;
                            var eh = H4h;
                            var el = H4l;
                            var fh = H5h;
                            var fl = H5l;
                            var gh = H6h;
                            var gl = H6l;
                            var hh = H7h;
                            var hl = H7l;
                            // Rounds
                            for(var i = 0; i < 80; i++){
                                // Shortcut
                                var Wi = W[i];
                                // Extend message
                                if (i < 16) {
                                    var Wih = Wi.high = M[offset + i * 2] | 0;
                                    var Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                                } else {
                                    // Gamma0
                                    var gamma0x = W[i - 15];
                                    var gamma0xh = gamma0x.high;
                                    var gamma0xl = gamma0x.low;
                                    var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                                    var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                                    // Gamma1
                                    var gamma1x = W[i - 2];
                                    var gamma1xh = gamma1x.high;
                                    var gamma1xl = gamma1x.low;
                                    var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                                    var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                                    var Wi7 = W[i - 7];
                                    var Wi7h = Wi7.high;
                                    var Wi7l = Wi7.low;
                                    var Wi16 = W[i - 16];
                                    var Wi16h = Wi16.high;
                                    var Wi16l = Wi16.low;
                                    var Wil = gamma0l + Wi7l;
                                    var Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                                    var Wil = Wil + gamma1l;
                                    var Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                                    var Wil = Wil + Wi16l;
                                    var Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                                    Wi.high = Wih;
                                    Wi.low = Wil;
                                }
                                var chh = eh & fh ^ ~eh & gh;
                                var chl = el & fl ^ ~el & gl;
                                var majh = ah & bh ^ ah & ch ^ bh & ch;
                                var majl = al & bl ^ al & cl ^ bl & cl;
                                var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                                var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                                var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                                var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                                // t1 = h + sigma1 + ch + K[i] + W[i]
                                var Ki = K[i];
                                var Kih = Ki.high;
                                var Kil = Ki.low;
                                var t1l = hl + sigma1l;
                                var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                                var t1l = t1l + chl;
                                var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                                var t1l = t1l + Kil;
                                var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                                var t1l = t1l + Wil;
                                var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                                // t2 = sigma0 + maj
                                var t2l = sigma0l + majl;
                                var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                                // Update working variables
                                hh = gh;
                                hl = gl;
                                gh = fh;
                                gl = fl;
                                fh = eh;
                                fl = el;
                                el = dl + t1l | 0;
                                eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                                dh = ch;
                                dl = cl;
                                ch = bh;
                                cl = bl;
                                bh = ah;
                                bl = al;
                                al = t1l + t2l | 0;
                                ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                            }
                            // Intermediate hash value
                            H0l = H0.low = H0l + al;
                            H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                            H1l = H1.low = H1l + bl;
                            H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                            H2l = H2.low = H2l + cl;
                            H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                            H3l = H3.low = H3l + dl;
                            H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                            H4l = H4.low = H4l + el;
                            H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                            H5l = H5.low = H5l + fl;
                            H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                            H6l = H6.low = H6l + gl;
                            H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                            H7l = H7.low = H7l + hl;
                            H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
                        },
                        _doFinalize: function() {
                            // Shortcuts
                            var data = this._data;
                            var dataWords = data.words;
                            var nBitsTotal = this._nDataBytes * 8;
                            var nBitsLeft = data.sigBytes * 8;
                            // Add padding
                            dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                            dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                            dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                            data.sigBytes = dataWords.length * 4;
                            // Hash final blocks
                            this._process();
                            // Convert hash to 32-bit word array before returning
                            var hash = this._hash.toX32();
                            // Return final computed hash
                            return hash;
                        },
                        clone: function() {
                            var clone = Hasher.clone.call(this);
                            clone._hash = this._hash.clone();
                            return clone;
                        },
                        blockSize: 32
                    });
                    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
                    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
                })();
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_x64 = C.x64;
                    var X64Word = C_x64.Word;
                    var X64WordArray = C_x64.WordArray;
                    var C_algo = C.algo;
                    var SHA512 = C_algo.SHA512;
                    /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
                        _doReset: function() {
                            this._hash = new X64WordArray.init([
                                new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                                new X64Word.init(0x629a292a, 0x367cd507),
                                new X64Word.init(0x9159015a, 0x3070dd17),
                                new X64Word.init(0x152fecd8, 0xf70e5939),
                                new X64Word.init(0x67332667, 0xffc00b31),
                                new X64Word.init(0x8eb44a87, 0x68581511),
                                new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                                new X64Word.init(0x47b5481d, 0xbefa4fa4)
                            ]);
                        },
                        _doFinalize: function() {
                            var hash = SHA512._doFinalize.call(this);
                            hash.sigBytes -= 16;
                            return hash;
                        }
                    });
                    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
                    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
                })();
                /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined1) {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var Base = C_lib.Base;
                    var WordArray = C_lib.WordArray;
                    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
                    var C_enc = C.enc;
                    var Utf8 = C_enc.Utf8;
                    var Base64 = C_enc.Base64;
                    var C_algo = C.algo;
                    var EvpKDF = C_algo.EvpKDF;
                    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
                        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
                        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                            return this.create(this._ENC_XFORM_MODE, key, cfg);
                        },
                        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                            return this.create(this._DEC_XFORM_MODE, key, cfg);
                        },
                        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                            // Apply config defaults
                            this.cfg = this.cfg.extend(cfg);
                            // Store transform mode and key
                            this._xformMode = xformMode;
                            this._key = key;
                            // Set initial values
                            this.reset();
                        },
                        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                            // Reset data buffer
                            BufferedBlockAlgorithm.reset.call(this);
                            // Perform concrete-cipher logic
                            this._doReset();
                        },
                        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                            // Append
                            this._append(dataUpdate);
                            // Process available blocks
                            return this._process();
                        },
                        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                            // Final data update
                            if (dataUpdate) this._append(dataUpdate);
                            // Perform concrete-cipher logic
                            var finalProcessedData = this._doFinalize();
                            return finalProcessedData;
                        },
                        keySize: 4,
                        ivSize: 4,
                        _ENC_XFORM_MODE: 1,
                        _DEC_XFORM_MODE: 2,
                        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                            function selectCipherStrategy(key) {
                                if (typeof key == 'string') return PasswordBasedCipher;
                                else return SerializableCipher;
                            }
                            return function(cipher) {
                                return {
                                    encrypt: function(message, key, cfg) {
                                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                                    },
                                    decrypt: function(ciphertext, key, cfg) {
                                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                                    }
                                };
                            };
                        }()
                    });
                    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
                        _doFinalize: function() {
                            // Process partial blocks
                            var finalProcessedBlocks = this._process(true);
                            return finalProcessedBlocks;
                        },
                        blockSize: 1
                    });
                    /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
                    /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
                        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                            return this.Encryptor.create(cipher, iv);
                        },
                        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                            return this.Decryptor.create(cipher, iv);
                        },
                        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                            this._cipher = cipher;
                            this._iv = iv;
                        }
                    });
                    /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
                        /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
                        /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                // XOR and encrypt
                                xorBlock.call(this, words, offset, blockSize);
                                cipher.encryptBlock(words, offset);
                                // Remember this block to use with next block
                                this._prevBlock = words.slice(offset, offset + blockSize);
                            }
                        });
                        /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                // Remember this block to use with next block
                                var thisBlock = words.slice(offset, offset + blockSize);
                                // Decrypt and XOR
                                cipher.decryptBlock(words, offset);
                                xorBlock.call(this, words, offset, blockSize);
                                // This block becomes the previous block
                                this._prevBlock = thisBlock;
                            }
                        });
                        function xorBlock(words, offset, blockSize) {
                            // Shortcut
                            var iv = this._iv;
                            // Choose mixing block
                            if (iv) {
                                var block = iv;
                                // Remove IV for subsequent blocks
                                this._iv = undefined1;
                            } else var block = this._prevBlock;
                            // XOR blocks
                            for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
                        }
                        return CBC;
                    }();
                    /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
                    /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
                        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                            // Shortcut
                            var blockSizeBytes = blockSize * 4;
                            // Count padding bytes
                            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                            // Create padding word
                            var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                            // Create padding
                            var paddingWords = [];
                            for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                            var padding = WordArray.create(paddingWords, nPaddingBytes);
                            // Add padding
                            data.concat(padding);
                        },
                        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                            // Get number of padding bytes from last byte
                            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                            // Remove padding
                            data.sigBytes -= nPaddingBytes;
                        }
                    };
                    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
                        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                            mode: CBC,
                            padding: Pkcs7
                        }),
                        reset: function() {
                            // Reset cipher
                            Cipher.reset.call(this);
                            // Shortcuts
                            var cfg = this.cfg;
                            var iv = cfg.iv;
                            var mode = cfg.mode;
                            // Reset block mode
                            if (this._xformMode == this._ENC_XFORM_MODE) var modeCreator = mode.createEncryptor;
                            else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                                var modeCreator = mode.createDecryptor;
                                // Keep at least one block in the buffer for unpadding
                                this._minBufferSize = 1;
                            }
                            if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                            else {
                                this._mode = modeCreator.call(mode, this, iv && iv.words);
                                this._mode.__creator = modeCreator;
                            }
                        },
                        _doProcessBlock: function(words, offset) {
                            this._mode.processBlock(words, offset);
                        },
                        _doFinalize: function() {
                            // Shortcut
                            var padding = this.cfg.padding;
                            // Finalize
                            if (this._xformMode == this._ENC_XFORM_MODE) {
                                // Pad data
                                padding.pad(this._data, this.blockSize);
                                // Process final blocks
                                var finalProcessedBlocks = this._process(true);
                            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                                // Process final blocks
                                var finalProcessedBlocks = this._process(true);
                                // Unpad data
                                padding.unpad(finalProcessedBlocks);
                            }
                            return finalProcessedBlocks;
                        },
                        blockSize: 4
                    });
                    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
                        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                            this.mixIn(cipherParams);
                        },
                        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                            return (formatter || this.formatter).stringify(this);
                        }
                    });
                    /**
	     * Format namespace.
	     */ var C_format = C.format = {};
                    /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
                        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                            // Shortcuts
                            var ciphertext = cipherParams.ciphertext;
                            var salt = cipherParams.salt;
                            // Format
                            if (salt) var wordArray = WordArray.create([
                                0x53616c74,
                                0x65645f5f
                            ]).concat(salt).concat(ciphertext);
                            else var wordArray = ciphertext;
                            return wordArray.toString(Base64);
                        },
                        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                            // Parse base64
                            var ciphertext = Base64.parse(openSSLStr);
                            // Shortcut
                            var ciphertextWords = ciphertext.words;
                            // Test for salt
                            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                                // Extract salt
                                var salt = WordArray.create(ciphertextWords.slice(2, 4));
                                // Remove salt from ciphertext
                                ciphertextWords.splice(0, 4);
                                ciphertext.sigBytes -= 16;
                            }
                            return CipherParams.create({
                                ciphertext: ciphertext,
                                salt: salt
                            });
                        }
                    };
                    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
                        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                            format: OpenSSLFormatter
                        }),
                        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                            // Apply config defaults
                            cfg = this.cfg.extend(cfg);
                            // Encrypt
                            var encryptor = cipher.createEncryptor(key, cfg);
                            var ciphertext = encryptor.finalize(message);
                            // Shortcut
                            var cipherCfg = encryptor.cfg;
                            // Create and return serializable cipher params
                            return CipherParams.create({
                                ciphertext: ciphertext,
                                key: key,
                                iv: cipherCfg.iv,
                                algorithm: cipher,
                                mode: cipherCfg.mode,
                                padding: cipherCfg.padding,
                                blockSize: cipher.blockSize,
                                formatter: cfg.format
                            });
                        },
                        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                            // Apply config defaults
                            cfg = this.cfg.extend(cfg);
                            // Convert string to CipherParams
                            ciphertext = this._parse(ciphertext, cfg.format);
                            // Decrypt
                            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                            return plaintext;
                        },
                        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                            if (typeof ciphertext == 'string') return format.parse(ciphertext, this);
                            else return ciphertext;
                        }
                    });
                    /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
                    /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
                        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt) {
                            // Generate random salt
                            if (!salt) salt = WordArray.random(8);
                            // Derive key and IV
                            var key = EvpKDF.create({
                                keySize: keySize + ivSize
                            }).compute(password, salt);
                            // Separate key and IV
                            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                            key.sigBytes = keySize * 4;
                            // Return params
                            return CipherParams.create({
                                key: key,
                                iv: iv,
                                salt: salt
                            });
                        }
                    };
                    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
                        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                            kdf: OpenSSLKdf
                        }),
                        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                            // Apply config defaults
                            cfg = this.cfg.extend(cfg);
                            // Derive key and other params
                            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
                            // Add IV to config
                            cfg.iv = derivedParams.iv;
                            // Encrypt
                            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                            // Mix in derived params
                            ciphertext.mixIn(derivedParams);
                            return ciphertext;
                        },
                        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                            // Apply config defaults
                            cfg = this.cfg.extend(cfg);
                            // Convert string to CipherParams
                            ciphertext = this._parse(ciphertext, cfg.format);
                            // Derive key and other params
                            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
                            // Add IV to config
                            cfg.iv = derivedParams.iv;
                            // Decrypt
                            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                            return plaintext;
                        }
                    });
                }();
                /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
                    var CFB = CryptoJS.lib.BlockCipherMode.extend();
                    CFB.Encryptor = CFB.extend({
                        processBlock: function(words, offset) {
                            // Shortcuts
                            var cipher = this._cipher;
                            var blockSize = cipher.blockSize;
                            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                            // Remember this block to use with next block
                            this._prevBlock = words.slice(offset, offset + blockSize);
                        }
                    });
                    CFB.Decryptor = CFB.extend({
                        processBlock: function(words, offset) {
                            // Shortcuts
                            var cipher = this._cipher;
                            var blockSize = cipher.blockSize;
                            // Remember this block to use with next block
                            var thisBlock = words.slice(offset, offset + blockSize);
                            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                            // This block becomes the previous block
                            this._prevBlock = thisBlock;
                        }
                    });
                    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
                        // Shortcut
                        var iv = this._iv;
                        // Generate keystream
                        if (iv) {
                            var keystream = iv.slice(0);
                            // Remove IV for subsequent blocks
                            this._iv = undefined;
                        } else var keystream = this._prevBlock;
                        cipher.encryptBlock(keystream, 0);
                        // Encrypt
                        for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                    }
                    return CFB;
                }();
                /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
                    var ECB = CryptoJS.lib.BlockCipherMode.extend();
                    ECB.Encryptor = ECB.extend({
                        processBlock: function(words, offset) {
                            this._cipher.encryptBlock(words, offset);
                        }
                    });
                    ECB.Decryptor = ECB.extend({
                        processBlock: function(words, offset) {
                            this._cipher.decryptBlock(words, offset);
                        }
                    });
                    return ECB;
                }();
                /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
                    pad: function(data, blockSize) {
                        // Shortcuts
                        var dataSigBytes = data.sigBytes;
                        var blockSizeBytes = blockSize * 4;
                        // Count padding bytes
                        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
                        // Compute last byte position
                        var lastBytePos = dataSigBytes + nPaddingBytes - 1;
                        // Pad
                        data.clamp();
                        data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
                        data.sigBytes += nPaddingBytes;
                    },
                    unpad: function(data) {
                        // Get number of padding bytes from last byte
                        var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                        // Remove padding
                        data.sigBytes -= nPaddingBytes;
                    }
                };
                /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
                    pad: function(data, blockSize) {
                        // Shortcut
                        var blockSizeBytes = blockSize * 4;
                        // Count padding bytes
                        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                        // Pad
                        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                            nPaddingBytes << 24
                        ], 1));
                    },
                    unpad: function(data) {
                        // Get number of padding bytes from last byte
                        var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                        // Remove padding
                        data.sigBytes -= nPaddingBytes;
                    }
                };
                /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
                    pad: function(data, blockSize) {
                        // Add 0x80 byte
                        data.concat(CryptoJS.lib.WordArray.create([
                            0x80000000
                        ], 1));
                        // Zero pad the rest
                        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
                    },
                    unpad: function(data) {
                        // Remove zero padding
                        CryptoJS.pad.ZeroPadding.unpad(data);
                        // Remove one more byte -- the 0x80 byte
                        data.sigBytes--;
                    }
                };
                /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
                    var OFB = CryptoJS.lib.BlockCipherMode.extend();
                    var Encryptor = OFB.Encryptor = OFB.extend({
                        processBlock: function(words, offset) {
                            // Shortcuts
                            var cipher = this._cipher;
                            var blockSize = cipher.blockSize;
                            var iv = this._iv;
                            var keystream = this._keystream;
                            // Generate keystream
                            if (iv) {
                                keystream = this._keystream = iv.slice(0);
                                // Remove IV for subsequent blocks
                                this._iv = undefined;
                            }
                            cipher.encryptBlock(keystream, 0);
                            // Encrypt
                            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                        }
                    });
                    OFB.Decryptor = Encryptor;
                    return OFB;
                }();
                /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
                    pad: function() {},
                    unpad: function() {}
                };
                (function(undefined1) {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var CipherParams = C_lib.CipherParams;
                    var C_enc = C.enc;
                    var Hex = C_enc.Hex;
                    var C_format = C.format;
                    var HexFormatter = C_format.Hex = {
                        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                            return cipherParams.ciphertext.toString(Hex);
                        },
                        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                            var ciphertext = Hex.parse(input);
                            return CipherParams.create({
                                ciphertext: ciphertext
                            });
                        }
                    };
                })();
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var BlockCipher = C_lib.BlockCipher;
                    var C_algo = C.algo;
                    // Lookup tables
                    var SBOX = [];
                    var INV_SBOX = [];
                    var SUB_MIX_0 = [];
                    var SUB_MIX_1 = [];
                    var SUB_MIX_2 = [];
                    var SUB_MIX_3 = [];
                    var INV_SUB_MIX_0 = [];
                    var INV_SUB_MIX_1 = [];
                    var INV_SUB_MIX_2 = [];
                    var INV_SUB_MIX_3 = [];
                    // Compute lookup tables
                    (function() {
                        // Compute double table
                        var d = [];
                        for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
                        else d[i] = i << 1 ^ 0x11b;
                        // Walk GF(2^8)
                        var x = 0;
                        var xi = 0;
                        for(var i = 0; i < 256; i++){
                            // Compute sbox
                            var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                            sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                            SBOX[x] = sx;
                            INV_SBOX[sx] = x;
                            // Compute multiplication
                            var x2 = d[x];
                            var x4 = d[x2];
                            var x8 = d[x4];
                            // Compute sub bytes, mix columns tables
                            var t = d[sx] * 0x101 ^ sx * 0x1010100;
                            SUB_MIX_0[x] = t << 24 | t >>> 8;
                            SUB_MIX_1[x] = t << 16 | t >>> 16;
                            SUB_MIX_2[x] = t << 8 | t >>> 24;
                            SUB_MIX_3[x] = t;
                            // Compute inv sub bytes, inv mix columns tables
                            var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                            INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                            INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                            INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                            INV_SUB_MIX_3[sx] = t;
                            // Compute next counter
                            if (!x) x = xi = 1;
                            else {
                                x = x2 ^ d[d[d[x8 ^ x2]]];
                                xi ^= d[d[xi]];
                            }
                        }
                    })();
                    // Precomputed Rcon lookup
                    var RCON = [
                        0x00,
                        0x01,
                        0x02,
                        0x04,
                        0x08,
                        0x10,
                        0x20,
                        0x40,
                        0x80,
                        0x1b,
                        0x36
                    ];
                    /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
                        _doReset: function() {
                            // Skip reset of nRounds has been set before and key did not change
                            if (this._nRounds && this._keyPriorReset === this._key) return;
                            // Shortcuts
                            var key = this._keyPriorReset = this._key;
                            var keyWords = key.words;
                            var keySize = key.sigBytes / 4;
                            // Compute number of rounds
                            var nRounds = this._nRounds = keySize + 6;
                            // Compute number of key schedule rows
                            var ksRows = (nRounds + 1) * 4;
                            // Compute key schedule
                            var keySchedule = this._keySchedule = [];
                            for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                            else {
                                var t = keySchedule[ksRow - 1];
                                if (!(ksRow % keySize)) {
                                    // Rot word
                                    t = t << 8 | t >>> 24;
                                    // Sub word
                                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                                    // Mix Rcon
                                    t ^= RCON[ksRow / keySize | 0] << 24;
                                } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                                t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                                keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                            }
                            // Compute inv key schedule
                            var invKeySchedule = this._invKeySchedule = [];
                            for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                                var ksRow = ksRows - invKsRow;
                                if (invKsRow % 4) var t = keySchedule[ksRow];
                                else var t = keySchedule[ksRow - 4];
                                if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                                else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                            }
                        },
                        encryptBlock: function(M, offset) {
                            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
                        },
                        decryptBlock: function(M, offset) {
                            // Swap 2nd and 4th rows
                            var t = M[offset + 1];
                            M[offset + 1] = M[offset + 3];
                            M[offset + 3] = t;
                            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                            // Inv swap 2nd and 4th rows
                            var t = M[offset + 1];
                            M[offset + 1] = M[offset + 3];
                            M[offset + 3] = t;
                        },
                        _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                            // Shortcut
                            var nRounds = this._nRounds;
                            // Get input, add round key
                            var s0 = M[offset] ^ keySchedule[0];
                            var s1 = M[offset + 1] ^ keySchedule[1];
                            var s2 = M[offset + 2] ^ keySchedule[2];
                            var s3 = M[offset + 3] ^ keySchedule[3];
                            // Key schedule row counter
                            var ksRow = 4;
                            // Rounds
                            for(var round = 1; round < nRounds; round++){
                                // Shift rows, sub bytes, mix columns, add round key
                                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                                // Update state
                                s0 = t0;
                                s1 = t1;
                                s2 = t2;
                                s3 = t3;
                            }
                            // Shift rows, sub bytes, add round key
                            var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                            var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                            var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                            var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                            // Set output
                            M[offset] = t0;
                            M[offset + 1] = t1;
                            M[offset + 2] = t2;
                            M[offset + 3] = t3;
                        },
                        keySize: 8
                    });
                    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
                })();
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var BlockCipher = C_lib.BlockCipher;
                    var C_algo = C.algo;
                    // Permuted Choice 1 constants
                    var PC1 = [
                        57,
                        49,
                        41,
                        33,
                        25,
                        17,
                        9,
                        1,
                        58,
                        50,
                        42,
                        34,
                        26,
                        18,
                        10,
                        2,
                        59,
                        51,
                        43,
                        35,
                        27,
                        19,
                        11,
                        3,
                        60,
                        52,
                        44,
                        36,
                        63,
                        55,
                        47,
                        39,
                        31,
                        23,
                        15,
                        7,
                        62,
                        54,
                        46,
                        38,
                        30,
                        22,
                        14,
                        6,
                        61,
                        53,
                        45,
                        37,
                        29,
                        21,
                        13,
                        5,
                        28,
                        20,
                        12,
                        4
                    ];
                    // Permuted Choice 2 constants
                    var PC2 = [
                        14,
                        17,
                        11,
                        24,
                        1,
                        5,
                        3,
                        28,
                        15,
                        6,
                        21,
                        10,
                        23,
                        19,
                        12,
                        4,
                        26,
                        8,
                        16,
                        7,
                        27,
                        20,
                        13,
                        2,
                        41,
                        52,
                        31,
                        37,
                        47,
                        55,
                        30,
                        40,
                        51,
                        45,
                        33,
                        48,
                        44,
                        49,
                        39,
                        56,
                        34,
                        53,
                        46,
                        42,
                        50,
                        36,
                        29,
                        32
                    ];
                    // Cumulative bit shift constants
                    var BIT_SHIFTS = [
                        1,
                        2,
                        4,
                        6,
                        8,
                        10,
                        12,
                        14,
                        15,
                        17,
                        19,
                        21,
                        23,
                        25,
                        27,
                        28
                    ];
                    // SBOXes and round permutation constants
                    var SBOX_P = [
                        {
                            0x0: 0x808200,
                            0x10000000: 0x8000,
                            0x20000000: 0x808002,
                            0x30000000: 0x2,
                            0x40000000: 0x200,
                            0x50000000: 0x808202,
                            0x60000000: 0x800202,
                            0x70000000: 0x800000,
                            0x80000000: 0x202,
                            0x90000000: 0x800200,
                            0xa0000000: 0x8200,
                            0xb0000000: 0x808000,
                            0xc0000000: 0x8002,
                            0xd0000000: 0x800002,
                            0xe0000000: 0x0,
                            0xf0000000: 0x8202,
                            0x8000000: 0x0,
                            0x18000000: 0x808202,
                            0x28000000: 0x8202,
                            0x38000000: 0x8000,
                            0x48000000: 0x808200,
                            0x58000000: 0x200,
                            0x68000000: 0x808002,
                            0x78000000: 0x2,
                            0x88000000: 0x800200,
                            0x98000000: 0x8200,
                            0xa8000000: 0x808000,
                            0xb8000000: 0x800202,
                            0xc8000000: 0x800002,
                            0xd8000000: 0x8002,
                            0xe8000000: 0x202,
                            0xf8000000: 0x800000,
                            0x1: 0x8000,
                            0x10000001: 0x2,
                            0x20000001: 0x808200,
                            0x30000001: 0x800000,
                            0x40000001: 0x808002,
                            0x50000001: 0x8200,
                            0x60000001: 0x200,
                            0x70000001: 0x800202,
                            0x80000001: 0x808202,
                            0x90000001: 0x808000,
                            0xa0000001: 0x800002,
                            0xb0000001: 0x8202,
                            0xc0000001: 0x202,
                            0xd0000001: 0x800200,
                            0xe0000001: 0x8002,
                            0xf0000001: 0x0,
                            0x8000001: 0x808202,
                            0x18000001: 0x808000,
                            0x28000001: 0x800000,
                            0x38000001: 0x200,
                            0x48000001: 0x8000,
                            0x58000001: 0x800002,
                            0x68000001: 0x2,
                            0x78000001: 0x8202,
                            0x88000001: 0x8002,
                            0x98000001: 0x800202,
                            0xa8000001: 0x202,
                            0xb8000001: 0x808200,
                            0xc8000001: 0x800200,
                            0xd8000001: 0x0,
                            0xe8000001: 0x8200,
                            0xf8000001: 0x808002
                        },
                        {
                            0x0: 0x40084010,
                            0x1000000: 0x4000,
                            0x2000000: 0x80000,
                            0x3000000: 0x40080010,
                            0x4000000: 0x40000010,
                            0x5000000: 0x40084000,
                            0x6000000: 0x40004000,
                            0x7000000: 0x10,
                            0x8000000: 0x84000,
                            0x9000000: 0x40004010,
                            0xa000000: 0x40000000,
                            0xb000000: 0x84010,
                            0xc000000: 0x80010,
                            0xd000000: 0x0,
                            0xe000000: 0x4010,
                            0xf000000: 0x40080000,
                            0x800000: 0x40004000,
                            0x1800000: 0x84010,
                            0x2800000: 0x10,
                            0x3800000: 0x40004010,
                            0x4800000: 0x40084010,
                            0x5800000: 0x40000000,
                            0x6800000: 0x80000,
                            0x7800000: 0x40080010,
                            0x8800000: 0x80010,
                            0x9800000: 0x0,
                            0xa800000: 0x4000,
                            0xb800000: 0x40080000,
                            0xc800000: 0x40000010,
                            0xd800000: 0x84000,
                            0xe800000: 0x40084000,
                            0xf800000: 0x4010,
                            0x10000000: 0x0,
                            0x11000000: 0x40080010,
                            0x12000000: 0x40004010,
                            0x13000000: 0x40084000,
                            0x14000000: 0x40080000,
                            0x15000000: 0x10,
                            0x16000000: 0x84010,
                            0x17000000: 0x4000,
                            0x18000000: 0x4010,
                            0x19000000: 0x80000,
                            0x1a000000: 0x80010,
                            0x1b000000: 0x40000010,
                            0x1c000000: 0x84000,
                            0x1d000000: 0x40004000,
                            0x1e000000: 0x40000000,
                            0x1f000000: 0x40084010,
                            0x10800000: 0x84010,
                            0x11800000: 0x80000,
                            0x12800000: 0x40080000,
                            0x13800000: 0x4000,
                            0x14800000: 0x40004000,
                            0x15800000: 0x40084010,
                            0x16800000: 0x10,
                            0x17800000: 0x40000000,
                            0x18800000: 0x40084000,
                            0x19800000: 0x40000010,
                            0x1a800000: 0x40004010,
                            0x1b800000: 0x80010,
                            0x1c800000: 0x0,
                            0x1d800000: 0x4010,
                            0x1e800000: 0x40080010,
                            0x1f800000: 0x84000
                        },
                        {
                            0x0: 0x104,
                            0x100000: 0x0,
                            0x200000: 0x4000100,
                            0x300000: 0x10104,
                            0x400000: 0x10004,
                            0x500000: 0x4000004,
                            0x600000: 0x4010104,
                            0x700000: 0x4010000,
                            0x800000: 0x4000000,
                            0x900000: 0x4010100,
                            0xa00000: 0x10100,
                            0xb00000: 0x4010004,
                            0xc00000: 0x4000104,
                            0xd00000: 0x10000,
                            0xe00000: 0x4,
                            0xf00000: 0x100,
                            0x80000: 0x4010100,
                            0x180000: 0x4010004,
                            0x280000: 0x0,
                            0x380000: 0x4000100,
                            0x480000: 0x4000004,
                            0x580000: 0x10000,
                            0x680000: 0x10004,
                            0x780000: 0x104,
                            0x880000: 0x4,
                            0x980000: 0x100,
                            0xa80000: 0x4010000,
                            0xb80000: 0x10104,
                            0xc80000: 0x10100,
                            0xd80000: 0x4000104,
                            0xe80000: 0x4010104,
                            0xf80000: 0x4000000,
                            0x1000000: 0x4010100,
                            0x1100000: 0x10004,
                            0x1200000: 0x10000,
                            0x1300000: 0x4000100,
                            0x1400000: 0x100,
                            0x1500000: 0x4010104,
                            0x1600000: 0x4000004,
                            0x1700000: 0x0,
                            0x1800000: 0x4000104,
                            0x1900000: 0x4000000,
                            0x1a00000: 0x4,
                            0x1b00000: 0x10100,
                            0x1c00000: 0x4010000,
                            0x1d00000: 0x104,
                            0x1e00000: 0x10104,
                            0x1f00000: 0x4010004,
                            0x1080000: 0x4000000,
                            0x1180000: 0x104,
                            0x1280000: 0x4010100,
                            0x1380000: 0x0,
                            0x1480000: 0x10004,
                            0x1580000: 0x4000100,
                            0x1680000: 0x100,
                            0x1780000: 0x4010004,
                            0x1880000: 0x10000,
                            0x1980000: 0x4010104,
                            0x1a80000: 0x10104,
                            0x1b80000: 0x4000004,
                            0x1c80000: 0x4000104,
                            0x1d80000: 0x4010000,
                            0x1e80000: 0x4,
                            0x1f80000: 0x10100
                        },
                        {
                            0x0: 0x80401000,
                            0x10000: 0x80001040,
                            0x20000: 0x401040,
                            0x30000: 0x80400000,
                            0x40000: 0x0,
                            0x50000: 0x401000,
                            0x60000: 0x80000040,
                            0x70000: 0x400040,
                            0x80000: 0x80000000,
                            0x90000: 0x400000,
                            0xa0000: 0x40,
                            0xb0000: 0x80001000,
                            0xc0000: 0x80400040,
                            0xd0000: 0x1040,
                            0xe0000: 0x1000,
                            0xf0000: 0x80401040,
                            0x8000: 0x80001040,
                            0x18000: 0x40,
                            0x28000: 0x80400040,
                            0x38000: 0x80001000,
                            0x48000: 0x401000,
                            0x58000: 0x80401040,
                            0x68000: 0x0,
                            0x78000: 0x80400000,
                            0x88000: 0x1000,
                            0x98000: 0x80401000,
                            0xa8000: 0x400000,
                            0xb8000: 0x1040,
                            0xc8000: 0x80000000,
                            0xd8000: 0x400040,
                            0xe8000: 0x401040,
                            0xf8000: 0x80000040,
                            0x100000: 0x400040,
                            0x110000: 0x401000,
                            0x120000: 0x80000040,
                            0x130000: 0x0,
                            0x140000: 0x1040,
                            0x150000: 0x80400040,
                            0x160000: 0x80401000,
                            0x170000: 0x80001040,
                            0x180000: 0x80401040,
                            0x190000: 0x80000000,
                            0x1a0000: 0x80400000,
                            0x1b0000: 0x401040,
                            0x1c0000: 0x80001000,
                            0x1d0000: 0x400000,
                            0x1e0000: 0x40,
                            0x1f0000: 0x1000,
                            0x108000: 0x80400000,
                            0x118000: 0x80401040,
                            0x128000: 0x0,
                            0x138000: 0x401000,
                            0x148000: 0x400040,
                            0x158000: 0x80000000,
                            0x168000: 0x80001040,
                            0x178000: 0x40,
                            0x188000: 0x80000040,
                            0x198000: 0x1000,
                            0x1a8000: 0x80001000,
                            0x1b8000: 0x80400040,
                            0x1c8000: 0x1040,
                            0x1d8000: 0x80401000,
                            0x1e8000: 0x400000,
                            0x1f8000: 0x401040
                        },
                        {
                            0x0: 0x80,
                            0x1000: 0x1040000,
                            0x2000: 0x40000,
                            0x3000: 0x20000000,
                            0x4000: 0x20040080,
                            0x5000: 0x1000080,
                            0x6000: 0x21000080,
                            0x7000: 0x40080,
                            0x8000: 0x1000000,
                            0x9000: 0x20040000,
                            0xa000: 0x20000080,
                            0xb000: 0x21040080,
                            0xc000: 0x21040000,
                            0xd000: 0x0,
                            0xe000: 0x1040080,
                            0xf000: 0x21000000,
                            0x800: 0x1040080,
                            0x1800: 0x21000080,
                            0x2800: 0x80,
                            0x3800: 0x1040000,
                            0x4800: 0x40000,
                            0x5800: 0x20040080,
                            0x6800: 0x21040000,
                            0x7800: 0x20000000,
                            0x8800: 0x20040000,
                            0x9800: 0x0,
                            0xa800: 0x21040080,
                            0xb800: 0x1000080,
                            0xc800: 0x20000080,
                            0xd800: 0x21000000,
                            0xe800: 0x1000000,
                            0xf800: 0x40080,
                            0x10000: 0x40000,
                            0x11000: 0x80,
                            0x12000: 0x20000000,
                            0x13000: 0x21000080,
                            0x14000: 0x1000080,
                            0x15000: 0x21040000,
                            0x16000: 0x20040080,
                            0x17000: 0x1000000,
                            0x18000: 0x21040080,
                            0x19000: 0x21000000,
                            0x1a000: 0x1040000,
                            0x1b000: 0x20040000,
                            0x1c000: 0x40080,
                            0x1d000: 0x20000080,
                            0x1e000: 0x0,
                            0x1f000: 0x1040080,
                            0x10800: 0x21000080,
                            0x11800: 0x1000000,
                            0x12800: 0x1040000,
                            0x13800: 0x20040080,
                            0x14800: 0x20000000,
                            0x15800: 0x1040080,
                            0x16800: 0x80,
                            0x17800: 0x21040000,
                            0x18800: 0x40080,
                            0x19800: 0x21040080,
                            0x1a800: 0x0,
                            0x1b800: 0x21000000,
                            0x1c800: 0x1000080,
                            0x1d800: 0x40000,
                            0x1e800: 0x20040000,
                            0x1f800: 0x20000080
                        },
                        {
                            0x0: 0x10000008,
                            0x100: 0x2000,
                            0x200: 0x10200000,
                            0x300: 0x10202008,
                            0x400: 0x10002000,
                            0x500: 0x200000,
                            0x600: 0x200008,
                            0x700: 0x10000000,
                            0x800: 0x0,
                            0x900: 0x10002008,
                            0xa00: 0x202000,
                            0xb00: 0x8,
                            0xc00: 0x10200008,
                            0xd00: 0x202008,
                            0xe00: 0x2008,
                            0xf00: 0x10202000,
                            0x80: 0x10200000,
                            0x180: 0x10202008,
                            0x280: 0x8,
                            0x380: 0x200000,
                            0x480: 0x202008,
                            0x580: 0x10000008,
                            0x680: 0x10002000,
                            0x780: 0x2008,
                            0x880: 0x200008,
                            0x980: 0x2000,
                            0xa80: 0x10002008,
                            0xb80: 0x10200008,
                            0xc80: 0x0,
                            0xd80: 0x10202000,
                            0xe80: 0x202000,
                            0xf80: 0x10000000,
                            0x1000: 0x10002000,
                            0x1100: 0x10200008,
                            0x1200: 0x10202008,
                            0x1300: 0x2008,
                            0x1400: 0x200000,
                            0x1500: 0x10000000,
                            0x1600: 0x10000008,
                            0x1700: 0x202000,
                            0x1800: 0x202008,
                            0x1900: 0x0,
                            0x1a00: 0x8,
                            0x1b00: 0x10200000,
                            0x1c00: 0x2000,
                            0x1d00: 0x10002008,
                            0x1e00: 0x10202000,
                            0x1f00: 0x200008,
                            0x1080: 0x8,
                            0x1180: 0x202000,
                            0x1280: 0x200000,
                            0x1380: 0x10000008,
                            0x1480: 0x10002000,
                            0x1580: 0x2008,
                            0x1680: 0x10202008,
                            0x1780: 0x10200000,
                            0x1880: 0x10202000,
                            0x1980: 0x10200008,
                            0x1a80: 0x2000,
                            0x1b80: 0x202008,
                            0x1c80: 0x200008,
                            0x1d80: 0x0,
                            0x1e80: 0x10000000,
                            0x1f80: 0x10002008
                        },
                        {
                            0x0: 0x100000,
                            0x10: 0x2000401,
                            0x20: 0x400,
                            0x30: 0x100401,
                            0x40: 0x2100401,
                            0x50: 0x0,
                            0x60: 0x1,
                            0x70: 0x2100001,
                            0x80: 0x2000400,
                            0x90: 0x100001,
                            0xa0: 0x2000001,
                            0xb0: 0x2100400,
                            0xc0: 0x2100000,
                            0xd0: 0x401,
                            0xe0: 0x100400,
                            0xf0: 0x2000000,
                            0x8: 0x2100001,
                            0x18: 0x0,
                            0x28: 0x2000401,
                            0x38: 0x2100400,
                            0x48: 0x100000,
                            0x58: 0x2000001,
                            0x68: 0x2000000,
                            0x78: 0x401,
                            0x88: 0x100401,
                            0x98: 0x2000400,
                            0xa8: 0x2100000,
                            0xb8: 0x100001,
                            0xc8: 0x400,
                            0xd8: 0x2100401,
                            0xe8: 0x1,
                            0xf8: 0x100400,
                            0x100: 0x2000000,
                            0x110: 0x100000,
                            0x120: 0x2000401,
                            0x130: 0x2100001,
                            0x140: 0x100001,
                            0x150: 0x2000400,
                            0x160: 0x2100400,
                            0x170: 0x100401,
                            0x180: 0x401,
                            0x190: 0x2100401,
                            0x1a0: 0x100400,
                            0x1b0: 0x1,
                            0x1c0: 0x0,
                            0x1d0: 0x2100000,
                            0x1e0: 0x2000001,
                            0x1f0: 0x400,
                            0x108: 0x100400,
                            0x118: 0x2000401,
                            0x128: 0x2100001,
                            0x138: 0x1,
                            0x148: 0x2000000,
                            0x158: 0x100000,
                            0x168: 0x401,
                            0x178: 0x2100400,
                            0x188: 0x2000001,
                            0x198: 0x2100000,
                            0x1a8: 0x0,
                            0x1b8: 0x2100401,
                            0x1c8: 0x100401,
                            0x1d8: 0x400,
                            0x1e8: 0x2000400,
                            0x1f8: 0x100001
                        },
                        {
                            0x0: 0x8000820,
                            0x1: 0x20000,
                            0x2: 0x8000000,
                            0x3: 0x20,
                            0x4: 0x20020,
                            0x5: 0x8020820,
                            0x6: 0x8020800,
                            0x7: 0x800,
                            0x8: 0x8020000,
                            0x9: 0x8000800,
                            0xa: 0x20800,
                            0xb: 0x8020020,
                            0xc: 0x820,
                            0xd: 0x0,
                            0xe: 0x8000020,
                            0xf: 0x20820,
                            0x80000000: 0x800,
                            0x80000001: 0x8020820,
                            0x80000002: 0x8000820,
                            0x80000003: 0x8000000,
                            0x80000004: 0x8020000,
                            0x80000005: 0x20800,
                            0x80000006: 0x20820,
                            0x80000007: 0x20,
                            0x80000008: 0x8000020,
                            0x80000009: 0x820,
                            0x8000000a: 0x20020,
                            0x8000000b: 0x8020800,
                            0x8000000c: 0x0,
                            0x8000000d: 0x8020020,
                            0x8000000e: 0x8000800,
                            0x8000000f: 0x20000,
                            0x10: 0x20820,
                            0x11: 0x8020800,
                            0x12: 0x20,
                            0x13: 0x800,
                            0x14: 0x8000800,
                            0x15: 0x8000020,
                            0x16: 0x8020020,
                            0x17: 0x20000,
                            0x18: 0x0,
                            0x19: 0x20020,
                            0x1a: 0x8020000,
                            0x1b: 0x8000820,
                            0x1c: 0x8020820,
                            0x1d: 0x20800,
                            0x1e: 0x820,
                            0x1f: 0x8000000,
                            0x80000010: 0x20000,
                            0x80000011: 0x800,
                            0x80000012: 0x8020020,
                            0x80000013: 0x20820,
                            0x80000014: 0x20,
                            0x80000015: 0x8020000,
                            0x80000016: 0x8000000,
                            0x80000017: 0x8000820,
                            0x80000018: 0x8020820,
                            0x80000019: 0x8000020,
                            0x8000001a: 0x8000800,
                            0x8000001b: 0x0,
                            0x8000001c: 0x20800,
                            0x8000001d: 0x820,
                            0x8000001e: 0x20020,
                            0x8000001f: 0x8020800
                        }
                    ];
                    // Masks that select the SBOX input
                    var SBOX_MASK = [
                        0xf8000001,
                        0x1f800000,
                        0x01f80000,
                        0x001f8000,
                        0x0001f800,
                        0x00001f80,
                        0x000001f8,
                        0x8000001f
                    ];
                    /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
                        _doReset: function() {
                            // Shortcuts
                            var key = this._key;
                            var keyWords = key.words;
                            // Select 56 bits according to PC1
                            var keyBits = [];
                            for(var i = 0; i < 56; i++){
                                var keyBitPos = PC1[i] - 1;
                                keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                            }
                            // Assemble 16 subkeys
                            var subKeys = this._subKeys = [];
                            for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                                // Create subkey
                                var subKey = subKeys[nSubKey] = [];
                                // Shortcut
                                var bitShift = BIT_SHIFTS[nSubKey];
                                // Select 48 bits according to PC2
                                for(var i = 0; i < 24; i++){
                                    // Select from the left 28 key bits
                                    subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                                    // Select from the right 28 key bits
                                    subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                                }
                                // Since each subkey is applied to an expanded 32-bit input,
                                // the subkey can be broken into 8 values scaled to 32-bits,
                                // which allows the key to be used without expansion
                                subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                                for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                                subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                            }
                            // Compute inverse subkeys
                            var invSubKeys = this._invSubKeys = [];
                            for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
                        },
                        encryptBlock: function(M, offset) {
                            this._doCryptBlock(M, offset, this._subKeys);
                        },
                        decryptBlock: function(M, offset) {
                            this._doCryptBlock(M, offset, this._invSubKeys);
                        },
                        _doCryptBlock: function(M, offset, subKeys) {
                            // Get input
                            this._lBlock = M[offset];
                            this._rBlock = M[offset + 1];
                            // Initial permutation
                            exchangeLR.call(this, 4, 0x0f0f0f0f);
                            exchangeLR.call(this, 16, 0x0000ffff);
                            exchangeRL.call(this, 2, 0x33333333);
                            exchangeRL.call(this, 8, 0x00ff00ff);
                            exchangeLR.call(this, 1, 0x55555555);
                            // Rounds
                            for(var round = 0; round < 16; round++){
                                // Shortcuts
                                var subKey = subKeys[round];
                                var lBlock = this._lBlock;
                                var rBlock = this._rBlock;
                                // Feistel function
                                var f = 0;
                                for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                                this._lBlock = rBlock;
                                this._rBlock = lBlock ^ f;
                            }
                            // Undo swap from last round
                            var t = this._lBlock;
                            this._lBlock = this._rBlock;
                            this._rBlock = t;
                            // Final permutation
                            exchangeLR.call(this, 1, 0x55555555);
                            exchangeRL.call(this, 8, 0x00ff00ff);
                            exchangeRL.call(this, 2, 0x33333333);
                            exchangeLR.call(this, 16, 0x0000ffff);
                            exchangeLR.call(this, 4, 0x0f0f0f0f);
                            // Set output
                            M[offset] = this._lBlock;
                            M[offset + 1] = this._rBlock;
                        },
                        keySize: 2,
                        ivSize: 2,
                        blockSize: 2
                    });
                    // Swap bits across the left and right words
                    function exchangeLR(offset, mask) {
                        var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
                        this._rBlock ^= t;
                        this._lBlock ^= t << offset;
                    }
                    function exchangeRL(offset, mask) {
                        var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
                        this._lBlock ^= t;
                        this._rBlock ^= t << offset;
                    }
                    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
                    /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
                        _doReset: function() {
                            // Shortcuts
                            var key = this._key;
                            var keyWords = key.words;
                            // Create DES instances
                            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
                            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
                            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
                        },
                        encryptBlock: function(M, offset) {
                            this._des1.encryptBlock(M, offset);
                            this._des2.decryptBlock(M, offset);
                            this._des3.encryptBlock(M, offset);
                        },
                        decryptBlock: function(M, offset) {
                            this._des3.decryptBlock(M, offset);
                            this._des2.encryptBlock(M, offset);
                            this._des1.decryptBlock(M, offset);
                        },
                        keySize: 6,
                        ivSize: 2,
                        blockSize: 2
                    });
                    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
                })();
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var StreamCipher = C_lib.StreamCipher;
                    var C_algo = C.algo;
                    /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
                        _doReset: function() {
                            // Shortcuts
                            var key = this._key;
                            var keyWords = key.words;
                            var keySigBytes = key.sigBytes;
                            // Init sbox
                            var S = this._S = [];
                            for(var i = 0; i < 256; i++)S[i] = i;
                            // Key setup
                            for(var i = 0, j = 0; i < 256; i++){
                                var keyByteIndex = i % keySigBytes;
                                var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                                j = (j + S[i] + keyByte) % 256;
                                // Swap
                                var t = S[i];
                                S[i] = S[j];
                                S[j] = t;
                            }
                            // Counters
                            this._i = this._j = 0;
                        },
                        _doProcessBlock: function(M, offset) {
                            M[offset] ^= generateKeystreamWord.call(this);
                        },
                        keySize: 8,
                        ivSize: 0
                    });
                    function generateKeystreamWord() {
                        // Shortcuts
                        var S = this._S;
                        var i = this._i;
                        var j = this._j;
                        // Generate keystream word
                        var keystreamWord = 0;
                        for(var n = 0; n < 4; n++){
                            i = (i + 1) % 256;
                            j = (j + S[i]) % 256;
                            // Swap
                            var t = S[i];
                            S[i] = S[j];
                            S[j] = t;
                            keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
                        }
                        // Update counters
                        this._i = i;
                        this._j = j;
                        return keystreamWord;
                    }
                    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
                    /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
                        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                            drop: 192
                        }),
                        _doReset: function() {
                            RC4._doReset.call(this);
                            // Drop
                            for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
                        }
                    });
                    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
                })();
                /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
                    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
                    function incWord(word) {
                        if ((word >> 24 & 0xff) === 0xff) {
                            var b1 = word >> 16 & 0xff;
                            var b2 = word >> 8 & 0xff;
                            var b3 = word & 0xff;
                            if (b1 === 0xff) {
                                b1 = 0;
                                if (b2 === 0xff) {
                                    b2 = 0;
                                    if (b3 === 0xff) b3 = 0;
                                    else ++b3;
                                } else ++b2;
                            } else ++b1;
                            word = 0;
                            word += b1 << 16;
                            word += b2 << 8;
                            word += b3;
                        } else word += 16777216;
                        return word;
                    }
                    function incCounter(counter) {
                        if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
                        counter[1] = incWord(counter[1]);
                        return counter;
                    }
                    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
                        processBlock: function(words, offset) {
                            // Shortcuts
                            var cipher = this._cipher;
                            var blockSize = cipher.blockSize;
                            var iv = this._iv;
                            var counter = this._counter;
                            // Generate keystream
                            if (iv) {
                                counter = this._counter = iv.slice(0);
                                // Remove IV for subsequent blocks
                                this._iv = undefined;
                            }
                            incCounter(counter);
                            var keystream = counter.slice(0);
                            cipher.encryptBlock(keystream, 0);
                            // Encrypt
                            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                        }
                    });
                    CTRGladman.Decryptor = Encryptor;
                    return CTRGladman;
                }();
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var StreamCipher = C_lib.StreamCipher;
                    var C_algo = C.algo;
                    // Reusable objects
                    var S = [];
                    var C_ = [];
                    var G = [];
                    /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
                        _doReset: function() {
                            // Shortcuts
                            var K = this._key.words;
                            var iv = this.cfg.iv;
                            // Swap endian
                            for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                            // Generate initial state values
                            var X = this._X = [
                                K[0],
                                K[3] << 16 | K[2] >>> 16,
                                K[1],
                                K[0] << 16 | K[3] >>> 16,
                                K[2],
                                K[1] << 16 | K[0] >>> 16,
                                K[3],
                                K[2] << 16 | K[1] >>> 16
                            ];
                            // Generate initial counter values
                            var C = this._C = [
                                K[2] << 16 | K[2] >>> 16,
                                K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                                K[3] << 16 | K[3] >>> 16,
                                K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                                K[0] << 16 | K[0] >>> 16,
                                K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                                K[1] << 16 | K[1] >>> 16,
                                K[3] & 0xffff0000 | K[0] & 0x0000ffff
                            ];
                            // Carry bit
                            this._b = 0;
                            // Iterate the system four times
                            for(var i = 0; i < 4; i++)nextState.call(this);
                            // Modify the counters
                            for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                            // IV setup
                            if (iv) {
                                // Shortcuts
                                var IV = iv.words;
                                var IV_0 = IV[0];
                                var IV_1 = IV[1];
                                // Generate four subvectors
                                var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                                var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                                var i1 = i0 >>> 16 | i2 & 0xffff0000;
                                var i3 = i2 << 16 | i0 & 0x0000ffff;
                                // Modify counter values
                                C[0] ^= i0;
                                C[1] ^= i1;
                                C[2] ^= i2;
                                C[3] ^= i3;
                                C[4] ^= i0;
                                C[5] ^= i1;
                                C[6] ^= i2;
                                C[7] ^= i3;
                                // Iterate the system four times
                                for(var i = 0; i < 4; i++)nextState.call(this);
                            }
                        },
                        _doProcessBlock: function(M, offset) {
                            // Shortcut
                            var X = this._X;
                            // Iterate the system
                            nextState.call(this);
                            // Generate four keystream words
                            S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                            S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                            S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                            S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                            for(var i = 0; i < 4; i++){
                                // Swap endian
                                S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                                // Encrypt
                                M[offset + i] ^= S[i];
                            }
                        },
                        blockSize: 4,
                        ivSize: 2
                    });
                    function nextState() {
                        // Shortcuts
                        var X = this._X;
                        var C = this._C;
                        // Save old counter values
                        for(var i = 0; i < 8; i++)C_[i] = C[i];
                        // Calculate new counter values
                        C[0] = C[0] + 0x4d34d34d + this._b | 0;
                        C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
                        C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
                        C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
                        C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
                        C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
                        C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
                        C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
                        this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
                        // Calculate the g-values
                        for(var i = 0; i < 8; i++){
                            var gx = X[i] + C[i];
                            // Construct high and low argument for squaring
                            var ga = gx & 0xffff;
                            var gb = gx >>> 16;
                            // Calculate high and low result of squaring
                            var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                            var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                            // High XOR low
                            G[i] = gh ^ gl;
                        }
                        // Calculate new state values
                        X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
                        X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
                        X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
                        X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
                        X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
                        X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
                        X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
                        X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
                    }
                    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
                })();
                /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
                    var CTR = CryptoJS.lib.BlockCipherMode.extend();
                    var Encryptor = CTR.Encryptor = CTR.extend({
                        processBlock: function(words, offset) {
                            // Shortcuts
                            var cipher = this._cipher;
                            var blockSize = cipher.blockSize;
                            var iv = this._iv;
                            var counter = this._counter;
                            // Generate keystream
                            if (iv) {
                                counter = this._counter = iv.slice(0);
                                // Remove IV for subsequent blocks
                                this._iv = undefined;
                            }
                            var keystream = counter.slice(0);
                            cipher.encryptBlock(keystream, 0);
                            // Increment counter
                            counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                            // Encrypt
                            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                        }
                    });
                    CTR.Decryptor = Encryptor;
                    return CTR;
                }();
                (function() {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var StreamCipher = C_lib.StreamCipher;
                    var C_algo = C.algo;
                    // Reusable objects
                    var S = [];
                    var C_ = [];
                    var G = [];
                    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
                        _doReset: function() {
                            // Shortcuts
                            var K = this._key.words;
                            var iv = this.cfg.iv;
                            // Generate initial state values
                            var X = this._X = [
                                K[0],
                                K[3] << 16 | K[2] >>> 16,
                                K[1],
                                K[0] << 16 | K[3] >>> 16,
                                K[2],
                                K[1] << 16 | K[0] >>> 16,
                                K[3],
                                K[2] << 16 | K[1] >>> 16
                            ];
                            // Generate initial counter values
                            var C = this._C = [
                                K[2] << 16 | K[2] >>> 16,
                                K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                                K[3] << 16 | K[3] >>> 16,
                                K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                                K[0] << 16 | K[0] >>> 16,
                                K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                                K[1] << 16 | K[1] >>> 16,
                                K[3] & 0xffff0000 | K[0] & 0x0000ffff
                            ];
                            // Carry bit
                            this._b = 0;
                            // Iterate the system four times
                            for(var i = 0; i < 4; i++)nextState.call(this);
                            // Modify the counters
                            for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                            // IV setup
                            if (iv) {
                                // Shortcuts
                                var IV = iv.words;
                                var IV_0 = IV[0];
                                var IV_1 = IV[1];
                                // Generate four subvectors
                                var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                                var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                                var i1 = i0 >>> 16 | i2 & 0xffff0000;
                                var i3 = i2 << 16 | i0 & 0x0000ffff;
                                // Modify counter values
                                C[0] ^= i0;
                                C[1] ^= i1;
                                C[2] ^= i2;
                                C[3] ^= i3;
                                C[4] ^= i0;
                                C[5] ^= i1;
                                C[6] ^= i2;
                                C[7] ^= i3;
                                // Iterate the system four times
                                for(var i = 0; i < 4; i++)nextState.call(this);
                            }
                        },
                        _doProcessBlock: function(M, offset) {
                            // Shortcut
                            var X = this._X;
                            // Iterate the system
                            nextState.call(this);
                            // Generate four keystream words
                            S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                            S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                            S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                            S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                            for(var i = 0; i < 4; i++){
                                // Swap endian
                                S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                                // Encrypt
                                M[offset + i] ^= S[i];
                            }
                        },
                        blockSize: 4,
                        ivSize: 2
                    });
                    function nextState() {
                        // Shortcuts
                        var X = this._X;
                        var C = this._C;
                        // Save old counter values
                        for(var i = 0; i < 8; i++)C_[i] = C[i];
                        // Calculate new counter values
                        C[0] = C[0] + 0x4d34d34d + this._b | 0;
                        C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
                        C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
                        C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
                        C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
                        C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
                        C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
                        C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
                        this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
                        // Calculate the g-values
                        for(var i = 0; i < 8; i++){
                            var gx = X[i] + C[i];
                            // Construct high and low argument for squaring
                            var ga = gx & 0xffff;
                            var gb = gx >>> 16;
                            // Calculate high and low result of squaring
                            var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                            var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                            // High XOR low
                            G[i] = gh ^ gl;
                        }
                        // Calculate new state values
                        X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
                        X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
                        X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
                        X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
                        X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
                        X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
                        X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
                        X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
                    }
                    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
                })();
                /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
                    pad: function(data, blockSize) {
                        // Shortcut
                        var blockSizeBytes = blockSize * 4;
                        // Pad
                        data.clamp();
                        data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
                    },
                    unpad: function(data) {
                        // Shortcut
                        var dataWords = data.words;
                        // Unpad
                        var i = data.sigBytes - 1;
                        while(!(dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff))i--;
                        data.sigBytes = i + 1;
                    }
                };
                return CryptoJS;
            });
        },
        {}
    ],
    122: [
        function(require1, module, exports) {
            'use strict';
            var elliptic = exports;
            // hello ladies ;)
            function inherits(ctor, superCtor) {
                ctor.super_ = superCtor;
                var TempCtor = function() {};
                TempCtor.prototype = superCtor.prototype;
                ctor.prototype = new TempCtor();
                ctor.prototype.constructor = ctor;
            }
            elliptic.inherits = inherits;
            elliptic.version = '6.5.0';
            elliptic.utils = require1('./elliptic/utils');
            elliptic.curve = require1('./elliptic/curve');
            elliptic.curves = require1('./elliptic/curves');
            // Protocols
            elliptic.ec = require1('./elliptic/ec');
            elliptic.eddsa = require1('./elliptic/eddsa');
        },
        {
            "./elliptic/curve": 125,
            "./elliptic/curves": 128,
            "./elliptic/ec": 129,
            "./elliptic/eddsa": 132,
            "./elliptic/utils": 136
        }
    ],
    123: [
        function(require1, module, exports) {
            'use strict';
            var BN = require1('../../../../BN/bn');
            var elliptic = require1('../../elliptic');
            var utils = elliptic.utils;
            var getNAF = utils.getNAF;
            var getJSF = utils.getJSF;
            var assert = utils.assert;
            function BaseCurve(type, conf) {
                this.type = type;
                this.p = new BN(conf.p, 16);
                // Use Montgomery, when there is no fast reduction for the prime
                this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);
                // Useful for many curves
                this.zero = new BN(0).toRed(this.red);
                this.one = new BN(1).toRed(this.red);
                this.two = new BN(2).toRed(this.red);
                // Curve configuration, optional
                this.n = conf.n && new BN(conf.n, 16);
                this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
                // Temporary arrays
                this._wnafT1 = new Array(4);
                this._wnafT2 = new Array(4);
                this._wnafT3 = new Array(4);
                this._wnafT4 = new Array(4);
                // Generalized Greg Maxwell's trick
                var adjustCount = this.n && this.p.div(this.n);
                if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
                else {
                    this._maxwellTrick = true;
                    this.redN = this.n.toRed(this.red);
                }
            }
            module.exports = BaseCurve;
            BaseCurve.prototype.point = function point() {
                throw new Error('Not implemented');
            };
            BaseCurve.prototype.validate = function validate() {
                throw new Error('Not implemented');
            };
            BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
                assert(p.precomputed);
                var doubles = p._getDoubles();
                var naf = getNAF(k, 1);
                var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
                I /= 3;
                // Translate into more windowed form
                var repr = [];
                for(var j = 0; j < naf.length; j += doubles.step){
                    var nafW = 0;
                    for(var k = j + doubles.step - 1; k >= j; k--)nafW = (nafW << 1) + naf[k];
                    repr.push(nafW);
                }
                var a = this.jpoint(null, null, null);
                var b = this.jpoint(null, null, null);
                for(var i = I; i > 0; i--){
                    for(var j = 0; j < repr.length; j++){
                        var nafW = repr[j];
                        if (nafW === i) b = b.mixedAdd(doubles.points[j]);
                        else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
                    }
                    a = a.add(b);
                }
                return a.toP();
            };
            BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
                var w = 4;
                // Precompute window
                var nafPoints = p._getNAFPoints(w);
                w = nafPoints.wnd;
                var wnd = nafPoints.points;
                // Get NAF form
                var naf = getNAF(k, w);
                // Add `this`*(N+1) for every w-NAF index
                var acc = this.jpoint(null, null, null);
                for(var i = naf.length - 1; i >= 0; i--){
                    // Count zeroes
                    for(var k = 0; i >= 0 && naf[i] === 0; i--)k++;
                    if (i >= 0) k++;
                    acc = acc.dblp(k);
                    if (i < 0) break;
                    var z = naf[i];
                    assert(z !== 0);
                    if (p.type === 'affine') {
                        // J +- P
                        if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
                        else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
                    } else // J +- J
                    if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
                    else acc = acc.add(wnd[-z - 1 >> 1].neg());
                }
                return p.type === 'affine' ? acc.toP() : acc;
            };
            BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
                var wndWidth = this._wnafT1;
                var wnd = this._wnafT2;
                var naf = this._wnafT3;
                // Fill all arrays
                var max = 0;
                for(var i = 0; i < len; i++){
                    var p = points[i];
                    var nafPoints = p._getNAFPoints(defW);
                    wndWidth[i] = nafPoints.wnd;
                    wnd[i] = nafPoints.points;
                }
                // Comb small window NAFs
                for(var i = len - 1; i >= 1; i -= 2){
                    var a = i - 1;
                    var b = i;
                    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
                        naf[a] = getNAF(coeffs[a], wndWidth[a]);
                        naf[b] = getNAF(coeffs[b], wndWidth[b]);
                        max = Math.max(naf[a].length, max);
                        max = Math.max(naf[b].length, max);
                        continue;
                    }
                    var comb = [
                        points[a],
                        /* 1 */ null,
                        /* 3 */ null,
                        /* 5 */ points[b]
                    ];
                    // Try to avoid Projective points, if possible
                    if (points[a].y.cmp(points[b].y) === 0) {
                        comb[1] = points[a].add(points[b]);
                        comb[2] = points[a].toJ().mixedAdd(points[b].neg());
                    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
                        comb[1] = points[a].toJ().mixedAdd(points[b]);
                        comb[2] = points[a].add(points[b].neg());
                    } else {
                        comb[1] = points[a].toJ().mixedAdd(points[b]);
                        comb[2] = points[a].toJ().mixedAdd(points[b].neg());
                    }
                    var index = [
                        -3,
                        /* -1 -1 */ -1,
                        /* -1 0 */ -5,
                        /* -1 1 */ -7,
                        /* 0 -1 */ 0,
                        /* 0 0 */ 7,
                        /* 0 1 */ 5,
                        /* 1 -1 */ 1,
                        /* 1 0 */ 3 /* 1 1 */ 
                    ];
                    var jsf = getJSF(coeffs[a], coeffs[b]);
                    max = Math.max(jsf[0].length, max);
                    naf[a] = new Array(max);
                    naf[b] = new Array(max);
                    for(var j = 0; j < max; j++){
                        var ja = jsf[0][j] | 0;
                        var jb = jsf[1][j] | 0;
                        naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
                        naf[b][j] = 0;
                        wnd[a] = comb;
                    }
                }
                var acc = this.jpoint(null, null, null);
                var tmp = this._wnafT4;
                for(var i = max; i >= 0; i--){
                    var k = 0;
                    while(i >= 0){
                        var zero = true;
                        for(var j = 0; j < len; j++){
                            tmp[j] = naf[j][i] | 0;
                            if (tmp[j] !== 0) zero = false;
                        }
                        if (!zero) break;
                        k++;
                        i--;
                    }
                    if (i >= 0) k++;
                    acc = acc.dblp(k);
                    if (i < 0) break;
                    for(var j = 0; j < len; j++){
                        var z = tmp[j];
                        var p;
                        if (z === 0) continue;
                        else if (z > 0) p = wnd[j][z - 1 >> 1];
                        else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
                        if (p.type === 'affine') acc = acc.mixedAdd(p);
                        else acc = acc.add(p);
                    }
                }
                // Zeroify references
                for(var i = 0; i < len; i++)wnd[i] = null;
                if (jacobianResult) return acc;
                else return acc.toP();
            };
            function BasePoint(curve, type) {
                this.curve = curve;
                this.type = type;
                this.precomputed = null;
            }
            BaseCurve.BasePoint = BasePoint;
            BasePoint.prototype.eq = function eq() {
                throw new Error('Not implemented');
            };
            BasePoint.prototype.validate = function validate() {
                return this.curve.validate(this);
            };
            BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
                bytes = utils.toArray(bytes, enc);
                var len = this.p.byteLength();
                // uncompressed, hybrid-odd, hybrid-even
                if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
                    if (bytes[0] === 0x06) assert(bytes[bytes.length - 1] % 2 === 0);
                    else if (bytes[0] === 0x07) assert(bytes[bytes.length - 1] % 2 === 1);
                    var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
                    return res;
                } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
                throw new Error('Unknown point format');
            };
            BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
                return this.encode(enc, true);
            };
            BasePoint.prototype._encode = function _encode(compact) {
                var len = this.curve.p.byteLength();
                var x = this.getX().toArray('be', len);
                if (compact) return [
                    this.getY().isEven() ? 0x02 : 0x03
                ].concat(x);
                return [
                    0x04
                ].concat(x, this.getY().toArray('be', len));
            };
            BasePoint.prototype.encode = function encode(enc, compact) {
                return utils.encode(this._encode(compact), enc);
            };
            BasePoint.prototype.precompute = function precompute(power) {
                if (this.precomputed) return this;
                var precomputed = {
                    doubles: null,
                    naf: null,
                    beta: null
                };
                precomputed.naf = this._getNAFPoints(8);
                precomputed.doubles = this._getDoubles(4, power);
                precomputed.beta = this._getBeta();
                this.precomputed = precomputed;
                return this;
            };
            BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
                if (!this.precomputed) return false;
                var doubles = this.precomputed.doubles;
                if (!doubles) return false;
                return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
            };
            BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
                if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
                var doubles = [
                    this
                ];
                var acc = this;
                for(var i = 0; i < power; i += step){
                    for(var j = 0; j < step; j++)acc = acc.dbl();
                    doubles.push(acc);
                }
                return {
                    step: step,
                    points: doubles
                };
            };
            BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
                if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
                var res = [
                    this
                ];
                var max = (1 << wnd) - 1;
                var dbl = max === 1 ? null : this.dbl();
                for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
                return {
                    wnd: wnd,
                    points: res
                };
            };
            BasePoint.prototype._getBeta = function _getBeta() {
                return null;
            };
            BasePoint.prototype.dblp = function dblp(k) {
                var r = this;
                for(var i = 0; i < k; i++)r = r.dbl();
                return r;
            };
        },
        {
            "../../../../BN/bn": 120,
            "../../elliptic": 122
        }
    ],
    124: [
        function(require1, module, exports) {
            'use strict';
            var curve = require1('../curve');
            var elliptic = require1('../../elliptic');
            var BN = require1('../../../../BN/bn');
            var inherits = elliptic.inherits;
            var Base = curve.base;
            var assert = elliptic.utils.assert;
            function EdwardsCurve(conf) {
                // NOTE: Important as we are creating point in Base.call()
                this.twisted = (conf.a | 0) !== 1;
                this.mOneA = this.twisted && (conf.a | 0) === -1;
                this.extended = this.mOneA;
                Base.call(this, 'edwards', conf);
                this.a = new BN(conf.a, 16).umod(this.red.m);
                this.a = this.a.toRed(this.red);
                this.c = new BN(conf.c, 16).toRed(this.red);
                this.c2 = this.c.redSqr();
                this.d = new BN(conf.d, 16).toRed(this.red);
                this.dd = this.d.redAdd(this.d);
                assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
                this.oneC = (conf.c | 0) === 1;
            }
            inherits(EdwardsCurve, Base);
            module.exports = EdwardsCurve;
            EdwardsCurve.prototype._mulA = function _mulA(num) {
                if (this.mOneA) return num.redNeg();
                else return this.a.redMul(num);
            };
            EdwardsCurve.prototype._mulC = function _mulC(num) {
                if (this.oneC) return num;
                else return this.c.redMul(num);
            };
            // Just for compatibility with Short curve
            EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
                return this.point(x, y, z, t);
            };
            EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
                x = new BN(x, 16);
                if (!x.red) x = x.toRed(this.red);
                var x2 = x.redSqr();
                var rhs = this.c2.redSub(this.a.redMul(x2));
                var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
                var y2 = rhs.redMul(lhs.redInvm());
                var y = y2.redSqrt();
                if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
                var isOdd = y.fromRed().isOdd();
                if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
                return this.point(x, y);
            };
            EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
                y = new BN(y, 16);
                if (!y.red) y = y.toRed(this.red);
                // x^2 = (y^2 - 1) / (d y^2 + 1)
                var y2 = y.redSqr();
                var lhs = y2.redSub(this.one);
                var rhs = y2.redMul(this.d).redAdd(this.one);
                var x2 = lhs.redMul(rhs.redInvm());
                if (x2.cmp(this.zero) === 0) {
                    if (odd) throw new Error('invalid point');
                    else return this.point(this.zero, y);
                }
                var x = x2.redSqrt();
                if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
                if (x.isOdd() !== odd) x = x.redNeg();
                return this.point(x, y);
            };
            EdwardsCurve.prototype.validate = function validate(point) {
                if (point.isInfinity()) return true;
                // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
                point.normalize();
                var x2 = point.x.redSqr();
                var y2 = point.y.redSqr();
                var lhs = x2.redMul(this.a).redAdd(y2);
                var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
                return lhs.cmp(rhs) === 0;
            };
            function Point(curve, x, y, z, t) {
                Base.BasePoint.call(this, curve, 'projective');
                if (x === null && y === null && z === null) {
                    this.x = this.curve.zero;
                    this.y = this.curve.one;
                    this.z = this.curve.one;
                    this.t = this.curve.zero;
                    this.zOne = true;
                } else {
                    this.x = new BN(x, 16);
                    this.y = new BN(y, 16);
                    this.z = z ? new BN(z, 16) : this.curve.one;
                    this.t = t && new BN(t, 16);
                    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
                    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
                    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
                    if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
                    this.zOne = this.z === this.curve.one;
                    // Use extended coordinates
                    if (this.curve.extended && !this.t) {
                        this.t = this.x.redMul(this.y);
                        if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
                    }
                }
            }
            inherits(Point, Base.BasePoint);
            EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
                return Point.fromJSON(this, obj);
            };
            EdwardsCurve.prototype.point = function point(x, y, z, t) {
                return new Point(this, x, y, z, t);
            };
            Point.fromJSON = function fromJSON(curve, obj) {
                return new Point(curve, obj[0], obj[1], obj[2]);
            };
            Point.prototype.inspect = function inspect() {
                if (this.isInfinity()) return '<EC Point Infinity>';
                return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
            };
            Point.prototype.isInfinity = function isInfinity() {
                // XXX This code assumes that zero is always zero in red
                return this.x.cmpn(0) === 0 && this.y.cmp(this.z) === 0;
            };
            Point.prototype._extDbl = function _extDbl() {
                // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
                //     #doubling-dbl-2008-hwcd
                // 4M + 4S
                // A = X1^2
                var a = this.x.redSqr();
                // B = Y1^2
                var b = this.y.redSqr();
                // C = 2 * Z1^2
                var c = this.z.redSqr();
                c = c.redIAdd(c);
                // D = a * A
                var d = this.curve._mulA(a);
                // E = (X1 + Y1)^2 - A - B
                var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
                // G = D + B
                var g = d.redAdd(b);
                // F = G - C
                var f = g.redSub(c);
                // H = D - B
                var h = d.redSub(b);
                // X3 = E * F
                var nx = e.redMul(f);
                // Y3 = G * H
                var ny = g.redMul(h);
                // T3 = E * H
                var nt = e.redMul(h);
                // Z3 = F * G
                var nz = f.redMul(g);
                return this.curve.point(nx, ny, nz, nt);
            };
            Point.prototype._projDbl = function _projDbl() {
                // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
                //     #doubling-dbl-2008-bbjlp
                //     #doubling-dbl-2007-bl
                // and others
                // Generally 3M + 4S or 2M + 4S
                // B = (X1 + Y1)^2
                var b = this.x.redAdd(this.y).redSqr();
                // C = X1^2
                var c = this.x.redSqr();
                // D = Y1^2
                var d = this.y.redSqr();
                var nx;
                var ny;
                var nz;
                if (this.curve.twisted) {
                    // E = a * C
                    var e = this.curve._mulA(c);
                    // F = E + D
                    var f = e.redAdd(d);
                    if (this.zOne) {
                        // X3 = (B - C - D) * (F - 2)
                        nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
                        // Y3 = F * (E - D)
                        ny = f.redMul(e.redSub(d));
                        // Z3 = F^2 - 2 * F
                        nz = f.redSqr().redSub(f).redSub(f);
                    } else {
                        // H = Z1^2
                        var h = this.z.redSqr();
                        // J = F - 2 * H
                        var j = f.redSub(h).redISub(h);
                        // X3 = (B-C-D)*J
                        nx = b.redSub(c).redISub(d).redMul(j);
                        // Y3 = F * (E - D)
                        ny = f.redMul(e.redSub(d));
                        // Z3 = F * J
                        nz = f.redMul(j);
                    }
                } else {
                    // E = C + D
                    var e = c.redAdd(d);
                    // H = (c * Z1)^2
                    var h = this.curve._mulC(this.c.redMul(this.z)).redSqr();
                    // J = E - 2 * H
                    var j = e.redSub(h).redSub(h);
                    // X3 = c * (B - E) * J
                    nx = this.curve._mulC(b.redISub(e)).redMul(j);
                    // Y3 = c * E * (C - D)
                    ny = this.curve._mulC(e).redMul(c.redISub(d));
                    // Z3 = E * J
                    nz = e.redMul(j);
                }
                return this.curve.point(nx, ny, nz);
            };
            Point.prototype.dbl = function dbl() {
                if (this.isInfinity()) return this;
                // Double in extended coordinates
                if (this.curve.extended) return this._extDbl();
                else return this._projDbl();
            };
            Point.prototype._extAdd = function _extAdd(p) {
                // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
                //     #addition-add-2008-hwcd-3
                // 8M
                // A = (Y1 - X1) * (Y2 - X2)
                var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
                // B = (Y1 + X1) * (Y2 + X2)
                var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
                // C = T1 * k * T2
                var c = this.t.redMul(this.curve.dd).redMul(p.t);
                // D = Z1 * 2 * Z2
                var d = this.z.redMul(p.z.redAdd(p.z));
                // E = B - A
                var e = b.redSub(a);
                // F = D - C
                var f = d.redSub(c);
                // G = D + C
                var g = d.redAdd(c);
                // H = B + A
                var h = b.redAdd(a);
                // X3 = E * F
                var nx = e.redMul(f);
                // Y3 = G * H
                var ny = g.redMul(h);
                // T3 = E * H
                var nt = e.redMul(h);
                // Z3 = F * G
                var nz = f.redMul(g);
                return this.curve.point(nx, ny, nz, nt);
            };
            Point.prototype._projAdd = function _projAdd(p) {
                // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
                //     #addition-add-2008-bbjlp
                //     #addition-add-2007-bl
                // 10M + 1S
                // A = Z1 * Z2
                var a = this.z.redMul(p.z);
                // B = A^2
                var b = a.redSqr();
                // C = X1 * X2
                var c = this.x.redMul(p.x);
                // D = Y1 * Y2
                var d = this.y.redMul(p.y);
                // E = d * C * D
                var e = this.curve.d.redMul(c).redMul(d);
                // F = B - E
                var f = b.redSub(e);
                // G = B + E
                var g = b.redAdd(e);
                // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
                var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
                var nx = a.redMul(f).redMul(tmp);
                var ny;
                var nz;
                if (this.curve.twisted) {
                    // Y3 = A * G * (D - a * C)
                    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
                    // Z3 = F * G
                    nz = f.redMul(g);
                } else {
                    // Y3 = A * G * (D - C)
                    ny = a.redMul(g).redMul(d.redSub(c));
                    // Z3 = c * F * G
                    nz = this.curve._mulC(f).redMul(g);
                }
                return this.curve.point(nx, ny, nz);
            };
            Point.prototype.add = function add(p) {
                if (this.isInfinity()) return p;
                if (p.isInfinity()) return this;
                if (this.curve.extended) return this._extAdd(p);
                else return this._projAdd(p);
            };
            Point.prototype.mul = function mul(k) {
                if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
                else return this.curve._wnafMul(this, k);
            };
            Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
                return this.curve._wnafMulAdd(1, [
                    this,
                    p
                ], [
                    k1,
                    k2
                ], 2, false);
            };
            Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
                return this.curve._wnafMulAdd(1, [
                    this,
                    p
                ], [
                    k1,
                    k2
                ], 2, true);
            };
            Point.prototype.normalize = function normalize() {
                if (this.zOne) return this;
                // Normalize coordinates
                var zi = this.z.redInvm();
                this.x = this.x.redMul(zi);
                this.y = this.y.redMul(zi);
                if (this.t) this.t = this.t.redMul(zi);
                this.z = this.curve.one;
                this.zOne = true;
                return this;
            };
            Point.prototype.neg = function neg() {
                return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
            };
            Point.prototype.getX = function getX() {
                this.normalize();
                return this.x.fromRed();
            };
            Point.prototype.getY = function getY() {
                this.normalize();
                return this.y.fromRed();
            };
            Point.prototype.eq = function eq(other) {
                return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
            };
            Point.prototype.eqXToP = function eqXToP(x) {
                var rx = x.toRed(this.curve.red).redMul(this.z);
                if (this.x.cmp(rx) === 0) return true;
                var xc = x.clone();
                var t = this.curve.redN.redMul(this.z);
                for(;;){
                    xc.iadd(this.curve.n);
                    if (xc.cmp(this.curve.p) >= 0) return false;
                    rx.redIAdd(t);
                    if (this.x.cmp(rx) === 0) return true;
                }
                return false;
            };
            // Compatibility with BaseCurve
            Point.prototype.toP = Point.prototype.normalize;
            Point.prototype.mixedAdd = Point.prototype.add;
        },
        {
            "../../../../BN/bn": 120,
            "../../elliptic": 122,
            "../curve": 125
        }
    ],
    125: [
        function(require1, module, exports) {
            'use strict';
            var curve = exports;
            curve.base = require1('./base');
            curve.short = require1('./short');
            curve.mont = require1('./mont');
            curve.edwards = require1('./edwards');
        },
        {
            "./base": 123,
            "./edwards": 124,
            "./mont": 126,
            "./short": 127
        }
    ],
    126: [
        function(require1, module, exports) {
            'use strict';
            var curve = require1('../curve');
            var BN = require1('../../../../BN/bn');
            var inherits = require1('../../elliptic').inherits;
            var Base = curve.base;
            var elliptic = require1('../../elliptic');
            var utils = elliptic.utils;
            function MontCurve(conf) {
                Base.call(this, 'mont', conf);
                this.a = new BN(conf.a, 16).toRed(this.red);
                this.b = new BN(conf.b, 16).toRed(this.red);
                this.i4 = new BN(4).toRed(this.red).redInvm();
                this.two = new BN(2).toRed(this.red);
                this.a24 = this.i4.redMul(this.a.redAdd(this.two));
            }
            inherits(MontCurve, Base);
            module.exports = MontCurve;
            MontCurve.prototype.validate = function validate(point) {
                var x = point.normalize().x;
                var x2 = x.redSqr();
                var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
                var y = rhs.redSqrt();
                return y.redSqr().cmp(rhs) === 0;
            };
            function Point(curve, x, z) {
                Base.BasePoint.call(this, curve, 'projective');
                if (x === null && z === null) {
                    this.x = this.curve.one;
                    this.z = this.curve.zero;
                } else {
                    this.x = new BN(x, 16);
                    this.z = new BN(z, 16);
                    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
                    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
                }
            }
            inherits(Point, Base.BasePoint);
            MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
                return this.point(utils.toArray(bytes, enc), 1);
            };
            MontCurve.prototype.point = function point(x, z) {
                return new Point(this, x, z);
            };
            MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
                return Point.fromJSON(this, obj);
            };
            Point.prototype.precompute = function precompute() {
            // No-op
            };
            Point.prototype._encode = function _encode() {
                return this.getX().toArray('be', this.curve.p.byteLength());
            };
            Point.fromJSON = function fromJSON(curve, obj) {
                return new Point(curve, obj[0], obj[1] || curve.one);
            };
            Point.prototype.inspect = function inspect() {
                if (this.isInfinity()) return '<EC Point Infinity>';
                return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
            };
            Point.prototype.isInfinity = function isInfinity() {
                // XXX This code assumes that zero is always zero in red
                return this.z.cmpn(0) === 0;
            };
            Point.prototype.dbl = function dbl() {
                // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
                // 2M + 2S + 4A
                // A = X1 + Z1
                var a = this.x.redAdd(this.z);
                // AA = A^2
                var aa = a.redSqr();
                // B = X1 - Z1
                var b = this.x.redSub(this.z);
                // BB = B^2
                var bb = b.redSqr();
                // C = AA - BB
                var c = aa.redSub(bb);
                // X3 = AA * BB
                var nx = aa.redMul(bb);
                // Z3 = C * (BB + A24 * C)
                var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
                return this.curve.point(nx, nz);
            };
            Point.prototype.add = function add() {
                throw new Error('Not supported on Montgomery curve');
            };
            Point.prototype.diffAdd = function diffAdd(p, diff) {
                // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
                // 4M + 2S + 6A
                // A = X2 + Z2
                var a = this.x.redAdd(this.z);
                // B = X2 - Z2
                var b = this.x.redSub(this.z);
                // C = X3 + Z3
                var c = p.x.redAdd(p.z);
                // D = X3 - Z3
                var d = p.x.redSub(p.z);
                // DA = D * A
                var da = d.redMul(a);
                // CB = C * B
                var cb = c.redMul(b);
                // X5 = Z1 * (DA + CB)^2
                var nx = diff.z.redMul(da.redAdd(cb).redSqr());
                // Z5 = X1 * (DA - CB)^2
                var nz = diff.x.redMul(da.redISub(cb).redSqr());
                return this.curve.point(nx, nz);
            };
            Point.prototype.mul = function mul(k) {
                var t = k.clone();
                var a = this; // (N / 2) * Q + Q
                var b = this.curve.point(null, null); // (N / 2) * Q
                var c = this; // Q
                for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
                for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
                    // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
                    a = a.diffAdd(b, c);
                    // N * Q = 2 * ((N / 2) * Q + Q))
                    b = b.dbl();
                } else {
                    // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
                    b = a.diffAdd(b, c);
                    // N * Q + Q = 2 * ((N / 2) * Q + Q)
                    a = a.dbl();
                }
                return b;
            };
            Point.prototype.mulAdd = function mulAdd() {
                throw new Error('Not supported on Montgomery curve');
            };
            Point.prototype.jumlAdd = function jumlAdd() {
                throw new Error('Not supported on Montgomery curve');
            };
            Point.prototype.eq = function eq(other) {
                return this.getX().cmp(other.getX()) === 0;
            };
            Point.prototype.normalize = function normalize() {
                this.x = this.x.redMul(this.z.redInvm());
                this.z = this.curve.one;
                return this;
            };
            Point.prototype.getX = function getX() {
                // Normalize coordinates
                this.normalize();
                return this.x.fromRed();
            };
        },
        {
            "../../../../BN/bn": 120,
            "../../elliptic": 122,
            "../curve": 125
        }
    ],
    127: [
        function(require1, module, exports) {
            'use strict';
            var curve = require1('../curve');
            var elliptic = require1('../../elliptic');
            var BN = require1('../../../../BN/bn');
            var inherits = elliptic.inherits;
            var Base = curve.base;
            var assert = elliptic.utils.assert;
            function ShortCurve(conf) {
                Base.call(this, 'short', conf);
                this.a = new BN(conf.a, 16).toRed(this.red);
                this.b = new BN(conf.b, 16).toRed(this.red);
                this.tinv = this.two.redInvm();
                this.zeroA = this.a.fromRed().cmpn(0) === 0;
                this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
                // If the curve is endomorphic, precalculate beta and lambda
                this.endo = this._getEndomorphism(conf);
                this._endoWnafT1 = new Array(4);
                this._endoWnafT2 = new Array(4);
            }
            inherits(ShortCurve, Base);
            module.exports = ShortCurve;
            ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
                // No efficient endomorphism
                if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
                // Compute beta and lambda, that lambda * P = (beta * Px; Py)
                var beta;
                var lambda;
                if (conf.beta) beta = new BN(conf.beta, 16).toRed(this.red);
                else {
                    var betas = this._getEndoRoots(this.p);
                    // Choose the smallest beta
                    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
                    beta = beta.toRed(this.red);
                }
                if (conf.lambda) lambda = new BN(conf.lambda, 16);
                else {
                    // Choose the lambda that is matching selected beta
                    var lambdas = this._getEndoRoots(this.n);
                    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
                    else {
                        lambda = lambdas[1];
                        assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
                    }
                }
                // Get basis vectors, used for balanced length-two representation
                var basis;
                if (conf.basis) basis = conf.basis.map(function(vec) {
                    return {
                        a: new BN(vec.a, 16),
                        b: new BN(vec.b, 16)
                    };
                });
                else basis = this._getEndoBasis(lambda);
                return {
                    beta: beta,
                    lambda: lambda,
                    basis: basis
                };
            };
            ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
                // Find roots of for x^2 + x + 1 in F
                // Root = (-1 +- Sqrt(-3)) / 2
                //
                var red = num === this.p ? this.red : BN.mont(num);
                var tinv = new BN(2).toRed(red).redInvm();
                var ntinv = tinv.redNeg();
                var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);
                var l1 = ntinv.redAdd(s).fromRed();
                var l2 = ntinv.redSub(s).fromRed();
                return [
                    l1,
                    l2
                ];
            };
            ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
                // aprxSqrt >= sqrt(this.n)
                var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
                // 3.74
                // Run EGCD, until r(L + 1) < aprxSqrt
                var u = lambda;
                var v = this.n.clone();
                var x1 = new BN(1);
                var y1 = new BN(0);
                var x2 = new BN(0);
                var y2 = new BN(1);
                // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
                var a0;
                var b0;
                // First vector
                var a1;
                var b1;
                // Second vector
                var a2;
                var b2;
                var prevR;
                var i = 0;
                var r;
                var x;
                while(u.cmpn(0) !== 0){
                    var q = v.div(u);
                    r = v.sub(q.mul(u));
                    x = x2.sub(q.mul(x1));
                    var y = y2.sub(q.mul(y1));
                    if (!a1 && r.cmp(aprxSqrt) < 0) {
                        a0 = prevR.neg();
                        b0 = x1;
                        a1 = r.neg();
                        b1 = x;
                    } else if (a1 && ++i === 2) break;
                    prevR = r;
                    v = u;
                    u = r;
                    x2 = x1;
                    x1 = x;
                    y2 = y1;
                    y1 = y;
                }
                a2 = r.neg();
                b2 = x;
                var len1 = a1.sqr().add(b1.sqr());
                var len2 = a2.sqr().add(b2.sqr());
                if (len2.cmp(len1) >= 0) {
                    a2 = a0;
                    b2 = b0;
                }
                // Normalize signs
                if (a1.negative) {
                    a1 = a1.neg();
                    b1 = b1.neg();
                }
                if (a2.negative) {
                    a2 = a2.neg();
                    b2 = b2.neg();
                }
                return [
                    {
                        a: a1,
                        b: b1
                    },
                    {
                        a: a2,
                        b: b2
                    }
                ];
            };
            ShortCurve.prototype._endoSplit = function _endoSplit(k) {
                var basis = this.endo.basis;
                var v1 = basis[0];
                var v2 = basis[1];
                var c1 = v2.b.mul(k).divRound(this.n);
                var c2 = v1.b.neg().mul(k).divRound(this.n);
                var p1 = c1.mul(v1.a);
                var p2 = c2.mul(v2.a);
                var q1 = c1.mul(v1.b);
                var q2 = c2.mul(v2.b);
                // Calculate answer
                var k1 = k.sub(p1).sub(p2);
                var k2 = q1.add(q2).neg();
                return {
                    k1: k1,
                    k2: k2
                };
            };
            ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
                x = new BN(x, 16);
                if (!x.red) x = x.toRed(this.red);
                var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
                var y = y2.redSqrt();
                if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
                // XXX Is there any way to tell if the number is odd without converting it
                // to non-red form?
                var isOdd = y.fromRed().isOdd();
                if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
                return this.point(x, y);
            };
            ShortCurve.prototype.validate = function validate(point) {
                if (point.inf) return true;
                var x = point.x;
                var y = point.y;
                var ax = this.a.redMul(x);
                var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
                return y.redSqr().redISub(rhs).cmpn(0) === 0;
            };
            ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
                var npoints = this._endoWnafT1;
                var ncoeffs = this._endoWnafT2;
                for(var i = 0; i < points.length; i++){
                    var split = this._endoSplit(coeffs[i]);
                    var p = points[i];
                    var beta = p._getBeta();
                    if (split.k1.negative) {
                        split.k1.ineg();
                        p = p.neg(true);
                    }
                    if (split.k2.negative) {
                        split.k2.ineg();
                        beta = beta.neg(true);
                    }
                    npoints[i * 2] = p;
                    npoints[i * 2 + 1] = beta;
                    ncoeffs[i * 2] = split.k1;
                    ncoeffs[i * 2 + 1] = split.k2;
                }
                var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
                // Clean-up references to points and coefficients
                for(var j = 0; j < i * 2; j++){
                    npoints[j] = null;
                    ncoeffs[j] = null;
                }
                return res;
            };
            function Point(curve, x, y, isRed) {
                Base.BasePoint.call(this, curve, 'affine');
                if (x === null && y === null) {
                    this.x = null;
                    this.y = null;
                    this.inf = true;
                } else {
                    this.x = new BN(x, 16);
                    this.y = new BN(y, 16);
                    // Force redgomery representation when loading from JSON
                    if (isRed) {
                        this.x.forceRed(this.curve.red);
                        this.y.forceRed(this.curve.red);
                    }
                    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
                    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
                    this.inf = false;
                }
            }
            inherits(Point, Base.BasePoint);
            ShortCurve.prototype.point = function point(x, y, isRed) {
                return new Point(this, x, y, isRed);
            };
            ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
                return Point.fromJSON(this, obj, red);
            };
            Point.prototype._getBeta = function _getBeta() {
                if (!this.curve.endo) return;
                var pre = this.precomputed;
                if (pre && pre.beta) return pre.beta;
                var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
                if (pre) {
                    var curve = this.curve;
                    var endoMul = function(p) {
                        return curve.point(p.x.redMul(curve.endo.beta), p.y);
                    };
                    pre.beta = beta;
                    beta.precomputed = {
                        beta: null,
                        naf: pre.naf && {
                            wnd: pre.naf.wnd,
                            points: pre.naf.points.map(endoMul)
                        },
                        doubles: pre.doubles && {
                            step: pre.doubles.step,
                            points: pre.doubles.points.map(endoMul)
                        }
                    };
                }
                return beta;
            };
            Point.prototype.toJSON = function toJSON() {
                if (!this.precomputed) return [
                    this.x,
                    this.y
                ];
                return [
                    this.x,
                    this.y,
                    this.precomputed && {
                        doubles: this.precomputed.doubles && {
                            step: this.precomputed.doubles.step,
                            points: this.precomputed.doubles.points.slice(1)
                        },
                        naf: this.precomputed.naf && {
                            wnd: this.precomputed.naf.wnd,
                            points: this.precomputed.naf.points.slice(1)
                        }
                    }
                ];
            };
            Point.fromJSON = function fromJSON(curve, obj, red) {
                if (typeof obj === 'string') obj = JSON.parse(obj);
                var res = curve.point(obj[0], obj[1], red);
                if (!obj[2]) return res;
                function obj2point(obj) {
                    return curve.point(obj[0], obj[1], red);
                }
                var pre = obj[2];
                res.precomputed = {
                    beta: null,
                    doubles: pre.doubles && {
                        step: pre.doubles.step,
                        points: [
                            res
                        ].concat(pre.doubles.points.map(obj2point))
                    },
                    naf: pre.naf && {
                        wnd: pre.naf.wnd,
                        points: [
                            res
                        ].concat(pre.naf.points.map(obj2point))
                    }
                };
                return res;
            };
            Point.prototype.inspect = function inspect() {
                if (this.isInfinity()) return '<EC Point Infinity>';
                return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
            };
            Point.prototype.isInfinity = function isInfinity() {
                return this.inf;
            };
            Point.prototype.add = function add(p) {
                // O + P = P
                if (this.inf) return p;
                // P + O = P
                if (p.inf) return this;
                // P + P = 2P
                if (this.eq(p)) return this.dbl();
                // P + (-P) = O
                if (this.neg().eq(p)) return this.curve.point(null, null);
                // P + Q = O
                if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
                var c = this.y.redSub(p.y);
                if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
                var nx = c.redSqr().redISub(this.x).redISub(p.x);
                var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
                return this.curve.point(nx, ny);
            };
            Point.prototype.dbl = function dbl() {
                if (this.inf) return this;
                // 2P = O
                var ys1 = this.y.redAdd(this.y);
                if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
                var a = this.curve.a;
                var x2 = this.x.redSqr();
                var dyinv = ys1.redInvm();
                var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
                var nx = c.redSqr().redISub(this.x.redAdd(this.x));
                var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
                return this.curve.point(nx, ny);
            };
            Point.prototype.getX = function getX() {
                return this.x.fromRed();
            };
            Point.prototype.getY = function getY() {
                return this.y.fromRed();
            };
            Point.prototype.mul = function mul(k) {
                k = new BN(k, 16);
                if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
                else if (this.curve.endo) return this.curve._endoWnafMulAdd([
                    this
                ], [
                    k
                ]);
                else return this.curve._wnafMul(this, k);
            };
            Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
                var points = [
                    this,
                    p2
                ];
                var coeffs = [
                    k1,
                    k2
                ];
                if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
                else return this.curve._wnafMulAdd(1, points, coeffs, 2);
            };
            Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
                var points = [
                    this,
                    p2
                ];
                var coeffs = [
                    k1,
                    k2
                ];
                if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
                else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
            };
            Point.prototype.eq = function eq(p) {
                return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
            };
            Point.prototype.neg = function neg(_precompute) {
                if (this.inf) return this;
                var res = this.curve.point(this.x, this.y.redNeg());
                if (_precompute && this.precomputed) {
                    var pre = this.precomputed;
                    var negate = function(p) {
                        return p.neg();
                    };
                    res.precomputed = {
                        naf: pre.naf && {
                            wnd: pre.naf.wnd,
                            points: pre.naf.points.map(negate)
                        },
                        doubles: pre.doubles && {
                            step: pre.doubles.step,
                            points: pre.doubles.points.map(negate)
                        }
                    };
                }
                return res;
            };
            Point.prototype.toJ = function toJ() {
                if (this.inf) return this.curve.jpoint(null, null, null);
                var res = this.curve.jpoint(this.x, this.y, this.curve.one);
                return res;
            };
            function JPoint(curve, x, y, z) {
                Base.BasePoint.call(this, curve, 'jacobian');
                if (x === null && y === null && z === null) {
                    this.x = this.curve.one;
                    this.y = this.curve.one;
                    this.z = new BN(0);
                } else {
                    this.x = new BN(x, 16);
                    this.y = new BN(y, 16);
                    this.z = new BN(z, 16);
                }
                if (!this.x.red) this.x = this.x.toRed(this.curve.red);
                if (!this.y.red) this.y = this.y.toRed(this.curve.red);
                if (!this.z.red) this.z = this.z.toRed(this.curve.red);
                this.zOne = this.z === this.curve.one;
            }
            inherits(JPoint, Base.BasePoint);
            ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
                return new JPoint(this, x, y, z);
            };
            JPoint.prototype.toP = function toP() {
                if (this.isInfinity()) return this.curve.point(null, null);
                var zinv = this.z.redInvm();
                var zinv2 = zinv.redSqr();
                var ax = this.x.redMul(zinv2);
                var ay = this.y.redMul(zinv2).redMul(zinv);
                return this.curve.point(ax, ay);
            };
            JPoint.prototype.neg = function neg() {
                return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
            };
            JPoint.prototype.add = function add(p) {
                // O + P = P
                if (this.isInfinity()) return p;
                // P + O = P
                if (p.isInfinity()) return this;
                // 12M + 4S + 7A
                var pz2 = p.z.redSqr();
                var z2 = this.z.redSqr();
                var u1 = this.x.redMul(pz2);
                var u2 = p.x.redMul(z2);
                var s1 = this.y.redMul(pz2.redMul(p.z));
                var s2 = p.y.redMul(z2.redMul(this.z));
                var h = u1.redSub(u2);
                var r = s1.redSub(s2);
                if (h.cmpn(0) === 0) {
                    if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
                    else return this.dbl();
                }
                var h2 = h.redSqr();
                var h3 = h2.redMul(h);
                var v = u1.redMul(h2);
                var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
                var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
                var nz = this.z.redMul(p.z).redMul(h);
                return this.curve.jpoint(nx, ny, nz);
            };
            JPoint.prototype.mixedAdd = function mixedAdd(p) {
                // O + P = P
                if (this.isInfinity()) return p.toJ();
                // P + O = P
                if (p.isInfinity()) return this;
                // 8M + 3S + 7A
                var z2 = this.z.redSqr();
                var u1 = this.x;
                var u2 = p.x.redMul(z2);
                var s1 = this.y;
                var s2 = p.y.redMul(z2).redMul(this.z);
                var h = u1.redSub(u2);
                var r = s1.redSub(s2);
                if (h.cmpn(0) === 0) {
                    if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
                    else return this.dbl();
                }
                var h2 = h.redSqr();
                var h3 = h2.redMul(h);
                var v = u1.redMul(h2);
                var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
                var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
                var nz = this.z.redMul(h);
                return this.curve.jpoint(nx, ny, nz);
            };
            JPoint.prototype.dblp = function dblp(pow) {
                if (pow === 0) return this;
                if (this.isInfinity()) return this;
                if (!pow) return this.dbl();
                if (this.curve.zeroA || this.curve.threeA) {
                    var r = this;
                    for(var i = 0; i < pow; i++)r = r.dbl();
                    return r;
                }
                // 1M + 2S + 1A + N * (4S + 5M + 8A)
                // N = 1 => 6M + 6S + 9A
                var a = this.curve.a;
                var tinv = this.curve.tinv;
                var jx = this.x;
                var jy = this.y;
                var jz = this.z;
                var jz4 = jz.redSqr().redSqr();
                // Reuse results
                var jyd = jy.redAdd(jy);
                for(var i = 0; i < pow; i++){
                    var jx2 = jx.redSqr();
                    var jyd2 = jyd.redSqr();
                    var jyd4 = jyd2.redSqr();
                    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
                    var t1 = jx.redMul(jyd2);
                    var nx = c.redSqr().redISub(t1.redAdd(t1));
                    var t2 = t1.redISub(nx);
                    var dny = c.redMul(t2);
                    dny = dny.redIAdd(dny).redISub(jyd4);
                    var nz = jyd.redMul(jz);
                    if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
                    jx = nx;
                    jz = nz;
                    jyd = dny;
                }
                return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
            };
            JPoint.prototype.dbl = function dbl() {
                if (this.isInfinity()) return this;
                if (this.curve.zeroA) return this._zeroDbl();
                else if (this.curve.threeA) return this._threeDbl();
                else return this._dbl();
            };
            JPoint.prototype._zeroDbl = function _zeroDbl() {
                var nx;
                var ny;
                var nz;
                // Z = 1
                if (this.zOne) {
                    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
                    //     #doubling-mdbl-2007-bl
                    // 1M + 5S + 14A
                    // XX = X1^2
                    var xx = this.x.redSqr();
                    // YY = Y1^2
                    var yy = this.y.redSqr();
                    // YYYY = YY^2
                    var yyyy = yy.redSqr();
                    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
                    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
                    s = s.redIAdd(s);
                    // M = 3 * XX + a; a = 0
                    var m = xx.redAdd(xx).redIAdd(xx);
                    // T = M ^ 2 - 2*S
                    var t = m.redSqr().redISub(s).redISub(s);
                    // 8 * YYYY
                    var yyyy8 = yyyy.redIAdd(yyyy);
                    yyyy8 = yyyy8.redIAdd(yyyy8);
                    yyyy8 = yyyy8.redIAdd(yyyy8);
                    // X3 = T
                    nx = t;
                    // Y3 = M * (S - T) - 8 * YYYY
                    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
                    // Z3 = 2*Y1
                    nz = this.y.redAdd(this.y);
                } else {
                    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
                    //     #doubling-dbl-2009-l
                    // 2M + 5S + 13A
                    // A = X1^2
                    var a = this.x.redSqr();
                    // B = Y1^2
                    var b = this.y.redSqr();
                    // C = B^2
                    var c = b.redSqr();
                    // D = 2 * ((X1 + B)^2 - A - C)
                    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
                    d = d.redIAdd(d);
                    // E = 3 * A
                    var e = a.redAdd(a).redIAdd(a);
                    // F = E^2
                    var f = e.redSqr();
                    // 8 * C
                    var c8 = c.redIAdd(c);
                    c8 = c8.redIAdd(c8);
                    c8 = c8.redIAdd(c8);
                    // X3 = F - 2 * D
                    nx = f.redISub(d).redISub(d);
                    // Y3 = E * (D - X3) - 8 * C
                    ny = e.redMul(d.redISub(nx)).redISub(c8);
                    // Z3 = 2 * Y1 * Z1
                    nz = this.y.redMul(this.z);
                    nz = nz.redIAdd(nz);
                }
                return this.curve.jpoint(nx, ny, nz);
            };
            JPoint.prototype._threeDbl = function _threeDbl() {
                var nx;
                var ny;
                var nz;
                // Z = 1
                if (this.zOne) {
                    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
                    //     #doubling-mdbl-2007-bl
                    // 1M + 5S + 15A
                    // XX = X1^2
                    var xx = this.x.redSqr();
                    // YY = Y1^2
                    var yy = this.y.redSqr();
                    // YYYY = YY^2
                    var yyyy = yy.redSqr();
                    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
                    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
                    s = s.redIAdd(s);
                    // M = 3 * XX + a
                    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
                    // T = M^2 - 2 * S
                    var t = m.redSqr().redISub(s).redISub(s);
                    // X3 = T
                    nx = t;
                    // Y3 = M * (S - T) - 8 * YYYY
                    var yyyy8 = yyyy.redIAdd(yyyy);
                    yyyy8 = yyyy8.redIAdd(yyyy8);
                    yyyy8 = yyyy8.redIAdd(yyyy8);
                    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
                    // Z3 = 2 * Y1
                    nz = this.y.redAdd(this.y);
                } else {
                    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
                    // 3M + 5S
                    // delta = Z1^2
                    var delta = this.z.redSqr();
                    // gamma = Y1^2
                    var gamma = this.y.redSqr();
                    // beta = X1 * gamma
                    var beta = this.x.redMul(gamma);
                    // alpha = 3 * (X1 - delta) * (X1 + delta)
                    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
                    alpha = alpha.redAdd(alpha).redIAdd(alpha);
                    // X3 = alpha^2 - 8 * beta
                    var beta4 = beta.redIAdd(beta);
                    beta4 = beta4.redIAdd(beta4);
                    var beta8 = beta4.redAdd(beta4);
                    nx = alpha.redSqr().redISub(beta8);
                    // Z3 = (Y1 + Z1)^2 - gamma - delta
                    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
                    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
                    var ggamma8 = gamma.redSqr();
                    ggamma8 = ggamma8.redIAdd(ggamma8);
                    ggamma8 = ggamma8.redIAdd(ggamma8);
                    ggamma8 = ggamma8.redIAdd(ggamma8);
                    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
                }
                return this.curve.jpoint(nx, ny, nz);
            };
            JPoint.prototype._dbl = function _dbl() {
                var a = this.curve.a;
                // 4M + 6S + 10A
                var jx = this.x;
                var jy = this.y;
                var jz = this.z;
                var jz4 = jz.redSqr().redSqr();
                var jx2 = jx.redSqr();
                var jy2 = jy.redSqr();
                var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
                var jxd4 = jx.redAdd(jx);
                jxd4 = jxd4.redIAdd(jxd4);
                var t1 = jxd4.redMul(jy2);
                var nx = c.redSqr().redISub(t1.redAdd(t1));
                var t2 = t1.redISub(nx);
                var jyd8 = jy2.redSqr();
                jyd8 = jyd8.redIAdd(jyd8);
                jyd8 = jyd8.redIAdd(jyd8);
                jyd8 = jyd8.redIAdd(jyd8);
                var ny = c.redMul(t2).redISub(jyd8);
                var nz = jy.redAdd(jy).redMul(jz);
                return this.curve.jpoint(nx, ny, nz);
            };
            JPoint.prototype.trpl = function trpl() {
                if (!this.curve.zeroA) return this.dbl().add(this);
                // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
                // 5M + 10S + ...
                // XX = X1^2
                var xx = this.x.redSqr();
                // YY = Y1^2
                var yy = this.y.redSqr();
                // ZZ = Z1^2
                var zz = this.z.redSqr();
                // YYYY = YY^2
                var yyyy = yy.redSqr();
                // M = 3 * XX + a * ZZ2; a = 0
                var m = xx.redAdd(xx).redIAdd(xx);
                // MM = M^2
                var mm = m.redSqr();
                // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
                var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
                e = e.redIAdd(e);
                e = e.redAdd(e).redIAdd(e);
                e = e.redISub(mm);
                // EE = E^2
                var ee = e.redSqr();
                // T = 16*YYYY
                var t = yyyy.redIAdd(yyyy);
                t = t.redIAdd(t);
                t = t.redIAdd(t);
                t = t.redIAdd(t);
                // U = (M + E)^2 - MM - EE - T
                var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
                // X3 = 4 * (X1 * EE - 4 * YY * U)
                var yyu4 = yy.redMul(u);
                yyu4 = yyu4.redIAdd(yyu4);
                yyu4 = yyu4.redIAdd(yyu4);
                var nx = this.x.redMul(ee).redISub(yyu4);
                nx = nx.redIAdd(nx);
                nx = nx.redIAdd(nx);
                // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
                var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
                ny = ny.redIAdd(ny);
                ny = ny.redIAdd(ny);
                ny = ny.redIAdd(ny);
                // Z3 = (Z1 + E)^2 - ZZ - EE
                var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
                return this.curve.jpoint(nx, ny, nz);
            };
            JPoint.prototype.mul = function mul(k, kbase) {
                k = new BN(k, kbase);
                return this.curve._wnafMul(this, k);
            };
            JPoint.prototype.eq = function eq(p) {
                if (p.type === 'affine') return this.eq(p.toJ());
                if (this === p) return true;
                // x1 * z2^2 == x2 * z1^2
                var z2 = this.z.redSqr();
                var pz2 = p.z.redSqr();
                if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
                // y1 * z2^3 == y2 * z1^3
                var z3 = z2.redMul(this.z);
                var pz3 = pz2.redMul(p.z);
                return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
            };
            JPoint.prototype.eqXToP = function eqXToP(x) {
                var zs = this.z.redSqr();
                var rx = x.toRed(this.curve.red).redMul(zs);
                if (this.x.cmp(rx) === 0) return true;
                var xc = x.clone();
                var t = this.curve.redN.redMul(zs);
                for(;;){
                    xc.iadd(this.curve.n);
                    if (xc.cmp(this.curve.p) >= 0) return false;
                    rx.redIAdd(t);
                    if (this.x.cmp(rx) === 0) return true;
                }
                return false;
            };
            JPoint.prototype.inspect = function inspect() {
                if (this.isInfinity()) return '<EC JPoint Infinity>';
                return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
            };
            JPoint.prototype.isInfinity = function isInfinity() {
                // XXX This code assumes that zero is always zero in red
                return this.z.cmpn(0) === 0;
            };
        },
        {
            "../../../../BN/bn": 120,
            "../../elliptic": 122,
            "../curve": 125
        }
    ],
    128: [
        function(require1, module, exports) {
            'use strict';
            var curves = exports;
            var elliptic = require1('../elliptic');
            var assert = elliptic.utils.assert;
            function PresetCurve(options) {
                if (options.type === 'short') this.curve = new elliptic.curve.short(options);
                else if (options.type === 'edwards') this.curve = new elliptic.curve.edwards(options);
                else this.curve = new elliptic.curve.mont(options);
                this.g = this.curve.g;
                this.n = this.curve.n;
                this.hash = options.hash;
                assert(this.g.validate(), 'Invalid curve');
                assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
            }
            curves.PresetCurve = PresetCurve;
            function defineCurve(name, options) {
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        var curve = new PresetCurve(options);
                        Object.defineProperty(curves, name, {
                            configurable: true,
                            enumerable: true,
                            value: curve
                        });
                        return curve;
                    }
                });
            }
            defineCurve('p192', {
                type: 'short',
                prime: 'p192',
                p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
                a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
                b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
                n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
                hash: 'SHA256',
                gRed: false,
                g: [
                    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
                    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
                ]
            });
            defineCurve('p224', {
                type: 'short',
                prime: 'p224',
                p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
                a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
                b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
                n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
                hash: 'SHA256',
                gRed: false,
                g: [
                    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
                    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
                ]
            });
            defineCurve('p256', {
                type: 'short',
                prime: null,
                p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
                a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
                b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
                n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
                hash: 'SHA256',
                gRed: false,
                g: [
                    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
                    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
                ]
            });
            defineCurve('p384', {
                type: 'short',
                prime: null,
                p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
                a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
                b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
                n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
                hash: 'SHA384',
                gRed: false,
                g: [
                    "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
                    "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
                ]
            });
            defineCurve('p521', {
                type: 'short',
                prime: null,
                p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
                a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
                b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
                n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
                hash: 'SHA512',
                gRed: false,
                g: [
                    "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
                    "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
                ]
            });
            defineCurve('curve25519', {
                type: 'mont',
                prime: 'p25519',
                p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
                a: '76d06',
                b: '1',
                n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
                hash: 'SHA256',
                gRed: false,
                g: [
                    '9'
                ]
            });
            defineCurve('ed25519', {
                type: 'edwards',
                prime: 'p25519',
                p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
                a: '-1',
                c: '1',
                // -121665 * (121666^(-1)) (mod P)
                d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
                n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
                hash: 'SHA256',
                gRed: false,
                g: [
                    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
                    // 4/5
                    '6666666666666666666666666666666666666666666666666666666666666658'
                ]
            });
            var pre;
            try {
                pre = require1('./precomputed/secp256k1');
            } catch (e) {
                pre = undefined;
            }
            defineCurve('secp256k1', {
                type: 'short',
                prime: 'k256',
                p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
                a: '0',
                b: '7',
                n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
                h: '1',
                hash: 'SHA256',
                // Precomputed endomorphism
                beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
                lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
                basis: [
                    {
                        a: '3086d221a7d46bcde86c90e49284eb15',
                        b: '-e4437ed6010e88286f547fa90abfe4c3'
                    },
                    {
                        a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
                        b: '3086d221a7d46bcde86c90e49284eb15'
                    }
                ],
                gRed: false,
                g: [
                    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
                    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
                    pre
                ]
            });
        },
        {
            "../elliptic": 122,
            "./precomputed/secp256k1": 135
        }
    ],
    129: [
        function(require1, module, exports) {
            'use strict';
            var BN = require1('../../../../BN/bn');
            var HmacDRBG = require1('../../hmac-drbg/hmac-drbg');
            var elliptic = require1('../../elliptic');
            var utils = elliptic.utils;
            var assert = utils.assert;
            var KeyPair = require1('./key');
            var Signature = require1('./signature');
            function EC(options) {
                if (!(this instanceof EC)) return new EC(options);
                // Shortcut `elliptic.ec(curve-name)`
                if (typeof options === 'string') {
                    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);
                    options = elliptic.curves[options];
                }
                // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
                if (options instanceof elliptic.curves.PresetCurve) options = {
                    curve: options
                };
                this.curve = options.curve.curve;
                this.n = this.curve.n;
                this.nh = this.n.ushrn(1);
                this.g = this.curve.g;
                // Point on curve
                this.g = options.curve.g;
                this.g.precompute(options.curve.n.bitLength() + 1);
                // Hash for function for DRBG
                this.hash = options.hash || options.curve.hash;
            }
            module.exports = EC;
            EC.prototype.keyPair = function keyPair(options) {
                return new KeyPair(this, options);
            };
            EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
                return KeyPair.fromPrivate(this, priv, enc);
            };
            EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
                return KeyPair.fromPublic(this, pub, enc);
            };
            EC.prototype.genKeyPair = function genKeyPair(options) {
                if (!options) options = {};
                // Instantiate Hmac_DRBG
                var drbg = new HmacDRBG({
                    hash: this.hash,
                    pers: options.pers,
                    persEnc: options.persEnc || 'utf8',
                    entropy: options.entropy || null,
                    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
                    nonce: this.n.toArray()
                });
                var bytes = this.n.byteLength();
                var ns2 = this.n.sub(new BN(2));
                do {
                    var priv = new BN(drbg.generate(bytes));
                    if (priv.cmp(ns2) > 0) continue;
                    priv.iaddn(1);
                    return this.keyFromPrivate(priv);
                }while (true);
            };
            EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
                var delta = msg.byteLength() * 8 - this.n.bitLength();
                if (delta > 0) msg = msg.ushrn(delta);
                if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
                else return msg;
            };
            EC.prototype.sign = function sign(msg, key, enc, options) {
                if (typeof enc === 'object') {
                    options = enc;
                    enc = null;
                }
                if (!options) options = {};
                key = this.keyFromPrivate(key, enc);
                msg = this._truncateToN(new BN(msg, 16));
                // Zero-extend key to provide enough entropy
                var bytes = this.n.byteLength();
                var bkey = key.getPrivate().toArray('be', bytes);
                // Zero-extend nonce to have the same byte size as N
                var nonce = msg.toArray('be', bytes);
                // Instantiate Hmac_DRBG
                var drbg = new HmacDRBG({
                    hash: this.hash,
                    entropy: options['extraEntropy'] ? bkey.concat(options['extraEntropy']) : bkey,
                    nonce: nonce,
                    pers: options.pers,
                    persEnc: options.persEnc || 'utf8'
                });
                // Number of bytes to generate
                var ns1 = this.n.sub(new BN(1));
                for(var iter = 0;; iter++){
                    var k = options.k ? options.k(iter) : new BN(drbg.generate(this.n.byteLength()));
                    k = this._truncateToN(k, true);
                    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
                    var kp = this.g.mul(k);
                    if (kp.isInfinity()) continue;
                    var kpX = kp.getX();
                    var r = kpX.umod(this.n);
                    if (r.cmpn(0) === 0) continue;
                    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
                    s = s.umod(this.n);
                    if (s.cmpn(0) === 0) continue;
                    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
                    // Use complement of `s`, if it is > `n / 2`
                    if (options.canonical && s.cmp(this.nh) > 0) {
                        s = this.n.sub(s);
                        recoveryParam ^= 1;
                    }
                    return new Signature({
                        r: r,
                        s: s,
                        recoveryParam: recoveryParam
                    });
                }
            };
            EC.prototype.verify = function verify(msg, signature, key, enc) {
                msg = this._truncateToN(new BN(msg, 16));
                key = this.keyFromPublic(key, enc);
                signature = new Signature(signature, 'hex');
                // Perform primitive values validation
                var r = signature.r;
                var s = signature.s;
                if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
                if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
                // Validate signature
                var sinv = s.invm(this.n);
                var u1 = sinv.mul(msg).umod(this.n);
                var u2 = sinv.mul(r).umod(this.n);
                if (!this.curve._maxwellTrick) {
                    var p = this.g.mulAdd(u1, key.getPublic(), u2);
                    if (p.isInfinity()) return false;
                    return p.getX().umod(this.n).cmp(r) === 0;
                }
                // NOTE: Greg Maxwell's trick, inspired by:
                // https://git.io/vad3K
                var p = this.g.jmulAdd(u1, key.getPublic(), u2);
                if (p.isInfinity()) return false;
                // Compare `p.x` of Jacobian point with `r`,
                // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
                // inverse of `p.z^2`
                return p.eqXToP(r);
            };
            EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
                assert((3 & j) === j, 'The recovery param is more than two bits');
                signature = new Signature(signature, enc);
                var n = this.n;
                var e = new BN(msg);
                var r = signature.r;
                var s = signature.s;
                // A set LSB signifies that the y-coordinate is odd
                var isYOdd = j & 1;
                var isSecondKey = j >> 1;
                if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
                // 1.1. Let x = r + jn.
                if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
                else r = this.curve.pointFromX(r, isYOdd);
                var rInv = signature.r.invm(n);
                var s1 = n.sub(e).mul(rInv).umod(n);
                var s2 = s.mul(rInv).umod(n);
                // 1.6.1 Compute Q = r^-1 (sR -  eG)
                //               Q = r^-1 (sR + -eG)
                return this.g.mulAdd(s1, r, s2);
            };
            EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
                signature = new Signature(signature, enc);
                if (signature.recoveryParam !== null) return signature.recoveryParam;
                for(var i = 0; i < 4; i++){
                    var Qprime;
                    try {
                        Qprime = this.recoverPubKey(e, signature, i);
                    } catch (e) {
                        continue;
                    }
                    if (Qprime.eq(Q)) return i;
                }
                throw new Error('Unable to find valid recovery factor');
            };
        },
        {
            "../../../../BN/bn": 120,
            "../../elliptic": 122,
            "../../hmac-drbg/hmac-drbg": 137,
            "./key": 130,
            "./signature": 131
        }
    ],
    130: [
        function(require1, module, exports) {
            'use strict';
            var BN = require1('../../../../BN/bn');
            var elliptic = require1('../../elliptic');
            var utils = elliptic.utils;
            var assert = utils.assert;
            function KeyPair(ec, options) {
                this.ec = ec;
                this.priv = null;
                this.pub = null;
                // KeyPair(ec, { priv: ..., pub: ... })
                if (options.priv) this._importPrivate(options.priv, options.privEnc);
                if (options.pub) this._importPublic(options.pub, options.pubEnc);
            }
            module.exports = KeyPair;
            KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
                if (pub instanceof KeyPair) return pub;
                return new KeyPair(ec, {
                    pub: pub,
                    pubEnc: enc
                });
            };
            KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
                if (priv instanceof KeyPair) return priv;
                return new KeyPair(ec, {
                    priv: priv,
                    privEnc: enc
                });
            };
            KeyPair.prototype.validate = function validate() {
                var pub = this.getPublic();
                if (pub.isInfinity()) return {
                    result: false,
                    reason: 'Invalid public key'
                };
                if (!pub.validate()) return {
                    result: false,
                    reason: 'Public key is not a point'
                };
                if (!pub.mul(this.ec.curve.n).isInfinity()) return {
                    result: false,
                    reason: 'Public key * N != O'
                };
                return {
                    result: true,
                    reason: null
                };
            };
            KeyPair.prototype.getPublic = function getPublic(compact, enc) {
                // compact is optional argument
                if (typeof compact === 'string') {
                    enc = compact;
                    compact = null;
                }
                if (!this.pub) this.pub = this.ec.g.mul(this.priv);
                if (!enc) return this.pub;
                return this.pub.encode(enc, compact);
            };
            KeyPair.prototype.getPrivate = function getPrivate(enc) {
                if (enc === 'hex') return this.priv.toString(16, 2);
                else return this.priv;
            };
            KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
                this.priv = new BN(key, enc || 16);
                // Ensure that the priv won't be bigger than n, otherwise we may fail
                // in fixed multiplication method
                this.priv = this.priv.umod(this.ec.curve.n);
            };
            KeyPair.prototype._importPublic = function _importPublic(key, enc) {
                if (key.x || key.y) {
                    // Montgomery points only have an `x` coordinate.
                    // Weierstrass/Edwards points on the other hand have both `x` and
                    // `y` coordinates.
                    if (this.ec.curve.type === 'mont') assert(key.x, 'Need x coordinate');
                    else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') assert(key.x && key.y, 'Need both x and y coordinate');
                    this.pub = this.ec.curve.point(key.x, key.y);
                    return;
                }
                this.pub = this.ec.curve.decodePoint(key, enc);
            };
            // ECDH
            KeyPair.prototype.derive = function derive(pub) {
                return pub.mul(this.priv).getX();
            };
            // ECDSA
            KeyPair.prototype.sign = function sign(msg, enc, options) {
                return this.ec.sign(msg, this, enc, options);
            };
            KeyPair.prototype.verify = function verify(msg, signature) {
                return this.ec.verify(msg, signature, this);
            };
            KeyPair.prototype.inspect = function inspect() {
                return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
            };
        },
        {
            "../../../../BN/bn": 120,
            "../../elliptic": 122
        }
    ],
    131: [
        function(require1, module, exports) {
            'use strict';
            var BN = require1('../../../../BN/bn');
            var elliptic = require1('../../elliptic');
            var utils = elliptic.utils;
            var assert = utils.assert;
            function Signature(options, enc) {
                if (options instanceof Signature) return options;
                //if (this._importDER(options, enc))
                //  return;
                assert(options.r && options.s, 'Signature without r or s');
                this.r = new BN(options.r, 16);
                this.s = new BN(options.s, 16);
                if (options.recoveryParam === undefined) this.recoveryParam = null;
                else this.recoveryParam = options.recoveryParam;
            }
            module.exports = Signature;
        },
        {
            "../../../../BN/bn": 120,
            "../../elliptic": 122
        }
    ],
    132: [
        function(require1, module, exports) {
            'use strict';
            var curves = require1('../curves');
            var utils = require1('../utils');
            var assert = utils.assert;
            var parseBytes = utils.parseBytes;
            var KeyPair = require1('./key');
            var Signature = require1('./signature');
            const BN = require1('../../../../BN/bn.js');
            const { byteArrayToWordArray: byteArrayToWordArray } = require1('../../../../../base/functions/encode');
            const CryptoJS = require1('../../../../crypto-js/crypto-js');
            function EDDSA(curveName) {
                assert(curveName === 'ed25519', 'only tested with ed25519 so far');
                if (!(this instanceof EDDSA)) return new EDDSA(curveName);
                var curve = curves[curveName].curve;
                this.curve = curve;
                this.g = curve.g;
                this.g.precompute(curve.n.bitLength() + 1);
                this.pointClass = curve.point().constructor;
                this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
            //this.hash = hash.sha512;
            }
            module.exports = EDDSA;
            /**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ EDDSA.prototype.sign = function sign(message, secret) {
                message = parseBytes(message);
                var key = this.keyFromSecret(secret);
                var r = this.hashInt(key.secret(), message);
                var R = this.g.mul(r);
                var Rencoded = this.encodePoint(R);
                var s_ = this.hashInt(Rencoded, key.pubBytes(), message);
                s_ = s_.mul(key.priv());
                var S = r.add(s_).umod(this.curve.n);
                return this.makeSignature({
                    R: R,
                    S: S,
                    Rencoded: Rencoded
                });
            };
            /**
 * @param {Array|String} message - message bytes
 * @param {Array|String|KeyPair} secret - secret bytes or a keypair
 * @returns {Signature} - signature
 */ EDDSA.prototype.signModified = function sign(message, secret) {
                message = parseBytes(message);
                var key = this.keyFromSecret(secret);
                // convert between curve25519 and ed25519 keys
                const secretLE = new BN(key.secret(), 16, 'le');
                const pubKey = this.encodePoint(this.g.mul(secretLE));
                const signBit = pubKey[31] & 0x80;
                var r = this.hashInt(key.secret(), message);
                var R = this.g.mul(r);
                var Rencoded = this.encodePoint(R);
                let s_ = this.hashInt(Rencoded, pubKey, message);
                s_ = s_.mul(secretLE);
                var S = r.add(s_).umod(this.curve.n);
                var Sencoded = S.toArray('le', 32);
                Sencoded[31] |= signBit;
                return this.makeSignature({
                    R: R,
                    S: S,
                    Rencoded: Rencoded,
                    Sencoded: Sencoded
                });
            };
            /**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ EDDSA.prototype.verify = function verify(message, sig, pub) {
                message = parseBytes(message);
                sig = this.makeSignature(sig);
                var key = this.keyFromPublic(pub);
                var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
                var SG = this.g.mul(sig.S());
                var RplusAh = sig.R().add(key.pub().mul(h));
                return RplusAh.eq(SG);
            };
            EDDSA.prototype.hashInt = function hashInt() {
                let toHash = Array.from(arguments).reduce((a, b)=>a.concat(b));
                toHash = byteArrayToWordArray(toHash);
                const digest = CryptoJS['SHA512'](toHash).toString(CryptoJS.enc.Hex);
                return utils.intFromLE(digest).umod(this.curve.n);
            };
            EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
                return KeyPair.fromPublic(this, pub);
            };
            EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
                return KeyPair.fromSecret(this, secret);
            };
            EDDSA.prototype.makeSignature = function makeSignature(sig) {
                if (sig instanceof Signature) return sig;
                return new Signature(this, sig);
            };
            /**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ EDDSA.prototype.encodePoint = function encodePoint(point) {
                var enc = point.getY().toArray('le', this.encodingLength);
                enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
                return enc;
            };
            EDDSA.prototype.decodePoint = function decodePoint(bytes) {
                bytes = utils.parseBytes(bytes);
                var lastIx = bytes.length - 1;
                var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
                var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
                var y = utils.intFromLE(normed);
                return this.curve.pointFromY(y, xIsOdd);
            };
            EDDSA.prototype.encodeInt = function encodeInt(num) {
                return num.toArray('le', this.encodingLength);
            };
            EDDSA.prototype.decodeInt = function decodeInt(bytes) {
                return utils.intFromLE(bytes);
            };
            EDDSA.prototype.isPoint = function isPoint(val) {
                return val instanceof this.pointClass;
            };
        },
        {
            "../../../../../base/functions/encode": 11,
            "../../../../BN/bn.js": 120,
            "../../../../crypto-js/crypto-js": 121,
            "../curves": 128,
            "../utils": 136,
            "./key": 133,
            "./signature": 134
        }
    ],
    133: [
        function(require1, module, exports) {
            'use strict';
            var utils = require1('../utils');
            var assert = utils.assert;
            var parseBytes = utils.parseBytes;
            var cachedProperty = utils.cachedProperty;
            /**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function KeyPair(eddsa, params) {
                this.eddsa = eddsa;
                this._secret = parseBytes(params.secret);
                if (eddsa.isPoint(params.pub)) this._pub = params.pub;
                else this._pubBytes = parseBytes(params.pub);
            }
            KeyPair.fromPublic = function fromPublic(eddsa, pub) {
                if (pub instanceof KeyPair) return pub;
                return new KeyPair(eddsa, {
                    pub: pub
                });
            };
            KeyPair.fromSecret = function fromSecret(eddsa, secret) {
                if (secret instanceof KeyPair) return secret;
                return new KeyPair(eddsa, {
                    secret: secret
                });
            };
            KeyPair.prototype.secret = function secret() {
                return this._secret;
            };
            cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
                return this.eddsa.encodePoint(this.pub());
            });
            cachedProperty(KeyPair, 'pub', function pub() {
                if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
                return this.eddsa.g.mul(this.priv());
            });
            cachedProperty(KeyPair, 'privBytes', function privBytes() {
                var eddsa = this.eddsa;
                var hash = this.hash();
                var lastIx = eddsa.encodingLength - 1;
                var a = hash.slice(0, eddsa.encodingLength);
                a[0] &= 248;
                a[lastIx] &= 127;
                a[lastIx] |= 64;
                return a;
            });
            cachedProperty(KeyPair, 'priv', function priv() {
                return this.eddsa.decodeInt(this.privBytes());
            });
            cachedProperty(KeyPair, 'hash', function hash() {
                return this.eddsa.hash().update(this.secret()).digest();
            });
            cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
                return this.hash().slice(this.eddsa.encodingLength);
            });
            KeyPair.prototype.sign = function sign(message) {
                assert(this._secret, 'KeyPair can only verify');
                return this.eddsa.sign(message, this);
            };
            KeyPair.prototype.signModified = function sign(message) {
                assert(this._secret, 'KeyPair can only verify');
                return this.eddsa.signModified(message, this);
            };
            KeyPair.prototype.verify = function verify(message, sig) {
                return this.eddsa.verify(message, sig, this);
            };
            KeyPair.prototype.getSecret = function getSecret(enc) {
                assert(this._secret, 'KeyPair is public only');
                return utils.encode(this.secret(), enc);
            };
            KeyPair.prototype.getPublic = function getPublic(enc) {
                return utils.encode(this.pubBytes(), enc);
            };
            module.exports = KeyPair;
        },
        {
            "../utils": 136
        }
    ],
    134: [
        function(require1, module, exports) {
            'use strict';
            var BN = require1('../../../../BN/bn');
            var utils = require1('../utils');
            var assert = utils.assert;
            var cachedProperty = utils.cachedProperty;
            var parseBytes = utils.parseBytes;
            /**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function Signature(eddsa, sig) {
                this.eddsa = eddsa;
                if (typeof sig !== 'object') sig = parseBytes(sig);
                if (Array.isArray(sig)) sig = {
                    R: sig.slice(0, eddsa.encodingLength),
                    S: sig.slice(eddsa.encodingLength)
                };
                assert(sig.R && sig.S, 'Signature without R or S');
                if (eddsa.isPoint(sig.R)) this._R = sig.R;
                if (sig.S instanceof BN) this._S = sig.S;
                this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
                this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
            }
            cachedProperty(Signature, 'S', function S() {
                return this.eddsa.decodeInt(this.Sencoded());
            });
            cachedProperty(Signature, 'R', function R() {
                return this.eddsa.decodePoint(this.Rencoded());
            });
            cachedProperty(Signature, 'Rencoded', function Rencoded() {
                return this.eddsa.encodePoint(this.R());
            });
            cachedProperty(Signature, 'Sencoded', function Sencoded() {
                return this.eddsa.encodeInt(this.S());
            });
            Signature.prototype.toBytes = function toBytes() {
                return this.Rencoded().concat(this.Sencoded());
            };
            Signature.prototype.toHex = function toHex() {
                return utils.encode(this.toBytes(), 'hex').toUpperCase();
            };
            module.exports = Signature;
        },
        {
            "../../../../BN/bn": 120,
            "../utils": 136
        }
    ],
    135: [
        function(require1, module, exports) {
            module.exports = {
                doubles: {
                    step: 4,
                    points: [
                        [
                            'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                            'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
                        ],
                        [
                            '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                            '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
                        ],
                        [
                            '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                            'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
                        ],
                        [
                            '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                            '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
                        ],
                        [
                            '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                            '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
                        ],
                        [
                            '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                            '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
                        ],
                        [
                            'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                            '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
                        ],
                        [
                            '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                            'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
                        ],
                        [
                            'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                            '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
                        ],
                        [
                            'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                            'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
                        ],
                        [
                            'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                            '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
                        ],
                        [
                            '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                            '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
                        ],
                        [
                            '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                            '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
                        ],
                        [
                            '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                            '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
                        ],
                        [
                            '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                            '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
                        ],
                        [
                            '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                            '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
                        ],
                        [
                            '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                            '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
                        ],
                        [
                            '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                            '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
                        ],
                        [
                            '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                            'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
                        ],
                        [
                            'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                            '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
                        ],
                        [
                            'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                            '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
                        ],
                        [
                            '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                            '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
                        ],
                        [
                            '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                            '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
                        ],
                        [
                            'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                            '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
                        ],
                        [
                            '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                            'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
                        ],
                        [
                            'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                            '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
                        ],
                        [
                            'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                            'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
                        ],
                        [
                            'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                            '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
                        ],
                        [
                            'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                            'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
                        ],
                        [
                            'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                            '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
                        ],
                        [
                            '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                            'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
                        ],
                        [
                            '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                            '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
                        ],
                        [
                            'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                            '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
                        ],
                        [
                            '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                            'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
                        ],
                        [
                            'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                            '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
                        ],
                        [
                            'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                            '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
                        ],
                        [
                            'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                            'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
                        ],
                        [
                            '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                            '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
                        ],
                        [
                            '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                            '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
                        ],
                        [
                            '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                            'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
                        ],
                        [
                            '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                            '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
                        ],
                        [
                            'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                            '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
                        ],
                        [
                            '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                            '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
                        ],
                        [
                            '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                            'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
                        ],
                        [
                            '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                            '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
                        ],
                        [
                            'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                            '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
                        ],
                        [
                            '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                            'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
                        ],
                        [
                            'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                            'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
                        ],
                        [
                            'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                            '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
                        ],
                        [
                            '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                            'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
                        ],
                        [
                            '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                            'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
                        ],
                        [
                            'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                            '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
                        ],
                        [
                            'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                            '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
                        ],
                        [
                            'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                            '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
                        ],
                        [
                            '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                            'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
                        ],
                        [
                            '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                            '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
                        ],
                        [
                            'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                            'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
                        ],
                        [
                            '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                            'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
                        ],
                        [
                            '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                            '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
                        ],
                        [
                            '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                            '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
                        ],
                        [
                            'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                            'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
                        ],
                        [
                            '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                            '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
                        ],
                        [
                            '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                            '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
                        ],
                        [
                            'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                            '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
                        ],
                        [
                            'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                            'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
                        ]
                    ]
                },
                naf: {
                    wnd: 7,
                    points: [
                        [
                            'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                            '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
                        ],
                        [
                            '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                            'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
                        ],
                        [
                            '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                            '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
                        ],
                        [
                            'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                            'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
                        ],
                        [
                            '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                            'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
                        ],
                        [
                            'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                            'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
                        ],
                        [
                            'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                            '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
                        ],
                        [
                            'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                            '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
                        ],
                        [
                            '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                            '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
                        ],
                        [
                            '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                            '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
                        ],
                        [
                            '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                            '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
                        ],
                        [
                            '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                            '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
                        ],
                        [
                            'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                            'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
                        ],
                        [
                            'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                            '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
                        ],
                        [
                            '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                            'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
                        ],
                        [
                            '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                            'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
                        ],
                        [
                            '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                            '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
                        ],
                        [
                            '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                            '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
                        ],
                        [
                            '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                            '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
                        ],
                        [
                            '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                            'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
                        ],
                        [
                            'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                            'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
                        ],
                        [
                            '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                            '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
                        ],
                        [
                            '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                            '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
                        ],
                        [
                            'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                            'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
                        ],
                        [
                            '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                            '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
                        ],
                        [
                            'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                            'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
                        ],
                        [
                            'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                            'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
                        ],
                        [
                            '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                            '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
                        ],
                        [
                            '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                            '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
                        ],
                        [
                            '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                            '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
                        ],
                        [
                            'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                            '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
                        ],
                        [
                            '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                            '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
                        ],
                        [
                            'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                            '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
                        ],
                        [
                            '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                            'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
                        ],
                        [
                            '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                            'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
                        ],
                        [
                            'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                            'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
                        ],
                        [
                            '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                            '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
                        ],
                        [
                            '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                            'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
                        ],
                        [
                            'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                            'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
                        ],
                        [
                            '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                            '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
                        ],
                        [
                            '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                            'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
                        ],
                        [
                            '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                            '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
                        ],
                        [
                            '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                            'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
                        ],
                        [
                            'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                            '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
                        ],
                        [
                            '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                            '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
                        ],
                        [
                            '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                            'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
                        ],
                        [
                            '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                            'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
                        ],
                        [
                            'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                            'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
                        ],
                        [
                            'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                            'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
                        ],
                        [
                            '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                            '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
                        ],
                        [
                            '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                            '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
                        ],
                        [
                            'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                            '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
                        ],
                        [
                            'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                            'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
                        ],
                        [
                            '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                            '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
                        ],
                        [
                            '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                            '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
                        ],
                        [
                            'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                            '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
                        ],
                        [
                            '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                            '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
                        ],
                        [
                            'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                            'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
                        ],
                        [
                            '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                            'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
                        ],
                        [
                            '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                            '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
                        ],
                        [
                            'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                            '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
                        ],
                        [
                            'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                            '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
                        ],
                        [
                            '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                            '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
                        ],
                        [
                            '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                            '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
                        ],
                        [
                            '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                            'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
                        ],
                        [
                            '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                            'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
                        ],
                        [
                            '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                            '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
                        ],
                        [
                            '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                            '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
                        ],
                        [
                            '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                            '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
                        ],
                        [
                            '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                            'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
                        ],
                        [
                            'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                            'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
                        ],
                        [
                            '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                            'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
                        ],
                        [
                            'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                            '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
                        ],
                        [
                            'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                            '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
                        ],
                        [
                            'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                            '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
                        ],
                        [
                            'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                            '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
                        ],
                        [
                            '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                            'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
                        ],
                        [
                            '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                            '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
                        ],
                        [
                            '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                            'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
                        ],
                        [
                            'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                            'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
                        ],
                        [
                            'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                            '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
                        ],
                        [
                            'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                            'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
                        ],
                        [
                            'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                            '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
                        ],
                        [
                            '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                            '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
                        ],
                        [
                            'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                            '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
                        ],
                        [
                            'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                            '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
                        ],
                        [
                            '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                            '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
                        ],
                        [
                            '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                            'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
                        ],
                        [
                            'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                            '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
                        ],
                        [
                            'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                            '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
                        ],
                        [
                            'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                            '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
                        ],
                        [
                            '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                            '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
                        ],
                        [
                            'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                            'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
                        ],
                        [
                            '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                            'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
                        ],
                        [
                            'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                            'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
                        ],
                        [
                            'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                            '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
                        ],
                        [
                            '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                            'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
                        ],
                        [
                            'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                            '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
                        ],
                        [
                            'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                            '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
                        ],
                        [
                            'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                            '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
                        ],
                        [
                            '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                            'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
                        ],
                        [
                            '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                            'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
                        ],
                        [
                            'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                            '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
                        ],
                        [
                            '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                            'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
                        ],
                        [
                            '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                            '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
                        ],
                        [
                            '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                            'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
                        ],
                        [
                            'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                            'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
                        ],
                        [
                            '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                            'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
                        ],
                        [
                            '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                            '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
                        ],
                        [
                            '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                            'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
                        ],
                        [
                            '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                            '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
                        ],
                        [
                            'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                            'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
                        ],
                        [
                            '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                            '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
                        ],
                        [
                            'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                            '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
                        ],
                        [
                            '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                            '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
                        ],
                        [
                            'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                            'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
                        ],
                        [
                            'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                            '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
                        ],
                        [
                            'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                            'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
                        ],
                        [
                            '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                            'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
                        ],
                        [
                            '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                            '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
                        ],
                        [
                            '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                            'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
                        ],
                        [
                            '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                            '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
                        ],
                        [
                            '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                            '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
                        ],
                        [
                            '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                            'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
                        ],
                        [
                            '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                            '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
                        ],
                        [
                            '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                            '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
                        ],
                        [
                            '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                            '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
                        ]
                    ]
                }
            };
        },
        {}
    ],
    136: [
        function(require1, module, exports) {
            'use strict';
            var utils = exports;
            var BN = require1('../../../BN/bn');
            utils.assert = function(condition, errorMessage) {
                if (!condition) throw new Error(errorMessage);
            };
            // Represent num in a w-NAF form
            function getNAF(num, w) {
                var naf = [];
                var ws = 1 << w + 1;
                var k = num.clone();
                while(k.cmpn(1) >= 0){
                    var z;
                    if (k.isOdd()) {
                        var mod = k.andln(ws - 1);
                        if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                        else z = mod;
                        k.isubn(z);
                    } else z = 0;
                    naf.push(z);
                    // Optimization, shift by word if possible
                    var shift = k.cmpn(0) !== 0 && k.andln(ws - 1) === 0 ? w + 1 : 1;
                    for(var i = 1; i < shift; i++)naf.push(0);
                    k.iushrn(shift);
                }
                return naf;
            }
            utils.getNAF = getNAF;
            // Represent k1, k2 in a Joint Sparse Form
            function getJSF(k1, k2) {
                var jsf = [
                    [],
                    []
                ];
                k1 = k1.clone();
                k2 = k2.clone();
                var d1 = 0;
                var d2 = 0;
                while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
                    // First phase
                    var m14 = k1.andln(3) + d1 & 3;
                    var m24 = k2.andln(3) + d2 & 3;
                    if (m14 === 3) m14 = -1;
                    if (m24 === 3) m24 = -1;
                    var u1;
                    if ((m14 & 1) === 0) u1 = 0;
                    else {
                        var m8 = k1.andln(7) + d1 & 7;
                        if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                        else u1 = m14;
                    }
                    jsf[0].push(u1);
                    var u2;
                    if ((m24 & 1) === 0) u2 = 0;
                    else {
                        var m8 = k2.andln(7) + d2 & 7;
                        if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                        else u2 = m24;
                    }
                    jsf[1].push(u2);
                    // Second phase
                    if (2 * d1 === u1 + 1) d1 = 1 - d1;
                    if (2 * d2 === u2 + 1) d2 = 1 - d2;
                    k1.iushrn(1);
                    k2.iushrn(1);
                }
                return jsf;
            }
            utils.getJSF = getJSF;
            function cachedProperty(obj, name, computer) {
                var key = '_' + name;
                obj.prototype[name] = function cachedProperty() {
                    return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
                };
            }
            utils.cachedProperty = cachedProperty;
            function parseBytes(bytes) {
                return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') : bytes;
            }
            utils.parseBytes = parseBytes;
            function intFromLE(bytes) {
                return new BN(bytes, 'hex', 'le');
            }
            utils.intFromLE = intFromLE;
            // used to convert `CryptoJS` wordArrays into `crypto` hex buffers
            function wordToByteArray(word, length) {
                var ba = [], xFF = 0xFF;
                if (length > 0) ba.push(word >>> 24);
                if (length > 1) ba.push(word >>> 16 & xFF);
                if (length > 2) ba.push(word >>> 8 & xFF);
                if (length > 3) ba.push(word & xFF);
                return ba;
            }
            function wordArrayToBuffer(wordArray) {
                let length = undefined;
                if (wordArray.hasOwnProperty("sigBytes") && wordArray.hasOwnProperty("words")) {
                    length = wordArray.sigBytes;
                    wordArray = wordArray.words;
                } else throw Error('Argument not a wordArray');
                const result = [];
                let bytes = [];
                let i = 0;
                while(length > 0){
                    bytes = wordToByteArray(wordArray[i], Math.min(4, length));
                    length -= bytes.length;
                    result.push(bytes);
                    i++;
                }
                return [].concat.apply([], result);
            }
            utils.wordArrayToBuffer = wordArrayToBuffer;
            // https://github.com/indutny/minimalistic-crypto-utils/blob/master/lib/utils.js
            // moved here to remove the dep
            function toArray(msg, enc) {
                if (Array.isArray(msg)) return msg.slice();
                if (!msg) return [];
                var res = [];
                if (typeof msg !== 'string') {
                    for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
                    return res;
                }
                if (enc === 'hex') {
                    msg = msg.replace(/[^a-z0-9]+/ig, '');
                    if (msg.length % 2 !== 0) msg = '0' + msg;
                    for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
                } else for(var i = 0; i < msg.length; i++){
                    var c = msg.charCodeAt(i);
                    var hi = c >> 8;
                    var lo = c & 0xff;
                    if (hi) res.push(hi, lo);
                    else res.push(lo);
                }
                return res;
            }
            utils.toArray = toArray;
            function zero2(word) {
                if (word.length === 1) return '0' + word;
                else return word;
            }
            utils.zero2 = zero2;
            function toHex(msg) {
                var res = '';
                for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
                return res;
            }
            utils.toHex = toHex;
            utils.encode = function encode(arr, enc) {
                if (enc === 'hex') return toHex(arr);
                else return arr;
            };
        },
        {
            "../../../BN/bn": 120
        }
    ],
    137: [
        function(require1, module, exports) {
            'use strict';
            var CryptoJS = require1('../../../crypto-js/crypto-js');
            var assert = require1('../elliptic/utils').assert;
            var utils = require1('../elliptic/utils');
            var { byteArrayToWordArray: byteArrayToWordArray } = require1('../../../../base/functions/encode');
            // some static stuff
            const ONE = CryptoJS.enc.Utf8.parse('\x01');
            const ZERO = CryptoJS.enc.Utf8.parse('\x00');
            function HmacDRBG(options) {
                if (!(this instanceof HmacDRBG)) return new HmacDRBG(options);
                this.hash = options.hash;
                this.predResist = !!options.predResist;
                this.outLen = this.hash.slice(3, 6); // only support SHAXXX hashes
                this.minEntropy = options.minEntropy || 192;
                this._reseed = null;
                this.reseedInterval = null;
                this.K = null;
                this.V = null;
                var entropy = options.entropy;
                var nonce = options.nonce;
                var pers = [];
                assert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
                this._init(entropy, nonce, pers);
            }
            module.exports = HmacDRBG;
            HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
                var seed = entropy.concat(nonce).concat(pers);
                this.K = new CryptoJS.lib.WordArray.init();
                this.V = new CryptoJS.lib.WordArray.init();
                const magicNumber = 16843009;
                this.V.words = Array(this.outLen / 32).fill(magicNumber);
                this.V.sigBytes = 32;
                this._update(seed);
                this._reseed = 1;
                this.reseedInterval = 0x1000000000000; // 2^48
            };
            HmacDRBG.prototype._hmac = function hmac() {
                return new CryptoJS.lib.WordArray.init();
            };
            HmacDRBG.prototype._update = function update(seed) {
                var kmac = this._hmac();
                kmac.concat(this.V);
                kmac.concat(ZERO);
                if (seed) kmac.concat(byteArrayToWordArray(seed));
                this.K = CryptoJS['Hmac' + this.hash](kmac, this.K);
                this.V = CryptoJS['Hmac' + this.hash](this.V, this.K);
                if (!seed) return;
                kmac = this._hmac();
                kmac.concat(this.V);
                kmac.concat(ONE);
                kmac.concat(byteArrayToWordArray(seed));
                this.K = CryptoJS['Hmac' + this.hash](kmac, this.K);
                this.V = CryptoJS['Hmac' + this.hash](this.V, this.K);
            };
            HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
                // Optional entropy enc
                if (typeof entropyEnc !== 'string') {
                    addEnc = add;
                    add = entropyEnc;
                    entropyEnc = null;
                }
                //entropy = utils.toArray(entropy, entropyEnc);
                //add = utils.toArray(add, addEnc);
                assert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
                this._update(entropy.concat(add || []));
                this._reseed = 1;
            };
            HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
                if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
                // Optional encoding
                if (typeof enc !== 'string') {
                    addEnc = add;
                    add = enc;
                    enc = null;
                }
                // Optional additional data
                if (add) {
                    add = CryptoJS.enc.Utf8.parse(add);
                    this._update(add);
                }
                var res = new CryptoJS.lib.WordArray.init();
                while(res.sigBytes < len){
                    this.V = CryptoJS['Hmac' + this.hash](this.V, this.K);
                    res.concat(this.V);
                }
                this._update(add);
                this._reseed++;
                return utils.wordArrayToBuffer(res);
            };
        },
        {
            "../../../../base/functions/encode": 11,
            "../../../crypto-js/crypto-js": 121,
            "../elliptic/utils": 136
        }
    ],
    138: [
        function(require1, module, exports) {
            'use strict';
            var fetch1 = require1('../node-fetch/index');
            function wrapFetchForNode(fetch1) {
                // Support schemaless URIs on the server for parity with the browser.
                // https://github.com/matthew-andrews/isomorphic-fetch/pull/10
                const f = function(u, options) {
                    if (typeof u === 'string' && u.slice(0, 2) === '//') return fetch1('https:' + u, options);
                    return fetch1(u, options);
                };
                // Igor Kroitor 2019 Dec 30
                // expose http and https
                // https://github.com/ccxt/ccxt/issues/6327
                f.http = fetch1.http;
                f.https = fetch1.https;
                return f;
            }
            module.exports = function(context) {
                // This modifies the global `node-fetch` object, which isn't great, since
                // different callers to `fetch-ponyfill` which pass a different Promise
                // implementation would each expect to have their implementation used. But,
                // given the way `node-fetch` is implemented, this is the only way to make
                // it work at all.
                if (context && context.Promise) fetch1.Promise = context.Promise;
                return {
                    fetch: wrapFetchForNode(fetch1),
                    Headers: fetch1.Headers,
                    Request: fetch1.Request,
                    Response: fetch1.Response
                };
            };
        },
        {
            "../node-fetch/index": 139
        }
    ],
    139: [
        function(require1, module, exports) {
            (function(global1, Buffer) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                // Based on https://github.com/tmpvar/jsdom/blob/aa85b2abf07766ff7bf5c1f6daafb3726f2f2db5/lib/jsdom/living/blob.js
                // (MIT licensed)
                const BUFFER = Symbol('buffer');
                const TYPE = Symbol('type');
                class Blob1 {
                    constructor(){
                        this[TYPE] = '';
                        const blobParts = arguments[0];
                        const options = arguments[1];
                        const buffers = [];
                        if (blobParts) {
                            const a = blobParts;
                            const length = Number(a.length);
                            for(let i = 0; i < length; i++){
                                const element = a[i];
                                let buffer;
                                if (element instanceof Buffer) buffer = element;
                                else if (ArrayBuffer.isView(element)) buffer = Buffer.from(element.buffer, element.byteOffset, element.byteLength);
                                else if (element instanceof ArrayBuffer) buffer = Buffer.from(element);
                                else if (element instanceof Blob1) buffer = element[BUFFER];
                                else buffer = Buffer.from(typeof element === 'string' ? element : String(element));
                                buffers.push(buffer);
                            }
                        }
                        this[BUFFER] = Buffer.concat(buffers);
                        let type = options && options.type !== undefined && String(options.type).toLowerCase();
                        if (type && !/[^\u0020-\u007E]/.test(type)) this[TYPE] = type;
                    }
                    get size() {
                        return this[BUFFER].length;
                    }
                    get type() {
                        return this[TYPE];
                    }
                    slice() {
                        const size = this.size;
                        const start = arguments[0];
                        const end = arguments[1];
                        let relativeStart, relativeEnd;
                        if (start === undefined) relativeStart = 0;
                        else if (start < 0) relativeStart = Math.max(size + start, 0);
                        else relativeStart = Math.min(start, size);
                        if (end === undefined) relativeEnd = size;
                        else if (end < 0) relativeEnd = Math.max(size + end, 0);
                        else relativeEnd = Math.min(end, size);
                        const span = Math.max(relativeEnd - relativeStart, 0);
                        const buffer = this[BUFFER];
                        const slicedBuffer = buffer.slice(relativeStart, relativeStart + span);
                        const blob = new Blob1([], {
                            type: arguments[2]
                        });
                        blob[BUFFER] = slicedBuffer;
                        return blob;
                    }
                }
                Object.defineProperties(Blob1.prototype, {
                    size: {
                        enumerable: true
                    },
                    type: {
                        enumerable: true
                    },
                    slice: {
                        enumerable: true
                    }
                });
                Object.defineProperty(Blob1.prototype, Symbol.toStringTag, {
                    value: 'Blob',
                    writable: false,
                    enumerable: false,
                    configurable: true
                });
                /**
 * fetch-error.js
 *
 * FetchError interface for operational errors
 */ /**
 * Create FetchError instance
 *
 * @param   String      message      Error message for human
 * @param   String      type         Error type for machine
 * @param   String      systemError  For Node.js system error
 * @return  FetchError
 */ function FetchError(message, type, systemError) {
                    Error.call(this, message);
                    this.message = message;
                    this.type = type;
                    // when err.type is `system`, err.code contains system error code
                    if (systemError) this.code = this.errno = systemError.code;
                    // hide custom error implementation details from end-users
                    Error.captureStackTrace(this, this.constructor);
                }
                FetchError.prototype = Object.create(Error.prototype);
                FetchError.prototype.constructor = FetchError;
                FetchError.prototype.name = 'FetchError';
                /**
 * body.js
 *
 * Body interface provides common methods for Request and Response
 */ const Stream = require1('stream');
                var _require = require1('stream');
                const PassThrough = _require.PassThrough;
                /*
let convert;
try {
	convert = require('encoding').convert;
} catch (e) {}
*/ const INTERNALS = Symbol('Body internals');
                /**
 * Body mixin
 *
 * Ref: https://fetch.spec.whatwg.org/#body
 *
 * @param   Stream  body  Readable stream
 * @param   Object  opts  Response options
 * @return  Void
 */ function Body(body) {
                    var _this = this;
                    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$size = _ref.size;
                    let size = _ref$size === undefined ? 0 : _ref$size;
                    var _ref$timeout = _ref.timeout;
                    let timeout = _ref$timeout === undefined ? 0 : _ref$timeout;
                    if (body == null) // body is undefined or null
                    body = null;
                    else if (typeof body === 'string') ;
                    else if (isURLSearchParams(body)) ;
                    else if (body instanceof Blob1) ;
                    else if (Buffer.isBuffer(body)) ;
                    else if (Object.prototype.toString.call(body) === '[object ArrayBuffer]') ;
                    else if (body instanceof Stream) ;
                    else // none of the above
                    // coerce to string
                    body = String(body);
                    this[INTERNALS] = {
                        body: body,
                        disturbed: false,
                        error: null
                    };
                    this.size = size;
                    this.timeout = timeout;
                    if (body instanceof Stream) body.on('error', function(err) {
                        _this[INTERNALS].error = new FetchError(`Invalid response body while trying to fetch ${_this.url}: ${err.message}`, 'system', err);
                    });
                }
                Body.prototype = {
                    get body () {
                        return this[INTERNALS].body;
                    },
                    get bodyUsed () {
                        return this[INTERNALS].disturbed;
                    },
                    /**
  * Decode response as ArrayBuffer
  *
  * @return  Promise
  */ arrayBuffer () {
                        return consumeBody.call(this).then(function(buf) {
                            return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
                        });
                    },
                    /**
  * Return raw response as Blob
  *
  * @return Promise
  */ blob () {
                        let ct = this.headers && this.headers.get('content-type') || '';
                        return consumeBody.call(this).then(function(buf) {
                            return Object.assign(// Prevent copying
                            new Blob1([], {
                                type: ct.toLowerCase()
                            }), {
                                [BUFFER]: buf
                            });
                        });
                    },
                    /**
  * Decode response as json
  *
  * @return  Promise
  */ json () {
                        var _this2 = this;
                        return consumeBody.call(this).then(function(buffer) {
                            try {
                                return JSON.parse(buffer.toString());
                            } catch (err) {
                                return Body.Promise.reject(new FetchError(`invalid json response body at ${_this2.url} reason: ${err.message}`, 'invalid-json'));
                            }
                        });
                    },
                    /**
  * Decode response as text
  *
  * @return  Promise
  */ text () {
                        return consumeBody.call(this).then(function(buffer) {
                            return buffer.toString();
                        });
                    },
                    /**
  * Decode response as buffer (non-spec api)
  *
  * @return  Promise
  */ buffer () {
                        return consumeBody.call(this);
                    },
                    /**
  * Decode response as text, while automatically detecting the encoding and
  * trying to decode to UTF-8 (non-spec api)
  *
  * @return  Promise
  */ textConverted () {
                        var _this3 = this;
                        return consumeBody.call(this).then(function(buffer) {
                            return convertBody(buffer, _this3.headers);
                        });
                    }
                };
                // In browsers, all properties are enumerable.
                Object.defineProperties(Body.prototype, {
                    body: {
                        enumerable: true
                    },
                    bodyUsed: {
                        enumerable: true
                    },
                    arrayBuffer: {
                        enumerable: true
                    },
                    blob: {
                        enumerable: true
                    },
                    json: {
                        enumerable: true
                    },
                    text: {
                        enumerable: true
                    }
                });
                Body.mixIn = function(proto) {
                    for (const name of Object.getOwnPropertyNames(Body.prototype))// istanbul ignore else: future proof
                    if (!(name in proto)) {
                        const desc = Object.getOwnPropertyDescriptor(Body.prototype, name);
                        Object.defineProperty(proto, name, desc);
                    }
                };
                /**
 * Consume and convert an entire Body to a Buffer.
 *
 * Ref: https://fetch.spec.whatwg.org/#concept-body-consume-body
 *
 * @return  Promise
 */ function consumeBody() {
                    var _this4 = this;
                    if (this[INTERNALS].disturbed) return Body.Promise.reject(new TypeError(`body used already for: ${this.url}`));
                    this[INTERNALS].disturbed = true;
                    if (this[INTERNALS].error) return Body.Promise.reject(this[INTERNALS].error);
                    // body is null
                    if (this.body === null) return Body.Promise.resolve(Buffer.alloc(0));
                    // body is string
                    if (typeof this.body === 'string') return Body.Promise.resolve(Buffer.from(this.body));
                    // body is blob
                    if (this.body instanceof Blob1) return Body.Promise.resolve(this.body[BUFFER]);
                    // body is buffer
                    if (Buffer.isBuffer(this.body)) return Body.Promise.resolve(this.body);
                    // body is buffer
                    if (Object.prototype.toString.call(this.body) === '[object ArrayBuffer]') return Body.Promise.resolve(Buffer.from(this.body));
                    // istanbul ignore if: should never happen
                    if (!(this.body instanceof Stream)) return Body.Promise.resolve(Buffer.alloc(0));
                    // body is stream
                    // get ready to actually consume the body
                    let accum = [];
                    let accumBytes = 0;
                    let abort = false;
                    return new Body.Promise(function(resolve, reject) {
                        let resTimeout;
                        // allow timeout on slow response body
                        if (_this4.timeout) resTimeout = setTimeout(function() {
                            abort = true;
                            reject(new FetchError(`Response timeout while trying to fetch ${_this4.url} (over ${_this4.timeout}ms)`, 'body-timeout'));
                        }, _this4.timeout);
                        // handle stream error, such as incorrect content-encoding
                        _this4.body.on('error', function(err) {
                            reject(new FetchError(`Invalid response body while trying to fetch ${_this4.url}: ${err.message}`, 'system', err));
                        });
                        _this4.body.on('data', function(chunk) {
                            if (abort || chunk === null) return;
                            if (_this4.size && accumBytes + chunk.length > _this4.size) {
                                abort = true;
                                reject(new FetchError(`content size at ${_this4.url} over limit: ${_this4.size}`, 'max-size'));
                                return;
                            }
                            accumBytes += chunk.length;
                            accum.push(chunk);
                        });
                        _this4.body.on('end', function() {
                            if (abort) return;
                            clearTimeout(resTimeout);
                            try {
                                resolve(Buffer.concat(accum));
                            } catch (err) {
                                // handle streams that have accumulated too much data (issue #414)
                                reject(new FetchError(`Could not create Buffer from response body for ${_this4.url}: ${err.message}`, 'system', err));
                            }
                        });
                    });
                }
                /**
 * Detect buffer encoding and convert to target encoding
 * ref: http://www.w3.org/TR/2011/WD-html5-20110113/parsing.html#determining-the-character-encoding
 *
 * @param   Buffer  buffer    Incoming buffer
 * @param   String  encoding  Target encoding
 * @return  String
 */ function convertBody(buffer, headers) {
                    if (typeof convert !== 'function') throw new Error('The package `encoding` must be installed to use the textConverted() function');
                    const ct = headers.get('content-type');
                    let charset = 'utf-8';
                    let res, str;
                    // header
                    if (ct) res = /charset=([^;]*)/i.exec(ct);
                    // no charset in content type, peek at response body for at most 1024 bytes
                    str = buffer.slice(0, 1024).toString();
                    // html5
                    if (!res && str) res = /<meta.+?charset=(['"])(.+?)\1/i.exec(str);
                    // html4
                    if (!res && str) {
                        res = /<meta[\s]+?http-equiv=(['"])content-type\1[\s]+?content=(['"])(.+?)\2/i.exec(str);
                        if (res) res = /charset=(.*)/i.exec(res.pop());
                    }
                    // xml
                    if (!res && str) res = /<\?xml.+?encoding=(['"])(.+?)\1/i.exec(str);
                    // found charset
                    if (res) {
                        charset = res.pop();
                        // prevent decode issues when sites use incorrect encoding
                        // ref: https://hsivonen.fi/encoding-menu/
                        if (charset === 'gb2312' || charset === 'gbk') charset = 'gb18030';
                    }
                    // turn raw buffers into a single utf-8 buffer
                    return convert(buffer, 'UTF-8', charset).toString();
                }
                /**
 * Detect a URLSearchParams object
 * ref: https://github.com/bitinn/node-fetch/issues/296#issuecomment-307598143
 *
 * @param   Object  obj     Object to detect by type or brand
 * @return  String
 */ function isURLSearchParams(obj) {
                    // Duck-typing as a necessary condition.
                    if (typeof obj !== 'object' || typeof obj.append !== 'function' || typeof obj.delete !== 'function' || typeof obj.get !== 'function' || typeof obj.getAll !== 'function' || typeof obj.has !== 'function' || typeof obj.set !== 'function') return false;
                    // Brand-checking and more duck-typing as optional condition.
                    return obj.constructor.name === 'URLSearchParams' || Object.prototype.toString.call(obj) === '[object URLSearchParams]' || typeof obj.sort === 'function';
                }
                /**
 * Clone body given Res/Req instance
 *
 * @param   Mixed  instance  Response or Request instance
 * @return  Mixed
 */ function clone(instance) {
                    let p1, p2;
                    let body = instance.body;
                    // don't allow cloning a used body
                    if (instance.bodyUsed) throw new Error('cannot clone body after it is used');
                    // check that body is a stream and not form-data object
                    // note: we can't clone the form-data object without having it as a dependency
                    if (body instanceof Stream && typeof body.getBoundary !== 'function') {
                        // tee instance body
                        p1 = new PassThrough();
                        p2 = new PassThrough();
                        body.pipe(p1);
                        body.pipe(p2);
                        // set instance body to teed body and return the other teed body
                        instance[INTERNALS].body = p1;
                        body = p2;
                    }
                    return body;
                }
                /**
 * Performs the operation "extract a `Content-Type` value from |object|" as
 * specified in the specification:
 * https://fetch.spec.whatwg.org/#concept-bodyinit-extract
 *
 * This function assumes that instance.body is present.
 *
 * @param   Mixed  instance  Response or Request instance
 */ function extractContentType(instance) {
                    const body = instance.body;
                    // istanbul ignore if: Currently, because of a guard in Request, body
                    // can never be null. Included here for completeness.
                    if (body === null) // body is null
                    return null;
                    else if (typeof body === 'string') // body is string
                    return 'text/plain;charset=UTF-8';
                    else if (isURLSearchParams(body)) // body is a URLSearchParams
                    return 'application/x-www-form-urlencoded;charset=UTF-8';
                    else if (body instanceof Blob1) // body is blob
                    return body.type || null;
                    else if (Buffer.isBuffer(body)) // body is buffer
                    return null;
                    else if (Object.prototype.toString.call(body) === '[object ArrayBuffer]') // body is array buffer
                    return null;
                    else if (typeof body.getBoundary === 'function') // detect form data input from form-data module
                    return `multipart/form-data;boundary=${body.getBoundary()}`;
                    else // body is stream
                    // can't really do much about this
                    return null;
                }
                /**
 * The Fetch Standard treats this as if "total bytes" is a property on the body.
 * For us, we have to explicitly get it with a function.
 *
 * ref: https://fetch.spec.whatwg.org/#concept-body-total-bytes
 *
 * @param   Body    instance   Instance of Body
 * @return  Number?            Number of bytes, or null if not possible
 */ function getTotalBytes(instance) {
                    const body = instance.body;
                    // istanbul ignore if: included for completion
                    if (body === null) // body is null
                    return 0;
                    else if (typeof body === 'string') // body is string
                    return Buffer.byteLength(body);
                    else if (isURLSearchParams(body)) // body is URLSearchParams
                    return Buffer.byteLength(String(body));
                    else if (body instanceof Blob1) // body is blob
                    return body.size;
                    else if (Buffer.isBuffer(body)) // body is buffer
                    return body.length;
                    else if (Object.prototype.toString.call(body) === '[object ArrayBuffer]') // body is array buffer
                    return body.byteLength;
                    else if (body && typeof body.getLengthSync === 'function') {
                        // detect form data input from form-data module
                        if (body._lengthRetrievers && body._lengthRetrievers.length == 0 || // 1.x
                        body.hasKnownLength && body.hasKnownLength()) // 2.x
                        return body.getLengthSync();
                        return null;
                    } else // body is stream
                    // can't really do much about this
                    return null;
                }
                /**
 * Write a Body to a Node.js WritableStream (e.g. http.Request) object.
 *
 * @param   Body    instance   Instance of Body
 * @return  Void
 */ function writeToStream(dest, instance) {
                    const body = instance.body;
                    if (body === null) // body is null
                    dest.end();
                    else if (typeof body === 'string') {
                        // body is string
                        dest.write(body);
                        dest.end();
                    } else if (isURLSearchParams(body)) {
                        // body is URLSearchParams
                        dest.write(Buffer.from(String(body)));
                        dest.end();
                    } else if (body instanceof Blob1) {
                        // body is blob
                        dest.write(body[BUFFER]);
                        dest.end();
                    } else if (Buffer.isBuffer(body)) {
                        // body is buffer
                        dest.write(body);
                        dest.end();
                    } else if (Object.prototype.toString.call(body) === '[object ArrayBuffer]') {
                        // body is array buffer
                        dest.write(Buffer.from(body));
                        dest.end();
                    } else // body is stream
                    body.pipe(dest);
                }
                // expose Promise
                Body.Promise = global1.Promise;
                /**
 * headers.js
 *
 * Headers class offers convenient helpers
 */ const invalidTokenRegex = /[^\^_`a-zA-Z\-0-9!#$%&'*+.|~]/;
                const invalidHeaderCharRegex = /[^\t\x20-\x7e\x80-\xff]/;
                function validateName(name) {
                    name = `${name}`;
                    if (invalidTokenRegex.test(name)) throw new TypeError(`${name} is not a legal HTTP header name`);
                }
                function validateValue(value) {
                    value = `${value}`;
                    if (invalidHeaderCharRegex.test(value)) throw new TypeError(`${value} is not a legal HTTP header value`);
                }
                /**
 * Find the key in the map object given a header name.
 *
 * Returns undefined if not found.
 *
 * @param   String  name  Header name
 * @return  String|Undefined
 */ function find(map, name) {
                    name = name.toLowerCase();
                    for(const key in map){
                        if (key.toLowerCase() === name) return key;
                    }
                    return undefined;
                }
                const MAP = Symbol('map');
                class Headers {
                    /**
  * Headers class
  *
  * @param   Object  headers  Response headers
  * @return  Void
  */ constructor(){
                        let init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                        this[MAP] = Object.create(null);
                        if (init instanceof Headers) {
                            const rawHeaders = init.raw();
                            const headerNames = Object.keys(rawHeaders);
                            for (const headerName of headerNames)for (const value of rawHeaders[headerName])this.append(headerName, value);
                            return;
                        }
                        // We don't worry about converting prop to ByteString here as append()
                        // will handle it.
                        if (init == null) ;
                        else if (typeof init === 'object') {
                            const method = init[Symbol.iterator];
                            if (method != null) {
                                if (typeof method !== 'function') throw new TypeError('Header pairs must be iterable');
                                // sequence<sequence<ByteString>>
                                // Note: per spec we have to first exhaust the lists then process them
                                const pairs = [];
                                for (const pair of init){
                                    if (typeof pair !== 'object' || typeof pair[Symbol.iterator] !== 'function') throw new TypeError('Each header pair must be iterable');
                                    pairs.push(Array.from(pair));
                                }
                                for (const pair of pairs){
                                    if (pair.length !== 2) throw new TypeError('Each header pair must be a name/value tuple');
                                    this.append(pair[0], pair[1]);
                                }
                            } else // record<ByteString, ByteString>
                            for (const key of Object.keys(init)){
                                const value = init[key];
                                this.append(key, value);
                            }
                        } else throw new TypeError('Provided initializer must be an object');
                    }
                    /**
  * Return combined header value given name
  *
  * @param   String  name  Header name
  * @return  Mixed
  */ get(name) {
                        name = `${name}`;
                        validateName(name);
                        const key = find(this[MAP], name);
                        if (key === undefined) return null;
                        return this[MAP][key].join(', ');
                    }
                    /**
  * Iterate over all headers
  *
  * @param   Function  callback  Executed for each item with parameters (value, name, thisArg)
  * @param   Boolean   thisArg   `this` context for callback function
  * @return  Void
  */ forEach(callback) {
                        let thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                        let pairs = getHeaders(this);
                        let i = 0;
                        while(i < pairs.length){
                            var _pairs$i = pairs[i];
                            const name = _pairs$i[0], value = _pairs$i[1];
                            callback.call(thisArg, value, name, this);
                            pairs = getHeaders(this);
                            i++;
                        }
                    }
                    /**
  * Overwrite header values given name
  *
  * @param   String  name   Header name
  * @param   String  value  Header value
  * @return  Void
  */ set(name, value) {
                        name = `${name}`;
                        value = `${value}`;
                        validateName(name);
                        validateValue(value);
                        const key = find(this[MAP], name);
                        this[MAP][key !== undefined ? key : name] = [
                            value
                        ];
                    }
                    /**
  * Append a value onto existing header
  *
  * @param   String  name   Header name
  * @param   String  value  Header value
  * @return  Void
  */ append(name, value) {
                        name = `${name}`;
                        value = `${value}`;
                        validateName(name);
                        validateValue(value);
                        const key = find(this[MAP], name);
                        if (key !== undefined) this[MAP][key].push(value);
                        else this[MAP][name] = [
                            value
                        ];
                    }
                    /**
  * Check for header name existence
  *
  * @param   String   name  Header name
  * @return  Boolean
  */ has(name) {
                        name = `${name}`;
                        validateName(name);
                        return find(this[MAP], name) !== undefined;
                    }
                    /**
  * Delete all header values given name
  *
  * @param   String  name  Header name
  * @return  Void
  */ delete(name) {
                        name = `${name}`;
                        validateName(name);
                        const key = find(this[MAP], name);
                        if (key !== undefined) delete this[MAP][key];
                    }
                    /**
  * Return raw headers (non-spec api)
  *
  * @return  Object
  */ raw() {
                        return this[MAP];
                    }
                    /**
  * Get an iterator on keys.
  *
  * @return  Iterator
  */ keys() {
                        return createHeadersIterator(this, 'key');
                    }
                    /**
  * Get an iterator on values.
  *
  * @return  Iterator
  */ values() {
                        return createHeadersIterator(this, 'value');
                    }
                    /**
  * Get an iterator on entries.
  *
  * This is the default iterator of the Headers object.
  *
  * @return  Iterator
  */ [Symbol.iterator]() {
                        return createHeadersIterator(this, 'key+value');
                    }
                }
                Headers.prototype.entries = Headers.prototype[Symbol.iterator];
                Object.defineProperty(Headers.prototype, Symbol.toStringTag, {
                    value: 'Headers',
                    writable: false,
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperties(Headers.prototype, {
                    get: {
                        enumerable: true
                    },
                    forEach: {
                        enumerable: true
                    },
                    set: {
                        enumerable: true
                    },
                    append: {
                        enumerable: true
                    },
                    has: {
                        enumerable: true
                    },
                    delete: {
                        enumerable: true
                    },
                    keys: {
                        enumerable: true
                    },
                    values: {
                        enumerable: true
                    },
                    entries: {
                        enumerable: true
                    }
                });
                function getHeaders(headers) {
                    let kind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key+value';
                    const keys = Object.keys(headers[MAP]).sort();
                    return keys.map(kind === 'key' ? function(k) {
                        return k.toLowerCase();
                    } : kind === 'value' ? function(k) {
                        return headers[MAP][k].join(', ');
                    } : function(k) {
                        return [
                            k.toLowerCase(),
                            headers[MAP][k].join(', ')
                        ];
                    });
                }
                const INTERNAL = Symbol('internal');
                function createHeadersIterator(target, kind) {
                    const iterator = Object.create(HeadersIteratorPrototype);
                    iterator[INTERNAL] = {
                        target: target,
                        kind: kind,
                        index: 0
                    };
                    return iterator;
                }
                const HeadersIteratorPrototype = Object.setPrototypeOf({
                    next () {
                        // istanbul ignore if
                        if (!this || Object.getPrototypeOf(this) !== HeadersIteratorPrototype) throw new TypeError('Value of `this` is not a HeadersIterator');
                        var _INTERNAL = this[INTERNAL];
                        const target = _INTERNAL.target, kind = _INTERNAL.kind, index = _INTERNAL.index;
                        const values = getHeaders(target, kind);
                        const len = values.length;
                        if (index >= len) return {
                            value: undefined,
                            done: true
                        };
                        this[INTERNAL].index = index + 1;
                        return {
                            value: values[index],
                            done: false
                        };
                    }
                }, Object.getPrototypeOf(Object.getPrototypeOf([][Symbol.iterator]())));
                Object.defineProperty(HeadersIteratorPrototype, Symbol.toStringTag, {
                    value: 'HeadersIterator',
                    writable: false,
                    enumerable: false,
                    configurable: true
                });
                /**
 * Export the Headers object in a form that Node.js can consume.
 *
 * @param   Headers  headers
 * @return  Object
 */ function exportNodeCompatibleHeaders(headers) {
                    const obj = Object.assign({
                        __proto__: null
                    }, headers[MAP]);
                    // http.request() only supports string as Host header. This hack makes
                    // specifying custom Host header possible.
                    const hostHeaderKey = find(headers[MAP], 'Host');
                    if (hostHeaderKey !== undefined) obj[hostHeaderKey] = obj[hostHeaderKey][0];
                    return obj;
                }
                /**
 * Create a Headers object from an object of headers, ignoring those that do
 * not conform to HTTP grammar productions.
 *
 * @param   Object  obj  Object of headers
 * @return  Headers
 */ function createHeadersLenient(obj) {
                    const headers = new Headers();
                    for (const name of Object.keys(obj)){
                        if (invalidTokenRegex.test(name)) continue;
                        if (Array.isArray(obj[name])) for (const val of obj[name]){
                            if (invalidHeaderCharRegex.test(val)) continue;
                            if (headers[MAP][name] === undefined) headers[MAP][name] = [
                                val
                            ];
                            else headers[MAP][name].push(val);
                        }
                        else if (!invalidHeaderCharRegex.test(obj[name])) headers[MAP][name] = [
                            obj[name]
                        ];
                    }
                    return headers;
                }
                /**
 * response.js
 *
 * Response class provides content decoding
 */ var _require$1 = require1('http');
                const STATUS_CODES = _require$1.STATUS_CODES;
                const INTERNALS$1 = Symbol('Response internals');
                /**
 * Response class
 *
 * @param   Stream  body  Readable stream
 * @param   Object  opts  Response options
 * @return  Void
 */ class Response {
                    constructor(){
                        let body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        Body.call(this, body, opts);
                        const status = opts.status || 200;
                        this[INTERNALS$1] = {
                            url: opts.url,
                            status: status,
                            statusText: opts.statusText || STATUS_CODES[status],
                            headers: new Headers(opts.headers)
                        };
                    }
                    get url() {
                        return this[INTERNALS$1].url;
                    }
                    get status() {
                        return this[INTERNALS$1].status;
                    }
                    /**
  * Convenience property representing if the request ended normally
  */ get ok() {
                        return this[INTERNALS$1].status >= 200 && this[INTERNALS$1].status < 300;
                    }
                    get statusText() {
                        return this[INTERNALS$1].statusText;
                    }
                    get headers() {
                        return this[INTERNALS$1].headers;
                    }
                    /**
  * Clone this response
  *
  * @return  Response
  */ clone() {
                        return new Response(clone(this), {
                            url: this.url,
                            status: this.status,
                            statusText: this.statusText,
                            headers: this.headers,
                            ok: this.ok
                        });
                    }
                }
                Body.mixIn(Response.prototype);
                Object.defineProperties(Response.prototype, {
                    url: {
                        enumerable: true
                    },
                    status: {
                        enumerable: true
                    },
                    ok: {
                        enumerable: true
                    },
                    statusText: {
                        enumerable: true
                    },
                    headers: {
                        enumerable: true
                    },
                    clone: {
                        enumerable: true
                    }
                });
                Object.defineProperty(Response.prototype, Symbol.toStringTag, {
                    value: 'Response',
                    writable: false,
                    enumerable: false,
                    configurable: true
                });
                /**
 * request.js
 *
 * Request class contains server only options
 *
 * All spec algorithm step numbers are based on https://fetch.spec.whatwg.org/commit-snapshots/ae716822cb3a61843226cd090eefc6589446c1d2/.
 */ var _require$2 = require1('url');
                const format_url = _require$2.format;
                const parse_url = _require$2.parse;
                const INTERNALS$2 = Symbol('Request internals');
                /**
 * Check if a value is an instance of Request.
 *
 * @param   Mixed   input
 * @return  Boolean
 */ function isRequest(input) {
                    return typeof input === 'object' && typeof input[INTERNALS$2] === 'object';
                }
                /**
 * Request class
 *
 * @param   Mixed   input  Url or Request instance
 * @param   Object  init   Custom options
 * @return  Void
 */ class Request {
                    constructor(input){
                        let init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        let parsedURL;
                        // normalize input
                        if (!isRequest(input)) {
                            if (input && input.href) // in order to support Node.js' Url objects; though WHATWG's URL objects
                            // will fall into this branch also (since their `toString()` will return
                            // `href` property anyway)
                            parsedURL = parse_url(input.href);
                            else // coerce input to a string before attempting to parse
                            parsedURL = parse_url(`${input}`);
                            input = {};
                        } else parsedURL = parse_url(input.url);
                        let method = init.method || input.method || 'GET';
                        method = method.toUpperCase();
                        if ((init.body != null || isRequest(input) && input.body !== null) && (method === 'GET' || method === 'HEAD')) throw new TypeError('Request with GET/HEAD method cannot have body');
                        let inputBody = init.body != null ? init.body : isRequest(input) && input.body !== null ? clone(input) : null;
                        Body.call(this, inputBody, {
                            timeout: init.timeout || input.timeout || 0,
                            size: init.size || input.size || 0
                        });
                        const headers = new Headers(init.headers || input.headers || {});
                        if (init.body != null) {
                            const contentType = extractContentType(this);
                            if (contentType !== null && !headers.has('Content-Type')) headers.append('Content-Type', contentType);
                        }
                        this[INTERNALS$2] = {
                            method: method,
                            redirect: init.redirect || input.redirect || 'follow',
                            headers: headers,
                            parsedURL: parsedURL
                        };
                        // node-fetch-only options
                        this.follow = init.follow !== undefined ? init.follow : input.follow !== undefined ? input.follow : 20;
                        this.compress = init.compress !== undefined ? init.compress : input.compress !== undefined ? input.compress : true;
                        this.counter = init.counter || input.counter || 0;
                        this.agent = init.agent || input.agent;
                    }
                    get method() {
                        return this[INTERNALS$2].method;
                    }
                    get url() {
                        return format_url(this[INTERNALS$2].parsedURL);
                    }
                    get headers() {
                        return this[INTERNALS$2].headers;
                    }
                    get redirect() {
                        return this[INTERNALS$2].redirect;
                    }
                    /**
  * Clone this request
  *
  * @return  Request
  */ clone() {
                        return new Request(this);
                    }
                }
                Body.mixIn(Request.prototype);
                Object.defineProperty(Request.prototype, Symbol.toStringTag, {
                    value: 'Request',
                    writable: false,
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperties(Request.prototype, {
                    method: {
                        enumerable: true
                    },
                    url: {
                        enumerable: true
                    },
                    headers: {
                        enumerable: true
                    },
                    redirect: {
                        enumerable: true
                    },
                    clone: {
                        enumerable: true
                    }
                });
                /**
 * Convert a Request to Node.js http request options.
 *
 * @param   Request  A Request instance
 * @return  Object   The options object to be passed to http.request
 */ function getNodeRequestOptions(request) {
                    const parsedURL = request[INTERNALS$2].parsedURL;
                    const headers = new Headers(request[INTERNALS$2].headers);
                    // fetch step 1.3
                    if (!headers.has('Accept')) headers.set('Accept', '*/*');
                    // Basic fetch
                    if (!parsedURL.protocol || !parsedURL.hostname) throw new TypeError('Only absolute URLs are supported');
                    if (!/^https?:$/.test(parsedURL.protocol)) throw new TypeError('Only HTTP(S) protocols are supported');
                    // HTTP-network-or-cache fetch steps 2.4-2.7
                    let contentLengthValue = null;
                    if (request.body == null && /^(POST|PUT)$/i.test(request.method)) contentLengthValue = '0';
                    if (request.body != null) {
                        const totalBytes = getTotalBytes(request);
                        if (typeof totalBytes === 'number') contentLengthValue = String(totalBytes);
                    }
                    if (contentLengthValue) headers.set('Content-Length', contentLengthValue);
                    // HTTP-network-or-cache fetch step 2.11
                    if (!headers.has('User-Agent')) headers.set('User-Agent', 'node-fetch/1.0 (+https://github.com/bitinn/node-fetch)');
                    // HTTP-network-or-cache fetch step 2.15
                    if (request.compress) headers.set('Accept-Encoding', 'gzip,deflate');
                    if (!headers.has('Connection') && !request.agent) headers.set('Connection', 'close');
                    // HTTP-network fetch step 4.2
                    // chunked encoding is handled by Node.js
                    return Object.assign({}, parsedURL, {
                        method: request.method,
                        headers: exportNodeCompatibleHeaders(headers),
                        agent: request.agent
                    });
                }
                /**
 * index.js
 *
 * a request API compatible with window.fetch
 *
 * All spec algorithm step numbers are based on https://fetch.spec.whatwg.org/commit-snapshots/ae716822cb3a61843226cd090eefc6589446c1d2/.
 */ const http = require1('http');
                const https = require1('https');
                var _require$3 = require1('stream');
                const PassThrough$1 = _require$3.PassThrough;
                var _require2 = require1('url');
                const resolve_url = _require2.resolve;
                const zlib = require1('zlib');
                /**
 * Fetch function
 *
 * @param   Mixed    url   Absolute url or Request instance
 * @param   Object   opts  Fetch options
 * @return  Promise
 */ function fetch1(url, opts) {
                    // allow custom promise
                    if (!fetch1.Promise) throw new Error('native promise missing, set fetch.Promise to your favorite alternative');
                    Body.Promise = fetch1.Promise;
                    // wrap http.request into fetch
                    return new fetch1.Promise(function(resolve, reject) {
                        // build request object
                        const request = new Request(url, opts);
                        const options = getNodeRequestOptions(request);
                        const send = (options.protocol === 'https:' ? https : http).request;
                        // send request
                        const req = send(options);
                        let reqTimeout;
                        function finalize() {
                            req.abort();
                            clearTimeout(reqTimeout);
                        }
                        if (request.timeout) req.once('socket', function(socket) {
                            reqTimeout = setTimeout(function() {
                                reject(new FetchError(`network timeout at: ${request.url}`, 'request-timeout'));
                                finalize();
                            }, request.timeout);
                        });
                        req.on('error', function(err) {
                            reject(new FetchError(`request to ${request.url} failed, reason: ${err.message}`, 'system', err));
                            finalize();
                        });
                        req.on('response', function(res) {
                            clearTimeout(reqTimeout);
                            const headers = createHeadersLenient(res.headers);
                            // HTTP fetch step 5
                            if (fetch1.isRedirect(res.statusCode)) {
                                // HTTP fetch step 5.2
                                const location = headers.get('Location');
                                // HTTP fetch step 5.3
                                const locationURL = location === null ? null : resolve_url(request.url, location);
                                // HTTP fetch step 5.5
                                switch(request.redirect){
                                    case 'error':
                                        reject(new FetchError(`redirect mode is set to error: ${request.url}`, 'no-redirect'));
                                        finalize();
                                        return;
                                    case 'manual':
                                        // node-fetch-specific step: make manual redirect a bit easier to use by setting the Location header value to the resolved URL.
                                        if (locationURL !== null) headers.set('Location', locationURL);
                                        break;
                                    case 'follow':
                                        // HTTP-redirect fetch step 2
                                        if (locationURL === null) break;
                                        // HTTP-redirect fetch step 5
                                        if (request.counter >= request.follow) {
                                            reject(new FetchError(`maximum redirect reached at: ${request.url}`, 'max-redirect'));
                                            finalize();
                                            return;
                                        }
                                        // HTTP-redirect fetch step 6 (counter increment)
                                        // Create a new Request object.
                                        const requestOpts = {
                                            headers: new Headers(request.headers),
                                            follow: request.follow,
                                            counter: request.counter + 1,
                                            agent: request.agent,
                                            compress: request.compress,
                                            method: request.method,
                                            body: request.body
                                        };
                                        // HTTP-redirect fetch step 9
                                        if (res.statusCode !== 303 && request.body && getTotalBytes(request) === null) {
                                            reject(new FetchError('Cannot follow redirect with body being a readable stream', 'unsupported-redirect'));
                                            finalize();
                                            return;
                                        }
                                        // HTTP-redirect fetch step 11
                                        if (res.statusCode === 303 || (res.statusCode === 301 || res.statusCode === 302) && request.method === 'POST') {
                                            requestOpts.method = 'GET';
                                            requestOpts.body = undefined;
                                            requestOpts.headers.delete('content-length');
                                        }
                                        // HTTP-redirect fetch step 15
                                        resolve(fetch1(new Request(locationURL, requestOpts)));
                                        finalize();
                                        return;
                                }
                            }
                            // prepare response
                            let body = res.pipe(new PassThrough$1());
                            const response_options = {
                                url: request.url,
                                status: res.statusCode,
                                statusText: res.statusMessage,
                                headers: headers,
                                size: request.size,
                                timeout: request.timeout
                            };
                            // HTTP-network fetch step 12.1.1.3
                            const codings = headers.get('Content-Encoding');
                            // HTTP-network fetch step 12.1.1.4: handle content codings
                            // in following scenarios we ignore compression support
                            // 1. compression support is disabled
                            // 2. HEAD request
                            // 3. no Content-Encoding header
                            // 4. no content response (204)
                            // 5. content not modified response (304)
                            if (!request.compress || request.method === 'HEAD' || codings === null || res.statusCode === 204 || res.statusCode === 304) {
                                resolve(new Response(body, response_options));
                                return;
                            }
                            // For Node v6+
                            // Be less strict when decoding compressed responses, since sometimes
                            // servers send slightly invalid responses that are still accepted
                            // by common browsers.
                            // Always using Z_SYNC_FLUSH is what cURL does.
                            const zlibOptions = {
                                flush: zlib.Z_SYNC_FLUSH,
                                finishFlush: zlib.Z_SYNC_FLUSH
                            };
                            // for gzip
                            if (codings == 'gzip' || codings == 'x-gzip') {
                                body = body.pipe(zlib.createGunzip(zlibOptions));
                                resolve(new Response(body, response_options));
                                return;
                            }
                            // for deflate
                            if (codings == 'deflate' || codings == 'x-deflate') {
                                // handle the infamous raw deflate response from old servers
                                // a hack for old IIS and Apache servers
                                const raw = res.pipe(new PassThrough$1());
                                raw.once('data', function(chunk) {
                                    // see http://stackoverflow.com/questions/37519828
                                    if ((chunk[0] & 0x0F) === 0x08) body = body.pipe(zlib.createInflate());
                                    else body = body.pipe(zlib.createInflateRaw());
                                    resolve(new Response(body, response_options));
                                });
                                return;
                            }
                            // otherwise, use response as-is
                            resolve(new Response(body, response_options));
                        });
                        writeToStream(req, request);
                    });
                }
                /**
 * Redirect code matching
 *
 * @param   Number   code  Status code
 * @return  Boolean
 */ fetch1.isRedirect = function(code) {
                    return code === 301 || code === 302 || code === 303 || code === 307 || code === 308;
                };
                // Needed for TypeScript.
                fetch1.default = fetch1;
                // expose Promise
                fetch1.Promise = global1.Promise;
                // Igor Kroitor 2019 Dec 30
                // expose http and https
                // https://github.com/ccxt/ccxt/issues/6327
                fetch1.http = http;
                fetch1.https = https;
                module.exports = exports = fetch1;
                exports.Headers = Headers;
                exports.Request = Request;
                exports.Response = Response;
                exports.FetchError = FetchError;
            }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {}, require1("buffer").Buffer);
        },
        {
            "buffer": 182,
            "http": 224,
            "https": 187,
            "stream": 223,
            "url": 230,
            "zlib": 181
        }
    ],
    140: [
        function(require1, module, exports) {
            (function(Buffer) {
                /*!
 * RSA library for Node.js
 *
 * Author: rzcoder
 * License MIT
 */ var rsa = require1('./libs/rsa.js');
                var _ = require1('./utils')._;
                var schemes = require1('./schemes/schemes.js');
                var formats = require1('./formats/formats.js');
                module.exports = function() {
                    var SUPPORTED_HASH_ALGORITHMS = {
                        browser: [
                            'md5',
                            'ripemd160',
                            'sha1',
                            'sha256',
                            'sha512'
                        ]
                    };
                    var DEFAULT_ENCRYPTION_SCHEME = 'pkcs1';
                    var DEFAULT_SIGNING_SCHEME = 'pkcs1';
                    var EXPORT_FORMAT_ALIASES = {
                        'private': 'pkcs1-private-pem',
                        'private-der': 'pkcs1-private-der',
                        'public': 'pkcs8-public-pem',
                        'public-der': 'pkcs8-public-der'
                    };
                    /**
     * @param key {string|buffer|object} Key in PEM format, or data for generate key {b: bits, e: exponent}
     * @constructor
     */ function NodeRSA(key, format, options) {
                        if (!(this instanceof NodeRSA)) return new NodeRSA(key, format, options);
                        if (_.isObject(format)) {
                            options = format;
                            format = undefined;
                        }
                        this.$options = {
                            signingScheme: DEFAULT_SIGNING_SCHEME,
                            signingSchemeOptions: {
                                hash: 'sha256',
                                saltLength: null
                            },
                            encryptionScheme: DEFAULT_ENCRYPTION_SCHEME,
                            encryptionSchemeOptions: {
                                hash: 'sha1',
                                label: null
                            },
                            environment: 'browser',
                            rsaUtils: this
                        };
                        this.keyPair = new rsa.Key();
                        this.$cache = {};
                        if (Buffer.isBuffer(key) || _.isString(key)) this.importKey(key, format);
                        else if (_.isObject(key)) this.generateKeyPair(key.b, key.e);
                        this.setOptions(options);
                    }
                    /**
     * Set and validate options for key instance
     * @param options
     */ NodeRSA.prototype.setOptions = function(options) {
                        options = options || {};
                        if (options.environment) this.$options.environment = options.environment;
                        if (options.signingScheme) {
                            if (_.isString(options.signingScheme)) {
                                var signingScheme = options.signingScheme.toLowerCase().split('-');
                                if (signingScheme.length == 1) {
                                    if (SUPPORTED_HASH_ALGORITHMS.node.indexOf(signingScheme[0]) > -1) {
                                        this.$options.signingSchemeOptions = {
                                            hash: signingScheme[0]
                                        };
                                        this.$options.signingScheme = DEFAULT_SIGNING_SCHEME;
                                    } else {
                                        this.$options.signingScheme = signingScheme[0];
                                        this.$options.signingSchemeOptions = {
                                            hash: null
                                        };
                                    }
                                } else {
                                    this.$options.signingSchemeOptions = {
                                        hash: signingScheme[1]
                                    };
                                    this.$options.signingScheme = signingScheme[0];
                                }
                            } else if (_.isObject(options.signingScheme)) {
                                this.$options.signingScheme = options.signingScheme.scheme || DEFAULT_SIGNING_SCHEME;
                                this.$options.signingSchemeOptions = _.omit(options.signingScheme, 'scheme');
                            }
                            if (!schemes.isSignature(this.$options.signingScheme)) throw Error('Unsupported signing scheme');
                            if (this.$options.signingSchemeOptions.hash && SUPPORTED_HASH_ALGORITHMS[this.$options.environment].indexOf(this.$options.signingSchemeOptions.hash) === -1) throw Error('Unsupported hashing algorithm for ' + this.$options.environment + ' environment');
                        }
                        if (options.encryptionScheme) {
                            if (_.isString(options.encryptionScheme)) {
                                this.$options.encryptionScheme = options.encryptionScheme.toLowerCase();
                                this.$options.encryptionSchemeOptions = {};
                            } else if (_.isObject(options.encryptionScheme)) {
                                this.$options.encryptionScheme = options.encryptionScheme.scheme || DEFAULT_ENCRYPTION_SCHEME;
                                this.$options.encryptionSchemeOptions = _.omit(options.encryptionScheme, 'scheme');
                            }
                            if (!schemes.isEncryption(this.$options.encryptionScheme)) throw Error('Unsupported encryption scheme');
                            if (this.$options.encryptionSchemeOptions.hash && SUPPORTED_HASH_ALGORITHMS[this.$options.environment].indexOf(this.$options.encryptionSchemeOptions.hash) === -1) throw Error('Unsupported hashing algorithm for ' + this.$options.environment + ' environment');
                        }
                        this.keyPair.setOptions(this.$options);
                    };
                    /**
     * Importing key
     * @param keyData {string|buffer|Object}
     * @param format {string}
     */ NodeRSA.prototype.importKey = function(keyData, format) {
                        if (!keyData) throw Error("Empty key given");
                        if (format) format = EXPORT_FORMAT_ALIASES[format] || format;
                        if (!formats.detectAndImport(this.keyPair, keyData, format) && format === undefined) throw Error("Key format must be specified");
                        this.$cache = {};
                        return this;
                    };
                    /**
     * Check if key pair contains private key
     */ NodeRSA.prototype.isPrivate = function() {
                        return this.keyPair.isPrivate();
                    };
                    /**
     * Check if key pair contains public key
     * @param [strict] {boolean} - public key only, return false if have private exponent
     */ NodeRSA.prototype.isPublic = function(strict) {
                        return this.keyPair.isPublic(strict);
                    };
                    /**
     * Check if key pair doesn't contains any data
     */ NodeRSA.prototype.isEmpty = function(strict) {
                        return !(this.keyPair.n || this.keyPair.e || this.keyPair.d);
                    };
                    /**
     *  Signing data
     *
     * @param buffer {string|number|object|array|Buffer} - data for signing. Object and array will convert to JSON string.
     * @param encoding {string} - optional. Encoding for output result, may be 'buffer', 'binary', 'hex' or 'base64'. Default 'buffer'.
     * @param source_encoding {string} - optional. Encoding for given string. Default utf8.
     * @returns {string|Buffer}
     */ NodeRSA.prototype.sign = function(buffer, encoding, source_encoding) {
                        if (!this.isPrivate()) throw Error("This is not private key");
                        var res = this.keyPair.sign(this.$getDataForEncrypt(buffer, source_encoding));
                        if (encoding && encoding != 'buffer') res = res.toString(encoding);
                        return res;
                    };
                    /**
     * Preparing given data for encrypting/signing. Just make new/return Buffer object.
     *
     * @param buffer {string|number|object|array|Buffer} - data for encrypting. Object and array will convert to JSON string.
     * @param encoding {string} - optional. Encoding for given string. Default utf8.
     * @returns {Buffer}
     */ NodeRSA.prototype.$getDataForEncrypt = function(buffer, encoding) {
                        if (_.isString(buffer) || _.isNumber(buffer)) return Buffer.from('' + buffer, encoding || 'utf8');
                        else if (Buffer.isBuffer(buffer)) return buffer;
                        else if (_.isObject(buffer)) return Buffer.from(JSON.stringify(buffer));
                        else throw Error("Unexpected data type");
                    };
                    return NodeRSA;
                }();
            }).call(this, require1("buffer").Buffer);
        },
        {
            "./formats/formats.js": 147,
            "./libs/rsa.js": 151,
            "./schemes/schemes.js": 153,
            "./utils": 154,
            "buffer": 182
        }
    ],
    141: [
        function(require1, module, exports) {
            // Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
            module.exports = {
                newInvalidAsn1Error: function(msg) {
                    var e = new Error();
                    e.name = 'InvalidAsn1Error';
                    e.message = msg || '';
                    return e;
                }
            };
        },
        {}
    ],
    142: [
        function(require1, module, exports) {
            // Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
            var errors = require1('./errors');
            var types = require1('./types');
            var Reader = require1('./reader');
            // --- Exports
            module.exports = {
                Reader: Reader
            };
            for(var t in types)if (types.hasOwnProperty(t)) module.exports[t] = types[t];
            for(var e in errors)if (errors.hasOwnProperty(e)) module.exports[e] = errors[e];
        },
        {
            "./errors": 141,
            "./reader": 143,
            "./types": 144
        }
    ],
    143: [
        function(require1, module, exports) {
            (function(Buffer) {
                // Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
                var assert = require1('assert');
                // var Buffer = require('safer-buffer').Buffer;
                var ASN1 = require1('./types');
                var errors = require1('./errors');
                // --- Globals
                var newInvalidAsn1Error = errors.newInvalidAsn1Error;
                // --- API
                function Reader(data) {
                    if (!data || !Buffer.isBuffer(data)) throw new TypeError('data must be a node Buffer');
                    this._buf = data;
                    this._size = data.length;
                    // These hold the "current" state
                    this._len = 0;
                    this._offset = 0;
                }
                Object.defineProperty(Reader.prototype, 'length', {
                    enumerable: true,
                    get: function() {
                        return this._len;
                    }
                });
                Object.defineProperty(Reader.prototype, 'offset', {
                    enumerable: true,
                    get: function() {
                        return this._offset;
                    }
                });
                Object.defineProperty(Reader.prototype, 'remain', {
                    get: function() {
                        return this._size - this._offset;
                    }
                });
                Object.defineProperty(Reader.prototype, 'buffer', {
                    get: function() {
                        return this._buf.slice(this._offset);
                    }
                });
                /**
 * Reads a single byte and advances offset; you can pass in `true` to make this
 * a "peek" operation (i.e., get the byte, but don't advance the offset).
 *
 * @param {Boolean} peek true means don't move offset.
 * @return {Number} the next byte, null if not enough data.
 */ Reader.prototype.readByte = function(peek) {
                    if (this._size - this._offset < 1) return null;
                    var b = this._buf[this._offset] & 0xff;
                    if (!peek) this._offset += 1;
                    return b;
                };
                Reader.prototype.peek = function() {
                    return this.readByte(true);
                };
                /**
 * Reads a (potentially) variable length off the BER buffer.  This call is
 * not really meant to be called directly, as callers have to manipulate
 * the internal buffer afterwards.
 *
 * As a result of this call, you can call `Reader.length`, until the
 * next thing called that does a readLength.
 *
 * @return {Number} the amount of offset to advance the buffer.
 * @throws {InvalidAsn1Error} on bad ASN.1
 */ Reader.prototype.readLength = function(offset) {
                    if (offset === undefined) offset = this._offset;
                    if (offset >= this._size) return null;
                    var lenB = this._buf[offset++] & 0xff;
                    if (lenB === null) return null;
                    if ((lenB & 0x80) === 0x80) {
                        lenB &= 0x7f;
                        if (lenB === 0) throw newInvalidAsn1Error('Indefinite length not supported');
                        if (lenB > 4) throw newInvalidAsn1Error('encoding too long');
                        if (this._size - offset < lenB) return null;
                        this._len = 0;
                        for(var i = 0; i < lenB; i++)this._len = (this._len << 8) + (this._buf[offset++] & 0xff);
                    } else // Wasn't a variable length
                    this._len = lenB;
                    return offset;
                };
                /**
 * Parses the next sequence in this BER buffer.
 *
 * To get the length of the sequence, call `Reader.length`.
 *
 * @return {Number} the sequence's tag.
 */ Reader.prototype.readSequence = function(tag) {
                    var seq = this.peek();
                    if (seq === null) return null;
                    if (tag !== undefined && tag !== seq) throw newInvalidAsn1Error('Expected 0x' + tag.toString(16) + ': got 0x' + seq.toString(16));
                    var o = this.readLength(this._offset + 1); // stored in `length`
                    if (o === null) return null;
                    this._offset = o;
                    return seq;
                };
                Reader.prototype.readInt = function() {
                    return this._readTag(ASN1.Integer);
                };
                Reader.prototype.readBoolean = function() {
                    return this._readTag(ASN1.Boolean) === 0 ? false : true;
                };
                Reader.prototype.readEnumeration = function() {
                    return this._readTag(ASN1.Enumeration);
                };
                Reader.prototype.readString = function(tag, retbuf) {
                    if (!tag) tag = ASN1.OctetString;
                    var b = this.peek();
                    if (b === null) return null;
                    if (b !== tag) throw newInvalidAsn1Error('Expected 0x' + tag.toString(16) + ': got 0x' + b.toString(16));
                    var o = this.readLength(this._offset + 1); // stored in `length`
                    if (o === null) return null;
                    if (this.length > this._size - o) return null;
                    this._offset = o;
                    if (this.length === 0) return retbuf ? Buffer.alloc(0) : '';
                    var str = this._buf.slice(this._offset, this._offset + this.length);
                    this._offset += this.length;
                    return retbuf ? str : str.toString('utf8');
                };
                Reader.prototype.readOID = function(tag) {
                    if (!tag) tag = ASN1.OID;
                    var b = this.readString(tag, true);
                    if (b === null) return null;
                    var values = [];
                    var value = 0;
                    for(var i = 0; i < b.length; i++){
                        var byte = b[i] & 0xff;
                        value <<= 7;
                        value += byte & 0x7f;
                        if ((byte & 0x80) === 0) {
                            values.push(value);
                            value = 0;
                        }
                    }
                    value = values.shift();
                    values.unshift(value % 40);
                    values.unshift(value / 40 >> 0);
                    return values.join('.');
                };
                Reader.prototype._readTag = function(tag) {
                    assert.ok(tag !== undefined);
                    var b = this.peek();
                    if (b === null) return null;
                    if (b !== tag) throw newInvalidAsn1Error('Expected 0x' + tag.toString(16) + ': got 0x' + b.toString(16));
                    var o = this.readLength(this._offset + 1); // stored in `length`
                    if (o === null) return null;
                    if (this.length > 4) throw newInvalidAsn1Error('Integer too long: ' + this.length);
                    if (this.length > this._size - o) return null;
                    this._offset = o;
                    var fb = this._buf[this._offset];
                    var value = 0;
                    for(var i = 0; i < this.length; i++){
                        value <<= 8;
                        value |= this._buf[this._offset++] & 0xff;
                    }
                    if ((fb & 0x80) === 0x80 && i !== 4) value -= 1 << i * 8;
                    return value >> 0;
                };
                // --- Exported API
                module.exports = Reader;
            }).call(this, require1("buffer").Buffer);
        },
        {
            "./errors": 141,
            "./types": 144,
            "assert": 177,
            "buffer": 182
        }
    ],
    144: [
        function(require1, module, exports) {
            // Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
            module.exports = {
                EOC: 0,
                Boolean: 1,
                Integer: 2,
                BitString: 3,
                OctetString: 4,
                Null: 5,
                OID: 6,
                ObjectDescriptor: 7,
                External: 8,
                Real: 9,
                Enumeration: 10,
                PDV: 11,
                Utf8String: 12,
                RelativeOID: 13,
                Sequence: 16,
                Set: 17,
                NumericString: 18,
                PrintableString: 19,
                T61String: 20,
                VideotexString: 21,
                IA5String: 22,
                UTCTime: 23,
                GeneralizedTime: 24,
                GraphicString: 25,
                VisibleString: 26,
                GeneralString: 28,
                UniversalString: 29,
                CharacterString: 30,
                BMPString: 31,
                Constructor: 32,
                Context: 128
            };
        },
        {}
    ],
    145: [
        function(require1, module, exports) {
            // Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
            // If you have no idea what ASN.1 or BER is, see this:
            // ftp://ftp.rsa.com/pub/pkcs/ascii/layman.asc
            var Ber = require1('./ber/index');
            // --- Exported API
            module.exports = {
                Ber: Ber,
                BerReader: Ber.Reader
            };
        },
        {
            "./ber/index": 142
        }
    ],
    146: [
        function(require1, module, exports) {
            var _ = require1('../utils')._;
            var utils = require1('../utils');
            module.exports = {
                privateExport: function(key, options) {
                    return {
                        n: key.n.toBuffer(),
                        e: key.e,
                        d: key.d.toBuffer(),
                        p: key.p.toBuffer(),
                        q: key.q.toBuffer(),
                        dmp1: key.dmp1.toBuffer(),
                        dmq1: key.dmq1.toBuffer(),
                        coeff: key.coeff.toBuffer()
                    };
                },
                privateImport: function(key, data, options) {
                    if (data.n && data.e && data.d && data.p && data.q && data.dmp1 && data.dmq1 && data.coeff) key.setPrivate(data.n, data.e, data.d, data.p, data.q, data.dmp1, data.dmq1, data.coeff);
                    else throw Error("Invalid key data");
                },
                publicExport: function(key, options) {
                    return {
                        n: key.n.toBuffer(),
                        e: key.e
                    };
                },
                publicImport: function(key, data, options) {
                    if (data.n && data.e) key.setPublic(data.n, data.e);
                    else throw Error("Invalid key data");
                },
                /**
     * Trying autodetect and import key
     * @param key
     * @param data
     */ autoImport: function(key, data) {
                    if (data.n && data.e) {
                        if (data.d && data.p && data.q && data.dmp1 && data.dmq1 && data.coeff) {
                            module.exports.privateImport(key, data);
                            return true;
                        } else {
                            module.exports.publicImport(key, data);
                            return true;
                        }
                    }
                    return false;
                }
            };
        },
        {
            "../utils": 154
        }
    ],
    147: [
        function(require1, module, exports) {
            var _ = require1('../utils')._;
            module.exports = {
                pkcs1: require1('./pkcs1'),
                pkcs8: require1('./pkcs8'),
                components: require1('./components'),
                detectAndImport: function(key, data, format) {
                    if (format === undefined) for(var scheme in module.exports){
                        if (typeof module.exports[scheme].autoImport === 'function' && module.exports[scheme].autoImport(key, data)) return true;
                    }
                    else if (format) {
                        var fmt = formatParse(format);
                        if (module.exports[fmt.scheme]) {
                            if (fmt.keyType === 'private') module.exports[fmt.scheme].privateImport(key, data, fmt.keyOpt);
                            else module.exports[fmt.scheme].publicImport(key, data, fmt.keyOpt);
                        } else throw Error('Unsupported key format');
                    }
                    return false;
                }
            };
        },
        {
            "../utils": 154,
            "./components": 146,
            "./pkcs1": 148,
            "./pkcs8": 149
        }
    ],
    148: [
        function(require1, module, exports) {
            (function(Buffer) {
                var ber = require1('../asn1/index').Ber;
                var _ = require1('../utils')._;
                var utils = require1('../utils');
                const PRIVATE_OPENING_BOUNDARY = '-----BEGIN RSA PRIVATE KEY-----';
                const PRIVATE_CLOSING_BOUNDARY = '-----END RSA PRIVATE KEY-----';
                const PUBLIC_OPENING_BOUNDARY = '-----BEGIN RSA PUBLIC KEY-----';
                const PUBLIC_CLOSING_BOUNDARY = '-----END RSA PUBLIC KEY-----';
                module.exports = {
                    privateExport: function(key, options) {
                        options = options || {};
                        var n = key.n.toBuffer();
                        var d = key.d.toBuffer();
                        var p = key.p.toBuffer();
                        var q = key.q.toBuffer();
                        var dmp1 = key.dmp1.toBuffer();
                        var dmq1 = key.dmq1.toBuffer();
                        var coeff = key.coeff.toBuffer();
                        var length = n.length + d.length + p.length + q.length + dmp1.length + dmq1.length + coeff.length + 512; // magic
                        var writer = new ber.Writer({
                            size: length
                        });
                        writer.startSequence();
                        writer.writeInt(0);
                        writer.writeBuffer(n, 2);
                        writer.writeInt(key.e);
                        writer.writeBuffer(d, 2);
                        writer.writeBuffer(p, 2);
                        writer.writeBuffer(q, 2);
                        writer.writeBuffer(dmp1, 2);
                        writer.writeBuffer(dmq1, 2);
                        writer.writeBuffer(coeff, 2);
                        writer.endSequence();
                        if (options.type === 'der') return writer.buffer;
                        else return PRIVATE_OPENING_BOUNDARY + '\n' + utils.linebrk(writer.buffer.toString('base64'), 64) + '\n' + PRIVATE_CLOSING_BOUNDARY;
                    },
                    privateImport: function(key, data, options) {
                        options = options || {};
                        var buffer;
                        if (options.type !== 'der') {
                            if (Buffer.isBuffer(data)) data = data.toString('utf8');
                            if (_.isString(data)) {
                                var pem = utils.trimSurroundingText(data, PRIVATE_OPENING_BOUNDARY, PRIVATE_CLOSING_BOUNDARY).replace(/\s+|\n\r|\n|\r$/gm, '');
                                buffer = Buffer.from(pem, 'base64');
                            } else throw Error('Unsupported key format');
                        } else if (Buffer.isBuffer(data)) buffer = data;
                        else throw Error('Unsupported key format');
                        var reader = new ber.Reader(buffer);
                        reader.readSequence();
                        reader.readString(2, true); // just zero
                        key.setPrivate(reader.readString(2, true), reader.readString(2, true), reader.readString(2, true), reader.readString(2, true), reader.readString(2, true), reader.readString(2, true), reader.readString(2, true), reader.readString(2, true) // coefficient -- (inverse of q) mod p
                        );
                    },
                    publicExport: function(key, options) {
                        options = options || {};
                        var n = key.n.toBuffer();
                        var length = n.length + 512; // magic
                        var bodyWriter = new ber.Writer({
                            size: length
                        });
                        bodyWriter.startSequence();
                        bodyWriter.writeBuffer(n, 2);
                        bodyWriter.writeInt(key.e);
                        bodyWriter.endSequence();
                        if (options.type === 'der') return bodyWriter.buffer;
                        else return PUBLIC_OPENING_BOUNDARY + '\n' + utils.linebrk(bodyWriter.buffer.toString('base64'), 64) + '\n' + PUBLIC_CLOSING_BOUNDARY;
                    },
                    publicImport: function(key, data, options) {
                        options = options || {};
                        var buffer;
                        if (options.type !== 'der') {
                            if (Buffer.isBuffer(data)) data = data.toString('utf8');
                            if (_.isString(data)) {
                                var pem = utils.trimSurroundingText(data, PUBLIC_OPENING_BOUNDARY, PUBLIC_CLOSING_BOUNDARY).replace(/\s+|\n\r|\n|\r$/gm, '');
                                buffer = Buffer.from(pem, 'base64');
                            }
                        } else if (Buffer.isBuffer(data)) buffer = data;
                        else throw Error('Unsupported key format');
                        var body = new ber.Reader(buffer);
                        body.readSequence();
                        key.setPublic(body.readString(0x02, true), body.readString(0x02, true) // publicExponent
                        );
                    },
                    /**
     * Trying autodetect and import key
     * @param key
     * @param data
     */ autoImport: function(key, data) {
                        // [\S\s]* matches zero or more of any character
                        if (/^[\S\s]*-----BEGIN RSA PRIVATE KEY-----\s*(?=(([A-Za-z0-9+/=]+\s*)+))\1-----END RSA PRIVATE KEY-----[\S\s]*$/g.test(data)) {
                            module.exports.privateImport(key, data);
                            return true;
                        }
                        if (/^[\S\s]*-----BEGIN RSA PUBLIC KEY-----\s*(?=(([A-Za-z0-9+/=]+\s*)+))\1-----END RSA PUBLIC KEY-----[\S\s]*$/g.test(data)) {
                            module.exports.publicImport(key, data);
                            return true;
                        }
                        return false;
                    }
                };
            }).call(this, require1("buffer").Buffer);
        },
        {
            "../asn1/index": 145,
            "../utils": 154,
            "buffer": 182
        }
    ],
    149: [
        function(require1, module, exports) {
            (function(Buffer) {
                var ber = require1('../asn1/index').Ber;
                var _ = require1('../utils')._;
                var PUBLIC_RSA_OID = '1.2.840.113549.1.1.1';
                var utils = require1('../utils');
                const PRIVATE_OPENING_BOUNDARY = '-----BEGIN PRIVATE KEY-----';
                const PRIVATE_CLOSING_BOUNDARY = '-----END PRIVATE KEY-----';
                const PUBLIC_OPENING_BOUNDARY = '-----BEGIN PUBLIC KEY-----';
                const PUBLIC_CLOSING_BOUNDARY = '-----END PUBLIC KEY-----';
                module.exports = {
                    privateExport: function(key, options) {
                        options = options || {};
                        var n = key.n.toBuffer();
                        var d = key.d.toBuffer();
                        var p = key.p.toBuffer();
                        var q = key.q.toBuffer();
                        var dmp1 = key.dmp1.toBuffer();
                        var dmq1 = key.dmq1.toBuffer();
                        var coeff = key.coeff.toBuffer();
                        var length = n.length + d.length + p.length + q.length + dmp1.length + dmq1.length + coeff.length + 512; // magic
                        var bodyWriter = new ber.Writer({
                            size: length
                        });
                        bodyWriter.startSequence();
                        bodyWriter.writeInt(0);
                        bodyWriter.writeBuffer(n, 2);
                        bodyWriter.writeInt(key.e);
                        bodyWriter.writeBuffer(d, 2);
                        bodyWriter.writeBuffer(p, 2);
                        bodyWriter.writeBuffer(q, 2);
                        bodyWriter.writeBuffer(dmp1, 2);
                        bodyWriter.writeBuffer(dmq1, 2);
                        bodyWriter.writeBuffer(coeff, 2);
                        bodyWriter.endSequence();
                        var writer = new ber.Writer({
                            size: length
                        });
                        writer.startSequence();
                        writer.writeInt(0);
                        writer.startSequence();
                        writer.writeOID(PUBLIC_RSA_OID);
                        writer.writeNull();
                        writer.endSequence();
                        writer.writeBuffer(bodyWriter.buffer, 4);
                        writer.endSequence();
                        if (options.type === 'der') return writer.buffer;
                        else return PRIVATE_OPENING_BOUNDARY + '\n' + utils.linebrk(writer.buffer.toString('base64'), 64) + '\n' + PRIVATE_CLOSING_BOUNDARY;
                    },
                    privateImport: function(key, data, options) {
                        options = options || {};
                        var buffer;
                        if (options.type !== 'der') {
                            if (Buffer.isBuffer(data)) data = data.toString('utf8');
                            if (_.isString(data)) {
                                var pem = utils.trimSurroundingText(data, PRIVATE_OPENING_BOUNDARY, PRIVATE_CLOSING_BOUNDARY).replace('-----END PRIVATE KEY-----', '').replace(/\s+|\n\r|\n|\r$/gm, '');
                                buffer = Buffer.from(pem, 'base64');
                            } else throw Error('Unsupported key format');
                        } else if (Buffer.isBuffer(data)) buffer = data;
                        else throw Error('Unsupported key format');
                        var reader = new ber.Reader(buffer);
                        reader.readSequence();
                        reader.readInt(0);
                        var header = new ber.Reader(reader.readString(0x30, true));
                        if (header.readOID(0x06, true) !== PUBLIC_RSA_OID) throw Error('Invalid Public key format');
                        var body = new ber.Reader(reader.readString(0x04, true));
                        body.readSequence();
                        body.readString(2, true); // just zero
                        key.setPrivate(body.readString(2, true), body.readString(2, true), body.readString(2, true), body.readString(2, true), body.readString(2, true), body.readString(2, true), body.readString(2, true), body.readString(2, true) // coefficient -- (inverse of q) mod p
                        );
                    },
                    publicExport: function(key, options) {
                        options = options || {};
                        var n = key.n.toBuffer();
                        var length = n.length + 512; // magic
                        var bodyWriter = new ber.Writer({
                            size: length
                        });
                        bodyWriter.writeByte(0);
                        bodyWriter.startSequence();
                        bodyWriter.writeBuffer(n, 2);
                        bodyWriter.writeInt(key.e);
                        bodyWriter.endSequence();
                        var writer = new ber.Writer({
                            size: length
                        });
                        writer.startSequence();
                        writer.startSequence();
                        writer.writeOID(PUBLIC_RSA_OID);
                        writer.writeNull();
                        writer.endSequence();
                        writer.writeBuffer(bodyWriter.buffer, 3);
                        writer.endSequence();
                        if (options.type === 'der') return writer.buffer;
                        else return PUBLIC_OPENING_BOUNDARY + '\n' + utils.linebrk(writer.buffer.toString('base64'), 64) + '\n' + PUBLIC_CLOSING_BOUNDARY;
                    },
                    publicImport: function(key, data, options) {
                        options = options || {};
                        var buffer;
                        if (options.type !== 'der') {
                            if (Buffer.isBuffer(data)) data = data.toString('utf8');
                            if (_.isString(data)) {
                                var pem = utils.trimSurroundingText(data, PUBLIC_OPENING_BOUNDARY, PUBLIC_CLOSING_BOUNDARY).replace(/\s+|\n\r|\n|\r$/gm, '');
                                buffer = Buffer.from(pem, 'base64');
                            }
                        } else if (Buffer.isBuffer(data)) buffer = data;
                        else throw Error('Unsupported key format');
                        var reader = new ber.Reader(buffer);
                        reader.readSequence();
                        var header = new ber.Reader(reader.readString(0x30, true));
                        if (header.readOID(0x06, true) !== PUBLIC_RSA_OID) throw Error('Invalid Public key format');
                        var body = new ber.Reader(reader.readString(0x03, true));
                        body.readByte();
                        body.readSequence();
                        key.setPublic(body.readString(0x02, true), body.readString(0x02, true) // publicExponent
                        );
                    },
                    /**
     * Trying autodetect and import key
     * @param key
     * @param data
     */ autoImport: function(key, data) {
                        if (/^[\S\s]*-----BEGIN PRIVATE KEY-----\s*(?=(([A-Za-z0-9+/=]+\s*)+))\1-----END PRIVATE KEY-----[\S\s]*$/g.test(data)) {
                            module.exports.privateImport(key, data);
                            return true;
                        }
                        if (/^[\S\s]*-----BEGIN PUBLIC KEY-----\s*(?=(([A-Za-z0-9+/=]+\s*)+))\1-----END PUBLIC KEY-----[\S\s]*$/g.test(data)) {
                            module.exports.publicImport(key, data);
                            return true;
                        }
                        return false;
                    }
                };
            }).call(this, require1("buffer").Buffer);
        },
        {
            "../asn1/index": 145,
            "../utils": 154,
            "buffer": 182
        }
    ],
    150: [
        function(require1, module, exports) {
            (function(Buffer) {
                /*
 * Basic JavaScript BN library - subset useful for RSA encryption.
 *
 * Copyright (c) 2003-2005  Tom Wu
 * ~BSD license~
 *
 * Added Node.js Buffers support
 * 2014 rzcoder
 *
 * Deleted some stuff to save bytes
 * frosty00
 */ var _ = require1('../utils')._;
                // Bits per digit
                var dbits;
                // (public) Constructor
                function BigInteger(a, b) {
                    if (a != null) {
                        if ("number" == typeof a) this.fromNumber(a, b);
                        else if (Buffer.isBuffer(a)) this.fromBuffer(a);
                        else if (b == null && "string" != typeof a) this.fromByteArray(a);
                        else this.fromString(a, b);
                    }
                }
                // return new, unset BigInteger
                function nbi() {
                    return new BigInteger(null);
                }
                // am: Compute w_j += (x*this_i), propagate carries,
                // c is initial carry, returns final carry.
                // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
                // We need to select the fastest one that works in this environment.
                // Alternately, set max digit bits to 28 since some
                // browsers slow down when dealing with 32-bit numbers.
                function am3(i, x, w, j, c, n) {
                    var xl = x & 0x3fff, xh = x >> 14;
                    while(--n >= 0){
                        var l = this[i] & 0x3fff;
                        var h = this[i++] >> 14;
                        var m = xh * l + h * xl;
                        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
                        c = (l >> 28) + (m >> 14) + xh * h;
                        w[j++] = l & 0xfffffff;
                    }
                    return c;
                }
                // We need to select the fastest one that works in this environment.
                //if (j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
                //	BigInteger.prototype.am = am2;
                //	dbits = 30;
                //} else if (j_lm && (navigator.appName != "Netscape")) {
                //	BigInteger.prototype.am = am1;
                //	dbits = 26;
                //} else { // Mozilla/Netscape seems to prefer am3
                //	BigInteger.prototype.am = am3;
                //	dbits = 28;
                //}
                // For node.js, we pick am3 with max dbits to 28.
                BigInteger.prototype.am = am3;
                dbits = 28;
                BigInteger.prototype.DB = dbits;
                BigInteger.prototype.DM = (1 << dbits) - 1;
                BigInteger.prototype.DV = 1 << dbits;
                var BI_FP = 52;
                BigInteger.prototype.FV = Math.pow(2, BI_FP);
                BigInteger.prototype.F1 = BI_FP - dbits;
                BigInteger.prototype.F2 = 2 * dbits - BI_FP;
                // Digit conversions
                var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
                var BI_RC = new Array();
                var rr, vv;
                rr = "0".charCodeAt(0);
                for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
                rr = "a".charCodeAt(0);
                for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
                rr = "A".charCodeAt(0);
                for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
                function int2char(n) {
                    return BI_RM.charAt(n);
                }
                function intAt(s, i) {
                    var c = BI_RC[s.charCodeAt(i)];
                    return c == null ? -1 : c;
                }
                // (protected) copy this to r
                function bnpCopyTo(r) {
                    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
                    r.t = this.t;
                    r.s = this.s;
                }
                // (protected) set from integer value x, -DV <= x < DV
                function bnpFromInt(x) {
                    this.t = 1;
                    this.s = x < 0 ? -1 : 0;
                    if (x > 0) this[0] = x;
                    else if (x < -1) this[0] = x + DV;
                    else this.t = 0;
                }
                // return bigint initialized to value
                function nbv(i) {
                    var r = nbi();
                    r.fromInt(i);
                    return r;
                }
                // (protected) set from string and radix
                function bnpFromString(data, radix, unsigned) {
                    var k;
                    switch(radix){
                        case 2:
                            k = 1;
                            break;
                        case 4:
                            k = 2;
                            break;
                        case 8:
                            k = 3;
                            break;
                        case 16:
                            k = 4;
                            break;
                        case 32:
                            k = 5;
                            break;
                        case 256:
                            k = 8;
                            break;
                        default:
                            this.fromRadix(data, radix);
                            return;
                    }
                    this.t = 0;
                    this.s = 0;
                    var i = data.length;
                    var mi = false;
                    var sh = 0;
                    while(--i >= 0){
                        var x = k == 8 ? data[i] & 0xff : intAt(data, i);
                        if (x < 0) {
                            if (data.charAt(i) == "-") mi = true;
                            continue;
                        }
                        mi = false;
                        if (sh === 0) this[this.t++] = x;
                        else if (sh + k > this.DB) {
                            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
                            this[this.t++] = x >> this.DB - sh;
                        } else this[this.t - 1] |= x << sh;
                        sh += k;
                        if (sh >= this.DB) sh -= this.DB;
                    }
                    if (!unsigned && k == 8 && (data[0] & 0x80) != 0) {
                        this.s = -1;
                        if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
                    }
                    this.clamp();
                    if (mi) BigInteger.ZERO.subTo(this, this);
                }
                function bnpFromByteArray(a, unsigned) {
                    this.fromString(a, 256, unsigned);
                }
                function bnpFromBuffer(a) {
                    this.fromString(a, 256, true);
                }
                // (protected) clamp off excess high words
                function bnpClamp() {
                    var c = this.s & this.DM;
                    while(this.t > 0 && this[this.t - 1] == c)--this.t;
                }
                // (public) return string representation in given radix
                function bnToString(b) {
                    if (this.s < 0) return "-" + this.negate().toString(b);
                    var k;
                    if (b == 16) k = 4;
                    else if (b == 8) k = 3;
                    else if (b == 2) k = 1;
                    else if (b == 32) k = 5;
                    else if (b == 4) k = 2;
                    else return this.toRadix(b);
                    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
                    var p = this.DB - i * this.DB % k;
                    if (i-- > 0) {
                        if (p < this.DB && (d = this[i] >> p) > 0) {
                            m = true;
                            r = int2char(d);
                        }
                        while(i >= 0){
                            if (p < k) {
                                d = (this[i] & (1 << p) - 1) << k - p;
                                d |= this[--i] >> (p += this.DB - k);
                            } else {
                                d = this[i] >> (p -= k) & km;
                                if (p <= 0) {
                                    p += this.DB;
                                    --i;
                                }
                            }
                            if (d > 0) m = true;
                            if (m) r += int2char(d);
                        }
                    }
                    return m ? r : "0";
                }
                // (public) -this
                function bnNegate() {
                    var r = nbi();
                    BigInteger.ZERO.subTo(this, r);
                    return r;
                }
                // (public) |this|
                function bnAbs() {
                    return this.s < 0 ? this.negate() : this;
                }
                // (public) return + if this > a, - if this < a, 0 if equal
                function bnCompareTo(a) {
                    var r = this.s - a.s;
                    if (r != 0) return r;
                    var i = this.t;
                    r = i - a.t;
                    if (r != 0) return this.s < 0 ? -r : r;
                    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
                    return 0;
                }
                // returns bit length of the integer x
                function nbits(x) {
                    var r = 1, t;
                    if ((t = x >>> 16) != 0) {
                        x = t;
                        r += 16;
                    }
                    if ((t = x >> 8) != 0) {
                        x = t;
                        r += 8;
                    }
                    if ((t = x >> 4) != 0) {
                        x = t;
                        r += 4;
                    }
                    if ((t = x >> 2) != 0) {
                        x = t;
                        r += 2;
                    }
                    if ((t = x >> 1) != 0) {
                        x = t;
                        r += 1;
                    }
                    return r;
                }
                // (public) return the number of bits in "this"
                function bnBitLength() {
                    if (this.t <= 0) return 0;
                    return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
                }
                // (protected) r = this << n*DB
                function bnpDLShiftTo(n, r) {
                    var i;
                    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
                    for(i = n - 1; i >= 0; --i)r[i] = 0;
                    r.t = this.t + n;
                    r.s = this.s;
                }
                // (protected) r = this >> n*DB
                function bnpDRShiftTo(n, r) {
                    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
                    r.t = Math.max(this.t - n, 0);
                    r.s = this.s;
                }
                // (protected) r = this << n
                function bnpLShiftTo(n, r) {
                    var bs = n % this.DB;
                    var cbs = this.DB - bs;
                    var bm = (1 << cbs) - 1;
                    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
                    for(i = this.t - 1; i >= 0; --i){
                        r[i + ds + 1] = this[i] >> cbs | c;
                        c = (this[i] & bm) << bs;
                    }
                    for(i = ds - 1; i >= 0; --i)r[i] = 0;
                    r[ds] = c;
                    r.t = this.t + ds + 1;
                    r.s = this.s;
                    r.clamp();
                }
                // (protected) r = this >> n
                function bnpRShiftTo(n, r) {
                    r.s = this.s;
                    var ds = Math.floor(n / this.DB);
                    if (ds >= this.t) {
                        r.t = 0;
                        return;
                    }
                    var bs = n % this.DB;
                    var cbs = this.DB - bs;
                    var bm = (1 << bs) - 1;
                    r[0] = this[ds] >> bs;
                    for(var i = ds + 1; i < this.t; ++i){
                        r[i - ds - 1] |= (this[i] & bm) << cbs;
                        r[i - ds] = this[i] >> bs;
                    }
                    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
                    r.t = this.t - ds;
                    r.clamp();
                }
                // (protected) r = this - a
                function bnpSubTo(a, r) {
                    var i = 0, c = 0, m = Math.min(a.t, this.t);
                    while(i < m){
                        c += this[i] - a[i];
                        r[i++] = c & this.DM;
                        c >>= this.DB;
                    }
                    if (a.t < this.t) {
                        c -= a.s;
                        while(i < this.t){
                            c += this[i];
                            r[i++] = c & this.DM;
                            c >>= this.DB;
                        }
                        c += this.s;
                    } else {
                        c += this.s;
                        while(i < a.t){
                            c -= a[i];
                            r[i++] = c & this.DM;
                            c >>= this.DB;
                        }
                        c -= a.s;
                    }
                    r.s = c < 0 ? -1 : 0;
                    if (c < -1) r[i++] = this.DV + c;
                    else if (c > 0) r[i++] = c;
                    r.t = i;
                    r.clamp();
                }
                // (protected) r = this * a, r != this,a (HAC 14.12)
                // "this" should be the larger one if appropriate.
                function bnpMultiplyTo(a, r) {
                    var x = this.abs(), y = a.abs();
                    var i = x.t;
                    r.t = i + y.t;
                    while(--i >= 0)r[i] = 0;
                    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
                    r.s = 0;
                    r.clamp();
                    if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
                }
                // (protected) r = this^2, r != this (HAC 14.16)
                function bnpSquareTo(r) {
                    var x = this.abs();
                    var i = r.t = 2 * x.t;
                    while(--i >= 0)r[i] = 0;
                    for(i = 0; i < x.t - 1; ++i){
                        var c = x.am(i, x[i], r, 2 * i, 0, 1);
                        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                            r[i + x.t] -= x.DV;
                            r[i + x.t + 1] = 1;
                        }
                    }
                    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
                    r.s = 0;
                    r.clamp();
                }
                // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
                // r != q, this != m.  q or r may be null.
                function bnpDivRemTo(m, q, r) {
                    var pm = m.abs();
                    if (pm.t <= 0) return;
                    var pt = this.abs();
                    if (pt.t < pm.t) {
                        if (q != null) q.fromInt(0);
                        if (r != null) this.copyTo(r);
                        return;
                    }
                    if (r == null) r = nbi();
                    var y = nbi(), ts = this.s, ms = m.s;
                    var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
                    if (nsh > 0) {
                        pm.lShiftTo(nsh, y);
                        pt.lShiftTo(nsh, r);
                    } else {
                        pm.copyTo(y);
                        pt.copyTo(r);
                    }
                    var ys = y.t;
                    var y0 = y[ys - 1];
                    if (y0 === 0) return;
                    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
                    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
                    var i = r.t, j = i - ys, t = q == null ? nbi() : q;
                    y.dlShiftTo(j, t);
                    if (r.compareTo(t) >= 0) {
                        r[r.t++] = 1;
                        r.subTo(t, r);
                    }
                    BigInteger.ONE.dlShiftTo(ys, t);
                    t.subTo(y, y); // "negative" y so we can replace sub with am later
                    while(y.t < ys)y[y.t++] = 0;
                    while(--j >= 0){
                        // Estimate quotient digit
                        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
                        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
                            y.dlShiftTo(j, t);
                            r.subTo(t, r);
                            while(r[i] < --qd)r.subTo(t, r);
                        }
                    }
                    if (q != null) {
                        r.drShiftTo(ys, q);
                        if (ts != ms) BigInteger.ZERO.subTo(q, q);
                    }
                    r.t = ys;
                    r.clamp();
                    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
                    if (ts < 0) BigInteger.ZERO.subTo(r, r);
                }
                // (public) this mod a
                function bnMod(a) {
                    var r = nbi();
                    this.abs().divRemTo(a, null, r);
                    if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
                    return r;
                }
                // Modular reduction using "classic" algorithm
                function Classic(m) {
                    this.m = m;
                }
                function cConvert(x) {
                    if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
                    else return x;
                }
                function cRevert(x) {
                    return x;
                }
                function cReduce(x) {
                    x.divRemTo(this.m, null, x);
                }
                function cMulTo(x, y, r) {
                    x.multiplyTo(y, r);
                    this.reduce(r);
                }
                function cSqrTo(x, r) {
                    x.squareTo(r);
                    this.reduce(r);
                }
                Classic.prototype.convert = cConvert;
                Classic.prototype.revert = cRevert;
                Classic.prototype.reduce = cReduce;
                Classic.prototype.mulTo = cMulTo;
                Classic.prototype.sqrTo = cSqrTo;
                // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
                // justification:
                //         xy == 1 (mod m)
                //         xy =  1+km
                //   xy(2-xy) = (1+km)(1-km)
                // x[y(2-xy)] = 1-k^2m^2
                // x[y(2-xy)] == 1 (mod m^2)
                // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
                // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
                // JS multiply "overflows" differently from C/C++, so care is needed here.
                function bnpInvDigit() {
                    if (this.t < 1) return 0;
                    var x = this[0];
                    if ((x & 1) === 0) return 0;
                    var y = x & 3; // y == 1/x mod 2^2
                    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
                    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
                    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
                    // last step - calculate inverse mod DV directly;
                    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
                    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
                    // we really want the negative inverse, and -DV < y < DV
                    return y > 0 ? this.DV - y : -y;
                }
                // Montgomery reduction
                function Montgomery(m) {
                    this.m = m;
                    this.mp = m.invDigit();
                    this.mpl = this.mp & 0x7fff;
                    this.mph = this.mp >> 15;
                    this.um = (1 << m.DB - 15) - 1;
                    this.mt2 = 2 * m.t;
                }
                // xR mod m
                function montConvert(x) {
                    var r = nbi();
                    x.abs().dlShiftTo(this.m.t, r);
                    r.divRemTo(this.m, null, r);
                    if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
                    return r;
                }
                // x/R mod m
                function montRevert(x) {
                    var r = nbi();
                    x.copyTo(r);
                    this.reduce(r);
                    return r;
                }
                // x = x/R mod m (HAC 14.32)
                function montReduce(x) {
                    while(x.t <= this.mt2)x[x.t++] = 0;
                    for(var i = 0; i < this.m.t; ++i){
                        // faster way of calculating u0 = x[i]*mp mod DV
                        var j = x[i] & 0x7fff;
                        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
                        // use am to combine the multiply-shift-add into one call
                        j = i + this.m.t;
                        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
                        // propagate carry
                        while(x[j] >= x.DV){
                            x[j] -= x.DV;
                            x[++j]++;
                        }
                    }
                    x.clamp();
                    x.drShiftTo(this.m.t, x);
                    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
                }
                // r = "x^2/R mod m"; x != r
                function montSqrTo(x, r) {
                    x.squareTo(r);
                    this.reduce(r);
                }
                // r = "xy/R mod m"; x,y != r
                function montMulTo(x, y, r) {
                    x.multiplyTo(y, r);
                    this.reduce(r);
                }
                Montgomery.prototype.convert = montConvert;
                Montgomery.prototype.revert = montRevert;
                Montgomery.prototype.reduce = montReduce;
                Montgomery.prototype.mulTo = montMulTo;
                Montgomery.prototype.sqrTo = montSqrTo;
                // (protected) true iff this is even
                function bnpIsEven() {
                    return (this.t > 0 ? this[0] & 1 : this.s) === 0;
                }
                // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
                function bnpExp(e, z) {
                    if (e > 0xffffffff || e < 1) return BigInteger.ONE;
                    var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e) - 1;
                    g.copyTo(r);
                    while(--i >= 0){
                        z.sqrTo(r, r2);
                        if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
                        else {
                            var t = r;
                            r = r2;
                            r2 = t;
                        }
                    }
                    return z.revert(r);
                }
                // Copyright (c) 2005-2009  Tom Wu
                // All Rights Reserved.
                // See "LICENSE" for details.
                // Extended JavaScript BN functions, required for RSA private ops.
                // Version 1.1: new BigInteger("0", 10) returns "proper" zero
                // Version 1.2: square() API, isProbablePrime fix
                //(public)
                function bnClone() {
                    var r = nbi();
                    this.copyTo(r);
                    return r;
                }
                //(public) return value as integer
                function bnIntValue() {
                    if (this.s < 0) {
                        if (this.t == 1) return this[0] - this.DV;
                        else if (this.t === 0) return -1;
                    } else if (this.t == 1) return this[0];
                    else if (this.t === 0) return 0;
                    // assumes 16 < DB < 32
                    return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
                }
                //(protected) return x s.t. r^x < DV
                function bnpChunkSize(r) {
                    return Math.floor(Math.LN2 * this.DB / Math.log(r));
                }
                //(public) 0 if this === 0, 1 if this > 0
                function bnSigNum() {
                    if (this.s < 0) return -1;
                    else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;
                    else return 1;
                }
                //(protected) convert to radix string
                function bnpToRadix(b) {
                    if (b == null) b = 10;
                    if (this.signum() === 0 || b < 2 || b > 36) return "0";
                    var cs = this.chunkSize(b);
                    var a = Math.pow(b, cs);
                    var d = nbv(a), y = nbi(), z = nbi(), r = "";
                    this.divRemTo(d, y, z);
                    while(y.signum() > 0){
                        r = (a + z.intValue()).toString(b).substr(1) + r;
                        y.divRemTo(d, y, z);
                    }
                    return z.intValue().toString(b) + r;
                }
                //(protected) convert from radix string
                function bnpFromRadix(s, b) {
                    this.fromInt(0);
                    if (b == null) b = 10;
                    var cs = this.chunkSize(b);
                    var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
                    for(var i = 0; i < s.length; ++i){
                        var x = intAt(s, i);
                        if (x < 0) {
                            if (s.charAt(i) == "-" && this.signum() === 0) mi = true;
                            continue;
                        }
                        w = b * w + x;
                        if (++j >= cs) {
                            this.dMultiply(d);
                            this.dAddOffset(w, 0);
                            j = 0;
                            w = 0;
                        }
                    }
                    if (j > 0) {
                        this.dMultiply(Math.pow(b, j));
                        this.dAddOffset(w, 0);
                    }
                    if (mi) BigInteger.ZERO.subTo(this, this);
                }
                //(public) convert to bigendian byte array
                function bnToByteArray() {
                    var i = this.t, r = new Array();
                    r[0] = this.s;
                    var p = this.DB - i * this.DB % 8, d, k = 0;
                    if (i-- > 0) {
                        if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
                        while(i >= 0){
                            if (p < 8) {
                                d = (this[i] & (1 << p) - 1) << 8 - p;
                                d |= this[--i] >> (p += this.DB - 8);
                            } else {
                                d = this[i] >> (p -= 8) & 0xff;
                                if (p <= 0) {
                                    p += this.DB;
                                    --i;
                                }
                            }
                            if ((d & 0x80) != 0) d |= -256;
                            if (k === 0 && (this.s & 0x80) != (d & 0x80)) ++k;
                            if (k > 0 || d != this.s) r[k++] = d;
                        }
                    }
                    return r;
                }
                /**
 * return Buffer object
 * @param trim {boolean} slice buffer if first element == 0
 * @returns {Buffer}
 */ function bnToBuffer(trimOrSize) {
                    var res = Buffer.from(this.toByteArray());
                    if (trimOrSize === true && res[0] === 0) res = res.slice(1);
                    else if (_.isNumber(trimOrSize)) {
                        if (res.length > trimOrSize) {
                            for(var i = 0; i < res.length - trimOrSize; i++){
                                if (res[i] !== 0) return null;
                            }
                            return res.slice(res.length - trimOrSize);
                        } else if (res.length < trimOrSize) {
                            var padded = Buffer.alloc(trimOrSize);
                            padded.fill(0, 0, trimOrSize - res.length);
                            res.copy(padded, trimOrSize - res.length);
                            return padded;
                        }
                    }
                    return res;
                }
                function bnEquals(a) {
                    return this.compareTo(a) == 0;
                }
                function bnMin(a) {
                    return this.compareTo(a) < 0 ? this : a;
                }
                function bnMax(a) {
                    return this.compareTo(a) > 0 ? this : a;
                }
                //(protected) r = this op a (bitwise)
                function bnpBitwiseTo(a, op, r) {
                    var i, f, m = Math.min(a.t, this.t);
                    for(i = 0; i < m; ++i)r[i] = op(this[i], a[i]);
                    if (a.t < this.t) {
                        f = a.s & this.DM;
                        for(i = m; i < this.t; ++i)r[i] = op(this[i], f);
                        r.t = this.t;
                    } else {
                        f = this.s & this.DM;
                        for(i = m; i < a.t; ++i)r[i] = op(f, a[i]);
                        r.t = a.t;
                    }
                    r.s = op(this.s, a.s);
                    r.clamp();
                }
                //(public) this & a
                function op_and(x, y) {
                    return x & y;
                }
                function bnAnd(a) {
                    var r = nbi();
                    this.bitwiseTo(a, op_and, r);
                    return r;
                }
                //(public) this | a
                function op_or(x, y) {
                    return x | y;
                }
                function bnOr(a) {
                    var r = nbi();
                    this.bitwiseTo(a, op_or, r);
                    return r;
                }
                //(public) this ^ a
                function op_xor(x, y) {
                    return x ^ y;
                }
                function bnXor(a) {
                    var r = nbi();
                    this.bitwiseTo(a, op_xor, r);
                    return r;
                }
                //(public) this & ~a
                function op_andnot(x, y) {
                    return x & ~y;
                }
                //(public) ~this
                function bnNot() {
                    var r = nbi();
                    for(var i = 0; i < this.t; ++i)r[i] = this.DM & ~this[i];
                    r.t = this.t;
                    r.s = ~this.s;
                    return r;
                }
                //return index of lowest 1-bit in x, x < 2^31
                function lbit(x) {
                    if (x === 0) return -1;
                    var r = 0;
                    if ((x & 0xffff) === 0) {
                        x >>= 16;
                        r += 16;
                    }
                    if ((x & 0xff) === 0) {
                        x >>= 8;
                        r += 8;
                    }
                    if ((x & 0xf) === 0) {
                        x >>= 4;
                        r += 4;
                    }
                    if ((x & 3) === 0) {
                        x >>= 2;
                        r += 2;
                    }
                    if ((x & 1) === 0) ++r;
                    return r;
                }
                //(public) returns index of lowest 1-bit (or -1 if none)
                function bnGetLowestSetBit() {
                    for(var i = 0; i < this.t; ++i)if (this[i] != 0) return i * this.DB + lbit(this[i]);
                    if (this.s < 0) return this.t * this.DB;
                    return -1;
                }
                //return number of 1 bits in x
                function cbit(x) {
                    var r = 0;
                    while(x != 0){
                        x &= x - 1;
                        ++r;
                    }
                    return r;
                }
                //(protected) r = this + a
                function bnpAddTo(a, r) {
                    var i = 0, c = 0, m = Math.min(a.t, this.t);
                    while(i < m){
                        c += this[i] + a[i];
                        r[i++] = c & this.DM;
                        c >>= this.DB;
                    }
                    if (a.t < this.t) {
                        c += a.s;
                        while(i < this.t){
                            c += this[i];
                            r[i++] = c & this.DM;
                            c >>= this.DB;
                        }
                        c += this.s;
                    } else {
                        c += this.s;
                        while(i < a.t){
                            c += a[i];
                            r[i++] = c & this.DM;
                            c >>= this.DB;
                        }
                        c += a.s;
                    }
                    r.s = c < 0 ? -1 : 0;
                    if (c > 0) r[i++] = c;
                    else if (c < -1) r[i++] = this.DV + c;
                    r.t = i;
                    r.clamp();
                }
                //(public) this + a
                function bnAdd(a) {
                    var r = nbi();
                    this.addTo(a, r);
                    return r;
                }
                //(public) this - a
                function bnSubtract(a) {
                    var r = nbi();
                    this.subTo(a, r);
                    return r;
                }
                //(public) this * a
                function bnMultiply(a) {
                    var r = nbi();
                    this.multiplyTo(a, r);
                    return r;
                }
                // (public) this^2
                function bnSquare() {
                    var r = nbi();
                    this.squareTo(r);
                    return r;
                }
                //(public) this / a
                function bnDivide(a) {
                    var r = nbi();
                    this.divRemTo(a, r, null);
                    return r;
                }
                //(public) this % a
                function bnRemainder(a) {
                    var r = nbi();
                    this.divRemTo(a, null, r);
                    return r;
                }
                //(protected) this *= n, this >= 0, 1 < n < DV
                function bnpDMultiply(n) {
                    this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
                    ++this.t;
                    this.clamp();
                }
                //(protected) this += n << w words, this >= 0
                function bnpDAddOffset(n, w) {
                    if (n === 0) return;
                    while(this.t <= w)this[this.t++] = 0;
                    this[w] += n;
                    while(this[w] >= this.DV){
                        this[w] -= this.DV;
                        if (++w >= this.t) this[this.t++] = 0;
                        ++this[w];
                    }
                }
                //A "null" reducer
                function NullExp() {}
                function nNop(x) {
                    return x;
                }
                function nMulTo(x, y, r) {
                    x.multiplyTo(y, r);
                }
                function nSqrTo(x, r) {
                    x.squareTo(r);
                }
                NullExp.prototype.convert = nNop;
                NullExp.prototype.revert = nNop;
                NullExp.prototype.mulTo = nMulTo;
                NullExp.prototype.sqrTo = nSqrTo;
                //(public) this^e
                function bnPow(e) {
                    return this.exp(e, new NullExp());
                }
                //(protected) r = lower n words of "this * a", a.t <= n
                //"this" should be the larger one if appropriate.
                function bnpMultiplyLowerTo(a, n, r) {
                    var i = Math.min(this.t + a.t, n);
                    r.s = 0; // assumes a,this >= 0
                    r.t = i;
                    while(i > 0)r[--i] = 0;
                    var j;
                    for(j = r.t - this.t; i < j; ++i)r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
                    for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a[i], r, i, 0, n - i);
                    r.clamp();
                }
                //(protected) r = "this * a" without lower n words, n > 0
                //"this" should be the larger one if appropriate.
                function bnpMultiplyUpperTo(a, n, r) {
                    --n;
                    var i = r.t = this.t + a.t - n;
                    r.s = 0; // assumes a,this >= 0
                    while(--i >= 0)r[i] = 0;
                    for(i = Math.max(n - this.t, 0); i < a.t; ++i)r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
                    r.clamp();
                    r.drShiftTo(1, r);
                }
                //Barrett modular reduction
                function Barrett(m) {
                    // setup Barrett
                    this.r2 = nbi();
                    this.q3 = nbi();
                    BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
                    this.mu = this.r2.divide(m);
                    this.m = m;
                }
                function barrettConvert(x) {
                    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
                    else if (x.compareTo(this.m) < 0) return x;
                    else {
                        var r = nbi();
                        x.copyTo(r);
                        this.reduce(r);
                        return r;
                    }
                }
                function barrettRevert(x) {
                    return x;
                }
                //x = x mod m (HAC 14.42)
                function barrettReduce(x) {
                    x.drShiftTo(this.m.t - 1, this.r2);
                    if (x.t > this.m.t + 1) {
                        x.t = this.m.t + 1;
                        x.clamp();
                    }
                    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
                    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
                    while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
                    x.subTo(this.r2, x);
                    while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
                }
                //r = x^2 mod m; x != r
                function barrettSqrTo(x, r) {
                    x.squareTo(r);
                    this.reduce(r);
                }
                //r = x*y mod m; x,y != r
                function barrettMulTo(x, y, r) {
                    x.multiplyTo(y, r);
                    this.reduce(r);
                }
                Barrett.prototype.convert = barrettConvert;
                Barrett.prototype.revert = barrettRevert;
                Barrett.prototype.reduce = barrettReduce;
                Barrett.prototype.mulTo = barrettMulTo;
                Barrett.prototype.sqrTo = barrettSqrTo;
                //(public) this^e % m (HAC 14.85)
                function bnModPow(e, m) {
                    var i = e.bitLength(), k, r = nbv(1), z;
                    if (i <= 0) return r;
                    else if (i < 18) k = 1;
                    else if (i < 48) k = 3;
                    else if (i < 144) k = 4;
                    else if (i < 768) k = 5;
                    else k = 6;
                    if (i < 8) z = new Classic(m);
                    else if (m.isEven()) z = new Barrett(m);
                    else z = new Montgomery(m);
                    // precomputation
                    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
                    g[1] = z.convert(this);
                    if (k > 1) {
                        var g2 = nbi();
                        z.sqrTo(g[1], g2);
                        while(n <= km){
                            g[n] = nbi();
                            z.mulTo(g2, g[n - 2], g[n]);
                            n += 2;
                        }
                    }
                    var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
                    i = nbits(e[j]) - 1;
                    while(j >= 0){
                        if (i >= k1) w = e[j] >> i - k1 & km;
                        else {
                            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
                            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
                        }
                        n = k;
                        while((w & 1) === 0){
                            w >>= 1;
                            --n;
                        }
                        if ((i -= n) < 0) {
                            i += this.DB;
                            --j;
                        }
                        if (is1) {
                            g[w].copyTo(r);
                            is1 = false;
                        } else {
                            while(n > 1){
                                z.sqrTo(r, r2);
                                z.sqrTo(r2, r);
                                n -= 2;
                            }
                            if (n > 0) z.sqrTo(r, r2);
                            else {
                                t = r;
                                r = r2;
                                r2 = t;
                            }
                            z.mulTo(r2, g[w], r);
                        }
                        while(j >= 0 && (e[j] & 1 << i) === 0){
                            z.sqrTo(r, r2);
                            t = r;
                            r = r2;
                            r2 = t;
                            if (--i < 0) {
                                i = this.DB - 1;
                                --j;
                            }
                        }
                    }
                    return z.revert(r);
                }
                //(public) gcd(this,a) (HAC 14.54)
                function bnGCD(a) {
                    var x = this.s < 0 ? this.negate() : this.clone();
                    var y = a.s < 0 ? a.negate() : a.clone();
                    if (x.compareTo(y) < 0) {
                        var t = x;
                        x = y;
                        y = t;
                    }
                    var i = x.getLowestSetBit(), g = y.getLowestSetBit();
                    if (g < 0) return x;
                    if (i < g) g = i;
                    if (g > 0) {
                        x.rShiftTo(g, x);
                        y.rShiftTo(g, y);
                    }
                    while(x.signum() > 0){
                        if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
                        if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
                        if (x.compareTo(y) >= 0) {
                            x.subTo(y, x);
                            x.rShiftTo(1, x);
                        } else {
                            y.subTo(x, y);
                            y.rShiftTo(1, y);
                        }
                    }
                    if (g > 0) y.lShiftTo(g, y);
                    return y;
                }
                // protected
                BigInteger.prototype.copyTo = bnpCopyTo;
                BigInteger.prototype.fromInt = bnpFromInt;
                BigInteger.prototype.fromString = bnpFromString;
                BigInteger.prototype.fromByteArray = bnpFromByteArray;
                BigInteger.prototype.fromBuffer = bnpFromBuffer;
                BigInteger.prototype.clamp = bnpClamp;
                BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
                BigInteger.prototype.drShiftTo = bnpDRShiftTo;
                BigInteger.prototype.lShiftTo = bnpLShiftTo;
                BigInteger.prototype.rShiftTo = bnpRShiftTo;
                BigInteger.prototype.subTo = bnpSubTo;
                BigInteger.prototype.multiplyTo = bnpMultiplyTo;
                BigInteger.prototype.squareTo = bnpSquareTo;
                BigInteger.prototype.divRemTo = bnpDivRemTo;
                BigInteger.prototype.invDigit = bnpInvDigit;
                BigInteger.prototype.isEven = bnpIsEven;
                BigInteger.prototype.exp = bnpExp;
                BigInteger.prototype.chunkSize = bnpChunkSize;
                BigInteger.prototype.toRadix = bnpToRadix;
                BigInteger.prototype.fromRadix = bnpFromRadix;
                BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
                BigInteger.prototype.addTo = bnpAddTo;
                BigInteger.prototype.dMultiply = bnpDMultiply;
                BigInteger.prototype.dAddOffset = bnpDAddOffset;
                BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
                BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
                // public
                BigInteger.prototype.toString = bnToString;
                BigInteger.prototype.negate = bnNegate;
                BigInteger.prototype.abs = bnAbs;
                BigInteger.prototype.compareTo = bnCompareTo;
                BigInteger.prototype.bitLength = bnBitLength;
                BigInteger.prototype.mod = bnMod;
                BigInteger.prototype.clone = bnClone;
                BigInteger.prototype.intValue = bnIntValue;
                BigInteger.prototype.signum = bnSigNum;
                BigInteger.prototype.toByteArray = bnToByteArray;
                BigInteger.prototype.toBuffer = bnToBuffer;
                BigInteger.prototype.equals = bnEquals;
                BigInteger.prototype.min = bnMin;
                BigInteger.prototype.max = bnMax;
                BigInteger.prototype.and = bnAnd;
                BigInteger.prototype.or = bnOr;
                BigInteger.prototype.xor = bnXor;
                BigInteger.prototype.not = bnNot;
                BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
                BigInteger.prototype.add = bnAdd;
                BigInteger.prototype.subtract = bnSubtract;
                BigInteger.prototype.multiply = bnMultiply;
                BigInteger.prototype.divide = bnDivide;
                BigInteger.prototype.remainder = bnRemainder;
                BigInteger.prototype.modPow = bnModPow;
                BigInteger.prototype.pow = bnPow;
                BigInteger.prototype.gcd = bnGCD;
                BigInteger.int2char = int2char;
                // "constants"
                BigInteger.ZERO = nbv(0);
                BigInteger.ONE = nbv(1);
                // JSBN-specific extension
                BigInteger.prototype.square = bnSquare;
                //BigInteger interfaces not implemented in jsbn:
                //BigInteger(int signum, byte[] magnitude)
                //double doubleValue()
                //float floatValue()
                //int hashCode()
                //long longValue()
                //static BigInteger valueOf(long val)
                module.exports = BigInteger;
            }).call(this, require1("buffer").Buffer);
        },
        {
            "../utils": 154,
            "buffer": 182
        }
    ],
    151: [
        function(require1, module, exports) {
            /*
 * RSA Encryption / Decryption with PKCS1 v2 Padding.
 *
 * ~MIT License~
 * Contributors:
 * Tom Wu, rzcoder, frosty00
*/ var _ = require1('../utils')._;
            var BigInteger = require1('./jsbn.js');
            var utils = require1('../utils.js');
            var schemes = require1('../schemes/schemes.js');
            //exports.BigInteger = BigInteger;
            module.exports.Key = function() {
                /**
     * RSA key constructor
     *
     * n - modulus
     * e - publicExponent
     * d - privateExponent
     * p - prime1
     * q - prime2
     * dmp1 - exponent1 -- d mod (p1)
     * dmq1 - exponent2 -- d mod (q-1)
     * coeff - coefficient -- (inverse of q) mod p
     */ function RSAKey() {
                    this.n = null;
                    this.e = 0;
                    this.d = null;
                    this.p = null;
                    this.q = null;
                    this.dmp1 = null;
                    this.dmq1 = null;
                    this.coeff = null;
                }
                RSAKey.prototype.setOptions = function(options) {
                    var signingSchemeProvider = schemes[options.signingScheme];
                    var encryptionSchemeProvider = schemes[options.encryptionScheme];
                    if (signingSchemeProvider === encryptionSchemeProvider) this.signingScheme = this.encryptionScheme = encryptionSchemeProvider.makeScheme(this, options);
                    else {
                        this.encryptionScheme = encryptionSchemeProvider.makeScheme(this, options);
                        this.signingScheme = signingSchemeProvider.makeScheme(this, options);
                    }
                };
                /**
     * Set the private key fields N, e, d and CRT params from buffers
     *
     * @param N
     * @param E
     * @param D
     * @param P
     * @param Q
     * @param DP
     * @param DQ
     * @param C
     */ RSAKey.prototype.setPrivate = function(N, E, D, P, Q, DP, DQ, C) {
                    if (N && E && D && N.length > 0 && (_.isNumber(E) || E.length > 0) && D.length > 0) {
                        this.n = new BigInteger(N);
                        this.e = _.isNumber(E) ? E : utils.get32IntFromBuffer(E, 0);
                        this.d = new BigInteger(D);
                        if (P && Q && DP && DQ && C) {
                            this.p = new BigInteger(P);
                            this.q = new BigInteger(Q);
                            this.dmp1 = new BigInteger(DP);
                            this.dmq1 = new BigInteger(DQ);
                            this.coeff = new BigInteger(C);
                        }
                        this.$$recalculateCache();
                    } else throw Error("Invalid RSA private key");
                };
                /**
     * private
     * Perform raw private operation on "x": return x^d (mod n)
     *
     * @param x
     * @returns {*}
     */ RSAKey.prototype.$doPrivate = function(x) {
                    if (this.p || this.q) return x.modPow(this.d, this.n);
                    // TODO: re-calculate any missing CRT params
                    var xp = x.mod(this.p).modPow(this.dmp1, this.p);
                    var xq = x.mod(this.q).modPow(this.dmq1, this.q);
                    while(xp.compareTo(xq) < 0)xp = xp.add(this.p);
                    return xp.subtract(xq).multiply(this.coeff).mod(this.p).multiply(this.q).add(xq);
                };
                RSAKey.prototype.sign = function(buffer) {
                    return this.signingScheme.sign.apply(this.signingScheme, arguments);
                };
                /**
     * Check if key pair contains private key
     */ RSAKey.prototype.isPrivate = function() {
                    return this.n && this.e && this.d || false;
                };
                Object.defineProperty(RSAKey.prototype, 'keySize', {
                    get: function() {
                        return this.cache.keyBitLength;
                    }
                });
                Object.defineProperty(RSAKey.prototype, 'encryptedDataLength', {
                    get: function() {
                        return this.cache.keyByteLength;
                    }
                });
                Object.defineProperty(RSAKey.prototype, 'maxMessageLength', {
                    get: function() {
                        return this.encryptionScheme.maxMessageLength();
                    }
                });
                /**
     * Caching key data
     */ RSAKey.prototype.$$recalculateCache = function() {
                    this.cache = this.cache || {};
                    // Bit & byte length
                    this.cache.keyBitLength = this.n.bitLength();
                    this.cache.keyByteLength = this.cache.keyBitLength + 6 >> 3;
                };
                return RSAKey;
            }();
        },
        {
            "../schemes/schemes.js": 153,
            "../utils": 154,
            "../utils.js": 154,
            "./jsbn.js": 150
        }
    ],
    152: [
        function(require1, module, exports) {
            (function(Buffer) {
                /**
 * PKCS1 padding and signature scheme
 */ var BigInteger = require1('../libs/jsbn');
                var CryptoJS = require1('../../crypto-js/crypto-js');
                var constants = {
                    RSA_NO_PADDING: 3
                };
                require1('constants');
                var SIGN_INFO_HEAD = {
                    md2: Buffer.from('3020300c06082a864886f70d020205000410', 'hex'),
                    md5: Buffer.from('3020300c06082a864886f70d020505000410', 'hex'),
                    sha1: Buffer.from('3021300906052b0e03021a05000414', 'hex'),
                    sha224: Buffer.from('302d300d06096086480165030402040500041c', 'hex'),
                    sha256: Buffer.from('3031300d060960864801650304020105000420', 'hex'),
                    sha384: Buffer.from('3041300d060960864801650304020205000430', 'hex'),
                    sha512: Buffer.from('3051300d060960864801650304020305000440', 'hex'),
                    ripemd160: Buffer.from('3021300906052b2403020105000414', 'hex'),
                    rmd160: Buffer.from('3021300906052b2403020105000414', 'hex')
                };
                var SIGN_ALG_TO_HASH_ALIASES = {
                    'ripemd160': 'rmd160'
                };
                var DEFAULT_HASH_FUNCTION = 'sha256';
                module.exports = {
                    isEncryption: true,
                    isSignature: true
                };
                module.exports.makeScheme = function(key, options) {
                    function Scheme(key, options) {
                        this.key = key;
                        this.options = options;
                    }
                    Scheme.prototype.maxMessageLength = function() {
                        if (this.options.encryptionSchemeOptions && this.options.encryptionSchemeOptions.padding == constants.RSA_NO_PADDING) return this.key.encryptedDataLength;
                        return this.key.encryptedDataLength - 11;
                    };
                    /**
     * Unpad input Buffer and, if valid, return the Buffer object
     * alg: PKCS#1 (type 2, random)
     * @param buffer
     * @returns {Buffer}
     */ Scheme.prototype.encUnPad = function(buffer, options) {
                        options = options || {};
                        var i = 0;
                        if (this.options.encryptionSchemeOptions && this.options.encryptionSchemeOptions.padding == constants.RSA_NO_PADDING) {
                            //RSA_NO_PADDING treated like JAVA left pad with zero character
                            var unPad;
                            if (typeof buffer.lastIndexOf == "function") unPad = buffer.slice(buffer.lastIndexOf('\0') + 1, buffer.length);
                            else unPad = buffer.slice(String.prototype.lastIndexOf.call(buffer, '\0') + 1, buffer.length);
                            return unPad;
                        }
                        if (buffer.length < 4) return null;
                        /* Type 1: zeros padding for private key decrypt */ if (options.type === 1) {
                            if (buffer[0] !== 0 && buffer[1] !== 1) return null;
                            i = 3;
                            while(buffer[i] !== 0){
                                if (buffer[i] != 0xFF || ++i >= buffer.length) return null;
                            }
                        } else {
                            /* random padding for public key decrypt */ if (buffer[0] !== 0 && buffer[1] !== 2) return null;
                            i = 3;
                            while(buffer[i] !== 0){
                                if (++i >= buffer.length) return null;
                            }
                        }
                        return buffer.slice(i + 1, buffer.length);
                    };
                    Scheme.prototype.sign = function(buffer) {
                        var hashAlgorithm = this.options.signingSchemeOptions.hash || DEFAULT_HASH_FUNCTION;
                        if (this.options.environment === 'browser') {
                            hashAlgorithm = SIGN_ALG_TO_HASH_ALIASES[hashAlgorithm] || hashAlgorithm;
                            var hasher = CryptoJS[hashAlgorithm.toUpperCase()](buffer.toString());
                            var asBuffer = wordArrayToBuffer(hasher);
                            var paddedHash = this.pkcs1pad(asBuffer, hashAlgorithm);
                            var res = this.key.$doPrivate(new BigInteger(paddedHash)).toBuffer(this.key.encryptedDataLength);
                            return res;
                        } else throw new Error('CCXT only supports browser mode :P');
                    };
                    /**
     * PKCS#1 pad input buffer to max data length
     * @param hashBuf
     * @param hashAlgorithm
     * @returns {*}
     */ Scheme.prototype.pkcs1pad = function(hashBuf, hashAlgorithm) {
                        var digest = SIGN_INFO_HEAD[hashAlgorithm];
                        if (!digest) throw Error('Unsupported hash algorithm');
                        var data = Buffer.concat([
                            digest,
                            hashBuf
                        ]);
                        if (data.length + 10 > this.key.encryptedDataLength) throw Error('Key is too short for signing algorithm (' + hashAlgorithm + ')');
                        var filled = Buffer.alloc(this.key.encryptedDataLength - data.length - 1);
                        filled.fill(0xff, 0, filled.length - 1);
                        filled[0] = 1;
                        filled[filled.length - 1] = 0;
                        var res = Buffer.concat([
                            filled,
                            data
                        ]);
                        return res;
                    };
                    return new Scheme(key, options);
                };
                // used to convert `CryptoJS` wordArrays into `crypto` hex buffers
                function wordToByteArray(word, length) {
                    var ba = [], xFF = 0xFF;
                    if (length > 0) ba.push(word >>> 24);
                    if (length > 1) ba.push(word >>> 16 & xFF);
                    if (length > 2) ba.push(word >>> 8 & xFF);
                    if (length > 3) ba.push(word & xFF);
                    return ba;
                }
                function wordArrayToBuffer(wordArray) {
                    let length = undefined;
                    if (wordArray.hasOwnProperty("sigBytes") && wordArray.hasOwnProperty("words")) {
                        length = wordArray.sigBytes;
                        wordArray = wordArray.words;
                    } else throw Error('Argument not a wordArray');
                    const result = [];
                    let bytes = [];
                    let i = 0;
                    while(length > 0){
                        bytes = wordToByteArray(wordArray[i], Math.min(4, length));
                        length -= bytes.length;
                        result.push(bytes);
                        i++;
                    }
                    return new Buffer.from([].concat.apply([], result), 'hex');
                }
            }).call(this, require1("buffer").Buffer);
        },
        {
            "../../crypto-js/crypto-js": 121,
            "../libs/jsbn": 150,
            "buffer": 182,
            "constants": 184
        }
    ],
    153: [
        function(require1, module, exports) {
            module.exports = {
                pkcs1: require1('./pkcs1'),
                /**
     * Check if scheme has padding methods
     * @param scheme {string}
     * @returns {Boolean}
     */ isEncryption: function(scheme) {
                    return module.exports[scheme] && module.exports[scheme].isEncryption;
                },
                /**
     * Check if scheme has sign/verify methods
     * @param scheme {string}
     * @returns {Boolean}
     */ isSignature: function(scheme) {
                    return module.exports[scheme] && module.exports[scheme].isSignature;
                }
            };
        },
        {
            "./pkcs1": 152
        }
    ],
    154: [
        function(require1, module, exports) {
            /*
 * Utils functions
 *
 */ /**
 * Break string str each maxLen symbols
 * @param str
 * @param maxLen
 * @returns {string}
 */ module.exports.linebrk = function(str, maxLen) {
                var res = '';
                var i = 0;
                while(i + maxLen < str.length){
                    res += str.substring(i, i + maxLen) + "\n";
                    i += maxLen;
                }
                return res + str.substring(i, str.length);
            };
            /**
 * Trying get a 32-bit unsigned integer from the partial buffer
 * @param buffer
 * @param offset
 * @returns {Number}
 */ module.exports.get32IntFromBuffer = function(buffer, offset) {
                offset = offset || 0;
                var size = 0;
                if ((size = buffer.length - offset) > 0) {
                    if (size >= 4) return buffer.readUInt32BE(offset);
                    else {
                        var res = 0;
                        for(var i = offset + size, d = 0; i > offset; i--, d += 2)res += buffer[i - 1] * Math.pow(16, d);
                        return res;
                    }
                } else return NaN;
            };
            module.exports._ = {
                isObject: function(value) {
                    var type = typeof value;
                    return !!value && (type == 'object' || type == 'function');
                },
                isString: function(value) {
                    return typeof value == 'string' || value instanceof String;
                },
                isNumber: function(value) {
                    return typeof value == 'number' || !isNaN(parseFloat(value)) && isFinite(value);
                },
                /**
     * Returns copy of `obj` without `removeProp` field.
     * @param obj
     * @param removeProp
     * @returns Object
     */ omit: function(obj, removeProp) {
                    var newObj = {};
                    for(var prop in obj){
                        if (!obj.hasOwnProperty(prop) || prop === removeProp) continue;
                        newObj[prop] = obj[prop];
                    }
                    return newObj;
                }
            };
            /**
 * Strips everything around the opening and closing lines, including the lines
 * themselves.
 */ module.exports.trimSurroundingText = function(data, opening, closing) {
                var trimStartIndex = 0;
                var trimEndIndex = data.length;
                var openingBoundaryIndex = data.indexOf(opening);
                if (openingBoundaryIndex >= 0) trimStartIndex = openingBoundaryIndex + opening.length;
                var closingBoundaryIndex = data.indexOf(closing, openingBoundaryIndex);
                if (closingBoundaryIndex >= 0) trimEndIndex = closingBoundaryIndex;
                return data.substring(trimStartIndex, trimEndIndex);
            };
        },
        {}
    ],
    155: [
        function(require1, module, exports) {
            'use strict';
            var replace = String.prototype.replace;
            var percentTwenties = /%20/g;
            module.exports = {
                'default': 'RFC3986',
                formatters: {
                    RFC1738: function(value) {
                        return replace.call(value, percentTwenties, '+');
                    },
                    RFC3986: function(value) {
                        return value;
                    }
                },
                RFC1738: 'RFC1738',
                RFC3986: 'RFC3986'
            };
        },
        {}
    ],
    156: [
        function(require1, module, exports) {
            'use strict';
            var stringify = require1('./stringify');
            var parse = require1('./parse');
            var formats = require1('./formats');
            module.exports = {
                formats: formats,
                parse: parse,
                stringify: stringify
            };
        },
        {
            "./formats": 155,
            "./parse": 157,
            "./stringify": 158
        }
    ],
    157: [
        function(require1, module, exports) {
            'use strict';
            var utils = require1('./utils');
            var has = Object.prototype.hasOwnProperty;
            var defaults = {
                allowDots: false,
                allowPrototypes: false,
                arrayLimit: 20,
                charset: 'utf-8',
                charsetSentinel: false,
                comma: false,
                decoder: utils.decode,
                delimiter: '&',
                depth: 5,
                ignoreQueryPrefix: false,
                interpretNumericEntities: false,
                parameterLimit: 1000,
                parseArrays: true,
                plainObjects: false,
                strictNullHandling: false
            };
            var interpretNumericEntities = function(str) {
                return str.replace(/&#(\d+);/g, function($0, numberStr) {
                    return String.fromCharCode(parseInt(numberStr, 10));
                });
            };
            // This is what browsers will submit when the ✓ character occurs in an
            // application/x-www-form-urlencoded body and the encoding of the page containing
            // the form is iso-8859-1, or when the submitted form has an accept-charset
            // attribute of iso-8859-1. Presumably also with other charsets that do not contain
            // the ✓ character, such as us-ascii.
            var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
            // These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
            var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
            var parseValues = function parseQueryStringValues(str, options) {
                var obj = {};
                var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
                var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
                var parts = cleanStr.split(options.delimiter, limit);
                var skipIndex = -1; // Keep track of where the utf8 sentinel was found
                var i;
                var charset = options.charset;
                if (options.charsetSentinel) {
                    for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
                        if (parts[i] === charsetSentinel) charset = 'utf-8';
                        else if (parts[i] === isoSentinel) charset = 'iso-8859-1';
                        skipIndex = i;
                        i = parts.length; // The eslint settings do not allow break;
                    }
                }
                for(i = 0; i < parts.length; ++i){
                    if (i === skipIndex) continue;
                    var part = parts[i];
                    var bracketEqualsPos = part.indexOf(']=');
                    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
                    var key, val;
                    if (pos === -1) {
                        key = options.decoder(part, defaults.decoder, charset);
                        val = options.strictNullHandling ? null : '';
                    } else {
                        key = options.decoder(part.slice(0, pos), defaults.decoder, charset);
                        val = options.decoder(part.slice(pos + 1), defaults.decoder, charset);
                    }
                    if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = interpretNumericEntities(val);
                    if (val && options.comma && val.indexOf(',') > -1) val = val.split(',');
                    if (has.call(obj, key)) obj[key] = utils.combine(obj[key], val);
                    else obj[key] = val;
                }
                return obj;
            };
            var parseObject = function(chain, val, options) {
                var leaf = val;
                for(var i = chain.length - 1; i >= 0; --i){
                    var obj;
                    var root = chain[i];
                    if (root === '[]' && options.parseArrays) obj = [].concat(leaf);
                    else {
                        obj = options.plainObjects ? Object.create(null) : {};
                        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
                        var index = parseInt(cleanRoot, 10);
                        if (!options.parseArrays && cleanRoot === '') obj = {
                            0: leaf
                        };
                        else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                            obj = [];
                            obj[index] = leaf;
                        } else obj[cleanRoot] = leaf;
                    }
                    leaf = obj;
                }
                return leaf;
            };
            var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
                if (!givenKey) return;
                // Transform dot notation to bracket notation
                var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
                // The regex chunks
                var brackets = /(\[[^[\]]*])/;
                var child = /(\[[^[\]]*])/g;
                // Get the parent
                var segment = brackets.exec(key);
                var parent = segment ? key.slice(0, segment.index) : key;
                // Stash the parent if it exists
                var keys = [];
                if (parent) {
                    // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
                    if (!options.plainObjects && has.call(Object.prototype, parent)) {
                        if (!options.allowPrototypes) return;
                    }
                    keys.push(parent);
                }
                // Loop through children appending to the array until we hit depth
                var i = 0;
                while((segment = child.exec(key)) !== null && i < options.depth){
                    i += 1;
                    if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
                        if (!options.allowPrototypes) return;
                    }
                    keys.push(segment[1]);
                }
                // If there's a remainder, just add whatever is left
                if (segment) keys.push('[' + key.slice(segment.index) + ']');
                return parseObject(keys, val, options);
            };
            var normalizeParseOptions = function normalizeParseOptions(opts) {
                if (!opts) return defaults;
                if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
                if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
                var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
                return {
                    allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
                    allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
                    arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
                    charset: charset,
                    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
                    comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
                    decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
                    delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
                    depth: typeof opts.depth === 'number' ? opts.depth : defaults.depth,
                    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
                    interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
                    parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
                    parseArrays: opts.parseArrays !== false,
                    plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
                    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
                };
            };
            module.exports = function(str, opts) {
                var options = normalizeParseOptions(opts);
                if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? Object.create(null) : {};
                var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
                var obj = options.plainObjects ? Object.create(null) : {};
                // Iterate over the keys and setup the new object
                var keys = Object.keys(tempObj);
                for(var i = 0; i < keys.length; ++i){
                    var key = keys[i];
                    var newObj = parseKeys(key, tempObj[key], options);
                    obj = utils.merge(obj, newObj, options);
                }
                return utils.compact(obj);
            };
        },
        {
            "./utils": 159
        }
    ],
    158: [
        function(require1, module, exports) {
            'use strict';
            var utils = require1('./utils');
            var formats = require1('./formats');
            var has = Object.prototype.hasOwnProperty;
            var arrayPrefixGenerators = {
                brackets: function brackets(prefix) {
                    return prefix + '[]';
                },
                comma: 'comma',
                indices: function indices(prefix, key) {
                    return prefix + '[' + key + ']';
                },
                repeat: function repeat(prefix) {
                    return prefix;
                }
            };
            var isArray = Array.isArray;
            var push = Array.prototype.push;
            var pushToArray = function(arr, valueOrArray) {
                push.apply(arr, isArray(valueOrArray) ? valueOrArray : [
                    valueOrArray
                ]);
            };
            var toISO = Date.prototype.toISOString;
            var defaults = {
                addQueryPrefix: false,
                allowDots: false,
                charset: 'utf-8',
                charsetSentinel: false,
                delimiter: '&',
                encode: true,
                encoder: utils.encode,
                encodeValuesOnly: false,
                formatter: formats.formatters[formats['default']],
                // deprecated
                indices: false,
                serializeDate: function serializeDate(date) {
                    return toISO.call(date);
                },
                skipNulls: false,
                strictNullHandling: false
            };
            var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset) {
                var obj = object;
                if (typeof filter === 'function') obj = filter(prefix, obj);
                else if (obj instanceof Date) obj = serializeDate(obj);
                else if (generateArrayPrefix === 'comma' && isArray(obj)) obj = obj.join(',');
                if (obj === null) {
                    if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset) : prefix;
                    obj = '';
                }
                if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
                    if (encoder) {
                        var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset);
                        return [
                            formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset))
                        ];
                    }
                    return [
                        formatter(prefix) + '=' + formatter(String(obj))
                    ];
                }
                var values = [];
                if (typeof obj === 'undefined') return values;
                var objKeys;
                if (isArray(filter)) objKeys = filter;
                else {
                    var keys = Object.keys(obj);
                    objKeys = sort ? keys.sort(sort) : keys;
                }
                for(var i = 0; i < objKeys.length; ++i){
                    var key = objKeys[i];
                    if (skipNulls && obj[key] === null) continue;
                    if (isArray(obj)) pushToArray(values, stringify(obj[key], typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
                    else pushToArray(values, stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
                }
                return values;
            };
            var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
                if (!opts) return defaults;
                if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
                var charset = opts.charset || defaults.charset;
                if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
                var format = formats['default'];
                if (typeof opts.format !== 'undefined') {
                    if (!has.call(formats.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
                    format = opts.format;
                }
                var formatter = formats.formatters[format];
                var filter = defaults.filter;
                if (typeof opts.filter === 'function' || isArray(opts.filter)) filter = opts.filter;
                return {
                    addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
                    allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
                    charset: charset,
                    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
                    delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
                    encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
                    encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
                    encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
                    filter: filter,
                    formatter: formatter,
                    serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
                    skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
                    sort: typeof opts.sort === 'function' ? opts.sort : null,
                    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
                };
            };
            module.exports = function(object, opts) {
                var obj = object;
                var options = normalizeStringifyOptions(opts);
                var objKeys;
                var filter;
                if (typeof options.filter === 'function') {
                    filter = options.filter;
                    obj = filter('', obj);
                } else if (isArray(options.filter)) {
                    filter = options.filter;
                    objKeys = filter;
                }
                var keys = [];
                if (typeof obj !== 'object' || obj === null) return '';
                var arrayFormat;
                if (opts && opts.arrayFormat in arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
                else if (opts && 'indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
                else arrayFormat = 'indices';
                var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
                if (!objKeys) objKeys = Object.keys(obj);
                if (options.sort) objKeys.sort(options.sort);
                for(var i = 0; i < objKeys.length; ++i){
                    var key = objKeys[i];
                    if (options.skipNulls && obj[key] === null) continue;
                    pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.formatter, options.encodeValuesOnly, options.charset));
                }
                var joined = keys.join(options.delimiter);
                var prefix = options.addQueryPrefix === true ? '?' : '';
                if (options.charsetSentinel) {
                    if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
                    prefix += 'utf8=%26%2310003%3B&';
                    else // encodeURIComponent('✓')
                    prefix += 'utf8=%E2%9C%93&';
                }
                return joined.length > 0 ? prefix + joined : '';
            };
        },
        {
            "./formats": 155,
            "./utils": 159
        }
    ],
    159: [
        function(require1, module, exports) {
            'use strict';
            var has = Object.prototype.hasOwnProperty;
            var isArray = Array.isArray;
            var hexTable = function() {
                var array = [];
                for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
                return array;
            }();
            var compactQueue = function compactQueue(queue) {
                while(queue.length > 1){
                    var item = queue.pop();
                    var obj = item.obj[item.prop];
                    if (isArray(obj)) {
                        var compacted = [];
                        for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
                        item.obj[item.prop] = compacted;
                    }
                }
            };
            var arrayToObject = function arrayToObject(source, options) {
                var obj = options && options.plainObjects ? Object.create(null) : {};
                for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
                return obj;
            };
            var merge = function merge(target, source, options) {
                if (!source) return target;
                if (typeof source !== 'object') {
                    if (isArray(target)) target.push(source);
                    else if (target && typeof target === 'object') {
                        if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) target[source] = true;
                    } else return [
                        target,
                        source
                    ];
                    return target;
                }
                if (!target || typeof target !== 'object') return [
                    target
                ].concat(source);
                var mergeTarget = target;
                if (isArray(target) && !isArray(source)) mergeTarget = arrayToObject(target, options);
                if (isArray(target) && isArray(source)) {
                    source.forEach(function(item, i) {
                        if (has.call(target, i)) {
                            var targetItem = target[i];
                            if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                            else target.push(item);
                        } else target[i] = item;
                    });
                    return target;
                }
                return Object.keys(source).reduce(function(acc, key) {
                    var value = source[key];
                    if (has.call(acc, key)) acc[key] = merge(acc[key], value, options);
                    else acc[key] = value;
                    return acc;
                }, mergeTarget);
            };
            var assign = function assignSingleSource(target, source) {
                return Object.keys(source).reduce(function(acc, key) {
                    acc[key] = source[key];
                    return acc;
                }, target);
            };
            var decode = function(str, decoder, charset) {
                var strWithoutPlus = str.replace(/\+/g, ' ');
                if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
                return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
                // utf-8
                try {
                    return decodeURIComponent(strWithoutPlus);
                } catch (e) {
                    return strWithoutPlus;
                }
            };
            var encode = function encode(str, defaultEncoder, charset) {
                // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
                // It has been adapted here for stricter adherence to RFC 3986
                if (str.length === 0) return str;
                var string = typeof str === 'string' ? str : String(str);
                if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
                    return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
                });
                var out = '';
                for(var i = 0; i < string.length; ++i){
                    var c = string.charCodeAt(i);
                    if (c === 0x2D // -
                     || c === 0x2E // .
                     || c === 0x5F // _
                     || c === 0x7E // ~
                     || c >= 0x30 && c <= 0x39 // 0-9
                     || c >= 0x41 && c <= 0x5A // a-z
                     || c >= 0x61 && c <= 0x7A // A-Z
                    ) {
                        out += string.charAt(i);
                        continue;
                    }
                    if (c < 0x80) {
                        out = out + hexTable[c];
                        continue;
                    }
                    if (c < 0x800) {
                        out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
                        continue;
                    }
                    if (c < 0xD800 || c >= 0xE000) {
                        out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
                        continue;
                    }
                    i += 1;
                    c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
                    out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
                }
                return out;
            };
            var compact = function compact(value) {
                var queue = [
                    {
                        obj: {
                            o: value
                        },
                        prop: 'o'
                    }
                ];
                var refs = [];
                for(var i = 0; i < queue.length; ++i){
                    var item = queue[i];
                    var obj = item.obj[item.prop];
                    var keys = Object.keys(obj);
                    for(var j = 0; j < keys.length; ++j){
                        var key = keys[j];
                        var val = obj[key];
                        if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                            queue.push({
                                obj: obj,
                                prop: key
                            });
                            refs.push(val);
                        }
                    }
                }
                compactQueue(queue);
                return value;
            };
            var isRegExp = function isRegExp(obj) {
                return Object.prototype.toString.call(obj) === '[object RegExp]';
            };
            var isBuffer = function isBuffer(obj) {
                if (!obj || typeof obj !== 'object') return false;
                return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
            };
            var combine = function combine(a, b) {
                return [].concat(a, b);
            };
            module.exports = {
                arrayToObject: arrayToObject,
                assign: assign,
                combine: combine,
                compact: compact,
                decode: decode,
                encode: encode,
                isBuffer: isBuffer,
                isRegExp: isRegExp,
                merge: merge
            };
        },
        {}
    ],
    160: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, ExchangeError: ExchangeError1, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, PermissionDenied: PermissionDenied, BadRequest: BadRequest, BadSymbol: BadSymbol, DDoSProtection: DDoSProtection, InvalidOrder: InvalidOrder, AccountSuspended: AccountSuspended } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class stex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'stex',
                        'name': 'STEX',
                        'countries': [
                            'EE'
                        ],
                        'rateLimit': 1000 / 3,
                        'certified': false,
                        // new metainfo interface
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrder': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingFees': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderTrades': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': false,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': true
                        },
                        'version': 'v3',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/69680782-03fd0b80-10bd-11ea-909e-7f603500e9cc.jpg',
                            'api': 'https://api3.stex.com',
                            'www': 'https://www.stex.com',
                            'doc': [
                                'https://help.stex.com/en/collections/1593608-api-v3-documentation'
                            ],
                            'fees': 'https://app.stex.com/en/pairs-specification',
                            'referral': 'https://app.stex.com?ref=36416021'
                        },
                        'requiredCredentials': {
                            'apiKey': false,
                            'secret': false,
                            'token': true
                        },
                        'timeframes': {
                            '1m': '1',
                            '5m': '5',
                            '30m': '30',
                            '1h': '60',
                            '4h': '240',
                            '12h': '720',
                            '1d': '1D'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'currencies': 1,
                                    'currencies/{currencyId}': 1,
                                    'markets': 1,
                                    'pairs-groups': 1,
                                    'currency_pairs/list/{code}': 1,
                                    'currency_pairs/group/{currencyPairGroupId}': 1,
                                    'currency_pairs/{currencyPairId}': 1,
                                    'ticker': 1,
                                    'ticker/{currencyPairId}': 1,
                                    'trades/{currencyPairId}': 1,
                                    'orderbook/{currencyPairId}': 1,
                                    'chart/{currencyPairId}/{candlesType}': 1,
                                    'deposit-statuses': 1,
                                    'deposit-statuses/{statusId}': 1,
                                    'withdrawal-statuses': 1,
                                    'withdrawal-statuses/{statusId}': 1,
                                    'ping': 1,
                                    'mobile-versions': 1,
                                    'twitter': 1
                                }
                            },
                            'trading': {
                                'get': {
                                    'fees/{currencyPairId}': 1,
                                    'orders': 12,
                                    'orders/{currencyPairId}': 6,
                                    'order/{orderId}': 12
                                },
                                'post': {
                                    'orders/{currencyPairId}': 1.5,
                                    'orders/bulk/{currencyPairId}': 12
                                },
                                'delete': {
                                    'orders': 30,
                                    'orders/{currencyPairId}': 12,
                                    'order/{orderId}': 1.5
                                }
                            },
                            'reports': {
                                'get': {
                                    'currencies': 12,
                                    'currency_pairs': 12,
                                    'orders': 12,
                                    'orders/{orderId}': 12,
                                    'trades/{currencyPairId}': 12,
                                    'background/{listMode}': 12,
                                    'background/{id}': 12,
                                    'background/download/{id}': 12
                                },
                                'post': {
                                    'background/create': 12
                                },
                                'delete': {
                                    'background/{id}': 12
                                }
                            },
                            'profile': {
                                'get': {
                                    'info': 3,
                                    'wallets': 3,
                                    'wallets/{walletId}': 3,
                                    'wallets/address/{walletId}': 3,
                                    'deposits': 3,
                                    'deposits/{id}': 3,
                                    'rewards': 3,
                                    'rewards/{id}': 3,
                                    'addressbook': 3,
                                    'addressbook/{itemId}': 3,
                                    'withdrawals': 3,
                                    'withdrawals/{id}': 3,
                                    'notifications': 3,
                                    'notifications/price': 3,
                                    'favorite/currency_pairs': 3,
                                    'token-scopes': 3
                                },
                                'post': {
                                    'wallets/burn/{walletId}': 3,
                                    'wallets/{walletId}/hold_amount': 3,
                                    'wallets/{currencyId}': 3,
                                    'wallets/address/{walletId}': 3,
                                    'addressbook/disable_item/{itemId}': 3,
                                    'addressbook/enable_item/{itemId}': 3,
                                    'addressbook/enable_strict_wd': 3,
                                    'addressbook/disable_strict_wd': 3,
                                    'withdraw': 30,
                                    'notifications/price': 3,
                                    'referral/program': 3,
                                    'referral/insert/{code}': 3,
                                    'referral/bonus_transfer/{currencyId}': 3
                                },
                                'put': {
                                    'favorite/currency_pairs/set': 3
                                },
                                'delete': {
                                    'addressbook/{itemId}': 3,
                                    'withdraw/{withdrawalId}': 30,
                                    'notifications/price/{priceAlertId}': 3
                                }
                            },
                            'verification': {
                                'get': {
                                    'countries': 1,
                                    'status': 1,
                                    'fractal/url': 1,
                                    'smart-id': 1,
                                    'stex': 1,
                                    'cryptonomica/code': 1
                                },
                                'post': {
                                    'smart-id': 1,
                                    'stex': 1,
                                    'cryptonomica': 1
                                }
                            },
                            'settings': {
                                'get': {
                                    'notifications/{event}': 1,
                                    'notifications': 1
                                },
                                'put': {
                                    'notifications': 1,
                                    'notifications/set': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'taker': this.parseNumber('0.002'),
                                'maker': this.parseNumber('0.002')
                            }
                        },
                        'commonCurrencies': {
                            'BC': 'Bitcoin Confidential',
                            'BITS': 'Bitcoinus',
                            'BITSW': 'BITS',
                            'BHD': 'Bithold',
                            'BTH': 'Bithereum',
                            'MPH': 'Chasyr Token',
                            'SBTC': 'SBTCT'
                        },
                        'options': {
                            'parseOrderToPrecision': false,
                            'networks': {
                                'ERC20': 5,
                                'ETH': 5,
                                'OMNI': 10,
                                'XLM': 20,
                                'BEP2': 22,
                                'TRC20': 24,
                                'TRX': 24,
                                'SOL': 25,
                                'BEP20': 501
                            }
                        },
                        'exceptions': {
                            'exact': {
                                // {"success":false,"message":"Wrong parameters","errors":{"candleType":["Invalid Candle Type!"]}}
                                // {"success":false,"message":"Wrong parameters","errors":{"time":["timeStart or timeEnd is less then 1"]}}
                                'Wrong parameters': BadRequest,
                                'Unauthenticated.': AuthenticationError,
                                'Server Error': ExchangeError1,
                                'This feature is only enabled for users verifies by Cryptonomica': PermissionDenied,
                                'Too Many Attempts.': DDoSProtection,
                                'Selected Pair is disabled': BadSymbol,
                                'Invalid scope(s) provided.': PermissionDenied,
                                'The maximum amount of open orders with the same price cannot exceed 10': InvalidOrder,
                                'Your account not verified!': AccountSuspended
                            },
                            'broad': {
                                'Not enough': InsufficientFunds
                            }
                        }
                    });
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     {
                    //         "success":true,
                    //         "data":[
                    //             {
                    //                 "id":1,
                    //                 "code":"BTC",
                    //                 "name":"Bitcoin",
                    //                 "active":true,
                    //                 "delisted":false,
                    //                 "precision":8,
                    //                 "minimum_tx_confirmations":1,
                    //                 "minimum_withdrawal_amount":"0.00200000",
                    //                 "minimum_deposit_amount":"0.00000000",
                    //                 "deposit_fee_currency_id":1,
                    //                 "deposit_fee_currency_code":"BTC",
                    //                 "deposit_fee_const":"0.00000000",
                    //                 "deposit_fee_percent":"0.00000000",
                    //                 "withdrawal_fee_currency_id":1,
                    //                 "withdrawal_fee_currency_code":"BTC",
                    //                 "withdrawal_fee_const":"0.00100000",
                    //                 "withdrawal_fee_percent":"0.00000000",
                    //                 "block_explorer_url":"https:\/\/blockchain.info\/tx\/",
                    //                 "protocol_specific_settings":null
                    //             },
                    //         ]
                    //     }
                    //
                    const result = {};
                    const currencies = this.safeValue(response, 'data', []);
                    for(let i = 0; i < currencies.length; i++){
                        const currency = currencies[i];
                        const id = this.safeString(currency, 'id');
                        const numericId = this.safeInteger(currency, 'id');
                        // todo: will need to rethink the fees
                        // to add support for multiple withdrawal/deposit methods and
                        // differentiated fees for each particular method
                        const code = this.safeCurrencyCode(this.safeString(currency, 'code'));
                        const precision = this.safeString(currency, 'precision');
                        const amountLimit = this.parsePrecision(precision);
                        const fee = this.safeNumber(currency, 'withdrawal_fee_const'); // todo: redesign
                        const active = this.safeValue(currency, 'active', true);
                        result[code] = {
                            'id': id,
                            'numericId': numericId,
                            'code': code,
                            'info': currency,
                            'type': undefined,
                            'name': this.safeString(currency, 'name'),
                            'active': active,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': fee,
                            'precision': parseInt(precision),
                            'limits': {
                                'amount': {
                                    'min': this.parseNumber(amountLimit),
                                    'max': undefined
                                },
                                'deposit': {
                                    'min': this.safeNumber(currency, 'minimum_deposit_amount'),
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'minimum_withdrawal_amount'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const request = {
                        'code': 'ALL'
                    };
                    const response = await this.publicGetCurrencyPairsListCode(this.extend(request, params));
                    //
                    //     {
                    //         "success":true,
                    //         "data":[
                    //             {
                    //                 "id":935,
                    //                 "currency_id":662,
                    //                 "currency_code":"ABET",
                    //                 "currency_name":"Altbet",
                    //                 "market_currency_id":1,
                    //                 "market_code":"BTC",
                    //                 "market_name":"Bitcoin",
                    //                 "min_order_amount":"0.00000010",
                    //                 "min_buy_price":"0.00000001",
                    //                 "min_sell_price":"0.00000001",
                    //                 "buy_fee_percent":"0.20000000",
                    //                 "sell_fee_percent":"0.20000000",
                    //                 "active":true,
                    //                 "delisted":false,
                    //                 "pair_message":"",
                    //                 "currency_precision":8,
                    //                 "market_precision":8,
                    //                 "symbol":"ABET_BTC",
                    //                 "group_name":"BTC",
                    //                 "group_id":1
                    //             }
                    //         ]
                    //     }
                    //
                    const result = [];
                    const markets = this.safeValue(response, 'data', []);
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'id');
                        const numericId = this.safeInteger(market, 'id');
                        const baseId = this.safeString(market, 'currency_id');
                        const quoteId = this.safeString(market, 'market_currency_id');
                        const baseNumericId = this.safeInteger(market, 'currency_id');
                        const quoteNumericId = this.safeInteger(market, 'market_currency_id');
                        const base = this.safeCurrencyCode(this.safeString(market, 'currency_code'));
                        const quote = this.safeCurrencyCode(this.safeString(market, 'market_code'));
                        const minBuyPrice = this.safeString(market, 'min_buy_price');
                        const minSellPrice = this.safeString(market, 'min_sell_price');
                        const minPrice = Precise.stringMax(minBuyPrice, minSellPrice);
                        const buyFee = Precise.stringDiv(this.safeString(market, 'buy_fee_percent'), '100');
                        const sellFee = Precise.stringDiv(this.safeString(market, 'sell_fee_percent'), '100');
                        const fee = Precise.stringMax(buyFee, sellFee);
                        result.push({
                            'id': id,
                            'numericId': numericId,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'baseNumericId': baseNumericId,
                            'quoteNumericId': quoteNumericId,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': this.safeValue(market, 'active'),
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': fee,
                            'maker': fee,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'currency_precision'),
                                'price': this.safeInteger(market, 'market_precision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min_order_amount'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': minPrice,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPairId': market['id']
                    };
                    const response = await this.publicGetTickerCurrencyPairId(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": {
                    //             "id": 2,
                    //             "amount_multiplier": 1,
                    //             "currency_code": "ETH",
                    //             "market_code": "BTC",
                    //             "currency_name": "Ethereum",
                    //             "market_name": "Bitcoin",
                    //             "symbol": "ETH_BTC",
                    //             "group_name": "BTC",
                    //             "group_id": 1,
                    //             "ask": "0.02069998",
                    //             "bid": "0.02028622",
                    //             "last": "0.02049224",
                    //             "open": "0.02059605",
                    //             "low": "0.01977744",
                    //             "high": "0.02097005",
                    //             "volume": "480.43248971",
                    //             "volumeQuote": "23491.29826130",
                    //             "count": "7384",
                    //             "fiatsRate": {
                    //                 "USD": 7230.86,
                    //                 "EUR": 6590.79,
                    //                 "UAH": 173402,
                    //                 "AUD": 10595.51,
                    //                 "IDR": 101568085,
                    //                 "CNY": 50752,
                    //                 "KRW": 8452295,
                    //                 "JPY": 784607,
                    //                 "VND": 167315119,
                    //                 "INR": 517596,
                    //                 "GBP": 5607.25,
                    //                 "CAD": 9602.63,
                    //                 "BRL": 30472,
                    //                 "RUB": 460718
                    //             },
                    //             "timestamp": 1574698235601
                    //         }
                    //     }
                    //
                    const ticker = this.safeValue(response, 'data', {});
                    return this.parseTicker(ticker, market);
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetPing(params);
                    //
                    //     {
                    //         "success": true,
                    //         "data": {
                    //             "server_datetime": {
                    //                 "date": "2019-01-22 15:13:34.233796",
                    //                 "timezone_type": 3,
                    //                 "timezone": "UTC"
                    //             },
                    //             "server_timestamp": 1548170014
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const serverDatetime = this.safeValue(data, 'server_datetime', {});
                    return this.parse8601(this.safeString(serverDatetime, 'date'));
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPairId': market['id']
                    };
                    if (limit !== undefined) {
                        request['limit_bids'] = limit; // returns all if set to 0, default 100
                        request['limit_asks'] = limit; // returns all if set to 0, default 100
                    }
                    const response = await this.publicGetOrderbookCurrencyPairId(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": {
                    //             "ask": [
                    //                 { "currency_pair_id": 2, "amount": "2.17865373", "price": "0.02062917", "amount2": "0.04494382", "count": 1, "cumulative_amount": 2.17865373 },
                    //                 { "currency_pair_id": 2, "amount": "2.27521743", "price": "0.02062918", "amount2": "0.04693587", "count": 1, "cumulative_amount": 4.45387116 },
                    //                 { "currency_pair_id": 2, "amount": "1.26980049", "price": "0.02063170", "amount2": "0.02619814", "count": 1, "cumulative_amount": 5.72367165 },
                    //             ],
                    //             "bid": [
                    //                 { "currency_pair_id": 2, "amount": "0.00978005", "price": "0.02057000", "amount2": "0.00020118", "count": 1, "cumulative_amount": 0.00978005 },
                    //                 { "currency_pair_id": 2, "amount": "0.00500000", "price": "0.02056000", "amount2": "0.00010280", "count": 1, "cumulative_amount": 0.01478005 },
                    //                 { "currency_pair_id": 2, "amount": "0.77679882", "price": "0.02054001", "amount2": "0.01595546", "count": 1, "cumulative_amount": 0.79157887 },
                    //             ],
                    //             "ask_total_amount": 2555.749174609999,
                    //             "bid_total_amount": 29.180037330000005
                    //         }
                    //     }
                    //
                    const orderbook = this.safeValue(response, 'data', {});
                    return this.parseOrderBook(orderbook, symbol, undefined, 'bid', 'ask', 'price', 'amount');
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "id": 2,
                    //         "amount_multiplier": 1,
                    //         "currency_code": "ETH",
                    //         "market_code": "BTC",
                    //         "currency_name": "Ethereum",
                    //         "market_name": "Bitcoin",
                    //         "symbol": "ETH_BTC",
                    //         "group_name": "BTC",
                    //         "group_id": 1,
                    //         "ask": "0.02069998",
                    //         "bid": "0.02028622",
                    //         "last": "0.02049224",
                    //         "open": "0.02059605",
                    //         "low": "0.01977744",
                    //         "high": "0.02097005",
                    //         "volume": "480.43248971",
                    //         "volumeQuote": "23491.29826130",
                    //         "count": "7384",
                    //         "fiatsRate": {
                    //             "USD": 7230.86,
                    //             "EUR": 6590.79,
                    //             "UAH": 173402,
                    //             "AUD": 10595.51,
                    //             "IDR": 101568085,
                    //             "CNY": 50752,
                    //             "KRW": 8452295,
                    //             "JPY": 784607,
                    //             "VND": 167315119,
                    //             "INR": 517596,
                    //             "GBP": 5607.25,
                    //             "CAD": 9602.63,
                    //             "BRL": 30472,
                    //             "RUB": 460718
                    //         },
                    //         "timestamp": 1574698235601
                    //     }
                    //
                    const timestamp = this.safeInteger(ticker, 'timestamp');
                    const marketId = this.safeString2(ticker, 'id', 'symbol');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const last = this.safeString(ticker, 'last');
                    const open = this.safeString(ticker, 'open');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volumeQuote'),
                        'quoteVolume': this.safeString(ticker, 'volume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTicker(params);
                    //
                    //     {
                    //         "success":true,
                    //         "data":[
                    //             {
                    //                 "id":262,
                    //                 "amount_multiplier":1,
                    //                 "currency_code":"ARDR",
                    //                 "market_code":"BTC",
                    //                 "currency_name":"ARDOR",
                    //                 "market_name":"Bitcoin",
                    //                 "symbol":"ARDR_BTC",
                    //                 "group_name":"BTC",
                    //                 "group_id":1,
                    //                 "ask":"0.00000630",
                    //                 "bid":"0.00000613",
                    //                 "last":"0.00000617",
                    //                 "open":"0.00000620",
                    //                 "low":"0.00000614",
                    //                 "high":"0.00000630",
                    //                 "volume":"30.37795305",
                    //                 "volumeQuote":"4911487.01996544",
                    //                 "count":"710",
                    //                 "fiatsRate":{
                    //                     "USD":7230.86,
                    //                     "EUR":6590.79,
                    //                     "UAH":173402,
                    //                     "AUD":10744.52,
                    //                     "IDR":101568085,
                    //                     "CNY":50752,
                    //                     "KRW":8452295,
                    //                     "JPY":784607,
                    //                     "VND":167315119,
                    //                     "INR":517596,
                    //                     "GBP":5607.25,
                    //                     "CAD":9602.63,
                    //                     "BRL":30472,
                    //                     "RUB":467358
                    //                 },
                    //                 "timestamp":1574698617304,
                    //                 "group_position":1
                    //             },
                    //         ]
                    //     }
                    //
                    const tickers = this.safeValue(response, 'data', []);
                    return this.parseTickers(tickers, symbols);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "time": 1566086400000,
                    //         "close": 0.01895,
                    //         "open": 0.01812427,
                    //         "high": 0.0191588,
                    //         "low": 0.01807001,
                    //         "volume": 2588.597813750006
                    //     }
                    //
                    return [
                        this.safeInteger(ohlcv, 'time'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1d', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPairId': market['id'],
                        'candlesType': this.timeframes[timeframe]
                    };
                    if (limit === undefined) limit = 100;
                    else request['limit'] = limit;
                    const duration = this.parseTimeframe(timeframe);
                    const timerange = limit * duration;
                    if (since === undefined) {
                        request['timeEnd'] = this.seconds();
                        request['timeStart'] = request['timeEnd'] - timerange;
                    } else {
                        request['timeStart'] = parseInt(since / 1000);
                        request['timeEnd'] = this.sum(request['timeStart'], timerange);
                    }
                    const response = await this.publicGetChartCurrencyPairIdCandlesType(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": [
                    //             {
                    //                 "time": 1566086400000,
                    //                 "close": 0.01895,
                    //                 "open": 0.01812427,
                    //                 "high": 0.0191588,
                    //                 "low": 0.01807001,
                    //                 "volume": 2588.597813750006
                    //             },
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     {
                    //         "id": 35989317,
                    //         "price": "0.02033813",
                    //         "amount": "3.60000000",
                    //         "type": "BUY",
                    //         "timestamp": "1574713503"
                    //     }
                    //
                    // private fetchMyTrades, fetchClosedOrder, fetchOrderTrades
                    //
                    //     {
                    //         "id": 658745,
                    //         "buy_order_id": 6587453,
                    //         "sell_order_id": 6587459,
                    //         "price": 0.012285,
                    //         "amount": 6.35,
                    //         "trade_type": "SELL",
                    //         "timestamp": "1538737692"
                    //     }
                    //
                    const id = this.safeString(trade, 'id');
                    const timestamp = this.safeTimestamp(trade, 'timestamp');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    let symbol = undefined;
                    if (symbol === undefined && market !== undefined) symbol = market['symbol'];
                    const side = this.safeStringLower2(trade, 'type', 'trade_type');
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': undefined,
                        'type': undefined,
                        'takerOrMaker': undefined,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPairId': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // currently limited to 100 or fewer
                    if (since !== undefined) {
                        request['sort'] = 'ASC'; // needed to make the from param work
                        request['from'] = parseInt(since / 1000);
                    }
                    const response = await this.publicGetTradesCurrencyPairId(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": [
                    //             {
                    //                 "id": 35989317,
                    //                 "price": "0.02033813",
                    //                 "amount": "3.60000000",
                    //                 "type": "BUY",
                    //                 "timestamp": "1574713503"
                    //             },
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, 'data', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPairId': market['id']
                    };
                    const response = await this.tradingGetFeesCurrencyPairId(this.extend(request, params));
                    //
                    //     {
                    //         success: true,
                    //         data: { buy_fee: '0.00200000', sell_fee: '0.00200000' },
                    //         unified_message: { message_id: 'operation_successful', substitutions: [] }
                    //      }
                    //
                    const data = this.safeValue(response, 'data');
                    return {
                        'info': response,
                        'symbol': market['symbol'],
                        'maker': this.safeNumber(data, 'sell_fee'),
                        'taker': this.safeNumber(data, 'buy_fee'),
                        'percentage': true,
                        'tierBased': true
                    };
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const balances = this.safeValue(response, 'data', []);
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const code = this.safeCurrencyCode(this.safeString(balance, 'currency_id'));
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'balance');
                        account['used'] = this.safeString(balance, 'frozen_balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    // await this.loadAccounts ();
                    const response = await this.profileGetWallets(params);
                    //
                    //     {
                    //         "success": true,
                    //         "data": [
                    //             {
                    //                 "id": null,
                    //                 "currency_id": 665,
                    //                 "delisted": false,
                    //                 "disabled": false,
                    //                 "disable_deposits": false,
                    //                 "currency_code": "ORM",
                    //                 "currency_name": "Orium",
                    //                 "currency_type_id": 5,
                    //                 "balance": "0",
                    //                 "frozen_balance": "0",
                    //                 "bonus_balance": "0",
                    //                 "total_balance": "0",
                    //                 "protocol_specific_settings": null,
                    //                 "rates": { "BTC": "0.00000000020", "USD": "0.00000147" },
                    //             },
                    //             {
                    //                 "id": null,
                    //                 "currency_id": 272,
                    //                 "delisted": false,
                    //                 "disabled": false,
                    //                 "disable_deposits": false,
                    //                 "currency_code": "USDT",
                    //                 "currency_name": "TetherUSD",
                    //                 "currency_type_id": 23,
                    //                 "balance": "0",
                    //                 "frozen_balance": "0",
                    //                 "bonus_balance": "0",
                    //                 "total_balance": "0",
                    //                 "protocol_specific_settings": [
                    //                     { "protocol_name": "OMNI", "protocol_id": 10, "active": true, "withdrawal_fee_currency_id": 272, "withdrawal_fee_const": 10, "withdrawal_fee_percent": 0, "block_explorer_url": "https://omniexplorer.info/search/" },
                    //                     { "protocol_name": "ERC20", "protocol_id": 5, "active": true, "withdrawal_fee_const": 1.2, "withdrawal_fee_percent": 0, "block_explorer_url": "https://etherscan.io/tx/" },
                    //                     { "protocol_name": "TRON", "protocol_id": 24, "active": true, "withdrawal_fee_currency_id": 272, "withdrawal_fee_const": 0.2, "withdrawal_fee_percent": 0, "block_explorer_url": "https://tronscan.org/#/transaction/" }
                    //                 ],
                    //                 "rates": { "BTC": "0.00013893", "USD": "1" },
                    //             },
                    //         ]
                    //     }
                    //
                    return this.parseBalance(response);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'PROCESSING': 'open',
                        'PENDING': 'open',
                        'PARTIAL': 'open',
                        'FINISHED': 'closed',
                        'CANCELLED': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder, fetchOpenOrders, fetchClosedOrders, cancelOrder, fetchOrder, fetchClosedOrder
                    //
                    //     {
                    //         "id": 828680665,
                    //         "currency_pair_id": 1,
                    //         "currency_pair_name": "NXT_BTC",
                    //         "price": "0.011384",
                    //         "trigger_price": 0.011385,
                    //         "initial_amount": "13.942",
                    //         "processed_amount": "3.724", // missing in fetchClosedOrder
                    //         "type": "SELL",
                    //         "original_type": "STOP_LIMIT_SELL",
                    //         "created": "2019-01-17 10:14:48",
                    //         "timestamp": "1547720088",
                    //         "status": "PARTIAL"
                    //         // fetchClosedOrder only
                    //         "trades": [
                    //             {
                    //                 "id": 658745,
                    //                 "buy_order_id": 658745,
                    //                 "sell_order_id": 828680665,
                    //                 "price": 0.012285,
                    //                 "amount": 6.35,
                    //                 "trade_type": "SELL",
                    //                 "timestamp": "1538737692"
                    //             }
                    //         ],
                    //         // fetchClosedOrder only
                    //         "fees": [
                    //             {
                    //                 "id": 1234567,
                    //                 "currency_id": 1,
                    //                 "amount": 0.00025,
                    //                 "timestamp": "1548149238"
                    //             }
                    //         ]
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const marketId = this.safeString2(order, 'currency_pair_id', 'currency_pair_name');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const timestamp = this.safeTimestamp(order, 'timestamp');
                    const price = this.safeNumber(order, 'price');
                    const amount = this.safeNumber(order, 'initial_amount');
                    const filled = this.safeNumber(order, 'processed_amount');
                    let remaining = undefined;
                    let cost = undefined;
                    if (filled !== undefined) {
                        if (amount !== undefined) {
                            remaining = amount - filled;
                            if (this.options['parseOrderToPrecision']) remaining = parseFloat(this.amountToPrecision(symbol, remaining));
                            remaining = Math.max(remaining, 0.0);
                        }
                        if (price !== undefined) {
                            if (cost === undefined) cost = price * filled;
                        }
                    }
                    let type = this.safeString(order, 'original_type');
                    if (type === 'BUY' || type === 'SELL') type = undefined;
                    const side = this.safeStringLower(order, 'type');
                    const rawTrades = this.safeValue(order, 'trades');
                    let trades = undefined;
                    if (rawTrades !== undefined) trades = this.parseTrades(rawTrades, market, undefined, undefined, {
                        'symbol': symbol,
                        'order': id
                    });
                    const stopPrice = this.safeNumber(order, 'trigger_price');
                    const result = {
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'cost': cost,
                        'average': undefined,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'trades': trades
                    };
                    const fees = this.safeValue(order, 'fees');
                    if (fees === undefined) result['fee'] = undefined;
                    else {
                        const numFees = fees.length;
                        if (numFees > 0) {
                            result['fees'] = [];
                            for(let i = 0; i < fees.length; i++){
                                const feeCost = this.safeNumber(fees[i], 'amount');
                                if (feeCost !== undefined) {
                                    const feeCurrencyId = this.safeString(fees[i], 'currency_id');
                                    const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                                    result['fees'].push({
                                        'cost': feeCost,
                                        'currency': feeCurrencyCode
                                    });
                                }
                            }
                        } else result['fee'] = undefined;
                    }
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (type === 'market') throw new ExchangeError1(this.id + ' createOrder() allows limit orders only');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (type === 'limit') type = side;
                    const request = {
                        'currencyPairId': market['id'],
                        'type': type.toUpperCase(),
                        'amount': parseFloat(this.amountToPrecision(symbol, amount)),
                        'price': parseFloat(this.priceToPrecision(symbol, price))
                    };
                    const response = await this.tradingPostOrdersCurrencyPairId(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": {
                    //             "id": 828680665,
                    //             "currency_pair_id": 1,
                    //             "currency_pair_name": "NXT_BTC",
                    //             "price": "0.011384",
                    //             "trigger_price": 0.011385,
                    //             "initial_amount": "13.942",
                    //             "processed_amount": "3.724",
                    //             "type": "SELL",
                    //             "original_type": "STOP_LIMIT_SELL",
                    //             "created": "2019-01-17 10:14:48",
                    //             "timestamp": "1547720088",
                    //             "status": "PARTIAL"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseOrder(data, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderId': id
                    };
                    const response = await this.tradingGetOrderOrderId(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": {
                    //             "id": 828680665,
                    //             "currency_pair_id": 1,
                    //             "currency_pair_name": "NXT_BTC",
                    //             "price": "0.011384",
                    //             "trigger_price": 0.011385,
                    //             "initial_amount": "13.942",
                    //             "processed_amount": "3.724",
                    //             "type": "SELL",
                    //             "original_type": "STOP_LIMIT_SELL",
                    //             "created": "2019-01-17 10:14:48",
                    //             "timestamp": "1547720088",
                    //             "status": "PARTIAL"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    return this.parseOrder(data, market);
                }
                async fetchClosedOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderId': id
                    };
                    const response = await this.reportsGetOrdersOrderId(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": {
                    //             "id": 5478965,
                    //             "currency_pair_id": 1,
                    //             "currency_pair_name": "NXT_BTC",
                    //             "price": "0.00013800",
                    //             "initial_amount": "1.00000000",
                    //             "type": "BUY",
                    //             "created": "2019-01-22 09:27:17",
                    //             "timestamp": 1548149237,
                    //             "status": "FINISHED",
                    //             "trades": [
                    //                 {
                    //                     "id": 658745,
                    //                     "buy_order_id": 6587453,
                    //                     "sell_order_id": 6587459,
                    //                     "price": 0.012285,
                    //                     "amount": 6.35,
                    //                     "trade_type": "SELL",
                    //                     "timestamp": "1538737692"
                    //                 }
                    //             ],
                    //             "fees": [
                    //                 {
                    //                     "id": 1234567,
                    //                     "currency_id": 1,
                    //                     "amount": 0.00025,
                    //                     "timestamp": "1548149238"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    return this.parseOrder(data, market);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    const order = await this.fetchClosedOrder(id, symbol, params);
                    return order['trades'];
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    let method = 'tradingGetOrders';
                    const request = {
                    };
                    if (symbol !== undefined) {
                        method = 'tradingGetOrdersCurrencyPairId';
                        market = this.market(symbol);
                        request['currencyPairId'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": [
                    //             {
                    //                 "id": 828680665,
                    //                 "currency_pair_id": 1,
                    //                 "currency_pair_name": "NXT_BTC",
                    //                 "price": "0.011384",
                    //                 "trigger_price": 0.011385,
                    //                 "initial_amount": "13.942",
                    //                 "processed_amount": "3.724",
                    //                 "type": "SELL",
                    //                 "original_type": "STOP_LIMIT_SELL",
                    //                 "created": "2019-01-17 10:14:48",
                    //                 "timestamp": "1547720088",
                    //                 "status": "PARTIAL"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderId': id
                    };
                    const response = await this.tradingDeleteOrderOrderId(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": {
                    //             "put_into_processing_queue": [
                    //                 {
                    //                     "id": 828680665,
                    //                     "currency_pair_id": 1,
                    //                     "currency_pair_name": "NXT_BTC",
                    //                     "price": "0.011384",
                    //                     "trigger_price": 0.011385,
                    //                     "initial_amount": "13.942",
                    //                     "processed_amount": "3.724",
                    //                     "type": "SELL",
                    //                     "original_type": "STOP_LIMIT_SELL",
                    //                     "created": "2019-01-17 10:14:48",
                    //                     "timestamp": "1547720088",
                    //                     "status": "PARTIAL"
                    //                 }
                    //             ],
                    //             "not_put_into_processing_queue": [
                    //                 {
                    //                     "id": 828680665,
                    //                     "currency_pair_id": 1,
                    //                     "currency_pair_name": "NXT_BTC",
                    //                     "price": "0.011384",
                    //                     "trigger_price": 0.011385,
                    //                     "initial_amount": "13.942",
                    //                     "processed_amount": "3.724",
                    //                     "type": "SELL",
                    //                     "original_type": "STOP_LIMIT_SELL",
                    //                     "created": "2019-01-17 10:14:48",
                    //                     "timestamp": "1547720088",
                    //                     "status": "PARTIAL"
                    //                 }
                    //             ],
                    //             "message": "string"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const acceptedOrders = this.safeValue(data, 'put_into_processing_queue', []);
                    const rejectedOrders = this.safeValue(data, 'not_put_into_processing_queue', []);
                    const numAcceptedOrders = acceptedOrders.length;
                    const numRejectedOrders = rejectedOrders.length;
                    if (numAcceptedOrders < 1) {
                        if (numRejectedOrders < 1) throw new OrderNotFound(this.id + ' cancelOrder() received an empty response: ' + this.json(response));
                        else return this.parseOrder(rejectedOrders[0]);
                    } else {
                        if (numRejectedOrders < 1) return this.parseOrder(acceptedOrders[0]);
                        else throw new OrderNotFound(this.id + ' cancelOrder() received an empty response: ' + this.json(response));
                    }
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let method = 'tradingDeleteOrders';
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        request['currencyPairId'] = market['id'];
                        method = 'tradingDeleteOrdersCurrencyPairId';
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "success":true,
                    //         "data":{
                    //             "put_into_processing_queue":[],
                    //             "not_put_into_processing_queue":[],
                    //             "message":"Orders operations are handled in processing queue, therefore cancelling is not immediate."
                    //         }
                    //     }
                    //
                    return response;
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'currencyPairId': market['id']
                    };
                    if (since !== undefined) request['timeStart'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.reportsGetTradesCurrencyPairId(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": [
                    //             {
                    //                 "id": 658745,
                    //                 "buy_order_id": 6587453,
                    //                 "sell_order_id": 6587459,
                    //                 "price": 0.012285,
                    //                 "amount": 6.35,
                    //                 "trade_type": "SELL",
                    //                 "timestamp": "1538737692"
                    //             }
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, 'data', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currencyId': currency['id']
                    };
                    const response = await this.profilePostWalletsCurrencyId(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": {
                    //             "id": 45875,
                    //             "currency_id": 1,
                    //             "delisted": false,
                    //             "disabled": false,
                    //             "disable_deposits": false,
                    //             "code": "BTC",
                    //             "balance": "0.198752",
                    //             "frozen_balance": "1.5784",
                    //             "bonus_balance": "0.000",
                    //             "deposit_address": {
                    //                 "address": "0X12WERTYUIIJHGFVBNMJHGDFGHJ765SDFGHJ",
                    //                 "address_name": "Address",
                    //                 "additional_address_parameter": "qwertyuiopasdfghjkl",
                    //                 "additional_address_parameter_name": "Destination Tag",
                    //                 "notification": "",
                    //                 "protocol_id": 10,
                    //                 "protocol_name": "Tether OMNI",
                    //                 "supports_new_address_creation": false
                    //                 },
                    //             "multi_deposit_addresses": [
                    //                 {
                    //                     "address": "0X12WERTYUIIJHGFVBNMJHGDFGHJ765SDFGHJ",
                    //                     "address_name": "Address",
                    //                     "additional_address_parameter": "qwertyuiopasdfghjkl",
                    //                     "additional_address_parameter_name": "Destination Tag",
                    //                     "notification": "",
                    //                     "protocol_id": 10,
                    //                     "protocol_name": "Tether OMNI",
                    //                     "supports_new_address_creation": false
                    //                 }
                    //             ],
                    //             "withdrawal_additional_field_name": "Payment ID (optional)",
                    //             "rates": { "BTC": 0.000001 },
                    //             "protocol_specific_settings": [
                    //                 {
                    //                     "protocol_name": "Tether OMNI",
                    //                     "protocol_id": 10,
                    //                     "active": true,
                    //                     "withdrawal_fee_currency_id": 1,
                    //                     "withdrawal_fee_const": 0.002,
                    //                     "withdrawal_fee_percent": 0,
                    //                     "block_explorer_url": "https://omniexplorer.info/search/"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const depositAddress = this.safeValue(data, 'deposit_address', {});
                    const address = this.safeString(depositAddress, 'address');
                    const tag = this.safeString(depositAddress, 'additional_address_parameter');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'info': response
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const balance = await this.fetchBalance();
                    const wallets = this.safeValue(balance['info'], 'data', []);
                    const walletsByCurrencyId = this.indexBy(wallets, 'currency_id');
                    const currency = this.currency(code);
                    const wallet = this.safeValue(walletsByCurrencyId, currency['id']);
                    if (wallet === undefined) throw new ExchangeError1(this.id + ' fetchDepositAddress() could not find the wallet id for currency code ' + code + ', try to call createDepositAddress() first');
                    const walletId = this.safeInteger(wallet, 'id');
                    if (walletId === undefined) throw new ExchangeError1(this.id + ' fetchDepositAddress() could not find the wallet id for currency code ' + code + ', try to call createDepositAddress() first');
                    const request = {
                        'walletId': walletId
                    };
                    const response = await this.profileGetWalletsWalletId(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": {
                    //             "id": 45875,
                    //             "currency_id": 1,
                    //             "delisted": false,
                    //             "disabled": false,
                    //             "disable_deposits": false,
                    //             "code": "BTC",
                    //             "balance": "0.198752",
                    //             "frozen_balance": "1.5784",
                    //             "bonus_balance": "0.000",
                    //             "deposit_address": {
                    //                 "address": "0X12WERTYUIIJHGFVBNMJHGDFGHJ765SDFGHJ",
                    //                 "address_name": "Address",
                    //                 "additional_address_parameter": "qwertyuiopasdfghjkl",
                    //                 "additional_address_parameter_name": "Destination Tag",
                    //                 "notification": "",
                    //                 "protocol_id": 10,
                    //                 "protocol_name": "Tether OMNI",
                    //                 "supports_new_address_creation": false
                    //             },
                    //             "multi_deposit_addresses": [
                    //                 {
                    //                     "address": "0X12WERTYUIIJHGFVBNMJHGDFGHJ765SDFGHJ",
                    //                     "address_name": "Address",
                    //                     "additional_address_parameter": "qwertyuiopasdfghjkl",
                    //                     "additional_address_parameter_name": "Destination Tag",
                    //                     "notification": "",
                    //                     "protocol_id": 10,
                    //                     "protocol_name": "Tether OMNI",
                    //                     "supports_new_address_creation": false
                    //                 }
                    //             ],
                    //             "withdrawal_additional_field_name": "Payment ID (optional)",
                    //             "rates": { "BTC": 0.000001 },
                    //             "protocol_specific_settings": [
                    //                 {
                    //                     "protocol_name": "Tether OMNI",
                    //                     "protocol_id": 10,
                    //                     "active": true,
                    //                     "withdrawal_fee_currency_id": 1,
                    //                     "withdrawal_fee_const": 0.002,
                    //                     "withdrawal_fee_percent": 0,
                    //                     "block_explorer_url": "https://omniexplorer.info/search/"
                    //                 }
                    //             ]
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const depositAddress = this.safeValue(data, 'deposit_address', {});
                    const address = this.safeString(depositAddress, 'address');
                    const tag = this.safeString(depositAddress, 'additional_address_parameter');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + api + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        headers = {
                            'Authorization': 'Bearer ' + this.token
                        };
                        if (method === 'GET' || method === 'DELETE') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else {
                            body = this.json(query);
                            if (Object.keys(query).length) headers['Content-Type'] = 'application/json';
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'processing': 'pending',
                        'checking by system': 'pending',
                        'hodl': 'pending',
                        'amount too low': 'failed',
                        'not confirmed': 'pending',
                        'cancelled by user': 'canceled',
                        'approved': 'pending',
                        'finished': 'ok',
                        'withdrawal error': 'failed',
                        'deposit error': 'failed',
                        'cancelled by admin': 'canceled',
                        'awaiting': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "id": 123654789,
                    //         "currency_id": 1,
                    //         "currency_code": "BTC",
                    //         "deposit_fee_currency_id": 1,
                    //         "deposit_fee_currency_code": "BTC",
                    //         "amount": 0.25,
                    //         "fee": 0.00025,
                    //         "txid": "qwertyuhgfdsasdfgh",
                    //         "protocol_id": 0,
                    //         "deposit_status_id": 1,
                    //         "status": "PROCESSING",
                    //         "status_color": "#BC3D51",
                    //         "created_at": "2018-11-28 12:32:08",
                    //         "timestamp": "1543409389",
                    //         "confirmations": "1 of 2"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "id": 65899,
                    //         "amount": "0.00600000",
                    //         "currency_id": 1,
                    //         "currency_code": "BTC",
                    //         "fee": "0.00400000",
                    //         "fee_currency_id": 1,
                    //         "fee_currency_code": "BTC",
                    //         "withdrawal_status_id": 1,
                    //         "status": "Not Confirmed",
                    //         "status_color": "#BC3D51",
                    //         "created_at": "2019-01-21 09:36:05",
                    //         "created_ts": "1548063365",
                    //         "updated_at": "2019-01-21 09:36:05",
                    //         "updated_ts": "1548063365",
                    //         "txid": null,
                    //         "protocol_id": 0,
                    //         "withdrawal_address": {
                    //             "address": "0X12WERTYUIIJHGFVBNMJHGDFGHJ765SDFGHJ",
                    //             "address_name": "Address",
                    //             "additional_address_parameter": "qwertyuiopasdfghjkl",
                    //             "additional_address_parameter_name": "Destination Tag",
                    //             "notification": "",
                    //             "protocol_id": 10,
                    //             "protocol_name": "Tether OMNI",
                    //             "supports_new_address_creation": false
                    //         }
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const withdrawalAddress = this.safeValue(transaction, 'withdrawal_address', {});
                    const address = this.safeString(withdrawalAddress, 'address');
                    const tag = this.safeString(withdrawalAddress, 'additional_address_parameter');
                    const currencyId = this.safeString(transaction, 'currency_id');
                    let code = undefined;
                    if (currencyId in this.currencies_by_id) currency = this.currencies_by_id[currencyId];
                    else code = this.commonCurrencyCode(this.safeString(transaction, 'currency_code'));
                    if (code === undefined && currency !== undefined) code = currency['code'];
                    const type = 'deposit_status_id' in transaction ? 'deposit' : 'withdrawal';
                    const amount = this.safeNumber(transaction, 'amount');
                    const status = this.parseTransactionStatus(this.safeStringLower(transaction, 'status'));
                    const timestamp = this.safeTimestamp2(transaction, 'timestamp', 'created_ts');
                    const updated = this.safeTimestamp(transaction, 'updated_ts');
                    const txid = this.safeString(transaction, 'txid');
                    let fee = undefined;
                    const feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost !== undefined) {
                        const feeCurrencyId = this.safeString(transaction, 'fee_currency_id', 'deposit_fee_currency_id');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrencyCode
                        };
                    }
                    const network = this.safeString(withdrawalAddress, 'protocol_name');
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'addressFrom': undefined,
                        'address': address,
                        'addressTo': address,
                        'tagFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currencyId'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['timeStart'] = since;
                    const response = await this.profileGetDeposits(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": [
                    //             {
                    //                 "id": 123654789,
                    //                 "currency_id": 1,
                    //                 "currency_code": "BTC",
                    //                 "deposit_fee_currency_id": 1,
                    //                 "deposit_fee_currency_code": "BTC",
                    //                 "amount": 0.25,
                    //                 "fee": 0.00025,
                    //                 "txid": "qwertyuhgfdsasdfgh",
                    //                 "protocol_id": 0,
                    //                 "deposit_status_id": 1,
                    //                 "status": "PROCESSING",
                    //                 "status_color": "#BC3D51",
                    //                 "created_at": "2018-11-28 12:32:08",
                    //                 "timestamp": "1543409389",
                    //                 "confirmations": "1 of 2",
                    //                 "protocol_specific_settings": {
                    //                     "protocol_name": "Tether OMNI",
                    //                     "protocol_id": 10,
                    //                     "block_explorer_url": "https://omniexplorer.info/search/"
                    //                 }
                    //             }
                    //         ]
                    //     }
                    //
                    const deposits = this.safeValue(response, 'data', []);
                    return this.parseTransactions(deposits, code, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    let currency = undefined;
                    const request = {};
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currencyId'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['timeStart'] = since;
                    const response = await this.profileGetWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": [
                    //             {
                    //                 "id": 65899,
                    //                 "amount": "0.00600000",
                    //                 "currency_id": 1,
                    //                 "currency_code": "BTC",
                    //                 "fee": "0.00400000",
                    //                 "fee_currency_id": 1,
                    //                 "fee_currency_code": "BTC",
                    //                 "withdrawal_status_id": 1,
                    //                 "status": "Not Confirmed",
                    //                 "status_color": "#BC3D51",
                    //                 "created_at": "2019-01-21 09:36:05",
                    //                 "created_ts": "1548063365",
                    //                 "updated_at": "2019-01-21 09:36:05",
                    //                 "updated_ts": "1548063365",
                    //                 "txid": null,
                    //                 "protocol_id": 0,
                    //                 "withdrawal_address": {
                    //                     "address": "0X12WERTYUIIJHGFVBNMJHGDFGHJ765SDFGHJ",
                    //                     "address_name": "Address",
                    //                     "additional_address_parameter": "qwertyuiopasdfghjkl",
                    //                     "additional_address_parameter_name": "Destination Tag",
                    //                     "notification": "",
                    //                     "protocol_id": 10,
                    //                     "protocol_name": "Tether OMNI",
                    //                     "supports_new_address_creation": false
                    //                 },
                    //                 "protocol_specific_settings": {
                    //                     "protocol_name": "Tether OMNI",
                    //                     "protocol_id": 10,
                    //                     "block_explorer_url": "https://omniexplorer.info/search/"
                    //                 }
                    //             }
                    //         ]
                    //     }
                    //
                    const withdrawals = this.safeValue(response, 'data', []);
                    return this.parseTransactions(withdrawals, code, since, limit);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency_id': currency['id'],
                        'amount': parseFloat(this.currencyToPrecision(code, amount)),
                        'address': address
                    };
                    if (tag !== undefined) request['additional_address_parameter'] = tag;
                    const networks = this.safeValue(this.options, 'networks', {});
                    let network = this.safeStringUpper(params, 'network'); // this line allows the user to specify either ERC20 or ETH
                    network = this.safeInteger(networks, network, network); // handle ERC20>ETH alias
                    if (network !== undefined) {
                        request['protocol_id'] = network;
                        params = this.omit(params, 'network');
                    }
                    const response = await this.profilePostWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "data": {
                    //             "id": 65899,
                    //             "amount": "0.00600000",
                    //             "currency_id": 1,
                    //             "currency_code": "BTC",
                    //             "fee": "0.00400000",
                    //             "fee_currency_id": 1,
                    //             "fee_currency_code": "BTC",
                    //             "withdrawal_status_id": 1,
                    //             "status": "Not Confirmed",
                    //             "status_color": "#BC3D51",
                    //             "created_at": "2019-01-21 09:36:05",
                    //             "created_ts": "1548063365",
                    //             "updated_at": "2019-01-21 09:36:05",
                    //             "updated_ts": "1548063365",
                    //             "txid": null,
                    //             "protocol_id": 0,
                    //             "withdrawal_address": {
                    //                 "address": "0X12WERTYUIIJHGFVBNMJHGDFGHJ765SDFGHJ",
                    //                 "address_name": "Address",
                    //                 "additional_address_parameter": "qwertyuiopasdfghjkl",
                    //                 "additional_address_parameter_name": "Destination Tag",
                    //                 "notification": "",
                    //                 "protocol_id": 10,
                    //                 "protocol_name": "Tether OMNI",
                    //                 "supports_new_address_creation": false
                    //             }
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    return this.parseTransaction(data, currency);
                }
                async fetchFundingFees(codes, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     {
                    //         "success": true,
                    //         "data": [
                    //             {
                    //                 "id": 1,
                    //                 "code": "BTC",
                    //                 "name": "Bitcoin",
                    //                 "active": true,
                    //                 "delisted": false,
                    //                 "precision": 8,
                    //                 "minimum_tx_confirmations": 24,
                    //                 "minimum_withdrawal_amount": "0.009",
                    //                 "minimum_deposit_amount": "0.000003",
                    //                 "deposit_fee_currency_id": 1,
                    //                 "deposit_fee_currency_code": "ETH",
                    //                 "deposit_fee_const": "0.00001",
                    //                 "deposit_fee_percent": "0",
                    //                 "withdrawal_fee_currency_id": 1,
                    //                 "withdrawal_fee_currency_code": "ETH",
                    //                 "withdrawal_fee_const": "0.0015",
                    //                 "withdrawal_fee_percent": "0",
                    //                 "withdrawal_limit": "string",
                    //                 "block_explorer_url": "https://blockchain.info/tx/",
                    //                 "protocol_specific_settings": [
                    //                     {
                    //                         "protocol_name": "Tether OMNI",
                    //                         "protocol_id": 10,
                    //                         "active": true,
                    //                         "withdrawal_fee_currency_id": 1,
                    //                         "withdrawal_fee_const": 0.002,
                    //                         "withdrawal_fee_percent": 0,
                    //                         "block_explorer_url": "https://omniexplorer.info/search/"
                    //                     }
                    //                 ]
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const withdrawFees = {};
                    const depositFees = {};
                    for(let i = 0; i < data.length; i++){
                        const id = this.safeString(data[i], 'id');
                        const code = this.safeCurrencyCode(id);
                        withdrawFees[code] = this.safeNumber(data[i], 'withdrawal_fee_const');
                        depositFees[code] = this.safeNumber(data[i], 'deposit_fee_const');
                    }
                    return {
                        'withdraw': withdrawFees,
                        'deposit': depositFees,
                        'info': response
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //     {"success":false,"message":"Wrong parameters","errors":{"candleType":["Invalid Candle Type!"]}}
                    //     {"success":false,"message":"Wrong parameters","errors":{"time":["timeStart or timeEnd is less then 1"]}}
                    //     {"success":false,"message":"Not enough  ETH"}
                    //
                    const success = this.safeValue(response, 'success', false);
                    if (!success) {
                        const message = this.safeString(response, 'message');
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    161: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, BadRequest: BadRequest, OrderNotFound: OrderNotFound, InvalidAddress: InvalidAddress } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class therock extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'therock',
                        'name': 'TheRockTrading',
                        'countries': [
                            'MT'
                        ],
                        // 10 requests per second => 1000ms / 10 => 100 ms between requests (all endpoints)
                        'rateLimit': 100,
                        'version': 'v1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLedger': true,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': true,
                            'fetchTransactions': 'emulated',
                            'fetchWithdrawals': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766869-75057fa2-5ee9-11e7-9a6f-13e641fa4707.jpg',
                            'api': 'https://api.therocktrading.com',
                            'www': 'https://therocktrading.com',
                            'doc': [
                                'https://api.therocktrading.com/doc/v1/index.html',
                                'https://api.therocktrading.com/doc/'
                            ]
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'funds': 1,
                                    'funds/{id}': 1,
                                    'funds/{id}/orderbook': 1,
                                    'funds/{id}/ticker': 1,
                                    'funds/{id}/trades': 1,
                                    'funds/tickers': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'balances': 1,
                                    'balances/{id}': 1,
                                    'discounts': 1,
                                    'discounts/{id}': 1,
                                    'funds': 1,
                                    'funds/{id}': 1,
                                    'funds/{id}/trades': 1,
                                    'funds/{fund_id}/orders': 1,
                                    'funds/{fund_id}/orders/{id}': 1,
                                    'funds/{fund_id}/position_balances': 1,
                                    'funds/{fund_id}/positions': 1,
                                    'funds/{fund_id}/positions/{id}': 1,
                                    'transactions': 1,
                                    'transactions/{id}': 1,
                                    'withdraw_limits/{id}': 1,
                                    'withdraw_limits': 1
                                },
                                'post': {
                                    'atms/withdraw': 1,
                                    'funds/{fund_id}/orders': 1
                                },
                                'delete': {
                                    'funds/{fund_id}/orders/{id}': 1,
                                    'funds/{fund_id}/orders/remove_all': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.002'),
                                'taker': this.parseNumber('0.002')
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false,
                                'withdraw': {},
                                'deposit': {
                                    'BTC': 0,
                                    'BCH': 0,
                                    'PPC': 0,
                                    'ETH': 0,
                                    'ZEC': 0,
                                    'LTC': 0,
                                    'EUR': 0
                                }
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'Request already running': BadRequest,
                                'cannot specify multiple address types': BadRequest,
                                'Currency is not included in the list': BadRequest,
                                'Record not found': OrderNotFound
                            },
                            'broad': {
                                'before must be greater than after param': BadRequest,
                                'must be shorter than 60 days': BadRequest,
                                'must be a multiple of (period param) in minutes': BadRequest,
                                'Address allocation limit reached for currency': InvalidAddress,
                                'is not a valid value for param currency': BadRequest,
                                ' is invalid': InvalidAddress
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetFunds(params);
                    //
                    //    {
                    //        funds: [
                    //            {
                    //                id: "BTCEUR",
                    //                description: "Trade Bitcoin with Euro",
                    //                type: "currency",
                    //                base_currency: "EUR",
                    //                trade_currency: "BTC",
                    //                buy_fee: 0.2,
                    //                sell_fee: 0.2,
                    //                minimum_price_offer: 0.01,
                    //                minimum_quantity_offer: 0.0005,
                    //                base_currency_decimals: 2,
                    //                trade_currency_decimals: 4,
                    //                leverages: []
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    const markets = this.safeValue(response, 'funds');
                    const result = [];
                    if (markets === undefined) throw new ExchangeError1(this.id + ' fetchMarkets() got an unexpected response');
                    else for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'id');
                        const baseId = this.safeString(market, 'trade_currency');
                        const quoteId = this.safeString(market, 'base_currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const buy_fee = this.safeString(market, 'buy_fee');
                        const sell_fee = this.safeString(market, 'sell_fee');
                        let taker = Precise.stringMax(buy_fee, sell_fee);
                        taker = this.parseNumber(Precise.stringDiv(taker, '100'));
                        const leverages = this.safeValue(market, 'leverages');
                        const leveragesLength = leverages.length;
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': leveragesLength > 0,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': taker,
                            'maker': taker,
                            'contractSize': undefined,
                            'active': true,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'trade_currency_decimals'),
                                'price': this.safeInteger(market, 'base_currency_decimals')
                            },
                            'limits': {
                                'leverage': {
                                    'min': 1,
                                    'max': this.safeValue(leverages, leveragesLength - 1, 1)
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minimum_quantity_offer'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'minimum_price_offer'),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'balances', []);
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'trading_balance');
                        account['total'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalances(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': this.marketId(symbol)
                    };
                    const orderbook = await this.publicGetFundsIdOrderbook(this.extend(request, params));
                    const timestamp = this.parse8601(this.safeString(orderbook, 'date'));
                    return this.parseOrderBook(orderbook, symbol, timestamp, 'bids', 'asks', 'price', 'amount');
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "date":"2022-01-16T00:05:08.192Z",
                    //         "fund_id":"ETHBTC",
                    //         "bid":0.07707802,
                    //         "ask":0.07733404,
                    //         "last":0.07739053,
                    //         "open":0.07628192,
                    //         "close":0.07687651,
                    //         "low":0.07612047,
                    //         "high":0.07703306,
                    //         "volume":1.10179665,
                    //         "volume_traded":14.273
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(ticker, 'date'));
                    market = this.safeMarket(undefined, market);
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': market['symbol'],
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': this.safeString(ticker, 'close'),
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume_traded'),
                        'quoteVolume': this.safeString(ticker, 'volume'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetFundsTickers(params);
                    const tickers = this.indexBy(response['tickers'], 'fund_id');
                    const ids = Object.keys(tickers);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const market = this.safeMarket(id);
                        const symbol = market['symbol'];
                        const ticker = tickers[id];
                        result[symbol] = this.parseTicker(ticker, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': market['id']
                    };
                    const response = await this.publicGetFundsIdTicker(this.extend(request, params));
                    //
                    //     {
                    //         "date":"2022-01-16T00:05:08.192Z",
                    //         "fund_id":"ETHBTC",
                    //         "bid":0.07707802,
                    //         "ask":0.07733404,
                    //         "last":0.07739053,
                    //         "open":0.07628192,
                    //         "close":0.07687651,
                    //         "low":0.07612047,
                    //         "high":0.07703306,
                    //         "volume":1.10179665,
                    //         "volume_traded":14.273
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades, fetchOrder trades
                    //
                    //     {      id:  4493548,
                    //       fund_id: "ETHBTC",
                    //        amount:  0.203,
                    //         price:  0.02783576,
                    //          side: "buy",
                    //          dark:  false,
                    //          date: "2018-11-30T08:19:18.236Z" }
                    //
                    // fetchMyTrades
                    //
                    //     {           id:    237338,
                    //            fund_id:   "BTCEUR",
                    //             amount:    0.348,
                    //              price:    348,
                    //               side:   "sell",
                    //               dark:    false,
                    //           order_id:    14920648,
                    //               date:   "2015-06-03T00:49:49.000Z",
                    //       transactions: [ {       id:  2770768,
                    //                             date: "2015-06-03T00:49:49.000Z",
                    //                             type: "sold_currency_to_fund",
                    //                            price:  121.1,
                    //                         currency: "EUR"                       },
                    //                       {       id:  2770769,
                    //                             date: "2015-06-03T00:49:49.000Z",
                    //                             type: "released_currency_to_fund",
                    //                            price:  0.348,
                    //                         currency: "BTC"                        },
                    //                       {       id:  2770772,
                    //                             date: "2015-06-03T00:49:49.000Z",
                    //                             type: "paid_commission",
                    //                            price:  0.06,
                    //                         currency: "EUR",
                    //                         trade_id:  440492                     }   ] }
                    //
                    const marketId = this.safeString(trade, 'fund_id');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.parse8601(this.safeString(trade, 'date'));
                    const id = this.safeString(trade, 'id');
                    const orderId = this.safeString(trade, 'order_id');
                    const side = this.safeString(trade, 'side');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    let fee = undefined;
                    let feeCostString = undefined;
                    const transactions = this.safeValue(trade, 'transactions', []);
                    const transactionsByType = this.groupBy(transactions, 'type');
                    const feeTransactions = this.safeValue(transactionsByType, 'paid_commission', []);
                    for(let i = 0; i < feeTransactions.length; i++){
                        if (feeCostString === undefined) feeCostString = '0.0';
                        feeCostString = Precise.stringAdd(feeCostString, this.safeString(feeTransactions[i], 'price'));
                    }
                    if (feeCostString !== undefined) fee = {
                        'cost': feeCostString,
                        'currency': market['quote']
                    };
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                parseLedgerEntryDirection(direction) {
                    const directions = {
                        'affiliate_earnings': 'in',
                        'atm_payment': 'in',
                        'bought_currency_from_fund': 'out',
                        'bought_shares': 'out',
                        'paid_commission': 'out',
                        'paypal_payment': 'in',
                        'pos_payment': 'in',
                        'released_currency_to_fund': 'out',
                        'rollover_commission': 'out',
                        'sold_currency_to_fund': 'in',
                        'sold_shares': 'in',
                        'transfer_received': 'in',
                        'transfer_sent': 'out',
                        'withdraw': 'out'
                    };
                    return this.safeString(directions, direction, direction);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'affiliate_earnings': 'referral',
                        'atm_payment': 'transaction',
                        'bought_currency_from_fund': 'trade',
                        'bought_shares': 'trade',
                        'paid_commission': 'fee',
                        'paypal_payment': 'transaction',
                        'pos_payment': 'transaction',
                        'released_currency_to_fund': 'trade',
                        'rollover_commission': 'fee',
                        'sold_currency_to_fund': 'trade',
                        'sold_shares': 'trade',
                        'transfer_received': 'transfer',
                        'transfer_sent': 'transfer',
                        'withdraw': 'transaction'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    // withdrawal
                    //
                    //     {
                    //         "id": 21311223,
                    //         "date": "2015-06-30T13:55:11.000Z",
                    //         "type": "withdraw",
                    //         "price": 103.00,
                    //         "currency": "EUR",
                    //         "fund_id": null,
                    //         "order_id": null,
                    //         "trade_id": null,
                    //         "transfer_detail": {
                    //             "method": "wire_transfer",
                    //             "id": "F112DD3",
                    //             "recipient": "IT123456789012",
                    //             "confirmations": 0
                    //         }
                    //     }
                    //
                    // deposit
                    //
                    //     {
                    //         "id": 21311222,
                    //         "date": "2015-06-30T13:55:11.000Z",
                    //         "type": "atm_payment",
                    //         "price": 2.01291,
                    //         "currency": "BTC",
                    //         "fund_id": "null",
                    //         "order_id": null,
                    //         "trade_id": null,
                    //         "transfer_detail": {
                    //             "method": "bitcoin",
                    //             "id": "0e3e2357e806b6cdb1f70b54c3a3a17b6714ee1f0e68bebb44a74b1efd512098",
                    //             "recipient": "mzb3NgX9Dr6jgGAu31L6jsPGB2zkaFxxyf",
                    //             "confirmations": 3
                    //         }
                    //     }
                    //
                    // trade fee
                    //
                    //     {
                    //         "id": 21311221,
                    //         "date": "2015-06-30T13:55:11.000Z",
                    //         "type": "paid_commission",
                    //         "price": 0.0001,
                    //         "fund_id": "BTCEUR",
                    //         "order_id": 12832371,
                    //         "trade_id": 12923212,
                    //         "currency": "BTC",
                    //         "transfer_detail": null
                    //     }
                    //
                    const id = this.safeString(item, 'id');
                    let referenceId = undefined;
                    let type = this.safeString(item, 'type');
                    const direction = this.parseLedgerEntryDirection(type);
                    type = this.parseLedgerEntryType(type);
                    if (type === 'trade' || type === 'fee') referenceId = this.safeString(item, 'trade_id');
                    const currencyId = this.safeString(item, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    const amount = this.safeNumber(item, 'price');
                    const timestamp = this.parse8601(this.safeString(item, 'date'));
                    const status = 'ok';
                    return {
                        'info': item,
                        'id': id,
                        'direction': direction,
                        'account': undefined,
                        'referenceId': referenceId,
                        'referenceAccount': undefined,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'before': undefined,
                        'after': undefined,
                        'status': status,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': undefined
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) request['after'] = this.iso8601(since);
                    const response = await this.privateGetTransactions(this.extend(request, params));
                    //
                    //     {
                    //         "transactions": [
                    //             {
                    //                 "id": 21311223,
                    //                 "date": "2015-06-30T13:55:11.000Z",
                    //                 "type": "withdraw",
                    //                 "price": 103.00,
                    //                 "currency": "EUR",
                    //                 "fund_id": null,
                    //                 "order_id": null,
                    //                 "trade_id": null,
                    //                 "transfer_detail": {
                    //                     "method": "wire_transfer",
                    //                     "id": "F112DD3",
                    //                     "recipient": "IT123456789012",
                    //                     "confirmations": 0
                    //                 }
                    //             },
                    //             {
                    //                 "id": 21311222,
                    //                 "date": "2015-06-30T13:55:11.000Z",
                    //                 "type": "atm_payment",
                    //                 "price": 2.01291,
                    //                 "currency": "BTC",
                    //                 "fund_id": "null",
                    //                 "order_id": null,
                    //                 "trade_id": null,
                    //                 "transfer_detail": {
                    //                     "method": "bitcoin",
                    //                     "id": "0e3e2357e806b6cdb1f70b54c3a3a17b6714ee1f0e68bebb44a74b1efd512098",
                    //                     "recipient": "mzb3NgX9Dr6jgGAu31L6jsPGB2zkaFxxyf",
                    //                     "confirmations": 3
                    //                 }
                    //             },
                    //             {
                    //                 "id": 21311221,
                    //                 "date": "2015-06-30T13:55:11.000Z",
                    //                 "type": "paid_commission",
                    //                 "price": 0.0001,
                    //                 "fund_id": "BTCEUR",
                    //                 "order_id": 12832371,
                    //                 "trade_id": 12923212,
                    //                 "currency": "BTC",
                    //                 "transfer_detail": null
                    //             }
                    //         ],
                    //         "meta": {
                    //             "total_count": 1221,
                    //             "first": { "page": 1, "href": "https://api.therocktrading.com/v1/transactions?page=1" },
                    //             "previous": null,
                    //             "current": { "page": 1, "href": "https://api.therocktrading.com/v1/transactions?page=1" },
                    //             "next": { "page": 2, "href": "https://api.therocktrading.com/v1/transactions?page=2" },
                    //             "last": { "page": 1221, "href": "https://api.therocktrading.com/v1/transactions?page=1221" }
                    //         }
                    //     }
                    //
                    const transactions = this.safeValue(response, 'transactions', []);
                    return this.parseLedger(transactions, currency, since, limit);
                }
                parseTransactionType(type) {
                    const types = {
                        'withdraw': 'withdrawal',
                        'atm_payment': 'deposit'
                    };
                    return this.safeString(types, type, type);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchWithdrawals
                    //
                    //     // fiat
                    //
                    //     {
                    //         "id": 21311223,
                    //         "date": "2015-06-30T13:55:11.000Z",
                    //         "type": "withdraw",
                    //         "price": 103.00,
                    //         "currency": "EUR",
                    //         "fund_id": null,
                    //         "order_id": null,
                    //         "trade_id": null,
                    //         "transfer_detail": {
                    //             "method": "wire_transfer",
                    //             "id": "F112DD3",
                    //             "recipient": "IT123456789012",
                    //             "confirmations": 0
                    //         }
                    //     }
                    //
                    //     {
                    //         "id": 12564223,
                    //         "date": "2017-08-07T08:13:50.023Z",
                    //         "note": "GB7IDL401573388",
                    //         "type": "withdraw",
                    //         "price": 4345.93,
                    //         "fund_id": null,
                    //         "currency": "EUR",
                    //         "order_id": null,
                    //         "trade_id": null,
                    //         "transfer_detail": {
                    //             "id": "EXECUTEDBUTUNCHECKED",
                    //             "method": "wire_transfer",
                    //             "recipient": "GB7IDL401573388",
                    //             "confirmations": 0
                    //         }
                    //     }
                    //
                    //     // crypto
                    //
                    //     {
                    //         id: 20914695,
                    //         date: '2018-02-24T07:13:23.002Z',
                    //         type: 'withdraw',
                    //         price: 2.70883607,
                    //         currency: 'BCH',
                    //         fund_id: null,
                    //         order_id: null,
                    //         trade_id: null,
                    //         note: '1MAHLhJoz9W2ydbRf972WSgJYJ3Ui7aotm',
                    //         transfer_detail: {
                    //             method: 'bitcoin_cash',
                    //             id: '8261949194985b01985006724dca5d6059989e096fa95608271d00dd902327fa',
                    //             recipient: '1MAHLhJoz9W2ydbRf972WSgJYJ3Ui7aotm',
                    //             confirmations: 0
                    //         }
                    //     }
                    //
                    //
                    // fetchDeposits
                    //
                    //     // fiat
                    //
                    //     {
                    //         id: 16176632,
                    //         date: '2017-11-20T21:00:13.355Z',
                    //         type: 'atm_payment',
                    //         price: 5000,
                    //         currency: 'EUR',
                    //         fund_id: null,
                    //         order_id: null,
                    //         trade_id: null,
                    //         note: 'Mistral deposit',
                    //         transfer_detail: {
                    //             method: 'wire_transfer',
                    //             id: '972JQ49337DX769T',
                    //             recipient: null,
                    //             confirmations: 0
                    //         }
                    //     }
                    //
                    //     // crypto
                    //
                    //     {
                    //         "id": 21311222,
                    //         "date": "2015-06-30T13:55:11.000Z",
                    //         "type": "atm_payment",
                    //         "price": 2.01291,
                    //         "currency": "BTC",
                    //         "fund_id": "null",
                    //         "order_id": null,
                    //         "trade_id": null,
                    //         "transfer_detail": {
                    //             "method": "bitcoin",
                    //             "id": "0e3e2357e806b6cdb1f70b54c3a3a17b6714ee1f0e68bebb44a74b1efd512098",
                    //             "recipient": "mzb3NgX9Dr6jgGAu31L6jsPGB2zkaFxxyf",
                    //             "confirmations": 3
                    //         }
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const type = this.parseTransactionType(this.safeString(transaction, 'type'));
                    const detail = this.safeValue(transaction, 'transfer_detail', {});
                    const method = this.safeString(detail, 'method');
                    let txid = undefined;
                    let address = undefined;
                    if (method !== undefined) {
                        if (method !== 'wire_transfer') {
                            txid = this.safeString(detail, 'id');
                            address = this.safeString(detail, 'recipient');
                        }
                    }
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    const amount = this.safeNumber(transaction, 'price');
                    const timestamp = this.parse8601(this.safeString(transaction, 'date'));
                    const status = 'ok';
                    const network = this.safeString(detail, 'method');
                    // todo parse tags
                    return {
                        'info': transaction,
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': network,
                        'addressFrom': undefined,
                        'addressTo': address,
                        'address': address,
                        'tagFrom': undefined,
                        'tagTo': undefined,
                        'tag': undefined,
                        'status': status,
                        'type': type,
                        'updated': undefined,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': undefined
                    };
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    const request = {
                        'type': 'withdraw'
                    };
                    return await this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    const request = {
                        'type': 'atm_payment'
                    };
                    return await this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (since !== undefined) request['after'] = this.iso8601(since);
                    params = this.extend(request, params);
                    const response = await this.privateGetTransactions(params);
                    //
                    //     {
                    //         "transactions": [
                    //             {
                    //                 "id": 21311223,
                    //                 "date": "2015-06-30T13:55:11.000Z",
                    //                 "type": "withdraw",
                    //                 "price": 103.00,
                    //                 "currency": "EUR",
                    //                 "fund_id": null,
                    //                 "order_id": null,
                    //                 "trade_id": null,
                    //                 "transfer_detail": {
                    //                     "method": "wire_transfer",
                    //                     "id": "F112DD3",
                    //                     "recipient": "IT123456789012",
                    //                     "confirmations": 0
                    //                 }
                    //             },
                    //             {
                    //                 "id": 21311222,
                    //                 "date": "2015-06-30T13:55:11.000Z",
                    //                 "type": "atm_payment",
                    //                 "price": 2.01291,
                    //                 "currency": "BTC",
                    //                 "fund_id": "null",
                    //                 "order_id": null,
                    //                 "trade_id": null,
                    //                 "transfer_detail": {
                    //                     "method": "bitcoin",
                    //                     "id": "0e3e2357e806b6cdb1f70b54c3a3a17b6714ee1f0e68bebb44a74b1efd512098",
                    //                     "recipient": "mzb3NgX9Dr6jgGAu31L6jsPGB2zkaFxxyf",
                    //                     "confirmations": 3
                    //                 }
                    //             },
                    //             {
                    //                 "id": 21311221,
                    //                 "date": "2015-06-30T13:55:11.000Z",
                    //                 "type": "paid_commission",
                    //                 "price": 0.0001,
                    //                 "fund_id": "BTCEUR",
                    //                 "order_id": 12832371,
                    //                 "trade_id": 12923212,
                    //                 "currency": "BTC",
                    //                 "transfer_detail": null
                    //             }
                    //         ],
                    //         "meta": {
                    //             "total_count": 1221,
                    //             "first": { "page": 1, "href": "https://api.therocktrading.com/v1/transactions?page=1" },
                    //             "previous": null,
                    //             "current": { "page": 1, "href": "https://api.therocktrading.com/v1/transactions?page=1" },
                    //             "next": { "page": 2, "href": "https://api.therocktrading.com/v1/transactions?page=2" },
                    //             "last": { "page": 1221, "href": "https://api.therocktrading.com/v1/transactions?page=1221" }
                    //         }
                    //     }
                    //
                    const transactions = this.safeValue(response, 'transactions', []);
                    const transactionTypes = [
                        'withdraw',
                        'atm_payment'
                    ];
                    const depositsAndWithdrawals = this.filterByArray(transactions, 'type', transactionTypes, false);
                    return this.parseTransactions(depositsAndWithdrawals, currency, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'active': 'open',
                        'executed': 'closed',
                        'deleted': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "id": 4325578,
                    //         "fund_id":"BTCEUR",
                    //         "side":"buy",
                    //         "type":"limit",
                    //         "status":"executed",
                    //         "price":0.0102,
                    //         "amount": 50.0,
                    //         "amount_unfilled": 0.0,
                    //         "conditional_type": null,
                    //         "conditional_price": null,
                    //         "date":"2015-06-03T00:49:48.000Z",
                    //         "close_on": nil,
                    //         "leverage": 1.0,
                    //         "position_id": null,
                    //         "trades": [
                    //             {
                    //                 "id":237338,
                    //                 "fund_id":"BTCEUR",
                    //                 "amount":50,
                    //                 "price":0.0102,
                    //                 "side":"buy",
                    //                 "dark":false,
                    //                 "date":"2015-06-03T00:49:49.000Z"
                    //             }
                    //         ]
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const marketId = this.safeString(order, 'fund_id');
                    const symbol = this.safeSymbol(marketId, market);
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const timestamp = this.parse8601(this.safeString(order, 'date'));
                    const type = this.safeString(order, 'type');
                    const side = this.safeString(order, 'side');
                    const amount = this.safeNumber(order, 'amount');
                    const remaining = this.safeNumber(order, 'amount_unfilled');
                    let filled = undefined;
                    if (amount !== undefined) {
                        if (remaining !== undefined) filled = amount - remaining;
                    }
                    const price = this.safeNumber(order, 'price');
                    let trades = this.safeValue(order, 'trades');
                    let cost = undefined;
                    let average = undefined;
                    let lastTradeTimestamp = undefined;
                    if (trades !== undefined) {
                        const numTrades = trades.length;
                        if (numTrades > 0) {
                            trades = this.parseTrades(trades, market, undefined, undefined, {
                                'orderId': id
                            });
                            // todo: determine the cost and the average price from trades
                            cost = 0;
                            filled = 0;
                            for(let i = 0; i < numTrades; i++){
                                const trade = trades[i];
                                cost = this.sum(cost, trade['cost']);
                                filled = this.sum(filled, trade['amount']);
                            }
                            if (filled > 0) average = cost / filled;
                            lastTradeTimestamp = trades[numTrades - 1]['timestamp'];
                        } else cost = 0;
                    }
                    const stopPrice = this.safeNumber(order, 'conditional_price');
                    return {
                        'id': id,
                        'clientOrderId': undefined,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'average': average,
                        'remaining': remaining,
                        'fee': undefined,
                        'trades': trades
                    };
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'active'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    const request = {
                        'status': 'executed'
                    };
                    return await this.fetchOrders(symbol, since, limit, this.extend(request, params));
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'fund_id': market['id']
                    };
                    if (since !== undefined) request['after'] = this.iso8601(since);
                    const response = await this.privateGetFundsFundIdOrders(this.extend(request, params));
                    //
                    //     {
                    //         orders: [
                    //             {
                    //                 id: 299333648,
                    //                 fund_id: 'BTCEUR',
                    //                 side: 'sell',
                    //                 type: 'limit',
                    //                 status: 'executed',
                    //                 price: 5821,
                    //                 amount: 0.1,
                    //                 amount_unfilled: 0,
                    //                 conditional_type: null,
                    //                 conditional_price: null,
                    //                 date: '2018-06-18T17:38:16.129Z',
                    //                 close_on: null,
                    //                 dark: false,
                    //                 leverage: 1,
                    //                 position_id: 0
                    //             }
                    //         ]
                    //     }
                    //
                    const orders = this.safeValue(response, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': id,
                        'fund_id': market['id']
                    };
                    const response = await this.privateGetFundsFundIdOrdersId(this.extend(request, params));
                    //
                    //     {
                    //         "id": 4325578,
                    //         "fund_id":"BTCEUR",
                    //         "side":"buy",
                    //         "type":"limit",
                    //         "status":"executed",
                    //         "price":0.0102,
                    //         "amount": 50.0,
                    //         "amount_unfilled": 0.0,
                    //         "conditional_type": null,
                    //         "conditional_price": null,
                    //         "date":"2015-06-03T00:49:48.000Z",
                    //         "close_on": null,
                    //         "leverage": 1.0,
                    //         "position_id": null,
                    //         "trades": [
                    //             {
                    //                 "id":237338,
                    //                 "fund_id":"BTCEUR",
                    //                 "amount":50,
                    //                 "price":0.0102,
                    //                 "side":"buy",
                    //                 "dark":false,
                    //                 "date":"2015-06-03T00:49:49.000Z"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    if (type === 'market') price = 0;
                    const request = {
                        'fund_id': this.marketId(symbol),
                        'side': side,
                        'amount': amount,
                        'price': price
                    };
                    const response = await this.privatePostFundsFundIdOrders(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id,
                        'fund_id': this.marketId(symbol)
                    };
                    const response = await this.privateDeleteFundsFundIdOrdersId(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': market['id']
                    };
                    if (limit !== undefined) request['per_page'] = limit; // default 25 max 200
                    if (since !== undefined) request['after'] = this.iso8601(since);
                    const response = await this.privateGetFundsIdTrades(this.extend(request, params));
                    //
                    //     {
                    //         "trades": [
                    //             {
                    //                 "id":237338,
                    //                 "fund_id":"BTCEUR",
                    //                 "amount":0.348,
                    //                 "price":348.0,
                    //                 "side":"sell",
                    //                 "dark": false,
                    //                 "order_id":14920648,
                    //                 "date":"2015-06-03T00:49:49.000Z",
                    //                 "transactions": [
                    //                     { "id": 2770768, "date": "2015-06-03T00:49:49.000Z", "type": "sold_currency_to_fund", "price": 121.1, "currency": "EUR" },
                    //                     { "id": 2770769, "date": "2015-06-03T00:49:49.000Z", "type": "released_currency_to_fund", "price": 0.348, "currency": "BTC" },
                    //                     { "id": 2770772, "date": "2015-06-03T00:49:49.000Z", "type": "paid_commission", "price": 0.06, "currency": "EUR", "trade_id": 440492 },
                    //                 ]
                    //             }
                    //         ],
                    //         "meta": {
                    //             "total_count": 31,
                    //             "first": { "href": "https://api.therocktrading.com/v1/funds/BTCXRP/trades?page=1" },
                    //             "previous": null,
                    //             "current": { "href": "https://api.therocktrading.com/v1/funds/BTCXRP/trades?page=1" },
                    //             "next": { "href": "https://api.therocktrading.com/v1/funds/BTCXRP/trades?page=2" },
                    //             "last":{ "href":"https://api.therocktrading.com/v1/funds/BTCXRP/trades?page=2" }
                    //         }
                    //     }
                    //
                    const trades = this.safeValue(response, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': market['id']
                    };
                    if (limit !== undefined) request['per_page'] = limit; // default 25 max 200
                    if (since !== undefined) request['after'] = this.iso8601(since);
                    const response = await this.publicGetFundsIdTrades(this.extend(request, params));
                    //
                    //     {
                    //         trades: [
                    //             {
                    //                 id:  4493548,
                    //                 fund_id: "ETHBTC",
                    //                 amount:  0.203,
                    //                 price:  0.02783576,
                    //                 side: "buy",
                    //                 dark:  false,
                    //                 date: "2018-11-30T08:19:18.236Z"
                    //             },
                    //             {
                    //                 id:  4492926,
                    //                 fund_id: "ETHBTC",
                    //                 amount:  0.04,
                    //                 price:  0.02767034,
                    //                 side: "buy",
                    //                 dark:  false,
                    //                 date: "2018-11-30T07:03:03.897Z"
                    //             }
                    //         ],
                    //         meta: {
                    //             total_count: null,
                    //             first: { page: 1, href: "https://api.therocktrading.com/v1/funds/ETHBTC/trades?page=1" },
                    //             previous: null,
                    //             current: { page:  1, href: "https://api.therocktrading.com/v1/funds/ETHBTC/trades?page=1" },
                    //             next: { page:  2, href: "https://api.therocktrading.com/v1/funds/ETHBTC/trades?page=2" },
                    //             last: null
                    //         }
                    //     }
                    //
                    return this.parseTrades(response['trades'], market, since, limit);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    let request = {
                        'id': market['id']
                    };
                    const response = await this.publicGetFundsId(this.extend(request, params));
                    //
                    //     {
                    //         id: 'ETHBTC',
                    //         description: 'Trade Ether with Bitcoin',
                    //         type: 'currency',
                    //         base_currency: 'BTC',
                    //         trade_currency: 'ETH',
                    //         buy_fee: '0.2',
                    //         sell_fee: '0.2',
                    //         minimum_price_offer: '0.00000001',
                    //         minimum_quantity_offer: '0.005',
                    //         base_currency_decimals: '8',
                    //         trade_currency_decimals: '3',
                    //         leverages: []
                    //     }
                    //
                    request = {
                        'id': market['quoteId']
                    };
                    const discount = await this.privateGetDiscountsId(this.extend(request, params));
                    //
                    //     {
                    //         "currency":"BTC",
                    //         "discount":50.0,
                    //         "details": {
                    //             "personal_discount": 50.0,
                    //             "commissions_related_discount": 0.0
                    //         }
                    //     }
                    //
                    return this.parseTradingFee(response, discount, market);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetFunds(params);
                    //
                    //     {
                    //         funds: [
                    //             {
                    //                 id: 'BTCEUR',
                    //                 description: 'Trade Bitcoin with Euro',
                    //                 type: 'currency',
                    //                 base_currency: 'EUR',
                    //                 trade_currency: 'BTC',
                    //                 buy_fee: '0.2',
                    //                 sell_fee: '0.2',
                    //                 minimum_price_offer: '0.01',
                    //                 minimum_quantity_offer: '0.0005',
                    //                 base_currency_decimals: '2',
                    //                 trade_currency_decimals: '4',
                    //                 leverages: []
                    //             },
                    //         ]
                    //     }
                    //
                    const discountsResponse = await this.privateGetDiscounts(params);
                    //
                    //     {
                    //         "discounts": [
                    //             {
                    //                 "currency":"BTC",
                    //                 "discount":50.0,
                    //                 "details": {
                    //                     "personal_discount": 50.0,
                    //                     "commissions_related_discount": 0.0
                    //                 }
                    //             }
                    //         ]
                    //     }
                    //
                    const funds = this.safeValue(response, 'funds', []);
                    const discounts = this.safeValue(discountsResponse, 'discounts', []);
                    const result = {};
                    for(let i = 0; i < funds.length; i++){
                        const fund = funds[i];
                        const marketId = this.safeString(fund, 'id');
                        const market = this.safeMarket(marketId);
                        const quoteId = this.safeValue(market, 'quoteId');
                        const discount = this.filterBy(discounts, 'currency', quoteId);
                        const fee = this.parseTradingFee(fund, discount, market);
                        const symbol = fee['symbol'];
                        result[symbol] = fee;
                    }
                    return result;
                }
                parseTradingFee(fee, discount, market) {
                    const marketId = this.safeString(fee, 'id');
                    const takerString = this.safeString(fee, 'buy_fee');
                    const makerString = this.safeString(fee, 'sell_fee');
                    // TotalFee = (100 - discount) * fee / 10000
                    const discountString = this.safeString(discount, 'discount', '0');
                    const feePercentage = Precise.stringSub('100', discountString);
                    const taker = this.parseNumber(Precise.stringDiv(Precise.stringMul(takerString, feePercentage), '10000'));
                    const maker = this.parseNumber(Precise.stringDiv(Precise.stringMul(makerString, feePercentage), '10000'));
                    return {
                        'info': fee,
                        'symbol': this.safeSymbol(marketId, market),
                        'maker': maker,
                        'taker': taker,
                        'percentage': true,
                        'tierBased': true
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    headers = headers === undefined ? {} : headers;
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        if (Object.keys(query).length) {
                            if (method === 'POST') {
                                body = this.json(query);
                                headers['Content-Type'] = 'application/json';
                            } else {
                                const queryString = this.rawencode(query);
                                if (queryString.length) url += '?' + queryString;
                            }
                        }
                        const nonce = this.nonce().toString();
                        const auth = nonce + url;
                        headers['X-TRT-KEY'] = this.apiKey;
                        headers['X-TRT-NONCE'] = nonce;
                        headers['X-TRT-SIGN'] = this.hmac(this.encode(auth), this.encode(this.secret), 'sha512');
                    } else if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.rawencode(query);
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //     {
                    //         "errors": [
                    //             { "message": ":currency is not a valid value for param currency","code": "11","meta": { "key":"currency","value":":currency"} },
                    //             { "message": "Address allocation limit reached for currency :currency.","code": "13" },
                    //             { "message": "Request already running", "code": "50"},
                    //             { "message": "cannot specify multiple address types", "code": "12" },
                    //             { "message": ":address_type is invalid", "code": "12" }
                    //         ]
                    //     }
                    //
                    const errors = this.safeValue(response, 'errors', []);
                    const numErrors = errors.length;
                    if (numErrors > 0) {
                        const feedback = this.id + ' ' + body;
                        // here we throw the first error we can identify
                        for(let i = 0; i < numErrors; i++){
                            const error = errors[i];
                            const message = this.safeString(error, 'message');
                            this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        }
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    162: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, ArgumentsRequired: ArgumentsRequired1 } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class tidebit extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'tidebit',
                        'name': 'TideBit',
                        'countries': [
                            'HK'
                        ],
                        'rateLimit': 1000,
                        'version': 'v2',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchDepositAddress': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchOHLCV': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1',
                            '5m': '5',
                            '15m': '15',
                            '30m': '30',
                            '1h': '60',
                            '2h': '120',
                            '4h': '240',
                            '12h': '720',
                            '1d': '1440',
                            '3d': '4320',
                            '1w': '10080'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87460811-1e690280-c616-11ea-8652-69f187305add.jpg',
                            'api': 'https://www.tidebit.com',
                            'www': 'https://www.tidebit.com',
                            'doc': [
                                'https://www.tidebit.com/documents/api/guide',
                                'https://www.tidebit.com/swagger/#/default'
                            ],
                            'referral': 'http://bit.ly/2IX0LrM'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'markets',
                                    'tickers',
                                    'tickers/{market}',
                                    'timestamp',
                                    'trades',
                                    'trades/{market}',
                                    'order_book',
                                    'order',
                                    'k_with_pending_trades',
                                    'k',
                                    'depth'
                                ],
                                'post': []
                            },
                            'private': {
                                'get': [
                                    'addresses/{address}',
                                    'deposits/history',
                                    'deposits/get_deposit',
                                    'deposits/deposit_address',
                                    'historys/orders',
                                    'historys/vouchers',
                                    'historys/accounts',
                                    'historys/snapshots',
                                    'linkage/get_status',
                                    'members/me',
                                    'order',
                                    'orders',
                                    'partners/orders/{id}/trades',
                                    'referral_commissions/get_undeposited',
                                    'referral_commissions/get_graph_data',
                                    'trades/my',
                                    'withdraws/bind_account_list',
                                    'withdraws/get_withdraw_account',
                                    'withdraws/fetch_bind_info'
                                ],
                                'post': [
                                    'deposits/deposit_cash',
                                    'favorite_markets/update',
                                    'order/delete',
                                    'orders',
                                    'orders/multi',
                                    'orders/clear',
                                    'referral_commissions/deposit',
                                    'withdraws/apply',
                                    'withdraws/bind_bank',
                                    'withdraws/bind_address'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.003'),
                                'taker': this.parseNumber('0.003')
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': true,
                                'withdraw': {}
                            }
                        },
                        'exceptions': {
                            '2002': InsufficientFunds,
                            '2003': OrderNotFound
                        }
                    });
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateGetDepositAddress(this.extend(request, params));
                    if ('success' in response) {
                        if (response['success']) {
                            const address = this.safeString(response, 'address');
                            const tag = this.safeString(response, 'addressTag');
                            return {
                                'currency': code,
                                'address': this.checkAddress(address),
                                'tag': tag,
                                'info': response
                            };
                        }
                    }
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetMarkets(params);
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'id');
                        const symbol = this.safeString(market, 'name');
                        const [baseId, quoteId] = symbol.split('/');
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': this.safeCurrencyCode(baseId),
                            'quote': this.safeCurrencyCode(quoteId),
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': this.precision,
                            'limits': this.extend({
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            }, this.limits),
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'accounts');
                    const result = {
                        'info': balances
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'balance');
                        account['used'] = this.safeString(balance, 'locked');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetMembersMe(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default = 300
                    request['market'] = market['id'];
                    const response = await this.publicGetDepth(this.extend(request, params));
                    const timestamp = this.safeTimestamp(response, 'timestamp');
                    return this.parseOrderBook(response, symbol, timestamp);
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "at":1398410899,
                    //         "ticker": {
                    //             "buy": "3000.0",
                    //             "sell":"3100.0",
                    //             "low":"3000.0",
                    //             "high":"3000.0",
                    //             "last":"3000.0",
                    //             "vol":"0.11"
                    //         }
                    //     }
                    //
                    const timestamp = this.safeTimestamp(ticker, 'at');
                    ticker = this.safeValue(ticker, 'ticker', {});
                    market = this.safeMarket(undefined, market);
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': market['symbol'],
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'ask': this.safeString(ticker, 'sell'),
                        'bidVolume': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'change': undefined,
                        'percentage': undefined,
                        'previousClose': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'vol'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const tickers = await this.publicGetTickers(params);
                    const ids = Object.keys(tickers);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const market = this.safeMarket(id);
                        const symbol = market['symbol'];
                        const ticker = tickers[id];
                        result[symbol] = this.parseTicker(ticker, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.publicGetTickersMarket(this.extend(request, params));
                    //
                    //     {
                    //         "at":1398410899,
                    //         "ticker": {
                    //             "buy": "3000.0",
                    //             "sell":"3100.0",
                    //             "low":"3000.0",
                    //             "high":"3000.0",
                    //             "last":"3000.0",
                    //             "vol":"0.11"
                    //         }
                    //     }
                    //
                    return this.parseTicker(response, market);
                }
                parseTrade(trade, market) {
                    const timestamp = this.parse8601(this.safeString(trade, 'created_at'));
                    const id = this.safeString(trade, 'id');
                    const price = this.safeString(trade, 'price');
                    const amount = this.safeString(trade, 'volume');
                    market = this.safeMarket(undefined, market);
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': undefined,
                        'side': undefined,
                        'order': undefined,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.publicGetTrades(this.extend(request, params));
                    return this.parseTrades(response, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1498530360,
                    //         2700.0,
                    //         2700.0,
                    //         2700.0,
                    //         2700.0,
                    //         0.01
                    //     ]
                    //
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (limit === undefined) limit = 30; // default is 30
                    const request = {
                        'market': market['id'],
                        'period': this.timeframes[timeframe],
                        'limit': limit
                    };
                    if (since !== undefined) request['timestamp'] = parseInt(since / 1000);
                    else request['timestamp'] = 1800000;
                    const response = await this.publicGetK(this.extend(request, params));
                    //
                    //     [
                    //         [1498530360,2700.0,2700.0,2700.0,2700.0,0.01],
                    //         [1498530420,2700.0,2700.0,2700.0,2700.0,0],
                    //         [1498530480,2700.0,2700.0,2700.0,2700.0,0],
                    //     ]
                    //
                    if (response === 'null') return [];
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'done': 'closed',
                        'wait': 'open',
                        'cancel': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "id": 7,                              // 唯一的 Order ID
                    //         "side": "sell",                       // Buy/Sell 代表买单/卖单
                    //         "price": "3100.0",                    // 出价
                    //         "avg_price": "3101.2",                // 平均成交价
                    //         "state": "wait",                      // 订单的当前状态 [wait,done,cancel]
                    //                                               //   wait   表明订单正在市场上挂单
                    //                                               //          是一个active order
                    //                                               //          此时订单可能部分成交或者尚未成交
                    //                                               //   done   代表订单已经完全成交
                    //                                               //   cancel 代表订单已经被撤销
                    //         "market": "btccny",                   // 订单参与的交易市场
                    //         "created_at": "2014-04-18T02:02:33Z", // 下单时间 ISO8601格式
                    //         "volume": "100.0",                    // 购买/卖出数量
                    //         "remaining_volume": "89.8",           // 还未成交的数量 remaining_volume 总是小于等于 volume
                    //                                               //   在订单完全成交时变成 0
                    //         "executed_volume": "10.2",            // 已成交的数量
                    //                                               //   volume = remaining_volume + executed_volume
                    //         "trades_count": 1,                    // 订单的成交数 整数值
                    //                                               //   未成交的订单为 0 有一笔成交的订单为 1
                    //                                               //   通过该字段可以判断订单是否处于部分成交状态
                    //         "trades": [                           // 订单的详细成交记录 参见Trade
                    //                                               //   注意: 只有某些返回详细订单数据的 API 才会包含 Trade 数据
                    //             {
                    //                 "id": 2,
                    //                 "price": "3100.0",
                    //                 "volume": "10.2",
                    //                 "market": "btccny",
                    //                 "created_at": "2014-04-18T02:04:49Z",
                    //                 "side": "sell"
                    //             }
                    //         ]
                    //     }
                    //
                    const marketId = this.safeString(order, 'market');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const status = this.parseOrderStatus(this.safeString(order, 'state'));
                    const id = this.safeString(order, 'id');
                    const type = this.safeString(order, 'ord_type');
                    const side = this.safeString(order, 'side');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'volume');
                    const filled = this.safeString(order, 'executed_volume');
                    const remaining = this.safeString(order, 'remaining_volume');
                    const average = this.safeString(order, 'avg_price');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'cost': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'info': order,
                        'average': average
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'market': this.marketId(symbol),
                        'side': side,
                        'volume': amount.toString(),
                        'ord_type': type
                    };
                    if (type === 'limit') request['price'] = price.toString();
                    const response = await this.privatePostOrders(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': id
                    };
                    const result = await this.privatePostOrderDelete(this.extend(request, params));
                    const order = this.parseOrder(result);
                    const status = this.safeString(order, 'status');
                    if (status === 'closed' || status === 'canceled') throw new OrderNotFound(this.id + ' ' + this.json(order));
                    return order;
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const id = this.safeString(params, 'id');
                    if (id === undefined) throw new ArgumentsRequired1(this.id + ' withdraw() requires an extra `id` param (withdraw account id according to withdraws/bind_account_list endpoint');
                    const request = {
                        'id': id,
                        'currency_type': 'coin',
                        'currency': currency['id'],
                        'body': amount
                    };
                    if (tag !== undefined) request['memo'] = tag;
                    const result = await this.privatePostWithdrawsApply(this.extend(request, params));
                    return this.parseTransaction(result, currency);
                }
                parseTransaction(transaction, currency) {
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'id': undefined,
                        'txid': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': undefined,
                        'info': transaction
                    };
                }
                nonce() {
                    return this.milliseconds();
                }
                encodeParams(params) {
                    return this.urlencode(this.keysort(params));
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const request = "/api/" + this.version + '/' + this.implodeParams(path, params) + '.json';
                    const query = this.omit(params, this.extractParams(path));
                    let url = this.urls['api'] + request;
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const sortedByKey = this.keysort(this.extend({
                            'access_key': this.apiKey,
                            'tonce': nonce
                        }, params));
                        const query = this.urlencode(sortedByKey);
                        const payload = method + '|' + request + '|' + query;
                        const signature = this.hmac(this.encode(payload), this.encode(this.secret));
                        const suffix = query + '&signature=' + signature;
                        if (method === 'GET') url += '?' + suffix;
                        else {
                            body = suffix;
                            headers = {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            };
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (code === 400 || response === undefined) {
                        const feedback = this.id + ' ' + body;
                        if (response === undefined) throw new ExchangeError1(feedback);
                        const error = this.safeValue(response, 'error', {});
                        const errorCode = this.safeString(error, 'code');
                        this.throwExactlyMatchedException(this.exceptions, errorCode, feedback);
                    // fallback to default error handler
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    163: [
        function(require1, module, exports) {
            'use strict';
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, ExchangeNotAvailable: ExchangeNotAvailable, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, DDoSProtection: DDoSProtection, InvalidOrder: InvalidOrder, AuthenticationError: AuthenticationError, PermissionDenied: PermissionDenied } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            module.exports = class tidex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'tidex',
                        'name': 'Tidex',
                        'countries': [
                            'UK'
                        ],
                        'rateLimit': 2000,
                        'version': '3',
                        'userAgent': this.userAgents['chrome'],
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchCurrencies': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/30781780-03149dc4-a12e-11e7-82bb-313b269d24d4.jpg',
                            'api': {
                                'web': 'https://gate.tidex.com/api',
                                'public': 'https://api.tidex.com/api/3',
                                'private': 'https://api.tidex.com/tapi'
                            },
                            'www': 'https://tidex.com',
                            'doc': 'https://tidex.com/exchange/public-api',
                            'referral': 'https://tidex.com/exchange/?ref=57f5638d9cd7',
                            'fees': [
                                'https://tidex.com/exchange/assets-spec',
                                'https://tidex.com/exchange/pairs-spec'
                            ]
                        },
                        'api': {
                            'web': {
                                'get': [
                                    'currency',
                                    'pairs',
                                    'tickers',
                                    'orders',
                                    'ordershistory',
                                    'trade-data',
                                    'trade-data/{id}'
                                ]
                            },
                            'public': {
                                'get': [
                                    'info',
                                    'ticker/{pair}',
                                    'depth/{pair}',
                                    'trades/{pair}'
                                ]
                            },
                            'private': {
                                'post': [
                                    'getInfoExt',
                                    'getInfo',
                                    'Trade',
                                    'ActiveOrders',
                                    'OrderInfo',
                                    'CancelOrder',
                                    'TradeHistory',
                                    'getDepositAddress',
                                    'createWithdraw',
                                    'getWithdraw'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'feeSide': 'get',
                                'tierBased': false,
                                'percentage': true,
                                'taker': this.parseNumber('0.001'),
                                'maker': this.parseNumber('0.001')
                            }
                        },
                        'commonCurrencies': {
                            'DSH': 'DASH',
                            'EMGO': 'MGO',
                            'MGO': 'WMGO'
                        },
                        'exceptions': {
                            'exact': {
                                '803': InvalidOrder,
                                '804': InvalidOrder,
                                '805': InvalidOrder,
                                '806': InvalidOrder,
                                '807': InvalidOrder,
                                '831': InsufficientFunds,
                                '832': InsufficientFunds,
                                '833': OrderNotFound
                            },
                            'broad': {
                                'Invalid pair name': ExchangeError1,
                                'invalid api key': AuthenticationError,
                                'invalid sign': AuthenticationError,
                                'api key dont have trade permission': AuthenticationError,
                                'invalid parameter': InvalidOrder,
                                'invalid order': InvalidOrder,
                                'Requests too often': DDoSProtection,
                                'not available': ExchangeNotAvailable,
                                'data unavailable': ExchangeNotAvailable,
                                'external service unavailable': ExchangeNotAvailable,
                                'IP restricted': PermissionDenied
                            }
                        },
                        'options': {
                            'fetchTickersMaxLength': 2048
                        },
                        'orders': {}
                    });
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.webGetCurrency(params);
                    //
                    //     [
                    //         {
                    //             "id":2,
                    //             "symbol":"BTC",
                    //             "type":2,
                    //             "name":"Bitcoin",
                    //             "amountPoint":8,
                    //             "depositEnable":true,
                    //             "depositMinAmount":0.0005,
                    //             "withdrawEnable":true,
                    //             "withdrawFee":0.0004,
                    //             "withdrawMinAmount":0.0005,
                    //             "settings":{
                    //                 "Blockchain":"https://blockchair.com/bitcoin/",
                    //                 "TxUrl":"https://blockchair.com/bitcoin/transaction/{0}",
                    //                 "AddrUrl":"https://blockchair.com/bitcoin/address/{0}",
                    //                 "ConfirmationCount":3,
                    //                 "NeedMemo":false
                    //             },
                    //             "visible":true,
                    //             "isDelisted":false
                    //         }
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        const id = this.safeString(currency, 'symbol');
                        const precision = this.safeInteger(currency, 'amountPoint');
                        const code = this.safeCurrencyCode(id);
                        const visible = this.safeValue(currency, 'visible');
                        let active = visible === true;
                        const withdrawEnable = this.safeValue(currency, 'withdrawEnable', true);
                        const depositEnable = this.safeValue(currency, 'depositEnable', true);
                        if (!withdrawEnable || !depositEnable) active = false;
                        const name = this.safeString(currency, 'name');
                        const fee = this.safeNumber(currency, 'withdrawFee');
                        result[code] = {
                            'id': id,
                            'code': code,
                            'name': name,
                            'active': active,
                            'deposit': depositEnable,
                            'withdraw': withdrawEnable,
                            'precision': precision,
                            'funding': {
                                'withdraw': {
                                    'active': withdrawEnable,
                                    'fee': fee
                                },
                                'deposit': {
                                    'active': depositEnable,
                                    'fee': this.parseNumber('0')
                                }
                            },
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'withdrawMinAmount'),
                                    'max': undefined
                                },
                                'deposit': {
                                    'min': this.safeNumber(currency, 'depositMinAmount'),
                                    'max': undefined
                                }
                            },
                            'info': currency
                        };
                    }
                    return result;
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetInfo(params);
                    //
                    //     {
                    //         "server_time":1615861869,
                    //         "pairs":{
                    //             "ltc_btc":{
                    //                 "decimal_places":8,
                    //                 "min_price":0.00000001,
                    //                 "max_price":3.0,
                    //                 "min_amount":0.001,
                    //                 "max_amount":1000000.0,
                    //                 "min_total":0.0001,
                    //                 "hidden":0,
                    //                 "fee":0.1,
                    //             },
                    //         },
                    //     }
                    //
                    const markets = response['pairs'];
                    const keys = Object.keys(markets);
                    const result = [];
                    for(let i = 0; i < keys.length; i++){
                        const id = keys[i];
                        const market = markets[id];
                        const [baseId, quoteId] = id.split('_');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const hidden = this.safeInteger(market, 'hidden');
                        let takerFeeString = this.safeString(market, 'fee');
                        takerFeeString = Precise.stringDiv(takerFeeString, '100');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': hidden === 0,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.parseNumber(takerFeeString),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'decimal_places'),
                                'price': this.safeInteger(market, 'decimal_places')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min_amount'),
                                    'max': this.safeNumber(market, 'max_amount')
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'min_price'),
                                    'max': this.safeNumber(market, 'max_price')
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_total'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'return');
                    const timestamp = this.safeTimestamp(balances, 'server_time');
                    const result = {
                        'info': response,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    };
                    const funds = this.safeValue(balances, 'funds', {});
                    const currencyIds = Object.keys(funds);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const balance = this.safeValue(funds, currencyId, {});
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'value');
                        account['used'] = this.safeString(balance, 'inOrders');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGetInfoExt(params);
                    //
                    //     {
                    //         "success":1,
                    //         "return":{
                    //             "funds":{
                    //                 "btc":{"value":0.0000499885629956,"inOrders":0.0},
                    //                 "eth":{"value":0.000000030741708,"inOrders":0.0},
                    //                 "tdx":{"value":0.0000000155385356,"inOrders":0.0}
                    //             },
                    //             "rights":{
                    //                 "info":true,
                    //                 "trade":true,
                    //                 "withdraw":false
                    //             },
                    //             "transaction_count":0,
                    //             "open_orders":0,
                    //             "server_time":1619436907
                    //         },
                    //         "stat":{
                    //             "isSuccess":true,
                    //             "serverTime":"00:00:00.0001157",
                    //             "time":"00:00:00.0101364",
                    //             "errors":null
                    //         }
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default = 150, max = 2000
                    const response = await this.publicGetDepthPair(this.extend(request, params));
                    const market_id_in_reponse = market['id'] in response;
                    if (!market_id_in_reponse) throw new ExchangeError1(this.id + ' ' + market['symbol'] + ' order book is empty or not available');
                    const orderbook = response[market['id']];
                    return this.parseOrderBook(orderbook, symbol);
                }
                async fetchOrderBooks(symbols, limit, params = {}) {
                    await this.loadMarkets();
                    let ids = undefined;
                    if (symbols === undefined) {
                        ids = this.ids.join('-');
                        // max URL length is 2083 symbols, including http schema, hostname, tld, etc...
                        if (ids.length > 2048) {
                            const numIds = this.ids.length;
                            throw new ExchangeError1(this.id + ' fetchOrderBooks() has ' + numIds.toString() + ' symbols exceeding max URL length, you are required to specify a list of symbols in the first argument to fetchOrderBooks');
                        }
                    } else {
                        ids = this.marketIds(symbols);
                        ids = ids.join('-');
                    }
                    const request = {
                        'pair': ids
                    };
                    if (limit !== undefined) request['limit'] = limit; // default = 150, max = 2000
                    const response = await this.publicGetDepthPair(this.extend(request, params));
                    const result = {};
                    ids = Object.keys(response);
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const symbol = this.safeSymbol(id);
                        result[symbol] = this.parseOrderBook(response[id]);
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         high: 0.03497582,
                    //         low: 0.03248474,
                    //         avg: 0.03373028,
                    //         vol: 120.11485715062999,
                    //         vol_cur: 3572.24914074,
                    //         last: 0.0337611,
                    //         buy: 0.0337442,
                    //         sell: 0.03377798,
                    //         updated: 1537522009
                    //     }
                    //
                    const timestamp = this.safeTimestamp(ticker, 'updated');
                    market = this.safeMarket(undefined, market);
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': market['symbol'],
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': this.safeString(ticker, 'avg'),
                        'baseVolume': this.safeString(ticker, 'vol_cur'),
                        'quoteVolume': this.safeString(ticker, 'vol'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    let ids = this.ids;
                    if (symbols === undefined) {
                        const numIds = ids.length;
                        ids = ids.join('-');
                        // max URL length is 2048 symbols, including http schema, hostname, tld, etc...
                        if (ids.length > this.options['fetchTickersMaxLength']) {
                            const maxLength = this.safeInteger(this.options, 'fetchTickersMaxLength', 2048);
                            throw new ArgumentsRequired1(this.id + ' fetchTickers() has ' + numIds.toString() + ' markets exceeding max URL length for this endpoint (' + maxLength.toString() + ' characters), please, specify a list of symbols of interest in the first argument to fetchTickers');
                        }
                    } else {
                        ids = this.marketIds(symbols);
                        ids = ids.join('-');
                    }
                    const request = {
                        'pair': ids
                    };
                    const response = await this.publicGetTickerPair(this.extend(request, params));
                    const result = {};
                    const keys = Object.keys(response);
                    for(let i = 0; i < keys.length; i++){
                        const id = keys[i];
                        const market = this.safeMarket(id);
                        const symbol = market['symbol'];
                        result[symbol] = this.parseTicker(response[id], market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    const tickers = await this.fetchTickers([
                        symbol
                    ], params);
                    return tickers[symbol];
                }
                parseTrade(trade, market) {
                    const timestamp = this.safeTimestamp(trade, 'timestamp');
                    let side = this.safeString(trade, 'type');
                    if (side === 'ask') side = 'sell';
                    else if (side === 'bid') side = 'buy';
                    const priceString = this.safeString2(trade, 'rate', 'price');
                    const id = this.safeString2(trade, 'trade_id', 'tid');
                    const orderId = this.safeString(trade, 'order_id');
                    const marketId = this.safeString(trade, 'pair');
                    const symbol = this.safeSymbol(marketId, market);
                    const amountString = this.safeString(trade, 'amount');
                    const price = this.parseNumber(priceString);
                    const amount = this.parseNumber(amountString);
                    const cost = this.parseNumber(Precise.stringMul(priceString, amountString));
                    const type = 'limit'; // all trades are still limit trades
                    let takerOrMaker = undefined;
                    let fee = undefined;
                    const feeCost = this.safeNumber(trade, 'commission');
                    if (feeCost !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'commissionCurrency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrencyCode
                        };
                    }
                    const isYourOrder = this.safeValue(trade, 'is_your_order');
                    if (isYourOrder !== undefined) {
                        takerOrMaker = 'taker';
                        if (isYourOrder) takerOrMaker = 'maker';
                        if (fee === undefined) fee = this.calculateFee(symbol, type, side, amount, price, takerOrMaker);
                    }
                    return {
                        'id': id,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'takerOrMaker': takerOrMaker,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': fee,
                        'info': trade
                    };
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetTradesPair(this.extend(request, params));
                    if (Array.isArray(response)) {
                        const numElements = response.length;
                        if (numElements === 0) return [];
                    }
                    return this.parseTrades(response[market['id']], market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (type === 'market') throw new ExchangeError1(this.id + ' createOrder() allows limit orders only');
                    const amountString = amount.toString();
                    const priceString = price.toString();
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'type': side,
                        'amount': this.amountToPrecision(symbol, amount),
                        'rate': this.priceToPrecision(symbol, price)
                    };
                    const response = await this.privatePostTrade(this.extend(request, params));
                    let id = undefined;
                    let status = 'open';
                    let filledString = '0.0';
                    let remainingString = amountString;
                    const returnResult = this.safeValue(response, 'return');
                    if (returnResult !== undefined) {
                        id = this.safeString(returnResult, 'order_id');
                        if (id === '0') {
                            id = this.safeString(returnResult, 'init_order_id');
                            status = 'closed';
                        }
                        filledString = this.safeString(returnResult, 'received', filledString);
                        remainingString = this.safeString(returnResult, 'remains', amountString);
                    }
                    const timestamp = this.milliseconds();
                    return this.safeOrder({
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'price': priceString,
                        'cost': undefined,
                        'amount': amountString,
                        'remaining': remainingString,
                        'filled': filledString,
                        'fee': undefined,
                        // 'trades': this.parseTrades (order['trades'], market),
                        'info': response,
                        'clientOrderId': undefined,
                        'average': undefined,
                        'trades': undefined
                    }, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': parseInt(id)
                    };
                    return await this.privatePostCancelOrder(this.extend(request, params));
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '0': 'open',
                        '1': 'closed',
                        '2': 'canceled',
                        '3': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    const id = this.safeString(order, 'id');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const timestamp = this.safeTimestamp(order, 'timestamp_created');
                    const marketId = this.safeString(order, 'pair');
                    const symbol = this.safeSymbol(marketId, market);
                    let remaining = undefined;
                    let amount = undefined;
                    const price = this.safeString(order, 'rate');
                    if ('start_amount' in order) {
                        amount = this.safeString(order, 'start_amount');
                        remaining = this.safeString(order, 'amount');
                    } else remaining = this.safeString(order, 'amount');
                    const fee = undefined;
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'type': 'limit',
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': this.safeString(order, 'type'),
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'amount': amount,
                        'remaining': remaining,
                        'filled': undefined,
                        'status': status,
                        'fee': fee,
                        'average': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': parseInt(id)
                    };
                    const response = await this.privatePostOrderInfo(this.extend(request, params));
                    id = id.toString();
                    const result = this.safeValue(response, 'return', {});
                    const order = this.safeValue(result, id);
                    return this.parseOrder(this.extend({
                        'id': id
                    }, order));
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['pair'] = market['id'];
                    }
                    const response = await this.privatePostActiveOrders(this.extend(request, params));
                    //
                    //     {
                    //         "success":1,
                    //         "return":{
                    //             "1255468911":{
                    //                 "status":0,
                    //                 "pair":"spike_usdt",
                    //                 "type":"sell",
                    //                 "amount":35028.44256388,
                    //                 "rate":0.00199989,
                    //                 "timestamp_created":1602684432
                    //             }
                    //         },
                    //         "stat":{
                    //             "isSuccess":true,
                    //             "serverTime":"00:00:00.0000826",
                    //             "time":"00:00:00.0091423",
                    //             "errors":null
                    //         }
                    //     }
                    //
                    // it can only return 'open' orders (i.e. no way to fetch 'closed' orders)
                    const orders = this.safeValue(response, 'return', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    // some derived classes use camelcase notation for request fields
                    const request = {
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['pair'] = market['id'];
                    }
                    if (limit !== undefined) request['count'] = parseInt(limit);
                    if (since !== undefined) request['since'] = parseInt(since / 1000);
                    const response = await this.privatePostTradeHistory(this.extend(request, params));
                    const trades = this.safeValue(response, 'return', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'asset': currency['id'],
                        'amount': parseFloat(amount),
                        'address': address
                    };
                    if (tag !== undefined) request['memo'] = tag;
                    const response = await this.privatePostCreateWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "success":1,
                    //         "return":{
                    //             "withdraw_id":1111,
                    //             "withdraw_info":{
                    //                 "id":1111,
                    //                 "asset_id":1,
                    //                 "asset":"BTC",
                    //                 "amount":0.0093,
                    //                 "fee":0.0007,
                    //                 "create_time":1575128018,
                    //                 "status":"Created",
                    //                 "data":{
                    //                     "address":"1KFHE7w8BhaENAswwryaoccDb6qcT6DbYY",
                    //                     "memo":"memo",
                    //                     "tx":null,
                    //                     "error":null
                    //                 },
                    //                 "in_blockchain":false
                    //             }
                    //         }
                    //     }
                    //
                    const result = this.safeValue(response, 'return', {});
                    const withdrawInfo = this.safeValue(result, 'withdraw_info', {});
                    return this.parseTransaction(withdrawInfo, currency);
                }
                parseTransaction(transaction, currency) {
                    //
                    //     {
                    //         "id":1111,
                    //         "asset_id":1,
                    //         "asset":"BTC",
                    //         "amount":0.0093,
                    //         "fee":0.0007,
                    //         "create_time":1575128018,
                    //         "status":"Created",
                    //         "data":{
                    //             "address":"1KFHE7w8BhaENAswwryaoccDb6qcT6DbYY",
                    //             "memo":"memo",
                    //             "tx":null,
                    //             "error":null
                    //         },
                    //         "in_blockchain":false
                    //     }
                    //
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'id': this.safeString(transaction, 'id'),
                        'txid': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': undefined,
                        'info': transaction
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api];
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce();
                        body = this.urlencode(this.extend({
                            'nonce': nonce,
                            'method': path
                        }, query));
                        const signature = this.hmac(this.encode(body), this.encode(this.secret), 'sha512');
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Key': this.apiKey,
                            'Sign': signature
                        };
                    } else if (api === 'public') {
                        url += '/' + this.implodeParams(path, params);
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        url += '/' + this.implodeParams(path, params);
                        if (method === 'GET') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else if (Object.keys(query).length) {
                            body = this.json(query);
                            headers = {
                                'Content-Type': 'application/json'
                            };
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if ('success' in response) {
                        //
                        // 1 - The exchange only returns the integer 'success' key from their private API
                        //
                        //     { "success": 1, ... } httpCode === 200
                        //     { "success": 0, ... } httpCode === 200
                        //
                        // 2 - However, derived exchanges can return non-integers
                        //
                        //     It can be a numeric string
                        //     { "sucesss": "1", ... }
                        //     { "sucesss": "0", ... }, httpCode >= 200 (can be 403, 502, etc)
                        //
                        //     Or just a string
                        //     { "success": "true", ... }
                        //     { "success": "false", ... }, httpCode >= 200
                        //
                        //     Or a boolean
                        //     { "success": true, ... }
                        //     { "success": false, ... }, httpCode >= 200
                        //
                        // 3 - Oversimplified, Python PEP8 forbids comparison operator (===) of different types
                        //
                        // 4 - We do not want to copy-paste and duplicate the code of this handler to other exchanges derived from Liqui
                        //
                        // To cover points 1, 2, 3 and 4 combined this handler should work like this:
                        //
                        let success = this.safeValue(response, 'success', false);
                        if (typeof success === 'string') {
                            if (success === 'true' || success === '1') success = true;
                            else success = false;
                        }
                        if (!success) {
                            const code = this.safeString(response, 'code');
                            const message = this.safeString(response, 'error');
                            const feedback = this.id + ' ' + body;
                            this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                            this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                            throw new ExchangeError1(feedback); // unknown message
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    164: [
        function(require1, module, exports) {
            'use strict';
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, PermissionDenied: PermissionDenied, ExchangeNotAvailable: ExchangeNotAvailable, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, RateLimitExceeded: RateLimitExceeded, NotSupported: NotSupported, BadRequest: BadRequest, AuthenticationError: AuthenticationError } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            module.exports = class timex extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'timex',
                        'name': 'TimeX',
                        'countries': [
                            'AU'
                        ],
                        'version': 'v1',
                        'rateLimit': 1500,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'editOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false
                        },
                        'timeframes': {
                            '1m': 'I1',
                            '5m': 'I5',
                            '15m': 'I15',
                            '30m': 'I30',
                            '1h': 'H1',
                            '2h': 'H2',
                            '4h': 'H4',
                            '6h': 'H6',
                            '12h': 'H12',
                            '1d': 'D1',
                            '1w': 'W1'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/70423869-6839ab00-1a7f-11ea-8f94-13ae72c31115.jpg',
                            'api': 'https://plasma-relay-backend.timex.io',
                            'www': 'https://timex.io',
                            'doc': 'https://docs.timex.io',
                            'referral': 'https://timex.io/?refcode=1x27vNkTbP1uwkCck'
                        },
                        'api': {
                            'custody': {
                                'get': [
                                    'credentials',
                                    'credentials/h/{hash}',
                                    'credentials/k/{key}',
                                    'credentials/me/address',
                                    'deposit-addresses',
                                    'deposit-addresses/h/{hash}'
                                ]
                            },
                            'history': {
                                'get': [
                                    'orders',
                                    'orders/details',
                                    'orders/export/csv',
                                    'trades',
                                    'trades/export/csv'
                                ]
                            },
                            'currencies': {
                                'get': [
                                    'a/{address}',
                                    'i/{id}',
                                    's/{symbol}'
                                ],
                                'post': [
                                    'perform',
                                    'prepare',
                                    'remove/perform',
                                    's/{symbol}/remove/prepare',
                                    's/{symbol}/update/perform',
                                    's/{symbol}/update/prepare'
                                ]
                            },
                            'markets': {
                                'get': [
                                    'i/{id}',
                                    's/{symbol}'
                                ],
                                'post': [
                                    'perform',
                                    'prepare',
                                    'remove/perform',
                                    's/{symbol}/remove/prepare',
                                    's/{symbol}/update/perform',
                                    's/{symbol}/update/prepare'
                                ]
                            },
                            'public': {
                                'get': [
                                    'candles',
                                    'currencies',
                                    'markets',
                                    'orderbook',
                                    'orderbook/raw',
                                    'orderbook/v2',
                                    'tickers',
                                    'trades'
                                ]
                            },
                            'statistics': {
                                'get': [
                                    'address'
                                ]
                            },
                            'trading': {
                                'get': [
                                    'balances',
                                    'fees',
                                    'orders'
                                ],
                                'post': [
                                    'orders',
                                    'orders/json'
                                ],
                                'put': [
                                    'orders',
                                    'orders/json'
                                ],
                                'delete': [
                                    'orders',
                                    'orders/json'
                                ]
                            },
                            'tradingview': {
                                'get': [
                                    'config',
                                    'history',
                                    'symbol_info',
                                    'time'
                                ]
                            }
                        },
                        'exceptions': {
                            'exact': {
                                '0': ExchangeError1,
                                '1': NotSupported,
                                '4000': BadRequest,
                                '4001': BadRequest,
                                '4002': InsufficientFunds,
                                '4003': AuthenticationError,
                                '4004': AuthenticationError,
                                '4005': BadRequest,
                                '4006': BadRequest,
                                '4007': BadRequest,
                                '4300': PermissionDenied,
                                '4100': AuthenticationError,
                                '4400': OrderNotFound,
                                '5001': InvalidOrder,
                                '5002': ExchangeError1,
                                '400': BadRequest,
                                '401': AuthenticationError,
                                '403': PermissionDenied,
                                '404': OrderNotFound,
                                '429': RateLimitExceeded,
                                '500': ExchangeError1,
                                '503': ExchangeNotAvailable
                            },
                            'broad': {
                                'Insufficient': InsufficientFunds
                            }
                        },
                        'options': {
                            'expireIn': 31536000,
                            'fetchTickers': {
                                'period': '1d'
                            },
                            'fetchTrades': {
                                'sort': 'timestamp,asc'
                            },
                            'fetchMyTrades': {
                                'sort': 'timestamp,asc'
                            },
                            'fetchOpenOrders': {
                                'sort': 'createdAt,asc'
                            },
                            'fetchClosedOrders': {
                                'sort': 'createdAt,asc'
                            },
                            'defaultSort': 'timestamp,asc',
                            'defaultSortOrders': 'createdAt,asc'
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetMarkets(params);
                    //
                    //     [
                    //         {
                    //             "symbol": "ETHBTC",
                    //             "name": "ETH/BTC",
                    //             "baseCurrency": "ETH",
                    //             "baseTokenAddress": "0x45932db54b38af1f5a57136302eeba66a5975c15",
                    //             "quoteCurrency": "BTC",
                    //             "quoteTokenAddress": "0x8370fbc6ddec1e18b4e41e72ed943e238458487c",
                    //             "feeCurrency": "BTC",
                    //             "feeTokenAddress": "0x8370fbc6ddec1e18b4e41e72ed943e238458487c",
                    //             "quantityIncrement": "0.0000001",
                    //             "takerFee": "0.005",
                    //             "makerFee": "0.0025",
                    //             "tickSize": "0.00000001",
                    //             "baseMinSize": "0.0001",
                    //             "quoteMinSize": "0.00001",
                    //             "locked": false
                    //         }
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++)result.push(this.parseMarket(response[i]));
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCurrencies(params);
                    //
                    //     [
                    //         {
                    //             "symbol": "BTC",
                    //             "name": "Bitcoin",
                    //             "address": "0x8370fbc6ddec1e18b4e41e72ed943e238458487c",
                    //             "icon": "data:image/svg+xml;base64,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",
                    //             "background": "transparent",
                    //             "fiatSymbol": "BTC",
                    //             "decimals": 8,
                    //             "tradeDecimals": 20,
                    //             "displayDecimals": 4,
                    //             "crypto": true,
                    //             "depositEnabled": true,
                    //             "withdrawalEnabled": true,
                    //             "transferEnabled": true,
                    //             "buyEnabled": false,
                    //             "purchaseEnabled": false,
                    //             "redeemEnabled": false,
                    //             "active": true,
                    //             "withdrawalFee": "50000000000000000",
                    //             "purchaseCommissions": []
                    //         },
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const currency = response[i];
                        result.push(this.parseCurrency(currency));
                    }
                    return this.indexBy(result, 'code');
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const period = this.safeString(this.options['fetchTickers'], 'period', '1d');
                    const request = {
                        'period': this.timeframes[period]
                    };
                    const response = await this.publicGetTickers(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "ask": 0.017,
                    //             "bid": 0.016,
                    //             "high": 0.019,
                    //             "last": 0.017,
                    //             "low": 0.015,
                    //             "market": "TIME/ETH",
                    //             "open": 0.016,
                    //             "period": "H1",
                    //             "timestamp": "2018-12-14T20:50:36.134Z",
                    //             "volume": 4.57,
                    //             "volumeQuote": 0.07312
                    //         }
                    //     ]
                    //
                    return this.parseTickers(response, symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const period = this.safeString(this.options['fetchTickers'], 'period', '1d');
                    const request = {
                        'market': market['id'],
                        'period': this.timeframes[period]
                    };
                    const response = await this.publicGetTickers(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "ask": 0.017,
                    //             "bid": 0.016,
                    //             "high": 0.019,
                    //             "last": 0.017,
                    //             "low": 0.015,
                    //             "market": "TIME/ETH",
                    //             "open": 0.016,
                    //             "period": "H1",
                    //             "timestamp": "2018-12-14T20:50:36.134Z",
                    //             "volume": 4.57,
                    //             "volumeQuote": 0.07312
                    //         }
                    //     ]
                    //
                    const ticker = this.safeValue(response, 0);
                    return this.parseTicker(ticker, market);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetOrderbookV2(this.extend(request, params));
                    //
                    //     {
                    //         "timestamp":"2019-12-05T00:21:09.538",
                    //         "bid":[
                    //             {
                    //                 "index":"2",
                    //                 "price":"0.02024007",
                    //                 "baseTokenAmount":"0.0096894",
                    //                 "baseTokenCumulativeAmount":"0.0096894",
                    //                 "quoteTokenAmount":"0.000196114134258",
                    //                 "quoteTokenCumulativeAmount":"0.000196114134258"
                    //             },
                    //         "ask":[
                    //             {
                    //                 "index":"-3",
                    //                 "price":"0.02024012",
                    //                 "baseTokenAmount":"0.005",
                    //                 "baseTokenCumulativeAmount":"0.005",
                    //                 "quoteTokenAmount":"0.0001012006",
                    //                 "quoteTokenCumulativeAmount":"0.0001012006"
                    //             },
                    //         ]
                    //     }
                    //
                    const timestamp = this.parse8601(this.safeString(response, 'timestamp'));
                    return this.parseOrderBook(response, symbol, timestamp, 'bid', 'ask', 'price', 'baseTokenAmount');
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const options = this.safeValue(this.options, 'fetchTrades', {});
                    const defaultSort = this.safeValue(options, 'sort', 'timestamp,asc');
                    const sort = this.safeString(params, 'sort', defaultSort);
                    const query = this.omit(params, 'sort');
                    const request = {
                        // 'address': 'string', // trade’s member account (?)
                        // 'cursor': 1234, // int64 (?)
                        // 'from': this.iso8601 (since),
                        'market': market['id'],
                        // 'page': 0, // results page you want to retrieve 0 .. N
                        // 'size': limit, // number of records per page, 100 by default
                        'sort': sort
                    };
                    if (since !== undefined) request['from'] = this.iso8601(since);
                    if (limit !== undefined) request['size'] = limit; // default is 100
                    const response = await this.publicGetTrades(this.extend(request, query));
                    //
                    //     [
                    //         {
                    //             "id":1,
                    //             "timestamp":"2019-06-25T17:01:50.309",
                    //             "direction":"BUY",
                    //             "price":"0.027",
                    //             "quantity":"0.001"
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'period': this.timeframes[timeframe]
                    };
                    // if since and limit are not specified
                    const duration = this.parseTimeframe(timeframe);
                    if (since !== undefined) {
                        request['from'] = this.iso8601(since);
                        if (limit !== undefined) request['till'] = this.iso8601(this.sum(since, this.sum(limit, 1) * duration * 1000));
                    } else if (limit !== undefined) {
                        const now = this.milliseconds();
                        request['till'] = this.iso8601(now);
                        request['from'] = this.iso8601(now - limit * duration * 1000 - 1);
                    } else request['till'] = this.iso8601(this.milliseconds());
                    const response = await this.publicGetCandles(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "timestamp":"2019-12-04T23:00:00",
                    //             "open":"0.02024009",
                    //             "high":"0.02024009",
                    //             "low":"0.02024009",
                    //             "close":"0.02024009",
                    //             "volume":"0.00008096036",
                    //             "volumeQuote":"0.004",
                    //         },
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'totalBalance');
                        account['used'] = this.safeString(balance, 'lockedBalance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.tradingGetBalances(params);
                    //
                    //     [
                    //         {"currency":"BTC","totalBalance":"0","lockedBalance":"0"},
                    //         {"currency":"AUDT","totalBalance":"0","lockedBalance":"0"},
                    //         {"currency":"ETH","totalBalance":"0","lockedBalance":"0"},
                    //         {"currency":"TIME","totalBalance":"0","lockedBalance":"0"},
                    //         {"currency":"USDT","totalBalance":"0","lockedBalance":"0"}
                    //     ]
                    //
                    return this.parseBalance(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const uppercaseSide = side.toUpperCase();
                    let uppercaseType = type.toUpperCase();
                    const postOnly = this.safeValue(params, 'postOnly', false);
                    if (postOnly) {
                        uppercaseType = 'POST_ONLY';
                        params = this.omit(params, [
                            'postOnly'
                        ]);
                    }
                    const request = {
                        'symbol': market['id'],
                        'quantity': this.amountToPrecision(symbol, amount),
                        'side': uppercaseSide,
                        'orderTypes': uppercaseType
                    };
                    let query = params;
                    if (uppercaseType === 'LIMIT' || uppercaseType === 'POST_ONLY') {
                        request['price'] = this.priceToPrecision(symbol, price);
                        const defaultExpireIn = this.safeInteger(this.options, 'expireIn');
                        const expireTime = this.safeValue(params, 'expireTime');
                        const expireIn = this.safeValue(params, 'expireIn', defaultExpireIn);
                        if (expireTime !== undefined) request['expireTime'] = expireTime;
                        else if (expireIn !== undefined) request['expireIn'] = expireIn;
                        else throw new InvalidOrder(this.id + ' createOrder() method requires a expireTime or expireIn param for a ' + type + ' order, you can also set the expireIn exchange-wide option');
                        query = this.omit(params, [
                            'expireTime',
                            'expireIn'
                        ]);
                    } else request['price'] = 0;
                    const response = await this.tradingPostOrders(this.extend(request, query));
                    //
                    //     {
                    //         "orders": [
                    //             {
                    //                 "cancelledQuantity": "0.3",
                    //                 "clientOrderId": "my-order-1",
                    //                 "createdAt": "1970-01-01T00:00:00",
                    //                 "cursorId": 50,
                    //                 "expireTime": "1970-01-01T00:00:00",
                    //                 "filledQuantity": "0.3",
                    //                 "id": "string",
                    //                 "price": "0.017",
                    //                 "quantity": "0.3",
                    //                 "side": "BUY",
                    //                 "symbol": "TIMEETH",
                    //                 "type": "LIMIT",
                    //                 "updatedAt": "1970-01-01T00:00:00"
                    //             }
                    //         ]
                    //     }
                    //
                    const orders = this.safeValue(response, 'orders', []);
                    const order = this.safeValue(orders, 0, {});
                    return this.parseOrder(order, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'id': id
                    };
                    if (amount !== undefined) request['quantity'] = this.amountToPrecision(symbol, amount);
                    if (price !== undefined) request['price'] = this.priceToPrecision(symbol, price);
                    const response = await this.tradingPutOrders(this.extend(request, params));
                    //
                    //     {
                    //         "changedOrders": [
                    //             {
                    //                 "newOrder": {
                    //                 "cancelledQuantity": "0.3",
                    //                 "clientOrderId": "my-order-1",
                    //                 "createdAt": "1970-01-01T00:00:00",
                    //                 "cursorId": 50,
                    //                 "expireTime": "1970-01-01T00:00:00",
                    //                 "filledQuantity": "0.3",
                    //                 "id": "string",
                    //                 "price": "0.017",
                    //                 "quantity": "0.3",
                    //                 "side": "BUY",
                    //                 "symbol": "TIMEETH",
                    //                 "type": "LIMIT",
                    //                 "updatedAt": "1970-01-01T00:00:00"
                    //                 },
                    //                 "oldId": "string",
                    //             },
                    //         ],
                    //         "unchangedOrders": [ "string" ],
                    //     }
                    //
                    if ('unchangedOrders' in response) {
                        const orderIds = this.safeValue(response, 'unchangedOrders', []);
                        const orderId = this.safeString(orderIds, 0);
                        return {
                            'id': orderId,
                            'info': response
                        };
                    }
                    const orders = this.safeValue(response, 'changedOrders', []);
                    const firstOrder = this.safeValue(orders, 0, {});
                    const order = this.safeValue(firstOrder, 'newOrder', {});
                    return this.parseOrder(order, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    return await this.cancelOrders([
                        id
                    ], symbol, params);
                }
                async cancelOrders(ids, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'id': ids
                    };
                    const response = await this.tradingDeleteOrders(this.extend(request, params));
                    //
                    //     {
                    //         "changedOrders": [
                    //             {
                    //                 "newOrder": {
                    //                     "cancelledQuantity": "0.3",
                    //                     "clientOrderId": "my-order-1",
                    //                     "createdAt": "1970-01-01T00:00:00",
                    //                     "cursorId": 50,
                    //                     "expireTime": "1970-01-01T00:00:00",
                    //                     "filledQuantity": "0.3",
                    //                     "id": "string",
                    //                     "price": "0.017",
                    //                     "quantity": "0.3",
                    //                     "side": "BUY",
                    //                     "symbol": "TIMEETH",
                    //                     "type": "LIMIT",
                    //                     "updatedAt": "1970-01-01T00:00:00"
                    //                 },
                    //                 "oldId": "string",
                    //             },
                    //         ],
                    //         "unchangedOrders": [ "string" ],
                    //     }
                    return response;
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderHash': id
                    };
                    const response = await this.historyGetOrdersDetails(request);
                    //
                    //     {
                    //         "order": {
                    //             "cancelledQuantity": "0.3",
                    //             "clientOrderId": "my-order-1",
                    //             "createdAt": "1970-01-01T00:00:00",
                    //             "cursorId": 50,
                    //             "expireTime": "1970-01-01T00:00:00",
                    //             "filledQuantity": "0.3",
                    //             "id": "string",
                    //             "price": "0.017",
                    //             "quantity": "0.3",
                    //             "side": "BUY",
                    //             "symbol": "TIMEETH",
                    //             "type": "LIMIT",
                    //             "updatedAt": "1970-01-01T00:00:00"
                    //         },
                    //         "trades": [
                    //             {
                    //                 "fee": "0.3",
                    //                 "id": 100,
                    //                 "makerOrTaker": "MAKER",
                    //                 "makerOrderId": "string",
                    //                 "price": "0.017",
                    //                 "quantity": "0.3",
                    //                 "side": "BUY",
                    //                 "symbol": "TIMEETH",
                    //                 "takerOrderId": "string",
                    //                 "timestamp": "2019-12-05T07:48:26.310Z"
                    //             }
                    //         ]
                    //     }
                    //
                    const order = this.safeValue(response, 'order', {});
                    const trades = this.safeValue(response, 'trades', []);
                    return this.parseOrder(this.extend(order, {
                        'trades': trades
                    }));
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const options = this.safeValue(this.options, 'fetchOpenOrders', {});
                    const defaultSort = this.safeValue(options, 'sort', 'createdAt,asc');
                    const sort = this.safeString(params, 'sort', defaultSort);
                    const query = this.omit(params, 'sort');
                    const request = {
                        // 'clientOrderId': '123', // order’s client id list for filter
                        // page: 0, // results page you want to retrieve (0 .. N)
                        'sort': sort
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this.tradingGetOrders(this.extend(request, query));
                    //
                    //     {
                    //         "orders": [
                    //             {
                    //                 "cancelledQuantity": "0.3",
                    //                 "clientOrderId": "my-order-1",
                    //                 "createdAt": "1970-01-01T00:00:00",
                    //                 "cursorId": 50,
                    //                 "expireTime": "1970-01-01T00:00:00",
                    //                 "filledQuantity": "0.3",
                    //                 "id": "string",
                    //                 "price": "0.017",
                    //                 "quantity": "0.3",
                    //                 "side": "BUY",
                    //                 "symbol": "TIMEETH",
                    //                 "type": "LIMIT",
                    //                 "updatedAt": "1970-01-01T00:00:00"
                    //             }
                    //         ]
                    //     }
                    //
                    const orders = this.safeValue(response, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const options = this.safeValue(this.options, 'fetchClosedOrders', {});
                    const defaultSort = this.safeValue(options, 'sort', 'createdAt,asc');
                    const sort = this.safeString(params, 'sort', defaultSort);
                    const query = this.omit(params, 'sort');
                    const request = {
                        // 'clientOrderId': '123', // order’s client id list for filter
                        // page: 0, // results page you want to retrieve (0 .. N)
                        'sort': sort,
                        'side': 'BUY'
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['from'] = this.iso8601(since);
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this.historyGetOrders(this.extend(request, query));
                    //
                    //     {
                    //         "orders": [
                    //             {
                    //                 "cancelledQuantity": "0.3",
                    //                 "clientOrderId": "my-order-1",
                    //                 "createdAt": "1970-01-01T00:00:00",
                    //                 "cursorId": 50,
                    //                 "expireTime": "1970-01-01T00:00:00",
                    //                 "filledQuantity": "0.3",
                    //                 "id": "string",
                    //                 "price": "0.017",
                    //                 "quantity": "0.3",
                    //                 "side": "BUY",
                    //                 "symbol": "TIMEETH",
                    //                 "type": "LIMIT",
                    //                 "updatedAt": "1970-01-01T00:00:00"
                    //             }
                    //         ]
                    //     }
                    //
                    const orders = this.safeValue(response, 'orders', []);
                    return this.parseOrders(orders, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const options = this.safeValue(this.options, 'fetchMyTrades', {});
                    const defaultSort = this.safeValue(options, 'sort', 'timestamp,asc');
                    const sort = this.safeString(params, 'sort', defaultSort);
                    const query = this.omit(params, 'sort');
                    const request = {
                        // 'cursorId': 123, // int64 (?)
                        // 'from': this.iso8601 (since),
                        // 'makerOrderId': '1234', // maker order hash
                        // 'owner': '...', // owner address (?)
                        // 'page': 0, // results page you want to retrieve (0 .. N)
                        // 'side': 'BUY', // or 'SELL'
                        // 'size': limit,
                        'sort': sort
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['from'] = this.iso8601(since);
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this.historyGetTrades(this.extend(request, query));
                    //
                    //     {
                    //         "trades": [
                    //             {
                    //                 "fee": "0.3",
                    //                 "id": 100,
                    //                 "makerOrTaker": "MAKER",
                    //                 "makerOrderId": "string",
                    //                 "price": "0.017",
                    //                 "quantity": "0.3",
                    //                 "side": "BUY",
                    //                 "symbol": "TIMEETH",
                    //                 "takerOrderId": "string",
                    //                 "timestamp": "2019-12-08T04:54:11.171Z"
                    //             }
                    //         ]
                    //     }
                    //
                    const trades = this.safeValue(response, 'trades', []);
                    return this.parseTrades(trades, market, since, limit);
                }
                parseTradingFee(fee, market) {
                    //
                    //     {
                    //         "fee": 0.0075,
                    //         "market": "ETHBTC"
                    //     }
                    //
                    const marketId = this.safeString(fee, 'market');
                    const rate = this.safeNumber(fee, 'fee');
                    return {
                        'info': fee,
                        'symbol': this.safeSymbol(marketId, market),
                        'maker': rate,
                        'taker': rate
                    };
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'markets': market['id']
                    };
                    const response = await this.tradingGetFees(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "fee": 0.0075,
                    //             "market": "ETHBTC"
                    //         }
                    //     ]
                    //
                    const result = this.safeValue(response, 0, {});
                    return this.parseTradingFee(result, market);
                }
                parseMarket(market) {
                    //
                    //     {
                    //         "symbol": "ETHBTC",
                    //         "name": "ETH/BTC",
                    //         "baseCurrency": "ETH",
                    //         "baseTokenAddress": "0x45932db54b38af1f5a57136302eeba66a5975c15",
                    //         "quoteCurrency": "BTC",
                    //         "quoteTokenAddress": "0x8370fbc6ddec1e18b4e41e72ed943e238458487c",
                    //         "feeCurrency": "BTC",
                    //         "feeTokenAddress": "0x8370fbc6ddec1e18b4e41e72ed943e238458487c",
                    //         "quantityIncrement": "0.0000001",
                    //         "takerFee": "0.005",
                    //         "makerFee": "0.0025",
                    //         "tickSize": "0.00000001",
                    //         "baseMinSize": "0.0001",
                    //         "quoteMinSize": "0.00001",
                    //         "locked": false
                    //     }
                    //
                    const locked = this.safeValue(market, 'locked');
                    const id = this.safeString(market, 'symbol');
                    const baseId = this.safeString(market, 'baseCurrency');
                    const quoteId = this.safeString(market, 'quoteCurrency');
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    const amountIncrement = this.safeString(market, 'quantityIncrement');
                    const minBase = this.safeString(market, 'baseMinSize');
                    const minAmount = Precise.stringMax(amountIncrement, minBase);
                    const priceIncrement = this.safeString(market, 'tickSize');
                    const minCost = this.safeString(market, 'quoteMinSize');
                    return {
                        'id': id,
                        'symbol': base + '/' + quote,
                        'base': base,
                        'quote': quote,
                        'settle': undefined,
                        'baseId': baseId,
                        'quoteId': quoteId,
                        'settleId': undefined,
                        'type': 'spot',
                        'spot': true,
                        'margin': false,
                        'swap': false,
                        'future': false,
                        'option': false,
                        'active': !locked,
                        'contract': false,
                        'linear': undefined,
                        'inverse': undefined,
                        'taker': this.safeNumber(market, 'takerFee'),
                        'maker': this.safeNumber(market, 'makerFee'),
                        'contractSize': undefined,
                        'expiry': undefined,
                        'expiryDatetime': undefined,
                        'strike': undefined,
                        'optionType': undefined,
                        'precision': {
                            'amount': this.precisionFromString(this.safeString(market, 'quantityIncrement')),
                            'price': this.precisionFromString(this.safeString(market, 'tickSize'))
                        },
                        'limits': {
                            'leverage': {
                                'min': undefined,
                                'max': undefined
                            },
                            'amount': {
                                'min': this.parseNumber(minAmount),
                                'max': undefined
                            },
                            'price': {
                                'min': this.parseNumber(priceIncrement),
                                'max': undefined
                            },
                            'cost': {
                                'min': minCost,
                                'max': undefined
                            }
                        },
                        'info': market
                    };
                }
                parseCurrency(currency) {
                    //
                    //     {
                    //         "symbol": "BTC",
                    //         "name": "Bitcoin",
                    //         "address": "0x8370fbc6ddec1e18b4e41e72ed943e238458487c",
                    //         "icon": "data:image/svg+xml;base64,PHN2ZyB3aWR...mc+Cg==",
                    //         "background": "transparent",
                    //         "fiatSymbol": "BTC",
                    //         "decimals": 8,
                    //         "tradeDecimals": 20,
                    //         "displayDecimals": 4,
                    //         "crypto": true,
                    //         "depositEnabled": true,
                    //         "withdrawalEnabled": true,
                    //         "transferEnabled": true,
                    //         "buyEnabled": false,
                    //         "purchaseEnabled": false,
                    //         "redeemEnabled": false,
                    //         "active": true,
                    //         "withdrawalFee": "50000000000000000",
                    //         "purchaseCommissions": []
                    //     }
                    //
                    // https://github.com/ccxt/ccxt/issues/6878
                    //
                    //     {
                    //         "symbol":"XRP",
                    //         "name":"Ripple",
                    //         "address":"0x0dc8882914f3ddeebf4cec6dc20edb99df3def6c",
                    //         "decimals":6,
                    //         "tradeDecimals":16,
                    //         "depositEnabled":true,
                    //         "withdrawalEnabled":true,
                    //         "transferEnabled":true,
                    //         "active":true
                    //     }
                    //
                    const id = this.safeString(currency, 'symbol');
                    const code = this.safeCurrencyCode(id);
                    const name = this.safeString(currency, 'name');
                    const precision = this.safeInteger(currency, 'decimals');
                    const depositEnabled = this.safeValue(currency, 'depositEnabled');
                    const withdrawEnabled = this.safeValue(currency, 'withdrawalEnabled');
                    const isActive = this.safeValue(currency, 'active');
                    const active = depositEnabled && withdrawEnabled && isActive;
                    // const fee = this.safeNumber (currency, 'withdrawalFee');
                    const feeString = this.safeString(currency, 'withdrawalFee');
                    const tradeDecimals = this.safeInteger(currency, 'tradeDecimals');
                    let fee = undefined;
                    if (feeString !== undefined && tradeDecimals !== undefined) {
                        const feeStringLen = feeString.length;
                        const dotIndex = feeStringLen - tradeDecimals;
                        if (dotIndex > 0) {
                            const whole = feeString.slice(0, dotIndex);
                            const fraction = feeString.slice(-dotIndex);
                            fee = this.parseNumber(whole + '.' + fraction);
                        } else {
                            let fraction = '.';
                            for(let i = 0; i < -dotIndex; i++)fraction += '0';
                            fee = this.parseNumber(fraction + feeString);
                        }
                    }
                    return {
                        'id': code,
                        'code': code,
                        'info': currency,
                        'type': undefined,
                        'name': name,
                        'active': active,
                        'deposit': depositEnabled,
                        'withdraw': withdrawEnabled,
                        'fee': fee,
                        'precision': precision,
                        'limits': {
                            'withdraw': {
                                'min': fee,
                                'max': undefined
                            },
                            'amount': {
                                'min': undefined,
                                'max': undefined
                            }
                        }
                    };
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "ask": 0.017,
                    //         "bid": 0.016,
                    //         "high": 0.019,
                    //         "last": 0.017,
                    //         "low": 0.015,
                    //         "market": "TIME/ETH",
                    //         "open": 0.016,
                    //         "period": "H1",
                    //         "timestamp": "2018-12-14T20:50:36.134Z",
                    //         "volume": 4.57,
                    //         "volumeQuote": 0.07312
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'market');
                    const symbol = this.safeSymbol(marketId, market, '/');
                    const timestamp = this.parse8601(this.safeString(ticker, 'timestamp'));
                    const last = this.safeString(ticker, 'last');
                    const open = this.safeString(ticker, 'open');
                    return this.safeTicker({
                        'symbol': symbol,
                        'info': ticker,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'volume'),
                        'quoteVolume': this.safeString(ticker, 'volumeQuote')
                    }, market, false);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "id":1,
                    //         "timestamp":"2019-06-25T17:01:50.309",
                    //         "direction":"BUY",
                    //         "price":"0.027",
                    //         "quantity":"0.001"
                    //     }
                    //
                    // fetchMyTrades, fetchOrder (private)
                    //
                    //     {
                    //         "id": "7613414",
                    //         "makerOrderId": "0x8420af060722f560098f786a2894d4358079b6ea5d14b395969ed77bc87a623a",
                    //         "takerOrderId": "0x1235ef158a361815b54c9988b6241c85aedcbc1fe81caf8df8587d5ab0373d1a",
                    //         "symbol": "LTCUSDT",
                    //         "side": "BUY",
                    //         "quantity": "0.2",
                    //         "fee": "0.22685",
                    //         "feeToken": "USDT",
                    //         "price": "226.85",
                    //         "makerOrTaker": "TAKER",
                    //         "timestamp": "2021-04-09T15:39:45.608"
                    //    }
                    //
                    const marketId = this.safeString(trade, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.parse8601(this.safeString(trade, 'timestamp'));
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'quantity');
                    const price = this.parseNumber(priceString);
                    const amount = this.parseNumber(amountString);
                    const cost = this.parseNumber(Precise.stringMul(priceString, amountString));
                    const id = this.safeString(trade, 'id');
                    const side = this.safeStringLower2(trade, 'direction', 'side');
                    const takerOrMaker = this.safeStringLower(trade, 'makerOrTaker');
                    let orderId = undefined;
                    if (takerOrMaker !== undefined) orderId = this.safeString(trade, takerOrMaker + 'OrderId');
                    let fee = undefined;
                    const feeCost = this.safeNumber(trade, 'fee');
                    const feeCurrency = this.safeCurrencyCode(this.safeString(trade, 'feeToken'));
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': feeCurrency
                    };
                    return {
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'takerOrMaker': takerOrMaker,
                        'fee': fee
                    };
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "timestamp":"2019-12-04T23:00:00",
                    //         "open":"0.02024009",
                    //         "high":"0.02024009",
                    //         "low":"0.02024009",
                    //         "close":"0.02024009",
                    //         "volume":"0.00008096036",
                    //         "volumeQuote":"0.004",
                    //     }
                    //
                    return [
                        this.parse8601(this.safeString(ohlcv, 'timestamp')),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                parseOrder(order, market) {
                    //
                    // fetchOrder, createOrder, cancelOrder, cancelOrders, fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "cancelledQuantity": "0.3",
                    //         "clientOrderId": "my-order-1",
                    //         "createdAt": "1970-01-01T00:00:00",
                    //         "cursorId": 50,
                    //         "expireTime": "1970-01-01T00:00:00",
                    //         "filledQuantity": "0.3",
                    //         "id": "string",
                    //         "price": "0.017",
                    //         "quantity": "0.3",
                    //         "side": "BUY",
                    //         "symbol": "TIMEETH",
                    //         "type": "LIMIT",
                    //         "updatedAt": "1970-01-01T00:00:00"
                    //         "trades": [], // injected from the outside
                    //     }
                    //
                    const id = this.safeString(order, 'id');
                    const type = this.safeStringLower(order, 'type');
                    const side = this.safeStringLower(order, 'side');
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const timestamp = this.parse8601(this.safeString(order, 'createdAt'));
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'quantity');
                    const filled = this.safeString(order, 'filledQuantity');
                    const canceledQuantity = this.omitZero(this.safeString(order, 'cancelledQuantity'));
                    let status = undefined;
                    if (Precise.stringEquals(filled, amount)) status = 'closed';
                    else if (canceledQuantity !== undefined) status = 'canceled';
                    else status = 'open';
                    const rawTrades = this.safeValue(order, 'trades', []);
                    const clientOrderId = this.safeString(order, 'clientOrderId');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'average': undefined,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': undefined,
                        'trades': rawTrades
                    }, market);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + api + '/' + path;
                    if (Object.keys(params).length) url += '?' + this.urlencodeWithArrayRepeat(params);
                    if (api !== 'public') {
                        this.checkRequiredCredentials();
                        const auth = this.stringToBase64(this.apiKey + ':' + this.secret);
                        const secret = 'Basic ' + this.decode(auth);
                        headers = {
                            'authorization': secret
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(statusCode, statusText, url, method, responseHeaders, responseBody, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    if (statusCode >= 400) {
                        //
                        //     {"error":{"timestamp":"05.12.2019T05:25:43.584+0000","status":"BAD_REQUEST","message":"Insufficient ETH balance. Required: 1, actual: 0.","code":4001}}
                        //     {"error":{"timestamp":"05.12.2019T04:03:25.419+0000","status":"FORBIDDEN","message":"Access denied","code":4300}}
                        //
                        const feedback = this.id + ' ' + responseBody;
                        let error = this.safeValue(response, 'error');
                        if (error === undefined) error = response;
                        const code = this.safeString2(error, 'code', 'status');
                        const message = this.safeString2(error, 'message', 'debugMessage');
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    165: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, BadRequest: BadRequest, AuthenticationError: AuthenticationError, InvalidOrder: InvalidOrder, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, PermissionDenied: PermissionDenied, AddressPending: AddressPending } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class upbit extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'upbit',
                        'name': 'Upbit',
                        'countries': [
                            'KR'
                        ],
                        'version': 'v1',
                        'rateLimit': 1000,
                        'pro': true,
                        // new metainfo interface
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createMarketOrder': true,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchCanceledOrders': true,
                            'fetchClosedOrders': true,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': undefined,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': true,
                            'fetchOrders': undefined,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': false,
                            'fetchTransactions': undefined,
                            'fetchWithdrawals': true,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': 'minutes',
                            '3m': 'minutes',
                            '5m': 'minutes',
                            '15m': 'minutes',
                            '30m': 'minutes',
                            '1h': 'minutes',
                            '4h': 'minutes',
                            '1d': 'days',
                            '1w': 'weeks',
                            '1M': 'months'
                        },
                        'hostname': 'api.upbit.com',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/49245610-eeaabe00-f423-11e8-9cba-4b0aed794799.jpg',
                            'api': {
                                'public': 'https://{hostname}',
                                'private': 'https://{hostname}'
                            },
                            'www': 'https://upbit.com',
                            'doc': 'https://docs.upbit.com/docs/%EC%9A%94%EC%B2%AD-%EC%88%98-%EC%A0%9C%ED%95%9C',
                            'fees': 'https://upbit.com/service_center/guide'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'market/all',
                                    'candles/{timeframe}',
                                    'candles/{timeframe}/{unit}',
                                    'candles/minutes/{unit}',
                                    'candles/minutes/1',
                                    'candles/minutes/3',
                                    'candles/minutes/5',
                                    'candles/minutes/15',
                                    'candles/minutes/30',
                                    'candles/minutes/60',
                                    'candles/minutes/240',
                                    'candles/days',
                                    'candles/weeks',
                                    'candles/months',
                                    'trades/ticks',
                                    'ticker',
                                    'orderbook'
                                ]
                            },
                            'private': {
                                'get': [
                                    'accounts',
                                    'orders/chance',
                                    'order',
                                    'orders',
                                    'withdraws',
                                    'withdraw',
                                    'withdraws/chance',
                                    'deposits',
                                    'deposit',
                                    'deposits/coin_addresses',
                                    'deposits/coin_address'
                                ],
                                'post': [
                                    'orders',
                                    'withdraws/coin',
                                    'withdraws/krw',
                                    'deposits/generate_coin_address'
                                ],
                                'delete': [
                                    'order'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.0025'),
                                'taker': this.parseNumber('0.0025')
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false,
                                'withdraw': {},
                                'deposit': {}
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'This key has expired.': AuthenticationError,
                                'Missing request parameter error. Check the required parameters!': BadRequest,
                                'side is missing, side does not have a valid value': InvalidOrder
                            },
                            'broad': {
                                'thirdparty_agreement_required': PermissionDenied,
                                'out_of_scope': PermissionDenied,
                                'order_not_found': OrderNotFound,
                                'insufficient_funds': InsufficientFunds,
                                'invalid_access_key': AuthenticationError,
                                'jwt_verification': AuthenticationError,
                                'create_ask_error': ExchangeError1,
                                'create_bid_error': ExchangeError1,
                                'volume_too_large': InvalidOrder,
                                'invalid_funds': InvalidOrder
                            }
                        },
                        'options': {
                            'createMarketBuyOrderRequiresPrice': true,
                            'fetchTickersMaxLength': 4096,
                            'fetchOrderBooksMaxLength': 4096,
                            'tradingFeesByQuoteCurrency': {
                                'KRW': 0.0005
                            }
                        },
                        'commonCurrencies': {
                            'TON': 'Tokamak Network'
                        }
                    });
                }
                async fetchCurrency(code, params = {}) {
                    // this method is for retrieving funding fees and limits per currency
                    // it requires private access and API keys properly set up
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    return await this.fetchCurrencyById(currency['id'], params);
                }
                async fetchCurrencyById(id, params = {}) {
                    // this method is for retrieving funding fees and limits per currency
                    // it requires private access and API keys properly set up
                    const request = {
                        'currency': id
                    };
                    const response = await this.privateGetWithdrawsChance(this.extend(request, params));
                    //
                    //     {
                    //         "member_level": {
                    //             "security_level": 3,
                    //             "fee_level": 0,
                    //             "email_verified": true,
                    //             "identity_auth_verified": true,
                    //             "bank_account_verified": true,
                    //             "kakao_pay_auth_verified": false,
                    //             "locked": false,
                    //             "wallet_locked": false
                    //         },
                    //         "currency": {
                    //             "code": "BTC",
                    //             "withdraw_fee": "0.0005",
                    //             "is_coin": true,
                    //             "wallet_state": "working",
                    //             "wallet_support": [ "deposit", "withdraw" ]
                    //         },
                    //         "account": {
                    //             "currency": "BTC",
                    //             "balance": "10.0",
                    //             "locked": "0.0",
                    //             "avg_krw_buy_price": "8042000",
                    //             "modified": false
                    //         },
                    //         "withdraw_limit": {
                    //             "currency": "BTC",
                    //             "minimum": null,
                    //             "onetime": null,
                    //             "daily": "10.0",
                    //             "remaining_daily": "10.0",
                    //             "remaining_daily_krw": "0.0",
                    //             "fixed": null,
                    //             "can_withdraw": true
                    //         }
                    //     }
                    //
                    const memberInfo = this.safeValue(response, 'member_level', {});
                    const currencyInfo = this.safeValue(response, 'currency', {});
                    const withdrawLimits = this.safeValue(response, 'withdraw_limit', {});
                    const canWithdraw = this.safeValue(withdrawLimits, 'can_withdraw');
                    const walletState = this.safeString(currencyInfo, 'wallet_state');
                    const walletLocked = this.safeValue(memberInfo, 'wallet_locked');
                    const locked = this.safeValue(memberInfo, 'locked');
                    let active = true;
                    if (canWithdraw !== undefined && !canWithdraw) active = false;
                    else if (walletState !== 'working') active = false;
                    else if (walletLocked !== undefined && walletLocked) active = false;
                    else if (locked !== undefined && locked) active = false;
                    const maxOnetimeWithdrawal = this.safeNumber(withdrawLimits, 'onetime');
                    const maxDailyWithdrawal = this.safeNumber(withdrawLimits, 'daily', maxOnetimeWithdrawal);
                    const remainingDailyWithdrawal = this.safeNumber(withdrawLimits, 'remaining_daily', maxDailyWithdrawal);
                    let maxWithdrawLimit = undefined;
                    if (remainingDailyWithdrawal > 0) maxWithdrawLimit = remainingDailyWithdrawal;
                    else maxWithdrawLimit = maxDailyWithdrawal;
                    const precision = undefined;
                    const currencyId = this.safeString(currencyInfo, 'code');
                    const code = this.safeCurrencyCode(currencyId);
                    return {
                        'info': response,
                        'id': currencyId,
                        'code': code,
                        'name': code,
                        'active': active,
                        'fee': this.safeNumber(currencyInfo, 'withdraw_fee'),
                        'precision': precision,
                        'limits': {
                            'withdraw': {
                                'min': this.safeNumber(withdrawLimits, 'minimum'),
                                'max': maxWithdrawLimit
                            }
                        }
                    };
                }
                async fetchMarket(symbol, params = {}) {
                    // this method is for retrieving trading fees and limits per market
                    // it requires private access and API keys properly set up
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    return await this.fetchMarketById(market['id'], params);
                }
                async fetchMarketById(id, params = {}) {
                    // this method is for retrieving trading fees and limits per market
                    // it requires private access and API keys properly set up
                    const request = {
                        'market': id
                    };
                    const response = await this.privateGetOrdersChance(this.extend(request, params));
                    //
                    //     {
                    //         "bid_fee": "0.0015",
                    //         "ask_fee": "0.0015",
                    //         "market": {
                    //             "id": "KRW-BTC",
                    //             "name": "BTC/KRW",
                    //             "order_types": [ "limit" ],
                    //             "order_sides": [ "ask", "bid" ],
                    //             "bid": { "currency": "KRW", "price_unit": null, "min_total": 1000 },
                    //             "ask": { "currency": "BTC", "price_unit": null, "min_total": 1000 },
                    //             "max_total": "100000000.0",
                    //             "state": "active",
                    //         },
                    //         "bid_account": {
                    //             "currency": "KRW",
                    //             "balance": "0.0",
                    //             "locked": "0.0",
                    //             "avg_buy_price": "0",
                    //             "avg_buy_price_modified": false,
                    //             "unit_currency": "KRW",
                    //         },
                    //         "ask_account": {
                    //             "currency": "BTC",
                    //             "balance": "10.0",
                    //             "locked": "0.0",
                    //             "avg_buy_price": "8042000",
                    //             "avg_buy_price_modified": false,
                    //             "unit_currency": "KRW",
                    //         }
                    //     }
                    //
                    const marketInfo = this.safeValue(response, 'market');
                    const bid = this.safeValue(marketInfo, 'bid');
                    const ask = this.safeValue(marketInfo, 'ask');
                    const marketId = this.safeString(marketInfo, 'id');
                    const baseId = this.safeString(ask, 'currency');
                    const quoteId = this.safeString(bid, 'currency');
                    const base = this.safeCurrencyCode(baseId);
                    const quote = this.safeCurrencyCode(quoteId);
                    const state = this.safeString(marketInfo, 'state');
                    const bidFee = this.safeNumber(response, 'bid_fee');
                    const askFee = this.safeNumber(response, 'ask_fee');
                    const fee = Math.max(bidFee, askFee);
                    return {
                        'id': marketId,
                        'symbol': base + '/' + quote,
                        'base': base,
                        'quote': quote,
                        'settle': undefined,
                        'baseId': baseId,
                        'quoteId': quoteId,
                        'settleId': undefined,
                        'type': 'spot',
                        'spot': true,
                        'margin': false,
                        'swap': false,
                        'future': false,
                        'option': false,
                        'active': state === 'active',
                        'contract': false,
                        'linear': undefined,
                        'inverse': undefined,
                        'taker': fee,
                        'maker': fee,
                        'contractSize': undefined,
                        'expiry': undefined,
                        'expiryDatetime': undefined,
                        'strike': undefined,
                        'optionType': undefined,
                        'precision': {
                            'amount': parseInt('8'),
                            'price': parseInt('8')
                        },
                        'limits': {
                            'leverage': {
                                'min': undefined,
                                'max': undefined
                            },
                            'amount': {
                                'min': this.safeNumber(ask, 'min_total'),
                                'max': undefined
                            },
                            'price': {
                                'min': undefined,
                                'max': undefined
                            },
                            'cost': {
                                'min': this.safeNumber(bid, 'min_total'),
                                'max': this.safeNumber(marketInfo, 'max_total')
                            },
                            'info': response
                        }
                    };
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetMarketAll(params);
                    //
                    //    [
                    //        {
                    //            market: "KRW-BTC",
                    //            korean_name: "비트코인",
                    //            english_name: "Bitcoin"
                    //        },
                    //        ...,
                    //    ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        const id = this.safeString(market, 'market');
                        const [quoteId, baseId] = id.split('-');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': true,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.safeNumber(this.options['tradingFeesByQuoteCurrency'], quote, this.fees['trading']['taker']),
                            'maker': this.safeNumber(this.options['tradingFeesByQuoteCurrency'], quote, this.fees['trading']['maker']),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'price': 8,
                                'amount': 8
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'balance');
                        account['used'] = this.safeString(balance, 'locked');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetAccounts(params);
                    //
                    //     [ {          currency: "BTC",
                    //                   balance: "0.005",
                    //                    locked: "0.0",
                    //         avg_krw_buy_price: "7446000",
                    //                  modified:  false     },
                    //       {          currency: "ETH",
                    //                   balance: "0.1",
                    //                    locked: "0.0",
                    //         avg_krw_buy_price: "250000",
                    //                  modified:  false    }   ]
                    //
                    return this.parseBalance(response);
                }
                async fetchOrderBooks(symbols, limit, params = {}) {
                    await this.loadMarkets();
                    let ids = undefined;
                    if (symbols === undefined) {
                        ids = this.ids.join(',');
                        // max URL length is 2083 symbols, including http schema, hostname, tld, etc...
                        if (ids.length > this.options['fetchOrderBooksMaxLength']) {
                            const numIds = this.ids.length;
                            throw new ExchangeError1(this.id + ' fetchOrderBooks() has ' + numIds.toString() + ' symbols (' + ids.length.toString() + ' characters) exceeding max URL length (' + this.options['fetchOrderBooksMaxLength'].toString() + ' characters), you are required to specify a list of symbols in the first argument to fetchOrderBooks');
                        }
                    } else {
                        ids = this.marketIds(symbols);
                        ids = ids.join(',');
                    }
                    const request = {
                        'markets': ids
                    };
                    const response = await this.publicGetOrderbook(this.extend(request, params));
                    //
                    //     [ {          market:   "BTC-ETH",
                    //               timestamp:    1542899030043,
                    //          total_ask_size:    109.57065201,
                    //          total_bid_size:    125.74430631,
                    //         orderbook_units: [ { ask_price: 0.02926679,
                    //                              bid_price: 0.02919904,
                    //                               ask_size: 4.20293961,
                    //                               bid_size: 11.65043576 },
                    //                            ...,
                    //                            { ask_price: 0.02938209,
                    //                              bid_price: 0.0291231,
                    //                               ask_size: 0.05135782,
                    //                               bid_size: 13.5595     }   ] },
                    //       {          market:   "KRW-BTC",
                    //               timestamp:    1542899034662,
                    //          total_ask_size:    12.89790974,
                    //          total_bid_size:    4.88395783,
                    //         orderbook_units: [ { ask_price: 5164000,
                    //                              bid_price: 5162000,
                    //                               ask_size: 2.57606495,
                    //                               bid_size: 0.214       },
                    //                            ...,
                    //                            { ask_price: 5176000,
                    //                              bid_price: 5152000,
                    //                               ask_size: 2.752,
                    //                               bid_size: 0.4650305 }    ] }   ]
                    //
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const orderbook = response[i];
                        const marketId = this.safeString(orderbook, 'market');
                        const symbol = this.safeSymbol(marketId, undefined, '-');
                        const timestamp = this.safeInteger(orderbook, 'timestamp');
                        result[symbol] = {
                            'symbol': symbol,
                            'bids': this.sortBy(this.parseBidsAsks(orderbook['orderbook_units'], 'bid_price', 'bid_size'), 0, true),
                            'asks': this.sortBy(this.parseBidsAsks(orderbook['orderbook_units'], 'ask_price', 'ask_size'), 0),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'nonce': undefined
                        };
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    const orderbooks = await this.fetchOrderBooks([
                        symbol
                    ], limit, params);
                    return this.safeValue(orderbooks, symbol);
                }
                parseTicker(ticker, market) {
                    //
                    //       {                market: "BTC-ETH",
                    //                    trade_date: "20181122",
                    //                    trade_time: "104543",
                    //                trade_date_kst: "20181122",
                    //                trade_time_kst: "194543",
                    //               trade_timestamp:  1542883543097,
                    //                 opening_price:  0.02976455,
                    //                    high_price:  0.02992577,
                    //                     low_price:  0.02934283,
                    //                   trade_price:  0.02947773,
                    //            prev_closing_price:  0.02966,
                    //                        change: "FALL",
                    //                  change_price:  0.00018227,
                    //                   change_rate:  0.0061453136,
                    //           signed_change_price:  -0.00018227,
                    //            signed_change_rate:  -0.0061453136,
                    //                  trade_volume:  1.00000005,
                    //               acc_trade_price:  100.95825586,
                    //           acc_trade_price_24h:  289.58650166,
                    //              acc_trade_volume:  3409.85311036,
                    //          acc_trade_volume_24h:  9754.40510513,
                    //         highest_52_week_price:  0.12345678,
                    //          highest_52_week_date: "2018-02-01",
                    //          lowest_52_week_price:  0.023936,
                    //           lowest_52_week_date: "2017-12-08",
                    //                     timestamp:  1542883543813  }
                    //
                    const timestamp = this.safeInteger(ticker, 'trade_timestamp');
                    const marketId = this.safeString2(ticker, 'market', 'code');
                    market = this.safeMarket(marketId, market, '-');
                    const last = this.safeString(ticker, 'trade_price');
                    return this.safeTicker({
                        'symbol': market['symbol'],
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high_price'),
                        'low': this.safeString(ticker, 'low_price'),
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'opening_price'),
                        'close': last,
                        'last': last,
                        'previousClose': this.safeString(ticker, 'prev_closing_price'),
                        'change': this.safeString(ticker, 'signed_change_price'),
                        'percentage': this.safeString(ticker, 'signed_change_rate'),
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'acc_trade_volume_24h'),
                        'quoteVolume': this.safeString(ticker, 'acc_trade_price_24h'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    let ids = undefined;
                    if (symbols === undefined) {
                        ids = this.ids.join(',');
                        // max URL length is 2083 symbols, including http schema, hostname, tld, etc...
                        if (ids.length > this.options['fetchTickersMaxLength']) {
                            const numIds = this.ids.length;
                            throw new ExchangeError1(this.id + ' fetchTickers() has ' + numIds.toString() + ' symbols exceeding max URL length, you are required to specify a list of symbols in the first argument to fetchTickers');
                        }
                    } else {
                        ids = this.marketIds(symbols);
                        ids = ids.join(',');
                    }
                    const request = {
                        'markets': ids
                    };
                    const response = await this.publicGetTicker(this.extend(request, params));
                    //
                    //     [ {                market: "BTC-ETH",
                    //                    trade_date: "20181122",
                    //                    trade_time: "104543",
                    //                trade_date_kst: "20181122",
                    //                trade_time_kst: "194543",
                    //               trade_timestamp:  1542883543097,
                    //                 opening_price:  0.02976455,
                    //                    high_price:  0.02992577,
                    //                     low_price:  0.02934283,
                    //                   trade_price:  0.02947773,
                    //            prev_closing_price:  0.02966,
                    //                        change: "FALL",
                    //                  change_price:  0.00018227,
                    //                   change_rate:  0.0061453136,
                    //           signed_change_price:  -0.00018227,
                    //            signed_change_rate:  -0.0061453136,
                    //                  trade_volume:  1.00000005,
                    //               acc_trade_price:  100.95825586,
                    //           acc_trade_price_24h:  289.58650166,
                    //              acc_trade_volume:  3409.85311036,
                    //          acc_trade_volume_24h:  9754.40510513,
                    //         highest_52_week_price:  0.12345678,
                    //          highest_52_week_date: "2018-02-01",
                    //          lowest_52_week_price:  0.023936,
                    //           lowest_52_week_date: "2017-12-08",
                    //                     timestamp:  1542883543813  } ]
                    //
                    const result = {};
                    for(let t = 0; t < response.length; t++){
                        const ticker = this.parseTicker(response[t]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    const tickers = await this.fetchTickers([
                        symbol
                    ], params);
                    return this.safeValue(tickers, symbol);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades
                    //
                    //       {             market: "BTC-ETH",
                    //             trade_date_utc: "2018-11-22",
                    //             trade_time_utc: "13:55:24",
                    //                  timestamp:  1542894924397,
                    //                trade_price:  0.02914289,
                    //               trade_volume:  0.20074397,
                    //         prev_closing_price:  0.02966,
                    //               change_price:  -0.00051711,
                    //                    ask_bid: "ASK",
                    //              sequential_id:  15428949259430000 }
                    //
                    // fetchOrder trades
                    //
                    //         {
                    //             "market": "KRW-BTC",
                    //             "uuid": "78162304-1a4d-4524-b9e6-c9a9e14d76c3",
                    //             "price": "101000.0",
                    //             "volume": "0.77368323",
                    //             "funds": "78142.00623",
                    //             "ask_fee": "117.213009345",
                    //             "bid_fee": "117.213009345",
                    //             "created_at": "2018-04-05T14:09:15+09:00",
                    //             "side": "bid",
                    //         }
                    //
                    const id = this.safeString2(trade, 'sequential_id', 'uuid');
                    const orderId = undefined;
                    let timestamp = this.safeInteger(trade, 'timestamp');
                    if (timestamp === undefined) timestamp = this.parse8601(this.safeString(trade, 'created_at'));
                    let side = undefined;
                    const askOrBid = this.safeStringLower2(trade, 'ask_bid', 'side');
                    if (askOrBid === 'ask') side = 'sell';
                    else if (askOrBid === 'bid') side = 'buy';
                    const cost = this.safeString(trade, 'funds');
                    const price = this.safeString2(trade, 'trade_price', 'price');
                    const amount = this.safeString2(trade, 'trade_volume', 'volume');
                    const marketId = this.safeString2(trade, 'market', 'code');
                    market = this.safeMarket(marketId, market, '-');
                    let fee = undefined;
                    const feeCost = this.safeString(trade, askOrBid + '_fee');
                    if (feeCost !== undefined) fee = {
                        'currency': market['quote'],
                        'cost': feeCost
                    };
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'order': orderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (limit === undefined) limit = 200;
                    const request = {
                        'market': market['id'],
                        'count': limit
                    };
                    const response = await this.publicGetTradesTicks(this.extend(request, params));
                    //
                    //     [ {             market: "BTC-ETH",
                    //             trade_date_utc: "2018-11-22",
                    //             trade_time_utc: "13:55:24",
                    //                  timestamp:  1542894924397,
                    //                trade_price:  0.02914289,
                    //               trade_volume:  0.20074397,
                    //         prev_closing_price:  0.02966,
                    //               change_price:  -0.00051711,
                    //                    ask_bid: "ASK",
                    //              sequential_id:  15428949259430000 },
                    //       {             market: "BTC-ETH",
                    //             trade_date_utc: "2018-11-22",
                    //             trade_time_utc: "13:03:10",
                    //                  timestamp:  1542891790123,
                    //                trade_price:  0.02917,
                    //               trade_volume:  7.392,
                    //         prev_closing_price:  0.02966,
                    //               change_price:  -0.00049,
                    //                    ask_bid: "ASK",
                    //              sequential_id:  15428917910540000 }  ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.privateGetOrdersChance(this.extend(request, params));
                    //
                    //     {
                    //         "bid_fee": "0.0005",
                    //         "ask_fee": "0.0005",
                    //         "maker_bid_fee": "0.0005",
                    //         "maker_ask_fee": "0.0005",
                    //         "market": {
                    //             "id": "KRW-BTC",
                    //             "name": "BTC/KRW",
                    //             "order_types": [ "limit" ],
                    //             "order_sides": [ "ask", "bid" ],
                    //             "bid": { "currency": "KRW", "price_unit": null, "min_total": 5000 },
                    //             "ask": { "currency": "BTC", "price_unit": null, "min_total": 5000 },
                    //             "max_total": "1000000000.0",
                    //             "state": "active"
                    //         },
                    //         "bid_account": {
                    //             "currency": "KRW",
                    //             "balance": "0.34202414",
                    //             "locked": "4999.99999922",
                    //             "avg_buy_price": "0",
                    //             "avg_buy_price_modified": true,
                    //             "unit_currency": "KRW"
                    //         },
                    //         "ask_account": {
                    //             "currency": "BTC",
                    //             "balance": "0.00048",
                    //             "locked": "0.0",
                    //             "avg_buy_price": "20870000",
                    //             "avg_buy_price_modified": false,
                    //             "unit_currency": "KRW"
                    //         }
                    //     }
                    //
                    const askFee = this.safeString(response, 'ask_fee');
                    const bidFee = this.safeString(response, 'bid_fee');
                    const taker = Precise.stringMax(askFee, bidFee);
                    const makerAskFee = this.safeString(response, 'maker_ask_fee');
                    const makerBidFee = this.safeString(response, 'maker_bid_fee');
                    const maker = Precise.stringMax(makerAskFee, makerBidFee);
                    return {
                        'info': response,
                        'symbol': symbol,
                        'maker': this.parseNumber(maker),
                        'taker': this.parseNumber(taker),
                        'percentage': true,
                        'tierBased': false
                    };
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         market: "BTC-ETH",
                    //         candle_date_time_utc: "2018-11-22T13:47:00",
                    //         candle_date_time_kst: "2018-11-22T22:47:00",
                    //         opening_price: 0.02915963,
                    //         high_price: 0.02915963,
                    //         low_price: 0.02915448,
                    //         trade_price: 0.02915448,
                    //         timestamp: 1542894473674,
                    //         candle_acc_trade_price: 0.0981629437535248,
                    //         candle_acc_trade_volume: 3.36693173,
                    //         unit: 1
                    //     }
                    //
                    return [
                        this.parse8601(this.safeString(ohlcv, 'candle_date_time_utc')),
                        this.safeNumber(ohlcv, 'opening_price'),
                        this.safeNumber(ohlcv, 'high_price'),
                        this.safeNumber(ohlcv, 'low_price'),
                        this.safeNumber(ohlcv, 'trade_price'),
                        this.safeNumber(ohlcv, 'candle_acc_trade_volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const timeframePeriod = this.parseTimeframe(timeframe);
                    const timeframeValue = this.timeframes[timeframe];
                    if (limit === undefined) limit = 200;
                    const request = {
                        'market': market['id'],
                        'timeframe': timeframeValue,
                        'count': limit
                    };
                    let method = 'publicGetCandlesTimeframe';
                    if (timeframeValue === 'minutes') {
                        const numMinutes = Math.round(timeframePeriod / 60);
                        request['unit'] = numMinutes;
                        method += 'Unit';
                    }
                    if (since !== undefined) // convert `since` to `to` value
                    request['to'] = this.iso8601(this.sum(since, timeframePeriod * limit * 1000));
                    const response = await this[method](this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             market: "BTC-ETH",
                    //             candle_date_time_utc: "2018-11-22T13:47:00",
                    //             candle_date_time_kst: "2018-11-22T22:47:00",
                    //             opening_price: 0.02915963,
                    //             high_price: 0.02915963,
                    //             low_price: 0.02915448,
                    //             trade_price: 0.02915448,
                    //             timestamp: 1542894473674,
                    //             candle_acc_trade_price: 0.0981629437535248,
                    //             candle_acc_trade_volume: 3.36693173,
                    //             unit: 1
                    //         },
                    //         {
                    //             market: "BTC-ETH",
                    //             candle_date_time_utc: "2018-11-22T10:06:00",
                    //             candle_date_time_kst: "2018-11-22T19:06:00",
                    //             opening_price: 0.0294,
                    //             high_price: 0.02940882,
                    //             low_price: 0.02934283,
                    //             trade_price: 0.02937354,
                    //             timestamp: 1542881219276,
                    //             candle_acc_trade_price: 0.0762597110943884,
                    //             candle_acc_trade_volume: 2.5949617,
                    //             unit: 1
                    //         }
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (type === 'market') {
                        // for market buy it requires the amount of quote currency to spend
                        if (side === 'buy') {
                            if (this.options['createMarketBuyOrderRequiresPrice']) {
                                if (price === undefined) throw new InvalidOrder(this.id + " createOrder() requires the price argument with market buy orders to calculate total order cost (amount to spend), where cost = amount * price. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount, or, alternatively, add .options['createMarketBuyOrderRequiresPrice'] = false to supply the cost in the amount argument (the exchange-specific behaviour)");
                                else amount = amount * price;
                            }
                        }
                    }
                    let orderSide = undefined;
                    if (side === 'buy') orderSide = 'bid';
                    else if (side === 'sell') orderSide = 'ask';
                    else throw new InvalidOrder(this.id + ' createOrder() allows buy or sell side only!');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'side': orderSide
                    };
                    if (type === 'limit') {
                        request['volume'] = this.amountToPrecision(symbol, amount);
                        request['price'] = this.priceToPrecision(symbol, price);
                        request['ord_type'] = type;
                    } else if (type === 'market') {
                        if (side === 'buy') {
                            request['ord_type'] = 'price';
                            request['price'] = this.priceToPrecision(symbol, amount);
                        } else if (side === 'sell') {
                            request['ord_type'] = type;
                            request['volume'] = this.amountToPrecision(symbol, amount);
                        }
                    }
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'identifier');
                    if (clientOrderId !== undefined) request['identifier'] = clientOrderId;
                    params = this.omit(params, [
                        'clientOrderId',
                        'identifier'
                    ]);
                    const response = await this.privatePostOrders(this.extend(request, params));
                    //
                    //     {
                    //         'uuid': 'cdd92199-2897-4e14-9448-f923320408ad',
                    //         'side': 'bid',
                    //         'ord_type': 'limit',
                    //         'price': '100.0',
                    //         'avg_price': '0.0',
                    //         'state': 'wait',
                    //         'market': 'KRW-BTC',
                    //         'created_at': '2018-04-10T15:42:23+09:00',
                    //         'volume': '0.01',
                    //         'remaining_volume': '0.01',
                    //         'reserved_fee': '0.0015',
                    //         'remaining_fee': '0.0015',
                    //         'paid_fee': '0.0',
                    //         'locked': '1.0015',
                    //         'executed_volume': '0.0',
                    //         'trades_count': 0
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'uuid': id
                    };
                    const response = await this.privateDeleteOrder(this.extend(request, params));
                    //
                    //     {
                    //         "uuid": "cdd92199-2897-4e14-9448-f923320408ad",
                    //         "side": "bid",
                    //         "ord_type": "limit",
                    //         "price": "100.0",
                    //         "state": "wait",
                    //         "market": "KRW-BTC",
                    //         "created_at": "2018-04-10T15:42:23+09:00",
                    //         "volume": "0.01",
                    //         "remaining_volume": "0.01",
                    //         "reserved_fee": "0.0015",
                    //         "remaining_fee": "0.0015",
                    //         "paid_fee": "0.0",
                    //         "locked": "1.0015",
                    //         "executed_volume": "0.0",
                    //         "trades_count": 0
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default is 100
                    const response = await this.privateGetDeposits(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "type": "deposit",
                    //             "uuid": "94332e99-3a87-4a35-ad98-28b0c969f830",
                    //             "currency": "KRW",
                    //             "txid": "9e37c537-6849-4c8b-a134-57313f5dfc5a",
                    //             "state": "ACCEPTED",
                    //             "created_at": "2017-12-08T15:38:02+09:00",
                    //             "done_at": "2017-12-08T15:38:02+09:00",
                    //             "amount": "100000.0",
                    //             "fee": "0.0"
                    //         },
                    //         ...,
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default is 100
                    const response = await this.privateGetWithdraws(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "type": "withdraw",
                    //             "uuid": "9f432943-54e0-40b7-825f-b6fec8b42b79",
                    //             "currency": "BTC",
                    //             "txid": null,
                    //             "state": "processing",
                    //             "created_at": "2018-04-13T11:24:01+09:00",
                    //             "done_at": null,
                    //             "amount": "0.01",
                    //             "fee": "0.0",
                    //             "krw_amount": "80420.0"
                    //         },
                    //         ...,
                    //     ]
                    //
                    return this.parseTransactions(response, currency, since, limit);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'submitting': 'pending',
                        'submitted': 'pending',
                        'almost_accepted': 'pending',
                        'rejected': 'failed',
                        'accepted': 'pending',
                        'processing': 'pending',
                        'done': 'ok',
                        'canceled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "type": "deposit",
                    //         "uuid": "94332e99-3a87-4a35-ad98-28b0c969f830",
                    //         "currency": "KRW",
                    //         "txid": "9e37c537-6849-4c8b-a134-57313f5dfc5a",
                    //         "state": "ACCEPTED",
                    //         "created_at": "2017-12-08T15:38:02+09:00",
                    //         "done_at": "2017-12-08T15:38:02+09:00",
                    //         "amount": "100000.0",
                    //         "fee": "0.0"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "type": "withdraw",
                    //         "uuid": "9f432943-54e0-40b7-825f-b6fec8b42b79",
                    //         "currency": "BTC",
                    //         "txid": "cd81e9b45df8da29f936836e58c907a106057e454a45767a7b06fcb19b966bba",
                    //         "state": "processing",
                    //         "created_at": "2018-04-13T11:24:01+09:00",
                    //         "done_at": null,
                    //         "amount": "0.01",
                    //         "fee": "0.0",
                    //         "krw_amount": "80420.0"
                    //     }
                    //
                    const id = this.safeString(transaction, 'uuid');
                    const amount = this.safeNumber(transaction, 'amount');
                    const address = undefined; // not present in the data structure received from the exchange
                    const tag = undefined; // not present in the data structure received from the exchange
                    const txid = this.safeString(transaction, 'txid');
                    const updated = this.parse8601(this.safeString(transaction, 'done_at'));
                    const timestamp = this.parse8601(this.safeString(transaction, 'created_at', updated));
                    let type = this.safeString(transaction, 'type');
                    if (type === 'withdraw') type = 'withdrawal';
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    const status = this.parseTransactionStatus(this.safeStringLower(transaction, 'state'));
                    const feeCost = this.safeNumber(transaction, 'fee');
                    return {
                        'info': transaction,
                        'id': id,
                        'currency': code,
                        'amount': amount,
                        'network': undefined,
                        'address': address,
                        'addressTo': undefined,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': undefined,
                        'tagFrom': undefined,
                        'status': status,
                        'type': type,
                        'updated': updated,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': {
                            'currency': code,
                            'cost': feeCost
                        }
                    };
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'wait': 'open',
                        'done': 'closed',
                        'cancel': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "uuid": "a08f09b1-1718-42e2-9358-f0e5e083d3ee",
                    //         "side": "bid",
                    //         "ord_type": "limit",
                    //         "price": "17417000.0",
                    //         "state": "done",
                    //         "market": "KRW-BTC",
                    //         "created_at": "2018-04-05T14:09:14+09:00",
                    //         "volume": "1.0",
                    //         "remaining_volume": "0.0",
                    //         "reserved_fee": "26125.5",
                    //         "remaining_fee": "25974.0",
                    //         "paid_fee": "151.5",
                    //         "locked": "17341974.0",
                    //         "executed_volume": "1.0",
                    //         "trades_count": 2,
                    //         "trades": [
                    //             {
                    //                 "market": "KRW-BTC",
                    //                 "uuid": "78162304-1a4d-4524-b9e6-c9a9e14d76c3",
                    //                 "price": "101000.0",
                    //                 "volume": "0.77368323",
                    //                 "funds": "78142.00623",
                    //                 "ask_fee": "117.213009345",
                    //                 "bid_fee": "117.213009345",
                    //                 "created_at": "2018-04-05T14:09:15+09:00",
                    //                 "side": "bid",
                    //             },
                    //             {
                    //                 "market": "KRW-BTC",
                    //                 "uuid": "f73da467-c42f-407d-92fa-e10d86450a20",
                    //                 "price": "101000.0",
                    //                 "volume": "0.22631677",
                    //                 "funds": "22857.99377",
                    //                 "ask_fee": "34.286990655", // missing in market orders
                    //                 "bid_fee": "34.286990655", // missing in market orders
                    //                 "created_at": "2018-04-05T14:09:15+09:00", // missing in market orders
                    //                 "side": "bid",
                    //             },
                    //         ],
                    //     }
                    //
                    const id = this.safeString(order, 'uuid');
                    let side = this.safeString(order, 'side');
                    if (side === 'bid') side = 'buy';
                    else side = 'sell';
                    let type = this.safeString(order, 'ord_type');
                    const timestamp = this.parse8601(this.safeString(order, 'created_at'));
                    const status = this.parseOrderStatus(this.safeString(order, 'state'));
                    let lastTradeTimestamp = undefined;
                    let price = this.safeNumber(order, 'price');
                    const amount = this.safeNumber(order, 'volume');
                    const remaining = this.safeNumber(order, 'remaining_volume');
                    const filled = this.safeNumber(order, 'executed_volume');
                    let cost = undefined;
                    if (type === 'price') {
                        type = 'market';
                        cost = price;
                        price = undefined;
                    }
                    let average = undefined;
                    let fee = undefined;
                    let feeCost = this.safeNumber(order, 'paid_fee');
                    const marketId = this.safeString(order, 'market');
                    market = this.safeMarket(marketId, market);
                    let trades = this.safeValue(order, 'trades', []);
                    trades = this.parseTrades(trades, market, undefined, undefined, {
                        'order': id,
                        'type': type
                    });
                    const numTrades = trades.length;
                    if (numTrades > 0) {
                        // the timestamp in fetchOrder trades is missing
                        lastTradeTimestamp = trades[numTrades - 1]['timestamp'];
                        let getFeesFromTrades = false;
                        if (feeCost === undefined) {
                            getFeesFromTrades = true;
                            feeCost = 0;
                        }
                        cost = 0;
                        for(let i = 0; i < numTrades; i++){
                            const trade = trades[i];
                            cost = this.sum(cost, trade['cost']);
                            if (getFeesFromTrades) {
                                const tradeFee = this.safeValue(trades[i], 'fee', {});
                                const tradeFeeCost = this.safeNumber(tradeFee, 'cost');
                                if (tradeFeeCost !== undefined) feeCost = this.sum(feeCost, tradeFeeCost);
                            }
                        }
                        average = cost / filled;
                    }
                    if (feeCost !== undefined) fee = {
                        'currency': market['quote'],
                        'cost': feeCost
                    };
                    const result = {
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'symbol': market['symbol'],
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': cost,
                        'average': average,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': fee,
                        'trades': trades
                    };
                    return result;
                }
                async fetchOrdersByState(state, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        // 'market': this.marketId (symbol),
                        'state': state
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market'] = market['id'];
                    }
                    const response = await this.privateGetOrders(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "uuid": "a08f09b1-1718-42e2-9358-f0e5e083d3ee",
                    //             "side": "bid",
                    //             "ord_type": "limit",
                    //             "price": "17417000.0",
                    //             "state": "done",
                    //             "market": "KRW-BTC",
                    //             "created_at": "2018-04-05T14:09:14+09:00",
                    //             "volume": "1.0",
                    //             "remaining_volume": "0.0",
                    //             "reserved_fee": "26125.5",
                    //             "remaining_fee": "25974.0",
                    //             "paid_fee": "151.5",
                    //             "locked": "17341974.0",
                    //             "executed_volume": "1.0",
                    //             "trades_count":2
                    //         },
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByState('wait', symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByState('done', symbol, since, limit, params);
                }
                async fetchCanceledOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersByState('cancel', symbol, since, limit, params);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'uuid': id
                    };
                    const response = await this.privateGetOrder(this.extend(request, params));
                    //
                    //     {
                    //         "uuid": "a08f09b1-1718-42e2-9358-f0e5e083d3ee",
                    //         "side": "bid",
                    //         "ord_type": "limit",
                    //         "price": "17417000.0",
                    //         "state": "done",
                    //         "market": "KRW-BTC",
                    //         "created_at": "2018-04-05T14:09:14+09:00",
                    //         "volume": "1.0",
                    //         "remaining_volume": "0.0",
                    //         "reserved_fee": "26125.5",
                    //         "remaining_fee": "25974.0",
                    //         "paid_fee": "151.5",
                    //         "locked": "17341974.0",
                    //         "executed_volume": "1.0",
                    //         "trades_count": 2,
                    //         "trades": [
                    //             {
                    //                 "market": "KRW-BTC",
                    //                 "uuid": "78162304-1a4d-4524-b9e6-c9a9e14d76c3",
                    //                 "price": "101000.0",
                    //                 "volume": "0.77368323",
                    //                 "funds": "78142.00623",
                    //                 "ask_fee": "117.213009345",
                    //                 "bid_fee": "117.213009345",
                    //                 "created_at": "2018-04-05T14:09:15+09:00",
                    //                 "side": "bid"
                    //             },
                    //             {
                    //                 "market": "KRW-BTC",
                    //                 "uuid": "f73da467-c42f-407d-92fa-e10d86450a20",
                    //                 "price": "101000.0",
                    //                 "volume": "0.22631677",
                    //                 "funds": "22857.99377",
                    //                 "ask_fee": "34.286990655",
                    //                 "bid_fee": "34.286990655",
                    //                 "created_at": "2018-04-05T14:09:15+09:00",
                    //                 "side": "bid"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseOrder(response);
                }
                async fetchDepositAddresses(codes, params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetDepositsCoinAddresses(params);
                    //
                    //     [
                    //         {
                    //             "currency": "BTC",
                    //             "deposit_address": "3EusRwybuZUhVDeHL7gh3HSLmbhLcy7NqD",
                    //             "secondary_address": null
                    //         },
                    //         {
                    //             "currency": "ETH",
                    //             "deposit_address": "0x0d73e0a482b8cf568976d2e8688f4a899d29301c",
                    //             "secondary_address": null
                    //         },
                    //         {
                    //             "currency": "XRP",
                    //             "deposit_address": "rN9qNpgnBaZwqCg8CvUZRPqCcPPY7wfWep",
                    //             "secondary_address": "3057887915"
                    //         }
                    //     ]
                    //
                    return this.parseDepositAddresses(response);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    //     {
                    //         "currency": "BTC",
                    //         "deposit_address": "3EusRwybuZUhVDeHL7gh3HSLmbhLcy7NqD",
                    //         "secondary_address": null
                    //     }
                    //
                    const address = this.safeString(depositAddress, 'deposit_address');
                    const tag = this.safeString(depositAddress, 'secondary_address');
                    const currencyId = this.safeString(depositAddress, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': depositAddress
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const response = await this.privateGetDepositsCoinAddress(this.extend({
                        'currency': currency['id']
                    }, params));
                    //
                    //     {
                    //         "currency": "BTC",
                    //         "deposit_address": "3EusRwybuZUhVDeHL7gh3HSLmbhLcy7NqD",
                    //         "secondary_address": null
                    //     }
                    //
                    return this.parseDepositAddress(response);
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    // https://github.com/ccxt/ccxt/issues/6452
                    const response = await this.privatePostDepositsGenerateCoinAddress(this.extend(request, params));
                    //
                    // https://docs.upbit.com/v1.0/reference#%EC%9E%85%EA%B8%88-%EC%A3%BC%EC%86%8C-%EC%83%9D%EC%84%B1-%EC%9A%94%EC%B2%AD
                    // can be any of the two responses:
                    //
                    //     {
                    //         "success" : true,
                    //         "message" : "Creating BTC deposit address."
                    //     }
                    //
                    //     {
                    //         "currency": "BTC",
                    //         "deposit_address": "3EusRwybuZUhVDeHL7gh3HSLmbhLcy7NqD",
                    //         "secondary_address": null
                    //     }
                    //
                    const message = this.safeString(response, 'message');
                    if (message !== undefined) throw new AddressPending(this.id + ' is generating ' + code + ' deposit address, call fetchDepositAddress or createDepositAddress one more time later to retrieve the generated address');
                    return this.parseDepositAddress(response);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'amount': amount
                    };
                    let method = 'privatePostWithdraws';
                    if (code !== 'KRW') {
                        method += 'Coin';
                        request['currency'] = currency['id'];
                        request['address'] = address;
                        if (tag !== undefined) request['secondary_address'] = tag;
                    } else method += 'Krw';
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "type": "withdraw",
                    //         "uuid": "9f432943-54e0-40b7-825f-b6fec8b42b79",
                    //         "currency": "BTC",
                    //         "txid": "ebe6937b-130e-4066-8ac6-4b0e67f28adc",
                    //         "state": "processing",
                    //         "created_at": "2018-04-13T11:24:01+09:00",
                    //         "done_at": null,
                    //         "amount": "0.01",
                    //         "fee": "0.0",
                    //         "krw_amount": "80420.0"
                    //     }
                    //
                    return this.parseTransaction(response);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.implodeParams(this.urls['api'][api], {
                        'hostname': this.hostname
                    });
                    url += '/' + this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (method !== 'POST') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    }
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce();
                        const request = {
                            'access_key': this.apiKey,
                            'nonce': nonce
                        };
                        if (Object.keys(query).length) {
                            const auth = this.urlencode(query);
                            const hash = this.hash(this.encode(auth), 'sha512');
                            request['query_hash'] = hash;
                            request['query_hash_alg'] = 'SHA512';
                        }
                        const jwt = this.jwt(request, this.encode(this.secret));
                        headers = {
                            'Authorization': 'Bearer ' + jwt
                        };
                        if (method !== 'GET' && method !== 'DELETE') {
                            body = this.json(params);
                            headers['Content-Type'] = 'application/json';
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    //
                    //   { 'error': { 'message': "Missing request parameter error. Check the required parameters!", 'name': 400 } },
                    //   { 'error': { 'message': "side is missing, side does not have a valid value", 'name': "validation_error" } },
                    //   { 'error': { 'message': "개인정보 제 3자 제공 동의가 필요합니다.", 'name': "thirdparty_agreement_required" } },
                    //   { 'error': { 'message': "권한이 부족합니다.", 'name': "out_of_scope" } },
                    //   { 'error': { 'message': "주문을 찾지 못했습니다.", 'name': "order_not_found" } },
                    //   { 'error': { 'message': "주문가능한 금액(ETH)이 부족합니다.", 'name': "insufficient_funds_ask" } },
                    //   { 'error': { 'message': "주문가능한 금액(BTC)이 부족합니다.", 'name': "insufficient_funds_bid" } },
                    //   { 'error': { 'message': "잘못된 엑세스 키입니다.", 'name': "invalid_access_key" } },
                    //   { 'error': { 'message': "Jwt 토큰 검증에 실패했습니다.", 'name': "jwt_verification" } }
                    //
                    const error = this.safeValue(response, 'error');
                    if (error !== undefined) {
                        const message = this.safeString(error, 'message');
                        const name = this.safeString(error, 'name');
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], name, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], name, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    166: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, OrderNotFound: OrderNotFound, InvalidOrder: InvalidOrder, BadRequest: BadRequest, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded, RequestTimeout: RequestTimeout, BadSymbol: BadSymbol, AddressPending: AddressPending, PermissionDenied: PermissionDenied, InsufficientFunds: InsufficientFunds } = require1('./base/errors');
            const { ROUND: ROUND } = require1('./base/functions/number');
            const Precise = require1('./base/Precise');
            // ---------------------------------------------------------------------------
            module.exports = class vcc extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'vcc',
                        'name': 'VCC Exchange',
                        'countries': [
                            'VN'
                        ],
                        'rateLimit': 1000,
                        'version': 'v3',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': undefined,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': undefined,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': 'emulated',
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': true,
                            'fetchTradingFees': undefined,
                            'fetchTransactions': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawals': true,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': false,
                            'withdraw': false
                        },
                        'timeframes': {
                            '1m': '60000',
                            '5m': '300000',
                            '15m': '900000',
                            '30m': '1800000',
                            '1h': '3600000',
                            '2h': '7200000',
                            '4h': '14400000',
                            '6h': '21600000',
                            '12h': '43200000',
                            '1d': '86400000',
                            '1w': '604800000'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/100545356-8427f500-326c-11eb-9539-7d338242d61b.jpg',
                            'api': {
                                'public': 'https://api.vcc.exchange',
                                'private': 'https://api.vcc.exchange'
                            },
                            'www': 'https://vcc.exchange',
                            'doc': [
                                'https://vcc.exchange/api'
                            ],
                            'fees': 'https://support.vcc.exchange/hc/en-us/articles/360016401754',
                            'referral': 'https://vcc.exchange?ref=l4xhrH'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    'summary',
                                    'exchange_info',
                                    'assets',
                                    'ticker',
                                    'trades/{market_pair}',
                                    'orderbook/{market_pair}',
                                    'chart/bars',
                                    'tick_sizes'
                                ]
                            },
                            'private': {
                                'get': [
                                    'user',
                                    'balance',
                                    'orders/{order_id}',
                                    'orders/open',
                                    'orders',
                                    'orders/trades',
                                    'deposit-address',
                                    'transactions'
                                ],
                                'post': [
                                    'orders'
                                ],
                                'put': [
                                    'orders/{order_id}/cancel',
                                    'orders/cancel-by-type',
                                    'orders/cancel-all'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'maker': this.parseNumber('0.002'),
                                'taker': this.parseNumber('0.002')
                            }
                        },
                        'exceptions': {
                            'exact': {},
                            'broad': {
                                'limit may not be greater than': BadRequest,
                                'Insufficient balance': InsufficientFunds,
                                'Unauthenticated': AuthenticationError,
                                'signature is invalid': AuthenticationError,
                                'Timeout': RequestTimeout,
                                'Too many requests': RateLimitExceeded,
                                'quantity field is required': InvalidOrder,
                                'price field is required': InvalidOrder,
                                'error_security_level': PermissionDenied,
                                'pair is invalid': BadSymbol,
                                // {"message":"The given data was invalid.","errors":{"type":["The selected type is invalid."]}}
                                // {"message":"The given data was invalid.","errors":{"trade_type":["The selected trade type is invalid."]}}
                                'type is invalid': InvalidOrder,
                                'Data not found': OrderNotFound
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetExchangeInfo(params);
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"4677e56a42f0c29872f3a6e75f5d39d2f07c748c",
                    //         "data":{
                    //             "timezone":"UTC",
                    //             "serverTime":1605821914333,
                    //             "symbols":[
                    //                 {
                    //                     "id":"btcvnd",
                    //                     "symbol":"BTC\/VND",
                    //                     "coin":"btc",
                    //                     "currency":"vnd",
                    //                     "baseId":1,
                    //                     "quoteId":0,
                    //                     "active":true,
                    //                     "base_precision":"0.0000010000",
                    //                     "quote_precision":"1.0000000000",
                    //                     "minimum_quantity":"0.0000010000",
                    //                     "minimum_amount":"250000.0000000000",
                    //                     "precision":{"price":0,"amount":6,"cost":6},
                    //                     "limits":{
                    //                         "amount":{"min":"0.0000010000"},
                    //                         "price":{"min":"1.0000000000"},
                    //                         "cost":{"min":"250000.0000000000"},
                    //                     },
                    //                 },
                    //             ],
                    //         },
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const markets = this.safeValue(data, 'symbols');
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = this.safeValue(markets, i);
                        const symbol = this.safeString(market, 'symbol');
                        const id = symbol.replace('/', '_');
                        const baseId = this.safeString(market, 'coin');
                        const quoteId = this.safeString(market, 'currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const precision = this.safeValue(market, 'precision', {});
                        const limits = this.safeValue(market, 'limits', {});
                        const amountLimits = this.safeValue(limits, 'amount', {});
                        const priceLimits = this.safeValue(limits, 'price', {});
                        const costLimits = this.safeValue(limits, 'cost', {});
                        const entry = {
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settledId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': this.safeValue(market, 'active'),
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(precision, 'amount'),
                                'price': this.safeInteger(precision, 'price'),
                                'cost': this.safeInteger(precision, 'cost')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(amountLimits, 'min'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': this.safeNumber(priceLimits, 'min'),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(costLimits, 'min'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        };
                        result.push(entry);
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetAssets(params);
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"2514c8012d94ea375018fc13e0b5d4d896e435df",
                    //         "data":{
                    //             "BTC":{
                    //                 "name":"Bitcoin",
                    //                 "unified_cryptoasset_id":1,
                    //                 "can_withdraw":1,
                    //                 "can_deposit":1,
                    //                 "min_withdraw":"0.0011250000",
                    //                 "max_withdraw":"100.0000000000",
                    //                 "maker_fee":"0.002",
                    //                 "taker_fee":"0.002",
                    //                 "decimal":8,
                    //                 "withdrawal_fee":"0.0006250000",
                    //             },
                    //         },
                    //     }
                    //
                    const result = {};
                    const data = this.safeValue(response, 'data');
                    const ids = Object.keys(data);
                    for(let i = 0; i < ids.length; i++){
                        const id = this.safeStringLower(ids, i);
                        const currency = this.safeValue(data, ids[i]);
                        const code = this.safeCurrencyCode(id);
                        const canDeposit = this.safeInteger(currency, 'can_deposit');
                        const canWithdraw = this.safeInteger(currency, 'can_withdraw');
                        const active = canDeposit && canWithdraw;
                        const depositEnabled = canDeposit === 1;
                        const withdrawEnabled = canWithdraw === 1;
                        result[code] = {
                            'id': id,
                            'code': code,
                            'name': this.safeString(currency, 'name'),
                            'active': active,
                            'deposit': depositEnabled,
                            'withdraw': withdrawEnabled,
                            'fee': this.safeNumber(currency, 'withdrawal_fee'),
                            'precision': this.safeInteger(currency, 'decimal'),
                            'limits': {
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'min_withdraw'),
                                    'max': this.safeNumber(currency, 'max_withdraw')
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchTradingFee(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = this.extend({
                        'symbol': market['id']
                    }, this.omit(params, 'symbol'));
                    const response = await this.privateGetTradingFeeSymbol(request);
                    //
                    //     {
                    //         takeLiquidityRate: '0.001',
                    //         provideLiquidityRate: '-0.0001'
                    //     }
                    //
                    return {
                        'info': response,
                        'maker': this.safeNumber(response, 'provideLiquidityRate'),
                        'taker': this.safeNumber(response, 'takeLiquidityRate')
                    };
                }
                parseBalance(response) {
                    const data = this.safeValue(response, 'data');
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const currencyIds = Object.keys(data);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const balance = this.safeValue(data, currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available_balance');
                        account['total'] = this.safeString(balance, 'balance');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetBalance(params);
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"7168e6c99e90f60673070944d987988eef7d91fa",
                    //         "data":{
                    //             "vnd":{"balance":0,"available_balance":0},
                    //             "btc":{"balance":0,"available_balance":0},
                    //             "eth":{"balance":0,"available_balance":0},
                    //         },
                    //     }
                    //
                    return this.parseBalance(response);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "low":"415805323.0000000000",
                    //         "high":"415805323.0000000000",
                    //         "open":"415805323.0000000000",
                    //         "close":"415805323.0000000000",
                    //         "time":"1605845940000",
                    //         "volume":"0.0065930000",
                    //         "opening_time":1605845963263,
                    //         "closing_time":1605845963263
                    //     }
                    //
                    return [
                        this.safeInteger(ohlcv, 'time'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'coin': market['baseId'],
                        'currency': market['quoteId'],
                        'resolution': this.timeframes[timeframe]
                    };
                    limit = limit === undefined ? 100 : limit;
                    limit = Math.min(100, limit);
                    const duration = this.parseTimeframe(timeframe);
                    if (since === undefined) {
                        const end = this.seconds();
                        request['to'] = end;
                        request['from'] = end - limit * duration;
                    } else {
                        const start = parseInt(since / 1000);
                        request['from'] = start;
                        request['to'] = this.sum(start, limit * duration);
                    }
                    const response = await this.publicGetChartBars(this.extend(request, params));
                    //
                    //     [
                    //         {"low":"415805323.0000000000","high":"415805323.0000000000","open":"415805323.0000000000","close":"415805323.0000000000","time":"1605845940000","volume":"0.0065930000","opening_time":1605845963263,"closing_time":1605845963263},
                    //         {"low":"416344148.0000000000","high":"416344148.0000000000","open":"415805323.0000000000","close":"416344148.0000000000","time":"1605846000000","volume":"0.0052810000","opening_time":1605846011490,"closing_time":1605846011490},
                    //         {"low":"416299269.0000000000","high":"417278376.0000000000","open":"416344148.0000000000","close":"417278376.0000000000","time":"1605846060000","volume":"0.0136750000","opening_time":1605846070727,"closing_time":1605846102282},
                    //     ]
                    //
                    return this.parseOHLCVs(response, market, timeframe, since, limit);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_pair': market['id'],
                        // 'depth': 0, // 0 = full orderbook, 5, 10, 20, 50, 100, 500
                        'level': 2
                    };
                    if (limit !== undefined) {
                        if (limit !== 0 && limit !== 5 && limit !== 10 && limit !== 20 && limit !== 50 && limit !== 100 && limit !== 500) throw new BadRequest(this.id + ' fetchOrderBook() limit must be 0, 5, 10, 20, 50, 100, 500 if specified');
                        request['depth'] = limit;
                    }
                    const response = await this.publicGetOrderbookMarketPair(this.extend(request, params));
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"376cee43af26deabcd3762ab11a876b6e7a71e82",
                    //         "data":{
                    //             "bids":[
                    //                 ["413342637.0000000000","0.165089"],
                    //                 ["413274576.0000000000","0.03"],
                    //                 ["413274574.0000000000","0.03"],
                    //             ],
                    //             "asks":[
                    //                 ["416979125.0000000000","0.122835"],
                    //                 ["417248934.0000000000","0.030006"],
                    //                 ["417458879.0000000000","0.1517"],
                    //             ],
                    //             "timestamp":"1605841619147"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const timestamp = this.safeValue(data, 'timestamp');
                    return this.parseOrderBook(data, symbol, timestamp, 'bids', 'asks', 0, 1);
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "base_id":1,
                    //         "quote_id":0,
                    //         "last_price":"411119457",
                    //         "max_price":"419893173.0000000000",
                    //         "min_price":"401292577.0000000000",
                    //         "open_price":null,
                    //         "base_volume":"10.5915050000",
                    //         "quote_volume":"4367495977.4484430060",
                    //         "isFrozen":0
                    //     }
                    //
                    const timestamp = this.milliseconds();
                    const baseVolume = this.safeString(ticker, 'base_volume');
                    const quoteVolume = this.safeString(ticker, 'quote_volume');
                    const open = this.safeString(ticker, 'open_price');
                    const last = this.safeString(ticker, 'last_price');
                    const symbol = this.safeSymbol(undefined, market);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'max_price'),
                        'low': this.safeString(ticker, 'min_price'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetTicker(params);
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"fc521161aebe506178b8588cd2adb598eaf1018e",
                    //         "data":{
                    //             "BTC_VND":{
                    //                 "base_id":1,
                    //                 "quote_id":0,
                    //                 "last_price":"411119457",
                    //                 "max_price":"419893173.0000000000",
                    //                 "min_price":"401292577.0000000000",
                    //                 "open_price":null,
                    //                 "base_volume":"10.5915050000",
                    //                 "quote_volume":"4367495977.4484430060",
                    //                 "isFrozen":0
                    //             },
                    //         }
                    //     }
                    //
                    const result = {};
                    const data = this.safeValue(response, 'data');
                    const marketIds = Object.keys(data);
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const market = this.safeMarket(marketId, undefined, '_');
                        const symbol = market['symbol'];
                        result[symbol] = this.parseTicker(data[marketId], market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                parseTrade(trade, market) {
                    //
                    // public fetchTrades
                    //
                    //     {
                    //         "trade_id":181509285,
                    //         "price":"415933022.0000000000",
                    //         "base_volume":"0.0022080000",
                    //         "quote_volume":"918380.1125760000",
                    //         "trade_timestamp":1605842150357,
                    //         "type":"buy",
                    //     }
                    //
                    // private fetchMyTrades
                    //
                    //     {
                    //         "trade_type":"sell",
                    //         "fee":"0.0610578086",
                    //         "id":1483372,
                    //         "created_at":1606581578368,
                    //         "currency":"usdt",
                    //         "coin":"btc",
                    //         "price":"17667.1900000000",
                    //         "quantity":"0.0017280000",
                    //         "amount":"30.5289043200",
                    //     }
                    //
                    const timestamp = this.safeInteger2(trade, 'trade_timestamp', 'created_at');
                    const baseId = this.safeStringUpper(trade, 'coin');
                    const quoteId = this.safeStringUpper(trade, 'currency');
                    let marketId = undefined;
                    if (baseId !== undefined && quoteId !== undefined) marketId = baseId + '_' + quoteId;
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString2(trade, 'base_volume', 'quantity');
                    const price = this.parseNumber(priceString);
                    const amount = this.parseNumber(amountString);
                    let cost = this.safeNumber2(trade, 'quote_volume', 'amount');
                    if (cost === undefined) cost = this.parseNumber(Precise.stringMul(priceString, amountString));
                    const side = this.safeString2(trade, 'type', 'trade_type');
                    const id = this.safeString2(trade, 'trade_id', 'id');
                    const feeCost = this.safeNumber(trade, 'fee');
                    let fee = undefined;
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': market['quote']
                    };
                    return {
                        'info': trade,
                        'id': id,
                        'order': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': fee
                    };
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market_pair': market['id']
                    };
                    if (limit !== undefined) request['count'] = Math.min(1000, limit);
                    const response = await this.publicGetTradesMarketPair(this.extend(request, params));
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"1f811b533143f739008a3e4ecaaab2ec82ea50d4",
                    //         "data":[
                    //             {
                    //                 "trade_id":181509285,
                    //                 "price":"415933022.0000000000",
                    //                 "base_volume":"0.0022080000",
                    //                 "quote_volume":"918380.1125760000",
                    //                 "trade_timestamp":1605842150357,
                    //                 "type":"buy",
                    //             },
                    //         ],
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['limit'] = Math.min(1000, limit);
                    if (since !== undefined) request['start'] = since;
                    const response = await this.privateGetTransactions(this.extend(request, params));
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"1fdfb0ec85b666871d62fe59d098d01839b05e97",
                    //         "data":{
                    //             "current_page":1,
                    //             "data":[
                    //                 {
                    //                     "id":85391,
                    //                     "user_id":253063,
                    //                     "transaction_id":"0x885719cee5910ca509a223d208797510e80eb27a2f1d51a71bb4ccb82d538131",
                    //                     "internal_transaction_id":null,
                    //                     "temp_transaction_id":"2367",
                    //                     "currency":"usdt",
                    //                     "amount":"30.0000000000",
                    //                     "btc_amount":"0.0000000000",
                    //                     "usdt_amount":"0.0000000000",
                    //                     "fee":"0.0000000000",
                    //                     "tx_cost":"0.0000000000",
                    //                     "confirmation":0,
                    //                     "deposit_code":null,
                    //                     "status":"success",
                    //                     "bank_name":null,
                    //                     "foreign_bank_account":null,
                    //                     "foreign_bank_account_holder":null,
                    //                     "blockchain_address":"0xd54b84AD27E4c4a8C9E0b2b53701DeFc728f6E44",
                    //                     "destination_tag":null,
                    //                     "error_detail":null,
                    //                     "refunded":"0.0000000000",
                    //                     "transaction_date":"2020-11-28",
                    //                     "transaction_timestamp":"1606563143.959",
                    //                     "created_at":1606563143959,
                    //                     "updated_at":1606563143959,
                    //                     "transaction_email_timestamp":0,
                    //                     "network":null,
                    //                     "collect_tx_id":null,
                    //                     "collect_id":null
                    //                 }
                    //             ],
                    //             "first_page_url":"http:\/\/api.vcc.exchange\/v3\/transactions?page=1",
                    //             "from":1,
                    //             "last_page":1,
                    //             "last_page_url":"http:\/\/api.vcc.exchange\/v3\/transactions?page=1",
                    //             "next_page_url":null,
                    //             "path":"http:\/\/api.vcc.exchange\/v3\/transactions",
                    //             "per_page":10,
                    //             "prev_page_url":null,
                    //             "to":1,
                    //             "total":1
                    //         }
                    //     }
                    //
                    let data = this.safeValue(response, 'data', {});
                    data = this.safeValue(data, 'data', []);
                    return this.parseTransactions(data, currency, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    const request = {
                        'type': 'deposit'
                    };
                    return await this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    const request = {
                        'type': 'withdraw'
                    };
                    return await this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                parseTransaction(transaction, currency) {
                    //
                    // fetchTransactions, fetchDeposits, fetchWithdrawals
                    //
                    //     {
                    //         "id":85391,
                    //         "user_id":253063,
                    //         "transaction_id":"0x885719cee5910ca509a223d208797510e80eb27a2f1d51a71bb4ccb82d538131",
                    //         "internal_transaction_id":null,
                    //         "temp_transaction_id":"2367",
                    //         "currency":"usdt",
                    //         "amount":"30.0000000000",
                    //         "btc_amount":"0.0000000000",
                    //         "usdt_amount":"0.0000000000",
                    //         "fee":"0.0000000000",
                    //         "tx_cost":"0.0000000000",
                    //         "confirmation":0,
                    //         "deposit_code":null,
                    //         "status":"success",
                    //         "bank_name":null,
                    //         "foreign_bank_account":null,
                    //         "foreign_bank_account_holder":null,
                    //         "blockchain_address":"0xd54b84AD27E4c4a8C9E0b2b53701DeFc728f6E44",
                    //         "destination_tag":null,
                    //         "error_detail":null,
                    //         "refunded":"0.0000000000",
                    //         "transaction_date":"2020-11-28",
                    //         "transaction_timestamp":"1606563143.959",
                    //         "created_at":1606563143959,
                    //         "updated_at":1606563143959,
                    //         "transaction_email_timestamp":0,
                    //         "network":null,
                    //         "collect_tx_id":null,
                    //         "collect_id":null
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const timestamp = this.safeInteger(transaction, 'created_at');
                    const updated = this.safeInteger(transaction, 'updated_at');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    let amount = this.safeNumber(transaction, 'amount');
                    if (amount !== undefined) amount = Math.abs(amount);
                    const address = this.safeString(transaction, 'blockchain_address');
                    const txid = this.safeString(transaction, 'transaction_id');
                    const tag = this.safeString(transaction, 'destination_tag');
                    let fee = undefined;
                    const feeCost = this.safeNumber(transaction, 'fee');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    const type = amount > 0 ? 'deposit' : 'withdrawal';
                    const network = this.safeString(transaction, 'network');
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'address': address,
                        'addressTo': address,
                        'addressFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'tagFrom': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'pending': 'pending',
                        'error': 'failed',
                        'success': 'ok',
                        'cancel': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransactionType(type) {
                    const types = {
                        'deposit': 'deposit',
                        'withdraw': 'withdrawal'
                    };
                    return this.safeString(types, type, type);
                }
                costToPrecision(symbol, cost) {
                    return this.decimalToPrecision(cost, ROUND, this.markets[symbol]['precision']['cost'], this.precisionMode, this.paddingMode);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'coin': market['baseId'],
                        'currency': market['quoteId'],
                        'trade_type': side,
                        'type': type
                    };
                    if (type === 'ceiling_market') {
                        const ceiling = this.safeValue(params, 'ceiling');
                        if (ceiling !== undefined) request['ceiling'] = this.costToPrecision(symbol, ceiling);
                        else if (price !== undefined) request['ceiling'] = this.costToPrecision(symbol, amount * price);
                        else throw new InvalidOrder(this.id + ' createOrder() requires a price argument or a ceiling parameter for ' + type + ' orders');
                    } else request['quantity'] = this.amountToPrecision(symbol, amount);
                    if (type === 'limit') request['price'] = this.priceToPrecision(symbol, price);
                    const stopPrice = this.safeValue2(params, 'stop_price', 'stopPrice');
                    if (stopPrice !== undefined) {
                        request['is_stop'] = 1;
                        request['stop_condition'] = side === 'buy' ? 'le' : 'ge'; // ge = greater than or equal, le = less than or equal
                        request['stop_price'] = this.priceToPrecision(symbol, stopPrice);
                    }
                    params = this.omit(params, [
                        'stop_price',
                        'stopPrice'
                    ]);
                    const response = await this.privatePostOrders(this.extend(request, params));
                    //
                    // ceiling_market order
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"213fc0d433f38307f736cae1cbda4cc310469b7a",
                    //         "data":{
                    //             "coin":"btc",
                    //             "currency":"usdt",
                    //             "trade_type":"buy",
                    //             "type":"ceiling_market",
                    //             "ceiling":"30",
                    //             "user_id":253063,
                    //             "email":"igor.kroitor@gmail.com",
                    //             "side":"buy",
                    //             "quantity":"0.00172800",
                    //             "status":"pending",
                    //             "fee":0,
                    //             "created_at":1606571333035,
                    //             "updated_at":1606571333035,
                    //             "instrument_symbol":"BTCUSDT",
                    //             "remaining":"0.00172800",
                    //             "fee_rate":"0.002",
                    //             "id":88214435
                    //         }
                    //     }
                    //
                    // limit order
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"d9b1159d2bcefa2388be156e32ddc7cc324400ee",
                    //         "data":{
                    //             "id":41230,
                    //             "trade_type":"sell",
                    //             "type":"limit",
                    //             "quantity":"1",
                    //             "price":"14.99",
                    //             "currency":"usdt",
                    //             "coin":"neo",
                    //             "status":"pending",
                    //             "is_stop": "1",
                    //             "stop_price": "13",
                    //             "stop_condition": "ge",
                    //             "fee":0,
                    //             "created_at":1560244052168,
                    //             "updated_at":1560244052168
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privatePutOrdersOrderIdCancel(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async cancelAllOrders(symbol, params = {}) {
                    const type = this.safeString(params, 'type');
                    const method = type === undefined ? 'privatePutOrdersCancelAll' : 'privatePutOrdersCancelByType';
                    const request = {};
                    if (type !== undefined) request['type'] = type;
                    await this.loadMarkets();
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "dataVersion":"6d72fb82a9c613c8166581a887e1723ce5a937ff",
                    //         "data":{
                    //             "data":[
                    //                 {
                    //                     "id":410,
                    //                     "trade_type":"sell",
                    //                     "currency":"usdt",
                    //                     "coin":"neo",
                    //                     "type":"limit",
                    //                     "quantity":"1.0000000000",
                    //                     "price":"14.9900000000",
                    //                     "executed_quantity":"0.0000000000",
                    //                     "executed_price":"0.0000000000",
                    //                     "fee":"0.0000000000",
                    //                     "status":"canceled",
                    //                     "created_at":1560244052168,
                    //                     "updated_at":1560244052168,
                    //                 },
                    //             ],
                    //         },
                    //     }
                    //
                    let data = this.safeValue(response, 'data', {});
                    data = this.safeValue(response, 'data', []);
                    return this.parseOrders(data);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'pending': 'open',
                        'stopping': 'open',
                        'executing': 'open',
                        'executed': 'closed',
                        'canceled': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // ceiling_market
                    //
                    //     {
                    //         "coin":"btc",
                    //         "currency":"usdt",
                    //         "trade_type":"buy",
                    //         "type":"ceiling_market",
                    //         "ceiling":"30",
                    //         "user_id":253063,
                    //         "email":"igor.kroitor@gmail.com",
                    //         "side":"buy",
                    //         "quantity":"0.00172800",
                    //         "status":"pending",
                    //         "fee":0,
                    //         "created_at":1606571333035,
                    //         "updated_at":1606571333035,
                    //         "instrument_symbol":"BTCUSDT",
                    //         "remaining":"0.00172800",
                    //         "fee_rate":"0.002",
                    //         "id":88214435
                    //     }
                    //
                    // limit order
                    //
                    //     {
                    //         "id":41230,
                    //         "trade_type":"sell",
                    //         "type":"limit",
                    //         "quantity":"1",
                    //         "price":"14.99",
                    //         "currency":"usdt",
                    //         "coin":"neo",
                    //         "status":"pending",
                    //         "is_stop": "1",
                    //         "stop_price": "13",
                    //         "stop_condition": "ge",
                    //         "fee":0,
                    //         "created_at":1560244052168,
                    //         "updated_at":1560244052168
                    //     }
                    //
                    const created = this.safeValue(order, 'created_at');
                    const updated = this.safeValue(order, 'updated_at');
                    const baseId = this.safeStringUpper(order, 'coin');
                    const quoteId = this.safeStringUpper(order, 'currency');
                    const marketId = baseId + '_' + quoteId;
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    const amount = this.safeString(order, 'quantity');
                    const filled = this.safeString(order, 'executed_quantity');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const cost = this.safeString(order, 'ceiling');
                    const id = this.safeString(order, 'id');
                    const price = this.safeString(order, 'price');
                    const average = this.safeString(order, 'executed_price');
                    const remaining = this.safeString(order, 'remaining');
                    const type = this.safeString(order, 'type');
                    const side = this.safeString(order, 'trade_type');
                    const fee = {
                        'currency': market['quote'],
                        'cost': this.safeNumber(order, 'fee'),
                        'rate': this.safeNumber(order, 'fee_rate')
                    };
                    let lastTradeTimestamp = undefined;
                    if (updated !== created) lastTradeTimestamp = updated;
                    const stopPrice = this.safeNumber(order, 'stopPrice');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': id,
                        'timestamp': created,
                        'datetime': this.iso8601(created),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': stopPrice,
                        'average': average,
                        'amount': amount,
                        'cost': cost,
                        'filled': filled,
                        'remaining': remaining,
                        'fee': fee,
                        'trades': undefined,
                        'info': order
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': id
                    };
                    const response = await this.privateGetOrdersOrderId(this.extend(request, params));
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"57448aa1fb8f227254e8e2e925b3ade8e1e5bbef",
                    //         "data":{
                    //             "id":88265741,
                    //             "user_id":253063,
                    //             "email":"igor.kroitor@gmail.com",
                    //             "updated_at":1606581578141,
                    //             "created_at":1606581578141,
                    //             "coin":"btc",
                    //             "currency":"usdt",
                    //             "type":"market",
                    //             "trade_type":"sell",
                    //             "executed_price":"17667.1900000000",
                    //             "price":null,
                    //             "executed_quantity":"0.0017280000",
                    //             "quantity":"0.0017280000",
                    //             "fee":"0.0610578086",
                    //             "status":"executed",
                    //             "is_stop":0,
                    //             "stop_condition":null,
                    //             "stop_price":null,
                    //             "ceiling":null
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseOrder(data);
                }
                async fetchOrdersWithMethod(method, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['coin'] = market['baseId'];
                        request['currency'] = market['quoteId'];
                    }
                    if (since !== undefined) request['start_date'] = since;
                    if (limit !== undefined) request['limit'] = Math.min(1000, limit); // max 1000
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"89aa11497f23fdd34cf9de9c55acfad863c78780",
                    //         "data":{
                    //             "current_page":1,
                    //             "data":[
                    //                 {
                    //                     "id":88489678,
                    //                     "email":"igor.kroitor@gmail.com",
                    //                     "updated_at":1606628593567,
                    //                     "created_at":1606628593567,
                    //                     "coin":"btc",
                    //                     "currency":"usdt",
                    //                     "type":"limit",
                    //                     "trade_type":"buy",
                    //                     "executed_price":"0.0000000000",
                    //                     "price":"10000.0000000000",
                    //                     "executed_quantity":"0.0000000000",
                    //                     "quantity":"0.0010000000",
                    //                     "fee":"0.0000000000",
                    //                     "status":"pending",
                    //                     "is_stop":0,
                    //                     "stop_condition":null,
                    //                     "stop_price":null,
                    //                     "ceiling":null,
                    //                 },
                    //             ],
                    //             "first_page_url":"http:\/\/api.vcc.exchange\/v3\/orders\/open?page=1",
                    //             "from":1,
                    //             "last_page":1,
                    //             "last_page_url":"http:\/\/api.vcc.exchange\/v3\/orders\/open?page=1",
                    //             "next_page_url":null,
                    //             "path":"http:\/\/api.vcc.exchange\/v3\/orders\/open",
                    //             "per_page":10,
                    //             "prev_page_url":null,
                    //             "to":1,
                    //             "total":1,
                    //         },
                    //     }
                    //
                    let data = this.safeValue(response, 'data', {});
                    data = this.safeValue(data, 'data', []);
                    return this.parseOrders(data, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersWithMethod('privateGetOrdersOpen', symbol, since, limit, params);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    return await this.fetchOrdersWithMethod('privateGetOrders', symbol, since, limit, params);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['coin'] = market['baseId'];
                        request['currency'] = market['quoteId'];
                    }
                    if (since !== undefined) request['start_date'] = since;
                    if (limit !== undefined) request['limit'] = Math.min(1000, limit); // max 1000
                    const response = await this.privateGetOrdersTrades(this.extend(request, params));
                    //
                    //     {
                    //         "message":null,
                    //         "dataVersion":"eb890af684cf84e20044e9a9771b96302e7b8dec",
                    //         "data":{
                    //             "current_page":1,
                    //             "data":[
                    //                 {
                    //                     "trade_type":"sell",
                    //                     "fee":"0.0610578086",
                    //                     "id":1483372,
                    //                     "created_at":1606581578368,
                    //                     "currency":"usdt",
                    //                     "coin":"btc",
                    //                     "price":"17667.1900000000",
                    //                     "quantity":"0.0017280000",
                    //                     "amount":"30.5289043200",
                    //                 },
                    //             ],
                    //             "first_page_url":"http:\/\/api.vcc.exchange\/v3\/orders\/trades?page=1",
                    //             "from":1,
                    //             "last_page":1,
                    //             "last_page_url":"http:\/\/api.vcc.exchange\/v3\/orders\/trades?page=1",
                    //             "next_page_url":null,
                    //             "path":"http:\/\/api.vcc.exchange\/v3\/orders\/trades",
                    //             "per_page":10,
                    //             "prev_page_url":null,
                    //             "to":2,
                    //             "total":2,
                    //         },
                    //     }
                    //
                    let data = this.safeValue(response, 'data', {});
                    data = this.safeValue(data, 'data', []);
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.privateGetDepositAddress(this.extend(request, params));
                    //
                    //     {
                    //         "dataVersion":"6d72fb82a9c613c8166581a887e1723ce5a937ff",
                    //         "data":{
                    //             "status": "REQUESTED",
                    //             "blockchain_address": "",
                    //             "currency": "btc"
                    //         }
                    //     }
                    //
                    //     {
                    //         "dataVersion":"6d72fb82a9c613c8166581a887e1723ce5a937ff",
                    //         "data":{
                    //             "status": "PROVISIONED",
                    //             "blockchain_address": "rPVMhWBsfF9iMXYj3aAzJVkPDTFNSyWdKy",
                    //             "blockchain_tag": "920396135",
                    //             "currency": "xrp"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const status = this.safeString(data, 'status');
                    if (status === 'REQUESTED') throw new AddressPending(this.id + ' is generating ' + code + ' deposit address, call fetchDepositAddress one more time later to retrieve the generated address');
                    const address = this.safeString(data, 'blockchain_address');
                    this.checkAddress(address);
                    const tag = this.safeString(data, 'blockchain_tag');
                    const currencyId = this.safeString(data, 'currency');
                    return {
                        'currency': this.safeCurrencyCode(currencyId),
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': data
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.version + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.milliseconds().toString();
                        if (method !== 'GET') body = this.json(query);
                        const auth = method + ' ' + url;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha256');
                        headers = {
                            'Authorization': 'Bearer ' + this.apiKey,
                            'Content-Type': 'application/json',
                            'timestamp': timestamp,
                            'signature': signature
                        };
                    }
                    url = this.urls['api'][api] + '/' + url;
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    //     {"message":"Insufficient balance."}
                    //     {"message":"Unauthenticated."} // wrong api key
                    //     {"message":"The given data was invalid.","errors":{"signature":["HMAC signature is invalid"]}}
                    //     {"code":504,"message":"Gateway Timeout","description":""}
                    //     {"code":429,"message":"Too many requests","description":"Too many requests"}
                    //
                    const message = this.safeString(response, 'message');
                    if (message !== undefined) {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    167: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder, AccountSuspended: AccountSuspended, ExchangeError: ExchangeError1, DuplicateOrderId: DuplicateOrderId, OrderNotFound: OrderNotFound, BadSymbol: BadSymbol, ExchangeNotAvailable: ExchangeNotAvailable, BadRequest: BadRequest } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class wavesexchange extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'wavesexchange',
                        'name': 'Waves.Exchange',
                        'countries': [
                            'CH'
                        ],
                        'certified': true,
                        'pro': false,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createMarketOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': false,
                            'createStopMarketOrder': false,
                            'createStopOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchDepositAddress': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'signIn': true,
                            'transfer': false,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '2h': '2h',
                            '3h': '3h',
                            '4h': '4h',
                            '6h': '6h',
                            '12h': '12h',
                            '1d': '1d',
                            '1w': '1w',
                            '1M': '1M'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/84547058-5fb27d80-ad0b-11ea-8711-78ac8b3c7f31.jpg',
                            'test': {
                                'matcher': 'https://matcher-testnet.waves.exchange',
                                'node': 'https://nodes-testnet.wavesnodes.com',
                                'public': 'https://api-testnet.wavesplatform.com/v0',
                                'private': 'https://api-testnet.waves.exchange/v1',
                                'forward': 'https://testnet.waves.exchange/api/v1/forward/matcher',
                                'market': 'https://testnet.waves.exchange/api/v1/forward/marketdata/api/v1'
                            },
                            'api': {
                                'matcher': 'https://matcher.waves.exchange',
                                'node': 'https://nodes.waves.exchange',
                                'public': 'https://api.wavesplatform.com/v0',
                                'private': 'https://api.waves.exchange/v1',
                                'forward': 'https://waves.exchange/api/v1/forward/matcher',
                                'market': 'https://waves.exchange/api/v1/forward/marketdata/api/v1'
                            },
                            'doc': 'https://docs.waves.exchange',
                            'www': 'https://waves.exchange'
                        },
                        'api': {
                            'matcher': {
                                'get': [
                                    'matcher',
                                    'matcher/settings',
                                    'matcher/settings/rates',
                                    'matcher/balance/reserved/{publicKey}',
                                    'matcher/debug/allSnashotOffsets',
                                    'matcher/debug/currentOffset',
                                    'matcher/debug/lastOffset',
                                    'matcher/debug/oldestSnapshotOffset',
                                    'matcher/orderbook',
                                    'matcher/orderbook/{amountAsset}/{priceAsset}',
                                    'matcher/orderbook/{baseId}/{quoteId}/publicKey/{publicKey}',
                                    'matcher/orderbook/{baseId}/{quoteId}/{orderId}',
                                    'matcher/orderbook/{baseId}/{quoteId}/info',
                                    'matcher/orderbook/{baseId}/{quoteId}/status',
                                    'matcher/orderbook/{baseId}/{quoteId}/tradeableBalance/{address}',
                                    'matcher/orderbook/{publicKey}',
                                    'matcher/orderbook/{publicKey}/{orderId}',
                                    'matcher/orders/{address}',
                                    'matcher/orders/{address}/{orderId}',
                                    'matcher/transactions/{orderId}'
                                ],
                                'post': [
                                    'matcher/orderbook',
                                    'matcher/orderbook/market',
                                    'matcher/orderbook/cancel',
                                    'matcher/orderbook/{baseId}/{quoteId}/cancel',
                                    'matcher/orderbook/{amountAsset}/{priceAsset}/calculateFee',
                                    'matcher/debug/saveSnapshots',
                                    'matcher/orders/{address}/cancel',
                                    'matcher/orders/cancel/{orderId}'
                                ],
                                'delete': [
                                    'matcher/orderbook/{baseId}/{quoteId}',
                                    'matcher/settings/rates/{assetId}'
                                ],
                                'put': [
                                    'matcher/settings/rates/{assetId}'
                                ]
                            },
                            'node': {
                                'get': [
                                    'addresses',
                                    'addresses/balance/{address}',
                                    'addresses/balance/{address}/{confirmations}',
                                    'addresses/balance/details/{address}',
                                    'addresses/data/{address}',
                                    'addresses/data/{address}/{key}',
                                    'addresses/effectiveBalance/{address}',
                                    'addresses/effectiveBalance/{address}/{confirmations}',
                                    'addresses/publicKey/{publicKey}',
                                    'addresses/scriptInfo/{address}',
                                    'addresses/scriptInfo/{address}/meta',
                                    'addresses/seed/{address}',
                                    'addresses/seq/{from}/{to}',
                                    'addresses/validate/{address}',
                                    'alias/by-address/{address}',
                                    'alias/by-alias/{alias}',
                                    'assets/{assetId}/distribution/{height}/{limit}',
                                    'assets/balance/{address}',
                                    'assets/balance/{address}/{assetId}',
                                    'assets/details/{assetId}',
                                    'assets/nft/{address}/limit/{limit}',
                                    'blockchain/rewards',
                                    'blockchain/rewards/height',
                                    'blocks/address/{address}/{from}/{to}/',
                                    'blocks/at/{height}',
                                    'blocks/delay/{signature}/{blockNum}',
                                    'blocks/first',
                                    'blocks/headers/last',
                                    'blocks/headers/seq/{from}/{to}',
                                    'blocks/height',
                                    'blocks/height/{signature}',
                                    'blocks/last',
                                    'blocks/seq/{from}/{to}',
                                    'blocks/signature/{signature}',
                                    'consensus/algo',
                                    'consensus/basetarget',
                                    'consensus/basetarget/{blockId}',
                                    'consensus/{generatingbalance}/address',
                                    'consensus/generationsignature',
                                    'consensus/generationsignature/{blockId}',
                                    'debug/balances/history/{address}',
                                    'debug/blocks/{howMany}',
                                    'debug/configInfo',
                                    'debug/historyInfo',
                                    'debug/info',
                                    'debug/minerInfo',
                                    'debug/portfolios/{address}',
                                    'debug/state',
                                    'debug/stateChanges/address/{address}',
                                    'debug/stateChanges/info/{id}',
                                    'debug/stateWaves/{height}',
                                    'leasing/active/{address}',
                                    'node/state',
                                    'node/version',
                                    'peers/all',
                                    'peers/blacklisted',
                                    'peers/connected',
                                    'peers/suspended',
                                    'transactions/address/{address}/limit/{limit}',
                                    'transactions/info/{id}',
                                    'transactions/status',
                                    'transactions/unconfirmed',
                                    'transactions/unconfirmed/info/{id}',
                                    'transactions/unconfirmed/size',
                                    'utils/seed',
                                    'utils/seed/{length}',
                                    'utils/time',
                                    'wallet/seed'
                                ],
                                'post': [
                                    'addresses',
                                    'addresses/data/{address}',
                                    'addresses/sign/{address}',
                                    'addresses/signText/{address}',
                                    'addresses/verify/{address}',
                                    'addresses/verifyText/{address}',
                                    'debug/blacklist',
                                    'debug/print',
                                    'debug/rollback',
                                    'debug/validate',
                                    'node/stop',
                                    'peers/clearblacklist',
                                    'peers/connect',
                                    'transactions/broadcast',
                                    'transactions/calculateFee',
                                    'tranasctions/sign',
                                    'transactions/sign/{signerAddress}',
                                    'tranasctions/status',
                                    'utils/hash/fast',
                                    'utils/hash/secure',
                                    'utils/script/compileCode',
                                    'utils/script/compileWithImports',
                                    'utils/script/decompile',
                                    'utils/script/estimate',
                                    'utils/sign/{privateKey}',
                                    'utils/transactionsSerialize'
                                ],
                                'delete': [
                                    'addresses/{address}',
                                    'debug/rollback-to/{signature}'
                                ]
                            },
                            'public': {
                                'get': [
                                    'assets',
                                    'pairs',
                                    'candles/{baseId}/{quoteId}',
                                    'transactions/exchange'
                                ]
                            },
                            'private': {
                                'get': [
                                    'deposit/addresses/{currency}',
                                    'deposit/addresses/{currency}/{platform}',
                                    'platforms',
                                    'deposit/currencies',
                                    'withdraw/currencies',
                                    'withdraw/addresses/{currency}/{address}'
                                ],
                                'post': [
                                    'oauth2/token'
                                ]
                            },
                            'forward': {
                                'get': [
                                    'matcher/orders/{address}',
                                    'matcher/orders/{address}/{orderId}'
                                ],
                                'post': [
                                    'matcher/orders/{wavesAddress}/cancel'
                                ]
                            },
                            'market': {
                                'get': [
                                    'tickers'
                                ]
                            }
                        },
                        'currencies': {
                            'WX': {
                                'id': 'EMAMLxDnv3xiz8RXg8Btj33jcEw3wLczL3JKYYmuubpc',
                                'numericId': undefined,
                                'code': 'WX',
                                'precision': 8
                            }
                        },
                        'options': {
                            'allowedCandles': 1440,
                            'accessToken': undefined,
                            'createMarketBuyOrderRequiresPrice': true,
                            'matcherPublicKey': undefined,
                            'quotes': undefined,
                            'createOrderDefaultExpiry': 2419200000,
                            'wavesAddress': undefined,
                            'withdrawFeeUSDN': 7420,
                            'withdrawFeeWAVES': 100000,
                            'wavesPrecision': 8,
                            'messagePrefix': 'W',
                            'networks': {
                                'ERC20': 'ETH',
                                'BEP20': 'BSC'
                            },
                            'reverseNetworks': {
                                'ETH': 'ERC20',
                                'BSC': 'BEP20'
                            }
                        },
                        'commonCurrencies': {
                            'EGG': 'Waves Ducks'
                        },
                        'requiresEddsa': true,
                        'exceptions': {
                            '3147270': InsufficientFunds,
                            '112': InsufficientFunds,
                            '4': ExchangeError1,
                            '13': ExchangeNotAvailable,
                            '14': ExchangeNotAvailable,
                            '3145733': AccountSuspended,
                            '3148040': DuplicateOrderId,
                            '3148801': AuthenticationError,
                            '9440512': AuthenticationError,
                            '9440771': BadSymbol,
                            '9441026': InvalidOrder,
                            '9441282': InvalidOrder,
                            '9441286': InvalidOrder,
                            '9441295': InvalidOrder,
                            '9441540': InvalidOrder,
                            '9441542': InvalidOrder,
                            '106954752': AuthenticationError,
                            '106954769': AuthenticationError,
                            '106957828': AuthenticationError,
                            '106960131': AuthenticationError,
                            '106981137': AuthenticationError,
                            '9437193': OrderNotFound,
                            '1048577': BadRequest,
                            '1051904': AuthenticationError
                        }
                    });
                }
                setSandboxMode(enabled) {
                    this.options['messagePrefix'] = enabled ? 'T' : 'W';
                    return super.setSandboxMode(enabled);
                }
                async getFeesForAsset(symbol, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    amount = this.amountToPrecision(symbol, amount);
                    price = this.priceToPrecision(symbol, price);
                    const request = this.extend({
                        'amountAsset': market['baseId'],
                        'priceAsset': market['quoteId'],
                        'orderType': side,
                        'amount': amount,
                        'price': price
                    }, params);
                    return await this.matcherPostMatcherOrderbookAmountAssetPriceAssetCalculateFee(request);
                }
                async calculateFee(symbol, type, side, amount, price, takerOrMaker = 'taker', params = {}) {
                    const response = await this.getFeesForAsset(symbol, side, amount, price);
                    // {
                    //     "base":{
                    //        "feeAssetId":"WAVES",
                    //        "matcherFee":"1000000"
                    //     },
                    //     "discount":{
                    //        "feeAssetId":"EMAMLxDnv3xiz8RXg8Btj33jcEw3wLczL3JKYYmuubpc",
                    //        "matcherFee":"4077612"
                    //     }
                    //  }
                    const isDiscountFee = this.safeValue(params, 'isDiscountFee', false);
                    let mode = undefined;
                    if (isDiscountFee) mode = this.safeValue(response, 'discount');
                    else mode = this.safeValue(response, 'base');
                    const matcherFee = this.safeString(mode, 'matcherFee');
                    const feeAssetId = this.safeString(mode, 'feeAssetId');
                    const feeAsset = this.safeCurrencyCode(feeAssetId);
                    const adjustedMatcherFee = this.currencyFromPrecision(feeAsset, matcherFee);
                    const amountAsString = this.numberToString(amount);
                    const priceAsString = this.numberToString(price);
                    const feeCost = this.feeToPrecision(symbol, this.parseNumber(adjustedMatcherFee));
                    const feeRate = Precise.stringDiv(adjustedMatcherFee, Precise.stringMul(amountAsString, priceAsString));
                    return {
                        'type': takerOrMaker,
                        'currency': feeAsset,
                        'rate': this.parseNumber(feeRate),
                        'cost': this.parseNumber(feeCost)
                    };
                }
                async getQuotes() {
                    let quotes = this.safeValue(this.options, 'quotes');
                    if (quotes) return quotes;
                    else {
                        // currencies can have any name because you can create you own token
                        // as a result someone can create a fake token called BTC
                        // we use this mapping to determine the real tokens
                        // https://docs.waves.exchange/en/waves-matcher/matcher-api#asset-pair
                        const response = await this.matcherGetMatcherSettings();
                        // {
                        //   "orderVersions": [
                        //     1,
                        //     2,
                        //     3
                        //   ],
                        //   "success": true,
                        //   "matcherPublicKey": "9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5",
                        //   "orderFee": {
                        //     "dynamic": {
                        //       "baseFee": 300000,
                        //       "rates": {
                        //         "34N9YcEETLWn93qYQ64EsP1x89tSruJU44RrEMSXXEPJ": 1.22639597,
                        //         "62LyMjcr2DtiyF5yVXFhoQ2q414VPPJXjsNYp72SuDCH": 0.00989643,
                        //         "HZk1mbfuJpmxU1Fs4AX5MWLVYtctsNcg6e2C6VKqK8zk": 0.0395674,
                        //         "8LQW8f7P5d5PZM7GtZEBgaqRPGSzS3DfPuiXrURJ4AJS": 0.00018814,
                        //         "4LHHvYGNKJUg5hj65aGD5vgScvCBmLpdRFtjokvCjSL8": 26.19721262,
                        //         "474jTeYx2r2Va35794tCScAXWJG9hU2HcgxzMowaZUnu": 0.00752978,
                        //         "DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p": 1.84575,
                        //         "B3uGHFRpSUuGEDWjqB9LWWxafQj8VTvpMucEyoxzws5H": 0.02330273,
                        //         "zMFqXuoyrn5w17PFurTqxB7GsS71fp9dfk6XFwxbPCy": 0.00721412,
                        //         "5WvPKSJXzVE2orvbkJ8wsQmmQKqTv9sGBPksV4adViw3": 0.02659103,
                        //         "WAVES": 1,
                        //         "BrjUWjndUanm5VsJkbUip8VRYy6LWJePtxya3FNv4TQa": 0.03433583
                        //       }
                        //     }
                        //   },
                        //   "networkByte": 87,
                        //   "matcherVersion": "2.1.3.5",
                        //   "status": "SimpleResponse",
                        //   "priceAssets": [
                        //     "Ft8X1v1LTa1ABafufpaCWyVj8KkaxUWE6xBhW6sNFJck",
                        //     "DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p",
                        //     "34N9YcEETLWn93qYQ64EsP1x89tSruJU44RrEMSXXEPJ",
                        //     "Gtb1WRznfchDnTh37ezoDTJ4wcoKaRsKqKjJjy7nm2zU",
                        //     "2mX5DzVKWrAJw8iwdJnV2qtoeVG9h5nTDpTqC1wb1WEN",
                        //     "8LQW8f7P5d5PZM7GtZEBgaqRPGSzS3DfPuiXrURJ4AJS",
                        //     "WAVES",
                        //     "474jTeYx2r2Va35794tCScAXWJG9hU2HcgxzMowaZUnu",
                        //     "zMFqXuoyrn5w17PFurTqxB7GsS71fp9dfk6XFwxbPCy",
                        //     "62LyMjcr2DtiyF5yVXFhoQ2q414VPPJXjsNYp72SuDCH",
                        //     "HZk1mbfuJpmxU1Fs4AX5MWLVYtctsNcg6e2C6VKqK8zk",
                        //     "B3uGHFRpSUuGEDWjqB9LWWxafQj8VTvpMucEyoxzws5H",
                        //     "5WvPKSJXzVE2orvbkJ8wsQmmQKqTv9sGBPksV4adViw3",
                        //     "BrjUWjndUanm5VsJkbUip8VRYy6LWJePtxya3FNv4TQa",
                        //     "4LHHvYGNKJUg5hj65aGD5vgScvCBmLpdRFtjokvCjSL8"
                        //   ]
                        // }
                        quotes = {};
                        const priceAssets = this.safeValue(response, 'priceAssets');
                        for(let i = 0; i < priceAssets.length; i++)quotes[priceAssets[i]] = true;
                        this.options['quotes'] = quotes;
                        return quotes;
                    }
                }
                async fetchMarkets(params = {}) {
                    const response = await this.marketGetTickers();
                    //
                    //   [
                    //       {
                    //           "symbol": "WAVES/BTC",
                    //           "amountAssetID": "WAVES",
                    //           "amountAssetName": "Waves",
                    //           "amountAssetDecimals": 8,
                    //           "amountAssetTotalSupply": "106908766.00000000",
                    //           "amountAssetMaxSupply": "106908766.00000000",
                    //           "amountAssetCirculatingSupply": "106908766.00000000",
                    //           "priceAssetID": "8LQW8f7P5d5PZM7GtZEBgaqRPGSzS3DfPuiXrURJ4AJS",
                    //           "priceAssetName": "WBTC",
                    //           "priceAssetDecimals": 8,
                    //           "priceAssetTotalSupply": "20999999.96007507",
                    //           "priceAssetMaxSupply": "20999999.96007507",
                    //           "priceAssetCirculatingSupply": "20999999.66019601",
                    //           "24h_open": "0.00032688",
                    //           "24h_high": "0.00033508",
                    //           "24h_low": "0.00032443",
                    //           "24h_close": "0.00032806",
                    //           "24h_vwap": "0.00032988",
                    //           "24h_volume": "42349.69440104",
                    //           "24h_priceVolume": "13.97037207",
                    //           "timestamp":1640232379124
                    //       }
                    //       ...
                    //   ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const entry = response[i];
                        const baseId = this.safeString(entry, 'amountAssetID');
                        const quoteId = this.safeString(entry, 'priceAssetID');
                        const id = baseId + '/' + quoteId;
                        const marketId = this.safeString(entry, 'symbol');
                        let [base, quote] = marketId.split('/');
                        base = this.safeCurrencyCode(base);
                        quote = this.safeCurrencyCode(quote);
                        const symbol = base + '/' + quote;
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(entry, 'amountAssetDecimals'),
                                'price': this.safeInteger(entry, 'priceAssetDecimals')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': entry
                        });
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = this.extend({
                        'amountAsset': market['baseId'],
                        'priceAsset': market['quoteId']
                    }, params);
                    const response = await this.matcherGetMatcherOrderbookAmountAssetPriceAsset(request);
                    const timestamp = this.safeInteger(response, 'timestamp');
                    const bids = this.parseOrderBookSide(this.safeValue(response, 'bids'), market, limit);
                    const asks = this.parseOrderBookSide(this.safeValue(response, 'asks'), market, limit);
                    return {
                        'symbol': symbol,
                        'bids': bids,
                        'asks': asks,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'nonce': undefined
                    };
                }
                parseOrderBookSide(bookSide, market, limit) {
                    const precision = market['precision'];
                    const wavesPrecision = this.safeInteger(this.options, 'wavesPrecision', 8);
                    const amountPrecision = Math.pow(10, precision['amount']);
                    const difference = precision['amount'] - precision['price'];
                    const pricePrecision = Math.pow(10, wavesPrecision - difference);
                    const result = [];
                    for(let i = 0; i < bookSide.length; i++){
                        const entry = bookSide[i];
                        const price = this.safeInteger(entry, 'price', 0) / pricePrecision;
                        const amount = this.safeInteger(entry, 'amount', 0) / amountPrecision;
                        if (limit !== undefined && i > limit) break;
                        result.push([
                            price,
                            amount
                        ]);
                    }
                    return result;
                }
                checkRequiredKeys() {
                    if (this.apiKey === undefined) throw new AuthenticationError(this.id + ' requires apiKey credential');
                    if (this.secret === undefined) throw new AuthenticationError(this.id + ' requires secret credential');
                    let apiKeyBytes = undefined;
                    let secretKeyBytes = undefined;
                    try {
                        apiKeyBytes = this.base58ToBinary(this.apiKey);
                    } catch (e) {
                        throw new AuthenticationError(this.id + ' apiKey must be a base58 encoded public key');
                    }
                    try {
                        secretKeyBytes = this.base58ToBinary(this.secret);
                    } catch (e) {
                        throw new AuthenticationError(this.id + ' secret must be a base58 encoded private key');
                    }
                    const hexApiKeyBytes = this.binaryToBase16(apiKeyBytes);
                    const hexSecretKeyBytes = this.binaryToBase16(secretKeyBytes);
                    if (hexApiKeyBytes.length !== 64) throw new AuthenticationError(this.id + ' apiKey must be a base58 encoded public key');
                    if (hexSecretKeyBytes.length !== 64) throw new AuthenticationError(this.id + ' secret must be a base58 encoded private key');
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const query = this.omit(params, this.extractParams(path));
                    const isCancelOrder = path === 'matcher/orders/{wavesAddress}/cancel';
                    path = this.implodeParams(path, params);
                    let url = this.urls['api'][api] + '/' + path;
                    let queryString = this.urlencodeWithArrayRepeat(query);
                    if (api === 'private' || api === 'forward') {
                        headers = {
                            'Accept': 'application/json'
                        };
                        const accessToken = this.safeString(this.options, 'accessToken');
                        if (accessToken) headers['Authorization'] = 'Bearer ' + accessToken;
                        if (method === 'POST') headers['content-type'] = 'application/json';
                        else headers['content-type'] = 'application/x-www-form-urlencoded';
                        if (isCancelOrder) {
                            body = this.json([
                                query['orderId']
                            ]);
                            queryString = '';
                        }
                        if (queryString.length > 0) url += '?' + queryString;
                    } else if (api === 'matcher') {
                        if (method === 'POST') {
                            headers = {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            };
                            body = this.json(query);
                        } else headers = query;
                    } else if (method === 'POST') {
                        headers = {
                            'content-type': 'application/json'
                        };
                        body = this.json(query);
                    } else {
                        headers = {
                            'content-type': 'application/x-www-form-urlencoded'
                        };
                        if (queryString.length > 0) url += '?' + queryString;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                async signIn(params = {}) {
                    if (!this.safeString(this.options, 'accessToken')) {
                        const prefix = 'ffffff01';
                        const expiresDelta = 604800;
                        let seconds = this.sum(this.seconds(), expiresDelta);
                        seconds = seconds.toString();
                        const clientId = 'waves.exchange';
                        // W for production, T for testnet
                        const defaultMessagePrefix = this.safeString(this.options, 'messagePrefix', 'W');
                        const message = defaultMessagePrefix + ':' + clientId + ':' + seconds;
                        const messageHex = this.binaryToBase16(this.stringToBinary(this.encode(message)));
                        const payload = prefix + messageHex;
                        const hexKey = this.binaryToBase16(this.base58ToBinary(this.secret));
                        const signature = this.eddsa(payload, hexKey, 'ed25519');
                        const request = {
                            'grant_type': 'password',
                            'scope': 'general',
                            'username': this.apiKey,
                            'password': seconds + ':' + signature,
                            'client_id': clientId
                        };
                        const response = await this.privatePostOauth2Token(request);
                        // { access_token: 'eyJhbGciOXJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaWciOiJiaTZiMVhMQlo0M1Q4QmRTSlVSejJBZGlQdVlpaFZQYVhhVjc4ZGVIOEpTM3M3NUdSeEU1VkZVOE5LRUI0UXViNkFHaUhpVFpuZ3pzcnhXdExUclRvZTgiLCJhIjoiM1A4VnpMU2EyM0VXNUNWY2tIYlY3ZDVCb043NWZGMWhoRkgiLCJuYiI6IlciLCJ1c2VyX25hbWUiOiJBSFhuOG5CQTRTZkxRRjdoTFFpU24xNmt4eWVoaml6QkdXMVRkcm1TWjFnRiIsInNjb3BlIjpbImdlbmVyYWwiXSwibHQiOjYwNDc5OSwicGsiOiJBSFhuOG5CQTRTZkxRRjdoTFFpU24xNmt4eWVoaml6QkdXMVRkcm1TWjFnRiIsImV4cCI6MTU5MTk3NTA1NywiZXhwMCI6MTU5MTk3NTA1NywianRpIjoiN2JhOTUxMTMtOGI2MS00NjEzLTlkZmYtNTEwYTc0NjlkOWI5IiwiY2lkIjoid2F2ZXMuZXhjaGFuZ2UifQ.B-XwexBnUAzbWknVN68RKT0ZP5w6Qk1SKJ8usL3OIwDEzCUUX9PjW-5TQHmiCRcA4oft8lqXEiCwEoNfsblCo_jTpRo518a1vZkIbHQk0-13Dm1K5ewGxfxAwBk0g49odcbKdjl64TN1yM_PO1VtLVuiTeZP-XF-S42Uj-7fcO-r7AulyQLuTE0uo-Qdep8HDCk47rduZwtJOmhFbCCnSgnLYvKWy3CVTeldsR77qxUY-vy8q9McqeP7Id-_MWnsob8vWXpkeJxaEsw1Fke1dxApJaJam09VU8EB3ZJWpkT7V8PdafIrQGeexx3jhKKxo7rRb4hDV8kfpVoCgkvFan',
                        //   token_type: 'bearer',
                        //   refresh_token: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaWciOiJiaTZiMVhMQlo0M1Q4QmRTSlVSejJBZGlQdVlpaFZQYVhhVjc4ZGVIOEpTM3M3NUdSeEU1VkZVOE5LRUI0UXViNkFHaUhpVFpuZ3pzcnhXdExUclRvZTgiLCJhIjoiM1A4VnpMU2EyM0VXNUNWY2tIYlY3ZDVCb043NWZGMWhoRkgiLCJuYiI6IlciLCJ1c2VyX25hbWUiOiJBSFhuOG5CQTRTZkxRRjdoTFFpU24xNmt4eWVoaml6QkdXMVRkcm1TWjFnRiIsInNjb3BlIjpbImdlbmVyYWwiXSwiYXRpIjoiN2JhOTUxMTMtOGI2MS00NjEzLTlkZmYtNTEwYTc0NjlkXWI5IiwibHQiOjYwNDc5OSwicGsiOiJBSFhuOG5CQTRTZkxRRjdoTFFpU24xNmt4eWVoaml6QkdXMVRkcm1TWjFnRiIsImV4cCI6MTU5Mzk2MjI1OCwiZXhwMCI6MTU5MTk3NTA1NywianRpIjoiM2MzZWRlMTktNjI5My00MTNlLWJmMWUtZTRlZDZlYzUzZTgzIiwiY2lkIjoid2F2ZXMuZXhjaGFuZ2UifQ.gD1Qj0jfqayfZpBvNY0t3ccMyK5hdbT7dY-_5L6LxwV0Knan4ndEtvygxlTOczmJUKtnA4T1r5GBFgNMZTvtViKZIbqZNysEg2OY8UxwDaF4VPeGJLg_QXEnn8wBeBQdyMafh9UQdwD2ci7x-saM4tOAGmncAygfTDxy80201gwDhfAkAGerb9kL00oWzSJScldxu--pNLDBUEHZt52MSEel10HGrzvZkkvvSh67vcQo5TOGb5KG6nh65UdJCwr41AVz4fbQPP-N2Nkxqy0TE_bqVzZxExXgvcS8TS0Z82T3ijJa_ct7B9wblpylBnvmyj3VycUzufD6uy8MUGq32D',
                        //   expires_in: 604798,
                        //   scope: 'general' }
                        this.options['accessToken'] = this.safeString(response, 'access_token');
                        return this.options['accessToken'];
                    }
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         "__type":"pair",
                    //         "data":{
                    //             "firstPrice":0.00012512,
                    //             "lastPrice":0.00012441,
                    //             "low":0.00012167,
                    //             "high":0.00012768,
                    //             "weightedAveragePrice":0.000124710697407246,
                    //             "volume":209554.26356614,
                    //             "quoteVolume":26.1336583539951,
                    //             "volumeWaves":209554.26356614,
                    //             "txsCount":6655
                    //         },
                    //         "amountAsset":"WAVES",
                    //         "priceAsset":"8LQW8f7P5d5PZM7GtZEBgaqRPGSzS3DfPuiXrURJ4AJS"
                    //     }
                    //
                    const timestamp = undefined;
                    const baseId = this.safeString(ticker, 'amountAsset');
                    const quoteId = this.safeString(ticker, 'priceAsset');
                    let symbol = undefined;
                    if (baseId !== undefined && quoteId !== undefined) {
                        const marketId = baseId + '/' + quoteId;
                        if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                        else {
                            const base = this.safeCurrencyCode(baseId);
                            const quote = this.safeCurrencyCode(quoteId);
                            symbol = base + '/' + quote;
                        }
                    }
                    if (symbol === undefined && market !== undefined) symbol = market['symbol'];
                    const data = this.safeValue(ticker, 'data', {});
                    const last = this.safeString(data, 'lastPrice');
                    const low = this.safeString(data, 'low');
                    const high = this.safeString(data, 'high');
                    const vwap = this.safeString(data, 'weightedAveragePrice');
                    const baseVolume = this.safeString(data, 'volume');
                    const quoteVolume = this.safeString(data, 'quoteVolume');
                    const open = this.safeString(data, 'firstPrice');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': high,
                        'low': low,
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': vwap,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pairs': market['id']
                    };
                    const response = await this.publicGetPairs(this.extend(request, params));
                    //
                    //     {
                    //         "__type":"list",
                    //         "data":[
                    //             {
                    //                 "__type":"pair",
                    //                 "data":{
                    //                     "firstPrice":0.00012512,
                    //                     "lastPrice":0.00012441,
                    //                     "low":0.00012167,
                    //                     "high":0.00012768,
                    //                     "weightedAveragePrice":0.000124710697407246,
                    //                     "volume":209554.26356614,
                    //                     "quoteVolume":26.1336583539951,
                    //                     "volumeWaves":209554.26356614,
                    //                     "txsCount":6655
                    //                 },
                    //                 "amountAsset":"WAVES",
                    //                 "priceAsset":"8LQW8f7P5d5PZM7GtZEBgaqRPGSzS3DfPuiXrURJ4AJS"
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const ticker = this.safeValue(data, 0, {});
                    return this.parseTicker(ticker, market);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'baseId': market['baseId'],
                        'quoteId': market['quoteId'],
                        'interval': this.timeframes[timeframe]
                    };
                    const allowedCandles = this.safeInteger(this.options, 'allowedCandles', 1440);
                    if (limit === undefined) limit = allowedCandles;
                    limit = Math.min(allowedCandles, limit);
                    const duration = this.parseTimeframe(timeframe) * 1000;
                    if (since === undefined) {
                        const durationRoundedTimestamp = parseInt(this.milliseconds() / duration) * duration;
                        const delta = (limit - 1) * duration;
                        const timeStart = durationRoundedTimestamp - delta;
                        request['timeStart'] = timeStart.toString();
                    } else {
                        request['timeStart'] = since.toString();
                        const timeEnd = this.sum(since, duration * limit);
                        request['timeEnd'] = timeEnd.toString();
                    }
                    const response = await this.publicGetCandlesBaseIdQuoteId(this.extend(request, params));
                    //
                    //     {
                    //         "__type": "list",
                    //         "data": [
                    //             {
                    //                 "__type": "candle",
                    //                 "data": {
                    //                     "time": "2020-06-09T14:47:00.000Z",
                    //                     "open": 0.0250385,
                    //                     "close": 0.0250385,
                    //                     "high": 0.0250385,
                    //                     "low": 0.0250385,
                    //                     "volume": 0.01033012,
                    //                     "quoteVolume": 0.00025865,
                    //                     "weightedAveragePrice": 0.0250385,
                    //                     "maxHeight": 2099399,
                    //                     "txsCount": 5,
                    //                     "timeClose": "2020-06-09T14:47:59.999Z"
                    //                 }
                    //             }
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    let result = this.parseOHLCVs(data, market, timeframe, since, limit);
                    result = this.filterFutureCandles(result);
                    let lastClose = undefined;
                    const length = result.length;
                    for(let i = 0; i < result.length; i++){
                        const j = length - i - 1;
                        const entry = result[j];
                        const open = entry[1];
                        if (open === undefined) {
                            entry[1] = lastClose;
                            entry[2] = lastClose;
                            entry[3] = lastClose;
                            entry[4] = lastClose;
                            result[j] = entry;
                        }
                        lastClose = entry[4];
                    }
                    return result;
                }
                filterFutureCandles(ohlcvs) {
                    const result = [];
                    const timestamp = this.milliseconds();
                    for(let i = 0; i < ohlcvs.length; i++){
                        if (ohlcvs[i][0] > timestamp) break;
                        result.push(ohlcvs[i]);
                    }
                    return result;
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         __type: 'candle',
                    //         data: {
                    //             time: '2020-06-05T20:46:00.000Z',
                    //             open: 240.573975,
                    //             close: 240.573975,
                    //             high: 240.573975,
                    //             low: 240.573975,
                    //             volume: 0.01278413,
                    //             quoteVolume: 3.075528,
                    //             weightedAveragePrice: 240.573975,
                    //             maxHeight: 2093895,
                    //             txsCount: 5,
                    //             timeClose: '2020-06-05T20:46:59.999Z'
                    //         }
                    //     }
                    //
                    const data = this.safeValue(ohlcv, 'data', {});
                    return [
                        this.parse8601(this.safeString(data, 'time')),
                        this.safeNumber(data, 'open'),
                        this.safeNumber(data, 'high'),
                        this.safeNumber(data, 'low'),
                        this.safeNumber(data, 'close'),
                        this.safeNumber(data, 'volume', 0)
                    ];
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.signIn();
                    const networks = this.safeValue(this.options, 'networks', {});
                    const rawNetwork = this.safeStringUpper(params, 'network');
                    const network = this.safeString(networks, rawNetwork, rawNetwork);
                    params = this.omit(params, [
                        'network'
                    ]);
                    const supportedCurrencies = await this.privateGetPlatforms();
                    //
                    //     {
                    //       "type": "list",
                    //       "page_info": {
                    //         "has_next_page": false,
                    //         "last_cursor": null
                    //       },
                    //       "items": [
                    //         {
                    //           "type": "platform",
                    //           "id": "ETH",
                    //           "name": "Ethereum",
                    //           "currencies": [
                    //             "BAG",
                    //             "BNT",
                    //             "CRV",
                    //             "EGG",
                    //             "ETH",
                    //             "EURN",
                    //             "FL",
                    //             "NSBT",
                    //             "USDAP",
                    //             "USDC",
                    //             "USDFL",
                    //             "USDN",
                    //             "USDT",
                    //             "WAVES"
                    //           ]
                    //         }
                    //       ]
                    //     }
                    //
                    const currencies = {};
                    const networksByCurrency = {};
                    const items = this.safeValue(supportedCurrencies, 'items', []);
                    for(let i = 0; i < items.length; i++){
                        const entry = items[i];
                        const currencyId = this.safeString(entry, 'id');
                        const innerCurrencies = this.safeValue(entry, 'currencies', []);
                        for(let j = 0; j < innerCurrencies.length; j++){
                            const currencyCode = this.safeString(innerCurrencies, j);
                            currencies[currencyCode] = true;
                            if (!(currencyCode in networksByCurrency)) networksByCurrency[currencyCode] = {};
                            networksByCurrency[currencyCode][currencyId] = true;
                        }
                    }
                    if (!(code in currencies)) {
                        const codes = Object.keys(currencies);
                        throw new ExchangeError1(this.id + ' fetchDepositAddress() ' + code + ' not supported. Currency code must be one of ' + codes.join(', '));
                    }
                    let response = undefined;
                    if (network === undefined) {
                        const request = {
                            'currency': code
                        };
                        response = await this.privateGetDepositAddressesCurrency(this.extend(request, params));
                    } else {
                        const supportedNetworks = networksByCurrency[code];
                        if (!(network in supportedNetworks)) {
                            const supportedNetworkKeys = Object.keys(supportedNetworks);
                            throw new ExchangeError1(this.id + ' ' + network + ' network ' + code + ' deposit address not supported. Network must be one of ' + supportedNetworkKeys.join(', '));
                        }
                        if (network === 'WAVES') {
                            const request = {
                                'publicKey': this.apiKey
                            };
                            const response = await this.nodeGetAddressesPublicKeyPublicKey(this.extend(request, request));
                            const address = this.safeString(response, 'address');
                            return {
                                'address': address,
                                'code': code,
                                'network': network,
                                'tag': undefined,
                                'info': response
                            };
                        } else {
                            const request = {
                                'currency': code,
                                'platform': network
                            };
                            response = await this.privateGetDepositAddressesCurrencyPlatform(this.extend(request, params));
                        }
                    }
                    //
                    // {
                    //   "type": "deposit_addresses",
                    //   "currency": {
                    //     "type": "deposit_currency",
                    //     "id": "ERGO",
                    //     "waves_asset_id": "5dJj4Hn9t2Ve3tRpNGirUHy4yBK6qdJRAJYV21yPPuGz",
                    //     "platform_id": "BSC",
                    //     "decimals": 9,
                    //     "status": "active",
                    //     "allowed_amount": {
                    //       "min": 0.001,
                    //       "max": 100000
                    //     },
                    //     "fees": {
                    //       "flat": 0,
                    //       "rate": 0
                    //     }
                    //   },
                    //   "deposit_addresses": [
                    //     "9fRAAQjF8Yqg7qicQCL884zjimsRnuwsSavsM1rUdDaoG8mThku"
                    //   ]
                    // }
                    const currency = this.safeValue(response, 'currency');
                    const networkId = this.safeString(currency, 'platform_id');
                    const reverseNetworks = this.safeValue(this.options, 'reverseNetworks', {});
                    const unifiedNetwork = this.safeString(reverseNetworks, networkId, networkId);
                    const addresses = this.safeValue(response, 'deposit_addresses');
                    const address = this.safeString(addresses, 0);
                    return {
                        'address': address,
                        'code': code,
                        'tag': undefined,
                        'network': unifiedNetwork,
                        'info': response
                    };
                }
                async getMatcherPublicKey() {
                    // this method returns a single string
                    const matcherPublicKey = this.safeString(this.options, 'matcherPublicKey');
                    if (matcherPublicKey) return matcherPublicKey;
                    else {
                        const response = await this.matcherGetMatcher();
                        // remove trailing quotes from string response
                        this.options['matcherPublicKey'] = response.slice(1, response.length - 1);
                        return this.options['matcherPublicKey'];
                    }
                }
                getAssetBytes(currencyId) {
                    if (currencyId === 'WAVES') return this.numberToBE(0, 1);
                    else return this.binaryConcat(this.numberToBE(1, 1), this.base58ToBinary(currencyId));
                }
                getAssetId(currencyId) {
                    if (currencyId === 'WAVES') return '';
                    return currencyId;
                }
                priceToPrecision(symbol, price) {
                    const market = this.markets[symbol];
                    const wavesPrecision = this.safeInteger(this.options, 'wavesPrecision', 8);
                    const difference = market['precision']['amount'] - market['precision']['price'];
                    return parseInt(parseFloat(this.toPrecision(price, wavesPrecision - difference)));
                }
                amountToPrecision(symbol, amount) {
                    return parseInt(parseFloat(this.toPrecision(amount, this.markets[symbol]['precision']['amount'])));
                }
                currencyToPrecision(code, amount) {
                    return parseInt(parseFloat(this.toPrecision(amount, this.currencies[code]['precision'])));
                }
                fromPrecision(amount, scale) {
                    if (amount === undefined) return undefined;
                    const precise = new Precise(amount);
                    precise.decimals = precise.decimals + scale;
                    precise.reduce();
                    return precise.toString();
                }
                toPrecision(amount, scale) {
                    const amountString = amount.toString();
                    const precise = new Precise(amountString);
                    precise.decimals = precise.decimals - scale;
                    precise.reduce();
                    return precise.toString();
                }
                currencyFromPrecision(currency, amount) {
                    const scale = this.currencies[currency]['precision'];
                    return this.fromPrecision(amount, scale);
                }
                priceFromPrecision(symbol, price) {
                    const market = this.markets[symbol];
                    const wavesPrecision = this.safeInteger(this.options, 'wavesPrecision', 8);
                    const scale = wavesPrecision - market['precision']['amount'] + market['precision']['price'];
                    return this.fromPrecision(price, scale);
                }
                safeGetDynamic(settings) {
                    const orderFee = this.safeValue(settings, 'orderFee');
                    if ('dynamic' in orderFee) return this.safeValue(orderFee, 'dynamic');
                    else return this.safeValue(orderFee['composite']['default'], 'dynamic');
                }
                safeGetRates(dynamic) {
                    const rates = this.safeValue(dynamic, 'rates');
                    if (rates === undefined) return {
                        'WAVES': 1
                    };
                    return rates;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    this.checkRequiredDependencies();
                    this.checkRequiredKeys();
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const matcherPublicKey = await this.getMatcherPublicKey();
                    const amountAsset = this.getAssetId(market['baseId']);
                    const priceAsset = this.getAssetId(market['quoteId']);
                    const isMarketOrder = type === 'market';
                    if (isMarketOrder && price === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a price argument for ' + type + ' orders to determine the max price for buy and the min price for sell');
                    const orderType = side === 'buy' ? 0 : 1;
                    const timestamp = this.milliseconds();
                    const defaultExpiryDelta = this.safeInteger(this.options, 'createOrderDefaultExpiry', 2419200000);
                    const expiration = this.sum(timestamp, defaultExpiryDelta);
                    const matcherFees = await this.getFeesForAsset(symbol, side, amount, price);
                    // {
                    //     "base":{
                    //        "feeAssetId":"WAVES", // varies depending on the trading pair
                    //        "matcherFee":"1000000"
                    //     },
                    //     "discount":{
                    //        "feeAssetId":"EMAMLxDnv3xiz8RXg8Btj33jcEw3wLczL3JKYYmuubpc",
                    //        "matcherFee":"4077612"
                    //     }
                    //  }
                    const base = this.safeValue(matcherFees, 'base');
                    const baseFeeAssetId = this.safeString(base, 'feeAssetId');
                    const baseFeeAsset = this.safeCurrencyCode(baseFeeAssetId);
                    const baseMatcherFee = this.safeString(base, 'matcherFee');
                    const discount = this.safeValue(matcherFees, 'discount');
                    const discountFeeAssetId = this.safeString(discount, 'feeAssetId');
                    const discountFeeAsset = this.safeCurrencyCode(discountFeeAssetId);
                    const discountMatcherFee = this.safeString(discount, 'matcherFee');
                    let matcherFeeAssetId = undefined;
                    let matcherFee = undefined;
                    // check first if user supplied asset fee is valid
                    if ('feeAsset' in params || 'feeAsset' in this.options) {
                        const feeAsset = this.safeString(params, 'feeAsset', this.safeString(this.options, 'feeAsset'));
                        const feeCurrency = this.currency(feeAsset);
                        matcherFeeAssetId = this.safeString(feeCurrency, 'id');
                    }
                    const balances = await this.fetchBalance();
                    if (matcherFeeAssetId !== undefined) {
                        if (baseFeeAssetId !== matcherFeeAssetId && discountFeeAssetId !== matcherFeeAssetId) throw new InvalidOrder(this.id + ' asset fee must be ' + baseFeeAsset + ' or ' + discountFeeAsset);
                        const matcherFeeAsset = this.safeCurrencyCode(matcherFeeAssetId);
                        const rawMatcherFee = matcherFeeAssetId === baseFeeAssetId ? baseMatcherFee : discountMatcherFee;
                        const floatMatcherFee = parseFloat(this.currencyFromPrecision(matcherFeeAsset, rawMatcherFee));
                        if (matcherFeeAsset in balances && balances[matcherFeeAsset]['free'] >= floatMatcherFee) matcherFee = parseInt(rawMatcherFee);
                        else throw new InsufficientFunds(this.id + ' not enough funds of the selected asset fee');
                    }
                    if (matcherFeeAssetId === undefined) {
                        // try to the pay the fee using the base first then discount asset
                        const floatBaseMatcherFee = parseFloat(this.currencyFromPrecision(baseFeeAsset, baseMatcherFee));
                        if (baseFeeAsset in balances && balances[baseFeeAsset]['free'] >= floatBaseMatcherFee) {
                            matcherFeeAssetId = baseFeeAssetId;
                            matcherFee = parseInt(baseMatcherFee);
                        } else {
                            const floatDiscountMatcherFee = parseFloat(this.currencyFromPrecision(discountFeeAsset, discountMatcherFee));
                            if (discountFeeAsset in balances && balances[discountFeeAsset]['free'] >= floatDiscountMatcherFee) {
                                matcherFeeAssetId = discountFeeAssetId;
                                matcherFee = parseInt(discountMatcherFee);
                            }
                        }
                    }
                    if (matcherFeeAssetId === undefined) throw new InsufficientFunds(this.id + ' not enough funds on none of the eligible asset fees');
                    amount = this.amountToPrecision(symbol, amount);
                    price = this.priceToPrecision(symbol, price);
                    const byteArray = [
                        this.numberToBE(3, 1),
                        this.base58ToBinary(this.apiKey),
                        this.base58ToBinary(matcherPublicKey),
                        this.getAssetBytes(market['baseId']),
                        this.getAssetBytes(market['quoteId']),
                        this.numberToBE(orderType, 1),
                        this.numberToBE(price, 8),
                        this.numberToBE(amount, 8),
                        this.numberToBE(timestamp, 8),
                        this.numberToBE(expiration, 8),
                        this.numberToBE(matcherFee, 8),
                        this.getAssetBytes(matcherFeeAssetId)
                    ];
                    const binary = this.binaryConcatArray(byteArray);
                    const signature = this.eddsa(this.binaryToBase16(binary), this.binaryToBase16(this.base58ToBinary(this.secret)), 'ed25519');
                    const assetPair = {
                        'amountAsset': amountAsset,
                        'priceAsset': priceAsset
                    };
                    const body = {
                        'senderPublicKey': this.apiKey,
                        'matcherPublicKey': matcherPublicKey,
                        'assetPair': assetPair,
                        'orderType': side,
                        'price': price,
                        'amount': amount,
                        'timestamp': timestamp,
                        'expiration': expiration,
                        'matcherFee': parseInt(matcherFee),
                        'signature': signature,
                        'version': 3
                    };
                    if (matcherFeeAssetId !== 'WAVES') body['matcherFeeAssetId'] = matcherFeeAssetId;
                    //
                    //     {
                    //         "success":true,
                    //         "message":{
                    //             "version":3,
                    //             "id":"GK5ox4RfLJFtqjQsCbDmvCya8ZhFVEUQDtF4yYuAJ6C7",
                    //             "sender":"3P8VzLSa23EW5CVckHbV7d5BoN75fF1hhFH",
                    //             "senderPublicKey":"AHXn8nBA4SfLQF7hLQiSn16kxyehjizBGW1TdrmSZ1gF",
                    //             "matcherPublicKey":"9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5",
                    //             "assetPair":{
                    //                 "amountAsset":"C1iWsKGqLwjHUndiQ7iXpdmPum9PeCDFfyXBdJJosDRS",
                    //                 "priceAsset":"WAVES"
                    //             },
                    //             "orderType":"buy",
                    //             "amount":110874978,
                    //             "price":514397851,
                    //             "timestamp":1650473255988,
                    //             "expiration":1652892455988,
                    //             "matcherFee":7074571,
                    //             "matcherFeeAssetId":"Atqv59EYzjFGuitKVnMRk6H8FukjoV3ktPorbEys25on",
                    //             "signature":"5Vgs6mbdZJv5Ce9mdobT6fppXr6bKn5WVDbzP6mGG5jMB5jgcA2eSScwctgvY5SwPm9n1bctAAKuXtLcdHjNNie8",
                    //             "proofs":["5Vgs6mbdZJv5Ce9mdobT6fppXr6bKn5WVDbzP6mGG5jMB5jgcA2eSScwctgvY5SwPm9n1bctAAKuXtLcdHjNNie8"]
                    //         },
                    //         "status":"OrderAccepted"
                    //     }
                    //
                    if (isMarketOrder) {
                        const response = await this.matcherPostMatcherOrderbookMarket(body);
                        const value = this.safeValue(response, 'message');
                        return this.parseOrder(value, market);
                    } else {
                        const response = await this.matcherPostMatcherOrderbook(body);
                        const value = this.safeValue(response, 'message');
                        return this.parseOrder(value, market);
                    }
                }
                async cancelOrder(id, symbol, params = {}) {
                    this.checkRequiredDependencies();
                    this.checkRequiredKeys();
                    await this.signIn();
                    const wavesAddress = await this.getWavesAddress();
                    const response = await this.forwardPostMatcherOrdersWavesAddressCancel({
                        'wavesAddress': wavesAddress,
                        'orderId': id
                    });
                    //  {
                    //    "success":true,
                    //    "message":[[{"orderId":"EBpJeGM36KKFz5gTJAUKDBm89V8wqxKipSFBdU35AN3c","success":true,"status":"OrderCanceled"}]],
                    //    "status":"BatchCancelCompleted"
                    //  }
                    const message = this.safeValue(response, 'message');
                    const firstMessage = this.safeValue(message, 0);
                    const firstOrder = this.safeValue(firstMessage, 0);
                    const returnedId = this.safeString(firstOrder, 'orderId');
                    return {
                        'info': response,
                        'id': returnedId,
                        'clientOrderId': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': undefined,
                        'side': undefined,
                        'price': undefined,
                        'amount': undefined,
                        'cost': undefined,
                        'average': undefined,
                        'filled': undefined,
                        'remaining': undefined,
                        'status': undefined,
                        'fee': undefined,
                        'trades': undefined
                    };
                }
                async fetchOrder(id, symbol, params = {}) {
                    this.checkRequiredDependencies();
                    this.checkRequiredKeys();
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const timestamp = this.milliseconds();
                    const byteArray = [
                        this.base58ToBinary(this.apiKey),
                        this.numberToBE(timestamp, 8)
                    ];
                    const binary = this.binaryConcatArray(byteArray);
                    const hexSecret = this.binaryToBase16(this.base58ToBinary(this.secret));
                    const signature = this.eddsa(this.binaryToBase16(binary), hexSecret, 'ed25519');
                    const request = {
                        'Timestamp': timestamp.toString(),
                        'Signature': signature,
                        'publicKey': this.apiKey,
                        'orderId': id
                    };
                    const response = await this.matcherGetMatcherOrderbookPublicKeyOrderId(this.extend(request, params));
                    return this.parseOrder(response, market);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    this.checkRequiredDependencies();
                    this.checkRequiredKeys();
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const timestamp = this.milliseconds();
                    const byteArray = [
                        this.base58ToBinary(this.apiKey),
                        this.numberToBE(timestamp, 8)
                    ];
                    const binary = this.binaryConcatArray(byteArray);
                    const hexSecret = this.binaryToBase16(this.base58ToBinary(this.secret));
                    const signature = this.eddsa(this.binaryToBase16(binary), hexSecret, 'ed25519');
                    const request = {
                        'Accept': 'application/json',
                        'Timestamp': timestamp.toString(),
                        'Signature': signature,
                        'publicKey': this.apiKey,
                        'baseId': market['baseId'],
                        'quoteId': market['quoteId']
                    };
                    const response = await this.matcherGetMatcherOrderbookBaseIdQuoteIdPublicKeyPublicKey(this.extend(request, params));
                    // [ { id: '3KicDeWayY2mdrRoYdCkP3gUAoUZUNT1AA6GAtWuPLfa',
                    //     type: 'sell',
                    //     orderType: 'limit',
                    //     amount: 1,
                    //     fee: 300000,
                    //     price: 100000000,
                    //     timestamp: 1591651254076,
                    //     filled: 0,
                    //     filledFee: 0,
                    //     feeAsset: 'WAVES',
                    //     status: 'Accepted',
                    //     assetPair:
                    //      { amountAsset: null,
                    //        priceAsset: '8LQW8f7P5d5PZM7GtZEBgaqRPGSzS3DfPuiXrURJ4AJS' },
                    //     avgWeighedPrice: 0 }, ... ]
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.signIn();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const address = await this.getWavesAddress();
                    const request = {
                        'address': address,
                        'activeOnly': true
                    };
                    const response = await this.forwardGetMatcherOrdersAddress(request);
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.signIn();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const address = await this.getWavesAddress();
                    const request = {
                        'address': address,
                        'closedOnly': true
                    };
                    const response = await this.forwardGetMatcherOrdersAddress(request);
                    // [
                    //   {
                    //     "id": "9aXcxvXai73jbAm7tQNnqaQ2PwUjdmWuyjvRTKAHsw4f",
                    //     "type": "buy",
                    //     "orderType": "limit",
                    //     "amount": 23738330,
                    //     "fee": 300000,
                    //     "price": 3828348334,
                    //     "timestamp": 1591926905636,
                    //     "filled": 23738330,
                    //     "filledFee": 300000,
                    //     "feeAsset": "WAVES",
                    //     "status": "Filled",
                    //     "assetPair": {
                    //       "amountAsset": "HZk1mbfuJpmxU1Fs4AX5MWLVYtctsNcg6e2C6VKqK8zk",
                    //       "priceAsset": null
                    //     },
                    //     "avgWeighedPrice": 3828348334
                    //   }, ...
                    // ]
                    return this.parseOrders(response, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'Cancelled': 'canceled',
                        'Accepted': 'open',
                        'Filled': 'closed',
                        'PartiallyFilled': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                getSymbolFromAssetPair(assetPair) {
                    // a blank string or null can indicate WAVES
                    const baseId = this.safeString(assetPair, 'amountAsset', 'WAVES');
                    const quoteId = this.safeString(assetPair, 'priceAsset', 'WAVES');
                    return this.safeCurrencyCode(baseId) + '/' + this.safeCurrencyCode(quoteId);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         'version': 3,
                    //         'id': 'BshyeHXDfJmTnjTdBYt371jD4yWaT3JTP6KpjpsiZepS',
                    //         'sender': '3P8VzLSa23EW5CVckHbV7d5BoN75fF1hhFH',
                    //         'senderPublicKey': 'AHXn8nBA4SfLQF7hLQiSn16kxyehjizBGW1TdrmSZ1gF',
                    //         'matcherPublicKey': '9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5',
                    //         'assetPair': {
                    //             'amountAsset': '474jTeYx2r2Va35794tCScAXWJG9hU2HcgxzMowaZUnu',
                    //             'priceAsset': 'DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p',
                    //         },
                    //         'orderType': 'buy',
                    //         'amount': 10000,
                    //         'price': 400000000,
                    //         'timestamp': 1599848586891,
                    //         'expiration': 1602267786891,
                    //         'matcherFee': 3008,
                    //         'matcherFeeAssetId': '474jTeYx2r2Va35794tCScAXWJG9hU2HcgxzMowaZUnu',
                    //         'signature': '3D2h8ubrhuWkXbVn4qJ3dvjmZQxLoRNfjTqb9uNpnLxUuwm4fGW2qGH6yKFe2SQPrcbgkS3bDVe7SNtMuatEJ7qy',
                    //         'proofs': [
                    //             '3D2h8ubrhuWkXbVn4qJ3dvjmZQxLoRNfjTqb9uNpnLxUuwm4fGW2qGH6yKFe2SQPrcbgkS3bDVe7SNtMuatEJ7qy',
                    //         ],
                    //     }
                    //
                    //
                    // fetchOrder, fetchOrders, fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         id: '81D9uKk2NfmZzfG7uaJsDtxqWFbJXZmjYvrL88h15fk8',
                    //         type: 'buy',
                    //         orderType: 'limit',
                    //         amount: 30000000000,
                    //         filled: 0,
                    //         price: 1000000,
                    //         fee: 300000,
                    //         filledFee: 0,
                    //         feeAsset: 'WAVES',
                    //         timestamp: 1594303779322,
                    //         status: 'Cancelled',
                    //         assetPair: {
                    //             amountAsset: '474jTeYx2r2Va35794tCScAXWJG9hU2HcgxzMowaZUnu',
                    //             priceAsset: 'WAVES'
                    //         },
                    //         avgWeighedPrice: 0,
                    //         version: 3,
                    //         totalExecutedPriceAssets: 0,  // in fetchOpenOrder/s
                    //     }
                    //
                    const timestamp = this.safeInteger(order, 'timestamp');
                    const side = this.safeString2(order, 'type', 'orderType');
                    let type = 'limit';
                    if ('type' in order) // fetchOrders
                    type = this.safeString(order, 'orderType', type);
                    const id = this.safeString(order, 'id');
                    const filledString = this.safeString(order, 'filled');
                    const priceString = this.safeString(order, 'price');
                    const amountString = this.safeString(order, 'amount');
                    const assetPair = this.safeValue(order, 'assetPair');
                    let symbol = undefined;
                    if (assetPair !== undefined) symbol = this.getSymbolFromAssetPair(assetPair);
                    else if (market !== undefined) symbol = market['symbol'];
                    const amountCurrency = this.safeCurrencyCode(this.safeString(assetPair, 'amountAsset', 'WAVES'));
                    const price = this.priceFromPrecision(symbol, priceString);
                    const amount = this.currencyFromPrecision(amountCurrency, amountString);
                    const filled = this.currencyFromPrecision(amountCurrency, filledString);
                    const average = this.priceFromPrecision(symbol, this.safeString(order, 'avgWeighedPrice'));
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    let fee = undefined;
                    if ('type' in order) {
                        const currency = this.safeCurrencyCode(this.safeString(order, 'feeAsset'));
                        fee = {
                            'currency': currency,
                            'fee': this.parseNumber(this.currencyFromPrecision(currency, this.safeString(order, 'filledFee')))
                        };
                    } else {
                        const currency = this.safeCurrencyCode(this.safeString(order, 'matcherFeeAssetId', 'WAVES'));
                        fee = {
                            'currency': currency,
                            'fee': this.parseNumber(this.currencyFromPrecision(currency, this.safeString(order, 'matcherFee')))
                        };
                    }
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'average': average,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async getWavesAddress() {
                    const cachedAddreess = this.safeString(this.options, 'wavesAddress');
                    if (cachedAddreess === undefined) {
                        const request = {
                            'publicKey': this.apiKey
                        };
                        const response = await this.nodeGetAddressesPublicKeyPublicKey(request);
                        this.options['wavesAddress'] = this.safeString(response, 'address');
                        return this.options['wavesAddress'];
                    } else return cachedAddreess;
                }
                async fetchBalance(params = {}) {
                    // makes a lot of different requests to get all the data
                    // in particular:
                    // fetchMarkets, getWavesAddress,
                    // getTotalBalance (doesn't include waves), getReservedBalance (doesn't include waves)
                    // getReservedBalance (includes WAVES)
                    // I couldn't find another way to get all the data
                    this.checkRequiredDependencies();
                    this.checkRequiredKeys();
                    await this.loadMarkets();
                    const wavesAddress = await this.getWavesAddress();
                    const request = {
                        'address': wavesAddress
                    };
                    const totalBalance = await this.nodeGetAssetsBalanceAddress(request);
                    // {
                    //   "address": "3P8VzLSa23EW5CVckHbV7d5BoN75fF1hhFH",
                    //   "balances": [
                    //     {
                    //       "assetId": "DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p",
                    //       "balance": 1177200,
                    //       "reissuable": false,
                    //       "minSponsoredAssetFee": 7420,
                    //       "sponsorBalance": 47492147189709,
                    //       "quantity": 999999999775381400,
                    //       "issueTransaction": {
                    //         "senderPublicKey": "BRnVwSVctnV8pge5vRpsJdWnkjWEJspFb6QvrmZvu3Ht",
                    //         "quantity": 1000000000000000000,
                    //         "fee": 100400000,
                    //         "description": "Neutrino USD",
                    //         "type": 3,
                    //         "version": 2,
                    //         "reissuable": false,
                    //         "script": null,
                    //         "sender": "3PC9BfRwJWWiw9AREE2B3eWzCks3CYtg4yo",
                    //         "feeAssetId": null,
                    //         "chainId": 87,
                    //         "proofs": [
                    //           "3HNpbVkgP69NWSeb9hGYauiQDaXrRXh3tXFzNsGwsAAXnFrA29SYGbLtziW9JLpXEq7qW1uytv5Fnm5XTUMB2BxU"
                    //         ],
                    //         "assetId": "DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p",
                    //         "decimals": 6,
                    //         "name": "USD-N",
                    //         "id": "DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p",
                    //         "timestamp": 1574429393962
                    //       }
                    //     }
                    //   ]
                    // }
                    const balances = this.safeValue(totalBalance, 'balances');
                    const result = {};
                    let timestamp = undefined;
                    const assetIds = [];
                    const nonStandardBalances = [];
                    for(let i = 0; i < balances.length; i++){
                        const entry = balances[i];
                        const entryTimestamp = this.safeInteger(entry, 'timestamp');
                        timestamp = timestamp === undefined ? entryTimestamp : Math.max(timestamp, entryTimestamp);
                        const issueTransaction = this.safeValue(entry, 'issueTransaction');
                        const currencyId = this.safeString(entry, 'assetId');
                        const balance = this.safeString(entry, 'balance');
                        if (issueTransaction === undefined) {
                            assetIds.push(currencyId);
                            nonStandardBalances.push(balance);
                            continue;
                        }
                        const decimals = this.safeInteger(issueTransaction, 'decimals');
                        let code = undefined;
                        if (currencyId in this.currencies_by_id) {
                            code = this.safeCurrencyCode(currencyId);
                            result[code] = this.account();
                            result[code]['total'] = this.fromPrecision(balance, decimals);
                        }
                    }
                    const nonStandardAssets = assetIds.length;
                    if (nonStandardAssets) {
                        const request = {
                            'ids': assetIds
                        };
                        const response = await this.publicGetAssets(request);
                        const data = this.safeValue(response, 'data');
                        for(let i = 0; i < data.length; i++){
                            const entry = data[i];
                            const balance = nonStandardBalances[i];
                            const inner = this.safeValue(entry, 'data');
                            const decimals = this.safeInteger(inner, 'precision');
                            const ticker = this.safeString(inner, 'ticker');
                            const code = this.safeCurrencyCode(ticker);
                            result[code] = this.account();
                            result[code]['total'] = this.fromPrecision(balance, decimals);
                        }
                    }
                    const currentTimestamp = this.milliseconds();
                    const byteArray = [
                        this.base58ToBinary(this.apiKey),
                        this.numberToBE(currentTimestamp, 8)
                    ];
                    const binary = this.binaryConcatArray(byteArray);
                    const hexSecret = this.binaryToBase16(this.base58ToBinary(this.secret));
                    const signature = this.eddsa(this.binaryToBase16(binary), hexSecret, 'ed25519');
                    const matcherRequest = {
                        'publicKey': this.apiKey,
                        'signature': signature,
                        'timestamp': currentTimestamp.toString()
                    };
                    const reservedBalance = await this.matcherGetMatcherBalanceReservedPublicKey(matcherRequest);
                    // { WAVES: 200300000 }
                    const reservedKeys = Object.keys(reservedBalance);
                    for(let i = 0; i < reservedKeys.length; i++){
                        const currencyId = reservedKeys[i];
                        const code = this.safeCurrencyCode(currencyId);
                        if (!(code in result)) result[code] = this.account();
                        const amount = this.safeString(reservedBalance, currencyId);
                        if (code in this.currencies) result[code]['used'] = this.currencyFromPrecision(code, amount);
                        else result[code]['used'] = amount;
                    }
                    const wavesRequest = {
                        'address': wavesAddress
                    };
                    const wavesTotal = await this.nodeGetAddressesBalanceAddress(wavesRequest);
                    // {
                    //   "address": "3P8VzLSa23EW5CVckHbV7d5BoN75fF1hhFH",
                    //   "confirmations": 0,
                    //   "balance": 909085978
                    // }
                    result['WAVES'] = this.safeValue(result, 'WAVES', {});
                    result['WAVES']['total'] = this.currencyFromPrecision('WAVES', this.safeString(wavesTotal, 'balance'));
                    const codes = Object.keys(result);
                    for(let i = 0; i < codes.length; i++){
                        const code = codes[i];
                        if (this.safeValue(result[code], 'used') === undefined) result[code]['used'] = '0';
                    }
                    result['timestamp'] = timestamp;
                    result['datetime'] = this.iso8601(timestamp);
                    return this.safeBalance(result);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const address = await this.getWavesAddress();
                    const request = {
                        'sender': address,
                        'amountAsset': market['baseId'],
                        'priceAsset': market['quoteId']
                    };
                    const response = await this.publicGetTransactionsExchange(request);
                    const data = this.safeValue(response, 'data');
                    //
                    //      {
                    //          "__type":"list",
                    //          "isLastPage":true,
                    //          "lastCursor":"MzA2MjQ0MzAwMDI5OjpkZXNj",
                    //          "data": [
                    //              {
                    //                  "__type":"transaction",
                    //                  "data": {
                    //                      "id":"GbjPqco2wRP5QSrY5LimFrUyJaM535K9nhK5zaQ7J7Tx",
                    //                      "timestamp":"2022-04-06T19:56:31.479Z",
                    //                      "height":3062443,
                    //                      "type":7,
                    //                      "version":2,
                    //                      "proofs":[
                    //                          "57mYrANw61eiArCTv2eYwzXm71jYC2KpZ5AeM9zHEstuRaYSAWSuSE7njAJYJu8zap6DMCm3nzqc6es3wQFDpRCN"
                    //                      ],
                    //                      "fee":0.003,
                    //                      "applicationStatus":"succeeded",
                    //                      "sender":"3PEjHv3JGjcWNpYEEkif2w8NXV4kbhnoGgu",
                    //                      "senderPublicKey":"9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5",
                    //                      "buyMatcherFee":0,
                    //                      "sellMatcherFee":0.00141728,
                    //                      "price":215.7431,
                    //                      "amount":0.09,
                    //                      "order1": {
                    //                          "id":"49qiuQj5frdZ6zpTCEpMuKPMAh1EimwXpXWB4BeCw33h",
                    //                          "senderPublicKey":"CjUfoH3dsDZsf5UuAjqqzpWHXgvKzBZpVG9YixF7L48K",
                    //                          "matcherPublicKey":"9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5",
                    //                          "assetPair": {
                    //                              "amountAsset":"7TMu26hAs7B2oW6c5sfx45KSZT7GQA3TZNYuCav8Dcqt",
                    //                              "priceAsset":"DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p"
                    //                          },
                    //                          "orderType":"buy",
                    //                          "price":215.7431,
                    //                          "sender":"3PR9WmaHV5ueVw2Wr9xsiCG3t4ySXzkkGLy",
                    //                          "amount":0.36265477,
                    //                          "timestamp":"2022-04-06T19:55:06.832Z",
                    //                          "expiration":"2022-05-05T19:55:06.832Z",
                    //                          "matcherFee":3.000334,
                    //                          "signature":"2rBWhdeuRJNpQfXfTFtcR8x8Lpic8FUHPdLML9uxABRUuxe48YRJcZxbncwWAh9LWFCEUZiztv7RZBZfGMWfFxTs",
                    //                          "matcherFeeAssetId":"DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p"
                    //                      },
                    //                      "order2": {
                    //                          "id":"AkxiJqCuv6wm8K41TUSgFNwShZMnCbMDT78MqrcWpQ53",
                    //                          "senderPublicKey":"72o7qNKyne5hthB1Ww6famE7uHrk5vTVB2ZfUMBEqL3Y",
                    //                          "matcherPublicKey":"9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5",
                    //                          "assetPair": {
                    //                              "amountAsset":"7TMu26hAs7B2oW6c5sfx45KSZT7GQA3TZNYuCav8Dcqt",
                    //                              "priceAsset":"DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p"
                    //                          },
                    //                          "orderType":"sell",
                    //                          "price":210,
                    //                          "sender":"3P3CzbjGgiqEyUBeKZYfgZtyaZfMG8fjoUD",
                    //                          "amount":0.09,
                    //                          "timestamp":"2022-04-06T19:56:18.535Z",
                    //                          "expiration":"2022-05-04T19:56:18.535Z",
                    //                          "matcherFee":0.00141728,
                    //                          "signature":"5BZCjYn6QzVkMXBFDBnzcAUBdCZqhq9hQfRXFHfLUQCsbis4zeriw4sUqLa1BZRT2isC6iY4Z4HtekikPqZ461PT",
                    //                          "matcherFeeAssetId":"7TMu26hAs7B2oW6c5sfx45KSZT7GQA3TZNYuCav8Dcqt"
                    //                      }
                    //                  }
                    //              },...
                    //          ]
                    //      }
                    //
                    return this.parseTrades(data, market, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'amountAsset': market['baseId'],
                        'priceAsset': market['quoteId']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    if (since !== undefined) request['timeStart'] = since;
                    const response = await this.publicGetTransactionsExchange(request);
                    const data = this.safeValue(response, 'data');
                    //
                    //      {
                    //          "__type":"list",
                    //          "isLastPage":false,
                    //          "lastCursor":"MzA2MjM2MTAwMDU0OjpkZXNj",
                    //          "data": [
                    //              {
                    //                  "__type":"transaction",
                    //                  "data": {
                    //                      "id":"F42WsvSsyEzvpPLFjVhQKkSNuopooP4zMkjSUs47NeML",
                    //                      "timestamp":"2022-04-06T18:39:49.145Z",
                    //                      "height":3062361,
                    //                      "type":7,
                    //                      "version":2,
                    //                      "proofs": [
                    //                          "39iJv82kFi4pyuBxYeZpP45NXXjbrCXdVsHPAAvj32UMLmTXLjMTfV43PcmZDSAuS93HKSDo1aKJrin8UvkeE9Bs"
                    //                      ],
                    //                      "fee":0.003,
                    //                      "applicationStatus":"succeeded",
                    //                      "sender":"3PEjHv3JGjcWNpYEEkif2w8NXV4kbhnoGgu",
                    //                      "senderPublicKey":"9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5",
                    //                      "buyMatcherFee":0.02314421,
                    //                      "sellMatcherFee":0,
                    //                      "price":217.3893,
                    //                      "amount":0.34523025,
                    //                      "order1": {
                    //                          "id":"HkM36PHGaeeZdDKT1mYgZXhaU9PRZ54RZiJc2K4YMT3Q",
                    //                          "senderPublicKey":"7wYCaDcc6GX1Jx2uS7QgLHBypBKvrezTS1HfiW6Xe4Bk",
                    //                          "matcherPublicKey":"9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5",
                    //                          "assetPair": {
                    //                              "amountAsset":"7TMu26hAs7B2oW6c5sfx45KSZT7GQA3TZNYuCav8Dcqt",
                    //                              "priceAsset":"DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p"
                    //                          },
                    //                          "orderType":"buy",
                    //                          "price":225.2693,
                    //                          "sender":"3PLPc8f4DGYaF9C9bwJ2uVmHqRv3NCjg5VQ",
                    //                          "amount":2.529,
                    //                          "timestamp":"2022-04-06T18:39:48.796Z",
                    //                          "expiration":"2022-05-05T18:39:48.796Z",
                    //                          "matcherFee":0.17584444,
                    //                          "signature":"2yQfJoomv86evQDw36fg1uiRkHvPDZtRp3qvxqTBWPvz4JLTHGQtEHJF5NGTvym6U93CtgNprngzmD9ecHBjxf6U",
                    //                          "matcherFeeAssetId":"Atqv59EYzjFGuitKVnMRk6H8FukjoV3ktPorbEys25on"
                    //                      },
                    //                      "order2": {
                    //                          "id":"F7HKmeuzwWdk3wKitHLnVx5MuD4wBWPpphQ8kUGx4tT9",
                    //                          "senderPublicKey":"CjUfoH3dsDZsf5UuAjqqzpWHXgvKzBZpVG9YixF7L48K",
                    //                          "matcherPublicKey":"9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5",
                    //                          "assetPair": {
                    //                              "amountAsset":"7TMu26hAs7B2oW6c5sfx45KSZT7GQA3TZNYuCav8Dcqt",
                    //                              "priceAsset":"DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p"
                    //                          },
                    //                          "orderType":"sell",
                    //                          "price":217.3893,
                    //                          "sender":"3PR9WmaHV5ueVw2Wr9xsiCG3t4ySXzkkGLy",
                    //                          "amount":0.35767793,
                    //                          "timestamp":"2022-04-06T18:32:01.390Z",
                    //                          "expiration":"2022-05-05T18:32:01.390Z",
                    //                          "matcherFee":0.0139168,
                    //                          "signature":"34HgWVLPgeYWkiSvAc5ChVepGTYDQDug2dMTSincs6idEyoM7AtaZuH3mqQ5RJG2fcxxH2QSB723Qq3dgLQwQmKf",
                    //                          "matcherFeeAssetId":"7TMu26hAs7B2oW6c5sfx45KSZT7GQA3TZNYuCav8Dcqt"
                    //                      }
                    //                  }
                    //              }, ...
                    //          ]
                    //      }
                    //
                    return this.parseTrades(data, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // { __type: 'transaction',
                    //   data:
                    //    { id: 'HSdruioHqvYHeyn9hhyoHdRWPB2bFA8ujeCPZMK6992c',
                    //      timestamp: '2020-06-09T19:34:51.897Z',
                    //      height: 2099684,
                    //      type: 7,
                    //      version: 2,
                    //      proofs:
                    //       [ '26teDHERQgwjjHqEn4REcDotNG8M21xjou3X42XuDuCvrRkQo6aPyrswByH3UrkWG8v27ZAaVNzoxDg4teNcLtde' ],
                    //      fee: 0.003,
                    //      sender: '3PEjHv3JGjcWNpYEEkif2w8NXV4kbhnoGgu',
                    //      senderPublicKey: '9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5',
                    //      buyMatcherFee: 0.00299999,
                    //      sellMatcherFee: 0.00299999,
                    //      price: 0.00012003,
                    //      amount: 60.80421562,
                    //      order1:
                    //       { id: 'CBRwP3ar4oMvvpUiGyfxc1syh41488SDi2GkrjuBDegv',
                    //         senderPublicKey: 'DBXSHBz96NFsMu7xh4fi2eT9ZnyxefAHXsMxUayzgC6a',
                    //         matcherPublicKey: '9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5',
                    //         assetPair: [Object],
                    //         orderType: 'buy',
                    //         price: 0.00012003,
                    //         sender: '3PJfFRgVuJ47UY4ckb74EGzEBzkHXtmG1LA',
                    //         amount: 60.80424773,
                    //         timestamp: '2020-06-09T19:34:51.885Z',
                    //         expiration: '2020-06-10T12:31:31.885Z',
                    //         matcherFee: 0.003,
                    //         signature: '4cA3ZAb3XAEEXaFG7caqpto5TRbpR5PkhZpxoNQZ9ZReNvjuJQs5a3THnumv7rcqmVUiVtuHAgk2f67ANcqtKyJ8',
                    //         matcherFeeAssetId: null },
                    //      order2:
                    //       { id: 'CHJSLQ6dfSPs6gu2mAegrMUcRiDEDqaj2GKfvptMjS3M',
                    //         senderPublicKey: '3RUC4NGFZm9H8VJhSSjJyFLdiE42qNiUagDcZPwjgDf8',
                    //         matcherPublicKey: '9cpfKN9suPNvfeUNphzxXMjcnn974eme8ZhWUjaktzU5',
                    //         assetPair: [Object],
                    //         orderType: 'sell',
                    //         price: 0.00012003,
                    //         sender: '3P9vKoQpMZtaSkHKpNh977YY9ZPzTuntLAq',
                    //         amount: 60.80424773,
                    //         timestamp: '2020-06-09T19:34:51.887Z',
                    //         expiration: '2020-06-10T12:31:31.887Z',
                    //         matcherFee: 0.003,
                    //         signature: '3SFyrcqzou2ddZyNisnLYaGhLt5qRjKxH8Nw3s4T5U7CEKGX9DDo8dS27RgThPVGbYF1rYET1FwrWoQ2UFZ6SMTR',
                    //         matcherFeeAssetId: null } } }
                    //
                    const data = this.safeValue(trade, 'data');
                    const datetime = this.safeString(data, 'timestamp');
                    const timestamp = this.parse8601(datetime);
                    const id = this.safeString(data, 'id');
                    const priceString = this.safeString(data, 'price');
                    const amountString = this.safeString(data, 'amount');
                    const order1 = this.safeValue(data, 'order1');
                    const order2 = this.safeValue(data, 'order2');
                    let order = undefined;
                    // order2 arrived after order1
                    if (this.safeString(order1, 'senderPublicKey') === this.apiKey) order = order1;
                    else order = order2;
                    let symbol = undefined;
                    const assetPair = this.safeValue(order, 'assetPair');
                    if (assetPair !== undefined) symbol = this.getSymbolFromAssetPair(assetPair);
                    else if (market !== undefined) symbol = market['symbol'];
                    const side = this.safeString(order, 'orderType');
                    const orderId = this.safeString(order, 'id');
                    const fee = {
                        'cost': this.safeString(order, 'matcherFee'),
                        'currency': this.safeCurrencyCode(this.safeString(order, 'matcherFeeAssetId', 'WAVES'))
                    };
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'symbol': symbol,
                        'id': id,
                        'order': orderId,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    const errorCode = this.safeString(response, 'error');
                    const success = this.safeValue(response, 'success', true);
                    const Exception1 = this.safeValue(this.exceptions, errorCode);
                    if (Exception1 !== undefined) {
                        const message = this.safeString(response, 'message');
                        throw new Exception1(this.id + ' ' + message);
                    }
                    const message = this.safeString(response, 'message');
                    if (message === 'Validation Error') throw new BadRequest(this.id + ' ' + body);
                    if (!success) throw new ExchangeError1(this.id + ' ' + body);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    // currently only works for BTC and WAVES
                    if (code !== 'WAVES') {
                        const supportedCurrencies = await this.privateGetWithdrawCurrencies();
                        const currencies = {};
                        const items = this.safeValue(supportedCurrencies, 'items', []);
                        for(let i = 0; i < items.length; i++){
                            const entry = items[i];
                            const currencyCode = this.safeString(entry, 'id');
                            currencies[currencyCode] = true;
                        }
                        if (!(code in currencies)) {
                            const codes = Object.keys(currencies);
                            throw new ExchangeError1(this.id + ' withdraw() ' + code + ' not supported. Currency code must be one of ' + codes.toString());
                        }
                    }
                    await this.loadMarkets();
                    const hexChars = [
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        'a',
                        'b',
                        'c',
                        'd',
                        'e',
                        'f'
                    ];
                    const set = {};
                    for(let i = 0; i < hexChars.length; i++){
                        const key = hexChars[i];
                        set[key] = true;
                    }
                    let isErc20 = true;
                    const noPrefix = this.remove0xPrefix(address);
                    const lower = noPrefix.toLowerCase();
                    for(let i = 0; i < lower.length; i++){
                        const character = lower[i];
                        if (!(character in set)) {
                            isErc20 = false;
                            break;
                        }
                    }
                    await this.signIn();
                    let proxyAddress = undefined;
                    if (code === 'WAVES' && !isErc20) proxyAddress = address;
                    else {
                        const withdrawAddressRequest = {
                            'address': address,
                            'currency': code
                        };
                        const withdrawAddress = await this.privateGetWithdrawAddressesCurrencyAddress(withdrawAddressRequest);
                        const currency = this.safeValue(withdrawAddress, 'currency');
                        const allowedAmount = this.safeValue(currency, 'allowed_amount');
                        const minimum = this.safeNumber(allowedAmount, 'min');
                        if (amount <= minimum) throw new BadRequest(this.id + ' ' + code + ' withdraw failed, amount ' + amount.toString() + ' must be greater than the minimum allowed amount of ' + minimum.toString());
                        // {
                        //   "type": "withdrawal_addresses",
                        //   "currency": {
                        //     "type": "withdrawal_currency",
                        //     "id": "BTC",
                        //     "waves_asset_id": "8LQW8f7P5d5PZM7GtZEBgaqRPGSzS3DfPuiXrURJ4AJS",
                        //     "decimals": 8,
                        //     "status": "active",
                        //     "allowed_amount": {
                        //       "min": 0.001,
                        //       "max": 20
                        //     },
                        //     "fees": {
                        //       "flat": 0.001,
                        //       "rate": 0
                        //     }
                        //   },
                        //   "proxy_addresses": [
                        //     "3P3qqmkiLwNHB7x1FeoE8bvkRtULwGpo9ga"
                        //   ]
                        // }
                        const proxyAddresses = this.safeValue(withdrawAddress, 'proxy_addresses', []);
                        proxyAddress = this.safeString(proxyAddresses, 0);
                    }
                    const fee = this.safeInteger(this.options, 'withdrawFeeWAVES', 100000); // 0.001 WAVES
                    const feeAssetId = 'WAVES';
                    const type = 4; // transfer
                    const version = 2;
                    const amountInteger = this.currencyToPrecision(code, amount);
                    const currency = this.currency(code);
                    const timestamp = this.milliseconds();
                    const byteArray = [
                        this.numberToBE(4, 1),
                        this.numberToBE(2, 1),
                        this.base58ToBinary(this.apiKey),
                        this.getAssetBytes(currency['id']),
                        this.getAssetBytes(feeAssetId),
                        this.numberToBE(timestamp, 8),
                        this.numberToBE(amountInteger, 8),
                        this.numberToBE(fee, 8),
                        this.base58ToBinary(proxyAddress),
                        this.numberToBE(0, 2)
                    ];
                    const binary = this.binaryConcatArray(byteArray);
                    const hexSecret = this.binaryToBase16(this.base58ToBinary(this.secret));
                    const signature = this.eddsa(this.binaryToBase16(binary), hexSecret, 'ed25519');
                    const request = {
                        'senderPublicKey': this.apiKey,
                        'amount': amountInteger,
                        'fee': fee,
                        'type': type,
                        'version': version,
                        'attachment': '',
                        'feeAssetId': this.getAssetId(feeAssetId),
                        'proofs': [
                            signature
                        ],
                        'assetId': this.getAssetId(currency['id']),
                        'recipient': proxyAddress,
                        'timestamp': timestamp,
                        'signature': signature
                    };
                    const result = await this.nodePostTransactionsBroadcast(request);
                    //
                    //     {
                    //         "id": "string",
                    //         "signature": "string",
                    //         "fee": 0,
                    //         "timestamp": 1460678400000,
                    //         "recipient": "3P274YB5qseSE9DTTL3bpSjosZrYBPDpJ8k",
                    //         "amount": 0
                    //     }
                    //
                    return this.parseTransaction(result, currency);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "id": "string",
                    //         "signature": "string",
                    //         "fee": 0,
                    //         "timestamp": 1460678400000,
                    //         "recipient": "3P274YB5qseSE9DTTL3bpSjosZrYBPDpJ8k",
                    //         "amount": 0
                    //     }
                    //
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'id': undefined,
                        'txid': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': undefined,
                        'info': transaction
                    };
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    168: [
        function(require1, module, exports) {
            'use strict';
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, BadRequest: BadRequest, RateLimitExceeded: RateLimitExceeded, BadSymbol: BadSymbol, ArgumentsRequired: ArgumentsRequired1, PermissionDenied: PermissionDenied, InsufficientFunds: InsufficientFunds, InvalidOrder: InvalidOrder } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            module.exports = class wazirx extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'wazirx',
                        'name': 'WazirX',
                        'countries': [
                            'IN'
                        ],
                        'version': 'v2',
                        'rateLimit': 100,
                        'has': {
                            'CORS': false,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchBidsAsks': false,
                            'fetchClosedOrders': false,
                            'fetchCurrencies': false,
                            'fetchDepositAddress': false,
                            'fetchDepositAddressesByNetwork': false,
                            'fetchDeposits': true,
                            'fetchFundingFees': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': false,
                            'fetchOHLCV': false,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchStatus': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransactions': false,
                            'fetchTransfers': false,
                            'fetchWithdrawals': false,
                            'transfer': false,
                            'withdraw': false
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/148647666-c109c20b-f8ac-472f-91c3-5f658cb90f49.jpeg',
                            'api': 'https://api.wazirx.com/sapi/v1',
                            'www': 'https://wazirx.com',
                            'doc': 'https://docs.wazirx.com/#public-rest-api-for-wazirx',
                            'fees': 'https://wazirx.com/fees',
                            'referral': 'https://wazirx.com/invite/k7rrnks5'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'exchangeInfo': 1,
                                    'depth': 1,
                                    'ping': 1,
                                    'systemStatus': 1,
                                    'tickers/24hr': 1,
                                    'ticker/24hr': 1,
                                    'time': 1,
                                    'trades': 1
                                }
                            },
                            'private': {
                                'get': {
                                    'account': 1,
                                    'allOrders': 1,
                                    'funds': 1,
                                    'historicalTrades': 1,
                                    'openOrders': 1,
                                    'order': 1,
                                    'myTrades': 1
                                },
                                'post': {
                                    'order': 1,
                                    'order/test': 1
                                },
                                'delete': {
                                    'order': 1,
                                    'openOrders': 1
                                }
                            }
                        },
                        'fees': {
                            'WRX': {
                                'maker': this.parseNumber('0.0'),
                                'taker': this.parseNumber('0.0')
                            }
                        },
                        'exceptions': {
                            'exact': {
                                '-1121': BadSymbol,
                                '1999': BadRequest,
                                '2002': InsufficientFunds,
                                '2005': BadRequest,
                                '2078': PermissionDenied,
                                '2098': BadRequest,
                                '2031': InvalidOrder,
                                '2113': BadRequest,
                                '2115': BadRequest,
                                '2136': RateLimitExceeded,
                                '94001': InvalidOrder
                            }
                        },
                        'options': {
                            // 'fetchTradesMethod': 'privateGetHistoricalTrades',
                            'recvWindow': 10000
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetExchangeInfo(params);
                    //
                    // {
                    //     "timezone":"UTC",
                    //     "serverTime":1641336850932,
                    //     "symbols":[
                    //     {
                    //         "symbol":"btcinr",
                    //         "status":"trading",
                    //         "baseAsset":"btc",
                    //         "quoteAsset":"inr",
                    //         "baseAssetPrecision":5,
                    //         "quoteAssetPrecision":0,
                    //         "orderTypes":[
                    //             "limit",
                    //             "stop_limit"
                    //         ],
                    //         "isSpotTradingAllowed":true,
                    //         "filters":[
                    //             {
                    //                 "filterType":"PRICE_FILTER",
                    //                 "minPrice":"1",
                    //                 "tickSize":"1"
                    //             }
                    //         ]
                    //     },
                    //
                    const markets = this.safeValue(response, 'symbols', []);
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const entry = markets[i];
                        const id = this.safeString(entry, 'symbol');
                        const baseId = this.safeString(entry, 'baseAsset');
                        const quoteId = this.safeString(entry, 'quoteAsset');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const isSpot = this.safeValue(entry, 'isSpotTradingAllowed');
                        const filters = this.safeValue(entry, 'filters');
                        let minPrice = undefined;
                        for(let j = 0; j < filters.length; j++){
                            const filter = filters[j];
                            const filterType = this.safeString(filter, 'filterType');
                            if (filterType === 'PRICE_FILTER') minPrice = this.safeNumber(filter, 'minPrice');
                        }
                        const fee = this.safeValue(this.fees, quote, {});
                        let takerString = this.safeString(fee, 'taker', '0.2');
                        takerString = Precise.stringDiv(takerString, '100');
                        let makerString = this.safeString(fee, 'maker', '0.2');
                        makerString = Precise.stringDiv(makerString, '100');
                        const status = this.safeString(entry, 'status');
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': isSpot,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': status === 'trading',
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.parseNumber(takerString),
                            'maker': this.parseNumber(makerString),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(entry, 'baseAssetPrecision'),
                                'price': this.safeInteger(entry, 'quoteAssetPrecision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': minPrice,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': entry
                        });
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // [1, 5, 10, 20, 50, 100, 500, 1000]
                    const response = await this.publicGetDepth(this.extend(request, params));
                    //
                    //     {
                    //          "timestamp":1559561187,
                    //          "asks":[
                    //                     ["8540.0","1.5"],
                    //                     ["8541.0","0.0042"]
                    //                 ],
                    //          "bids":[
                    //                     ["8530.0","0.8814"],
                    //                     ["8524.0","1.4"]
                    //                 ]
                    //      }
                    //
                    const timestamp = this.safeInteger(response, 'timestamp');
                    return this.parseOrderBook(response, symbol, timestamp);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const ticker = await this.publicGetTicker24hr(this.extend(request, params));
                    //
                    // {
                    //     "symbol":"wrxinr",
                    //     "baseAsset":"wrx",
                    //     "quoteAsset":"inr",
                    //     "openPrice":"94.77",
                    //     "lowPrice":"92.7",
                    //     "highPrice":"95.17",
                    //     "lastPrice":"94.03",
                    //     "volume":"1118700.0",
                    //     "bidPrice":"94.02",
                    //     "askPrice":"94.03",
                    //     "at":1641382455000
                    // }
                    //
                    return this.parseTicker(ticker, market);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const tickers = await this.publicGetTickers24hr();
                    //
                    // [
                    //     {
                    //        "symbol":"btcinr",
                    //        "baseAsset":"btc",
                    //        "quoteAsset":"inr",
                    //        "openPrice":"3698486",
                    //        "lowPrice":"3641155.0",
                    //        "highPrice":"3767999.0",
                    //        "lastPrice":"3713212.0",
                    //        "volume":"254.11582",
                    //        "bidPrice":"3715021.0",
                    //        "askPrice":"3715022.0",
                    //     }
                    //     ...
                    // ]
                    //
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const ticker = tickers[i];
                        const parsedTicker = this.parseTicker(ticker);
                        const symbol = parsedTicker['symbol'];
                        result[symbol] = parsedTicker;
                    }
                    return result;
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // Default 500; max 1000.
                    const method = this.safeString(this.options, 'fetchTradesMethod', 'publicGetTrades');
                    const response = await this[method](this.extend(request, params));
                    // [
                    //     {
                    //         "id":322307791,
                    //         "price":"93.7",
                    //         "qty":"0.7",
                    //         "quoteQty":"65.59",
                    //         "time":1641386701000,
                    //         "isBuyerMaker":false
                    //     },
                    // ]
                    return this.parseTrades(response, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    //     {
                    //         "id":322307791,
                    //         "price":"93.7",
                    //         "qty":"0.7",
                    //         "quoteQty":"65.59",
                    //         "time":1641386701000,
                    //         "isBuyerMaker":false
                    //     }
                    //
                    const id = this.safeString(trade, 'id');
                    const timestamp = this.safeInteger(trade, 'time');
                    const datetime = this.iso8601(timestamp);
                    market = this.safeMarket(undefined, market);
                    const isBuyerMaker = this.safeValue(trade, 'isBuyerMaker');
                    const side = isBuyerMaker ? 'sell' : 'buy';
                    const price = this.safeNumber(trade, 'price');
                    const amount = this.safeNumber(trade, 'qty');
                    const cost = this.safeNumber(trade, 'quoteQty');
                    return this.safeTrade({
                        'info': trade,
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': datetime,
                        'symbol': market['symbol'],
                        'order': id,
                        'type': undefined,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': undefined
                    }, market);
                }
                async fetchStatus(params = {}) {
                    const response = await this.publicGetSystemStatus(params);
                    //
                    //     {
                    //         "status":"normal", // normal, system maintenance
                    //         "message":"System is running normally."
                    //     }
                    //
                    const status = this.safeString(response, 'status');
                    return {
                        'status': status === 'normal' ? 'ok' : 'maintenance',
                        'updated': this.milliseconds(),
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetTime(params);
                    //
                    //     {
                    //         "serverTime":1635467280514
                    //     }
                    //
                    return this.safeInteger(response, 'serverTime');
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //        "symbol":"btcinr",
                    //        "baseAsset":"btc",
                    //        "quoteAsset":"inr",
                    //        "openPrice":"3698486",
                    //        "lowPrice":"3641155.0",
                    //        "highPrice":"3767999.0",
                    //        "lastPrice":"3713212.0",
                    //        "volume":"254.11582", // base volume
                    //        "bidPrice":"3715021.0",
                    //        "askPrice":"3715022.0",
                    //        "at":1641382455000 // only on fetchTicker
                    //     }
                    //
                    const marketId = this.safeString(ticker, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const last = this.safeString(ticker, 'lastPrice');
                    const open = this.safeString(ticker, 'openPrice');
                    const high = this.safeString(ticker, 'highPrice');
                    const low = this.safeString(ticker, 'lowPrice');
                    const baseVolume = this.safeString(ticker, 'volume');
                    const bid = this.safeString(ticker, 'bidPrice');
                    const ask = this.safeString(ticker, 'askPrice');
                    const timestamp = this.safeString(ticker, 'at');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': high,
                        'low': low,
                        'bid': bid,
                        'bidVolume': undefined,
                        'ask': ask,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                parseBalance(response) {
                    const result = {};
                    for(let i = 0; i < response.length; i++){
                        const balance = response[i];
                        const id = this.safeString(balance, 'asset');
                        const code = this.safeCurrencyCode(id);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'free');
                        account['used'] = this.safeString(balance, 'locked');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privateGetFunds(params);
                    //
                    // [
                    //       {
                    //          "asset":"inr",
                    //          "free":"0.0",
                    //          "locked":"0.0"
                    //       },
                    // ]
                    //
                    return this.parseBalance(response);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a `symbol` argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetAllOrders(this.extend(request, params));
                    // [
                    //     {
                    //         "id": 28,
                    //         "symbol": "wrxinr",
                    //         "price": "9293.0",
                    //         "origQty": "10.0",
                    //         "executedQty": "8.2",
                    //         "status": "cancel",
                    //         "type": "limit",
                    //         "side": "sell",
                    //         "createdTime": 1499827319559,
                    //         "updatedTime": 1499827319559
                    //     },
                    //     {
                    //         "id": 30,
                    //         "symbol": "wrxinr",
                    //         "price": "9293.0",
                    //         "stopPrice": "9200.0",
                    //         "origQty": "10.0",
                    //         "executedQty": "0.0",
                    //         "status": "cancel",
                    //         "type": "stop_limit",
                    //         "side": "sell",
                    //         "createdTime": 1499827319559,
                    //         "updatedTime": 1507725176595
                    //     }
                    // ]
                    let orders = this.parseOrders(response, market, since, limit);
                    orders = this.filterBy(orders, 'symbol', symbol);
                    return orders;
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const response = await this.privateGetOpenOrders(this.extend(request, params));
                    // [
                    //     {
                    //         "id": 28,
                    //         "symbol": "wrxinr",
                    //         "price": "9293.0",
                    //         "origQty": "10.0",
                    //         "executedQty": "8.2",
                    //         "status": "cancel",
                    //         "type": "limit",
                    //         "side": "sell",
                    //         "createdTime": 1499827319559,
                    //         "updatedTime": 1499827319559
                    //     },
                    //     {
                    //         "id": 30,
                    //         "symbol": "wrxinr",
                    //         "price": "9293.0",
                    //         "stopPrice": "9200.0",
                    //         "origQty": "10.0",
                    //         "executedQty": "0.0",
                    //         "status": "cancel",
                    //         "type": "stop_limit",
                    //         "side": "sell",
                    //         "createdTime": 1499827319559,
                    //         "updatedTime": 1507725176595
                    //     }
                    // ]
                    const orders = this.parseOrders(response, market, since, limit);
                    return orders;
                }
                async cancelAllOrders(symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelAllOrders() requires a `symbol` argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    return await this.privateDeleteOpenOrders(this.extend(request, params));
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a `symbol` argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'orderId': id
                    };
                    const response = await this.privateDeleteOrder(this.extend(request, params));
                    return this.parseOrder(response);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    type = type.toLowerCase();
                    if (type !== 'limit' && type !== 'stop_limit') throw new ExchangeError1(this.id + ' createOrder() supports limit and stop_limit orders only');
                    if (price === undefined) throw new ExchangeError1(this.id + ' createOrder() requires a price argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'side': side,
                        'quantity': amount,
                        'type': 'limit'
                    };
                    request['price'] = this.priceToPrecision(symbol, price);
                    const stopPrice = this.safeString(params, 'stopPrice');
                    if (stopPrice !== undefined) request['type'] = 'stop_limit';
                    const response = await this.privatePostOrder(this.extend(request, params));
                    // {
                    //     "id": 28,
                    //     "symbol": "wrxinr",
                    //     "price": "9293.0",
                    //     "origQty": "10.0",
                    //     "executedQty": "8.2",
                    //     "status": "wait",
                    //     "type": "limit",
                    //     "side": "sell",
                    //     "createdTime": 1499827319559,
                    //     "updatedTime": 1499827319559
                    // }
                    return this.parseOrder(response, market);
                }
                parseOrder(order, market) {
                    // {
                    //     "id":1949417813,
                    //     "symbol":"ltcusdt",
                    //     "type":"limit",
                    //     "side":"sell",
                    //     "status":"done",
                    //     "price":"146.2",
                    //     "origQty":"0.05",
                    //     "executedQty":"0.05",
                    //     "createdTime":1641252564000,
                    //     "updatedTime":1641252564000
                    // },
                    const created = this.safeInteger(order, 'createdTime');
                    const updated = this.safeInteger(order, 'updatedTime');
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const amount = this.safeString(order, 'quantity');
                    const filled = this.safeString(order, 'executedQty');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'));
                    const id = this.safeString(order, 'id');
                    const price = this.safeString(order, 'price');
                    const type = this.safeStringLower(order, 'type');
                    const side = this.safeStringLower(order, 'side');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': created,
                        'datetime': this.iso8601(created),
                        'lastTradeTimestamp': updated,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'cost': undefined,
                        'fee': undefined,
                        'average': undefined,
                        'trades': []
                    }, market);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'wait': 'open',
                        'done': 'closed',
                        'cancel': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/' + path;
                    if (api === 'public') {
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    }
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const timestamp = this.milliseconds();
                        let data = this.extend({
                            'recvWindow': this.options['recvWindow'],
                            'timestamp': timestamp
                        }, params);
                        data = this.keysort(data);
                        const signature = this.hmac(this.encode(this.urlencode(data)), this.encode(this.secret), 'sha256');
                        url += '?' + this.urlencode(data);
                        url += '&signature=' + signature;
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-Api-Key': this.apiKey
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    //
                    // {"code":2098,"message":"Request out of receiving window."}
                    //
                    if (response === undefined) return;
                    const errorCode = this.safeString(response, 'code');
                    if (errorCode !== undefined) {
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                        throw new ExchangeError1(feedback);
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    169: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeNotAvailable: ExchangeNotAvailable, ExchangeError: ExchangeError1, DDoSProtection: DDoSProtection, BadSymbol: BadSymbol, InvalidOrder: InvalidOrder, ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, OrderNotFound: OrderNotFound, PermissionDenied: PermissionDenied, InsufficientFunds: InsufficientFunds, BadRequest: BadRequest } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class whitebit extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'whitebit',
                        'name': 'WhiteBit',
                        'version': 'v2',
                        'countries': [
                            'EE'
                        ],
                        'rateLimit': 500,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelOrder': true,
                            'createDepositAddress': undefined,
                            'createLimitOrder': undefined,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'editOrder': undefined,
                            'fetchBalance': true,
                            'fetchBidsAsks': undefined,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchFundingFees': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrderBook': true,
                            'fetchOrderTrades': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '3m': '3m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '2h': '2h',
                            '4h': '4h',
                            '6h': '6h',
                            '8h': '8h',
                            '12h': '12h',
                            '1d': '1d',
                            '3d': '3d',
                            '1w': '1w',
                            '1M': '1M'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/66732963-8eb7dd00-ee66-11e9-849b-10d9282bb9e0.jpg',
                            'api': {
                                'v1': {
                                    'public': 'https://whitebit.com/api/v1/public',
                                    'private': 'https://whitebit.com/api/v1'
                                },
                                'v2': {
                                    'public': 'https://whitebit.com/api/v2/public'
                                },
                                'v4': {
                                    'public': 'https://whitebit.com/api/v4/public',
                                    'private': 'https://whitebit.com/api/v4'
                                }
                            },
                            'www': 'https://www.whitebit.com',
                            'doc': 'https://github.com/whitebit-exchange/api-docs',
                            'fees': 'https://whitebit.com/fee-schedule',
                            'referral': 'https://whitebit.com/referral/d9bdf40e-28f2-4b52-b2f9-cd1415d82963'
                        },
                        'api': {
                            'web': {
                                'get': [
                                    'v1/healthcheck'
                                ]
                            },
                            'v1': {
                                'public': {
                                    'get': [
                                        'markets',
                                        'tickers',
                                        'ticker',
                                        'symbols',
                                        'depth/result',
                                        'history',
                                        'kline'
                                    ]
                                },
                                'private': {
                                    'post': [
                                        'account/balance',
                                        'order/new',
                                        'order/cancel',
                                        'orders',
                                        'account/order_history',
                                        'account/executed_history',
                                        'account/executed_history/all',
                                        'account/order'
                                    ]
                                }
                            },
                            'v2': {
                                'public': {
                                    'get': [
                                        'markets',
                                        'ticker',
                                        'assets',
                                        'fee',
                                        'depth/{market}',
                                        'trades/{market}'
                                    ]
                                }
                            },
                            'v4': {
                                'public': {
                                    'get': [
                                        'assets',
                                        'fee',
                                        'orderbook/{market}',
                                        'ticker',
                                        'trades/{market}',
                                        'time',
                                        'ping'
                                    ]
                                },
                                'private': {
                                    'post': [
                                        'main-account/address',
                                        'main-account/balance',
                                        'main-account/create-new-address',
                                        'main-account/codes',
                                        'main-account/codes/apply',
                                        'main-account/codes/my',
                                        'main-account/codes/history',
                                        'main-account/fiat-deposit-url',
                                        'main-account/history',
                                        'main-account/withdraw',
                                        'main-account/withdraw-pay',
                                        'main-account/transfer',
                                        'trade-account/balance',
                                        'trade-account/executed-history',
                                        'trade-account/order',
                                        'trade-account/order/history',
                                        'order/new',
                                        'order/market',
                                        'order/stock_market',
                                        'order/stop_limit',
                                        'order/stop_market',
                                        'order/cancel',
                                        'orders'
                                    ]
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': false,
                                'percentage': true,
                                'taker': this.parseNumber('0.001'),
                                'maker': this.parseNumber('0.001')
                            }
                        },
                        'options': {
                            'createMarketBuyOrderRequiresPrice': true,
                            'fiatCurrencies': [
                                'EUR',
                                'USD',
                                'RUB',
                                'UAH'
                            ],
                            'accountsByType': {
                                'main': 'main',
                                'spot': 'trade',
                                'margin': 'margin'
                            },
                            'transfer': {
                                'fillTransferResponseFromRequest': true
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'Unauthorized request.': AuthenticationError,
                                'The market format is invalid.': BadSymbol,
                                'Market is not available': BadSymbol,
                                'Invalid payload.': BadRequest,
                                'Amount must be greater than 0': InvalidOrder,
                                'The order id field is required.': InvalidOrder,
                                'Not enough balance': InsufficientFunds,
                                'This action is unauthorized.': PermissionDenied,
                                'This API Key is not authorized to perform this action.': PermissionDenied,
                                'Unexecuted order was not found.': OrderNotFound,
                                '503': ExchangeNotAvailable,
                                '422': OrderNotFound
                            },
                            'broad': {
                                'Given amount is less than min amount': InvalidOrder,
                                'Total is less than': InvalidOrder,
                                'fee must be no less than': InvalidOrder,
                                'Enable your key in API settings': PermissionDenied
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.v2PublicGetMarkets(params);
                    //
                    //    {
                    //        "success": true,
                    //        "message": "",
                    //        "result": [
                    //            {
                    //                "name":
                    //                "C98_USDT",
                    //                "stock":"C98",
                    //                "money":"USDT",
                    //                "stockPrec":"3",
                    //                "moneyPrec":"5",
                    //                "feePrec":"6",
                    //                "makerFee":"0.001",
                    //                "takerFee":"0.001",
                    //                "minAmount":"2.5",
                    //                "minTotal":"5.05",
                    //                "tradesEnabled":true
                    //            },
                    //            ...
                    //        ]
                    //    }
                    //
                    const markets = this.safeValue(response, 'result');
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'name');
                        const baseId = this.safeString(market, 'stock');
                        const quoteId = this.safeString(market, 'money');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const symbol = base + '/' + quote;
                        const active = this.safeValue(market, 'tradesEnabled');
                        const entry = {
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': active,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.safeNumber(market, 'makerFee'),
                            'maker': this.safeNumber(market, 'takerFee'),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'stockPrec'),
                                'price': this.safeInteger(market, 'moneyPrec')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minAmount'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minTotal'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        };
                        result.push(entry);
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.v4PublicGetAssets(params);
                    //
                    //      "BTC": {
                    //          "name": "Bitcoin",
                    //          "unified_cryptoasset_id": 1,
                    //          "can_withdraw": true,
                    //          "can_deposit": true,
                    //          "min_withdraw": "0.001",
                    //          "max_withdraw": "2",
                    //          "maker_fee": "0.1",
                    //          "taker_fee": "0.1",
                    //          "min_deposit": "0.0001",
                    //           "max_deposit": "0",
                    //       },
                    //
                    const ids = Object.keys(response);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const currency = response[id];
                        // breaks down in Python due to utf8 encoding issues on the exchange side
                        // const name = this.safeString (currency, 'name');
                        const canDeposit = this.safeValue(currency, 'can_deposit', true);
                        const canWithdraw = this.safeValue(currency, 'can_withdraw', true);
                        const active = canDeposit && canWithdraw;
                        const code = this.safeCurrencyCode(id);
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'name': undefined,
                            'active': active,
                            'deposit': canDeposit,
                            'withdraw': canWithdraw,
                            'fee': undefined,
                            'precision': undefined,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(currency, 'min_withdraw'),
                                    'max': this.safeNumber(currency, 'max_withdraw')
                                }
                            }
                        };
                    }
                    return result;
                }
                async fetchFundingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.v4PublicGetFee(params);
                    //
                    //      {
                    //          "1INCH":{
                    //              "is_depositable":true,
                    //              "is_withdrawal":true,
                    //              "ticker":"1INCH",
                    //              "name":"1inch",
                    //              "providers":[
                    //              ],
                    //              "withdraw":{
                    //                   "max_amount":"0",
                    //                  "min_amount":"21.5",
                    //                  "fixed":"17.5",
                    //                  "flex":null
                    //              },
                    //              "deposit":{
                    //                  "max_amount":"0",
                    //                  "min_amount":"19.5",
                    //                  "fixed":null,
                    //                  "flex":null
                    //               }
                    //          },
                    //           {...}
                    //      }
                    //
                    const currenciesIds = Object.keys(response);
                    const withdrawFees = {};
                    const depositFees = {};
                    for(let i = 0; i < currenciesIds.length; i++){
                        const currency = currenciesIds[i];
                        const data = response[currency];
                        const code = this.safeCurrencyCode(currency);
                        const withdraw = this.safeValue(data, 'withdraw', {});
                        withdrawFees[code] = this.safeString(withdraw, 'fixed');
                        const deposit = this.safeValue(data, 'deposit', {});
                        depositFees[code] = this.safeString(deposit, 'fixed');
                    }
                    return {
                        'withdraw': withdrawFees,
                        'deposit': depositFees,
                        'info': response
                    };
                }
                async fetchTradingFees(params = {}) {
                    const response = await this.v4PublicGetAssets(params);
                    //
                    //      {
                    //          '1INCH': {
                    //              name: '1inch',
                    //              unified_cryptoasset_id: '8104',
                    //              can_withdraw: true,
                    //              can_deposit: true,
                    //              min_withdraw: '33',
                    //              max_withdraw: '0',
                    //              maker_fee: '0.1',
                    //              taker_fee: '0.1',
                    //              min_deposit: '30',
                    //              max_deposit: '0'
                    //            },
                    //            ...
                    //      }
                    //
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        const market = this.market(symbol);
                        const fee = this.safeValue(response, market['baseId'], {});
                        let makerFee = this.safeString(fee, 'maker_fee');
                        let takerFee = this.safeString(fee, 'taker_fee');
                        makerFee = Precise.stringDiv(makerFee, '100');
                        takerFee = Precise.stringDiv(takerFee, '100');
                        result[symbol] = {
                            'info': fee,
                            'symbol': market['symbol'],
                            'percentage': true,
                            'tierBased': false,
                            'maker': this.parseNumber(makerFee),
                            'taker': this.parseNumber(takerFee)
                        };
                    }
                    return result;
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.v1PublicGetTicker(this.extend(request, params));
                    //
                    //      {
                    //         "success":true,
                    //         "message":"",
                    //         "result": {
                    //             "bid":"0.021979",
                    //             "ask":"0.021996",
                    //             "open":"0.02182",
                    //             "high":"0.022039",
                    //             "low":"0.02161",
                    //             "last":"0.021987",
                    //             "volume":"2810.267",
                    //             "deal":"61.383565474",
                    //             "change":"0.76",
                    //         },
                    //     }
                    //
                    const ticker = this.safeValue(response, 'result', {});
                    return this.parseTicker(ticker, market);
                }
                parseTicker(ticker, market) {
                    //
                    //  FetchTicker (v1)
                    //
                    //    {
                    //        "bid": "0.021979",
                    //        "ask": "0.021996",
                    //        "open": "0.02182",
                    //        "high": "0.022039",
                    //        "low": "0.02161",
                    //        "last": "0.021987",
                    //        "volume": "2810.267",
                    //        "deal": "61.383565474",
                    //        "change": "0.76",
                    //    }
                    //
                    // FetchTickers (v4)
                    //
                    //    "BCH_RUB": {
                    //        "base_id": 1831,
                    //        "quote_id": 0,
                    //        "last_price": "32830.21",
                    //        "quote_volume": "1494659.8024096",
                    //        "base_volume": "46.1083",
                    //        "isFrozen": false,
                    //        "change": "2.12" // in percent
                    //    }
                    //
                    market = this.safeMarket(undefined, market);
                    const last = this.safeString(ticker, 'last_price');
                    return this.safeTicker({
                        'symbol': market['symbol'],
                        'timestamp': undefined,
                        'datetime': undefined,
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': this.safeString(ticker, 'change'),
                        'average': undefined,
                        'baseVolume': this.safeString2(ticker, 'base_volume', 'volume'),
                        'quoteVolume': this.safeString2(ticker, 'quote_volume', 'deal'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.v4PublicGetTicker(params);
                    //
                    //      "BCH_RUB": {
                    //          "base_id":1831,
                    //          "quote_id":0,
                    //          "last_price":"32830.21",
                    //          "quote_volume":"1494659.8024096",
                    //          "base_volume":"46.1083",
                    //          "isFrozen":false,
                    //          "change":"2.12"
                    //      },
                    //
                    const marketIds = Object.keys(response);
                    const result = {};
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const market = this.safeMarket(marketId);
                        const ticker = this.parseTicker(response[marketId], market);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (limit !== undefined) request['depth'] = limit; // default = 50, maximum = 100
                    const response = await this.v4PublicGetOrderbookMarket(this.extend(request, params));
                    //
                    //      {
                    //          "timestamp": 1594391413,
                    //          "asks": [
                    //              [
                    //                  "9184.41",
                    //                  "0.773162"
                    //              ],
                    //              [ ... ]
                    //          ],
                    //          "bids": [
                    //              [
                    //                  "9181.19",
                    //                  "0.010873"
                    //              ],
                    //              [ ... ]
                    //          ]
                    //      }
                    //
                    const timestamp = this.safeString(response, 'timestamp');
                    return this.parseOrderBook(response, symbol, timestamp);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    const response = await this.v4PublicGetTradesMarket(this.extend(request, params));
                    //
                    //      [
                    //          {
                    //              "tradeID": 158056419,
                    //              "price": "9186.13",
                    //              "quote_volume": "0.0021",
                    //              "base_volume": "9186.13",
                    //              "trade_timestamp": 1594391747,
                    //              "type": "sell"
                    //          },
                    //      ],
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseTrade(trade, market) {
                    // fetchTradesV4
                    //     {
                    //       "tradeID": 158056419,
                    //       "price": "9186.13",
                    //       "quote_volume": "0.0021",
                    //       "base_volume": "9186.13",
                    //       "trade_timestamp": 1594391747,
                    //       "type": "sell"
                    //     },
                    //
                    // orderTrades (v4Private)
                    //
                    //     {
                    //         "time": 1593342324.613711,
                    //         "fee": "0.00000419198",
                    //         "price": "0.00000701",
                    //         "amount": "598",
                    //         "id": 149156519, // trade id
                    //         "dealOrderId": 3134995325, // orderId
                    //         "clientOrderId": "customId11",
                    //         "role": 2, // 1 = maker, 2 = taker
                    //         "deal": "0.00419198" // amount in money
                    //     }
                    //
                    const timestamp = this.safeTimestamp2(trade, 'time', 'trade_timestamp');
                    const orderId = this.safeString(trade, 'dealOrderId');
                    const cost = this.safeString(trade, 'deal');
                    const price = this.safeString(trade, 'price');
                    const amount = this.safeString2(trade, 'amount', 'base_volume');
                    const id = this.safeString2(trade, 'id', 'tradeID');
                    const side = this.safeString(trade, 'type');
                    const symbol = this.safeSymbol(undefined, market);
                    const role = this.safeInteger(trade, 'role');
                    let takerOrMaker = undefined;
                    if (role !== undefined) takerOrMaker = role === 1 ? 'maker' : 'taker';
                    let fee = undefined;
                    const feeCost = this.safeString(trade, 'fee');
                    if (feeCost !== undefined) {
                        const safeMarket = this.safeMarket(undefined, market);
                        const quote = safeMarket['quote'];
                        fee = {
                            'cost': feeCost,
                            'currency': quote
                        };
                    }
                    return this.safeTrade({
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'id': id,
                        'order': orderId,
                        'type': undefined,
                        'takerOrMaker': takerOrMaker,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'fee': fee
                    }, market);
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'interval': this.timeframes[timeframe]
                    };
                    if (since !== undefined) {
                        const maxLimit = 1440;
                        if (limit === undefined) limit = maxLimit;
                        limit = Math.min(limit, maxLimit);
                        const start = parseInt(since / 1000);
                        const duration = this.parseTimeframe(timeframe);
                        const end = this.sum(start, duration * limit);
                        request['start'] = start;
                        request['end'] = end;
                    }
                    if (limit !== undefined) request['limit'] = limit; // max 1440
                    const response = await this.v1PublicGetKline(this.extend(request, params));
                    //
                    //     {
                    //         "success":true,
                    //         "message":"",
                    //         "result":[
                    //             [1591488000,"0.025025","0.025025","0.025029","0.025023","6.181","0.154686629"],
                    //             [1591488060,"0.025028","0.025033","0.025035","0.025026","8.067","0.201921167"],
                    //             [1591488120,"0.025034","0.02505","0.02505","0.025034","20.089","0.503114696"],
                    //         ]
                    //     }
                    //
                    const result = this.safeValue(response, 'result', []);
                    return this.parseOHLCVs(result, market, timeframe, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         1591488000,
                    //         "0.025025",
                    //         "0.025025",
                    //         "0.025029",
                    //         "0.025023",
                    //         "6.181",
                    //         "0.154686629"
                    //     ]
                    //
                    return [
                        this.safeTimestamp(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchStatus(params = {}) {
                    const response = await this.v4PublicGetPing(params);
                    //
                    //      [
                    //          "pong"
                    //      ]
                    //
                    const status = this.safeString(response, 0);
                    return {
                        'status': status === 'pong' ? 'ok' : status,
                        'updated': this.milliseconds(),
                        'eta': undefined,
                        'url': undefined,
                        'info': response
                    };
                }
                async fetchTime(params = {}) {
                    const response = await this.v4PublicGetTime(params);
                    //
                    //     {
                    //         "time":1635467280514
                    //     }
                    //
                    return this.safeInteger(response, 'time');
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    let method = undefined;
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'side': side,
                        'amount': this.amountToPrecision(symbol, amount)
                    };
                    const stopPrice = this.safeNumber2(params, 'stopPrice', 'activationPrice');
                    if (stopPrice !== undefined) {
                        // it's a stop order
                        request['activation_price'] = this.priceToPrecision(symbol, stopPrice);
                        if (type === 'limit' || type === 'stopLimit') // it's a stop-limit-order
                        method = 'v4PrivateOPostOrderStopLimit';
                        else if (type === 'market' || type === 'stopMarket') // it's a stop-market-order
                        method = 'v4PrivatePostOrderStopMarket';
                    } else {
                        if (type === 'market') // it's a regular market order
                        method = 'v4PrivatePostOrderMarket';
                        if (type === 'limit') // it's a regular limit order
                        method = 'v4PrivatePostOrderNew';
                    }
                    // aggregate common assignments regardless stop or not
                    if (type === 'limit' || type === 'stopLimit') {
                        if (price === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires a price argument for a stopLimit order');
                        const convertedPrice = this.priceToPrecision(symbol, price);
                        request['price'] = convertedPrice;
                    }
                    if (type === 'market' || type === 'stopMarket') {
                        if (side === 'buy') {
                            let cost = this.safeNumber(params, 'cost');
                            const createMarketBuyOrderRequiresPrice = this.safeValue(this.options, 'createMarketBuyOrderRequiresPrice', true);
                            if (createMarketBuyOrderRequiresPrice) {
                                if (price !== undefined) {
                                    if (cost === undefined) cost = amount * price;
                                } else if (cost === undefined) throw new InvalidOrder(this.id + " createOrder() requires the price argument for market buy orders to calculate total order cost (amount to spend), where cost = amount * price. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount, or, alternatively, add .options['createMarketBuyOrderRequiresPrice'] = false and supply the total cost value in the 'amount' argument or in the 'cost' extra parameter (the exchange-specific behaviour)");
                            } else cost = cost === undefined ? amount : cost;
                            request['amount'] = this.costToPrecision(symbol, cost);
                        }
                    }
                    if (method === undefined) throw new ArgumentsRequired1(this.id + ' createOrder() requires one of the following order types: market, limit, stopLimit or stopMarket');
                    const response = await this[method](this.extend(request, params));
                    return this.parseOrder(response);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id'],
                        'orderId': parseInt(id)
                    };
                    return await this.v4PrivatePostOrderCancel(this.extend(request, params));
                }
                parseBalance(response) {
                    const balanceKeys = Object.keys(response);
                    const result = {};
                    for(let i = 0; i < balanceKeys.length; i++){
                        const id = balanceKeys[i];
                        const balance = response[id];
                        const code = this.safeCurrencyCode(id);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'freeze');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.v4PrivatePostTradeAccountBalance(params);
                    //
                    //     {
                    //         "BTC": { "available": "0.123", "freeze": "1" },
                    //         "XMR": { "available": "3013", "freeze": "100" },
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'market': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default 50 max 100
                    const response = await this.v4PrivatePostOrders(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "orderId": 3686033640,
                    //             "clientOrderId": "customId11",
                    //             "market": "BTC_USDT",
                    //             "side": "buy",
                    //             "type": "limit",
                    //             "timestamp": 1594605801.49815,    // current timestamp of unexecuted order
                    //             "dealMoney": "0",                 // executed amount in money
                    //             "dealStock": "0",                 // executed amount in stock
                    //             "amount": "2.241379",             // active order amount
                    //             "takerFee": "0.001",
                    //             "makerFee": "0.001",
                    //             "left": "2.241379",               // unexecuted amount in stock
                    //             "dealFee": "0",                   // executed fee by deal
                    //             "price": "40000"
                    //         },
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit, {
                        'status': 'open'
                    });
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        symbol = market['symbol'];
                        request['market'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 50 max 100
                    const response = await this.v4PrivatePostTradeAccountOrderHistory(this.extend(request, params));
                    //
                    //     {
                    //         "BTC_USDT": [
                    //             {
                    //                 "id": 160305483,
                    //                 "clientOrderId": "customId11",
                    //                 "time": 1594667731.724403,
                    //                 "side": "sell",
                    //                 "role": 2, // 1 = maker, 2 = taker
                    //                 "amount": "0.000076",
                    //                 "price": "9264.21",
                    //                 "deal": "0.70407996",
                    //                 "fee": "0.00070407996"
                    //             },
                    //         ],
                    //     }
                    //
                    const marketIds = Object.keys(response);
                    let results = [];
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const market = this.safeMarket(marketId, undefined, '_');
                        const orders = response[marketId];
                        for(let j = 0; j < orders.length; j++){
                            const order = this.parseOrder(orders[j], market);
                            results.push(this.extend(order, {
                                'status': 'filled'
                            }));
                        }
                    }
                    results = this.sortBy(results, 'timestamp');
                    results = this.filterBySymbolSinceLimit(results, symbol, since, limit, since === undefined);
                    return results;
                }
                parseOrder(order, market) {
                    //
                    // createOrder, fetchOpenOrders
                    //
                    //     {
                    //         "orderId": 4180284841,
                    //         "clientOrderId": "order1987111",
                    //         "market": "BTC_USDT",
                    //         "side": "buy",
                    //         "type": "stop limit",
                    //         "timestamp": 1595792396.165973,
                    //         "dealMoney": "0",                  // if order finished - amount in money currency that finished
                    //         "dealStock": "0",                  // if order finished - amount in stock currency that finished
                    //         "amount": "0.001",
                    //         "takerFee": "0.001",
                    //         "makerFee": "0.001",
                    //         "left": "0.001",                   // remaining amount
                    //         "dealFee": "0",                    // fee in money that you pay if order is finished
                    //         "price": "40000",
                    //         "activation_price": "40000"        // activation price -> only for stopLimit, stopMarket
                    //     }
                    //
                    // fetchClosedOrders
                    //
                    //     {
                    //         "market": "BTC_USDT"
                    //         "amount": "0.0009",
                    //         "price": "40000",
                    //         "type": "limit",
                    //         "id": 4986126152,
                    //         "clientOrderId": "customId11",
                    //         "side": "sell",
                    //         "ctime": 1597486960.311311,       // timestamp of order creation
                    //         "takerFee": "0.001",
                    //         "ftime": 1597486960.311332,       // executed order timestamp
                    //         "makerFee": "0.001",
                    //         "dealFee": "0.041258268",         // paid fee if order is finished
                    //         "dealStock": "0.0009",            // amount in stock currency that finished
                    //         "dealMoney": "41.258268"          // amount in money currency that finished
                    //     }
                    //
                    const marketId = this.safeString(order, 'market');
                    market = this.safeMarket(marketId, market, '_');
                    const symbol = market['symbol'];
                    const side = this.safeString(order, 'side');
                    const filled = this.safeString(order, 'dealStock');
                    const remaining = this.safeString(order, 'left');
                    let clientOrderId = this.safeString(order, 'clientOrderId');
                    if (clientOrderId === '') clientOrderId = undefined;
                    let price = this.safeString(order, 'price');
                    const stopPrice = this.safeString(order, 'activation_price');
                    const orderId = this.safeString2(order, 'orderId', 'id');
                    const type = this.safeString(order, 'type');
                    let amount = this.safeString(order, 'amount');
                    let cost = undefined;
                    if (price === '0') // api error to be solved
                    price = undefined;
                    if (side === 'buy' && type.indexOf('market') >= 0) {
                        // in these cases the amount is in the quote currency meaning it's the cost
                        cost = amount;
                        amount = undefined;
                        if (price !== undefined) // if the price is available we can do this conversion
                        // from amount in quote currency to base currency
                        amount = Precise.stringDiv(cost, price);
                    }
                    const dealFee = this.safeString(order, 'dealFee');
                    let fee = undefined;
                    if (dealFee !== undefined) fee = {
                        'cost': this.parseNumber(dealFee),
                        'currency': market['quote']
                    };
                    const timestamp = this.safeTimestamp2(order, 'ctime', 'timestamp');
                    const lastTradeTimestamp = this.safeTimestamp(order, 'ftime');
                    return this.safeOrder({
                        'info': order,
                        'id': orderId,
                        'symbol': symbol,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': lastTradeTimestamp,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'status': undefined,
                        'side': side,
                        'price': price,
                        'type': type,
                        'stopPrice': stopPrice,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'average': undefined,
                        'cost': cost,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'orderId': parseInt(id)
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['market'] = market['id'];
                    }
                    if (limit !== undefined) request['limit'] = limit; // default 50, max 100
                    const response = await this.v4PrivatePostTradeAccountOrder(this.extend(request, params));
                    //
                    //     {
                    //         "records": [
                    //             {
                    //                 "time": 1593342324.613711,
                    //                 "fee": "0.00000419198",
                    //                 "price": "0.00000701",
                    //                 "amount": "598",
                    //                 "id": 149156519, // trade id
                    //                 "dealOrderId": 3134995325, // orderId
                    //                 "clientOrderId": "customId11", // empty string if not specified
                    //                 "role": 2, // 1 = maker, 2 = taker
                    //                 "deal": "0.00419198"
                    //             }
                    //         ],
                    //         "offset": 0,
                    //         "limit": 100
                    //     }
                    //
                    const data = this.safeValue(response, 'records', []);
                    return this.parseTrades(data, market);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'ticker': currency['id']
                    };
                    let method = 'v4PrivatePostMainAccountAddress';
                    if (this.isFiat(code)) {
                        method = 'v4PrivatePostMainAccountFiatDepositUrl';
                        const provider = this.safeNumber(params, 'provider');
                        if (provider === undefined) throw new ArgumentsRequired1(this.id + ' fetchDepositAddress() requires a provider when the ticker is fiat');
                        request['provider'] = provider;
                        const amount = this.safeNumber(params, 'amount');
                        if (amount === undefined) throw new ArgumentsRequired1(this.id + ' fetchDepositAddress() requires an amount when the ticker is fiat');
                        request['amount'] = amount;
                        const uniqueId = this.safeValue(params, 'uniqueId');
                        if (uniqueId === undefined) throw new ArgumentsRequired1(this.id + ' fetchDepositAddress() requires an uniqueId when the ticker is fiat');
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    // fiat
                    //
                    //     {
                    //         "url": "https://someaddress.com"
                    //     }
                    //
                    // crypto
                    //
                    //     {
                    //         "account": {
                    //             "address": "GDTSOI56XNVAKJNJBLJGRNZIVOCIZJRBIDKTWSCYEYNFAZEMBLN75RMN",
                    //             "memo": "48565488244493"
                    //         },
                    //         "required": {
                    //             "fixedFee": "0",
                    //             "flexFee": {
                    //                 "maxFee": "0",
                    //                 "minFee": "0",
                    //                 "percent": "0"
                    //             },
                    //             "maxAmount": "0",
                    //             "minAmount": "1"
                    //         }
                    //     }
                    //
                    const url = this.safeString(response, 'url');
                    const account = this.safeValue(response, 'account', {});
                    const address = this.safeString(account, 'address', url);
                    const tag = this.safeString(account, 'memo');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const accountsByType = this.safeValue(this.options, 'accountsByType');
                    const fromAccountId = this.safeString(accountsByType, fromAccount, fromAccount);
                    const toAccountId = this.safeString(accountsByType, toAccount, toAccount);
                    let type = undefined;
                    if (fromAccountId === 'main' && toAccountId === 'trade') type = 'deposit';
                    else if (fromAccountId === 'trade' && toAccountId === 'main') type = 'withdraw';
                    if (type === undefined) throw new ExchangeError1(this.id + ' transfer() only allows transfers between main account and spot account');
                    const request = {
                        'ticker': currency['id'],
                        'method': type,
                        'amount': this.currencyToPrecision(code, amount)
                    };
                    const response = await this.v4PrivatePostMainAccountTransfer(this.extend(request, params));
                    //
                    //    []
                    //
                    const transfer = this.parseTransfer(response, currency);
                    const transferOptions = this.safeValue(this.options, 'transfer', {});
                    const fillTransferResponseFromRequest = this.safeValue(transferOptions, 'fillTransferResponseFromRequest', true);
                    if (fillTransferResponseFromRequest) {
                        transfer['amount'] = amount;
                        transfer['fromAccount'] = fromAccount;
                        transfer['toAccount'] = toAccount;
                    }
                    return transfer;
                }
                parseTransfer(transfer, currency) {
                    //
                    //    []
                    //
                    return {
                        'info': transfer,
                        'id': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'currency': this.safeCurrencyCode(undefined, currency),
                        'amount': undefined,
                        'fromAccount': undefined,
                        'toAccount': undefined,
                        'status': 'pending'
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code); // check if it has canDeposit
                    const request = {
                        'ticker': currency['id'],
                        'amount': this.currencyToPrecision(code, amount),
                        'address': address
                    };
                    let uniqueId = this.safeValue(params, 'uniqueId');
                    if (uniqueId === undefined) uniqueId = this.uuid22();
                    request['uniqueId'] = uniqueId;
                    if (tag !== undefined) request['memo'] = tag;
                    if (this.isFiat(code)) {
                        const provider = this.safeValue(params, 'provider');
                        if (provider === undefined) throw new ArgumentsRequired1(this.id + ' fetchDepositAddress() requires a provider when the ticker is fiat');
                        request['provider'] = provider;
                    }
                    const response = await this.v4PrivatePostMainAccountWithdraw(this.extend(request, params));
                    //
                    // empty array with a success status
                    // go to deposit/withdraw history and check you request status by uniqueId
                    //
                    //     []
                    //
                    return this.extend({
                        'id': uniqueId
                    }, this.parseTransaction(response, currency));
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     []
                    //
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'id': undefined,
                        'txid': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': undefined,
                        'info': transaction
                    };
                }
                isFiat(currency) {
                    const fiatCurrencies = this.safeValue(this.options, 'fiatCurrencies', []);
                    return this.inArray(currency, fiatCurrencies);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const query = this.omit(params, this.extractParams(path));
                    const version = this.safeValue(api, 0);
                    const accessibility = this.safeValue(api, 1);
                    const pathWithParams = '/' + this.implodeParams(path, params);
                    let url = this.urls['api'][version][accessibility] + pathWithParams;
                    if (accessibility === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    }
                    if (accessibility === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce().toString();
                        const secret = this.stringToBinary(this.encode(this.secret));
                        const request = "/api/" + version + pathWithParams;
                        body = this.json(this.extend({
                            'request': request,
                            'nonce': nonce
                        }, params));
                        const payload = this.stringToBase64(body);
                        const signature = this.hmac(payload, secret, 'sha512');
                        headers = {
                            'Content-Type': 'application/json',
                            'X-TXC-APIKEY': this.apiKey,
                            'X-TXC-PAYLOAD': payload,
                            'X-TXC-SIGNATURE': signature
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (code === 418 || code === 429) throw new DDoSProtection(this.id + ' ' + code.toString() + ' ' + reason + ' ' + body);
                    if (code === 404) throw new ExchangeError1(this.id + ' ' + code.toString() + ' endpoint not found');
                    if (response !== undefined) {
                        // For cases where we have a meaningful status
                        // {"response":null,"status":422,"errors":{"orderId":["Finished order id 435453454535 not found on your account"]},"notification":null,"warning":"Finished order id 435453454535 not found on your account","_token":null}
                        const status = this.safeInteger(response, 'status');
                        // {"code":10,"message":"Unauthorized request."}
                        const message = this.safeString(response, 'message');
                        // For these cases where we have a generic code variable error key
                        // {"code":0,"message":"Validation failed","errors":{"amount":["Amount must be greater than 0"]}}
                        const code = this.safeInteger(response, 'code');
                        const hasErrorStatus = status !== undefined && status !== '200';
                        if (hasErrorStatus || code !== undefined) {
                            const feedback = this.id + ' ' + body;
                            let errorInfo = message;
                            if (hasErrorStatus) errorInfo = status;
                            else {
                                const errorObject = this.safeValue(response, 'errors');
                                if (errorObject !== undefined) {
                                    const errorKey = Object.keys(errorObject)[0];
                                    const errorMessageArray = this.safeValue(errorObject, errorKey, []);
                                    const errorMessageLength = errorMessageArray.length;
                                    errorInfo = errorMessageLength > 0 ? errorMessageArray[0] : body;
                                }
                            }
                            this.throwExactlyMatchedException(this.exceptions['exact'], errorInfo, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    170: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded, BadRequest: BadRequest, ExchangeError: ExchangeError1, InvalidOrder: InvalidOrder } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            const { TICK_SIZE: TICK_SIZE } = require1('./base/functions/number');
            // ---------------------------------------------------------------------------
            module.exports = class woo extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'woo',
                        'name': 'WOO X',
                        'countries': [
                            'KY'
                        ],
                        'rateLimit': 100,
                        'version': 'v1',
                        'certified': false,
                        'hostname': 'woo.org',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': true,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelAllOrders': false,
                            'cancelOrder': true,
                            'cancelOrders': true,
                            'cancelWithdraw': false,
                            'createMarketOrder': false,
                            'createOrder': true,
                            'createStopLimitOrder': false,
                            'createStopMarketOrder': false,
                            'createStopOrder': false,
                            'fetchBalance': true,
                            'fetchCanceledOrders': false,
                            'fetchClosedOrder': false,
                            'fetchClosedOrders': false,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': false,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLedger': true,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrder': false,
                            'fetchOpenOrders': false,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchOrderTrades': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchStatus': false,
                            'fetchTicker': false,
                            'fetchTickers': false,
                            'fetchTime': false,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': true,
                            'fetchTransfers': true,
                            'fetchWithdrawals': true,
                            'transfer': true,
                            'withdraw': false
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '4h': '4h',
                            '12h': '12h',
                            '1d': '1d',
                            '1w': '1w',
                            '1M': '1mon',
                            '1y': '1y'
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/150730761-1a00e5e0-d28c-480f-9e65-089ce3e6ef3b.jpg',
                            'api': {
                                'public': 'https://api.{hostname}',
                                'private': 'https://api.{hostname}'
                            },
                            // TEST (stating) api ( https://support.woo.org/hc/en-001/articles/4406352945305--Institutional-Account-Welcome-Packet-V-2) doesn't work at this moment, even thou
                            // 'test': {
                            //     'public': 'http://api.staging.woo.org',
                            //     'private': 'http://api.staging.woo.org',
                            // },
                            'www': 'https://woo.org/',
                            'doc': [
                                'https://docs.woo.org/'
                            ],
                            'fees': [
                                'https://support.woo.org/hc/en-001/articles/4404611795353--Trading-Fees'
                            ],
                            'referral': 'https://referral.woo.org/BAJS6oNmZb3vi3RGA'
                        },
                        'api': {
                            'v1': {
                                'public': {
                                    'get': {
                                        'info': 1,
                                        'info/{symbol}': 1,
                                        'market_trades': 1,
                                        'token': 1,
                                        'token_network': 1
                                    }
                                },
                                'private': {
                                    'get': {
                                        'client/token': 1,
                                        'order/{oid}': 1,
                                        'client/order/{client_order_id}': 1,
                                        'orders': 1,
                                        'orderbook/{symbol}': 1,
                                        'kline': 1,
                                        'client/trade/{tid}': 1,
                                        'order/{oid}/trades': 1,
                                        'client/trades': 1,
                                        'client/info': 60,
                                        'asset/deposit': 120,
                                        'asset/history': 60,
                                        'token_interest': 60,
                                        'token_interest/{token}': 60,
                                        'interest/history': 60,
                                        'interest/repay': 60
                                    },
                                    'post': {
                                        'order': 5,
                                        'asset/main_sub_transfer': 30,
                                        'asset/withdraw': 120
                                    },
                                    'delete': {
                                        'order': 1,
                                        'client/order': 1,
                                        'orders': 1,
                                        'asset/withdraw': 120
                                    }
                                }
                            },
                            'v2': {
                                'private': {
                                    'get': {
                                        'client/holding': 1
                                    }
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'maker': this.parseNumber('0.0002'),
                                'taker': this.parseNumber('0.0005')
                            }
                        },
                        'options': {
                            'createMarketBuyOrderRequiresPrice': true,
                            'network-aliases': {
                                'ALGO': 'ALGO',
                                'ATOM': 'ATOM',
                                'AVAXC': 'AVAXC',
                                'BNB': 'BEP2',
                                'BSC': 'BEP20',
                                'BTC': 'BTC',
                                'BCHSV': 'BSV',
                                'EOS': 'EOS',
                                'ETH': 'ERC20',
                                'HECO': 'HRC20',
                                'MATIC': 'POLYGON',
                                'ONT': 'ONT',
                                'SOL': 'SPL',
                                'TERRA': 'TERRA',
                                'TRON': 'TRC20'
                            },
                            // network-aliases for titles are removed (just in case, if needed: pastebin.com/raw/BvgKViPN )
                            'network-aliases-for-protocol': {
                                'ALGO': 'ALGO',
                                'ATOM': 'ATOM',
                                'C Chain': 'AVAXC',
                                'BEP2': 'BEP2',
                                'BEP20': 'BEP20',
                                'BTC': 'BTC',
                                'BSV': 'BSV',
                                'EOS': 'EOS',
                                'ERC20': 'ERC20',
                                'HECO': 'HRC20',
                                'Polygon': 'POLYGON',
                                'ONT': 'ONT',
                                'SOL': 'SPL',
                                'TERRA': 'TERRA',
                                'TRON': 'TRC20'
                            },
                            // these network aliases require manual mapping here
                            'network-aliases-for-tokens': {
                                'HT': 'ERC20',
                                'OMG': 'ERC20',
                                'UATOM': 'ATOM',
                                'ZRX': 'ZRX'
                            },
                            'defaultNetworkCodePriorities': [
                                'TRC20',
                                'ERC20',
                                'BSC20'
                            ],
                            // override defaultNetworkCodePriorities for a specific currency
                            'defaultNetworkCodeForCurrencies': {
                            },
                            'transfer': {
                                'fillResponseFromRequest': true
                            }
                        },
                        'commonCurrencies': {},
                        'exceptions': {
                            'exact': {
                                '-1000': ExchangeError1,
                                '-1001': AuthenticationError,
                                '-1002': AuthenticationError,
                                '-1003': RateLimitExceeded,
                                '-1004': BadRequest,
                                '-1005': BadRequest,
                                '-1006': BadRequest,
                                '-1007': BadRequest,
                                '-1008': InvalidOrder,
                                '-1009': BadRequest,
                                '-1011': ExchangeError1,
                                '-1012': BadRequest,
                                '-1101': InvalidOrder,
                                '-1102': InvalidOrder,
                                '-1103': InvalidOrder,
                                '-1104': InvalidOrder,
                                '-1105': InvalidOrder
                            },
                            'broad': {
                                'symbol must not be blank': BadRequest,
                                'The token is not supported': BadRequest,
                                'Your order and symbol are not valid or already canceled': BadRequest,
                                'Insufficient WOO. Please enable margin trading for leverage trading': BadRequest
                            }
                        },
                        'precisionMode': TICK_SIZE
                    });
                }
                async fetchMarkets(params = {}) {
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchMarkets', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PublicGetInfo'
                    });
                    const response = await this[method](query);
                    //
                    // {
                    //     rows: [
                    //         {
                    //             symbol: "SPOT_AAVE_USDT",
                    //             quote_min: 0,
                    //             quote_max: 100000,
                    //             quote_tick: 0.01,
                    //             base_min: 0.01,
                    //             base_max: 7284,
                    //             base_tick: 0.0001,
                    //             min_notional: 10,
                    //             price_range: 0.1,
                    //             created_time: "0",
                    //             updated_time: "1639107647.988",
                    //             is_stable: 0
                    //         },
                    //         ...
                    //     success: true
                    // }
                    //
                    const data = this.safeValue(response, 'rows', []);
                    const result = [];
                    for(let i = 0; i < data.length; i++){
                        const market = data[i];
                        const marketId = this.safeString(market, 'symbol');
                        const parts = marketId.split('_');
                        const marketTypeVal = this.safeStringLower(parts, 0);
                        const isSpot = marketTypeVal === 'spot';
                        const isSwap = false;
                        const isFuture = false;
                        const isOption = false;
                        const baseId = this.safeString(parts, 1);
                        const quoteId = this.safeString(parts, 2);
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const symbol = base + '/' + quote;
                        const minQuote = this.safeNumber(market, 'quote_min');
                        const maxQuote = this.safeNumber(market, 'quote_max');
                        const minBase = this.safeNumber(market, 'base_min');
                        const maxBase = this.safeNumber(market, 'base_max');
                        const priceScale = this.safeNumber(market, 'quote_tick');
                        const quantityScale = this.safeNumber(market, 'base_tick');
                        const minCost = this.safeNumber(market, 'min_notional');
                        result.push({
                            'id': marketId,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': marketTypeVal,
                            'spot': isSpot,
                            'margin': true,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': isSwap || isFuture || isOption,
                            'linear': undefined,
                            'inverse': undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': quantityScale,
                                'price': priceScale
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': minBase,
                                    'max': maxBase
                                },
                                'price': {
                                    'min': minQuote,
                                    'max': maxQuote
                                },
                                'cost': {
                                    'min': minCost,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchTrades', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PublicGetMarketTrades'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    // {
                    //     success: true,
                    //     rows: [
                    //         {
                    //             symbol: "SPOT_BTC_USDT",
                    //             side: "SELL",
                    //             executed_price: 46222.35,
                    //             executed_quantity: 0.0012,
                    //             executed_timestamp: "1641241162.329"
                    //         },
                    //         {
                    //             symbol: "SPOT_BTC_USDT",
                    //             side: "SELL",
                    //             executed_price: 46222.35,
                    //             executed_quantity: 0.0012,
                    //             executed_timestamp: "1641241162.329"
                    //         },
                    //         {
                    //             symbol: "SPOT_BTC_USDT",
                    //             side: "BUY",
                    //             executed_price: 46224.32,
                    //             executed_quantity: 0.00039,
                    //             executed_timestamp: "1641241162.287"
                    //         },
                    //         ...
                    //      ]
                    // }
                    //
                    const resultResponse = this.safeValue(response, 'rows', {});
                    return this.parseTrades(resultResponse, market, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // public/market_trades
                    //
                    //     {
                    //         symbol: "SPOT_BTC_USDT",
                    //         side: "SELL",
                    //         executed_price: 46222.35,
                    //         executed_quantity: 0.0012,
                    //         executed_timestamp: "1641241162.329"
                    //     }
                    //
                    // fetchOrderTrades, fetchOrder
                    //
                    //     {
                    //         id: '99119876',
                    //         symbol: 'SPOT_WOO_USDT',
                    //         fee: '0.0024',
                    //         side: 'BUY',
                    //         executed_timestamp: '1641481113.084',
                    //         order_id: '87001234',
                    //         order_tag: 'default', <-- this param only in "fetchOrderTrades"
                    //         executed_price: '1',
                    //         executed_quantity: '12',
                    //         fee_asset: 'WOO',
                    //         is_maker: '1'
                    //     }
                    //
                    const isFromFetchOrder = 'id' in trade;
                    const timestamp = this.safeTimestamp(trade, 'executed_timestamp');
                    const marketId = this.safeString(trade, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const price = this.safeString(trade, 'executed_price');
                    const amount = this.safeString(trade, 'executed_quantity');
                    const order_id = this.safeString(trade, 'order_id');
                    const fee = this.parseTokenAndFeeTemp(trade, 'fee_asset', 'fee');
                    const cost = Precise.stringMul(price, amount);
                    const side = this.safeStringLower(trade, 'side');
                    let id = this.safeString(trade, 'id');
                    if (id === undefined) {
                        if (timestamp !== undefined) {
                            const amountStr = amount === undefined ? '' : amount;
                            const sideStr = side === undefined ? '' : side;
                            const priceStr = price === undefined ? '' : price;
                            const marketIdStr = this.safeString(market, 'id', '');
                            id = this.numberToString(timestamp) + '-' + marketIdStr + '-' + sideStr + '-' + amountStr + '-' + priceStr;
                        }
                    }
                    let takerOrMaker = undefined;
                    if (isFromFetchOrder) {
                        const isMaker = this.safeString(trade, 'is_maker') === '1';
                        takerOrMaker = isMaker ? 'maker' : 'taker';
                    }
                    return this.safeTrade({
                        'id': id,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'order': order_id,
                        'takerOrMaker': takerOrMaker,
                        'type': undefined,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                parseTokenAndFeeTemp(item, feeTokenKey, feeAmountKey) {
                    const feeCost = this.safeString(item, feeAmountKey);
                    let fee = undefined;
                    if (feeCost !== undefined) {
                        const feeCurrencyId = this.safeString(item, feeTokenKey);
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrencyCode
                        };
                    }
                    return fee;
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.v1PrivateGetClientInfo(params);
                    //
                    //     {
                    //         "application":{
                    //             "id":45585,
                    //             "leverage":3.00,
                    //             "otpauth":false,
                    //             "alias":"email@address.com",
                    //             "application_id":"c2cc4d74-c8cb-4e10-84db-af2089b8c68a",
                    //             "account":"email@address.com",
                    //             "account_mode":"PURE_SPOT",
                    //             "taker_fee_rate":5.00,
                    //             "maker_fee_rate":2.00,
                    //             "interest_rate":0.00,
                    //             "futures_leverage":1.00,
                    //             "futures_taker_fee_rate":5.00,
                    //             "futures_maker_fee_rate":2.00
                    //         },
                    //         "margin_rate":1000,
                    //         "success":true
                    //     }
                    //
                    const application = this.safeValue(response, 'application', {});
                    const maker = this.safeString(application, 'maker_fee_rate');
                    const taker = this.safeString(application, 'taker_fee_rate');
                    const result = {};
                    for(let i = 0; i < this.symbols.length; i++){
                        const symbol = this.symbols[i];
                        result[symbol] = {
                            'info': response,
                            'symbol': symbol,
                            'maker': this.parseNumber(Precise.stringDiv(maker, '10000')),
                            'taker': this.parseNumber(Precise.stringDiv(taker, '10000')),
                            'percentage': true,
                            'tierBased': true
                        };
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    let method = undefined;
                    const result = {};
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchCurrencies', undefined, params);
                    method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PublicGetToken'
                    });
                    const tokenResponse = await this[method](query);
                    //
                    // {
                    //     rows: [
                    //         {
                    //             token: "ETH_USDT",
                    //             fullname: "Tether",
                    //             decimals: 6,
                    //             balance_token: "USDT",
                    //             created_time: "0",
                    //             updated_time: "0"
                    //         },
                    //         {
                    //             token: "BSC_USDT",
                    //             fullname: "Tether",
                    //             decimals: 18,
                    //             balance_token: "USDT",
                    //             created_time: "0",
                    //             updated_time: "0"
                    //         },
                    //         {
                    //             token: "ZEC",
                    //             fullname: "ZCash",
                    //             decimals: 8,
                    //             balance_token: "ZEC",
                    //             created_time: "0",
                    //             updated_time: "0"
                    //         },
                    //         ...
                    //     ],
                    //     success: true
                    // }
                    //
                    method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PublicGetTokenNetwork'
                    });
                    const tokenNetworkResponse = await this[method](query);
                    //
                    // {
                    //     rows: [
                    //         {
                    //             protocol: "ERC20",
                    //             token: "USDT",
                    //             name: "Ethereum",
                    //             minimum_withdrawal: 30,
                    //             withdrawal_fee: 25,
                    //             allow_deposit: 1,
                    //             allow_withdraw: 1
                    //         },
                    //         {
                    //             protocol: "TRC20",
                    //             token: "USDT",
                    //             name: "Tron",
                    //             minimum_withdrawal: 30,
                    //             withdrawal_fee: 1,
                    //             allow_deposit: 1,
                    //             allow_withdraw: 1
                    //         },
                    //         ...
                    //     ],
                    //     success: true
                    // }
                    //
                    const tokenRows = this.safeValue(tokenResponse, 'rows', []);
                    const tokenNetworkRows = this.safeValue(tokenNetworkResponse, 'rows', []);
                    const networksByCurrencyId = this.groupBy(tokenNetworkRows, 'token');
                    for(let i = 0; i < tokenRows.length; i++){
                        const currency = tokenRows[i];
                        const id = this.safeString(currency, 'balance_token');
                        const code = this.safeCurrencyCode(id);
                        const name = this.safeString(currency, 'fullname');
                        const decimals = this.safeInteger(currency, 'decimals');
                        const chainedTokenCode = this.safeString(currency, 'token');
                        const parts = chainedTokenCode.split('_');
                        const chainNameId = this.safeString(parts, 0, chainedTokenCode);
                        const chainCode = this.safeString(this.options['network-aliases'], chainNameId, chainNameId);
                        if (!(code in result)) {
                            const networks = this.safeValue(networksByCurrencyId, id, []);
                            const resultingNetworks = {};
                            for(let j = 0; j < networks.length; j++){
                                const networkEntry = networks[j];
                                const networkId = this.safeString(networkEntry, 'protocol');
                                const networkIdManualMatched = this.safeString(this.options['network-aliases-for-tokens'], networkId, networkId);
                                const networkCode = this.safeString2(this.options['network-aliases-for-protocol'], chainNameId, chainNameId, networkIdManualMatched);
                                const depositEnabled = this.safeInteger(networkEntry, 'allow_deposit', 0);
                                const withdrawEnabled = this.safeInteger(networkEntry, 'allow_withdraw', 0);
                                resultingNetworks[networkCode] = {
                                    'id': networkId,
                                    'network': networkCode,
                                    'limits': {
                                        'withdraw': {
                                            'min': this.safeNumber(networkEntry, 'minimum_withdrawal'),
                                            'max': undefined
                                        },
                                        'deposit': {
                                            'min': undefined,
                                            'max': undefined
                                        }
                                    },
                                    'active': undefined,
                                    'deposit': depositEnabled,
                                    'withdraw': withdrawEnabled,
                                    'fee': this.safeNumber(networkEntry, 'withdrawal_fee'),
                                    'precision': undefined,
                                    'info': networkEntry
                                };
                            }
                            const networksKeys = Object.keys(resultingNetworks);
                            const firstNetworkKey = networksKeys[0];
                            const networkLength = networksKeys.length;
                            result[code] = {
                                'id': id,
                                'name': name,
                                'code': code,
                                'precision': networkLength === 1 ? decimals : undefined,
                                'active': undefined,
                                'fee': networkLength === 1 ? resultingNetworks[firstNetworkKey]['fee'] : undefined,
                                'networks': resultingNetworks,
                                'limits': {
                                    'deposit': {
                                        'min': undefined,
                                        'max': undefined
                                    },
                                    'withdraw': {
                                        'min': networkLength === 1 ? resultingNetworks[firstNetworkKey]['limits']['withdraw']['min'] : undefined,
                                        'max': undefined
                                    }
                                },
                                'info': {}
                            };
                        }
                        const networkKeys = Object.keys(result[code]['networks']);
                        const firstNetworkKey = this.safeString(networkKeys, 0);
                        // now add the precision info from token-object
                        if (chainCode in result[code]['networks']) result[code]['networks'][chainCode]['precision'] = decimals;
                        else // else chainCode will be the only token slug, which has only 1 supported network
                        result[code]['networks'][firstNetworkKey]['precision'] = decimals;
                        // now add the info object specifically for the item
                        result[code]['info'][chainedTokenCode] = currency;
                    }
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'order_type': type.toUpperCase(),
                        'side': side.toUpperCase()
                    };
                    if (price !== undefined) request['order_price'] = this.priceToPrecision(symbol, price);
                    if (type === 'market') {
                        // for market buy it requires the amount of quote currency to spend
                        if (side === 'buy') {
                            const cost = this.safeNumber(params, 'cost');
                            if (this.safeValue(this.options, 'createMarketBuyOrderRequiresPrice', true)) {
                                if (cost === undefined) {
                                    if (price === undefined) throw new InvalidOrder(this.id + " createOrder() requires the price argument for market buy orders to calculate total order cost. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount, or alternatively, supply the total cost value in the 'order_amount' in  exchange-specific parameters");
                                    else request['order_amount'] = this.costToPrecision(symbol, amount * price);
                                } else request['order_amount'] = this.costToPrecision(symbol, cost);
                            }
                        } else request['order_quantity'] = this.amountToPrecision(symbol, amount);
                    } else request['order_quantity'] = this.amountToPrecision(symbol, amount);
                    const clientOrderId = this.safeString2(params, 'clOrdID', 'clientOrderId');
                    if (clientOrderId !== undefined) request['client_order_id'] = clientOrderId;
                    params = this.omit(params, [
                        'clOrdID',
                        'clientOrderId'
                    ]);
                    const [marketType, query] = this.handleMarketTypeAndParams('createOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PrivatePostOrder'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     success: true,
                    //     timestamp: '1641383206.489',
                    //     order_id: '86980774',
                    //     order_type: 'LIMIT',
                    //     order_price: '1', // null for 'MARKET' order
                    //     order_quantity: '12', // null for 'MARKET' order
                    //     order_amount: null, // NOT-null for 'MARKET' order
                    //     client_order_id: '0'
                    // }
                    return this.extend(this.parseOrder(response, market), {
                        'type': type
                    });
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const request = undefined;
                    const clientOrderIdUnified = this.safeString2(params, 'clOrdID', 'clientOrderId');
                    const clientOrderIdExchangeSpecific = this.safeString2(params, 'client_order_id', clientOrderIdUnified);
                    const isByClientOrder = clientOrderIdExchangeSpecific !== undefined;
                    if (isByClientOrder) {
                        request['client_order_id'] = clientOrderIdExchangeSpecific;
                        params = this.omit(params, [
                            'clOrdID',
                            'clientOrderId',
                            'client_order_id'
                        ]);
                    } else request['order_id'] = id;
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    request['symbol'] = market['id'];
                    const [marketType, query] = this.handleMarketTypeAndParams('cancelOrder', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PrivateDeleteOrder'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    // { success: true, status: 'CANCEL_SENT' }
                    //
                    const extendParams = {
                        'symbol': symbol
                    };
                    if (isByClientOrder) extendParams['client_order_id'] = clientOrderIdExchangeSpecific;
                    else extendParams['id'] = id;
                    return this.extend(this.parseOrder(response), extendParams);
                }
                async cancelOrders(ids, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' canelOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const [marketType, query] = this.handleMarketTypeAndParams('cancelOrders', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PrivateDeleteOrders'
                    });
                    const response = await this[method](this.extend(request, query));
                    return response;
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const market = symbol !== undefined ? this.market(symbol) : undefined;
                    const request = {};
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrder', market, params);
                    const clientOrderId = this.safeString2(params, 'clOrdID', 'clientOrderId');
                    let chosenSpotMethod = undefined;
                    if (clientOrderId) {
                        chosenSpotMethod = 'v1PrivateGetClientOrderClientOrderId';
                        request['client_order_id'] = clientOrderId;
                    } else {
                        chosenSpotMethod = 'v1PrivateGetOrderOid';
                        request['oid'] = id;
                    }
                    const method = this.getSupportedMapping(marketType, {
                        'spot': chosenSpotMethod
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    // {
                    //     success: true,
                    //     symbol: 'SPOT_WOO_USDT',
                    //     status: 'FILLED', // FILLED, NEW
                    //     side: 'BUY',
                    //     created_time: '1641480933.000',
                    //     order_id: '87541111',
                    //     order_tag: 'default',
                    //     price: '1',
                    //     type: 'LIMIT',
                    //     quantity: '12',
                    //     amount: null,
                    //     visible: '12',
                    //     executed: '12', // or any partial amount
                    //     total_fee: '0.0024',
                    //     fee_asset: 'WOO',
                    //     client_order_id: null,
                    //     average_executed_price: '1',
                    //     Transactions: [
                    //       {
                    //         id: '99111647',
                    //         symbol: 'SPOT_WOO_USDT',
                    //         fee: '0.0024',
                    //         side: 'BUY',
                    //         executed_timestamp: '1641482113.084',
                    //         order_id: '87541111',
                    //         executed_price: '1',
                    //         executed_quantity: '12',
                    //         fee_asset: 'WOO',
                    //         is_maker: '1'
                    //       }
                    //     ]
                    // }
                    //
                    return this.parseOrder(response);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['start_t'] = since;
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrders', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PrivateGetOrders'
                    });
                    const response = await this[method](this.extend(request, query));
                    const data = this.safeValue(response, 'rows');
                    return this.parseOrders(data, market, since, limit, params);
                }
                parseOrder(order, market) {
                    //
                    // Possible input functions:
                    // * createOrder
                    // * cancelOrder
                    // * fetchOrder
                    // * fetchOrders
                    // const isFromFetchOrder = ('order_tag' in order); TO_DO
                    const timestamp = this.safeTimestamp2(order, 'timestamp', 'created_time');
                    const orderId = this.safeInteger(order, 'order_id');
                    const clientOrderId = this.safeTimestamp(order, 'client_order_id'); // Somehow, this always returns 0 for limit order
                    const marketId = this.safeString(order, 'symbol');
                    market = this.safeMarket(marketId, market);
                    const symbol = market['symbol'];
                    const price = this.safeString2(order, 'order_price', 'price');
                    const amount = this.safeString2(order, 'order_quantity', 'quantity'); // This is base amount
                    const cost = this.safeString2(order, 'order_amount', 'amount'); // This is quote amount
                    const orderType = this.safeStringLower2(order, 'order_type', 'type');
                    const status = this.safeValue(order, 'status');
                    const side = this.safeStringLower2(order, 'side');
                    const filled = this.safeValue(order, 'executed');
                    const remaining = Precise.stringSub(cost, filled);
                    const fee = this.safeValue(order, 'total_fee');
                    const feeCurrency = this.safeString(order, 'fee_asset');
                    const transactions = this.safeValue(order, 'Transactions');
                    return this.safeOrder({
                        'id': orderId,
                        'clientOrderId': clientOrderId,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': this.parseOrderStatus(status),
                        'symbol': symbol,
                        'type': orderType,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'average': undefined,
                        'amount': amount,
                        'filled': filled,
                        'remaining': remaining,
                        'cost': cost,
                        'trades': transactions,
                        'fee': {
                            'cost': fee,
                            'currency': feeCurrency
                        },
                        'info': order
                    }, market);
                }
                parseOrderStatus(status) {
                    if (status !== undefined) {
                        const statuses = {
                            'NEW': 'open',
                            'FILLED': 'closed',
                            'CANCEL_SENT': 'canceled',
                            'CANCEL_ALL_SENT': 'canceled'
                        };
                        return this.safeString(statuses, status, status);
                    }
                    return status;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (limit !== undefined) {
                        limit = Math.min(limit, 1000);
                        request['max_level'] = limit;
                    }
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrderBook', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PrivateGetOrderbookSymbol'
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    // {
                    //   success: true,
                    //   timestamp: '1641562961192',
                    //   asks: [
                    //     { price: '0.921', quantity: '76.01' },
                    //     { price: '0.933', quantity: '477.10' },
                    //     ...
                    //   ],
                    //   bids: [
                    //     { price: '0.940', quantity: '13502.47' },
                    //     { price: '0.932', quantity: '43.91' },
                    //     ...
                    //   ]
                    // }
                    //
                    const timestamp = this.safeInteger(response, 'timestamp');
                    return this.parseOrderBook(response, symbol, timestamp, 'bids', 'asks', 'price', 'quantity');
                }
                async fetchOHLCV(symbol, timeframe = '1h', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'type': this.timeframes[timeframe]
                    };
                    if (limit !== undefined) request['limit'] = Math.min(limit, 1000);
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOHLCV', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PrivateGetKline'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     success: true,
                    //     rows: [
                    //       {
                    //         open: '0.94238',
                    //         close: '0.94271',
                    //         low: '0.94238',
                    //         high: '0.94296',
                    //         volume: '73.55',
                    //         amount: '69.32040520',
                    //         symbol: 'SPOT_WOO_USDT',
                    //         type: '1m',
                    //         start_timestamp: '1641584700000',
                    //         end_timestamp: '1641584760000'
                    //       },
                    //       {
                    //         open: '0.94186',
                    //         close: '0.94186',
                    //         low: '0.94186',
                    //         high: '0.94186',
                    //         volume: '64.00',
                    //         amount: '60.27904000',
                    //         symbol: 'SPOT_WOO_USDT',
                    //         type: '1m',
                    //         start_timestamp: '1641584640000',
                    //         end_timestamp: '1641584700000'
                    //       },
                    //       ...
                    //     ]
                    // }
                    const data = this.safeValue(response, 'rows', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    // example response in fetchOHLCV
                    return [
                        this.safeInteger(ohlcv, 'start_timestamp'),
                        this.safeNumber(ohlcv, 'open'),
                        this.safeNumber(ohlcv, 'high'),
                        this.safeNumber(ohlcv, 'low'),
                        this.safeNumber(ohlcv, 'close'),
                        this.safeNumber(ohlcv, 'volume')
                    ];
                }
                async fetchOrderTrades(id, symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'oid': id
                    };
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchOrderTrades', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PrivateGetOrderOidTrades'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     success: true,
                    //     rows: [
                    //       {
                    //         id: '99111647',
                    //         symbol: 'SPOT_WOO_USDT',
                    //         fee: '0.0024',
                    //         side: 'BUY',
                    //         executed_timestamp: '1641482113.084',
                    //         order_id: '87541111',
                    //         order_tag: 'default',
                    //         executed_price: '1',
                    //         executed_quantity: '12',
                    //         fee_asset: 'WOO',
                    //         is_maker: '1'
                    //       }
                    //     ]
                    // }
                    const trades = this.safeValue(response, 'rows', []);
                    return this.parseTrades(trades, market, since, limit, params);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['start_t'] = since;
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchMyTrades', market, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PrivateGetClientTrades'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     "success": true,
                    //     "meta": {
                    //         "records_per_page": 25,
                    //         "current_page": 1
                    //     },
                    //     "rows": [
                    //         {
                    //             "id": 5,
                    //             "symbol": "SPOT_BTC_USDT",
                    //             "order_id": 211,
                    //             "order_tag": "default",
                    //             "executed_price": 10892.84,
                    //             "executed_quantity": 0.002,
                    //             "is_maker": 0,
                    //             "side": "SELL",
                    //             "fee": 0,
                    //             "fee_asset": "USDT",
                    //             "executed_timestamp": "1566264290.250"
                    //         },
                    //         ...
                    //     ]
                    // }
                    const trades = this.safeValue(response, 'rows', []);
                    return this.parseTrades(trades, market, since, limit, params);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchBalance', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v2PrivateGetClientHolding'
                    });
                    const response = await this[method](query);
                    //
                    // {
                    //     holding: [
                    //       {
                    //         token: 'USDT',
                    //         holding: '23.56', // free balance
                    //         frozen: '888.0', // i.e. if in processing withdrawal
                    //         interest: '0.0',
                    //         outstanding_holding: '-56.7', // this value is set (negative number) if there is an open limit order, and this is QUOTE currency of order
                    //         pending_exposure: '333.45', //  this value is set  (positive number) if there is an open limit order, and this is BASE currency of order
                    //         opening_cost: '0.00000000',
                    //         holding_cost: '0.00000000',
                    //         realised_pnl: '0.00000000',
                    //         settled_pnl: '0.00000000',
                    //         fee_24_h: '0',
                    //         settled_pnl_24_h: '0',
                    //         updated_time: '1641370779'
                    //       },
                    //       ...
                    //     ],
                    //     success: true
                    // }
                    //
                    return this.parseBalance(response);
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    const balances = this.safeValue(response, 'holding', []);
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const code = this.safeCurrencyCode(this.safeString(balance, 'token'));
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'holding');
                        const used = this.safeString(balance, 'outstanding_holding');
                        account['used'] = Precise.stringNeg(used);
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchDepositAddress(code, params = {}) {
                    // this method is TODO because of networks unification
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const networkCodeDefault = this.defaultNetworkCodeForCurrency(code);
                    const networkCode = this.safeValue(params, 'network', networkCodeDefault);
                    params = this.omit(params, 'network');
                    const networkAliases = this.safeValue(this.options, 'network-aliases', {});
                    const networkId = this.getKeyByValue(networkAliases, networkCode);
                    const codeForExchange = networkId + '_' + currency['code'];
                    const request = {
                        'token': codeForExchange
                    };
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchDepositAddress', undefined, params);
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'v1PrivateGetAssetDeposit'
                    });
                    const response = await this[method](this.extend(request, query));
                    // {
                    //     success: true,
                    //     address: '3Jmtjx5544T4smrit9Eroe4PCrRkpDeKjP',
                    //     extra: ''
                    // }
                    let tag = this.safeString(response, 'extra');
                    if (tag === '') tag = undefined;
                    const address = this.safeString(response, 'address');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': networkCode,
                        'info': response
                    };
                }
                async getAssetHistoryRows(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['balance_token'] = currency['id'];
                    }
                    if (since !== undefined) request['start_t'] = since;
                    if (limit !== undefined) request['pageSize'] = limit;
                    const transactionType = this.safeString(params, 'type');
                    params = this.omit(params, 'type');
                    if (transactionType !== undefined) request['type'] = transactionType;
                    const response = await this.v1PrivateGetAssetHistory(this.extend(request, params));
                    // {
                    //     rows: [
                    //       {
                    //         id: '22010508193900165',
                    //         token: 'TRON_USDT',
                    //         extra: '',
                    //         amount: '13.75848500',
                    //         status: 'COMPLETED',
                    //         account: null,
                    //         description: null,
                    //         user_id: '42222',
                    //         application_id: '6ad2b303-f354-45c0-8105-9f5f19d0e335',
                    //         external_id: '220105081900134',
                    //         target_address: 'TXnyFSnAYad3YCaqtwMw9jvXKkeU39NLnK',
                    //         source_address: 'TYDzsYUEpvnYmQk4zGP9sWWcTEd2MiAtW6',
                    //         type: 'BALANCE',
                    //         token_side: 'DEPOSIT',
                    //         tx_id: '35b0004022f6b3ad07f39a0b7af199f6b258c2c3e2c7cdc93c67efa74fd625ee',
                    //         fee_token: '',
                    //         fee_amount: '0.00000000',
                    //         created_time: '1641370779.442',
                    //         updated_time: '1641370779.465',
                    //         is_new_target_address: null,
                    //         confirmed_number: '29',
                    //         confirming_threshold: '27',
                    //         audit_tag: '1',
                    //         audit_result: '0',
                    //         balance_token: null, // TODO -write to support, that this seems broken. here should be the token id
                    //         network_name: null // TODO -write to support, that this seems broken. here should be the network id
                    //       }
                    //     ],
                    //     meta: { total: '1', records_per_page: '25', current_page: '1' },
                    //     success: true
                    // }
                    return [
                        currency,
                        this.safeValue(response, 'rows', {})
                    ];
                }
                async fetchLedger(code, since, limit, params = {}) {
                    const [currency, rows] = await this.getAssetHistoryRows(code, since, limit, params);
                    return this.parseLedger(rows, currency, since, limit, params);
                }
                parseLedgerEntry(item, currency) {
                    const networkizedCode = this.safeString(item, 'token');
                    const currencyDefined = this.getCurrencyFromChaincode(networkizedCode, currency);
                    const code = currencyDefined['code'];
                    const amount = this.safeNumber(item, 'amount');
                    const side = this.safeNumber(item, 'token_side');
                    const direction = side === 'DEPOSIT' ? 'in' : 'out';
                    const timestamp = this.safeTimestamp(item, 'created_time');
                    const fee = this.parseTokenAndFeeTemp(item, 'fee_token', 'fee_amount');
                    return {
                        'id': this.safeString(item, 'id'),
                        'currency': code,
                        'account': this.safeString(item, 'account'),
                        'referenceAccount': undefined,
                        'referenceId': this.safeString(item, 'tx_id'),
                        'status': this.parseTransactionStatus(item, 'status'),
                        'amount': amount,
                        'before': undefined,
                        'after': undefined,
                        'fee': fee,
                        'direction': direction,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'type': this.parseLedgerEntryType(this.safeString(item, 'type')),
                        'info': item
                    };
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'BALANCE': 'transaction',
                        'COLLATERAL': 'transfer'
                    };
                    return this.safeString(types, type, type);
                }
                getCurrencyFromChaincode(networkizedCode, currency) {
                    if (currency !== undefined) return currency;
                    else {
                        const parts = networkizedCode.split('_');
                        const partsLength = parts.length;
                        const firstPart = this.safeString(parts, 0);
                        let currencyId = this.safeString(parts, 1, firstPart);
                        if (partsLength > 2) currencyId += '_' + this.safeString(parts, 2);
                        currency = this.safeCurrency(currencyId);
                    }
                    return currency;
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    const request = {
                        'token_side': 'DEPOSIT'
                    };
                    return await this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    const request = {
                        'token_side': 'WITHDRAW'
                    };
                    return await this.fetchTransactions(code, since, limit, this.extend(request, params));
                }
                async fetchTransactions(code, since, limit, params = {}) {
                    const request = {
                        'type': 'BALANCE'
                    };
                    const [currency, rows] = await this.getAssetHistoryRows(code, since, limit, this.extend(request, params));
                    return this.parseTransactions(rows, currency, since, limit, params);
                }
                parseTransaction(transaction, currency) {
                    // example in fetchLedger
                    const networkizedCode = this.safeString(transaction, 'token');
                    const currencyDefined = this.getCurrencyFromChaincode(networkizedCode, currency);
                    const code = currencyDefined['code'];
                    let movementDirection = this.safeStringLower(transaction, 'token_side');
                    if (movementDirection === 'withdraw') movementDirection = 'withdrawal';
                    const fee = this.parseTokenAndFeeTemp(transaction, 'fee_token', 'fee_amount');
                    fee['rate'] = undefined;
                    const addressTo = this.safeString(transaction, 'target_address');
                    const addressFrom = this.safeString(transaction, 'source_address');
                    const timestamp = this.safeTimestamp(transaction, 'created_time');
                    return {
                        'id': this.safeString(transaction, 'id'),
                        'txid': this.safeString(transaction, 'tx_id'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'address': undefined,
                        'addressFrom': addressFrom,
                        'addressTo': addressTo,
                        'tag': this.safeString(transaction, 'extra'),
                        'type': movementDirection,
                        'amount': this.safeNumber(transaction, 'amount'),
                        'currency': code,
                        'status': this.parseTransactionStatus(this.safeString(transaction, 'status')),
                        'updated': this.safeTimestamp(transaction, 'updated_time'),
                        'fee': fee,
                        'info': transaction
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        'NEW': 'pending',
                        'CONFIRMING': 'pending',
                        'PROCESSING': 'pending',
                        'COMPLETED': 'ok',
                        'CANCELED': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'token': currency['id'],
                        'amount': this.parseNumber(amount),
                        'from_application_id': fromAccount,
                        'to_application_id': toAccount
                    };
                    const response = await this.v1PrivatePostAssetMainSubTransfer(this.extend(request, params));
                    //
                    //     {
                    //         "success": true,
                    //         "id": 200
                    //     }
                    //
                    const transfer = this.parseTransfer(response, currency);
                    const transferOptions = this.safeValue(this.options, 'transfer', {});
                    const fillResponseFromRequest = this.safeValue(transferOptions, 'fillResponseFromRequest', true);
                    if (fillResponseFromRequest) {
                        transfer['amount'] = amount;
                        transfer['fromAccount'] = fromAccount;
                        transfer['toAccount'] = toAccount;
                    }
                    return transfer;
                }
                async fetchTransfers(code, since, limit, params = {}) {
                    const request = {
                        'type': 'COLLATERAL'
                    };
                    const [currency, rows] = await this.getAssetHistoryRows(code, since, limit, this.extend(request, params));
                    return this.parseTransfers(rows, currency, since, limit, params);
                }
                parseTransfer(transfer, currency) {
                    //
                    //    getAssetHistoryRows
                    //        {
                    //            "created_time": "1579399877.041",  // Unix epoch time in seconds
                    //            "updated_time": "1579399877.041",  // Unix epoch time in seconds
                    //            "id": "202029292829292",
                    //            "external_id": "202029292829292",
                    //            "application_id": null,
                    //            "token": "ETH",
                    //            "target_address": "0x31d64B3230f8baDD91dE1710A65DF536aF8f7cDa",
                    //            "source_address": "0x70fd25717f769c7f9a46b319f0f9103c0d887af0",
                    //            "extra": "",
                    //            "type": "BALANCE",
                    //            "token_side": "DEPOSIT",
                    //            "amount": 1000,
                    //            "tx_id": "0x8a74c517bc104c8ebad0c3c3f64b1f302ed5f8bca598ae4459c63419038106b6",
                    //            "fee_token": null,
                    //            "fee_amount": null,
                    //            "status": "CONFIRMING"
                    //        }
                    //
                    //    v1PrivatePostAssetMainSubTransfer
                    //        {
                    //            "success": true,
                    //            "id": 200
                    //        }
                    //
                    const networkizedCode = this.safeString(transfer, 'token');
                    const currencyDefined = this.getCurrencyFromChaincode(networkizedCode, currency);
                    const code = currencyDefined['code'];
                    let movementDirection = this.safeStringLower(transfer, 'token_side');
                    if (movementDirection === 'withdraw') movementDirection = 'withdrawal';
                    let fromAccount = undefined;
                    let toAccount = undefined;
                    if (movementDirection === 'withdraw') {
                        fromAccount = undefined;
                        toAccount = 'spot';
                    } else if (movementDirection === 'deposit') {
                        fromAccount = 'spot';
                        toAccount = undefined;
                    }
                    const timestamp = this.safeTimestamp(transfer, 'created_time');
                    const success = this.safeValue(transfer, 'success');
                    let status = undefined;
                    if (success !== undefined) status = success ? 'ok' : 'failed';
                    return {
                        'id': this.safeString(transfer, 'id'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': code,
                        'amount': this.safeNumber(transfer, 'amount'),
                        'fromAccount': fromAccount,
                        'toAccount': toAccount,
                        'status': this.parseTransferStatus(this.safeString(transfer, 'status', status)),
                        'info': transfer
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'NEW': 'pending',
                        'CONFIRMING': 'pending',
                        'PROCESSING': 'pending',
                        'COMPLETED': 'ok',
                        'CANCELED': 'canceled'
                    };
                    return this.safeString(statuses, status, status);
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, section = 'public', method = 'GET', params = {}, headers, body) {
                    const version = section[0];
                    const access = section[1];
                    let url = this.implodeHostname(this.urls['api'][access]);
                    url += '/' + version + '/';
                    path = this.implodeParams(path, params);
                    params = this.omit(params, this.extractParams(path));
                    params = this.keysort(params);
                    if (access === 'public') {
                        url += access + '/' + path;
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    } else {
                        this.checkRequiredCredentials();
                        url += path;
                        const ts = this.nonce().toString();
                        let auth = this.urlencode(params);
                        if (method === 'POST' || method === 'DELETE') body = auth;
                        else url += '?' + auth;
                        auth += '|' + ts;
                        const signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha256');
                        headers = {
                            'x-api-key': this.apiKey,
                            'x-api-signature': signature,
                            'x-api-timestamp': ts,
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (!response) return; // fallback to default error handler
                    //
                    //     400 Bad Request {"success":false,"code":-1012,"message":"Amount is required for buy market orders when margin disabled."}
                    //
                    const success = this.safeValue(response, 'success');
                    const errorCode = this.safeString(response, 'code');
                    if (!success) {
                        const feedback = this.id + ' ' + this.json(response);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                        this.throwExactlyMatchedException(this.exceptions['exact'], errorCode, feedback);
                    }
                }
                defaultNetworkCodeForCurrency(code) {
                    // at first, try to find if user or exchange has defined default networks for the specific currency
                    const defaultNetworkCodeForCurrencies = this.safeValue(this.options, 'defaultNetworkCodeForCurrencies');
                    if (defaultNetworkCodeForCurrencies !== undefined) {
                        const defaultNetworkCode = this.safeStringUpper(defaultNetworkCodeForCurrencies, code);
                        if (defaultNetworkCode !== undefined) return defaultNetworkCode;
                    }
                    // if not found by above 'defaultNetworkCodeForCurrencies' for specific currency, then try with `defaultNetworkCodePriorities`
                    const currencyItem = this.currency(code);
                    const networks = currencyItem['networks'];
                    const defaultNetworkCodePriorities = this.safeValue(this.options, 'defaultNetworkCodePriorities');
                    if (defaultNetworkCodePriorities !== undefined) {
                        // itterate according to priority networks
                        const networksKeys = Object.keys(networks);
                        const networksKeysLength = networksKeys.length;
                        if (networksKeysLength > 0) for(let i = 0; i < defaultNetworkCodePriorities.length; i++){
                            const networkCode = defaultNetworkCodePriorities[i];
                            if (networkCode in networks) return networkCode;
                        }
                    }
                    // if it was not returned according to above options, then return the first network of currency
                    const networkKeys = Object.keys(networks);
                    return this.safeValue(networkKeys, 0);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8,
            "./base/functions/number": 14
        }
    ],
    171: [
        function(require1, module, exports) {
            'use strict';
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, BadRequest: BadRequest, InsufficientFunds: InsufficientFunds, InvalidAddress: InvalidAddress, BadSymbol: BadSymbol, InvalidOrder: InvalidOrder } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            module.exports = class xena extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'xena',
                        'name': 'Xena Exchange',
                        'countries': [
                            'VC',
                            'UK'
                        ],
                        // per second rate limits are far lower than the equivalent hourly
                        // requests per second rounded down (3dp)
                        // relative weight costs rounded up (3dp)
                        // 1 hour = 3600 seconds
                        // Order Cancellations: 100k per hour => 100 000 / 3600 = 27.777 requests per second => rateLimit = 1000ms / 27.777 = 36.001008 ms between requests => 36.1 (safety)
                        // New Orders: 30k per hour => 30 000 / 3600 = 8.333 requests per second => cost = 27.777 / 8.333 = 3.333373335 => 3.334
                        // Heartbeat: 30k per hour => 30 000 / 3600 = 8.333 requests per second => cost = 27.777 / 8.333 = 3.333373335 => 3.334
                        // Candles: 5000 per hour => 5000 /  3600 = 1.388 requests per second => cost = 27.777 / 1.388 = 20.01224784 => 20.013
                        // Dom (market data): 5000 per hour => 5000 /  3600 = 1.388 requests per second => cost = 27.777 / 1.388 = 20.01224784 => 20.013
                        // All snapshot requests (balances, active orders and trade history, positions): 500 per hour => 0.138 requests per second => cost = 27.777 / 0.138 = 201.2826087 => 201.283
                        'rateLimit': 36.1,
                        'has': {
                            'CORS': undefined,
                            'spot': false,
                            'margin': false,
                            'swap': undefined,
                            'future': undefined,
                            'option': false,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createOrder': true,
                            'editOrder': true,
                            'fetchAccounts': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDeposits': true,
                            'fetchLedger': true,
                            'fetchLeverageTiers': true,
                            'fetchMarketLeverageTiers': 'emulated',
                            'fetchMarkets': true,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrderBook': true,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTime': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchTransfer': false,
                            'fetchTransfers': false,
                            'fetchWithdrawal': false,
                            'fetchWithdrawals': true,
                            'transfer': false,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/51840849/87489843-bb469280-c64c-11ea-91aa-69c6326506af.jpg',
                            'test': {
                                'public': 'https://trading.demo.xena.io/api',
                                'private': 'https://api.demo.xena.io'
                            },
                            'api': {
                                'public': 'https://trading.xena.exchange/api',
                                'private': 'https://api.xena.exchange'
                            },
                            'www': 'https://xena.exchange',
                            'doc': 'https://support.xena.exchange/support/solutions/44000808700',
                            'fees': 'https://trading.xena.exchange/en/contracts/terms-and-condition'
                        },
                        'timeframes': {
                            '1m': '1m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '4h': '4h',
                            '12h': '12h',
                            '1d': '1d',
                            '1w': '1w'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'common/currencies': 20.013,
                                    'common/instruments': 20.013,
                                    'common/features': 20.013,
                                    'common/commissions': 20.013,
                                    'common/news': 20.013,
                                    'market-data/candles/{marketId}/{timeframe}': 20.013,
                                    'market-data/market-watch': 20.013,
                                    'market-data/dom/{symbol}': 20.013,
                                    'market-data/candles/{symbol}/{timeframe}': 20.013,
                                    'market-data/trades/{symbol}': 20.013,
                                    'market-data/server-time': 20.013,
                                    'market-data/v2/candles/{symbol}/{timeframe}': 20.013,
                                    'market-data/v2/trades/{symbol}': 20.013,
                                    'market-data/v2/dom/{symbol}/': 20.013,
                                    'market-data/v2/server-time': 20.013
                                }
                            },
                            'private': {
                                'get': {
                                    'trading/accounts/{accountId}/order': 50,
                                    'trading/accounts/{accountId}/active-orders': 50,
                                    'trading/accounts/{accountId}/last-order-statuses': 50,
                                    'trading/accounts/{accountId}/positions': 50,
                                    'trading/accounts/{accountId}/positions-history': 50,
                                    'trading/accounts/{accountId}/margin-requirements': 50,
                                    'trading/accounts': 50,
                                    'trading/accounts/{accountId}/balance': 50,
                                    'trading/accounts/{accountId}/trade-history': 50,
                                    // 'trading/accounts/{accountId}/trade-history?symbol=BTC/USDT&client_order_id=EMBB8Veke&trade_id=2205043254': 50,
                                    'transfers/accounts': 50,
                                    'transfers/accounts/{accountId}': 50,
                                    'transfers/accounts/{accountId}/deposit-address/{currency}': 50,
                                    'transfers/accounts/{accountId}/deposits': 100,
                                    'transfers/accounts/{accountId}/trusted-addresses': 50,
                                    'transfers/accounts/{accountId}/withdrawals': 50,
                                    'transfers/accounts/{accountId}/balance-history': 50
                                },
                                'post': {
                                    'trading/order/new': 3.334,
                                    'trading/order/heartbeat': 3.334,
                                    'trading/order/cancel': 1,
                                    'trading/order/mass-cancel': 1,
                                    'trading/order/replace': 3.334,
                                    'trading/position/maintenance': 3.334,
                                    'transfers/accounts/{accountId}/withdrawals': 3.334,
                                    'transfers/accounts/{accountId}/deposit-address/{currency}': 3.334
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': 0.0005,
                                'taker': 0.001,
                                'tierBased': true,
                                'percentage': true
                            },
                            'funding': {
                                'tierBased': false,
                                'percentage': false,
                                'withdraw': {},
                                'deposit': {}
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'Validation failed': BadRequest,
                                'Unknown derivative symbol': BadSymbol,
                                'Unknown account': BadRequest,
                                'Wrong TransactTime': BadRequest,
                                'ClOrdId is empty': BadRequest
                            },
                            'broad': {
                                'Invalid aggregation ratio or depth': BadRequest,
                                'address': InvalidAddress,
                                'Money not enough': InsufficientFunds,
                                'parse error': BadRequest,
                                'Not enough': InsufficientFunds
                            }
                        },
                        'options': {
                            'defaultType': 'margin',
                            'accountId': undefined
                        }
                    });
                }
                async fetchTime(params = {}) {
                    const response = await this.publicGetMarketDataV2ServerTime(params);
                    //
                    //     {
                    //         "msgType":"0",
                    //         "transactTime":1594774454112817637
                    //     }
                    //
                    const transactTime = this.safeInteger(response, 'transactTime');
                    return parseInt(transactTime / 1000000);
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetCommonInstruments(params);
                    //
                    //     [
                    //         {
                    //             "type": "Index",
                    //             "symbol": ".ADAUSD",
                    //             "tickSize": 4,
                    //             "enabled": true
                    //         },
                    //         {
                    //             "id":"ETHUSD_3M_250920",
                    //             "type":"Margin",
                    //             "marginType":"XenaFuture",
                    //             "symbol":"ETHUSD_3M_250920",
                    //             "baseCurrency":"ETH",
                    //             "quoteCurrency":"USD",
                    //             "settlCurrency":"BTC",
                    //             "tickSize":2,
                    //             "minOrderQuantity":"1",
                    //             "orderQtyStep":"1",
                    //             "limitOrderMaxDistance":"10",
                    //             "priceInputMask":"0000.00",
                    //             "enabled":true,
                    //             "liquidationMaxDistance":"0.01",
                    //             "contractValue":"1",
                    //             "contractCurrency":"BTC",
                    //             "lotSize":"1",
                    //             "tickValue":"0.00000001", // linear contracts only
                    //             "maxOrderQty":"175000",
                    //             "maxPosVolume":"1750000",
                    //             "mark":".ETHUSD_3M_250920",
                    //             "underlying":".ETHUSD_TWAP",
                    //             "openInterest":".ETHUSD_3M_250920_OpenInterest",
                    //             "floatingPL":"BidAsk", // perpetual contracts only
                    //             "addUvmToFreeMargin":"ProfitAndLoss",
                    //             "margin":{
                    //                 "netting":"PositionsAndOrders",
                    //                 "rates":[
                    //                     {"maxVolume":"175000","initialRate":"0.05","maintenanceRate":"0.0125"},
                    //                     {"maxVolume":"350000","initialRate":"0.1","maintenanceRate":"0.025"},
                    //                     {"maxVolume":"500000","initialRate":"0.2","maintenanceRate":"0.05"},
                    //                     {"maxVolume":"750000","initialRate":"0.3","maintenanceRate":"0.075"},
                    //                     {"maxVolume":"1050000","initialRate":"0.4","maintenanceRate":"0.1"},
                    //                     {"maxVolume":"1400000","initialRate":"0.5","maintenanceRate":"0.125"},
                    //                     {"maxVolume":"1750000","initialRate":"1","maintenanceRate":"0.25"}
                    //                 ],
                    //                 "rateMultipliers":{
                    //                     "LimitBuy":"1",
                    //                     "LimitSell":"1",
                    //                     "Long":"1",
                    //                     "MarketBuy":"1",
                    //                     "MarketSell":"1",
                    //                     "Short":"1",
                    //                     "StopBuy":"0",
                    //                     "StopSell":"0"
                    //                 }
                    //             },
                    //             "clearing":{"enabled":true,"index":".ETHUSD_3M_250920"},
                    //             "premium":{"enabled":true,"index":".XBTUSD_Premium_IR_Corrected"}, // perpetual contracts only
                    //             "riskAdjustment":{"enabled":true,"index":".RiskAdjustment_IR"},
                    //             "expiration":{"enabled":true,"index":".ETHUSD_TWAP"}, // futures only
                    //             "pricePrecision":3,
                    //             "priceRange":{
                    //                 "enabled":true,
                    //                 "distance":"0.03",
                    //                 "movingBoundary":"0",
                    //                 "lowIndex":".ETHUSD_3M_250920_LOWRANGE",
                    //                 "highIndex":".ETHUSD_3M_250920_HIGHRANGE"
                    //             },
                    //             "priceLimits":{
                    //                 "enabled":true,
                    //                 "distance":"0.5",
                    //                 "movingBoundary":"0",
                    //                 "lowIndex":".ETHUSD_3M_250920_LOWLIMIT",
                    //                 "highIndex":".ETHUSD_3M_250920_HIGHLIMIT"
                    //             },
                    //             "inverse":true, // inverse contracts only
                    //             "serie":"ETHUSD", // futures only
                    //             "tradingStartDate":"2020-03-27 07:00:00",
                    //             "expiryDate":"2020-09-25 08:00:00" // futures only
                    //         },
                    //         {
                    //             "type":"Index",
                    //             "symbol":".ETHUSD_Premium_IR_Corrected",
                    //             "tickSize":6,
                    //             "enabled":true,
                    //             "basis":365
                    //         },
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < response.length; i++){
                        const market = response[i];
                        let type = this.safeStringLower(market, 'type');
                        const id = this.safeString(market, 'symbol');
                        const numericId = this.safeString(market, 'id');
                        const marginType = this.safeString(market, 'marginType');
                        const baseId = this.safeString(market, 'baseCurrency');
                        const quoteId = this.safeString(market, 'quoteCurrency');
                        const settleId = this.safeString(market, 'settlCurrency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const settle = this.safeCurrencyCode(settleId);
                        const expiryDate = this.safeString(market, 'expiryDate');
                        const expiryTimestamp = this.parse8601(expiryDate);
                        let symbol = id;
                        let future = false;
                        let swap = false;
                        if (type === 'margin') {
                            symbol = base + '/' + quote + ':' + settle;
                            if (marginType === 'XenaFuture') {
                                symbol = symbol + '-' + this.yymmdd(expiryTimestamp);
                                type = 'future';
                                future = true;
                            } else if (marginType === 'XenaListedPerpetual') {
                                type = 'swap';
                                swap = true;
                            }
                        }
                        const inverse = this.safeValue(market, 'inverse', false);
                        const contract = swap || future;
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'numericId': numericId,
                            'type': type,
                            'spot': false,
                            'margin': false,
                            'swap': swap,
                            'future': future,
                            'option': false,
                            'active': this.safeValue(market, 'enabled', false),
                            'contract': contract,
                            'linear': contract ? !inverse : undefined,
                            'inverse': contract ? inverse : undefined,
                            'contractSize': this.safeNumber(market, 'contractValue'),
                            'expiry': expiryTimestamp,
                            'expiryDatetime': this.iso8601(expiryTimestamp),
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': parseInt('0'),
                                'price': this.safeInteger2(market, 'tickSize', 'pricePrecision')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'minOrderQuantity'),
                                    'max': this.safeNumber(market, 'maxOrderQty')
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.publicGetCommonCurrencies(params);
                    //
                    //     {
                    //         "BAB": {
                    //             "name":"BAB",
                    //             "title":"Bitcoin ABC",
                    //             "blockchain":{
                    //                 "name":"BAB",
                    //                 "title":"Bitcoin ABC",
                    //                 "deposit":{"confirmations":6},
                    //                 "withdraw":{"confirmations":1},
                    //                 "addressReuseAllowed":false,
                    //                 "view":{
                    //                     "uriTemplate":"bitcoinabc:%s?message=Xena Exchange",
                    //                     "recommendedFee":"0.00001",
                    //                     "transactionUrl":"https://blockchair.com/bitcoin-cash/transaction/${txId}",
                    //                     "walletUrl":"https://blockchair.com/bitcoin-cash/address/${walletId}"
                    //                 }
                    //             },
                    //             "precision":5,
                    //             "withdraw":{"minAmount":"0.01","commission":"0.001"},
                    //             "view":{
                    //                 "color":"#DC7C08",
                    //                 "site":"https://www.bitcoinabc.org"
                    //             },
                    //             "enabled":true
                    //         },
                    //     }
                    const ids = Object.keys(response);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const currency = response[id];
                        const code = this.safeCurrencyCode(id);
                        const name = this.safeString(currency, 'title');
                        const precision = this.safeInteger(currency, 'precision');
                        const enabled = this.safeValue(currency, 'enabled');
                        const active = enabled === true;
                        const withdraw = this.safeValue(currency, 'withdraw', {});
                        result[code] = {
                            'id': id,
                            'code': code,
                            'info': currency,
                            'name': name,
                            'active': active,
                            'deposit': undefined,
                            'withdraw': undefined,
                            'fee': this.safeNumber(withdraw, 'commission'),
                            'precision': precision,
                            'limits': {
                                'amount': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'withdraw': {
                                    'min': this.safeNumber(withdraw, 'minAmount'),
                                    'max': undefined
                                }
                            }
                        };
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    // fetchTicker, fetchTickers
                    //
                    //     {
                    //         "symbol":".XBTUSD_3M_250920_MID",
                    //         "firstPx":"9337.49",
                    //         "lastPx":"9355.81",
                    //         "highPx":"9579.42",
                    //         "lowPx":"9157.63",
                    //         "buyVolume":"0",
                    //         "sellVolume":"0",
                    //         "bid":"0",
                    //         "ask":"0"
                    //     }
                    //
                    const timestamp = this.milliseconds();
                    const marketId = this.safeString(ticker, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const last = this.safeString(ticker, 'lastPx');
                    const open = this.safeString(ticker, 'firstPx');
                    const buyVolume = this.safeString(ticker, 'buyVolume');
                    const sellVolume = this.safeString(ticker, 'sellVolume');
                    const baseVolume = this.sum(buyVolume, sellVolume);
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'highPx'),
                        'low': this.safeString(ticker, 'lowPx'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const tickers = await this.fetchTickers(undefined, params);
                    if (symbol in tickers) return tickers[symbol];
                    throw new BadSymbol(this.id + ' fetchTicker() could not find a ticker with symbol ' + symbol);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const tickers = await this.publicGetMarketDataMarketWatch(params);
                    //
                    //     [
                    //         {
                    //             "symbol":".XBTUSD_3M_250920_MID",
                    //             "firstPx":"9337.49",
                    //             "lastPx":"9355.81",
                    //             "highPx":"9579.42",
                    //             "lowPx":"9157.63",
                    //             "buyVolume":"0",
                    //             "sellVolume":"0",
                    //             "bid":"0",
                    //             "ask":"0"
                    //         }
                    //     ]
                    //
                    const result = {};
                    for(let i = 0; i < tickers.length; i++){
                        const ticker = this.parseTicker(tickers[i]);
                        const symbol = ticker['symbol'];
                        result[symbol] = ticker;
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    if (limit !== undefined) request['depth'] = limit;
                    const response = await this.publicGetMarketDataV2DomSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "msgType":"W",
                    //         "mdStreamId":"DOM:XBTUSD:aggregated",
                    //         "lastUpdateTime":1594772683037691997,
                    //         "mdBookType":"2",
                    //         "symbol":"XBTUSD",
                    //         "lowRangePx":"9132.24",
                    //         "highRangePx":"9410.36",
                    //         "lowLimitPx":"9132.24",
                    //         "highLimitPx":"9410.36",
                    //         "clearingPx":"9253.4",
                    //         "bestBid":"9269.8",
                    //         "bestAsk":"9275.9",
                    //         "mdEntry":[
                    //             {"mdEntryType":"1","mdEntryPx":"9275.9","mdEntrySize":"3000","numberOfOrders":1},
                    //             {"mdEntryType":"1","mdEntryPx":"9277.7","mdEntrySize":"50000","numberOfOrders":1},
                    //             {"mdEntryType":"1","mdEntryPx":"9277.8","mdEntrySize":"2000","numberOfOrders":1},
                    //             {"mdEntryType":"0","mdEntryPx":"9269.8","mdEntrySize":"2000","numberOfOrders":1},
                    //             {"mdEntryType":"0","mdEntryPx":"9267.9","mdEntrySize":"3000","numberOfOrders":1},
                    //             {"mdEntryType":"0","mdEntryPx":"9267.8","mdEntrySize":"50000","numberOfOrders":1},
                    //         ]
                    //     }
                    //
                    const mdEntry = this.safeValue(response, 'mdEntry', []);
                    const mdEntriesByType = this.groupBy(mdEntry, 'mdEntryType');
                    const lastUpdateTime = this.safeInteger(response, 'lastUpdateTime');
                    let timestamp = undefined;
                    if (lastUpdateTime !== undefined) timestamp = parseInt(lastUpdateTime / 1000000);
                    return this.parseOrderBook(mdEntriesByType, symbol, timestamp, '0', '1', 'mdEntryPx', 'mdEntrySize');
                }
                async fetchAccounts(params = {}) {
                    const response = await this.privateGetTradingAccounts(params);
                    //
                    //     {
                    //         "accounts": [
                    //             { "id":8273231, "kind": "Spot" },
                    //             { "id":10012833469, "kind": "Margin", "currency": "BTC" }
                    //         ]
                    //     }
                    //
                    const accounts = this.safeValue(response, 'accounts');
                    const result = [];
                    for(let i = 0; i < accounts.length; i++){
                        const account = accounts[i];
                        const accountId = this.safeString(account, 'id');
                        const currencyId = this.safeString(account, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const type = this.safeStringLower(account, 'kind');
                        result.push({
                            'id': accountId,
                            'type': type,
                            'currency': code,
                            'info': account
                        });
                    }
                    return result;
                }
                async findAccountByType(type) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountsByType = this.groupBy(this.accounts, 'type');
                    const accounts = this.safeValue(accountsByType, type);
                    if (accounts === undefined) throw new ExchangeError1(this.id + " findAccountByType() could not find an accountId with type '" + type + "', specify the 'accountId' parameter instead"); // eslint-disable-line quotes
                    const numAccounts = accounts.length;
                    if (numAccounts > 1) throw new ExchangeError1(this.id + " findAccountByType() found more than one accountId with type '" + type + "', specify the 'accountId' parameter instead"); // eslint-disable-line quotes
                    return accounts[0];
                }
                async getAccountId(params) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const defaultAccountId = this.safeString(this.options, 'accountId');
                    const accountId = this.safeString(params, 'accountId', defaultAccountId);
                    if (accountId !== undefined) return accountId;
                    const defaultType = this.safeString(this.options, 'defaultType', 'margin');
                    const type = this.safeString(params, 'type', defaultType);
                    params = this.omit(params, 'type');
                    if (type === undefined) throw new ArgumentsRequired1(this.id + " requires an 'accountId' parameter or a 'type' parameter ('spot' or 'margin')");
                    const account = await this.findAccountByType(type);
                    return account['id'];
                }
                parseBalance(response) {
                    const result = {
                        'info': response
                    };
                    let timestamp = undefined;
                    const balances = this.safeValue(response, 'balances', []);
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const lastUpdateTime = this.safeString(balance, 'lastUpdateTime');
                        const lastUpdated = lastUpdateTime.slice(0, 13);
                        const currentTimestamp = parseInt(lastUpdated);
                        timestamp = timestamp === undefined ? currentTimestamp : Math.max(timestamp, currentTimestamp);
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'onHold');
                        result[code] = account;
                    }
                    result['timestamp'] = timestamp;
                    result['datetime'] = this.iso8601(timestamp);
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const request = {
                        'accountId': accountId
                    };
                    const response = await this.privateGetTradingAccountsAccountIdBalance(this.extend(request, params));
                    //
                    //     {
                    //         "msgType":"XAR",
                    //         "balances":[
                    //             {
                    //                 "currency":"BTC",
                    //                 "lastUpdateTime":1619384111905916598,
                    //                 "available":"0.00549964",
                    //                 "onHold":"0",
                    //                 "settled":"0.00549964",
                    //                 "equity":"0.00549964"
                    //             }
                    //         ]
                    //     }
                    //
                    return this.parseBalance(response);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //         "mdUpdateAction":"0",
                    //         "mdEntryType":"2",
                    //         "mdEntryPx":"9225.16",
                    //         "mdEntrySize":"10000",
                    //         "transactTime":1594728504524977655,
                    //         "tradeId":"6ac51bb7-7505-4f35-85ef-61eb738cb4d9",
                    //         "aggressorSide":"1"
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         "msgType":"8",
                    //         "account":1012838158,
                    //         "clOrdId":"xXWKLQVl3",
                    //         "orderId":"89eee8bd-98ae-4d06-97dc-ee2d12997fe7",
                    //         "symbol":"ETHUSD",
                    //         "transactTime":1595143349089739000,
                    //         "execId":"c4bd0ee2330930924e0f6fdde4630e56751692a4",
                    //         "tradeId":"30a394b2-6d53-4bc4-b276-d8e19f470ba1",
                    //         "side":"2",
                    //         "lastQty":"1",
                    //         "lastPx":"234.58",
                    //         "avgPx":"234.58",
                    //         "calculatedCcyLastQty":"0",
                    //         "netMoney":"0",
                    //         "lastLiquidityInd":"2",
                    //         "commission":"0.00000011",
                    //         "commRate":"0.00045",
                    //         "commCurrency":"BTC",
                    //         "positionId":132162662,
                    //         "positionEffect":"C"
                    //     }
                    //
                    const id = this.safeString(trade, 'tradeId');
                    let timestamp = this.safeInteger(trade, 'transactTime');
                    if (timestamp !== undefined) timestamp = parseInt(timestamp / 1000000);
                    let side = this.safeStringLower2(trade, 'side', 'aggressorSide');
                    if (side === '1') side = 'buy';
                    else if (side === '2') side = 'sell';
                    const orderId = this.safeString(trade, 'orderId');
                    const marketId = this.safeString(trade, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const priceString = this.safeString2(trade, 'lastPx', 'mdEntryPx');
                    const amountString = this.safeString2(trade, 'lastQty', 'mdEntrySize');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'commission');
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'commCurrency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        const feeRateString = this.safeString(trade, 'commRate');
                        fee = {
                            'cost': feeCostString,
                            'rate': feeRateString,
                            'currency': feeCurrencyCode
                        };
                    }
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'order': orderId,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const request = {
                        'accountId': accountId
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['from'] = since * 1000000;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetTradingAccountsAccountIdTradeHistory(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "msgType":"8",
                    //             "account":1012838158,
                    //             "clOrdId":"xXWKLQVl3",
                    //             "orderId":"89eee8bd-98ae-4d06-97dc-ee2d12997fe7",
                    //             "symbol":"ETHUSD",
                    //             "transactTime":1595143349089739000,
                    //             "execId":"c4bd0ee2330930924e0f6fdde4630e56751692a4",
                    //             "tradeId":"30a394b2-6d53-4bc4-b276-d8e19f470ba1",
                    //             "side":"2",
                    //             "lastQty":"1",
                    //             "lastPx":"234.58",
                    //             "avgPx":"234.58",
                    //             "calculatedCcyLastQty":"0",
                    //             "netMoney":"0",
                    //             "lastLiquidityInd":"2",
                    //             "commission":"0.00000011",
                    //             "commRate":"0.00045",
                    //             "commCurrency":"BTC",
                    //             "positionId":132162662,
                    //             "positionEffect":"C"
                    //         },
                    //         {
                    //             "msgType":"8",
                    //             "account":1012838158,
                    //             "clOrdId":"3ce8c305-9936-4e97-9206-71ae3ff40305",
                    //             "orderId":"a93c686d-990e-44d9-9cbe-61107744b990",
                    //             "symbol":"ETHUSD",
                    //             "transactTime":1595143315369226000,
                    //             "execId":"1c745881722ad966a4ce71600cd058d59da0d1c3",
                    //             "tradeId":"77f75bd8-27c4-4b1a-a5e8-0d59239ce216",
                    //             "side":"1",
                    //             "lastQty":"1",
                    //             "lastPx":"234.72",
                    //             "avgPx":"234.72",
                    //             "calculatedCcyLastQty":"0",
                    //             "netMoney":"0",
                    //             "lastLiquidityInd":"2",
                    //             "commission":"0.00000011",
                    //             "commRate":"0.00045",
                    //             "commCurrency":"BTC",
                    //             "positionId":132162662,
                    //             "positionEffect":"O"
                    //         }
                    //     ]
                    //
                    return this.parseTrades(response, market, since, limit);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     {
                    //         "transactTime":1594784700000000000,
                    //         "firstPx":"9246.3",
                    //         "lastPx":"9232.8",
                    //         "highPx":"9246.3",
                    //         "lowPx":"9232.8",
                    //         "buyVolume":"0",
                    //         "sellVolume":"0"
                    //     }
                    //
                    const transactTime = this.safeInteger(ohlcv, 'transactTime');
                    const timestamp = parseInt(transactTime / 1000000);
                    const buyVolume = this.safeNumber(ohlcv, 'buyVolume');
                    const sellVolume = this.safeNumber(ohlcv, 'sellVolume');
                    const volume = this.sum(buyVolume, sellVolume);
                    return [
                        timestamp,
                        this.safeNumber(ohlcv, 'firstPx'),
                        this.safeNumber(ohlcv, 'highPx'),
                        this.safeNumber(ohlcv, 'lowPx'),
                        this.safeNumber(ohlcv, 'lastPx'),
                        volume
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id'],
                        'timeframe': this.timeframes[timeframe]
                    };
                    const durationInSeconds = this.parseTimeframe(timeframe);
                    const duration = durationInSeconds * 1000;
                    if (since !== undefined) {
                        request['from'] = since * 1000000;
                        if (limit !== undefined) request['to'] = this.sum(since, limit * duration) * 1000000;
                    } else {
                        const now = this.milliseconds();
                        // max limit is 1000
                        if (limit !== undefined) request['from'] = (now - limit * duration) * 1000000;
                    }
                    const response = await this.publicGetMarketDataV2CandlesSymbolTimeframe(this.extend(request, params));
                    //
                    //     {
                    //         "mdEntry":[
                    //             {"transactTime":1594784700000000000,"firstPx":"9246.3","lastPx":"9232.8","highPx":"9246.3","lowPx":"9232.8","buyVolume":"0","sellVolume":"0"},
                    //             {"transactTime":1594785600000000000,"firstPx":"9231.8","lastPx":"9227.3","highPx":"9232.8","lowPx":"9227.3","buyVolume":"0","sellVolume":"0"},
                    //             {"transactTime":1594786500000000000,"firstPx":"9226.3","lastPx":"9230.3","highPx":"9230.3","lowPx":"9220.6","buyVolume":"0","sellVolume":"0"}
                    //         ]
                    //     }
                    //
                    const mdEntry = this.safeValue(response, 'mdEntry', []);
                    return this.parseOHLCVs(mdEntry, market, timeframe, since, limit);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    if (since !== undefined) request['from'] = this.iso8601(since);
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetMarketDataV2TradesSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "msgType":"W",
                    //         "lastUpdateTime":1594737830902223803,
                    //         "symbol":"XBTUSD",
                    //         "mdEntry":[
                    //             {
                    //                 "mdUpdateAction":"0",
                    //                 "mdEntryType":"2",
                    //                 "mdEntryPx":"9225.16",
                    //                 "mdEntrySize":"10000",
                    //                 "transactTime":1594728504524977655,
                    //                 "tradeId":"6ac51bb7-7505-4f35-85ef-61eb738cb4d9",
                    //                 "aggressorSide":"1"
                    //             },
                    //         ]
                    //     }
                    //
                    const mdEntry = this.safeValue(response, 'mdEntry', []);
                    return this.parseTrades(mdEntry, market, since, limit);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        'A': 'open',
                        '0': 'open',
                        '1': 'open',
                        '2': 'closed',
                        '6': 'canceled',
                        '4': 'canceled',
                        'E': 'open',
                        '8': 'rejected'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder
                    //
                    //     {
                    //         "msgType":"8",
                    //         "account":1012838720,
                    //         "clOrdId":"XAq0pRQ1g",
                    //         "orderId":"64d7a06a-27e5-422e-99d9-3cadc04f5a35",
                    //         "symbol":"XBTUSD",
                    //         "ordType":"2",
                    //         "price":"9000",
                    //         "transactTime":1593778763271127920,
                    //         "execId":"ff5fb8153652f0516bf07b6979255bed053c84b9",
                    //         "execType":"I",
                    //         "ordStatus":"0",
                    //         "side":"1",
                    //         "orderQty":"1",
                    //         "leavesQty":"1",
                    //         "cumQty":"0",
                    //         "positionEffect":"O",
                    //         "marginAmt":"0.00000556",
                    //         "marginAmtType":"11"
                    //     }
                    //
                    const id = this.safeString(order, 'orderId');
                    const clientOrderId = this.safeString(order, 'clOrdId');
                    const transactTime = this.safeInteger(order, 'transactTime');
                    const timestamp = parseInt(transactTime / 1000000);
                    const status = this.parseOrderStatus(this.safeString(order, 'ordStatus'));
                    const marketId = this.safeString(order, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'orderQty');
                    const filled = this.safeString(order, 'cumQty');
                    const remaining = this.safeString(order, 'leavesQty');
                    let side = this.safeString(order, 'side');
                    if (side === '1') side = 'buy';
                    else if (side === '2') side = 'sell';
                    let type = this.safeString(order, 'ordType');
                    if (type === '1') type = 'market';
                    else if (type === '2') type = 'limit';
                    else if (type === '3') type = 'stop';
                    else if (type === '4') type = 'stop-limit';
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': clientOrderId,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': symbol,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'average': undefined,
                        'filled': filled,
                        'remaining': remaining,
                        'status': status,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const orderTypes = {
                        'market': '1',
                        'limit': '2',
                        'stop': '3',
                        'stop-limit': '4'
                    };
                    const orderType = this.safeString(orderTypes, type);
                    if (orderType === undefined) throw new InvalidOrder(this.id + ' createOrder() does not support order type ' + type + ', supported order types are market, limit, stop, stop-limit');
                    const orderSides = {
                        'buy': '1',
                        'sell': '2'
                    };
                    const orderSide = this.safeString(orderSides, side);
                    if (orderSide === undefined) throw new InvalidOrder(this.id + ' createOrder() does not support order side ' + side + ', supported order sides are buy, sell');
                    const market = this.market(symbol);
                    const request = {
                        'account': parseInt(accountId),
                        'symbol': market['id'],
                        'ordType': orderType,
                        'side': orderSide,
                        'orderQty': this.amountToPrecision(symbol, amount),
                        'transactTime': this.milliseconds() * 1000000
                    };
                    if (type === 'limit' || type === 'stop-limit') {
                        if (price === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a price argument for order type ' + type);
                        request['price'] = this.priceToPrecision(symbol, price);
                    }
                    if (type === 'stop' || type === 'stop-limit') {
                        const stopPx = this.safeNumber(params, 'stopPx');
                        if (stopPx === undefined) throw new InvalidOrder(this.id + ' createOrder() requires a stopPx param for order type ' + type);
                        request['stopPx'] = this.priceToPrecision(symbol, stopPx);
                        params = this.omit(params, 'stopPx');
                    }
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'clOrdId', this.uuid());
                    if (clientOrderId !== undefined) {
                        request['clOrdId'] = clientOrderId;
                        params = this.omit(params, [
                            'clientOrderId',
                            'clOrdId'
                        ]);
                    }
                    const response = await this.privatePostTradingOrderNew(this.extend(request, params));
                    //
                    //     {
                    //         "msgType":"8",
                    //         "account":1012838720,
                    //         "clOrdId":"XAq0pRQ1g",
                    //         "orderId":"64d7a06a-27e5-422e-99d9-3cadc04f5a35",
                    //         "symbol":"XBTUSD",
                    //         "ordType":"2",
                    //         "price":"9000",
                    //         "transactTime":1593778763271127920,
                    //         "execId":"ff5fb8153652f0516bf07b6979255bed053c84b9",
                    //         "execType":"I",
                    //         "ordStatus":"0",
                    //         "side":"1",
                    //         "orderQty":"1",
                    //         "leavesQty":"1",
                    //         "cumQty":"0",
                    //         "positionEffect":"O",
                    //         "marginAmt":"0.00000556",
                    //         "marginAmtType":"11"
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async editOrder(id, symbol, type, side, amount, price, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const market = this.market(symbol);
                    const request = {
                        'account': parseInt(accountId),
                        'clOrdId': this.uuid(),
                        'symbol': market['id'],
                        'transactTime': this.milliseconds() * 1000000
                    };
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'origClOrdId');
                    if (clientOrderId !== undefined) {
                        request['origClOrdId'] = clientOrderId;
                        params = this.omit(params, [
                            'clientOrderId',
                            'origClOrdId'
                        ]);
                    } else request['orderId'] = id;
                    if (amount !== undefined) request['orderQty'] = this.amountToPrecision(symbol, amount);
                    if (price !== undefined) request['price'] = this.priceToPrecision(symbol, price);
                    const stopPx = this.safeNumber(params, 'stopPx');
                    if (stopPx !== undefined) {
                        request['stopPx'] = this.priceToPrecision(symbol, stopPx);
                        params = this.omit(params, 'stopPx');
                    }
                    const capPrice = this.safeNumber(params, 'capPrice');
                    if (capPrice !== undefined) {
                        request['capPrice'] = this.priceToPrecision(symbol, capPrice);
                        params = this.omit(params, 'capPrice');
                    }
                    const response = await this.privatePostTradingOrderReplace(this.extend(request, params));
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const clientOrderId = this.safeString2(params, 'clientOrderId', 'origClOrdId');
                    params = this.omit(params, [
                        'clientOrderId',
                        'origClOrdId'
                    ]);
                    const market = this.market(symbol);
                    const request = {
                        'account': parseInt(accountId),
                        'symbol': market['id'],
                        'clOrdId': this.uuid(),
                        'transactTime': this.milliseconds() * 1000000
                    };
                    if (clientOrderId !== undefined) request['origClOrdId'] = clientOrderId;
                    else request['orderId'] = id;
                    const response = await this.privatePostTradingOrderCancel(this.extend(request, params));
                    //
                    //     {
                    //         "msgType":"8",
                    //         "account":1012838158,
                    //         "clOrdId":"0fa3fb55-9dc0-4cfc-a1db-6aa8b7dd2d98",
                    //         "origClOrdId":"3b2878bb-24d8-4922-9d2a-5b8009416677",
                    //         "orderId":"665b418e-9d09-4461-b733-d317f6bff43f",
                    //         "symbol":"ETHUSD",
                    //         "ordType":"2",
                    //         "price":"640",
                    //         "transactTime":1595060080941618739,
                    //         "execId":"c541c0ca437c0e6501c3a50a9d4dc8f575f49972",
                    //         "execType":"6",
                    //         "ordStatus":"6",
                    //         "side":"2",
                    //         "orderQty":"1",
                    //         "leavesQty":"0",
                    //         "cumQty":"0",
                    //         "positionEffect":"O",
                    //         "marginAmt":"0.000032",
                    //         "marginAmtType":"11"
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const request = {
                        'account': parseInt(accountId),
                        'clOrdId': this.uuid()
                    };
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        request['symbol'] = market['id'];
                        request['massCancelRequestType'] = '1'; // CancelOrdersForASecurity
                    } else request['massCancelRequestType'] = '7'; // CancelAllOrders
                    const response = await this.privatePostTradingOrderMassCancel(this.extend(request, params));
                    //
                    //     {
                    //         "msgType":"r",
                    //         "clOrdId":"b3e95759-e43e-4b3a-b664-a4d213e281a7",
                    //         "massActionReportID":"e915b6f4-a7ca-4c5c-b8d6-e39862530248",
                    //         "massCancelResponse":"1",
                    //         "symbol":"ETHUSD",
                    //         "transactTime":1595065630133756426,
                    //         "totalAffectedOrders":2,
                    //         "account":1012838158
                    //     }
                    //
                    return response;
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const request = {
                        'accountId': accountId
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    const response = await this.privateGetTradingAccountsAccountIdActiveOrders(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "msgType":"8",
                    //             "account":1012838720,
                    //             "clOrdId":"XAq0pRQ1g",
                    //             "orderId":"64d7a06a-27e5-422e-99d9-3cadc04f5a35",
                    //             "symbol":"XBTUSD",
                    //             "ordType":"2",
                    //             "price":"9000",
                    //             "transactTime":1593778763271127920,
                    //             "execId":"ff5fb8153652f0516bf07b6979255bed053c84b9",
                    //             "execType":"I",
                    //             "ordStatus":"0",
                    //             "side":"1",
                    //             "orderQty":"1",
                    //             "leavesQty":"1",
                    //             "cumQty":"0",
                    //             "positionEffect":"O",
                    //             "marginAmt":"0.00000556",
                    //             "marginAmtType":"11"
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const request = {
                        'accountId': accountId
                    };
                    let market = undefined;
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['from'] = this.iso8601(since) * 1000000;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.privateGetTradingAccountsAccountIdLastOrderStatuses(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "msgType":"8",
                    //             "account":1012838720,
                    //             "clOrdId":"XAq0pRQ1g",
                    //             "orderId":"64d7a06a-27e5-422e-99d9-3cadc04f5a35",
                    //             "symbol":"XBTUSD",
                    //             "ordType":"2",
                    //             "price":"9000",
                    //             "transactTime":1593778763271127920,
                    //             "execId":"ff5fb8153652f0516bf07b6979255bed053c84b9",
                    //             "execType":"I",
                    //             "ordStatus":"0",
                    //             "side":"1",
                    //             "orderQty":"1",
                    //             "leavesQty":"1",
                    //             "cumQty":"0",
                    //             "positionEffect":"O",
                    //             "marginAmt":"0.00000556",
                    //             "marginAmtType":"11"
                    //         }
                    //     ]
                    //
                    return this.parseOrders(response, market, since, limit);
                }
                async createDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const currency = this.currency(code);
                    const request = {
                        'accountId': accountId,
                        'currency': currency['id']
                    };
                    const response = await this.privatePostTransfersAccountsAccountIdDepositAddressCurrency(this.extend(request, params));
                    //
                    //     {
                    //         "address": "mu5GceHFAG38mGRYCFqafe5ZiNKLX3rKk9",
                    //         "uri": "bitcoin:mu5GceHFAG38mGRYCFqafe5ZiNKLX3rKk9?message=Xena Exchange",
                    //         "allowsRenewal": true
                    //     }
                    //
                    const address = this.safeValue(response, 'address');
                    const tag = undefined;
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'info': response
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const currency = this.currency(code);
                    const request = {
                        'accountId': accountId,
                        'currency': currency['id']
                    };
                    const response = await this.privateGetTransfersAccountsAccountIdDepositAddressCurrency(this.extend(request, params));
                    //
                    //     {
                    //         "address": "mu5GceHFAG38mGRYCFqafe5ZiNKLX3rKk9",
                    //         "uri": "bitcoin:mu5GceHFAG38mGRYCFqafe5ZiNKLX3rKk9?message=Xena Exchange",
                    //         "allowsRenewal": true
                    //     }
                    //
                    const address = this.safeValue(response, 'address');
                    const tag = undefined;
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': response
                    };
                }
                async fetchTransactionsByType(type, code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchTransactions() requires a currency `code` argument');
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'accountId': accountId
                    };
                    if (since !== undefined) request['since'] = parseInt(since / 1000);
                    const method = 'privateGetTransfersAccountsAccountId' + this.capitalize(type);
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "withdrawals": [
                    //             {
                    //                 "withdrawalRequestId": 47383243,
                    //                 "externalId": "...",    // external ID submitted by the client when creating the request
                    //                 "status": 1,
                    //                 "statusMessage": "Pending confirmation",
                    //                 "amount": "10.2",
                    //                 "currency": "BTC",
                    //                 "lastUpdated": <UNIX nanoseconds>,
                    //                 "blockchain": "Bitcoin",
                    //                 "address": "mu5GceHFAG38mGRYCFqafe5ZiNKLX3rKk9",
                    //                 "txId": "0xfbb1b73c4f0bda4f67dca266ce6ef42f520fbb98"
                    //             }
                    //         ]
                    //     }
                    //
                    //     {
                    //         "deposits": [
                    //             {
                    //                 "currency": "BTC",
                    //                 "amount": "1.2",
                    //                 "status": 1,
                    //                 "statusMessage": "Processing",
                    //                 "blockchain": "Bitcoin",
                    //                 "txId": "0xfbb1b73c4f0bda4f67dca266ce6ef42f520fbb98",
                    //                 "address": "mu5GceHFAG38mGRYCFqafe5ZiNKLX3rKk9",
                    //                 "lastUpdated": <UNIX nanoseconds>
                    //                 "confirmations": 2,
                    //                 "requiredConfirmations": 6
                    //             }
                    //         ]
                    //     }
                    //
                    //
                    const transactions = this.safeValue(response, type, []);
                    return this.parseTransactions(transactions, currency, since, limit);
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    return await this.fetchTransactionsByType('withdrawals', code, since, limit, params);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    return await this.fetchTransactionsByType('deposits', code, since, limit, params);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw()
                    //
                    //     {
                    //         "withdrawalRequestId": 47383243,
                    //         "status": 1,
                    //         "statusMessage": "Pending confirmation"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "withdrawalRequestId": 47383243,
                    //         "externalId": "...",    // external ID submitted by the client when creating the request
                    //         "status": 1,
                    //         "statusMessage": "Pending confirmation",
                    //         "amount": "10.2",
                    //         "currency": "BTC",
                    //         "lastUpdated": <UNIX nanoseconds>,
                    //         "blockchain": "Bitcoin",
                    //         "address": "mu5GceHFAG38mGRYCFqafe5ZiNKLX3rKk9",
                    //         "txId": "0xfbb1b73c4f0bda4f67dca266ce6ef42f520fbb98"
                    //     }
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "currency": "BTC",
                    //         "amount": "1.2",
                    //         "status": 1,
                    //         "statusMessage": "Processing",
                    //         "blockchain": "Bitcoin",
                    //         "txId": "0xfbb1b73c4f0bda4f67dca266ce6ef42f520fbb98",
                    //         "address": "mu5GceHFAG38mGRYCFqafe5ZiNKLX3rKk9",
                    //         "lastUpdated": <UNIX nanoseconds>
                    //         "confirmations": 2,
                    //         "requiredConfirmations": 6
                    //     }
                    //
                    const id = this.safeString(transaction, 'withdrawalRequestId');
                    const type = id === undefined ? 'deposit' : 'withdrawal';
                    let updated = this.safeInteger(transaction, 'lastUpdated');
                    if (updated !== undefined) updated = parseInt(updated / 1000000);
                    const timestamp = undefined;
                    const txid = this.safeString(transaction, 'txId');
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    const address = this.safeString(transaction, 'address');
                    const addressFrom = undefined;
                    const addressTo = address;
                    const amount = this.safeNumber(transaction, 'amount');
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    const fee = undefined;
                    const network = this.safeString(transaction, 'blockchain');
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': network,
                        'addressFrom': addressFrom,
                        'addressTo': addressTo,
                        'address': address,
                        'tagFrom': undefined,
                        'tagTo': undefined,
                        'tag': undefined,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        '1': 'pending',
                        '2': 'ok',
                        '3': 'failed',
                        '4': 'failed',
                        '5': 'pending',
                        '100': 'pending',
                        '101': 'pending',
                        '102': 'pending',
                        '103': 'pending'
                    };
                    return this.safeString(statuses, status, status);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const currency = this.currency(code);
                    let uuid = this.uuid();
                    uuid = uuid.split('-');
                    uuid = uuid.join('');
                    const request = {
                        'currency': currency['id'],
                        'accountId': accountId,
                        'amount': this.currencyToPrecision(code, amount),
                        'address': address,
                        'id': uuid
                    };
                    const response = await this.privatePostTransfersAccountsAccountIdWithdrawals(this.extend(request, params));
                    //
                    //     {
                    //         "withdrawalRequestId": 47383243,
                    //         "status": 1,
                    //         "statusMessage": "Pending confirmation"
                    //     }
                    //
                    return this.parseTransaction(response, currency);
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'deposit': 'transaction',
                        'withdrawal': 'transaction',
                        'internal deposit': 'transfer',
                        'internal withdrawal': 'transfer',
                        'rebate': 'rebate',
                        'reward': 'reward'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     {
                    //         "accountId":8263118,
                    //         "ts":1551974415000000000,
                    //         "amount":"-1",
                    //         "currency":"BTC",
                    //         "kind":"internal withdrawal",
                    //         "commission":"0",
                    //         "id":96
                    //     }
                    //
                    const id = this.safeString(item, 'id');
                    let direction = undefined;
                    const account = this.safeString(item, 'accountId');
                    const referenceId = undefined;
                    const referenceAccount = undefined;
                    const type = this.parseLedgerEntryType(this.safeString(item, 'kind'));
                    const code = this.safeCurrencyCode(this.safeString(item, 'currency'), currency);
                    let amount = this.safeNumber(item, 'amount');
                    if (amount < 0) {
                        direction = 'out';
                        amount = Math.abs(amount);
                    } else direction = 'in';
                    let timestamp = this.safeInteger(item, 'ts');
                    if (timestamp !== undefined) timestamp = parseInt(timestamp / 1000000);
                    const fee = {
                        'cost': this.safeNumber(item, 'commission'),
                        'currency': code
                    };
                    const before = undefined;
                    const after = this.safeNumber(item, 'balance');
                    const status = 'ok';
                    return {
                        'info': item,
                        'id': id,
                        'direction': direction,
                        'account': account,
                        'referenceId': referenceId,
                        'referenceAccount': referenceAccount,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'before': before,
                        'after': after,
                        'status': status,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': fee
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    await this.loadAccounts();
                    const accountId = await this.getAccountId(params);
                    const request = {
                        'accountId': accountId
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['symbol'] = currency['id'];
                    }
                    if (since !== undefined) request['from'] = since * 1000000;
                    if (limit !== undefined) request['limit'] = limit; // max 5000
                    const response = await this.privateGetTransfersAccountsAccountIdBalanceHistory(this.extend(request, params));
                    //
                    //     [
                    //         {
                    //             "accountId":8263118,
                    //             "ts":1551974415000000000,
                    //             "amount":"-1",
                    //             "currency":"BTC",
                    //             "kind":"internal withdrawal",
                    //             "commission":"0",
                    //             "id":96
                    //         },
                    //         {
                    //             "accountId":8263118,
                    //             "ts":1551964677000000000,
                    //             "amount":"-1",
                    //             "currency":"BTC",
                    //             "kind":"internal deposit",
                    //             "commission":"0",
                    //             "id":95
                    //         }
                    //     ]
                    //
                    return this.parseLedger(response, currency, since, limit);
                }
                async fetchLeverageTiers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetCommonInstruments(params);
                    //
                    //    [
                    //        {
                    //            "id": "XBTUSD_3M_240622",
                    //            "type": "Margin",
                    //            "marginType": "XenaFuture",
                    //            "symbol": "XBTUSD_3M_240622",
                    //            "baseCurrency": "BTC",
                    //            "quoteCurrency": "USD",
                    //            "settlCurrency": "USDC",
                    //            "tickSize": 0,
                    //            "minOrderQuantity": "0.0001",
                    //            "orderQtyStep": "0.0001",
                    //            "limitOrderMaxDistance": "10",
                    //            "priceInputMask": "00000.0",
                    //            "enabled": true,
                    //            "liquidationMaxDistance": "0.01",
                    //            "contractValue": "1",
                    //            "contractCurrency": "BTC",
                    //            "lotSize": "1",
                    //            "maxOrderQty": "10",
                    //            "maxPosVolume": "200",
                    //            "mark": ".XBTUSD_3M_240622",
                    //            "underlying": ".BTC3_TWAP",
                    //            "openInterest": ".XBTUSD_3M_240622_OpenInterest",
                    //            "addUvmToFreeMargin": "ProfitAndLoss",
                    //            "margin": {
                    //                "netting": "PositionsAndOrders",
                    //                "rates": [
                    //                    { "maxVolume": "10", "initialRate": "0.05", "maintenanceRate": "0.025" },
                    //                    { "maxVolume": "20", "initialRate": "0.1", "maintenanceRate": "0.05" },
                    //                    { "maxVolume": "30", "initialRate": "0.2", "maintenanceRate": "0.1" },
                    //                    { "maxVolume": "40", "initialRate": "0.3", "maintenanceRate": "0.15" },
                    //                    { "maxVolume": "60", "initialRate": "0.4", "maintenanceRate": "0.2" },
                    //                    { "maxVolume": "150", "initialRate": "0.5", "maintenanceRate": "0.25" },
                    //                    { "maxVolume": "200", "initialRate": "1", "maintenanceRate": "0.5" }
                    //               ],
                    //               "rateMultipliers": {
                    //                    "LimitBuy": "1",
                    //                    "LimitSell": "1",
                    //                    "Long": "1",
                    //                    "MarketBuy": "1",
                    //                    "MarketSell": "1",
                    //                    "Short": "1",
                    //                    "StopBuy": "0",
                    //                    "StopSell": "0"
                    //                }
                    //            },
                    //            "clearing": { "enabled": true, "index": ".XBTUSD_3M_240622" },
                    //            "riskAdjustment": { "enabled": true, "index": ".RiskAdjustment_IR" },
                    //            "expiration": { "enabled": true, "index": ".BTC3_TWAP" },
                    //            "pricePrecision": 1,
                    //            "priceRange": {
                    //                "enabled": true,
                    //                "distance": "0.2",
                    //                "movingBoundary": "0",
                    //                "lowIndex": ".XBTUSD_3M_240622_LOWRANGE",
                    //                "highIndex": ".XBTUSD_3M_240622_HIGHRANGE"
                    //            },
                    //            "priceLimits": {
                    //                "enabled": true,
                    //                "distance": "0.5",
                    //                "movingBoundary": "0",
                    //                "lowIndex": ".XBTUSD_3M_240622_LOWLIMIT",
                    //                "highIndex": ".XBTUSD_3M_240622_HIGHLIMIT"
                    //            },
                    //            "serie": "XBTUSD",
                    //            "tradingStartDate": "2021-12-31 07:00:00",
                    //            "expiryDate": "2022-06-24 08:00:00"
                    //           },
                    //           ...
                    //        ]
                    //
                    return this.parseLeverageTiers(response, symbols, 'symbol');
                }
                parseMarketLeverageTiers(info, market) {
                    /**
         * @ignore
         * @method
         * @param {dict} info Exchange market response for 1 market
         * @param {dict} market CCXT market
         */ //
                    //    {
                    //        "id": "XBTUSD_3M_240622",
                    //        "type": "Margin",
                    //        "marginType": "XenaFuture",
                    //        "symbol": "XBTUSD_3M_240622",
                    //        "baseCurrency": "BTC",
                    //        "quoteCurrency": "USD",
                    //        "settlCurrency": "USDC",
                    //        "tickSize": 0,
                    //        "minOrderQuantity": "0.0001",
                    //        "orderQtyStep": "0.0001",
                    //        "limitOrderMaxDistance": "10",
                    //        "priceInputMask": "00000.0",
                    //        "enabled": true,
                    //        "liquidationMaxDistance": "0.01",
                    //        "contractValue": "1",
                    //        "contractCurrency": "BTC",
                    //        "lotSize": "1",
                    //        "maxOrderQty": "10",
                    //        "maxPosVolume": "200",
                    //        "mark": ".XBTUSD_3M_240622",
                    //        "underlying": ".BTC3_TWAP",
                    //        "openInterest": ".XBTUSD_3M_240622_OpenInterest",
                    //        "addUvmToFreeMargin": "ProfitAndLoss",
                    //        "margin": {
                    //            "netting": "PositionsAndOrders",
                    //            "rates": [
                    //                { "maxVolume": "10", "initialRate": "0.05", "maintenanceRate": "0.025" },
                    //                { "maxVolume": "20", "initialRate": "0.1", "maintenanceRate": "0.05" },
                    //                { "maxVolume": "30", "initialRate": "0.2", "maintenanceRate": "0.1" },
                    //                { "maxVolume": "40", "initialRate": "0.3", "maintenanceRate": "0.15" },
                    //                { "maxVolume": "60", "initialRate": "0.4", "maintenanceRate": "0.2" },
                    //                { "maxVolume": "150", "initialRate": "0.5", "maintenanceRate": "0.25" },
                    //                { "maxVolume": "200", "initialRate": "1", "maintenanceRate": "0.5" }
                    //            ],
                    //            "rateMultipliers": {
                    //                "LimitBuy": "1",
                    //                "LimitSell": "1",
                    //                "Long": "1",
                    //                "MarketBuy": "1",
                    //                "MarketSell": "1",
                    //                "Short": "1",
                    //                "StopBuy": "0",
                    //                "StopSell": "0"
                    //            }
                    //        },
                    //        "clearing": { "enabled": true, "index": ".XBTUSD_3M_240622" },
                    //        "riskAdjustment": { "enabled": true, "index": ".RiskAdjustment_IR" },
                    //        "expiration": { "enabled": true, "index": ".BTC3_TWAP" },
                    //        "pricePrecision": 1,
                    //        "priceRange": {
                    //            "enabled": true,
                    //            "distance": "0.2",
                    //            "movingBoundary": "0",
                    //            "lowIndex": ".XBTUSD_3M_240622_LOWRANGE",
                    //            "highIndex": ".XBTUSD_3M_240622_HIGHRANGE"
                    //        },
                    //        "priceLimits": {
                    //            "enabled": true,
                    //            "distance": "0.5",
                    //            "movingBoundary": "0",
                    //            "lowIndex": ".XBTUSD_3M_240622_LOWLIMIT",
                    //            "highIndex": ".XBTUSD_3M_240622_HIGHLIMIT"
                    //        },
                    //        "serie": "XBTUSD",
                    //        "tradingStartDate": "2021-12-31 07:00:00",
                    //        "expiryDate": "2022-06-24 08:00:00"
                    //    }
                    //
                    const margin = this.safeValue(info, 'margin');
                    const rates = this.safeValue(margin, 'rates');
                    let floor = 0;
                    const id = this.safeString(info, 'symbol');
                    market = this.safeMarket(id, market);
                    const tiers = [];
                    if (rates !== undefined) for(let j = 0; j < rates.length; j++){
                        const tier = rates[j];
                        const cap = this.safeNumber(tier, 'maxVolume');
                        const initialRate = this.safeString(tier, 'initialRate');
                        tiers.push({
                            'tier': this.sum(j, 1),
                            'currency': market['base'],
                            'minNotional': floor,
                            'maxNotional': cap,
                            'maintenanceMarginRate': this.safeNumber(tier, 'maintenanceRate'),
                            'maxLeverage': this.parseNumber(Precise.stringDiv('1', initialRate)),
                            'info': tier
                        });
                        floor = cap;
                    }
                    return tiers;
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api] + '/' + this.implodeParams(path, params);
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'public') {
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'private') {
                        this.checkRequiredCredentials();
                        let nonce = this.nonce();
                        // php does not format it properly
                        // therefore we use string concatenation here
                        // nonce *= 1000000;
                        nonce = nonce.toString();
                        nonce = nonce + '000000'; // see the comment a few lines above
                        const payload = 'AUTH' + nonce;
                        const secret = this.secret.slice(14, 78);
                        const ecdsa = this.ecdsa(payload, secret, 'p256', 'sha256');
                        const signature = ecdsa['r'] + ecdsa['s'];
                        headers = {
                            'X-AUTH-API-KEY': this.apiKey,
                            'X-AUTH-API-PAYLOAD': payload,
                            'X-AUTH-API-SIGNATURE': signature,
                            'X-AUTH-API-NONCE': nonce
                        };
                        if (method === 'GET') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else if (method === 'POST') {
                            body = this.json(query);
                            headers['Content-Type'] = 'application/json';
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(code, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    //     {"error":"Validation failed","fields":["address"]}
                    //     {"error":"Money not enough. You have only: 0 ETH","fields":["amount"]}
                    //
                    if (code >= 400) {
                        const feedback = this.id + ' ' + this.json(response);
                        const message = this.safeString(response, 'error');
                        const exact = this.exceptions['exact'];
                        if (message in exact) throw new exact[message](feedback);
                        const broad = this.exceptions['broad'];
                        const broadKey = this.findBroadlyMatchedKey(broad, body);
                        if (broadKey !== undefined) throw new broad[broadKey](feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    172: [
        function(require1, module, exports) {
            'use strict';
            // ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, ExchangeNotAvailable: ExchangeNotAvailable, InvalidNonce: InvalidNonce, InsufficientFunds: InsufficientFunds, OrderNotFound: OrderNotFound, DDoSProtection: DDoSProtection, InvalidOrder: InvalidOrder, AuthenticationError: AuthenticationError, RateLimitExceeded: RateLimitExceeded } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            // ---------------------------------------------------------------------------
            module.exports = class yobit extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'yobit',
                        'name': 'YoBit',
                        'countries': [
                            'RU'
                        ],
                        'rateLimit': 2000,
                        'version': '3',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createDepositAddress': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchDepositAddress': true,
                            'fetchDeposits': undefined,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrderBooks': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': true,
                            'fetchTransactions': undefined,
                            'fetchWithdrawals': undefined,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766910-cdcbfdae-5eea-11e7-9859-03fea873272d.jpg',
                            'api': {
                                'public': 'https://yobit.net/api',
                                'private': 'https://yobit.net/tapi'
                            },
                            'www': 'https://www.yobit.net',
                            'doc': 'https://www.yobit.net/en/api/',
                            'fees': 'https://www.yobit.net/en/fees/'
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'depth/{pair}': 1,
                                    'info': 1,
                                    'ticker/{pair}': 1,
                                    'trades/{pair}': 1
                                }
                            },
                            'private': {
                                'post': {
                                    'ActiveOrders': 1,
                                    'CancelOrder': 1,
                                    'GetDepositAddress': 1,
                                    'getInfo': 1,
                                    'OrderInfo': 1,
                                    'Trade': 1,
                                    'TradeHistory': 1,
                                    'WithdrawCoinsToAddress': 1
                                }
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': 0.002,
                                'taker': 0.002
                            },
                            'funding': {
                                'withdraw': {}
                            }
                        },
                        'commonCurrencies': {
                            'AIR': 'AirCoin',
                            'ANI': 'ANICoin',
                            'ANT': 'AntsCoin',
                            'ATMCHA': 'ATM',
                            'ASN': 'Ascension',
                            'AST': 'Astral',
                            'ATM': 'Autumncoin',
                            'AUR': 'AuroraCoin',
                            'BAB': 'Babel',
                            'BAN': 'BANcoin',
                            'BCC': 'BCH',
                            'BCS': 'BitcoinStake',
                            'BITS': 'Bitstar',
                            'BLN': 'Bulleon',
                            'BNS': 'Benefit Bonus Coin',
                            'BOT': 'BOTcoin',
                            'BON': 'BONES',
                            'BPC': 'BitcoinPremium',
                            'BST': 'BitStone',
                            'BTS': 'Bitshares2',
                            'CAT': 'BitClave',
                            'CBC': 'CryptoBossCoin',
                            'CMT': 'CometCoin',
                            'COIN': 'Coin.com',
                            'COV': 'Coven Coin',
                            'COVX': 'COV',
                            'CPC': 'Capricoin',
                            'CREDIT': 'Creditbit',
                            'CS': 'CryptoSpots',
                            'DCT': 'Discount',
                            'DFT': 'DraftCoin',
                            'DGD': 'DarkGoldCoin',
                            'DIRT': 'DIRTY',
                            'DROP': 'FaucetCoin',
                            'DSH': 'DASH',
                            'EGC': 'EverGreenCoin',
                            'EGG': 'EggCoin',
                            'EKO': 'EkoCoin',
                            'ENTER': 'ENTRC',
                            'EPC': 'ExperienceCoin',
                            'ESC': 'EdwardSnowden',
                            'EUROPE': 'EUROP',
                            'EXT': 'LifeExtension',
                            'FUND': 'FUNDChains',
                            'FUNK': 'FUNKCoin',
                            'FX': 'FCoin',
                            'GCC': 'GlobalCryptocurrency',
                            'GEN': 'Genstake',
                            'GENE': 'Genesiscoin',
                            'GMR': 'Gimmer',
                            'GOLD': 'GoldMint',
                            'GOT': 'Giotto Coin',
                            'GSX': 'GlowShares',
                            'GT': 'GTcoin',
                            'HTML5': 'HTML',
                            'HYPERX': 'HYPER',
                            'ICN': 'iCoin',
                            'INSANE': 'INSN',
                            'JNT': 'JointCoin',
                            'JPC': 'JupiterCoin',
                            'JWL': 'Jewels',
                            'KNC': 'KingN Coin',
                            'LBTCX': 'LiteBitcoin',
                            'LIZI': 'LiZi',
                            'LOC': 'LocoCoin',
                            'LOCX': 'LOC',
                            'LUNYR': 'LUN',
                            'LUN': 'LunarCoin',
                            'LUNA': 'Luna Coin',
                            'MASK': 'Yobit MASK',
                            'MDT': 'Midnight',
                            'MEME': 'Memez Token',
                            'MIS': 'MIScoin',
                            'MM': 'MasterMint',
                            'NAV': 'NavajoCoin',
                            'NBT': 'NiceBytes',
                            'OMG': 'OMGame',
                            'ONX': 'Onix',
                            'PAC': '$PAC',
                            'PLAY': 'PlayCoin',
                            'PIVX': 'Darknet',
                            'PRS': 'PRE',
                            'PURE': 'PurePOS',
                            'PUTIN': 'PutinCoin',
                            'SPACE': 'Spacecoin',
                            'STK': 'StakeCoin',
                            'SUB': 'Subscriptio',
                            'PAY': 'EPAY',
                            'PLC': 'Platin Coin',
                            'RAI': 'RaiderCoin',
                            'RCN': 'RCoin',
                            'REP': 'Republicoin',
                            'RUR': 'RUB',
                            'SBTC': 'Super Bitcoin',
                            'SMC': 'SmartCoin',
                            'SOLO': 'SoloCoin',
                            'STAR': 'StarCoin',
                            'SUPER': 'SuperCoin',
                            'TNS': 'Transcodium',
                            'TTC': 'TittieCoin',
                            'UNI': 'Universe',
                            'UST': 'Uservice',
                            'VOL': 'VolumeCoin',
                            'XIN': 'XINCoin',
                            'XMT': 'SummitCoin',
                            'XRA': 'Ratecoin'
                        },
                        'options': {
                            // 'fetchTickersMaxLength': 2048,
                            'fetchOrdersRequiresSymbol': true,
                            'fetchTickersMaxLength': 512
                        },
                        'exceptions': {
                            'exact': {
                                '803': InvalidOrder,
                                '804': InvalidOrder,
                                '805': InvalidOrder,
                                '806': InvalidOrder,
                                '807': InvalidOrder,
                                '831': InsufficientFunds,
                                '832': InsufficientFunds,
                                '833': OrderNotFound
                            },
                            'broad': {
                                'Invalid pair name': ExchangeError1,
                                'invalid api key': AuthenticationError,
                                'invalid sign': AuthenticationError,
                                'api key dont have trade permission': AuthenticationError,
                                'invalid parameter': InvalidOrder,
                                'invalid order': InvalidOrder,
                                'The given order has already been cancelled': InvalidOrder,
                                'Requests too often': DDoSProtection,
                                'not available': ExchangeNotAvailable,
                                'data unavailable': ExchangeNotAvailable,
                                'external service unavailable': ExchangeNotAvailable,
                                'Total transaction amount': InvalidOrder,
                                'The given order has already been closed and cannot be cancelled': InvalidOrder,
                                'Insufficient funds': InsufficientFunds,
                                'invalid key': AuthenticationError,
                                'invalid nonce': InvalidNonce,
                                'Total order amount is less than minimal amount': InvalidOrder,
                                'Rate Limited': RateLimitExceeded
                            }
                        },
                        'orders': {}
                    });
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'return', {});
                    const timestamp = this.safeInteger(balances, 'server_time');
                    const result = {
                        'info': response,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    };
                    const free = this.safeValue(balances, 'funds', {});
                    const total = this.safeValue(balances, 'funds_incl_orders', {});
                    const currencyIds = Object.keys(this.extend(free, total));
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['free'] = this.safeString(free, currencyId);
                        account['total'] = this.safeString(total, currencyId);
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGetInfo(params);
                    //
                    //     {
                    //         "success":1,
                    //         "return":{
                    //             "funds":{
                    //                 "ltc":22,
                    //                 "nvc":423.998,
                    //                 "ppc":10,
                    //             },
                    //             "funds_incl_orders":{
                    //                 "ltc":32,
                    //                 "nvc":523.998,
                    //                 "ppc":20,
                    //             },
                    //             "rights":{
                    //                 "info":1,
                    //                 "trade":0,
                    //                 "withdraw":0
                    //             },
                    //             "transaction_count":0,
                    //             "open_orders":1,
                    //             "server_time":1418654530
                    //         }
                    //     }
                    //
                    return this.parseBalance(response);
                }
                async fetchMarkets(params = {}) {
                    const response = await this.publicGetInfo(params);
                    //
                    //     {
                    //         "server_time":1615856752,
                    //         "pairs":{
                    //             "ltc_btc":{
                    //                 "decimal_places":8,
                    //                 "min_price":0.00000001,
                    //                 "max_price":10000,
                    //                 "min_amount":0.0001,
                    //                 "min_total":0.0001,
                    //                 "hidden":0,
                    //                 "fee":0.2,
                    //                 "fee_buyer":0.2,
                    //                 "fee_seller":0.2
                    //             },
                    //         },
                    //     }
                    //
                    const markets = this.safeValue(response, 'pairs');
                    const keys = Object.keys(markets);
                    const result = [];
                    for(let i = 0; i < keys.length; i++){
                        const id = keys[i];
                        const market = markets[id];
                        const [baseId, quoteId] = id.split('_');
                        let base = baseId.toUpperCase();
                        let quote = quoteId.toUpperCase();
                        base = this.safeCurrencyCode(base);
                        quote = this.safeCurrencyCode(quote);
                        const hidden = this.safeInteger(market, 'hidden');
                        let feeString = this.safeString(market, 'fee');
                        feeString = Precise.stringDiv(feeString, '100');
                        // yobit maker = taker
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': hidden === 0,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.parseNumber(feeString),
                            'maker': this.parseNumber(feeString),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': this.safeInteger(market, 'decimal_places'),
                                'price': this.safeInteger(market, 'decimal_places')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'min_amount'),
                                    'max': this.safeNumber(market, 'max_amount')
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'min_price'),
                                    'max': this.safeNumber(market, 'max_price')
                                },
                                'cost': {
                                    'min': this.safeNumber(market, 'min_total'),
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit; // default = 150, max = 2000
                    const response = await this.publicGetDepthPair(this.extend(request, params));
                    const market_id_in_reponse = market['id'] in response;
                    if (!market_id_in_reponse) throw new ExchangeError1(this.id + ' ' + market['symbol'] + ' order book is empty or not available');
                    const orderbook = response[market['id']];
                    return this.parseOrderBook(orderbook, symbol);
                }
                async fetchOrderBooks(symbols, limit, params = {}) {
                    await this.loadMarkets();
                    let ids = undefined;
                    if (symbols === undefined) {
                        ids = this.ids.join('-');
                        // max URL length is 2083 symbols, including http schema, hostname, tld, etc...
                        if (ids.length > 2048) {
                            const numIds = this.ids.length;
                            throw new ExchangeError1(this.id + ' fetchOrderBooks() has ' + numIds.toString() + ' symbols exceeding max URL length, you are required to specify a list of symbols in the first argument to fetchOrderBooks');
                        }
                    } else {
                        ids = this.marketIds(symbols);
                        ids = ids.join('-');
                    }
                    const request = {
                        'pair': ids
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetDepthPair(this.extend(request, params));
                    const result = {};
                    ids = Object.keys(response);
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const symbol = this.safeSymbol(id);
                        result[symbol] = this.parseOrderBook(response[id], symbol);
                    }
                    return result;
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         high: 0.03497582,
                    //         low: 0.03248474,
                    //         avg: 0.03373028,
                    //         vol: 120.11485715062999,
                    //         vol_cur: 3572.24914074,
                    //         last: 0.0337611,
                    //         buy: 0.0337442,
                    //         sell: 0.03377798,
                    //         updated: 1537522009
                    //     }
                    //
                    const timestamp = this.safeTimestamp(ticker, 'updated');
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': this.safeSymbol(undefined, market),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': this.safeString(ticker, 'avg'),
                        'baseVolume': this.safeString(ticker, 'vol_cur'),
                        'quoteVolume': this.safeString(ticker, 'vol'),
                        'info': ticker
                    }, market, false);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    let ids = this.ids;
                    if (symbols === undefined) {
                        const numIds = ids.length;
                        ids = ids.join('-');
                        const maxLength = this.safeInteger(this.options, 'fetchTickersMaxLength', 2048);
                        // max URL length is 2048 symbols, including http schema, hostname, tld, etc...
                        if (ids.length > this.options['fetchTickersMaxLength']) throw new ArgumentsRequired1(this.id + ' fetchTickers() has ' + numIds.toString() + ' markets exceeding max URL length for this endpoint (' + maxLength.toString() + ' characters), please, specify a list of symbols of interest in the first argument to fetchTickers');
                    } else {
                        ids = this.marketIds(symbols);
                        ids = ids.join('-');
                    }
                    const request = {
                        'pair': ids
                    };
                    const tickers = await this.publicGetTickerPair(this.extend(request, params));
                    const result = {};
                    const keys = Object.keys(tickers);
                    for(let k = 0; k < keys.length; k++){
                        const id = keys[k];
                        const ticker = tickers[id];
                        const market = this.safeMarket(id);
                        const symbol = market['symbol'];
                        result[symbol] = this.parseTicker(ticker, market);
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    const tickers = await this.fetchTickers([
                        symbol
                    ], params);
                    return tickers[symbol];
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "type":"bid",
                    //          "price":0.14046179,
                    //          "amount":0.001,
                    //          "tid":200256901,
                    //          "timestamp":1649861004
                    //      }
                    //
                    // fetchMyTrades (private)
                    //
                    //      {
                    //          "pair":"doge_usdt",
                    //          "type":"sell",
                    //          "amount":139,
                    //          "rate":0.139,
                    //          "order_id":"2101103631773172",
                    //          "is_your_order":1,
                    //          "timestamp":"1649861561"
                    //      }
                    //
                    const timestamp = this.safeTimestamp(trade, 'timestamp');
                    let side = this.safeString(trade, 'type');
                    if (side === 'ask') side = 'sell';
                    else if (side === 'bid') side = 'buy';
                    const priceString = this.safeString2(trade, 'rate', 'price');
                    const id = this.safeString2(trade, 'trade_id', 'tid');
                    const order = this.safeString(trade, 'order_id');
                    const marketId = this.safeString(trade, 'pair');
                    const symbol = this.safeSymbol(marketId, market);
                    const amountString = this.safeString(trade, 'amount');
                    // arguments for calculateFee (need to be numbers)
                    const price = this.parseNumber(priceString);
                    const amount = this.parseNumber(amountString);
                    const type = 'limit'; // all trades are still limit trades
                    let fee = undefined;
                    const feeCostString = this.safeNumber(trade, 'commission');
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'commissionCurrency');
                        const feeCurrencyCode = this.safeCurrencyCode(feeCurrencyId);
                        fee = {
                            'cost': feeCostString,
                            'currency': feeCurrencyCode
                        };
                    }
                    const isYourOrder = this.safeValue(trade, 'is_your_order');
                    if (isYourOrder !== undefined) {
                        if (fee === undefined) {
                            const feeInNumbers = this.calculateFee(symbol, type, side, amount, price, 'taker');
                            fee = {
                                'currency': this.safeString(feeInNumbers, 'currency'),
                                'cost': this.safeString(feeInNumbers, 'cost'),
                                'rate': this.safeString(feeInNumbers, 'rate')
                            };
                        }
                    }
                    return this.safeTrade({
                        'id': id,
                        'order': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.publicGetTradesPair(this.extend(request, params));
                    //
                    //      {
                    //          "doge_usdt": [
                    //              {
                    //                  "type":"ask",
                    //                  "price":0.13956743,
                    //                  "amount":0.0008,
                    //                  "tid":200256900,
                    //                  "timestamp":1649860521
                    //              },
                    //          ]
                    //      }
                    //
                    if (Array.isArray(response)) {
                        const numElements = response.length;
                        if (numElements === 0) return [];
                    }
                    const result = this.safeValue(response, market['id'], []);
                    return this.parseTrades(result, market, since, limit);
                }
                async fetchTradingFees(params = {}) {
                    await this.loadMarkets();
                    const response = await this.publicGetInfo(params);
                    //
                    //     {
                    //         "server_time":1615856752,
                    //         "pairs":{
                    //             "ltc_btc":{
                    //                 "decimal_places":8,
                    //                 "min_price":0.00000001,
                    //                 "max_price":10000,
                    //                 "min_amount":0.0001,
                    //                 "min_total":0.0001,
                    //                 "hidden":0,
                    //                 "fee":0.2,
                    //                 "fee_buyer":0.2,
                    //                 "fee_seller":0.2
                    //             },
                    //             ...
                    //         },
                    //     }
                    //
                    const pairs = this.safeValue(response, 'pairs');
                    const marketIds = Object.keys(pairs);
                    const result = {};
                    for(let i = 0; i < marketIds.length; i++){
                        const marketId = marketIds[i];
                        const pair = this.safeValue(pairs, marketId, {});
                        const symbol = this.safeSymbol(marketId, undefined, '_');
                        const takerString = this.safeString(pair, 'fee_buyer');
                        const makerString = this.safeString(pair, 'fee_seller');
                        const taker = this.parseNumber(Precise.stringDiv(takerString, '100'));
                        const maker = this.parseNumber(Precise.stringDiv(makerString, '100'));
                        result[symbol] = {
                            'info': pair,
                            'symbol': symbol,
                            'taker': taker,
                            'maker': maker,
                            'percentage': true,
                            'tierBased': false
                        };
                    }
                    return result;
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    if (type === 'market') throw new ExchangeError1(this.id + ' createOrder() allows limit orders only');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id'],
                        'type': side,
                        'amount': this.amountToPrecision(symbol, amount),
                        'rate': this.priceToPrecision(symbol, price)
                    };
                    const response = await this.privatePostTrade(this.extend(request, params));
                    //
                    //      {
                    //          "success":1,
                    //          "return": {
                    //              "received":0,
                    //              "remains":10,
                    //              "order_id":1101103635125179,
                    //              "funds": {
                    //                  "usdt":27.84756553,
                    //                  "usdttrc20":0,
                    //                  "doge":19.98327206
                    //              },
                    //              "funds_incl_orders": {
                    //                  "usdt":30.35256553,
                    //                  "usdttrc20":0,
                    //                  "doge":19.98327206
                    //               },
                    //               "server_time":1650114256
                    //           }
                    //       }
                    //
                    const result = this.safeValue(response, 'return');
                    return this.parseOrder(result, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': parseInt(id)
                    };
                    const response = await this.privatePostCancelOrder(this.extend(request, params));
                    //
                    //      {
                    //          "success":1,
                    //          "return": {
                    //              "order_id":1101103632552304,
                    //              "funds": {
                    //                  "usdt":30.71055443,
                    //                  "usdttrc20":0,
                    //                  "doge":9.98327206
                    //              },
                    //              "funds_incl_orders": {
                    //                  "usdt":31.81275443,
                    //                  "usdttrc20":0,
                    //                  "doge":9.98327206
                    //              },
                    //              "server_time":1649918298
                    //          }
                    //      }
                    //
                    const result = this.safeValue(response, 'return', {});
                    return this.parseOrder(result);
                }
                parseOrderStatus(status) {
                    const statuses = {
                        '0': 'open',
                        '1': 'closed',
                        '2': 'canceled',
                        '3': 'open'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseOrder(order, market) {
                    //
                    // createOrder (private)
                    //
                    //      {
                    //          "received":0,
                    //          "remains":10,
                    //          "order_id":1101103635125179,
                    //          "funds": {
                    //              "usdt":27.84756553,
                    //              "usdttrc20":0,
                    //              "doge":19.98327206
                    //          },
                    //          "funds_incl_orders": {
                    //              "usdt":30.35256553,
                    //              "usdttrc20":0,
                    //              "doge":19.98327206
                    //          },
                    //          "server_time":1650114256
                    //      }
                    //
                    // fetchOrder (private)
                    //
                    //      {
                    //          "id: "1101103635103335",  // id-field is manually added in fetchOrder () from exchange response id-order dictionary structure
                    //          "pair":"doge_usdt",
                    //          "type":"buy",
                    //          "start_amount":10,
                    //          "amount":10,
                    //          "rate":0.05,
                    //          "timestamp_created":"1650112553",
                    //          "status":0
                    //      }
                    //
                    // fetchOpenOrders (private)
                    //
                    //      {
                    //          "id":"1101103635103335", // id-field is manually added in fetchOpenOrders () from exchange response id-order dictionary structure
                    //          "pair":"doge_usdt",
                    //          "type":"buy",
                    //          "amount":10,
                    //          "rate":0.05,
                    //          "timestamp_created":"1650112553",
                    //          "status":0
                    //      }
                    //
                    // cancelOrder (private)
                    //
                    //      {
                    //          "order_id":1101103634000197,
                    //          "funds": {
                    //              "usdt":31.81275443,
                    //              "usdttrc20":0,
                    //              "doge":9.98327206
                    //          },
                    //          "funds_incl_orders": {
                    //              "usdt":31.81275443,
                    //              "usdttrc20":0,
                    //              "doge":9.98327206
                    //          }
                    //      }
                    //
                    let id = this.safeString2(order, 'id', 'order_id');
                    let status = this.parseOrderStatus(this.safeString(order, 'status', 'open'));
                    if (id === '0') {
                        id = this.safeString(order, 'init_order_id');
                        status = 'closed';
                    }
                    const timestamp = this.safeTimestamp2(order, 'timestamp_created', 'server_time');
                    const marketId = this.safeString(order, 'pair');
                    const symbol = this.safeSymbol(marketId, market);
                    const amount = this.safeString(order, 'start_amount');
                    const remaining = this.safeString2(order, 'amount', 'remains');
                    const filled = this.safeString(order, 'received', '0.0');
                    const price = this.safeString(order, 'rate');
                    const fee = undefined;
                    const type = 'limit';
                    const side = this.safeString(order, 'type');
                    return this.safeOrder({
                        'info': order,
                        'id': id,
                        'clientOrderId': undefined,
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'type': type,
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'amount': amount,
                        'remaining': remaining,
                        'filled': filled,
                        'status': status,
                        'fee': fee,
                        'average': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchOrder(id, symbol, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'order_id': parseInt(id)
                    };
                    const response = await this.privatePostOrderInfo(this.extend(request, params));
                    id = id.toString();
                    const orders = this.safeValue(response, 'return', {});
                    //
                    //      {
                    //          "success":1,
                    //          "return": {
                    //              "1101103635103335": {
                    //                  "pair":"doge_usdt",
                    //                  "type":"buy",
                    //                  "start_amount":10,
                    //                  "amount":10,
                    //                  "rate":0.05,
                    //                  "timestamp_created":"1650112553",
                    //                  "status":0
                    //              }
                    //          }
                    //      }
                    //
                    return this.parseOrder(this.extend({
                        'id': id
                    }, orders[id]));
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const request = {};
                    const market = undefined;
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        request['pair'] = market['id'];
                    }
                    const response = await this.privatePostActiveOrders(this.extend(request, params));
                    //
                    //      {
                    //          "success":1,
                    //          "return": {
                    //              "1101103634006799": {
                    //                  "pair":"doge_usdt",
                    //                  "type":"buy",
                    //                  "amount":10,
                    //                  "rate":0.1,
                    //                  "timestamp_created":"1650034937",
                    //                  "status":0
                    //              },
                    //              "1101103634006738": {
                    //                  "pair":"doge_usdt",
                    //                  "type":"buy",
                    //                  "amount":10,
                    //                  "rate":0.1,
                    //                  "timestamp_created":"1650034932",
                    //                  "status":0
                    //              }
                    //          }
                    //      }
                    //
                    const result = this.safeValue(response, 'return', {});
                    return this.parseOrders(result, market, since, limit);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchMyTrades() requires a `symbol` argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    // some derived classes use camelcase notation for request fields
                    const request = {
                        // 'from': 123456789, // trade ID, from which the display starts numerical 0 (test result: liqui ignores this field)
                        // 'count': 1000, // the number of trades for display numerical, default = 1000
                        // 'from_id': trade ID, from which the display starts numerical 0
                        // 'end_id': trade ID on which the display ends numerical ∞
                        // 'order': 'ASC', // sorting, default = DESC (test result: liqui ignores this field, most recent trade always goes last)
                        // 'since': 1234567890, // UTC start time, default = 0 (test result: liqui ignores this field)
                        // 'end': 1234567890, // UTC end time, default = ∞ (test result: liqui ignores this field)
                        'pair': market['id']
                    };
                    if (limit !== undefined) request['count'] = parseInt(limit);
                    if (since !== undefined) request['since'] = parseInt(since / 1000);
                    const response = await this.privatePostTradeHistory(this.extend(request, params));
                    //
                    //      {
                    //          "success":1,
                    //          "return": {
                    //              "200257004": {
                    //                  "pair":"doge_usdt",
                    //                  "type":"sell",
                    //                  "amount":139,
                    //                  "rate":0.139,
                    //                  "order_id":"2101103631773172",
                    //                  "is_your_order":1,
                    //                  "timestamp":"1649861561"
                    //              }
                    //          }
                    //      }
                    //
                    const trades = this.safeValue(response, 'return', {});
                    const ids = Object.keys(trades);
                    const result = [];
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const trade = this.parseTrade(this.extend(trades[id], {
                            'trade_id': id
                        }), market);
                        result.push(trade);
                    }
                    return this.filterBySymbolSinceLimit(result, market['symbol'], since, limit);
                }
                async createDepositAddress(code, params = {}) {
                    const request = {
                        'need_new': 1
                    };
                    const response = await this.fetchDepositAddress(code, this.extend(request, params));
                    const address = this.safeString(response, 'address');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': undefined,
                        'info': response['info']
                    };
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coinName': currency['id'],
                        'need_new': 0
                    };
                    const response = await this.privatePostGetDepositAddress(this.extend(request, params));
                    const address = this.safeString(response['return'], 'address');
                    this.checkAddress(address);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': undefined,
                        'network': undefined,
                        'info': response
                    };
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coinName': currency['id'],
                        'amount': amount,
                        'address': address
                    };
                    // no docs on the tag, yet...
                    if (tag !== undefined) throw new ExchangeError1(this.id + ' withdraw() does not support the tag argument yet due to a lack of docs on withdrawing with tag/memo on behalf of the exchange.');
                    const response = await this.privatePostWithdrawCoinsToAddress(this.extend(request, params));
                    return {
                        'info': response,
                        'id': undefined
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'][api];
                    const query = this.omit(params, this.extractParams(path));
                    if (api === 'private') {
                        this.checkRequiredCredentials();
                        const nonce = this.nonce();
                        body = this.urlencode(this.extend({
                            'nonce': nonce,
                            'method': path
                        }, query));
                        const signature = this.hmac(this.encode(body), this.encode(this.secret), 'sha512');
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Key': this.apiKey,
                            'Sign': signature
                        };
                    } else if (api === 'public') {
                        url += '/' + this.version + '/' + this.implodeParams(path, params);
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else {
                        url += '/' + this.implodeParams(path, params);
                        if (method === 'GET') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                        } else if (Object.keys(query).length) {
                            body = this.json(query);
                            headers = {
                                'Content-Type': 'application/json'
                            };
                        }
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if ('success' in response) {
                        //
                        // 1 - Liqui only returns the integer 'success' key from their private API
                        //
                        //     { "success": 1, ... } httpCode === 200
                        //     { "success": 0, ... } httpCode === 200
                        //
                        // 2 - However, exchanges derived from Liqui, can return non-integers
                        //
                        //     It can be a numeric string
                        //     { "sucesss": "1", ... }
                        //     { "sucesss": "0", ... }, httpCode >= 200 (can be 403, 502, etc)
                        //
                        //     Or just a string
                        //     { "success": "true", ... }
                        //     { "success": "false", ... }, httpCode >= 200
                        //
                        //     Or a boolean
                        //     { "success": true, ... }
                        //     { "success": false, ... }, httpCode >= 200
                        //
                        // 3 - Oversimplified, Python PEP8 forbids comparison operator (===) of different types
                        //
                        // 4 - We do not want to copy-paste and duplicate the code of this handler to other exchanges derived from Liqui
                        //
                        // To cover points 1, 2, 3 and 4 combined this handler should work like this:
                        //
                        let success = this.safeValue(response, 'success', false);
                        if (typeof success === 'string') {
                            if (success === 'true' || success === '1') success = true;
                            else success = false;
                        }
                        if (!success) {
                            const code = this.safeString(response, 'code');
                            const message = this.safeString(response, 'error');
                            const feedback = this.id + ' ' + body;
                            this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                            this.throwExactlyMatchedException(this.exceptions['exact'], message, feedback);
                            this.throwBroadlyMatchedException(this.exceptions['broad'], message, feedback);
                            throw new ExchangeError1(feedback); // unknown message
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    173: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { ExchangeError: ExchangeError1, BadRequest: BadRequest } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class zaif extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'zaif',
                        'name': 'Zaif',
                        'countries': [
                            'JP'
                        ],
                        // 10 requests per second = 1000ms / 10 = 100ms between requests (public market endpoints)
                        'rateLimit': 100,
                        'version': '1',
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'cancelOrder': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'fetchBalance': true,
                            'fetchClosedOrders': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchOpenOrders': true,
                            'fetchOrderBook': true,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'withdraw': true
                        },
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/27766927-39ca2ada-5eeb-11e7-972f-1b4199518ca6.jpg',
                            'api': 'https://api.zaif.jp',
                            'www': 'https://zaif.jp',
                            'doc': [
                                'https://techbureau-api-document.readthedocs.io/ja/latest/index.html',
                                'https://corp.zaif.jp/api-docs',
                                'https://corp.zaif.jp/api-docs/api_links',
                                'https://www.npmjs.com/package/zaif.jp',
                                'https://github.com/you21979/node-zaif'
                            ],
                            'fees': 'https://zaif.jp/fee?lang=en'
                        },
                        'fees': {
                            'trading': {
                                'percentage': true,
                                'taker': this.parseNumber('0.001'),
                                'maker': this.parseNumber('0')
                            }
                        },
                        'api': {
                            'public': {
                                'get': {
                                    'depth/{pair}': 1,
                                    'currencies/{pair}': 1,
                                    'currencies/all': 1,
                                    'currency_pairs/{pair}': 1,
                                    'currency_pairs/all': 1,
                                    'last_price/{pair}': 1,
                                    'ticker/{pair}': 1,
                                    'trades/{pair}': 1
                                }
                            },
                            'private': {
                                'post': {
                                    'active_orders': 5,
                                    'cancel_order': 5,
                                    'deposit_history': 5,
                                    'get_id_info': 5,
                                    'get_info': 10,
                                    'get_info2': 5,
                                    'get_personal_info': 5,
                                    'trade': 5,
                                    'trade_history': 50,
                                    'withdraw': 5,
                                    'withdraw_history': 5
                                }
                            },
                            'ecapi': {
                                'post': {
                                    'createInvoice': 1,
                                    'getInvoice': 1,
                                    'getInvoiceIdsByOrderNumber': 1,
                                    'cancelInvoice': 1
                                }
                            },
                            'tlapi': {
                                'post': {
                                    'get_positions': 66,
                                    'position_history': 66,
                                    'active_positions': 5,
                                    'create_position': 33,
                                    'change_position': 33,
                                    'cancel_position': 33
                                }
                            },
                            'fapi': {
                                'get': {
                                    'groups/{group_id}': 1,
                                    'last_price/{group_id}/{pair}': 1,
                                    'ticker/{group_id}/{pair}': 1,
                                    'trades/{group_id}/{pair}': 1,
                                    'depth/{group_id}/{pair}': 1
                                }
                            }
                        },
                        'options': {
                            // zaif schedule defines several market-specific fees
                            'fees': {
                                'BTC/JPY': {
                                    'maker': 0,
                                    'taker': 0.001
                                },
                                'BCH/JPY': {
                                    'maker': 0,
                                    'taker': 0.003
                                },
                                'BCH/BTC': {
                                    'maker': 0,
                                    'taker': 0.003
                                },
                                'PEPECASH/JPY': {
                                    'maker': 0,
                                    'taker': 0.0001
                                },
                                'PEPECASH/BT': {
                                    'maker': 0,
                                    'taker': 0.0001
                                }
                            }
                        },
                        'exceptions': {
                            'exact': {
                                'unsupported currency_pair': BadRequest
                            },
                            'broad': {}
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const markets = await this.publicGetCurrencyPairsAll(params);
                    //
                    //     [
                    //         {
                    //             "aux_unit_point": 0,
                    //             "item_japanese": "\u30d3\u30c3\u30c8\u30b3\u30a4\u30f3",
                    //             "aux_unit_step": 5.0,
                    //             "description": "\u30d3\u30c3\u30c8\u30b3\u30a4\u30f3\u30fb\u65e5\u672c\u5186\u306e\u53d6\u5f15\u3092\u884c\u3046\u3053\u3068\u304c\u3067\u304d\u307e\u3059",
                    //             "item_unit_min": 0.001,
                    //             "event_number": 0,
                    //             "currency_pair": "btc_jpy",
                    //             "is_token": false,
                    //             "aux_unit_min": 5.0,
                    //             "aux_japanese": "\u65e5\u672c\u5186",
                    //             "id": 1,
                    //             "item_unit_step": 0.0001,
                    //             "name": "BTC/JPY",
                    //             "seq": 0,
                    //             "title": "BTC/JPY"
                    //         }
                    //     ]
                    //
                    const result = [];
                    for(let i = 0; i < markets.length; i++){
                        const market = markets[i];
                        const id = this.safeString(market, 'currency_pair');
                        const name = this.safeString(market, 'name');
                        const [baseId, quoteId] = name.split('/');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const symbol = base + '/' + quote;
                        const fees = this.safeValue(this.options['fees'], symbol, this.fees['trading']);
                        const itemUnitStep = this.safeString(market, 'item_unit_step');
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': undefined,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': fees['taker'],
                            'maker': fees['maker'],
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': Precise.stringMul(itemUnitStep, '-1e10'),
                                'price': this.safeInteger(market, 'aux_unit_point')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'item_unit_min'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': this.safeNumber(market, 'aux_unit_min'),
                                    'max': undefined
                                },
                                'cost': {
                                    'min': undefined,
                                    'max': undefined
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'return', {});
                    const deposit = this.safeValue(balances, 'deposit');
                    const result = {
                        'info': response,
                        'timestamp': undefined,
                        'datetime': undefined
                    };
                    const funds = this.safeValue(balances, 'funds', {});
                    const currencyIds = Object.keys(funds);
                    for(let i = 0; i < currencyIds.length; i++){
                        const currencyId = currencyIds[i];
                        const code = this.safeCurrencyCode(currencyId);
                        const balance = this.safeString(funds, currencyId);
                        const account = this.account();
                        account['free'] = balance;
                        account['total'] = balance;
                        if (deposit !== undefined) {
                            if (currencyId in deposit) account['total'] = this.safeString(deposit, currencyId);
                        }
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.privatePostGetInfo(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'pair': this.marketId(symbol)
                    };
                    const response = await this.publicGetDepthPair(this.extend(request, params));
                    return this.parseOrderBook(response, symbol);
                }
                parseTicker(ticker, market) {
                    //
                    // {
                    //     "last": 9e-08,
                    //     "high": 1e-07,
                    //     "low": 9e-08,
                    //     "vwap": 0.0,
                    //     "volume": 135250.0,
                    //     "bid": 9e-08,
                    //     "ask": 1e-07
                    // }
                    //
                    const symbol = this.safeSymbol(undefined, market);
                    const timestamp = this.milliseconds();
                    const vwap = this.safeString(ticker, 'vwap');
                    const baseVolume = this.safeString(ticker, 'volume');
                    const quoteVolume = Precise.stringMul(baseVolume, vwap);
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'bid'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'ask'),
                        'askVolume': undefined,
                        'vwap': vwap,
                        'open': undefined,
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': baseVolume,
                        'quoteVolume': quoteVolume,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    const ticker = await this.publicGetTickerPair(this.extend(request, params));
                    //
                    // {
                    //     "last": 9e-08,
                    //     "high": 1e-07,
                    //     "low": 9e-08,
                    //     "vwap": 0.0,
                    //     "volume": 135250.0,
                    //     "bid": 9e-08,
                    //     "ask": 1e-07
                    // }
                    //
                    return this.parseTicker(ticker, market);
                }
                parseTrade(trade, market) {
                    //
                    // fetchTrades (public)
                    //
                    //      {
                    //          "date": 1648559414,
                    //          "price": 5880375.0,
                    //          "amount": 0.017,
                    //          "tid": 176126557,
                    //          "currency_pair": "btc_jpy",
                    //          "trade_type": "ask"
                    //      }
                    //
                    let side = this.safeString(trade, 'trade_type');
                    side = side === 'bid' ? 'buy' : 'sell';
                    const timestamp = this.safeTimestamp(trade, 'date');
                    const id = this.safeString2(trade, 'id', 'tid');
                    const priceString = this.safeString(trade, 'price');
                    const amountString = this.safeString(trade, 'amount');
                    const marketId = this.safeString(trade, 'currency_pair');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    return this.safeTrade({
                        'id': id,
                        'info': trade,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': undefined,
                        'side': side,
                        'order': undefined,
                        'takerOrMaker': undefined,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'fee': undefined
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'pair': market['id']
                    };
                    let response = await this.publicGetTradesPair(this.extend(request, params));
                    //
                    //      [
                    //          {
                    //              "date": 1648559414,
                    //              "price": 5880375.0,
                    //              "amount": 0.017,
                    //              "tid": 176126557,
                    //              "currency_pair": "btc_jpy",
                    //              "trade_type": "ask"
                    //          }, ...
                    //      ]
                    //
                    const numTrades = response.length;
                    if (numTrades === 1) {
                        const firstTrade = response[0];
                        if (!Object.keys(firstTrade).length) response = [];
                    }
                    return this.parseTrades(response, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    if (type !== 'limit') throw new ExchangeError1(this.id + ' createOrder() allows limit orders only');
                    const request = {
                        'currency_pair': this.marketId(symbol),
                        'action': side === 'buy' ? 'bid' : 'ask',
                        'amount': amount,
                        'price': price
                    };
                    const response = await this.privatePostTrade(this.extend(request, params));
                    return {
                        'info': response,
                        'id': response['return']['order_id'].toString()
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    const request = {
                        'order_id': id
                    };
                    return await this.privatePostCancelOrder(this.extend(request, params));
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         "currency_pair": "btc_jpy",
                    //         "action": "ask",
                    //         "amount": 0.03,
                    //         "price": 56000,
                    //         "timestamp": 1402021125,
                    //         "comment" : "demo"
                    //     }
                    //
                    let side = this.safeString(order, 'action');
                    side = side === 'bid' ? 'buy' : 'sell';
                    const timestamp = this.safeTimestamp(order, 'timestamp');
                    const marketId = this.safeString(order, 'currency_pair');
                    const symbol = this.safeSymbol(marketId, market, '_');
                    const price = this.safeString(order, 'price');
                    const amount = this.safeString(order, 'amount');
                    const id = this.safeString(order, 'id');
                    return this.safeOrder({
                        'id': id,
                        'clientOrderId': undefined,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': 'open',
                        'symbol': symbol,
                        'type': 'limit',
                        'timeInForce': undefined,
                        'postOnly': undefined,
                        'side': side,
                        'price': price,
                        'stopPrice': undefined,
                        'cost': undefined,
                        'amount': amount,
                        'filled': undefined,
                        'remaining': undefined,
                        'trades': undefined,
                        'fee': undefined,
                        'info': order,
                        'average': undefined
                    }, market);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['currency_pair'] = market['id'];
                    }
                    const response = await this.privatePostActiveOrders(this.extend(request, params));
                    return this.parseOrders(response['return'], market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    const request = {
                    };
                    if (symbol !== undefined) {
                        market = this.market(symbol);
                        request['currency_pair'] = market['id'];
                    }
                    const response = await this.privatePostTradeHistory(this.extend(request, params));
                    return this.parseOrders(response['return'], market, since, limit);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (code === 'JPY') throw new ExchangeError1(this.id + ' withdraw() does not allow ' + code + ' withdrawals');
                    const request = {
                        'currency': currency['id'],
                        'amount': amount,
                        'address': address
                    };
                    if (tag !== undefined) request['message'] = tag;
                    const result = await this.privatePostWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "success": 1,
                    //         "return": {
                    //             "id": 23634,
                    //             "fee": 0.001,
                    //             "txid":,
                    //             "funds": {
                    //                 "jpy": 15320,
                    //                 "btc": 1.392,
                    //                 "xem": 100.2,
                    //                 "mona": 2600
                    //             }
                    //         }
                    //     }
                    //
                    const returnData = this.safeValue(result, 'return');
                    return this.parseTransaction(returnData, currency);
                }
                parseTransaction(transaction, currency) {
                    //
                    //     {
                    //         "id": 23634,
                    //         "fee": 0.001,
                    //         "txid":,
                    //         "funds": {
                    //             "jpy": 15320,
                    //             "btc": 1.392,
                    //             "xem": 100.2,
                    //             "mona": 2600
                    //         }
                    //     }
                    //
                    currency = this.safeCurrency(undefined, currency);
                    let fee = undefined;
                    const feeCost = this.safeValue(transaction, 'fee');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': currency['code']
                    };
                    return {
                        'id': this.safeString(transaction, 'id'),
                        'txid': this.safeString(transaction, 'txid'),
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': fee,
                        'info': transaction
                    };
                }
                nonce() {
                    const nonce = parseFloat(this.milliseconds() / 1000);
                    return nonce.toFixed(8);
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.urls['api'] + '/';
                    if (api === 'public') url += 'api/' + this.version + '/' + this.implodeParams(path, params);
                    else if (api === 'fapi') url += 'fapi/' + this.version + '/' + this.implodeParams(path, params);
                    else {
                        this.checkRequiredCredentials();
                        if (api === 'ecapi') url += 'ecapi';
                        else if (api === 'tlapi') url += 'tlapi';
                        else url += 'tapi';
                        const nonce = this.nonce();
                        body = this.urlencode(this.extend({
                            'method': path,
                            'nonce': nonce
                        }, params));
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Key': this.apiKey,
                            'Sign': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return;
                    //
                    //     {"error": "unsupported currency_pair"}
                    //
                    const feedback = this.id + ' ' + body;
                    const error = this.safeString(response, 'error');
                    if (error !== undefined) {
                        this.throwExactlyMatchedException(this.exceptions['exact'], error, feedback);
                        this.throwBroadlyMatchedException(this.exceptions['broad'], error, feedback);
                        throw new ExchangeError1(feedback); // unknown message
                    }
                    const success = this.safeValue(response, 'success', true);
                    if (!success) throw new ExchangeError1(feedback);
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    174: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { BadRequest: BadRequest, BadSymbol: BadSymbol, ExchangeError: ExchangeError1, ArgumentsRequired: ArgumentsRequired1, AuthenticationError: AuthenticationError, InsufficientFunds: InsufficientFunds, NotSupported: NotSupported, OrderNotFound: OrderNotFound, ExchangeNotAvailable: ExchangeNotAvailable, RateLimitExceeded: RateLimitExceeded, PermissionDenied: PermissionDenied, InvalidOrder: InvalidOrder, InvalidAddress: InvalidAddress, OnMaintenance: OnMaintenance, RequestTimeout: RequestTimeout, AccountSuspended: AccountSuspended, NetworkError: NetworkError, DDoSProtection: DDoSProtection, DuplicateOrderId: DuplicateOrderId, BadResponse: BadResponse } = require1('./base/errors');
            const Precise = require1('./base/Precise');
            //  ---------------------------------------------------------------------------
            module.exports = class zb extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'zb',
                        'name': 'ZB',
                        'countries': [
                            'CN'
                        ],
                        // previously rateLimit = 100
                        // Trading and Margin 10 000 per minute (IP) => 10000 / 60 = 166.66666... per second => rateLimit = 1000/166.66666 = 6
                        // Trade and Margin 60 per second (apiKey) => weight = 166.666 / 60 = 2.778 (2.7777777...)
                        // Kline 1 per second => weight = 166.667
                        // v2 Futures API 100 per 2 seconds => 50 per second => weight = 3.334 (3.3333333...)
                        // for endpoints not mentioned in docs
                        // previous rateLimit was 100 translating to 10 requests per second => weight = 166.666 / 10 = 16.667 (16.666666...)
                        'rateLimit': 6,
                        'version': 'v1',
                        'certified': true,
                        'pro': true,
                        'has': {
                            'CORS': undefined,
                            'spot': true,
                            'margin': true,
                            'swap': true,
                            'future': undefined,
                            'option': undefined,
                            'addMargin': true,
                            'cancelAllOrders': true,
                            'cancelOrder': true,
                            'createMarketOrder': undefined,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'createStopLimitOrder': true,
                            'createStopMarketOrder': true,
                            'createStopOrder': true,
                            'fetchBalance': true,
                            'fetchBorrowRate': true,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': true,
                            'fetchCanceledOrders': true,
                            'fetchClosedOrders': true,
                            'fetchCurrencies': true,
                            'fetchDepositAddress': true,
                            'fetchDepositAddresses': true,
                            'fetchDeposits': true,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': true,
                            'fetchFundingRateHistory': true,
                            'fetchFundingRates': true,
                            'fetchLedger': true,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarketLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrder': true,
                            'fetchOrderBook': true,
                            'fetchOrders': true,
                            'fetchPosition': true,
                            'fetchPositions': true,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTickers': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'fetchWithdrawals': true,
                            'reduceMargin': true,
                            'setLeverage': true,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '1m',
                            '3m': '3m',
                            '5m': '5m',
                            '15m': '15m',
                            '30m': '30m',
                            '1h': '1h',
                            '2h': '2h',
                            '4h': '4h',
                            '6h': '6h',
                            '12h': '12h',
                            '1d': '1d',
                            '3d': '3d',
                            '5d': '5d',
                            '1w': '1w'
                        },
                        'hostname': 'zb.com',
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/32859187-cd5214f0-ca5e-11e7-967d-96568e2e2bd1.jpg',
                            'api': {
                                'spot': {
                                    'v1': {
                                        'public': 'https://api.{hostname}/data',
                                        'private': 'https://trade.{hostname}/api'
                                    }
                                },
                                'contract': {
                                    'v1': {
                                        'public': 'https://fapi.{hostname}/api/public'
                                    },
                                    'v2': {
                                        'public': 'https://fapi.{hostname}/Server/api',
                                        'private': 'https://fapi.{hostname}/Server/api'
                                    }
                                }
                            },
                            'www': 'https://www.zb.com',
                            'doc': 'https://www.zb.com/i/developer',
                            'fees': 'https://www.zb.com/i/rate',
                            'referral': {
                                'url': 'https://www.zbex.club/en/register?ref=4301lera',
                                'discount': 0.16
                            }
                        },
                        'api': {
                            'spot': {
                                'v1': {
                                    'public': {
                                        'get': {
                                            'markets': 16.667,
                                            'ticker': 16.667,
                                            'allTicker': 16.667,
                                            'depth': 16.667,
                                            'trades': 16.667,
                                            'kline': 166.667,
                                            'getGroupMarkets': 16.667,
                                            'getFeeInfo': 16.667
                                        }
                                    },
                                    'private': {
                                        'get': {
                                            // spot API
                                            'order': 1,
                                            'orderMoreV2': 1,
                                            'cancelOrder': 1,
                                            'cancelAllOrdersAfter': 1,
                                            'getOrder': 1,
                                            'getOrders': 1,
                                            'getOrdersNew': 16.667,
                                            'getOrdersIgnoreTradeType': 1,
                                            'getUnfinishedOrdersIgnoreTradeType': 1,
                                            'getFinishedAndPartialOrders': 1,
                                            'getAccountInfo': 16.667,
                                            'getUserAddress': 16.667,
                                            'getPayinAddress': 16.667,
                                            'getWithdrawAddress': 16.667,
                                            'getWithdrawRecord': 16.667,
                                            'getChargeRecord': 16.667,
                                            'getCnyWithdrawRecord': 16.667,
                                            'getCnyChargeRecord': 16.667,
                                            'withdraw': 16.667,
                                            // sub accounts
                                            'addSubUser': 16.667,
                                            'getSubUserList': 16.667,
                                            'doTransferFunds': 16.667,
                                            'createSubUserKey': 16.667,
                                            // leverage API
                                            'getLeverAssetsInfo': 16.667,
                                            'getLeverBills': 16.667,
                                            'transferInLever': 16.667,
                                            'transferOutLever': 16.667,
                                            'loan': 16.667,
                                            'cancelLoan': 16.667,
                                            'getLoans': 16.667,
                                            'getLoanRecords': 16.667,
                                            'borrow': 16.667,
                                            'autoBorrow': 16.667,
                                            'repay': 16.667,
                                            'doAllRepay': 16.667,
                                            'getRepayments': 16.667,
                                            'getFinanceRecords': 16.667,
                                            'changeInvestMark': 16.667,
                                            'changeLoop': 16.667,
                                            // cross API
                                            'getCrossAssets': 16.667,
                                            'getCrossBills': 16.667,
                                            'transferInCross': 16.667,
                                            'transferOutCross': 16.667,
                                            'doCrossLoan': 16.667,
                                            'doCrossRepay': 16.667,
                                            'getCrossRepayRecords': 16.667
                                        }
                                    }
                                }
                            },
                            'contract': {
                                'v1': {
                                    'public': {
                                        'get': {
                                            'depth': 16.667,
                                            'fundingRate': 16.667,
                                            'indexKline': 16.667,
                                            'indexPrice': 16.667,
                                            'kline': 16.667,
                                            'markKline': 16.667,
                                            'markPrice': 16.667,
                                            'ticker': 16.667,
                                            'trade': 16.667
                                        }
                                    }
                                },
                                'v2': {
                                    'public': {
                                        'get': {
                                            'allForceOrders': 3.334,
                                            'config/marketList': 3.334,
                                            'topLongShortAccountRatio': 3.334,
                                            'topLongShortPositionRatio': 3.334,
                                            'fundingRate': 3.334,
                                            'premiumIndex': 3.334
                                        }
                                    },
                                    'private': {
                                        'get': {
                                            'Fund/balance': 3.334,
                                            'Fund/getAccount': 3.334,
                                            'Fund/getBill': 3.334,
                                            'Fund/getBillTypeList': 3.334,
                                            'Fund/marginHistory': 3.334,
                                            'Positions/getPositions': 3.334,
                                            'Positions/getNominalValue': 3.334,
                                            'Positions/marginInfo': 3.334,
                                            'setting/get': 3.334,
                                            'trade/getAllOrders': 3.334,
                                            'trade/getOrder': 3.334,
                                            'trade/getOrderAlgos': 3.334,
                                            'trade/getTradeList': 3.334,
                                            'trade/getUndoneOrders': 3.334,
                                            'trade/tradeHistory': 3.334
                                        },
                                        'post': {
                                            'activity/buyTicket': 3.334,
                                            'Fund/transferFund': 3.334,
                                            'Positions/setMarginCoins': 3.334,
                                            'Positions/updateAppendUSDValue': 3.334,
                                            'Positions/updateMargin': 3.334,
                                            'setting/setLeverage': 3.334,
                                            'trade/batchOrder': 3.334,
                                            'trade/batchCancelOrder': 3.334,
                                            'trade/cancelAlgos': 3.334,
                                            'trade/cancelAllOrders': 3.334,
                                            'trade/cancelOrder': 3.334,
                                            'trade/order': 3.334,
                                            'trade/orderAlgo': 3.334,
                                            'trade/updateOrderAlgo': 3.334
                                        }
                                    }
                                }
                            }
                        },
                        'fees': {
                            'funding': {
                                'withdraw': {}
                            },
                            'trading': {
                                'maker': this.parseNumber('0.002'),
                                'taker': this.parseNumber('0.002')
                            }
                        },
                        'commonCurrencies': {
                            'ANG': 'Anagram',
                            'ENT': 'ENTCash',
                            'BCHABC': 'BCHABC',
                            'BCHSV': 'BCHSV'
                        },
                        'options': {
                            'timeframes': {
                                'spot': {
                                    '1m': '1min',
                                    '3m': '3min',
                                    '5m': '5min',
                                    '15m': '15min',
                                    '30m': '30min',
                                    '1h': '1hour',
                                    '2h': '2hour',
                                    '4h': '4hour',
                                    '6h': '6hour',
                                    '12h': '12hour',
                                    '1d': '1day',
                                    '3d': '3day',
                                    '1w': '1week'
                                },
                                'swap': {
                                    '1m': '1M',
                                    '5m': '5M',
                                    '15m': '15M',
                                    '30m': '30M',
                                    '1h': '1H',
                                    '6h': '6H',
                                    '1d': '1D',
                                    '5d': '5D'
                                }
                            }
                        },
                        'exceptions': {
                            'ws': {
                                // '1000': ExchangeError, // The call is successful.
                                '1001': ExchangeError1,
                                '1002': ExchangeError1,
                                '1003': AuthenticationError,
                                '1004': AuthenticationError,
                                '1005': AuthenticationError,
                                '1006': PermissionDenied,
                                '1007': ExchangeError1,
                                '1009': OnMaintenance,
                                '1010': ExchangeNotAvailable,
                                '1012': PermissionDenied,
                                '1013': ExchangeError1,
                                '1014': ExchangeError1,
                                '2001': InsufficientFunds,
                                '2002': InsufficientFunds,
                                '2003': InsufficientFunds,
                                '2005': InsufficientFunds,
                                '2006': InsufficientFunds,
                                '2007': InsufficientFunds,
                                '2008': InsufficientFunds,
                                '2009': InsufficientFunds,
                                '3001': OrderNotFound,
                                '3002': InvalidOrder,
                                '3003': InvalidOrder,
                                '3004': AuthenticationError,
                                '3005': BadRequest,
                                '3006': PermissionDenied,
                                '3007': RequestTimeout,
                                '3008': ExchangeError1,
                                '3009': InvalidOrder,
                                '3010': PermissionDenied,
                                '3011': InvalidOrder,
                                '3012': InvalidOrder,
                                '4001': AccountSuspended,
                                '4002': RateLimitExceeded
                            },
                            'exact': {
                                // '1000': 'Successful operation',
                                '10001': ExchangeError1,
                                '10002': PermissionDenied,
                                '10003': BadResponse,
                                '10004': BadResponse,
                                '10005': PermissionDenied,
                                '10006': BadRequest,
                                '10007': ExchangeError1,
                                '10008': ExchangeError1,
                                '10009': ExchangeError1,
                                '1001': ExchangeError1,
                                '10010': AuthenticationError,
                                '10011': AuthenticationError,
                                '10012': AccountSuspended,
                                '10013': AuthenticationError,
                                '10014': AuthenticationError,
                                '10015': AuthenticationError,
                                '10016': AuthenticationError,
                                '10017': PermissionDenied,
                                '10018': AccountSuspended,
                                '10019': RequestTimeout,
                                '1002': ExchangeError1,
                                '10020': BadRequest,
                                '10021': BadRequest,
                                '10022': BadRequest,
                                '10023': RateLimitExceeded,
                                '10024': AuthenticationError,
                                '10025': ExchangeError1,
                                '10026': NetworkError,
                                '10027': RequestTimeout,
                                '10028': ExchangeNotAvailable,
                                '10029': DDoSProtection,
                                '1003': AuthenticationError,
                                '10030': BadRequest,
                                '10031': BadRequest,
                                '10032': BadRequest,
                                '10033': BadRequest,
                                '10034': BadRequest,
                                '10035': BadRequest,
                                '10036': BadRequest,
                                '10037': ArgumentsRequired1,
                                '10038': BadRequest,
                                '10039': BadResponse,
                                '1004': AuthenticationError,
                                '10040': BadResponse,
                                '10041': BadResponse,
                                '10042': ExchangeError1,
                                '10043': ExchangeError1,
                                '10044': ExchangeError1,
                                '10045': ExchangeError1,
                                '10046': ExchangeError1,
                                '10047': ExchangeError1,
                                '10048': ExchangeError1,
                                '10049': NetworkError,
                                '1005': AuthenticationError,
                                '1006': AuthenticationError,
                                '1009': ExchangeNotAvailable,
                                '1010': ExchangeNotAvailable,
                                '10100': OnMaintenance,
                                '1012': PermissionDenied,
                                '1013': ExchangeError1,
                                '1014': ExchangeError1,
                                '11000': ExchangeError1,
                                '11001': ExchangeError1,
                                '110011': ExchangeError1,
                                '11002': ExchangeError1,
                                '11003': ExchangeError1,
                                '11004': InsufficientFunds,
                                '11005': InvalidOrder,
                                '11006': InsufficientFunds,
                                '11007': OrderNotFound,
                                '11008': ExchangeError1,
                                '11009': ExchangeError1,
                                '110110': ExchangeError1,
                                '11012': InsufficientFunds,
                                '11013': ExchangeError1,
                                '11014': ExchangeError1,
                                '11015': AuthenticationError,
                                '11016': AuthenticationError,
                                '11017': ExchangeError1,
                                '11018': InsufficientFunds,
                                '11019': ExchangeError1,
                                '11021': InsufficientFunds,
                                '11023': ExchangeError1,
                                '11030': PermissionDenied,
                                '11031': ExchangeError1,
                                '11032': ExchangeError1,
                                '11033': ArgumentsRequired1,
                                '11034': ExchangeError1,
                                '12000': InvalidOrder,
                                '12001': InvalidOrder,
                                '12002': InvalidOrder,
                                '12003': InvalidOrder,
                                '12004': InvalidOrder,
                                '12005': InvalidOrder,
                                '12006': InvalidOrder,
                                '12007': InvalidOrder,
                                '12008': InvalidOrder,
                                '12009': InvalidOrder,
                                '12010': InvalidOrder,
                                '12011': InvalidOrder,
                                '12012': OrderNotFound,
                                '12013': InvalidOrder,
                                '12014': InvalidOrder,
                                '12015': InvalidOrder,
                                '12016': InvalidOrder,
                                '12017': InvalidOrder,
                                '12018': InvalidOrder,
                                '12019': ArgumentsRequired1,
                                '12020': ExchangeError1,
                                '12021': InvalidOrder,
                                '12022': InvalidOrder,
                                '12023': OrderNotFound,
                                '12024': InvalidOrder,
                                '12025': InvalidOrder,
                                '12026': DuplicateOrderId,
                                '12027': ExchangeNotAvailable,
                                '12028': InvalidOrder,
                                '12029': InvalidOrder,
                                '12201': InvalidOrder,
                                '12202': InvalidOrder,
                                '12203': InvalidOrder,
                                '12204': InvalidOrder,
                                '12205': InvalidOrder,
                                '12206': InvalidOrder,
                                '12207': RateLimitExceeded,
                                '13001': AuthenticationError,
                                '13002': PermissionDenied,
                                // '13003': AuthenticationError, // User is locked
                                '13003': InvalidOrder,
                                '13004': InvalidOrder,
                                '13005': RateLimitExceeded,
                                '13006': ExchangeError1,
                                '13007': ExchangeError1,
                                '13008': ExchangeError1,
                                '13009': ExchangeError1,
                                '14000': ExchangeError1,
                                '14001': AuthenticationError,
                                '14002': AuthenticationError,
                                '14003': ExchangeError1,
                                '14100': ExchangeError1,
                                '14101': RateLimitExceeded,
                                '14200': ArgumentsRequired1,
                                '14300': ExchangeError1,
                                '14301': ExchangeError1,
                                '14302': ExchangeError1,
                                '14303': ExchangeError1,
                                '14305': ExchangeError1,
                                '14306': ExchangeError1,
                                '14307': InvalidOrder,
                                '14308': InvalidOrder,
                                '14309': ExchangeError1,
                                '14310': NotSupported,
                                '14311': NotSupported,
                                '14312': ExchangeError1,
                                '14313': PermissionDenied,
                                '14314': ExchangeError1,
                                '2001': InsufficientFunds,
                                '2002': InsufficientFunds,
                                '2003': InsufficientFunds,
                                '2005': InsufficientFunds,
                                '2006': InsufficientFunds,
                                '2007': InsufficientFunds,
                                '2008': InsufficientFunds,
                                '2009': InsufficientFunds,
                                '3001': OrderNotFound,
                                '3002': InvalidOrder,
                                '3003': InvalidOrder,
                                '3004': AuthenticationError,
                                '3005': BadRequest,
                                '3006': AuthenticationError,
                                '3007': AuthenticationError,
                                '3008': OrderNotFound,
                                '3009': InvalidOrder,
                                '3010': PermissionDenied,
                                '3011': InvalidOrder,
                                '3012': InvalidOrder,
                                '4001': ExchangeNotAvailable,
                                '4002': RateLimitExceeded,
                                '9999': ExchangeError1
                            },
                            'broad': {
                                "\u63D0\u5E01\u5730\u5740\u6709\u8BEF, \u8BF7\u5148\u6DFB\u52A0\u63D0\u5E01\u5730\u5740\u3002": InvalidAddress,
                                "\u8D44\u91D1\u4E0D\u8DB3,\u65E0\u6CD5\u5212\u8D26": InsufficientFunds,
                                "\u54CD\u5E94\u8D85\u65F6": RequestTimeout
                            }
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const markets = await this.spotV1PublicGetMarkets(params);
                    //
                    //     {
                    //         "zb_qc":{
                    //             "amountScale":2,
                    //             "minAmount":0.01,
                    //             "minSize":5,
                    //             "priceScale":4,
                    //         },
                    //     }
                    //
                    let contracts = undefined;
                    try {
                        // https://github.com/ZBFuture/docs_en/blob/main/API%20V2%20_en.md#7-public-markethttp
                        // https://fapi.zb.com/Server/api/v2/config/marketList 502 Bad Gateway
                        contracts = await this.contractV2PublicGetConfigMarketList(params);
                    } catch (e) {
                        contracts = {};
                    }
                    //
                    //     {
                    //         BTC_USDT: {
                    //             symbol: 'BTC_USDT',
                    //             buyerCurrencyId: '6',
                    //             contractType: '1',
                    //             defaultMarginMode: '1',
                    //             marketType: '2',
                    //             historyDBName: 'trade_history_readonly.dbc',
                    //             defaultLeverage: '20',
                    //             id: '100',
                    //             canCancelOrder: true,
                    //             area: '1',
                    //             mixMarginCoinName: 'usdt',
                    //             fundingRateRatio: '0.25',
                    //             marginCurrencyName: 'usdt',
                    //             minTradeMoney: '0.0001',
                    //             enableTime: '1638954000000',
                    //             maxTradeMoney: '10000000',
                    //             canTrade: true,
                    //             maxLeverage: '125',
                    //             defaultPositionsMode: '2',
                    //             onlyWhitelistVisible: false,
                    //             riskWarnRatio: '0.8',
                    //             marginDecimal: '8',
                    //             spot: false,
                    //             status: '1',
                    //             amountDecimal: '3',
                    //             leverage: false,
                    //             minAmount: '0.001',
                    //             canOrder: true,
                    //             duration: '1',
                    //             feeDecimal: '8',
                    //             sellerCurrencyId: '1',
                    //             maxAmount: '1000',
                    //             canOpenPosition: true,
                    //             isSupportMixMargin: false,
                    //             markPriceLimitRate: '0.05',
                    //             marginCurrencyId: '6',
                    //             stopFundingFee: false,
                    //             priceDecimal: '2',
                    //             lightenUpFeeRate: '0',
                    //             futures: true,
                    //             sellerCurrencyName: 'btc',
                    //             marketPriceLimitRate: '0.05',
                    //             canRebate: true,
                    //             marketName: 'BTC_USDT',
                    //             depth: [ 0.01, 0.1, 1 ],
                    //             createTime: '1607590430094',
                    //             mixMarginCoinIds: [ 6 ],
                    //             buyerCurrencyName: 'usdt',
                    //             stopService: false
                    //         },
                    //     }
                    //
                    const contractsData = this.safeValue(contracts, 'data', []);
                    const contractsById = this.indexBy(contractsData, 'marketName');
                    const dataById = this.deepExtend(contractsById, markets);
                    const keys = Object.keys(dataById);
                    const result = [];
                    for(let i = 0; i < keys.length; i++){
                        const id = keys[i];
                        const market = dataById[id];
                        const [baseId, quoteId] = id.split('_');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        const settleId = this.safeValue(market, 'marginCurrencyName');
                        const settle = this.safeCurrencyCode(settleId);
                        const spot = settle === undefined;
                        const swap = this.safeValue(market, 'futures', false);
                        const linear = swap ? true : undefined;
                        let active = true;
                        let symbol = base + '/' + quote;
                        const amountPrecisionString = this.safeString2(market, 'amountScale', 'amountDecimal');
                        const pricePrecisionString = this.safeString2(market, 'priceScale', 'priceDecimal');
                        if (swap) {
                            const status = this.safeString(market, 'status');
                            active = status === '1';
                            symbol = base + '/' + quote + ':' + settle;
                        }
                        result.push({
                            'id': id,
                            'symbol': symbol,
                            'base': base,
                            'quote': quote,
                            'settle': settle,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': settleId,
                            'type': swap ? 'swap' : 'spot',
                            'spot': spot,
                            'margin': false,
                            'swap': swap,
                            'future': false,
                            'option': false,
                            'active': active,
                            'contract': swap,
                            'linear': linear,
                            'inverse': swap ? !linear : undefined,
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'strike': undefined,
                            'optionType': undefined,
                            'precision': {
                                'amount': parseInt(amountPrecisionString),
                                'price': parseInt(pricePrecisionString)
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': this.safeNumber(market, 'maxLeverage')
                                },
                                'amount': {
                                    'min': this.safeNumber(market, 'minAmount'),
                                    'max': this.safeNumber(market, 'maxAmount')
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber2(market, 'minSize', 'minTradeMoney'),
                                    'max': this.safeNumber(market, 'maxTradeMoney')
                                }
                            },
                            'info': market
                        });
                    }
                    return result;
                }
                async fetchCurrencies(params = {}) {
                    const response = await this.spotV1PublicGetGetFeeInfo(params);
                    //
                    //     {
                    //         "code":1000,
                    //         "message":"success",
                    //         "result":{
                    //             "USDT":[
                    //                 {
                    //                     "chainName":"TRC20",
                    //                     "canWithdraw":true,
                    //                     "fee":1.0,
                    //                     "mainChainName":"TRX",
                    //                     "canDeposit":true
                    //                 },
                    //                 {
                    //                     "chainName":"OMNI",
                    //                     "canWithdraw":true,
                    //                     "fee":5.0,
                    //                     "mainChainName":"BTC",
                    //                     "canDeposit":true
                    //                 },
                    //                 {
                    //                     "chainName":"ERC20",
                    //                     "canWithdraw":true,
                    //                     "fee":15.0,
                    //                     "mainChainName":"ETH",
                    //                     "canDeposit":true
                    //                 }
                    //             ],
                    //         }
                    //     }
                    //
                    const currencies = this.safeValue(response, 'result', {});
                    const ids = Object.keys(currencies);
                    const result = {};
                    for(let i = 0; i < ids.length; i++){
                        const id = ids[i];
                        const currency = currencies[id];
                        const code = this.safeCurrencyCode(id);
                        const precision = undefined;
                        let isWithdrawEnabled = true;
                        let isDepositEnabled = true;
                        const fees = {};
                        for(let j = 0; j < currency.length; j++){
                            const networkItem = currency[j];
                            const network = this.safeString(networkItem, 'chainName');
                            // const name = this.safeString (networkItem, 'name');
                            const withdrawFee = this.safeNumber(networkItem, 'fee');
                            const depositEnable = this.safeValue(networkItem, 'canDeposit');
                            const withdrawEnable = this.safeValue(networkItem, 'canWithdraw');
                            isDepositEnabled = isDepositEnabled || depositEnable;
                            isWithdrawEnabled = isWithdrawEnabled || withdrawEnable;
                            fees[network] = withdrawFee;
                        }
                        const active = isWithdrawEnabled && isDepositEnabled;
                        result[code] = {
                            'id': id,
                            'name': undefined,
                            'code': code,
                            'precision': precision,
                            'info': currency,
                            'active': active,
                            'deposit': isDepositEnabled,
                            'withdraw': isWithdrawEnabled,
                            'fee': undefined,
                            'fees': fees,
                            'limits': this.limits
                        };
                    }
                    return result;
                }
                parseBalance(response) {
                    const balances = this.safeValue(response['result'], 'coins');
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        //     {        enName: "BTC",
                        //               freez: "0.00000000",
                        //         unitDecimal:  8, // always 8
                        //              cnName: "BTC",
                        //       isCanRecharge:  true, // TODO: should use this
                        //             unitTag: "฿",
                        //       isCanWithdraw:  true,  // TODO: should use this
                        //           available: "0.00000000",
                        //                 key: "btc"         }
                        const account = this.account();
                        const currencyId = this.safeString(balance, 'key');
                        const code = this.safeCurrencyCode(currencyId);
                        account['free'] = this.safeString(balance, 'available');
                        account['used'] = this.safeString(balance, 'freez');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                parseSwapBalance(response) {
                    const result = {
                        'info': response
                    };
                    const data = this.safeValue(response, 'data', {});
                    for(let i = 0; i < data.length; i++){
                        const balance = data[i];
                        //
                        //     {
                        //         "userId": "6896693805014120448",
                        //         "currencyId": "6",
                        //         "currencyName": "usdt",
                        //         "amount": "30.56585118",
                        //         "freezeAmount": "0",
                        //         "contractType": 1,
                        //         "id": "6899113714763638819",
                        //         "createTime": "1644876888934",
                        //         "modifyTime": "1645787446037",
                        //         "accountBalance": "30.56585118",
                        //         "allMargin": "0",
                        //         "allowTransferOutAmount": "30.56585118"
                        //     },
                        //
                        const code = this.safeCurrencyCode(this.safeString(balance, 'currencyName'));
                        const account = this.account();
                        account['total'] = this.safeString(balance, 'accountBalance');
                        account['free'] = this.safeString(balance, 'allowTransferOutAmount');
                        account['used'] = this.safeString(balance, 'freezeAmount');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                parseMarginBalance(response, marginMode) {
                    const result = {
                        'info': response
                    };
                    let levers = undefined;
                    if (marginMode === 'isolated') {
                        const message = this.safeValue(response, 'message', {});
                        const data = this.safeValue(message, 'datas', {});
                        levers = this.safeValue(data, 'levers', []);
                    } else {
                        const crossResponse = this.safeValue(response, 'result', {});
                        levers = this.safeValue(crossResponse, 'list', []);
                    }
                    for(let i = 0; i < levers.length; i++){
                        const balance = levers[i];
                        //
                        // Isolated Margin
                        //
                        //     {
                        //         "cNetUSD": "0.00",
                        //         "repayLeverShow": "-",
                        //         "cCanLoanIn": "0.002115400000000",
                        //         "fNetCNY": "147.76081161",
                        //         "fLoanIn": "0.00",
                        //         "repayLevel": 0,
                        //         "level": 1,
                        //         "netConvertCNY": "147.760811613032",
                        //         "cFreeze": "0.00",
                        //         "cUnitTag": "BTC",
                        //         "version": 1646783178609,
                        //         "cAvailableUSD": "0.00",
                        //         "cNetCNY": "0.00",
                        //         "riskRate": "-",
                        //         "fAvailableUSD": "20.49273433",
                        //         "fNetUSD": "20.49273432",
                        //         "cShowName": "BTC",
                        //         "leverMultiple": "5.00",
                        //         "couldTransferOutFiat": "20.49273433",
                        //         "noticeLine": "1.13",
                        //         "fFreeze": "0.00",
                        //         "cUnitDecimal": 8,
                        //         "fCanLoanIn": "81.970937320000000",
                        //         "cAvailable": "0.00",
                        //         "repayLock": false,
                        //         "status": 1,
                        //         "forbidType": 0,
                        //         "totalConvertCNY": "147.760811613032",
                        //         "cAvailableCNY": "0.00",
                        //         "unwindPrice": "0.00",
                        //         "fOverdraft": "0.00",
                        //         "fShowName": "USDT",
                        //         "statusShow": "%E6%AD%A3%E5%B8%B8",
                        //         "cOverdraft": "0.00",
                        //         "netConvertUSD": "20.49273433",
                        //         "cNetBtc": "0.00",
                        //         "loanInConvertCNY": "0.00",
                        //         "fAvailableCNY": "147.760811613032",
                        //         "key": "btcusdt",
                        //         "fNetBtc": "0.0005291",
                        //         "fUnitDecimal": 8,
                        //         "loanInConvertUSD": "0.00",
                        //         "showName": "BTC/USDT",
                        //         "startLine": "1.25",
                        //         "totalConvertUSD": "20.49273433",
                        //         "couldTransferOutCoin": "0.00",
                        //         "cEnName": "BTC",
                        //         "leverMultipleInterest": "3.00",
                        //         "fAvailable": "20.49273433",
                        //         "fEnName": "USDT",
                        //         "forceRepayLine": "1.08",
                        //         "cLoanIn": "0.00"
                        //     }
                        //
                        // Cross Margin
                        //
                        //     [
                        //         {
                        //             "fundType": 2,
                        //             "loanIn": 0,
                        //             "amount": 0,
                        //             "freeze": 0,
                        //             "overdraft": 0,
                        //             "key": "BTC",
                        //             "canTransferOut": 0
                        //         },
                        //     ],
                        //
                        const account = this.account();
                        if (marginMode === 'isolated') {
                            const code = this.safeCurrencyCode(this.safeString(balance, 'fShowName'));
                            account['total'] = this.safeString(balance, 'fAvailableUSD'); // total amount in USD
                            account['free'] = this.safeString(balance, 'couldTransferOutFiat');
                            account['used'] = this.safeString(balance, 'fFreeze');
                            result[code] = account;
                        } else {
                            const code = this.safeCurrencyCode(this.safeString(balance, 'key'));
                            account['total'] = this.safeString(balance, 'amount');
                            account['free'] = this.safeString(balance, 'canTransferOut');
                            account['used'] = this.safeString(balance, 'freeze');
                            result[code] = account;
                        }
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('fetchBalance', undefined, params);
                    const margin = marketType === 'margin';
                    const swap = marketType === 'swap';
                    let marginMethod = undefined;
                    const defaultMargin = margin ? 'isolated' : 'cross';
                    const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                    if (marginMode === 'isolated') marginMethod = 'spotV1PrivateGetGetLeverAssetsInfo';
                    else if (marginMode === 'cross') marginMethod = 'spotV1PrivateGetGetCrossAssets';
                    const method = this.getSupportedMapping(marketType, {
                        'spot': 'spotV1PrivateGetGetAccountInfo',
                        'swap': 'contractV2PrivateGetFundBalance',
                        'margin': marginMethod
                    });
                    const request = {
                    };
                    if (swap) request['futuresAccountType'] = 1;
                    const response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     {
                    //         "result": {
                    //             "coins": [
                    //                 {
                    //                     "isCanWithdraw": "true",
                    //                     "canLoan": false,
                    //                     "fundstype": 51,
                    //                     "showName": "ZB",
                    //                     "isCanRecharge": "true",
                    //                     "cnName": "ZB",
                    //                     "enName": "ZB",
                    //                     "available": "0",
                    //                     "freez": "0",
                    //                     "unitTag": "ZB",
                    //                     "key": "zb",
                    //                     "unitDecimal": 8
                    //                 },
                    //             ],
                    //             "version": 1645856691340,
                    //             "base": {
                    //                 "auth_google_enabled": true,
                    //                 "auth_mobile_enabled": false,
                    //                 "trade_password_enabled": true,
                    //                 "username": "blank@gmail.com"
                    //             }
                    //         },
                    //         "leverPerm": true,
                    //         "otcPerm": false,
                    //         "assetPerm": true,
                    //         "moneyPerm": true,
                    //         "subUserPerm": true,
                    //         "entrustPerm": true
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": [
                    //             {
                    //                 "userId": "6896693805014120448",
                    //                 "currencyId": "6",
                    //                 "currencyName": "usdt",
                    //                 "amount": "30.56585118",
                    //                 "freezeAmount": "0",
                    //                 "contractType": 1,
                    //                 "id": "6899113714763638819",
                    //                 "createTime": "1644876888934",
                    //                 "modifyTime": "1645787446037",
                    //                 "accountBalance": "30.56585118",
                    //                 "allMargin": "0",
                    //                 "allowTransferOutAmount": "30.56585118"
                    //             },
                    //         ],
                    //         "desc": "操作成功"
                    //     }
                    //
                    // Isolated Margin
                    //
                    //     {
                    //         "code": 1000,
                    //         "message": {
                    //             "des": "success",
                    //             "isSuc": true,
                    //             "datas": {
                    //                 "leverPerm": true,
                    //                 "levers": [
                    //                     {
                    //                         "cNetUSD": "0.00",
                    //                         "repayLeverShow": "-",
                    //                         "cCanLoanIn": "0.002115400000000",
                    //                         "fNetCNY": "147.76081161",
                    //                         "fLoanIn": "0.00",
                    //                         "repayLevel": 0,
                    //                         "level": 1,
                    //                         "netConvertCNY": "147.760811613032",
                    //                         "cFreeze": "0.00",
                    //                         "cUnitTag": "BTC",
                    //                         "version": 1646783178609,
                    //                         "cAvailableUSD": "0.00",
                    //                         "cNetCNY": "0.00",
                    //                         "riskRate": "-",
                    //                         "fAvailableUSD": "20.49273433",
                    //                         "fNetUSD": "20.49273432",
                    //                         "cShowName": "BTC",
                    //                         "leverMultiple": "5.00",
                    //                         "couldTransferOutFiat": "20.49273433",
                    //                         "noticeLine": "1.13",
                    //                         "fFreeze": "0.00",
                    //                         "cUnitDecimal": 8,
                    //                         "fCanLoanIn": "81.970937320000000",
                    //                         "cAvailable": "0.00",
                    //                         "repayLock": false,
                    //                         "status": 1,
                    //                         "forbidType": 0,
                    //                         "totalConvertCNY": "147.760811613032",
                    //                         "cAvailableCNY": "0.00",
                    //                         "unwindPrice": "0.00",
                    //                         "fOverdraft": "0.00",
                    //                         "fShowName": "USDT",
                    //                         "statusShow": "%E6%AD%A3%E5%B8%B8",
                    //                         "cOverdraft": "0.00",
                    //                         "netConvertUSD": "20.49273433",
                    //                         "cNetBtc": "0.00",
                    //                         "loanInConvertCNY": "0.00",
                    //                         "fAvailableCNY": "147.760811613032",
                    //                         "key": "btcusdt",
                    //                         "fNetBtc": "0.0005291",
                    //                         "fUnitDecimal": 8,
                    //                         "loanInConvertUSD": "0.00",
                    //                         "showName": "BTC/USDT",
                    //                         "startLine": "1.25",
                    //                         "totalConvertUSD": "20.49273433",
                    //                         "couldTransferOutCoin": "0.00",
                    //                         "cEnName": "BTC",
                    //                         "leverMultipleInterest": "3.00",
                    //                         "fAvailable": "20.49273433",
                    //                         "fEnName": "USDT",
                    //                         "forceRepayLine": "1.08",
                    //                         "cLoanIn": "0.00"
                    //                     }
                    //                 ]
                    //             }
                    //         }
                    //     }
                    //
                    // Cross Margin
                    //
                    //     {
                    //         "code": 1000,
                    //         "message": "操作成功",
                    //         "result": {
                    //             "loanIn": 0,
                    //             "total": 71.167,
                    //             "riskRate": "-",
                    //             "list" :[
                    //                 {
                    //                     "fundType": 2,
                    //                     "loanIn": 0,
                    //                     "amount": 0,
                    //                     "freeze": 0,
                    //                     "overdraft": 0,
                    //                     "key": "BTC",
                    //                     "canTransferOut": 0
                    //                 },
                    //             ],
                    //             "net": 71.167
                    //         }
                    //     }
                    //
                    // todo: use this somehow
                    // let permissions = response['result']['base'];
                    if (swap) return this.parseSwapBalance(response);
                    else if (margin) return this.parseMarginBalance(response, marginMode);
                    else return this.parseBalance(response);
                }
                parseDepositAddress(depositAddress, currency) {
                    //
                    // fetchDepositAddress
                    //
                    //     {
                    //         "key": "0x0af7f36b8f09410f3df62c81e5846da673d4d9a9"
                    //     }
                    //
                    // fetchDepositAddresses
                    //
                    //     {
                    //         "blockChain": "btc",
                    //         "isUseMemo": false,
                    //         "address": "1LL5ati6pXHZnTGzHSA3rWdqi4mGGXudwM",
                    //         "canWithdraw": true,
                    //         "canDeposit": true
                    //     }
                    //     {
                    //         "blockChain": "bts",
                    //         "isUseMemo": true,
                    //         "account": "btstest",
                    //         "memo": "123",
                    //         "canWithdraw": true,
                    //         "canDeposit": true
                    //     }
                    //
                    let address = this.safeString2(depositAddress, 'key', 'address');
                    let tag = undefined;
                    const memo = this.safeString(depositAddress, 'memo');
                    if (memo !== undefined) tag = memo;
                    else if (address.indexOf('_') >= 0) {
                        const parts = address.split('_');
                        address = parts[0]; // WARNING: MAY BE tag_address INSTEAD OF address_tag FOR SOME CURRENCIES!!
                        tag = parts[1];
                    }
                    const currencyId = this.safeString(depositAddress, 'blockChain');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    return {
                        'currency': code,
                        'address': address,
                        'tag': tag,
                        'network': undefined,
                        'info': depositAddress
                    };
                }
                async fetchDepositAddresses(codes, params = {}) {
                    await this.loadMarkets();
                    const response = await this.spotV1PrivateGetGetPayinAddress(params);
                    //
                    //     {
                    //         "code": 1000,
                    //         "message": {
                    //             "des": "success",
                    //             "isSuc": true,
                    //             "datas": [
                    //                 {
                    //                     "blockChain": "btc",
                    //                     "isUseMemo": false,
                    //                     "address": "1LL5ati6pXHZnTGzHSA3rWdqi4mGGXudwM",
                    //                     "canWithdraw": true,
                    //                     "canDeposit": true
                    //                 },
                    //                 {
                    //                     "blockChain": "bts",
                    //                     "isUseMemo": true,
                    //                     "account": "btstest",
                    //                     "memo": "123",
                    //                     "canWithdraw": true,
                    //                     "canDeposit": true
                    //                 },
                    //             ]
                    //         }
                    //     }
                    //
                    const message = this.safeValue(response, 'message', {});
                    const datas = this.safeValue(message, 'datas', []);
                    return this.parseDepositAddresses(datas, codes);
                }
                async fetchDepositAddress(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id']
                    };
                    const response = await this.spotV1PrivateGetGetUserAddress(this.extend(request, params));
                    //
                    //     {
                    //         "code": 1000,
                    //         "message": {
                    //             "des": "success",
                    //             "isSuc": true,
                    //             "datas": {
                    //                 "key": "0x0af7f36b8f09410f3df62c81e5846da673d4d9a9"
                    //             }
                    //         }
                    //     }
                    //
                    const message = this.safeValue(response, 'message', {});
                    const datas = this.safeValue(message, 'datas', {});
                    return this.parseDepositAddress(datas, currency);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                    };
                    const marketIdField = market['swap'] ? 'symbol' : 'market';
                    request[marketIdField] = market['id'];
                    const method = this.getSupportedMapping(market['type'], {
                        'spot': 'spotV1PublicGetDepth',
                        'swap': 'contractV1PublicGetDepth'
                    });
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //     {
                    //         "asks":[
                    //             [35000.0,0.2741],
                    //             [34949.0,0.0173],
                    //             [34900.0,0.5004],
                    //         ],
                    //         "bids":[
                    //             [34119.32,0.0030],
                    //             [34107.83,0.1500],
                    //             [34104.42,0.1500],
                    //         ],
                    //         "timestamp":1624536510
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 10000,
                    //         "desc": "操作成功",
                    //         "data": {
                    //             "asks": [
                    //                 [43416.6,0.02],
                    //                 [43418.25,0.04],
                    //                 [43425.82,0.02]
                    //             ],
                    //             "bids": [
                    //                 [43414.61,0.1],
                    //                 [43414.18,0.04],
                    //                 [43413.03,0.05]
                    //             ],
                    //             "time": 1645087743071
                    //         }
                    //     }
                    //
                    let result = undefined;
                    let timestamp = undefined;
                    if (market['type'] === 'swap') {
                        result = this.safeValue(response, 'data');
                        timestamp = this.safeInteger(result, 'time');
                    } else {
                        result = response;
                        timestamp = this.safeTimestamp(response, 'timestamp');
                    }
                    return this.parseOrderBook(result, symbol, timestamp);
                }
                async fetchTickers(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.spotV1PublicGetAllTicker(params);
                    const result = {};
                    const marketsByIdWithoutUnderscore = {};
                    const marketIds = Object.keys(this.markets_by_id);
                    for(let i = 0; i < marketIds.length; i++){
                        const tickerId = marketIds[i].replace('_', '');
                        marketsByIdWithoutUnderscore[tickerId] = this.markets_by_id[marketIds[i]];
                    }
                    const ids = Object.keys(response);
                    for(let i = 0; i < ids.length; i++){
                        const market = this.safeValue(marketsByIdWithoutUnderscore, ids[i]);
                        if (market !== undefined) {
                            const symbol = market['symbol'];
                            const ticker = this.safeValue(response, ids[i]);
                            if (ticker !== undefined) result[symbol] = this.parseTicker(ticker, market);
                        }
                    }
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                    };
                    const marketIdField = market['swap'] ? 'symbol' : 'market';
                    request[marketIdField] = market['id'];
                    const method = this.getSupportedMapping(market['type'], {
                        'spot': 'spotV1PublicGetTicker',
                        'swap': 'contractV1PublicGetTicker'
                    });
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //     {
                    //         "date":"1624399623587",
                    //         "ticker":{
                    //             "high":"33298.38",
                    //             "vol":"56152.9012",
                    //             "last":"32578.55",
                    //             "low":"28808.19",
                    //             "buy":"32572.68",
                    //             "sell":"32615.37",
                    //             "turnover":"1764201303.6100",
                    //             "open":"31664.85",
                    //             "riseRate":"2.89"
                    //         }
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 10000,
                    //         "desc": "操作成功",
                    //         "data": {
                    //             "BTC_USDT": [44053.47,44357.77,42911.54,43297.79,53471.264,-1.72,1645093002,302201.255084]
                    //         }
                    //     }
                    //
                    let ticker = undefined;
                    if (market['type'] === 'swap') {
                        ticker = {};
                        const data = this.safeValue(response, 'data');
                        const values = this.safeValue(data, market['id']);
                        for(let i = 0; i < values.length; i++){
                            ticker['open'] = this.safeValue(values, 0);
                            ticker['high'] = this.safeValue(values, 1);
                            ticker['low'] = this.safeValue(values, 2);
                            ticker['last'] = this.safeValue(values, 3);
                            ticker['vol'] = this.safeValue(values, 4);
                            ticker['riseRate'] = this.safeValue(values, 5);
                        }
                    } else {
                        ticker = this.safeValue(response, 'ticker', {});
                        ticker['date'] = this.safeValue(response, 'date');
                    }
                    return this.parseTicker(ticker, market);
                }
                parseTicker(ticker, market) {
                    //
                    // Spot
                    //
                    //     {
                    //         "date":"1624399623587", // injected from outside
                    //         "high":"33298.38",
                    //         "vol":"56152.9012",
                    //         "last":"32578.55",
                    //         "low":"28808.19",
                    //         "buy":"32572.68",
                    //         "sell":"32615.37",
                    //         "turnover":"1764201303.6100",
                    //         "open":"31664.85",
                    //         "riseRate":"2.89"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         open: 44083.82,
                    //         high: 44357.77,
                    //         low: 42911.54,
                    //         last: 43097.87,
                    //         vol: 53451.641,
                    //         riseRate: -2.24
                    //     }
                    //
                    const timestamp = this.safeInteger(ticker, 'date', this.milliseconds());
                    const last = this.safeString(ticker, 'last');
                    return this.safeTicker({
                        'symbol': this.safeSymbol(undefined, market),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'high': this.safeString(ticker, 'high'),
                        'low': this.safeString(ticker, 'low'),
                        'bid': this.safeString(ticker, 'buy'),
                        'bidVolume': undefined,
                        'ask': this.safeString(ticker, 'sell'),
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': this.safeString(ticker, 'open'),
                        'close': last,
                        'last': last,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': this.safeString(ticker, 'vol'),
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                parseOHLCV(ohlcv, market) {
                    if (market['swap']) {
                        const ohlcvLength = ohlcv.length;
                        if (ohlcvLength > 5) return [
                            this.safeTimestamp(ohlcv, 5),
                            this.safeNumber(ohlcv, 0),
                            this.safeNumber(ohlcv, 1),
                            this.safeNumber(ohlcv, 2),
                            this.safeNumber(ohlcv, 3),
                            this.safeNumber(ohlcv, 4)
                        ];
                        else return [
                            this.safeTimestamp(ohlcv, 4),
                            this.safeNumber(ohlcv, 0),
                            this.safeNumber(ohlcv, 1),
                            this.safeNumber(ohlcv, 2),
                            this.safeNumber(ohlcv, 3),
                            undefined
                        ];
                    } else return [
                        this.safeInteger(ohlcv, 0),
                        this.safeNumber(ohlcv, 1),
                        this.safeNumber(ohlcv, 2),
                        this.safeNumber(ohlcv, 3),
                        this.safeNumber(ohlcv, 4),
                        this.safeNumber(ohlcv, 5)
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const swap = market['swap'];
                    const spot = market['spot'];
                    const options = this.safeValue(this.options, 'timeframes', {});
                    const timeframes = this.safeValue(options, market['type'], {});
                    const timeframeValue = this.safeString(timeframes, timeframe);
                    if (timeframeValue === undefined) throw new NotSupported(this.id + ' fetchOHLCV() does not support ' + timeframe + ' timeframe for ' + market['type'] + ' markets');
                    if (limit === undefined) limit = 1000;
                    const request = {
                    };
                    const marketIdField = swap ? 'symbol' : 'market';
                    request[marketIdField] = market['id'];
                    const periodField = swap ? 'period' : 'type';
                    request[periodField] = timeframeValue;
                    const price = this.safeString(params, 'price');
                    params = this.omit(params, 'price');
                    let method = this.getSupportedMapping(market['type'], {
                        'spot': 'spotV1PublicGetKline',
                        'swap': 'contractV1PublicGetKline'
                    });
                    if (swap) {
                        if (price === 'mark') method = 'contractV1PublicGetMarkKline';
                        else if (price === 'index') method = 'contractV1PublicGetIndexKline';
                    } else if (spot) {
                        if (since !== undefined) request['since'] = since;
                    }
                    if (limit !== undefined) request['size'] = limit;
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //     {
                    //         "symbol": "BTC",
                    //         "data": [
                    //             [1645091400000,43183.24,43187.49,43145.92,43182.28,0.9110],
                    //             [1645091460000,43182.18,43183.15,43182.06,43183.15,1.4393],
                    //             [1645091520000,43182.11,43240.1,43182.11,43240.1,0.3802]
                    //         ],
                    //         "moneyType": "USDT"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 10000,
                    //         "desc": "操作成功",
                    //         "data": [
                    //             [41433.44,41433.44,41405.88,41408.75,21.368,1646366460],
                    //             [41409.25,41423.74,41408.8,41423.42,9.828,1646366520],
                    //             [41423.96,41429.39,41369.98,41370.31,123.104,1646366580]
                    //         ]
                    //     }
                    //
                    // Mark
                    //
                    //     {
                    //         "code": 10000,
                    //         "desc": "操作成功",
                    //         "data": [
                    //             [41603.39,41603.39,41591.59,41600.81,1646381760],
                    //             [41600.36,41605.75,41587.69,41601.97,1646381820],
                    //             [41601.97,41601.97,41562.62,41593.96,1646381880]
                    //         ]
                    //     }
                    //
                    // Index
                    //
                    //     {
                    //         "code": 10000,
                    //         "desc": "操作成功",
                    //         "data": [
                    //             [41697.53,41722.29,41689.16,41689.16,1646381640],
                    //             [41690.1,41691.73,41611.61,41611.61,1646381700],
                    //             [41611.61,41619.49,41594.87,41594.87,1646381760]
                    //         ]
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parseOHLCVs(data, market, timeframe, since, limit);
                }
                async fetchMarkOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'mark'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                async fetchIndexOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    const request = {
                        'price': 'index'
                    };
                    return await this.fetchOHLCV(symbol, timeframe, since, limit, this.extend(request, params));
                }
                parseTrade(trade, market) {
                    //
                    // Spot
                    //
                    //     {
                    //         "date":1624537391,
                    //         "amount":"0.0142",
                    //         "price":"33936.42",
                    //         "trade_type":"ask",
                    //         "type":"sell",
                    //         "tid":1718869018
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "amount": "0.002",
                    //         "createTime": "1645787446034",
                    //         "feeAmount": "-0.05762699",
                    //         "feeCurrency": "USDT",
                    //         "id": "6902932868050395136",
                    //         "maker": false,
                    //         "orderId": "6902932868042006528",
                    //         "price": "38417.99",
                    //         "relizedPnl": "0.30402",
                    //         "side": 4,
                    //         "userId": "6896693805014120448"
                    //     },
                    //
                    const sideField = market['swap'] ? 'side' : 'trade_type';
                    let side = this.safeString(trade, sideField);
                    let takerOrMaker = undefined;
                    const maker = this.safeValue(trade, 'maker');
                    if (maker !== undefined) takerOrMaker = maker ? 'maker' : 'taker';
                    if (market['spot']) side = side === 'bid' ? 'buy' : 'sell';
                    else {
                        if (side === '3') side = 'sell'; // close long
                        else if (side === '4') side = 'buy'; // close short
                        else if (side === '1') side = 'buy'; // open long
                        else if (side === '2') side = 'sell'; // open short
                    }
                    let timestamp = undefined;
                    if (market['swap']) timestamp = this.safeInteger(trade, 'createTime');
                    else timestamp = this.safeTimestamp(trade, 'date');
                    const price = this.safeString(trade, 'price');
                    const amount = this.safeString(trade, 'amount');
                    let fee = undefined;
                    const feeCostString = this.safeString(trade, 'feeAmount');
                    if (feeCostString !== undefined) {
                        const feeCurrencyId = this.safeString(trade, 'feeCurrency');
                        fee = {
                            'cost': feeCostString,
                            'currency': this.safeCurrencyCode(feeCurrencyId)
                        };
                    }
                    market = this.safeMarket(undefined, market);
                    return this.safeTrade({
                        'info': trade,
                        'id': this.safeString(trade, 'tid'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': market['symbol'],
                        'type': undefined,
                        'side': side,
                        'order': this.safeString(trade, 'orderId'),
                        'takerOrMaker': takerOrMaker,
                        'price': price,
                        'amount': amount,
                        'cost': undefined,
                        'fee': fee
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchTrades() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const swap = market['swap'];
                    const request = {
                    };
                    if (limit !== undefined) request['pageSize'] = limit;
                    if (since !== undefined) request['startTime'] = since;
                    const marketIdField = swap ? 'symbol' : 'market';
                    request[marketIdField] = market['id'];
                    if (swap && params['pageNum'] === undefined) request['pageNum'] = 1;
                    const method = this.getSupportedMapping(market['type'], {
                        'spot': 'spotV1PublicGetTrades',
                        'swap': 'contractV2PrivateGetTradeTradeHistory'
                    });
                    let response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //     [
                    //         {"date":1624537391,"amount":"0.0142","price":"33936.42","trade_type":"ask","type":"sell","tid":1718869018},
                    //         {"date":1624537391,"amount":"0.0010","price":"33936.42","trade_type":"ask","type":"sell","tid":1718869020},
                    //         {"date":1624537391,"amount":"0.0133","price":"33936.42","trade_type":"ask","type":"sell","tid":1718869021},
                    //     ]
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": {
                    //             "list": [
                    //                 {
                    //                     "amount": "0.002",
                    //                     "createTime": "1645787446034",
                    //                     "feeAmount": "-0.05762699",
                    //                     "feeCurrency": "USDT",
                    //                     "id": "6902932868050395136",
                    //                     "maker": false,
                    //                     "orderId": "6902932868042006528",
                    //                     "price": "38417.99",
                    //                     "relizedPnl": "0.30402",
                    //                     "side": 4,
                    //                     "userId": "6896693805014120448"
                    //                 },
                    //             ],
                    //             "pageNum": 1,
                    //             "pageSize": 10
                    //         },
                    //         "desc": "操作成功"
                    //     }
                    //
                    if (swap) {
                        const data = this.safeValue(response, 'data');
                        response = this.safeValue(data, 'list');
                    }
                    return this.parseTrades(response, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const swap = market['swap'];
                    const spot = market['spot'];
                    const timeInForce = this.safeString(params, 'timeInForce');
                    const reduceOnly = this.safeValue(params, 'reduceOnly');
                    const stop = this.safeValue(params, 'stop');
                    const stopPrice = this.safeNumber2(params, 'triggerPrice', 'stopPrice');
                    if (type === 'market') throw new InvalidOrder(this.id + ' createOrder() on ' + market['type'] + ' markets does not allow market orders');
                    let method = this.getSupportedMapping(market['type'], {
                        'spot': 'spotV1PrivateGetOrder',
                        'swap': 'contractV2PrivatePostTradeOrder'
                    });
                    const request = {
                        'amount': this.amountToPrecision(symbol, amount)
                    };
                    if (stop || stopPrice) {
                        method = 'contractV2PrivatePostTradeOrderAlgo';
                        const orderType = this.safeInteger(params, 'orderType');
                        const priceType = this.safeInteger(params, 'priceType');
                        const bizType = this.safeInteger(params, 'bizType');
                        const algoPrice = this.safeNumber(params, 'algoPrice');
                        request['symbol'] = market['id'];
                        if (side === 'sell' && reduceOnly) request['side'] = 3; // close long
                        else if (side === 'buy' && reduceOnly) request['side'] = 4; // close short
                        else if (side === 'buy') request['side'] = 1; // open long
                        else if (side === 'sell') request['side'] = 2; // open short
                        else if (side === 5) request['side'] = 5; // one way position buy
                        else if (side === 6) request['side'] = 6; // one way position sell
                        else if (side === 0) request['side'] = 0; // one way position close only
                        if (type === 'trigger' || orderType === 1) request['orderType'] = 1;
                        else if (type === 'stop loss' || type === 'take profit' || orderType === 2 || priceType || bizType) {
                            request['orderType'] = 2;
                            request['priceType'] = priceType;
                            request['bizType'] = bizType;
                        }
                        request['triggerPrice'] = this.priceToPrecision(symbol, stopPrice);
                        request['algoPrice'] = this.priceToPrecision(symbol, algoPrice);
                    } else {
                        if (price) request['price'] = this.priceToPrecision(symbol, price);
                        if (spot) {
                            request['tradeType'] = side === 'buy' ? '1' : '0';
                            request['currency'] = market['id'];
                            if (timeInForce !== undefined) {
                                if (timeInForce === 'PO') request['orderType'] = 1;
                                else if (timeInForce === 'IOC') request['orderType'] = 2;
                                else throw new InvalidOrder(this.id + ' createOrder() on ' + market['type'] + ' markets does not allow ' + timeInForce + ' orders');
                            }
                        } else if (swap) {
                            if (side === 'sell' && reduceOnly) request['side'] = 3; // close long
                            else if (side === 'buy' && reduceOnly) request['side'] = 4; // close short
                            else if (side === 'buy') request['side'] = 1; // open long
                            else if (side === 'sell') request['side'] = 2; // open short
                            if (type === 'limit') request['action'] = 1;
                            else if (timeInForce === 'IOC') request['action'] = 3;
                            else if (timeInForce === 'PO') request['action'] = 4;
                            else if (timeInForce === 'FOK') request['action'] = 5;
                            else request['action'] = type;
                            request['symbol'] = market['id'];
                            const clientOrderId = this.safeString(params, 'clientOrderId'); // OPTIONAL '^[a-zA-Z0-9-_]{1,36}$', // The user-defined order number
                            if (clientOrderId !== undefined) request['clientOrderId'] = clientOrderId;
                            // using extend as const name causes issues in python
                            const extendOrderAlgos = this.safeValue(params, 'extend', undefined); // OPTIONAL {"orderAlgos":[{"bizType":1,"priceType":1,"triggerPrice":"70000"},{"bizType":2,"priceType":1,"triggerPrice":"40000"}]}
                            if (extendOrderAlgos !== undefined) request['extend'] = extendOrderAlgos;
                        }
                    }
                    const query = this.omit(params, [
                        'reduceOnly',
                        'stop',
                        'stopPrice',
                        'orderType',
                        'triggerPrice',
                        'algoPrice',
                        'priceType',
                        'bizType',
                        'clientOrderId',
                        'extend'
                    ]);
                    let response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     {
                    //         "code": 1000,
                    //         "message": "操作成功",
                    //         "id": "202202224851151555"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 10000,
                    //         "desc": "操作成功",
                    //         "data": {
                    //             "orderId": "6901786759944937472",
                    //             "orderCode": null
                    //         }
                    //     }
                    //
                    // Algo order
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": "6919884551305242624",
                    //         "desc": "操作成功"
                    //     }
                    //
                    if (swap && !stop && stopPrice === undefined) {
                        response = this.safeValue(response, 'data');
                        response['timeInForce'] = timeInForce;
                        const tradeType = this.safeString(response, 'tradeType');
                        if (tradeType === undefined) response['type'] = tradeType;
                        response['total_amount'] = amount;
                        response['price'] = price;
                    }
                    return this.parseOrder(response, market);
                }
                async cancelOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const swap = market['swap'];
                    const request = {
                    };
                    const marketIdField = swap ? 'symbol' : 'currency';
                    request[marketIdField] = this.marketId(symbol);
                    const orderIdField = swap ? 'orderId' : 'id';
                    request[orderIdField] = id.toString();
                    const method = this.getSupportedMapping(market['type'], {
                        'spot': 'spotV1PrivateGetCancelOrder',
                        'swap': 'contractV2PrivatePostTradeCancelOrder'
                    });
                    const response = await this[method](this.extend(request, params));
                    //
                    // Spot
                    //
                    //     {
                    //         "code": 1000,
                    //         "message": "Success。"
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 10007,
                    //         "desc": "orderId与clientOrderId选填1个"
                    //     }
                    //
                    return this.parseOrder(response, market);
                }
                async cancelAllOrders(symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' cancelAllOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const stop = this.safeValue(params, 'stop');
                    if (market['spot']) throw new NotSupported(this.id + ' cancelAllOrders() is not supported on ' + market['type'] + ' markets');
                    const request = {
                        'symbol': market['id']
                    };
                    let method = 'contractV2PrivatePostTradeCancelAllOrders';
                    if (stop) method = 'contractV2PrivatePostTradeCancelAlgos';
                    const query = this.omit(params, 'stop');
                    return await this[method](this.extend(request, query));
                }
                async fetchOrder(id, symbol, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const reduceOnly = this.safeValue(params, 'reduceOnly');
                    const stop = this.safeValue(params, 'stop');
                    const swap = market['swap'];
                    const request = {
                    };
                    const marketIdField = swap ? 'symbol' : 'currency';
                    request[marketIdField] = this.marketId(symbol);
                    const orderIdField = swap ? 'orderId' : 'id';
                    request[orderIdField] = id.toString();
                    let method = this.getSupportedMapping(market['type'], {
                        'spot': 'spotV1PrivateGetGetOrder',
                        'swap': 'contractV2PrivateGetTradeGetOrder'
                    });
                    if (stop) {
                        method = 'contractV2PrivateGetTradeGetOrderAlgos';
                        const orderType = this.safeInteger(params, 'orderType');
                        if (orderType === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrder() requires an orderType parameter for stop orders');
                        const side = this.safeInteger(params, 'side');
                        const bizType = this.safeInteger(params, 'bizType');
                        if (side === 'sell' && reduceOnly) request['side'] = 3; // close long
                        else if (side === 'buy' && reduceOnly) request['side'] = 4; // close short
                        else if (side === 'buy') request['side'] = 1; // open long
                        else if (side === 'sell') request['side'] = 2; // open short
                        else if (side === 5) request['side'] = 5; // one way position buy
                        else if (side === 6) request['side'] = 6; // one way position sell
                        else if (side === 0) request['side'] = 0; // one way position close only
                        if (orderType === 1) request['orderType'] = 1;
                        else if (orderType === 2 || bizType) {
                            request['orderType'] = 2;
                            request['bizType'] = bizType;
                        }
                    }
                    const query = this.omit(params, [
                        'reduceOnly',
                        'stop',
                        'side',
                        'orderType',
                        'bizType'
                    ]);
                    let response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     {
                    //         'total_amount': 0.01,
                    //         'id': '20180910244276459',
                    //         'price': 180.0,
                    //         'trade_date': 1536576744960,
                    //         'status': 2,
                    //         'trade_money': '1.96742',
                    //         'trade_amount': 0.01,
                    //         'type': 0,
                    //         'currency': 'eth_usdt'
                    //     }
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": {
                    //             "action": 1,
                    //             "amount": "0.002",
                    //             "availableAmount": "0.002",
                    //             "availableValue": "60",
                    //             "avgPrice": "0",
                    //             "canCancel": true,
                    //             "cancelStatus": 20,
                    //             "createTime": "1646185684379",
                    //             "entrustType": 1,
                    //             "id": "6904603200733782016",
                    //             "leverage": 2,
                    //             "margin": "30",
                    //             "marketId": "100",
                    //             "modifyTime": "1646185684416",
                    //             "price": "30000",
                    //             "priority": 0,
                    //             "showStatus": 1,
                    //             "side": 1,
                    //             "sourceType": 4,
                    //             "status": 12,
                    //             "tradeAmount": "0",
                    //             "tradeValue": "0",
                    //             "type": 1,
                    //             "userId": "6896693805014120448",
                    //             "value": "60"
                    //         },
                    //         "desc":"操作成功"
                    //     }
                    //
                    // Algo order
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": {
                    //             "list": [
                    //                 {
                    //                     "action": 1,
                    //                     "algoPrice": "30000",
                    //                     "amount": "0.003",
                    //                     "bizType": 0,
                    //                     "canCancel": true,
                    //                     "createTime": "1649913941109",
                    //                     "errorCode": 0,
                    //                     "id": "6920240642849449984",
                    //                     "isLong": false,
                    //                     "leverage": 10,
                    //                     "marketId": "100",
                    //                     "modifyTime": "1649913941109",
                    //                     "orderType": 1,
                    //                     "priceType": 2,
                    //                     "side": 5,
                    //                     "sourceType": 4,
                    //                     "status": 1,
                    //                     "submitPrice": "41270.53",
                    //                     "symbol": "BTC_USDT",
                    //                     "tradedAmount": "0",
                    //                     "triggerCondition": "<=",
                    //                     "triggerPrice": "31000",
                    //                     "triggerTime": "0",
                    //                     "userId": "6896693805014120448"
                    //                 },
                    //             ],
                    //             "pageNum": 1,
                    //             "pageSize": 10
                    //         },
                    //         "desc": "操作成功"
                    //     }
                    //
                    if (stop) {
                        const data = this.safeValue(response, 'data', {});
                        response = this.safeValue(data, 'list', []);
                        const result = [];
                        for(let i = 0; i < response.length; i++){
                            const entry = response[i];
                            const algoId = this.safeString(entry, 'id');
                            if (id === algoId) result.push(entry);
                        }
                        response = result[0];
                    }
                    if (swap && !stop) response = this.safeValue(response, 'data', {});
                    return this.parseOrder(response, market);
                }
                async fetchOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const reduceOnly = this.safeValue(params, 'reduceOnly');
                    const stop = this.safeValue(params, 'stop');
                    const swap = market['swap'];
                    const request = {
                        'pageSize': limit
                    };
                    const marketIdField = market['swap'] ? 'symbol' : 'currency';
                    request[marketIdField] = market['id'];
                    const pageNumField = market['swap'] ? 'pageNum' : 'pageIndex';
                    request[pageNumField] = 1;
                    if (swap) request['startTime'] = since;
                    let method = this.getSupportedMapping(market['type'], {
                        'spot': 'spotV1PrivateGetGetOrdersIgnoreTradeType',
                        'swap': 'contractV2PrivateGetTradeGetAllOrders'
                    });
                    // tradeType 交易类型1/0[buy/sell]
                    if ('tradeType' in params) method = 'spotV1PrivateGetGetOrdersNew';
                    if (stop) {
                        method = 'contractV2PrivateGetTradeGetOrderAlgos';
                        const orderType = this.safeInteger(params, 'orderType');
                        if (orderType === undefined) throw new ArgumentsRequired1(this.id + ' fetchOrders() requires an orderType parameter for stop orders');
                        const side = this.safeInteger(params, 'side');
                        const bizType = this.safeInteger(params, 'bizType');
                        if (side === 'sell' && reduceOnly) request['side'] = 3; // close long
                        else if (side === 'buy' && reduceOnly) request['side'] = 4; // close short
                        else if (side === 'buy') request['side'] = 1; // open long
                        else if (side === 'sell') request['side'] = 2; // open short
                        else if (side === 5) request['side'] = 5; // one way position buy
                        else if (side === 6) request['side'] = 6; // one way position sell
                        else if (side === 0) request['side'] = 0; // one way position close only
                        if (orderType === 1) request['orderType'] = 1;
                        else if (orderType === 2 || bizType) {
                            request['orderType'] = 2;
                            request['bizType'] = bizType;
                        }
                    }
                    const query = this.omit(params, [
                        'reduceOnly',
                        'stop',
                        'side',
                        'orderType',
                        'bizType'
                    ]);
                    let response = undefined;
                    try {
                        response = await this[method](this.extend(request, query));
                    } catch (e) {
                        if (e instanceof OrderNotFound) return [];
                        throw e;
                    }
                    // Spot
                    //
                    //     [
                    //         {
                    //             "acctType": 0,
                    //             "currency": "btc_usdt",
                    //             "fees": 0,
                    //             "id": "202202234857482656",
                    //             "price": 30000.0,
                    //             "status": 3,
                    //             "total_amount": 0.0006,
                    //             "trade_amount": 0.0000,
                    //             "trade_date": 1645610254524,
                    //             "trade_money": 0.000000,
                    //             "type": 1,
                    //             "useZbFee": false,
                    //             "webId": 0
                    //         }
                    //     ]
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": {
                    //             "list": [
                    //                 {
                    //                     "action": 1,
                    //                     "amount": "0.004",
                    //                     "availableAmount": "0.004",
                    //                     "availableValue": "120",
                    //                     "avgPrice": "0",
                    //                     "canCancel": true,
                    //                     "cancelStatus": 20,
                    //                     "createTime": "1645609643885",
                    //                     "entrustType": 1,
                    //                     "id": "6902187111785635850",
                    //                     "leverage": 5,
                    //                     "margin": "24",
                    //                     "marketId": "100",
                    //                     "marketName": "BTC_USDT",
                    //                     "modifyTime": "1645609643889",
                    //                     "price": "30000",
                    //                     "showStatus": 1,
                    //                     "side": 1,
                    //                     "sourceType": 1,
                    //                     "status": 12,
                    //                     "tradeAmount": "0",
                    //                     "tradeValue": "0",
                    //                     "type": 1,
                    //                     "userId": "6896693805014120448",
                    //                     "value": "120"
                    //                 },
                    //             ],
                    //             "pageNum": 1,
                    //             "pageSize": 10
                    //         },
                    //         "desc": "操作成功"
                    //     }
                    //
                    // Algo order
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": {
                    //             "list": [
                    //                 {
                    //                     "action": 1,
                    //                     "algoPrice": "30000",
                    //                     "amount": "0.003",
                    //                     "bizType": 0,
                    //                     "canCancel": true,
                    //                     "createTime": "1649913941109",
                    //                     "errorCode": 0,
                    //                     "id": "6920240642849449984",
                    //                     "isLong": false,
                    //                     "leverage": 10,
                    //                     "marketId": "100",
                    //                     "modifyTime": "1649913941109",
                    //                     "orderType": 1,
                    //                     "priceType": 2,
                    //                     "side": 5,
                    //                     "sourceType": 4,
                    //                     "status": 1,
                    //                     "submitPrice": "41270.53",
                    //                     "symbol": "BTC_USDT",
                    //                     "tradedAmount": "0",
                    //                     "triggerCondition": "<=",
                    //                     "triggerPrice": "31000",
                    //                     "triggerTime": "0",
                    //                     "userId": "6896693805014120448"
                    //                 },
                    //             ],
                    //             "pageNum": 1,
                    //             "pageSize": 10
                    //         },
                    //         "desc": "操作成功"
                    //     }
                    //
                    if (swap) {
                        const data = this.safeValue(response, 'data', {});
                        response = this.safeValue(data, 'list', []);
                    }
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchCanceledOrders(symbol, since, limit = 10, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchCanceledOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const reduceOnly = this.safeValue(params, 'reduceOnly');
                    const stop = this.safeValue(params, 'stop');
                    const request = {
                        'pageSize': limit
                    };
                    const marketIdField = market['spot'] ? 'currency' : 'symbol';
                    request[marketIdField] = market['id'];
                    const pageNumField = market['spot'] ? 'pageIndex' : 'pageNum';
                    request[pageNumField] = 1;
                    let method = 'spotV1PrivateGetGetOrdersIgnoreTradeType';
                    if (stop) {
                        method = 'contractV2PrivateGetTradeGetOrderAlgos';
                        const orderType = this.safeInteger(params, 'orderType');
                        if (orderType === undefined) throw new ArgumentsRequired1(this.id + ' fetchCanceledOrders() requires an orderType parameter for stop orders');
                        const side = this.safeInteger(params, 'side');
                        const bizType = this.safeInteger(params, 'bizType');
                        if (side === 'sell' && reduceOnly) request['side'] = 3; // close long
                        else if (side === 'buy' && reduceOnly) request['side'] = 4; // close short
                        else if (side === 'buy') request['side'] = 1; // open long
                        else if (side === 'sell') request['side'] = 2; // open short
                        else if (side === 5) request['side'] = 5; // one way position buy
                        else if (side === 6) request['side'] = 6; // one way position sell
                        else if (side === 0) request['side'] = 0; // one way position close only
                        if (orderType === 1) request['orderType'] = 1;
                        else if (orderType === 2 || bizType) {
                            request['orderType'] = 2;
                            request['bizType'] = bizType;
                        }
                        request['status'] = 2;
                    }
                    // tradeType 交易类型1/0[buy/sell]
                    if ('tradeType' in params) method = 'spotV1PrivateGetGetOrdersNew';
                    let response = undefined;
                    try {
                        response = await this[method](this.extend(request, params));
                    } catch (e) {
                        if (e instanceof OrderNotFound) return [];
                        throw e;
                    }
                    const query = this.omit(params, [
                        'reduceOnly',
                        'stop',
                        'side',
                        'orderType',
                        'bizType'
                    ]);
                    response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     [
                    //         {
                    //             "acctType": 0,
                    //             "currency": "btc_usdt",
                    //             "fees": 0,
                    //             "id": "202202234857482656",
                    //             "price": 30000.0,
                    //             "status": 1,
                    //             "total_amount": 0.0006,
                    //             "trade_amount": 0.0000,
                    //             "trade_date": 1645610254524,
                    //             "trade_money": 0.000000,
                    //             "type": 1,
                    //             "useZbFee": false,
                    //             "webId": 0
                    //         }
                    //     ]
                    //
                    // Algo order
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": {
                    //             "list": [
                    //                 {
                    //                     "action": 1,
                    //                     "algoPrice": "30000",
                    //                     "amount": "0.003",
                    //                     "bizType": 0,
                    //                     "canCancel": true,
                    //                     "createTime": "1649913941109",
                    //                     "errorCode": 0,
                    //                     "id": "6920240642849449984",
                    //                     "isLong": false,
                    //                     "leverage": 10,
                    //                     "marketId": "100",
                    //                     "modifyTime": "1649913941109",
                    //                     "orderType": 1,
                    //                     "priceType": 2,
                    //                     "side": 5,
                    //                     "sourceType": 4,
                    //                     "status": 2,
                    //                     "submitPrice": "41270.53",
                    //                     "symbol": "BTC_USDT",
                    //                     "tradedAmount": "0",
                    //                     "triggerCondition": "<=",
                    //                     "triggerPrice": "31000",
                    //                     "triggerTime": "0",
                    //                     "userId": "6896693805014120448"
                    //                 },
                    //             ],
                    //             "pageNum": 1,
                    //             "pageSize": 10
                    //         },
                    //         "desc": "操作成功"
                    //     }
                    //
                    if (stop) {
                        const data = this.safeValue(response, 'data', {});
                        response = this.safeValue(data, 'list', []);
                    }
                    const result = [];
                    if (market['type'] === 'spot') {
                        for(let i = 0; i < response.length; i++){
                            const entry = response[i];
                            const status = this.safeString(entry, 'status');
                            if (status === '1') result.push(entry);
                        }
                        response = result;
                    }
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchClosedOrders(symbol, since, limit = 10, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchClosedOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const reduceOnly = this.safeValue(params, 'reduceOnly');
                    const stop = this.safeValue(params, 'stop');
                    const request = {
                        'pageSize': limit
                    };
                    const marketIdField = market['spot'] ? 'currency' : 'symbol';
                    request[marketIdField] = market['id'];
                    const pageNumField = market['spot'] ? 'pageIndex' : 'pageNum';
                    request[pageNumField] = 1;
                    let method = 'spotV1PrivateGetGetFinishedAndPartialOrders';
                    if (stop) {
                        method = 'contractV2PrivateGetTradeGetOrderAlgos';
                        const orderType = this.safeInteger(params, 'orderType');
                        if (orderType === undefined) throw new ArgumentsRequired1(this.id + ' fetchClosedOrders() requires an orderType parameter for stop orders');
                        const side = this.safeInteger(params, 'side');
                        const bizType = this.safeInteger(params, 'bizType');
                        if (side === 'sell' && reduceOnly) request['side'] = 3; // close long
                        else if (side === 'buy' && reduceOnly) request['side'] = 4; // close short
                        else if (side === 'buy') request['side'] = 1; // open long
                        else if (side === 'sell') request['side'] = 2; // open short
                        else if (side === 5) request['side'] = 5; // one way position buy
                        else if (side === 6) request['side'] = 6; // one way position sell
                        else if (side === 0) request['side'] = 0; // one way position close only
                        if (orderType === 1) request['orderType'] = 1;
                        else if (orderType === 2 || bizType) {
                            request['orderType'] = 2;
                            request['bizType'] = bizType;
                        }
                        request['status'] = 5;
                    }
                    const query = this.omit(params, [
                        'reduceOnly',
                        'stop',
                        'side',
                        'orderType',
                        'bizType'
                    ]);
                    let response = await this[method](this.extend(request, query));
                    //
                    // Spot
                    //
                    //     [
                    //         {
                    //             "acctType": 0,
                    //             "currency": "btc_usdt",
                    //             "fees": 0.00823354,
                    //             "id": "202204145086706337",
                    //             "price": 41167.7,
                    //             "status": 2,
                    //             "total_amount": 0.0001,
                    //             "trade_amount": 0.0001,
                    //             "trade_date": 1649917867370,
                    //             "trade_money": 4.116770,
                    //             "type": 0,
                    //             "useZbFee": false,
                    //             "webId": 0
                    //         },
                    //     ]
                    //
                    // Algo order
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": {
                    //             "list": [
                    //                 {
                    //                     "action": 1,
                    //                     "algoPrice": "30000",
                    //                     "amount": "0.003",
                    //                     "bizType": 0,
                    //                     "canCancel": true,
                    //                     "createTime": "1649913941109",
                    //                     "errorCode": 0,
                    //                     "id": "6920240642849449984",
                    //                     "isLong": false,
                    //                     "leverage": 10,
                    //                     "marketId": "100",
                    //                     "modifyTime": "1649913941109",
                    //                     "orderType": 1,
                    //                     "priceType": 2,
                    //                     "side": 5,
                    //                     "sourceType": 4,
                    //                     "status": 1,
                    //                     "submitPrice": "41270.53",
                    //                     "symbol": "BTC_USDT",
                    //                     "tradedAmount": "0",
                    //                     "triggerCondition": "<=",
                    //                     "triggerPrice": "31000",
                    //                     "triggerTime": "0",
                    //                     "userId": "6896693805014120448"
                    //                 },
                    //             ],
                    //             "pageNum": 1,
                    //             "pageSize": 10
                    //         },
                    //         "desc": "操作成功"
                    //     }
                    //
                    if (stop) {
                        const data = this.safeValue(response, 'data', {});
                        response = this.safeValue(data, 'list', []);
                    }
                    return this.parseOrders(response, market, since, limit);
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires a symbol argument');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const reduceOnly = this.safeValue(params, 'reduceOnly');
                    const stop = this.safeValue(params, 'stop');
                    const swap = market['swap'];
                    const request = {
                    };
                    if (limit !== undefined) request['pageSize'] = limit; // default pageSize is 10 for spot, 30 for swap
                    const marketIdField = market['swap'] ? 'symbol' : 'currency';
                    request[marketIdField] = market['id'];
                    const pageNumField = market['swap'] ? 'pageNum' : 'pageIndex';
                    request[pageNumField] = 1;
                    if (swap && since !== undefined) request['startTime'] = since;
                    let method = this.getSupportedMapping(market['type'], {
                        'spot': 'spotV1PrivateGetGetUnfinishedOrdersIgnoreTradeType',
                        'swap': 'contractV2PrivateGetTradeGetUndoneOrders'
                    });
                    if (stop) {
                        method = 'contractV2PrivateGetTradeGetOrderAlgos';
                        const orderType = this.safeInteger(params, 'orderType');
                        if (orderType === undefined) throw new ArgumentsRequired1(this.id + ' fetchOpenOrders() requires an orderType parameter for stop orders');
                        const side = this.safeInteger(params, 'side');
                        const bizType = this.safeInteger(params, 'bizType');
                        if (side === 'sell' && reduceOnly) request['side'] = 3; // close long
                        else if (side === 'buy' && reduceOnly) request['side'] = 4; // close short
                        else if (side === 'buy') request['side'] = 1; // open long
                        else if (side === 'sell') request['side'] = 2; // open short
                        else if (side === 5) request['side'] = 5; // one way position buy
                        else if (side === 6) request['side'] = 6; // one way position sell
                        else if (side === 0) request['side'] = 0; // one way position close only
                        if (orderType === 1) request['orderType'] = 1;
                        else if (orderType === 2 || bizType) {
                            request['orderType'] = 2;
                            request['bizType'] = bizType;
                        }
                        request['status'] = 1;
                    }
                    const query = this.omit(params, [
                        'reduceOnly',
                        'stop',
                        'side',
                        'orderType',
                        'bizType'
                    ]);
                    // tradeType 交易类型1/0[buy/sell]
                    if ('tradeType' in params) method = 'spotV1PrivateGetGetOrdersNew';
                    let response = undefined;
                    try {
                        response = await this[method](this.extend(request, query));
                    } catch (e) {
                        if (e instanceof OrderNotFound) return [];
                        throw e;
                    }
                    //
                    // Spot
                    //
                    //     [
                    //         {
                    //             "currency": "btc_usdt",
                    //             "id": "20150928158614292",
                    //             "price": 1560,
                    //             "status": 3,
                    //             "total_amount": 0.1,
                    //             "trade_amount": 0,
                    //             "trade_date": 1443410396717,
                    //             "trade_money": 0,
                    //             "type": 0,
                    //             "fees": "0.03",
                    //             "useZbFee": true
                    //         },
                    //     ]
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": {
                    //             "list": [
                    //                 {
                    //                     "action": 1,
                    //                     "amount": "0.003",
                    //                     "availableAmount": "0.003",
                    //                     "availableValue": "90",
                    //                     "avgPrice": "0",
                    //                     "canCancel": true,
                    //                     "cancelStatus": 20,
                    //                     "createTime": "1645694610880",
                    //                     "entrustType": 1,
                    //                     "id": "6902543489192632320",
                    //                     "leverage": 5,
                    //                     "margin": "18",
                    //                     "marketId": "100",
                    //                     "modifyTime": "1645694610883",
                    //                     "price": "30000",
                    //                     "priority": 0,
                    //                     "showStatus": 1,
                    //                     "side": 1,
                    //                     "sourceType": 1,
                    //                     "status": 12,
                    //                     "tradeAmount": "0",
                    //                     "tradeValue": "0",
                    //                     "type": 1,
                    //                     "userId": "6896693805014120448",
                    //                     "value": "90"
                    //                 }
                    //             ],
                    //             "pageNum": 1,
                    //             "pageSize": 30
                    //         },
                    //         "desc": "操作成功"
                    //     }
                    //
                    // Algo order
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": {
                    //             "list": [
                    //                 {
                    //                     "action": 1,
                    //                     "algoPrice": "30000",
                    //                     "amount": "0.003",
                    //                     "bizType": 0,
                    //                     "canCancel": true,
                    //                     "createTime": "1649913941109",
                    //                     "errorCode": 0,
                    //                     "id": "6920240642849449984",
                    //                     "isLong": false,
                    //                     "leverage": 10,
                    //                     "marketId": "100",
                    //                     "modifyTime": "1649913941109",
                    //                     "orderType": 1,
                    //                     "priceType": 2,
                    //                     "side": 5,
                    //                     "sourceType": 4,
                    //                     "status": 1,
                    //                     "submitPrice": "41270.53",
                    //                     "symbol": "BTC_USDT",
                    //                     "tradedAmount": "0",
                    //                     "triggerCondition": "<=",
                    //                     "triggerPrice": "31000",
                    //                     "triggerTime": "0",
                    //                     "userId": "6896693805014120448"
                    //                 },
                    //             ],
                    //             "pageNum": 1,
                    //             "pageSize": 10
                    //         },
                    //         "desc": "操作成功"
                    //     }
                    //
                    if (swap) {
                        const data = this.safeValue(response, 'data', {});
                        response = this.safeValue(data, 'list', []);
                    }
                    return this.parseOrders(response, market, since, limit);
                }
                parseOrder(order, market) {
                    //
                    // Spot fetchOrder, fetchClosedOrders
                    //
                    //     {
                    //         acctType: 0,
                    //         currency: 'btc_usdt',
                    //         fees: 3.6e-7,
                    //         id: '202102282829772463',
                    //         price: 45177.5,
                    //         status: 2,
                    //         total_amount: 0.0002,
                    //         trade_amount: 0.0002,
                    //         trade_date: 1614515104998,
                    //         trade_money: 8.983712,
                    //         type: 1,
                    //         useZbFee: false
                    //     },
                    //
                    // Swap fetchOrder
                    //
                    //     {
                    //         "action": 1,
                    //         "amount": "0.002",
                    //         "availableAmount": "0.002",
                    //         "availableValue": "60",
                    //         "avgPrice": "0",
                    //         "canCancel": true,
                    //         "cancelStatus": 20,
                    //         "createTime": "1646185684379",
                    //         "entrustType": 1,
                    //         "id": "6904603200733782016",
                    //         "leverage": 2,
                    //         "margin": "30",
                    //         "marketId": "100",
                    //         "modifyTime": "1646185684416",
                    //         "price": "30000",
                    //         "priority": 0,
                    //         "showStatus": 1,
                    //         "side": 1,
                    //         "sourceType": 4,
                    //         "status": 12,
                    //         "tradeAmount": "0",
                    //         "tradeValue": "0",
                    //         "type": 1,
                    //         "userId": "6896693805014120448",
                    //         "value": "60"
                    //     },
                    //
                    // Algo fetchOrder, fetchOrders, fetchOpenOrders, fetchClosedOrders
                    //
                    //     {
                    //         "action": 1,
                    //         "algoPrice": "30000",
                    //         "amount": "0.003",
                    //         "bizType": 0,
                    //         "canCancel": true,
                    //         "createTime": "1649913941109",
                    //         "errorCode": 0,
                    //         "id": "6920240642849449984",
                    //         "isLong": false,
                    //         "leverage": 10,
                    //         "marketId": "100",
                    //         "modifyTime": "1649913941109",
                    //         "orderType": 1,
                    //         "priceType": 2,
                    //         "side": 5,
                    //         "sourceType": 4,
                    //         "status": 1,
                    //         "submitPrice": "41270.53",
                    //         "symbol": "BTC_USDT",
                    //         "tradedAmount": "0",
                    //         "triggerCondition": "<=",
                    //         "triggerPrice": "31000",
                    //         "triggerTime": "0",
                    //         "userId": "6896693805014120448"
                    //     },
                    //
                    // Spot createOrder
                    //
                    //     {
                    //         code: '1000',
                    //         message: '操作成功',
                    //         id: '202202224851151555',
                    //         type: '1',
                    //         total_amount: 0.0002,
                    //         price: 30000
                    //     }
                    //
                    // Swap createOrder
                    //
                    //     {
                    //         orderId: '6901786759944937472',
                    //         orderCode: null,
                    //         timeInForce: 'IOC',
                    //         total_amount: 0.0002,
                    //         price: 30000
                    //     }
                    //
                    // Algo createOrder
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": "6919884551305242624",
                    //         "desc": "操作成功"
                    //     }
                    //
                    let orderId = market['swap'] ? this.safeValue(order, 'orderId') : this.safeValue(order, 'id');
                    if (orderId === undefined) orderId = this.safeValue(order, 'id');
                    let side = this.safeInteger2(order, 'type', 'side');
                    if (side === undefined) side = undefined;
                    else if (market['type'] === 'spot') side = side === 1 ? 'buy' : 'sell';
                    let timestamp = this.safeInteger(order, 'trade_date');
                    if (timestamp === undefined) timestamp = this.safeInteger(order, 'createTime');
                    const marketId = this.safeString(order, 'currency');
                    market = this.safeMarket(marketId, market, '_');
                    const price = this.safeString2(order, 'price', 'algoPrice');
                    const filled = market['swap'] ? this.safeString(order, 'tradeAmount') : this.safeString(order, 'trade_amount');
                    let amount = this.safeString(order, 'total_amount');
                    if (amount === undefined) amount = this.safeString(order, 'amount');
                    const cost = this.safeString(order, 'trade_money');
                    const status = this.parseOrderStatus(this.safeString(order, 'status'), market);
                    const timeInForce = this.safeString(order, 'timeInForce');
                    const postOnly = timeInForce === 'PO';
                    const feeCost = this.safeNumber(order, 'fees');
                    let fee = undefined;
                    if (feeCost !== undefined) {
                        let feeCurrency = undefined;
                        const zbFees = this.safeValue(order, 'useZbFee');
                        if (zbFees === true) feeCurrency = 'ZB';
                        else feeCurrency = side === 'sell' ? market['quote'] : market['base'];
                        fee = {
                            'cost': feeCost,
                            'currency': feeCurrency
                        };
                    }
                    return this.safeOrder({
                        'info': order,
                        'id': orderId,
                        'clientOrderId': this.safeString(order, 'userId'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'symbol': market['symbol'],
                        'type': 'limit',
                        'timeInForce': timeInForce,
                        'postOnly': postOnly,
                        'side': side,
                        'price': price,
                        'stopPrice': this.safeString(order, 'triggerPrice'),
                        'average': this.safeString(order, 'avgPrice'),
                        'cost': cost,
                        'amount': amount,
                        'filled': filled,
                        'remaining': undefined,
                        'status': status,
                        'fee': fee,
                        'trades': undefined
                    }, market);
                }
                parseOrderStatus(status, market) {
                    let statuses = {};
                    if (market['type'] === 'spot') statuses = {
                        '0': 'open',
                        '1': 'canceled',
                        '2': 'closed',
                        '3': 'open'
                    };
                    else statuses = {
                        '1': 'open',
                        '2': 'canceled',
                        '3': 'open',
                        '4': 'failed',
                        '5': 'closed'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransactionStatus(status) {
                    const statuses = {
                        '0': 'pending',
                        '1': 'failed',
                        '2': 'ok',
                        '3': 'canceled',
                        '5': 'ok'
                    };
                    return this.safeString(statuses, status, status);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "code": 1000,
                    //         "message": "success",
                    //         "id": "withdrawalId"
                    //     }
                    //
                    // fetchWithdrawals
                    //
                    //     {
                    //         "amount": 0.01,
                    //         "fees": 0.001,
                    //         "id": 2016042556231,
                    //         "manageTime": 1461579340000,
                    //         "status": 3,
                    //         "submitTime": 1461579288000,
                    //         "toAddress": "14fxEPirL9fyfw1i9EF439Pq6gQ5xijUmp",
                    //     }
                    //
                    // fetchDeposits
                    //
                    //     {
                    //         "address": "1FKN1DZqCm8HaTujDioRL2Aezdh7Qj7xxx",
                    //         "amount": "1.00000000",
                    //         "confirmTimes": 1,
                    //         "currency": "BTC",
                    //         "description": "Successfully Confirm",
                    //         "hash": "7ce842de187c379abafadd64a5fe66c5c61c8a21fb04edff9532234a1dae6xxx",
                    //         "id": 558,
                    //         "itransfer": 1,
                    //         "status": 2,
                    //         "submit_time": "2016-12-07 18:51:57",
                    //     }
                    //
                    const id = this.safeString(transaction, 'id');
                    const txid = this.safeString(transaction, 'hash');
                    const amount = this.safeNumber(transaction, 'amount');
                    let timestamp = this.parse8601(this.safeString(transaction, 'submit_time'));
                    timestamp = this.safeInteger(transaction, 'submitTime', timestamp);
                    let address = this.safeString2(transaction, 'toAddress', 'address');
                    let tag = undefined;
                    if (address !== undefined) {
                        const parts = address.split('_');
                        address = this.safeString(parts, 0);
                        tag = this.safeString(parts, 1);
                    }
                    const confirmTimes = this.safeInteger(transaction, 'confirmTimes');
                    const updated = this.safeInteger(transaction, 'manageTime');
                    let type = undefined;
                    const currencyId = this.safeString(transaction, 'currency');
                    const code = this.safeCurrencyCode(currencyId, currency);
                    if (address !== undefined) type = confirmTimes === undefined ? 'withdrawal' : 'deposit';
                    const status = this.parseTransactionStatus(this.safeString(transaction, 'status'));
                    let fee = undefined;
                    const feeCost = this.safeNumber(transaction, 'fees');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': code
                    };
                    return {
                        'info': transaction,
                        'id': id,
                        'txid': txid,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': address,
                        'addressTo': address,
                        'tagFrom': undefined,
                        'tag': tag,
                        'tagTo': tag,
                        'type': type,
                        'amount': amount,
                        'currency': code,
                        'status': status,
                        'updated': updated,
                        'fee': fee
                    };
                }
                async setLeverage(leverage, symbol, params = {}) {
                    await this.loadMarkets();
                    if (symbol === undefined) throw new ArgumentsRequired1(this.id + ' setLeverage() requires a symbol argument');
                    if (leverage < 1 || leverage > 125) throw new BadRequest(this.id + ' setLeverage() leverage should be between 1 and 125');
                    const market = this.market(symbol);
                    let accountType = undefined;
                    if (!market['swap']) throw new BadSymbol(this.id + ' setLeverage() supports swap contracts only');
                    else accountType = 1;
                    const request = {
                        'symbol': market['id'],
                        'leverage': leverage,
                        'futuresAccountType': accountType
                    };
                    return await this.contractV2PrivatePostSettingSetLeverage(this.extend(request, params));
                }
                async fetchFundingRateHistory(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    if (symbol !== undefined) {
                        const market = this.market(symbol);
                        symbol = market['symbol'];
                        request['symbol'] = market['id'];
                    }
                    if (since !== undefined) request['startTime'] = since;
                    const till = this.safeInteger(params, 'till');
                    const endTime = this.safeString(params, 'endTime');
                    params = this.omit(params, [
                        'endTime',
                        'till'
                    ]);
                    if (till !== undefined) request['endTime'] = till;
                    else if (endTime !== undefined) request['endTime'] = endTime;
                    if (limit !== undefined) request['limit'] = limit;
                    const response = await this.contractV2PublicGetFundingRate(this.extend(request, params));
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": [
                    //             {
                    //                 "symbol": "BTC_USDT",
                    //                 "fundingRate": "0.0001",
                    //                 "fundingTime": "1645171200000"
                    //             },
                    //         ],
                    //         "desc": "操作成功"
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    const rates = [];
                    for(let i = 0; i < data.length; i++){
                        const entry = data[i];
                        const marketId = this.safeString(entry, 'symbol');
                        const symbol = this.safeSymbol(marketId);
                        const timestamp = this.safeString(entry, 'fundingTime');
                        rates.push({
                            'info': entry,
                            'symbol': symbol,
                            'fundingRate': this.safeNumber(entry, 'fundingRate'),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp)
                        });
                    }
                    const sorted = this.sortBy(rates, 'timestamp');
                    return this.filterBySymbolSinceLimit(sorted, symbol, since, limit);
                }
                async fetchFundingRate(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    if (!market['swap']) throw new BadSymbol(this.id + ' fetchFundingRate() does not supports contracts only');
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.contractV1PublicGetFundingRate(this.extend(request, params));
                    //
                    //     {
                    //         "code": 10000,
                    //         "desc": "操作成功",
                    //         "data": {
                    //             "fundingRate": "0.0001",
                    //             "nextCalculateTime": "2022-02-19 00:00:00"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseFundingRate(data, market);
                }
                parseFundingRate(contract, market) {
                    //
                    // fetchFundingRate
                    //
                    //     {
                    //         "fundingRate": "0.0001",
                    //         "nextCalculateTime": "2022-02-19 00:00:00"
                    //     }
                    //
                    // fetchFundingRates
                    //
                    //     {
                    //         "symbol": "BTC_USDT",
                    //         "markPrice": "43254.42",
                    //         "indexPrice": "43278.61",
                    //         "lastFundingRate": "0.0001",
                    //         "nextFundingTime": "1646121600000"
                    //     }
                    //
                    const marketId = this.safeString(contract, 'symbol');
                    const symbol = this.safeSymbol(marketId, market);
                    const fundingRate = this.safeNumber(contract, 'fundingRate');
                    const nextFundingDatetime = this.safeString(contract, 'nextCalculateTime');
                    return {
                        'info': contract,
                        'symbol': symbol,
                        'markPrice': this.safeString(contract, 'markPrice'),
                        'indexPrice': this.safeString(contract, 'indexPrice'),
                        'interestRate': undefined,
                        'estimatedSettlePrice': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'fundingRate': fundingRate,
                        'fundingTimestamp': undefined,
                        'fundingDatetime': undefined,
                        'nextFundingRate': undefined,
                        'nextFundingTimestamp': this.parse8601(nextFundingDatetime),
                        'nextFundingDatetime': nextFundingDatetime,
                        'previousFundingRate': this.safeString(contract, 'lastFundingRate'),
                        'previousFundingTimestamp': undefined,
                        'previousFundingDatetime': undefined
                    };
                }
                async fetchFundingRates(symbols, params = {}) {
                    await this.loadMarkets();
                    const response = await this.contractV2PublicGetPremiumIndex(params);
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": [
                    //             {
                    //                 "symbol": "BTC_USDT",
                    //                 "markPrice": "43254.42",
                    //                 "indexPrice": "43278.61",
                    //                 "lastFundingRate": "0.0001",
                    //                 "nextFundingTime": "1646121600000"
                    //             },
                    //         ],
                    //         "desc":"操作成功"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const result = this.parseFundingRates(data);
                    return this.filterByArray(result, 'symbol', symbols);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    const password = this.safeString(params, 'safePwd', this.password);
                    if (password === undefined) throw new ArgumentsRequired1(this.id + ' withdraw() requires exchange.password or a safePwd parameter');
                    const fees = this.safeNumber(params, 'fees');
                    if (fees === undefined) throw new ArgumentsRequired1(this.id + ' withdraw() requires a fees parameter');
                    this.checkAddress(address);
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    if (tag !== undefined) address += '_' + tag;
                    const request = {
                        'amount': this.currencyToPrecision(code, amount),
                        'currency': currency['id'],
                        'fees': this.currencyToPrecision(code, fees),
                        // 'itransfer': 0, // agree for an internal transfer, 0 disagree, 1 agree, the default is to disagree
                        'method': 'withdraw',
                        'receiveAddr': address,
                        'safePwd': password
                    };
                    const response = await this.spotV1PrivateGetWithdraw(this.extend(request, params));
                    //
                    //     {
                    //         "code": 1000,
                    //         "message": "success",
                    //         "id": "withdrawalId"
                    //     }
                    //
                    const transaction = this.parseTransaction(response, currency);
                    return this.extend(transaction, {
                        'type': 'withdrawal',
                        'address': address,
                        'addressTo': address,
                        'amount': amount
                    });
                }
                async fetchWithdrawals(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['pageSize'] = limit;
                    const response = await this.spotV1PrivateGetGetWithdrawRecord(this.extend(request, params));
                    //
                    //     {
                    //         "code": 1000,
                    //         "message": {
                    //             "des": "success",
                    //             "isSuc": true,
                    //             "datas": {
                    //                 "list": [
                    //                     {
                    //                         "amount": 0.01,
                    //                         "fees": 0.001,
                    //                         "id": 2016042556231,
                    //                         "manageTime": 1461579340000,
                    //                         "status": 3,
                    //                         "submitTime": 1461579288000,
                    //                         "toAddress": "14fxEPirL9fyfw1i9EF439Pq6gQ5xijUmp",
                    //                     },
                    //                 ],
                    //                 "pageIndex": 1,
                    //                 "pageSize": 10,
                    //                 "totalCount": 4,
                    //                 "totalPage": 1
                    //             }
                    //         }
                    //     }
                    //
                    const message = this.safeValue(response, 'message', {});
                    const datas = this.safeValue(message, 'datas', {});
                    const withdrawals = this.safeValue(datas, 'list', []);
                    return this.parseTransactions(withdrawals, currency, since, limit);
                }
                async fetchDeposits(code, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                    };
                    let currency = undefined;
                    if (code !== undefined) {
                        currency = this.currency(code);
                        request['currency'] = currency['id'];
                    }
                    if (limit !== undefined) request['pageSize'] = limit;
                    const response = await this.spotV1PrivateGetGetChargeRecord(this.extend(request, params));
                    //
                    //     {
                    //         "code": 1000,
                    //         "message": {
                    //             "des": "success",
                    //             "isSuc": true,
                    //             "datas": {
                    //                 "list": [
                    //                     {
                    //                         "address": "1FKN1DZqCm8HaTujDioRL2Aezdh7Qj7xxx",
                    //                         "amount": "1.00000000",
                    //                         "confirmTimes": 1,
                    //                         "currency": "BTC",
                    //                         "description": "Successfully Confirm",
                    //                         "hash": "7ce842de187c379abafadd64a5fe66c5c61c8a21fb04edff9532234a1dae6xxx",
                    //                         "id": 558,
                    //                         "itransfer": 1,
                    //                         "status": 2,
                    //                         "submit_time": "2016-12-07 18:51:57",
                    //                     },
                    //                 ],
                    //                 "pageIndex": 1,
                    //                 "pageSize": 10,
                    //                 "total": 8
                    //             }
                    //         }
                    //     }
                    //
                    const message = this.safeValue(response, 'message', {});
                    const datas = this.safeValue(message, 'datas', {});
                    const deposits = this.safeValue(datas, 'list', []);
                    return this.parseTransactions(deposits, currency, since, limit);
                }
                async fetchPosition(symbol, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbol !== undefined) market = this.market(symbol);
                    const request = {
                        'futuresAccountType': 1
                    };
                    const response = await this.contractV2PrivateGetPositionsGetPositions(this.extend(request, params));
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": [
                    //             {
                    //                 "amount": "0.002",
                    //                 "appendAmount": "0",
                    //                 "autoLightenRatio": "0",
                    //                 "avgPrice": "38570",
                    //                 "bankruptcyPrice": "46288.41",
                    //                 "contractType": 1,
                    //                 "createTime": "1645784751867",
                    //                 "freezeAmount": "0",
                    //                 "freezeList": [
                    //                     {
                    //                         "amount": "15.436832",
                    //                         "currencyId": "6",
                    //                         "currencyName": "usdt",
                    //                         "modifyTime": "1645784751867"
                    //                     }
                    //                 ],
                    //                 "id": "6902921567894972486",
                    //                 "lastAppendAmount": "0",
                    //                 "leverage": 5,
                    //                 "liquidateLevel": 1,
                    //                 "liquidatePrice": "46104",
                    //                 "maintainMargin": "0.30912384",
                    //                 "margin": "15.436832",
                    //                 "marginAppendCount": 0,
                    //                 "marginBalance": "15.295872",
                    //                 "marginMode": 1,
                    //                 "marginRate": "0.020209",
                    //                 "marketId": "100",
                    //                 "marketName": "BTC_USDT",
                    //                 "modifyTime": "1645784751867",
                    //                 "nominalValue": "77.14736",
                    //                 "originAppendAmount": "0",
                    //                 "originId": "6902921567894972591",
                    //                 "refreshType": "Timer",
                    //                 "returnRate": "-0.0091",
                    //                 "side": 0,
                    //                 "status": 1,
                    //                 "unrealizedPnl": "-0.14096",
                    //                 "userId": "6896693805014120448"
                    //             }
                    //         ],
                    //         "desc": "操作成功"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    const firstPosition = this.safeValue(data, 0);
                    return this.parsePosition(firstPosition, market);
                }
                async fetchPositions(symbols, params = {}) {
                    await this.loadMarkets();
                    let market = undefined;
                    if (symbols !== undefined) market = this.market(symbols);
                    const request = {
                        'futuresAccountType': 1
                    };
                    const response = await this.contractV2PrivateGetPositionsGetPositions(this.extend(request, params));
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": [
                    //             {
                    //                 "amount": "0.002",
                    //                 "appendAmount": "0",
                    //                 "autoLightenRatio": "0",
                    //                 "avgPrice": "38570",
                    //                 "bankruptcyPrice": "46288.41",
                    //                 "contractType": 1,
                    //                 "createTime": "1645784751867",
                    //                 "freezeAmount": "0",
                    //                 "freezeList": [
                    //                     {
                    //                         "amount": "15.436832",
                    //                         "currencyId": "6",
                    //                         "currencyName": "usdt",
                    //                         "modifyTime": "1645784751867"
                    //                     }
                    //                 ],
                    //                 "id": "6902921567894972486",
                    //                 "lastAppendAmount": "0",
                    //                 "leverage": 5,
                    //                 "liquidateLevel": 1,
                    //                 "liquidatePrice": "46104",
                    //                 "maintainMargin": "0.30912384",
                    //                 "margin": "15.436832",
                    //                 "marginAppendCount": 0,
                    //                 "marginBalance": "15.295872",
                    //                 "marginMode": 1,
                    //                 "marginRate": "0.020209",
                    //                 "marketId": "100",
                    //                 "marketName": "BTC_USDT",
                    //                 "modifyTime": "1645784751867",
                    //                 "nominalValue": "77.14736",
                    //                 "originAppendAmount": "0",
                    //                 "originId": "6902921567894972591",
                    //                 "refreshType": "Timer",
                    //                 "returnRate": "-0.0091",
                    //                 "side": 0,
                    //                 "status": 1,
                    //                 "unrealizedPnl": "-0.14096",
                    //                 "userId": "6896693805014120448"
                    //             },
                    //         ],
                    //         "desc": "操作成功"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', []);
                    return this.parsePositions(data, market);
                }
                parsePosition(position, market) {
                    //
                    //     {
                    //         "amount": "0.002",
                    //         "appendAmount": "0",
                    //         "autoLightenRatio": "0",
                    //         "avgPrice": "38570",
                    //         "bankruptcyPrice": "46288.41",
                    //         "contractType": 1,
                    //         "createTime": "1645784751867",
                    //         "freezeAmount": "0",
                    //         "freezeList": [
                    //             {
                    //                 "amount": "15.436832",
                    //                 "currencyId": "6",
                    //                 "currencyName": "usdt",
                    //                 "modifyTime": "1645784751867"
                    //             }
                    //         ],
                    //         "id": "6902921567894972486",
                    //         "lastAppendAmount": "0",
                    //         "leverage": 5,
                    //         "liquidateLevel": 1,
                    //         "liquidatePrice": "46104",
                    //         "maintainMargin": "0.30912384",
                    //         "margin": "15.436832",
                    //         "marginAppendCount": 0,
                    //         "marginBalance": "15.295872",
                    //         "marginMode": 1,
                    //         "marginRate": "0.020209",
                    //         "marketId": "100",
                    //         "marketName": "BTC_USDT",
                    //         "modifyTime": "1645784751867",
                    //         "nominalValue": "77.14736",
                    //         "originAppendAmount": "0",
                    //         "originId": "6902921567894972591",
                    //         "refreshType": "Timer",
                    //         "returnRate": "-0.0091",
                    //         "side": 0,
                    //         "status": 1,
                    //         "unrealizedPnl": "-0.14096",
                    //         "userId": "6896693805014120448"
                    //     }
                    //
                    market = this.safeMarket(this.safeString(position, 'marketName'), market);
                    const symbol = market['symbol'];
                    const contracts = this.safeString(position, 'amount');
                    const entryPrice = this.safeNumber(position, 'avgPrice');
                    const initialMargin = this.safeString(position, 'margin');
                    const rawSide = this.safeString(position, 'side');
                    const side = rawSide === '1' ? 'long' : 'short';
                    const openType = this.safeString(position, 'marginMode');
                    const marginMode = openType === '1' ? 'isolated' : 'cross';
                    const leverage = this.safeString(position, 'leverage');
                    const liquidationPrice = this.safeNumber(position, 'liquidatePrice');
                    const unrealizedProfit = this.safeNumber(position, 'unrealizedPnl');
                    const maintenanceMargin = this.safeNumber(position, 'maintainMargin');
                    const marginRatio = this.safeNumber(position, 'marginRate');
                    const notional = this.safeNumber(position, 'nominalValue');
                    const percentage = Precise.stringMul(this.safeString(position, 'returnRate'), '100');
                    const timestamp = this.safeNumber(position, 'createTime');
                    return {
                        'info': position,
                        'symbol': symbol,
                        'contracts': this.parseNumber(contracts),
                        'contractSize': undefined,
                        'entryPrice': entryPrice,
                        'collateral': undefined,
                        'side': side,
                        'unrealizedProfit': unrealizedProfit,
                        'leverage': this.parseNumber(leverage),
                        'percentage': percentage,
                        'marginMode': marginMode,
                        'marginType': marginMode,
                        'notional': notional,
                        'markPrice': undefined,
                        'liquidationPrice': liquidationPrice,
                        'initialMargin': this.parseNumber(initialMargin),
                        'initialMarginPercentage': undefined,
                        'maintenanceMargin': maintenanceMargin,
                        'maintenanceMarginPercentage': undefined,
                        'marginRatio': marginRatio,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp)
                    };
                }
                parsePositions(positions) {
                    const result = [];
                    for(let i = 0; i < positions.length; i++)result.push(this.parsePosition(positions[i]));
                    return result;
                }
                parseLedgerEntryType(type) {
                    const types = {
                        '1': 'realized pnl',
                        '2': 'commission',
                        '3': 'funding fee subtract',
                        '4': 'funding fee addition',
                        '5': 'insurance clear',
                        '6': 'transfer in',
                        '7': 'transfer out',
                        '8': 'margin addition',
                        '9': 'margin subtraction',
                        '10': 'commission addition',
                        '11': 'bill type freeze',
                        '12': 'bill type unfreeze',
                        '13': 'system take over margin',
                        '14': 'transfer',
                        '15': 'realized pnl collection',
                        '16': 'funding fee collection',
                        '17': 'recommender return commission',
                        '18': 'by level subtract positions',
                        '19': 'system add',
                        '20': 'system subtract',
                        '23': 'trading competition take over fund',
                        '24': 'trading contest tickets',
                        '25': 'return of trading contest tickets',
                        '26': 'experience expired recall',
                        '50': 'test register gift',
                        '51': 'register gift',
                        '52': 'deposit gift',
                        '53': 'trading volume gift',
                        '54': 'awards gift',
                        '55': 'trading volume gift',
                        '56': 'awards gift expire',
                        '201': 'open positions',
                        '202': 'close positions',
                        '203': 'take over positions',
                        '204': 'trading competition take over positions',
                        '205': 'one way open long',
                        '206': 'one way open short',
                        '207': 'one way close long',
                        '208': 'one way close short',
                        '301': 'coupon deduction service charge',
                        '302': 'experience deduction',
                        '303': 'experience expired'
                    };
                    return this.safeString(types, type, type);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //     [
                    //         {
                    //             "type": 3,
                    //             "changeAmount": "0.00434664",
                    //             "isIn": 0,
                    //             "beforeAmount": "30.53353135",
                    //             "beforeFreezeAmount": "21.547",
                    //             "createTime": "1646121604997",
                    //             "available": "30.52918471",
                    //             "unit": "usdt",
                    //             "symbol": "BTC_USDT"
                    //         },
                    //     ],
                    //
                    const timestamp = this.safeString(item, 'createTime');
                    let direction = undefined;
                    const changeDirection = this.safeNumber(item, 'isIn');
                    if (changeDirection === 1) direction = 'increase';
                    else direction = 'reduce';
                    let fee = undefined;
                    const feeCost = this.safeNumber(item, 'fee');
                    if (feeCost !== undefined) fee = {
                        'cost': feeCost,
                        'currency': this.safeCurrencyCode(this.safeString(item, 'unit'))
                    };
                    return {
                        'id': this.safeString(item, 'id'),
                        'info': item,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'direction': direction,
                        'account': this.safeString(item, 'userId'),
                        'referenceId': undefined,
                        'referenceAccount': undefined,
                        'type': this.parseLedgerEntryType(this.safeInteger(item, 'type')),
                        'currency': this.safeCurrencyCode(this.safeString(item, 'unit')),
                        'amount': this.safeNumber(item, 'changeAmount'),
                        'before': this.safeNumber(item, 'beforeAmount'),
                        'after': this.safeNumber(item, 'available'),
                        'status': undefined,
                        'fee': fee
                    };
                }
                async fetchLedger(code, since, limit, params = {}) {
                    if (code === undefined) throw new ArgumentsRequired1(this.id + ' fetchLedger() requires a code argument');
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'futuresAccountType': 1
                    };
                    if (code !== undefined) request['currencyName'] = currency['id'];
                    if (since !== undefined) request['startTime'] = since;
                    if (limit !== undefined) request['pageSize'] = limit;
                    const response = await this.contractV2PrivateGetFundGetBill(this.extend(request, params));
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": {
                    //             "list": [
                    //                 {
                    //                     "type": 3,
                    //                     "changeAmount": "0.00434664",
                    //                     "isIn": 0,
                    //                     "beforeAmount": "30.53353135",
                    //                     "beforeFreezeAmount": "21.547",
                    //                     "createTime": "1646121604997",
                    //                     "available": "30.52918471",
                    //                     "unit": "usdt",
                    //                     "symbol": "BTC_USDT"
                    //                 },
                    //             ],
                    //             "pageNum": 1,
                    //             "pageSize": 10
                    //         },
                    //         "desc": "操作成功"
                    //     }
                    //
                    const data = this.safeValue(response, 'data', {});
                    const list = this.safeValue(data, 'list', []);
                    return this.parseLedger(list, currency, since, limit);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const [marketType, query] = this.handleMarketTypeAndParams('transfer', undefined, params);
                    const currency = this.currency(code);
                    const margin = marketType === 'margin';
                    const swap = marketType === 'swap';
                    let side = undefined;
                    let marginMethod = undefined;
                    const amountToPrecision = this.currencyToPrecision(code, amount);
                    const request = {
                        'amount': amountToPrecision
                    };
                    if (swap) {
                        if (fromAccount === 'spot' || toAccount === 'future') side = 1;
                        else side = 0;
                        request['currencyName'] = currency['id'];
                        request['clientId'] = this.safeString(params, 'clientId');
                        request['side'] = side;
                    } else {
                        const defaultMargin = margin ? 'isolated' : 'cross';
                        const marginMode = this.safeString2(this.options, 'defaultMarginMode', 'marginMode', defaultMargin);
                        if (marginMode === 'isolated') {
                            if (fromAccount === 'spot' || toAccount === 'isolated') marginMethod = 'spotV1PrivateGetTransferInLever';
                            else marginMethod = 'spotV1PrivateGetTransferOutLever';
                            request['marketName'] = this.safeString(params, 'marketName');
                        } else if (marginMode === 'cross') {
                            if (fromAccount === 'spot' || toAccount === 'cross') marginMethod = 'spotV1PrivateGetTransferInCross';
                            else marginMethod = 'spotV1PrivateGetTransferOutCross';
                        }
                        request['coin'] = currency['id'];
                    }
                    const method = this.getSupportedMapping(marketType, {
                        'swap': 'contractV2PrivatePostFundTransferFund',
                        'margin': marginMethod
                    });
                    const response = await this[method](this.extend(request, query));
                    //
                    // Swap
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": "2sdfsdfsdf232342",
                    //         "desc": "Success"
                    //     }
                    //
                    // Margin
                    //
                    //     {
                    //         "code": 1000,
                    //         "message": "Success"
                    //     }
                    //
                    return this.extend(this.parseTransfer(response, currency), {
                        'amount': this.parseNumber(amountToPrecision),
                        'fromAccount': fromAccount,
                        'toAccount': toAccount
                    });
                }
                parseTransfer(transfer, currency) {
                    // response samples in 'transfer'
                    const timestamp = this.milliseconds();
                    return {
                        'id': this.safeString(transfer, 'data'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'currency': this.safeCurrencyCode(undefined, 'currency'),
                        'amount': undefined,
                        'fromAccount': undefined,
                        'toAccount': undefined,
                        'status': undefined
                    };
                }
                async modifyMarginHelper(symbol, amount, type, params = {}) {
                    if (params['positionsId'] === undefined) throw new ArgumentsRequired1(this.id + ' modifyMarginHelper() requires a positionsId argument in the params');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    amount = this.amountToPrecision(symbol, amount);
                    const position = this.safeString(params, 'positionsId');
                    const request = {
                        'positionsId': position,
                        'amount': amount,
                        'type': type,
                        'futuresAccountType': 1
                    };
                    const response = await this.contractV2PrivatePostPositionsUpdateMargin(this.extend(request, params));
                    //
                    //     {
                    //         "code": 10000,
                    //         "data": {
                    //             "amount": "0.002",
                    //             "appendAmount": "0",
                    //             "avgPrice": "43927.23",
                    //             "bankruptcyPrice": "41730.86",
                    //             "createTime": "1646208695609",
                    //             "freezeAmount": "0",
                    //             "id": "6900781818669377576",
                    //             "keyMark": "6896693805014120448-100-1-",
                    //             "lastAppendAmount": "0",
                    //             "lastTime": "1646209235505",
                    //             "leverage": 20,
                    //             "liquidateLevel": 1,
                    //             "liquidatePrice": "41898.46",
                    //             "maintainMargin": "0",
                    //             "margin": "4.392723",
                    //             "marginAppendCount": 0,
                    //             "marginBalance": "0",
                    //             "marginMode": 1,
                    //             "marginRate": "0",
                    //             "marketId": "100",
                    //             "marketName": "BTC_USDT",
                    //             "modifyTime": "1646209235505",
                    //             "nominalValue": "87.88828",
                    //             "originAppendAmount": "0",
                    //             "originId": "6904699716827818029",
                    //             "positionsMode": 2,
                    //             "sellerCurrencyId": "1",
                    //             "side": 1,
                    //             "status": 1,
                    //             "unrealizedPnl": "0.03382",
                    //             "usable": true,
                    //             "userId": "6896693805014120448"
                    //         },
                    //         "desc":"操作成功"
                    //     }
                    //
                    return this.extend(this.parseModifyMargin(response, market), {
                        'amount': this.parseNumber(amount)
                    });
                }
                parseModifyMargin(data, market) {
                    const innerData = this.safeValue(data, 'data', {});
                    const sideRaw = this.safeInteger(innerData, 'side');
                    const side = sideRaw === 1 ? 'add' : 'reduce';
                    const statusCode = this.safeInteger(innerData, 'status');
                    const status = statusCode === 1 ? 'ok' : 'failed';
                    return {
                        'info': data,
                        'type': side,
                        'amount': undefined,
                        'code': market['quote'],
                        'symbol': market['symbol'],
                        'status': status
                    };
                }
                async addMargin(symbol, amount, params = {}) {
                    if (params['positionsId'] === undefined) throw new ArgumentsRequired1(this.id + ' addMargin() requires a positionsId argument in the params');
                    return await this.modifyMarginHelper(symbol, amount, 1, params);
                }
                async reduceMargin(symbol, amount, params = {}) {
                    if (params['positionsId'] === undefined) throw new ArgumentsRequired1(this.id + ' reduceMargin() requires a positionsId argument in the params');
                    return await this.modifyMarginHelper(symbol, amount, 0, params);
                }
                async fetchBorrowRate(code, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'coin': currency['id']
                    };
                    const response = await this.spotV1PrivateGetGetLoans(this.extend(request, params));
                    //
                    //     {
                    //         code: '1000',
                    //         message: '操作成功',
                    //         result: [
                    //             {
                    //                 interestRateOfDay: '0.0005',
                    //                 repaymentDay: '30',
                    //                 amount: '148804.4841',
                    //                 balance: '148804.4841',
                    //                 rateOfDayShow: '0.05 %',
                    //                 coinName: 'USDT',
                    //                 lowestAmount: '0.01'
                    //             },
                    //         ]
                    //     }
                    //
                    const timestamp = this.milliseconds();
                    const data = this.safeValue(response, 'result', []);
                    const rate = this.safeValue(data, 0, {});
                    return {
                        'currency': this.safeCurrencyCode(this.safeString(rate, 'coinName')),
                        'rate': this.safeNumber(rate, 'interestRateOfDay'),
                        'period': this.safeNumber(rate, 'repaymentDay'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'info': rate
                    };
                }
                async fetchBorrowRates(params = {}) {
                    if (params['coin'] === undefined) throw new ArgumentsRequired1(this.id + ' fetchBorrowRates() requires a coin argument in the params');
                    await this.loadMarkets();
                    const currency = this.currency(this.safeString(params, 'coin'));
                    const request = {
                        'coin': currency['id']
                    };
                    const response = await this.spotV1PrivateGetGetLoans(this.extend(request, params));
                    //
                    //     {
                    //         code: '1000',
                    //         message: '操作成功',
                    //         result: [
                    //             {
                    //                 interestRateOfDay: '0.0005',
                    //                 repaymentDay: '30',
                    //                 amount: '148804.4841',
                    //                 balance: '148804.4841',
                    //                 rateOfDayShow: '0.05 %',
                    //                 coinName: 'USDT',
                    //                 lowestAmount: '0.01'
                    //             },
                    //         ]
                    //     }
                    //
                    const timestamp = this.milliseconds();
                    const data = this.safeValue(response, 'result');
                    const rates = [];
                    for(let i = 0; i < data.length; i++){
                        const entry = data[i];
                        rates.push({
                            'currency': this.safeCurrencyCode(this.safeString(entry, 'coinName')),
                            'rate': this.safeNumber(entry, 'interestRateOfDay'),
                            'period': this.safeNumber(entry, 'repaymentDay'),
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'info': entry
                        });
                    }
                    return rates;
                }
                nonce() {
                    return this.milliseconds();
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    const [section, version, access] = api;
                    let url = this.implodeHostname(this.urls['api'][section][version][access]);
                    if (access === 'public') {
                        if (path === 'getFeeInfo') url = this.implodeHostname(this.urls['api'][section][version]['private']) + '/' + path;
                        else url += '/' + version + '/' + path;
                        if (Object.keys(params).length) url += '?' + this.urlencode(params);
                    } else if (section === 'contract') {
                        const timestamp = this.milliseconds();
                        const iso8601 = this.iso8601(timestamp);
                        let signedString = iso8601 + method + '/Server/api/' + version + '/' + path;
                        params = this.keysort(params);
                        headers = {
                            'ZB-APIKEY': this.apiKey,
                            'ZB-TIMESTAMP': iso8601
                        };
                        url += '/' + version + '/' + path;
                        if (method === 'POST') {
                            headers['Content-Type'] = 'application/json';
                            body = this.json(params);
                            signedString += this.urlencode(params);
                        } else if (Object.keys(params).length) {
                            const query = this.urlencode(params);
                            url += '?' + query;
                            signedString += query;
                        }
                        const secret = this.hash(this.encode(this.secret), 'sha1');
                        const signature = this.hmac(this.encode(signedString), this.encode(secret), 'sha256', 'base64');
                        headers['ZB-SIGN'] = signature;
                    } else {
                        let query = this.keysort(this.extend({
                            'method': path,
                            'accesskey': this.apiKey
                        }, params));
                        const nonce = this.nonce();
                        query = this.keysort(query);
                        const auth = this.rawencode(query);
                        const secret = this.hash(this.encode(this.secret), 'sha1');
                        const signature = this.hmac(this.encode(auth), this.encode(secret), 'md5');
                        const suffix = 'sign=' + signature + '&reqTime=' + nonce.toString();
                        url += '/' + path + '?' + auth + '&' + suffix;
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if (body[0] === '{') {
                        const feedback = this.id + ' ' + body;
                        this.throwBroadlyMatchedException(this.exceptions['broad'], body, feedback);
                        if ('code' in response) {
                            const code = this.safeString(response, 'code');
                            this.throwExactlyMatchedException(this.exceptions['exact'], code, feedback);
                            if (code !== '1000' && code !== '10000') throw new ExchangeError1(feedback);
                        }
                        // special case for {"result":false,"message":"服务端忙碌"} (a "Busy Server" reply)
                        const result = this.safeValue(response, 'result');
                        if (result !== undefined) {
                            if (!result) {
                                const message = this.safeString(response, 'message');
                                if (message === "\u670D\u52A1\u7AEF\u5FD9\u788C") throw new ExchangeNotAvailable(feedback);
                                else throw new ExchangeError1(feedback);
                            }
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/Precise": 6,
            "./base/errors": 8
        }
    ],
    175: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const ndax = require1('./ndax.js');
            //  ---------------------------------------------------------------------------
            module.exports = class zipmex extends ndax {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'zipmex',
                        'name': 'Zipmex',
                        'countries': [
                            'AU',
                            'SG',
                            'TH',
                            'ID'
                        ],
                        'certified': false,
                        'pro': true,
                        'urls': {
                            'logo': 'https://user-images.githubusercontent.com/1294454/146103275-c39a34d9-68a4-4cd2-b1f1-c684548d311b.jpg',
                            'test': undefined,
                            'api': {
                                'public': 'https://apws.zipmex.com:8443/AP',
                                'private': 'https://apws.zipmex.com:8443/AP'
                            },
                            'www': 'https://zipmex.com/',
                            'referral': 'https://trade.zipmex.com/global/accounts/sign-up?aff=KLm7HyCsvN',
                            'fees': 'https://zipmex.com/fee-schedule'
                        },
                        'fees': {
                            'trading': {
                                'tierBased': true,
                                'percentage': true,
                                'taker': this.parseNumber('0.002'),
                                'maker': this.parseNumber('0.002')
                            }
                        }
                    });
                }
            };
        },
        {
            "./ndax.js": 107
        }
    ],
    176: [
        function(require1, module, exports) {
            'use strict';
            //  ---------------------------------------------------------------------------
            const Exchange = require1('./base/Exchange');
            const { InvalidNonce: InvalidNonce, InsufficientFunds: InsufficientFunds, AuthenticationError: AuthenticationError, InvalidOrder: InvalidOrder, ExchangeError: ExchangeError1, OrderNotFound: OrderNotFound, AccountSuspended: AccountSuspended, BadSymbol: BadSymbol, OrderImmediatelyFillable: OrderImmediatelyFillable, RateLimitExceeded: RateLimitExceeded, OnMaintenance: OnMaintenance, PermissionDenied: PermissionDenied } = require1('./base/errors');
            //  ---------------------------------------------------------------------------
            module.exports = class zonda extends Exchange {
                describe() {
                    return this.deepExtend(super.describe(), {
                        'id': 'zonda',
                        'name': 'Zonda',
                        'countries': [
                            'EE'
                        ],
                        'rateLimit': 1000,
                        'has': {
                            'CORS': true,
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'addMargin': false,
                            'cancelOrder': true,
                            'createOrder': true,
                            'createReduceOnlyOrder': false,
                            'fetchBalance': true,
                            'fetchBorrowRate': false,
                            'fetchBorrowRateHistories': false,
                            'fetchBorrowRateHistory': false,
                            'fetchBorrowRates': false,
                            'fetchBorrowRatesPerSymbol': false,
                            'fetchFundingHistory': false,
                            'fetchFundingRate': false,
                            'fetchFundingRateHistory': false,
                            'fetchFundingRates': false,
                            'fetchIndexOHLCV': false,
                            'fetchLedger': true,
                            'fetchLeverage': false,
                            'fetchLeverageTiers': false,
                            'fetchMarkets': true,
                            'fetchMarkOHLCV': false,
                            'fetchMyTrades': true,
                            'fetchOHLCV': true,
                            'fetchOpenOrders': true,
                            'fetchOrderBook': true,
                            'fetchPosition': false,
                            'fetchPositions': false,
                            'fetchPositionsRisk': false,
                            'fetchPremiumIndexOHLCV': false,
                            'fetchTicker': true,
                            'fetchTrades': true,
                            'fetchTradingFee': false,
                            'fetchTradingFees': false,
                            'reduceMargin': false,
                            'setLeverage': false,
                            'setMarginMode': false,
                            'setPositionMode': false,
                            'transfer': true,
                            'withdraw': true
                        },
                        'timeframes': {
                            '1m': '60',
                            '3m': '180',
                            '5m': '300',
                            '15m': '900',
                            '30m': '1800',
                            '1h': '3600',
                            '2h': '7200',
                            '4h': '14400',
                            '6h': '21600',
                            '12h': '43200',
                            '1d': '86400',
                            '3d': '259200',
                            '1w': '604800'
                        },
                        'hostname': 'zonda.exchange',
                        'urls': {
                            'referral': 'https://auth.zondaglobal.com/ref/jHlbB4mIkdS1',
                            'logo': 'https://user-images.githubusercontent.com/1294454/159202310-a0e38007-5e7c-4ba9-a32f-c8263a0291fe.jpg',
                            'www': 'https://zondaglobal.com',
                            'api': {
                                'public': 'https://{hostname}/API/Public',
                                'private': 'https://{hostname}/API/Trading/tradingApi.php',
                                'v1_01Public': 'https://api.{hostname}/rest',
                                'v1_01Private': 'https://api.{hostname}/rest'
                            },
                            'doc': [
                                'https://docs.zonda.exchange/',
                                'https://github.com/BitBayNet/API'
                            ],
                            'support': 'https://zondaglobal.com/en/helpdesk/zonda-exchange',
                            'fees': 'https://zondaglobal.com/legal/zonda-exchange/fees'
                        },
                        'api': {
                            'public': {
                                'get': [
                                    '{id}/all',
                                    '{id}/market',
                                    '{id}/orderbook',
                                    '{id}/ticker',
                                    '{id}/trades'
                                ]
                            },
                            'private': {
                                'post': [
                                    'info',
                                    'trade',
                                    'cancel',
                                    'orderbook',
                                    'orders',
                                    'transfer',
                                    'withdraw',
                                    'history',
                                    'transactions'
                                ]
                            },
                            'v1_01Public': {
                                'get': [
                                    'trading/ticker',
                                    'trading/ticker/{symbol}',
                                    'trading/stats',
                                    'trading/stats/{symbol}',
                                    'trading/orderbook/{symbol}',
                                    'trading/transactions/{symbol}',
                                    'trading/candle/history/{symbol}/{resolution}'
                                ]
                            },
                            'v1_01Private': {
                                'get': [
                                    'payments/withdrawal/{detailId}',
                                    'payments/deposit/{detailId}',
                                    'trading/offer',
                                    'trading/config/{symbol}',
                                    'trading/history/transactions',
                                    'balances/BITBAY/history',
                                    'balances/BITBAY/balance',
                                    'fiat_cantor/rate/{baseId}/{quoteId}',
                                    'fiat_cantor/history'
                                ],
                                'post': [
                                    'trading/offer/{symbol}',
                                    'trading/config/{symbol}',
                                    'balances/BITBAY/balance',
                                    'balances/BITBAY/balance/transfer/{source}/{destination}',
                                    'fiat_cantor/exchange'
                                ],
                                'delete': [
                                    'trading/offer/{symbol}/{id}/{side}/{price}'
                                ],
                                'put': [
                                    'balances/BITBAY/balance/{id}'
                                ]
                            }
                        },
                        'fees': {
                            'trading': {
                                'maker': this.parseNumber('0.0'),
                                'taker': this.parseNumber('0.001'),
                                'percentage': true,
                                'tierBased': false
                            },
                            'fiat': {
                                'maker': 0.003,
                                'taker': 0.0043,
                                'percentage': true,
                                'tierBased': true,
                                'tiers': {
                                    'taker': [
                                        [
                                            0.0043,
                                            0
                                        ],
                                        [
                                            0.0042,
                                            1250
                                        ],
                                        [
                                            0.0041,
                                            3750
                                        ],
                                        [
                                            0.0040,
                                            7500
                                        ],
                                        [
                                            0.0039,
                                            10000
                                        ],
                                        [
                                            0.0038,
                                            15000
                                        ],
                                        [
                                            0.0037,
                                            20000
                                        ],
                                        [
                                            0.0036,
                                            25000
                                        ],
                                        [
                                            0.0035,
                                            37500
                                        ],
                                        [
                                            0.0034,
                                            50000
                                        ],
                                        [
                                            0.0033,
                                            75000
                                        ],
                                        [
                                            0.0032,
                                            100000
                                        ],
                                        [
                                            0.0031,
                                            150000
                                        ],
                                        [
                                            0.0030,
                                            200000
                                        ],
                                        [
                                            0.0029,
                                            250000
                                        ],
                                        [
                                            0.0028,
                                            375000
                                        ],
                                        [
                                            0.0027,
                                            500000
                                        ],
                                        [
                                            0.0026,
                                            625000
                                        ],
                                        [
                                            0.0025,
                                            875000
                                        ]
                                    ],
                                    'maker': [
                                        [
                                            0.0030,
                                            0
                                        ],
                                        [
                                            0.0029,
                                            1250
                                        ],
                                        [
                                            0.0028,
                                            3750
                                        ],
                                        [
                                            0.0028,
                                            7500
                                        ],
                                        [
                                            0.0027,
                                            10000
                                        ],
                                        [
                                            0.0026,
                                            15000
                                        ],
                                        [
                                            0.0025,
                                            20000
                                        ],
                                        [
                                            0.0025,
                                            25000
                                        ],
                                        [
                                            0.0024,
                                            37500
                                        ],
                                        [
                                            0.0023,
                                            50000
                                        ],
                                        [
                                            0.0023,
                                            75000
                                        ],
                                        [
                                            0.0022,
                                            100000
                                        ],
                                        [
                                            0.0021,
                                            150000
                                        ],
                                        [
                                            0.0021,
                                            200000
                                        ],
                                        [
                                            0.0020,
                                            250000
                                        ],
                                        [
                                            0.0019,
                                            375000
                                        ],
                                        [
                                            0.0018,
                                            500000
                                        ],
                                        [
                                            0.0018,
                                            625000
                                        ],
                                        [
                                            0.0017,
                                            875000
                                        ]
                                    ]
                                }
                            },
                            'funding': {
                                'withdraw': {}
                            }
                        },
                        'options': {
                            'fiatCurrencies': [
                                'EUR',
                                'USD',
                                'GBP',
                                'PLN'
                            ],
                            'transfer': {
                                'fillResponseFromRequest': true
                            }
                        },
                        'exceptions': {
                            '400': ExchangeError1,
                            '401': InvalidOrder,
                            '402': InvalidOrder,
                            '403': InvalidOrder,
                            '404': InvalidOrder,
                            '405': InvalidOrder,
                            '406': InsufficientFunds,
                            // code 407 not specified are not specified in their docs
                            '408': InvalidOrder,
                            '501': AuthenticationError,
                            '502': AuthenticationError,
                            '503': InvalidNonce,
                            '504': ExchangeError1,
                            '505': AuthenticationError,
                            '506': AccountSuspended,
                            // codes 507 and 508 are not specified in their docs
                            '509': ExchangeError1,
                            '510': BadSymbol,
                            'FUNDS_NOT_SUFFICIENT': InsufficientFunds,
                            'OFFER_FUNDS_NOT_EXCEEDING_MINIMUMS': InvalidOrder,
                            'OFFER_NOT_FOUND': OrderNotFound,
                            'OFFER_WOULD_HAVE_BEEN_PARTIALLY_FILLED': OrderImmediatelyFillable,
                            'ACTION_LIMIT_EXCEEDED': RateLimitExceeded,
                            'UNDER_MAINTENANCE': OnMaintenance,
                            'REQUEST_TIMESTAMP_TOO_OLD': InvalidNonce,
                            'PERMISSIONS_NOT_SUFFICIENT': PermissionDenied
                        },
                        'commonCurrencies': {
                            'GGC': 'Global Game Coin'
                        }
                    });
                }
                async fetchMarkets(params = {}) {
                    const response = await this.v1_01PublicGetTradingTicker(params);
                    const fiatCurrencies = this.safeValue(this.options, 'fiatCurrencies', []);
                    //
                    //     {
                    //         status: 'Ok',
                    //         items: {
                    //             'BSV-USD': {
                    //                 market: {
                    //                     code: 'BSV-USD',
                    //                     first: { currency: 'BSV', minOffer: '0.00035', scale: 8 },
                    //                     second: { currency: 'USD', minOffer: '5', scale: 2 }
                    //                 },
                    //                 time: '1557569762154',
                    //                 highestBid: '52.31',
                    //                 lowestAsk: '62.99',
                    //                 rate: '63',
                    //                 previousRate: '51.21',
                    //             },
                    //         },
                    //     }
                    //
                    const result = [];
                    const items = this.safeValue(response, 'items');
                    const keys = Object.keys(items);
                    for(let i = 0; i < keys.length; i++){
                        const id = keys[i];
                        const item = items[id];
                        const market = this.safeValue(item, 'market', {});
                        const first = this.safeValue(market, 'first', {});
                        const second = this.safeValue(market, 'second', {});
                        const baseId = this.safeString(first, 'currency');
                        const quoteId = this.safeString(second, 'currency');
                        const base = this.safeCurrencyCode(baseId);
                        const quote = this.safeCurrencyCode(quoteId);
                        let fees = this.safeValue(this.fees, 'trading', {});
                        if (this.inArray(base, fiatCurrencies) || this.inArray(quote, fiatCurrencies)) fees = this.safeValue(this.fees, 'fiat', {});
                        // todo: check that the limits have ben interpreted correctly
                        // todo: parse the fees page
                        result.push({
                            'id': id,
                            'symbol': base + '/' + quote,
                            'base': base,
                            'quote': quote,
                            'settle': undefined,
                            'baseId': baseId,
                            'quoteId': quoteId,
                            'settleId': undefined,
                            'type': 'spot',
                            'spot': true,
                            'margin': false,
                            'swap': false,
                            'future': false,
                            'option': false,
                            'active': undefined,
                            'contract': false,
                            'linear': undefined,
                            'inverse': undefined,
                            'taker': this.safeNumber(fees, 'taker'),
                            'maker': this.safeNumber(fees, 'maker'),
                            'contractSize': undefined,
                            'expiry': undefined,
                            'expiryDatetime': undefined,
                            'optionType': undefined,
                            'strike': undefined,
                            'precision': {
                                'amount': this.safeInteger(first, 'scale'),
                                'price': this.safeInteger(second, 'scale')
                            },
                            'limits': {
                                'leverage': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'amount': {
                                    'min': this.safeNumber(first, 'minOffer'),
                                    'max': undefined
                                },
                                'price': {
                                    'min': undefined,
                                    'max': undefined
                                },
                                'cost': {
                                    'min': this.safeNumber(second, 'minOffer'),
                                    'max': undefined
                                }
                            },
                            'info': item
                        });
                    }
                    return result;
                }
                async fetchOpenOrders(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    const response = await this.v1_01PrivateGetTradingOffer(this.extend(request, params));
                    const items = this.safeValue(response, 'items', []);
                    return this.parseOrders(items, undefined, since, limit, {
                        'status': 'open'
                    });
                }
                parseOrder(order, market) {
                    //
                    //     {
                    //         market: 'ETH-EUR',
                    //         offerType: 'Sell',
                    //         id: '93d3657b-d616-11e9-9248-0242ac110005',
                    //         currentAmount: '0.04',
                    //         lockedAmount: '0.04',
                    //         rate: '280',
                    //         startAmount: '0.04',
                    //         time: '1568372806924',
                    //         postOnly: false,
                    //         hidden: false,
                    //         mode: 'limit',
                    //         receivedAmount: '0.0',
                    //         firstBalanceId: '5b816c3e-437c-4e43-9bef-47814ae7ebfc',
                    //         secondBalanceId: 'ab43023b-4079-414c-b340-056e3430a3af'
                    //     }
                    //
                    const marketId = this.safeString(order, 'market');
                    const symbol = this.safeSymbol(marketId, market, '-');
                    const timestamp = this.safeInteger(order, 'time');
                    const amount = this.safeString(order, 'startAmount');
                    const remaining = this.safeString(order, 'currentAmount');
                    const postOnly = this.safeValue(order, 'postOnly');
                    return this.safeOrder({
                        'id': this.safeString(order, 'id'),
                        'clientOrderId': undefined,
                        'info': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': undefined,
                        'symbol': symbol,
                        'type': this.safeString(order, 'mode'),
                        'timeInForce': undefined,
                        'postOnly': postOnly,
                        'side': this.safeStringLower(order, 'offerType'),
                        'price': this.safeString(order, 'rate'),
                        'stopPrice': undefined,
                        'amount': amount,
                        'cost': undefined,
                        'filled': undefined,
                        'remaining': remaining,
                        'average': undefined,
                        'fee': undefined,
                        'trades': undefined
                    }, market);
                }
                async fetchMyTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {};
                    if (symbol) {
                        const markets = [
                            this.marketId(symbol)
                        ];
                        request['markets'] = markets;
                    }
                    const query = {
                        'query': this.json(this.extend(request, params))
                    };
                    const response = await this.v1_01PrivateGetTradingHistoryTransactions(query);
                    //
                    //     {
                    //         status: 'Ok',
                    //         totalRows: '67',
                    //         items: [
                    //             {
                    //                 id: 'b54659a0-51b5-42a0-80eb-2ac5357ccee2',
                    //                 market: 'BTC-EUR',
                    //                 time: '1541697096247',
                    //                 amount: '0.00003',
                    //                 rate: '4341.44',
                    //                 initializedBy: 'Sell',
                    //                 wasTaker: false,
                    //                 userAction: 'Buy',
                    //                 offerId: 'bd19804a-6f89-4a69-adb8-eb078900d006',
                    //                 commissionValue: null
                    //             },
                    //         ]
                    //     }
                    //
                    const items = this.safeValue(response, 'items');
                    const result = this.parseTrades(items, undefined, since, limit);
                    if (symbol === undefined) return result;
                    return this.filterBySymbol(result, symbol);
                }
                parseBalance(response) {
                    const balances = this.safeValue(response, 'balances');
                    if (balances === undefined) throw new ExchangeError1(this.id + ' empty balance response ' + this.json(response));
                    const result = {
                        'info': response
                    };
                    for(let i = 0; i < balances.length; i++){
                        const balance = balances[i];
                        const currencyId = this.safeString(balance, 'currency');
                        const code = this.safeCurrencyCode(currencyId);
                        const account = this.account();
                        account['used'] = this.safeString(balance, 'lockedFunds');
                        account['free'] = this.safeString(balance, 'availableFunds');
                        result[code] = account;
                    }
                    return this.safeBalance(result);
                }
                async fetchBalance(params = {}) {
                    await this.loadMarkets();
                    const response = await this.v1_01PrivateGetBalancesBITBAYBalance(params);
                    return this.parseBalance(response);
                }
                async fetchOrderBook(symbol, limit, params = {}) {
                    await this.loadMarkets();
                    const request = {
                        'symbol': this.marketId(symbol)
                    };
                    const response = await this.v1_01PublicGetTradingOrderbookSymbol(this.extend(request, params));
                    //
                    //     {
                    //         "status":"Ok",
                    //         "sell":[
                    //             {"ra":"43988.93","ca":"0.00100525","sa":"0.00100525","pa":"0.00100525","co":1},
                    //             {"ra":"43988.94","ca":"0.00114136","sa":"0.00114136","pa":"0.00114136","co":1},
                    //             {"ra":"43989","ca":"0.010578","sa":"0.010578","pa":"0.010578","co":1},
                    //         ],
                    //         "buy":[
                    //             {"ra":"42157.33","ca":"2.83147881","sa":"2.83147881","pa":"2.83147881","co":2},
                    //             {"ra":"42096.0","ca":"0.00011878","sa":"0.00011878","pa":"0.00011878","co":1},
                    //             {"ra":"42022.0","ca":"0.00011899","sa":"0.00011899","pa":"0.00011899","co":1},
                    //         ],
                    //         "timestamp":"1642299886122",
                    //         "seqNo":"27641254"
                    //     }
                    //
                    const rawBids = this.safeValue(response, 'buy', []);
                    const rawAsks = this.safeValue(response, 'sell', []);
                    const timestamp = this.safeInteger(response, 'timestamp');
                    return {
                        'symbol': symbol,
                        'bids': this.parseBidsAsks(rawBids, 'ra', 'ca'),
                        'asks': this.parseBidsAsks(rawAsks, 'ra', 'ca'),
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'nonce': this.safeInteger(response, 'seqNo')
                    };
                }
                parseTicker(ticker, market) {
                    //
                    //     {
                    //         m: 'ETH-PLN',
                    //         h: '13485.13',
                    //         l: '13100.01',
                    //         v: '126.10710939',
                    //         r24h: '13332.72'
                    //       }
                    //
                    const open = this.safeString(ticker, 'r24h');
                    const high = this.safeString(ticker, 'h');
                    const low = this.safeString(ticker, 'l');
                    const volume = this.safeString(ticker, 'v');
                    const marketId = this.safeString(ticker, 'm');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    return this.safeTicker({
                        'symbol': symbol,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'high': high,
                        'low': low,
                        'bid': undefined,
                        'bidVolume': undefined,
                        'ask': undefined,
                        'askVolume': undefined,
                        'vwap': undefined,
                        'open': open,
                        'close': undefined,
                        'last': undefined,
                        'previousClose': undefined,
                        'change': undefined,
                        'percentage': undefined,
                        'average': undefined,
                        'baseVolume': volume,
                        'quoteVolume': undefined,
                        'info': ticker
                    }, market, false);
                }
                async fetchTicker(symbol, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const request = {
                        'symbol': market['id']
                    };
                    const response = await this.v1_01PublicGetTradingStatsSymbol(this.extend(request, params));
                    //
                    //     {
                    //       status: 'Ok',
                    //       stats: {
                    //         m: 'ETH-PLN',
                    //         h: '13485.13',
                    //         l: '13100.01',
                    //         v: '126.10710939',
                    //         r24h: '13332.72'
                    //       }
                    //     }
                    //
                    const stats = this.safeValue(response, 'stats');
                    return this.parseTicker(stats, market);
                }
                async fetchLedger(code, since, limit, params = {}) {
                    const balanceCurrencies = [];
                    if (code !== undefined) {
                        const currency = this.currency(code);
                        balanceCurrencies.push(currency['id']);
                    }
                    let request = {
                        'balanceCurrencies': balanceCurrencies
                    };
                    if (since !== undefined) request['fromTime'] = since;
                    if (limit !== undefined) request['limit'] = limit;
                    request = this.extend(request, params);
                    const response = await this.v1_01PrivateGetBalancesBITBAYHistory({
                        'query': this.json(request)
                    });
                    const items = response['items'];
                    return this.parseLedger(items, undefined, since, limit);
                }
                parseLedgerEntry(item, currency) {
                    //
                    //    FUNDS_MIGRATION
                    //    {
                    //      "historyId": "84ea7a29-7da5-4de5-b0c0-871e83cad765",
                    //      "balance": {
                    //        "id": "821ec166-cb88-4521-916c-f4eb44db98df",
                    //        "currency": "LTC",
                    //        "type": "CRYPTO",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "LTC"
                    //      },
                    //      "detailId": null,
                    //      "time": 1506128252968,
                    //      "type": "FUNDS_MIGRATION",
                    //      "value": 0.0009957,
                    //      "fundsBefore": { "total": 0, "available": 0, "locked": 0 },
                    //      "fundsAfter": { "total": 0.0009957, "available": 0.0009957, "locked": 0 },
                    //      "change": { "total": 0.0009957, "available": 0.0009957, "locked": 0 }
                    //    }
                    //
                    //    CREATE_BALANCE
                    //    {
                    //      "historyId": "d0fabd8d-9107-4b5e-b9a6-3cab8af70d49",
                    //      "balance": {
                    //        "id": "653ffcf2-3037-4ebe-8e13-d5ea1a01d60d",
                    //        "currency": "BTG",
                    //        "type": "CRYPTO",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "BTG"
                    //      },
                    //      "detailId": null,
                    //      "time": 1508895244751,
                    //      "type": "CREATE_BALANCE",
                    //      "value": 0,
                    //      "fundsBefore": { "total": null, "available": null, "locked": null },
                    //      "fundsAfter": { "total": 0, "available": 0, "locked": 0 },
                    //      "change": { "total": 0, "available": 0, "locked": 0 }
                    //    }
                    //
                    //    BITCOIN_GOLD_FORK
                    //    {
                    //      "historyId": "2b4d52d3-611c-473d-b92c-8a8d87a24e41",
                    //      "balance": {
                    //        "id": "653ffcf2-3037-4ebe-8e13-d5ea1a01d60d",
                    //        "currency": "BTG",
                    //        "type": "CRYPTO",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "BTG"
                    //      },
                    //      "detailId": null,
                    //      "time": 1508895244778,
                    //      "type": "BITCOIN_GOLD_FORK",
                    //      "value": 0.00453512,
                    //      "fundsBefore": { "total": 0, "available": 0, "locked": 0 },
                    //      "fundsAfter": { "total": 0.00453512, "available": 0.00453512, "locked": 0 },
                    //      "change": { "total": 0.00453512, "available": 0.00453512, "locked": 0 }
                    //    }
                    //
                    //    ADD_FUNDS
                    //    {
                    //      "historyId": "3158236d-dae5-4a5d-81af-c1fa4af340fb",
                    //      "balance": {
                    //        "id": "3a7e7a1e-0324-49d5-8f59-298505ebd6c7",
                    //        "currency": "BTC",
                    //        "type": "CRYPTO",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "BTC"
                    //      },
                    //      "detailId": "8e83a960-e737-4380-b8bb-259d6e236faa",
                    //      "time": 1520631178816,
                    //      "type": "ADD_FUNDS",
                    //      "value": 0.628405,
                    //      "fundsBefore": { "total": 0.00453512, "available": 0.00453512, "locked": 0 },
                    //      "fundsAfter": { "total": 0.63294012, "available": 0.63294012, "locked": 0 },
                    //      "change": { "total": 0.628405, "available": 0.628405, "locked": 0 }
                    //    }
                    //
                    //    TRANSACTION_PRE_LOCKING
                    //    {
                    //      "historyId": "e7d19e0f-03b3-46a8-bc72-dde72cc24ead",
                    //      "balance": {
                    //        "id": "3a7e7a1e-0324-49d5-8f59-298505ebd6c7",
                    //        "currency": "BTC",
                    //        "type": "CRYPTO",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "BTC"
                    //      },
                    //      "detailId": null,
                    //      "time": 1520706403868,
                    //      "type": "TRANSACTION_PRE_LOCKING",
                    //      "value": -0.1,
                    //      "fundsBefore": { "total": 0.63294012, "available": 0.63294012, "locked": 0 },
                    //      "fundsAfter": { "total": 0.63294012, "available": 0.53294012, "locked": 0.1 },
                    //      "change": { "total": 0, "available": -0.1, "locked": 0.1 }
                    //    }
                    //
                    //    TRANSACTION_POST_OUTCOME
                    //    {
                    //      "historyId": "c4010825-231d-4a9c-8e46-37cde1f7b63c",
                    //      "balance": {
                    //        "id": "3a7e7a1e-0324-49d5-8f59-298505ebd6c7",
                    //        "currency": "BTC",
                    //        "type": "CRYPTO",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "BTC"
                    //      },
                    //      "detailId": "bf2876bc-b545-4503-96c8-ef4de8233876",
                    //      "time": 1520706404032,
                    //      "type": "TRANSACTION_POST_OUTCOME",
                    //      "value": -0.01771415,
                    //      "fundsBefore": { "total": 0.63294012, "available": 0.53294012, "locked": 0.1 },
                    //      "fundsAfter": { "total": 0.61522597, "available": 0.53294012, "locked": 0.08228585 },
                    //      "change": { "total": -0.01771415, "available": 0, "locked": -0.01771415 }
                    //    }
                    //
                    //    TRANSACTION_POST_INCOME
                    //    {
                    //      "historyId": "7f18b7af-b676-4125-84fd-042e683046f6",
                    //      "balance": {
                    //        "id": "ab43023b-4079-414c-b340-056e3430a3af",
                    //        "currency": "EUR",
                    //        "type": "FIAT",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "EUR"
                    //      },
                    //      "detailId": "f5fcb274-0cc7-4385-b2d3-bae2756e701f",
                    //      "time": 1520706404035,
                    //      "type": "TRANSACTION_POST_INCOME",
                    //      "value": 628.78,
                    //      "fundsBefore": { "total": 0, "available": 0, "locked": 0 },
                    //      "fundsAfter": { "total": 628.78, "available": 628.78, "locked": 0 },
                    //      "change": { "total": 628.78, "available": 628.78, "locked": 0 }
                    //    }
                    //
                    //    TRANSACTION_COMMISSION_OUTCOME
                    //    {
                    //      "historyId": "843177fa-61bc-4cbf-8be5-b029d856c93b",
                    //      "balance": {
                    //        "id": "ab43023b-4079-414c-b340-056e3430a3af",
                    //        "currency": "EUR",
                    //        "type": "FIAT",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "EUR"
                    //      },
                    //      "detailId": "f5fcb274-0cc7-4385-b2d3-bae2756e701f",
                    //      "time": 1520706404050,
                    //      "type": "TRANSACTION_COMMISSION_OUTCOME",
                    //      "value": -2.71,
                    //      "fundsBefore": { "total": 766.06, "available": 766.06, "locked": 0 },
                    //      "fundsAfter": { "total": 763.35,"available": 763.35, "locked": 0 },
                    //      "change": { "total": -2.71, "available": -2.71, "locked": 0 }
                    //    }
                    //
                    //    TRANSACTION_OFFER_COMPLETED_RETURN
                    //    {
                    //      "historyId": "cac69b04-c518-4dc5-9d86-e76e91f2e1d2",
                    //      "balance": {
                    //        "id": "3a7e7a1e-0324-49d5-8f59-298505ebd6c7",
                    //        "currency": "BTC",
                    //        "type": "CRYPTO",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "BTC"
                    //      },
                    //      "detailId": null,
                    //      "time": 1520714886425,
                    //      "type": "TRANSACTION_OFFER_COMPLETED_RETURN",
                    //      "value": 0.00000196,
                    //      "fundsBefore": { "total": 0.00941208, "available": 0.00941012, "locked": 0.00000196 },
                    //      "fundsAfter": { "total": 0.00941208, "available": 0.00941208, "locked": 0 },
                    //      "change": { "total": 0, "available": 0.00000196, "locked": -0.00000196 }
                    //    }
                    //
                    //    WITHDRAWAL_LOCK_FUNDS
                    //    {
                    //      "historyId": "03de2271-66ab-4960-a786-87ab9551fc14",
                    //      "balance": {
                    //        "id": "3a7e7a1e-0324-49d5-8f59-298505ebd6c7",
                    //        "currency": "BTC",
                    //        "type": "CRYPTO",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "BTC"
                    //      },
                    //      "detailId": "6ad3dc72-1d6d-4ec2-8436-ca43f85a38a6",
                    //      "time": 1522245654481,
                    //      "type": "WITHDRAWAL_LOCK_FUNDS",
                    //      "value": -0.8,
                    //      "fundsBefore": { "total": 0.8, "available": 0.8, "locked": 0 },
                    //      "fundsAfter": { "total": 0.8, "available": 0, "locked": 0.8 },
                    //      "change": { "total": 0, "available": -0.8, "locked": 0.8 }
                    //    }
                    //
                    //    WITHDRAWAL_SUBTRACT_FUNDS
                    //    {
                    //      "historyId": "b0308c89-5288-438d-a306-c6448b1a266d",
                    //      "balance": {
                    //        "id": "3a7e7a1e-0324-49d5-8f59-298505ebd6c7",
                    //        "currency": "BTC",
                    //        "type": "CRYPTO",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "BTC"
                    //      },
                    //      "detailId": "6ad3dc72-1d6d-4ec2-8436-ca43f85a38a6",
                    //      "time": 1522246526186,
                    //      "type": "WITHDRAWAL_SUBTRACT_FUNDS",
                    //      "value": -0.8,
                    //      "fundsBefore": { "total": 0.8, "available": 0, "locked": 0.8 },
                    //      "fundsAfter": { "total": 0, "available": 0, "locked": 0 },
                    //      "change": { "total": -0.8, "available": 0, "locked": -0.8 }
                    //    }
                    //
                    //    TRANSACTION_OFFER_ABORTED_RETURN
                    //    {
                    //      "historyId": "b1a3c075-d403-4e05-8f32-40512cdd88c0",
                    //      "balance": {
                    //        "id": "3a7e7a1e-0324-49d5-8f59-298505ebd6c7",
                    //        "currency": "BTC",
                    //        "type": "CRYPTO",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "BTC"
                    //      },
                    //      "detailId": null,
                    //      "time": 1522512298662,
                    //      "type": "TRANSACTION_OFFER_ABORTED_RETURN",
                    //      "value": 0.0564931,
                    //      "fundsBefore": { "total": 0.44951311, "available": 0.39302001, "locked": 0.0564931 },
                    //      "fundsAfter": { "total": 0.44951311, "available": 0.44951311, "locked": 0 },
                    //      "change": { "total": 0, "available": 0.0564931, "locked": -0.0564931 }
                    //    }
                    //
                    //    WITHDRAWAL_UNLOCK_FUNDS
                    //    {
                    //      "historyId": "0ed569a2-c330-482e-bb89-4cb553fb5b11",
                    //      "balance": {
                    //        "id": "3a7e7a1e-0324-49d5-8f59-298505ebd6c7",
                    //        "currency": "BTC",
                    //        "type": "CRYPTO",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "BTC"
                    //      },
                    //      "detailId": "0c7be256-c336-4111-bee7-4eb22e339700",
                    //      "time": 1527866360785,
                    //      "type": "WITHDRAWAL_UNLOCK_FUNDS",
                    //      "value": 0.05045,
                    //      "fundsBefore": { "total": 0.86001578, "available": 0.80956578, "locked": 0.05045 },
                    //      "fundsAfter": { "total": 0.86001578, "available": 0.86001578, "locked": 0 },
                    //      "change": { "total": 0, "available": 0.05045, "locked": -0.05045 }
                    //    }
                    //
                    //    TRANSACTION_COMMISSION_RETURN
                    //    {
                    //      "historyId": "07c89c27-46f1-4d7a-8518-b73798bf168a",
                    //      "balance": {
                    //        "id": "ab43023b-4079-414c-b340-056e3430a3af",
                    //        "currency": "EUR",
                    //        "type": "FIAT",
                    //        "userId": "a34d361d-7bad-49c1-888e-62473b75d877",
                    //        "name": "EUR"
                    //      },
                    //      "detailId": null,
                    //      "time": 1528304043063,
                    //      "type": "TRANSACTION_COMMISSION_RETURN",
                    //      "value": 0.6,
                    //      "fundsBefore": { "total": 0, "available": 0, "locked": 0 },
                    //      "fundsAfter": { "total": 0.6, "available": 0.6, "locked": 0 },
                    //      "change": { "total": 0.6, "available": 0.6, "locked": 0 }
                    //    }
                    //
                    const timestamp = this.safeInteger(item, 'time');
                    const balance = this.safeValue(item, 'balance', {});
                    const currencyId = this.safeString(balance, 'currency');
                    const code = this.safeCurrencyCode(currencyId);
                    const change = this.safeValue(item, 'change', {});
                    let amount = this.safeNumber(change, 'total');
                    let direction = 'in';
                    if (amount < 0) {
                        direction = 'out';
                        amount = -amount;
                    }
                    const id = this.safeString(item, 'historyId');
                    // there are 2 undocumented api calls: (v1_01PrivateGetPaymentsDepositDetailId and v1_01PrivateGetPaymentsWithdrawalDetailId)
                    // that can be used to enrich the transfers with txid, address etc (you need to use info.detailId as a parameter)
                    const referenceId = this.safeString(item, 'detailId');
                    const type = this.parseLedgerEntryType(this.safeString(item, 'type'));
                    const fundsBefore = this.safeValue(item, 'fundsBefore', {});
                    const before = this.safeNumber(fundsBefore, 'total');
                    const fundsAfter = this.safeValue(item, 'fundsAfter', {});
                    const after = this.safeNumber(fundsAfter, 'total');
                    return {
                        'info': item,
                        'id': id,
                        'direction': direction,
                        'account': undefined,
                        'referenceId': referenceId,
                        'referenceAccount': undefined,
                        'type': type,
                        'currency': code,
                        'amount': amount,
                        'before': before,
                        'after': after,
                        'status': 'ok',
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'fee': undefined
                    };
                }
                parseLedgerEntryType(type) {
                    const types = {
                        'ADD_FUNDS': 'transaction',
                        'BITCOIN_GOLD_FORK': 'transaction',
                        'CREATE_BALANCE': 'transaction',
                        'FUNDS_MIGRATION': 'transaction',
                        'WITHDRAWAL_LOCK_FUNDS': 'transaction',
                        'WITHDRAWAL_SUBTRACT_FUNDS': 'transaction',
                        'WITHDRAWAL_UNLOCK_FUNDS': 'transaction',
                        'TRANSACTION_COMMISSION_OUTCOME': 'fee',
                        'TRANSACTION_COMMISSION_RETURN': 'fee',
                        'TRANSACTION_OFFER_ABORTED_RETURN': 'trade',
                        'TRANSACTION_OFFER_COMPLETED_RETURN': 'trade',
                        'TRANSACTION_POST_INCOME': 'trade',
                        'TRANSACTION_POST_OUTCOME': 'trade',
                        'TRANSACTION_PRE_LOCKING': 'trade'
                    };
                    return this.safeString(types, type, type);
                }
                parseOHLCV(ohlcv, market) {
                    //
                    //     [
                    //         '1582399800000',
                    //         {
                    //             o: '0.0001428',
                    //             c: '0.0001428',
                    //             h: '0.0001428',
                    //             l: '0.0001428',
                    //             v: '4',
                    //             co: '1'
                    //         }
                    //     ]
                    //
                    const first = this.safeValue(ohlcv, 1, {});
                    return [
                        this.safeInteger(ohlcv, 0),
                        this.safeNumber(first, 'o'),
                        this.safeNumber(first, 'h'),
                        this.safeNumber(first, 'l'),
                        this.safeNumber(first, 'c'),
                        this.safeNumber(first, 'v')
                    ];
                }
                async fetchOHLCV(symbol, timeframe = '1m', since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const tradingSymbol = market['baseId'] + '-' + market['quoteId'];
                    const request = {
                        'symbol': tradingSymbol,
                        'resolution': this.timeframes[timeframe]
                    };
                    if (limit === undefined) limit = 100;
                    const duration = this.parseTimeframe(timeframe);
                    const timerange = limit * duration * 1000;
                    if (since === undefined) {
                        request['to'] = this.milliseconds();
                        request['from'] = request['to'] - timerange;
                    } else {
                        request['from'] = parseInt(since);
                        request['to'] = this.sum(request['from'], timerange);
                    }
                    const response = await this.v1_01PublicGetTradingCandleHistorySymbolResolution(this.extend(request, params));
                    //
                    //     {
                    //         "status":"Ok",
                    //         "items":[
                    //             ["1591503060000",{"o":"0.02509572","c":"0.02509438","h":"0.02509664","l":"0.02509438","v":"0.02082165","co":"17"}],
                    //             ["1591503120000",{"o":"0.02509606","c":"0.02509515","h":"0.02509606","l":"0.02509487","v":"0.04971703","co":"13"}],
                    //             ["1591503180000",{"o":"0.02509532","c":"0.02509589","h":"0.02509589","l":"0.02509454","v":"0.01332236","co":"7"}],
                    //         ]
                    //     }
                    //
                    const items = this.safeValue(response, 'items', []);
                    return this.parseOHLCVs(items, market, timeframe, since, limit);
                }
                parseTrade(trade, market) {
                    //
                    // createOrder trades
                    //
                    //     {
                    //         "rate": "0.02195928",
                    //         "amount": "0.00167952"
                    //     }
                    //
                    // fetchMyTrades (private)
                    //
                    //     {
                    //         amount: "0.29285199",
                    //         commissionValue: "0.00125927",
                    //         id: "11c8203a-a267-11e9-b698-0242ac110007",
                    //         initializedBy: "Buy",
                    //         market: "ETH-EUR",
                    //         offerId: "11c82038-a267-11e9-b698-0242ac110007",
                    //         rate: "277",
                    //         time: "1562689917517",
                    //         userAction: "Buy",
                    //         wasTaker: true,
                    //     }
                    //
                    // fetchTrades (public)
                    //
                    //     {
                    //          id: 'df00b0da-e5e0-11e9-8c19-0242ac11000a',
                    //          t: '1570108958831',
                    //          a: '0.04776653',
                    //          r: '0.02145854',
                    //          ty: 'Sell'
                    //     }
                    //
                    const timestamp = this.safeInteger2(trade, 'time', 't');
                    const side = this.safeStringLower2(trade, 'userAction', 'ty');
                    const wasTaker = this.safeValue(trade, 'wasTaker');
                    let takerOrMaker = undefined;
                    if (wasTaker !== undefined) takerOrMaker = wasTaker ? 'taker' : 'maker';
                    const priceString = this.safeString2(trade, 'rate', 'r');
                    const amountString = this.safeString2(trade, 'amount', 'a');
                    const feeCostString = this.safeString(trade, 'commissionValue');
                    const marketId = this.safeString(trade, 'market');
                    market = this.safeMarket(marketId, market, '-');
                    const symbol = market['symbol'];
                    let fee = undefined;
                    if (feeCostString !== undefined) {
                        const feeCurrency = side === 'buy' ? market['base'] : market['quote'];
                        fee = {
                            'currency': feeCurrency,
                            'cost': feeCostString
                        };
                    }
                    const order = this.safeString(trade, 'offerId');
                    // todo: check this logic
                    let type = undefined;
                    if (order !== undefined) type = order ? 'limit' : 'market';
                    return this.safeTrade({
                        'id': this.safeString(trade, 'id'),
                        'order': order,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'price': priceString,
                        'amount': amountString,
                        'cost': undefined,
                        'takerOrMaker': takerOrMaker,
                        'fee': fee,
                        'info': trade
                    }, market);
                }
                async fetchTrades(symbol, since, limit, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const tradingSymbol = market['baseId'] + '-' + market['quoteId'];
                    const request = {
                        'symbol': tradingSymbol
                    };
                    if (since !== undefined) request['fromTime'] = since - 1; // result does not include exactly `since` time therefore decrease by 1
                    if (limit !== undefined) request['limit'] = limit; // default - 10, max - 300
                    const response = await this.v1_01PublicGetTradingTransactionsSymbol(this.extend(request, params));
                    const items = this.safeValue(response, 'items');
                    return this.parseTrades(items, market, since, limit);
                }
                async createOrder(symbol, type, side, amount, price, params = {}) {
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const tradingSymbol = market['baseId'] + '-' + market['quoteId'];
                    amount = parseFloat(this.amountToPrecision(symbol, amount));
                    const request = {
                        'symbol': tradingSymbol,
                        'offerType': side,
                        'amount': amount,
                        'mode': type
                    };
                    if (type === 'limit') {
                        request['rate'] = price;
                        price = parseFloat(this.priceToPrecision(symbol, price));
                    }
                    const response = await this.v1_01PrivatePostTradingOfferSymbol(this.extend(request, params));
                    //
                    // unfilled (open order)
                    //
                    //     {
                    //         status: 'Ok',
                    //         completed: false, // can deduce status from here
                    //         offerId: 'ce9cc72e-d61c-11e9-9248-0242ac110005',
                    //         transactions: [], // can deduce order info from here
                    //     }
                    //
                    // filled (closed order)
                    //
                    //     {
                    //         "status": "Ok",
                    //         "offerId": "942a4a3e-e922-11e9-8c19-0242ac11000a",
                    //         "completed": true,
                    //         "transactions": [
                    //           {
                    //             "rate": "0.02195928",
                    //             "amount": "0.00167952"
                    //           },
                    //           {
                    //             "rate": "0.02195928",
                    //             "amount": "0.00167952"
                    //           },
                    //           {
                    //             "rate": "0.02196207",
                    //             "amount": "0.27704177"
                    //           }
                    //         ]
                    //     }
                    //
                    // partially-filled (open order)
                    //
                    //     {
                    //         "status": "Ok",
                    //         "offerId": "d0ebefab-f4d7-11e9-8c19-0242ac11000a",
                    //         "completed": false,
                    //         "transactions": [
                    //           {
                    //             "rate": "0.02106404",
                    //             "amount": "0.0019625"
                    //           },
                    //           {
                    //             "rate": "0.02106404",
                    //             "amount": "0.0019625"
                    //           },
                    //           {
                    //             "rate": "0.02105901",
                    //             "amount": "0.00975256"
                    //           }
                    //         ]
                    //     }
                    //
                    const timestamp = this.milliseconds(); // the real timestamp is missing in the response
                    const id = this.safeString(response, 'offerId');
                    const completed = this.safeValue(response, 'completed', false);
                    const status = completed ? 'closed' : 'open';
                    let filled = 0;
                    let cost = undefined;
                    const transactions = this.safeValue(response, 'transactions');
                    let trades = undefined;
                    if (transactions !== undefined) {
                        trades = this.parseTrades(transactions, market, undefined, undefined, {
                            'timestamp': timestamp,
                            'datetime': this.iso8601(timestamp),
                            'symbol': symbol,
                            'side': side,
                            'type': type,
                            'orderId': id
                        });
                        cost = 0;
                        for(let i = 0; i < trades.length; i++){
                            filled = this.sum(filled, trades[i]['amount']);
                            cost = this.sum(cost, trades[i]['cost']);
                        }
                    }
                    const remaining = amount - filled;
                    return {
                        'id': id,
                        'info': response,
                        'timestamp': timestamp,
                        'datetime': this.iso8601(timestamp),
                        'lastTradeTimestamp': undefined,
                        'status': status,
                        'symbol': symbol,
                        'type': type,
                        'side': side,
                        'price': price,
                        'amount': amount,
                        'cost': cost,
                        'filled': filled,
                        'remaining': remaining,
                        'average': undefined,
                        'fee': undefined,
                        'trades': trades,
                        'clientOrderId': undefined
                    };
                }
                async cancelOrder(id, symbol, params = {}) {
                    const side = this.safeString(params, 'side');
                    if (side === undefined) throw new ExchangeError1(this.id + ' cancelOrder() requires a `side` parameter ("buy" or "sell")');
                    const price = this.safeValue(params, 'price');
                    if (price === undefined) throw new ExchangeError1(this.id + ' cancelOrder() requires a `price` parameter (float or string)');
                    await this.loadMarkets();
                    const market = this.market(symbol);
                    const tradingSymbol = market['baseId'] + '-' + market['quoteId'];
                    const request = {
                        'symbol': tradingSymbol,
                        'id': id,
                        'side': side,
                        'price': price
                    };
                    // { status: 'Fail', errors: [ 'NOT_RECOGNIZED_OFFER_TYPE' ] }  -- if required params are missing
                    // { status: 'Ok', errors: [] }
                    return this.v1_01PrivateDeleteTradingOfferSymbolIdSidePrice(this.extend(request, params));
                }
                isFiat(currency) {
                    const fiatCurrencies = {
                        'USD': true,
                        'EUR': true,
                        'PLN': true
                    };
                    return this.safeValue(fiatCurrencies, currency, false);
                }
                async transfer(code, amount, fromAccount, toAccount, params = {}) {
                    await this.loadMarkets();
                    const currency = this.currency(code);
                    const request = {
                        'source': fromAccount,
                        'destination': toAccount,
                        'currency': code,
                        'funds': this.currencyToPrecision(code, amount)
                    };
                    const response = await this.v1_01PrivatePostBalancesBITBAYBalanceTransferSourceDestination(this.extend(request, params));
                    //
                    //     {
                    //         "status": "Ok",
                    //         "from": {
                    //             "id": "ad9397c5-3bd9-4372-82ba-22da6a90cb56",
                    //             "userId": "4bc43956-423f-47fd-9faa-acd37c58ed9f",
                    //             "availableFunds": 0.01803472,
                    //             "totalFunds": 0.01804161,
                    //             "lockedFunds": 0.00000689,
                    //             "currency": "BTC",
                    //             "type": "CRYPTO",
                    //             "name": "BTC",
                    //             "balanceEngine": "BITBAY"
                    //         },
                    //         "to": {
                    //             "id": "01931d52-536b-4ca5-a9f4-be28c86d0cc3",
                    //             "userId": "4bc43956-423f-47fd-9faa-acd37c58ed9f",
                    //             "availableFunds": 0.0001,
                    //             "totalFunds": 0.0001,
                    //             "lockedFunds": 0,
                    //             "currency": "BTC",
                    //             "type": "CRYPTO",
                    //             "name": "Prowizja",
                    //             "balanceEngine": "BITBAY"
                    //         },
                    //         "errors": null
                    //     }
                    //
                    const transfer = this.parseTransfer(response, currency);
                    const transferOptions = this.safeValue(this.options, 'transfer', {});
                    const fillResponseFromRequest = this.safeValue(transferOptions, 'fillResponseFromRequest', true);
                    if (fillResponseFromRequest) transfer['amount'] = amount;
                    return transfer;
                }
                parseTransfer(transfer, currency) {
                    //
                    //     {
                    //         "status": "Ok",
                    //         "from": {
                    //             "id": "ad9397c5-3bd9-4372-82ba-22da6a90cb56",
                    //             "userId": "4bc43956-423f-47fd-9faa-acd37c58ed9f",
                    //             "availableFunds": 0.01803472,
                    //             "totalFunds": 0.01804161,
                    //             "lockedFunds": 0.00000689,
                    //             "currency": "BTC",
                    //             "type": "CRYPTO",
                    //             "name": "BTC",
                    //             "balanceEngine": "BITBAY"
                    //         },
                    //         "to": {
                    //             "id": "01931d52-536b-4ca5-a9f4-be28c86d0cc3",
                    //             "userId": "4bc43956-423f-47fd-9faa-acd37c58ed9f",
                    //             "availableFunds": 0.0001,
                    //             "totalFunds": 0.0001,
                    //             "lockedFunds": 0,
                    //             "currency": "BTC",
                    //             "type": "CRYPTO",
                    //             "name": "Prowizja",
                    //             "balanceEngine": "BITBAY"
                    //         },
                    //         "errors": null
                    //     }
                    //
                    const status = this.safeString(transfer, 'status');
                    const fromAccount = this.safeValue(transfer, 'from', {});
                    const fromId = this.safeString(fromAccount, 'id');
                    const to = this.safeValue(transfer, 'to', {});
                    const toId = this.safeString(to, 'id');
                    const currencyId = this.safeString(fromAccount, 'currency');
                    return {
                        'info': transfer,
                        'id': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'currency': this.safeCurrencyCode(currencyId, currency),
                        'amount': undefined,
                        'fromAccount': fromId,
                        'toAccount': toId,
                        'status': this.parseTransferStatus(status)
                    };
                }
                parseTransferStatus(status) {
                    const statuses = {
                        'Ok': 'ok',
                        'Fail': 'failed'
                    };
                    return this.safeString(statuses, status, status);
                }
                async withdraw(code, amount, address, tag, params = {}) {
                    [tag, params] = this.handleWithdrawTagAndParams(tag, params);
                    this.checkAddress(address);
                    await this.loadMarkets();
                    let method = undefined;
                    const currency = this.currency(code);
                    const request = {
                        'currency': currency['id'],
                        'quantity': amount
                    };
                    if (this.isFiat(code)) method = 'privatePostWithdraw';
                    else {
                        method = 'privatePostTransfer';
                        if (tag !== undefined) address += '?dt=' + tag.toString();
                        request['address'] = address;
                    }
                    const response = await this[method](this.extend(request, params));
                    //
                    //     {
                    //         "status": "Ok",
                    //         "data": {
                    //           "id": "65e01087-afb0-4ab2-afdb-cc925e360296"
                    //         }
                    //     }
                    //
                    const data = this.safeValue(response, 'data');
                    return this.parseTransaction(data, currency);
                }
                parseTransaction(transaction, currency) {
                    //
                    // withdraw
                    //
                    //     {
                    //         "id": "65e01087-afb0-4ab2-afdb-cc925e360296"
                    //     }
                    //
                    currency = this.safeCurrency(undefined, currency);
                    return {
                        'id': this.safeString(transaction, 'id'),
                        'txid': undefined,
                        'timestamp': undefined,
                        'datetime': undefined,
                        'network': undefined,
                        'addressFrom': undefined,
                        'address': undefined,
                        'addressTo': undefined,
                        'amount': undefined,
                        'type': undefined,
                        'currency': currency['code'],
                        'status': undefined,
                        'updated': undefined,
                        'tagFrom': undefined,
                        'tag': undefined,
                        'tagTo': undefined,
                        'comment': undefined,
                        'fee': undefined,
                        'info': transaction
                    };
                }
                sign(path, api = 'public', method = 'GET', params = {}, headers, body) {
                    let url = this.implodeHostname(this.urls['api'][api]);
                    if (api === 'public') {
                        const query = this.omit(params, this.extractParams(path));
                        url += '/' + this.implodeParams(path, params) + '.json';
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'v1_01Public') {
                        const query = this.omit(params, this.extractParams(path));
                        url += '/' + this.implodeParams(path, params);
                        if (Object.keys(query).length) url += '?' + this.urlencode(query);
                    } else if (api === 'v1_01Private') {
                        this.checkRequiredCredentials();
                        const query = this.omit(params, this.extractParams(path));
                        url += '/' + this.implodeParams(path, params);
                        const nonce = this.milliseconds().toString();
                        let payload = undefined;
                        if (method !== 'POST') {
                            if (Object.keys(query).length) url += '?' + this.urlencode(query);
                            payload = this.apiKey + nonce;
                        } else if (body === undefined) {
                            body = this.json(query);
                            payload = this.apiKey + nonce + body;
                        }
                        headers = {
                            'Request-Timestamp': nonce,
                            'Operation-Id': this.uuid(),
                            'API-Key': this.apiKey,
                            'API-Hash': this.hmac(this.encode(payload), this.encode(this.secret), 'sha512'),
                            'Content-Type': 'application/json'
                        };
                    } else {
                        this.checkRequiredCredentials();
                        body = this.urlencode(this.extend({
                            'method': path,
                            'moment': this.nonce()
                        }, params));
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'API-Key': this.apiKey,
                            'API-Hash': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                        };
                    }
                    return {
                        'url': url,
                        'method': method,
                        'body': body,
                        'headers': headers
                    };
                }
                handleErrors(httpCode, reason, url, method, headers, body, response, requestHeaders, requestBody) {
                    if (response === undefined) return; // fallback to default error handler
                    if ('code' in response) {
                        //
                        // bitbay returns the integer 'success': 1 key from their private API
                        // or an integer 'code' value from 0 to 510 and an error message
                        //
                        //      { 'success': 1, ... }
                        //      { 'code': 502, 'message': 'Invalid sign' }
                        //      { 'code': 0, 'message': 'offer funds not exceeding minimums' }
                        //
                        //      400 At least one parameter wasn't set
                        //      401 Invalid order type
                        //      402 No orders with specified currencies
                        //      403 Invalid payment currency name
                        //      404 Error. Wrong transaction type
                        //      405 Order with this id doesn't exist
                        //      406 No enough money or crypto
                        //      408 Invalid currency name
                        //      501 Invalid public key
                        //      502 Invalid sign
                        //      503 Invalid moment parameter. Request time doesn't match current server time
                        //      504 Invalid method
                        //      505 Key has no permission for this action
                        //      506 Account locked. Please contact with customer service
                        //      509 The BIC/SWIFT is required for this currency
                        //      510 Invalid market name
                        //
                        const code = this.safeString(response, 'code'); // always an integer
                        const feedback = this.id + ' ' + body;
                        this.throwExactlyMatchedException(this.exceptions, code, feedback);
                        throw new ExchangeError1(feedback);
                    } else if ('status' in response) {
                        //
                        //      {"status":"Fail","errors":["OFFER_FUNDS_NOT_EXCEEDING_MINIMUMS"]}
                        //
                        const status = this.safeString(response, 'status');
                        if (status === 'Fail') {
                            const errors = this.safeValue(response, 'errors');
                            const feedback = this.id + ' ' + body;
                            for(let i = 0; i < errors.length; i++){
                                const error = errors[i];
                                this.throwExactlyMatchedException(this.exceptions, error, feedback);
                            }
                            throw new ExchangeError1(feedback);
                        }
                    }
                }
            };
        },
        {
            "./base/Exchange": 5,
            "./base/errors": 8
        }
    ],
    177: [
        function(require1, module, exports) {
            (function(global1) {
                'use strict';
                // compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
                // original notice:
                /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function compare(a, b) {
                    if (a === b) return 0;
                    var x = a.length;
                    var y = b.length;
                    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                        x = a[i];
                        y = b[i];
                        break;
                    }
                    if (x < y) return -1;
                    if (y < x) return 1;
                    return 0;
                }
                function isBuffer(b) {
                    if (global1.Buffer && typeof global1.Buffer.isBuffer === 'function') return global1.Buffer.isBuffer(b);
                    return !!(b != null && b._isBuffer);
                }
                // based on node assert, original notice:
                // http://wiki.commonjs.org/wiki/Unit_Testing/1.0
                //
                // THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
                //
                // Originally from narwhal.js (http://narwhaljs.org)
                // Copyright (c) 2009 Thomas Robinson <280north.com>
                //
                // Permission is hereby granted, free of charge, to any person obtaining a copy
                // of this software and associated documentation files (the 'Software'), to
                // deal in the Software without restriction, including without limitation the
                // rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
                // sell copies of the Software, and to permit persons to whom the Software is
                // furnished to do so, subject to the following conditions:
                //
                // The above copyright notice and this permission notice shall be included in
                // all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                // AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
                // ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
                // WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                var util = require1('util/');
                var hasOwn = Object.prototype.hasOwnProperty;
                var pSlice = Array.prototype.slice;
                var functionsHaveNames = function() {
                    return (function foo() {}).name === 'foo';
                }();
                function pToString(obj) {
                    return Object.prototype.toString.call(obj);
                }
                function isView(arrbuf) {
                    if (isBuffer(arrbuf)) return false;
                    if (typeof global1.ArrayBuffer !== 'function') return false;
                    if (typeof ArrayBuffer.isView === 'function') return ArrayBuffer.isView(arrbuf);
                    if (!arrbuf) return false;
                    if (arrbuf instanceof DataView) return true;
                    if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) return true;
                    return false;
                }
                // 1. The assert module provides functions that throw
                // AssertionError's when particular conditions are not met. The
                // assert module must conform to the following interface.
                var assert = module.exports = ok;
                // 2. The AssertionError is defined in assert.
                // new assert.AssertionError({ message: message,
                //                             actual: actual,
                //                             expected: expected })
                var regex = /\s*function\s+([^\(\s]*)\s*/;
                // based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
                function getName(func) {
                    if (!util.isFunction(func)) return;
                    if (functionsHaveNames) return func.name;
                    var str = func.toString();
                    var match = str.match(regex);
                    return match && match[1];
                }
                assert.AssertionError = function AssertionError(options) {
                    this.name = 'AssertionError';
                    this.actual = options.actual;
                    this.expected = options.expected;
                    this.operator = options.operator;
                    if (options.message) {
                        this.message = options.message;
                        this.generatedMessage = false;
                    } else {
                        this.message = getMessage(this);
                        this.generatedMessage = true;
                    }
                    var stackStartFunction = options.stackStartFunction || fail;
                    if (Error.captureStackTrace) Error.captureStackTrace(this, stackStartFunction);
                    else {
                        // non v8 browsers so we can have a stacktrace
                        var err = new Error();
                        if (err.stack) {
                            var out = err.stack;
                            // try to strip useless frames
                            var fn_name = getName(stackStartFunction);
                            var idx = out.indexOf('\n' + fn_name);
                            if (idx >= 0) {
                                // once we have located the function frame
                                // we need to strip out everything before it (and its line)
                                var next_line = out.indexOf('\n', idx + 1);
                                out = out.substring(next_line + 1);
                            }
                            this.stack = out;
                        }
                    }
                };
                // assert.AssertionError instanceof Error
                util.inherits(assert.AssertionError, Error);
                function truncate(s, n) {
                    if (typeof s === 'string') return s.length < n ? s : s.slice(0, n);
                    else return s;
                }
                function inspect(something) {
                    if (functionsHaveNames || !util.isFunction(something)) return util.inspect(something);
                    var rawname = getName(something);
                    var name = rawname ? ': ' + rawname : '';
                    return '[Function' + name + ']';
                }
                function getMessage(self1) {
                    return truncate(inspect(self1.actual), 128) + ' ' + self1.operator + ' ' + truncate(inspect(self1.expected), 128);
                }
                // At present only the three keys mentioned above are used and
                // understood by the spec. Implementations or sub modules can pass
                // other keys to the AssertionError's constructor - they will be
                // ignored.
                // 3. All of the following functions must throw an AssertionError
                // when a corresponding condition is not met, with a message that
                // may be undefined if not provided.  All assertion methods provide
                // both the actual and expected values to the assertion error for
                // display purposes.
                function fail(actual, expected, message, operator, stackStartFunction) {
                    throw new assert.AssertionError({
                        message: message,
                        actual: actual,
                        expected: expected,
                        operator: operator,
                        stackStartFunction: stackStartFunction
                    });
                }
                // EXTENSION! allows for well behaved errors defined elsewhere.
                assert.fail = fail;
                // 4. Pure assertion tests whether a value is truthy, as determined
                // by !!guard.
                // assert.ok(guard, message_opt);
                // This statement is equivalent to assert.equal(true, !!guard,
                // message_opt);. To test strictly for the value true, use
                // assert.strictEqual(true, guard, message_opt);.
                function ok(value, message) {
                    if (!value) fail(value, true, message, '==', assert.ok);
                }
                assert.ok = ok;
                // 5. The equality assertion tests shallow, coercive equality with
                // ==.
                // assert.equal(actual, expected, message_opt);
                assert.equal = function equal(actual, expected, message) {
                    if (actual != expected) fail(actual, expected, message, '==', assert.equal);
                };
                // 6. The non-equality assertion tests for whether two objects are not equal
                // with != assert.notEqual(actual, expected, message_opt);
                assert.notEqual = function notEqual(actual, expected, message) {
                    if (actual == expected) fail(actual, expected, message, '!=', assert.notEqual);
                };
                // 7. The equivalence assertion tests a deep equality relation.
                // assert.deepEqual(actual, expected, message_opt);
                assert.deepEqual = function deepEqual(actual, expected, message) {
                    if (!_deepEqual(actual, expected, false)) fail(actual, expected, message, 'deepEqual', assert.deepEqual);
                };
                assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
                    if (!_deepEqual(actual, expected, true)) fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
                };
                function _deepEqual(actual, expected, strict, memos) {
                    // 7.1. All identical values are equivalent, as determined by ===.
                    if (actual === expected) return true;
                    else if (isBuffer(actual) && isBuffer(expected)) return compare(actual, expected) === 0;
                    else if (util.isDate(actual) && util.isDate(expected)) return actual.getTime() === expected.getTime();
                    else if (util.isRegExp(actual) && util.isRegExp(expected)) return actual.source === expected.source && actual.global === expected.global && actual.multiline === expected.multiline && actual.lastIndex === expected.lastIndex && actual.ignoreCase === expected.ignoreCase;
                    else if ((actual === null || typeof actual !== 'object') && (expected === null || typeof expected !== 'object')) return strict ? actual === expected : actual == expected;
                    else if (isView(actual) && isView(expected) && pToString(actual) === pToString(expected) && !(actual instanceof Float32Array || actual instanceof Float64Array)) return compare(new Uint8Array(actual.buffer), new Uint8Array(expected.buffer)) === 0;
                    else if (isBuffer(actual) !== isBuffer(expected)) return false;
                    else {
                        memos = memos || {
                            actual: [],
                            expected: []
                        };
                        var actualIndex = memos.actual.indexOf(actual);
                        if (actualIndex !== -1) {
                            if (actualIndex === memos.expected.indexOf(expected)) return true;
                        }
                        memos.actual.push(actual);
                        memos.expected.push(expected);
                        return objEquiv(actual, expected, strict, memos);
                    }
                }
                function isArguments(object) {
                    return Object.prototype.toString.call(object) == '[object Arguments]';
                }
                function objEquiv(a, b, strict, actualVisitedObjects) {
                    if (a === null || a === undefined || b === null || b === undefined) return false;
                    // if one is a primitive, the other must be same
                    if (util.isPrimitive(a) || util.isPrimitive(b)) return a === b;
                    if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)) return false;
                    var aIsArgs = isArguments(a);
                    var bIsArgs = isArguments(b);
                    if (aIsArgs && !bIsArgs || !aIsArgs && bIsArgs) return false;
                    if (aIsArgs) {
                        a = pSlice.call(a);
                        b = pSlice.call(b);
                        return _deepEqual(a, b, strict);
                    }
                    var ka = objectKeys(a);
                    var kb = objectKeys(b);
                    var key, i;
                    // having the same number of owned properties (keys incorporates
                    // hasOwnProperty)
                    if (ka.length !== kb.length) return false;
                    //the same set of keys (although not necessarily the same order),
                    ka.sort();
                    kb.sort();
                    //~~~cheap key test
                    for(i = ka.length - 1; i >= 0; i--){
                        if (ka[i] !== kb[i]) return false;
                    }
                    //equivalent values for every corresponding key, and
                    //~~~possibly expensive deep test
                    for(i = ka.length - 1; i >= 0; i--){
                        key = ka[i];
                        if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects)) return false;
                    }
                    return true;
                }
                // 8. The non-equivalence assertion tests for any deep inequality.
                // assert.notDeepEqual(actual, expected, message_opt);
                assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
                    if (_deepEqual(actual, expected, false)) fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
                };
                assert.notDeepStrictEqual = notDeepStrictEqual;
                function notDeepStrictEqual(actual, expected, message) {
                    if (_deepEqual(actual, expected, true)) fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
                }
                // 9. The strict equality assertion tests strict equality, as determined by ===.
                // assert.strictEqual(actual, expected, message_opt);
                assert.strictEqual = function strictEqual(actual, expected, message) {
                    if (actual !== expected) fail(actual, expected, message, '===', assert.strictEqual);
                };
                // 10. The strict non-equality assertion tests for strict inequality, as
                // determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
                assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
                    if (actual === expected) fail(actual, expected, message, '!==', assert.notStrictEqual);
                };
                function expectedException(actual, expected) {
                    if (!actual || !expected) return false;
                    if (Object.prototype.toString.call(expected) == '[object RegExp]') return expected.test(actual);
                    try {
                        if (actual instanceof expected) return true;
                    } catch (e) {
                    // Ignore.  The instanceof check doesn't work for arrow functions.
                    }
                    if (Error.isPrototypeOf(expected)) return false;
                    return expected.call({}, actual) === true;
                }
                function _tryBlock(block) {
                    var error;
                    try {
                        block();
                    } catch (e) {
                        error = e;
                    }
                    return error;
                }
                function _throws(shouldThrow, block, expected, message) {
                    var actual;
                    if (typeof block !== 'function') throw new TypeError('"block" argument must be a function');
                    if (typeof expected === 'string') {
                        message = expected;
                        expected = null;
                    }
                    actual = _tryBlock(block);
                    message = (expected && expected.name ? ' (' + expected.name + ').' : '.') + (message ? ' ' + message : '.');
                    if (shouldThrow && !actual) fail(actual, expected, 'Missing expected exception' + message);
                    var userProvidedMessage = typeof message === 'string';
                    var isUnwantedException = !shouldThrow && util.isError(actual);
                    var isUnexpectedException = !shouldThrow && actual && !expected;
                    if (isUnwantedException && userProvidedMessage && expectedException(actual, expected) || isUnexpectedException) fail(actual, expected, 'Got unwanted exception' + message);
                    if (shouldThrow && actual && expected && !expectedException(actual, expected) || !shouldThrow && actual) throw actual;
                }
                // 11. Expected to throw an error:
                // assert.throws(block, Error_opt, message_opt);
                assert.throws = function(block, /*optional*/ error, /*optional*/ message) {
                    _throws(true, block, error, message);
                };
                // EXTENSION! This is annoying to write outside this module.
                assert.doesNotThrow = function(block, /*optional*/ error, /*optional*/ message) {
                    _throws(false, block, error, message);
                };
                assert.ifError = function(err) {
                    if (err) throw err;
                };
                var objectKeys = Object.keys || function(obj) {
                    var keys = [];
                    for(var key in obj)if (hasOwn.call(obj, key)) keys.push(key);
                    return keys;
                };
            }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        },
        {
            "util/": 235
        }
    ],
    178: [
        function(require1, module, exports) {
            'use strict';
            exports.byteLength = byteLength;
            exports.toByteArray = toByteArray;
            exports.fromByteArray = fromByteArray;
            var lookup = [];
            var revLookup = [];
            var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
            var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
            for(var i = 0, len = code.length; i < len; ++i){
                lookup[i] = code[i];
                revLookup[code.charCodeAt(i)] = i;
            }
            revLookup['-'.charCodeAt(0)] = 62;
            revLookup['_'.charCodeAt(0)] = 63;
            function placeHoldersCount(b64) {
                var len = b64.length;
                if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
                // the number of equal signs (place holders)
                // if there are two placeholders, than the two characters before it
                // represent one byte
                // if there is only one, then the three characters before it represent 2 bytes
                // this is just a cheap hack to not do indexOf twice
                return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
            }
            function byteLength(b64) {
                // base64 is 4/3 + up to two characters of the original data
                return b64.length * 3 / 4 - placeHoldersCount(b64);
            }
            function toByteArray(b64) {
                var i, l, tmp, placeHolders, arr;
                var len = b64.length;
                placeHolders = placeHoldersCount(b64);
                arr = new Arr(len * 3 / 4 - placeHolders);
                // if there are placeholders, only get up to the last complete 4 chars
                l = placeHolders > 0 ? len - 4 : len;
                var L = 0;
                for(i = 0; i < l; i += 4){
                    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
                    arr[L++] = tmp >> 16 & 0xFF;
                    arr[L++] = tmp >> 8 & 0xFF;
                    arr[L++] = tmp & 0xFF;
                }
                if (placeHolders === 2) {
                    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
                    arr[L++] = tmp & 0xFF;
                } else if (placeHolders === 1) {
                    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
                    arr[L++] = tmp >> 8 & 0xFF;
                    arr[L++] = tmp & 0xFF;
                }
                return arr;
            }
            function tripletToBase64(num) {
                return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
            }
            function encodeChunk(uint8, start, end) {
                var tmp;
                var output = [];
                for(var i = start; i < end; i += 3){
                    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
                    output.push(tripletToBase64(tmp));
                }
                return output.join('');
            }
            function fromByteArray(uint8) {
                var tmp;
                var len = uint8.length;
                var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
                ;
                var output = '';
                var parts = [];
                var maxChunkLength = 16383 // must be multiple of 3
                ;
                // go through the array every three bytes, we'll deal with trailing stuff later
                for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
                // pad the end with zeros, but make sure to not forget the extra bytes
                if (extraBytes === 1) {
                    tmp = uint8[len - 1];
                    output += lookup[tmp >> 2];
                    output += lookup[tmp << 4 & 0x3F];
                    output += '==';
                } else if (extraBytes === 2) {
                    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
                    output += lookup[tmp >> 10];
                    output += lookup[tmp >> 4 & 0x3F];
                    output += lookup[tmp << 2 & 0x3F];
                    output += '=';
                }
                parts.push(output);
                return parts.join('');
            }
        },
        {}
    ],
    179: [
        function(require1, module, exports) {},
        {}
    ],
    180: [
        function(require1, module, exports) {
            (function(process, Buffer) {
                'use strict';
                /* eslint camelcase: "off" */ var assert = require1('assert');
                var Zstream = require1('pako/lib/zlib/zstream');
                var zlib_deflate = require1('pako/lib/zlib/deflate.js');
                var zlib_inflate = require1('pako/lib/zlib/inflate.js');
                var constants = require1('pako/lib/zlib/constants');
                for(var key in constants)exports[key] = constants[key];
                // zlib modes
                exports.NONE = 0;
                exports.DEFLATE = 1;
                exports.INFLATE = 2;
                exports.GZIP = 3;
                exports.GUNZIP = 4;
                exports.DEFLATERAW = 5;
                exports.INFLATERAW = 6;
                exports.UNZIP = 7;
                var GZIP_HEADER_ID1 = 0x1f;
                var GZIP_HEADER_ID2 = 0x8b;
                /**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */ function Zlib(mode) {
                    if (typeof mode !== 'number' || mode < exports.DEFLATE || mode > exports.UNZIP) throw new TypeError('Bad argument');
                    this.dictionary = null;
                    this.err = 0;
                    this.flush = 0;
                    this.init_done = false;
                    this.level = 0;
                    this.memLevel = 0;
                    this.mode = mode;
                    this.strategy = 0;
                    this.windowBits = 0;
                    this.write_in_progress = false;
                    this.pending_close = false;
                    this.gzip_id_bytes_read = 0;
                }
                Zlib.prototype.close = function() {
                    if (this.write_in_progress) {
                        this.pending_close = true;
                        return;
                    }
                    this.pending_close = false;
                    assert(this.init_done, 'close before init');
                    assert(this.mode <= exports.UNZIP);
                    if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) zlib_deflate.deflateEnd(this.strm);
                    else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) zlib_inflate.inflateEnd(this.strm);
                    this.mode = exports.NONE;
                    this.dictionary = null;
                };
                Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
                    return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
                };
                Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
                    return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
                };
                Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
                    assert.equal(arguments.length, 8);
                    assert(this.init_done, 'write before init');
                    assert(this.mode !== exports.NONE, 'already finalized');
                    assert.equal(false, this.write_in_progress, 'write already in progress');
                    assert.equal(false, this.pending_close, 'close is pending');
                    this.write_in_progress = true;
                    assert.equal(false, flush === undefined, 'must provide flush value');
                    this.write_in_progress = true;
                    if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) throw new Error('Invalid flush value');
                    if (input == null) {
                        input = Buffer.alloc(0);
                        in_len = 0;
                        in_off = 0;
                    }
                    this.strm.avail_in = in_len;
                    this.strm.input = input;
                    this.strm.next_in = in_off;
                    this.strm.avail_out = out_len;
                    this.strm.output = out;
                    this.strm.next_out = out_off;
                    this.flush = flush;
                    if (!async) {
                        // sync version
                        this._process();
                        if (this._checkError()) return this._afterSync();
                        return;
                    }
                    // async version
                    var self1 = this;
                    process.nextTick(function() {
                        self1._process();
                        self1._after();
                    });
                    return this;
                };
                Zlib.prototype._afterSync = function() {
                    var avail_out = this.strm.avail_out;
                    var avail_in = this.strm.avail_in;
                    this.write_in_progress = false;
                    return [
                        avail_in,
                        avail_out
                    ];
                };
                Zlib.prototype._process = function() {
                    var next_expected_header_byte = null;
                    // If the avail_out is left at 0, then it means that it ran out
                    // of room.  If there was avail_out left over, then it means
                    // that all of the input was consumed.
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.GZIP:
                        case exports.DEFLATERAW:
                            this.err = zlib_deflate.deflate(this.strm, this.flush);
                            break;
                        case exports.UNZIP:
                            if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
                            switch(this.gzip_id_bytes_read){
                                case 0:
                                    if (next_expected_header_byte === null) break;
                                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                                        this.gzip_id_bytes_read = 1;
                                        next_expected_header_byte++;
                                        if (this.strm.avail_in === 1) break;
                                    } else {
                                        this.mode = exports.INFLATE;
                                        break;
                                    }
                                // fallthrough
                                case 1:
                                    if (next_expected_header_byte === null) break;
                                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                                        this.gzip_id_bytes_read = 2;
                                        this.mode = exports.GUNZIP;
                                    } else // There is no actual difference between INFLATE and INFLATERAW
                                    // (after initialization).
                                    this.mode = exports.INFLATE;
                                    break;
                                default:
                                    throw new Error('invalid number of gzip magic number bytes read');
                            }
                        // fallthrough
                        case exports.INFLATE:
                        case exports.GUNZIP:
                        case exports.INFLATERAW:
                            this.err = zlib_inflate.inflate(this.strm, this.flush);
                            if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                                // Load it
                                this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
                                if (this.err === exports.Z_OK) // And try to decode again
                                this.err = zlib_inflate.inflate(this.strm, this.flush);
                                else if (this.err === exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                                // Make it possible for After() to tell a bad dictionary from bad
                                // input.
                                this.err = exports.Z_NEED_DICT;
                            }
                            while(this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                                // Bytes remain in input buffer. Perhaps this is another compressed
                                // member in the same archive, or just trailing garbage.
                                // Trailing zero bytes are okay, though, since they are frequently
                                // used for padding.
                                this.reset();
                                this.err = zlib_inflate.inflate(this.strm, this.flush);
                            }
                            break;
                        default:
                            throw new Error('Unknown mode ' + this.mode);
                    }
                };
                Zlib.prototype._checkError = function() {
                    // Acceptable error states depend on the type of zlib stream.
                    switch(this.err){
                        case exports.Z_OK:
                        case exports.Z_BUF_ERROR:
                            if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
                                this._error('unexpected end of file');
                                return false;
                            }
                            break;
                        case exports.Z_STREAM_END:
                            break;
                        case exports.Z_NEED_DICT:
                            if (this.dictionary == null) this._error('Missing dictionary');
                            else this._error('Bad dictionary');
                            return false;
                        default:
                            // something else.
                            this._error('Zlib error');
                            return false;
                    }
                    return true;
                };
                Zlib.prototype._after = function() {
                    if (!this._checkError()) return;
                    var avail_out = this.strm.avail_out;
                    var avail_in = this.strm.avail_in;
                    this.write_in_progress = false;
                    // call the write() cb
                    this.callback(avail_in, avail_out);
                    if (this.pending_close) this.close();
                };
                Zlib.prototype._error = function(message) {
                    if (this.strm.msg) message = this.strm.msg;
                    this.onerror(message, this.err);
                    this.write_in_progress = false;
                    if (this.pending_close) this.close();
                };
                Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
                    assert(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');
                    assert(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
                    assert(level >= -1 && level <= 9, 'invalid compression level');
                    assert(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');
                    assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, 'invalid strategy');
                    this._init(level, windowBits, memLevel, strategy, dictionary);
                    this._setDictionary();
                };
                Zlib.prototype.params = function() {
                    throw new Error('deflateParams Not supported');
                };
                Zlib.prototype.reset = function() {
                    this._reset();
                    this._setDictionary();
                };
                Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
                    this.level = level;
                    this.windowBits = windowBits;
                    this.memLevel = memLevel;
                    this.strategy = strategy;
                    this.flush = exports.Z_NO_FLUSH;
                    this.err = exports.Z_OK;
                    if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) this.windowBits += 16;
                    if (this.mode === exports.UNZIP) this.windowBits += 32;
                    if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
                    this.strm = new Zstream();
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.GZIP:
                        case exports.DEFLATERAW:
                            this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
                            break;
                        case exports.INFLATE:
                        case exports.GUNZIP:
                        case exports.INFLATERAW:
                        case exports.UNZIP:
                            this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
                            break;
                        default:
                            throw new Error('Unknown mode ' + this.mode);
                    }
                    if (this.err !== exports.Z_OK) this._error('Init error');
                    this.dictionary = dictionary;
                    this.write_in_progress = false;
                    this.init_done = true;
                };
                Zlib.prototype._setDictionary = function() {
                    if (this.dictionary == null) return;
                    this.err = exports.Z_OK;
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.DEFLATERAW:
                            this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
                            break;
                        default:
                            break;
                    }
                    if (this.err !== exports.Z_OK) this._error('Failed to set dictionary');
                };
                Zlib.prototype._reset = function() {
                    this.err = exports.Z_OK;
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.DEFLATERAW:
                        case exports.GZIP:
                            this.err = zlib_deflate.deflateReset(this.strm);
                            break;
                        case exports.INFLATE:
                        case exports.INFLATERAW:
                        case exports.GUNZIP:
                            this.err = zlib_inflate.inflateReset(this.strm);
                            break;
                        default:
                            break;
                    }
                    if (this.err !== exports.Z_OK) this._error('Failed to reset stream');
                };
                exports.Zlib = Zlib;
            }).call(this, require1('_process'), require1("buffer").Buffer);
        },
        {
            "_process": 204,
            "assert": 177,
            "buffer": 182,
            "pako/lib/zlib/constants": 194,
            "pako/lib/zlib/deflate.js": 196,
            "pako/lib/zlib/inflate.js": 198,
            "pako/lib/zlib/zstream": 202
        }
    ],
    181: [
        function(require1, module, exports) {
            (function(process) {
                'use strict';
                var Buffer = require1('buffer').Buffer;
                var Transform = require1('stream').Transform;
                var binding = require1('./binding');
                var util = require1('util');
                var assert = require1('assert').ok;
                var kMaxLength = require1('buffer').kMaxLength;
                var kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + kMaxLength.toString(16) + ' bytes';
                // zlib doesn't provide these, so kludge them in following the same
                // const naming scheme zlib uses.
                binding.Z_MIN_WINDOWBITS = 8;
                binding.Z_MAX_WINDOWBITS = 15;
                binding.Z_DEFAULT_WINDOWBITS = 15;
                // fewer than 64 bytes per chunk is stupid.
                // technically it could work with as few as 8, but even 64 bytes
                // is absurdly low.  Usually a MB or more is best.
                binding.Z_MIN_CHUNK = 64;
                binding.Z_MAX_CHUNK = Infinity;
                binding.Z_DEFAULT_CHUNK = 16384;
                binding.Z_MIN_MEMLEVEL = 1;
                binding.Z_MAX_MEMLEVEL = 9;
                binding.Z_DEFAULT_MEMLEVEL = 8;
                binding.Z_MIN_LEVEL = -1;
                binding.Z_MAX_LEVEL = 9;
                binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
                // expose all the zlib constants
                var bkeys = Object.keys(binding);
                for(var bk = 0; bk < bkeys.length; bk++){
                    var bkey = bkeys[bk];
                    if (bkey.match(/^Z/)) Object.defineProperty(exports, bkey, {
                        enumerable: true,
                        value: binding[bkey],
                        writable: false
                    });
                }
                // translation table for return codes.
                var codes = {
                    Z_OK: binding.Z_OK,
                    Z_STREAM_END: binding.Z_STREAM_END,
                    Z_NEED_DICT: binding.Z_NEED_DICT,
                    Z_ERRNO: binding.Z_ERRNO,
                    Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
                    Z_DATA_ERROR: binding.Z_DATA_ERROR,
                    Z_MEM_ERROR: binding.Z_MEM_ERROR,
                    Z_BUF_ERROR: binding.Z_BUF_ERROR,
                    Z_VERSION_ERROR: binding.Z_VERSION_ERROR
                };
                var ckeys = Object.keys(codes);
                for(var ck = 0; ck < ckeys.length; ck++){
                    var ckey = ckeys[ck];
                    codes[codes[ckey]] = ckey;
                }
                Object.defineProperty(exports, 'codes', {
                    enumerable: true,
                    value: Object.freeze(codes),
                    writable: false
                });
                exports.Deflate = Deflate;
                exports.Inflate = Inflate;
                exports.Gzip = Gzip;
                exports.Gunzip = Gunzip;
                exports.DeflateRaw = DeflateRaw;
                exports.InflateRaw = InflateRaw;
                exports.Unzip = Unzip;
                exports.createDeflate = function(o) {
                    return new Deflate(o);
                };
                exports.createInflate = function(o) {
                    return new Inflate(o);
                };
                exports.createDeflateRaw = function(o) {
                    return new DeflateRaw(o);
                };
                exports.createInflateRaw = function(o) {
                    return new InflateRaw(o);
                };
                exports.createGzip = function(o) {
                    return new Gzip(o);
                };
                exports.createGunzip = function(o) {
                    return new Gunzip(o);
                };
                exports.createUnzip = function(o) {
                    return new Unzip(o);
                };
                // Convenience methods.
                // compress/decompress a string or buffer in one step.
                exports.deflate = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Deflate(opts), buffer, callback);
                };
                exports.deflateSync = function(buffer, opts) {
                    return zlibBufferSync(new Deflate(opts), buffer);
                };
                exports.gzip = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Gzip(opts), buffer, callback);
                };
                exports.gzipSync = function(buffer, opts) {
                    return zlibBufferSync(new Gzip(opts), buffer);
                };
                exports.deflateRaw = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new DeflateRaw(opts), buffer, callback);
                };
                exports.deflateRawSync = function(buffer, opts) {
                    return zlibBufferSync(new DeflateRaw(opts), buffer);
                };
                exports.unzip = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Unzip(opts), buffer, callback);
                };
                exports.unzipSync = function(buffer, opts) {
                    return zlibBufferSync(new Unzip(opts), buffer);
                };
                exports.inflate = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Inflate(opts), buffer, callback);
                };
                exports.inflateSync = function(buffer, opts) {
                    return zlibBufferSync(new Inflate(opts), buffer);
                };
                exports.gunzip = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Gunzip(opts), buffer, callback);
                };
                exports.gunzipSync = function(buffer, opts) {
                    return zlibBufferSync(new Gunzip(opts), buffer);
                };
                exports.inflateRaw = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new InflateRaw(opts), buffer, callback);
                };
                exports.inflateRawSync = function(buffer, opts) {
                    return zlibBufferSync(new InflateRaw(opts), buffer);
                };
                function zlibBuffer(engine, buffer, callback) {
                    var buffers = [];
                    var nread = 0;
                    engine.on('error', onError);
                    engine.on('end', onEnd);
                    engine.end(buffer);
                    flow();
                    function flow() {
                        var chunk;
                        while(null !== (chunk = engine.read())){
                            buffers.push(chunk);
                            nread += chunk.length;
                        }
                        engine.once('readable', flow);
                    }
                    function onError(err) {
                        engine.removeListener('end', onEnd);
                        engine.removeListener('readable', flow);
                        callback(err);
                    }
                    function onEnd() {
                        var buf;
                        var err = null;
                        if (nread >= kMaxLength) err = new RangeError(kRangeErrorMessage);
                        else buf = Buffer.concat(buffers, nread);
                        buffers = [];
                        engine.close();
                        callback(err, buf);
                    }
                }
                function zlibBufferSync(engine, buffer) {
                    if (typeof buffer === 'string') buffer = Buffer.from(buffer);
                    if (!Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');
                    var flushFlag = engine._finishFlushFlag;
                    return engine._processChunk(buffer, flushFlag);
                }
                // generic zlib
                // minimal 2-byte header
                function Deflate(opts) {
                    if (!(this instanceof Deflate)) return new Deflate(opts);
                    Zlib.call(this, opts, binding.DEFLATE);
                }
                function Inflate(opts) {
                    if (!(this instanceof Inflate)) return new Inflate(opts);
                    Zlib.call(this, opts, binding.INFLATE);
                }
                // gzip - bigger header, same deflate compression
                function Gzip(opts) {
                    if (!(this instanceof Gzip)) return new Gzip(opts);
                    Zlib.call(this, opts, binding.GZIP);
                }
                function Gunzip(opts) {
                    if (!(this instanceof Gunzip)) return new Gunzip(opts);
                    Zlib.call(this, opts, binding.GUNZIP);
                }
                // raw - no header
                function DeflateRaw(opts) {
                    if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
                    Zlib.call(this, opts, binding.DEFLATERAW);
                }
                function InflateRaw(opts) {
                    if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
                    Zlib.call(this, opts, binding.INFLATERAW);
                }
                // auto-detect header.
                function Unzip(opts) {
                    if (!(this instanceof Unzip)) return new Unzip(opts);
                    Zlib.call(this, opts, binding.UNZIP);
                }
                function isValidFlushFlag(flag) {
                    return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
                }
                // the Zlib class they all inherit from
                // This thing manages the queue of requests, and returns
                // true or false if there is anything in the queue when
                // you call the .write() method.
                function Zlib(opts, mode) {
                    var _this = this;
                    this._opts = opts = opts || {};
                    this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
                    Transform.call(this, opts);
                    if (opts.flush && !isValidFlushFlag(opts.flush)) throw new Error('Invalid flush flag: ' + opts.flush);
                    if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) throw new Error('Invalid flush flag: ' + opts.finishFlush);
                    this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
                    this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : binding.Z_FINISH;
                    if (opts.chunkSize) {
                        if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) throw new Error('Invalid chunk size: ' + opts.chunkSize);
                    }
                    if (opts.windowBits) {
                        if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) throw new Error('Invalid windowBits: ' + opts.windowBits);
                    }
                    if (opts.level) {
                        if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) throw new Error('Invalid compression level: ' + opts.level);
                    }
                    if (opts.memLevel) {
                        if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) throw new Error('Invalid memLevel: ' + opts.memLevel);
                    }
                    if (opts.strategy) {
                        if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) throw new Error('Invalid strategy: ' + opts.strategy);
                    }
                    if (opts.dictionary) {
                        if (!Buffer.isBuffer(opts.dictionary)) throw new Error('Invalid dictionary: it should be a Buffer instance');
                    }
                    this._handle = new binding.Zlib(mode);
                    var self1 = this;
                    this._hadError = false;
                    this._handle.onerror = function(message, errno) {
                        // there is no way to cleanly recover.
                        // continuing only obscures problems.
                        _close(self1);
                        self1._hadError = true;
                        var error = new Error(message);
                        error.errno = errno;
                        error.code = exports.codes[errno];
                        self1.emit('error', error);
                    };
                    var level = exports.Z_DEFAULT_COMPRESSION;
                    if (typeof opts.level === 'number') level = opts.level;
                    var strategy = exports.Z_DEFAULT_STRATEGY;
                    if (typeof opts.strategy === 'number') strategy = opts.strategy;
                    this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
                    this._buffer = Buffer.allocUnsafe(this._chunkSize);
                    this._offset = 0;
                    this._level = level;
                    this._strategy = strategy;
                    this.once('end', this.close);
                    Object.defineProperty(this, '_closed', {
                        get: function() {
                            return !_this._handle;
                        },
                        configurable: true,
                        enumerable: true
                    });
                }
                util.inherits(Zlib, Transform);
                Zlib.prototype.params = function(level, strategy, callback) {
                    if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) throw new RangeError('Invalid compression level: ' + level);
                    if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) throw new TypeError('Invalid strategy: ' + strategy);
                    if (this._level !== level || this._strategy !== strategy) {
                        var self1 = this;
                        this.flush(binding.Z_SYNC_FLUSH, function() {
                            assert(self1._handle, 'zlib binding closed');
                            self1._handle.params(level, strategy);
                            if (!self1._hadError) {
                                self1._level = level;
                                self1._strategy = strategy;
                                if (callback) callback();
                            }
                        });
                    } else process.nextTick(callback);
                };
                Zlib.prototype.reset = function() {
                    assert(this._handle, 'zlib binding closed');
                    return this._handle.reset();
                };
                // This is the _flush function called by the transform class,
                // internally, when the last chunk has been written.
                Zlib.prototype._flush = function(callback) {
                    this._transform(Buffer.alloc(0), '', callback);
                };
                Zlib.prototype.flush = function(kind, callback) {
                    var _this2 = this;
                    var ws = this._writableState;
                    if (typeof kind === 'function' || kind === undefined && !callback) {
                        callback = kind;
                        kind = binding.Z_FULL_FLUSH;
                    }
                    if (ws.ended) {
                        if (callback) process.nextTick(callback);
                    } else if (ws.ending) {
                        if (callback) this.once('end', callback);
                    } else if (ws.needDrain) {
                        if (callback) this.once('drain', function() {
                            return _this2.flush(kind, callback);
                        });
                    } else {
                        this._flushFlag = kind;
                        this.write(Buffer.alloc(0), '', callback);
                    }
                };
                Zlib.prototype.close = function(callback) {
                    _close(this, callback);
                    process.nextTick(emitCloseNT, this);
                };
                function _close(engine, callback) {
                    if (callback) process.nextTick(callback);
                    // Caller may invoke .close after a zlib error (which will null _handle).
                    if (!engine._handle) return;
                    engine._handle.close();
                    engine._handle = null;
                }
                function emitCloseNT(self1) {
                    self1.emit('close');
                }
                Zlib.prototype._transform = function(chunk, encoding, cb) {
                    var flushFlag;
                    var ws = this._writableState;
                    var ending = ws.ending || ws.ended;
                    var last = ending && (!chunk || ws.length === chunk.length);
                    if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));
                    if (!this._handle) return cb(new Error('zlib binding closed'));
                    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
                    // (or whatever flag was provided using opts.finishFlush).
                    // If it's explicitly flushing at some other time, then we use
                    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
                    // goodness.
                    if (last) flushFlag = this._finishFlushFlag;
                    else {
                        flushFlag = this._flushFlag;
                        // once we've flushed the last of the queue, stop flushing and
                        // go back to the normal behavior.
                        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
                    }
                    this._processChunk(chunk, flushFlag, cb);
                };
                Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
                    var availInBefore = chunk && chunk.length;
                    var availOutBefore = this._chunkSize - this._offset;
                    var inOff = 0;
                    var self1 = this;
                    var async = typeof cb === 'function';
                    if (!async) {
                        var buffers = [];
                        var nread = 0;
                        var error;
                        this.on('error', function(er) {
                            error = er;
                        });
                        assert(this._handle, 'zlib binding closed');
                        do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
                        while (!this._hadError && callback(res[0], res[1]));
                        if (this._hadError) throw error;
                        if (nread >= kMaxLength) {
                            _close(this);
                            throw new RangeError(kRangeErrorMessage);
                        }
                        var buf = Buffer.concat(buffers, nread);
                        _close(this);
                        return buf;
                    }
                    assert(this._handle, 'zlib binding closed');
                    var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
                    req.buffer = chunk;
                    req.callback = callback;
                    function callback(availInAfter, availOutAfter) {
                        // When the callback is used in an async write, the callback's
                        // context is the `req` object that was created. The req object
                        // is === this._handle, and that's why it's important to null
                        // out the values after they are done being used. `this._handle`
                        // can stay in memory longer than the callback and buffer are needed.
                        if (this) {
                            this.buffer = null;
                            this.callback = null;
                        }
                        if (self1._hadError) return;
                        var have = availOutBefore - availOutAfter;
                        assert(have >= 0, 'have should not go down');
                        if (have > 0) {
                            var out = self1._buffer.slice(self1._offset, self1._offset + have);
                            self1._offset += have;
                            // serve some output to the consumer.
                            if (async) self1.push(out);
                            else {
                                buffers.push(out);
                                nread += out.length;
                            }
                        }
                        // exhausted the output buffer, or used all the input create a new one.
                        if (availOutAfter === 0 || self1._offset >= self1._chunkSize) {
                            availOutBefore = self1._chunkSize;
                            self1._offset = 0;
                            self1._buffer = Buffer.allocUnsafe(self1._chunkSize);
                        }
                        if (availOutAfter === 0) {
                            // Not actually done.  Need to reprocess.
                            // Also, update the availInBefore to the availInAfter value,
                            // so that if we have to hit it a third (fourth, etc.) time,
                            // it'll have the correct byte counts.
                            inOff += availInBefore - availInAfter;
                            availInBefore = availInAfter;
                            if (!async) return true;
                            var newReq = self1._handle.write(flushFlag, chunk, inOff, availInBefore, self1._buffer, self1._offset, self1._chunkSize);
                            newReq.callback = callback; // this same function
                            newReq.buffer = chunk;
                            return;
                        }
                        if (!async) return false;
                        // finished with the chunk.
                        cb();
                    }
                };
                util.inherits(Deflate, Zlib);
                util.inherits(Inflate, Zlib);
                util.inherits(Gzip, Zlib);
                util.inherits(Gunzip, Zlib);
                util.inherits(DeflateRaw, Zlib);
                util.inherits(InflateRaw, Zlib);
                util.inherits(Unzip, Zlib);
            }).call(this, require1('_process'));
        },
        {
            "./binding": 180,
            "_process": 204,
            "assert": 177,
            "buffer": 182,
            "stream": 223,
            "util": 235
        }
    ],
    182: [
        function(require1, module, exports) {
            /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
            var base64 = require1('base64-js');
            var ieee754 = require1('ieee754');
            exports.Buffer = Buffer;
            exports.SlowBuffer = SlowBuffer;
            exports.INSPECT_MAX_BYTES = 50;
            var K_MAX_LENGTH = 0x7fffffff;
            exports.kMaxLength = K_MAX_LENGTH;
            /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
            if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
            function typedArraySupport() {
                // Can typed array instances can be augmented?
                try {
                    var arr = new Uint8Array(1);
                    arr.__proto__ = {
                        __proto__: Uint8Array.prototype,
                        foo: function() {
                            return 42;
                        }
                    };
                    return arr.foo() === 42;
                } catch (e) {
                    return false;
                }
            }
            function createBuffer(length) {
                if (length > K_MAX_LENGTH) throw new RangeError('Invalid typed array length');
                // Return an augmented `Uint8Array` instance
                var buf = new Uint8Array(length);
                buf.__proto__ = Buffer.prototype;
                return buf;
            }
            /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
                // Common case.
                if (typeof arg === 'number') {
                    if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
                    return allocUnsafe(arg);
                }
                return from(arg, encodingOrOffset, length);
            }
            // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
            if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) Object.defineProperty(Buffer, Symbol.species, {
                value: null,
                configurable: true,
                enumerable: false,
                writable: false
            });
            Buffer.poolSize = 8192 // not used by this implementation
            ;
            function from(value, encodingOrOffset, length) {
                if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
                if (isArrayBuffer(value)) return fromArrayBuffer(value, encodingOrOffset, length);
                if (typeof value === 'string') return fromString(value, encodingOrOffset);
                return fromObject(value);
            }
            /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
                return from(value, encodingOrOffset, length);
            };
            // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
            // https://github.com/feross/buffer/pull/148
            Buffer.prototype.__proto__ = Uint8Array.prototype;
            Buffer.__proto__ = Uint8Array;
            function assertSize(size) {
                if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
                else if (size < 0) throw new RangeError('"size" argument must not be negative');
            }
            function alloc(size, fill, encoding) {
                assertSize(size);
                if (size <= 0) return createBuffer(size);
                if (fill !== undefined) // Only pay attention to encoding if it's a string. This
                // prevents accidentally sending in a number that would
                // be interpretted as a start offset.
                return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
                return createBuffer(size);
            }
            /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
                return alloc(size, fill, encoding);
            };
            function allocUnsafe(size) {
                assertSize(size);
                return createBuffer(size < 0 ? 0 : checked(size) | 0);
            }
            /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
                return allocUnsafe(size);
            };
            /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
                return allocUnsafe(size);
            };
            function fromString(string, encoding) {
                if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
                if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
                var length = byteLength(string, encoding) | 0;
                var buf = createBuffer(length);
                var actual = buf.write(string, encoding);
                if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
                // cause everything after the first invalid character to be ignored. (e.g.
                // 'abxxcd' will be treated as 'ab')
                buf = buf.slice(0, actual);
                return buf;
            }
            function fromArrayLike(array) {
                var length = array.length < 0 ? 0 : checked(array.length) | 0;
                var buf = createBuffer(length);
                for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
                return buf;
            }
            function fromArrayBuffer(array, byteOffset, length) {
                if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
                if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
                var buf;
                if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
                else if (length === undefined) buf = new Uint8Array(array, byteOffset);
                else buf = new Uint8Array(array, byteOffset, length);
                // Return an augmented `Uint8Array` instance
                buf.__proto__ = Buffer.prototype;
                return buf;
            }
            function fromObject(obj) {
                if (Buffer.isBuffer(obj)) {
                    var len = checked(obj.length) | 0;
                    var buf = createBuffer(len);
                    if (buf.length === 0) return buf;
                    obj.copy(buf, 0, 0, len);
                    return buf;
                }
                if (obj) {
                    if (isArrayBufferView(obj) || 'length' in obj) {
                        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
                        return fromArrayLike(obj);
                    }
                    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
                }
                throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
            }
            function checked(length) {
                // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
                // length is NaN (which is otherwise coerced to zero.)
                if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
                return length | 0;
            }
            function SlowBuffer(length) {
                if (+length != length) length = 0;
                return Buffer.alloc(+length);
            }
            Buffer.isBuffer = function isBuffer(b) {
                return b != null && b._isBuffer === true;
            };
            Buffer.compare = function compare(a, b) {
                if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('Arguments must be Buffers');
                if (a === b) return 0;
                var x = a.length;
                var y = b.length;
                for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                    x = a[i];
                    y = b[i];
                    break;
                }
                if (x < y) return -1;
                if (y < x) return 1;
                return 0;
            };
            Buffer.isEncoding = function isEncoding(encoding) {
                switch(String(encoding).toLowerCase()){
                    case 'hex':
                    case 'utf8':
                    case 'utf-8':
                    case 'ascii':
                    case 'latin1':
                    case 'binary':
                    case 'base64':
                    case 'ucs2':
                    case 'ucs-2':
                    case 'utf16le':
                    case 'utf-16le':
                        return true;
                    default:
                        return false;
                }
            };
            Buffer.concat = function concat(list, length) {
                if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
                if (list.length === 0) return Buffer.alloc(0);
                var i;
                if (length === undefined) {
                    length = 0;
                    for(i = 0; i < list.length; ++i)length += list[i].length;
                }
                var buffer = Buffer.allocUnsafe(length);
                var pos = 0;
                for(i = 0; i < list.length; ++i){
                    var buf = list[i];
                    if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
                    buf.copy(buffer, pos);
                    pos += buf.length;
                }
                return buffer;
            };
            function byteLength(string, encoding) {
                if (Buffer.isBuffer(string)) return string.length;
                if (isArrayBufferView(string) || isArrayBuffer(string)) return string.byteLength;
                if (typeof string !== 'string') string = '' + string;
                var len = string.length;
                if (len === 0) return 0;
                // Use a for loop to avoid recursion
                var loweredCase = false;
                for(;;)switch(encoding){
                    case 'ascii':
                    case 'latin1':
                    case 'binary':
                        return len;
                    case 'utf8':
                    case 'utf-8':
                    case undefined:
                        return utf8ToBytes(string).length;
                    case 'ucs2':
                    case 'ucs-2':
                    case 'utf16le':
                    case 'utf-16le':
                        return len * 2;
                    case 'hex':
                        return len >>> 1;
                    case 'base64':
                        return base64ToBytes(string).length;
                    default:
                        if (loweredCase) return utf8ToBytes(string).length // assume utf8
                        ;
                        encoding = ('' + encoding).toLowerCase();
                        loweredCase = true;
                }
            }
            Buffer.byteLength = byteLength;
            function slowToString(encoding, start, end) {
                var loweredCase = false;
                // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
                // property of a typed array.
                // This behaves neither like String nor Uint8Array in that we set start/end
                // to their upper/lower bounds if the value passed is out of range.
                // undefined is handled specially as per ECMA-262 6th Edition,
                // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
                if (start === undefined || start < 0) start = 0;
                // Return early if start > this.length. Done here to prevent potential uint32
                // coercion fail below.
                if (start > this.length) return '';
                if (end === undefined || end > this.length) end = this.length;
                if (end <= 0) return '';
                // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
                end >>>= 0;
                start >>>= 0;
                if (end <= start) return '';
                if (!encoding) encoding = 'utf8';
                while(true)switch(encoding){
                    case 'hex':
                        return hexSlice(this, start, end);
                    case 'utf8':
                    case 'utf-8':
                        return utf8Slice(this, start, end);
                    case 'ascii':
                        return asciiSlice(this, start, end);
                    case 'latin1':
                    case 'binary':
                        return latin1Slice(this, start, end);
                    case 'base64':
                        return base64Slice(this, start, end);
                    case 'ucs2':
                    case 'ucs-2':
                    case 'utf16le':
                    case 'utf-16le':
                        return utf16leSlice(this, start, end);
                    default:
                        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                        encoding = (encoding + '').toLowerCase();
                        loweredCase = true;
                }
            }
            // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
            // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
            // reliably in a browserify context because there could be multiple different
            // copies of the 'buffer' package in use. This method works even for Buffer
            // instances that were created from another copy of the `buffer` package.
            // See: https://github.com/feross/buffer/issues/154
            Buffer.prototype._isBuffer = true;
            function swap(b, n, m) {
                var i = b[n];
                b[n] = b[m];
                b[m] = i;
            }
            Buffer.prototype.swap16 = function swap16() {
                var len = this.length;
                if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
                for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
                return this;
            };
            Buffer.prototype.swap32 = function swap32() {
                var len = this.length;
                if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
                for(var i = 0; i < len; i += 4){
                    swap(this, i, i + 3);
                    swap(this, i + 1, i + 2);
                }
                return this;
            };
            Buffer.prototype.swap64 = function swap64() {
                var len = this.length;
                if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
                for(var i = 0; i < len; i += 8){
                    swap(this, i, i + 7);
                    swap(this, i + 1, i + 6);
                    swap(this, i + 2, i + 5);
                    swap(this, i + 3, i + 4);
                }
                return this;
            };
            Buffer.prototype.toString = function toString() {
                var length = this.length;
                if (length === 0) return '';
                if (arguments.length === 0) return utf8Slice(this, 0, length);
                return slowToString.apply(this, arguments);
            };
            Buffer.prototype.equals = function equals(b) {
                if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
                if (this === b) return true;
                return Buffer.compare(this, b) === 0;
            };
            Buffer.prototype.inspect = function inspect() {
                var str = '';
                var max = exports.INSPECT_MAX_BYTES;
                if (this.length > 0) {
                    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
                    if (this.length > max) str += ' ... ';
                }
                return '<Buffer ' + str + '>';
            };
            Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
                if (!Buffer.isBuffer(target)) throw new TypeError('Argument must be a Buffer');
                if (start === undefined) start = 0;
                if (end === undefined) end = target ? target.length : 0;
                if (thisStart === undefined) thisStart = 0;
                if (thisEnd === undefined) thisEnd = this.length;
                if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
                if (thisStart >= thisEnd && start >= end) return 0;
                if (thisStart >= thisEnd) return -1;
                if (start >= end) return 1;
                start >>>= 0;
                end >>>= 0;
                thisStart >>>= 0;
                thisEnd >>>= 0;
                if (this === target) return 0;
                var x = thisEnd - thisStart;
                var y = end - start;
                var len = Math.min(x, y);
                var thisCopy = this.slice(thisStart, thisEnd);
                var targetCopy = target.slice(start, end);
                for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
                    x = thisCopy[i];
                    y = targetCopy[i];
                    break;
                }
                if (x < y) return -1;
                if (y < x) return 1;
                return 0;
            };
            // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
            // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
            //
            // Arguments:
            // - buffer - a Buffer to search
            // - val - a string, Buffer, or number
            // - byteOffset - an index into `buffer`; will be clamped to an int32
            // - encoding - an optional encoding, relevant is val is a string
            // - dir - true for indexOf, false for lastIndexOf
            function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
                // Empty buffer means no match
                if (buffer.length === 0) return -1;
                // Normalize byteOffset
                if (typeof byteOffset === 'string') {
                    encoding = byteOffset;
                    byteOffset = 0;
                } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
                else if (byteOffset < -2147483648) byteOffset = -2147483648;
                byteOffset = +byteOffset // Coerce to Number.
                ;
                if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
                byteOffset = dir ? 0 : buffer.length - 1;
                // Normalize byteOffset: negative offsets start from the end of the buffer
                if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
                if (byteOffset >= buffer.length) {
                    if (dir) return -1;
                    else byteOffset = buffer.length - 1;
                } else if (byteOffset < 0) {
                    if (dir) byteOffset = 0;
                    else return -1;
                }
                // Normalize val
                if (typeof val === 'string') val = Buffer.from(val, encoding);
                // Finally, search either indexOf (if dir is true) or lastIndexOf
                if (Buffer.isBuffer(val)) {
                    // Special case: looking for empty string/buffer always fails
                    if (val.length === 0) return -1;
                    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
                } else if (typeof val === 'number') {
                    val = val & 0xFF // Search for a byte value [0-255]
                    ;
                    if (typeof Uint8Array.prototype.indexOf === 'function') {
                        if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                        else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                    }
                    return arrayIndexOf(buffer, [
                        val
                    ], byteOffset, encoding, dir);
                }
                throw new TypeError('val must be string, number or Buffer');
            }
            function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
                var indexSize = 1;
                var arrLength = arr.length;
                var valLength = val.length;
                if (encoding !== undefined) {
                    encoding = String(encoding).toLowerCase();
                    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                        if (arr.length < 2 || val.length < 2) return -1;
                        indexSize = 2;
                        arrLength /= 2;
                        valLength /= 2;
                        byteOffset /= 2;
                    }
                }
                function read(buf, i) {
                    if (indexSize === 1) return buf[i];
                    else return buf.readUInt16BE(i * indexSize);
                }
                var i;
                if (dir) {
                    var foundIndex = -1;
                    for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                        if (foundIndex === -1) foundIndex = i;
                        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                    } else {
                        if (foundIndex !== -1) i -= i - foundIndex;
                        foundIndex = -1;
                    }
                } else {
                    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                    for(i = byteOffset; i >= 0; i--){
                        var found = true;
                        for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                            found = false;
                            break;
                        }
                        if (found) return i;
                    }
                }
                return -1;
            }
            Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
                return this.indexOf(val, byteOffset, encoding) !== -1;
            };
            Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
                return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
            };
            Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
                return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
            };
            function hexWrite(buf, string, offset, length) {
                offset = Number(offset) || 0;
                var remaining = buf.length - offset;
                if (!length) length = remaining;
                else {
                    length = Number(length);
                    if (length > remaining) length = remaining;
                }
                // must be an even number of digits
                var strLen = string.length;
                if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
                if (length > strLen / 2) length = strLen / 2;
                for(var i = 0; i < length; ++i){
                    var parsed = parseInt(string.substr(i * 2, 2), 16);
                    if (numberIsNaN(parsed)) return i;
                    buf[offset + i] = parsed;
                }
                return i;
            }
            function utf8Write(buf, string, offset, length) {
                return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
            }
            function asciiWrite(buf, string, offset, length) {
                return blitBuffer(asciiToBytes(string), buf, offset, length);
            }
            function latin1Write(buf, string, offset, length) {
                return asciiWrite(buf, string, offset, length);
            }
            function base64Write(buf, string, offset, length) {
                return blitBuffer(base64ToBytes(string), buf, offset, length);
            }
            function ucs2Write(buf, string, offset, length) {
                return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
            }
            Buffer.prototype.write = function write(string, offset, length, encoding) {
                // Buffer#write(string)
                if (offset === undefined) {
                    encoding = 'utf8';
                    length = this.length;
                    offset = 0;
                // Buffer#write(string, encoding)
                } else if (length === undefined && typeof offset === 'string') {
                    encoding = offset;
                    length = this.length;
                    offset = 0;
                // Buffer#write(string, offset[, length][, encoding])
                } else if (isFinite(offset)) {
                    offset = offset >>> 0;
                    if (isFinite(length)) {
                        length = length >>> 0;
                        if (encoding === undefined) encoding = 'utf8';
                    } else {
                        encoding = length;
                        length = undefined;
                    }
                } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
                var remaining = this.length - offset;
                if (length === undefined || length > remaining) length = remaining;
                if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
                if (!encoding) encoding = 'utf8';
                var loweredCase = false;
                for(;;)switch(encoding){
                    case 'hex':
                        return hexWrite(this, string, offset, length);
                    case 'utf8':
                    case 'utf-8':
                        return utf8Write(this, string, offset, length);
                    case 'ascii':
                        return asciiWrite(this, string, offset, length);
                    case 'latin1':
                    case 'binary':
                        return latin1Write(this, string, offset, length);
                    case 'base64':
                        // Warning: maxLength not taken into account in base64Write
                        return base64Write(this, string, offset, length);
                    case 'ucs2':
                    case 'ucs-2':
                    case 'utf16le':
                    case 'utf-16le':
                        return ucs2Write(this, string, offset, length);
                    default:
                        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                        encoding = ('' + encoding).toLowerCase();
                        loweredCase = true;
                }
            };
            Buffer.prototype.toJSON = function toJSON() {
                return {
                    type: 'Buffer',
                    data: Array.prototype.slice.call(this._arr || this, 0)
                };
            };
            function base64Slice(buf, start, end) {
                if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
                else return base64.fromByteArray(buf.slice(start, end));
            }
            function utf8Slice(buf, start, end) {
                end = Math.min(buf.length, end);
                var res = [];
                var i = start;
                while(i < end){
                    var firstByte = buf[i];
                    var codePoint = null;
                    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
                    if (i + bytesPerSequence <= end) {
                        var secondByte, thirdByte, fourthByte, tempCodePoint;
                        switch(bytesPerSequence){
                            case 1:
                                if (firstByte < 0x80) codePoint = firstByte;
                                break;
                            case 2:
                                secondByte = buf[i + 1];
                                if ((secondByte & 0xC0) === 0x80) {
                                    tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                                    if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                                }
                                break;
                            case 3:
                                secondByte = buf[i + 1];
                                thirdByte = buf[i + 2];
                                if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                                    tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                                    if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                                }
                                break;
                            case 4:
                                secondByte = buf[i + 1];
                                thirdByte = buf[i + 2];
                                fourthByte = buf[i + 3];
                                if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                                    tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                                    if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                                }
                        }
                    }
                    if (codePoint === null) {
                        // we did not generate a valid codePoint so insert a
                        // replacement char (U+FFFD) and advance only 1 byte
                        codePoint = 0xFFFD;
                        bytesPerSequence = 1;
                    } else if (codePoint > 0xFFFF) {
                        // encode to utf16 (surrogate pair dance)
                        codePoint -= 0x10000;
                        res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                        codePoint = 0xDC00 | codePoint & 0x3FF;
                    }
                    res.push(codePoint);
                    i += bytesPerSequence;
                }
                return decodeCodePointsArray(res);
            }
            // Based on http://stackoverflow.com/a/22747272/680742, the browser with
            // the lowest limit is Chrome, with 0x10000 args.
            // We go 1 magnitude less, for safety
            var MAX_ARGUMENTS_LENGTH = 0x1000;
            function decodeCodePointsArray(codePoints) {
                var len = codePoints.length;
                if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
                ;
                // Decode in chunks to avoid "call stack size exceeded".
                var res = '';
                var i = 0;
                while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
                return res;
            }
            function asciiSlice(buf, start, end) {
                var ret = '';
                end = Math.min(buf.length, end);
                for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
                return ret;
            }
            function latin1Slice(buf, start, end) {
                var ret = '';
                end = Math.min(buf.length, end);
                for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
                return ret;
            }
            function hexSlice(buf, start, end) {
                var len = buf.length;
                if (!start || start < 0) start = 0;
                if (!end || end < 0 || end > len) end = len;
                var out = '';
                for(var i = start; i < end; ++i)out += toHex(buf[i]);
                return out;
            }
            function utf16leSlice(buf, start, end) {
                var bytes = buf.slice(start, end);
                var res = '';
                for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
                return res;
            }
            Buffer.prototype.slice = function slice(start, end) {
                var len = this.length;
                start = ~~start;
                end = end === undefined ? len : ~~end;
                if (start < 0) {
                    start += len;
                    if (start < 0) start = 0;
                } else if (start > len) start = len;
                if (end < 0) {
                    end += len;
                    if (end < 0) end = 0;
                } else if (end > len) end = len;
                if (end < start) end = start;
                var newBuf = this.subarray(start, end);
                // Return an augmented `Uint8Array` instance
                newBuf.__proto__ = Buffer.prototype;
                return newBuf;
            };
            /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
                if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
                if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
            }
            Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
                offset = offset >>> 0;
                byteLength = byteLength >>> 0;
                if (!noAssert) checkOffset(offset, byteLength, this.length);
                var val = this[offset];
                var mul = 1;
                var i = 0;
                while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                return val;
            };
            Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
                offset = offset >>> 0;
                byteLength = byteLength >>> 0;
                if (!noAssert) checkOffset(offset, byteLength, this.length);
                var val = this[offset + --byteLength];
                var mul = 1;
                while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
                return val;
            };
            Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 1, this.length);
                return this[offset];
            };
            Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 2, this.length);
                return this[offset] | this[offset + 1] << 8;
            };
            Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 2, this.length);
                return this[offset] << 8 | this[offset + 1];
            };
            Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 4, this.length);
                return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
            };
            Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 4, this.length);
                return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
            };
            Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
                offset = offset >>> 0;
                byteLength = byteLength >>> 0;
                if (!noAssert) checkOffset(offset, byteLength, this.length);
                var val = this[offset];
                var mul = 1;
                var i = 0;
                while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                mul *= 0x80;
                if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                return val;
            };
            Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
                offset = offset >>> 0;
                byteLength = byteLength >>> 0;
                if (!noAssert) checkOffset(offset, byteLength, this.length);
                var i = byteLength;
                var mul = 1;
                var val = this[offset + --i];
                while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
                mul *= 0x80;
                if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                return val;
            };
            Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 1, this.length);
                if (!(this[offset] & 0x80)) return this[offset];
                return (0xff - this[offset] + 1) * -1;
            };
            Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 2, this.length);
                var val = this[offset] | this[offset + 1] << 8;
                return val & 0x8000 ? val | 0xFFFF0000 : val;
            };
            Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 2, this.length);
                var val = this[offset + 1] | this[offset] << 8;
                return val & 0x8000 ? val | 0xFFFF0000 : val;
            };
            Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 4, this.length);
                return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
            };
            Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 4, this.length);
                return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
            };
            Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 4, this.length);
                return ieee754.read(this, offset, true, 23, 4);
            };
            Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 4, this.length);
                return ieee754.read(this, offset, false, 23, 4);
            };
            Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 8, this.length);
                return ieee754.read(this, offset, true, 52, 8);
            };
            Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
                offset = offset >>> 0;
                if (!noAssert) checkOffset(offset, 8, this.length);
                return ieee754.read(this, offset, false, 52, 8);
            };
            function checkInt(buf, value, offset, ext, max, min) {
                if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
                if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
                if (offset + ext > buf.length) throw new RangeError('Index out of range');
            }
            Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
                value = +value;
                offset = offset >>> 0;
                byteLength = byteLength >>> 0;
                if (!noAssert) {
                    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                    checkInt(this, value, offset, byteLength, maxBytes, 0);
                }
                var mul = 1;
                var i = 0;
                this[offset] = value & 0xFF;
                while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                return offset + byteLength;
            };
            Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
                value = +value;
                offset = offset >>> 0;
                byteLength = byteLength >>> 0;
                if (!noAssert) {
                    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                    checkInt(this, value, offset, byteLength, maxBytes, 0);
                }
                var i = byteLength - 1;
                var mul = 1;
                this[offset + i] = value & 0xFF;
                while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                return offset + byteLength;
            };
            Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
                this[offset] = value & 0xff;
                return offset + 1;
            };
            Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                this[offset] = value & 0xff;
                this[offset + 1] = value >>> 8;
                return offset + 2;
            };
            Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                this[offset] = value >>> 8;
                this[offset + 1] = value & 0xff;
                return offset + 2;
            };
            Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                this[offset + 3] = value >>> 24;
                this[offset + 2] = value >>> 16;
                this[offset + 1] = value >>> 8;
                this[offset] = value & 0xff;
                return offset + 4;
            };
            Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                this[offset] = value >>> 24;
                this[offset + 1] = value >>> 16;
                this[offset + 2] = value >>> 8;
                this[offset + 3] = value & 0xff;
                return offset + 4;
            };
            Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) {
                    var limit = Math.pow(2, 8 * byteLength - 1);
                    checkInt(this, value, offset, byteLength, limit - 1, -limit);
                }
                var i = 0;
                var mul = 1;
                var sub = 0;
                this[offset] = value & 0xFF;
                while(++i < byteLength && (mul *= 0x100)){
                    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
                    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                }
                return offset + byteLength;
            };
            Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) {
                    var limit = Math.pow(2, 8 * byteLength - 1);
                    checkInt(this, value, offset, byteLength, limit - 1, -limit);
                }
                var i = byteLength - 1;
                var mul = 1;
                var sub = 0;
                this[offset + i] = value & 0xFF;
                while(--i >= 0 && (mul *= 0x100)){
                    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
                    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                }
                return offset + byteLength;
            };
            Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
                if (value < 0) value = 0xff + value + 1;
                this[offset] = value & 0xff;
                return offset + 1;
            };
            Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                this[offset] = value & 0xff;
                this[offset + 1] = value >>> 8;
                return offset + 2;
            };
            Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                this[offset] = value >>> 8;
                this[offset + 1] = value & 0xff;
                return offset + 2;
            };
            Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                this[offset] = value & 0xff;
                this[offset + 1] = value >>> 8;
                this[offset + 2] = value >>> 16;
                this[offset + 3] = value >>> 24;
                return offset + 4;
            };
            Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                if (value < 0) value = 0xffffffff + value + 1;
                this[offset] = value >>> 24;
                this[offset + 1] = value >>> 16;
                this[offset + 2] = value >>> 8;
                this[offset + 3] = value & 0xff;
                return offset + 4;
            };
            function checkIEEE754(buf, value, offset, ext, max, min) {
                if (offset + ext > buf.length) throw new RangeError('Index out of range');
                if (offset < 0) throw new RangeError('Index out of range');
            }
            function writeFloat(buf, value, offset, littleEndian, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
                ieee754.write(buf, value, offset, littleEndian, 23, 4);
                return offset + 4;
            }
            Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
                return writeFloat(this, value, offset, true, noAssert);
            };
            Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
                return writeFloat(this, value, offset, false, noAssert);
            };
            function writeDouble(buf, value, offset, littleEndian, noAssert) {
                value = +value;
                offset = offset >>> 0;
                if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
                ieee754.write(buf, value, offset, littleEndian, 52, 8);
                return offset + 8;
            }
            Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
                return writeDouble(this, value, offset, true, noAssert);
            };
            Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
                return writeDouble(this, value, offset, false, noAssert);
            };
            // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
            Buffer.prototype.copy = function copy(target, targetStart, start, end) {
                if (!start) start = 0;
                if (!end && end !== 0) end = this.length;
                if (targetStart >= target.length) targetStart = target.length;
                if (!targetStart) targetStart = 0;
                if (end > 0 && end < start) end = start;
                // Copy 0 bytes; we're done
                if (end === start) return 0;
                if (target.length === 0 || this.length === 0) return 0;
                // Fatal error conditions
                if (targetStart < 0) throw new RangeError('targetStart out of bounds');
                if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
                if (end < 0) throw new RangeError('sourceEnd out of bounds');
                // Are we oob?
                if (end > this.length) end = this.length;
                if (target.length - targetStart < end - start) end = target.length - targetStart + start;
                var len = end - start;
                var i;
                if (this === target && start < targetStart && targetStart < end) // descending copy from end
                for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
                else if (len < 1000) // ascending copy from start
                for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
                else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
                return len;
            };
            // Usage:
            //    buffer.fill(number[, offset[, end]])
            //    buffer.fill(buffer[, offset[, end]])
            //    buffer.fill(string[, offset[, end]][, encoding])
            Buffer.prototype.fill = function fill(val, start, end, encoding) {
                // Handle string cases:
                if (typeof val === 'string') {
                    if (typeof start === 'string') {
                        encoding = start;
                        start = 0;
                        end = this.length;
                    } else if (typeof end === 'string') {
                        encoding = end;
                        end = this.length;
                    }
                    if (val.length === 1) {
                        var code = val.charCodeAt(0);
                        if (code < 256) val = code;
                    }
                    if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
                    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
                } else if (typeof val === 'number') val = val & 255;
                // Invalid ranges are not set to a default, so can range check early.
                if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
                if (end <= start) return this;
                start = start >>> 0;
                end = end === undefined ? this.length : end >>> 0;
                if (!val) val = 0;
                var i;
                if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
                else {
                    var bytes = Buffer.isBuffer(val) ? val : new Buffer(val, encoding);
                    var len = bytes.length;
                    for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
                }
                return this;
            };
            // HELPER FUNCTIONS
            // ================
            var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
            function base64clean(str) {
                // Node strips out invalid characters like \n and \t from the string, base64-js does not
                str = str.trim().replace(INVALID_BASE64_RE, '');
                // Node converts strings with length < 2 to ''
                if (str.length < 2) return '';
                // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
                while(str.length % 4 !== 0)str = str + '=';
                return str;
            }
            function toHex(n) {
                if (n < 16) return '0' + n.toString(16);
                return n.toString(16);
            }
            function utf8ToBytes(string, units) {
                units = units || Infinity;
                var codePoint;
                var length = string.length;
                var leadSurrogate = null;
                var bytes = [];
                for(var i = 0; i < length; ++i){
                    codePoint = string.charCodeAt(i);
                    // is surrogate component
                    if (codePoint > 0xD7FF && codePoint < 0xE000) {
                        // last char was a lead
                        if (!leadSurrogate) {
                            // no lead yet
                            if (codePoint > 0xDBFF) {
                                // unexpected trail
                                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                continue;
                            } else if (i + 1 === length) {
                                // unpaired lead
                                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                continue;
                            }
                            // valid lead
                            leadSurrogate = codePoint;
                            continue;
                        }
                        // 2 leads in a row
                        if (codePoint < 0xDC00) {
                            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                            leadSurrogate = codePoint;
                            continue;
                        }
                        // valid surrogate pair
                        codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
                    } else if (leadSurrogate) // valid bmp char, but last char was a lead
                    {
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    }
                    leadSurrogate = null;
                    // encode utf8
                    if (codePoint < 0x80) {
                        if ((units -= 1) < 0) break;
                        bytes.push(codePoint);
                    } else if (codePoint < 0x800) {
                        if ((units -= 2) < 0) break;
                        bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
                    } else if (codePoint < 0x10000) {
                        if ((units -= 3) < 0) break;
                        bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                    } else if (codePoint < 0x110000) {
                        if ((units -= 4) < 0) break;
                        bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                    } else throw new Error('Invalid code point');
                }
                return bytes;
            }
            function asciiToBytes(str) {
                var byteArray = [];
                for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
                byteArray.push(str.charCodeAt(i) & 0xFF);
                return byteArray;
            }
            function utf16leToBytes(str, units) {
                var c, hi, lo;
                var byteArray = [];
                for(var i = 0; i < str.length; ++i){
                    if ((units -= 2) < 0) break;
                    c = str.charCodeAt(i);
                    hi = c >> 8;
                    lo = c % 256;
                    byteArray.push(lo);
                    byteArray.push(hi);
                }
                return byteArray;
            }
            function base64ToBytes(str) {
                return base64.toByteArray(base64clean(str));
            }
            function blitBuffer(src, dst, offset, length) {
                for(var i = 0; i < length; ++i){
                    if (i + offset >= dst.length || i >= src.length) break;
                    dst[i + offset] = src[i];
                }
                return i;
            }
            // ArrayBuffers from another context (i.e. an iframe) do not pass the `instanceof` check
            // but they should be treated as valid. See: https://github.com/feross/buffer/issues/166
            function isArrayBuffer(obj) {
                return obj instanceof ArrayBuffer || obj != null && obj.constructor != null && obj.constructor.name === 'ArrayBuffer' && typeof obj.byteLength === 'number';
            }
            // Node 0.10 supports `ArrayBuffer` but lacks `ArrayBuffer.isView`
            function isArrayBufferView(obj) {
                return typeof ArrayBuffer.isView === 'function' && ArrayBuffer.isView(obj);
            }
            function numberIsNaN(obj) {
                return obj !== obj // eslint-disable-line no-self-compare
                ;
            }
        },
        {
            "base64-js": 178,
            "ieee754": 188
        }
    ],
    183: [
        function(require1, module, exports) {
            module.exports = {
                "100": "Continue",
                "101": "Switching Protocols",
                "102": "Processing",
                "200": "OK",
                "201": "Created",
                "202": "Accepted",
                "203": "Non-Authoritative Information",
                "204": "No Content",
                "205": "Reset Content",
                "206": "Partial Content",
                "207": "Multi-Status",
                "208": "Already Reported",
                "226": "IM Used",
                "300": "Multiple Choices",
                "301": "Moved Permanently",
                "302": "Found",
                "303": "See Other",
                "304": "Not Modified",
                "305": "Use Proxy",
                "307": "Temporary Redirect",
                "308": "Permanent Redirect",
                "400": "Bad Request",
                "401": "Unauthorized",
                "402": "Payment Required",
                "403": "Forbidden",
                "404": "Not Found",
                "405": "Method Not Allowed",
                "406": "Not Acceptable",
                "407": "Proxy Authentication Required",
                "408": "Request Timeout",
                "409": "Conflict",
                "410": "Gone",
                "411": "Length Required",
                "412": "Precondition Failed",
                "413": "Payload Too Large",
                "414": "URI Too Long",
                "415": "Unsupported Media Type",
                "416": "Range Not Satisfiable",
                "417": "Expectation Failed",
                "418": "I'm a teapot",
                "421": "Misdirected Request",
                "422": "Unprocessable Entity",
                "423": "Locked",
                "424": "Failed Dependency",
                "425": "Unordered Collection",
                "426": "Upgrade Required",
                "428": "Precondition Required",
                "429": "Too Many Requests",
                "431": "Request Header Fields Too Large",
                "451": "Unavailable For Legal Reasons",
                "500": "Internal Server Error",
                "501": "Not Implemented",
                "502": "Bad Gateway",
                "503": "Service Unavailable",
                "504": "Gateway Timeout",
                "505": "HTTP Version Not Supported",
                "506": "Variant Also Negotiates",
                "507": "Insufficient Storage",
                "508": "Loop Detected",
                "509": "Bandwidth Limit Exceeded",
                "510": "Not Extended",
                "511": "Network Authentication Required"
            };
        },
        {}
    ],
    184: [
        function(require1, module, exports) {
            module.exports = {
                "O_RDONLY": 0,
                "O_WRONLY": 1,
                "O_RDWR": 2,
                "S_IFMT": 61440,
                "S_IFREG": 32768,
                "S_IFDIR": 16384,
                "S_IFCHR": 8192,
                "S_IFBLK": 24576,
                "S_IFIFO": 4096,
                "S_IFLNK": 40960,
                "S_IFSOCK": 49152,
                "O_CREAT": 512,
                "O_EXCL": 2048,
                "O_NOCTTY": 131072,
                "O_TRUNC": 1024,
                "O_APPEND": 8,
                "O_DIRECTORY": 1048576,
                "O_NOFOLLOW": 256,
                "O_SYNC": 128,
                "O_SYMLINK": 2097152,
                "O_NONBLOCK": 4,
                "S_IRWXU": 448,
                "S_IRUSR": 256,
                "S_IWUSR": 128,
                "S_IXUSR": 64,
                "S_IRWXG": 56,
                "S_IRGRP": 32,
                "S_IWGRP": 16,
                "S_IXGRP": 8,
                "S_IRWXO": 7,
                "S_IROTH": 4,
                "S_IWOTH": 2,
                "S_IXOTH": 1,
                "E2BIG": 7,
                "EACCES": 13,
                "EADDRINUSE": 48,
                "EADDRNOTAVAIL": 49,
                "EAFNOSUPPORT": 47,
                "EAGAIN": 35,
                "EALREADY": 37,
                "EBADF": 9,
                "EBADMSG": 94,
                "EBUSY": 16,
                "ECANCELED": 89,
                "ECHILD": 10,
                "ECONNABORTED": 53,
                "ECONNREFUSED": 61,
                "ECONNRESET": 54,
                "EDEADLK": 11,
                "EDESTADDRREQ": 39,
                "EDOM": 33,
                "EDQUOT": 69,
                "EEXIST": 17,
                "EFAULT": 14,
                "EFBIG": 27,
                "EHOSTUNREACH": 65,
                "EIDRM": 90,
                "EILSEQ": 92,
                "EINPROGRESS": 36,
                "EINTR": 4,
                "EINVAL": 22,
                "EIO": 5,
                "EISCONN": 56,
                "EISDIR": 21,
                "ELOOP": 62,
                "EMFILE": 24,
                "EMLINK": 31,
                "EMSGSIZE": 40,
                "EMULTIHOP": 95,
                "ENAMETOOLONG": 63,
                "ENETDOWN": 50,
                "ENETRESET": 52,
                "ENETUNREACH": 51,
                "ENFILE": 23,
                "ENOBUFS": 55,
                "ENODATA": 96,
                "ENODEV": 19,
                "ENOENT": 2,
                "ENOEXEC": 8,
                "ENOLCK": 77,
                "ENOLINK": 97,
                "ENOMEM": 12,
                "ENOMSG": 91,
                "ENOPROTOOPT": 42,
                "ENOSPC": 28,
                "ENOSR": 98,
                "ENOSTR": 99,
                "ENOSYS": 78,
                "ENOTCONN": 57,
                "ENOTDIR": 20,
                "ENOTEMPTY": 66,
                "ENOTSOCK": 38,
                "ENOTSUP": 45,
                "ENOTTY": 25,
                "ENXIO": 6,
                "EOPNOTSUPP": 102,
                "EOVERFLOW": 84,
                "EPERM": 1,
                "EPIPE": 32,
                "EPROTO": 100,
                "EPROTONOSUPPORT": 43,
                "EPROTOTYPE": 41,
                "ERANGE": 34,
                "EROFS": 30,
                "ESPIPE": 29,
                "ESRCH": 3,
                "ESTALE": 70,
                "ETIME": 101,
                "ETIMEDOUT": 60,
                "ETXTBSY": 26,
                "EWOULDBLOCK": 35,
                "EXDEV": 18,
                "SIGHUP": 1,
                "SIGINT": 2,
                "SIGQUIT": 3,
                "SIGILL": 4,
                "SIGTRAP": 5,
                "SIGABRT": 6,
                "SIGIOT": 6,
                "SIGBUS": 10,
                "SIGFPE": 8,
                "SIGKILL": 9,
                "SIGUSR1": 30,
                "SIGSEGV": 11,
                "SIGUSR2": 31,
                "SIGPIPE": 13,
                "SIGALRM": 14,
                "SIGTERM": 15,
                "SIGCHLD": 20,
                "SIGCONT": 19,
                "SIGSTOP": 17,
                "SIGTSTP": 18,
                "SIGTTIN": 21,
                "SIGTTOU": 22,
                "SIGURG": 16,
                "SIGXCPU": 24,
                "SIGXFSZ": 25,
                "SIGVTALRM": 26,
                "SIGPROF": 27,
                "SIGWINCH": 28,
                "SIGIO": 23,
                "SIGSYS": 12,
                "SSL_OP_ALL": 2147486719,
                "SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION": 262144,
                "SSL_OP_CIPHER_SERVER_PREFERENCE": 4194304,
                "SSL_OP_CISCO_ANYCONNECT": 32768,
                "SSL_OP_COOKIE_EXCHANGE": 8192,
                "SSL_OP_CRYPTOPRO_TLSEXT_BUG": 2147483648,
                "SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS": 2048,
                "SSL_OP_EPHEMERAL_RSA": 0,
                "SSL_OP_LEGACY_SERVER_CONNECT": 4,
                "SSL_OP_MICROSOFT_BIG_SSLV3_BUFFER": 32,
                "SSL_OP_MICROSOFT_SESS_ID_BUG": 1,
                "SSL_OP_MSIE_SSLV2_RSA_PADDING": 0,
                "SSL_OP_NETSCAPE_CA_DN_BUG": 536870912,
                "SSL_OP_NETSCAPE_CHALLENGE_BUG": 2,
                "SSL_OP_NETSCAPE_DEMO_CIPHER_CHANGE_BUG": 1073741824,
                "SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG": 8,
                "SSL_OP_NO_COMPRESSION": 131072,
                "SSL_OP_NO_QUERY_MTU": 4096,
                "SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION": 65536,
                "SSL_OP_NO_SSLv2": 16777216,
                "SSL_OP_NO_SSLv3": 33554432,
                "SSL_OP_NO_TICKET": 16384,
                "SSL_OP_NO_TLSv1": 67108864,
                "SSL_OP_NO_TLSv1_1": 268435456,
                "SSL_OP_NO_TLSv1_2": 134217728,
                "SSL_OP_PKCS1_CHECK_1": 0,
                "SSL_OP_PKCS1_CHECK_2": 0,
                "SSL_OP_SINGLE_DH_USE": 1048576,
                "SSL_OP_SINGLE_ECDH_USE": 524288,
                "SSL_OP_SSLEAY_080_CLIENT_DH_BUG": 128,
                "SSL_OP_SSLREF2_REUSE_CERT_TYPE_BUG": 0,
                "SSL_OP_TLS_BLOCK_PADDING_BUG": 512,
                "SSL_OP_TLS_D5_BUG": 256,
                "SSL_OP_TLS_ROLLBACK_BUG": 8388608,
                "ENGINE_METHOD_DSA": 2,
                "ENGINE_METHOD_DH": 4,
                "ENGINE_METHOD_RAND": 8,
                "ENGINE_METHOD_ECDH": 16,
                "ENGINE_METHOD_ECDSA": 32,
                "ENGINE_METHOD_CIPHERS": 64,
                "ENGINE_METHOD_DIGESTS": 128,
                "ENGINE_METHOD_STORE": 256,
                "ENGINE_METHOD_PKEY_METHS": 512,
                "ENGINE_METHOD_PKEY_ASN1_METHS": 1024,
                "ENGINE_METHOD_ALL": 65535,
                "ENGINE_METHOD_NONE": 0,
                "DH_CHECK_P_NOT_SAFE_PRIME": 2,
                "DH_CHECK_P_NOT_PRIME": 1,
                "DH_UNABLE_TO_CHECK_GENERATOR": 4,
                "DH_NOT_SUITABLE_GENERATOR": 8,
                "NPN_ENABLED": 1,
                "RSA_PKCS1_PADDING": 1,
                "RSA_SSLV23_PADDING": 2,
                "RSA_NO_PADDING": 3,
                "RSA_PKCS1_OAEP_PADDING": 4,
                "RSA_X931_PADDING": 5,
                "RSA_PKCS1_PSS_PADDING": 6,
                "POINT_CONVERSION_COMPRESSED": 2,
                "POINT_CONVERSION_UNCOMPRESSED": 4,
                "POINT_CONVERSION_HYBRID": 6,
                "F_OK": 0,
                "R_OK": 4,
                "W_OK": 2,
                "X_OK": 1,
                "UV_UDP_REUSEADDR": 4
            };
        },
        {}
    ],
    185: [
        function(require1, module, exports) {
            (function(Buffer) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // NOTE: These type checking functions intentionally don't use `instanceof`
                // because it is fragile and can be easily faked with `Object.create()`.
                function isArray(arg) {
                    if (Array.isArray) return Array.isArray(arg);
                    return objectToString(arg) === '[object Array]';
                }
                exports.isArray = isArray;
                function isBoolean(arg) {
                    return typeof arg === 'boolean';
                }
                exports.isBoolean = isBoolean;
                function isNull(arg) {
                    return arg === null;
                }
                exports.isNull = isNull;
                function isNullOrUndefined(arg) {
                    return arg == null;
                }
                exports.isNullOrUndefined = isNullOrUndefined;
                function isNumber(arg) {
                    return typeof arg === 'number';
                }
                exports.isNumber = isNumber;
                function isString(arg) {
                    return typeof arg === 'string';
                }
                exports.isString = isString;
                function isSymbol(arg) {
                    return typeof arg === 'symbol';
                }
                exports.isSymbol = isSymbol;
                function isUndefined(arg) {
                    return arg === void 0;
                }
                exports.isUndefined = isUndefined;
                function isRegExp(re) {
                    return objectToString(re) === '[object RegExp]';
                }
                exports.isRegExp = isRegExp;
                function isObject(arg) {
                    return typeof arg === 'object' && arg !== null;
                }
                exports.isObject = isObject;
                function isDate(d) {
                    return objectToString(d) === '[object Date]';
                }
                exports.isDate = isDate;
                function isError(e) {
                    return objectToString(e) === '[object Error]' || e instanceof Error;
                }
                exports.isError = isError;
                function isFunction(arg) {
                    return typeof arg === 'function';
                }
                exports.isFunction = isFunction;
                function isPrimitive(arg) {
                    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
                    typeof arg === 'undefined';
                }
                exports.isPrimitive = isPrimitive;
                exports.isBuffer = Buffer.isBuffer;
                function objectToString(o) {
                    return Object.prototype.toString.call(o);
                }
            }).call(this, {
                "isBuffer": require1("../../is-buffer/index.js")
            });
        },
        {
            "../../is-buffer/index.js": 190
        }
    ],
    186: [
        function(require1, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
            function EventEmitter() {
                this._events = this._events || {};
                this._maxListeners = this._maxListeners || undefined;
            }
            module.exports = EventEmitter;
            // Backwards-compat with node 0.10.x
            EventEmitter.EventEmitter = EventEmitter;
            EventEmitter.prototype._events = undefined;
            EventEmitter.prototype._maxListeners = undefined;
            // By default EventEmitters will print a warning if more than 10 listeners are
            // added to it. This is a useful default which helps finding memory leaks.
            EventEmitter.defaultMaxListeners = 10;
            // Obviously not all Emitters should be limited to 10. This function allows
            // that to be increased. Set to zero for unlimited.
            EventEmitter.prototype.setMaxListeners = function(n) {
                if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
                this._maxListeners = n;
                return this;
            };
            EventEmitter.prototype.emit = function(type) {
                var er, handler, len, args, i, listeners;
                if (!this._events) this._events = {};
                // If there is no 'error' event listener then throw.
                if (type === 'error') {
                    if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
                        er = arguments[1];
                        if (er instanceof Error) throw er; // Unhandled 'error' event
                        else {
                            // At least give some kind of context to the user
                            var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                            err.context = er;
                            throw err;
                        }
                    }
                }
                handler = this._events[type];
                if (isUndefined(handler)) return false;
                if (isFunction(handler)) switch(arguments.length){
                    // fast cases
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    // slower
                    default:
                        args = Array.prototype.slice.call(arguments, 1);
                        handler.apply(this, args);
                }
                else if (isObject(handler)) {
                    args = Array.prototype.slice.call(arguments, 1);
                    listeners = handler.slice();
                    len = listeners.length;
                    for(i = 0; i < len; i++)listeners[i].apply(this, args);
                }
                return true;
            };
            EventEmitter.prototype.addListener = function(type, listener) {
                var m;
                if (!isFunction(listener)) throw TypeError('listener must be a function');
                if (!this._events) this._events = {};
                // To avoid recursion in the case that type === "newListener"! Before
                // adding it to the listeners, first emit "newListener".
                if (this._events.newListener) this.emit('newListener', type, isFunction(listener.listener) ? listener.listener : listener);
                if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
                this._events[type] = listener;
                else if (isObject(this._events[type])) // If we've already got an array, just append.
                this._events[type].push(listener);
                else // Adding the second element, need to change to array.
                this._events[type] = [
                    this._events[type],
                    listener
                ];
                // Check for listener leak
                if (isObject(this._events[type]) && !this._events[type].warned) {
                    if (!isUndefined(this._maxListeners)) m = this._maxListeners;
                    else m = EventEmitter.defaultMaxListeners;
                    if (m && m > 0 && this._events[type].length > m) {
                        this._events[type].warned = true;
                        console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
                        if (typeof console.trace === 'function') // not supported in IE 10
                        console.trace();
                    }
                }
                return this;
            };
            EventEmitter.prototype.on = EventEmitter.prototype.addListener;
            EventEmitter.prototype.once = function(type, listener) {
                if (!isFunction(listener)) throw TypeError('listener must be a function');
                var fired = false;
                function g() {
                    this.removeListener(type, g);
                    if (!fired) {
                        fired = true;
                        listener.apply(this, arguments);
                    }
                }
                g.listener = listener;
                this.on(type, g);
                return this;
            };
            // emits a 'removeListener' event iff the listener was removed
            EventEmitter.prototype.removeListener = function(type, listener) {
                var list, position, length, i;
                if (!isFunction(listener)) throw TypeError('listener must be a function');
                if (!this._events || !this._events[type]) return this;
                list = this._events[type];
                length = list.length;
                position = -1;
                if (list === listener || isFunction(list.listener) && list.listener === listener) {
                    delete this._events[type];
                    if (this._events.removeListener) this.emit('removeListener', type, listener);
                } else if (isObject(list)) {
                    for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
                        position = i;
                        break;
                    }
                    if (position < 0) return this;
                    if (list.length === 1) {
                        list.length = 0;
                        delete this._events[type];
                    } else list.splice(position, 1);
                    if (this._events.removeListener) this.emit('removeListener', type, listener);
                }
                return this;
            };
            EventEmitter.prototype.removeAllListeners = function(type) {
                var key, listeners;
                if (!this._events) return this;
                // not listening for removeListener, no need to emit
                if (!this._events.removeListener) {
                    if (arguments.length === 0) this._events = {};
                    else if (this._events[type]) delete this._events[type];
                    return this;
                }
                // emit removeListener for all listeners on all events
                if (arguments.length === 0) {
                    for(key in this._events){
                        if (key === 'removeListener') continue;
                        this.removeAllListeners(key);
                    }
                    this.removeAllListeners('removeListener');
                    this._events = {};
                    return this;
                }
                listeners = this._events[type];
                if (isFunction(listeners)) this.removeListener(type, listeners);
                else if (listeners) // LIFO order
                while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
                delete this._events[type];
                return this;
            };
            EventEmitter.prototype.listeners = function(type) {
                var ret;
                if (!this._events || !this._events[type]) ret = [];
                else if (isFunction(this._events[type])) ret = [
                    this._events[type]
                ];
                else ret = this._events[type].slice();
                return ret;
            };
            EventEmitter.prototype.listenerCount = function(type) {
                if (this._events) {
                    var evlistener = this._events[type];
                    if (isFunction(evlistener)) return 1;
                    else if (evlistener) return evlistener.length;
                }
                return 0;
            };
            EventEmitter.listenerCount = function(emitter, type) {
                return emitter.listenerCount(type);
            };
            function isFunction(arg) {
                return typeof arg === 'function';
            }
            function isNumber(arg) {
                return typeof arg === 'number';
            }
            function isObject(arg) {
                return typeof arg === 'object' && arg !== null;
            }
            function isUndefined(arg) {
                return arg === void 0;
            }
        },
        {}
    ],
    187: [
        function(require1, module, exports) {
            var http = require1('http');
            var url = require1('url');
            var https = module.exports;
            for(var key in http)if (http.hasOwnProperty(key)) https[key] = http[key];
            https.request = function(params, cb) {
                params = validateParams(params);
                return http.request.call(this, params, cb);
            };
            https.get = function(params, cb) {
                params = validateParams(params);
                return http.get.call(this, params, cb);
            };
            function validateParams(params) {
                if (typeof params === 'string') params = url.parse(params);
                if (!params.protocol) params.protocol = 'https:';
                if (params.protocol !== 'https:') throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"');
                return params;
            }
        },
        {
            "http": 224,
            "url": 230
        }
    ],
    188: [
        function(require1, module, exports) {
            exports.read = function(buffer, offset, isLE, mLen, nBytes) {
                var e, m;
                var eLen = nBytes * 8 - mLen - 1;
                var eMax = (1 << eLen) - 1;
                var eBias = eMax >> 1;
                var nBits = -7;
                var i = isLE ? nBytes - 1 : 0;
                var d = isLE ? -1 : 1;
                var s = buffer[offset + i];
                i += d;
                e = s & (1 << -nBits) - 1;
                s >>= -nBits;
                nBits += eLen;
                for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
                m = e & (1 << -nBits) - 1;
                e >>= -nBits;
                nBits += mLen;
                for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
                if (e === 0) e = 1 - eBias;
                else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
                else {
                    m = m + Math.pow(2, mLen);
                    e = e - eBias;
                }
                return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
            };
            exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
                var e, m, c;
                var eLen = nBytes * 8 - mLen - 1;
                var eMax = (1 << eLen) - 1;
                var eBias = eMax >> 1;
                var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
                var i = isLE ? 0 : nBytes - 1;
                var d = isLE ? 1 : -1;
                var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
                value = Math.abs(value);
                if (isNaN(value) || value === Infinity) {
                    m = isNaN(value) ? 1 : 0;
                    e = eMax;
                } else {
                    e = Math.floor(Math.log(value) / Math.LN2);
                    if (value * (c = Math.pow(2, -e)) < 1) {
                        e--;
                        c *= 2;
                    }
                    if (e + eBias >= 1) value += rt / c;
                    else value += rt * Math.pow(2, 1 - eBias);
                    if (value * c >= 2) {
                        e++;
                        c /= 2;
                    }
                    if (e + eBias >= eMax) {
                        m = 0;
                        e = eMax;
                    } else if (e + eBias >= 1) {
                        m = (value * c - 1) * Math.pow(2, mLen);
                        e = e + eBias;
                    } else {
                        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                        e = 0;
                    }
                }
                for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
                e = e << mLen | m;
                eLen += mLen;
                for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
                buffer[offset + i - d] |= s * 128;
            };
        },
        {}
    ],
    189: [
        function(require1, module, exports) {
            if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
            module.exports = function inherits(ctor, superCtor) {
                ctor.super_ = superCtor;
                ctor.prototype = Object.create(superCtor.prototype, {
                    constructor: {
                        value: ctor,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
            };
            else // old school shim for old browsers
            module.exports = function inherits(ctor, superCtor) {
                ctor.super_ = superCtor;
                var TempCtor = function() {};
                TempCtor.prototype = superCtor.prototype;
                ctor.prototype = new TempCtor();
                ctor.prototype.constructor = ctor;
            };
        },
        {}
    ],
    190: [
        function(require1, module, exports) {
            /*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
            // Object.prototype.constructor. Remove this eventually
            module.exports = function(obj) {
                return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
            };
            function isBuffer(obj) {
                return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
            }
            // For Node v0.10 support. Remove this eventually.
            function isSlowBuffer(obj) {
                return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
            }
        },
        {}
    ],
    191: [
        function(require1, module, exports) {
            var toString = {}.toString;
            module.exports = Array.isArray || function(arr) {
                return toString.call(arr) == '[object Array]';
            };
        },
        {}
    ],
    192: [
        function(require1, module, exports) {
            'use strict';
            var TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
            function _has(obj, key) {
                return Object.prototype.hasOwnProperty.call(obj, key);
            }
            exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
                var sources = Array.prototype.slice.call(arguments, 1);
                while(sources.length){
                    var source = sources.shift();
                    if (!source) continue;
                    if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
                    for(var p in source)if (_has(source, p)) obj[p] = source[p];
                }
                return obj;
            };
            // reduce buffer size, avoiding mem copy
            exports.shrinkBuf = function(buf, size) {
                if (buf.length === size) return buf;
                if (buf.subarray) return buf.subarray(0, size);
                buf.length = size;
                return buf;
            };
            var fnTyped = {
                arraySet: function(dest, src, src_offs, len, dest_offs) {
                    if (src.subarray && dest.subarray) {
                        dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
                        return;
                    }
                    // Fallback to ordinary array
                    for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
                },
                // Join array of chunks to single array.
                flattenChunks: function(chunks) {
                    var i, l, len, pos, chunk, result;
                    // calculate data length
                    len = 0;
                    for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
                    // join chunks
                    result = new Uint8Array(len);
                    pos = 0;
                    for(i = 0, l = chunks.length; i < l; i++){
                        chunk = chunks[i];
                        result.set(chunk, pos);
                        pos += chunk.length;
                    }
                    return result;
                }
            };
            var fnUntyped = {
                arraySet: function(dest, src, src_offs, len, dest_offs) {
                    for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
                },
                // Join array of chunks to single array.
                flattenChunks: function(chunks) {
                    return [].concat.apply([], chunks);
                }
            };
            // Enable/Disable typed arrays use, for testing
            //
            exports.setTyped = function(on) {
                if (on) {
                    exports.Buf8 = Uint8Array;
                    exports.Buf16 = Uint16Array;
                    exports.Buf32 = Int32Array;
                    exports.assign(exports, fnTyped);
                } else {
                    exports.Buf8 = Array;
                    exports.Buf16 = Array;
                    exports.Buf32 = Array;
                    exports.assign(exports, fnUntyped);
                }
            };
            exports.setTyped(TYPED_OK);
        },
        {}
    ],
    193: [
        function(require1, module, exports) {
            'use strict';
            // Note: adler32 takes 12% for level 0 and 2% for level 6.
            // It isn't worth it to make additional optimizations as in original.
            // Small size is preferable.
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
            function adler32(adler, buf, len, pos) {
                var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
                while(len !== 0){
                    // Set limit ~ twice less than 5552, to keep
                    // s2 in 31-bits, because we force signed ints.
                    // in other case %= will fail.
                    n = len > 2000 ? 2000 : len;
                    len -= n;
                    do {
                        s1 = s1 + buf[pos++] | 0;
                        s2 = s2 + s1 | 0;
                    }while (--n);
                    s1 %= 65521;
                    s2 %= 65521;
                }
                return s1 | s2 << 16 | 0;
            }
            module.exports = adler32;
        },
        {}
    ],
    194: [
        function(require1, module, exports) {
            'use strict';
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
            module.exports = {
                /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
                Z_PARTIAL_FLUSH: 1,
                Z_SYNC_FLUSH: 2,
                Z_FULL_FLUSH: 3,
                Z_FINISH: 4,
                Z_BLOCK: 5,
                Z_TREES: 6,
                /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
                Z_STREAM_END: 1,
                Z_NEED_DICT: 2,
                Z_ERRNO: -1,
                Z_STREAM_ERROR: -2,
                Z_DATA_ERROR: -3,
                //Z_MEM_ERROR:     -4,
                Z_BUF_ERROR: -5,
                //Z_VERSION_ERROR: -6,
                /* compression levels */ Z_NO_COMPRESSION: 0,
                Z_BEST_SPEED: 1,
                Z_BEST_COMPRESSION: 9,
                Z_DEFAULT_COMPRESSION: -1,
                Z_FILTERED: 1,
                Z_HUFFMAN_ONLY: 2,
                Z_RLE: 3,
                Z_FIXED: 4,
                Z_DEFAULT_STRATEGY: 0,
                /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
                Z_TEXT: 1,
                //Z_ASCII:                1, // = Z_TEXT (deprecated)
                Z_UNKNOWN: 2,
                /* The deflate compression method */ Z_DEFLATED: 8
            };
        },
        {}
    ],
    195: [
        function(require1, module, exports) {
            'use strict';
            // Note: we can't get significant speed boost here.
            // So write code to minimize size - no pregenerated tables
            // and array tools dependencies.
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
            // Use ordinary array, since untyped makes no boost here
            function makeTable() {
                var c, table = [];
                for(var n = 0; n < 256; n++){
                    c = n;
                    for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
                    table[n] = c;
                }
                return table;
            }
            // Create table on load. Just 255 signed longs. Not a problem.
            var crcTable = makeTable();
            function crc32(crc, buf, len, pos) {
                var t = crcTable, end = pos + len;
                crc ^= -1;
                for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
                return crc ^ -1; // >>> 0;
            }
            module.exports = crc32;
        },
        {}
    ],
    196: [
        function(require1, module, exports) {
            'use strict';
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
            var utils = require1('../utils/common');
            var trees = require1('./trees');
            var adler32 = require1('./adler32');
            var crc32 = require1('./crc32');
            var msg = require1('./messages');
            /* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var Z_NO_FLUSH = 0;
            var Z_PARTIAL_FLUSH = 1;
            //var Z_SYNC_FLUSH    = 2;
            var Z_FULL_FLUSH = 3;
            var Z_FINISH = 4;
            var Z_BLOCK = 5;
            //var Z_TREES         = 6;
            /* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
            var Z_STREAM_END = 1;
            //var Z_NEED_DICT     = 2;
            //var Z_ERRNO         = -1;
            var Z_STREAM_ERROR = -2;
            var Z_DATA_ERROR = -3;
            //var Z_MEM_ERROR     = -4;
            var Z_BUF_ERROR = -5;
            //var Z_VERSION_ERROR = -6;
            /* compression levels */ //var Z_NO_COMPRESSION      = 0;
            //var Z_BEST_SPEED          = 1;
            //var Z_BEST_COMPRESSION    = 9;
            var Z_DEFAULT_COMPRESSION = -1;
            var Z_FILTERED = 1;
            var Z_HUFFMAN_ONLY = 2;
            var Z_RLE = 3;
            var Z_FIXED = 4;
            var Z_DEFAULT_STRATEGY = 0;
            /* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
            //var Z_TEXT                = 1;
            //var Z_ASCII               = 1; // = Z_TEXT
            var Z_UNKNOWN = 2;
            /* The deflate compression method */ var Z_DEFLATED = 8;
            /*============================================================================*/ var MAX_MEM_LEVEL = 9;
            /* Maximum value for memLevel in deflateInit2 */ var MAX_WBITS = 15;
            /* 32K LZ77 window */ var DEF_MEM_LEVEL = 8;
            var LENGTH_CODES = 29;
            /* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
            /* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
            /* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
            /* number of distance codes */ var BL_CODES = 19;
            /* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
            /* maximum heap size */ var MAX_BITS = 15;
            /* All codes must not exceed MAX_BITS bits */ var MIN_MATCH = 3;
            var MAX_MATCH = 258;
            var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
            var PRESET_DICT = 0x20;
            var INIT_STATE = 42;
            var EXTRA_STATE = 69;
            var NAME_STATE = 73;
            var COMMENT_STATE = 91;
            var HCRC_STATE = 103;
            var BUSY_STATE = 113;
            var FINISH_STATE = 666;
            var BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
            var BS_BLOCK_DONE = 2; /* block flush performed */ 
            var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
            var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
            var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
            function err(strm, errorCode) {
                strm.msg = msg[errorCode];
                return errorCode;
            }
            function rank(f) {
                return (f << 1) - (f > 4 ? 9 : 0);
            }
            function zero(buf) {
                var len = buf.length;
                while(--len >= 0)buf[len] = 0;
            }
            /* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function flush_pending(strm) {
                var s = strm.state;
                //_tr_flush_bits(s);
                var len = s.pending;
                if (len > strm.avail_out) len = strm.avail_out;
                if (len === 0) return;
                utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
                strm.next_out += len;
                s.pending_out += len;
                strm.total_out += len;
                strm.avail_out -= len;
                s.pending -= len;
                if (s.pending === 0) s.pending_out = 0;
            }
            function flush_block_only(s, last) {
                trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
                s.block_start = s.strstart;
                flush_pending(s.strm);
            }
            function put_byte(s, b) {
                s.pending_buf[s.pending++] = b;
            }
            /* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function putShortMSB(s, b) {
                //  put_byte(s, (Byte)(b >> 8));
                //  put_byte(s, (Byte)(b & 0xff));
                s.pending_buf[s.pending++] = b >>> 8 & 0xff;
                s.pending_buf[s.pending++] = b & 0xff;
            }
            /* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function read_buf(strm, buf, start, size) {
                var len = strm.avail_in;
                if (len > size) len = size;
                if (len === 0) return 0;
                strm.avail_in -= len;
                // zmemcpy(buf, strm->next_in, len);
                utils.arraySet(buf, strm.input, strm.next_in, len, start);
                if (strm.state.wrap === 1) strm.adler = adler32(strm.adler, buf, len, start);
                else if (strm.state.wrap === 2) strm.adler = crc32(strm.adler, buf, len, start);
                strm.next_in += len;
                strm.total_in += len;
                return len;
            }
            /* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function longest_match(s, cur_match) {
                var chain_length = s.max_chain_length; /* max hash chain length */ 
                var scan = s.strstart; /* current string */ 
                var match; /* matched string */ 
                var len; /* length of current match */ 
                var best_len = s.prev_length; /* best match length so far */ 
                var nice_match = s.nice_match; /* stop if match long enough */ 
                var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
                var _win = s.window; // shortcut
                var wmask = s.w_mask;
                var prev = s.prev;
                /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + MAX_MATCH;
                var scan_end1 = _win[scan + best_len - 1];
                var scan_end = _win[scan + best_len];
                /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
                /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
                /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
                // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
                do {
                    // Assert(cur_match < s->strstart, "no future");
                    match = cur_match;
                    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
                    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
                    match++;
                    // Assert(*scan == *match, "match[2]?");
                    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
                    while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
                    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                    len = MAX_MATCH - (strend - scan);
                    scan = strend - MAX_MATCH;
                    if (len > best_len) {
                        s.match_start = cur_match;
                        best_len = len;
                        if (len >= nice_match) break;
                        scan_end1 = _win[scan + best_len - 1];
                        scan_end = _win[scan + best_len];
                    }
                }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
                if (best_len <= s.lookahead) return best_len;
                return s.lookahead;
            }
            /* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function fill_window(s) {
                var _w_size = s.w_size;
                var p, n, m, more, str;
                //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
                do {
                    more = s.window_size - s.lookahead - s.strstart;
                    // JS ints have 32 bit, block below not needed
                    /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
                    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                    //        more = wsize;
                    //
                    //  } else if (more == (unsigned)(-1)) {
                    //        /* Very unlikely, but possible on 16 bit machine if
                    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                    //         */
                    //        more--;
                    //    }
                    //}
                    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                        utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
                        s.match_start -= _w_size;
                        s.strstart -= _w_size;
                        /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
                        /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
                        p = n;
                        do {
                            m = s.head[--p];
                            s.head[p] = m >= _w_size ? m - _w_size : 0;
                        }while (--n);
                        n = _w_size;
                        p = n;
                        do {
                            m = s.prev[--p];
                            s.prev[p] = m >= _w_size ? m - _w_size : 0;
                        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
                        more += _w_size;
                    }
                    if (s.strm.avail_in === 0) break;
                    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
                    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                    s.lookahead += n;
                    /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
                        str = s.strstart - s.insert;
                        s.ins_h = s.window[str];
                        /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
                        //#if MIN_MATCH != 3
                        //        Call update_hash() MIN_MATCH-3 more times
                        //#endif
                        while(s.insert){
                            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                            s.prev[str & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = str;
                            str++;
                            s.insert--;
                            if (s.lookahead + s.insert < MIN_MATCH) break;
                        }
                    }
                /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
            /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
            //    var curr = s.strstart + s.lookahead;
            //    var init = 0;
            //
            //    if (s.high_water < curr) {
            //      /* Previous high water mark below current data -- zero WIN_INIT
            //       * bytes or up to end of window, whichever is less.
            //       */
            //      init = s.window_size - curr;
            //      if (init > WIN_INIT)
            //        init = WIN_INIT;
            //      zmemzero(s->window + curr, (unsigned)init);
            //      s->high_water = curr + init;
            //    }
            //    else if (s->high_water < (ulg)curr + WIN_INIT) {
            //      /* High water mark at or above current data, but below current data
            //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
            //       * to end of window, whichever is less.
            //       */
            //      init = (ulg)curr + WIN_INIT - s->high_water;
            //      if (init > s->window_size - s->high_water)
            //        init = s->window_size - s->high_water;
            //      zmemzero(s->window + s->high_water, (unsigned)init);
            //      s->high_water += init;
            //    }
            //  }
            //
            //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
            //    "not enough room for search");
            }
            /* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function deflate_stored(s, flush) {
                /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
                if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
                /* Copy as much as possible from input to output: */ for(;;){
                    /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
                        //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                        //  s->block_start >= (long)s->w_size, "slide too late");
                        //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                        //        s.block_start >= s.w_size)) {
                        //        throw  new Error("slide too late");
                        //      }
                        fill_window(s);
                        if (s.lookahead === 0 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                        if (s.lookahead === 0) break;
                    /* flush the current block */ }
                    //Assert(s->block_start >= 0L, "block gone");
                    //    if (s.block_start < 0) throw new Error("block gone");
                    s.strstart += s.lookahead;
                    s.lookahead = 0;
                    /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
                    if (s.strstart === 0 || s.strstart >= max_start) {
                        /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
                        s.strstart = max_start;
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                }
                s.insert = 0;
                if (flush === Z_FINISH) {
                    /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                    if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                    /***/ return BS_FINISH_DONE;
                }
                if (s.strstart > s.block_start) {
                    /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                    if (s.strm.avail_out === 0) return BS_NEED_MORE;
                /***/ }
                return BS_NEED_MORE;
            }
            /* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function deflate_fast(s, flush) {
                var hash_head; /* head of the hash chain */ 
                var bflush; /* set if current block must be flushed */ 
                for(;;){
                    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
                        fill_window(s);
                        if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                        if (s.lookahead === 0) break; /* flush the current block */ 
                    }
                    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
                    if (s.lookahead >= MIN_MATCH) {
                        /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                        hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                        s.head[s.ins_h] = s.strstart;
                    /***/ }
                    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
                    if (s.match_length >= MIN_MATCH) {
                        // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                        /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
                        s.lookahead -= s.match_length;
                        /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                            s.match_length--; /* string at strstart already in table */ 
                            do {
                                s.strstart++;
                                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                                s.head[s.ins_h] = s.strstart;
                            /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                            s.strstart++;
                        } else {
                            s.strstart += s.match_length;
                            s.match_length = 0;
                            s.ins_h = s.window[s.strstart];
                            /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
                        //#if MIN_MATCH != 3
                        //                Call UPDATE_HASH() MIN_MATCH-3 more times
                        //#endif
                        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
                    } else {
                        /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
                        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                        s.lookahead--;
                        s.strstart++;
                    }
                    if (bflush) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                }
                s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
                if (flush === Z_FINISH) {
                    /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                    if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                    /***/ return BS_FINISH_DONE;
                }
                if (s.last_lit) {
                    /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                    if (s.strm.avail_out === 0) return BS_NEED_MORE;
                /***/ }
                return BS_BLOCK_DONE;
            }
            /* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function deflate_slow(s, flush) {
                var hash_head; /* head of hash chain */ 
                var bflush; /* set if current block must be flushed */ 
                var max_insert;
                /* Process the input block. */ for(;;){
                    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
                        fill_window(s);
                        if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                        if (s.lookahead === 0) break;
                         /* flush the current block */ 
                    }
                    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
                    if (s.lookahead >= MIN_MATCH) {
                        /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                        hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                        s.head[s.ins_h] = s.strstart;
                    /***/ }
                    /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
                    s.prev_match = s.match_start;
                    s.match_length = MIN_MATCH - 1;
                    if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                        /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
                        /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
                    }
                    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
                        max_insert = s.strstart + s.lookahead - MIN_MATCH;
                        /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                        /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
                        /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
                        s.prev_length -= 2;
                        do if (++s.strstart <= max_insert) {
                            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                        /***/ }
                        while (--s.prev_length !== 0);
                        s.match_available = 0;
                        s.match_length = MIN_MATCH - 1;
                        s.strstart++;
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    } else if (s.match_available) {
                        /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
                        if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
                        s.strstart++;
                        s.lookahead--;
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    } else {
                        /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
                        s.strstart++;
                        s.lookahead--;
                    }
                }
                //Assert (flush != Z_NO_FLUSH, "no flush?");
                if (s.match_available) {
                    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
                    s.match_available = 0;
                }
                s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
                if (flush === Z_FINISH) {
                    /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                    if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                    /***/ return BS_FINISH_DONE;
                }
                if (s.last_lit) {
                    /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                    if (s.strm.avail_out === 0) return BS_NEED_MORE;
                /***/ }
                return BS_BLOCK_DONE;
            }
            /* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function deflate_rle(s, flush) {
                var bflush; /* set if current block must be flushed */ 
                var prev; /* byte at distance one to match */ 
                var scan, strend; /* scan goes up to strend for length of run */ 
                var _win = s.window;
                for(;;){
                    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
                        fill_window(s);
                        if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                        if (s.lookahead === 0) break;
                         /* flush the current block */ 
                    }
                    /* See how many times the previous byte repeats */ s.match_length = 0;
                    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
                        scan = s.strstart - 1;
                        prev = _win[scan];
                        if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                            strend = s.strstart + MAX_MATCH;
                            do ;
                            while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                            s.match_length = MAX_MATCH - (strend - scan);
                            if (s.match_length > s.lookahead) s.match_length = s.lookahead;
                        }
                    //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                    }
                    /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
                        //check_match(s, s.strstart, s.strstart - 1, s.match_length);
                        /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
                        s.lookahead -= s.match_length;
                        s.strstart += s.match_length;
                        s.match_length = 0;
                    } else {
                        /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
                        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                        s.lookahead--;
                        s.strstart++;
                    }
                    if (bflush) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                }
                s.insert = 0;
                if (flush === Z_FINISH) {
                    /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                    if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                    /***/ return BS_FINISH_DONE;
                }
                if (s.last_lit) {
                    /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                    if (s.strm.avail_out === 0) return BS_NEED_MORE;
                /***/ }
                return BS_BLOCK_DONE;
            }
            /* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function deflate_huff(s, flush) {
                var bflush; /* set if current block must be flushed */ 
                for(;;){
                    /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
                        fill_window(s);
                        if (s.lookahead === 0) {
                            if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            break; /* flush the current block */ 
                        }
                    }
                    /* Output a literal byte */ s.match_length = 0;
                    //Tracevv((stderr,"%c", s->window[s->strstart]));
                    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                    if (bflush) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                }
                s.insert = 0;
                if (flush === Z_FINISH) {
                    /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                    if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                    /***/ return BS_FINISH_DONE;
                }
                if (s.last_lit) {
                    /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                    if (s.strm.avail_out === 0) return BS_NEED_MORE;
                /***/ }
                return BS_BLOCK_DONE;
            }
            /* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
                this.good_length = good_length;
                this.max_lazy = max_lazy;
                this.nice_length = nice_length;
                this.max_chain = max_chain;
                this.func = func;
            }
            var configuration_table;
            configuration_table = [
                /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
                /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
                /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
                /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
                /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
                /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
                /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
                /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
                /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
                /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
            ];
            /* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function lm_init(s) {
                s.window_size = 2 * s.w_size;
                /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
                /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
                s.good_match = configuration_table[s.level].good_length;
                s.nice_match = configuration_table[s.level].nice_length;
                s.max_chain_length = configuration_table[s.level].max_chain;
                s.strstart = 0;
                s.block_start = 0;
                s.lookahead = 0;
                s.insert = 0;
                s.match_length = s.prev_length = MIN_MATCH - 1;
                s.match_available = 0;
                s.ins_h = 0;
            }
            function DeflateState() {
                this.strm = null; /* pointer back to this zlib stream */ 
                this.status = 0; /* as the name implies */ 
                this.pending_buf = null; /* output still pending */ 
                this.pending_buf_size = 0; /* size of pending_buf */ 
                this.pending_out = 0; /* next pending byte to output to the stream */ 
                this.pending = 0; /* nb of bytes in the pending buffer */ 
                this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
                this.gzhead = null; /* gzip header information to write */ 
                this.gzindex = 0; /* where in extra, name, or comment */ 
                this.method = Z_DEFLATED; /* can only be DEFLATED */ 
                this.last_flush = -1; /* value of flush param for previous deflate call */ 
                this.w_size = 0; /* LZ77 window size (32K by default) */ 
                this.w_bits = 0; /* log2(w_size)  (8..16) */ 
                this.w_mask = 0; /* w_size - 1 */ 
                this.window = null;
                /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
                /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
                /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
                this.ins_h = 0; /* hash index of string to be inserted */ 
                this.hash_size = 0; /* number of elements in hash table */ 
                this.hash_bits = 0; /* log2(hash_size) */ 
                this.hash_mask = 0; /* hash_size-1 */ 
                this.hash_shift = 0;
                /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
                /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
                this.prev_match = 0; /* previous match */ 
                this.match_available = 0; /* set if previous match exists */ 
                this.strstart = 0; /* start of string to insert */ 
                this.match_start = 0; /* start of matching string */ 
                this.lookahead = 0; /* number of valid bytes ahead in window */ 
                this.prev_length = 0;
                /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
                /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
                /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
                //this.max_insert_length = 0;
                /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
                this.strategy = 0; /* favor or force Huffman coding*/ 
                this.good_match = 0;
                /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
                /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
                // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
                // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
                // Use flat array of DOUBLE size, with interleaved fata,
                // because JS does not support effective
                this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
                this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
                this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
                zero(this.dyn_ltree);
                zero(this.dyn_dtree);
                zero(this.bl_tree);
                this.l_desc = null; /* desc. for literal tree */ 
                this.d_desc = null; /* desc. for distance tree */ 
                this.bl_desc = null; /* desc. for bit length tree */ 
                //ush bl_count[MAX_BITS+1];
                this.bl_count = new utils.Buf16(MAX_BITS + 1);
                /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
                this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
                zero(this.heap);
                this.heap_len = 0; /* number of elements in the heap */ 
                this.heap_max = 0; /* element of largest frequency */ 
                /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
                zero(this.depth);
                /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
                this.lit_bufsize = 0;
                /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
                this.d_buf = 0;
                /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
                this.static_len = 0; /* bit length of current block with static trees */ 
                this.matches = 0; /* number of string matches in current block */ 
                this.insert = 0; /* bytes at end of window left to insert */ 
                this.bi_buf = 0;
                /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
            /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
            // sense only for pointers and memory check tools.
            //this.high_water = 0;
            /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
            function deflateResetKeep(strm) {
                var s;
                if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR);
                strm.total_in = strm.total_out = 0;
                strm.data_type = Z_UNKNOWN;
                s = strm.state;
                s.pending = 0;
                s.pending_out = 0;
                if (s.wrap < 0) s.wrap = -s.wrap;
                s.status = s.wrap ? INIT_STATE : BUSY_STATE;
                strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
                 : 1; // adler32(0, Z_NULL, 0)
                s.last_flush = Z_NO_FLUSH;
                trees._tr_init(s);
                return Z_OK;
            }
            function deflateReset(strm) {
                var ret = deflateResetKeep(strm);
                if (ret === Z_OK) lm_init(strm.state);
                return ret;
            }
            function deflateSetHeader(strm, head) {
                if (!strm || !strm.state) return Z_STREAM_ERROR;
                if (strm.state.wrap !== 2) return Z_STREAM_ERROR;
                strm.state.gzhead = head;
                return Z_OK;
            }
            function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
                if (!strm) return Z_STREAM_ERROR;
                var wrap = 1;
                if (level === Z_DEFAULT_COMPRESSION) level = 6;
                if (windowBits < 0) {
                    wrap = 0;
                    windowBits = -windowBits;
                } else if (windowBits > 15) {
                    wrap = 2; /* write gzip wrapper instead */ 
                    windowBits -= 16;
                }
                if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR);
                if (windowBits === 8) windowBits = 9;
                /* until 256-byte window bug fixed */ var s = new DeflateState();
                strm.state = s;
                s.strm = strm;
                s.wrap = wrap;
                s.gzhead = null;
                s.w_bits = windowBits;
                s.w_size = 1 << s.w_bits;
                s.w_mask = s.w_size - 1;
                s.hash_bits = memLevel + 7;
                s.hash_size = 1 << s.hash_bits;
                s.hash_mask = s.hash_size - 1;
                s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
                s.window = new utils.Buf8(s.w_size * 2);
                s.head = new utils.Buf16(s.hash_size);
                s.prev = new utils.Buf16(s.w_size);
                // Don't need mem init magic for JS.
                //s.high_water = 0;  /* nothing written to s->window yet */
                s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
                s.pending_buf_size = s.lit_bufsize * 4;
                //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
                //s->pending_buf = (uchf *) overlay;
                s.pending_buf = new utils.Buf8(s.pending_buf_size);
                // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
                //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
                s.d_buf = 1 * s.lit_bufsize;
                //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
                s.l_buf = 3 * s.lit_bufsize;
                s.level = level;
                s.strategy = strategy;
                s.method = method;
                return deflateReset(strm);
            }
            function deflateInit(strm, level) {
                return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
            }
            function deflate(strm, flush) {
                var old_flush, s;
                var beg, val; // for gzip header write only
                if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
                s = strm.state;
                if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
                s.strm = strm; /* just in case */ 
                old_flush = s.last_flush;
                s.last_flush = flush;
                /* Write the header */ if (s.status === INIT_STATE) {
                    if (s.wrap === 2) {
                        strm.adler = 0; //crc32(0L, Z_NULL, 0);
                        put_byte(s, 31);
                        put_byte(s, 139);
                        put_byte(s, 8);
                        if (!s.gzhead) {
                            put_byte(s, 0);
                            put_byte(s, 0);
                            put_byte(s, 0);
                            put_byte(s, 0);
                            put_byte(s, 0);
                            put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                            put_byte(s, OS_CODE);
                            s.status = BUSY_STATE;
                        } else {
                            put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                            put_byte(s, s.gzhead.time & 0xff);
                            put_byte(s, s.gzhead.time >> 8 & 0xff);
                            put_byte(s, s.gzhead.time >> 16 & 0xff);
                            put_byte(s, s.gzhead.time >> 24 & 0xff);
                            put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                            put_byte(s, s.gzhead.os & 0xff);
                            if (s.gzhead.extra && s.gzhead.extra.length) {
                                put_byte(s, s.gzhead.extra.length & 0xff);
                                put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                            }
                            if (s.gzhead.hcrc) strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
                            s.gzindex = 0;
                            s.status = EXTRA_STATE;
                        }
                    } else {
                        var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
                        var level_flags = -1;
                        if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
                        else if (s.level < 6) level_flags = 1;
                        else if (s.level === 6) level_flags = 2;
                        else level_flags = 3;
                        header |= level_flags << 6;
                        if (s.strstart !== 0) header |= PRESET_DICT;
                        header += 31 - header % 31;
                        s.status = BUSY_STATE;
                        putShortMSB(s, header);
                        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                            putShortMSB(s, strm.adler >>> 16);
                            putShortMSB(s, strm.adler & 0xffff);
                        }
                        strm.adler = 1; // adler32(0L, Z_NULL, 0);
                    }
                }
                //#ifdef GZIP
                if (s.status === EXTRA_STATE) {
                    if (s.gzhead.extra /* != Z_NULL*/ ) {
                        beg = s.pending; /* start of bytes to update crc */ 
                        while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                            if (s.pending === s.pending_buf_size) {
                                if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                flush_pending(strm);
                                beg = s.pending;
                                if (s.pending === s.pending_buf_size) break;
                            }
                            put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                            s.gzindex++;
                        }
                        if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                        if (s.gzindex === s.gzhead.extra.length) {
                            s.gzindex = 0;
                            s.status = NAME_STATE;
                        }
                    } else s.status = NAME_STATE;
                }
                if (s.status === NAME_STATE) {
                    if (s.gzhead.name /* != Z_NULL*/ ) {
                        beg = s.pending; /* start of bytes to update crc */ 
                        //int val;
                        do {
                            if (s.pending === s.pending_buf_size) {
                                if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                flush_pending(strm);
                                beg = s.pending;
                                if (s.pending === s.pending_buf_size) {
                                    val = 1;
                                    break;
                                }
                            }
                            // JS specific: little magic to add zero terminator to end of string
                            if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                            else val = 0;
                            put_byte(s, val);
                        }while (val !== 0);
                        if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                        if (val === 0) {
                            s.gzindex = 0;
                            s.status = COMMENT_STATE;
                        }
                    } else s.status = COMMENT_STATE;
                }
                if (s.status === COMMENT_STATE) {
                    if (s.gzhead.comment /* != Z_NULL*/ ) {
                        beg = s.pending; /* start of bytes to update crc */ 
                        //int val;
                        do {
                            if (s.pending === s.pending_buf_size) {
                                if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                flush_pending(strm);
                                beg = s.pending;
                                if (s.pending === s.pending_buf_size) {
                                    val = 1;
                                    break;
                                }
                            }
                            // JS specific: little magic to add zero terminator to end of string
                            if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                            else val = 0;
                            put_byte(s, val);
                        }while (val !== 0);
                        if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                        if (val === 0) s.status = HCRC_STATE;
                    } else s.status = HCRC_STATE;
                }
                if (s.status === HCRC_STATE) {
                    if (s.gzhead.hcrc) {
                        if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
                        if (s.pending + 2 <= s.pending_buf_size) {
                            put_byte(s, strm.adler & 0xff);
                            put_byte(s, strm.adler >> 8 & 0xff);
                            strm.adler = 0; //crc32(0L, Z_NULL, 0);
                            s.status = BUSY_STATE;
                        }
                    } else s.status = BUSY_STATE;
                }
                //#endif
                /* Flush as much pending output as possible */ if (s.pending !== 0) {
                    flush_pending(strm);
                    if (strm.avail_out === 0) {
                        /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
                        return Z_OK;
                    }
                /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) return err(strm, Z_BUF_ERROR);
                /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR);
                /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
                    var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
                    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
                    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                        if (strm.avail_out === 0) s.last_flush = -1;
                        return Z_OK;
                    /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
                    if (bstate === BS_BLOCK_DONE) {
                        if (flush === Z_PARTIAL_FLUSH) trees._tr_align(s);
                        else if (flush !== Z_BLOCK) {
                            trees._tr_stored_block(s, 0, 0, false);
                            /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH) {
                                /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                                if (s.lookahead === 0) {
                                    s.strstart = 0;
                                    s.block_start = 0;
                                    s.insert = 0;
                                }
                            }
                        }
                        flush_pending(strm);
                        if (strm.avail_out === 0) {
                            s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                            return Z_OK;
                        }
                    }
                }
                //Assert(strm->avail_out > 0, "bug2");
                //if (strm.avail_out <= 0) { throw new Error("bug2");}
                if (flush !== Z_FINISH) return Z_OK;
                if (s.wrap <= 0) return Z_STREAM_END;
                /* Write the trailer */ if (s.wrap === 2) {
                    put_byte(s, strm.adler & 0xff);
                    put_byte(s, strm.adler >> 8 & 0xff);
                    put_byte(s, strm.adler >> 16 & 0xff);
                    put_byte(s, strm.adler >> 24 & 0xff);
                    put_byte(s, strm.total_in & 0xff);
                    put_byte(s, strm.total_in >> 8 & 0xff);
                    put_byte(s, strm.total_in >> 16 & 0xff);
                    put_byte(s, strm.total_in >> 24 & 0xff);
                } else {
                    putShortMSB(s, strm.adler >>> 16);
                    putShortMSB(s, strm.adler & 0xffff);
                }
                flush_pending(strm);
                /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
                /* write the trailer only once! */ return s.pending !== 0 ? Z_OK : Z_STREAM_END;
            }
            function deflateEnd(strm) {
                var status;
                if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
                status = strm.state.status;
                if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR);
                strm.state = null;
                return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
            }
            /* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function deflateSetDictionary(strm, dictionary) {
                var dictLength = dictionary.length;
                var s;
                var str, n;
                var wrap;
                var avail;
                var next;
                var input;
                var tmpDict;
                if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
                s = strm.state;
                wrap = s.wrap;
                if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR;
                /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
                s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
                /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
                    if (wrap === 0) {
                        /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                    /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
                    tmpDict = new utils.Buf8(s.w_size);
                    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
                    dictionary = tmpDict;
                    dictLength = s.w_size;
                }
                /* insert dictionary into window and hash */ avail = strm.avail_in;
                next = strm.next_in;
                input = strm.input;
                strm.avail_in = dictLength;
                strm.next_in = 0;
                strm.input = dictionary;
                fill_window(s);
                while(s.lookahead >= MIN_MATCH){
                    str = s.strstart;
                    n = s.lookahead - (MIN_MATCH - 1);
                    do {
                        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                        s.prev[str & s.w_mask] = s.head[s.ins_h];
                        s.head[s.ins_h] = str;
                        str++;
                    }while (--n);
                    s.strstart = str;
                    s.lookahead = MIN_MATCH - 1;
                    fill_window(s);
                }
                s.strstart += s.lookahead;
                s.block_start = s.strstart;
                s.insert = s.lookahead;
                s.lookahead = 0;
                s.match_length = s.prev_length = MIN_MATCH - 1;
                s.match_available = 0;
                strm.next_in = next;
                strm.input = input;
                strm.avail_in = avail;
                s.wrap = wrap;
                return Z_OK;
            }
            exports.deflateInit = deflateInit;
            exports.deflateInit2 = deflateInit2;
            exports.deflateReset = deflateReset;
            exports.deflateResetKeep = deflateResetKeep;
            exports.deflateSetHeader = deflateSetHeader;
            exports.deflate = deflate;
            exports.deflateEnd = deflateEnd;
            exports.deflateSetDictionary = deflateSetDictionary;
            exports.deflateInfo = 'pako deflate (from Nodeca project)';
        /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ },
        {
            "../utils/common": 192,
            "./adler32": 193,
            "./crc32": 195,
            "./messages": 200,
            "./trees": 201
        }
    ],
    197: [
        function(require1, module, exports) {
            'use strict';
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
            // See state defs from inflate.js
            var BAD = 30; /* got a data error -- remain here until reset */ 
            var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
            /*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
                var state;
                var _in; /* local strm.input */ 
                var last; /* have enough input while in < last */ 
                var _out; /* local strm.output */ 
                var beg; /* inflate()'s initial strm.output */ 
                var end; /* while out < end, enough space available */ 
                //#ifdef INFLATE_STRICT
                var dmax; /* maximum distance from zlib header */ 
                //#endif
                var wsize; /* window size or zero if not using window */ 
                var whave; /* valid bytes in the window */ 
                var wnext; /* window write index */ 
                // Use `s_window` instead `window`, avoid conflict with instrumentation tools
                var s_window; /* allocated sliding window, if wsize != 0 */ 
                var hold; /* local strm.hold */ 
                var bits; /* local strm.bits */ 
                var lcode; /* local strm.lencode */ 
                var dcode; /* local strm.distcode */ 
                var lmask; /* mask for first level of length codes */ 
                var dmask; /* mask for first level of distance codes */ 
                var here; /* retrieved table entry */ 
                var op; /* code bits, operation, extra bits, or */ 
                /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
                var dist; /* match distance */ 
                var from; /* where to copy match from */ 
                var from_source;
                var input, output; // JS specific, because we have no pointers
                /* copy state to local variables */ state = strm.state;
                //here = state.here;
                _in = strm.next_in;
                input = strm.input;
                last = _in + (strm.avail_in - 5);
                _out = strm.next_out;
                output = strm.output;
                beg = _out - (start - strm.avail_out);
                end = _out + (strm.avail_out - 257);
                //#ifdef INFLATE_STRICT
                dmax = state.dmax;
                //#endif
                wsize = state.wsize;
                whave = state.whave;
                wnext = state.wnext;
                s_window = state.window;
                hold = state.hold;
                bits = state.bits;
                lcode = state.lencode;
                dcode = state.distcode;
                lmask = (1 << state.lenbits) - 1;
                dmask = (1 << state.distbits) - 1;
                /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
                    if (bits < 15) {
                        hold += input[_in++] << bits;
                        bits += 8;
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    here = lcode[hold & lmask];
                    dolen: for(;;){
                        op = here >>> 24 /*here.bits*/ ;
                        hold >>>= op;
                        bits -= op;
                        op = here >>> 16 & 0xff /*here.op*/ ;
                        if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                        //        "inflate:         literal '%c'\n" :
                        //        "inflate:         literal 0x%02x\n", here.val));
                        output[_out++] = here & 0xffff /*here.val*/ ;
                        else if (op & 16) {
                            len = here & 0xffff /*here.val*/ ;
                            op &= 15; /* number of extra bits */ 
                            if (op) {
                                if (bits < op) {
                                    hold += input[_in++] << bits;
                                    bits += 8;
                                }
                                len += hold & (1 << op) - 1;
                                hold >>>= op;
                                bits -= op;
                            }
                            //Tracevv((stderr, "inflate:         length %u\n", len));
                            if (bits < 15) {
                                hold += input[_in++] << bits;
                                bits += 8;
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                            here = dcode[hold & dmask];
                            dodist: for(;;){
                                op = here >>> 24 /*here.bits*/ ;
                                hold >>>= op;
                                bits -= op;
                                op = here >>> 16 & 0xff /*here.op*/ ;
                                if (op & 16) {
                                    dist = here & 0xffff /*here.val*/ ;
                                    op &= 15; /* number of extra bits */ 
                                    if (bits < op) {
                                        hold += input[_in++] << bits;
                                        bits += 8;
                                        if (bits < op) {
                                            hold += input[_in++] << bits;
                                            bits += 8;
                                        }
                                    }
                                    dist += hold & (1 << op) - 1;
                                    //#ifdef INFLATE_STRICT
                                    if (dist > dmax) {
                                        strm.msg = 'invalid distance too far back';
                                        state.mode = BAD;
                                        break top;
                                    }
                                    //#endif
                                    hold >>>= op;
                                    bits -= op;
                                    //Tracevv((stderr, "inflate:         distance %u\n", dist));
                                    op = _out - beg; /* max distance in output */ 
                                    if (dist > op) {
                                        op = dist - op; /* distance back in window */ 
                                        if (op > whave) {
                                            if (state.sane) {
                                                strm.msg = 'invalid distance too far back';
                                                state.mode = BAD;
                                                break top;
                                            }
                                        }
                                        from = 0; // window index
                                        from_source = s_window;
                                        if (wnext === 0) {
                                            from += wsize - op;
                                            if (op < len) {
                                                len -= op;
                                                do output[_out++] = s_window[from++];
                                                while (--op);
                                                from = _out - dist; /* rest from output */ 
                                                from_source = output;
                                            }
                                        } else if (wnext < op) {
                                            from += wsize + wnext - op;
                                            op -= wnext;
                                            if (op < len) {
                                                len -= op;
                                                do output[_out++] = s_window[from++];
                                                while (--op);
                                                from = 0;
                                                if (wnext < len) {
                                                    op = wnext;
                                                    len -= op;
                                                    do output[_out++] = s_window[from++];
                                                    while (--op);
                                                    from = _out - dist; /* rest from output */ 
                                                    from_source = output;
                                                }
                                            }
                                        } else {
                                            from += wnext - op;
                                            if (op < len) {
                                                len -= op;
                                                do output[_out++] = s_window[from++];
                                                while (--op);
                                                from = _out - dist; /* rest from output */ 
                                                from_source = output;
                                            }
                                        }
                                        while(len > 2){
                                            output[_out++] = from_source[from++];
                                            output[_out++] = from_source[from++];
                                            output[_out++] = from_source[from++];
                                            len -= 3;
                                        }
                                        if (len) {
                                            output[_out++] = from_source[from++];
                                            if (len > 1) output[_out++] = from_source[from++];
                                        }
                                    } else {
                                        from = _out - dist; /* copy direct from output */ 
                                        do {
                                            output[_out++] = output[from++];
                                            output[_out++] = output[from++];
                                            output[_out++] = output[from++];
                                            len -= 3;
                                        }while (len > 2);
                                        if (len) {
                                            output[_out++] = output[from++];
                                            if (len > 1) output[_out++] = output[from++];
                                        }
                                    }
                                } else if ((op & 64) === 0) {
                                    here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                                    continue dodist;
                                } else {
                                    strm.msg = 'invalid distance code';
                                    state.mode = BAD;
                                    break top;
                                }
                                break; // need to emulate goto via "continue"
                            }
                        } else if ((op & 64) === 0) {
                            here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                            continue dolen;
                        } else if (op & 32) {
                            //Tracevv((stderr, "inflate:         end of block\n"));
                            state.mode = TYPE;
                            break top;
                        } else {
                            strm.msg = 'invalid literal/length code';
                            state.mode = BAD;
                            break top;
                        }
                        break; // need to emulate goto via "continue"
                    }
                }while (_in < last && _out < end);
                /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
                _in -= len;
                bits -= len << 3;
                hold &= (1 << bits) - 1;
                /* update state and return */ strm.next_in = _in;
                strm.next_out = _out;
                strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
                strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
                state.hold = hold;
                state.bits = bits;
                return;
            };
        },
        {}
    ],
    198: [
        function(require1, module, exports) {
            'use strict';
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
            var utils = require1('../utils/common');
            var adler32 = require1('./adler32');
            var crc32 = require1('./crc32');
            var inflate_fast = require1('./inffast');
            var inflate_table = require1('./inftrees');
            var CODES = 0;
            var LENS = 1;
            var DISTS = 2;
            /* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
            //var Z_PARTIAL_FLUSH = 1;
            //var Z_SYNC_FLUSH    = 2;
            //var Z_FULL_FLUSH    = 3;
            var Z_FINISH = 4;
            var Z_BLOCK = 5;
            var Z_TREES = 6;
            /* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
            var Z_STREAM_END = 1;
            var Z_NEED_DICT = 2;
            //var Z_ERRNO         = -1;
            var Z_STREAM_ERROR = -2;
            var Z_DATA_ERROR = -3;
            var Z_MEM_ERROR = -4;
            var Z_BUF_ERROR = -5;
            //var Z_VERSION_ERROR = -6;
            /* The deflate compression method */ var Z_DEFLATED = 8;
            /* STATES ====================================================================*/ /* ===========================================================================*/ var HEAD = 1; /* i: waiting for magic header */ 
            var FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
            var TIME = 3; /* i: waiting for modification time (gzip) */ 
            var OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
            var EXLEN = 5; /* i: waiting for extra length (gzip) */ 
            var EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
            var NAME = 7; /* i: waiting for end of file name (gzip) */ 
            var COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
            var HCRC = 9; /* i: waiting for header crc (gzip) */ 
            var DICTID = 10; /* i: waiting for dictionary check value */ 
            var DICT = 11; /* waiting for inflateSetDictionary() call */ 
            var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
            var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
            var STORED = 14; /* i: waiting for stored size (length and complement) */ 
            var COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
            var COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
            var TABLE = 17; /* i: waiting for dynamic block table lengths */ 
            var LENLENS = 18; /* i: waiting for code length code lengths */ 
            var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
            var LEN_ = 20; /* i: same as LEN below, but only first time in */ 
            var LEN = 21; /* i: waiting for length/lit/eob code */ 
            var LENEXT = 22; /* i: waiting for length extra bits */ 
            var DIST = 23; /* i: waiting for distance code */ 
            var DISTEXT = 24; /* i: waiting for distance extra bits */ 
            var MATCH = 25; /* o: waiting for output space to copy string */ 
            var LIT = 26; /* o: waiting for output space to write literal */ 
            var CHECK = 27; /* i: waiting for 32-bit check value */ 
            var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
            var DONE = 29; /* finished check, done -- remain here until reset */ 
            var BAD = 30; /* got a data error -- remain here until reset */ 
            var MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
            var SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
            /* ===========================================================================*/ var ENOUGH_LENS = 852;
            var ENOUGH_DISTS = 592;
            //var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
            var MAX_WBITS = 15;
            /* 32K LZ77 window */ var DEF_WBITS = MAX_WBITS;
            function zswap32(q) {
                return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
            }
            function InflateState() {
                this.mode = 0; /* current inflate mode */ 
                this.last = false; /* true if processing last block */ 
                this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
                this.havedict = false; /* true if dictionary provided */ 
                this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
                this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
                this.check = 0; /* protected copy of check value */ 
                this.total = 0; /* protected copy of output count */ 
                // TODO: may be {}
                this.head = null; /* where to save gzip header information */ 
                /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
                this.wsize = 0; /* window size or zero if not using window */ 
                this.whave = 0; /* valid bytes in the window */ 
                this.wnext = 0; /* window write index */ 
                this.window = null; /* allocated sliding window, if needed */ 
                /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
                this.bits = 0; /* number of bits in "in" */ 
                /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
                this.offset = 0; /* distance back to copy string from */ 
                /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
                /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
                this.distcode = null; /* starting table for distance codes */ 
                this.lenbits = 0; /* index bits for lencode */ 
                this.distbits = 0; /* index bits for distcode */ 
                /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
                this.nlen = 0; /* number of length code lengths */ 
                this.ndist = 0; /* number of distance code lengths */ 
                this.have = 0; /* number of code lengths in lens[] */ 
                this.next = null; /* next available space in codes[] */ 
                this.lens = new utils.Buf16(320); /* temporary storage for code lengths */ 
                this.work = new utils.Buf16(288); /* work area for code table building */ 
                /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
                this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
                this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
                this.sane = 0; /* if false, allow invalid distance too far */ 
                this.back = 0; /* bits back of last unprocessed length/lit */ 
                this.was = 0; /* initial length of match */ 
            }
            function inflateResetKeep(strm) {
                var state;
                if (!strm || !strm.state) return Z_STREAM_ERROR;
                state = strm.state;
                strm.total_in = strm.total_out = state.total = 0;
                strm.msg = ''; /*Z_NULL*/ 
                if (state.wrap) strm.adler = state.wrap & 1;
                state.mode = HEAD;
                state.last = 0;
                state.havedict = 0;
                state.dmax = 32768;
                state.head = null /*Z_NULL*/ ;
                state.hold = 0;
                state.bits = 0;
                //state.lencode = state.distcode = state.next = state.codes;
                state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
                state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
                state.sane = 1;
                state.back = -1;
                //Tracev((stderr, "inflate: reset\n"));
                return Z_OK;
            }
            function inflateReset(strm) {
                var state;
                if (!strm || !strm.state) return Z_STREAM_ERROR;
                state = strm.state;
                state.wsize = 0;
                state.whave = 0;
                state.wnext = 0;
                return inflateResetKeep(strm);
            }
            function inflateReset2(strm, windowBits) {
                var wrap;
                var state;
                /* get the state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
                state = strm.state;
                /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
                    wrap = 0;
                    windowBits = -windowBits;
                } else {
                    wrap = (windowBits >> 4) + 1;
                    if (windowBits < 48) windowBits &= 15;
                }
                /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
                if (state.window !== null && state.wbits !== windowBits) state.window = null;
                /* update state and reset the rest of it */ state.wrap = wrap;
                state.wbits = windowBits;
                return inflateReset(strm);
            }
            function inflateInit2(strm, windowBits) {
                var ret;
                var state;
                if (!strm) return Z_STREAM_ERROR;
                //strm.msg = Z_NULL;                 /* in case we return an error */
                state = new InflateState();
                //if (state === Z_NULL) return Z_MEM_ERROR;
                //Tracev((stderr, "inflate: allocated\n"));
                strm.state = state;
                state.window = null /*Z_NULL*/ ;
                ret = inflateReset2(strm, windowBits);
                if (ret !== Z_OK) strm.state = null /*Z_NULL*/ ;
                return ret;
            }
            function inflateInit(strm) {
                return inflateInit2(strm, DEF_WBITS);
            }
            /*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var virgin = true;
            var lenfix, distfix; // We have no pointers in JS, so keep tables separate
            function fixedtables(state) {
                /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
                    var sym;
                    lenfix = new utils.Buf32(512);
                    distfix = new utils.Buf32(32);
                    /* literal/length table */ sym = 0;
                    while(sym < 144)state.lens[sym++] = 8;
                    while(sym < 256)state.lens[sym++] = 9;
                    while(sym < 280)state.lens[sym++] = 7;
                    while(sym < 288)state.lens[sym++] = 8;
                    inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
                        bits: 9
                    });
                    /* distance table */ sym = 0;
                    while(sym < 32)state.lens[sym++] = 5;
                    inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
                        bits: 5
                    });
                    /* do this just once */ virgin = false;
                }
                state.lencode = lenfix;
                state.lenbits = 9;
                state.distcode = distfix;
                state.distbits = 5;
            }
            /*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function updatewindow(strm, src, end, copy) {
                var dist;
                var state = strm.state;
                /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
                    state.wsize = 1 << state.wbits;
                    state.wnext = 0;
                    state.whave = 0;
                    state.window = new utils.Buf8(state.wsize);
                }
                /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
                    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
                    state.wnext = 0;
                    state.whave = state.wsize;
                } else {
                    dist = state.wsize - state.wnext;
                    if (dist > copy) dist = copy;
                    //zmemcpy(state->window + state->wnext, end - copy, dist);
                    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
                    copy -= dist;
                    if (copy) {
                        //zmemcpy(state->window, end - copy, copy);
                        utils.arraySet(state.window, src, end - copy, copy, 0);
                        state.wnext = copy;
                        state.whave = state.wsize;
                    } else {
                        state.wnext += dist;
                        if (state.wnext === state.wsize) state.wnext = 0;
                        if (state.whave < state.wsize) state.whave += dist;
                    }
                }
                return 0;
            }
            function inflate(strm, flush) {
                var state;
                var input, output; // input/output buffers
                var next; /* next input INDEX */ 
                var put; /* next output INDEX */ 
                var have, left; /* available input and output */ 
                var hold; /* bit buffer */ 
                var bits; /* bits in bit buffer */ 
                var _in, _out; /* save starting available input and output */ 
                var copy; /* number of stored or match bytes to copy */ 
                var from; /* where to copy match bytes from */ 
                var from_source;
                var here = 0; /* current decoding table entry */ 
                var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
                //var last;                   /* parent table entry */
                var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
                var len; /* length to copy for repeats, bits to drop */ 
                var ret; /* return code */ 
                var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */ 
                var opts;
                var n; // temporary var for NEED_BITS
                var order = /* permutation of code lengths */ [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ];
                if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
                state = strm.state;
                if (state.mode === TYPE) state.mode = TYPEDO;
                 /* skip check */ 
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                _in = have;
                _out = left;
                ret = Z_OK;
                inf_leave: for(;;)switch(state.mode){
                    case HEAD:
                        if (state.wrap === 0) {
                            state.mode = TYPEDO;
                            break;
                        }
                        //=== NEEDBITS(16);
                        while(bits < 16){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        if (state.wrap & 2 && hold === 0x8b1f) {
                            state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                            //=== CRC2(state.check, hold);
                            hbuf[0] = hold & 0xff;
                            hbuf[1] = hold >>> 8 & 0xff;
                            state.check = crc32(state.check, hbuf, 2, 0);
                            //===//
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = FLAGS;
                            break;
                        }
                        state.flags = 0; /* expect zlib header */ 
                        if (state.head) state.head.done = false;
                        if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                            strm.msg = 'incorrect header check';
                            state.mode = BAD;
                            break;
                        }
                        if ((hold & 0x0f) !== Z_DEFLATED) {
                            strm.msg = 'unknown compression method';
                            state.mode = BAD;
                            break;
                        }
                        //--- DROPBITS(4) ---//
                        hold >>>= 4;
                        bits -= 4;
                        //---//
                        len = (hold & 0x0f) + 8;
                        if (state.wbits === 0) state.wbits = len;
                        else if (len > state.wbits) {
                            strm.msg = 'invalid window size';
                            state.mode = BAD;
                            break;
                        }
                        state.dmax = 1 << len;
                        //Tracev((stderr, "inflate:   zlib header ok\n"));
                        strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
                        state.mode = hold & 0x200 ? DICTID : TYPE;
                        //=== INITBITS();
                        hold = 0;
                        bits = 0;
                        break;
                    case FLAGS:
                        //=== NEEDBITS(16); */
                        while(bits < 16){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        state.flags = hold;
                        if ((state.flags & 0xff) !== Z_DEFLATED) {
                            strm.msg = 'unknown compression method';
                            state.mode = BAD;
                            break;
                        }
                        if (state.flags & 0xe000) {
                            strm.msg = 'unknown header flags set';
                            state.mode = BAD;
                            break;
                        }
                        if (state.head) state.head.text = hold >> 8 & 1;
                        if (state.flags & 0x0200) {
                            //=== CRC2(state.check, hold);
                            hbuf[0] = hold & 0xff;
                            hbuf[1] = hold >>> 8 & 0xff;
                            state.check = crc32(state.check, hbuf, 2, 0);
                        //===//
                        }
                        //=== INITBITS();
                        hold = 0;
                        bits = 0;
                        //===//
                        state.mode = TIME;
                    /* falls through */ case TIME:
                        //=== NEEDBITS(32); */
                        while(bits < 32){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        if (state.head) state.head.time = hold;
                        if (state.flags & 0x0200) {
                            //=== CRC4(state.check, hold)
                            hbuf[0] = hold & 0xff;
                            hbuf[1] = hold >>> 8 & 0xff;
                            hbuf[2] = hold >>> 16 & 0xff;
                            hbuf[3] = hold >>> 24 & 0xff;
                            state.check = crc32(state.check, hbuf, 4, 0);
                        //===
                        }
                        //=== INITBITS();
                        hold = 0;
                        bits = 0;
                        //===//
                        state.mode = OS;
                    /* falls through */ case OS:
                        //=== NEEDBITS(16); */
                        while(bits < 16){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        if (state.head) {
                            state.head.xflags = hold & 0xff;
                            state.head.os = hold >> 8;
                        }
                        if (state.flags & 0x0200) {
                            //=== CRC2(state.check, hold);
                            hbuf[0] = hold & 0xff;
                            hbuf[1] = hold >>> 8 & 0xff;
                            state.check = crc32(state.check, hbuf, 2, 0);
                        //===//
                        }
                        //=== INITBITS();
                        hold = 0;
                        bits = 0;
                        //===//
                        state.mode = EXLEN;
                    /* falls through */ case EXLEN:
                        if (state.flags & 0x0400) {
                            //=== NEEDBITS(16); */
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.length = hold;
                            if (state.head) state.head.extra_len = hold;
                            if (state.flags & 0x0200) {
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32(state.check, hbuf, 2, 0);
                            //===//
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                        //===//
                        } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
                        state.mode = EXTRA;
                    /* falls through */ case EXTRA:
                        if (state.flags & 0x0400) {
                            copy = state.length;
                            if (copy > have) copy = have;
                            if (copy) {
                                if (state.head) {
                                    len = state.head.extra_len - state.length;
                                    if (!state.head.extra) // Use untyped array for more convenient processing later
                                    state.head.extra = new Array(state.head.extra_len);
                                    utils.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                                    // - no need for additional size check
                                    copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                                //zmemcpy(state.head.extra + len, next,
                                //        len + copy > state.head.extra_max ?
                                //        state.head.extra_max - len : copy);
                                }
                                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                                have -= copy;
                                next += copy;
                                state.length -= copy;
                            }
                            if (state.length) break inf_leave;
                        }
                        state.length = 0;
                        state.mode = NAME;
                    /* falls through */ case NAME:
                        if (state.flags & 0x0800) {
                            if (have === 0) break inf_leave;
                            copy = 0;
                            do {
                                // TODO: 2 or 1 bytes?
                                len = input[next + copy++];
                                /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                            }while (len && copy < have);
                            if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                            have -= copy;
                            next += copy;
                            if (len) break inf_leave;
                        } else if (state.head) state.head.name = null;
                        state.length = 0;
                        state.mode = COMMENT;
                    /* falls through */ case COMMENT:
                        if (state.flags & 0x1000) {
                            if (have === 0) break inf_leave;
                            copy = 0;
                            do {
                                len = input[next + copy++];
                                /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                            }while (len && copy < have);
                            if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                            have -= copy;
                            next += copy;
                            if (len) break inf_leave;
                        } else if (state.head) state.head.comment = null;
                        state.mode = HCRC;
                    /* falls through */ case HCRC:
                        if (state.flags & 0x0200) {
                            //=== NEEDBITS(16); */
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (hold !== (state.check & 0xffff)) {
                                strm.msg = 'header crc mismatch';
                                state.mode = BAD;
                                break;
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                        //===//
                        }
                        if (state.head) {
                            state.head.hcrc = state.flags >> 9 & 1;
                            state.head.done = true;
                        }
                        strm.adler = state.check = 0;
                        state.mode = TYPE;
                        break;
                    case DICTID:
                        //=== NEEDBITS(32); */
                        while(bits < 32){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        strm.adler = state.check = zswap32(hold);
                        //=== INITBITS();
                        hold = 0;
                        bits = 0;
                        //===//
                        state.mode = DICT;
                    /* falls through */ case DICT:
                        if (state.havedict === 0) {
                            //--- RESTORE() ---
                            strm.next_out = put;
                            strm.avail_out = left;
                            strm.next_in = next;
                            strm.avail_in = have;
                            state.hold = hold;
                            state.bits = bits;
                            //---
                            return Z_NEED_DICT;
                        }
                        strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
                        state.mode = TYPE;
                    /* falls through */ case TYPE:
                        if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
                    /* falls through */ case TYPEDO:
                        if (state.last) {
                            //--- BYTEBITS() ---//
                            hold >>>= bits & 7;
                            bits -= bits & 7;
                            //---//
                            state.mode = CHECK;
                            break;
                        }
                        //=== NEEDBITS(3); */
                        while(bits < 3){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        state.last = hold & 0x01 /*BITS(1)*/ ;
                        //--- DROPBITS(1) ---//
                        hold >>>= 1;
                        bits -= 1;
                        //---//
                        switch(hold & 0x03){
                            case 0:
                                /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                                //        state.last ? " (last)" : ""));
                                state.mode = STORED;
                                break;
                            case 1:
                                /* fixed block */ fixedtables(state);
                                //Tracev((stderr, "inflate:     fixed codes block%s\n",
                                //        state.last ? " (last)" : ""));
                                state.mode = LEN_; /* decode codes */ 
                                if (flush === Z_TREES) {
                                    //--- DROPBITS(2) ---//
                                    hold >>>= 2;
                                    bits -= 2;
                                    break inf_leave;
                                }
                                break;
                            case 2:
                                /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                                //        state.last ? " (last)" : ""));
                                state.mode = TABLE;
                                break;
                            case 3:
                                strm.msg = 'invalid block type';
                                state.mode = BAD;
                        }
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break;
                    case STORED:
                        //--- BYTEBITS() ---// /* go to byte boundary */
                        hold >>>= bits & 7;
                        bits -= bits & 7;
                        //---//
                        //=== NEEDBITS(32); */
                        while(bits < 32){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                            strm.msg = 'invalid stored block lengths';
                            state.mode = BAD;
                            break;
                        }
                        state.length = hold & 0xffff;
                        //Tracev((stderr, "inflate:       stored length %u\n",
                        //        state.length));
                        //=== INITBITS();
                        hold = 0;
                        bits = 0;
                        //===//
                        state.mode = COPY_;
                        if (flush === Z_TREES) break inf_leave;
                    /* falls through */ case COPY_:
                        state.mode = COPY;
                    /* falls through */ case COPY:
                        copy = state.length;
                        if (copy) {
                            if (copy > have) copy = have;
                            if (copy > left) copy = left;
                            if (copy === 0) break inf_leave;
                            //--- zmemcpy(put, next, copy); ---
                            utils.arraySet(output, input, next, copy, put);
                            //---//
                            have -= copy;
                            next += copy;
                            left -= copy;
                            put += copy;
                            state.length -= copy;
                            break;
                        }
                        //Tracev((stderr, "inflate:       stored end\n"));
                        state.mode = TYPE;
                        break;
                    case TABLE:
                        //=== NEEDBITS(14); */
                        while(bits < 14){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        state.nlen = (hold & 0x1f) + 257;
                        //--- DROPBITS(5) ---//
                        hold >>>= 5;
                        bits -= 5;
                        //---//
                        state.ndist = (hold & 0x1f) + 1;
                        //--- DROPBITS(5) ---//
                        hold >>>= 5;
                        bits -= 5;
                        //---//
                        state.ncode = (hold & 0x0f) + 4;
                        //--- DROPBITS(4) ---//
                        hold >>>= 4;
                        bits -= 4;
                        //---//
                        //#ifndef PKZIP_BUG_WORKAROUND
                        if (state.nlen > 286 || state.ndist > 30) {
                            strm.msg = 'too many length or distance symbols';
                            state.mode = BAD;
                            break;
                        }
                        //#endif
                        //Tracev((stderr, "inflate:       table sizes ok\n"));
                        state.have = 0;
                        state.mode = LENLENS;
                    /* falls through */ case LENLENS:
                        while(state.have < state.ncode){
                            //=== NEEDBITS(3);
                            while(bits < 3){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                            //--- DROPBITS(3) ---//
                            hold >>>= 3;
                            bits -= 3;
                        //---//
                        }
                        while(state.have < 19)state.lens[order[state.have++]] = 0;
                        // We have separate tables & no pointers. 2 commented lines below not needed.
                        //state.next = state.codes;
                        //state.lencode = state.next;
                        // Switch to use dynamic table
                        state.lencode = state.lendyn;
                        state.lenbits = 7;
                        opts = {
                            bits: state.lenbits
                        };
                        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
                        state.lenbits = opts.bits;
                        if (ret) {
                            strm.msg = 'invalid code lengths set';
                            state.mode = BAD;
                            break;
                        }
                        //Tracev((stderr, "inflate:       code lengths ok\n"));
                        state.have = 0;
                        state.mode = CODELENS;
                    /* falls through */ case CODELENS:
                        while(state.have < state.nlen + state.ndist){
                            for(;;){
                                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                                here_bits = here >>> 24;
                                here_op = here >>> 16 & 0xff;
                                here_val = here & 0xffff;
                                if (here_bits <= bits) break;
                                //--- PULLBYTE() ---//
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            //---//
                            }
                            if (here_val < 16) {
                                //--- DROPBITS(here.bits) ---//
                                hold >>>= here_bits;
                                bits -= here_bits;
                                //---//
                                state.lens[state.have++] = here_val;
                            } else {
                                if (here_val === 16) {
                                    //=== NEEDBITS(here.bits + 2);
                                    n = here_bits + 2;
                                    while(bits < n){
                                        if (have === 0) break inf_leave;
                                        have--;
                                        hold += input[next++] << bits;
                                        bits += 8;
                                    }
                                    //===//
                                    //--- DROPBITS(here.bits) ---//
                                    hold >>>= here_bits;
                                    bits -= here_bits;
                                    //---//
                                    if (state.have === 0) {
                                        strm.msg = 'invalid bit length repeat';
                                        state.mode = BAD;
                                        break;
                                    }
                                    len = state.lens[state.have - 1];
                                    copy = 3 + (hold & 0x03); //BITS(2);
                                    //--- DROPBITS(2) ---//
                                    hold >>>= 2;
                                    bits -= 2;
                                //---//
                                } else if (here_val === 17) {
                                    //=== NEEDBITS(here.bits + 3);
                                    n = here_bits + 3;
                                    while(bits < n){
                                        if (have === 0) break inf_leave;
                                        have--;
                                        hold += input[next++] << bits;
                                        bits += 8;
                                    }
                                    //===//
                                    //--- DROPBITS(here.bits) ---//
                                    hold >>>= here_bits;
                                    bits -= here_bits;
                                    //---//
                                    len = 0;
                                    copy = 3 + (hold & 0x07); //BITS(3);
                                    //--- DROPBITS(3) ---//
                                    hold >>>= 3;
                                    bits -= 3;
                                //---//
                                } else {
                                    //=== NEEDBITS(here.bits + 7);
                                    n = here_bits + 7;
                                    while(bits < n){
                                        if (have === 0) break inf_leave;
                                        have--;
                                        hold += input[next++] << bits;
                                        bits += 8;
                                    }
                                    //===//
                                    //--- DROPBITS(here.bits) ---//
                                    hold >>>= here_bits;
                                    bits -= here_bits;
                                    //---//
                                    len = 0;
                                    copy = 11 + (hold & 0x7f); //BITS(7);
                                    //--- DROPBITS(7) ---//
                                    hold >>>= 7;
                                    bits -= 7;
                                //---//
                                }
                                if (state.have + copy > state.nlen + state.ndist) {
                                    strm.msg = 'invalid bit length repeat';
                                    state.mode = BAD;
                                    break;
                                }
                                while(copy--)state.lens[state.have++] = len;
                            }
                        }
                        /* handle error breaks in while */ if (state.mode === BAD) break;
                        /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                            strm.msg = 'invalid code -- missing end-of-block';
                            state.mode = BAD;
                            break;
                        }
                        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
                        opts = {
                            bits: state.lenbits
                        };
                        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
                        // We have separate tables & no pointers. 2 commented lines below not needed.
                        // state.next_index = opts.table_index;
                        state.lenbits = opts.bits;
                        // state.lencode = state.next;
                        if (ret) {
                            strm.msg = 'invalid literal/lengths set';
                            state.mode = BAD;
                            break;
                        }
                        state.distbits = 6;
                        //state.distcode.copy(state.codes);
                        // Switch to use dynamic table
                        state.distcode = state.distdyn;
                        opts = {
                            bits: state.distbits
                        };
                        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
                        // We have separate tables & no pointers. 2 commented lines below not needed.
                        // state.next_index = opts.table_index;
                        state.distbits = opts.bits;
                        // state.distcode = state.next;
                        if (ret) {
                            strm.msg = 'invalid distances set';
                            state.mode = BAD;
                            break;
                        }
                        //Tracev((stderr, 'inflate:       codes ok\n'));
                        state.mode = LEN_;
                        if (flush === Z_TREES) break inf_leave;
                    /* falls through */ case LEN_:
                        state.mode = LEN;
                    /* falls through */ case LEN:
                        if (have >= 6 && left >= 258) {
                            //--- RESTORE() ---
                            strm.next_out = put;
                            strm.avail_out = left;
                            strm.next_in = next;
                            strm.avail_in = have;
                            state.hold = hold;
                            state.bits = bits;
                            //---
                            inflate_fast(strm, _out);
                            //--- LOAD() ---
                            put = strm.next_out;
                            output = strm.output;
                            left = strm.avail_out;
                            next = strm.next_in;
                            input = strm.input;
                            have = strm.avail_in;
                            hold = state.hold;
                            bits = state.bits;
                            //---
                            if (state.mode === TYPE) state.back = -1;
                            break;
                        }
                        state.back = 0;
                        for(;;){
                            here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                            here_bits = here >>> 24;
                            here_op = here >>> 16 & 0xff;
                            here_val = here & 0xffff;
                            if (here_bits <= bits) break;
                            //--- PULLBYTE() ---//
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        //---//
                        }
                        if (here_op && (here_op & 0xf0) === 0) {
                            last_bits = here_bits;
                            last_op = here_op;
                            last_val = here_val;
                            for(;;){
                                here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                                here_bits = here >>> 24;
                                here_op = here >>> 16 & 0xff;
                                here_val = here & 0xffff;
                                if (last_bits + here_bits <= bits) break;
                                //--- PULLBYTE() ---//
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            //---//
                            }
                            //--- DROPBITS(last.bits) ---//
                            hold >>>= last_bits;
                            bits -= last_bits;
                            //---//
                            state.back += last_bits;
                        }
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        state.back += here_bits;
                        state.length = here_val;
                        if (here_op === 0) {
                            //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                            //        "inflate:         literal '%c'\n" :
                            //        "inflate:         literal 0x%02x\n", here.val));
                            state.mode = LIT;
                            break;
                        }
                        if (here_op & 32) {
                            //Tracevv((stderr, "inflate:         end of block\n"));
                            state.back = -1;
                            state.mode = TYPE;
                            break;
                        }
                        if (here_op & 64) {
                            strm.msg = 'invalid literal/length code';
                            state.mode = BAD;
                            break;
                        }
                        state.extra = here_op & 15;
                        state.mode = LENEXT;
                    /* falls through */ case LENEXT:
                        if (state.extra) {
                            //=== NEEDBITS(state.extra);
                            n = state.extra;
                            while(bits < n){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                            //--- DROPBITS(state.extra) ---//
                            hold >>>= state.extra;
                            bits -= state.extra;
                            //---//
                            state.back += state.extra;
                        }
                        //Tracevv((stderr, "inflate:         length %u\n", state.length));
                        state.was = state.length;
                        state.mode = DIST;
                    /* falls through */ case DIST:
                        for(;;){
                            here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                            here_bits = here >>> 24;
                            here_op = here >>> 16 & 0xff;
                            here_val = here & 0xffff;
                            if (here_bits <= bits) break;
                            //--- PULLBYTE() ---//
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        //---//
                        }
                        if ((here_op & 0xf0) === 0) {
                            last_bits = here_bits;
                            last_op = here_op;
                            last_val = here_val;
                            for(;;){
                                here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                                here_bits = here >>> 24;
                                here_op = here >>> 16 & 0xff;
                                here_val = here & 0xffff;
                                if (last_bits + here_bits <= bits) break;
                                //--- PULLBYTE() ---//
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            //---//
                            }
                            //--- DROPBITS(last.bits) ---//
                            hold >>>= last_bits;
                            bits -= last_bits;
                            //---//
                            state.back += last_bits;
                        }
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        state.back += here_bits;
                        if (here_op & 64) {
                            strm.msg = 'invalid distance code';
                            state.mode = BAD;
                            break;
                        }
                        state.offset = here_val;
                        state.extra = here_op & 15;
                        state.mode = DISTEXT;
                    /* falls through */ case DISTEXT:
                        if (state.extra) {
                            //=== NEEDBITS(state.extra);
                            n = state.extra;
                            while(bits < n){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                            //--- DROPBITS(state.extra) ---//
                            hold >>>= state.extra;
                            bits -= state.extra;
                            //---//
                            state.back += state.extra;
                        }
                        //#ifdef INFLATE_STRICT
                        if (state.offset > state.dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = BAD;
                            break;
                        }
                        //#endif
                        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
                        state.mode = MATCH;
                    /* falls through */ case MATCH:
                        if (left === 0) break inf_leave;
                        copy = _out - left;
                        if (state.offset > copy) {
                            copy = state.offset - copy;
                            if (copy > state.whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = BAD;
                                    break;
                                }
                            }
                            if (copy > state.wnext) {
                                copy -= state.wnext;
                                from = state.wsize - copy;
                            } else from = state.wnext - copy;
                            if (copy > state.length) copy = state.length;
                            from_source = state.window;
                        } else {
                            from_source = output;
                            from = put - state.offset;
                            copy = state.length;
                        }
                        if (copy > left) copy = left;
                        left -= copy;
                        state.length -= copy;
                        do output[put++] = from_source[from++];
                        while (--copy);
                        if (state.length === 0) state.mode = LEN;
                        break;
                    case LIT:
                        if (left === 0) break inf_leave;
                        output[put++] = state.length;
                        left--;
                        state.mode = LEN;
                        break;
                    case CHECK:
                        if (state.wrap) {
                            //=== NEEDBITS(32);
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                // Use '|' instead of '+' to make sure that result is signed
                                hold |= input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            _out -= left;
                            strm.total_out += _out;
                            state.total += _out;
                            if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                            _out = left;
                            // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                            if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                                strm.msg = 'incorrect data check';
                                state.mode = BAD;
                                break;
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                        //===//
                        //Tracev((stderr, "inflate:   check matches trailer\n"));
                        }
                        state.mode = LENGTH;
                    /* falls through */ case LENGTH:
                        if (state.wrap && state.flags) {
                            //=== NEEDBITS(32);
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (hold !== (state.total & 0xffffffff)) {
                                strm.msg = 'incorrect length check';
                                state.mode = BAD;
                                break;
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                        //===//
                        //Tracev((stderr, "inflate:   length matches trailer\n"));
                        }
                        state.mode = DONE;
                    /* falls through */ case DONE:
                        ret = Z_STREAM_END;
                        break inf_leave;
                    case BAD:
                        ret = Z_DATA_ERROR;
                        break inf_leave;
                    case MEM:
                        return Z_MEM_ERROR;
                    case SYNC:
                    /* falls through */ default:
                        return Z_STREAM_ERROR;
                }
                // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
                /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
                    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
                        state.mode = MEM;
                        return Z_MEM_ERROR;
                    }
                }
                _in -= strm.avail_in;
                _out -= strm.avail_out;
                strm.total_in += _in;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
                strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
                if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
                return ret;
            }
            function inflateEnd(strm) {
                if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return Z_STREAM_ERROR;
                var state = strm.state;
                if (state.window) state.window = null;
                strm.state = null;
                return Z_OK;
            }
            function inflateGetHeader(strm, head) {
                var state;
                /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
                state = strm.state;
                if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
                /* save header structure */ state.head = head;
                head.done = false;
                return Z_OK;
            }
            function inflateSetDictionary(strm, dictionary) {
                var dictLength = dictionary.length;
                var state;
                var dictid;
                var ret;
                /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return Z_STREAM_ERROR;
                state = strm.state;
                if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR;
                /* check for correct dictionary identifier */ if (state.mode === DICT) {
                    dictid = 1; /* adler32(0, null, 0)*/ 
                    /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32(dictid, dictionary, dictLength, 0);
                    if (dictid !== state.check) return Z_DATA_ERROR;
                }
                /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
                if (ret) {
                    state.mode = MEM;
                    return Z_MEM_ERROR;
                }
                state.havedict = 1;
                // Tracev((stderr, "inflate:   dictionary set\n"));
                return Z_OK;
            }
            exports.inflateReset = inflateReset;
            exports.inflateReset2 = inflateReset2;
            exports.inflateResetKeep = inflateResetKeep;
            exports.inflateInit = inflateInit;
            exports.inflateInit2 = inflateInit2;
            exports.inflate = inflate;
            exports.inflateEnd = inflateEnd;
            exports.inflateGetHeader = inflateGetHeader;
            exports.inflateSetDictionary = inflateSetDictionary;
            exports.inflateInfo = 'pako inflate (from Nodeca project)';
        /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ },
        {
            "../utils/common": 192,
            "./adler32": 193,
            "./crc32": 195,
            "./inffast": 197,
            "./inftrees": 199
        }
    ],
    199: [
        function(require1, module, exports) {
            'use strict';
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
            var utils = require1('../utils/common');
            var MAXBITS = 15;
            var ENOUGH_LENS = 852;
            var ENOUGH_DISTS = 592;
            //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
            var CODES = 0;
            var LENS = 1;
            var DISTS = 2;
            var lbase = [
                /* Length codes 257..285 base */ 3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                13,
                15,
                17,
                19,
                23,
                27,
                31,
                35,
                43,
                51,
                59,
                67,
                83,
                99,
                115,
                131,
                163,
                195,
                227,
                258,
                0,
                0
            ];
            var lext = [
                /* Length codes 257..285 extra */ 16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                17,
                17,
                17,
                17,
                18,
                18,
                18,
                18,
                19,
                19,
                19,
                19,
                20,
                20,
                20,
                20,
                21,
                21,
                21,
                21,
                16,
                72,
                78
            ];
            var dbase = [
                /* Distance codes 0..29 base */ 1,
                2,
                3,
                4,
                5,
                7,
                9,
                13,
                17,
                25,
                33,
                49,
                65,
                97,
                129,
                193,
                257,
                385,
                513,
                769,
                1025,
                1537,
                2049,
                3073,
                4097,
                6145,
                8193,
                12289,
                16385,
                24577,
                0,
                0
            ];
            var dext = [
                /* Distance codes 0..29 extra */ 16,
                16,
                16,
                16,
                17,
                17,
                18,
                18,
                19,
                19,
                20,
                20,
                21,
                21,
                22,
                22,
                23,
                23,
                24,
                24,
                25,
                25,
                26,
                26,
                27,
                27,
                28,
                28,
                29,
                29,
                64,
                64
            ];
            module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
                var bits = opts.bits;
                //here = opts.here; /* table entry for duplication */
                var len = 0; /* a code's length in bits */ 
                var sym = 0; /* index of code symbols */ 
                var min = 0, max = 0; /* minimum and maximum code lengths */ 
                var root = 0; /* number of index bits for root table */ 
                var curr = 0; /* number of index bits for current table */ 
                var drop = 0; /* code bits to drop for sub-table */ 
                var left = 0; /* number of prefix codes available */ 
                var used = 0; /* code entries in table used */ 
                var huff = 0; /* Huffman code */ 
                var incr; /* for incrementing code, index */ 
                var fill; /* index for replicating entries */ 
                var low; /* low bits for current root entry */ 
                var mask; /* mask for low root bits */ 
                var next; /* next available space in table */ 
                var base = null; /* base value table to use */ 
                var base_index = 0;
                //  var shoextra;    /* extra bits table to use */
                var end; /* use base and extra for symbol > end */ 
                var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
                var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
                var extra = null;
                var extra_index = 0;
                var here_bits, here_op, here_val;
                /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
                for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
                /* bound code lengths, force root to be within code lengths */ root = bits;
                for(max = MAXBITS; max >= 1; max--){
                    if (count[max] !== 0) break;
                }
                if (root > max) root = max;
                if (max === 0) {
                    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
                    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
                    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
                    table[table_index++] = 20971520;
                    //table.op[opts.table_index] = 64;
                    //table.bits[opts.table_index] = 1;
                    //table.val[opts.table_index++] = 0;
                    table[table_index++] = 20971520;
                    opts.bits = 1;
                    return 0; /* no symbols, but wait for decoding to report error */ 
                }
                for(min = 1; min < max; min++){
                    if (count[min] !== 0) break;
                }
                if (root < min) root = min;
                /* check for an over-subscribed or incomplete set of lengths */ left = 1;
                for(len = 1; len <= MAXBITS; len++){
                    left <<= 1;
                    left -= count[len];
                    if (left < 0) return -1;
                     /* over-subscribed */ 
                }
                if (left > 0 && (type === CODES || max !== 1)) return -1; /* incomplete set */ 
                /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
                for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
                /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
                /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
                // to avoid deopts in old v8
                if (type === CODES) {
                    base = extra = work; /* dummy value--not used */ 
                    end = 19;
                } else if (type === LENS) {
                    base = lbase;
                    base_index -= 257;
                    extra = lext;
                    extra_index -= 257;
                    end = 256;
                } else {
                    base = dbase;
                    extra = dext;
                    end = -1;
                }
                /* initialize opts for loop */ huff = 0; /* starting code */ 
                sym = 0; /* starting code symbol */ 
                len = min; /* starting code length */ 
                next = table_index; /* current table to fill in */ 
                curr = root; /* current table index bits */ 
                drop = 0; /* current bits to drop from code for index */ 
                low = -1; /* trigger new sub-table when len > root */ 
                used = 1 << root; /* use root table entries */ 
                mask = used - 1; /* mask for comparing low */ 
                /* check available table space */ if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
                /* process all codes and make table entries */ for(;;){
                    /* create table entry */ here_bits = len - drop;
                    if (work[sym] < end) {
                        here_op = 0;
                        here_val = work[sym];
                    } else if (work[sym] > end) {
                        here_op = extra[extra_index + work[sym]];
                        here_val = base[base_index + work[sym]];
                    } else {
                        here_op = 96; /* end of block */ 
                        here_val = 0;
                    }
                    /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
                    fill = 1 << curr;
                    min = fill; /* save offset to next table */ 
                    do {
                        fill -= incr;
                        table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
                    }while (fill !== 0);
                    /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
                    while(huff & incr)incr >>= 1;
                    if (incr !== 0) {
                        huff &= incr - 1;
                        huff += incr;
                    } else huff = 0;
                    /* go to next symbol, update count, len */ sym++;
                    if (--count[len] === 0) {
                        if (len === max) break;
                        len = lens[lens_index + work[sym]];
                    }
                    /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
                        /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
                        /* increment past last table */ next += min; /* here min is 1 << curr */ 
                        /* determine length of next table */ curr = len - drop;
                        left = 1 << curr;
                        while(curr + drop < max){
                            left -= count[curr + drop];
                            if (left <= 0) break;
                            curr++;
                            left <<= 1;
                        }
                        /* check for enough space */ used += 1 << curr;
                        if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
                        /* point entry in root table to sub-table */ low = huff & mask;
                        /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
                    }
                }
                /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
                //table.bits[next + huff] = len - drop;
                //table.val[next + huff] = 0;
                table[next + huff] = len - drop << 24 | 4194304;
                /* set return parameters */ //opts.table_index += used;
                opts.bits = root;
                return 0;
            };
        },
        {
            "../utils/common": 192
        }
    ],
    200: [
        function(require1, module, exports) {
            'use strict';
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
            module.exports = {
                2: 'need dictionary',
                /* Z_NEED_DICT       2  */ 1: 'stream end',
                /* Z_STREAM_END      1  */ 0: '',
                /* Z_OK              0  */ '-1': 'file error',
                /* Z_ERRNO         (-1) */ '-2': 'stream error',
                /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
                /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
                /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
                /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
            };
        },
        {}
    ],
    201: [
        function(require1, module, exports) {
            'use strict';
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
            var utils = require1('../utils/common');
            /* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
            //var Z_HUFFMAN_ONLY      = 2;
            //var Z_RLE               = 3;
            var Z_FIXED = 4;
            //var Z_DEFAULT_STRATEGY  = 0;
            /* Possible values of the data_type field (though see inflate()) */ var Z_BINARY = 0;
            var Z_TEXT = 1;
            //var Z_ASCII             = 1; // = Z_TEXT
            var Z_UNKNOWN = 2;
            /*============================================================================*/ function zero(buf) {
                var len = buf.length;
                while(--len >= 0)buf[len] = 0;
            }
            // From zutil.h
            var STORED_BLOCK = 0;
            var STATIC_TREES = 1;
            var DYN_TREES = 2;
            /* The three kinds of block type */ var MIN_MATCH = 3;
            var MAX_MATCH = 258;
            /* The minimum and maximum match lengths */ // From deflate.h
            /* ===========================================================================
 * Internal compression state.
 */ var LENGTH_CODES = 29;
            /* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
            /* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
            /* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
            /* number of distance codes */ var BL_CODES = 19;
            /* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
            /* maximum heap size */ var MAX_BITS = 15;
            /* All codes must not exceed MAX_BITS bits */ var Buf_size = 16;
            /* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var MAX_BL_BITS = 7;
            /* Bit length codes must not exceed MAX_BL_BITS bits */ var END_BLOCK = 256;
            /* end of block literal code */ var REP_3_6 = 16;
            /* repeat previous bit length 3-6 times (2 bits of repeat count) */ var REPZ_3_10 = 17;
            /* repeat a zero length 3-10 times  (3 bits of repeat count) */ var REPZ_11_138 = 18;
            /* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var extra_lbits = /* extra bits for each length code */ [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                0
            ];
            var extra_dbits = /* extra bits for each distance code */ [
                0,
                0,
                0,
                0,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                5,
                5,
                6,
                6,
                7,
                7,
                8,
                8,
                9,
                9,
                10,
                10,
                11,
                11,
                12,
                12,
                13,
                13
            ];
            var extra_blbits = /* extra bits for each bit length code */ [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                2,
                3,
                7
            ];
            var bl_order = [
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ];
            /* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
            var DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
            // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
            var static_ltree = new Array((L_CODES + 2) * 2);
            zero(static_ltree);
            /* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var static_dtree = new Array(D_CODES * 2);
            zero(static_dtree);
            /* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var _dist_code = new Array(DIST_CODE_LEN);
            zero(_dist_code);
            /* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
            zero(_length_code);
            /* length code for each normalized match length (0 == MIN_MATCH) */ var base_length = new Array(LENGTH_CODES);
            zero(base_length);
            /* First normalized length for each code (0 = MIN_MATCH) */ var base_dist = new Array(D_CODES);
            zero(base_dist);
            /* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
                this.static_tree = static_tree; /* static tree or NULL */ 
                this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
                this.extra_base = extra_base; /* base index for extra_bits */ 
                this.elems = elems; /* max number of elements in the tree */ 
                this.max_length = max_length; /* max bit length for the codes */ 
                // show if `static_tree` has data or dummy - needed for monomorphic objects
                this.has_stree = static_tree && static_tree.length;
            }
            var static_l_desc;
            var static_d_desc;
            var static_bl_desc;
            function TreeDesc(dyn_tree, stat_desc) {
                this.dyn_tree = dyn_tree; /* the dynamic tree */ 
                this.max_code = 0; /* largest code with non zero frequency */ 
                this.stat_desc = stat_desc; /* the corresponding static tree */ 
            }
            function d_code(dist) {
                return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
            }
            /* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function put_short(s, w) {
                //    put_byte(s, (uch)((w) & 0xff));
                //    put_byte(s, (uch)((ush)(w) >> 8));
                s.pending_buf[s.pending++] = w & 0xff;
                s.pending_buf[s.pending++] = w >>> 8 & 0xff;
            }
            /* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function send_bits(s, value, length) {
                if (s.bi_valid > Buf_size - length) {
                    s.bi_buf |= value << s.bi_valid & 0xffff;
                    put_short(s, s.bi_buf);
                    s.bi_buf = value >> Buf_size - s.bi_valid;
                    s.bi_valid += length - Buf_size;
                } else {
                    s.bi_buf |= value << s.bi_valid & 0xffff;
                    s.bi_valid += length;
                }
            }
            function send_code(s, c, tree) {
                send_bits(s, tree[c * 2], tree[c * 2 + 1]);
            }
            /* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function bi_reverse(code, len) {
                var res = 0;
                do {
                    res |= code & 1;
                    code >>>= 1;
                    res <<= 1;
                }while (--len > 0);
                return res >>> 1;
            }
            /* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function bi_flush(s) {
                if (s.bi_valid === 16) {
                    put_short(s, s.bi_buf);
                    s.bi_buf = 0;
                    s.bi_valid = 0;
                } else if (s.bi_valid >= 8) {
                    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                    s.bi_buf >>= 8;
                    s.bi_valid -= 8;
                }
            }
            /* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function gen_bitlen(s, desc) //    deflate_state *s;
            //    tree_desc *desc;    /* the tree descriptor */
            {
                var tree = desc.dyn_tree;
                var max_code = desc.max_code;
                var stree = desc.stat_desc.static_tree;
                var has_stree = desc.stat_desc.has_stree;
                var extra = desc.stat_desc.extra_bits;
                var base = desc.stat_desc.extra_base;
                var max_length = desc.stat_desc.max_length;
                var h; /* heap index */ 
                var n, m; /* iterate over the tree elements */ 
                var bits; /* bit length */ 
                var xbits; /* extra bits */ 
                var f; /* frequency */ 
                var overflow = 0; /* number of elements with bit length too large */ 
                for(bits = 0; bits <= MAX_BITS; bits++)s.bl_count[bits] = 0;
                /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
                for(h = s.heap_max + 1; h < HEAP_SIZE; h++){
                    n = s.heap[h];
                    bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
                    if (bits > max_length) {
                        bits = max_length;
                        overflow++;
                    }
                    tree[n * 2 + 1] = bits;
                    /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
                     /* not a leaf node */ 
                    s.bl_count[bits]++;
                    xbits = 0;
                    if (n >= base) xbits = extra[n - base];
                    f = tree[n * 2] /*.Freq*/ ;
                    s.opt_len += f * (bits + xbits);
                    if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
                }
                if (overflow === 0) return;
                // Trace((stderr,"\nbit length overflow\n"));
                /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
                    bits = max_length - 1;
                    while(s.bl_count[bits] === 0)bits--;
                    s.bl_count[bits]--; /* move one leaf down the tree */ 
                    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
                    s.bl_count[max_length]--;
                    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
                }while (overflow > 0);
                /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
                    n = s.bl_count[bits];
                    while(n !== 0){
                        m = s.heap[--h];
                        if (m > max_code) continue;
                        if (tree[m * 2 + 1] !== bits) {
                            // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                            s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                            tree[m * 2 + 1] = bits;
                        }
                        n--;
                    }
                }
            }
            /* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
            //    int max_code;              /* largest code with non zero frequency */
            //    ushf *bl_count;            /* number of codes at each bit length */
            {
                var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */ 
                var code = 0; /* running code value */ 
                var bits; /* bit index */ 
                var n; /* code index */ 
                /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
                /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
                //        "inconsistent bit counts");
                //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
                for(n = 0; n <= max_code; n++){
                    var len = tree[n * 2 + 1] /*.Len*/ ;
                    if (len === 0) continue;
                    /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
                //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
                }
            }
            /* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function tr_static_init() {
                var n; /* iterates over tree elements */ 
                var bits; /* bit counter */ 
                var length; /* length value */ 
                var code; /* code value */ 
                var dist; /* distance index */ 
                var bl_count = new Array(MAX_BITS + 1);
                /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
                //if (static_init_done) return;
                /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
                for(code = 0; code < LENGTH_CODES - 1; code++){
                    base_length[code] = length;
                    for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
                }
                //Assert (length == 256, "tr_static_init: length != 256");
                /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
                /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
                for(code = 0; code < 16; code++){
                    base_dist[code] = dist;
                    for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
                }
                //Assert (dist == 256, "tr_static_init: dist != 256");
                dist >>= 7; /* from now on, all distances are divided by 128 */ 
                for(; code < D_CODES; code++){
                    base_dist[code] = dist << 7;
                    for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
                }
                //Assert (dist == 256, "tr_static_init: 256+dist != 512");
                /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS; bits++)bl_count[bits] = 0;
                n = 0;
                while(n <= 143){
                    static_ltree[n * 2 + 1] = 8;
                    n++;
                    bl_count[8]++;
                }
                while(n <= 255){
                    static_ltree[n * 2 + 1] = 9;
                    n++;
                    bl_count[9]++;
                }
                while(n <= 279){
                    static_ltree[n * 2 + 1] = 7;
                    n++;
                    bl_count[7]++;
                }
                while(n <= 287){
                    static_ltree[n * 2 + 1] = 8;
                    n++;
                    bl_count[8]++;
                }
                /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES + 1, bl_count);
                /* The static distance tree is trivial: */ for(n = 0; n < D_CODES; n++){
                    static_dtree[n * 2 + 1] = 5;
                    static_dtree[n * 2] = bi_reverse(n, 5);
                }
                // Now data ready and we can init static trees
                static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
                static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
                static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
            //static_init_done = true;
            }
            /* ===========================================================================
 * Initialize a new block.
 */ function init_block(s) {
                var n; /* iterates over tree elements */ 
                /* Initialize the trees. */ for(n = 0; n < L_CODES; n++)s.dyn_ltree[n * 2] = 0;
                for(n = 0; n < D_CODES; n++)s.dyn_dtree[n * 2] = 0;
                for(n = 0; n < BL_CODES; n++)s.bl_tree[n * 2] = 0;
                s.dyn_ltree[END_BLOCK * 2] = 1;
                s.opt_len = s.static_len = 0;
                s.last_lit = s.matches = 0;
            }
            /* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function bi_windup(s) {
                if (s.bi_valid > 8) put_short(s, s.bi_buf);
                else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
                s.pending_buf[s.pending++] = s.bi_buf;
                s.bi_buf = 0;
                s.bi_valid = 0;
            }
            /* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function copy_block(s, buf, len, header) //DeflateState *s;
            //charf    *buf;    /* the input data */
            //unsigned len;     /* its length */
            //int      header;  /* true if block header must be written */
            {
                bi_windup(s); /* align on byte boundary */ 
                if (header) {
                    put_short(s, len);
                    put_short(s, ~len);
                }
                //  while (len--) {
                //    put_byte(s, *buf++);
                //  }
                utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
                s.pending += len;
            }
            /* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function smaller(tree, n, m, depth) {
                var _n2 = n * 2;
                var _m2 = m * 2;
                return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
            }
            /* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function pqdownheap(s, tree, k) //    deflate_state *s;
            //    ct_data *tree;  /* the tree to restore */
            //    int k;               /* node to move down */
            {
                var v = s.heap[k];
                var j = k << 1; /* left son of k */ 
                while(j <= s.heap_len){
                    /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
                    /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
                    /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
                    k = j;
                    /* And continue down the tree, setting j to the left son of k */ j <<= 1;
                }
                s.heap[k] = v;
            }
            // inlined manually
            // var SMALLEST = 1;
            /* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function compress_block(s, ltree, dtree) //    deflate_state *s;
            //    const ct_data *ltree; /* literal tree */
            //    const ct_data *dtree; /* distance tree */
            {
                var dist; /* distance of matched string */ 
                var lc; /* match length or unmatched char (if dist == 0) */ 
                var lx = 0; /* running index in l_buf */ 
                var code; /* the code to send */ 
                var extra; /* number of extra bits to send */ 
                if (s.last_lit !== 0) do {
                    dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
                    lc = s.pending_buf[s.l_buf + lx];
                    lx++;
                    if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
                    else {
                        /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
                        send_code(s, code + LITERALS + 1, ltree); /* send the length code */ 
                        extra = extra_lbits[code];
                        if (extra !== 0) {
                            lc -= base_length[code];
                            send_bits(s, lc, extra); /* send the extra length bits */ 
                        }
                        dist--; /* dist is now the match distance - 1 */ 
                        code = d_code(dist);
                        //Assert (code < D_CODES, "bad d_code");
                        send_code(s, code, dtree); /* send the distance code */ 
                        extra = extra_dbits[code];
                        if (extra !== 0) {
                            dist -= base_dist[code];
                            send_bits(s, dist, extra); /* send the extra distance bits */ 
                        }
                    } /* literal or match pair ? */ 
                /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                //       "pendingBuf overflow");
                }while (lx < s.last_lit);
                send_code(s, END_BLOCK, ltree);
            }
            /* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function build_tree(s, desc) //    deflate_state *s;
            //    tree_desc *desc; /* the tree descriptor */
            {
                var tree = desc.dyn_tree;
                var stree = desc.stat_desc.static_tree;
                var has_stree = desc.stat_desc.has_stree;
                var elems = desc.stat_desc.elems;
                var n, m; /* iterate over heap elements */ 
                var max_code = -1; /* largest code with non zero frequency */ 
                var node; /* new node being created */ 
                /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
                s.heap_max = HEAP_SIZE;
                for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
                    s.heap[++s.heap_len] = max_code = n;
                    s.depth[n] = 0;
                } else tree[n * 2 + 1] = 0;
                /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
                    node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                    tree[node * 2] = 1;
                    s.depth[node] = 0;
                    s.opt_len--;
                    if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
                /* node is 0 or 1 so it does not have extra bits */ }
                desc.max_code = max_code;
                /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
                /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
                do {
                    //pqremove(s, tree, n);  /* n = node of least frequency */
                    /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
                    s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
                    pqdownheap(s, tree, 1 /*SMALLEST*/ );
                    /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
                    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
                    s.heap[--s.heap_max] = m;
                    /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
                    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                    tree[n * 2 + 1] = tree[m * 2 + 1] = node;
                    /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
                    pqdownheap(s, tree, 1 /*SMALLEST*/ );
                }while (s.heap_len >= 2);
                s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
                /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
                /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
            }
            /* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function scan_tree(s, tree, max_code) //    deflate_state *s;
            //    ct_data *tree;   /* the tree to be scanned */
            //    int max_code;    /* and its largest code of non zero frequency */
            {
                var n; /* iterates over all tree elements */ 
                var prevlen = -1; /* last emitted length */ 
                var curlen; /* length of current code */ 
                var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
                var count = 0; /* repeat count of the current code */ 
                var max_count = 7; /* max repeat count */ 
                var min_count = 4; /* min repeat count */ 
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
                for(n = 0; n <= max_code; n++){
                    curlen = nextlen;
                    nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
                    if (++count < max_count && curlen === nextlen) continue;
                    else if (count < min_count) s.bl_tree[curlen * 2] += count;
                    else if (curlen !== 0) {
                        if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
                        s.bl_tree[REP_3_6 * 2]++;
                    } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
                    else s.bl_tree[REPZ_11_138 * 2]++;
                    count = 0;
                    prevlen = curlen;
                    if (nextlen === 0) {
                        max_count = 138;
                        min_count = 3;
                    } else if (curlen === nextlen) {
                        max_count = 6;
                        min_count = 3;
                    } else {
                        max_count = 7;
                        min_count = 4;
                    }
                }
            }
            /* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function send_tree(s, tree, max_code) //    deflate_state *s;
            //    ct_data *tree; /* the tree to be scanned */
            //    int max_code;       /* and its largest code of non zero frequency */
            {
                var n; /* iterates over all tree elements */ 
                var prevlen = -1; /* last emitted length */ 
                var curlen; /* length of current code */ 
                var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
                var count = 0; /* repeat count of the current code */ 
                var max_count = 7; /* max repeat count */ 
                var min_count = 4; /* min repeat count */ 
                /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                for(n = 0; n <= max_code; n++){
                    curlen = nextlen;
                    nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
                    if (++count < max_count && curlen === nextlen) continue;
                    else if (count < min_count) do send_code(s, curlen, s.bl_tree);
                    while (--count !== 0);
                    else if (curlen !== 0) {
                        if (curlen !== prevlen) {
                            send_code(s, curlen, s.bl_tree);
                            count--;
                        }
                        //Assert(count >= 3 && count <= 6, " 3_6?");
                        send_code(s, REP_3_6, s.bl_tree);
                        send_bits(s, count - 3, 2);
                    } else if (count <= 10) {
                        send_code(s, REPZ_3_10, s.bl_tree);
                        send_bits(s, count - 3, 3);
                    } else {
                        send_code(s, REPZ_11_138, s.bl_tree);
                        send_bits(s, count - 11, 7);
                    }
                    count = 0;
                    prevlen = curlen;
                    if (nextlen === 0) {
                        max_count = 138;
                        min_count = 3;
                    } else if (curlen === nextlen) {
                        max_count = 6;
                        min_count = 3;
                    } else {
                        max_count = 7;
                        min_count = 4;
                    }
                }
            }
            /* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function build_bl_tree(s) {
                var max_blindex; /* index of last bit length code of non zero freq */ 
                /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
                scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
                /* Build the bit length tree: */ build_tree(s, s.bl_desc);
                /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--){
                    if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
                }
                /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
                //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
                //        s->opt_len, s->static_len));
                return max_blindex;
            }
            /* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
            //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
            {
                var rank; /* index in bl_order */ 
                //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
                //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
                //        "too many codes");
                //Tracev((stderr, "\nbl counts: "));
                send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
                send_bits(s, dcodes - 1, 5);
                send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
                for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
                //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
                send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
                //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
                send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
            //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
            }
            /* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function detect_data_type(s) {
                /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
                var n;
                /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
                    if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
                }
                /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
                for(n = 32; n < LITERALS; n++){
                    if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
                }
                /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
            }
            var static_init_done = false;
            /* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function _tr_init(s) {
                if (!static_init_done) {
                    tr_static_init();
                    static_init_done = true;
                }
                s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
                s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
                s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
                s.bi_buf = 0;
                s.bi_valid = 0;
                /* Initialize the first block of the first file: */ init_block(s);
            }
            /* ===========================================================================
 * Send a stored block
 */ function _tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
            //charf *buf;       /* input block */
            //ulg stored_len;   /* length of input block */
            //int last;         /* one if this is the last block for a file */
            {
                send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
                copy_block(s, buf, stored_len, true); /* with header */ 
            }
            /* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function _tr_align(s) {
                send_bits(s, STATIC_TREES << 1, 3);
                send_code(s, END_BLOCK, static_ltree);
                bi_flush(s);
            }
            /* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function _tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
            //charf *buf;       /* input block, or NULL if too old */
            //ulg stored_len;   /* length of input block */
            //int last;         /* one if this is the last block for a file */
            {
                var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
                var max_blindex = 0; /* index of last bit length code of non zero freq */ 
                /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
                    /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN) s.strm.data_type = detect_data_type(s);
                    /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
                    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                    //        s->static_len));
                    build_tree(s, s.d_desc);
                    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                    //        s->static_len));
                    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
                    /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
                    static_lenb = s.static_len + 3 + 7 >>> 3;
                    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                    //        s->last_lit));
                    if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
                } else // Assert(buf != (char*)0, "lost buf");
                opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
                if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block(s, buf, stored_len, last);
                else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                    compress_block(s, static_ltree, static_dtree);
                } else {
                    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                    compress_block(s, s.dyn_ltree, s.dyn_dtree);
                }
                // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
                /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
                if (last) bi_windup(s);
            // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
            //       s->compressed_len-7*last));
            }
            /* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function _tr_tally(s, dist, lc) //    deflate_state *s;
            //    unsigned dist;  /* distance of matched string */
            //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
            {
                //var out_length, in_length, dcode;
                s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
                s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
                s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
                s.last_lit++;
                if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
                else {
                    s.matches++;
                    /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
                    //Assert((ush)dist < (ush)MAX_DIST(s) &&
                    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
                    s.dyn_dtree[d_code(dist) * 2]++;
                }
                // (!) This block is disabled in zlib defaults,
                // don't enable it for binary compatibility
                //#ifdef TRUNCATE_BLOCK
                //  /* Try to guess if it is profitable to stop the current block here */
                //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
                //    /* Compute an upper bound for the compressed length */
                //    out_length = s.last_lit*8;
                //    in_length = s.strstart - s.block_start;
                //
                //    for (dcode = 0; dcode < D_CODES; dcode++) {
                //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
                //    }
                //    out_length >>>= 3;
                //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
                //    //       s->last_lit, in_length, out_length,
                //    //       100L - out_length*100L/in_length));
                //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
                //      return true;
                //    }
                //  }
                //#endif
                return s.last_lit === s.lit_bufsize - 1;
            /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
            exports._tr_init = _tr_init;
            exports._tr_stored_block = _tr_stored_block;
            exports._tr_flush_block = _tr_flush_block;
            exports._tr_tally = _tr_tally;
            exports._tr_align = _tr_align;
        },
        {
            "../utils/common": 192
        }
    ],
    202: [
        function(require1, module, exports) {
            'use strict';
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
            function ZStream() {
                /* next input byte */ this.input = null; // JS specific, because we have no pointers
                this.next_in = 0;
                /* number of bytes available at input */ this.avail_in = 0;
                /* total number of input bytes read so far */ this.total_in = 0;
                /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
                this.next_out = 0;
                /* remaining free space at output */ this.avail_out = 0;
                /* total number of bytes output so far */ this.total_out = 0;
                /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
                /* not visible by applications */ this.state = null;
                /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
                /* adler32 value of the uncompressed data */ this.adler = 0;
            }
            module.exports = ZStream;
        },
        {}
    ],
    203: [
        function(require1, module, exports) {
            (function(process) {
                'use strict';
                if (!process.version || process.version.indexOf('v0.') === 0 || process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) module.exports = nextTick;
                else module.exports = process.nextTick;
                function nextTick(fn, arg1, arg2, arg3) {
                    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
                    var len = arguments.length;
                    var args, i;
                    switch(len){
                        case 0:
                        case 1:
                            return process.nextTick(fn);
                        case 2:
                            return process.nextTick(function afterTickOne() {
                                fn.call(null, arg1);
                            });
                        case 3:
                            return process.nextTick(function afterTickTwo() {
                                fn.call(null, arg1, arg2);
                            });
                        case 4:
                            return process.nextTick(function afterTickThree() {
                                fn.call(null, arg1, arg2, arg3);
                            });
                        default:
                            args = new Array(len - 1);
                            i = 0;
                            while(i < args.length)args[i++] = arguments[i];
                            return process.nextTick(function afterTick() {
                                fn.apply(null, args);
                            });
                    }
                }
            }).call(this, require1('_process'));
        },
        {
            "_process": 204
        }
    ],
    204: [
        function(require1, module, exports) {
            // shim for using process in browser
            var process = module.exports = {};
            // cached from whatever global is present so that test runners that stub it
            // don't break things.  But we need to wrap it in a try catch in case it is
            // wrapped in strict mode code which doesn't define any globals.  It's inside a
            // function because try/catches deoptimize in certain engines.
            var cachedSetTimeout;
            var cachedClearTimeout;
            function defaultSetTimout() {
                throw new Error('setTimeout has not been defined');
            }
            function defaultClearTimeout() {
                throw new Error('clearTimeout has not been defined');
            }
            (function() {
                try {
                    if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
                    else cachedSetTimeout = defaultSetTimout;
                } catch (e) {
                    cachedSetTimeout = defaultSetTimout;
                }
                try {
                    if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
                    else cachedClearTimeout = defaultClearTimeout;
                } catch (e) {
                    cachedClearTimeout = defaultClearTimeout;
                }
            })();
            function runTimeout(fun) {
                if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                return setTimeout(fun, 0);
                // if setTimeout wasn't available but was latter defined
                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                    cachedSetTimeout = setTimeout;
                    return setTimeout(fun, 0);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedSetTimeout(fun, 0);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                        return cachedSetTimeout.call(null, fun, 0);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                        return cachedSetTimeout.call(this, fun, 0);
                    }
                }
            }
            function runClearTimeout(marker) {
                if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                return clearTimeout(marker);
                // if clearTimeout wasn't available but was latter defined
                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                    cachedClearTimeout = clearTimeout;
                    return clearTimeout(marker);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedClearTimeout(marker);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                        return cachedClearTimeout.call(null, marker);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                        return cachedClearTimeout.call(this, marker);
                    }
                }
            }
            var queue = [];
            var draining = false;
            var currentQueue;
            var queueIndex = -1;
            function cleanUpNextTick() {
                if (!draining || !currentQueue) return;
                draining = false;
                if (currentQueue.length) queue = currentQueue.concat(queue);
                else queueIndex = -1;
                if (queue.length) drainQueue();
            }
            function drainQueue() {
                if (draining) return;
                var timeout = runTimeout(cleanUpNextTick);
                draining = true;
                var len = queue.length;
                while(len){
                    currentQueue = queue;
                    queue = [];
                    while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                    queueIndex = -1;
                    len = queue.length;
                }
                currentQueue = null;
                draining = false;
                runClearTimeout(timeout);
            }
            process.nextTick = function(fun) {
                var args = new Array(arguments.length - 1);
                if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                queue.push(new Item(fun, args));
                if (queue.length === 1 && !draining) runTimeout(drainQueue);
            };
            // v8 likes predictible objects
            function Item(fun, array) {
                this.fun = fun;
                this.array = array;
            }
            Item.prototype.run = function() {
                this.fun.apply(null, this.array);
            };
            process.title = 'browser';
            process.browser = true;
            process.env = {};
            process.argv = [];
            process.version = ''; // empty string to avoid regexp issues
            process.versions = {};
            function noop() {}
            process.on = noop;
            process.addListener = noop;
            process.once = noop;
            process.off = noop;
            process.removeListener = noop;
            process.removeAllListeners = noop;
            process.emit = noop;
            process.prependListener = noop;
            process.prependOnceListener = noop;
            process.listeners = function(name) {
                return [];
            };
            process.binding = function(name) {
                throw new Error('process.binding is not supported');
            };
            process.cwd = function() {
                return '/';
            };
            process.chdir = function(dir) {
                throw new Error('process.chdir is not supported');
            };
            process.umask = function() {
                return 0;
            };
        },
        {}
    ],
    205: [
        function(require1, module, exports) {
            (function(global1) {
                (function(root) {
                    /** Detect free variables */ var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
                    var freeModule = typeof module == 'object' && module && !module.nodeType && module;
                    var freeGlobal = typeof global1 == 'object' && global1;
                    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
                    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
                        'overflow': 'Overflow: input needs wider integers to process',
                        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
                        'invalid-input': 'Invalid input'
                    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
                    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
                        throw new RangeError(errors[type]);
                    }
                    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
                        var length = array.length;
                        var result = [];
                        while(length--)result[length] = fn(array[length]);
                        return result;
                    }
                    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
                        var parts = string.split('@');
                        var result = '';
                        if (parts.length > 1) {
                            // In email addresses, only the domain name should be punycoded. Leave
                            // the local part (i.e. everything up to `@`) intact.
                            result = parts[0] + '@';
                            string = parts[1];
                        }
                        // Avoid `split(regex)` for IE8 compatibility. See #17.
                        string = string.replace(regexSeparators, '\x2E');
                        var labels = string.split('.');
                        var encoded = map(labels, fn).join('.');
                        return result + encoded;
                    }
                    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
                        var output = [], counter = 0, length = string.length, value, extra;
                        while(counter < length){
                            value = string.charCodeAt(counter++);
                            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                                // high surrogate, and there is a next character
                                extra = string.charCodeAt(counter++);
                                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                                else {
                                    // unmatched surrogate; only append this code unit, in case the next
                                    // code unit is the high surrogate of a surrogate pair
                                    output.push(value);
                                    counter--;
                                }
                            } else output.push(value);
                        }
                        return output;
                    }
                    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
                        return map(array, function(value) {
                            var output = '';
                            if (value > 0xFFFF) {
                                value -= 0x10000;
                                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                                value = 0xDC00 | value & 0x3FF;
                            }
                            output += stringFromCharCode(value);
                            return output;
                        }).join('');
                    }
                    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
                        if (codePoint - 48 < 10) return codePoint - 22;
                        if (codePoint - 65 < 26) return codePoint - 65;
                        if (codePoint - 97 < 26) return codePoint - 97;
                        return base;
                    }
                    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
                        //  0..25 map to ASCII a..z or A..Z
                        // 26..35 map to ASCII 0..9
                        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
                    }
                    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
                        var k = 0;
                        delta = firstTime ? floor(delta / damp) : delta >> 1;
                        delta += floor(delta / numPoints);
                        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
                        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
                    }
                    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
                        // Don't use UCS-2
                        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
                        // Handle the basic code points: let `basic` be the number of input code
                        // points before the last delimiter, or `0` if there is none, then copy
                        // the first basic code points to the output.
                        basic = input.lastIndexOf(delimiter);
                        if (basic < 0) basic = 0;
                        for(j = 0; j < basic; ++j){
                            // if it's not a basic code point
                            if (input.charCodeAt(j) >= 0x80) error('not-basic');
                            output.push(input.charCodeAt(j));
                        }
                        // Main decoding loop: start just after the last delimiter if any basic code
                        // points were copied; start at the beginning otherwise.
                        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
                            // `index` is the index of the next character to be consumed.
                            // Decode a generalized variable-length integer into `delta`,
                            // which gets added to `i`. The overflow checking is easier
                            // if we increase `i` as we go, then subtract off its starting
                            // value at the end to obtain `delta`.
                            for(oldi = i, w = 1, k = base;; k += base){
                                if (index >= inputLength) error('invalid-input');
                                digit = basicToDigit(input.charCodeAt(index++));
                                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                                i += digit * w;
                                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                if (digit < t) break;
                                baseMinusT = base - t;
                                if (w > floor(maxInt / baseMinusT)) error('overflow');
                                w *= baseMinusT;
                            }
                            out = output.length + 1;
                            bias = adapt(i - oldi, out, oldi == 0);
                            // `i` was supposed to wrap around from `out` to `0`,
                            // incrementing `n` each time, so we'll fix that now:
                            if (floor(i / out) > maxInt - n) error('overflow');
                            n += floor(i / out);
                            i %= out;
                            // Insert `n` at position `i` of the output
                            output.splice(i++, 0, n);
                        }
                        return ucs2encode(output);
                    }
                    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
                        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
                        // Convert the input in UCS-2 to Unicode
                        input = ucs2decode(input);
                        // Cache the length
                        inputLength = input.length;
                        // Initialize the state
                        n = initialN;
                        delta = 0;
                        bias = initialBias;
                        // Handle the basic code points
                        for(j = 0; j < inputLength; ++j){
                            currentValue = input[j];
                            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
                        }
                        handledCPCount = basicLength = output.length;
                        // `handledCPCount` is the number of code points that have been handled;
                        // `basicLength` is the number of basic code points.
                        // Finish the basic string - if it is not empty - with a delimiter
                        if (basicLength) output.push(delimiter);
                        // Main encoding loop:
                        while(handledCPCount < inputLength){
                            // All non-basic code points < n have been handled already. Find the next
                            // larger one:
                            for(m = maxInt, j = 0; j < inputLength; ++j){
                                currentValue = input[j];
                                if (currentValue >= n && currentValue < m) m = currentValue;
                            }
                            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
                            // but guard against overflow
                            handledCPCountPlusOne = handledCPCount + 1;
                            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
                            delta += (m - n) * handledCPCountPlusOne;
                            n = m;
                            for(j = 0; j < inputLength; ++j){
                                currentValue = input[j];
                                if (currentValue < n && ++delta > maxInt) error('overflow');
                                if (currentValue == n) {
                                    // Represent delta as a generalized variable-length integer
                                    for(q = delta, k = base;; k += base){
                                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                        if (q < t) break;
                                        qMinusT = q - t;
                                        baseMinusT = base - t;
                                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                                        q = floor(qMinusT / baseMinusT);
                                    }
                                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                                    delta = 0;
                                    ++handledCPCount;
                                }
                            }
                            ++delta;
                            ++n;
                        }
                        return output.join('');
                    }
                    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
                        return mapDomain(input, function(string) {
                            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
                        });
                    }
                    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
                        return mapDomain(input, function(string) {
                            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
                        });
                    }
                    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
                        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
                        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
                            'decode': ucs2decode,
                            'encode': ucs2encode
                        },
                        'decode': decode,
                        'encode': encode,
                        'toASCII': toASCII,
                        'toUnicode': toUnicode
                    };
                    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
                    // like the following:
                    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
                        return punycode;
                    });
                    else if (freeExports && freeModule) {
                        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
                        freeModule.exports = punycode;
                        else // in Narwhal or RingoJS v0.7.0-
                        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
                    } else // in Rhino or a web browser
                    root.punycode = punycode;
                })(this);
            }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        },
        {}
    ],
    206: [
        function(require1, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
            'use strict';
            // If obj.hasOwnProperty has been overridden, then calling
            // obj.hasOwnProperty(prop) will break.
            // See: https://github.com/joyent/node/issues/1707
            function hasOwnProperty(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            }
            module.exports = function(qs, sep, eq, options) {
                sep = sep || '&';
                eq = eq || '=';
                var obj = {};
                if (typeof qs !== 'string' || qs.length === 0) return obj;
                var regexp = /\+/g;
                qs = qs.split(sep);
                var maxKeys = 1000;
                if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
                var len = qs.length;
                // maxKeys <= 0 means that we should not limit keys count
                if (maxKeys > 0 && len > maxKeys) len = maxKeys;
                for(var i = 0; i < len; ++i){
                    var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
                    if (idx >= 0) {
                        kstr = x.substr(0, idx);
                        vstr = x.substr(idx + 1);
                    } else {
                        kstr = x;
                        vstr = '';
                    }
                    k = decodeURIComponent(kstr);
                    v = decodeURIComponent(vstr);
                    if (!hasOwnProperty(obj, k)) obj[k] = v;
                    else if (isArray(obj[k])) obj[k].push(v);
                    else obj[k] = [
                        obj[k],
                        v
                    ];
                }
                return obj;
            };
            var isArray = Array.isArray || function(xs) {
                return Object.prototype.toString.call(xs) === '[object Array]';
            };
        },
        {}
    ],
    207: [
        function(require1, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
            'use strict';
            var stringifyPrimitive = function(v) {
                switch(typeof v){
                    case 'string':
                        return v;
                    case 'boolean':
                        return v ? 'true' : 'false';
                    case 'number':
                        return isFinite(v) ? v : '';
                    default:
                        return '';
                }
            };
            module.exports = function(obj, sep, eq, name) {
                sep = sep || '&';
                eq = eq || '=';
                if (obj === null) obj = undefined;
                if (typeof obj === 'object') return map(objectKeys(obj), function(k) {
                    var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
                    if (isArray(obj[k])) return map(obj[k], function(v) {
                        return ks + encodeURIComponent(stringifyPrimitive(v));
                    }).join(sep);
                    else return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
                }).join(sep);
                if (!name) return '';
                return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
            };
            var isArray = Array.isArray || function(xs) {
                return Object.prototype.toString.call(xs) === '[object Array]';
            };
            function map(xs, f) {
                if (xs.map) return xs.map(f);
                var res = [];
                for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
                return res;
            }
            var objectKeys = Object.keys || function(obj) {
                var res = [];
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
                return res;
            };
        },
        {}
    ],
    208: [
        function(require1, module, exports) {
            'use strict';
            exports.decode = exports.parse = require1('./decode');
            exports.encode = exports.stringify = require1('./encode');
        },
        {
            "./decode": 206,
            "./encode": 207
        }
    ],
    209: [
        function(require1, module, exports) {
            module.exports = require1('./lib/_stream_duplex.js');
        },
        {
            "./lib/_stream_duplex.js": 210
        }
    ],
    210: [
        function(require1, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
            // a duplex stream is just a stream that is both readable and writable.
            // Since JS doesn't have multiple prototypal inheritance, this class
            // prototypally inherits from Readable, and then parasitically from
            // Writable.
            'use strict';
            /*<replacement>*/ var processNextTick = require1('process-nextick-args');
            /*</replacement>*/ /*<replacement>*/ var objectKeys = Object.keys || function(obj) {
                var keys = [];
                for(var key in obj)keys.push(key);
                return keys;
            };
            /*</replacement>*/ module.exports = Duplex;
            /*<replacement>*/ var util = require1('core-util-is');
            util.inherits = require1('inherits');
            /*</replacement>*/ var Readable = require1('./_stream_readable');
            var Writable = require1('./_stream_writable');
            util.inherits(Duplex, Readable);
            var keys = objectKeys(Writable.prototype);
            for(var v = 0; v < keys.length; v++){
                var method = keys[v];
                if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
            }
            function Duplex(options) {
                if (!(this instanceof Duplex)) return new Duplex(options);
                Readable.call(this, options);
                Writable.call(this, options);
                if (options && options.readable === false) this.readable = false;
                if (options && options.writable === false) this.writable = false;
                this.allowHalfOpen = true;
                if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
                this.once('end', onend);
            }
            // the no-half-open enforcer
            function onend() {
                // if we allow half-open state, or if the writable side ended,
                // then we're ok.
                if (this.allowHalfOpen || this._writableState.ended) return;
                // no more data can be written.
                // But allow more writes to happen in this tick.
                processNextTick(onEndNT, this);
            }
            function onEndNT(self1) {
                self1.end();
            }
            Object.defineProperty(Duplex.prototype, 'destroyed', {
                get: function() {
                    if (this._readableState === undefined || this._writableState === undefined) return false;
                    return this._readableState.destroyed && this._writableState.destroyed;
                },
                set: function(value) {
                    // we ignore the value if the stream
                    // has not been initialized yet
                    if (this._readableState === undefined || this._writableState === undefined) return;
                    // backward compatibility, the user is explicitly
                    // managing destroyed
                    this._readableState.destroyed = value;
                    this._writableState.destroyed = value;
                }
            });
            Duplex.prototype._destroy = function(err, cb) {
                this.push(null);
                this.end();
                processNextTick(cb, err);
            };
            function forEach(xs, f) {
                for(var i = 0, l = xs.length; i < l; i++)f(xs[i], i);
            }
        },
        {
            "./_stream_readable": 212,
            "./_stream_writable": 214,
            "core-util-is": 185,
            "inherits": 189,
            "process-nextick-args": 203
        }
    ],
    211: [
        function(require1, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
            // a passthrough stream.
            // basically just the most minimal sort of Transform stream.
            // Every written chunk gets output as-is.
            'use strict';
            module.exports = PassThrough;
            var Transform = require1('./_stream_transform');
            /*<replacement>*/ var util = require1('core-util-is');
            util.inherits = require1('inherits');
            /*</replacement>*/ util.inherits(PassThrough, Transform);
            function PassThrough(options) {
                if (!(this instanceof PassThrough)) return new PassThrough(options);
                Transform.call(this, options);
            }
            PassThrough.prototype._transform = function(chunk, encoding, cb) {
                cb(null, chunk);
            };
        },
        {
            "./_stream_transform": 213,
            "core-util-is": 185,
            "inherits": 189
        }
    ],
    212: [
        function(require1, module, exports) {
            (function(process, global1) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                'use strict';
                /*<replacement>*/ var processNextTick = require1('process-nextick-args');
                /*</replacement>*/ module.exports = Readable;
                /*<replacement>*/ var isArray = require1('isarray');
                /*</replacement>*/ /*<replacement>*/ var Duplex;
                /*</replacement>*/ Readable.ReadableState = ReadableState;
                /*<replacement>*/ var EE = require1('events').EventEmitter;
                var EElistenerCount = function(emitter, type) {
                    return emitter.listeners(type).length;
                };
                /*</replacement>*/ /*<replacement>*/ var Stream = require1('./internal/streams/stream');
                /*</replacement>*/ // TODO(bmeurer): Change this back to const once hole checks are
                // properly optimized away early in Ignition+TurboFan.
                /*<replacement>*/ var Buffer = require1('safe-buffer').Buffer;
                var OurUint8Array = global1.Uint8Array || function() {};
                function _uint8ArrayToBuffer(chunk) {
                    return Buffer.from(chunk);
                }
                function _isUint8Array(obj) {
                    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                }
                /*</replacement>*/ /*<replacement>*/ var util = require1('core-util-is');
                util.inherits = require1('inherits');
                /*</replacement>*/ /*<replacement>*/ var debugUtil = require1('util');
                var debug = void 0;
                if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog('stream');
                else debug = function() {};
                /*</replacement>*/ var BufferList = require1('./internal/streams/BufferList');
                var destroyImpl = require1('./internal/streams/destroy');
                var StringDecoder;
                util.inherits(Readable, Stream);
                var kProxyEvents = [
                    'error',
                    'close',
                    'destroy',
                    'pause',
                    'resume'
                ];
                function prependListener(emitter, event, fn) {
                    // Sadly this is not cacheable as some libraries bundle their own
                    // event emitter implementation with them.
                    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
                    else {
                        // This is a hack to make sure that our error handler is attached before any
                        // userland ones.  NEVER DO THIS. This is here only because this code needs
                        // to continue to work with older versions of Node.js that do not include
                        // the prependListener() method. The goal is to eventually remove this hack.
                        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
                        else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);
                        else emitter._events[event] = [
                            fn,
                            emitter._events[event]
                        ];
                    }
                }
                function ReadableState(options, stream) {
                    Duplex = Duplex || require1('./_stream_duplex');
                    options = options || {};
                    // object stream flag. Used to make read(n) ignore n and to
                    // make all the buffer merging and length checks go away
                    this.objectMode = !!options.objectMode;
                    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
                    // the point at which it stops calling _read() to fill the buffer
                    // Note: 0 is a valid value, means "don't call _read preemptively ever"
                    var hwm = options.highWaterMark;
                    var defaultHwm = this.objectMode ? 16 : 16384;
                    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
                    // cast to ints.
                    this.highWaterMark = Math.floor(this.highWaterMark);
                    // A linked list is used to store data chunks instead of an array because the
                    // linked list can remove elements from the beginning faster than
                    // array.shift()
                    this.buffer = new BufferList();
                    this.length = 0;
                    this.pipes = null;
                    this.pipesCount = 0;
                    this.flowing = null;
                    this.ended = false;
                    this.endEmitted = false;
                    this.reading = false;
                    // a flag to be able to tell if the event 'readable'/'data' is emitted
                    // immediately, or on a later tick.  We set this to true at first, because
                    // any actions that shouldn't happen until "later" should generally also
                    // not happen before the first read call.
                    this.sync = true;
                    // whenever we return null, then we set a flag to say
                    // that we're awaiting a 'readable' event emission.
                    this.needReadable = false;
                    this.emittedReadable = false;
                    this.readableListening = false;
                    this.resumeScheduled = false;
                    // has it been destroyed
                    this.destroyed = false;
                    // Crypto is kind of old and crusty.  Historically, its default string
                    // encoding is 'binary' so we have to make this configurable.
                    // Everything else in the universe uses 'utf8', though.
                    this.defaultEncoding = options.defaultEncoding || 'utf8';
                    // the number of writers that are awaiting a drain event in .pipe()s
                    this.awaitDrain = 0;
                    // if true, a maybeReadMore has been scheduled
                    this.readingMore = false;
                    this.decoder = null;
                    this.encoding = null;
                    if (options.encoding) {
                        if (!StringDecoder) StringDecoder = require1('string_decoder/').StringDecoder;
                        this.decoder = new StringDecoder(options.encoding);
                        this.encoding = options.encoding;
                    }
                }
                function Readable(options) {
                    Duplex = Duplex || require1('./_stream_duplex');
                    if (!(this instanceof Readable)) return new Readable(options);
                    this._readableState = new ReadableState(options, this);
                    // legacy
                    this.readable = true;
                    if (options) {
                        if (typeof options.read === 'function') this._read = options.read;
                        if (typeof options.destroy === 'function') this._destroy = options.destroy;
                    }
                    Stream.call(this);
                }
                Object.defineProperty(Readable.prototype, 'destroyed', {
                    get: function() {
                        if (this._readableState === undefined) return false;
                        return this._readableState.destroyed;
                    },
                    set: function(value) {
                        // we ignore the value if the stream
                        // has not been initialized yet
                        if (!this._readableState) return;
                        // backward compatibility, the user is explicitly
                        // managing destroyed
                        this._readableState.destroyed = value;
                    }
                });
                Readable.prototype.destroy = destroyImpl.destroy;
                Readable.prototype._undestroy = destroyImpl.undestroy;
                Readable.prototype._destroy = function(err, cb) {
                    this.push(null);
                    cb(err);
                };
                // Manually shove something into the read() buffer.
                // This returns true if the highWaterMark has not been hit yet,
                // similar to how Writable.write() returns true if you should
                // write() some more.
                Readable.prototype.push = function(chunk, encoding) {
                    var state = this._readableState;
                    var skipChunkCheck;
                    if (!state.objectMode) {
                        if (typeof chunk === 'string') {
                            encoding = encoding || state.defaultEncoding;
                            if (encoding !== state.encoding) {
                                chunk = Buffer.from(chunk, encoding);
                                encoding = '';
                            }
                            skipChunkCheck = true;
                        }
                    } else skipChunkCheck = true;
                    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
                };
                // Unshift should *always* be something directly out of read()
                Readable.prototype.unshift = function(chunk) {
                    return readableAddChunk(this, chunk, null, true, false);
                };
                function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
                    var state = stream._readableState;
                    if (chunk === null) {
                        state.reading = false;
                        onEofChunk(stream, state);
                    } else {
                        var er;
                        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
                        if (er) stream.emit('error', er);
                        else if (state.objectMode || chunk && chunk.length > 0) {
                            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
                            if (addToFront) {
                                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                                else addChunk(stream, state, chunk, true);
                            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
                            else {
                                state.reading = false;
                                if (state.decoder && !encoding) {
                                    chunk = state.decoder.write(chunk);
                                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                                    else maybeReadMore(stream, state);
                                } else addChunk(stream, state, chunk, false);
                            }
                        } else if (!addToFront) state.reading = false;
                    }
                    return needMoreData(state);
                }
                function addChunk(stream, state, chunk, addToFront) {
                    if (state.flowing && state.length === 0 && !state.sync) {
                        stream.emit('data', chunk);
                        stream.read(0);
                    } else {
                        // update the buffer info.
                        state.length += state.objectMode ? 1 : chunk.length;
                        if (addToFront) state.buffer.unshift(chunk);
                        else state.buffer.push(chunk);
                        if (state.needReadable) emitReadable(stream);
                    }
                    maybeReadMore(stream, state);
                }
                function chunkInvalid(state, chunk) {
                    var er;
                    if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
                    return er;
                }
                // if it's past the high water mark, we can push in some more.
                // Also, if we have no data yet, we can stand some
                // more bytes.  This is to work around cases where hwm=0,
                // such as the repl.  Also, if the push() triggered a
                // readable event, and the user called read(largeNumber) such that
                // needReadable was set, then we ought to push more, so that another
                // 'readable' event will be triggered.
                function needMoreData(state) {
                    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
                }
                Readable.prototype.isPaused = function() {
                    return this._readableState.flowing === false;
                };
                // backwards compatibility.
                Readable.prototype.setEncoding = function(enc) {
                    if (!StringDecoder) StringDecoder = require1('string_decoder/').StringDecoder;
                    this._readableState.decoder = new StringDecoder(enc);
                    this._readableState.encoding = enc;
                    return this;
                };
                // Don't raise the hwm > 8MB
                var MAX_HWM = 0x800000;
                function computeNewHighWaterMark(n) {
                    if (n >= MAX_HWM) n = MAX_HWM;
                    else {
                        // Get the next highest power of 2 to prevent increasing hwm excessively in
                        // tiny amounts
                        n--;
                        n |= n >>> 1;
                        n |= n >>> 2;
                        n |= n >>> 4;
                        n |= n >>> 8;
                        n |= n >>> 16;
                        n++;
                    }
                    return n;
                }
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function howMuchToRead(n, state) {
                    if (n <= 0 || state.length === 0 && state.ended) return 0;
                    if (state.objectMode) return 1;
                    if (n !== n) {
                        // Only flow one buffer at a time
                        if (state.flowing && state.length) return state.buffer.head.data.length;
                        else return state.length;
                    }
                    // If we're asking for more than the current hwm, then raise the hwm.
                    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
                    if (n <= state.length) return n;
                    // Don't have enough
                    if (!state.ended) {
                        state.needReadable = true;
                        return 0;
                    }
                    return state.length;
                }
                // you can override either this method, or the async _read(n) below.
                Readable.prototype.read = function(n) {
                    debug('read', n);
                    n = parseInt(n, 10);
                    var state = this._readableState;
                    var nOrig = n;
                    if (n !== 0) state.emittedReadable = false;
                    // if we're doing read(0) to trigger a readable event, but we
                    // already have a bunch of data in the buffer, then just trigger
                    // the 'readable' event and move on.
                    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
                        debug('read: emitReadable', state.length, state.ended);
                        if (state.length === 0 && state.ended) endReadable(this);
                        else emitReadable(this);
                        return null;
                    }
                    n = howMuchToRead(n, state);
                    // if we've ended, and we're now clear, then finish it up.
                    if (n === 0 && state.ended) {
                        if (state.length === 0) endReadable(this);
                        return null;
                    }
                    // All the actual chunk generation logic needs to be
                    // *below* the call to _read.  The reason is that in certain
                    // synthetic stream cases, such as passthrough streams, _read
                    // may be a completely synchronous operation which may change
                    // the state of the read buffer, providing enough data when
                    // before there was *not* enough.
                    //
                    // So, the steps are:
                    // 1. Figure out what the state of things will be after we do
                    // a read from the buffer.
                    //
                    // 2. If that resulting state will trigger a _read, then call _read.
                    // Note that this may be asynchronous, or synchronous.  Yes, it is
                    // deeply ugly to write APIs this way, but that still doesn't mean
                    // that the Readable class should behave improperly, as streams are
                    // designed to be sync/async agnostic.
                    // Take note if the _read call is sync or async (ie, if the read call
                    // has returned yet), so that we know whether or not it's safe to emit
                    // 'readable' etc.
                    //
                    // 3. Actually pull the requested chunks out of the buffer and return.
                    // if we need a readable event, then we need to do some reading.
                    var doRead = state.needReadable;
                    debug('need readable', doRead);
                    // if we currently have less than the highWaterMark, then also read some
                    if (state.length === 0 || state.length - n < state.highWaterMark) {
                        doRead = true;
                        debug('length less than watermark', doRead);
                    }
                    // however, if we've ended, then there's no point, and if we're already
                    // reading, then it's unnecessary.
                    if (state.ended || state.reading) {
                        doRead = false;
                        debug('reading or ended', doRead);
                    } else if (doRead) {
                        debug('do read');
                        state.reading = true;
                        state.sync = true;
                        // if the length is currently zero, then we *need* a readable event.
                        if (state.length === 0) state.needReadable = true;
                        // call internal read method
                        this._read(state.highWaterMark);
                        state.sync = false;
                        // If _read pushed data synchronously, then `reading` will be false,
                        // and we need to re-evaluate how much data we can return to the user.
                        if (!state.reading) n = howMuchToRead(nOrig, state);
                    }
                    var ret;
                    if (n > 0) ret = fromList(n, state);
                    else ret = null;
                    if (ret === null) {
                        state.needReadable = true;
                        n = 0;
                    } else state.length -= n;
                    if (state.length === 0) {
                        // If we have nothing in the buffer, then we want to know
                        // as soon as we *do* get something into the buffer.
                        if (!state.ended) state.needReadable = true;
                        // If we tried to read() past the EOF, then emit end on the next tick.
                        if (nOrig !== n && state.ended) endReadable(this);
                    }
                    if (ret !== null) this.emit('data', ret);
                    return ret;
                };
                function onEofChunk(stream, state) {
                    if (state.ended) return;
                    if (state.decoder) {
                        var chunk = state.decoder.end();
                        if (chunk && chunk.length) {
                            state.buffer.push(chunk);
                            state.length += state.objectMode ? 1 : chunk.length;
                        }
                    }
                    state.ended = true;
                    // emit 'readable' now to make sure it gets picked up.
                    emitReadable(stream);
                }
                // Don't emit readable right away in sync mode, because this can trigger
                // another read() call => stack overflow.  This way, it might trigger
                // a nextTick recursion warning, but that's not so bad.
                function emitReadable(stream) {
                    var state = stream._readableState;
                    state.needReadable = false;
                    if (!state.emittedReadable) {
                        debug('emitReadable', state.flowing);
                        state.emittedReadable = true;
                        if (state.sync) processNextTick(emitReadable_, stream);
                        else emitReadable_(stream);
                    }
                }
                function emitReadable_(stream) {
                    debug('emit readable');
                    stream.emit('readable');
                    flow(stream);
                }
                // at this point, the user has presumably seen the 'readable' event,
                // and called read() to consume some data.  that may have triggered
                // in turn another _read(n) call, in which case reading = true if
                // it's in progress.
                // However, if we're not ended, or reading, and the length < hwm,
                // then go ahead and try to read some more preemptively.
                function maybeReadMore(stream, state) {
                    if (!state.readingMore) {
                        state.readingMore = true;
                        processNextTick(maybeReadMore_, stream, state);
                    }
                }
                function maybeReadMore_(stream, state) {
                    var len = state.length;
                    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
                        debug('maybeReadMore read 0');
                        stream.read(0);
                        if (len === state.length) break;
                        else len = state.length;
                    }
                    state.readingMore = false;
                }
                // abstract method.  to be overridden in specific implementation classes.
                // call cb(er, data) where data is <= n in length.
                // for virtual (non-string, non-buffer) streams, "length" is somewhat
                // arbitrary, and perhaps not very meaningful.
                Readable.prototype._read = function(n) {
                    this.emit('error', new Error('_read() is not implemented'));
                };
                Readable.prototype.pipe = function(dest, pipeOpts) {
                    var src = this;
                    var state = this._readableState;
                    switch(state.pipesCount){
                        case 0:
                            state.pipes = dest;
                            break;
                        case 1:
                            state.pipes = [
                                state.pipes,
                                dest
                            ];
                            break;
                        default:
                            state.pipes.push(dest);
                            break;
                    }
                    state.pipesCount += 1;
                    debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
                    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
                    var endFn = doEnd ? onend : unpipe;
                    if (state.endEmitted) processNextTick(endFn);
                    else src.once('end', endFn);
                    dest.on('unpipe', onunpipe);
                    function onunpipe(readable, unpipeInfo) {
                        debug('onunpipe');
                        if (readable === src) {
                            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                                unpipeInfo.hasUnpiped = true;
                                cleanup();
                            }
                        }
                    }
                    function onend() {
                        debug('onend');
                        dest.end();
                    }
                    // when the dest drains, it reduces the awaitDrain counter
                    // on the source.  This would be more elegant with a .once()
                    // handler in flow(), but adding and removing repeatedly is
                    // too slow.
                    var ondrain = pipeOnDrain(src);
                    dest.on('drain', ondrain);
                    var cleanedUp = false;
                    function cleanup() {
                        debug('cleanup');
                        // cleanup event handlers once the pipe is broken
                        dest.removeListener('close', onclose);
                        dest.removeListener('finish', onfinish);
                        dest.removeListener('drain', ondrain);
                        dest.removeListener('error', onerror);
                        dest.removeListener('unpipe', onunpipe);
                        src.removeListener('end', onend);
                        src.removeListener('end', unpipe);
                        src.removeListener('data', ondata);
                        cleanedUp = true;
                        // if the reader is waiting for a drain event from this
                        // specific writer, then it would cause it to never start
                        // flowing again.
                        // So, if this is awaiting a drain, then we just call it now.
                        // If we don't know, then assume that we are waiting for one.
                        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
                    }
                    // If the user pushes more data while we're writing to dest then we'll end up
                    // in ondata again. However, we only want to increase awaitDrain once because
                    // dest will only emit one 'drain' event for the multiple writes.
                    // => Introduce a guard on increasing awaitDrain.
                    var increasedAwaitDrain = false;
                    src.on('data', ondata);
                    function ondata(chunk) {
                        debug('ondata');
                        increasedAwaitDrain = false;
                        var ret = dest.write(chunk);
                        if (false === ret && !increasedAwaitDrain) {
                            // If the user unpiped during `dest.write()`, it is possible
                            // to get stuck in a permanently paused state if that write
                            // also returned false.
                            // => Check whether `dest` is still a piping destination.
                            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                                debug('false write response, pause', src._readableState.awaitDrain);
                                src._readableState.awaitDrain++;
                                increasedAwaitDrain = true;
                            }
                            src.pause();
                        }
                    }
                    // if the dest has an error, then stop piping into it.
                    // however, don't suppress the throwing behavior for this.
                    function onerror(er) {
                        debug('onerror', er);
                        unpipe();
                        dest.removeListener('error', onerror);
                        if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
                    }
                    // Make sure our error handler is attached before userland ones.
                    prependListener(dest, 'error', onerror);
                    // Both close and finish should trigger unpipe, but only once.
                    function onclose() {
                        dest.removeListener('finish', onfinish);
                        unpipe();
                    }
                    dest.once('close', onclose);
                    function onfinish() {
                        debug('onfinish');
                        dest.removeListener('close', onclose);
                        unpipe();
                    }
                    dest.once('finish', onfinish);
                    function unpipe() {
                        debug('unpipe');
                        src.unpipe(dest);
                    }
                    // tell the dest that it's being piped to
                    dest.emit('pipe', src);
                    // start the flow if it hasn't been started already.
                    if (!state.flowing) {
                        debug('pipe resume');
                        src.resume();
                    }
                    return dest;
                };
                function pipeOnDrain(src) {
                    return function() {
                        var state = src._readableState;
                        debug('pipeOnDrain', state.awaitDrain);
                        if (state.awaitDrain) state.awaitDrain--;
                        if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
                            state.flowing = true;
                            flow(src);
                        }
                    };
                }
                Readable.prototype.unpipe = function(dest) {
                    var state = this._readableState;
                    var unpipeInfo = {
                        hasUnpiped: false
                    };
                    // if we're not piping anywhere, then do nothing.
                    if (state.pipesCount === 0) return this;
                    // just one destination.  most common case.
                    if (state.pipesCount === 1) {
                        // passed in one, but it's not the right one.
                        if (dest && dest !== state.pipes) return this;
                        if (!dest) dest = state.pipes;
                        // got a match.
                        state.pipes = null;
                        state.pipesCount = 0;
                        state.flowing = false;
                        if (dest) dest.emit('unpipe', this, unpipeInfo);
                        return this;
                    }
                    // slow case. multiple pipe destinations.
                    if (!dest) {
                        // remove all.
                        var dests = state.pipes;
                        var len = state.pipesCount;
                        state.pipes = null;
                        state.pipesCount = 0;
                        state.flowing = false;
                        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, unpipeInfo);
                        return this;
                    }
                    // try to find the right one.
                    var index = indexOf(state.pipes, dest);
                    if (index === -1) return this;
                    state.pipes.splice(index, 1);
                    state.pipesCount -= 1;
                    if (state.pipesCount === 1) state.pipes = state.pipes[0];
                    dest.emit('unpipe', this, unpipeInfo);
                    return this;
                };
                // set up data events if they are asked for
                // Ensure readable listeners eventually get something
                Readable.prototype.on = function(ev, fn) {
                    var res = Stream.prototype.on.call(this, ev, fn);
                    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
                    {
                        if (this._readableState.flowing !== false) this.resume();
                    } else if (ev === 'readable') {
                        var state = this._readableState;
                        if (!state.endEmitted && !state.readableListening) {
                            state.readableListening = state.needReadable = true;
                            state.emittedReadable = false;
                            if (!state.reading) processNextTick(nReadingNextTick, this);
                            else if (state.length) emitReadable(this);
                        }
                    }
                    return res;
                };
                Readable.prototype.addListener = Readable.prototype.on;
                function nReadingNextTick(self1) {
                    debug('readable nexttick read 0');
                    self1.read(0);
                }
                // pause() and resume() are remnants of the legacy readable stream API
                // If the user uses them, then switch into old mode.
                Readable.prototype.resume = function() {
                    var state = this._readableState;
                    if (!state.flowing) {
                        debug('resume');
                        state.flowing = true;
                        resume(this, state);
                    }
                    return this;
                };
                function resume(stream, state) {
                    if (!state.resumeScheduled) {
                        state.resumeScheduled = true;
                        processNextTick(resume_, stream, state);
                    }
                }
                function resume_(stream, state) {
                    if (!state.reading) {
                        debug('resume read 0');
                        stream.read(0);
                    }
                    state.resumeScheduled = false;
                    state.awaitDrain = 0;
                    stream.emit('resume');
                    flow(stream);
                    if (state.flowing && !state.reading) stream.read(0);
                }
                Readable.prototype.pause = function() {
                    debug('call pause flowing=%j', this._readableState.flowing);
                    if (false !== this._readableState.flowing) {
                        debug('pause');
                        this._readableState.flowing = false;
                        this.emit('pause');
                    }
                    return this;
                };
                function flow(stream) {
                    var state = stream._readableState;
                    debug('flow', state.flowing);
                    while(state.flowing && stream.read() !== null);
                }
                // wrap an old-style stream as the async data source.
                // This is *not* part of the readable stream interface.
                // It is an ugly unfortunate mess of history.
                Readable.prototype.wrap = function(stream) {
                    var state = this._readableState;
                    var paused = false;
                    var self1 = this;
                    stream.on('end', function() {
                        debug('wrapped end');
                        if (state.decoder && !state.ended) {
                            var chunk = state.decoder.end();
                            if (chunk && chunk.length) self1.push(chunk);
                        }
                        self1.push(null);
                    });
                    stream.on('data', function(chunk) {
                        debug('wrapped data');
                        if (state.decoder) chunk = state.decoder.write(chunk);
                        // don't skip over falsy values in objectMode
                        if (state.objectMode && (chunk === null || chunk === undefined)) return;
                        else if (!state.objectMode && (!chunk || !chunk.length)) return;
                        var ret = self1.push(chunk);
                        if (!ret) {
                            paused = true;
                            stream.pause();
                        }
                    });
                    // proxy all the other methods.
                    // important when wrapping filters and duplexes.
                    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
                        return function() {
                            return stream[method].apply(stream, arguments);
                        };
                    }(i);
                    // proxy certain important events.
                    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], self1.emit.bind(self1, kProxyEvents[n]));
                    // when we try to consume some more bytes, simply unpause the
                    // underlying stream.
                    self1._read = function(n) {
                        debug('wrapped _read', n);
                        if (paused) {
                            paused = false;
                            stream.resume();
                        }
                    };
                    return self1;
                };
                // exposed for testing purposes only.
                Readable._fromList = fromList;
                // Pluck off n bytes from an array of buffers.
                // Length is the combined lengths of all the buffers in the list.
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function fromList(n, state) {
                    // nothing buffered
                    if (state.length === 0) return null;
                    var ret;
                    if (state.objectMode) ret = state.buffer.shift();
                    else if (!n || n >= state.length) {
                        // read it all, truncate the list
                        if (state.decoder) ret = state.buffer.join('');
                        else if (state.buffer.length === 1) ret = state.buffer.head.data;
                        else ret = state.buffer.concat(state.length);
                        state.buffer.clear();
                    } else // read part of list
                    ret = fromListPartial(n, state.buffer, state.decoder);
                    return ret;
                }
                // Extracts only enough buffered data to satisfy the amount requested.
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function fromListPartial(n, list, hasStrings) {
                    var ret;
                    if (n < list.head.data.length) {
                        // slice is the same for buffers and strings
                        ret = list.head.data.slice(0, n);
                        list.head.data = list.head.data.slice(n);
                    } else if (n === list.head.data.length) // first chunk is a perfect match
                    ret = list.shift();
                    else // result spans more than one buffer
                    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
                    return ret;
                }
                // Copies a specified amount of characters from the list of buffered data
                // chunks.
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function copyFromBufferString(n, list) {
                    var p = list.head;
                    var c = 1;
                    var ret = p.data;
                    n -= ret.length;
                    while(p = p.next){
                        var str = p.data;
                        var nb = n > str.length ? str.length : n;
                        if (nb === str.length) ret += str;
                        else ret += str.slice(0, n);
                        n -= nb;
                        if (n === 0) {
                            if (nb === str.length) {
                                ++c;
                                if (p.next) list.head = p.next;
                                else list.head = list.tail = null;
                            } else {
                                list.head = p;
                                p.data = str.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    list.length -= c;
                    return ret;
                }
                // Copies a specified amount of bytes from the list of buffered data chunks.
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function copyFromBuffer(n, list) {
                    var ret = Buffer.allocUnsafe(n);
                    var p = list.head;
                    var c = 1;
                    p.data.copy(ret);
                    n -= p.data.length;
                    while(p = p.next){
                        var buf = p.data;
                        var nb = n > buf.length ? buf.length : n;
                        buf.copy(ret, ret.length - n, 0, nb);
                        n -= nb;
                        if (n === 0) {
                            if (nb === buf.length) {
                                ++c;
                                if (p.next) list.head = p.next;
                                else list.head = list.tail = null;
                            } else {
                                list.head = p;
                                p.data = buf.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    list.length -= c;
                    return ret;
                }
                function endReadable(stream) {
                    var state = stream._readableState;
                    // If we get here before consuming all the bytes, then that is a
                    // bug in node.  Should never happen.
                    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
                    if (!state.endEmitted) {
                        state.ended = true;
                        processNextTick(endReadableNT, state, stream);
                    }
                }
                function endReadableNT(state, stream) {
                    // Check that we didn't get one last unshift.
                    if (!state.endEmitted && state.length === 0) {
                        state.endEmitted = true;
                        stream.readable = false;
                        stream.emit('end');
                    }
                }
                function forEach(xs, f) {
                    for(var i = 0, l = xs.length; i < l; i++)f(xs[i], i);
                }
                function indexOf(xs, x) {
                    for(var i = 0, l = xs.length; i < l; i++){
                        if (xs[i] === x) return i;
                    }
                    return -1;
                }
            }).call(this, require1('_process'), typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        },
        {
            "./_stream_duplex": 210,
            "./internal/streams/BufferList": 215,
            "./internal/streams/destroy": 216,
            "./internal/streams/stream": 217,
            "_process": 204,
            "core-util-is": 185,
            "events": 186,
            "inherits": 189,
            "isarray": 191,
            "process-nextick-args": 203,
            "safe-buffer": 222,
            "string_decoder/": 228,
            "util": 179
        }
    ],
    213: [
        function(require1, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
            // a transform stream is a readable/writable stream where you do
            // something with the data.  Sometimes it's called a "filter",
            // but that's not a great name for it, since that implies a thing where
            // some bits pass through, and others are simply ignored.  (That would
            // be a valid example of a transform, of course.)
            //
            // While the output is causally related to the input, it's not a
            // necessarily symmetric or synchronous transformation.  For example,
            // a zlib stream might take multiple plain-text writes(), and then
            // emit a single compressed chunk some time in the future.
            //
            // Here's how this works:
            //
            // The Transform stream has all the aspects of the readable and writable
            // stream classes.  When you write(chunk), that calls _write(chunk,cb)
            // internally, and returns false if there's a lot of pending writes
            // buffered up.  When you call read(), that calls _read(n) until
            // there's enough pending readable data buffered up.
            //
            // In a transform stream, the written data is placed in a buffer.  When
            // _read(n) is called, it transforms the queued up data, calling the
            // buffered _write cb's as it consumes chunks.  If consuming a single
            // written chunk would result in multiple output chunks, then the first
            // outputted bit calls the readcb, and subsequent chunks just go into
            // the read buffer, and will cause it to emit 'readable' if necessary.
            //
            // This way, back-pressure is actually determined by the reading side,
            // since _read has to be called to start processing a new chunk.  However,
            // a pathological inflate type of transform can cause excessive buffering
            // here.  For example, imagine a stream where every byte of input is
            // interpreted as an integer from 0-255, and then results in that many
            // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
            // 1kb of data being output.  In this case, you could write a very small
            // amount of input, and end up with a very large amount of output.  In
            // such a pathological inflating mechanism, there'd be no way to tell
            // the system to stop doing the transform.  A single 4MB write could
            // cause the system to run out of memory.
            //
            // However, even in such a pathological case, only a single written chunk
            // would be consumed, and then the rest would wait (un-transformed) until
            // the results of the previous transformed chunk were consumed.
            'use strict';
            module.exports = Transform;
            var Duplex = require1('./_stream_duplex');
            /*<replacement>*/ var util = require1('core-util-is');
            util.inherits = require1('inherits');
            /*</replacement>*/ util.inherits(Transform, Duplex);
            function TransformState(stream) {
                this.afterTransform = function(er, data) {
                    return afterTransform(stream, er, data);
                };
                this.needTransform = false;
                this.transforming = false;
                this.writecb = null;
                this.writechunk = null;
                this.writeencoding = null;
            }
            function afterTransform(stream, er, data) {
                var ts = stream._transformState;
                ts.transforming = false;
                var cb = ts.writecb;
                if (!cb) return stream.emit('error', new Error('write callback called multiple times'));
                ts.writechunk = null;
                ts.writecb = null;
                if (data !== null && data !== undefined) stream.push(data);
                cb(er);
                var rs = stream._readableState;
                rs.reading = false;
                if (rs.needReadable || rs.length < rs.highWaterMark) stream._read(rs.highWaterMark);
            }
            function Transform(options) {
                if (!(this instanceof Transform)) return new Transform(options);
                Duplex.call(this, options);
                this._transformState = new TransformState(this);
                var stream = this;
                // start out asking for a readable event once data is transformed.
                this._readableState.needReadable = true;
                // we have implemented the _read method, and done the other things
                // that Readable wants before the first _read call, so unset the
                // sync guard flag.
                this._readableState.sync = false;
                if (options) {
                    if (typeof options.transform === 'function') this._transform = options.transform;
                    if (typeof options.flush === 'function') this._flush = options.flush;
                }
                // When the writable side finishes, then flush out anything remaining.
                this.once('prefinish', function() {
                    if (typeof this._flush === 'function') this._flush(function(er, data) {
                        done(stream, er, data);
                    });
                    else done(stream);
                });
            }
            Transform.prototype.push = function(chunk, encoding) {
                this._transformState.needTransform = false;
                return Duplex.prototype.push.call(this, chunk, encoding);
            };
            // This is the part where you do stuff!
            // override this function in implementation classes.
            // 'chunk' is an input chunk.
            //
            // Call `push(newChunk)` to pass along transformed output
            // to the readable side.  You may call 'push' zero or more times.
            //
            // Call `cb(err)` when you are done with this chunk.  If you pass
            // an error, then that'll put the hurt on the whole operation.  If you
            // never call cb(), then you'll never get another chunk.
            Transform.prototype._transform = function(chunk, encoding, cb) {
                throw new Error('_transform() is not implemented');
            };
            Transform.prototype._write = function(chunk, encoding, cb) {
                var ts = this._transformState;
                ts.writecb = cb;
                ts.writechunk = chunk;
                ts.writeencoding = encoding;
                if (!ts.transforming) {
                    var rs = this._readableState;
                    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
                }
            };
            // Doesn't matter what the args are here.
            // _transform does all the work.
            // That we got here means that the readable side wants more data.
            Transform.prototype._read = function(n) {
                var ts = this._transformState;
                if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
                    ts.transforming = true;
                    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
                } else // mark that we need a transform, so that any data that comes in
                // will get processed, now that we've asked for it.
                ts.needTransform = true;
            };
            Transform.prototype._destroy = function(err, cb) {
                var _this = this;
                Duplex.prototype._destroy.call(this, err, function(err2) {
                    cb(err2);
                    _this.emit('close');
                });
            };
            function done(stream, er, data) {
                if (er) return stream.emit('error', er);
                if (data !== null && data !== undefined) stream.push(data);
                // if there's nothing in the write buffer, then that means
                // that nothing more will ever be provided
                var ws = stream._writableState;
                var ts = stream._transformState;
                if (ws.length) throw new Error('Calling transform done when ws.length != 0');
                if (ts.transforming) throw new Error('Calling transform done when still transforming');
                return stream.push(null);
            }
        },
        {
            "./_stream_duplex": 210,
            "core-util-is": 185,
            "inherits": 189
        }
    ],
    214: [
        function(require1, module, exports) {
            (function(process, global1) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // A bit simpler than readable streams.
                // Implement an async ._write(chunk, encoding, cb), and it'll handle all
                // the drain event emission and buffering.
                'use strict';
                /*<replacement>*/ var processNextTick = require1('process-nextick-args');
                /*</replacement>*/ module.exports = Writable;
                /* <replacement> */ function WriteReq(chunk, encoding, cb) {
                    this.chunk = chunk;
                    this.encoding = encoding;
                    this.callback = cb;
                    this.next = null;
                }
                // It seems a linked list but it is not
                // there will be only 2 of these for each stream
                function CorkedRequest(state) {
                    var _this = this;
                    this.next = null;
                    this.entry = null;
                    this.finish = function() {
                        onCorkedFinish(_this, state);
                    };
                }
                /* </replacement> */ /*<replacement>*/ var asyncWrite = !process.browser && [
                    'v0.10',
                    'v0.9.'
                ].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
                /*</replacement>*/ /*<replacement>*/ var Duplex;
                /*</replacement>*/ Writable.WritableState = WritableState;
                /*<replacement>*/ var util = require1('core-util-is');
                util.inherits = require1('inherits');
                /*</replacement>*/ /*<replacement>*/ var internalUtil = {
                    deprecate: require1('util-deprecate')
                };
                /*</replacement>*/ /*<replacement>*/ var Stream = require1('./internal/streams/stream');
                /*</replacement>*/ /*<replacement>*/ var Buffer = require1('safe-buffer').Buffer;
                var OurUint8Array = global1.Uint8Array || function() {};
                function _uint8ArrayToBuffer(chunk) {
                    return Buffer.from(chunk);
                }
                function _isUint8Array(obj) {
                    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                }
                /*</replacement>*/ var destroyImpl = require1('./internal/streams/destroy');
                util.inherits(Writable, Stream);
                function nop() {}
                function WritableState(options, stream) {
                    Duplex = Duplex || require1('./_stream_duplex');
                    options = options || {};
                    // object stream flag to indicate whether or not this stream
                    // contains buffers or objects.
                    this.objectMode = !!options.objectMode;
                    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
                    // the point at which write() starts returning false
                    // Note: 0 is a valid value, means that we always return false if
                    // the entire buffer is not flushed immediately on write()
                    var hwm = options.highWaterMark;
                    var defaultHwm = this.objectMode ? 16 : 16384;
                    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
                    // cast to ints.
                    this.highWaterMark = Math.floor(this.highWaterMark);
                    // if _final has been called
                    this.finalCalled = false;
                    // drain event flag.
                    this.needDrain = false;
                    // at the start of calling end()
                    this.ending = false;
                    // when end() has been called, and returned
                    this.ended = false;
                    // when 'finish' is emitted
                    this.finished = false;
                    // has it been destroyed
                    this.destroyed = false;
                    // should we decode strings into buffers before passing to _write?
                    // this is here so that some node-core streams can optimize string
                    // handling at a lower level.
                    var noDecode = options.decodeStrings === false;
                    this.decodeStrings = !noDecode;
                    // Crypto is kind of old and crusty.  Historically, its default string
                    // encoding is 'binary' so we have to make this configurable.
                    // Everything else in the universe uses 'utf8', though.
                    this.defaultEncoding = options.defaultEncoding || 'utf8';
                    // not an actual buffer we keep track of, but a measurement
                    // of how much we're waiting to get pushed to some underlying
                    // socket or file.
                    this.length = 0;
                    // a flag to see when we're in the middle of a write.
                    this.writing = false;
                    // when true all writes will be buffered until .uncork() call
                    this.corked = 0;
                    // a flag to be able to tell if the onwrite cb is called immediately,
                    // or on a later tick.  We set this to true at first, because any
                    // actions that shouldn't happen until "later" should generally also
                    // not happen before the first write call.
                    this.sync = true;
                    // a flag to know if we're processing previously buffered items, which
                    // may call the _write() callback in the same tick, so that we don't
                    // end up in an overlapped onwrite situation.
                    this.bufferProcessing = false;
                    // the callback that's passed to _write(chunk,cb)
                    this.onwrite = function(er) {
                        onwrite(stream, er);
                    };
                    // the callback that the user supplies to write(chunk,encoding,cb)
                    this.writecb = null;
                    // the amount that is being written when _write is called.
                    this.writelen = 0;
                    this.bufferedRequest = null;
                    this.lastBufferedRequest = null;
                    // number of pending user-supplied write callbacks
                    // this must be 0 before 'finish' can be emitted
                    this.pendingcb = 0;
                    // emit prefinish if the only thing we're waiting for is _write cbs
                    // This is relevant for synchronous Transform streams
                    this.prefinished = false;
                    // True if the error was already emitted and should not be thrown again
                    this.errorEmitted = false;
                    // count buffered requests
                    this.bufferedRequestCount = 0;
                    // allocate the first CorkedRequest, there is always
                    // one allocated and free to use, and we maintain at most two
                    this.corkedRequestsFree = new CorkedRequest(this);
                }
                WritableState.prototype.getBuffer = function getBuffer() {
                    var current = this.bufferedRequest;
                    var out = [];
                    while(current){
                        out.push(current);
                        current = current.next;
                    }
                    return out;
                };
                (function() {
                    try {
                        Object.defineProperty(WritableState.prototype, 'buffer', {
                            get: internalUtil.deprecate(function() {
                                return this.getBuffer();
                            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
                        });
                    } catch (_) {}
                })();
                // Test _writableState for inheritance to account for Duplex streams,
                // whose prototype chain only points to Readable.
                var realHasInstance;
                if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
                    realHasInstance = Function.prototype[Symbol.hasInstance];
                    Object.defineProperty(Writable, Symbol.hasInstance, {
                        value: function(object) {
                            if (realHasInstance.call(this, object)) return true;
                            return object && object._writableState instanceof WritableState;
                        }
                    });
                } else realHasInstance = function(object) {
                    return object instanceof this;
                };
                function Writable(options) {
                    Duplex = Duplex || require1('./_stream_duplex');
                    // Writable ctor is applied to Duplexes, too.
                    // `realHasInstance` is necessary because using plain `instanceof`
                    // would return false, as no `_writableState` property is attached.
                    // Trying to use the custom `instanceof` for Writable here will also break the
                    // Node.js LazyTransform implementation, which has a non-trivial getter for
                    // `_writableState` that would lead to infinite recursion.
                    if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) return new Writable(options);
                    this._writableState = new WritableState(options, this);
                    // legacy.
                    this.writable = true;
                    if (options) {
                        if (typeof options.write === 'function') this._write = options.write;
                        if (typeof options.writev === 'function') this._writev = options.writev;
                        if (typeof options.destroy === 'function') this._destroy = options.destroy;
                        if (typeof options.final === 'function') this._final = options.final;
                    }
                    Stream.call(this);
                }
                // Otherwise people can pipe Writable streams, which is just wrong.
                Writable.prototype.pipe = function() {
                    this.emit('error', new Error('Cannot pipe, not readable'));
                };
                function writeAfterEnd(stream, cb) {
                    var er = new Error('write after end');
                    // TODO: defer error events consistently everywhere, not just the cb
                    stream.emit('error', er);
                    processNextTick(cb, er);
                }
                // Checks that a user-supplied chunk is valid, especially for the particular
                // mode the stream is in. Currently this means that `null` is never accepted
                // and undefined/non-string values are only allowed in object mode.
                function validChunk(stream, state, chunk, cb) {
                    var valid = true;
                    var er = false;
                    if (chunk === null) er = new TypeError('May not write null values to stream');
                    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
                    if (er) {
                        stream.emit('error', er);
                        processNextTick(cb, er);
                        valid = false;
                    }
                    return valid;
                }
                Writable.prototype.write = function(chunk, encoding, cb) {
                    var state = this._writableState;
                    var ret = false;
                    var isBuf = _isUint8Array(chunk) && !state.objectMode;
                    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
                    if (typeof encoding === 'function') {
                        cb = encoding;
                        encoding = null;
                    }
                    if (isBuf) encoding = 'buffer';
                    else if (!encoding) encoding = state.defaultEncoding;
                    if (typeof cb !== 'function') cb = nop;
                    if (state.ended) writeAfterEnd(this, cb);
                    else if (isBuf || validChunk(this, state, chunk, cb)) {
                        state.pendingcb++;
                        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
                    }
                    return ret;
                };
                Writable.prototype.cork = function() {
                    var state = this._writableState;
                    state.corked++;
                };
                Writable.prototype.uncork = function() {
                    var state = this._writableState;
                    if (state.corked) {
                        state.corked--;
                        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
                    }
                };
                Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
                    // node::ParseEncoding() requires lower case.
                    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
                    if (!([
                        'hex',
                        'utf8',
                        'utf-8',
                        'ascii',
                        'binary',
                        'base64',
                        'ucs2',
                        'ucs-2',
                        'utf16le',
                        'utf-16le',
                        'raw'
                    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
                    this._writableState.defaultEncoding = encoding;
                    return this;
                };
                function decodeChunk(state, chunk, encoding) {
                    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = Buffer.from(chunk, encoding);
                    return chunk;
                }
                // if we're already writing something, then just put this
                // in the queue, and wait our turn.  Otherwise, call _write
                // If we return false, then we need a drain event, so set that flag.
                function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
                    if (!isBuf) {
                        var newChunk = decodeChunk(state, chunk, encoding);
                        if (chunk !== newChunk) {
                            isBuf = true;
                            encoding = 'buffer';
                            chunk = newChunk;
                        }
                    }
                    var len = state.objectMode ? 1 : chunk.length;
                    state.length += len;
                    var ret = state.length < state.highWaterMark;
                    // we must ensure that previous needDrain will not be reset to false.
                    if (!ret) state.needDrain = true;
                    if (state.writing || state.corked) {
                        var last = state.lastBufferedRequest;
                        state.lastBufferedRequest = {
                            chunk: chunk,
                            encoding: encoding,
                            isBuf: isBuf,
                            callback: cb,
                            next: null
                        };
                        if (last) last.next = state.lastBufferedRequest;
                        else state.bufferedRequest = state.lastBufferedRequest;
                        state.bufferedRequestCount += 1;
                    } else doWrite(stream, state, false, len, chunk, encoding, cb);
                    return ret;
                }
                function doWrite(stream, state, writev, len, chunk, encoding, cb) {
                    state.writelen = len;
                    state.writecb = cb;
                    state.writing = true;
                    state.sync = true;
                    if (writev) stream._writev(chunk, state.onwrite);
                    else stream._write(chunk, encoding, state.onwrite);
                    state.sync = false;
                }
                function onwriteError(stream, state, sync, er, cb) {
                    --state.pendingcb;
                    if (sync) {
                        // defer the callback if we are being called synchronously
                        // to avoid piling up things on the stack
                        processNextTick(cb, er);
                        // this can emit finish, and it will always happen
                        // after error
                        processNextTick(finishMaybe, stream, state);
                        stream._writableState.errorEmitted = true;
                        stream.emit('error', er);
                    } else {
                        // the caller expect this to happen before if
                        // it is async
                        cb(er);
                        stream._writableState.errorEmitted = true;
                        stream.emit('error', er);
                        // this can emit finish, but finish must
                        // always follow error
                        finishMaybe(stream, state);
                    }
                }
                function onwriteStateUpdate(state) {
                    state.writing = false;
                    state.writecb = null;
                    state.length -= state.writelen;
                    state.writelen = 0;
                }
                function onwrite(stream, er) {
                    var state = stream._writableState;
                    var sync = state.sync;
                    var cb = state.writecb;
                    onwriteStateUpdate(state);
                    if (er) onwriteError(stream, state, sync, er, cb);
                    else {
                        // Check if we're actually ready to finish, but don't emit yet
                        var finished = needFinish(state);
                        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
                        if (sync) /*<replacement>*/ asyncWrite(afterWrite, stream, state, finished, cb);
                        else afterWrite(stream, state, finished, cb);
                    }
                }
                function afterWrite(stream, state, finished, cb) {
                    if (!finished) onwriteDrain(stream, state);
                    state.pendingcb--;
                    cb();
                    finishMaybe(stream, state);
                }
                // Must force callback to be called on nextTick, so that we don't
                // emit 'drain' before the write() consumer gets the 'false' return
                // value, and has a chance to attach a 'drain' listener.
                function onwriteDrain(stream, state) {
                    if (state.length === 0 && state.needDrain) {
                        state.needDrain = false;
                        stream.emit('drain');
                    }
                }
                // if there's something in the buffer waiting, then process it
                function clearBuffer(stream, state) {
                    state.bufferProcessing = true;
                    var entry = state.bufferedRequest;
                    if (stream._writev && entry && entry.next) {
                        // Fast case, write everything using _writev()
                        var l = state.bufferedRequestCount;
                        var buffer = new Array(l);
                        var holder = state.corkedRequestsFree;
                        holder.entry = entry;
                        var count = 0;
                        var allBuffers = true;
                        while(entry){
                            buffer[count] = entry;
                            if (!entry.isBuf) allBuffers = false;
                            entry = entry.next;
                            count += 1;
                        }
                        buffer.allBuffers = allBuffers;
                        doWrite(stream, state, true, state.length, buffer, '', holder.finish);
                        // doWrite is almost always async, defer these to save a bit of time
                        // as the hot path ends with doWrite
                        state.pendingcb++;
                        state.lastBufferedRequest = null;
                        if (holder.next) {
                            state.corkedRequestsFree = holder.next;
                            holder.next = null;
                        } else state.corkedRequestsFree = new CorkedRequest(state);
                    } else {
                        // Slow case, write chunks one-by-one
                        while(entry){
                            var chunk = entry.chunk;
                            var encoding = entry.encoding;
                            var cb = entry.callback;
                            var len = state.objectMode ? 1 : chunk.length;
                            doWrite(stream, state, false, len, chunk, encoding, cb);
                            entry = entry.next;
                            // if we didn't call the onwrite immediately, then
                            // it means that we need to wait until it does.
                            // also, that means that the chunk and cb are currently
                            // being processed, so move the buffer counter past them.
                            if (state.writing) break;
                        }
                        if (entry === null) state.lastBufferedRequest = null;
                    }
                    state.bufferedRequestCount = 0;
                    state.bufferedRequest = entry;
                    state.bufferProcessing = false;
                }
                Writable.prototype._write = function(chunk, encoding, cb) {
                    cb(new Error('_write() is not implemented'));
                };
                Writable.prototype._writev = null;
                Writable.prototype.end = function(chunk, encoding, cb) {
                    var state = this._writableState;
                    if (typeof chunk === 'function') {
                        cb = chunk;
                        chunk = null;
                        encoding = null;
                    } else if (typeof encoding === 'function') {
                        cb = encoding;
                        encoding = null;
                    }
                    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
                    // .end() fully uncorks
                    if (state.corked) {
                        state.corked = 1;
                        this.uncork();
                    }
                    // ignore unnecessary end() calls.
                    if (!state.ending && !state.finished) endWritable(this, state, cb);
                };
                function needFinish(state) {
                    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
                }
                function callFinal(stream, state) {
                    stream._final(function(err) {
                        state.pendingcb--;
                        if (err) stream.emit('error', err);
                        state.prefinished = true;
                        stream.emit('prefinish');
                        finishMaybe(stream, state);
                    });
                }
                function prefinish(stream, state) {
                    if (!state.prefinished && !state.finalCalled) {
                        if (typeof stream._final === 'function') {
                            state.pendingcb++;
                            state.finalCalled = true;
                            processNextTick(callFinal, stream, state);
                        } else {
                            state.prefinished = true;
                            stream.emit('prefinish');
                        }
                    }
                }
                function finishMaybe(stream, state) {
                    var need = needFinish(state);
                    if (need) {
                        prefinish(stream, state);
                        if (state.pendingcb === 0) {
                            state.finished = true;
                            stream.emit('finish');
                        }
                    }
                    return need;
                }
                function endWritable(stream, state, cb) {
                    state.ending = true;
                    finishMaybe(stream, state);
                    if (cb) {
                        if (state.finished) processNextTick(cb);
                        else stream.once('finish', cb);
                    }
                    state.ended = true;
                    stream.writable = false;
                }
                function onCorkedFinish(corkReq, state, err) {
                    var entry = corkReq.entry;
                    corkReq.entry = null;
                    while(entry){
                        var cb = entry.callback;
                        state.pendingcb--;
                        cb(err);
                        entry = entry.next;
                    }
                    if (state.corkedRequestsFree) state.corkedRequestsFree.next = corkReq;
                    else state.corkedRequestsFree = corkReq;
                }
                Object.defineProperty(Writable.prototype, 'destroyed', {
                    get: function() {
                        if (this._writableState === undefined) return false;
                        return this._writableState.destroyed;
                    },
                    set: function(value) {
                        // we ignore the value if the stream
                        // has not been initialized yet
                        if (!this._writableState) return;
                        // backward compatibility, the user is explicitly
                        // managing destroyed
                        this._writableState.destroyed = value;
                    }
                });
                Writable.prototype.destroy = destroyImpl.destroy;
                Writable.prototype._undestroy = destroyImpl.undestroy;
                Writable.prototype._destroy = function(err, cb) {
                    this.end();
                    cb(err);
                };
            }).call(this, require1('_process'), typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        },
        {
            "./_stream_duplex": 210,
            "./internal/streams/destroy": 216,
            "./internal/streams/stream": 217,
            "_process": 204,
            "core-util-is": 185,
            "inherits": 189,
            "process-nextick-args": 203,
            "safe-buffer": 222,
            "util-deprecate": 232
        }
    ],
    215: [
        function(require1, module, exports) {
            'use strict';
            /*<replacement>*/ function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Buffer = require1('safe-buffer').Buffer;
            /*</replacement>*/ function copyBuffer(src, target, offset) {
                src.copy(target, offset);
            }
            module.exports = function() {
                function BufferList() {
                    _classCallCheck(this, BufferList);
                    this.head = null;
                    this.tail = null;
                    this.length = 0;
                }
                BufferList.prototype.push = function push(v) {
                    var entry = {
                        data: v,
                        next: null
                    };
                    if (this.length > 0) this.tail.next = entry;
                    else this.head = entry;
                    this.tail = entry;
                    ++this.length;
                };
                BufferList.prototype.unshift = function unshift(v) {
                    var entry = {
                        data: v,
                        next: this.head
                    };
                    if (this.length === 0) this.tail = entry;
                    this.head = entry;
                    ++this.length;
                };
                BufferList.prototype.shift = function shift() {
                    if (this.length === 0) return;
                    var ret = this.head.data;
                    if (this.length === 1) this.head = this.tail = null;
                    else this.head = this.head.next;
                    --this.length;
                    return ret;
                };
                BufferList.prototype.clear = function clear() {
                    this.head = this.tail = null;
                    this.length = 0;
                };
                BufferList.prototype.join = function join(s) {
                    if (this.length === 0) return '';
                    var p = this.head;
                    var ret = '' + p.data;
                    while(p = p.next)ret += s + p.data;
                    return ret;
                };
                BufferList.prototype.concat = function concat(n) {
                    if (this.length === 0) return Buffer.alloc(0);
                    if (this.length === 1) return this.head.data;
                    var ret = Buffer.allocUnsafe(n >>> 0);
                    var p = this.head;
                    var i = 0;
                    while(p){
                        copyBuffer(p.data, ret, i);
                        i += p.data.length;
                        p = p.next;
                    }
                    return ret;
                };
                return BufferList;
            }();
        },
        {
            "safe-buffer": 222
        }
    ],
    216: [
        function(require1, module, exports) {
            'use strict';
            /*<replacement>*/ var processNextTick = require1('process-nextick-args');
            /*</replacement>*/ // undocumented cb() API, needed for core, not for public API
            function destroy(err, cb) {
                var _this = this;
                var readableDestroyed = this._readableState && this._readableState.destroyed;
                var writableDestroyed = this._writableState && this._writableState.destroyed;
                if (readableDestroyed || writableDestroyed) {
                    if (cb) cb(err);
                    else if (err && (!this._writableState || !this._writableState.errorEmitted)) processNextTick(emitErrorNT, this, err);
                    return;
                }
                // we set destroyed to true before firing error callbacks in order
                // to make it re-entrance safe in case destroy() is called within callbacks
                if (this._readableState) this._readableState.destroyed = true;
                // if this is a duplex stream mark the writable part as destroyed as well
                if (this._writableState) this._writableState.destroyed = true;
                this._destroy(err || null, function(err) {
                    if (!cb && err) {
                        processNextTick(emitErrorNT, _this, err);
                        if (_this._writableState) _this._writableState.errorEmitted = true;
                    } else if (cb) cb(err);
                });
            }
            function undestroy() {
                if (this._readableState) {
                    this._readableState.destroyed = false;
                    this._readableState.reading = false;
                    this._readableState.ended = false;
                    this._readableState.endEmitted = false;
                }
                if (this._writableState) {
                    this._writableState.destroyed = false;
                    this._writableState.ended = false;
                    this._writableState.ending = false;
                    this._writableState.finished = false;
                    this._writableState.errorEmitted = false;
                }
            }
            function emitErrorNT(self1, err) {
                self1.emit('error', err);
            }
            module.exports = {
                destroy: destroy,
                undestroy: undestroy
            };
        },
        {
            "process-nextick-args": 203
        }
    ],
    217: [
        function(require1, module, exports) {
            module.exports = require1('events').EventEmitter;
        },
        {
            "events": 186
        }
    ],
    218: [
        function(require1, module, exports) {
            module.exports = require1('./readable').PassThrough;
        },
        {
            "./readable": 219
        }
    ],
    219: [
        function(require1, module, exports) {
            exports = module.exports = require1('./lib/_stream_readable.js');
            exports.Stream = exports;
            exports.Readable = exports;
            exports.Writable = require1('./lib/_stream_writable.js');
            exports.Duplex = require1('./lib/_stream_duplex.js');
            exports.Transform = require1('./lib/_stream_transform.js');
            exports.PassThrough = require1('./lib/_stream_passthrough.js');
        },
        {
            "./lib/_stream_duplex.js": 210,
            "./lib/_stream_passthrough.js": 211,
            "./lib/_stream_readable.js": 212,
            "./lib/_stream_transform.js": 213,
            "./lib/_stream_writable.js": 214
        }
    ],
    220: [
        function(require1, module, exports) {
            module.exports = require1('./readable').Transform;
        },
        {
            "./readable": 219
        }
    ],
    221: [
        function(require1, module, exports) {
            module.exports = require1('./lib/_stream_writable.js');
        },
        {
            "./lib/_stream_writable.js": 214
        }
    ],
    222: [
        function(require1, module, exports) {
            /* eslint-disable node/no-deprecated-api */ var buffer = require1('buffer');
            var Buffer = buffer.Buffer;
            // alternative to using Object.keys for old browsers
            function copyProps(src, dst) {
                for(var key in src)dst[key] = src[key];
            }
            if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
            else {
                // Copy properties from require('buffer')
                copyProps(buffer, exports);
                exports.Buffer = SafeBuffer;
            }
            function SafeBuffer(arg, encodingOrOffset, length) {
                return Buffer(arg, encodingOrOffset, length);
            }
            // Copy static methods from Buffer
            copyProps(Buffer, SafeBuffer);
            SafeBuffer.from = function(arg, encodingOrOffset, length) {
                if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
                return Buffer(arg, encodingOrOffset, length);
            };
            SafeBuffer.alloc = function(size, fill, encoding) {
                if (typeof size !== 'number') throw new TypeError('Argument must be a number');
                var buf = Buffer(size);
                if (fill !== undefined) {
                    if (typeof encoding === 'string') buf.fill(fill, encoding);
                    else buf.fill(fill);
                } else buf.fill(0);
                return buf;
            };
            SafeBuffer.allocUnsafe = function(size) {
                if (typeof size !== 'number') throw new TypeError('Argument must be a number');
                return Buffer(size);
            };
            SafeBuffer.allocUnsafeSlow = function(size) {
                if (typeof size !== 'number') throw new TypeError('Argument must be a number');
                return buffer.SlowBuffer(size);
            };
        },
        {
            "buffer": 182
        }
    ],
    223: [
        function(require1, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
            module.exports = Stream;
            var EE = require1('events').EventEmitter;
            var inherits = require1('inherits');
            inherits(Stream, EE);
            Stream.Readable = require1('readable-stream/readable.js');
            Stream.Writable = require1('readable-stream/writable.js');
            Stream.Duplex = require1('readable-stream/duplex.js');
            Stream.Transform = require1('readable-stream/transform.js');
            Stream.PassThrough = require1('readable-stream/passthrough.js');
            // Backwards-compat with node 0.4.x
            Stream.Stream = Stream;
            // old-style streams.  Note that the pipe method (the only relevant
            // part of this class) is overridden in the Readable class.
            function Stream() {
                EE.call(this);
            }
            Stream.prototype.pipe = function(dest, options) {
                var source = this;
                function ondata(chunk) {
                    if (dest.writable) {
                        if (false === dest.write(chunk) && source.pause) source.pause();
                    }
                }
                source.on('data', ondata);
                function ondrain() {
                    if (source.readable && source.resume) source.resume();
                }
                dest.on('drain', ondrain);
                // If the 'end' option is not supplied, dest.end() will be called when
                // source gets the 'end' or 'close' events.  Only dest.end() once.
                if (!dest._isStdio && (!options || options.end !== false)) {
                    source.on('end', onend);
                    source.on('close', onclose);
                }
                var didOnEnd = false;
                function onend() {
                    if (didOnEnd) return;
                    didOnEnd = true;
                    dest.end();
                }
                function onclose() {
                    if (didOnEnd) return;
                    didOnEnd = true;
                    if (typeof dest.destroy === 'function') dest.destroy();
                }
                // don't leave dangling pipes when there are errors.
                function onerror(er) {
                    cleanup();
                    if (EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
                }
                source.on('error', onerror);
                dest.on('error', onerror);
                // remove all the event listeners that were added.
                function cleanup() {
                    source.removeListener('data', ondata);
                    dest.removeListener('drain', ondrain);
                    source.removeListener('end', onend);
                    source.removeListener('close', onclose);
                    source.removeListener('error', onerror);
                    dest.removeListener('error', onerror);
                    source.removeListener('end', cleanup);
                    source.removeListener('close', cleanup);
                    dest.removeListener('close', cleanup);
                }
                source.on('end', cleanup);
                source.on('close', cleanup);
                dest.on('close', cleanup);
                dest.emit('pipe', source);
                // Allow for unix-like usage: A.pipe(B).pipe(C)
                return dest;
            };
        },
        {
            "events": 186,
            "inherits": 189,
            "readable-stream/duplex.js": 209,
            "readable-stream/passthrough.js": 218,
            "readable-stream/readable.js": 219,
            "readable-stream/transform.js": 220,
            "readable-stream/writable.js": 221
        }
    ],
    224: [
        function(require1, module, exports) {
            (function(global1) {
                var ClientRequest = require1('./lib/request');
                var extend = require1('xtend');
                var statusCodes = require1('builtin-status-codes');
                var url = require1('url');
                var http = exports;
                http.request = function(opts, cb) {
                    if (typeof opts === 'string') opts = url.parse(opts);
                    else opts = extend(opts);
                    // Normally, the page is loaded from http or https, so not specifying a protocol
                    // will result in a (valid) protocol-relative url. However, this won't work if
                    // the protocol is something else, like 'file:'
                    var defaultProtocol = global1.location.protocol.search(/^https?:$/) === -1 ? 'http:' : '';
                    var protocol = opts.protocol || defaultProtocol;
                    var host = opts.hostname || opts.host;
                    var port = opts.port;
                    var path = opts.path || '/';
                    // Necessary for IPv6 addresses
                    if (host && host.indexOf(':') !== -1) host = '[' + host + ']';
                    // This may be a relative url. The browser should always be able to interpret it correctly.
                    opts.url = (host ? protocol + '//' + host : '') + (port ? ':' + port : '') + path;
                    opts.method = (opts.method || 'GET').toUpperCase();
                    opts.headers = opts.headers || {};
                    // Also valid opts.auth, opts.mode
                    var req = new ClientRequest(opts);
                    if (cb) req.on('response', cb);
                    return req;
                };
                http.get = function get(opts, cb) {
                    var req = http.request(opts, cb);
                    req.end();
                    return req;
                };
                http.Agent = function() {};
                http.Agent.defaultMaxSockets = 4;
                http.STATUS_CODES = statusCodes;
                http.METHODS = [
                    'CHECKOUT',
                    'CONNECT',
                    'COPY',
                    'DELETE',
                    'GET',
                    'HEAD',
                    'LOCK',
                    'M-SEARCH',
                    'MERGE',
                    'MKACTIVITY',
                    'MKCOL',
                    'MOVE',
                    'NOTIFY',
                    'OPTIONS',
                    'PATCH',
                    'POST',
                    'PROPFIND',
                    'PROPPATCH',
                    'PURGE',
                    'PUT',
                    'REPORT',
                    'SEARCH',
                    'SUBSCRIBE',
                    'TRACE',
                    'UNLOCK',
                    'UNSUBSCRIBE'
                ];
            }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        },
        {
            "./lib/request": 226,
            "builtin-status-codes": 183,
            "url": 230,
            "xtend": 236
        }
    ],
    225: [
        function(require1, module, exports) {
            (function(global1) {
                exports.fetch = isFunction(global1.fetch) && isFunction(global1.ReadableStream);
                exports.blobConstructor = false;
                try {
                    new Blob([
                        new ArrayBuffer(1)
                    ]);
                    exports.blobConstructor = true;
                } catch (e) {}
                // The xhr request to example.com may violate some restrictive CSP configurations,
                // so if we're running in a browser that supports `fetch`, avoid calling getXHR()
                // and assume support for certain features below.
                var xhr;
                function getXHR() {
                    // Cache the xhr value
                    if (xhr !== undefined) return xhr;
                    if (global1.XMLHttpRequest) {
                        xhr = new global1.XMLHttpRequest();
                        // If XDomainRequest is available (ie only, where xhr might not work
                        // cross domain), use the page location. Otherwise use example.com
                        // Note: this doesn't actually make an http request.
                        try {
                            xhr.open('GET', global1.XDomainRequest ? '/' : 'https://example.com');
                        } catch (e) {
                            xhr = null;
                        }
                    } else // Service workers don't have XHR
                    xhr = null;
                    return xhr;
                }
                function checkTypeSupport(type) {
                    var xhr = getXHR();
                    if (!xhr) return false;
                    try {
                        xhr.responseType = type;
                        return xhr.responseType === type;
                    } catch (e) {}
                    return false;
                }
                // For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
                // Safari 7.1 appears to have fixed this bug.
                var haveArrayBuffer = typeof global1.ArrayBuffer !== 'undefined';
                var haveSlice = haveArrayBuffer && isFunction(global1.ArrayBuffer.prototype.slice);
                // If fetch is supported, then arraybuffer will be supported too. Skip calling
                // checkTypeSupport(), since that calls getXHR().
                exports.arraybuffer = exports.fetch || haveArrayBuffer && checkTypeSupport('arraybuffer');
                // These next two tests unavoidably show warnings in Chrome. Since fetch will always
                // be used if it's available, just return false for these to avoid the warnings.
                exports.msstream = !exports.fetch && haveSlice && checkTypeSupport('ms-stream');
                exports.mozchunkedarraybuffer = !exports.fetch && haveArrayBuffer && checkTypeSupport('moz-chunked-arraybuffer');
                // If fetch is supported, then overrideMimeType will be supported too. Skip calling
                // getXHR().
                exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false);
                exports.vbArray = isFunction(global1.VBArray);
                function isFunction(value) {
                    return typeof value === 'function';
                }
                xhr = null // Help gc
                ;
            }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        },
        {}
    ],
    226: [
        function(require1, module, exports) {
            (function(process, global1, Buffer) {
                var capability = require1('./capability');
                var inherits = require1('inherits');
                var response = require1('./response');
                var stream = require1('readable-stream');
                var toArrayBuffer = require1('to-arraybuffer');
                var IncomingMessage = response.IncomingMessage;
                var rStates = response.readyStates;
                function decideMode(preferBinary, useFetch) {
                    if (capability.fetch && useFetch) return 'fetch';
                    else if (capability.mozchunkedarraybuffer) return 'moz-chunked-arraybuffer';
                    else if (capability.msstream) return 'ms-stream';
                    else if (capability.arraybuffer && preferBinary) return 'arraybuffer';
                    else if (capability.vbArray && preferBinary) return 'text:vbarray';
                    else return 'text';
                }
                var ClientRequest = module.exports = function(opts) {
                    var self1 = this;
                    stream.Writable.call(self1);
                    self1._opts = opts;
                    self1._body = [];
                    self1._headers = {};
                    if (opts.auth) self1.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'));
                    Object.keys(opts.headers).forEach(function(name) {
                        self1.setHeader(name, opts.headers[name]);
                    });
                    var preferBinary;
                    var useFetch = true;
                    if (opts.mode === 'disable-fetch' || 'timeout' in opts) {
                        // If the use of XHR should be preferred and includes preserving the 'content-type' header.
                        // Force XHR to be used since the Fetch API does not yet support timeouts.
                        useFetch = false;
                        preferBinary = true;
                    } else if (opts.mode === 'prefer-streaming') // If streaming is a high priority but binary compatibility and
                    // the accuracy of the 'content-type' header aren't
                    preferBinary = false;
                    else if (opts.mode === 'allow-wrong-content-type') // If streaming is more important than preserving the 'content-type' header
                    preferBinary = !capability.overrideMimeType;
                    else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') // Use binary if text streaming may corrupt data or the content-type header, or for speed
                    preferBinary = true;
                    else throw new Error('Invalid value for opts.mode');
                    self1._mode = decideMode(preferBinary, useFetch);
                    self1.on('finish', function() {
                        self1._onFinish();
                    });
                };
                inherits(ClientRequest, stream.Writable);
                ClientRequest.prototype.setHeader = function(name, value) {
                    var self1 = this;
                    var lowerName = name.toLowerCase();
                    // This check is not necessary, but it prevents warnings from browsers about setting unsafe
                    // headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
                    // http-browserify did it, so I will too.
                    if (unsafeHeaders.indexOf(lowerName) !== -1) return;
                    self1._headers[lowerName] = {
                        name: name,
                        value: value
                    };
                };
                ClientRequest.prototype.getHeader = function(name) {
                    var header = this._headers[name.toLowerCase()];
                    if (header) return header.value;
                    return null;
                };
                ClientRequest.prototype.removeHeader = function(name) {
                    var self1 = this;
                    delete self1._headers[name.toLowerCase()];
                };
                ClientRequest.prototype._onFinish = function() {
                    var self1 = this;
                    if (self1._destroyed) return;
                    var opts = self1._opts;
                    var headersObj = self1._headers;
                    var body = null;
                    if (opts.method !== 'GET' && opts.method !== 'HEAD') {
                        if (capability.blobConstructor) body = new global1.Blob(self1._body.map(function(buffer) {
                            return toArrayBuffer(buffer);
                        }), {
                            type: (headersObj['content-type'] || {}).value || ''
                        });
                        else // get utf8 string
                        body = Buffer.concat(self1._body).toString();
                    }
                    // create flattened list of headers
                    var headersList = [];
                    Object.keys(headersObj).forEach(function(keyName) {
                        var name = headersObj[keyName].name;
                        var value = headersObj[keyName].value;
                        if (Array.isArray(value)) value.forEach(function(v) {
                            headersList.push([
                                name,
                                v
                            ]);
                        });
                        else headersList.push([
                            name,
                            value
                        ]);
                    });
                    if (self1._mode === 'fetch') global1.fetch(self1._opts.url, {
                        method: self1._opts.method,
                        headers: headersList,
                        body: body || undefined,
                        mode: 'cors',
                        credentials: opts.withCredentials ? 'include' : 'same-origin'
                    }).then(function(response) {
                        self1._fetchResponse = response;
                        self1._connect();
                    }, function(reason) {
                        self1.emit('error', reason);
                    });
                    else {
                        var xhr = self1._xhr = new global1.XMLHttpRequest();
                        try {
                            xhr.open(self1._opts.method, self1._opts.url, true);
                        } catch (err) {
                            process.nextTick(function() {
                                self1.emit('error', err);
                            });
                            return;
                        }
                        // Can't set responseType on really old browsers
                        if ('responseType' in xhr) xhr.responseType = self1._mode.split(':')[0];
                        if ('withCredentials' in xhr) xhr.withCredentials = !!opts.withCredentials;
                        if (self1._mode === 'text' && 'overrideMimeType' in xhr) xhr.overrideMimeType('text/plain; charset=x-user-defined');
                        if ('timeout' in opts) {
                            xhr.timeout = opts.timeout;
                            xhr.ontimeout = function() {
                                self1.emit('timeout');
                            };
                        }
                        headersList.forEach(function(header) {
                            xhr.setRequestHeader(header[0], header[1]);
                        });
                        self1._response = null;
                        xhr.onreadystatechange = function() {
                            switch(xhr.readyState){
                                case rStates.LOADING:
                                case rStates.DONE:
                                    self1._onXHRProgress();
                                    break;
                            }
                        };
                        // Necessary for streaming in Firefox, since xhr.response is ONLY defined
                        // in onprogress, not in onreadystatechange with xhr.readyState = 3
                        if (self1._mode === 'moz-chunked-arraybuffer') xhr.onprogress = function() {
                            self1._onXHRProgress();
                        };
                        xhr.onerror = function() {
                            if (self1._destroyed) return;
                            self1.emit('error', new Error('XHR error'));
                        };
                        try {
                            xhr.send(body);
                        } catch (err) {
                            process.nextTick(function() {
                                self1.emit('error', err);
                            });
                            return;
                        }
                    }
                };
                /**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */ function statusValid(xhr) {
                    try {
                        var status = xhr.status;
                        return status !== null && status !== 0;
                    } catch (e) {
                        return false;
                    }
                }
                ClientRequest.prototype._onXHRProgress = function() {
                    var self1 = this;
                    if (!statusValid(self1._xhr) || self1._destroyed) return;
                    if (!self1._response) self1._connect();
                    self1._response._onXHRProgress();
                };
                ClientRequest.prototype._connect = function() {
                    var self1 = this;
                    if (self1._destroyed) return;
                    self1._response = new IncomingMessage(self1._xhr, self1._fetchResponse, self1._mode);
                    self1._response.on('error', function(err) {
                        self1.emit('error', err);
                    });
                    self1.emit('response', self1._response);
                };
                ClientRequest.prototype._write = function(chunk, encoding, cb) {
                    var self1 = this;
                    self1._body.push(chunk);
                    cb();
                };
                ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function() {
                    var self1 = this;
                    self1._destroyed = true;
                    if (self1._response) self1._response._destroyed = true;
                    if (self1._xhr) self1._xhr.abort();
                // Currently, there isn't a way to truly abort a fetch.
                // If you like bikeshedding, see https://github.com/whatwg/fetch/issues/27
                };
                ClientRequest.prototype.end = function(data, encoding, cb) {
                    var self1 = this;
                    if (typeof data === 'function') {
                        cb = data;
                        data = undefined;
                    }
                    stream.Writable.prototype.end.call(self1, data, encoding, cb);
                };
                ClientRequest.prototype.flushHeaders = function() {};
                ClientRequest.prototype.setTimeout = function() {};
                ClientRequest.prototype.setNoDelay = function() {};
                ClientRequest.prototype.setSocketKeepAlive = function() {};
                // Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
                var unsafeHeaders = [
                    'accept-charset',
                    'accept-encoding',
                    'access-control-request-headers',
                    'access-control-request-method',
                    'connection',
                    'content-length',
                    'cookie',
                    'cookie2',
                    'date',
                    'dnt',
                    'expect',
                    'host',
                    'keep-alive',
                    'origin',
                    'referer',
                    'te',
                    'trailer',
                    'transfer-encoding',
                    'upgrade',
                    'user-agent',
                    'via'
                ];
            }).call(this, require1('_process'), typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {}, require1("buffer").Buffer);
        },
        {
            "./capability": 225,
            "./response": 227,
            "_process": 204,
            "buffer": 182,
            "inherits": 189,
            "readable-stream": 219,
            "to-arraybuffer": 229
        }
    ],
    227: [
        function(require1, module, exports) {
            (function(process, global1, Buffer) {
                var capability = require1('./capability');
                var inherits = require1('inherits');
                var stream = require1('readable-stream');
                var rStates = exports.readyStates = {
                    UNSENT: 0,
                    OPENED: 1,
                    HEADERS_RECEIVED: 2,
                    LOADING: 3,
                    DONE: 4
                };
                var IncomingMessage = exports.IncomingMessage = function(xhr, response, mode) {
                    var self1 = this;
                    stream.Readable.call(self1);
                    self1._mode = mode;
                    self1.headers = {};
                    self1.rawHeaders = [];
                    self1.trailers = {};
                    self1.rawTrailers = [];
                    // Fake the 'close' event, but only once 'end' fires
                    self1.on('end', function() {
                        // The nextTick is necessary to prevent the 'request' module from causing an infinite loop
                        process.nextTick(function() {
                            self1.emit('close');
                        });
                    });
                    if (mode === 'fetch') {
                        self1._fetchResponse = response;
                        self1.url = response.url;
                        self1.statusCode = response.status;
                        self1.statusMessage = response.statusText;
                        response.headers.forEach(function(header, key) {
                            self1.headers[key.toLowerCase()] = header;
                            self1.rawHeaders.push(key, header);
                        });
                        // TODO: this doesn't respect backpressure. Once WritableStream is available, this can be fixed
                        var reader = response.body.getReader();
                        function read() {
                            reader.read().then(function(result) {
                                if (self1._destroyed) return;
                                if (result.done) {
                                    self1.push(null);
                                    return;
                                }
                                self1.push(new Buffer(result.value));
                                read();
                            }).catch(function(err) {
                                self1.emit('error', err);
                            });
                        }
                        read();
                    } else {
                        self1._xhr = xhr;
                        self1._pos = 0;
                        self1.url = xhr.responseURL;
                        self1.statusCode = xhr.status;
                        self1.statusMessage = xhr.statusText;
                        var headers = xhr.getAllResponseHeaders().split(/\r?\n/);
                        headers.forEach(function(header) {
                            var matches = header.match(/^([^:]+):\s*(.*)/);
                            if (matches) {
                                var key = matches[1].toLowerCase();
                                if (key === 'set-cookie') {
                                    if (self1.headers[key] === undefined) self1.headers[key] = [];
                                    self1.headers[key].push(matches[2]);
                                } else if (self1.headers[key] !== undefined) self1.headers[key] += ', ' + matches[2];
                                else self1.headers[key] = matches[2];
                                self1.rawHeaders.push(matches[1], matches[2]);
                            }
                        });
                        self1._charset = 'x-user-defined';
                        if (!capability.overrideMimeType) {
                            var mimeType = self1.rawHeaders['mime-type'];
                            if (mimeType) {
                                var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/);
                                if (charsetMatch) self1._charset = charsetMatch[1].toLowerCase();
                            }
                            if (!self1._charset) self1._charset = 'utf-8' // best guess
                            ;
                        }
                    }
                };
                inherits(IncomingMessage, stream.Readable);
                IncomingMessage.prototype._read = function() {};
                IncomingMessage.prototype._onXHRProgress = function() {
                    var self1 = this;
                    var xhr = self1._xhr;
                    var response = null;
                    switch(self1._mode){
                        case 'text:vbarray':
                            if (xhr.readyState !== rStates.DONE) break;
                            try {
                                // This fails in IE8
                                response = new global1.VBArray(xhr.responseBody).toArray();
                            } catch (e) {}
                            if (response !== null) {
                                self1.push(new Buffer(response));
                                break;
                            }
                        // Falls through in IE8	
                        case 'text':
                            try {
                                response = xhr.responseText;
                            } catch (e) {
                                self1._mode = 'text:vbarray';
                                break;
                            }
                            if (response.length > self1._pos) {
                                var newData = response.substr(self1._pos);
                                if (self1._charset === 'x-user-defined') {
                                    var buffer = new Buffer(newData.length);
                                    for(var i = 0; i < newData.length; i++)buffer[i] = newData.charCodeAt(i) & 0xff;
                                    self1.push(buffer);
                                } else self1.push(newData, self1._charset);
                                self1._pos = response.length;
                            }
                            break;
                        case 'arraybuffer':
                            if (xhr.readyState !== rStates.DONE || !xhr.response) break;
                            response = xhr.response;
                            self1.push(new Buffer(new Uint8Array(response)));
                            break;
                        case 'moz-chunked-arraybuffer':
                            response = xhr.response;
                            if (xhr.readyState !== rStates.LOADING || !response) break;
                            self1.push(new Buffer(new Uint8Array(response)));
                            break;
                        case 'ms-stream':
                            response = xhr.response;
                            if (xhr.readyState !== rStates.LOADING) break;
                            var reader = new global1.MSStreamReader();
                            reader.onprogress = function() {
                                if (reader.result.byteLength > self1._pos) {
                                    self1.push(new Buffer(new Uint8Array(reader.result.slice(self1._pos))));
                                    self1._pos = reader.result.byteLength;
                                }
                            };
                            reader.onload = function() {
                                self1.push(null);
                            };
                            // reader.onerror = ??? // TODO: this
                            reader.readAsArrayBuffer(response);
                            break;
                    }
                    // The ms-stream case handles end separately in reader.onload()
                    if (self1._xhr.readyState === rStates.DONE && self1._mode !== 'ms-stream') self1.push(null);
                };
            }).call(this, require1('_process'), typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {}, require1("buffer").Buffer);
        },
        {
            "./capability": 225,
            "_process": 204,
            "buffer": 182,
            "inherits": 189,
            "readable-stream": 219
        }
    ],
    228: [
        function(require1, module, exports) {
            'use strict';
            var Buffer = require1('safe-buffer').Buffer;
            var isEncoding = Buffer.isEncoding || function(encoding) {
                encoding = '' + encoding;
                switch(encoding && encoding.toLowerCase()){
                    case 'hex':
                    case 'utf8':
                    case 'utf-8':
                    case 'ascii':
                    case 'binary':
                    case 'base64':
                    case 'ucs2':
                    case 'ucs-2':
                    case 'utf16le':
                    case 'utf-16le':
                    case 'raw':
                        return true;
                    default:
                        return false;
                }
            };
            function _normalizeEncoding(enc) {
                if (!enc) return 'utf8';
                var retried;
                while(true)switch(enc){
                    case 'utf8':
                    case 'utf-8':
                        return 'utf8';
                    case 'ucs2':
                    case 'ucs-2':
                    case 'utf16le':
                    case 'utf-16le':
                        return 'utf16le';
                    case 'latin1':
                    case 'binary':
                        return 'latin1';
                    case 'base64':
                    case 'ascii':
                    case 'hex':
                        return enc;
                    default:
                        if (retried) return; // undefined
                        enc = ('' + enc).toLowerCase();
                        retried = true;
                }
            }
            // Do not cache `Buffer.isEncoding` when checking encoding names as some
            // modules monkey-patch it to support additional encodings
            function normalizeEncoding(enc) {
                var nenc = _normalizeEncoding(enc);
                if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
                return nenc || enc;
            }
            // StringDecoder provides an interface for efficiently splitting a series of
            // buffers into a series of JS strings without breaking apart multi-byte
            // characters.
            exports.StringDecoder = StringDecoder;
            function StringDecoder(encoding) {
                this.encoding = normalizeEncoding(encoding);
                var nb;
                switch(this.encoding){
                    case 'utf16le':
                        this.text = utf16Text;
                        this.end = utf16End;
                        nb = 4;
                        break;
                    case 'utf8':
                        this.fillLast = utf8FillLast;
                        nb = 4;
                        break;
                    case 'base64':
                        this.text = base64Text;
                        this.end = base64End;
                        nb = 3;
                        break;
                    default:
                        this.write = simpleWrite;
                        this.end = simpleEnd;
                        return;
                }
                this.lastNeed = 0;
                this.lastTotal = 0;
                this.lastChar = Buffer.allocUnsafe(nb);
            }
            StringDecoder.prototype.write = function(buf) {
                if (buf.length === 0) return '';
                var r;
                var i;
                if (this.lastNeed) {
                    r = this.fillLast(buf);
                    if (r === undefined) return '';
                    i = this.lastNeed;
                    this.lastNeed = 0;
                } else i = 0;
                if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
                return r || '';
            };
            StringDecoder.prototype.end = utf8End;
            // Returns only complete characters in a Buffer
            StringDecoder.prototype.text = utf8Text;
            // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
            StringDecoder.prototype.fillLast = function(buf) {
                if (this.lastNeed <= buf.length) {
                    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
                    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                }
                buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
                this.lastNeed -= buf.length;
            };
            // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
            // continuation byte.
            function utf8CheckByte(byte) {
                if (byte <= 0x7F) return 0;
                else if (byte >> 5 === 0x06) return 2;
                else if (byte >> 4 === 0x0E) return 3;
                else if (byte >> 3 === 0x1E) return 4;
                return -1;
            }
            // Checks at most 3 bytes at the end of a Buffer in order to detect an
            // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
            // needed to complete the UTF-8 character (if applicable) are returned.
            function utf8CheckIncomplete(self1, buf, i) {
                var j = buf.length - 1;
                if (j < i) return 0;
                var nb = utf8CheckByte(buf[j]);
                if (nb >= 0) {
                    if (nb > 0) self1.lastNeed = nb - 1;
                    return nb;
                }
                if (--j < i) return 0;
                nb = utf8CheckByte(buf[j]);
                if (nb >= 0) {
                    if (nb > 0) self1.lastNeed = nb - 2;
                    return nb;
                }
                if (--j < i) return 0;
                nb = utf8CheckByte(buf[j]);
                if (nb >= 0) {
                    if (nb > 0) {
                        if (nb === 2) nb = 0;
                        else self1.lastNeed = nb - 3;
                    }
                    return nb;
                }
                return 0;
            }
            // Validates as many continuation bytes for a multi-byte UTF-8 character as
            // needed or are available. If we see a non-continuation byte where we expect
            // one, we "replace" the validated continuation bytes we've seen so far with
            // UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
            // behavior. The continuation byte check is included three times in the case
            // where all of the continuation bytes for a character exist in the same buffer.
            // It is also done this way as a slight performance increase instead of using a
            // loop.
            function utf8CheckExtraBytes(self1, buf, p) {
                if ((buf[0] & 0xC0) !== 0x80) {
                    self1.lastNeed = 0;
                    return '\ufffd'.repeat(p);
                }
                if (self1.lastNeed > 1 && buf.length > 1) {
                    if ((buf[1] & 0xC0) !== 0x80) {
                        self1.lastNeed = 1;
                        return '\ufffd'.repeat(p + 1);
                    }
                    if (self1.lastNeed > 2 && buf.length > 2) {
                        if ((buf[2] & 0xC0) !== 0x80) {
                            self1.lastNeed = 2;
                            return '\ufffd'.repeat(p + 2);
                        }
                    }
                }
            }
            // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
            function utf8FillLast(buf) {
                var p = this.lastTotal - this.lastNeed;
                var r = utf8CheckExtraBytes(this, buf, p);
                if (r !== undefined) return r;
                if (this.lastNeed <= buf.length) {
                    buf.copy(this.lastChar, p, 0, this.lastNeed);
                    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                }
                buf.copy(this.lastChar, p, 0, buf.length);
                this.lastNeed -= buf.length;
            }
            // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
            // partial character, the character's bytes are buffered until the required
            // number of bytes are available.
            function utf8Text(buf, i) {
                var total = utf8CheckIncomplete(this, buf, i);
                if (!this.lastNeed) return buf.toString('utf8', i);
                this.lastTotal = total;
                var end = buf.length - (total - this.lastNeed);
                buf.copy(this.lastChar, 0, end);
                return buf.toString('utf8', i, end);
            }
            // For UTF-8, a replacement character for each buffered byte of a (partial)
            // character needs to be added to the output.
            function utf8End(buf) {
                var r = buf && buf.length ? this.write(buf) : '';
                if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
                return r;
            }
            // UTF-16LE typically needs two bytes per character, but even if we have an even
            // number of bytes available, we need to check if we end on a leading/high
            // surrogate. In that case, we need to wait for the next two bytes in order to
            // decode the last character properly.
            function utf16Text(buf, i) {
                if ((buf.length - i) % 2 === 0) {
                    var r = buf.toString('utf16le', i);
                    if (r) {
                        var c = r.charCodeAt(r.length - 1);
                        if (c >= 0xD800 && c <= 0xDBFF) {
                            this.lastNeed = 2;
                            this.lastTotal = 4;
                            this.lastChar[0] = buf[buf.length - 2];
                            this.lastChar[1] = buf[buf.length - 1];
                            return r.slice(0, -1);
                        }
                    }
                    return r;
                }
                this.lastNeed = 1;
                this.lastTotal = 2;
                this.lastChar[0] = buf[buf.length - 1];
                return buf.toString('utf16le', i, buf.length - 1);
            }
            // For UTF-16LE we do not explicitly append special replacement characters if we
            // end on a partial character, we simply let v8 handle that.
            function utf16End(buf) {
                var r = buf && buf.length ? this.write(buf) : '';
                if (this.lastNeed) {
                    var end = this.lastTotal - this.lastNeed;
                    return r + this.lastChar.toString('utf16le', 0, end);
                }
                return r;
            }
            function base64Text(buf, i) {
                var n = (buf.length - i) % 3;
                if (n === 0) return buf.toString('base64', i);
                this.lastNeed = 3 - n;
                this.lastTotal = 3;
                if (n === 1) this.lastChar[0] = buf[buf.length - 1];
                else {
                    this.lastChar[0] = buf[buf.length - 2];
                    this.lastChar[1] = buf[buf.length - 1];
                }
                return buf.toString('base64', i, buf.length - n);
            }
            function base64End(buf) {
                var r = buf && buf.length ? this.write(buf) : '';
                if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
                return r;
            }
            // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
            function simpleWrite(buf) {
                return buf.toString(this.encoding);
            }
            function simpleEnd(buf) {
                return buf && buf.length ? this.write(buf) : '';
            }
        },
        {
            "safe-buffer": 222
        }
    ],
    229: [
        function(require1, module, exports) {
            var Buffer = require1('buffer').Buffer;
            module.exports = function(buf) {
                // If the buffer is backed by a Uint8Array, a faster version will work
                if (buf instanceof Uint8Array) {
                    // If the buffer isn't a subarray, return the underlying ArrayBuffer
                    if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) return buf.buffer;
                    else if (typeof buf.buffer.slice === 'function') // Otherwise we need to get a proper copy
                    return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
                }
                if (Buffer.isBuffer(buf)) {
                    // This is the slow version that will work with any Buffer
                    // implementation (even in old browsers)
                    var arrayCopy = new Uint8Array(buf.length);
                    var len = buf.length;
                    for(var i = 0; i < len; i++)arrayCopy[i] = buf[i];
                    return arrayCopy.buffer;
                } else throw new Error('Argument must be a Buffer');
            };
        },
        {
            "buffer": 182
        }
    ],
    230: [
        function(require1, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
            'use strict';
            var punycode = require1('punycode');
            var util = require1('./util');
            exports.parse = urlParse;
            exports.resolve = urlResolve;
            exports.resolveObject = urlResolveObject;
            exports.format = urlFormat;
            exports.Url = Url;
            function Url() {
                this.protocol = null;
                this.slashes = null;
                this.auth = null;
                this.host = null;
                this.port = null;
                this.hostname = null;
                this.hash = null;
                this.search = null;
                this.query = null;
                this.pathname = null;
                this.path = null;
                this.href = null;
            }
            // Reference: RFC 3986, RFC 1808, RFC 2396
            // define these here so at least they only have to be
            // compiled once on the first module load.
            var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
            simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
            // We actually just auto-escape these.
            delims = [
                '<',
                '>',
                '"',
                '`',
                ' ',
                '\r',
                '\n',
                '\t'
            ], // RFC 2396: characters not allowed for various reasons.
            unwise = [
                '{',
                '}',
                '|',
                '\\',
                '^',
                '`'
            ].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
            autoEscape = [
                '\''
            ].concat(unwise), // Characters that are never ever allowed in a hostname.
            // Note that any invalid chars are also handled, but these
            // are the ones that are *expected* to be seen, so we fast-path
            // them.
            nonHostChars = [
                '%',
                '/',
                '?',
                ';',
                '#'
            ].concat(autoEscape), hostEndingChars = [
                '/',
                '?',
                '#'
            ], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
            unsafeProtocol = {
                'javascript': true,
                'javascript:': true
            }, // protocols that never have a hostname.
            hostlessProtocol = {
                'javascript': true,
                'javascript:': true
            }, // protocols that always contain a // bit.
            slashedProtocol = {
                'http': true,
                'https': true,
                'ftp': true,
                'gopher': true,
                'file': true,
                'http:': true,
                'https:': true,
                'ftp:': true,
                'gopher:': true,
                'file:': true
            }, querystring = require1('querystring');
            function urlParse(url, parseQueryString, slashesDenoteHost) {
                if (url && util.isObject(url) && url instanceof Url) return url;
                var u = new Url;
                u.parse(url, parseQueryString, slashesDenoteHost);
                return u;
            }
            Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
                if (!util.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
                // Copy chrome, IE, opera backslash-handling behavior.
                // Back slashes before the query string get converted to forward slashes
                // See: https://code.google.com/p/chromium/issues/detail?id=25916
                var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
                uSplit[0] = uSplit[0].replace(slashRegex, '/');
                url = uSplit.join(splitter);
                var rest = url;
                // trim before proceeding.
                // This is to support parse stuff like "  http://foo.com  \n"
                rest = rest.trim();
                if (!slashesDenoteHost && url.split('#').length === 1) {
                    // Try fast path regexp
                    var simplePath = simplePathPattern.exec(rest);
                    if (simplePath) {
                        this.path = rest;
                        this.href = rest;
                        this.pathname = simplePath[1];
                        if (simplePath[2]) {
                            this.search = simplePath[2];
                            if (parseQueryString) this.query = querystring.parse(this.search.substr(1));
                            else this.query = this.search.substr(1);
                        } else if (parseQueryString) {
                            this.search = '';
                            this.query = {};
                        }
                        return this;
                    }
                }
                var proto = protocolPattern.exec(rest);
                if (proto) {
                    proto = proto[0];
                    var lowerProto = proto.toLowerCase();
                    this.protocol = lowerProto;
                    rest = rest.substr(proto.length);
                }
                // figure out if it's got a host
                // user@server is *always* interpreted as a hostname, and url
                // resolution will treat //foo/bar as host=foo,path=bar because that's
                // how the browser resolves relative URLs.
                if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
                    var slashes = rest.substr(0, 2) === '//';
                    if (slashes && !(proto && hostlessProtocol[proto])) {
                        rest = rest.substr(2);
                        this.slashes = true;
                    }
                }
                if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
                    // there's a hostname.
                    // the first instance of /, ?, ;, or # ends the host.
                    //
                    // If there is an @ in the hostname, then non-host chars *are* allowed
                    // to the left of the last @ sign, unless some host-ending character
                    // comes *before* the @-sign.
                    // URLs are obnoxious.
                    //
                    // ex:
                    // http://a@b@c/ => user:a@b host:c
                    // http://a@b?@c => user:a host:c path:/?@c
                    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
                    // Review our test case against browsers more comprehensively.
                    // find the first instance of any hostEndingChars
                    var hostEnd = -1;
                    for(var i = 0; i < hostEndingChars.length; i++){
                        var hec = rest.indexOf(hostEndingChars[i]);
                        if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                    }
                    // at this point, either we have an explicit point where the
                    // auth portion cannot go past, or the last @ char is the decider.
                    var auth, atSign;
                    if (hostEnd === -1) // atSign can be anywhere.
                    atSign = rest.lastIndexOf('@');
                    else // atSign must be in auth portion.
                    // http://a@b/c@d => host:b auth:a path:/c@d
                    atSign = rest.lastIndexOf('@', hostEnd);
                    // Now we have a portion which is definitely the auth.
                    // Pull that off.
                    if (atSign !== -1) {
                        auth = rest.slice(0, atSign);
                        rest = rest.slice(atSign + 1);
                        this.auth = decodeURIComponent(auth);
                    }
                    // the host is the remaining to the left of the first non-host char
                    hostEnd = -1;
                    for(var i = 0; i < nonHostChars.length; i++){
                        var hec = rest.indexOf(nonHostChars[i]);
                        if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                    }
                    // if we still have not hit it, then the entire thing is a host.
                    if (hostEnd === -1) hostEnd = rest.length;
                    this.host = rest.slice(0, hostEnd);
                    rest = rest.slice(hostEnd);
                    // pull out port.
                    this.parseHost();
                    // we've indicated that there is a hostname,
                    // so even if it's empty, it has to be present.
                    this.hostname = this.hostname || '';
                    // if hostname begins with [ and ends with ]
                    // assume that it's an IPv6 address.
                    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
                    // validate a little.
                    if (!ipv6Hostname) {
                        var hostparts = this.hostname.split(/\./);
                        for(var i = 0, l = hostparts.length; i < l; i++){
                            var part = hostparts[i];
                            if (!part) continue;
                            if (!part.match(hostnamePartPattern)) {
                                var newpart = '';
                                for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                                // we need this to make sure size of hostname is not
                                // broken by replacing non-ASCII by nothing
                                newpart += 'x';
                                else newpart += part[j];
                                // we test again with ASCII char only
                                if (!newpart.match(hostnamePartPattern)) {
                                    var validParts = hostparts.slice(0, i);
                                    var notHost = hostparts.slice(i + 1);
                                    var bit = part.match(hostnamePartStart);
                                    if (bit) {
                                        validParts.push(bit[1]);
                                        notHost.unshift(bit[2]);
                                    }
                                    if (notHost.length) rest = '/' + notHost.join('.') + rest;
                                    this.hostname = validParts.join('.');
                                    break;
                                }
                            }
                        }
                    }
                    if (this.hostname.length > hostnameMaxLen) this.hostname = '';
                    else // hostnames are always lower case.
                    this.hostname = this.hostname.toLowerCase();
                    if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
                    // It only converts parts of the domain name that
                    // have non-ASCII characters, i.e. it doesn't matter if
                    // you call it with a domain that already is ASCII-only.
                    this.hostname = punycode.toASCII(this.hostname);
                    var p = this.port ? ':' + this.port : '';
                    var h = this.hostname || '';
                    this.host = h + p;
                    this.href += this.host;
                    // strip [ and ] from the hostname
                    // the host field still retains them, though
                    if (ipv6Hostname) {
                        this.hostname = this.hostname.substr(1, this.hostname.length - 2);
                        if (rest[0] !== '/') rest = '/' + rest;
                    }
                }
                // now rest is set to the post-host stuff.
                // chop off any delim chars.
                if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
                // escaped, even if encodeURIComponent doesn't think they
                // need to be.
                for(var i = 0, l = autoEscape.length; i < l; i++){
                    var ae = autoEscape[i];
                    if (rest.indexOf(ae) === -1) continue;
                    var esc = encodeURIComponent(ae);
                    if (esc === ae) esc = escape(ae);
                    rest = rest.split(ae).join(esc);
                }
                // chop off from the tail first.
                var hash = rest.indexOf('#');
                if (hash !== -1) {
                    // got a fragment string.
                    this.hash = rest.substr(hash);
                    rest = rest.slice(0, hash);
                }
                var qm = rest.indexOf('?');
                if (qm !== -1) {
                    this.search = rest.substr(qm);
                    this.query = rest.substr(qm + 1);
                    if (parseQueryString) this.query = querystring.parse(this.query);
                    rest = rest.slice(0, qm);
                } else if (parseQueryString) {
                    // no query string, but parseQueryString still requested
                    this.search = '';
                    this.query = {};
                }
                if (rest) this.pathname = rest;
                if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
                //to support http.request
                if (this.pathname || this.search) {
                    var p = this.pathname || '';
                    var s = this.search || '';
                    this.path = p + s;
                }
                // finally, reconstruct the href based on what has been validated.
                this.href = this.format();
                return this;
            };
            // format a parsed object into a url string
            function urlFormat(obj) {
                // ensure it's an object, and not a string url.
                // If it's an obj, this is a no-op.
                // this way, you can call url_format() on strings
                // to clean up potentially wonky urls.
                if (util.isString(obj)) obj = urlParse(obj);
                if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
                return obj.format();
            }
            Url.prototype.format = function() {
                var auth = this.auth || '';
                if (auth) {
                    auth = encodeURIComponent(auth);
                    auth = auth.replace(/%3A/i, ':');
                    auth += '@';
                }
                var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
                if (this.host) host = auth + this.host;
                else if (this.hostname) {
                    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
                    if (this.port) host += ':' + this.port;
                }
                if (this.query && util.isObject(this.query) && Object.keys(this.query).length) query = querystring.stringify(this.query);
                var search = this.search || query && '?' + query || '';
                if (protocol && protocol.substr(-1) !== ':') protocol += ':';
                // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
                // unless they had them to begin with.
                if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
                    host = '//' + (host || '');
                    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
                } else if (!host) host = '';
                if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
                if (search && search.charAt(0) !== '?') search = '?' + search;
                pathname = pathname.replace(/[?#]/g, function(match) {
                    return encodeURIComponent(match);
                });
                search = search.replace('#', '%23');
                return protocol + host + pathname + search + hash;
            };
            function urlResolve(source, relative) {
                return urlParse(source, false, true).resolve(relative);
            }
            Url.prototype.resolve = function(relative) {
                return this.resolveObject(urlParse(relative, false, true)).format();
            };
            function urlResolveObject(source, relative) {
                if (!source) return relative;
                return urlParse(source, false, true).resolveObject(relative);
            }
            Url.prototype.resolveObject = function(relative) {
                if (util.isString(relative)) {
                    var rel = new Url();
                    rel.parse(relative, false, true);
                    relative = rel;
                }
                var result = new Url();
                var tkeys = Object.keys(this);
                for(var tk = 0; tk < tkeys.length; tk++){
                    var tkey = tkeys[tk];
                    result[tkey] = this[tkey];
                }
                // hash is always overridden, no matter what.
                // even href="" will remove it.
                result.hash = relative.hash;
                // if the relative url is empty, then there's nothing left to do here.
                if (relative.href === '') {
                    result.href = result.format();
                    return result;
                }
                // hrefs like //foo/bar always cut to the protocol.
                if (relative.slashes && !relative.protocol) {
                    // take everything except the protocol from relative
                    var rkeys = Object.keys(relative);
                    for(var rk = 0; rk < rkeys.length; rk++){
                        var rkey = rkeys[rk];
                        if (rkey !== 'protocol') result[rkey] = relative[rkey];
                    }
                    //urlParse appends trailing / to urls like http://www.example.com
                    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = '/';
                    result.href = result.format();
                    return result;
                }
                if (relative.protocol && relative.protocol !== result.protocol) {
                    // if it's a known url protocol, then changing
                    // the protocol does weird things
                    // first, if it's not file:, then we MUST have a host,
                    // and if there was a path
                    // to begin with, then we MUST have a path.
                    // if it is file:, then the host is dropped,
                    // because that's known to be hostless.
                    // anything else is assumed to be absolute.
                    if (!slashedProtocol[relative.protocol]) {
                        var keys = Object.keys(relative);
                        for(var v = 0; v < keys.length; v++){
                            var k = keys[v];
                            result[k] = relative[k];
                        }
                        result.href = result.format();
                        return result;
                    }
                    result.protocol = relative.protocol;
                    if (!relative.host && !hostlessProtocol[relative.protocol]) {
                        var relPath = (relative.pathname || '').split('/');
                        while(relPath.length && !(relative.host = relPath.shift()));
                        if (!relative.host) relative.host = '';
                        if (!relative.hostname) relative.hostname = '';
                        if (relPath[0] !== '') relPath.unshift('');
                        if (relPath.length < 2) relPath.unshift('');
                        result.pathname = relPath.join('/');
                    } else result.pathname = relative.pathname;
                    result.search = relative.search;
                    result.query = relative.query;
                    result.host = relative.host || '';
                    result.auth = relative.auth;
                    result.hostname = relative.hostname || relative.host;
                    result.port = relative.port;
                    // to support http.request
                    if (result.pathname || result.search) {
                        var p = result.pathname || '';
                        var s = result.search || '';
                        result.path = p + s;
                    }
                    result.slashes = result.slashes || relative.slashes;
                    result.href = result.format();
                    return result;
                }
                var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
                // if the url is a non-slashed url, then relative
                // links like ../.. should be able
                // to crawl up to the hostname, as well.  This is strange.
                // result.protocol has already been set by now.
                // Later on, put the first path part into the host field.
                if (psychotic) {
                    result.hostname = '';
                    result.port = null;
                    if (result.host) {
                        if (srcPath[0] === '') srcPath[0] = result.host;
                        else srcPath.unshift(result.host);
                    }
                    result.host = '';
                    if (relative.protocol) {
                        relative.hostname = null;
                        relative.port = null;
                        if (relative.host) {
                            if (relPath[0] === '') relPath[0] = relative.host;
                            else relPath.unshift(relative.host);
                        }
                        relative.host = null;
                    }
                    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
                }
                if (isRelAbs) {
                    // it's absolute.
                    result.host = relative.host || relative.host === '' ? relative.host : result.host;
                    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
                    result.search = relative.search;
                    result.query = relative.query;
                    srcPath = relPath;
                // fall through to the dot-handling below.
                } else if (relPath.length) {
                    // it's relative
                    // throw away the existing file, and take the new path instead.
                    if (!srcPath) srcPath = [];
                    srcPath.pop();
                    srcPath = srcPath.concat(relPath);
                    result.search = relative.search;
                    result.query = relative.query;
                } else if (!util.isNullOrUndefined(relative.search)) {
                    // just pull out the search.
                    // like href='?foo'.
                    // Put this after the other two cases because it simplifies the booleans
                    if (psychotic) {
                        result.hostname = result.host = srcPath.shift();
                        //occationaly the auth can get stuck only in host
                        //this especially happens in cases like
                        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                        var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
                        if (authInHost) {
                            result.auth = authInHost.shift();
                            result.host = result.hostname = authInHost.shift();
                        }
                    }
                    result.search = relative.search;
                    result.query = relative.query;
                    //to support http.request
                    if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
                    result.href = result.format();
                    return result;
                }
                if (!srcPath.length) {
                    // no path at all.  easy.
                    // we've already handled the other stuff above.
                    result.pathname = null;
                    //to support http.request
                    if (result.search) result.path = '/' + result.search;
                    else result.path = null;
                    result.href = result.format();
                    return result;
                }
                // if a url ENDs in . or .., then it must get a trailing slash.
                // however, if it ends in anything else non-slashy,
                // then it must NOT get a trailing slash.
                var last = srcPath.slice(-1)[0];
                var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
                // strip single dots, resolve double dots to parent dir
                // if the path tries to go above the root, `up` ends up > 0
                var up = 0;
                for(var i = srcPath.length; i >= 0; i--){
                    last = srcPath[i];
                    if (last === '.') srcPath.splice(i, 1);
                    else if (last === '..') {
                        srcPath.splice(i, 1);
                        up++;
                    } else if (up) {
                        srcPath.splice(i, 1);
                        up--;
                    }
                }
                // if the path is allowed to go above the root, restore leading ..s
                if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
                if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
                if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
                var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
                // put the host back
                if (psychotic) {
                    result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
                    //occationaly the auth can get stuck only in host
                    //this especially happens in cases like
                    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
                    if (authInHost) {
                        result.auth = authInHost.shift();
                        result.host = result.hostname = authInHost.shift();
                    }
                }
                mustEndAbs = mustEndAbs || result.host && srcPath.length;
                if (mustEndAbs && !isAbsolute) srcPath.unshift('');
                if (!srcPath.length) {
                    result.pathname = null;
                    result.path = null;
                } else result.pathname = srcPath.join('/');
                //to support request.http
                if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
                result.auth = relative.auth || result.auth;
                result.slashes = result.slashes || relative.slashes;
                result.href = result.format();
                return result;
            };
            Url.prototype.parseHost = function() {
                var host = this.host;
                var port = portPattern.exec(host);
                if (port) {
                    port = port[0];
                    if (port !== ':') this.port = port.substr(1);
                    host = host.substr(0, host.length - port.length);
                }
                if (host) this.hostname = host;
            };
        },
        {
            "./util": 231,
            "punycode": 205,
            "querystring": 208
        }
    ],
    231: [
        function(require1, module, exports) {
            'use strict';
            module.exports = {
                isString: function(arg) {
                    return typeof arg === 'string';
                },
                isObject: function(arg) {
                    return typeof arg === 'object' && arg !== null;
                },
                isNull: function(arg) {
                    return arg === null;
                },
                isNullOrUndefined: function(arg) {
                    return arg == null;
                }
            };
        },
        {}
    ],
    232: [
        function(require1, module, exports) {
            (function(global1) {
                /**
 * Module exports.
 */ module.exports = deprecate;
                /**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
                    if (config('noDeprecation')) return fn;
                    var warned = false;
                    function deprecated() {
                        if (!warned) {
                            if (config('throwDeprecation')) throw new Error(msg);
                            else if (config('traceDeprecation')) console.trace(msg);
                            else console.warn(msg);
                            warned = true;
                        }
                        return fn.apply(this, arguments);
                    }
                    return deprecated;
                }
                /**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
                    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
                    try {
                        if (!global1.localStorage) return false;
                    } catch (_) {
                        return false;
                    }
                    var val = global1.localStorage[name];
                    if (null == val) return false;
                    return String(val).toLowerCase() === 'true';
                }
            }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        },
        {}
    ],
    233: [
        function(require1, module, exports) {
            arguments[4][189][0].apply(exports, arguments);
        },
        {
            "dup": 189
        }
    ],
    234: [
        function(require1, module, exports) {
            module.exports = function isBuffer(arg) {
                return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
            };
        },
        {}
    ],
    235: [
        function(require1, module, exports) {
            (function(process, global1) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var formatRegExp = /%[sdj%]/g;
                exports.format = function(f) {
                    if (!isString(f)) {
                        var objects = [];
                        for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
                        return objects.join(' ');
                    }
                    var i = 1;
                    var args = arguments;
                    var len = args.length;
                    var str = String(f).replace(formatRegExp, function(x) {
                        if (x === '%%') return '%';
                        if (i >= len) return x;
                        switch(x){
                            case '%s':
                                return String(args[i++]);
                            case '%d':
                                return Number(args[i++]);
                            case '%j':
                                try {
                                    return JSON.stringify(args[i++]);
                                } catch (_) {
                                    return '[Circular]';
                                }
                            default:
                                return x;
                        }
                    });
                    for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += ' ' + x;
                    else str += ' ' + inspect(x);
                    return str;
                };
                // Mark that a method should not be used.
                // Returns a modified function which warns once by default.
                // If --no-deprecation is set, then it is a no-op.
                exports.deprecate = function(fn, msg) {
                    // Allow for deprecating things in the process of starting up.
                    if (isUndefined(global1.process)) return function() {
                        return exports.deprecate(fn, msg).apply(this, arguments);
                    };
                    if (process.noDeprecation === true) return fn;
                    var warned = false;
                    function deprecated() {
                        if (!warned) {
                            if (process.throwDeprecation) throw new Error(msg);
                            else if (process.traceDeprecation) console.trace(msg);
                            else console.error(msg);
                            warned = true;
                        }
                        return fn.apply(this, arguments);
                    }
                    return deprecated;
                };
                var debugs = {};
                var debugEnviron;
                exports.debuglog = function(set) {
                    if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
                    set = set.toUpperCase();
                    if (!debugs[set]) {
                        if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
                            var pid = process.pid;
                            debugs[set] = function() {
                                var msg = exports.format.apply(exports, arguments);
                                console.error('%s %d: %s', set, pid, msg);
                            };
                        } else debugs[set] = function() {};
                    }
                    return debugs[set];
                };
                /**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function inspect(obj, opts) {
                    // default options
                    var ctx = {
                        seen: [],
                        stylize: stylizeNoColor
                    };
                    // legacy...
                    if (arguments.length >= 3) ctx.depth = arguments[2];
                    if (arguments.length >= 4) ctx.colors = arguments[3];
                    if (isBoolean(opts)) // legacy...
                    ctx.showHidden = opts;
                    else if (opts) // got an "options" object
                    exports._extend(ctx, opts);
                    // set default options
                    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
                    if (isUndefined(ctx.depth)) ctx.depth = 2;
                    if (isUndefined(ctx.colors)) ctx.colors = false;
                    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
                    if (ctx.colors) ctx.stylize = stylizeWithColor;
                    return formatValue(ctx, obj, ctx.depth);
                }
                exports.inspect = inspect;
                // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
                inspect.colors = {
                    'bold': [
                        1,
                        22
                    ],
                    'italic': [
                        3,
                        23
                    ],
                    'underline': [
                        4,
                        24
                    ],
                    'inverse': [
                        7,
                        27
                    ],
                    'white': [
                        37,
                        39
                    ],
                    'grey': [
                        90,
                        39
                    ],
                    'black': [
                        30,
                        39
                    ],
                    'blue': [
                        34,
                        39
                    ],
                    'cyan': [
                        36,
                        39
                    ],
                    'green': [
                        32,
                        39
                    ],
                    'magenta': [
                        35,
                        39
                    ],
                    'red': [
                        31,
                        39
                    ],
                    'yellow': [
                        33,
                        39
                    ]
                };
                // Don't use 'blue' not visible on cmd.exe
                inspect.styles = {
                    'special': 'cyan',
                    'number': 'yellow',
                    'boolean': 'yellow',
                    'undefined': 'grey',
                    'null': 'bold',
                    'string': 'green',
                    'date': 'magenta',
                    // "name": intentionally not styling
                    'regexp': 'red'
                };
                function stylizeWithColor(str, styleType) {
                    var style = inspect.styles[styleType];
                    if (style) return '\u001b[' + inspect.colors[style][0] + 'm' + str + '\u001b[' + inspect.colors[style][1] + 'm';
                    else return str;
                }
                function stylizeNoColor(str, styleType) {
                    return str;
                }
                function arrayToHash(array) {
                    var hash = {};
                    array.forEach(function(val, idx) {
                        hash[val] = true;
                    });
                    return hash;
                }
                function formatValue(ctx, value, recurseTimes) {
                    // Provide a hook for user-specified inspect functions.
                    // Check that value is an object with an inspect function on it
                    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
                    value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
                    !(value.constructor && value.constructor.prototype === value)) {
                        var ret = value.inspect(recurseTimes, ctx);
                        if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
                        return ret;
                    }
                    // Primitive types cannot have properties
                    var primitive = formatPrimitive(ctx, value);
                    if (primitive) return primitive;
                    // Look up the keys of the object.
                    var keys = Object.keys(value);
                    var visibleKeys = arrayToHash(keys);
                    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
                    // IE doesn't make error fields non-enumerable
                    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
                    if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return formatError(value);
                    // Some type of object without properties can be shortcutted.
                    if (keys.length === 0) {
                        if (isFunction(value)) {
                            var name = value.name ? ': ' + value.name : '';
                            return ctx.stylize('[Function' + name + ']', 'special');
                        }
                        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
                        if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
                        if (isError(value)) return formatError(value);
                    }
                    var base = '', array = false, braces = [
                        '{',
                        '}'
                    ];
                    // Make Array say that they are Array
                    if (isArray(value)) {
                        array = true;
                        braces = [
                            '[',
                            ']'
                        ];
                    }
                    // Make functions say that they are functions
                    if (isFunction(value)) {
                        var n = value.name ? ': ' + value.name : '';
                        base = ' [Function' + n + ']';
                    }
                    // Make RegExps say that they are RegExps
                    if (isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
                    // Make dates with properties first say the date
                    if (isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
                    // Make error with message first say the error
                    if (isError(value)) base = ' ' + formatError(value);
                    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
                    if (recurseTimes < 0) {
                        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
                        else return ctx.stylize('[Object]', 'special');
                    }
                    ctx.seen.push(value);
                    var output;
                    if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
                    else output = keys.map(function(key) {
                        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
                    });
                    ctx.seen.pop();
                    return reduceToSingleString(output, base, braces);
                }
                function formatPrimitive(ctx, value) {
                    if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
                    if (isString(value)) {
                        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
                        return ctx.stylize(simple, 'string');
                    }
                    if (isNumber(value)) return ctx.stylize('' + value, 'number');
                    if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
                    // For some reason typeof null is "object", so special case here.
                    if (isNull(value)) return ctx.stylize('null', 'null');
                }
                function formatError(value) {
                    return '[' + Error.prototype.toString.call(value) + ']';
                }
                function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
                    var output = [];
                    for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
                    else output.push('');
                    keys.forEach(function(key) {
                        if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
                    });
                    return output;
                }
                function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
                    var name, str, desc;
                    desc = Object.getOwnPropertyDescriptor(value, key) || {
                        value: value[key]
                    };
                    if (desc.get) {
                        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
                        else str = ctx.stylize('[Getter]', 'special');
                    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
                    if (!hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
                    if (!str) {
                        if (ctx.seen.indexOf(desc.value) < 0) {
                            if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
                            else str = formatValue(ctx, desc.value, recurseTimes - 1);
                            if (str.indexOf('\n') > -1) {
                                if (array) str = str.split('\n').map(function(line) {
                                    return '  ' + line;
                                }).join('\n').substr(2);
                                else str = '\n' + str.split('\n').map(function(line) {
                                    return '   ' + line;
                                }).join('\n');
                            }
                        } else str = ctx.stylize('[Circular]', 'special');
                    }
                    if (isUndefined(name)) {
                        if (array && key.match(/^\d+$/)) return str;
                        name = JSON.stringify('' + key);
                        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                            name = name.substr(1, name.length - 2);
                            name = ctx.stylize(name, 'name');
                        } else {
                            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                            name = ctx.stylize(name, 'string');
                        }
                    }
                    return name + ': ' + str;
                }
                function reduceToSingleString(output, base, braces) {
                    var numLinesEst = 0;
                    var length = output.reduce(function(prev, cur) {
                        numLinesEst++;
                        if (cur.indexOf('\n') >= 0) numLinesEst++;
                        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
                    }, 0);
                    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
                    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
                }
                // NOTE: These type checking functions intentionally don't use `instanceof`
                // because it is fragile and can be easily faked with `Object.create()`.
                function isArray(ar) {
                    return Array.isArray(ar);
                }
                exports.isArray = isArray;
                function isBoolean(arg) {
                    return typeof arg === 'boolean';
                }
                exports.isBoolean = isBoolean;
                function isNull(arg) {
                    return arg === null;
                }
                exports.isNull = isNull;
                function isNullOrUndefined(arg) {
                    return arg == null;
                }
                exports.isNullOrUndefined = isNullOrUndefined;
                function isNumber(arg) {
                    return typeof arg === 'number';
                }
                exports.isNumber = isNumber;
                function isString(arg) {
                    return typeof arg === 'string';
                }
                exports.isString = isString;
                function isSymbol(arg) {
                    return typeof arg === 'symbol';
                }
                exports.isSymbol = isSymbol;
                function isUndefined(arg) {
                    return arg === void 0;
                }
                exports.isUndefined = isUndefined;
                function isRegExp(re) {
                    return isObject(re) && objectToString(re) === '[object RegExp]';
                }
                exports.isRegExp = isRegExp;
                function isObject(arg) {
                    return typeof arg === 'object' && arg !== null;
                }
                exports.isObject = isObject;
                function isDate(d) {
                    return isObject(d) && objectToString(d) === '[object Date]';
                }
                exports.isDate = isDate;
                function isError(e) {
                    return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
                }
                exports.isError = isError;
                function isFunction(arg) {
                    return typeof arg === 'function';
                }
                exports.isFunction = isFunction;
                function isPrimitive(arg) {
                    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
                    typeof arg === 'undefined';
                }
                exports.isPrimitive = isPrimitive;
                exports.isBuffer = require1('./support/isBuffer');
                function objectToString(o) {
                    return Object.prototype.toString.call(o);
                }
                function pad(n) {
                    return n < 10 ? '0' + n.toString(10) : n.toString(10);
                }
                var months = [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec'
                ];
                // 26 Feb 16:19:34
                function timestamp() {
                    var d = new Date();
                    var time = [
                        pad(d.getHours()),
                        pad(d.getMinutes()),
                        pad(d.getSeconds())
                    ].join(':');
                    return [
                        d.getDate(),
                        months[d.getMonth()],
                        time
                    ].join(' ');
                }
                // log is just a thin wrapper to console.log that prepends a timestamp
                exports.log = function() {
                    console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
                };
                /**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ exports.inherits = require1('inherits');
                exports._extend = function(origin, add) {
                    // Don't do anything if add isn't an object
                    if (!add || !isObject(add)) return origin;
                    var keys = Object.keys(add);
                    var i = keys.length;
                    while(i--)origin[keys[i]] = add[keys[i]];
                    return origin;
                };
                function hasOwnProperty(obj, prop) {
                    return Object.prototype.hasOwnProperty.call(obj, prop);
                }
            }).call(this, require1('_process'), typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        },
        {
            "./support/isBuffer": 234,
            "_process": 204,
            "inherits": 233
        }
    ],
    236: [
        function(require1, module, exports) {
            module.exports = extend;
            var hasOwnProperty = Object.prototype.hasOwnProperty;
            function extend() {
                var target = {};
                for(var i = 0; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            }
        },
        {}
    ]
}, {}, [
    1
]);


/*_____      ___            __                 _____                                     
_/  ___\____ \_ |___ ______|__| ____     _____/  ___\  _____________ ______  _____  _____  
\   __\\__  \ | __  \\  __ \  |/ ___\   /  _ \   __\  /  ___/|  __  \\___  \/  ___\/  __ \ 
 |  |   / __ \| \_\  \  | \/  |  \___  (  (_) )  |    \___  \|  |_)  )/  _  \  \___\  ___/_
 |__|  (______)____ _/__|  |__|\____/   \____/|__|   /______/|   ___/(______/\_____/\_____/
                                                             |__|                     */ // LOCALS IN MOD SCOPE
var $6bfa5c439efc151f$var$g1 = 33;
var $6bfa5c439efc151f$var$procs = {}; // ALL PROCESSES
// The following variables are created in the module (file) scope and are accessible throughout this module.
var $6bfa5c439efc151f$var$eventer = new EventTarget(); // FABRIC EVENTER 
var $6bfa5c439efc151f$var$channel = new MessageChannel(); // FOR WORKER PORTS 
var $6bfa5c439efc151f$var$port1 = $6bfa5c439efc151f$var$channel.port1; // PORT
var $6bfa5c439efc151f$var$port2 = $6bfa5c439efc151f$var$channel.port2; // PORT
var $6bfa5c439efc151f$var$creds = false; // future cache ref 
// should operate with pre injected creds 
// Generate a unique identifier for this instance of the worker module
var $6bfa5c439efc151f$var$proc_uuid = crypto.randomUUID ? crypto.randomUUID() : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
var $6bfa5c439efc151f$var$g0 = 2;
// var is_worker = ! document;
// var scriptnode = document.createElement('script');
// scriptnode.setAttribute('id','pchecker');
// var script_path = is_worker ? null : (function() {
// 	var id = '9998998';
// 	return document.querySelector('#pchecker').previousSibling.src;
// })();
// STANDARD CAPABILITY 
var $6bfa5c439efc151f$var$input_to_capability = {
    init: 'init',
    focusObject: 'loadCluster',
    objectAdded: 'loadSupportingObjectProc' // fabric.publishIntent( vector:object )
};
// CREDENTIAL PROVIDER
function $6bfa5c439efc151f$var$init(initObj) {
    $6bfa5c439efc151f$var$creds = initObj.creds;
}
// MESSAGE TO WORKERS:
function $6bfa5c439efc151f$var$messageToWorker(intentObj) {
    //FIND Worker by ID in existing workers list: 
    $6bfa5c439efc151f$var$mergeIntent(intentObj);
//If worker does not exist , spawn worker: 
//after worker spawned or retrieved postMessage () 
//(currently landled by mergeIntent)
}
// MESSAGE FROM WORKERS: 
function $6bfa5c439efc151f$var$messageFromWorker(e) {
    var messageObject = e.data;
    // REJECT IF NO METHOD OR DATA 
    if (!messageObject) return;
    if (!('method' in messageObject)) return;
    // USE SELF REPORT EVENTS TO ADD SUCCESSFUL WORKERS METADATA 
    if (messageObject.method == 'report') {
        $6bfa5c439efc151f$var$procs[messageObject.uuid]['wid'] = messageObject['worker_id'];
        console.log('        report:| ');
        for(var p in $6bfa5c439efc151f$var$procs)console.log('              ', p, ' : ', $6bfa5c439efc151f$var$procs[p]);
        var d = 3;
    } else {
        // PROPAGATE MESSAGES ONWARDS AS EVENTS 
        // fabricEvent struct 
        // { foreign_method:
        //           method:  
        //             uuid:
        //          payload:
        // }
        var d5 = 5;
        dispatchEvent(new CustomEvent('fabricEvent', {
            detail: e.data
        }));
    //console.log('Fabric: ', e.data.method  , e.data );        
    }
}
// MESSAGE ERROR FROM WORKER 
async function $6bfa5c439efc151f$var$errorFromWorker(e) {
    // ROUTE TO MAIN CONE IF REF EXISTS
    console.log(' Fabric ERROR: ', e);
// TODO: Add ref from options 
}
// GENERAL PROC STARTER 
async function $6bfa5c439efc151f$var$mergeIntent(intentObj) {
    // ENSURE UUID LINKAGE
    if (!('uuid' in intentObj)) intentObj.uuid = intentObj.module + '.' + intentObj.brand; //util.uuidv4() // OR HASH UUID FROM ATTRIBS
    // MESSAGE EXISTING OR SPAWN 
    var target_worker; // X ES 
    if ($6bfa5c439efc151f$var$procs[intentObj.uuid]) {
        target_worker = $6bfa5c439efc151f$var$procs[intentObj.uuid].worker; // SHOULD INIT START DEPENDENCIES of REQUESTED NON LIVING )
        target_worker.postMessage(intentObj);
    } else {
        // CHECK IF WORKER.CLASSIC or WORKER.MODULE 
        const driver_conf = {
            type: 'module'
        } // driver.includes('esm') ?  { type:'module'} : { type:'classic' }
        ;
        const container_path = '/fabric/container.mjs'; // workers dont use relative to page 
        var target_worker = new Worker(container_path, driver_conf); // MUST USE ABSO PATH // pass { type:'module' } for es6 still buggy and bundled dependencies with node polyfils issues
        target_worker.addEventListener('message', $6bfa5c439efc151f$var$messageFromWorker);
        target_worker.addEventListener('onerror', $6bfa5c439efc151f$var$messageFromWorker);
        // TODO: CHECK IF CREDENTIALS IN px3 
        // STRUCTURED CLONE COMPATIBILITY STRIP REFS  //console.log(' merge Intent ', new Date().getTime() )    
        var px1 = {
            ...intentObj
        } //  "Spread"
        ;
        var px2 = Object.assign({}, intentObj) //  "Object.assign"
        ;
        var px3 = JSON.parse(JSON.stringify(intentObj)) //  "JSON"            
        ;
        // IN ABSENCE OF KEYSTORE and USE MANUALLY ADDED 
        // UNREGISTERED WORKER MUST FIRE INIT BEFORE FINAL ( init last to overwrite )
        // Here is UUID from Credential Provider supposed to overwrite the UUID set ? 
        // Suppose it can't because it already has precedent in the map or UI 
        // let intentObjFused = { method:'init' , ...creds.keySelect(  'dom' , intentObj.brand )[0]   , ...px3 } 
        // remove internal credential provider for simplicity for now // creds are embedded outside 
        let intentObjFused = {
            ...px3,
            method: 'init'
        };
        $6bfa5c439efc151f$var$procs[intentObjFused.uuid] = {
            worker: target_worker
        }; // INSERT PROCESS
        // 1ST MESSAGE   SENDS INIT 
        target_worker.postMessage(intentObjFused);
        // 2ND MESSAGE   SENDS ORIGINAL FIRST INTENT OBJECT 
        if (px3.method) {
            await $692e115c8623e54c$export$e772c8ff12451969(1000); // THIS DELAY SHOULD BE CONDITIONAL 
            // EXPERIMENT WITH CUE FOR INIT AND SEQUENTIAL ORDERS 
            target_worker.postMessage(px3);
        }
    // creds could be expanded to creds.keySelect( ['dom','domain','brand'] )
    }
}
// DEALLOCATES ALL WORKERS
function $6bfa5c439efc151f$var$dropProcs() {
    for(var p in $6bfa5c439efc151f$var$procs){
        var pr = $6bfa5c439efc151f$var$procs[p];
        pr.worker.terminate();
        console.log('terminated: ', p);
    }
    // SPEED UP GARBCOL
    $6bfa5c439efc151f$var$procs = {};
}
// SHOULD ENABLE WORKER TARGETTING BY ATTRIOBUTE
function $6bfa5c439efc151f$var$keySelect(k, v) {
    // by domain for general domain level request 
    // by UUID for single individual 
    // by symbol for broad multi-update 
    // returned array iterate postMessage to all !! 
    console.log(' key selecting by ', k);
}
// TIMESERIES PER GRID COORDINATE 
function $6bfa5c439efc151f$var$accessFrameByVector(x, y, z, s, t) {
    // ACCESS CACHE AND RETURN SERIES 
    console.log(' frame fector ');
}
async function $6bfa5c439efc151f$var$querySegment(targObj) {
// query Graph , match graph with grid of avail 
// query procs{[]} check if procs contain 
// return df / grid 
}
function $6bfa5c439efc151f$var$objectsOnline() {
    // return running object process  p[ ]
    console.log($6bfa5c439efc151f$var$procs);
    return $6bfa5c439efc151f$var$procs;
}
function $6bfa5c439efc151f$var$getProcs() {
    return $6bfa5c439efc151f$var$procs;
}
var $6bfa5c439efc151f$export$2e2bcd8739ae039 // FUTURE ENABLE ERROR TRACK 
 // Worker.onerror        // ErrorEvent of type error event occurs.
 // Worker.onmessage      // MessageEvent of type message occurs — i.e. when a message is sent to the parent document from the worker via DedicatedWorkerGlobalScope.postMessage. The message is stored in the event's data property.
 // Worker.onmessageerror // 
 // console.log( 'publishing Intent Into the fabric by address and target fn or xclass ');
 // console.log( intentObj )
 // OOPS ERROR CAUSE JS SET BY REFERENCE 
 // var launch_obj = px3;
 // launch_obj.method = 'init';
 // class Fabric extends EventTarget {
 //     constructor(){
 //         super()
 //     }
 // }
 // fabric = new Fabric()
 // export { fabric }
 = {
    init: $6bfa5c439efc151f$var$init,
    objectsOnline: $6bfa5c439efc151f$var$objectsOnline,
    dropProcs: $6bfa5c439efc151f$var$dropProcs,
    getProcs: $6bfa5c439efc151f$var$getProcs,
    mergeIntent: $6bfa5c439efc151f$var$mergeIntent,
    addEventListener: $6bfa5c439efc151f$var$eventer.addEventListener.bind(undefined),
    removeEventListener: $6bfa5c439efc151f$var$eventer.removeEventListener.bind(undefined),
    dispatchEvent: $6bfa5c439efc151f$var$eventer.dispatchEvent.bind(undefined)
};



function $dd6c36accdb121d6$export$633a080005861476(layouts_a, layouts_b) {
    for(var ly in layouts_b){
        var cur_incoming_layout = layouts_b[ly];
        // CREATE NON EXISTING LAYOUT 
        if (!layouts_a[ly]) layouts_a[ly] = {};
        // MERGE 
        layouts_a[ly] = {
            ...layouts_a[ly],
            ...cur_incoming_layout
        };
    }
    return layouts_a;
}
function $dd6c36accdb121d6$export$942c543eb03edfbd(nodes_a, nodes_b) {
    for(var n in nodes_b){
        var nd = nodes_b[n];
        nodes_a.set(nd.slot, nd);
    }
    return nodes_a;
}
function $dd6c36accdb121d6$export$bca7207b99358270(links_a, links_b) {
    for(var k in links_b){
        var lk = links_b[k];
        // prob is no slot for link ?
        links_a.set([
            lk.slota,
            lk.slotb
        ], lk);
    }
    return links_a;
}


var $64eddd7ed8bdeee7$export$7ccc53e8f1e7dfc5 = function eventify(subject) {
    $64eddd7ed8bdeee7$var$validateSubject(subject);
    var eventsStorage = $64eddd7ed8bdeee7$var$createEventsStorage(subject);
    subject.on = eventsStorage.on;
    subject.off = eventsStorage.off;
    subject.fire = eventsStorage.fire;
    return subject;
};
function $64eddd7ed8bdeee7$var$createEventsStorage(subject) {
    // Store all event listeners to this hash. Key is event name, value is array
    // of callback records.
    //
    // A callback record consists of callback function and its optional context:
    // { 'eventName' => [{callback: function, ctx: object}] }
    var registeredEvents = Object.create(null);
    return {
        on: function(eventName, callback, ctx) {
            if (typeof callback !== 'function') throw new Error('callback is expected to be a function');
            var handlers = registeredEvents[eventName];
            if (!handlers) handlers = registeredEvents[eventName] = [];
            handlers.push({
                callback: callback,
                ctx: ctx
            });
            return subject;
        },
        off: function(eventName, callback) {
            var wantToRemoveAll = typeof eventName === 'undefined';
            if (wantToRemoveAll) {
                // Killing old events storage should be enough in this case:
                registeredEvents = Object.create(null);
                return subject;
            }
            if (registeredEvents[eventName]) {
                var deleteAllCallbacksForEvent = typeof callback !== 'function';
                if (deleteAllCallbacksForEvent) delete registeredEvents[eventName];
                else {
                    var callbacks = registeredEvents[eventName];
                    for(var i = 0; i < callbacks.length; ++i)if (callbacks[i].callback === callback) callbacks.splice(i, 1);
                }
            }
            return subject;
        },
        fire: function(eventName) {
            var callbacks = registeredEvents[eventName];
            if (!callbacks) return subject;
            var fireArguments;
            if (arguments.length > 1) fireArguments = Array.prototype.splice.call(arguments, 1);
            for(var i = 0; i < callbacks.length; ++i){
                var callbackInfo = callbacks[i];
                callbackInfo.callback.apply(callbackInfo.ctx, fireArguments);
            }
            return subject;
        }
    };
}
function $64eddd7ed8bdeee7$var$validateSubject(subject) {
    if (!subject) throw new Error('Eventify cannot use falsy object as events subject');
    var reservedWords = [
        'on',
        'fire',
        'off'
    ];
    for(var i = 0; i < reservedWords.length; ++i){
        if (subject.hasOwnProperty(reservedWords[i])) throw new Error("Subject cannot be eventified, since it already has property '" + reservedWords[i] + "'");
    }
}


/**
 * @fileOverview Contains definition of the core graph object.
 */ // TODO: need to change storage layer:
// 1. Be able to get all nodes O(1)
// 2. Be able to get number of links O(1)
/**
 * @example
 *  var graph = require('ngraph.graph')();
 *  graph.addNode(1);     // graph has one node.
 *  graph.addLink(2, 3);  // now graph contains three nodes and one link.
 *
 */ var $0dd61d98ba46ad83$var$ngraph_graph = $0dd61d98ba46ad83$var$createGraph;
/**
 * Creates a new graph
 */ function $0dd61d98ba46ad83$var$createGraph(options) {
    // Graph structure is maintained as dictionary of nodes
    // and array of links. Each node has 'links' property which
    // hold all links related to that node. And general links
    // array is used to speed up all links enumeration. This is inefficient
    // in terms of memory, but simplifies coding.
    options = options || {};
    if ('uniqueLinkId' in options) {
        console.warn("ngraph.graph: Starting from version 0.14 `uniqueLinkId` is deprecated.\nUse `multigraph` option instead\n", '\n', "Note: there is also change in default behavior: From now on each graph\nis considered to be not a multigraph by default (each edge is unique).");
        options.multigraph = options.uniqueLinkId;
    }
    // Dear reader, the non-multigraphs do not guarantee that there is only
    // one link for a given pair of node. When this option is set to false
    // we can save some memory and CPU (18% faster for non-multigraph);
    if (options.multigraph === undefined) options.multigraph = false;
    if (typeof Map !== 'function') // TODO: Should we polyfill it ourselves? We don't use much operations there..
    throw new Error('ngraph.graph requires `Map` to be defined. Please polyfill it before using ngraph');
    var nodes = new Map(); // nodeId => Node
    var links = new Map(); // linkId => Link
    // Hash of multi-edges. Used to track ids of edges between same nodes
    var multiEdges = {};
    var suspendEvents = 0;
    var createLink = options.multigraph ? createUniqueLink : createSingleLink, // Our graph API provides means to listen to graph changes. Users can subscribe
    // to be notified about changes in the graph by using `on` method. However
    // in some cases they don't use it. To avoid unnecessary memory consumption
    // we will not record graph changes until we have at least one subscriber.
    // Code below supports this optimization.
    //
    // Accumulates all changes made during graph updates.
    // Each change element contains:
    //  changeType - one of the strings: 'add', 'remove' or 'update';
    //  node - if change is related to node this property is set to changed graph's node;
    //  link - if change is related to link this property is set to changed graph's link;
    changes = [], recordLinkChange = noop, recordNodeChange = noop, enterModification = noop, exitModification = noop;
    // this is our public API:
    var graphPart = {
        /**
     * Sometimes duck typing could be slow. Giving clients a hint about data structure
     * via explicit version number here:
     */ version: 20.0,
        /**
     * Adds node to the graph. If node with given id already exists in the graph
     * its data is extended with whatever comes in 'data' argument.
     *
     * @param nodeId the node's identifier. A string or number is preferred.
     * @param [data] additional data for the node being added. If node already
     *   exists its data object is augmented with the new one.
     *
     * @return {node} The newly added node or node with given id if it already exists.
     */ addNode: addNode,
        /**
     * Adds a link to the graph. The function always create a new
     * link between two nodes. If one of the nodes does not exists
     * a new node is created.
     *
     * @param fromId link start node id;
     * @param toId link end node id;
     * @param [data] additional data to be set on the new link;
     *
     * @return {link} The newly created link
     */ addLink: addLink,
        /**
     * Removes link from the graph. If link does not exist does nothing.
     *
     * @param link - object returned by addLink() or getLinks() methods.
     *
     * @returns true if link was removed; false otherwise.
     */ removeLink: removeLink,
        /**
     * Removes node with given id from the graph. If node does not exist in the graph
     * does nothing.
     *
     * @param nodeId node's identifier passed to addNode() function.
     *
     * @returns true if node was removed; false otherwise.
     */ removeNode: removeNode,
        /**
     * Gets node with given identifier. If node does not exist undefined value is returned.
     *
     * @param nodeId requested node identifier;
     *
     * @return {node} in with requested identifier or undefined if no such node exists.
     */ getNode: getNode,
        /**
     * Gets number of nodes in this graph.
     *
     * @return number of nodes in the graph.
     */ getNodeCount: getNodeCount,
        /**
     * Gets total number of links in the graph.
     */ getLinkCount: getLinkCount,
        /**
     * Gets total number of links in the graph.
     */ getEdgeCount: getLinkCount,
        /**
     * Synonym for `getLinkCount()`
     */ getLinksCount: getLinkCount,
        /**
     * Synonym for `getNodeCount()`
     */ getNodesCount: getNodeCount,
        /**
     * Gets all links (inbound and outbound) from the node with given id.
     * If node with given id is not found null is returned.
     *
     * @param nodeId requested node identifier.
     *
     * @return Set of links from and to requested node if such node exists;
     *   otherwise null is returned.
     */ getLinks: getLinks,
        /**
     * Invokes callback on each node of the graph.
     *
     * @param {Function(node)} callback Function to be invoked. The function
     *   is passed one argument: visited node.
     */ forEachNode: forEachNode,
        /**
     * Invokes callback on every linked (adjacent) node to the given one.
     *
     * @param nodeId Identifier of the requested node.
     * @param {Function(node, link)} callback Function to be called on all linked nodes.
     *   The function is passed two parameters: adjacent node and link object itself.
     * @param oriented if true graph treated as oriented.
     */ forEachLinkedNode: forEachLinkedNode,
        /**
     * Enumerates all links in the graph
     *
     * @param {Function(link)} callback Function to be called on all links in the graph.
     *   The function is passed one parameter: graph's link object.
     *
     * Link object contains at least the following fields:
     *  fromId - node id where link starts;
     *  toId - node id where link ends,
     *  data - additional data passed to graph.addLink() method.
     */ forEachLink: forEachLink,
        /**
     * Suspend all notifications about graph changes until
     * endUpdate is called.
     */ beginUpdate: enterModification,
        /**
     * Resumes all notifications about graph changes and fires
     * graph 'changed' event in case there are any pending changes.
     */ endUpdate: exitModification,
        /**
     * Removes all nodes and links from the graph.
     */ clear: clear,
        /**
     * Detects whether there is a link between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     * NOTE: this function is synonym for getLink()
     *
     * @returns link if there is one. null otherwise.
     */ hasLink: getLink,
        /**
     * Detects whether there is a node with given id
     * 
     * Operation complexity is O(1)
     * NOTE: this function is synonym for getNode()
     *
     * @returns node if there is one; Falsy value otherwise.
     */ hasNode: getNode,
        /**
     * Gets an edge between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     *
     * @param {string} fromId link start identifier
     * @param {string} toId link end identifier
     *
     * @returns link if there is one; undefined otherwise.
     */ getLink: getLink
    };
    // this will add `on()` and `fire()` methods.
    (0, $64eddd7ed8bdeee7$export$7ccc53e8f1e7dfc5)(graphPart);
    monitorSubscribers();
    return graphPart;
    function monitorSubscribers() {
        var realOn = graphPart.on;
        // replace real `on` with our temporary on, which will trigger change
        // modification monitoring:
        graphPart.on = on;
        function on() {
            // now it's time to start tracking stuff:
            graphPart.beginUpdate = enterModification = enterModificationReal;
            graphPart.endUpdate = exitModification = exitModificationReal;
            recordLinkChange = recordLinkChangeReal;
            recordNodeChange = recordNodeChangeReal;
            // this will replace current `on` method with real pub/sub from `eventify`.
            graphPart.on = realOn;
            // delegate to real `on` handler:
            return realOn.apply(graphPart, arguments);
        }
    }
    function recordLinkChangeReal(link, changeType) {
        changes.push({
            link: link,
            changeType: changeType
        });
    }
    function recordNodeChangeReal(node, changeType) {
        changes.push({
            node: node,
            changeType: changeType
        });
    }
    function addNode(nodeId, data) {
        if (nodeId === undefined) throw new Error('Invalid node identifier');
        enterModification();
        var node = getNode(nodeId);
        if (!node) {
            node = new $0dd61d98ba46ad83$var$Node(nodeId, data);
            recordNodeChange(node, 'add');
        } else {
            node.data = data;
            recordNodeChange(node, 'update');
        }
        nodes.set(nodeId, node);
        exitModification();
        return node;
    }
    function getNode(nodeId) {
        return nodes.get(nodeId);
    }
    function removeNode(nodeId) {
        var node = getNode(nodeId);
        if (!node) return false;
        enterModification();
        var prevLinks = node.links;
        if (prevLinks) {
            prevLinks.forEach(removeLinkInstance);
            node.links = null;
        }
        nodes.delete(nodeId);
        recordNodeChange(node, 'remove');
        exitModification();
        return true;
    }
    function addLink(fromId, toId, data) {
        enterModification();
        var fromNode = getNode(fromId) || addNode(fromId);
        var toNode = getNode(toId) || addNode(toId);
        var link = createLink(fromId, toId, data);
        var isUpdate = links.has(link.id);
        links.set(link.id, link);
        // TODO: this is not cool. On large graphs potentially would consume more memory.
        $0dd61d98ba46ad83$var$addLinkToNode(fromNode, link);
        if (fromId !== toId) // make sure we are not duplicating links for self-loops
        $0dd61d98ba46ad83$var$addLinkToNode(toNode, link);
        recordLinkChange(link, isUpdate ? 'update' : 'add');
        exitModification();
        return link;
    }
    function createSingleLink(fromId, toId, data) {
        var linkId = $0dd61d98ba46ad83$var$makeLinkId(fromId, toId);
        var prevLink = links.get(linkId);
        if (prevLink) {
            prevLink.data = data;
            return prevLink;
        }
        return new $0dd61d98ba46ad83$var$Link(fromId, toId, data, linkId);
    }
    function createUniqueLink(fromId, toId, data) {
        // TODO: Find a better/faster way to store multigraphs
        var linkId = $0dd61d98ba46ad83$var$makeLinkId(fromId, toId);
        var isMultiEdge = multiEdges.hasOwnProperty(linkId);
        if (isMultiEdge || getLink(fromId, toId)) {
            if (!isMultiEdge) multiEdges[linkId] = 0;
            var suffix = '@' + ++multiEdges[linkId];
            linkId = $0dd61d98ba46ad83$var$makeLinkId(fromId + suffix, toId + suffix);
        }
        return new $0dd61d98ba46ad83$var$Link(fromId, toId, data, linkId);
    }
    function getNodeCount() {
        return nodes.size;
    }
    function getLinkCount() {
        return links.size;
    }
    function getLinks(nodeId) {
        var node = getNode(nodeId);
        return node ? node.links : null;
    }
    function removeLink(link, otherId) {
        if (otherId !== undefined) link = getLink(link, otherId);
        return removeLinkInstance(link);
    }
    function removeLinkInstance(link) {
        if (!link) return false;
        if (!links.get(link.id)) return false;
        enterModification();
        links.delete(link.id);
        var fromNode = getNode(link.fromId);
        var toNode = getNode(link.toId);
        if (fromNode) fromNode.links.delete(link);
        if (toNode) toNode.links.delete(link);
        recordLinkChange(link, 'remove');
        exitModification();
        return true;
    }
    function getLink(fromNodeId, toNodeId) {
        if (fromNodeId === undefined || toNodeId === undefined) return undefined;
        return links.get($0dd61d98ba46ad83$var$makeLinkId(fromNodeId, toNodeId));
    }
    function clear() {
        enterModification();
        forEachNode(function(node) {
            removeNode(node.id);
        });
        exitModification();
    }
    function forEachLink(callback) {
        if (typeof callback === 'function') {
            var valuesIterator = links.values();
            var nextValue = valuesIterator.next();
            while(!nextValue.done){
                if (callback(nextValue.value)) return true; // client doesn't want to proceed. Return.
                nextValue = valuesIterator.next();
            }
        }
    }
    function forEachLinkedNode(nodeId, callback, oriented) {
        var node = getNode(nodeId);
        if (node && node.links && typeof callback === 'function') {
            if (oriented) return forEachOrientedLink(node.links, nodeId, callback);
            else return forEachNonOrientedLink(node.links, nodeId, callback);
        }
    }
    // eslint-disable-next-line no-shadow
    function forEachNonOrientedLink(links, nodeId, callback) {
        var quitFast;
        var valuesIterator = links.values();
        var nextValue = valuesIterator.next();
        while(!nextValue.done){
            var link = nextValue.value;
            var linkedNodeId = link.fromId === nodeId ? link.toId : link.fromId;
            quitFast = callback(nodes.get(linkedNodeId), link);
            if (quitFast) return true; // Client does not need more iterations. Break now.
            nextValue = valuesIterator.next();
        }
    }
    // eslint-disable-next-line no-shadow
    function forEachOrientedLink(links, nodeId, callback) {
        var quitFast;
        var valuesIterator = links.values();
        var nextValue = valuesIterator.next();
        while(!nextValue.done){
            var link = nextValue.value;
            if (link.fromId === nodeId) {
                quitFast = callback(nodes.get(link.toId), link);
                if (quitFast) return true; // Client does not need more iterations. Break now.
            }
            nextValue = valuesIterator.next();
        }
    }
    // we will not fire anything until users of this library explicitly call `on()`
    // method.
    function noop() {}
    // Enter, Exit modification allows bulk graph updates without firing events.
    function enterModificationReal() {
        suspendEvents += 1;
    }
    function exitModificationReal() {
        suspendEvents -= 1;
        if (suspendEvents === 0 && changes.length > 0) {
            graphPart.fire('changed', changes);
            changes.length = 0;
        }
    }
    function forEachNode(callback) {
        if (typeof callback !== 'function') throw new Error('Function is expected to iterate over graph nodes. You passed ' + callback);
        var valuesIterator = nodes.values();
        var nextValue = valuesIterator.next();
        while(!nextValue.done){
            if (callback(nextValue.value)) return true; // client doesn't want to proceed. Return.
            nextValue = valuesIterator.next();
        }
    }
}
/**
 * Internal structure to represent node;
 */ function $0dd61d98ba46ad83$var$Node(id, data) {
    this.id = id;
    this.links = null;
    this.data = data;
}
function $0dd61d98ba46ad83$var$addLinkToNode(node, link) {
    if (node.links) node.links.add(link);
    else node.links = new Set([
        link
    ]);
}
/**
 * Internal structure to represent links;
 */ function $0dd61d98ba46ad83$var$Link(fromId, toId, data, id) {
    this.fromId = fromId;
    this.toId = toId;
    this.data = data;
    this.id = id;
}
function $0dd61d98ba46ad83$var$makeLinkId(fromId, toId) {
    return fromId.toString() + "\uD83D\uDC49 " + toId.toString();
}
var $0dd61d98ba46ad83$export$2e2bcd8739ae039 = $0dd61d98ba46ad83$var$ngraph_graph;



var $d5a70d093dd6853c$var$routemap = {
    neo: {
        node (o) {
            return {
                id: 'elementId',
                a: 'toid',
                b: 'fromid'
            };
        },
        edge () {}
    }
};
var $d5a70d093dd6853c$export$2e2bcd8739ae039 = {
    fields (originin) {}
};


class $c65b92b1e8691885$export$b57773e9f9a0fc72 extends EventTarget {
    // ORIGIN MATRIX PARAMS COULD BE ROUTES FOR THIS ORIGIN: 
    constructor(obj = {
        origin: ''
    }){
        super();
        this.extractors = {
            neo: {
                node (o) {},
                edge (o) {}
            },
            keycache: {
                node (o) {}
            }
        };
        this.resetMap();
        this.nodes;
        this.links;
        this.nodes_by_uuid = {};
        this.links_by_uuid = {};
        this.links_by_ab = {};
    }
    // Start New Map();
    resetMap(map_in = {
        nodes: [],
        links: [],
        meta: {
            origin: 'general',
            foreign_id_name: 'elementId'
        }
    }) {
        this.graph = (0, $0dd61d98ba46ad83$export$2e2bcd8739ae039)();
        this.nodes = new Map();
        this.links = new Map();
        this.meta = {
            layouts: {}
        };
        this.link_foreign_to_slot = {};
        this.node_foreign_to_slot = {};
        this.nodes_by_uuid = {};
        this.links_by_uuid = {};
        this.links_by_ab = {};
        this.mergeMap(map_in);
    }
    appendMap(map_in) {
        // CONCAT LAYOUTS ONE BY ONE
        // KEEP CURRENT POSITION FOR EXISTING 
        // LATER: 
        // USE CASE TWO MAPS WITH DIFFERENT SLOTS HAVE THE SAME UNDERLYING NODE
        // TWO LAYOUTS WITH DIFFERENT SLOTS ARE POINTING TO SAME NODE 
        // how would "same node be identified , same origin plus same ID ? "
        // ALSO GLOBAL COLLECTION WITH REUSABLE OBJECTS CREATED 
        if (map_in.nodes) this.nodes = $dd6c36accdb121d6$export$942c543eb03edfbd(this.nodes, map_in.nodes);
        if (map_in.links) this.links = $dd6c36accdb121d6$export$bca7207b99358270(this.links, map_in.links);
        if (map_in.meta) this.meta.layouts = $dd6c36accdb121d6$export$633a080005861476(this.meta.layouts, map_in.meta.layouts);
        var e = 3;
    }
    incomingFromAuxFeeds(diff_in = {}) {
    // price Feeds + data streams
    // routed by symnol + function xclass + label 
    // scam local slots for incomingdomains
    ///////////////////////////////////////
    // later create cache index 
    ////////////////////////////////////
    }
    extractNodeKeycache(o) {
        var outX;
        // flatten properties into payload
        if (o.slot && o.payload) {
            outX = o;
            outX.type = 'object';
        } else outX = {
            origin: 'neo',
            slot: $f88ac7a2e1f41a9d$export$abe4376e1bf796d6(),
            type: 'object',
            payload: o
        };
        return outX;
    }
    transformExtract(map_in = {
        nodes: [],
        links: [],
        meta: {}
    }) {
        this.extractors[map_in.meta.origin](map_in);
    }
    incomingDiffWithMetadata(map_in = {
        nodes: [],
        links: [],
        meta: {}
    }) {
        var structuredDiff = this.transformExtract(map_in);
    }
    incomingDiffFromKeyCache(map_in = {
        nodes: [],
        links: [],
        meta: {}
    }) {
        // u are here 
        // this is wrecking llm saved nodes 
        var diff_out = {
            nodes: [],
            links: [],
            meta: {}
        };
        for(var ni in map_in.nodes){
            // for every incoming neo node check if it exists by UUID merge payload if it does, create new if not 
            var inObj = map_in.nodes[ni];
            if (!inObj.payload) inObj.payload = {
                ...inObj
            };
            var uuiidd = inObj.payload ? inObj.payload.uuid : inObj.uuid;
            var existingNode = this.getNodeByForeignKey('uuid', uuiidd);
            if (existingNode) existingNode.payload = inObj.payload;
            else {
                existingNode = this.extractNodeKeycache(inObj);
                this.nodes.set(existingNode.slot, existingNode);
                this.node_foreign_to_slot[existingNode.payload['uuid']] = existingNode.slot;
            }
            diff_out.nodes.push(existingNode);
        }
        for(var li in map_in.links){
            var liObj = map_in.links[li];
            if (!liObj.payload) liObj.payload = liObj.data;
            //var existingLink = this.getOrCreateLinkByForeignKey( 'uuid' , liObj.payload.uuid , liObj );
            var uuiidd = liObj.payload ? liObj.payload.uuid : liObj.data ? liObj.data.uuid : liObj.uuid;
            var existingLink = liObj; // this.getLinkByForeignKey( 'uuid' ,  uuiidd )
            if (existingLink) ;
            else existingLink = this.extractLinkKeycache(liObj);
            this.links.set([
                existingLink.slota,
                existingLink.slotb
            ], existingLink);
            diff_out.links.push(existingLink);
        }
        diff_out.meta = map_in.meta;
        // merge nodes by uuid 
        this.dispatchEvent(new CustomEvent('freshDiffEvent', {
            detail: diff_out
        }));
    }
    incomingDiffFromExtractor(map_in = {
        nodes: [],
        links: [],
        meta: {}
    }) {
        var diff_out = {
            nodes: [],
            links: [],
            meta: {}
        };
        // iter nodes, check if elementId /uuid exists in mem
        for(var ni in map_in.nodes){
            // for every incoming neo node check if it exists by UUID merge payload if it does, create new if not 
            var payloadIn = this.extractNodeNeo(map_in.nodes[ni]).payload;
            var prepayload = payloadIn; /// { ...o , ...o.properties }
            var origin = 'extractor';
            delete prepayload.properties;
            var x = {
                origin: origin,
                slot: origin + '_' + prepayload.uuid,
                type: 'object',
                payload: prepayload
            };
            //return x;           
            var existingNode = x; //  this.extractNodeNeo( payloadIn )  
            diff_out.nodes.push(existingNode);
        }
        for(var li in map_in.links){
            var liObj = map_in.links[li];
            //var existingLink = this.extractLinkNeo( liObj );
            var x = {
                origin: 'neo',
                slota: 'neo_' + liObj.uuid,
                slotb: 'neo_' + liObj.uuid,
                type: liObj.type,
                payload: liObj
            };
            diff_out.links.push(x);
        }
        diff_out.meta = 'meta' in map_in ? map_in.meta : {};
        // merge nodes by uuid 
        this.dispatchEvent(new CustomEvent('freshDiffEvent', {
            detail: diff_out
        }));
    }
    incomingDiffFromOai(map_in = {
        nodes: [],
        links: [],
        meta: {}
    }) {
        // YOU ARE HERE HOW DO YOu MAP DIFFERENT KEYS from
        // varied responses to local 
        var f = 3;
        var diff_out = {
            nodes: [],
            links: [],
            meta: {}
        };
        for(var ni in map_in.nodes){
            // for every incoming neo node check if it exists by UUID merge payload if it does, create new if not 
            var payloadIn = map_in.nodes[ni];
            //var prepayload= payloadIn; /// { ...o , ...o.properties }
            var origin = 'oai';
            payloadIn.label = 'tag';
            payloadIn.uuid = origin + '_' + payloadIn.name + 'o';
            var x = {
                origin: origin,
                slot: payloadIn.id,
                type: 'object',
                payload: payloadIn
            };
            //return x;           
            var existingNode = x; //  this.extractNodeNeo( payloadIn )  
            diff_out.nodes.push(existingNode);
        }
        for(var li in map_in.links){
            var liObj = map_in.links[li];
            var existingLink = {};
            existingLink.name = 'lnk';
            existingLink.slota = liObj.source;
            existingLink.slotb = liObj.target;
            existingLink.payload = {
                label: liObj.type
            };
            diff_out.links.push(existingLink);
        }
        this.dispatchEvent(new CustomEvent('freshDiffEvent', {
            detail: diff_out
        }));
    }
    updateCache(nodes_in, links_in) {
        for (let node of nodes_in)if (node && node.slot) this.nodes_by_uuid[node.slot] = node;
        for (let link of links_in)if (link && link.slota && link.slotb) this.links_by_ab[link.slota, link.slotb] = link;
    }
    getCache() {
        var node_list = [];
        var link_list = [];
        for(let n in this.nodes_by_uuid){
            let node = this.nodes_by_uuid[n];
            node_list.push(node.payload);
        }
        for(let l in this.links_by_ab){
            let link = this.links_by_ab[l];
            link_list.push(link.payload);
        }
        return {
            nodes: node_list,
            links: link_list
        };
    }
    incomingDiffFromGeneric(map_in = {
        nodes: [],
        links: [],
        meta: {}
    }) {
        // YOU ARE HERE 
        // LOGGED IN: 
        // LOADING DATA FROM REMOTE AI 
        // Now just map the remote ai nodes and edges to internal : 
        var map_in_temp = map_in;
        map_in = {
            nodes: map_in_temp['payload']['nodes'],
            links: map_in_temp['payload']['edges'],
            meta: {
                type: "query",
                source: "glad"
            }
        };
        var f = 3;
        var diff_out = {
            nodes: [],
            links: [],
            meta: {}
        };
        function shrink(nin) {
            // here strip drop all spaces and special characters from nin adn return
            if (typeof nin === 'string') return nin.replace(/[^a-zA-Z0-9]/g, '');
            return nin;
        }
        var ids_to_uuids = {};
        for(var ni in map_in.nodes){
            // for every incoming neo node check if it exists by UUID merge payload if it does, create new if not 
            var payloadIn = map_in.nodes[ni];
            //var prepayload= payloadIn; /// { ...o , ...o.properties }
            var origin = 'oai';
            payloadIn.label = 'tag';
            payloadIn.uuid = origin + '_' + shrink(payloadIn.name) + '_oid'; //+payloadIn.id
            ids_to_uuids[payloadIn.id] = payloadIn.uuid;
            var contained_node = {
                origin: origin,
                slot: payloadIn.uuid,
                type: 'object',
                payload: payloadIn
            };
            var x = contained_node; //  this.extractNodeNeo( payloadIn )  
            diff_out.nodes.push(contained_node);
        }
        for(var li in map_in.links){
            var liObj = map_in.links[li];
            var existingLink = {};
            existingLink.name = 'lnk';
            // you are here 
            // the a and be need to be 
            // converted from id to derived_uuid 
            existingLink.slota = ids_to_uuids[liObj.from];
            existingLink.slotb = ids_to_uuids[liObj.to];
            existingLink.payload = liObj;
            diff_out.links.push(existingLink);
        }
        this.updateCache(diff_out.nodes, diff_out.links);
        this.dispatchEvent(new CustomEvent('freshDiffEvent', {
            detail: diff_out
        }));
    }
    incomingDiffFromNeo(map_in = {
        nodes: [],
        links: [],
        meta: {}
    }) {
        var diff_out = {
            nodes: [],
            links: [],
            meta: {}
        };
        // iter nodes, check if elementId /uuid exists in mem
        for(var ni in map_in.nodes){
            // for every incoming neo node check if it exists by UUID merge payload if it does, create new if not 
            var payloadIn = this.extractNodeNeo(map_in.nodes[ni]).payload;
            var existingNode = this.extractNodeNeo(payloadIn);
            diff_out.nodes.push(existingNode);
        }
        for(var li in map_in.links){
            var liObj = map_in.links[li];
            var existingLink = this.extractLinkNeo(liObj);
            diff_out.links.push(existingLink);
        }
        diff_out.meta = map_in.meta;
        // merge nodes by uuid 
        this.dispatchEvent(new CustomEvent('freshDiffEvent', {
            detail: diff_out
        }));
    }
    incomingDiffFromNeo_DualDiff(map_in = {
        nodes: [],
        links: [],
        meta: {}
    }) {
        var diff_out = {
            nodes: [],
            links: [],
            meta: {}
        };
        // iter nodes, check if elementId /uuid exists in mem
        for(var ni in map_in.nodes){
            // for every incoming neo node check if it exists by UUID merge payload if it does, create new if not 
            var payloadIn = this.extractNodeNeo(map_in.nodes[ni]).payload;
            var existingNode;
            // in objs from neo will always have elementID  but local in Mem
            existingNode = this.getNodeByForeignKey('uuid', payloadIn.uuid);
            if (existingNode) {
                existingNode.payload = {
                    ...existingNode.payload,
                    ...payloadIn
                };
                diff_out.nodes.push(existingNode);
            } else {
                existingNode = this.extractNodeNeo(payloadIn);
                this.nodes.set(existingNode.slot, existingNode);
                this.node_foreign_to_slot[existingNode.payload['elementId']] = existingNode.slot;
            }
            diff_out.nodes.push(existingNode);
        }
        for(var li in map_in.links){
            var liObj = map_in.links[li];
            //var existingLink = this.getOrCreateLinkByForeignKey( 'uuid' , liObj.properties.uuid , liObj );
            //var existingLink = this.getLinkByForeignKeys( 'elementId'  , liObj.startNodeElementId , liObj.endNodeElementId  )
            // GET OR CREATE LINK BY Elid 
            var slota = this.node_foreign_to_slot[liObj.startNodeElementId];
            var slotb = this.node_foreign_to_slot[liObj.endNodeElementId];
            var existingLink = this.links.get([
                slota,
                slotb
            ]);
            if (existingLink) existingLink.payload = liObj;
            else {
                existingLink = this.extractLinkNeo(liObj);
                this.links.set([
                    existingLink.slota,
                    existingLink.slotb
                ], existingLink);
            }
            diff_out.links.push(existingLink);
        }
        diff_out.meta = map_in.meta;
        // merge nodes by uuid 
        this.dispatchEvent(new CustomEvent('freshDiffEvent', {
            detail: diff_out
        }));
    }
    // EXTRACTORS  FIRST WAVE 
    extractNodeNeo(o) {
        // flatten properties into payload
        var prepayload = {
            ...o,
            ...o.properties
        };
        var origin = 'neo';
        delete prepayload.properties;
        var x = {
            origin: origin,
            slot: origin + '_' + prepayload.elementId,
            type: 'object',
            payload: prepayload
        };
        return x;
    }
    extractLinkNeo(o) {
        var x = {
            origin: 'neo',
            slota: 'neo_' + o.startNodeElementId,
            slotb: 'neo_' + o.endNodeElementId,
            type: o.type,
            payload: o
        };
        return x;
    }
    extractLinkNeoList(o) {
        var x = {
            origin: 'neo',
            slota: this.node_foreign_to_slot[o.startNodeElementId],
            slotb: this.node_foreign_to_slot[o.endNodeElementId],
            type: o.type,
            payload: o
        };
        return x;
    }
    extractLinkKeycache(o) {
        var x = o;
        if (!o.slota && o.a) o.slota = o.a;
        if (!o.slotb && o.b) o.slotb = o.b;
        x.type = o.type ? o.type : 'added';
        x.origin = 'internal';
        return x;
    }
    transformEdgeToNeo(diffIn) {
        // check for slot a and slot b 
        // find Object A and B 
        // check if A and B have element ID 
        // formulate sabric with 
        var obj = diffIn.params;
        //var node_a = this.nodes.get( obj.a )
        //var node_b = this.nodes.get( obj.b )
        //var a_elId = node_a.payload.elementId;
        //var b_elId = node_b.payload.elementId;
        var props = obj.payload;
        var l_type = obj.type;
        var c = 0;
        // check if exists //:
        return {
            startElementId: obj.startElementId,
            endElementId: obj.endElementId,
            type: l_type,
            properties: props
        };
    }
    spawnInsertObjectType(type_in) {
        var props = (0, $440781629901dd2f$export$2e2bcd8739ae039).xclass_props(type_in);
        props['uuid'] = $f88ac7a2e1f41a9d$export$abe4376e1bf796d6();
        var origin = 'internal';
        // MERGE 
        //var payload = { labels:[type_in] , properties:props }
        var payload = {
            labels: [
                type_in
            ],
            ...props
        };
        var final_obj = {
            origin: origin,
            slot: origin + '_' + payload.uuid,
            type: 'object',
            payload: payload
        };
        this.appendDiff({
            nodes: [
                final_obj
            ]
        });
        var r = 3;
    }
    appendDiff(map_in = {
        nodes: [],
        links: [],
        meta: {}
    }) {
        // this should iterate incoming nodes 
        // check origin for each node , get ID per origin 
        // merge into existing slot by origin id or temp iD ?
        // use case: push freshNode  push neoMerged
        var diff_out = {};
        if (map_in.nodes) this.nodes = $dd6c36accdb121d6$export$942c543eb03edfbd(this.nodes, map_in.nodes);
        diff_out.nodes = map_in.nodes;
        if (map_in.links) this.links = $dd6c36accdb121d6$export$bca7207b99358270(this.links, map_in.links);
        if (map_in.meta) this.meta.layouts = $dd6c36accdb121d6$export$633a080005861476(this.meta.layouts, map_in.meta.layouts);
        var e = 3;
        this.dispatchEvent(new CustomEvent('freshDiffEvent', {
            detail: diff_out
        }));
    }
    pushDiff(map_in = {
        nodes: [],
        links: [],
        meta: {}
    }) {
        // this should iterate incoming nodes 
        // check origin for each node , get ID per origin 
        // merge into existing slot by origin id or temp iD ?
        // use case: push freshNode  push neoMerged
        if (map_in.nodes) for(var n in map_in.nodes)getNodeByForeignKey(foreign_name_in, id_in);
        this.tryMergeByUUID();
        this.nodes = $dd6c36accdb121d6$export$942c543eb03edfbd(this.nodes, map_in.nodes);
        if (map_in.links) this.links = $dd6c36accdb121d6$export$bca7207b99358270(this.links, map_in.links);
        if (map_in.meta) this.meta.layouts = $dd6c36accdb121d6$export$633a080005861476(this.meta.layouts, map_in.meta.layouts);
        var e = 3;
    }
    tryMergeByUUID() {
        for(var n in this.nodes);
    }
    unwrapExtract(obj) {}
    mergeDiff(map_in = {
        nodes: [],
        links: [],
        meta: {
            origin: 'general',
            foreign_id_name: 'elementId'
        }
    }) {}
    // THIS SHOULD MERGE FOREIGN SCHEMAS AND NORMALIZE ALL NODES AND LINKS TO SLOTS 
    mergeMap(map_in = {
        nodes: [],
        links: [],
        meta: {
            origin: 'general',
            foreign_id_name: 'elementId'
        }
    }) {
        console.log('scanning incoming n');
        var foreign_id_name = map_in.meta.foreign_id;
        var foreign_a_name = map_in.meta.foreign_a;
        var foreign_b_name = map_in.meta.foreign_b;
        var diff_nodes = {};
        var diff_links = {};
        var diff_meta = {};
        // RUN THROUGH INCOMINB NODES AND CHECK IF EACH INCOMIN 
        // FOREIGN_ID ALREADY EXISTS IN SLOT 
        // USE EXISTING SLOT IF ALREADY LOADED INSERT IF NOT 
        for(var i in map_in.nodes){
            var n = map_in.nodes[i];
            var foreign_id = n[foreign_id_name];
            var existing_object = this.getNodeByForeignId(foreign_id_name, foreign_id);
            if (!existing_object) {
                var new_slot = $f88ac7a2e1f41a9d$export$abe4376e1bf796d6();
                var new_node = {
                    origin: map_in.meta.origin,
                    slot: new_slot,
                    //uuid:new_slot ,
                    payload: n
                };
                this.nodes.set(new_slot, new_node);
                existing_object = this.nodes.get(new_slot);
                diff_nodes[new_slot] = existing_object;
            }
            //console.log(' scanning incoming nodes: ', foreign_id_name , foreign_id , existing_object.slot );
            this.node_foreign_to_slot[foreign_id] = existing_object.slot;
        }
        // SCAN INCOMING RELATIONSHIPS AND MAP INCOMING FOREIGN_IDS TO EXISTING SLOTS 
        // THEN MAP 
        for(var i in map_in.links){
            var l = map_in.links[i];
            var foreign_id = l[foreign_id_name];
            var existing_object = this.getLinkByForeignKey(foreign_id_name, foreign_id);
            if (!existing_object) {
                var new_slot = $f88ac7a2e1f41a9d$export$abe4376e1bf796d6();
                var new_link = {
                    origin: map_in.meta.origin,
                    slot: new_slot,
                    //uuid:new_slot ,
                    slota: this.node_foreign_to_slot[l[foreign_a_name]],
                    slotb: this.node_foreign_to_slot[l[foreign_b_name]],
                    payload: l
                };
                this.links.set(new_slot, new_link);
                existing_object = this.links.get(new_slot);
                diff_links[new_slot] = existing_object;
            }
            //console.log(' scanning incoming nodes: ', foreign_id_name , foreign_id , existing_object.slot );
            this.link_foreign_to_slot[foreign_id] = existing_object.slot;
        }
        // MERGE LAYOUTS:
        if ('layouts' in map_in.meta) // GO THROUGH EVERY INCOMING LAYOUT 
        for(var l in map_in.meta.layouts){
            var lyt_in = map_in.meta.layouts[l];
            // CONVERT FOREIGN IDS TO SLOTS 
            // var remapped_layout_in = {}
            // for( var nd in lyt_in ){    
            //     if(  this.node_foreign_to_slot[ nd ]   ){
            //         remapped_layout_in[ this.node_foreign_to_slot[ nd ] ]=lyt_in[ nd ];
            //     } 
            // }  
            // MERGE
            if (!this.meta.layouts[l]) this.meta.layouts[l] = {};
            this.meta.layouts[l] = {
                ...this.meta.layouts[l],
                ...lyt_in
            };
        }
        var object_emitter;
        return {
            nodes: diff_nodes,
            links: diff_links
        };
    // AFTER MERGE DISPATCH  
    //this.dispatchEvent( new CustomEvent('freshDataEvent', { detail: {model:this } } ) )  
    // in future this dispatch can be batched with timeout 
    }
    // THIS SHOULD MERGE FOREIGN SCHEMAS AND NORMALIZE ALL NODES AND LINKS TO SLOTS 
    mergeMapOg(map_in = {
        nodes: [],
        links: [],
        meta: {
            origin: 'general',
            foreign_id_name: 'elementId'
        }
    }) {
        console.log('scanning incoming n');
        var foreign_id_name = map_in.meta.foreign_id;
        var foreign_a_name = map_in.meta.foreign_a;
        var foreign_b_name = map_in.meta.foreign_b;
        // RUN THROUGH INCOMINB NODES AND CHECK IF EACH INCOMIN 
        // FOREIGN_ID ALREADY EXISTS IN SLOT 
        // USE EXISTING SLOT IF ALREADY LOADED INSERT IF NOT 
        for(var i in map_in.nodes){
            var n = map_in.nodes[i];
            var foreign_id = n[foreign_id_name];
            var existing_object = this.getNodeByForeignId(foreign_id_name, foreign_id);
            if (!existing_object) {
                var new_slot = $f88ac7a2e1f41a9d$export$abe4376e1bf796d6();
                var new_node = {
                    origin: map_in.meta.origin,
                    slot: new_slot,
                    //uuid:new_slot ,
                    payload: n
                };
                this.nodes.set(new_slot, new_node);
                existing_object = this.nodes.get(new_slot);
            }
            //console.log(' scanning incoming nodes: ', foreign_id_name , foreign_id , existing_object.slot );
            this.node_foreign_to_slot[foreign_id] = existing_object.slot;
        }
        // SCAN INCOMING RELATIONSHIPS AND MAP INCOMING FOREIGN_IDS TO EXISTING SLOTS 
        // THEN MAP 
        for(var i in map_in.links){
            var l = map_in.links[i];
            var foreign_id = l[foreign_id_name];
            var existing_object = this.getLinkByForeignId(foreign_id_name, foreign_id);
            if (!existing_object) {
                var new_slot = $f88ac7a2e1f41a9d$export$abe4376e1bf796d6();
                var new_link = {
                    origin: map_in.meta.origin,
                    slot: new_slot,
                    //uuid:new_slot ,
                    slota: this.node_foreign_to_slot[l[foreign_a_name]],
                    slotb: this.node_foreign_to_slot[l[foreign_b_name]],
                    payload: l
                };
                this.links.set(new_slot, new_link);
                existing_object = this.links.get(new_slot);
            }
            //console.log(' scanning incoming nodes: ', foreign_id_name , foreign_id , existing_object.slot );
            this.link_foreign_to_slot[foreign_id] = existing_object.slot;
        }
        // MERGE LAYOUTS:
        if ('layouts' in map_in.meta) // GO THROUGH EVERY INCOMING LAYOUT 
        for(var l in map_in.meta.layouts){
            var lyt_in = map_in.meta.layouts[l];
            // CONVERT FOREIGN IDS TO SLOTS 
            // var remapped_layout_in = {}
            // for( var nd in lyt_in ){    
            //     if(  this.node_foreign_to_slot[ nd ]   ){
            //         remapped_layout_in[ this.node_foreign_to_slot[ nd ] ]=lyt_in[ nd ];
            //     } 
            // }  
            // MERGE
            if (!this.meta.layouts[l]) this.meta.layouts[l] = {};
            this.meta.layouts[l] = {
                ...this.meta.layouts[l],
                ...lyt_in
            };
        }
        var object_emitter = '';
    // AFTER MERGE DISPATCH  
    //this.dispatchEvent( new CustomEvent('freshDataEvent', { detail: {model:this } } ) )  
    // in future this dispatch can be batched with timeout 
    }
    // THIS SHOULD MERGE FOREIGN SCHEMAS AND NORMALIZE ALL NODES AND LINKS TO SLOTS 
    transformMap(map_in = {
        nodes: [],
        links: [],
        meta: {
            origin: 'general',
            foreign_id_name: 'elementId'
        }
    }) {
        console.log('scanning incoming n');
        var foreign_id_name = map_in.meta.foreign_id;
        var foreign_a_name = map_in.meta.foreign_a;
        var foreign_b_name = map_in.meta.foreign_b;
        var diff_nodes = {};
        var diff_links = {};
        var diff_meta = {};
        // RUN THROUGH INCOMINB NODES AND CHECK IF EACH INCOMIN 
        // FOREIGN_ID ALREADY EXISTS IN SLOT 
        // USE EXISTING SLOT IF ALREADY LOADED INSERT IF NOT 
        for(var i in map_in.nodes){
            var n = map_in.nodes[i];
            var foreign_id = n[foreign_id_name];
            var existing_object = this.getNodeByForeignId(foreign_id_name, foreign_id);
            if (!existing_object) {
                var new_slot = $f88ac7a2e1f41a9d$export$abe4376e1bf796d6();
                var new_node = {
                    origin: map_in.meta.origin,
                    slot: new_slot,
                    //uuid:new_slot ,
                    payload: n
                };
                diff_nodes[new_slot] = new_node;
                existing_object = diff_nodes[new_slot];
            }
            //console.log(' scanning incoming nodes: ', foreign_id_name , foreign_id , existing_object.slot );
            this.node_foreign_to_slot[foreign_id] = existing_object.slot;
        }
        // SCAN INCOMING RELATIONSHIPS AND MAP 
        // INCOMING FOREIGN_IDS TO EXISTING SLOTS 
        // THEN MAP 
        for(var i in map_in.links){
            var l = map_in.links[i];
            var foreign_id = l[foreign_id_name];
            var existing_object = this.getLinkByForeignId(foreign_id_name, foreign_id);
            if (!existing_object) {
                var new_slot = $f88ac7a2e1f41a9d$export$abe4376e1bf796d6();
                var new_link = {
                    origin: map_in.meta.origin,
                    slot: new_slot,
                    //uuid:new_slot ,
                    slota: this.node_foreign_to_slot[l[foreign_a_name]],
                    slotb: this.node_foreign_to_slot[l[foreign_b_name]],
                    payload: l
                };
                diff_links[new_slot] = new_link;
                existing_object = diff_links[new_slot];
            }
            //console.log(' scanning incoming nodes: ', foreign_id_name , foreign_id , existing_object.slot );
            this.link_foreign_to_slot[foreign_id] = existing_object.slot;
        }
        // MERGE LAYOUTS:
        if ('layouts' in map_in.meta) // GO THROUGH EVERY INCOMING LAYOUT 
        for(var l in map_in.meta.layouts){
            var lyt_in = map_in.meta.layouts[l];
            // CONVERT FOREIGN IDS TO SLOTS 
            // var remapped_layout_in = {}
            // for( var nd in lyt_in ){    
            //     if(  this.node_foreign_to_slot[ nd ]   ){
            //         remapped_layout_in[ this.node_foreign_to_slot[ nd ] ]=lyt_in[ nd ];
            //     } 
            // }  
            // MERGE
            if (!this.meta.layouts[l]) this.meta.layouts[l] = {};
            this.meta.layouts[l] = {
                ...this.meta.layouts[l],
                ...lyt_in
            };
        }
        var object_emitter = '';
        // AFTER MERGE DISPATCH  
        //this.dispatchEvent( new CustomEvent('freshDataEvent', { detail: {model:this } } ) )  
        // in future this dispatch can be batched with timeout 
        return {
            nodes: diff_nodes,
            links: diff_links
        };
    }
    getMap() {
        // map slot to uuid 
        return {
            meta: {
                origin: 'int',
                name: 'merged',
                layouts: this.meta.layouts
            },
            nodes: Object.fromEntries(this.nodes.entries()),
            links: Object.fromEntries(this.links.entries())
        };
    }
    getNode(slot) {
        return this.nodes.get(slot);
    }
    // AUTO CREATE 
    getOrCreateNodeByForeignKey(foreign_name_in1, id_in1, obj) {
        var existingNode = this.getNodeByForeignKey(foreign_name_in1, id_in1);
        if (existingNode) existingNode.payload = {
            ...existingNode.payload,
            ...obj
        };
        else existingNode = this.extractNodeNeo(obj);
        this.nodes.set(existingNode.slot, existingNode);
        this.node_foreign_to_slot[existingNode.payload[foreign_name_in1]] = existingNode.slot;
        return existingNode;
    }
    getOrCreateLinkByForeignKey(foreign_name_in1, id_in1, obj) {
        var existingLink = this.getLinkByForeignKey(foreign_name_in1, id_in1);
        if (existingLink) existingLink.payload = obj;
        else existingLink = this.extractLinkNeo(obj);
        this.links.set([
            existingLink.slota,
            existingLink.slotb
        ], existingLink);
        return existingLink;
    }
    // FIND NODE BY KEY
    getNodeByForeignKey(foreign_name_in1, id_in1) {
        var existing = false;
        for (var [k, n] of this.nodes)if (n.payload && n.payload[foreign_name_in1] == id_in1) {
            existing = n;
            break;
        } else var f = 0;
        return existing;
    }
    // FIND FOREIGN LINK 
    getLinkByForeignKey(foreign_name_in1, id_in1) {
        var existing = false;
        for (var [k, n] of this.links)if (n.payload[foreign_name_in1] == id_in1) {
            existing = n;
            break;
        } else var f = 0;
        return existing;
    }
    getLinkByForeignKeys(foreign_name_in1, id1, id2) {
        var existing = false;
        var slota = this.node_foreign_to_slot[id1];
        var slotb = this.node_foreign_to_slot[id2];
        var link = this.links.get([
            slota,
            slotb
        ]);
        if (link) existing = link;
        else var f = 0;
        return existing;
    }
    // SHOW ALL MAPPINGS 
    printInventory() {
        console.log('MATRIX: \n');
        console.log('NODES: ');
        for (var [k, o] of this.nodes);
        console.log('LINKS: ');
        for (var [k, o] of this.links);
    }
}
 ////// EXAMPS 
 // this.nodes.set( '0x2av8a8v00711', {
 //         origin:'int',
 //         slot:'0x2av8a8v00711',
 //         payload:{
 //             id:'2323',
 //             name:'fsfjd'
 //         }
 //     });
 // this.nodes.set('0x1a2b3c4d5f0a3d',{
 //         origin:'int',
 //         slot:'0x1a2b3c4d5f0a3d',
 //         payload:{
 //             elementId:'0x1a2b3c4d5f0a3d',
 //             id:'1112323',
 //             name:'a3b3c2e5',
 //             a:'uuid-v3-'
 //         }
 //     });      
 // SHOULD THIS BE IN META ? 
 // this.identity_router = {
 //     neo:{
 //         foreign_id:'elementId'
 //     },
 //     internal:{
 //         foreign_id:'uuid'
 //     }
 // }
 //         this.origins = {
 //     'neo':'https' 
 // }
 // wrapMergeNode( obj , origin='internal' , uuid= ids.uuidv4() ){
 //     if( ! uuid ){ }
 //     // find  origin  e.g.  NEO /  Keycache  / Local / Created 
 //     var n = this.nodes;
 // }
 // addOrigin( obj ){
 // }
 // wrapMergeNodes( nodes , origin='general' , id_key = false ){
 //     for( var n of nodes ){
 //         var origin_id = n[ id_key ]; // extrinsic 
 //         //var origin_id = ids.uuidv4;    // intrinsic 
 //         this.nodes.push( { origin , uuid:origin_id , payload:n } )
 //     }
 // }
 //var nodes = map.nodes;
 //var links = map.links; 
 //var meta = map.meta; 
 // finds existing nodes by their internal primary mapping 
 // then it uses existing UUID 
 //for( var n of map.nodes ){
 // var origin_id = n[ id_key ]; // extrinsic 
 //var origin_id = ids.uuidv4();    // intrinsic 
 //this.nodes.push( { origin , uuid:origin_id , payload:n } )
 //}




async function $61abcf8bc5f450ed$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}



var $hPtJY = parcelRequire("hPtJY");


class $14b973211f4cd758$var$SessionModel extends EventTarget {
    constructor(initObj){
        super();
        // SESSION
        this.session = {
            state: 0,
            state_change: 'start',
            selected_object: false,
            navstate: {},
            genesis_object: {},
            display: '',
            file: 0,
            urlks: {},
            panels_open: false
        };
        // KEYCACHE
        this.keycache = new (0, $ed871e0b99fd3eca$export$2e2bcd8739ae039)({});
        this.keycache.set_imkey('blank', 'blank');
        // ORIGIN MATRIX
        this.matrix = new (0, $c65b92b1e8691885$export$b57773e9f9a0fc72)({});
        this.matrix.addEventListener('freshDiffEvent', (function(e) {
            console.log('fresh  *  *  * ');
            this.dispatchEvent(new CustomEvent('freshDataEvent', {
                detail: e.detail
            }));
        }).bind(this));
        this.sessiongraph = (0, $0dd61d98ba46ad83$export$2e2bcd8739ae039)();
        // FABRIC
        (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).init({
            creds: this.keycache
        });
        (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).addEventListener('fabricEvent', this.onFabricEvent.bind(this));
        this.fabric = (0, $6bfa5c439efc151f$export$2e2bcd8739ae039);
    }
    async onFreshDataEvent(e) {
        console.log('  matrix fires on fresh data  ');
    }
    async evaluateSessionStatus() {
        // CHECK FRAGMENT 
        var lochash = window.location.hash.substr(1);
        if (lochash) {
            // INDIVIDUAL VARIABLES 
            var urlks = {};
            var q = lochash.split('&');
            for(var i = 0; i < q.length; i++){
                var kv = q[i].split('=');
                this.session.urlks[kv[0]] = kv[1];
            }
        }
        var session_stub = this.getLocal('loc');
        var vfound = await this.keycache.discoverVaults();
        if (vfound.length == 0 && (0, $b1acb6ed8a11dca2$export$722a64dea1b767dc).isElectron()) {
            this.session.state = 2;
            this.dispatchEvent(new CustomEvent('sessionEvent', {
                detail: {
                    model: this
                }
            }));
        } else if ('domain' in session_stub) this.loginVault(session_stub);
        else {
            this.dispatchEvent(new CustomEvent('sessionEvent', {
                detail: {
                    model: this
                }
            }));
            var index_stub = 'uix/index_dyn.html';
            var g = 3;
            var sel_obj = {
                type: 'x',
                fragment: index_stub,
                model: this
            };
            this.dispatchEvent(new CustomEvent('navEvent', {
                detail: sel_obj
            }));
        }
        // HASH URL OPS IF NOT EMPTY: 
        if (lochash != '') {
            // INDIVIDUAL VARIABLES 
            var urlks = {};
            var q = lochash.split('&');
            for(var i = 0; i < q.length; i++){
                var kv = q[i].split('=');
                this.session.urlks[kv[0]] = kv[1];
            }
            var urlks = this.session.urlks;
            // U domain + pw EXISTS ENTER valult : 
            if ('u' in urlks) this.loginVault({
                domain: urlks.u,
                pw: urlks.u,
                fn: 'login_vault',
                action: 'login_vault'
            });
            // PATH EXISTS TRY FILE OR VAULT LOAD 
            if ('p' in urlks) {
                //await sleep(100);
                // check if path has '/'
                if (urlks.p.includes('/')) this.pushNavState({
                    type: 'map',
                    fragment: urlks.p,
                    title: 'URLIN'
                });
                else this.pushNavState({
                    fn: 'cred_launch',
                    action: 'cred_launch',
                    domain: urlks.p,
                    uuid: urlks.p
                });
            }
            // BLOB 
            if ('b' in urlks) //await sleep(1000);
            (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent({
                module: 'extractor',
                method: 'downloadBlob',
                url: urlks.b,
                uuid: urlks.b + 'f132'
            });
            // MAP ( may need login ,  so requested map should  update modeel )
            if ('m' in urlks) {
                //await sleep(1500);
                var eventObj = {};
                eventObj['uuid'] = urlks.m;
                eventObj['requested_uuid'] = urlks.m;
                eventObj['fn'] = 'cred_launch';
                this.pushNavState(eventObj);
            }
            var l = 3;
        }
        // Attempt to list local directory structure (works only in secure/electron/node environments)
        try {
            // Check if running in Node.js or Electron (not in browser)
            if (typeof window === "undefined") {
                const fs = (parcelRequire("kjyEk"));
                const path = (parcelRequire("59kwG"));
                const dirPath = $hPtJY.cwd(); // current working directory
                let files = fs.readdirSync(dirPath);
                this.session.localDirectory = files.map((f)=>({
                        name: f,
                        isDirectory: fs.statSync(path.join(dirPath, f)).isDirectory()
                    }));
            // Optionally log or dispatch event
            // console.log("Local directory listing:", this.session.localDirectory);
            } else if (window && window.showDirectoryPicker) // Modern browser with File System Access API
            (async ()=>{
                try {
                    const dirHandle = await window.showDirectoryPicker();
                    this.session.localDirectory = [];
                    for await (const entry of dirHandle.values())this.session.localDirectory.push({
                        name: entry.name,
                        kind: entry.kind
                    });
                // Optionally log or dispatch event
                // console.log("Local directory listing:", this.session.localDirectory);
                } catch (e) {
                    var i = 5;
                // User cancelled or not allowed
                // console.warn("Directory access cancelled or denied.");
                }
            })();
            else // Not supported in this environment
            console.warn("Local directory listing not supported in this environment.");
        } catch (err) {
        // Handle any errors gracefully
        // console.error("Error listing local directory:", err);
        }
    //this.dispatchEvent( new CustomEvent('logEvent', { detail:{ 'message':'KEY CA:  count: '+this.keycache.count()} }) )
    }
    pushNavState(obj) {
        this.session.navstate = obj;
        this.session.state_change = 'fn' in obj ? obj['fn'] : this.state_change;
        //this.session.state_change = ( 'action' in obj ) ? obj['action'] : this.state_change;
        this.session.selected_object = obj;
        obj['model'] = this;
        //if( this.session.state_change == undefined ){ return };
        switch(this.session.state_change){
            case 'check_status':
                this.dispatchEvent(new CustomEvent('navEvent', {
                    detail: obj
                }));
                break;
            case 'home':
                this.dispatchEvent(new CustomEvent('navEvent', {
                    detail: obj
                }));
                break;
            case 'downloadBlob':
                break;
            case 'import_demos':
                // somehow pull JSON , then embed objects in keycache 
                // loop and then fire event to show populated collections 
                //fabric.mergeIntent( { module:'extractor',method:'rawMaps'} ); 
                (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent({
                    module: 'extractor',
                    method: 'features'
                });
                break;
            case 'unlockimport_vault':
                var tt = 0;
                this.model.keycache.importFileAndLogin(file, pw);
                break;
            case 'destroy':
            case 'selfdestruct':
                this.keycache.deleteBlob();
                break;
            case 'save_items':
                this.keycache.save();
                obj['model'] = this;
                this.dispatchEvent(new CustomEvent('navEvent', {
                    detail: obj
                }));
                break;
            case 'cred_launch':
                obj['model'] = this;
                if ('domain' in this.session.selected_object || 'uuid' in this.session.selected_object) {
                    //var actobj = this.keycache.items[ this.session.selected_object.domain ]
                    var kobj = this.keycache.keySelect('uuid', this.session.selected_object.uuid)[0];
                    if (!kobj) break;
                    if (kobj.ty == 'map' && 'nodes' in kobj.dat) {
                        if ('meta' in kobj.dat) var n = 987987;
                        kobj.dat.meta['origin'] = 'int';
                        kobj.dat.meta['foreign_id'] = 'uuid';
                        kobj.dat.meta['foreign_a'] = 'a';
                        kobj.dat.meta['foreign_b'] = 'b';
                        // this.matrix.mergeMap( actobj.dat );
                        this.matrix.incomingDiffFromKeyCache(kobj.dat);
                        //this.matrix.printInventory();
                        //var map_out = this.matrix.getMap();
                        //this.session.selected_object['dat']=actobj.dat;
                        //this.session.selected_object['type']=this.session.selected_object.fn;
                        var o = 8;
                        this.dispatchEvent(new CustomEvent('freshDataEvent', {
                            detail: map_out
                        }));
                    }
                    if (kobj.ty == 'key') {
                        // get funtion type from glue mapper ?
                        kobj.label = (0, $440781629901dd2f$export$2e2bcd8739ae039).xclass_method_object(kobj.ty, 'launches', kobj);
                        var func_node = {
                            origin: 'wallet',
                            slot: $f88ac7a2e1f41a9d$export$abe4376e1bf796d6(),
                            payload: kobj
                        };
                        var wrapped = {
                            nodes: [
                                func_node
                            ]
                        };
                        this.matrix.appendMap(wrapped);
                        var map_out = this.matrix.getMap();
                        var o = 8;
                        this.dispatchEvent(new CustomEvent('freshDataEvent', {
                            detail: map_out
                        }));
                    }
                }
                break;
            case 'cred_launch_og':
                obj['model'] = this;
                if ('domain' in this.session.selected_object || 'uuid' in this.session.selected_object) {
                    //var actobj = this.keycache.items[ this.session.selected_object.domain ]
                    var actobj = this.keycache.keySelect('uuid', this.session.selected_object.uuid)[0];
                    if ('nodes' in actobj.dat) {
                        this.session.selected_object['dat'] = actobj.dat;
                        this.session.selected_object['type'] = this.session.selected_object.fn;
                        this.dispatchEvent(new CustomEvent('navEvent', {
                            detail: this.session.selected_object
                        }));
                    }
                }
                break;
            case "cred_del":
                this.keycache.keyDelete('uuid', this.session.selected_object.uuid);
                obj['model'] = this;
                this.dispatchEvent(new CustomEvent('navEvent', {
                    detail: this.session.selected_object
                }));
                break;
            case "create_map":
                // CLEAR PROCS CHAMP
                (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).dropProcs();
                this.matrix.resetMap();
                obj['model'] = this;
                this.dispatchEvent(new CustomEvent('navEvent', {
                    detail: this.session.selected_object
                }));
                break;
            case "export_backup":
                // ARCHIVE
                this.keycache.exportFile();
                break;
            case "export_clear":
                // ARCHIVE
                this.keycache.exportClear();
                break;
            case "createObject":
                this.matrix.spawnInsertObjectType(obj.type);
                //this.matrix.appendMap( { nodes:[final_obj] } )
                var d = 3;
                break;
            case "keyImport":
                // should parse obj , 
                // find dat , 
                // and show unlock screen pointed at encrypted clyater
                this.session.file = obj;
                this.dispatchEvent(new CustomEvent('navEvent', {
                    detail: obj
                }));
                var s = 0;
                break;
            case "mapImport":
                var d = 9;
                break;
            case "importComplete":
                this.dispatchEvent(new CustomEvent('navEvent', {
                    detail: obj
                }));
                break;
            default:
                if (this.session.state == 1) this.dispatchEvent(new CustomEvent('navEvent', {
                    detail: obj
                }));
                else this.dispatchEvent(new CustomEvent('navEvent', {
                    detail: obj
                }));
                break;
        }
        // io
        switch(obj.type){
            case 'query':
                //HERE DOES IT SELECT DOMAIN ?
                //are different search results for different urls ?
                // URL can BE encrypted blob 
                // URL Can be DB_query + DB_URL 
                console.log('qrx;');
                //this.dispatchEvent(new CustomEvent('navEvent',{ detail:{ reset:true } } ) )
                delete obj['model'];
                var intentObj = {
                    brand: 'neo',
                    module: 'neo',
                    method: 'process',
                    params: obj.item,
                    uuid: 'neowut'
                };
                var o = this.keycache.mergeArtifacts(intentObj);
                (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent(o);
                break;
            case 'linkadd':
                console.log('wut ');
                break;
        }
    }
    async pushMessage(obj) {
        // TODO: need another way that doesnt reject due to OR 
        // REJECT MESSAGES FROM OTHER PLUGINS 
        // if( !('fn' in obj) || !('method' in obj) ){ return; }
        if (obj.fn == 'detailEvent') {
            //should use some params from click or selected object 
            //to load type and name or id 
            //    {  'module':'avatarRouter' , 'url':'somepath'}
            // fabric.mergeIntent( obj ); 
            var aiObj = {
                "id": "5",
                "type": "Person",
                "name": "John Smith",
                "field": "Pharmacology",
                "contribution": "Research on drug-plant interactions",
                "label": "tag",
                "uuid": "oai_JohnSmith_oid",
                "level": 2,
                "fn": "detailEvent",
                "ctx": {
                    "nodes": [],
                    "links": []
                }
            };
            var cyz = this.matrix.getCache();
            aiObj.ctx = cyz;
            var fabObj = {};
            fabObj.module = 'generic';
            fabObj.uuid = 'generic1';
            fabObj.method = 'report';
            fabObj.params = aiObj;
            (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent(fabObj);
            (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).addEventListener("fabricEvent", function(e) {
                var e = 3;
                console.log(' e: ', e);
            });
        }
        if (obj.fn == 'importComplete') {
            var wobj = {};
            wobj['dom'] = obj.meta.name;
            wobj['ty'] = 'map';
            wobj['payload'] = obj; //{ meta:obj.meta , nodes:obj.nodes , links:obj.links}
            this.keycache.keyMerge('dom', obj.meta.name, {
                dom: obj.meta.name,
                dat: obj,
                ty: 'map'
            });
            this.dispatchEvent(new CustomEvent('sessionEvent', {
                detail: {
                    model: this
                }
            }));
        }
        if (obj.fn == 'savemap') {
            var wobj = {};
            wobj['dom'] = obj.payload.meta.name;
            wobj['ty'] = 'map';
            wobj['payload'] = obj.payload; //{ meta:obj.meta , nodes:obj.nodes , links:obj.links}
            // WRITES MAP TO ITEMS 
            //this.keycache.addItem( wobj )
            this.keycache.keyMerge('dom', obj.payload.meta.name, {
                dom: obj.payload.meta.name,
                dat: obj.payload,
                ty: 'map'
            });
            // WRITES MAP TO JSON DEMOS 
            var jsonstring = JSON.stringify(obj.payload);
        } else if (obj.fn == 'spawn') //var remove_merge_object = { ...obj , ...this.keycache.items[ obj.domain ]  }
        // WOWSERS DESIGN change 
        // YOU ARE HERE 
        // CAn we MERGE Credentials here more logically ? 
        //  { ...this.keycache.keySelect( 'dom' , obj.uuid )[0]  , ...obj } 
        // fabric.mergeIntent(  { ...this.keycache.keySelect( 'dom' , obj.uuid )[0]  , ...obj }  )
        (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent(obj);
        else if (obj.method && obj.method == 'subgraph') {
            //var node = this.matrix.getNode( obj.slot);
            obj.identifier = obj.elementId;
            var intentObj = {
                brand: 'neo',
                module: 'neo',
                method: 'process',
                params: obj,
                data: obj.data
            };
            var o = this.keycache.mergeArtifacts(intentObj);
            (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent(o);
            var j = 8;
        } else if (obj.method && obj.method == 'mergeobject') {
            // find origin from object 
            //var node = this.matrix.getNode( obj.slot);
            //obj.identifier = node.payload.elementId;
            // IF ORIGIN == NEO 
            var intentObj = {
                brand: 'neo',
                module: 'neo',
                method: 'process',
                params: {
                    object: obj.params.payload
                }
            };
            var o = this.keycache.mergeArtifacts(intentObj);
            (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent(o);
            var j = 8;
        } else if (obj.method && obj.method == 'mergelink') {
            // find origin from object 
            // var node = this.matrix.getNode( obj.slot);
            // obj.identifier = node.payload.elementId;
            // IF ORIGIN == NEO 
            var edge = this.matrix.transformEdgeToNeo(obj);
            var intentObj = {
                brand: 'neo',
                module: 'neo',
                method: 'process',
                params: {
                    link: edge
                }
            };
            // solve repeat artifacts 
            var o = this.keycache.mergeArtifacts(intentObj);
            (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent(o);
            var j = 8;
        }
        var a = 1;
    }
    async sendOperation(obj) {
        // IN: module + method + payload 
        var sendcode = 0;
        if ('type' in obj) obj.method = obj.type;
        switch(obj.method){
            case 'login':
            case 'register':
                obj.pw = await this.keycache.digestMessage(obj.pw);
                break;
            case 'freesearch':
                var aiObj = obj;
                var cyz = this.matrix.getCache();
                aiObj.ctx = cyz;
                var fabObj = {};
                fabObj.module = 'generic';
                fabObj.uuid = 'generic1';
                fabObj.method = 'query';
                fabObj.params = aiObj;
                (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent(fabObj);
                break;
            case 'deepreport':
                var aiObj = obj;
                var cyz = this.matrix.getCache();
                aiObj.ctx = cyz;
                var fabObj = {};
                fabObj.module = 'generic';
                fabObj.method = 'report';
                fabObj.params = aiObj;
                (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent(fabObj);
                break;
        }
        obj['uuid'] = 'gen1';
    }
    togglePanels() {
        if (this.session.panels_open) this.session.panels_open = false;
        else this.session.panels_open = true;
        this.dispatchEvent(new CustomEvent('sessionEvent', {
            detail: {
                model: this
            }
        }));
    }
    /////AUTH
    setSession(objin) {
        this.session = objin;
        this.dispatchEvent(new CustomEvent('sessionEvent', {
            detail: {
                model: this
            }
        }));
    }
    getProcs() {
        return (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).getProcs();
    }
    async intAuth(obj) {
        this.keycache.set_imkey(obj.un, obj.pw);
    //var resObj = await this.connector.postProc( obj )
    // re9aji 
    //const outboundObj = Object.assign( {}, resObj ,{ model:this } );
    //this.pushLocal( resObj )
    //this.setSession( resObj )
    //this.dispatchEvent( new CustomEvent('sessionEvent',  { detail:outboundObj } ) )
    }
    async intReg(obj) {
        var intentObj = {
            ...obj,
            module: 'generic'
        };
        intentObj['method'] = obj.action;
        (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent(intentObj);
    // { 
    //     uuid:'0x0x0x',
    //     module:'generic',
    //     method:'reg',
    //     un:'x@gmail.com',
    //     ac:'x',
    //     pw:'x'
    // } 
    }
    async pushOp(obj) {
        var intentObj = {
            ...obj,
            module: 'generic'
        };
        intentObj['method'] = obj.action;
        (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent(intentObj);
    // { 
    //     uuid:'0x0x0x',
    //     module:'generic',
    //     method:'reg',
    //     un:'x@gmail.com',
    //     ac:'x',
    //     pw:'x'
    // } 
    }
    async pushAuth(obj) {
        this.keycache.set_imkey(obj.un, obj.pw);
        var resObj = await this.connector.postProc(obj);
        // re9aji 
        const outboundObj = Object.assign({}, resObj, {
            model: this
        });
        this.pushLocal(resObj);
        this.setSession(resObj);
        this.dispatchEvent(new CustomEvent('sessionEvent', {
            detail: outboundObj
        }));
    }
    appendObject(o) {
        const outboundObj = Object.assign({}, {
            model: this
        });
        this.post_op = this.keycache.addItem(o);
        if (!this.post_op) outboundObj['message'] = 'not saved: ';
        this.dispatchEvent(new CustomEvent('sessionEvent', {
            detail: outboundObj
        }));
    }
    //multiple creds 
    async pushNewCreds(objArr) {
        this.keycache.appendCollection(objArr);
    }
    async pushReg(obj) {
        obj.action = 'reg';
        var resObj = await this.connector.postProc(obj);
        const outboundObj = Object.assign({}, resObj, {
            model: this
        });
        this.dispatchEvent(new CustomEvent('sessionEvent', {
            detail: outboundObj
        }));
    }
    async pushOpv1(obj) {
        var resObj = await this.connector.postProc(obj);
        //var resObj = await this.connector.proc( obj )
        const outboundObj = Object.assign({}, resObj, {
            model: this
        });
        this.dispatchEvent(new CustomEvent('sessionEvent', {
            detail: outboundObj
        }));
    }
    async exitVault(obj) {
        const outboundObj = Object.assign({}, {
            model: this
        });
        this.session.state = 0;
        this.genesis_object = {};
        this.keycache.exit;
        localStorage.removeItem('loc');
        var selected_obj = {
            'type': 'map',
            'title': 'NEW',
            'fragment': 'blank'
        };
        //this.dispatchEvent\( event ) 
        this.dispatchEvent(new CustomEvent('sessionEvent', {
            detail: outboundObj
        }));
        var selected_obj = {
            'type': 'map',
            'title': 'NEW',
            'fragment': 'blank'
        };
        var event = new CustomEvent('navRequestEvent', {
            detail: selected_obj,
            bubbles: true
        });
        this.dispatchEvent(event);
    }
    async loginVault(obj) {
        var logRes = '';
        var d = 'domain' in obj ? obj.domain : 'x';
        // encrypt and store creds 
        if (this.session.file && this.session.file.dat) {
            //var arbufdat = convert.str2ab( this.session.file.dat );
            var arbufdat = $dad38998d2bf836c$export$a7a17e76664e3e44(this.session.file.dat);
            logRes = await this.keycache.loginAndLoad(d, obj.pw, arbufdat);
        } else //this.pushLocal( 'loc', obj );
        logRes = await this.keycache.loginAndLoad(d, obj.pw);
        const outboundObj = Object.assign({}, {
            res: logRes
        }, {
            model: this
        });
        if (logRes) {
            this.session.un = obj.domain || 'no domain';
            this.session.message = 'success';
            this.session.tkn = 'success';
            this.session.state = 1;
            this.session.tkn = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1dWlkIjoiNWRhYTI0NmI5N2NmNGIyMThkZTk4YmM0OWRjMDQ2NWIiLCJleHAiOjE2MzgwODAyNDd9.A32rX4DcTbxuPQ3Y3PPPI_jbGwyuMtFdiABza-ubF3I";
            this.session.state_change = 'show_status';
            // here successful client seed can attempt login to server
            //  ( this is entrypoint to create agent relationship through fabric )
            // can it login and get jwt what 'username' and 'pw' to use 
            // could username be domain ... and 'pw' be hashed version of passed in PW? 
            // how would that be called here ? 
            var reqObj1 = {
                uuid: 'generic01',
                module: 'generic',
                method: 'login',
                payload: {
                    un: obj.domain,
                    pw: 'x'
                }
            };
            (0, $6bfa5c439efc151f$export$2e2bcd8739ae039).mergeIntent(reqObj1);
            // 
            // un: obj.domain            
            // = { 
            // state:1 ,
            // ip: "localstore",
            // lastlogin: "27-Nov-2021 (22:10:57)",
            // message: "Local Success",
            // state: 1,
            // tkn: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1dWlkIjoiNWRhYTI0NmI5N2NmNGIyMThkZTk4YmM0OWRjMDQ2NWIiLCJleHAiOjE2MzgwODAyNDd9.A32rX4DcTbxuPQ3Y3PPPI_jbGwyuMtFdiABza-ubF3I",
            // un: obj.domain
            //};
            this.genesis_object = {
                domain: obj.domain,
                key: this.keycache.im_key
            };
            var selected_obj = {
                'type': 'map',
                'title': 'NEW',
                'fragment': 'blank'
            };
            var event = new CustomEvent('navRequestEvent', {
                detail: selected_obj,
                bubbles: true
            });
            this.dispatchEvent(event);
            this.dispatchEvent(new CustomEvent('sessionEvent', {
                detail: outboundObj
            }));
            if ('m' in this.session.urlks) {
                (0, $61abcf8bc5f450ed$export$e772c8ff12451969)(300);
                console.log(' w ', 'requested_uuid');
                var eventObj = {};
                eventObj['uuid'] = this.session.urlks.m;
                eventObj['requested_uuid'] = this.session.urlks.m;
                eventObj['fn'] = 'cred_launch';
                this.pushNavState(eventObj);
            }
        } else {
            outboundObj.message = 'Incorrect Credentials';
            this.dispatchEvent(new CustomEvent('sessionEvent', {
                detail: outboundObj
            }));
        }
    }
    async newVault(obj) {
        var resObj = {
            message: 'phrase match',
            state: 0
        };
        var report = (0, $f555e5b4f123ed0e$export$2e2bcd8739ae039).inspect(obj);
        var avail = await this.keycache.available(obj.domain);
        if (report.error == 0 && avail) {
            // check if prev exists 
            this.keycache = new (0, $ed871e0b99fd3eca$export$2e2bcd8739ae039)({});
            this.session = {
                state: 1,
                ip: "localstore",
                lastlogin: "27-Nov-2021 (22:10:57)",
                message: "Local Success",
                state: 1,
                tkn: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1dWlkIjoiNWRhYTI0NmI5N2NmNGIyMThkZTk4YmM0OWRjMDQ2NWIiLCJleHAiOjE2MzgwODAyNDd9.A32rX4DcTbxuPQ3Y3PPPI_jbGwyuMtFdiABza-ubF3I",
                un: obj.domain
            };
            await this.keycache.set_imkey(obj.domain, obj.passphrase1);
            this.genesis_object = {
                domain: obj.domain,
                key: this.keycache.im_key
            };
            await this.keycache.save();
            var selected_obj = {
                'type': 'map',
                'title': 'NEW',
                'fragment': 'blank'
            };
            var event = new CustomEvent('navRequestEvent', {
                detail: selected_obj,
                bubbles: true
            });
            this.dispatchEvent(event);
        }
        if (avail == false) report.message = 'Domain Already exists.';
        const outboundObj = Object.assign({}, report, {
            model: this
        });
        this.dispatchEvent(new CustomEvent('sessionEvent', {
            detail: outboundObj
        }));
    }
    resetAuth(obj) {
        //localStorage.clear();
        this.connector.logout().then((function(authObj) {
            this.setSession({});
        }).bind(this));
    }
    onFabricEvent(e) {
        console.log(' fabric event reaches model: ', e.detail);
        if ('foreignMethod' in e.detail && e.detail.foreignMethod == 'rawMaps') for(var m in e.detail.payload){
            console.log(m, e.detail.payload[m]);
            var mobj = e.detail.payload[m];
            mobj.dom = mobj.meta.name;
            mobj.ty = 'map';
            this.keycache.addItem(e.detail.payload[m]);
        }
        switch(e.detail.module){
            case 'generic':
                switch(e.detail.method){
                    case 'register':
                    case 'reset':
                    case 'login':
                        // here it should add the identity to whatever array holds creds 
                        console.log('login  generic', e.detail);
                        var genericServiceItem = {};
                        genericServiceItem.ty = "key";
                        genericServiceItem.dom = "generic";
                        genericServiceItem.dat = e.detail.payload;
                        this.keycache.addItem(genericServiceItem);
                    // you are here 
                    case 'logout':
                        var response = {};
                        var okthen = 0;
                        break;
                    case 'query':
                        var response = {};
                        var okthen = 0;
                        // THIS SHOULD ENGAGE THE SYSTEM NOW: 
                        this.matrix.incomingDiffFromGeneric(e.detail);
                        //  session model sees update coming in 
                        //  shoul write it to model 
                        //  ObjectMatrix 
                        console.log(e.detail);
                        break;
                    case 'else':
                        break;
                }
                e.detail.model = this;
                this.dispatchEvent(new CustomEvent('sessionEvent', {
                    detail: e.detail
                }));
                e.stopPropagation();
                break;
            case 'keycache':
                console.log(' kc.ogged ');
                e.stopPropagation();
                break;
            case 'neo':
                e.detail.model = this;
                e.stopPropagation();
                break;
            case 'ccxt':
                break;
            case 'extractor':
                var d = 5;
                switch(e.detail.method){
                    case 'downloadBlob':
                        var blob = e.detail.payload;
                        this.session.file = blob[0];
                        this.pushNavState({
                            fn: 'keyImport'
                        });
                        break;
                    case 'features':
                        // here we insert geoJSON nodes 
                        var gjnds = 2;
                        this.matrix.incomingDiffFromExtractor(e.detail.payload);
                        break;
                    case 'else':
                        break;
                }
                break;
            case 'oai':
                console.log(' ok got these items in session model now how to route into graph ');
                var resObj = e.detail.payload;
                this.matrix.incomingDiffFromOai(resObj);
                break;
        }
    // WRITES MAP TO ITEMS 
    // this.keycache.addItem( wobj )
    }
    scanServices() {
        service_mesh.scan() // returns  list of connection objects with drivers 
        ;
    }
    initStubs(e) {
        // THESE WILL EVENTUALLY LOAD BASED ON CONTEXT 
        //  So keycache get safe items 
        //  return list of functions 
        //  
        var walletstubs = [
            {
                'type': 'file',
                'title': 'Cerebro Spinal',
                'fragment': 'miccco/vission',
                'renderer': './masonry/index.html'
            },
            {
                'type': 'file',
                'title': 'Tree Micros',
                'fragment': 'miccco/vission',
                'renderer': './masonry/index.html'
            },
            {
                'type': 'connect',
                'title': '204.157.123.12'
            },
            {
                'type': 'connect',
                'title': 'signalmesh.io'
            },
            {
                'type': 'bank',
                'title': 'Wellsfargo'
            },
            {
                'type': 'bank',
                'title': 'CHASE'
            },
            {
                'type': 'settings',
                'title': 'Profile Settings'
            },
            {
                'type': 'coin',
                'title': 'Litecoin LTC'
            },
            {
                'type': 'coin',
                'title': 'Bitcoin BTC'
            },
            // here add to no4j 
            {
                'type': 'new',
                'title': 'New Alias (V-Identity)',
                'fragment': 'Alias'
            },
            {
                'type': 'new',
                'title': 'GIT Repository',
                'fragment': 'Repo'
            },
            {
                'type': 'new',
                'title': 'Exchange',
                'fragment': 'Exchange'
            },
            {
                'type': 'new',
                'title': 'New BTC Address'
            },
            {
                'type': 'new',
                'title': 'New LTC Address'
            },
            {
                'type': 'map',
                'title': 'ServerMap',
                'fragment': 'json/servermap.json'
            },
            {
                'type': 'command',
                'title': 'hosts'
            },
            {
                'type': 'command',
                'title': 'reset'
            },
            {
                'type': 'command',
                'title': 'inventory'
            },
            {
                'type': 'command',
                'title': 'inventory2'
            },
            {
                'type': 'command',
                'title': 'keys'
            },
            {
                'type': 'command',
                'title': 'logout',
                'fragment': 'jxtlogout'
            },
            {
                'type': 'command',
                'title': 'authenticate',
                'fragment': '/loginjwt.html'
            },
            {
                'type': 'alias',
                'title': 'micccco@gmail.com'
            },
            {
                'type': 'alias',
                'title': 'BigHodler'
            },
            {
                'type': 'alias',
                'title': 'PSYTRON'
            },
            {
                'type': 'key',
                'title': 'gdax'
            },
            {
                'type': 'key',
                'title': 'bittrex'
            },
            {
                'type': 'key',
                'title': 'coinbase'
            },
            {
                'type': 'key',
                'title': 'localhost'
            },
            {
                'type': 'key',
                'title': 'coinex (HK)'
            },
            {
                'type': 'key',
                'title': 'okex (CN)'
            },
            {
                'type': 'map',
                'title': 'Bots and Banks',
                'fragment': 'miccco/botsandbanks'
            },
            {
                'type': 'map',
                'title': 'Poolside View',
                'fragment': 'miccco/pools'
            },
            {
                'type': 'map',
                'title': 'miccco/ShipItYo',
                'fragment': 'miccco/shipityo'
            },
            {
                'type': 'map',
                'title': 'miccco/Vission',
                'fragment': 'miccco/vission'
            },
            {
                'type': 'map',
                'title': 'miccco/parimutuel',
                'fragment': 'miccco/parimutuel'
            },
            {
                'type': 'map',
                'title': 'miccco/global',
                'fragment': 'miccco/global'
            },
            /*{ 'type':'map' , 'title':'miccco/People' , 'fragment':'miccco/people'},*/ {
                'type': 'map',
                'title': 'miccco/Pharmacology',
                'fragment': 'miccco/pharma'
            },
            {
                'type': 'substance',
                'title': 'Probenesid',
                'fragment': 'probenesid'
            },
            {
                'type': 'substance',
                'title': 'Codeine',
                'fragment': 'probenesid'
            },
            {
                'type': 'substance',
                'title': 'Ketoconazol',
                'fragment': 'probenesid'
            },
            {
                'type': 'substance',
                'title': 'Penecillin G',
                'fragment': 'probenesid'
            },
            {
                'type': 'substance',
                'title': 'Ritonair',
                'fragment': 'probenesid'
            },
            {
                'type': 'map',
                'title': 'NEW',
                'fragment': 'blank',
                'fn': 'create_map'
            },
            {
                'type': 'map',
                'title': 'System Dependency Graph'
            },
            {
                'type': 'map',
                'title': 'Correlation strength each LINK'
            },
            {
                'type': 'map',
                'title': 'Blocks and Miners, '
            },
            {
                'type': 'query',
                'title': 'All',
                'fragment': '(x)-[r]-(y)'
            },
            {
                'type': 'query',
                'title': 'A-stars',
                'fragment': '(:Star)-[:SHINES]-(:Star)'
            },
            {
                'type': 'query',
                title: 'A-moves',
                item: {
                    'fragment': '(:Person)--()'
                }
            },
            {
                'type': 'query',
                title: 'A-Movie-Person',
                item: {
                    'pattern': '(:Movie)--(:Person)'
                }
            },
            {
                'type': 'query',
                title: 'ALLV2',
                item: {
                    'pattern': '(x)--(y)'
                }
            },
            {
                'type': 'query',
                title: 'A-Related:Branch:6fb:1746',
                item: {
                    'identifier': '4:f1731dc5-74ac-401d-9312-d6481729f6fb:1746'
                }
            },
            {
                'type': 'query',
                title: 'A-Related:Branch:6fb:37',
                item: {
                    'identifier': '4:f1731dc5-74ac-401d-9312-d6481729f6fb:6'
                }
            },
            {
                'type': 'query',
                title: 'Alias:f1731',
                item: {
                    'identifier': '4:f1731dc5-74ac-401d-9312-d6481729f6fb:33892'
                }
            },
            {
                'type': 'query',
                title: 'Ocean',
                item: {
                    'identifier': '4:4f968e5a-fb91-456b-8a18-18c1cf301f88:256'
                }
            },
            {
                'type': 'query',
                title: 'T64 ',
                item: {
                    'identifier': '4:4f968e5a-fb91-456b-8a18-18c1cf301f88:248'
                }
            },
            {
                'type': 'query',
                title: 'NEO Home (db) ',
                item: {
                    'identifier': '4:4f968e5a-fb91-456b-8a18-18c1cf301f88:241'
                }
            },
            {
                'type': 'query',
                title: 'Al Co. ',
                item: {
                    'identifier': '4:4f968e5a-fb91-456b-8a18-18c1cf301f88:233'
                }
            },
            {
                'type': 'query',
                title: 'Exce. ',
                item: {
                    'identifier': '4:4f968e5a-fb91-456b-8a18-18c1cf301f88:233'
                }
            },
            {
                'type': 'query',
                title: 'Alter Corp. 4:4f968e5',
                item: {
                    'identifier': '4:4f968e5a-fb91-456b-8a18-18c1cf301f88:225'
                }
            },
            {
                'type': 'query',
                title: 'Bot 4:4f968e5a',
                item: {
                    'identifier': '4:4f968e5a-fb91-456b-8a18-18c1cf301f88:212'
                }
            },
            //{ 'type':'query' , 'title':'west_coast_connect' ,'fragme-[r0:TRANSFERS|:CONVERTS]-(x1:Vehicle)return x0,r0,x1'},
            {
                'type': 'query',
                'title': 'conversion_only',
                'fragment': '/mapqrx?qrx=MATCH(x0:Vehicle)-[r0:CONVERTS]-(x1:Vehicle)return x0,r0,x1'
            },
            {
                'type': 'query',
                'title': 'Apps per Domain',
                'fragment': '/mapqrx?qrx=MATCH(x0:App)-[r0]-(x1:Domain)return x0,r0,x1'
            },
            {
                'type': 'query',
                'title': '(x)-[r]-(x1)',
                'fragment': '/mapqrx?qrx=MATCH(x0:Vehicle)-[r0]-(x1)return x0,r0,x1'
            },
            {
                'type': 'map',
                'title': 'Single Frag',
                'fragment': '/mapqrx?qrx=MATCH(x0:App)return x0'
            },
            {
                'type': 'query',
                'title': 'Actor Company',
                'fragment': '/mapqrx?qrx=MATCH(x0:Actor)-[r0]-(x1:)return x0,r0,x1'
            },
            {
                'type': 'query',
                'title': 'assets_world',
                'fragment': '/mapqrx?qrx=MATCH(x0:Asset)-[r0]-(x1:Asset)return x0,r0,x1'
            },
            {
                'type': 'map',
                'title': 'qrx=MATCH(x0:User)return',
                '/mapqrx?fragment': 'qrx=MATCH(x0:User)return x0'
            },
            {
                'type': 'map',
                'title': 'MATCH( x0:Actor )return x0',
                'fragment': '/mapqrx?qrx=MATCH(x0:Actor)-[r0]-(x1)-[r1]-(x2)return x0'
            },
            {
                'type': 'map',
                'title': 'MATCH( x0:Block )return x0',
                'fragment': '/mapqrx?qrx=MATCH(x0:Block)return x0'
            },
            {
                'type': 'map',
                'title': 'MATCH( x0:User )-( x1:World)',
                'fragment': '/mapqrx?qrx=MATCH( x0:User)-[r0:HAS]-( x1:World) return x0,r0,x1'
            },
            {
                'type': 'map',
                'title': 'MATCH( x0:World )-[r0:HAS]',
                'fragment': '/mapqrx?qrx=MATCH(x0:World)-[r0]-(x1:User)-[r1]-(x2:Credential)return x0,r0,x1,r1,x2'
            },
            {
                'type': 'map',
                'title': 'Project: Xynthx (GIT)',
                'fragment': '/mapqrx?qrx=MATCH(x0:Project)-[r0]-(x1:Repo)-[r1]-(x2:Alias)return x0,r0,x1,r1,x2'
            },
            {
                'type': 'contract',
                'title': 'Balancer V2',
                'fragment': 'la'
            },
            {
                'type': 'contract',
                'title': 'Uniswap',
                'fragment': 'lo'
            }
        ];
        var techtags = [
            {
                'type': 'python',
                'fun': 'add',
                'title': 'Python',
                'fragment': 'qrx=MATCH(x0:Project)-[r0]-(x1:Repo)-[r1]-(x2:Alias)return x0,r0,x1,r1,x2'
            },
            {
                'type': 'python',
                'fun': 'add',
                'title': 'Tensorflow'
            },
            {
                'type': 'go',
                'fun': 'add',
                'title': 'Go'
            },
            {
                'type': 'neo4j',
                'fun': 'add',
                'title': 'NEO4J'
            },
            {
                'type': 'mysql',
                'fun': 'add',
                'title': 'MySQL'
            },
            {
                'type': 'postgresql',
                'fun': 'add',
                'title': 'PostgreSQL'
            },
            {
                'type': 'react',
                'fun': 'add',
                'title': 'React'
            },
            {
                'type': 'spark',
                'fun': 'add',
                'title': 'Spark'
            },
            {
                'type': 'docker',
                'fun': 'add',
                'title': 'Docker'
            },
            {
                'type': 'kubernetes',
                'fun': 'add',
                'title': 'Kubernetes'
            }
        ];
        var allstubs = [
            ...walletstubs,
            ...techtags
        ];
        //searchmod.initStubs( allstubs )
        this.dispatchEvent(new CustomEvent('initEvent', {
            detail: {
                model: this,
                stubs: allstubs
            }
        }));
    }
    //// LOCAL STORAGE 
    getLocal(dom) {
        var item = localStorage.getItem(dom);
        if (item) {
            var obj = JSON.parse(item);
            return obj;
        } else return {};
    }
    pushLocal(dom, obj) {
        var item = this.getLocal();
        var newlocal = {
            ...item,
            ...obj
        };
        localStorage.setItem(dom, JSON.stringify(obj));
        return newlocal;
    }
    onLogEvent() {
        console.log(' state model hears log event ', this);
    }
}
var $14b973211f4cd758$export$2e2bcd8739ae039 // function LocalStore(){
 //     this.push=function( obj ){
 //         console.log(' push localstore')
 //     }
 // }
 // FOLLOW UP CHECK HTTP AND INVALIDATE IF NECESSARY 
 //this.connector.checkstatus().then( function(resObj){
 //this.setState( resObj )
 //}.bind(this))
 // YOU ARE HERE :  DOES ALIAS WRAP CYTHON ? 
 // this.alias.authenticate() 
 // Alias checks current auth and loads inventory blob ? 
 // 
 // ALIAS_PROXY   , ALIAS_WRAPPER()
 // a = AliasProxy()
 // a.authenticate( obj ) 
 // now token is in Cython  AliasProxy falls back on localstore
 // 
 // a.search( string )
 // v = a.vehicle( 'domain' ,'symbol')
 // map_object.vehicles = v ;
 // map talks to vehicle / object inside the map through alias. 
 // YOU ARE HERE :  DOES ALIAS WRAP CYTHON ? 
 // this.alias.authenticate() 
 // Alias checks current auth and loads inventory blob ? 
 // ALIAS_PROXY   , ALIAS_WRAPPER()
 // a = AliasProxy()
 // a.authenticate( obj )  
 // now token is in Cython  AliasProxy falls back on localstore
 // a.search( string )
 // v = a.vehicle( 'domain' ,'symbol')
 // map_object.vehicles = v ;
 // map talks to vehicle / object inside the map through alias. 
 // (async () => {
 //     const exchanges = [
 //         'bittrex',
 //         'poloniex',
 //     ]
 //     const symbol = 'BTC/USDT'
 //     const tickers = {}
 //     await Promise.all (exchanges.map (exchangeId =>
 //         new Promise (async (resolve, reject) => {
 //             const exchange = new ccxt[exchangeId] ({ enableRateLimit: true })
 //             while (true) {
 //                 const ticker = await exchange.fetchTicker (symbol)
 //                 tickers[exchangeId] = ticker
 //                 Object.keys (tickers).map (exchangeId => {
 //                     const ticker = tickers[exchangeId]
 //                     console.log (ticker['datetime'], exchangeId, ticker['bid'], ticker['ask'])
 //                 })
 //             }
 //         })
 //     ))
 // })(); 
 //                         case 'connectmeta':
 //                     // DETECT META 
 //                     console.log(' connect meta attempt: ')
 //                     if (window.ethereum) {
 //                         window.web3 = new Web3(ethereum);
 //                         try {
 //                             ethereum.enable();
 //                         } catch (err) {
 //                             //$('#status').html('User denied account access', err)
 //                             console.log(' MM: user denied acccount access ')
 //                         }
 //                     } else if (window.web3) {
 //                         window.web3 = new Web3(web3.currentProvider)
 //                         console.log(' MM: enabled: ')
 //                     } else {
 //                         console.log(' MM: None dtecte ')
 //                         alert(' No Wallet Detected')
 //                     }                
 //                     // LAUNCH PMNT
 //                     web3.eth.getAccounts().then( o =>{ 
 //                         const accountx = o[0] 
 //                         const paymentAddress = '0xBe7518241bd2025c2E14B76eCf643b8A71f710C8' // ccc CB in
 //                         const amountEth = "0.001"
 //                         web3.eth.sendTransaction({
 //                             from: accountx,
 //                             to: paymentAddress,
 //                             value: web3.utils.toWei(amountEth, 'ether')
 //                         }, (err, transactionId) => {
 //                             if (err) {
 //                                 console.log('Payment failed', err)
 //                                 this.con.querySelector("#ethstatus").innerHTML='<span style="color:red;">PAYMENT FAIL</div>';
 //                             } else {
 //                                 console.log('Payment successful', transactionId)
 //                                 this.con.querySelector("#ethstatus").innerHTML='<span style="color:green;">PAYMENT SUCCESS: '+transactionId+'</div>';
 //                             }
 //                         })    
 //                     })
 //                     break;
 /* migrated to Fabric: 
        // DETECT 
        if (typeof window.ethereum !== 'undefined') {
            this.dispatchEvent( new CustomEvent('logEvent', { detail:{'message':'MM DETECT: YES'} }) )
        }
        // CCXT 
        if( window.ccxt ){
            var ccxt = window.ccxt;
            this.dispatchEvent( new CustomEvent('logEvent', { detail:{ 'message':'CFI XT: YES  count: '+ccxt.exchanges.length } }) )
        }        
        // ETHERS 
        if( window.ethers ){
            this.dispatchEvent( new CustomEvent('logEvent', { detail:{ 'message':'ETHRS: YES  ' } }) )
        }                
        // CHECK ELECtRON 
        if( platform.isElectron() ){
            this.dispatchEvent( new CustomEvent('logEvent', { detail:{'message':'ELCTR: YES'} }) )   
        }
        */  // ADD LOCAL CLUSTERS TO THE LIST 
 // CHECK AVAIL LISTS ON SERVER PER THIS KEY AND SIG 
 // LOAD PUBLIC STUBS FOR SEARCH 
 // CHECK for STUBS IN NEO4J 
 // var neoJS_fast_service = {}; 
 // crypto graphically 
 // CHECK FOR ELECTRON CONTEXT - TWO WAY CONNECT  
 // if( window && window.process && window.process.type ){
 //     const { ipcRenderer } = require('electron')
 //     console.log('electron detected required');
 //     var sync_response = ipcRenderer.sendSync('synchronous-message', 'ping');
 //     console.log(' sync response: ', sync_response) // prints "pong"
 //     ipcRenderer.on('asynchronous-reply', (event, arg) => { console.log(arg) })// prints "pong"
 //     ipcRenderer.send('asynchronous-message', 'ping')
 //     ipcRenderer.send('xovent', 'xo ping')   
 //     this.dispatchEvent( new CustomEvent('logEvent', { detail:{'message':'ELC: YES'} }) )
 // }else{
 //     this.dispatchEvent( new CustomEvent('logEvent', { detail:{'message':'ELC: N0'} }) )
 // };
 // function validator() {
 //     this.reflex = function( obi){
 //         return 7;
 //     }
 //     this.inspect = function( obj ){
 //         return 1;
 //     }
 // }
 //
 // NEEDED THIS TO CALL addEventListener on model
 //this.addEventListener = this.addEventListener
 //this.removeEventListener = this.removeEventListener
 //this.dispatchEvent = this.dispatchEvent
 = $14b973211f4cd758$var$SessionModel;


// import ServicePool from './../frame/servicepool.js'
// import Alias from './../alias/alias.js'

class $90c97e484e1fef0d$var$SessionController {
    // AGGREGATES APP INPUT
    constructor(obj){
        this.idt = 'basic0001';
        this.model = obj.model;
        this.connector = obj.connector;
        // CAVEMAN RESCOPE
        this.onLogEvent = this.onLogEvent.bind(this);
        this.onUiEvent = this.onUiEvent.bind(this);
        this.onNavRequestEvent = this.onNavRequestEvent.bind(this);
        this.onFabricEvent = this.onFabricEvent.bind(this);
        this.onKeyImportEvent = this.onKeyImportEvent.bind(this);
        // TAB TITLE: 
        const getDomainName = ()=>{
            const url = window.location.hostname;
            const domainParts = url.split('.');
            if (domainParts.length > 2) domainParts.shift(); // Remove subdomain if present
            const domainName = domainParts[0];
            document.title = domainName.charAt(0).toUpperCase() + domainName.slice(1);
        };
        getDomainName();
    // omniGraph.load(  expected_context_nodes )
    // omni.load( users_nodes  )
    // omni.search(    ) returns nodes[] , links[]
    // contracts input output apps  ,  
    // exchanges input output apps
    // needs to check self credentials
    // omni get nodes 
    // this.alias = new Alias() // good bones 
    // var drivers_to_load = ['disk_authenticator' , 'network_authenticator' , 'extension_authenticator' , 'coinlock']
    // this.servicePool = new ServicePool( { drivers:drivers_to_load} )
    }
    async start() {
        // CHECK URL STATE PARSE: 
        this.model.evaluateSessionStatus();
        // searchmenu items
        this.model.initStubs();
    }
    // EVENTS X Y Z // 
    onMapMessage(e) {
        // fn = " "
        // domain.symbol.xclass 
        // PDR:   x.y.z.  
        console.log(' from map ', e.data);
        var obj = e.data;
        this.model.pushMessage(obj);
    }
    // USER INPUTS // 
    onUiEvent(e) {
        var reqOp = e.detail.fn || e.detail.action || 'unknown';
        switch(reqOp){
            case 'home':
                this.model.pushNavState(e.detail);
                break;
            case 'reset':
            case 'register':
            case 'login':
            case 'importComplete':
                //this.model.pushNavState( e.detail )
                this.model.pushMessage(e.detail);
                break;
            case 'login':
                this.model.sendOperation(e.detail);
                break;
            case 'registerOG':
                this.model.pushReg(e.detail);
                break;
            case 'reset':
                this.model.pushOp(e.detail);
                break;
            case 'create_vault':
                this.model.newVault(e.detail);
                break;
            case 'login_vault':
                this.model.loginVault(e.detail);
                break;
            case 'unlockimport_vault':
                this.model.loginVault(e.detail);
                break;
            case 'exit_vault':
                this.model.exitVault(e.detail);
                break;
            case 'appendObject':
                this.model.appendObject(e.detail);
                break;
            case 'keyImport':
            case 'save_items':
            case 'navState':
            case 'show_unlock':
            case 'show_cred':
            case 'show_procs':
            case 'check_status':
            case 'showcol_object':
            case 'showcol_device':
            case 'showcol_key':
            case 'showcol_map':
            case 'showcol_vault':
            case 'create_map':
            case 'export_backup':
            case 'export_clear':
            case 'cred_launch':
            case 'cred_del':
            case 'cred_merge':
            case 'import_demos':
            case 'create':
            case 'createObject':
            case 'destroy':
                this.model.pushNavState(e.detail);
                break;
            case 'searchClick':
                console.log('  this model for session hears freesearch attempt  ');
                this.model.sendOperation(e.detail);
                break;
            case 'mapImport':
                this.model.pushMessage(e.detail);
                break;
            case 'burgerClick':
                break;
            default:
                break;
        }
    }
    onUnlockImportEvent(e) {
        var tt = 9;
    }
    onFabricEvent(e) {
        this.model.fabricEvent(e.detail);
    }
    onChildBoot(e) {
        console.log(' -> ))) Session controller parent received message!:  ', e.data);
    }
    onLogEvent(e) {
    //console.log(' controller input:  ',this)
    }
    // SHOULD ALSO MOVE TO UI
    onNavRequestEvent(e) {
        var obj = e.detail;
        this.model.pushNavState(e.detail);
    }
    onKeyImportEvent(e) {
        var i = 4;
    // was keyImport 
    }
}
var $90c97e484e1fef0d$export$2e2bcd8739ae039 = $90c97e484e1fef0d$var$SessionController;



var $fzZ9h = parcelRequire("fzZ9h");

//TODO: unfactor $ jquery here 



class $147756b0f58bc411$var$SearchMod extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    constructor(initObj){
        super(initObj);
        // Bind Scope Listeners 
        this.setSearchClick = this.setSearchClick.bind(this);
        this.setSearchInput = this.setSearchInput.bind(this);
        this.setSearchKeyDownPaste = this.setSearchKeyDownPaste.bind(this);
        this.onSessionEvent = this.onSessionEvent.bind(this);
        this.initEvent = this.initEvent.bind(this);
        //const shadow = this.attachShadow( {mode: 'open'} );
        //this.shadow = shadow;
        //const xContainer = document.createElement('div');
        //xContainer.classList.add('search-mod');
        //shadow.appendChild(xContainer);
        //this.xinput = shadow.getElementById("inputfield")
        //this.xoutput = shadow.getElementById("outputfield")
        //this.xinput.addEventListener("keyup", this.termKeyUp );
        this.label_colors = {
            'connect': '#1f4554',
            'receive': '#1f4554',
            'map': '#341661',
            'bank': '#444444',
            'settings': '#444444',
            'new': '#295d02',
            'command': '#000000',
            'command2': '#a0008b',
            'coin': '#a95500',
            'alias': '#1e1e79',
            'key': '#073369'
        };
        this.local_aliases = []; // populate the 'searchable' stubs
        for(var l in this.local_aliases){
            var obj = this.local_aliases[l];
            obj['searchable'] = '' + obj['type'] + ' ' + obj['title'].toLowerCase();
        }
        var available_functions = {};
        function process_found_command(command_in, identifier_in) {
            console.log('   ', command_in, identifier_in);
        }
        for(var i in this.local_aliases){
            var obj = this.local_aliases[i];
            obj['color'] = this.label_colors[obj['type']];
        }
        this.loaded_indexes = [];
        this.selected_index = -1;
        this.runstate = 0;
        this.render();
    }
    render() {
        this.container.innerHTML = `
            <style>
                .spin{
                    width:42px;
                    position:absolute;
                    right:0px;
                    top:50%;
                    transform: translateY(-50%);
                }      
                .resu{
                    position:relative;
                    border-top: solid rgba(0, 85, 240, 0.24);
                    border-width:thin;
                    border-radius:0px;
                    margin-bottom:0px;
                    overflow:hidden;
                    font-size:12px;
                    cursor: pointer;
                    cursor: hand;
                    color:#AAAAAA;
                    margin-right:6px;
                    margin-left:6px;
                    background-color: rgba(15,15,15,0.7); }
                .res_icon{
                    width:25px;
                }
                .resutok{ background-color:white; border:solid #CCCCCC 1px; border-radius:10px; margin-bottom:4px; overflow:hidden; font-size:23px; text-align:center; padding:20px; }
                .colu{ display: inline-block;padding:9px;}
                .field1{ }
                .field2{/* width:25px; */
                    width:70px;
                    font-size:10px;
                    padding:8px;
                    margin-top:5px;
                }
                .field3{ }
                .colulast{
                    display: inline-block;
                    position:absolute;
                    right:3px;
                    margin: 11px;
                    top:1px;
                }
                .playi{ width:20px;  display: block; margin: 0 auto; }
                .active{ display:none; }
                .startsurv{
                    font-size:20px;
                    width:20px;
                    margin-left:18px;
                    text-align: right;}
                .light{ color:#CCCCCC; }
                
                .searchholder{
                    pointer-events: auto;
                    /* Remove margin:auto and margin-top, set to hug top */
                    min-width: 260px;
                    max-width: 408px;
                    margin: 0 auto;
                    padding: 0;
                    z-index: 10;
                }
                .form-group{margin-bottom: 10px;}
                .searchlogo{ position:absolute; left:8px; bottom:0px; vertical-align:bottom; font-size:13px; color:#9999BB; }
                #searchbox{ 
                    background-color:#060606;  
                    border: solid #444480 1px; 
                    color:#DDDDDD;
                    border-radius:0.55rem;}
                .octlogo{  width:44px; position:absolute; right:5px; margin-bottom:4px; }
                .survmessage{ font-size:10px; color:#888888; text-align:center; }
                .function_option_0{
                    text-align: center;
                    border: 0px;
                    background-color: #050531;
                    border-radius: 5px;
                    padding: 2px;
                }
                .function_option_1{
                    text-align: center;
                    border: -3px;
                    background-color: #011901;
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    padding: 2px;
                    padding-right: 14px;
                    padding-left: 14px;
                }

                .Center-Container {
                    position: absolute;
                    height:100%;
                    width:100%;
                }
                .Absolute-Center {
                    position: relative;
                    top: 50%;
                    -webkit-transform: translateY(-50%);
                    -ms-transform: translateY(-50%);
                    transform: translateY(-50%);
                }
                input:focus::-webkit-textfield-decoration-container {
                    visibility: hidden;
                    pointer-events: none;
                    position: absolute;
                    right: 0;
                }                  
            </style>

            <!--oooXXXooo-->
            <div class="searchholder">
                <div class="brand" style="margin-top:18px;">
                </div>
                <div class="form-groupXL" style="position:relative;" incomponent="true">
                    <input id='searchbox' type="text" class="form-control input-lg"  autocomplete="off" spellcheck="false" incomponent="true">
                    <img class="spin" src="/img/spinoff.png"/>
                    <img class="spin active" src="/img/spinner.gif" incomponent="true"/>
                </div>
                
                <div id="search_results">
                </div>
                <div class="searchcontainer">
                </div>
            </div>
            <!--oooXXXooo-->`;
        //this.spinr= $( this.querySelector('.active') )
        this.spinr = this.container.querySelector('.active');
        this.rez = (0, $bd2fb69ec5c665ce$export$2e2bcd8739ae039)(this.container.querySelector('#search_results'));
        this.restemplate = (0, $bd2fb69ec5c665ce$export$2e2bcd8739ae039)(this.container.querySelector("#searchitem"));
        (0, $bd2fb69ec5c665ce$export$2e2bcd8739ae039)(this).on('click', this.setSearchClick);
        (0, $bd2fb69ec5c665ce$export$2e2bcd8739ae039)(this.container.querySelector("#searchbox")).on('keydown paste', this.setSearchKeyDownPaste);
        (0, $bd2fb69ec5c665ce$export$2e2bcd8739ae039)(this.container.querySelector("#searchbox")).on('input', this.setSearchInput);
    }
    initEvent(e) {
        console.log(' init Event ');
        this.initStubs(e.detail.stubs);
    }
    initStubs(stbs) {
        this.local_aliases = stbs;
        for(var l in this.local_aliases){
            var obj = this.local_aliases[l];
            obj['searchable'] = '' + obj['type'] + ' ' + obj['title'].toLowerCase();
        }
        var available_functions = {};
        function process_found_command(command_in, identifier_in) {
            console.log('   ', command_in, identifier_in);
        }
        for(var i in this.local_aliases){
            var obj = this.local_aliases[i];
            obj['color'] = this.label_colors[obj['type']];
        }
        this.loaded_indexes = [];
        this.selected_index = -1;
        this.runstate = 0;
    }
    onSessionEvent(e) {
        if (e.detail.model.session.state == 1) this.container.style.display = 'inline';
        else this.container.style.display = 'none';
        // IF panels are open glide on screen 
        if (e.detail.model.session.panels_open) {
            var g = 5;
            this.drawer = document.querySelector('.searchholder');
            (0, $f7cabcf4b0e0fb2e$export$99ee26438460406a).to(this.drawer, {
                duration: 1,
                top: -90,
                ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
            });
        } else {
            //this.container.style.display='none'
            this.drawer = document.querySelector('.searchholder');
            (0, $f7cabcf4b0e0fb2e$export$99ee26438460406a).to(this.drawer, {
                duration: 1,
                top: 0,
                ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
            });
            var d = 5;
        }
    }
    termKeyUp(event) {}
    getItemTemplate(obj, ndx) {
        var file_name_yo = obj["type"];
        if (obj["type"] == 'bank') file_name_yo = obj["type"] + obj["title"].toLowerCase();
        var label_color = this.label_colors[obj.type];
        var item_template = `
            <div id="result">
                <div class="resu" ndx="${ndx}">
                    <div class="colu field1"><img class="res_icon" src="/img/${file_name_yo}.png"/></div>
                    <div class="colu field2 function_option_0" style="background-color:${label_color};">${obj.type}</div>
                    <div class="colu field3">${obj.title}</div>
                    <div class="colulast">\u{27A4}
                        <!--<img class="startsurv" src="img/play_button.png"></img>-->
                    </div>
                </div>
            </div>`;
        return item_template;
    }
    pushResultItemV2(obj_in, ndx) {
        var tmplt = this.getItemTemplate(obj_in, ndx);
        var tmpltobj = (0, $bd2fb69ec5c665ce$export$2e2bcd8739ae039)(tmplt);
        obj_in.element = tmpltobj.find('.resu');
        this.loaded_indexes.push(obj_in);
        tmpltobj.appendTo(this.rez);
    //this.rez[0].insertAdjacentHTML( 'beforeend', tmplt )
    }
    setSearchClick(e) {
        var resultdiv = (0, $bd2fb69ec5c665ce$export$2e2bcd8739ae039)(e.target).closest('.resu');
        if (resultdiv.length > 0) {
            var ndx = resultdiv.attr("ndx");
            this.selected_index = ndx;
            var selected_obj = this.loaded_indexes[this.selected_index];
            this.generateNavEvent(e);
            e.stopPropagation();
        }
    }
    setSearchKeyDownPaste(e) {
        //this.spinr.style.display = 'block';
        this.stopSpinner();
        this.rez.find('.resu').css("background-color", "rgba(14,14,14,0.7)");
        this.dispatchEvent(new CustomEvent('logEvent', {
            detail: {
                'message': 'Search INPUT'
            }
        }));
        e = e || window.event;
        if (e.keyCode == '9') {
            var update_search_with_this = this.loaded_indexes[0]['type'] + ' ';
            e.target.value = update_search_with_this; // set field 
            e.preventDefault(); // stop tab exit field 
            e.target.dispatchEvent(new Event('input', {
                bubbles: true
            }));
            var k = 3;
        } else if (e.keyCode == '38') {
            this.selected_index = this.selected_index >= 1 ? this.selected_index - 1 : this.selected_index;
            e.target.value = this.loaded_indexes[this.selected_index]['type'];
            //this.dispatchEvent( new CustomEvent('logEvent', { detail:{'message':'SELECT'} }) )
            this.loaded_indexes[this.selected_index].element.css("background-color", "rgba(0,152,254,0.5)") // INDIGO BG
            ;
        //this.loaded_indexes[ this.selected_index ].element.css("background-color", "rgba(254,0,0,0.5)")   // RED BG 
        } else if (e.keyCode == '40') {
            this.selected_index = this.selected_index + 1;
            e.target.value = this.loaded_indexes[this.selected_index]['type'];
            //this.dispatchEvent( new CustomEvent('logEvent', { detail:{'message':'SELECT'} }) )
            this.loaded_indexes[this.selected_index].element.css("background-color", "rgba(0,152,254,0.5)") // INDIGO BG
            ;
        //this.loaded_indexes[ this.selected_index ].element.css("background-color", "rgba(254,0,0,0.5)") // RED BG 
        } else if (e.keyCode == '13') {
            //this.generateNavEvent(e)
            // runstate = 'loading'      // RESTORE AFTER EVENT LISTENERES ARE WIRED
            // THIS ROLLED STATUS TEXT ONTO LOG TERMINAL: 
            // requestAnimationFrame( updateTossScroll )
            console.log(' BIG ENTER ');
            var what_is_selected = 0;
            //this.processSelectedItem();
            this.generateNavEvent(e);
        }
        e.stopPropagation();
    }
    setSearchInput(e) {
        this_pass_index = 0;
        this.spinr.style.display = 'block';
        this.rez.empty();
        var tosearch = (0, $bd2fb69ec5c665ce$export$2e2bcd8739ae039)(e.target).val().toLowerCase();
        this.loaded_indexes = [];
        this.selected_index = -1;
        var this_pass_index = 0;
        var search_tokens = tosearch.split(" ");
        if (tosearch != '') try {
            for(var i in this.local_aliases){
                var valx = this.local_aliases[i];
                //if( valx['type'].indexOf( tosearch ) !== -1 || valx['title'].indexOf( tosearch ) !== -1) {
                if (valx['searchable'].indexOf(tosearch) !== -1 || valx['title'].indexOf(tosearch) !== -1) {
                    if (this_pass_index < 9) this.pushResultItemV2(valx, this_pass_index);
                    this_pass_index++;
                }
            }
        } catch (e) {
            console.log(' no keys ', e);
        }
        if (tosearch.includes('0x')) try {
            this.pushResultItemV2({
                title: tosearch,
                type: 'new',
                color: 0xff0000
            }, 0);
        } catch (e) {
            console.log(' no keys ', e);
        }
        if ([
            'view',
            'list',
            'vehicle',
            'asset'
        ].indexOf(search_tokens[0]) >= 0) {
            if (search_tokens[1] && !isNaN(search_tokens[1])) //this.spinr.style.display='none'
            this.stopSpinner();
        } else this.stopSpinner();
    }
    startSpinner() {
        console.log(' firing spinner ');
    }
    stopSpinner() {
        this.spinr.style.display = 'block';
        setTimeout((function() {
            this.spinr.style.display = 'none';
        }).bind(this), 400);
    }
    generateNavEvent(e) {
        this.spinr.style.display = 'none';
        this.rez.empty();
        if ('target' in e && 'value' in e.target) this.qry = e.target.value;
        else this.qry = 'none';
        e.target.value = "";
        var selected_obj;
        if (this.selected_index < 0) {
            console.log(' regular search no stub or result ');
            selected_obj = {
                'qry': 'qrx=' + this.qry,
                'type': 'freesearch'
            };
        } else selected_obj = this.loaded_indexes[this.selected_index];
        var outbound_object = {};
        outbound_object['action'] = 'searchClick';
        outbound_object['type'] = selected_obj['type'];
        outbound_object['title'] = selected_obj['title'];
        outbound_object['item'] = selected_obj['item'];
        outbound_object['query'] = this.qry;
        var event = new CustomEvent('uiEvent', {
            detail: outbound_object,
            bubbles: true
        });
        this.dispatchEvent(event);
    }
    onDataUpdate(data_in) {
        this.printTerm(data_in);
    }
    printTerm(data_in) {
        //var xcontainer = this.shadowRoot.querySelector('.tickertapecontainer')
        //var xcontainer = document.querySelector('ticker-tape').shadow
        var xcontainer = this.shadow.querySelector('.termcontainer');
        xcontainer.innerHTML = '';
        var termlines = data_in;
        for(var t in termlines)xcontainer.insertAdjacentHTML('beforeend', '<div>QUICK STRING</div>');
    }
    toggleSearch() {
    /*
        var searchopen = 1;
        function searchToggle( e){
        if( searchopen){
            searchopen=0;
            TweenMax.to('.searchholder', 1, { ease:Expo.easeOut, top: -86+'px'});
        }else{
            searchopen=1;
            TweenMax.to('.searchholder', 1, { ease:Expo.easeOut, top: 0+'px'});
        }
        }*/ }
    openPanel() {
        this.drawer_open = 1;
        this.drawer = this.con.querySelector('#slide_drawer2');
        (0, $f7cabcf4b0e0fb2e$export$99ee26438460406a).to(this.drawer, {
            duration: 1,
            right: 0,
            ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
        });
    }
    closePanel() {
        this.drawer_open = 0;
        this.drawer = this.con.querySelector('#slide_drawer2');
        (0, $f7cabcf4b0e0fb2e$export$99ee26438460406a).to(this.drawer, {
            duration: 1,
            right: -350,
            ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
        });
    }
}
var $147756b0f58bc411$export$2e2bcd8739ae039 /*termKeyUpp=( event )=>{     //// TEST THIS IN FUTURE SAFARI / WEBKIT
        console.log('wow term') // WORKS IN CHROME, BUT BREAKS IN SAFARI
    }*/  = $147756b0f58bc411$var$SearchMod;









var $fzZ9h = parcelRequire("fzZ9h");
var $b15991d11dfc94c1$var$count = 11;
class $b15991d11dfc94c1$export$5631afde407885cb extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    constructor(initObj){
        super(initObj);
        // better to have initObj ? 
        // if 'container' in initObj else 'body'
        // if 'data' in initObj else {}
        // if 'id' in initObj else 'qr'
        this.count = 1000;
        var node = initObj.data;
        this.node = initObj.data;
        this.initObj = initObj;
        this.uuid = initObj.slot;
        this.model = node && node.model ? node.model : {};
        var label = node.data.labels ? node.data.labels[0] : node.data.label.toLowerCase();
        /*
        container_in.insertAdjacentHTML( 'beforeend' , factory2d.renderSync( 'qr', obj.data ) );
        var qr_panels = container_in.querySelectorAll('#qr')
        var panel = qr_panels[ qr_panels.length-1 ] 
        panel.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
        panel.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="1" modulesize="2"></qr-code>' );
        panel.querySelector('#supereditabletitle').addEventListener('input', function(e){
            //console.log('what input',e.target.value,data_in.uuid, this.model )
            this.model.updateObject( obj.data.uuid , { name:e.target.value } )
        }.bind(this)) */ var vnode = (0, $fzZ9h.factory2d).renderNodeSync('qr', node.data);
        var functionality_map_of_fields = {
            'xclass': {
                'display1': 'name',
                'display2': 'price'
            },
            'alias': {
                'display1': 'name',
                'display2': 'price'
            },
            'repo': {
                'display1': 'name',
                'display2': 'label'
            }
        };
        //  this.inject( vnode , obj.data )
        // TEMP SUSPEND GLYPH INJECT UNTIL PERFORMANCE FIX FOR ICONS: 
        //vnode.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
        //vnode.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="0" modulesize="2"></qr-code>' );
        // ITEM QR 
        var qr = new (0, $e1d36db1977d2c76$export$2e2bcd8739ae039)({
            //url: "https://github.com/chuckfairy/VanillQR.js",
            url: "http://vi55tiaddhereIDandURL",
            size: 80,
            colorLight: "#00000000",
            colorDark: "#00FFFF",
            toTable: false,
            ecclevel: 1,
            noBorder: true,
            borderSize: 4 //Border size to output at
        });
        vnode.querySelector('#qrbox').appendChild(qr.domElement);
        // ITEM LOGO
        var brnd = (0, $440781629901dd2f$export$2e2bcd8739ae039).xclass_brand(label, 'brand', node.payload);
        if (brnd) {
            var domain_elem = document.createElement("img");
            domain_elem.src = brnd;
            domain_elem.style.display = 'block';
            domain_elem.style.marginLeft = "4px";
            domain_elem.style.width = vnode.querySelector('#qrbox').children[0].width + 'px';
            vnode.querySelector('#domainbox').appendChild(domain_elem);
        }
        // POPULATE FIELDS: ( here bi-modal-destructure[]{} didnt work. )
        var disps = (0, $440781629901dd2f$export$2e2bcd8739ae039).xclass_method_object(label, 'display', node.data);
        vnode.querySelector('#display1').value = disps[0];
        vnode.querySelector('#display2').value = disps[1];
        // FLIP TOP ICONS
        //if( 'ndx' in initObj && initObj.ndx >1 ){
        //    vnode.querySelector('.iditemholder').style.flexDirection='row-reverse';    
        //}
        vnode.querySelector('#display1').addEventListener('input', (function(e) {
            // console.log('what input',e.target.value,data_in.uuid, this.model )
            // var updateObj = {} // updateObj[ field_aliases[ data.label ][ 'display1'] ] = e.target.value;
            // would resolve to: field_aliases[ 'repo' ]['display1'] => 'name'; 
            // => updateObject=> { 'name':e.target.value }
            this.model.updateObject(node.id, {
                name: e.target.value
            });
        }).bind(this));
        vnode.querySelector('.mode_button').addEventListener('click', (function(e) {
            console.log('  SAVE OBJECT:   ');
            // WURD 
            this.model.saveObject(node);
        }).bind(this));
        vnode.querySelector('#buttonfork').addEventListener('click', (function(e) {
            // WURD 
            this.model.forkObject(node);
            console.log('fork ');
        }).bind(this));
        // PASS THE NODE MODIFIABLE DATA ONLY 
        const { body: body, links: links, plane: plane, sprite: sprite, tele: tele, ...allExceptThe } = node.data;
        // Add listener for RESET button
        const resetBtn = vnode.querySelector('#buttonreset');
        if (resetBtn) resetBtn.addEventListener('click', (function(e) {
            // Create a tiny file navigation window (file input)
            let fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.style.display = 'none';
            document.body.appendChild(fileInput);
            // When a file is selected
            fileInput.addEventListener('change', function(event) {
                const file = event.target.files[0];
                if (!file) {
                    document.body.removeChild(fileInput);
                    return;
                }
                // Prepare form data
                const formData = new FormData();
                formData.append('file', file);
                var uploadposturl = '/initcreds';
                if (node.data && node.data.initurl) uploadposturl = node.data.initurl;
                // POST to /initcreds
                fetch(uploadposturl, {
                    method: 'POST',
                    body: formData
                }).then((response)=>{
                    if (!response.ok) throw new Error('Upload failed');
                    return response.json ? response.json() : response.text();
                }).then((data)=>{
                    alert('File uploaded successfully!');
                }).catch((err)=>{
                    alert('File upload failed: ' + err.message);
                }).finally(()=>{
                    document.body.removeChild(fileInput);
                });
            });
            // Trigger file dialog
            fileInput.click();
        }).bind(this));
        // CONTAINER KVS 
        var kvals = {
            origin: node.origin || 'NEW',
            type: node.type || 'unknown',
            slot: node.slot || '00000001'
        };
        this.kvsc = new (0, $3494c43f722f695b$export$1e2124d9bec1f71d)({
            container: vnode.querySelector('#qr_keyval'),
            data: kvals
        });
        this.kvsc.addEventListener('kvInputEvent', (function(e) {
            console.log(' QR hears kvInputEvent ');
            this.model.updateObject(this.node, e.detail);
        }).bind(this));
        // PAYLOAD KVS 
        this.kvs = new (0, $3494c43f722f695b$export$1e2124d9bec1f71d)({
            container: vnode.querySelector('#qr_keyval1'),
            data: node.payload,
            color: true
        });
        this.kvs.addEventListener('kvInputEvent', (function(e) {
            console.log(' QR hears kvInputEvent ');
            this.model.updateObject(this.node, e.detail);
        }).bind(this));
        // SHOW NESTED PROPERTIES 
        if (node.payload.properties) {
            this.kvs = new (0, $3494c43f722f695b$export$1e2124d9bec1f71d)({
                container: vnode.querySelector('#qr_keyval2'),
                data: node.payload.properties
            });
            this.kvs.addEventListener('kvInputEvent', (function(e) {
                this.model.updateObject(this.node.payload.properties, e.detail);
            }).bind(this));
        }
        initObj.target.appendChild(vnode);
    //var shadow = this.attachShadow({mode: 'open'});
    //shadow.innerHTML = `<p>Hello, ${ wot }</p>`;
    // attach custom listeners 
    //con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
    // fil in the image from obj
    // con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
    }
    onDataUpdate(data_in) {}
    increment() {
        $b15991d11dfc94c1$var$count += 1;
        return {
            count: $b15991d11dfc94c1$var$count,
            thiscount: this.count
        };
    }
    increment2() {
        this.count += 1;
        return {
            count: $b15991d11dfc94c1$var$count,
            thiscount: this.count
        };
    }
}
 //var gl = new gluemapper( { fieldname: })
 //var DISP1 = gluemapper.pull( obj.data , label , 0 )
 //var DISP2 = gluemapper.pull( obj.data , label , 1 )
 // THIS WILL SHORTLY REPLACE THE TWO LINES ABOVE: 
 //







var $fzZ9h = parcelRequire("fzZ9h");
var $1500b689e3519186$var$count = 11;
class $1500b689e3519186$export$5beeae30d1389e5 extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    constructor(initObj){
        super(initObj);
        // better to have initObj ? 
        // if 'container' in initObj else 'body'
        // if 'data' in initObj else {}
        // if 'id' in initObj else 'qr'
        var node = initObj.data;
        /*
        this.count = 1000;
        this.node=initObj.data;
        this.initObj = initObj;
        this.uuid = initObj.slot;
        this.model = ( node &&  node.model ) ? node.model : {} ;
        var label= node.data.labels ? node.data.labels[0] : node.data.label.toLowerCase();
        
        /*
        container_in.insertAdjacentHTML( 'beforeend' , factory2d.renderSync( 'qr', obj.data ) );
        var qr_panels = container_in.querySelectorAll('#qr')
        var panel = qr_panels[ qr_panels.length-1 ] 
        panel.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
        panel.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="1" modulesize="2"></qr-code>' );
        panel.querySelector('#supereditabletitle').addEventListener('input', function(e){
            //console.log('what input',e.target.value,data_in.uuid, this.model )
            this.model.updateObject( obj.data.uuid , { name:e.target.value } )
        }.bind(this)) */ var vnode = (0, $fzZ9h.factory2d).renderNodeSync('outline', node.data);
        var functionality_map_of_fields = {
            'xclass': {
                'display1': 'name',
                'display2': 'price'
            },
            'alias': {
                'display1': 'name',
                'display2': 'price'
            },
            'repo': {
                'display1': 'name',
                'display2': 'label'
            }
        };
        vnode.querySelector('#mainname').innerHTML = node.data.name;
        // vnode.querySelector('#else').appendChild(qr.domElement);
        //  this.inject( vnode , obj.data )
        // TEMP SUSPEND GLYPH INJECT UNTIL PERFORMANCE FIX FOR ICONS: 
        //vnode.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
        //vnode.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="0" modulesize="2"></qr-code>' );
        // ITEM QR 
        // var qr = new VanillaQR({
        //     //url: "https://github.com/chuckfairy/VanillQR.js",
        //     url: 'http://vi55ti'+'addhereIDandURL',
        //     size: 80,
        //     colorLight: "#00000000",
        //     colorDark: "#00FFFF",
        //     toTable: false,//output to table or canvas
        //     ecclevel: 1,//Ecc correction level 1-4
        //     noBorder:true,//Use a border or not
        //     borderSize: 4//Border size to output at
        // });
        // vnode.querySelector('#qrbox').appendChild(qr.domElement);
        // ITEM LOGO
        // var brnd = gluemapper.xclass_brand( label , 'brand', node.payload )
        // if( brnd ){
        //     var domain_elem = document.createElement("img");
        //     domain_elem.src = brnd;
        //     domain_elem.style.display='block';
        //     domain_elem.style.marginLeft = "4px";
        //     domain_elem.style.width=vnode.querySelector('#qrbox').children[0].width+'px';
        //     vnode.querySelector('#domainbox').appendChild(domain_elem);
        // }
        // // POPULATE FIELDS: ( here bi-modal-destructure[]{} didnt work. )
        // var disps = gluemapper.xclass_method_object( label , 'display', node.data  )
        // vnode.querySelector('#display1').value = disps[0]
        // vnode.querySelector('#display2').value = disps[1]
        // FLIP TOP ICONS
        //if( 'ndx' in initObj && initObj.ndx >1 ){
        //    vnode.querySelector('.iditemholder').style.flexDirection='row-reverse';    
        //}
        // vnode.querySelector('#display1').addEventListener('input', function(e){
        //     // console.log('what input',e.target.value,data_in.uuid, this.model )
        //     // var updateObj = {} // updateObj[ field_aliases[ data.label ][ 'display1'] ] = e.target.value;
        //     // would resolve to: field_aliases[ 'repo' ]['display1'] => 'name'; 
        //     // => updateObject=> { 'name':e.target.value }
        //     this.model.updateObject( node.id , { name:e.target.value } )
        // }.bind(this))        
        // vnode.querySelector('.mode_button').addEventListener('click', function(e){
        //     console.log('  SAVE OBJECT:   ')
        //     // WURD 
        //     this.model.saveObject( node )
        // }.bind(this))     
        // vnode.querySelector('#buttonfork').addEventListener('click', function(e){
        //     // WURD 
        //     this.model.forkObject( node )
        //     console.log( 'fork ')
        // }.bind(this))     
        // PASS THE NODE MODIFIABLE DATA ONLY 
        // const { body, links,plane,sprite,tele, ...allExceptThe } = node.data;
        // // Add listener for RESET button
        // const resetBtn = vnode.querySelector('#buttonreset');
        // if (resetBtn) {
        //     resetBtn.addEventListener('click', function(e) {
        //         // Create a tiny file navigation window (file input)
        //         let fileInput = document.createElement('input');
        //         fileInput.type = 'file';
        //         fileInput.style.display = 'none';
        //         document.body.appendChild(fileInput);
        //         // When a file is selected
        //         fileInput.addEventListener('change', function(event) {
        //             const file = event.target.files[0];
        //             if (!file) {
        //                 document.body.removeChild(fileInput);
        //                 return;
        //             }
        //             // Prepare form data
        //             const formData = new FormData();
        //             formData.append('file', file);
        //             var uploadposturl = '/initcreds'
        //             if( node.data && node.data.initurl ){
        //                 uploadposturl = node.data.initurl
        //             }
        //             // POST to /initcreds
        //             fetch( uploadposturl, {
        //                 method: 'POST',
        //                 body: formData
        //             })
        //             .then(response => {
        //                 if (!response.ok) throw new Error('Upload failed');
        //                 return response.json ? response.json() : response.text();
        //             })
        //             .then(data => {
        //                 alert('File uploaded successfully!');
        //             })
        //             .catch(err => {
        //                 alert('File upload failed: ' + err.message);
        //             })
        //             .finally(() => {
        //                 document.body.removeChild(fileInput);
        //             });
        //         });
        //         // Trigger file dialog
        //         fileInput.click();
        //     }.bind(this));
        // }
        // // CONTAINER KVS 
        // var kvals = { origin:node.origin||'NEW' , type:node.type||'unknown' , slot:node.slot||'00000001' } ;
        // this.kvsc = new Kvs( { container: vnode.querySelector('#qr_keyval') , data:kvals }  )
        // this.kvsc.addEventListener( 'kvInputEvent' , function(e){
        //     console.log(' QR hears kvInputEvent ')
        //     this.model.updateObject( this.node  , e.detail  )
        // }.bind(this));                
        // // PAYLOAD KVS 
        // this.kvs = new Kvs( { container: vnode.querySelector('#qr_keyval1') , data:node.payload  , color:true }  )
        // this.kvs.addEventListener( 'kvInputEvent' , function(e){
        //     console.log(' QR hears kvInputEvent ')
        //     this.model.updateObject( this.node , e.detail  )
        // }.bind(this));
        // SHOW NESTED PROPERTIES 
        // if( node.payload.properties ){
        //     this.kvs = new Kvs( { container: vnode.querySelector('#qr_keyval2') , data:node.payload.properties  }  )
        //     this.kvs.addEventListener( 'kvInputEvent' , function(e){
        //         this.model.updateObject( this.node.payload.properties , e.detail  )
        //     }.bind(this));      
        // }
        node.target.appendChild(vnode);
    //var shadow = this.attachShadow({mode: 'open'});
    //shadow.innerHTML = `<p>Hello, ${ wot }</p>`;
    // attach custom listeners 
    //con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
    // fil in the image from obj
    // con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
    }
    onDataUpdate(data_in) {}
    increment() {
        $1500b689e3519186$var$count += 1;
        return {
            count: $1500b689e3519186$var$count,
            thiscount: this.count
        };
    }
    increment2() {
        this.count += 1;
        return {
            count: $1500b689e3519186$var$count,
            thiscount: this.count
        };
    }
}
 //var gl = new gluemapper( { fieldname: })
 //var DISP1 = gluemapper.pull( obj.data , label , 0 )
 //var DISP2 = gluemapper.pull( obj.data , label , 1 )
 // THIS WILL SHORTLY REPLACE THE TWO LINES ABOVE: 
 //







var $fzZ9h = parcelRequire("fzZ9h");
var $8199d96972f5e4cd$var$count = 11;
class $8199d96972f5e4cd$export$47eb42ff093406d4 extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    constructor(initObj){
        super(initObj);
        // better to have initObj ? 
        // if 'container' in initObj else 'body'
        // if 'data' in initObj else {}
        // if 'id' in initObj else 'qr'
        this.count = 1000;
        var node = initObj.data;
        this.node = initObj.data;
        this.initObj = initObj;
        this.uuid = initObj.slot;
        this.model = node.model;
        var label = node.payload.labels ? node.payload.labels[0] : node.payload.label.toLowerCase();
        /*
        container_in.insertAdjacentHTML( 'beforeend' , factory2d.renderSync( 'qr', obj.data ) );
        var qr_panels = container_in.querySelectorAll('#qr')
        var panel = qr_panels[ qr_panels.length-1 ] 
        panel.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
        panel.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="1" modulesize="2"></qr-code>' );
        panel.querySelector('#supereditabletitle').addEventListener('input', function(e){
            //console.log('what input',e.target.value,data_in.uuid, this.model )
            this.model.updateObject( obj.data.uuid , { name:e.target.value } )
        }.bind(this)) */ var vnode = (0, $fzZ9h.factory2d).renderNodeSync('qr', node.payload);
        var functionality_map_of_fields = {
            'xclass': {
                'display1': 'name',
                'display2': 'price'
            },
            'alias': {
                'display1': 'name',
                'display2': 'price'
            },
            'repo': {
                'display1': 'name',
                'display2': 'label'
            }
        };
        // YOU ARE HERE 
        // NEXT STEP IS  
        // 
        //this.inject( vnode , obj.data )
        // TEMP SUSPEND GLYPH INJECT UNTIL PERFORMANCE FIX FOR ICONS: 
        //vnode.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
        //vnode.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="0" modulesize="2"></qr-code>' );
        // ITEM QR 
        var qr = new (0, $e1d36db1977d2c76$export$2e2bcd8739ae039)({
            //url: "https://github.com/chuckfairy/VanillQR.js",
            url: "http://vi55tiaddhereIDandURL",
            size: 80,
            colorLight: "#00000000",
            colorDark: "#00FFFF",
            toTable: false,
            ecclevel: 1,
            noBorder: true,
            borderSize: 4 //Border size to output at
        });
        vnode.querySelector('#qrbox').appendChild(qr.domElement);
        // ITEM LOGO
        var brnd = (0, $440781629901dd2f$export$2e2bcd8739ae039).xclass_brand(label, 'brand', node.payload);
        if (brnd) {
            var domain_elem = document.createElement("img");
            domain_elem.src = brnd;
            domain_elem.style.display = 'block';
            domain_elem.style.marginLeft = "4px";
            domain_elem.style.width = vnode.querySelector('#qrbox').children[0].width + 'px';
            vnode.querySelector('#domainbox').appendChild(domain_elem);
        }
        // POPULATE FIELDS: ( here bi-modal-destructure[]{} didnt work. )
        var disps = (0, $440781629901dd2f$export$2e2bcd8739ae039).xclass_method_object(label, 'display', node.data);
        vnode.querySelector('#display1').value = disps[0];
        vnode.querySelector('#display2').value = disps[1];
        // FLIP TOP ICONS
        //if( 'ndx' in initObj && initObj.ndx >1 ){
        //    vnode.querySelector('.iditemholder').style.flexDirection='row-reverse';    
        //}
        vnode.querySelector('#display1').addEventListener('input', (function(e) {
            // console.log('what input',e.target.value,data_in.uuid, this.model )
            // var updateObj = {} // updateObj[ field_aliases[ data.label ][ 'display1'] ] = e.target.value;
            // would resolve to: field_aliases[ 'repo' ]['display1'] => 'name'; 
            // => updateObject=> { 'name':e.target.value }
            this.model.updateObject(node.id, {
                name: e.target.value
            });
        }).bind(this));
        vnode.querySelector('.mode_button').addEventListener('click', (function(e) {
            console.log('  SAVE OBJECT:   ');
            // WURD 
            this.model.saveObject(node);
        }).bind(this));
        // PASS THE NODE MODIFIABLE DATA ONLY 
        const { body: body, links: links, plane: plane, sprite: sprite, tele: tele, ...allExceptThe } = node.data;
        // CONTAINER KVS 
        var kvals = {
            origin: node.origin || 'NEW',
            type: node.type || 'unknown',
            slot: node.slot || '00000001'
        };
        this.kvsc = new (0, $3494c43f722f695b$export$1e2124d9bec1f71d)({
            container: vnode.querySelector('#qr_keyval'),
            data: kvals
        });
        this.kvsc.addEventListener('kvInputEvent', (function(e) {
            console.log(' QR hears kvInputEvent ');
            this.model.updateObject(this.node, e.detail);
        }).bind(this));
        // PAYLOAD KVS 
        this.kvs = new (0, $3494c43f722f695b$export$1e2124d9bec1f71d)({
            container: vnode.querySelector('#qr_keyval1'),
            data: node.payload
        });
        this.kvs.addEventListener('kvInputEvent', (function(e) {
            console.log(' QR hears kvInputEvent ');
            this.model.updateObject(this.node, e.detail);
        }).bind(this));
        // SHOW NESTED PROPERTIES 
        if (node.payload.properties) {
            this.kvs = new (0, $3494c43f722f695b$export$1e2124d9bec1f71d)({
                container: vnode.querySelector('#qr_keyval2'),
                data: node.payload.properties
            });
            this.kvs.addEventListener('kvInputEvent', (function(e) {
                this.model.updateObject(this.node.payload.properties, e.detail);
            }).bind(this));
        }
        initObj.target.appendChild(vnode);
    //var shadow = this.attachShadow({mode: 'open'});
    //shadow.innerHTML = `<p>Hello, ${ wot }</p>`;
    // attach custom listeners 
    //con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
    // fil in the image from obj
    // con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
    }
    onDataUpdate(data_in) {}
    increment() {
        $8199d96972f5e4cd$var$count += 1;
        return {
            count: $8199d96972f5e4cd$var$count,
            thiscount: this.count
        };
    }
    increment2() {
        this.count += 1;
        return {
            count: $8199d96972f5e4cd$var$count,
            thiscount: this.count
        };
    }
}
 //var gl = new gluemapper( { fieldname: })
 //var DISP1 = gluemapper.pull( obj.data , label , 0 )
 //var DISP2 = gluemapper.pull( obj.data , label , 1 )
 // THIS WILL SHORTLY REPLACE THE TWO LINES ABOVE: 
 //







var $fzZ9h = parcelRequire("fzZ9h");
var $48ed57f132e58e1a$var$count = 11;
class $48ed57f132e58e1a$export$9b1e7b004bf806af extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    constructor(initObj){
        super(initObj);
        // better to have initObj ? 
        // if 'container' in initObj else 'body'
        // if 'data' in initObj else {}
        // if 'id' in initObj else 'qr'
        this.count = 1000;
        var obj = initObj.data;
        this.initObj = initObj;
        this.uuid = initObj.data.data.uuid;
        this.model = obj.data.model;
        var label = "inserted";
        if ('label' in obj.data) label = obj.data.label.toLowerCase();
        /*
        container_in.insertAdjacentHTML( 'beforeend' , factory2d.renderSync( 'qr', obj.data ) );
        var qr_panels = container_in.querySelectorAll('#qr')
        var panel = qr_panels[ qr_panels.length-1 ] 
        panel.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
        panel.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="1" modulesize="2"></qr-code>' );
        panel.querySelector('#supereditabletitle').addEventListener('input', function(e){
            //console.log('what input',e.target.value,data_in.uuid, this.model )
            this.model.updateObject( obj.data.uuid , { name:e.target.value } )
        }.bind(this)) */ var vnode = (0, $fzZ9h.factory2d).renderNodeSync('buysell', obj.data);
        var functionality_map_of_fields = {
            'xclass': {
                'display1': 'name',
                'display2': 'price'
            },
            'alias': {
                'display1': 'name',
                'display2': 'price'
            },
            'repo': {
                'display1': 'name',
                'display2': 'label'
            }
        };
        //this.inject( vnode , obj.data )
        // TEMP SUSPEND GLYPH INJECT UNTIL PERFORMANCE FIX FOR ICONS: 
        //vnode.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
        //vnode.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="0" modulesize="2"></qr-code>' );
        // ITEM QR 
        var qr = new (0, $e1d36db1977d2c76$export$2e2bcd8739ae039)({
            //url: "https://github.com/chuckfairy/VanillQR.js",
            url: 'http://vi55ti' + obj.data.uuid,
            size: 80,
            colorLight: "#00000000",
            colorDark: "#00FFFF",
            toTable: false,
            ecclevel: 1,
            noBorder: true,
            borderSize: 4 //Border size to output at
        });
        //vnode.querySelector('#qrbox').appendChild(qr.domElement);
        // ITEM LOGO
        if ('domain' in obj.data) {
            var domain_elem = document.createElement("img");
            domain_elem.src = 'media/domain/' + obj.data.domain + '.png';
            domain_elem.style.display = 'block';
            domain_elem.style.marginLeft = "4px";
            domain_elem.style.width = vnode.querySelector('#qrbox').children[0].width + 'px';
            vnode.querySelector('#domainbox').appendChild(domain_elem);
        }
        // POPULATE FIELDS: ( here bi-modal-destructure[]{} didnt work. )
        var disps = (0, $440781629901dd2f$export$2e2bcd8739ae039).xclass_method_object(label, 'display', obj.data);
        //vnode.querySelector('#display1').value = disps[0]
        //vnode.querySelector('#display2').value = disps[1]
        // FLIP TOP ICONS
        //if( 'ndx' in initObj && initObj.ndx >1 ){
        //    vnode.querySelector('.iditemholder').style.flexDirection='row-reverse';    
        //}
        // vnode.querySelector('#display1').addEventListener('input', function(e){
        //     // console.log('what input',e.target.value,data_in.uuid, this.model )
        //     // var updateObj = {} // updateObj[ field_aliases[ data.label ][ 'display1'] ] = e.target.value;
        //     // would resolve to: field_aliases[ 'repo' ]['display1'] => 'name'; 
        //     // => updateObject=> { 'name':e.target.value }
        //     this.model.updateObject( obj.data.uuid , { name:e.target.value } )
        // }.bind(this))        
        // PASS THE NODE MODIFIABLE DATA ONLY 
        const { body: body, links: links, plane: plane, sprite: sprite, tele: tele, ...allExceptThe } = obj.data;
        var trobj = {
            trans: 'NCNC1',
            id: '0x0a3e2a436a'
        };
        this.kvs = new (0, $3494c43f722f695b$export$1e2124d9bec1f71d)({
            container: vnode.querySelector('#qr_keyval'),
            data: trobj
        });
        this.kvs.addEventListener('kvInputEvent', (function(e) {
            console.log(' QR hears kvInputEvent ');
            this.model.updateObject(this.uuid, e.detail);
        }).bind(this));
        initObj.target.appendChild(vnode);
    //var shadow = this.attachShadow({mode: 'open'});
    //shadow.innerHTML = `<p>Hello, ${ wot }</p>`;
    // attach custom listeners 
    //con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
    // fil in the image from obj
    // con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
    }
    onDataUpdate(data_in) {}
    increment() {
        $48ed57f132e58e1a$var$count += 1;
        return {
            count: $48ed57f132e58e1a$var$count,
            thiscount: this.count
        };
    }
    increment2() {
        this.count += 1;
        return {
            count: $48ed57f132e58e1a$var$count,
            thiscount: this.count
        };
    }
}
 //var gl = new gluemapper( { fieldname: })
 //var DISP1 = gluemapper.pull( obj.data , label , 0 )
 //var DISP2 = gluemapper.pull( obj.data , label , 1 )
 // THIS WILL SHORTLY REPLACE THE TWO LINES ABOVE: 
 //







var $fzZ9h = parcelRequire("fzZ9h");
class $580abc179c9a1949$export$54c2e3dc7acea9f5 extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    constructor(initObj){
        super(initObj);
        // better to have initObj ? 
        // if 'container' in initObj else 'body'
        // if 'data' in initObj else {}
        // if 'id' in initObj else 'qr'
        var obj = initObj.data;
        this.initObj = initObj;
        this.uuid = initObj.data.data.uuid;
        this.model = obj.data.model;
        var label = obj.data.label.toLowerCase();
        /*
        container_in.insertAdjacentHTML( 'beforeend' , factory2d.renderSync( 'qr', obj.data ) );
        var qr_panels = container_in.querySelectorAll('#qr')
        var panel = qr_panels[ qr_panels.length-1 ] 
        panel.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
        panel.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="1" modulesize="2"></qr-code>' );
        panel.querySelector('#supereditabletitle').addEventListener('input', function(e){
            //console.log('what input',e.target.value,data_in.uuid, this.model )
            this.model.updateObject( obj.data.uuid , { name:e.target.value } )
        }.bind(this)) */ var vnode = (0, $fzZ9h.factory2d).renderNodeSync('list', obj.data);
        var functionality_map_of_fields = {
            'xclass': {
                'display1': 'name',
                'display2': 'price'
            },
            'alias': {
                'display1': 'name',
                'display2': 'price'
            },
            'repo': {
                'display1': 'name',
                'display2': 'label'
            }
        };
        //this.inject( vnode , obj.data )
        // TEMP SUSPEND GLYPH INJECT UNTIL PERFORMANCE FIX FOR ICONS: 
        //vnode.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
        //vnode.querySelector('#qrbox').insertAdjacentHTML( 'afterbegin' , '<qr-code data="'+label+'" margin="0" modulesize="2"></qr-code>' );
        /*
        // ITEM QR 
        var qr = new VanillaQR({
            //url: "https://github.com/chuckfairy/VanillQR.js",
            url: 'http://vi55ti'+obj.data.uuid,
            size: 80,
            colorLight: "#00000000",
            colorDark: "#00FFFF",
            toTable: false,//output to table or canvas
            ecclevel: 1,//Ecc correction level 1-4
            noBorder:true,//Use a border or not
            borderSize: 4//Border size to output at
        });
        vnode.querySelector('#qrbox').appendChild(qr.domElement);

        // ITEM LOGO
        if( 'domain' in obj.data ){
            var domain_elem = document.createElement("img");
            domain_elem.src = 'media/domain/'+obj.data.domain+'.png';
            domain_elem.style.display='block';
            domain_elem.style.marginLeft = "4px";
            domain_elem.style.width=vnode.querySelector('#qrbox').children[0].width+'px';
            vnode.querySelector('#domainbox').appendChild(domain_elem);
        }

        //var gl = new gluemapper( { fieldname: })

        var DISP1 = gluemapper.pull( obj.data , label , 0 )
        var DISP2 = gluemapper.pull( obj.data , label , 1 )

        vnode.querySelector('#display1').value= DISP1
        vnode.querySelector('#display2').value= DISP2
        vnode.querySelector('#display1').addEventListener('input', function(e){
            // console.log('what input',e.target.value,data_in.uuid, this.model )
            // var updateObj = {} // updateObj[ field_aliases[ data.label ][ 'display1'] ] = e.target.value;
            // would resolve to: field_aliases[ 'repo' ]['display1'] => 'name'; 
            // => updateObject=> { 'name':e.target.value }
            this.model.updateObject( obj.data.uuid , { name:e.target.value } )
        }.bind(this))        
        
        */ // FLIP TOP ICONS
        //if( 'ndx' in initObj && initObj.ndx >1 ){
        //    vnode.querySelector('.iditemholder').style.flexDirection='row-reverse';    
        //}
        //var sym = '3f';
        //var vll = 'X'
        // let dv2 = document.createElement('div');
        // dv2.innerHTML = this.itemTemplate2( { symbol:sym, price:vll } );
        // vnode.insertAdjacentHTML( 'beforeend', dv2.innerHTML );
        obj.data.price = Math.random();
        var objlist = obj.model.focusIndex;
        var subnode;
        for(var o in objlist){
            var nod = objlist[o];
            subnode = (0, $fzZ9h.factory2d).renderNodeSync('listitem', nod.data);
            vnode.appendChild(subnode);
        }
        // subnode = factory2d.renderNodeSync( 'listitem', {name:'Hong Kong', price:'$32,000 / CM' } );
        // vnode.appendChild( subnode );
        // obj.data.price = Math.random();
        // subnode = factory2d.renderNodeSync( 'listitem', {name:'Argentina', price:'$36,000 / Cap M' } );
        // vnode.appendChild( subnode );        
        // obj.data.price = Math.random();
        // subnode = factory2d.renderNodeSync( 'listitem', {name:'United States', price:'$11,000 / cap' } );
        // vnode.appendChild( subnode );      
        // obj.data.price = Math.random();
        // subnode = factory2d.renderNodeSync( 'listitem', {name:'China', price:'$12/cap' } );
        // vnode.appendChild( subnode );        
        // obj.data.price = Math.random();
        // subnode = factory2d.renderNodeSync( 'listitem', {name:'South Korea', price:'$11/cap' } );
        // vnode.appendChild( subnode );     
        // obj.data.price = Math.random();
        // subnode = factory2d.renderNodeSync( 'listitem', {name:'Tritun', price:'$30,000/gram' } );
        // vnode.appendChild( subnode );       
        // obj.data.price = Math.random();
        // subnode = factory2d.renderNodeSync( 'listitem', {name:'GOLD', price:'$1,400/gram' } );
        // vnode.appendChild( subnode );    
        // obj.data.price = Math.random();
        // subnode = factory2d.renderNodeSync( 'listitem', {name:'Water Liter', price:'$10/liter' } );
        // vnode.appendChild( subnode );       
        // obj.data.price = Math.random();
        // subnode = factory2d.renderNodeSync( 'listitem', {name:'Silver AG', price:'$1,400/gram' } );
        // vnode.appendChild( subnode );                             
        // obj.data.price = Math.random();
        // subnode = factory2d.renderNodeSync( 'listitem', {name:'StarLINK', price:'$532/share' } );
        // vnode.appendChild( subnode );       
        // obj.data.price = Math.random();
        // subnode = factory2d.renderNodeSync( 'listitem', {name:'AIR METER', price:'$1,400/m3' } );
        // vnode.appendChild( subnode );                             
        //initObj.target.appendChild( vnode )
        // PASS THE NODE MODIFIABLE DATA ONLY 
        /*
        const { body, links,plane,sprite,tele, ...allExceptThe } = obj.data;
        this.kvs = new Kvs( { container: vnode.querySelector('#qr_keyval') , data:allExceptThe  }  )

        this.kvs.addEventListener( 'kvInputEvent' , function(e){
            console.log(' QR hears kvInputEvent ')
            this.model.updateObject( this.uuid , e.detail  )
        }.bind(this));
        */ initObj.target.appendChild(vnode);
    //var shadow = this.attachShadow({mode: 'open'});
    //shadow.innerHTML = `<p>Hello, ${ wot }</p>`;
    // attach custom listeners 
    //con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
    // fil in the image from obj
    // con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';
    }
    itemTemplate2(obj_in) {
        let template_item = `
            <div class="griditem">
                <div class="griditemcolumn">
                    ${obj_in.symbol}
                </div>
                <div  class="griditemcolumn">
                    (${obj_in.price})
                </div>
                <div  class="griditemcolumn">
                    [${obj_in.price}]
                </div>                    
                
                <div  class="griditemcolumn">
                    <img src="img/icons/angle-down-solid.svg" class="redarrow" style=" vertical-align:middle;"/>
                    ${obj_in.price}
                </div>
            </div>`;
        return template_item;
    }
    onDataUpdate(data_in) {}
}



class $b2f82a7b3cd6a34a$export$469baeb1b98e0c9 extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    constructor(initObj){
        super(initObj);
        const shadow = this.attachShadow({
            mode: 'open'
        });
        this.shadow = shadow;
        const tickertapeContainer = document.createElement('div');
        tickertapeContainer.classList.add('grid-panel');
        tickertapeContainer.innerHTML = `
            <style>
                .gridpanelcontainer {
                    background-color: #000;
                    font-size: 13px;
                    position: relative;
                    font-family: 'Roboto Condensed', sans-serif;
                    overflow: hidden;
                    display:flex;
                }
                .gridcolumn {
                    width:32%;
                    min-width:300px; 
                }
                .griditem{
                    position:relative; 
                    overflow:hidden;
                    display:flex;
                    justify-content:space-between;
                    align-items: center;
                    vertical-align: middle;
                    border-bottom: solid gray 1px;
                    font-size: 12px;
                    padding: 4px;
                }
                .redarrow{
                    position:absolute;
                    top:50%;
                    width:12px;
                    right:44px;
                    transform: translate(-50%,-50%);
                }
                .greenarrow{
                    position:absolute;
                    top:50%;
                    width:12px;
                    right:14px;
                    transform: translate(-50%,-50%);
                }   
                .griditemcolumn{
                    width:50px;
                    
                }             
            </style>
            <div style="display:flex; flex-wrap:wrap; justify-content:space-between; ">
                <div class="gridcolumn panel1">
                </div>
    
                <div class="gridcolumn panel2">
                </div>
    
                <div class="gridcolumn panel3">
                </div>
            </div>                  
        `;
        /*
        let reqURL = 'http://localhost:8851/comodhashes'
        var requestURL = "/data/comodhashes.json";
        $.ajax({
            url: requestURL,
            type: "GET",
            contentType: 'application/json;charset=UTF-8',
            data: {
                //'selected': document.getElementById('first_cat').value
                'selected':'bars'
            },
            dataType:"json",
            success:function ( data){
                this.buildTicker( data )
            }.bind(this)
        });*/ // this.render();
        // appending the container to the shadow DOM
        shadow.appendChild(tickertapeContainer);
    }
    get myObj() {
        return this._myObj;
    }
    set myObj(value) {
        this._myObj = value;
        this.render();
    }
    render() {
        this.innerHTML = ``;
    }
    onDataUpdate(data_in) {
        this.buildTicker(data_in);
    }
    buildTicker(data_in) {
        function templateDynamic(obj_in, temp_identifier) {
            var x_templates = {
                'tickeritem_red': `
                <div class='tickeritem'>
                    <div class='tickertext' style="">${obj_in.price}</div>
                    <div class='tickertext' >${obj_in.symbol}</div>
                </div>
            `,
                'tickeritem_green': `
                <div class='tickeritem'>
                    <div class='tickertext' style="">${obj_in.price}</div>
                    <div class='tickertext' >${obj_in.symbol}</div>
                </div>
            `
            };
            return x_templates[temp_identifier];
        }
        function itemTemplate(obj_in) {
            let template_item = `
                <div class="griditem">
                    <div style="">
                        ${obj_in.symbol}
                    </div>
                    <div style="">
                        ${obj_in.price}
                    </div>
                </div>`;
            return template_item;
        }
        function itemTemplate2(obj_in) {
            let template_item = `
                <div class="griditem">
                    <div class="griditemcolumn">
                        ${obj_in.symbol}
                    </div>
                    <div  class="griditemcolumn">
                        (${obj_in.price})
                    </div>
                    <div  class="griditemcolumn">
                        [${obj_in.price}]
                    </div>                    
                    
                    <div  class="griditemcolumn">
                        <img src="img/icons/angle-down-solid.svg" class="redarrow" style=" vertical-align:middle;"/>
                        ${obj_in.price}
                    </div>
                </div>`;
            return template_item;
        }
        //var xcontainer = this.shadowRoot.querySelector('.tickertapecontainer')
        //var xcontainer = document.querySelector('ticker-tape').shadow
        var panels = [];
        var con1 = this.shadow.querySelector('.panel1');
        con1.innerHTML = '';
        panels.push(con1);
        var con2 = this.shadow.querySelector('.panel2');
        con2.innerHTML = '';
        panels.push(con2);
        var con3 = this.shadow.querySelector('.panel3');
        con3.innerHTML = '';
        panels.push(con3);
        var slotsmap = {
            'NAS100': 2,
            'BCO/USD': 2,
            'WTICO/USD': 2,
            'CORN/USD': 2,
            'WHEAT/US': 2,
            'NATGAS/USD': 2,
            'WHEAT/USD': 2,
            'SUGAR/USD': 2,
            'XAG/USD': 2,
            'XAU/USD': 2,
            'XCU/USD': 2,
            'XPD/USD': 2,
            'XPT/USD': 2,
            'SPX500/USD': 1,
            'NAS100/USD': 1,
            'CN50/USD': 1,
            'USB02Y/USD': 1,
            'USB05Y/USD': 1,
            'USB10Y/USD': 1,
            'USB30Y/USD': 1
        };
        var asset_list = data_in.nodes;
        for(var a in asset_list){
            var obj = asset_list[a];
            var sym = a.split('-')[1];
            var vll = obj[Object.keys(obj)[0]];
            let dv2 = document.createElement('div');
            dv2.innerHTML = itemTemplate2({
                symbol: sym,
                price: vll
            });
            var gx = itemTemplate2({
                symbol: sym,
                price: vll
            });
            if (sym in slotsmap) panels[slotsmap[sym]].insertAdjacentHTML('beforeend', gx);
            else panels[0].insertAdjacentHTML('beforeend', gx);
        }
    }
}


var $1ff2b0a4ee3068d6$var$defaultBindingOptions = {
    allowDownsampling: true
};
function $1ff2b0a4ee3068d6$var$bindToDevicePixelRatio(canvas, options) {
    if (options === void 0) options = $1ff2b0a4ee3068d6$var$defaultBindingOptions;
    return new $1ff2b0a4ee3068d6$var$DevicePixelRatioBinding(canvas, options);
}
var $1ff2b0a4ee3068d6$var$DevicePixelRatioBinding = /** @class */ function() {
    function DevicePixelRatioBinding(canvas, options) {
        var _this = this;
        this._resolutionMediaQueryList = null;
        this._resolutionListener = function(ev) {
            return _this._onResolutionChanged();
        };
        this._canvasConfiguredListeners = [];
        this.canvas = canvas;
        this._canvasSize = {
            width: this.canvas.clientWidth,
            height: this.canvas.clientHeight
        };
        this._options = options;
        this._configureCanvas();
        this._installResolutionListener();
    }
    DevicePixelRatioBinding.prototype.destroy = function() {
        this._canvasConfiguredListeners.length = 0;
        this._uninstallResolutionListener();
        this.canvas = null;
    };
    Object.defineProperty(DevicePixelRatioBinding.prototype, "canvasSize", {
        get: function() {
            return {
                width: this._canvasSize.width,
                height: this._canvasSize.height
            };
        },
        enumerable: true,
        configurable: true
    });
    DevicePixelRatioBinding.prototype.resizeCanvas = function(size) {
        this._canvasSize = {
            width: size.width,
            height: size.height
        };
        this._configureCanvas();
    };
    Object.defineProperty(DevicePixelRatioBinding.prototype, "pixelRatio", {
        get: function() {
            // According to DOM Level 2 Core specification, ownerDocument should never be null for HTMLCanvasElement
            // see https://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#node-ownerDoc
            var win = this.canvas.ownerDocument.defaultView;
            if (win == null) throw new Error('No window is associated with the canvas');
            return win.devicePixelRatio > 1 || this._options.allowDownsampling ? win.devicePixelRatio : 1;
        },
        enumerable: true,
        configurable: true
    });
    DevicePixelRatioBinding.prototype.subscribeCanvasConfigured = function(listener) {
        this._canvasConfiguredListeners.push(listener);
    };
    DevicePixelRatioBinding.prototype.unsubscribeCanvasConfigured = function(listener) {
        this._canvasConfiguredListeners = this._canvasConfiguredListeners.filter(function(l) {
            return l != listener;
        });
    };
    DevicePixelRatioBinding.prototype._configureCanvas = function() {
        var ratio = this.pixelRatio;
        this.canvas.style.width = this._canvasSize.width + "px";
        this.canvas.style.height = this._canvasSize.height + "px";
        this.canvas.width = this._canvasSize.width * ratio;
        this.canvas.height = this._canvasSize.height * ratio;
        this._emitCanvasConfigured();
    };
    DevicePixelRatioBinding.prototype._emitCanvasConfigured = function() {
        var _this = this;
        this._canvasConfiguredListeners.forEach(function(listener) {
            return listener.call(_this);
        });
    };
    DevicePixelRatioBinding.prototype._installResolutionListener = function() {
        if (this._resolutionMediaQueryList !== null) throw new Error('Resolution listener is already installed');
        // According to DOM Level 2 Core specification, ownerDocument should never be null for HTMLCanvasElement
        // see https://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#node-ownerDoc
        var win = this.canvas.ownerDocument.defaultView;
        if (win == null) throw new Error('No window is associated with the canvas');
        var dppx = win.devicePixelRatio;
        this._resolutionMediaQueryList = win.matchMedia("all and (resolution: " + dppx + "dppx)");
        // IE and some versions of Edge do not support addEventListener/removeEventListener, and we are going to use the deprecated addListener/removeListener
        this._resolutionMediaQueryList.addListener(this._resolutionListener);
    };
    DevicePixelRatioBinding.prototype._uninstallResolutionListener = function() {
        if (this._resolutionMediaQueryList !== null) {
            // IE and some versions of Edge do not support addEventListener/removeEventListener, and we are going to use the deprecated addListener/removeListener
            this._resolutionMediaQueryList.removeListener(this._resolutionListener);
            this._resolutionMediaQueryList = null;
        }
    };
    DevicePixelRatioBinding.prototype._reinstallResolutionListener = function() {
        this._uninstallResolutionListener();
        this._installResolutionListener();
    };
    DevicePixelRatioBinding.prototype._onResolutionChanged = function() {
        this._configureCanvas();
        this._reinstallResolutionListener();
    };
    return DevicePixelRatioBinding;
}();
/*!
 * @license
 * TradingView Lightweight Charts v3.4.0
 * Copyright (c) 2020 TradingView, Inc.
 * Licensed under Apache License 2.0 https://www.apache.org/licenses/LICENSE-2.0
 */ var $1ff2b0a4ee3068d6$export$aa318e0578993894, $1ff2b0a4ee3068d6$export$5d24e00cfde59887;
function $1ff2b0a4ee3068d6$var$h(t, i) {
    var n, h = ((n = {})[0] = [], n[1] = [
        t.lineWidth,
        t.lineWidth
    ], n[2] = [
        2 * t.lineWidth,
        2 * t.lineWidth
    ], n[3] = [
        6 * t.lineWidth,
        6 * t.lineWidth
    ], n[4] = [
        t.lineWidth,
        4 * t.lineWidth
    ], n)[i];
    t.setLineDash(h);
}
function $1ff2b0a4ee3068d6$var$s(t, i, n, h) {
    t.beginPath();
    var s = t.lineWidth % 2 ? .5 : 0;
    t.moveTo(n, i + s), t.lineTo(h, i + s), t.stroke();
}
!function(t) {
    t[t.Simple = 0] = "Simple", t[t.WithSteps = 1] = "WithSteps";
}($1ff2b0a4ee3068d6$export$aa318e0578993894 || ($1ff2b0a4ee3068d6$export$aa318e0578993894 = {})), function(t) {
    t[t.Solid = 0] = "Solid", t[t.Dotted = 1] = "Dotted", t[t.Dashed = 2] = "Dashed", t[t.LargeDashed = 3] = "LargeDashed", t[t.SparseDotted = 4] = "SparseDotted";
}($1ff2b0a4ee3068d6$export$5d24e00cfde59887 || ($1ff2b0a4ee3068d6$export$5d24e00cfde59887 = {}));
var $1ff2b0a4ee3068d6$var$r = function(t, i) {
    return ($1ff2b0a4ee3068d6$var$r = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, i) {
        t.__proto__ = i;
    } || function(t, i) {
        for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
    })(t, i);
};
function $1ff2b0a4ee3068d6$var$e(t, i) {
    if ("function" != typeof i && null !== i) throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    function n() {
        this.constructor = t;
    }
    $1ff2b0a4ee3068d6$var$r(t, i), t.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n);
}
var $1ff2b0a4ee3068d6$var$u = function() {
    return ($1ff2b0a4ee3068d6$var$u = Object.assign || function(t) {
        for(var i, n = 1, h = arguments.length; n < h; n++)for(var s in i = arguments[n])Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s]);
        return t;
    }).apply(this, arguments);
};
function $1ff2b0a4ee3068d6$var$a(t, i) {
    for(var n = 0, h = i.length, s = t.length; n < h; n++, s++)t[s] = i[n];
    return t;
}
function $1ff2b0a4ee3068d6$var$o(t, i) {
    if (!t) throw new Error("Assertion failed" + (i ? ": " + i : ""));
}
function $1ff2b0a4ee3068d6$var$l(t) {
    if (void 0 === t) throw new Error("Value is undefined");
    return t;
}
function $1ff2b0a4ee3068d6$var$f(t) {
    if (null === t) throw new Error("Value is null");
    return t;
}
function $1ff2b0a4ee3068d6$var$c(t) {
    return $1ff2b0a4ee3068d6$var$f($1ff2b0a4ee3068d6$var$l(t));
}
function $1ff2b0a4ee3068d6$var$v(t) {
    for(var i = [], n = 1; n < arguments.length; n++)i[n - 1] = arguments[n];
    for(var h = 0, s = i; h < s.length; h++){
        var r = s[h];
        for(var e in r)void 0 !== r[e] && ("object" != typeof r[e] || void 0 === t[e] ? t[e] = r[e] : $1ff2b0a4ee3068d6$var$v(t[e], r[e]));
    }
    return t;
}
function $1ff2b0a4ee3068d6$var$_(t) {
    return "number" == typeof t && isFinite(t);
}
function $1ff2b0a4ee3068d6$var$d(t) {
    return "number" == typeof t && t % 1 == 0;
}
function $1ff2b0a4ee3068d6$var$w(t) {
    return "string" == typeof t;
}
function $1ff2b0a4ee3068d6$var$M(t) {
    return "boolean" == typeof t;
}
function $1ff2b0a4ee3068d6$var$b(t) {
    var i, n, h, s = t;
    if (!s || "object" != typeof s) return s;
    for(n in i = Array.isArray(s) ? [] : {}, s)s.hasOwnProperty(n) && (h = s[n], i[n] = h && "object" == typeof h ? $1ff2b0a4ee3068d6$var$b(h) : h);
    return i;
}
function $1ff2b0a4ee3068d6$var$m(t) {
    return null !== t;
}
function $1ff2b0a4ee3068d6$var$g(t) {
    return null === t ? void 0 : t;
}
var $1ff2b0a4ee3068d6$var$p = function() {
    function t() {
        this.t = [];
    }
    return t.prototype.i = function(t) {
        this.t = t;
    }, t.prototype.h = function(t, i, n, h) {
        this.t.forEach(function(s) {
            t.save(), s.h(t, i, n, h), t.restore();
        });
    }, t;
}(), $1ff2b0a4ee3068d6$var$y = function() {
    function t() {}
    return t.prototype.h = function(t, i, n, h) {
        t.save(), t.scale(i, i), this.u(t, n, h), t.restore();
    }, t.prototype.o = function(t, i, n, h) {
        t.save(), t.scale(i, i), this.l(t, n, h), t.restore();
    }, t.prototype.l = function(t, i, n) {}, t;
}(), $1ff2b0a4ee3068d6$var$k = function(t) {
    function i() {
        var i = null !== t && t.apply(this, arguments) || this;
        return i.v = null, i;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype._ = function(t) {
        this.v = t;
    }, i.prototype.u = function(t) {
        if (null !== this.v && null !== this.v.M) {
            var i = this.v.M, n = this.v, h = function(h) {
                t.beginPath();
                for(var s = i.to - 1; s >= i.from; --s){
                    var r = n.m[s];
                    t.moveTo(r.g, r.p), t.arc(r.g, r.p, h, 0, 2 * Math.PI);
                }
                t.fill();
            };
            t.fillStyle = n.k, h(n.N + 2), t.fillStyle = n.S, h(n.N);
        }
    }, i;
}($1ff2b0a4ee3068d6$var$y);
var $1ff2b0a4ee3068d6$var$x = {
    from: 0,
    to: 1
}, $1ff2b0a4ee3068d6$var$N = function() {
    function t(t, i) {
        this.C = new $1ff2b0a4ee3068d6$var$p, this.D = [], this.T = [], this.B = !0, this.L = t, this.A = i, this.C.i(this.D);
    }
    return t.prototype.V = function(t) {
        var i = this, n = this.L.O();
        n.length !== this.D.length && (this.T = n.map(function() {
            return {
                m: [
                    {
                        g: 0,
                        p: 0,
                        P: 0,
                        F: 0
                    }
                ],
                S: "",
                k: i.L.I().layout.backgroundColor,
                N: 0,
                M: null
            };
        }), this.D = this.T.map(function(t) {
            var i = new $1ff2b0a4ee3068d6$var$k;
            return i._(t), i;
        }), this.C.i(this.D)), this.B = !0;
    }, t.prototype.W = function(t, i, n) {
        return this.B && (this.R(), this.B = !1), this.C;
    }, t.prototype.R = function() {
        var t = this, i = this.L.O(), n = this.A.j(), h = this.L.U();
        i.forEach(function(i, s) {
            var r = t.T[s], e = i.q(n);
            if (null !== e && i.H()) {
                var u = $1ff2b0a4ee3068d6$var$f(i.Y());
                r.S = e.K, r.k = e.$, r.N = e.N, r.m[0].F = e.F, r.m[0].p = i.Z().X(e.F, u.J), r.m[0].P = n, r.m[0].g = h.G(n), r.M = $1ff2b0a4ee3068d6$var$x;
            } else r.M = null;
        });
    }, t;
}(), $1ff2b0a4ee3068d6$var$S = function() {
    function t(t) {
        this.tt = t;
    }
    return t.prototype.h = function(t, i, n, r) {
        if (null !== this.tt) {
            var e = this.tt.it.H, u = this.tt.nt.H;
            if (e || u) {
                t.save();
                var a = Math.round(this.tt.g * i), o = Math.round(this.tt.p * i), l = Math.ceil(this.tt.ht * i), f = Math.ceil(this.tt.st * i);
                t.lineCap = "butt", e && a >= 0 && (t.lineWidth = Math.floor(this.tt.it.rt * i), t.strokeStyle = this.tt.it.et, t.fillStyle = this.tt.it.et, $1ff2b0a4ee3068d6$var$h(t, this.tt.it.ut), function(t, i, n, h) {
                    t.beginPath();
                    var s = t.lineWidth % 2 ? .5 : 0;
                    t.moveTo(i + s, n), t.lineTo(i + s, h), t.stroke();
                }(t, a, 0, f)), u && o >= 0 && (t.lineWidth = Math.floor(this.tt.nt.rt * i), t.strokeStyle = this.tt.nt.et, t.fillStyle = this.tt.nt.et, $1ff2b0a4ee3068d6$var$h(t, this.tt.nt.ut), $1ff2b0a4ee3068d6$var$s(t, o, 0, l)), t.restore();
            }
        }
    }, t;
}(), $1ff2b0a4ee3068d6$var$C = function() {
    function t(t) {
        this.B = !0, this.at = {
            it: {
                rt: 1,
                ut: 0,
                et: "",
                H: !1
            },
            nt: {
                rt: 1,
                ut: 0,
                et: "",
                H: !1
            },
            ht: 0,
            st: 0,
            g: 0,
            p: 0
        }, this.ot = new $1ff2b0a4ee3068d6$var$S(this.at), this.lt = t;
    }
    return t.prototype.V = function() {
        this.B = !0;
    }, t.prototype.W = function(t, i) {
        return this.B && (this.R(), this.B = !1), this.ot;
    }, t.prototype.R = function() {
        var t = this.lt.H(), i = $1ff2b0a4ee3068d6$var$f(this.lt.ft()), n = i.ct().I().crosshair, h = this.at;
        h.nt.H = t && this.lt.vt(i), h.it.H = t && this.lt._t(), h.nt.rt = n.horzLine.width, h.nt.ut = n.horzLine.style, h.nt.et = n.horzLine.color, h.it.rt = n.vertLine.width, h.it.ut = n.vertLine.style, h.it.et = n.vertLine.color, h.ht = i.dt(), h.st = i.wt(), h.g = this.lt.Mt(), h.p = this.lt.bt();
    }, t;
}(), $1ff2b0a4ee3068d6$var$D = {
    khaki: "#f0e68c",
    azure: "#f0ffff",
    aliceblue: "#f0f8ff",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    gainsboro: "#dcdcdc",
    gray: "#808080",
    green: "#008000",
    honeydew: "#f0fff0",
    floralwhite: "#fffaf0",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lemonchiffon: "#fffacd",
    hotpink: "#ff69b4",
    lightyellow: "#ffffe0",
    greenyellow: "#adff2f",
    lightgoldenrodyellow: "#fafad2",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    lightcyan: "#e0ffff",
    magenta: "#f0f",
    maroon: "#800000",
    olive: "#808000",
    orange: "#ffa500",
    oldlace: "#fdf5e6",
    mediumblue: "#0000cd",
    transparent: "#0000",
    lime: "#0f0",
    lightpink: "#ffb6c1",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    midnightblue: "#191970",
    orchid: "#da70d6",
    mediumorchid: "#ba55d3",
    mediumturquoise: "#48d1cc",
    orangered: "#ff4500",
    royalblue: "#4169e1",
    powderblue: "#b0e0e6",
    red: "#f00",
    coral: "#ff7f50",
    turquoise: "#40e0d0",
    white: "#fff",
    whitesmoke: "#f5f5f5",
    wheat: "#f5deb3",
    teal: "#008080",
    steelblue: "#4682b4",
    bisque: "#ffe4c4",
    aquamarine: "#7fffd4",
    aqua: "#0ff",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    springgreen: "#00ff7f",
    antiquewhite: "#faebd7",
    burlywood: "#deb887",
    brown: "#a52a2a",
    beige: "#f5f5dc",
    chocolate: "#d2691e",
    chartreuse: "#7fff00",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cadetblue: "#5f9ea0",
    tomato: "#ff6347",
    fuchsia: "#f0f",
    blue: "#00f",
    salmon: "#fa8072",
    blanchedalmond: "#ffebcd",
    slateblue: "#6a5acd",
    slategray: "#708090",
    thistle: "#d8bfd8",
    tan: "#d2b48c",
    cyan: "#0ff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    blueviolet: "#8a2be2",
    black: "#000",
    darkmagenta: "#8b008b",
    darkslateblue: "#483d8b",
    darkkhaki: "#bdb76b",
    darkorchid: "#9932cc",
    darkorange: "#ff8c00",
    darkgreen: "#006400",
    darkred: "#8b0000",
    dodgerblue: "#1e90ff",
    darkslategray: "#2f4f4f",
    dimgray: "#696969",
    deepskyblue: "#00bfff",
    firebrick: "#b22222",
    forestgreen: "#228b22",
    indigo: "#4b0082",
    ivory: "#fffff0",
    lavenderblush: "#fff0f5",
    feldspar: "#d19275",
    indianred: "#cd5c5c",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightskyblue: "#87cefa",
    lightslategray: "#789",
    lightslateblue: "#8470ff",
    snow: "#fffafa",
    lightseagreen: "#20b2aa",
    lightsalmon: "#ffa07a",
    darksalmon: "#e9967a",
    darkviolet: "#9400d3",
    mediumpurple: "#9370d8",
    mediumaquamarine: "#66cdaa",
    skyblue: "#87ceeb",
    lavender: "#e6e6fa",
    lightsteelblue: "#b0c4de",
    mediumvioletred: "#c71585",
    mintcream: "#f5fffa",
    navajowhite: "#ffdead",
    navy: "#000080",
    olivedrab: "#6b8e23",
    palevioletred: "#d87093",
    violetred: "#d02090",
    yellow: "#ff0",
    yellowgreen: "#9acd32",
    lawngreen: "#7cfc00",
    pink: "#ffc0cb",
    paleturquoise: "#afeeee",
    palegoldenrod: "#eee8aa",
    darkolivegreen: "#556b2f",
    darkseagreen: "#8fbc8f",
    darkturquoise: "#00ced1",
    peachpuff: "#ffdab9",
    deeppink: "#ff1493",
    violet: "#ee82ee",
    palegreen: "#98fb98",
    mediumseagreen: "#3cb371",
    peru: "#cd853f",
    saddlebrown: "#8b4513",
    sandybrown: "#f4a460",
    rosybrown: "#bc8f8f",
    purple: "#800080",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    papayawhip: "#ffefd5",
    mediumslateblue: "#7b68ee",
    plum: "#dda0dd",
    mediumspringgreen: "#00fa9a"
};
function $1ff2b0a4ee3068d6$var$T(t) {
    return t < 0 ? 0 : t > 255 ? 255 : Math.round(t) || 0;
}
var $1ff2b0a4ee3068d6$var$B = /^#([0-9a-f])([0-9a-f])([0-9a-f])([0-9a-f])?$/i, $1ff2b0a4ee3068d6$var$E = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})?$/i, $1ff2b0a4ee3068d6$var$L = /^rgb\(\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*\)$/, $1ff2b0a4ee3068d6$var$A = /^rgba\(\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?[\d]{0,10}(?:\.\d+)?)\s*\)$/;
function $1ff2b0a4ee3068d6$var$V(t) {
    var i, n = function(t) {
        var i;
        if ((t = t.toLowerCase()) in $1ff2b0a4ee3068d6$var$D && (t = $1ff2b0a4ee3068d6$var$D[t]), i = $1ff2b0a4ee3068d6$var$A.exec(t) || $1ff2b0a4ee3068d6$var$L.exec(t)) return [
            $1ff2b0a4ee3068d6$var$T(parseInt(i[1], 10)),
            $1ff2b0a4ee3068d6$var$T(parseInt(i[2], 10)),
            $1ff2b0a4ee3068d6$var$T(parseInt(i[3], 10))
        ];
        if (i = $1ff2b0a4ee3068d6$var$E.exec(t)) return [
            $1ff2b0a4ee3068d6$var$T(parseInt(i[1], 16)),
            $1ff2b0a4ee3068d6$var$T(parseInt(i[2], 16)),
            $1ff2b0a4ee3068d6$var$T(parseInt(i[3], 16))
        ];
        if (i = $1ff2b0a4ee3068d6$var$B.exec(t)) return [
            $1ff2b0a4ee3068d6$var$T(17 * parseInt(i[1], 16)),
            $1ff2b0a4ee3068d6$var$T(17 * parseInt(i[2], 16)),
            $1ff2b0a4ee3068d6$var$T(17 * parseInt(i[3], 16))
        ];
        throw new Error("Cannot parse color: " + t);
    }(t);
    return {
        gt: "rgb(" + n[0] + ", " + n[1] + ", " + n[2] + ")",
        yt: (i = n, .199 * i[0] + .687 * i[1] + .114 * i[2] > 160 ? "black" : "white")
    };
}
function $1ff2b0a4ee3068d6$var$O(t, i, n, h, s, r) {
    t.fillRect(i + r, n, h - 2 * r, r), t.fillRect(i + r, n + s - r, h - 2 * r, r), t.fillRect(i, n, r, s), t.fillRect(i + h - r, n, r, s);
}
function $1ff2b0a4ee3068d6$var$z(t, i, n) {
    t.save(), t.scale(i, i), n(), t.restore();
}
function $1ff2b0a4ee3068d6$var$P(t, i, n, h, s, r) {
    t.save(), t.globalCompositeOperation = "copy", t.fillStyle = r, t.fillRect(i, n, h, s), t.restore();
}
var $1ff2b0a4ee3068d6$export$67315bc29c7dd713, $1ff2b0a4ee3068d6$var$I = function() {
    function t(t, i) {
        this._(t, i);
    }
    return t.prototype._ = function(t, i) {
        this.tt = t, this.kt = i;
    }, t.prototype.h = function(t, i, n, h, s, r) {
        if (this.tt.H) {
            t.font = i.xt;
            var e = this.tt.Nt || !this.tt.St ? i.Ct : 0, u = i.Dt, a = i.Tt, o = i.Bt, l = i.Et, f = i.Lt, c = this.tt.At, v = Math.ceil(n.Vt(t, c)), _ = i.Ot, d = i.zt + a + o, w = Math.ceil(.5 * d), M = u + v + l + f + e, b = this.kt.Pt;
            this.kt.Ft && (b = this.kt.Ft);
            var m, g, p = (b = Math.round(b)) - w, y = p + d, k = "right" === s, x = k ? h : 0, N = Math.ceil(h * r), S = x;
            if (t.fillStyle = this.kt.gt, t.lineWidth = 1, t.lineCap = "butt", c) {
                k ? (m = x - e, g = (S = x - M) + f) : (S = x + M, m = x + e, g = x + u + e + l);
                var C = Math.max(1, Math.floor(r)), D = Math.max(1, Math.floor(u * r)), T = k ? N : 0, B = Math.round(p * r), E = Math.round(S * r), L = Math.round(b * r) - Math.floor(.5 * r), A = L + C + (L - B), V = Math.round(m * r);
                t.save(), t.beginPath(), t.moveTo(T, B), t.lineTo(E, B), t.lineTo(E, A), t.lineTo(T, A), t.fill(), t.fillStyle = this.tt.$, t.fillRect(k ? N - D : 0, B, D, A - B), this.tt.Nt && (t.fillStyle = this.kt.et, t.fillRect(T, L, V - T, C)), t.textAlign = "left", t.fillStyle = this.kt.et, $1ff2b0a4ee3068d6$var$z(t, r, function() {
                    t.fillText(c, g, y - o - _);
                }), t.restore();
            }
        }
    }, t.prototype.wt = function(t, i) {
        return this.tt.H ? t.zt + t.Tt + t.Bt : 0;
    }, t;
}(), $1ff2b0a4ee3068d6$var$W = function() {
    function t(t) {
        this.It = {
            Pt: 0,
            et: "#FFF",
            gt: "#000"
        }, this.Wt = {
            At: "",
            H: !1,
            Nt: !0,
            St: !1,
            $: ""
        }, this.Rt = {
            At: "",
            H: !1,
            Nt: !1,
            St: !0,
            $: ""
        }, this.B = !0, this.jt = new (t || $1ff2b0a4ee3068d6$var$I)(this.Wt, this.It), this.Ut = new (t || $1ff2b0a4ee3068d6$var$I)(this.Rt, this.It);
    }
    return t.prototype.At = function() {
        return this.Wt.At;
    }, t.prototype.Pt = function() {
        return this.qt(), this.It.Pt;
    }, t.prototype.V = function() {
        this.B = !0;
    }, t.prototype.wt = function(t, i) {
        return void 0 === i && (i = !1), Math.max(this.jt.wt(t, i), this.Ut.wt(t, i));
    }, t.prototype.Ht = function() {
        return this.It.Ft || 0;
    }, t.prototype.Yt = function(t) {
        this.It.Ft = t;
    }, t.prototype.Kt = function() {
        return this.qt(), this.Wt.H || this.Rt.H;
    }, t.prototype.$t = function() {
        return this.qt(), this.Wt.H;
    }, t.prototype.W = function(t) {
        return this.qt(), this.Wt.Nt = this.Wt.Nt && t.I().drawTicks, this.Rt.Nt = this.Rt.Nt && t.I().drawTicks, this.jt._(this.Wt, this.It), this.Ut._(this.Rt, this.It), this.jt;
    }, t.prototype.Xt = function() {
        return this.qt(), this.jt._(this.Wt, this.It), this.Ut._(this.Rt, this.It), this.Ut;
    }, t.prototype.qt = function() {
        this.B && (this.Wt.Nt = !0, this.Rt.Nt = !1, this.Zt(this.Wt, this.Rt, this.It));
    }, t;
}(), $1ff2b0a4ee3068d6$var$R = function(t) {
    function i(i, n, h) {
        var s = t.call(this) || this;
        return s.lt = i, s.Jt = n, s.Gt = h, s;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.Zt = function(t, i, n) {
        t.H = !1;
        var h = this.lt.I().horzLine;
        if (h.labelVisible) {
            var s = this.Jt.Y();
            if (this.lt.H() && !this.Jt.Qt() && null !== s) {
                var r = $1ff2b0a4ee3068d6$var$V(h.labelBackgroundColor);
                n.gt = r.gt, n.et = r.yt;
                var e = this.Gt(this.Jt);
                n.Pt = e.Pt, t.At = this.Jt.ti(e.F, s), t.H = !0;
            }
        }
    }, i;
}($1ff2b0a4ee3068d6$var$W), $1ff2b0a4ee3068d6$var$j = /[1-9]/g, $1ff2b0a4ee3068d6$var$U = function() {
    function t() {
        this.tt = null;
    }
    return t.prototype._ = function(t) {
        this.tt = t;
    }, t.prototype.h = function(t, i, n) {
        var h = this;
        if (null !== this.tt && !1 !== this.tt.H && 0 !== this.tt.At.length) {
            t.font = i.xt;
            var s = Math.round(i.ii.Vt(t, this.tt.At, $1ff2b0a4ee3068d6$var$j));
            if (!(s <= 0)) {
                t.save();
                var r = i.ni, e = s + 2 * r, u = e / 2, a = this.tt.dt, o = this.tt.Pt, l = Math.floor(o - u) + .5;
                l < 0 ? (o += Math.abs(0 - l), l = Math.floor(o - u) + .5) : l + e > a && (o -= Math.abs(a - (l + e)), l = Math.floor(o - u) + .5);
                var c = l + e, v = 0 + i.Dt + i.Tt + i.zt + i.Bt;
                t.fillStyle = this.tt.gt;
                var _ = Math.round(l * n), d = Math.round(0 * n), w = Math.round(c * n), M = Math.round(v * n);
                t.fillRect(_, d, w - _, M - d);
                var b = Math.round(this.tt.Pt * n), m = d, g = Math.round((m + i.Dt + i.Ct) * n);
                t.fillStyle = this.tt.et;
                var p = Math.max(1, Math.floor(n)), y = Math.floor(.5 * n);
                t.fillRect(b - y, m, p, g - m);
                var k = v - i.Ot - i.Bt;
                t.textAlign = "left", t.fillStyle = this.tt.et, $1ff2b0a4ee3068d6$var$z(t, n, function() {
                    t.fillText($1ff2b0a4ee3068d6$var$f(h.tt).At, l + r, k);
                }), t.restore();
            }
        }
    }, t;
}(), $1ff2b0a4ee3068d6$var$q = function() {
    function t(t, i, n) {
        this.B = !0, this.ot = new $1ff2b0a4ee3068d6$var$U, this.at = {
            H: !1,
            gt: "#4c525e",
            et: "white",
            At: "",
            dt: 0,
            Pt: NaN
        }, this.A = t, this.hi = i, this.Gt = n;
    }
    return t.prototype.V = function() {
        this.B = !0;
    }, t.prototype.W = function() {
        return this.B && (this.R(), this.B = !1), this.ot._(this.at), this.ot;
    }, t.prototype.R = function() {
        var t = this.at;
        t.H = !1;
        var i = this.A.I().vertLine;
        if (i.labelVisible) {
            var n = this.hi.U();
            if (!n.Qt()) {
                var h = n.si(this.A.j());
                t.dt = n.dt();
                var s = this.Gt();
                if (s.P) {
                    t.Pt = s.Pt, t.At = n.ri($1ff2b0a4ee3068d6$var$f(h)), t.H = !0;
                    var r = $1ff2b0a4ee3068d6$var$V(i.labelBackgroundColor);
                    t.gt = r.gt, t.et = r.yt;
                }
            }
        }
    }, t;
}(), $1ff2b0a4ee3068d6$var$H = function() {
    function t() {
        this.ei = null, this.ui = 0;
    }
    return t.prototype.ai = function() {
        return this.ui;
    }, t.prototype.oi = function(t) {
        this.ui = t;
    }, t.prototype.Z = function() {
        return this.ei;
    }, t.prototype.li = function(t) {
        this.ei = t;
    }, t.prototype.fi = function(t, i) {
        return [];
    }, t.prototype.ci = function(t) {
        return [];
    }, t.prototype.vi = function() {
        return [];
    }, t.prototype.H = function() {
        return !0;
    }, t;
}();
!function(t) {
    t[t.Normal = 0] = "Normal", t[t.Magnet = 1] = "Magnet";
}($1ff2b0a4ee3068d6$export$67315bc29c7dd713 || ($1ff2b0a4ee3068d6$export$67315bc29c7dd713 = {}));
var $1ff2b0a4ee3068d6$var$Y = function(t) {
    function i(i, n) {
        var h = t.call(this) || this;
        h._i = null, h.di = NaN, h.wi = 0, h.Mi = !0, h.bi = new Map, h.mi = !1, h.gi = NaN, h.pi = NaN, h.yi = NaN, h.ki = NaN, h.hi = i, h.xi = n, h.Ni = new $1ff2b0a4ee3068d6$var$N(i, h);
        var s, r;
        h.Si = (s = function() {
            return h.di;
        }, r = function() {
            return h.pi;
        }, function(t) {
            var i = r(), n = s();
            if (t === $1ff2b0a4ee3068d6$var$f(h._i).Ci()) return {
                F: n,
                Pt: i
            };
            var e = $1ff2b0a4ee3068d6$var$f(t.Y());
            return {
                F: t.Di(i, e),
                Pt: i
            };
        });
        var e = function(t, i) {
            return function() {
                return {
                    P: h.hi.U().si(t()),
                    Pt: i()
                };
            };
        }(function() {
            return h.wi;
        }, function() {
            return h.Mt();
        });
        return h.Ti = new $1ff2b0a4ee3068d6$var$q(h, i, e), h.Bi = new $1ff2b0a4ee3068d6$var$C(h), h;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.I = function() {
        return this.xi;
    }, i.prototype.Ei = function(t, i) {
        this.yi = t, this.ki = i;
    }, i.prototype.Li = function() {
        this.yi = NaN, this.ki = NaN;
    }, i.prototype.Ai = function() {
        return this.yi;
    }, i.prototype.Vi = function() {
        return this.ki;
    }, i.prototype.Oi = function(t, i, n) {
        this.mi || (this.mi = !0), this.Mi = !0, this.zi(t, i, n);
    }, i.prototype.j = function() {
        return this.wi;
    }, i.prototype.Mt = function() {
        return this.gi;
    }, i.prototype.bt = function() {
        return this.pi;
    }, i.prototype.H = function() {
        return this.Mi;
    }, i.prototype.Pi = function() {
        this.Mi = !1, this.Fi(), this.di = NaN, this.gi = NaN, this.pi = NaN, this._i = null, this.Li();
    }, i.prototype.ci = function(t) {
        return null !== this._i ? [
            this.Bi,
            this.Ni
        ] : [];
    }, i.prototype.vt = function(t) {
        return t === this._i && this.xi.horzLine.visible;
    }, i.prototype._t = function() {
        return this.xi.vertLine.visible;
    }, i.prototype.fi = function(t, i) {
        this.Mi && this._i === t || this.bi.clear();
        var n = [];
        return this._i === t && n.push(this.Ii(this.bi, i, this.Si)), n;
    }, i.prototype.vi = function() {
        return this.Mi ? [
            this.Ti
        ] : [];
    }, i.prototype.ft = function() {
        return this._i;
    }, i.prototype.Wi = function() {
        this.Bi.V(), this.bi.forEach(function(t) {
            return t.V();
        }), this.Ti.V(), this.Ni.V();
    }, i.prototype.Ri = function(t) {
        return t && !t.Ci().Qt() ? t.Ci() : null;
    }, i.prototype.zi = function(t, i, n) {
        this.ji(t, i, n) && this.Wi();
    }, i.prototype.ji = function(t, i, n) {
        var h = this.gi, s = this.pi, r = this.di, e = this.wi, u = this._i, a = this.Ri(n);
        this.wi = t, this.gi = isNaN(t) ? NaN : this.hi.U().G(t), this._i = n;
        var o = null !== a ? a.Y() : null;
        return null !== a && null !== o ? (this.di = i, this.pi = a.X(i, o)) : (this.di = NaN, this.pi = NaN), h !== this.gi || s !== this.pi || e !== this.wi || r !== this.di || u !== this._i;
    }, i.prototype.Fi = function() {
        var t = this.hi.O().map(function(t) {
            return t.qi().Ui();
        }).filter($1ff2b0a4ee3068d6$var$m), i = 0 === t.length ? null : Math.max.apply(Math, t);
        this.wi = null !== i ? i : NaN;
    }, i.prototype.Ii = function(t, i, n) {
        var h = t.get(i);
        return void 0 === h && (h = new $1ff2b0a4ee3068d6$var$R(this, i, n), t.set(i, h)), h;
    }, i;
}($1ff2b0a4ee3068d6$var$H), $1ff2b0a4ee3068d6$var$K = ".";
function $1ff2b0a4ee3068d6$var$$(t, i) {
    if (!$1ff2b0a4ee3068d6$var$_(t)) return "n/a";
    if (!$1ff2b0a4ee3068d6$var$d(i)) throw new TypeError("invalid length");
    if (i < 0 || i > 16) throw new TypeError("invalid length");
    if (0 === i) return t.toString();
    return ("0000000000000000" + t.toString()).slice(-i);
}
var $1ff2b0a4ee3068d6$var$X = function() {
    function t(t, i) {
        if (i || (i = 1), $1ff2b0a4ee3068d6$var$_(t) && $1ff2b0a4ee3068d6$var$d(t) || (t = 100), t < 0) throw new TypeError("invalid base");
        this.Jt = t, this.Hi = i, this.Yi();
    }
    return t.prototype.format = function(t) {
        var i = t < 0 ? "\u2212" : "";
        return t = Math.abs(t), i + this.Ki(t);
    }, t.prototype.Yi = function() {
        if (this.$i = 0, this.Jt > 0 && this.Hi > 0) for(var t = this.Jt; t > 1;)t /= 10, this.$i++;
    }, t.prototype.Ki = function(t) {
        var i = this.Jt / this.Hi, n = Math.floor(t), h = "", s = void 0 !== this.$i ? this.$i : NaN;
        if (i > 1) {
            var r = +(Math.round(t * i) - n * i).toFixed(this.$i);
            r >= i && (r -= i, n += 1), h = $1ff2b0a4ee3068d6$var$K + $1ff2b0a4ee3068d6$var$$(+r.toFixed(this.$i) * this.Hi, s);
        } else n = Math.round(n * i) / i, s > 0 && (h = $1ff2b0a4ee3068d6$var$K + $1ff2b0a4ee3068d6$var$$(0, s));
        return n.toFixed(0) + h;
    }, t;
}(), $1ff2b0a4ee3068d6$var$Z = function(t) {
    function i(i) {
        return void 0 === i && (i = 100), t.call(this, i) || this;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.format = function(i) {
        return t.prototype.format.call(this, i) + "%";
    }, i;
}($1ff2b0a4ee3068d6$var$X), $1ff2b0a4ee3068d6$var$J = function() {
    function t() {
        this.Xi = [];
    }
    return t.prototype.Zi = function(t, i, n) {
        var h = {
            Ji: t,
            Gi: i,
            Qi: !0 === n
        };
        this.Xi.push(h);
    }, t.prototype.tn = function(t) {
        var i = this.Xi.findIndex(function(i) {
            return t === i.Ji;
        });
        i > -1 && this.Xi.splice(i, 1);
    }, t.prototype.nn = function(t) {
        this.Xi = this.Xi.filter(function(i) {
            return i.Gi === t;
        });
    }, t.prototype.hn = function(t, i) {
        var n = $1ff2b0a4ee3068d6$var$a([], this.Xi);
        this.Xi = this.Xi.filter(function(t) {
            return !t.Qi;
        }), n.forEach(function(n) {
            return n.Ji(t, i);
        });
    }, t.prototype.sn = function() {
        return this.Xi.length > 0;
    }, t.prototype.rn = function() {
        this.Xi = [];
    }, t;
}(), $1ff2b0a4ee3068d6$var$G = function() {
    function t(t, i) {
        this.en = t, this.un = i;
    }
    return t.prototype.an = function(t) {
        return null !== t && this.en === t.en && this.un === t.un;
    }, t.prototype.on = function() {
        return new t(this.en, this.un);
    }, t.prototype.ln = function() {
        return this.en;
    }, t.prototype.fn = function() {
        return this.un;
    }, t.prototype.cn = function() {
        return this.un - this.en;
    }, t.prototype.Qt = function() {
        return this.un === this.en || Number.isNaN(this.un) || Number.isNaN(this.en);
    }, t.prototype.vn = function(i) {
        return null === i ? this : new t(Math.min(this.ln(), i.ln()), Math.max(this.fn(), i.fn()));
    }, t.prototype._n = function(t) {
        if ($1ff2b0a4ee3068d6$var$_(t) && 0 !== this.un - this.en) {
            var i = .5 * (this.un + this.en), n = this.un - i, h = this.en - i;
            n *= t, h *= t, this.un = i + n, this.en = i + h;
        }
    }, t.prototype.dn = function(t) {
        $1ff2b0a4ee3068d6$var$_(t) && (this.un += t, this.en += t);
    }, t.prototype.wn = function() {
        return {
            minValue: this.en,
            maxValue: this.un
        };
    }, t.Mn = function(i) {
        return null === i ? null : new t(i.minValue, i.maxValue);
    }, t;
}();
function $1ff2b0a4ee3068d6$var$Q(t, i, n) {
    return Math.min(Math.max(t, i), n);
}
function $1ff2b0a4ee3068d6$var$tt(t, i, n) {
    return i - t <= n;
}
function $1ff2b0a4ee3068d6$var$it(t) {
    return t <= 0 ? NaN : Math.log(t) / Math.log(10);
}
function $1ff2b0a4ee3068d6$var$nt(t) {
    var i = Math.ceil(t);
    return i % 2 != 0 ? i - 1 : i;
}
function $1ff2b0a4ee3068d6$var$ht(t) {
    var i = Math.ceil(t);
    return i % 2 == 0 ? i - 1 : i;
}
function $1ff2b0a4ee3068d6$var$st(t, i) {
    var n = 100 * (t - i) / i;
    return i < 0 ? -n : n;
}
function $1ff2b0a4ee3068d6$var$rt(t, i) {
    var n = $1ff2b0a4ee3068d6$var$st(t.ln(), i), h = $1ff2b0a4ee3068d6$var$st(t.fn(), i);
    return new $1ff2b0a4ee3068d6$var$G(n, h);
}
function $1ff2b0a4ee3068d6$var$et(t, i) {
    var n = 100 * (t - i) / i + 100;
    return i < 0 ? -n : n;
}
function $1ff2b0a4ee3068d6$var$ut(t, i) {
    var n = $1ff2b0a4ee3068d6$var$et(t.ln(), i), h = $1ff2b0a4ee3068d6$var$et(t.fn(), i);
    return new $1ff2b0a4ee3068d6$var$G(n, h);
}
function $1ff2b0a4ee3068d6$var$at(t) {
    var i = Math.abs(t);
    if (i < 1e-8) return 0;
    var n = $1ff2b0a4ee3068d6$var$it(i + 1e-4) + 4;
    return t < 0 ? -n : n;
}
function $1ff2b0a4ee3068d6$var$ot(t) {
    var i = Math.abs(t);
    if (i < 1e-8) return 0;
    var n = Math.pow(10, i - 4) - 1e-4;
    return t < 0 ? -n : n;
}
function $1ff2b0a4ee3068d6$var$lt(t) {
    if (null === t) return null;
    var i = $1ff2b0a4ee3068d6$var$at(t.ln()), n = $1ff2b0a4ee3068d6$var$at(t.fn());
    return new $1ff2b0a4ee3068d6$var$G(i, n);
}
var $1ff2b0a4ee3068d6$export$6b4fbb6217f8a7c2, $1ff2b0a4ee3068d6$var$ct = function() {
    function t(t, i) {
        if (this.bn = t, this.mn = i, function(t) {
            if (t < 0) return !1;
            for(var i = t; i > 1; i /= 10)if (i % 10 != 0) return !1;
            return !0;
        }(this.bn)) this.gn = [
            2,
            2.5,
            2
        ];
        else {
            this.gn = [];
            for(var n = this.bn; 1 !== n;){
                if (n % 2 == 0) this.gn.push(2), n /= 2;
                else {
                    if (n % 5 != 0) throw new Error("unexpected base");
                    this.gn.push(2, 2.5), n /= 5;
                }
                if (this.gn.length > 100) throw new Error("something wrong with base");
            }
        }
    }
    return t.prototype.pn = function(t, i, n) {
        for(var h, s, r, e = 0 === this.bn ? 0 : 1 / this.bn, u = 1e-9, a = Math.pow(10, Math.max(0, Math.ceil($1ff2b0a4ee3068d6$var$it(t - i)))), o = 0, l = this.mn[0];;){
            var f = $1ff2b0a4ee3068d6$var$tt(a, e, u) && a > e + u, c = $1ff2b0a4ee3068d6$var$tt(a, n * l, u), v = $1ff2b0a4ee3068d6$var$tt(a, 1, u);
            if (!(f && c && v)) break;
            a /= l, l = this.mn[++o % this.mn.length];
        }
        if (a <= e + u && (a = e), a = Math.max(1, a), this.gn.length > 0 && (h = a, s = 1, r = u, Math.abs(h - s) < r)) for(o = 0, l = this.gn[0]; $1ff2b0a4ee3068d6$var$tt(a, n * l, u) && a > e + u;)a /= l, l = this.gn[++o % this.gn.length];
        return a;
    }, t;
}(), $1ff2b0a4ee3068d6$var$vt = function() {
    function t(t, i, n, h) {
        this.yn = [], this.Jt = t, this.bn = i, this.kn = n, this.xn = h;
    }
    return t.prototype.pn = function(t, i) {
        if (t < i) throw new Error("high < low");
        var n = this.Jt.wt(), h = (t - i) * this.Nn() / n, s = new $1ff2b0a4ee3068d6$var$ct(this.bn, [
            2,
            2.5,
            2
        ]), r = new $1ff2b0a4ee3068d6$var$ct(this.bn, [
            2,
            2,
            2.5
        ]), e = new $1ff2b0a4ee3068d6$var$ct(this.bn, [
            2.5,
            2,
            2
        ]), u = [];
        return u.push(s.pn(t, i, h), r.pn(t, i, h), e.pn(t, i, h)), function(t) {
            if (t.length < 1) throw Error("array is empty");
            for(var i = t[0], n = 1; n < t.length; ++n)t[n] < i && (i = t[n]);
            return i;
        }(u);
    }, t.prototype.Sn = function() {
        var t = this.Jt, i = t.Y();
        if (null !== i) {
            var n = t.wt(), h = this.kn(n - 1, i), s = this.kn(0, i), r = this.Jt.I().entireTextOnly ? this.Cn() / 2 : 0, e = r, u = n - 1 - r, a = Math.max(h, s), o = Math.min(h, s);
            if (a !== o) {
                for(var l = this.pn(a, o), f = a % l, c = a >= o ? 1 : -1, v = null, _ = 0, d = a - (f += f < 0 ? l : 0); d > o; d -= l){
                    var w = this.xn(d, i, !0);
                    null !== v && Math.abs(w - v) < this.Nn() || w < e || w > u || (_ < this.yn.length ? (this.yn[_].Dn = w, this.yn[_].Tn = t.Bn(d)) : this.yn.push({
                        Dn: w,
                        Tn: t.Bn(d)
                    }), _++, v = w, t.En() && (l = this.pn(d * c, o)));
                }
                this.yn.length = _;
            } else this.yn = [];
        } else this.yn = [];
    }, t.prototype.Ln = function() {
        return this.yn;
    }, t.prototype.Cn = function() {
        return this.Jt.zt();
    }, t.prototype.Nn = function() {
        return Math.ceil(2.5 * this.Cn());
    }, t;
}();
function $1ff2b0a4ee3068d6$var$_t(t) {
    return t.slice().sort(function(t, i) {
        return $1ff2b0a4ee3068d6$var$f(t.ai()) - $1ff2b0a4ee3068d6$var$f(i.ai());
    });
}
!function(t) {
    t[t.Normal = 0] = "Normal", t[t.Logarithmic = 1] = "Logarithmic", t[t.Percentage = 2] = "Percentage", t[t.IndexedTo100 = 3] = "IndexedTo100";
}($1ff2b0a4ee3068d6$export$6b4fbb6217f8a7c2 || ($1ff2b0a4ee3068d6$export$6b4fbb6217f8a7c2 = {}));
var $1ff2b0a4ee3068d6$export$10777445820939da, $1ff2b0a4ee3068d6$var$wt = new $1ff2b0a4ee3068d6$var$Z, $1ff2b0a4ee3068d6$var$Mt = new $1ff2b0a4ee3068d6$var$X(100, 1), $1ff2b0a4ee3068d6$var$bt = function() {
    function t(t, i, n, h) {
        this.An = 0, this.Vn = null, this.On = null, this.zn = null, this.Pn = {
            Fn: !1,
            In: null
        }, this.Wn = 0, this.Rn = 0, this.jn = new $1ff2b0a4ee3068d6$var$J, this.Un = new $1ff2b0a4ee3068d6$var$J, this.qn = [], this.Hn = null, this.Yn = null, this.Kn = null, this.$n = null, this.Xn = $1ff2b0a4ee3068d6$var$Mt, this.Zn = t, this.xi = i, this.Jn = n, this.Gn = h, this.Qn = new $1ff2b0a4ee3068d6$var$vt(this, 100, this.th.bind(this), this.ih.bind(this));
    }
    return t.prototype.nh = function() {
        return this.Zn;
    }, t.prototype.I = function() {
        return this.xi;
    }, t.prototype.hh = function(t) {
        if ($1ff2b0a4ee3068d6$var$v(this.xi, t), this.sh(), void 0 !== t.mode && this.rh({
            eh: t.mode
        }), void 0 !== t.scaleMargins) {
            var i = $1ff2b0a4ee3068d6$var$l(t.scaleMargins.top), n = $1ff2b0a4ee3068d6$var$l(t.scaleMargins.bottom);
            if (i < 0 || i > 1) throw new Error("Invalid top margin - expect value between 0 and 1, given=" + i);
            if (n < 0 || n > 1 || i + n > 1) throw new Error("Invalid bottom margin - expect value between 0 and 1, given=" + n);
            if (i + n > 1) throw new Error("Invalid margins - sum of margins must be less than 1, given=" + (i + n));
            this.uh(), this.Yn = null;
        }
    }, t.prototype.ah = function() {
        return this.xi.autoScale;
    }, t.prototype.En = function() {
        return 1 === this.xi.mode;
    }, t.prototype.oh = function() {
        return 2 === this.xi.mode;
    }, t.prototype.lh = function() {
        return 3 === this.xi.mode;
    }, t.prototype.eh = function() {
        return {
            fh: this.xi.autoScale,
            _h: this.xi.invertScale,
            eh: this.xi.mode
        };
    }, t.prototype.rh = function(t) {
        var i = this.eh(), n = null;
        void 0 !== t.fh && (this.xi.autoScale = t.fh), void 0 !== t.eh && (this.xi.mode = t.eh, 2 !== t.eh && 3 !== t.eh || (this.xi.autoScale = !0), this.Pn.Fn = !1), 1 === i.eh && t.eh !== i.eh && (!function(t) {
            if (null === t) return !1;
            var i = $1ff2b0a4ee3068d6$var$ot(t.ln()), n = $1ff2b0a4ee3068d6$var$ot(t.fn());
            return isFinite(i) && isFinite(n);
        }(this.On) ? this.xi.autoScale = !0 : null !== (n = function(t) {
            if (null === t) return null;
            var i = $1ff2b0a4ee3068d6$var$ot(t.ln()), n = $1ff2b0a4ee3068d6$var$ot(t.fn());
            return new $1ff2b0a4ee3068d6$var$G(i, n);
        }(this.On)) && this.dh(n)), 1 === t.eh && t.eh !== i.eh && null !== (n = $1ff2b0a4ee3068d6$var$lt(this.On)) && this.dh(n);
        var h = i.eh !== this.xi.mode;
        h && (2 === i.eh || this.oh()) && this.sh(), h && (3 === i.eh || this.lh()) && this.sh(), void 0 !== t._h && i._h !== t._h && (this.xi.invertScale = t._h, this.wh()), this.Un.hn(i, this.eh());
    }, t.prototype.Mh = function() {
        return this.Un;
    }, t.prototype.zt = function() {
        return this.Jn.fontSize;
    }, t.prototype.wt = function() {
        return this.An;
    }, t.prototype.bh = function(t) {
        this.An !== t && (this.An = t, this.uh(), this.Yn = null);
    }, t.prototype.mh = function() {
        if (this.Vn) return this.Vn;
        var t = this.wt() - this.gh() - this.ph();
        return this.Vn = t, t;
    }, t.prototype.yh = function() {
        return this.kh(), this.On;
    }, t.prototype.dh = function(t, i) {
        var n = this.On;
        (i || null === n && null !== t || null !== n && !n.an(t)) && (this.Yn = null, this.On = t);
    }, t.prototype.Qt = function() {
        return this.kh(), 0 === this.An || !this.On || this.On.Qt();
    }, t.prototype.xh = function(t) {
        return this._h() ? t : this.wt() - 1 - t;
    }, t.prototype.X = function(t, i) {
        return this.oh() ? t = $1ff2b0a4ee3068d6$var$st(t, i) : this.lh() && (t = $1ff2b0a4ee3068d6$var$et(t, i)), this.ih(t, i);
    }, t.prototype.Nh = function(t, i, n) {
        this.kh();
        for(var h = this.ph(), s = $1ff2b0a4ee3068d6$var$f(this.yh()), r = s.ln(), e = s.fn(), u = this.mh() - 1, a = this._h(), o = u / (e - r), l = void 0 === n ? 0 : n.from, c = void 0 === n ? t.length : n.to, v = this.Sh(), _ = l; _ < c; _++){
            var d = t[_], w = d.F;
            if (!isNaN(w)) {
                var M = w;
                null !== v && (M = v(d.F, i));
                var b = h + o * (M - r), m = a ? b : this.An - 1 - b;
                d.p = m;
            }
        }
    }, t.prototype.Ch = function(t, i, n) {
        this.kh();
        for(var h = this.ph(), s = $1ff2b0a4ee3068d6$var$f(this.yh()), r = s.ln(), e = s.fn(), u = this.mh() - 1, a = this._h(), o = u / (e - r), l = void 0 === n ? 0 : n.from, c = void 0 === n ? t.length : n.to, v = this.Sh(), _ = l; _ < c; _++){
            var d = t[_], w = d.open, M = d.high, b = d.low, m = d.close;
            null !== v && (w = v(d.open, i), M = v(d.high, i), b = v(d.low, i), m = v(d.close, i));
            var g = h + o * (w - r), p = a ? g : this.An - 1 - g;
            d.Dh = p, g = h + o * (M - r), p = a ? g : this.An - 1 - g, d.Th = p, g = h + o * (b - r), p = a ? g : this.An - 1 - g, d.Bh = p, g = h + o * (m - r), p = a ? g : this.An - 1 - g, d.Eh = p;
        }
    }, t.prototype.Di = function(t, i) {
        var n = this.th(t, i);
        return this.Lh(n, i);
    }, t.prototype.Lh = function(t, i) {
        var n = t;
        return this.oh() ? n = function(t, i) {
            return i < 0 && (t = -t), t / 100 * i + i;
        }(n, i) : this.lh() && (n = function(t, i) {
            return t -= 100, i < 0 && (t = -t), t / 100 * i + i;
        }(n, i)), n;
    }, t.prototype.Ah = function() {
        return this.qn;
    }, t.prototype.Vh = function() {
        if (this.Hn) return this.Hn;
        for(var t = [], i = 0; i < this.qn.length; i++){
            var n = this.qn[i];
            null === n.ai() && n.oi(i + 1), t.push(n);
        }
        return t = $1ff2b0a4ee3068d6$var$_t(t), this.Hn = t, this.Hn;
    }, t.prototype.Oh = function(t) {
        -1 === this.qn.indexOf(t) && (this.qn.push(t), this.sh(), this.zh());
    }, t.prototype.Ph = function(t) {
        var i = this.qn.indexOf(t);
        if (-1 === i) throw new Error("source is not attached to scale");
        this.qn.splice(i, 1), 0 === this.qn.length && (this.rh({
            fh: !0
        }), this.dh(null)), this.sh(), this.zh();
    }, t.prototype.Y = function() {
        for(var t = null, i = 0, n = this.qn; i < n.length; i++){
            var h = n[i].Y();
            null !== h && (null === t || h.Fh < t.Fh) && (t = h);
        }
        return null === t ? null : t.J;
    }, t.prototype._h = function() {
        return this.xi.invertScale;
    }, t.prototype.Ln = function() {
        return this.Yn || (this.Qn.Sn(), this.Yn = this.Qn.Ln(), this.jn.hn()), this.Yn;
    }, t.prototype.Ih = function() {
        return this.jn;
    }, t.prototype.Wh = function(t) {
        this.oh() || this.lh() || null === this.Kn && null === this.zn && (this.Qt() || (this.Kn = this.An - t, this.zn = $1ff2b0a4ee3068d6$var$f(this.yh()).on()));
    }, t.prototype.Rh = function(t) {
        if (!this.oh() && !this.lh() && null !== this.Kn) {
            this.rh({
                fh: !1
            }), (t = this.An - t) < 0 && (t = 0);
            var i = (this.Kn + .2 * (this.An - 1)) / (t + .2 * (this.An - 1)), n = $1ff2b0a4ee3068d6$var$f(this.zn).on();
            i = Math.max(i, .1), n._n(i), this.dh(n);
        }
    }, t.prototype.jh = function() {
        this.oh() || this.lh() || (this.Kn = null, this.zn = null);
    }, t.prototype.Uh = function(t) {
        this.ah() || null === this.$n && null === this.zn && (this.Qt() || (this.$n = t, this.zn = $1ff2b0a4ee3068d6$var$f(this.yh()).on()));
    }, t.prototype.qh = function(t) {
        if (!this.ah() && null !== this.$n) {
            var i = $1ff2b0a4ee3068d6$var$f(this.yh()).cn() / (this.mh() - 1), n = t - this.$n;
            this._h() && (n *= -1);
            var h = n * i, s = $1ff2b0a4ee3068d6$var$f(this.zn).on();
            s.dn(h), this.dh(s, !0), this.Yn = null;
        }
    }, t.prototype.Hh = function() {
        this.ah() || null !== this.$n && (this.$n = null, this.zn = null);
    }, t.prototype.Yh = function() {
        return this.Xn || this.sh(), this.Xn;
    }, t.prototype.ti = function(t, i) {
        switch(this.xi.mode){
            case 2:
                return this.Yh().format($1ff2b0a4ee3068d6$var$st(t, i));
            case 3:
                return this.Yh().format($1ff2b0a4ee3068d6$var$et(t, i));
            default:
                return this.Kh(t);
        }
    }, t.prototype.Bn = function(t) {
        switch(this.xi.mode){
            case 2:
            case 3:
                return this.Yh().format(t);
            default:
                return this.Kh(t);
        }
    }, t.prototype.$h = function(t) {
        return this.Kh(t, $1ff2b0a4ee3068d6$var$f(this.Xh()).Yh());
    }, t.prototype.Zh = function(t, i) {
        return t = $1ff2b0a4ee3068d6$var$st(t, i), $1ff2b0a4ee3068d6$var$wt.format(t);
    }, t.prototype.Jh = function() {
        return this.qn;
    }, t.prototype.Gh = function(t) {
        this.Pn = {
            In: t,
            Fn: !1
        };
    }, t.prototype.Wi = function() {
        this.qn.forEach(function(t) {
            return t.Wi();
        });
    }, t.prototype.sh = function() {
        this.Yn = null;
        var t = this.Xh(), i = 100;
        null !== t && (i = Math.round(1 / t.Qh())), this.Xn = $1ff2b0a4ee3068d6$var$Mt, this.oh() ? (this.Xn = $1ff2b0a4ee3068d6$var$wt, i = 100) : this.lh() ? (this.Xn = new $1ff2b0a4ee3068d6$var$X(100, 1), i = 100) : null !== t && (this.Xn = t.Yh()), this.Qn = new $1ff2b0a4ee3068d6$var$vt(this, i, this.th.bind(this), this.ih.bind(this)), this.Qn.Sn();
    }, t.prototype.zh = function() {
        this.Hn = null;
    }, t.prototype.Xh = function() {
        return this.qn[0] || null;
    }, t.prototype.gh = function() {
        return this._h() ? this.xi.scaleMargins.bottom * this.wt() + this.Rn : this.xi.scaleMargins.top * this.wt() + this.Wn;
    }, t.prototype.ph = function() {
        return this._h() ? this.xi.scaleMargins.top * this.wt() + this.Wn : this.xi.scaleMargins.bottom * this.wt() + this.Rn;
    }, t.prototype.kh = function() {
        this.Pn.Fn || (this.Pn.Fn = !0, this.ts());
    }, t.prototype.uh = function() {
        this.Vn = null;
    }, t.prototype.ih = function(t, i) {
        if (this.kh(), this.Qt()) return 0;
        t = this.En() && t ? $1ff2b0a4ee3068d6$var$at(t) : t;
        var n = $1ff2b0a4ee3068d6$var$f(this.yh()), h = this.ph() + (this.mh() - 1) * (t - n.ln()) / n.cn();
        return this.xh(h);
    }, t.prototype.th = function(t, i) {
        if (this.kh(), this.Qt()) return 0;
        var n = this.xh(t), h = $1ff2b0a4ee3068d6$var$f(this.yh()), s = h.ln() + h.cn() * ((n - this.ph()) / (this.mh() - 1));
        return this.En() ? $1ff2b0a4ee3068d6$var$ot(s) : s;
    }, t.prototype.wh = function() {
        this.Yn = null, this.Qn.Sn();
    }, t.prototype.ts = function() {
        var t = this.Pn.In;
        if (null !== t) {
            for(var i = null, n = 0, h = 0, s = 0, r = this.Jh(); s < r.length; s++){
                var e = r[s];
                if (e.H()) {
                    var u = e.Y();
                    if (null !== u) {
                        var a = e.ns(t.hs(), t.ss()), o = a && a.yh();
                        if (null !== o) {
                            switch(this.xi.mode){
                                case 1:
                                    o = $1ff2b0a4ee3068d6$var$lt(o);
                                    break;
                                case 2:
                                    o = $1ff2b0a4ee3068d6$var$rt(o, u.J);
                                    break;
                                case 3:
                                    o = $1ff2b0a4ee3068d6$var$ut(o, u.J);
                            }
                            if (i = null === i ? o : i.vn($1ff2b0a4ee3068d6$var$f(o)), null !== a) {
                                var l = a.rs();
                                null !== l && (n = Math.max(n, l.above), h = Math.max(n, l.below));
                            }
                        }
                    }
                }
            }
            if (n === this.Wn && h === this.Rn || (this.Wn = n, this.Rn = h, this.Yn = null, this.uh()), null !== i) {
                if (i.ln() === i.fn()) {
                    var c = this.Xh(), v = 5 * (null === c || this.oh() || this.lh() ? 1 : c.Qh());
                    i = new $1ff2b0a4ee3068d6$var$G(i.ln() - v, i.fn() + v);
                }
                this.dh(i);
            } else null === this.On && this.dh(new $1ff2b0a4ee3068d6$var$G(-0.5, .5));
            this.Pn.Fn = !0;
        }
    }, t.prototype.Sh = function() {
        return this.oh() ? $1ff2b0a4ee3068d6$var$st : this.lh() ? $1ff2b0a4ee3068d6$var$et : this.En() ? $1ff2b0a4ee3068d6$var$at : null;
    }, t.prototype.Kh = function(t, i) {
        return void 0 === this.Gn.priceFormatter ? (void 0 === i && (i = this.Yh()), i.format(t)) : this.Gn.priceFormatter(t);
    }, t;
}();
function $1ff2b0a4ee3068d6$var$mt(t) {
    void 0 !== t.borderColor && (t.borderUpColor = t.borderColor, t.borderDownColor = t.borderColor), void 0 !== t.wickColor && (t.wickUpColor = t.wickColor, t.wickDownColor = t.wickColor);
}
!function(t) {
    t[t.LastBar = 0] = "LastBar", t[t.LastVisible = 1] = "LastVisible";
}($1ff2b0a4ee3068d6$export$10777445820939da || ($1ff2b0a4ee3068d6$export$10777445820939da = {}));
var $1ff2b0a4ee3068d6$var$gt = function(t) {
    return t.getUTCFullYear();
};
function $1ff2b0a4ee3068d6$var$pt(t, i, n) {
    return i.replace(/yyyy/g, function(t) {
        return $1ff2b0a4ee3068d6$var$$($1ff2b0a4ee3068d6$var$gt(t), 4);
    }(t)).replace(/yy/g, function(t) {
        return $1ff2b0a4ee3068d6$var$$($1ff2b0a4ee3068d6$var$gt(t) % 100, 2);
    }(t)).replace(/MMMM/g, function(t, i) {
        return new Date(t.getUTCFullYear(), t.getUTCMonth(), 1).toLocaleString(i, {
            month: "long"
        });
    }(t, n)).replace(/MMM/g, function(t, i) {
        return new Date(t.getUTCFullYear(), t.getUTCMonth(), 1).toLocaleString(i, {
            month: "short"
        });
    }(t, n)).replace(/MM/g, function(t) {
        return $1ff2b0a4ee3068d6$var$$(function(t) {
            return t.getUTCMonth() + 1;
        }(t), 2);
    }(t)).replace(/dd/g, function(t) {
        return $1ff2b0a4ee3068d6$var$$(function(t) {
            return t.getUTCDate();
        }(t), 2);
    }(t));
}
var $1ff2b0a4ee3068d6$var$yt = function() {
    function t(t, i) {
        void 0 === t && (t = "yyyy-MM-dd"), void 0 === i && (i = "default"), this.es = t, this.us = i;
    }
    return t.prototype.os = function(t) {
        return $1ff2b0a4ee3068d6$var$pt(t, this.es, this.us);
    }, t;
}(), $1ff2b0a4ee3068d6$var$kt = function() {
    function t(t) {
        this.ls = t || "%h:%m:%s";
    }
    return t.prototype.os = function(t) {
        return this.ls.replace("%h", $1ff2b0a4ee3068d6$var$$(t.getUTCHours(), 2)).replace("%m", $1ff2b0a4ee3068d6$var$$(t.getUTCMinutes(), 2)).replace("%s", $1ff2b0a4ee3068d6$var$$(t.getUTCSeconds(), 2));
    }, t;
}(), $1ff2b0a4ee3068d6$var$xt = {
    fs: "yyyy-MM-dd",
    cs: "%h:%m:%s",
    vs: " ",
    _s: "default"
}, $1ff2b0a4ee3068d6$var$Nt = function() {
    function t(t) {
        void 0 === t && (t = {});
        var i = $1ff2b0a4ee3068d6$var$u($1ff2b0a4ee3068d6$var$u({}, $1ff2b0a4ee3068d6$var$xt), t);
        this.ds = new $1ff2b0a4ee3068d6$var$yt(i.fs, i._s), this.ws = new $1ff2b0a4ee3068d6$var$kt(i.cs), this.Ms = i.vs;
    }
    return t.prototype.os = function(t) {
        return "" + this.ds.os(t) + this.Ms + this.ws.os(t);
    }, t;
}();
var $1ff2b0a4ee3068d6$var$St = function() {
    function t(t, i) {
        void 0 === i && (i = 50), this.bs = 0, this.gs = 1, this.ps = 1, this.ys = new Map, this.ks = new Map, this.xs = t, this.Ns = i;
    }
    return t.prototype.os = function(t) {
        var i = void 0 === t.Ss ? new Date(1e3 * t.Cs).getTime() : new Date(Date.UTC(t.Ss.year, t.Ss.month - 1, t.Ss.day)).getTime(), n = this.ys.get(i);
        if (void 0 !== n) return n.Ds;
        if (this.bs === this.Ns) {
            var h = this.ks.get(this.ps);
            this.ks.delete(this.ps), this.ys.delete($1ff2b0a4ee3068d6$var$l(h)), this.ps++, this.bs--;
        }
        var s = this.xs(t);
        return this.ys.set(i, {
            Ds: s,
            Ts: this.gs
        }), this.ks.set(this.gs, i), this.bs++, this.gs++, s;
    }, t;
}(), $1ff2b0a4ee3068d6$var$Ct = function() {
    function t(t, i) {
        $1ff2b0a4ee3068d6$var$o(t <= i, "right should be >= left"), this.Bs = t, this.Es = i;
    }
    return t.prototype.hs = function() {
        return this.Bs;
    }, t.prototype.ss = function() {
        return this.Es;
    }, t.prototype.Ls = function() {
        return this.Es - this.Bs + 1;
    }, t.prototype.As = function(t) {
        return this.Bs <= t && t <= this.Es;
    }, t.prototype.an = function(t) {
        return this.Bs === t.hs() && this.Es === t.ss();
    }, t;
}();
function $1ff2b0a4ee3068d6$var$Dt(t, i) {
    return null === t || null === i ? t === i : t.an(i);
}
var $1ff2b0a4ee3068d6$export$2f85f4e66fc865ef, $1ff2b0a4ee3068d6$var$Bt = function() {
    function t() {
        this.Vs = new Map, this.ys = null;
    }
    return t.prototype.Os = function(t) {
        var i = this;
        this.ys = null, this.Vs.clear(), t.forEach(function(t, n) {
            var h = i.Vs.get(t.zs);
            void 0 === h && (h = [], i.Vs.set(t.zs, h)), h.push({
                Ps: n,
                P: t.P,
                Fs: t.zs
            });
        });
    }, t.prototype.Is = function(t, i) {
        var n = Math.ceil(i / t);
        return null !== this.ys && this.ys.Ws === n || (this.ys = {
            Ln: this.Rs(n),
            Ws: n
        }), this.ys.Ln;
    }, t.prototype.Rs = function(t) {
        for(var i = [], n = 0, h = Array.from(this.Vs.keys()).sort(function(t, i) {
            return i - t;
        }); n < h.length; n++){
            var s = h[n];
            if (this.Vs.get(s)) {
                var r = i;
                i = [];
                for(var e = r.length, u = 0, a = $1ff2b0a4ee3068d6$var$l(this.Vs.get(s)), o = a.length, f = 1 / 0, c = -1 / 0, v = 0; v < o; v++){
                    for(var _ = a[v], d = _.Ps; u < e;){
                        var w = r[u], M = w.Ps;
                        if (!(M < d)) {
                            f = M;
                            break;
                        }
                        u++, i.push(w), c = M, f = 1 / 0;
                    }
                    f - d >= t && d - c >= t && (i.push(_), c = d);
                }
                for(; u < e; u++)i.push(r[u]);
            }
        }
        return i;
    }, t;
}(), $1ff2b0a4ee3068d6$var$Et = function() {
    function t(t) {
        this.js = t;
    }
    return t.prototype.Us = function() {
        return null === this.js ? null : new $1ff2b0a4ee3068d6$var$Ct(Math.floor(this.js.hs()), Math.ceil(this.js.ss()));
    }, t.prototype.qs = function() {
        return this.js;
    }, t.Hs = function() {
        return new t(null);
    }, t;
}();
!function(t) {
    t[t.Year = 0] = "Year", t[t.Month = 1] = "Month", t[t.DayOfMonth = 2] = "DayOfMonth", t[t.Time = 3] = "Time", t[t.TimeWithSeconds = 4] = "TimeWithSeconds";
}($1ff2b0a4ee3068d6$export$2f85f4e66fc865ef || ($1ff2b0a4ee3068d6$export$2f85f4e66fc865ef = {}));
var $1ff2b0a4ee3068d6$var$Lt = function() {
    function t(t, i, n) {
        this.Ys = 0, this.Ks = null, this.$s = [], this.$n = null, this.Kn = null, this.Xs = new $1ff2b0a4ee3068d6$var$Bt, this.Zs = new Map, this.Js = $1ff2b0a4ee3068d6$var$Et.Hs(), this.Gs = !0, this.Qs = new $1ff2b0a4ee3068d6$var$J, this.tr = new $1ff2b0a4ee3068d6$var$J, this.ir = new $1ff2b0a4ee3068d6$var$J, this.nr = null, this.hr = null, this.sr = [], this.xi = i, this.Gn = n, this.rr = i.rightOffset, this.er = i.barSpacing, this.hi = t, this.ur();
    }
    return t.prototype.I = function() {
        return this.xi;
    }, t.prototype.ar = function(t) {
        $1ff2b0a4ee3068d6$var$v(this.Gn, t), this.lr(), this.ur();
    }, t.prototype.hh = function(t, i) {
        var n;
        $1ff2b0a4ee3068d6$var$v(this.xi, t), this.xi.fixLeftEdge && this.cr(), this.xi.fixRightEdge && this.vr(), void 0 !== t.barSpacing && this.hi._r(t.barSpacing), void 0 !== t.rightOffset && this.hi.dr(t.rightOffset), void 0 !== t.minBarSpacing && this.hi._r(null !== (n = t.barSpacing) && void 0 !== n ? n : this.er), this.lr(), this.ur(), this.ir.hn();
    }, t.prototype.si = function(t) {
        var i;
        return (null === (i = this.$s[t]) || void 0 === i ? void 0 : i.P) || null;
    }, t.prototype.wr = function(t, i) {
        if (this.$s.length < 1) return null;
        if (t.Cs > this.$s[this.$s.length - 1].P.Cs) return i ? this.$s.length - 1 : null;
        for(var n = 0; n < this.$s.length; ++n){
            if (t.Cs === this.$s[n].P.Cs) return n;
            if (t.Cs < this.$s[n].P.Cs) return i ? n : null;
        }
        return null;
    }, t.prototype.Qt = function() {
        return 0 === this.Ys || 0 === this.$s.length;
    }, t.prototype.Mr = function() {
        return this.br(), this.Js.Us();
    }, t.prototype.mr = function() {
        return this.br(), this.Js.qs();
    }, t.prototype.gr = function() {
        var t = this.Mr();
        if (null === t) return null;
        var i = {
            from: t.hs(),
            to: t.ss()
        };
        return this.pr(i);
    }, t.prototype.pr = function(t) {
        var i = Math.round(t.from), n = Math.round(t.to), h = $1ff2b0a4ee3068d6$var$f(this.yr()), s = $1ff2b0a4ee3068d6$var$f(this.kr());
        return {
            from: $1ff2b0a4ee3068d6$var$f(this.si(Math.max(h, i))),
            to: $1ff2b0a4ee3068d6$var$f(this.si(Math.min(s, n)))
        };
    }, t.prototype.Nr = function(t) {
        return {
            from: $1ff2b0a4ee3068d6$var$f(this.wr(t.from, !0)),
            to: $1ff2b0a4ee3068d6$var$f(this.wr(t.to, !0))
        };
    }, t.prototype.Sr = function() {
        return this.Xs;
    }, t.prototype.dt = function() {
        return this.Ys;
    }, t.prototype.Cr = function(t) {
        if (isFinite(t) && !(t <= 0) && this.Ys !== t) {
            if (this.xi.lockVisibleTimeRangeOnResize && this.Ys) {
                var i = this.er * t / this.Ys;
                this.Dr(i);
            }
            if (this.xi.fixLeftEdge) {
                var n = this.Mr();
                if (null !== n) {
                    if (n.hs() <= 0) {
                        var h = this.Ys - t;
                        this.rr -= Math.round(h / this.er) + 1;
                    }
                }
            }
            this.Ys = t, this.Gs = !0, this.Tr(), this.Br();
        }
    }, t.prototype.G = function(t) {
        if (this.Qt() || !$1ff2b0a4ee3068d6$var$d(t)) return 0;
        var i = this.Er() + this.rr - t;
        return this.Ys - (i + .5) * this.er - 1;
    }, t.prototype.Lr = function(t, i) {
        for(var n = this.Er(), h = void 0 === i ? 0 : i.from, s = void 0 === i ? t.length : i.to, r = h; r < s; r++){
            var e = t[r].P, u = n + this.rr - e, a = this.Ys - (u + .5) * this.er - 1;
            t[r].g = a;
        }
    }, t.prototype.Ar = function(t) {
        return Math.ceil(this.Vr(t));
    }, t.prototype.dr = function(t) {
        this.Gs = !0, this.rr = t, this.Br(), this.hi.Or(), this.hi.zr();
    }, t.prototype.Pr = function() {
        return this.er;
    }, t.prototype._r = function(t) {
        this.Dr(t), this.Br(), this.hi.Or(), this.hi.zr();
    }, t.prototype.Fr = function() {
        return this.rr;
    }, t.prototype.Ln = function() {
        if (this.Qt()) return null;
        if (null !== this.hr) return this.hr;
        for(var t = this.er, i = 5 * (this.hi.I().layout.fontSize + 4), n = Math.round(i / t), h = $1ff2b0a4ee3068d6$var$f(this.Mr()), s = Math.max(h.hs(), h.hs() - n), r = Math.max(h.ss(), h.ss() - n), e = 0, u = 0, a = this.Xs.Is(t, i); u < a.length; u++){
            var o = a[u];
            if (s <= o.Ps && o.Ps <= r) {
                var l = this.si(o.Ps);
                if (null !== l) {
                    if (e < this.sr.length) {
                        var c = this.sr[e];
                        c.Dn = this.G(o.Ps), c.Tn = this.Ir(l, o.Fs), c.Fs = o.Fs;
                    } else this.sr.push({
                        Dn: this.G(o.Ps),
                        Tn: this.Ir(l, o.Fs),
                        Fs: o.Fs
                    });
                    e++;
                }
            }
        }
        return this.sr.length = e, this.hr = this.sr, this.sr;
    }, t.prototype.Wr = function() {
        this.Gs = !0, this._r(this.xi.barSpacing), this.dr(this.xi.rightOffset);
    }, t.prototype.Rr = function(t) {
        this.Gs = !0, this.Ks = t, this.Br(), this.cr();
    }, t.prototype.jr = function(t, i) {
        var n = this.Vr(t), h = this.Pr(), s = h + i * (h / 10);
        this._r(s), this.xi.rightBarStaysOnScroll || this.dr(this.Fr() + (n - this.Vr(t)));
    }, t.prototype.Wh = function(t) {
        this.$n && this.Hh(), null === this.Kn && null === this.nr && (this.Qt() || (this.Kn = t, this.Ur()));
    }, t.prototype.Rh = function(t) {
        if (null !== this.nr) {
            var i = $1ff2b0a4ee3068d6$var$Q(this.Ys - t, 0, this.Ys), n = $1ff2b0a4ee3068d6$var$Q(this.Ys - $1ff2b0a4ee3068d6$var$f(this.Kn), 0, this.Ys);
            0 !== i && 0 !== n && this._r(this.nr.Pr * i / n);
        }
    }, t.prototype.jh = function() {
        null !== this.Kn && (this.Kn = null, this.qr());
    }, t.prototype.Uh = function(t) {
        null === this.$n && null === this.nr && (this.Qt() || (this.$n = t, this.Ur()));
    }, t.prototype.qh = function(t) {
        if (null !== this.$n) {
            var i = (this.$n - t) / this.Pr();
            this.rr = $1ff2b0a4ee3068d6$var$f(this.nr).Fr + i, this.Gs = !0, this.Br();
        }
    }, t.prototype.Hh = function() {
        null !== this.$n && (this.$n = null, this.qr());
    }, t.prototype.Hr = function() {
        this.Yr(this.xi.rightOffset);
    }, t.prototype.Yr = function(t, i) {
        var n = this;
        if (void 0 === i && (i = 400), !isFinite(t)) throw new RangeError("offset is required and must be finite number");
        if (!isFinite(i) || i <= 0) throw new RangeError("animationDuration (optional) must be finite positive number");
        var h = this.rr, s = Date.now(), r = function() {
            var e = (Date.now() - s) / i, u = e >= 1, a = u ? t : h + (t - h) * e;
            n.dr(a), u || setTimeout(r, 20);
        };
        r();
    }, t.prototype.V = function(t) {
        this.Gs = !0, this.$s = t, this.Xs.Os(t), this.Br();
    }, t.prototype.Kr = function() {
        return this.Qs;
    }, t.prototype.$r = function() {
        return this.tr;
    }, t.prototype.Xr = function() {
        return this.ir;
    }, t.prototype.Er = function() {
        return this.Ks || 0;
    }, t.prototype.Zr = function(t) {
        var i = t.Ls();
        this.Dr(this.Ys / i), this.rr = t.ss() - this.Er(), this.Br(), this.Gs = !0, this.hi.Or(), this.hi.zr();
    }, t.prototype.Jr = function() {
        var t = this.yr(), i = this.kr();
        null !== t && null !== i && this.Zr(new $1ff2b0a4ee3068d6$var$Ct(t, i + this.xi.rightOffset));
    }, t.prototype.Gr = function(t) {
        var i = new $1ff2b0a4ee3068d6$var$Ct(t.from, t.to);
        this.Zr(i);
    }, t.prototype.ri = function(t) {
        return void 0 !== this.Gn.timeFormatter ? this.Gn.timeFormatter(t.Ss || t.Cs) : this.Qr.os(new Date(1e3 * t.Cs));
    }, t.prototype.yr = function() {
        return 0 === this.$s.length ? null : 0;
    }, t.prototype.kr = function() {
        return 0 === this.$s.length ? null : this.$s.length - 1;
    }, t.prototype.te = function(t) {
        return (this.Ys - 1 - t) / this.er;
    }, t.prototype.Vr = function(t) {
        var i = this.te(t), n = this.Er() + this.rr - i;
        return Math.round(1e6 * n) / 1e6;
    }, t.prototype.Dr = function(t) {
        var i = this.er;
        this.er = t, this.Tr(), i !== this.er && (this.Gs = !0, this.ie());
    }, t.prototype.br = function() {
        if (this.Gs) {
            if (this.Gs = !1, this.Qt()) this.ne($1ff2b0a4ee3068d6$var$Et.Hs());
            else {
                var t = this.Er(), i = this.Ys / this.er, n = this.rr + t, h = new $1ff2b0a4ee3068d6$var$Ct(n - i + 1, n);
                this.ne(new $1ff2b0a4ee3068d6$var$Et(h));
            }
        }
    }, t.prototype.Tr = function() {
        var t = this.he();
        if (this.er < t && (this.er = t, this.Gs = !0), 0 !== this.Ys) {
            var i = .5 * this.Ys;
            this.er > i && (this.er = i, this.Gs = !0);
        }
    }, t.prototype.he = function() {
        return this.xi.fixLeftEdge && this.xi.fixRightEdge ? this.Ys / this.$s.length : this.xi.minBarSpacing;
    }, t.prototype.Br = function() {
        var t = this.se();
        this.rr > t && (this.rr = t, this.Gs = !0);
        var i = this.re();
        null !== i && this.rr < i && (this.rr = i, this.Gs = !0);
    }, t.prototype.re = function() {
        var t = this.yr(), i = this.Ks;
        return null === t || null === i ? null : t - i - 1 + (this.xi.fixLeftEdge ? this.Ys / this.er : Math.min(2, this.$s.length));
    }, t.prototype.se = function() {
        return this.xi.fixRightEdge ? 0 : this.Ys / this.er - Math.min(2, this.$s.length);
    }, t.prototype.Ur = function() {
        this.nr = {
            Pr: this.Pr(),
            Fr: this.Fr()
        };
    }, t.prototype.qr = function() {
        this.nr = null;
    }, t.prototype.Ir = function(t, i) {
        var n = this, h = this.Zs.get(i);
        return void 0 === h && (h = new $1ff2b0a4ee3068d6$var$St(function(t) {
            return n.ee(t, i);
        }), this.Zs.set(i, h)), h.os(t);
    }, t.prototype.ee = function(t, i) {
        var n, h, s = this.xi.timeVisible;
        return h = i < 20 && s ? this.xi.secondsVisible ? 4 : 3 : i < 40 && s ? 3 : i < 50 || i < 60 ? 2 : i < 70 ? 1 : 0, void 0 !== this.xi.tickMarkFormatter ? this.xi.tickMarkFormatter(null !== (n = t.Ss) && void 0 !== n ? n : t.Cs, h, this.Gn.locale) : function(t, i, n) {
            var h = {};
            switch(i){
                case 0:
                    h.year = "numeric";
                    break;
                case 1:
                    h.month = "short";
                    break;
                case 2:
                    h.day = "numeric";
                    break;
                case 3:
                    h.hour12 = !1, h.hour = "2-digit", h.minute = "2-digit";
                    break;
                case 4:
                    h.hour12 = !1, h.hour = "2-digit", h.minute = "2-digit", h.second = "2-digit";
            }
            var s = void 0 === t.Ss ? new Date(1e3 * t.Cs) : new Date(Date.UTC(t.Ss.year, t.Ss.month - 1, t.Ss.day));
            return new Date(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate(), s.getUTCHours(), s.getUTCMinutes(), s.getUTCSeconds(), s.getUTCMilliseconds()).toLocaleString(n, h);
        }(t, h, this.Gn.locale);
    }, t.prototype.ne = function(t) {
        var i = this.Js;
        this.Js = t, $1ff2b0a4ee3068d6$var$Dt(i.Us(), this.Js.Us()) || this.Qs.hn(), $1ff2b0a4ee3068d6$var$Dt(i.qs(), this.Js.qs()) || this.tr.hn(), this.ie();
    }, t.prototype.ie = function() {
        this.hr = null;
    }, t.prototype.lr = function() {
        this.ie(), this.Zs.clear();
    }, t.prototype.ur = function() {
        var t = this.Gn.dateFormat;
        this.xi.timeVisible ? this.Qr = new $1ff2b0a4ee3068d6$var$Nt({
            fs: t,
            cs: this.xi.secondsVisible ? "%h:%m:%s" : "%h:%m",
            vs: "   ",
            _s: this.Gn.locale
        }) : this.Qr = new $1ff2b0a4ee3068d6$var$yt(t, this.Gn.locale);
    }, t.prototype.cr = function() {
        if (this.xi.fixLeftEdge) {
            var t = this.yr();
            if (null !== t) {
                var i = $1ff2b0a4ee3068d6$var$f(this.Mr()).hs() - t;
                if (i < 0) {
                    var n = this.rr - i - 1;
                    this.dr(n);
                }
                this.Tr();
            }
        }
    }, t.prototype.vr = function() {
        this.Br(), this.Tr();
    }, t;
}();
function $1ff2b0a4ee3068d6$export$45e4facdeecbf8d7(t) {
    return !$1ff2b0a4ee3068d6$var$_(t) && !$1ff2b0a4ee3068d6$var$w(t);
}
function $1ff2b0a4ee3068d6$export$d45648b9f1f4eae6(t) {
    return $1ff2b0a4ee3068d6$var$_(t);
}
var $1ff2b0a4ee3068d6$var$Ot = "'Trebuchet MS', Roboto, Ubuntu, sans-serif";
function $1ff2b0a4ee3068d6$var$zt(t, i, n) {
    return void 0 !== n ? n += " " : n = "", void 0 === i && (i = $1ff2b0a4ee3068d6$var$Ot), "" + n + t + "px " + i;
}
var $1ff2b0a4ee3068d6$var$Pt = function() {
    function t(t) {
        this.ue = {
            Dt: 1,
            Ct: 4,
            zt: NaN,
            xt: "",
            ae: "",
            et: "",
            Bt: 0,
            Et: 0,
            Lt: 0,
            Tt: 0,
            Ot: 0
        }, this.L = t;
    }
    return t.prototype.I = function() {
        var t = this.ue, i = this.oe(), n = this.le();
        return t.zt === i && t.ae === n || (t.zt = i, t.ae = n, t.xt = $1ff2b0a4ee3068d6$var$zt(i, n), t.Tt = Math.floor(i / 3.5), t.Bt = t.Tt, t.Et = Math.max(Math.ceil(i / 2 - t.Ct / 2), 0), t.Lt = Math.ceil(i / 2 + t.Ct / 2), t.Ot = Math.round(i / 10)), t.et = this.fe(), this.ue;
    }, t.prototype.fe = function() {
        return this.L.I().layout.textColor;
    }, t.prototype.oe = function() {
        return this.L.I().layout.fontSize;
    }, t.prototype.le = function() {
        return this.L.I().layout.fontFamily;
    }, t;
}();
function $1ff2b0a4ee3068d6$var$Ft(t) {
    return "left" === t || "right" === t;
}
var $1ff2b0a4ee3068d6$var$It = function() {
    function t(t) {
        this.ce = new Map, this.ve = !1, this._e = [], this.de = t;
    }
    return t.prototype.we = function(t, i) {
        var n = function(t, i) {
            return void 0 === t ? i : {
                Me: Math.max(t.Me, i.Me),
                fh: t.fh || i.fh
            };
        }(this.ce.get(t), i);
        this.ce.set(t, n);
    }, t.prototype.be = function() {
        return this.de;
    }, t.prototype.me = function(t) {
        var i = this.ce.get(t);
        return void 0 === i ? {
            Me: this.de
        } : {
            Me: Math.max(this.de, i.Me),
            fh: i.fh
        };
    }, t.prototype.ge = function() {
        this._e = [
            {
                pe: 0
            }
        ];
    }, t.prototype.ye = function(t) {
        this._e = [
            {
                pe: 1,
                J: t
            }
        ];
    }, t.prototype.ke = function() {
        this._e = [
            {
                pe: 4
            }
        ];
    }, t.prototype._r = function(t) {
        this._e.push({
            pe: 2,
            J: t
        });
    }, t.prototype.dr = function(t) {
        this._e.push({
            pe: 3,
            J: t
        });
    }, t.prototype.xe = function() {
        return this._e;
    }, t.prototype.vn = function(t) {
        var i = this;
        this.ve = this.ve || t.ve, this._e = this._e.concat(t._e);
        for(var n = 0, h = t._e; n < h.length; n++){
            var s = h[n];
            this.Ne(s);
        }
        this.de = Math.max(this.de, t.de), t.ce.forEach(function(t, n) {
            i.we(n, t);
        });
    }, t.prototype.Ne = function(t) {
        switch(t.pe){
            case 0:
                this.ge();
                break;
            case 1:
                this.ye(t.J);
                break;
            case 2:
                this._r(t.J);
                break;
            case 3:
                this.dr(t.J);
                break;
            case 4:
                this.ke();
        }
    }, t;
}(), $1ff2b0a4ee3068d6$var$Wt = function() {
    function t(t) {
        this.Se = t;
    }
    return t.prototype.format = function(t) {
        var i = "";
        return t < 0 && (i = "-", t = -t), t < 995 ? i + this.Ce(t) : t < 999995 ? i + this.Ce(t / 1e3) + "K" : t < 999999995 ? (t = 1e3 * Math.round(t / 1e3), i + this.Ce(t / 1e6) + "M") : (t = 1e6 * Math.round(t / 1e6), i + this.Ce(t / 1e9) + "B");
    }, t.prototype.Ce = function(t) {
        var i = Math.pow(10, this.Se);
        return ((t = Math.round(t * i) / i) >= 1e-15 && t < 1 ? t.toFixed(this.Se).replace(/\.?0+$/, "") : String(t)).replace(/(\.[1-9]*)0+$/, function(t, i) {
            return i;
        });
    }, t;
}();
function $1ff2b0a4ee3068d6$var$Rt(t, i, n, h) {
    if (0 !== i.length) {
        var s = i[h.from].g, r = i[h.from].p;
        t.moveTo(s, r);
        for(var e = h.from + 1; e < h.to; ++e){
            var u = i[e];
            if (1 === n) {
                var a = i[e - 1].p, o = u.g;
                t.lineTo(o, a);
            }
            t.lineTo(u.g, u.p);
        }
    }
}
var $1ff2b0a4ee3068d6$var$jt = function(t) {
    function i() {
        var i = null !== t && t.apply(this, arguments) || this;
        return i.v = null, i;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype._ = function(t) {
        this.v = t;
    }, i.prototype.u = function(t) {
        if (null !== this.v && 0 !== this.v.m.length && null !== this.v.M) {
            if (t.lineCap = "butt", t.lineJoin = "round", t.strokeStyle = this.v.S, t.lineWidth = this.v.rt, $1ff2b0a4ee3068d6$var$h(t, this.v.ut), t.lineWidth = 1, t.beginPath(), 1 === this.v.m.length) {
                var i = this.v.m[0], n = this.v.De / 2;
                t.moveTo(i.g - n, this.v.Te), t.lineTo(i.g - n, i.p), t.lineTo(i.g + n, i.p), t.lineTo(i.g + n, this.v.Te);
            } else t.moveTo(this.v.m[this.v.M.from].g, this.v.Te), t.lineTo(this.v.m[this.v.M.from].g, this.v.m[this.v.M.from].p), $1ff2b0a4ee3068d6$var$Rt(t, this.v.m, this.v.Be, this.v.M), this.v.M.to > this.v.M.from && (t.lineTo(this.v.m[this.v.M.to - 1].g, this.v.Te), t.lineTo(this.v.m[this.v.M.from].g, this.v.Te));
            t.closePath();
            var s = t.createLinearGradient(0, 0, 0, this.v.Te);
            s.addColorStop(0, this.v.Ee), s.addColorStop(1, this.v.Le), t.fillStyle = s, t.fill();
        }
    }, i;
}($1ff2b0a4ee3068d6$var$y), $1ff2b0a4ee3068d6$var$Ut = function(t) {
    function i() {
        var i = null !== t && t.apply(this, arguments) || this;
        return i.v = null, i;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype._ = function(t) {
        this.v = t;
    }, i.prototype.u = function(t) {
        if (null !== this.v && 0 !== this.v.m.length && null !== this.v.M) {
            if (t.lineCap = "butt", t.lineWidth = this.v.rt, $1ff2b0a4ee3068d6$var$h(t, this.v.ut), t.strokeStyle = this.v.S, t.lineJoin = "round", t.beginPath(), 1 === this.v.m.length) {
                var i = this.v.m[0];
                t.moveTo(i.g - this.v.De / 2, i.p), t.lineTo(i.g + this.v.De / 2, i.p);
            } else $1ff2b0a4ee3068d6$var$Rt(t, this.v.m, this.v.Be, this.v.M);
            t.stroke();
        }
    }, i;
}($1ff2b0a4ee3068d6$var$y);
function $1ff2b0a4ee3068d6$var$qt(t, i, n, h, s) {
    void 0 === h && (h = 0), void 0 === s && (s = t.length);
    for(var r = s - h; 0 < r;){
        var e = r >> 1, u = h + e;
        n(t[u], i) ? (h = u + 1, r -= e + 1) : r = e;
    }
    return h;
}
function $1ff2b0a4ee3068d6$var$Ht(t, i, n, h, s) {
    void 0 === h && (h = 0), void 0 === s && (s = t.length);
    for(var r = s - h; 0 < r;){
        var e = r >> 1, u = h + e;
        n(i, t[u]) ? r = e : (h = u + 1, r -= e + 1);
    }
    return h;
}
function $1ff2b0a4ee3068d6$var$Yt(t, i) {
    return t.P < i;
}
function $1ff2b0a4ee3068d6$var$Kt(t, i) {
    return t < i.P;
}
function $1ff2b0a4ee3068d6$var$$t(t, i, n) {
    var h = i.hs(), s = i.ss(), r = $1ff2b0a4ee3068d6$var$qt(t, h, $1ff2b0a4ee3068d6$var$Yt), e = $1ff2b0a4ee3068d6$var$Ht(t, s, $1ff2b0a4ee3068d6$var$Kt);
    if (!n) return {
        from: r,
        to: e
    };
    var u = r, a = e;
    return r > 0 && r < t.length && t[r].P >= h && (u = r - 1), e > 0 && e < t.length && t[e - 1].P <= s && (a = e + 1), {
        from: u,
        to: a
    };
}
var $1ff2b0a4ee3068d6$var$Xt = function() {
    function t(t, i, n) {
        this.Ae = !0, this.Ve = !0, this.Oe = !0, this.ze = [], this.Pe = null, this.Fe = t, this.Ie = i, this.We = n;
    }
    return t.prototype.V = function(t) {
        this.Ae = !0, "data" === t && (this.Ve = !0), "options" === t && (this.Oe = !0);
    }, t.prototype.Re = function() {
        this.Ve && (this.je(), this.Ve = !1), this.Ae && (this.Ue(), this.Ae = !1), this.Oe && (this.qe(), this.Oe = !1);
    }, t.prototype.He = function() {
        this.Pe = null;
    }, t.prototype.Ue = function() {
        var t = this.Fe.Z(), i = this.Ie.U();
        if (this.He(), !i.Qt() && !t.Qt()) {
            var n = i.Mr();
            if (null !== n && 0 !== this.Fe.qi().Ye()) {
                var h = this.Fe.Y();
                null !== h && (this.Pe = $1ff2b0a4ee3068d6$var$$t(this.ze, n, this.We), this.Ke(t, i, h.J));
            }
        }
    }, t;
}(), $1ff2b0a4ee3068d6$var$Zt = function(t) {
    function i(i, n) {
        return t.call(this, i, n, !0) || this;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.Ke = function(t, i, n) {
        i.Lr(this.ze, $1ff2b0a4ee3068d6$var$g(this.Pe)), t.Nh(this.ze, n, $1ff2b0a4ee3068d6$var$g(this.Pe));
    }, i.prototype.$e = function(t, i) {
        return {
            P: t,
            F: i,
            g: NaN,
            p: NaN
        };
    }, i.prototype.qe = function() {}, i.prototype.je = function() {
        var t = this, i = this.Fe.Xe();
        this.ze = this.Fe.qi().Ze().map(function(n) {
            var h = n.J[3];
            return t.Je(n.Ps, h, i);
        });
    }, i;
}($1ff2b0a4ee3068d6$var$Xt), $1ff2b0a4ee3068d6$var$Jt = function(t) {
    function i(i, n) {
        var h = t.call(this, i, n) || this;
        return h.ot = new $1ff2b0a4ee3068d6$var$p, h.Ge = new $1ff2b0a4ee3068d6$var$jt, h.Qe = new $1ff2b0a4ee3068d6$var$Ut, h.ot.i([
            h.Ge,
            h.Qe
        ]), h;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.W = function(t, i) {
        if (!this.Fe.H()) return null;
        var n = this.Fe.I();
        this.Re();
        var h = {
            Be: n.lineType,
            m: this.ze,
            S: n.lineColor,
            ut: n.lineStyle,
            rt: n.lineWidth,
            Ee: n.topColor,
            Le: n.bottomColor,
            Te: t,
            M: this.Pe,
            De: this.Ie.U().Pr()
        };
        return this.Ge._(h), this.Qe._(h), this.ot;
    }, i.prototype.Je = function(t, i) {
        return this.$e(t, i);
    }, i;
}($1ff2b0a4ee3068d6$var$Zt);
var $1ff2b0a4ee3068d6$var$Gt = function() {
    function t() {
        this.tt = null, this.tu = 0, this.iu = 0;
    }
    return t.prototype._ = function(t) {
        this.tt = t;
    }, t.prototype.h = function(t, i, n, h) {
        if (null !== this.tt && 0 !== this.tt.qi.length && null !== this.tt.M) {
            if (this.tu = this.nu(i), this.tu >= 2) Math.max(1, Math.floor(i)) % 2 != this.tu % 2 && this.tu--;
            this.iu = this.tt.hu ? Math.min(this.tu, Math.floor(i)) : this.tu;
            for(var s = null, r = this.iu <= this.tu && this.tt.Pr >= Math.floor(1.5 * i), e = this.tt.M.from; e < this.tt.M.to; ++e){
                var u = this.tt.qi[e];
                s !== u.et && (t.fillStyle = u.et, s = u.et);
                var a = Math.floor(.5 * this.iu), o = Math.round(u.g * i), l = o - a, f = this.iu, c = l + f - 1, v = Math.min(u.Th, u.Bh), _ = Math.max(u.Th, u.Bh), d = Math.round(v * i) - a, w = Math.round(_ * i) + a, M = Math.max(w - d, this.iu);
                t.fillRect(l, d, f, M);
                var b = Math.ceil(1.5 * this.tu);
                if (r) {
                    if (this.tt.su) {
                        var m = o - b, g = Math.max(d, Math.round(u.Dh * i) - a), p = g + f - 1;
                        p > d + M - 1 && (g = (p = d + M - 1) - f + 1), t.fillRect(m, g, l - m, p - g + 1);
                    }
                    var y = o + b, k = Math.max(d, Math.round(u.Eh * i) - a), x = k + f - 1;
                    x > d + M - 1 && (k = (x = d + M - 1) - f + 1), t.fillRect(c + 1, k, y - c, x - k + 1);
                }
            }
        }
    }, t.prototype.nu = function(t) {
        var i = Math.floor(t);
        return Math.max(i, Math.floor(function(t, i) {
            return Math.floor(.3 * t * i);
        }($1ff2b0a4ee3068d6$var$f(this.tt).Pr, t)));
    }, t;
}(), $1ff2b0a4ee3068d6$var$Qt = function(t) {
    function i(i, n) {
        return t.call(this, i, n, !1) || this;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.Ke = function(t, i, n) {
        i.Lr(this.ze, $1ff2b0a4ee3068d6$var$g(this.Pe)), t.Ch(this.ze, n, $1ff2b0a4ee3068d6$var$g(this.Pe));
    }, i.prototype.ru = function(t, i, n) {
        return {
            P: t,
            open: i.J[0],
            high: i.J[1],
            low: i.J[2],
            close: i.J[3],
            g: NaN,
            Dh: NaN,
            Th: NaN,
            Bh: NaN,
            Eh: NaN
        };
    }, i.prototype.je = function() {
        var t = this, i = this.Fe.Xe();
        this.ze = this.Fe.qi().Ze().map(function(n) {
            return t.Je(n.Ps, n, i);
        });
    }, i;
}($1ff2b0a4ee3068d6$var$Xt), $1ff2b0a4ee3068d6$var$ti = function(t) {
    function i() {
        var i = null !== t && t.apply(this, arguments) || this;
        return i.ot = new $1ff2b0a4ee3068d6$var$Gt, i;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.W = function(t, i) {
        if (!this.Fe.H()) return null;
        var n = this.Fe.I();
        this.Re();
        var h = {
            qi: this.ze,
            Pr: this.Ie.U().Pr(),
            su: n.openVisible,
            hu: n.thinBars,
            M: this.Pe
        };
        return this.ot._(h), this.ot;
    }, i.prototype.qe = function() {
        var t = this;
        this.ze.forEach(function(i) {
            i.et = t.Fe.Xe().uu(i.P).eu;
        });
    }, i.prototype.Je = function(t, i, n) {
        return $1ff2b0a4ee3068d6$var$u($1ff2b0a4ee3068d6$var$u({}, this.ru(t, i, n)), {
            et: n.uu(t).eu
        });
    }, i;
}($1ff2b0a4ee3068d6$var$Qt), $1ff2b0a4ee3068d6$var$ii = function() {
    function t() {
        this.tt = null, this.tu = 0;
    }
    return t.prototype._ = function(t) {
        this.tt = t;
    }, t.prototype.h = function(t, i, n, h) {
        if (null !== this.tt && 0 !== this.tt.qi.length && null !== this.tt.M) {
            if (this.tu = function(t, i) {
                if (t >= 2.5 && t <= 4) return Math.floor(3 * i);
                var n = 1 - .2 * Math.atan(Math.max(4, t) - 4) / (.5 * Math.PI), h = Math.floor(t * n * i), s = Math.floor(t * i), r = Math.min(h, s);
                return Math.max(Math.floor(i), r);
            }(this.tt.Pr, i), this.tu >= 2) Math.floor(i) % 2 != this.tu % 2 && this.tu--;
            var s = this.tt.qi;
            this.tt.au && this.ou(t, s, this.tt.M, i), this.tt.lu && this.fu(t, s, this.tt.M, this.tt.Pr, i);
            var r = this.cu(i);
            (!this.tt.lu || this.tu > 2 * r) && this.vu(t, s, this.tt.M, i);
        }
    }, t.prototype.ou = function(t, i, n, h) {
        if (null !== this.tt) {
            var s = "", r = Math.min(Math.floor(h), Math.floor(this.tt.Pr * h));
            r = Math.max(Math.floor(h), Math.min(r, this.tu));
            for(var e = Math.floor(.5 * r), u = null, a = n.from; a < n.to; a++){
                var o = i[a];
                o._u !== s && (t.fillStyle = o._u, s = o._u);
                var l = Math.round(Math.min(o.Dh, o.Eh) * h), f = Math.round(Math.max(o.Dh, o.Eh) * h), c = Math.round(o.Th * h), v = Math.round(o.Bh * h), _ = Math.round(h * o.g) - e, d = _ + r - 1;
                null !== u && (_ = Math.max(u + 1, _), _ = Math.min(_, d));
                var w = d - _ + 1;
                t.fillRect(_, c, w, l - c), t.fillRect(_, f + 1, w, v - f), u = d;
            }
        }
    }, t.prototype.cu = function(t) {
        var i = Math.floor(1 * t);
        this.tu <= 2 * i && (i = Math.floor(.5 * (this.tu - 1)));
        var n = Math.max(Math.floor(t), i);
        return this.tu <= 2 * n ? Math.max(Math.floor(t), Math.floor(1 * t)) : n;
    }, t.prototype.fu = function(t, i, n, h, s) {
        if (null !== this.tt) for(var r = "", e = this.cu(s), u = null, a = n.from; a < n.to; a++){
            var o = i[a];
            o.$ !== r && (t.fillStyle = o.$, r = o.$);
            var l = Math.round(o.g * s) - Math.floor(.5 * this.tu), f = l + this.tu - 1, c = Math.round(Math.min(o.Dh, o.Eh) * s), v = Math.round(Math.max(o.Dh, o.Eh) * s);
            if (null !== u && (l = Math.max(u + 1, l), l = Math.min(l, f)), this.tt.Pr * s > 2 * e) $1ff2b0a4ee3068d6$var$O(t, l, c, f - l + 1, v - c + 1, e);
            else {
                var _ = f - l + 1;
                t.fillRect(l, c, _, v - c + 1);
            }
            u = f;
        }
    }, t.prototype.vu = function(t, i, n, h) {
        if (null !== this.tt) for(var s = "", r = this.cu(h), e = n.from; e < n.to; e++){
            var u = i[e], a = Math.round(Math.min(u.Dh, u.Eh) * h), o = Math.round(Math.max(u.Dh, u.Eh) * h), l = Math.round(u.g * h) - Math.floor(.5 * this.tu), f = l + this.tu - 1;
            if (u.et !== s) {
                var c = u.et;
                t.fillStyle = c, s = c;
            }
            this.tt.lu && (l += r, a += r, f -= r, o -= r), a > o || t.fillRect(l, a, f - l + 1, o - a + 1);
        }
    }, t;
}(), $1ff2b0a4ee3068d6$var$ni = function(t) {
    function i() {
        var i = null !== t && t.apply(this, arguments) || this;
        return i.ot = new $1ff2b0a4ee3068d6$var$ii, i;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.W = function(t, i) {
        if (!this.Fe.H()) return null;
        var n = this.Fe.I();
        this.Re();
        var h = {
            qi: this.ze,
            Pr: this.Ie.U().Pr(),
            au: n.wickVisible,
            lu: n.borderVisible,
            M: this.Pe
        };
        return this.ot._(h), this.ot;
    }, i.prototype.qe = function() {
        var t = this;
        this.ze.forEach(function(i) {
            var n = t.Fe.Xe().uu(i.P);
            i.et = n.eu, i._u = n.du, i.$ = n.wu;
        });
    }, i.prototype.Je = function(t, i, n) {
        var h = n.uu(t);
        return $1ff2b0a4ee3068d6$var$u($1ff2b0a4ee3068d6$var$u({}, this.ru(t, i, n)), {
            et: h.eu,
            _u: h.du,
            $: h.wu
        });
    }, i;
}($1ff2b0a4ee3068d6$var$Qt), $1ff2b0a4ee3068d6$var$hi = function() {
    function t() {
        this.tt = null, this.Mu = [];
    }
    return t.prototype._ = function(t) {
        this.tt = t, this.Mu = [];
    }, t.prototype.h = function(t, i, n, h) {
        if (null !== this.tt && 0 !== this.tt.m.length && null !== this.tt.M) {
            this.Mu.length || this.bu(i);
            for(var s = Math.max(1, Math.floor(i)), r = Math.round(this.tt.mu * i) - Math.floor(s / 2), e = r + s, u = this.tt.M.from; u < this.tt.M.to; u++){
                var a = this.tt.m[u], o = this.Mu[u - this.tt.M.from], l = Math.round(a.p * i);
                t.fillStyle = a.et;
                var f = void 0, c = void 0;
                l <= r ? (f = l, c = e) : (f = r, c = l - Math.floor(s / 2) + s), t.fillRect(o.hs, f, o.ss - o.hs + 1, c - f);
            }
        }
    }, t.prototype.bu = function(t) {
        if (null !== this.tt && 0 !== this.tt.m.length && null !== this.tt.M) {
            var i = Math.ceil(this.tt.Pr * t) <= 1 ? 0 : Math.max(1, Math.floor(t)), n = Math.round(this.tt.Pr * t) - i;
            this.Mu = new Array(this.tt.M.to - this.tt.M.from);
            for(var h = this.tt.M.from; h < this.tt.M.to; h++){
                var s, r = this.tt.m[h], e = Math.round(r.g * t), u = void 0, a = void 0;
                if (n % 2) u = e - (s = (n - 1) / 2), a = e + s;
                else u = e - (s = n / 2), a = e + s - 1;
                this.Mu[h - this.tt.M.from] = {
                    hs: u,
                    ss: a,
                    gu: e,
                    pu: r.g * t,
                    P: r.P
                };
            }
            for(h = this.tt.M.from + 1; h < this.tt.M.to; h++){
                var o = this.Mu[h - this.tt.M.from], l = this.Mu[h - this.tt.M.from - 1];
                o.P === l.P + 1 && o.hs - l.ss !== i + 1 && (l.gu > l.pu ? l.ss = o.hs - i - 1 : o.hs = l.ss + i + 1);
            }
            var f = Math.ceil(this.tt.Pr * t);
            for(h = this.tt.M.from; h < this.tt.M.to; h++){
                (o = this.Mu[h - this.tt.M.from]).ss < o.hs && (o.ss = o.hs);
                var c = o.ss - o.hs + 1;
                f = Math.min(c, f);
            }
            if (i > 0 && f < 4) for(h = this.tt.M.from; h < this.tt.M.to; h++)(c = (o = this.Mu[h - this.tt.M.from]).ss - o.hs + 1) > f && (o.gu > o.pu ? o.ss -= 1 : o.hs += 1);
        } else this.Mu = [];
    }, t;
}();
function $1ff2b0a4ee3068d6$var$si(t) {
    return {
        m: [],
        Pr: t,
        mu: NaN,
        M: null
    };
}
function $1ff2b0a4ee3068d6$var$ri(t, i, n) {
    return {
        P: t,
        F: i,
        g: NaN,
        p: NaN,
        et: n
    };
}
var $1ff2b0a4ee3068d6$var$ei = function(t) {
    function i(i, n) {
        var h = t.call(this, i, n, !1) || this;
        return h.C = new $1ff2b0a4ee3068d6$var$p, h.yu = $1ff2b0a4ee3068d6$var$si(0), h.ot = new $1ff2b0a4ee3068d6$var$hi, h;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.W = function(t, i) {
        return this.Fe.H() ? (this.Re(), this.C) : null;
    }, i.prototype.je = function() {
        var t = this.Ie.U().Pr();
        this.yu = $1ff2b0a4ee3068d6$var$si(t);
        for(var i = 0, n = 0, h = this.Fe.I().color, s = 0, r = this.Fe.qi().Ze(); s < r.length; s++){
            var e = r[s], u = e.J[3], a = void 0 !== e.et ? e.et : h, o = $1ff2b0a4ee3068d6$var$ri(e.Ps, u, a);
            ++i < this.yu.m.length ? this.yu.m[i] = o : this.yu.m.push(o), this.ze[n++] = {
                P: e.Ps,
                g: 0
            };
        }
        this.ot._(this.yu), this.C.i([
            this.ot
        ]);
    }, i.prototype.qe = function() {}, i.prototype.He = function() {
        t.prototype.He.call(this), this.yu.M = null;
    }, i.prototype.Ke = function(t, i, n) {
        if (null !== this.Pe) {
            var h = i.Pr(), s = $1ff2b0a4ee3068d6$var$f(i.Mr()), r = t.X(this.Fe.I().base, n);
            i.Lr(this.yu.m), t.Nh(this.yu.m, n), this.yu.mu = r, this.yu.M = $1ff2b0a4ee3068d6$var$$t(this.yu.m, s, !1), this.yu.Pr = h, this.ot._(this.yu);
        }
    }, i;
}($1ff2b0a4ee3068d6$var$Xt), $1ff2b0a4ee3068d6$var$ui = function(t) {
    function i(i, n) {
        var h = t.call(this, i, n) || this;
        return h.Qe = new $1ff2b0a4ee3068d6$var$Ut, h;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.W = function(t, i) {
        if (!this.Fe.H()) return null;
        var n = this.Fe.I();
        this.Re();
        var h = {
            m: this.ze,
            S: n.color,
            ut: n.lineStyle,
            Be: n.lineType,
            rt: n.lineWidth,
            M: this.Pe,
            De: this.Ie.U().Pr()
        };
        return this.Qe._(h), this.Qe;
    }, i.prototype.Je = function(t, i) {
        return this.$e(t, i);
    }, i;
}($1ff2b0a4ee3068d6$var$Zt), $1ff2b0a4ee3068d6$var$ai = /[2-9]/g, $1ff2b0a4ee3068d6$var$oi = function() {
    function t(t) {
        void 0 === t && (t = 50), this.ys = new Map, this.ku = 0, this.xu = Array.from(new Array(t));
    }
    return t.prototype.Nu = function() {
        this.ys.clear(), this.xu.fill(void 0);
    }, t.prototype.Vt = function(t, i, n) {
        var h = n || $1ff2b0a4ee3068d6$var$ai, s = String(i).replace(h, "0"), r = this.ys.get(s);
        if (void 0 === r) {
            if (0 === (r = t.measureText(s).width) && 0 !== i.length) return 0;
            var e = this.xu[this.ku];
            void 0 !== e && this.ys.delete(e), this.xu[this.ku] = s, this.ku = (this.ku + 1) % this.xu.length, this.ys.set(s, r);
        }
        return r;
    }, t;
}(), $1ff2b0a4ee3068d6$var$li = function() {
    function t(t) {
        this.Su = null, this.ue = null, this.Cu = "right", this.Ys = 0, this.Du = t;
    }
    return t.prototype.Tu = function(t, i, n, h) {
        this.Su = t, this.ue = i, this.Ys = n, this.Cu = h;
    }, t.prototype.h = function(t, i) {
        null !== this.ue && null !== this.Su && this.Su.h(t, this.ue, this.Du, this.Ys, this.Cu, i);
    }, t;
}(), $1ff2b0a4ee3068d6$var$fi = function() {
    function t(t, i, n) {
        this.Bu = t, this.Du = new $1ff2b0a4ee3068d6$var$oi(50), this.Eu = i, this.L = n, this.oe = -1, this.ot = new $1ff2b0a4ee3068d6$var$li(this.Du);
    }
    return t.prototype.W = function(t, i) {
        var n = this.L.Lu(this.Eu);
        if (null === n) return null;
        var h = n.Au(this.Eu) ? n.Ci() : this.Eu.Z();
        if (null === h) return null;
        var s = n.Vu(h);
        if ("overlay" === s) return null;
        var r = this.L.Ou();
        return r.zt !== this.oe && (this.oe = r.zt, this.Du.Nu()), this.ot.Tu(this.Bu.Xt(), r, i, s), this.ot;
    }, t;
}(), $1ff2b0a4ee3068d6$var$ci = function() {
    function t() {
        this.tt = null;
    }
    return t.prototype._ = function(t) {
        this.tt = t;
    }, t.prototype.h = function(t, i, n, r) {
        if (null !== this.tt && !1 !== this.tt.H) {
            var e = Math.round(this.tt.p * i);
            if (!(e < 0 || e > Math.ceil(this.tt.wt * i))) {
                var u = Math.ceil(this.tt.dt * i);
                t.lineCap = "butt", t.strokeStyle = this.tt.et, t.lineWidth = Math.floor(this.tt.rt * i), $1ff2b0a4ee3068d6$var$h(t, this.tt.ut), $1ff2b0a4ee3068d6$var$s(t, e, 0, u);
            }
        }
    }, t;
}(), $1ff2b0a4ee3068d6$var$vi = function() {
    function t(t) {
        this.zu = {
            dt: 0,
            wt: 0,
            p: 0,
            et: "rgba(0, 0, 0, 0)",
            rt: 1,
            ut: 0,
            H: !1
        }, this.Pu = new $1ff2b0a4ee3068d6$var$ci, this.B = !0, this.Fe = t, this.Ie = t.ct(), this.Pu._(this.zu);
    }
    return t.prototype.V = function() {
        this.B = !0;
    }, t.prototype.W = function(t, i) {
        return this.Fe.H() ? (this.B && (this.Fu(t, i), this.B = !1), this.Pu) : null;
    }, t;
}(), $1ff2b0a4ee3068d6$var$_i = function(t) {
    function i(i) {
        return t.call(this, i) || this;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.Fu = function(t, i) {
        this.zu.H = !1;
        var n = this.Fe.Z(), h = n.eh().eh;
        if (2 === h || 3 === h) {
            var s = this.Fe.I();
            if (s.baseLineVisible && this.Fe.H()) {
                var r = this.Fe.Y();
                null !== r && (this.zu.H = !0, this.zu.p = n.X(r.J, r.J), this.zu.dt = i, this.zu.wt = t, this.zu.et = s.baseLineColor, this.zu.rt = s.baseLineWidth, this.zu.ut = s.baseLineStyle);
            }
        }
    }, i;
}($1ff2b0a4ee3068d6$var$vi);
function $1ff2b0a4ee3068d6$var$di(t, i) {
    return $1ff2b0a4ee3068d6$var$ht(Math.min(Math.max(t, 12), 30) * i);
}
function $1ff2b0a4ee3068d6$var$wi(t, i) {
    switch(t){
        case "arrowDown":
        case "arrowUp":
            return $1ff2b0a4ee3068d6$var$di(i, 1);
        case "circle":
            return $1ff2b0a4ee3068d6$var$di(i, .8);
        case "square":
            return $1ff2b0a4ee3068d6$var$di(i, .7);
    }
}
function $1ff2b0a4ee3068d6$var$Mi(t) {
    return $1ff2b0a4ee3068d6$var$nt($1ff2b0a4ee3068d6$var$di(t, 1));
}
function $1ff2b0a4ee3068d6$var$bi(t) {
    return Math.max($1ff2b0a4ee3068d6$var$di(t, .1), 3);
}
function $1ff2b0a4ee3068d6$var$mi(t, i, n, h, s) {
    var r = $1ff2b0a4ee3068d6$var$wi("square", n), e = (r - 1) / 2, u = t - e, a = i - e;
    return h >= u && h <= u + r && s >= a && s <= a + r;
}
function $1ff2b0a4ee3068d6$var$gi(t, i, n, h, s) {
    var r = ($1ff2b0a4ee3068d6$var$wi("arrowUp", s) - 1) / 2, e = ($1ff2b0a4ee3068d6$var$ht(s / 2) - 1) / 2;
    i.beginPath(), t ? (i.moveTo(n - r, h), i.lineTo(n, h - r), i.lineTo(n + r, h), i.lineTo(n + e, h), i.lineTo(n + e, h + r), i.lineTo(n - e, h + r), i.lineTo(n - e, h)) : (i.moveTo(n - r, h), i.lineTo(n, h + r), i.lineTo(n + r, h), i.lineTo(n + e, h), i.lineTo(n + e, h - r), i.lineTo(n - e, h - r), i.lineTo(n - e, h)), i.fill();
}
function $1ff2b0a4ee3068d6$var$pi(t, i, n, h, s, r) {
    return $1ff2b0a4ee3068d6$var$mi(i, n, h, s, r);
}
var $1ff2b0a4ee3068d6$var$yi = function(t) {
    function i() {
        var i = null !== t && t.apply(this, arguments) || this;
        return i.tt = null, i.Du = new $1ff2b0a4ee3068d6$var$oi, i.oe = -1, i.le = "", i.Iu = "", i;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype._ = function(t) {
        this.tt = t;
    }, i.prototype.Tu = function(t, i) {
        this.oe === t && this.le === i || (this.oe = t, this.le = i, this.Iu = $1ff2b0a4ee3068d6$var$zt(t, i), this.Du.Nu());
    }, i.prototype.Wu = function(t, i) {
        if (null === this.tt || null === this.tt.M) return null;
        for(var n = this.tt.M.from; n < this.tt.M.to; n++){
            var h = this.tt.m[n];
            if ($1ff2b0a4ee3068d6$var$xi(h, t, i)) return {
                Ru: h.ju,
                Uu: h.Uu
            };
        }
        return null;
    }, i.prototype.u = function(t, i, n) {
        if (null !== this.tt && null !== this.tt.M) {
            t.textBaseline = "middle", t.font = this.Iu;
            for(var h = this.tt.M.from; h < this.tt.M.to; h++){
                var s = this.tt.m[h];
                void 0 !== s.At && (s.At.dt = this.Du.Vt(t, s.At.qu), s.At.wt = this.oe), $1ff2b0a4ee3068d6$var$ki(s, t);
            }
        }
    }, i;
}($1ff2b0a4ee3068d6$var$y);
function $1ff2b0a4ee3068d6$var$ki(t, i) {
    i.fillStyle = t.et, void 0 !== t.At && function(t, i, n, h) {
        t.fillText(i, n, h);
    }(i, t.At.qu, t.g - t.At.dt / 2, t.At.p), function(t, i) {
        if (0 === t.Ye) return;
        switch(t.Hu){
            case "arrowDown":
                return void $1ff2b0a4ee3068d6$var$gi(!1, i, t.g, t.p, t.Ye);
            case "arrowUp":
                return void $1ff2b0a4ee3068d6$var$gi(!0, i, t.g, t.p, t.Ye);
            case "circle":
                return void function(t, i, n, h) {
                    var s = ($1ff2b0a4ee3068d6$var$wi("circle", h) - 1) / 2;
                    t.beginPath(), t.arc(i, n, s, 0, 2 * Math.PI, !1), t.fill();
                }(i, t.g, t.p, t.Ye);
            case "square":
                return void function(t, i, n, h) {
                    var s = $1ff2b0a4ee3068d6$var$wi("square", h), r = (s - 1) / 2, e = i - r, u = n - r;
                    t.fillRect(e, u, s, s);
                }(i, t.g, t.p, t.Ye);
        }
        t.Hu;
    }(t, i);
}
function $1ff2b0a4ee3068d6$var$xi(t, i, n) {
    return !(void 0 === t.At || !function(t, i, n, h, s, r) {
        var e = h / 2;
        return s >= t && s <= t + n && r >= i - e && r <= i + e;
    }(t.g, t.At.p, t.At.dt, t.At.wt, i, n)) || function(t, i, n) {
        if (0 === t.Ye) return !1;
        switch(t.Hu){
            case "arrowDown":
            case "arrowUp":
                return $1ff2b0a4ee3068d6$var$pi(0, t.g, t.p, t.Ye, i, n);
            case "circle":
                return function(t, i, n, h, s) {
                    var r = 2 + $1ff2b0a4ee3068d6$var$wi("circle", n) / 2, e = t - h, u = i - s;
                    return Math.sqrt(e * e + u * u) <= r;
                }(t.g, t.p, t.Ye, i, n);
            case "square":
                return $1ff2b0a4ee3068d6$var$mi(t.g, t.p, t.Ye, i, n);
        }
        t.Hu;
    }(t, i, n);
}
function $1ff2b0a4ee3068d6$var$Ni(t, i, n, h, s, r, e, u, a) {
    var o = $1ff2b0a4ee3068d6$var$_(n) ? n : n.close, l = $1ff2b0a4ee3068d6$var$_(n) ? n : n.high, f = $1ff2b0a4ee3068d6$var$_(n) ? n : n.low, c = $1ff2b0a4ee3068d6$var$_(i.size) ? Math.max(i.size, 0) : 1, v = $1ff2b0a4ee3068d6$var$Mi(u.Pr()) * c, d = v / 2;
    switch(t.Ye = v, i.position){
        case "inBar":
            return t.p = e.X(o, a), void (void 0 !== t.At && (t.At.p = t.p + d + r + .6 * s));
        case "aboveBar":
            return t.p = e.X(l, a) - d - h.Yu, void 0 !== t.At && (t.At.p = t.p - d - .6 * s, h.Yu += 1.2 * s), void (h.Yu += v + r);
        case "belowBar":
            return t.p = e.X(f, a) + d + h.Ku, void 0 !== t.At && (t.At.p = t.p + d + r + .6 * s, h.Ku += 1.2 * s), void (h.Ku += v + r);
    }
    i.position;
}
var $1ff2b0a4ee3068d6$var$Si = function() {
    function t(t, i) {
        this.B = !0, this.$u = !0, this.Xu = !0, this.Zu = null, this.ot = new $1ff2b0a4ee3068d6$var$yi, this.Ju = t, this.hi = i, this.tt = {
            m: [],
            M: null
        };
    }
    return t.prototype.V = function(t) {
        this.B = !0, this.Xu = !0, "data" === t && (this.$u = !0);
    }, t.prototype.W = function(t, i, n) {
        if (!this.Ju.H()) return null;
        this.B && this.Re();
        var h = this.hi.I().layout;
        return this.ot.Tu(h.fontSize, h.fontFamily), this.ot._(this.tt), this.ot;
    }, t.prototype.Gu = function() {
        if (this.Xu) {
            if (this.Ju.Qu().length > 0) {
                var t = this.hi.U().Pr(), i = $1ff2b0a4ee3068d6$var$bi(t), n = 1.5 * $1ff2b0a4ee3068d6$var$Mi(t) + 2 * i;
                this.Zu = {
                    above: n,
                    below: n
                };
            } else this.Zu = null;
            this.Xu = !1;
        }
        return this.Zu;
    }, t.prototype.Re = function() {
        var t = this.Ju.Z(), i = this.hi.U(), n = this.Ju.Qu();
        this.$u && (this.tt.m = n.map(function(t) {
            return {
                P: t.time,
                g: 0,
                p: 0,
                Ye: 0,
                Hu: t.shape,
                et: t.color,
                ju: t.ju,
                Uu: t.id,
                At: void 0
            };
        }), this.$u = !1);
        var h = this.hi.I().layout;
        this.tt.M = null;
        var s = i.Mr();
        if (null !== s) {
            var r = this.Ju.Y();
            if (null !== r && 0 !== this.tt.m.length) {
                var e = NaN, u = $1ff2b0a4ee3068d6$var$bi(i.Pr()), a = {
                    Yu: u,
                    Ku: u
                };
                this.tt.M = $1ff2b0a4ee3068d6$var$$t(this.tt.m, s, !0);
                for(var o = this.tt.M.from; o < this.tt.M.to; o++){
                    var l = n[o];
                    l.time !== e && (a.Yu = u, a.Ku = u, e = l.time);
                    var f = this.tt.m[o];
                    f.g = i.G(l.time), void 0 !== l.text && l.text.length > 0 && (f.At = {
                        qu: l.text,
                        p: 0,
                        dt: 0,
                        wt: 0
                    });
                    var c = this.Ju.ta(l.time);
                    null !== c && $1ff2b0a4ee3068d6$var$Ni(f, l, c, a, h.fontSize, u, t, i, r.J);
                }
                this.B = !1;
            }
        }
    }, t;
}(), $1ff2b0a4ee3068d6$var$Ci = function(t) {
    function i(i) {
        return t.call(this, i) || this;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.Fu = function(t, i) {
        var n = this.zu;
        n.H = !1;
        var h = this.Fe.I();
        if (h.priceLineVisible && this.Fe.H()) {
            var s = this.Fe.ia(0 === h.priceLineSource);
            s.na || (n.H = !0, n.p = s.Pt, n.et = this.Fe.ha(s.et), n.dt = i, n.wt = t, n.rt = h.priceLineWidth, n.ut = h.priceLineStyle);
        }
    }, i;
}($1ff2b0a4ee3068d6$var$vi), $1ff2b0a4ee3068d6$var$Di = function(t) {
    function i(i) {
        var n = t.call(this) || this;
        return n.lt = i, n;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.Zt = function(t, i, n) {
        if (t.H = !1, i.H = !1, this.lt.H()) {
            var h = this.lt.I(), s = h.lastValueVisible, r = "" !== this.lt.sa(), e = 0 === h.seriesLastValueMode, u = this.lt.ia(!1);
            if (!u.na) {
                s && (t.At = this.ra(u, s, e), t.H = 0 !== t.At.length), (r || e) && (i.At = this.ea(u, s, r, e), i.H = i.At.length > 0);
                var a = this.lt.ha(u.et), o = $1ff2b0a4ee3068d6$var$V(a);
                n.gt = o.gt, n.et = o.yt, n.Pt = u.Pt, i.$ = this.lt.ct().I().layout.backgroundColor, t.$ = a;
            }
        }
    }, i.prototype.ea = function(t, i, n, h) {
        var s = "", r = this.lt.sa();
        return n && 0 !== r.length && (s += r + " "), i && h && (s += this.lt.Z().oh() ? t.ua : t.aa), s.trim();
    }, i.prototype.ra = function(t, i, n) {
        return i ? n ? this.lt.Z().oh() ? t.aa : t.ua : t.At : "";
    }, i;
}($1ff2b0a4ee3068d6$var$W), $1ff2b0a4ee3068d6$var$Ti = function() {
    function t(t, i) {
        this.On = t, this.oa = i || null;
    }
    return t.prototype.yh = function() {
        return this.On;
    }, t.prototype.rs = function() {
        return this.oa;
    }, t.prototype.wn = function() {
        return null === this.On ? null : {
            priceRange: this.On.wn(),
            margins: this.oa || void 0
        };
    }, t.Mn = function(i) {
        return null === i ? null : new t($1ff2b0a4ee3068d6$var$G.Mn(i.priceRange), i.margins);
    }, t;
}(), $1ff2b0a4ee3068d6$var$Bi = function(t) {
    function i(i, n) {
        var h = t.call(this, i) || this;
        return h.la = n, h;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.Fu = function(t, i) {
        var n = this.zu;
        if (n.H = !1, this.Fe.H()) {
            var h = this.la.fa();
            if (null !== h) {
                var s = this.la.I();
                n.H = !0, n.p = h, n.et = s.color, n.dt = i, n.wt = t, n.rt = s.lineWidth, n.ut = s.lineStyle;
            }
        }
    }, i;
}($1ff2b0a4ee3068d6$var$vi), $1ff2b0a4ee3068d6$var$Ei = function(t) {
    function i(i, n) {
        var h = t.call(this) || this;
        return h.Ju = i, h.la = n, h;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.Zt = function(t, i, n) {
        t.H = !1, i.H = !1;
        var h = this.la.I(), s = h.axisLabelVisible, r = "" !== h.title;
        if (s && this.Ju.H()) {
            var e = this.la.fa();
            if (null !== e) {
                r && (i.At = h.title, i.H = !0), i.$ = this.Ju.ct().I().layout.backgroundColor, t.At = this.Ju.Z().$h(h.price), t.H = !0;
                var u = $1ff2b0a4ee3068d6$var$V(h.color);
                n.gt = u.gt, n.et = u.yt, n.Pt = e;
            }
        }
    }, i;
}($1ff2b0a4ee3068d6$var$W), $1ff2b0a4ee3068d6$var$Li = function() {
    function t(t, i) {
        this.Ju = t, this.xi = i, this.ca = new $1ff2b0a4ee3068d6$var$Bi(t, this), this.Bu = new $1ff2b0a4ee3068d6$var$Ei(t, this), this.va = new $1ff2b0a4ee3068d6$var$fi(this.Bu, t, t.ct());
    }
    return t.prototype.hh = function(t) {
        $1ff2b0a4ee3068d6$var$v(this.xi, t), this.V(), this.Ju.ct().zr();
    }, t.prototype.I = function() {
        return this.xi;
    }, t.prototype.ci = function() {
        return [
            this.ca,
            this.va
        ];
    }, t.prototype._a = function() {
        return this.Bu;
    }, t.prototype.V = function() {
        this.ca.V(), this.Bu.V();
    }, t.prototype.fa = function() {
        var t = this.Ju, i = t.Z();
        if (t.ct().U().Qt() || i.Qt()) return null;
        var n = t.Y();
        return null === n ? null : i.X(this.xi.price, n.J);
    }, t;
}(), $1ff2b0a4ee3068d6$var$Ai = function(t) {
    function i(i) {
        var n = t.call(this) || this;
        return n.hi = i, n;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.ct = function() {
        return this.hi;
    }, i;
}($1ff2b0a4ee3068d6$var$H), $1ff2b0a4ee3068d6$var$Vi = {
    eu: "",
    wu: "",
    du: ""
}, $1ff2b0a4ee3068d6$var$Oi = function() {
    function t(t) {
        this.Ju = t;
    }
    return t.prototype.uu = function(t, i) {
        var n = this.Ju.da(), h = this.Ju.I();
        switch(n){
            case "Line":
                return this.wa(h);
            case "Area":
                return this.Ma(h);
            case "Bar":
                return this.ba(h, t, i);
            case "Candlestick":
                return this.ma(h, t, i);
            case "Histogram":
                return this.ga(h, t, i);
        }
        throw new Error("Unknown chart style");
    }, t.prototype.ba = function(t, i, n) {
        var h = $1ff2b0a4ee3068d6$var$u({}, $1ff2b0a4ee3068d6$var$Vi), s = t.upColor, r = t.downColor, e = s, a = r, o = $1ff2b0a4ee3068d6$var$f(this.pa(i, n)), l = $1ff2b0a4ee3068d6$var$c(o.J[0]) <= $1ff2b0a4ee3068d6$var$c(o.J[3]);
        return h.eu = l ? s : r, h.wu = l ? e : a, h;
    }, t.prototype.ma = function(t, i, n) {
        var h = $1ff2b0a4ee3068d6$var$u({}, $1ff2b0a4ee3068d6$var$Vi), s = t.upColor, r = t.downColor, e = t.borderUpColor, a = t.borderDownColor, o = t.wickUpColor, l = t.wickDownColor, v = $1ff2b0a4ee3068d6$var$f(this.pa(i, n)), _ = $1ff2b0a4ee3068d6$var$c(v.J[0]) <= $1ff2b0a4ee3068d6$var$c(v.J[3]);
        return h.eu = _ ? s : r, h.wu = _ ? e : a, h.du = _ ? o : l, h;
    }, t.prototype.Ma = function(t) {
        return $1ff2b0a4ee3068d6$var$u($1ff2b0a4ee3068d6$var$u({}, $1ff2b0a4ee3068d6$var$Vi), {
            eu: t.lineColor
        });
    }, t.prototype.wa = function(t) {
        return $1ff2b0a4ee3068d6$var$u($1ff2b0a4ee3068d6$var$u({}, $1ff2b0a4ee3068d6$var$Vi), {
            eu: t.color
        });
    }, t.prototype.ga = function(t, i, n) {
        var h = $1ff2b0a4ee3068d6$var$u({}, $1ff2b0a4ee3068d6$var$Vi), s = $1ff2b0a4ee3068d6$var$f(this.pa(i, n));
        return h.eu = void 0 !== s.et ? s.et : t.color, h;
    }, t.prototype.pa = function(t, i) {
        return void 0 !== i ? i.J : this.Ju.qi().ya(t);
    }, t;
}(), $1ff2b0a4ee3068d6$var$zi = function() {
    function t() {
        this.ka = [], this.xa = new Map, this.Na = new Map;
    }
    return t.prototype.Sa = function() {
        this.ka = [], this.xa.clear(), this.Na.clear();
    }, t.prototype.Ca = function() {
        return this.Ye() > 0 ? this.ka[this.ka.length - 1] : null;
    }, t.prototype.Da = function() {
        return this.Ye() > 0 ? this.Ta(0) : null;
    }, t.prototype.Ui = function() {
        return this.Ye() > 0 ? this.Ta(this.ka.length - 1) : null;
    }, t.prototype.Ye = function() {
        return this.ka.length;
    }, t.prototype.Qt = function() {
        return 0 === this.Ye();
    }, t.prototype.As = function(t) {
        return null !== this.Ba(t, 0);
    }, t.prototype.ya = function(t) {
        return this.Ea(t);
    }, t.prototype.Ea = function(t, i) {
        void 0 === i && (i = 0);
        var n = this.Ba(t, i);
        return null === n ? null : $1ff2b0a4ee3068d6$var$u($1ff2b0a4ee3068d6$var$u({}, this.La(n)), {
            Ps: this.Ta(n)
        });
    }, t.prototype.Ze = function() {
        return this.ka;
    }, t.prototype.Aa = function(t, i, n) {
        if (this.Qt()) return null;
        for(var h = null, s = 0, r = n; s < r.length; s++){
            var e = r[s];
            h = $1ff2b0a4ee3068d6$var$Pi(h, this.Va(t, i, e));
        }
        return h;
    }, t.prototype.vn = function(t) {
        0 !== t.length && (this.Qt() || t[t.length - 1].Ps < this.ka[0].Ps ? this.Oa(t) : t[0].Ps > this.ka[this.ka.length - 1].Ps ? this.za(t) : 1 !== t.length || t[0].Ps !== this.ka[this.ka.length - 1].Ps ? this.Pa(t) : this.Fa(t[0]));
    }, t.prototype.Ta = function(t) {
        return this.ka[t].Ps;
    }, t.prototype.La = function(t) {
        return this.ka[t];
    }, t.prototype.Ba = function(t, i) {
        var n = this.Ia(t);
        if (null === n && 0 !== i) switch(i){
            case -1:
                return this.Wa(t);
            case 1:
                return this.Ra(t);
            default:
                throw new TypeError("Unknown search mode");
        }
        return n;
    }, t.prototype.Wa = function(t) {
        var i = this.ja(t);
        return i > 0 && (i -= 1), i !== this.ka.length && this.Ta(i) < t ? i : null;
    }, t.prototype.Ra = function(t) {
        var i = this.Ua(t);
        return i !== this.ka.length && t < this.Ta(i) ? i : null;
    }, t.prototype.Ia = function(t) {
        var i = this.ja(t);
        return i === this.ka.length || t < this.ka[i].Ps ? null : i;
    }, t.prototype.ja = function(t) {
        return $1ff2b0a4ee3068d6$var$qt(this.ka, t, function(t, i) {
            return t.Ps < i;
        });
    }, t.prototype.Ua = function(t) {
        return $1ff2b0a4ee3068d6$var$Ht(this.ka, t, function(t, i) {
            return i.Ps > t;
        });
    }, t.prototype.qa = function(t, i, n) {
        for(var h = null, s = t; s < i; s++){
            var r = this.ka[s].J[n];
            Number.isNaN(r) || (null === h ? h = {
                Ha: r,
                Ya: r
            } : (r < h.Ha && (h.Ha = r), r > h.Ya && (h.Ya = r)));
        }
        return h;
    }, t.prototype.Ka = function(t) {
        var i = Math.floor(t.Ps / 30);
        this.xa.forEach(function(t) {
            return t.delete(i);
        });
    }, t.prototype.Oa = function(t) {
        $1ff2b0a4ee3068d6$var$o(0 !== t.length, "plotRows should not be empty"), this.Na.clear(), this.xa.clear(), this.ka = t.concat(this.ka);
    }, t.prototype.za = function(t) {
        $1ff2b0a4ee3068d6$var$o(0 !== t.length, "plotRows should not be empty"), this.Na.clear(), this.xa.clear(), this.ka = this.ka.concat(t);
    }, t.prototype.Fa = function(t) {
        $1ff2b0a4ee3068d6$var$o(!this.Qt(), "plot list should not be empty"), $1ff2b0a4ee3068d6$var$o(this.ka[this.ka.length - 1].Ps === t.Ps, "last row index should match new row index"), this.Ka(t), this.Na.delete(t.Ps), this.ka[this.ka.length - 1] = t;
    }, t.prototype.Pa = function(t) {
        $1ff2b0a4ee3068d6$var$o(0 !== t.length, "plot rows should not be empty"), this.Na.clear(), this.xa.clear(), this.ka = function(t, i) {
            var n = function(t, i) {
                var n = t.length, h = i.length, s = n + h, r = 0, e = 0;
                for(; r < n && e < h;)t[r].Ps < i[e].Ps ? r++ : t[r].Ps > i[e].Ps ? e++ : (r++, e++, s--);
                return s;
            }(t, i), h = new Array(n), s = 0, r = 0, e = t.length, u = i.length, a = 0;
            for(; s < e && r < u;)t[s].Ps < i[r].Ps ? (h[a] = t[s], s++) : t[s].Ps > i[r].Ps ? (h[a] = i[r], r++) : (h[a] = i[r], s++, r++), a++;
            for(; s < e;)h[a] = t[s], s++, a++;
            for(; r < u;)h[a] = i[r], r++, a++;
            return h;
        }(this.ka, t);
    }, t.prototype.Va = function(t, i, n) {
        if (this.Qt()) return null;
        var h = null, s = $1ff2b0a4ee3068d6$var$f(this.Da()), r = $1ff2b0a4ee3068d6$var$f(this.Ui()), e = Math.max(t, s), u = Math.min(i, r), a = 30 * Math.ceil(e / 30), o = Math.max(a, 30 * Math.floor(u / 30)), l = this.ja(e), c = this.Ua(Math.min(u, a, i));
        h = $1ff2b0a4ee3068d6$var$Pi(h, this.qa(l, c, n));
        var v = this.xa.get(n);
        void 0 === v && (v = new Map, this.xa.set(n, v));
        for(var _ = Math.max(a + 1, e); _ < o; _ += 30){
            var d = Math.floor(_ / 30), w = v.get(d);
            if (void 0 === w) {
                var M = this.ja(30 * d), b = this.Ua(30 * (d + 1) - 1);
                w = this.qa(M, b, n), v.set(d, w);
            }
            h = $1ff2b0a4ee3068d6$var$Pi(h, w);
        }
        l = this.ja(o), c = this.Ua(u);
        return h = $1ff2b0a4ee3068d6$var$Pi(h, this.qa(l, c, n));
    }, t;
}();
function $1ff2b0a4ee3068d6$var$Pi(t, i) {
    return null === t ? i : null === i ? t : {
        Ha: Math.min(t.Ha, i.Ha),
        Ya: Math.max(t.Ya, i.Ya)
    };
}
var $1ff2b0a4ee3068d6$var$Fi = function(t) {
    function i(i, n, h) {
        var s = t.call(this, i) || this;
        s.tt = new $1ff2b0a4ee3068d6$var$zi, s.ca = new $1ff2b0a4ee3068d6$var$Ci(s), s.$a = [], s.Xa = new $1ff2b0a4ee3068d6$var$_i(s), s.Za = null, s.Ja = [], s.Ga = [], s.xi = n, s.Qa = h;
        var r = new $1ff2b0a4ee3068d6$var$Di(s);
        return s.bi = [
            r
        ], s.va = new $1ff2b0a4ee3068d6$var$fi(r, s, i), s.io(), s.no(), s;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.rn = function() {}, i.prototype.ha = function(t) {
        return this.xi.priceLineColor || t;
    }, i.prototype.ia = function(t, i) {
        var n = {
            na: !0
        }, h = this.Z();
        if (this.ct().U().Qt() || h.Qt() || this.tt.Qt()) return n;
        var s, r, e = this.ct().U().Mr(), u = this.Y();
        if (null === e || null === u) return n;
        if (t) {
            var a = this.tt.Ca();
            if (null === a) return n;
            s = a, r = a.Ps;
        } else {
            var o = this.tt.Ea(e.ss(), -1);
            if (null === o) return n;
            if (null === (s = this.tt.ya(o.Ps))) return n;
            r = o.Ps;
        }
        var l = s.J[3], f = this.Xe().uu(r, {
            J: s
        }), c = h.X(l, u.J);
        return {
            na: !1,
            F: i ? l : void 0,
            At: h.ti(l, u.J),
            ua: h.$h(l),
            aa: h.Zh(l, u.J),
            et: f.eu,
            Pt: c,
            Ps: r
        };
    }, i.prototype.Xe = function() {
        return null !== this.Za || (this.Za = new $1ff2b0a4ee3068d6$var$Oi(this)), this.Za;
    }, i.prototype.I = function() {
        return this.xi;
    }, i.prototype.hh = function(t) {
        var i = t.priceScaleId;
        void 0 !== i && i !== this.xi.priceScaleId && this.ct().ho(this, i), $1ff2b0a4ee3068d6$var$v(this.xi, t), null !== this.ei && void 0 !== t.scaleMargins && this.ei.hh({
            scaleMargins: t.scaleMargins
        }), void 0 !== t.priceFormat && this.io(), this.ct().so(this), this.ct().ro(), this.Bi.V("options");
    }, i.prototype.eo = function() {
        this.tt.Sa(), this.no();
    }, i.prototype.uo = function(t, i) {
        i && this.tt.Sa(), this.tt.vn(t), this.ao(), this.Bi.V("data"), this.Ni.V("data");
        var n = this.ct().Lu(this);
        this.ct().oo(n), this.ct().so(this), this.ct().ro(), this.ct().zr();
    }, i.prototype.lo = function(t) {
        this.Ja = t.map(function(t) {
            return $1ff2b0a4ee3068d6$var$u({}, t);
        }), this.ao();
        var i = this.ct().Lu(this);
        this.Ni.V("data"), this.ct().oo(i), this.ct().so(this), this.ct().ro(), this.ct().zr();
    }, i.prototype.Qu = function() {
        return this.Ga;
    }, i.prototype.fo = function(t) {
        var i = new $1ff2b0a4ee3068d6$var$Li(this, t);
        return this.$a.push(i), this.ct().so(this), i;
    }, i.prototype.co = function(t) {
        var i = this.$a.indexOf(t);
        -1 !== i && this.$a.splice(i, 1), this.ct().so(this);
    }, i.prototype.da = function() {
        return this.Qa;
    }, i.prototype.Y = function() {
        var t = this.vo();
        return null === t ? null : {
            J: t.J[3],
            Fh: t.P
        };
    }, i.prototype.vo = function() {
        var t = this.ct().U().Mr();
        if (null === t) return null;
        var i = t.hs();
        return this.tt.Ea(i, 1);
    }, i.prototype.qi = function() {
        return this.tt;
    }, i.prototype.ta = function(t) {
        var i = this.tt.ya(t);
        return null === i ? null : "Bar" === this.Qa || "Candlestick" === this.Qa ? {
            open: i.J[0],
            high: i.J[1],
            low: i.J[2],
            close: i.J[3]
        } : i.J[3];
    }, i.prototype.ci = function() {
        var t = [];
        this._o() || t.push(this.Xa);
        for(var i = 0, n = this.$a; i < n.length; i++){
            var h = n[i];
            t.push.apply(t, h.ci());
        }
        return t.push(this.Bi, this.ca, this.va, this.Ni), t;
    }, i.prototype.fi = function(t, i) {
        for(var n = i === this.ei || this._o() ? $1ff2b0a4ee3068d6$var$a([], this.bi) : [], h = 0, s = this.$a; h < s.length; h++){
            var r = s[h];
            n.push(r._a());
        }
        return n;
    }, i.prototype.ns = function(t, i) {
        var n = this;
        if (void 0 !== this.xi.autoscaleInfoProvider) {
            var h = this.xi.autoscaleInfoProvider(function() {
                var h = n.do(t, i);
                return null === h ? null : h.wn();
            });
            return $1ff2b0a4ee3068d6$var$Ti.Mn(h);
        }
        return this.do(t, i);
    }, i.prototype.Qh = function() {
        return this.xi.priceFormat.minMove;
    }, i.prototype.Yh = function() {
        return this.Xn;
    }, i.prototype.Wi = function() {
        this.Bi.V(), this.Ni.V();
        for(var t = 0, i = this.bi; t < i.length; t++)i[t].V();
        for(var n = 0, h = this.$a; n < h.length; n++)h[n].V();
        this.ca.V(), this.Xa.V();
    }, i.prototype.Z = function() {
        return $1ff2b0a4ee3068d6$var$f(this.ei);
    }, i.prototype.q = function(t) {
        if (!(("Line" === this.Qa || "Area" === this.Qa) && this.xi.crosshairMarkerVisible)) return null;
        var i = this.tt.ya(t);
        return null === i ? null : {
            F: i.J[3],
            N: this.wo(),
            $: this.Mo(),
            K: this.bo(t)
        };
    }, i.prototype.sa = function() {
        return this.xi.title;
    }, i.prototype.H = function() {
        return this.xi.visible;
    }, i.prototype._o = function() {
        return !$1ff2b0a4ee3068d6$var$Ft(this.Z().nh());
    }, i.prototype.do = function(t, i) {
        if (!$1ff2b0a4ee3068d6$var$d(t) || !$1ff2b0a4ee3068d6$var$d(i) || this.tt.Qt()) return null;
        var n = "Line" === this.Qa || "Area" === this.Qa || "Histogram" === this.Qa ? [
            3
        ] : [
            2,
            1
        ], h = this.tt.Aa(t, i, n), s = null !== h ? new $1ff2b0a4ee3068d6$var$G(h.Ha, h.Ya) : null;
        if ("Histogram" === this.da()) {
            var r = this.xi.base, e = new $1ff2b0a4ee3068d6$var$G(r, r);
            s = null !== s ? s.vn(e) : e;
        }
        return new $1ff2b0a4ee3068d6$var$Ti(s, this.Ni.Gu());
    }, i.prototype.wo = function() {
        switch(this.Qa){
            case "Line":
            case "Area":
                return this.xi.crosshairMarkerRadius;
        }
        return 0;
    }, i.prototype.Mo = function() {
        switch(this.Qa){
            case "Line":
            case "Area":
                var t = this.xi.crosshairMarkerBorderColor;
                if (0 !== t.length) return t;
        }
        return this.ct().I().layout.backgroundColor;
    }, i.prototype.bo = function(t) {
        switch(this.Qa){
            case "Line":
            case "Area":
                var i = this.xi.crosshairMarkerBackgroundColor;
                if (0 !== i.length) return i;
        }
        return this.Xe().uu(t).eu;
    }, i.prototype.io = function() {
        switch(this.xi.priceFormat.type){
            case "custom":
                this.Xn = {
                    format: this.xi.priceFormat.formatter
                };
                break;
            case "volume":
                this.Xn = new $1ff2b0a4ee3068d6$var$Wt(this.xi.priceFormat.precision);
                break;
            case "percent":
                this.Xn = new $1ff2b0a4ee3068d6$var$Z(this.xi.priceFormat.precision);
                break;
            default:
                var t = Math.pow(10, this.xi.priceFormat.precision);
                this.Xn = new $1ff2b0a4ee3068d6$var$X(t, this.xi.priceFormat.minMove * t);
        }
        null !== this.ei && this.ei.sh();
    }, i.prototype.ao = function() {
        var t = this, i = this.ct().U();
        if (i.Qt() || 0 === this.tt.Ye()) this.Ga = [];
        else {
            var n = $1ff2b0a4ee3068d6$var$f(this.tt.Da());
            this.Ga = this.Ja.map(function(h, s) {
                var r = $1ff2b0a4ee3068d6$var$f(i.wr(h.time, !0)), e = r < n ? 1 : -1;
                return {
                    time: $1ff2b0a4ee3068d6$var$f(t.tt.Ea(r, e)).Ps,
                    position: h.position,
                    shape: h.shape,
                    color: h.color,
                    id: h.id,
                    ju: s,
                    text: h.text,
                    size: h.size
                };
            });
        }
    }, i.prototype.no = function() {
        switch(this.Ni = new $1ff2b0a4ee3068d6$var$Si(this, this.ct()), this.Qa){
            case "Bar":
                this.Bi = new $1ff2b0a4ee3068d6$var$ti(this, this.ct());
                break;
            case "Candlestick":
                this.Bi = new $1ff2b0a4ee3068d6$var$ni(this, this.ct());
                break;
            case "Line":
                this.Bi = new $1ff2b0a4ee3068d6$var$ui(this, this.ct());
                break;
            case "Area":
                this.Bi = new $1ff2b0a4ee3068d6$var$Jt(this, this.ct());
                break;
            case "Histogram":
                this.Bi = new $1ff2b0a4ee3068d6$var$ei(this, this.ct());
                break;
            default:
                throw Error("Unknown chart style assigned: " + this.Qa);
        }
    }, i;
}($1ff2b0a4ee3068d6$var$Ai), $1ff2b0a4ee3068d6$var$Ii = function() {
    function t(t) {
        this.xi = t;
    }
    return t.prototype.mo = function(t, i, n) {
        var h = t;
        if (0 === this.xi.mode) return h;
        var s = n.Ci(), r = s.Y();
        if (null === r) return h;
        var e = s.X(t, r), u = n.Ah().filter(function(t) {
            return t instanceof $1ff2b0a4ee3068d6$var$Fi;
        }).reduce(function(t, h) {
            if (n.Au(h) || !h.H()) return t;
            var s = h.Z(), r = h.qi();
            if (s.Qt() || !r.As(i)) return t;
            var e = r.ya(i);
            if (null === e) return t;
            var u = $1ff2b0a4ee3068d6$var$c(h.Y());
            return t.concat([
                s.X(e.J[3], u.J)
            ]);
        }, []);
        if (0 === u.length) return h;
        u.sort(function(t, i) {
            return Math.abs(t - e) - Math.abs(i - e);
        });
        var a = u[0];
        return h = s.Di(a, r);
    }, t;
}(), $1ff2b0a4ee3068d6$var$Wi = function() {
    function t() {
        this.tt = null;
    }
    return t.prototype._ = function(t) {
        this.tt = t;
    }, t.prototype.h = function(t, i, n, s) {
        var r = this;
        if (null !== this.tt) {
            var e = Math.max(1, Math.floor(i));
            t.lineWidth = e;
            var u = Math.ceil(this.tt.st * i), a = Math.ceil(this.tt.ht * i);
            !function(t, i) {
                t.save(), t.lineWidth % 2 && t.translate(.5, .5), i(), t.restore();
            }(t, function() {
                var n = $1ff2b0a4ee3068d6$var$f(r.tt);
                if (n.po) {
                    t.strokeStyle = n.yo, $1ff2b0a4ee3068d6$var$h(t, n.ko), t.beginPath();
                    for(var s = 0, o = n.xo; s < o.length; s++){
                        var l = o[s], c = Math.round(l.Dn * i);
                        t.moveTo(c, -e), t.lineTo(c, u + e);
                    }
                    t.stroke();
                }
                if (n.No) {
                    t.strokeStyle = n.So, $1ff2b0a4ee3068d6$var$h(t, n.Co), t.beginPath();
                    for(var v = 0, _ = n.Do; v < _.length; v++){
                        var d = _[v], w = Math.round(d.Dn * i);
                        t.moveTo(-e, w), t.lineTo(a + e, w);
                    }
                    t.stroke();
                }
            });
        }
    }, t;
}(), $1ff2b0a4ee3068d6$var$Ri = function() {
    function t(t) {
        this.ot = new $1ff2b0a4ee3068d6$var$Wi, this.B = !0, this._i = t;
    }
    return t.prototype.V = function() {
        this.B = !0;
    }, t.prototype.W = function(t, i) {
        if (this.B) {
            var n = this._i.ct().I().grid, h = {
                st: t,
                ht: i,
                No: n.horzLines.visible,
                po: n.vertLines.visible,
                So: n.horzLines.color,
                yo: n.vertLines.color,
                Co: n.horzLines.style,
                ko: n.vertLines.style,
                Do: this._i.Ci().Ln(),
                xo: this._i.ct().U().Ln() || []
            };
            this.ot._(h), this.B = !1;
        }
        return this.ot;
    }, t;
}(), $1ff2b0a4ee3068d6$var$ji = function() {
    function t(t) {
        this.Bi = new $1ff2b0a4ee3068d6$var$Ri(t);
    }
    return t.prototype.To = function() {
        return this.Bi;
    }, t;
}(), $1ff2b0a4ee3068d6$var$Ui = function() {
    function t(t, i) {
        this.qn = [], this.Bo = new Map, this.An = 0, this.Ys = 0, this.Eo = 1e3, this.Hn = null, this.Lo = new $1ff2b0a4ee3068d6$var$J, this.Ao = t, this.hi = i, this.Vo = new $1ff2b0a4ee3068d6$var$ji(this);
        var n = i.I();
        this.Oo = this.zo("left", n.leftPriceScale), this.Po = this.zo("right", n.rightPriceScale), this.Oo.Mh().Zi(this.Fo.bind(this, this.Oo), this), this.Po.Mh().Zi(this.Fo.bind(this, this.Oo), this), this.Io(n);
    }
    return t.prototype.Io = function(t) {
        if (t.leftPriceScale && this.Oo.hh(t.leftPriceScale), t.rightPriceScale && this.Po.hh(t.rightPriceScale), t.localization && (this.Oo.sh(), this.Po.sh()), t.overlayPriceScales) for(var i = 0, n = Array.from(this.Bo.values()); i < n.length; i++){
            var h = $1ff2b0a4ee3068d6$var$f(n[i][0].Z());
            h.hh(t.overlayPriceScales), t.localization && h.sh();
        }
    }, t.prototype.Wo = function(t) {
        switch(t){
            case "left":
                return this.Oo;
            case "right":
                return this.Po;
        }
        return this.Bo.has(t) ? $1ff2b0a4ee3068d6$var$l(this.Bo.get(t))[0].Z() : null;
    }, t.prototype.rn = function() {
        this.ct().Ro().nn(this), this.Oo.Mh().nn(this), this.Po.Mh().nn(this), this.qn.forEach(function(t) {
            t.rn && t.rn();
        }), this.Lo.hn();
    }, t.prototype.jo = function() {
        return this.Eo;
    }, t.prototype.Uo = function(t) {
        this.Eo = t;
    }, t.prototype.ct = function() {
        return this.hi;
    }, t.prototype.dt = function() {
        return this.Ys;
    }, t.prototype.wt = function() {
        return this.An;
    }, t.prototype.Cr = function(t) {
        this.Ys = t, this.qo();
    }, t.prototype.bh = function(t) {
        var i = this;
        this.An = t, this.Oo.bh(t), this.Po.bh(t), this.qn.forEach(function(n) {
            if (i.Au(n)) {
                var h = n.Z();
                null !== h && h.bh(t);
            }
        }), this.qo();
    }, t.prototype.Ah = function() {
        return this.qn;
    }, t.prototype.Au = function(t) {
        var i = t.Z();
        return null === i || this.Oo !== i && this.Po !== i;
    }, t.prototype.Oh = function(t, i, n) {
        var h = void 0 !== n ? n : this.Yo().Ho - 1;
        this.Ko(t, i, h);
    }, t.prototype.Ph = function(t) {
        var i = this.qn.indexOf(t);
        $1ff2b0a4ee3068d6$var$o(-1 !== i, "removeDataSource: invalid data source"), this.qn.splice(i, 1);
        var n = $1ff2b0a4ee3068d6$var$f(t.Z()).nh();
        if (this.Bo.has(n)) {
            var h = $1ff2b0a4ee3068d6$var$l(this.Bo.get(n)), s = h.indexOf(t);
            -1 !== s && (h.splice(s, 1), 0 === h.length && this.Bo.delete(n));
        }
        var r = t.Z();
        r && r.Ah().indexOf(t) >= 0 && r.Ph(t), null !== r && (r.zh(), this.$o(r)), this.Hn = null;
    }, t.prototype.Vu = function(t) {
        return t === this.Oo ? "left" : t === this.Po ? "right" : "overlay";
    }, t.prototype.Xo = function() {
        return this.Oo;
    }, t.prototype.Zo = function() {
        return this.Po;
    }, t.prototype.Jo = function(t, i) {
        t.Wh(i);
    }, t.prototype.Go = function(t, i) {
        t.Rh(i), this.qo();
    }, t.prototype.Qo = function(t) {
        t.jh();
    }, t.prototype.tl = function(t, i) {
        t.Uh(i);
    }, t.prototype.il = function(t, i) {
        t.qh(i), this.qo();
    }, t.prototype.nl = function(t) {
        t.Hh();
    }, t.prototype.qo = function() {
        this.qn.forEach(function(t) {
            t.Wi();
        });
    }, t.prototype.Ci = function() {
        var t = null;
        return this.hi.I().rightPriceScale.visible && 0 !== this.Po.Ah().length ? t = this.Po : this.hi.I().leftPriceScale.visible && 0 !== this.Oo.Ah().length ? t = this.Oo : 0 !== this.qn.length && (t = this.qn[0].Z()), null === t && (t = this.Po), t;
    }, t.prototype.$o = function(t) {
        null !== t && t.ah() && this.hl(t);
    }, t.prototype.sl = function(t) {
        var i = this.Ao.Mr();
        t.rh({
            fh: !0
        }), null !== i && t.Gh(i), this.qo();
    }, t.prototype.rl = function() {
        this.hl(this.Oo), this.hl(this.Po);
    }, t.prototype.el = function() {
        var t = this;
        this.$o(this.Oo), this.$o(this.Po), this.qn.forEach(function(i) {
            t.Au(i) && t.$o(i.Z());
        }), this.qo(), this.hi.zr();
    }, t.prototype.Vh = function() {
        return null === this.Hn && (this.Hn = $1ff2b0a4ee3068d6$var$_t(this.qn)), this.Hn;
    }, t.prototype.ul = function() {
        return this.Lo;
    }, t.prototype.al = function() {
        return this.Vo;
    }, t.prototype.hl = function(t) {
        var i = t.Jh();
        if (i && i.length > 0 && !this.Ao.Qt()) {
            var n = this.Ao.Mr();
            null !== n && t.Gh(n);
        }
        t.Wi();
    }, t.prototype.Yo = function() {
        var t = this.Vh();
        if (0 === t.length) return {
            Ho: 0,
            ol: 0
        };
        for(var i = 0, n = 0, h = 0; h < t.length; h++){
            var s = t[h].ai();
            null !== s && (s < i && (i = s), s > n && (n = s));
        }
        return {
            Ho: i,
            ol: n
        };
    }, t.prototype.Ko = function(t, i, n) {
        var h = this.Wo(i);
        if (null === h && (h = this.zo(i, this.hi.I().overlayPriceScales)), this.qn.push(t), !$1ff2b0a4ee3068d6$var$Ft(i)) {
            var s = this.Bo.get(i) || [];
            s.push(t), this.Bo.set(i, s);
        }
        h.Oh(t), t.li(h), t.oi(n), this.$o(h), this.Hn = null;
    }, t.prototype.Fo = function(t, i, n) {
        i.eh !== n.eh && this.hl(t);
    }, t.prototype.zo = function(t, i) {
        var n = $1ff2b0a4ee3068d6$var$u({
            visible: !0,
            autoScale: !0
        }, $1ff2b0a4ee3068d6$var$b(i)), h = new $1ff2b0a4ee3068d6$var$bt(t, n, this.hi.I().layout, this.hi.I().localization);
        return h.bh(this.wt()), h;
    }, t;
}(), $1ff2b0a4ee3068d6$var$qi = function(t) {
    function i(i) {
        var n = t.call(this) || this;
        return n.ll = new Map, n.tt = i, n;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.u = function(t) {}, i.prototype.l = function(t) {
        if (this.tt.H) {
            t.save();
            for(var i = 0, n = 0, h = this.tt.fl; n < h.length; n++)if (0 !== (a = h[n]).At.length) {
                t.font = a.xt;
                var s = this.cl(t, a.At);
                s > this.tt.dt ? a.jr = this.tt.dt / s : a.jr = 1, i += a.vl * a.jr;
            }
            var r = 0;
            switch(this.tt._l){
                case "top":
                    r = 0;
                    break;
                case "center":
                    r = Math.max((this.tt.wt - i) / 2, 0);
                    break;
                case "bottom":
                    r = Math.max(this.tt.wt - i, 0);
            }
            t.fillStyle = this.tt.et;
            for(var e = 0, u = this.tt.fl; e < u.length; e++){
                var a = u[e];
                t.save();
                var o = 0;
                switch(this.tt.dl){
                    case "left":
                        t.textAlign = "left", o = a.vl / 2;
                        break;
                    case "center":
                        t.textAlign = "center", o = this.tt.dt / 2;
                        break;
                    case "right":
                        t.textAlign = "right", o = this.tt.dt - 1 - a.vl / 2;
                }
                t.translate(o, r), t.textBaseline = "top", t.font = a.xt, t.scale(a.jr, a.jr), t.fillText(a.At, 0, a.wl), t.restore(), r += a.vl * a.jr;
            }
            t.restore();
        }
    }, i.prototype.cl = function(t, i) {
        var n = this.Ml(t.font), h = n.get(i);
        return void 0 === h && (h = t.measureText(i).width, n.set(i, h)), h;
    }, i.prototype.Ml = function(t) {
        var i = this.ll.get(t);
        return void 0 === i && (i = new Map, this.ll.set(t, i)), i;
    }, i;
}($1ff2b0a4ee3068d6$var$y), $1ff2b0a4ee3068d6$var$Hi = function() {
    function t(t) {
        this.B = !0, this.at = {
            H: !1,
            et: "",
            wt: 0,
            dt: 0,
            fl: [],
            _l: "center",
            dl: "center"
        }, this.ot = new $1ff2b0a4ee3068d6$var$qi(this.at), this.lt = t;
    }
    return t.prototype.V = function() {
        this.B = !0;
    }, t.prototype.W = function(t, i) {
        return this.B && (this.R(t, i), this.B = !1), this.ot;
    }, t.prototype.R = function(t, i) {
        var n = this.lt.I(), h = this.at;
        h.H = n.visible, h.H && (h.et = n.color, h.dt = i, h.wt = t, h.dl = n.horzAlign, h._l = n.vertAlign, h.fl = [
            {
                At: n.text,
                xt: $1ff2b0a4ee3068d6$var$zt(n.fontSize, n.fontFamily, n.fontStyle),
                vl: 1.2 * n.fontSize,
                wl: 0,
                jr: 0
            }
        ]);
    }, t;
}(), $1ff2b0a4ee3068d6$var$Yi = function(t) {
    function i(i, n) {
        var h = t.call(this) || this;
        return h.xi = n, h.Bi = new $1ff2b0a4ee3068d6$var$Hi(h), h;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.ci = function() {
        return [
            this.Bi
        ];
    }, i.prototype.I = function() {
        return this.xi;
    }, i.prototype.Wi = function() {
        this.Bi.V();
    }, i;
}($1ff2b0a4ee3068d6$var$H), $1ff2b0a4ee3068d6$var$Ki = function() {
    function t(t, i) {
        this.bl = [], this.ml = [], this.Ys = 0, this.gl = null, this.pl = null, this.yl = new $1ff2b0a4ee3068d6$var$J, this.kl = new $1ff2b0a4ee3068d6$var$J, this.xl = t, this.xi = i, this.Nl = new $1ff2b0a4ee3068d6$var$Pt(this), this.Ao = new $1ff2b0a4ee3068d6$var$Lt(this, i.timeScale, this.xi.localization), this.A = new $1ff2b0a4ee3068d6$var$Y(this, i.crosshair), this.Sl = new $1ff2b0a4ee3068d6$var$Ii(i.crosshair), this.Cl = new $1ff2b0a4ee3068d6$var$Yi(this, i.watermark), this.Dl(), this.bl[0].Uo(2e3);
    }
    return t.prototype.Tl = function() {
        this.Bl(new $1ff2b0a4ee3068d6$var$It(3));
    }, t.prototype.zr = function() {
        this.Bl(new $1ff2b0a4ee3068d6$var$It(2));
    }, t.prototype.so = function(t) {
        var i = this.El(t);
        this.Bl(i);
    }, t.prototype.Ll = function() {
        return this.pl;
    }, t.prototype.Al = function(t) {
        var i = this.pl;
        this.pl = t, null !== i && this.so(i.Vl), null !== t && this.so(t.Vl);
    }, t.prototype.I = function() {
        return this.xi;
    }, t.prototype.hh = function(t) {
        $1ff2b0a4ee3068d6$var$v(this.xi, t), this.bl.forEach(function(i) {
            return i.Io(t);
        }), void 0 !== t.timeScale && this.Ao.hh(t.timeScale), void 0 !== t.localization && this.Ao.ar(t.localization), (t.leftPriceScale || t.rightPriceScale) && this.yl.hn(), this.Tl();
    }, t.prototype.Ol = function(t, i) {
        var n = this.zl(t);
        null !== n && (n.Z.hh(i), this.yl.hn());
    }, t.prototype.zl = function(t) {
        for(var i = 0, n = this.bl; i < n.length; i++){
            var h = n[i], s = h.Wo(t);
            if (null !== s) return {
                ft: h,
                Z: s
            };
        }
        return null;
    }, t.prototype.U = function() {
        return this.Ao;
    }, t.prototype.Pl = function() {
        return this.bl;
    }, t.prototype.Fl = function() {
        return this.Cl;
    }, t.prototype.Il = function() {
        return this.A;
    }, t.prototype.Wl = function() {
        return this.kl;
    }, t.prototype.Rl = function(t, i) {
        t.bh(i), this.Or();
    }, t.prototype.Cr = function(t) {
        this.Ys = t, this.Ao.Cr(this.Ys), this.bl.forEach(function(i) {
            return i.Cr(t);
        }), this.Or();
    }, t.prototype.Dl = function(t) {
        var i = new $1ff2b0a4ee3068d6$var$Ui(this.Ao, this);
        void 0 !== t ? this.bl.splice(t, 0, i) : this.bl.push(i);
        var n = void 0 === t ? this.bl.length - 1 : t, h = new $1ff2b0a4ee3068d6$var$It(3);
        return h.we(n, {
            Me: 0,
            fh: !0
        }), this.Bl(h), i;
    }, t.prototype.Jo = function(t, i, n) {
        t.Jo(i, n);
    }, t.prototype.Go = function(t, i, n) {
        t.Go(i, n), this.ro(), this.Bl(this.jl(t, 2));
    }, t.prototype.Qo = function(t, i) {
        t.Qo(i), this.Bl(this.jl(t, 2));
    }, t.prototype.tl = function(t, i, n) {
        i.ah() || t.tl(i, n);
    }, t.prototype.il = function(t, i, n) {
        i.ah() || (t.il(i, n), this.ro(), this.Bl(this.jl(t, 2)));
    }, t.prototype.nl = function(t, i) {
        i.ah() || (t.nl(i), this.Bl(this.jl(t, 2)));
    }, t.prototype.sl = function(t, i) {
        t.sl(i), this.Bl(this.jl(t, 2));
    }, t.prototype.Ul = function(t) {
        this.Ao.Wh(t);
    }, t.prototype.ql = function(t, i) {
        var n = this.U();
        if (!n.Qt() && 0 !== i) {
            var h = n.dt();
            t = Math.max(1, Math.min(t, h)), n.jr(t, i), this.Or();
        }
    }, t.prototype.Hl = function(t) {
        this.Yl(0), this.Kl(t), this.$l();
    }, t.prototype.Xl = function(t) {
        this.Ao.Rh(t), this.Or();
    }, t.prototype.Zl = function() {
        this.Ao.jh(), this.zr();
    }, t.prototype.Yl = function(t) {
        this.gl = t, this.Ao.Uh(t);
    }, t.prototype.Kl = function(t) {
        var i = !1;
        return null !== this.gl && Math.abs(t - this.gl) > 20 && (this.gl = null, i = !0), this.Ao.qh(t), this.Or(), i;
    }, t.prototype.$l = function() {
        this.Ao.Hh(), this.zr(), this.gl = null;
    }, t.prototype.O = function() {
        return this.ml;
    }, t.prototype.Jl = function(t, i, n) {
        this.A.Ei(t, i);
        var h = NaN, s = this.Ao.Ar(t), r = this.Ao.Mr();
        null !== r && (s = Math.min(Math.max(r.hs(), s), r.ss()));
        var e = n.Ci(), u = e.Y();
        null !== u && (h = e.Di(i, u)), h = this.Sl.mo(h, s, n), this.A.Oi(s, h, n), this.Gl(), this.kl.hn(this.A.j(), {
            x: t,
            y: i
        });
    }, t.prototype.Ql = function() {
        this.Il().Pi(), this.Gl(), this.kl.hn(null, null);
    }, t.prototype.ro = function() {
        var t = this.A.ft();
        if (null !== t) {
            var i = this.A.Ai(), n = this.A.Vi();
            this.Jl(i, n, t);
        }
        this.A.Wi();
    }, t.prototype.tf = function(t, i) {
        var n = this.Ao.si(0);
        void 0 !== i && this.Ao.V(i);
        var h = this.Ao.si(0), s = this.Ao.Er(), r = this.Ao.Mr();
        if (null !== r && null !== n && null !== h) {
            var e = r.As(s), u = n.Cs > h.Cs, a = null !== t && t > s && !u, o = e && this.Ao.I().shiftVisibleRangeOnNewBar;
            if (a && !o && null !== t) {
                var l = t - s;
                this.Ao.dr(this.Ao.Fr() - l);
            }
        }
        this.Ao.Rr(t);
    }, t.prototype.oo = function(t) {
        null !== t && t.el();
    }, t.prototype.Lu = function(t) {
        var i = this.bl.find(function(i) {
            return i.Vh().includes(t);
        });
        return void 0 === i ? null : i;
    }, t.prototype.Or = function() {
        this.Cl.Wi(), this.bl.forEach(function(t) {
            return t.el();
        }), this.ro();
    }, t.prototype.rn = function() {
        this.bl.forEach(function(t) {
            return t.rn();
        }), this.bl.length = 0, this.xi.localization.priceFormatter = void 0, this.xi.localization.timeFormatter = void 0;
    }, t.prototype.if = function() {
        return this.Nl;
    }, t.prototype.Ou = function() {
        return this.Nl.I();
    }, t.prototype.Ro = function() {
        return this.yl;
    }, t.prototype.nf = function(t, i) {
        var n = this.bl[0], h = this.hf(i, t, n);
        return this.ml.push(h), 1 === this.ml.length ? this.Tl() : this.zr(), h;
    }, t.prototype.sf = function(t) {
        var i = this.Lu(t), n = this.ml.indexOf(t);
        $1ff2b0a4ee3068d6$var$o(-1 !== n, "Series not found"), this.ml.splice(n, 1), $1ff2b0a4ee3068d6$var$f(i).Ph(t), t.rn && t.rn();
    }, t.prototype.ho = function(t, i) {
        var n = $1ff2b0a4ee3068d6$var$f(this.Lu(t));
        n.Ph(t);
        var h = this.zl(i);
        if (null === h) {
            var s = t.ai();
            n.Oh(t, i, s);
        } else {
            s = h.ft === n ? t.ai() : void 0;
            h.ft.Oh(t, i, s);
        }
    }, t.prototype.Jr = function() {
        var t = new $1ff2b0a4ee3068d6$var$It(2);
        t.ge(), this.Bl(t);
    }, t.prototype.rf = function(t) {
        var i = new $1ff2b0a4ee3068d6$var$It(2);
        i.ye(t), this.Bl(i);
    }, t.prototype.ke = function() {
        var t = new $1ff2b0a4ee3068d6$var$It(2);
        t.ke(), this.Bl(t);
    }, t.prototype._r = function(t) {
        var i = new $1ff2b0a4ee3068d6$var$It(2);
        i._r(t), this.Bl(i);
    }, t.prototype.dr = function(t) {
        var i = new $1ff2b0a4ee3068d6$var$It(2);
        i.dr(t), this.Bl(i);
    }, t.prototype.ef = function() {
        return this.xi.rightPriceScale.visible ? "right" : "left";
    }, t.prototype.jl = function(t, i) {
        var n = new $1ff2b0a4ee3068d6$var$It(i);
        if (null !== t) {
            var h = this.bl.indexOf(t);
            n.we(h, {
                Me: i
            });
        }
        return n;
    }, t.prototype.El = function(t, i) {
        return void 0 === i && (i = 2), this.jl(this.Lu(t), i);
    }, t.prototype.Bl = function(t) {
        this.xl && this.xl(t), this.bl.forEach(function(t) {
            return t.al().To().V();
        });
    }, t.prototype.Gl = function() {
        this.Bl(new $1ff2b0a4ee3068d6$var$It(1));
    }, t.prototype.hf = function(t, i, n) {
        var h = new $1ff2b0a4ee3068d6$var$Fi(this, t, i), s = void 0 !== t.priceScaleId ? t.priceScaleId : this.ef();
        return n.Oh(h, s), $1ff2b0a4ee3068d6$var$Ft(s) || h.hh(t), h;
    }, t;
}(), $1ff2b0a4ee3068d6$var$$i = function() {
    function t(t, i) {
        this.ht = t, this.st = i;
    }
    return t.prototype.an = function(t) {
        return this.ht === t.ht && this.st === t.st;
    }, t;
}();
function $1ff2b0a4ee3068d6$var$Xi(t) {
    return t.ownerDocument && t.ownerDocument.defaultView && t.ownerDocument.defaultView.devicePixelRatio || 1;
}
function $1ff2b0a4ee3068d6$var$Zi(t) {
    var i = $1ff2b0a4ee3068d6$var$f(t.getContext("2d"));
    return i.setTransform(1, 0, 0, 1, 0, 0), i;
}
function $1ff2b0a4ee3068d6$var$Ji(t, i) {
    var n = t.createElement("canvas"), h = $1ff2b0a4ee3068d6$var$Xi(n);
    return n.style.width = i.ht + "px", n.style.height = i.st + "px", n.width = i.ht * h, n.height = i.st * h, n;
}
function $1ff2b0a4ee3068d6$var$Gi(i, n) {
    var h = $1ff2b0a4ee3068d6$var$f(i.ownerDocument).createElement("canvas");
    i.appendChild(h);
    var s = $1ff2b0a4ee3068d6$var$bindToDevicePixelRatio(h);
    return s.resizeCanvas({
        width: n.ht,
        height: n.st
    }), s;
}
var $1ff2b0a4ee3068d6$var$Qi = "undefined" != typeof window;
var $1ff2b0a4ee3068d6$var$tn = function() {
    if (!$1ff2b0a4ee3068d6$var$Qi) return !1;
    var t = !!navigator.maxTouchPoints || !!navigator.msMaxTouchPoints || !!$1ff2b0a4ee3068d6$var$Qi && ("ontouchstart" in window || Boolean(window.DocumentTouch && document instanceof window.DocumentTouch));
    return "onorientationchange" in window && t;
}();
var $1ff2b0a4ee3068d6$var$nn = function() {
    if (!$1ff2b0a4ee3068d6$var$Qi) return !1;
    var t = /Android/i.test(navigator.userAgent), i = /iPhone|iPad|iPod|AppleWebKit.+Mobile/i.test(navigator.userAgent);
    return t || i;
}(), $1ff2b0a4ee3068d6$var$hn = function() {
    function t(t, i, n) {
        this.uf = 0, this.af = null, this.lf = null, this.ff = !1, this.cf = null, this.vf = !1, this._f = !1, this.df = null, this.wf = null, this.Mf = null, this.bf = null, this.mf = 0, this.gf = !1, this.pf = !1, this.yf = !1, this.kf = t, this.xf = i, this.xi = n, this.Nf();
    }
    return t.prototype.rn = function() {
        null !== this.df && (this.df(), this.df = null), null !== this.wf && (this.wf(), this.wf = null), null !== this.Mf && (this.Mf(), this.Mf = null), this.Sf(), this.Cf();
    }, t.prototype.Df = function(t) {
        var i = this;
        this.wf && this.wf();
        var n = this.Tf.bind(this);
        this.wf = function() {
            i.kf.removeEventListener("mousemove", n);
        }, this.kf.addEventListener("mousemove", n), $1ff2b0a4ee3068d6$var$en(t) && this.Tf(t);
        var h = this.Bf(t);
        this.Ef(h, this.xf.Lf);
    }, t.prototype.Cf = function() {
        null !== this.af && clearTimeout(this.af), this.uf = 0, this.af = null;
    }, t.prototype.Tf = function(t) {
        if (!this.yf || $1ff2b0a4ee3068d6$var$en(t)) {
            var i = this.Bf(t);
            this.Ef(i, this.xf.Af);
        }
    }, t.prototype.Vf = function(t) {
        if ((!("button" in t) || 0 === t.button) && null === this.bf) {
            var i = $1ff2b0a4ee3068d6$var$en(t);
            if (!this.pf || !i) {
                this.gf = !0;
                var n = this.Bf(t), h = $1ff2b0a4ee3068d6$var$c(this.cf), s = Math.abs(h.g - n.Of), r = Math.abs(h.p - n.zf), e = s + r > 5;
                if (e || !i) {
                    if (e && !this.vf && i) {
                        var u = .5 * s, a = r >= u && !this.xi.Pf, o = u > r && !this.xi.Ff;
                        a || o || (this.pf = !0);
                    }
                    e && (this.vf = !0, this._f = !0, i && this.Sf()), this.pf || (this.Ef(n, this.xf.If), i && $1ff2b0a4ee3068d6$var$un(t));
                }
            }
        }
    }, t.prototype.Wf = function(t) {
        if (!("button" in t) || 0 === t.button) {
            var i = this.Bf(t);
            this.Sf(), this.cf = null, this.yf = !1, this.Mf && (this.Mf(), this.Mf = null), $1ff2b0a4ee3068d6$var$en(t) && this.Rf(t), this.Ef(i, this.xf.jf), ++this.uf, this.af && this.uf > 1 ? (this.Ef(i, this.xf.Uf), this.Cf()) : this._f || this.Ef(i, this.xf.qf), $1ff2b0a4ee3068d6$var$en(t) && ($1ff2b0a4ee3068d6$var$un(t), this.Rf(t), 0 === t.touches.length && (this.ff = !1));
        }
    }, t.prototype.Sf = function() {
        null !== this.lf && (clearTimeout(this.lf), this.lf = null);
    }, t.prototype.Hf = function(t) {
        if (!("button" in t) || 0 === t.button) {
            var i = this.Bf(t);
            this._f = !1, this.vf = !1, this.pf = !1, $1ff2b0a4ee3068d6$var$en(t) && this.Df(t), this.cf = {
                g: i.Of,
                p: i.zf
            }, this.Mf && (this.Mf(), this.Mf = null);
            var n = this.Vf.bind(this), h = this.Wf.bind(this), s = this.kf.ownerDocument.documentElement;
            this.Mf = function() {
                s.removeEventListener("touchmove", n), s.removeEventListener("touchend", h), s.removeEventListener("mousemove", n), s.removeEventListener("mouseup", h);
            }, s.addEventListener("touchmove", n, {
                passive: !1
            }), s.addEventListener("touchend", h, {
                passive: !1
            }), this.Sf(), $1ff2b0a4ee3068d6$var$en(t) && 1 === t.touches.length ? this.lf = setTimeout(this.Yf.bind(this, t), 240) : (s.addEventListener("mousemove", n), s.addEventListener("mouseup", h)), this.yf = !0, this.Ef(i, this.xf.Kf), this.af || (this.uf = 0, this.af = setTimeout(this.Cf.bind(this), 500));
        }
    }, t.prototype.Nf = function() {
        var t = this;
        this.kf.addEventListener("mouseenter", this.Df.bind(this)), this.kf.addEventListener("touchcancel", this.Sf.bind(this));
        var i = this.kf.ownerDocument, n = function(i) {
            t.xf.$f && (i.composed && t.kf.contains(i.composedPath()[0]) || i.target && t.kf.contains(i.target) || t.xf.$f());
        };
        this.df = function() {
            i.removeEventListener("mousedown", n), i.removeEventListener("touchstart", n);
        }, i.addEventListener("mousedown", n), i.addEventListener("touchstart", n, {
            passive: !0
        }), this.kf.addEventListener("mouseleave", this.Rf.bind(this)), this.kf.addEventListener("touchstart", this.Hf.bind(this), {
            passive: !0
        }), $1ff2b0a4ee3068d6$var$tn || this.kf.addEventListener("mousedown", this.Hf.bind(this)), this.Xf(), this.kf.addEventListener("touchmove", function() {}, {
            passive: !1
        });
    }, t.prototype.Xf = function() {
        var t = this;
        void 0 === this.xf.Zf && void 0 === this.xf.Jf && void 0 === this.xf.Gf || (this.kf.addEventListener("touchstart", function(i) {
            return t.Qf(i.touches);
        }, {
            passive: !0
        }), this.kf.addEventListener("touchmove", function(i) {
            if (2 === i.touches.length && null !== t.bf && void 0 !== t.xf.Jf) {
                var n = $1ff2b0a4ee3068d6$var$rn(i.touches[0], i.touches[1]) / t.mf;
                t.xf.Jf(t.bf, n), $1ff2b0a4ee3068d6$var$un(i);
            }
        }, {
            passive: !1
        }), this.kf.addEventListener("touchend", function(i) {
            t.Qf(i.touches);
        }));
    }, t.prototype.Qf = function(t) {
        1 === t.length && (this.gf = !1), 2 !== t.length || this.gf || this.ff ? this.tc() : this.ic(t);
    }, t.prototype.ic = function(t) {
        var i = $1ff2b0a4ee3068d6$var$sn(this.kf);
        this.bf = {
            g: (t[0].clientX - i.left + (t[1].clientX - i.left)) / 2,
            p: (t[0].clientY - i.top + (t[1].clientY - i.top)) / 2
        }, this.mf = $1ff2b0a4ee3068d6$var$rn(t[0], t[1]), void 0 !== this.xf.Zf && this.xf.Zf(), this.Sf();
    }, t.prototype.tc = function() {
        null !== this.bf && (this.bf = null, void 0 !== this.xf.Gf && this.xf.Gf());
    }, t.prototype.Rf = function(t) {
        this.wf && this.wf();
        var i = this.Bf(t);
        this.Ef(i, this.xf.nc);
    }, t.prototype.Yf = function(t) {
        var i = this.Bf(t);
        this.Ef(i, this.xf.hc), this._f = !0, this.ff = !0;
    }, t.prototype.Ef = function(t, i) {
        i && i.call(this.xf, t);
    }, t.prototype.Bf = function(t) {
        var i;
        i = "touches" in t && t.touches.length ? t.touches[0] : "changedTouches" in t && t.changedTouches.length ? t.changedTouches[0] : t;
        var n = $1ff2b0a4ee3068d6$var$sn(this.kf);
        return {
            sc: i.clientX,
            rc: i.clientY,
            Of: i.pageX,
            zf: i.pageY,
            ec: i.screenX,
            uc: i.screenY,
            ac: i.clientX - n.left,
            oc: i.clientY - n.top,
            lc: t.ctrlKey,
            fc: t.altKey,
            cc: t.shiftKey,
            vc: t.metaKey,
            pe: t.type.startsWith("mouse") ? "mouse" : "touch",
            _c: t.view
        };
    }, t;
}();
function $1ff2b0a4ee3068d6$var$sn(t) {
    return t.getBoundingClientRect() || {
        left: 0,
        top: 0
    };
}
function $1ff2b0a4ee3068d6$var$rn(t, i) {
    var n = t.clientX - i.clientX, h = t.clientY - i.clientY;
    return Math.sqrt(n * n + h * h);
}
function $1ff2b0a4ee3068d6$var$en(t) {
    return Boolean(t.touches);
}
function $1ff2b0a4ee3068d6$var$un(t) {
    t.cancelable && t.preventDefault();
}
var $1ff2b0a4ee3068d6$var$an = function() {
    function t(t, i, n, h) {
        this.Du = new $1ff2b0a4ee3068d6$var$oi(200), this.oe = 0, this.dc = "", this.Iu = "", this.xu = [], this.wc = new Map, this.oe = t, this.dc = i, this.Iu = $1ff2b0a4ee3068d6$var$zt(t, n, h);
    }
    return t.prototype.rn = function() {
        this.Du.Nu(), this.xu = [], this.wc.clear();
    }, t.prototype.Mc = function(t, i, n, h, s) {
        var r = this.bc(t, i);
        if ("left" !== s) {
            var e = $1ff2b0a4ee3068d6$var$Xi(t.canvas);
            n -= Math.floor(r.mc * e);
        }
        h -= Math.floor(r.wt / 2), t.drawImage(r.gc, n, h, r.dt, r.wt);
    }, t.prototype.bc = function(t, i) {
        var n, h = this;
        if (this.wc.has(i)) n = $1ff2b0a4ee3068d6$var$l(this.wc.get(i));
        else {
            if (this.xu.length >= 200) {
                var s = $1ff2b0a4ee3068d6$var$l(this.xu.shift());
                this.wc.delete(s);
            }
            var r = $1ff2b0a4ee3068d6$var$Xi(t.canvas), e = Math.ceil(this.oe / 4.5), u = Math.round(this.oe / 10), a = Math.ceil(this.Du.Vt(t, i)), o = $1ff2b0a4ee3068d6$var$nt(Math.round(a + 2 * e)), f = $1ff2b0a4ee3068d6$var$nt(this.oe + 2 * e), c = $1ff2b0a4ee3068d6$var$Ji(document, new $1ff2b0a4ee3068d6$var$$i(o, f));
            n = {
                At: i,
                mc: Math.round(Math.max(1, a)),
                dt: Math.ceil(o * r),
                wt: Math.ceil(f * r),
                gc: c
            }, 0 !== a && (this.xu.push(n.At), this.wc.set(n.At, n)), $1ff2b0a4ee3068d6$var$z(t = $1ff2b0a4ee3068d6$var$Zi(n.gc), r, function() {
                t.font = h.Iu, t.fillStyle = h.dc, t.fillText(i, 0, f - e - u);
            });
        }
        return n;
    }, t;
}(), $1ff2b0a4ee3068d6$var$on = function() {
    function t(t, i, n, h) {
        var s = this;
        this.Jt = null, this.yc = null, this.kc = null, this.xc = !1, this.Nc = new $1ff2b0a4ee3068d6$var$oi(50), this.Sc = new $1ff2b0a4ee3068d6$var$an(11, "#000"), this.dc = null, this.Iu = null, this.Cc = 0, this.Dc = function() {
            s.Tc(s.Nl.I()), s._i.Bc().ct().zr();
        }, this.Ec = function() {
            s._i.Bc().ct().zr();
        }, this._i = t, this.xi = i, this.Nl = n, this.Lc = "left" === h, this.Ac = document.createElement("div"), this.Ac.style.height = "100%", this.Ac.style.overflow = "hidden", this.Ac.style.width = "25px", this.Ac.style.left = "0", this.Ac.style.position = "relative", this.Vc = $1ff2b0a4ee3068d6$var$Gi(this.Ac, new $1ff2b0a4ee3068d6$var$$i(16, 16)), this.Vc.subscribeCanvasConfigured(this.Dc);
        var r = this.Vc.canvas;
        r.style.position = "absolute", r.style.zIndex = "1", r.style.left = "0", r.style.top = "0", this.Oc = $1ff2b0a4ee3068d6$var$Gi(this.Ac, new $1ff2b0a4ee3068d6$var$$i(16, 16)), this.Oc.subscribeCanvasConfigured(this.Ec);
        var e = this.Oc.canvas;
        e.style.position = "absolute", e.style.zIndex = "2", e.style.left = "0", e.style.top = "0";
        var u = {
            Kf: this.zc.bind(this),
            If: this.Pc.bind(this),
            $f: this.Fc.bind(this),
            jf: this.Ic.bind(this),
            Uf: this.Wc.bind(this),
            Lf: this.Rc.bind(this),
            nc: this.jc.bind(this)
        };
        this.Uc = new $1ff2b0a4ee3068d6$var$hn(this.Oc.canvas, u, {
            Pf: !1,
            Ff: !0
        });
    }
    return t.prototype.rn = function() {
        this.Uc.rn(), this.Oc.unsubscribeCanvasConfigured(this.Ec), this.Oc.destroy(), this.Vc.unsubscribeCanvasConfigured(this.Dc), this.Vc.destroy(), null !== this.Jt && this.Jt.Ih().nn(this), this.Jt = null, null !== this.kc && (clearTimeout(this.kc), this.kc = null), this.Sc.rn();
    }, t.prototype.qc = function() {
        return this.Ac;
    }, t.prototype.K = function() {
        return this.xi.backgroundColor;
    }, t.prototype.S = function() {
        return $1ff2b0a4ee3068d6$var$f(this.Jt).I().borderColor;
    }, t.prototype.Hc = function() {
        return this.xi.textColor;
    }, t.prototype.zt = function() {
        return this.xi.fontSize;
    }, t.prototype.Yc = function() {
        return $1ff2b0a4ee3068d6$var$zt(this.zt(), this.xi.fontFamily);
    }, t.prototype.Kc = function() {
        var t = this.Nl.I(), i = this.dc !== t.et, n = this.Iu !== t.xt;
        return (i || n) && (this.Tc(t), this.dc = t.et), n && (this.Nc.Nu(), this.Iu = t.xt), t;
    }, t.prototype.$c = function() {
        if (null === this.Jt) return 0;
        var t = 34, i = this.Kc(), n = $1ff2b0a4ee3068d6$var$Zi(this.Vc.canvas), h = this.Jt.Ln();
        n.font = this.Yc(), h.length > 0 && (t = Math.max(this.Nc.Vt(n, h[0].Tn), this.Nc.Vt(n, h[h.length - 1].Tn)));
        for(var s = this.Xc(), r = s.length; r--;){
            var e = this.Nc.Vt(n, s[r].At());
            e > t && (t = e);
        }
        var u = Math.ceil(i.Dt + i.Ct + i.Et + i.Lt + t);
        return u += u % 2;
    }, t.prototype.Zc = function(t) {
        if (t.ht < 0 || t.st < 0) throw new Error("Try to set invalid size to PriceAxisWidget " + JSON.stringify(t));
        null !== this.yc && this.yc.an(t) || (this.yc = t, this.Vc.resizeCanvas({
            width: t.ht,
            height: t.st
        }), this.Oc.resizeCanvas({
            width: t.ht,
            height: t.st
        }), this.Ac.style.width = t.ht + "px", this.Ac.style.height = t.st + "px", this.Ac.style.minWidth = t.ht + "px");
    }, t.prototype.Jc = function() {
        return $1ff2b0a4ee3068d6$var$f(this.yc).ht;
    }, t.prototype.li = function(t) {
        this.Jt !== t && (null !== this.Jt && this.Jt.Ih().nn(this), this.Jt = t, t.Ih().Zi(this.jn.bind(this), this));
    }, t.prototype.Z = function() {
        return this.Jt;
    }, t.prototype.Nu = function() {
        var t = this._i.Gc();
        this._i.Bc().ct().sl(t, $1ff2b0a4ee3068d6$var$f(this.Z()));
    }, t.prototype.Qc = function(t) {
        if (null !== this.yc) {
            if (1 !== t) {
                var i = $1ff2b0a4ee3068d6$var$Zi(this.Vc.canvas);
                this.tv(), this.iv(i, this.Vc.pixelRatio), this.fu(i, this.Vc.pixelRatio), this.nv(i, this.Vc.pixelRatio), this.hv(i, this.Vc.pixelRatio);
            }
            var n = $1ff2b0a4ee3068d6$var$Zi(this.Oc.canvas), h = this.yc.ht, s = this.yc.st;
            $1ff2b0a4ee3068d6$var$z(n, this.Oc.pixelRatio, function() {
                n.clearRect(0, 0, h, s);
            }), this.sv(n, this.Oc.pixelRatio);
        }
    }, t.prototype.rv = function() {
        return this.Vc.canvas;
    }, t.prototype.zc = function(t) {
        if (null !== this.Jt && !this.Jt.Qt() && this._i.Bc().I().handleScale.axisPressedMouseMove.price) {
            var i = this._i.Bc().ct(), n = this._i.Gc();
            this.xc = !0, i.Jo(n, this.Jt, t.oc);
        }
    }, t.prototype.Pc = function(t) {
        if (null !== this.Jt && this._i.Bc().I().handleScale.axisPressedMouseMove.price) {
            var i = this._i.Bc().ct(), n = this._i.Gc(), h = this.Jt;
            i.Go(n, h, t.oc);
        }
    }, t.prototype.Fc = function() {
        if (null !== this.Jt && this._i.Bc().I().handleScale.axisPressedMouseMove.price) {
            var t = this._i.Bc().ct(), i = this._i.Gc(), n = this.Jt;
            this.xc && (this.xc = !1, t.Qo(i, n));
        }
    }, t.prototype.Ic = function(t) {
        if (null !== this.Jt && this._i.Bc().I().handleScale.axisPressedMouseMove.price) {
            var i = this._i.Bc().ct(), n = this._i.Gc();
            this.xc = !1, i.Qo(n, this.Jt);
        }
    }, t.prototype.Wc = function(t) {
        this._i.Bc().I().handleScale.axisDoubleClickReset && this.Nu();
    }, t.prototype.Rc = function(t) {
        null !== this.Jt && (!this._i.Bc().ct().I().handleScale.axisPressedMouseMove.price || this.Jt.oh() || this.Jt.lh() || this.ev(1));
    }, t.prototype.jc = function(t) {
        this.ev(0);
    }, t.prototype.Xc = function() {
        var t = this, i = [], n = null === this.Jt ? void 0 : this.Jt;
        return function(h) {
            for(var s = 0; s < h.length; ++s)for(var r = h[s].fi(t._i.Gc(), n), e = 0; e < r.length; e++)i.push(r[e]);
        }(this._i.Gc().Vh()), i;
    }, t.prototype.iv = function(t, i) {
        var n = this;
        if (null !== this.yc) {
            var h = this.yc.ht, s = this.yc.st;
            $1ff2b0a4ee3068d6$var$z(t, i, function() {
                $1ff2b0a4ee3068d6$var$P(t, 0, 0, h, s, n.K());
            });
        }
    }, t.prototype.fu = function(t, i) {
        if (null !== this.yc && null !== this.Jt && this.Jt.I().borderVisible) {
            t.save(), t.fillStyle = this.S();
            var n, h = Math.max(1, Math.floor(this.Kc().Dt * i));
            n = this.Lc ? Math.floor(this.yc.ht * i) - h : 0, t.fillRect(n, 0, h, Math.ceil(this.yc.st * i)), t.restore();
        }
    }, t.prototype.nv = function(t, i) {
        if (null !== this.yc && null !== this.Jt) {
            var n = this.Jt.Ln();
            t.save(), t.strokeStyle = this.S(), t.font = this.Yc(), t.fillStyle = this.S();
            var h = this.Kc(), s = this.Jt.I().borderVisible && this.Jt.I().drawTicks, r = this.Lc ? Math.floor((this.yc.ht - h.Ct) * i - h.Dt * i) : Math.floor(h.Dt * i), e = this.Lc ? Math.round(r - h.Et * i) : Math.round(r + h.Ct * i + h.Et * i), u = this.Lc ? "right" : "left", a = Math.max(1, Math.floor(i)), o = Math.floor(.5 * i);
            if (s) {
                var l = Math.round(h.Ct * i);
                t.beginPath();
                for(var f = 0, c = n; f < c.length; f++){
                    var v = c[f];
                    t.rect(r, Math.round(v.Dn * i) - o, l, a);
                }
                t.fill();
            }
            t.fillStyle = this.Hc();
            for(var _ = 0, d = n; _ < d.length; _++){
                v = d[_];
                this.Sc.Mc(t, v.Tn, e, Math.round(v.Dn * i), u);
            }
            t.restore();
        }
    }, t.prototype.tv = function() {
        if (null !== this.yc && null !== this.Jt) {
            var t = this.yc.st / 2, i = [], n = this.Jt.Vh().slice(), h = this._i.Gc(), s = this.Kc();
            this.Jt === h.Ci() && this._i.Gc().Vh().forEach(function(t) {
                h.Au(t) && n.push(t);
            });
            var r = this.Jt.Ah()[0], e = this.Jt;
            n.forEach(function(n) {
                var s = n.fi(h, e);
                s.forEach(function(t) {
                    t.Yt(null), t.Kt() && i.push(t);
                }), r === n && s.length > 0 && (t = s[0].Pt());
            });
            var u = i.filter(function(i) {
                return i.Pt() <= t;
            }), a = i.filter(function(i) {
                return i.Pt() > t;
            });
            if (u.sort(function(t, i) {
                return i.Pt() - t.Pt();
            }), u.length && a.length && a.push(u[0]), a.sort(function(t, i) {
                return t.Pt() - i.Pt();
            }), i.forEach(function(t) {
                return t.Yt(t.Pt());
            }), this.Jt.I().alignLabels) {
                for(var o = 1; o < u.length; o++){
                    var l = u[o], f = (v = u[o - 1]).wt(s, !1);
                    l.Pt() > (_ = v.Ht()) - f && l.Yt(_ - f);
                }
                for(var c = 1; c < a.length; c++){
                    var v, _;
                    l = a[c], f = (v = a[c - 1]).wt(s, !0);
                    l.Pt() < (_ = v.Ht()) + f && l.Yt(_ + f);
                }
            }
        }
    }, t.prototype.hv = function(t, i) {
        var n = this;
        if (null !== this.yc) {
            t.save();
            var h = this.yc, s = this.Xc(), r = this.Kc(), e = this.Lc ? "right" : "left";
            s.forEach(function(s) {
                if (s.$t()) {
                    var u = s.W($1ff2b0a4ee3068d6$var$f(n.Jt));
                    t.save(), u.h(t, r, n.Nc, h.ht, e, i), t.restore();
                }
            }), t.restore();
        }
    }, t.prototype.sv = function(t, i) {
        var n = this;
        if (null !== this.yc && null !== this.Jt) {
            t.save();
            var h = this.yc, s = this._i.Bc().ct(), r = [], e = this._i.Gc(), u = s.Il().fi(e, this.Jt);
            u.length && r.push(u);
            var a = this.Kc(), o = this.Lc ? "right" : "left";
            r.forEach(function(s) {
                s.forEach(function(s) {
                    t.save(), s.W($1ff2b0a4ee3068d6$var$f(n.Jt)).h(t, a, n.Nc, h.ht, o, i), t.restore();
                });
            }), t.restore();
        }
    }, t.prototype.ev = function(t) {
        this.Ac.style.cursor = 1 === t ? "ns-resize" : "default";
    }, t.prototype.jn = function() {
        var t = this, i = this.$c();
        if (this.Cc < i) {
            var n = this._i.Bc();
            null === this.kc && (this.kc = setTimeout(function() {
                n && n.ct().Tl(), t.kc = null;
            }, 100));
        }
        this.Cc = i;
    }, t.prototype.Tc = function(t) {
        this.Sc.rn(), this.Sc = new $1ff2b0a4ee3068d6$var$an(t.zt, t.et, t.ae);
    }, t;
}(), $1ff2b0a4ee3068d6$var$ln = $1ff2b0a4ee3068d6$var$nn, $1ff2b0a4ee3068d6$var$fn = function() {
    function t(t, i) {
        var n = this;
        this.yc = new $1ff2b0a4ee3068d6$var$$i(0, 0), this.uv = null, this.av = null, this.ov = null, this.lv = !1, this.fv = new $1ff2b0a4ee3068d6$var$J, this.cv = 0, this.vv = !1, this._v = null, this.dv = !1, this.wv = null, this.Dc = function() {
            return n.Mv && n.hi().zr();
        }, this.Ec = function() {
            return n.Mv && n.hi().zr();
        }, this.bv = t, this.Mv = i, this.Mv.ul().Zi(this.mv.bind(this), this, !0), this.gv = document.createElement("td"), this.gv.style.padding = "0", this.gv.style.position = "relative";
        var h = document.createElement("div");
        h.style.width = "100%", h.style.height = "100%", h.style.position = "relative", h.style.overflow = "hidden", this.pv = document.createElement("td"), this.pv.style.padding = "0", this.yv = document.createElement("td"), this.yv.style.padding = "0", this.gv.appendChild(h), this.Vc = $1ff2b0a4ee3068d6$var$Gi(h, new $1ff2b0a4ee3068d6$var$$i(16, 16)), this.Vc.subscribeCanvasConfigured(this.Dc);
        var s = this.Vc.canvas;
        s.style.position = "absolute", s.style.zIndex = "1", s.style.left = "0", s.style.top = "0", this.Oc = $1ff2b0a4ee3068d6$var$Gi(h, new $1ff2b0a4ee3068d6$var$$i(16, 16)), this.Oc.subscribeCanvasConfigured(this.Ec);
        var r = this.Oc.canvas;
        r.style.position = "absolute", r.style.zIndex = "2", r.style.left = "0", r.style.top = "0", this.kv = document.createElement("tr"), this.kv.appendChild(this.pv), this.kv.appendChild(this.gv), this.kv.appendChild(this.yv), this.xv();
        var e = this.Bc().I().handleScroll;
        this.Uc = new $1ff2b0a4ee3068d6$var$hn(this.Oc.canvas, this, {
            Pf: !e.vertTouchDrag,
            Ff: !e.horzTouchDrag
        });
    }
    return t.prototype.rn = function() {
        null !== this.uv && this.uv.rn(), null !== this.av && this.av.rn(), this.Oc.unsubscribeCanvasConfigured(this.Ec), this.Oc.destroy(), this.Vc.unsubscribeCanvasConfigured(this.Dc), this.Vc.destroy(), null !== this.Mv && this.Mv.ul().nn(this), this.Uc.rn();
    }, t.prototype.Gc = function() {
        return $1ff2b0a4ee3068d6$var$f(this.Mv);
    }, t.prototype.Nv = function(i) {
        null !== this.Mv && this.Mv.ul().nn(this), this.Mv = i, null !== this.Mv && this.Mv.ul().Zi(t.prototype.mv.bind(this), this, !0), this.xv();
    }, t.prototype.Bc = function() {
        return this.bv;
    }, t.prototype.qc = function() {
        return this.kv;
    }, t.prototype.xv = function() {
        if (null !== this.Mv && (this.Sv(), 0 !== this.hi().O().length)) {
            if (null !== this.uv) {
                var t = this.Mv.Xo();
                this.uv.li($1ff2b0a4ee3068d6$var$f(t));
            }
            if (null !== this.av) {
                var i = this.Mv.Zo();
                this.av.li($1ff2b0a4ee3068d6$var$f(i));
            }
        }
    }, t.prototype.jo = function() {
        return null !== this.Mv ? this.Mv.jo() : 0;
    }, t.prototype.Uo = function(t) {
        this.Mv && this.Mv.Uo(t);
    }, t.prototype.Lf = function(t) {
        if (this.Mv) {
            var i = t.ac, n = t.oc;
            $1ff2b0a4ee3068d6$var$tn || this.Cv(i, n);
        }
    }, t.prototype.Kf = function(t) {
        if (this.vv = !1, this.dv = null !== this._v, this.Mv) {
            if (document.activeElement !== document.body && document.activeElement !== document.documentElement) $1ff2b0a4ee3068d6$var$f(document.activeElement).blur();
            else {
                var i = document.getSelection();
                null !== i && i.removeAllRanges();
            }
            var n = this.hi();
            if (!this.Mv.Ci().Qt() && !n.U().Qt()) {
                if (null !== this._v) {
                    var h = n.Il();
                    this.wv = {
                        x: h.Mt(),
                        y: h.bt()
                    }, this._v = {
                        x: t.ac,
                        y: t.oc
                    };
                }
                $1ff2b0a4ee3068d6$var$tn || this.Cv(t.ac, t.oc);
            }
        }
    }, t.prototype.Af = function(t) {
        if (this.Mv) {
            var i = t.ac, n = t.oc;
            if (this.Dv() && this.Tv(), !$1ff2b0a4ee3068d6$var$tn) {
                this.Cv(i, n);
                var h = this.Wu(i, n);
                this.hi().Al(h && {
                    Vl: h.Vl,
                    Bv: h.Bv
                }), null !== h && void 0 !== h._c.Ev && h._c.Ev(i, n);
            }
        }
    }, t.prototype.qf = function(t) {
        if (null !== this.Mv) {
            var i = t.ac, n = t.oc, h = this.Wu(i, n);
            if (null !== h && void 0 !== h._c.Lv && h._c.Lv(i, n), this.fv.sn()) {
                var s = this.hi().Il().j();
                this.fv.hn(s, {
                    x: i,
                    y: n
                });
            }
            this.Av();
        }
    }, t.prototype.If = function(t) {
        if (null !== this.Mv) {
            var i = this.hi(), n = t.ac, h = t.oc;
            if (null !== this._v) {
                this.dv = !1;
                var s = $1ff2b0a4ee3068d6$var$f(this.wv), r = s.x + (n - this._v.x), e = s.y + (h - this._v.y);
                this.Cv(r, e);
            } else this.Dv() || this.Cv(n, h);
            if (!i.U().Qt()) {
                var u = this.bv.I().handleScroll;
                if (u.pressedMouseMove && "touch" !== t.pe || (u.horzTouchDrag || u.vertTouchDrag) && "mouse" !== t.pe) {
                    var a = this.Mv.Ci();
                    null !== this.ov || this.Vv() || (this.ov = {
                        x: t.sc,
                        y: t.rc
                    }), null === this.ov || this.ov.x === t.sc && this.ov.y === t.rc || this.lv || (a.Qt() || i.tl(this.Mv, a, t.oc), i.Yl(t.ac), this.lv = !0), this.lv && (a.Qt() || i.il(this.Mv, a, t.oc), i.Kl(t.ac));
                }
            }
        }
    }, t.prototype.jf = function(t) {
        if (null !== this.Mv) {
            this.vv = !1;
            var i = this.hi();
            if (this.lv) {
                var n = this.Mv.Ci();
                i.nl(this.Mv, n), i.$l(), this.ov = null, this.lv = !1;
            }
        }
    }, t.prototype.hc = function(t) {
        if (this.vv = !0, null === this._v && $1ff2b0a4ee3068d6$var$ln) {
            var i = {
                x: t.ac,
                y: t.oc
            };
            this.Ov(i, i);
        }
    }, t.prototype.nc = function(t) {
        null !== this.Mv && (this.Mv.ct().Al(null), $1ff2b0a4ee3068d6$var$nn || this.Tv());
    }, t.prototype.zv = function() {
        return this.fv;
    }, t.prototype.Zf = function() {
        this.cv = 1;
    }, t.prototype.Jf = function(t, i) {
        if (this.bv.I().handleScale.pinch) {
            var n = 5 * (i - this.cv);
            this.cv = i, this.hi().ql(t.g, n);
        }
    }, t.prototype.Wu = function(t, i) {
        var n = this.Mv;
        if (null === n) return null;
        for(var h = 0, s = n.Vh(); h < s.length; h++){
            var r = s[h], e = this.Pv(r.ci(n), t, i);
            if (null !== e) return {
                Vl: r,
                _c: e._c,
                Bv: e.Bv
            };
        }
        return null;
    }, t.prototype.Fv = function(t, i) {
        $1ff2b0a4ee3068d6$var$f("left" === i ? this.uv : this.av).Zc(new $1ff2b0a4ee3068d6$var$$i(t, this.yc.st));
    }, t.prototype.Iv = function() {
        return this.yc;
    }, t.prototype.Zc = function(t) {
        if (t.ht < 0 || t.st < 0) throw new Error("Try to set invalid size to PaneWidget " + JSON.stringify(t));
        this.yc.an(t) || (this.yc = t, this.Vc.resizeCanvas({
            width: t.ht,
            height: t.st
        }), this.Oc.resizeCanvas({
            width: t.ht,
            height: t.st
        }), this.gv.style.width = t.ht + "px", this.gv.style.height = t.st + "px");
    }, t.prototype.Wv = function() {
        var t = $1ff2b0a4ee3068d6$var$f(this.Mv);
        t.$o(t.Xo()), t.$o(t.Zo());
        for(var i = 0, n = t.Ah(); i < n.length; i++){
            var h = n[i];
            if (t.Au(h)) {
                var s = h.Z();
                null !== s && t.$o(s), h.Wi();
            }
        }
    }, t.prototype.rv = function() {
        return this.Vc.canvas;
    }, t.prototype.Qc = function(t) {
        if (0 !== t && null !== this.Mv) {
            if (t > 1 && this.Wv(), null !== this.uv && this.uv.Qc(t), null !== this.av && this.av.Qc(t), 1 !== t) {
                var i = $1ff2b0a4ee3068d6$var$Zi(this.Vc.canvas);
                i.save(), this.iv(i, this.Rv(), this.Vc.pixelRatio), this.Mv && (this.jv(i, this.Vc.pixelRatio), this.Uv(i, this.Vc.pixelRatio), this.qv(i, this.Vc.pixelRatio)), i.restore();
            }
            var n = $1ff2b0a4ee3068d6$var$Zi(this.Oc.canvas);
            n.clearRect(0, 0, Math.ceil(this.yc.ht * this.Oc.pixelRatio), Math.ceil(this.yc.st * this.Oc.pixelRatio)), this.Hv(n, this.Oc.pixelRatio);
        }
    }, t.prototype.Yv = function() {
        return this.uv;
    }, t.prototype.Kv = function() {
        return this.av;
    }, t.prototype.Rv = function() {
        return this.bv.I().layout.backgroundColor;
    }, t.prototype.mv = function() {
        null !== this.Mv && this.Mv.ul().nn(this), this.Mv = null;
    }, t.prototype.iv = function(t, i, n) {
        var h = this;
        $1ff2b0a4ee3068d6$var$z(t, n, function() {
            $1ff2b0a4ee3068d6$var$P(t, 0, 0, h.yc.ht, h.yc.st, i);
        });
    }, t.prototype.jv = function(t, i) {
        var n = $1ff2b0a4ee3068d6$var$f(this.Mv), h = n.al().To().W(n.wt(), n.dt());
        null !== h && (t.save(), h.h(t, i, !1), t.restore());
    }, t.prototype.Uv = function(t, i) {
        var n = this.hi().Fl();
        this.$v(n, t, i), this.Xv(n, t, i);
    }, t.prototype.Hv = function(t, i) {
        this.Xv(this.hi().Il(), t, i);
    }, t.prototype.qv = function(t, i) {
        for(var n = $1ff2b0a4ee3068d6$var$f(this.Mv).Vh(), h = 0, s = n; h < s.length; h++){
            var r = s[h];
            this.$v(r, t, i);
        }
        for(var e = 0, u = n; e < u.length; e++){
            r = u[e];
            this.Xv(r, t, i);
        }
    }, t.prototype.Xv = function(t, i, n) {
        for(var h = $1ff2b0a4ee3068d6$var$f(this.Mv), s = t.ci(h), r = h.wt(), e = h.dt(), u = h.ct().Ll(), a = null !== u && u.Vl === t, o = null !== u && a && void 0 !== u.Bv ? u.Bv.Ru : void 0, l = 0, c = s; l < c.length; l++){
            var v = c[l].W(r, e);
            null !== v && (i.save(), v.h(i, n, a, o), i.restore());
        }
    }, t.prototype.$v = function(t, i, n) {
        for(var h = $1ff2b0a4ee3068d6$var$f(this.Mv), s = t.ci(h), r = h.wt(), e = h.dt(), u = h.ct().Ll(), a = null !== u && u.Vl === t, o = null !== u && a && void 0 !== u.Bv ? u.Bv.Ru : void 0, l = 0, c = s; l < c.length; l++){
            var v = c[l].W(r, e);
            null !== v && void 0 !== v.o && (i.save(), v.o(i, n, a, o), i.restore());
        }
    }, t.prototype.Pv = function(t, i, n) {
        for(var h = 0, s = t; h < s.length; h++){
            var r = s[h], e = r.W(this.yc.st, this.yc.ht);
            if (null !== e && e.Wu) {
                var u = e.Wu(i, n);
                if (null !== u) return {
                    _c: r,
                    Bv: u
                };
            }
        }
        return null;
    }, t.prototype.Sv = function() {
        if (null !== this.Mv) {
            var t = this.bv;
            t.I().leftPriceScale.visible || null === this.uv || (this.pv.removeChild(this.uv.qc()), this.uv.rn(), this.uv = null), t.I().rightPriceScale.visible || null === this.av || (this.yv.removeChild(this.av.qc()), this.av.rn(), this.av = null);
            var i = t.ct().if();
            t.I().leftPriceScale.visible && null === this.uv && (this.uv = new $1ff2b0a4ee3068d6$var$on(this, t.I().layout, i, "left"), this.pv.appendChild(this.uv.qc())), t.I().rightPriceScale.visible && null === this.av && (this.av = new $1ff2b0a4ee3068d6$var$on(this, t.I().layout, i, "right"), this.yv.appendChild(this.av.qc()));
        }
    }, t.prototype.Dv = function() {
        return $1ff2b0a4ee3068d6$var$ln && null === this._v;
    }, t.prototype.Vv = function() {
        return $1ff2b0a4ee3068d6$var$ln && this.vv || null !== this._v;
    }, t.prototype.Zv = function(t) {
        return Math.max(0, Math.min(t, this.yc.ht - 1));
    }, t.prototype.Jv = function(t) {
        return Math.max(0, Math.min(t, this.yc.st - 1));
    }, t.prototype.Cv = function(t, i) {
        this.hi().Jl(this.Zv(t), this.Jv(i), $1ff2b0a4ee3068d6$var$f(this.Mv));
    }, t.prototype.Tv = function() {
        this.hi().Ql();
    }, t.prototype.Av = function() {
        this.dv && (this._v = null, this.Tv());
    }, t.prototype.Ov = function(t, i) {
        this._v = t, this.dv = !1, this.Cv(i.x, i.y);
        var n = this.hi().Il();
        this.wv = {
            x: n.Mt(),
            y: n.bt()
        };
    }, t.prototype.hi = function() {
        return this.bv.ct();
    }, t;
}(), $1ff2b0a4ee3068d6$var$cn = function() {
    function t(t, i, n, h) {
        var s = this;
        this.B = !0, this.yc = new $1ff2b0a4ee3068d6$var$$i(0, 0), this.Dc = function() {
            return s.Qc(3);
        }, this.Lc = "left" === t, this.Nl = n.if, this.xi = i, this.Gv = h, this.Ac = document.createElement("div"), this.Ac.style.width = "25px", this.Ac.style.height = "100%", this.Ac.style.overflow = "hidden", this.Vc = $1ff2b0a4ee3068d6$var$Gi(this.Ac, new $1ff2b0a4ee3068d6$var$$i(16, 16)), this.Vc.subscribeCanvasConfigured(this.Dc);
    }
    return t.prototype.rn = function() {
        this.Vc.unsubscribeCanvasConfigured(this.Dc), this.Vc.destroy();
    }, t.prototype.qc = function() {
        return this.Ac;
    }, t.prototype.Iv = function() {
        return this.yc;
    }, t.prototype.Zc = function(t) {
        if (t.ht < 0 || t.st < 0) throw new Error("Try to set invalid size to PriceAxisStub " + JSON.stringify(t));
        this.yc.an(t) || (this.yc = t, this.Vc.resizeCanvas({
            width: t.ht,
            height: t.st
        }), this.Ac.style.width = t.ht + "px", this.Ac.style.minWidth = t.ht + "px", this.Ac.style.height = t.st + "px", this.B = !0);
    }, t.prototype.Qc = function(t) {
        if ((!(t < 3) || this.B) && 0 !== this.yc.ht && 0 !== this.yc.st) {
            this.B = !1;
            var i = $1ff2b0a4ee3068d6$var$Zi(this.Vc.canvas);
            this.iv(i, this.Vc.pixelRatio), this.fu(i, this.Vc.pixelRatio);
        }
    }, t.prototype.rv = function() {
        return this.Vc.canvas;
    }, t.prototype.fu = function(t, i) {
        if (this.Gv()) {
            var n = this.yc.ht;
            t.save(), t.fillStyle = this.xi.timeScale.borderColor;
            var h = Math.floor(this.Nl.I().Dt * i), s = this.Lc ? Math.round(n * i) - h : 0;
            t.fillRect(s, 0, h, h), t.restore();
        }
    }, t.prototype.iv = function(t, i) {
        var n = this;
        $1ff2b0a4ee3068d6$var$z(t, i, function() {
            $1ff2b0a4ee3068d6$var$P(t, 0, 0, n.yc.ht, n.yc.st, n.xi.layout.backgroundColor);
        });
    }, t;
}();
function $1ff2b0a4ee3068d6$var$vn(t, i) {
    return t.Fs > i.Fs ? t : i;
}
var $1ff2b0a4ee3068d6$var$_n = function() {
    function t(t) {
        var i = this;
        this.Qv = null, this.t_ = null, this.ue = null, this.i_ = !1, this.yc = new $1ff2b0a4ee3068d6$var$$i(0, 0), this.Dc = function() {
            return i.bv.ct().zr();
        }, this.Ec = function() {
            return i.bv.ct().zr();
        }, this.bv = t, this.xi = t.I().layout, this.n_ = document.createElement("tr"), this.h_ = document.createElement("td"), this.h_.style.padding = "0", this.s_ = document.createElement("td"), this.s_.style.padding = "0", this.Ac = document.createElement("td"), this.Ac.style.height = "25px", this.Ac.style.padding = "0", this.r_ = document.createElement("div"), this.r_.style.width = "100%", this.r_.style.height = "100%", this.r_.style.position = "relative", this.r_.style.overflow = "hidden", this.Ac.appendChild(this.r_), this.Vc = $1ff2b0a4ee3068d6$var$Gi(this.r_, new $1ff2b0a4ee3068d6$var$$i(16, 16)), this.Vc.subscribeCanvasConfigured(this.Dc);
        var n = this.Vc.canvas;
        n.style.position = "absolute", n.style.zIndex = "1", n.style.left = "0", n.style.top = "0", this.Oc = $1ff2b0a4ee3068d6$var$Gi(this.r_, new $1ff2b0a4ee3068d6$var$$i(16, 16)), this.Oc.subscribeCanvasConfigured(this.Ec);
        var h = this.Oc.canvas;
        h.style.position = "absolute", h.style.zIndex = "2", h.style.left = "0", h.style.top = "0", this.n_.appendChild(this.h_), this.n_.appendChild(this.Ac), this.n_.appendChild(this.s_), this.e_(), this.bv.ct().Ro().Zi(this.e_.bind(this), this), this.Uc = new $1ff2b0a4ee3068d6$var$hn(this.Oc.canvas, this, {
            Pf: !0,
            Ff: !1
        });
    }
    return t.prototype.rn = function() {
        this.Uc.rn(), null !== this.Qv && this.Qv.rn(), null !== this.t_ && this.t_.rn(), this.Oc.unsubscribeCanvasConfigured(this.Ec), this.Oc.destroy(), this.Vc.unsubscribeCanvasConfigured(this.Dc), this.Vc.destroy();
    }, t.prototype.qc = function() {
        return this.n_;
    }, t.prototype.u_ = function() {
        return this.Qv;
    }, t.prototype.a_ = function() {
        return this.t_;
    }, t.prototype.Kf = function(t) {
        if (!this.i_) {
            this.i_ = !0;
            var i = this.bv.ct();
            !i.U().Qt() && this.bv.I().handleScale.axisPressedMouseMove.time && i.Ul(t.ac);
        }
    }, t.prototype.$f = function() {
        var t = this.bv.ct();
        !t.U().Qt() && this.i_ && (this.i_ = !1, this.bv.I().handleScale.axisPressedMouseMove.time && t.Zl());
    }, t.prototype.If = function(t) {
        var i = this.bv.ct();
        !i.U().Qt() && this.bv.I().handleScale.axisPressedMouseMove.time && i.Xl(t.ac);
    }, t.prototype.jf = function(t) {
        this.i_ = !1;
        var i = this.bv.ct();
        i.U().Qt() && !this.bv.I().handleScale.axisPressedMouseMove.time || i.Zl();
    }, t.prototype.Uf = function() {
        this.bv.I().handleScale.axisDoubleClickReset && this.bv.ct().ke();
    }, t.prototype.Lf = function(t) {
        this.bv.ct().I().handleScale.axisPressedMouseMove.time && this.ev(1);
    }, t.prototype.nc = function(t) {
        this.ev(0);
    }, t.prototype.Iv = function() {
        return this.yc;
    }, t.prototype.o_ = function(t, i, n) {
        this.yc && this.yc.an(t) || (this.yc = t, this.Vc.resizeCanvas({
            width: t.ht,
            height: t.st
        }), this.Oc.resizeCanvas({
            width: t.ht,
            height: t.st
        }), this.Ac.style.width = t.ht + "px", this.Ac.style.height = t.st + "px"), null !== this.Qv && this.Qv.Zc(new $1ff2b0a4ee3068d6$var$$i(i, t.st)), null !== this.t_ && this.t_.Zc(new $1ff2b0a4ee3068d6$var$$i(n, t.st));
    }, t.prototype.l_ = function() {
        var t = this.f_();
        return Math.ceil(t.Dt + t.Ct + t.zt + t.Tt + t.Bt);
    }, t.prototype.V = function() {
        this.bv.ct().U().Ln();
    }, t.prototype.rv = function() {
        return this.Vc.canvas;
    }, t.prototype.Qc = function(t) {
        if (0 !== t) {
            if (1 !== t) {
                var i = $1ff2b0a4ee3068d6$var$Zi(this.Vc.canvas);
                this.iv(i, this.Vc.pixelRatio), this.fu(i, this.Vc.pixelRatio), this.nv(i, this.Vc.pixelRatio), null !== this.Qv && this.Qv.Qc(t), null !== this.t_ && this.t_.Qc(t);
            }
            var n = $1ff2b0a4ee3068d6$var$Zi(this.Oc.canvas), h = this.Oc.pixelRatio;
            n.clearRect(0, 0, Math.ceil(this.yc.ht * h), Math.ceil(this.yc.st * h)), this.c_([
                this.bv.ct().Il()
            ], n, h);
        }
    }, t.prototype.iv = function(t, i) {
        var n = this;
        $1ff2b0a4ee3068d6$var$z(t, i, function() {
            $1ff2b0a4ee3068d6$var$P(t, 0, 0, n.yc.ht, n.yc.st, n.Rv());
        });
    }, t.prototype.fu = function(t, i) {
        if (this.bv.I().timeScale.borderVisible) {
            t.save(), t.fillStyle = this.v_();
            var n = Math.max(1, Math.floor(this.f_().Dt * i));
            t.fillRect(0, 0, Math.ceil(this.yc.ht * i), n), t.restore();
        }
    }, t.prototype.nv = function(t, i) {
        var n = this, h = this.bv.ct().U().Ln();
        if (h && 0 !== h.length) {
            var s = h.reduce($1ff2b0a4ee3068d6$var$vn, h[0]).Fs;
            s > 30 && s < 40 && (s = 30), t.save(), t.strokeStyle = this.v_();
            var r = this.f_(), e = r.Dt + r.Ct + r.Tt + r.zt - r.Ot;
            t.textAlign = "center", t.fillStyle = this.v_();
            var u = Math.floor(this.f_().Dt * i), a = Math.max(1, Math.floor(i)), o = Math.floor(.5 * i);
            if (this.bv.ct().U().I().borderVisible) {
                t.beginPath();
                for(var l = Math.round(r.Ct * i), f = h.length; f--;){
                    var c = Math.round(h[f].Dn * i);
                    t.rect(c - o, u, a, l);
                }
                t.fill();
            }
            t.fillStyle = this.fe(), $1ff2b0a4ee3068d6$var$z(t, i, function() {
                t.font = n.__();
                for(var i = 0, r = h; i < r.length; i++)(o = r[i]).Fs < s && t.fillText(o.Tn, o.Dn, e);
                t.font = n.d_();
                for(var u = 0, a = h; u < a.length; u++){
                    var o;
                    (o = a[u]).Fs >= s && t.fillText(o.Tn, o.Dn, e);
                }
            });
        }
    }, t.prototype.c_ = function(t, i, n) {
        for(var h = this.f_(), s = 0, r = t; s < r.length; s++)for(var e = 0, u = r[s].vi(); e < u.length; e++){
            var a = u[e];
            i.save(), a.W().h(i, h, n), i.restore();
        }
    }, t.prototype.Rv = function() {
        return this.xi.backgroundColor;
    }, t.prototype.v_ = function() {
        return this.bv.I().timeScale.borderColor;
    }, t.prototype.fe = function() {
        return this.xi.textColor;
    }, t.prototype.oe = function() {
        return this.xi.fontSize;
    }, t.prototype.__ = function() {
        return $1ff2b0a4ee3068d6$var$zt(this.oe(), this.xi.fontFamily);
    }, t.prototype.d_ = function() {
        return $1ff2b0a4ee3068d6$var$zt(this.oe(), this.xi.fontFamily, "bold");
    }, t.prototype.f_ = function() {
        null === this.ue && (this.ue = {
            Dt: 1,
            Ot: NaN,
            Tt: NaN,
            Bt: NaN,
            ni: NaN,
            Ct: 3,
            zt: NaN,
            xt: "",
            ii: new $1ff2b0a4ee3068d6$var$oi
        });
        var t = this.ue, i = this.__();
        if (t.xt !== i) {
            var n = this.oe();
            t.zt = n, t.xt = i, t.Tt = Math.ceil(n / 2.5), t.Bt = t.Tt, t.ni = Math.ceil(n / 2), t.Ot = Math.round(this.oe() / 5), t.ii.Nu();
        }
        return this.ue;
    }, t.prototype.ev = function(t) {
        this.Ac.style.cursor = 1 === t ? "ew-resize" : "default";
    }, t.prototype.e_ = function() {
        var t = this.bv.ct(), i = t.I();
        i.leftPriceScale.visible || null === this.Qv || (this.h_.removeChild(this.Qv.qc()), this.Qv.rn(), this.Qv = null), i.rightPriceScale.visible || null === this.t_ || (this.s_.removeChild(this.t_.qc()), this.t_.rn(), this.t_ = null);
        var n = {
            if: this.bv.ct().if()
        };
        if (i.leftPriceScale.visible && null === this.Qv) {
            var h = function() {
                return i.leftPriceScale.borderVisible && t.U().I().borderVisible;
            };
            this.Qv = new $1ff2b0a4ee3068d6$var$cn("left", this.bv.I(), n, h), this.h_.appendChild(this.Qv.qc());
        }
        if (i.rightPriceScale.visible && null === this.t_) {
            h = function() {
                return i.rightPriceScale.borderVisible && t.U().I().borderVisible;
            };
            this.t_ = new $1ff2b0a4ee3068d6$var$cn("right", this.bv.I(), n, h), this.s_.appendChild(this.t_.qc());
        }
    }, t;
}(), $1ff2b0a4ee3068d6$var$dn = function() {
    function t(t, i) {
        var n;
        this.w_ = [], this.M_ = 0, this.An = 0, this.Ys = 0, this.b_ = 0, this.m_ = 0, this.g_ = null, this.p_ = !1, this.fv = new $1ff2b0a4ee3068d6$var$J, this.kl = new $1ff2b0a4ee3068d6$var$J, this.xi = i, this.n_ = document.createElement("div"), this.n_.classList.add("tv-lightweight-charts"), this.n_.style.overflow = "hidden", this.n_.style.width = "100%", this.n_.style.height = "100%", (n = this.n_).style.userSelect = "none", n.style.webkitUserSelect = "none", n.style.msUserSelect = "none", n.style.MozUserSelect = "none", n.style.webkitTapHighlightColor = "transparent", this.y_ = document.createElement("table"), this.y_.setAttribute("cellspacing", "0"), this.n_.appendChild(this.y_), this.k_ = this.x_.bind(this), this.n_.addEventListener("wheel", this.k_, {
            passive: !1
        }), this.hi = new $1ff2b0a4ee3068d6$var$Ki(this.xl.bind(this), this.xi), this.ct().Wl().Zi(this.N_.bind(this), this), this.S_ = new $1ff2b0a4ee3068d6$var$_n(this), this.y_.appendChild(this.S_.qc());
        var h = this.xi.width, s = this.xi.height;
        if (0 === h || 0 === s) {
            var r = t.getBoundingClientRect();
            0 === h && (h = Math.floor(r.width), h -= h % 2), 0 === s && (s = Math.floor(r.height), s -= s % 2);
        }
        this.C_(h, s), this.D_(), t.appendChild(this.n_), this.T_(), this.hi.U().Xr().Zi(this.hi.Tl.bind(this.hi), this), this.hi.Ro().Zi(this.hi.Tl.bind(this.hi), this);
    }
    return t.prototype.ct = function() {
        return this.hi;
    }, t.prototype.I = function() {
        return this.xi;
    }, t.prototype.B_ = function() {
        return this.w_;
    }, t.prototype.rn = function() {
        this.n_.removeEventListener("wheel", this.k_), 0 !== this.M_ && window.cancelAnimationFrame(this.M_), this.hi.Wl().nn(this), this.hi.U().Xr().nn(this), this.hi.Ro().nn(this), this.hi.rn();
        for(var t = 0, i = this.w_; t < i.length; t++){
            var n = i[t];
            this.y_.removeChild(n.qc()), n.zv().nn(this), n.rn();
        }
        this.w_ = [], $1ff2b0a4ee3068d6$var$f(this.S_).rn(), null !== this.n_.parentElement && this.n_.parentElement.removeChild(this.n_), this.kl.rn(), this.fv.rn();
    }, t.prototype.C_ = function(t, i, n) {
        if (void 0 === n && (n = !1), this.An !== i || this.Ys !== t) {
            this.An = i, this.Ys = t;
            var h = i + "px", s = t + "px";
            $1ff2b0a4ee3068d6$var$f(this.n_).style.height = h, $1ff2b0a4ee3068d6$var$f(this.n_).style.width = s, this.y_.style.height = h, this.y_.style.width = s, n ? this.E_(new $1ff2b0a4ee3068d6$var$It(3)) : this.hi.Tl();
        }
    }, t.prototype.Qc = function(t) {
        void 0 === t && (t = new $1ff2b0a4ee3068d6$var$It(3));
        for(var i = 0; i < this.w_.length; i++)this.w_[i].Qc(t.me(i).Me);
        this.S_.Qc(t.be());
    }, t.prototype.hh = function(t) {
        this.hi.hh(t), this.T_();
        var i = t.width || this.Ys, n = t.height || this.An;
        this.C_(i, n);
    }, t.prototype.zv = function() {
        return this.fv;
    }, t.prototype.Wl = function() {
        return this.kl;
    }, t.prototype.L_ = function() {
        var t = this;
        null !== this.g_ && (this.E_(this.g_), this.g_ = null);
        var i = this.w_[0], n = $1ff2b0a4ee3068d6$var$Ji(document, new $1ff2b0a4ee3068d6$var$$i(this.Ys, this.An)), h = $1ff2b0a4ee3068d6$var$Zi(n), s = $1ff2b0a4ee3068d6$var$Xi(n);
        return $1ff2b0a4ee3068d6$var$z(h, s, function() {
            var n = 0, s = 0, r = function(i) {
                for(var r = 0; r < t.w_.length; r++){
                    var e = t.w_[r], u = e.Iv().st, a = $1ff2b0a4ee3068d6$var$f("left" === i ? e.Yv() : e.Kv()), o = a.rv();
                    h.drawImage(o, n, s, a.Jc(), u), s += u;
                }
            };
            t.A_() && (r("left"), n = $1ff2b0a4ee3068d6$var$f(i.Yv()).Jc()), s = 0;
            for(var e = 0; e < t.w_.length; e++){
                var u = t.w_[e], a = u.Iv(), o = u.rv();
                h.drawImage(o, n, s, a.ht, a.st), s += a.st;
            }
            n += i.Iv().ht, t.V_() && (s = 0, r("right"));
            var l = function(i) {
                var r = $1ff2b0a4ee3068d6$var$f("left" === i ? t.S_.u_() : t.S_.a_()), e = r.Iv(), u = r.rv();
                h.drawImage(u, n, s, e.ht, e.st);
            };
            if (t.xi.timeScale.visible) {
                n = 0, t.A_() && (l("left"), n = $1ff2b0a4ee3068d6$var$f(i.Yv()).Jc());
                var c = t.S_.Iv();
                o = t.S_.rv();
                h.drawImage(o, n, s, c.ht, c.st), t.V_() && (n = i.Iv().ht, l("right"), h.restore());
            }
        }), n;
    }, t.prototype.O_ = function(t) {
        return "none" === t ? 0 : ("left" !== t || this.A_()) && ("right" !== t || this.V_()) ? 0 === this.w_.length ? 0 : $1ff2b0a4ee3068d6$var$f("left" === t ? this.w_[0].Yv() : this.w_[0].Kv()).Jc() : 0;
    }, t.prototype.z_ = function() {
        for(var t = 0, i = 0, n = 0, h = 0, s = this.w_; h < s.length; h++){
            var r = s[h];
            this.A_() && (i = Math.max(i, $1ff2b0a4ee3068d6$var$f(r.Yv()).$c())), this.V_() && (n = Math.max(n, $1ff2b0a4ee3068d6$var$f(r.Kv()).$c())), t += r.jo();
        }
        var e = this.Ys, u = this.An, a = Math.max(e - i - n, 0), o = this.xi.timeScale.visible ? this.S_.l_() : 0;
        o % 2 && (o += 1);
        for(var l = 0 + o, c = u < l ? 0 : u - l, v = c / t, _ = 0, d = 0; d < this.w_.length; ++d){
            (r = this.w_[d]).Nv(this.hi.Pl()[d]);
            var w, M = 0;
            M = d === this.w_.length - 1 ? c - _ : Math.round(r.jo() * v), _ += w = Math.max(M, 2), r.Zc(new $1ff2b0a4ee3068d6$var$$i(a, w)), this.A_() && r.Fv(i, "left"), this.V_() && r.Fv(n, "right"), r.Gc() && this.hi.Rl(r.Gc(), w);
        }
        this.S_.o_(new $1ff2b0a4ee3068d6$var$$i(a, o), i, n), this.hi.Cr(a), this.b_ !== i && (this.b_ = i), this.m_ !== n && (this.m_ = n);
    }, t.prototype.x_ = function(t) {
        var i = t.deltaX / 100, n = -t.deltaY / 100;
        if (0 !== i && this.xi.handleScroll.mouseWheel || 0 !== n && this.xi.handleScale.mouseWheel) {
            switch(t.cancelable && t.preventDefault(), t.deltaMode){
                case t.DOM_DELTA_PAGE:
                    i *= 120, n *= 120;
                    break;
                case t.DOM_DELTA_LINE:
                    i *= 32, n *= 32;
            }
            if (0 !== n && this.xi.handleScale.mouseWheel) {
                var h = Math.sign(n) * Math.min(1, Math.abs(n)), s = t.clientX - this.n_.getBoundingClientRect().left;
                this.ct().ql(s, h);
            }
            0 !== i && this.xi.handleScroll.mouseWheel && this.ct().Hl(-80 * i);
        }
    }, t.prototype.E_ = function(t) {
        var i = t.be();
        if (3 === i && this.P_(), 3 === i || 2 === i) {
            for(var n = this.hi.Pl(), h = 0; h < n.length; h++)t.me(h).fh && n[h].rl();
            for(var s = t.xe(), r = 0, e = s; r < e.length; r++){
                var u = e[r];
                this.Ne(u);
            }
            s.length > 0 && (this.hi.Or(), this.hi.ro(), this.hi.zr()), this.S_.V();
        }
        this.Qc(t);
    }, t.prototype.Ne = function(t) {
        var i = this.hi.U();
        switch(t.pe){
            case 0:
                i.Jr();
                break;
            case 1:
                i.Gr(t.J);
                break;
            case 2:
                i._r(t.J);
                break;
            case 3:
                i.dr(t.J);
                break;
            case 4:
                i.Wr();
        }
    }, t.prototype.xl = function(t) {
        var i = this;
        null !== this.g_ ? this.g_.vn(t) : this.g_ = t, this.p_ || (this.p_ = !0, this.M_ = window.requestAnimationFrame(function() {
            i.p_ = !1, i.M_ = 0, null !== i.g_ && (i.E_(i.g_), i.g_ = null);
        }));
    }, t.prototype.P_ = function() {
        this.D_();
    }, t.prototype.D_ = function() {
        for(var t = this.hi.Pl(), i = t.length, n = this.w_.length, h = i; h < n; h++){
            var s = $1ff2b0a4ee3068d6$var$l(this.w_.pop());
            this.y_.removeChild(s.qc()), s.zv().nn(this), s.rn();
        }
        for(h = n; h < i; h++)(s = new $1ff2b0a4ee3068d6$var$fn(this, t[h])).zv().Zi(this.F_.bind(this), this), this.w_.push(s), this.y_.insertBefore(s.qc(), this.S_.qc());
        for(h = 0; h < i; h++){
            var r = t[h];
            (s = this.w_[h]).Gc() !== r ? s.Nv(r) : s.xv();
        }
        this.T_(), this.z_();
    }, t.prototype.I_ = function(t, i) {
        var n, h = new Map;
        null !== t && this.hi.O().forEach(function(i) {
            var n = i.ta(t);
            null !== n && h.set(i, n);
        });
        if (null !== t) {
            var s = this.hi.U().si(t);
            null !== s && (n = s);
        }
        var r = this.ct().Ll(), e = null !== r && r.Vl instanceof $1ff2b0a4ee3068d6$var$Fi ? r.Vl : void 0, u = null !== r && void 0 !== r.Bv ? r.Bv.Uu : void 0;
        return {
            P: n,
            W_: i || void 0,
            R_: e,
            j_: h,
            U_: u
        };
    }, t.prototype.F_ = function(t, i) {
        var n = this;
        this.fv.hn(function() {
            return n.I_(t, i);
        });
    }, t.prototype.N_ = function(t, i) {
        var n = this;
        this.kl.hn(function() {
            return n.I_(t, i);
        });
    }, t.prototype.T_ = function() {
        var t = this.xi.timeScale.visible ? "" : "none";
        this.S_.qc().style.display = t;
    }, t.prototype.A_ = function() {
        return this.xi.leftPriceScale.visible;
    }, t.prototype.V_ = function() {
        return this.xi.rightPriceScale.visible;
    }, t;
}();
function $1ff2b0a4ee3068d6$var$wn(t, i, n) {
    var h = n.value, s = {
        Ps: i,
        P: t,
        J: [
            h,
            h,
            h,
            h
        ]
    };
    return "color" in n && void 0 !== n.color && (s.et = n.color), s;
}
function $1ff2b0a4ee3068d6$var$Mn(t, i, n) {
    return {
        Ps: i,
        P: t,
        J: [
            n.open,
            n.high,
            n.low,
            n.close
        ]
    };
}
function $1ff2b0a4ee3068d6$var$bn(t) {
    return void 0 !== t.J;
}
function $1ff2b0a4ee3068d6$var$mn(t) {
    return function(i, n, h) {
        var s;
        return void 0 === (s = h).open && void 0 === s.value ? {
            P: i,
            Ps: n
        } : t(i, n, h);
    };
}
var $1ff2b0a4ee3068d6$var$gn = {
    Candlestick: $1ff2b0a4ee3068d6$var$mn($1ff2b0a4ee3068d6$var$Mn),
    Bar: $1ff2b0a4ee3068d6$var$mn($1ff2b0a4ee3068d6$var$Mn),
    Area: $1ff2b0a4ee3068d6$var$mn($1ff2b0a4ee3068d6$var$wn),
    Histogram: $1ff2b0a4ee3068d6$var$mn($1ff2b0a4ee3068d6$var$wn),
    Line: $1ff2b0a4ee3068d6$var$mn($1ff2b0a4ee3068d6$var$wn)
};
function $1ff2b0a4ee3068d6$var$pn(t) {
    return $1ff2b0a4ee3068d6$var$gn[t];
}
function $1ff2b0a4ee3068d6$var$yn(t) {
    return 60 * t * 60000;
}
function $1ff2b0a4ee3068d6$var$kn(t) {
    return 60 * t * 1e3;
}
var $1ff2b0a4ee3068d6$var$xn, $1ff2b0a4ee3068d6$var$Nn = [
    {
        q_: 1,
        Fs: 20
    },
    {
        q_: ($1ff2b0a4ee3068d6$var$xn = 1, 1e3 * $1ff2b0a4ee3068d6$var$xn),
        Fs: 19
    },
    {
        q_: $1ff2b0a4ee3068d6$var$kn(1),
        Fs: 20
    },
    {
        q_: $1ff2b0a4ee3068d6$var$kn(5),
        Fs: 21
    },
    {
        q_: $1ff2b0a4ee3068d6$var$kn(30),
        Fs: 22
    },
    {
        q_: $1ff2b0a4ee3068d6$var$yn(1),
        Fs: 30
    },
    {
        q_: $1ff2b0a4ee3068d6$var$yn(3),
        Fs: 31
    },
    {
        q_: $1ff2b0a4ee3068d6$var$yn(6),
        Fs: 32
    },
    {
        q_: $1ff2b0a4ee3068d6$var$yn(12),
        Fs: 33
    }
];
function $1ff2b0a4ee3068d6$var$Sn(t, i) {
    if (null !== i) {
        var n = new Date(1e3 * i), h = new Date(1e3 * t);
        if (h.getUTCFullYear() !== n.getUTCFullYear()) return 70;
        if (h.getUTCMonth() !== n.getUTCMonth()) return 60;
        if (h.getUTCDate() !== n.getUTCDate()) return 50;
        for(var s = $1ff2b0a4ee3068d6$var$Nn.length - 1; s >= 0; --s)if (Math.floor(n.getTime() / $1ff2b0a4ee3068d6$var$Nn[s].q_) !== Math.floor(h.getTime() / $1ff2b0a4ee3068d6$var$Nn[s].q_)) return $1ff2b0a4ee3068d6$var$Nn[s].Fs;
    }
    return 20;
}
function $1ff2b0a4ee3068d6$var$Cn(t) {
    if (!$1ff2b0a4ee3068d6$export$45e4facdeecbf8d7(t)) throw new Error("time must be of type BusinessDay");
    var i = new Date(Date.UTC(t.year, t.month - 1, t.day, 0, 0, 0, 0));
    return {
        Cs: Math.round(i.getTime() / 1e3),
        Ss: t
    };
}
function $1ff2b0a4ee3068d6$var$Dn(t) {
    if (!$1ff2b0a4ee3068d6$export$d45648b9f1f4eae6(t)) throw new Error("time must be of type isUTCTimestamp");
    return {
        Cs: t
    };
}
function $1ff2b0a4ee3068d6$var$Tn(t) {
    return 0 === t.length ? null : $1ff2b0a4ee3068d6$export$45e4facdeecbf8d7(t[0].time) ? $1ff2b0a4ee3068d6$var$Cn : $1ff2b0a4ee3068d6$var$Dn;
}
function $1ff2b0a4ee3068d6$var$Bn(t) {
    return $1ff2b0a4ee3068d6$export$d45648b9f1f4eae6(t) ? $1ff2b0a4ee3068d6$var$Dn(t) : $1ff2b0a4ee3068d6$export$45e4facdeecbf8d7(t) ? $1ff2b0a4ee3068d6$var$Cn(t) : $1ff2b0a4ee3068d6$var$Cn($1ff2b0a4ee3068d6$var$En(t));
}
function $1ff2b0a4ee3068d6$var$En(t) {
    var i = new Date(t);
    if (isNaN(i.getTime())) throw new Error("Invalid date string=" + t + ", expected format=yyyy-mm-dd");
    return {
        day: i.getUTCDate(),
        month: i.getUTCMonth() + 1,
        year: i.getUTCFullYear()
    };
}
function $1ff2b0a4ee3068d6$var$Ln(t) {
    $1ff2b0a4ee3068d6$var$w(t.time) && (t.time = $1ff2b0a4ee3068d6$var$En(t.time));
}
function $1ff2b0a4ee3068d6$var$An(t) {
    return {
        Ps: 0,
        H_: new Map,
        Fh: t
    };
}
var $1ff2b0a4ee3068d6$var$Vn = function() {
    function t() {
        this.Y_ = new Map, this.K_ = new Map, this.X_ = new Map, this.Z_ = [];
    }
    return t.prototype.rn = function() {
        this.Y_.clear(), this.K_.clear(), this.X_.clear(), this.Z_ = [];
    }, t.prototype.J_ = function(t, i) {
        var n = this;
        this.X_.has(t) && this.Y_.forEach(function(i) {
            return i.H_.delete(t);
        });
        var h = [];
        if (0 !== i.length) {
            !function(t) {
                t.forEach($1ff2b0a4ee3068d6$var$Ln);
            }(i);
            var s = $1ff2b0a4ee3068d6$var$f($1ff2b0a4ee3068d6$var$Tn(i)), r = $1ff2b0a4ee3068d6$var$pn(t.da());
            h = i.map(function(i) {
                var h = s(i.time), e = n.Y_.get(h.Cs);
                void 0 === e && (e = $1ff2b0a4ee3068d6$var$An(h), n.Y_.set(h.Cs, e));
                var u = r(h, e.Ps, i);
                return e.H_.set(t, u), u;
            });
        }
        return this.G_(), this.Q_(t, h), this.td(t);
    }, t.prototype.sf = function(t) {
        return this.J_(t, []);
    }, t.prototype.nd = function(t, i) {
        $1ff2b0a4ee3068d6$var$Ln(i);
        var n = $1ff2b0a4ee3068d6$var$f($1ff2b0a4ee3068d6$var$Tn([
            i
        ]))(i.time), h = this.X_.get(t);
        if (void 0 !== h && n.Cs < h.Cs) throw new Error("Cannot update oldest data, last time=" + h.Cs + ", new time=" + n.Cs);
        var s = this.Y_.get(n.Cs), r = void 0 === s;
        void 0 === s && (s = $1ff2b0a4ee3068d6$var$An(n), this.Y_.set(n.Cs, s));
        var e = $1ff2b0a4ee3068d6$var$pn(t.da())(n, s.Ps, i);
        s.H_.set(t, e);
        var u = this.hd(t, e);
        if (!r) {
            var a = new Map;
            return null !== u && a.set(t, u), {
                sd: a,
                U: {
                    Er: this.rd()
                }
            };
        }
        return this.td(t);
    }, t.prototype.hd = function(t, i) {
        var n = this.K_.get(t);
        void 0 === n && (n = [], this.K_.set(t, n));
        var h = 0 !== n.length ? n[n.length - 1] : null, s = null;
        return null === h || i.P.Cs > h.P.Cs ? $1ff2b0a4ee3068d6$var$bn(i) && (n.push(i), s = {
            Tl: !1,
            ed: [
                i
            ]
        }) : $1ff2b0a4ee3068d6$var$bn(i) ? (n[n.length - 1] = i, s = {
            Tl: !1,
            ed: [
                i
            ]
        }) : (n.splice(-1, 1), s = {
            Tl: !0,
            ed: n
        }), this.X_.set(t, i.P), s;
    }, t.prototype.Q_ = function(t, i) {
        0 !== i.length ? (this.K_.set(t, i.filter($1ff2b0a4ee3068d6$var$bn)), this.X_.set(t, i[i.length - 1].P)) : (this.K_.delete(t), this.X_.delete(t));
    }, t.prototype.G_ = function() {
        var t = new Map;
        this.Y_.forEach(function(i, n) {
            i.H_.size > 0 && t.set(n, i);
        }), this.Y_ = t;
    }, t.prototype.ud = function(t) {
        for(var i = -1, n = 0; n < this.Z_.length && n < t.length; ++n){
            var h = this.Z_[n], s = t[n];
            if (h.P.Cs !== s.P.Cs) {
                i = n;
                break;
            }
            s.zs = h.zs;
        }
        if (-1 === i && this.Z_.length !== t.length && (i = Math.min(this.Z_.length, t.length)), -1 === i) return -1;
        var r = function(i) {
            var n = $1ff2b0a4ee3068d6$var$l(e.Y_.get(t[i].P.Cs));
            n.Ps = i, n.H_.forEach(function(t) {
                t.Ps = i;
            });
        }, e = this;
        for(n = i; n < t.length; ++n)r(n);
        return function(t, i) {
            void 0 === i && (i = 0);
            for(var n = 0 === i || 0 === t.length ? null : t[i - 1].P.Cs, h = 0, s = i; s < t.length; ++s){
                var r = t[s];
                r.zs = $1ff2b0a4ee3068d6$var$Sn(r.P.Cs, n), h += r.P.Cs - (n || r.P.Cs), n = r.P.Cs;
            }
            if (0 === i && t.length > 1) {
                var e = Math.ceil(h / (t.length - 1)), u = t[0].P.Cs - e;
                t[0].zs = $1ff2b0a4ee3068d6$var$Sn(t[0].P.Cs, u);
            }
        }(t, i), this.Z_ = t, i;
    }, t.prototype.rd = function() {
        if (0 === this.K_.size) return null;
        var t = 0;
        return this.K_.forEach(function(i) {
            0 !== i.length && (t = Math.max(t, i[i.length - 1].Ps));
        }), t;
    }, t.prototype.td = function(t) {
        var i = Array.from(this.Y_.values()).map(function(t) {
            return {
                zs: 0,
                P: t.Fh
            };
        });
        i.sort(function(t, i) {
            return t.P.Cs - i.P.Cs;
        });
        var n = this.ud(i), h = {
            sd: new Map,
            U: {
                Er: this.rd()
            }
        };
        if (-1 !== n) this.K_.forEach(function(t, i) {
            h.sd.set(i, {
                ed: t,
                Tl: !0
            });
        }), this.K_.has(t) || h.sd.set(t, {
            ed: [],
            Tl: !0
        }), h.U.ad = this.Z_;
        else {
            var s = this.K_.get(t);
            h.sd.set(t, {
                ed: s || [],
                Tl: !0
            });
        }
        return h;
    }, t;
}();
var $1ff2b0a4ee3068d6$var$On = {
    color: "#FF0000",
    price: 0,
    lineStyle: 2,
    lineWidth: 1,
    axisLabelVisible: !0,
    title: ""
}, $1ff2b0a4ee3068d6$var$zn = function() {
    function t(t) {
        this.la = t;
    }
    return t.prototype.applyOptions = function(t) {
        this.la.hh(t);
    }, t.prototype.options = function() {
        return this.la.I();
    }, t.prototype.od = function() {
        return this.la;
    }, t;
}();
function $1ff2b0a4ee3068d6$var$Pn(t) {
    var i = t.overlay, n = function(t, i) {
        var n = {};
        for(var h in t)Object.prototype.hasOwnProperty.call(t, h) && i.indexOf(h) < 0 && (n[h] = t[h]);
        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var s = 0;
            for(h = Object.getOwnPropertySymbols(t); s < h.length; s++)i.indexOf(h[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, h[s]) && (n[h[s]] = t[h[s]]);
        }
        return n;
    }(t, [
        "overlay"
    ]);
    return i && (n.priceScaleId = ""), n;
}
var $1ff2b0a4ee3068d6$var$Fn = function() {
    function t(t, i, n) {
        this.Fe = t, this.ld = i, this.fd = n;
    }
    return t.prototype.priceFormatter = function() {
        return this.Fe.Yh();
    }, t.prototype.priceToCoordinate = function(t) {
        var i = this.Fe.Y();
        return null === i ? null : this.Fe.Z().X(t, i.J);
    }, t.prototype.coordinateToPrice = function(t) {
        var i = this.Fe.Y();
        return null === i ? null : this.Fe.Z().Di(t, i.J);
    }, t.prototype.barsInLogicalRange = function(t) {
        if (null === t) return null;
        var i = new $1ff2b0a4ee3068d6$var$Et(new $1ff2b0a4ee3068d6$var$Ct(t.from, t.to)).Us(), n = this.Fe.qi();
        if (n.Qt()) return null;
        var h = n.Ea(i.hs(), 1), s = n.Ea(i.ss(), -1), r = $1ff2b0a4ee3068d6$var$f(n.Da()), e = $1ff2b0a4ee3068d6$var$f(n.Ui());
        if (null !== h && null !== s && h.Ps > s.Ps) return {
            barsBefore: t.from - r,
            barsAfter: e - t.to
        };
        var u = {
            barsBefore: null === h || h.Ps === r ? t.from - r : h.Ps - r,
            barsAfter: null === s || s.Ps === e ? e - t.to : e - s.Ps
        };
        return null !== h && null !== s && (u.from = h.P.Ss || h.P.Cs, u.to = s.P.Ss || s.P.Cs), u;
    }, t.prototype.setData = function(t) {
        this.Fe.da(), this.ld.vd(this.Fe, t);
    }, t.prototype.update = function(t) {
        this.Fe.da(), this.ld.uo(this.Fe, t);
    }, t.prototype.setMarkers = function(t) {
        var i = t.map(function(t) {
            return $1ff2b0a4ee3068d6$var$u($1ff2b0a4ee3068d6$var$u({}, t), {
                time: $1ff2b0a4ee3068d6$var$Bn(t.time)
            });
        });
        this.Fe.lo(i);
    }, t.prototype.applyOptions = function(t) {
        var i = $1ff2b0a4ee3068d6$var$Pn(t);
        this.Fe.hh(i);
    }, t.prototype.options = function() {
        return $1ff2b0a4ee3068d6$var$b(this.Fe.I());
    }, t.prototype.priceScale = function() {
        return this.fd.priceScale(this.Fe.Z().nh());
    }, t.prototype.createPriceLine = function(t) {
        var i = $1ff2b0a4ee3068d6$var$v($1ff2b0a4ee3068d6$var$b($1ff2b0a4ee3068d6$var$On), t), n = this.Fe.fo(i);
        return new $1ff2b0a4ee3068d6$var$zn(n);
    }, t.prototype.removePriceLine = function(t) {
        this.Fe.co(t.od());
    }, t.prototype.seriesType = function() {
        return this.Fe.da();
    }, t;
}(), $1ff2b0a4ee3068d6$var$In = function(t) {
    function i() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $1ff2b0a4ee3068d6$var$e(i, t), i.prototype.applyOptions = function(i) {
        $1ff2b0a4ee3068d6$var$mt(i), t.prototype.applyOptions.call(this, i);
    }, i;
}($1ff2b0a4ee3068d6$var$Fn), $1ff2b0a4ee3068d6$var$Wn = {
    autoScale: !0,
    mode: 0,
    invertScale: !1,
    alignLabels: !0,
    borderVisible: !0,
    borderColor: "#2B2B43",
    entireTextOnly: !1,
    visible: !1,
    drawTicks: !0,
    scaleMargins: {
        bottom: .1,
        top: .2
    }
}, $1ff2b0a4ee3068d6$var$Rn = {
    color: "rgba(0, 0, 0, 0)",
    visible: !1,
    fontSize: 48,
    fontFamily: $1ff2b0a4ee3068d6$var$Ot,
    fontStyle: "",
    text: "",
    horzAlign: "center",
    vertAlign: "center"
}, $1ff2b0a4ee3068d6$var$jn = {
    width: 0,
    height: 0,
    layout: {
        backgroundColor: "#FFFFFF",
        textColor: "#191919",
        fontSize: 11,
        fontFamily: $1ff2b0a4ee3068d6$var$Ot
    },
    crosshair: {
        vertLine: {
            color: "#758696",
            width: 1,
            style: 3,
            visible: !0,
            labelVisible: !0,
            labelBackgroundColor: "#4c525e"
        },
        horzLine: {
            color: "#758696",
            width: 1,
            style: 3,
            visible: !0,
            labelVisible: !0,
            labelBackgroundColor: "#4c525e"
        },
        mode: 1
    },
    grid: {
        vertLines: {
            color: "#D6DCDE",
            style: 0,
            visible: !0
        },
        horzLines: {
            color: "#D6DCDE",
            style: 0,
            visible: !0
        }
    },
    overlayPriceScales: $1ff2b0a4ee3068d6$var$u({}, $1ff2b0a4ee3068d6$var$Wn),
    leftPriceScale: $1ff2b0a4ee3068d6$var$u($1ff2b0a4ee3068d6$var$u({}, $1ff2b0a4ee3068d6$var$Wn), {
        visible: !1
    }),
    rightPriceScale: $1ff2b0a4ee3068d6$var$u($1ff2b0a4ee3068d6$var$u({}, $1ff2b0a4ee3068d6$var$Wn), {
        visible: !0
    }),
    timeScale: {
        rightOffset: 0,
        barSpacing: 6,
        minBarSpacing: .5,
        fixLeftEdge: !1,
        fixRightEdge: !1,
        lockVisibleTimeRangeOnResize: !1,
        rightBarStaysOnScroll: !1,
        borderVisible: !0,
        borderColor: "#2B2B43",
        visible: !0,
        timeVisible: !1,
        secondsVisible: !0,
        shiftVisibleRangeOnNewBar: !0
    },
    watermark: $1ff2b0a4ee3068d6$var$Rn,
    localization: {
        locale: $1ff2b0a4ee3068d6$var$Qi ? navigator.language : "",
        dateFormat: "dd MMM 'yy"
    },
    handleScroll: {
        mouseWheel: !0,
        pressedMouseMove: !0,
        horzTouchDrag: !0,
        vertTouchDrag: !0
    },
    handleScale: {
        axisPressedMouseMove: {
            time: !0,
            price: !0
        },
        axisDoubleClickReset: !0,
        mouseWheel: !0,
        pinch: !0
    }
}, $1ff2b0a4ee3068d6$var$Un = {
    upColor: "#26a69a",
    downColor: "#ef5350",
    wickVisible: !0,
    borderVisible: !0,
    borderColor: "#378658",
    borderUpColor: "#26a69a",
    borderDownColor: "#ef5350",
    wickColor: "#737375",
    wickUpColor: "#26a69a",
    wickDownColor: "#ef5350"
}, $1ff2b0a4ee3068d6$var$qn = {
    upColor: "#26a69a",
    downColor: "#ef5350",
    openVisible: !0,
    thinBars: !0
}, $1ff2b0a4ee3068d6$var$Hn = {
    color: "#2196f3",
    lineStyle: 0,
    lineWidth: 3,
    lineType: 0,
    crosshairMarkerVisible: !0,
    crosshairMarkerRadius: 4,
    crosshairMarkerBorderColor: "",
    crosshairMarkerBackgroundColor: ""
}, $1ff2b0a4ee3068d6$var$Yn = {
    topColor: "rgba( 46, 220, 135, 0.4)",
    bottomColor: "rgba( 40, 221, 100, 0)",
    lineColor: "#33D778",
    lineStyle: 0,
    lineWidth: 3,
    lineType: 0,
    crosshairMarkerVisible: !0,
    crosshairMarkerRadius: 4,
    crosshairMarkerBorderColor: "",
    crosshairMarkerBackgroundColor: ""
}, $1ff2b0a4ee3068d6$var$Kn = {
    color: "#26a69a",
    base: 0
}, $1ff2b0a4ee3068d6$var$$n = {
    title: "",
    visible: !0,
    lastValueVisible: !0,
    priceLineVisible: !0,
    priceLineSource: 0,
    priceLineWidth: 1,
    priceLineColor: "",
    priceLineStyle: 2,
    baseLineVisible: !0,
    baseLineWidth: 1,
    baseLineColor: "#B2B5BE",
    baseLineStyle: 0,
    priceFormat: {
        type: "price",
        precision: 2,
        minMove: .01
    }
}, $1ff2b0a4ee3068d6$var$Xn = function() {
    function t(t, i) {
        this._d = t, this.dd = i;
    }
    return t.prototype.applyOptions = function(t) {
        this._d.ct().Ol(this.dd, t);
    }, t.prototype.options = function() {
        return this.Jt().I();
    }, t.prototype.width = function() {
        return $1ff2b0a4ee3068d6$var$Ft(this.dd) ? this._d.O_("left" === this.dd ? "left" : "right") : 0;
    }, t.prototype.Jt = function() {
        return $1ff2b0a4ee3068d6$var$f(this._d.ct().zl(this.dd)).Z;
    }, t;
}(), $1ff2b0a4ee3068d6$var$Zn = function() {
    function t(t) {
        this.wd = new $1ff2b0a4ee3068d6$var$J, this.tr = new $1ff2b0a4ee3068d6$var$J, this.hi = t, this.Ao().Kr().Zi(this.Md.bind(this)), this.Ao().$r().Zi(this.bd.bind(this));
    }
    return t.prototype.rn = function() {
        this.Ao().Kr().nn(this), this.Ao().$r().nn(this), this.wd.rn();
    }, t.prototype.scrollPosition = function() {
        return this.Ao().Fr();
    }, t.prototype.scrollToPosition = function(t, i) {
        i ? this.Ao().Yr(t, 1e3) : this.hi.dr(t);
    }, t.prototype.scrollToRealTime = function() {
        this.Ao().Hr();
    }, t.prototype.getVisibleRange = function() {
        var t, i, n = this.Ao().gr();
        return null === n ? null : {
            from: null !== (t = n.from.Ss) && void 0 !== t ? t : n.from.Cs,
            to: null !== (i = n.to.Ss) && void 0 !== i ? i : n.to.Cs
        };
    }, t.prototype.setVisibleRange = function(t) {
        var i = {
            from: $1ff2b0a4ee3068d6$var$Bn(t.from),
            to: $1ff2b0a4ee3068d6$var$Bn(t.to)
        }, n = this.Ao().Nr(i);
        this.hi.rf(n);
    }, t.prototype.getVisibleLogicalRange = function() {
        var t = this.Ao().mr();
        return null === t ? null : {
            from: t.hs(),
            to: t.ss()
        };
    }, t.prototype.setVisibleLogicalRange = function(t) {
        $1ff2b0a4ee3068d6$var$o(t.from <= t.to, "The from index cannot be after the to index."), this.hi.rf(t);
    }, t.prototype.resetTimeScale = function() {
        this.hi.ke();
    }, t.prototype.fitContent = function() {
        this.hi.Jr();
    }, t.prototype.logicalToCoordinate = function(t) {
        var i = this.hi.U();
        return i.Qt() ? null : i.G(t);
    }, t.prototype.coordinateToLogical = function(t) {
        var i = this.hi.U();
        return i.Qt() ? null : i.Ar(t);
    }, t.prototype.timeToCoordinate = function(t) {
        var i = $1ff2b0a4ee3068d6$var$Bn(t), n = this.hi.U(), h = n.wr(i, !1);
        return null === h ? null : n.G(h);
    }, t.prototype.coordinateToTime = function(t) {
        var i, n = this.hi.U(), h = n.Ar(t), s = n.si(h);
        return null === s ? null : null !== (i = s.Ss) && void 0 !== i ? i : s.Cs;
    }, t.prototype.subscribeVisibleTimeRangeChange = function(t) {
        this.wd.Zi(t);
    }, t.prototype.unsubscribeVisibleTimeRangeChange = function(t) {
        this.wd.tn(t);
    }, t.prototype.subscribeVisibleLogicalRangeChange = function(t) {
        this.tr.Zi(t);
    }, t.prototype.unsubscribeVisibleLogicalRangeChange = function(t) {
        this.tr.tn(t);
    }, t.prototype.applyOptions = function(t) {
        this.Ao().hh(t);
    }, t.prototype.options = function() {
        return $1ff2b0a4ee3068d6$var$b(this.Ao().I());
    }, t.prototype.Ao = function() {
        return this.hi.U();
    }, t.prototype.Md = function() {
        this.wd.sn() && this.wd.hn(this.getVisibleRange());
    }, t.prototype.bd = function() {
        this.tr.sn() && this.tr.hn(this.getVisibleLogicalRange());
    }, t;
}();
function $1ff2b0a4ee3068d6$var$Jn(t) {
    if (void 0 !== t && "custom" !== t.type) {
        var i = t;
        void 0 !== i.minMove && void 0 === i.precision && (i.precision = function(t) {
            if (t >= 1) return 0;
            for(var i = 0; i < 8; i++){
                var n = Math.round(t);
                if (Math.abs(n - t) < 1e-8) return i;
                t *= 10;
            }
            return i;
        }(i.minMove));
    }
}
function $1ff2b0a4ee3068d6$var$Gn(t) {
    return function(t) {
        if ($1ff2b0a4ee3068d6$var$M(t.handleScale)) {
            var i = t.handleScale;
            t.handleScale = {
                axisDoubleClickReset: i,
                axisPressedMouseMove: {
                    time: i,
                    price: i
                },
                mouseWheel: i,
                pinch: i
            };
        } else if (void 0 !== t.handleScale && $1ff2b0a4ee3068d6$var$M(t.handleScale.axisPressedMouseMove)) {
            var n = t.handleScale.axisPressedMouseMove;
            t.handleScale.axisPressedMouseMove = {
                time: n,
                price: n
            };
        }
        var h = t.handleScroll;
        $1ff2b0a4ee3068d6$var$M(h) && (t.handleScroll = {
            horzTouchDrag: h,
            vertTouchDrag: h,
            mouseWheel: h,
            pressedMouseMove: h
        });
    }(t), function(t) {
        if (t.priceScale) {
            t.leftPriceScale = t.leftPriceScale || {}, t.rightPriceScale = t.rightPriceScale || {};
            var i = t.priceScale.position;
            delete t.priceScale.position, t.leftPriceScale = $1ff2b0a4ee3068d6$var$v(t.leftPriceScale, t.priceScale), t.rightPriceScale = $1ff2b0a4ee3068d6$var$v(t.rightPriceScale, t.priceScale), "left" === i && (t.leftPriceScale.visible = !0, t.rightPriceScale.visible = !1), "right" === i && (t.leftPriceScale.visible = !1, t.rightPriceScale.visible = !0), "none" === i && (t.leftPriceScale.visible = !1, t.rightPriceScale.visible = !1), t.overlayPriceScales = t.overlayPriceScales || {}, void 0 !== t.priceScale.invertScale && (t.overlayPriceScales.invertScale = t.priceScale.invertScale), void 0 !== t.priceScale.scaleMargins && (t.overlayPriceScales.scaleMargins = t.priceScale.scaleMargins);
        }
    }(t), t;
}
var $1ff2b0a4ee3068d6$var$Qn = function() {
    function t(t, i) {
        var n = this;
        this.md = new $1ff2b0a4ee3068d6$var$Vn, this.gd = new Map, this.pd = new Map, this.yd = new $1ff2b0a4ee3068d6$var$J, this.kd = new $1ff2b0a4ee3068d6$var$J;
        var h = void 0 === i ? $1ff2b0a4ee3068d6$var$b($1ff2b0a4ee3068d6$var$jn) : $1ff2b0a4ee3068d6$var$v($1ff2b0a4ee3068d6$var$b($1ff2b0a4ee3068d6$var$jn), $1ff2b0a4ee3068d6$var$Gn(i));
        this._d = new $1ff2b0a4ee3068d6$var$dn(t, h), this._d.zv().Zi(function(t) {
            n.yd.sn() && n.yd.hn(n.xd(t()));
        }, this), this._d.Wl().Zi(function(t) {
            n.kd.sn() && n.kd.hn(n.xd(t()));
        }, this);
        var s = this._d.ct();
        this.Nd = new $1ff2b0a4ee3068d6$var$Zn(s);
    }
    return t.prototype.remove = function() {
        this._d.zv().nn(this), this._d.Wl().nn(this), this.Nd.rn(), this._d.rn(), this.gd.clear(), this.pd.clear(), this.yd.rn(), this.kd.rn(), this.md.rn();
    }, t.prototype.resize = function(t, i, n) {
        this._d.C_(t, i, n);
    }, t.prototype.addAreaSeries = function(t) {
        void 0 === t && (t = {}), $1ff2b0a4ee3068d6$var$Jn((t = $1ff2b0a4ee3068d6$var$Pn(t)).priceFormat);
        var i = $1ff2b0a4ee3068d6$var$v($1ff2b0a4ee3068d6$var$b($1ff2b0a4ee3068d6$var$$n), $1ff2b0a4ee3068d6$var$Yn, t), n = this._d.ct().nf("Area", i), h = new $1ff2b0a4ee3068d6$var$Fn(n, this, this);
        return this.gd.set(h, n), this.pd.set(n, h), h;
    }, t.prototype.addBarSeries = function(t) {
        void 0 === t && (t = {}), $1ff2b0a4ee3068d6$var$Jn((t = $1ff2b0a4ee3068d6$var$Pn(t)).priceFormat);
        var i = $1ff2b0a4ee3068d6$var$v($1ff2b0a4ee3068d6$var$b($1ff2b0a4ee3068d6$var$$n), $1ff2b0a4ee3068d6$var$qn, t), n = this._d.ct().nf("Bar", i), h = new $1ff2b0a4ee3068d6$var$Fn(n, this, this);
        return this.gd.set(h, n), this.pd.set(n, h), h;
    }, t.prototype.addCandlestickSeries = function(t) {
        void 0 === t && (t = {}), $1ff2b0a4ee3068d6$var$mt(t = $1ff2b0a4ee3068d6$var$Pn(t)), $1ff2b0a4ee3068d6$var$Jn(t.priceFormat);
        var i = $1ff2b0a4ee3068d6$var$v($1ff2b0a4ee3068d6$var$b($1ff2b0a4ee3068d6$var$$n), $1ff2b0a4ee3068d6$var$Un, t), n = this._d.ct().nf("Candlestick", i), h = new $1ff2b0a4ee3068d6$var$In(n, this, this);
        return this.gd.set(h, n), this.pd.set(n, h), h;
    }, t.prototype.addHistogramSeries = function(t) {
        void 0 === t && (t = {}), $1ff2b0a4ee3068d6$var$Jn((t = $1ff2b0a4ee3068d6$var$Pn(t)).priceFormat);
        var i = $1ff2b0a4ee3068d6$var$v($1ff2b0a4ee3068d6$var$b($1ff2b0a4ee3068d6$var$$n), $1ff2b0a4ee3068d6$var$Kn, t), n = this._d.ct().nf("Histogram", i), h = new $1ff2b0a4ee3068d6$var$Fn(n, this, this);
        return this.gd.set(h, n), this.pd.set(n, h), h;
    }, t.prototype.addLineSeries = function(t) {
        void 0 === t && (t = {}), $1ff2b0a4ee3068d6$var$Jn((t = $1ff2b0a4ee3068d6$var$Pn(t)).priceFormat);
        var i = $1ff2b0a4ee3068d6$var$v($1ff2b0a4ee3068d6$var$b($1ff2b0a4ee3068d6$var$$n), $1ff2b0a4ee3068d6$var$Hn, t), n = this._d.ct().nf("Line", i), h = new $1ff2b0a4ee3068d6$var$Fn(n, this, this);
        return this.gd.set(h, n), this.pd.set(n, h), h;
    }, t.prototype.removeSeries = function(t) {
        var i = $1ff2b0a4ee3068d6$var$l(this.gd.get(t)), n = this.md.sf(i);
        this._d.ct().sf(i), this.Sd(n), this.gd.delete(t), this.pd.delete(i);
    }, t.prototype.vd = function(t, i) {
        this.Sd(this.md.J_(t, i));
    }, t.prototype.uo = function(t, i) {
        this.Sd(this.md.nd(t, i));
    }, t.prototype.subscribeClick = function(t) {
        this.yd.Zi(t);
    }, t.prototype.unsubscribeClick = function(t) {
        this.yd.tn(t);
    }, t.prototype.subscribeCrosshairMove = function(t) {
        this.kd.Zi(t);
    }, t.prototype.unsubscribeCrosshairMove = function(t) {
        this.kd.tn(t);
    }, t.prototype.priceScale = function(t) {
        return void 0 === t && (t = this._d.ct().ef()), new $1ff2b0a4ee3068d6$var$Xn(this._d, t);
    }, t.prototype.timeScale = function() {
        return this.Nd;
    }, t.prototype.applyOptions = function(t) {
        this._d.hh($1ff2b0a4ee3068d6$var$Gn(t));
    }, t.prototype.options = function() {
        return this._d.I();
    }, t.prototype.takeScreenshot = function() {
        return this._d.L_();
    }, t.prototype.Sd = function(t) {
        var i = this._d.ct();
        i.tf(t.U.Er, t.U.ad), t.sd.forEach(function(t, i) {
            return i.uo(t.ed, t.Tl);
        }), i.Or();
    }, t.prototype.Cd = function(t) {
        return $1ff2b0a4ee3068d6$var$l(this.pd.get(t));
    }, t.prototype.xd = function(t) {
        var i = this, n = new Map;
        t.j_.forEach(function(t, h) {
            n.set(i.Cd(h), t);
        });
        var h = void 0 === t.R_ ? void 0 : this.Cd(t.R_);
        return {
            time: t.P && (t.P.Ss || t.P.Cs),
            point: t.W_,
            hoveredSeries: h,
            hoveredMarkerId: t.U_,
            seriesPrices: n
        };
    }, t;
}();
function $1ff2b0a4ee3068d6$export$c870ec99876cb45c(t, i) {
    var n;
    if ($1ff2b0a4ee3068d6$var$w(t)) {
        var h = document.getElementById(t);
        $1ff2b0a4ee3068d6$var$o(null !== h, "Cannot find element in DOM with id=" + t), n = h;
    } else n = t;
    return new $1ff2b0a4ee3068d6$var$Qn(n, i);
}
function $1ff2b0a4ee3068d6$export$83d89fbfd8236492() {
    return "3.4.0";
}




var $fzZ9h = parcelRequire("fzZ9h");
class $9770131023f2f022$export$dfbd03a8873a1248 extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    constructor(initObj){
        super(initObj);
        //container_in.insertAdjacentHTML( 'beforeend' , factory2d.renderSync( 'timeseries', dat ) );
        var k = 3;
        var r = 2;
        var obj = initObj.data;
        var vnode = (0, $fzZ9h.factory2d).renderNodeSync('timeseries', obj.data);
        this.container = initObj.target;
        this.chart = (0, $1ff2b0a4ee3068d6$export$c870ec99876cb45c)(vnode.querySelector('#linechart'), {
            width: 660,
            height: 280
        });
        initObj.target.appendChild(vnode);
        var w = vnode.querySelector('#linechart').offsetWidth;
        var h = vnode.querySelector('#linechart').offsetWidth;
        this.chart.resize(w, 280);
        this.chart.applyOptions({
            grid: {
                vertLines: {
                    color: 'rgba(30, 30, 240, 1.0)',
                    style: 1,
                    visible: true
                },
                horzLines: {
                    color: 'rgba(70, 30, 250, 1.0)',
                    style: 1,
                    visible: true
                }
            },
            layout: {
                backgroundColor: '#1111FF33',
                textColor: '#CCCCEE'
            }
        });
        this.chart.applyOptions({
            priceScale: {
                //position: 'left',
                //mode: 2,
                autoScale: true,
                //invertScale: true,
                //alignLabels: false,
                //borderVisible: false,
                //borderColor: '#555ffd',
                scaleMargins: {
                    top: 0.30,
                    bottom: 0.25
                }
            }
        });
        var seg_arr = this.getGeneratedTimeSeries();
        this.lineSeries = this.chart.addLineSeries();
        //lineSeries.setData( seg_arr )
        // var moc_arr = [
        //     { time: '2019-02-11', value: 20.01 },
        //     { time: '2019-03-11', value: 40.01 },
        //     { time: '2019-04-11', value: 80.01 },
        //     { time: '2019-04-12', value: 96.63 },
        //     { time: '2019-04-13', value: 76.64 },
        //     { time: '2019-04-14', value: 81.89 },
        //     { time: '2019-04-15', value: 74.43 },
        //     { time: '2019-04-16', value: 80.01 },
        //     { time: '2019-04-17', value: 96.63 },
        //     { time: '2019-04-18', value: 76.64 },
        //     { time: '2019-04-19', value: 81.89 },
        //     { time: '2019-04-20', value: 74.43 },
        //     { time: '2019-04-21', value: 80.01 },
        //     { time: '2019-04-22', value: 96.63 },
        //     { time: '2019-04-23', value: 76.64 },
        //     { time: '2019-04-24', value: 81.89 },
        //     { time: '2019-04-25', value: 74.43 },
        //     { time: '2019-04-26', value: 80.01 },
        //     { time: '2019-04-27', value: 96.63 },
        //     { time: '2019-04-28', value: 76.64 },
        //     { time: '2019-04-29', value: 81.89 }
        // ]
        //this.lineSeries.setData(seg_arr );
        //this.chart.timeScale().fitContent();    
        var chart_conf_obj = {
            width: window.innerWidth - 100,
            height: window.innerHeight / 2,
            autoSize: true,
            rightPriceScale: {
                scaleMargins: {
                    top: 0.3,
                    bottom: 0.25
                }
            },
            layout: {
                backgroundColor: "#131722",
                textColor: "#d1d4dd",
                background: {
                    color: '#000000'
                }
            },
            grid: {
                vertLines: {
                    color: "rgba(42, 46, 57, 0)"
                },
                horzLines: {
                    color: "rgba(42, 46, 57, 0.6)"
                }
            },
            timeScale: {
                timeVisible: true,
                secondsVisible: true,
                fixLeftEdge: false,
                fixRightEdge: false,
                ticksVisible: true,
                minBarSpacing: 0.01 // Limits maximum zoom out so set this lower for birds eye on big dataset 
            }
        };
        var loadedFrame = {};
        var lineSeriesMap = {}; // Store references to LineSeries
        setInterval((function() {
            fetch('/jso').then((response)=>response.json()).then((function(newData) {
                var data = newData;
                //let chartContainer = document.getElementById('lightweight');
                //let chart = chartContainer.lightweightChart;
                var chart = this.chart;
                for(let key in data){
                    let lineSeries = lineSeriesMap[key];
                    if (!lineSeries) {
                        var clr;
                        try {
                            //clr = '#FF00FF' // 
                            //'#' + Math.floor(Math.random()*16777215).toString(16)
                            clr = '#' + ('00000' + (Math.random() * 16777216 | 0).toString(16)).slice(-6);
                        } catch (e) {
                            clr = '#FF00FF';
                        }
                        lineSeries = chart.addLineSeries({
                            title: key,
                            color: clr,
                            lineWidth: Math.random() * 1.9 + 0.2
                        });
                        // title: 'My Line Name'
                        chart.timeScale().fitContent();
                        lineSeriesMap[key] = lineSeries;
                    }
                    var series = data[key];
                    if (series) {
                        var seriesData = [];
                        for(var s in series){
                            var item = series[s];
                            var itemtime = new Date(item.time);
                            itemtime = itemtime.getTime() / 1000;
                            var sobj = {
                                time: itemtime,
                                value: item.value
                            };
                            seriesData.push(sobj);
                        }
                        lineSeries.setData(seriesData);
                        const markers = [
                            {
                                time: {
                                    year: 2024,
                                    month: 4,
                                    day: 20,
                                    hour: 1
                                },
                                position: 'aboveBar',
                                color: '#f684FF',
                                shape: 'circle',
                                text: 'X11d ETCT'
                            },
                            {
                                time: {
                                    year: 2024,
                                    month: 4,
                                    day: 20,
                                    hour: 14
                                },
                                position: 'belowBar',
                                color: '#f6FF10',
                                shape: 'square',
                                text: 'AX12 4#R5'
                            }
                        ];
                        lineSeries.setMarkers(markers);
                    } //for
                //chart.timeScale().fitContent()
                }
            }).bind(this)).catch((error)=>console.error('Error:', error));
        }).bind(this), 30000); // Poll every 5 seconds        
    }
    getGeneratedTimeSeries() {
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        };
        var seg_arr = [];
        var d = new Date();
        var last_value = 99;
        d.setDate(2);
        for(var i = 0; i < 30; i++){
            d.setDate(i + 1);
            var ll = d.toLocaleDateString(undefined, options);
            //var nl = nd.toLocaleDateString(undefined, options);
            var nz = d.toLocaleDateString(undefined, options);
            seg_arr.push({
                time: nz,
                value: last_value + i * 2
            });
            last_value = last_value + Math.random() * 5 - Math.random() * 5;
        }
        return seg_arr;
    }
    timeSeries(data_in) {
        var seg_arr = this.getGeneratedTimeSeries();
        var translated_series = [];
        for(var i in data_in.payload){
            let sample = data_in.payload[i];
            // THIS wasn't working:
            // new Date(sample[0]).toLocaleTimeString('en-GB', { timeZone: 'UTC' }) 
            // github suggested switch to unix timestamp: 
            translated_series.push({
                time: sample[0] / 1000,
                value: sample[3]
            });
        }
        //const lineSeries = this.chart.addLineSeries();
        // YOU ARE HERE: 
        // THIS UPDATED SERIES IS NOT RENDERING FOR SOME REASON 
        // RED ERRORS ARE JAMMING UP stream 
        this.lineSeries.setData(translated_series);
        //this.lineSeries.update( translated_series );
        this.chart.timeScale().fitContent();
    }
    onDataUpdate(data_in) {
        console.log(" onDataUpdate From Fabric Hopefully ? ");
    }
}
 //var sizespec = this.container.getBoundingClientRect()
 //var offsetwidth = this.container.offsetWidth;
 //console.log( offsetwidth )
 /*
DOMRect {
    bottom: 177,
    height: 54.7,
    left: 278.5,​
    right: 909.5,
    top: 122.3,
    width: 631,
    x: 278.5,
    y: 122.3,
}*/ 

//import { Kvs } from '/x_modules/kvs.js'


var $fzZ9h = parcelRequire("fzZ9h");
class $5b9d6bf8215b3d97$export$a170af9b7ab0a85f {
    constructor(initObj){
        var obj = initObj.data;
        var container_in = initObj.target;
        var vnode = (0, $fzZ9h.factory2d).renderNodeSync('xfer', obj);
        var model = obj.model;
        var fromId = obj.fromId;
        var toId = obj.toId;
        this.initObject = initObj;
        this.holder = vnode.querySelector('#xfer_keyval');
        var kvals = {
            origin: obj.origin || 'NEW',
            type: obj.type || 'unknown',
            slota: obj.a || '00000001',
            slotb: obj.b || '00000001'
        };
        this.kvs = new (0, $3494c43f722f695b$export$1e2124d9bec1f71d)({
            container: vnode.querySelector('#xfer_keyval'),
            data: kvals
        });
        this.kvs2 = new (0, $3494c43f722f695b$export$1e2124d9bec1f71d)({
            container: vnode.querySelector('#xfer_keyval'),
            data: obj.data,
            color: true
        });
        vnode.querySelector('#delete_edge').addEventListener('click', (function(e) {
            console.log(' delete edge ');
            model.removeLink(fromId, toId);
            var a = 1;
        }).bind(this));
        vnode.querySelector('#sync_edge').addEventListener('click', (function(e) {
            console.log(' sync edge ');
            model.saveLink(fromId, toId);
            var a = 1;
        }).bind(this));
        this.kvs.addEventListener('kvInputEvent', (function(e) {
            console.log(' XFER hears kvInputEvent ');
            model.updateLink(fromId, toId, e.detail);
        //this.model.updateObject( this.uuid , e.detail  )
        }).bind(this));
        var anode = container_in.appendChild(vnode) // append vnode after all mutations         
        ;
    }
}
 /*
var dat= obj.dat;
this.model = obj.data.model;
container_in.insertAdjacentHTML( 'beforeend' , factory2d.render( 'qr', obj.data ) );
var qr_panels = container_in.querySelectorAll('#qr')

var label= obj.data.label.toLowerCase();
var panel = qr_panels[ qr_panels.length-1 ] 
panel.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';



panel.querySelector('#supereditabletitle').addEventListener('input', function(e){
    //console.log('what input',e.target.value,data_in.uuid, this.model )
    this.model.updateObject( obj.data.uuid , { name:e.target.value } )
}.bind(this))
*/  /*
vnode.querySelector('#xfer_key').value=obj.data.name;
vnode.querySelector('#xfer_key').addEventListener('input', (e)=>{
    model.updateLink( fromId , toId , { name:e.target.value } )
})
vnode.querySelector('#xfer_val').value=obj.data.tag;
vnode.querySelector('#xfer_val').addEventListener('input', (e)=>{
    model.updateLink( fromId , toId , { tag:e.target.value } )
})*/  //var tclone =  vnode.cloneNode(true);
 //var zclone =  vnode.cloneNode();
 // attach custom listeners 
 // fil in the image from obj
 // con1.querySelector('#glyphbox').src = 'models2d/'+label+'.png' || 'UNTYPED';        
 /*
for( var i in obj.data ){    

    var toins = tmp.cloneNode(true);
    toins.querySelector('#xfer_key').value=i;
    // YOU ARE HERE 
    // ATTACH LISTENER FOR REMOVE: 
    toins.querySelector('#xfer_removeitem').setAttribute("kvid", i);
    toins.querySelector('#xfer_removeitem').addEventListener('click', (e)=>{
        this.id = i;
        e.target.yoyo=i;
        console.log(' remove keyval ',i , this.id ,e.target.getAttribute("kvid") )
        e.target.parentElement.remove()
        //this.removeItem()
        //model.updateLink( fromId , toId , { tag:e.target.value } )
    })  

    toins.querySelector('#xfer_val').value=obj.data[i];
    this.holder.appendChild( toins )
    //holder.insertAdjacentHTML('beforebegin' , '<div style="display:flex; justify-content:space-between;">'+'<input value="'+i+'"></input>'+'<input value="'+obj.data[i]+'"></input>'+'</div>' )
}*/ 


var $fzZ9h = parcelRequire("fzZ9h");
class $b780af1c6e386242$export$8dd80f06eb58bfe1 {
    constructor(initObj){
        var dat = initObj.data;
        var container_in = initObj.target;
        container_in.insertAdjacentHTML('beforeend', (0, $fzZ9h.factory2d).renderSync('terminal', dat));
        const iframe = container_in.querySelector('#termframe');
        iframe.addEventListener('load', ()=>{
            const domain = window.location.hostname;
            iframe.contentWindow.postMessage({
                domain: domain
            }, '*');
        });
    }
    onDataUpdate(data_in) {}
}



var $fzZ9h = parcelRequire("fzZ9h");
class $79865f20e2393a38$export$20554ca9023d9869 {
    constructor(initObj){
        var dat = initObj.data;
        var container_in = initObj.target;
        container_in.insertAdjacentHTML('beforeend', (0, $fzZ9h.factory2d).renderSync('lwc', dat));
        const iframe = container_in.querySelector('#termframe');
        iframe.addEventListener('load', ()=>{
            const domain = window.location.hostname;
            iframe.contentWindow.postMessage({
                domain: domain
            }, '*');
        });
    }
    onDataUpdate(data_in) {}
}





var $fzZ9h = parcelRequire("fzZ9h");
class $6c0eed9c56fff3d7$export$c9926905baeaa2bf extends (0, $353707a6de894831$export$e6544c0c2e56b326) {
    instanceField = 'instance field';
    constructor(initObj){
        super(initObj);
        //container_in.insertAdjacentHTML( 'beforeend' , factory2d.renderSync( 'timeseries', dat ) );
        var k = 3;
        var r = 2;
        var obj = initObj.data;
        this.magnificentSeven = 7;
        var vnode = (0, $fzZ9h.factory2d).renderNodeSync('cex', obj.data);
        this.container = initObj.target;
        this.chart = (0, $1ff2b0a4ee3068d6$export$c870ec99876cb45c)(vnode.querySelector('#linechart'), {
            width: 660,
            height: 280
        });
        initObj.target.appendChild(vnode);
        var w = vnode.querySelector('#linechart').offsetWidth;
        var h = vnode.querySelector('#linechart').offsetWidth;
        this.chart.resize(w, 280);
        this.chart.applyOptions({
            layout: {
                backgroundColor: '#11119933',
                textColor: '#CCCCEE'
            }
        });
        this.chart.applyOptions({
            grid: {
                vertLines: {
                    color: 'rgba(30, 30, 180, 0.7)',
                    style: 1,
                    visible: true
                },
                horzLines: {
                    color: 'rgba(70, 30, 190, 0.6)',
                    style: 1,
                    visible: true
                }
            }
        });
        this.chart.applyOptions({
            priceScale: {
                //position: 'left',
                //mode: 2,
                autoScale: true,
                //invertScale: true,
                //alignLabels: false,
                //borderVisible: false,
                //borderColor: '#555ffd',
                scaleMargins: {
                    top: 0.30,
                    bottom: 0.25
                }
            }
        });
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        };
        var seg_arr = [];
        var d = new Date();
        var last_value = 99;
        d.setDate(2);
        for(var i = 0; i < 30; i++){
            d.setDate(i + 1);
            var ll = d.toLocaleDateString(undefined, options);
            //var nl = nd.toLocaleDateString(undefined, options);
            var nz = d.toLocaleDateString(undefined, options);
            seg_arr.push({
                time: nz,
                value: last_value
            });
            last_value = last_value + Math.random() * 5 - Math.random() * 5;
        }
        //const lineSeries = this.chart.addLineSeries();
        //lineSeries.setData( seg_arr )
        var moc_arr = [
            {
                time: '2019-02-11',
                value: 20.01
            },
            {
                time: '2019-03-11',
                value: 40.01
            },
            {
                time: '2019-04-11',
                value: 80.01
            },
            {
                time: '2019-04-12',
                value: 96.63
            },
            {
                time: '2019-04-13',
                value: 76.64
            },
            {
                time: '2019-04-14',
                value: 81.89
            },
            {
                time: '2019-04-15',
                value: 74.43
            },
            {
                time: '2019-04-16',
                value: 80.01
            },
            {
                time: '2019-04-17',
                value: 96.63
            },
            {
                time: '2019-04-18',
                value: 76.64
            },
            {
                time: '2019-04-19',
                value: 81.89
            },
            {
                time: '2019-04-20',
                value: 74.43
            },
            {
                time: '2019-04-21',
                value: 80.01
            },
            {
                time: '2019-04-22',
                value: 96.63
            },
            {
                time: '2019-04-23',
                value: 76.64
            },
            {
                time: '2019-04-24',
                value: 81.89
            },
            {
                time: '2019-04-25',
                value: 74.43
            },
            {
                time: '2019-04-26',
                value: 80.01
            },
            {
                time: '2019-04-27',
                value: 96.63
            },
            {
                time: '2019-04-28',
                value: 76.64
            },
            {
                time: '2019-04-29',
                value: 81.89
            }
        ];
    //lineSeries.setData(seg_arr );
    //this.chart.timeScale().fitContent();    
    }
    fetchBalance(obj) {
        console.log('balancesx finally in obj ');
        console.log(obj);
        var holdr = this.container.querySelector('#balanceListHolder');
        holdr.innerHTML = "";
        for(var i in obj.total)// console.log( f , obj.free[f] )
        if (obj.total[i] > 0) {
            console.log(' avail : ', i, obj.total[i]);
            holdr.insertAdjacentHTML('beforeend', '<div class"balobj" style="color:white">' + i + ':' + obj.total[i] + '</div>');
        }
    }
    pricedBalances(obj) {
        // hybrid composit from fabric combines prices and balances 
        // 
        console.log(obj);
        var l = 3;
        var holdr = this.container.querySelector('#balanceListHolder');
        holdr.innerHTML = "";
        for(var i in obj.payload){
            // console.log( f , obj.free[f] )
            var bnode = obj.payload[i];
            holdr.insertAdjacentHTML('beforeend', '<div class"balobj" style="color:white; font-size:10px;">' + i + ':' + bnode.balance + '  USD Unit Cost: ' + bnode.usd_cost + ' :    Asset Holdings Value: ' + bnode.usd_value + '</div>');
            bnode;
        }
    }
    onDataUpdate(data_in) {
        var k = 9;
        console.log(' data update in CDEX module ');
    }
    timeSeries(data_in) {
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        };
        var seg_arr = [];
        var d = new Date();
        var last_value = 99;
        d.setDate(2);
        for(var i = 0; i < 30; i++){
            d.setDate(i + 1);
            var ll = d.toLocaleDateString(undefined, options);
            //var nl = nd.toLocaleDateString(undefined, options);
            var nz = d.toLocaleDateString(undefined, options);
            seg_arr.push({
                time: nz,
                value: last_value + i * 2
            });
            last_value = last_value + Math.random() * 5 - Math.random() * 5;
        }
        var translated_series = [];
        for(var i in data_in.payload){
            let sample = data_in.payload[i];
            // THIS wasn't working:
            // new Date(sample[0]).toLocaleTimeString('en-GB', { timeZone: 'UTC' }) 
            // github suggested switch to unix timestamp: 
            translated_series.push({
                time: sample[0] / 1000,
                value: sample[3]
            });
        }
        const lineSeries = this.chart.addLineSeries();
        // YOU ARE HERE: 
        // THIS UPDATED SERIES IS NOT RENDERING FOR SOME REASON 
        // RED ERRORS ARE JAMMING UP stream 
        lineSeries.setData(translated_series);
        this.chart.timeScale().fitContent();
    }
    specialFunc(o) {
        console.log('special func ');
    }
}
 //var sizespec = this.container.getBoundingClientRect()
 //var offsetwidth = this.container.offsetWidth;
 //console.log( offsetwidth )
 /*
DOMRect {
    bottom: 177,
    height: 54.7,
    left: 278.5,​
    right: 909.5,
    top: 122.3,
    width: 631,
    x: 278.5,
    y: 122.3,
}*/ 

//import { Kvs } from '/x_modules/kvs.js'
//import { Kvs } from '/x_modules/apps/kvs/kvs.js'
class $2518811b2c1cb929$export$4de9705c4c081023 {
    constructor(initObj){
        console.log(' new hex frame ', initObj);
        this.frame = document.createElement('iframe');
        this.frame.setAttribute('id', 'frame'); // assign an id
        this.frame.style.width = '500px';
        this.target = initObj.target;
        this.target.appendChild(this.frame); // to place at end of document
        // assign url
        this.frame.setAttribute('src', 'http://yahoo.com');
    }
}


parcelRequire("fzZ9h");
class $a2b1549bc5eaa632$export$9bfb54f216f14ff2 {
    constructor(initObj){
        var dat = initObj.data;
        var container_in = initObj.target;
        var shimhtml = `
            <body style="background-color:#010101;">
                <div id="shimcont" style="width:100%; min-width:300px; color:#9cff00; border:solid black 0.3px;">
                    <style>
                        #shimframe {
                            width: 100%;
                            height: 100%;
                            border: none;
                            margin: 0;
                            padding: 0;
                            display: block;
                        }
                    </style>
                    <iframe id="shimframe" src="http://192.168.1.251:7777/gui"> 
                    </iframe>

                </div>
            </body>        
        `;
        this.bogel = {
            "wow": "3000"
        };
        container_in.insertAdjacentHTML('beforeend', shimhtml);
        const shimframe = container_in.querySelector('#shimframe');
        if (shimframe && dat && dat.data && dat.data['url']) shimframe.src = dat.data['url'];
        const iframe = container_in.querySelector('#shimframe');
        iframe.addEventListener('load', (function(e) {
            const domain = window.location.hostname;
            iframe.contentWindow.postMessage({
                domain: domain
            }, '*');
        }).bind(this));
    }
    onDataUpdate(data_in) {}
}


var $76d1376f02fffec0$var$run_counter = 1;
var $76d1376f02fffec0$var$counter = 0;
var $76d1376f02fffec0$var$count = 839;
var $76d1376f02fffec0$var$numberone = 1;
function $76d1376f02fffec0$var$init(obj) {
    this.counter = 33;
    this.count = 48484;
    var v = 3;
    var vnode = window.factory2d.renderNodeSync('funbay');
    obj.target.appendChild(vnode);
    window.addEventListener('mapChanged', function(e) {
        var oi = 3;
        console.log('mapChanged heard in temp module: ', this);
    });
}
function $76d1376f02fffec0$var$increment() {
    $76d1376f02fffec0$var$count += 1;
    return {
        count: $76d1376f02fffec0$var$count,
        thiscount: this.count
    };
}
function $76d1376f02fffec0$var$increment2() {
    this.count += 1;
    return {
        count: $76d1376f02fffec0$var$count,
        thiscount: this.count
    };
}
function $76d1376f02fffec0$var$decrement() {
    $76d1376f02fffec0$var$counter--;
}
var $76d1376f02fffec0$export$2e2bcd8739ae039 = {
    counter: $76d1376f02fffec0$var$counter,
    increment: $76d1376f02fffec0$var$increment,
    increment2: $76d1376f02fffec0$var$increment2,
    decrement: $76d1376f02fffec0$var$decrement,
    init: $76d1376f02fffec0$var$init
};


var $80c884b768c91c89$var$run_counter = 1;
var $80c884b768c91c89$var$counter = 0;
var $80c884b768c91c89$var$count = 839;
var $80c884b768c91c89$var$numberone = 1;
function $80c884b768c91c89$var$init(obj) {
    this.counter = 33;
    this.count = 48484;
    var v = 3;
    var vnode = window.factory2d.renderNodeSync('funbay');
    obj.target.appendChild(vnode);
    window.addEventListener('mapChanged', function(e) {
        var oi = 3;
        console.log('mapChanged heard in temp module: ', this);
    });
}
function $80c884b768c91c89$var$increment() {
    $80c884b768c91c89$var$count += 1;
    return {
        count: $80c884b768c91c89$var$count,
        thiscount: this.count
    };
}
function $80c884b768c91c89$var$increment2() {
    this.count += 1;
    return {
        count: $80c884b768c91c89$var$count,
        thiscount: this.count
    };
}
function $80c884b768c91c89$var$decrement() {
    $80c884b768c91c89$var$counter--;
}
var $80c884b768c91c89$export$2e2bcd8739ae039 = {
    counter: $80c884b768c91c89$var$counter,
    increment: $80c884b768c91c89$var$increment,
    increment2: $80c884b768c91c89$var$increment2,
    decrement: $80c884b768c91c89$var$decrement,
    init: $80c884b768c91c89$var$init
};



var $fzZ9h = parcelRequire("fzZ9h");

// FOR rendering inline avatar of selected item: temp removed
// import { startGlyph } from '/x_modules/miniglyph.js'
function $b7d57ef123ad56b9$export$5bf24f01b2ed424d() {
    this.constructor = function() {
        var parent = this;
        this.model;
        this.drawer;
        this.drawer2;
        this.drawer_open = 0;
        this.iter = 0;
        this.panels = [];
        // Drag state variables
        this.isDragging = false;
        this.dragStartY = 0;
        this.dragStartTop = 0;
        this.dragStartBottom = 0;
        this.currentTop = -600;
        this.currentBottom = -600;
        // SELECT PANELS PER XCLASS AVATAR TYPE 
        // token needs:  buy sell swap xfer display 
        // address: SEND , Receive Display , Route Receive 
        this.capability_matrix = {
            alias: {
                init: (o)=>{
                    return [];
                }
            }
        };
        // THIS HAS TO BE DONE FOR BUNDELER NOT TO SHAKE OFF CLASSES
        // SINCE THEY ARENT INLINE INSTANTIATED
        this.futureclasses = {
            Qr: $b15991d11dfc94c1$export$5631afde407885cb,
            Timeseries: $9770131023f2f022$export$dfbd03a8873a1248,
            Xfer: $5b9d6bf8215b3d97$export$a170af9b7ab0a85f,
            Terminal: $b780af1c6e386242$export$8dd80f06eb58bfe1,
            Hexframe: $2518811b2c1cb929$export$4de9705c4c081023,
            List: $580abc179c9a1949$export$54c2e3dc7acea9f5,
            Pricelist: $b2f82a7b3cd6a34a$export$469baeb1b98e0c9,
            Funbay: $76d1376f02fffec0$export$2e2bcd8739ae039,
            Cex: $6c0eed9c56fff3d7$export$c9926905baeaa2bf,
            Buysell: $48ed57f132e58e1a$export$9b1e7b004bf806af,
            Detail: $8199d96972f5e4cd$export$47eb42ff093406d4,
            Shim: $a2b1549bc5eaa632$export$9bfb54f216f14ff2,
            Outline: $1500b689e3519186$export$5beeae30d1389e5
        };
        // FUTURE PANELS UI NEEDED: ( cache it )
        //function logLoaded( lib_in ){ console.log( lib_in +' Loaded.' )}
        //factory2d.load( 'qr' ).then( ( libx  ) =>{ console.log('qr loaded')} );   
        //factory2d.load( 'kvs' ).then( ( libx  ) =>{ console.log('kvs loaded ')} );           
        //factory2d.load( 'xfer' ).then( ( libx  ) =>{ console.log('xfer loaded')} );   
        //factory2d.load( 'terminal' ).then( ( libx  ) =>{ console.log('terminal loaded')} );   
        //factory2d.load( 'timeseries' ).then( ( libx  ) =>{ console.log('tiemseries loaded ')} );    
        // TODO: DATABASE LIST INPUT with AUTHENTICATED GLUEMAPPER 
        (0, $fzZ9h.factory2d).loadAll([
            '/prices.html',
            '/poutline.html',
            '/pricetiles.html',
            '/x_modules/apps/outline/outline.html'
        ]).then((libx)=>{
            console.log('library loaded in DDV2');
        });
    //window.factory2d = factory2d;
    //this.onLogEvent = this.onMapChangeEvent.bind(this)
    //this.printTerm = this.printTerm.bind(this)
    };
    this.onFocusEvent = (function(eventObj) {
        this.model = eventObj.detail.model;
        if (model.focusobject) //var thegoods = ; 
        this.buildControls(this.model.focusobject);
        else {
            this.drawer_open = 0;
            (0, $f7cabcf4b0e0fb2e$export$7b23975ad686bf91).to(this.drawer, 2, {
                top: -400,
                ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
            });
            (0, $f7cabcf4b0e0fb2e$export$7b23975ad686bf91).to(this.drawer2, 2, {
                bottom: -400,
                ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
            });
        //this.reset();
        }
    }).bind(this);
    this.onDetailEvent = (function(eventObj) {
        //var con1 = this.con.querySelector('#detailpanel2')        
        var model1 = eventObj;
        if (eventObj) {
            // BUILD INITIAL UI 
            //this.buildControls( eventObj )
            this.con.innerHTML = '';
            var cl = this.newClass(this.con, 'Outline', eventObj, 'bigcontent_id1', 0);
            //       this.newClass( con1 , 'Qr' ,      fromObj , 'some_id1' ,  0);            
            // Find the element with class 'summary-column' inside this.con and assign it to 'outlineholder'
            var outlineholder = this.con.querySelector('#summary_column');
            // Iterate all key-values in eventObj and render them as summary sections
            if (eventObj && typeof eventObj === 'object') {
                for(let key in eventObj)if (eventObj.hasOwnProperty(key)) {
                    // Create the summary section node
                    var section = document.createElement('div');
                    section.className = "summary-section";
                    section.style.display = "flex";
                    section.style.alignItems = "center";
                    section.style.gap = "8px";
                    section.style.borderBottom = "1px solid #f2f2f2"; // very subtle line
                    // Label
                    var labelSpan = document.createElement('span');
                    labelSpan.className = "summary-label";
                    labelSpan.style.fontWeight = "bold";
                    labelSpan.style.marginRight = "5px";
                    labelSpan.style.whiteSpace = "nowrap";
                    labelSpan.textContent = key + ":";
                    // Value
                    var valueSpan = document.createElement('span');
                    valueSpan.className = "summary-value";
                    valueSpan.style.marginLeft = "2px";
                    valueSpan.style.whiteSpace = "nowrap";
                    let val = eventObj[key];
                    if (typeof val === 'object' && val !== null) valueSpan.textContent = JSON.stringify(val);
                    else valueSpan.textContent = val !== null && val !== undefined ? val.toString() : '';
                    // Compose
                    section.appendChild(labelSpan);
                    section.appendChild(valueSpan);
                    outlineholder.appendChild(section);
                }
            }
            // REQUEST ADDITIONAL DATA
            // here merge the eventObj with 
            // init object requesting ai 
            //this.fabric.intent( {  HERE USE node.data to get deep report } )
            //  , how'd u learn about this 
            // SLIDE PANEL 
            this.drawer_open = 1;
            (0, $f7cabcf4b0e0fb2e$export$7b23975ad686bf91).to(this.drawer, 2, {
                top: 10,
                ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
            });
            (0, $f7cabcf4b0e0fb2e$export$7b23975ad686bf91).to(this.drawer2, 2, {
                bottom: 0,
                ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
            });
            // Update current position state //
            this.currentTop = 10;
            this.currentBottom = 0;
        } else {
            this.drawer_open = 0;
            (0, $f7cabcf4b0e0fb2e$export$7b23975ad686bf91).to(this.drawer, 2, {
                top: -400,
                ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
            });
            (0, $f7cabcf4b0e0fb2e$export$7b23975ad686bf91).to(this.drawer2, 2, {
                bottom: -400,
                ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
            });
            // Update current position state //
            this.currentTop = -400;
            this.currentBottom = -400;
        //this.reset();
        }
    }).bind(this);
    this.mapMessage = (function(e) {
        if (e.data && e.data.fn && e.data.fn == 'detailEvent') {
            console.log(' map message ok ');
            this.onDetailEvent(e.data);
        }
        var obj = e.data;
        var r = 3;
    }).bind(this);
    this.constructor();
    // Drag event handlers
    this.onMouseDown = (function(e) {
        // Only allow dragging on the background, not on interactive elements
        if (e.target.closest('#closebuttonxl') || e.target.closest('#detailpanelholder') || e.target.closest('input')) return;
        this.isDragging = true;
        this.dragStartY = e.clientY || e.touches[0].clientY;
        this.dragStartTop = this.currentTop;
        this.dragStartBottom = this.currentBottom;
        // Add dragging class for visual feedback
        this.drawer.classList.add('dragging');
        this.drawer2.classList.add('dragging');
        // Prevent text selection during drag
        e.preventDefault();
        // Add event listeners for drag
        document.addEventListener('mousemove', this.onMouseMove.bind(this));
        document.addEventListener('mouseup', this.onMouseUp.bind(this));
        document.addEventListener('touchmove', this.onMouseMove.bind(this));
        document.addEventListener('touchend', this.onMouseUp.bind(this));
    }).bind(this);
    this.onMouseMove = (function(e) {
        if (!this.isDragging) return;
        const clientY = e.clientY || (e.touches && e.touches[0] ? e.touches[0].clientY : 0);
        const deltaY = clientY - this.dragStartY;
        // Calculate new positions with bounds
        let newTop = this.dragStartTop + deltaY;
        let newBottom = this.dragStartBottom - deltaY;
        // Constrain the panels // allow unlimited upward movement, limit downward movement
        newTop = Math.max(-600, newTop); // Only limit downward movement
        newBottom = Math.max(-600, newBottom); // Only limit downward movement
        // Update current positions
        this.currentTop = newTop;
        this.currentBottom = newBottom;
        // Apply the new positions smoothly
        this.drawer.style.top = newTop + 'px';
        this.drawer2.style.bottom = newBottom + 'px';
    }).bind(this);
    this.onMouseUp = (function(e) {
        if (!this.isDragging) return;
        this.isDragging = false;
        // Remove dragging class
        this.drawer.classList.remove('dragging');
        this.drawer2.classList.remove('dragging');
        // Remove event listeners
        document.removeEventListener('mousemove', this.onMouseMove.bind(this));
        document.removeEventListener('mouseup', this.onMouseUp.bind(this));
        document.removeEventListener('touchmove', this.onMouseMove.bind(this));
        document.removeEventListener('touchend', this.onMouseUp.bind(this));
        // Snap to nearest position or animate to final position
        this.snapToPosition();
    }).bind(this);
    this.snapToPosition = (function() {
        // Determine if panels should be open or closed based on current position
        const topThreshold = -300; // If top panel is above this, consider it closed
        const bottomThreshold = -300; // If bottom panel is below this, consider it closed
        let targetTop, targetBottom;
        if (this.currentTop > topThreshold && this.currentBottom > bottomThreshold) {
            // Snap to open position - but respect if user dragged higher
            targetTop = Math.max(10, this.currentTop); // Keep higher position if dragged up
            targetBottom = Math.max(0, this.currentBottom); // Keep higher position if dragged up
            this.drawer_open = 1;
        } else {
            // Snap to closed position
            targetTop = -600;
            targetBottom = -600;
            this.drawer_open = 0;
        }
        // Animate to target position
        (0, $f7cabcf4b0e0fb2e$export$7b23975ad686bf91).to(this.drawer, 0.5, {
            top: targetTop,
            ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
        });
        (0, $f7cabcf4b0e0fb2e$export$7b23975ad686bf91).to(this.drawer2, 0.5, {
            bottom: targetBottom,
            ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
        });
        // Update current positions
        this.currentTop = targetTop;
        this.currentBottom = targetBottom;
    }).bind(this);
    this.onFabricEvent = (function(e) {
        var focusObject = e.detail.model.focusobject;
        console.log(' Fabric Event in Detail Display: : ', e.detail);
        // THIS METHOD DISTRIBUTES THE CALL TO ALL PANELS 
        // IF ACTIVE ID IN DETAIL IS RECEIVED 
        if (focusObject && focusObject.id == e.detail.obj.uuid) {
            console.log(' RELEVENT EVENT');
            console.log(this.panels);
            for(var p in this.panels){
                console.log(" detail panel: ", p);
                try {
                    this.panels[p][e.detail.obj.method](e.detail.obj);
                } catch (e) {}
            }
        }
    // if( e.detail.obj.method == 'fetchBalances' ){
    //     console.log( e.detail.obj )
    // }
    // if( e.detail.obj.method == 'timeSeries' && focusObject.id == e.detail.obj.uuid ){
    //     console.log( e.detail.obj )
    //     this.panels[2][ e.detail.obj.method ]( e.detail.obj )
    // }
    // if( e.detail.obj.method == 'pricedBalances' && focusObject.id == e.detail.obj.uuid ){
    //     console.log( e.detail.obj )
    //     this.panels[1][ e.detail.obj.method ]( e.detail.obj )
    // }        
    }).bind(this);
    this.toggleDrawer = function() {
        if (this.drawer_open) {
            this.drawer_open = 0;
            (0, $f7cabcf4b0e0fb2e$export$7b23975ad686bf91).to(this.drawer, 2, {
                top: -580,
                ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
            });
            (0, $f7cabcf4b0e0fb2e$export$7b23975ad686bf91).to(this.drawer2, 2, {
                bottom: -580,
                ease: (0, $f7cabcf4b0e0fb2e$export$41e9d1ff1a2fb15a).easeOut
            });
            // Update current position state
            this.currentTop = -580;
            this.currentBottom = -580;
        //TweenMax.to(sortmenu, 2, {right:-580 , ease:Expo.easeOut} );
        //TweenMax.to('.holder', 1, { ease:Expo.easeOut, top: -86+'px'});
        }
    };
    this.headerTemplateBLANK = function(vl) {
        var tmpl = `<div class='coltitle' style="border-top:solid #0075a7 1px;"></div>`;
        return tmpl;
    };
    this.headerTemplate = function(val) {
        var tmpl = `<div class='coltitle' style=" border-bottom:solid #0093ad 1px;">${val}</div>`;
        return tmpl;
    };
    this.updateControls = function(data_in) {};
    this.selfContain = function(xclass_in, data_in) {
    // this will be inside component 
    //factory2d.render('qr', data_in ) 
    //factory2d.render('anglezone', data_in )
    //factory2d.render('greenlogo', data_in )
    };
    this.newClass = function(container_in, xclass_in, dat, id_in, ndx_in) {
        // Auto cap 
        // var xclass = ( xclass_in.charAt(0).toUpperCase() + xclass_in.slice(1) ) + 'Panel';
        var xclass = xclass_in.charAt(0).toUpperCase() + xclass_in.slice(1); // Capitalize Class name
        var class_ref = this.futureclasses[xclass];
        var obj = {
            target: container_in,
            data: dat,
            id_in: id_in,
            ndx: ndx_in
        };
        var p;
        if (typeof class_ref == 'function') p = new class_ref({
            'data': obj
        });
        else {
            p = class_ref;
            p.init(obj);
        }
        return p;
    };
    this.buildControls = function(obj) {
        var con1 = this.con;
        con1.innerHTML = '';
        // RESET ACTIVE PANELS 
        this.panels = [];
        var label;
        if (obj.payload && 'labels' in obj.payload) label = obj.payload.labels[0];
        else label = 'connects';
        // HERE HOW DO WE ATTACH THE ENCYCLOPEDIA TEMPLATE 
        // WHAT IS IDEAL TEMPLATE 
        // OUTLINE ON LEFT AND TEMPLATE ON THE right
        // AND ITs UPdateable 
        var y = (0, $fzZ9h.factory2d).renderNodeSync('poutline', {});
        var x = (0, $fzZ9h.factory2d).renderNodeSync('prices', {});
        // --- Example: Attach three equally wide columns of cool informational content ---
        // were heree , depending on node attributes it attaches su b-website
        // what attributes are the best : 
        //  subwebsite  :   xclass ?  label ? 
        // glue mapper ? 
        var z = 0;
        if ('name' in obj && obj.name == 'Lithium') z = y;
        else if (Math.random() < 0.5) z = y;
        else z = x;
        con1.appendChild(z);
        // OK IS IT HERE THAT WE ADD INJECTION OF IFRAME PARANMETERS ? 
        // OR DO WE PUT IT IN THE TERMINAL MODULE 
        // HOW DOES IT GO FROM DATA TO TERMINAL MODULE 
        // Eventuall map this to the module itself
        // E.g. module knows its best arrangement | soon xclasss 
        var detected_xclass = label.toLowerCase();
        label = detected_xclass;
    };
    this.render = function() {
        //var con = document.createElement('div')
        this.con = document.getElementById('twodstage');
        this.con1 = this.con;
        //this.con=con;
        this.con.setAttribute("id", "detailpanel2");
        //document.body.appendChild( con );
        this.con.innerHTML = `
            <style>
                .confpanel{
                    width:32%;
                    min-width:300px; 
                }
                .submenutitle{
                    font-size:10px;
                    color:white;
                    border: none;                        
                    outline: none;
                    background: transparent;
                    border: none transparent;
                    border-color: transparent;
                }        
                .noselect {
                  -webkit-touch-callout: none; /* iOS Safari */
                    -webkit-user-select: none; /* Safari */
                     -khtml-user-select: none; /* Konqueror HTML */
                       -moz-user-select: none; /* Old versions of Firefox */
                        -ms-user-select: none; /* Internet Explorer/Edge */
                            user-select: none; /* Non-prefixed */
                }    
                input{
                    font-size:10px;
                }       
                .container{
                    max-width:1400px;
                }
                .draggable-panel {
                    cursor: grab;
                }
                .draggable-panel:active {
                    cursor: grabbing;
                }
                .draggable-panel.dragging {
                    cursor: grabbing;
                }                  
            </style>
            <div id="basecontent" class="draggable-panel" style="width:100%; background:#000000de;">

            </div>`;
    // this.drawer = this.con.querySelector('#slide_drawer')
    // this.drawer2 = this.con.querySelector('#slide_drawer2')
    // Add drag event listeners to both panels
    //this.drawer.addEventListener('mousedown', this.onMouseDown.bind(this));
    //this.drawer2.addEventListener('mousedown', this.onMouseDown.bind(this));
    //this.drawer.addEventListener('touchstart', this.onMouseDown.bind(this));
    //this.drawer2.addEventListener('touchstart', this.onMouseDown.bind(this));
    // this.drawer2.querySelector('#closebuttonxl').addEventListener('click', function(event) {
    //     //window.controller.setFocusObject( false )
    //     window.dispatchEvent( new CustomEvent( 'focusRemovedEvent' , { detail:{} }) )
    // })
    //startGlyph( { label:'alias'  , campos:[0,0,2.5] , camlook:[0,0,0], objrot:[Math.PI/4], holder:this.con.querySelector('#glyphbox') } )
    };
    this.render();
}
 // cancel need for custom element due to 
 //customElements.define('detail-panel', DetailPanel );
 // PRELOAD PANEL COMPONENTS UNTIL ASYNC PROMISE WORKS ON ALL BROWSERS 
 //import { QrPanel } from '/x_modules/components/qr-panel.js';
 //import { TimeseriesPanel } from '/x_modules/components/timeseries-panel.js';
 //import { XferPanel } from '/x_modules/components/xfer-panel.js';
 //import { TerminalPanel } from '/x_modules/components/terminal-panel.js';
 /*

    
    // THIS DOUBLE NESTS THE CUSTOM ELEMENT TAG and CAUSES RENDER PROBLEMS FOR DESIGNERS: 
    this.newComponent=function( container_in , xclass , dat , id_in ){
        // FUTURE USE ELIMINATES IMPORTS ON TOP 
        //import xclass from '/x_module/components/'+class+'-panel.js'.then( ( module )=>{ con1.insert( module ) } )
        //import('/x_modules/components/'+xclass+'.js').then( (module) => {
        container_in.insertAdjacentHTML('beforeend','<'+xclass+' id="'+id_in+'"></'+xclass+'>' )
        var app_ref = container_in.querySelector('#'+id_in+'');
        app_ref.onDataUpdate( dat )            
    }


    this.newClassDynamicWorking9999=function( container_in , xclass , dat , id_in ){
        xclass = ( xclass.charAt(0).toUpperCase() + xclass.slice(1) ) + 'Panel';
        var class_ref = eval(xclass);
        var p =  new class_ref( container_in, dat , id_in )
        return p;
        // THIS WORKS on 9999 but not in Parcel Bundle ( likely bundle can't follow eval )
    }
*/  // this.cap_map={
 //     'repo':['qr','hexframe'],
 //     'tower':['qr','terminal'],
 //     'project':['qr','terminal'],            
 //     'alias':['qr','timeseries'],
 //     'module':['qr','qr','funbay'], 
 //     'token':['qr','qr','qr'], 
 //     'service':['qr','terminal'],
 //     'exchange':['qr','funbay'],
 //     'exchange1':['stored_key','time_series'],
 //     'wordpress1':['auth','anglezone','greenlogo'],
 //     'app1':['tags','app_domain','auth'],
 //     'connects':['qr','xfer','qr'],
 //     'owns':['qr','xfer','qr'],
 //     'transfers':['qr','xfer','qr'],
 //     'link':['qr','xfer','qr'],
 //     'listd':['list','list','list']
 // }
 // Michal cooks, cleans for days deposits money from savings *
 // Rafal response: " I want nothing to do with you on social level "
 // Broccolli in your teeth: Insulting those that drain their life to help you
 // Broccolli all over your face: Espouse virtue to fathers face, forsake legacy behind back. 
 //label = ('label' in obj.payload )?  : 'connects';
 // GET ARRAY OF CAPABILITY DEMANDS FOR THIS XCLASS 
 // var caplist = gluemapper.xclass_caps( label , 'caps' , obj );
 // 
 // // ATTACH PANELS 
 // if( obj.label == 'Module' ){
 //     var winds=[];
 //     console.log('Module clicked: ')
 //     caplist.forEach( function(item, index){
 //         var nc = this.newClass( con1 ,  caplist[index] , obj , 'some_id5',index)
 //         var a = nc;
 //         winds.push( nc );
 //     }.bind(this));       
 //     var j=3;      
 // }
 // else{
 //     caplist.forEach( function(item, index){
 //         var ncyo = this.newClass( con1 ,  caplist[index] , obj , 'some_id5',index)
 //         this.panels.push( ncyo )
 //         var k = 9; 
 //     }.bind(this)); 
 // } 


//import driver from "./../../web_modules/neo4j-driver.js"
////// SESSIONS ////
window.jtkn = 'blank' // JTKN
;
window.session_fragment = Math.round(Math.random() * 99999);
window.official_base = window.location.protocol + "//" + window.location.host;
window.official_base = 'https://api.apdex.com';
//var official_base = window.location.protocol + "//" + window.location.host;
if (window.location.host.includes("localhost") || window.location.host.includes("xcore.love") || window.location.host.includes("0.0.0.0")) // window.official_base ='http://localhost:8851' 
window.official_base = 'https://api.apdex.com';
window.term = function(min) {
    this.dispatchEvent(new CustomEvent('statusEvent', {
        detail: {
            'message': min
        }
    }));
};
async function $e2e02b6b4ba38832$var$ready() {
    var factory2d = new (0, $fzZ9h.Factory2d)();
    await factory2d.loadAll([
        './uix/qpanels.html',
        'x_modules/apps/terminal/indexxterm.html',
        'x_modules/apps/buysell/buysell.html'
    ]).then((libx)=>{
        console.log('library loaded - - - ');
    });
    window.factory2d = factory2d;
    window.jtkn = 'blank';
    var model = new (0, $14b973211f4cd758$export$2e2bcd8739ae039)({
        connector: (0, $7164e009da884f04$export$f79a732982c93a3b)
    });
    var controller = new (0, $90c97e484e1fef0d$export$2e2bcd8739ae039)({
        model: model,
        connector: (0, $7164e009da884f04$export$f79a732982c93a3b)
    });
    var clearframe = new (0, $ab4527151d7de39d$export$2e2bcd8739ae039)({
        target: document.body
    });
    var detaildisplay = new (0, $b7d57ef123ad56b9$export$5bf24f01b2ed424d)();
    // WORK AROUND FOR search stretch 
    var searchExpander = `
            <div style="display: flex;">
                <div style="flex: 0 0 300px; pointer-events:none; "></div>
                <div id="ifh" style="flex: 1; ">             
                </div>
                <div style="flex: 0 0 300px; pointer-events:none; "></div>
            </div>`;
    document.body.insertAdjacentHTML('beforeend', searchExpander);
    var searchmod = new (0, $147756b0f58bc411$export$2e2bcd8739ae039)({
        target: document.querySelector('#outersearchcontainer'),
        maxwidth: 480
    });
    var qnav = new (0, $09c90862b9048f4b$export$2e2bcd8739ae039)();
    window.addEventListener('uiEvent', controller.onUiEvent, true);
    // postMessage from Iframe 3D Click 
    window.addEventListener('message', controller.onMapMessage.bind(controller), true);
    window.addEventListener('message', detaildisplay.mapMessage, true);
    window.addEventListener('navRequestEvent', controller.onNavRequestEvent, true);
    window.addEventListener('unlockimportEvent', controller.onUnlockImportEvent, true);
    model.addEventListener('navRequestEvent', controller.onNavRequestEvent, true);
    // temp work around for navRequestClick needed after actions like login 
    model.addEventListener('sessionEvent', searchmod.onSessionEvent, true);
    model.addEventListener('initEvent', searchmod.initEvent, true);
    model.addEventListener('sessionEvent', qnav.onSessionEvent, true);
    model.addEventListener('navEvent', qnav.onNavEvent, true);
    model.addEventListener('navEvent', clearframe.onNavEvent, true);
    model.addEventListener('fabricEvent', clearframe.onFabricEvent, true);
    model.addEventListener('freshDataEvent', clearframe.onFreshDataEvent, true);
    controller.start();
}
document.addEventListener("DOMContentLoaded", $e2e02b6b4ba38832$var$ready); // addEventListener('registerEvent',  controller.onRegisterEvent, true );
 //var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
 //var eventer = window[eventMethod];
 //var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
 //eventer(messageEvent, controller.onChildBoot ,false);      
 // alternate boot method 
 //window.addEventListener('message' , controller.onChildBoot , true)
 //var gx = new Glue()
 //gx.push( {'finally':'finally'}
 // omniGraph.load(  expected_context_nodes )
 // omni.load( users_nodes  )
 // omni.search(    ) returns nodes[] , links[]
 // contracts input output apps  ,  
 // exchanges input output apps
 // needs to check self credentials omni / connector object space
 // omni get nodes 
 // check local nodes
 // check omni nodes
 // var allstubs = [ ...walletstubs, ...techtags ]
 // searchmod.initStubs( allstubs )
 // connector.objectSpace()
 // var nowthis = this; 
 // SETTING FRAME TITLE TO DOMAIN: 
 //var capDom = platform.domain()[0].toUpperCase() + platform.domain().substring(1)
 //document.title = capDom+ ' Map LX V0.44'
 // import './frame/search-mod.js';  // searchMod  
 // hyperFrame  import './js/clear-frame.js' 
 // self clearing iFrame 
 //model.addEventListener('authEvent',    function(e){ console.log('BSE:',e,e.detail) },true )
 //model.addEventListener('sessionEvent', function(e){  console.log('>> sessionEvent .main.:',e,e.detail); },true )
 // var logterm = new LogTerm();
 // addEventListener('logEvent',    logterm.onLogEvent , true );
 // following 3 events could be userInputEvent ( authReq , keyImport , navReq )


//# sourceMappingURL=index.b45b3256.js.map
